/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2853);
	module.exports = __webpack_require__(1736);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2965);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 2 */
[3546, 2482],
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(754);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1756);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1754);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.19.2
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(2459)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.19.2';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.20.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    if (Object.getOwnPropertyNames) {
	        return (Object.getOwnPropertyNames(obj).length === 0);
	    } else {
	        var k;
	        for (k in obj) {
	            if (obj.hasOwnProperty(k)) {
	                return false;
	            }
	        }
	        return true;
	    }
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.weekdayMismatch &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid() && !isNaN(value)) {
	        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	        }
	        else {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function mod(n, x) {
	    return ((n % x) + x) % x;
	}
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	function daysInMonth(year, month) {
	    if (isNaN(year) || isNaN(month)) {
	        return NaN;
	    }
	    var modMonth = mod(month, 12);
	    year += (month - modMonth) / 12;
	    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            var aliasedRequire = require;
	            __webpack_require__(1530)("./" + name);
	            getSetGlobalLocale(oldLocale);
	        } catch (e) {}
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, tmpLocale, parentConfig = baseConfig;
	        // MERGE
	        tmpLocale = loadLocale(name);
	        if (tmpLocale != null) {
	            parentConfig = tmpLocale._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	
	    // check for mismatching day of week
	    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	        getParsingFlags(config).weekdayMismatch = true;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	    var result = [
	        untruncateYear(yearStr),
	        defaultLocaleMonthsShort.indexOf(monthStr),
	        parseInt(dayStr, 10),
	        parseInt(hourStr, 10),
	        parseInt(minuteStr, 10)
	    ];
	
	    if (secondStr) {
	        result.push(parseInt(secondStr, 10));
	    }
	
	    return result;
	}
	
	function untruncateYear(yearStr) {
	    var year = parseInt(yearStr, 10);
	    if (year <= 49) {
	        return 2000 + year;
	    } else if (year <= 999) {
	        return 1900 + year;
	    }
	    return year;
	}
	
	function preprocessRFC2822(s) {
	    // Remove comments and folding whitespace and replace multiple-spaces with a single space
	    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
	}
	
	function checkWeekday(weekdayStr, parsedInput, config) {
	    if (weekdayStr) {
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	        if (weekdayProvided !== weekdayActual) {
	            getParsingFlags(config).weekdayMismatch = true;
	            config._isValid = false;
	            return false;
	        }
	    }
	    return true;
	}
	
	var obsOffsets = {
	    UT: 0,
	    GMT: 0,
	    EDT: -4 * 60,
	    EST: -5 * 60,
	    CDT: -5 * 60,
	    CST: -6 * 60,
	    MDT: -6 * 60,
	    MST: -7 * 60,
	    PDT: -7 * 60,
	    PST: -8 * 60
	};
	
	function calculateOffset(obsOffset, militaryOffset, numOffset) {
	    if (obsOffset) {
	        return obsOffsets[obsOffset];
	    } else if (militaryOffset) {
	        // the only allowed military tz is Z
	        return 0;
	    } else {
	        var hm = parseInt(numOffset, 10);
	        var m = hm % 100, h = (hm - m) / 100;
	        return h * 60 + m;
	    }
	}
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var match = rfc2822.exec(preprocessRFC2822(config._i));
	    if (match) {
	        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	        if (!checkWeekday(match[1], parsedArray, config)) {
	            return;
	        }
	
	        config._a = parsedArray;
	        config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	        config._d = createUTCDate.apply(null, config._a);
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible to translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    switch (units) {
	        case 'year': output = monthDiff(this, that) / 12; break;
	        case 'month': output = monthDiff(this, that); break;
	        case 'quarter': output = monthDiff(this, that) / 3; break;
	        case 'second': output = (this - that) / 1e3; break; // 1000
	        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	        default: output = this - that;
	    }
	
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString(keepOffset) {
	    if (!this.isValid()) {
	        return null;
	    }
	    var utc = keepOffset !== true;
	    var m = utc ? this.clone().utc() : this;
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        if (utc) {
	            return this.toDate().toISOString();
	        } else {
	            return new Date(this._d.valueOf()).toISOString().replace('Z', formatMoment(m, 'Z'));
	        }
	    }
	    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0]);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function clone$1 () {
	    return createDuration(this);
	}
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function sign(x) {
	    return ((x > 0) - (x < 0)) || +x;
	}
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    var totalSign = total < 0 ? '-' : '';
	    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	    return totalSign + 'P' +
	        (Y ? ymSign + Y + 'Y' : '') +
	        (M ? ymSign + M + 'M' : '') +
	        (D ? daysSign + D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? hmsSign + h + 'H' : '') +
	        (m ? hmsSign + m + 'M' : '') +
	        (s ? hmsSign + s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.clone          = clone$1;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.20.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	// currently HTML5 input type only supports 24-hour formats
	hooks.HTML5_FMT = {
	    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	    DATE: 'YYYY-MM-DD',                             // <input type="date" />
	    TIME: 'HH:mm',                                  // <input type="time" />
	    TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	    TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	    WEEK: 'YYYY-[W]WW',                             // <input type="week" />
	    MONTH: 'YYYY-MM'                                // <input type="month" />
	};
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.18.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null,
	        rfc2822         : false,
	        weekdayMismatch : false
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i = 0; i < momentProperties.length; i++) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    this._dayOfMonthOrdinalParseLenient = new RegExp(
	        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	            '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    ss : '%d seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return isArray(this._months) ? this._months :
	            this._months['standalone'];
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return isArray(this._monthsShort) ? this._monthsShort :
	            this._monthsShort['standalone'];
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    // can't just apply() to create a date:
	    // https://stackoverflow.com/q/181348
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    // the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    // the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return isArray(this._weekdays) ? this._weekdays :
	            this._weekdays['standalone'];
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('k',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	addRegexToken('kk', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['k', 'kk'], function (input, array, config) {
	    var kInput = toInt(input);
	    array[HOUR] = kInput === 24 ? 0 : kInput;
	});
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(1811)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	var basicRfcRegex = /^((?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d?\d\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(?:\d\d)?\d\d\s)(\d\d:\d\d)(\:\d\d)?(\s(?:UT|GMT|[ECMP][SD]T|[A-IK-Za-ik-z]|[+-]\d{4}))$/;
	
	// date and time from ref 2822 format
	function configFromRFC2822(config) {
	    var string, match, dayFormat,
	        dateFormat, timeFormat, tzFormat;
	    var timezones = {
	        ' GMT': ' +0000',
	        ' EDT': ' -0400',
	        ' EST': ' -0500',
	        ' CDT': ' -0500',
	        ' CST': ' -0600',
	        ' MDT': ' -0600',
	        ' MST': ' -0700',
	        ' PDT': ' -0700',
	        ' PST': ' -0800'
	    };
	    var military = 'YXWVUTSRQPONZABCDEFGHIKLM';
	    var timezone, timezoneIndex;
	
	    string = config._i
	        .replace(/\([^\)]*\)|[\n\t]/g, ' ') // Remove comments and folding whitespace
	        .replace(/(\s\s+)/g, ' ') // Replace multiple-spaces with a single space
	        .replace(/^\s|\s$/g, ''); // Remove leading and trailing spaces
	    match = basicRfcRegex.exec(string);
	
	    if (match) {
	        dayFormat = match[1] ? 'ddd' + ((match[1].length === 5) ? ', ' : ' ') : '';
	        dateFormat = 'D MMM ' + ((match[2].length > 10) ? 'YYYY ' : 'YY ');
	        timeFormat = 'HH:mm' + (match[4] ? ':ss' : '');
	
	        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	        if (match[1]) { // day of week given
	            var momentDate = new Date(match[2]);
	            var momentDay = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][momentDate.getDay()];
	
	            if (match[1].substr(0,3) !== momentDay) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return;
	            }
	        }
	
	        switch (match[5].length) {
	            case 2: // military
	                if (timezoneIndex === 0) {
	                    timezone = ' +0000';
	                } else {
	                    timezoneIndex = military.indexOf(match[5][1].toUpperCase()) - 12;
	                    timezone = ((timezoneIndex < 0) ? ' -' : ' +') +
	                        (('' + timezoneIndex).replace(/^-?/, '0')).match(/..$/)[0] + '00';
	                }
	                break;
	            case 4: // Zone
	                timezone = timezones[match[5]];
	                break;
	            default: // UT or +/-9999
	                timezone = timezones[' GMT'];
	        }
	        match[5] = timezone;
	        config._i = match.splice(1).join('');
	        tzFormat = ' ZZ';
	        config._f = dayFormat + dateFormat + timeFormat + tzFormat;
	        configFromStringAndFormat(config);
	        getParsingFlags(config).rfc2822 = true;
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    configFromRFC2822(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	    } else {
	        return;
	    }
	
	    // Final attempt, use Input Fallback
	    hooks.createFromInputFallback(config);
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear != null) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// constant that refers to the RFC 2822 form
	hooks.RFC_2822 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	    if (config._f === hooks.RFC_2822) {
	        configFromRFC2822(config);
	        return;
	    }
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (isUndefined(input)) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (isObject(input)) {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	function isDurationValid(m) {
	    for (var key in m) {
	        if (!(ordering.indexOf(key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	            return false;
	        }
	    }
	
	    var unitHasDecimal = false;
	    for (var i = 0; i < ordering.length; ++i) {
	        if (m[ordering[i]]) {
	            if (unitHasDecimal) {
	                return false; // only allow non-integers for smallest unit
	            }
	            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                unitHasDecimal = true;
	            }
	        }
	    }
	
	    return true;
	}
	
	function isValid$1() {
	    return this._isValid;
	}
	
	function createInvalid$1() {
	    return createDuration(NaN);
	}
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    this._isValid = isDurationValid(normalizedInput);
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime, keepMinutes) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16 && !keepMinutes) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm, false, true);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	createDuration.invalid = createInvalid$1;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString() {
	    if (!this.isValid()) {
	        return null;
	    }
	    var m = this.clone().utc();
	    if (m.year() < 0 || m.year() > 9999) {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	    if (isFunction(Date.prototype.toISOString)) {
	        // native implementation is ~50x faster, use it when we can
	        return this.toDate().toISOString();
	    }
	    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$2 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    // TODO: Remove "ordinalParse" fallback in next major release.
	    return isStrict ?
	      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	      locale._dayOfMonthOrdinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$2;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    if (!this.isValid()) {
	        return NaN;
	    }
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this.isValid() ? this[units + 's']() : NaN;
	}
	
	function makeGetter(name) {
	    return function () {
	        return this.isValid() ? this._data[name] : NaN;
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    ss: 44,         // a few seconds to seconds
	    s : 45,         // seconds to minute
	    m : 45,         // minutes to hour
	    h : 22,         // hours to day
	    d : 26,         // days to month
	    M : 11          // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds <= thresholds.ss && ['s', seconds]  ||
	            seconds < thresholds.s   && ['ss', seconds] ||
	            minutes <= 1             && ['m']           ||
	            minutes < thresholds.m   && ['mm', minutes] ||
	            hours   <= 1             && ['h']           ||
	            hours   < thresholds.h   && ['hh', hours]   ||
	            days    <= 1             && ['d']           ||
	            days    < thresholds.d   && ['dd', days]    ||
	            months  <= 1             && ['M']           ||
	            months  < thresholds.M   && ['MM', months]  ||
	            years   <= 1             && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    if (threshold === 's') {
	        thresholds.ss = limit - 1;
	    }
	    return true;
	}
	
	function humanize (withSuffix) {
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    if (!this.isValid()) {
	        return this.localeData().invalidDate();
	    }
	
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.isValid        = isValid$1;
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.18.1';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(755);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(755);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(2737);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports._curry = exports.bsSizes = exports.bsStyles = exports.bsClass = undefined;
	
	var _entries = __webpack_require__(756);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.prefix = prefix;
	exports.getClassSet = getClassSet;
	exports.splitBsProps = splitBsProps;
	exports.splitBsPropsAndOmit = splitBsPropsAndOmit;
	exports.addStyle = addStyle;
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function curry(fn) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var last = args[args.length - 1];
	    if (typeof last === 'function') {
	      return fn.apply(undefined, args);
	    }
	    return function (Component) {
	      return fn.apply(undefined, args.concat([Component]));
	    };
	  };
	} // TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.
	
	function prefix(props, variant) {
	  !(props.bsClass != null) ?  false ? (0, _invariant2.default)(false, 'A `bsClass` prop is required for this component') : (0, _invariant2.default)(false) : void 0;
	  return props.bsClass + (variant ? '-' + variant : '');
	}
	
	var bsClass = exports.bsClass = curry(function (defaultClass, Component) {
	  var propTypes = Component.propTypes || (Component.propTypes = {});
	  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	
	  propTypes.bsClass = _propTypes2.default.string;
	  defaultProps.bsClass = defaultClass;
	
	  return Component;
	});
	
	var bsStyles = exports.bsStyles = curry(function (styles, defaultStyle, Component) {
	  if (typeof defaultStyle !== 'string') {
	    Component = defaultStyle;
	    defaultStyle = undefined;
	  }
	
	  var existing = Component.STYLES || [];
	  var propTypes = Component.propTypes || {};
	
	  styles.forEach(function (style) {
	    if (existing.indexOf(style) === -1) {
	      existing.push(style);
	    }
	  });
	
	  var propType = _propTypes2.default.oneOf(existing);
	
	  // expose the values on the propType function for documentation
	  Component.STYLES = existing;
	  propType._values = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsStyle: propType
	  });
	
	  if (defaultStyle !== undefined) {
	    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
	    defaultProps.bsStyle = defaultStyle;
	  }
	
	  return Component;
	});
	
	var bsSizes = exports.bsSizes = curry(function (sizes, defaultSize, Component) {
	  if (typeof defaultSize !== 'string') {
	    Component = defaultSize;
	    defaultSize = undefined;
	  }
	
	  var existing = Component.SIZES || [];
	  var propTypes = Component.propTypes || {};
	
	  sizes.forEach(function (size) {
	    if (existing.indexOf(size) === -1) {
	      existing.push(size);
	    }
	  });
	
	  var values = [];
	  existing.forEach(function (size) {
	    var mappedSize = _StyleConfig.SIZE_MAP[size];
	    if (mappedSize && mappedSize !== size) {
	      values.push(mappedSize);
	    }
	
	    values.push(size);
	  });
	
	  var propType = _propTypes2.default.oneOf(values);
	  propType._values = values;
	
	  // expose the values on the propType function for documentation
	  Component.SIZES = existing;
	
	  Component.propTypes = (0, _extends3.default)({}, propTypes, {
	    bsSize: propType
	  });
	
	  if (defaultSize !== undefined) {
	    if (!Component.defaultProps) {
	      Component.defaultProps = {};
	    }
	    Component.defaultProps.bsSize = defaultSize;
	  }
	
	  return Component;
	});
	
	function getClassSet(props) {
	  var _classes;
	
	  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);
	
	  if (props.bsSize) {
	    var bsSize = _StyleConfig.SIZE_MAP[props.bsSize] || props.bsSize;
	    classes[prefix(props, bsSize)] = true;
	  }
	
	  if (props.bsStyle) {
	    classes[prefix(props, props.bsStyle)] = true;
	  }
	
	  return classes;
	}
	
	function getBsProps(props) {
	  return {
	    bsClass: props.bsClass,
	    bsSize: props.bsSize,
	    bsStyle: props.bsStyle,
	    bsRole: props.bsRole
	  };
	}
	
	function isBsProp(propName) {
	  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
	}
	
	function splitBsProps(props) {
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (!isBsProp(propName)) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	function splitBsPropsAndOmit(props, omittedPropNames) {
	  var isOmittedProp = {};
	  omittedPropNames.forEach(function (propName) {
	    isOmittedProp[propName] = true;
	  });
	
	  var elementProps = {};
	  (0, _entries2.default)(props).forEach(function (_ref2) {
	    var propName = _ref2[0],
	        propValue = _ref2[1];
	
	    if (!isBsProp(propName) && !isOmittedProp[propName]) {
	      elementProps[propName] = propValue;
	    }
	  });
	
	  return [getBsProps(props), elementProps];
	}
	
	/**
	 * Add a style variant to a Component. Mutates the propTypes of the component
	 * in order to validate the new variant.
	 */
	function addStyle(Component) {
	  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    styleVariant[_key2 - 1] = arguments[_key2];
	  }
	
	  bsStyles(styleVariant, Component);
	}
	
	var _curry = exports._curry = curry;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StyleSheetManager = exports.ServerStyleSheet = exports.withTheme = exports.ThemeProvider = exports.injectGlobal = exports.keyframes = exports.css = undefined;
	
	var _flatten = __webpack_require__(1408);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _stringifyRules = __webpack_require__(3274);
	
	var _stringifyRules2 = _interopRequireDefault(_stringifyRules);
	
	var _generateAlphabeticName = __webpack_require__(3269);
	
	var _generateAlphabeticName2 = _interopRequireDefault(_generateAlphabeticName);
	
	var _css = __webpack_require__(3257);
	
	var _css2 = _interopRequireDefault(_css);
	
	var _ServerStyleSheet = __webpack_require__(376);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	var _StyleSheetManager = __webpack_require__(1405);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	var _StyledComponent2 = __webpack_require__(3264);
	
	var _StyledComponent3 = _interopRequireDefault(_StyledComponent2);
	
	var _ComponentStyle2 = __webpack_require__(3263);
	
	var _ComponentStyle3 = _interopRequireDefault(_ComponentStyle2);
	
	var _styled2 = __webpack_require__(3260);
	
	var _styled3 = _interopRequireDefault(_styled2);
	
	var _keyframes2 = __webpack_require__(3259);
	
	var _keyframes3 = _interopRequireDefault(_keyframes2);
	
	var _injectGlobal2 = __webpack_require__(3258);
	
	var _injectGlobal3 = _interopRequireDefault(_injectGlobal2);
	
	var _constructWithOptions2 = __webpack_require__(3256);
	
	var _constructWithOptions3 = _interopRequireDefault(_constructWithOptions2);
	
	var _ThemeProvider = __webpack_require__(377);
	
	var _ThemeProvider2 = _interopRequireDefault(_ThemeProvider);
	
	var _withTheme = __webpack_require__(3261);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* Instantiate singletons */
	
	
	/* Import components */
	
	
	/* Import singleton constructors */
	
	
	/* Import singletons */
	var ComponentStyle = (0, _ComponentStyle3.default)(_generateAlphabeticName2.default, _flatten2.default, _stringifyRules2.default);
	
	/* Import Higher Order Components */
	
	var constructWithOptions = (0, _constructWithOptions3.default)(_css2.default);
	var StyledComponent = (0, _StyledComponent3.default)(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = (0, _keyframes3.default)(_generateAlphabeticName2.default, _stringifyRules2.default, _css2.default);
	var injectGlobal = (0, _injectGlobal3.default)(_stringifyRules2.default, _css2.default);
	var styled = (0, _styled3.default)(StyledComponent, constructWithOptions);
	
	/* Export everything */
	exports.default = styled;
	exports.css = _css2.default;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.ThemeProvider = _ThemeProvider2.default;
	exports.withTheme = _withTheme2.default;
	exports.ServerStyleSheet = _ServerStyleSheet2.default;
	exports.StyleSheetManager = _StyleSheetManager2.default;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.rtl = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rtl = document.getElementsByTagName('html')[0].getAttribute('dir');
	var withDirection = function withDirection(Component) {
	  return function (props) {
	    return _react2.default.createElement(Component, Object.assign({}, props, { 'data-rtl': rtl }));
	  };
	};
	
	exports.default = withDirection;
	exports.rtl = rtl;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(896);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseChildIndex = exports.getReactEventByType = exports.renderByOrder = exports.isChildrenEqual = exports.isSingleChildEqual = exports.filterSvgElements = exports.isSsr = exports.validateWidthHeight = exports.filterEventsOfChild = exports.filterEventAttributes = exports.getPresentationAttributes = exports.withoutType = exports.findChildByType = exports.findAllByType = exports.getDisplayName = exports.LEGEND_TYPES = exports.SCALE_TYPES = exports.EVENT_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = undefined;
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isString2 = __webpack_require__(154);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _isObject2 = __webpack_require__(87);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DataUtils = __webpack_require__(39);
	
	var _PureRender = __webpack_require__(22);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var PRESENTATION_ATTRIBUTES = exports.PRESENTATION_ATTRIBUTES = {
	  alignmentBaseline: _propTypes2.default.string,
	  angle: _propTypes2.default.number,
	  baselineShift: _propTypes2.default.string,
	  clip: _propTypes2.default.string,
	  clipPath: _propTypes2.default.string,
	  clipRule: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  colorInterpolation: _propTypes2.default.string,
	  colorInterpolationFilters: _propTypes2.default.string,
	  colorProfile: _propTypes2.default.string,
	  colorRendering: _propTypes2.default.string,
	  cursor: _propTypes2.default.string,
	  direction: _propTypes2.default.oneOf(['ltr', 'rtl', 'inherit']),
	  display: _propTypes2.default.string,
	  dominantBaseline: _propTypes2.default.string,
	  enableBackground: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  fillOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  fillRule: _propTypes2.default.oneOf(['nonzero', 'evenodd', 'inherit']),
	  filter: _propTypes2.default.string,
	  floodColor: _propTypes2.default.string,
	  floodOpacity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  font: _propTypes2.default.string,
	  fontFamily: _propTypes2.default.string,
	  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontSizeAdjust: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  fontStretch: _propTypes2.default.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
	  fontStyle: _propTypes2.default.oneOf(['normal', 'italic', 'oblique', 'inherit']),
	  fontVariant: _propTypes2.default.oneOf(['normal', 'small-caps', 'inherit']),
	  fontWeight: _propTypes2.default.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
	  glyphOrientationHorizontal: _propTypes2.default.string,
	  glyphOrientationVertical: _propTypes2.default.string,
	  imageRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
	  kerning: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  lightingColor: _propTypes2.default.string,
	  markerEnd: _propTypes2.default.string,
	  markerMid: _propTypes2.default.string,
	  markerStart: _propTypes2.default.string,
	  mask: _propTypes2.default.string,
	  opacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  overflow: _propTypes2.default.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
	  pointerEvents: _propTypes2.default.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
	  shapeRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
	  stopColor: _propTypes2.default.string,
	  stopOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  stroke: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeDasharray: _propTypes2.default.string,
	  strokeDashoffset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeLinecap: _propTypes2.default.oneOf(['butt', 'round', 'square', 'inherit']),
	  strokeLinejoin: _propTypes2.default.oneOf(['miter', 'round', 'bevel', 'inherit']),
	  strokeMiterlimit: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeOpacity: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  textDecoration: _propTypes2.default.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
	  textRendering: _propTypes2.default.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
	  unicodeBidi: _propTypes2.default.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
	  visibility: _propTypes2.default.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
	  wordSpacing: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  writingMode: _propTypes2.default.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
	  transform: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  dx: _propTypes2.default.number,
	  dy: _propTypes2.default.number,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  r: _propTypes2.default.number,
	  // The radius of Rectangle
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	};
	
	var EVENT_ATTRIBUTES = exports.EVENT_ATTRIBUTES = {
	  onClick: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onMouseOver: _propTypes2.default.func,
	  onMouseMove: _propTypes2.default.func,
	  onMouseOut: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchMove: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  onTouchCancel: _propTypes2.default.func
	};
	
	var REACT_BROWSER_EVENT_MAP = {
	  click: 'onClick',
	  mousedown: 'onMouseDown',
	  mouseup: 'onMouseUp',
	  mouseover: 'onMouseOver',
	  mousemove: 'onMouseMove',
	  mouseout: 'onMouseOut',
	  mouseenter: 'onMouseEnter',
	  mouseleave: 'onMouseLeave',
	  touchcancel: 'onTouchCancel',
	  touchend: 'onTouchEnd',
	  touchmove: 'onTouchMove',
	  touchstart: 'onTouchStart'
	};
	
	var SCALE_TYPES = exports.SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
	
	var LEGEND_TYPES = exports.LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
	
	/**
	 * Get the display name of a component
	 * @param  {Object} Comp Specified Component
	 * @return {String}      Display name of Component
	 */
	var getDisplayName = exports.getDisplayName = function getDisplayName(Comp) {
	  if (!Comp) {
	    return '';
	  }
	  if (typeof Comp === 'string') {
	    return Comp;
	  }
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	/*
	 * Find and return all matched children by type. `type` can be a React element class or
	 * string
	 */
	var findAllByType = exports.findAllByType = function findAllByType(children, type) {
	  var result = [];
	  var types = [];
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    var childType = child && child.type && (child.type.displayName || child.type.name);
	    if (types.indexOf(childType) !== -1) {
	      result.push(child);
	    }
	  });
	
	  return result;
	};
	/*
	 * Return the first matched child by type, return null otherwise.
	 * `type` can be a React element class or string.
	 */
	var findChildByType = exports.findChildByType = function findChildByType(children, type) {
	  var result = findAllByType(children, type);
	
	  return result && result[0];
	};
	
	/*
	 * Create a new array of children excluding the ones matched the type
	 */
	var withoutType = exports.withoutType = function withoutType(children, type) {
	  var newChildren = [];
	  var types = void 0;
	
	  if ((0, _isArray3.default)(type)) {
	    types = type.map(function (t) {
	      return getDisplayName(t);
	    });
	  } else {
	    types = [getDisplayName(type)];
	  }
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
	      return;
	    }
	    newChildren.push(child);
	  });
	
	  return newChildren;
	};
	
	/**
	 * get all the presentation attribute of svg element
	 * @param  {Object} el A react element or the props of a react element
	 * @return {Object}    attributes or null
	 */
	var getPresentationAttributes = exports.getPresentationAttributes = function getPresentationAttributes(el) {
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = props[i];
	    }
	  }
	  return out;
	};
	
	var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
	  return function (e) {
	    originalHandler(props, e);
	
	    return null;
	  };
	};
	/**
	 * get all the event attribute of svg element
	 * @param  {Object}   el           A react element or the props of a react element
	 * @param  {Function} newHandler   New handler of event
	 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
	 * @return {Object}                attributes or null
	 */
	var filterEventAttributes = exports.filterEventAttributes = function filterEventAttributes(el, newHandler) {
	  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!el || (0, _isFunction3.default)(el)) {
	    return null;
	  }
	
	  var props = _react2.default.isValidElement(el) ? el.props : el;
	
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
	      if (!out) out = {};
	      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
	    }
	  }
	  return out;
	};
	
	var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
	  return function (e) {
	    originalHandler(data, index, e);
	
	    return null;
	  };
	};
	
	var filterEventsOfChild = exports.filterEventsOfChild = function filterEventsOfChild(props, data, index) {
	  if (!(0, _isObject3.default)(props)) {
	    return null;
	  }
	
	  var out = null;
	  // eslint-disable-next-line no-restricted-syntax
	  for (var i in props) {
	    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && (0, _isFunction3.default)(props[i])) {
	      if (!out) out = {};
	      out[i] = getEventHandlerOfChild(props[i], data, index);
	    }
	  }
	  return out;
	};
	
	/**
	 * validate the width and height props of a chart element
	 * @param  {Object} el A chart element
	 * @return {Boolean}   true If the props width and height are number, and greater than 0
	 */
	var validateWidthHeight = exports.validateWidthHeight = function validateWidthHeight(el) {
	  if (!el || !el.props) {
	    return false;
	  }
	  var _el$props = el.props,
	      width = _el$props.width,
	      height = _el$props.height;
	
	
	  if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0) {
	    return false;
	  }
	
	  return true;
	};
	
	var isSsr = exports.isSsr = function isSsr() {
	  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
	};
	
	var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];
	
	var isSvgElement = function isSvgElement(child) {
	  return child && child.type && (0, _isString3.default)(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
	};
	
	/**
	 * Filter all the svg elements of children
	 * @param  {Array} children The children of a react element
	 * @return {Array}          All the svg elements
	 */
	var filterSvgElements = exports.filterSvgElements = function filterSvgElements(children) {
	  var svgElements = [];
	
	  _react2.default.Children.forEach(children, function (entry) {
	    if (entry && entry.type && (0, _isString3.default)(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
	      svgElements.push(entry);
	    }
	  });
	
	  return svgElements;
	};
	var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
	  if ((0, _isNil3.default)(nextChild) && (0, _isNil3.default)(prevChild)) {
	    return true;
	  } else if (!(0, _isNil3.default)(nextChild) && !(0, _isNil3.default)(prevChild)) {
	    var _ref = nextChild.props || {},
	        nextChildren = _ref.children,
	        nextProps = _objectWithoutProperties(_ref, ['children']);
	
	    var _ref2 = prevChild.props || {},
	        prevChildren = _ref2.children,
	        prevProps = _objectWithoutProperties(_ref2, ['children']);
	
	    if (nextChildren && prevChildren) {
	      // eslint-disable-next-line no-use-before-define
	      return (0, _PureRender.shallowEqual)(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
	    } else if (!nextChildren && !prevChildren) {
	      return (0, _PureRender.shallowEqual)(nextProps, prevProps);
	    }
	
	    return false;
	  }
	
	  return false;
	};
	/**
	 * Wether props of children changed
	 * @param  {Object} nextChildren The latest children
	 * @param  {Object} prevChildren The prev children
	 * @return {Boolean}             equal or not
	 */
	exports.isSingleChildEqual = isSingleChildEqual;
	var isChildrenEqual = exports.isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
	  if (nextChildren === prevChildren) {
	    return true;
	  }
	
	  if (_react.Children.count(nextChildren) !== _react.Children.count(prevChildren)) {
	    return false;
	  }
	  var count = _react.Children.count(nextChildren);
	
	  if (count === 0) {
	    return true;
	  }
	  if (count === 1) {
	    return isSingleChildEqual((0, _isArray3.default)(nextChildren) ? nextChildren[0] : nextChildren, (0, _isArray3.default)(prevChildren) ? prevChildren[0] : prevChildren);
	  }
	
	  for (var i = 0; i < count; i++) {
	    var nextChild = nextChildren[i];
	    var prevChild = prevChildren[i];
	
	    if ((0, _isArray3.default)(nextChild) || (0, _isArray3.default)(prevChild)) {
	      if (!isChildrenEqual(nextChild, prevChild)) {
	        return false;
	      }
	    } else if (!isSingleChildEqual(nextChild, prevChild)) {
	      return false;
	    }
	  }
	
	  return true;
	};
	
	var renderByOrder = exports.renderByOrder = function renderByOrder(children, renderMap) {
	  var elements = [];
	  var record = {};
	
	  _react.Children.forEach(children, function (child, index) {
	    if (child && isSvgElement(child)) {
	      elements.push(child);
	    } else if (child && renderMap[getDisplayName(child.type)]) {
	      var displayName = getDisplayName(child.type);
	      var _renderMap$displayNam = renderMap[displayName],
	          handler = _renderMap$displayNam.handler,
	          once = _renderMap$displayNam.once;
	
	
	      if (once && !record[displayName] || !once) {
	        var results = handler(child, displayName, index);
	
	        if ((0, _isArray3.default)(results)) {
	          elements = [elements].concat(_toConsumableArray(results));
	        } else {
	          elements.push(results);
	        }
	
	        record[displayName] = true;
	      }
	    }
	  });
	
	  return elements;
	};
	
	var getReactEventByType = exports.getReactEventByType = function getReactEventByType(e) {
	  var type = e && e.type;
	
	  if (type && REACT_BROWSER_EVENT_MAP[type]) {
	    return REACT_BROWSER_EVENT_MAP[type];
	  }
	
	  return null;
	};
	
	var parseChildIndex = exports.parseChildIndex = function parseChildIndex(child, children) {
	  var result = -1;
	  _react.Children.forEach(children, function (entry, index) {
	    if (entry === child) {
	      result = index;
	    }
	  });
	
	  return result;
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 22 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;
	function shallowEqual(a, b) {
	  /* eslint-disable no-restricted-syntax */
	  for (var key in a) {
	    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
	      return false;
	    }
	  }
	  for (var _key in b) {
	    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function shouldComponentUpdate(props, state) {
	  return !shallowEqual(props, this.props) || !shallowEqual(state, this.state);
	}
	
	function pureRenderDecorator(component) {
	  // eslint-disable-next-line no-param-reassign
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(287);
	module.exports.easing = __webpack_require__(1842);
	module.exports.canvas = __webpack_require__(1841);
	module.exports.options = __webpack_require__(1843);


/***/ },
/* 24 */
[3534, 128, 87],
/* 25 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Voronoi = __webpack_require__(900);
	
	var _react = __webpack_require__(1);
	
	var _animation = __webpack_require__(38);
	
	var _scalesUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, (0, _scalesUtils.getScalePropTypesByAttribute)('x'), (0, _scalesUtils.getScalePropTypesByAttribute)('y'), (0, _scalesUtils.getScalePropTypesByAttribute)('size'), (0, _scalesUtils.getScalePropTypesByAttribute)('opacity'), (0, _scalesUtils.getScalePropTypesByAttribute)('color'), {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  onValueMouseOver: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  onValueClick: _propTypes2.default.func,
	  onValueRightClick: _propTypes2.default.func,
	  onSeriesMouseOver: _propTypes2.default.func,
	  onSeriesMouseOut: _propTypes2.default.func,
	  onSeriesClick: _propTypes2.default.func,
	  onSeriesRightClick: _propTypes2.default.func,
	  onNearestX: _propTypes2.default.func,
	  onNearestXY: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  animation: _animation.AnimationPropType
	});
	
	var defaultProps = {
	  className: '',
	  style: {}
	};
	
	var AbstractSeries = function (_PureComponent) {
	  _inherits(AbstractSeries, _PureComponent);
	
	  _createClass(AbstractSeries, null, [{
	    key: 'getParentConfig',
	
	
	    /**
	     * Get a default config for the parent.
	     * @returns {Object} Empty config.
	     */
	    value: function getParentConfig() {
	      return {};
	    }
	  }, {
	    key: 'requiresSVG',
	
	    /**
	     * Tells the rest of the world that it requires SVG to work.
	     * @returns {boolean} Result.
	     */
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  function AbstractSeries(props) {
	    _classCallCheck(this, AbstractSeries);
	
	    var _this = _possibleConstructorReturn(this, (AbstractSeries.__proto__ || Object.getPrototypeOf(AbstractSeries)).call(this, props));
	
	    _this._seriesMouseOverHandler = _this._seriesMouseOverHandler.bind(_this);
	    _this._valueMouseOverHandler = _this._valueMouseOverHandler.bind(_this);
	    _this._seriesMouseOutHandler = _this._seriesMouseOutHandler.bind(_this);
	    _this._valueMouseOutHandler = _this._valueMouseOutHandler.bind(_this);
	    _this._seriesClickHandler = _this._seriesClickHandler.bind(_this);
	    _this._valueClickHandler = _this._valueClickHandler.bind(_this);
	    _this._seriesRightClickHandler = _this._seriesRightClickHandler.bind(_this);
	    _this._valueRightClickHandler = _this._valueRightClickHandler.bind(_this);
	    return _this;
	  }
	
	  /**
	   * Mouse over handler for the specific series' value.
	   * @param {Object} d Value object
	   * @param {Object} event Event.
	   * @protected
	   */
	
	
	  _createClass(AbstractSeries, [{
	    key: '_valueMouseOverHandler',
	    value: function _valueMouseOverHandler(d, event) {
	      var _props = this.props,
	          onValueMouseOver = _props.onValueMouseOver,
	          onSeriesMouseOver = _props.onSeriesMouseOver;
	
	      if (onValueMouseOver) {
	        onValueMouseOver(d, { event: event });
	      }
	      if (onSeriesMouseOver) {
	        onSeriesMouseOver({ event: event });
	      }
	    }
	
	    /**
	     * Mouse over handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesMouseOverHandler',
	    value: function _seriesMouseOverHandler(event) {
	      var onSeriesMouseOver = this.props.onSeriesMouseOver;
	
	      if (onSeriesMouseOver) {
	        onSeriesMouseOver({ event: event });
	      }
	    }
	
	    /**
	     * Mouse out handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueMouseOutHandler',
	    value: function _valueMouseOutHandler(d, event) {
	      var _props2 = this.props,
	          onValueMouseOut = _props2.onValueMouseOut,
	          onSeriesMouseOut = _props2.onSeriesMouseOut;
	
	      if (onValueMouseOut) {
	        onValueMouseOut(d, { event: event });
	      }
	      if (onSeriesMouseOut) {
	        onSeriesMouseOut({ event: event });
	      }
	    }
	
	    /**
	     * Mouse out handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesMouseOutHandler',
	    value: function _seriesMouseOutHandler(event) {
	      var onSeriesMouseOut = this.props.onSeriesMouseOut;
	
	      if (onSeriesMouseOut) {
	        onSeriesMouseOut({ event: event });
	      }
	    }
	
	    /**
	     * Click handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueClickHandler',
	    value: function _valueClickHandler(d, event) {
	      var _props3 = this.props,
	          onValueClick = _props3.onValueClick,
	          onSeriesClick = _props3.onSeriesClick;
	
	      if (onValueClick) {
	        onValueClick(d, { event: event });
	      }
	      if (onSeriesClick) {
	        onSeriesClick({ event: event });
	      }
	    }
	
	    /**
	     * Right Click handler for the specific series' value.
	     * @param {Object} d Value object
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_valueRightClickHandler',
	    value: function _valueRightClickHandler(d, event) {
	      var _props4 = this.props,
	          onValueRightClick = _props4.onValueRightClick,
	          onSeriesRightClick = _props4.onSeriesRightClick;
	
	      if (onValueRightClick) {
	        onValueRightClick(d, { event: event });
	      }
	      if (onSeriesRightClick) {
	        onSeriesRightClick({ event: event });
	      }
	    }
	
	    /**
	     * Click handler for the entire series.
	     * @param {Object} event Event.
	     * @protected
	     */
	
	  }, {
	    key: '_seriesClickHandler',
	    value: function _seriesClickHandler(event) {
	      var onSeriesClick = this.props.onSeriesClick;
	
	      if (onSeriesClick) {
	        onSeriesClick({ event: event });
	      }
	    }
	
	    /**
	    * Right Click handler for the entire series.
	    * @param {Object} event Event.
	    * @protected
	    */
	
	  }, {
	    key: '_seriesRightClickHandler',
	    value: function _seriesRightClickHandler(event) {
	      var onSeriesRightClick = this.props.onSeriesRightClick;
	
	      if (onSeriesRightClick) {
	        onSeriesRightClick({ event: event });
	      }
	    }
	
	    /**
	     * Get attribute functor.
	     * @param {string} attr Attribute name
	     * @returns {*} Functor.
	     * @protected
	     */
	
	  }, {
	    key: '_getAttributeFunctor',
	    value: function _getAttributeFunctor(attr) {
	      return (0, _scalesUtils.getAttributeFunctor)(this.props, attr);
	    }
	
	    /**
	     * Get the attr0 functor.
	     * @param {string} attr Attribute name.
	     * @returns {*} Functor.
	     * @private
	     */
	
	  }, {
	    key: '_getAttr0Functor',
	    value: function _getAttr0Functor(attr) {
	      return (0, _scalesUtils.getAttr0Functor)(this.props, attr);
	    }
	
	    /**
	     * Get the attribute value if it is available.
	     * @param {string} attr Attribute name.
	     * @returns {*} Attribute value if available, fallback value or undefined
	     * otherwise.
	     * @protected
	     */
	
	  }, {
	    key: '_getAttributeValue',
	    value: function _getAttributeValue(attr) {
	      return (0, _scalesUtils.getAttributeValue)(this.props, attr);
	    }
	
	    /**
	     * Get the scale object distance by the attribute from the list of properties.
	     * @param {string} attr Attribute name.
	     * @returns {number} Scale distance.
	     * @protected
	     */
	
	  }, {
	    key: '_getScaleDistance',
	    value: function _getScaleDistance(attr) {
	      var scaleObject = (0, _scalesUtils.getScaleObjectFromProps)(this.props, attr);
	      return scaleObject ? scaleObject.distance : 0;
	    }
	  }, {
	    key: '_getXYCoordinateInContainer',
	    value: function _getXYCoordinateInContainer(event) {
	      var _props5 = this.props,
	          _props5$marginTop = _props5.marginTop,
	          marginTop = _props5$marginTop === undefined ? 0 : _props5$marginTop,
	          _props5$marginLeft = _props5.marginLeft,
	          marginLeft = _props5$marginLeft === undefined ? 0 : _props5$marginLeft;
	      var _event$nativeEvent = event.nativeEvent,
	          clientX = _event$nativeEvent.clientX,
	          clientY = _event$nativeEvent.clientY,
	          currentTarget = event.currentTarget;
	
	      var rect = currentTarget.getBoundingClientRect();
	      return {
	        x: clientX - rect.left - currentTarget.clientLeft - marginLeft,
	        y: clientY - rect.top - currentTarget.clientTop - marginTop
	      };
	    }
	  }, {
	    key: '_handleNearestX',
	    value: function _handleNearestX(event) {
	      var _props6 = this.props,
	          onNearestX = _props6.onNearestX,
	          data = _props6.data;
	
	      var minDistance = Number.POSITIVE_INFINITY;
	      var value = null;
	      var valueIndex = null;
	
	      var coordinate = this._getXYCoordinateInContainer(event);
	      var xScaleFn = this._getAttributeFunctor('x');
	
	      data.forEach(function (item, i) {
	        var currentCoordinate = xScaleFn(item);
	        var newDistance = Math.abs(coordinate.x - currentCoordinate);
	        if (newDistance < minDistance) {
	          minDistance = newDistance;
	          value = item;
	          valueIndex = i;
	        }
	      });
	      if (!value) {
	        return;
	      }
	      onNearestX(value, {
	        innerX: xScaleFn(value),
	        index: valueIndex,
	        event: event.nativeEvent
	      });
	    }
	  }, {
	    key: '_handleNearestXY',
	    value: function _handleNearestXY(event) {
	      var _props7 = this.props,
	          onNearestXY = _props7.onNearestXY,
	          data = _props7.data;
	
	
	      var coordinate = this._getXYCoordinateInContainer(event);
	      var xScaleFn = this._getAttributeFunctor('x');
	      var yScaleFn = this._getAttributeFunctor('y');
	
	      // Create a voronoi with each node center points
	      var voronoiInstance = (0, _d3Voronoi.voronoi)().x(xScaleFn).y(yScaleFn);
	
	      var foundPoint = voronoiInstance(data).find(coordinate.x, coordinate.y);
	      var value = foundPoint.data;
	
	      if (!value) {
	        return;
	      }
	      onNearestXY(value, {
	        innerX: foundPoint.x,
	        innerY: foundPoint.y,
	        index: foundPoint.index,
	        event: event.nativeEvent
	      });
	    }
	  }, {
	    key: 'onParentMouseMove',
	    value: function onParentMouseMove(event) {
	      var _props8 = this.props,
	          onNearestX = _props8.onNearestX,
	          onNearestXY = _props8.onNearestXY,
	          data = _props8.data;
	
	      if (!onNearestX && !onNearestXY || !data) {
	        return;
	      }
	      if (onNearestXY) {
	        this._handleNearestXY(event);
	      } else {
	        this._handleNearestX(event);
	      }
	    }
	  }]);
	
	  return AbstractSeries;
	}(_react.PureComponent);
	
	AbstractSeries.displayName = 'AbstractSeries';
	AbstractSeries.propTypes = propTypes;
	AbstractSeries.defaultProps = defaultProps;
	
	exports.default = AbstractSeries;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(414)
	var ieee754 = __webpack_require__(2266)
	var isArray = __webpack_require__(959)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(325);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function elementType(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  if (propType !== 'function' && propType !== 'string') {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(elementType);
	module.exports = exports['default'];

/***/ },
/* 31 */
[3448, 3278],
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlockTree = __webpack_require__(910);
	var ContentState = __webpack_require__(422);
	var EditorBidiService = __webpack_require__(1929);
	var Immutable = __webpack_require__(26);
	var SelectionState = __webpack_require__(184);
	
	var OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Stack = Immutable.Stack;
	
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent,
	        decorator = config.decorator;
	
	    var recordConfig = _extends({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	
	    return new EditorState(map);
	  };
	
	  EditorState.prototype.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  EditorState.prototype.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  EditorState.prototype.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  EditorState.prototype.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  EditorState.prototype.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  EditorState.prototype.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  EditorState.prototype.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  EditorState.prototype.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  EditorState.prototype.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  };
	
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	
	
	  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	  };
	
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	
	
	  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  EditorState.prototype.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  };
	
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  };
	
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	    return updateSelection(editorState, selection, true);
	  };
	
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  };
	
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  };
	
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var forceSelection = changeType !== 'insert-characters';
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	    // Don't discard inline style overrides for the following change types:
	    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];
	
	    if (overrideChangeTypes.indexOf(changeType) === -1) {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	
	    return EditorState.set(editorState, editorStateChanges);
	  };
	
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  };
	
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  };
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  EditorState.prototype.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
	  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
	  var prevBlockMap = contentState.getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
	  }).map(function (block) {
	    return BlockTree.generate(content, block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
	    return k === fromKey;
	  }).skip(1).skipUntil(function (block, _) {
	    return block.getLength();
	  }).first();
	
	  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Icon = function Icon(props) {
	    var type = props.type,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        spin = props.spin;
	
	    var classString = (0, _classnames2['default'])((0, _defineProperty3['default'])({
	        anticon: true,
	        'anticon-spin': !!spin || type === 'loading'
	    }, 'anticon-' + type, true), className);
	    return React.createElement('i', (0, _extends3['default'])({}, (0, _omit2['default'])(props, ['type', 'spin']), { className: classString }));
	};
	exports['default'] = Icon;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	
	module.exports = {
		/**
		 * @private
		 */
		_set: function(scope, values) {
			return helpers.merge(this[scope] || (this[scope] = {}), values);
		}
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.WEEKDAYS = exports.BLOCKED_MODIFIER = exports.DAY_SIZE = exports.OPEN_UP = exports.OPEN_DOWN = exports.ANCHOR_RIGHT = exports.ANCHOR_LEFT = exports.ICON_AFTER_POSITION = exports.ICON_BEFORE_POSITION = exports.VERTICAL_SCROLLABLE = exports.VERTICAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = exports.END_DATE = exports.START_DATE = exports.ISO_MONTH_FORMAT = exports.ISO_FORMAT = exports.DISPLAY_FORMAT = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DISPLAY_FORMAT = exports.DISPLAY_FORMAT = 'L';
	var ISO_FORMAT = exports.ISO_FORMAT = 'YYYY-MM-DD';
	var ISO_MONTH_FORMAT = exports.ISO_MONTH_FORMAT = 'YYYY-MM';
	
	var START_DATE = exports.START_DATE = 'startDate';
	var END_DATE = exports.END_DATE = 'endDate';
	
	var HORIZONTAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = 'horizontal';
	var VERTICAL_ORIENTATION = exports.VERTICAL_ORIENTATION = 'vertical';
	var VERTICAL_SCROLLABLE = exports.VERTICAL_SCROLLABLE = 'verticalScrollable';
	
	var ICON_BEFORE_POSITION = exports.ICON_BEFORE_POSITION = 'before';
	var ICON_AFTER_POSITION = exports.ICON_AFTER_POSITION = 'after';
	
	var ANCHOR_LEFT = exports.ANCHOR_LEFT = 'left';
	var ANCHOR_RIGHT = exports.ANCHOR_RIGHT = 'right';
	
	var OPEN_DOWN = exports.OPEN_DOWN = 'down';
	var OPEN_UP = exports.OPEN_UP = 'up';
	
	var DAY_SIZE = exports.DAY_SIZE = 39;
	var BLOCKED_MODIFIER = exports.BLOCKED_MODIFIER = 'blocked';
	var WEEKDAYS = exports.WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AnimationPropType = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.extractAnimatedPropValues = extractAnimatedPropValues;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Interpolate = __webpack_require__(291);
	
	var _reactMotion = __webpack_require__(2761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var ANIMATION_PROPTYPES = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  stiffness: _propTypes2.default.number,
	  nonAnimatedProps: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  damping: _propTypes2.default.number
	}), _propTypes2.default.bool]);
	
	var propTypes = {
	  animatedProps: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	  animation: ANIMATION_PROPTYPES,
	  onStart: _propTypes2.default.func,
	  onEnd: _propTypes2.default.func
	};
	
	/**
	 * Format the animation style object
	 * @param {Object|String} animationStyle - The animation style property, either the name of a
	 * presets are one of noWobble, gentle, wobbly, stiff
	 */
	function getAnimationStyle() {
	  var animationStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _reactMotion.presets.noWobble;
	
	  if (typeof animationStyle === 'string') {
	    return _reactMotion.presets[animationStyle] || _reactMotion.presets.noWobble;
	  }
	  var damping = animationStyle.damping,
	      stiffness = animationStyle.stiffness;
	
	  return _extends({
	    damping: damping || _reactMotion.presets.noWobble.damping,
	    stiffness: stiffness || _reactMotion.presets.noWobble.stiffness
	  }, animationStyle);
	}
	
	/**
	 * Extract the animated props from the entire props object.
	 * @param {Object} props Props.
	 * @returns {Object} Object of animated props.
	 */
	function extractAnimatedPropValues(props) {
	  var animatedProps = props.animatedProps,
	      otherProps = _objectWithoutProperties(props, ['animatedProps']);
	
	  return animatedProps.reduce(function (result, animatedPropName) {
	    if (otherProps.hasOwnProperty(animatedPropName)) {
	      result[animatedPropName] = otherProps[animatedPropName];
	    }
	    return result;
	  }, {});
	}
	
	var Animation = function (_PureComponent) {
	  _inherits(Animation, _PureComponent);
	
	  function Animation(props) {
	    _classCallCheck(this, Animation);
	
	    var _this = _possibleConstructorReturn(this, (Animation.__proto__ || Object.getPrototypeOf(Animation)).call(this, props));
	
	    _this._updateInterpolator(props);
	    _this._renderChildren = _this._renderChildren.bind(_this);
	    _this._motionEndHandler = _this._motionEndHandler.bind(_this);
	    return _this;
	  }
	
	  _createClass(Animation, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(props) {
	      this._updateInterpolator(this.props, props);
	      if (props.onStart) {
	        props.onStart();
	      }
	    }
	
	    /**
	     * Update the interpolator function and assign it to this._interpolator.
	     * @param {Object} oldProps Old props.
	     * @param {Object} newProps New props.
	     * @private
	     */
	
	  }, {
	    key: '_updateInterpolator',
	    value: function _updateInterpolator(oldProps, newProps) {
	      this._interpolator = (0, _d3Interpolate.interpolate)(extractAnimatedPropValues(oldProps), newProps ? extractAnimatedPropValues(newProps) : null);
	    }
	
	    /**
	     * Render the child into the parent.
	     * @param {Number} i Number generated by the spring.
	     * @returns {React.Component} Rendered react element.
	     * @private
	     */
	
	  }, {
	    key: '_renderChildren',
	    value: function _renderChildren(_ref) {
	      var i = _ref.i;
	      var children = this.props.children;
	
	      var interpolator = this._interpolator;
	      var child = _react2.default.Children.only(children);
	      var interpolatedProps = interpolator ? interpolator(i) : interpolator;
	
	      // interpolator doesnt play nice with deeply nested objected
	      // so we expose an additional prop for situations like these, soit _data,
	      // which stores the full tree and can be recombined with the sanitized version
	      // after interpolation
	      var data = interpolatedProps && interpolatedProps.data || null;
	      if (data && child.props._data) {
	        data = data.map(function (row, index) {
	          var correspondingCell = child.props._data[index];
	          return _extends({}, row, { parent: correspondingCell.parent, children: correspondingCell.children });
	        });
	      }
	
	      return _react2.default.cloneElement(child, _extends({}, child.props, interpolatedProps, {
	        data: data || child.props.data || null,
	        // enforce re-rendering
	        _animation: Math.random()
	      }));
	    }
	  }, {
	    key: '_motionEndHandler',
	    value: function _motionEndHandler() {
	      if (this.props.onEnd) {
	        this.props.onEnd();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animationStyle = getAnimationStyle(this.props.animation);
	      var defaultStyle = { i: 0 };
	      var style = { i: (0, _reactMotion.spring)(1, animationStyle) };
	      // In order to make Motion re-run animations each time, the random key is
	      // always passed.
	      // TODO: find a better solution for the spring.
	      var key = Math.random();
	      return _react2.default.createElement(
	        _reactMotion.Motion,
	        _extends({ defaultStyle: defaultStyle, style: style, key: key }, { onRest: this._motionEndHandler }),
	        this._renderChildren
	      );
	    }
	  }]);
	
	  return Animation;
	}(_react.PureComponent);
	
	Animation.propTypes = propTypes;
	Animation.displayName = 'Animation';
	
	exports.default = Animation;
	var AnimationPropType = exports.AnimationPropType = ANIMATION_PROPTYPES;

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLinearRegression = exports.findEntryInArray = exports.interpolateNumber = exports.hasDuplicate = exports.getAnyElementOfObject = exports.getPercentValue = exports.uniqueId = exports.isNumOrStr = exports.isNumber = exports.isPercent = exports.mathSign = undefined;
	
	var _get2 = __webpack_require__(153);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isNaN2 = __webpack_require__(319);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isNumber2 = __webpack_require__(462);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _isString2 = __webpack_require__(154);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mathSign = exports.mathSign = function mathSign(value) {
	  if (value === 0) {
	    return 0;
	  }
	  if (value > 0) {
	    return 1;
	  }
	
	  return -1;
	};
	
	var isPercent = exports.isPercent = function isPercent(value) {
	  return (0, _isString3.default)(value) && value.indexOf('%') === value.length - 1;
	};
	
	var isNumber = exports.isNumber = function isNumber(value) {
	  return (0, _isNumber3.default)(value) && !(0, _isNaN3.default)(value);
	};
	
	var isNumOrStr = exports.isNumOrStr = function isNumOrStr(value) {
	  return isNumber(value) || (0, _isString3.default)(value);
	};
	
	var idCounter = 0;
	var uniqueId = exports.uniqueId = function uniqueId(prefix) {
	  var id = ++idCounter;
	
	  return '' + (prefix || '') + id;
	};
	/**
	 * Get percent value of a total value
	 * @param {Number|String} percent A percent
	 * @param {Number} totalValue     Total value
	 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
	 * @param {Boolean} validate      If set to be true, the result will be validated
	 * @return {Number} value
	 */
	var getPercentValue = exports.getPercentValue = function getPercentValue(percent, totalValue) {
	  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!isNumber(percent) && !(0, _isString3.default)(percent)) {
	    return defaultValue;
	  }
	
	  var value = void 0;
	
	  if (isPercent(percent)) {
	    var index = percent.indexOf('%');
	    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
	  } else {
	    value = +percent;
	  }
	
	  if ((0, _isNaN3.default)(value)) {
	    value = defaultValue;
	  }
	
	  if (validate && value > totalValue) {
	    value = totalValue;
	  }
	
	  return value;
	};
	
	var getAnyElementOfObject = exports.getAnyElementOfObject = function getAnyElementOfObject(obj) {
	  if (!obj) {
	    return null;
	  }
	
	  var keys = Object.keys(obj);
	
	  if (keys && keys.length) {
	    return obj[keys[0]];
	  }
	
	  return null;
	};
	
	var hasDuplicate = exports.hasDuplicate = function hasDuplicate(ary) {
	  if (!(0, _isArray3.default)(ary)) {
	    return false;
	  }
	
	  var len = ary.length;
	  var cache = {};
	
	  for (var i = 0; i < len; i++) {
	    if (!cache[ary[i]]) {
	      cache[ary[i]] = true;
	    } else {
	      return true;
	    }
	  }
	
	  return false;
	};
	
	var interpolateNumber = exports.interpolateNumber = function interpolateNumber(numberA, numberB) {
	  if (isNumber(numberA) && isNumber(numberB)) {
	    return function (t) {
	      return numberA + t * (numberB - numberA);
	    };
	  }
	
	  return function () {
	    return numberB;
	  };
	};
	
	var findEntryInArray = exports.findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
	  if (!ary || !ary.length) {
	    return null;
	  }
	
	  return ary.find(function (entry) {
	    return entry && (0, _get3.default)(entry, specifiedKey) === specifiedValue;
	  });
	};
	
	/**
	 * The least square linear regression
	 * @param {Array} data The array of points
	 * @returns {Object} The domain of x, and the parameter of linear function
	 */
	var getLinearRegression = exports.getLinearRegression = function getLinearRegression(data) {
	  if (!data || !data.length) {
	    return null;
	  }
	
	  var len = data.length;
	  var xsum = 0;
	  var ysum = 0;
	  var xysum = 0;
	  var xxsum = 0;
	  var xmin = Infinity;
	  var xmax = -Infinity;
	
	  for (var i = 0; i < len; i++) {
	    xsum += data[i].cx;
	    ysum += data[i].cy;
	    xysum += data[i].cx * data[i].cy;
	    xxsum += data[i].cx * data[i].cx;
	    xmin = Math.min(xmin, data[i].cx);
	    xmax = Math.max(xmax, data[i].cx);
	  }
	
	  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
	
	  return {
	    xmin: xmin,
	    xmax: xmax,
	    a: a,
	    b: (ysum - a * xsum) / len
	  };
	};

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(2822);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(1271);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(2823);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(209);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _immutable = __webpack_require__(35);
	
	var _deepEqual = __webpack_require__(3095);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _keys = __webpack_require__(3096);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _setIn = __webpack_require__(3097);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _splice = __webpack_require__(3098);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(1358);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyList = (0, _immutable.List)();
	
	var structure = {
	  allowsArrayErrors: false,
	  empty: (0, _immutable.Map)(),
	  emptyList: emptyList,
	  getIn: function getIn(state, field) {
	    return _immutable.Iterable.isIterable(state) ? state.getIn((0, _toPath3.default)(field)) : (0, _getIn2.default)(state, field);
	  },
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: function deleteIn(state, field) {
	    return state.deleteIn((0, _toPath3.default)(field));
	  },
	  forEach: function forEach(items, callback) {
	    items.forEach(callback);
	  },
	  fromJS: function fromJS(jsValue) {
	    return (0, _immutable.fromJS)(jsValue, function (key, value) {
	      return _immutable.Iterable.isIndexed(value) ? value.toList() : value.toMap();
	    });
	  },
	  keys: _keys2.default,
	  size: function size(list) {
	    return list ? list.size : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return _immutable.Iterable.isIterable(value) ? value.toJS() : value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/* todo: I want this to actually be an array of Function | string but that causes errors */
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_StyleSheet", {
	  value: __webpack_require__(2).shape({
	    create: __webpack_require__(2).func.isRequired
	  })
	});
	
	/* eslint-disable no-undef */

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _affix = __webpack_require__(581);
	
	Object.defineProperty(exports, 'Affix', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_affix)['default'];
	    }
	});
	
	var _anchor = __webpack_require__(1432);
	
	Object.defineProperty(exports, 'Anchor', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_anchor)['default'];
	    }
	});
	
	var _autoComplete = __webpack_require__(1434);
	
	Object.defineProperty(exports, 'AutoComplete', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_autoComplete)['default'];
	    }
	});
	
	var _alert = __webpack_require__(1429);
	
	Object.defineProperty(exports, 'Alert', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_alert)['default'];
	    }
	});
	
	var _avatar = __webpack_require__(1435);
	
	Object.defineProperty(exports, 'Avatar', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_avatar)['default'];
	    }
	});
	
	var _backTop = __webpack_require__(1436);
	
	Object.defineProperty(exports, 'BackTop', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_backTop)['default'];
	    }
	});
	
	var _badge = __webpack_require__(1438);
	
	Object.defineProperty(exports, 'Badge', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_badge)['default'];
	    }
	});
	
	var _breadcrumb = __webpack_require__(1440);
	
	Object.defineProperty(exports, 'Breadcrumb', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_breadcrumb)['default'];
	    }
	});
	
	var _button = __webpack_require__(142);
	
	Object.defineProperty(exports, 'Button', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_button)['default'];
	    }
	});
	
	var _calendar = __webpack_require__(1444);
	
	Object.defineProperty(exports, 'Calendar', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_calendar)['default'];
	    }
	});
	
	var _card = __webpack_require__(1450);
	
	Object.defineProperty(exports, 'Card', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_card)['default'];
	    }
	});
	
	var _collapse = __webpack_require__(1457);
	
	Object.defineProperty(exports, 'Collapse', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_collapse)['default'];
	    }
	});
	
	var _carousel = __webpack_require__(1451);
	
	Object.defineProperty(exports, 'Carousel', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_carousel)['default'];
	    }
	});
	
	var _cascader = __webpack_require__(1452);
	
	Object.defineProperty(exports, 'Cascader', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_cascader)['default'];
	    }
	});
	
	var _checkbox = __webpack_require__(169);
	
	Object.defineProperty(exports, 'Checkbox', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_checkbox)['default'];
	    }
	});
	
	var _col = __webpack_require__(1454);
	
	Object.defineProperty(exports, 'Col', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_col)['default'];
	    }
	});
	
	var _datePicker = __webpack_require__(1461);
	
	Object.defineProperty(exports, 'DatePicker', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_datePicker)['default'];
	    }
	});
	
	var _divider = __webpack_require__(1463);
	
	Object.defineProperty(exports, 'Divider', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_divider)['default'];
	    }
	});
	
	var _dropdown = __webpack_require__(382);
	
	Object.defineProperty(exports, 'Dropdown', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_dropdown)['default'];
	    }
	});
	
	var _form = __webpack_require__(1467);
	
	Object.defineProperty(exports, 'Form', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_form)['default'];
	    }
	});
	
	var _icon = __webpack_require__(33);
	
	Object.defineProperty(exports, 'Icon', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_icon)['default'];
	    }
	});
	
	var _input = __webpack_require__(271);
	
	Object.defineProperty(exports, 'Input', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_input)['default'];
	    }
	});
	
	var _inputNumber = __webpack_require__(1468);
	
	Object.defineProperty(exports, 'InputNumber', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_inputNumber)['default'];
	    }
	});
	
	var _layout = __webpack_require__(1474);
	
	Object.defineProperty(exports, 'Layout', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_layout)['default'];
	    }
	});
	
	var _list = __webpack_require__(1477);
	
	Object.defineProperty(exports, 'List', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_list)['default'];
	    }
	});
	
	var _localeProvider = __webpack_require__(1480);
	
	Object.defineProperty(exports, 'LocaleProvider', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_localeProvider)['default'];
	    }
	});
	
	var _message = __webpack_require__(1485);
	
	Object.defineProperty(exports, 'message', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_message)['default'];
	    }
	});
	
	var _menu = __webpack_require__(595);
	
	Object.defineProperty(exports, 'Menu', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_menu)['default'];
	    }
	});
	
	var _modal = __webpack_require__(1488);
	
	Object.defineProperty(exports, 'Modal', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_modal)['default'];
	    }
	});
	
	var _notification = __webpack_require__(1489);
	
	Object.defineProperty(exports, 'notification', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_notification)['default'];
	    }
	});
	
	var _pagination = __webpack_require__(384);
	
	Object.defineProperty(exports, 'Pagination', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_pagination)['default'];
	    }
	});
	
	var _popconfirm = __webpack_require__(1492);
	
	Object.defineProperty(exports, 'Popconfirm', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_popconfirm)['default'];
	    }
	});
	
	var _popover = __webpack_require__(1493);
	
	Object.defineProperty(exports, 'Popover', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_popover)['default'];
	    }
	});
	
	var _progress = __webpack_require__(597);
	
	Object.defineProperty(exports, 'Progress', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_progress)['default'];
	    }
	});
	
	var _radio = __webpack_require__(272);
	
	Object.defineProperty(exports, 'Radio', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_radio)['default'];
	    }
	});
	
	var _rate = __webpack_require__(1497);
	
	Object.defineProperty(exports, 'Rate', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_rate)['default'];
	    }
	});
	
	var _row = __webpack_require__(1498);
	
	Object.defineProperty(exports, 'Row', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_row)['default'];
	    }
	});
	
	var _select = __webpack_require__(211);
	
	Object.defineProperty(exports, 'Select', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_select)['default'];
	    }
	});
	
	var _slider = __webpack_require__(1499);
	
	Object.defineProperty(exports, 'Slider', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_slider)['default'];
	    }
	});
	
	var _spin = __webpack_require__(386);
	
	Object.defineProperty(exports, 'Spin', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_spin)['default'];
	    }
	});
	
	var _steps = __webpack_require__(1500);
	
	Object.defineProperty(exports, 'Steps', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_steps)['default'];
	    }
	});
	
	var _switch = __webpack_require__(1501);
	
	Object.defineProperty(exports, 'Switch', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_switch)['default'];
	    }
	});
	
	var _table = __webpack_require__(1511);
	
	Object.defineProperty(exports, 'Table', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_table)['default'];
	    }
	});
	
	var _transfer = __webpack_require__(1519);
	
	Object.defineProperty(exports, 'Transfer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_transfer)['default'];
	    }
	});
	
	var _tree = __webpack_require__(1524);
	
	Object.defineProperty(exports, 'Tree', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_tree)['default'];
	    }
	});
	
	var _treeSelect = __webpack_require__(1523);
	
	Object.defineProperty(exports, 'TreeSelect', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_treeSelect)['default'];
	    }
	});
	
	var _tabs = __webpack_require__(598);
	
	Object.defineProperty(exports, 'Tabs', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_tabs)['default'];
	    }
	});
	
	var _tag = __webpack_require__(1514);
	
	Object.defineProperty(exports, 'Tag', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_tag)['default'];
	    }
	});
	
	var _timePicker = __webpack_require__(599);
	
	Object.defineProperty(exports, 'TimePicker', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_timePicker)['default'];
	    }
	});
	
	var _timeline = __webpack_require__(1517);
	
	Object.defineProperty(exports, 'Timeline', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_timeline)['default'];
	    }
	});
	
	var _tooltip = __webpack_require__(170);
	
	Object.defineProperty(exports, 'Tooltip', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_tooltip)['default'];
	    }
	});
	
	var _mention = __webpack_require__(1482);
	
	Object.defineProperty(exports, 'Mention', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_mention)['default'];
	    }
	});
	
	var _upload = __webpack_require__(1527);
	
	Object.defineProperty(exports, 'Upload', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_upload)['default'];
	    }
	});
	
	var _version = __webpack_require__(1529);
	
	Object.defineProperty(exports, 'version', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_version)['default'];
	    }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* @remove-on-es-build-begin */
	// this file is not used if use https://github.com/ant-design/babel-plugin-import
	var ENV = ("production");
	if (ENV !== 'production' && ENV !== 'test' && typeof console !== 'undefined' && console.warn && typeof window !== 'undefined') {
	    console.warn('You are using a whole package of antd, ' + 'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.');
	}
	/* @remove-on-es-build-end */

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warning = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var formatRegExp = /%[sdj%]/g;
	
	var warning = exports.warning = function warning() {};
	
	// don't print warning message when in production env or node runtime
	if (false) {
	  exports.warning = warning = function warning(type, errors) {
	    if (typeof console !== 'undefined' && console.warn) {
	      if (errors.every(function (e) {
	        return typeof e === 'string';
	      })) {
	        console.warn(type, errors);
	      }
	    }
	  };
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var next = function next(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === objArrLength) {
	      callback(results);
	    }
	  };
	  objArrKeys.forEach(function (key) {
	    var arr = objArr[key];
	    if (firstFields.indexOf(key) !== -1) {
	      asyncSerialArray(arr, func, next);
	    } else {
	      asyncParallelArray(arr, func, next);
	    }
	  });
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && (0, _typeof3['default'])(target[s]) === 'object') {
	          target[s] = (0, _extends3['default'])({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = get;
	
	var _lodash = __webpack_require__(974);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _endsWith = __webpack_require__(506);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function get(object, path, defaultValue) {
	  var modelString = path;
	
	  if (typeof path === 'number') {
	    var result = object[path];
	
	    return result === undefined ? defaultValue : result;
	  }
	
	  if (!path.length) return object;
	
	  if ((0, _endsWith2.default)(modelString, '.')) {
	    modelString = modelString.slice(0, -1);
	  } else if ((0, _endsWith2.default)(modelString, '[]')) {
	    modelString = modelString.slice(0, -2);
	  }
	
	  return (0, _lodash2.default)(object, modelString, defaultValue);
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Layer
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	function Layer(props) {
	  var children = props.children,
	      className = props.className,
	      others = _objectWithoutProperties(props, ['children', 'className']);
	
	  var layerClass = (0, _classnames2.default)('recharts-layer', className);
	
	  return _react2.default.createElement(
	    'g',
	    _extends({ className: layerClass }, others),
	    children
	  );
	}
	
	Layer.propTypes = propTypes;
	
	exports.default = Layer;

/***/ },
/* 47 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (f) {
	    return f != null;
	  }).reduce(function (acc, f) {
	    if (typeof f !== 'function') {
	      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
	    }
	
	    if (acc === null) {
	      return f;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      f.apply(this, args);
	    };
	  }, null);
	}
	
	exports.default = createChainedFunction;
	module.exports = exports['default'];

/***/ },
/* 48 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DISCRETE_COLOR_RANGE = exports.DISCRETE_COLOR_RANGE = ['#12939A', '#79C7E3', '#1A3177', '#FF9833', '#EF5D28'];
	
	var EXTENDED_DISCRETE_COLOR_RANGE = exports.EXTENDED_DISCRETE_COLOR_RANGE = ['#19CDD7', '#DDB27C', '#88572C', '#FF991F', '#F15C17', '#223F9A', '#DA70BF', '#125C77', '#4DC19C', '#776E57', '#12939A', '#17B8BE', '#F6D18A', '#B7885E', '#FFCB99', '#F89570', '#829AE3', '#E79FD5', '#1E96BE', '#89DAC1', '#B3AD9E'];
	
	var CONTINUOUS_COLOR_RANGE = exports.CONTINUOUS_COLOR_RANGE = ['#EF5D28', '#FF9833'];
	
	var SIZE_RANGE = exports.SIZE_RANGE = [1, 10];
	
	var OPACITY_RANGE = exports.OPACITY_RANGE = [0.1, 1];
	var OPACITY_TYPE = exports.OPACITY_TYPE = 'literal';
	var DEFAULT_OPACITY = exports.DEFAULT_OPACITY = 1;
	
	var DEFAULT_SIZE = exports.DEFAULT_SIZE = 5;
	
	var DEFAULT_COLOR = exports.DEFAULT_COLOR = DISCRETE_COLOR_RANGE[0];
	
	var DEFAULT_TICK_SIZE = exports.DEFAULT_TICK_SIZE = 7;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ANIMATED_SERIES_PROPS = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.isSeriesChild = isSeriesChild;
	exports.getSeriesChildren = getSeriesChildren;
	exports.getStackedData = getStackedData;
	exports.getSeriesPropsFromChildren = getSeriesPropsFromChildren;
	exports.getRadialDomain = getRadialDomain;
	exports.getStackParams = getStackParams;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Check if the component is series or not.
	 * @param {React.Component} child Component.
	 * @returns {boolean} True if the child is series, false otherwise.
	 */
	function isSeriesChild(child) {
	  var prototype = child.type.prototype;
	
	  return prototype instanceof _abstractSeries2.default;
	}
	
	/**
	 * Get all series from the 'children' object of the component.
	 * @param {Object} children Children.
	 * @returns {Array} Array of children.
	 */
	function getSeriesChildren(children) {
	  return _react2.default.Children.toArray(children).filter(function (child) {
	    return child && isSeriesChild(child);
	  });
	}
	
	/**
	 * Collect the map of repetitions of the series type for all children.
	 * @param {Array} children Array of children.
	 * @returns {{}} Map of repetitions where sameTypeTotal is the total amount and
	 * sameTypeIndex is always 0.
	 */
	function collectSeriesTypesInfo(children) {
	  var result = {};
	  children.filter(isSeriesChild).forEach(function (child) {
	    var displayName = child.type.displayName;
	    var cluster = child.props.cluster;
	
	    if (!result[displayName]) {
	      result[displayName] = {
	        sameTypeTotal: 0,
	        sameTypeIndex: 0,
	        clusters: new Set()
	      };
	    }
	    result[displayName].clusters.add(cluster);
	    result[displayName].sameTypeTotal++;
	  });
	  return result;
	}
	
	/**
	 * Check series to see if it has angular data that needs to be converted
	 * @param {Array} data - an array of objects to check
	 * @returns {Boolean} whether or not this series contains polar configuration
	 */
	function seriesHasAngleRadius() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  if (!data) {
	    return false;
	  }
	  return data.some(function (row) {
	    return row.radius && row.angle;
	  });
	}
	
	/**
	 * Possibly convert polar coordinates to x/y for computing domain
	 * @param {Array} data - an array of objects to check
	 * @param {String} attr - the property being checked
	 * @returns {Boolean} whether or not this series contains polar configuration
	 */
	function prepareData(data) {
	  if (!seriesHasAngleRadius(data)) {
	    return data;
	  }
	
	  return data.map(function (row) {
	    return _extends({}, row, {
	      x: row.radius * Math.cos(row.angle),
	      y: row.radius * Math.sin(row.angle)
	    });
	  });
	}
	
	/**
	 * Collect the stacked data for all children in use. If the children don't have
	 * the data (e.g. the child is invalid series or something else), then the child
	 * is skipped.
	 * Each next value of attr is equal to the previous value plus the difference
	 * between attr0 and attr.
	 * @param {Array} children Array of children.
	 * @param {string} attr Attribute to stack by.
	 * @returns {Array} New array of children for the series.
	 */
	function getStackedData(children, attr) {
	  // It stores the last segment position added to each bar, separated by cluster.
	  var latestAttrPositions = {};
	
	  return children.reduce(function (accumulator, series, seriesIndex) {
	    // Skip the children that are not series (e.g. don't have any data).
	    if (!series) {
	      accumulator.push(null);
	      return accumulator;
	    }
	
	    var _series$props = series.props,
	        data = _series$props.data,
	        _series$props$cluster = _series$props.cluster,
	        cluster = _series$props$cluster === undefined ? 'default' : _series$props$cluster;
	
	    var preppedData = prepareData(data, attr);
	
	    if (!attr || !preppedData || !preppedData.length) {
	      accumulator.push(preppedData);
	      return accumulator;
	    }
	
	    var attr0 = attr + '0';
	    var baseAttr = attr === 'y' ? 'x' : 'y';
	
	    accumulator.push(preppedData.map(function (d, dIndex) {
	      var _extends2, _latestAttrPositions$2;
	
	      if (!latestAttrPositions[cluster]) {
	        latestAttrPositions[cluster] = {};
	      }
	
	      var prevD = latestAttrPositions[cluster][d[baseAttr]];
	      // It is the first segment of a bar.
	      if (!prevD) {
	        var _latestAttrPositions$;
	
	        latestAttrPositions[cluster][d[baseAttr]] = (_latestAttrPositions$ = {}, _defineProperty(_latestAttrPositions$, attr0, d[attr0]), _defineProperty(_latestAttrPositions$, attr, d[attr]), _latestAttrPositions$);
	
	        return _extends({}, d);
	      }
	
	      // Calculate the position of the next segment in a bar.
	      var nextD = _extends({}, d, (_extends2 = {}, _defineProperty(_extends2, attr0, prevD[attr]), _defineProperty(_extends2, attr, prevD[attr] + d[attr] - (d[attr0] || 0)), _extends2));
	
	      latestAttrPositions[cluster][d[baseAttr]] = (_latestAttrPositions$2 = {}, _defineProperty(_latestAttrPositions$2, attr0, nextD[attr0]), _defineProperty(_latestAttrPositions$2, attr, nextD[attr]), _latestAttrPositions$2);
	
	      return nextD;
	    }));
	
	    return accumulator;
	  }, []);
	}
	
	/**
	 * Get the list of series props for a child.
	 * @param {Array} children Array of all children.
	 * @returns {Array} Array of series props for each child. If a child is not a
	 * series, than it's undefined.
	 */
	function getSeriesPropsFromChildren(children) {
	  var result = [];
	  var seriesTypesInfo = collectSeriesTypesInfo(children);
	  var seriesIndex = 0;
	  var _opacityValue = _theme.DEFAULT_OPACITY;
	  children.forEach(function (child) {
	    var props = void 0;
	    if (isSeriesChild(child)) {
	      var seriesTypeInfo = seriesTypesInfo[child.type.displayName];
	      var _colorValue = _theme.DISCRETE_COLOR_RANGE[seriesIndex % _theme.DISCRETE_COLOR_RANGE.length];
	      props = _extends({}, seriesTypeInfo, {
	        seriesIndex: seriesIndex,
	        ref: 'series' + seriesIndex,
	        _colorValue: _colorValue,
	        _opacityValue: _opacityValue
	      });
	      seriesTypeInfo.sameTypeIndex++;
	      seriesIndex++;
	      if (child.props.cluster) {
	        props.cluster = child.props.cluster;
	        // Using Array.from() so we can use .indexOf
	        props.clusters = Array.from(seriesTypeInfo.clusters);
	        props.sameTypeTotal = props.clusters.length;
	        props.sameTypeIndex = props.clusters.indexOf(child.props.cluster);
	      }
	    }
	    result.push(props);
	  });
	  return result;
	}
	
	/**
	 * Find the max radius value from the nodes to be rendered after they have been
	 * transformed into an array
	 * @param {Array} data - the tree data after it has been broken into a iterable
	 * it is an array of objects!
	 * @returns {number} the maximum value in coordinates for the radial variable
	 */
	function getRadialDomain(data) {
	  return data.reduce(function (res, row) {
	    return Math.max(row.radius, res);
	  }, 0);
	}
	
	var ANIMATED_SERIES_PROPS = exports.ANIMATED_SERIES_PROPS = ['xRange', 'xDomain', 'x', 'yRange', 'yDomain', 'y', 'colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'strokeRange', 'strokeDomain', 'stroke', 'fillRange', 'fillDomain', 'fill', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'data', 'angleDomain', 'angleRange', 'angle', 'radiusDomain', 'radiusRange', 'radius', 'innerRadiusDomain', 'innerRadiusRange', 'innerRadius'];
	
	function getStackParams(props) {
	  var _stackBy = props._stackBy,
	      valuePosAttr = props.valuePosAttr,
	      cluster = props.cluster;
	  var _props$sameTypeTotal = props.sameTypeTotal,
	      sameTypeTotal = _props$sameTypeTotal === undefined ? 1 : _props$sameTypeTotal,
	      _props$sameTypeIndex = props.sameTypeIndex,
	      sameTypeIndex = _props$sameTypeIndex === undefined ? 0 : _props$sameTypeIndex;
	
	  // If bars are stacked, but not clustering, override `sameTypeTotal` and
	  // `sameTypeIndex` such that bars are stacked and not staggered.
	
	  if (_stackBy === valuePosAttr && !cluster) {
	    sameTypeTotal = 1;
	    sameTypeIndex = 0;
	  }
	  return { sameTypeTotal: sameTypeTotal, sameTypeIndex: sameTypeIndex };
	}

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(1425) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1585);

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1758);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1757);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ChildrenUtils = __webpack_require__(2490);
	
	var _AnimateChild = __webpack_require__(2489);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _util = __webpack_require__(1147);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                return _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else {
	      if (type === 'appear') {
	        if (_util2['default'].allowAppearCallback(props)) {
	          props.onAppear(key);
	          props.onEnd(key, true);
	        }
	      } else {
	        if (_util2['default'].allowEnterCallback(props)) {
	          props.onEnter(key);
	          props.onEnd(key, true);
	        }
	      }
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_util2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = Animate;
	module.exports = exports['default'];

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.isObjectLike = isObjectLike;
	exports.default = isPlainObject;
	// Adapted from https://github.com/jonschlinkert/is-plain-object
	function isObjectLike(val) {
	  return val != null && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object';
	}
	
	function isObject(val) {
	  return isObjectLike(val) && Array.isArray(val) === false;
	}
	
	function isObjectObject(o) {
	  return isObject(o) === true && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	function isPlainObject(o) {
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  var ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  var prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(539);
	var core = __webpack_require__(537);
	var hide = __webpack_require__(1337);
	var redefine = __webpack_require__(3004);
	var ctx = __webpack_require__(2997);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1400);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(3234);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(3233);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(3232);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1399);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1401);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defineProperties = __webpack_require__(224);
	
	var implementation = __webpack_require__(1134);
	var getPolyfill = __webpack_require__(1135);
	var shim = __webpack_require__(2465);
	
	var polyfill = getPolyfill();
	
	defineProperties(polyfill, {
		implementation: implementation,
		getPolyfill: getPolyfill,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function omit(obj, fields) {
	  var shallowCopy = (0, _extends3["default"])({}, obj);
	  for (var i = 0; i < fields.length; i++) {
	    var key = fields[i];
	    delete shallowCopy[key];
	  }
	  return shallowCopy;
	}
	
	exports["default"] = omit;
	module.exports = exports['default'];

/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var Size = exports.Size = {
	  LARGE: 'large',
	  SMALL: 'small',
	  XSMALL: 'xsmall'
	};
	
	var SIZE_MAP = exports.SIZE_MAP = {
	  large: 'lg',
	  medium: 'md',
	  small: 'sm',
	  xsmall: 'xs',
	  lg: 'lg',
	  md: 'md',
	  sm: 'sm',
	  xs: 'xs'
	};
	
	var DEVICE_SIZES = exports.DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
	
	var State = exports.State = {
	  SUCCESS: 'success',
	  WARNING: 'warning',
	  DANGER: 'danger',
	  INFO: 'info'
	};
	
	var Style = exports.Style = {
	  DEFAULT: 'default',
	  PRIMARY: 'primary',
	  LINK: 'link',
	  INVERSE: 'inverse'
	};

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _SCALE_FUNCTIONS;
	
	exports._getSmallestDistanceIndex = _getSmallestDistanceIndex;
	exports.getScaleFnFromScaleObject = getScaleFnFromScaleObject;
	exports.getDomainByAccessor = getDomainByAccessor;
	exports._getScaleDistanceAndAdjustedDomain = _getScaleDistanceAndAdjustedDomain;
	exports._adjustCategoricalScale = _adjustCategoricalScale;
	exports.getScaleObjectFromProps = getScaleObjectFromProps;
	exports.getAttributeScale = getAttributeScale;
	exports.getAttributeFunctor = getAttributeFunctor;
	exports.getAttr0Functor = getAttr0Functor;
	exports.getAttributeValue = getAttributeValue;
	exports.getScalePropTypesByAttribute = getScalePropTypesByAttribute;
	exports.extractScalePropsFromProps = extractScalePropsFromProps;
	exports.getMissingScaleProps = getMissingScaleProps;
	exports.literalScale = literalScale;
	exports.getFontColorFromBackground = getFontColorFromBackground;
	exports.getXYPlotValues = getXYPlotValues;
	exports.getOptionalScaleProps = getOptionalScaleProps;
	
	var _d3Scale = __webpack_require__(180);
	
	var _d3Array = __webpack_require__(147);
	
	var _d3Collection = __webpack_require__(290);
	
	var _d3Color = __webpack_require__(122);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactUtils = __webpack_require__(203);
	
	var _dataUtils = __webpack_require__(2953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Linear scale name.
	 * @type {string}
	 * @const
	 */
	var LINEAR_SCALE_TYPE = 'linear';
	
	/**
	 * Ordinal scale name.
	 * @type {string}
	 * @const
	 */
	var ORDINAL_SCALE_TYPE = 'ordinal';
	
	/**
	 * Category scale.
	 * @type {string}
	 * @const
	 */
	var CATEGORY_SCALE_TYPE = 'category';
	
	/**
	 * Literal scale.
	 * Differs slightly from d3's identity scale in that it does not coerce value
	 * into numbers, it simply returns exactly what you give it
	 * @type {string}
	 * @const
	 */
	var LITERAL_SCALE_TYPE = 'literal';
	
	/**
	 * Log scale name.
	 * @type {string}
	 * @const
	 */
	var LOG_SCALE_TYPE = 'log';
	
	/**
	 * Time scale name.
	 * @type {string}
	 * @const
	 */
	var TIME_SCALE_TYPE = 'time';
	
	/**
	 * Time UTC scale name.
	 * @type {string}
	 * @const
	 */
	var TIME_UTC_SCALE_TYPE = 'time-utc';
	
	/**
	 * Scale functions that are supported in the library.
	 * @type {Object}
	 * @const
	 */
	var SCALE_FUNCTIONS = (_SCALE_FUNCTIONS = {}, _defineProperty(_SCALE_FUNCTIONS, LINEAR_SCALE_TYPE, _d3Scale.scaleLinear), _defineProperty(_SCALE_FUNCTIONS, ORDINAL_SCALE_TYPE, _d3Scale.scalePoint), _defineProperty(_SCALE_FUNCTIONS, CATEGORY_SCALE_TYPE, _d3Scale.scaleOrdinal), _defineProperty(_SCALE_FUNCTIONS, LITERAL_SCALE_TYPE, literalScale), _defineProperty(_SCALE_FUNCTIONS, LOG_SCALE_TYPE, _d3Scale.scaleLog), _defineProperty(_SCALE_FUNCTIONS, TIME_SCALE_TYPE, _d3Scale.scaleTime), _defineProperty(_SCALE_FUNCTIONS, TIME_UTC_SCALE_TYPE, _d3Scale.scaleUtc), _SCALE_FUNCTIONS);
	
	/**
	 * Attrs for which a scale can be set up at XYPlot level
	 * @type {Array}
	 * @const
	 */
	
	var XYPLOT_ATTR = ['color', 'fill', 'opacity', 'stroke'];
	
	/**
	 * Title case a given string
	 * @param {String} str Array of values.
	 * @returns {String} titlecased string
	 */
	function toTitleCase(str) {
	  return '' + str[0].toUpperCase() + str.slice(1);
	}
	
	/**
	 * Find the smallest distance between the values on a given scale and return
	 * the index of the element, where the smallest distance was found.
	 * It returns the first occurrence of i where
	 * `scale(value[i]) - scale(value[i - 1])` is minimal
	 * @param {Array} values Array of values.
	 * @param {Object} scaleObject Scale object.
	 * @returns {number} Index of an element where the smallest distance was found.
	 * @private
	 */
	function _getSmallestDistanceIndex(values, scaleObject) {
	  var scaleFn = getScaleFnFromScaleObject(scaleObject);
	  var result = 0;
	  if (scaleFn) {
	    var nextValue = void 0;
	    var currentValue = scaleFn(values[0]);
	    var distance = Infinity;
	    var nextDistance = void 0;
	
	    for (var i = 1; i < values.length; i++) {
	      nextValue = scaleFn(values[i]);
	      nextDistance = Math.abs(nextValue - currentValue);
	      if (nextDistance < distance) {
	        distance = nextDistance;
	        result = i;
	      }
	      currentValue = nextValue;
	    }
	  }
	  return result;
	}
	
	/**
	 * Crate a scale function from the scale object.
	 * @param {Object} scaleObject Scale object.
	 - scaleObject.domain {Array}
	 - scaleObject.range {Array}
	 - scaleObject.type {string}
	 - scaleObject.attr {string}
	 * @returns {*} Scale function.
	 * @private
	 */
	function getScaleFnFromScaleObject(scaleObject) {
	  if (!scaleObject) {
	    return null;
	  }
	  var type = scaleObject.type,
	      domain = scaleObject.domain,
	      range = scaleObject.range;
	
	  var modDomain = domain[0] === domain[1] ? domain[0] === 0 ? [-1, 0] : [-domain[0], domain[0]] : domain;
	  if (type === LITERAL_SCALE_TYPE) {
	    return literalScale(range[0]);
	  }
	  var scale = SCALE_FUNCTIONS[type]().domain(modDomain).range(range);
	  if (type === ORDINAL_SCALE_TYPE) {
	    scale.padding(0.5);
	  }
	  return scale;
	}
	
	/**
	 * Get the domain from the array of data.
	 * @param {Array} allData All data.
	 * @param {function} accessor - accessor for main value.
	 * @param {function} accessor0 - accessor for the naught value.
	 * @param {string} type Scale type.
	 * @returns {Array} Domain.
	 * @private
	 */
	function getDomainByAccessor(allData, accessor, accessor0, type) {
	  var domain = void 0;
	
	  // Collect both attr and available attr0 values from the array of data.
	  var values = allData.reduce(function (data, d) {
	    var value = accessor(d);
	    var value0 = accessor0(d);
	    if (_isDefined(value)) {
	      data.push(value);
	    }
	    if (_isDefined(value0)) {
	      data.push(value0);
	    }
	    return data;
	  }, []);
	
	  if (!values.length) {
	    return [];
	  }
	
	  // Create proper domain depending on the type of the scale.
	  if (type !== ORDINAL_SCALE_TYPE && type !== CATEGORY_SCALE_TYPE) {
	    domain = (0, _d3Array.extent)(values);
	  } else {
	    domain = (0, _d3Collection.set)(values).values();
	  }
	  return domain;
	}
	
	/**
	 * Create custom scale object from the value. When the scale is created from
	 * this object, it should return the same value all time.
	 * @param {string} attr Attribute.
	 * @param {*} value Value.
	 * @param {string} type - the type of scale being used
	 * @param {function} accessor - the accessor function
	 * @param {function} accessor0 - the accessor function for the potential naught value
	 * @returns {Object} Custom scale object.
	 * @private
	 */
	function _createScaleObjectForValue(attr, value, type, accessor, accessor0) {
	  if (type === LITERAL_SCALE_TYPE) {
	    return {
	      type: LITERAL_SCALE_TYPE,
	      domain: [],
	      range: [value],
	      distance: 0,
	      attr: attr,
	      baseValue: undefined,
	      isValue: true,
	      accessor: accessor
	    };
	  }
	  if (typeof value === 'undefined') {
	    return null;
	  }
	  return {
	    type: CATEGORY_SCALE_TYPE,
	    range: [value],
	    domain: [],
	    distance: 0,
	    attr: attr,
	    baseValue: undefined,
	    isValue: true,
	    accessor: accessor
	  };
	}
	
	/**
	 * Create a regular scale object for a further use from the existing parameters.
	 * @param {Array} domain - Domain.
	 * @param {Array} range - Range.
	 * @param {string} type - Type.
	 * @param {number} distance - Distance.
	 * @param {string} attr - Attribute.
	 * @param {number} baseValue - Base value.
	 * @param {function} accessor - Attribute accesor
	 * @param {function} accessor0 - Attribute accesor for potential naught value
	 * @returns {Object} Scale object.
	 * @private
	 */
	function _createScaleObjectForFunction(_ref) {
	  var domain = _ref.domain,
	      range = _ref.range,
	      type = _ref.type,
	      distance = _ref.distance,
	      attr = _ref.attr,
	      baseValue = _ref.baseValue,
	      accessor = _ref.accessor,
	      accessor0 = _ref.accessor0;
	
	  return {
	    domain: domain,
	    range: range,
	    type: type,
	    distance: distance,
	    attr: attr,
	    baseValue: baseValue,
	    isValue: false,
	    accessor: accessor,
	    accessor0: accessor0
	  };
	}
	
	/**
	 * Get scale object from props. E. g. object like {xRange, xDomain, xDistance,
	 * xType} is transformed into {range, domain, distance, type}.
	 * @param {Object} props Props.
	 * @param {string} attr Attribute.
	 * @returns {*} Null or an object with the scale.
	 * @private
	 */
	function _collectScaleObjectFromProps(props, attr) {
	  var value = props[attr],
	      fallbackValue = props['_' + attr + 'Value'],
	      range = props[attr + 'Range'],
	      _props$ = props[attr + 'Distance'],
	      distance = _props$ === undefined ? 0 : _props$,
	      baseValue = props[attr + 'BaseValue'],
	      _props$2 = props[attr + 'Type'],
	      type = _props$2 === undefined ? LINEAR_SCALE_TYPE : _props$2,
	      noFallBack = props[attr + 'NoFallBack'],
	      _props$3 = props['get' + toTitleCase(attr)],
	      accessor = _props$3 === undefined ? function (d) {
	    return d[attr];
	  } : _props$3,
	      _props$4 = props['get' + toTitleCase(attr) + '0'],
	      accessor0 = _props$4 === undefined ? function (d) {
	    return d[attr + '0'];
	  } : _props$4;
	  var domain = props[attr + 'Domain'];
	  // Return value-based scale if the value is assigned.
	
	  if (!noFallBack && typeof value !== 'undefined') {
	    return _createScaleObjectForValue(attr, value, props[attr + 'Type'], accessor, accessor0);
	  }
	  // Pick up the domain from the properties and create a new one if it's not
	  // available.
	  if (typeof baseValue !== 'undefined') {
	    domain = (0, _dataUtils.addValueToArray)(domain, baseValue);
	  }
	
	  // Make sure that the minimum necessary properties exist.
	  if (!range || !domain || !domain.length) {
	    // Try to use the fallback value if it is available.
	    return _createScaleObjectForValue(attr, fallbackValue, props[attr + 'Type'], accessor, accessor0);
	  }
	
	  return _createScaleObjectForFunction({
	    domain: domain,
	    range: range,
	    type: type,
	    distance: distance,
	    attr: attr,
	    baseValue: baseValue,
	    accessor: accessor,
	    accessor0: accessor0
	  });
	}
	
	/**
	 * Compute left domain adjustment for the given values.
	 * @param {Array} values Array of values.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeLeftDomainAdjustment(values) {
	  if (values.length > 1) {
	    return (values[1] - values[0]) / 2;
	  }
	  if (values.length === 1) {
	    return values[0] - 0.5;
	  }
	  return 0;
	}
	
	/**
	 * Compute right domain adjustment for the given values.
	 * @param {Array} values Array of values.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeRightDomainAdjustment(values) {
	  if (values.length > 1) {
	    return (values[values.length - 1] - values[values.length - 2]) / 2;
	  }
	  if (values.length === 1) {
	    return values[0] - 0.5;
	  }
	  return 0;
	}
	
	/**
	 * Compute distance for the given values.
	 * @param {Array} values Array of values.
	 * @param {Array} domain Domain.
	 * @param {number} bestDistIndex Index of a best distance found.
	 * @param {function} scaleFn Scale function.
	 * @returns {number} Domain adjustment.
	 * @private
	 */
	function _computeScaleDistance(values, domain, bestDistIndex, scaleFn) {
	  if (values.length > 1) {
	    // Avoid zero indexes.
	    var i = Math.max(bestDistIndex, 1);
	    return Math.abs(scaleFn(values[i]) - scaleFn(values[i - 1]));
	  }
	  if (values.length === 1) {
	    return Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
	  }
	  return 0;
	}
	
	/**
	 * Normilize array of values with a single value.
	 * @param {Array} arr Array of data.
	 * @param {Array} values Array of values.
	 * @param {string} attr Attribute.
	 * @param {string} type Type.
	 * @private
	 */
	function _normalizeValues(data, values, accessor0, type) {
	  if (type === TIME_SCALE_TYPE && values.length === 1) {
	    var attr0 = accessor0(data[0]);
	
	    return [attr0].concat(_toConsumableArray(values));
	  }
	
	  return values;
	}
	
	/**
	 * Get the distance, the smallest and the largest value of the domain.
	 * @param {Array} data Array of data for the single series.
	 * @param {Object} scaleObject Scale object.
	 * @returns {{domain0: number, domainN: number, distance: number}} Result.
	 * @private
	 */
	function _getScaleDistanceAndAdjustedDomain(data, scaleObject) {
	  var domain = scaleObject.domain,
	      type = scaleObject.type,
	      accessor = scaleObject.accessor,
	      accessor0 = scaleObject.accessor0;
	
	
	  var uniqueValues = (0, _dataUtils.getUniquePropertyValues)(data, accessor);
	
	  // Fix time scale if a data has only one value.
	  var values = _normalizeValues(data, uniqueValues, accessor0, type);
	  var index = _getSmallestDistanceIndex(values, scaleObject);
	
	  var adjustedDomain = [].concat(domain);
	
	  adjustedDomain[0] -= _computeLeftDomainAdjustment(values);
	  adjustedDomain[domain.length - 1] += _computeRightDomainAdjustment(values);
	  // Fix log scale if it's too small.
	  if (type === LOG_SCALE_TYPE && domain[0] <= 0) {
	    adjustedDomain[0] = Math.min(domain[1] / 10, 1);
	  }
	
	  var adjustedScaleFn = getScaleFnFromScaleObject(_extends({}, scaleObject, {
	    domain: adjustedDomain
	  }));
	
	  var distance = _computeScaleDistance(values, adjustedDomain, index, adjustedScaleFn);
	
	  return {
	    domain0: adjustedDomain[0],
	    domainN: adjustedDomain[adjustedDomain.length - 1],
	    distance: distance
	  };
	}
	
	/**
	 * Returns true if scale adjustments are possible for a given scale.
	 * @param {Object} props Props.
	 * @param {Object} scaleObject Scale object.
	 * @returns {boolean} True if scale adjustments possible.
	 * @private
	 */
	function _isScaleAdjustmentPossible(props, scaleObject) {
	  var attr = scaleObject.attr;
	  var _props$_adjustBy = props._adjustBy,
	      adjustBy = _props$_adjustBy === undefined ? [] : _props$_adjustBy,
	      _props$_adjustWhat = props._adjustWhat,
	      adjustWhat = _props$_adjustWhat === undefined ? [] : _props$_adjustWhat;
	
	  // The scale cannot be adjusted if there's no attributes to adjust, no
	  // suitable values
	
	  return adjustWhat.length && adjustBy.length && adjustBy.indexOf(attr) !== -1;
	}
	
	/**
	 * Adjust continuous scales (e.g. 'linear', 'log' and 'time') by adding the
	 * space from the left and right of them and by computing the best distance.
	 * @param {Object} props Props.
	 * @param {Object} scaleObject Scale object.
	 * @returns {*} Scale object with adjustments.
	 * @private
	 */
	function _adjustContinuousScale(props, scaleObject) {
	  var allSeriesData = props._allData,
	      _props$_adjustWhat2 = props._adjustWhat,
	      adjustWhat = _props$_adjustWhat2 === undefined ? [] : _props$_adjustWhat2;
	
	  // Assign the initial values.
	
	  var domainLength = scaleObject.domain.length;
	  var domain = scaleObject.domain;
	
	  var scaleDomain0 = domain[0];
	  var scaleDomainN = domain[domainLength - 1];
	  var scaleDistance = scaleObject.distance;
	
	  // Find the smallest left position of the domain, the largest right position
	  // of the domain and the best distance for them.
	  allSeriesData.forEach(function (data, index) {
	    if (adjustWhat.indexOf(index) === -1) {
	      return;
	    }
	    if (data && data.length) {
	      var _getScaleDistanceAndA = _getScaleDistanceAndAdjustedDomain(data, scaleObject),
	          domain0 = _getScaleDistanceAndA.domain0,
	          domainN = _getScaleDistanceAndA.domainN,
	          distance = _getScaleDistanceAndA.distance;
	
	      scaleDomain0 = Math.min(scaleDomain0, domain0);
	      scaleDomainN = Math.max(scaleDomainN, domainN);
	      scaleDistance = Math.max(scaleDistance, distance);
	    }
	  });
	
	  scaleObject.domain = [scaleDomain0].concat(_toConsumableArray(domain.slice(1, -1)), [scaleDomainN]);
	
	  scaleObject.distance = scaleDistance;
	
	  return scaleObject;
	}
	
	/**
	 * Get an adjusted scale. Suitable for 'category' and 'ordinal' scales.
	 * @param {Object} scaleObject Scale object.
	 * @returns {*} Scale object with adjustments.
	 * @private
	 */
	function _adjustCategoricalScale(scaleObject) {
	  var scaleFn = getScaleFnFromScaleObject(scaleObject);
	  var domain = scaleObject.domain,
	      range = scaleObject.range;
	
	  if (domain.length > 1) {
	    scaleObject.distance = Math.abs(scaleFn(domain[1]) - scaleFn(domain[0]));
	  } else {
	    scaleObject.distance = Math.abs(range[1] - range[0]);
	  }
	
	  return scaleObject;
	}
	
	/**
	 * Retrieve a scale object or a value from the properties passed.
	 * @param {Object} props Object of props.
	 * @param {string} attr Attribute.
	 * @returns {*} Scale object, value or null.
	 */
	function getScaleObjectFromProps(props, attr) {
	  // Create the initial scale object.
	  var scaleObject = _collectScaleObjectFromProps(props, attr);
	  if (!scaleObject) {
	    return null;
	  }
	
	  // Make sure if it's possible to add space to the scale object. If not,
	  // return the object immediately.
	  if (!_isScaleAdjustmentPossible(props, scaleObject)) {
	    return scaleObject;
	  }
	
	  var type = scaleObject.type;
	  // Depending on what type the scale is, apply different adjustments. Distances
	  // for the ordinal and category scales are even, equal domains cannot be
	  // adjusted.
	
	  if (type === ORDINAL_SCALE_TYPE || type === CATEGORY_SCALE_TYPE) {
	    return _adjustCategoricalScale(scaleObject);
	  }
	  return _adjustContinuousScale(props, scaleObject);
	}
	
	/**
	 * Get d3 scale for a given prop.
	 * @param {Object} props Props.
	 * @param {string} attr Attribute.
	 * @returns {function} d3 scale function.
	 */
	function getAttributeScale(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  return getScaleFnFromScaleObject(scaleObject);
	}
	
	/**
	 * Get the value of `attr` from the object.
	 * @param {Object} d - data Object.
	 * @param {Function} accessor - accessor function.
	 * @returns {*} Value of the point.
	 * @private
	 */
	function _getAttrValue(d, accessor) {
	  return accessor(d.data ? d.data : d);
	}
	
	function _isDefined(value) {
	  return typeof value !== 'undefined';
	}
	
	/*
	 * Adds a percentage of padding to a given domain
	 * @param {Array} domain X or Y domain to pad.
	 * @param {Number} padding Percentage of padding to add to domain
	 * @returns {Array} Padded Domain
	 */
	function _padDomain(domain, padding) {
	  if (!domain) {
	    return domain;
	  }
	  if (isNaN(parseFloat(domain[0])) || isNaN(parseFloat(domain[1]))) {
	    return domain;
	  }
	
	  var _domain = _slicedToArray(domain, 2),
	      min = _domain[0],
	      max = _domain[1];
	
	  var domainPadding = (max - min) * (padding * 0.01);
	  return [min - domainPadding, max + domainPadding];
	}
	
	/**
	 * Get prop functor (either a value or a function) for a given attribute.
	 * @param {Object} props Series props.
	 * @param {Function} accessor - Property accessor.
	 * @returns {*} Function or value.
	 */
	function getAttributeFunctor(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    var scaleFn = getScaleFnFromScaleObject(scaleObject);
	    return function (d) {
	      return scaleFn(_getAttrValue(d, scaleObject.accessor));
	    };
	  }
	  return null;
	}
	
	/**
	 * Get the functor which extracts value form [attr]0 property. Use baseValue if
	 * no attr0 property for a given object is defined. Fall back to domain[0] if no
	 * base value is available.
	 * @param {Object} props Object of props.
	 * @param {string} attr Attribute name.
	 * @returns {*} Function which returns value or null if no values available.
	 */
	function getAttr0Functor(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    var attr0 = attr + '0';
	    var domain = scaleObject.domain;
	    var _scaleObject$baseValu = scaleObject.baseValue,
	        baseValue = _scaleObject$baseValu === undefined ? domain[0] : _scaleObject$baseValu;
	
	    var scaleFn = getScaleFnFromScaleObject(scaleObject);
	    return function (d) {
	      var value = _getAttrValue(d, function (el) {
	        return el[attr0];
	      });
	      return scaleFn(_isDefined(value) ? value : baseValue);
	    };
	  }
	  return null;
	}
	
	/**
	 * Tries to get the string|number value of the attr and falls back to
	 * a fallback property in case if the value is a scale.
	 * @param {Object} props Series props.
	 * @param {string} attr Property name.
	 * @returns {*} Function or value.
	 */
	function getAttributeValue(props, attr) {
	  var scaleObject = getScaleObjectFromProps(props, attr);
	  if (scaleObject) {
	    if (!scaleObject.isValue && props['_' + attr + 'Value'] === undefined) {
	      (0, _reactUtils.warning)('[React-vis] Cannot use data defined ' + attr + ' for this ' + 'series type. Using fallback value instead.');
	    }
	    return props['_' + attr + 'Value'] || scaleObject.range[0];
	  }
	  return null;
	}
	
	/**
	 * Get prop types by the attribute.
	 * @param {string} attr Attribute.
	 * @returns {Object} Object of xDomain, xRange, xType, xDistance and _xValue,
	 * where x is an attribute passed to the function.
	 */
	function getScalePropTypesByAttribute(attr) {
	  var _ref2;
	
	  return _ref2 = {}, _defineProperty(_ref2, '_' + attr + 'Value', _propTypes2.default.any), _defineProperty(_ref2, attr + 'Domain', _propTypes2.default.array), _defineProperty(_ref2, 'get' + toTitleCase(attr), _propTypes2.default.func), _defineProperty(_ref2, 'get' + toTitleCase(attr) + '0', _propTypes2.default.func), _defineProperty(_ref2, attr + 'Range', _propTypes2.default.array), _defineProperty(_ref2, attr + 'Type', _propTypes2.default.oneOf(Object.keys(SCALE_FUNCTIONS))), _defineProperty(_ref2, attr + 'Distance', _propTypes2.default.number), _defineProperty(_ref2, attr + 'BaseValue', _propTypes2.default.any), _ref2;
	}
	
	/**
	 * Extract the list of scale properties from the entire props object.
	 * @param {Object} props Props.
	 * @param {Array<String>} attributes Array of attributes for the given
	 * components (for instance, `['x', 'y', 'color']`).
	 * @returns {Object} Collected props.
	 */
	function extractScalePropsFromProps(props, attributes) {
	  var result = {};
	  Object.keys(props).forEach(function (key) {
	    // this filtering is critical for extracting the correct accessors!
	    var attr = attributes.find(function (a) {
	      // width
	      var isPlainSet = key.indexOf(a) === 0;
	      // Ex: _data
	      var isUnderscoreSet = key.indexOf('_' + a) === 0;
	      // EX: getX
	      var usesGet = key.indexOf('get' + toTitleCase(a)) === 0;
	      return isPlainSet || isUnderscoreSet || usesGet;
	    });
	    if (!attr) {
	      return;
	    }
	    result[key] = props[key];
	  });
	  return result;
	}
	
	/**
	 * Extract the missing scale props from the given data and return them as
	 * an object.
	 * @param {Object} props Props.
	 * @param {Array} data Array of all data.
	 * @param {Array<String>} attributes Array of attributes for the given
	 * components (for instance, `['x', 'y', 'color']`).
	 * @returns {Object} Collected props.
	 */
	function getMissingScaleProps(props, data, attributes) {
	  var result = {};
	  // Make sure that the domain is set pad it if specified
	  attributes.forEach(function (attr) {
	    if (!props['get' + toTitleCase(attr)]) {
	      result['get' + toTitleCase(attr)] = function (d) {
	        return d[attr];
	      };
	    }
	    if (!props['get' + toTitleCase(attr) + '0']) {
	      result['get' + toTitleCase(attr) + '0'] = function (d) {
	        return d[attr + '0'];
	      };
	    }
	    if (!props[attr + 'Domain']) {
	      result[attr + 'Domain'] = getDomainByAccessor(data, props['get' + toTitleCase(attr)] || result['get' + toTitleCase(attr)], props['get' + toTitleCase(attr) + '0'] || result['get' + toTitleCase(attr) + '0'], props[attr + 'Type']);
	      if (props[attr + 'Padding']) {
	        result[attr + 'Domain'] = _padDomain(result[attr + 'Domain'], props[attr + 'Padding']);
	      }
	    }
	  });
	
	  return result;
	}
	
	/**
	 * Return a d3 scale that returns the literal value that was given to it
	 * @returns {function} literal scale.
	 */
	function literalScale(defaultValue) {
	  function scale(d) {
	    if (d === undefined) {
	      return defaultValue;
	    }
	    return d;
	  }
	
	  function response() {
	    return scale;
	  }
	
	  scale.domain = response;
	  scale.range = response;
	  scale.unknown = response;
	  scale.copy = response;
	
	  return scale;
	}
	
	function getFontColorFromBackground(background) {
	  if (background) {
	    return (0, _d3Color.hsl)(background).l > 0.57 ? '#222' : '#fff';
	  }
	  return null;
	}
	
	/**
	 * Creates fallback values for series from scales defined at XYPlot level.
	 * @param {Object} props Props of the XYPlot object.
	 * @param {Array<Object>} children Array of components, children of XYPlot
	 * @returns {Array<Object>} Collected props.
	 */
	
	function getXYPlotValues(props, children) {
	  var XYPlotScales = XYPLOT_ATTR.reduce(function (prev, attr) {
	    var domain = props[attr + 'Domain'],
	        range = props[attr + 'Range'],
	        type = props[attr + 'Type'];
	
	
	    if (domain && range && type) {
	      return _extends({}, prev, _defineProperty({}, attr, SCALE_FUNCTIONS[type]().domain(domain).range(range)));
	    }
	    return prev;
	  }, {});
	
	  return children.map(function (child) {
	    return XYPLOT_ATTR.reduce(function (prev, attr) {
	      if (child.props && child.props[attr] !== undefined) {
	        var scaleInput = child.props[attr];
	        var scale = XYPlotScales[attr];
	        var fallbackValue = scale ? scale(scaleInput) : scaleInput;
	        return _extends({}, prev, _defineProperty({}, '_' + attr + 'Value', fallbackValue));
	      }
	      return prev;
	    }, {});
	  });
	}
	
	var OPTIONAL_SCALE_PROPS = ['Padding'];
	var OPTIONAL_SCALE_PROPS_REGS = OPTIONAL_SCALE_PROPS.map(function (str) {
	  return new RegExp(str + '$', 'i');
	});
	/**
	 * Get the list of optional scale-related settings for XYPlot
	 * mostly just used to find padding properties
	 * @param {Object} props Object of props.
	 * @returns {Object} Optional Props.
	 * @private
	 */
	function getOptionalScaleProps(props) {
	  return Object.keys(props).reduce(function (acc, prop) {
	    var propIsNotOptional = OPTIONAL_SCALE_PROPS_REGS.every(function (reg) {
	      return !prop.match(reg);
	    });
	    if (propIsNotOptional) {
	      return acc;
	    }
	    acc[prop] = props[prop];
	    return acc;
	  }, {});
	}
	
	exports.default = {
	  extractScalePropsFromProps: extractScalePropsFromProps,
	  getAttributeScale: getAttributeScale,
	  getAttributeFunctor: getAttributeFunctor,
	  getAttr0Functor: getAttr0Functor,
	  getAttributeValue: getAttributeValue,
	  getDomainByAccessor: getDomainByAccessor,
	  getFontColorFromBackground: getFontColorFromBackground,
	  getMissingScaleProps: getMissingScaleProps,
	  getOptionalScaleProps: getOptionalScaleProps,
	  getScaleObjectFromProps: getScaleObjectFromProps,
	  getScalePropTypesByAttribute: getScalePropTypesByAttribute,
	  getXYPlotValues: getXYPlotValues,
	  literalScale: literalScale
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_URL =  false ? 'https://prdapi.gogochart.com/api' :  true ? 'https://devapi.gogochart.com/api' : 'http://localhost:3003/api';
	
	console.log(' env ', ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_STAGE":"fake"}));
	console.log(' payment : ', API_URL);
	exports.default = API_URL;

/***/ },
/* 62 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CalendarDayPhrases = exports.DayPickerNavigationPhrases = exports.DayPickerKeyboardShortcutsPhrases = exports.DayPickerPhrases = exports.SingleDatePickerInputPhrases = exports.SingleDatePickerPhrases = exports.DateRangePickerInputPhrases = exports.DateRangePickerPhrases = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var calendarLabel = 'Calendar';
	var closeDatePicker = 'Close';
	var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
	var clearDate = 'Clear Date';
	var clearDates = 'Clear Dates';
	var jumpToPrevMonth = 'Move backward to switch to the previous month.';
	var jumpToNextMonth = 'Move forward to switch to the next month.';
	var keyboardShortcuts = 'Keyboard Shortcuts';
	var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
	var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
	var openThisPanel = 'Open this panel.';
	var enterKey = 'Enter key';
	var leftArrowRightArrow = 'Right and left arrow keys';
	var upArrowDownArrow = 'up and down arrow keys';
	var pageUpPageDown = 'page up and page down keys';
	var homeEnd = 'Home and end keys';
	var escape = 'Escape key';
	var questionMark = 'Question mark';
	var selectFocusedDate = 'Select the date in focus.';
	var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
	var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
	var moveFocusByOneMonth = 'Switch months.';
	var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
	var returnFocusToInput = 'Return to the date input field.';
	var keyboardNavigationInstructions = 'Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';
	
	// eslint-disable-next-line camelcase
	var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
	  var date = _ref.date;
	  return 'Choose ' + String(date) + ' as your check-in date. It\'s available.';
	};
	
	// eslint-disable-next-line camelcase
	var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
	  var date = _ref2.date;
	  return 'Choose ' + String(date) + ' as your check-out date. It\'s available.';
	};
	var chooseAvailableDate = function chooseAvailableDate(_ref3) {
	  var date = _ref3.date;
	  return date;
	};
	var dateIsUnavailable = function dateIsUnavailable(_ref4) {
	  var date = _ref4.date;
	  return 'Not available. ' + String(date);
	};
	
	exports['default'] = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  focusStartDate: focusStartDate,
	  clearDate: clearDate,
	  clearDates: clearDates,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable
	};
	var DateRangePickerPhrases = exports.DateRangePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDates: clearDates,
	  focusStartDate: focusStartDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable
	};
	
	var DateRangePickerInputPhrases = exports.DateRangePickerInputPhrases = {
	  focusStartDate: focusStartDate,
	  clearDates: clearDates,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	
	var SingleDatePickerPhrases = exports.SingleDatePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDate: clearDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable
	};
	
	var SingleDatePickerInputPhrases = exports.SingleDatePickerInputPhrases = {
	  clearDate: clearDate,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	
	var DayPickerPhrases = exports.DayPickerPhrases = {
	  calendarLabel: calendarLabel,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable
	};
	
	var DayPickerKeyboardShortcutsPhrases = exports.DayPickerKeyboardShortcutsPhrases = {
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput
	};
	
	var DayPickerNavigationPhrases = exports.DayPickerNavigationPhrases = {
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth
	};
	
	var CalendarDayPhrases = exports.CalendarDayPhrases = {
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable
	};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _required = __webpack_require__(726);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _whitespace = __webpack_require__(1547);
	
	var _whitespace2 = _interopRequireDefault(_whitespace);
	
	var _type = __webpack_require__(1546);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _range = __webpack_require__(1545);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _enum = __webpack_require__(1543);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(1544);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  required: _required2['default'],
	  whitespace: _whitespace2['default'],
	  type: _type2['default'],
	  range: _range2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default']
	};
	module.exports = exports['default'];

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var ContentStateInlineStyle = __webpack_require__(1914);
	var DraftFeatureFlags = __webpack_require__(125);
	var Immutable = __webpack_require__(26);
	
	var applyEntityToContentState = __webpack_require__(1933);
	var getCharacterRemovalRange = __webpack_require__(1954);
	var getContentStateFragment = __webpack_require__(297);
	var insertFragmentIntoContentState = __webpack_require__(1959);
	var insertTextIntoContentState = __webpack_require__(1960);
	var invariant = __webpack_require__(18);
	var modifyBlockForContentState = __webpack_require__(1971);
	var removeEntitiesAtEdges = __webpack_require__(931);
	var removeRangeFromContentState = __webpack_require__(1973);
	var splitBlockInContentState = __webpack_require__(1975);
	
	var OrderedSet = Immutable.OrderedSet;
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    var startKey = void 0,
	        endKey = void 0,
	        startBlock = void 0,
	        endBlock = void 0;
	    if (rangeToRemove.getIsBackward()) {
	      rangeToRemove = rangeToRemove.merge({
	        anchorKey: rangeToRemove.getFocusKey(),
	        anchorOffset: rangeToRemove.getFocusOffset(),
	        focusKey: rangeToRemove.getAnchorKey(),
	        focusOffset: rangeToRemove.getAnchorOffset(),
	        isBackward: false
	      });
	    }
	    startKey = rangeToRemove.getAnchorKey();
	    endKey = rangeToRemove.getFocusKey();
	    startBlock = contentState.getBlockForKey(startKey);
	    endBlock = contentState.getBlockForKey(endKey);
	    var startOffset = rangeToRemove.getStartOffset();
	    var endOffset = rangeToRemove.getEndOffset();
	
	    var startEntityKey = startBlock.getEntityAt(startOffset);
	    var endEntityKey = endBlock.getEntityAt(endOffset - 1);
	
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (startKey === endKey) {
	      if (startEntityKey && startEntityKey === endEntityKey) {
	        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
	      }
	    }
	    var adjustedRemovalRange = rangeToRemove;
	    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
	      // Adjust the selection to properly delete segemented and immutable
	      // entities
	      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
	    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ type: blockType, depth: 0 });
	    });
	  },
	
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: blockData });
	    });
	  },
	
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: block.getData().merge(blockData) });
	    });
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ },
/* 67 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Iterates through children that are typically specified as `props.children`,
	 * but only maps over children that are "valid components".
	 *
	 * The mapFunction provided index will be normalised to the components mapped,
	 * so an invalid component would not increase the index.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @return {object} Object containing the ordered map of results.
	 */
	function map(children, func, context) {
	  var index = 0;
	
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    return func.call(context, child, index++);
	  });
	}
	
	/**
	 * Iterates through children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for context.
	 */
	// TODO: This module should be ElementChildren, and should use named exports.
	
	function forEach(children, func, context) {
	  var index = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    func.call(context, child, index++);
	  });
	}
	
	/**
	 * Count the number of "valid components" in the Children container.
	 *
	 * @param {?*} children Children tree container.
	 * @returns {number}
	 */
	function count(children) {
	  var result = 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    ++result;
	  });
	
	  return result;
	}
	
	/**
	 * Finds children that are typically specified as `props.children`,
	 * but only iterates over children that are "valid components".
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child with the index reflecting the position relative to "valid components".
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func.
	 * @param {*} context Context for func.
	 * @returns {array} of children that meet the func return statement
	 */
	function filter(children, func, context) {
	  var index = 0;
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result.push(child);
	    }
	  });
	
	  return result;
	}
	
	function find(children, func, context) {
	  var index = 0;
	  var result = void 0;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = child;
	    }
	  });
	
	  return result;
	}
	
	function every(children, func, context) {
	  var index = 0;
	  var result = true;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (!func.call(context, child, index++)) {
	      result = false;
	    }
	  });
	
	  return result;
	}
	
	function some(children, func, context) {
	  var index = 0;
	  var result = false;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (result) {
	      return;
	    }
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    if (func.call(context, child, index++)) {
	      result = true;
	    }
	  });
	
	  return result;
	}
	
	function toArray(children) {
	  var result = [];
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return;
	    }
	
	    result.push(child);
	  });
	
	  return result;
	}
	
	exports.default = {
	  map: map,
	  forEach: forEach,
	  count: count,
	  find: find,
	  filter: filter,
	  every: every,
	  some: some,
	  toArray: toArray
	};
	module.exports = exports['default'];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseDomainOfCategoryAxis = exports.getBandSizeOfAxis = exports.parseSpecifiedDomain = exports.MAX_VALUE_REG = exports.MIN_VALUE_REG = exports.getDomainOfStackGroups = exports.getStackedDataOfItem = exports.detectReferenceElementsDomain = exports.getBaseValueOfBar = exports.getCateCoordinateOfBar = exports.getCateCoordinateOfLine = exports.getTicksOfScale = exports.calculateDomainOfTicks = exports.getStackGroupsByAxisId = exports.getStackedData = exports.offsetSign = exports.truncateByDomain = exports.findPositionOfBar = exports.checkDomainOfScale = exports.parseScale = exports.combineEventHandlers = exports.getTicksOfAxis = exports.getCoordinatesOfGrid = exports.isCategorialAxis = exports.getDomainOfItemsWithSameAxis = exports.parseErrorBarsOfAxis = exports.getDomainOfErrorBars = exports.appendOffsetOfLegend = exports.getBarPosition = exports.getBarSizeList = exports.getLegendProps = exports.getMainColorOfGraphicItem = exports.calculateActiveTickIndex = exports.getDomainOfDataByKey = exports.getValueByDataKey = undefined;
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _sortBy2 = __webpack_require__(1010);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isNaN2 = __webpack_require__(319);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isString2 = __webpack_require__(154);
	
	var _isString3 = _interopRequireDefault(_isString2);
	
	var _max2 = __webpack_require__(2442);
	
	var _max3 = _interopRequireDefault(_max2);
	
	var _min2 = __webpack_require__(1007);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _flatMap2 = __webpack_require__(2431);
	
	var _flatMap3 = _interopRequireDefault(_flatMap2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _get2 = __webpack_require__(153);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _rechartsScale = __webpack_require__(2973);
	
	var _d3Scale = __webpack_require__(1339);
	
	var d3Scales = _interopRequireWildcard(_d3Scale);
	
	var _d3Shape = __webpack_require__(107);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReferenceDot = __webpack_require__(1330);
	
	var _ReferenceDot2 = _interopRequireDefault(_ReferenceDot);
	
	var _ReferenceLine = __webpack_require__(1331);
	
	var _ReferenceLine2 = _interopRequireDefault(_ReferenceLine);
	
	var _ReferenceArea = __webpack_require__(1329);
	
	var _ReferenceArea2 = _interopRequireDefault(_ReferenceArea);
	
	var _ErrorBar = __webpack_require__(257);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Legend = __webpack_require__(533);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var getValueByDataKey = exports.getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
	  if ((0, _isNil3.default)(obj) || (0, _isNil3.default)(dataKey)) {
	    return defaultValue;
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(dataKey)) {
	    return (0, _get3.default)(obj, dataKey, defaultValue);
	  }
	
	  if ((0, _isFunction3.default)(dataKey)) {
	    return dataKey(obj);
	  }
	
	  return defaultValue;
	};
	/**
	 * Get domain of data by key
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {String}  key       The unique key of a group of data
	 * @param  {String}  type      The type of axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array} Domain of data
	 */
	var getDomainOfDataByKey = exports.getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
	  var flattenData = (0, _flatMap3.default)(data, function (entry) {
	    return getValueByDataKey(entry, key);
	  });
	
	  if (type === 'number') {
	    var domain = flattenData.filter(_DataUtils.isNumber);
	
	    return [Math.min.apply(null, domain), Math.max.apply(null, domain)];
	  }
	
	  var validateData = filterNil ? flattenData.filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  }) : flattenData;
	
	  return validateData.map(function (entry) {
	    return (0, _DataUtils.isNumOrStr)(entry) ? entry : '';
	  });
	};
	
	var calculateActiveTickIndex = exports.calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
	  var index = -1;
	  var len = ticks.length;
	
	  if (len > 1) {
	    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
	      var range = axis.range;
	      // ticks are distributed in a circle
	
	      for (var i = 0; i < len; i++) {
	        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
	        var cur = unsortedTicks[i].coordinate;
	        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
	        var sameDirectionCoord = void 0;
	
	        if ((0, _DataUtils.mathSign)(cur - before) !== (0, _DataUtils.mathSign)(after - cur)) {
	          var diffInterval = [];
	          if ((0, _DataUtils.mathSign)(after - cur) === (0, _DataUtils.mathSign)(range[1] - range[0])) {
	            sameDirectionCoord = after;
	
	            var curInRange = cur + range[1] - range[0];
	            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
	            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
	          } else {
	            sameDirectionCoord = before;
	
	            var afterInRange = after + range[1] - range[0];
	            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
	            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
	          }
	          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];
	
	          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        } else {
	          var min = Math.min(before, after);
	          var max = Math.max(before, after);
	
	          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
	            index = unsortedTicks[i].index;
	            break;
	          }
	        }
	      }
	    } else {
	      // ticks are distributed in a single direction
	      for (var _i = 0; _i < len; _i++) {
	        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
	          index = ticks[_i].index;
	          break;
	        }
	      }
	    }
	  } else {
	    index = 0;
	  }
	
	  return index;
	};
	
	/**
	 * Get the main color of each graphic item
	 * @param  {ReactElement} item A graphic item
	 * @return {String}            Color
	 */
	var getMainColorOfGraphicItem = exports.getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
	  var displayName = item.type.displayName;
	  var result = void 0;
	
	  switch (displayName) {
	    case 'Line':
	    case 'Area':
	    case 'Radar':
	      result = item.props.stroke;
	      break;
	    default:
	      result = item.props.fill;
	      break;
	  }
	
	  return result;
	};
	
	var getLegendProps = exports.getLegendProps = function getLegendProps(_ref) {
	  var children = _ref.children,
	      formatedGraphicalItems = _ref.formatedGraphicalItems,
	      legendWidth = _ref.legendWidth,
	      legendContent = _ref.legendContent;
	
	  var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	  if (!legendItem) {
	    return null;
	  }
	
	  var legendData = void 0;
	  if (legendItem.props && legendItem.props.payload) {
	    legendData = legendItem.props && legendItem.props.payload;
	  } else if (legendContent === 'children') {
	    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
	      var item = _ref2.item,
	          props = _ref2.props;
	
	      var data = props.sectors || props.data || [];
	
	      return result.concat(data.map(function (entry) {
	        return {
	          type: legendItem.props.iconType || item.props.legendType,
	          value: entry.name,
	          color: entry.fill,
	          payload: entry
	        };
	      }));
	    }, []);
	  } else {
	    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
	      var item = _ref3.item;
	      var _item$props = item.props,
	          dataKey = _item$props.dataKey,
	          name = _item$props.name,
	          legendType = _item$props.legendType,
	          hide = _item$props.hide;
	
	
	      return {
	        inactive: hide,
	        dataKey: dataKey,
	        type: legendItem.props.iconType || legendType || 'square',
	        color: getMainColorOfGraphicItem(item),
	        value: name || dataKey,
	        payload: item.props
	      };
	    });
	  }
	
	  return _extends({}, legendItem.props, _Legend2.default.getWithHeight(legendItem, legendWidth), {
	    payload: legendData,
	    item: legendItem
	  });
	};
	/**
	 * Calculate the size of all groups for stacked bar graph
	 * @param  {Object} stackGroups The items grouped by axisId and stackId
	 * @return {Object} The size of all groups
	 */
	var getBarSizeList = exports.getBarSizeList = function getBarSizeList(_ref4) {
	  var globalSize = _ref4.barSize,
	      _ref4$stackGroups = _ref4.stackGroups,
	      stackGroups = _ref4$stackGroups === undefined ? {} : _ref4$stackGroups;
	
	  if (!stackGroups) {
	    return {};
	  }
	
	  var result = {};
	  var numericAxisIds = Object.keys(stackGroups);
	
	  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
	    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
	    var stackIds = Object.keys(sgs);
	
	    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
	      var _sgs$stackIds$j = sgs[stackIds[j]],
	          items = _sgs$stackIds$j.items,
	          cateAxisId = _sgs$stackIds$j.cateAxisId;
	
	
	      var barItems = items.filter(function (item) {
	        return (0, _ReactUtils.getDisplayName)(item.type).indexOf('Bar') >= 0;
	      });
	
	      if (barItems && barItems.length) {
	        var selfSize = barItems[0].props.barSize;
	
	        var cateId = barItems[0].props[cateAxisId];
	
	        if (!result[cateId]) {
	          result[cateId] = [];
	        }
	
	        result[cateId].push({
	          item: barItems[0],
	          stackList: barItems.slice(1),
	          barSize: (0, _isNil3.default)(selfSize) ? globalSize : selfSize
	        });
	      }
	    }
	  }
	
	  return result;
	};
	
	/**
	   * Calculate the size of each bar and the gap between two bars
	   * @param  {Number} bandSize  The size of each category
	   * @param  {sizeList} sizeList  The size of all groups
	   * @param  {maxBarSize} maxBarSize The maximum size of bar
	   * @return {Number} The size of each bar and the gap between two bars
	   */
	var getBarPosition = exports.getBarPosition = function getBarPosition(_ref5) {
	  var barGap = _ref5.barGap,
	      barCategoryGap = _ref5.barCategoryGap,
	      bandSize = _ref5.bandSize,
	      _ref5$sizeList = _ref5.sizeList,
	      sizeList = _ref5$sizeList === undefined ? [] : _ref5$sizeList,
	      maxBarSize = _ref5.maxBarSize;
	
	  var len = sizeList.length;
	  if (len < 1) return null;
	
	  var realBarGap = (0, _DataUtils.getPercentValue)(barGap, bandSize, 0, true);
	  var result = void 0;
	
	  // whether or not is barSize setted by user
	  if (sizeList[0].barSize === +sizeList[0].barSize) {
	    var useFull = false;
	    var fullBarSize = bandSize / len;
	    var sum = sizeList.reduce(function (res, entry) {
	      return res + entry.barSize || 0;
	    }, 0);
	    sum += (len - 1) * realBarGap;
	
	    if (sum >= bandSize) {
	      sum -= (len - 1) * realBarGap;
	      realBarGap = 0;
	    }
	    if (sum >= bandSize && fullBarSize > 0) {
	      useFull = true;
	      fullBarSize *= 0.9;
	      sum = len * fullBarSize;
	    }
	
	    var offset = (bandSize - sum) / 2 >> 0;
	    var prev = { offset: offset - realBarGap, size: 0 };
	
	    result = sizeList.reduce(function (res, entry) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: prev.offset + prev.size + realBarGap,
	          size: useFull ? fullBarSize : entry.barSize
	        }
	      }]);
	
	      prev = newRes[newRes.length - 1].position;
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: prev });
	        });
	      }
	      return newRes;
	    }, []);
	  } else {
	    var _offset = (0, _DataUtils.getPercentValue)(barCategoryGap, bandSize, 0, true);
	
	    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
	      realBarGap = 0;
	    }
	
	    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
	    if (originalSize > 1) {
	      originalSize >>= 0;
	    }
	    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
	
	    result = sizeList.reduce(function (res, entry, i) {
	      var newRes = [].concat(_toConsumableArray(res), [{
	        item: entry.item,
	        position: {
	          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
	          size: size
	        }
	      }]);
	
	      if (entry.stackList && entry.stackList.length) {
	        entry.stackList.forEach(function (item) {
	          newRes.push({ item: item, position: newRes[newRes.length - 1].position });
	        });
	      }
	      return newRes;
	    }, []);
	  }
	
	  return result;
	};
	
	var appendOffsetOfLegend = exports.appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      margin = props.margin;
	
	  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	  var legendProps = getLegendProps({ children: children, items: items, legendWidth: legendWidth, legendHeight: legendHeight });
	  var newOffset = offset;
	
	  if (legendProps) {
	    var box = legendBox || {};
	    var align = legendProps.align,
	        verticalAlign = legendProps.verticalAlign,
	        layout = legendProps.layout;
	
	
	    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && (0, _DataUtils.isNumber)(offset[align])) {
	      newOffset = _extends({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
	    }
	
	    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && (0, _DataUtils.isNumber)(offset[verticalAlign])) {
	      newOffset = _extends({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
	    }
	  }
	
	  return newOffset;
	};
	
	var getDomainOfErrorBars = exports.getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
	  var children = item.props.children;
	
	  var errorBars = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default).filter(function (errorBarChild) {
	    var direction = errorBarChild.props.direction;
	
	
	    return (0, _isNil3.default)(direction) || (0, _isNil3.default)(axisType) ? true : axisType.indexOf(direction) >= 0;
	  });
	
	  if (errorBars && errorBars.length) {
	    var keys = errorBars.map(function (errorBarChild) {
	      return errorBarChild.props.dataKey;
	    });
	
	    return data.reduce(function (result, entry) {
	      var entryValue = getValueByDataKey(entry, dataKey, 0);
	      var mainValue = (0, _isArray3.default)(entryValue) ? [(0, _min3.default)(entryValue), (0, _max3.default)(entryValue)] : [entryValue, entryValue];
	      var errorDomain = keys.reduce(function (prevErrorArr, k) {
	        var errorValue = getValueByDataKey(entry, k, 0);
	        var lowerValue = mainValue[0] - Math.abs((0, _isArray3.default)(errorValue) ? errorValue[0] : errorValue);
	        var upperValue = mainValue[1] + Math.abs((0, _isArray3.default)(errorValue) ? errorValue[1] : errorValue);
	
	        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
	      }, [Infinity, -Infinity]);
	
	      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	var parseErrorBarsOfAxis = exports.parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
	  var domains = items.map(function (item) {
	    return getDomainOfErrorBars(data, item, dataKey, axisType);
	  }).filter(function (entry) {
	    return !(0, _isNil3.default)(entry);
	  });
	
	  if (domains && domains.length) {
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  return null;
	};
	/**
	 * Get domain of data by the configuration of item element
	 * @param  {Array}   data      The data displayed in the chart
	 * @param  {Array}   items     The instances of item
	 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
	 * @param  {Boolean} filterNil Whether or not filter nil values
	 * @return {Array}        Domain
	 */
	var getDomainOfItemsWithSameAxis = exports.getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
	  var domains = items.map(function (item) {
	    var dataKey = item.props.dataKey;
	
	
	    if (type === 'number' && dataKey) {
	      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
	    }
	    return getDomainOfDataByKey(data, dataKey, type, filterNil);
	  });
	
	  if (type === 'number') {
	    // Calculate the domain of number axis
	    return domains.reduce(function (result, entry) {
	      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
	    }, [Infinity, -Infinity]);
	  }
	
	  var tag = {};
	  // Get the union set of category axis
	  return domains.reduce(function (result, entry) {
	    for (var i = 0, len = entry.length; i < len; i++) {
	      if (!tag[entry[i]]) {
	        tag[entry[i]] = true;
	
	        result.push(entry[i]);
	      }
	    }
	    return result;
	  }, []);
	};
	
	var isCategorialAxis = exports.isCategorialAxis = function isCategorialAxis(layout, axisType) {
	  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
	};
	
	/**
	 * Calculate the Coordinates of grid
	 * @param  {Array} ticks The ticks in axis
	 * @param {Number} min   The minimun value of axis
	 * @param {Number} max   The maximun value of axis
	 * @return {Array}       Coordinates
	 */
	var getCoordinatesOfGrid = exports.getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
	  var hasMin = void 0,
	      hasMax = void 0;
	
	  var values = ticks.map(function (entry) {
	    if (entry.coordinate === min) {
	      hasMin = true;
	    }
	    if (entry.coordinate === max) {
	      hasMax = true;
	    }
	
	    return entry.coordinate;
	  });
	
	  if (!hasMin) {
	    values.push(min);
	  }
	  if (!hasMax) {
	    values.push(max);
	  }
	
	  return values;
	};
	
	/**
	 * Get the ticks of an axis
	 * @param  {Object}  axis The configuration of an axis
	 * @param {Boolean} isGrid Whether or not are the ticks in grid
	 * @param {Boolean} isAll Return the ticks of all the points or not
	 * @return {Array}  Ticks
	 */
	var getTicksOfAxis = exports.getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
	  if (!axis) return null;
	  var scale = axis.scale;
	  var duplicateDomain = axis.duplicateDomain,
	      type = axis.type,
	      range = axis.range;
	
	  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
	  offset = axis.axisType === 'angleAxis' ? (0, _DataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
	
	  // The ticks setted by user should only affect the ticks adjacent to axis line
	  if (isGrid && (axis.ticks || axis.niceTicks)) {
	    return (axis.ticks || axis.niceTicks).map(function (entry) {
	      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
	
	      return {
	        coordinate: scale(scaleContent) + offset,
	        value: entry,
	        offset: offset
	      };
	    });
	  }
	
	  if (axis.isCategorial && axis.categoricalDomain) {
	    return axis.categoricalDomain.map(function (entry, index) {
	      return {
	        coordinate: scale(entry),
	        value: entry,
	        index: index,
	        offset: offset
	      };
	    });
	  }
	
	  if (scale.ticks && !isAll) {
	    return scale.ticks(axis.tickCount).map(function (entry) {
	      return { coordinate: scale(entry) + offset, value: entry, offset: offset };
	    });
	  }
	
	  // When axis has duplicated text, serial numbers are used to generate scale
	  return scale.domain().map(function (entry, index) {
	    return {
	      coordinate: scale(entry) + offset,
	      value: duplicateDomain ? duplicateDomain[entry] : entry,
	      index: index,
	      offset: offset
	    };
	  });
	};
	
	/**
	 * combine the handlers
	 * @param  {Function} defaultHandler Internal private handler
	 * @param  {Function} parentHandler  Handler function specified in parent component
	 * @param  {Function} childHandler   Handler function specified in child component
	 * @return {Function}                The combined handler
	 */
	var combineEventHandlers = exports.combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
	  var customizedHandler = void 0;
	
	  if ((0, _isFunction3.default)(childHandler)) {
	    customizedHandler = childHandler;
	  } else if ((0, _isFunction3.default)(parentHandler)) {
	    customizedHandler = parentHandler;
	  }
	
	  if ((0, _isFunction3.default)(defaultHandler) || customizedHandler) {
	    return function (arg1, arg2, arg3, arg4) {
	      if ((0, _isFunction3.default)(defaultHandler)) {
	        defaultHandler(arg1, arg2, arg3, arg4);
	      }
	      if ((0, _isFunction3.default)(customizedHandler)) {
	        customizedHandler(arg1, arg2, arg3, arg4);
	      }
	    };
	  }
	
	  return null;
	};
	/**
	 * Parse the scale function of axis
	 * @param  {Object}   axis          The option of axis
	 * @param  {String}   chartType     The displayName of chart
	 * @return {Function}               The scale funcion
	 */
	var parseScale = exports.parseScale = function parseScale(axis, chartType) {
	  var scale = axis.scale,
	      type = axis.type,
	      layout = axis.layout,
	      axisType = axis.axisType;
	
	  if (scale === 'auto') {
	    if (layout === 'radial' && axisType === 'radiusAxis') {
	      return { scale: d3Scales.scaleBand(), realScaleType: 'band' };
	    } else if (layout === 'radial' && axisType === 'angleAxis') {
	      return { scale: d3Scales.scaleLinear(), realScaleType: 'linear' };
	    }
	
	    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
	      return { scale: d3Scales.scalePoint(), realScaleType: 'point' };
	    } else if (type === 'category') {
	      return { scale: d3Scales.scaleBand(), realScaleType: 'band' };
	    }
	
	    return { scale: d3Scales.scaleLinear(), realScaleType: 'linear' };
	  } else if ((0, _isString3.default)(scale)) {
	    var name = 'scale' + scale.slice(0, 1).toUpperCase() + scale.slice(1);
	
	    return {
	      scale: (d3Scales[name] || d3Scales.scalePoint)(),
	      realScaleType: d3Scales[name] ? name : 'point'
	    };
	  }
	
	  return (0, _isFunction3.default)(scale) ? { scale: scale } : { scale: d3Scales.scalePoint(), realScaleType: 'point' };
	};
	var EPS = 1e-4;
	var checkDomainOfScale = exports.checkDomainOfScale = function checkDomainOfScale(scale) {
	  var domain = scale.domain();
	
	  if (!domain || domain.length <= 2) {
	    return;
	  }
	
	  var len = domain.length;
	  var range = scale.range();
	  var min = Math.min(range[0], range[1]) - EPS;
	  var max = Math.max(range[0], range[1]) + EPS;
	  var first = scale(domain[0]);
	  var last = scale(domain[len - 1]);
	
	  if (first < min || first > max || last < min || last > max) {
	    scale.domain([domain[0], domain[len - 1]]);
	  }
	};
	
	var findPositionOfBar = exports.findPositionOfBar = function findPositionOfBar(barPosition, child) {
	  if (!barPosition) {
	    return null;
	  }
	
	  for (var i = 0, len = barPosition.length; i < len; i++) {
	    if (barPosition[i].item === child) {
	      return barPosition[i].position;
	    }
	  }
	
	  return null;
	};
	
	var truncateByDomain = exports.truncateByDomain = function truncateByDomain(value, domain) {
	  if (!domain || domain.length !== 2 || !(0, _DataUtils.isNumber)(domain[0]) || !(0, _DataUtils.isNumber)(domain[1])) {
	    return value;
	  }
	
	  var min = Math.min(domain[0], domain[1]);
	  var max = Math.max(domain[0], domain[1]);
	
	  var result = [value[0], value[1]];
	  if (!(0, _DataUtils.isNumber)(value[0]) || value[0] < min) {
	    result[0] = min;
	  }
	
	  if (!(0, _DataUtils.isNumber)(value[1]) || value[1] > max) {
	    result[1] = max;
	  }
	
	  if (result[0] > max) {
	    result[0] = max;
	  }
	
	  if (result[1] < min) {
	    result[1] = min;
	  }
	
	  return result;
	};
	
	/* eslint no-param-reassign: 0 */
	var offsetSign = exports.offsetSign = function offsetSign(series) {
	  var n = series.length;
	  if (n <= 0) {
	    return;
	  }
	
	  for (var j = 0, m = series[0].length; j < m; ++j) {
	    var positive = 0;
	    var negative = 0;
	
	    for (var i = 0; i < n; ++i) {
	      var value = (0, _isNaN3.default)(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
	
	      if (value >= 0) {
	        series[i][j][0] = positive;
	        series[i][j][1] = positive + value;
	        positive = series[i][j][1];
	      } else {
	        series[i][j][0] = negative;
	        series[i][j][1] = negative + value;
	        negative = series[i][j][1];
	      }
	    }
	  }
	};
	
	var STACK_OFFSET_MAP = {
	  sign: offsetSign,
	  expand: _d3Shape.stackOffsetExpand,
	  none: _d3Shape.stackOffsetNone,
	  silhouette: _d3Shape.stackOffsetSilhouette,
	  wiggle: _d3Shape.stackOffsetWiggle
	};
	
	var getStackedData = exports.getStackedData = function getStackedData(data, stackItems, offsetType) {
	  var dataKeys = stackItems.map(function (item) {
	    return item.props.dataKey;
	  });
	  var stack = (0, _d3Shape.stack)().keys(dataKeys).value(function (d, key) {
	    return +getValueByDataKey(d, key, 0);
	  }).order(_d3Shape.stackOrderNone).offset(STACK_OFFSET_MAP[offsetType]);
	
	  return stack(data);
	};
	
	var getStackGroupsByAxisId = exports.getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
	  if (!data) {
	    return null;
	  }
	
	  // reversing items to affect render order (for layering)
	  var items = reverseStackOrder ? _items.reverse() : _items;
	
	  var stackGroups = items.reduce(function (result, item) {
	    var _item$props2 = item.props,
	        stackId = _item$props2.stackId,
	        hide = _item$props2.hide;
	
	
	    if (hide) {
	      return result;
	    }
	
	    var axisId = item.props[numericAxisId];
	    var parentGroup = result[axisId] || { hasStack: false, stackGroups: {} };
	
	    if ((0, _DataUtils.isNumOrStr)(stackId)) {
	      var childGroup = parentGroup.stackGroups[stackId] || {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: []
	      };
	
	      childGroup.items.push(item);
	
	      parentGroup.hasStack = true;
	
	      parentGroup.stackGroups[stackId] = childGroup;
	    } else {
	      parentGroup.stackGroups[(0, _DataUtils.uniqueId)('_stackId_')] = {
	        numericAxisId: numericAxisId, cateAxisId: cateAxisId, items: [item]
	      };
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, parentGroup));
	  }, {});
	
	  return Object.keys(stackGroups).reduce(function (result, axisId) {
	    var group = stackGroups[axisId];
	
	    if (group.hasStack) {
	      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
	        var g = group.stackGroups[stackId];
	
	        return _extends({}, res, _defineProperty({}, stackId, {
	          numericAxisId: numericAxisId,
	          cateAxisId: cateAxisId,
	          items: g.items,
	          stackedData: getStackedData(data, g.items, offsetType)
	        }));
	      }, {});
	    }
	
	    return _extends({}, result, _defineProperty({}, axisId, group));
	  }, {});
	};
	
	/**
	 * get domain of ticks
	 * @param  {Array} ticks Ticks of axis
	 * @param  {String} type  The type of axis
	 * @return {Array} domain
	 */
	var calculateDomainOfTicks = exports.calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
	  if (type === 'number') {
	    return [Math.min.apply(null, ticks), Math.max.apply(null, ticks)];
	  }
	
	  return ticks;
	};
	
	/**
	 * Configure the scale function of axis
	 * @param {Object} scale The scale function
	 * @param {Object} opts  The configuration of axis
	 * @return {Object}      null
	 */
	var getTicksOfScale = exports.getTicksOfScale = function getTicksOfScale(scale, opts) {
	  var realScaleType = opts.realScaleType,
	      type = opts.type,
	      tickCount = opts.tickCount,
	      originalDomain = opts.originalDomain,
	      allowDecimals = opts.allowDecimals;
	
	  var scaleType = realScaleType || opts.scale;
	
	  if (scaleType !== 'auto' && scaleType !== 'linear') {
	    return null;
	  }
	
	  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
	    // Calculate the ticks by the number of grid when the axis is a number axis
	    var domain = scale.domain();
	    var tickValues = (0, _rechartsScale.getNiceTickValues)(domain, tickCount, allowDecimals);
	
	    scale.domain(calculateDomainOfTicks(tickValues, type));
	
	    return { niceTicks: tickValues };
	  } else if (tickCount && type === 'number') {
	    var _domain = scale.domain();
	    var _tickValues = (0, _rechartsScale.getTickValuesFixedDomain)(_domain, tickCount, allowDecimals);
	
	    return { niceTicks: _tickValues };
	  }
	
	  return null;
	};
	
	var getCateCoordinateOfLine = exports.getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
	  var axis = _ref6.axis,
	      ticks = _ref6.ticks,
	      bandSize = _ref6.bandSize,
	      entry = _ref6.entry,
	      index = _ref6.index;
	
	  if (axis.type === 'category') {
	    // find coordinate of category axis by the value of category
	    if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _isNil3.default)(entry[axis.dataKey])) {
	      var matchedTick = (0, _DataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
	
	      if (matchedTick) {
	        return matchedTick.coordinate + bandSize / 2;
	      }
	    }
	
	    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
	  }
	
	  var value = getValueByDataKey(entry, axis.dataKey);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) : null;
	};
	
	var getCateCoordinateOfBar = exports.getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
	  var axis = _ref7.axis,
	      ticks = _ref7.ticks,
	      offset = _ref7.offset,
	      bandSize = _ref7.bandSize,
	      entry = _ref7.entry,
	      index = _ref7.index;
	
	  if (axis.type === 'category') {
	    return ticks[index] ? ticks[index].coordinate + offset : null;
	  }
	  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
	
	  return !(0, _isNil3.default)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
	};
	
	var getBaseValueOfBar = exports.getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
	  var numericAxis = _ref8.numericAxis;
	
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var min = Math.min(domain[0], domain[1]);
	    var max = Math.max(domain[0], domain[1]);
	
	    if (min <= 0 && max >= 0) {
	      return 0;
	    }
	    if (max < 0) {
	      return max;
	    }
	
	    return min;
	  }
	
	  return domain[0];
	};
	
	var detectReferenceElementsDomain = exports.detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
	  var lines = (0, _ReactUtils.findAllByType)(children, _ReferenceLine2.default);
	  var dots = (0, _ReactUtils.findAllByType)(children, _ReferenceDot2.default);
	  var elements = lines.concat(dots);
	  var areas = (0, _ReactUtils.findAllByType)(children, _ReferenceArea2.default);
	  var idKey = axisType + 'Id';
	  var valueKey = axisType[0];
	  var finalDomain = domain;
	
	  if (elements.length) {
	    finalDomain = elements.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[valueKey])) {
	        var value = el.props[valueKey];
	
	        return [Math.min(result[0], value), Math.max(result[1], value)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (areas.length) {
	    var key1 = valueKey + '1';
	    var key2 = valueKey + '2';
	
	    finalDomain = areas.reduce(function (result, el) {
	      if (el.props[idKey] === axisId && el.props.alwaysShow && (0, _DataUtils.isNumber)(el.props[key1]) && (0, _DataUtils.isNumber)(el.props[key2])) {
	        var value1 = el.props[key1];
	        var value2 = el.props[key2];
	
	        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
	      }
	      return result;
	    }, finalDomain);
	  }
	
	  if (specifiedTicks && specifiedTicks.length) {
	    finalDomain = specifiedTicks.reduce(function (result, tick) {
	      if ((0, _DataUtils.isNumber)(tick)) {
	        return [Math.min(result[0], tick), Math.max(result[1], tick)];
	      }
	
	      return result;
	    }, finalDomain);
	  }
	
	  return finalDomain;
	};
	
	var getStackedDataOfItem = exports.getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
	  var stackId = item.props.stackId;
	
	
	  if ((0, _DataUtils.isNumOrStr)(stackId)) {
	    var group = stackGroups[stackId];
	
	    if (group && group.items.length) {
	      var itemIndex = -1;
	
	      for (var i = 0, len = group.items.length; i < len; i++) {
	        if (group.items[i] === item) {
	          itemIndex = i;
	          break;
	        }
	      }
	      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
	    }
	  }
	
	  return null;
	};
	
	var getDomainOfSingle = function getDomainOfSingle(data) {
	  return data.reduce(function (result, entry) {
	    return [Math.min.apply(null, entry.concat([result[0]]).filter(_DataUtils.isNumber)), Math.max.apply(null, entry.concat([result[1]]).filter(_DataUtils.isNumber))];
	  }, [Infinity, -Infinity]);
	};
	
	var getDomainOfStackGroups = exports.getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
	  return Object.keys(stackGroups).reduce(function (result, stackId) {
	    var group = stackGroups[stackId];
	    var stackedData = group.stackedData;
	
	    var domain = stackedData.reduce(function (res, entry) {
	      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
	
	      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
	    }, [Infinity, -Infinity]);
	
	    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
	  }, [Infinity, -Infinity]).map(function (result) {
	    return result === Infinity || result === -Infinity ? 0 : result;
	  });
	};
	
	var MIN_VALUE_REG = exports.MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	var MAX_VALUE_REG = exports.MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
	
	var parseSpecifiedDomain = exports.parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
	  if (!(0, _isArray3.default)(specifiedDomain)) {
	    return dataDomain;
	  }
	
	  var domain = [];
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[0])) {
	    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
	  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
	    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
	
	    domain[0] = dataDomain[0] - value;
	  } else if ((0, _isFunction3.default)(specifiedDomain[0])) {
	    domain[0] = specifiedDomain[0](dataDomain[0]);
	  } else {
	    domain[0] = dataDomain[0];
	  }
	
	  if ((0, _DataUtils.isNumber)(specifiedDomain[1])) {
	    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
	  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
	    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];
	
	    domain[1] = dataDomain[1] + _value;
	  } else if ((0, _isFunction3.default)(specifiedDomain[1])) {
	    domain[1] = specifiedDomain[1](dataDomain[1]);
	  } else {
	    domain[1] = dataDomain[1];
	  }
	
	  return domain;
	};
	
	/**
	 * Calculate the size between two category
	 * @param  {Object} axis  The options of axis
	 * @param  {Array}  ticks The ticks of axis
	 * @return {Number} Size
	 */
	var getBandSizeOfAxis = exports.getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
	  if (axis && axis.scale && axis.scale.bandwidth) {
	    return axis.scale.bandwidth();
	  }
	
	  if (axis && ticks && ticks.length >= 2) {
	    var orderedTicks = (0, _sortBy3.default)(ticks, function (o) {
	      return o.coordinate;
	    });
	    var bandSize = Infinity;
	
	    for (var i = 1, len = orderedTicks.length; i < len; i++) {
	      var cur = orderedTicks[i];
	      var prev = orderedTicks[i - 1];
	
	      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
	    }
	
	    return bandSize === Infinity ? 0 : bandSize;
	  }
	
	  return 0;
	};
	/**
	 * parse the domain of a category axis when a domain is specified
	 * @param   {Array}        specifiedDomain  The domain specified by users
	 * @param   {Array}        calculatedDomain The domain calculated by dateKey
	 * @param   {ReactElement} axisChild        The axis element
	 * @returns {Array}        domains
	 */
	var parseDomainOfCategoryAxis = exports.parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
	  if (!specifiedDomain || !specifiedDomain.length) {
	    return calculatedDomain;
	  }
	
	  if ((0, _isEqual3.default)(specifiedDomain, (0, _get3.default)(axisChild, 'type.defaultProps.domain'))) {
	    return calculatedDomain;
	  }
	
	  return specifiedDomain;
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(26),
	    Map = _require.Map,
	    OrderedSet = _require.OrderedSet,
	    Record = _require.Record;
	
	// Immutable.map is typed such that the value for every key in the map
	// must be the same type
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = function (_CharacterMetadataRec) {
	  _inherits(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
	  }
	
	  CharacterMetadata.prototype.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  CharacterMetadata.prototype.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
	    return this.getStyle().includes(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  };
	
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    var defaultConfig = {
	      style: EMPTY_SET,
	      entity: null
	    };
	
	    // Fill in unspecified properties, if necessary.
	    var configMap = Map(defaultConfig).merge(config);
	
	    var existing = pool.get(configMap);
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	  /**
	   * TAB
	   */
	  TAB: 9,
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12, // NUMLOCK on FF/Safari Mac
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	  /**
	   * ALT
	   */
	  ALT: 18,
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	  /**
	   * ESC
	   */
	  ESC: 27,
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33, // also NUM_NORTH_EAST
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34, // also NUM_SOUTH_EAST
	  /**
	   * END
	   */
	  END: 35, // also NUM_SOUTH_WEST
	  /**
	   * HOME
	   */
	  HOME: 36, // also NUM_NORTH_WEST
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40, // also NUM_SOUTH
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	  /**
	   * INSERT
	   */
	  INSERT: 45, // also NUM_INSERT
	  /**
	   * DELETE
	   */
	  DELETE: 46, // also NUM_DELETE
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	  /**
	   * ONE
	   */
	  ONE: 49,
	  /**
	   * TWO
	   */
	  TWO: 50,
	  /**
	   * THREE
	   */
	  THREE: 51,
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	  /**
	   * SIX
	   */
	  SIX: 54,
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	  /**
	   * NINE
	   */
	  NINE: 57,
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63, // needs localization
	  /**
	   * A
	   */
	  A: 65,
	  /**
	   * B
	   */
	  B: 66,
	  /**
	   * C
	   */
	  C: 67,
	  /**
	   * D
	   */
	  D: 68,
	  /**
	   * E
	   */
	  E: 69,
	  /**
	   * F
	   */
	  F: 70,
	  /**
	   * G
	   */
	  G: 71,
	  /**
	   * H
	   */
	  H: 72,
	  /**
	   * I
	   */
	  I: 73,
	  /**
	   * J
	   */
	  J: 74,
	  /**
	   * K
	   */
	  K: 75,
	  /**
	   * L
	   */
	  L: 76,
	  /**
	   * M
	   */
	  M: 77,
	  /**
	   * N
	   */
	  N: 78,
	  /**
	   * O
	   */
	  O: 79,
	  /**
	   * P
	   */
	  P: 80,
	  /**
	   * Q
	   */
	  Q: 81,
	  /**
	   * R
	   */
	  R: 82,
	  /**
	   * S
	   */
	  S: 83,
	  /**
	   * T
	   */
	  T: 84,
	  /**
	   * U
	   */
	  U: 85,
	  /**
	   * V
	   */
	  V: 86,
	  /**
	   * W
	   */
	  W: 87,
	  /**
	   * X
	   */
	  X: 88,
	  /**
	   * Y
	   */
	  Y: 89,
	  /**
	   * Z
	   */
	  Z: 90,
	  /**
	   * META
	   */
	  META: 91, // WIN_KEY_LEFT
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	  /**
	   * F1
	   */
	  F1: 112,
	  /**
	   * F2
	   */
	  F2: 113,
	  /**
	   * F3
	   */
	  F3: 114,
	  /**
	   * F4
	   */
	  F4: 115,
	  /**
	   * F5
	   */
	  F5: 116,
	  /**
	   * F6
	   */
	  F6: 117,
	  /**
	   * F7
	   */
	  F7: 118,
	  /**
	   * F8
	   */
	  F8: 119,
	  /**
	   * F9
	   */
	  F9: 120,
	  /**
	   * F10
	   */
	  F10: 121,
	  /**
	   * F11
	   */
	  F11: 122,
	  /**
	   * F12
	   */
	  F12: 123,
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186, // needs localization
	  /**
	   * DASH
	   */
	  DASH: 189, // needs localization
	  /**
	   * EQUALS
	   */
	  EQUALS: 187, // needs localization
	  /**
	   * COMMA
	   */
	  COMMA: 188, // needs localization
	  /**
	   * PERIOD
	   */
	  PERIOD: 190, // needs localization
	  /**
	   * SLASH
	   */
	  SLASH: 191, // needs localization
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192, // needs localization
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222, // needs localization
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219, // needs localization
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220, // needs localization
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221, // needs localization
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224, // Firefox (Gecko) fires this for the meta key instead of 91
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229
	};
	
	/*
	 whether text and modified key is entered at the same time.
	 */
	KeyCode.isTextModifyingKeyEvent = function isTextModifyingKeyEvent(e) {
	  var keyCode = e.keyCode;
	  if (e.altKey && !e.ctrlKey || e.metaKey ||
	  // Function keys don't generate text
	  keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	    return false;
	  }
	
	  // The following keys are quite harmless, even in combination with
	  // CTRL, ALT or SHIFT.
	  switch (keyCode) {
	    case KeyCode.ALT:
	    case KeyCode.CAPS_LOCK:
	    case KeyCode.CONTEXT_MENU:
	    case KeyCode.CTRL:
	    case KeyCode.DOWN:
	    case KeyCode.END:
	    case KeyCode.ESC:
	    case KeyCode.HOME:
	    case KeyCode.INSERT:
	    case KeyCode.LEFT:
	    case KeyCode.MAC_FF_META:
	    case KeyCode.META:
	    case KeyCode.NUMLOCK:
	    case KeyCode.NUM_CENTER:
	    case KeyCode.PAGE_DOWN:
	    case KeyCode.PAGE_UP:
	    case KeyCode.PAUSE:
	    case KeyCode.PRINT_SCREEN:
	    case KeyCode.RIGHT:
	    case KeyCode.SHIFT:
	    case KeyCode.UP:
	    case KeyCode.WIN_KEY:
	    case KeyCode.WIN_KEY_RIGHT:
	      return false;
	    default:
	      return true;
	  }
	};
	
	/*
	 whether character is entered.
	 */
	KeyCode.isCharacterKey = function isCharacterKey(keyCode) {
	  if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	    return true;
	  }
	
	  if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	    return true;
	  }
	
	  // Safari sends zero key code for non-latin characters.
	  if (window.navigation.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	    return true;
	  }
	
	  switch (keyCode) {
	    case KeyCode.SPACE:
	    case KeyCode.QUESTION_MARK:
	    case KeyCode.NUM_PLUS:
	    case KeyCode.NUM_MINUS:
	    case KeyCode.NUM_PERIOD:
	    case KeyCode.NUM_DIVISION:
	    case KeyCode.SEMICOLON:
	    case KeyCode.DASH:
	    case KeyCode.EQUALS:
	    case KeyCode.COMMA:
	    case KeyCode.PERIOD:
	    case KeyCode.SLASH:
	    case KeyCode.APOSTROPHE:
	    case KeyCode.SINGLE_QUOTE:
	    case KeyCode.OPEN_SQUARE_BRACKET:
	    case KeyCode.BACKSLASH:
	    case KeyCode.CLOSE_SQUARE_BRACKET:
	      return true;
	    default:
	      return false;
	  }
	};
	
	exports['default'] = KeyCode;
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getPhrasePropTypes;
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getPhrasePropTypes(defaultPhrases) {
	  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
	    return (0, _object2['default'])({}, phrases, _defineProperty({}, key, _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].node])));
	  }, {});
	}

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var warned = {};
	
	exports['default'] = function (valid, message) {
	    if (!valid && !warned[message]) {
	        (0, _warning2['default'])(false, message);
	        warned[message] = true;
	    }
	};

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LocaleReceiver = function (_React$Component) {
	    (0, _inherits3['default'])(LocaleReceiver, _React$Component);
	
	    function LocaleReceiver() {
	        (0, _classCallCheck3['default'])(this, LocaleReceiver);
	        return (0, _possibleConstructorReturn3['default'])(this, (LocaleReceiver.__proto__ || Object.getPrototypeOf(LocaleReceiver)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(LocaleReceiver, [{
	        key: 'getLocale',
	        value: function getLocale() {
	            var _props = this.props,
	                componentName = _props.componentName,
	                defaultLocale = _props.defaultLocale;
	            var antLocale = this.context.antLocale;
	
	            var localeFromContext = antLocale && antLocale[componentName];
	            return (0, _extends3['default'])({}, typeof defaultLocale === 'function' ? defaultLocale() : defaultLocale, localeFromContext || {});
	        }
	    }, {
	        key: 'getLocaleCode',
	        value: function getLocaleCode() {
	            var antLocale = this.context.antLocale;
	
	            var localeCode = antLocale && antLocale.locale;
	            // Had use LocaleProvide but didn't set locale
	            if (antLocale && antLocale.exist && !localeCode) {
	                return 'en-us';
	            }
	            return localeCode;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.props.children(this.getLocale(), this.getLocaleCode());
	        }
	    }]);
	    return LocaleReceiver;
	}(React.Component);
	
	exports['default'] = LocaleReceiver;
	
	LocaleReceiver.contextTypes = {
	    antLocale: _propTypes2['default'].object
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-param-reassign */
	/* eslint-disable no-restricted-syntax */
	/* eslint-disable guard-for-in */
	
	var assert = __webpack_require__(117);
	var objectAssign = __webpack_require__(1566);
	
	function pick(object, keys) {
	  return keys.reduce(function(prev, key) {
	    if (object[key]) {
	      prev[key] = object[key];
	    }
	    return prev;
	  }, {});
	}
	
	function getKeysNotIn(obj, allowedKeys) {
	  var notAllowed = [];
	  for (var key in obj) {
	    if (allowedKeys.indexOf(key) === -1) {
	      notAllowed.push(key);
	    }
	  }
	  return notAllowed;
	}
	
	function objectValues(obj) {
	  var values = [];
	  for (var key in obj) {
	    values.push(obj[key]);
	  }
	  return values;
	}
	
	function extend() {
	  var params = objectValues(arguments);
	  params.unshift({});
	  return objectAssign.get().apply(undefined, params);
	}
	
	function merge(object, keys) {
	  return {
	    base: keys ? pick(object, keys) : object,
	    with: function(object2, keys2) {
	      object2 = keys2 ? pick(object2, keys2) : object2;
	      return extend(this.base, object2);
	    }
	  };
	}
	
	function blacklist(object, blacklistedKeys) {
	  return Object.keys(object).reduce(function(p, key) {
	    if (blacklistedKeys.indexOf(key) === -1) {
	      p[key] = object[key];
	    }
	    return p;
	  }, {});
	}
	
	function camelToSnake(str) {
	  var newKey = '';
	  var index = 0;
	  var code;
	  var wasPrevNumber = true;
	  var wasPrevUppercase = true;
	
	  while (index < str.length) {
	    code = str.charCodeAt(index);
	    if (
	      (!wasPrevUppercase && code >= 65 && code <= 90) ||
	      (!wasPrevNumber && code >= 48 && code <= 57)
	    ) {
	      newKey += '_';
	      newKey += str[index].toLowerCase();
	    } else {
	      newKey += str[index].toLowerCase();
	    }
	    wasPrevNumber = code >= 48 && code <= 57;
	    wasPrevUppercase = code >= 65 && code <= 90;
	    index++;
	  }
	
	  return newKey;
	}
	
	function snakeToCamel(str) {
	  var parts = str.split('_');
	  return parts.reduce(function(p, c) {
	    return p + c.charAt(0).toUpperCase() + c.slice(1);
	  }, parts.shift());
	}
	
	function toSnakeCase(object, exceptions) {
	  if (typeof object !== 'object' || assert.isArray(object) || object === null) {
	    return object;
	  }
	  exceptions = exceptions || [];
	
	  return Object.keys(object).reduce(function(p, key) {
	    var newKey = exceptions.indexOf(key) === -1 ? camelToSnake(key) : key;
	    p[newKey] = toSnakeCase(object[key]);
	    return p;
	  }, {});
	}
	
	function toCamelCase(object, exceptions) {
	  if (typeof object !== 'object' || assert.isArray(object) || object === null) {
	    return object;
	  }
	
	  exceptions = exceptions || [];
	
	  return Object.keys(object).reduce(function(p, key) {
	    var newKey = exceptions.indexOf(key) === -1 ? snakeToCamel(key) : key;
	    p[newKey] = toCamelCase(object[key]);
	    return p;
	  }, {});
	}
	
	module.exports = {
	  toSnakeCase: toSnakeCase,
	  toCamelCase: toCamelCase,
	  blacklist: blacklist,
	  merge: merge,
	  pick: pick,
	  getKeysNotIn: getKeysNotIn,
	  extend: extend
	};


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(735);
	var isBuffer = __webpack_require__(2289);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlockNode
	 * @format
	 * 
	 *
	 * This file is a fork of ContentBlock adding support for nesting references by
	 * providing links to children, parent, prevSibling, and nextSibling.
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(71);
	var Immutable = __webpack_require__(26);
	
	var findRangesImmutable = __webpack_require__(227);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  parent: null,
	  characterList: List(),
	  data: Map(),
	  depth: 0,
	  key: '',
	  text: '',
	  type: 'unstyled',
	  children: List(),
	  prevSibling: null,
	  nextSibling: null
	};
	
	var haveEqualStyle = function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	};
	
	var haveEqualEntity = function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	};
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlockNode = function (_Record) {
	  _inherits(ContentBlockNode, _Record);
	
	  function ContentBlockNode() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;
	
	    _classCallCheck(this, ContentBlockNode);
	
	    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
	  }
	
	  ContentBlockNode.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlockNode.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlockNode.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlockNode.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlockNode.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlockNode.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
	    return this.get('children');
	  };
	
	  ContentBlockNode.prototype.getParentKey = function getParentKey() {
	    return this.get('parent');
	  };
	
	  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
	    return this.get('prevSibling');
	  };
	
	  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
	    return this.get('nextSibling');
	  };
	
	  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlockNode;
	}(Record(defaultRecord));
	
	module.exports = ContentBlockNode;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2856);


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DIRECTION = exports.ORIENTATION = undefined;
	exports.getTicksTotalFromSize = getTicksTotalFromSize;
	exports.getTickValues = getTickValues;
	exports.generateFit = generateFit;
	exports.generatePoints = generatePoints;
	exports.getAxisAngle = getAxisAngle;
	
	var _d3Array = __webpack_require__(147);
	
	var _d3Scale = __webpack_require__(180);
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ORIENTATION = exports.ORIENTATION = {
	  TOP: 'top',
	  LEFT: 'left',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  VERTICAL: 'vertical',
	  HORIZONTAL: 'horizontal'
	};
	
	var DIRECTION = exports.DIRECTION = {
	  VERTICAL: 'vertical',
	  HORIZONTAL: 'horizontal'
	};
	
	/**
	 * Get total amount of ticks from a given size in pixels.
	 * @param {number} size Size of the axis in pixels.
	 * @returns {number} Total amount of ticks.
	 */
	function getTicksTotalFromSize(size) {
	  if (size < 700) {
	    if (size > 300) {
	      return 10;
	    }
	    return 5;
	  }
	  return 20;
	}
	
	/**
	 * Get the tick values from a given d3 scale.
	 * @param {d3.scale} scale Scale function.
	 * @param {number} tickTotal Total number of ticks
	 * @param {Array} tickValues Array of tick values if they exist.
	 * @returns {Array} Array of tick values.
	 */
	function getTickValues(scale, tickTotal, tickValues) {
	  return !tickValues ? scale.ticks ? scale.ticks(tickTotal) : scale.domain() : tickValues;
	}
	
	/**
	 * Generate a description of a decorative axis in terms of a linear equation
	 * y = slope * x + offset in coordinates
	 * @param {Object} axisStart Object of format {x, y} describing in coordinates
	 * the start position of the decorative axis
	 * @param {Object} axisEnd Object of format {x, y} describing in coordinates
	 * the start position of the decorative axis
	 * @returns {Number} Object describing each the line in coordinates
	 */
	function generateFit(axisStart, axisEnd) {
	  // address the special case when the slope is infinite
	  if (axisStart.x === axisEnd.x) {
	    return {
	      left: axisStart.y,
	      right: axisEnd.y,
	      slope: 0,
	      offset: axisStart.x
	    };
	  }
	  var slope = (axisStart.y - axisEnd.y) / (axisStart.x - axisEnd.x);
	  return {
	    left: axisStart.x,
	    right: axisEnd.x,
	    // generate the linear projection of the axis direction
	    slope: slope,
	    offset: axisStart.y - slope * axisStart.x
	  };
	}
	
	/**
	 * Generate a description of a decorative axis in terms of a linear equation
	 * y = slope * x + offset in coordinates
	 * @param props
	 * props.@param {Object} axisStart Object of format {x, y} describing in coordinates
	 * the start position of the decorative axis
	 * props.@param {Object} axisEnd Object of format {x, y} describing in coordinates
	 * the start position of the decorative axis
	 * props.@param {Number} numberOfTicks The number of ticks on the axis
	 * props.@param {Array.Numbers} axisDomain The values to be interpolated across for the axis
	 * @returns {Number} Object describing the slope and the specific coordinates of the points
	 */
	function generatePoints(_ref) {
	  var axisStart = _ref.axisStart,
	      axisEnd = _ref.axisEnd,
	      numberOfTicks = _ref.numberOfTicks,
	      axisDomain = _ref.axisDomain;
	
	  var _generateFit = generateFit(axisStart, axisEnd),
	      left = _generateFit.left,
	      right = _generateFit.right,
	      slope = _generateFit.slope,
	      offset = _generateFit.offset;
	  // construct a linear band of points, then map them
	
	
	  var pointSlope = (right - left) / numberOfTicks;
	  var axisScale = (0, _d3Scale.scaleLinear)().domain([left, right]).range(axisDomain);
	
	  var slopeVertical = axisStart.x === axisEnd.x;
	  return {
	    slope: slopeVertical ? Infinity : slope,
	    points: (0, _d3Array.range)(left, right + pointSlope, pointSlope).map(function (val) {
	      if (slopeVertical) {
	        return { y: val, x: slope * val + offset, text: axisScale(val) };
	      }
	      return { x: val, y: slope * val + offset, text: axisScale(val) };
	    })
	  };
	}
	
	/**
	 * Compute the angle (in radians) of a decorative axis
	 * @param {Object} axisStart Object of format {x, y} describing in coordinates
	 * the start position of the decorative axis
	 * @param {Object} axisEnd Object of format {x, y} describing in coordinates
	 * the start position of the decorative axis
	 * @returns {Number} Angle in radials
	 */
	function getAxisAngle(axisStart, axisEnd) {
	  if (axisStart.x === axisEnd.x) {
	    return axisEnd.y > axisStart.y ? Math.PI / 2 : 3 * Math.PI / 2;
	  }
	  return Math.atan((axisEnd.y - axisStart.y) / (axisEnd.x - axisStart.x));
	}
	
	exports.default = {
	  DIRECTION: DIRECTION,
	  ORIENTATION: ORIENTATION,
	  getTicksTotalFromSize: getTicksTotalFromSize,
	  getTickValues: getTickValues
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withStylesPropTypes = exports.cssNoRTL = exports.css = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.withStyles = withStyles;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(231);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _deepmerge = __webpack_require__(1882);
	
	var _deepmerge2 = _interopRequireDefault(_deepmerge);
	
	var _constants = __webpack_require__(2956);
	
	var _brcast = __webpack_require__(2957);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _ThemedStyleSheet = __webpack_require__(1321);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Add some named exports for convenience.
	var css = exports.css = _ThemedStyleSheet2['default'].resolve;
	var cssNoRTL = exports.cssNoRTL = _ThemedStyleSheet2['default'].resolveNoRTL;
	var withStylesPropTypes = exports.withStylesPropTypes = {
	  styles: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  theme: _propTypes2['default'].object.isRequired // eslint-disable-line react/forbid-prop-types
	};
	
	var EMPTY_STYLES = {};
	var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
	  return EMPTY_STYLES;
	};
	
	function baseClass(pureComponent) {
	  if (pureComponent) {
	    if (!_react2['default'].PureComponent) {
	      throw new ReferenceError('withStyles() pureComponent option requires React 15.3.0 or later');
	    }
	
	    return _react2['default'].PureComponent;
	  }
	
	  return _react2['default'].Component;
	}
	
	var contextTypes = _defineProperty({}, _constants.CHANNEL, _brcast2['default']);
	
	function withStyles(styleFn) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stylesPropName = _ref.stylesPropName,
	      stylesPropName = _ref$stylesPropName === undefined ? 'styles' : _ref$stylesPropName,
	      _ref$themePropName = _ref.themePropName,
	      themePropName = _ref$themePropName === undefined ? 'theme' : _ref$themePropName,
	      _ref$flushBefore = _ref.flushBefore,
	      flushBefore = _ref$flushBefore === undefined ? false : _ref$flushBefore,
	      _ref$pureComponent = _ref.pureComponent,
	      pureComponent = _ref$pureComponent === undefined ? false : _ref$pureComponent;
	
	  var styleDefLTR = void 0;
	  var styleDefRTL = void 0;
	  var BaseClass = baseClass(pureComponent);
	
	  return function () {
	    function withStylesHOC(WrappedComponent) {
	      // NOTE: Use a class here so components are ref-able if need be:
	      // eslint-disable-next-line react/prefer-stateless-function
	      var WithStyles = function (_BaseClass) {
	        _inherits(WithStyles, _BaseClass);
	
	        function WithStyles() {
	          _classCallCheck(this, WithStyles);
	
	          return _possibleConstructorReturn(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).apply(this, arguments));
	        }
	
	        _createClass(WithStyles, [{
	          key: 'componentWillMount',
	          value: function () {
	            function componentWillMount() {
	              this.maybeCreateStyles();
	            }
	
	            return componentWillMount;
	          }()
	        }, {
	          key: 'maybeCreateStyles',
	          value: function () {
	            function maybeCreateStyles() {
	              var direction = this.context[_constants.CHANNEL] && this.context[_constants.CHANNEL].getState();
	              var isRTL = direction === _constants.DIRECTIONS.RTL;
	              if (isRTL && !styleDefRTL) {
	                styleDefRTL = styleFn ? _ThemedStyleSheet2['default'].createRTL(styleFn) : EMPTY_STYLES_FN;
	              } else if (!isRTL && !styleDefLTR) {
	                styleDefLTR = styleFn ? _ThemedStyleSheet2['default'].create(styleFn) : EMPTY_STYLES_FN;
	              }
	
	              return isRTL ? styleDefRTL : styleDefLTR;
	            }
	
	            return maybeCreateStyles;
	          }()
	        }, {
	          key: 'render',
	          value: function () {
	            function render() {
	              var _ref2;
	
	              // As some components will depend on previous styles in
	              // the component tree, we provide the option of flushing the
	              // buffered styles (i.e. to a style tag) **before** the rendering
	              // cycle begins.
	              //
	              // The interfaces provide the optional "flush" method which
	              // is run in turn by ThemedStyleSheet.flush.
	              if (flushBefore) {
	                _ThemedStyleSheet2['default'].flush();
	              }
	
	              var styleDef = this.maybeCreateStyles();
	
	              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, (_ref2 = {}, _defineProperty(_ref2, themePropName, _ThemedStyleSheet2['default'].get()), _defineProperty(_ref2, stylesPropName, styleDef()), _ref2)));
	            }
	
	            return render;
	          }()
	        }]);
	
	        return WithStyles;
	      }(BaseClass);
	
	      var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	      WithStyles.WrappedComponent = WrappedComponent;
	      WithStyles.displayName = 'withStyles(' + String(wrappedComponentName) + ')';
	      WithStyles.contextTypes = contextTypes;
	      if (WrappedComponent.propTypes) {
	        WithStyles.propTypes = (0, _deepmerge2['default'])({}, WrappedComponent.propTypes);
	        delete WithStyles.propTypes[stylesPropName];
	        delete WithStyles.propTypes[themePropName];
	      }
	      if (WrappedComponent.defaultProps) {
	        WithStyles.defaultProps = (0, _deepmerge2['default'])({}, WrappedComponent.defaultProps);
	      }
	
	      return (0, _hoistNonReactStatics2['default'])(WithStyles, WrappedComponent);
	    }
	
	    return withStylesHOC;
	  }();
	}

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(408)('wks');
	var uid = __webpack_require__(284);
	var Symbol = __webpack_require__(119).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var color = __webpack_require__(894);
	var helpers = __webpack_require__(23);
	
	function interpolate(start, view, model, ease) {
		var keys = Object.keys(model);
		var i, ilen, key, actual, origin, target, type, c0, c1;
	
		for (i = 0, ilen = keys.length; i < ilen; ++i) {
			key = keys[i];
	
			target = model[key];
	
			// if a value is added to the model after pivot() has been called, the view
			// doesn't contain it, so let's initialize the view to the target value.
			if (!view.hasOwnProperty(key)) {
				view[key] = target;
			}
	
			actual = view[key];
	
			if (actual === target || key[0] === '_') {
				continue;
			}
	
			if (!start.hasOwnProperty(key)) {
				start[key] = actual;
			}
	
			origin = start[key];
	
			type = typeof target;
	
			if (type === typeof origin) {
				if (type === 'string') {
					c0 = color(origin);
					if (c0.valid) {
						c1 = color(target);
						if (c1.valid) {
							view[key] = c1.mix(c0, ease).rgbString();
							continue;
						}
					}
				} else if (type === 'number' && isFinite(origin) && isFinite(target)) {
					view[key] = origin + (target - origin) * ease;
					continue;
				}
			}
	
			view[key] = target;
		}
	}
	
	var Element = function(configuration) {
		helpers.extend(this, configuration);
		this.initialize.apply(this, arguments);
	};
	
	helpers.extend(Element.prototype, {
	
		initialize: function() {
			this.hidden = false;
		},
	
		pivot: function() {
			var me = this;
			if (!me._view) {
				me._view = helpers.clone(me._model);
			}
			me._start = {};
			return me;
		},
	
		transition: function(ease) {
			var me = this;
			var model = me._model;
			var start = me._start;
			var view = me._view;
	
			// No animation -> No Transition
			if (!model || ease === 1) {
				me._view = model;
				me._start = null;
				return me;
			}
	
			if (!view) {
				view = me._view = {};
			}
	
			if (!start) {
				start = me._start = {};
			}
	
			interpolate(start, view, model, ease);
	
			return me;
		},
	
		tooltipPosition: function() {
			return {
				x: this._model.x,
				y: this._model.y
			};
		},
	
		hasValue: function() {
			return helpers.isNumber(this._model.x) && helpers.isNumber(this._model.y);
		}
	});
	
	Element.extend = helpers.inherits;
	
	module.exports = Element;


/***/ },
/* 84 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ },
/* 85 */
[3477, 2356, 2357, 110, 36, 2446],
/* 86 */
[3533, 453],
/* 87 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 88 */
[3535, 128, 2384, 112],
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = addEventListenerWrap;
	
	var _addDomEventListener = __webpack_require__(1422);
	
	var _addDomEventListener2 = _interopRequireDefault(_addDomEventListener);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function addEventListenerWrap(target, eventType, cb) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom2['default'].unstable_batchedUpdates ? function run(e) {
	    _reactDom2['default'].unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener2['default'])(target, eventType, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 90 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function mapValues(object, iteratee) {
	  var result = {};
	
	  Object.keys(object || {}).forEach(function (key) {
	    result[key] = iteratee(object[key], key, object);
	  });
	
	  return result;
	}
	
	exports.default = mapValues;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.inRangeOfSector = exports.formatAngleOfSector = exports.getAngleOfPoint = exports.distanceBetweenPoints = exports.formatAxisMap = exports.getMaxRadius = exports.polarToCartesian = exports.radianToDegree = exports.degreeToRadian = exports.RADIAN = undefined;
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var RADIAN = exports.RADIAN = Math.PI / 180;
	
	var degreeToRadian = exports.degreeToRadian = function degreeToRadian(angle) {
	  return angle * Math.PI / 180;
	};
	
	var radianToDegree = exports.radianToDegree = function radianToDegree(angleInRadian) {
	  return angleInRadian * 180 / Math.PI;
	};
	
	var polarToCartesian = exports.polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
	  return {
	    x: cx + Math.cos(-RADIAN * angle) * radius,
	    y: cy + Math.sin(-RADIAN * angle) * radius
	  };
	};
	
	var getMaxRadius = exports.getMaxRadius = function getMaxRadius(width, height) {
	  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    top: 0, right: 0, bottom: 0, left: 0
	  };
	  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
	};
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = exports.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height;
	  var startAngle = props.startAngle,
	      endAngle = props.endAngle;
	
	  var cx = (0, _DataUtils.getPercentValue)(props.cx, width, width / 2);
	  var cy = (0, _DataUtils.getPercentValue)(props.cy, height, height / 2);
	  var maxRadius = getMaxRadius(width, height, offset);
	  var innerRadius = (0, _DataUtils.getPercentValue)(props.innerRadius, maxRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(props.outerRadius, maxRadius, maxRadius * 0.8);
	  var ids = Object.keys(axisMap);
	
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var domain = axis.domain,
	        reversed = axis.reversed;
	
	    var range = void 0;
	
	    if ((0, _isNil3.default)(axis.range)) {
	      if (axisType === 'angleAxis') {
	        range = [startAngle, endAngle];
	      } else if (axisType === 'radiusAxis') {
	        range = [innerRadius, outerRadius];
	      }
	
	      if (reversed) {
	        range = [range[1], range[0]];
	      }
	    } else {
	      range = axis.range;
	      startAngle = range[0];
	      endAngle = range[1];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        realScaleType = _parseScale.realScaleType,
	        scale = _parseScale.scale;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _extends({}, axis, { realScaleType: realScaleType }));
	
	    var finalAxis = _extends({}, axis, ticks, {
	      range: range,
	      radius: outerRadius,
	      realScaleType: realScaleType, scale: scale, cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	
	    return _extends({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	var distanceBetweenPoints = exports.distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
	  var x1 = point.x,
	      y1 = point.y;
	  var x2 = anotherPoint.x,
	      y2 = anotherPoint.y;
	
	
	  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
	};
	
	var getAngleOfPoint = exports.getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
	  var x = _ref.x,
	      y = _ref.y;
	  var cx = _ref2.cx,
	      cy = _ref2.cy;
	
	  var radius = distanceBetweenPoints({ x: x, y: y }, { x: cx, y: cy });
	
	  if (radius <= 0) {
	    return { radius: radius };
	  }
	
	  var cos = (x - cx) / radius;
	  var angleInRadian = Math.acos(cos);
	
	  if (y > cy) {
	    angleInRadian = 2 * Math.PI - angleInRadian;
	  }
	
	  return { radius: radius, angle: radianToDegree(angleInRadian), angleInRadian: angleInRadian };
	};
	
	var formatAngleOfSector = exports.formatAngleOfSector = function formatAngleOfSector(_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	
	  return {
	    startAngle: startAngle - min * 360,
	    endAngle: endAngle - min * 360
	  };
	};
	
	var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
	  var startAngle = _ref4.startAngle,
	      endAngle = _ref4.endAngle;
	
	  var startCnt = Math.floor(startAngle / 360);
	  var endCnt = Math.floor(endAngle / 360);
	  var min = Math.min(startCnt, endCnt);
	
	  return angle + min * 360;
	};
	
	var inRangeOfSector = exports.inRangeOfSector = function inRangeOfSector(_ref5, sector) {
	  var x = _ref5.x,
	      y = _ref5.y;
	
	  var _getAngleOfPoint = getAngleOfPoint({ x: x, y: y }, sector),
	      radius = _getAngleOfPoint.radius,
	      angle = _getAngleOfPoint.angle;
	
	  var innerRadius = sector.innerRadius,
	      outerRadius = sector.outerRadius;
	
	
	  if (radius < innerRadius || radius > outerRadius) {
	    return false;
	  }
	
	  if (radius === 0) {
	    return true;
	  }
	
	  var _formatAngleOfSector = formatAngleOfSector(sector),
	      startAngle = _formatAngleOfSector.startAngle,
	      endAngle = _formatAngleOfSector.endAngle;
	
	  var formatAngle = angle;
	  var inRange = void 0;
	
	  if (startAngle <= endAngle) {
	    while (formatAngle > endAngle) {
	      formatAngle -= 360;
	    }
	    while (formatAngle < startAngle) {
	      formatAngle += 360;
	    }
	    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
	  } else {
	    while (formatAngle > startAngle) {
	      formatAngle -= 360;
	    }
	    while (formatAngle < endAngle) {
	      formatAngle += 360;
	    }
	    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
	  }
	
	  if (inRange) {
	    return _extends({}, sector, { radius: radius, angle: reverseFormatAngleOfSetor(formatAngle, sector) });
	  }
	
	  return null;
	};

/***/ },
/* 92 */
36,
/* 93 */
[3546, 3205],
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.check = check;
	exports.hasOwn = hasOwn;
	exports.remove = remove;
	exports.deferred = deferred;
	exports.arrayOfDeffered = arrayOfDeffered;
	exports.delay = delay;
	exports.createMockTask = createMockTask;
	exports.autoInc = autoInc;
	exports.makeIterator = makeIterator;
	exports.log = log;
	exports.deprecate = deprecate;
	var sym = exports.sym = function sym(id) {
	  return '@@redux-saga/' + id;
	};
	
	var TASK = /*#__PURE__*/exports.TASK = sym('TASK');
	var HELPER = /*#__PURE__*/exports.HELPER = sym('HELPER');
	var MATCH = /*#__PURE__*/exports.MATCH = sym('MATCH');
	var CANCEL = /*#__PURE__*/exports.CANCEL = sym('CANCEL_PROMISE');
	var SAGA_ACTION = /*#__PURE__*/exports.SAGA_ACTION = sym('SAGA_ACTION');
	var SELF_CANCELLATION = /*#__PURE__*/exports.SELF_CANCELLATION = sym('SELF_CANCELLATION');
	var konst = exports.konst = function konst(v) {
	  return function () {
	    return v;
	  };
	};
	var kTrue = /*#__PURE__*/exports.kTrue = konst(true);
	var kFalse = /*#__PURE__*/exports.kFalse = konst(false);
	var noop = exports.noop = function noop() {};
	var ident = exports.ident = function ident(v) {
	  return v;
	};
	
	function check(value, predicate, error) {
	  if (!predicate(value)) {
	    log('error', 'uncaught at check', error);
	    throw new Error(error);
	  }
	}
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	function hasOwn(object, property) {
	  return is.notUndef(object) && hasOwnProperty.call(object, property);
	}
	
	var is = exports.is = {
	  undef: function undef(v) {
	    return v === null || v === undefined;
	  },
	  notUndef: function notUndef(v) {
	    return v !== null && v !== undefined;
	  },
	  func: function func(f) {
	    return typeof f === 'function';
	  },
	  number: function number(n) {
	    return typeof n === 'number';
	  },
	  string: function string(s) {
	    return typeof s === 'string';
	  },
	  array: Array.isArray,
	  object: function object(obj) {
	    return obj && !is.array(obj) && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
	  },
	  promise: function promise(p) {
	    return p && is.func(p.then);
	  },
	  iterator: function iterator(it) {
	    return it && is.func(it.next) && is.func(it.throw);
	  },
	  iterable: function iterable(it) {
	    return it && is.func(Symbol) ? is.func(it[Symbol.iterator]) : is.array(it);
	  },
	  task: function task(t) {
	    return t && t[TASK];
	  },
	  observable: function observable(ob) {
	    return ob && is.func(ob.subscribe);
	  },
	  buffer: function buffer(buf) {
	    return buf && is.func(buf.isEmpty) && is.func(buf.take) && is.func(buf.put);
	  },
	  pattern: function pattern(pat) {
	    return pat && (is.string(pat) || (typeof pat === 'undefined' ? 'undefined' : _typeof(pat)) === 'symbol' || is.func(pat) || is.array(pat));
	  },
	  channel: function channel(ch) {
	    return ch && is.func(ch.take) && is.func(ch.close);
	  },
	  helper: function helper(it) {
	    return it && it[HELPER];
	  },
	  stringableFunc: function stringableFunc(f) {
	    return is.func(f) && hasOwn(f, 'toString');
	  }
	};
	
	var object = exports.object = {
	  assign: function assign(target, source) {
	    for (var i in source) {
	      if (hasOwn(source, i)) {
	        target[i] = source[i];
	      }
	    }
	  }
	};
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	}
	
	var array = exports.array = {
	  from: function from(obj) {
	    var arr = Array(obj.length);
	    for (var i in obj) {
	      if (hasOwn(obj, i)) {
	        arr[i] = obj[i];
	      }
	    }
	    return arr;
	  }
	};
	
	function deferred() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var def = _extends({}, props);
	  var promise = new Promise(function (resolve, reject) {
	    def.resolve = resolve;
	    def.reject = reject;
	  });
	  def.promise = promise;
	  return def;
	}
	
	function arrayOfDeffered(length) {
	  var arr = [];
	  for (var i = 0; i < length; i++) {
	    arr.push(deferred());
	  }
	  return arr;
	}
	
	function delay(ms) {
	  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	  var timeoutId = void 0;
	  var promise = new Promise(function (resolve) {
	    timeoutId = setTimeout(function () {
	      return resolve(val);
	    }, ms);
	  });
	
	  promise[CANCEL] = function () {
	    return clearTimeout(timeoutId);
	  };
	
	  return promise;
	}
	
	function createMockTask() {
	  var _ref;
	
	  var running = true;
	  var _result = void 0,
	      _error = void 0;
	
	  return _ref = {}, _ref[TASK] = true, _ref.isRunning = function isRunning() {
	    return running;
	  }, _ref.result = function result() {
	    return _result;
	  }, _ref.error = function error() {
	    return _error;
	  }, _ref.setRunning = function setRunning(b) {
	    return running = b;
	  }, _ref.setResult = function setResult(r) {
	    return _result = r;
	  }, _ref.setError = function setError(e) {
	    return _error = e;
	  }, _ref;
	}
	
	function autoInc() {
	  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = /*#__PURE__*/exports.uid = autoInc();
	
	var kThrow = function kThrow(err) {
	  throw err;
	};
	var kReturn = function kReturn(value) {
	  return { value: value, done: true };
	};
	function makeIterator(next) {
	  var thro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : kThrow;
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var isHelper = arguments[3];
	
	  var iterator = { name: name, next: next, throw: thro, return: kReturn };
	
	  if (isHelper) {
	    iterator[HELPER] = true;
	  }
	  if (typeof Symbol !== 'undefined') {
	    iterator[Symbol.iterator] = function () {
	      return iterator;
	    };
	  }
	  return iterator;
	}
	
	/**
	  Print error in a useful way whether in a browser environment
	  (with expandable error stack traces), or in a node.js environment
	  (text-only log output)
	 **/
	function log(level, message) {
	  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  /*eslint-disable no-console*/
	  if (typeof window === 'undefined') {
	    console.log('redux-saga ' + level + ': ' + message + '\n' + (error && error.stack || error));
	  } else {
	    console[level](message, error);
	  }
	}
	
	function deprecate(fn, deprecationWarning) {
	  return function () {
	    if (false) log('warn', deprecationWarning);
	    return fn.apply(undefined, arguments);
	  };
	}
	
	var updateIncentive = exports.updateIncentive = function updateIncentive(deprecated, preferred) {
	  return deprecated + ' has been deprecated in favor of ' + preferred + ', please update your code';
	};
	
	var internalErr = exports.internalErr = function internalErr(err) {
	  return new Error('\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project\'s github repo.\n  Error: ' + err + '\n');
	};
	
	var createSetContextWarning = exports.createSetContextWarning = function createSetContextWarning(ctx, props) {
	  return (ctx ? ctx + '.' : '') + 'setContext(props): argument ' + props + ' is not a plain object';
	};
	
	var wrapSagaDispatch = exports.wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
	  return function (action) {
	    return dispatch(Object.defineProperty(action, SAGA_ACTION, { value: true }));
	  };
	};
	
	var cloneableGenerator = exports.cloneableGenerator = function cloneableGenerator(generatorFunc) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var history = [];
	    var gen = generatorFunc.apply(undefined, args);
	    return {
	      next: function next(arg) {
	        history.push(arg);
	        return gen.next(arg);
	      },
	      clone: function clone() {
	        var clonedGen = cloneableGenerator(generatorFunc).apply(undefined, args);
	        history.forEach(function (arg) {
	          return clonedGen.next(arg);
	        });
	        return clonedGen;
	      },
	      return: function _return(value) {
	        return gen.return(value);
	      },
	      throw: function _throw(exception) {
	        return gen.throw(exception);
	      }
	    };
	  };
	};

/***/ },
/* 95 */
/***/ function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(119);
	var core = __webpack_require__(62);
	var ctx = __webpack_require__(400);
	var hide = __webpack_require__(178);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(2009);
	var VersionRange = __webpack_require__(2010);
	
	var mapObject = __webpack_require__(2024);
	var memoizeStringOnly = __webpack_require__(2025);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ },
/* 98 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(233);
	var compressions = __webpack_require__(443);
	var nodeBuffer = __webpack_require__(444);
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: "application/zip"
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob('application/zip');
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	


/***/ },
/* 100 */
[3521, 991],
/* 101 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * this is sort of silly but needed for Button
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'a'
	};
	
	function isTrivialHref(href) {
	  return !href || href.trim() === '#';
	}
	
	/**
	 * There are situations due to browser quirks or Bootstrap CSS where
	 * an anchor tag is needed, when semantically a button tag is the
	 * better choice. SafeAnchor ensures that when an anchor is used like a
	 * button its accessible. It also emulates input `disabled` behavior for
	 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
	 */
	
	var SafeAnchor = function (_React$Component) {
	  (0, _inherits3.default)(SafeAnchor, _React$Component);
	
	  function SafeAnchor(props, context) {
	    (0, _classCallCheck3.default)(this, SafeAnchor);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  SafeAnchor.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        href = _props.href,
	        onClick = _props.onClick;
	
	
	    if (disabled || isTrivialHref(href)) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (event.key === ' ') {
	      event.preventDefault();
	      this.handleClick(event);
	    }
	  };
	
	  SafeAnchor.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        disabled = _props2.disabled,
	        onKeyDown = _props2.onKeyDown,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'disabled', 'onKeyDown']);
	
	
	    if (isTrivialHref(props.href)) {
	      props.role = props.role || 'button';
	      // we want to make sure there is a href attribute on the node
	      // otherwise, the cursor incorrectly styled (except with role='button')
	      props.href = props.href || '#';
	    }
	
	    if (disabled) {
	      props.tabIndex = -1;
	      props.style = (0, _extends3.default)({ pointerEvents: 'none' }, props.style);
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	      onClick: this.handleClick,
	      onKeyDown: (0, _createChainedFunction2.default)(this.handleKeyDown, onKeyDown)
	    }));
	  };
	
	  return SafeAnchor;
	}(_react2.default.Component);
	
	SafeAnchor.propTypes = propTypes;
	SafeAnchor.defaultProps = defaultProps;
	
	exports.default = SafeAnchor;
	module.exports = exports['default'];

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.translateStyle = exports.AnimateGroup = exports.configBezier = exports.configSpring = undefined;
	
	var _Animate = __webpack_require__(1299);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	var _easing = __webpack_require__(1300);
	
	var _util = __webpack_require__(351);
	
	var _AnimateGroup = __webpack_require__(2871);
	
	var _AnimateGroup2 = _interopRequireDefault(_AnimateGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.configSpring = _easing.configSpring;
	exports.configBezier = _easing.configBezier;
	exports.AnimateGroup = _AnimateGroup2.default;
	exports.translateStyle = _util.translateStyle;
	exports.default = _Animate2.default;

/***/ },
/* 104 */
[3521, 1372],
/* 105 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {function redirect(url) {
	  global.window.location = url;
	}
	
	function getDocument() {
	  return global.window.document;
	}
	
	function getWindow() {
	  return global.window;
	}
	
	module.exports = {
	  redirect: redirect,
	  getDocument: getDocument,
	  getWindow: getWindow
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 106 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var rowStyle = {
	  width: '100%',
	  display: 'flex',
	  flexFlow: 'row wrap'
	};
	var colStyle = {
	  marginBottom: '16px'
	};
	var gutter = 16;
	var basicStyle = {
	  rowStyle: rowStyle,
	  colStyle: colStyle,
	  gutter: gutter
	};
	
	exports.default = basicStyle;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.2.0. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(1878)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var abs = Math.abs;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var max = Math.max;
	var min = Math.min;
	var sin = Math.sin;
	var sqrt = Math.sqrt;
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * cos(a0), r1 * sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * cos(a1), r0 * sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
	          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * sin(ap)),
	            p1 = asin(rp / r1 * sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * cos(a01),
	          y01 = r1 * sin(a01),
	          x10 = r0 * cos(a10),
	          y10 = r0 * sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * cos(a11),
	            y11 = r1 * sin(a11),
	            x00 = r0 * cos(a00),
	            y00 = r0 * sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
	              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = min(rc, (r0 - lc) / (kc - 1));
	          rc1 = min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [cos(a) * r, sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant(0),
	      y1 = y,
	      defined = constant(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant(0),
	      endAngle = constant(tau),
	      padAngle = constant(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function lineRadial(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var lineRadial$1 = function() {
	  return lineRadial(line().curve(curveRadialLinear));
	};
	
	var areaRadial = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var pointRadial = function(x, y) {
	  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
	};
	
	var slice = Array.prototype.slice;
	
	function linkSource(d) {
	  return d.source;
	}
	
	function linkTarget(d) {
	  return d.target;
	}
	
	function link(curve) {
	  var source = linkSource,
	      target = linkTarget,
	      x$$1 = x,
	      y$$1 = y,
	      context = null;
	
	  function link() {
	    var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
	    if (!context) context = buffer = d3Path.path();
	    curve(context, +x$$1.apply(this, (argv[0] = s, argv)), +y$$1.apply(this, argv), +x$$1.apply(this, (argv[0] = t, argv)), +y$$1.apply(this, argv));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  link.source = function(_) {
	    return arguments.length ? (source = _, link) : source;
	  };
	
	  link.target = function(_) {
	    return arguments.length ? (target = _, link) : target;
	  };
	
	  link.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), link) : x$$1;
	  };
	
	  link.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), link) : y$$1;
	  };
	
	  link.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), link) : context;
	  };
	
	  return link;
	}
	
	function curveHorizontal(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
	}
	
	function curveVertical(context, x0, y0, x1, y1) {
	  context.moveTo(x0, y0);
	  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
	}
	
	function curveRadial$1(context, x0, y0, x1, y1) {
	  var p0 = pointRadial(x0, y0),
	      p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
	      p2 = pointRadial(x1, y0),
	      p3 = pointRadial(x1, y1);
	  context.moveTo(p0[0], p0[1]);
	  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
	}
	
	function linkHorizontal() {
	  return link(curveHorizontal);
	}
	
	function linkVertical() {
	  return link(curveVertical);
	}
	
	function linkRadial() {
	  var l = link(curveRadial$1);
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	  return l;
	}
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant(circle),
	      size = constant(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = ((function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	}))(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = ((function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	}))(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = ((function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	}))(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var diverging = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
	    for (yp = yn = 0, i = 0; i < n; ++i) {
	      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
	        d[0] = yp, d[1] = yp += dy;
	      } else if (dy < 0) {
	        d[1] = yn, d[0] = yn += dy;
	      } else {
	        d[0] = yp;
	      }
	    }
	  }
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.areaRadial = areaRadial;
	exports.radialArea = areaRadial;
	exports.lineRadial = lineRadial$1;
	exports.radialLine = lineRadial$1;
	exports.pointRadial = pointRadial;
	exports.linkHorizontal = linkHorizontal;
	exports.linkVertical = linkVertical;
	exports.linkRadial = linkRadial;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetDiverging = diverging;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = void 0;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.validateMetadata = validateMetadata;
	exports.getExtPrefix = getExtPrefix;
	
	var _semverCompare = __webpack_require__(3242);
	
	var _semverCompare2 = _interopRequireDefault(_semverCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Added "possibleLengths" and renamed
	// "country_phone_code_to_countries" to "country_calling_codes".
	var V2 = '1.0.18';
	
	// Added "idd_prefix" and "default_idd_prefix".
	var V3 = '1.2.0';
	
	var DEFAULT_EXT_PREFIX = ' ext. ';
	
	var Metadata = function () {
		function Metadata(metadata) {
			_classCallCheck(this, Metadata);
	
			validateMetadata(metadata);
	
			this.metadata = metadata;
	
			this.v1 = !metadata.version;
			this.v2 = metadata.version !== undefined && (0, _semverCompare2.default)(metadata.version, V3) === -1;
			this.v3 = metadata.version !== undefined; // && compare(metadata.version, V4) === -1
		}
	
		_createClass(Metadata, [{
			key: 'hasCountry',
			value: function hasCountry(country) {
				return this.metadata.countries[country] !== undefined;
			}
		}, {
			key: 'country',
			value: function country(_country) {
				if (!_country) {
					this._country = undefined;
					this.country_metadata = undefined;
					return this;
				}
	
				if (!this.hasCountry(_country)) {
					throw new Error('Unknown country: ' + _country);
				}
	
				this._country = _country;
				this.country_metadata = this.metadata.countries[_country];
				return this;
			}
		}, {
			key: 'countryCallingCode',
			value: function countryCallingCode() {
				return this.country_metadata[0];
			}
		}, {
			key: 'IDDPrefix',
			value: function IDDPrefix() {
				if (this.v1 || this.v2) return;
				return this.country_metadata[1];
			}
		}, {
			key: 'defaultIDDPrefix',
			value: function defaultIDDPrefix() {
				if (this.v1 || this.v2) return;
				return this.country_metadata[12];
			}
		}, {
			key: 'nationalNumberPattern',
			value: function nationalNumberPattern() {
				if (this.v1 || this.v2) return this.country_metadata[1];
				return this.country_metadata[2];
			}
		}, {
			key: 'possibleLengths',
			value: function possibleLengths() {
				if (this.v1) return;
				return this.country_metadata[this.v2 ? 2 : 3];
			}
		}, {
			key: 'formats',
			value: function formats() {
				var _this = this;
	
				var formats = this.country_metadata[this.v1 ? 2 : this.v2 ? 3 : 4] || [];
				return formats.map(function (_) {
					return new Format(_, _this);
				});
			}
		}, {
			key: 'nationalPrefix',
			value: function nationalPrefix() {
				return this.country_metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
			}
		}, {
			key: 'nationalPrefixFormattingRule',
			value: function nationalPrefixFormattingRule() {
				return this.country_metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
			}
		}, {
			key: 'nationalPrefixForParsing',
			value: function nationalPrefixForParsing() {
				// If `national_prefix_for_parsing` is not set explicitly,
				// then infer it from `national_prefix` (if any)
				return this.country_metadata[this.v1 ? 5 : this.v2 ? 6 : 7] || this.nationalPrefix();
			}
		}, {
			key: 'nationalPrefixTransformRule',
			value: function nationalPrefixTransformRule() {
				return this.country_metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
			}
		}, {
			key: 'nationalPrefixIsOptionalWhenFormatting',
			value: function nationalPrefixIsOptionalWhenFormatting() {
				return !!this.country_metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
			}
		}, {
			key: 'leadingDigits',
			value: function leadingDigits() {
				return this.country_metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
			}
		}, {
			key: 'types',
			value: function types() {
				return this.country_metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
			}
		}, {
			key: 'hasTypes',
			value: function hasTypes() {
				// Versions 1.2.0 - 1.2.4: can be `[]`.
				/* istanbul ignore next */
				if (this.types() && this.types().length === 0) {
					return false;
				}
				// Versions <= 1.2.4: can be `undefined`.
				// Version >= 1.2.5: can be `0`.
				return !!this.types();
			}
		}, {
			key: 'type',
			value: function type(_type) {
				if (this.hasTypes() && getType(this.types(), _type)) {
					return new Type(getType(this.types(), _type), this);
				}
			}
		}, {
			key: 'ext',
			value: function ext() {
				if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
				return this.country_metadata[13] || DEFAULT_EXT_PREFIX;
			}
		}, {
			key: 'countryCallingCodes',
			value: function countryCallingCodes() {
				if (this.v1) return this.metadata.country_phone_code_to_countries;
				return this.metadata.country_calling_codes;
			}
	
			// Formatting information for regions which share
			// a country calling code is contained by only one region
			// for performance reasons. For example, for NANPA region
			// ("North American Numbering Plan Administration",
			//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
			// it will be contained in the metadata for `US`.
			//
			// `country_calling_code` is always valid.
			// But the actual country may not necessarily be part of the metadata.
			//
	
		}, {
			key: 'chooseCountryByCountryCallingCode',
			value: function chooseCountryByCountryCallingCode(country_calling_code) {
				var country = this.countryCallingCodes()[country_calling_code][0];
	
				// Do not want to test this case.
				// (custom metadata, not all countries).
				/* istanbul ignore else */
				if (this.hasCountry(country)) {
					this.country(country);
				}
			}
		}, {
			key: 'selectedCountry',
			value: function selectedCountry() {
				return this._country;
			}
		}]);
	
		return Metadata;
	}();
	
	exports.default = Metadata;
	
	var Format = function () {
		function Format(format, metadata) {
			_classCallCheck(this, Format);
	
			this._format = format;
			this.metadata = metadata;
		}
	
		_createClass(Format, [{
			key: 'pattern',
			value: function pattern() {
				return this._format[0];
			}
		}, {
			key: 'format',
			value: function format() {
				return this._format[1];
			}
		}, {
			key: 'leadingDigitsPatterns',
			value: function leadingDigitsPatterns() {
				return this._format[2] || [];
			}
		}, {
			key: 'nationalPrefixFormattingRule',
			value: function nationalPrefixFormattingRule() {
				return this._format[3] || this.metadata.nationalPrefixFormattingRule();
			}
		}, {
			key: 'nationalPrefixIsOptionalWhenFormatting',
			value: function nationalPrefixIsOptionalWhenFormatting() {
				return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormatting();
			}
		}, {
			key: 'nationalPrefixIsMandatoryWhenFormatting',
			value: function nationalPrefixIsMandatoryWhenFormatting() {
				// National prefix is omitted if there's no national prefix formatting rule
				// set for this country, or when the national prefix formatting rule
				// contains no national prefix itself, or when this rule is set but
				// national prefix is optional for this phone number format
				// (and it is not enforced explicitly)
				return this.nationalPrefixFormattingRule() &&
				// Check that national prefix formatting rule is not a dummy one.
				// Check that national prefix formatting rule actually has national prefix digit(s).
				this.usesNationalPrefix() &&
				// Or maybe national prefix is optional for this format
				!this.nationalPrefixIsOptionalWhenFormatting();
			}
	
			// Checks whether national prefix formatting rule contains national prefix
	
		}, {
			key: 'usesNationalPrefix',
			value: function usesNationalPrefix() {
				// Check that national prefix formatting rule is not a dummy one
				return this.nationalPrefixFormattingRule() !== '$1' &&
				// Check that national prefix formatting rule actually has national prefix digit(s)
				/\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''));
			}
		}, {
			key: 'internationalFormat',
			value: function internationalFormat() {
				return this._format[5] || this.format();
			}
		}]);
	
		return Format;
	}();
	
	var Type = function () {
		function Type(type, metadata) {
			_classCallCheck(this, Type);
	
			this.type = type;
			this.metadata = metadata;
		}
	
		_createClass(Type, [{
			key: 'pattern',
			value: function pattern() {
				if (this.metadata.v1) return this.type;
				return this.type[0];
			}
		}, {
			key: 'possibleLengths',
			value: function possibleLengths() {
				if (this.metadata.v1) return;
				return this.type[1] || this.metadata.possibleLengths();
			}
		}]);
	
		return Type;
	}();
	
	function getType(types, type) {
		switch (type) {
			case 'FIXED_LINE':
				return types[0];
			case 'MOBILE':
				return types[1];
			case 'TOLL_FREE':
				return types[2];
			case 'PREMIUM_RATE':
				return types[3];
			case 'PERSONAL_NUMBER':
				return types[4];
			case 'VOICEMAIL':
				return types[5];
			case 'UAN':
				return types[6];
			case 'PAGER':
				return types[7];
			case 'VOIP':
				return types[8];
			case 'SHARED_COST':
				return types[9];
		}
	}
	
	function validateMetadata(metadata) {
		if (!metadata) {
			throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
		}
	
		// `country_phone_code_to_countries` was renamed to
		// `country_calling_codes` in `1.0.18`.
		if (!is_object(metadata) || !is_object(metadata.countries) || !is_object(metadata.country_calling_codes) && !is_object(metadata.country_phone_code_to_countries)) {
			throw new Error('[libphonenumber-js] `metadata` argument was passed but it\'s not a valid metadata. Must be an object having `.countries` and `.country_calling_codes` child object properties. Got ' + (is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata) + '.');
		}
	}
	
	// Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	/* istanbul ignore next */
	var is_object = function is_object(_) {
		return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
	};
	
	// Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	/* istanbul ignore next */
	var type_of = function type_of(_) {
		return typeof _ === 'undefined' ? 'undefined' : _typeof(_);
	};
	
	function getExtPrefix(country, metadata) {
		return new Metadata(metadata).country(country).ext();
	}
	//# sourceMappingURL=metadata.js.map

/***/ },
/* 110 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 111 */
[3529, 24, 461],
/* 112 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 113 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var actionTypes = {
	  BLUR: 'rrf/blur',
	  CHANGE: 'rrf/change',
	  FOCUS: 'rrf/focus',
	  RESET: 'rrf/reset',
	  VALIDATE: 'rrf/validate',
	  SET_DIRTY: 'rrf/setDirty',
	  SET_ERRORS: 'rrf/setErrors',
	  SET_INITIAL: 'rrf/setInitial',
	  SET_PENDING: 'rrf/setPending',
	  SET_PRISTINE: 'rrf/setPristine',
	  SET_SUBMITTED: 'rrf/setSubmitted',
	  SET_SUBMIT_FAILED: 'rrf/setSubmitFailed',
	  SET_TOUCHED: 'rrf/setTouched',
	  SET_UNTOUCHED: 'rrf/setUntouched',
	  SET_VALIDITY: 'rrf/setValidity',
	  SET_VALIDATING: 'rrf/setValidating',
	  SET_FIELDS_VALIDITY: 'rrf/setFieldsValidity',
	  SET_VIEW_VALUE: 'rrf/setViewValue',
	  RESET_VALIDITY: 'rrf/resetValidity',
	  BATCH: 'rrf/batch',
	  NULL: null,
	  ADD_INTENT: 'rrf/addIntent',
	  CLEAR_INTENTS: 'rrf/clearIntents'
	};
	
	exports.default = actionTypes;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _splice = __webpack_require__(3102);
	
	var _splice2 = _interopRequireDefault(_splice);
	
	var _getIn = __webpack_require__(1358);
	
	var _getIn2 = _interopRequireDefault(_getIn);
	
	var _setIn = __webpack_require__(3101);
	
	var _setIn2 = _interopRequireDefault(_setIn);
	
	var _deepEqual = __webpack_require__(3099);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deleteIn = __webpack_require__(3100);
	
	var _deleteIn2 = _interopRequireDefault(_deleteIn);
	
	var _keys = __webpack_require__(1359);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn2.default,
	  setIn: _setIn2.default,
	  deepEqual: _deepEqual2.default,
	  deleteIn: _deleteIn2.default,
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys2.default,
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice2.default,
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	
	exports.default = structure;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.clones = exports.CONTEXT_KEY = exports.LOCAL_ATTR = exports.SC_ATTR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BrowserStyleSheet = __webpack_require__(3262);
	
	var _BrowserStyleSheet2 = _interopRequireDefault(_BrowserStyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(376);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SC_ATTR = exports.SC_ATTR = 'data-styled-components';
	var LOCAL_ATTR = exports.LOCAL_ATTR = 'data-styled-components-is-local';
	var CONTEXT_KEY = exports.CONTEXT_KEY = '__styled-components-stylesheet__';
	
	/* eslint-disable flowtype/object-type-delimiter */
	
	/* eslint-enable flowtype/object-type-delimiter */
	
	var instance = null;
	// eslint-disable-next-line no-use-before-define
	var clones = exports.clones = [];
	
	var StyleSheet = function () {
	  function StyleSheet(tagConstructor) {
	    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    _classCallCheck(this, StyleSheet);
	
	    this.hashes = {};
	    this.deferredInjections = {};
	    this.stylesCacheable = typeof document !== 'undefined';
	
	    this.tagConstructor = tagConstructor;
	    this.tags = tags;
	    this.names = names;
	    this.constructComponentTagMap();
	  }
	  // helper for `ComponentStyle` to know when it cache static styles.
	  // staticly styled-component can not safely cache styles on the server
	  // without all `ComponentStyle` instances saving a reference to the
	  // the styleSheet instance they last rendered with,
	  // or listening to creation / reset events. otherwise you might create
	  // a component with one stylesheet and render it another api response
	  // with another, losing styles on from your server-side render.
	
	
	  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
	    var _this = this;
	
	    this.componentTags = {};
	
	    this.tags.forEach(function (tag) {
	      Object.keys(tag.components).forEach(function (componentId) {
	        _this.componentTags[componentId] = tag;
	      });
	    });
	  };
	
	  /* Best level of caching—get the name from the hash straight away. */
	
	
	  StyleSheet.prototype.getName = function getName(hash) {
	    return this.hashes[hash.toString()];
	  };
	
	  /* Second level of caching—if the name is already in the dom, don't
	   * inject anything and record the hash for getName next time. */
	
	
	  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
	    if (!this.names[name]) return false;
	
	    this.hashes[hash.toString()] = name;
	    return true;
	  };
	
	  /* Third type of caching—don't inject components' componentId twice. */
	
	
	  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
	    return !!this.componentTags[componentId];
	  };
	
	  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
	    if (this === instance) {
	      clones.forEach(function (clone) {
	        clone.deferredInject(componentId, isLocal, css);
	      });
	    }
	
	    this.getOrCreateTag(componentId, isLocal);
	    this.deferredInjections[componentId] = css;
	  };
	
	  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
	    if (this === instance) {
	      clones.forEach(function (clone) {
	        clone.inject(componentId, isLocal, css);
	      });
	    }
	
	    var tag = this.getOrCreateTag(componentId, isLocal);
	
	    var deferredInjection = this.deferredInjections[componentId];
	    if (deferredInjection) {
	      tag.inject(componentId, deferredInjection);
	      delete this.deferredInjections[componentId];
	    }
	
	    tag.inject(componentId, css, name);
	
	    if (hash && name) {
	      this.hashes[hash.toString()] = name;
	    }
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    return this.tags.map(function (tag, i) {
	      return tag.toReactElement('sc-' + i);
	    });
	  };
	
	  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
	    var existingTag = this.componentTags[componentId];
	    if (existingTag) {
	      return existingTag;
	    }
	
	    var lastTag = this.tags[this.tags.length - 1];
	    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
	    this.componentTags[componentId] = componentTag;
	    componentTag.addComponent(componentId);
	    return componentTag;
	  };
	
	  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
	    var newTag = this.tagConstructor(isLocal);
	    this.tags.push(newTag);
	    return newTag;
	  };
	
	  StyleSheet.reset = function reset(isServer) {
	    instance = StyleSheet.create(isServer);
	  };
	
	  /* We can make isServer totally implicit once Jest 20 drops and we
	   * can change environment on a per-test basis. */
	
	
	  StyleSheet.create = function create() {
	    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';
	
	    return (isServer ? _ServerStyleSheet2.default : _BrowserStyleSheet2.default).create();
	  };
	
	  StyleSheet.clone = function clone(oldSheet) {
	    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
	      return tag.clone();
	    }), _extends({}, oldSheet.names));
	
	    newSheet.hashes = _extends({}, oldSheet.hashes);
	    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
	    clones.push(newSheet);
	
	    return newSheet;
	  };
	
	  _createClass(StyleSheet, null, [{
	    key: 'instance',
	    get: function get() {
	      return instance || (instance = StyleSheet.create());
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports.default = StyleSheet;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _en_US = __webpack_require__(1170);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	var _en_US3 = __webpack_require__(381);
	
	var _en_US4 = _interopRequireDefault(_en_US3);
	
	var _en_US5 = __webpack_require__(387);
	
	var _en_US6 = _interopRequireDefault(_en_US5);
	
	var _en_US7 = __webpack_require__(584);
	
	var _en_US8 = _interopRequireDefault(_en_US7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	    locale: 'en',
	    Pagination: _en_US2['default'],
	    DatePicker: _en_US4['default'],
	    TimePicker: _en_US6['default'],
	    Calendar: _en_US8['default'],
	    Table: {
	        filterTitle: 'Filter menu',
	        filterConfirm: 'OK',
	        filterReset: 'Reset',
	        emptyText: 'No data',
	        selectAll: 'Select current page',
	        selectInvert: 'Invert current page'
	    },
	    Modal: {
	        okText: 'OK',
	        cancelText: 'Cancel',
	        justOkText: 'OK'
	    },
	    Popconfirm: {
	        okText: 'OK',
	        cancelText: 'Cancel'
	    },
	    Transfer: {
	        titles: ['', ''],
	        notFoundContent: 'Not Found',
	        searchPlaceholder: 'Search here',
	        itemUnit: 'item',
	        itemsUnit: 'items'
	    },
	    Select: {
	        notFoundContent: 'Not Found'
	    },
	    Upload: {
	        uploading: 'Uploading...',
	        removeFile: 'Remove file',
	        uploadError: 'Upload error',
	        previewFile: 'Preview file'
	    }
	};

/***/ },
/* 117 */
/***/ function(module, exports) {

	var toString = Object.prototype.toString;
	
	function attribute(o, attr, type, text) {
	  type = type === 'array' ? 'object' : type;
	  if (o && typeof o[attr] !== type) {
	    throw new Error(text);
	  }
	}
	
	function variable(o, type, text) {
	  if (typeof o !== type) {
	    throw new Error(text);
	  }
	}
	
	function value(o, values, text) {
	  if (values.indexOf(o) === -1) {
	    throw new Error(text);
	  }
	}
	
	function check(o, config, attributes) {
	  if (!config.optional || o) {
	    variable(o, config.type, config.message);
	  }
	  if (config.type === 'object' && attributes) {
	    var keys = Object.keys(attributes);
	
	    for (var index = 0; index < keys.length; index++) {
	      var a = keys[index];
	      if (!attributes[a].optional || o[a]) {
	        if (!attributes[a].condition || attributes[a].condition(o)) {
	          attribute(o, a, attributes[a].type, attributes[a].message);
	          if (attributes[a].values) {
	            value(o[a], attributes[a].values, attributes[a].value_message);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Wrap `Array.isArray` Polyfill for IE9
	 * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
	 *
	 * @param {Array} array
	 * @private
	 */
	function isArray(array) {
	  if (this.supportsIsArray()) {
	    return Array.isArray(array);
	  }
	
	  return toString.call(array) === '[object Array]';
	}
	
	function supportsIsArray() {
	  return Array.isArray != null;
	}
	
	module.exports = {
	  check: check,
	  attribute: attribute,
	  variable: variable,
	  value: value,
	  isArray: isArray,
	  supportsIsArray: supportsIsArray
	};


/***/ },
/* 118 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getView = getView;
	function getView(width) {
	  var newView = 'MobileView';
	  if (width > 1220) {
	    newView = 'DesktopView';
	  } else if (width > 767) {
	    newView = 'TabView';
	  }
	  return newView;
	}
	var actions = {
	  COLLPSE_CHANGE: 'COLLPSE_CHANGE',
	  COLLPSE_OPEN_DRAWER: 'COLLPSE_OPEN_DRAWER',
	  CHANGE_OPEN_KEYS: 'CHANGE_OPEN_KEYS',
	  TOGGLE_ALL: 'TOGGLE_ALL',
	  CHANGE_CURRENT: 'CHANGE_CURRENT',
	  SET_CURRENT_APP: 'SET_CURRENT_APP',
	  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
	
	  toggleCollapsed: function toggleCollapsed() {
	    return {
	      type: actions.COLLPSE_CHANGE
	    };
	  },
	  toggleAll: function toggleAll(width, height) {
	    var view = getView(width);
	    var collapsed = view !== 'DesktopView';
	    return {
	      type: actions.TOGGLE_ALL,
	      collapsed: collapsed,
	      view: view,
	      height: height
	    };
	  },
	  toggleOpenDrawer: function toggleOpenDrawer() {
	    return {
	      type: actions.COLLPSE_OPEN_DRAWER
	    };
	  },
	  changeOpenKeys: function changeOpenKeys(openKeys) {
	    return {
	      type: actions.CHANGE_OPEN_KEYS,
	      openKeys: openKeys
	    };
	  },
	  changeCurrent: function changeCurrent(current) {
	    return {
	      type: actions.CHANGE_CURRENT,
	      current: current
	    };
	  },
	
	  searchTermUpdated: function searchTermUpdated(searchTerm) {
	    return {
	      type: actions.SET_SEARCH_TERM,
	      searchTerm: searchTerm
	    };
	  },
	
	
	  appSelected: function appSelected(app, secondApp) {
	    console.log(' app action', app);
	    return {
	      type: actions.SET_CURRENT_APP,
	      app: app,
	      secondApp: secondApp
	    };
	  }
	
	  // searchTermUpdated: searchTerm => ({
	  //   type: actions.SET_SEARCH_TERM,
	  //   searchTerm,
	  // })
	
	};
	exports.default = actions;

/***/ },
/* 119 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 120 */
[3349, 143, 759, 410, 144],
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {};
	module.exports.Arc = __webpack_require__(1837);
	module.exports.Line = __webpack_require__(1838);
	module.exports.Point = __webpack_require__(1839);
	module.exports.Rectangle = __webpack_require__(1840);


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.3. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var define = function(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	};
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*";
	var reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*";
	var reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*";
	var reHex3 = /^#([0-9a-f]{3})$/;
	var reHex6 = /^#([0-9a-f]{6})$/;
	var reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$");
	var reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$");
	var reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$");
	var reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$");
	var reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$");
	var reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  toString: function() {
	    return this.rgb() + "";
	  }
	});
	
	function color(format) {
	  var m;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format])
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (0 <= this.r && this.r <= 255)
	        && (0 <= this.g && this.g <= 255)
	        && (0 <= this.b && this.b <= 255)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  toString: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "rgb(" : "rgba(")
	        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	var Kn = 18;
	var Xn = 0.950470;
	var Yn = 1;
	var Zn = 1.088830;
	var t0 = 4 / 29;
	var t1 = 6 / 29;
	var t2 = 3 * t1 * t1;
	var t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) {
	    var h = o.h * deg2rad;
	    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	  }
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var b = rgb2xyz(o.r),
	      a = rgb2xyz(o.g),
	      l = rgb2xyz(o.b),
	      x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	      y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	      z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    y = Yn * lab2xyz(y);
	    x = Xn * lab2xyz(x);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	      xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	      xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function xyz2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2xyz(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return labConvert(this).rgb();
	  }
	}));
	
	var A = -0.14861;
	var B = +1.78277;
	var C = -0.29227;
	var D = -0.90649;
	var E = +1.97294;
	var ED = E * D;
	var EB = E * B;
	var BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.rgb = rgb;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.hcl = hcl;
	exports.cubehelix = cubehelix;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 123 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 * @format
	 * 
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(1912);
	var BlockMapBuilder = __webpack_require__(225);
	var CharacterMetadata = __webpack_require__(71);
	var CompositeDraftDecorator = __webpack_require__(1913);
	var ContentBlock = __webpack_require__(148);
	var ContentState = __webpack_require__(422);
	var DefaultDraftBlockRenderMap = __webpack_require__(423);
	var DefaultDraftInlineStyle = __webpack_require__(911);
	var DraftEditor = __webpack_require__(1915);
	var DraftEditorBlock = __webpack_require__(912);
	var DraftEntity = __webpack_require__(296);
	var DraftModifier = __webpack_require__(66);
	var DraftEntityInstance = __webpack_require__(913);
	var EditorState = __webpack_require__(32);
	var KeyBindingUtil = __webpack_require__(424);
	var RichTextEditorUtil = __webpack_require__(916);
	var SelectionState = __webpack_require__(184);
	
	var convertFromDraftStateToRaw = __webpack_require__(1934);
	var convertFromHTMLToContentBlocks = __webpack_require__(917);
	var convertFromRawToDraftState = __webpack_require__(1935);
	var generateRandomKey = __webpack_require__(108);
	var getDefaultKeyBinding = __webpack_require__(918);
	var getVisibleSelectionRect = __webpack_require__(1958);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(1925);
	
	module.exports = DraftFeatureFlags;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This allows you to work with object hierarchies that have been frozen
	 * with Object.freeze().  "get" operations can use the normal JS syntax,
	 * but operations that modify the data will have to return partial copies of
	 * the structure. The portions of the structure that did not change will
	 * === their previous values.
	 *
	 * Inspired by clojure/mori and Immutable.js
	 */
	
	"use strict";
	
	var i = exports;
	
	// we only care about objects or arrays for now
	function weCareAbout(val) {
	  return null !== val &&
	    (Array.isArray(val) ||
	      // This will skip objects created with `new Foo()`
	      // and objects created with `Object.create(proto)`
	      // The benefit is ignoring DOM elements and event emitters,
	      // which are often circular.
	      isObjectLike(val));
	}
	
	function isObjectLike(val) {
	  return typeof val === "object" &&
	    val.constructor === Object &&
	    Object.getPrototypeOf(val) === Object.prototype;
	}
	
	
	function arrayClone(arr) {
	  var index = 0,
	    length = arr.length,
	    result = Array(length);
	
	  for (; index < length; index += 1) {
	    result[index] = arr[index];
	  }
	  return result;
	}
	
	function objClone(obj) {
	  var index = 0,
	    keys = Object.keys(obj),
	    length = keys.length,
	    key,
	    result = {};
	
	  for (; index < length; index += 1) {
	    key = keys[index];
	    result[key] = obj[key];
	  }
	  return result;
	}
	
	function clone(coll) {
	  if (Array.isArray(coll)) {
	    return arrayClone(coll);
	  } else {
	    return objClone(coll);
	  }
	}
	
	function freezeIfNeeded(coll) {
	  if (
	      weCareAbout(coll) &&
	      (
	        !Object.isFrozen(coll) &&
	        ("production") !== "production"
	      )) {
	    return baseFreeze(coll, []);
	  }
	  return coll;
	}
	
	function _freeze(coll) {
	  if (true) {
	    return coll;
	  }
	  if (typeof coll === "object") {
	    return Object.freeze(coll);
	  } else {
	    return coll;
	  }
	}
	
	function baseFreeze(coll, prevNodes) {
	  if (prevNodes.some(function (node) { return node === coll; })) {
	    throw new Error("object has a reference cycle");
	  }
	
	  Object.freeze(coll);
	  prevNodes.push(coll);
	  Object.keys(coll).forEach(function (key) {
	    var prop = coll[key];
	    if (weCareAbout(prop)) {
	      baseFreeze(prop, prevNodes);
	    }
	  });
	  prevNodes.pop();
	
	  return coll;
	}
	
	/**
	 * recrursively freeze an object and all its child objects
	 * @param  {Object|Array} coll
	 * @return {Object|Array}
	 */
	exports.freeze = function freeze(coll) {
	  if (true) {
	    return coll;
	  }
	  return baseFreeze(coll, []);
	};
	
	/**
	 * recursively un-freeze an object, by cloning frozen collections
	 * @param  {[type]} coll [description]
	 * @return {[type]}      [description]
	 */
	exports.thaw = function thaw(coll) {
	  if (weCareAbout(coll) && Object.isFrozen(coll)) {
	    var newColl = clone(coll);
	    Object.keys(newColl).forEach(function (key) {
	      newColl[key] = thaw(newColl[key]);
	    });
	    return newColl;
	  }
	  return coll;
	};
	
	/**
	 * set a value on an object or array
	 * @param  {Object|Array}  coll
	 * @param  {String|Number} key   Key or index
	 * @param  {Object}        value
	 * @return {Object|Array}        new object hierarchy with modifications
	 */
	exports.assoc = function assoc(coll, key, value) {
	  if (coll[key] === value) {
	    return _freeze(coll);
	  }
	
	  var newObj = clone(coll);
	
	  newObj[key] = freezeIfNeeded(value);
	
	  return _freeze(newObj);
	
	};
	exports.set = exports.assoc;
	
	/**
	 * un-set a value on an object or array
	 * @param  {Object|Array}  coll
	 * @param  {String|Number} key  Key or Index
	 * @return {Object|Array}       New object or array
	 */
	exports.dissoc = function dissoc(coll, key) {
	  var newObj = clone(coll);
	
	  delete newObj[key];
	
	  return _freeze(newObj);
	};
	exports.unset = exports.dissoc;
	
	/**
	 * set a value deep in a hierarchical structure
	 * @param  {Object|Array} coll
	 * @param  {Array}        path    A list of keys to traverse
	 * @param  {Object}       value
	 * @return {Object|Array}       new object hierarchy with modifications
	 */
	exports.assocIn = function assocIn(coll, path, value) {
	  var key0 = path[0];
	  if (path.length === 1) {
	    // simplest case is a 1-element array.  Just a simple assoc.
	    return i.assoc(coll, key0, value);
	  } else {
	    // break the problem down.  Assoc this object with the first key
	    // and the result of assocIn with the rest of the keys
	    return i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
	  }
	};
	exports.setIn = exports.assocIn;
	
	/**
	 * get an object from a hierachy based on an array of keys
	 * @param  {Object|Array} coll
	 * @param  {Array}        path    list of keys
	 * @return {Object}       value, or undefined
	 */
	function baseGet(coll, path) {
	  return (path || []).reduce(function (curr, key) {
	    if (!curr) { return; }
	    return curr[key];
	  }, coll);
	}
	
	exports.getIn = baseGet;
	
	/**
	 * Update a value in a hierarchy
	 * @param  {Object|Array}   coll
	 * @param  {Array}          path     list of keys
	 * @param  {Function} callback The existing value with be passed to this.
	 *                             Return the new value to set
	 * @return {Object|Array}      new object hierarchy with modifications
	 */
	exports.updateIn = function updateIn(coll, path, callback) {
	  var existingVal = baseGet(coll, path);
	  return i.assocIn(coll, path, callback(existingVal));
	};
	
	
	// generate wrappers for the mutative array methods
	["push", "unshift", "pop", "shift", "reverse", "sort"]
	.forEach(function (methodName) {
	  exports[methodName] = function (arr, val) {
	    var newArr = arrayClone(arr);
	
	    newArr[methodName](freezeIfNeeded(val));
	
	    return _freeze(newArr);
	  };
	
	  exports[methodName].displayName = "icepick." + methodName;
	});
	
	// splice is special because it is variadic
	exports.splice = function splice(arr/*, args*/) {
	  var newArr = arrayClone(arr),
	    args = rest(arguments).map(freezeIfNeeded);
	
	  newArr.splice.apply(newArr, args);
	
	  return _freeze(newArr);
	};
	
	// slice is non-mutative
	exports.slice = function slice(arr, arg1, arg2) {
	  var newArr = arr.slice(arg1, arg2);
	
	  return _freeze(newArr);
	};
	
	["map", "filter"].forEach(function (methodName) {
	  exports[methodName] = function (fn, arr) {
	    var newArr = arr[methodName](fn);
	
	    return _freeze(newArr);
	  };
	
	  exports[methodName].displayName = "icepick." + methodName;
	});
	
	exports.extend =
	exports.assign = function assign(/*...objs*/) {
	  var newObj = rest(arguments).reduce(singleAssign, arguments[0]);
	
	  return _freeze(newObj);
	};
	
	function singleAssign(obj1, obj2) {
	  return Object.keys(obj2).reduce(function (obj, key) {
	    return i.assoc(obj, key, obj2[key]);
	  }, obj1);
	}
	
	exports.merge = merge;
	function merge(target, source, resolver) {
	  if (target == null || source == null) {
	    return target;
	  }
	  return Object.keys(source).reduce(function (obj, key) {
	    var sourceVal = source[key];
	    var targetVal = obj[key];
	
	    var resolvedSourceVal =
	      resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
	
	    if (weCareAbout(sourceVal) && weCareAbout(targetVal)) {
	      // if they are both frozen and reference equal, assume they are deep equal
	      if ((
	            (Object.isFrozen(resolvedSourceVal) &&
	              Object.isFrozen(targetVal)) ||
	            ("production") === "production"
	          ) &&
	          resolvedSourceVal === targetVal) {
	        return obj;
	      }
	      if (Array.isArray(sourceVal)) {
	        return i.assoc(obj, key, resolvedSourceVal);
	      }
	      // recursively merge pairs of objects
	      return assocIfDifferent(obj, key,
	        merge(targetVal, resolvedSourceVal, resolver));
	    }
	
	    // primitive values, stuff with prototypes
	    return assocIfDifferent(obj, key, resolvedSourceVal);
	  }, target);
	}
	
	function assocIfDifferent(target, key, value) {
	  if (target[key] === value) {
	    return target;
	  }
	  return i.assoc(target, key, value);
	}
	
	function _slice(array, start) {
	  var begin = start || 0;
	  var len = array.length;
	  len -= begin;
	  len = len < 0 ? 0 : len;
	  var result = new Array(len);
	  for (var i = 0; i < len; i += 1) {
	    result[i] = array[i + begin];
	  }
	  return result;
	}
	
	
	function rest(args) {
	  return _slice(args, 1);
	}
	
	
	var chainProto = {
	  value: function value() {
	    return this.val;
	  },
	  thru: function thru(fn) {
	    this.val = freezeIfNeeded(fn(this.val));
	    return this;
	  }
	};
	
	Object.keys(exports).forEach(function (methodName) {
	  chainProto[methodName] = function (/*...args*/) {
	    var args = _slice(arguments);
	    args.unshift(this.val);
	    this.val = exports[methodName].apply(null, args);
	    return this;
	  };
	});
	
	exports.chain = function chain(val) {
	  var wrapped = Object.create(chainProto);
	  wrapped.val = val;
	  return wrapped;
	};
	
	// for testing
	exports._weCareAbout = weCareAbout;
	exports._slice = _slice;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_MAPPINGS = exports.MAX_LENGTH_COUNTRY_CODE = exports.MAX_LENGTH_FOR_NSN = exports.PLUS_CHARS = exports.VALID_PUNCTUATION = exports.VALID_DIGITS = exports.WHITESPACE = undefined;
	exports.parse_phone_number_digits = parse_phone_number_digits;
	exports.parse_national_number_and_country_calling_code = parse_national_number_and_country_calling_code;
	exports.matches_entirely = matches_entirely;
	exports.create_extension_pattern = create_extension_pattern;
	
	var _IDD = __webpack_require__(970);
	
	// `DASHES` will be right after the opening square bracket of the "character class"
	var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D';
	var SLASHES = '\uFF0F/';
	var DOTS = '\uFF0E.';
	var WHITESPACE = exports.WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000';
	var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]';
	// export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
	var TILDES = '~\u2053\u223C\uFF5E';
	
	// Digits accepted in phone numbers
	// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
	var VALID_DIGITS = exports.VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9';
	
	// Regular expression of acceptable punctuation found in phone numbers. This
	// excludes punctuation found as a leading character only. This consists of dash
	// characters, white space characters, full stops, slashes, square brackets,
	// parentheses and tildes. Full-width variants are also present.
	var VALID_PUNCTUATION = exports.VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES;
	
	var PLUS_CHARS = exports.PLUS_CHARS = '+\uFF0B';
	var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+');
	
	// The ITU says the maximum length should be 15,
	// but one can find longer numbers in Germany.
	var MAX_LENGTH_FOR_NSN = exports.MAX_LENGTH_FOR_NSN = 17;
	
	// The maximum length of the country calling code.
	var MAX_LENGTH_COUNTRY_CODE = exports.MAX_LENGTH_COUNTRY_CODE = 3;
	
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGIT_MAPPINGS = exports.DIGIT_MAPPINGS = {
		'0': '0',
		'1': '1',
		'2': '2',
		'3': '3',
		'4': '4',
		'5': '5',
		'6': '6',
		'7': '7',
		'8': '8',
		'9': '9',
		'\uFF10': '0', // Fullwidth digit 0
		'\uFF11': '1', // Fullwidth digit 1
		'\uFF12': '2', // Fullwidth digit 2
		'\uFF13': '3', // Fullwidth digit 3
		'\uFF14': '4', // Fullwidth digit 4
		'\uFF15': '5', // Fullwidth digit 5
		'\uFF16': '6', // Fullwidth digit 6
		'\uFF17': '7', // Fullwidth digit 7
		'\uFF18': '8', // Fullwidth digit 8
		'\uFF19': '9', // Fullwidth digit 9
		'\u0660': '0', // Arabic-indic digit 0
		'\u0661': '1', // Arabic-indic digit 1
		'\u0662': '2', // Arabic-indic digit 2
		'\u0663': '3', // Arabic-indic digit 3
		'\u0664': '4', // Arabic-indic digit 4
		'\u0665': '5', // Arabic-indic digit 5
		'\u0666': '6', // Arabic-indic digit 6
		'\u0667': '7', // Arabic-indic digit 7
		'\u0668': '8', // Arabic-indic digit 8
		'\u0669': '9', // Arabic-indic digit 9
		'\u06F0': '0', // Eastern-Arabic digit 0
		'\u06F1': '1', // Eastern-Arabic digit 1
		'\u06F2': '2', // Eastern-Arabic digit 2
		'\u06F3': '3', // Eastern-Arabic digit 3
		'\u06F4': '4', // Eastern-Arabic digit 4
		'\u06F5': '5', // Eastern-Arabic digit 5
		'\u06F6': '6', // Eastern-Arabic digit 6
		'\u06F7': '7', // Eastern-Arabic digit 7
		'\u06F8': '8', // Eastern-Arabic digit 8
		'\u06F9': '9' // Eastern-Arabic digit 9
	
	
		/**
	  * Drops all punctuation leaving only digits and the leading `+` sign (if any).
	  * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
	  *
	  * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	  *
	  * @param  {string} number
	  * @return {string}
	  */
	};function parse_phone_number_digits(number) {
		return (LEADING_PLUS_CHARS_PATTERN.test(number) ? '+' : '') + drop_and_substitute_characters(number, DIGIT_MAPPINGS);
	}
	
	// Parses a formatted phone number
	// and returns `{ country_calling_code, number }`
	// where `number` is the national (significant) phone number.
	//
	// (aka `maybeExtractCountryPhoneCode`)
	//
	function parse_national_number_and_country_calling_code(number, country, metadata) {
		number = parse_phone_number_digits(number);
	
		if (!number) {
			return {};
		}
	
		// If this is not an international phone number,
		// then don't extract country phone code.
		if (number[0] !== '+') {
			// Convert an "out-of-country" dialing phone number
			// to a proper international phone number.
			var numberWithoutIDD = (0, _IDD.stripIDDPrefix)(number, country, metadata.metadata);
	
			// If an IDD prefix was stripped then
			// convert the number to international one.
			if (numberWithoutIDD && numberWithoutIDD !== number) {
				number = '+' + numberWithoutIDD;
			} else {
				return { number: number };
			}
		}
	
		// Fast abortion: country codes do not begin with a '0'
		if (number[1] === '0') {
			return {};
		}
	
		// The thing with country phone codes
		// is that they are orthogonal to each other
		// i.e. there's no such country phone code A
		// for which country phone code B exists
		// where B starts with A.
		// Therefore, while scanning digits,
		// if a valid country code is found,
		// that means that it is the country code.
		//
		var i = 2;
		while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
			var countryCallingCode = number.slice(1, i);
	
			if (metadata.countryCallingCodes()[countryCallingCode]) {
				return {
					countryCallingCode: countryCallingCode,
					number: number.slice(i)
				};
			}
	
			i++;
		}
	
		return {};
	}
	
	// Checks whether the entire input sequence can be matched
	// against the regular expression.
	function matches_entirely() {
		var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
		var regular_expression = arguments[1];
	
		if (typeof regular_expression === 'string') {
			regular_expression = '^(?:' + regular_expression + ')$';
		}
	
		var matched_groups = text.match(regular_expression);
		return matched_groups !== null && matched_groups[0].length === text.length;
	}
	
	// For any character not being part of `replacements`
	// it is removed from the phone number.
	function drop_and_substitute_characters(text, replacements) {
		var replaced = '';
	
		// Using `.split('')` to iterate through a string here
		// to avoid requiring `Symbol.iterator` polyfill.
		// `.split('')` is generally not safe for Unicode,
		// but in this particular case for `digits` it is safe.
		// for (const character of text)
		for (var _iterator = text.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var character = _ref;
	
			var replacement = replacements[character.toUpperCase()];
	
			if (replacement) {
				replaced += replacement;
			}
		}
	
		return replaced;
	}
	
	// The RFC 3966 format for extensions.
	var RFC3966_EXTN_PREFIX = ';ext=';
	
	// Pattern to capture digits used in an extension.
	// Places a maximum length of '7' for an extension.
	var CAPTURING_EXTN_DIGITS = '([' + VALID_DIGITS + ']{1,7})';
	
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	function create_extension_pattern(purpose) {
		// One-character symbols that can be used to indicate an extension.
		var single_extension_characters = 'x\uFF58#\uFF03~\uFF5E';
	
		switch (purpose) {
			// For parsing, we are slightly more lenient in our interpretation than for matching. Here we
			// allow "comma" and "semicolon" as possible extension indicators. When matching, these are
			case 'parsing':
				single_extension_characters = ',;' + single_extension_characters;
		}
	
		return RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + '[ \xA0\\t,]*' + '(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|' + '[' + single_extension_characters + ']|int|anexo|\uFF49\uFF4E\uFF54)' + '[:\\.\uFF0E]?[ \xA0\\t,-]*' + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + VALID_DIGITS + ']{1,5})#';
	}
	//# sourceMappingURL=common.js.map

/***/ },
/* 128 */
[3470, 189, 2385, 2411],
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(70)(module)))

/***/ },
/* 130 */
/***/ function(module, exports) {

	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof source !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i = 0, l = chunks.length; i < l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for (var i = 0; i < len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function (chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getTodayTime = getTodayTime;
	exports.getTitleString = getTitleString;
	exports.getTodayTimeStr = getTodayTimeStr;
	exports.getMonthName = getMonthName;
	exports.syncTime = syncTime;
	exports.getTimeConfig = getTimeConfig;
	exports.isTimeValidByConfig = isTimeValidByConfig;
	exports.isTimeValid = isTimeValid;
	exports.isAllowedDate = isAllowedDate;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultDisabledTime = {
	  disabledHours: function disabledHours() {
	    return [];
	  },
	  disabledMinutes: function disabledMinutes() {
	    return [];
	  },
	  disabledSeconds: function disabledSeconds() {
	    return [];
	  }
	};
	
	function getTodayTime(value) {
	  var today = (0, _moment2['default'])();
	  today.locale(value.locale()).utcOffset(value.utcOffset());
	  return today;
	}
	
	function getTitleString(value) {
	  return value.format('LL');
	}
	
	function getTodayTimeStr(value) {
	  var today = getTodayTime(value);
	  return getTitleString(today);
	}
	
	function getMonthName(month) {
	  var locale = month.locale();
	  var localeData = month.localeData();
	  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
	}
	
	function syncTime(from, to) {
	  if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
	  to.hour(from.hour());
	  to.minute(from.minute());
	  to.second(from.second());
	}
	
	function getTimeConfig(value, disabledTime) {
	  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
	  disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
	  return disabledTimeConfig;
	}
	
	function isTimeValidByConfig(value, disabledTimeConfig) {
	  var invalidTime = false;
	  if (value) {
	    var hour = value.hour();
	    var minutes = value.minute();
	    var seconds = value.second();
	    var disabledHours = disabledTimeConfig.disabledHours();
	    if (disabledHours.indexOf(hour) === -1) {
	      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
	      if (disabledMinutes.indexOf(minutes) === -1) {
	        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
	        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
	      } else {
	        invalidTime = true;
	      }
	    } else {
	      invalidTime = true;
	    }
	  }
	  return !invalidTime;
	}
	
	function isTimeValid(value, disabledTime) {
	  var disabledTimeConfig = getTimeConfig(value, disabledTime);
	  return isTimeValidByConfig(value, disabledTimeConfig);
	}
	
	function isAllowedDate(value, disabledDate, disabledTime) {
	  if (disabledDate) {
	    if (disabledDate(value)) {
	      return false;
	    }
	  }
	  if (disabledTime) {
	    if (!isTimeValid(value, disabledTime)) {
	      return false;
	    }
	  }
	  return true;
	}

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _contains = __webpack_require__(2637);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(2628);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(1194);
	
	var _getContainerRenderMixin = __webpack_require__(1198);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	var _Portal = __webpack_require__(1197);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var mixins = [];
	
	if (!IS_REACT_16) {
	  mixins.push((0, _getContainerRenderMixin2['default'])({
	    autoMount: false,
	
	    isVisible: function isVisible(instance) {
	      return instance.state.popupVisible;
	    },
	    isForceRender: function isForceRender(instance) {
	      return instance.props.forceRender;
	    },
	    getContainer: function getContainer(instance) {
	      return instance.getContainer();
	    }
	  }));
	}
	
	var Trigger = (0, _createReactClass2['default'])({
	  displayName: 'Trigger',
	  propTypes: {
	    children: _propTypes2['default'].any,
	    action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	    showAction: _propTypes2['default'].any,
	    hideAction: _propTypes2['default'].any,
	    getPopupClassNameFromAlign: _propTypes2['default'].any,
	    onPopupVisibleChange: _propTypes2['default'].func,
	    afterPopupVisibleChange: _propTypes2['default'].func,
	    popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	    popupStyle: _propTypes2['default'].object,
	    prefixCls: _propTypes2['default'].string,
	    popupClassName: _propTypes2['default'].string,
	    popupPlacement: _propTypes2['default'].string,
	    builtinPlacements: _propTypes2['default'].object,
	    popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    popupAnimation: _propTypes2['default'].any,
	    mouseEnterDelay: _propTypes2['default'].number,
	    mouseLeaveDelay: _propTypes2['default'].number,
	    zIndex: _propTypes2['default'].number,
	    focusDelay: _propTypes2['default'].number,
	    blurDelay: _propTypes2['default'].number,
	    getPopupContainer: _propTypes2['default'].func,
	    getDocument: _propTypes2['default'].func,
	    forceRender: _propTypes2['default'].bool,
	    destroyPopupOnHide: _propTypes2['default'].bool,
	    mask: _propTypes2['default'].bool,
	    maskClosable: _propTypes2['default'].bool,
	    onPopupAlign: _propTypes2['default'].func,
	    popupAlign: _propTypes2['default'].object,
	    popupVisible: _propTypes2['default'].bool,
	    maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    maskAnimation: _propTypes2['default'].string
	  },
	
	  mixins: mixins,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-trigger-popup',
	      getPopupClassNameFromAlign: returnEmptyString,
	      getDocument: returnDocument,
	      onPopupVisibleChange: noop,
	      afterPopupVisibleChange: noop,
	      onPopupAlign: noop,
	      popupClassName: '',
	      mouseEnterDelay: 0,
	      mouseLeaveDelay: 0.1,
	      focusDelay: 0,
	      blurDelay: 0.15,
	      popupStyle: {},
	      destroyPopupOnHide: false,
	      popupAlign: {},
	      defaultPopupVisible: false,
	      mask: false,
	      maskClosable: true,
	      action: [],
	      showAction: [],
	      hideAction: []
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    this.prevPopupVisible = popupVisible;
	
	    return {
	      popupVisible: popupVisible
	    };
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    this.prevPopupVisible = prevState.popupVisible;
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    this.fireEvents('onMouseEnter', e);
	    this.delaySetPopupVisible(true, this.props.mouseEnterDelay);
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    this.fireEvents('onMouseLeave', e);
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onPopupMouseEnter: function onPopupMouseEnter() {
	    this.clearDelayTimer();
	  },
	  onPopupMouseLeave: function onPopupMouseLeave(e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && this._component && this._component.getPopupDomNode && (0, _contains2['default'])(this._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    this.delaySetPopupVisible(false, this.props.mouseLeaveDelay);
	  },
	  onFocus: function onFocus(e) {
	    this.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    this.clearDelayTimer();
	    if (this.isFocusToShow()) {
	      this.focusTime = Date.now();
	      this.delaySetPopupVisible(true, this.props.focusDelay);
	    }
	  },
	  onMouseDown: function onMouseDown(e) {
	    this.fireEvents('onMouseDown', e);
	    this.preClickTime = Date.now();
	  },
	  onTouchStart: function onTouchStart(e) {
	    this.fireEvents('onTouchStart', e);
	    this.preTouchTime = Date.now();
	  },
	  onBlur: function onBlur(e) {
	    this.fireEvents('onBlur', e);
	    this.clearDelayTimer();
	    if (this.isBlurToHide()) {
	      this.delaySetPopupVisible(false, this.props.blurDelay);
	    }
	  },
	  onContextMenu: function onContextMenu(e) {
	    e.preventDefault();
	    this.fireEvents('onContextMenu', e);
	    this.setPopupVisible(true);
	  },
	  onContextMenuClose: function onContextMenuClose() {
	    if (this.isContextMenuToShow()) {
	      this.close();
	    }
	  },
	  onClick: function onClick(event) {
	    this.fireEvents('onClick', event);
	    // focus will trigger click
	    if (this.focusTime) {
	      var preTime = void 0;
	      if (this.preClickTime && this.preTouchTime) {
	        preTime = Math.min(this.preClickTime, this.preTouchTime);
	      } else if (this.preClickTime) {
	        preTime = this.preClickTime;
	      } else if (this.preTouchTime) {
	        preTime = this.preTouchTime;
	      }
	      if (Math.abs(preTime - this.focusTime) < 20) {
	        return;
	      }
	      this.focusTime = 0;
	    }
	    this.preClickTime = 0;
	    this.preTouchTime = 0;
	    event.preventDefault();
	    var nextVisible = !this.state.popupVisible;
	    if (this.isClickToHide() && !nextVisible || nextVisible && this.isClickToShow()) {
	      this.setPopupVisible(!this.state.popupVisible);
	    }
	  },
	  onDocumentClick: function onDocumentClick(event) {
	    if (this.props.mask && !this.props.maskClosable) {
	      return;
	    }
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(this);
	    var popupNode = this.getPopupDomNode();
	    if (!(0, _contains2['default'])(root, target) && !(0, _contains2['default'])(popupNode, target)) {
	      this.close();
	    }
	  },
	  handlePortalUpdate: function handlePortalUpdate() {
	    if (this.prevPopupVisible !== this.state.popupVisible) {
	      this.props.afterPopupVisibleChange(this.state.popupVisible);
	    }
	  },
	  getPopupDomNode: function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  },
	  getRootDomNode: function getRootDomNode() {
	    return (0, _reactDom.findDOMNode)(this);
	  },
	  getPopupClassNameFromAlign: function getPopupClassNameFromAlign(align) {
	    var className = [];
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        builtinPlacements = props.builtinPlacements,
	        prefixCls = props.prefixCls;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getPopupClassNameFromAlign)(builtinPlacements, prefixCls, align));
	    }
	    if (props.getPopupClassNameFromAlign) {
	      className.push(props.getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  },
	  getPopupAlign: function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  },
	  getComponent: function getComponent() {
	    var props = this.props,
	        state = this.state;
	
	    var mouseProps = {};
	    if (this.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = this.onPopupMouseEnter;
	    }
	    if (this.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = this.onPopupMouseLeave;
	    }
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: props.prefixCls,
	        destroyPopupOnHide: props.destroyPopupOnHide,
	        visible: state.popupVisible,
	        className: props.popupClassName,
	        action: props.action,
	        align: this.getPopupAlign(),
	        onAlign: props.onPopupAlign,
	        animation: props.popupAnimation,
	        getClassNameFromAlign: this.getPopupClassNameFromAlign
	      }, mouseProps, {
	        getRootDomNode: this.getRootDomNode,
	        style: props.popupStyle,
	        mask: props.mask,
	        zIndex: props.zIndex,
	        transitionName: props.popupTransitionName,
	        maskAnimation: props.maskAnimation,
	        maskTransitionName: props.maskTransitionName,
	        ref: this.savePopup
	      }),
	      typeof props.popup === 'function' ? props.popup() : props.popup
	    );
	  },
	  getContainer: function getContainer() {
	    var props = this.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(this)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  },
	  setPopupVisible: function setPopupVisible(popupVisible) {
	    this.clearDelayTimer();
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({
	          popupVisible: popupVisible
	        });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	  },
	  delaySetPopupVisible: function delaySetPopupVisible(visible, delayS) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible);
	    }
	  },
	  clearDelayTimer: function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  },
	  clearOutsideHandler: function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  },
	  createTwoChains: function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  },
	  isClickToShow: function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  },
	  isContextMenuToShow: function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  },
	  isClickToHide: function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  },
	  isMouseEnterToShow: function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  },
	  isMouseLeaveToHide: function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  },
	  isFocusToShow: function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  },
	  isBlurToHide: function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  },
	  forcePopupAlign: function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  },
	  fireEvents: function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  },
	  close: function close() {
	    this.setPopupVisible(false);
	  },
	  savePopup: function savePopup(node) {
	    if (IS_REACT_16) {
	      this._component = node;
	    }
	  },
	  render: function render() {
	    var popupVisible = this.state.popupVisible;
	
	    var props = this.props;
	    var children = props.children;
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return trigger;
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || props.forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        {
	          key: 'portal',
	          getContainer: this.getContainer,
	          didUpdate: this.handlePortalUpdate
	        },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  }
	});
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(8);
	var momentValidationWrapper = __webpack_require__(2756);
	var core = __webpack_require__(2755);
	
	moment.createFromInputFallback = function(config) {
	  config._d = new Date(config._i);
	};
	
	module.exports = {
	
	  momentObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : core.createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ },
/* 134 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var initialFieldState = {
	  focus: false,
	  pending: false,
	  pristine: true,
	  submitted: false,
	  submitFailed: false,
	  retouched: false,
	  touched: false,
	  valid: true,
	  validating: false,
	  validated: false,
	  validity: {},
	  errors: {},
	  intents: []
	};
	
	exports.default = initialFieldState;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _deepEqual = __webpack_require__(901);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _chartUtils = __webpack_require__(162);
	
	var _reactUtils = __webpack_require__(203);
	
	var _animation = __webpack_require__(38);
	
	var _theme = __webpack_require__(48);
	
	var _canvasWrapper = __webpack_require__(2930);
	
	var _canvasWrapper2 = _interopRequireDefault(_canvasWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ATTRIBUTES = ['x', 'y', 'radius', 'angle', 'color', 'fill', 'stroke', 'opacity', 'size'];
	
	var DEFAULT_MARGINS = {
	  left: 40,
	  right: 10,
	  top: 10,
	  bottom: 40
	};
	
	/**
	 * Remove parents from tree formatted data. deep-equal doesnt play nice with data
	 * that has circular structures, so we make every node single directional by pruning the parents.
	 * @param {Array} data - the data object to have circular deps resolved in
	 * @returns {Array} the sanitized data
	 */
	function cleanseData(data) {
	  return data.map(function (series) {
	    if (!Array.isArray(series)) {
	      return series;
	    }
	    return series.map(function (row) {
	      return _extends({}, row, { parent: null });
	    });
	  });
	}
	
	/**
	 * Wrapper on the deep-equal method for checking equality of next props vs current props
	 * @param {Object} scaleMixins - Scale object.
	 * @param {Object} nextScaleMixins - Scale object.
	 * @param {Boolean} hasTreeStructure - Whether or not to cleanse the data of possible cyclic structures
	 * @returns {Boolean} whether or not the two mixins objects are equal
	 */
	function checkIfMixinsAreEqual(nextScaleMixins, scaleMixins, hasTreeStructure) {
	  var newMixins = _extends({}, nextScaleMixins, {
	    _allData: hasTreeStructure ? cleanseData(nextScaleMixins._allData) : nextScaleMixins._allData
	  });
	  var oldMixins = _extends({}, scaleMixins, {
	    _allData: hasTreeStructure ? cleanseData(scaleMixins._allData) : scaleMixins._allData
	  });
	  // it's hard to say if this function is reasonable?
	  return (0, _deepEqual2.default)(newMixins, oldMixins);
	}
	
	var XYPlot = function (_React$Component) {
	  _inherits(XYPlot, _React$Component);
	
	  _createClass(XYPlot, null, [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        animation: _animation.AnimationPropType,
	        className: _propTypes2.default.string,
	        dontCheckIfEmpty: _propTypes2.default.bool,
	        height: _propTypes2.default.number.isRequired,
	        margin: _chartUtils.MarginPropType,
	        onClick: _propTypes2.default.func,
	        onDoubleClick: _propTypes2.default.func,
	        onMouseDown: _propTypes2.default.func,
	        onMouseEnter: _propTypes2.default.func,
	        onMouseLeave: _propTypes2.default.func,
	        onMouseMove: _propTypes2.default.func,
	        onWheel: _propTypes2.default.func,
	        stackBy: _propTypes2.default.oneOf(ATTRIBUTES),
	        style: _propTypes2.default.object,
	        width: _propTypes2.default.number.isRequired
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        className: ''
	      };
	    }
	  }]);
	
	  function XYPlot(props) {
	    _classCallCheck(this, XYPlot);
	
	    var _this = _possibleConstructorReturn(this, (XYPlot.__proto__ || Object.getPrototypeOf(XYPlot)).call(this, props));
	
	    _this._clickHandler = _this._clickHandler.bind(_this);
	    _this._doubleClickHandler = _this._doubleClickHandler.bind(_this);
	    _this._mouseDownHandler = _this._mouseDownHandler.bind(_this);
	    _this._mouseLeaveHandler = _this._mouseLeaveHandler.bind(_this);
	    _this._mouseEnterHandler = _this._mouseEnterHandler.bind(_this);
	    _this._mouseMoveHandler = _this._mouseMoveHandler.bind(_this);
	    _this._wheelHandler = _this._wheelHandler.bind(_this);
	    var stackBy = props.stackBy;
	
	    var children = (0, _seriesUtils.getSeriesChildren)(props.children);
	    var data = (0, _seriesUtils.getStackedData)(children, stackBy);
	    _this.state = {
	      scaleMixins: _this._getScaleMixins(data, props),
	      data: data
	    };
	    return _this;
	  }
	
	  _createClass(XYPlot, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _reactUtils.checkIfStyleSheetIsImported)();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var children = (0, _seriesUtils.getSeriesChildren)(nextProps.children);
	      var nextData = (0, _seriesUtils.getStackedData)(children, nextProps.stackBy);
	      var scaleMixins = this.state.scaleMixins;
	
	      var nextScaleMixins = this._getScaleMixins(nextData, nextProps);
	      if (!checkIfMixinsAreEqual(nextScaleMixins, scaleMixins, nextProps.hasTreeStructure)) {
	        this.setState({
	          scaleMixins: nextScaleMixins,
	          data: nextData
	        });
	      }
	    }
	
	    /**
	     * Trigger click related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Click event.
	     * @private
	     */
	
	  }, {
	    key: '_clickHandler',
	    value: function _clickHandler(event) {
	      var onClick = this.props.onClick;
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	
	    /**
	     * Trigger doule-click related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Double-click event.
	     * @private
	     */
	
	  }, {
	    key: '_doubleClickHandler',
	    value: function _doubleClickHandler(event) {
	      var onDoubleClick = this.props.onDoubleClick;
	
	      if (onDoubleClick) {
	        onDoubleClick(event);
	      }
	    }
	
	    /**
	     * Trigger mouse-down related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Mouse down event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseDownHandler',
	    value: function _mouseDownHandler(event) {
	      var _this2 = this;
	
	      var _props = this.props,
	          onMouseDown = _props.onMouseDown,
	          children = _props.children;
	
	      if (onMouseDown) {
	        onMouseDown(event);
	      }
	      var seriesChildren = (0, _seriesUtils.getSeriesChildren)(children);
	      seriesChildren.forEach(function (child, index) {
	        var component = _this2.refs['series' + index];
	        if (component && component.onParentMouseDown) {
	          component.onParentMouseDown(event);
	        }
	      });
	    }
	
	    /**
	     * Trigger movement-related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Mouse move event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseMoveHandler',
	    value: function _mouseMoveHandler(event) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          onMouseMove = _props2.onMouseMove,
	          children = _props2.children;
	
	      if (onMouseMove) {
	        onMouseMove(event);
	      }
	      var seriesChildren = (0, _seriesUtils.getSeriesChildren)(children);
	      seriesChildren.forEach(function (child, index) {
	        var component = _this3.refs['series' + index];
	        if (component && component.onParentMouseMove) {
	          component.onParentMouseMove(event);
	        }
	      });
	    }
	
	    /**
	     * Trigger onMouseLeave handler if it was passed in props.
	     * @param {Event} event Native event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseLeaveHandler',
	    value: function _mouseLeaveHandler(event) {
	      var onMouseLeave = this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave({ event: event });
	      }
	    }
	
	    /**
	     * Trigger onMouseEnter handler if it was passed in props.
	     * @param {Event} event Native event.
	     * @private
	     */
	
	  }, {
	    key: '_mouseEnterHandler',
	    value: function _mouseEnterHandler(event) {
	      var onMouseEnter = this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter({ event: event });
	      }
	    }
	
	    /**
	     * Trigger doule-click related callbacks if they are available.
	     * @param {React.SyntheticEvent} event Double-click event.
	     * @private
	     */
	
	  }, {
	    key: '_wheelHandler',
	    value: function _wheelHandler(event) {
	      var onWheel = this.props.onWheel;
	
	      if (onWheel) {
	        onWheel(event);
	      }
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var _getInnerDimensions = (0, _chartUtils.getInnerDimensions)(props, DEFAULT_MARGINS),
	          innerWidth = _getInnerDimensions.innerWidth,
	          innerHeight = _getInnerDimensions.innerHeight;
	
	      var colorRanges = ['color', 'fill', 'stroke'].reduce(function (acc, attr) {
	        var range = props[attr + 'Type'] === 'category' ? _theme.EXTENDED_DISCRETE_COLOR_RANGE : _theme.CONTINUOUS_COLOR_RANGE;
	        return _extends({}, acc, _defineProperty({}, attr + 'Range', range));
	      }, {});
	
	      return _extends({
	        xRange: [0, innerWidth],
	        yRange: [innerHeight, 0]
	      }, colorRanges, {
	        opacityType: _theme.OPACITY_TYPE,
	        sizeRange: _theme.SIZE_RANGE
	      });
	    }
	
	    /**
	     * Get the map of scales from the props, apply defaults to them and then pass
	     * them further.
	     * @param {Object} data Array of all data.
	     * @param {Object} props Props of the component.
	     * @returns {Object} Map of scale-related props.
	     * @private
	     */
	
	  }, {
	    key: '_getScaleMixins',
	    value: function _getScaleMixins(data, props) {
	      var _ref;
	
	      var filteredData = data.filter(function (d) {
	        return d;
	      });
	      var allData = (_ref = []).concat.apply(_ref, _toConsumableArray(filteredData));
	
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var optionalScaleProps = (0, _scalesUtils.getOptionalScaleProps)(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, optionalScaleProps, userScaleProps), allData, ATTRIBUTES);
	      var children = (0, _seriesUtils.getSeriesChildren)(props.children);
	      var zeroBaseProps = {};
	      var adjustBy = new Set();
	      var adjustWhat = new Set();
	      children.forEach(function (child, index) {
	        if (!child || !data[index]) {
	          return;
	        }
	        ATTRIBUTES.forEach(function (attr) {
	          var _child$type$getParent = child.type.getParentConfig(attr, child.props),
	              isDomainAdjustmentNeeded = _child$type$getParent.isDomainAdjustmentNeeded,
	              zeroBaseValue = _child$type$getParent.zeroBaseValue;
	
	          if (isDomainAdjustmentNeeded) {
	            adjustBy.add(attr);
	            adjustWhat.add(index);
	          }
	          if (zeroBaseValue) {
	            var specifiedDomain = props[attr + 'Domain'];
	            zeroBaseProps[attr + 'BaseValue'] = specifiedDomain ? specifiedDomain[0] : 0;
	          }
	        });
	      });
	      return _extends({}, defaultScaleProps, zeroBaseProps, userScaleProps, missingScaleProps, {
	        _allData: data,
	        _adjustBy: Array.from(adjustBy),
	        _adjustWhat: Array.from(adjustWhat),
	        _stackBy: props.stackBy
	      });
	    }
	
	    /**
	     * Checks if the plot is empty or not.
	     * Currently checks the data only.
	     * @returns {boolean} True for empty.
	     * @private
	     */
	
	  }, {
	    key: '_isPlotEmpty',
	    value: function _isPlotEmpty() {
	      var data = this.state.data;
	
	      return !data || !data.length || !data.some(function (series) {
	        return series && series.some(function (d) {
	          return d;
	        });
	      });
	    }
	
	    /**
	     * Prepare the child components (including series) for rendering.
	     * @returns {Array} Array of child components.
	     * @private
	     */
	
	  }, {
	    key: '_getClonedChildComponents',
	    value: function _getClonedChildComponents() {
	      var props = this.props;
	      var animation = this.props.animation;
	      var _state = this.state,
	          scaleMixins = _state.scaleMixins,
	          data = _state.data;
	
	      var dimensions = (0, _chartUtils.getInnerDimensions)(this.props, DEFAULT_MARGINS);
	      var children = _react2.default.Children.toArray(this.props.children);
	      var seriesProps = (0, _seriesUtils.getSeriesPropsFromChildren)(children);
	      var XYPlotValues = (0, _scalesUtils.getXYPlotValues)(props, children);
	      return children.map(function (child, index) {
	        var dataProps = null;
	        if (seriesProps[index]) {
	          // Get the index of the series in the list of props and retrieve
	          // the data property from it.
	          var seriesIndex = seriesProps[index].seriesIndex;
	
	          dataProps = { data: data[seriesIndex] };
	        }
	        return _react2.default.cloneElement(child, _extends({}, dimensions, {
	          animation: animation
	        }, seriesProps[index], scaleMixins, child.props, XYPlotValues[index], dataProps));
	      });
	    }
	  }, {
	    key: 'renderCanvasComponents',
	    value: function renderCanvasComponents(components, props) {
	      var componentsToRender = components.filter(function (c) {
	        return c && !c.type.requiresSVG && c.type.isCanvas;
	      });
	
	      if (componentsToRender.length === 0) {
	        return null;
	      }
	      var _componentsToRender$ = componentsToRender[0].props,
	          marginLeft = _componentsToRender$.marginLeft,
	          marginTop = _componentsToRender$.marginTop,
	          marginBottom = _componentsToRender$.marginBottom,
	          marginRight = _componentsToRender$.marginRight,
	          innerHeight = _componentsToRender$.innerHeight,
	          innerWidth = _componentsToRender$.innerWidth;
	
	      return _react2.default.createElement(
	        _canvasWrapper2.default,
	        {
	          innerHeight: innerHeight,
	          innerWidth: innerWidth,
	          marginLeft: marginLeft,
	          marginTop: marginTop,
	          marginBottom: marginBottom,
	          marginRight: marginRight
	        },
	        componentsToRender
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          dontCheckIfEmpty = _props3.dontCheckIfEmpty,
	          style = _props3.style,
	          width = _props3.width,
	          height = _props3.height;
	
	
	      if (!dontCheckIfEmpty && this._isPlotEmpty()) {
	        return _react2.default.createElement('div', {
	          className: 'rv-xy-plot ' + className,
	          style: _extends({
	            width: width + 'px',
	            height: height + 'px'
	          }, this.props.style) });
	      }
	      var components = this._getClonedChildComponents();
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: {
	            width: width + 'px',
	            height: height + 'px'
	          },
	          className: 'rv-xy-plot ' + className },
	        _react2.default.createElement(
	          'svg',
	          {
	            className: 'rv-xy-plot__inner',
	            width: width,
	            height: height,
	            style: style,
	            onClick: this._clickHandler,
	            onDoubleClick: this._doubleClickHandler,
	            onMouseDown: this._mouseDownHandler,
	            onMouseMove: this._mouseMoveHandler,
	            onMouseLeave: this._mouseLeaveHandler,
	            onMouseEnter: this._mouseEnterHandler,
	            onWheel: this._wheelHandler },
	          components.filter(function (c) {
	            return c && c.type.requiresSVG;
	          })
	        ),
	        this.renderCanvasComponents(components, this.props),
	        components.filter(function (c) {
	          return c && !c.type.requiresSVG && !c.type.isCanvas;
	        })
	      );
	    }
	  }]);
	
	  return XYPlot;
	}(_react2.default.Component);
	
	XYPlot.displayName = 'XYPlot';
	
	exports.default = XYPlot;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _sortBy2 = __webpack_require__(1010);
	
	var _sortBy3 = _interopRequireDefault(_sortBy2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _range2 = __webpack_require__(1008);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _throttle2 = __webpack_require__(464);
	
	var _throttle3 = _interopRequireDefault(_throttle2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(259);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(357);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Legend = __webpack_require__(533);
	
	var _Legend2 = _interopRequireDefault(_Legend);
	
	var _Curve = __webpack_require__(206);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Cross = __webpack_require__(1335);
	
	var _Cross2 = _interopRequireDefault(_Cross);
	
	var _Sector = __webpack_require__(360);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Dot = __webpack_require__(165);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Rectangle = __webpack_require__(207);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _CartesianAxis = __webpack_require__(1328);
	
	var _CartesianAxis2 = _interopRequireDefault(_CartesianAxis);
	
	var _Brush = __webpack_require__(1327);
	
	var _Brush2 = _interopRequireDefault(_Brush);
	
	var _DOMUtils = __webpack_require__(536);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _PureRender = __webpack_require__(22);
	
	var _Events = __webpack_require__(2993);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ORIENT_MAP = {
	  xAxis: ['bottom', 'top'],
	  yAxis: ['left', 'right']
	};
	
	var originCoordinate = { x: 0, y: 0 };
	
	var generateCategoricalChart = function generateCategoricalChart(_ref) {
	  var _class, _temp, _initialiseProps;
	
	  var chartName = _ref.chartName,
	      GraphicalChild = _ref.GraphicalChild,
	      _ref$eventType = _ref.eventType,
	      eventType = _ref$eventType === undefined ? 'axis' : _ref$eventType,
	      axisComponents = _ref.axisComponents,
	      legendContent = _ref.legendContent,
	      formatAxisMap = _ref.formatAxisMap,
	      defaultProps = _ref.defaultProps,
	      propTypes = _ref.propTypes;
	  var CategoricalChartWrapper = (_temp = _class = function (_Component) {
	    _inherits(CategoricalChartWrapper, _Component);
	
	    function CategoricalChartWrapper(props) {
	      _classCallCheck(this, CategoricalChartWrapper);
	
	      var _this = _possibleConstructorReturn(this, (CategoricalChartWrapper.__proto__ || Object.getPrototypeOf(CategoricalChartWrapper)).call(this, props));
	
	      _initialiseProps.call(_this);
	
	      var defaultState = _this.constructor.createDefaultState(props);
	      var updateId = 0;
	      _this.state = _extends({}, defaultState, { updateId: 0
	      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: props }, defaultState, { updateId: updateId })));
	
	      _this.uniqueChartId = (0, _isNil3.default)(props.id) ? (0, _DataUtils.uniqueId)('recharts') : props.id;
	
	      if (props.throttleDelay) {
	        _this.triggeredAfterMouseMove = (0, _throttle3.default)(_this.triggeredAfterMouseMove, props.throttleDelay);
	      }
	      return _this;
	    }
	
	    /* eslint-disable  react/no-did-mount-set-state */
	
	
	    /**
	     * Returns default, reset state for the categorical chart.
	     * @param {Object} props Props object to use when creating the default state
	     * @return {Object} Whole new state
	     */
	
	
	    _createClass(CategoricalChartWrapper, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.addListener();
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _props = this.props,
	            data = _props.data,
	            children = _props.children,
	            width = _props.width,
	            height = _props.height,
	            layout = _props.layout,
	            stackOffset = _props.stackOffset,
	            margin = _props.margin;
	        var updateId = this.state.updateId;
	
	
	        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !(0, _PureRender.shallowEqual)(nextProps.margin, margin)) {
	          var defaultState = this.constructor.createDefaultState(nextProps);
	          this.setState(_extends({}, defaultState, { updateId: updateId + 1
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({ props: nextProps }, defaultState, { updateId: updateId + 1 }))));
	        } else if (!(0, _ReactUtils.isChildrenEqual)(nextProps.children, children)) {
	          // update configuration in chilren
	          var hasGlobalData = !(0, _isNil3.default)(nextProps.data);
	          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
	          var _state = this.state,
	              dataStartIndex = _state.dataStartIndex,
	              dataEndIndex = _state.dataEndIndex;
	          // Don't update brush
	
	          var _defaultState = _extends({}, this.constructor.createDefaultState(nextProps), { dataEndIndex: dataEndIndex, dataStartIndex: dataStartIndex
	          });
	
	          this.setState(_extends({}, _defaultState, {
	            updateId: newUpdateId
	          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_extends({
	            props: nextProps
	          }, _defaultState, {
	            updateId: newUpdateId
	          }))));
	        }
	        // add syncId
	        if ((0, _isNil3.default)(this.props.syncId) && !(0, _isNil3.default)(nextProps.syncId)) {
	          this.addListener();
	        }
	        // remove syncId
	        if (!(0, _isNil3.default)(this.props.syncId) && (0, _isNil3.default)(nextProps.syncId)) {
	          this.removeListener();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (!(0, _isNil3.default)(this.props.syncId)) {
	          this.removeListener();
	        }
	        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
	          this.triggeredAfterMouseMove.cancel();
	        }
	      }
	      /**
	      * Get the configuration of all x-axis or y-axis
	      * @param  {Object} props          Latest props
	      * @param  {String} axisType       The type of axis
	      * @param  {Array}  graphicalItems The instances of item
	      * @param  {Object} stackGroups    The items grouped by axisId and stackId
	      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
	      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
	      * @return {Object}          Configuration
	      */
	
	    }, {
	      key: 'getAxisMap',
	      value: function getAxisMap(props, _ref2) {
	        var _ref2$axisType = _ref2.axisType,
	            axisType = _ref2$axisType === undefined ? 'xAxis' : _ref2$axisType,
	            AxisComp = _ref2.AxisComp,
	            graphicalItems = _ref2.graphicalItems,
	            stackGroups = _ref2.stackGroups,
	            dataStartIndex = _ref2.dataStartIndex,
	            dataEndIndex = _ref2.dataEndIndex;
	        var children = props.children;
	
	        var axisIdKey = axisType + 'Id';
	        // Get all the instance of Axis
	        var axes = (0, _ReactUtils.findAllByType)(children, AxisComp);
	
	        var axisMap = {};
	
	        if (axes && axes.length) {
	          axisMap = this.getAxisMapByAxes(props, { axes: axes, graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey,
	            stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        } else if (graphicalItems && graphicalItems.length) {
	          axisMap = this.getAxisMapByItems(props, {
	            Axis: AxisComp,
	            graphicalItems: graphicalItems, axisType: axisType, axisIdKey: axisIdKey, stackGroups: stackGroups, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex });
	        }
	
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of axis instance
	       * @param  {Object} props         Latest props
	       * @param {Array}  axes           The instance of axes
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}      Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByAxes',
	      value: function getAxisMapByAxes(props, _ref3) {
	        var _this2 = this;
	
	        var axes = _ref3.axes,
	            graphicalItems = _ref3.graphicalItems,
	            axisType = _ref3.axisType,
	            axisIdKey = _ref3.axisIdKey,
	            stackGroups = _ref3.stackGroups,
	            dataStartIndex = _ref3.dataStartIndex,
	            dataEndIndex = _ref3.dataEndIndex;
	        var layout = props.layout,
	            children = props.children,
	            stackOffset = props.stackOffset;
	
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	
	        // Eliminate duplicated axes
	        var axisMap = axes.reduce(function (result, child) {
	          var _child$props = child.props,
	              type = _child$props.type,
	              dataKey = _child$props.dataKey,
	              allowDataOverflow = _child$props.allowDataOverflow,
	              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
	              scale = _child$props.scale,
	              ticks = _child$props.ticks;
	
	          var axisId = child.props[axisIdKey];
	          var displayedData = _this2.constructor.getDisplayedData(props, {
	            graphicalItems: graphicalItems.filter(function (item) {
	              return item.props[axisIdKey] === axisId;
	            }),
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          });
	          var len = displayedData.length;
	
	          if (!result[axisId]) {
	            var domain = void 0,
	                duplicateDomain = void 0,
	                categoricalDomain = void 0;
	
	            if (dataKey) {
	              domain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, type);
	
	              if (type === 'category' && isCategorial) {
	                var duplicate = (0, _DataUtils.hasDuplicate)(domain);
	
	                if (allowDuplicatedCategory && duplicate) {
	                  duplicateDomain = domain;
	                  // When category axis has duplicated text, serial numbers are used to generate scale
	                  domain = (0, _range3.default)(0, len);
	                } else if (!allowDuplicatedCategory) {
	                  // remove duplicated category
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                }
	              } else if (type === 'category') {
	                if (!allowDuplicatedCategory) {
	                  domain = (0, _ChartUtils.parseDomainOfCategoryAxis)(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
	                    return finalDomain.indexOf(entry) >= 0 || entry === '' || (0, _isNil3.default)(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
	                  }, []);
	                } else {
	                  // eliminate undefined or null or empty string
	                  domain = domain.filter(function (entry) {
	                    return entry !== '' && !(0, _isNil3.default)(entry);
	                  });
	                }
	              } else if (type === 'number') {
	                var errorBarsDomain = (0, _ChartUtils.parseErrorBarsOfAxis)(displayedData, graphicalItems.filter(function (item) {
	                  return item.props[axisIdKey] === axisId && !item.props.hide;
	                }), dataKey, axisType);
	
	                if (errorBarsDomain) {
	                  domain = errorBarsDomain;
	                }
	              }
	
	              if (isCategorial && (type === 'number' || scale !== 'auto')) {
	                categoricalDomain = (0, _ChartUtils.getDomainOfDataByKey)(displayedData, dataKey, 'category');
	              }
	            } else if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
	              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
	              domain = stackOffset === 'expand' ? [0, 1] : (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	            } else {
	              domain = (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), type, true);
	            }
	            if (type === 'number') {
	              // To detect wether there is any reference lines whose props alwaysShow is true
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType, ticks);
	
	              if (child.props.domain) {
	                domain = (0, _ChartUtils.parseSpecifiedDomain)(child.props.domain, domain, allowDataOverflow);
	              }
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({}, child.props, {
	              axisType: axisType,
	              domain: domain,
	              categoricalDomain: categoricalDomain,
	              duplicateDomain: duplicateDomain,
	              originalDomain: child.props.domain,
	              isCategorial: isCategorial,
	              layout: layout
	            })));
	          }
	
	          return result;
	        }, {});
	        return axisMap;
	      }
	      /**
	       * Get the configuration of axis by the options of item,
	       * this kind of axis does not display in chart
	       * @param  {Object} props         Latest props
	       * @param  {Array} graphicalItems The instances of item
	       * @param  {ReactElement} Axis    Axis Component
	       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
	       * @param  {String} axisIdKey     The unique id of an axis
	       * @param  {Object} stackGroups   The items grouped by axisId and stackId
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @return {Object}               Configuration
	       */
	
	    }, {
	      key: 'getAxisMapByItems',
	      value: function getAxisMapByItems(props, _ref4) {
	        var graphicalItems = _ref4.graphicalItems,
	            Axis = _ref4.Axis,
	            axisType = _ref4.axisType,
	            axisIdKey = _ref4.axisIdKey,
	            stackGroups = _ref4.stackGroups,
	            dataStartIndex = _ref4.dataStartIndex,
	            dataEndIndex = _ref4.dataEndIndex;
	        var layout = props.layout,
	            children = props.children;
	
	        var displayedData = this.constructor.getDisplayedData(props, {
	          graphicalItems: graphicalItems, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex
	        });
	        var len = displayedData.length;
	        var isCategorial = (0, _ChartUtils.isCategorialAxis)(layout, axisType);
	        var index = -1;
	
	        // The default type of x-axis is category axis,
	        // The default contents of x-axis is the serial numbers of data
	        // The default type of y-axis is number axis
	        // The default contents of y-axis is the domain of data
	        var axisMap = graphicalItems.reduce(function (result, child) {
	          var axisId = child.props[axisIdKey];
	
	          if (!result[axisId]) {
	            index++;
	            var domain = void 0;
	
	            if (isCategorial) {
	              domain = (0, _range3.default)(0, len);
	            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
	              domain = (0, _ChartUtils.getDomainOfStackGroups)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            } else {
	              domain = (0, _ChartUtils.parseSpecifiedDomain)(Axis.defaultProps.domain, (0, _ChartUtils.getDomainOfItemsWithSameAxis)(displayedData, graphicalItems.filter(function (item) {
	                return item.props[axisIdKey] === axisId && !item.props.hide;
	              }), 'number'), Axis.defaultProps.allowDataOverflow);
	              domain = (0, _ChartUtils.detectReferenceElementsDomain)(children, domain, axisId, axisType);
	            }
	
	            return _extends({}, result, _defineProperty({}, axisId, _extends({
	              axisType: axisType
	            }, Axis.defaultProps, {
	              hide: true,
	              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
	              domain: domain,
	              originalDomain: Axis.defaultProps.domain,
	              isCategorial: isCategorial,
	              layout: layout
	              // specify scale when no Axis
	              // scale: isCategorial ? 'band' : 'linear',
	            })));
	          }
	
	          return result;
	        }, {});
	
	        return axisMap;
	      }
	    }, {
	      key: 'getActiveCoordinate',
	      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
	        var layout = this.props.layout;
	
	        var entry = tooltipTicks.find(function (tick) {
	          return tick && tick.index === activeIndex;
	        });
	
	        if (entry) {
	          if (layout === 'horizontal') {
	            return { x: entry.coordinate, y: rangeObj.y };
	          } else if (layout === 'vertical') {
	            return { x: rangeObj.x, y: entry.coordinate };
	          } else if (layout === 'centric') {
	            var _angle = entry.coordinate;
	            var _radius = rangeObj.radius;
	
	            return _extends({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle), {
	              angle: _angle, radius: _radius
	            });
	          }
	
	          var radius = entry.coordinate;
	          var angle = rangeObj.angle;
	
	          return _extends({}, rangeObj, (0, _PolarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle), {
	            angle: angle, radius: radius
	          });
	        }
	
	        return originCoordinate;
	      }
	      /**
	       * Get the information of mouse in chart, return null when the mouse is not in the chart
	       * @param  {Object} event    The event object
	       * @return {Object}          Mouse data
	       */
	
	    }, {
	      key: 'getMouseInfo',
	      value: function getMouseInfo(event) {
	        if (!this.container) {
	          return null;
	        }
	
	        var containerOffset = (0, _DOMUtils.getOffset)(this.container);
	        var e = (0, _DOMUtils.calculateChartCoordinate)(event, containerOffset);
	        var rangeObj = this.inRange(e.chartX, e.chartY);
	        if (!rangeObj) {
	          return null;
	        }
	
	        var _state2 = this.state,
	            xAxisMap = _state2.xAxisMap,
	            yAxisMap = _state2.yAxisMap;
	
	
	        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
	          var xScale = (0, _DataUtils.getAnyElementOfObject)(xAxisMap).scale;
	          var yScale = (0, _DataUtils.getAnyElementOfObject)(yAxisMap).scale;
	          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
	          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
	
	          return _extends({}, e, { xValue: xValue, yValue: yValue });
	        }
	
	        var _state3 = this.state,
	            ticks = _state3.orderedTooltipTicks,
	            axis = _state3.tooltipAxis,
	            tooltipTicks = _state3.tooltipTicks;
	
	        var pos = this.calculateTooltipPos(rangeObj);
	        var activeIndex = (0, _ChartUtils.calculateActiveTickIndex)(pos, ticks, tooltipTicks, axis);
	
	        if (activeIndex >= 0 && tooltipTicks) {
	          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
	          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
	          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
	
	          return _extends({}, e, {
	            activeTooltipIndex: activeIndex,
	            activeLabel: activeLabel, activePayload: activePayload, activeCoordinate: activeCoordinate
	          });
	        }
	
	        return null;
	      }
	      /**
	       * Get the content to be displayed in the tooltip
	       * @param  {Number} activeIndex    Active index of data
	       * @param  {String} activeLabel    Active label of data
	       * @return {Array}                 The content of tooltip
	       */
	
	    }, {
	      key: 'getTooltipContent',
	      value: function getTooltipContent(activeIndex, activeLabel) {
	        var _state4 = this.state,
	            graphicalItems = _state4.graphicalItems,
	            tooltipAxis = _state4.tooltipAxis;
	
	        var displayedData = this.constructor.getDisplayedData(this.props, this.state);
	
	        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
	          return null;
	        }
	
	        // get data by activeIndex when the axis don't allow duplicated category
	        return graphicalItems.reduce(function (result, child) {
	          var hide = child.props.hide;
	
	
	          if (hide) {
	            return result;
	          }
	
	          var _child$props2 = child.props,
	              dataKey = _child$props2.dataKey,
	              name = _child$props2.name,
	              unit = _child$props2.unit,
	              formatter = _child$props2.formatter,
	              data = _child$props2.data;
	
	          var payload = void 0;
	
	          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	            // graphic child has data props
	            payload = (0, _DataUtils.findEntryInArray)(data || displayedData, tooltipAxis.dataKey, activeLabel);
	          } else {
	            payload = displayedData[activeIndex];
	          }
	
	          if (!payload) {
	            return result;
	          }
	          return [].concat(_toConsumableArray(result), [_extends({}, (0, _ReactUtils.getPresentationAttributes)(child), {
	            dataKey: dataKey, unit: unit, formatter: formatter,
	            name: name || dataKey,
	            color: (0, _ChartUtils.getMainColorOfGraphicItem)(child),
	            value: (0, _ChartUtils.getValueByDataKey)(payload, dataKey),
	            payload: payload
	          })]);
	        }, []);
	      }
	    }, {
	      key: 'getFormatItems',
	      value: function getFormatItems(props, currentState) {
	        var _this3 = this;
	
	        var graphicalItems = currentState.graphicalItems,
	            stackGroups = currentState.stackGroups,
	            offset = currentState.offset,
	            updateId = currentState.updateId,
	            dataStartIndex = currentState.dataStartIndex,
	            dataEndIndex = currentState.dataEndIndex;
	        var barSize = props.barSize,
	            layout = props.layout,
	            barGap = props.barGap,
	            barCategoryGap = props.barCategoryGap,
	            globalMaxBarSize = props.maxBarSize;
	
	        var _getAxisNameByLayout = this.getAxisNameByLayout(layout),
	            numericAxisName = _getAxisNameByLayout.numericAxisName,
	            cateAxisName = _getAxisNameByLayout.cateAxisName;
	
	        var hasBar = this.constructor.hasBar(graphicalItems);
	        var sizeList = hasBar && (0, _ChartUtils.getBarSizeList)({ barSize: barSize, stackGroups: stackGroups });
	        var formatedItems = [];
	
	        graphicalItems.forEach(function (item, index) {
	          var displayedData = _this3.constructor.getDisplayedData(props, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex }, item);
	          var _item$props = item.props,
	              dataKey = _item$props.dataKey,
	              childMaxBarSize = _item$props.maxBarSize;
	
	          var numericAxisId = item.props[numericAxisName + 'Id'];
	          var cateAxisId = item.props[cateAxisName + 'Id'];
	          var axisObj = axisComponents.reduce(function (result, entry) {
	            var _extends4;
	
	            var axisMap = currentState[entry.axisType + 'Map'];
	            var id = item.props[entry.axisType + 'Id'];
	            var axis = axisMap && axisMap[id];
	
	            return _extends({}, result, (_extends4 = {}, _defineProperty(_extends4, entry.axisType, axis), _defineProperty(_extends4, entry.axisType + 'Ticks', (0, _ChartUtils.getTicksOfAxis)(axis)), _extends4));
	          }, {});
	          var cateAxis = axisObj[cateAxisName];
	          var cateTicks = axisObj[cateAxisName + 'Ticks'];
	          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, _ChartUtils.getStackedDataOfItem)(item, stackGroups[numericAxisId].stackGroups);
	          var bandSize = (0, _ChartUtils.getBandSizeOfAxis)(cateAxis, cateTicks);
	          var maxBarSize = (0, _isNil3.default)(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
	          var barPosition = hasBar && (0, _ChartUtils.getBarPosition)({
	            barGap: barGap, barCategoryGap: barCategoryGap, bandSize: bandSize, sizeList: sizeList[cateAxisId], maxBarSize: maxBarSize
	          });
	          var componsedFn = item && item.type && item.type.getComposedData;
	
	          if (componsedFn) {
	            var _extends5;
	
	            formatedItems.push({
	              props: _extends({}, componsedFn(_extends({}, axisObj, { displayedData: displayedData, props: props, dataKey: dataKey, item: item, bandSize: bandSize,
	                barPosition: barPosition, offset: offset, stackedData: stackedData, layout: layout, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex,
	                onItemMouseLeave: (0, _ChartUtils.combineEventHandlers)(_this3.handleItemMouseLeave, null, item.props.onMouseLeave),
	                onItemMouseEnter: (0, _ChartUtils.combineEventHandlers)(_this3.handleItemMouseEnter, null, item.props.onMouseEnter)
	              })), (_extends5 = {
	                key: item.key || 'item-' + index
	              }, _defineProperty(_extends5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_extends5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_extends5, 'animationId', updateId), _extends5)),
	              childIndex: (0, _ReactUtils.parseChildIndex)(item, props.children),
	              item: item
	            });
	          }
	        });
	
	        return formatedItems;
	      }
	    }, {
	      key: 'getCursorRectangle',
	      value: function getCursorRectangle() {
	        var layout = this.props.layout;
	        var _state5 = this.state,
	            activeCoordinate = _state5.activeCoordinate,
	            offset = _state5.offset,
	            tooltipAxisBandSize = _state5.tooltipAxisBandSize;
	
	        var halfSize = tooltipAxisBandSize / 2;
	
	        return {
	          stroke: 'none',
	          fill: '#ccc',
	          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
	          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
	          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
	          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
	        };
	      }
	    }, {
	      key: 'getCursorPoints',
	      value: function getCursorPoints() {
	        var layout = this.props.layout;
	        var _state6 = this.state,
	            activeCoordinate = _state6.activeCoordinate,
	            offset = _state6.offset;
	
	        var x1 = void 0,
	            y1 = void 0,
	            x2 = void 0,
	            y2 = void 0;
	
	        if (layout === 'horizontal') {
	          x1 = activeCoordinate.x;
	          x2 = x1;
	          y1 = offset.top;
	          y2 = offset.top + offset.height;
	        } else if (layout === 'vertical') {
	          y1 = activeCoordinate.y;
	          y2 = y1;
	          x1 = offset.left;
	          x2 = offset.left + offset.width;
	        } else if (!(0, _isNil3.default)(activeCoordinate.cx) || !(0, _isNil3.default)(activeCoordinate.cy)) {
	          if (layout === 'centric') {
	            var cx = activeCoordinate.cx,
	                cy = activeCoordinate.cy,
	                innerRadius = activeCoordinate.innerRadius,
	                outerRadius = activeCoordinate.outerRadius,
	                angle = activeCoordinate.angle;
	
	            var innerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
	            var outerPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
	            x1 = innerPoint.x;
	            y1 = innerPoint.y;
	            x2 = outerPoint.x;
	            y2 = outerPoint.y;
	          } else {
	            var _cx = activeCoordinate.cx,
	                _cy = activeCoordinate.cy,
	                radius = activeCoordinate.radius,
	                startAngle = activeCoordinate.startAngle,
	                endAngle = activeCoordinate.endAngle;
	
	            var startPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, startAngle);
	            var endPoint = (0, _PolarUtils.polarToCartesian)(_cx, _cy, radius, endAngle);
	
	            return {
	              points: [startPoint, endPoint],
	              cx: _cx, cy: _cy, radius: radius, startAngle: startAngle, endAngle: endAngle
	            };
	          }
	        }
	
	        return [{ x: x1, y: y1 }, { x: x2, y: y2 }];
	      }
	    }, {
	      key: 'getAxisNameByLayout',
	      value: function getAxisNameByLayout(layout) {
	        if (layout === 'horizontal') {
	          return { numericAxisName: 'yAxis', cateAxisName: 'xAxis' };
	        } else if (layout === 'vertical') {
	          return { numericAxisName: 'xAxis', cateAxisName: 'yAxis' };
	        } else if (layout === 'centric') {
	          return { numericAxisName: 'radiusAxis', cateAxisName: 'angleAxis' };
	        }
	
	        return { numericAxisName: 'angleAxis', cateAxisName: 'radiusAxis' };
	      }
	    }, {
	      key: 'calculateTooltipPos',
	      value: function calculateTooltipPos(rangeObj) {
	        var layout = this.props.layout;
	
	
	        if (layout === 'horizontal') {
	          return rangeObj.x;
	        }
	        if (layout === 'vertical') {
	          return rangeObj.y;
	        }
	        if (layout === 'centric') {
	          return rangeObj.angle;
	        }
	
	        return rangeObj.radius;
	      }
	    }, {
	      key: 'inRange',
	      value: function inRange(x, y) {
	        var layout = this.props.layout;
	
	
	        if (layout === 'horizontal' || layout === 'vertical') {
	          var offset = this.state.offset;
	
	          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
	
	          return isInRange ? { x: x, y: y } : null;
	        }
	
	        var _state7 = this.state,
	            angleAxisMap = _state7.angleAxisMap,
	            radiusAxisMap = _state7.radiusAxisMap;
	
	
	        if (angleAxisMap && radiusAxisMap) {
	          var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	
	          return (0, _PolarUtils.inRangeOfSector)({ x: x, y: y }, angleAxis);
	        }
	
	        return null;
	      }
	    }, {
	      key: 'parseEventsOfWrapper',
	      value: function parseEventsOfWrapper() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseMove: this.handleMouseMove,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchMove: this.handleTouchMove,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        } : {};
	        var outerEvents = (0, _ReactUtils.filterEventAttributes)(this.props, this.handleOuterEvent);
	
	        return _extends({}, outerEvents, tooltipEvents);
	      }
	      /**
	       * The AxisMaps are expensive to render on large data sets
	       * so provide the ability to store them in state and only update them when necessary
	       * they are dependent upon the start and end index of
	       * the brush so it's important that this method is called _after_
	       * the state is updated with any new start/end indices
	       *
	       * @param {Object} props          The props object to be used for updating the axismaps
	       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
	       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
	       * @param {Number} updateId       The update id
	       * @return {Object} state New state to set
	       */
	
	    }, {
	      key: 'updateStateOfAxisMapsOffsetAndStackGroups',
	      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref5) {
	        var _this4 = this;
	
	        var props = _ref5.props,
	            dataStartIndex = _ref5.dataStartIndex,
	            dataEndIndex = _ref5.dataEndIndex,
	            updateId = _ref5.updateId;
	
	        if (!(0, _ReactUtils.validateWidthHeight)({ props: props })) {
	          return null;
	        }
	
	        var children = props.children,
	            layout = props.layout,
	            stackOffset = props.stackOffset,
	            data = props.data,
	            reverseStackOrder = props.reverseStackOrder;
	
	        var _getAxisNameByLayout2 = this.getAxisNameByLayout(layout),
	            numericAxisName = _getAxisNameByLayout2.numericAxisName,
	            cateAxisName = _getAxisNameByLayout2.cateAxisName;
	
	        var graphicalItems = (0, _ReactUtils.findAllByType)(children, GraphicalChild);
	        var stackGroups = (0, _ChartUtils.getStackGroupsByAxisId)(data, graphicalItems, numericAxisName + 'Id', cateAxisName + 'Id', stackOffset, reverseStackOrder);
	        var axisObj = axisComponents.reduce(function (result, entry) {
	          var name = entry.axisType + 'Map';
	
	          return _extends({}, result, _defineProperty({}, name, _this4.getAxisMap(props, _extends({}, entry, {
	            graphicalItems: graphicalItems,
	            stackGroups: entry.axisType === numericAxisName && stackGroups,
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }))));
	        }, {});
	
	        var offset = this.calculateOffset(_extends({}, axisObj, { props: props, graphicalItems: graphicalItems }));
	
	        Object.keys(axisObj).forEach(function (key) {
	          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
	        });
	        var cateAxisMap = axisObj[cateAxisName + 'Map'];
	        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
	
	        var formatedGraphicalItems = this.getFormatItems(props, _extends({}, axisObj, { dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId,
	          graphicalItems: graphicalItems, stackGroups: stackGroups, offset: offset
	        }));
	
	        return _extends({
	          formatedGraphicalItems: formatedGraphicalItems, graphicalItems: graphicalItems, offset: offset, stackGroups: stackGroups
	        }, ticksObj, axisObj);
	      }
	
	      /* eslint-disable  no-underscore-dangle */
	
	    }, {
	      key: 'addListener',
	      value: function addListener() {
	        _Events.eventCenter.on(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners + 1);
	        }
	      }
	    }, {
	      key: 'removeListener',
	      value: function removeListener() {
	        _Events.eventCenter.removeListener(_Events.SYNC_EVENT, this.handleReceiveSyncEvent);
	
	        if (_Events.eventCenter.setMaxListeners && _Events.eventCenter._maxListeners) {
	          _Events.eventCenter.setMaxListeners(_Events.eventCenter._maxListeners - 1);
	        }
	      }
	      /**
	       * Calculate the offset of main part in the svg element
	       * @param  {Object} props          Latest props
	       * @param  {Array}  graphicalItems The instances of item
	       * @param  {Object} xAxisMap       The configuration of x-axis
	       * @param  {Object} yAxisMap       The configuration of y-axis
	       * @return {Object} The offset of main part in the svg element
	       */
	
	    }, {
	      key: 'calculateOffset',
	      value: function calculateOffset(_ref6) {
	        var props = _ref6.props,
	            graphicalItems = _ref6.graphicalItems,
	            _ref6$xAxisMap = _ref6.xAxisMap,
	            xAxisMap = _ref6$xAxisMap === undefined ? {} : _ref6$xAxisMap,
	            _ref6$yAxisMap = _ref6.yAxisMap,
	            yAxisMap = _ref6$yAxisMap === undefined ? {} : _ref6$yAxisMap;
	        var width = props.width,
	            height = props.height,
	            children = props.children;
	
	        var margin = props.margin || {};
	        var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	        var legendItem = (0, _ReactUtils.findChildByType)(children, _Legend2.default);
	
	        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
	          var entry = yAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
	          }
	
	          return result;
	        }, { left: margin.left || 0, right: margin.right || 0 });
	
	        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
	          var entry = xAxisMap[id];
	          var orientation = entry.orientation;
	
	          if (!entry.mirror && !entry.hide) {
	            return _extends({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
	          }
	
	          return result;
	        }, { top: margin.top || 0, bottom: margin.bottom || 0 });
	
	        var offset = _extends({}, offsetV, offsetH);
	
	        var brushBottom = offset.bottom;
	
	        if (brushItem) {
	          offset.bottom += brushItem.props.height || _Brush2.default.defaultProps.height;
	        }
	
	        if (legendItem && this.legendInstance) {
	          var legendBox = this.legendInstance.getBBox();
	
	          offset = (0, _ChartUtils.appendOffsetOfLegend)(offset, graphicalItems, props, legendBox);
	        }
	
	        return _extends({
	          brushBottom: brushBottom
	        }, offset, {
	          width: width - offset.left - offset.right,
	          height: height - offset.top - offset.bottom
	        });
	      }
	      /**
	       * The handler of mouse entering chart
	       * @param  {Object} e              Event object
	       * @return {Null}                  null
	       */
	
	      /**
	       * The handler of mouse entering a scatter
	       * @param {Object} el     The active scatter
	       * @return {Object} no return
	       */
	
	      /**
	       * The handler of mouse leaving a scatter
	       * @return {Object} no return
	       */
	
	      /**
	       * The handler of mouse moving in chart
	       * @param  {Object} e        Event object
	       * @return {Null} no return
	       */
	
	      /**
	       * The handler if mouse leaving chart
	       * @param {Object} e Event object
	       * @return {Null} no return
	       */
	
	    }, {
	      key: 'triggerSyncEvent',
	      value: function triggerSyncEvent(data) {
	        var syncId = this.props.syncId;
	
	
	        if (!(0, _isNil3.default)(syncId)) {
	          _Events.eventCenter.emit(_Events.SYNC_EVENT, syncId, this.uniqueChartId, data);
	        }
	      }
	    }, {
	      key: 'filterFormatItem',
	      value: function filterFormatItem(item, displayName, childIndex) {
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	
	
	        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
	          var entry = formatedGraphicalItems[i];
	
	          if (entry.item === item || entry.props.key === item.key || displayName === (0, _ReactUtils.getDisplayName)(entry.item.type) && childIndex === entry.childIndex) {
	            return entry;
	          }
	        }
	
	        return null;
	      }
	    }, {
	      key: 'renderAxis',
	
	      /**
	       * Draw axis
	       * @param {Object} axisOptions The options of axis
	       * @param {Object} element      The axis element
	       * @param {String} displayName  The display name of axis
	       * @param {Number} index        The index of element
	       * @return {ReactElement}       The instance of x-axes
	       */
	      value: function renderAxis(axisOptions, element, displayName, index) {
	        var _props2 = this.props,
	            width = _props2.width,
	            height = _props2.height;
	
	
	        return _react2.default.createElement(_CartesianAxis2.default, _extends({}, axisOptions, {
	          className: 'recharts-' + axisOptions.axisType + ' ' + axisOptions.axisType,
	          key: element.key || displayName + '-' + index,
	          viewBox: { x: 0, y: 0, width: width, height: height },
	          ticksGenerator: this.axesTicksGenerator
	        }));
	      }
	      /**
	       * Draw grid
	       * @param  {ReactElement} element the grid item
	       * @return {ReactElement} The instance of grid
	       */
	
	    }, {
	      key: 'renderLegend',
	
	      /**
	       * Draw legend
	       * @return {ReactElement}            The instance of Legend
	       */
	      value: function renderLegend() {
	        var _this5 = this;
	
	        var formatedGraphicalItems = this.state.formatedGraphicalItems;
	        var _props3 = this.props,
	            children = _props3.children,
	            width = _props3.width,
	            height = _props3.height;
	
	        var margin = this.props.margin || {};
	        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
	        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
	        var props = (0, _ChartUtils.getLegendProps)({
	          children: children, formatedGraphicalItems: formatedGraphicalItems, legendWidth: legendWidth, legendHeight: legendHeight, legendContent: legendContent
	        });
	
	        if (!props) {
	          return null;
	        }
	
	        var item = props.item,
	            otherProps = _objectWithoutProperties(props, ['item']);
	
	        return (0, _react.cloneElement)(item, _extends({}, otherProps, {
	          chartWidth: width,
	          chartHeight: height,
	          margin: margin,
	          ref: function ref(legend) {
	            _this5.legendInstance = legend;
	          },
	          onBBoxUpdate: this.handleLegendBBoxUpdate
	        }));
	      }
	      /**
	       * Draw Tooltip
	       * @return {ReactElement}  The instance of Tooltip
	       */
	
	    }, {
	      key: 'renderTooltip',
	      value: function renderTooltip() {
	        var children = this.props.children;
	
	        var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	        if (!tooltipItem) {
	          return null;
	        }
	
	        var _state8 = this.state,
	            isTooltipActive = _state8.isTooltipActive,
	            activeCoordinate = _state8.activeCoordinate,
	            activePayload = _state8.activePayload,
	            activeLabel = _state8.activeLabel,
	            offset = _state8.offset;
	
	
	        return (0, _react.cloneElement)(tooltipItem, {
	          viewBox: _extends({}, offset, { x: offset.left, y: offset.top }),
	          active: isTooltipActive,
	          label: activeLabel,
	          payload: isTooltipActive ? activePayload : [],
	          coordinate: activeCoordinate
	        });
	      }
	    }, {
	      key: 'renderActiveDot',
	      value: function renderActiveDot(option, props) {
	        var dot = void 0;
	
	        if ((0, _react.isValidElement)(option)) {
	          dot = (0, _react.cloneElement)(option, props);
	        } else if ((0, _isFunction3.default)(option)) {
	          dot = option(props);
	        } else {
	          dot = _react2.default.createElement(_Dot2.default, props);
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-active-dot', key: props.key },
	          dot
	        );
	      }
	    }, {
	      key: 'renderActivePoints',
	      value: function renderActivePoints(_ref7) {
	        var item = _ref7.item,
	            activePoint = _ref7.activePoint,
	            basePoint = _ref7.basePoint,
	            childIndex = _ref7.childIndex,
	            isRange = _ref7.isRange;
	
	        var result = [];
	        var key = item.props.key;
	        var _item$item$props = item.item.props,
	            activeDot = _item$item$props.activeDot,
	            dataKey = _item$item$props.dataKey;
	
	        var dotProps = _extends({
	          index: childIndex,
	          dataKey: dataKey,
	          cx: activePoint.x,
	          cy: activePoint.y,
	          r: 4,
	          fill: (0, _ChartUtils.getMainColorOfGraphicItem)(item.item),
	          strokeWidth: 2,
	          stroke: '#fff',
	          payload: activePoint.payload,
	          value: activePoint.value,
	          key: key + '-activePoint-' + childIndex
	        }, (0, _ReactUtils.getPresentationAttributes)(activeDot), (0, _ReactUtils.filterEventAttributes)(activeDot));
	
	        result.push(this.renderActiveDot(activeDot, dotProps, childIndex));
	
	        if (basePoint) {
	          result.push(this.renderActiveDot(activeDot, _extends({}, dotProps, {
	            cx: basePoint.x,
	            cy: basePoint.y,
	            key: key + '-basePoint-' + childIndex
	          }), childIndex));
	        } else if (isRange) {
	          result.push(null);
	        }
	
	        return result;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this6 = this;
	
	        if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	          return null;
	        }
	
	        var _props4 = this.props,
	            children = _props4.children,
	            className = _props4.className,
	            width = _props4.width,
	            height = _props4.height,
	            style = _props4.style,
	            compact = _props4.compact,
	            others = _objectWithoutProperties(_props4, ['children', 'className', 'width', 'height', 'style', 'compact']);
	
	        var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	        var map = {
	          CartesianGrid: { handler: this.renderGrid, once: true },
	          ReferenceArea: { handler: this.renderReferenceElement },
	          ReferenceLine: { handler: this.renderReferenceElement },
	          ReferenceDot: { handler: this.renderReferenceElement },
	          XAxis: { handler: this.renderXAxis },
	          YAxis: { handler: this.renderYAxis },
	          Brush: { handler: this.renderBrush, once: true },
	          Bar: { handler: this.renderGraphicChild },
	          Line: { handler: this.renderGraphicChild },
	          Area: { handler: this.renderGraphicChild },
	          Radar: { handler: this.renderGraphicChild },
	          RadialBar: { handler: this.renderGraphicChild },
	          Scatter: { handler: this.renderGraphicChild },
	          Pie: { handler: this.renderGraphicChild },
	          Tooltip: { handler: this.renderCursor, once: true },
	          PolarGrid: { handler: this.renderPolarGrid, once: true },
	          PolarAngleAxis: { handler: this.renderPolarAxis },
	          PolarRadiusAxis: { handler: this.renderPolarAxis }
	        };
	
	        // The "compact" mode is mainly used as the panorama within Brush
	        if (compact) {
	          return _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            (0, _ReactUtils.renderByOrder)(children, map)
	          );
	        }
	
	        var events = this.parseEventsOfWrapper();
	        return _react2.default.createElement(
	          'div',
	          _extends({
	            className: (0, _classnames2.default)('recharts-wrapper', className),
	            style: _extends({ position: 'relative', cursor: 'default', width: width, height: height }, style)
	          }, events, {
	            ref: function ref(node) {
	              _this6.container = node;
	            }
	          }),
	          _react2.default.createElement(
	            _Surface2.default,
	            _extends({}, attrs, { width: width, height: height }),
	            (0, _ReactUtils.renderByOrder)(children, map)
	          ),
	          this.renderLegend(),
	          this.renderTooltip()
	        );
	      }
	    }]);
	
	    return CategoricalChartWrapper;
	  }(_react.Component), _class.displayName = chartName, _class.propTypes = _extends({
	    syncId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	    compact: _propTypes2.default.bool,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	    stackOffset: _propTypes2.default.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
	    throttleDelay: _propTypes2.default.number,
	    margin: _propTypes2.default.shape({
	      top: _propTypes2.default.number,
	      right: _propTypes2.default.number,
	      bottom: _propTypes2.default.number,
	      left: _propTypes2.default.number
	    }),
	    barCategoryGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    barGap: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    barSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    maxBarSize: _propTypes2.default.number,
	    style: _propTypes2.default.object,
	    className: _propTypes2.default.string,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	    defaultShowTooltip: _propTypes2.default.bool,
	    onClick: _propTypes2.default.func,
	    onMouseLeave: _propTypes2.default.func,
	    onMouseEnter: _propTypes2.default.func,
	    onMouseMove: _propTypes2.default.func,
	    onMouseDown: _propTypes2.default.func,
	    onMouseUp: _propTypes2.default.func,
	    reverseStackOrder: _propTypes2.default.bool,
	    id: _propTypes2.default.string
	  }, propTypes), _class.defaultProps = _extends({
	    layout: 'horizontal',
	    stackOffset: 'none',
	    barCategoryGap: '10%',
	    barGap: 4,
	    margin: { top: 5, right: 5, bottom: 5, left: 5 },
	    reverseStackOrder: false
	  }, defaultProps), _class.createDefaultState = function (props) {
	    var children = props.children,
	        defaultShowTooltip = props.defaultShowTooltip;
	
	    var brushItem = (0, _ReactUtils.findChildByType)(children, _Brush2.default);
	    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
	    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
	    return {
	      chartX: 0,
	      chartY: 0,
	      dataStartIndex: startIndex,
	      dataEndIndex: endIndex,
	      activeTooltipIndex: -1,
	      isTooltipActive: !(0, _isNil3.default)(defaultShowTooltip) ? defaultShowTooltip : false
	    };
	  }, _class.hasBar = function (graphicalItems) {
	    if (!graphicalItems || !graphicalItems.length) {
	      return false;
	    }
	
	    return graphicalItems.some(function (item) {
	      var name = (0, _ReactUtils.getDisplayName)(item && item.type);
	
	      return name && name.indexOf('Bar') >= 0;
	    });
	  }, _class.getDisplayedData = function (props, _ref8, item) {
	    var graphicalItems = _ref8.graphicalItems,
	        dataStartIndex = _ref8.dataStartIndex,
	        dataEndIndex = _ref8.dataEndIndex;
	
	    var itemsData = (graphicalItems || []).reduce(function (result, child) {
	      var itemData = child.props.data;
	
	      if (itemData && itemData.length) {
	        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
	      }
	
	      return result;
	    }, []);
	    if (itemsData && itemsData.length > 0) {
	      return itemsData;
	    }
	
	    if (item && item.props && item.props.data && item.props.data.length > 0) {
	      return item.props.data;
	    }
	
	    var data = props.data;
	
	
	    if (data && data.length && (0, _DataUtils.isNumber)(dataStartIndex) && (0, _DataUtils.isNumber)(dataEndIndex)) {
	      return data.slice(dataStartIndex, dataEndIndex + 1);
	    }
	
	    return [];
	  }, _initialiseProps = function _initialiseProps() {
	    var _this7 = this;
	
	    this.handleLegendBBoxUpdate = function (box) {
	      if (box && _this7.legendInstance) {
	        var _state9 = _this7.state,
	            dataStartIndex = _state9.dataStartIndex,
	            dataEndIndex = _state9.dataEndIndex,
	            updateId = _state9.updateId;
	
	
	        _this7.setState(_this7.updateStateOfAxisMapsOffsetAndStackGroups({
	          props: _this7.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId
	        }));
	      }
	    };
	
	    this.handleReceiveSyncEvent = function (cId, chartId, data) {
	      var _props5 = _this7.props,
	          syncId = _props5.syncId,
	          layout = _props5.layout;
	      var updateId = _this7.state.updateId;
	
	
	      if (syncId === cId && chartId !== _this7.uniqueChartId) {
	        var dataStartIndex = data.dataStartIndex,
	            dataEndIndex = data.dataEndIndex;
	
	
	        if (!(0, _isNil3.default)(data.dataStartIndex) || !(0, _isNil3.default)(data.dataEndIndex)) {
	          _this7.setState(_extends({
	            dataStartIndex: dataStartIndex,
	            dataEndIndex: dataEndIndex
	          }, _this7.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this7.props, dataStartIndex: dataStartIndex, dataEndIndex: dataEndIndex, updateId: updateId })));
	        } else if (!(0, _isNil3.default)(data.activeTooltipIndex)) {
	          var chartX = data.chartX,
	              chartY = data.chartY,
	              activeTooltipIndex = data.activeTooltipIndex;
	          var _state10 = _this7.state,
	              offset = _state10.offset,
	              tooltipTicks = _state10.tooltipTicks;
	
	          if (!offset) {
	            return;
	          }
	          var viewBox = _extends({}, offset, { x: offset.left, y: offset.top });
	          // When a categotical chart is combined with another chart, the value of chartX
	          // and chartY may beyond the boundaries.
	          var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
	          var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
	          var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
	          var activePayload = _this7.getTooltipContent(activeTooltipIndex);
	          var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
	            x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
	            y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
	          } : originCoordinate;
	
	          _this7.setState(_extends({}, data, { activeLabel: activeLabel, activeCoordinate: activeCoordinate, activePayload: activePayload }));
	        } else {
	          _this7.setState(data);
	        }
	      }
	    };
	
	    this.handleBrushChange = function (_ref9) {
	      var startIndex = _ref9.startIndex,
	          endIndex = _ref9.endIndex;
	
	      // Only trigger changes if the extents of the brush have actually changed
	      if (startIndex !== _this7.state.dataStartIndex || endIndex !== _this7.state.dataEndIndex) {
	        var updateId = _this7.state.updateId;
	
	
	        _this7.setState(function () {
	          return _extends({
	            dataStartIndex: startIndex,
	            dataEndIndex: endIndex
	          }, _this7.updateStateOfAxisMapsOffsetAndStackGroups({ props: _this7.props, dataStartIndex: startIndex, dataEndIndex: endIndex, updateId: updateId }));
	        });
	
	        _this7.triggerSyncEvent({
	          dataStartIndex: startIndex,
	          dataEndIndex: endIndex
	        });
	      }
	    };
	
	    this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this7.props.onMouseEnter;
	
	      var mouse = _this7.getMouseInfo(e);
	
	      if (mouse) {
	        var nextState = _extends({}, mouse, { isTooltipActive: true });
	        _this7.setState(nextState);
	        _this7.triggerSyncEvent(nextState);
	
	        if ((0, _isFunction3.default)(onMouseEnter)) {
	          onMouseEnter(nextState, e);
	        }
	      }
	    };
	
	    this.triggeredAfterMouseMove = function (e) {
	      var onMouseMove = _this7.props.onMouseMove;
	
	      var mouse = _this7.getMouseInfo(e);
	      var nextState = mouse ? _extends({}, mouse, { isTooltipActive: true }) : { isTooltipActive: false };
	
	      _this7.setState(nextState);
	      _this7.triggerSyncEvent(nextState);
	
	      if ((0, _isFunction3.default)(onMouseMove)) {
	        onMouseMove(nextState, e);
	      }
	    };
	
	    this.handleItemMouseEnter = function (el) {
	      _this7.setState(function () {
	        return {
	          isTooltipActive: true,
	          activeItem: el,
	          activePayload: el.tooltipPayload,
	          activeCoordinate: el.tooltipPosition || { x: el.cx, y: el.cy }
	        };
	      });
	    };
	
	    this.handleItemMouseLeave = function () {
	      _this7.setState(function () {
	        return {
	          isTooltipActive: false
	        };
	      });
	    };
	
	    this.handleMouseMove = function (e) {
	      if (e && (0, _isFunction3.default)(e.persist)) {
	        e.persist();
	      }
	      _this7.triggeredAfterMouseMove(e);
	    };
	
	    this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this7.props.onMouseLeave;
	
	      var nextState = { isTooltipActive: false };
	
	      _this7.setState(nextState);
	      _this7.triggerSyncEvent(nextState);
	
	      if ((0, _isFunction3.default)(onMouseLeave)) {
	        onMouseLeave(nextState, e);
	      }
	    };
	
	    this.handleOuterEvent = function (e) {
	      var eventName = (0, _ReactUtils.getReactEventByType)(e);
	
	      if (eventName && (0, _isFunction3.default)(_this7.props[eventName])) {
	        var mouse = _this7.getMouseInfo(e);
	        var handler = _this7.props[eventName];
	
	        handler(mouse, e);
	      }
	    };
	
	    this.handleClick = function (e) {
	      var onClick = _this7.props.onClick;
	
	
	      if ((0, _isFunction3.default)(onClick)) {
	        var mouse = _this7.getMouseInfo(e);
	
	        onClick(mouse, e);
	      }
	    };
	
	    this.handleMouseDown = function (e) {
	      var onMouseDown = _this7.props.onMouseDown;
	
	
	      if ((0, _isFunction3.default)(onMouseDown)) {
	        var mouse = _this7.getMouseInfo(e);
	
	        onMouseDown(mouse, e);
	      }
	    };
	
	    this.handleMouseUp = function (e) {
	      var onMouseUp = _this7.props.onMouseUp;
	
	
	      if ((0, _isFunction3.default)(onMouseUp)) {
	        var mouse = _this7.getMouseInfo(e);
	
	        onMouseUp(mouse, e);
	      }
	    };
	
	    this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this7.handleMouseMove(e.changedTouches[0]);
	      }
	    };
	
	    this.handleTouchStart = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this7.handleMouseDown(e.changedTouches[0]);
	      }
	    };
	
	    this.handleTouchEnd = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this7.handleMouseUp(e.changedTouches[0]);
	      }
	    };
	
	    this.verticalCoordinatesGenerator = function (_ref10) {
	      var xAxis = _ref10.xAxis,
	          width = _ref10.width,
	          height = _ref10.height,
	          offset = _ref10.offset;
	      return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, xAxis, {
	        ticks: (0, _ChartUtils.getTicksOfAxis)(xAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.left, offset.left + offset.width);
	    };
	
	    this.horizontalCoordinatesGenerator = function (_ref11) {
	      var yAxis = _ref11.yAxis,
	          width = _ref11.width,
	          height = _ref11.height,
	          offset = _ref11.offset;
	      return (0, _ChartUtils.getCoordinatesOfGrid)(_CartesianAxis2.default.getTicks(_extends({}, _CartesianAxis2.default.defaultProps, yAxis, {
	        ticks: (0, _ChartUtils.getTicksOfAxis)(yAxis, true),
	        viewBox: { x: 0, y: 0, width: width, height: height }
	      })), offset.top, offset.top + offset.height);
	    };
	
	    this.axesTicksGenerator = function (axis) {
	      return (0, _ChartUtils.getTicksOfAxis)(axis, true);
	    };
	
	    this.tooltipTicksGenerator = function (axisMap) {
	      var axis = (0, _DataUtils.getAnyElementOfObject)(axisMap);
	      var tooltipTicks = (0, _ChartUtils.getTicksOfAxis)(axis, false, true);
	
	      return {
	        tooltipTicks: tooltipTicks,
	        orderedTooltipTicks: (0, _sortBy3.default)(tooltipTicks, function (o) {
	          return o.coordinate;
	        }),
	        tooltipAxis: axis,
	        tooltipAxisBandSize: (0, _ChartUtils.getBandSizeOfAxis)(axis)
	      };
	    };
	
	    this.renderCursor = function (element) {
	      var _state11 = _this7.state,
	          isTooltipActive = _state11.isTooltipActive,
	          activeCoordinate = _state11.activeCoordinate,
	          activePayload = _state11.activePayload,
	          offset = _state11.offset;
	
	
	      if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
	        return null;
	      }
	      var layout = _this7.props.layout;
	
	      var restProps = void 0;
	      var cursorComp = _Curve2.default;
	
	      if (chartName === 'ScatterChart') {
	        restProps = activeCoordinate;
	        cursorComp = _Cross2.default;
	      } else if (chartName === 'BarChart') {
	        restProps = _this7.getCursorRectangle();
	        cursorComp = _Rectangle2.default;
	      } else if (layout === 'radial') {
	        var _getCursorPoints = _this7.getCursorPoints(),
	            cx = _getCursorPoints.cx,
	            cy = _getCursorPoints.cy,
	            radius = _getCursorPoints.radius,
	            startAngle = _getCursorPoints.startAngle,
	            endAngle = _getCursorPoints.endAngle;
	
	        restProps = {
	          cx: cx, cy: cy, startAngle: startAngle, endAngle: endAngle, innerRadius: radius, outerRadius: radius
	        };
	        cursorComp = _Sector2.default;
	      } else {
	        restProps = { points: _this7.getCursorPoints() };
	        cursorComp = _Curve2.default;
	      }
	      var key = element.key || '_recharts-cursor';
	      var cursorProps = _extends({
	        stroke: '#ccc',
	        pointerEvents: 'none'
	      }, offset, restProps, (0, _ReactUtils.getPresentationAttributes)(element.props.cursor), {
	        payload: activePayload,
	        key: key,
	        className: 'recharts-tooltip-cursor'
	      });
	
	      return (0, _react.isValidElement)(element.props.cursor) ? (0, _react.cloneElement)(element.props.cursor, cursorProps) : (0, _react.createElement)(cursorComp, cursorProps);
	    };
	
	    this.renderPolarAxis = function (element, displayName, index) {
	      var axisType = element.type.axisType;
	      var axisMap = _this7.state[axisType + 'Map'];
	      var axisOption = axisMap[element.props[axisType + 'Id']];
	
	      return (0, _react.cloneElement)(element, _extends({}, axisOption, {
	        className: axisType,
	        key: element.key || displayName + '-' + index,
	        ticks: (0, _ChartUtils.getTicksOfAxis)(axisOption, true)
	      }));
	    };
	
	    this.renderXAxis = function (element, displayName, index) {
	      var xAxisMap = _this7.state.xAxisMap;
	
	      var axisObj = xAxisMap[element.props.xAxisId];
	
	      return _this7.renderAxis(axisObj, element, displayName, index);
	    };
	
	    this.renderYAxis = function (element, displayName, index) {
	      var yAxisMap = _this7.state.yAxisMap;
	
	      var axisObj = yAxisMap[element.props.yAxisId];
	
	      return _this7.renderAxis(axisObj, element, displayName, index);
	    };
	
	    this.renderGrid = function (element) {
	      var _state12 = _this7.state,
	          xAxisMap = _state12.xAxisMap,
	          yAxisMap = _state12.yAxisMap,
	          offset = _state12.offset;
	      var _props6 = _this7.props,
	          width = _props6.width,
	          height = _props6.height;
	
	      var xAxis = (0, _DataUtils.getAnyElementOfObject)(xAxisMap);
	      var yAxis = (0, _DataUtils.getAnyElementOfObject)(yAxisMap);
	      var props = element.props || {};
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || 'grid',
	        x: (0, _DataUtils.isNumber)(props.x) ? props.x : offset.left,
	        y: (0, _DataUtils.isNumber)(props.y) ? props.y : offset.top,
	        width: (0, _DataUtils.isNumber)(props.width) ? props.width : offset.width,
	        height: (0, _DataUtils.isNumber)(props.height) ? props.height : offset.height,
	        xAxis: xAxis,
	        yAxis: yAxis,
	        offset: offset,
	        chartWidth: width,
	        chartHeight: height,
	        verticalCoordinatesGenerator: _this7.verticalCoordinatesGenerator,
	        horizontalCoordinatesGenerator: _this7.horizontalCoordinatesGenerator
	      });
	    };
	
	    this.renderPolarGrid = function (element) {
	      var _state13 = _this7.state,
	          radiusAxisMap = _state13.radiusAxisMap,
	          angleAxisMap = _state13.angleAxisMap;
	
	      var radiusAxis = (0, _DataUtils.getAnyElementOfObject)(radiusAxisMap);
	      var angleAxis = (0, _DataUtils.getAnyElementOfObject)(angleAxisMap);
	      var cx = angleAxis.cx,
	          cy = angleAxis.cy,
	          innerRadius = angleAxis.innerRadius,
	          outerRadius = angleAxis.outerRadius;
	
	
	      return (0, _react.cloneElement)(element, {
	        polarAngles: (0, _ChartUtils.getTicksOfAxis)(angleAxis, true).map(function (entry) {
	          return entry.coordinate;
	        }),
	        polarRadius: (0, _ChartUtils.getTicksOfAxis)(radiusAxis, true).map(function (entry) {
	          return entry.coordinate;
	        }),
	        cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	        key: element.key || 'polar-grid'
	      });
	    };
	
	    this.renderBrush = function (element) {
	      var _props7 = _this7.props,
	          margin = _props7.margin,
	          data = _props7.data;
	      var _state14 = _this7.state,
	          offset = _state14.offset,
	          dataStartIndex = _state14.dataStartIndex,
	          dataEndIndex = _state14.dataEndIndex,
	          updateId = _state14.updateId;
	
	      // TODO: update brush when children update
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || '_recharts-brush',
	        onChange: (0, _ChartUtils.combineEventHandlers)(_this7.handleBrushChange, null, element.props.onChange),
	        data: data,
	        x: (0, _DataUtils.isNumber)(element.props.x) ? element.props.x : offset.left,
	        y: (0, _DataUtils.isNumber)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
	        width: (0, _DataUtils.isNumber)(element.props.width) ? element.props.width : offset.width,
	        startIndex: dataStartIndex,
	        endIndex: dataEndIndex,
	        updateId: 'brush-' + updateId
	      });
	    };
	
	    this.renderReferenceElement = function (element, displayName, index) {
	      if (!element) {
	        return null;
	      }
	      var _state15 = _this7.state,
	          xAxisMap = _state15.xAxisMap,
	          yAxisMap = _state15.yAxisMap,
	          offset = _state15.offset;
	      var _element$props = element.props,
	          xAxisId = _element$props.xAxisId,
	          yAxisId = _element$props.yAxisId;
	
	
	      return (0, _react.cloneElement)(element, {
	        key: element.key || displayName + '-' + index,
	        xAxis: xAxisMap[xAxisId],
	        yAxis: yAxisMap[yAxisId],
	        viewBox: {
	          x: offset.left,
	          y: offset.top,
	          width: offset.width,
	          height: offset.height
	        }
	      });
	    };
	
	    this.renderGraphicChild = function (element, displayName, index) {
	      var item = _this7.filterFormatItem(element, displayName, index);
	      if (!item) {
	        return null;
	      }
	
	      var graphicalItem = (0, _react.cloneElement)(element, item.props);
	      var _state16 = _this7.state,
	          isTooltipActive = _state16.isTooltipActive,
	          tooltipAxis = _state16.tooltipAxis,
	          activeTooltipIndex = _state16.activeTooltipIndex,
	          activeLabel = _state16.activeLabel;
	      var children = _this7.props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	      var _item$props2 = item.props,
	          points = _item$props2.points,
	          isRange = _item$props2.isRange,
	          baseLine = _item$props2.baseLine;
	      var _item$item$props2 = item.item.props,
	          activeDot = _item$item$props2.activeDot,
	          hide = _item$item$props2.hide;
	
	      var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
	
	      if (hasActive) {
	        var activePoint = void 0,
	            basePoint = void 0;
	
	        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
	          activePoint = (0, _DataUtils.findEntryInArray)(points, 'payload.' + tooltipAxis.dataKey, activeLabel);
	          basePoint = isRange && baseLine && (0, _DataUtils.findEntryInArray)(baseLine, 'payload.' + tooltipAxis.dataKey, activeLabel);
	        } else {
	          activePoint = points[activeTooltipIndex];
	          basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
	        }
	
	        if (!(0, _isNil3.default)(activePoint)) {
	          return [graphicalItem].concat(_toConsumableArray(_this7.renderActivePoints({
	            item: item, activePoint: activePoint, basePoint: basePoint, childIndex: activeTooltipIndex,
	            isRange: isRange
	          })));
	        }
	      }
	
	      if (isRange) {
	        return [graphicalItem, null, null];
	      }
	
	      return [graphicalItem, null];
	    };
	  }, _temp);
	
	
	  return CategoricalChartWrapper;
	};
	
	exports.default = generateCategoricalChart;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(87);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Text = __webpack_require__(164);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	var _PolarUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var cartesianViewBoxShape = _propTypes2.default.shape({
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number
	});
	var polarViewBoxShape = _propTypes2.default.shape({
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number
	});
	
	var propTypes = {
	  viewBox: _propTypes2.default.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
	  formatter: _propTypes2.default.func,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  offset: _propTypes2.default.number,
	  position: _propTypes2.default.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  className: _propTypes2.default.string,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  offset: 5
	};
	
	var getLabel = function getLabel(props) {
	  var value = props.value,
	      formatter = props.formatter;
	
	  var label = (0, _isNil3.default)(props.children) ? value : props.children;
	
	  if ((0, _isFunction3.default)(formatter)) {
	    return formatter(label);
	  }
	
	  return label;
	};
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	  return sign * deltaAngle;
	};
	
	var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
	  var position = labelProps.position,
	      viewBox = labelProps.viewBox,
	      offset = labelProps.offset,
	      className = labelProps.className;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle,
	      clockWise = viewBox.clockWise;
	
	  var radius = (innerRadius + outerRadius) / 2;
	  var deltaAngle = getDeltaAngle(startAngle, endAngle);
	  var sign = deltaAngle >= 0 ? 1 : -1;
	  var labelAngle = void 0,
	      direction = void 0;
	
	  if (position === 'insideStart') {
	    labelAngle = startAngle + sign * offset;
	    direction = clockWise;
	  } else if (position === 'insideEnd') {
	    labelAngle = endAngle - sign * offset;
	    direction = !clockWise;
	  } else if (position === 'end') {
	    labelAngle = endAngle + sign * offset;
	    direction = clockWise;
	  }
	
	  direction = deltaAngle <= 0 ? direction : !direction;
	
	  var startPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
	  var endPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
	  var path = 'M' + startPoint.x + ',' + startPoint.y + '\n    A' + radius + ',' + radius + ',0,1,' + (direction ? 0 : 1) + ',\n    ' + endPoint.x + ',' + endPoint.y;
	  var id = (0, _isNil3.default)(labelProps.id) ? (0, _DataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
	
	  return _react2.default.createElement(
	    'text',
	    _extends({}, attrs, {
	      dominantBaseline: 'central',
	      className: (0, _classnames2.default)('recharts-radial-bar-label', className)
	    }),
	    _react2.default.createElement(
	      'defs',
	      null,
	      _react2.default.createElement('path', { id: id, d: path })
	    ),
	    _react2.default.createElement(
	      'textPath',
	      { xlinkHref: '#' + id },
	      label
	    )
	  );
	};
	
	var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var cx = viewBox.cx,
	      cy = viewBox.cy,
	      innerRadius = viewBox.innerRadius,
	      outerRadius = viewBox.outerRadius,
	      startAngle = viewBox.startAngle,
	      endAngle = viewBox.endAngle;
	
	  var midAngle = (startAngle + endAngle) / 2;
	
	  if (position === 'outside') {
	    var _polarToCartesian = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle),
	        _x = _polarToCartesian.x,
	        _y = _polarToCartesian.y;
	
	    return {
	      x: _x,
	      y: _y,
	      textAnchor: _x >= cx ? 'start' : 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'center') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'centerTop') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'centerBottom') {
	    return {
	      x: cx,
	      y: cy,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  var r = (innerRadius + outerRadius) / 2;
	
	  var _polarToCartesian2 = (0, _PolarUtils.polarToCartesian)(cx, cy, r, midAngle),
	      x = _polarToCartesian2.x,
	      y = _polarToCartesian2.y;
	
	  return {
	    x: x,
	    y: y,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
	  var viewBox = props.viewBox,
	      offset = props.offset,
	      position = props.position;
	  var x = viewBox.x,
	      y = viewBox.y,
	      width = viewBox.width,
	      height = viewBox.height;
	
	  var sign = height >= 0 ? 1 : -1;
	
	  if (position === 'top') {
	    return {
	      x: x + width / 2,
	      y: y - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: sign > 0 ? 'end' : 'start'
	    };
	  }
	
	  if (position === 'bottom') {
	    return {
	      x: x + width / 2,
	      y: y + height + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'left') {
	    return {
	      x: x - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'right') {
	    return {
	      x: x + width + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideLeft') {
	    return {
	      x: x + offset,
	      y: y + height / 2,
	      textAnchor: 'start',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideRight') {
	    return {
	      x: x + width - offset,
	      y: y + height / 2,
	      textAnchor: 'end',
	      verticalAnchor: 'middle'
	    };
	  }
	
	  if (position === 'insideTop') {
	    return {
	      x: x + width / 2,
	      y: y + sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottom') {
	    return {
	      x: x + width / 2,
	      y: y + height - sign * offset,
	      textAnchor: 'middle',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideTopLeft') {
	    return {
	      x: x + offset,
	      y: y + sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideTopRight') {
	    return {
	      x: x + width - offset,
	      y: y + sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'start'
	    };
	  }
	
	  if (position === 'insideBottomLeft') {
	    return {
	      x: x + offset,
	      y: y + height - sign * offset,
	      textAnchor: 'start',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if (position === 'insideBottomRight') {
	    return {
	      x: x + width - offset,
	      y: y + height - sign * offset,
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  if ((0, _isObject3.default)(position) && ((0, _DataUtils.isNumber)(position.x) || (0, _DataUtils.isPercent)(position.x)) && ((0, _DataUtils.isNumber)(position.y) || (0, _DataUtils.isPercent)(position.y))) {
	    return {
	      x: x + (0, _DataUtils.getPercentValue)(position.x, width),
	      y: y + (0, _DataUtils.getPercentValue)(position.y, height),
	      textAnchor: 'end',
	      verticalAnchor: 'end'
	    };
	  }
	
	  return {
	    x: x + width / 2,
	    y: y + height / 2,
	    textAnchor: 'middle',
	    verticalAnchor: 'middle'
	  };
	};
	
	var isPolar = function isPolar(viewBox) {
	  return (0, _DataUtils.isNumber)(viewBox.cx);
	};
	
	function Label(props) {
	  var viewBox = props.viewBox,
	      position = props.position,
	      value = props.value,
	      children = props.children,
	      content = props.content,
	      _props$className = props.className,
	      className = _props$className === undefined ? '' : _props$className;
	
	
	  if (!viewBox || (0, _isNil3.default)(value) && (0, _isNil3.default)(children) && !(0, _react.isValidElement)(content) && !(0, _isFunction3.default)(content)) {
	    return null;
	  }
	
	  if ((0, _react.isValidElement)(content)) {
	    return (0, _react.cloneElement)(content, props);
	  }
	
	  var label = void 0;
	  if ((0, _isFunction3.default)(content)) {
	    label = content(props);
	
	    if ((0, _react.isValidElement)(label)) {
	      return label;
	    }
	  } else {
	    label = getLabel(props);
	  }
	
	  var isPolarLabel = isPolar(viewBox);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(props);
	
	  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
	    return renderRadialLabel(props, label, attrs);
	  }
	
	  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
	
	  return _react2.default.createElement(
	    _Text2.default,
	    _extends({
	      className: (0, _classnames2.default)('recharts-label', className)
	    }, attrs, positionAttrs),
	    label
	  );
	}
	
	Label.displayName = 'Label';
	Label.defaultProps = defaultProps;
	Label.propTypes = propTypes;
	
	var parseViewBox = function parseViewBox(props) {
	  var cx = props.cx,
	      cy = props.cy,
	      angle = props.angle,
	      startAngle = props.startAngle,
	      endAngle = props.endAngle,
	      r = props.r,
	      radius = props.radius,
	      innerRadius = props.innerRadius,
	      outerRadius = props.outerRadius,
	      x = props.x,
	      y = props.y,
	      top = props.top,
	      left = props.left,
	      width = props.width,
	      height = props.height,
	      clockWise = props.clockWise;
	
	
	  if ((0, _DataUtils.isNumber)(width) && (0, _DataUtils.isNumber)(height)) {
	    if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	      return { x: x, y: y, width: width, height: height };
	    } else if ((0, _DataUtils.isNumber)(top) && (0, _DataUtils.isNumber)(left)) {
	      return { x: top, y: left, width: width, height: height };
	    }
	  }
	
	  if ((0, _DataUtils.isNumber)(x) && (0, _DataUtils.isNumber)(y)) {
	    return { x: x, y: y, width: 0, height: 0 };
	  }
	
	  if ((0, _DataUtils.isNumber)(cx) && (0, _DataUtils.isNumber)(cy)) {
	    return {
	      cx: cx, cy: cy,
	      startAngle: startAngle || angle || 0,
	      endAngle: endAngle || angle || 0,
	      innerRadius: innerRadius || 0,
	      outerRadius: outerRadius || radius || r || 0,
	      clockWise: clockWise
	    };
	  }
	
	  if (props.viewBox) {
	    return props.viewBox;
	  }
	
	  return {};
	};
	
	var parseLabel = function parseLabel(label, viewBox) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', viewBox: viewBox });
	  }
	
	  if ((0, _DataUtils.isNumOrStr)(label)) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', viewBox: viewBox, value: label });
	  }
	
	  if ((0, _react.isValidElement)(label) || (0, _isFunction3.default)(label)) {
	    return _react2.default.createElement(Label, { key: 'label-implicit', content: label, viewBox: viewBox });
	  }
	
	  if ((0, _isObject3.default)(label)) {
	    return _react2.default.createElement(Label, _extends({ viewBox: viewBox }, label, { key: 'label-implicit' }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	  var children = parentProps.children;
	
	  var parentViewBox = parseViewBox(parentProps);
	
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, Label).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      viewBox: viewBox || parentViewBox,
	      key: 'label-' + index
	    });
	  });
	
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
	
	  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
	};
	
	Label.parseViewBox = parseViewBox;
	Label.renderCallByParent = renderCallByParent;
	
	exports.default = Label;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isObject2 = __webpack_require__(87);
	
	var _isObject3 = _interopRequireDefault(_isObject2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _last2 = __webpack_require__(1005);
	
	var _last3 = _interopRequireDefault(_last2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  id: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  valueAccessor: _propTypes2.default.func,
	  clockWise: _propTypes2.default.bool,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func])
	};
	
	var defaultProps = {
	  valueAccessor: function valueAccessor(entry) {
	    return (0, _isArray3.default)(entry.value) ? (0, _last3.default)(entry.value) : entry.value;
	  }
	};
	
	function LabelList(props) {
	  var data = props.data,
	      valueAccessor = props.valueAccessor,
	      dataKey = props.dataKey,
	      clockWise = props.clockWise,
	      id = props.id,
	      others = _objectWithoutProperties(props, ['data', 'valueAccessor', 'dataKey', 'clockWise', 'id']);
	
	  if (!data || !data.length) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _Layer2.default,
	    { className: 'recharts-label-list' },
	    data.map(function (entry, index) {
	      var value = (0, _isNil3.default)(dataKey) ? valueAccessor(entry, index) : (0, _ChartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
	      var idProps = (0, _isNil3.default)(id) ? {} : {
	        id: id + '-' + index
	      };
	
	      return _react2.default.createElement(_Label2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(entry), others, idProps, {
	        index: index,
	        value: value,
	        viewBox: _Label2.default.parseViewBox((0, _isNil3.default)(clockWise) ? entry : _extends({}, entry, { clockWise: clockWise })),
	        key: 'label-' + index
	      }));
	    })
	  );
	}
	
	LabelList.propTypes = propTypes;
	LabelList.displayName = 'LabelList';
	
	var parseLabelList = function parseLabelList(label, data) {
	  if (!label) {
	    return null;
	  }
	
	  if (label === true) {
	    return _react2.default.createElement(LabelList, { key: 'labelList-implicit', data: data });
	  }
	
	  if (_react2.default.isValidElement(label) || (0, _isFunction3.default)(label)) {
	    return _react2.default.createElement(LabelList, { key: 'labelList-implicit', data: data, content: label });
	  }
	
	  if ((0, _isObject3.default)(label)) {
	    return _react2.default.createElement(LabelList, _extends({ data: data }, label, { key: 'labelList-implicit' }));
	  }
	
	  return null;
	};
	
	var renderCallByParent = function renderCallByParent(parentProps, data) {
	  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
	    return null;
	  }
	  var children = parentProps.children;
	
	
	  var explicitChilren = (0, _ReactUtils.findAllByType)(children, LabelList).map(function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      data: data,
	      key: 'labelList-' + index
	    });
	  });
	  if (!ckeckPropsLabel) {
	    return explicitChilren;
	  }
	
	  var implicitLabelList = parseLabelList(parentProps.label, data);
	
	  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
	};
	
	LabelList.renderCallByParent = renderCallByParent;
	LabelList.defaultProps = defaultProps;
	
	exports.default = LabelList;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LabeledScaleHelper = exports.ScaleHelper = exports.rectWithCoords = exports.rectWithPoints = exports.formatAxisMap = undefined;
	
	var _every2 = __webpack_require__(2427);
	
	var _every3 = _interopRequireDefault(_every2);
	
	var _mapValues2 = __webpack_require__(2441);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Calculate the scale function, position, width, height of axes
	 * @param  {Object} props     Latest props
	 * @param  {Object} axisMap   The configuration of axes
	 * @param  {Object} offset    The offset of main part in the svg element
	 * @param  {String} axisType  The type of axes, x-axis or y-axis
	 * @param  {String} chartName The name of chart
	 * @return {Object} Configuration
	 */
	var formatAxisMap = exports.formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
	  var width = props.width,
	      height = props.height,
	      layout = props.layout;
	
	  var ids = Object.keys(axisMap);
	  var steps = {
	    left: offset.left,
	    leftMirror: offset.left,
	    right: width - offset.right,
	    rightMirror: width - offset.right,
	    top: offset.top,
	    topMirror: offset.top,
	    bottom: height - offset.bottom,
	    bottomMirror: height - offset.bottom
	  };
	
	  return ids.reduce(function (result, id) {
	    var axis = axisMap[id];
	    var orientation = axis.orientation,
	        domain = axis.domain,
	        _axis$padding = axis.padding,
	        padding = _axis$padding === undefined ? {} : _axis$padding,
	        mirror = axis.mirror,
	        reversed = axis.reversed;
	
	    var offsetKey = '' + orientation + (mirror ? 'Mirror' : '');
	
	    var range = void 0,
	        x = void 0,
	        y = void 0,
	        needSpace = void 0;
	
	    if (axisType === 'xAxis') {
	      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
	    } else if (axisType === 'yAxis') {
	      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
	    } else {
	      range = axis.range;
	    }
	
	    if (reversed) {
	      range = [range[1], range[0]];
	    }
	
	    var _parseScale = (0, _ChartUtils.parseScale)(axis, chartName),
	        scale = _parseScale.scale,
	        realScaleType = _parseScale.realScaleType;
	
	    scale.domain(domain).range(range);
	    (0, _ChartUtils.checkDomainOfScale)(scale);
	    var ticks = (0, _ChartUtils.getTicksOfScale)(scale, _extends({}, axis, { realScaleType: realScaleType }));
	
	    if (axisType === 'xAxis') {
	      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	      x = offset.left;
	      y = steps[offsetKey] - needSpace * axis.height;
	    } else if (axisType === 'yAxis') {
	      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	      x = steps[offsetKey] - needSpace * axis.width;
	      y = offset.top;
	    }
	
	    var finalAxis = _extends({}, axis, ticks, {
	      realScaleType: realScaleType, x: x, y: y, scale: scale,
	      width: axisType === 'xAxis' ? offset.width : axis.width,
	      height: axisType === 'yAxis' ? offset.height : axis.height
	    });
	
	    finalAxis.bandSize = (0, _ChartUtils.getBandSizeOfAxis)(finalAxis, ticks);
	
	    if (!axis.hide && axisType === 'xAxis') {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
	    } else if (!axis.hide) {
	      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
	    }
	
	    return _extends({}, result, _defineProperty({}, id, finalAxis));
	  }, {});
	};
	
	var rectWithPoints = exports.rectWithPoints = function rectWithPoints(_ref, _ref2) {
	  var x1 = _ref.x,
	      y1 = _ref.y;
	  var x2 = _ref2.x,
	      y2 = _ref2.y;
	  return {
	    x: Math.min(x1, x2),
	    y: Math.min(y1, y2),
	    width: Math.abs(x2 - x1),
	    height: Math.abs(y2 - y1)
	  };
	};
	
	/**
	 * Compute the x, y, width, and height of a box from two reference points.
	 * @param  {Object} coords     x1, x2, y1, and y2
	 * @return {Object} object
	 */
	var rectWithCoords = exports.rectWithCoords = function rectWithCoords(_ref3) {
	  var x1 = _ref3.x1,
	      y1 = _ref3.y1,
	      x2 = _ref3.x2,
	      y2 = _ref3.y2;
	  return rectWithPoints({ x: x1, y: y1 }, { x: x2, y: y2 });
	};
	
	var ScaleHelper = exports.ScaleHelper = (_temp = _class = function () {
	  _createClass(ScaleHelper, null, [{
	    key: 'create',
	    value: function create(obj) {
	      return new ScaleHelper(obj);
	    }
	  }]);
	
	  function ScaleHelper(scale) {
	    _classCallCheck(this, ScaleHelper);
	
	    this.scale = scale;
	  }
	
	  _createClass(ScaleHelper, [{
	    key: 'apply',
	    value: function apply(value) {
	      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref4.bandAware;
	
	      if (value === undefined) {
	        return undefined;
	      } else if (bandAware) {
	        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
	        return this.scale(value) + offset;
	      }
	      return this.scale(value);
	    }
	  }, {
	    key: 'isInRange',
	    value: function isInRange(value) {
	      var range = this.range();
	
	      var first = range[0];
	      var last = range[range.length - 1];
	
	      return first <= last ? value >= first && value <= last : value >= last && value <= first;
	    }
	  }, {
	    key: 'domain',
	    get: function get() {
	      return this.scale.domain;
	    }
	  }, {
	    key: 'range',
	    get: function get() {
	      return this.scale.range;
	    }
	  }, {
	    key: 'rangeMin',
	    get: function get() {
	      return this.range()[0];
	    }
	  }, {
	    key: 'rangeMax',
	    get: function get() {
	      return this.range()[1];
	    }
	  }, {
	    key: 'bandwidth',
	    get: function get() {
	      return this.scale.bandwidth;
	    }
	  }]);
	
	  return ScaleHelper;
	}(), _class.EPS = 1e-4, _temp);
	
	var LabeledScaleHelper = exports.LabeledScaleHelper = function () {
	  _createClass(LabeledScaleHelper, null, [{
	    key: 'create',
	    value: function create(obj) {
	      return new this(obj);
	    }
	  }]);
	
	  function LabeledScaleHelper(scales) {
	    _classCallCheck(this, LabeledScaleHelper);
	
	    this.scales = (0, _mapValues3.default)(scales, ScaleHelper.create);
	    Object.assign(this, this.scales);
	  }
	
	  _createClass(LabeledScaleHelper, [{
	    key: 'apply',
	    value: function apply(coords) {
	      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	          bandAware = _ref5.bandAware;
	
	      var scales = this.scales;
	
	      return (0, _mapValues3.default)(coords, function (value, label) {
	        return scales[label].apply(value, { bandAware: bandAware });
	      });
	    }
	  }, {
	    key: 'isInRange',
	    value: function isInRange(coords) {
	      var scales = this.scales;
	
	      return (0, _every3.default)(coords, function (value, label) {
	        return scales[label].isInRange(value);
	      });
	    }
	  }]);
	
	  return LabeledScaleHelper;
	}();

/***/ },
/* 140 */
87,
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (name, context, definition) {
	  if (typeof module !== 'undefined' && module.exports) module.exports = definition();
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  else context[name] = definition();
	})('urljoin', this, function () {
	
	  function normalize (str, options) {
	
	    // make sure protocol is followed by two slashes
	    str = str.replace(/:\//g, '://');
	
	    // remove consecutive slashes
	    str = str.replace(/([^:\s])\/+/g, '$1/');
	
	    // remove trailing slash before parameters or hash
	    str = str.replace(/\/(\?|&|#[^!])/g, '$1');
	
	    // replace ? in parameters with &
	    str = str.replace(/(\?.+)\?/g, '$1&');
	
	    return str;
	  }
	
	  return function () {
	    var input = arguments;
	    var options = {};
	
	    if (typeof arguments[0] === 'object') {
	      // new syntax with array and options
	      input = arguments[0];
	      options = arguments[1] || {};
	    }
	
	    var joined = [].slice.call(input, 0).join('/');
	    return normalize(joined, options);
	  };
	
	});


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(1442);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _buttonGroup = __webpack_require__(1441);
	
	var _buttonGroup2 = _interopRequireDefault(_buttonGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_button2['default'].Group = _buttonGroup2['default'];
	exports['default'] = _button2['default'];

/***/ },
/* 143 */
[3343, 217],
/* 144 */
[3345, 177],
/* 145 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(760);
	var defined = __webpack_require__(401);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.2.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var ascending = function(a, b) {
	  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	};
	
	var bisector = function(compare) {
	  if (compare.length === 1) compare = ascendingComparator(compare);
	  return {
	    left: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) < 0) lo = mid + 1;
	        else hi = mid;
	      }
	      return lo;
	    },
	    right: function(a, x, lo, hi) {
	      if (lo == null) lo = 0;
	      if (hi == null) hi = a.length;
	      while (lo < hi) {
	        var mid = lo + hi >>> 1;
	        if (compare(a[mid], x) > 0) hi = mid;
	        else lo = mid + 1;
	      }
	      return lo;
	    }
	  };
	};
	
	function ascendingComparator(f) {
	  return function(d, x) {
	    return ascending(f(d), x);
	  };
	}
	
	var ascendingBisect = bisector(ascending);
	var bisectRight = ascendingBisect.right;
	var bisectLeft = ascendingBisect.left;
	
	var pairs = function(array, f) {
	  if (f == null) f = pair;
	  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	  while (i < n) pairs[i] = f(p, p = array[++i]);
	  return pairs;
	};
	
	function pair(a, b) {
	  return [a, b];
	}
	
	var cross = function(values0, values1, reduce) {
	  var n0 = values0.length,
	      n1 = values1.length,
	      values = new Array(n0 * n1),
	      i0,
	      i1,
	      i,
	      value0;
	
	  if (reduce == null) reduce = pair;
	
	  for (i0 = i = 0; i0 < n0; ++i0) {
	    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
	      values[i] = reduce(value0, values1[i1]);
	    }
	  }
	
	  return values;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var number = function(x) {
	  return x === null ? NaN : +x;
	};
	
	var variance = function(values, valueof) {
	  var n = values.length,
	      m = 0,
	      i = -1,
	      mean = 0,
	      value,
	      delta,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        delta = value - mean;
	        mean += delta / ++m;
	        sum += delta * (value - mean);
	      }
	    }
	  }
	
	  if (m > 1) return sum / (m - 1);
	};
	
	var deviation = function(array, f) {
	  var v = variance(array, f);
	  return v ? Math.sqrt(v) : v;
	};
	
	var extent = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null) {
	            if (min > value) min = value;
	            if (max < value) max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return [min, max];
	};
	
	var array = Array.prototype;
	
	var slice = array.slice;
	var map = array.map;
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var range = function(start, stop, step) {
	  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	  var i = -1,
	      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	      range = new Array(n);
	
	  while (++i < n) {
	    range[i] = start + i * step;
	  }
	
	  return range;
	};
	
	var e10 = Math.sqrt(50);
	var e5 = Math.sqrt(10);
	var e2 = Math.sqrt(2);
	
	var ticks = function(start, stop, count) {
	  var reverse,
	      i = -1,
	      n,
	      ticks,
	      step;
	
	  stop = +stop, start = +start, count = +count;
	  if (start === stop && count > 0) return [start];
	  if (reverse = stop < start) n = start, start = stop, stop = n;
	  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
	
	  if (step > 0) {
	    start = Math.ceil(start / step);
	    stop = Math.floor(stop / step);
	    ticks = new Array(n = Math.ceil(stop - start + 1));
	    while (++i < n) ticks[i] = (start + i) * step;
	  } else {
	    start = Math.floor(start * step);
	    stop = Math.ceil(stop * step);
	    ticks = new Array(n = Math.ceil(start - stop + 1));
	    while (++i < n) ticks[i] = (start - i) / step;
	  }
	
	  if (reverse) ticks.reverse();
	
	  return ticks;
	};
	
	function tickIncrement(start, stop, count) {
	  var step = (stop - start) / Math.max(0, count),
	      power = Math.floor(Math.log(step) / Math.LN10),
	      error = step / Math.pow(10, power);
	  return power >= 0
	      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
	      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
	}
	
	function tickStep(start, stop, count) {
	  var step0 = Math.abs(stop - start) / Math.max(0, count),
	      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	      error = step0 / step1;
	  if (error >= e10) step1 *= 10;
	  else if (error >= e5) step1 *= 5;
	  else if (error >= e2) step1 *= 2;
	  return stop < start ? -step1 : step1;
	}
	
	var sturges = function(values) {
	  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	};
	
	var histogram = function() {
	  var value = identity,
	      domain = extent,
	      threshold = sturges;
	
	  function histogram(data) {
	    var i,
	        n = data.length,
	        x,
	        values = new Array(n);
	
	    for (i = 0; i < n; ++i) {
	      values[i] = value(data[i], i, data);
	    }
	
	    var xz = domain(values),
	        x0 = xz[0],
	        x1 = xz[1],
	        tz = threshold(values, x0, x1);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      tz = tickStep(x0, x1, tz);
	      tz = range(Math.ceil(x0 / tz) * tz, Math.floor(x1 / tz) * tz, tz); // exclusive
	    }
	
	    // Remove any thresholds outside the domain.
	    var m = tz.length;
	    while (tz[0] <= x0) tz.shift(), --m;
	    while (tz[m - 1] > x1) tz.pop(), --m;
	
	    var bins = new Array(m + 1),
	        bin;
	
	    // Initialize bins.
	    for (i = 0; i <= m; ++i) {
	      bin = bins[i] = [];
	      bin.x0 = i > 0 ? tz[i - 1] : x0;
	      bin.x1 = i < m ? tz[i] : x1;
	    }
	
	    // Assign data to bins by value, ignoring any outside the domain.
	    for (i = 0; i < n; ++i) {
	      x = values[i];
	      if (x0 <= x && x <= x1) {
	        bins[bisectRight(tz, x, 0, m)].push(data[i]);
	      }
	    }
	
	    return bins;
	  }
	
	  histogram.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	  };
	
	  histogram.domain = function(_) {
	    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	  };
	
	  histogram.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	  };
	
	  return histogram;
	};
	
	var quantile = function(values, p, valueof) {
	  if (valueof == null) valueof = number;
	  if (!(n = values.length)) return;
	  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
	  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
	  var n,
	      i = (n - 1) * p,
	      i0 = Math.floor(i),
	      value0 = +valueof(values[i0], i0, values),
	      value1 = +valueof(values[i0 + 1], i0 + 1, values);
	  return value0 + (value1 - value0) * (i - i0);
	};
	
	var freedmanDiaconis = function(values, min, max) {
	  values = map.call(values, number).sort(ascending);
	  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	};
	
	var scott = function(values, min, max) {
	  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	};
	
	var max = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      max;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        max = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && value > max) {
	            max = value;
	          }
	        }
	      }
	    }
	  }
	
	  return max;
	};
	
	var mean = function(values, valueof) {
	  var n = values.length,
	      m = n,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) sum += value;
	      else --m;
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
	      else --m;
	    }
	  }
	
	  if (m) return sum / m;
	};
	
	var median = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      numbers = [];
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (!isNaN(value = number(values[i]))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (!isNaN(value = number(valueof(values[i], i, values)))) {
	        numbers.push(value);
	      }
	    }
	  }
	
	  return quantile(numbers.sort(ascending), 0.5);
	};
	
	var merge = function(arrays) {
	  var n = arrays.length,
	      m,
	      i = -1,
	      j = 0,
	      merged,
	      array;
	
	  while (++i < n) j += arrays[i].length;
	  merged = new Array(j);
	
	  while (--n >= 0) {
	    array = arrays[n];
	    m = array.length;
	    while (--m >= 0) {
	      merged[--j] = array[m];
	    }
	  }
	
	  return merged;
	};
	
	var min = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      min;
	
	  if (valueof == null) {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = values[i]) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = values[i]) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  else {
	    while (++i < n) { // Find the first comparable value.
	      if ((value = valueof(values[i], i, values)) != null && value >= value) {
	        min = value;
	        while (++i < n) { // Compare the remaining values.
	          if ((value = valueof(values[i], i, values)) != null && min > value) {
	            min = value;
	          }
	        }
	      }
	    }
	  }
	
	  return min;
	};
	
	var permute = function(array, indexes) {
	  var i = indexes.length, permutes = new Array(i);
	  while (i--) permutes[i] = array[indexes[i]];
	  return permutes;
	};
	
	var scan = function(values, compare) {
	  if (!(n = values.length)) return;
	  var n,
	      i = 0,
	      j = 0,
	      xi,
	      xj = values[j];
	
	  if (compare == null) compare = ascending;
	
	  while (++i < n) {
	    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
	      xj = xi, j = i;
	    }
	  }
	
	  if (compare(xj, xj) === 0) return j;
	};
	
	var shuffle = function(array, i0, i1) {
	  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m + i0];
	    array[m + i0] = array[i + i0];
	    array[i + i0] = t;
	  }
	
	  return array;
	};
	
	var sum = function(values, valueof) {
	  var n = values.length,
	      i = -1,
	      value,
	      sum = 0;
	
	  if (valueof == null) {
	    while (++i < n) {
	      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
	    }
	  }
	
	  else {
	    while (++i < n) {
	      if (value = +valueof(values[i], i, values)) sum += value;
	    }
	  }
	
	  return sum;
	};
	
	var transpose = function(matrix) {
	  if (!(n = matrix.length)) return [];
	  for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	      row[j] = matrix[j][i];
	    }
	  }
	  return transpose;
	};
	
	function length(d) {
	  return d.length;
	}
	
	var zip = function() {
	  return transpose(arguments);
	};
	
	exports.bisect = bisectRight;
	exports.bisectRight = bisectRight;
	exports.bisectLeft = bisectLeft;
	exports.ascending = ascending;
	exports.bisector = bisector;
	exports.cross = cross;
	exports.descending = descending;
	exports.deviation = deviation;
	exports.extent = extent;
	exports.histogram = histogram;
	exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	exports.thresholdScott = scott;
	exports.thresholdSturges = sturges;
	exports.max = max;
	exports.mean = mean;
	exports.median = median;
	exports.merge = merge;
	exports.min = min;
	exports.pairs = pairs;
	exports.permute = permute;
	exports.quantile = quantile;
	exports.range = range;
	exports.scan = scan;
	exports.shuffle = shuffle;
	exports.sum = sum;
	exports.ticks = ticks;
	exports.tickIncrement = tickIncrement;
	exports.tickStep = tickStep;
	exports.transpose = transpose;
	exports.variance = variance;
	exports.zip = zip;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(71);
	var Immutable = __webpack_require__(26);
	
	var findRangesImmutable = __webpack_require__(227);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlock = function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock(config) {
	    _classCallCheck(this, ContentBlock);
	
	    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
	  }
	
	  ContentBlock.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlock.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlock.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlock.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlock.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlock.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlock.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	
	
	  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	
	
	  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	exports.default = parse;
	exports.is_viable_phone_number = is_viable_phone_number;
	exports.extract_formatted_phone_number = extract_formatted_phone_number;
	exports.strip_national_prefix_and_carrier_code = strip_national_prefix_and_carrier_code;
	exports.find_country_code = find_country_code;
	
	var _common = __webpack_require__(127);
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _types = __webpack_require__(306);
	
	var _types2 = _interopRequireDefault(_types);
	
	var _RFC = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// The minimum length of the national significant number.
	var MIN_LENGTH_FOR_NSN = 2;
	
	// We don't allow input strings for parsing to be longer than 250 chars.
	// This prevents malicious input from consuming CPU.
	var MAX_INPUT_STRING_LENGTH = 250;
	
	/**
	 * Regexp of all possible ways to write extensions, for use when parsing. This
	 * will be run as a case-insensitive regexp match. Wide character versions are
	 * also provided after each ASCII version. There are three regular expressions
	 * here. The first covers RFC 3966 format, where the extension is added using
	 * ';ext='. The second more generic one starts with optional white space and
	 * ends with an optional full stop (.), followed by zero or more spaces/tabs
	 * /commas and then the numbers themselves. The other one covers the special
	 * case of American numbers where the extension is written with a hash at the
	 * end, such as '- 503#'. Note that the only capturing groups should be around
	 * the digits that you want to capture as part of the extension, or else parsing
	 * will fail! We allow two options for representing the accented o - the
	 * character itself, and one in the unicode decomposed form with the combining
	 * acute accent.
	 */
	var EXTN_PATTERNS_FOR_PARSING = (0, _common.create_extension_pattern)('parsing');
	
	// Regexp of all known extension prefixes used by different regions followed by
	// 1 or more valid digits, for use when parsing.
	var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i');
	
	//  Regular expression of viable phone numbers. This is location independent.
	//  Checks we have at least three leading digits, and only valid punctuation,
	//  alpha characters and digits in the phone number. Does not include extension
	//  data. The symbol 'x' is allowed here as valid punctuation since it is often
	//  used as a placeholder for carrier codes, for example in Brazilian phone
	//  numbers. We also allow multiple '+' characters at the start.
	//
	//  Corresponds to the following:
	//  [digits]{minLengthNsn}|
	//  plus_sign*
	//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
	//
	//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
	//  they are entered as "15" etc, but only if there is no punctuation in them.
	//  The second expression restricts the number of digits to three or more, but
	//  then allows them to be in international form, and to have alpha-characters
	//  and punctuation. We split up the two reg-exes here and combine them when
	//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
	//  with ^ and append $ to each branch.
	//
	//  "Note VALID_PUNCTUATION starts with a -,
	//   so must be the first in the range" (c) Google devs.
	//  (wtf did they mean by saying that; probably nothing)
	//
	var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + _common.VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}';
	//
	// And this is the second reg-exp:
	// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
	//
	var VALID_PHONE_NUMBER = '[' + _common.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _common.VALID_PUNCTUATION + ']*' + '[' + _common.VALID_DIGITS + ']' + '){3,}' + '[' + _common.VALID_PUNCTUATION + _common.VALID_DIGITS + ']*';
	
	// The combined regular expression for valid phone numbers:
	//
	var VALID_PHONE_NUMBER_PATTERN = new RegExp(
	// Either a short two-digit-only phone number
	'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
	// Or a longer fully parsed phone number (min 3 characters)
	'^' + VALID_PHONE_NUMBER +
	// Phone number extensions
	'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' + '$', 'i');
	
	// This consists of the plus symbol, digits, and arabic-indic digits.
	var PHONE_NUMBER_START_PATTERN = new RegExp('[' + _common.PLUS_CHARS + _common.VALID_DIGITS + ']');
	
	// Regular expression of trailing characters that we want to remove.
	var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + _common.VALID_DIGITS + ']+$');
	
	var default_options = {
		country: {}
	
		// `options`:
		//  {
		//    country:
		//    {
		//      restrict - (a two-letter country code)
		//                 the phone number must be in this country
		//
		//      default - (a two-letter country code)
		//                default country to use for phone number parsing and validation
		//                (if no country code could be derived from the phone number)
		//    }
		//  }
		//
		// Returns `{ country, number }`
		//
		// Example use cases:
		//
		// ```js
		// parse('8 (800) 555-35-35', 'RU')
		// parse('8 (800) 555-35-35', 'RU', metadata)
		// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
		// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
		// parse('+7 800 555 35 35')
		// parse('+7 800 555 35 35', metadata)
		// ```
		//
	};function parse(arg_1, arg_2, arg_3, arg_4) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
		    text = _sort_out_arguments.text,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		// Validate `defaultCountry`.
	
	
		if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
			throw new Error('Unknown country: ' + options.defaultCountry);
		}
	
		// Parse the phone number.
	
		var _parse_input = parse_input(text),
		    formatted_phone_number = _parse_input.number,
		    ext = _parse_input.ext;
	
		// If the phone number is not viable then return nothing.
	
	
		if (!formatted_phone_number) {
			return {};
		}
	
		var _parse_phone_number = parse_phone_number(formatted_phone_number, options.defaultCountry, metadata),
		    country = _parse_phone_number.country,
		    national_number = _parse_phone_number.national_number,
		    countryCallingCode = _parse_phone_number.countryCallingCode,
		    carrierCode = _parse_phone_number.carrierCode;
	
		if (!metadata.selectedCountry()) {
			return options.extended ? { countryCallingCode: countryCallingCode } : {};
		}
	
		// Validate national (significant) number length.
		//
		// A sidenote:
		//
		// They say that sometimes national (significant) numbers
		// can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
		// https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
		// Such numbers will just be discarded.
		//
		if (national_number.length < MIN_LENGTH_FOR_NSN || national_number.length > _common.MAX_LENGTH_FOR_NSN) {
			// Google's demo just throws an error in this case.
			return options.extended ? { countryCallingCode: countryCallingCode } : {};
		}
	
		// Check if national phone number pattern matches the number
		// National number pattern is different for each country,
		// even for those ones which are part of the "NANPA" group.
		var valid = country && (0, _common.matches_entirely)(national_number, new RegExp(metadata.nationalNumberPattern())) ? true : false;
	
		if (!options.extended) {
			return valid ? result(country, national_number, ext) : {};
		}
	
		return {
			country: country,
			countryCallingCode: countryCallingCode,
			carrierCode: carrierCode,
			valid: valid,
			possible: valid ? true : options.extended === true && metadata.possibleLengths() && is_possible_number(national_number, countryCallingCode !== undefined, metadata),
			phone: national_number,
			ext: ext
		};
	}
	
	// Checks to see if the string of characters could possibly be a phone number at
	// all. At the moment, checks to see that the string begins with at least 2
	// digits, ignoring any punctuation commonly found in phone numbers. This method
	// does not require the number to be normalized in advance - but does assume
	// that leading non-number symbols have been removed, such as by the method
	// `extract_possible_number`.
	//
	function is_viable_phone_number(number) {
		return number.length >= MIN_LENGTH_FOR_NSN && (0, _common.matches_entirely)(number, VALID_PHONE_NUMBER_PATTERN);
	}
	
	/**
	 * Extracts a parseable phone number.
	 * @param  {string} text - Input.
	 * @return {string}.
	 */
	function extract_formatted_phone_number(text) {
		if (!text || text.length > MAX_INPUT_STRING_LENGTH) {
			return;
		}
	
		// Attempt to extract a possible number from the string passed in
	
		var starts_at = text.search(PHONE_NUMBER_START_PATTERN);
	
		if (starts_at < 0) {
			return;
		}
	
		return text
		// Trim everything to the left of the phone number
		.slice(starts_at)
		// Remove trailing non-numerical characters
		.replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
	}
	
	// Strips any national prefix (such as 0, 1) present in the number provided.
	// "Carrier codes" are only used  in Colombia and Brazil,
	// and only when dialing within those countries from a mobile phone to a fixed line number.
	function strip_national_prefix_and_carrier_code(number, metadata) {
		if (!number || !metadata.nationalPrefixForParsing()) {
			return { number: number };
		}
	
		// Attempt to parse the first digits as a national prefix
		var national_prefix_pattern = new RegExp('^(?:' + metadata.nationalPrefixForParsing() + ')');
		var national_prefix_matcher = national_prefix_pattern.exec(number);
	
		// If no national prefix is present in the phone number,
		// but the national prefix is optional for this country,
		// then consider this phone number valid.
		//
		// Google's reference `libphonenumber` implementation
		// wouldn't recognize such phone numbers as valid,
		// but I think it would perfectly make sense
		// to consider such phone numbers as valid
		// because if a national phone number was originally
		// formatted without the national prefix
		// then it must be parseable back into the original national number.
		// In other words, `parse(format(number))`
		// must always be equal to `number`.
		//
		if (!national_prefix_matcher) {
			return { number: number };
		}
	
		var national_significant_number = void 0;
	
		// `national_prefix_for_parsing` capturing groups
		// (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
		var captured_groups_count = national_prefix_matcher.length - 1;
	
		// If the national number tranformation is needed then do it.
		//
		// I don't know what did they mean by `&& national_prefix_matcher[captured_groups_count]`.
		// https://github.com/googlei18n/libphonenumber/blob/d978e59c2e6b1ddfb6816cd190e1b62d9a96bc3b/javascript/i18n/phonenumbers/phonenumberutil.js#L3885
		// https://github.com/googlei18n/libphonenumber/blob/d978e59c2e6b1ddfb6816cd190e1b62d9a96bc3b/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2906
		//
		if (metadata.nationalPrefixTransformRule() && national_prefix_matcher[captured_groups_count]) {
			national_significant_number = number.replace(national_prefix_pattern, metadata.nationalPrefixTransformRule());
		}
		// Else, no transformation is necessary,
		// and just strip the national prefix.
		else {
				national_significant_number = number.slice(national_prefix_matcher[0].length);
			}
	
		var carrierCode = void 0;
		if (captured_groups_count > 0) {
			carrierCode = national_prefix_matcher[1];
		}
	
		// The following is done in `get_country_and_national_number_for_local_number()` instead.
		//
		// // Verify the parsed national (significant) number for this country
		// const national_number_rule = new RegExp(metadata.nationalNumberPattern())
		// //
		// // If the original number (before stripping national prefix) was viable,
		// // and the resultant number is not, then prefer the original phone number.
		// // This is because for some countries (e.g. Russia) the same digit could be both
		// // a national prefix and a leading digit of a valid national phone number,
		// // like `8` is the national prefix for Russia and both
		// // `8 800 555 35 35` and `800 555 35 35` are valid numbers.
		// if (matches_entirely(number, national_number_rule) &&
		// 		!matches_entirely(national_significant_number, national_number_rule))
		// {
		// 	return number
		// }
	
		// Return the parsed national (significant) number
		return {
			number: national_significant_number,
			carrierCode: carrierCode
		};
	}
	
	function find_country_code(country_calling_code, national_phone_number, metadata) {
		// Is always non-empty, because `country_calling_code` is always valid
		var possible_countries = metadata.countryCallingCodes()[country_calling_code];
	
		// If there's just one country corresponding to the country code,
		// then just return it, without further phone number digits validation.
		if (possible_countries.length === 1) {
			return possible_countries[0];
		}
	
		return _find_country_code(possible_countries, national_phone_number, metadata.metadata);
	}
	
	// Changes `metadata` `country`.
	function _find_country_code(possible_countries, national_phone_number, metadata) {
		metadata = new _metadata2.default(metadata);
	
		for (var _iterator = possible_countries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var country = _ref;
	
			metadata.country(country);
	
			// Leading digits check would be the simplest one
			if (metadata.leadingDigits()) {
				if (national_phone_number && national_phone_number.search(metadata.leadingDigits()) === 0) {
					return country;
				}
			}
			// Else perform full validation with all of those
			// fixed-line/mobile/etc regular expressions.
			else if ((0, _types2.default)({ phone: national_phone_number, country: country }, metadata.metadata)) {
					return country;
				}
		}
	}
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
		var text = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// If the phone number is passed as a string.
		// `parse('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			text = arg_1;
		} else throw new TypeError('A phone number for parsing must be a string.');
	
		// If "default country" argument is being passed
		// then move it to `options`.
		// `parse('88005553535', 'RU', [options], metadata)`.
		if (typeof arg_2 === 'string') {
			if (arg_4) {
				options = _extends({ defaultCountry: arg_2 }, arg_3);
				metadata = arg_4;
			} else {
				options = { defaultCountry: arg_2 };
				metadata = arg_3;
			}
		}
		// No "default country" argument is being passed.
		// International phone number is passed.
		// `parse('+78005553535', [options], metadata)`.
		else {
				if (arg_3) {
					options = arg_2;
					metadata = arg_3;
				} else {
					metadata = arg_2;
				}
			}
	
		// Apply default options.
		if (options) {
			options = _extends({}, default_options, options);
		} else {
			options = default_options;
		}
	
		return { text: text, options: options, metadata: new _metadata2.default(metadata) };
	}
	
	// Strips any extension (as in, the part of the number dialled after the call is
	// connected, usually indicated with extn, ext, x or similar) from the end of
	// the number, and returns it.
	function strip_extension(number) {
		var start = number.search(EXTN_PATTERN);
		if (start < 0) {
			return {};
		}
	
		// If we find a potential extension, and the number preceding this is a viable
		// number, we assume it is an extension.
		var number_without_extension = number.slice(0, start);
		/* istanbul ignore if - seems a bit of a redundant check */
		if (!is_viable_phone_number(number_without_extension)) {
			return {};
		}
	
		var matches = number.match(EXTN_PATTERN);
		var i = 1;
		while (i < matches.length) {
			if (matches[i] != null && matches[i].length > 0) {
				return {
					number: number_without_extension,
					ext: matches[i]
				};
			}
			i++;
		}
	}
	
	function is_possible_number(national_number, is_international, metadata) {
		switch ((0, _types.check_number_length_for_type)(national_number, undefined, metadata)) {
			case 'IS_POSSIBLE':
				return true;
			// case 'IS_POSSIBLE_LOCAL_ONLY':
			// 	return !is_international
			default:
				return false;
		}
	}
	
	/**
	 * @param  {string} text - Input.
	 * @return {object} `{ ?number, ?ext }`.
	 */
	function parse_input(text) {
		// Parse RFC 3966 phone number URI.
		if (text && text.indexOf('tel:') === 0) {
			return (0, _RFC.parseRFC3966)(text);
		}
	
		var number = extract_formatted_phone_number(text);
	
		// If the phone number is not viable, then abort.
		if (!number || !is_viable_phone_number(number)) {
			return {};
		}
	
		// Attempt to parse extension first, since it doesn't require region-specific
		// data and we want to have the non-normalised number here.
		var with_extension_stripped = strip_extension(number);
		if (with_extension_stripped.ext) {
			return with_extension_stripped;
		}
	
		return { number: number };
	}
	
	/**
	 * Creates `parse()` result object.
	 */
	function result(country, national_number, ext) {
		var result = {
			country: country,
			phone: national_number
		};
	
		if (ext) {
			result.ext = ext;
		}
	
		return result;
	}
	
	/**
	 * Parses a viable phone number.
	 * Returns `{ country, countryCallingCode, national_number }`.
	 */
	function parse_phone_number(formatted_phone_number, default_country, metadata) {
		var _parse_national_numbe = (0, _common.parse_national_number_and_country_calling_code)(formatted_phone_number, default_country, metadata),
		    countryCallingCode = _parse_national_numbe.countryCallingCode,
		    number = _parse_national_numbe.number;
	
		if (!number) {
			return { countryCallingCode: countryCallingCode };
		}
	
		var country = void 0;
	
		// Attempt to extract country from international phone number.
		if (countryCallingCode) {
			// Sometimes there are several countries
			// corresponding to the same country phone code
			// (e.g. NANPA countries all having `1` country phone code).
			// Therefore, to reliably determine the exact country,
			// national (significant) number should have been parsed first.
			//
			// When `metadata.json` is generated, all "ambiguous" country phone codes
			// get their countries populated with the full set of
			// "phone number type" regular expressions.
			//
			country = find_country_code(countryCallingCode, number, metadata);
	
			if (country) {
				metadata.country(country);
			} else {
				// Formatting information for regions which share
				// a country calling code is contained by only one region
				// for performance reasons. For example, for NANPA region
				// ("North American Numbering Plan Administration",
				//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
				// it will be contained in the metadata for `US`.
				metadata.chooseCountryByCountryCallingCode(countryCallingCode);
			}
		} else if (default_country) {
			country = default_country;
			metadata.country(country);
			countryCallingCode = metadata.countryCallingCode();
		} else return {};
	
		// Parsing national prefixes and carrier codes
		// is only required for local phone numbers
		// but some people don't understand that
		// and sometimes write international phone numbers
		// with national prefixes (or maybe even carrier codes).
		// http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
		// Google's original library forgives such mistakes
		// and so does this library, because it has been requested:
		// https://github.com/catamphetamine/libphonenumber-js/issues/127
	
		var _parse_national_numbe2 = parse_national_number(number, metadata),
		    national_number = _parse_national_numbe2.national_number,
		    carrier_code = _parse_national_numbe2.carrier_code;
	
		return {
			country: country,
			countryCallingCode: countryCallingCode,
			national_number: national_number,
			carrierCode: carrier_code
		};
	}
	
	function parse_national_number(number, metadata) {
		var national_number = (0, _common.parse_phone_number_digits)(number);
		var carrier_code = void 0;
	
		// Only strip national prefixes for non-international phone numbers
		// because national prefixes can't be present in international phone numbers.
		// Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
		// first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
		// and then it would assume that's a valid number which it isn't.
		// So no forgiveness for grandmas here.
		// The issue asking for this fix:
		// https://github.com/catamphetamine/libphonenumber-js/issues/159
	
		var _strip_national_prefi = strip_national_prefix_and_carrier_code(national_number, metadata),
		    potential_national_number = _strip_national_prefi.number,
		    carrierCode = _strip_national_prefi.carrierCode;
	
		// If metadata has "possible lengths" then employ the new algorythm.
	
	
		if (metadata.possibleLengths()) {
			// We require that the NSN remaining after stripping the national prefix and
			// carrier code be long enough to be a possible length for the region.
			// Otherwise, we don't do the stripping, since the original number could be
			// a valid short number.
			switch ((0, _types.check_number_length_for_type)(potential_national_number, undefined, metadata)) {
				case 'TOO_SHORT':
				// case 'IS_POSSIBLE_LOCAL_ONLY':
				case 'INVALID_LENGTH':
					break;
				default:
					national_number = potential_national_number;
					carrier_code = carrierCode;
			}
		} else {
			// If the original number (before stripping national prefix) was viable,
			// and the resultant number is not, then prefer the original phone number.
			// This is because for some countries (e.g. Russia) the same digit could be both
			// a national prefix and a leading digit of a valid national phone number,
			// like `8` is the national prefix for Russia and both
			// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
			if ((0, _common.matches_entirely)(national_number, metadata.nationalNumberPattern()) && !(0, _common.matches_entirely)(potential_national_number, metadata.nationalNumberPattern())) {
				// Keep the number without stripping national prefix.
			} else {
				national_number = potential_national_number;
				carrier_code = carrierCode;
			}
		}
	
		return {
			national_number: national_number,
			carrier_code: carrier_code
		};
	}
	
	// Determines the country for a given (possibly incomplete) phone number.
	// export function get_country_from_phone_number(number, metadata)
	// {
	// 	return parse_phone_number(number, null, metadata).country
	// }
	//# sourceMappingURL=parse.js.map

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 152 */
[3494, 2354, 2387],
/* 153 */
[3526, 983],
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(128),
	    isArray = __webpack_require__(36),
	    isObjectLike = __webpack_require__(112);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 155 */
[3536, 128, 112],
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.toArray = toArray;
	exports.getActiveIndex = getActiveIndex;
	exports.getActiveKey = getActiveKey;
	exports.setTransform = setTransform;
	exports.isTransformSupported = isTransformSupported;
	exports.setTransition = setTransition;
	exports.getTransformPropValue = getTransformPropValue;
	exports.isVertical = isVertical;
	exports.getTransformByIndex = getTransformByIndex;
	exports.getMarginStyle = getMarginStyle;
	exports.getStyle = getStyle;
	exports.setPxStyle = setPxStyle;
	exports.getDataAttr = getDataAttr;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArray(children) {
	  // allow [c,[a,b]]
	  var c = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    if (child) {
	      c.push(child);
	    }
	  });
	  return c;
	}
	
	function getActiveIndex(children, activeKey) {
	  var c = toArray(children);
	  for (var i = 0; i < c.length; i++) {
	    if (c[i].key === activeKey) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function getActiveKey(children, index) {
	  var c = toArray(children);
	  return c[index].key;
	}
	
	function setTransform(style, v) {
	  style.transform = v;
	  style.webkitTransform = v;
	  style.mozTransform = v;
	}
	
	function isTransformSupported(style) {
	  return 'transform' in style || 'webkitTransform' in style || 'MozTransform' in style;
	}
	
	function setTransition(style, v) {
	  style.transition = v;
	  style.webkitTransition = v;
	  style.MozTransition = v;
	}
	function getTransformPropValue(v) {
	  return {
	    transform: v,
	    WebkitTransform: v,
	    MozTransform: v
	  };
	}
	
	function isVertical(tabBarPosition) {
	  return tabBarPosition === 'left' || tabBarPosition === 'right';
	}
	
	function getTransformByIndex(index, tabBarPosition) {
	  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
	  return translate + '(' + -index * 100 + '%) translateZ(0)';
	}
	
	function getMarginStyle(index, tabBarPosition) {
	  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
	  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
	}
	
	function getStyle(el, property) {
	  return +getComputedStyle(el).getPropertyValue(property).replace('px', '');
	}
	
	function setPxStyle(el, value, vertical) {
	  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
	  setTransform(el.style, 'translate3d(' + value + ')');
	}
	
	function getDataAttr(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
	      prev[key] = props[key];
	    }
	    return prev;
	  }, {});
	}

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.Well = exports.Tooltip = exports.ToggleButtonGroup = exports.ToggleButton = exports.Thumbnail = exports.Tabs = exports.TabPane = exports.Table = exports.TabContent = exports.TabContainer = exports.Tab = exports.SplitButton = exports.SafeAnchor = exports.Row = exports.ResponsiveEmbed = exports.Radio = exports.ProgressBar = exports.Popover = exports.PanelGroup = exports.Panel = exports.PaginationButton = exports.Pagination = exports.Pager = exports.PageItem = exports.PageHeader = exports.OverlayTrigger = exports.Overlay = exports.NavItem = exports.NavDropdown = exports.NavbarBrand = exports.Navbar = exports.Nav = exports.ModalTitle = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = exports.Modal = exports.MenuItem = exports.Media = exports.ListGroupItem = exports.ListGroup = exports.Label = exports.Jumbotron = exports.InputGroup = exports.Image = exports.HelpBlock = exports.Grid = exports.Glyphicon = exports.FormGroup = exports.FormControl = exports.Form = exports.Fade = exports.DropdownButton = exports.Dropdown = exports.Collapse = exports.Col = exports.ControlLabel = exports.CloseButton = exports.Clearfix = exports.Checkbox = exports.CarouselItem = exports.Carousel = exports.ButtonToolbar = exports.ButtonGroup = exports.Button = exports.BreadcrumbItem = exports.Breadcrumb = exports.Badge = exports.Alert = exports.Accordion = undefined;
	
	var _Accordion2 = __webpack_require__(2648);
	
	var _Accordion3 = _interopRequireDefault(_Accordion2);
	
	var _Alert2 = __webpack_require__(2649);
	
	var _Alert3 = _interopRequireDefault(_Alert2);
	
	var _Badge2 = __webpack_require__(2650);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _Breadcrumb2 = __webpack_require__(2651);
	
	var _Breadcrumb3 = _interopRequireDefault(_Breadcrumb2);
	
	var _BreadcrumbItem2 = __webpack_require__(1199);
	
	var _BreadcrumbItem3 = _interopRequireDefault(_BreadcrumbItem2);
	
	var _Button2 = __webpack_require__(241);
	
	var _Button3 = _interopRequireDefault(_Button2);
	
	var _ButtonGroup2 = __webpack_require__(484);
	
	var _ButtonGroup3 = _interopRequireDefault(_ButtonGroup2);
	
	var _ButtonToolbar2 = __webpack_require__(2652);
	
	var _ButtonToolbar3 = _interopRequireDefault(_ButtonToolbar2);
	
	var _Carousel2 = __webpack_require__(2653);
	
	var _Carousel3 = _interopRequireDefault(_Carousel2);
	
	var _CarouselItem2 = __webpack_require__(1200);
	
	var _CarouselItem3 = _interopRequireDefault(_CarouselItem2);
	
	var _Checkbox2 = __webpack_require__(2655);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Clearfix2 = __webpack_require__(2656);
	
	var _Clearfix3 = _interopRequireDefault(_Clearfix2);
	
	var _CloseButton2 = __webpack_require__(485);
	
	var _CloseButton3 = _interopRequireDefault(_CloseButton2);
	
	var _ControlLabel2 = __webpack_require__(2658);
	
	var _ControlLabel3 = _interopRequireDefault(_ControlLabel2);
	
	var _Col2 = __webpack_require__(2657);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	var _Collapse2 = __webpack_require__(486);
	
	var _Collapse3 = _interopRequireDefault(_Collapse2);
	
	var _Dropdown2 = __webpack_require__(331);
	
	var _Dropdown3 = _interopRequireDefault(_Dropdown2);
	
	var _DropdownButton2 = __webpack_require__(2659);
	
	var _DropdownButton3 = _interopRequireDefault(_DropdownButton2);
	
	var _Fade2 = __webpack_require__(332);
	
	var _Fade3 = _interopRequireDefault(_Fade2);
	
	var _Form2 = __webpack_require__(2661);
	
	var _Form3 = _interopRequireDefault(_Form2);
	
	var _FormControl2 = __webpack_require__(2662);
	
	var _FormControl3 = _interopRequireDefault(_FormControl2);
	
	var _FormGroup2 = __webpack_require__(2665);
	
	var _FormGroup3 = _interopRequireDefault(_FormGroup2);
	
	var _Glyphicon2 = __webpack_require__(487);
	
	var _Glyphicon3 = _interopRequireDefault(_Glyphicon2);
	
	var _Grid2 = __webpack_require__(1202);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _HelpBlock2 = __webpack_require__(2666);
	
	var _HelpBlock3 = _interopRequireDefault(_HelpBlock2);
	
	var _Image2 = __webpack_require__(2667);
	
	var _Image3 = _interopRequireDefault(_Image2);
	
	var _InputGroup2 = __webpack_require__(2668);
	
	var _InputGroup3 = _interopRequireDefault(_InputGroup2);
	
	var _Jumbotron2 = __webpack_require__(2671);
	
	var _Jumbotron3 = _interopRequireDefault(_Jumbotron2);
	
	var _Label2 = __webpack_require__(2672);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _ListGroup2 = __webpack_require__(2673);
	
	var _ListGroup3 = _interopRequireDefault(_ListGroup2);
	
	var _ListGroupItem2 = __webpack_require__(1203);
	
	var _ListGroupItem3 = _interopRequireDefault(_ListGroupItem2);
	
	var _Media2 = __webpack_require__(333);
	
	var _Media3 = _interopRequireDefault(_Media2);
	
	var _MenuItem2 = __webpack_require__(2680);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _Modal2 = __webpack_require__(2681);
	
	var _Modal3 = _interopRequireDefault(_Modal2);
	
	var _ModalBody2 = __webpack_require__(1204);
	
	var _ModalBody3 = _interopRequireDefault(_ModalBody2);
	
	var _ModalFooter2 = __webpack_require__(1205);
	
	var _ModalFooter3 = _interopRequireDefault(_ModalFooter2);
	
	var _ModalHeader2 = __webpack_require__(1206);
	
	var _ModalHeader3 = _interopRequireDefault(_ModalHeader2);
	
	var _ModalTitle2 = __webpack_require__(1207);
	
	var _ModalTitle3 = _interopRequireDefault(_ModalTitle2);
	
	var _Nav2 = __webpack_require__(1208);
	
	var _Nav3 = _interopRequireDefault(_Nav2);
	
	var _Navbar2 = __webpack_require__(2684);
	
	var _Navbar3 = _interopRequireDefault(_Navbar2);
	
	var _NavbarBrand2 = __webpack_require__(1210);
	
	var _NavbarBrand3 = _interopRequireDefault(_NavbarBrand2);
	
	var _NavDropdown2 = __webpack_require__(2683);
	
	var _NavDropdown3 = _interopRequireDefault(_NavDropdown2);
	
	var _NavItem2 = __webpack_require__(1209);
	
	var _NavItem3 = _interopRequireDefault(_NavItem2);
	
	var _Overlay2 = __webpack_require__(1211);
	
	var _Overlay3 = _interopRequireDefault(_Overlay2);
	
	var _OverlayTrigger2 = __webpack_require__(2688);
	
	var _OverlayTrigger3 = _interopRequireDefault(_OverlayTrigger2);
	
	var _PageHeader2 = __webpack_require__(2689);
	
	var _PageHeader3 = _interopRequireDefault(_PageHeader2);
	
	var _PageItem2 = __webpack_require__(2690);
	
	var _PageItem3 = _interopRequireDefault(_PageItem2);
	
	var _Pager2 = __webpack_require__(2691);
	
	var _Pager3 = _interopRequireDefault(_Pager2);
	
	var _Pagination2 = __webpack_require__(2692);
	
	var _Pagination3 = _interopRequireDefault(_Pagination2);
	
	var _PaginationButton2 = __webpack_require__(1213);
	
	var _PaginationButton3 = _interopRequireDefault(_PaginationButton2);
	
	var _Panel2 = __webpack_require__(2693);
	
	var _Panel3 = _interopRequireDefault(_Panel2);
	
	var _PanelGroup2 = __webpack_require__(1214);
	
	var _PanelGroup3 = _interopRequireDefault(_PanelGroup2);
	
	var _Popover2 = __webpack_require__(2694);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _ProgressBar2 = __webpack_require__(2695);
	
	var _ProgressBar3 = _interopRequireDefault(_ProgressBar2);
	
	var _Radio2 = __webpack_require__(2696);
	
	var _Radio3 = _interopRequireDefault(_Radio2);
	
	var _ResponsiveEmbed2 = __webpack_require__(2697);
	
	var _ResponsiveEmbed3 = _interopRequireDefault(_ResponsiveEmbed2);
	
	var _Row2 = __webpack_require__(2698);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _SafeAnchor2 = __webpack_require__(102);
	
	var _SafeAnchor3 = _interopRequireDefault(_SafeAnchor2);
	
	var _SplitButton2 = __webpack_require__(2699);
	
	var _SplitButton3 = _interopRequireDefault(_SplitButton2);
	
	var _Tab2 = __webpack_require__(2701);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _TabContainer2 = __webpack_require__(488);
	
	var _TabContainer3 = _interopRequireDefault(_TabContainer2);
	
	var _TabContent2 = __webpack_require__(489);
	
	var _TabContent3 = _interopRequireDefault(_TabContent2);
	
	var _Table2 = __webpack_require__(2702);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TabPane2 = __webpack_require__(1215);
	
	var _TabPane3 = _interopRequireDefault(_TabPane2);
	
	var _Tabs2 = __webpack_require__(2703);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Thumbnail2 = __webpack_require__(2704);
	
	var _Thumbnail3 = _interopRequireDefault(_Thumbnail2);
	
	var _ToggleButton2 = __webpack_require__(1216);
	
	var _ToggleButton3 = _interopRequireDefault(_ToggleButton2);
	
	var _ToggleButtonGroup2 = __webpack_require__(2705);
	
	var _ToggleButtonGroup3 = _interopRequireDefault(_ToggleButtonGroup2);
	
	var _Tooltip2 = __webpack_require__(2706);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _Well2 = __webpack_require__(2707);
	
	var _Well3 = _interopRequireDefault(_Well2);
	
	var _utils2 = __webpack_require__(2711);
	
	var _utils = _interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Accordion = _Accordion3.default;
	exports.Alert = _Alert3.default;
	exports.Badge = _Badge3.default;
	exports.Breadcrumb = _Breadcrumb3.default;
	exports.BreadcrumbItem = _BreadcrumbItem3.default;
	exports.Button = _Button3.default;
	exports.ButtonGroup = _ButtonGroup3.default;
	exports.ButtonToolbar = _ButtonToolbar3.default;
	exports.Carousel = _Carousel3.default;
	exports.CarouselItem = _CarouselItem3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Clearfix = _Clearfix3.default;
	exports.CloseButton = _CloseButton3.default;
	exports.ControlLabel = _ControlLabel3.default;
	exports.Col = _Col3.default;
	exports.Collapse = _Collapse3.default;
	exports.Dropdown = _Dropdown3.default;
	exports.DropdownButton = _DropdownButton3.default;
	exports.Fade = _Fade3.default;
	exports.Form = _Form3.default;
	exports.FormControl = _FormControl3.default;
	exports.FormGroup = _FormGroup3.default;
	exports.Glyphicon = _Glyphicon3.default;
	exports.Grid = _Grid3.default;
	exports.HelpBlock = _HelpBlock3.default;
	exports.Image = _Image3.default;
	exports.InputGroup = _InputGroup3.default;
	exports.Jumbotron = _Jumbotron3.default;
	exports.Label = _Label3.default;
	exports.ListGroup = _ListGroup3.default;
	exports.ListGroupItem = _ListGroupItem3.default;
	exports.Media = _Media3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.Modal = _Modal3.default;
	exports.ModalBody = _ModalBody3.default;
	exports.ModalFooter = _ModalFooter3.default;
	exports.ModalHeader = _ModalHeader3.default;
	exports.ModalTitle = _ModalTitle3.default;
	exports.Nav = _Nav3.default;
	exports.Navbar = _Navbar3.default;
	exports.NavbarBrand = _NavbarBrand3.default;
	exports.NavDropdown = _NavDropdown3.default;
	exports.NavItem = _NavItem3.default;
	exports.Overlay = _Overlay3.default;
	exports.OverlayTrigger = _OverlayTrigger3.default;
	exports.PageHeader = _PageHeader3.default;
	exports.PageItem = _PageItem3.default;
	exports.Pager = _Pager3.default;
	exports.Pagination = _Pagination3.default;
	exports.PaginationButton = _PaginationButton3.default;
	exports.Panel = _Panel3.default;
	exports.PanelGroup = _PanelGroup3.default;
	exports.Popover = _Popover3.default;
	exports.ProgressBar = _ProgressBar3.default;
	exports.Radio = _Radio3.default;
	exports.ResponsiveEmbed = _ResponsiveEmbed3.default;
	exports.Row = _Row3.default;
	exports.SafeAnchor = _SafeAnchor3.default;
	exports.SplitButton = _SplitButton3.default;
	exports.Tab = _Tab3.default;
	exports.TabContainer = _TabContainer3.default;
	exports.TabContent = _TabContent3.default;
	exports.Table = _Table3.default;
	exports.TabPane = _TabPane3.default;
	exports.Tabs = _Tabs3.default;
	exports.Thumbnail = _Thumbnail3.default;
	exports.ToggleButton = _ToggleButton3.default;
	exports.ToggleButtonGroup = _ToggleButtonGroup3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.Well = _Well3.default;
	exports.utils = _utils;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf(_constants.WEEKDAYS);

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	!function(root, factory) {
	     true ? module.exports = factory(__webpack_require__(1)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.react);
	}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_8__) {
	    return function(modules) {
	        function __webpack_require__(moduleId) {
	            if (installedModules[moduleId]) return installedModules[moduleId].exports;
	            var module = installedModules[moduleId] = {
	                i: moduleId,
	                l: !1,
	                exports: {}
	            };
	            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
	            module.l = !0, module.exports;
	        }
	        var installedModules = {};
	        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
	        __webpack_require__.d = function(exports, name, getter) {
	            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
	                configurable: !1,
	                enumerable: !0,
	                get: getter
	            });
	        }, __webpack_require__.n = function(module) {
	            var getter = module && module.__esModule ? function() {
	                return module.default;
	            } : function() {
	                return module;
	            };
	            return __webpack_require__.d(getter, "a", getter), getter;
	        }, __webpack_require__.o = function(object, property) {
	            return Object.prototype.hasOwnProperty.call(object, property);
	        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 7);
	    }([ function(module, exports, __webpack_require__) {
	        var REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, isValidElement = function(object) {
	            return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
	        };
	        module.exports = __webpack_require__(9)(isValidElement, !0);
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function makeEmptyFunction(arg) {
	            return function() {
	                return arg;
	            };
	        }
	        var emptyFunction = function() {};
	        emptyFunction.thatReturns = makeEmptyFunction, emptyFunction.thatReturnsFalse = makeEmptyFunction(!1), 
	        emptyFunction.thatReturnsTrue = makeEmptyFunction(!0), emptyFunction.thatReturnsNull = makeEmptyFunction(null), 
	        emptyFunction.thatReturnsThis = function() {
	            return this;
	        }, emptyFunction.thatReturnsArgument = function(arg) {
	            return arg;
	        }, module.exports = emptyFunction;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function invariant(condition, format, a, b, c, d, e, f) {
	            if (validateFormat(format), !condition) {
	                var error;
	                if (void 0 === format) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."); else {
	                    var args = [ a, b, c, d, e, f ], argIndex = 0;
	                    error = new Error(format.replace(/%s/g, function() {
	                        return args[argIndex++];
	                    })), error.name = "Invariant Violation";
	                }
	                throw error.framesToPop = 1, error;
	            }
	        }
	        var validateFormat = function(format) {};
	        validateFormat = function(format) {
	            if (void 0 === format) throw new Error("invariant requires an error message argument");
	        }, module.exports = invariant;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        var emptyFunction = __webpack_require__(1), warning = emptyFunction, printWarning = function(format) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
	            var argIndex = 0, message = "Warning: " + format.replace(/%s/g, function() {
	                return args[argIndex++];
	            });
	            "undefined" != typeof console && console.error(message);
	            try {
	                throw new Error(message);
	            } catch (x) {}
	        };
	        warning = function(condition, format) {
	            if (void 0 === format) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
	            if (0 !== format.indexOf("Failed Composite propType: ") && !condition) {
	                for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) args[_key2 - 2] = arguments[_key2];
	                printWarning.apply(void 0, [ format ].concat(args));
	            }
	        }, module.exports = warning;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function hyphenateStyleName(string) {
	            return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
	        }
	        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
	        module.exports = hyphenateStyleName;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        });
	        var _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _propTypes = __webpack_require__(0), _propTypes2 = function(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }(_propTypes), stringOrNumber = _propTypes2.default.oneOfType([ _propTypes2.default.string, _propTypes2.default.number ]), matchers = {
	            orientation: _propTypes2.default.oneOf([ "portrait", "landscape" ]),
	            scan: _propTypes2.default.oneOf([ "progressive", "interlace" ]),
	            aspectRatio: _propTypes2.default.string,
	            deviceAspectRatio: _propTypes2.default.string,
	            height: stringOrNumber,
	            deviceHeight: stringOrNumber,
	            width: stringOrNumber,
	            deviceWidth: stringOrNumber,
	            color: _propTypes2.default.bool,
	            colorIndex: _propTypes2.default.bool,
	            monochrome: _propTypes2.default.bool,
	            resolution: stringOrNumber
	        }, features = _extends({
	            minAspectRatio: _propTypes2.default.string,
	            maxAspectRatio: _propTypes2.default.string,
	            minDeviceAspectRatio: _propTypes2.default.string,
	            maxDeviceAspectRatio: _propTypes2.default.string,
	            minHeight: stringOrNumber,
	            maxHeight: stringOrNumber,
	            minDeviceHeight: stringOrNumber,
	            maxDeviceHeight: stringOrNumber,
	            minWidth: stringOrNumber,
	            maxWidth: stringOrNumber,
	            minDeviceWidth: stringOrNumber,
	            maxDeviceWidth: stringOrNumber,
	            minColor: _propTypes2.default.number,
	            maxColor: _propTypes2.default.number,
	            minColorIndex: _propTypes2.default.number,
	            maxColorIndex: _propTypes2.default.number,
	            minMonochrome: _propTypes2.default.number,
	            maxMonochrome: _propTypes2.default.number,
	            minResolution: stringOrNumber,
	            maxResolution: stringOrNumber
	        }, matchers), types = {
	            all: _propTypes2.default.bool,
	            grid: _propTypes2.default.bool,
	            aural: _propTypes2.default.bool,
	            braille: _propTypes2.default.bool,
	            handheld: _propTypes2.default.bool,
	            print: _propTypes2.default.bool,
	            projection: _propTypes2.default.bool,
	            screen: _propTypes2.default.bool,
	            tty: _propTypes2.default.bool,
	            tv: _propTypes2.default.bool,
	            embossed: _propTypes2.default.bool
	        }, all = _extends({}, types, features);
	        matchers.type = Object.keys(types), exports.default = {
	            all: all,
	            types: types,
	            matchers: matchers,
	            features: features
	        }, module.exports = exports.default;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function _classCallCheck(instance, Constructor) {
	            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
	        }
	        function _possibleConstructorReturn(self, call) {
	            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	            return !call || "object" != typeof call && "function" != typeof call ? self : call;
	        }
	        function _inherits(subClass, superClass) {
	            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	            subClass.prototype = Object.create(superClass && superClass.prototype, {
	                constructor: {
	                    value: subClass,
	                    enumerable: !1,
	                    writable: !0,
	                    configurable: !0
	                }
	            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	        }
	        function omit(object, keys) {
	            var newObject = _extends({}, object);
	            return keys.forEach(function(key) {
	                return delete newObject[key];
	            }), newObject;
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.toQuery = exports.default = void 0;
	        var _createClass = function() {
	            function defineProperties(target, props) {
	                for (var i = 0; i < props.length; i++) {
	                    var descriptor = props[i];
	                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
	                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	                }
	            }
	            return function(Constructor, protoProps, staticProps) {
	                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
	                Constructor;
	            };
	        }(), _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _react = __webpack_require__(8), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(0), _propTypes2 = _interopRequireDefault(_propTypes), _matchmediaquery = __webpack_require__(12), _matchmediaquery2 = _interopRequireDefault(_matchmediaquery), _hyphenateStyleName = __webpack_require__(5), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(6), _mediaQuery2 = _interopRequireDefault(_mediaQuery), _toQuery = __webpack_require__(14), _toQuery2 = _interopRequireDefault(_toQuery), defaultTypes = {
	            component: _propTypes2.default.node,
	            query: _propTypes2.default.string,
	            values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
	            children: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.func ]),
	            onChange: _propTypes2.default.func,
	            onBeforeChange: _propTypes2.default.func
	        }, mediaKeys = Object.keys(_mediaQuery2.default.all), excludedQueryKeys = Object.keys(defaultTypes), excludedPropKeys = excludedQueryKeys.concat(mediaKeys), MediaQuery = function(_React$Component) {
	            function MediaQuery() {
	                var _ref, _temp, _this, _ret;
	                _classCallCheck(this, MediaQuery);
	                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
	                return _temp = _this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [ this ].concat(args))), 
	                _this.state = {
	                    matches: !1
	                }, _this.updateMatches = function() {
	                    _this._mql.matches !== _this.state.matches && _this.setState({
	                        matches: _this._mql.matches
	                    });
	                }, _this.removeMql = function() {
	                    _this._mql && (_this._mql.removeListener(_this.updateMatches), _this._mql.dispose());
	                }, _ret = _temp, _possibleConstructorReturn(_this, _ret);
	            }
	            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, [ {
	                key: "componentWillMount",
	                value: function() {
	                    this.updateQuery(this.props);
	                }
	            }, {
	                key: "componentWillReceiveProps",
	                value: function(nextProps) {
	                    this.updateQuery(nextProps);
	                }
	            }, {
	                key: "updateQuery",
	                value: function(props) {
	                    var values = void 0;
	                    if (props.query ? this.query = props.query : this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys)), 
	                    !this.query) throw new Error("Invalid or missing MediaQuery!");
	                    props.values && (values = Object.keys(props.values).reduce(function(result, key) {
	                        return result[(0, _hyphenateStyleName2.default)(key)] = props.values[key], result;
	                    }, {})), this.removeMql(), this._mql = (0, _matchmediaquery2.default)(this.query, values), 
	                    this._mql.addListener(this.updateMatches), this.updateMatches();
	                }
	            }, {
	                key: "componentWillUpdate",
	                value: function(_, nextState) {
	                    this.props.onBeforeChange && this.state.matches !== nextState.matches && this.props.onBeforeChange(this.state.matches);
	                }
	            }, {
	                key: "componentDidUpdate",
	                value: function(_, prevState) {
	                    this.props.onChange && prevState.matches !== this.state.matches && this.props.onChange(this.state.matches);
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function() {
	                    this.removeMql();
	                }
	            }, {
	                key: "render",
	                value: function() {
	                    if ("function" == typeof this.props.children) return this.props.children(this.state.matches);
	                    if (!1 === this.state.matches) return null;
	                    var props = omit(this.props, excludedPropKeys), hasMergeProps = Object.keys(props).length > 0, childrenCount = _react2.default.Children.count(this.props.children);
	                    return this.props.component || null == this.props.children || hasMergeProps && childrenCount > 1 ? _react2.default.createElement(this.props.component || "div", props, this.props.children) : hasMergeProps ? _react2.default.cloneElement(this.props.children, props) : childrenCount ? this.props.children : null;
	                }
	            } ]), MediaQuery;
	        }(_react2.default.Component);
	        MediaQuery.displayName = "MediaQuery", MediaQuery.defaultProps = {
	            values: {}
	        }, exports.default = MediaQuery, exports.toQuery = _toQuery2.default;
	    }, function(module, exports) {
	        module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        var emptyFunction = __webpack_require__(1), invariant = __webpack_require__(2), warning = __webpack_require__(3), assign = __webpack_require__(10), ReactPropTypesSecret = __webpack_require__(4), checkPropTypes = __webpack_require__(11);
	        module.exports = function(isValidElement, throwOnDirectAccess) {
	            function getIteratorFn(maybeIterable) {
	                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	                if ("function" == typeof iteratorFn) return iteratorFn;
	            }
	            function is(x, y) {
	                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
	            }
	            function PropTypeError(message) {
	                this.message = message, this.stack = "";
	            }
	            function createChainableTypeChecker(validate) {
	                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
	                    secret !== ReactPropTypesSecret) if (throwOnDirectAccess) invariant(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"); else if ("undefined" != typeof console) {
	                        var cacheKey = componentName + ":" + propName;
	                        !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (warning(!1, "You are manually calling a React.PropTypes validation function for the `%s` prop on `%s`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details.", propFullName, componentName), 
	                        manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
	                    }
	                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
	                }
	                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
	                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
	            }
	            function createPrimitiveTypeChecker(expectedType) {
	                function validate(props, propName, componentName, location, propFullName, secret) {
	                    var propValue = props[propName];
	                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createArrayOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
	                    var propValue = props[propName];
	                    if (!Array.isArray(propValue)) {
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
	                    }
	                    for (var i = 0; i < propValue.length; i++) {
	                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createInstanceTypeChecker(expectedClass) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if (!(props[propName] instanceof expectedClass)) {
	                        var expectedClassName = expectedClass.name || ANONYMOUS;
	                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createEnumTypeChecker(expectedValues) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` supplied to `" + componentName + "`, expected one of " + JSON.stringify(expectedValues) + ".");
	                }
	                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (warning(!1, "Invalid argument supplied to oneOf, expected an instance of array."), 
	                emptyFunction.thatReturnsNull);
	            }
	            function createObjectOfTypeChecker(typeChecker) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
	                    for (var key in propValue) if (propValue.hasOwnProperty(key)) {
	                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error instanceof Error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createUnionTypeChecker(arrayOfTypeCheckers) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
	                    }
	                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
	                }
	                if (!Array.isArray(arrayOfTypeCheckers)) return warning(!1, "Invalid argument supplied to oneOfType, expected an instance of array."), 
	                emptyFunction.thatReturnsNull;
	                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	                    var checker = arrayOfTypeCheckers[i];
	                    if ("function" != typeof checker) return warning(!1, "Invalid argument supplied to oneOfType. Expected an array of check functions, but received %s at index %s.", getPostfixForTypeWarning(checker), i), 
	                    emptyFunction.thatReturnsNull;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    for (var key in shapeTypes) {
	                        var checker = shapeTypes[key];
	                        if (checker) {
	                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                            if (error) return error;
	                        }
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function createStrictShapeTypeChecker(shapeTypes) {
	                function validate(props, propName, componentName, location, propFullName) {
	                    var propValue = props[propName], propType = getPropType(propValue);
	                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
	                    var allKeys = assign({}, props[propName], shapeTypes);
	                    for (var key in allKeys) {
	                        var checker = shapeTypes[key];
	                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
	                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
	                        if (error) return error;
	                    }
	                    return null;
	                }
	                return createChainableTypeChecker(validate);
	            }
	            function isNode(propValue) {
	                switch (typeof propValue) {
	                  case "number":
	                  case "string":
	                  case "undefined":
	                    return !0;
	
	                  case "boolean":
	                    return !propValue;
	
	                  case "object":
	                    if (Array.isArray(propValue)) return propValue.every(isNode);
	                    if (null === propValue || isValidElement(propValue)) return !0;
	                    var iteratorFn = getIteratorFn(propValue);
	                    if (!iteratorFn) return !1;
	                    var step, iterator = iteratorFn.call(propValue);
	                    if (iteratorFn !== propValue.entries) {
	                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
	                    } else for (;!(step = iterator.next()).done; ) {
	                        var entry = step.value;
	                        if (entry && !isNode(entry[1])) return !1;
	                    }
	                    return !0;
	
	                  default:
	                    return !1;
	                }
	            }
	            function isSymbol(propType, propValue) {
	                return "symbol" === propType || ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
	            }
	            function getPropType(propValue) {
	                var propType = typeof propValue;
	                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
	            }
	            function getPreciseType(propValue) {
	                if (void 0 === propValue || null === propValue) return "" + propValue;
	                var propType = getPropType(propValue);
	                if ("object" === propType) {
	                    if (propValue instanceof Date) return "date";
	                    if (propValue instanceof RegExp) return "regexp";
	                }
	                return propType;
	            }
	            function getPostfixForTypeWarning(value) {
	                var type = getPreciseType(value);
	                switch (type) {
	                  case "array":
	                  case "object":
	                    return "an " + type;
	
	                  case "boolean":
	                  case "date":
	                  case "regexp":
	                    return "a " + type;
	
	                  default:
	                    return type;
	                }
	            }
	            function getClassName(propValue) {
	                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
	            }
	            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
	                array: createPrimitiveTypeChecker("array"),
	                bool: createPrimitiveTypeChecker("boolean"),
	                func: createPrimitiveTypeChecker("function"),
	                number: createPrimitiveTypeChecker("number"),
	                object: createPrimitiveTypeChecker("object"),
	                string: createPrimitiveTypeChecker("string"),
	                symbol: createPrimitiveTypeChecker("symbol"),
	                any: function() {
	                    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	                }(),
	                arrayOf: createArrayOfTypeChecker,
	                element: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        var propValue = props[propName];
	                        if (!isValidElement(propValue)) {
	                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
	                        }
	                        return null;
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                instanceOf: createInstanceTypeChecker,
	                node: function() {
	                    function validate(props, propName, componentName, location, propFullName) {
	                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
	                    }
	                    return createChainableTypeChecker(validate);
	                }(),
	                objectOf: createObjectOfTypeChecker,
	                oneOf: createEnumTypeChecker,
	                oneOfType: createUnionTypeChecker,
	                shape: createShapeTypeChecker,
	                exact: createStrictShapeTypeChecker
	            };
	            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
	            ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function toObject(val) {
	            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
	            return Object(val);
	        }
	        /*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
	        module.exports = function() {
	            try {
	                if (!Object.assign) return !1;
	                var test1 = new String("abc");
	                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
	                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
	                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
	                    return test2[n];
	                }).join("")) return !1;
	                var test3 = {};
	                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
	                    test3[letter] = letter;
	                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
	            } catch (err) {
	                return !1;
	            }
	        }() ? Object.assign : function(target, source) {
	            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
	                from = Object(arguments[s]);
	                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
	                if (getOwnPropertySymbols) {
	                    symbols = getOwnPropertySymbols(from);
	                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
	                }
	            }
	            return to;
	        };
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	            for (var typeSpecName in typeSpecs) if (typeSpecs.hasOwnProperty(typeSpecName)) {
	                var error;
	                try {
	                    invariant("function" == typeof typeSpecs[typeSpecName], "%s: %s type `%s` is invalid; it must be a function, usually from the `prop-types` package, but received `%s`.", componentName || "React class", location, typeSpecName, typeof typeSpecs[typeSpecName]), 
	                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	                } catch (ex) {
	                    error = ex;
	                }
	                if (warning(!error || error instanceof Error, "%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error), 
	                error instanceof Error && !(error.message in loggedTypeFailures)) {
	                    loggedTypeFailures[error.message] = !0;
	                    var stack = getStack ? getStack() : "";
	                    warning(!1, "Failed %s type: %s%s", location, error.message, null != stack ? stack : "");
	                }
	            }
	        }
	        var invariant = __webpack_require__(2), warning = __webpack_require__(3), ReactPropTypesSecret = __webpack_require__(4), loggedTypeFailures = {};
	        module.exports = checkPropTypes;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function Mql(query, values) {
	            function addListener(listener) {
	                mql && mql.addListener(listener);
	            }
	            function removeListener(listener) {
	                mql && mql.removeListener(listener);
	            }
	            function update(evt) {
	                self.matches = evt.matches, self.media = evt.media;
	            }
	            function dispose() {
	                mql && mql.removeListener(update);
	            }
	            var self = this;
	            if (dynamicMatch) {
	                var mql = dynamicMatch.call(window, query);
	                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
	            } else this.matches = staticMatch(query, values), this.media = query;
	            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
	        }
	        function matchMedia(query, values) {
	            return new Mql(query, values);
	        }
	        var staticMatch = __webpack_require__(13).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
	        module.exports = matchMedia;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function matchQuery(mediaQuery, values) {
	            return parseQuery(mediaQuery).some(function(query) {
	                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
	                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
	                var expressionsMatch = query.expressions.every(function(expression) {
	                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
	                    if (!value) return !1;
	                    switch (feature) {
	                      case "orientation":
	                      case "scan":
	                        return value.toLowerCase() === expValue.toLowerCase();
	
	                      case "width":
	                      case "height":
	                      case "device-width":
	                      case "device-height":
	                        expValue = toPx(expValue), value = toPx(value);
	                        break;
	
	                      case "resolution":
	                        expValue = toDpi(expValue), value = toDpi(value);
	                        break;
	
	                      case "aspect-ratio":
	                      case "device-aspect-ratio":
	                      case "device-pixel-ratio":
	                        expValue = toDecimal(expValue), value = toDecimal(value);
	                        break;
	
	                      case "grid":
	                      case "color":
	                      case "color-index":
	                      case "monochrome":
	                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
	                    }
	                    switch (modifier) {
	                      case "min":
	                        return value >= expValue;
	
	                      case "max":
	                        return value <= expValue;
	
	                      default:
	                        return value === expValue;
	                    }
	                });
	                return expressionsMatch && !inverse || !expressionsMatch && inverse;
	            });
	        }
	        function parseQuery(mediaQuery) {
	            return mediaQuery.split(",").map(function(query) {
	                query = query.trim();
	                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
	                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
	                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
	                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
	                    return {
	                        modifier: feature[1],
	                        feature: feature[2],
	                        value: captures[2]
	                    };
	                }), parsed;
	            });
	        }
	        function toDecimal(ratio) {
	            var numbers, decimal = Number(ratio);
	            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
	            decimal;
	        }
	        function toDpi(resolution) {
	            var value = parseFloat(resolution);
	            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
	              case "dpcm":
	                return value / 2.54;
	
	              case "dppx":
	                return 96 * value;
	
	              default:
	                return value;
	            }
	        }
	        function toPx(length) {
	            var value = parseFloat(length);
	            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
	              case "em":
	              case "rem":
	                return 16 * value;
	
	              case "cm":
	                return 96 * value / 2.54;
	
	              case "mm":
	                return 96 * value / 2.54 / 10;
	
	              case "in":
	                return 96 * value;
	
	              case "pt":
	                return 72 * value;
	
	              case "pc":
	                return 72 * value / 12;
	
	              default:
	                return value;
	            }
	        }
	        exports.match = matchQuery, exports.parse = parseQuery;
	        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
	    }, function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function keyVal(k, v) {
	            var realKey = (0, _hyphenateStyleName2.default)(k);
	            return "number" == typeof v && (v += "px"), !0 === v ? k : !1 === v ? negate(k) : "(" + realKey + ": " + v + ")";
	        }
	        function join(conds) {
	            return conds.join(" and ");
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.default = function(obj) {
	            var rules = [];
	            return Object.keys(_mediaQuery2.default.all).forEach(function(k) {
	                var v = obj[k];
	                null != v && rules.push(keyVal(k, v));
	            }), join(rules);
	        };
	        var _hyphenateStyleName = __webpack_require__(5), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(6), _mediaQuery2 = _interopRequireDefault(_mediaQuery), negate = function(cond) {
	            return "not " + cond;
	        };
	        module.exports = exports.default;
	    } ]);
	});
	//# sourceMappingURL=react-responsive.js.map

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(2839);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(2840);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(1276);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(2841);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(2842);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(2843);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(2844);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1277);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(512);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(2845);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(2846);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(2847);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(2848);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--label';
	
	var LabelSeries = function (_AbstractSeries) {
	  _inherits(LabelSeries, _AbstractSeries);
	
	  function LabelSeries() {
	    _classCallCheck(this, LabelSeries);
	
	    return _possibleConstructorReturn(this, (LabelSeries.__proto__ || Object.getPrototypeOf(LabelSeries)).apply(this, arguments));
	  }
	
	  _createClass(LabelSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          allowOffsetToBeReversed = _props.allowOffsetToBeReversed,
	          className = _props.className,
	          data = _props.data,
	          _data = _props._data,
	          getLabel = _props.getLabel,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          rotation = _props.rotation,
	          xRange = _props.xRange,
	          yRange = _props.yRange;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(LabelSeries, _extends({}, this.props, { animation: null, _data: data }))
	        );
	      }
	
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.reduce(function (res, d, i) {
	          var style = d.style,
	              xOffset = d.xOffset,
	              yOffset = d.yOffset;
	
	          if (!getLabel(d)) {
	            return res;
	          }
	          var xVal = xFunctor(d);
	          var yVal = yFunctor(d);
	          var leftOfMiddle = xVal < (xRange[1] - xRange[0]) / 2;
	          var aboveMiddle = yVal < Math.abs(yRange[1] - yRange[0]) / 2;
	
	          var x = xVal + (allowOffsetToBeReversed && leftOfMiddle ? -1 : 1) * (xOffset || 0);
	          var y = yVal + (allowOffsetToBeReversed && aboveMiddle ? -1 : 1) * (yOffset || 0);
	          var attrs = _extends({
	            alignmentBaseline: aboveMiddle ? 'text-before-edge' : 'text-after-edge',
	            className: 'rv-xy-plot__series--label-text',
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onContextMenu: function onContextMenu(e) {
	              return _this2._valueRightClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            },
	            textAnchor: leftOfMiddle ? 'start' : 'end',
	            x: x,
	            y: y,
	            transform: 'rotate(' + (d.rotation || rotation) + ',' + x + ',' + y + ')'
	          }, style);
	          var textContent = getLabel(_data ? _data[i] : d);
	          return res.concat([_react2.default.createElement(
	            'text',
	            attrs,
	            textContent
	          )]);
	        }, [])
	      );
	    }
	  }]);
	
	  return LabelSeries;
	}(_abstractSeries2.default);
	
	LabelSeries.propTypes = {
	  animation: _propTypes2.default.bool,
	  allowOffsetToBeReversed: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    angle: _propTypes2.default.number,
	    radius: _propTypes2.default.number,
	    label: _propTypes2.default.string,
	    xOffset: _propTypes2.default.number,
	    yOffset: _propTypes2.default.number,
	    style: _propTypes2.default.object
	  })).isRequired,
	  marginLeft: _propTypes2.default.number,
	  marginTop: _propTypes2.default.number,
	  rotation: _propTypes2.default.number,
	  xRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  yRange: _propTypes2.default.arrayOf(_propTypes2.default.number)
	};
	LabelSeries.defaultProps = {
	  animation: false,
	  rotation: 0,
	  getLabel: function getLabel(d) {
	    return d.label;
	  }
	};
	LabelSeries.displayName = 'LabelSeries';
	exports.default = LabelSeries;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MarginPropType = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.getInnerDimensions = getInnerDimensions;
	exports.getRadialLayoutMargin = getRadialLayoutMargin;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the dimensions of the component for the future use.
	 * @param {Object} props Props.
	 * @param {Object} defaultMargins Object with default margins.
	 * @returns {Object} Dimensions of the component.
	 */
	function getInnerDimensions(props, defaultMargins) {
	  var margin = props.margin,
	      width = props.width,
	      height = props.height;
	
	  var marginProps = _extends({}, defaultMargins, typeof margin === 'number' ? {
	    left: margin,
	    right: margin,
	    top: margin,
	    bottom: margin
	  } : margin);
	  var _marginProps$left = marginProps.left,
	      marginLeft = _marginProps$left === undefined ? 0 : _marginProps$left,
	      _marginProps$top = marginProps.top,
	      marginTop = _marginProps$top === undefined ? 0 : _marginProps$top,
	      _marginProps$right = marginProps.right,
	      marginRight = _marginProps$right === undefined ? 0 : _marginProps$right,
	      _marginProps$bottom = marginProps.bottom,
	      marginBottom = _marginProps$bottom === undefined ? 0 : _marginProps$bottom;
	
	  return {
	    marginLeft: marginLeft,
	    marginTop: marginTop,
	    marginRight: marginRight,
	    marginBottom: marginBottom,
	    innerHeight: height - marginBottom - marginTop,
	    innerWidth: width - marginLeft - marginRight
	  };
	}
	
	/**
	 * Calculate the margin of the sunburst,
	 * so it can be at the center of the container
	 * @param  {Number} width - the width of the container
	 * @param  {Number} height - the height of the container
	 * @param  {Number} radius - the max radius of the sunburst
	 * @return {Object} an object includes {bottom, left, right, top}
	 */
	function getRadialLayoutMargin(width, height, radius) {
	  var marginX = width / 2 - radius;
	  var marginY = height / 2 - radius;
	  return {
	    bottom: marginY,
	    left: marginX,
	    right: marginX,
	    top: marginY
	  };
	}
	
	var MarginPropType = exports.MarginPropType = _propTypes2.default.oneOfType([_propTypes2.default.shape({
	  left: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  right: _propTypes2.default.number,
	  bottom: _propTypes2.default.number
	}), _propTypes2.default.number]);

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(321);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(222);
	util.inherits = __webpack_require__(98);
	/*</replacement>*/
	
	var Readable = __webpack_require__(1322);
	var Writable = __webpack_require__(527);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduceCssCalc = __webpack_require__(3024);
	
	var _reduceCssCalc2 = _interopRequireDefault(_reduceCssCalc);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DOMUtils = __webpack_require__(536);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
	
	var calculateWordWidths = function calculateWordWidths(props) {
	  try {
	    var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	    var wordsWithComputedWidth = words.map(function (word) {
	      return { word: word, width: (0, _DOMUtils.getStringSize)(word, props.style).width };
	    });
	
	    var spaceWidth = (0, _DOMUtils.getStringSize)('\xA0', props.style).width;
	
	    return { wordsWithComputedWidth: wordsWithComputedWidth, spaceWidth: spaceWidth };
	  } catch (e) {
	    return null;
	  }
	};
	
	var Text = (_temp2 = _class = function (_Component) {
	  _inherits(Text, _Component);
	
	  function Text() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Text);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Text.__proto__ || Object.getPrototypeOf(Text)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      wordsByLines: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Text, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.updateWordsByLines(this.props, true);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var needCalculate = this.props.children !== nextProps.children || this.props.style !== nextProps.style;
	      this.updateWordsByLines(nextProps, needCalculate);
	    }
	  }, {
	    key: 'updateWordsByLines',
	    value: function updateWordsByLines(props, needCalculate) {
	      // Only perform calculations if using features that require them (multiline, scaleToFit)
	      if ((props.width || props.scaleToFit) && !(0, _ReactUtils.isSsr)()) {
	        if (needCalculate) {
	          var wordWidths = calculateWordWidths(props);
	
	          if (wordWidths) {
	            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
	                spaceWidth = wordWidths.spaceWidth;
	
	
	            this.wordsWithComputedWidth = wordsWithComputedWidth;
	            this.spaceWidth = spaceWidth;
	          } else {
	            this.updateWordsWithoutCalculate(props);
	
	            return;
	          }
	        }
	
	        var wordsByLines = this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
	        this.setState({ wordsByLines: wordsByLines });
	      } else {
	        this.updateWordsWithoutCalculate(props);
	      }
	    }
	  }, {
	    key: 'updateWordsWithoutCalculate',
	    value: function updateWordsWithoutCalculate(props) {
	      var words = !(0, _isNil3.default)(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
	      this.setState({ wordsByLines: [{ words: words }] });
	    }
	  }, {
	    key: 'calculateWordsByLines',
	    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
	      var scaleToFit = this.props.scaleToFit;
	
	      return wordsWithComputedWidth.reduce(function (result, _ref2) {
	        var word = _ref2.word,
	            width = _ref2.width;
	
	        var currentLine = result[result.length - 1];
	
	        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
	          // Word can be added to an existing line
	          currentLine.words.push(word);
	          currentLine.width += width + spaceWidth;
	        } else {
	          // Add first word to line or word is too long to scaleToFit on existing line
	          var newLine = { words: [word], width: width };
	          result.push(newLine);
	        }
	
	        return result;
	      }, []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          dx = _props.dx,
	          dy = _props.dy,
	          textAnchor = _props.textAnchor,
	          verticalAnchor = _props.verticalAnchor,
	          scaleToFit = _props.scaleToFit,
	          angle = _props.angle,
	          lineHeight = _props.lineHeight,
	          capHeight = _props.capHeight,
	          className = _props.className,
	          textProps = _objectWithoutProperties(_props, ['dx', 'dy', 'textAnchor', 'verticalAnchor', 'scaleToFit', 'angle', 'lineHeight', 'capHeight', 'className']);
	
	      var wordsByLines = this.state.wordsByLines;
	
	
	      if (!(0, _DataUtils.isNumOrStr)(textProps.x) || !(0, _DataUtils.isNumOrStr)(textProps.y)) {
	        return null;
	      }
	      var x = textProps.x + ((0, _DataUtils.isNumber)(dx) ? dx : 0);
	      var y = textProps.y + ((0, _DataUtils.isNumber)(dy) ? dy : 0);
	
	      var startDy = void 0;
	      switch (verticalAnchor) {
	        case 'start':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + capHeight + ')');
	          break;
	        case 'middle':
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) / 2 + ' * -' + lineHeight + ' + (' + capHeight + ' / 2))');
	          break;
	        default:
	          startDy = (0, _reduceCssCalc2.default)('calc(' + (wordsByLines.length - 1) + ' * -' + lineHeight + ')');
	          break;
	      }
	
	      var transforms = [];
	      if (scaleToFit) {
	        var lineWidth = wordsByLines[0].width;
	        transforms.push('scale(' + this.props.width / lineWidth + ')');
	      }
	      if (angle) {
	        transforms.push('rotate(' + angle + ', ' + x + ', ' + y + ')');
	      }
	      if (transforms.length) {
	        textProps.transform = transforms.join(' ');
	      }
	
	      return _react2.default.createElement(
	        'text',
	        _extends({}, (0, _ReactUtils.getPresentationAttributes)(textProps), {
	          x: x,
	          y: y,
	          className: (0, _classnames2.default)('recharts-text', className),
	          textAnchor: textAnchor
	        }),
	        wordsByLines.map(function (line, index) {
	          return _react2.default.createElement(
	            'tspan',
	            { x: x, dy: index === 0 ? startDy : lineHeight, key: index },
	            line.words.join(' ')
	          );
	        })
	      );
	    }
	  }]);
	
	  return Text;
	}(_react.Component), _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  scaleToFit: _propTypes2.default.bool,
	  angle: _propTypes2.default.number,
	  textAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end', 'inherit']),
	  verticalAnchor: _propTypes2.default.oneOf(['start', 'middle', 'end']),
	  style: _propTypes2.default.object
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  lineHeight: '1em',
	  capHeight: '0.71em', // Magic number from d3
	  scaleToFit: false,
	  textAnchor: 'start',
	  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior
	}, _temp2);
	exports.default = Text;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Dot, _Component);
	
	  function Dot() {
	    _classCallCheck(this, Dot);
	
	    return _possibleConstructorReturn(this, (Dot.__proto__ || Object.getPrototypeOf(Dot)).apply(this, arguments));
	  }
	
	  _createClass(Dot, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          r = _props.r,
	          className = _props.className;
	
	      var layerClass = (0, _classnames2.default)('recharts-dot', className);
	
	      if (cx === +cx && cy === +cy && r === +r) {
	        return _react2.default.createElement('circle', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	          className: layerClass,
	          cx: cx,
	          cy: cy,
	          r: r
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Dot;
	}(_react.Component), _class2.displayName = 'Dot', _class2.propTypes = {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  r: _propTypes2.default.number
	}, _temp)) || _class;
	
	exports.default = Dot;

/***/ },
/* 166 */
[3494, 3125, 3154],
/* 167 */
112,
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.asEffect = exports.takem = exports.detach = undefined;
	exports.take = take;
	exports.put = put;
	exports.all = all;
	exports.race = race;
	exports.call = call;
	exports.apply = apply;
	exports.cps = cps;
	exports.fork = fork;
	exports.spawn = spawn;
	exports.join = join;
	exports.cancel = cancel;
	exports.select = select;
	exports.actionChannel = actionChannel;
	exports.cancelled = cancelled;
	exports.flush = flush;
	exports.getContext = getContext;
	exports.setContext = setContext;
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var _sagaHelpers = /*#__PURE__*/__webpack_require__(1397);
	
	var IO = /*#__PURE__*/(0, _utils.sym)('IO');
	var TAKE = 'TAKE';
	var PUT = 'PUT';
	var ALL = 'ALL';
	var RACE = 'RACE';
	var CALL = 'CALL';
	var CPS = 'CPS';
	var FORK = 'FORK';
	var JOIN = 'JOIN';
	var CANCEL = 'CANCEL';
	var SELECT = 'SELECT';
	var ACTION_CHANNEL = 'ACTION_CHANNEL';
	var CANCELLED = 'CANCELLED';
	var FLUSH = 'FLUSH';
	var GET_CONTEXT = 'GET_CONTEXT';
	var SET_CONTEXT = 'SET_CONTEXT';
	
	var TEST_HINT = '\n(HINT: if you are getting this errors in tests, consider using createMockTask from redux-saga/utils)';
	
	var effect = function effect(type, payload) {
	  var _ref;
	
	  return _ref = {}, _ref[IO] = true, _ref[type] = payload, _ref;
	};
	
	var detach = exports.detach = function detach(eff) {
	  (0, _utils.check)(asEffect.fork(eff), _utils.is.object, 'detach(eff): argument must be a fork effect');
	  eff[FORK].detached = true;
	  return eff;
	};
	
	function take() {
	  var patternOrChannel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '*';
	
	  if (arguments.length) {
	    (0, _utils.check)(arguments[0], _utils.is.notUndef, 'take(patternOrChannel): patternOrChannel is undefined');
	  }
	  if (_utils.is.pattern(patternOrChannel)) {
	    return effect(TAKE, { pattern: patternOrChannel });
	  }
	  if (_utils.is.channel(patternOrChannel)) {
	    return effect(TAKE, { channel: patternOrChannel });
	  }
	  throw new Error('take(patternOrChannel): argument ' + String(patternOrChannel) + ' is not valid channel or a valid pattern');
	}
	
	take.maybe = function () {
	  var eff = take.apply(undefined, arguments);
	  eff[TAKE].maybe = true;
	  return eff;
	};
	
	var takem = /*#__PURE__*/exports.takem = (0, _utils.deprecate)(take.maybe, /*#__PURE__*/(0, _utils.updateIncentive)('takem', 'take.maybe'));
	
	function put(channel, action) {
	  if (arguments.length > 1) {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(channel, action): argument channel is undefined');
	    (0, _utils.check)(channel, _utils.is.channel, 'put(channel, action): argument ' + channel + ' is not a valid channel');
	    (0, _utils.check)(action, _utils.is.notUndef, 'put(channel, action): argument action is undefined');
	  } else {
	    (0, _utils.check)(channel, _utils.is.notUndef, 'put(action): argument action is undefined');
	    action = channel;
	    channel = null;
	  }
	  return effect(PUT, { channel: channel, action: action });
	}
	
	put.resolve = function () {
	  var eff = put.apply(undefined, arguments);
	  eff[PUT].resolve = true;
	  return eff;
	};
	
	put.sync = /*#__PURE__*/(0, _utils.deprecate)(put.resolve, /*#__PURE__*/(0, _utils.updateIncentive)('put.sync', 'put.resolve'));
	
	function all(effects) {
	  return effect(ALL, effects);
	}
	
	function race(effects) {
	  return effect(RACE, effects);
	}
	
	function getFnCallDesc(meth, fn, args) {
	  (0, _utils.check)(fn, _utils.is.notUndef, meth + ': argument fn is undefined');
	
	  var context = null;
	  if (_utils.is.array(fn)) {
	    var _fn = fn;
	    context = _fn[0];
	    fn = _fn[1];
	  } else if (fn.fn) {
	    var _fn2 = fn;
	    context = _fn2.context;
	    fn = _fn2.fn;
	  }
	  if (context && _utils.is.string(fn) && _utils.is.func(context[fn])) {
	    fn = context[fn];
	  }
	  (0, _utils.check)(fn, _utils.is.func, meth + ': argument ' + fn + ' is not a function');
	
	  return { context: context, fn: fn, args: args };
	}
	
	function call(fn) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return effect(CALL, getFnCallDesc('call', fn, args));
	}
	
	function apply(context, fn) {
	  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  return effect(CALL, getFnCallDesc('apply', { context: context, fn: fn }, args));
	}
	
	function cps(fn) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    args[_key2 - 1] = arguments[_key2];
	  }
	
	  return effect(CPS, getFnCallDesc('cps', fn, args));
	}
	
	function fork(fn) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    args[_key3 - 1] = arguments[_key3];
	  }
	
	  return effect(FORK, getFnCallDesc('fork', fn, args));
	}
	
	function spawn(fn) {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  return detach(fork.apply(undefined, [fn].concat(args)));
	}
	
	function join() {
	  for (var _len5 = arguments.length, tasks = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	    tasks[_key5] = arguments[_key5];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return join(t);
	    }));
	  }
	  var task = tasks[0];
	  (0, _utils.check)(task, _utils.is.notUndef, 'join(task): argument task is undefined');
	  (0, _utils.check)(task, _utils.is.task, 'join(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  return effect(JOIN, task);
	}
	
	function cancel() {
	  for (var _len6 = arguments.length, tasks = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	    tasks[_key6] = arguments[_key6];
	  }
	
	  if (tasks.length > 1) {
	    return all(tasks.map(function (t) {
	      return cancel(t);
	    }));
	  }
	  var task = tasks[0];
	  if (tasks.length === 1) {
	    (0, _utils.check)(task, _utils.is.notUndef, 'cancel(task): argument task is undefined');
	    (0, _utils.check)(task, _utils.is.task, 'cancel(task): argument ' + task + ' is not a valid Task object ' + TEST_HINT);
	  }
	  return effect(CANCEL, task || _utils.SELF_CANCELLATION);
	}
	
	function select(selector) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    args[_key7 - 1] = arguments[_key7];
	  }
	
	  if (arguments.length === 0) {
	    selector = _utils.ident;
	  } else {
	    (0, _utils.check)(selector, _utils.is.notUndef, 'select(selector,[...]): argument selector is undefined');
	    (0, _utils.check)(selector, _utils.is.func, 'select(selector,[...]): argument ' + selector + ' is not a function');
	  }
	  return effect(SELECT, { selector: selector, args: args });
	}
	
	/**
	  channel(pattern, [buffer])    => creates an event channel for store actions
	**/
	function actionChannel(pattern, buffer) {
	  (0, _utils.check)(pattern, _utils.is.notUndef, 'actionChannel(pattern,...): argument pattern is undefined');
	  if (arguments.length > 1) {
	    (0, _utils.check)(buffer, _utils.is.notUndef, 'actionChannel(pattern, buffer): argument buffer is undefined');
	    (0, _utils.check)(buffer, _utils.is.buffer, 'actionChannel(pattern, buffer): argument ' + buffer + ' is not a valid buffer');
	  }
	  return effect(ACTION_CHANNEL, { pattern: pattern, buffer: buffer });
	}
	
	function cancelled() {
	  return effect(CANCELLED, {});
	}
	
	function flush(channel) {
	  (0, _utils.check)(channel, _utils.is.channel, 'flush(channel): argument ' + channel + ' is not valid channel');
	  return effect(FLUSH, channel);
	}
	
	function getContext(prop) {
	  (0, _utils.check)(prop, _utils.is.string, 'getContext(prop): argument ' + prop + ' is not a string');
	  return effect(GET_CONTEXT, prop);
	}
	
	function setContext(props) {
	  (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)(null, props));
	  return effect(SET_CONTEXT, props);
	}
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	    args[_key8 - 2] = arguments[_key8];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeEveryHelper, patternOrChannel, worker].concat(args));
	}
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	    args[_key9 - 2] = arguments[_key9];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.takeLatestHelper, patternOrChannel, worker].concat(args));
	}
	
	function throttle(ms, pattern, worker) {
	  for (var _len10 = arguments.length, args = Array(_len10 > 3 ? _len10 - 3 : 0), _key10 = 3; _key10 < _len10; _key10++) {
	    args[_key10 - 3] = arguments[_key10];
	  }
	
	  return fork.apply(undefined, [_sagaHelpers.throttleHelper, ms, pattern, worker].concat(args));
	}
	
	var createAsEffectType = function createAsEffectType(type) {
	  return function (effect) {
	    return effect && effect[IO] && effect[type];
	  };
	};
	
	var asEffect = exports.asEffect = {
	  take: /*#__PURE__*/createAsEffectType(TAKE),
	  put: /*#__PURE__*/createAsEffectType(PUT),
	  all: /*#__PURE__*/createAsEffectType(ALL),
	  race: /*#__PURE__*/createAsEffectType(RACE),
	  call: /*#__PURE__*/createAsEffectType(CALL),
	  cps: /*#__PURE__*/createAsEffectType(CPS),
	  fork: /*#__PURE__*/createAsEffectType(FORK),
	  join: /*#__PURE__*/createAsEffectType(JOIN),
	  cancel: /*#__PURE__*/createAsEffectType(CANCEL),
	  select: /*#__PURE__*/createAsEffectType(SELECT),
	  actionChannel: /*#__PURE__*/createAsEffectType(ACTION_CHANNEL),
	  cancelled: /*#__PURE__*/createAsEffectType(CANCELLED),
	  flush: /*#__PURE__*/createAsEffectType(FLUSH),
	  getContext: /*#__PURE__*/createAsEffectType(GET_CONTEXT),
	  setContext: /*#__PURE__*/createAsEffectType(SET_CONTEXT)
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Checkbox = __webpack_require__(585);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _Group = __webpack_require__(1453);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Checkbox2['default'].Group = _Group2['default'];
	exports['default'] = _Checkbox2['default'];

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcTooltip = __webpack_require__(1187);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _placements = __webpack_require__(1518);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var splitObject = function splitObject(obj, keys) {
	    var picked = {};
	    var omited = (0, _extends3['default'])({}, obj);
	    keys.forEach(function (key) {
	        if (obj && key in obj) {
	            picked[key] = obj[key];
	            delete omited[key];
	        }
	    });
	    return { picked: picked, omited: omited };
	};
	
	var Tooltip = function (_React$Component) {
	    (0, _inherits3['default'])(Tooltip, _React$Component);
	
	    function Tooltip(props) {
	        (0, _classCallCheck3['default'])(this, Tooltip);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	        _this.onVisibleChange = function (visible) {
	            var onVisibleChange = _this.props.onVisibleChange;
	
	            if (!('visible' in _this.props)) {
	                _this.setState({ visible: _this.isNoTitle() ? false : visible });
	            }
	            if (onVisibleChange && !_this.isNoTitle()) {
	                onVisibleChange(visible);
	            }
	        };
	        // 动态设置动画点
	        _this.onPopupAlign = function (domNode, align) {
	            var placements = _this.getPlacements();
	            // 当前返回的位置
	            var placement = Object.keys(placements).filter(function (key) {
	                return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
	            })[0];
	            if (!placement) {
	                return;
	            }
	            // 根据当前坐标设置动画点
	            var rect = domNode.getBoundingClientRect();
	            var transformOrigin = {
	                top: '50%',
	                left: '50%'
	            };
	            if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
	                transformOrigin.top = rect.height - align.offset[1] + 'px';
	            } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
	                transformOrigin.top = -align.offset[1] + 'px';
	            }
	            if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
	                transformOrigin.left = rect.width - align.offset[0] + 'px';
	            } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
	                transformOrigin.left = -align.offset[0] + 'px';
	            }
	            domNode.style.transformOrigin = transformOrigin.left + ' ' + transformOrigin.top;
	        };
	        _this.saveTooltip = function (node) {
	            _this.tooltip = node;
	        };
	        _this.state = {
	            visible: !!props.visible || !!props.defaultVisible
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Tooltip, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('visible' in nextProps) {
	                this.setState({ visible: nextProps.visible });
	            }
	        }
	    }, {
	        key: 'getPopupDomNode',
	        value: function getPopupDomNode() {
	            return this.tooltip.getPopupDomNode();
	        }
	    }, {
	        key: 'getPlacements',
	        value: function getPlacements() {
	            var _props = this.props,
	                builtinPlacements = _props.builtinPlacements,
	                arrowPointAtCenter = _props.arrowPointAtCenter,
	                autoAdjustOverflow = _props.autoAdjustOverflow;
	
	            return builtinPlacements || (0, _placements2['default'])({
	                arrowPointAtCenter: arrowPointAtCenter,
	                verticalArrowShift: 8,
	                autoAdjustOverflow: autoAdjustOverflow
	            });
	        }
	    }, {
	        key: 'isHoverTrigger',
	        value: function isHoverTrigger() {
	            var trigger = this.props.trigger;
	
	            if (!trigger || trigger === 'hover') {
	                return true;
	            }
	            if (Array.isArray(trigger)) {
	                return trigger.indexOf('hover') >= 0;
	            }
	            return false;
	        }
	        // Fix Tooltip won't hide at disabled button
	        // mouse events don't trigger at disabled button in Chrome
	        // https://github.com/react-component/tooltip/issues/18
	
	    }, {
	        key: 'getDisabledCompatibleChildren',
	        value: function getDisabledCompatibleChildren(element) {
	            if ((element.type.__ANT_BUTTON || element.type === 'button') && element.props.disabled && this.isHoverTrigger()) {
	                // Pick some layout related style properties up to span
	                // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
	                var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
	                    picked = _splitObject.picked,
	                    omited = _splitObject.omited;
	
	                var spanStyle = (0, _extends3['default'])({ display: 'inline-block' }, picked, { cursor: 'not-allowed' });
	                var buttonStyle = (0, _extends3['default'])({}, omited, { pointerEvents: 'none' });
	                var child = (0, _react.cloneElement)(element, {
	                    style: buttonStyle,
	                    className: null
	                });
	                return React.createElement(
	                    'span',
	                    { style: spanStyle, className: element.props.className },
	                    child
	                );
	            }
	            return element;
	        }
	    }, {
	        key: 'isNoTitle',
	        value: function isNoTitle() {
	            var _props2 = this.props,
	                title = _props2.title,
	                overlay = _props2.overlay;
	
	            return !title && !overlay; // overlay for old version compatibility
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props,
	                state = this.state;
	            var prefixCls = props.prefixCls,
	                title = props.title,
	                overlay = props.overlay,
	                openClassName = props.openClassName,
	                getPopupContainer = props.getPopupContainer,
	                getTooltipContainer = props.getTooltipContainer;
	
	            var children = props.children;
	            var visible = state.visible;
	            // Hide tooltip when there is no title
	            if (!('visible' in props) && this.isNoTitle()) {
	                visible = false;
	            }
	            var child = this.getDisabledCompatibleChildren(React.isValidElement(children) ? children : React.createElement(
	                'span',
	                null,
	                children
	            ));
	            var childProps = child.props;
	            var childCls = (0, _classnames2['default'])(childProps.className, (0, _defineProperty3['default'])({}, openClassName || prefixCls + '-open', true));
	            return React.createElement(
	                _rcTooltip2['default'],
	                (0, _extends3['default'])({}, this.props, { getTooltipContainer: getPopupContainer || getTooltipContainer, ref: this.saveTooltip, builtinPlacements: this.getPlacements(), overlay: overlay || title || '', visible: visible, onVisibleChange: this.onVisibleChange, onPopupAlign: this.onPopupAlign }),
	                visible ? (0, _react.cloneElement)(child, { className: childCls }) : child
	            );
	        }
	    }]);
	    return Tooltip;
	}(React.Component);
	
	exports['default'] = Tooltip;
	
	Tooltip.defaultProps = {
	    prefixCls: 'ant-tooltip',
	    placement: 'top',
	    transitionName: 'zoom-big-fast',
	    mouseEnterDelay: 0.1,
	    mouseLeaveDelay: 0.1,
	    arrowPointAtCenter: false,
	    autoAdjustOverflow: true
	};

/***/ },
/* 171 */
156,
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	var error = __webpack_require__(729);
	var objectHelper = __webpack_require__(76);
	
	function wrapCallback(cb, options) {
	  options = options || {};
	  options.ignoreCasing = options.ignoreCasing ? options.ignoreCasing : false;
	
	  return function(err, data) {
	    var errObj;
	
	    if (!err && !data) {
	      return cb(error.buildResponse('generic_error', 'Something went wrong'));
	    }
	
	    if (!err && data.err) {
	      err = data.err;
	      data = null;
	    }
	
	    if (!err && data.error) {
	      err = data;
	      data = null;
	    }
	
	    if (err) {
	      errObj = {
	        original: err
	      };
	
	      if (err.response && err.response.statusCode) {
	        errObj.statusCode = err.response.statusCode;
	      }
	
	      if (err.response && err.response.statusText) {
	        errObj.statusText = err.response.statusText;
	      }
	
	      if (err.response && err.response.body) {
	        err = err.response.body;
	      }
	
	      if (err.err) {
	        err = err.err;
	      }
	
	      errObj.code = err.error || err.code || err.error_code || err.status || null;
	      errObj.description =
	        err.errorDescription ||
	        err.error_description ||
	        err.description ||
	        err.error ||
	        err.details ||
	        err.err ||
	        null;
	
	      if (err.name) {
	        errObj.name = err.name;
	      }
	
	      if (err.policy) {
	        errObj.policy = err.policy;
	      }
	
	      return cb(errObj);
	    }
	
	    if (data.type && (data.type === 'text/html' || data.type === 'text/plain')) {
	      return cb(null, data.text);
	    }
	
	    if (options.ignoreCasing) {
	      return cb(null, data.body || data);
	    }
	
	    return cb(null, objectHelper.toCamelCase(data.body || data));
	  };
	}
	
	module.exports = wrapCallback;


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gogochart_alt_white_logo = __webpack_require__(3304);
	
	var _gogochart_alt_white_logo2 = _interopRequireDefault(_gogochart_alt_white_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Resources
	
	
	var HeaderLogo = function (_React$Component) {
	    _inherits(HeaderLogo, _React$Component);
	
	    function HeaderLogo() {
	        _classCallCheck(this, HeaderLogo);
	
	        return _possibleConstructorReturn(this, (HeaderLogo.__proto__ || Object.getPrototypeOf(HeaderLogo)).apply(this, arguments));
	    }
	
	    _createClass(HeaderLogo, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'logo-container' },
	                this.props.isClickable && _react2.default.createElement('img', { src: ("") + _gogochart_alt_white_logo2.default, onClick: function onClick() {
	                        return _this2.props.history.push('/');
	                    } }) || _react2.default.createElement('img', { src: ("") + _gogochart_alt_white_logo2.default })
	            );
	        }
	    }]);
	
	    return HeaderLogo;
	}(_react2.default.Component);
	
	exports.default = HeaderLogo;
	;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomizedTableWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  overflow: hidden;\n  overflow-x: auto;\n  background-color: #ffffff;\n\n  .ant-table-thead > tr > th {\n    color: ', ';\n    font-size: 13px;\n    background-color: ', ';\n    border-bottom: 0;\n\n    &.ant-table-column-sort {\n      background: ', ';\n      margin: ', ';\n    }\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 16px 15px;\n    white-space: nowrap;\n    text-align: ', ';\n\n    p {\n      margin-bottom: 0;\n    }\n  }\n\n  .ant-table-tbody > tr > td {\n    font-size: 12px;\n    color: ', ';\n    border-bottom: 1px solid ', ';\n\n    a {\n      color: ', ';\n      ', ';\n\n      &:hover {\n        color: ', ';\n      }\n    }\n  }\n\n  .ant-table-thead > tr.ant-table-row-hover > td,\n  .ant-table-tbody > tr.ant-table-row-hover > td,\n  .ant-table-thead > tr:hover > td,\n  .ant-table-tbody > tr:hover > td {\n    background-color: transparent;\n  }\n\n  .ant-table-bordered .ant-table-thead > tr > th {\n    border-bottom: 1px solid ', ';\n  }\n\n  .ant-table-bordered .ant-table-thead > tr > th,\n  .ant-table-bordered .ant-table-tbody > tr > td {\n    border-right: 1px solid ', ';\n  }\n\n  .ant-table-pagination {\n    float: ', ';\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-next {\n    border: 1px solid ', ';\n  }\n\n  .ant-pagination-disabled,\n  .ant-pagination-prev.ant-pagination-disabled,\n  .ant-pagination-next.ant-pagination-disabled {\n    border: 1px solid ', ';\n\n    a {\n      border: 0;\n    }\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-next,\n  .ant-pagination-jump-prev,\n  .ant-pagination-jump-next {\n    transform: ', ';\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-jump-prev,\n  .ant-pagination-jump-next {\n    margin: ', ';\n  }\n\n  .ant-pagination-item {\n    margin: ', ';\n\n    &:hover {\n      border-color: ', ';\n      ', ';\n    }\n\n    &:hover a {\n      color: ', ';\n    }\n  }\n\n  .ant-pagination-item-active {\n    background-color: ', ';\n    border-color: ', ';\n\n    a {\n      color: #ffffff;\n    }\n\n    &:hover a {\n      color: #ffffff;\n    }\n  }\n\n  .ant-table-expanded-row {\n    background: ', ';\n\n    p {\n      color: ', ';\n    }\n  }\n\n  .ant-spin-nested-loading > div > .ant-spin {\n    max-height: none;\n\n    .ant-spin-dot i {\n      color: ', ';\n    }\n  }\n\n  .ant-table-header {\n    background-color: transparent;\n  }\n\n  .ant-table-title {\n    background: ', ';\n    color: ', ';\n    font-size: 13px;\n    font-weight: 500;\n    padding: 16px 30px;\n    ', ';\n  }\n\n  .ant-table-footer {\n    background: ', ';\n    color: ', ';\n    font-size: 12px;\n    font-weight: 400;\n    padding: 16px 30px;\n    ', ';\n  }\n\n  .ant-table-content {\n    overflow-x: auto;\n  }\n\n  .ant-table-column-sorter-up.on .anticon-caret-up,\n  .ant-table-column-sorter-down.on .anticon-caret-up,\n  .ant-table-column-sorter-up.on .anticon-caret-down,\n  .ant-table-column-sorter-down.on .anticon-caret-down {\n    color: ', ';\n  }\n\n  &.isoSearchableTable {\n    .isoTableSearchBox {\n      padding: 20px;\n      display: flex;\n      background: #ffffff;\n      border: 1px solid ', ';\n      ', ';\n\n      input {\n        font-size: 14px;\n        font-weight: 400;\n        color: ', ';\n        line-height: inherit;\n        height: 36px;\n        width: 100%;\n        padding: 0 15px;\n        margin: 0;\n        border: 1px solid ', ';\n        outline: 0 !important;\n        overflow: hidden;\n        background-color: #ffffff;\n        ', ';\n        ', ';\n        ', ';\n\n        &:focus,\n        &:hover {\n          border-color: ', ';\n          ', ';\n        }\n\n        &::-webkit-input-placeholder {\n          color: ', ';\n        }\n\n        &:-moz-placeholder {\n          color: ', ';\n        }\n\n        &::-moz-placeholder {\n          color: ', ';\n        }\n        &:-ms-input-placeholder {\n          color: ', ';\n        }\n      }\n\n      button {\n        font-size: 12px;\n        font-weight: 400;\n        padding: 0;\n        text-transform: uppercase;\n        color: #ffffff;\n        background-color: ', ';\n        border: 0;\n        outline: 0;\n        height: 36px;\n        padding: 0 15px;\n        margin-left: -1px;\n        cursor: pointer;\n        border-radius: ', ';\n        ', ';\n\n        &:hover {\n          background-color: ', ';\n        }\n      }\n    }\n\n    .ant-table-thead > tr > th {\n      word-break: keep-all;\n\n      span {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n\n        i {\n          margin: ', ';\n          order: -1;\n        }\n      }\n    }\n  }\n\n  &.isoGroupTable {\n    .ant-table-thead > tr {\n      th {\n        border: 1px solid ', ';\n        border-left: 0;\n\n        &[rowspan] {\n          text-align: center;\n        }\n\n        &.isoImageCell {\n          padding: 3px;\n        }\n      }\n\n      &:first-child {\n        th {\n          &:first-child {\n            border-left: ', '\n              solid ', ';\n          }\n        }\n      }\n\n      &:last-child {\n        th {\n          border-top: 0;\n        }\n      }\n    }\n\n    .ant-table-tbody {\n      .ant-table-row {\n        td {\n          border-right: 1px solid ', ';\n\n          &:first-child {\n            border-left: ', '\n              solid ', ';\n          }\n\n          &:last-child {\n            border-left: ', '\n              solid ', ';\n          }\n\n          &.isoImageCell {\n            padding: 3px;\n          }\n        }\n      }\n    }\n  }\n\n  &.isoEditableTable {\n    .isoEditData {\n      .isoEditDataWrapper {\n        display: flex;\n        align-items: center;\n\n        input {\n          font-size: 12px;\n          font-weight: 400;\n          color: ', ';\n          line-height: inherit;\n          padding: 7px 10px;\n          margin: ', ';\n          border: 1px solid ', ';\n          outline: 0 !important;\n          overflow: hidden;\n          background-color: #ffffff;\n          ', ';\n          ', ';\n          ', ';\n\n          &:focus,\n          &:hover {\n            border-color: ', ';\n            ', ';\n          }\n\n          &::-webkit-input-placeholder {\n            color: ', ';\n          }\n\n          &:-moz-placeholder {\n            color: ', ';\n          }\n\n          &::-moz-placeholder {\n            color: ', ';\n          }\n          &:-ms-input-placeholder {\n            color: ', ';\n          }\n        }\n\n        .isoEditIcon {\n          cursor: pointer;\n        }\n      }\n\n      .isoDataWrapper {\n        display: flex;\n        align-items: center;\n\n        .isoEditIcon {\n          margin: ', ';\n          cursor: pointer;\n          flex-shrink: 0;\n        }\n      }\n    }\n  }\n'], ['\n  overflow: hidden;\n  overflow-x: auto;\n  background-color: #ffffff;\n\n  .ant-table-thead > tr > th {\n    color: ', ';\n    font-size: 13px;\n    background-color: ', ';\n    border-bottom: 0;\n\n    &.ant-table-column-sort {\n      background: ', ';\n      margin: ', ';\n    }\n  }\n\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    padding: 16px 15px;\n    white-space: nowrap;\n    text-align: ', ';\n\n    p {\n      margin-bottom: 0;\n    }\n  }\n\n  .ant-table-tbody > tr > td {\n    font-size: 12px;\n    color: ', ';\n    border-bottom: 1px solid ', ';\n\n    a {\n      color: ', ';\n      ', ';\n\n      &:hover {\n        color: ', ';\n      }\n    }\n  }\n\n  .ant-table-thead > tr.ant-table-row-hover > td,\n  .ant-table-tbody > tr.ant-table-row-hover > td,\n  .ant-table-thead > tr:hover > td,\n  .ant-table-tbody > tr:hover > td {\n    background-color: transparent;\n  }\n\n  .ant-table-bordered .ant-table-thead > tr > th {\n    border-bottom: 1px solid ', ';\n  }\n\n  .ant-table-bordered .ant-table-thead > tr > th,\n  .ant-table-bordered .ant-table-tbody > tr > td {\n    border-right: 1px solid ', ';\n  }\n\n  .ant-table-pagination {\n    float: ', ';\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-next {\n    border: 1px solid ', ';\n  }\n\n  .ant-pagination-disabled,\n  .ant-pagination-prev.ant-pagination-disabled,\n  .ant-pagination-next.ant-pagination-disabled {\n    border: 1px solid ', ';\n\n    a {\n      border: 0;\n    }\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-next,\n  .ant-pagination-jump-prev,\n  .ant-pagination-jump-next {\n    transform: ', ';\n  }\n\n  .ant-pagination-prev,\n  .ant-pagination-jump-prev,\n  .ant-pagination-jump-next {\n    margin: ', ';\n  }\n\n  .ant-pagination-item {\n    margin: ', ';\n\n    &:hover {\n      border-color: ', ';\n      ', ';\n    }\n\n    &:hover a {\n      color: ', ';\n    }\n  }\n\n  .ant-pagination-item-active {\n    background-color: ', ';\n    border-color: ', ';\n\n    a {\n      color: #ffffff;\n    }\n\n    &:hover a {\n      color: #ffffff;\n    }\n  }\n\n  .ant-table-expanded-row {\n    background: ', ';\n\n    p {\n      color: ', ';\n    }\n  }\n\n  .ant-spin-nested-loading > div > .ant-spin {\n    max-height: none;\n\n    .ant-spin-dot i {\n      color: ', ';\n    }\n  }\n\n  .ant-table-header {\n    background-color: transparent;\n  }\n\n  .ant-table-title {\n    background: ', ';\n    color: ', ';\n    font-size: 13px;\n    font-weight: 500;\n    padding: 16px 30px;\n    ', ';\n  }\n\n  .ant-table-footer {\n    background: ', ';\n    color: ', ';\n    font-size: 12px;\n    font-weight: 400;\n    padding: 16px 30px;\n    ', ';\n  }\n\n  .ant-table-content {\n    overflow-x: auto;\n  }\n\n  .ant-table-column-sorter-up.on .anticon-caret-up,\n  .ant-table-column-sorter-down.on .anticon-caret-up,\n  .ant-table-column-sorter-up.on .anticon-caret-down,\n  .ant-table-column-sorter-down.on .anticon-caret-down {\n    color: ', ';\n  }\n\n  &.isoSearchableTable {\n    .isoTableSearchBox {\n      padding: 20px;\n      display: flex;\n      background: #ffffff;\n      border: 1px solid ', ';\n      ', ';\n\n      input {\n        font-size: 14px;\n        font-weight: 400;\n        color: ', ';\n        line-height: inherit;\n        height: 36px;\n        width: 100%;\n        padding: 0 15px;\n        margin: 0;\n        border: 1px solid ', ';\n        outline: 0 !important;\n        overflow: hidden;\n        background-color: #ffffff;\n        ', ';\n        ', ';\n        ', ';\n\n        &:focus,\n        &:hover {\n          border-color: ', ';\n          ', ';\n        }\n\n        &::-webkit-input-placeholder {\n          color: ', ';\n        }\n\n        &:-moz-placeholder {\n          color: ', ';\n        }\n\n        &::-moz-placeholder {\n          color: ', ';\n        }\n        &:-ms-input-placeholder {\n          color: ', ';\n        }\n      }\n\n      button {\n        font-size: 12px;\n        font-weight: 400;\n        padding: 0;\n        text-transform: uppercase;\n        color: #ffffff;\n        background-color: ', ';\n        border: 0;\n        outline: 0;\n        height: 36px;\n        padding: 0 15px;\n        margin-left: -1px;\n        cursor: pointer;\n        border-radius: ', ';\n        ', ';\n\n        &:hover {\n          background-color: ', ';\n        }\n      }\n    }\n\n    .ant-table-thead > tr > th {\n      word-break: keep-all;\n\n      span {\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n\n        i {\n          margin: ', ';\n          order: -1;\n        }\n      }\n    }\n  }\n\n  &.isoGroupTable {\n    .ant-table-thead > tr {\n      th {\n        border: 1px solid ', ';\n        border-left: 0;\n\n        &[rowspan] {\n          text-align: center;\n        }\n\n        &.isoImageCell {\n          padding: 3px;\n        }\n      }\n\n      &:first-child {\n        th {\n          &:first-child {\n            border-left: ', '\n              solid ', ';\n          }\n        }\n      }\n\n      &:last-child {\n        th {\n          border-top: 0;\n        }\n      }\n    }\n\n    .ant-table-tbody {\n      .ant-table-row {\n        td {\n          border-right: 1px solid ', ';\n\n          &:first-child {\n            border-left: ', '\n              solid ', ';\n          }\n\n          &:last-child {\n            border-left: ', '\n              solid ', ';\n          }\n\n          &.isoImageCell {\n            padding: 3px;\n          }\n        }\n      }\n    }\n  }\n\n  &.isoEditableTable {\n    .isoEditData {\n      .isoEditDataWrapper {\n        display: flex;\n        align-items: center;\n\n        input {\n          font-size: 12px;\n          font-weight: 400;\n          color: ', ';\n          line-height: inherit;\n          padding: 7px 10px;\n          margin: ', ';\n          border: 1px solid ', ';\n          outline: 0 !important;\n          overflow: hidden;\n          background-color: #ffffff;\n          ', ';\n          ', ';\n          ', ';\n\n          &:focus,\n          &:hover {\n            border-color: ', ';\n            ', ';\n          }\n\n          &::-webkit-input-placeholder {\n            color: ', ';\n          }\n\n          &:-moz-placeholder {\n            color: ', ';\n          }\n\n          &::-moz-placeholder {\n            color: ', ';\n          }\n          &:-ms-input-placeholder {\n            color: ', ';\n          }\n        }\n\n        .isoEditIcon {\n          cursor: pointer;\n        }\n      }\n\n      .isoDataWrapper {\n        display: flex;\n        align-items: center;\n\n        .isoEditIcon {\n          margin: ', ';\n          cursor: pointer;\n          flex-shrink: 0;\n        }\n      }\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  .isoCustomizedTableControlBar {\n    margin-bottom: 40px;\n\n    .ant-form-item {\n      margin: ', ';\n    }\n\n    .ant-form-item-label {\n      label {\n        color: ', ';\n\n        &:after {\n          margin: ', ';\n        }\n      }\n    }\n\n    .ant-switch-checked {\n      border-color: ', ';\n      background-color: ', ';\n    }\n  }\n'], ['\n  .isoCustomizedTableControlBar {\n    margin-bottom: 40px;\n\n    .ant-form-item {\n      margin: ', ';\n    }\n\n    .ant-form-item-label {\n      label {\n        color: ', ';\n\n        &:after {\n          margin: ', ';\n        }\n      }\n    }\n\n    .ant-switch-checked {\n      border-color: ', ';\n      background-color: ', ';\n    }\n  }\n']);
	
	var _table = __webpack_require__(1632);
	
	var _table2 = _interopRequireDefault(_table);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _styleUtil = __webpack_require__(278);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TableWrapper = (0, _styledComponents2.default)(_table2.default)(_templateObject, (0, _styledTheme.palette)('secondary', 2), (0, _styledTheme.palette)('secondary', 1), (0, _styledTheme.palette)('secondary', 1), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 4px 0 0' : '0 0 0 4px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	}, (0, _styledTheme.palette)('text', 3), (0, _styledTheme.palette)('border', 0), (0, _styledTheme.palette)('primary', 0), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 4), (0, _styledTheme.palette)('border', 0), (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'left' : 'right';
	}, (0, _styledTheme.palette)('border', 0), (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'rotate(0)';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 0 0 8px' : '0 8px 0 0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 0 0 8px' : '0 8px 0 0';
	}, (0, _styledTheme.palette)('primary', 0), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('grayscale', 6), (0, _styledTheme.palette)('text', 3), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('secondary', 1), (0, _styledTheme.palette)('secondary', 2), (0, _styleUtil.borderRadius)(), (0, _styledTheme.palette)('secondary', 1), (0, _styledTheme.palette)('secondary', 2), (0, _styleUtil.borderRadius)(), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.boxShadow)('0 1px 6px rgba(0,0,0,0.2)'), (0, _styledTheme.palette)('text', 3), (0, _styledTheme.palette)('secondary', 7), (0, _styleUtil.borderRadius)('3px 0 0 3px'), (0, _styleUtil.transition)(), (0, _styleUtil.boxShadow)('none'), (0, _styledTheme.palette)('secondary', 7), (0, _styleUtil.boxShadow)('none'), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('primary', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? '3px 0 0 3px' : '0 3px 3px 0';
	}, (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 1), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 0 0 10px' : '0 10px 0 0';
	}, (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '1px';
	}, (0, _styledTheme.palette)('border', 0), (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '1px';
	}, (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? '1px' : '0';
	}, (0, _styledTheme.palette)('border', 0), (0, _styledTheme.palette)('text', 3), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 0 0 10px' : '0 10px 0 0';
	}, (0, _styledTheme.palette)('border', 0), (0, _styleUtil.borderRadius)('3px'), (0, _styleUtil.boxShadow)(), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.boxShadow)(), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 auto 0 0' : '0 0 0 auto';
	});
	
	var WDCustomizedTableWrapper = _styledComponents2.default.div(_templateObject2, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 0 0 16px' : '0 16px 0 0';
	}, (0, _styledTheme.palette)('secondary', 2), function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 2px 0 8px' : '0 8px 0 2px';
	}, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	
	var CustomizedTableWrapper = (0, _withDirection2.default)(WDCustomizedTableWrapper);
	
	exports.CustomizedTableWrapper = CustomizedTableWrapper;
	exports.default = (0, _withDirection2.default)(TableWrapper);

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1769), __esModule: true };

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(753);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 177 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 178 */
[3347, 120, 220, 144],
/* 179 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.7. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(147), __webpack_require__(290), __webpack_require__(291), __webpack_require__(223), __webpack_require__(420), __webpack_require__(899), __webpack_require__(122)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = Math.max(d3Array.tickStep(start, stop, interval), 1);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _propertyUtils = __webpack_require__(1891);
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	var getComputedStyleX = void 0;
	
	// https://stackoverflow.com/a/3485654/3040605
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = value + 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	  if (node.nodeType === 9) {
	    return node;
	  }
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	}
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = (0, _propertyUtils.getTransitionProperty)(elem) || '';
	    (0, _propertyUtils.setTransitionProperty)(elem, 'none');
	  }
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = presetH + 'px';
	  }
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = presetV + 'px';
	  }
	  // force relayout
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	  css(elem, originalStyle);
	  // force relayout
	  forceRelayout(elem);
	  if ('left' in offset || 'top' in offset) {
	    (0, _propertyUtils.setTransitionProperty)(elem, originalTransition);
	  }
	  var ret = {};
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	      var _off = offset[_key] - originalOffset[_key];
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	  css(elem, ret);
	}
	
	function setTransform(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = (0, _propertyUtils.getTransformXY)(elem);
	  var resultXY = { x: originalXY.x, y: originalXY.y };
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	  (0, _propertyUtils.setTransformXY)(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && (0, _propertyUtils.getTransformName)() in document.body.style) {
	    setTransform(elem, offset, option);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = void 0;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = void 0;
	  var j = void 0;
	  var i = void 0;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	        if (prop === 'border') {
	          cssProp = '' + prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, ex) {
	  var extra = ex;
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle));
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val = void 0;
	  var elem = args[0];
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i = void 0;
	    var ret = {};
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      utils.mix(ret, args[i]);
	    }
	    return ret;
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	
	mix(utils, domUtils);
	
	exports['default'] = utils;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}
	module.exports = exports["default"];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  // HTML DOM and SVG DOM may have different support levels,
	  // so we need to check on context instead of a document root element.
	  return _inDOM2.default ? function (context, node) {
	    if (context.contains) {
	      return context.contains(node);
	    } else if (context.compareDocumentPosition) {
	      return context === node || !!(context.compareDocumentPosition(node) & 16);
	    } else {
	      return fallback(context, node);
	    }
	  } : fallback;
	}();
	
	function fallback(context, node) {
	  if (node) do {
	    if (node === context) return true;
	  } while (node = node.parentNode);
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(26);
	
	var Record = Immutable.Record;
	
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
	  }
	
	  SelectionState.prototype.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  SelectionState.prototype.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  SelectionState.prototype.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  SelectionState.prototype.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  };
	
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	
	
	  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionEnd && selectionStart <= end;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  SelectionState.prototype.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  SelectionState.prototype.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  SelectionState.prototype.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  SelectionState.prototype.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  SelectionState.prototype.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ },
/* 185 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ },
/* 187 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 188 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
	}
	module.exports = exports['default'];

/***/ },
/* 189 */
[3459, 100],
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.connect = exports.Provider = undefined;
	
	var _Provider2 = __webpack_require__(2456);
	
	var _Provider3 = _interopRequireDefault(_Provider2);
	
	var _connect2 = __webpack_require__(2457);
	
	var _connect3 = _interopRequireDefault(_connect2);
	
	var _create2 = __webpack_require__(2458);
	
	var _create3 = _interopRequireDefault(_create2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider3.default;
	exports.connect = _connect3.default;
	exports.create = _create3.default;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Divider = exports.ItemGroup = exports.MenuItemGroup = exports.MenuItem = exports.Item = exports.SubMenu = undefined;
	
	var _Menu = __webpack_require__(2548);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _SubMenu = __webpack_require__(2551);
	
	var _SubMenu2 = _interopRequireDefault(_SubMenu);
	
	var _MenuItem = __webpack_require__(2549);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _MenuItemGroup = __webpack_require__(2550);
	
	var _MenuItemGroup2 = _interopRequireDefault(_MenuItemGroup);
	
	var _Divider = __webpack_require__(2547);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.SubMenu = _SubMenu2['default'];
	exports.Item = _MenuItem2['default'];
	exports.MenuItem = _MenuItem2['default'];
	exports.MenuItemGroup = _MenuItemGroup2['default'];
	exports.ItemGroup = _MenuItemGroup2['default'];
	exports.Divider = _Divider2['default'];
	exports['default'] = _Menu2['default'];

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isSameDay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  // Compare least significant, most likely to change units first
	  // Moment's isSame clones moment inputs and is a tad slow
	  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
	}

/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toMomentObject;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toMomentObject(dateString, customFormat) {
	  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
	
	  var date = (0, _moment2['default'])(dateString, dateFormats, true);
	  return date.isValid() ? date.hour(12) : null;
	}

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _countries = __webpack_require__(2738);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactFlagsSelect = function (_Component) {
		_inherits(ReactFlagsSelect, _Component);
	
		function ReactFlagsSelect(props) {
			_classCallCheck(this, ReactFlagsSelect);
	
			var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
			var fullCountries = Object.keys(_countries2.default);
	
			var selectCountries = _this.props.countries && _this.props.countries.filter(function (country) {
				return _countries2.default[country];
			});
	
			//Filter BlackList
			selectCountries = !_this.props.blackList ? selectCountries : fullCountries.filter(function (countryKey) {
				return selectCountries.filter(function (country) {
					return countryKey === country;
				}).length === 0;
			});
	
			var defaultCountry = _countries2.default[_this.props.defaultCountry] && _this.props.defaultCountry;
	
			_this.state = {
				openOptions: false,
				countries: selectCountries || fullCountries,
				defaultCountry: defaultCountry,
				filteredCountries: []
			};
	
			_this.toggleOptions = _this.toggleOptions.bind(_this);
			_this.closeOptions = _this.closeOptions.bind(_this);
			_this.onSelect = _this.onSelect.bind(_this);
			_this.filterSearch = _this.filterSearch.bind(_this);
			return _this;
		}
	
		ReactFlagsSelect.prototype.toggleOptions = function toggleOptions() {
			!this.state.disabled && this.setState({
				openOptions: !this.state.openOptions
			});
		};
	
		ReactFlagsSelect.prototype.closeOptions = function closeOptions(event) {
			if (event.target !== this.refs.selectedFlag && event.target !== this.refs.flagOptions && event.target !== this.refs.filterText) {
				this.setState({
					openOptions: false
				});
			}
		};
	
		ReactFlagsSelect.prototype.onSelect = function onSelect(countryCode) {
			this.setState({
				selected: countryCode,
				filter: ''
			});
			this.props.onSelect && this.props.onSelect(countryCode);
		};
	
		ReactFlagsSelect.prototype.updateSelected = function updateSelected(countryCode) {
			var isValid = _countries2.default[countryCode];
	
			isValid && this.setState({
				selected: countryCode
			});
		};
	
		ReactFlagsSelect.prototype.filterSearch = function filterSearch(evt) {
			var _this2 = this;
	
			var filterValue = evt.target.value;
			var filteredCountries = filterValue && this.state.countries.filter(function (key) {
				var label = _this2.props.customLabels[key] || _countries2.default[key];
				return label && label.match(new RegExp(filterValue, 'i'));
			});
	
			this.setState({ filter: filterValue, filteredCountries: filteredCountries });
		};
	
		ReactFlagsSelect.prototype.componentDidMount = function componentDidMount() {
			!this.props.disabled && window.addEventListener("click", this.closeOptions);
		};
	
		ReactFlagsSelect.prototype.componentWillUnmount = function componentWillUnmount() {
			!this.props.disabled && window.removeEventListener("click", this.closeOptions);
		};
	
		ReactFlagsSelect.prototype.render = function render() {
			var _this3 = this;
	
			var isSelected = this.state.selected || this.state.defaultCountry;
			var selectedSize = this.props.selectedSize;
			var optionsSize = this.props.optionsSize;
			var alignClass = this.props.alignOptions.toLowerCase() === 'left' ? 'to--left' : '';
	
			return _react2.default.createElement(
				'div',
				{ className: 'flag-select ' + (this.props.className ? this.props.className : "") },
				_react2.default.createElement(
					'div',
					{ ref: 'selectedFlag', style: { fontSize: selectedSize + 'px' }, className: 'selected--flag--option ' + (this.props.disabled ? 'no--focus' : ''), onClick: this.toggleOptions },
					isSelected && _react2.default.createElement(
						'span',
						{ className: 'country-flag', style: { width: selectedSize + 'px', height: selectedSize + 'px' } },
						_react2.default.createElement('img', { src: __webpack_require__(1242)("./" + isSelected.toLowerCase() + '.svg') }),
						this.props.showSelectedLabel && _react2.default.createElement(
							'span',
							{ className: 'country-label' },
							this.props.customLabels[isSelected] || _countries2.default[isSelected]
						)
					),
					!isSelected && _react2.default.createElement(
						'span',
						{ className: 'country-label' },
						this.props.placeholder
					),
					_react2.default.createElement(
						'span',
						{ className: 'arrow-down ' + (this.props.disabled ? 'hidden' : '') },
						'\u25BE'
					)
				),
				this.state.openOptions && _react2.default.createElement(
					'div',
					{ ref: 'flagOptions', style: { fontSize: optionsSize + 'px' }, className: 'flag-options ' + alignClass },
					this.props.searchable && _react2.default.createElement(
						'div',
						{ className: 'filterBox' },
						_react2.default.createElement('input', { type: 'text', placeholder: 'Search', ref: 'filterText', onChange: this.filterSearch })
					),
					(this.state.filter ? this.state.filteredCountries : this.state.countries).map(function (countryCode) {
						return _react2.default.createElement(
							'div',
							{ className: 'flag-option ' + (_this3.props.showOptionLabel ? 'has-label' : ''), key: countryCode, onClick: function onClick() {
									return _this3.onSelect(countryCode);
								} },
							_react2.default.createElement(
								'span',
								{ className: 'country-flag', style: { width: optionsSize + 'px', height: optionsSize + 'px' } },
								_react2.default.createElement('img', { src: __webpack_require__(1242)("./" + countryCode.toLowerCase() + '.svg') }),
								_this3.props.showOptionLabel && _react2.default.createElement(
									'span',
									{ className: 'country-label' },
									_this3.props.customLabels[countryCode] || _countries2.default[countryCode]
								)
							)
						);
					})
				)
			);
		};
	
		return ReactFlagsSelect;
	}(_react.Component);
	
	ReactFlagsSelect.defaultProps = {
		selectedSize: 16,
		optionsSize: 14,
		placeholder: "Select a country",
		showSelectedLabel: true,
		showOptionLabel: true,
		alignOptions: "right",
		customLabels: [],
		disabled: false,
		blackList: false,
		searchable: false
	};
	
	ReactFlagsSelect.propsType = {
		countries: _propTypes2.default.array,
		blackList: _propTypes2.default.bool,
		customLabels: _propTypes2.default.array,
		selectedSize: _propTypes2.default.number,
		optionsSize: _propTypes2.default.number,
		defaultCountry: _propTypes2.default.string,
		placeholder: _propTypes2.default.string,
		className: _propTypes2.default.string,
		showSelectedLabel: _propTypes2.default.bool,
		showOptionLabel: _propTypes2.default.bool,
		alignOptions: _propTypes2.default.string,
		onSelect: _propTypes2.default.func,
		disabled: _propTypes2.default.bool,
		searchable: _propTypes2.default.bool
	};
	
	exports.default = ReactFlagsSelect;
	module.exports = exports['default'];

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (componentOrElement) {
	  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
	};
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ownerDocument = __webpack_require__(182);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _fieldActions = __webpack_require__(500);
	
	var _fieldActions2 = _interopRequireDefault(_fieldActions);
	
	var _modelActions = __webpack_require__(1260);
	
	var _modelActions2 = _interopRequireDefault(_modelActions);
	
	var _batchActions = __webpack_require__(341);
	
	var _batchActions2 = _interopRequireDefault(_batchActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actions = _extends({}, _fieldActions2.default, _modelActions2.default, {
	  batch: _batchActions2.default
	});
	
	exports.default = actions;

/***/ },
/* 199 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = identity;
	function identity(a) {
	  return a;
	}

/***/ },
/* 200 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = omit;
	function omit(object, props) {
	  if (object == null) {
	    return {};
	  }
	  var newObject = _extends({}, object);
	
	  if (typeof props === 'string') {
	    delete newObject[props];
	  } else {
	    props.forEach(function (prop) {
	      delete newObject[prop];
	    });
	  }
	
	  return newObject;
	}

/***/ },
/* 201 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/* eslint-disable */
	
	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  if (objA instanceof Date && objB instanceof Date) {
	    return objA === objB;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var omitKeys = options.omitKeys,
	      deepKeys = options.deepKeys;
	
	  // Test for A's keys different from B.
	
	  for (var i = 0; i < keysA.length; i++) {
	    // if key is an omitted key, skip comparison
	    if (omitKeys && omitKeys.length && ~omitKeys.indexOf(keysA[i])) continue;
	
	    if (deepKeys && deepKeys.length && ~deepKeys.indexOf(keysA[i])) {
	      var result = shallowEqual(objA[keysA[i]], objB[keysA[i]]);
	
	      if (!result) return false;
	    } else if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	exports.default = shallowEqual;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var ReactCurrentOwner = __webpack_require__(1306);
	
	var warning = __webpack_require__(301);
	var canDefineProperty = __webpack_require__(1309);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(1307);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDOMNode = exports.isReactDOMSupported = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.warning = warning;
	exports.warnOnce = warnOnce;
	exports.checkIfStyleSheetIsImported = checkIfStyleSheetIsImported;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var _React$version$split = _react2.default.version.split('.'),
	    _React$version$split2 = _slicedToArray(_React$version$split, 2),
	    major = _React$version$split2[0],
	    minor = _React$version$split2[1];
	
	var versionHigherThanThirteen = Number(minor) > 13 || Number(major) > 13;
	
	var isReactDOMSupported = exports.isReactDOMSupported = function isReactDOMSupported() {
	  return versionHigherThanThirteen;
	};
	
	/**
	 * Support React 0.13 and greater where refs are React components, not DOM
	 * nodes.
	 * @param {*} ref React's ref.
	 * @returns {Element} DOM element.
	 */
	var getDOMNode = exports.getDOMNode = function getDOMNode(ref) {
	  if (!isReactDOMSupported()) {
	    return ref && ref.getDOMNode();
	  }
	  return ref;
	};
	
	var USED_MESSAGES = {};
	var HIDDEN_PROCESSES = {
	  test: true,
	  production: true
	};
	
	/**
	 * Warn the user about something
	 * @param {String} message - the message to be shown
	 * @param {Boolean} onlyShowMessageOnce - whether or not we allow the
	 - message to be show multiple times
	 */
	function warning(message) {
	  var onlyShowMessageOnce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  /* eslint-disable no-undef, no-process-env */
	  if (process && HIDDEN_PROCESSES[("production")]) {
	    return;
	  }
	  /* eslint-enable no-undef, no-process-env */
	  if (!onlyShowMessageOnce || !USED_MESSAGES[message]) {
	    /* eslint-disable no-console */
	    console.warn(message);
	    /* eslint-enable no-console */
	    USED_MESSAGES[message] = true;
	  }
	}
	
	/**
	 * Convience wrapper for warning
	 * @param {String} message - the message to be shown
	 */
	function warnOnce(message) {
	  warning(message, true);
	}
	
	/**
	 * Safely returns list of CSS from a CSS Style Sheet.
	 * @param {CSSStyleSheet} styleSheet  - CSS style sheet
	 * @returns {CSSRuleList} list of CSS rules
	 */
	function getCSSRules(styleSheet) {
	  // Without this check accessing styleSheet.cssRules throws SecurityErrror in Firefox
	  // See: https://github.com/uber/react-vis/issues/650
	  if (styleSheet.ownerNode.tagName === 'STYLE' || styleSheet.ownerNode.tagName === 'LINK' && styleSheet.ownerNode.href && styleSheet.ownerNode.href.startsWith(document.location.origin)) {
	    try {
	      return styleSheet.rules || styleSheet.cssRules;
	    } catch (err) {
	      return [];
	    }
	  }
	  return [];
	}
	
	// special tag for using to check if the style file has been imported
	// represented the md5 hash of the phrase "react-vis is cool"
	var MAGIC_CSS_RULE = '.react-vis-magic-css-import-rule';
	function checkIfStyleSheetIsImported() {
	  /* eslint-disable no-undef, no-process-env */
	  if (process && HIDDEN_PROCESSES[("production")]) {
	    return;
	  }
	  /* eslint-enable no-undef, no-process-env */
	
	  var foundImportTag = [].concat(_toConsumableArray(document.styleSheets)).some(function (styleSheet) {
	    var CSSRulesList = getCSSRules(styleSheet);
	    return [].concat(_toConsumableArray(CSSRulesList)).some(function (selector) {
	      return selector.selectorText === MAGIC_CSS_RULE;
	    });
	  });
	
	  if (!foundImportTag) {
	    /* eslint-disable max-len */
	    warnOnce('REACT-VIS: The style sheet for react-vis has not been imported, checkout https://uber.github.io/react-vis/documentation/general-principles/style for more details.');
	    /* eslint-enable max-len */
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview X Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var XAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(XAxis, _Component);
	
	  function XAxis() {
	    _classCallCheck(this, XAxis);
	
	    return _possibleConstructorReturn(this, (XAxis.__proto__ || Object.getPrototypeOf(XAxis)).apply(this, arguments));
	  }
	
	  _createClass(XAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return XAxis;
	}(_react.Component), _class2.displayName = 'XAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  allowDuplicatedCategory: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of x-axis
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The width of axis which is usually calculated internally
	  width: _propTypes2.default.number,
	  // The height of axis, which need to be setted by user
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['top', 'bottom']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  padding: _propTypes2.default.shape({
	    left: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDecimals: true,
	  hide: false,
	  orientation: 'bottom',
	  width: 0,
	  height: 30,
	  mirror: false,
	  xAxisId: 0,
	  tickCount: 5,
	  type: 'category',
	  domain: [0, 'auto'],
	  padding: { left: 0, right: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false,
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	exports.default = XAxis;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Y Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(YAxis, _Component);
	
	  function YAxis() {
	    _classCallCheck(this, YAxis);
	
	    return _possibleConstructorReturn(this, (YAxis.__proto__ || Object.getPrototypeOf(YAxis)).apply(this, arguments));
	  }
	
	  _createClass(YAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return YAxis;
	}(_react.Component), _class2.displayName = 'YAxis', _class2.propTypes = {
	  allowDecimals: _propTypes2.default.bool,
	  allowDuplicatedCategory: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of y-axis
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // Ticks can be any type when the axis is the type of category
	  // Ticks must be numbers when the axis is the type of number
	  ticks: _propTypes2.default.array,
	  // The count of ticks
	  tickCount: _propTypes2.default.number,
	  // The formatter function of tick
	  tickFormatter: _propTypes2.default.func,
	  // The width of axis, which need to be setted by user
	  width: _propTypes2.default.number,
	  // The height of axis which is usually calculated in Chart
	  height: _propTypes2.default.number,
	  mirror: _propTypes2.default.bool,
	  // The orientation of axis
	  orientation: _propTypes2.default.oneOf(['left', 'right']),
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    bottom: _propTypes2.default.number
	  }),
	  allowDataOverflow: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes2.default.func]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  minTickGap: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
	  reversed: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  allowDuplicatedCategory: true,
	  allowDecimals: true,
	  hide: false,
	  orientation: 'left',
	  width: 60,
	  height: 0,
	  mirror: false,
	  yAxisId: 0,
	  tickCount: 5,
	  type: 'number',
	  domain: [0, 'auto'],
	  padding: { top: 0, bottom: 0 },
	  allowDataOverflow: false,
	  scale: 'auto',
	  reversed: false
	}, _temp)) || _class;
	
	exports.default = YAxis;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(107);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CURVE_FACTORIES = {
	  curveBasisClosed: _d3Shape.curveBasisClosed, curveBasisOpen: _d3Shape.curveBasisOpen, curveBasis: _d3Shape.curveBasis, curveLinearClosed: _d3Shape.curveLinearClosed, curveLinear: _d3Shape.curveLinear,
	  curveMonotoneX: _d3Shape.curveMonotoneX, curveMonotoneY: _d3Shape.curveMonotoneY, curveNatural: _d3Shape.curveNatural, curveStep: _d3Shape.curveStep, curveStepAfter: _d3Shape.curveStepAfter,
	  curveStepBefore: _d3Shape.curveStepBefore
	};
	
	var defined = function defined(p) {
	  return p.x === +p.x && p.y === +p.y;
	};
	var getX = function getX(p) {
	  return p.x;
	};
	var getY = function getY(p) {
	  return p.y;
	};
	
	var getCurveFactory = function getCurveFactory(type, layout) {
	  if ((0, _isFunction3.default)(type)) {
	    return type;
	  }
	
	  var name = 'curve' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  if (name === 'curveMonotone' && layout) {
	    return CURVE_FACTORIES['' + name + (layout === 'vertical' ? 'Y' : 'X')];
	  }
	  return CURVE_FACTORIES[name] || _d3Shape.curveLinear;
	};
	
	var Curve = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Curve, _Component);
	
	  function Curve() {
	    _classCallCheck(this, Curve);
	
	    return _possibleConstructorReturn(this, (Curve.__proto__ || Object.getPrototypeOf(Curve)).apply(this, arguments));
	  }
	
	  _createClass(Curve, [{
	    key: 'getPath',
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          type = _props.type,
	          points = _props.points,
	          baseLine = _props.baseLine,
	          layout = _props.layout,
	          connectNulls = _props.connectNulls;
	
	      var curveFactory = getCurveFactory(type, layout);
	      var formatPoints = connectNulls ? points.filter(function (entry) {
	        return defined(entry);
	      }) : points;
	      var lineFunction = void 0;
	
	      if ((0, _isArray3.default)(baseLine)) {
	        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
	          return defined(base);
	        }) : baseLine;
	        var areaPoints = formatPoints.map(function (entry, index) {
	          return _extends({}, entry, { base: formatBaseLine[index] });
	        });
	        if (layout === 'vertical') {
	          lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(function (d) {
	            return d.base.x;
	          });
	        } else {
	          lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(function (d) {
	            return d.base.y;
	          });
	        }
	        lineFunction.defined(defined).curve(curveFactory);
	
	        return lineFunction(areaPoints);
	      } else if (layout === 'vertical' && (0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
	      } else if ((0, _DataUtils.isNumber)(baseLine)) {
	        lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
	      } else {
	        lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
	      }
	
	      lineFunction.defined(defined).curve(curveFactory);
	
	      return lineFunction(formatPoints);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          points = _props2.points,
	          path = _props2.path,
	          pathRef = _props2.pathRef;
	
	
	      if ((!points || !points.length) && !path) {
	        return null;
	      }
	
	      var realPath = points && points.length ? this.getPath() : path;
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props, null, true), {
	        className: (0, _classnames2.default)('recharts-curve', className),
	        d: realPath,
	        ref: pathRef
	      }));
	    }
	  }]);
	
	  return Curve;
	}(_react.Component), _class2.displayName = 'Curve', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  connectNulls: _propTypes2.default.bool,
	  path: _propTypes2.default.string,
	  pathRef: _propTypes2.default.func
	}), _class2.defaultProps = {
	  type: 'linear',
	  points: [],
	  connectNulls: false
	}, _temp)) || _class;
	
	exports.default = Curve;

/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Rectangle
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getRectangePath = function getRectangePath(x, y, width, height, radius) {
	  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
	  var sign = height >= 0 ? 1 : -1;
	  var clockWise = height >= 0 ? 1 : 0;
	  var path = void 0;
	
	  if (maxRadius > 0 && radius instanceof Array) {
	    var newRadius = [];
	    for (var i = 0, len = 4; i < len; i++) {
	      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
	    }
	
	    path = 'M' + x + ',' + (y + sign * newRadius[0]);
	
	    if (newRadius[0] > 0) {
	      path += 'A ' + newRadius[0] + ',' + newRadius[0] + ',0,0,' + clockWise + ',' + (x + newRadius[0]) + ',' + y;
	    }
	
	    path += 'L ' + (x + width - newRadius[1]) + ',' + y;
	
	    if (newRadius[1] > 0) {
	      path += 'A ' + newRadius[1] + ',' + newRadius[1] + ',0,0,' + clockWise + ',\n        ' + (x + width) + ',' + (y + sign * newRadius[1]);
	    }
	    path += 'L ' + (x + width) + ',' + (y + height - sign * newRadius[2]);
	
	    if (newRadius[2] > 0) {
	      path += 'A ' + newRadius[2] + ',' + newRadius[2] + ',0,0,' + clockWise + ',\n        ' + (x + width - newRadius[2]) + ',' + (y + height);
	    }
	    path += 'L ' + (x + newRadius[3]) + ',' + (y + height);
	
	    if (newRadius[3] > 0) {
	      path += 'A ' + newRadius[3] + ',' + newRadius[3] + ',0,0,' + clockWise + ',\n        ' + x + ',' + (y + height - sign * newRadius[3]);
	    }
	    path += 'Z';
	  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
	    var _newRadius = Math.min(maxRadius, radius);
	
	    path = 'M ' + x + ',' + (y + sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + _newRadius) + ',' + y + '\n            L ' + (x + width - _newRadius) + ',' + y + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width) + ',' + (y + sign * _newRadius) + '\n            L ' + (x + width) + ',' + (y + height - sign * _newRadius) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + (x + width - _newRadius) + ',' + (y + height) + '\n            L ' + (x + _newRadius) + ',' + (y + height) + '\n            A ' + _newRadius + ',' + _newRadius + ',0,0,' + clockWise + ',' + x + ',' + (y + height - sign * _newRadius) + ' Z';
	  } else {
	    path = 'M ' + x + ',' + y + ' h ' + width + ' v ' + height + ' h ' + -width + ' Z';
	  }
	
	  return path;
	};
	
	var Rectangle = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Rectangle, _Component);
	
	  function Rectangle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Rectangle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rectangle.__proto__ || Object.getPrototypeOf(Rectangle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      totalLength: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Rectangle, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (this.node && this.node.getTotalLength) {
	        try {
	          var totalLength = this.node.getTotalLength();
	
	          if (totalLength) {
	            this.setState({
	              totalLength: totalLength
	            });
	          }
	        } catch (err) {
	          // calculate total length error
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          radius = _props.radius,
	          className = _props.className;
	      var totalLength = this.state.totalLength;
	      var _props2 = this.props,
	          animationEasing = _props2.animationEasing,
	          animationDuration = _props2.animationDuration,
	          animationBegin = _props2.animationBegin,
	          isAnimationActive = _props2.isAnimationActive,
	          isUpdateAnimationActive = _props2.isUpdateAnimationActive;
	
	
	      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-rectangle', className);
	
	      if (!isUpdateAnimationActive) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: layerClass,
	          d: getRectangePath(x, y, width, height, radius)
	        }));
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          canBegin: totalLength > 0,
	          from: { width: width, height: height, x: x, y: y },
	          to: { width: width, height: height, x: x, y: y },
	          duration: animationDuration,
	          animationEasing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref2) {
	          var currWidth = _ref2.width,
	              currHeight = _ref2.height,
	              currX = _ref2.x,
	              currY = _ref2.y;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              canBegin: totalLength > 0,
	              from: '0px ' + (totalLength === -1 ? 1 : totalLength) + 'px',
	              to: totalLength + 'px 0px',
	              attributeName: 'strokeDasharray',
	              begin: animationBegin,
	              duration: animationDuration,
	              isActive: isAnimationActive,
	              easing: animationEasing
	            },
	            _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(_this2.props), (0, _ReactUtils.filterEventAttributes)(_this2.props), {
	              className: layerClass,
	              d: getRectangePath(currX, currY, currWidth, currHeight, radius),
	              ref: function ref(node) {
	                _this2.node = node;
	              }
	            }))
	          );
	        }
	      );
	    }
	  }]);
	
	  return Rectangle;
	}(_react.Component), _class2.displayName = 'Rectangle', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  // The radius of border
	  // The radius of four corners when radius is a number
	  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
	  radius: 0,
	  isAnimationActive: false,
	  isUpdateAnimationActive: false,
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _temp2)) || _class;
	
	exports.default = Rectangle;

/***/ },
/* 208 */
[3470, 363, 3152, 3180],
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(1363),
	    copyArray = __webpack_require__(1369),
	    isArray = __webpack_require__(92),
	    isSymbol = __webpack_require__(372),
	    stringToPath = __webpack_require__(1379),
	    toKey = __webpack_require__(262),
	    toString = __webpack_require__(1382);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNDEFINED_INPUT_ERROR = exports.INVALID_BUFFER = exports.isEnd = exports.END = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.emitter = emitter;
	exports.channel = channel;
	exports.eventChannel = eventChannel;
	exports.stdChannel = stdChannel;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var _buffers = /*#__PURE__*/__webpack_require__(374);
	
	var _scheduler = /*#__PURE__*/__webpack_require__(1398);
	
	var CHANNEL_END_TYPE = '@@redux-saga/CHANNEL_END';
	var END = exports.END = { type: CHANNEL_END_TYPE };
	var isEnd = exports.isEnd = function isEnd(a) {
	  return a && a.type === CHANNEL_END_TYPE;
	};
	
	function emitter() {
	  var subscribers = [];
	
	  function subscribe(sub) {
	    subscribers.push(sub);
	    return function () {
	      return (0, _utils.remove)(subscribers, sub);
	    };
	  }
	
	  function emit(item) {
	    var arr = subscribers.slice();
	    for (var i = 0, len = arr.length; i < len; i++) {
	      arr[i](item);
	    }
	  }
	
	  return {
	    subscribe: subscribe,
	    emit: emit
	  };
	}
	
	var INVALID_BUFFER = exports.INVALID_BUFFER = 'invalid buffer passed to channel factory function';
	var UNDEFINED_INPUT_ERROR = exports.UNDEFINED_INPUT_ERROR = 'Saga was provided with an undefined action';
	
	if (false) {
	  exports.UNDEFINED_INPUT_ERROR = UNDEFINED_INPUT_ERROR += '\nHints:\n    - check that your Action Creator returns a non-undefined value\n    - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners\n  ';
	}
	
	function channel() {
	  var buffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buffers.buffers.fixed();
	
	  var closed = false;
	  var takers = [];
	
	  (0, _utils.check)(buffer, _utils.is.buffer, INVALID_BUFFER);
	
	  function checkForbiddenStates() {
	    if (closed && takers.length) {
	      throw (0, _utils.internalErr)('Cannot have a closed channel with pending takers');
	    }
	    if (takers.length && !buffer.isEmpty()) {
	      throw (0, _utils.internalErr)('Cannot have pending takers with non empty buffer');
	    }
	  }
	
	  function put(input) {
	    checkForbiddenStates();
	    (0, _utils.check)(input, _utils.is.notUndef, UNDEFINED_INPUT_ERROR);
	    if (closed) {
	      return;
	    }
	    if (!takers.length) {
	      return buffer.put(input);
	    }
	    for (var i = 0; i < takers.length; i++) {
	      var cb = takers[i];
	      if (!cb[_utils.MATCH] || cb[_utils.MATCH](input)) {
	        takers.splice(i, 1);
	        return cb(input);
	      }
	    }
	  }
	
	  function take(cb) {
	    checkForbiddenStates();
	    (0, _utils.check)(cb, _utils.is.func, "channel.take's callback must be a function");
	
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	    } else if (!buffer.isEmpty()) {
	      cb(buffer.take());
	    } else {
	      takers.push(cb);
	      cb.cancel = function () {
	        return (0, _utils.remove)(takers, cb);
	      };
	    }
	  }
	
	  function flush(cb) {
	    checkForbiddenStates(); // TODO: check if some new state should be forbidden now
	    (0, _utils.check)(cb, _utils.is.func, "channel.flush' callback must be a function");
	    if (closed && buffer.isEmpty()) {
	      cb(END);
	      return;
	    }
	    cb(buffer.flush());
	  }
	
	  function close() {
	    checkForbiddenStates();
	    if (!closed) {
	      closed = true;
	      if (takers.length) {
	        var arr = takers;
	        takers = [];
	        for (var i = 0, len = arr.length; i < len; i++) {
	          arr[i](END);
	        }
	      }
	    }
	  }
	
	  return {
	    take: take,
	    put: put,
	    flush: flush,
	    close: close,
	    get __takers__() {
	      return takers;
	    },
	    get __closed__() {
	      return closed;
	    }
	  };
	}
	
	function eventChannel(subscribe) {
	  var buffer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _buffers.buffers.none();
	  var matcher = arguments[2];
	
	  /**
	    should be if(typeof matcher !== undefined) instead?
	    see PR #273 for a background discussion
	  **/
	  if (arguments.length > 2) {
	    (0, _utils.check)(matcher, _utils.is.func, 'Invalid match function passed to eventChannel');
	  }
	
	  var chan = channel(buffer);
	  var close = function close() {
	    if (!chan.__closed__) {
	      if (unsubscribe) {
	        unsubscribe();
	      }
	      chan.close();
	    }
	  };
	  var unsubscribe = subscribe(function (input) {
	    if (isEnd(input)) {
	      close();
	      return;
	    }
	    if (matcher && !matcher(input)) {
	      return;
	    }
	    chan.put(input);
	  });
	  if (chan.__closed__) {
	    unsubscribe();
	  }
	
	  if (!_utils.is.func(unsubscribe)) {
	    throw new Error('in eventChannel: subscribe should return a function to unsubscribe');
	  }
	
	  return {
	    take: chan.take,
	    flush: chan.flush,
	    close: close
	  };
	}
	
	function stdChannel(subscribe) {
	  var chan = eventChannel(function (cb) {
	    return subscribe(function (input) {
	      if (input[_utils.SAGA_ACTION]) {
	        cb(input);
	        return;
	      }
	      (0, _scheduler.asap)(function () {
	        return cb(input);
	      });
	    });
	  });
	
	  return _extends({}, chan, {
	    take: function take(cb, matcher) {
	      if (arguments.length > 1) {
	        (0, _utils.check)(matcher, _utils.is.func, "channel.take's matcher argument must be a function");
	        cb[_utils.MATCH] = matcher;
	      }
	      chan.take(cb);
	    }
	  });
	}

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcSelect = __webpack_require__(1174);
	
	var _rcSelect2 = _interopRequireDefault(_rcSelect);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var SelectPropTypes = {
	    prefixCls: _propTypes2['default'].string,
	    className: _propTypes2['default'].string,
	    size: _propTypes2['default'].oneOf(['default', 'large', 'small']),
	    combobox: _propTypes2['default'].bool,
	    notFoundContent: _propTypes2['default'].any,
	    showSearch: _propTypes2['default'].bool,
	    optionLabelProp: _propTypes2['default'].string,
	    transitionName: _propTypes2['default'].string,
	    choiceTransitionName: _propTypes2['default'].string
	};
	// => It is needless to export the declaration of below two inner components.
	// export { Option, OptGroup };
	
	var Select = function (_React$Component) {
	    (0, _inherits3['default'])(Select, _React$Component);
	
	    function Select() {
	        (0, _classCallCheck3['default'])(this, Select);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
	
	        _this.saveSelect = function (node) {
	            _this.rcSelect = node;
	        };
	        _this.renderSelect = function (locale) {
	            var _classNames;
	
	            var _a = _this.props,
	                prefixCls = _a.prefixCls,
	                _a$className = _a.className,
	                className = _a$className === undefined ? '' : _a$className,
	                size = _a.size,
	                mode = _a.mode,
	                restProps = __rest(_a, ["prefixCls", "className", "size", "mode"]);
	            var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), _classNames), className);
	            var optionLabelProp = _this.props.optionLabelProp;
	
	            var isCombobox = mode === 'combobox';
	            if (isCombobox) {
	                // children 带 dom 结构时，无法填入输入框
	                optionLabelProp = optionLabelProp || 'value';
	            }
	            var modeConfig = {
	                multiple: mode === 'multiple',
	                tags: mode === 'tags',
	                combobox: isCombobox
	            };
	            return React.createElement(_rcSelect2['default'], (0, _extends3['default'])({}, restProps, modeConfig, { prefixCls: prefixCls, className: cls, optionLabelProp: optionLabelProp || 'children', notFoundContent: _this.getNotFoundContent(locale), ref: _this.saveSelect }));
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Select, [{
	        key: 'focus',
	        value: function focus() {
	            this.rcSelect.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcSelect.blur();
	        }
	    }, {
	        key: 'getNotFoundContent',
	        value: function getNotFoundContent(locale) {
	            var _props = this.props,
	                notFoundContent = _props.notFoundContent,
	                mode = _props.mode;
	
	            var isCombobox = mode === 'combobox';
	            if (isCombobox) {
	                // AutoComplete don't have notFoundContent defaultly
	                return notFoundContent === undefined ? null : notFoundContent;
	            }
	            return notFoundContent === undefined ? locale.notFoundContent : notFoundContent;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Select', defaultLocale: _default2['default'].Select },
	                this.renderSelect
	            );
	        }
	    }]);
	    return Select;
	}(React.Component);
	
	exports['default'] = Select;
	
	Select.Option = _rcSelect.Option;
	Select.OptGroup = _rcSelect.OptGroup;
	Select.defaultProps = {
	    prefixCls: 'ant-select',
	    showSearch: false,
	    transitionName: 'slide-up',
	    choiceTransitionName: 'zoom'
	};
	Select.propTypes = SelectPropTypes;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1607);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer(props) {
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    { className: "footer" },
	    "@ 2018 Project X"
	  );
	}
	exports.default = Footer;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1613);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Styles
	
	
	var Avatar = function Avatar(data) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'header-avatar' },
	        _react2.default.createElement(
	            'span',
	            null,
	            "你好, " + data.name
	        )
	    );
	};
	var MenuItem = function (_React$Component) {
	    _inherits(MenuItem, _React$Component);
	
	    function MenuItem() {
	        _classCallCheck(this, MenuItem);
	
	        return _possibleConstructorReturn(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
	    }
	
	    _createClass(MenuItem, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'li',
	                { onClick: function onClick() {
	                        _this2.props.history.push(_this2.props.route);
	                    } },
	                this.props.children
	            );
	        }
	    }]);
	
	    return MenuItem;
	}(_react2.default.Component);
	
	var Menu = function (_React$Component2) {
	    _inherits(Menu, _React$Component2);
	
	    function Menu(props) {
	        _classCallCheck(this, Menu);
	
	        var _this3 = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	        _this3.state = {
	            userName: "there"
	        };
	        return _this3;
	    }
	
	    _createClass(Menu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this4 = this;
	
	            this.props.auth.getProfile(function (err, profile) {
	                if (err === null) {
	                    var firstName = profile["http://gogochart.com/user_metadata"] ? profile["http://gogochart.com/user_metadata"].firstname : "";
	                    _this4.setState({
	                        userName: firstName || profile.nickname
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this5 = this;
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'header-menu' },
	                _react2.default.createElement(Avatar, { name: this.state.userName }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'nav-bars' },
	                    _react2.default.createElement('span', null),
	                    _react2.default.createElement('span', null),
	                    _react2.default.createElement('span', null)
	                ),
	                _react2.default.createElement(
	                    'nav',
	                    null,
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            MenuItem,
	                            { history: this.props.history, route: "/me/account" },
	                            '\u6211\u7684\u5E10\u6237'
	                        ),
	                        _react2.default.createElement(
	                            MenuItem,
	                            { history: this.props.history, route: "/me/billing" },
	                            '\u4ED8\u6B3E\u8D44\u6599'
	                        ),
	                        _react2.default.createElement(
	                            MenuItem,
	                            { history: this.props.history, route: "/Campaign" },
	                            '\u5E7F\u544A\u9879\u76EE\u5217\u8868'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            { onClick: function onClick() {
	                                    _this5.props.auth.logout();
	                                } },
	                            '\u767B\u51FA'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Menu;
	}(_react2.default.Component);
	
	exports.default = Menu;
	;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1614);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Styles
	
	
	var HeaderWrapper = function (_React$Component) {
	    _inherits(HeaderWrapper, _React$Component);
	
	    function HeaderWrapper() {
	        _classCallCheck(this, HeaderWrapper);
	
	        return _possibleConstructorReturn(this, (HeaderWrapper.__proto__ || Object.getPrototypeOf(HeaderWrapper)).apply(this, arguments));
	    }
	
	    _createClass(HeaderWrapper, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'header-wrapper', theme: this.props.theme ? this.props.theme : "" },
	                this.props.children
	            );
	        }
	    }]);
	
	    return HeaderWrapper;
	}(_react2.default.Component);
	
	exports.default = HeaderWrapper;
	;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contentHolder = __webpack_require__(1638);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _contentHolder.ContentHolderWrapper,
	    { className: 'isoExampleWrapper', style: props.style },
	    props.children
	  );
	};

/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var actions = {
	
	  SET_CURRENT_APP: 'SET_CURRENT_APP',
	  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
	  SET_COUNTRY_CODE: 'SET_COUNTRY_CODE',
	
	  searchTermUpdated: function searchTermUpdated(searchTerm) {
	    return {
	      type: actions.SET_SEARCH_TERM,
	      searchTerm: searchTerm
	    };
	  },
	
	
	  appSelected: function appSelected(app, secondApp) {
	    console.log(' app action', app, secondApp);
	    return {
	      type: actions.SET_CURRENT_APP,
	      app: app,
	      secondApp: secondApp
	    };
	  },
	
	  countryCodeUpdated: function countryCodeUpdated(countryCode) {
	    return {
	      type: actions.SET_COUNTRY_CODE,
	      countryCode: countryCode
	    };
	  }
	
	  // searchTermUpdated: searchTerm => ({
	  //   type: actions.SET_SEARCH_TERM,
	  //   searchTerm,
	  // })
	
	};
	exports.default = actions;

/***/ },
/* 217 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(765);
	var enumBugKeys = __webpack_require__(402);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 219 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 220 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	
	/**
	 * Namespace to hold static tick generation functions
	 * @namespace Chart.Ticks
	 */
	module.exports = {
		/**
		 * Namespace to hold generators for different types of ticks
		 * @namespace Chart.Ticks.generators
		 */
		generators: {
			/**
			 * Interface for the options provided to the numeric tick generator
			 * @interface INumericTickGenerationOptions
			 */
			/**
			 * The maximum number of ticks to display
			 * @name INumericTickGenerationOptions#maxTicks
			 * @type Number
			 */
			/**
			 * The distance between each tick.
			 * @name INumericTickGenerationOptions#stepSize
			 * @type Number
			 * @optional
			 */
			/**
			 * Forced minimum for the ticks. If not specified, the minimum of the data range is used to calculate the tick minimum
			 * @name INumericTickGenerationOptions#min
			 * @type Number
			 * @optional
			 */
			/**
			 * The maximum value of the ticks. If not specified, the maximum of the data range is used to calculate the tick maximum
			 * @name INumericTickGenerationOptions#max
			 * @type Number
			 * @optional
			 */
	
			/**
			 * Generate a set of linear ticks
			 * @method Chart.Ticks.generators.linear
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			linear: function(generationOptions, dataRange) {
				var ticks = [];
				// To get a "nice" value for the tick spacing, we will use the appropriately named
				// "nice number" algorithm. See http://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
				// for details.
	
				var spacing;
				if (generationOptions.stepSize && generationOptions.stepSize > 0) {
					spacing = generationOptions.stepSize;
				} else {
					var niceRange = helpers.niceNum(dataRange.max - dataRange.min, false);
					spacing = helpers.niceNum(niceRange / (generationOptions.maxTicks - 1), true);
				}
				var niceMin = Math.floor(dataRange.min / spacing) * spacing;
				var niceMax = Math.ceil(dataRange.max / spacing) * spacing;
	
				// If min, max and stepSize is set and they make an evenly spaced scale use it.
				if (generationOptions.min && generationOptions.max && generationOptions.stepSize) {
					// If very close to our whole number, use it.
					if (helpers.almostWhole((generationOptions.max - generationOptions.min) / generationOptions.stepSize, spacing / 1000)) {
						niceMin = generationOptions.min;
						niceMax = generationOptions.max;
					}
				}
	
				var numSpaces = (niceMax - niceMin) / spacing;
				// If very close to our rounded value, use it.
				if (helpers.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
					numSpaces = Math.round(numSpaces);
				} else {
					numSpaces = Math.ceil(numSpaces);
				}
	
				// Put the values into the ticks array
				ticks.push(generationOptions.min !== undefined ? generationOptions.min : niceMin);
				for (var j = 1; j < numSpaces; ++j) {
					ticks.push(niceMin + (j * spacing));
				}
				ticks.push(generationOptions.max !== undefined ? generationOptions.max : niceMax);
	
				return ticks;
			},
	
			/**
			 * Generate a set of logarithmic ticks
			 * @method Chart.Ticks.generators.logarithmic
			 * @param generationOptions {INumericTickGenerationOptions} the options used to generate the ticks
			 * @param dataRange {IRange} the range of the data
			 * @returns {Array<Number>} array of tick values
			 */
			logarithmic: function(generationOptions, dataRange) {
				var ticks = [];
				var valueOrDefault = helpers.valueOrDefault;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph
				var tickVal = valueOrDefault(generationOptions.min, Math.pow(10, Math.floor(helpers.log10(dataRange.min))));
	
				var endExp = Math.floor(helpers.log10(dataRange.max));
				var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
				var exp, significand;
	
				if (tickVal === 0) {
					exp = Math.floor(helpers.log10(dataRange.minNotZero));
					significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
	
					ticks.push(tickVal);
					tickVal = significand * Math.pow(10, exp);
				} else {
					exp = Math.floor(helpers.log10(tickVal));
					significand = Math.floor(tickVal / Math.pow(10, exp));
				}
	
				do {
					ticks.push(tickVal);
	
					++significand;
					if (significand === 10) {
						significand = 1;
						++exp;
					}
	
					tickVal = significand * Math.pow(10, exp);
				} while (exp < endExp || (exp === endExp && significand < endSignificand));
	
				var lastTick = valueOrDefault(generationOptions.max, tickVal);
				ticks.push(lastTick);
	
				return ticks;
			}
		},
	
		/**
		 * Namespace to hold formatters for different types of ticks
		 * @namespace Chart.Ticks.formatters
		 */
		formatters: {
			/**
			 * Formatter for value labels
			 * @method Chart.Ticks.formatters.values
			 * @param value the value to display
			 * @return {String|Array} the label to display
			 */
			values: function(value) {
				return helpers.isArray(value) ? value : '' + value;
			},
	
			/**
			 * Formatter for linear numeric ticks
			 * @method Chart.Ticks.formatters.linear
			 * @param tickValue {Number} the value to be formatted
			 * @param index {Number} the position of the tickValue parameter in the ticks array
			 * @param ticks {Array<Number>} the list of ticks being converted
			 * @return {String} string representation of the tickValue parameter
			 */
			linear: function(tickValue, index, ticks) {
				// If we have lots of ticks, don't use the ones
				var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];
	
				// If we have a number like 2.5 as the delta, figure out how many decimal places we need
				if (Math.abs(delta) > 1) {
					if (tickValue !== Math.floor(tickValue)) {
						// not an integer
						delta = tickValue - Math.floor(tickValue);
					}
				}
	
				var logDelta = helpers.log10(Math.abs(delta));
				var tickString = '';
	
				if (tickValue !== 0) {
					var numDecimal = -1 * Math.floor(logDelta);
					numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
					tickString = tickValue.toFixed(numDecimal);
				} else {
					tickString = '0'; // never show decimal places for 0
				}
	
				return tickString;
			},
	
			logarithmic: function(tickValue, index, ticks) {
				var remain = tickValue / (Math.pow(10, Math.floor(helpers.log10(tickValue))));
	
				if (tickValue === 0) {
					return '0';
				} else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
					return tickValue.toExponential();
				}
				return '';
			}
		}
	};


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.2.2. Copyright 2018 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	var formatDecimal = function(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	};
	
	var exponent = function(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	};
	
	var formatGroup = function(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	};
	
	var formatNumerals = function(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	};
	
	var formatDefault = function(x, p) {
	  x = x.toPrecision(p);
	
	  out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (x[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      case "e": break out;
	      default: if (i0 > 0) i0 = 0; break;
	    }
	  }
	
	  return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	};
	
	var prefixExponent;
	
	var formatPrefixAuto = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	};
	
	var formatRounded = function(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	};
	
	var formatTypes = {
	  "": formatDefault,
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	// [[fill]align][sign][symbol][0][width][,][.precision][type]
	var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  return new FormatSpecifier(specifier);
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	  var match,
	      fill = match[1] || " ",
	      align = match[2] || ">",
	      sign = match[3] || "-",
	      symbol = match[4] || "",
	      zero = !!match[5],
	      width = match[6] && +match[6],
	      comma = !!match[7],
	      precision = match[8] && +match[8].slice(1),
	      type = match[9] || "";
	
	  // The "n" type is an alias for ",g".
	  if (type === "n") comma = true, type = "g";
	
	  // Map invalid types to the default format.
	  else if (!formatTypes[type]) type = "";
	
	  // If zero fill is specified, padding goes after sign and before digits.
	  if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	  this.fill = fill;
	  this.align = align;
	  this.sign = sign;
	  this.symbol = symbol;
	  this.zero = zero;
	  this.width = width;
	  this.comma = comma;
	  this.precision = precision;
	  this.type = type;
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width == null ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	      + this.type;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	var formatLocale = function(locale) {
	  var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	      currency = locale.currency,
	      decimal = locale.decimal,
	      numerals = locale.numerals ? formatNumerals(locale.numerals) : identity,
	      percent = locale.percent || "%";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        type = specifier.type;
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = !type || /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision == null ? (type ? 6 : 12)
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = formatType(Math.abs(value), precision);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	};
	
	var locale;
	
	
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	var precisionFixed = function(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	};
	
	var precisionPrefix = function(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	};
	
	var precisionRound = function(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	};
	
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(467);
	var foreach = __webpack_require__(2256);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	var toStr = Object.prototype.toString;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
	        /* eslint-disable no-unused-vars, no-restricted-syntax */
	        for (var _ in obj) { return false; }
	        /* eslint-enable no-unused-vars, no-restricted-syntax */
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			Object.defineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = props.concat(Object.getOwnPropertySymbols(map));
		}
		foreach(props, function (name) {
			defineProperty(object, name, map[name], predicates[name]);
		});
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ },
/* 226 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
	        blockKey = _offsetKey$split[0],
	        decoratorKey = _offsetKey$split[1],
	        leafKey = _offsetKey$split[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ },
/* 227 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    if (!areEqualFn(value, nextValue)) {
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventHandled
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Utility method for determining whether or not the value returned
	 * from a handler indicates that it was handled.
	 */
	function isEventHandled(value) {
	  return value === 'handled' || value === true;
	}
	
	module.exports = isEventHandled;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(304);
	
	var _PathUtils = __webpack_require__(187);
	
	var _createTransitionManager = __webpack_require__(437);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 231 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.onCut = onCut;
	exports.onPaste = onPaste;
	exports.onChange = onChange;
	exports.onKeyDown = onKeyDown;
	
	var _edit = __webpack_require__(2270);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _parse3 = __webpack_require__(439);
	
	var _parse4 = _interopRequireDefault(_parse3);
	
	var _format2 = __webpack_require__(952);
	
	var _format3 = _interopRequireDefault(_format2);
	
	var _dom = __webpack_require__(2269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function onCut(event, input, _parse, _format, on_change) {
		// The actual cut hasn't happened just yet hence the timeout.
		setTimeout(function () {
			return format_input_text(input, _parse, _format, undefined, on_change);
		}, 0);
	}
	
	function onPaste(event, input, _parse, _format, on_change) {
		var selection = (0, _dom.getSelection)(input);
	
		// If selection is made,
		// just erase the selected text
		// prior to pasting
		if (selection) {
			erase_selection(input, selection);
		}
	
		format_input_text(input, _parse, _format, undefined, on_change);
	}
	
	function onChange(event, input, _parse, _format, on_change) {
		format_input_text(input, _parse, _format, undefined, on_change);
	}
	
	// Intercepts "Delete" and "Backspace" keys.
	// (hitting "Delete" or "Backspace" at any caret
	//  position should always result in rasing a digit)
	function onKeyDown(event, input, _parse, _format, on_change) {
		var operation = (0, _dom.getOperation)(event);
	
		switch (operation) {
			case 'Delete':
			case 'Backspace':
				// Intercept this operation and perform it manually.
				event.preventDefault();
	
				var selection = (0, _dom.getSelection)(input);
	
				// If selection is made,
				// just erase the selected text,
				// and don't apply any more operations to it.
				if (selection) {
					erase_selection(input, selection);
					return format_input_text(input, _parse, _format, undefined, on_change);
				}
	
				// Else, perform the (character erasing) operation manually
				return format_input_text(input, _parse, _format, operation, on_change);
	
			default:
			// Will be handled when `onChange` fires.
		}
	}
	
	/**
	 * Erases the selected text inside an `<input/>`.
	 * @param  {DOMElement} input
	 * @param  {Selection} selection
	 */
	function erase_selection(input, selection) {
		var text = input.value;
		text = text.slice(0, selection.start) + text.slice(selection.end);
	
		input.value = text;
		(0, _dom.setCaretPosition)(input, selection.start);
	}
	
	/**
	 * Parses and re-formats `<input/>` textual value.
	 * E.g. when a user enters something into the `<input/>`
	 * that raw input must first be parsed and the re-formatted properly.
	 * Is called either after some user input (e.g. entered a character, pasted something)
	 * or after the user performed an `operation` (e.g. "Backspace", "Delete").
	 * @param  {DOMElement} input
	 * @param  {Function} parse
	 * @param  {Function} format
	 * @param  {string} [operation] - The operation that triggered `<input/>` textual value change. E.g. "Backspace", "Delete".
	 * @param  {Function} onChange
	 */
	function format_input_text(input, _parse, _format, operation, on_change) {
		// Parse `<input/>` textual value.
		// Get `value` and `caret` position.
		var _parse2 = (0, _parse4.default)(input.value, (0, _dom.getCaretPosition)(input), _parse),
		    value = _parse2.value,
		    caret = _parse2.caret;
	
		// If a user performed an operation (e.g. "Backspace", "Delete")
		// then apply that operation and get new `value` and `caret` position.
	
	
		if (operation) {
			var operation_applied = (0, _edit2.default)(value, caret, operation);
	
			value = operation_applied.value;
			caret = operation_applied.caret;
		}
	
		// Format the `value`.
		// (and reposition the caret accordingly)
		var formatted = (0, _format3.default)(value, caret, _format);
	
		var text = formatted.text;
		caret = formatted.caret;
	
		// Set `<input/>` textual value manually
		// to prevent React from resetting the caret position
		// later inside subsequent `render()`.
		// Doesn't work for custom `inputComponent`s for some reason.
		input.value = text;
		// Position the caret properly.
		(0, _dom.setCaretPosition)(input, caret);
	
		// `<input/>` textual value may have changed,
		// so the parsed `value` may have changed too.
		// The `value` didn't neccessarily change
		// but it might have.
		on_change(value);
	}
	//# sourceMappingURL=input control.js.map

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 234 */
[3525, 155],
/* 235 */
[3538, 2336, 986, 111],
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(2485);
	var parse = __webpack_require__(2484);
	var formats = __webpack_require__(1145);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2478)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.measureScrollbar = measureScrollbar;
	exports.debounce = debounce;
	exports.warningOnce = warningOnce;
	exports.remove = remove;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var scrollbarWidth = void 0;
	
	// Measure scrollbar width for padding body during modal show/hide
	var scrollbarMeasure = {
	  position: 'absolute',
	  top: '-9999px',
	  width: '50px',
	  height: '50px',
	  overflow: 'scroll'
	};
	
	function measureScrollbar() {
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return 0;
	  }
	  if (scrollbarWidth) {
	    return scrollbarWidth;
	  }
	  var scrollDiv = document.createElement('div');
	  for (var scrollProp in scrollbarMeasure) {
	    if (scrollbarMeasure.hasOwnProperty(scrollProp)) {
	      scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
	    }
	  }
	  document.body.appendChild(scrollDiv);
	  var width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  scrollbarWidth = width;
	  return scrollbarWidth;
	}
	
	function debounce(func, wait, immediate) {
	  var timeout = void 0;
	  function debounceFunc() {
	    var context = this;
	    var args = arguments;
	    // https://fb.me/react-event-pooling
	    if (args[0] && args[0].persist) {
	      args[0].persist();
	    }
	    var later = function later() {
	      timeout = null;
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	    if (callNow) {
	      func.apply(context, args);
	    }
	  }
	  debounceFunc.cancel = function cancel() {
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	  return debounceFunc;
	}
	
	var warned = {};
	function warningOnce(condition, format, args) {
	  if (!warned[format]) {
	    (0, _warning2['default'])(condition, format, args);
	    warned[format] = !condition;
	  }
	}
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  var front = array.slice(0, index);
	  var last = array.slice(index + 1, array.length);
	  return front.concat(last);
	}

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentWithPureRenderMixin
	 */
	
	var shallowEqual = __webpack_require__(2639);
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	
	module.exports = ReactComponentWithPureRenderMixin;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(946);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(175);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  block: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  componentClass: _elementType2.default,
	  href: _propTypes2.default.string,
	  /**
	   * Defines HTML button type attribute
	   * @defaultValue 'button'
	   */
	  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
	};
	
	var defaultProps = {
	  active: false,
	  block: false,
	  disabled: false
	};
	
	var Button = function (_React$Component) {
	  (0, _inherits3.default)(Button, _React$Component);
	
	  function Button() {
	    (0, _classCallCheck3.default)(this, Button);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
	    return _react2.default.createElement(_SafeAnchor2.default, (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, elementProps.disabled && 'disabled')
	    }));
	  };
	
	  Button.prototype.renderButton = function renderButton(_ref, className) {
	    var componentClass = _ref.componentClass,
	        elementProps = (0, _objectWithoutProperties3.default)(_ref, ['componentClass']);
	
	    var Component = componentClass || 'button';
	
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, elementProps, {
	      type: elementProps.type || 'button',
	      className: className
	    }));
	  };
	
	  Button.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        active = _props.active,
	        block = _props.block,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'block', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'block')] = block, _extends2));
	    var fullClassName = (0, _classnames2.default)(className, classes);
	
	    if (elementProps.href) {
	      return this.renderAnchor(elementProps, fullClassName);
	    }
	
	    return this.renderButton(elementProps, fullClassName);
	  };
	
	  return Button;
	}(_react2.default.Component);
	
	Button.propTypes = propTypes;
	Button.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL, _StyleConfig.Size.XSMALL], (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY, _StyleConfig.Style.LINK]), _StyleConfig.Style.DEFAULT, Button)));
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CloseButton = function () {
	  function CloseButton(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        fillRule: 'evenodd',
	        d: 'M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z'
	      })
	    );
	  }
	
	  return CloseButton;
	}();
	
	CloseButton.defaultProps = {
	  viewBox: '0 0 12 12'
	};
	exports['default'] = CloseButton;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAfterDay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isBeforeDay = __webpack_require__(245);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _isSameDay = __webpack_require__(194);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isBeforeDay2['default'])(a, b) && !(0, _isSameDay2['default'])(a, b);
	}

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isBeforeDay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	
	  var aYear = a.year();
	  var aMonth = a.month();
	
	  var bYear = b.year();
	  var bMonth = b.month();
	
	  var isSameYear = aYear === bYear;
	  var isSameMonth = aMonth === bMonth;
	
	  if (isSameYear && isSameMonth) return a.date() < b.date();
	  if (isSameYear) return aMonth < bMonth;
	  return aYear < bYear;
	}

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyAfterDay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isBeforeDay = __webpack_require__(245);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isBeforeDay2['default'])(a, b);
	}

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	exports.fieldsValid = fieldsValid;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValid(formState) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };
	
	  if (!formState) return true;
	
	  if (!formState.$form) {
	    var errors = formState.errors;
	
	
	    if (!Array.isArray(errors) && !(0, _isPlainObject2.default)(errors)) {
	      // If asyncKeys = true and the error is not an
	      // array or object (e.g. string), form errors are entirely async
	      // and should be ignored when async = true.
	      return !options.async && formState.asyncKeys || !errors;
	    }
	
	    return Object.keys(formState.errors).every(function (errorKey) {
	      // if specified to ignore async validator keys and
	      // current error key is an async validator key,
	      // treat key as valid
	      if (!options.async && Array.isArray(formState.asyncKeys) && !!~formState.asyncKeys.indexOf(errorKey)) {
	        return true;
	      }
	
	      var valid = !formState.errors[errorKey];
	
	      return valid;
	    });
	  }
	
	  return Object.keys(formState).every(function (key) {
	    return isValid(formState[key], options);
	  });
	}
	
	function fieldsValid(formState) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };
	
	  return Object.keys(formState).every(function (key) {
	    return key === '$form' || isValid(formState[key], options);
	  });
	}

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createInitialState = createInitialState;
	exports.default = createFormReducer;
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _arraysEqual = __webpack_require__(1264);
	
	var _arraysEqual2 = _interopRequireDefault(_arraysEqual);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _toPath = __webpack_require__(254);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _composeReducers = __webpack_require__(2802);
	
	var _composeReducers2 = _interopRequireDefault(_composeReducers);
	
	var _batchedEnhancer = __webpack_require__(503);
	
	var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);
	
	var _changeActionReducer = __webpack_require__(2801);
	
	var _changeActionReducer2 = _interopRequireDefault(_changeActionReducer);
	
	var _formActionsReducer = __webpack_require__(2800);
	
	var _createField = __webpack_require__(345);
	
	var _createField2 = _interopRequireDefault(_createField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createInitialState(model, state) {
	  var customInitialFieldState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (Array.isArray(state) || (0, _isPlainObject2.default)(state)) {
	    return (0, _createField.createFormState)(model, state, customInitialFieldState, options);
	  }
	
	  return (0, _createField2.default)(model, state, customInitialFieldState, options);
	}
	
	function wrapFormReducer(plugin, modelPath, initialState) {
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    if (!action.model) return state;
	
	    var path = (0, _toPath2.default)(action.model);
	
	    if (modelPath.length && !(0, _arraysEqual2.default)(path.slice(0, modelPath.length), modelPath)) {
	      return state;
	    }
	
	    var localPath = path.slice(modelPath.length);
	
	    return plugin(state, action, localPath);
	  };
	}
	
	function createFormReducer(model) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var _options$plugins = options.plugins,
	      plugins = _options$plugins === undefined ? [] : _options$plugins,
	      customInitialFieldState = options.initialFieldState,
	      _options$transformAct = options.transformAction,
	      transformAction = _options$transformAct === undefined ? null : _options$transformAct;
	
	  var modelPath = (0, _toPath2.default)(model);
	  var initialFormState = createInitialState(model, initialState, customInitialFieldState, options);
	
	  var defaultPlugins = [_changeActionReducer2.default, (0, _formActionsReducer.createFormActionsReducer)({ initialFieldState: customInitialFieldState })];
	
	  var wrappedPlugins = plugins.concat(defaultPlugins).map(function (plugin) {
	    return wrapFormReducer(plugin, modelPath, initialFormState);
	  });
	
	  return (0, _batchedEnhancer2.default)(_composeReducers2.default.apply(undefined, _toConsumableArray(wrappedPlugins)), undefined, {
	    transformAction: transformAction
	  });
	}

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assoc = assoc;
	exports.default = assocIn;
	
	var _identity = __webpack_require__(199);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function objClone(obj) {
	  var keys = Object.keys(obj);
	  var length = keys.length;
	  var result = {};
	  var index = 0;
	  var key = void 0;
	
	  for (; index < length; index += 1) {
	    key = keys[index];
	    result[key] = obj[key];
	  }
	  return result;
	}
	
	function assoc(state, key, value) {
	  var newState = objClone(state);
	
	  newState[key] = value;
	
	  return newState;
	}
	
	function assocIn(state, path, value) {
	  var fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _identity2.default;
	
	  if (!path.length) return value;
	
	  var key0 = path[0];
	
	  if (path.length === 1) {
	    return fn(assoc(state, key0, value));
	  }
	
	  return fn(assoc(state, key0, assocIn(state[key0] || {}, path.slice(1), value, fn)));
	}

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFieldFromState;
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _toPath = __webpack_require__(254);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _getForm = __webpack_require__(251);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategy = {
	  getForm: _getForm2.default
	};
	
	function getFieldFromState(state, modelString) {
	  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	
	  var form = state && '$form' in state ? state : s.getForm(state, modelString);
	
	  if (!form || !form.$form) return null;
	
	  if (!modelString.length) return form;
	
	  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', modelString);
	
	  var formPath = (0, _toPath2.default)(form.$form.model);
	  var fieldPath = (0, _toPath2.default)(modelString).slice(formPath.length);
	  var field = (0, _get2.default)(form, fieldPath);
	
	  if (!field) return null;
	  if ((0, _isPlainObject2.default)(field) && '$form' in field) return field.$form;
	
	  return field;
	}

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearGetFormCache = undefined;
	exports.getFormStateKey = getFormStateKey;
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _pathStartsWith = __webpack_require__(2814);
	
	var _pathStartsWith2 = _interopRequireDefault(_pathStartsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategy = {
	  get: _get2.default,
	  keys: function keys(state) {
	    return Object.keys(state);
	  },
	  isObject: function isObject(state) {
	    return (0, _isPlainObject2.default)(state);
	  }
	};
	
	function joinPaths() {
	  for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
	    paths[_key] = arguments[_key];
	  }
	
	  return paths.filter(function (path) {
	    return !!path && path.length;
	  }).join('.');
	}
	
	function getFormStateKey(state, model) {
	  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	  var currentPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
	
	  var deepCandidateKeys = [];
	  var result = null;
	
	  s.keys(state).some(function (key) {
	    var subState = s.get(state, key);
	
	    if (subState && s.get(subState, '$form')) {
	      var subStateModel = s.get(subState, '$form.model');
	
	      if ((0, _pathStartsWith2.default)(model, subStateModel) || subStateModel === '') {
	        var localPath = (0, _pathStartsWith.pathDifference)(model, subStateModel);
	
	        var resultPath = [currentPath, key];
	        var currentState = subState;
	
	        localPath.every(function (segment) {
	          if (s.get(currentState, segment) && s.get(currentState, segment + '.$form')) {
	            currentState = s.get(currentState, segment);
	            resultPath.push(segment);
	
	            return true;
	          }
	
	          return false;
	        });
	
	        result = joinPaths.apply(undefined, resultPath);
	
	        return true;
	      }
	
	      return false;
	    }
	
	    if (s.isObject(subState)) {
	      deepCandidateKeys.push(key);
	    }
	
	    return false;
	  });
	
	  if (result) return result;
	
	  deepCandidateKeys.some(function (key) {
	    result = getFormStateKey(s.get(state, key), model, s, joinPaths(currentPath, key));
	
	    return !!result;
	  });
	
	  if (result) return result;
	
	  return null;
	}
	
	var formStateKeyCache = {};
	
	var clearGetFormCache = exports.clearGetFormCache = function clearGetFormCache() {
	  return formStateKeyCache = {};
	}; // eslint-disable-line no-return-assign
	
	var getFormStateKeyCached = function () {
	  return function (state, modelString) {
	    var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	
	    if (formStateKeyCache[modelString]) return formStateKeyCache[modelString];
	
	    var result = getFormStateKey(state, modelString, s);
	
	    formStateKeyCache[modelString] = result; // eslint-disable-line no-return-assign
	
	    return result;
	  };
	}();
	
	function getForm(state, modelString) {
	  var s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultStrategy;
	
	  var formStateKey = getFormStateKeyCached(state, modelString, s);
	
	  if (!formStateKey) {
	    return null;
	  }
	
	  var form = s.get(state, formStateKey);
	
	  return form;
	}
	
	exports.default = getForm;

/***/ },
/* 252 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getModel;
	function getModel(model, state) {
	  return typeof model === 'function' && state ? model(state) : model;
	}

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getValue;
	exports.getCheckboxValue = getCheckboxValue;
	
	var _isMulti = __webpack_require__(346);
	
	var _isMulti2 = _interopRequireDefault(_isMulti);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function isEvent(event) {
	  return !!(event && event.stopPropagation && event.preventDefault);
	}
	
	function getEventValue(event) {
	  var target = event.target;
	
	
	  if (!target) {
	    if (!event.nativeEvent) {
	      return undefined;
	    }
	
	    return event.nativeEvent.text;
	  }
	
	  if (target.type === 'file') {
	    return [].concat(_toConsumableArray(target.files)) || target.dataTransfer && [].concat(_toConsumableArray(target.dataTransfer.files));
	  }
	
	  if (target.multiple) {
	    return [].concat(_toConsumableArray(target.selectedOptions)).map(function (option) {
	      return option.value;
	    });
	  }
	
	  return target.value;
	}
	
	function getValue(value) {
	  return isEvent(value) ? getEventValue(value) : value;
	}
	
	function getCheckboxValue(_, props) {
	  var controlProps = props.controlProps;
	
	
	  if ((0, _isMulti2.default)(props.model)) {
	    return controlProps.value;
	  }
	
	  return !props.modelValue;
	}

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toPath;
	
	var _lodash = __webpack_require__(975);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _endsWith = __webpack_require__(506);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toPath(value) {
	  var path = value;
	
	  if ((0, _endsWith2.default)(path, '.')) {
	    path = path.slice(0, -1);
	  } else if ((0, _endsWith2.default)(path, '[]')) {
	    path = path.slice(0, -2);
	  }
	
	  return (0, _lodash2.default)(path);
	}

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trackable = exports.createTrack = undefined;
	
	var _findKey2 = __webpack_require__(2805);
	
	var _findKey3 = _interopRequireDefault(_findKey2);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _iteratee = __webpack_require__(510);
	
	var _isMulti = __webpack_require__(346);
	
	var _isMulti2 = _interopRequireDefault(_isMulti);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	var defaultStrategy = {
	  findKey: _findKey3.default,
	  get: _get3.default
	};
	
	function createTrack() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  var iteratee = (0, _iteratee.createIteratee)(s);
	
	  return function track(model) {
	    for (var _len = arguments.length, predicates = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      predicates[_key - 1] = arguments[_key];
	    }
	
	    var isPartial = model[0] === '.';
	
	    return function (fullState, parentModel) {
	      var childModel = isPartial ? model.slice(1) : model;
	      var state = isPartial ? s.get(fullState, parentModel) : fullState;
	
	      var _childModel$split = childModel.split(/\[\]\.?/),
	          _childModel$split2 = _toArray(_childModel$split),
	          parentModelPath = _childModel$split2[0],
	          childModelPaths = _childModel$split2.slice(1);
	
	      var fullPath = parentModelPath;
	      var subState = s.get(state, fullPath);
	
	      predicates.forEach(function (predicate, i) {
	        var childModelPath = childModelPaths[i];
	        var predicateIteratee = iteratee(predicate);
	
	        var subPath = childModelPath ? s.findKey(subState, predicateIteratee) + '.' + childModelPath : '' + s.findKey(subState, predicateIteratee);
	
	        subState = s.get(subState, subPath);
	        fullPath += '.' + subPath;
	      });
	
	      if ((0, _isMulti2.default)(childModel) && predicates.length < childModelPaths.length) {
	        fullPath += '[]';
	      }
	
	      return isPartial ? parentModel + '.' + fullPath : fullPath;
	    };
	  };
	}
	
	var track = createTrack();
	
	function trackable(actionCreator) {
	  return function (model) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    if (typeof model === 'function') {
	      return function (dispatch, getState) {
	        var modelPath = model(getState());
	
	        dispatch(actionCreator.apply(undefined, [modelPath].concat(args)));
	      };
	    }
	
	    return actionCreator.apply(undefined, [model].concat(args));
	  };
	}
	
	exports.default = track;
	exports.createTrack = createTrack;
	exports.trackable = trackable;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PaymentRequestButtonElement = exports.PostalCodeElement = exports.CardCVCElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;
	
	var _Provider = __webpack_require__(518);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _inject = __webpack_require__(2879);
	
	var _inject2 = _interopRequireDefault(_inject);
	
	var _Elements = __webpack_require__(352);
	
	var _Elements2 = _interopRequireDefault(_Elements);
	
	var _Element = __webpack_require__(2877);
	
	var _Element2 = _interopRequireDefault(_Element);
	
	var _PaymentRequestButtonElement = __webpack_require__(2878);
	
	var _PaymentRequestButtonElement2 = _interopRequireDefault(_PaymentRequestButtonElement);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CardElement = (0, _Element2.default)('card', { sourceType: 'card' });
	
	var CardNumberElement = (0, _Element2.default)('cardNumber', { sourceType: 'card' });
	var CardExpiryElement = (0, _Element2.default)('cardExpiry');
	var CardCVCElement = (0, _Element2.default)('cardCvc');
	var PostalCodeElement = (0, _Element2.default)('postalCode');
	
	exports.StripeProvider = _Provider2.default;
	exports.injectStripe = _inject2.default;
	exports.Elements = _Elements2.default;
	exports.CardElement = CardElement;
	exports.CardNumberElement = CardNumberElement;
	exports.CardExpiryElement = CardExpiryElement;
	exports.CardCVCElement = CardCVCElement;
	exports.PostalCodeElement = PostalCodeElement;
	exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Render a group of error bar
	                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ErrorBar = (_temp = _class = function (_Component) {
	  _inherits(ErrorBar, _Component);
	
	  function ErrorBar() {
	    _classCallCheck(this, ErrorBar);
	
	    return _possibleConstructorReturn(this, (ErrorBar.__proto__ || Object.getPrototypeOf(ErrorBar)).apply(this, arguments));
	  }
	
	  _createClass(ErrorBar, [{
	    key: 'renderErrorBars',
	    value: function renderErrorBars() {
	      var _props = this.props,
	          offset = _props.offset,
	          layout = _props.layout,
	          width = _props.width,
	          dataKey = _props.dataKey,
	          data = _props.data,
	          dataPointFormatter = _props.dataPointFormatter,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis,
	          others = _objectWithoutProperties(_props, ['offset', 'layout', 'width', 'dataKey', 'data', 'dataPointFormatter', 'xAxis', 'yAxis']);
	
	      var props = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return data.map(function (entry, i) {
	        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
	            x = _dataPointFormatter.x,
	            y = _dataPointFormatter.y,
	            value = _dataPointFormatter.value,
	            errorVal = _dataPointFormatter.errorVal;
	
	        if (!errorVal) {
	          return null;
	        }
	
	        var xMid = void 0,
	            yMid = void 0,
	            xMin = void 0,
	            yMin = void 0,
	            xMax = void 0,
	            yMax = void 0,
	            scale = void 0,
	            coordsTop = void 0,
	            coordsMid = void 0,
	            coordsBot = void 0,
	            lowBound = void 0,
	            highBound = void 0;
	
	        if (Array.isArray(errorVal)) {
	          lowBound = errorVal[0];
	          highBound = errorVal[1];
	        } else {
	          lowBound = errorVal;
	          highBound = errorVal;
	        }
	
	        if (layout === 'vertical') {
	          scale = xAxis.scale;
	          xMid = value;
	          yMid = y + offset;
	          xMin = scale(xMid - lowBound);
	          yMin = yMid + width;
	          xMax = scale(xMid + highBound);
	          yMax = yMid - width;
	          coordsTop = { x1: xMax, y1: yMin, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMin, y1: yMid, x2: xMax, y2: yMid };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMin, y2: yMax };
	        } else if (layout === 'horizontal') {
	          scale = yAxis.scale;
	          xMid = x + offset;
	          yMid = value;
	          xMin = xMid - width;
	          xMax = xMid + width;
	          yMin = scale(yMid - lowBound);
	          yMax = scale(yMid + highBound);
	          coordsTop = { x1: xMin, y1: yMax, x2: xMax, y2: yMax };
	          coordsMid = { x1: xMid, y1: yMin, x2: xMid, y2: yMax };
	          coordsBot = { x1: xMin, y1: yMin, x2: xMax, y2: yMin };
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({ className: 'recharts-errorBar', key: 'bar-' + i }, props),
	          _react2.default.createElement('line', coordsTop),
	          _react2.default.createElement('line', coordsMid),
	          _react2.default.createElement('line', coordsBot)
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-errorBars' },
	        this.renderErrorBars()
	      );
	    }
	  }]);
	
	  return ErrorBar;
	}(_react.Component), _class.propTypes = {
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  data: _propTypes2.default.array,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  layout: _propTypes2.default.string,
	  dataPointFormatter: _propTypes2.default.func,
	  stroke: _propTypes2.default.string,
	  strokeWidth: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  offset: _propTypes2.default.number
	}, _class.defaultProps = {
	  stroke: 'black',
	  strokeWidth: 1.5,
	  width: 5,
	  offset: 0,
	  layout: 'horizontal'
	}, _temp);
	exports.default = ErrorBar;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Cross
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Cell() {
	  return null;
	}
	
	Cell.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES);
	Cell.displayName = 'Cell';
	
	exports.default = Cell;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * @fileOverview Surface
	                                                                                                                                                                                                                              */
	
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	function Surface(props) {
	  var children = props.children,
	      width = props.width,
	      height = props.height,
	      viewBox = props.viewBox,
	      className = props.className,
	      style = props.style,
	      others = _objectWithoutProperties(props, ['children', 'width', 'height', 'viewBox', 'className', 'style']);
	
	  var svgView = viewBox || { width: width, height: height, x: 0, y: 0 };
	  var layerClass = (0, _classnames2.default)('recharts-surface', className);
	  var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	  return _react2.default.createElement(
	    'svg',
	    _extends({}, attrs, {
	      className: layerClass,
	      width: width,
	      height: height,
	      style: style,
	      viewBox: svgView.x + ' ' + svgView.y + ' ' + svgView.width + ' ' + svgView.height,
	      version: '1.1'
	    }),
	    children
	  );
	}
	
	Surface.propTypes = propTypes;
	
	exports.default = Surface;

/***/ },
/* 260 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + '.' + name : name;
	};
	exports.default = formatName;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 262 */
[3525, 372],
/* 263 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 264 */
[3529, 553, 554],
/* 265 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var KEY_PREFIX = exports.KEY_PREFIX = 'reduxPersist:';
	var REHYDRATE = exports.REHYDRATE = 'persist/REHYDRATE';

/***/ },
/* 266 */
265,
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createUncontrollable = __webpack_require__(3295);
	
	var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mixin = {
	  shouldComponentUpdate: function shouldComponentUpdate() {
	    //let the forceUpdate trigger the update
	    return !this._notifying;
	  }
	};
	
	function set(component, propName, handler, value, args) {
	  if (handler) {
	    component._notifying = true;
	    handler.call.apply(handler, [component, value].concat(args));
	    component._notifying = false;
	  }
	
	  component._values[propName] = value;
	
	  if (!component.unmounted) component.forceUpdate();
	}
	
	exports.default = (0, _createUncontrollable2.default)(mixin, set);
	module.exports = exports['default'];

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* xlsx.js (C) 2013-2015 SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint -W041 */
	/*jshint funcscope:true, eqnull:true */
	var XLSX = {};
	(function make_xlsx(XLSX){
	XLSX.version = '0.8.20';
	var current_codepage = 1200, current_cptable;
	if(true) {
		if(typeof cptable === 'undefined') cptable = __webpack_require__(3327);
		current_cptable = cptable[current_codepage];
	}
	function reset_cp() { set_cp(1200); }
	var set_cp = function(cp) { current_codepage = cp; };
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	var debom_xml = function(data) { return data; };
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	if(typeof cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; current_cptable = cptable[cp]; };
		debom_xml = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.substr(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
	}
	var Base64 = (function make_b64(){
		var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
		return {
			encode: function(input, utf8) {
				var o = "";
				var c1, c2, c3, e1, e2, e3, e4;
				for(var i = 0; i < input.length; ) {
					c1 = input.charCodeAt(i++);
					c2 = input.charCodeAt(i++);
					c3 = input.charCodeAt(i++);
					e1 = c1 >> 2;
					e2 = (c1 & 3) << 4 | c2 >> 4;
					e3 = (c2 & 15) << 2 | c3 >> 6;
					e4 = c3 & 63;
					if (isNaN(c2)) { e3 = e4 = 64; }
					else if (isNaN(c3)) { e4 = 64; }
					o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
				}
				return o;
			},
			decode: function b64_decode(input, utf8) {
				var o = "";
				var c1, c2, c3;
				var e1, e2, e3, e4;
				input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
				for(var i = 0; i < input.length;) {
					e1 = map.indexOf(input.charAt(i++));
					e2 = map.indexOf(input.charAt(i++));
					e3 = map.indexOf(input.charAt(i++));
					e4 = map.indexOf(input.charAt(i++));
					c1 = e1 << 2 | e2 >> 4;
					c2 = (e2 & 15) << 4 | e3 >> 2;
					c3 = (e3 & 3) << 6 | e4;
					o += String.fromCharCode(c1);
					if (e3 != 64) { o += String.fromCharCode(c2); }
					if (e4 != 64) { o += String.fromCharCode(c3); }
				}
				return o;
			}
		};
	})();
	var has_buf = (typeof Buffer !== 'undefined');
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		return new (has_buf ? Buffer : Array)(len);
		/* jshint +W056 */
	}
	
	function s2a(s) {
		if(has_buf) return new Buffer(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	}
	
	var bconcat = function(bufs) { return [].concat.apply([], bufs); };
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/;
	/* ssf.js (C) 2013-2014 SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	var SSF = {};
	var make_ssf = function make_ssf(SSF){
	SSF.version = '0.8.1';
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	function isgeneral(s, i) { return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	/* Options */
	var opts_fmt = [
		["date1904", 0],
		["output", ""],
		["WTF", false]
	];
	function fixopts(o){
		for(var y = 0; y != opts_fmt.length; ++y) if(o[opts_fmt[y][0]]===undefined) o[opts_fmt[y][0]]=opts_fmt[y][1];
	}
	SSF.opts = opts_fmt;
	var table_fmt = {
		0:  'General',
		1:  '0',
		2:  '0.00',
		3:  '#,##0',
		4:  '#,##0.00',
		9:  '0%',
		10: '0.00%',
		11: '0.00E+00',
		12: '# ?/?',
		13: '# ??/??',
		14: 'm/d/yy',
		15: 'd-mmm-yy',
		16: 'd-mmm',
		17: 'mmm-yy',
		18: 'h:mm AM/PM',
		19: 'h:mm:ss AM/PM',
		20: 'h:mm',
		21: 'h:mm:ss',
		22: 'm/d/yy h:mm',
		37: '#,##0 ;(#,##0)',
		38: '#,##0 ;[Red](#,##0)',
		39: '#,##0.00;(#,##0.00)',
		40: '#,##0.00;[Red](#,##0.00)',
		45: 'mm:ss',
		46: '[h]:mm:ss',
		47: 'mmss.0',
		48: '##0.0E+0',
		49: '@',
		56: '"上午/下午 "hh"時"mm"分"ss"秒 "',
		65535: 'General'
	};
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.0000000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { Q = Q_1; P = P_1; }
		if(Q > D) { Q = Q_2; P = P_2; }
		if(!mixed) return [0, sgn * P, Q];
		if(Q===0) throw "Unexpected state: "+P+" "+P_1+" "+P_2+" "+Q+" "+Q_1+" "+Q_2;
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function general_fmt_int(v, opts) { return ""+v; }
	SSF._general_int = general_fmt_int;
	var general_fmt_num = (function make_general_fmt_num() {
	var gnr1 = /\.(\d*[1-9])0+$/, gnr2 = /\.0*$/, gnr4 = /\.(\d*[1-9])0+/, gnr5 = /\.0*[Ee]/, gnr6 = /(E[+-])(\d)$/;
	function gfn2(v) {
		var w = (v<0?12:11);
		var o = gfn5(v.toFixed(12)); if(o.length <= w) return o;
		o = v.toPrecision(10); if(o.length <= w) return o;
		return v.toExponential(5);
	}
	function gfn3(v) {
		var o = v.toFixed(11).replace(gnr1,".$1");
		if(o.length > (v<0?12:11)) o = v.toPrecision(6);
		return o;
	}
	function gfn4(o) {
		for(var i = 0; i != o.length; ++i) if((o.charCodeAt(i) | 0x20) === 101) return o.replace(gnr4,".$1").replace(gnr5,"E").replace("e","E").replace(gnr6,"$10$2");
		return o;
	}
	function gfn5(o) {
		//for(var i = 0; i != o.length; ++i) if(o.charCodeAt(i) === 46) return o.replace(gnr2,"").replace(gnr1,".$1");
		//return o;
		return o.indexOf(".") > -1 ? o.replace(gnr2,"").replace(gnr1,".$1") : o;
	}
	return function general_fmt_num(v, opts) {
		var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
		if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
		else if(Math.abs(V) <= 9) o = gfn2(v);
		else if(V === 10) o = v.toFixed(10).substr(0,12);
		else o = gfn3(v);
		return gfn5(gfn4(o));
	};})();
	SSF._general_num = general_fmt_num;
	function general_fmt(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? general_fmt_int(v, opts) : general_fmt_num(v, opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	SSF._general = general_fmt;
	function fix_hijri(date, o) { return 0; }
	function parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		fixopts(opts != null ? opts : (opts=[]));
		if(opts.date1904) date += 1462;
		if(out.u > 0.999) {
			out.u = 0;
			if(++time == 86400) { time = 0; ++date; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 */
			var d = new Date(1900,0,1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	SSF.parse_date_code = parse_date_code;
	/*jshint -W086 */
	function write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
			if(val.u === 0) switch(fmt) {
				case 's': case 'ss': return pad0(val.S, fmt.length);
				case '.0': case '.00': case '.000':
			}
			switch(fmt) {
				case 's': case 'ss': case '.0': case '.00': case '.000':
					if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
					else tt = ss0 === 1 ? 10 : 1;
					ss = Math.round((tt)*(val.S + val.u));
					if(ss >= 60*tt) ss = 0;
					if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
					o = pad0(ss,2 + ss0);
					if(fmt === 'ss') return o.substr(0,2);
					return "." + o.substr(2,fmt.length-1);
				default: throw 'bad second format: ' + fmt;
			}
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1;
		}
		if(outl > 0) return pad0(out, outl); else return "";
	}
	/*jshint +W086 */
	function commaify(s) {
		if(s.length <= 3) return s;
		var j = (s.length % 3), o = s.substr(0,j);
		for(; j!=s.length; j+=3) o+=(o.length > 0 ? "," : "") + s.substr(j,3);
		return o;
	}
	var write_num = (function make_write_num(){
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o[0] + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o[o.length-1];
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4]), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.(0+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) { return Math.round((val-Math.floor(val))*Math.pow(10,d)); }
	function flr(val) { if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0)); return ""+Math.floor(val); }
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt[1]==' '?2:1),val);
		var o, oo;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1)) !== null) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/) !== null) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1)) !== null) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+r[1]).replace(/\.$/,"."+r[1]).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", r[1].length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/)) !== null) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#,##0(\.?)$/)) !== null) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/)) !== null) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o[ri++]:x==='0'?'0':"";}));
		}
		if(fmt.match(phone) !== null) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa[oa.length-1] == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/)) !== null) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
	  if((r = fmt.match(/^([#0?]+)\.([#0]+)$/)) !== null) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(Math.abs(val))*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o[0] + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o[o.length-1];
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt[1]==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1)) !== null) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/) !== null) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1)) !== null) {
			o = (""+val).replace(/^([^\.]+)$/,"$1."+r[1]).replace(/\.$/,"."+r[1]).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", r[1].length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/)) !== null) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#,##0(\.?)$/)) !== null) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/)) !== null) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/)) !== null) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) !== null) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o[ri++]:x==='0'?'0':"";}));
		}
		if(fmt.match(phone) !== null) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa[oa.length-1] == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) !== null) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/)) !== null) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/)) !== null) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/)) !== null) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	return function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	};})();
	function split_fmt(fmt) {
		var out = [];
		var in_str = false, cc;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((cc=fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	SSF._split = split_fmt;
	var abstime = /\[[HhMmSs]*\]/;
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', q, dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt[i])) {
				case 'G': /* General */
					if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt[++i], t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt[i+1] === "1" || fmt[i+1] === "2") {
	          if(dt==null) { dt=parse_date_code(v, opts, fmt[i+1] === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i<fmt.length && fmt[i].toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M'; /* m = minute */
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A':
					q={t:c, v:"A"};
					if(dt==null) dt=parse_date_code(v, opts);
	        if(fmt.substr(i, 3) === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
	        else if(fmt.substr(i,5) === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt[i++] !== ']' && i < fmt.length) o += fmt[i];
					if(o.substr(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(abstime)) {
						if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
					} else { o=""; }
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while((c=fmt[++i]) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while("0#?.,E+-%".indexOf(c=fmt[++i]) > -1 || c=='\\' && fmt[i+1] == "-" && "0#".indexOf(fmt[i+2])>-1) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt[++i] === c) o+=c;
					q={t:c, v:o}; out[out.length] = q; lst = c; break;
				case '*': ++i; if(fmt[i] == ' ' || fmt[i] == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while("0123456789".indexOf(fmt[++i]) > -1) o+=fmt[i];
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxz".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': if(out[i].v === "B2");
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		switch(bt) {
			case 0: break;
			case 1:
				if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
				if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i] = undefined; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
					out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '(': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						(c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/') ||
						out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') ||
						c === 't' && (out[jj].v === '/' || '$€'.indexOf(out[jj].v) > -1 || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?')
					)) {
						out[i].v += out[jj].v;
						out[jj] = undefined; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v); /* '-' */
			ostr = write_num(nstr.charCodeAt(0) === 40 ? '(' : 'n', nstr, myv); /* '(' */
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v[j] === "0" || out[i].v[j] === "#")) vv = ostr[jj--] + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt ) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr[jj++];
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n(?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	SSF._eval = eval_fmt;
	var cfregex = /\[[=<>]/;
	var cfregex2 = /\[([=<>]*)(-?\d+\.?\d*)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw "cannot find right format for |" + fmt + "|";
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function format(fmt,v,o) {
		fixopts(o != null ? o : (o=[]));
		var sfmt = "";
		switch(typeof fmt) {
			case "string": sfmt = fmt; break;
			case "number": sfmt = (o.table != null ? o.table : table_fmt)[fmt]; break;
		}
		if(isgeneral(sfmt,0)) return general_fmt(v, o);
		var f = choose_fmt(sfmt, v);
		if(isgeneral(f[1])) return general_fmt(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	SSF._table = table_fmt;
	SSF.load = function load_entry(fmt, idx) { table_fmt[idx] = fmt; };
	SSF.format = format;
	SSF.get_table = function get_table() { return table_fmt; };
	SSF.load_table = function load_table(tbl) { for(var i=0; i!=0x0188; ++i) if(tbl[i] !== undefined) SSF.load(tbl[i], i); };
	};
	make_ssf(SSF);
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap = {
		"General Number": "General",
		"General Date": SSF._table[22],
		"Long Date": "dddd, mmmm dd, yyyy",
		"Medium Date": SSF._table[15],
		"Short Date": SSF._table[14],
		"Long Time": SSF._table[19],
		"Medium Time": SSF._table[18],
		"Short Time": SSF._table[20],
		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"Fixed": SSF._table[2],
		"Standard": SSF._table[4],
		"Percent": SSF._table[10],
		"Scientific": SSF._table[11],
		"Yes/No": '"Yes";"Yes";"No";@',
		"True/False": '"True";"True";"False";@',
		"On/Off": '"Yes";"Yes";"No";@'
	};
	
	var DO_NOT_EXPORT_CFB = true;
	/* cfb.js (C) 2013-2014 SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	
	/* [MS-CFB] v20130118 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '0.10.2';
	function parse(file) {
	var mver = 3; // major version
	var ssz = 512; // sector size
	var nmfs = 0; // number of mini FAT sectors
	var ndfs = 0; // number of DIFAT sectors
	var dir_start = 0; // first directory sector location
	var minifat_start = 0; // first mini FAT sector location
	var difat_start = 0; // first mini FAT sector location
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		default: throw "Major Version: Expected 3 or 4 saw " + mver;
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var nds = blob.read_shift(4, 'i');
	if(mver === 3 && nds !== 0) throw '# Directory Sectors: Expected 0 saw ' + nds;
	
	// Number of FAT Sectors
	//var nfs = blob.read_shift(4, 'i');
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	ndfs = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, ndfs, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [], FullPathDir = {};
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex);
	
	build_full_paths(FileIndex, FullPathDir, FullPaths, Paths);
	
	var root_name = Paths.shift();
	Paths.root = root_name;
	
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	var find_path = make_find_path(FullPaths, Paths, FileIndex, files, root_name);
	
	return {
		raw: {header: header, sectors: sectors},
		FileIndex: FileIndex,
		FullPaths: FullPaths,
		FullPathDir: FullPathDir,
		find: find_path
	};
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		blob.chk(HEADER_CLSID, 'CLSID: ');
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		blob.chk('feff', 'Byte Order: ');
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver !== 3) throw 'MajorVersion/SectorShift Mismatch'; break;
			case 0x0c: if(mver !== 4) throw 'MajorVersion/SectorShift Mismatch'; break;
			default: throw 'Sector Shift: Expected 9 or 12 saw ' + shift;
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = new Array(nsectors);
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FPD, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = new Array(pl), q = new Array(pl);
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1) { dad[L] = dad[i]; q.push(L); }
			if(R !== -1) { dad[R] = dad[i]; q.push(R); }
		}
		for(i=1; i !== pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = dad[i];
			if(j === 0) FP[i] = FP[0] + "/" + FP[i];
			else while(j !== 0) {
				FP[i] = FP[j] + "/" + FP[i];
				j = dad[j];
			}
			dad[i] = 0;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
			FPD[FP[i]] = FI[i];
		}
	}
	
	/* [MS-CFB] 2.6.4 */
	function make_find_path(FullPaths, Paths, FileIndex, files, root_name) {
		var UCFullPaths = new Array(FullPaths.length);
		var UCPaths = new Array(Paths.length), i;
		for(i = 0; i < FullPaths.length; ++i) UCFullPaths[i] = FullPaths[i].toUpperCase().replace(chr0,'').replace(chr1,'!');
		for(i = 0; i < Paths.length; ++i) UCPaths[i] = Paths[i].toUpperCase().replace(chr0,'').replace(chr1,'!');
		return function find_path(path) {
			var k;
			if(path.charCodeAt(0) === 47 /* "/" */) { k=true; path = root_name + path; }
			else k = path.indexOf("/") !== -1;
			var UCPath = path.toUpperCase().replace(chr0,'').replace(chr1,'!');
			var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
			if(w === -1) return null;
			return k === true ? FileIndex[w] : files[Paths[w]];
		};
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bytes */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw "DIFAT chain shorter than expected";
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var sl = sectors.length;
		var buf, buf_chain;
		if(!chkd) chkd = new Array(sl);
		var modulus = ssz - 1, j, jj;
		buf = [];
		buf_chain = [];
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw "FAT boundary crossed: " + j + " 4 "+ssz;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = new Array(sl);
		var chkd = new Array(sl), buf, buf_chain;
		var modulus = ssz - 1, i, j, k, jj;
		for(i=0; i < sl; ++i) {
			buf = [];
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k] === true) continue;
			buf_chain = [];
			for(j=k; j>=0;) {
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw "FAT boundary crossed: " + j + " 4 "+ssz;
				j = __readInt32LE(sectors[addr], jj);
			}
			sector_list[k] = {nodes: buf, data:__toBuffer([buf_chain])};
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex) {
		var blob;
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name, o, ctime, mtime;
		for(; i < sector.length; i+= 128) {
			blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			if(namelen === 0) continue;
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			o = {
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i')
			};
			ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) {
				o.ctime = ctime; o.ct = read_date(blob, blob.l-8);
			}
			mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) {
				o.mtime = mtime; o.mt = read_date(blob, blob.l-8);
			}
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = sector_list[o.start].data.slice(0,o.size);
				prep_blob(o.content, 0);
			} else {
				o.storage = 'minifat';
				if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN) {
					o.content = sector_list[minifat_store].data.slice(o.start*MSSZ,o.start*MSSZ+o.size);
					prep_blob(o.content, 0);
				}
			}
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	var fs;
	function readFileSync(filename, options) {
		if(fs === undefined) fs = __webpack_require__(466);
		return parse(fs.readFileSync(filename), options);
	}
	
	function readSync(blob, options) {
		switch(options !== undefined && options.type !== undefined ? options.type : "base64") {
			case "file": return readFileSync(blob, options);
			case "base64": return parse(s2a(Base64.decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob);
	}
	
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	exports.read = readSync;
	exports.parse = parse;
	exports.utils = {
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		consts: consts
	};
	
	return exports;
	})();
	
	if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
	function isval(x) { return x !== undefined && x !== null; }
	
	function keys(o) { return Object.keys(o); }
	
	function evert_key(obj, key) {
		var o = [], K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = [], K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = [], K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = [], K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	/* TODO: date1904 logic */
	function datenum(v, date1904) {
		if(date1904) v+=1462;
		var epoch = Date.parse(v);
		return (epoch + 2209161600000) / (24 * 60 * 60 * 1000);
	}
	
	function cc2str(arr) {
		var o = "";
		for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
		return o;
	}
	
	function getdata(data) {
		if(!data) return null;
		if(data.name.substr(-4) === ".bin") {
			if(data.data) return char_codes(data.data);
			if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
			if(data._data && data._data.getContent) return Array.prototype.slice.call(data._data.getContent());
		} else {
			if(data.data) return data.name.substr(-4) !== ".bin" ? debom_xml(data.data) : char_codes(data.data);
			if(data.asNodeBuffer && has_buf) return debom_xml(data.asNodeBuffer().toString('binary'));
			if(data.asBinary) return debom_xml(data.asBinary());
			if(data._data && data._data.getContent) return debom_xml(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		}
		return null;
	}
	
	function safegetzipfile(zip, file) {
		var f = file; if(zip.files[f]) return zip.files[f];
	
		var lowerCaseFiles = {};
		for (var key in zip.files) {
			lowerCaseFiles[key.toLowerCase()] = zip.files[key];
		}
	
		f = file.toLowerCase(); if(lowerCaseFiles[f]) return lowerCaseFiles[f];
		f = f.replace(/\//g,'\\'); if(lowerCaseFiles[f]) return lowerCaseFiles[f];
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	var _fs, jszip;
	if(typeof JSZip !== 'undefined') jszip = JSZip;
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			if(has_buf && typeof jszip === 'undefined') jszip = __webpack_require__(965);
			if(typeof jszip === 'undefined') jszip = __webpack_require__(1419).JSZip;
			_fs = __webpack_require__(466);
		}
	}
	var attregexg=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var tagregex=/<[^>]*>/g;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root) {
		var z = [];
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.substr(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, w="", v="", i=0, q="", cc="";
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.substr(0,c); v = cc.substring(c+2, cc.length-1);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) z[q] = v;
			else z[(j===5 && q.substr(0,5)==="xmlns"?"xmlns":"")+q.substr(j+1)] = v;
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		var encregex = /&[a-z]*;/g, coderegex = /_x([\da-fA-F]+)_/g;
		return function unescapexml(text){
			var s = text + '';
			return s.replace(encregex, function($$) { return encodings[$$]; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).substr(-4) + "_";});
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	
	function parsexmlbool(value, tag) {
		switch(value) {
			case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	var utf8read = function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { out += String.fromCharCode(((c & 31) << 6) | (d & 63)); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	};
	
	
	if(has_buf) {
		var utf8readb = function utf8readb(data) {
			var out = new Buffer(2*data.length), w, i, j = 1, k = 0, ww=0, c;
			for(i = 0; i < data.length; i+=j) {
				j = 1;
				if((c=data.charCodeAt(i)) < 128) w = c;
				else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
				else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
				else { j = 4;
					w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
					w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
				}
				if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
				out[k++] = w%256; out[k++] = w>>>8;
			}
			out.length = k;
			return out.toString('ucs2');
		};
		var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
		if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
		var utf8readc = function utf8readc(data) { return Buffer(data, 'binary').toString('utf8'); };
		if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;
	}
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = {};
		return function matchtag(f,g) {
			var t = f+"|"+g;
			if(mtcache[t] !== undefined) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([^\u2603]*)</(?:\\w+:)?'+f+'>',(g||"")));
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<vt:" + bt + ">(.*?)</vt:" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?vt:variant>/g, vtmregex = /<vt:([^>]*)>(.*)</;
	function parseVector(data) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		if(matches.length != h.size) throw "unexpected vector length " + matches.length + " != " + h.size;
		var res = [];
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			res.push({v:v[2], t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) {return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';}
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + (isval(h) ? wxt_helper(h) : "") + (isval(g) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } }
	
	function write_vt(s) {
		switch(typeof s) {
			case 'string': return writextag('vt:lpwstr', s);
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', String(s));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var XMLNS = {
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	};
	
	XMLNS.main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	function readIEEE754(buf, idx, isLE, nl, ml) {
		if(isLE === undefined) isLE = true;
		if(!nl) nl = 8;
		if(!ml && nl === 8) ml = 52;
		var e, m, el = nl * 8 - ml - 1, eMax = (1 << el) - 1, eBias = eMax >> 1;
		var bits = -7, d = isLE ? -1 : 1, i = isLE ? (nl - 1) : 0, s = buf[idx + i];
	
		i += d;
		e = s & ((1 << (-bits)) - 1); s >>>= (-bits); bits += el;
		for (; bits > 0; e = e * 256 + buf[idx + i], i += d, bits -= 8);
		m = e & ((1 << (-bits)) - 1); e >>>= (-bits); bits += ml;
		for (; bits > 0; m = m * 256 + buf[idx + i], i += d, bits -= 8);
		if (e === eMax) return m ? NaN : ((s ? -1 : 1) * Infinity);
		else if (e === 0) e = 1 - eBias;
		else { m = m + Math.pow(2, ml); e = e - eBias; }
		return (s ? -1 : 1) * m * Math.pow(2, e - ml);
	}
	
	var __toBuffer, ___toBuffer;
	__toBuffer = ___toBuffer = function toBuffer_(bufs) { var x = []; for(var i = 0; i < bufs[0].length; ++i) { x.push.apply(x, bufs[0][i]); } return x; };
	var __utf16le, ___utf16le;
	__utf16le = ___utf16le = function utf16le_(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join(""); };
	var __hexlify, ___hexlify;
	__hexlify = ___hexlify = function hexlify_(b,s,l) { return b.slice(s,(s+l)).map(function(x){return (x<16?"0":"") + x.toString(16);}).join(""); };
	var __utf8, ___utf8;
	__utf8 = ___utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var __lpstr, ___lpstr;
	__lpstr = ___lpstr = function lpstr_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __lpwstr, ___lpwstr;
	__lpwstr = ___lpwstr = function lpwstr_(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var __double, ___double;
	__double = ___double = function(b, idx) { return readIEEE754(b, idx);};
	
	var is_buf = function is_buf_a(a) { return Array.isArray(a); };
	if(has_buf) {
		__utf16le = function utf16le_b(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e); };
		__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
		__lpstr = function lpstr_b(b,i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b,i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__utf8 = function utf8_b(s,e) { return this.toString('utf8',s,e); };
		__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
		bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
		__double = function double_(b,i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
	}
	
	/* from js-xls */
	if(typeof cptable !== 'undefined') {
		__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)); };
		__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
	}
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return b[idx+1]*(1<<8)+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = b[idx+1]*(1<<8)+b[idx]; return (u < 0x8000) ? u : (0xffff - u + 1) * -1; };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	
	var ___unhexlify = function(s) { return s.match(/../g).map(function(x) { return parseInt(x,16);}); };
	var __unhexlify = typeof Buffer !== "undefined" ? function(s) { return Buffer.isBuffer(s) ? new Buffer(s, 'hex') : ___unhexlify(s); } : ___unhexlify;
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i != size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr': o = __lpstr(this, this.l); size = 5 + o.length; break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 5 + o.length; if(o[o.length-1] == '\u0000') size += 2; break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case 'wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4:
				if(t === 'i' || (this[this.l+3] & 0x80)===0) { oI = __readInt32LE(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; return oR; } break;
			case 8: if(t === 'f') { oR = __double(this, this.l); this.l += 8; return oR; }
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	function WriteShift(t, val, f) {
		var size, i;
		if(f === 'dbcs') {
			for(i = 0; i != val.length; ++i) this.writeUInt16LE(val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else switch(t) {
			case  1: size = 1; this[this.l] = val&255; break;
			case  3: size = 3; this[this.l+2] = val & 255; val >>>= 8; this[this.l+1] = val&255; val >>>= 8; this[this.l] = val&255; break;
			case  4: size = 4; this.writeUInt32LE(val, this.l); break;
			case  8: size = 8; if(f === 'f') { this.writeDoubleLE(val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; this.writeInt32LE(val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw fld + 'Expected ' + hexstr + ' saw ' + m;
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function writenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		while(data.l < data.length) {
			var RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			var d = R.f(data, length, opts);
			if(cb(d, R, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = 2048;
		var newblk = function ba_newblk(sz) {
			var o = new_buf(sz);
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			curbuf.length = curbuf.l;
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(sz < curbuf.length - curbuf.l) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return __toBuffer([bufs]);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; next(blksz); };
	
		return { next:next, push:push, end:end, _bufs:bufs };
	}
	
	function write_record(ba, type, payload, length) {
		var t = evert_RE[type], l;
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1 + length;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt) {
		if(tgt.s) {
			if(cell.cRel) cell.c += tgt.s.c;
			if(cell.rRel) cell.r += tgt.s.r;
		} else {
			cell.c += tgt.c;
			cell.r += tgt.r;
		}
		cell.cRel = cell.rRel = 0;
		while(cell.c >= 0x100) cell.c -= 0x100;
		while(cell.r >= 0x10000) cell.r -= 0x10000;
		return cell;
	}
	
	function shift_range_xls(cell, range) {
		cell.s = shift_cell_xls(cell.s, range.s);
		cell.e = shift_cell_xls(cell.e, range.s);
		return cell;
	}
	
	var OFFCRYPTO = {};
	var make_offcrypto = function(O, _crypto) {
		var crypto;
		if(typeof _crypto !== 'undefined') crypto = _crypto;
		else if(true) {
			try { crypto = __webpack_require__(1869); }
			catch(e) { crypto = null; }
		}
	
		O.rc4 = function(key, data) {
			var S = new Array(256);
			var c = 0, i = 0, j = 0, t = 0;
			for(i = 0; i != 256; ++i) S[i] = i;
			for(i = 0; i != 256; ++i) {
				j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
				t = S[i]; S[i] = S[j]; S[j] = t;
			}
			i = j = 0; out = Buffer(data.length);
			for(c = 0; c != data.length; ++c) {
				i = (i + 1)&255;
				j = (j + S[i])%256;
				t = S[i]; S[i] = S[j]; S[j] = t;
				out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
			}
			return out;
		};
	
		if(crypto) {
			O.md5 = function(hex) { return crypto.createHash('md5').update(hex).digest('hex'); };
		} else {
			O.md5 = function(hex) { throw "unimplemented"; };
		}
	};
	make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);
	
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data, length) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	
	/* [MS-XLSB] 2.1.7.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = { t: str, h: str };
		if((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for(var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = "<t>" + escapexml(str) + "</t>";
		if((flags & 2) !== 0) { /* fExtStr */
			/* TODO: phonetic string */
		}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		if(o == null) o = new_buf(5+2*str.t.length);
		o.write_shift(1,0);
		write_XLWideString(str.t, o);
		return o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		var fPhShow = data.read_shift(1);
		return { c:col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if(o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef === undefined ? cell.iStyleRef : cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	
	/* [MS-XLSB] 2.5.21 */
	function parse_XLSBCodeName (data, length) { return parse_XLWideString(data, length); }
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if(data.length > 0) o.write_shift(0, data, 'dbcs');
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		if(o == null) o = new_buf(4+2*data.length);
		o.write_shift(4, data.length);
		if(data.length > 0) o.write_shift(0, data, 'dbcs');
		return o;
	}
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLSB] 2.5.122 */
	/* [MS-XLS] 2.5.217 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l+4);
		var fX100 = b[0] & 1, fInt = b[0] & 2;
		data.l+=4;
		b[0] &= 0xFC; // b[0] &= ~3;
		var RK = fInt === 0 ? __double([0,0,0,0,b[0],b[1],b[2],b[3]],0) : __readInt32LE(b,0)>>2;
		return fX100 ? RK/100 : RK;
	}
	
	/* [MS-XLSB] 2.5.153 */
	function parse_UncheckedRfX(data) {
		var cell = {s: {}, e: {}};
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	
	function write_UncheckedRfX(r, o) {
		if(!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.171 */
	/* [MS-XLS] 2.5.342 */
	function parse_Xnum(data, length) { return data.read_shift(8, 'f'); }
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, 'f', data); }
	
	/* [MS-XLSB] 2.5.198.2 */
	var BErr = {
		0x00: "#NULL!",
		0x07: "#DIV/0!",
		0x0F: "#VALUE!",
		0x17: "#REF!",
		0x1D: "#NAME?",
		0x24: "#NUM!",
		0x2A: "#N/A",
		0x2B: "#GETTING_DATA",
		0xFF: "#WTF?"
	};
	var RBErr = evert_num(BErr);
	
	/* [MS-XLSB] 2.4.321 BrtColor */
	function parse_BrtColor(data, length) {
		var out = {};
		var d = data.read_shift(1);
		out.fValidRGB = d & 1;
		out.xColorType = d >>> 1;
		out.index = data.read_shift(1);
		out.nTintAndShade = data.read_shift(2, 'i');
		out.bRed   = data.read_shift(1);
		out.bGreen = data.read_shift(1);
		out.bBlue  = data.read_shift(1);
		out.bAlpha = data.read_shift(1);
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data, length) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fItalic: d & 0x2,
			fStrikeout: d & 0x8,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	/* [MS-OLEPS] 2.2 PropertyType */
	{
		var VT_EMPTY    = 0x0000;
		var VT_NULL     = 0x0001;
		var VT_I2       = 0x0002;
		var VT_I4       = 0x0003;
		var VT_R4       = 0x0004;
		var VT_R8       = 0x0005;
		var VT_CY       = 0x0006;
		var VT_DATE     = 0x0007;
		var VT_BSTR     = 0x0008;
		var VT_ERROR    = 0x000A;
		var VT_BOOL     = 0x000B;
		var VT_VARIANT  = 0x000C;
		var VT_DECIMAL  = 0x000E;
		var VT_I1       = 0x0010;
		var VT_UI1      = 0x0011;
		var VT_UI2      = 0x0012;
		var VT_UI4      = 0x0013;
		var VT_I8       = 0x0014;
		var VT_UI8      = 0x0015;
		var VT_INT      = 0x0016;
		var VT_UINT     = 0x0017;
		var VT_LPSTR    = 0x001E;
		var VT_LPWSTR   = 0x001F;
		var VT_FILETIME = 0x0040;
		var VT_BLOB     = 0x0041;
		var VT_STREAM   = 0x0042;
		var VT_STORAGE  = 0x0043;
		var VT_STREAMED_Object  = 0x0044;
		var VT_STORED_Object    = 0x0045;
		var VT_BLOB_Object      = 0x0046;
		var VT_CF       = 0x0047;
		var VT_CLSID    = 0x0048;
		var VT_VERSIONED_STREAM = 0x0049;
		var VT_VECTOR   = 0x1000;
		var VT_ARRAY    = 0x2000;
	
		var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
		var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
		var VT_CUSTOM   = [VT_STRING, VT_USTR];
	}
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
		0x01: { n: 'CodePage', t: VT_I2 },
		0x02: { n: 'Category', t: VT_STRING },
		0x03: { n: 'PresentationFormat', t: VT_STRING },
		0x04: { n: 'ByteCount', t: VT_I4 },
		0x05: { n: 'LineCount', t: VT_I4 },
		0x06: { n: 'ParagraphCount', t: VT_I4 },
		0x07: { n: 'SlideCount', t: VT_I4 },
		0x08: { n: 'NoteCount', t: VT_I4 },
		0x09: { n: 'HiddenCount', t: VT_I4 },
		0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
		0x0b: { n: 'Scale', t: VT_BOOL },
		0x0c: { n: 'HeadingPair', t: VT_VECTOR | VT_VARIANT },
		0x0d: { n: 'DocParts', t: VT_VECTOR | VT_LPSTR },
		0x0e: { n: 'Manager', t: VT_STRING },
		0x0f: { n: 'Company', t: VT_STRING },
		0x10: { n: 'LinksDirty', t: VT_BOOL },
		0x11: { n: 'CharacterCount', t: VT_I4 },
		0x13: { n: 'SharedDoc', t: VT_BOOL },
		0x16: { n: 'HLinksChanged', t: VT_BOOL },
		0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
		0x1A: { n: 'ContentType', t: VT_STRING },
		0x1B: { n: 'ContentStatus', t: VT_STRING },
		0x1C: { n: 'Language', t: VT_STRING },
		0x1D: { n: 'Version', t: VT_STRING },
		0xFF: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
		0x01: { n: 'CodePage', t: VT_I2 },
		0x02: { n: 'Title', t: VT_STRING },
		0x03: { n: 'Subject', t: VT_STRING },
		0x04: { n: 'Author', t: VT_STRING },
		0x05: { n: 'Keywords', t: VT_STRING },
		0x06: { n: 'Comments', t: VT_STRING },
		0x07: { n: 'Template', t: VT_STRING },
		0x08: { n: 'LastAuthor', t: VT_STRING },
		0x09: { n: 'RevNumber', t: VT_STRING },
		0x0A: { n: 'EditTime', t: VT_FILETIME },
		0x0B: { n: 'LastPrinted', t: VT_FILETIME },
		0x0C: { n: 'CreatedDate', t: VT_FILETIME },
		0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
		0x0E: { n: 'PageCount', t: VT_I4 },
		0x0F: { n: 'WordCount', t: VT_I4 },
		0x10: { n: 'CharCount', t: VT_I4 },
		0x11: { n: 'Thumbnail', t: VT_CF },
		0x12: { n: 'ApplicationName', t: VT_LPSTR },
		0x13: { n: 'DocumentSecurity', t: VT_I4 },
		0xFF: {}
	};
	
	/* [MS-OLEPS] 2.18 */
	var SpecialProperties = {
		0x80000000: { n: 'Locale', t: VT_UI4 },
		0x80000003: { n: 'Behavior', t: VT_UI4 },
		0x72627262: {}
	};
	
	(function() {
		for(var y in SpecialProperties) if(SpecialProperties.hasOwnProperty(y))
		DocSummaryPIDDSI[y] = SummaryPIDSI[y] = SpecialProperties[y];
	})();
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
		0x0001: "US", // United States
		0x0002: "CA", // Canada
		0x0003: "", // Latin America (except Brazil)
		0x0007: "RU", // Russia
		0x0014: "EG", // Egypt
		0x001E: "GR", // Greece
		0x001F: "NL", // Netherlands
		0x0020: "BE", // Belgium
		0x0021: "FR", // France
		0x0022: "ES", // Spain
		0x0024: "HU", // Hungary
		0x0027: "IT", // Italy
		0x0029: "CH", // Switzerland
		0x002B: "AT", // Austria
		0x002C: "GB", // United Kingdom
		0x002D: "DK", // Denmark
		0x002E: "SE", // Sweden
		0x002F: "NO", // Norway
		0x0030: "PL", // Poland
		0x0031: "DE", // Germany
		0x0034: "MX", // Mexico
		0x0037: "BR", // Brazil
		0x003d: "AU", // Australia
		0x0040: "NZ", // New Zealand
		0x0042: "TH", // Thailand
		0x0051: "JP", // Japan
		0x0052: "KR", // Korea
		0x0054: "VN", // Viet Nam
		0x0056: "CN", // China
		0x005A: "TR", // Turkey
		0x0069: "JS", // Ramastan
		0x00D5: "DZ", // Algeria
		0x00D8: "MA", // Morocco
		0x00DA: "LY", // Libya
		0x015F: "PT", // Portugal
		0x0162: "IS", // Iceland
		0x0166: "FI", // Finland
		0x01A4: "CZ", // Czech Republic
		0x0376: "TW", // Taiwan
		0x03C1: "LB", // Lebanon
		0x03C2: "JO", // Jordan
		0x03C3: "SY", // Syria
		0x03C4: "IQ", // Iraq
		0x03C5: "KW", // Kuwait
		0x03C6: "SA", // Saudi Arabia
		0x03CB: "AE", // United Arab Emirates
		0x03CC: "IL", // Israel
		0x03CE: "QA", // Qatar
		0x03D5: "IR", // Iran
		0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	var XLSIcv = rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Sheet */
		0xFFFFFF,
		0x000000
	]);
	
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations */
	/* [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type = {
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Chartsheet */
		"application/vnd.ms-excel.chartsheet": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "TODO",
	
		/* Dialogsheet */
		"application/vnd.ms-excel.dialogsheet": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "TODO",
	
		/* Macrosheet */
		"application/vnd.ms-excel.macrosheet": "TODO",
		"application/vnd.ms-excel.macrosheet+xml": "TODO",
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
	
		/* Comments */
		"application/vnd.ms-excel.comments": "comments",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "TODO",
	
		/* Metadata */
		"application/vnd.ms-excel.sheetMetadata": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "vba",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		"sheet": "js"
	};
	
	var CT_LIST = (function(){
		var o = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			sheets: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			styles: {/* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
		};
		keys(o).forEach(function(k) { if(!o[k].xlsm) o[k].xlsm = o[k].xlsx; });
		keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
		return o;
	})();
	
	var type2ct = evert_arr(ct2type);
	
	XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';
	
	function parse_ct(data, opts) {
		var ctext = {};
		if(!data || !data.match) return data;
		var ct = { workbooks: [], sheets: [], calcchains: [], themes: [], styles: [],
			coreprops: [], extprops: [], custprops: [], strs:[], comments: [], vba: [],
			TODO:[], rels:[], xmlns: "" };
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					else if(opts.WTF) console.error(y);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	var CTYPE_XML_ROOT = writextag('Types', null, {
		'xmlns': XMLNS.CT,
		'xmlns:xsd': XMLNS.xsd,
		'xmlns:xsi': XMLNS.xsi
	});
	
	var CTYPE_DEFAULTS = [
		['xml', 'application/xml'],
		['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
		['rels', type2ct.rels[0]]
	].map(function(x) {
		return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
	});
	
	function write_ct(ct, opts) {
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = (CTYPE_XML_ROOT);
		o = o.concat(CTYPE_DEFAULTS);
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			}
		};
		var f2 = function(w) {
			ct[w].forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			});
		};
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
		f1('workbooks');
		f2('sheets');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3.2 OPC Relationships Markup */
	var RELS = {
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument"
	};
	
	function parse_rels(data, currentFilePath) {
		if (!data) return data;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var rels = {};
		var hash = {};
		var resolveRelativePathIntoAbsolute = function (to) {
			var toksFrom = currentFilePath.split('/');
			toksFrom.pop(); // folder path
			var toksTo = to.split('/');
			var reversed = [];
			while (toksTo.length !== 0) {
				var tokTo = toksTo.shift();
				if (tokTo === '..') {
					toksFrom.pop();
				} else if (tokTo !== '.') {
					toksFrom.push(tokTo);
				}
			}
			return toksFrom.join('/');
		};
	
		data.match(tagregex).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolveRelativePathIntoAbsolute(y.Target);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';
	
	var RELS_ROOT = writextag('Relationships', null, {
		//'xmlns:ns0': XMLNS.RELS,
		'xmlns': XMLNS.RELS
	});
	
	/* TODO */
	function write_rels(rels) {
		var o = [];
		o[o.length] = (XML_HEADER);
		o[o.length] = (RELS_ROOT);
		keys(rels['!id']).forEach(function(rid) { var rel = rels['!id'][rid];
			o[o.length] = (writextag('Relationship', null, rel));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
	RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].substr(0,f[0].indexOf(":")) +":)"+ f[0].substr(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>(.*)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = cur[1];
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = new Date(p[f[1]]);
		}
	
		return p;
	}
	
	var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
		//'xmlns': XMLNS.CORE_PROPS,
		'xmlns:cp': XMLNS.CORE_PROPS,
		'xmlns:dc': XMLNS.dc,
		'xmlns:dcterms': XMLNS.dcterms,
		'xmlns:dcmitype': XMLNS.dcmitype,
		'xmlns:xsi': XMLNS.xsi
	});
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, opts) {
		var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
	  if (opts && opts.Props) {
	    if (opts.Props.title) o[o.length]       = '<dc:title>'       + opts.Props.title        + '</dc:title>';
	    if (opts.Props.subject) o[o.length]     = '<dc:subject>'     + opts.Props.subject      + '</dc:subject>';
	    if (opts.Props.creator) o[o.length]     = '<dc:creator>'     + opts.Props.creator      + '</dc:creator>';
	    if (opts.Props.keywords) o[o.length]    = '<cp:keywords>'    + opts.Props.keywords      + '</cp:keywords>';
	    if (opts.Props.description) o[o.length] = '<dc:description>' + opts.Props.description  + '</dc:description>';
	  }
	  if(cp) {
	
	    if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	    if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
	
	  	for(var i = 0; i != CORE_PROPS.length; ++i) { var f = CORE_PROPS[i]; cp_doit(f[0], cp[f[1]], null, o, p); }
	  }
	  if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
	  return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
	RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';
	
	function parse_ext_props(data, p) {
		var q = {}; if(!p) p = {};
	
		EXT_PROPS.forEach(function(f) {
			switch(f[2]) {
				case "string": p[f[1]] = (data.match(matchtag(f[0]))||[])[1]; break;
				case "bool": p[f[1]] = (data.match(matchtag(f[0]))||[])[1] === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>(.*)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) {
			var v = parseVector(q.HeadingPairs);
			var j = 0, widx = 0;
			for(var i = 0; i !== v.length; ++i) {
				switch(v[i].v) {
					case "Worksheets": widx = j; p.Worksheets = +(v[++i].v); break;
					case "Named Ranges": ++i; break; // TODO: Handle Named Ranges
				}
			}
			var parts = parseVector(q.TitlesOfParts).map(function(x) { return utf8read(x.v); });
			p.SheetNames = parts.slice(widx, widx + p.Worksheets);
		}
		return p;
	}
	
	var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.EXT_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_ext_props(cp, opts) {
		var o = [], p = {}, W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (EXT_PROPS_XML_ROOT);
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = cp[f[1]]; break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + s + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
	RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';
	
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name;
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties':
					if(y.xmlns !== XMLNS.CUST_PROPS) throw "unrecognized xmlns " + y.xmlns;
					if(y.xmlnsvt && y.xmlnsvt !== XMLNS.vt) throw "unrecognized vt " + y.xmlnsvt;
					break;
				case '<property': name = y.name; break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].substring(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'lpwstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text, '<vt:bool>');
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = new Date(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.substr(0,2) === "</") {
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.CUST_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_cust_props(cp, opts) {
		var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k]), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': k
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	function xlml_set_prop(Props, tag, val) {
		/* TODO: Normalize the properties */
		switch(tag) {
			case 'Description': tag = 'Comments'; break;
		}
		Props[tag] = val;
	}
	
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("dafuq?"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr');
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.10 VtVecUnalignedLpstr */
	function parse_VtVecUnalignedLpstr(blob) {
		return parse_VtVecUnalignedLpstrValue(blob);
	}
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i != cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OSHARED] 2.3.3.1.15 VtVecHeadingPair */
	function parse_VtVecHeadingPair(blob) {
		// NOTE: When invoked, wType & padding were already consumed
		return parse_VtVecHeadingPairValue(blob);
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = {};
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		if(size & 3 > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size;
		return o;
	}
	
	/* [MS-OLEPS] 2.14 Vector and Array Property Types */
	function parse_VtVector(blob, cb) {
		/* [MS-OLEPS] 2.14.2 VectorHeader */
	/*	var Length = blob.read_shift(4);
		var o = [];
		for(var i = 0; i != Length; ++i) {
			o.push(cb(blob));
		}
		return o;*/
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw && 4).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t, 4).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPair(blob);
			case 0x101E /*VT_LPSTR*/: return parse_VtVecUnalignedLpstr(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	/* [MS-OLEPS] 2.14.2 VectorHeader */
	/*function parse_VTVectorVariant(blob) {
		var Length = blob.read_shift(4);
	
		if(Length & 1 !== 0) throw new Error("VectorHeader Length=" + Length + " must be even");
		var o = [];
		for(var i = 0; i != Length; ++i) {
			o.push(parse_TypedPropertyValue(blob, VT_VARIANT));
		}
		return o;
	}*/
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj;
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l +2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if(!PIDSI && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + String(PropH[piddsi.n] & 0xFFFF);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 10000: // OSX Roman
					case 1252: // Windows Latin
	
					case 874: // SB Windows Thai
					case 1250: // SB Windows Central Europe
					case 1251: // SB Windows Cyrillic
					case 1253: // SB Windows Greek
					case 1254: // SB Windows Turkish
					case 1255: // SB Windows Hebrew
					case 1256: // SB Windows Arabic
					case 1257: // SB Windows Baltic
					case 1258: // SB Windows Vietnam
	
					case 932: // DB Windows Japanese Shift-JIS
					case 936: // DB Windows Simplified Chinese GBK
					case 949: // DB Windows Korean
					case 950: // DB Windows Traditional Chinese Big5
	
					case 1200: // UTF16LE
					case 1201: // UTF16BE
					case 65000: case -536: // UTF-7
					case 65001: case -535: // UTF-8
						set_cp(CodePage = PropH[piddsi.n]); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = parse_TypedPropertyValue(blob, VT_I2);
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = new Date(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI) {
		var blob = file.content;
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1;
		blob.chk('feff', 'Byte Order: ');
	
		var vers = blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		blob.chk(CFB.utils.consts.HEADER_CLSID, 'CLSID: ');
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw "Unrecognized #Sets: " + NumSets;
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw "Length mismatch";
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = { SystemIdentifier: SystemIdentifier };
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(blob.l !== Offset1) throw "Length mismatch 2: " + blob.l + " !== " + Offset1;
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) { }
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parslurp2(blob, length, cb) {
		var arr = [], target = blob.l + length, len = blob.read_shift(2);
		while(len-- !== 0) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.14 Boolean */
	var parse_Boolean = parsebool;
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(1);
		var width = 1, encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(opts === undefined || opts.biff !== 5) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { width = 2; encoding = 'dbcs-cont'; }
		}
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var fHighByte = flags & 0x1, fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = (flags & 0x1) ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts !== undefined && opts.biff > 0 && opts.biff < 8 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff !== 5 && opts.biff !== 2) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	var parse_ControlInfo = parsenoop;
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	var parse_URLMoniker = function(blob, length) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	};
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	var parse_FileMoniker = function(blob, length) {
		var cAnti = blob.read_shift(2);
		var ansiLength = blob.read_shift(4);
		var ansiPath = blob.read_shift(ansiLength, 'cstr');
		var endServer = blob.read_shift(2);
		var versionNumber = blob.read_shift(2);
		var cbUnicodePathSize = blob.read_shift(4);
		if(cbUnicodePathSize === 0) return ansiPath.replace(/\\/g,"/");
		var cbUnicodePathBytes = blob.read_shift(4);
		var usKeyValue = blob.read_shift(2);
		var unicodePath = blob.read_shift(cbUnicodePathBytes>>1, 'utf16le').replace(chr0,"");
		return unicodePath;
	};
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	var parse_HyperlinkMoniker = function(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw "unsupported moniker " + clsid;
		}
	};
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	var parse_HyperlinkString = function(blob, length) {
		var len = blob.read_shift(4);
		var o = blob.read_shift(len, 'utf16le').replace(chr0, "");
		return o;
	};
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object TODO: unify params with XLSX */
	var parse_Hyperlink = function(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, location, guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) location = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob, 8);
		blob.l = end;
		var target = (targetFrameName||moniker||oleMoniker);
		if(location) target+="#"+location;
		return {Target: target};
	};
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob, length) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* --- MS-XLS --- */
	
	/* 2.5.19 */
	function parse_XLSCell(blob, length) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return {r:rw, c:col, ixfe:ixfe};
	}
	
	/* 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* 2.5.158 */
	var HIDEOBJENUM = ['SHOWALL', 'SHOWPLACEHOLDER', 'HIDEALL'];
	var parse_HideObjEnum = parseuint16;
	
	/* 2.5.344 */
	function parse_XTI(blob, length) {
		var iSupBook = blob.read_shift(2), itabFirst = blob.read_shift(2,'i'), itabLast = blob.read_shift(2,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* 2.5.218 */
	function parse_RkRec(blob, length) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		//console.log("::", ixfe, RK,";;");
		return [ixfe, RK];
	}
	
	/* 2.5.1 */
	function parse_AddinUdf(blob, length) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw "Malformed AddinUdf: padding = " + l + " != " + cb;
		blob.l += cb;
		return udfName;
	}
	
	/* 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob, length) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* 2.5.211 */
	function parse_RefU(blob, length) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* 2.5.143 */
	function parse_FtCmo(blob, length) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* 2.5.149 */
	function parse_FtNts(blob, length) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* 2.5.142 */
	function parse_FtCf(blob, length) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* 2.5.140 - 2.5.154 and friends */
	var FtTab = {
		0x15: parse_FtCmo,
		0x13: parsenoop,                                /* FtLbsData */
		0x12: function(blob, length) { blob.l += 12; }, /* FtCblsData */
		0x11: function(blob, length) { blob.l += 8; },  /* FtRboData */
		0x10: parsenoop,                                /* FtEdoData */
		0x0F: parsenoop,                                /* FtGboData */
		0x0D: parse_FtNts,                              /* FtNts */
		0x0C: function(blob, length) { blob.l += 24; }, /* FtSbs */
		0x0B: function(blob, length) { blob.l += 10; }, /* FtRbo */
		0x0A: function(blob, length) { blob.l += 16; }, /* FtCbls */
		0x09: parsenoop,                                /* FtPictFmla */
		0x08: function(blob, length) { blob.l += 6; },  /* FtPioGrbit */
		0x07: parse_FtCf,                               /* FtCf */
		0x06: function(blob, length) { blob.l += 6; },  /* FtGmo */
		0x04: parsenoop,                                /* FtMacro */
		0x00: function(blob, length) { blob.l += 4; }   /* FtEnding */
	};
	function parse_FtArray(blob, length, ot) {
		var s = blob.l;
		var fts = [];
		while(blob.l < s + length) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, s + length - blob.l));
			} catch(e) { blob.l = s + length; return fts; }
		}
		if(blob.l != s + length) blob.l = s + length; //throw "bad Object Ft-sequence";
		return fts;
	}
	
	/* 2.5.129 */
	var parse_FontIndex = parseuint16;
	
	/* --- 2.4 Records --- */
	
	/* 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: throw "Unexpected BIFF Ver " + o.BIFFVer;
		}
		blob.read_shift(length);
		return o;
	}
	
	
	/* 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		var q;
		if((q=blob.read_shift(2))!==0x04b0) throw 'InterfaceHdr codePage ' + q;
		return 0x04b0;
	}
	
	
	/* 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	
	/* 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) >> 6;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	
	/* 2.4.265 TODO */
	function parse_SST(blob, length) {
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = [];
		for(var i = 0; i != ucnt; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	
	/* 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* 2.4.221 TODO*/
	function parse_Row(blob, length) {
		var rw = blob.read_shift(2), col = blob.read_shift(2), Col = blob.read_shift(2), rht = blob.read_shift(2);
		blob.read_shift(4); // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.read_shift(1); // reserved
		blob.read_shift(2); //ixfe, other flags
		return {r:rw, c:col, cnt:Col-col};
	}
	
	
	/* 2.4.125 */
	function parse_ForceFullCalculation(blob, length) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw "Invalid Future Record " + header.type;
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	var parse_CompressPictures = parsenoop2; /* 2.4.55 Not interesting */
	
	
	
	/* 2.4.215 rt */
	function parse_RecalcId(blob, length) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* 2.4.87 */
	function parse_DefaultRowHeight (blob, length) {
		var f = blob.read_shift(2), miyRw;
		miyRw = blob.read_shift(2); // flags & 0x02 -> hidden, else empty
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* 2.4.345 TODO */
	function parse_Window1(blob, length) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	
	/* 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		blob.l += 14;
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		return name;
	}
	
	/* 2.4.149 */
	function parse_LabelSst(blob, length) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	
	/* 2.4.148 */
	function parse_Label(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		var str = parse_XLUnicodeString(blob, length-6, opts);
		cell.val = str;
		return cell;
	}
	
	/* 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var ifmt = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [ifmt, fmtstr];
	}
	
	/* 2.4.90 */
	function parse_Dimensions(blob, length) {
		var w = length === 10 ? 2 : 4;
		var r = blob.read_shift(w), R = blob.read_shift(w),
		    c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l += 2;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	
	/* 2.4.220 */
	function parse_RK(blob, length) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw "MulRK read error";
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw "MulRK length mismatch";
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	
	/* 2.5.20 2.5.249 TODO */
	function parse_CellStyleXF(blob, length, style) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		return o;
	}
	function parse_CellXF(blob, length) {return parse_CellStyleXF(blob,length,0);}
	function parse_StyleXF(blob, length) {return parse_CellStyleXF(blob,length,1);}
	
	/* 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.ifmt = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle);
		return o;
	}
	
	/* 2.4.134 */
	function parse_Guts(blob, length) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw "Bad Gutters: " + out;
		return out;
	}
	
	/* 2.4.24 */
	function parse_BoolErr(blob, length) {
		var cell = parse_XLSCell(blob, 6);
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	
	/* 2.4.180 Number */
	function parse_Number(blob, length) {
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		var virtPath;
		if(cch >=0x01 && cch <=0xff) virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		var rgst = blob.read_shift(end - blob.l);
		opts.sbcch = cch;
		return [cch, ctab, virtPath, rgst];
	}
	
	/* 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = {
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		};
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		return o;
	}
	
	/* 2.4.150 TODO */
	function parse_Lbl(blob, length, opts) {
		if(opts.biff < 8) return parse_Label(blob, length, opts);
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(2);
		blob.l += 2;
		var itab = blob.read_shift(2);
		blob.l += 4;
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		var rgce = parse_NameParsedFormula(blob, target - blob.l, opts, cce);
		return {
			chKey: chKey,
			Name: name,
			rgce: rgce
		};
	}
	
	/* 2.4.106 TODO: verify supbook manipulation */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_ShortXLUnicodeString(blob, length, opts);
		var o = parslurp2(blob,length,parse_XTI);
		var oo = [];
		if(opts.sbcch === 0x0401) {
			for(var i = 0; i != o.length; ++i) oo.push(opts.snames[o[i][1]]);
			return oo;
		}
		else return o;
	}
	
	/* 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse];
	}
	
	/* 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		blob.l += 6; length -= 12; /* TODO: fAlwaysCalc */
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* 2.4.173 */
	function parse_MTRSettings(blob, length) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	
	/* 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length) {
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	
	/* 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo;
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts);
		var cchText = blob.read_shift(2);
		var cbRuns = blob.read_shift(2);
		var ifntEmpty = parse_FontIndex(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		var texts = "";
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw "TxO: bad continue record";
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw "cchText: " + cchText + " != " + texts.length;
		}
	
		blob.l = s + length;
		/* 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw "TxOLastRun mismatch: " + cchText2 + " " + cchText;
	//	blob.l += 6;
	//	if(s + length != blob.l) throw "TxO " + (s + length) + ", at " + blob.l;
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts||"" }; }
	}
	
	/* 2.4.140 */
	var parse_HLink = function(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	};
	
	/* 2.4.141 */
	var parse_HLinkTooltip = function(blob, length) {
		var end = blob.l + length;
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	};
	
	/* 2.4.63 */
	function parse_Country(blob, length) {
		var o = [], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	
	/* 2.4.50 ClrtClient */
	function parse_ClrtClient(blob, length) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* 2.4.188 */
	function parse_Palette(blob, length) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* 2.4.354 */
	function parse_XFCRC(blob, length) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	
	var parse_Style = parsenoop;
	var parse_StyleExt = parsenoop;
	
	var parse_ColInfo = parsenoop;
	
	var parse_Window2 = parsenoop;
	
	
	var parse_Backup = parsebool; /* 2.4.14 */
	var parse_Blank = parse_XLSCell; /* 2.4.20 Just the cell */
	var parse_BottomMargin = parse_Xnum; /* 2.4.27 */
	var parse_BuiltInFnGroupCount = parseuint16; /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */
	var parse_CalcCount = parseuint16; /* 2.4.31 #Iterations */
	var parse_CalcDelta = parse_Xnum; /* 2.4.32 */
	var parse_CalcIter = parsebool;  /* 2.4.33 1=iterative calc */
	var parse_CalcMode = parseuint16; /* 2.4.34 0=manual, 1=auto (def), 2=table */
	var parse_CalcPrecision = parsebool; /* 2.4.35 */
	var parse_CalcRefMode = parsenoop2; /* 2.4.36 */
	var parse_CalcSaveRecalc = parsebool; /* 2.4.37 */
	var parse_CodePage = parseuint16; /* 2.4.52 */
	var parse_Compat12 = parsebool; /* 2.4.54 true = no compatibility check */
	var parse_Date1904 = parsebool; /* 2.4.77 - 1=1904,0=1900 */
	var parse_DefColWidth = parseuint16; /* 2.4.89 */
	var parse_DSF = parsenoop2; /* 2.4.94 -- MUST be ignored */
	var parse_EntExU2 = parsenoop2; /* 2.4.102 -- Explicitly says to ignore */
	var parse_EOF = parsenoop2; /* 2.4.103 */
	var parse_Excel9File = parsenoop2; /* 2.4.104 -- Optional and unused */
	var parse_FeatHdr = parsenoop2; /* 2.4.112 */
	var parse_FontX = parseuint16; /* 2.4.123 */
	var parse_Footer = parse_XLHeaderFooter; /* 2.4.124 */
	var parse_GridSet = parseuint16; /* 2.4.132, =1 */
	var parse_HCenter = parsebool; /* 2.4.135 sheet centered horizontal on print */
	var parse_Header = parse_XLHeaderFooter; /* 2.4.136 */
	var parse_HideObj = parse_HideObjEnum; /* 2.4.139 */
	var parse_InterfaceEnd = parsenoop2; /* 2.4.145 -- noop */
	var parse_LeftMargin = parse_Xnum; /* 2.4.151 */
	var parse_Mms = parsenoop2; /* 2.4.169 -- Explicitly says to ignore */
	var parse_ObjProtect = parsebool; /* 2.4.183 -- must be 1 if present */
	var parse_Password = parseuint16; /* 2.4.191 */
	var parse_PrintGrid = parsebool; /* 2.4.202 */
	var parse_PrintRowCol = parsebool; /* 2.4.203 */
	var parse_PrintSize = parseuint16; /* 2.4.204 0:3 */
	var parse_Prot4Rev = parsebool; /* 2.4.205 */
	var parse_Prot4RevPass = parseuint16; /* 2.4.206 */
	var parse_Protect = parsebool; /* 2.4.207 */
	var parse_RefreshAll = parsebool; /* 2.4.217 -- must be 0 if not template */
	var parse_RightMargin = parse_Xnum; /* 2.4.219 */
	var parse_RRTabId = parseuint16a; /* 2.4.241 */
	var parse_ScenarioProtect = parsebool; /* 2.4.245 */
	var parse_Scl = parseuint16a; /* 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* 2.4.268 */
	var parse_SxBool = parsebool; /* 2.4.274 */
	var parse_TopMargin = parse_Xnum; /* 2.4.328 */
	var parse_UsesELFs = parsebool; /* 2.4.337 -- should be 0 */
	var parse_VCenter = parsebool; /* 2.4.342 */
	var parse_WinProtect = parsebool; /* 2.4.347 */
	var parse_WriteProtect = parsenoop; /* 2.4.350 empty record */
	
	
	/* ---- */
	var parse_VerticalPageBreaks = parsenoop;
	var parse_HorizontalPageBreaks = parsenoop;
	var parse_Selection = parsenoop;
	var parse_Continue = parsenoop;
	var parse_Pane = parsenoop;
	var parse_Pls = parsenoop;
	var parse_DCon = parsenoop;
	var parse_DConRef = parsenoop;
	var parse_DConName = parsenoop;
	var parse_XCT = parsenoop;
	var parse_CRN = parsenoop;
	var parse_FileSharing = parsenoop;
	var parse_Uncalced = parsenoop;
	var parse_Template = parsenoop;
	var parse_Intl = parsenoop;
	var parse_WsBool = parsenoop;
	var parse_Sort = parsenoop;
	var parse_Sync = parsenoop;
	var parse_LPr = parsenoop;
	var parse_DxGCol = parsenoop;
	var parse_FnGroupName = parsenoop;
	var parse_FilterMode = parsenoop;
	var parse_AutoFilterInfo = parsenoop;
	var parse_AutoFilter = parsenoop;
	var parse_Setup = parsenoop;
	var parse_ScenMan = parsenoop;
	var parse_SCENARIO = parsenoop;
	var parse_SxView = parsenoop;
	var parse_Sxvd = parsenoop;
	var parse_SXVI = parsenoop;
	var parse_SxIvd = parsenoop;
	var parse_SXLI = parsenoop;
	var parse_SXPI = parsenoop;
	var parse_DocRoute = parsenoop;
	var parse_RecipName = parsenoop;
	var parse_MulBlank = parsenoop;
	var parse_SXDI = parsenoop;
	var parse_SXDB = parsenoop;
	var parse_SXFDB = parsenoop;
	var parse_SXDBB = parsenoop;
	var parse_SXNum = parsenoop;
	var parse_SxErr = parsenoop;
	var parse_SXInt = parsenoop;
	var parse_SXString = parsenoop;
	var parse_SXDtr = parsenoop;
	var parse_SxNil = parsenoop;
	var parse_SXTbl = parsenoop;
	var parse_SXTBRGIITM = parsenoop;
	var parse_SxTbpg = parsenoop;
	var parse_ObProj = parsenoop;
	var parse_SXStreamID = parsenoop;
	var parse_DBCell = parsenoop;
	var parse_SXRng = parsenoop;
	var parse_SxIsxoper = parsenoop;
	var parse_BookBool = parsenoop;
	var parse_DbOrParamQry = parsenoop;
	var parse_OleObjectSize = parsenoop;
	var parse_SXVS = parsenoop;
	var parse_BkHim = parsenoop;
	var parse_MsoDrawingGroup = parsenoop;
	var parse_MsoDrawing = parsenoop;
	var parse_MsoDrawingSelection = parsenoop;
	var parse_PhoneticInfo = parsenoop;
	var parse_SxRule = parsenoop;
	var parse_SXEx = parsenoop;
	var parse_SxFilt = parsenoop;
	var parse_SxDXF = parsenoop;
	var parse_SxItm = parsenoop;
	var parse_SxName = parsenoop;
	var parse_SxSelect = parsenoop;
	var parse_SXPair = parsenoop;
	var parse_SxFmla = parsenoop;
	var parse_SxFormat = parsenoop;
	var parse_SXVDEx = parsenoop;
	var parse_SXFormula = parsenoop;
	var parse_SXDBEx = parsenoop;
	var parse_RRDInsDel = parsenoop;
	var parse_RRDHead = parsenoop;
	var parse_RRDChgCell = parsenoop;
	var parse_RRDRenSheet = parsenoop;
	var parse_RRSort = parsenoop;
	var parse_RRDMove = parsenoop;
	var parse_RRFormat = parsenoop;
	var parse_RRAutoFmt = parsenoop;
	var parse_RRInsertSh = parsenoop;
	var parse_RRDMoveBegin = parsenoop;
	var parse_RRDMoveEnd = parsenoop;
	var parse_RRDInsDelBegin = parsenoop;
	var parse_RRDInsDelEnd = parsenoop;
	var parse_RRDConflict = parsenoop;
	var parse_RRDDefName = parsenoop;
	var parse_RRDRstEtxp = parsenoop;
	var parse_LRng = parsenoop;
	var parse_CUsr = parsenoop;
	var parse_CbUsr = parsenoop;
	var parse_UsrInfo = parsenoop;
	var parse_UsrExcl = parsenoop;
	var parse_FileLock = parsenoop;
	var parse_RRDInfo = parsenoop;
	var parse_BCUsrs = parsenoop;
	var parse_UsrChk = parsenoop;
	var parse_UserBView = parsenoop;
	var parse_UserSViewBegin = parsenoop; // overloaded
	var parse_UserSViewEnd = parsenoop;
	var parse_RRDUserView = parsenoop;
	var parse_Qsi = parsenoop;
	var parse_CondFmt = parsenoop;
	var parse_CF = parsenoop;
	var parse_DVal = parsenoop;
	var parse_DConBin = parsenoop;
	var parse_Lel = parsenoop;
	var parse_XLSCodeName = parse_XLUnicodeString;
	var parse_SXFDBType = parsenoop;
	var parse_ObNoMacros = parsenoop;
	var parse_Dv = parsenoop;
	var parse_Index = parsenoop;
	var parse_Table = parsenoop;
	var parse_BigName = parsenoop;
	var parse_ContinueBigName = parsenoop;
	var parse_WebPub = parsenoop;
	var parse_QsiSXTag = parsenoop;
	var parse_DBQueryExt = parsenoop;
	var parse_ExtString = parsenoop;
	var parse_TxtQry = parsenoop;
	var parse_Qsir = parsenoop;
	var parse_Qsif = parsenoop;
	var parse_RRDTQSIF = parsenoop;
	var parse_OleDbConn = parsenoop;
	var parse_WOpt = parsenoop;
	var parse_SXViewEx = parsenoop;
	var parse_SXTH = parsenoop;
	var parse_SXPIEx = parsenoop;
	var parse_SXVDTEx = parsenoop;
	var parse_SXViewEx9 = parsenoop;
	var parse_ContinueFrt = parsenoop;
	var parse_RealTimeData = parsenoop;
	var parse_ChartFrtInfo = parsenoop;
	var parse_FrtWrapper = parsenoop;
	var parse_StartBlock = parsenoop;
	var parse_EndBlock = parsenoop;
	var parse_StartObject = parsenoop;
	var parse_EndObject = parsenoop;
	var parse_CatLab = parsenoop;
	var parse_YMult = parsenoop;
	var parse_SXViewLink = parsenoop;
	var parse_PivotChartBits = parsenoop;
	var parse_FrtFontList = parsenoop;
	var parse_SheetExt = parsenoop;
	var parse_BookExt = parsenoop;
	var parse_SXAddl = parsenoop;
	var parse_CrErr = parsenoop;
	var parse_HFPicture = parsenoop;
	var parse_Feat = parsenoop;
	var parse_DataLabExt = parsenoop;
	var parse_DataLabExtContents = parsenoop;
	var parse_CellWatch = parsenoop;
	var parse_FeatHdr11 = parsenoop;
	var parse_Feature11 = parsenoop;
	var parse_DropDownObjIds = parsenoop;
	var parse_ContinueFrt11 = parsenoop;
	var parse_DConn = parsenoop;
	var parse_List12 = parsenoop;
	var parse_Feature12 = parsenoop;
	var parse_CondFmt12 = parsenoop;
	var parse_CF12 = parsenoop;
	var parse_CFEx = parsenoop;
	var parse_AutoFilter12 = parsenoop;
	var parse_ContinueFrt12 = parsenoop;
	var parse_MDTInfo = parsenoop;
	var parse_MDXStr = parsenoop;
	var parse_MDXTuple = parsenoop;
	var parse_MDXSet = parsenoop;
	var parse_MDXProp = parsenoop;
	var parse_MDXKPI = parsenoop;
	var parse_MDB = parsenoop;
	var parse_PLV = parsenoop;
	var parse_DXF = parsenoop;
	var parse_TableStyles = parsenoop;
	var parse_TableStyle = parsenoop;
	var parse_TableStyleElement = parsenoop;
	var parse_NamePublish = parsenoop;
	var parse_NameCmt = parsenoop;
	var parse_SortData = parsenoop;
	var parse_GUIDTypeLib = parsenoop;
	var parse_FnGrp12 = parsenoop;
	var parse_NameFnGrp12 = parsenoop;
	var parse_HeaderFooter = parsenoop;
	var parse_CrtLayout12 = parsenoop;
	var parse_CrtMlFrt = parsenoop;
	var parse_CrtMlFrtContinue = parsenoop;
	var parse_ShapePropsStream = parsenoop;
	var parse_TextPropsStream = parsenoop;
	var parse_RichTextStream = parsenoop;
	var parse_CrtLayout12A = parsenoop;
	var parse_Units = parsenoop;
	var parse_Chart = parsenoop;
	var parse_Series = parsenoop;
	var parse_DataFormat = parsenoop;
	var parse_LineFormat = parsenoop;
	var parse_MarkerFormat = parsenoop;
	var parse_AreaFormat = parsenoop;
	var parse_PieFormat = parsenoop;
	var parse_AttachedLabel = parsenoop;
	var parse_SeriesText = parsenoop;
	var parse_ChartFormat = parsenoop;
	var parse_Legend = parsenoop;
	var parse_SeriesList = parsenoop;
	var parse_Bar = parsenoop;
	var parse_Line = parsenoop;
	var parse_Pie = parsenoop;
	var parse_Area = parsenoop;
	var parse_Scatter = parsenoop;
	var parse_CrtLine = parsenoop;
	var parse_Axis = parsenoop;
	var parse_Tick = parsenoop;
	var parse_ValueRange = parsenoop;
	var parse_CatSerRange = parsenoop;
	var parse_AxisLine = parsenoop;
	var parse_CrtLink = parsenoop;
	var parse_DefaultText = parsenoop;
	var parse_Text = parsenoop;
	var parse_ObjectLink = parsenoop;
	var parse_Frame = parsenoop;
	var parse_Begin = parsenoop;
	var parse_End = parsenoop;
	var parse_PlotArea = parsenoop;
	var parse_Chart3d = parsenoop;
	var parse_PicF = parsenoop;
	var parse_DropBar = parsenoop;
	var parse_Radar = parsenoop;
	var parse_Surf = parsenoop;
	var parse_RadarArea = parsenoop;
	var parse_AxisParent = parsenoop;
	var parse_LegendException = parsenoop;
	var parse_ShtProps = parsenoop;
	var parse_SerToCrt = parsenoop;
	var parse_AxesUsed = parsenoop;
	var parse_SBaseRef = parsenoop;
	var parse_SerParent = parsenoop;
	var parse_SerAuxTrend = parsenoop;
	var parse_IFmtRecord = parsenoop;
	var parse_Pos = parsenoop;
	var parse_AlRuns = parsenoop;
	var parse_BRAI = parsenoop;
	var parse_SerAuxErrBar = parsenoop;
	var parse_SerFmt = parsenoop;
	var parse_Chart3DBarShape = parsenoop;
	var parse_Fbi = parsenoop;
	var parse_BopPop = parsenoop;
	var parse_AxcExt = parsenoop;
	var parse_Dat = parsenoop;
	var parse_PlotGrowth = parsenoop;
	var parse_SIIndex = parsenoop;
	var parse_GelFrame = parsenoop;
	var parse_BopPopCustom = parsenoop;
	var parse_Fbi2 = parsenoop;
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_BIFF5String(blob) {
		var len = blob.read_shift(1);
		return blob.read_shift(len, 'sbcs-cont');
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.val = num;
		return cell;
	}
	
	/* 18.4.1 charset to codepage mapping */
	var CS2CP = {
		0:    1252, /* ANSI */
		1:   65001, /* DEFAULT */
		2:   65001, /* SYMBOL */
		77:  10000, /* MAC */
		128:   932, /* SHIFTJIS */
		129:   949, /* HANGUL */
		130:  1361, /* JOHAB */
		134:   936, /* GB2312 */
		136:   950, /* CHINESEBIG5 */
		161:  1253, /* GREEK */
		162:  1254, /* TURKISH */
		163:  1258, /* VIETNAMESE */
		177:  1255, /* HEBREW */
		178:  1256, /* ARABIC */
		186:  1257, /* BALTIC */
		204:  1251, /* RUSSIAN */
		222:   874, /* THAI */
		238:  1250, /* EASTEUROPE */
		255:  1252, /* OEM */
		69:   6969  /* MISC */
	};
	
	/* Parse a list of <r> tags */
	var parse_rs = (function parse_rs_factory() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr"), rregex = /<r>/g, rend = /<\/r>/, nlregex = /\r\n/g;
		/* 18.4.7 rPr CT_RPrElt */
		var parse_rpr = function parse_rpr(rpr, intro, outro) {
			var font = {}, cp = 65001;
			var m = rpr.match(tagregex), i = 0;
			if(m) for(;i!=m.length; ++i) {
				var y = parsexmltag(m[i]);
				switch(y[0]) {
					/* 18.8.12 condense CT_BooleanProperty */
					/* ** not required . */
					case '<condense': break;
					/* 18.8.17 extend CT_BooleanProperty */
					/* ** not required . */
					case '<extend': break;
					/* 18.8.36 shadow CT_BooleanProperty */
					/* ** not required . */
					case '<shadow':
						/* falls through */
					case '<shadow/>': break;
	
					/* 18.4.1 charset CT_IntProperty TODO */
					case '<charset':
						if(y.val == '1') break;
						cp = CS2CP[parseInt(y.val, 10)];
						break;
	
					/* 18.4.2 outline CT_BooleanProperty TODO */
					case '<outline':
						/* falls through */
					case '<outline/>': break;
	
					/* 18.4.5 rFont CT_FontName */
					case '<rFont': font.name = y.val; break;
	
					/* 18.4.11 sz CT_FontSize */
					case '<sz': font.sz = y.val; break;
	
					/* 18.4.10 strike CT_BooleanProperty */
					case '<strike':
						if(!y.val) break;
						/* falls through */
					case '<strike/>': font.strike = 1; break;
					case '</strike>': break;
	
					/* 18.4.13 u CT_UnderlineProperty */
					case '<u':
						if(!y.val) break;
						/* falls through */
					case '<u/>': font.u = 1; break;
					case '</u>': break;
	
					/* 18.8.2 b */
					case '<b':
						if(!y.val) break;
						/* falls through */
					case '<b/>': font.b = 1; break;
					case '</b>': break;
	
					/* 18.8.26 i */
					case '<i':
						if(!y.val) break;
						/* falls through */
					case '<i/>': font.i = 1; break;
					case '</i>': break;
	
					/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
					case '<color':
						if(y.rgb) font.color = y.rgb.substr(2,6);
						break;
	
					/* 18.8.18 family ST_FontFamily */
					case '<family': font.family = y.val; break;
	
					/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
					case '<vertAlign': break;
	
					/* 18.8.35 scheme CT_FontScheme TODO */
					case '<scheme': break;
	
					default:
						if(y[0].charCodeAt(1) !== 47) throw 'Unrecognized rich format ' + y[0];
				}
			}
			/* TODO: These should be generated styles, not inline */
			var style = [];
			if(font.b) style.push("font-weight: bold;");
			if(font.i) style.push("font-style: italic;");
			intro.push('<span style="' + style.join("") + '">');
			outro.push("</span>");
			return cp;
		};
	
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			var terms = [[],"",[]];
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex), cp = 65001;
			if(!isval(t)) return "";
			terms[1] = t[1];
	
			var rpr = r.match(rpregex);
			if(isval(rpr)) cp = parse_rpr(rpr[1], terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<t[^>]*>([^<]*)<\/t>/g, sirregex = /<r>/;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return null;
		var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		if(x.charCodeAt(1) === 116) {
			z.t = utf8read(unescapexml(x.substr(x.indexOf(">")+1).split(/<\/t>/)[0]));
			z.r = x;
			if(html) z.h = z.t;
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((y = x.match(sirregex))) {
			z.r = x;
			z.t = utf8read(unescapexml(x.match(sitregex).join("").replace(tagregex,"")));
			if(html) z.h = parse_rs(x);
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<sst([^>]*)>([\s\S]*)<\/sst>/;
	var sstr1 = /<(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = [], ss;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(isval(sst)) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i], opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS.main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.219 BrtBeginSst */
	function parse_BrtBeginSst(data, length) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = [];
		var pass = false;
		recordhopper(data, function hopper_sst(val, R, RT) {
			switch(R.n) {
				case 'BrtBeginSst': s.Count = val[0]; s.Unique = val[1]; break;
				case 'BrtSSTItem': s.push(val); break;
				case 'BrtEndSst': return true;
				/* TODO: produce a test case with a future record */
				case 'BrtFRTBegin': pass = true; break;
				case 'BrtFRTEnd': pass = false; break;
				default: if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n);
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
		write_record(ba, "BrtEndSst");
		return ba.end();
	}
	function _JS2ANSI(str) { if(typeof cptable !== 'undefined') return cptable.utils.encode(1252, str); return str.split("").map(function(x) { return x.charCodeAt(0); }); }
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_Version(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var o = {};
		o.Flags = blob.read_shift(4);
	
		// Check if SizeExtra is 0x00000000
		var tmp = blob.read_shift(4);
		if(tmp !== 0) throw 'Unrecognized SizeExtra: ' + tmp;
	
		o.AlgID = blob.read_shift(4);
		switch(o.AlgID) {
			case 0: case 0x6801: case 0x660E: case 0x660F: case 0x6610: break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		parsenoop(blob, length-12);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		return parsenoop(blob, length);
	}
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_Version(blob, 4); length -= 4;
		if(vers.Minor != 2) throw 'unrecognized minor version code: ' + vers.Minor;
		if(vers.Major > 4 || vers.Major < 2) throw 'unrecognized major version code: ' + vers.Major;
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_Version(blob, 4); length -= 4;
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1(null, Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = { key: parseuint16(blob), verificationBytes: parseuint16(blob) };
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu_decrypt = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = { Type: blob.read_shift(2) }; /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, length-2, opts, o);
		return o;
	}
	
	
	function hex2RGB(h) {
		var o = h.substr(h[0]==="#"?1:0,6);
		return [parseInt(o.substr(0,2),16),parseInt(o.substr(2,2),16),parseInt(o.substr(4,2),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().substr(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint == 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
	  var rev =rgb2Hex(hsl2RGB(hsl))
		return rev;
	}
	
	/* 18.3.1.13 width calculations */
	var DEF_MDW = 7, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return (( width + ((128/MDW)|0)/256 )* MDW )|0; }
	function px2char(px) { return (((px - 5)/MDW * 100 + 0.5)|0)/100; }
	function char2width(chr) { return (((chr * MDW + 5)/MDW*256)|0)/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	function find_mdw(collw, coll) {
		if(cycle_width(collw) != collw) {
			for(MDW=DEF_MDW; MDW>MIN_MDW; --MDW) if(cycle_width(collw) === collw) break;
			if(MDW === MIN_MDW) for(MDW=DEF_MDW+1; MDW<MAX_MDW; ++MDW) if(cycle_width(collw) === collw) break;
			if(MDW === MAX_MDW) MDW = DEF_MDW;
		}
	}
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	var styles = {}; // shared styles
	
	var themes = {}; // shared themes
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, opts) {
	  styles.Fills = [];
	  var fill = {};
	  t[0].match(tagregex).forEach(function (x) {
	    var y = parsexmltag(x);
	    switch (y[0]) {
	      case '<fills':
	      case '<fills>':
	      case '</fills>':
	        break;
	
	      /* 18.8.20 fill CT_Fill */
	      case '<fill>':
	        break;
	      case '</fill>':
	        styles.Fills.push(fill);
	        fill = {};
	        break;
	
	      /* 18.8.32 patternFill CT_PatternFill */
	      case '<patternFill':
	        if (y.patternType) fill.patternType = y.patternType;
	        break;
	      case '<patternFill/>':
	      case '</patternFill>':
	        break;
	
	      /* 18.8.3 bgColor CT_Color */
	      case '<bgColor':
	        if (!fill.bgColor) fill.bgColor = {};
	        if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
	        if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
	        if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
	
	
	        if (y.theme && themes.themeElements && themes.themeElements.clrScheme) {
	          fill.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[fill.bgColor.theme].rgb, fill.bgColor.tint || 0);
	          if (opts.WTF) fill.bgColor.raw_rgb = rgb_tint(themes.themeElements.clrScheme[fill.bgColor.theme].rgb,0);
	        }
	        /* Excel uses ARGB strings */
	        if (y.rgb) fill.bgColor.rgb = y.rgb;//.substring(y.rgb.length - 6);
	        break;
	      case '<bgColor/>':
	      case '</bgColor>':
	        break;
	
	      /* 18.8.19 fgColor CT_Color */
	      case '<fgColor':
	        if (!fill.fgColor) fill.fgColor = {};
	        if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
	        if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
	
	        if (y.theme && themes.themeElements && themes.themeElements.clrScheme) {
	          fill.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[fill.fgColor.theme].rgb, fill.fgColor.tint || 0);
	          if (opts.WTF) fill.fgColor.raw_rgb = rgb_tint(themes.themeElements.clrScheme[fill.fgColor.theme].rgb,0);
	        }
	
	        /* Excel uses ARGB strings */
	        if (y.rgb) fill.fgColor.rgb = y.rgb;//.substring(y.rgb.length - 6);
	        break;
	      case '<fgColor/>':
	      case '</fgColor>':
	        break;
	
	      default:
	        if (opts.WTF) throw 'unrecognized ' + y[0] + ' in fills';
	    }
	  });
	}
	
	function parse_fonts(t, opts) {
	  styles.Fonts = [];
	  var font = {};
	  t[0].match(tagregex).forEach(function (x) {
	    var y = parsexmltag(x);
	    switch (y[0]) {
	
	      case '<fonts':
	      case  '<fonts>':
	      case '</fonts>':
	        break;
	      case '<font':
	        break;
	      case '</font>':
	        styles.Fonts.push(font);
	        ;
	        font = {};
	        break;
	
	      case '<name':
	        if (y.val) font.name = y.val;
	        break;
	      case '<name/>':
	      case '</name>':
	        break;
	
	
	      case '<b/>':
	        font.bold = true;
	        break;
	      case '<u/>':
	        font.underline = true;
	        break;
	      case '<i/>':
	        font.italic = true;
	        break;
	      case '<strike/>':
	        font.strike = true;
	        break;
	      case '<outline/>':
	        font.outline = true;
	        break;
	      case '<shadow/>':
	        font.shadow = true;
	        break;
	
	
	      case '<sz':
	        if (y.val) font.sz = y.val;
	        break;
	      case '<sz/>':
	      case '</sz>':
	        break;
	
	      case '<vertAlign':
	        if (y.val) font.vertAlign = y.val;
	        break;
	      case '<vertAlign/>':
	      case '</vertAlign>':
	        break;
	
	
	      case '<color':
	        if (!font.color) font.color = {};
	        if (y.theme) font.color.theme = y.theme;
	        if (y.tint) font.color.tint = y.tint;
	        if (y.theme && themes.themeElements && themes.themeElements.clrScheme) {
	          font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
	        }
	        if (y.rgb) font.color.rgb = y.rgb;
	        break;
	      case '<color/>':
	      case '</color>':
	        break;
	    }
	  });
	}
	
	function parse_borders(t, opts) {
	  styles.Borders = [];
	  var border = {}, sub_border = {};
	  t[0].match(tagregex).forEach(function (x) {
	    var y = parsexmltag(x);
	    switch (y[0]) {
	      case '<borders':
	      case  '<borders>':
	      case '</borders>':
	        break;
	      case '<border':
	      case '<border>':
	        border = {};
	        if (y.diagonalUp) { border.diagonalUp = y.diagonalUp; }
	        if (y.diagonalDown) { border.diagonalDown = y.diagonalDown; }
	        styles.Borders.push(border);
	
	        break;
	        break;
	      case '</border>':
	        break;
	
	      case '<left':
	        sub_border = border.left = {};
	        if (y.style) {
	          sub_border.style = y.style;
	        }
	        break;
	      case '<right':
	        sub_border = border.right = {};
	        if (y.style) {
	          sub_border.style = y.style;
	        }
	        break;
	      case '<top':
	        sub_border = border.top = {};
	        if (y.style) {
	          sub_border.style = y.style;
	        }
	        break;
	      case '<bottom':
	        sub_border = border.bottom = {};
	        if (y.style) {
	          sub_border.style = y.style;
	        }
	        break;
	      case '<diagonal':
	        sub_border = border.diagonal = {};
	        if (y.style) {
	          sub_border.style = y.style;
	        }
	        break;
	
	      case '<color':
	        sub_border.color = {};
	        if (y.theme) sub_border.color.theme = y.theme;
	        if (y.theme && themes.themeElements && themes.themeElements.clrScheme) {
	          sub_border.color.rgb = rgb_tint(themes.themeElements.clrScheme[sub_border.color.theme].rgb, sub_border.color.tint || 0);
	        }
	
	        if (y.tint) sub_border.color.tint = y.tint;
	        if (y.rgb) sub_border.color.rgb = y.rgb;
	        if (y.auto) sub_border.color.auto = y.auto;
	        break;
	      case '<name/>':
	      case '</name>':
	        break;
	      default:
	        break;
	    }
	  });
	
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, opts) {
	  styles.NumberFmt = [];
	  var k = keys(SSF._table);
	  for (var i = 0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
	  var m = t[0].match(tagregex);
	  for (i = 0; i < m.length; ++i) {
	    var y = parsexmltag(m[i]);
	    switch (y[0]) {
	      case '<numFmts':
	      case '</numFmts>':
	      case '<numFmts/>':
	      case '<numFmts>':
	        break;
	      case '<numFmt':
	      {
	        var f = unescapexml(utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
	        styles.NumberFmt[j] = f;
	        if (j > 0) SSF.load(f, j);
	      }
	        break;
	      default:
	        if (opts.WTF) throw 'unrecognized ' + y[0] + ' in numFmts';
	    }
	  }
	}
	
	function write_numFmts(NF, opts) {
	  var o = ["<numFmts>"];
	  [
	    [5, 8],
	    [23, 26],
	    [41, 44],
	    [63, 66],
	    [164, 392]
	  ].forEach(function (r) {
	    for (var i = r[0]; i <= r[1]; ++i) if (NF[i] !== undefined) o[o.length] = (writextag('numFmt', null, {numFmtId: i, formatCode: escapexml(NF[i])}));
	  });
	  if (o.length === 1) return "";
	  o[o.length] = ("</numFmts>");
	  o[0] = writextag('numFmts', null, { count: o.length - 2 }).replace("/>", ">");
	  return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	function parse_cellXfs(t, opts) {
	  styles.CellXf = [];
	  var xf;
	  t[0].match(tagregex).forEach(function (x) {
	    var y = parsexmltag(x);
	    switch (y[0]) {
	      case '<cellXfs':
	      case '<cellXfs>':
	      case '<cellXfs/>':
	      case '</cellXfs>':
	        break;
	
	      /* 18.8.45 xf CT_Xf */
	      case '<xf':
	          xf = y;
	          delete xf[0];
	        delete y[0];
	        if (xf.numFmtId) xf.numFmtId = parseInt(xf.numFmtId, 10);
	        if (xf.fillId) xf.fillId = parseInt(xf.fillId, 10);
	        styles.CellXf.push(xf);
	        break;
	      case '</xf>':
	        break;
	
	      /* 18.8.1 alignment CT_CellAlignment */
	      case '<alignment':
	      case '<alignment/>':
	        var alignment = {}
	          if (y.vertical) { alignment.vertical = y.vertical;}
	          if (y.horizontal) { alignment.horizontal = y.horizontal;}
	          if (y.textRotation != undefined) { alignment.textRotation = y.textRotation; }
	          if (y.indent) { alignment.indent = y.indent; }
	          if (y.wrapText) { alignment.wrapText = y.wrapText; }
	          xf.alignment = alignment;
	
	        break;
	
	      /* 18.8.33 protection CT_CellProtection */
	      case '<protection':
	      case '</protection>':
	      case '<protection/>':
	        break;
	
	      case '<extLst':
	      case '</extLst>':
	        break;
	      case '<ext':
	        break;
	      default:
	        if (opts.WTF) throw 'unrecognized ' + y[0] + ' in cellXfs';
	    }
	  });
	}
	
	function write_cellXfs(cellXfs) {
	  var o = [];
	  o[o.length] = (writextag('cellXfs', null));
	  cellXfs.forEach(function (c) {
	    o[o.length] = (writextag('xf', null, c));
	  });
	  o[o.length] = ("</cellXfs>");
	  if (o.length === 2) return "";
	  o[0] = writextag('cellXfs', null, {count: o.length - 2}).replace("/>", ">");
	  return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml = (function make_pstyx() {
	  var numFmtRegex = /<numFmts([^>]*)>.*<\/numFmts>/;
	  var cellXfRegex = /<cellXfs([^>]*)>.*<\/cellXfs>/;
	  var fillsRegex = /<fills([^>]*)>.*<\/fills>/;
	  var bordersRegex = /<borders([^>]*)>.*<\/borders>/;
	
	  return function parse_sty_xml(data, opts) {
	    /* 18.8.39 styleSheet CT_Stylesheet */
	    var t;
	
	    /* numFmts CT_NumFmts ? */
	    if ((t = data.match(numFmtRegex))) parse_numFmts(t, opts);
	
	    /* fonts CT_Fonts ? */
	    if ((t = data.match(/<fonts([^>]*)>.*<\/fonts>/))) parse_fonts(t, opts)
	
	    /* fills CT_Fills */
	    if ((t = data.match(fillsRegex))) parse_fills(t, opts);
	
	    /* borders CT_Borders ? */
	    if ((t = data.match(bordersRegex))) parse_borders(t, opts);
	    /* cellStyleXfs CT_CellStyleXfs ? */
	
	    /* cellXfs CT_CellXfs ? */
	    if ((t = data.match(cellXfRegex))) parse_cellXfs(t, opts);
	
	    /* dxfs CT_Dxfs ? */
	    /* tableStyles CT_TableStyles ? */
	    /* colors CT_Colors ? */
	    /* extLst CT_ExtensionList ? */
	
	    return styles;
	  };
	})();
	
	var STYLES_XML_ROOT = writextag('styleSheet', null, {
	  'xmlns': XMLNS.main[0],
	  'xmlns:vt': XMLNS.vt
	});
	
	RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
	
	function write_sty_xml(wb, opts) {
	
	  if (typeof style_builder != 'undefined' && typeof 'require' != 'undefined') {
	    return style_builder.toXml();
	  }
	
	  var o = [XML_HEADER, STYLES_XML_ROOT], w;
	  if ((w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
	  o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
	  o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
	  o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
	  o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
	  if ((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
	  o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
	  o[o.length] = ('<dxfs count="0"/>');
	  o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
	  if (o.length > 2) {
	    o[o.length] = ('</styleSheet>');
	    o[1] = o[1].replace("/>", ">");
	  }
	  return o.join("");
	}
	/* [MS-XLSB] 2.4.651 BrtFmt */
	function parse_BrtFmt(data, length) {
		var ifmt = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [ifmt, stFmtCode];
	}
	
	/* [MS-XLSB] 2.4.653 BrtFont TODO */
	function parse_BrtFont(data, length) {
		var out = {flags:{}};
		out.dyHeight = data.read_shift(2);
		out.grbit = parse_FontFlags(data, 2);
		out.bls = data.read_shift(2);
		out.sss = data.read_shift(2);
		out.uls = data.read_shift(1);
		out.bFamily = data.read_shift(1);
		out.bCharSet = data.read_shift(1);
		data.l++;
		out.brtColor = parse_BrtColor(data, 8);
		out.bFontScheme = data.read_shift(1);
		out.name = parse_XLWideString(data, length - 21);
	
		out.flags.Bold = out.bls === 0x02BC;
		out.flags.Italic = out.grbit.fItalic;
		out.flags.Strikeout = out.grbit.fStrikeout;
		out.flags.Outline = out.grbit.fOutline;
		out.flags.Shadow = out.grbit.fShadow;
		out.flags.Condense = out.grbit.fCondense;
		out.flags.Extend = out.grbit.fExtend;
		out.flags.Sub = out.sss & 0x2;
		out.flags.Sup = out.sss & 0x1;
		return out;
	}
	
	/* [MS-XLSB] 2.4.816 BrtXF */
	function parse_BrtXF(data, length) {
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		parsenoop(data, length-4);
		return {ixfe:ixfeParent, ifmt:ifmt };
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, opts) {
		styles.NumberFmt = [];
		for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];
	
		styles.CellXf = [];
		var state = ""; /* TODO: this should be a stack */
		var pass = false;
		recordhopper(data, function hopper_sty(val, R, RT) {
			switch(R.n) {
				case 'BrtFmt':
					styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
					break;
				case 'BrtFont': break; /* TODO */
				case 'BrtKnownFonts': break; /* TODO */
				case 'BrtFill': break; /* TODO */
				case 'BrtBorder': break; /* TODO */
				case 'BrtXF':
					if(state === "CELLXFS") {
						styles.CellXf.push(val);
					}
					break; /* TODO */
				case 'BrtStyle': break; /* TODO */
				case 'BrtDXF': break; /* TODO */
				case 'BrtMRUColor': break; /* TODO */
				case 'BrtIndexedColor': break; /* TODO */
				case 'BrtBeginStyleSheet': break;
				case 'BrtEndStyleSheet': break;
				case 'BrtBeginTableStyle': break;
				case 'BrtTableStyleElement': break;
				case 'BrtEndTableStyle': break;
				case 'BrtBeginFmts': state = "FMTS"; break;
				case 'BrtEndFmts': state = ""; break;
				case 'BrtBeginFonts': state = "FONTS"; break;
				case 'BrtEndFonts': state = ""; break;
				case 'BrtACBegin': state = "ACFONTS"; break;
				case 'BrtACEnd': state = ""; break;
				case 'BrtBeginFills': state = "FILLS"; break;
				case 'BrtEndFills': state = ""; break;
				case 'BrtBeginBorders': state = "BORDERS"; break;
				case 'BrtEndBorders': state = ""; break;
				case 'BrtBeginCellStyleXFs': state = "CELLSTYLEXFS"; break;
				case 'BrtEndCellStyleXFs': state = ""; break;
				case 'BrtBeginCellXFs': state = "CELLXFS"; break;
				case 'BrtEndCellXFs': state = ""; break;
				case 'BrtBeginStyles': state = "STYLES"; break;
				case 'BrtEndStyles': state = ""; break;
				case 'BrtBeginDXFs': state = "DXFS"; break;
				case 'BrtEndDXFs': state = ""; break;
				case 'BrtBeginTableStyles': state = "TABLESTYLES"; break;
				case 'BrtEndTableStyles': state = ""; break;
				case 'BrtBeginColorPalette': state = "COLORPALETTE"; break;
				case 'BrtEndColorPalette': state = ""; break;
				case 'BrtBeginIndexedColors': state = "INDEXEDCOLORS"; break;
				case 'BrtEndIndexedColors': state = ""; break;
				case 'BrtBeginMRUColors': state = "MRUCOLORS"; break;
				case 'BrtEndMRUColors': state = ""; break;
				case 'BrtFRTBegin': pass = true; break;
				case 'BrtFRTEnd': pass = false; break;
				case 'BrtBeginStyleSheetExt14': break;
				case 'BrtBeginSlicerStyles': break;
				case 'BrtEndSlicerStyles': break;
				case 'BrtBeginTimelineStylesheetExt15': break;
				case 'BrtEndTimelineStylesheetExt15': break;
				case 'BrtBeginTimelineStyles': break;
				case 'BrtEndTimelineStyles': break;
				case 'BrtEndStyleSheetExt14': break;
				default: if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n);
			}
		});
		return styles;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(data, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginStyleSheet");
		/* [FMTS] */
		/* [FONTS] */
		/* [FILLS] */
		/* [BORDERS] */
		/* CELLSTYLEXFS */
		/* CELLXFS*/
		/* STYLES */
		/* DXFS */
		/* TABLESTYLES */
		/* [COLORPALETTE] */
		/* FRTSTYLESHEET*/
		write_record(ba, "BrtEndStyleSheet");
		return ba.end();
	}
	RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
	
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		t[0].match(tagregex).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr': color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr': color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.9 dk1 (Dark 1) */
				case '<a:dk1>':
				case '</a:dk1>':
				/* 20.1.4.1.10 dk2 (Dark 2) */
				case '<a:dk2>':
				case '</a:dk2>':
				/* 20.1.4.1.22 lt1 (Light 1) */
				case '<a:lt1>':
				case '</a:lt1>':
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:lt2>':
				case '</a:lt2>':
				/* 20.1.4.1.1 accent1 (Accent 1) */
				case '<a:accent1>':
				case '</a:accent1>':
				/* 20.1.4.1.2 accent2 (Accent 2) */
				case '<a:accent2>':
				case '</a:accent2>':
				/* 20.1.4.1.3 accent3 (Accent 3) */
				case '<a:accent3>':
				case '</a:accent3>':
				/* 20.1.4.1.4 accent4 (Accent 4) */
				case '<a:accent4>':
				case '</a:accent4>':
				/* 20.1.4.1.5 accent5 (Accent 5) */
				case '<a:accent5>':
				case '</a:accent5>':
				/* 20.1.4.1.6 accent6 (Accent 6) */
				case '<a:accent6>':
				case '</a:accent6>':
				/* 20.1.4.1.19 hlink (Hyperlink) */
				case '<a:hlink>':
				case '</a:hlink>':
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				case '<a:folHlink>':
				case '</a:folHlink>':
					if (y[0][1] === '/') {
						themes.themeElements.clrScheme.push(color);
						color = {};
					} else {
						color.name = y[0].substring(3, y[0].length - 1);
					}
					break;
	
				default: if(opts.WTF) throw 'unrecognized ' + y[0] + ' in clrScheme';
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme(t, opts) { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme(t, opts) { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[^\u2603]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[^\u2603]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[^\u2603]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw m[0] + ' not found in themeElements';
			m[2](t, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[^\u2603]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) return themes;
	
		var t;
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw 'themeElements not found in theme';
		parse_themeElements(t[0], opts);
	
		return themes;
	}
	
	//function write_theme() { return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults><a:spDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style></a:spDef><a:lnDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style></a:lnDef></a:objectDefaults><a:extraClrSchemeLst/></a:theme>'; }
	function write_theme(opts) {
	  if (opts.themeXml) { return opts.themeXml; }
	  return '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme"><a:themeElements><a:clrScheme name="Office"><a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1><a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1><a:dk2><a:srgbClr val="1F497D"/></a:dk2><a:lt2><a:srgbClr val="EEECE1"/></a:lt2><a:accent1><a:srgbClr val="4F81BD"/></a:accent1><a:accent2><a:srgbClr val="C0504D"/></a:accent2><a:accent3><a:srgbClr val="9BBB59"/></a:accent3><a:accent4><a:srgbClr val="8064A2"/></a:accent4><a:accent5><a:srgbClr val="4BACC6"/></a:accent5><a:accent6><a:srgbClr val="F79646"/></a:accent6><a:hlink><a:srgbClr val="0000FF"/></a:hlink><a:folHlink><a:srgbClr val="800080"/></a:folHlink></a:clrScheme><a:fontScheme name="Office"><a:majorFont><a:latin typeface="Cambria"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Times New Roman"/><a:font script="Hebr" typeface="Times New Roman"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="MoolBoran"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Times New Roman"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:majorFont><a:minorFont><a:latin typeface="Calibri"/><a:ea typeface=""/><a:cs typeface=""/><a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/><a:font script="Hang" typeface="맑은 고딕"/><a:font script="Hans" typeface="宋体"/><a:font script="Hant" typeface="新細明體"/><a:font script="Arab" typeface="Arial"/><a:font script="Hebr" typeface="Arial"/><a:font script="Thai" typeface="Tahoma"/><a:font script="Ethi" typeface="Nyala"/><a:font script="Beng" typeface="Vrinda"/><a:font script="Gujr" typeface="Shruti"/><a:font script="Khmr" typeface="DaunPenh"/><a:font script="Knda" typeface="Tunga"/><a:font script="Guru" typeface="Raavi"/><a:font script="Cans" typeface="Euphemia"/><a:font script="Cher" typeface="Plantagenet Cherokee"/><a:font script="Yiii" typeface="Microsoft Yi Baiti"/><a:font script="Tibt" typeface="Microsoft Himalaya"/><a:font script="Thaa" typeface="MV Boli"/><a:font script="Deva" typeface="Mangal"/><a:font script="Telu" typeface="Gautami"/><a:font script="Taml" typeface="Latha"/><a:font script="Syrc" typeface="Estrangelo Edessa"/><a:font script="Orya" typeface="Kalinga"/><a:font script="Mlym" typeface="Kartika"/><a:font script="Laoo" typeface="DokChampa"/><a:font script="Sinh" typeface="Iskoola Pota"/><a:font script="Mong" typeface="Mongolian Baiti"/><a:font script="Viet" typeface="Arial"/><a:font script="Uigh" typeface="Microsoft Uighur"/><a:font script="Geor" typeface="Sylfaen"/></a:minorFont></a:fontScheme><a:fmtScheme name="Office"><a:fillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="1"/></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs></a:gsLst><a:lin ang="16200000" scaled="0"/></a:gradFill></a:fillStyleLst><a:lnStyleLst><a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln><a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln></a:lnStyleLst><a:effectStyleLst><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst></a:effectStyle><a:effectStyle><a:effectLst><a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw></a:effectLst><a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d><a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d></a:effectStyle></a:effectStyleLst><a:bgFillStyleLst><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path></a:gradFill><a:gradFill rotWithShape="1"><a:gsLst><a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs><a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs></a:gsLst><a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path></a:gradFill></a:bgFillStyleLst></a:fmtScheme></a:themeElements><a:objectDefaults><a:spDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style></a:spDef><a:lnDef><a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style></a:lnDef></a:objectDefaults><a:extraClrSchemeLst/></a:theme>';
	}/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length) {
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		blob.l += length-4;
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob, length) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob, length) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.108 */
	function parse_ExtProp(blob, length) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2);
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 5 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x07: case 0x08: case 0x09: case 0x0a: break;
				case 0x0d: break; /* text color */
				case 0x0e: break; /* font scheme */
				default: throw "bafuq" + xfe[0].toString(16);
			}
		});
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data, opts) {
		var d = [];
		var l = 0, i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	function write_cc_xml(data, opts) { }
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data, length) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R, RT) {
			switch(R.n) {
				case 'BrtCalcChainItem$': out.push(val); break;
				case 'BrtBeginCalcChain$': break;
				case 'BrtEndCalcChain$': break;
				default: if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n);
			}
		});
		return out;
	}
	
	function write_cc_bin(data, opts) { }
	
	function parse_comments(zip, dirComments, sheets, sheetRels, opts) {
		for(var i = 0; i != dirComments.length; ++i) {
			var canonicalpath=dirComments[i];
			var comments=parse_cmnt(getzipdata(zip, canonicalpath.replace(/^\//,''), true), canonicalpath, opts);
			if(!comments || !comments.length) continue;
			// find the sheets targeted by these comments
			var sheetNames = keys(sheets);
			for(var j = 0; j != sheetNames.length; ++j) {
				var sheetName = sheetNames[j];
				var rels = sheetRels[sheetName];
				if(rels) {
					var rel = rels[canonicalpath];
					if(rel) insertCommentsIntoSheet(sheetName, sheets[sheetName], comments);
				}
			}
		}
	}
	
	function insertCommentsIntoSheet(sheetName, sheet, comments) {
		comments.forEach(function(comment) {
			var cell = sheet[comment.ref];
			if (!cell) {
				cell = {};
				sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				var thisCell = decode_cell(comment.ref);
				if(range.s.r > thisCell.r) range.s.r = thisCell.r;
				if(range.e.r < thisCell.r) range.e.r = thisCell.r;
				if(range.s.c > thisCell.c) range.s.c = thisCell.c;
				if(range.e.c < thisCell.c) range.e.c = thisCell.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = {a: comment.author, t: comment.t, r: comment.r};
			if(comment.h) o.h = comment.h;
			cell.c.push(o);
		});
	}
	
	/* 18.7.3 CT_Comment */
	function parse_comments_xml(data, opts) {
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		data.match(/<(?:\w+:)?authors>([^\u2603]*)<\/(?:\w+:)?authors>/)[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			authors.push(x.match(/<(?:\w+:)?author[^>]*>(.*)/)[1]);
		});
		(data.match(/<(?:\w+:)?commentList>([^\u2603]*)<\/(?:\w+:)?commentList>/)||["",""])[1].split(/<\/\w*:?comment>/).forEach(function(x, index) {
			if(x === "" || x.trim() === "") return;
			var y = parsexmltag(x.match(/<(?:\w+:)?comment[^>]*>/)[0]);
			var comment = { author: y.authorId && authors[y.authorId] ? authors[y.authorId] : undefined, ref: y.ref, guid: y.guid };
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<text>([^\u2603]*)<\/text>/);
			if (!textMatch || !textMatch[1]) return; // a comment may contain an empty text tag.
			var rt = parse_si(textMatch[1]);
			comment.r = rt.r;
			comment.t = rt.t;
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	function write_comments_xml(data, opts) { }
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data, length) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	
	/* [MS-XLSB] 2.4.324 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	
	/* [MS-XLSB] 2.4.325 BrtCommentText */
	var parse_BrtCommentText = parse_RichStr;
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R, RT) {
			switch(R.n) {
				case 'BrtCommentAuthor': authors.push(val); break;
				case 'BrtBeginComment': c = val; break;
				case 'BrtCommentText': c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 'BrtEndComment':
					c.author = authors[c.iauthor];
					delete c.iauthor;
					if(opts.sheetRows && opts.sheetRows <= c.rfx.r) break;
					delete c.rfx; out.push(c); break;
				case 'BrtBeginComments': break;
				case 'BrtEndComments': break;
				case 'BrtBeginCommentAuthors': break;
				case 'BrtEndCommentAuthors': break;
				case 'BrtBeginCommentList': break;
				case 'BrtEndCommentList': break;
				default: if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R.n);
			}
		});
		return out;
	}
	
	function write_comments_bin(data, opts) { }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z])R(\[?)(-?\d+|)\]?C(\[?)(-?\d+|)\]?/g;
		var rcbase;
		function rcfunc($$,$1,$2,$3,$4,$5) {
			var R = $3.length>0?parseInt($3,10)|0:0, C = $5.length>0?parseInt($5,10)|0:0;
			if(C<0 && $4.length === 0) C=0;
			if($4.length > 0) C += rcbase.c;
			if($2.length > 0) R += rcbase.r;
			return $1 + encode_col(C) + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	/* --- formula references point to MS-XLS --- */
	/* Small helpers */
	function parseread(l) { return function(blob, length) { blob.l+=l; return; }; }
	function parseread1(blob, length) { blob.l+=1; return; }
	
	/* Rgce Helpers */
	
	/* 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* 2.5.198.105 */
	function parse_RgceArea(blob, length) {
		var r=blob.read_shift(2), R=blob.read_shift(2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* 2.5.198.105 TODO */
	function parse_RgceAreaRel(blob, length) {
		var r=blob.read_shift(2), R=blob.read_shift(2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* 2.5.198.109 */
	function parse_RgceLoc(blob, length) {
		var r = blob.read_shift(2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	
	/* 2.5.198.111 */
	function parse_RgceLocRel(blob, length) {
		var r = blob.read_shift(2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x8000) >> 15, rRel = (cl & 0x4000) >> 14;
		cl &= 0x3FFF;
		if(cRel !== 0) while(cl >= 0x100) cl -= 0x100;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	
	/* Ptg Tokens */
	
	/* 2.5.198.27 */
	function parse_PtgArea(blob, length) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, 8);
		return [type, area];
	}
	
	/* 2.5.198.28 */
	function parse_PtgArea3d(blob, length) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var area = parse_RgceArea(blob, 8);
		return [type, ixti, area];
	}
	
	/* 2.5.198.29 */
	function parse_PtgAreaErr(blob, length) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += 8;
		return [type];
	}
	/* 2.5.198.30 */
	function parse_PtgAreaErr3d(blob, length) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		blob.l += 8;
		return [type, ixti];
	}
	
	/* 2.5.198.31 */
	function parse_PtgAreaN(blob, length) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, 8);
		return [type, area];
	}
	
	/* 2.5.198.32 -- ignore this and look in PtgExtraArray for shape + values */
	function parse_PtgArray(blob, length) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += 7;
		return [type];
	}
	
	/* 2.5.198.33 */
	function parse_PtgAttrBaxcel(blob, length) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* 2.5.198.34 */
	function parse_PtgAttrChoose(blob, length) {
		blob.l +=2;
		var offset = blob.read_shift(2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(2));
		return o;
	}
	
	/* 2.5.198.35 */
	function parse_PtgAttrGoto(blob, length) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(2)];
	}
	
	/* 2.5.198.36 */
	function parse_PtgAttrIf(blob, length) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* 2.5.198.37 */
	function parse_PtgAttrSemi(blob, length) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 4;
		return [bitSemi];
	}
	
	/* 2.5.198.40 (used by PtgAttrSpace and PtgAttrSpaceSemi) */
	function parse_PtgAttrSpaceType(blob, length) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* 2.5.198.38 */
	function parse_PtgAttrSpace(blob, length) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* 2.5.198.39 */
	function parse_PtgAttrSpaceSemi(blob, length) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* 2.5.198.84 TODO */
	function parse_PtgRef(blob, length) {
		var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob,4);
		return [type, loc];
	}
	
	/* 2.5.198.88 TODO */
	function parse_PtgRefN(blob, length) {
		var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob,4);
		return [type, loc];
	}
	
	/* 2.5.198.85 TODO */
	function parse_PtgRef3d(blob, length) {
		var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		var loc = parse_RgceLoc(blob,4);
		return [type, ixti, loc];
	}
	
	
	/* 2.5.198.62 TODO */
	function parse_PtgFunc(blob, length) {
		var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(2);
		return [FtabArgc[iftab], Ftab[iftab]];
	}
	/* 2.5.198.63 TODO */
	function parse_PtgFuncVar(blob, length) {
		blob.l++;
		var cparams = blob.read_shift(1), tab = parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob, length) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* 2.5.198.41 */
	var parse_PtgAttrSum = parseread(4);
	/* 2.5.198.43 */
	var parse_PtgConcat = parseread1;
	
	/* 2.5.198.58 */
	function parse_PtgExp(blob, length) {
		blob.l++;
		var row = blob.read_shift(2);
		var col = blob.read_shift(2);
		return [row, col];
	}
	
	/* 2.5.198.57 */
	function parse_PtgErr(blob, length) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* 2.5.198.66 TODO */
	function parse_PtgInt(blob, length) { blob.l++; return blob.read_shift(2); }
	
	/* 2.5.198.42 */
	function parse_PtgBool(blob, length) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* 2.5.198.79 */
	function parse_PtgNum(blob, length) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* 2.5.198.89 */
	function parse_PtgStr(blob, length) { blob.l++; return parse_ShortXLUnicodeString(blob); }
	
	/* 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	function parse_SerAr(blob) {
		var val = [];
		switch((val[0] = blob.read_shift(1))) {
			/* 2.5.192.113 */
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				blob.l += 7; break;
			/* 2.5.192.114 */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += 8; break;
			/* 2.5.192.115 */
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			/* 2.5.192.116 */
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			/* 2.5.192.117 */
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString(blob); break;
			// default: throw "Bad SerAr: " + val[0]; /* Unreachable */
		}
		return val;
	}
	
	/* 2.5.198.61 */
	function parse_PtgExtraMem(blob, cce) {
		var count = blob.read_shift(2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(parse_Ref8U(blob, 8));
		return out;
	}
	
	/* 2.5.198.59 */
	function parse_PtgExtraArray(blob) {
		var cols = 1 + blob.read_shift(1); //DColByteU
		var rows = 1 + blob.read_shift(2); //DRw
		for(var i = 0, o=[]; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob);
		return o;
	}
	
	/* 2.5.198.76 */
	function parse_PtgName(blob, length) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var nameindex = blob.read_shift(4);
		return [type, 0, nameindex];
	}
	
	/* 2.5.198.77 */
	function parse_PtgNameX(blob, length) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	
	/* 2.5.198.70 */
	function parse_PtgMemArea(blob, length) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	
	/* 2.5.198.72 */
	function parse_PtgMemFunc(blob, length) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	
	
	/* 2.5.198.86 */
	function parse_PtgRefErr(blob, length) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		return [type];
	}
	
	/* 2.5.198.26 */
	var parse_PtgAdd = parseread1;
	/* 2.5.198.45 */
	var parse_PtgDiv = parseread1;
	/* 2.5.198.56 */
	var parse_PtgEq = parseread1;
	/* 2.5.198.64 */
	var parse_PtgGe = parseread1;
	/* 2.5.198.65 */
	var parse_PtgGt = parseread1;
	/* 2.5.198.67 */
	var parse_PtgIsect = parseread1;
	/* 2.5.198.68 */
	var parse_PtgLe = parseread1;
	/* 2.5.198.69 */
	var parse_PtgLt = parseread1;
	/* 2.5.198.74 */
	var parse_PtgMissArg = parseread1;
	/* 2.5.198.75 */
	var parse_PtgMul = parseread1;
	/* 2.5.198.78 */
	var parse_PtgNe = parseread1;
	/* 2.5.198.80 */
	var parse_PtgParen = parseread1;
	/* 2.5.198.81 */
	var parse_PtgPercent = parseread1;
	/* 2.5.198.82 */
	var parse_PtgPower = parseread1;
	/* 2.5.198.83 */
	var parse_PtgRange = parseread1;
	/* 2.5.198.90 */
	var parse_PtgSub = parseread1;
	/* 2.5.198.93 */
	var parse_PtgUminus = parseread1;
	/* 2.5.198.94 */
	var parse_PtgUnion = parseread1;
	/* 2.5.198.95 */
	var parse_PtgUplus = parseread1;
	
	/* 2.5.198.71 */
	var parse_PtgMemErr = parsenoop;
	/* 2.5.198.73 */
	var parse_PtgMemNoMem = parsenoop;
	/* 2.5.198.87 */
	var parse_PtgRefErr3d = parsenoop;
	/* 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	/* 2.5.198.25 */
	var PtgTypes = {
		0x01: { n:'PtgExp', f:parse_PtgExp },
		0x02: { n:'PtgTbl', f:parse_PtgTbl },
		0x03: { n:'PtgAdd', f:parse_PtgAdd },
		0x04: { n:'PtgSub', f:parse_PtgSub },
		0x05: { n:'PtgMul', f:parse_PtgMul },
		0x06: { n:'PtgDiv', f:parse_PtgDiv },
		0x07: { n:'PtgPower', f:parse_PtgPower },
		0x08: { n:'PtgConcat', f:parse_PtgConcat },
		0x09: { n:'PtgLt', f:parse_PtgLt },
		0x0A: { n:'PtgLe', f:parse_PtgLe },
		0x0B: { n:'PtgEq', f:parse_PtgEq },
		0x0C: { n:'PtgGe', f:parse_PtgGe },
		0x0D: { n:'PtgGt', f:parse_PtgGt },
		0x0E: { n:'PtgNe', f:parse_PtgNe },
		0x0F: { n:'PtgIsect', f:parse_PtgIsect },
		0x10: { n:'PtgUnion', f:parse_PtgUnion },
		0x11: { n:'PtgRange', f:parse_PtgRange },
		0x12: { n:'PtgUplus', f:parse_PtgUplus },
		0x13: { n:'PtgUminus', f:parse_PtgUminus },
		0x14: { n:'PtgPercent', f:parse_PtgPercent },
		0x15: { n:'PtgParen', f:parse_PtgParen },
		0x16: { n:'PtgMissArg', f:parse_PtgMissArg },
		0x17: { n:'PtgStr', f:parse_PtgStr },
		0x1C: { n:'PtgErr', f:parse_PtgErr },
		0x1D: { n:'PtgBool', f:parse_PtgBool },
		0x1E: { n:'PtgInt', f:parse_PtgInt },
		0x1F: { n:'PtgNum', f:parse_PtgNum },
		0x20: { n:'PtgArray', f:parse_PtgArray },
		0x21: { n:'PtgFunc', f:parse_PtgFunc },
		0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
		0x23: { n:'PtgName', f:parse_PtgName },
		0x24: { n:'PtgRef', f:parse_PtgRef },
		0x25: { n:'PtgArea', f:parse_PtgArea },
		0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
		0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
		0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
		0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
		0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
		0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
		0x2C: { n:'PtgRefN', f:parse_PtgRefN },
		0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
		0x39: { n:'PtgNameX', f:parse_PtgNameX },
		0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
		0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
		0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
		0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
		0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
		0x40: 0x20, 0x60: 0x20,
		0x41: 0x21, 0x61: 0x21,
		0x42: 0x22, 0x62: 0x22,
		0x43: 0x23, 0x63: 0x23,
		0x44: 0x24, 0x64: 0x24,
		0x45: 0x25, 0x65: 0x25,
		0x46: 0x26, 0x66: 0x26,
		0x47: 0x27, 0x67: 0x27,
		0x48: 0x28, 0x68: 0x28,
		0x49: 0x29, 0x69: 0x29,
		0x4A: 0x2A, 0x6A: 0x2A,
		0x4B: 0x2B, 0x6B: 0x2B,
		0x4C: 0x2C, 0x6C: 0x2C,
		0x4D: 0x2D, 0x6D: 0x2D,
		0x59: 0x39, 0x79: 0x39,
		0x5A: 0x3A, 0x7A: 0x3A,
		0x5B: 0x3B, 0x7B: 0x3B,
		0x5C: 0x3C, 0x7C: 0x3C,
		0x5D: 0x3D, 0x7D: 0x3D
	};
	(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();
	
	var Ptg18 = {};
	var Ptg19 = {
		0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
		0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
		0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
		0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
		0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
		0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
		0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
		0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
		0xFF: {}
	};
	
	/* 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		blob.read_shift(1);
		var chn = blob.read_shift(4);
		var cbf = "";
		if(opts.biff === 5) blob.l += length-20;
		else cbf = parse_XLSCellParsedFormula(blob, length-20, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	
	/* 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
	}
	
	/* 2.5.198.103 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1]);
					o.push(rgce[i][2]);
					break;
				default: break;
			}
		}
		length = target - blob.l;
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce);
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, length - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts, ref) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce);
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* 2.5.198.104 */
	function parse_Rgce(blob, length) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id];
			//console.log("ptg", id, R)
			if(id === 0x18 || id === 0x19) {
				id = blob[blob.l + 1];
				R = (id === 0x18 ? Ptg18 : Ptg19)[id];
			}
			if(!R || !R.f) { ptgs.push(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length)]); }
		}
		return ptgs;
	}
	
	function mapper(x) { return x.map(function f2(y) { return y[1];}).join(",");}
	
	/* 2.2.2 + Magic TODO */
	function stringify_formula(formula, range, cell, supbooks, opts) {
		if(opts !== undefined && opts.biff === 5) return "BIFF5??";
		var _range = range !== undefined ? range : {s:{c:0, r:0}};
		var stack = [], e1, e2, type, c, ixti, nameidx, r;
		if(!formula[0] || !formula[0][0]) return "";
		//console.log("--",cell,formula[0])
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			//console.log("++",f, stack)
			switch(f[0]) {
			/* 2.2.2.1 Unary Operator Tokens */
				/* 2.5.198.93 */
				case 'PtgUminus': stack.push("-" + stack.pop()); break;
				/* 2.5.198.95 */
				case 'PtgUplus': stack.push("+" + stack.pop()); break;
				/* 2.5.198.81 */
				case 'PtgPercent': stack.push(stack.pop() + "%"); break;
	
			/* 2.2.2.1 Binary Value Operator Token */
				/* 2.5.198.26 */
				case 'PtgAdd':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"+"+e1);
					break;
				/* 2.5.198.90 */
				case 'PtgSub':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"-"+e1);
					break;
				/* 2.5.198.75 */
				case 'PtgMul':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"*"+e1);
					break;
				/* 2.5.198.45 */
				case 'PtgDiv':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"/"+e1);
					break;
				/* 2.5.198.82 */
				case 'PtgPower':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"^"+e1);
					break;
				/* 2.5.198.43 */
				case 'PtgConcat':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"&"+e1);
					break;
				/* 2.5.198.69 */
				case 'PtgLt':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"<"+e1);
					break;
				/* 2.5.198.68 */
				case 'PtgLe':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"<="+e1);
					break;
				/* 2.5.198.56 */
				case 'PtgEq':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"="+e1);
					break;
				/* 2.5.198.64 */
				case 'PtgGe':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+">="+e1);
					break;
				/* 2.5.198.65 */
				case 'PtgGt':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+">"+e1);
					break;
				/* 2.5.198.78 */
				case 'PtgNe':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+"<>"+e1);
					break;
	
			/* 2.2.2.1 Binary Reference Operator Token */
				/* 2.5.198.67 */
				case 'PtgIsect':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion':
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': break;
	
			/* 2.2.2.3 Control Tokens "can be ignored" */
				/* 2.5.198.34 */
				case 'PtgAttrChoose': break;
				/* 2.5.198.35 */
				case 'PtgAttrGoto': break;
				/* 2.5.198.36 */
				case 'PtgAttrIf': break;
	
	
				/* 2.5.198.84 */
				case 'PtgRef':
					type = f[1][0]; c = shift_cell_xls(decode_cell(encode_cell(f[1][1])), _range);
					stack.push(encode_cell(c));
					break;
				/* 2.5.198.88 */
				case 'PtgRefN':
					type = f[1][0]; c = shift_cell_xls(decode_cell(encode_cell(f[1][1])), cell);
					stack.push(encode_cell(c));
					break;
				case 'PtgRef3d': // TODO: lots of stuff
					type = f[1][0]; ixti = f[1][1]; c = shift_cell_xls(f[1][2], _range);
					stack.push(supbooks[1][ixti+1]+"!"+encode_cell(c));
					break;
	
			/* Function Call */
				/* 2.5.198.62 */
				case 'PtgFunc':
				/* 2.5.198.63 */
				case 'PtgFuncVar':
					/* f[1] = [argc, func] */
					var argc = f[1][0], func = f[1][1];
					if(!argc) argc = 0;
					var args = stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				/* 2.5.198.42 */
				case 'PtgBool': stack.push(f[1] ? "TRUE" : "FALSE"); break;
				/* 2.5.198.66 */
				case 'PtgInt': stack.push(f[1]); break;
				/* 2.5.198.79 TODO: precision? */
				case 'PtgNum': stack.push(String(f[1])); break;
				/* 2.5.198.89 */
				case 'PtgStr': stack.push('"' + f[1] + '"'); break;
				/* 2.5.198.57 */
				case 'PtgErr': stack.push(f[1]); break;
				/* 2.5.198.27 TODO: fixed points */
				case 'PtgArea':
					type = f[1][0]; r = shift_range_xls(f[1][1], _range);
					stack.push(encode_range(r));
					break;
				/* 2.5.198.28 */
				case 'PtgArea3d': // TODO: lots of stuff
					type = f[1][0]; ixti = f[1][1]; r = f[1][2];
					stack.push(supbooks[1][ixti+1]+"!"+encode_range(r));
					break;
				/* 2.5.198.41 */
				case 'PtgAttrSum':
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
			/* Expression Prefixes */
				/* 2.5.198.37 */
				case 'PtgAttrSemi': break;
	
				/* 2.5.97.60 TODO: do something different for revisions */
				case 'PtgName':
					/* f[1] = type, 0, nameindex */
					nameidx = f[1][2];
					var lbl = supbooks[0][nameidx];
					var name = lbl.Name;
					if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
					stack.push(name);
					break;
	
				/* 2.5.97.61 TODO: do something different for revisions */
				case 'PtgNameX':
					/* f[1] = type, ixti, nameindex */
					var bookidx = f[1][1]; nameidx = f[1][2]; var externbook;
					/* TODO: Properly handle missing values */
					if(supbooks[bookidx+1]) externbook = supbooks[bookidx+1][nameidx];
					else if(supbooks[bookidx-1]) externbook = supbooks[bookidx-1][nameidx];
					if(!externbook) externbook = {body: "??NAMEX??"};
					stack.push(externbook.body);
					break;
	
			/* 2.2.2.4 Display Tokens */
				/* 2.5.198.80 */
				case 'PtgParen': stack.push('(' + stack.pop() + ')'); break;
	
				/* 2.5.198.86 */
				case 'PtgRefErr': stack.push('#REF!'); break;
	
			/* */
				/* 2.5.198.58 TODO */
				case 'PtgExp':
					c = {c:f[1][1],r:f[1][0]};
					var q = {c: cell.c, r:cell.r};
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					}
					else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				/* 2.5.198.32 TODO */
				case 'PtgArray':
					stack.push("{" + f[1].map(mapper).join(";") + "}");
					break;
	
			/* 2.2.2.5 Mem Tokens */
				/* 2.5.198.70 TODO: confirm this is a non-display */
				case 'PtgMemArea':
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				/* 2.5.198.38 TODO */
				case 'PtgAttrSpace': break;
	
				/* 2.5.198.92 TODO */
				case 'PtgTbl': break;
	
				/* 2.5.198.71 */
				case 'PtgMemErr': break;
	
				/* 2.5.198.74 */
				case 'PtgMissArg':
					stack.push("");
					break;
	
				/* 2.5.198.29 TODO */
				case 'PtgAreaErr': break;
	
				/* 2.5.198.31 TODO */
				case 'PtgAreaN': stack.push(""); break;
	
				/* 2.5.198.87 TODO */
				case 'PtgRefErr3d': break;
	
				/* 2.5.198.72 TODO */
				case 'PtgMemFunc': break;
	
				default: throw 'Unrecognized Formula Token: ' + f;
			}
			//console.log("::",f, stack)
		}
		//console.log("--",stack);
		return stack[0];
	}
	
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula TODO: use similar logic to js-xls */
	function parse_XLSBCellParsedFormula(data, length) {
		var cce = data.read_shift(4);
		return parsenoop(data, length-4);
	}
	/* [MS-XLS] 2.5.198.44 */
	var PtgDataType = {
		0x1: "REFERENCE", // reference to range
		0x2: "VALUE", // single value
		0x3: "ARRAY" // array of values
	};
	
	/* [MS-XLS] 2.5.198.4 */
	var Cetab = {
		0x0000: 'BEEP',
		0x0001: 'OPEN',
		0x0002: 'OPEN.LINKS',
		0x0003: 'CLOSE.ALL',
		0x0004: 'SAVE',
		0x0005: 'SAVE.AS',
		0x0006: 'FILE.DELETE',
		0x0007: 'PAGE.SETUP',
		0x0008: 'PRINT',
		0x0009: 'PRINTER.SETUP',
		0x000A: 'QUIT',
		0x000B: 'NEW.WINDOW',
		0x000C: 'ARRANGE.ALL',
		0x000D: 'WINDOW.SIZE',
		0x000E: 'WINDOW.MOVE',
		0x000F: 'FULL',
		0x0010: 'CLOSE',
		0x0011: 'RUN',
		0x0016: 'SET.PRINT.AREA',
		0x0017: 'SET.PRINT.TITLES',
		0x0018: 'SET.PAGE.BREAK',
		0x0019: 'REMOVE.PAGE.BREAK',
		0x001A: 'FONT',
		0x001B: 'DISPLAY',
		0x001C: 'PROTECT.DOCUMENT',
		0x001D: 'PRECISION',
		0x001E: 'A1.R1C1',
		0x001F: 'CALCULATE.NOW',
		0x0020: 'CALCULATION',
		0x0022: 'DATA.FIND',
		0x0023: 'EXTRACT',
		0x0024: 'DATA.DELETE',
		0x0025: 'SET.DATABASE',
		0x0026: 'SET.CRITERIA',
		0x0027: 'SORT',
		0x0028: 'DATA.SERIES',
		0x0029: 'TABLE',
		0x002A: 'FORMAT.NUMBER',
		0x002B: 'ALIGNMENT',
		0x002C: 'STYLE',
		0x002D: 'BORDER',
		0x002E: 'CELL.PROTECTION',
		0x002F: 'COLUMN.WIDTH',
		0x0030: 'UNDO',
		0x0031: 'CUT',
		0x0032: 'COPY',
		0x0033: 'PASTE',
		0x0034: 'CLEAR',
		0x0035: 'PASTE.SPECIAL',
		0x0036: 'EDIT.DELETE',
		0x0037: 'INSERT',
		0x0038: 'FILL.RIGHT',
		0x0039: 'FILL.DOWN',
		0x003D: 'DEFINE.NAME',
		0x003E: 'CREATE.NAMES',
		0x003F: 'FORMULA.GOTO',
		0x0040: 'FORMULA.FIND',
		0x0041: 'SELECT.LAST.CELL',
		0x0042: 'SHOW.ACTIVE.CELL',
		0x0043: 'GALLERY.AREA',
		0x0044: 'GALLERY.BAR',
		0x0045: 'GALLERY.COLUMN',
		0x0046: 'GALLERY.LINE',
		0x0047: 'GALLERY.PIE',
		0x0048: 'GALLERY.SCATTER',
		0x0049: 'COMBINATION',
		0x004A: 'PREFERRED',
		0x004B: 'ADD.OVERLAY',
		0x004C: 'GRIDLINES',
		0x004D: 'SET.PREFERRED',
		0x004E: 'AXES',
		0x004F: 'LEGEND',
		0x0050: 'ATTACH.TEXT',
		0x0051: 'ADD.ARROW',
		0x0052: 'SELECT.CHART',
		0x0053: 'SELECT.PLOT.AREA',
		0x0054: 'PATTERNS',
		0x0055: 'MAIN.CHART',
		0x0056: 'OVERLAY',
		0x0057: 'SCALE',
		0x0058: 'FORMAT.LEGEND',
		0x0059: 'FORMAT.TEXT',
		0x005A: 'EDIT.REPEAT',
		0x005B: 'PARSE',
		0x005C: 'JUSTIFY',
		0x005D: 'HIDE',
		0x005E: 'UNHIDE',
		0x005F: 'WORKSPACE',
		0x0060: 'FORMULA',
		0x0061: 'FORMULA.FILL',
		0x0062: 'FORMULA.ARRAY',
		0x0063: 'DATA.FIND.NEXT',
		0x0064: 'DATA.FIND.PREV',
		0x0065: 'FORMULA.FIND.NEXT',
		0x0066: 'FORMULA.FIND.PREV',
		0x0067: 'ACTIVATE',
		0x0068: 'ACTIVATE.NEXT',
		0x0069: 'ACTIVATE.PREV',
		0x006A: 'UNLOCKED.NEXT',
		0x006B: 'UNLOCKED.PREV',
		0x006C: 'COPY.PICTURE',
		0x006D: 'SELECT',
		0x006E: 'DELETE.NAME',
		0x006F: 'DELETE.FORMAT',
		0x0070: 'VLINE',
		0x0071: 'HLINE',
		0x0072: 'VPAGE',
		0x0073: 'HPAGE',
		0x0074: 'VSCROLL',
		0x0075: 'HSCROLL',
		0x0076: 'ALERT',
		0x0077: 'NEW',
		0x0078: 'CANCEL.COPY',
		0x0079: 'SHOW.CLIPBOARD',
		0x007A: 'MESSAGE',
		0x007C: 'PASTE.LINK',
		0x007D: 'APP.ACTIVATE',
		0x007E: 'DELETE.ARROW',
		0x007F: 'ROW.HEIGHT',
		0x0080: 'FORMAT.MOVE',
		0x0081: 'FORMAT.SIZE',
		0x0082: 'FORMULA.REPLACE',
		0x0083: 'SEND.KEYS',
		0x0084: 'SELECT.SPECIAL',
		0x0085: 'APPLY.NAMES',
		0x0086: 'REPLACE.FONT',
		0x0087: 'FREEZE.PANES',
		0x0088: 'SHOW.INFO',
		0x0089: 'SPLIT',
		0x008A: 'ON.WINDOW',
		0x008B: 'ON.DATA',
		0x008C: 'DISABLE.INPUT',
		0x008E: 'OUTLINE',
		0x008F: 'LIST.NAMES',
		0x0090: 'FILE.CLOSE',
		0x0091: 'SAVE.WORKBOOK',
		0x0092: 'DATA.FORM',
		0x0093: 'COPY.CHART',
		0x0094: 'ON.TIME',
		0x0095: 'WAIT',
		0x0096: 'FORMAT.FONT',
		0x0097: 'FILL.UP',
		0x0098: 'FILL.LEFT',
		0x0099: 'DELETE.OVERLAY',
		0x009B: 'SHORT.MENUS',
		0x009F: 'SET.UPDATE.STATUS',
		0x00A1: 'COLOR.PALETTE',
		0x00A2: 'DELETE.STYLE',
		0x00A3: 'WINDOW.RESTORE',
		0x00A4: 'WINDOW.MAXIMIZE',
		0x00A6: 'CHANGE.LINK',
		0x00A7: 'CALCULATE.DOCUMENT',
		0x00A8: 'ON.KEY',
		0x00A9: 'APP.RESTORE',
		0x00AA: 'APP.MOVE',
		0x00AB: 'APP.SIZE',
		0x00AC: 'APP.MINIMIZE',
		0x00AD: 'APP.MAXIMIZE',
		0x00AE: 'BRING.TO.FRONT',
		0x00AF: 'SEND.TO.BACK',
		0x00B9: 'MAIN.CHART.TYPE',
		0x00BA: 'OVERLAY.CHART.TYPE',
		0x00BB: 'SELECT.END',
		0x00BC: 'OPEN.MAIL',
		0x00BD: 'SEND.MAIL',
		0x00BE: 'STANDARD.FONT',
		0x00BF: 'CONSOLIDATE',
		0x00C0: 'SORT.SPECIAL',
		0x00C1: 'GALLERY.3D.AREA',
		0x00C2: 'GALLERY.3D.COLUMN',
		0x00C3: 'GALLERY.3D.LINE',
		0x00C4: 'GALLERY.3D.PIE',
		0x00C5: 'VIEW.3D',
		0x00C6: 'GOAL.SEEK',
		0x00C7: 'WORKGROUP',
		0x00C8: 'FILL.GROUP',
		0x00C9: 'UPDATE.LINK',
		0x00CA: 'PROMOTE',
		0x00CB: 'DEMOTE',
		0x00CC: 'SHOW.DETAIL',
		0x00CE: 'UNGROUP',
		0x00CF: 'OBJECT.PROPERTIES',
		0x00D0: 'SAVE.NEW.OBJECT',
		0x00D1: 'SHARE',
		0x00D2: 'SHARE.NAME',
		0x00D3: 'DUPLICATE',
		0x00D4: 'APPLY.STYLE',
		0x00D5: 'ASSIGN.TO.OBJECT',
		0x00D6: 'OBJECT.PROTECTION',
		0x00D7: 'HIDE.OBJECT',
		0x00D8: 'SET.EXTRACT',
		0x00D9: 'CREATE.PUBLISHER',
		0x00DA: 'SUBSCRIBE.TO',
		0x00DB: 'ATTRIBUTES',
		0x00DC: 'SHOW.TOOLBAR',
		0x00DE: 'PRINT.PREVIEW',
		0x00DF: 'EDIT.COLOR',
		0x00E0: 'SHOW.LEVELS',
		0x00E1: 'FORMAT.MAIN',
		0x00E2: 'FORMAT.OVERLAY',
		0x00E3: 'ON.RECALC',
		0x00E4: 'EDIT.SERIES',
		0x00E5: 'DEFINE.STYLE',
		0x00F0: 'LINE.PRINT',
		0x00F3: 'ENTER.DATA',
		0x00F9: 'GALLERY.RADAR',
		0x00FA: 'MERGE.STYLES',
		0x00FB: 'EDITION.OPTIONS',
		0x00FC: 'PASTE.PICTURE',
		0x00FD: 'PASTE.PICTURE.LINK',
		0x00FE: 'SPELLING',
		0x0100: 'ZOOM',
		0x0103: 'INSERT.OBJECT',
		0x0104: 'WINDOW.MINIMIZE',
		0x0109: 'SOUND.NOTE',
		0x010A: 'SOUND.PLAY',
		0x010B: 'FORMAT.SHAPE',
		0x010C: 'EXTEND.POLYGON',
		0x010D: 'FORMAT.AUTO',
		0x0110: 'GALLERY.3D.BAR',
		0x0111: 'GALLERY.3D.SURFACE',
		0x0112: 'FILL.AUTO',
		0x0114: 'CUSTOMIZE.TOOLBAR',
		0x0115: 'ADD.TOOL',
		0x0116: 'EDIT.OBJECT',
		0x0117: 'ON.DOUBLECLICK',
		0x0118: 'ON.ENTRY',
		0x0119: 'WORKBOOK.ADD',
		0x011A: 'WORKBOOK.MOVE',
		0x011B: 'WORKBOOK.COPY',
		0x011C: 'WORKBOOK.OPTIONS',
		0x011D: 'SAVE.WORKSPACE',
		0x0120: 'CHART.WIZARD',
		0x0121: 'DELETE.TOOL',
		0x0122: 'MOVE.TOOL',
		0x0123: 'WORKBOOK.SELECT',
		0x0124: 'WORKBOOK.ACTIVATE',
		0x0125: 'ASSIGN.TO.TOOL',
		0x0127: 'COPY.TOOL',
		0x0128: 'RESET.TOOL',
		0x0129: 'CONSTRAIN.NUMERIC',
		0x012A: 'PASTE.TOOL',
		0x012E: 'WORKBOOK.NEW',
		0x0131: 'SCENARIO.CELLS',
		0x0132: 'SCENARIO.DELETE',
		0x0133: 'SCENARIO.ADD',
		0x0134: 'SCENARIO.EDIT',
		0x0135: 'SCENARIO.SHOW',
		0x0136: 'SCENARIO.SHOW.NEXT',
		0x0137: 'SCENARIO.SUMMARY',
		0x0138: 'PIVOT.TABLE.WIZARD',
		0x0139: 'PIVOT.FIELD.PROPERTIES',
		0x013A: 'PIVOT.FIELD',
		0x013B: 'PIVOT.ITEM',
		0x013C: 'PIVOT.ADD.FIELDS',
		0x013E: 'OPTIONS.CALCULATION',
		0x013F: 'OPTIONS.EDIT',
		0x0140: 'OPTIONS.VIEW',
		0x0141: 'ADDIN.MANAGER',
		0x0142: 'MENU.EDITOR',
		0x0143: 'ATTACH.TOOLBARS',
		0x0144: 'VBAActivate',
		0x0145: 'OPTIONS.CHART',
		0x0148: 'VBA.INSERT.FILE',
		0x014A: 'VBA.PROCEDURE.DEFINITION',
		0x0150: 'ROUTING.SLIP',
		0x0152: 'ROUTE.DOCUMENT',
		0x0153: 'MAIL.LOGON',
		0x0156: 'INSERT.PICTURE',
		0x0157: 'EDIT.TOOL',
		0x0158: 'GALLERY.DOUGHNUT',
		0x015E: 'CHART.TREND',
		0x0160: 'PIVOT.ITEM.PROPERTIES',
		0x0162: 'WORKBOOK.INSERT',
		0x0163: 'OPTIONS.TRANSITION',
		0x0164: 'OPTIONS.GENERAL',
		0x0172: 'FILTER.ADVANCED',
		0x0175: 'MAIL.ADD.MAILER',
		0x0176: 'MAIL.DELETE.MAILER',
		0x0177: 'MAIL.REPLY',
		0x0178: 'MAIL.REPLY.ALL',
		0x0179: 'MAIL.FORWARD',
		0x017A: 'MAIL.NEXT.LETTER',
		0x017B: 'DATA.LABEL',
		0x017C: 'INSERT.TITLE',
		0x017D: 'FONT.PROPERTIES',
		0x017E: 'MACRO.OPTIONS',
		0x017F: 'WORKBOOK.HIDE',
		0x0180: 'WORKBOOK.UNHIDE',
		0x0181: 'WORKBOOK.DELETE',
		0x0182: 'WORKBOOK.NAME',
		0x0184: 'GALLERY.CUSTOM',
		0x0186: 'ADD.CHART.AUTOFORMAT',
		0x0187: 'DELETE.CHART.AUTOFORMAT',
		0x0188: 'CHART.ADD.DATA',
		0x0189: 'AUTO.OUTLINE',
		0x018A: 'TAB.ORDER',
		0x018B: 'SHOW.DIALOG',
		0x018C: 'SELECT.ALL',
		0x018D: 'UNGROUP.SHEETS',
		0x018E: 'SUBTOTAL.CREATE',
		0x018F: 'SUBTOTAL.REMOVE',
		0x0190: 'RENAME.OBJECT',
		0x019C: 'WORKBOOK.SCROLL',
		0x019D: 'WORKBOOK.NEXT',
		0x019E: 'WORKBOOK.PREV',
		0x019F: 'WORKBOOK.TAB.SPLIT',
		0x01A0: 'FULL.SCREEN',
		0x01A1: 'WORKBOOK.PROTECT',
		0x01A4: 'SCROLLBAR.PROPERTIES',
		0x01A5: 'PIVOT.SHOW.PAGES',
		0x01A6: 'TEXT.TO.COLUMNS',
		0x01A7: 'FORMAT.CHARTTYPE',
		0x01A8: 'LINK.FORMAT',
		0x01A9: 'TRACER.DISPLAY',
		0x01AE: 'TRACER.NAVIGATE',
		0x01AF: 'TRACER.CLEAR',
		0x01B0: 'TRACER.ERROR',
		0x01B1: 'PIVOT.FIELD.GROUP',
		0x01B2: 'PIVOT.FIELD.UNGROUP',
		0x01B3: 'CHECKBOX.PROPERTIES',
		0x01B4: 'LABEL.PROPERTIES',
		0x01B5: 'LISTBOX.PROPERTIES',
		0x01B6: 'EDITBOX.PROPERTIES',
		0x01B7: 'PIVOT.REFRESH',
		0x01B8: 'LINK.COMBO',
		0x01B9: 'OPEN.TEXT',
		0x01BA: 'HIDE.DIALOG',
		0x01BB: 'SET.DIALOG.FOCUS',
		0x01BC: 'ENABLE.OBJECT',
		0x01BD: 'PUSHBUTTON.PROPERTIES',
		0x01BE: 'SET.DIALOG.DEFAULT',
		0x01BF: 'FILTER',
		0x01C0: 'FILTER.SHOW.ALL',
		0x01C1: 'CLEAR.OUTLINE',
		0x01C2: 'FUNCTION.WIZARD',
		0x01C3: 'ADD.LIST.ITEM',
		0x01C4: 'SET.LIST.ITEM',
		0x01C5: 'REMOVE.LIST.ITEM',
		0x01C6: 'SELECT.LIST.ITEM',
		0x01C7: 'SET.CONTROL.VALUE',
		0x01C8: 'SAVE.COPY.AS',
		0x01CA: 'OPTIONS.LISTS.ADD',
		0x01CB: 'OPTIONS.LISTS.DELETE',
		0x01CC: 'SERIES.AXES',
		0x01CD: 'SERIES.X',
		0x01CE: 'SERIES.Y',
		0x01CF: 'ERRORBAR.X',
		0x01D0: 'ERRORBAR.Y',
		0x01D1: 'FORMAT.CHART',
		0x01D2: 'SERIES.ORDER',
		0x01D3: 'MAIL.LOGOFF',
		0x01D4: 'CLEAR.ROUTING.SLIP',
		0x01D5: 'APP.ACTIVATE.MICROSOFT',
		0x01D6: 'MAIL.EDIT.MAILER',
		0x01D7: 'ON.SHEET',
		0x01D8: 'STANDARD.WIDTH',
		0x01D9: 'SCENARIO.MERGE',
		0x01DA: 'SUMMARY.INFO',
		0x01DB: 'FIND.FILE',
		0x01DC: 'ACTIVE.CELL.FONT',
		0x01DD: 'ENABLE.TIPWIZARD',
		0x01DE: 'VBA.MAKE.ADDIN',
		0x01E0: 'INSERTDATATABLE',
		0x01E1: 'WORKGROUP.OPTIONS',
		0x01E2: 'MAIL.SEND.MAILER',
		0x01E5: 'AUTOCORRECT',
		0x01E9: 'POST.DOCUMENT',
		0x01EB: 'PICKLIST',
		0x01ED: 'VIEW.SHOW',
		0x01EE: 'VIEW.DEFINE',
		0x01EF: 'VIEW.DELETE',
		0x01FD: 'SHEET.BACKGROUND',
		0x01FE: 'INSERT.MAP.OBJECT',
		0x01FF: 'OPTIONS.MENONO',
		0x0205: 'MSOCHECKS',
		0x0206: 'NORMAL',
		0x0207: 'LAYOUT',
		0x0208: 'RM.PRINT.AREA',
		0x0209: 'CLEAR.PRINT.AREA',
		0x020A: 'ADD.PRINT.AREA',
		0x020B: 'MOVE.BRK',
		0x0221: 'HIDECURR.NOTE',
		0x0222: 'HIDEALL.NOTES',
		0x0223: 'DELETE.NOTE',
		0x0224: 'TRAVERSE.NOTES',
		0x0225: 'ACTIVATE.NOTES',
		0x026C: 'PROTECT.REVISIONS',
		0x026D: 'UNPROTECT.REVISIONS',
		0x0287: 'OPTIONS.ME',
		0x028D: 'WEB.PUBLISH',
		0x029B: 'NEWWEBQUERY',
		0x02A1: 'PIVOT.TABLE.CHART',
		0x02F1: 'OPTIONS.SAVE',
		0x02F3: 'OPTIONS.SPELL',
		0x0328: 'HIDEALL.INKANNOTS'
	};
	
	/* [MS-XLS] 2.5.198.17 */
	var Ftab = {
		0x0000: 'COUNT',
		0x0001: 'IF',
		0x0002: 'ISNA',
		0x0003: 'ISERROR',
		0x0004: 'SUM',
		0x0005: 'AVERAGE',
		0x0006: 'MIN',
		0x0007: 'MAX',
		0x0008: 'ROW',
		0x0009: 'COLUMN',
		0x000A: 'NA',
		0x000B: 'NPV',
		0x000C: 'STDEV',
		0x000D: 'DOLLAR',
		0x000E: 'FIXED',
		0x000F: 'SIN',
		0x0010: 'COS',
		0x0011: 'TAN',
		0x0012: 'ATAN',
		0x0013: 'PI',
		0x0014: 'SQRT',
		0x0015: 'EXP',
		0x0016: 'LN',
		0x0017: 'LOG10',
		0x0018: 'ABS',
		0x0019: 'INT',
		0x001A: 'SIGN',
		0x001B: 'ROUND',
		0x001C: 'LOOKUP',
		0x001D: 'INDEX',
		0x001E: 'REPT',
		0x001F: 'MID',
		0x0020: 'LEN',
		0x0021: 'VALUE',
		0x0022: 'TRUE',
		0x0023: 'FALSE',
		0x0024: 'AND',
		0x0025: 'OR',
		0x0026: 'NOT',
		0x0027: 'MOD',
		0x0028: 'DCOUNT',
		0x0029: 'DSUM',
		0x002A: 'DAVERAGE',
		0x002B: 'DMIN',
		0x002C: 'DMAX',
		0x002D: 'DSTDEV',
		0x002E: 'VAR',
		0x002F: 'DVAR',
		0x0030: 'TEXT',
		0x0031: 'LINEST',
		0x0032: 'TREND',
		0x0033: 'LOGEST',
		0x0034: 'GROWTH',
		0x0035: 'GOTO',
		0x0036: 'HALT',
		0x0037: 'RETURN',
		0x0038: 'PV',
		0x0039: 'FV',
		0x003A: 'NPER',
		0x003B: 'PMT',
		0x003C: 'RATE',
		0x003D: 'MIRR',
		0x003E: 'IRR',
		0x003F: 'RAND',
		0x0040: 'MATCH',
		0x0041: 'DATE',
		0x0042: 'TIME',
		0x0043: 'DAY',
		0x0044: 'MONTH',
		0x0045: 'YEAR',
		0x0046: 'WEEKDAY',
		0x0047: 'HOUR',
		0x0048: 'MINUTE',
		0x0049: 'SECOND',
		0x004A: 'NOW',
		0x004B: 'AREAS',
		0x004C: 'ROWS',
		0x004D: 'COLUMNS',
		0x004E: 'OFFSET',
		0x004F: 'ABSREF',
		0x0050: 'RELREF',
		0x0051: 'ARGUMENT',
		0x0052: 'SEARCH',
		0x0053: 'TRANSPOSE',
		0x0054: 'ERROR',
		0x0055: 'STEP',
		0x0056: 'TYPE',
		0x0057: 'ECHO',
		0x0058: 'SET.NAME',
		0x0059: 'CALLER',
		0x005A: 'DEREF',
		0x005B: 'WINDOWS',
		0x005C: 'SERIES',
		0x005D: 'DOCUMENTS',
		0x005E: 'ACTIVE.CELL',
		0x005F: 'SELECTION',
		0x0060: 'RESULT',
		0x0061: 'ATAN2',
		0x0062: 'ASIN',
		0x0063: 'ACOS',
		0x0064: 'CHOOSE',
		0x0065: 'HLOOKUP',
		0x0066: 'VLOOKUP',
		0x0067: 'LINKS',
		0x0068: 'INPUT',
		0x0069: 'ISREF',
		0x006A: 'GET.FORMULA',
		0x006B: 'GET.NAME',
		0x006C: 'SET.VALUE',
		0x006D: 'LOG',
		0x006E: 'EXEC',
		0x006F: 'CHAR',
		0x0070: 'LOWER',
		0x0071: 'UPPER',
		0x0072: 'PROPER',
		0x0073: 'LEFT',
		0x0074: 'RIGHT',
		0x0075: 'EXACT',
		0x0076: 'TRIM',
		0x0077: 'REPLACE',
		0x0078: 'SUBSTITUTE',
		0x0079: 'CODE',
		0x007A: 'NAMES',
		0x007B: 'DIRECTORY',
		0x007C: 'FIND',
		0x007D: 'CELL',
		0x007E: 'ISERR',
		0x007F: 'ISTEXT',
		0x0080: 'ISNUMBER',
		0x0081: 'ISBLANK',
		0x0082: 'T',
		0x0083: 'N',
		0x0084: 'FOPEN',
		0x0085: 'FCLOSE',
		0x0086: 'FSIZE',
		0x0087: 'FREADLN',
		0x0088: 'FREAD',
		0x0089: 'FWRITELN',
		0x008A: 'FWRITE',
		0x008B: 'FPOS',
		0x008C: 'DATEVALUE',
		0x008D: 'TIMEVALUE',
		0x008E: 'SLN',
		0x008F: 'SYD',
		0x0090: 'DDB',
		0x0091: 'GET.DEF',
		0x0092: 'REFTEXT',
		0x0093: 'TEXTREF',
		0x0094: 'INDIRECT',
		0x0095: 'REGISTER',
		0x0096: 'CALL',
		0x0097: 'ADD.BAR',
		0x0098: 'ADD.MENU',
		0x0099: 'ADD.COMMAND',
		0x009A: 'ENABLE.COMMAND',
		0x009B: 'CHECK.COMMAND',
		0x009C: 'RENAME.COMMAND',
		0x009D: 'SHOW.BAR',
		0x009E: 'DELETE.MENU',
		0x009F: 'DELETE.COMMAND',
		0x00A0: 'GET.CHART.ITEM',
		0x00A1: 'DIALOG.BOX',
		0x00A2: 'CLEAN',
		0x00A3: 'MDETERM',
		0x00A4: 'MINVERSE',
		0x00A5: 'MMULT',
		0x00A6: 'FILES',
		0x00A7: 'IPMT',
		0x00A8: 'PPMT',
		0x00A9: 'COUNTA',
		0x00AA: 'CANCEL.KEY',
		0x00AB: 'FOR',
		0x00AC: 'WHILE',
		0x00AD: 'BREAK',
		0x00AE: 'NEXT',
		0x00AF: 'INITIATE',
		0x00B0: 'REQUEST',
		0x00B1: 'POKE',
		0x00B2: 'EXECUTE',
		0x00B3: 'TERMINATE',
		0x00B4: 'RESTART',
		0x00B5: 'HELP',
		0x00B6: 'GET.BAR',
		0x00B7: 'PRODUCT',
		0x00B8: 'FACT',
		0x00B9: 'GET.CELL',
		0x00BA: 'GET.WORKSPACE',
		0x00BB: 'GET.WINDOW',
		0x00BC: 'GET.DOCUMENT',
		0x00BD: 'DPRODUCT',
		0x00BE: 'ISNONTEXT',
		0x00BF: 'GET.NOTE',
		0x00C0: 'NOTE',
		0x00C1: 'STDEVP',
		0x00C2: 'VARP',
		0x00C3: 'DSTDEVP',
		0x00C4: 'DVARP',
		0x00C5: 'TRUNC',
		0x00C6: 'ISLOGICAL',
		0x00C7: 'DCOUNTA',
		0x00C8: 'DELETE.BAR',
		0x00C9: 'UNREGISTER',
		0x00CC: 'USDOLLAR',
		0x00CD: 'FINDB',
		0x00CE: 'SEARCHB',
		0x00CF: 'REPLACEB',
		0x00D0: 'LEFTB',
		0x00D1: 'RIGHTB',
		0x00D2: 'MIDB',
		0x00D3: 'LENB',
		0x00D4: 'ROUNDUP',
		0x00D5: 'ROUNDDOWN',
		0x00D6: 'ASC',
		0x00D7: 'DBCS',
		0x00D8: 'RANK',
		0x00DB: 'ADDRESS',
		0x00DC: 'DAYS360',
		0x00DD: 'TODAY',
		0x00DE: 'VDB',
		0x00DF: 'ELSE',
		0x00E0: 'ELSE.IF',
		0x00E1: 'END.IF',
		0x00E2: 'FOR.CELL',
		0x00E3: 'MEDIAN',
		0x00E4: 'SUMPRODUCT',
		0x00E5: 'SINH',
		0x00E6: 'COSH',
		0x00E7: 'TANH',
		0x00E8: 'ASINH',
		0x00E9: 'ACOSH',
		0x00EA: 'ATANH',
		0x00EB: 'DGET',
		0x00EC: 'CREATE.OBJECT',
		0x00ED: 'VOLATILE',
		0x00EE: 'LAST.ERROR',
		0x00EF: 'CUSTOM.UNDO',
		0x00F0: 'CUSTOM.REPEAT',
		0x00F1: 'FORMULA.CONVERT',
		0x00F2: 'GET.LINK.INFO',
		0x00F3: 'TEXT.BOX',
		0x00F4: 'INFO',
		0x00F5: 'GROUP',
		0x00F6: 'GET.OBJECT',
		0x00F7: 'DB',
		0x00F8: 'PAUSE',
		0x00FB: 'RESUME',
		0x00FC: 'FREQUENCY',
		0x00FD: 'ADD.TOOLBAR',
		0x00FE: 'DELETE.TOOLBAR',
		0x00FF: 'User',
		0x0100: 'RESET.TOOLBAR',
		0x0101: 'EVALUATE',
		0x0102: 'GET.TOOLBAR',
		0x0103: 'GET.TOOL',
		0x0104: 'SPELLING.CHECK',
		0x0105: 'ERROR.TYPE',
		0x0106: 'APP.TITLE',
		0x0107: 'WINDOW.TITLE',
		0x0108: 'SAVE.TOOLBAR',
		0x0109: 'ENABLE.TOOL',
		0x010A: 'PRESS.TOOL',
		0x010B: 'REGISTER.ID',
		0x010C: 'GET.WORKBOOK',
		0x010D: 'AVEDEV',
		0x010E: 'BETADIST',
		0x010F: 'GAMMALN',
		0x0110: 'BETAINV',
		0x0111: 'BINOMDIST',
		0x0112: 'CHIDIST',
		0x0113: 'CHIINV',
		0x0114: 'COMBIN',
		0x0115: 'CONFIDENCE',
		0x0116: 'CRITBINOM',
		0x0117: 'EVEN',
		0x0118: 'EXPONDIST',
		0x0119: 'FDIST',
		0x011A: 'FINV',
		0x011B: 'FISHER',
		0x011C: 'FISHERINV',
		0x011D: 'FLOOR',
		0x011E: 'GAMMADIST',
		0x011F: 'GAMMAINV',
		0x0120: 'CEILING',
		0x0121: 'HYPGEOMDIST',
		0x0122: 'LOGNORMDIST',
		0x0123: 'LOGINV',
		0x0124: 'NEGBINOMDIST',
		0x0125: 'NORMDIST',
		0x0126: 'NORMSDIST',
		0x0127: 'NORMINV',
		0x0128: 'NORMSINV',
		0x0129: 'STANDARDIZE',
		0x012A: 'ODD',
		0x012B: 'PERMUT',
		0x012C: 'POISSON',
		0x012D: 'TDIST',
		0x012E: 'WEIBULL',
		0x012F: 'SUMXMY2',
		0x0130: 'SUMX2MY2',
		0x0131: 'SUMX2PY2',
		0x0132: 'CHITEST',
		0x0133: 'CORREL',
		0x0134: 'COVAR',
		0x0135: 'FORECAST',
		0x0136: 'FTEST',
		0x0137: 'INTERCEPT',
		0x0138: 'PEARSON',
		0x0139: 'RSQ',
		0x013A: 'STEYX',
		0x013B: 'SLOPE',
		0x013C: 'TTEST',
		0x013D: 'PROB',
		0x013E: 'DEVSQ',
		0x013F: 'GEOMEAN',
		0x0140: 'HARMEAN',
		0x0141: 'SUMSQ',
		0x0142: 'KURT',
		0x0143: 'SKEW',
		0x0144: 'ZTEST',
		0x0145: 'LARGE',
		0x0146: 'SMALL',
		0x0147: 'QUARTILE',
		0x0148: 'PERCENTILE',
		0x0149: 'PERCENTRANK',
		0x014A: 'MODE',
		0x014B: 'TRIMMEAN',
		0x014C: 'TINV',
		0x014E: 'MOVIE.COMMAND',
		0x014F: 'GET.MOVIE',
		0x0150: 'CONCATENATE',
		0x0151: 'POWER',
		0x0152: 'PIVOT.ADD.DATA',
		0x0153: 'GET.PIVOT.TABLE',
		0x0154: 'GET.PIVOT.FIELD',
		0x0155: 'GET.PIVOT.ITEM',
		0x0156: 'RADIANS',
		0x0157: 'DEGREES',
		0x0158: 'SUBTOTAL',
		0x0159: 'SUMIF',
		0x015A: 'COUNTIF',
		0x015B: 'COUNTBLANK',
		0x015C: 'SCENARIO.GET',
		0x015D: 'OPTIONS.LISTS.GET',
		0x015E: 'ISPMT',
		0x015F: 'DATEDIF',
		0x0160: 'DATESTRING',
		0x0161: 'NUMBERSTRING',
		0x0162: 'ROMAN',
		0x0163: 'OPEN.DIALOG',
		0x0164: 'SAVE.DIALOG',
		0x0165: 'VIEW.GET',
		0x0166: 'GETPIVOTDATA',
		0x0167: 'HYPERLINK',
		0x0168: 'PHONETIC',
		0x0169: 'AVERAGEA',
		0x016A: 'MAXA',
		0x016B: 'MINA',
		0x016C: 'STDEVPA',
		0x016D: 'VARPA',
		0x016E: 'STDEVA',
		0x016F: 'VARA',
		0x0170: 'BAHTTEXT',
		0x0171: 'THAIDAYOFWEEK',
		0x0172: 'THAIDIGIT',
		0x0173: 'THAIMONTHOFYEAR',
		0x0174: 'THAINUMSOUND',
		0x0175: 'THAINUMSTRING',
		0x0176: 'THAISTRINGLENGTH',
		0x0177: 'ISTHAIDIGIT',
		0x0178: 'ROUNDBAHTDOWN',
		0x0179: 'ROUNDBAHTUP',
		0x017A: 'THAIYEAR',
		0x017B: 'RTD'
	};
	var FtabArgc = {
		0x0002: 1, /* ISNA */
		0x0003: 1, /* ISERROR */
		0x000F: 1, /* SIN */
		0x0010: 1, /* COS */
		0x0011: 1, /* TAN */
		0x0012: 1, /* ATAN */
		0x0014: 1, /* SQRT */
		0x0015: 1, /* EXP */
		0x0016: 1, /* LN */
		0x0017: 1, /* LOG10 */
		0x0018: 1, /* ABS */
		0x0019: 1, /* INT */
		0x001A: 1, /* SIGN */
		0x001B: 2, /* ROUND */
		0x001E: 2, /* REPT */
		0x001F: 3, /* MID */
		0x0020: 1, /* LEN */
		0x0021: 1, /* VALUE */
		0x0026: 1, /* NOT */
		0x0027: 2, /* MOD */
		0x0028: 3, /* DCOUNT */
		0x0029: 3, /* DSUM */
		0x002A: 3, /* DAVERAGE */
		0x002B: 3, /* DMIN */
		0x002C: 3, /* DMAX */
		0x002D: 3, /* DSTDEV */
		0x002F: 3, /* DVAR */
		0x0030: 2, /* TEXT */
		0x0035: 1, /* GOTO */
		0x003D: 3, /* MIRR */
		0x0041: 3, /* DATE */
		0x0042: 3, /* TIME */
		0x0043: 1, /* DAY */
		0x0044: 1, /* MONTH */
		0x0045: 1, /* YEAR */
		0x0047: 1, /* HOUR */
		0x0048: 1, /* MINUTE */
		0x0049: 1, /* SECOND */
		0x004B: 1, /* AREAS */
		0x004C: 1, /* ROWS */
		0x004D: 1, /* COLUMNS */
		0x004F: 2, /* ABSREF */
		0x0050: 2, /* RELREF */
		0x0053: 1, /* TRANSPOSE */
		0x0056: 1, /* TYPE */
		0x005A: 1, /* DEREF */
		0x0061: 2, /* ATAN2 */
		0x0062: 1, /* ASIN */
		0x0063: 1, /* ACOS */
		0x0069: 1, /* ISREF */
		0x006F: 1, /* CHAR */
		0x0070: 1, /* LOWER */
		0x0071: 1, /* UPPER */
		0x0072: 1, /* PROPER */
		0x0075: 2, /* EXACT */
		0x0076: 1, /* TRIM */
		0x0077: 4, /* REPLACE */
		0x0079: 1, /* CODE */
		0x007E: 1, /* ISERR */
		0x007F: 1, /* ISTEXT */
		0x0080: 1, /* ISNUMBER */
		0x0081: 1, /* ISBLANK */
		0x0082: 1, /* T */
		0x0083: 1, /* N */
		0x0085: 1, /* FCLOSE */
		0x0086: 1, /* FSIZE */
		0x0087: 1, /* FREADLN */
		0x0088: 2, /* FREAD */
		0x0089: 2, /* FWRITELN */
		0x008A: 2, /* FWRITE */
		0x008C: 1, /* DATEVALUE */
		0x008D: 1, /* TIMEVALUE */
		0x008E: 3, /* SLN */
		0x008F: 4, /* SYD */
		0x00A2: 1, /* CLEAN */
		0x00A3: 1, /* MDETERM */
		0x00A4: 1, /* MINVERSE */
		0x00A5: 2, /* MMULT */
		0x00AC: 1, /* WHILE */
		0x00AF: 2, /* INITIATE */
		0x00B0: 2, /* REQUEST */
		0x00B1: 3, /* POKE */
		0x00B2: 2, /* EXECUTE */
		0x00B3: 1, /* TERMINATE */
		0x00B8: 1, /* FACT */
		0x00BD: 3, /* DPRODUCT */
		0x00BE: 1, /* ISNONTEXT */
		0x00C3: 3, /* DSTDEVP */
		0x00C4: 3, /* DVARP */
		0x00C6: 1, /* ISLOGICAL */
		0x00C7: 3, /* DCOUNTA */
		0x00C9: 1, /* UNREGISTER */
		0x00CF: 4, /* REPLACEB */
		0x00D2: 3, /* MIDB */
		0x00D3: 1, /* LENB */
		0x00D4: 2, /* ROUNDUP */
		0x00D5: 2, /* ROUNDDOWN */
		0x00D6: 1, /* ASC */
		0x00D7: 1, /* DBCS */
		0x00E5: 1, /* SINH */
		0x00E6: 1, /* COSH */
		0x00E7: 1, /* TANH */
		0x00E8: 1, /* ASINH */
		0x00E9: 1, /* ACOSH */
		0x00EA: 1, /* ATANH */
		0x00EB: 3, /* DGET */
		0x00F4: 1, /* INFO */
		0x00FC: 2, /* FREQUENCY */
		0x0101: 1, /* EVALUATE */
		0x0105: 1, /* ERROR.TYPE */
		0x010F: 1, /* GAMMALN */
		0x0111: 4, /* BINOMDIST */
		0x0112: 2, /* CHIDIST */
		0x0113: 2, /* CHIINV */
		0x0114: 2, /* COMBIN */
		0x0115: 3, /* CONFIDENCE */
		0x0116: 3, /* CRITBINOM */
		0x0117: 1, /* EVEN */
		0x0118: 3, /* EXPONDIST */
		0x0119: 3, /* FDIST */
		0x011A: 3, /* FINV */
		0x011B: 1, /* FISHER */
		0x011C: 1, /* FISHERINV */
		0x011D: 2, /* FLOOR */
		0x011E: 4, /* GAMMADIST */
		0x011F: 3, /* GAMMAINV */
		0x0120: 2, /* CEILING */
		0x0121: 4, /* HYPGEOMDIST */
		0x0122: 3, /* LOGNORMDIST */
		0x0123: 3, /* LOGINV */
		0x0124: 3, /* NEGBINOMDIST */
		0x0125: 4, /* NORMDIST */
		0x0126: 1, /* NORMSDIST */
		0x0127: 3, /* NORMINV */
		0x0128: 1, /* NORMSINV */
		0x0129: 3, /* STANDARDIZE */
		0x012A: 1, /* ODD */
		0x012B: 2, /* PERMUT */
		0x012C: 3, /* POISSON */
		0x012D: 3, /* TDIST */
		0x012E: 4, /* WEIBULL */
		0x012F: 2, /* SUMXMY2 */
		0x0130: 2, /* SUMX2MY2 */
		0x0131: 2, /* SUMX2PY2 */
		0x0132: 2, /* CHITEST */
		0x0133: 2, /* CORREL */
		0x0134: 2, /* COVAR */
		0x0135: 3, /* FORECAST */
		0x0136: 2, /* FTEST */
		0x0137: 2, /* INTERCEPT */
		0x0138: 2, /* PEARSON */
		0x0139: 2, /* RSQ */
		0x013A: 2, /* STEYX */
		0x013B: 2, /* SLOPE */
		0x013C: 4, /* TTEST */
		0x0145: 2, /* LARGE */
		0x0146: 2, /* SMALL */
		0x0147: 2, /* QUARTILE */
		0x0148: 2, /* PERCENTILE */
		0x014B: 2, /* TRIMMEAN */
		0x014C: 2, /* TINV */
		0x0151: 2, /* POWER */
		0x0156: 1, /* RADIANS */
		0x0157: 1, /* DEGREES */
		0x015A: 2, /* COUNTIF */
		0x015B: 1, /* COUNTBLANK */
		0x015E: 4, /* ISPMT */
		0x015F: 3, /* DATEDIF */
		0x0160: 1, /* DATESTRING */
		0x0161: 2, /* NUMBERSTRING */
		0x0168: 1, /* PHONETIC */
		0x0170: 1, /* BAHTTEXT */
		0x0171: 1, /* THAIDAYOFWEEK */
		0x0172: 1, /* THAIDIGIT */
		0x0173: 1, /* THAIMONTHOFYEAR */
		0x0174: 1, /* THAINUMSOUND */
		0x0175: 1, /* THAINUMSTRING */
		0x0176: 1, /* THAISTRINGLENGTH */
		0x0177: 1, /* ISTHAIDIGIT */
		0x0178: 1, /* ROUNDBAHTDOWN */
		0x0179: 1, /* ROUNDBAHTUP */
		0x017A: 1, /* THAIYEAR */
		0xFFFF: 0
	};
	/* [MS-XLSX] 2.2.3 Functions */
	var XLSXFutureFunctions = {
		"_xlfn.ACOT": "ACOT",
		"_xlfn.ACOTH": "ACOTH",
		"_xlfn.AGGREGATE": "AGGREGATE",
		"_xlfn.ARABIC": "ARABIC",
		"_xlfn.AVERAGEIF": "AVERAGEIF",
		"_xlfn.AVERAGEIFS": "AVERAGEIFS",
		"_xlfn.BASE": "BASE",
		"_xlfn.BETA.DIST": "BETA.DIST",
		"_xlfn.BETA.INV": "BETA.INV",
		"_xlfn.BINOM.DIST": "BINOM.DIST",
		"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
		"_xlfn.BINOM.INV": "BINOM.INV",
		"_xlfn.BITAND": "BITAND",
		"_xlfn.BITLSHIFT": "BITLSHIFT",
		"_xlfn.BITOR": "BITOR",
		"_xlfn.BITRSHIFT": "BITRSHIFT",
		"_xlfn.BITXOR": "BITXOR",
		"_xlfn.CEILING.MATH": "CEILING.MATH",
		"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
		"_xlfn.CHISQ.DIST": "CHISQ.DIST",
		"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
		"_xlfn.CHISQ.INV": "CHISQ.INV",
		"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
		"_xlfn.CHISQ.TEST": "CHISQ.TEST",
		"_xlfn.COMBINA": "COMBINA",
		"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
		"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
		"_xlfn.COT": "COT",
		"_xlfn.COTH": "COTH",
		"_xlfn.COUNTIFS": "COUNTIFS",
		"_xlfn.COVARIANCE.P": "COVARIANCE.P",
		"_xlfn.COVARIANCE.S": "COVARIANCE.S",
		"_xlfn.CSC": "CSC",
		"_xlfn.CSCH": "CSCH",
		"_xlfn.DAYS": "DAYS",
		"_xlfn.DECIMAL": "DECIMAL",
		"_xlfn.ECMA.CEILING": "ECMA.CEILING",
		"_xlfn.ERF.PRECISE": "ERF.PRECISE",
		"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
		"_xlfn.EXPON.DIST": "EXPON.DIST",
		"_xlfn.F.DIST": "F.DIST",
		"_xlfn.F.DIST.RT": "F.DIST.RT",
		"_xlfn.F.INV": "F.INV",
		"_xlfn.F.INV.RT": "F.INV.RT",
		"_xlfn.F.TEST": "F.TEST",
		"_xlfn.FILTERXML": "FILTERXML",
		"_xlfn.FLOOR.MATH": "FLOOR.MATH",
		"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
		"_xlfn.FORMULATEXT": "FORMULATEXT",
		"_xlfn.GAMMA": "GAMMA",
		"_xlfn.GAMMA.DIST": "GAMMA.DIST",
		"_xlfn.GAMMA.INV": "GAMMA.INV",
		"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
		"_xlfn.GAUSS": "GAUSS",
		"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
		"_xlfn.IFNA": "IFNA",
		"_xlfn.IFERROR": "IFERROR",
		"_xlfn.IMCOSH": "IMCOSH",
		"_xlfn.IMCOT": "IMCOT",
		"_xlfn.IMCSC": "IMCSC",
		"_xlfn.IMCSCH": "IMCSCH",
		"_xlfn.IMSEC": "IMSEC",
		"_xlfn.IMSECH": "IMSECH",
		"_xlfn.IMSINH": "IMSINH",
		"_xlfn.IMTAN": "IMTAN",
		"_xlfn.ISFORMULA": "ISFORMULA",
		"_xlfn.ISO.CEILING": "ISO.CEILING",
		"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
		"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
		"_xlfn.LOGNORM.INV": "LOGNORM.INV",
		"_xlfn.MODE.MULT": "MODE.MULT",
		"_xlfn.MODE.SNGL": "MODE.SNGL",
		"_xlfn.MUNIT": "MUNIT",
		"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
		"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
		"_xlfn.NIGBINOM": "NIGBINOM",
		"_xlfn.NORM.DIST": "NORM.DIST",
		"_xlfn.NORM.INV": "NORM.INV",
		"_xlfn.NORM.S.DIST": "NORM.S.DIST",
		"_xlfn.NORM.S.INV": "NORM.S.INV",
		"_xlfn.NUMBERVALUE": "NUMBERVALUE",
		"_xlfn.PDURATION": "PDURATION",
		"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
		"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
		"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
		"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
		"_xlfn.PERMUTATIONA": "PERMUTATIONA",
		"_xlfn.PHI": "PHI",
		"_xlfn.POISSON.DIST": "POISSON.DIST",
		"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
		"_xlfn.QUARTILE.INC": "QUARTILE.INC",
		"_xlfn.QUERYSTRING": "QUERYSTRING",
		"_xlfn.RANK.AVG": "RANK.AVG",
		"_xlfn.RANK.EQ": "RANK.EQ",
		"_xlfn.RRI": "RRI",
		"_xlfn.SEC": "SEC",
		"_xlfn.SECH": "SECH",
		"_xlfn.SHEET": "SHEET",
		"_xlfn.SHEETS": "SHEETS",
		"_xlfn.SKEW.P": "SKEW.P",
		"_xlfn.STDEV.P": "STDEV.P",
		"_xlfn.STDEV.S": "STDEV.S",
		"_xlfn.SUMIFS": "SUMIFS",
		"_xlfn.T.DIST": "T.DIST",
		"_xlfn.T.DIST.2T": "T.DIST.2T",
		"_xlfn.T.DIST.RT": "T.DIST.RT",
		"_xlfn.T.INV": "T.INV",
		"_xlfn.T.INV.2T": "T.INV.2T",
		"_xlfn.T.TEST": "T.TEST",
		"_xlfn.UNICHAR": "UNICHAR",
		"_xlfn.UNICODE": "UNICODE",
		"_xlfn.VAR.P": "VAR.P",
		"_xlfn.VAR.S": "VAR.S",
		"_xlfn.WEBSERVICE": "WEBSERVICE",
		"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
		"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
		"_xlfn.XOR": "XOR",
		"_xlfn.Z.TEST": "Z.TEST"
	};
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	RELS.WS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet";
	
	function get_sst_id(sst, str) {
		for(var i = 0, len = sst.length; i < len; ++i) if(sst[i].t === str) { sst.Count ++; return i; }
		sst[len] = {t:str}; sst.Count ++; sst.Unique ++; return len;
	}
	
	function get_cell_style(styles, cell, opts) {
	  if (typeof style_builder != 'undefined') {
	    if (/^\d+$/.exec(cell.s)) { return cell.s}  // if its already an integer index, let it be
	    if (cell.s && (cell.s == +cell.s)) { return cell.s}  // if its already an integer index, let it be
	    var s = cell.s || {};
	    if (cell.z) s.numFmt = cell.z;
	    return style_builder.addStyle(s);
	  }
	  else {
	    var z = opts.revssf[cell.z != null ? cell.z : "General"];
	    for(var i = 0, len = styles.length; i != len; ++i) if(styles[i].numFmtId === z) return i;
	    styles[len] = {
	      numFmtId:z,
	      fontId:0,
	      fillId:0,
	      borderId:0,
	      xfId:0,
	      applyNumberFormat:1
	    };
	    return len;
	  }
	}
	
	function get_cell_style_csf(cellXf) {
	
	  if (cellXf) {
	
	    var s = {}
	
	    if (typeof cellXf.numFmtId != undefined)  {
	      s.numFmt = SSF._table[cellXf.numFmtId];
	    }
	
	    if(cellXf.fillId)  {
	      s.fill =  styles.Fills[cellXf.fillId];
	    }
	
	    if (cellXf.fontId) {
	      s.font = styles.Fonts[cellXf.fontId];
	    }
	    if (cellXf.borderId) {
	      s.border = styles.Borders[cellXf.borderId];
	    }
	    if (cellXf.applyAlignment==1) {
	      s.alignment = cellXf.alignment;
	    }
	
	
	    return JSON.parse(JSON.stringify(s));
	  }
	  return null;
	}
	
	function safe_format(p, fmtid, fillid, opts) {
		try {
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v,_ssfopts);
					else p.w = SSF._general_num(p.v,_ssfopts);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = SSF._general_int(dd,_ssfopts);
					else p.w = SSF._general_num(dd,_ssfopts);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF._general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF.format(fmtid,p.v,_ssfopts);
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
	}
	function parse_ws_xml_dim(ws, s) {
	  var d = safe_decode_range(s);
	  if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<mergeCell ref="[A-Z0-9:]+"\s*\/>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData>([^\u2603]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<hyperlink[^>]*\/>/g;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<col[^>]*\/>/g;
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, rels) {
	  if (!data) return data;
	  /* 18.3.1.99 worksheet CT_Worksheet */
	  var s = {};
	
	  /* 18.3.1.35 dimension CT_SheetDimension ? */
	  var ridx = data.indexOf("<dimension");
	  if (ridx > 0) {
	    var ref = data.substr(ridx, 50).match(dimregex);
	    if (ref != null) parse_ws_xml_dim(s, ref[1]);
	  }
	
	  /* 18.3.1.55 mergeCells CT_MergeCells */
	  var mergecells = [];
	  if (data.indexOf("</mergeCells>") !== -1) {
	    var merges = data.match(mergecregex);
	    for (ridx = 0; ridx != merges.length; ++ridx)
	      mergecells[ridx] = safe_decode_range(merges[ridx].substr(merges[ridx].indexOf("\"") + 1));
	  }
	
	  /* 18.3.1.17 cols CT_Cols */
	  var columns = [];
	  if (opts.cellStyles && data.indexOf("</cols>") !== -1) {
	    /* 18.3.1.13 col CT_Col */
	    var cols = data.match(colregex);
	    parse_ws_xml_cols(columns, cols);
	  }
	
	  var refguess = {s: {r: 1000000, c: 1000000}, e: {r: 0, c: 0}};
	
	  /* 18.3.1.80 sheetData CT_SheetData ? */
	  var mtch = data.match(sheetdataregex);
	  if (mtch) parse_ws_xml_data(mtch[1], s, opts, refguess);
	
	  /* 18.3.1.48 hyperlinks CT_Hyperlinks */
	  if (data.indexOf("</hyperlinks>") !== -1) parse_ws_xml_hlinks(s, data.match(hlinkregex), rels);
	
	  if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
	  if (opts.sheetRows > 0 && s["!ref"]) {
	    var tmpref = safe_decode_range(s["!ref"]);
	    if (opts.sheetRows < +tmpref.e.r) {
	      tmpref.e.r = opts.sheetRows - 1;
	      if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
	      if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
	      if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
	      if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
	      s["!fullref"] = s["!ref"];
	      s["!ref"] = encode_range(tmpref);
	    }
	  }
	  if (mergecells.length > 0) s["!merges"] = mergecells;
	  if (columns.length > 0) s["!cols"] = columns;
	  return s;
	}
	
	function write_ws_xml_merges(merges) {
	  if (merges.length == 0) return "";
	  var o = '<mergeCells count="' + merges.length + '">';
	  for (var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
	  return o + '</mergeCells>';
	}
	
	function write_ws_xml_pagesetup(setup) {
	  var pageSetup = writextag('pageSetup', null, {
	    scale: setup.scale || '100',
	    orientation: setup.orientation || 'portrait',
	    horizontalDpi: setup.horizontalDpi || '4294967292',
	    verticalDpi: setup.verticalDpi || '4294967292'
	  })
	  return pageSetup;
	}
	
	
	function parse_ws_xml_hlinks(s, data, rels) {
	  for (var i = 0; i != data.length; ++i) {
	    var val = parsexmltag(data[i], true);
	    if (!val.ref) return;
	    var rel = rels ? rels['!id'][val.id] : null;
	    if (rel) {
	      val.Target = rel.Target;
	      if (val.location) val.Target += "#" + val.location;
	      val.Rel = rel;
	    } else {
	      val.Target = val.location;
	      rel = {Target: val.location, TargetMode: 'Internal'};
	      val.Rel = rel;
	    }
	    var rng = safe_decode_range(val.ref);
	    for (var R = rng.s.r; R <= rng.e.r; ++R) for (var C = rng.s.c; C <= rng.e.c; ++C) {
	      var addr = encode_cell({c: C, r: R});
	      if (!s[addr]) s[addr] = {t: "stub", v: undefined};
	      s[addr].l = val;
	    }
	  }
	}
	
	function parse_ws_xml_cols(columns, cols) {
	  var seencol = false;
	  for (var coli = 0; coli != cols.length; ++coli) {
	    var coll = parsexmltag(cols[coli], true);
	    var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
	    delete coll.min;
	    delete coll.max;
	    if (!seencol && coll.width) {
	      seencol = true;
	      find_mdw(+coll.width, coll);
	    }
	    if (coll.width) {
	      coll.wpx = width2px(+coll.width);
	      coll.wch = px2char(coll.wpx);
	      coll.MDW = MDW;
	    }
	    while (colm <= colM) columns[colm++] = coll;
	  }
	}
	
	function write_ws_xml_cols(ws, cols) {
	  var o = ["<cols>"], col, width;
	  for (var i = 0; i != cols.length; ++i) {
	    if (!(col = cols[i])) continue;
	    var p = {min: i + 1, max: i + 1};
	    /* wch (chars), wpx (pixels) */
	    width = -1;
	    if (col.wpx) width = px2char(col.wpx);
	    else if (col.wch) width = col.wch;
	    if (width > -1) {
	      p.width = char2width(width);
	      p.customWidth = 1;
	    }
	    o[o.length] = (writextag('col', null, p));
	  }
	  o[o.length] = "</cols>";
	  return o.join("");
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts, idx, wb) {
	  if (cell.v === undefined && cell.s === undefined) return "";
	  var vv = "";
	  var oldt = cell.t, oldv = cell.v;
	  switch (cell.t) {
	    case 'b':
	      vv = cell.v ? "1" : "0";
	      break;
	    case 'n':
	      vv = '' + cell.v;
	      break;
	    case 'e':
	      vv = BErr[cell.v];
	      break;
	    case 'd':
	      if (opts.cellDates) vv = new Date(cell.v).toISOString();
	      else {
	        cell.t = 'n';
	        vv = '' + (cell.v = datenum(cell.v));
	        if (typeof cell.z === 'undefined') cell.z = SSF._table[14];
	      }
	      break;
	    default:
	      vv = cell.v;
	      break;
	  }
	  var v = writetag('v', escapexml(vv)), o = {r: ref};
	  /* TODO: cell style */
	  var os = get_cell_style(opts.cellXfs, cell, opts);
	  if (os !== 0) o.s = os;
	  switch (cell.t) {
	    case 'n':
	      break;
	    case 'd':
	      o.t = "d";
	      break;
	    case 'b':
	      o.t = "b";
	      break;
	    case 'e':
	      o.t = "e";
	      break;
	    default:
	      if (opts.bookSST) {
	        v = writetag('v', '' + get_sst_id(opts.Strings, cell.v));
	        o.t = "s";
	        break;
	      }
	      o.t = "str";
	      break;
	  }
	  if (cell.t != oldt) {
	    cell.t = oldt;
	    cell.v = oldv;
	  }
	  return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function parse_ws_xml_data_factory() {
	  var cellregex = /<(?:\w+:)?c[ >]/, rowregex = /<\/(?:\w+:)?row>/;
	  var rregex = /r=["']([^"']*)["']/, isregex = /<is>([\S\s]*?)<\/is>/;
	  var match_v = matchtag("v"), match_f = matchtag("f");
	
	  return function parse_ws_xml_data(sdata, s, opts, guess) {
	    var ri = 0, x = "", cells = [], cref = [], idx = 0, i = 0, cc = 0, d = "", p;
	    var tag, tagr = 0, tagc = 0;
	    var sstr;
	    var fmtid = 0, fillid = 0, do_format = Array.isArray(styles.CellXf), cf;
	    for (var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
	      x = marr[mt].trim();
	      var xlen = x.length;
	      if (xlen === 0) continue;
	
	      /* 18.3.1.73 row CT_Row */
	      for (ri = 0; ri < xlen; ++ri) if (x.charCodeAt(ri) === 62) break;
	      ++ri;
	      tag = parsexmltag(x.substr(0, ri), true);
	      /* SpreadSheetGear uses implicit r/c */
	      tagr = typeof tag.r !== 'undefined' ? parseInt(tag.r, 10) : tagr + 1;
	      tagc = -1;
	      if (opts.sheetRows && opts.sheetRows < tagr) continue;
	      if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
	      if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
	      /* 18.3.1.4 c CT_Cell */
	      cells = x.substr(ri).split(cellregex);
	      for (ri = typeof tag.r === 'undefined' ? 0 : 1; ri != cells.length; ++ri) {
	        x = cells[ri].trim();
	        if (x.length === 0) continue;
	        cref = x.match(rregex);
	        idx = ri;
	        i = 0;
	        cc = 0;
	        x = "<c " + (x.substr(0, 1) == "<" ? ">" : "") + x;
	        if (cref !== null && cref.length === 2) {
	          idx = 0;
	          d = cref[1];
	          for (i = 0; i != d.length; ++i) {
	            if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
	            idx = 26 * idx + cc;
	          }
	          --idx;
	          tagc = idx;
	        } else ++tagc;
	        for (i = 0; i != x.length; ++i) if (x.charCodeAt(i) === 62) break;
	        ++i;
	        tag = parsexmltag(x.substr(0, i), true);
	        if (!tag.r) tag.r = utils.encode_cell({r: tagr - 1, c: tagc});
	        d = x.substr(i);
	        p = {t: ""};
	
	        if ((cref = d.match(match_v)) !== null && cref[1] !== '') p.v = unescapexml(cref[1]);
	        if (opts.cellFormula && (cref = d.match(match_f)) !== null) p.f = unescapexml(cref[1]);
	
	        /* SCHEMA IS ACTUALLY INCORRECT HERE.  IF A CELL HAS NO T, EMIT "" */
	        if (tag.t === undefined && tag.s === undefined && p.v === undefined) {
	          if (!opts.sheetStubs) continue;
	          p.t = "stub";
	        }
	        else p.t = tag.t || "n";
	        if (guess.s.c > idx) guess.s.c = idx;
	        if (guess.e.c < idx) guess.e.c = idx;
	        /* 18.18.11 t ST_CellType */
	        switch (p.t) {
	          case 'n':
	            p.v = parseFloat(p.v);
	            if (isNaN(p.v)) p.v = "" // we don't want NaN if p.v is null
	            break;
	          case 's':
	            // if (!p.hasOwnProperty('v')) continue;
	            sstr = strs[parseInt(p.v, 10)];
	            p.v = sstr.t;
	            p.r = sstr.r;
	            if (opts.cellHTML) p.h = sstr.h;
	            break;
	          case 'str':
	            p.t = "s";
	            p.v = (p.v != null) ? utf8read(p.v) : '';
	            if (opts.cellHTML) p.h = p.v;
	            break;
	          case 'inlineStr':
	            cref = d.match(isregex);
	            p.t = 's';
	            if (cref !== null) {
	              sstr = parse_si(cref[1]);
	              p.v = sstr.t;
	            } else p.v = "";
	            break; // inline string
	          case 'b':
	            p.v = parsexmlbool(p.v);
	            break;
	          case 'd':
	            if (!opts.cellDates) {
	              p.v = datenum(p.v);
	              p.t = 'n';
	            }
	            break;
	            /* error string in .v, number in .v */
	          case 'e':
	            p.w = p.v;
	            p.v = RBErr[p.v];
	            break;
	        }
	        /* formatting */
	        fmtid = fillid = 0;
	        if (do_format && tag.s !== undefined) {
	          cf = styles.CellXf[tag.s];
	          if (opts.cellStyles) {
	            p.s = get_cell_style_csf(cf)
	          }
	          if (cf != null) {
	            if (cf.numFmtId != null) fmtid = cf.numFmtId;
	            if (opts.cellStyles && cf.fillId != null) fillid = cf.fillId;
	          }
	        }
	        safe_format(p, fmtid, fillid, opts);
	        s[tag.r] = p;
	      }
	    }
	  };
	})();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
	  var o = [], r = [], range = safe_decode_range(ws['!ref']), cell, ref, rr = "", cols = [], R, C;
	  for (C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
	  for (R = range.s.r; R <= range.e.r; ++R) {
	    r = [];
	    rr = encode_row(R);
	    for (C = range.s.c; C <= range.e.c; ++C) {
	      ref = cols[C] + rr;
	      if (ws[ref] === undefined) continue;
	      if ((cell = write_ws_xml_cell(ws[ref], ref, ws, opts, idx, wb)) != null) r.push(cell);
	    }
	    if (r.length > 0) o[o.length] = (writextag('row', r.join(""), {r: rr}));
	  }
	  return o.join("");
	}
	
	var WS_XML_ROOT = writextag('worksheet', null, {
	  'xmlns': XMLNS.main[0],
	  'xmlns:r': XMLNS.r
	});
	
	function write_ws_xml(idx, opts, wb) {
	  var o = [XML_HEADER, WS_XML_ROOT];
	  var s = wb.SheetNames[idx], sidx = 0, rdata = "";
	  var ws = wb.Sheets[s];
	  if (ws === undefined) ws = {};
	  var ref = ws['!ref'];
	  if (ref === undefined) ref = 'A1';
	  o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
	  var kids = [];
	  if (ws['!freeze']) {
	    var pane = '';
	    pane = writextag('pane', null, ws['!freeze'])
	    kids.push(pane)
	
	    var selection = writextag('selection', null, {
	      pane: "topLeft"
	    })
	    kids.push(selection)
	
	    var selection = writextag('selection', null, {
	      pane: "bottomLeft"
	    })
	    kids.push(selection)
	
	    var selection = writextag('selection', null, {
	      pane: "bottomRight",
	      activeCell: ws['!freeze'],
	      sqref: ws['!freeze']
	    })
	    kids.push(selection)
	  }
	
	
	//<selection pane="bottomRight" activeCell="A4" sqref="A4"/>
	
	  var sheetView = writextag('sheetView', kids.join('') || undefined, {
	    showGridLines: opts.showGridLines == false ? '0' : '1',
	    tabSelected: opts.tabSelected === undefined ? '0' : opts.tabSelected,  // see issue #26, need to set WorkbookViews if this is set
	    workbookViewId: opts.workbookViewId === undefined ? '0' : opts.workbookViewId
	  });
	  o[o.length] = writextag('sheetViews', sheetView);
	
	  if (ws['!cols'] !== undefined && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	  o[sidx = o.length] = '<sheetData/>';
	  if (ws['!ref'] !== undefined) {
	    rdata = write_ws_xml_data(ws, opts, idx, wb);
	    if (rdata.length > 0) o[o.length] = (rdata);
	  }
	  if (o.length > sidx + 1) {
	    o[o.length] = ('</sheetData>');
	    o[sidx] = o[sidx].replace("/>", ">");
	  }
	
	  if (ws['!merges'] !== undefined && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
	  if (ws['!pageSetup'] !== undefined) o[o.length] = write_ws_xml_pagesetup(ws['!pageSetup']);
	  if (ws['!rowBreaks'] !== undefined) o[o.length] = write_ws_xml_row_breaks(ws['!rowBreaks']);
	  if (ws['!colBreaks'] !== undefined) o[o.length] = write_ws_xml_col_breaks(ws['!colBreaks']);
	
	  if (o.length > 2) {
	    o[o.length] = ('</worksheet>');
	    o[1] = o[1].replace("/>", ">");
	  }
	  return o.join("");
	}
	
	function write_ws_xml_row_breaks(breaks) {
	  var brk = [];
	  for (var i = 0; i < breaks.length; i++) {
	    var thisBreak = '' + (breaks[i]);
	    var nextBreak = '' + (breaks[i + 1] || '16383');
	    brk.push(writextag('brk', null, {id: thisBreak, max: nextBreak, man: '1'}))
	  }
	  return writextag('rowBreaks', brk.join(' '), {count: brk.length, manualBreakCount: brk.length})
	}
	function write_ws_xml_col_breaks(breaks) {
	  var brk = [];
	  for (var i = 0; i < breaks.length; i++) {
	    var thisBreak = '' + (breaks[i]);
	    var nextBreak = '' + (breaks[i + 1] || '1048575');
	    brk.push(writextag('brk', null, {id: thisBreak, max: nextBreak, man: '1'}))
	  }
	  return writextag('colBreaks', brk.join(' '), {count: brk.length, manualBreakCount: brk.length})
	}
	
	/* [MS-XLSB] 2.4.718 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = [];
		z.r = data.read_shift(4);
		data.l += length-4;
		return z;
	}
	
	/* [MS-XLSB] 2.4.812 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.815 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		/* TODO: pull flags */
		data.l += 19;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	
	/* [MS-XLSB] 2.4.303 BrtCellBlank */
	function parse_BrtCellBlank(data, length) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, val, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(val, o);
	}
	
	
	/* [MS-XLSB] 2.4.304 BrtCellBool */
	function parse_BrtCellBool(data, length) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	
	/* [MS-XLSB] 2.4.305 BrtCellError */
	function parse_BrtCellError(data, length) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'e'];
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellIsst */
	function parse_BrtCellIsst(data, length) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	
	/* [MS-XLSB] 2.4.310 BrtCellReal */
	function parse_BrtCellReal(data, length) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	
	/* [MS-XLSB] 2.4.311 BrtCellRk */
	function parse_BrtCellRk(data, length) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellSt */
	function parse_BrtCellSt(data, length) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	
	/* [MS-XLSB] 2.4.647 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var cell = parse_XLSBCell(data);
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			var formula = parse_XLSBCellParsedFormula(data, length-9);
			o[3] = ""; /* TODO */
		}
		else data.l += length-9;
		return o;
	}
	
	/* [MS-XLSB] 2.4.648 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var cell = parse_XLSBCell(data);
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			var formula = parse_XLSBCellParsedFormula(data, length-9);
			o[3] = ""; /* TODO */
		}
		else data.l += length-9;
		return o;
	}
	
	/* [MS-XLSB] 2.4.649 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			var formula = parse_XLSBCellParsedFormula(data, length - 16);
			o[3] = ""; /* TODO */
		}
		else data.l += length-16;
		return o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var start = data.l;
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			var formula = parse_XLSBCellParsedFormula(data, start + length - data.l);
		}
		else data.l = start + length;
		return o;
	}
	
	/* [MS-XLSB] 2.4.676 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.656 BrtHLink */
	function parse_BrtHLink(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		return {rfx:rfx, relId:relId, loc:loc, tooltip:tooltip, display:display};
	}
	
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, opts, rels) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {};
	
		var ref;
		var refguess = {s: {r:1000000, c:1000000}, e: {r:0, c:0} };
	
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr;
		var mergecells = [];
		recordhopper(data, function ws_parse(val, R) {
			if(end) return;
			switch(R.n) {
				case 'BrtWsDim': ref = val; break;
				case 'BrtRowHdr':
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(row.r);
					break;
	
				case 'BrtFmlaBool':
				case 'BrtFmlaError':
				case 'BrtFmlaNum':
				case 'BrtFmlaString':
				case 'BrtCellBool':
				case 'BrtCellError':
				case 'BrtCellIsst':
				case 'BrtCellReal':
				case 'BrtCellRk':
				case 'BrtCellSt':
					p = {t:val[2]};
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = utf8read(val[1]); break;
					}
					if(opts.cellFormula && val.length > 3) p.f = val[3];
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.ifmt,null,opts);
					s[encode_col(C=val[0].c) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					break;
	
				case 'BrtCellBlank': if(!opts.sheetStubs) break;
					p = {t:'s',v:undefined};
					s[encode_col(C=val[0].c) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					break;
	
				/* Merge Cells */
				case 'BrtBeginMergeCells': break;
				case 'BrtEndMergeCells': break;
				case 'BrtMergeCell': mergecells.push(val); break;
	
				case 'BrtHLink':
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						addr = encode_cell({c:C,r:R});
						if(!s[addr]) s[addr] = {t:'s',v:undefined};
						s[addr].l = val;
					}
					break;
	
				case 'BrtArrFmla': break; // TODO
				case 'BrtShrFmla': break; // TODO
				case 'BrtBeginSheet': break;
				case 'BrtWsProp': break; // TODO
				case 'BrtSheetCalcProp': break; // TODO
				case 'BrtBeginWsViews': break; // TODO
				case 'BrtBeginWsView': break; // TODO
				case 'BrtPane': break; // TODO
				case 'BrtSel': break; // TODO
				case 'BrtEndWsView': break; // TODO
				case 'BrtEndWsViews': break; // TODO
				case 'BrtACBegin': break; // TODO
				case 'BrtRwDescent': break; // TODO
				case 'BrtACEnd': break; // TODO
				case 'BrtWsFmtInfoEx14': break; // TODO
				case 'BrtWsFmtInfo': break; // TODO
				case 'BrtBeginColInfos': break; // TODO
				case 'BrtColInfo': break; // TODO
				case 'BrtEndColInfos': break; // TODO
				case 'BrtBeginSheetData': break; // TODO
				case 'BrtEndSheetData': break; // TODO
				case 'BrtSheetProtection': break; // TODO
				case 'BrtPrintOptions': break; // TODO
				case 'BrtMargins': break; // TODO
				case 'BrtPageSetup': break; // TODO
				case 'BrtFRTBegin': pass = true; break;
				case 'BrtFRTEnd': pass = false; break;
				case 'BrtEndSheet': break; // TODO
				case 'BrtDrawing': break; // TODO
				case 'BrtLegacyDrawing': break; // TODO
				case 'BrtLegacyDrawingHF': break; // TODO
				case 'BrtPhoneticInfo': break; // TODO
				case 'BrtBeginHeaderFooter': break; // TODO
				case 'BrtEndHeaderFooter': break; // TODO
				case 'BrtBrk': break; // TODO
				case 'BrtBeginRwBrk': break; // TODO
				case 'BrtEndRwBrk': break; // TODO
				case 'BrtBeginColBrk': break; // TODO
				case 'BrtEndColBrk': break; // TODO
				case 'BrtBeginUserShViews': break; // TODO
				case 'BrtBeginUserShView': break; // TODO
				case 'BrtEndUserShView': break; // TODO
				case 'BrtEndUserShViews': break; // TODO
				case 'BrtBkHim': break; // TODO
				case 'BrtBeginOleObjects': break; // TODO
				case 'BrtOleObject': break; // TODO
				case 'BrtEndOleObjects': break; // TODO
				case 'BrtBeginListParts': break; // TODO
				case 'BrtListPart': break; // TODO
				case 'BrtEndListParts': break; // TODO
				case 'BrtBeginSortState': break; // TODO
				case 'BrtBeginSortCond': break; // TODO
				case 'BrtEndSortCond': break; // TODO
				case 'BrtEndSortState': break; // TODO
				case 'BrtBeginConditionalFormatting': break; // TODO
				case 'BrtEndConditionalFormatting': break; // TODO
				case 'BrtBeginCFRule': break; // TODO
				case 'BrtEndCFRule': break; // TODO
				case 'BrtBeginDVals': break; // TODO
				case 'BrtDVal': break; // TODO
				case 'BrtEndDVals': break; // TODO
				case 'BrtRangeProtection': break; // TODO
				case 'BrtBeginDCon': break; // TODO
				case 'BrtEndDCon': break; // TODO
				case 'BrtBeginDRefs': break;
				case 'BrtDRef': break;
				case 'BrtEndDRefs': break;
	
				/* ActiveX */
				case 'BrtBeginActiveXControls': break;
				case 'BrtActiveX': break;
				case 'BrtEndActiveXControls': break;
	
				/* AutoFilter */
				case 'BrtBeginAFilter': break;
				case 'BrtEndAFilter': break;
				case 'BrtBeginFilterColumn': break;
				case 'BrtBeginFilters': break;
				case 'BrtFilter': break;
				case 'BrtEndFilters': break;
				case 'BrtEndFilterColumn': break;
				case 'BrtDynamicFilter': break;
				case 'BrtTop10Filter': break;
				case 'BrtBeginCustomFilters': break;
				case 'BrtCustomFilter': break;
				case 'BrtEndCustomFilters': break;
	
				/* Smart Tags */
				case 'BrtBeginSmartTags': break;
				case 'BrtBeginCellSmartTags': break;
				case 'BrtBeginCellSmartTag': break;
				case 'BrtCellSmartTagProperty': break;
				case 'BrtEndCellSmartTag': break;
				case 'BrtEndCellSmartTags': break;
				case 'BrtEndSmartTags': break;
	
				/* Cell Watch */
				case 'BrtBeginCellWatches': break;
				case 'BrtCellWatch': break;
				case 'BrtEndCellWatches': break;
	
				/* Table */
				case 'BrtTable': break;
	
				/* Ignore Cell Errors */
				case 'BrtBeginCellIgnoreECs': break;
				case 'BrtCellIgnoreEC': break;
				case 'BrtEndCellIgnoreECs': break;
	
				default: if(!pass || opts.WTF) throw new Error("Unexpected record " + R.n);
			}
		}, opts);
		if(!s["!ref"] && (refguess.s.r < 1000000 || ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0)) s["!ref"] = encode_range(ref);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows < +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(mergecells.length > 0) s["!merges"] = mergecells;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts) {
		if(cell.v === undefined) return "";
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = {r:R, c:C};
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, cell.v);
					o.t = "s"; break;
				}
				o.t = "str"; break;
			case 'n': break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
		}
		write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
	}
	
	function write_CELLTABLE(ba, ws, idx, opts, wb) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 'BrtBeginSheetData');
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				if(!ws[ref]) continue;
				/* write cell */
				write_ws_bin_cell(ba, ws[ref], R, C, opts);
			}
		}
		write_record(ba, 'BrtEndSheetData');
	}
	
	function write_ws_bin(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var r = safe_decode_range(ws['!ref'] || "A1");
		write_record(ba, "BrtBeginSheet");
		/* [BrtWsProp] */
		write_record(ba, "BrtWsDim", write_BrtWsDim(r));
		/* [WSVIEWS2] */
		/* [WSFMTINFO] */
		/* *COLINFOS */
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		/* [[BrtSheetProtectionIso] BrtSheetProtection] */
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		/* [AUTOFILTER] */
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		/* [MERGECELLS] */
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		/* *BrtHLink */
		/* [BrtPrintOptions] */
		/* [BrtMargins] */
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		/* [IGNOREECS] */
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery', '0'],
		['autoCompressPictures', '1'],
		['backupFile', '0'],
		['checkCompatibility', '0'],
		['codeName', ''],
		['date1904', '0'],
		['dateCompatibility', '1'],
		//['defaultThemeVersion', '0'],
		['filterPrivacy', '0'],
		['hidePivotFieldList', '0'],
		['promptedSolutions', '0'],
		['publishItems', '0'],
		['refreshAllConnections', false],
		['saveExternalLinkValues', '1'],
		['showBorderUnselectedTables', '1'],
		['showInkAnnotation', '1'],
		['showObjects', 'all'],
		['showPivotChartFilter', '0']
		//['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab', '0'],
		['autoFilterDateGrouping', '1'],
		['firstSheet', '0'],
		['minimized', '0'],
		['showHorizontalScroll', '1'],
		['showSheetTabs', '1'],
		['showVerticalScroll', '1'],
		['tabRatio', '600'],
		['visibility', 'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904, 'date1904');
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var pass = false, xmlns = "xmlns";
		data.match(tagregex).forEach(function xml_wb(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing': case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr': delete y[0]; wb.WBProps = y; break;
				case '<workbookPr/>': delete y[0]; wb.WBProps = y; break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection': break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': delete y[0]; wb.WBView.push(y); break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet': delete y[0]; y.name = utf8read(y.name); wb.Sheets.push(y); break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': case '<definedName/>': case '</definedName>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3    customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22   smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7    ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				default: if(!pass && opts.WTF) throw 'unrecognized ' + y[0] + ' in workbook';
			}
		});
		if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	var WB_XML_ROOT = writextag('workbook', null, {
		'xmlns': XMLNS.main[0],
		//'xmlns:mx': XMLNS.mx,
		//'xmlns:s': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		try { return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false"; } catch(e) { return "false"; }
	}
	
	function write_wb_xml(wb, opts) {
		var o = [XML_HEADER];
		o[o.length] = WB_XML_ROOT;
		o[o.length] = (writextag('workbookPr', null, {date1904:safe1904(wb)}));
		o[o.length] = "<sheets>";
		for(var i = 0; i != wb.SheetNames.length; ++i)
			o[o.length] = (writextag('sheet',null,{name:wb.SheetNames[i].substr(0,31), sheetId:""+(i+1), "r:id":"rId"+(i+1)}));
		o[o.length] = "</sheets>";
	
	  var hasPrintHeaders = false;
	  for(var i = 0; i != wb.SheetNames.length; ++i) {
	    var sheetName = wb.SheetNames[i];
	    var sheet = wb.Sheets[sheetName]
	    if (sheet['!printHeader']) {
	      if (sheet['!printHeader'].length !== 2) {
	        throw "!printHeaders must be an array of length 2: "+sheet['!printHeader'];
	
	      }
	      hasPrintHeaders = true;
	    }
	
	  }
	
	  if (hasPrintHeaders) {
	    o[o.length] = '<definedNames>';
	    for(var i = 0; i != wb.SheetNames.length; ++i) {
	      var sheetName = wb.SheetNames[i];
	      var sheet = wb.Sheets[sheetName]
	      if (sheet['!printHeader'] || sheet['!printColumns']) {
	          var printHeader = sheet['!printHeader'];
	          var printColumns = sheet['!printColumns'];
	
	        //Sheet1!$A:$C,Sheet1!$1:$1
	        var range = "";
	
	        if (printColumns)  range += ("'" + sheetName + "'!")  + ("$" + printColumns[0] + ":$" + printColumns[1]);
	        if (printColumns && printHeader)  range += ","
	        if (printHeader) range += ("'" + sheetName + "'!" ) +  ("$" + printHeader[0] + ":$" + printHeader[1]);
	
	        console.log("-----------------------------")
	        console.log(range)
	        o[o.length] = (writextag('definedName', range, {
	          "name":"_xlnm.Print_Titles",
	          localSheetId : ''+i
	        }))
	      }
	    }
	    o[o.length] = '</definedNames>';
	  }
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.301 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.hsState = data.read_shift(4); //ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.hsState);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.substr(0,31), o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.807 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		data.read_shift(4);
		var dwThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		return [dwThemeVersion, strName];
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var pass = false, z;
	
		recordhopper(data, function hopper_wb(val, R) {
			switch(R.n) {
				case 'BrtBundleSh': wb.Sheets.push(val); break;
	
				case 'BrtBeginBook': break;
				case 'BrtFileVersion': break;
				case 'BrtWbProp': break;
				case 'BrtACBegin': break;
				case 'BrtAbsPath15': break;
				case 'BrtACEnd': break;
				case 'BrtWbFactoid': break;
				/*case 'BrtBookProtectionIso': break;*/
				case 'BrtBookProtection': break;
				case 'BrtBeginBookViews': break;
				case 'BrtBookView': break;
				case 'BrtEndBookViews': break;
				case 'BrtBeginBundleShs': break;
				case 'BrtEndBundleShs': break;
				case 'BrtBeginFnGroup': break;
				case 'BrtEndFnGroup': break;
				case 'BrtBeginExternals': break;
				case 'BrtSupSelf': break;
				case 'BrtSupBookSrc': break;
				case 'BrtExternSheet': break;
				case 'BrtEndExternals': break;
				case 'BrtName': break;
				case 'BrtCalcProp': break;
				case 'BrtUserBookView': break;
				case 'BrtBeginPivotCacheIDs': break;
				case 'BrtBeginPivotCacheID': break;
				case 'BrtEndPivotCacheID': break;
				case 'BrtEndPivotCacheIDs': break;
				case 'BrtWebOpt': break;
				case 'BrtFileRecover': break;
				case 'BrtFileSharing': break;
				/*case 'BrtBeginWebPubItems': break;
				case 'BrtBeginWebPubItem': break;
				case 'BrtEndWebPubItem': break;
				case 'BrtEndWebPubItems': break;*/
	
				/* Smart Tags */
				case 'BrtBeginSmartTagTypes': break;
				case 'BrtSmartTagType': break;
				case 'BrtEndSmartTagTypes': break;
	
				case 'BrtFRTBegin': pass = true; break;
				case 'BrtFRTArchID$': break;
				case 'BrtWorkBookPr15': break;
				case 'BrtFRTEnd': pass = false; break;
				case 'BrtEndBook': break;
				default: if(!pass || opts.WTF) throw new Error("Unexpected record " + R.n);
			}
		});
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function write_BUNDLESHS(ba, wb, opts) {
		write_record(ba, "BrtBeginBundleShs");
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var d = { hsState: 0, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
		}
		write_record(ba, "BrtEndBundleShs");
	}
	
	/* [MS-XLSB] 2.4.643 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		o.length = o.l;
		return o;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function write_BOOKVIEWS(ba, wb, opts) {
		write_record(ba, "BrtBeginBookViews");
		/* 1*(BrtBookView *FRT) */
		write_record(ba, "BrtEndBookViews");
	}
	
	/* [MS-XLSB] 2.4.302 BrtCalcProp */
	function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); /* force recalc */
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}
	
	function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.7.60 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginBook");
		write_record(ba, "BrtFileVersion", write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, "BrtWbProp", write_BrtWbProp());
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		write_record(ba, "BrtCalcProp", write_BrtCalcProp());
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		write_record(ba, "BrtFileRecover", write_BrtFileRecover());
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, "BrtEndBook");
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		return (name.substr(-4)===".bin" ? parse_wb_bin : parse_wb_xml)(data, opts);
	}
	
	function parse_ws(data, name, opts, rels) {
		return (name.substr(-4)===".bin" ? parse_ws_bin : parse_ws_xml)(data, opts, rels);
	}
	
	function parse_sty(data, name, opts) {
		return (name.substr(-4)===".bin" ? parse_sty_bin : parse_sty_xml)(data, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		return (name.substr(-4)===".bin" ? parse_sst_bin : parse_sst_xml)(data, opts);
	}
	
	function parse_cmnt(data, name, opts) {
		return (name.substr(-4)===".bin" ? parse_comments_bin : parse_comments_xml)(data, opts);
	}
	
	function parse_cc(data, name, opts) {
		return (name.substr(-4)===".bin" ? parse_cc_bin : parse_cc_xml)(data, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.substr(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb) {
		return (name.substr(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb);
	}
	
	function write_sty(data, name, opts) {
		return (name.substr(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.substr(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	/*
	function write_cmnt(data, name, opts) {
		return (name.substr(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	
	function write_cc(data, name, opts) {
		return (name.substr(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	var _chr = function(c) { return String.fromCharCode(c); };
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = []; if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
			if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].substr(1,y[2].length-2);
			else {
				if(y[1].substr(0,6) === "xmlns:") w = "xmlns"+y[1].substr(6);
				else w = y[1].substr(j+1);
				z[w] = y[2].substr(1,y[2].length-2);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
			if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].substr(1,y[2].length-2);
			else {
				if(y[1].substr(0,6) === "xmlns:") w = "xmlns"+y[1].substr(6);
				else w = y[1].substr(j+1);
				z[w] = y[2].substr(1,y[2].length-2);
			}
		}
		return z;
	}
	
	// ----
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF._general(value);
		return SSF.format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, Rn, cp, val) {
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": val = parsexmlbool(val); break;
			case "i2": case "int": val = parseInt(val, 10); break;
			case "r4": case "float": val = parseFloat(val); break;
			case "date": case "dateTime.tz": val = new Date(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw "bad custprop:" + cp[0];
		}
		Custprops[unescapexml(Rn[3])] = val;
	}
	
	function safe_format_xlml(cell, nf, o) {
		try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
					else cell.w = SSF._general_num(cell.v);
				}
				else cell.w = SSF._general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
			if(o.cellNF) cell.z = XLMLFormatMap[nf]||nf||"General";
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = xml.indexOf("<") > -1 ? ss : cell.r;
				break;
			case 'DateTime':
				cell.v = (Date.parse(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v >= 1 && cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; cell.w = xml; break;
			default: cell.t = 's'; cell.v = xlml_fixstr(ss); break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula != null && cell.Formula) {
			cell.f = rc_to_a1(unescapexml(cell.Formula), base);
			cell.Formula = undefined;
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		cell.ixfe = cell.StyleID !== undefined ? cell.StyleID : 'Default';
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v;
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		throw "badf";
	}
	
	/* TODO: Everything */
	var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	function parse_xlml_xml(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var state = [], tmp;
		var sheets = {}, sheetnames = [], cursheet = {}, sheetname = "";
		var table = {}, cell = {}, row = {}, dtag, didx;
		var c = 0, r = 0;
		var refguess = {s: {r:1000000, c:1000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var mergecells = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = {};
		var comments = [], comment = {};
		var cstys = [], csty;
		xlmlregex.lastIndex = 0;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'Data':
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]=="Comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'Cell':
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) cursheet[encode_col(c) + encode_row(r)] = cell;
					if(cell.HRef) {
						cell.l = {Target:cell.HRef, tooltip:cell.HRefScreenTip};
						cell.HRef = cell.HRefScreenTip = undefined;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						var cc = c + (parseInt(cell.MergeAcross,10)|0);
						var rr = r + (parseInt(cell.MergeDown,10)|0);
						mergecells.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					++c;
					if(cell.MergeAcross) c += +cell.MergeAcross;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].substr(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'Row':
				if(Rn[1]==='/' || Rn[0].substr(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].substr(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
				}
				break;
			case 'Worksheet': /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) cursheet["!ref"] = encode_range(refguess);
					if(mergecells.length) cursheet["!merges"] = mergecells;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:1000000, c:1000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = tmp.Name;
					cursheet = {};
					mergecells = [];
				}
				break;
			case 'Table':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					table = xlml_parsexmltag(Rn[0]);
					state.push([Rn[3], false]);
					cstys = [];
				}
				break;
	
			case 'Style':
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'NumberFormat':
				stag.nf = xlml_parsexmltag(Rn[0]).Format || "General";
				break;
	
			case 'Column':
				if(state[state.length-1][0] !== 'Table') break;
				csty = xlml_parsexmltag(Rn[0]);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = csty;
				break;
	
			case 'NamedRange': break;
			case 'NamedCell': break;
			case 'B': break;
			case 'I': break;
			case 'U': break;
			case 'S': break;
			case 'Sub': break;
			case 'Sup': break;
			case 'Span': break;
			case 'Border': break;
			case 'Alignment': break;
			case 'Borders': break;
			case 'Font':
				if(Rn[0].substr(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'Interior':
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'Protection': break;
	
			case 'Author':
			case 'Title':
			case 'Description':
			case 'Created':
			case 'Keywords':
			case 'Subject':
			case 'Category':
			case 'Company':
			case 'LastAuthor':
			case 'LastSaved':
			case 'LastPrinted':
			case 'Version':
			case 'Revision':
			case 'TotalTime':
			case 'HyperlinkBase':
			case 'Manager':
				if(Rn[0].substr(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, Rn[3], str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'Paragraphs': break;
	
			case 'Styles':
			case 'Workbook':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else state.push([Rn[3], false]);
				break;
	
			case 'Comment':
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = {a:tmp.Author};
				}
				break;
	
			case 'Name': break;
	
			case 'ComponentOptions':
			case 'DocumentProperties':
			case 'CustomDocumentProperties':
			case 'OfficeDocumentSettings':
			case 'PivotTable':
			case 'PivotCache':
			case 'Names':
			case 'MapInfo':
			case 'PageBreaks':
			case 'QueryTable':
			case 'DataValidation':
			case 'AutoFilter':
			case 'Sorting':
			case 'Schema':
			case 'data':
			case 'ConditionalFormatting':
			case 'SmartTagType':
			case 'SmartTags':
			case 'ExcelWorkbook':
			case 'WorkbookOptions':
			case 'WorksheetOptions':
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			default:
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'OfficeDocumentSettings': switch(Rn[3]) {
						case 'AllowPNG': break;
						case 'RemovePersonalInformation': break;
						case 'DownloadComponents': break;
						case 'LocationOfComponents': break;
						case 'Colors': break;
						case 'Color': break;
						case 'Index': break;
						case 'RGB': break;
						case 'PixelsPerInch': break;
						case 'TargetScreenSize': break;
						case 'ReadOnlyRecommended': break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'ComponentOptions': switch(Rn[3]) {
						case 'Toolbar': break;
						case 'HideOfficeLogo': break;
						case 'SpreadsheetAutoFit': break;
						case 'Label': break;
						case 'Caption': break;
						case 'MaxHeight': break;
						case 'MaxWidth': break;
						case 'NextSheetNumber': break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'ExcelWorkbook': switch(Rn[3]) {
						case 'WindowHeight': break;
						case 'WindowWidth': break;
						case 'WindowTopX': break;
						case 'WindowTopY': break;
						case 'TabRatio': break;
						case 'ProtectStructure': break;
						case 'ProtectWindows': break;
						case 'ActiveSheet': break;
						case 'DisplayInkNotes': break;
						case 'FirstVisibleSheet': break;
						case 'SupBook': break;
						case 'SheetName': break;
						case 'SheetIndex': break;
						case 'SheetIndexFirst': break;
						case 'SheetIndexLast': break;
						case 'Dll': break;
						case 'AcceptLabelsInFormulas': break;
						case 'DoNotSaveLinkValues': break;
						case 'Date1904': break;
						case 'Iteration': break;
						case 'MaxIterations': break;
						case 'MaxChange': break;
						case 'Path': break;
						case 'Xct': break;
						case 'Count': break;
						case 'SelectedSheets': break;
						case 'Calculation': break;
						case 'Uncalced': break;
						case 'StartupPrompt': break;
						case 'Crn': break;
						case 'ExternName': break;
						case 'Formula': break;
						case 'ColFirst': break;
						case 'ColLast': break;
						case 'WantAdvise': break;
						case 'Boolean': break;
						case 'Error': break;
						case 'Text': break;
						case 'OLE': break;
						case 'NoAutoRecover': break;
						case 'PublishObjects': break;
						case 'DoNotCalculateBeforeSave': break;
						case 'Number': break;
						case 'RefModeR1C1': break;
						case 'EmbedSaveSmartTags': break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'WorkbookOptions': switch(Rn[3]) {
						case 'OWCVersion': break;
						case 'Height': break;
						case 'Width': break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'WorksheetOptions': switch(Rn[3]) {
						case 'Unsynced': break;
						case 'Visible': break;
						case 'Print': break;
						case 'Panes': break;
						case 'Scale': break;
						case 'Pane': break;
						case 'Number': break;
						case 'Layout': break;
						case 'Header': break;
						case 'Footer': break;
						case 'PageSetup': break;
						case 'PageMargins': break;
						case 'Selected': break;
						case 'ProtectObjects': break;
						case 'EnableSelection': break;
						case 'ProtectScenarios': break;
						case 'ValidPrinterInfo': break;
						case 'HorizontalResolution': break;
						case 'VerticalResolution': break;
						case 'NumberofCopies': break;
						case 'ActiveRow': break;
						case 'ActiveCol': break;
						case 'ActivePane': break;
						case 'TopRowVisible': break;
						case 'TopRowBottomPane': break;
						case 'LeftColumnVisible': break;
						case 'LeftColumnRightPane': break;
						case 'FitToPage': break;
						case 'RangeSelection': break;
						case 'PaperSizeIndex': break;
						case 'PageLayoutZoom': break;
						case 'PageBreakZoom': break;
						case 'FilterOn': break;
						case 'DoNotDisplayGridlines': break;
						case 'SplitHorizontal': break;
						case 'SplitVertical': break;
						case 'FreezePanes': break;
						case 'FrozenNoSplit': break;
						case 'FitWidth': break;
						case 'FitHeight': break;
						case 'CommentsLayout': break;
						case 'Zoom': break;
						case 'LeftToRight': break;
						case 'Gridlines': break;
						case 'AllowSort': break;
						case 'AllowFilter': break;
						case 'AllowInsertRows': break;
						case 'AllowDeleteRows': break;
						case 'AllowInsertCols': break;
						case 'AllowDeleteCols': break;
						case 'AllowInsertHyperlinks': break;
						case 'AllowFormatCells': break;
						case 'AllowSizeCols': break;
						case 'AllowSizeRows': break;
						case 'NoSummaryRowsBelowDetail': break;
						case 'TabColorIndex': break;
						case 'DoNotDisplayHeadings': break;
						case 'ShowPageLayoutZoom': break;
						case 'NoSummaryColumnsRightDetail': break;
						case 'BlackAndWhite': break;
						case 'DoNotDisplayZeros': break;
						case 'DisplayPageBreak': break;
						case 'RowColHeadings': break;
						case 'DoNotDisplayOutline': break;
						case 'NoOrientation': break;
						case 'AllowUsePivotTables': break;
						case 'ZeroHeight': break;
						case 'ViewableRange': break;
						case 'Selection': break;
						case 'ProtectContents': break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'PivotTable': case 'PivotCache': switch(Rn[3]) {
						case 'ImmediateItemsOnDrop': break;
						case 'ShowPageMultipleItemLabel': break;
						case 'CompactRowIndent': break;
						case 'Location': break;
						case 'PivotField': break;
						case 'Orientation': break;
						case 'LayoutForm': break;
						case 'LayoutSubtotalLocation': break;
						case 'LayoutCompactRow': break;
						case 'Position': break;
						case 'PivotItem': break;
						case 'DataType': break;
						case 'DataField': break;
						case 'SourceName': break;
						case 'ParentField': break;
						case 'PTLineItems': break;
						case 'PTLineItem': break;
						case 'CountOfSameItems': break;
						case 'Item': break;
						case 'ItemType': break;
						case 'PTSource': break;
						case 'CacheIndex': break;
						case 'ConsolidationReference': break;
						case 'FileName': break;
						case 'Reference': break;
						case 'NoColumnGrand': break;
						case 'NoRowGrand': break;
						case 'BlankLineAfterItems': break;
						case 'Hidden': break;
						case 'Subtotal': break;
						case 'BaseField': break;
						case 'MapChildItems': break;
						case 'Function': break;
						case 'RefreshOnFileOpen': break;
						case 'PrintSetTitles': break;
						case 'MergeLabels': break;
						case 'DefaultVersion': break;
						case 'RefreshName': break;
						case 'RefreshDate': break;
						case 'RefreshDateCopy': break;
						case 'VersionLastRefresh': break;
						case 'VersionLastUpdate': break;
						case 'VersionUpdateableMin': break;
						case 'VersionRefreshableMin': break;
						case 'Calculation': break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'PageBreaks': switch(Rn[3]) {
						case 'ColBreaks': break;
						case 'ColBreak': break;
						case 'RowBreaks': break;
						case 'RowBreak': break;
						case 'ColStart': break;
						case 'ColEnd': break;
						case 'RowEnd': break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'AutoFilter': switch(Rn[3]) {
						case 'AutoFilterColumn': break;
						case 'AutoFilterCondition': break;
						case 'AutoFilterAnd': break;
						case 'AutoFilterOr': break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'QueryTable': switch(Rn[3]) {
						case 'Id': break;
						case 'AutoFormatFont': break;
						case 'AutoFormatPattern': break;
						case 'QuerySource': break;
						case 'QueryType': break;
						case 'EnableRedirections': break;
						case 'RefreshedInXl9': break;
						case 'URLString': break;
						case 'HTMLTables': break;
						case 'Connection': break;
						case 'CommandText': break;
						case 'RefreshInfo': break;
						case 'NoTitles': break;
						case 'NextId': break;
						case 'ColumnInfo': break;
						case 'OverwriteCells': break;
						case 'DoNotPromptForFile': break;
						case 'TextWizardSettings': break;
						case 'Source': break;
						case 'Number': break;
						case 'Decimal': break;
						case 'ThousandSeparator': break;
						case 'TrailingMinusNumbers': break;
						case 'FormatSettings': break;
						case 'FieldType': break;
						case 'Delimiters': break;
						case 'Tab': break;
						case 'Comma': break;
						case 'AutoFormatName': break;
						case 'VersionLastEdit': break;
						case 'VersionLastRefresh': break;
						default: seen = false;
					} break;
	
					/* Sorting */
					case 'Sorting':
					/* ConditionalFormatting */
					case 'ConditionalFormatting':
					/* DataValidation */
					case 'DataValidation': switch(Rn[3]) {
						case 'Range': break;
						case 'Type': break;
						case 'Min': break;
						case 'Max': break;
						case 'Sort': break;
						case 'Descending': break;
						case 'Order': break;
						case 'CaseSensitive': break;
						case 'Value': break;
						case 'ErrorStyle': break;
						case 'ErrorMessage': break;
						case 'ErrorTitle': break;
						case 'CellRangeList': break;
						case 'InputMessage': break;
						case 'InputTitle': break;
						case 'ComboHide': break;
						case 'InputHide': break;
						case 'Condition': break;
						case 'Qualifier': break;
						case 'UseBlank': break;
						case 'Value1': break;
						case 'Value2': break;
						case 'Format': break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'MapInfo': case 'Schema': case 'data': switch(Rn[3]) {
						case 'Map': break;
						case 'Entry': break;
						case 'Range': break;
						case 'XPath': break;
						case 'Field': break;
						case 'XSDType': break;
						case 'FilterOn': break;
						case 'Aggregate': break;
						case 'ElementType': break;
						case 'AttributeType': break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema':
						case 'element':
						case 'complexType':
						case 'datatype':
						case 'all':
						case 'attribute':
						case 'extends': break;
	
						case 'row': break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'SmartTags': break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]==='CustomDocumentProperties') {
					if(Rn[0].substr(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, Rn, cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = {};
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.SSF = SSF.get_table();
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64.decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(data.map(_chr).join(""), opts);
		}
	}
	
	function write_xlml(wb, opts) { }
	
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	
		/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		var l = 28, m;
		m = __lpstr(o, l);
		l += 4 + __readUInt32LE(o,l);
		v.UserType = m;
	
		/* [MS-OLEDS] 2.3.1 ClipboardFormatOrAnsiString */
		m = __readUInt32LE(o,l); l+= 4;
		switch(m) {
			case 0x00000000: break;
			case 0xffffffff: case 0xfffffffe: l+=4; break;
			default:
				if(m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
				l += m;
		}
	
		m = __lpstr(o, l); l += m.length === 0 ? 0 : 5 + m.length; v.Reserved1 = m;
	
		if((m = __readUInt32LE(o,l)) !== 0x71b2e9f4) return v;
		throw "Unsupported Unicode Extension";
	}
	
	/* 2.4.58 Continue logic */
	function slurp(R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu_decrypt) switch(R.n) {
		case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': break;
		default:
			if(d.length === 0) break;
			opts.enc.insitu_decrypt(d);
		}
		bufs.push(d);
		blob.l += l;
		var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
		while(next != null && next.n === 'Continue') {
			l = __readUInt16LE(blob,blob.l+2);
			bufs.push(blob.slice(blob.l+4,blob.l+4+l));
			blob.l += 4+l;
			next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
		}
		var b = bconcat(bufs);
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(!p.XF) return;
		try {
			var fmtid = p.XF.ifmt||0;
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else p.w = SSF._general(p.v);
			}
			else p.w = SSF.format(fmtid,p.v, {date1904:date1904||false});
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function make_cell(val, ixfe, t) {
		return {v:val, ixfe:ixfe, t:t};
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = {opts:{}};
		var Sheets = {};
		var out = {};
		var Directory = {};
		var found_sheet = false;
		var range = {};
		var last_formula = null;
		var sst = [];
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell, cc, cmnt, rng, rngC, rngR;
		var shared_formulae = {};
		var array_formulae = []; /* TODO: something more clever */
		var temp_val;
		var country;
		var cell_valid = true;
		var XFs = []; /* XF records */
		var palette = [];
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType) return;
			line.s = {};
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(!cell_valid) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line);
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(range.s) {
				if(cell.r < range.s.r) range.s.r = cell.r;
				if(cell.c < range.s.c) range.s.c = cell.c;
			}
			if(range.e) {
				if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
				if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			}
			if(options.sheetRows && lastcell.r >= options.sheetRows) cell_valid = false;
			else out[last_cell] = line;
		};
		var opts = {
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: shared_formulae, // shared formulae by address
			arrayf: array_formulae, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			wtf: false
		};
		if(options.password) opts.password = options.password;
		var mergecells = [];
		var objects = [];
		var supbooks = [[]]; // 1-indexed, will hold extern names
		var sbc = 0, sbci = 0, sbcli = 0;
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		var last_Rn = '';
		var file_depth = 0; /* TODO: make a real stack */
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
	
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_Rn === 'EOF') break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2)), y;
			var R = XLSRecordEnum[RecordType];
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
				}
				last_Rn = R.n;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType) throw "rt mismatch";
					if(R.r == 12){ blob.l += 10; length -= 10; } // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val;
				if(R.n === 'EOF') val = R.f(blob, length, opts);
				else val = slurp(R, blob, length, opts);
				var Rn = R.n;
				/* BIFF5 overrides */
				if(opts.biff === 5 || opts.biff === 2) switch(Rn) {
					case 'Lbl': Rn = 'Label'; break;
				}
				/* nested switch statements to workaround V8 128 limit */
				switch(Rn) {
					/* Workbook Options */
					case 'Date1904': wb.opts.Date1904 = val; break;
					case 'WriteProtect': wb.opts.WriteProtect = true; break;
					case 'FilePass':
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(opts.WTF) console.error(val);
						if(!options.password) throw new Error("File is password-protected");
						if(val.Type !== 0) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 'WriteAccess': opts.lastuser = val; break;
					case 'FileSharing': break; //TODO
					case 'CodePage':
						/* overrides based on test cases */
						if(val === 0x5212) val = 1200;
						else if(val === 0x8001) val = 1252;
						opts.codepage = val;
						set_cp(val);
						break;
					case 'RRTabId': opts.rrtabid = val; break;
					case 'WinProtect': opts.winlocked = val; break;
					case 'Template': break; // TODO
					case 'RefreshAll': wb.opts.RefreshAll = val; break;
					case 'BookBool': break; // TODO
					case 'UsesELFs': /* if(val) console.error("Unsupported ELFs"); */ break;
					case 'MTRSettings': {
						if(val[0] && val[1]) throw "Unsupported threads: " + val;
					} break; // TODO: actually support threads
					case 'CalcCount': wb.opts.CalcCount = val; break;
					case 'CalcDelta': wb.opts.CalcDelta = val; break;
					case 'CalcIter': wb.opts.CalcIter = val; break;
					case 'CalcMode': wb.opts.CalcMode = val; break;
					case 'CalcPrecision': wb.opts.CalcPrecision = val; break;
					case 'CalcSaveRecalc': wb.opts.CalcSaveRecalc = val; break;
					case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 'Uncalced': break;
					case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
					case 'WsBool': break; // TODO
					case 'XF': XFs.push(val); break;
					case 'ExtSST': break; // TODO
					case 'BookExt': break; // TODO
					case 'RichTextStream': break;
					case 'BkHim': break;
	
					case 'SupBook': supbooks[++sbc] = [val]; sbci = 0; break;
					case 'ExternName': supbooks[sbc][++sbci] = val; break;
					case 'Index': break; // TODO
					case 'Lbl': supbooks[0][++sbcli] = val; break;
					case 'ExternSheet': supbooks[sbc] = supbooks[sbc].concat(val); sbci += val.length; break;
	
					case 'Protect': out["!protect"] = val; break; /* for sheet or book */
					case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/
	
					case 'BoundSheet8': {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 'EOF': {
						if(--file_depth) break;
						if(range.e) {
							out["!range"] = range;
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								range.e.r++; range.e.c++;
							}
							if(mergecells.length > 0) out["!merges"] = mergecells;
							if(objects.length > 0) out["!objects"] = objects;
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = {};
					} break;
					case 'BOF': {
						if(opts.biff !== 8);
						else if(val.BIFFVer === 0x0500) opts.biff = 5;
						else if(val.BIFFVer === 0x0002) opts.biff = 2;
						else if(val.BIFFVer === 0x0007) opts.biff = 2;
						if(file_depth++) break;
						cell_valid = true;
						out = {};
						if(opts.biff === 2) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						mergecells = [];
						objects = [];
					} break;
					case 'Number': case 'BIFF2NUM': {
						temp_val = {ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:'n'};
						if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'BoolErr': {
						temp_val = {ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t};
						if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'RK': {
						temp_val = {ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'};
						if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulRk': {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= {ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'};
							if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 'Formula': {
						switch(val.val) {
							case 'String': last_formula = val; break;
							case 'Array Formula': throw "Array Formula unsupported";
							default:
								temp_val = {v:val.val, ixfe:val.cell.ixfe, t:val.tt};
								temp_val.XF = XFs[temp_val.ixfe];
								if(options.cellFormula) temp_val.f = "="+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
								addcell(val.cell, temp_val, options);
								last_formula = val;
						}
					} break;
					case 'String': {
						if(last_formula) {
							last_formula.val = val;
							temp_val = {v:last_formula.val, ixfe:last_formula.cell.ixfe, t:'s'};
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) temp_val.f = "="+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						}
					} break;
					case 'Array': {
						array_formulae.push(val);
					} break;
					case 'ShrFmla': {
						if(!cell_valid) break;
						//if(options.cellFormula) out[last_cell].f = stringify_formula(val[0], range, lastcell, supbooks, opts);
						/* TODO: capture range */
						shared_formulae[encode_cell(last_formula.cell)]= val[0];
					} break;
					case 'LabelSst':
						//temp_val={v:sst[val.isst].t, ixfe:val.ixfe, t:'s'};
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 'Label': case 'BIFF2STR':
						/* Some writers erroneously write Label */
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(temp_val.XF) safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 'Dimensions': {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 'SST': {
						sst = val;
					} break;
					case 'Format': { /* val = [id, fmt] */
						SSF.load(val[1], val[0]);
					} break;
	
					case 'MergeCells': mergecells = mergecells.concat(val); break;
	
					case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
					case 'TxO': opts.lastobj.TxO = val; break;
	
					case 'HLink': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC)
								if(out[encode_cell({c:rngC,r:rngR})])
									out[encode_cell({c:rngC,r:rngR})].l = val[1];
					} break;
					case 'HLinkTooltip': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC)
								if(out[encode_cell({c:rngC,r:rngR})])
									out[encode_cell({c:rngC,r:rngR})].l.tooltip = val[1];
					} break;
	
					/* Comments */
					case 'Note': {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) break;
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
	
					default: switch(R.n) { /* nested */
					case 'ClrtClient': break;
					case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;
	
					case 'NameCmt': break;
					case 'Header': break; // TODO
					case 'Footer': break; // TODO
					case 'HCenter': break; // TODO
					case 'VCenter': break; // TODO
					case 'Pls': break; // TODO
					case 'Setup': break; // TODO
					case 'DefColWidth': break; // TODO
					case 'GCW': break;
					case 'LHRecord': break;
					case 'ColInfo': break; // TODO
					case 'Row': break; // TODO
					case 'DBCell': break; // TODO
					case 'MulBlank': break; // TODO
					case 'EntExU2': break; // TODO
					case 'SxView': break; // TODO
					case 'Sxvd': break; // TODO
					case 'SXVI': break; // TODO
					case 'SXVDEx': break; // TODO
					case 'SxIvd': break; // TODO
					case 'SXDI': break; // TODO
					case 'SXLI': break; // TODO
					case 'SXEx': break; // TODO
					case 'QsiSXTag': break; // TODO
					case 'Selection': break;
					case 'Feat': break;
					case 'FeatHdr': case 'FeatHdr11': break;
					case 'Feature11': case 'Feature12': case 'List12': break;
					case 'Blank': break;
					case 'Country': country = val; break;
					case 'RecalcId': break;
					case 'DefaultRowHeight': case 'DxGCol': break; // TODO: htmlify
					case 'Fbi': case 'Fbi2': case 'GelFrame': break;
					case 'Font': break; // TODO
					case 'XFCRC': break; // TODO
					case 'Style': break; // TODO
					case 'StyleExt': break; // TODO
					case 'Palette': palette = val; break; // TODO
					case 'Theme': break; // TODO
					/* Protection */
					case 'ScenarioProtect': break;
					case 'ObjProtect': break;
	
					/* Conditional Formatting */
					case 'CondFmt12': break;
	
					/* Table */
					case 'Table': break; // TODO
					case 'TableStyles': break; // TODO
					case 'TableStyle': break; // TODO
					case 'TableStyleElement': break; // TODO
	
					/* PivotTable */
					case 'SXStreamID': break; // TODO
					case 'SXVS': break; // TODO
					case 'DConRef': break; // TODO
					case 'SXAddl': break; // TODO
					case 'DConBin': break; // TODO
					case 'DConName': break; // TODO
					case 'SXPI': break; // TODO
					case 'SxFormat': break; // TODO
					case 'SxSelect': break; // TODO
					case 'SxRule': break; // TODO
					case 'SxFilt': break; // TODO
					case 'SxItm': break; // TODO
					case 'SxDXF': break; // TODO
	
					/* Scenario Manager */
					case 'ScenMan': break;
	
					/* Data Consolidation */
					case 'DCon': break;
	
					/* Watched Cell */
					case 'CellWatch': break;
	
					/* Print Settings */
					case 'PrintRowCol': break;
					case 'PrintGrid': break;
					case 'PrintSize': break;
	
					case 'XCT': break;
					case 'CRN': break;
	
					case 'Scl': {
						//console.log("Zoom Level:", val[0]/val[1],val);
					} break;
					case 'SheetExt': {
	
					} break;
					case 'SheetExtOptional': {
	
					} break;
	
					/* VBA */
					case 'ObNoMacros': {
	
					} break;
					case 'ObProj': {
	
					} break;
					case 'CodeName': {
	
					} break;
					case 'GUIDTypeLib': {
	
					} break;
	
					case 'WOpt': break; // TODO: WTF?
					case 'PhoneticInfo': break;
	
					case 'OleObjectSize': break;
	
					/* Differential Formatting */
					case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;
	
					/* Data Validation */
					case 'Dv': case 'DVal': break;
	
					/* Data Series */
					case 'BRAI': case 'Series': case 'SeriesText': break;
	
					/* Data Connection */
					case 'DConn': break;
					case 'DbOrParamQry': break;
					case 'DBQueryExt': break;
	
					/* Formatting */
					case 'IFmtRecord': break;
					case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;
	
					/* Explicitly Ignored */
					case 'Excel9File': break;
					case 'Units': break;
					case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': case 'BuiltInFnGroupCount':
					/* View Stuff */
					case 'Window1': case 'Window2': case 'HideObj': case 'GridSet': case 'Guts':
					case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd':
					case 'Pane': break;
					default: switch(R.n) { /* nested */
					/* Chart */
					case 'Dat':
					case 'Begin': case 'End':
					case 'StartBlock': case 'EndBlock':
					case 'Frame': case 'Area':
					case 'Axis': case 'AxisLine': case 'Tick': break;
					case 'AxesUsed':
					case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
					case 'LineFormat': case 'AreaFormat':
					case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
					case 'PlotArea': case 'PlotGrowth': break;
					case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
					case 'DataFormat': case 'SerToCrt': case 'FontX': break;
					case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
					case 'ShtProps': break;
					case 'DefaultText': case 'Text': case 'CatLab': break;
					case 'DataLabExtContents': break;
					case 'Legend': case 'LegendException': break;
					case 'Pie': case 'Scatter': break;
					case 'PieFormat': case 'MarkerFormat': break;
					case 'StartObject': case 'EndObject': break;
					case 'AlRuns': case 'ObjectLink': break;
					case 'SIIndex': break;
					case 'AttachedLabel': case 'YMult': break;
	
					/* Chart Group */
					case 'Line': case 'Bar': break;
					case 'Surf': break;
	
					/* Axis Group */
					case 'AxisParent': break;
					case 'Pos': break;
					case 'ValueRange': break;
	
					/* Pivot Chart */
					case 'SXViewEx9': break; // TODO
					case 'SXViewLink': break;
					case 'PivotChartBits': break;
					case 'SBaseRef': break;
					case 'TextPropsStream': break;
	
					/* Chart Misc */
					case 'LnExt': break;
					case 'MkrExt': break;
					case 'CrtCoopt': break;
	
					/* Query Table */
					case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
					case 'TxtQry': break;
	
					/* Filter */
					case 'FilterMode': break;
					case 'AutoFilter': case 'AutoFilterInfo': break;
					case 'AutoFilter12': break;
					case 'DropDownObjIds': break;
					case 'Sort': break;
					case 'SortData': break;
	
					/* Drawing */
					case 'ShapePropsStream': break;
					case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
					case 'ImData': break;
					/* Pub Stuff */
					case 'WebPub': case 'AutoWebPub':
	
					/* Print Stuff */
					case 'RightMargin': case 'LeftMargin': case 'TopMargin': case 'BottomMargin':
					case 'HeaderFooter': case 'HFPicture': case 'PLV':
					case 'HorizontalPageBreaks': case 'VerticalPageBreaks':
					/* Behavioral */
					case 'Backup': case 'CompressPictures': case 'Compat12': break;
	
					/* Should not Happen */
					case 'Continue': case 'ContinueFrt12': break;
	
					/* Future Records */
					case 'FrtFontList': case 'FrtWrapper': break;
	
					/* BIFF5 records */
					case 'ExternCount': break;
					case 'RString': break;
					case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;
	
					default: switch(R.n) { /* nested */
					/* Miscellaneous */
					case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
					case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
					case 'Name': break;
					default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
				}}}}
			} else blob.l += length;
		}
		var sheetnamesraw = opts.biff === 2 ? ['Sheet1'] : Object.keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		var sheetnames = sheetnamesraw.slice();
		wb.Directory=sheetnamesraw;
		wb.SheetNames=sheetnamesraw;
		if(!options.bookSheets) wb.Sheets=Sheets;
		wb.Preamble=Preamble;
		wb.Strings = sst;
		wb.SSF = SSF.get_table();
		if(opts.enc) wb.Encryption = opts.enc;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		return wb;
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	var CompObj, Summary, Workbook;
	if(cfb.find) {
		CompObj = cfb.find('!CompObj');
		Summary = cfb.find('!SummaryInformation');
		Workbook = cfb.find('/Workbook');
	} else {
		prep_blob(cfb, 0);
		Workbook = {content: cfb};
	}
	
	if(!Workbook) Workbook = cfb.find('/Book');
	var CompObjP, SummaryP, WorkbookP;
	
	if(CompObj) CompObjP = parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = {};
	else {
		if(Workbook) WorkbookP = parse_workbook(Workbook.content, options, !!Workbook.find);
		else throw new Error("Cannot find Workbook stream");
	}
	
	if(cfb.find) parse_props(cfb);
	
	var props = {};
	for(var y in cfb.Summary) props[y] = cfb.Summary[y];
	for(y in cfb.DocSummary) props[y] = cfb.DocSummary[y];
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	WorkbookP.CompObjP = CompObjP;
	return WorkbookP;
	}
	
	/* TODO: WTF */
	function parse_props(cfb) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = cfb.find('!DocumentSummaryInformation');
		if(DSI) try { cfb.DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI); } catch(e) {}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = cfb.find('!SummaryInformation');
		if(SI) try { cfb.Summary = parse_PropertySetStream(SI, SummaryPIDSI); } catch(e) {}
	}
	
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
		0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
		0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
		0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
		0x0003: { n:"BrtCellError", f:parse_BrtCellError },
		0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
		0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
		0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
		0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
		0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
		0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
		0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
		0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
		0x0010: { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ },
		0x0013: { n:"BrtSSTItem", f:parse_RichStr },
		0x0014: { n:"BrtPCDIMissing", f:parsenoop },
		0x0015: { n:"BrtPCDINumber", f:parsenoop },
		0x0016: { n:"BrtPCDIBoolean", f:parsenoop },
		0x0017: { n:"BrtPCDIError", f:parsenoop },
		0x0018: { n:"BrtPCDIString", f:parsenoop },
		0x0019: { n:"BrtPCDIDatetime", f:parsenoop },
		0x001A: { n:"BrtPCDIIndex", f:parsenoop },
		0x001B: { n:"BrtPCDIAMissing", f:parsenoop },
		0x001C: { n:"BrtPCDIANumber", f:parsenoop },
		0x001D: { n:"BrtPCDIABoolean", f:parsenoop },
		0x001E: { n:"BrtPCDIAError", f:parsenoop },
		0x001F: { n:"BrtPCDIAString", f:parsenoop },
		0x0020: { n:"BrtPCDIADatetime", f:parsenoop },
		0x0021: { n:"BrtPCRRecord", f:parsenoop },
		0x0022: { n:"BrtPCRRecordDt", f:parsenoop },
		0x0023: { n:"BrtFRTBegin", f:parsenoop },
		0x0024: { n:"BrtFRTEnd", f:parsenoop },
		0x0025: { n:"BrtACBegin", f:parsenoop },
		0x0026: { n:"BrtACEnd", f:parsenoop },
		0x0027: { n:"BrtName", f:parsenoop },
		0x0028: { n:"BrtIndexRowBlock", f:parsenoop },
		0x002A: { n:"BrtIndexBlock", f:parsenoop },
		0x002B: { n:"BrtFont", f:parse_BrtFont },
		0x002C: { n:"BrtFmt", f:parse_BrtFmt },
		0x002D: { n:"BrtFill", f:parsenoop },
		0x002E: { n:"BrtBorder", f:parsenoop },
		0x002F: { n:"BrtXF", f:parse_BrtXF },
		0x0030: { n:"BrtStyle", f:parsenoop },
		0x0031: { n:"BrtCellMeta", f:parsenoop },
		0x0032: { n:"BrtValueMeta", f:parsenoop },
		0x0033: { n:"BrtMdb", f:parsenoop },
		0x0034: { n:"BrtBeginFmd", f:parsenoop },
		0x0035: { n:"BrtEndFmd", f:parsenoop },
		0x0036: { n:"BrtBeginMdx", f:parsenoop },
		0x0037: { n:"BrtEndMdx", f:parsenoop },
		0x0038: { n:"BrtBeginMdxTuple", f:parsenoop },
		0x0039: { n:"BrtEndMdxTuple", f:parsenoop },
		0x003A: { n:"BrtMdxMbrIstr", f:parsenoop },
		0x003B: { n:"BrtStr", f:parsenoop },
		0x003C: { n:"BrtColInfo", f:parsenoop },
		0x003E: { n:"BrtCellRString", f:parsenoop },
		0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
		0x0040: { n:"BrtDVal", f:parsenoop },
		0x0041: { n:"BrtSxvcellNum", f:parsenoop },
		0x0042: { n:"BrtSxvcellStr", f:parsenoop },
		0x0043: { n:"BrtSxvcellBool", f:parsenoop },
		0x0044: { n:"BrtSxvcellErr", f:parsenoop },
		0x0045: { n:"BrtSxvcellDate", f:parsenoop },
		0x0046: { n:"BrtSxvcellNil", f:parsenoop },
		0x0080: { n:"BrtFileVersion", f:parsenoop },
		0x0081: { n:"BrtBeginSheet", f:parsenoop },
		0x0082: { n:"BrtEndSheet", f:parsenoop },
		0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
		0x0084: { n:"BrtEndBook", f:parsenoop },
		0x0085: { n:"BrtBeginWsViews", f:parsenoop },
		0x0086: { n:"BrtEndWsViews", f:parsenoop },
		0x0087: { n:"BrtBeginBookViews", f:parsenoop },
		0x0088: { n:"BrtEndBookViews", f:parsenoop },
		0x0089: { n:"BrtBeginWsView", f:parsenoop },
		0x008A: { n:"BrtEndWsView", f:parsenoop },
		0x008B: { n:"BrtBeginCsViews", f:parsenoop },
		0x008C: { n:"BrtEndCsViews", f:parsenoop },
		0x008D: { n:"BrtBeginCsView", f:parsenoop },
		0x008E: { n:"BrtEndCsView", f:parsenoop },
		0x008F: { n:"BrtBeginBundleShs", f:parsenoop },
		0x0090: { n:"BrtEndBundleShs", f:parsenoop },
		0x0091: { n:"BrtBeginSheetData", f:parsenoop },
		0x0092: { n:"BrtEndSheetData", f:parsenoop },
		0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
		0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
		0x0097: { n:"BrtPane", f:parsenoop },
		0x0098: { n:"BrtSel", f:parsenoop },
		0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
		0x009A: { n:"BrtWbFactoid", f:parsenoop },
		0x009B: { n:"BrtFileRecover", f:parsenoop },
		0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
		0x009D: { n:"BrtCalcProp", f:parsenoop },
		0x009E: { n:"BrtBookView", f:parsenoop },
		0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
		0x00A0: { n:"BrtEndSst", f:parsenoop },
		0x00A1: { n:"BrtBeginAFilter", f:parsenoop },
		0x00A2: { n:"BrtEndAFilter", f:parsenoop },
		0x00A3: { n:"BrtBeginFilterColumn", f:parsenoop },
		0x00A4: { n:"BrtEndFilterColumn", f:parsenoop },
		0x00A5: { n:"BrtBeginFilters", f:parsenoop },
		0x00A6: { n:"BrtEndFilters", f:parsenoop },
		0x00A7: { n:"BrtFilter", f:parsenoop },
		0x00A8: { n:"BrtColorFilter", f:parsenoop },
		0x00A9: { n:"BrtIconFilter", f:parsenoop },
		0x00AA: { n:"BrtTop10Filter", f:parsenoop },
		0x00AB: { n:"BrtDynamicFilter", f:parsenoop },
		0x00AC: { n:"BrtBeginCustomFilters", f:parsenoop },
		0x00AD: { n:"BrtEndCustomFilters", f:parsenoop },
		0x00AE: { n:"BrtCustomFilter", f:parsenoop },
		0x00AF: { n:"BrtAFilterDateGroupItem", f:parsenoop },
		0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
		0x00B1: { n:"BrtBeginMergeCells", f:parsenoop },
		0x00B2: { n:"BrtEndMergeCells", f:parsenoop },
		0x00B3: { n:"BrtBeginPivotCacheDef", f:parsenoop },
		0x00B4: { n:"BrtEndPivotCacheDef", f:parsenoop },
		0x00B5: { n:"BrtBeginPCDFields", f:parsenoop },
		0x00B6: { n:"BrtEndPCDFields", f:parsenoop },
		0x00B7: { n:"BrtBeginPCDField", f:parsenoop },
		0x00B8: { n:"BrtEndPCDField", f:parsenoop },
		0x00B9: { n:"BrtBeginPCDSource", f:parsenoop },
		0x00BA: { n:"BrtEndPCDSource", f:parsenoop },
		0x00BB: { n:"BrtBeginPCDSRange", f:parsenoop },
		0x00BC: { n:"BrtEndPCDSRange", f:parsenoop },
		0x00BD: { n:"BrtBeginPCDFAtbl", f:parsenoop },
		0x00BE: { n:"BrtEndPCDFAtbl", f:parsenoop },
		0x00BF: { n:"BrtBeginPCDIRun", f:parsenoop },
		0x00C0: { n:"BrtEndPCDIRun", f:parsenoop },
		0x00C1: { n:"BrtBeginPivotCacheRecords", f:parsenoop },
		0x00C2: { n:"BrtEndPivotCacheRecords", f:parsenoop },
		0x00C3: { n:"BrtBeginPCDHierarchies", f:parsenoop },
		0x00C4: { n:"BrtEndPCDHierarchies", f:parsenoop },
		0x00C5: { n:"BrtBeginPCDHierarchy", f:parsenoop },
		0x00C6: { n:"BrtEndPCDHierarchy", f:parsenoop },
		0x00C7: { n:"BrtBeginPCDHFieldsUsage", f:parsenoop },
		0x00C8: { n:"BrtEndPCDHFieldsUsage", f:parsenoop },
		0x00C9: { n:"BrtBeginExtConnection", f:parsenoop },
		0x00CA: { n:"BrtEndExtConnection", f:parsenoop },
		0x00CB: { n:"BrtBeginECDbProps", f:parsenoop },
		0x00CC: { n:"BrtEndECDbProps", f:parsenoop },
		0x00CD: { n:"BrtBeginECOlapProps", f:parsenoop },
		0x00CE: { n:"BrtEndECOlapProps", f:parsenoop },
		0x00CF: { n:"BrtBeginPCDSConsol", f:parsenoop },
		0x00D0: { n:"BrtEndPCDSConsol", f:parsenoop },
		0x00D1: { n:"BrtBeginPCDSCPages", f:parsenoop },
		0x00D2: { n:"BrtEndPCDSCPages", f:parsenoop },
		0x00D3: { n:"BrtBeginPCDSCPage", f:parsenoop },
		0x00D4: { n:"BrtEndPCDSCPage", f:parsenoop },
		0x00D5: { n:"BrtBeginPCDSCPItem", f:parsenoop },
		0x00D6: { n:"BrtEndPCDSCPItem", f:parsenoop },
		0x00D7: { n:"BrtBeginPCDSCSets", f:parsenoop },
		0x00D8: { n:"BrtEndPCDSCSets", f:parsenoop },
		0x00D9: { n:"BrtBeginPCDSCSet", f:parsenoop },
		0x00DA: { n:"BrtEndPCDSCSet", f:parsenoop },
		0x00DB: { n:"BrtBeginPCDFGroup", f:parsenoop },
		0x00DC: { n:"BrtEndPCDFGroup", f:parsenoop },
		0x00DD: { n:"BrtBeginPCDFGItems", f:parsenoop },
		0x00DE: { n:"BrtEndPCDFGItems", f:parsenoop },
		0x00DF: { n:"BrtBeginPCDFGRange", f:parsenoop },
		0x00E0: { n:"BrtEndPCDFGRange", f:parsenoop },
		0x00E1: { n:"BrtBeginPCDFGDiscrete", f:parsenoop },
		0x00E2: { n:"BrtEndPCDFGDiscrete", f:parsenoop },
		0x00E3: { n:"BrtBeginPCDSDTupleCache", f:parsenoop },
		0x00E4: { n:"BrtEndPCDSDTupleCache", f:parsenoop },
		0x00E5: { n:"BrtBeginPCDSDTCEntries", f:parsenoop },
		0x00E6: { n:"BrtEndPCDSDTCEntries", f:parsenoop },
		0x00E7: { n:"BrtBeginPCDSDTCEMembers", f:parsenoop },
		0x00E8: { n:"BrtEndPCDSDTCEMembers", f:parsenoop },
		0x00E9: { n:"BrtBeginPCDSDTCEMember", f:parsenoop },
		0x00EA: { n:"BrtEndPCDSDTCEMember", f:parsenoop },
		0x00EB: { n:"BrtBeginPCDSDTCQueries", f:parsenoop },
		0x00EC: { n:"BrtEndPCDSDTCQueries", f:parsenoop },
		0x00ED: { n:"BrtBeginPCDSDTCQuery", f:parsenoop },
		0x00EE: { n:"BrtEndPCDSDTCQuery", f:parsenoop },
		0x00EF: { n:"BrtBeginPCDSDTCSets", f:parsenoop },
		0x00F0: { n:"BrtEndPCDSDTCSets", f:parsenoop },
		0x00F1: { n:"BrtBeginPCDSDTCSet", f:parsenoop },
		0x00F2: { n:"BrtEndPCDSDTCSet", f:parsenoop },
		0x00F3: { n:"BrtBeginPCDCalcItems", f:parsenoop },
		0x00F4: { n:"BrtEndPCDCalcItems", f:parsenoop },
		0x00F5: { n:"BrtBeginPCDCalcItem", f:parsenoop },
		0x00F6: { n:"BrtEndPCDCalcItem", f:parsenoop },
		0x00F7: { n:"BrtBeginPRule", f:parsenoop },
		0x00F8: { n:"BrtEndPRule", f:parsenoop },
		0x00F9: { n:"BrtBeginPRFilters", f:parsenoop },
		0x00FA: { n:"BrtEndPRFilters", f:parsenoop },
		0x00FB: { n:"BrtBeginPRFilter", f:parsenoop },
		0x00FC: { n:"BrtEndPRFilter", f:parsenoop },
		0x00FD: { n:"BrtBeginPNames", f:parsenoop },
		0x00FE: { n:"BrtEndPNames", f:parsenoop },
		0x00FF: { n:"BrtBeginPName", f:parsenoop },
		0x0100: { n:"BrtEndPName", f:parsenoop },
		0x0101: { n:"BrtBeginPNPairs", f:parsenoop },
		0x0102: { n:"BrtEndPNPairs", f:parsenoop },
		0x0103: { n:"BrtBeginPNPair", f:parsenoop },
		0x0104: { n:"BrtEndPNPair", f:parsenoop },
		0x0105: { n:"BrtBeginECWebProps", f:parsenoop },
		0x0106: { n:"BrtEndECWebProps", f:parsenoop },
		0x0107: { n:"BrtBeginEcWpTables", f:parsenoop },
		0x0108: { n:"BrtEndECWPTables", f:parsenoop },
		0x0109: { n:"BrtBeginECParams", f:parsenoop },
		0x010A: { n:"BrtEndECParams", f:parsenoop },
		0x010B: { n:"BrtBeginECParam", f:parsenoop },
		0x010C: { n:"BrtEndECParam", f:parsenoop },
		0x010D: { n:"BrtBeginPCDKPIs", f:parsenoop },
		0x010E: { n:"BrtEndPCDKPIs", f:parsenoop },
		0x010F: { n:"BrtBeginPCDKPI", f:parsenoop },
		0x0110: { n:"BrtEndPCDKPI", f:parsenoop },
		0x0111: { n:"BrtBeginDims", f:parsenoop },
		0x0112: { n:"BrtEndDims", f:parsenoop },
		0x0113: { n:"BrtBeginDim", f:parsenoop },
		0x0114: { n:"BrtEndDim", f:parsenoop },
		0x0115: { n:"BrtIndexPartEnd", f:parsenoop },
		0x0116: { n:"BrtBeginStyleSheet", f:parsenoop },
		0x0117: { n:"BrtEndStyleSheet", f:parsenoop },
		0x0118: { n:"BrtBeginSXView", f:parsenoop },
		0x0119: { n:"BrtEndSXVI", f:parsenoop },
		0x011A: { n:"BrtBeginSXVI", f:parsenoop },
		0x011B: { n:"BrtBeginSXVIs", f:parsenoop },
		0x011C: { n:"BrtEndSXVIs", f:parsenoop },
		0x011D: { n:"BrtBeginSXVD", f:parsenoop },
		0x011E: { n:"BrtEndSXVD", f:parsenoop },
		0x011F: { n:"BrtBeginSXVDs", f:parsenoop },
		0x0120: { n:"BrtEndSXVDs", f:parsenoop },
		0x0121: { n:"BrtBeginSXPI", f:parsenoop },
		0x0122: { n:"BrtEndSXPI", f:parsenoop },
		0x0123: { n:"BrtBeginSXPIs", f:parsenoop },
		0x0124: { n:"BrtEndSXPIs", f:parsenoop },
		0x0125: { n:"BrtBeginSXDI", f:parsenoop },
		0x0126: { n:"BrtEndSXDI", f:parsenoop },
		0x0127: { n:"BrtBeginSXDIs", f:parsenoop },
		0x0128: { n:"BrtEndSXDIs", f:parsenoop },
		0x0129: { n:"BrtBeginSXLI", f:parsenoop },
		0x012A: { n:"BrtEndSXLI", f:parsenoop },
		0x012B: { n:"BrtBeginSXLIRws", f:parsenoop },
		0x012C: { n:"BrtEndSXLIRws", f:parsenoop },
		0x012D: { n:"BrtBeginSXLICols", f:parsenoop },
		0x012E: { n:"BrtEndSXLICols", f:parsenoop },
		0x012F: { n:"BrtBeginSXFormat", f:parsenoop },
		0x0130: { n:"BrtEndSXFormat", f:parsenoop },
		0x0131: { n:"BrtBeginSXFormats", f:parsenoop },
		0x0132: { n:"BrtEndSxFormats", f:parsenoop },
		0x0133: { n:"BrtBeginSxSelect", f:parsenoop },
		0x0134: { n:"BrtEndSxSelect", f:parsenoop },
		0x0135: { n:"BrtBeginISXVDRws", f:parsenoop },
		0x0136: { n:"BrtEndISXVDRws", f:parsenoop },
		0x0137: { n:"BrtBeginISXVDCols", f:parsenoop },
		0x0138: { n:"BrtEndISXVDCols", f:parsenoop },
		0x0139: { n:"BrtEndSXLocation", f:parsenoop },
		0x013A: { n:"BrtBeginSXLocation", f:parsenoop },
		0x013B: { n:"BrtEndSXView", f:parsenoop },
		0x013C: { n:"BrtBeginSXTHs", f:parsenoop },
		0x013D: { n:"BrtEndSXTHs", f:parsenoop },
		0x013E: { n:"BrtBeginSXTH", f:parsenoop },
		0x013F: { n:"BrtEndSXTH", f:parsenoop },
		0x0140: { n:"BrtBeginISXTHRws", f:parsenoop },
		0x0141: { n:"BrtEndISXTHRws", f:parsenoop },
		0x0142: { n:"BrtBeginISXTHCols", f:parsenoop },
		0x0143: { n:"BrtEndISXTHCols", f:parsenoop },
		0x0144: { n:"BrtBeginSXTDMPS", f:parsenoop },
		0x0145: { n:"BrtEndSXTDMPs", f:parsenoop },
		0x0146: { n:"BrtBeginSXTDMP", f:parsenoop },
		0x0147: { n:"BrtEndSXTDMP", f:parsenoop },
		0x0148: { n:"BrtBeginSXTHItems", f:parsenoop },
		0x0149: { n:"BrtEndSXTHItems", f:parsenoop },
		0x014A: { n:"BrtBeginSXTHItem", f:parsenoop },
		0x014B: { n:"BrtEndSXTHItem", f:parsenoop },
		0x014C: { n:"BrtBeginMetadata", f:parsenoop },
		0x014D: { n:"BrtEndMetadata", f:parsenoop },
		0x014E: { n:"BrtBeginEsmdtinfo", f:parsenoop },
		0x014F: { n:"BrtMdtinfo", f:parsenoop },
		0x0150: { n:"BrtEndEsmdtinfo", f:parsenoop },
		0x0151: { n:"BrtBeginEsmdb", f:parsenoop },
		0x0152: { n:"BrtEndEsmdb", f:parsenoop },
		0x0153: { n:"BrtBeginEsfmd", f:parsenoop },
		0x0154: { n:"BrtEndEsfmd", f:parsenoop },
		0x0155: { n:"BrtBeginSingleCells", f:parsenoop },
		0x0156: { n:"BrtEndSingleCells", f:parsenoop },
		0x0157: { n:"BrtBeginList", f:parsenoop },
		0x0158: { n:"BrtEndList", f:parsenoop },
		0x0159: { n:"BrtBeginListCols", f:parsenoop },
		0x015A: { n:"BrtEndListCols", f:parsenoop },
		0x015B: { n:"BrtBeginListCol", f:parsenoop },
		0x015C: { n:"BrtEndListCol", f:parsenoop },
		0x015D: { n:"BrtBeginListXmlCPr", f:parsenoop },
		0x015E: { n:"BrtEndListXmlCPr", f:parsenoop },
		0x015F: { n:"BrtListCCFmla", f:parsenoop },
		0x0160: { n:"BrtListTrFmla", f:parsenoop },
		0x0161: { n:"BrtBeginExternals", f:parsenoop },
		0x0162: { n:"BrtEndExternals", f:parsenoop },
		0x0163: { n:"BrtSupBookSrc", f:parsenoop },
		0x0165: { n:"BrtSupSelf", f:parsenoop },
		0x0166: { n:"BrtSupSame", f:parsenoop },
		0x0167: { n:"BrtSupTabs", f:parsenoop },
		0x0168: { n:"BrtBeginSupBook", f:parsenoop },
		0x0169: { n:"BrtPlaceholderName", f:parsenoop },
		0x016A: { n:"BrtExternSheet", f:parsenoop },
		0x016B: { n:"BrtExternTableStart", f:parsenoop },
		0x016C: { n:"BrtExternTableEnd", f:parsenoop },
		0x016E: { n:"BrtExternRowHdr", f:parsenoop },
		0x016F: { n:"BrtExternCellBlank", f:parsenoop },
		0x0170: { n:"BrtExternCellReal", f:parsenoop },
		0x0171: { n:"BrtExternCellBool", f:parsenoop },
		0x0172: { n:"BrtExternCellError", f:parsenoop },
		0x0173: { n:"BrtExternCellString", f:parsenoop },
		0x0174: { n:"BrtBeginEsmdx", f:parsenoop },
		0x0175: { n:"BrtEndEsmdx", f:parsenoop },
		0x0176: { n:"BrtBeginMdxSet", f:parsenoop },
		0x0177: { n:"BrtEndMdxSet", f:parsenoop },
		0x0178: { n:"BrtBeginMdxMbrProp", f:parsenoop },
		0x0179: { n:"BrtEndMdxMbrProp", f:parsenoop },
		0x017A: { n:"BrtBeginMdxKPI", f:parsenoop },
		0x017B: { n:"BrtEndMdxKPI", f:parsenoop },
		0x017C: { n:"BrtBeginEsstr", f:parsenoop },
		0x017D: { n:"BrtEndEsstr", f:parsenoop },
		0x017E: { n:"BrtBeginPRFItem", f:parsenoop },
		0x017F: { n:"BrtEndPRFItem", f:parsenoop },
		0x0180: { n:"BrtBeginPivotCacheIDs", f:parsenoop },
		0x0181: { n:"BrtEndPivotCacheIDs", f:parsenoop },
		0x0182: { n:"BrtBeginPivotCacheID", f:parsenoop },
		0x0183: { n:"BrtEndPivotCacheID", f:parsenoop },
		0x0184: { n:"BrtBeginISXVIs", f:parsenoop },
		0x0185: { n:"BrtEndISXVIs", f:parsenoop },
		0x0186: { n:"BrtBeginColInfos", f:parsenoop },
		0x0187: { n:"BrtEndColInfos", f:parsenoop },
		0x0188: { n:"BrtBeginRwBrk", f:parsenoop },
		0x0189: { n:"BrtEndRwBrk", f:parsenoop },
		0x018A: { n:"BrtBeginColBrk", f:parsenoop },
		0x018B: { n:"BrtEndColBrk", f:parsenoop },
		0x018C: { n:"BrtBrk", f:parsenoop },
		0x018D: { n:"BrtUserBookView", f:parsenoop },
		0x018E: { n:"BrtInfo", f:parsenoop },
		0x018F: { n:"BrtCUsr", f:parsenoop },
		0x0190: { n:"BrtUsr", f:parsenoop },
		0x0191: { n:"BrtBeginUsers", f:parsenoop },
		0x0193: { n:"BrtEOF", f:parsenoop },
		0x0194: { n:"BrtUCR", f:parsenoop },
		0x0195: { n:"BrtRRInsDel", f:parsenoop },
		0x0196: { n:"BrtRREndInsDel", f:parsenoop },
		0x0197: { n:"BrtRRMove", f:parsenoop },
		0x0198: { n:"BrtRREndMove", f:parsenoop },
		0x0199: { n:"BrtRRChgCell", f:parsenoop },
		0x019A: { n:"BrtRREndChgCell", f:parsenoop },
		0x019B: { n:"BrtRRHeader", f:parsenoop },
		0x019C: { n:"BrtRRUserView", f:parsenoop },
		0x019D: { n:"BrtRRRenSheet", f:parsenoop },
		0x019E: { n:"BrtRRInsertSh", f:parsenoop },
		0x019F: { n:"BrtRRDefName", f:parsenoop },
		0x01A0: { n:"BrtRRNote", f:parsenoop },
		0x01A1: { n:"BrtRRConflict", f:parsenoop },
		0x01A2: { n:"BrtRRTQSIF", f:parsenoop },
		0x01A3: { n:"BrtRRFormat", f:parsenoop },
		0x01A4: { n:"BrtRREndFormat", f:parsenoop },
		0x01A5: { n:"BrtRRAutoFmt", f:parsenoop },
		0x01A6: { n:"BrtBeginUserShViews", f:parsenoop },
		0x01A7: { n:"BrtBeginUserShView", f:parsenoop },
		0x01A8: { n:"BrtEndUserShView", f:parsenoop },
		0x01A9: { n:"BrtEndUserShViews", f:parsenoop },
		0x01AA: { n:"BrtArrFmla", f:parsenoop },
		0x01AB: { n:"BrtShrFmla", f:parsenoop },
		0x01AC: { n:"BrtTable", f:parsenoop },
		0x01AD: { n:"BrtBeginExtConnections", f:parsenoop },
		0x01AE: { n:"BrtEndExtConnections", f:parsenoop },
		0x01AF: { n:"BrtBeginPCDCalcMems", f:parsenoop },
		0x01B0: { n:"BrtEndPCDCalcMems", f:parsenoop },
		0x01B1: { n:"BrtBeginPCDCalcMem", f:parsenoop },
		0x01B2: { n:"BrtEndPCDCalcMem", f:parsenoop },
		0x01B3: { n:"BrtBeginPCDHGLevels", f:parsenoop },
		0x01B4: { n:"BrtEndPCDHGLevels", f:parsenoop },
		0x01B5: { n:"BrtBeginPCDHGLevel", f:parsenoop },
		0x01B6: { n:"BrtEndPCDHGLevel", f:parsenoop },
		0x01B7: { n:"BrtBeginPCDHGLGroups", f:parsenoop },
		0x01B8: { n:"BrtEndPCDHGLGroups", f:parsenoop },
		0x01B9: { n:"BrtBeginPCDHGLGroup", f:parsenoop },
		0x01BA: { n:"BrtEndPCDHGLGroup", f:parsenoop },
		0x01BB: { n:"BrtBeginPCDHGLGMembers", f:parsenoop },
		0x01BC: { n:"BrtEndPCDHGLGMembers", f:parsenoop },
		0x01BD: { n:"BrtBeginPCDHGLGMember", f:parsenoop },
		0x01BE: { n:"BrtEndPCDHGLGMember", f:parsenoop },
		0x01BF: { n:"BrtBeginQSI", f:parsenoop },
		0x01C0: { n:"BrtEndQSI", f:parsenoop },
		0x01C1: { n:"BrtBeginQSIR", f:parsenoop },
		0x01C2: { n:"BrtEndQSIR", f:parsenoop },
		0x01C3: { n:"BrtBeginDeletedNames", f:parsenoop },
		0x01C4: { n:"BrtEndDeletedNames", f:parsenoop },
		0x01C5: { n:"BrtBeginDeletedName", f:parsenoop },
		0x01C6: { n:"BrtEndDeletedName", f:parsenoop },
		0x01C7: { n:"BrtBeginQSIFs", f:parsenoop },
		0x01C8: { n:"BrtEndQSIFs", f:parsenoop },
		0x01C9: { n:"BrtBeginQSIF", f:parsenoop },
		0x01CA: { n:"BrtEndQSIF", f:parsenoop },
		0x01CB: { n:"BrtBeginAutoSortScope", f:parsenoop },
		0x01CC: { n:"BrtEndAutoSortScope", f:parsenoop },
		0x01CD: { n:"BrtBeginConditionalFormatting", f:parsenoop },
		0x01CE: { n:"BrtEndConditionalFormatting", f:parsenoop },
		0x01CF: { n:"BrtBeginCFRule", f:parsenoop },
		0x01D0: { n:"BrtEndCFRule", f:parsenoop },
		0x01D1: { n:"BrtBeginIconSet", f:parsenoop },
		0x01D2: { n:"BrtEndIconSet", f:parsenoop },
		0x01D3: { n:"BrtBeginDatabar", f:parsenoop },
		0x01D4: { n:"BrtEndDatabar", f:parsenoop },
		0x01D5: { n:"BrtBeginColorScale", f:parsenoop },
		0x01D6: { n:"BrtEndColorScale", f:parsenoop },
		0x01D7: { n:"BrtCFVO", f:parsenoop },
		0x01D8: { n:"BrtExternValueMeta", f:parsenoop },
		0x01D9: { n:"BrtBeginColorPalette", f:parsenoop },
		0x01DA: { n:"BrtEndColorPalette", f:parsenoop },
		0x01DB: { n:"BrtIndexedColor", f:parsenoop },
		0x01DC: { n:"BrtMargins", f:parsenoop },
		0x01DD: { n:"BrtPrintOptions", f:parsenoop },
		0x01DE: { n:"BrtPageSetup", f:parsenoop },
		0x01DF: { n:"BrtBeginHeaderFooter", f:parsenoop },
		0x01E0: { n:"BrtEndHeaderFooter", f:parsenoop },
		0x01E1: { n:"BrtBeginSXCrtFormat", f:parsenoop },
		0x01E2: { n:"BrtEndSXCrtFormat", f:parsenoop },
		0x01E3: { n:"BrtBeginSXCrtFormats", f:parsenoop },
		0x01E4: { n:"BrtEndSXCrtFormats", f:parsenoop },
		0x01E5: { n:"BrtWsFmtInfo", f:parsenoop },
		0x01E6: { n:"BrtBeginMgs", f:parsenoop },
		0x01E7: { n:"BrtEndMGs", f:parsenoop },
		0x01E8: { n:"BrtBeginMGMaps", f:parsenoop },
		0x01E9: { n:"BrtEndMGMaps", f:parsenoop },
		0x01EA: { n:"BrtBeginMG", f:parsenoop },
		0x01EB: { n:"BrtEndMG", f:parsenoop },
		0x01EC: { n:"BrtBeginMap", f:parsenoop },
		0x01ED: { n:"BrtEndMap", f:parsenoop },
		0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
		0x01EF: { n:"BrtBeginDCon", f:parsenoop },
		0x01F0: { n:"BrtEndDCon", f:parsenoop },
		0x01F1: { n:"BrtBeginDRefs", f:parsenoop },
		0x01F2: { n:"BrtEndDRefs", f:parsenoop },
		0x01F3: { n:"BrtDRef", f:parsenoop },
		0x01F4: { n:"BrtBeginScenMan", f:parsenoop },
		0x01F5: { n:"BrtEndScenMan", f:parsenoop },
		0x01F6: { n:"BrtBeginSct", f:parsenoop },
		0x01F7: { n:"BrtEndSct", f:parsenoop },
		0x01F8: { n:"BrtSlc", f:parsenoop },
		0x01F9: { n:"BrtBeginDXFs", f:parsenoop },
		0x01FA: { n:"BrtEndDXFs", f:parsenoop },
		0x01FB: { n:"BrtDXF", f:parsenoop },
		0x01FC: { n:"BrtBeginTableStyles", f:parsenoop },
		0x01FD: { n:"BrtEndTableStyles", f:parsenoop },
		0x01FE: { n:"BrtBeginTableStyle", f:parsenoop },
		0x01FF: { n:"BrtEndTableStyle", f:parsenoop },
		0x0200: { n:"BrtTableStyleElement", f:parsenoop },
		0x0201: { n:"BrtTableStyleClient", f:parsenoop },
		0x0202: { n:"BrtBeginVolDeps", f:parsenoop },
		0x0203: { n:"BrtEndVolDeps", f:parsenoop },
		0x0204: { n:"BrtBeginVolType", f:parsenoop },
		0x0205: { n:"BrtEndVolType", f:parsenoop },
		0x0206: { n:"BrtBeginVolMain", f:parsenoop },
		0x0207: { n:"BrtEndVolMain", f:parsenoop },
		0x0208: { n:"BrtBeginVolTopic", f:parsenoop },
		0x0209: { n:"BrtEndVolTopic", f:parsenoop },
		0x020A: { n:"BrtVolSubtopic", f:parsenoop },
		0x020B: { n:"BrtVolRef", f:parsenoop },
		0x020C: { n:"BrtVolNum", f:parsenoop },
		0x020D: { n:"BrtVolErr", f:parsenoop },
		0x020E: { n:"BrtVolStr", f:parsenoop },
		0x020F: { n:"BrtVolBool", f:parsenoop },
		0x0210: { n:"BrtBeginCalcChain$", f:parsenoop },
		0x0211: { n:"BrtEndCalcChain$", f:parsenoop },
		0x0212: { n:"BrtBeginSortState", f:parsenoop },
		0x0213: { n:"BrtEndSortState", f:parsenoop },
		0x0214: { n:"BrtBeginSortCond", f:parsenoop },
		0x0215: { n:"BrtEndSortCond", f:parsenoop },
		0x0216: { n:"BrtBookProtection", f:parsenoop },
		0x0217: { n:"BrtSheetProtection", f:parsenoop },
		0x0218: { n:"BrtRangeProtection", f:parsenoop },
		0x0219: { n:"BrtPhoneticInfo", f:parsenoop },
		0x021A: { n:"BrtBeginECTxtWiz", f:parsenoop },
		0x021B: { n:"BrtEndECTxtWiz", f:parsenoop },
		0x021C: { n:"BrtBeginECTWFldInfoLst", f:parsenoop },
		0x021D: { n:"BrtEndECTWFldInfoLst", f:parsenoop },
		0x021E: { n:"BrtBeginECTwFldInfo", f:parsenoop },
		0x0224: { n:"BrtFileSharing", f:parsenoop },
		0x0225: { n:"BrtOleSize", f:parsenoop },
		0x0226: { n:"BrtDrawing", f:parsenoop },
		0x0227: { n:"BrtLegacyDrawing", f:parsenoop },
		0x0228: { n:"BrtLegacyDrawingHF", f:parsenoop },
		0x0229: { n:"BrtWebOpt", f:parsenoop },
		0x022A: { n:"BrtBeginWebPubItems", f:parsenoop },
		0x022B: { n:"BrtEndWebPubItems", f:parsenoop },
		0x022C: { n:"BrtBeginWebPubItem", f:parsenoop },
		0x022D: { n:"BrtEndWebPubItem", f:parsenoop },
		0x022E: { n:"BrtBeginSXCondFmt", f:parsenoop },
		0x022F: { n:"BrtEndSXCondFmt", f:parsenoop },
		0x0230: { n:"BrtBeginSXCondFmts", f:parsenoop },
		0x0231: { n:"BrtEndSXCondFmts", f:parsenoop },
		0x0232: { n:"BrtBkHim", f:parsenoop },
		0x0234: { n:"BrtColor", f:parsenoop },
		0x0235: { n:"BrtBeginIndexedColors", f:parsenoop },
		0x0236: { n:"BrtEndIndexedColors", f:parsenoop },
		0x0239: { n:"BrtBeginMRUColors", f:parsenoop },
		0x023A: { n:"BrtEndMRUColors", f:parsenoop },
		0x023C: { n:"BrtMRUColor", f:parsenoop },
		0x023D: { n:"BrtBeginDVals", f:parsenoop },
		0x023E: { n:"BrtEndDVals", f:parsenoop },
		0x0241: { n:"BrtSupNameStart", f:parsenoop },
		0x0242: { n:"BrtSupNameValueStart", f:parsenoop },
		0x0243: { n:"BrtSupNameValueEnd", f:parsenoop },
		0x0244: { n:"BrtSupNameNum", f:parsenoop },
		0x0245: { n:"BrtSupNameErr", f:parsenoop },
		0x0246: { n:"BrtSupNameSt", f:parsenoop },
		0x0247: { n:"BrtSupNameNil", f:parsenoop },
		0x0248: { n:"BrtSupNameBool", f:parsenoop },
		0x0249: { n:"BrtSupNameFmla", f:parsenoop },
		0x024A: { n:"BrtSupNameBits", f:parsenoop },
		0x024B: { n:"BrtSupNameEnd", f:parsenoop },
		0x024C: { n:"BrtEndSupBook", f:parsenoop },
		0x024D: { n:"BrtCellSmartTagProperty", f:parsenoop },
		0x024E: { n:"BrtBeginCellSmartTag", f:parsenoop },
		0x024F: { n:"BrtEndCellSmartTag", f:parsenoop },
		0x0250: { n:"BrtBeginCellSmartTags", f:parsenoop },
		0x0251: { n:"BrtEndCellSmartTags", f:parsenoop },
		0x0252: { n:"BrtBeginSmartTags", f:parsenoop },
		0x0253: { n:"BrtEndSmartTags", f:parsenoop },
		0x0254: { n:"BrtSmartTagType", f:parsenoop },
		0x0255: { n:"BrtBeginSmartTagTypes", f:parsenoop },
		0x0256: { n:"BrtEndSmartTagTypes", f:parsenoop },
		0x0257: { n:"BrtBeginSXFilters", f:parsenoop },
		0x0258: { n:"BrtEndSXFilters", f:parsenoop },
		0x0259: { n:"BrtBeginSXFILTER", f:parsenoop },
		0x025A: { n:"BrtEndSXFilter", f:parsenoop },
		0x025B: { n:"BrtBeginFills", f:parsenoop },
		0x025C: { n:"BrtEndFills", f:parsenoop },
		0x025D: { n:"BrtBeginCellWatches", f:parsenoop },
		0x025E: { n:"BrtEndCellWatches", f:parsenoop },
		0x025F: { n:"BrtCellWatch", f:parsenoop },
		0x0260: { n:"BrtBeginCRErrs", f:parsenoop },
		0x0261: { n:"BrtEndCRErrs", f:parsenoop },
		0x0262: { n:"BrtCrashRecErr", f:parsenoop },
		0x0263: { n:"BrtBeginFonts", f:parsenoop },
		0x0264: { n:"BrtEndFonts", f:parsenoop },
		0x0265: { n:"BrtBeginBorders", f:parsenoop },
		0x0266: { n:"BrtEndBorders", f:parsenoop },
		0x0267: { n:"BrtBeginFmts", f:parsenoop },
		0x0268: { n:"BrtEndFmts", f:parsenoop },
		0x0269: { n:"BrtBeginCellXFs", f:parsenoop },
		0x026A: { n:"BrtEndCellXFs", f:parsenoop },
		0x026B: { n:"BrtBeginStyles", f:parsenoop },
		0x026C: { n:"BrtEndStyles", f:parsenoop },
		0x0271: { n:"BrtBigName", f:parsenoop },
		0x0272: { n:"BrtBeginCellStyleXFs", f:parsenoop },
		0x0273: { n:"BrtEndCellStyleXFs", f:parsenoop },
		0x0274: { n:"BrtBeginComments", f:parsenoop },
		0x0275: { n:"BrtEndComments", f:parsenoop },
		0x0276: { n:"BrtBeginCommentAuthors", f:parsenoop },
		0x0277: { n:"BrtEndCommentAuthors", f:parsenoop },
		0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
		0x0279: { n:"BrtBeginCommentList", f:parsenoop },
		0x027A: { n:"BrtEndCommentList", f:parsenoop },
		0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
		0x027C: { n:"BrtEndComment", f:parsenoop },
		0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
		0x027E: { n:"BrtBeginOleObjects", f:parsenoop },
		0x027F: { n:"BrtOleObject", f:parsenoop },
		0x0280: { n:"BrtEndOleObjects", f:parsenoop },
		0x0281: { n:"BrtBeginSxrules", f:parsenoop },
		0x0282: { n:"BrtEndSxRules", f:parsenoop },
		0x0283: { n:"BrtBeginActiveXControls", f:parsenoop },
		0x0284: { n:"BrtActiveX", f:parsenoop },
		0x0285: { n:"BrtEndActiveXControls", f:parsenoop },
		0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy", f:parsenoop },
		0x0288: { n:"BrtBeginCellIgnoreECs", f:parsenoop },
		0x0289: { n:"BrtCellIgnoreEC", f:parsenoop },
		0x028A: { n:"BrtEndCellIgnoreECs", f:parsenoop },
		0x028B: { n:"BrtCsProp", f:parsenoop },
		0x028C: { n:"BrtCsPageSetup", f:parsenoop },
		0x028D: { n:"BrtBeginUserCsViews", f:parsenoop },
		0x028E: { n:"BrtEndUserCsViews", f:parsenoop },
		0x028F: { n:"BrtBeginUserCsView", f:parsenoop },
		0x0290: { n:"BrtEndUserCsView", f:parsenoop },
		0x0291: { n:"BrtBeginPcdSFCIEntries", f:parsenoop },
		0x0292: { n:"BrtEndPCDSFCIEntries", f:parsenoop },
		0x0293: { n:"BrtPCDSFCIEntry", f:parsenoop },
		0x0294: { n:"BrtBeginListParts", f:parsenoop },
		0x0295: { n:"BrtListPart", f:parsenoop },
		0x0296: { n:"BrtEndListParts", f:parsenoop },
		0x0297: { n:"BrtSheetCalcProp", f:parsenoop },
		0x0298: { n:"BrtBeginFnGroup", f:parsenoop },
		0x0299: { n:"BrtFnGroup", f:parsenoop },
		0x029A: { n:"BrtEndFnGroup", f:parsenoop },
		0x029B: { n:"BrtSupAddin", f:parsenoop },
		0x029C: { n:"BrtSXTDMPOrder", f:parsenoop },
		0x029D: { n:"BrtCsProtection", f:parsenoop },
		0x029F: { n:"BrtBeginWsSortMap", f:parsenoop },
		0x02A0: { n:"BrtEndWsSortMap", f:parsenoop },
		0x02A1: { n:"BrtBeginRRSort", f:parsenoop },
		0x02A2: { n:"BrtEndRRSort", f:parsenoop },
		0x02A3: { n:"BrtRRSortItem", f:parsenoop },
		0x02A4: { n:"BrtFileSharingIso", f:parsenoop },
		0x02A5: { n:"BrtBookProtectionIso", f:parsenoop },
		0x02A6: { n:"BrtSheetProtectionIso", f:parsenoop },
		0x02A7: { n:"BrtCsProtectionIso", f:parsenoop },
		0x02A8: { n:"BrtRangeProtectionIso", f:parsenoop },
		0x0400: { n:"BrtRwDescent", f:parsenoop },
		0x0401: { n:"BrtKnownFonts", f:parsenoop },
		0x0402: { n:"BrtBeginSXTupleSet", f:parsenoop },
		0x0403: { n:"BrtEndSXTupleSet", f:parsenoop },
		0x0404: { n:"BrtBeginSXTupleSetHeader", f:parsenoop },
		0x0405: { n:"BrtEndSXTupleSetHeader", f:parsenoop },
		0x0406: { n:"BrtSXTupleSetHeaderItem", f:parsenoop },
		0x0407: { n:"BrtBeginSXTupleSetData", f:parsenoop },
		0x0408: { n:"BrtEndSXTupleSetData", f:parsenoop },
		0x0409: { n:"BrtBeginSXTupleSetRow", f:parsenoop },
		0x040A: { n:"BrtEndSXTupleSetRow", f:parsenoop },
		0x040B: { n:"BrtSXTupleSetRowItem", f:parsenoop },
		0x040C: { n:"BrtNameExt", f:parsenoop },
		0x040D: { n:"BrtPCDH14", f:parsenoop },
		0x040E: { n:"BrtBeginPCDCalcMem14", f:parsenoop },
		0x040F: { n:"BrtEndPCDCalcMem14", f:parsenoop },
		0x0410: { n:"BrtSXTH14", f:parsenoop },
		0x0411: { n:"BrtBeginSparklineGroup", f:parsenoop },
		0x0412: { n:"BrtEndSparklineGroup", f:parsenoop },
		0x0413: { n:"BrtSparkline", f:parsenoop },
		0x0414: { n:"BrtSXDI14", f:parsenoop },
		0x0415: { n:"BrtWsFmtInfoEx14", f:parsenoop },
		0x0416: { n:"BrtBeginConditionalFormatting14", f:parsenoop },
		0x0417: { n:"BrtEndConditionalFormatting14", f:parsenoop },
		0x0418: { n:"BrtBeginCFRule14", f:parsenoop },
		0x0419: { n:"BrtEndCFRule14", f:parsenoop },
		0x041A: { n:"BrtCFVO14", f:parsenoop },
		0x041B: { n:"BrtBeginDatabar14", f:parsenoop },
		0x041C: { n:"BrtBeginIconSet14", f:parsenoop },
		0x041D: { n:"BrtDVal14", f:parsenoop },
		0x041E: { n:"BrtBeginDVals14", f:parsenoop },
		0x041F: { n:"BrtColor14", f:parsenoop },
		0x0420: { n:"BrtBeginSparklines", f:parsenoop },
		0x0421: { n:"BrtEndSparklines", f:parsenoop },
		0x0422: { n:"BrtBeginSparklineGroups", f:parsenoop },
		0x0423: { n:"BrtEndSparklineGroups", f:parsenoop },
		0x0425: { n:"BrtSXVD14", f:parsenoop },
		0x0426: { n:"BrtBeginSxview14", f:parsenoop },
		0x0427: { n:"BrtEndSxview14", f:parsenoop },
		0x042A: { n:"BrtBeginPCD14", f:parsenoop },
		0x042B: { n:"BrtEndPCD14", f:parsenoop },
		0x042C: { n:"BrtBeginExtConn14", f:parsenoop },
		0x042D: { n:"BrtEndExtConn14", f:parsenoop },
		0x042E: { n:"BrtBeginSlicerCacheIDs", f:parsenoop },
		0x042F: { n:"BrtEndSlicerCacheIDs", f:parsenoop },
		0x0430: { n:"BrtBeginSlicerCacheID", f:parsenoop },
		0x0431: { n:"BrtEndSlicerCacheID", f:parsenoop },
		0x0433: { n:"BrtBeginSlicerCache", f:parsenoop },
		0x0434: { n:"BrtEndSlicerCache", f:parsenoop },
		0x0435: { n:"BrtBeginSlicerCacheDef", f:parsenoop },
		0x0436: { n:"BrtEndSlicerCacheDef", f:parsenoop },
		0x0437: { n:"BrtBeginSlicersEx", f:parsenoop },
		0x0438: { n:"BrtEndSlicersEx", f:parsenoop },
		0x0439: { n:"BrtBeginSlicerEx", f:parsenoop },
		0x043A: { n:"BrtEndSlicerEx", f:parsenoop },
		0x043B: { n:"BrtBeginSlicer", f:parsenoop },
		0x043C: { n:"BrtEndSlicer", f:parsenoop },
		0x043D: { n:"BrtSlicerCachePivotTables", f:parsenoop },
		0x043E: { n:"BrtBeginSlicerCacheOlapImpl", f:parsenoop },
		0x043F: { n:"BrtEndSlicerCacheOlapImpl", f:parsenoop },
		0x0440: { n:"BrtBeginSlicerCacheLevelsData", f:parsenoop },
		0x0441: { n:"BrtEndSlicerCacheLevelsData", f:parsenoop },
		0x0442: { n:"BrtBeginSlicerCacheLevelData", f:parsenoop },
		0x0443: { n:"BrtEndSlicerCacheLevelData", f:parsenoop },
		0x0444: { n:"BrtBeginSlicerCacheSiRanges", f:parsenoop },
		0x0445: { n:"BrtEndSlicerCacheSiRanges", f:parsenoop },
		0x0446: { n:"BrtBeginSlicerCacheSiRange", f:parsenoop },
		0x0447: { n:"BrtEndSlicerCacheSiRange", f:parsenoop },
		0x0448: { n:"BrtSlicerCacheOlapItem", f:parsenoop },
		0x0449: { n:"BrtBeginSlicerCacheSelections", f:parsenoop },
		0x044A: { n:"BrtSlicerCacheSelection", f:parsenoop },
		0x044B: { n:"BrtEndSlicerCacheSelections", f:parsenoop },
		0x044C: { n:"BrtBeginSlicerCacheNative", f:parsenoop },
		0x044D: { n:"BrtEndSlicerCacheNative", f:parsenoop },
		0x044E: { n:"BrtSlicerCacheNativeItem", f:parsenoop },
		0x044F: { n:"BrtRangeProtection14", f:parsenoop },
		0x0450: { n:"BrtRangeProtectionIso14", f:parsenoop },
		0x0451: { n:"BrtCellIgnoreEC14", f:parsenoop },
		0x0457: { n:"BrtList14", f:parsenoop },
		0x0458: { n:"BrtCFIcon", f:parsenoop },
		0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs", f:parsenoop },
		0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs", f:parsenoop },
		0x045B: { n:"BrtBeginSlicers", f:parsenoop },
		0x045C: { n:"BrtEndSlicers", f:parsenoop },
		0x045D: { n:"BrtWbProp14", f:parsenoop },
		0x045E: { n:"BrtBeginSXEdit", f:parsenoop },
		0x045F: { n:"BrtEndSXEdit", f:parsenoop },
		0x0460: { n:"BrtBeginSXEdits", f:parsenoop },
		0x0461: { n:"BrtEndSXEdits", f:parsenoop },
		0x0462: { n:"BrtBeginSXChange", f:parsenoop },
		0x0463: { n:"BrtEndSXChange", f:parsenoop },
		0x0464: { n:"BrtBeginSXChanges", f:parsenoop },
		0x0465: { n:"BrtEndSXChanges", f:parsenoop },
		0x0466: { n:"BrtSXTupleItems", f:parsenoop },
		0x0468: { n:"BrtBeginSlicerStyle", f:parsenoop },
		0x0469: { n:"BrtEndSlicerStyle", f:parsenoop },
		0x046A: { n:"BrtSlicerStyleElement", f:parsenoop },
		0x046B: { n:"BrtBeginStyleSheetExt14", f:parsenoop },
		0x046C: { n:"BrtEndStyleSheetExt14", f:parsenoop },
		0x046D: { n:"BrtBeginSlicerCachesPivotCacheID", f:parsenoop },
		0x046E: { n:"BrtEndSlicerCachesPivotCacheID", f:parsenoop },
		0x046F: { n:"BrtBeginConditionalFormattings", f:parsenoop },
		0x0470: { n:"BrtEndConditionalFormattings", f:parsenoop },
		0x0471: { n:"BrtBeginPCDCalcMemExt", f:parsenoop },
		0x0472: { n:"BrtEndPCDCalcMemExt", f:parsenoop },
		0x0473: { n:"BrtBeginPCDCalcMemsExt", f:parsenoop },
		0x0474: { n:"BrtEndPCDCalcMemsExt", f:parsenoop },
		0x0475: { n:"BrtPCDField14", f:parsenoop },
		0x0476: { n:"BrtBeginSlicerStyles", f:parsenoop },
		0x0477: { n:"BrtEndSlicerStyles", f:parsenoop },
		0x0478: { n:"BrtBeginSlicerStyleElements", f:parsenoop },
		0x0479: { n:"BrtEndSlicerStyleElements", f:parsenoop },
		0x047A: { n:"BrtCFRuleExt", f:parsenoop },
		0x047B: { n:"BrtBeginSXCondFmt14", f:parsenoop },
		0x047C: { n:"BrtEndSXCondFmt14", f:parsenoop },
		0x047D: { n:"BrtBeginSXCondFmts14", f:parsenoop },
		0x047E: { n:"BrtEndSXCondFmts14", f:parsenoop },
		0x0480: { n:"BrtBeginSortCond14", f:parsenoop },
		0x0481: { n:"BrtEndSortCond14", f:parsenoop },
		0x0482: { n:"BrtEndDVals14", f:parsenoop },
		0x0483: { n:"BrtEndIconSet14", f:parsenoop },
		0x0484: { n:"BrtEndDatabar14", f:parsenoop },
		0x0485: { n:"BrtBeginColorScale14", f:parsenoop },
		0x0486: { n:"BrtEndColorScale14", f:parsenoop },
		0x0487: { n:"BrtBeginSxrules14", f:parsenoop },
		0x0488: { n:"BrtEndSxrules14", f:parsenoop },
		0x0489: { n:"BrtBeginPRule14", f:parsenoop },
		0x048A: { n:"BrtEndPRule14", f:parsenoop },
		0x048B: { n:"BrtBeginPRFilters14", f:parsenoop },
		0x048C: { n:"BrtEndPRFilters14", f:parsenoop },
		0x048D: { n:"BrtBeginPRFilter14", f:parsenoop },
		0x048E: { n:"BrtEndPRFilter14", f:parsenoop },
		0x048F: { n:"BrtBeginPRFItem14", f:parsenoop },
		0x0490: { n:"BrtEndPRFItem14", f:parsenoop },
		0x0491: { n:"BrtBeginCellIgnoreECs14", f:parsenoop },
		0x0492: { n:"BrtEndCellIgnoreECs14", f:parsenoop },
		0x0493: { n:"BrtDxf14", f:parsenoop },
		0x0494: { n:"BrtBeginDxF14s", f:parsenoop },
		0x0495: { n:"BrtEndDxf14s", f:parsenoop },
		0x0499: { n:"BrtFilter14", f:parsenoop },
		0x049A: { n:"BrtBeginCustomFilters14", f:parsenoop },
		0x049C: { n:"BrtCustomFilter14", f:parsenoop },
		0x049D: { n:"BrtIconFilter14", f:parsenoop },
		0x049E: { n:"BrtPivotCacheConnectionName", f:parsenoop },
		0x0800: { n:"BrtBeginDecoupledPivotCacheIDs", f:parsenoop },
		0x0801: { n:"BrtEndDecoupledPivotCacheIDs", f:parsenoop },
		0x0802: { n:"BrtDecoupledPivotCacheID", f:parsenoop },
		0x0803: { n:"BrtBeginPivotTableRefs", f:parsenoop },
		0x0804: { n:"BrtEndPivotTableRefs", f:parsenoop },
		0x0805: { n:"BrtPivotTableRef", f:parsenoop },
		0x0806: { n:"BrtSlicerCacheBookPivotTables", f:parsenoop },
		0x0807: { n:"BrtBeginSxvcells", f:parsenoop },
		0x0808: { n:"BrtEndSxvcells", f:parsenoop },
		0x0809: { n:"BrtBeginSxRow", f:parsenoop },
		0x080A: { n:"BrtEndSxRow", f:parsenoop },
		0x080C: { n:"BrtPcdCalcMem15", f:parsenoop },
		0x0813: { n:"BrtQsi15", f:parsenoop },
		0x0814: { n:"BrtBeginWebExtensions", f:parsenoop },
		0x0815: { n:"BrtEndWebExtensions", f:parsenoop },
		0x0816: { n:"BrtWebExtension", f:parsenoop },
		0x0817: { n:"BrtAbsPath15", f:parsenoop },
		0x0818: { n:"BrtBeginPivotTableUISettings", f:parsenoop },
		0x0819: { n:"BrtEndPivotTableUISettings", f:parsenoop },
		0x081B: { n:"BrtTableSlicerCacheIDs", f:parsenoop },
		0x081C: { n:"BrtTableSlicerCacheID", f:parsenoop },
		0x081D: { n:"BrtBeginTableSlicerCache", f:parsenoop },
		0x081E: { n:"BrtEndTableSlicerCache", f:parsenoop },
		0x081F: { n:"BrtSxFilter15", f:parsenoop },
		0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs", f:parsenoop },
		0x0821: { n:"BrtEndTimelineCachePivotCacheIDs", f:parsenoop },
		0x0822: { n:"BrtTimelineCachePivotCacheID", f:parsenoop },
		0x0823: { n:"BrtBeginTimelineCacheIDs", f:parsenoop },
		0x0824: { n:"BrtEndTimelineCacheIDs", f:parsenoop },
		0x0825: { n:"BrtBeginTimelineCacheID", f:parsenoop },
		0x0826: { n:"BrtEndTimelineCacheID", f:parsenoop },
		0x0827: { n:"BrtBeginTimelinesEx", f:parsenoop },
		0x0828: { n:"BrtEndTimelinesEx", f:parsenoop },
		0x0829: { n:"BrtBeginTimelineEx", f:parsenoop },
		0x082A: { n:"BrtEndTimelineEx", f:parsenoop },
		0x082B: { n:"BrtWorkBookPr15", f:parsenoop },
		0x082C: { n:"BrtPCDH15", f:parsenoop },
		0x082D: { n:"BrtBeginTimelineStyle", f:parsenoop },
		0x082E: { n:"BrtEndTimelineStyle", f:parsenoop },
		0x082F: { n:"BrtTimelineStyleElement", f:parsenoop },
		0x0830: { n:"BrtBeginTimelineStylesheetExt15", f:parsenoop },
		0x0831: { n:"BrtEndTimelineStylesheetExt15", f:parsenoop },
		0x0832: { n:"BrtBeginTimelineStyles", f:parsenoop },
		0x0833: { n:"BrtEndTimelineStyles", f:parsenoop },
		0x0834: { n:"BrtBeginTimelineStyleElements", f:parsenoop },
		0x0835: { n:"BrtEndTimelineStyleElements", f:parsenoop },
		0x0836: { n:"BrtDxf15", f:parsenoop },
		0x0837: { n:"BrtBeginDxfs15", f:parsenoop },
		0x0838: { n:"brtEndDxfs15", f:parsenoop },
		0x0839: { n:"BrtSlicerCacheHideItemsWithNoData", f:parsenoop },
		0x083A: { n:"BrtBeginItemUniqueNames", f:parsenoop },
		0x083B: { n:"BrtEndItemUniqueNames", f:parsenoop },
		0x083C: { n:"BrtItemUniqueName", f:parsenoop },
		0x083D: { n:"BrtBeginExtConn15", f:parsenoop },
		0x083E: { n:"BrtEndExtConn15", f:parsenoop },
		0x083F: { n:"BrtBeginOledbPr15", f:parsenoop },
		0x0840: { n:"BrtEndOledbPr15", f:parsenoop },
		0x0841: { n:"BrtBeginDataFeedPr15", f:parsenoop },
		0x0842: { n:"BrtEndDataFeedPr15", f:parsenoop },
		0x0843: { n:"BrtTextPr15", f:parsenoop },
		0x0844: { n:"BrtRangePr15", f:parsenoop },
		0x0845: { n:"BrtDbCommand15", f:parsenoop },
		0x0846: { n:"BrtBeginDbTables15", f:parsenoop },
		0x0847: { n:"BrtEndDbTables15", f:parsenoop },
		0x0848: { n:"BrtDbTable15", f:parsenoop },
		0x0849: { n:"BrtBeginDataModel", f:parsenoop },
		0x084A: { n:"BrtEndDataModel", f:parsenoop },
		0x084B: { n:"BrtBeginModelTables", f:parsenoop },
		0x084C: { n:"BrtEndModelTables", f:parsenoop },
		0x084D: { n:"BrtModelTable", f:parsenoop },
		0x084E: { n:"BrtBeginModelRelationships", f:parsenoop },
		0x084F: { n:"BrtEndModelRelationships", f:parsenoop },
		0x0850: { n:"BrtModelRelationship", f:parsenoop },
		0x0851: { n:"BrtBeginECTxtWiz15", f:parsenoop },
		0x0852: { n:"BrtEndECTxtWiz15", f:parsenoop },
		0x0853: { n:"BrtBeginECTWFldInfoLst15", f:parsenoop },
		0x0854: { n:"BrtEndECTWFldInfoLst15", f:parsenoop },
		0x0855: { n:"BrtBeginECTWFldInfo15", f:parsenoop },
		0x0856: { n:"BrtFieldListActiveItem", f:parsenoop },
		0x0857: { n:"BrtPivotCacheIdVersion", f:parsenoop },
		0x0858: { n:"BrtSXDI15", f:parsenoop },
		0xFFFF: { n:"", f:parsenoop }
	};
	
	var evert_RE = evert_key(XLSBRecordEnum, 'n');
	
	/* [MS-XLS] 2.3 Record Enumeration */
	var XLSRecordEnum = {
		0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
		0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
		0x0006: { n:"Formula", f:parse_Formula },
		0x0009: { n:'BOF', f:parse_BOF },
		0x000a: { n:'EOF', f:parse_EOF },
		0x000c: { n:"CalcCount", f:parse_CalcCount },
		0x000d: { n:"CalcMode", f:parse_CalcMode },
		0x000e: { n:"CalcPrecision", f:parse_CalcPrecision },
		0x000f: { n:"CalcRefMode", f:parse_CalcRefMode },
		0x0010: { n:"CalcDelta", f:parse_CalcDelta },
		0x0011: { n:"CalcIter", f:parse_CalcIter },
		0x0012: { n:"Protect", f:parse_Protect },
		0x0013: { n:"Password", f:parse_Password },
		0x0014: { n:"Header", f:parse_Header },
		0x0015: { n:"Footer", f:parse_Footer },
		0x0017: { n:"ExternSheet", f:parse_ExternSheet },
		0x0018: { n:"Lbl", f:parse_Lbl },
		0x0019: { n:"WinProtect", f:parse_WinProtect },
		0x001a: { n:"VerticalPageBreaks", f:parse_VerticalPageBreaks },
		0x001b: { n:"HorizontalPageBreaks", f:parse_HorizontalPageBreaks },
		0x001c: { n:"Note", f:parse_Note },
		0x001d: { n:"Selection", f:parse_Selection },
		0x0022: { n:"Date1904", f:parse_Date1904 },
		0x0023: { n:"ExternName", f:parse_ExternName },
		0x0026: { n:"LeftMargin", f:parse_LeftMargin },
		0x0027: { n:"RightMargin", f:parse_RightMargin },
		0x0028: { n:"TopMargin", f:parse_TopMargin },
		0x0029: { n:"BottomMargin", f:parse_BottomMargin },
		0x002a: { n:"PrintRowCol", f:parse_PrintRowCol },
		0x002b: { n:"PrintGrid", f:parse_PrintGrid },
		0x002f: { n:"FilePass", f:parse_FilePass },
		0x0031: { n:"Font", f:parse_Font },
		0x0033: { n:"PrintSize", f:parse_PrintSize },
		0x003c: { n:"Continue", f:parse_Continue },
		0x003d: { n:"Window1", f:parse_Window1 },
		0x0040: { n:"Backup", f:parse_Backup },
		0x0041: { n:"Pane", f:parse_Pane },
		0x0042: { n:'CodePage', f:parse_CodePage },
		0x004d: { n:"Pls", f:parse_Pls },
		0x0050: { n:"DCon", f:parse_DCon },
		0x0051: { n:"DConRef", f:parse_DConRef },
		0x0052: { n:"DConName", f:parse_DConName },
		0x0055: { n:"DefColWidth", f:parse_DefColWidth },
		0x0059: { n:"XCT", f:parse_XCT },
		0x005a: { n:"CRN", f:parse_CRN },
		0x005b: { n:"FileSharing", f:parse_FileSharing },
		0x005c: { n:'WriteAccess', f:parse_WriteAccess },
		0x005d: { n:"Obj", f:parse_Obj },
		0x005e: { n:"Uncalced", f:parse_Uncalced },
		0x005f: { n:"CalcSaveRecalc", f:parse_CalcSaveRecalc },
		0x0060: { n:"Template", f:parse_Template },
		0x0061: { n:"Intl", f:parse_Intl },
		0x0063: { n:"ObjProtect", f:parse_ObjProtect },
		0x007d: { n:"ColInfo", f:parse_ColInfo },
		0x0080: { n:"Guts", f:parse_Guts },
		0x0081: { n:"WsBool", f:parse_WsBool },
		0x0082: { n:"GridSet", f:parse_GridSet },
		0x0083: { n:"HCenter", f:parse_HCenter },
		0x0084: { n:"VCenter", f:parse_VCenter },
		0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
		0x0086: { n:"WriteProtect", f:parse_WriteProtect },
		0x008c: { n:"Country", f:parse_Country },
		0x008d: { n:"HideObj", f:parse_HideObj },
		0x0090: { n:"Sort", f:parse_Sort },
		0x0092: { n:"Palette", f:parse_Palette },
		0x0097: { n:"Sync", f:parse_Sync },
		0x0098: { n:"LPr", f:parse_LPr },
		0x0099: { n:"DxGCol", f:parse_DxGCol },
		0x009a: { n:"FnGroupName", f:parse_FnGroupName },
		0x009b: { n:"FilterMode", f:parse_FilterMode },
		0x009c: { n:"BuiltInFnGroupCount", f:parse_BuiltInFnGroupCount },
		0x009d: { n:"AutoFilterInfo", f:parse_AutoFilterInfo },
		0x009e: { n:"AutoFilter", f:parse_AutoFilter },
		0x00a0: { n:"Scl", f:parse_Scl },
		0x00a1: { n:"Setup", f:parse_Setup },
		0x00ae: { n:"ScenMan", f:parse_ScenMan },
		0x00af: { n:"SCENARIO", f:parse_SCENARIO },
		0x00b0: { n:"SxView", f:parse_SxView },
		0x00b1: { n:"Sxvd", f:parse_Sxvd },
		0x00b2: { n:"SXVI", f:parse_SXVI },
		0x00b4: { n:"SxIvd", f:parse_SxIvd },
		0x00b5: { n:"SXLI", f:parse_SXLI },
		0x00b6: { n:"SXPI", f:parse_SXPI },
		0x00b8: { n:"DocRoute", f:parse_DocRoute },
		0x00b9: { n:"RecipName", f:parse_RecipName },
		0x00bd: { n:"MulRk", f:parse_MulRk },
		0x00be: { n:"MulBlank", f:parse_MulBlank },
		0x00c1: { n:'Mms', f:parse_Mms },
		0x00c5: { n:"SXDI", f:parse_SXDI },
		0x00c6: { n:"SXDB", f:parse_SXDB },
		0x00c7: { n:"SXFDB", f:parse_SXFDB },
		0x00c8: { n:"SXDBB", f:parse_SXDBB },
		0x00c9: { n:"SXNum", f:parse_SXNum },
		0x00ca: { n:"SxBool", f:parse_SxBool },
		0x00cb: { n:"SxErr", f:parse_SxErr },
		0x00cc: { n:"SXInt", f:parse_SXInt },
		0x00cd: { n:"SXString", f:parse_SXString },
		0x00ce: { n:"SXDtr", f:parse_SXDtr },
		0x00cf: { n:"SxNil", f:parse_SxNil },
		0x00d0: { n:"SXTbl", f:parse_SXTbl },
		0x00d1: { n:"SXTBRGIITM", f:parse_SXTBRGIITM },
		0x00d2: { n:"SxTbpg", f:parse_SxTbpg },
		0x00d3: { n:"ObProj", f:parse_ObProj },
		0x00d5: { n:"SXStreamID", f:parse_SXStreamID },
		0x00d7: { n:"DBCell", f:parse_DBCell },
		0x00d8: { n:"SXRng", f:parse_SXRng },
		0x00d9: { n:"SxIsxoper", f:parse_SxIsxoper },
		0x00da: { n:"BookBool", f:parse_BookBool },
		0x00dc: { n:"DbOrParamQry", f:parse_DbOrParamQry },
		0x00dd: { n:"ScenarioProtect", f:parse_ScenarioProtect },
		0x00de: { n:"OleObjectSize", f:parse_OleObjectSize },
		0x00e0: { n:"XF", f:parse_XF },
		0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
		0x00e2: { n:'InterfaceEnd', f:parse_InterfaceEnd },
		0x00e3: { n:"SXVS", f:parse_SXVS },
		0x00e5: { n:"MergeCells", f:parse_MergeCells },
		0x00e9: { n:"BkHim", f:parse_BkHim },
		0x00eb: { n:"MsoDrawingGroup", f:parse_MsoDrawingGroup },
		0x00ec: { n:"MsoDrawing", f:parse_MsoDrawing },
		0x00ed: { n:"MsoDrawingSelection", f:parse_MsoDrawingSelection },
		0x00ef: { n:"PhoneticInfo", f:parse_PhoneticInfo },
		0x00f0: { n:"SxRule", f:parse_SxRule },
		0x00f1: { n:"SXEx", f:parse_SXEx },
		0x00f2: { n:"SxFilt", f:parse_SxFilt },
		0x00f4: { n:"SxDXF", f:parse_SxDXF },
		0x00f5: { n:"SxItm", f:parse_SxItm },
		0x00f6: { n:"SxName", f:parse_SxName },
		0x00f7: { n:"SxSelect", f:parse_SxSelect },
		0x00f8: { n:"SXPair", f:parse_SXPair },
		0x00f9: { n:"SxFmla", f:parse_SxFmla },
		0x00fb: { n:"SxFormat", f:parse_SxFormat },
		0x00fc: { n:"SST", f:parse_SST },
		0x00fd: { n:"LabelSst", f:parse_LabelSst },
		0x00ff: { n:"ExtSST", f:parse_ExtSST },
		0x0100: { n:"SXVDEx", f:parse_SXVDEx },
		0x0103: { n:"SXFormula", f:parse_SXFormula },
		0x0122: { n:"SXDBEx", f:parse_SXDBEx },
		0x0137: { n:"RRDInsDel", f:parse_RRDInsDel },
		0x0138: { n:"RRDHead", f:parse_RRDHead },
		0x013b: { n:"RRDChgCell", f:parse_RRDChgCell },
		0x013d: { n:"RRTabId", f:parse_RRTabId },
		0x013e: { n:"RRDRenSheet", f:parse_RRDRenSheet },
		0x013f: { n:"RRSort", f:parse_RRSort },
		0x0140: { n:"RRDMove", f:parse_RRDMove },
		0x014a: { n:"RRFormat", f:parse_RRFormat },
		0x014b: { n:"RRAutoFmt", f:parse_RRAutoFmt },
		0x014d: { n:"RRInsertSh", f:parse_RRInsertSh },
		0x014e: { n:"RRDMoveBegin", f:parse_RRDMoveBegin },
		0x014f: { n:"RRDMoveEnd", f:parse_RRDMoveEnd },
		0x0150: { n:"RRDInsDelBegin", f:parse_RRDInsDelBegin },
		0x0151: { n:"RRDInsDelEnd", f:parse_RRDInsDelEnd },
		0x0152: { n:"RRDConflict", f:parse_RRDConflict },
		0x0153: { n:"RRDDefName", f:parse_RRDDefName },
		0x0154: { n:"RRDRstEtxp", f:parse_RRDRstEtxp },
		0x015f: { n:"LRng", f:parse_LRng },
		0x0160: { n:"UsesELFs", f:parse_UsesELFs },
		0x0161: { n:"DSF", f:parse_DSF },
		0x0191: { n:"CUsr", f:parse_CUsr },
		0x0192: { n:"CbUsr", f:parse_CbUsr },
		0x0193: { n:"UsrInfo", f:parse_UsrInfo },
		0x0194: { n:"UsrExcl", f:parse_UsrExcl },
		0x0195: { n:"FileLock", f:parse_FileLock },
		0x0196: { n:"RRDInfo", f:parse_RRDInfo },
		0x0197: { n:"BCUsrs", f:parse_BCUsrs },
		0x0198: { n:"UsrChk", f:parse_UsrChk },
		0x01a9: { n:"UserBView", f:parse_UserBView },
		0x01aa: { n:"UserSViewBegin", f:parse_UserSViewBegin },
		0x01ab: { n:"UserSViewEnd", f:parse_UserSViewEnd },
		0x01ac: { n:"RRDUserView", f:parse_RRDUserView },
		0x01ad: { n:"Qsi", f:parse_Qsi },
		0x01ae: { n:"SupBook", f:parse_SupBook },
		0x01af: { n:"Prot4Rev", f:parse_Prot4Rev },
		0x01b0: { n:"CondFmt", f:parse_CondFmt },
		0x01b1: { n:"CF", f:parse_CF },
		0x01b2: { n:"DVal", f:parse_DVal },
		0x01b5: { n:"DConBin", f:parse_DConBin },
		0x01b6: { n:"TxO", f:parse_TxO },
		0x01b7: { n:"RefreshAll", f:parse_RefreshAll },
		0x01b8: { n:"HLink", f:parse_HLink },
		0x01b9: { n:"Lel", f:parse_Lel },
		0x01ba: { n:"CodeName", f:parse_XLSCodeName },
		0x01bb: { n:"SXFDBType", f:parse_SXFDBType },
		0x01bc: { n:"Prot4RevPass", f:parse_Prot4RevPass },
		0x01bd: { n:"ObNoMacros", f:parse_ObNoMacros },
		0x01be: { n:"Dv", f:parse_Dv },
		0x01c0: { n:"Excel9File", f:parse_Excel9File },
		0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
		0x01c2: { n:"EntExU2", f:parse_EntExU2 },
		0x0200: { n:"Dimensions", f:parse_Dimensions },
		0x0201: { n:"Blank", f:parse_Blank },
		0x0203: { n:"Number", f:parse_Number },
		0x0204: { n:"Label", f:parse_Label },
		0x0205: { n:"BoolErr", f:parse_BoolErr },
		0x0207: { n:"String", f:parse_String },
		0x0208: { n:'Row', f:parse_Row },
		0x020b: { n:"Index", f:parse_Index },
		0x0221: { n:"Array", f:parse_Array },
		0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
		0x0236: { n:"Table", f:parse_Table },
		0x023e: { n:"Window2", f:parse_Window2 },
		0x027e: { n:"RK", f:parse_RK },
		0x0293: { n:"Style", f:parse_Style },
		0x0418: { n:"BigName", f:parse_BigName },
		0x041e: { n:"Format", f:parse_Format },
		0x043c: { n:"ContinueBigName", f:parse_ContinueBigName },
		0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
		0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
		0x0801: { n:"WebPub", f:parse_WebPub },
		0x0802: { n:"QsiSXTag", f:parse_QsiSXTag },
		0x0803: { n:"DBQueryExt", f:parse_DBQueryExt },
		0x0804: { n:"ExtString", f:parse_ExtString },
		0x0805: { n:"TxtQry", f:parse_TxtQry },
		0x0806: { n:"Qsir", f:parse_Qsir },
		0x0807: { n:"Qsif", f:parse_Qsif },
		0x0808: { n:"RRDTQSIF", f:parse_RRDTQSIF },
		0x0809: { n:'BOF', f:parse_BOF },
		0x080a: { n:"OleDbConn", f:parse_OleDbConn },
		0x080b: { n:"WOpt", f:parse_WOpt },
		0x080c: { n:"SXViewEx", f:parse_SXViewEx },
		0x080d: { n:"SXTH", f:parse_SXTH },
		0x080e: { n:"SXPIEx", f:parse_SXPIEx },
		0x080f: { n:"SXVDTEx", f:parse_SXVDTEx },
		0x0810: { n:"SXViewEx9", f:parse_SXViewEx9 },
		0x0812: { n:"ContinueFrt", f:parse_ContinueFrt },
		0x0813: { n:"RealTimeData", f:parse_RealTimeData },
		0x0850: { n:"ChartFrtInfo", f:parse_ChartFrtInfo },
		0x0851: { n:"FrtWrapper", f:parse_FrtWrapper },
		0x0852: { n:"StartBlock", f:parse_StartBlock },
		0x0853: { n:"EndBlock", f:parse_EndBlock },
		0x0854: { n:"StartObject", f:parse_StartObject },
		0x0855: { n:"EndObject", f:parse_EndObject },
		0x0856: { n:"CatLab", f:parse_CatLab },
		0x0857: { n:"YMult", f:parse_YMult },
		0x0858: { n:"SXViewLink", f:parse_SXViewLink },
		0x0859: { n:"PivotChartBits", f:parse_PivotChartBits },
		0x085a: { n:"FrtFontList", f:parse_FrtFontList },
		0x0862: { n:"SheetExt", f:parse_SheetExt },
		0x0863: { n:"BookExt", f:parse_BookExt, r:12},
		0x0864: { n:"SXAddl", f:parse_SXAddl },
		0x0865: { n:"CrErr", f:parse_CrErr },
		0x0866: { n:"HFPicture", f:parse_HFPicture },
		0x0867: { n:'FeatHdr', f:parse_FeatHdr },
		0x0868: { n:"Feat", f:parse_Feat },
		0x086a: { n:"DataLabExt", f:parse_DataLabExt },
		0x086b: { n:"DataLabExtContents", f:parse_DataLabExtContents },
		0x086c: { n:"CellWatch", f:parse_CellWatch },
		0x0871: { n:"FeatHdr11", f:parse_FeatHdr11 },
		0x0872: { n:"Feature11", f:parse_Feature11 },
		0x0874: { n:"DropDownObjIds", f:parse_DropDownObjIds },
		0x0875: { n:"ContinueFrt11", f:parse_ContinueFrt11 },
		0x0876: { n:"DConn", f:parse_DConn },
		0x0877: { n:"List12", f:parse_List12 },
		0x0878: { n:"Feature12", f:parse_Feature12 },
		0x0879: { n:"CondFmt12", f:parse_CondFmt12 },
		0x087a: { n:"CF12", f:parse_CF12 },
		0x087b: { n:"CFEx", f:parse_CFEx },
		0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
		0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
		0x087e: { n:"AutoFilter12", f:parse_AutoFilter12 },
		0x087f: { n:"ContinueFrt12", f:parse_ContinueFrt12 },
		0x0884: { n:"MDTInfo", f:parse_MDTInfo },
		0x0885: { n:"MDXStr", f:parse_MDXStr },
		0x0886: { n:"MDXTuple", f:parse_MDXTuple },
		0x0887: { n:"MDXSet", f:parse_MDXSet },
		0x0888: { n:"MDXProp", f:parse_MDXProp },
		0x0889: { n:"MDXKPI", f:parse_MDXKPI },
		0x088a: { n:"MDB", f:parse_MDB },
		0x088b: { n:"PLV", f:parse_PLV },
		0x088c: { n:"Compat12", f:parse_Compat12, r:12 },
		0x088d: { n:"DXF", f:parse_DXF },
		0x088e: { n:"TableStyles", f:parse_TableStyles, r:12 },
		0x088f: { n:"TableStyle", f:parse_TableStyle },
		0x0890: { n:"TableStyleElement", f:parse_TableStyleElement },
		0x0892: { n:"StyleExt", f:parse_StyleExt },
		0x0893: { n:"NamePublish", f:parse_NamePublish },
		0x0894: { n:"NameCmt", f:parse_NameCmt },
		0x0895: { n:"SortData", f:parse_SortData },
		0x0896: { n:"Theme", f:parse_Theme, r:12 },
		0x0897: { n:"GUIDTypeLib", f:parse_GUIDTypeLib },
		0x0898: { n:"FnGrp12", f:parse_FnGrp12 },
		0x0899: { n:"NameFnGrp12", f:parse_NameFnGrp12 },
		0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
		0x089b: { n:"CompressPictures", f:parse_CompressPictures },
		0x089c: { n:"HeaderFooter", f:parse_HeaderFooter },
		0x089d: { n:"CrtLayout12", f:parse_CrtLayout12 },
		0x089e: { n:"CrtMlFrt", f:parse_CrtMlFrt },
		0x089f: { n:"CrtMlFrtContinue", f:parse_CrtMlFrtContinue },
		0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
		0x08a4: { n:"ShapePropsStream", f:parse_ShapePropsStream },
		0x08a5: { n:"TextPropsStream", f:parse_TextPropsStream },
		0x08a6: { n:"RichTextStream", f:parse_RichTextStream },
		0x08a7: { n:"CrtLayout12A", f:parse_CrtLayout12A },
		0x1001: { n:"Units", f:parse_Units },
		0x1002: { n:"Chart", f:parse_Chart },
		0x1003: { n:"Series", f:parse_Series },
		0x1006: { n:"DataFormat", f:parse_DataFormat },
		0x1007: { n:"LineFormat", f:parse_LineFormat },
		0x1009: { n:"MarkerFormat", f:parse_MarkerFormat },
		0x100a: { n:"AreaFormat", f:parse_AreaFormat },
		0x100b: { n:"PieFormat", f:parse_PieFormat },
		0x100c: { n:"AttachedLabel", f:parse_AttachedLabel },
		0x100d: { n:"SeriesText", f:parse_SeriesText },
		0x1014: { n:"ChartFormat", f:parse_ChartFormat },
		0x1015: { n:"Legend", f:parse_Legend },
		0x1016: { n:"SeriesList", f:parse_SeriesList },
		0x1017: { n:"Bar", f:parse_Bar },
		0x1018: { n:"Line", f:parse_Line },
		0x1019: { n:"Pie", f:parse_Pie },
		0x101a: { n:"Area", f:parse_Area },
		0x101b: { n:"Scatter", f:parse_Scatter },
		0x101c: { n:"CrtLine", f:parse_CrtLine },
		0x101d: { n:"Axis", f:parse_Axis },
		0x101e: { n:"Tick", f:parse_Tick },
		0x101f: { n:"ValueRange", f:parse_ValueRange },
		0x1020: { n:"CatSerRange", f:parse_CatSerRange },
		0x1021: { n:"AxisLine", f:parse_AxisLine },
		0x1022: { n:"CrtLink", f:parse_CrtLink },
		0x1024: { n:"DefaultText", f:parse_DefaultText },
		0x1025: { n:"Text", f:parse_Text },
		0x1026: { n:"FontX", f:parse_FontX },
		0x1027: { n:"ObjectLink", f:parse_ObjectLink },
		0x1032: { n:"Frame", f:parse_Frame },
		0x1033: { n:"Begin", f:parse_Begin },
		0x1034: { n:"End", f:parse_End },
		0x1035: { n:"PlotArea", f:parse_PlotArea },
		0x103a: { n:"Chart3d", f:parse_Chart3d },
		0x103c: { n:"PicF", f:parse_PicF },
		0x103d: { n:"DropBar", f:parse_DropBar },
		0x103e: { n:"Radar", f:parse_Radar },
		0x103f: { n:"Surf", f:parse_Surf },
		0x1040: { n:"RadarArea", f:parse_RadarArea },
		0x1041: { n:"AxisParent", f:parse_AxisParent },
		0x1043: { n:"LegendException", f:parse_LegendException },
		0x1044: { n:"ShtProps", f:parse_ShtProps },
		0x1045: { n:"SerToCrt", f:parse_SerToCrt },
		0x1046: { n:"AxesUsed", f:parse_AxesUsed },
		0x1048: { n:"SBaseRef", f:parse_SBaseRef },
		0x104a: { n:"SerParent", f:parse_SerParent },
		0x104b: { n:"SerAuxTrend", f:parse_SerAuxTrend },
		0x104e: { n:"IFmtRecord", f:parse_IFmtRecord },
		0x104f: { n:"Pos", f:parse_Pos },
		0x1050: { n:"AlRuns", f:parse_AlRuns },
		0x1051: { n:"BRAI", f:parse_BRAI },
		0x105b: { n:"SerAuxErrBar", f:parse_SerAuxErrBar },
		0x105c: { n:"ClrtClient", f:parse_ClrtClient },
		0x105d: { n:"SerFmt", f:parse_SerFmt },
		0x105f: { n:"Chart3DBarShape", f:parse_Chart3DBarShape },
		0x1060: { n:"Fbi", f:parse_Fbi },
		0x1061: { n:"BopPop", f:parse_BopPop },
		0x1062: { n:"AxcExt", f:parse_AxcExt },
		0x1063: { n:"Dat", f:parse_Dat },
		0x1064: { n:"PlotGrowth", f:parse_PlotGrowth },
		0x1065: { n:"SIIndex", f:parse_SIIndex },
		0x1066: { n:"GelFrame", f:parse_GelFrame },
		0x1067: { n:"BopPopCustom", f:parse_BopPopCustom },
		0x1068: { n:"Fbi2", f:parse_Fbi2 },
	
		/* These are specified in an older version of the spec */
		0x0016: { n:"ExternCount", f:parsenoop },
		0x007e: { n:"RK", f:parsenoop }, /* Not necessarily same as 0x027e */
		0x007f: { n:"ImData", f:parsenoop },
		0x0087: { n:"Addin", f:parsenoop },
		0x0088: { n:"Edg", f:parsenoop },
		0x0089: { n:"Pub", f:parsenoop },
		0x0091: { n:"Sub", f:parsenoop },
		0x0094: { n:"LHRecord", f:parsenoop },
		0x0095: { n:"LHNGraph", f:parsenoop },
		0x0096: { n:"Sound", f:parsenoop },
		0x00a9: { n:"CoordList", f:parsenoop },
		0x00ab: { n:"GCW", f:parsenoop },
		0x00bc: { n:"ShrFmla", f:parsenoop }, /* Not necessarily same as 0x04bc */
		0x00c2: { n:"AddMenu", f:parsenoop },
		0x00c3: { n:"DelMenu", f:parsenoop },
		0x00d6: { n:"RString", f:parsenoop },
		0x00df: { n:"UDDesc", f:parsenoop },
		0x00ea: { n:"TabIdConf", f:parsenoop },
		0x0162: { n:"XL5Modify", f:parsenoop },
		0x01a5: { n:"FileSharing2", f:parsenoop },
		0x0218: { n:"Name", f:parsenoop },
		0x0223: { n:"ExternName", f:parse_ExternName },
		0x0231: { n:"Font", f:parsenoop },
		0x0406: { n:"Formula", f:parse_Formula },
		0x086d: { n:"FeatInfo", f:parsenoop },
		0x0873: { n:"FeatInfo11", f:parsenoop },
		0x0881: { n:"SXAddl12", f:parsenoop },
		0x08c0: { n:"AutoWebPub", f:parsenoop },
		0x08c1: { n:"ListObj", f:parsenoop },
		0x08c2: { n:"ListField", f:parsenoop },
		0x08c3: { n:"ListDV", f:parsenoop },
		0x08c4: { n:"ListCondFmt", f:parsenoop },
		0x08c5: { n:"ListCF", f:parsenoop },
		0x08c6: { n:"FMQry", f:parsenoop },
		0x08c7: { n:"FMSQry", f:parsenoop },
		0x08c8: { n:"PLV", f:parsenoop }, /* supposedly PLV for Excel 11 */
		0x08c9: { n:"LnExt", f:parsenoop },
		0x08ca: { n:"MkrExt", f:parsenoop },
		0x08cb: { n:"CrtCoopt", f:parsenoop },
	
		0x0000: {}
	};
	
	
	/* Helper function to call out to ODS parser */
	function parse_ods(zip, opts) {
		if(typeof module !== "undefined" && "function" !== 'undefined' && typeof ODS === 'undefined') ODS = __webpack_require__(3328);
		if(typeof ODS === 'undefined' || !ODS.parse_ods) throw new Error("Unsupported ODS");
		return ODS.parse_ods(zip, opts);
	}
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	var fix_read_opts = fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	]);
	
	
	var fix_write_opts = fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['WTF', false] /* WTF mode (throws errors) */
	]);
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { return [w.name, wbrels['!id'][w.id].Target]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_ws(zip, path, relsPath, sheet, sheetRels, sheets, opts) {
		try {
			sheetRels[sheet]=parse_rels(getzipdata(zip, relsPath, true), path);
			sheets[sheet]=parse_ws(getzipdata(zip, path),path,opts,sheetRels[sheet]);
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	var nodirs = function nodirs(x){return x.substr(-1) != '/';};
	function parse_zip(zip, opts) {
		make_ssf(SSF);
		opts = opts || {};
		fix_read_opts(opts);
		reset_cp();
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
	
		var entries = keys(zip.files).filter(nodirs).sort();
		var dir = parse_ct(getzipdata(zip, '[Content_Types].xml'), opts);
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipfile(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].substr(-3) == "bin") xlsb = true;
		if(xlsb) set_cp(1200);
	
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) strs=parse_sst(getzipdata(zip, dir.sst.replace(/^\//,'')), dir.sst, opts);
	
	    // parse themes before styles so that we can reliably decode theme/tint into rgb when parsing styles
	    themes = {};
	    if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipdata(zip, dir.themes[0].replace(/^\//,''), true),dir.themes[0], opts);
	
	    styles = {};
			if(dir.style) styles = parse_sty(getzipdata(zip, dir.style.replace(/^\//,'')),dir.style, opts);
	
		}
	
		var wb = parse_wb(getzipdata(zip, dir.workbooks[0].replace(/^\//,'')), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length !== 0) {
			propdata = getzipdata(zip, dir.coreprops[0].replace(/^\//,''), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, dir.extprops[0].replace(/^\//,''), true);
				if(propdata) parse_ext_props(propdata, props);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipdata(zip, dir.custprops[0].replace(/^\//,''), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = {};
		if(opts.bookSheets || opts.bookProps) {
			if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			else if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, dir.calcchain.replace(/^\//,'')),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = {};
		var path, relsPath;
		if(!props.Worksheets) {
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipdata(zip, wbrelsfile, true), wbrelsfile);
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		for(i = 0; i != props.Worksheets; ++i) {
			if(wbrels) path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
			else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			safe_parse_ws(zip, path, relsPath, props.SheetNames[i], sheetRels, sheets, opts);
		}
	
		if(dir.comments) parse_comments(zip, dir.comments, sheets, sheetRels, opts);
	
		out = {
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: SSF.get_table()
		};
		if(opts.bookFiles) {
			out.keys = entries;
			out.files = zip.files;
		}
		if(opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,dir.vba[0],true);
			else if(dir.defaults.bin === 'application/vnd.ms-office.vbaProject') out.vbaraw = getzipdata(zip,'xl/vbaProject.bin',true);
		}
		return out;
	}
	function add_rels(rels, rId, f, type, relobj) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
	}
	
	function write_zip(wb, opts) {
		if(wb && !wb.SSF) {
			wb.SSF = SSF.get_table();
		}
		if(wb && wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var ct = { workbooks: [], sheets: [], calcchains: [], themes: [], styles: [],
			coreprops: [], extprops: [], custprops: [], strs:[], comments: [], vba: [],
			TODO:[], rels:[], xmlns: "" };
		fix_write_opts(opts = opts || {});
		var zip = new jszip();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		f = "docProps/core.xml";
		zip.file(f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
		f = "docProps/app.xml";
		if(!wb.Props) wb.Props = {};
		wb.Props.SheetNames = wb.SheetNames;
		wb.Props.Worksheets = wb.SheetNames.length;
		zip.file(f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip.file(f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		f = "xl/workbook." + wbext;
		zip.file(f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			f = "xl/worksheets/sheet" + rId + "." + wbext;
			zip.file(f, write_ws(rId-1, f, opts, wb));
			ct.sheets.push(f);
			add_rels(opts.wbrels, rId, "worksheets/sheet" + rId + "." + wbext, RELS.WS);
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip.file(f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, ++rId, "sharedStrings." + wbext, RELS.SST);
		}
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
	  zip.file(f, write_theme(opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, ++rId, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip.file(f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, ++rId, "styles." + wbext, RELS.STY);
	
		zip.file("[Content_Types].xml", write_ct(ct, opts));
		zip.file('_rels/.rels', write_rels(opts.rels));
		zip.file('xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
		return zip;
	}
	function firstbyte(f,o) {
		switch((o||{}).type || "base64") {
			case 'buffer': return f[0];
			case 'base64': return Base64.decode(f.substr(0,12)).charCodeAt(0);
			case 'binary': return f.charCodeAt(0);
			case 'array': return f[0];
			default: throw new Error("Unrecognized type " + o.type);
		}
	}
	
	function read_zip(data, opts) {
		var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		switch(o.type) {
			case "base64": zip = new jszip(d, { base64:true }); break;
			case "binary": case "array": zip = new jszip(d, { base64:false }); break;
			case "buffer": zip = new jszip(d); break;
			case "file": zip=new jszip(d=_fs.readFileSync(data)); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		return parse_zip(zip, o);
	}
	
	function readSync(data, opts) {
		var zip, d = data, isfile = false, n;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { isfile = true; o.type = "buffer"; d = _fs.readFileSync(data); }
		switch((n = firstbyte(d, o))) {
			case 0xD0:
				if(isfile) o.type = "file";
				return parse_xlscfb(CFB.read(data, o), o);
			case 0x09: return parse_xlscfb(s2a(o.type === 'base64' ? Base64.decode(data) : data), o);
			case 0x3C: return parse_xlml(d, o);
			case 0x50:
				if(isfile) o.type = "file";
				return read_zip(data, opts);
			default: throw new Error("Unsupported file " + n);
		}
	}
	
	function readFileSync(data, opts) {
		var o = opts||{}; o.type = 'file'
	  var wb = readSync(data, o);
	  wb.FILENAME = data;
		return wb;
	}
	function write_zip_type(wb, opts) {
		var o = opts||{};
	  style_builder  = new StyleBuilder(opts);
	
	  var z = write_zip(wb, o);
		switch(o.type) {
			case "base64": return z.generate({type:"base64"});
			case "binary": return z.generate({type:"string"});
			case "buffer": return z.generate({type:"nodebuffer"});
			case "file": return _fs.writeFileSync(o.file, z.generate({type:"nodebuffer"}));
			default: throw new Error("Unrecognized type " + o.type);
		}
	}
	
	function writeSync(wb, opts) {
		var o = opts||{};
		switch(o.bookType) {
			case 'xml': return write_xlml(wb, o);
			default: return write_zip_type(wb, o);
		}
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
	
		o.file = filename;
		switch(o.file.substr(-5).toLowerCase()) {
			case '.xlsx': o.bookType = 'xlsx'; break;
			case '.xlsm': o.bookType = 'xlsm'; break;
			case '.xlsb': o.bookType = 'xlsb'; break;
		default: switch(o.file.substr(-4).toLowerCase()) {
			case '.xls': o.bookType = 'xls'; break;
			case '.xml': o.bookType = 'xml'; break;
		}}
		return writeSync(wb, o);
	}
	
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function fix_cell(cstr) { return fix_col(fix_row(cstr)); }
	function unfix_cell(cstr) { return unfix_col(unfix_row(cstr)); }
	function decode_range(range) { var x =range.split(":").map(decode_cell); return {s:x[0],e:x[x.length-1]}; }
	function encode_range(cs,ce) {
		if(ce === undefined || typeof ce === 'number') return encode_range(cs.s, cs.e);
		if(typeof cs !== 'string') cs = encode_cell(cs); if(typeof ce !== 'string') ce = encode_cell(ce);
		return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || range.charCodeAt(++i) === 58) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		if(cell.z !== undefined) try { return (cell.w = SSF.format(cell.z, v)); } catch(e) { }
		if(!cell.XF) return v;
		try { return (cell.w = SSF.format(cell.XF.ifmt||0, v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v) {
		if(cell == null || cell.t == null) return "";
		if(cell.w !== undefined) return cell.w;
		if(v === undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_json(sheet, opts){
		var val, row, range, header = 0, offset = 1, r, hdr = [], isempty, R, C, v;
		var o = opts != null ? opts : {};
		var raw = o.raw;
		if(sheet == null || sheet["!ref"] == null) return [];
		range = o.range !== undefined ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = new Array(r.e.c-r.s.c+1);
		var out = new Array(r.e.r-r.s.r-offset+1);
		var outi = 0;
		for(C = r.s.c; C <= r.e.c; ++C) {
			cols[C] = encode_col(C);
			val = sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val === undefined) continue;
					hdr[C] = format_cell(val);
			}
		}
	
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			rr = encode_row(R);
			isempty = true;
			if(header === 1) row = [];
			else {
				row = {};
				if(Object.defineProperty) Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false});
				else row.__rowNum__ = R;
			}
			for (C = r.s.c; C <= r.e.c; ++C) {
				val = sheet[cols[C] + rr];
				if(val === undefined || val.t === undefined) continue;
				v = val.v;
				switch(val.t){
					case 'e': continue;
					case 's': break;
					case 'b': case 'n': break;
					default: throw 'unrecognized type ' + val.t;
				}
				if(v !== undefined) {
					row[hdr[C]] = raw ? v : format_cell(val,v);
					isempty = false;
				}
			}
			if(isempty === false || header === 1) out[outi++] = row;
		}
		out.length = outi;
		return out;
	}
	
	function sheet_to_row_object_array(sheet, opts) { return sheet_to_json(sheet, opts != null ? opts : {}); }
	
	function sheet_to_csv(sheet, opts) {
		var out = "", txt = "", qreg = /"/g;
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var row = "", rr = "", cols = [];
		var i = 0, cc = 0, val;
		var R = 0, C = 0;
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(R = r.s.r; R <= r.e.r; ++R) {
			row = "";
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				val = sheet[cols[C] + rr];
				txt = val !== undefined ? ''+format_cell(val) : "";
				for(i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34) {
					txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				row += (C === r.s.c ? "" : FS) + txt;
			}
			out += row + RS;
		}
		return out;
	}
	var make_csv = sheet_to_csv;
	
	function sheet_to_formulae(sheet) {
		var cmds, y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		cmds = new Array((r.e.r-r.s.r+1)*(r.e.c-r.s.c+1));
		var i = 0;
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = sheet[y];
				val = "";
				if(x === undefined) continue;
				if(x.f != null) val = x.f;
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else val = ""+x.v;
				cmds[i++] = y + "=" + val;
			}
		}
		cmds.length = i;
		return cmds;
	}
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		get_formulae: sheet_to_formulae,
		make_csv: sheet_to_csv,
		make_json: sheet_to_json,
		make_formulae: sheet_to_formulae,
		sheet_to_csv: sheet_to_csv,
		sheet_to_json: sheet_to_json,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_row_object_array
	};
	
	
	
	
	/////////////////////////////////////////////////////////////////////////////////////////////////////
	var XmlNode = (function () {
	  function XmlNode(tagName, attributes, children) {
	
	    if (!(this instanceof XmlNode)) {
	      return new XmlNode(tagName, attributes, children);
	    }
	    this.tagName = tagName;
	    this._attributes = attributes || {};
	    this._children = children || [];
	    this._prefix = '';
	    return this;
	  }
	
	  XmlNode.prototype.createElement = function () {
	    return new XmlNode(arguments)
	  }
	
	  XmlNode.prototype.children = function() {
	    return this._children;
	  }
	
	  XmlNode.prototype.append = function (node) {
	    this._children.push(node);
	    return this;
	  }
	
	  XmlNode.prototype.prefix = function (prefix) {
	    if (arguments.length==0) { return this._prefix;}
	    this._prefix = prefix;
	    return this;
	  }
	
	  XmlNode.prototype.attr = function (attr, value) {
	    if (value == undefined) {
	      delete this._attributes[attr];
	      return this;
	    }
	    if (arguments.length == 0) {
	      return this._attributes;
	    }
	    else if (typeof attr == 'string' && arguments.length == 1) {
	      return this._attributes.attr[attr];
	    }
	    if (typeof attr == 'object' && arguments.length == 1) {
	      for (var key in attr) {
	        this._attributes[key] = attr[key];
	      }
	    }
	    else if (arguments.length == 2 && typeof attr == 'string') {
	      this._attributes[attr] = value;
	    }
	    return this;
	  }
	
	  var APOS = "'"; QUOTE = '"'
	  var ESCAPED_QUOTE = {  }
	  ESCAPED_QUOTE[QUOTE] = '&quot;'
	  ESCAPED_QUOTE[APOS] = '&apos;'
	
	  XmlNode.prototype.escapeAttributeValue = function(att_value) {
	    return '"' + att_value.replace(/\"/g,'&quot;') + '"';// TODO Extend with four other codes
	
	  }
	
	  XmlNode.prototype.toXml = function (node) {
	    if (!node) node = this;
	    var xml = node._prefix;
	    xml += '<' + node.tagName;
	    if (node._attributes) {
	      for (var key in node._attributes) {
	        xml += ' ' + key + '=' + this.escapeAttributeValue(''+node._attributes[key]) + ''
	      }
	    }
	    if (node._children && node._children.length > 0) {
	      xml += ">";
	      for (var i = 0; i < node._children.length; i++) {
	        xml += this.toXml(node._children[i]);
	      }
	      xml += '</' + node.tagName + '>';
	    }
	    else {
	      xml += '/>';
	    }
	    return xml;
	  }
	  return XmlNode;
	})();
	/////////////////////////////////////////////////////////////////////////////////////////////////////
	
	  var StyleBuilder = function (options) {
	
	    var customNumFmtId = 164;
	
	
	
	    var table_fmt = {
	      0:  'General',
	      1:  '0',
	      2:  '0.00',
	      3:  '#,##0',
	      4:  '#,##0.00',
	      9:  '0%',
	      10: '0.00%',
	      11: '0.00E+00',
	      12: '# ?/?',
	      13: '# ??/??',
	      14: 'm/d/yy',
	      15: 'd-mmm-yy',
	      16: 'd-mmm',
	      17: 'mmm-yy',
	      18: 'h:mm AM/PM',
	      19: 'h:mm:ss AM/PM',
	      20: 'h:mm',
	      21: 'h:mm:ss',
	      22: 'm/d/yy h:mm',
	      37: '#,##0 ;(#,##0)',
	      38: '#,##0 ;[Red](#,##0)',
	      39: '#,##0.00;(#,##0.00)',
	      40: '#,##0.00;[Red](#,##0.00)',
	      45: 'mm:ss',
	      46: '[h]:mm:ss',
	      47: 'mmss.0',
	      48: '##0.0E+0',
	      49: '@',
	      56: '"上午/下午 "hh"時"mm"分"ss"秒 "'    };
	    var fmt_table = {};
	
	    for (var idx in table_fmt) {
	      fmt_table[table_fmt[idx]] = idx;
	    }
	
	
	    // cache style specs to avoid excessive duplication
	    _hashIndex = {};
	    _listIndex = [];
	
	    return {
	
	      initialize: function (options) {
	
	        this.$fonts = XmlNode('fonts').attr('count',0).attr("x14ac:knownFonts","1");
	        this.$fills = XmlNode('fills').attr('count',0);
	        this.$borders = XmlNode('borders').attr('count',0);
	        this.$numFmts = XmlNode('numFmts').attr('count',0);
	        this.$cellStyleXfs = XmlNode('cellStyleXfs');
	        this.$xf = XmlNode('xf')
	            .attr('numFmtId', 0)
	            .attr('fontId', 0)
	            .attr('fillId', 0)
	            .attr('borderId', 0);
	
	        this.$cellXfs = XmlNode('cellXfs').attr('count',0);
	        this.$cellStyles = XmlNode('cellStyles')
	            .append(XmlNode('cellStyle')
	                .attr('name', 'Normal')
	                .attr('xfId',0)
	                .attr('builtinId',0)
	            );
	        this.$dxfs = XmlNode('dxfs').attr('count', "0");
	        this.$tableStyles = XmlNode('tableStyles')
	            .attr('count','0')
	            .attr('defaultTableStyle','TableStyleMedium9')
	            .attr('defaultPivotStyle','PivotStyleMedium4')
	
	
	        this.$styles = XmlNode('styleSheet')
	            .attr('xmlns:mc','http://schemas.openxmlformats.org/markup-compatibility/2006')
	            .attr('xmlns:x14ac','http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac')
	            .attr('xmlns','http://schemas.openxmlformats.org/spreadsheetml/2006/main')
	            .attr('mc:Ignorable','x14ac')
	            .prefix('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>')
	            .append(this.$numFmts)
	            .append(this.$fonts)
	            .append(this.$fills)
	            .append(this.$borders)
	            .append(this.$cellStyleXfs.append(this.$xf))
	            .append(this.$cellXfs)
	            .append(this.$cellStyles)
	            .append(this.$dxfs)
	            .append(this.$tableStyles);
	
	
	        // need to specify styles at index 0 and 1.
	        // the second style MUST be gray125 for some reason
	
	        var defaultStyle = options.defaultCellStyle || {};
	        if (!defaultStyle.font) defaultStyle.font = {name: 'Calibri', sz: '12'};
	        if (!defaultStyle.font.name) defaultStyle.font.name = 'Calibri';
	        if (!defaultStyle.font.sz) defaultStyle.font.sz = 11;
	        if (!defaultStyle.fill) defaultStyle.fill = {  patternType: "none", fgColor: {}};
	        if (!defaultStyle.border) defaultStyle.border = {};
	        if (!defaultStyle.numFmt) defaultStyle.numFmt = 0;
	
	        this.defaultStyle = defaultStyle;
	
	        var gray125Style = JSON.parse(JSON.stringify(defaultStyle));
	        gray125Style.fill = {patternType: "gray125", fgColor: { }}
	
	        this.addStyles([defaultStyle, gray125Style]);
	        return this;
	      },
	
	      // create a style entry and returns an integer index that can be used in the cell .s property
	      // these format of this object follows the emerging Common Spreadsheet Format
	      addStyle: function (attributes) {
	
	        var hashKey = JSON.stringify(attributes);
	        var index = _hashIndex[hashKey];
	        if (index == undefined) {
	
	          index = this._addXf(attributes); //_listIndex.push(attributes) -1;
	          _hashIndex[hashKey] = index;
	        }
	        else {
	          index = _hashIndex[hashKey];
	        }
	        return index;
	      },
	
	      // create style entries and returns array of integer indexes that can be used in cell .s property
	      addStyles: function (styles) {
	        var self = this;
	        return styles.map(function (style) {
	          return self.addStyle(style);
	        })
	      },
	
	      _duckTypeStyle: function(attributes) {
	
	        if (typeof attributes == 'object' && (attributes.patternFill || attributes.fgColor)) {
	          return {fill: attributes }; // this must be read via XLSX.parseFile(...)
	        }
	        else if (attributes.font || attributes.numFmt || attributes.border || attributes.fill) {
	          return attributes;
	        }
	        else {
	          return this._getStyleCSS(attributes)
	        }
	      },
	
	      _getStyleCSS: function(css) {
	        return css; //TODO
	      },
	
	      // Create an <xf> record for the style as well as corresponding <font>, <fill>, <border>, <numfmts>
	      // Right now this is simple and creates a <font>, <fill>, <border>, <numfmts> for every <xf>
	      // We could perhaps get fancier and avoid duplicating  auxiliary entries as Excel presumably intended, but bother.
	      _addXf: function (attributes) {
	
	
	        var fontId = this._addFont(attributes.font);
	        var fillId = this._addFill(attributes.fill);
	        var borderId = this._addBorder(attributes.border);
	        var numFmtId = this._addNumFmt(attributes.numFmt);
	
	        var $xf = XmlNode('xf')
	            .attr("numFmtId", numFmtId)
	            .attr("fontId", fontId)
	            .attr("fillId", fillId)
	            .attr("borderId", borderId)
	            .attr("xfId", "0");
	
	        if (fontId > 0) {
	          $xf.attr('applyFont', "1");
	        }
	        if (fillId > 0) {
	          $xf.attr('applyFill', "1");
	        }
	        if (borderId > 0) {
	          $xf.attr('applyBorder', "1");
	        }
	        if (numFmtId > 0) {
	          $xf.attr('applyNumberFormat', "1");
	        }
	
	        if (attributes.alignment) {
	          var $alignment = XmlNode('alignment');
	          if (attributes.alignment.horizontal) { $alignment.attr('horizontal', attributes.alignment.horizontal);}
	          if (attributes.alignment.vertical)  { $alignment.attr('vertical', attributes.alignment.vertical);}
	          if (attributes.alignment.indent)  { $alignment.attr('indent', attributes.alignment.indent);}
	          if (attributes.alignment.readingOrder)  { $alignment.attr('readingOrder', attributes.alignment.readingOrder);}
	          if (attributes.alignment.wrapText)  { $alignment.attr('wrapText', attributes.alignment.wrapText);}
	          if (attributes.alignment.textRotation!=undefined)  { $alignment.attr('textRotation', attributes.alignment.textRotation);}
	
	          $xf.append($alignment).attr('applyAlignment',1)
	
	        }
	        this.$cellXfs.append($xf);
	        var count = +this.$cellXfs.children().length;
	
	        this.$cellXfs.attr('count', count);
	        return count - 1;
	      },
	
	      _addFont: function (attributes) {
	
	        if (!attributes) {  return 0; }
	
	        var $font = XmlNode('font')
	            .append(XmlNode('sz').attr('val', attributes.sz || this.defaultStyle.font.sz))
	            .append(XmlNode('name').attr('val', attributes.name || this.defaultStyle.font.name))
	
	        if (attributes.bold) $font.append(XmlNode('b'));
	        if (attributes.underline)  $font.append(XmlNode('u'));
	        if (attributes.italic)  $font.append(XmlNode('i'));
	        if (attributes.strike)  $font.append(XmlNode('strike'));
	        if (attributes.outline)  $font.append(XmlNode('outline'));
	        if (attributes.shadow)  $font.append(XmlNode('shadow'));
	
	        if (attributes.vertAlign) {
	          $font.append(XmlNode('vertAlign').attr('val', attributes.vertAlign))
	        }
	
	
	        if (attributes.color) {
	          if (attributes.color.theme) {
	            $font.append(XmlNode('color').attr('theme', attributes.color.theme))
	
	            if (attributes.color.tint) { //tint only if theme
	              $font.append(XmlNode('tint').attr('theme', attributes.color.tint))
	            }
	
	          } else if (attributes.color.rgb) { // not both rgb and theme
	            $font.append(XmlNode('color').attr('rgb', attributes.color.rgb))
	          }
	        }
	
	        this.$fonts.append($font);
	
	        var count = this.$fonts.children().length;
	        this.$fonts.attr('count', count);
	        return count - 1;
	      },
	
	        _addNumFmt: function (numFmt) {
	        if (!numFmt) { return 0; }
	
	        if (typeof numFmt == 'string') {
	          var numFmtIdx = fmt_table[numFmt];
	          if (numFmtIdx >= 0) {
	            return numFmtIdx; // we found a match against built in formats
	          }
	        }
	
	        if (/^[0-9]+$/.exec(numFmt)) {
	          return numFmt; // we're matching an integer against some known code
	        }
	        numFmt = numFmt
	            .replace(/&/g, '&amp;')
	            .replace(/</g, '&lt;')
	            .replace(/>/g, '&gt;')
	            .replace(/"/g, '&quot;')
	            .replace(/'/g, '&apos;');
	
	        var $numFmt = XmlNode('numFmt')
	            .attr('numFmtId', (++customNumFmtId))
	            .attr('formatCode', numFmt);
	
	        this.$numFmts.append($numFmt);
	
	        var count = this.$numFmts.children().length;
	        this.$numFmts.attr('count', count);
	        return customNumFmtId ;
	      },
	
	      _addFill: function (attributes) {
	
	        if (!attributes) { return 0; }
	
	        var $patternFill = XmlNode('patternFill')
	            .attr('patternType', attributes.patternType || 'solid');
	
	        if (attributes.fgColor) {
	          var $fgColor = XmlNode('fgColor');
	
	          //Excel doesn't like it when we set both rgb and theme+tint, but xlsx.parseFile() sets both
	          //var $fgColor = createElement('<fgColor/>', null, null, {xmlMode: true}).attr(attributes.fgColor)
	          if (attributes.fgColor.rgb) {
	
	            if (attributes.fgColor.rgb.length == 6) {
	              attributes.fgColor.rgb = "FF" + attributes.fgColor.rgb /// add alpha to an RGB as Excel expects aRGB
	            }
	
	            $fgColor.attr('rgb', attributes.fgColor.rgb);
	            $patternFill.append($fgColor);
	          }
	          else if (attributes.fgColor.theme) {
	            $fgColor.attr('theme', attributes.fgColor.theme);
	            if (attributes.fgColor.tint) {
	              $fgColor.attr('tint', attributes.fgColor.tint);
	            }
	            $patternFill.append($fgColor);
	          }
	
	          if (!attributes.bgColor) {
	            attributes.bgColor = { "indexed": "64"}
	          }
	        }
	
	        if (attributes.bgColor) {
	          var $bgColor = XmlNode('bgColor').attr(attributes.bgColor);
	          $patternFill.append($bgColor);
	        }
	
	        var $fill = XmlNode('fill')
	            .append($patternFill);
	
	        this.$fills.append($fill);
	
	        var count = this.$fills.children().length;
	        this.$fills.attr('count', count);
	        return count - 1;
	      },
	
	      _getSubBorder: function(direction, spec) {
	
	        var $direction = XmlNode(direction);
	        if (spec){
	          if (spec.style) $direction.attr('style', spec.style);
	          if (spec.color) {
	            var $color = XmlNode('color');
	            if (spec.color.auto) {
	              $color.attr('auto', spec.color.auto);
	            }
	            else if (spec.color.rgb) {
	              $color.attr('rgb', spec.color.rgb);
	            }
	            else if (spec.color.theme || spec.color.tint) {
	              $color.attr('theme', spec.color.theme || "1");
	              $color.attr('tint', spec.color.tint || "0");
	            }
	            $direction.append($color)
	          }
	        }
	        return $direction;
	      },
	
	      _addBorder: function (attributes) {
	        if (!attributes) { return 0; }
	
	        var self = this;
	
	        var $border = XmlNode('border')
	            .attr("diagonalUp",attributes.diagonalUp)
	            .attr("diagonalDown",attributes.diagonalDown);
	
	        var directions = ["left","right","top","bottom","diagonal"];
	
	        directions.forEach(function(direction) {
	          $border.append(self._getSubBorder(direction, attributes[direction]))
	        });
	        this.$borders.append($border);
	
	        var count = this.$borders.children().length;
	        this.$borders.attr('count', count);
	        return count -1;
	      },
	
	      toXml: function () {
	        return this.$styles.toXml();
	      }
	    }.initialize(options||{});
	  }
	
	
	XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.utils = utils;
	XLSX.CFB = CFB;
	XLSX.SSF = SSF;
	})( true ? exports : XLSX);
	var XLS = XLSX;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = getRequestAnimationFrame;
	exports.cancelRequestAnimationFrame = cancelRequestAnimationFrame;
	var availablePrefixs = ['moz', 'ms', 'webkit'];
	function requestAnimationFramePolyfill() {
	    var lastTime = 0;
	    return function (callback) {
	        var currTime = new Date().getTime();
	        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	        var id = window.setTimeout(function () {
	            callback(currTime + timeToCall);
	        }, timeToCall);
	        lastTime = currTime + timeToCall;
	        return id;
	    };
	}
	function getRequestAnimationFrame() {
	    if (typeof window === 'undefined') {
	        return function () {};
	    }
	    if (window.requestAnimationFrame) {
	        // https://github.com/vuejs/vue/issues/4465
	        return window.requestAnimationFrame.bind(window);
	    }
	    var prefix = availablePrefixs.filter(function (key) {
	        return key + 'RequestAnimationFrame' in window;
	    })[0];
	    return prefix ? window[prefix + 'RequestAnimationFrame'] : requestAnimationFramePolyfill();
	}
	function cancelRequestAnimationFrame(id) {
	    if (typeof window === 'undefined') {
	        return null;
	    }
	    if (window.cancelAnimationFrame) {
	        return window.cancelAnimationFrame(id);
	    }
	    var prefix = availablePrefixs.filter(function (key) {
	        return key + 'CancelAnimationFrame' in window || key + 'CancelRequestAnimationFrame' in window;
	    })[0];
	    return prefix ? (window[prefix + 'CancelAnimationFrame'] || window[prefix + 'CancelRequestAnimationFrame']).call(this, id) : clearTimeout(id);
	}

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Col = exports.Row = undefined;
	
	var _row = __webpack_require__(592);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(591);
	
	var _col2 = _interopRequireDefault(_col);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Row = _row2['default'];
	exports.Col = _col2['default'];

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Input = __webpack_require__(593);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _Group = __webpack_require__(1469);
	
	var _Group2 = _interopRequireDefault(_Group);
	
	var _Search = __webpack_require__(1470);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _TextArea = __webpack_require__(1471);
	
	var _TextArea2 = _interopRequireDefault(_TextArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Input2['default'].Group = _Group2['default'];
	_Input2['default'].Search = _Search2['default'];
	_Input2['default'].TextArea = _TextArea2['default'];
	exports['default'] = _Input2['default'];

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Group = exports.Button = undefined;
	
	var _radio = __webpack_require__(385);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _group = __webpack_require__(1495);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _radioButton = __webpack_require__(1496);
	
	var _radioButton2 = _interopRequireDefault(_radioButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_radio2['default'].Button = _radioButton2['default'];
	_radio2['default'].Group = _group2['default'];
	exports.Button = _radioButton2['default'];
	exports.Group = _group2['default'];
	exports['default'] = _radio2['default'];

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-param-reassign */
	var request = __webpack_require__(1410);
	var base64Url = __webpack_require__(728);
	var version = __webpack_require__(388);
	
	// ------------------------------------------------ RequestWrapper
	
	function RequestWrapper(req) {
	  this.request = req;
	  this.method = req.method;
	  this.url = req.url;
	  this.body = req._data;
	  this.headers = req._header;
	}
	
	RequestWrapper.prototype.abort = function() {
	  this.request.abort();
	};
	
	RequestWrapper.prototype.getMethod = function() {
	  return this.method;
	};
	
	RequestWrapper.prototype.getBody = function() {
	  return this.body;
	};
	
	RequestWrapper.prototype.getUrl = function() {
	  return this.url;
	};
	
	RequestWrapper.prototype.getHeaders = function() {
	  return this.headers;
	};
	
	// ------------------------------------------------ RequestObj
	
	function RequestObj(req) {
	  this.request = req;
	}
	
	RequestObj.prototype.set = function(key, value) {
	  this.request = this.request.set(key, value);
	  return this;
	};
	
	RequestObj.prototype.send = function(body) {
	  this.request = this.request.send(body);
	  return this;
	};
	
	RequestObj.prototype.withCredentials = function() {
	  this.request = this.request.withCredentials();
	  return this;
	};
	
	RequestObj.prototype.end = function(cb) {
	  this.request = this.request.end(cb);
	  return new RequestWrapper(this.request);
	};
	
	// ------------------------------------------------ RequestBuilder
	
	function RequestBuilder(options) {
	  this._sendTelemetry = options._sendTelemetry === false ? options._sendTelemetry : true;
	  this._telemetryInfo = options._telemetryInfo || null;
	  this._timesToRetryFailedRequests = options._timesToRetryFailedRequests;
	  this.headers = options.headers || {};
	}
	
	RequestBuilder.prototype.setCommonConfiguration = function(ongoingRequest, options) {
	  options = options || {};
	
	  if (options.noHeaders) {
	    return ongoingRequest;
	  }
	
	  var headers = this.headers;
	  ongoingRequest = ongoingRequest.set('Content-Type', 'application/json');
	
	  var keys = Object.keys(this.headers);
	
	  for (var a = 0; a < keys.length; a++) {
	    ongoingRequest = ongoingRequest.set(keys[a], headers[keys[a]]);
	  }
	
	  if (this._sendTelemetry) {
	    ongoingRequest = ongoingRequest.set('Auth0-Client', this.getTelemetryData());
	  }
	  if (this._timesToRetryFailedRequests > 0) {
	    ongoingRequest = ongoingRequest.retry(this._timesToRetryFailedRequests);
	  }
	  return ongoingRequest;
	};
	
	RequestBuilder.prototype.getTelemetryData = function() {
	  var clientInfo = this._telemetryInfo || { name: 'auth0.js', version: version.raw };
	  var jsonClientInfo = JSON.stringify(clientInfo);
	  return base64Url.encode(jsonClientInfo);
	};
	
	RequestBuilder.prototype.get = function(url, options) {
	  return new RequestObj(this.setCommonConfiguration(request.get(url), options));
	};
	
	RequestBuilder.prototype.post = function(url, options) {
	  return new RequestObj(this.setCommonConfiguration(request.post(url), options));
	};
	
	RequestBuilder.prototype.patch = function(url, options) {
	  return new RequestObj(this.setCommonConfiguration(request.patch(url), options));
	};
	
	module.exports = RequestBuilder;


/***/ },
/* 274 */
/***/ function(module, exports) {

	/* eslint-disable no-console */
	
	function Warn(options) {
	  this.disableWarnings = options.disableWarnings;
	}
	
	Warn.prototype.warning = function(message) {
	  if (this.disableWarnings) {
	    return;
	  }
	
	  console.warn(message);
	};
	
	module.exports = Warn;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactFlagsSelect = __webpack_require__(196);
	
	var _reactFlagsSelect2 = _interopRequireDefault(_reactFlagsSelect);
	
	__webpack_require__(185);
	
	var _reactSelect = __webpack_require__(514);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(430);
	
	var _reactRedux = __webpack_require__(40);
	
	var _search = __webpack_require__(578);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _redux = __webpack_require__(56);
	
	var _actions = __webpack_require__(216);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _Wrapper = __webpack_require__(1620);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _FlagWrapper = __webpack_require__(1618);
	
	var _FlagWrapper2 = _interopRequireDefault(_FlagWrapper);
	
	var _SelectWrapper = __webpack_require__(1619);
	
	var _SelectWrapper2 = _interopRequireDefault(_SelectWrapper);
	
	var _country = __webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GravatarOption = (0, _createReactClass2.default)({
	    propTypes: {
	        children: _propTypes2.default.node,
	        className: _propTypes2.default.string,
	        isDisabled: _propTypes2.default.bool,
	        isFocused: _propTypes2.default.bool,
	        isSelected: _propTypes2.default.bool,
	        onFocus: _propTypes2.default.func,
	        onSelect: _propTypes2.default.func,
	        option: _propTypes2.default.object.isRequired
	    },
	    handleMouseDown: function handleMouseDown(event) {
	        event.preventDefault();
	        event.stopPropagation();
	        this.props.onSelect(this.props.option, event);
	    },
	    handleMouseEnter: function handleMouseEnter(event) {
	        this.props.onFocus(this.props.option, event);
	    },
	    handleMouseMove: function handleMouseMove(event) {
	        if (this.props.isFocused) return;
	        this.props.onFocus(this.props.option, event);
	    },
	    render: function render() {
	        this.props.option.key < 4 && console.log(this.props.option);
	        return _react2.default.createElement(
	            'div',
	            {
	                className: this.props.className,
	                onMouseDown: this.handleMouseDown,
	                onMouseEnter: this.handleMouseEnter,
	                onMouseMove: this.handleMouseMove,
	                title: this.props.option.title },
	            _react2.default.createElement('img', { src: this.props.option.options.artworkUrl60 }),
	            _react2.default.createElement(
	                'span',
	                { className: 'app-name' },
	                this.props.children
	            ),
	            _react2.default.createElement(
	                'span',
	                { className: 'owner' },
	                this.props.option.options.sellerName
	            )
	        );
	    }
	});
	
	var SearchAppBar = function (_React$Component) {
	    _inherits(SearchAppBar, _React$Component);
	
	    function SearchAppBar() {
	        _classCallCheck(this, SearchAppBar);
	
	        var _this = _possibleConstructorReturn(this, (SearchAppBar.__proto__ || Object.getPrototypeOf(SearchAppBar)).call(this));
	
	        _this.onSelectAsyncChange = function (app) {
	            _this.setState({ value: app });
	            var _this$state = _this.state,
	                optionList = _this$state.optionList,
	                input = _this$state.input;
	
	            console.log(app.value);
	            console.log('optionList : ', optionList);
	            console.log(_this.props);
	
	            if (optionList && optionList.length > 1) {
	                _this.props.appSelected(app.value, optionList[1].value);
	
	                console.log(JSON.stringify(app.value));
	                console.log(JSON.stringify(optionList[1].value));
	            } else if (optionList && optionList.length === 1) {
	                _this.props.appSelected(app.value, app.value);
	            } else {
	                _this.props.appSelected(app.value, app.value);
	            }
	
	            _this.props.searchTermUpdated(input);
	
	            if (_this.props.auth && _this.props.auth.isAuthenticated()) {
	                _this.props.goTo('/addCampaign/appId/' + app.value.adamId);
	            } else {
	                _this.props.goTo('/home');
	            }
	        };
	
	        _this.getApps = function (input) {
	            if (!input) {
	                return Promise.resolve({ options: [] });
	            }
	
	            _this.setState({ input: input });
	
	            return _axios2.default.get('https://itunes.apple.com/search', {
	                params: { term: input, country: _this.props.countryCode || 'US', entity: 'software', 'Authorization': 'Bear xsjsjsjsjkss' }
	            }).then(function (response) {
	                // console.log(response.data);
	                if (response.data != undefined) {
	                    // let itemData = response.data;
	                    var itemData = response.data.results;
	                    console.log(itemData);
	
	                    var items = itemData.map(function (item, i) {
	                        return {
	                            key: i,
	                            label: item.trackCensoredName,
	                            id: i,
	                            value: {
	                                adamId: item.trackId,
	                                bundleId: item.bundleId,
	                                artworkUrl60: item.artworkUrl60,
	                                artworkUrl100: item.artworkUrl100,
	                                name: item.trackCensoredName,
	                                trackCensoredName: item.trackCensoredName,
	                                sellerName: item.sellerName,
	                                screenshotUrls: item.screenshotUrls
	                            },
	                            options: item
	                        };
	                    });
	                    console.log(' items ', items);
	
	                    _this.setState({ optionList: items });
	                    return { options: items };
	                }
	            }).catch(function (error) {
	                console.log(error.message);
	            });
	        };
	
	        _this.state = {
	            redirectToReferrer: false,
	            optionList: null
	        };
	        return _this;
	    }
	
	    //TODO optionlist is missing
	
	
	    _createClass(SearchAppBar, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'search-app-bar' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'search-app-bar-border-wrapper' },
	                    _react2.default.createElement(
	                        _FlagWrapper2.default,
	                        { className: 'region-select' },
	                        _react2.default.createElement(_reactFlagsSelect2.default, {
	                            className: 'regionInput',
	                            defaultCountry: this.props.countryCode ? this.props.countryCode.toUpperCase() : 'US',
	                            countries: _country.COUNTRIES,
	                            customLabels: _country.FLAG_LABELS,
	                            placeholder: 'Select Language',
	                            onSelect: this.props.onCountryCodeUpdated,
	                            showSelectedLabel: true
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _SelectWrapper2.default,
	                        { className: 'app-search ' + this.props.selectClassName },
	                        _react2.default.createElement(_reactSelect2.default.Async, {
	                            className: 'searchInput ' + this.props.selectClassName,
	                            multi: false,
	                            value: this.props.value,
	                            onChange: this.onSelectAsyncChange,
	                            valueKey: 'value',
	                            labelKey: 'label',
	                            loadOptions: this.getApps,
	                            placeholder: this.props.placeholder,
	                            noResultsText: 'No search result',
	                            backspaceRemoves: this.props.backspaceRemoves,
	                            optionComponent: GravatarOption
	                        })
	                    ),
	                    _react2.default.createElement('img', { src: ("") + _search2.default })
	                )
	            );
	        }
	    }]);
	
	    return SearchAppBar;
	}(_react2.default.Component);
	
	function mapDispatchToProps(dispatch) {
	    return {
	        appSelected: (0, _redux.bindActionCreators)(_actions2.default.appSelected, dispatch),
	        searchTermUpdated: (0, _redux.bindActionCreators)(_actions2.default.searchTermUpdated, dispatch),
	        onCountryCodeUpdated: function onCountryCodeUpdated(countryCode) {
	            return dispatch(_actions2.default.countryCodeUpdated(countryCode));
	        }
	
	    };
	}
	function mapStateToProps(state) {
	    var campaign = state.get('deep').campaign;
	    return {
	        search: state.get('search'),
	        campaign: campaign,
	        currentApp: state.getIn(['App', 'currentApp']),
	        secondApp: state.getIn(['App', 'secondApp']),
	        searchTerm: state.getIn(['App', 'searchTerm']),
	        countryCode: state.getIn(['ItunesSearch', 'countryCode']) || 'US'
	
	    };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SearchAppBar);

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SubMenu = exports.MenuItem = exports.DropdownMenu = exports.DropdownButtons = undefined;
	
	var _antd = __webpack_require__(43);
	
	var _dropdown = __webpack_require__(1627);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WDDropdowns = (0, _dropdown2.default)(_antd.Dropdown);
	var Dropdowns = (0, _withDirection2.default)(WDDropdowns);
	
	var WDDropdownButtons = (0, _dropdown2.default)(_antd.Dropdown.Button);
	var DropdownButtons = (0, _withDirection2.default)(WDDropdownButtons);
	var DropdownMenu = (0, _dropdown.DropdownMenus)(_antd.Menu);
	var MenuItem = (0, _dropdown.DropdownMenus)(_antd.Menu.Item);
	var SubMenu = (0, _dropdown.DropdownMenus)(_antd.Menu.SubMenu);
	
	exports.default = Dropdowns;
	exports.DropdownButtons = DropdownButtons;
	exports.DropdownMenu = DropdownMenu;
	exports.MenuItem = MenuItem;
	exports.SubMenu = SubMenu;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antd = __webpack_require__(43);
	
	exports.default = _antd.Tooltip;

/***/ },
/* 278 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transition = transition;
	exports.borderRadius = borderRadius;
	exports.boxShadow = boxShadow;
	// import { css } from 'styled-components';
	
	// Transition
	function transition() {
	    var timing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.3;
	
	    return '\n      -webkit-transition: all ' + timing + 's cubic-bezier(0.215, 0.61, 0.355, 1);\n      -moz-transition: all ' + timing + 's cubic-bezier(0.215, 0.61, 0.355, 1);\n      -ms-transition: all ' + timing + 's cubic-bezier(0.215, 0.61, 0.355, 1);\n      -o-transition: all ' + timing + 's cubic-bezier(0.215, 0.61, 0.355, 1);\n      transition: all ' + timing + 's cubic-bezier(0.215, 0.61, 0.355, 1);\n  ';
	}
	
	// Border Radius
	function borderRadius() {
	    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    return '\n      -webkit-border-radius: ' + radius + ';\n      -moz-border-radius: ' + radius + ';\n      -ms-transition: ' + radius + ';\n      -o-border-radius: ' + radius + ';\n      border-radius: ' + radius + ';\n  ';
	}
	
	// Box Shadow
	function boxShadow() {
	    var shadow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'none';
	
	    return '\n      -webkit-box-shadow: ' + shadow + ';\n      -moz-box-shadow: ' + shadow + ';\n      box-shadow: ' + shadow + ';\n  ';
	}

/***/ },
/* 279 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FLAG_LABELS = {
	  "US": "美国",
	  "GB": "英国",
	  "CA": "加拿大",
	  "CH": "瑞士",
	  "MX": "墨西哥",
	  "ZH": "ZH",
	  "AU": "澳大利亚",
	  "NZ": "新西兰",
	  "IT": "義大利",
	  "FR": "法國",
	  "DE": "德國",
	  "ES": "西班牙",
	  "JP": "日本",
	  "KR": "韓國"
	};
	
	var COUNTRIES = ["US", "GB", "CA", "CH", "MX", "AU", "NZ", "IT", "FR", "DE", "ES", "JP", "KR"];
	
	exports.FLAG_LABELS = FLAG_LABELS;
	exports.COUNTRIES = COUNTRIES;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1660);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	var GridContent = function (_React$Component) {
	    _inherits(GridContent, _React$Component);
	
	    function GridContent() {
	        _classCallCheck(this, GridContent);
	
	        return _possibleConstructorReturn(this, (GridContent.__proto__ || Object.getPrototypeOf(GridContent)).apply(this, arguments));
	    }
	
	    _createClass(GridContent, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: "grid-content " + (this.props.className ? this.props.className : "") },
	                this.props.title && this.props.title.length > 0 && _react2.default.createElement(
	                    "div",
	                    { className: "content-title" },
	                    this.props.title
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "content-explain" },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return GridContent;
	}(_react2.default.Component);
	
	exports.default = GridContent;
	;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1663);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _aosTick = __webpack_require__(3298);
	
	var _aosTick2 = _interopRequireDefault(_aosTick);
	
	var _aosCross = __webpack_require__(3297);
	
	var _aosCross2 = _interopRequireDefault(_aosCross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	// -- Resources
	
	
	var GridHeader = function (_React$Component) {
	    _inherits(GridHeader, _React$Component);
	
	    function GridHeader() {
	        _classCallCheck(this, GridHeader);
	
	        return _possibleConstructorReturn(this, (GridHeader.__proto__ || Object.getPrototypeOf(GridHeader)).apply(this, arguments));
	    }
	
	    _createClass(GridHeader, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: "grid-header" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "header-text" },
	                    this.props.title
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "header-explain" },
	                    this.props.children
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "header-icon" },
	                    _react2.default.createElement("img", { src: this.props.ok && _aosTick2.default || _aosCross2.default })
	                )
	            );
	        }
	    }]);
	
	    return GridHeader;
	}(_react2.default.Component);
	
	exports.default = GridHeader;
	;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCurrentLanguage = getCurrentLanguage;
	
	var _config = __webpack_require__(395);
	
	var _uk = __webpack_require__(2254);
	
	var _uk2 = _interopRequireDefault(_uk);
	
	var _china = __webpack_require__(2250);
	
	var _china2 = _interopRequireDefault(_china);
	
	var _spain = __webpack_require__(2253);
	
	var _spain2 = _interopRequireDefault(_spain);
	
	var _france = __webpack_require__(2251);
	
	var _france2 = _interopRequireDefault(_france);
	
	var _italy = __webpack_require__(2252);
	
	var _italy2 = _interopRequireDefault(_italy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var config = {
	  defaultLanguage: _config.language,
	  options: [{
	    languageId: 'english',
	    locale: 'en',
	    text: 'English',
	    icon: _uk2.default
	  }, {
	    languageId: 'chinese',
	    locale: 'zh',
	    text: 'Chinese',
	    icon: _china2.default
	  }, {
	    languageId: 'spanish',
	    locale: 'es',
	    text: 'Spanish',
	    icon: _spain2.default
	  }, {
	    languageId: 'french',
	    locale: 'fr',
	    text: 'French',
	    icon: _france2.default
	  }, {
	    languageId: 'italian',
	    locale: 'it',
	    text: 'Italian',
	    icon: _italy2.default
	  }]
	};
	
	function getCurrentLanguage(lang) {
	  var selecetedLanguage = config.options[0];
	  config.options.forEach(function (language) {
	    if (language.languageId === lang) {
	      selecetedLanguage = language;
	    }
	  });
	  return selecetedLanguage;
	}
	exports.default = config;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(401);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 284 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(1790)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(761)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = xor;
	function xor(a, b) {
	  var len = Math.min(a.length, b.length);
	  var out = new Buffer(len);
	  var i = -1;
	  while (++i < len) {
	    out.writeUInt8(a[i] ^ b[i], i);
	  }
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 287 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * @namespace Chart.helpers
	 */
	var helpers = {
		/**
		 * An empty function that can be used, for example, for optional callback.
		 */
		noop: function() {},
	
		/**
		 * Returns a unique id, sequentially generated from a global variable.
		 * @returns {Number}
		 * @function
		 */
		uid: (function() {
			var id = 0;
			return function() {
				return id++;
			};
		}()),
	
		/**
		 * Returns true if `value` is neither null nor undefined, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isNullOrUndef: function(value) {
			return value === null || typeof value === 'undefined';
		},
	
		/**
		 * Returns true if `value` is an array, else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @function
		 */
		isArray: Array.isArray ? Array.isArray : function(value) {
			return Object.prototype.toString.call(value) === '[object Array]';
		},
	
		/**
		 * Returns true if `value` is an object (excluding null), else returns false.
		 * @param {*} value - The value to test.
		 * @returns {Boolean}
		 * @since 2.7.0
		 */
		isObject: function(value) {
			return value !== null && Object.prototype.toString.call(value) === '[object Object]';
		},
	
		/**
		 * Returns `value` if defined, else returns `defaultValue`.
		 * @param {*} value - The value to return if defined.
		 * @param {*} defaultValue - The value to return if `value` is undefined.
		 * @returns {*}
		 */
		valueOrDefault: function(value, defaultValue) {
			return typeof value === 'undefined' ? defaultValue : value;
		},
	
		/**
		 * Returns value at the given `index` in array if defined, else returns `defaultValue`.
		 * @param {Array} value - The array to lookup for value at `index`.
		 * @param {Number} index - The index in `value` to lookup for value.
		 * @param {*} defaultValue - The value to return if `value[index]` is undefined.
		 * @returns {*}
		 */
		valueAtIndexOrDefault: function(value, index, defaultValue) {
			return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
		},
	
		/**
		 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
		 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
		 * @param {Function} fn - The function to call.
		 * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @returns {*}
		 */
		callback: function(fn, args, thisArg) {
			if (fn && typeof fn.call === 'function') {
				return fn.apply(thisArg, args);
			}
		},
	
		/**
		 * Note(SB) for performance sake, this method should only be used when loopable type
		 * is unknown or in none intensive code (not called often and small loopable). Else
		 * it's preferable to use a regular for() loop and save extra function calls.
		 * @param {Object|Array} loopable - The object or array to be iterated.
		 * @param {Function} fn - The function to call for each item.
		 * @param {Object} [thisArg] - The value of `this` provided for the call to `fn`.
		 * @param {Boolean} [reverse] - If true, iterates backward on the loopable.
		 */
		each: function(loopable, fn, thisArg, reverse) {
			var i, len, keys;
			if (helpers.isArray(loopable)) {
				len = loopable.length;
				if (reverse) {
					for (i = len - 1; i >= 0; i--) {
						fn.call(thisArg, loopable[i], i);
					}
				} else {
					for (i = 0; i < len; i++) {
						fn.call(thisArg, loopable[i], i);
					}
				}
			} else if (helpers.isObject(loopable)) {
				keys = Object.keys(loopable);
				len = keys.length;
				for (i = 0; i < len; i++) {
					fn.call(thisArg, loopable[keys[i]], keys[i]);
				}
			}
		},
	
		/**
		 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
		 * @see http://stackoverflow.com/a/14853974
		 * @param {Array} a0 - The array to compare
		 * @param {Array} a1 - The array to compare
		 * @returns {Boolean}
		 */
		arrayEquals: function(a0, a1) {
			var i, ilen, v0, v1;
	
			if (!a0 || !a1 || a0.length !== a1.length) {
				return false;
			}
	
			for (i = 0, ilen = a0.length; i < ilen; ++i) {
				v0 = a0[i];
				v1 = a1[i];
	
				if (v0 instanceof Array && v1 instanceof Array) {
					if (!helpers.arrayEquals(v0, v1)) {
						return false;
					}
				} else if (v0 !== v1) {
					// NOTE: two different object instances will never be equal: {x:20} != {x:20}
					return false;
				}
			}
	
			return true;
		},
	
		/**
		 * Returns a deep copy of `source` without keeping references on objects and arrays.
		 * @param {*} source - The value to clone.
		 * @returns {*}
		 */
		clone: function(source) {
			if (helpers.isArray(source)) {
				return source.map(helpers.clone);
			}
	
			if (helpers.isObject(source)) {
				var target = {};
				var keys = Object.keys(source);
				var klen = keys.length;
				var k = 0;
	
				for (; k < klen; ++k) {
					target[keys[k]] = helpers.clone(source[keys[k]]);
				}
	
				return target;
			}
	
			return source;
		},
	
		/**
		 * The default merger when Chart.helpers.merge is called without merger option.
		 * Note(SB): this method is also used by configMerge and scaleMerge as fallback.
		 * @private
		 */
		_merger: function(key, target, source, options) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.merge(tval, sval, options);
			} else {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Merges source[key] in target[key] only if target[key] is undefined.
		 * @private
		 */
		_mergerIf: function(key, target, source) {
			var tval = target[key];
			var sval = source[key];
	
			if (helpers.isObject(tval) && helpers.isObject(sval)) {
				helpers.mergeIf(tval, sval);
			} else if (!target.hasOwnProperty(key)) {
				target[key] = helpers.clone(sval);
			}
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` with the given `options`.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @param {Object} [options] - Merging options:
		 * @param {Function} [options.merger] - The merge method (key, target, source, options)
		 * @returns {Object} The `target` object.
		 */
		merge: function(target, source, options) {
			var sources = helpers.isArray(source) ? source : [source];
			var ilen = sources.length;
			var merge, i, keys, klen, k;
	
			if (!helpers.isObject(target)) {
				return target;
			}
	
			options = options || {};
			merge = options.merger || helpers._merger;
	
			for (i = 0; i < ilen; ++i) {
				source = sources[i];
				if (!helpers.isObject(source)) {
					continue;
				}
	
				keys = Object.keys(source);
				for (k = 0, klen = keys.length; k < klen; ++k) {
					merge(keys[k], target, source, options);
				}
			}
	
			return target;
		},
	
		/**
		 * Recursively deep copies `source` properties into `target` *only* if not defined in target.
		 * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
		 * @param {Object} target - The target object in which all sources are merged into.
		 * @param {Object|Array(Object)} source - Object(s) to merge into `target`.
		 * @returns {Object} The `target` object.
		 */
		mergeIf: function(target, source) {
			return helpers.merge(target, source, {merger: helpers._mergerIf});
		},
	
		/**
		 * Applies the contents of two or more objects together into the first object.
		 * @param {Object} target - The target object in which all objects are merged into.
		 * @param {Object} arg1 - Object containing additional properties to merge in target.
		 * @param {Object} argN - Additional objects containing properties to merge in target.
		 * @returns {Object} The `target` object.
		 */
		extend: function(target) {
			var setFn = function(value, key) {
				target[key] = value;
			};
			for (var i = 1, ilen = arguments.length; i < ilen; ++i) {
				helpers.each(arguments[i], setFn);
			}
			return target;
		},
	
		/**
		 * Basic javascript inheritance based on the model created in Backbone.js
		 */
		inherits: function(extensions) {
			var me = this;
			var ChartElement = (extensions && extensions.hasOwnProperty('constructor')) ? extensions.constructor : function() {
				return me.apply(this, arguments);
			};
	
			var Surrogate = function() {
				this.constructor = ChartElement;
			};
	
			Surrogate.prototype = me.prototype;
			ChartElement.prototype = new Surrogate();
			ChartElement.extend = helpers.inherits;
	
			if (extensions) {
				helpers.extend(ChartElement.prototype, extensions);
			}
	
			ChartElement.__super__ = me.prototype;
			return ChartElement;
		}
	};
	
	module.exports = helpers;
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.callback instead.
	 * @function Chart.helpers.callCallback
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.callCallback = helpers.callback;
	
	/**
	 * Provided for backward compatibility, use Array.prototype.indexOf instead.
	 * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
	 * @function Chart.helpers.indexOf
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.indexOf = function(array, item, fromIndex) {
		return Array.prototype.indexOf.call(array, item, fromIndex);
	};
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
	 * @function Chart.helpers.getValueOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueOrDefault = helpers.valueOrDefault;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
	 * @function Chart.helpers.getValueAtIndexOrDefault
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
	'use strict';
	
	/**
	 * Clones (copies) an Object using deep copying.
	 *
	 * This function supports circular references by default, but if you are certain
	 * there are no circular references in your object, you can save some CPU time
	 * by calling clone(obj, false).
	 *
	 * Caution: if `circular` is false and `parent` contains circular references,
	 * your program may enter an infinite loop and crash.
	 *
	 * @param `parent` - the object to be cloned
	 * @param `circular` - set to true if the object to be cloned may contain
	 *    circular references. (optional - true by default)
	 * @param `depth` - set to a number if the object is only to be cloned to
	 *    a particular depth. (optional - defaults to Infinity)
	 * @param `prototype` - sets the prototype to be used when cloning an object.
	 *    (optional - defaults to parent prototype).
	*/
	function clone(parent, circular, depth, prototype) {
	  var filter;
	  if (typeof circular === 'object') {
	    depth = circular.depth;
	    prototype = circular.prototype;
	    filter = circular.filter;
	    circular = circular.circular
	  }
	  // maintain two arrays for circular references, where corresponding parents
	  // and children have the same index
	  var allParents = [];
	  var allChildren = [];
	
	  var useBuffer = typeof Buffer != 'undefined';
	
	  if (typeof circular == 'undefined')
	    circular = true;
	
	  if (typeof depth == 'undefined')
	    depth = Infinity;
	
	  // recurse this function so we don't reset allParents and allChildren
	  function _clone(parent, depth) {
	    // cloning null always returns null
	    if (parent === null)
	      return null;
	
	    if (depth == 0)
	      return parent;
	
	    var child;
	    var proto;
	    if (typeof parent != 'object') {
	      return parent;
	    }
	
	    if (clone.__isArray(parent)) {
	      child = [];
	    } else if (clone.__isRegExp(parent)) {
	      child = new RegExp(parent.source, __getRegExpFlags(parent));
	      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
	    } else if (clone.__isDate(parent)) {
	      child = new Date(parent.getTime());
	    } else if (useBuffer && Buffer.isBuffer(parent)) {
	      child = new Buffer(parent.length);
	      parent.copy(child);
	      return child;
	    } else {
	      if (typeof prototype == 'undefined') {
	        proto = Object.getPrototypeOf(parent);
	        child = Object.create(proto);
	      }
	      else {
	        child = Object.create(prototype);
	        proto = prototype;
	      }
	    }
	
	    if (circular) {
	      var index = allParents.indexOf(parent);
	
	      if (index != -1) {
	        return allChildren[index];
	      }
	      allParents.push(parent);
	      allChildren.push(child);
	    }
	
	    for (var i in parent) {
	      var attrs;
	      if (proto) {
	        attrs = Object.getOwnPropertyDescriptor(proto, i);
	      }
	
	      if (attrs && attrs.set == null) {
	        continue;
	      }
	      child[i] = _clone(parent[i], depth - 1);
	    }
	
	    return child;
	  }
	
	  return _clone(parent, depth);
	}
	
	/**
	 * Simple flat clone using prototype, accepts only objects, usefull for property
	 * override on FLAT configuration object (no nested props).
	 *
	 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
	 * works.
	 */
	clone.clonePrototype = function clonePrototype(parent) {
	  if (parent === null)
	    return null;
	
	  var c = function () {};
	  c.prototype = parent;
	  return new c();
	};
	
	// private utility functions
	
	function __objToStr(o) {
	  return Object.prototype.toString.call(o);
	};
	clone.__objToStr = __objToStr;
	
	function __isDate(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Date]';
	};
	clone.__isDate = __isDate;
	
	function __isArray(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object Array]';
	};
	clone.__isArray = __isArray;
	
	function __isRegExp(o) {
	  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
	};
	clone.__isRegExp = __isRegExp;
	
	function __getRegExpFlags(re) {
	  var flags = '';
	  if (re.global) flags += 'g';
	  if (re.ignoreCase) flags += 'i';
	  if (re.multiline) flags += 'm';
	  return flags;
	};
	clone.__getRegExpFlags = __getRegExpFlags;
	
	return clone;
	})();
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = clone;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(1864);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(1860);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.4. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	var nest = function() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	};
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	var keys = function(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	};
	
	var values = function(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	};
	
	var entries = function(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	};
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(122)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	var basis$1 = function(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var basisClosed = function(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb$1 = ((function rgbGamma(y) {
	  var color$$1 = gamma(y);
	
	  function rgb$$1(start, end) {
	    var r = color$$1((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color$$1(start.g, end.g),
	        b = color$$1(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb$$1.gamma = rgbGamma;
	
	  return rgb$$1;
	}))(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color$$1;
	    for (i = 0; i < n; ++i) {
	      color$$1 = d3Color.rgb(colors[i]);
	      r[i] = color$$1.r || 0;
	      g[i] = color$$1.g || 0;
	      b[i] = color$$1.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color$$1.opacity = 1;
	    return function(t) {
	      color$$1.r = r(t);
	      color$$1.g = g(t);
	      color$$1.b = b(t);
	      return color$$1 + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	var array = function(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	};
	
	var date = function(a, b) {
	  var d = new Date;
	  return a = +a, b -= a, function(t) {
	    return d.setTime(a + b * t), d;
	  };
	};
	
	var number = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return a + b * t;
	  };
	};
	
	var object = function(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	};
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	var reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	var string = function(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	};
	
	var value = function(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	      : b instanceof d3Color.color ? rgb$1
	      : b instanceof Date ? date
	      : Array.isArray(b) ? array
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	};
	
	var round = function(a, b) {
	  return a = +a, b -= a, function(t) {
	    return Math.round(a + b * t);
	  };
	};
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	var decompose = function(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	};
	
	var cssNode;
	var cssRoot;
	var cssView;
	var svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2;
	var rho2 = 2;
	var rho4 = 4;
	var epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	var zoom = function(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	};
	
	function hsl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$2 = hsl$1(hue);
	var hslLong = hsl$1(nogamma);
	
	function lab$1(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl$1(hue$$1) {
	  return function(start, end) {
	    var h = hue$$1((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$2 = hcl$1(hue);
	var hclLong = hcl$1(nogamma);
	
	function cubehelix$1(hue$$1) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix$$1(start, end) {
	      var h = hue$$1((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix$$1.gamma = cubehelixGamma;
	
	    return cubehelix$$1;
	  })(1);
	}
	
	var cubehelix$2 = cubehelix$1(hue);
	var cubehelixLong = cubehelix$1(nogamma);
	
	var quantize = function(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	};
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateDate = date;
	exports.interpolateNumber = number;
	exports.interpolateObject = object;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.interpolateRgb = rgb$1;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateHsl = hsl$2;
	exports.interpolateHslLong = hslLong;
	exports.interpolateLab = lab$1;
	exports.interpolateHcl = hcl$2;
	exports.interpolateHclLong = hclLong;
	exports.interpolateCubehelix = cubehelix$2;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = style;
	
	var _camelizeStyle = __webpack_require__(908);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	var _hyphenateStyle = __webpack_require__(1908);
	
	var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);
	
	var _getComputedStyle2 = __webpack_require__(1903);
	
	var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);
	
	var _removeStyle = __webpack_require__(1904);
	
	var _removeStyle2 = _interopRequireDefault(_removeStyle);
	
	var _properties = __webpack_require__(907);
	
	var _isTransform = __webpack_require__(1905);
	
	var _isTransform2 = _interopRequireDefault(_isTransform);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function style(node, property, value) {
	  var css = '';
	  var transforms = '';
	  var props = property;
	
	  if (typeof property === 'string') {
	    if (value === undefined) {
	      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
	    } else {
	      (props = {})[property] = value;
	    }
	  }
	
	  Object.keys(props).forEach(function (key) {
	    var value = props[key];
	    if (!value && value !== 0) {
	      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
	    } else if ((0, _isTransform2.default)(key)) {
	      transforms += key + '(' + value + ') ';
	    } else {
	      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
	    }
	  });
	
	  if (transforms) {
	    css += _properties.transform + ': ' + transforms + ';';
	  }
	
	  node.style.cssText += ';' + css;
	}
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1910);

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @format
	 * 
	 */
	
	var DraftEntityInstance = __webpack_require__(913);
	var Immutable = __webpack_require__(26);
	
	var invariant = __webpack_require__(18);
	
	var Map = Immutable.Map;
	
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * Temporary utility for generating the warnings
	 */
	function logWarning(oldMethodCall, newMethodCall) {
	  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
	}
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getLastCreatedEntityKey' instead.
	   * ---
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
	    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
	    return DraftEntity.__getLastCreatedEntityKey();
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.createEntity' instead.
	   * ---
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    logWarning('DraftEntity.create', 'contentState.createEntity');
	    return DraftEntity.__create(type, mutability, data);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.addEntity' instead.
	   * ---
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    logWarning('DraftEntity.add', 'contentState.addEntity');
	    return DraftEntity.__add(instance);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getEntity' instead.
	   * ---
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    logWarning('DraftEntity.get', 'contentState.getEntity');
	    return DraftEntity.__get(key);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.mergeEntityData' instead.
	   * ---
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
	    return DraftEntity.__mergeData(key, toMerge);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.replaceEntityData' instead.
	   * ---
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
	    return DraftEntity.__replaceData(key, newData);
	  },
	
	  // ***********************************WARNING******************************
	  // --- the above public API will be deprecated in the next version of Draft!
	  // The methods below this line are private - don't call them directly.
	
	  /**
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
	    return '' + instanceKey;
	  },
	
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  __create: function __create(type, mutability, data) {
	    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  __add: function __add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  __get: function __get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  __mergeData: function __mergeData(key, toMerge) {
	    var instance = DraftEntity.__get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  __replaceData: function __replaceData(key, newData) {
	    var instance = DraftEntity.__get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @format
	 * 
	 */
	
	'use strict';
	
	var randomizeBlockMapKeys = __webpack_require__(930);
	var removeEntitiesAtEdges = __webpack_require__(931);
	
	var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block;
	  }));
	};
	
	module.exports = getContentStateFragment;

/***/ },
/* 298 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(2022);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(67);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(2257);
	
	module.exports = Function.prototype.bind || implementation;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(302);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(3235);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(3319);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.parseRFC3966 = parseRFC3966;
	exports.formatRFC3966 = formatRFC3966;
	
	var _parse = __webpack_require__(150);
	
	// https://www.ietf.org/rfc/rfc3966.txt
	
	/**
	 * @param  {string} text - Phone URI (RFC 3966).
	 * @return {object} `{ ?number, ?ext }`.
	 */
	function parseRFC3966(text) {
		var number = void 0;
		var ext = void 0;
	
		// Replace "tel:" with "tel=" for parsing convenience.
		text = text.replace(/^tel:/, 'tel=');
	
		for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var part = _ref;
	
			var _part$split = part.split('='),
			    _part$split2 = _slicedToArray(_part$split, 2),
			    name = _part$split2[0],
			    value = _part$split2[1];
	
			switch (name) {
				case 'tel':
					number = value;
					break;
				case 'ext':
					ext = value;
					break;
				case 'phone-context':
					// Only "country contexts" are supported.
					// "Domain contexts" are ignored.
					if (value[0] === '+') {
						number = value + number;
					}
					break;
			}
		}
	
		// If the phone number is not viable, then abort.
		if (!(0, _parse.is_viable_phone_number)(number)) {
			return {};
		}
	
		var result = { number: number };
		if (ext) {
			result.ext = ext;
		}
		return result;
	}
	
	/**
	 * @param  {object} - `{ ?number, ?extension }`.
	 * @return {string} Phone URI (RFC 3966).
	 */
	function formatRFC3966(_ref2) {
		var number = _ref2.number,
		    ext = _ref2.ext;
	
		if (!number) {
			return '';
		}
	
		if (number[0] !== '+') {
			throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
		}
	
		return 'tel:' + number + (ext ? ';ext=' + ext : '');
	}
	//# sourceMappingURL=RFC3966.js.map

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = get_number_type;
	exports.is_of_type = is_of_type;
	exports.sort_out_arguments = sort_out_arguments;
	exports.check_number_length_for_type = check_number_length_for_type;
	exports.merge_arrays = merge_arrays;
	
	var _parse = __webpack_require__(150);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _common = __webpack_require__(127);
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var non_fixed_line_types = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL'];
	
	// Finds out national phone number type (fixed line, mobile, etc)
	function get_number_type(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		// When no input was passed
	
	
		if (!input) {
			return;
		}
	
		// When `parse()` returned `{}`
		// meaning that the phone number is not a valid one.
		if (!input.country) {
			return;
		}
	
		if (!metadata.hasCountry(input.country)) {
			throw new Error('Unknown country: ' + input.country);
		}
	
		var national_number = input.phone;
		metadata.country(input.country);
	
		// The following is copy-pasted from the original function:
		// https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
	
		// Is this national number even valid for this country
		if (!(0, _common.matches_entirely)(national_number, metadata.nationalNumberPattern())) {
			return;
		}
	
		// Is it fixed line number
		if (is_of_type(national_number, 'FIXED_LINE', metadata)) {
			// Because duplicate regular expressions are removed
			// to reduce metadata size, if "mobile" pattern is ""
			// then it means it was removed due to being a duplicate of the fixed-line pattern.
			//
			if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			// v1 metadata.
			// Legacy.
			// Deprecated.
			if (!metadata.type('MOBILE')) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			// Check if the number happens to qualify as both fixed line and mobile.
			// (no such country in the minimal metadata set)
			/* istanbul ignore if */
			if (is_of_type(national_number, 'MOBILE', metadata)) {
				return 'FIXED_LINE_OR_MOBILE';
			}
	
			return 'FIXED_LINE';
		}
	
		for (var _iterator = non_fixed_line_types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var _type = _ref;
	
			if (is_of_type(national_number, _type, metadata)) {
				return _type;
			}
		}
	}
	
	function is_of_type(national_number, type, metadata) {
		type = metadata.type(type);
	
		if (!type || !type.pattern()) {
			return false;
		}
	
		// Check if any possible number lengths are present;
		// if so, we use them to avoid checking
		// the validation pattern if they don't match.
		// If they are absent, this means they match
		// the general description, which we have
		// already checked before a specific number type.
		if (type.possibleLengths() && type.possibleLengths().indexOf(national_number.length) < 0) {
			return false;
		}
	
		return (0, _common.matches_entirely)(national_number, type.pattern());
	}
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3) {
		var input = void 0;
		var metadata = void 0;
	
		// If the phone number is passed as a string.
		// `getNumberType('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			// If "resrict country" argument is being passed
			// then convert it to an `options` object.
			// `getNumberType('88005553535', 'RU', metadata)`.
			if (typeof arg_2 === 'string' || arg_2 === undefined) {
				metadata = arg_3;
	
				// `parse` extracts phone numbers from raw text,
				// therefore it will cut off all "garbage" characters,
				// while this `validate` function needs to verify
				// that the phone number contains no "garbage"
				// therefore the explicit `is_viable_phone_number` check.
				if ((0, _parse.is_viable_phone_number)(arg_1)) {
					input = (0, _parse2.default)(arg_1, arg_2, metadata);
				}
			}
			// No "resrict country" argument is being passed.
			// International phone number is passed.
			// `getNumberType('+78005553535', metadata)`.
			else {
					metadata = arg_2;
	
					// `parse` extracts phone numbers from raw text,
					// therefore it will cut off all "garbage" characters,
					// while this `validate` function needs to verify
					// that the phone number contains no "garbage"
					// therefore the explicit `is_viable_phone_number` check.
					if ((0, _parse.is_viable_phone_number)(arg_1)) {
						input = (0, _parse2.default)(arg_1, metadata);
					}
				}
		}
		// If the phone number is passed as a parsed phone number.
		// `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
		else if (is_object(arg_1) && typeof arg_1.phone === 'string') {
				// The `arg_1` must be a valid phone number
				// as a whole, not just a part of it which gets parsed here.
				if ((0, _parse.is_viable_phone_number)(arg_1.phone)) {
					input = arg_1;
				}
	
				metadata = arg_2;
			} else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');
	
		return { input: input, metadata: new _metadata2.default(metadata) };
	}
	
	// Should only be called for the "new" metadata which has "possible lengths".
	function check_number_length_for_type(national_number, type, metadata) {
		var type_info = metadata.type(type);
	
		// There should always be "<possiblePengths/>" set for every type element.
		// This is declared in the XML schema.
		// For size efficiency, where a sub-description (e.g. fixed-line)
		// has the same "<possiblePengths/>" as the "general description", this is missing,
		// so we fall back to the "general description". Where no numbers of the type
		// exist at all, there is one possible length (-1) which is guaranteed
		// not to match the length of any real phone number.
		var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
		// let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
	
		if (type === 'FIXED_LINE_OR_MOBILE') {
			// No such country in metadata.
			/* istanbul ignore next */
			if (!metadata.type('FIXED_LINE')) {
				// The rare case has been encountered where no fixedLine data is available
				// (true for some non-geographical entities), so we just check mobile.
				return test_number_length_for_type(national_number, 'MOBILE', metadata);
			}
	
			var mobile_type = metadata.type('MOBILE');
	
			if (mobile_type) {
				// Merge the mobile data in if there was any. "Concat" creates a new
				// array, it doesn't edit possible_lengths in place, so we don't need a copy.
				// Note that when adding the possible lengths from mobile, we have
				// to again check they aren't empty since if they are this indicates
				// they are the same as the general desc and should be obtained from there.
				possible_lengths = merge_arrays(possible_lengths, mobile_type.possibleLengths());
				// The current list is sorted; we need to merge in the new list and
				// re-sort (duplicates are okay). Sorting isn't so expensive because
				// the lists are very small.
	
				// if (local_lengths)
				// {
				// 	local_lengths = merge_arrays(local_lengths, mobile_type.possibleLengthsLocal())
				// }
				// else
				// {
				// 	local_lengths = mobile_type.possibleLengthsLocal()
				// }
			}
		}
		// If the type doesn't exist then return 'INVALID_LENGTH'.
		else if (type && !type_info) {
				return 'INVALID_LENGTH';
			}
	
		var actual_length = national_number.length;
	
		// // This is safe because there is never an overlap beween the possible lengths
		// // and the local-only lengths; this is checked at build time.
		// if (local_lengths && local_lengths.indexOf(national_number.length) >= 0)
		// {
		// 	return 'IS_POSSIBLE_LOCAL_ONLY'
		// }
	
		var minimum_length = possible_lengths[0];
	
		if (minimum_length === actual_length) {
			return 'IS_POSSIBLE';
		}
	
		if (minimum_length > actual_length) {
			return 'TOO_SHORT';
		}
	
		if (possible_lengths[possible_lengths.length - 1] < actual_length) {
			return 'TOO_LONG';
		}
	
		// We skip the first element since we've already checked it.
		return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
	}
	
	// Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	/* istanbul ignore next */
	var is_object = function is_object(_) {
		return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
	};
	
	function merge_arrays(a, b) {
		var merged = a.slice();
	
		for (var _iterator2 = b, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
			var _ref2;
	
			if (_isArray2) {
				if (_i2 >= _iterator2.length) break;
				_ref2 = _iterator2[_i2++];
			} else {
				_i2 = _iterator2.next();
				if (_i2.done) break;
				_ref2 = _i2.value;
			}
	
			var element = _ref2;
	
			if (a.indexOf(element) < 0) {
				merged.push(element);
			}
		}
	
		return merged.sort(function (a, b) {
			return a - b;
		});
	
		// ES6 version, requires Set polyfill.
		// let merged = new Set(a)
		// for (const element of b)
		// {
		// 	merged.add(i)
		// }
		// return Array.from(merged).sort((a, b) => a - b)
	}
	//# sourceMappingURL=types.js.map

/***/ },
/* 307 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 308 */
[3452, 2398, 2399, 2400, 2401, 2402],
/* 309 */
[3464, 317],
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(982),
	    createBaseEach = __webpack_require__(2375);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(155);
	
	/**
	 * The base implementation of methods like `_.max` and `_.min` which accepts a
	 * `comparator` to determine the extremum value.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The iteratee invoked per iteration.
	 * @param {Function} comparator The comparator used to compare values.
	 * @returns {*} Returns the extremum value.
	 */
	function baseExtremum(array, iteratee, comparator) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index],
	        current = iteratee(value);
	
	    if (current != null && (computed === undefined
	          ? (current === current && !isSymbol(current))
	          : comparator(current, computed)
	        )) {
	      var computed = current,
	          result = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseExtremum;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(980),
	    isFlattenable = __webpack_require__(2394);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 314 */
[3492, 2395],
/* 315 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 316 */
[3518, 152],
/* 317 */
263,
/* 318 */
[3528, 2350, 112],
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var isNumber = __webpack_require__(462);
	
	/**
	 * Checks if `value` is `NaN`.
	 *
	 * **Note:** This method is based on
	 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	 * `undefined` and other non-number values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 * @example
	 *
	 * _.isNaN(NaN);
	 * // => true
	 *
	 * _.isNaN(new Number(NaN));
	 * // => true
	 *
	 * isNaN(undefined);
	 * // => true
	 *
	 * _.isNaN(undefined);
	 * // => false
	 */
	function isNaN(value) {
	  // An `NaN` primitive is the only value that is not equal to itself.
	  // Perform the `toStringTag` check first to avoid errors with some
	  // ActiveX objects in IE.
	  return isNumber(value) && value != +value;
	}
	
	module.exports = isNaN;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
	 * @license MIT */
	
	;(function(root, factory) {
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory();
	  } else {
	    root.NProgress = factory();
	  }
	
	})(this, function() {
	  var NProgress = {};
	
	  NProgress.version = '0.2.0';
	
	  var Settings = NProgress.settings = {
	    minimum: 0.08,
	    easing: 'ease',
	    positionUsing: '',
	    speed: 200,
	    trickle: true,
	    trickleRate: 0.02,
	    trickleSpeed: 800,
	    showSpinner: true,
	    barSelector: '[role="bar"]',
	    spinnerSelector: '[role="spinner"]',
	    parent: 'body',
	    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
	  };
	
	  /**
	   * Updates configuration.
	   *
	   *     NProgress.configure({
	   *       minimum: 0.1
	   *     });
	   */
	  NProgress.configure = function(options) {
	    var key, value;
	    for (key in options) {
	      value = options[key];
	      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
	    }
	
	    return this;
	  };
	
	  /**
	   * Last number.
	   */
	
	  NProgress.status = null;
	
	  /**
	   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
	   *
	   *     NProgress.set(0.4);
	   *     NProgress.set(1.0);
	   */
	
	  NProgress.set = function(n) {
	    var started = NProgress.isStarted();
	
	    n = clamp(n, Settings.minimum, 1);
	    NProgress.status = (n === 1 ? null : n);
	
	    var progress = NProgress.render(!started),
	        bar      = progress.querySelector(Settings.barSelector),
	        speed    = Settings.speed,
	        ease     = Settings.easing;
	
	    progress.offsetWidth; /* Repaint */
	
	    queue(function(next) {
	      // Set positionUsing if it hasn't already been set
	      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();
	
	      // Add transition
	      css(bar, barPositionCSS(n, speed, ease));
	
	      if (n === 1) {
	        // Fade out
	        css(progress, { 
	          transition: 'none', 
	          opacity: 1 
	        });
	        progress.offsetWidth; /* Repaint */
	
	        setTimeout(function() {
	          css(progress, { 
	            transition: 'all ' + speed + 'ms linear', 
	            opacity: 0 
	          });
	          setTimeout(function() {
	            NProgress.remove();
	            next();
	          }, speed);
	        }, speed);
	      } else {
	        setTimeout(next, speed);
	      }
	    });
	
	    return this;
	  };
	
	  NProgress.isStarted = function() {
	    return typeof NProgress.status === 'number';
	  };
	
	  /**
	   * Shows the progress bar.
	   * This is the same as setting the status to 0%, except that it doesn't go backwards.
	   *
	   *     NProgress.start();
	   *
	   */
	  NProgress.start = function() {
	    if (!NProgress.status) NProgress.set(0);
	
	    var work = function() {
	      setTimeout(function() {
	        if (!NProgress.status) return;
	        NProgress.trickle();
	        work();
	      }, Settings.trickleSpeed);
	    };
	
	    if (Settings.trickle) work();
	
	    return this;
	  };
	
	  /**
	   * Hides the progress bar.
	   * This is the *sort of* the same as setting the status to 100%, with the
	   * difference being `done()` makes some placebo effect of some realistic motion.
	   *
	   *     NProgress.done();
	   *
	   * If `true` is passed, it will show the progress bar even if its hidden.
	   *
	   *     NProgress.done(true);
	   */
	
	  NProgress.done = function(force) {
	    if (!force && !NProgress.status) return this;
	
	    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
	  };
	
	  /**
	   * Increments by a random amount.
	   */
	
	  NProgress.inc = function(amount) {
	    var n = NProgress.status;
	
	    if (!n) {
	      return NProgress.start();
	    } else {
	      if (typeof amount !== 'number') {
	        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
	      }
	
	      n = clamp(n + amount, 0, 0.994);
	      return NProgress.set(n);
	    }
	  };
	
	  NProgress.trickle = function() {
	    return NProgress.inc(Math.random() * Settings.trickleRate);
	  };
	
	  /**
	   * Waits for all supplied jQuery promises and
	   * increases the progress as the promises resolve.
	   *
	   * @param $promise jQUery Promise
	   */
	  (function() {
	    var initial = 0, current = 0;
	
	    NProgress.promise = function($promise) {
	      if (!$promise || $promise.state() === "resolved") {
	        return this;
	      }
	
	      if (current === 0) {
	        NProgress.start();
	      }
	
	      initial++;
	      current++;
	
	      $promise.always(function() {
	        current--;
	        if (current === 0) {
	            initial = 0;
	            NProgress.done();
	        } else {
	            NProgress.set((initial - current) / initial);
	        }
	      });
	
	      return this;
	    };
	
	  })();
	
	  /**
	   * (Internal) renders the progress bar markup based on the `template`
	   * setting.
	   */
	
	  NProgress.render = function(fromStart) {
	    if (NProgress.isRendered()) return document.getElementById('nprogress');
	
	    addClass(document.documentElement, 'nprogress-busy');
	    
	    var progress = document.createElement('div');
	    progress.id = 'nprogress';
	    progress.innerHTML = Settings.template;
	
	    var bar      = progress.querySelector(Settings.barSelector),
	        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
	        parent   = document.querySelector(Settings.parent),
	        spinner;
	    
	    css(bar, {
	      transition: 'all 0 linear',
	      transform: 'translate3d(' + perc + '%,0,0)'
	    });
	
	    if (!Settings.showSpinner) {
	      spinner = progress.querySelector(Settings.spinnerSelector);
	      spinner && removeElement(spinner);
	    }
	
	    if (parent != document.body) {
	      addClass(parent, 'nprogress-custom-parent');
	    }
	
	    parent.appendChild(progress);
	    return progress;
	  };
	
	  /**
	   * Removes the element. Opposite of render().
	   */
	
	  NProgress.remove = function() {
	    removeClass(document.documentElement, 'nprogress-busy');
	    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
	    var progress = document.getElementById('nprogress');
	    progress && removeElement(progress);
	  };
	
	  /**
	   * Checks if the progress bar is rendered.
	   */
	
	  NProgress.isRendered = function() {
	    return !!document.getElementById('nprogress');
	  };
	
	  /**
	   * Determine which positioning CSS rule to use.
	   */
	
	  NProgress.getPositioningCSS = function() {
	    // Sniff on document.body.style
	    var bodyStyle = document.body.style;
	
	    // Sniff prefixes
	    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
	                       ('MozTransform' in bodyStyle) ? 'Moz' :
	                       ('msTransform' in bodyStyle) ? 'ms' :
	                       ('OTransform' in bodyStyle) ? 'O' : '';
	
	    if (vendorPrefix + 'Perspective' in bodyStyle) {
	      // Modern browsers with 3D support, e.g. Webkit, IE10
	      return 'translate3d';
	    } else if (vendorPrefix + 'Transform' in bodyStyle) {
	      // Browsers without 3D support, e.g. IE9
	      return 'translate';
	    } else {
	      // Browsers without translate() support, e.g. IE7-8
	      return 'margin';
	    }
	  };
	
	  /**
	   * Helpers
	   */
	
	  function clamp(n, min, max) {
	    if (n < min) return min;
	    if (n > max) return max;
	    return n;
	  }
	
	  /**
	   * (Internal) converts a percentage (`0..1`) to a bar translateX
	   * percentage (`-100%..0%`).
	   */
	
	  function toBarPerc(n) {
	    return (-1 + n) * 100;
	  }
	
	
	  /**
	   * (Internal) returns the correct CSS for changing the bar's
	   * position given an n percentage, and speed and ease from Settings
	   */
	
	  function barPositionCSS(n, speed, ease) {
	    var barCSS;
	
	    if (Settings.positionUsing === 'translate3d') {
	      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
	    } else if (Settings.positionUsing === 'translate') {
	      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
	    } else {
	      barCSS = { 'margin-left': toBarPerc(n)+'%' };
	    }
	
	    barCSS.transition = 'all '+speed+'ms '+ease;
	
	    return barCSS;
	  }
	
	  /**
	   * (Internal) Queues a function to be executed.
	   */
	
	  var queue = (function() {
	    var pending = [];
	    
	    function next() {
	      var fn = pending.shift();
	      if (fn) {
	        fn(next);
	      }
	    }
	
	    return function(fn) {
	      pending.push(fn);
	      if (pending.length == 1) next();
	    };
	  })();
	
	  /**
	   * (Internal) Applies css properties to an element, similar to the jQuery 
	   * css method.
	   *
	   * While this helper does assist with vendor prefixed property names, it 
	   * does not perform any manipulation of values prior to setting styles.
	   */
	
	  var css = (function() {
	    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
	        cssProps    = {};
	
	    function camelCase(string) {
	      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
	        return letter.toUpperCase();
	      });
	    }
	
	    function getVendorProp(name) {
	      var style = document.body.style;
	      if (name in style) return name;
	
	      var i = cssPrefixes.length,
	          capName = name.charAt(0).toUpperCase() + name.slice(1),
	          vendorName;
	      while (i--) {
	        vendorName = cssPrefixes[i] + capName;
	        if (vendorName in style) return vendorName;
	      }
	
	      return name;
	    }
	
	    function getStyleProp(name) {
	      name = camelCase(name);
	      return cssProps[name] || (cssProps[name] = getVendorProp(name));
	    }
	
	    function applyCss(element, prop, value) {
	      prop = getStyleProp(prop);
	      element.style[prop] = value;
	    }
	
	    return function(element, properties) {
	      var args = arguments,
	          prop, 
	          value;
	
	      if (args.length == 2) {
	        for (prop in properties) {
	          value = properties[prop];
	          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
	        }
	      } else {
	        applyCss(element, args[1], args[2]);
	      }
	    }
	  })();
	
	  /**
	   * (Internal) Determines if an element or space separated list of class names contains a class name.
	   */
	
	  function hasClass(element, name) {
	    var list = typeof element == 'string' ? element : classList(element);
	    return list.indexOf(' ' + name + ' ') >= 0;
	  }
	
	  /**
	   * (Internal) Adds a class to an element.
	   */
	
	  function addClass(element, name) {
	    var oldList = classList(element),
	        newList = oldList + name;
	
	    if (hasClass(oldList, name)) return; 
	
	    // Trim the opening space.
	    element.className = newList.substring(1);
	  }
	
	  /**
	   * (Internal) Removes a class from an element.
	   */
	
	  function removeClass(element, name) {
	    var oldList = classList(element),
	        newList;
	
	    if (!hasClass(element, name)) return;
	
	    // Replace the class name.
	    newList = oldList.replace(' ' + name + ' ', ' ');
	
	    // Trim the opening and closing spaces.
	    element.className = newList.substring(1, newList.length - 1);
	  }
	
	  /**
	   * (Internal) Gets a space separated list of the class names on the element. 
	   * The list is wrapped with a single space on each end to facilitate finding 
	   * matches within the list.
	   */
	
	  function classList(element) {
	    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
	  }
	
	  /**
	   * (Internal) Removes an element from the DOM.
	   */
	
	  function removeElement(element) {
	    element && element.parentNode && element.parentNode.removeChild(element);
	  }
	
	  return NProgress;
	});
	


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = all;
	
	var _createChainableTypeChecker = __webpack_require__(325);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function all() {
	  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
	    validators[_key] = arguments[_key];
	  }
	
	  function allPropTypes() {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    var error = null;
	
	    validators.forEach(function (validator) {
	      if (error != null) {
	        return;
	      }
	
	      var result = validator.apply(undefined, args);
	      if (result != null) {
	        error = result;
	      }
	    });
	
	    return error;
	  }
	
	  return (0, _createChainableTypeChecker2.default)(allPropTypes);
	}
	module.exports = exports['default'];

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createChainableTypeChecker = __webpack_require__(325);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validate(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);
	
	  if (_react2.default.isValidElement(propValue)) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
	  }
	
	  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
	    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
	  }
	
	  return null;
	}
	
	exports.default = (0, _createChainableTypeChecker2.default)(validate);
	module.exports = exports['default'];

/***/ },
/* 324 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRequiredForA11y;
	function isRequiredForA11y(validator) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 325 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainableTypeChecker;
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	// Mostly taken from ReactPropTypes.
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] == null) {
	      if (isRequired) {
	        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
	      }
	
	      return null;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	      args[_key - 6] = arguments[_key];
	    }
	
	    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	module.exports = exports['default'];

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _en_US = __webpack_require__(1156);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	exports['default'] = {
	  propTypes: {
	    className: _propTypes2['default'].string,
	    locale: _propTypes2['default'].object,
	    style: _propTypes2['default'].object,
	    visible: _propTypes2['default'].bool,
	    onSelect: _propTypes2['default'].func,
	    prefixCls: _propTypes2['default'].string,
	    onChange: _propTypes2['default'].func,
	    onOk: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      locale: _en_US2['default'],
	      style: {},
	      visible: true,
	      prefixCls: 'rc-calendar',
	      className: '',
	      onSelect: noop,
	      onChange: noop,
	      onClear: noop,
	      renderFooter: function renderFooter() {
	        return null;
	      },
	      renderSidebar: function renderSidebar() {
	        return null;
	      }
	    };
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return this.props.visible || nextProps.visible;
	  },
	  getFormat: function getFormat() {
	    var format = this.props.format;
	    var _props = this.props,
	        locale = _props.locale,
	        timePicker = _props.timePicker;
	
	    if (!format) {
	      if (timePicker) {
	        format = locale.dateTimeFormat;
	      } else {
	        format = locale.dateFormat;
	      }
	    }
	    return format;
	  },
	  focus: function focus() {
	    if (this.rootInstance) {
	      this.rootInstance.focus();
	    }
	  },
	  saveRoot: function saveRoot(root) {
	    this.rootInstance = root;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.noop = noop;
	exports.getKeyFromChildrenIndex = getKeyFromChildrenIndex;
	exports.loopMenuItem = loopMenuItem;
	exports.loopMenuItemRecusively = loopMenuItemRecusively;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getKeyFromChildrenIndex(child, menuEventKey, index) {
	  var prefix = menuEventKey || '';
	  return child.key || prefix + 'item_' + index;
	}
	
	function loopMenuItem(children, cb) {
	  var index = -1;
	  _react2['default'].Children.forEach(children, function (c) {
	    index++;
	    if (c && c.type && c.type.isMenuItemGroup) {
	      _react2['default'].Children.forEach(c.props.children, function (c2) {
	        index++;
	        cb(c2, index);
	      });
	    } else {
	      cb(c, index);
	    }
	  });
	}
	
	function loopMenuItemRecusively(children, keys, ret) {
	  if (!children || ret.find) {
	    return;
	  }
	  _react2['default'].Children.forEach(children, function (c) {
	    if (ret.find) {
	      return;
	    }
	    if (c) {
	      var construt = c.type;
	      if (!construt || !(construt.isSubMenu || construt.isMenuItem || construt.isMenuItemGroup)) {
	        return;
	      }
	      if (keys.indexOf(c.key) !== -1) {
	        ret.find = true;
	      } else if (c.props.children) {
	        loopMenuItemRecusively(c.props.children, keys, ret);
	      }
	    }
	  });
	}

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Handle = function (_React$Component) {
	  (0, _inherits3['default'])(Handle, _React$Component);
	
	  function Handle() {
	    (0, _classCallCheck3['default'])(this, Handle);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Handle.prototype.focus = function focus() {
	    this.handle.focus();
	  };
	
	  Handle.prototype.blur = function blur() {
	    this.handle.blur();
	  };
	
	  Handle.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        vertical = _props.vertical,
	        offset = _props.offset,
	        style = _props.style,
	        disabled = _props.disabled,
	        min = _props.min,
	        max = _props.max,
	        value = _props.value,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value']);
	
	
	    var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
	    var elStyle = (0, _extends3['default'])({}, style, postionStyle);
	    var ariaProps = {};
	    if (value !== undefined) {
	      ariaProps = (0, _extends3['default'])({}, ariaProps, {
	        'aria-valuemin': min,
	        'aria-valuemax': max,
	        'aria-valuenow': value,
	        'aria-disabled': !!disabled
	      });
	    }
	    return _react2['default'].createElement('div', (0, _extends3['default'])({
	      ref: function ref(node) {
	        return _this2.handle = node;
	      },
	      role: 'slider',
	      tabIndex: '0'
	    }, ariaProps, restProps, {
	      className: className,
	      style: elStyle
	    }));
	  };
	
	  return Handle;
	}(_react2['default'].Component);
	
	exports['default'] = Handle;
	
	
	Handle.propTypes = {
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  offset: _propTypes2['default'].number,
	  style: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  value: _propTypes2['default'].number
	};
	module.exports = exports['default'];

/***/ },
/* 329 */
[3338, 156],
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toArray;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArray(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (c) {
	    ret.push(c);
	  });
	  return ret;
	}
	module.exports = exports['default'];

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _activeElement = __webpack_require__(903);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(183);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _keycode = __webpack_require__(446);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(322);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _isRequiredForA11y = __webpack_require__(324);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(267);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ButtonGroup = __webpack_require__(484);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _DropdownMenu = __webpack_require__(2660);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _DropdownToggle = __webpack_require__(1201);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _PropTypes = __webpack_require__(2708);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOGGLE_ROLE = _DropdownToggle2.default.defaultProps.bsRole;
	var MENU_ROLE = _DropdownMenu2.default.defaultProps.bsRole;
	
	var propTypes = {
	  /**
	   * The menu will open above the dropdown button, instead of below it.
	   */
	  dropup: _propTypes2.default.bool,
	
	  /**
	   * An html id attribute, necessary for assistive technologies, such as screen readers.
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  componentClass: _elementType2.default,
	
	  /**
	   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
	   * @type {node}
	   */
	  children: (0, _all2.default)((0, _PropTypes.requiredRoles)(TOGGLE_ROLE, MENU_ROLE), (0, _PropTypes.exclusiveRoles)(MENU_ROLE)),
	
	  /**
	   * Whether or not component is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Align the menu to the right side of the Dropdown toggle
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Whether or not the Dropdown is visible.
	   *
	   * @controllable onToggle
	   */
	  open: _propTypes2.default.bool,
	
	  defaultOpen: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
	   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
	   *
	   * ```js
	   * function(Boolean isOpen, Object event, { String source }) {}
	   * ```
	   * @controllable open
	   */
	  onToggle: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
	   * a menu button.
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Which event when fired outside the component will cause it to be closed
	   */
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown']),
	
	  /**
	   * @private
	   */
	  onMouseEnter: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseLeave: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _ButtonGroup2.default
	};
	
	var Dropdown = function (_React$Component) {
	  (0, _inherits3.default)(Dropdown, _React$Component);
	
	  function Dropdown(props, context) {
	    (0, _classCallCheck3.default)(this, Dropdown);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	
	    _this._focusInDropdown = false;
	    _this.lastOpenEventType = null;
	    return _this;
	  }
	
	  Dropdown.prototype.componentDidMount = function componentDidMount() {
	    this.focusNextOnOpen();
	  };
	
	  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!nextProps.open && this.props.open) {
	      this._focusInDropdown = (0, _contains2.default)(_reactDom2.default.findDOMNode(this.menu), (0, _activeElement2.default)(document));
	    }
	  };
	
	  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var open = this.props.open;
	
	    var prevOpen = prevProps.open;
	
	    if (open && !prevOpen) {
	      this.focusNextOnOpen();
	    }
	
	    if (!open && prevOpen) {
	      // if focus hasn't already moved from the menu let's return it
	      // to the toggle
	      if (this._focusInDropdown) {
	        this._focusInDropdown = false;
	        this.focus();
	      }
	    }
	  };
	
	  Dropdown.prototype.focus = function focus() {
	    var toggle = _reactDom2.default.findDOMNode(this.toggle);
	
	    if (toggle && toggle.focus) {
	      toggle.focus();
	    }
	  };
	
	  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
	    var menu = this.menu;
	
	    if (!menu.focusNext) {
	      return;
	    }
	
	    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
	      menu.focusNext();
	    }
	  };
	
	  Dropdown.prototype.handleClick = function handleClick(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    this.toggleOpen(event, { source: 'click' });
	  };
	
	  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
	    if (!this.props.open) {
	      return;
	    }
	
	    this.toggleOpen(event, eventDetails);
	  };
	
	  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
	    if (this.props.disabled) {
	      return;
	    }
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        if (!this.props.open) {
	          this.toggleOpen(event, { source: 'keydown' });
	        } else if (this.menu.focusNext) {
	          this.menu.focusNext();
	        }
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.handleClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
	    var open = !this.props.open;
	
	    if (open) {
	      this.lastOpenEventType = eventDetails.source;
	    }
	
	    if (this.props.onToggle) {
	      this.props.onToggle(open, event, eventDetails);
	    }
	  };
	
	  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
	    var _this2 = this;
	
	    var id = _ref.id,
	        onSelect = _ref.onSelect,
	        rootCloseEvent = _ref.rootCloseEvent,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['id', 'onSelect', 'rootCloseEvent']);
	
	    var ref = function ref(c) {
	      _this2.menu = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      labelledBy: id,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'menu'),
	      onClose: (0, _createChainedFunction2.default)(child.props.onClose, this.handleClose),
	      onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, function (key, event) {
	        return _this2.handleClose(event, { source: 'select' });
	      }),
	      rootCloseEvent: rootCloseEvent
	    }));
	  };
	
	  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
	    var _this3 = this;
	
	    var ref = function ref(c) {
	      _this3.toggle = c;
	    };
	
	    if (typeof child.ref === 'string') {
	       false ? (0, _warning2.default)(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
	    } else {
	      ref = (0, _createChainedFunction2.default)(child.ref, ref);
	    }
	
	    return (0, _react.cloneElement)(child, (0, _extends3.default)({}, props, {
	      ref: ref,
	      bsClass: (0, _bootstrapUtils.prefix)(props, 'toggle'),
	      onClick: (0, _createChainedFunction2.default)(child.props.onClick, this.handleClick),
	      onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, this.handleKeyDown)
	    }));
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _classes,
	        _this4 = this;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        id = _props.id,
	        dropup = _props.dropup,
	        disabled = _props.disabled,
	        pullRight = _props.pullRight,
	        open = _props.open,
	        onSelect = _props.onSelect,
	        role = _props.role,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);
	
	
	    delete props.onToggle;
	
	    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);
	
	    if (dropup) {
	      classes[bsClass] = false;
	      classes.dropup = true;
	    }
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        switch (child.props.bsRole) {
	          case TOGGLE_ROLE:
	            return _this4.renderToggle(child, {
	              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
	            });
	          case MENU_ROLE:
	            return _this4.renderMenu(child, {
	              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
	            });
	          default:
	            return child;
	        }
	      })
	    );
	  };
	
	  return Dropdown;
	}(_react2.default.Component);
	
	Dropdown.propTypes = propTypes;
	Dropdown.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('dropdown', Dropdown);
	
	var UncontrolledDropdown = (0, _uncontrollable2.default)(Dropdown, { open: 'onToggle' });
	
	UncontrolledDropdown.Toggle = _DropdownToggle2.default;
	UncontrolledDropdown.Menu = _DropdownMenu2.default;
	
	exports.default = UncontrolledDropdown;
	module.exports = exports['default'];

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(1248);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Show the component; triggers the fade in or fade out animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is faded out
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the fade in animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the fade animation in milliseconds, to ensure that finishing
	   * callbacks are fired even if the original browser transition end events are
	   * canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component fades in
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade in
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the has component faded in
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component fades out
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to fade out
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has faded out
	   */
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false
	};
	
	var Fade = function (_React$Component) {
	  (0, _inherits3.default)(Fade, _React$Component);
	
	  function Fade() {
	    (0, _classCallCheck3.default)(this, Fade);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Fade.prototype.render = function render() {
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, this.props, {
	      className: (0, _classnames2.default)(this.props.className, 'fade'),
	      enteredClassName: 'in',
	      enteringClassName: 'in'
	    }));
	  };
	
	  return Fade;
	}(_react2.default.Component);
	
	Fade.propTypes = propTypes;
	Fade.defaultProps = defaultProps;
	
	exports.default = Fade;
	module.exports = exports['default'];

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _MediaBody = __webpack_require__(2674);
	
	var _MediaBody2 = _interopRequireDefault(_MediaBody);
	
	var _MediaHeading = __webpack_require__(2675);
	
	var _MediaHeading2 = _interopRequireDefault(_MediaHeading);
	
	var _MediaLeft = __webpack_require__(2676);
	
	var _MediaLeft2 = _interopRequireDefault(_MediaLeft);
	
	var _MediaList = __webpack_require__(2677);
	
	var _MediaList2 = _interopRequireDefault(_MediaList);
	
	var _MediaListItem = __webpack_require__(2678);
	
	var _MediaListItem2 = _interopRequireDefault(_MediaListItem);
	
	var _MediaRight = __webpack_require__(2679);
	
	var _MediaRight2 = _interopRequireDefault(_MediaRight);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Media = function (_React$Component) {
	  (0, _inherits3.default)(Media, _React$Component);
	
	  function Media() {
	    (0, _classCallCheck3.default)(this, Media);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Media.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Media;
	}(_react2.default.Component);
	
	Media.propTypes = propTypes;
	Media.defaultProps = defaultProps;
	
	Media.Heading = _MediaHeading2.default;
	Media.Body = _MediaBody2.default;
	Media.Left = _MediaLeft2.default;
	Media.Right = _MediaRight2.default;
	Media.List = _MediaList2.default;
	Media.ListItem = _MediaListItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', Media);
	module.exports = exports['default'];

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _entries = __webpack_require__(756);
	
	var _entries2 = _interopRequireDefault(_entries);
	
	exports.default = splitComponentProps;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function splitComponentProps(props, Component) {
	  var componentPropTypes = Component.propTypes;
	
	  var parentProps = {};
	  var childProps = {};
	
	  (0, _entries2.default)(props).forEach(function (_ref) {
	    var propName = _ref[0],
	        propValue = _ref[1];
	
	    if (componentPropTypes[propName]) {
	      parentProps[propName] = propValue;
	    } else {
	      childProps[propName] = propValue;
	    }
	  });
	
	  return [parentProps, childProps];
	}
	module.exports = exports["default"];

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _consolidatedEvents = __webpack_require__(289);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { forbidExtraProps } from 'airbnb-prop-types'; // TODO: add to propTypes; semver-major
	
	
	var propTypes = {
	  children: _propTypes2['default'].node,
	  onOutsideClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  children: _react2['default'].createElement('span', null),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }()
	};
	
	var OutsideClickHandler = function (_React$Component) {
	  _inherits(OutsideClickHandler, _React$Component);
	
	  function OutsideClickHandler() {
	    var _ref;
	
	    _classCallCheck(this, OutsideClickHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));
	
	    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(OutsideClickHandler, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        // `capture` flag is set to true so that a `stopPropagation` in the children
	        // will not prevent all outside click handlers from firing - maja
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(document, 'click', this.onOutsideClick, { capture: true });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) {
	          this.removeEventListener();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onOutsideClick',
	    value: function () {
	      function onOutsideClick(e) {
	        var onOutsideClick = this.props.onOutsideClick;
	        var childNode = this.childNode;
	
	        var isDescendantOfRoot = childNode && childNode.contains(e.target);
	        if (!isDescendantOfRoot) {
	          onOutsideClick(e);
	        }
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: 'setChildNodeRef',
	    value: function () {
	      function setChildNodeRef(ref) {
	        this.childNode = ref;
	      }
	
	      return setChildNodeRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        return _react2['default'].createElement(
	          'div',
	          { ref: this.setChildNodeRef },
	          this.props.children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return OutsideClickHandler;
	}(_react2['default'].Component);
	
	exports['default'] = OutsideClickHandler;
	
	
	OutsideClickHandler.propTypes = propTypes;
	OutsideClickHandler.defaultProps = defaultProps;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toISODateString;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(195);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toISODateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_FORMAT);
	}

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toISOMonthString;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(195);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toISOMonthString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_MONTH_FORMAT);
	}

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Copyright 2017, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(3332));
	var IntlMessageFormat = _interopDefault(__webpack_require__(955));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(2283));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var invariant = _interopDefault(__webpack_require__(29));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(2273));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      IntlMessageFormat.__addLocaleData(localeData);
	      IntlRelativeFormat.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	var oneOfType = PropTypes.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this.refs.wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? 'wrappedInstance' : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(React.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	
	  return InjectIntl;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 // months to year
	};
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = IntlRelativeFormat.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	}
	
	function getNamedFormat(formats, type, name) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  if (false) {
	    console.error('[React Intl] No ' + type + ' format named: ' + name);
	  }
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var date = new Date(value);
	  var defaults$$1 = format && getNamedFormat(formats, 'date', format);
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting date.\n' + e);
	    }
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var date = new Date(value);
	  var defaults$$1 = format && getNamedFormat(formats, 'time', format);
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting time.\n' + e);
	    }
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting relative time.\n' + e);
	    }
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting number.\n' + e);
	    }
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    if (false) {
	      console.error('[React Intl] Error formatting plural.\n' + e);
	    }
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // `id` is a required field of a Message Descriptor.
	
	  invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      if (false) {
	        console.error('[React Intl] Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '') + ('\n' + e));
	      }
	    }
	  } else {
	    if (false) {
	      // This prevents warnings from littering the console in development
	      // when no `messages` are passed into the <IntlProvider> for the
	      // default locale, and a default message is in the source.
	      if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	        console.error('[React Intl] Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''));
	      }
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      if (false) {
	        console.error('[React Intl] Error formatting the default message for: "' + id + '"' + ('\n' + e));
	      }
	    }
	  }
	
	  if (!formattedMessage) {
	    if (false) {
	      console.error('[React Intl] Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.'));
	    }
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {}
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	      getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	      getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	      getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	      getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats;
	
	
	        if (false) {
	          console.error('[React Intl] Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.'));
	        }
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: PropTypes.element.isRequired,
	  initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedDate
	      );
	    }
	  }]);
	  return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedTime
	      );
	    }
	  }]);
	  return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedRelative
	      );
	    }
	  }]);
	  return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  updateInterval: PropTypes.number,
	  initialNow: PropTypes.any,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedNumber
	      );
	    }
	  }]);
	  return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedPlural
	      );
	    }
	  }]);
	  return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	
	  other: PropTypes.node.isRequired,
	  zero: PropTypes.node,
	  one: PropTypes.node,
	  two: PropTypes.node,
	  few: PropTypes.node,
	  many: PropTypes.node,
	
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatMessage = _context$intl.formatMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if (React.isValidElement(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;


/***/ },
/* 339 */
/***/ function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getContainer;
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainer(container, defaultContainer) {
	  container = typeof container === 'function' ? container() : container;
	  return _reactDom2.default.findDOMNode(container) || defaultContainer;
	}
	module.exports = exports['default'];

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dispatchBatchIfNeeded = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _partition3 = __webpack_require__(2813);
	
	var _partition4 = _interopRequireDefault(_partition3);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _track = __webpack_require__(255);
	
	var _nullAction = __webpack_require__(343);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var batch = (0, _track.trackable)(function (model, actions) {
	  var dispatchableActions = actions.filter(function (action) {
	    return !!action;
	  });
	
	  if (!dispatchableActions.length) return _nullAction2.default;
	
	  if (dispatchableActions.length && dispatchableActions.every(_isPlainObject2.default)) {
	    if (dispatchableActions.length === 1) {
	      return dispatchableActions[0];
	    }
	
	    return {
	      type: _actionTypes2.default.BATCH,
	      model: model,
	      actions: dispatchableActions
	    };
	  }
	
	  var _partition = (0, _partition4.default)(dispatchableActions, function (action) {
	    return typeof action !== 'function';
	  }),
	      _partition2 = _slicedToArray(_partition, 2),
	      plainActions = _partition2[0],
	      actionThunks = _partition2[1];
	
	  if (!actionThunks.length) {
	    if (plainActions.length > 1) {
	      return {
	        type: _actionTypes2.default.BATCH,
	        model: model,
	        actions: plainActions
	      };
	    } else if (plainActions.length === 1) {
	      return plainActions[0];
	    }
	  }
	
	  return function (dispatch) {
	    if (plainActions.length > 1) {
	      dispatch({
	        type: _actionTypes2.default.BATCH,
	        model: model,
	        actions: plainActions
	      });
	    } else if (plainActions.length === 1) {
	      dispatch(plainActions[0]);
	    }
	    actionThunks.forEach(dispatch);
	  };
	});
	
	function dispatchBatchIfNeeded(model, actions, dispatch) {
	  if (!actions.length) return void 0;
	
	  var dispatchableActions = actions.filter(function (action) {
	    return !!action;
	  });
	
	  if (!dispatchableActions.length) return void 0;
	
	  return dispatch(batch(model, dispatchableActions));
	}
	
	exports.default = batch;
	exports.dispatchBatchIfNeeded = dispatchBatchIfNeeded;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isMulti = __webpack_require__(346);
	
	var _isMulti2 = _interopRequireDefault(_isMulti);
	
	var _iteratee = __webpack_require__(510);
	
	var _actions = __webpack_require__(198);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getTextValue(value) {
	  if (typeof value === 'string') {
	    return '' + value;
	  }
	
	  return value;
	}
	
	function isChecked(props) {
	  if ((0, _isMulti2.default)(props.model)) {
	    if (!props.modelValue) return false;
	
	    return props.modelValue.some(function (item) {
	      return item === props.value;
	    });
	  }
	  if (typeof props.modelValue === 'undefined') {
	    if (typeof props.defaultChecked !== 'undefined') {
	      return props.defaultChecked;
	    }
	  }
	
	  return !!props.modelValue;
	}
	
	var standardPropsMap = {
	  name: function name(props) {
	    return props.name || props.model;
	  },
	  disabled: function disabled(_ref) {
	    var fieldValue = _ref.fieldValue,
	        _disabled = _ref.disabled;
	    return (0, _iteratee.iterateeValue)(fieldValue, _disabled);
	  },
	  onChange: function onChange(_ref2) {
	    var _onChange = _ref2.onChange;
	    return _onChange;
	  },
	  onBlur: function onBlur(_ref3) {
	    var _onBlur = _ref3.onBlur;
	    return _onBlur;
	  },
	  onFocus: function onFocus(_ref4) {
	    var _onFocus = _ref4.onFocus;
	    return _onFocus;
	  },
	  onKeyPress: function onKeyPress(_ref5) {
	    var _onKeyPress = _ref5.onKeyPress;
	    return _onKeyPress;
	  }
	};
	
	var textPropsMap = _extends({}, standardPropsMap, {
	  // the value passed into the control is either the original control's
	  // value prop (if the control is controlled) or the value controlled by
	  // <Control>.
	  value: function value(props) {
	    if (props.hasOwnProperty('value')) {
	      return props.value;
	    }
	
	    var value = getTextValue(props.viewValue);
	
	    return value === undefined ? '' : value;
	  }
	});
	
	var getModelValue = function getModelValue(_ref6) {
	  var modelValue = _ref6.modelValue;
	  return modelValue;
	};
	var getViewValue = function getViewValue(props) {
	  return props.hasOwnProperty('value') ? props.value : props.viewValue;
	};
	
	var controlPropsMap = {
	  default: _extends({}, standardPropsMap, {
	    value: getViewValue
	  }),
	  checkbox: _extends({}, standardPropsMap, {
	    checked: isChecked
	  }),
	  radio: _extends({}, standardPropsMap, {
	    checked: function checked(props) {
	      return props.defaultChecked ? props.checked : props.modelValue === props.value;
	    },
	    value: function value(props) {
	      return props.value;
	    }
	  }),
	  select: _extends({}, standardPropsMap, {
	    value: getViewValue
	  }),
	  text: textPropsMap,
	  textarea: textPropsMap,
	  file: standardPropsMap,
	  button: _extends({}, standardPropsMap, {
	    value: getModelValue
	  }),
	  reset: _extends({}, standardPropsMap, {
	    onClick: function onClick(props) {
	      return function (event) {
	        event.preventDefault();
	        props.dispatch(_actions2.default.reset(props.model));
	      };
	    }
	  })
	};
	
	exports.default = controlPropsMap;

/***/ },
/* 343 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var NULL_ACTION = { type: null };
	
	exports.default = NULL_ACTION;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createModeler = undefined;
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _arraysEqual = __webpack_require__(1264);
	
	var _arraysEqual2 = _interopRequireDefault(_arraysEqual);
	
	var _toPath = __webpack_require__(254);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _batchedEnhancer = __webpack_require__(503);
	
	var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function icepickSet(state, path, value) {
	  return _icepick2.default.setIn(state, path, value);
	}
	
	var defaultStrategy = {
	  get: _get3.default,
	  set: icepickSet,
	  object: {}
	};
	
	function createModeler() {
	  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	  var getter = strategy.get,
	      setter = strategy.set,
	      object = strategy.object;
	
	
	  return function _createModelReducer(model) {
	    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object;
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var modelPath = (0, _toPath2.default)(model);
	
	    var modelReducer = function modelReducer() {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	      var action = arguments[1];
	
	      if (!action.model) {
	        return state;
	      }
	
	      var path = (0, _toPath2.default)(action.model);
	
	      if (!(0, _arraysEqual2.default)(path.slice(0, modelPath.length), modelPath)) {
	        return state;
	      }
	
	      var localPath = path.slice(modelPath.length);
	
	      switch (action.type) {
	        case _actionTypes2.default.CHANGE:
	          if (!localPath.length) {
	            return action.value;
	          }
	
	          if (getter(state, localPath) === action.value) {
	            return state;
	          }
	
	          return setter(state, localPath, action.value);
	
	        case _actionTypes2.default.RESET:
	          if (!localPath.length) {
	            return initialState;
	          }
	
	          if (getter(state, localPath) === getter(initialState, localPath)) {
	            return state;
	          }
	
	          return setter(state, localPath, getter(initialState, localPath));
	
	        default:
	          return state;
	      }
	    };
	
	    return (0, _batchedEnhancer2.default)(modelReducer, initialState, options);
	  };
	}
	
	var modelReducer = createModeler();
	
	exports.createModeler = createModeler;
	exports.default = modelReducer;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fieldOrForm = fieldOrForm;
	exports.getMeta = getMeta;
	exports.updateFieldState = updateFieldState;
	exports.default = createFieldState;
	exports.createFormState = createFormState;
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint-disable no-use-before-define */
	function fieldOrForm(model, value, customInitialFieldState) {
	  // TODO: create toModel()
	  var stringModel = Array.isArray(model) ? model.join('.') : model;
	
	  if (Array.isArray(value) || (0, _isPlainObject2.default)(value)) {
	    return createFormState(stringModel, value, customInitialFieldState);
	  }
	
	  return createFieldState(stringModel, value, customInitialFieldState);
	}
	/* eslint-enable no-use-before-define */
	
	function getMeta(fieldLike, prop) {
	  if (fieldLike && fieldLike.$form) return fieldLike.$form[prop];
	
	  return fieldLike[prop];
	}
	
	function getSubModelString(model, subModel) {
	  if (!model) return subModel;
	
	  return model + '.' + subModel;
	}
	
	function updateFieldState(existingFieldState, updatedFieldState) {
	  var newField = _extends({}, existingFieldState, updatedFieldState);
	
	  return newField;
	}
	
	function createFieldState(model, value, customInitialFieldState) {
	  return _extends({
	    initialValue: value
	  }, _initialFieldState2.default, customInitialFieldState, {
	    model: model,
	    value: value
	  });
	}
	
	function createFormState(model, values, customInitialFieldState) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  return _extends({
	    $form: createFieldState(model, values, customInitialFieldState, options)
	  }, options.lazy ? undefined : (0, _mapValues2.default)(values, function (value, key) {
	    var subModel = getSubModelString(model, key);
	
	    return fieldOrForm(subModel, value, customInitialFieldState);
	  }));
	}

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMulti;
	
	var _endsWith = __webpack_require__(506);
	
	var _endsWith2 = _interopRequireDefault(_endsWith);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isMulti(model) {
	  return (0, _endsWith2.default)(model, '[]');
	}

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = wrapWithModelResolver;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function resolveModel(model, parentModel) {
	  if (parentModel) {
	    if (model[0] === '.' || model[0] === '[') {
	      return '' + parentModel + model;
	    }
	
	    if (typeof model === 'function') {
	      return function (state) {
	        return model(state, parentModel);
	      };
	    }
	  }
	
	  return model;
	}
	
	function wrapWithModelResolver(WrappedComponent) {
	  var ResolvedModelWrapper = function (_PureComponent) {
	    _inherits(ResolvedModelWrapper, _PureComponent);
	
	    function ResolvedModelWrapper() {
	      _classCallCheck(this, ResolvedModelWrapper);
	
	      return _possibleConstructorReturn(this, (ResolvedModelWrapper.__proto__ || Object.getPrototypeOf(ResolvedModelWrapper)).apply(this, arguments));
	    }
	
	    _createClass(ResolvedModelWrapper, [{
	      key: 'render',
	      value: function render() {
	        var _context = this.context,
	            parentModel = _context.model,
	            localStore = _context.localStore;
	
	        var resolvedModel = resolveModel(this.props.model, parentModel);
	
	        return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	          model: resolvedModel,
	          store: localStore || undefined
	        }));
	      }
	    }]);
	
	    return ResolvedModelWrapper;
	  }(_react.PureComponent);
	
	  ResolvedModelWrapper.displayName = 'Modeled(' + WrappedComponent.displayName + ')';
	
	   false ? ResolvedModelWrapper.propTypes = {
	    model: _propTypes2.default.any
	  } : void 0;
	
	  ResolvedModelWrapper.contextTypes = {
	    model: _propTypes2.default.any,
	    localStore: _propTypes2.default.shape({
	      subscribe: _propTypes2.default.func,
	      dispatch: _propTypes2.default.func,
	      getState: _propTypes2.default.func
	    })
	  };
	
	  return ResolvedModelWrapper;
	}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(2852);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /*!
	                                                                                                                                                                                                                                                                                Copyright (c) 2018 Jed Watson.
	                                                                                                                                                                                                                                                                                Licensed under the MIT License (MIT), see
	                                                                                                                                                                                                                                                                                http://jedwatson.github.io/react-select
	                                                                                                                                                                                                                                                                              */
	
	
	var _reactInputAutosize = __webpack_require__(2740);
	
	var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _defaultArrowRenderer = __webpack_require__(1294);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(1295);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(515);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(516);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Option = __webpack_require__(1292);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _Value = __webpack_require__(1293);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var stringifyValue = function stringifyValue(value) {
		return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
	};
	
	var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);
	var stringOrNumber = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var instanceId = 1;
	
	var shouldShowValue = function shouldShowValue(state, props) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		if (!inputValue) return true;
	
		if (!onSelectResetsInput) {
			return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
		}
	
		return false;
	};
	
	var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
		var inputValue = state.inputValue,
		    isPseudoFocused = state.isPseudoFocused,
		    isFocused = state.isFocused;
		var onSelectResetsInput = props.onSelectResetsInput;
	
	
		return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
	};
	
	/**
	 * Retrieve a value from the given options and valueKey
	 * @param {String|Number|Array} value	- the selected value(s)
	 * @param {Object}		 props	- the Select component's props (or nextProps)
	 */
	var expandValue = function expandValue(value, props) {
		var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options,
		    valueKey = props.valueKey;
	
		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (String(options[i][valueKey]) === String(value)) return options[i];
		}
	};
	
	var handleRequired = function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	};
	
	var Select = function (_React$Component) {
		_inherits(Select, _React$Component);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
				return _this[fn] = _this[fn].bind(_this);
			});
	
			_this.state = {
				inputValue: '',
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false,
				required: false
			};
			return _this;
		}
	
		_createClass(Select, [{
			key: 'componentWillMount',
			value: function componentWillMount() {
				this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
				var valueArray = this.getValueArray(this.props.value);
	
				if (this.props.required) {
					this.setState({
						required: handleRequired(valueArray[0], this.props.multi)
					});
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
					console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
				}
				if (this.props.autoFocus || this.props.autofocus) {
					this.focus();
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var valueArray = this.getValueArray(nextProps.value, nextProps);
	
				if (nextProps.required) {
					this.setState({
						required: handleRequired(valueArray[0], nextProps.multi)
					});
				} else if (this.props.required) {
					// Used to be required but it's not any more
					this.setState({ required: false });
				}
	
				if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
					this.setState({ inputValue: this.handleInputValueChange('') });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				// focus to the selected option
				if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
					var focusedOptionNode = (0, _reactDom.findDOMNode)(this.focused);
					var menuNode = (0, _reactDom.findDOMNode)(this.menu);
	
					var scrollTop = menuNode.scrollTop;
					var scrollBottom = scrollTop + menuNode.offsetHeight;
					var optionTop = focusedOptionNode.offsetTop;
					var optionBottom = optionTop + focusedOptionNode.offsetHeight;
	
					if (scrollTop > optionTop || scrollBottom < optionBottom) {
						menuNode.scrollTop = focusedOptionNode.offsetTop;
					}
	
					// We still set hasScrolledToOption to true even if we didn't
					// actually need to scroll, as we've still confirmed that the
					// option is in view.
					this.hasScrolledToOption = true;
				} else if (!this.state.isOpen) {
					this.hasScrolledToOption = false;
				}
	
				if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
					this._scrollToFocusedOptionOnUpdate = false;
					var focusedDOM = (0, _reactDom.findDOMNode)(this.focused);
					var menuDOM = (0, _reactDom.findDOMNode)(this.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
					if (focusedRect.bottom > menuRect.bottom) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					} else if (focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop;
					}
				}
				if (this.props.scrollMenuIntoView && this.menuContainer) {
					var menuContainerRect = this.menuContainer.getBoundingClientRect();
					if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
						window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
					}
				}
				if (prevProps.disabled !== this.props.disabled) {
					this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
					this.closeMenu();
				}
				if (prevState.isOpen !== this.state.isOpen) {
					this.toggleTouchOutsideEvent(this.state.isOpen);
					var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
					handler && handler();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.toggleTouchOutsideEvent(false);
			}
		}, {
			key: 'toggleTouchOutsideEvent',
			value: function toggleTouchOutsideEvent(enabled) {
				if (enabled) {
					if (!document.addEventListener && document.attachEvent) {
						document.attachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.addEventListener('touchstart', this.handleTouchOutside);
					}
				} else {
					if (!document.removeEventListener && document.detachEvent) {
						document.detachEvent('ontouchstart', this.handleTouchOutside);
					} else {
						document.removeEventListener('touchstart', this.handleTouchOutside);
					}
				}
			}
		}, {
			key: 'handleTouchOutside',
			value: function handleTouchOutside(event) {
				// handle touch outside on ios to dismiss menu
				if (this.wrapper && !this.wrapper.contains(event.target)) {
					this.closeMenu();
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (!this.input) return;
				this.input.focus();
			}
		}, {
			key: 'blurInput',
			value: function blurInput() {
				if (!this.input) return;
				this.input.blur();
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchEndClearValue',
			value: function handleTouchEndClearValue(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Clear the value
				this.clearValue(event);
			}
		}, {
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (event.target.tagName === 'INPUT') {
					if (!this.state.isFocused) {
						this._openAfterFocus = this.props.openOnClick;
						this.focus();
					} else if (!this.state.isOpen) {
						this.setState({
							isOpen: true,
							isPseudoFocused: false
						});
					}
	
					return;
				}
	
				// prevent default event handlers
				event.preventDefault();
	
				// for the non-searchable select, toggle the menu
				if (!this.props.searchable) {
					// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
					this.focus();
					return this.setState({
						isOpen: !this.state.isOpen
					});
				}
	
				if (this.state.isFocused) {
					// On iOS, we can get into a state where we think the input is focused but it isn't really,
					// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
					// Call focus() again here to be safe.
					this.focus();
	
					var input = this.input;
					var toOpen = true;
	
					if (typeof input.getInput === 'function') {
						// Get the actual DOM input if the ref is an <AutosizeInput /> component
						input = input.getInput();
					}
	
					// clears the value so that the cursor will be at the end of input when the component re-renders
					input.value = '';
	
					if (this._focusAfterClear) {
						toOpen = false;
						this._focusAfterClear = false;
					}
	
					// if the input is focused, ensure the menu is open
					this.setState({
						isOpen: toOpen,
						isPseudoFocused: false,
						focusedOption: null
					});
				} else {
					// otherwise, focus the input and open the menu
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
					this.setState({ focusedOption: null });
				}
			}
		}, {
			key: 'handleMouseDownOnArrow',
			value: function handleMouseDownOnArrow(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				if (this.state.isOpen) {
					// prevent default event handlers
					event.stopPropagation();
					event.preventDefault();
					// close the menu
					this.closeMenu();
				} else {
					// If the menu isn't open, let the event bubble to the main handleMouseDown
					this.setState({
						isOpen: true
					});
				}
			}
		}, {
			key: 'handleMouseDownOnMenu',
			value: function handleMouseDownOnMenu(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, or if the component is disabled, ignore it.
				if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.stopPropagation();
				event.preventDefault();
	
				this._openAfterFocus = true;
				this.focus();
			}
		}, {
			key: 'closeMenu',
			value: function closeMenu() {
				if (this.props.onCloseResetsInput) {
					this.setState({
						inputValue: this.handleInputValueChange(''),
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				} else {
					this.setState({
						isOpen: false,
						isPseudoFocused: this.state.isFocused && !this.props.multi
					});
				}
				this.hasScrolledToOption = false;
			}
		}, {
			key: 'handleInputFocus',
			value: function handleInputFocus(event) {
				if (this.props.disabled) return;
	
				var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
				toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.
	
				if (this.props.onFocus) {
					this.props.onFocus(event);
				}
	
				this.setState({
					isFocused: true,
					isOpen: !!toOpen
				});
	
				this._focusAfterClear = false;
				this._openAfterFocus = false;
			}
		}, {
			key: 'handleInputBlur',
			value: function handleInputBlur(event) {
				// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
				if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
					this.focus();
					return;
				}
	
				if (this.props.onBlur) {
					this.props.onBlur(event);
				}
				var onBlurredState = {
					isFocused: false,
					isOpen: false,
					isPseudoFocused: false
				};
				if (this.props.onBlurResetsInput) {
					onBlurredState.inputValue = this.handleInputValueChange('');
				}
				this.setState(onBlurredState);
			}
		}, {
			key: 'handleInputChange',
			value: function handleInputChange(event) {
				var newInputValue = event.target.value;
	
				if (this.state.inputValue !== event.target.value) {
					newInputValue = this.handleInputValueChange(newInputValue);
				}
	
				this.setState({
					inputValue: newInputValue,
					isOpen: true,
					isPseudoFocused: false
				});
			}
		}, {
			key: 'setInputValue',
			value: function setInputValue(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				this.setState({
					inputValue: newValue
				});
			}
		}, {
			key: 'handleInputValueChange',
			value: function handleInputValueChange(newValue) {
				if (this.props.onInputChange) {
					var nextState = this.props.onInputChange(newValue);
					// Note: != used deliberately here to catch undefined and null
					if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
						newValue = '' + nextState;
					}
				}
				return newValue;
			}
		}, {
			key: 'handleKeyDown',
			value: function handleKeyDown(event) {
				if (this.props.disabled) return;
	
				if (typeof this.props.onInputKeyDown === 'function') {
					this.props.onInputKeyDown(event);
					if (event.defaultPrevented) {
						return;
					}
				}
	
				switch (event.keyCode) {
					case 8:
						// backspace
						if (!this.state.inputValue && this.props.backspaceRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
					case 9:
						// tab
						if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
							break;
						}
						event.preventDefault();
						this.selectFocusedOption();
						break;
					case 13:
						// enter
						event.preventDefault();
						event.stopPropagation();
						if (this.state.isOpen) {
							this.selectFocusedOption();
						} else {
							this.focusNextOption();
						}
						break;
					case 27:
						// escape
						event.preventDefault();
						if (this.state.isOpen) {
							this.closeMenu();
							event.stopPropagation();
						} else if (this.props.clearable && this.props.escapeClearsValue) {
							this.clearValue(event);
							event.stopPropagation();
						}
						break;
					case 32:
						// space
						if (this.props.searchable) {
							break;
						}
						event.preventDefault();
						if (!this.state.isOpen) {
							this.focusNextOption();
							break;
						}
						event.stopPropagation();
						this.selectFocusedOption();
						break;
					case 38:
						// up
						event.preventDefault();
						this.focusPreviousOption();
						break;
					case 40:
						// down
						event.preventDefault();
						this.focusNextOption();
						break;
					case 33:
						// page up
						event.preventDefault();
						this.focusPageUpOption();
						break;
					case 34:
						// page down
						event.preventDefault();
						this.focusPageDownOption();
						break;
					case 35:
						// end key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusEndOption();
						break;
					case 36:
						// home key
						if (event.shiftKey) {
							break;
						}
						event.preventDefault();
						this.focusStartOption();
						break;
					case 46:
						// delete
						if (!this.state.inputValue && this.props.deleteRemoves) {
							event.preventDefault();
							this.popValue();
						}
						break;
				}
			}
		}, {
			key: 'handleValueClick',
			value: function handleValueClick(option, event) {
				if (!this.props.onValueClick) return;
				this.props.onValueClick(option, event);
			}
		}, {
			key: 'handleMenuScroll',
			value: function handleMenuScroll(event) {
				if (!this.props.onMenuScrollToBottom) return;
				var target = event.target;
	
				if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
					this.props.onMenuScrollToBottom();
				}
			}
		}, {
			key: 'getOptionLabel',
			value: function getOptionLabel(op) {
				return op[this.props.labelKey];
			}
	
			/**
	   * Turns a value into an array from the given options
	   * @param {String|Number|Array} value		- the value of the select input
	   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
	   * @returns	{Array}	the value of the select represented in an array
	   */
	
		}, {
			key: 'getValueArray',
			value: function getValueArray(value) {
				var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
	
				/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
				var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
				if (props.multi) {
					if (typeof value === 'string') {
						value = value.split(props.delimiter);
					}
					if (!Array.isArray(value)) {
						if (value === null || value === undefined) return [];
						value = [value];
					}
					return value.map(function (value) {
						return expandValue(value, props);
					}).filter(function (i) {
						return i;
					});
				}
				var expandedValue = expandValue(value, props);
				return expandedValue ? [expandedValue] : [];
			}
		}, {
			key: 'setValue',
			value: function setValue(value) {
				var _this2 = this;
	
				if (this.props.autoBlur) {
					this.blurInput();
				}
				if (this.props.required) {
					var required = handleRequired(value, this.props.multi);
					this.setState({ required: required });
				}
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this2.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				if (this.props.onChange) {
					this.props.onChange(value);
				}
			}
		}, {
			key: 'selectValue',
			value: function selectValue(value) {
				var _this3 = this;
	
				// NOTE: we actually add/set the value in a callback to make sure the
				// input value is empty to avoid styling issues in Chrome
				if (this.props.closeOnSelect) {
					this.hasScrolledToOption = false;
				}
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				if (this.props.multi) {
					this.setState({
						focusedIndex: null,
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect
					}, function () {
						var valueArray = _this3.getValueArray(_this3.props.value);
						if (valueArray.some(function (i) {
							return i[_this3.props.valueKey] === value[_this3.props.valueKey];
						})) {
							_this3.removeValue(value);
						} else {
							_this3.addValue(value);
						}
					});
				} else {
					this.setState({
						inputValue: this.handleInputValueChange(updatedValue),
						isOpen: !this.props.closeOnSelect,
						isPseudoFocused: this.state.isFocused
					}, function () {
						_this3.setValue(value);
					});
				}
			}
		}, {
			key: 'addValue',
			value: function addValue(value) {
				var valueArray = this.getValueArray(this.props.value);
				var visibleOptions = this._visibleOptions.filter(function (val) {
					return !val.disabled;
				});
				var lastValueIndex = visibleOptions.indexOf(value);
				this.setValue(valueArray.concat(value));
				if (visibleOptions.length - 1 === lastValueIndex) {
					// the last option was selected; focus the second-last one
					this.focusOption(visibleOptions[lastValueIndex - 1]);
				} else if (visibleOptions.length > lastValueIndex) {
					// focus the option below the selected one
					this.focusOption(visibleOptions[lastValueIndex + 1]);
				}
			}
		}, {
			key: 'popValue',
			value: function popValue() {
				var valueArray = this.getValueArray(this.props.value);
				if (!valueArray.length) return;
				if (valueArray[valueArray.length - 1].clearableValue === false) return;
				this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
			}
		}, {
			key: 'removeValue',
			value: function removeValue(value) {
				var _this4 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				this.setValue(valueArray.filter(function (i) {
					return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
				}));
				this.focus();
			}
		}, {
			key: 'clearValue',
			value: function clearValue(event) {
				// if the event was triggered by a mousedown and not the primary
				// button, ignore it.
				if (event && event.type === 'mousedown' && event.button !== 0) {
					return;
				}
	
				event.preventDefault();
	
				this.setValue(this.getResetValue());
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false
				}, this.focus);
	
				this._focusAfterClear = true;
			}
		}, {
			key: 'getResetValue',
			value: function getResetValue() {
				if (this.props.resetValue !== undefined) {
					return this.props.resetValue;
				} else if (this.props.multi) {
					return [];
				} else {
					return null;
				}
			}
		}, {
			key: 'focusOption',
			value: function focusOption(option) {
				this.setState({
					focusedOption: option
				});
			}
		}, {
			key: 'focusNextOption',
			value: function focusNextOption() {
				this.focusAdjacentOption('next');
			}
		}, {
			key: 'focusPreviousOption',
			value: function focusPreviousOption() {
				this.focusAdjacentOption('previous');
			}
		}, {
			key: 'focusPageUpOption',
			value: function focusPageUpOption() {
				this.focusAdjacentOption('page_up');
			}
		}, {
			key: 'focusPageDownOption',
			value: function focusPageDownOption() {
				this.focusAdjacentOption('page_down');
			}
		}, {
			key: 'focusStartOption',
			value: function focusStartOption() {
				this.focusAdjacentOption('start');
			}
		}, {
			key: 'focusEndOption',
			value: function focusEndOption() {
				this.focusAdjacentOption('end');
			}
		}, {
			key: 'focusAdjacentOption',
			value: function focusAdjacentOption(dir) {
				var options = this._visibleOptions.map(function (option, index) {
					return { option: option, index: index };
				}).filter(function (option) {
					return !option.option.disabled;
				});
				this._scrollToFocusedOptionOnUpdate = true;
				if (!this.state.isOpen) {
					var newState = {
						focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
						isOpen: true
					};
					if (this.props.onSelectResetsInput) {
						newState.inputValue = '';
					}
					this.setState(newState);
					return;
				}
				if (!options.length) return;
				var focusedIndex = -1;
				for (var i = 0; i < options.length; i++) {
					if (this._focusedOption === options[i].option) {
						focusedIndex = i;
						break;
					}
				}
				if (dir === 'next' && focusedIndex !== -1) {
					focusedIndex = (focusedIndex + 1) % options.length;
				} else if (dir === 'previous') {
					if (focusedIndex > 0) {
						focusedIndex = focusedIndex - 1;
					} else {
						focusedIndex = options.length - 1;
					}
				} else if (dir === 'start') {
					focusedIndex = 0;
				} else if (dir === 'end') {
					focusedIndex = options.length - 1;
				} else if (dir === 'page_up') {
					var potentialIndex = focusedIndex - this.props.pageSize;
					if (potentialIndex < 0) {
						focusedIndex = 0;
					} else {
						focusedIndex = potentialIndex;
					}
				} else if (dir === 'page_down') {
					var _potentialIndex = focusedIndex + this.props.pageSize;
					if (_potentialIndex > options.length - 1) {
						focusedIndex = options.length - 1;
					} else {
						focusedIndex = _potentialIndex;
					}
				}
	
				if (focusedIndex === -1) {
					focusedIndex = 0;
				}
	
				this.setState({
					focusedIndex: options[focusedIndex].index,
					focusedOption: options[focusedIndex].option
				});
			}
		}, {
			key: 'getFocusedOption',
			value: function getFocusedOption() {
				return this._focusedOption;
			}
		}, {
			key: 'selectFocusedOption',
			value: function selectFocusedOption() {
				if (this._focusedOption) {
					return this.selectValue(this._focusedOption);
				}
			}
		}, {
			key: 'renderLoading',
			value: function renderLoading() {
				if (!this.props.isLoading) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
					_react2.default.createElement('span', { className: 'Select-loading' })
				);
			}
		}, {
			key: 'renderValue',
			value: function renderValue(valueArray, isOpen) {
				var _this5 = this;
	
				var renderLabel = this.props.valueRenderer || this.getOptionLabel;
				var ValueComponent = this.props.valueComponent;
				if (!valueArray.length) {
					var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
					return showPlaceholder ? _react2.default.createElement(
						'div',
						{ className: 'Select-placeholder' },
						this.props.placeholder
					) : null;
				}
				var onClick = this.props.onValueClick ? this.handleValueClick : null;
				if (this.props.multi) {
					return valueArray.map(function (value, i) {
						return _react2.default.createElement(
							ValueComponent,
							{
								disabled: _this5.props.disabled || value.clearableValue === false,
								id: _this5._instancePrefix + '-value-' + i,
								instancePrefix: _this5._instancePrefix,
								key: 'value-' + i + '-' + value[_this5.props.valueKey],
								onClick: onClick,
								onRemove: _this5.removeValue,
								placeholder: _this5.props.placeholder,
								value: value
							},
							renderLabel(value, i),
							_react2.default.createElement(
								'span',
								{ className: 'Select-aria-only' },
								'\xA0'
							)
						);
					});
				} else if (shouldShowValue(this.state, this.props)) {
					if (isOpen) onClick = null;
					return _react2.default.createElement(
						ValueComponent,
						{
							disabled: this.props.disabled,
							id: this._instancePrefix + '-value-item',
							instancePrefix: this._instancePrefix,
							onClick: onClick,
							placeholder: this.props.placeholder,
							value: valueArray[0]
						},
						renderLabel(valueArray[0])
					);
				}
			}
		}, {
			key: 'renderInput',
			value: function renderInput(valueArray, focusedOptionIndex) {
				var _classNames,
				    _this6 = this;
	
				var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
				var isOpen = this.state.isOpen;
	
				var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));
	
				var value = this.state.inputValue;
				if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
					// it hides input value when it is not focused and was not reset on select
					value = '';
				}
	
				var inputProps = _extends({}, this.props.inputProps, {
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-describedby': this.props['aria-describedby'],
					'aria-expanded': '' + isOpen,
					'aria-haspopup': '' + isOpen,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					'aria-owns': ariaOwns,
					className: className,
					onBlur: this.handleInputBlur,
					onChange: this.handleInputChange,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref) {
						return _this6.input = _ref;
					},
					role: 'combobox',
					required: this.state.required,
					tabIndex: this.props.tabIndex,
					value: value
				});
	
				if (this.props.inputRenderer) {
					return this.props.inputRenderer(inputProps);
				}
	
				if (this.props.disabled || !this.props.searchable) {
					var divProps = _objectWithoutProperties(this.props.inputProps, []);
	
					var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));
					return _react2.default.createElement('div', _extends({}, divProps, {
						'aria-expanded': isOpen,
						'aria-owns': _ariaOwns,
						'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
						'aria-disabled': '' + this.props.disabled,
						'aria-label': this.props['aria-label'],
						'aria-labelledby': this.props['aria-labelledby'],
						className: className,
						onBlur: this.handleInputBlur,
						onFocus: this.handleInputFocus,
						ref: function ref(_ref2) {
							return _this6.input = _ref2;
						},
						role: 'combobox',
						style: { border: 0, width: 1, display: 'inline-block' },
						tabIndex: this.props.tabIndex || 0
					}));
				}
	
				if (this.props.autosize) {
					return _react2.default.createElement(_reactInputAutosize2.default, _extends({ id: this.props.id }, inputProps, { minWidth: '5' }));
				}
				return _react2.default.createElement(
					'div',
					{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
					_react2.default.createElement('input', _extends({ id: this.props.id }, inputProps))
				);
			}
		}, {
			key: 'renderClear',
			value: function renderClear() {
				var valueArray = this.getValueArray(this.props.value);
				if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
				var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
				var clear = this.props.clearRenderer();
	
				return _react2.default.createElement(
					'span',
					{
						'aria-label': ariaLabel,
						className: 'Select-clear-zone',
						onMouseDown: this.clearValue,
						onTouchEnd: this.handleTouchEndClearValue,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						title: ariaLabel
					},
					clear
				);
			}
		}, {
			key: 'renderArrow',
			value: function renderArrow() {
				if (!this.props.arrowRenderer) return;
	
				var onMouseDown = this.handleMouseDownOnArrow;
				var isOpen = this.state.isOpen;
				var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });
	
				if (!arrow) {
					return null;
				}
	
				return _react2.default.createElement(
					'span',
					{
						className: 'Select-arrow-zone',
						onMouseDown: onMouseDown
					},
					arrow
				);
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions(excludeOptions) {
				var filterValue = this.state.inputValue;
				var options = this.props.options || [];
				if (this.props.filterOptions) {
					// Maintain backwards compatibility with boolean attribute
					var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;
	
					return filterOptions(options, filterValue, excludeOptions, {
						filterOption: this.props.filterOption,
						ignoreAccents: this.props.ignoreAccents,
						ignoreCase: this.props.ignoreCase,
						labelKey: this.props.labelKey,
						matchPos: this.props.matchPos,
						matchProp: this.props.matchProp,
						trimFilter: this.props.trimFilter,
						valueKey: this.props.valueKey
					});
				} else {
					return options;
				}
			}
		}, {
			key: 'onOptionRef',
			value: function onOptionRef(ref, isFocused) {
				if (isFocused) {
					this.focused = ref;
				}
			}
		}, {
			key: 'renderMenu',
			value: function renderMenu(options, valueArray, focusedOption) {
				if (options && options.length) {
					return this.props.menuRenderer({
						focusedOption: focusedOption,
						focusOption: this.focusOption,
						inputValue: this.state.inputValue,
						instancePrefix: this._instancePrefix,
						labelKey: this.props.labelKey,
						onFocus: this.focusOption,
						onOptionRef: this.onOptionRef,
						onSelect: this.selectValue,
						optionClassName: this.props.optionClassName,
						optionComponent: this.props.optionComponent,
						optionRenderer: this.props.optionRenderer || this.getOptionLabel,
						options: options,
						removeValue: this.removeValue,
						selectValue: this.selectValue,
						valueArray: valueArray,
						valueKey: this.props.valueKey
					});
				} else if (this.props.noResultsText) {
					return _react2.default.createElement(
						'div',
						{ className: 'Select-noresults' },
						this.props.noResultsText
					);
				} else {
					return null;
				}
			}
		}, {
			key: 'renderHiddenField',
			value: function renderHiddenField(valueArray) {
				var _this7 = this;
	
				if (!this.props.name) return;
				if (this.props.joinValues) {
					var value = valueArray.map(function (i) {
						return stringifyValue(i[_this7.props.valueKey]);
					}).join(this.props.delimiter);
					return _react2.default.createElement('input', {
						disabled: this.props.disabled,
						name: this.props.name,
						ref: function ref(_ref3) {
							return _this7.value = _ref3;
						},
						type: 'hidden',
						value: value
					});
				}
				return valueArray.map(function (item, index) {
					return _react2.default.createElement('input', {
						disabled: _this7.props.disabled,
						key: 'hidden.' + index,
						name: _this7.props.name,
						ref: 'value' + index,
						type: 'hidden',
						value: stringifyValue(item[_this7.props.valueKey])
					});
				});
			}
		}, {
			key: 'getFocusableOptionIndex',
			value: function getFocusableOptionIndex(selectedOption) {
				var options = this._visibleOptions;
				if (!options.length) return null;
	
				var valueKey = this.props.valueKey;
				var focusedOption = this.state.focusedOption || selectedOption;
				if (focusedOption && !focusedOption.disabled) {
					var focusedOptionIndex = -1;
					options.some(function (option, index) {
						var isOptionEqual = option[valueKey] === focusedOption[valueKey];
						if (isOptionEqual) {
							focusedOptionIndex = index;
						}
						return isOptionEqual;
					});
					if (focusedOptionIndex !== -1) {
						return focusedOptionIndex;
					}
				}
	
				for (var i = 0; i < options.length; i++) {
					if (!options[i].disabled) return i;
				}
				return null;
			}
		}, {
			key: 'renderOuter',
			value: function renderOuter(options, valueArray, focusedOption) {
				var _this8 = this;
	
				var menu = this.renderMenu(options, valueArray, focusedOption);
				if (!menu) {
					return null;
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref5) {
							return _this8.menuContainer = _ref5;
						}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
					_react2.default.createElement(
						'div',
						{
							className: 'Select-menu',
							id: this._instancePrefix + '-list',
							onMouseDown: this.handleMouseDownOnMenu,
							onScroll: this.handleMenuScroll,
							ref: function ref(_ref4) {
								return _this8.menu = _ref4;
							},
							role: 'listbox',
							style: this.props.menuStyle,
							tabIndex: -1
						},
						menu
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this9 = this;
	
				var valueArray = this.getValueArray(this.props.value);
				var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
				var isOpen = this.state.isOpen;
				if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
				var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);
	
				var focusedOption = null;
				if (focusedOptionIndex !== null) {
					focusedOption = this._focusedOption = options[focusedOptionIndex];
				} else {
					focusedOption = this._focusedOption = null;
				}
				var className = (0, _classnames2.default)('Select', this.props.className, {
					'has-value': valueArray.length,
					'is-clearable': this.props.clearable,
					'is-disabled': this.props.disabled,
					'is-focused': this.state.isFocused,
					'is-loading': this.props.isLoading,
					'is-open': isOpen,
					'is-pseudo-focused': this.state.isPseudoFocused,
					'is-searchable': this.props.searchable,
					'Select--multi': this.props.multi,
					'Select--rtl': this.props.rtl,
					'Select--single': !this.props.multi
				});
	
				var removeMessage = null;
				if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
					removeMessage = _react2.default.createElement(
						'span',
						{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
						this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
					);
				}
	
				return _react2.default.createElement(
					'div',
					{ ref: function ref(_ref7) {
							return _this9.wrapper = _ref7;
						},
						className: className,
						style: this.props.wrapperStyle },
					this.renderHiddenField(valueArray),
					_react2.default.createElement(
						'div',
						{ ref: function ref(_ref6) {
								return _this9.control = _ref6;
							},
							className: 'Select-control',
							onKeyDown: this.handleKeyDown,
							onMouseDown: this.handleMouseDown,
							onTouchEnd: this.handleTouchEnd,
							onTouchMove: this.handleTouchMove,
							onTouchStart: this.handleTouchStart,
							style: this.props.style
						},
						_react2.default.createElement(
							'span',
							{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
							this.renderValue(valueArray, isOpen),
							this.renderInput(valueArray, focusedOptionIndex)
						),
						removeMessage,
						this.renderLoading(),
						this.renderClear(),
						this.renderArrow()
					),
					isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
				);
			}
		}]);
	
		return Select;
	}(_react2.default.Component);
	
	Select.propTypes = {
		'aria-describedby': _propTypes2.default.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2.default.string, // aria label (for assistive tech)
		'aria-labelledby': _propTypes2.default.string, // html id of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2.default.func, // create the drop-down caret element
		autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
		autoFocus: _propTypes2.default.bool, // autofocus the component on mount
		autofocus: _propTypes2.default.bool, // deprecated; use autoFocus instead
		autosize: _propTypes2.default.bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2.default.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2.default.string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2.default.func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2.default.bool, // should it be possible to reset value
		closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
		deleteRemoves: _propTypes2.default.bool, // whether delete removes an item if there is no text input
		delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2.default.bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		id: _propTypes2.default.string, // html id to set on the input element for accessibility or tests
		ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2.default.object, // custom attributes for the Input
		inputRenderer: _propTypes2.default.func, // returns a custom input component
		instanceId: _propTypes2.default.string, // set the components instanceId
		isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2.default.string, // path of the label value in option objects
		matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
		menuRenderer: _propTypes2.default.func, // renders a custom menu with options
		menuStyle: _propTypes2.default.object, // optional style to apply to the menu
		multi: _propTypes2.default.bool, // multi-value input
		name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onClose: _propTypes2.default.func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2.default.func, // fires when the menu is opened
		onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
		onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
		openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
		openOnFocus: _propTypes2.default.bool, // always open options menu on focus
		optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2.default.func, // option component to render in dropdown
		optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
		options: _propTypes2.default.array, // array of options
		pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		removeSelected: _propTypes2.default.bool, // whether the selected option is removed from the dropdown on multi selects
		required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2.default.any, // value to use when you clear the control
		rtl: _propTypes2.default.bool, // set to true in order to use react-select in right-to-left direction
		scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2.default.bool, // whether to enable searching feature or not
		simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2.default.object, // optional style to apply to the control
		tabIndex: stringOrNumber, // optional tab index of the control
		tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
		trimFilter: _propTypes2.default.bool, // whether to trim whitespace around filter value
		value: _propTypes2.default.any, // initial field value
		valueComponent: _propTypes2.default.func, // value component to render
		valueKey: _propTypes2.default.string, // path of the label value in option objects
		valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
	};
	
	Select.defaultProps = {
		arrowRenderer: _defaultArrowRenderer2.default,
		autosize: true,
		backspaceRemoves: true,
		backspaceToRemoveMessage: 'Press backspace to remove {label}',
		clearable: true,
		clearAllText: 'Clear all',
		clearRenderer: _defaultClearRenderer2.default,
		clearValueText: 'Clear value',
		closeOnSelect: true,
		deleteRemoves: true,
		delimiter: ',',
		disabled: false,
		escapeClearsValue: true,
		filterOptions: _defaultFilterOptions2.default,
		ignoreAccents: true,
		ignoreCase: true,
		inputProps: {},
		isLoading: false,
		joinValues: false,
		labelKey: 'label',
		matchPos: 'any',
		matchProp: 'any',
		menuBuffer: 0,
		menuRenderer: _defaultMenuRenderer2.default,
		multi: false,
		noResultsText: 'No results found',
		onBlurResetsInput: true,
		onCloseResetsInput: true,
		onSelectResetsInput: true,
		openOnClick: true,
		optionComponent: _Option2.default,
		pageSize: 5,
		placeholder: 'Select...',
		removeSelected: true,
		required: false,
		rtl: false,
		scrollMenuIntoView: true,
		searchable: true,
		simpleValue: false,
		tabSelectsValue: true,
		trimFilter: true,
		valueComponent: _Value2.default,
		valueKey: 'value'
	};
	
	exports.default = Select;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warn = exports.getTransitionVal = exports.compose = exports.translateStyle = exports.mapObject = exports.debugf = exports.debug = exports.log = exports.generatePrefixStyle = exports.getDashCase = exports.identity = exports.getIntersectionKeys = undefined;
	
	var _intersection2 = __webpack_require__(2435);
	
	var _intersection3 = _interopRequireDefault(_intersection2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* eslint no-console: 0 */
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
	var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
	
	var getIntersectionKeys = exports.getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
	  return (0, _intersection3.default)(Object.keys(preObj), Object.keys(nextObj));
	};
	
	var identity = exports.identity = function identity(param) {
	  return param;
	};
	
	/*
	 * @description: convert camel case to dash case
	 * string => string
	 */
	var getDashCase = exports.getDashCase = function getDashCase(name) {
	  return name.replace(/([A-Z])/g, function (v) {
	    return '-' + v.toLowerCase();
	  });
	};
	
	/*
	 * @description: add compatible style prefix
	 * (string, string) => object
	 */
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
	    return _defineProperty({}, name, value);
	  }
	
	  var isTransition = name === 'transition';
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var styleVal = value;
	
	  return PREFIX_LIST.reduce(function (result, property, i) {
	    if (isTransition) {
	      styleVal = value.replace(/(transform|transform-origin)/gim, IN_LINE_PREFIX_LIST[i] + '$1');
	    }
	
	    return _extends({}, result, _defineProperty({}, property + camelName, styleVal));
	  }, {});
	};
	
	var log = exports.log = function log() {
	  var _console;
	
	  (_console = console).log.apply(_console, arguments);
	};
	
	/*
	 * @description: log the value of a varible
	 * string => any => any
	 */
	var debug = exports.debug = function debug(name) {
	  return function (item) {
	    log(name, item);
	
	    return item;
	  };
	};
	
	/*
	 * @description: log name, args, return value of a function
	 * function => function
	 */
	var debugf = exports.debugf = function debugf(tag, f) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var res = f.apply(undefined, args);
	    var name = tag || f.name || 'anonymous function';
	    var argNames = '(' + args.map(JSON.stringify).join(', ') + ')';
	
	    log(name + ': ' + argNames + ' => ' + JSON.stringify(res));
	
	    return res;
	  };
	};
	
	/*
	 * @description: map object on every element in this object.
	 * (function, object) => object
	 */
	var mapObject = exports.mapObject = function mapObject(fn, obj) {
	  return Object.keys(obj).reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, fn(key, obj[key])));
	  }, {});
	};
	
	/*
	 * @description: add compatible prefix to style
	 * object => object
	 */
	var translateStyle = exports.translateStyle = function translateStyle(style) {
	  return Object.keys(style).reduce(function (res, key) {
	    return _extends({}, res, generatePrefixStyle(key, res[key]));
	  }, style);
	};
	
	var compose = exports.compose = function compose() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var getTransitionVal = exports.getTransitionVal = function getTransitionVal(props, duration, easing) {
	  return props.map(function (prop) {
	    return getDashCase(prop) + ' ' + duration + 'ms ' + easing;
	  }).join(',');
	};
	
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.elementContextTypes = exports.injectContextTypes = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Provider = __webpack_require__(518);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var injectContextTypes = exports.injectContextTypes = {
	  getRegisteredElements: _propTypes2.default.func.isRequired
	};
	
	var elementContextTypes = exports.elementContextTypes = {
	  addElementsLoadListener: _propTypes2.default.func.isRequired,
	  registerElement: _propTypes2.default.func.isRequired,
	  unregisterElement: _propTypes2.default.func.isRequired
	};
	
	var Elements = function (_React$Component) {
	  _inherits(Elements, _React$Component);
	
	  function Elements(props, context) {
	    _classCallCheck(this, Elements);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRegisterElement = function (type, element) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [{ type: type, element: element }])
	        };
	      });
	    };
	
	    _this.handleUnregisterElement = function (el) {
	      _this.setState(function (prevState) {
	        return {
	          registeredElements: prevState.registeredElements.filter(function (_ref) {
	            var element = _ref.element;
	            return element !== el;
	          })
	        };
	      });
	    };
	
	    _this.state = {
	      registeredElements: []
	    };
	    return _this;
	  }
	
	  Elements.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return {
	      addElementsLoadListener: function addElementsLoadListener(fn) {
	        // Return the existing elements instance if we already have one.
	        if (_this2._elements) {
	          fn(_this2._elements);
	          return;
	        }
	
	        var _props = _this2.props,
	            children = _props.children,
	            options = _objectWithoutProperties(_props, ['children']);
	
	        if (_this2.context.tag === 'sync') {
	          _this2._elements = _this2.context.stripe.elements(options);
	          fn(_this2._elements);
	        } else {
	          _this2.context.addStripeLoadListener(function (stripe) {
	            if (_this2._elements) {
	              fn(_this2._elements);
	            } else {
	              _this2._elements = stripe.elements(options);
	              fn(_this2._elements);
	            }
	          });
	        }
	      },
	      registerElement: this.handleRegisterElement,
	      unregisterElement: this.handleUnregisterElement,
	      getRegisteredElements: function getRegisteredElements() {
	        return _this2.state.registeredElements;
	      }
	    };
	  };
	
	  Elements.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Elements;
	}(_react2.default.Component);
	
	Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
	Elements.contextTypes = _Provider.providerContextTypes;
	Elements.defaultProps = {
	  children: null
	};
	exports.default = Elements;

/***/ },
/* 353 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2892);


/***/ },
/* 355 */
[3546, 2907],
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Z Axis
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ZAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ZAxis, _Component);
	
	  function ZAxis() {
	    _classCallCheck(this, ZAxis);
	
	    return _possibleConstructorReturn(this, (ZAxis.__proto__ || Object.getPrototypeOf(ZAxis)).apply(this, arguments));
	  }
	
	  _createClass(ZAxis, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return ZAxis;
	}(_react.Component), _class2.displayName = 'ZAxis', _class2.propTypes = {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  // The name of data displayed in the axis
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unit of data displayed in the axis
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The unique id of z-axis
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  // The key of data displayed in the axis
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  // The range of axis
	  range: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes2.default.func])
	}, _class2.defaultProps = {
	  zAxisId: 0,
	  range: [64, 64],
	  scale: 'auto',
	  type: 'number'
	}, _temp)) || _class;
	
	exports.default = ZAxis;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Tooltip
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DefaultTooltipContent = __webpack_require__(2987);
	
	var _DefaultTooltipContent2 = _interopRequireDefault(_DefaultTooltipContent);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CLS_PREFIX = 'recharts-tooltip-wrapper';
	
	var EPS = 1;
	
	var propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  active: _propTypes2.default.bool,
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  offset: _propTypes2.default.number,
	
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  wrapperStyle: _propTypes2.default.object,
	  cursor: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.element, _propTypes2.default.object]),
	
	  coordinate: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  position: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  itemSorter: _propTypes2.default.func,
	  filterNull: _propTypes2.default.bool,
	  useTranslate3d: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  active: false,
	  offset: 10,
	  viewBox: { x1: 0, x2: 0, y1: 0, y2: 0 },
	  coordinate: { x: 0, y: 0 },
	  cursorStyle: {},
	  separator: ' : ',
	  wrapperStyle: {},
	  itemStyle: {},
	  labelStyle: {},
	  cursor: true,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationEasing: 'ease',
	  animationDuration: 400,
	  itemSorter: function itemSorter() {
	    return -1;
	  },
	  filterNull: true,
	  useTranslate3d: false
	};
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultTooltipContent2.default, props);
	};
	
	var Tooltip = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          isAnimationActive = _props.isAnimationActive,
	          animationDuration = _props.animationDuration,
	          animationEasing = _props.animationEasing,
	          filterNull = _props.filterNull;
	
	      var finalPayload = filterNull && payload && payload.length ? payload.filter(function (entry) {
	        return !(0, _isNil3.default)(entry.value);
	      }) : payload;
	      var hasPayload = finalPayload && finalPayload.length;
	      var _props2 = this.props,
	          content = _props2.content,
	          viewBox = _props2.viewBox,
	          coordinate = _props2.coordinate,
	          position = _props2.position,
	          active = _props2.active,
	          offset = _props2.offset,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        pointerEvents: 'none',
	        visibility: active && hasPayload ? 'visible' : 'hidden',
	        position: 'absolute',
	        top: 0
	      }, wrapperStyle);
	      var translateX = void 0,
	          translateY = void 0;
	
	      if (position && (0, _DataUtils.isNumber)(position.x) && (0, _DataUtils.isNumber)(position.y)) {
	        translateX = position.x;
	        translateY = position.y;
	      } else {
	        var _state2 = this.state,
	            boxWidth = _state2.boxWidth,
	            boxHeight = _state2.boxHeight;
	
	
	        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
	          translateX = position && (0, _DataUtils.isNumber)(position.x) ? position.x : Math.max(coordinate.x + boxWidth + offset > viewBox.x + viewBox.width ? coordinate.x - boxWidth - offset : coordinate.x + offset, viewBox.x);
	
	          translateY = position && (0, _DataUtils.isNumber)(position.y) ? position.y : Math.max(coordinate.y + boxHeight + offset > viewBox.y + viewBox.height ? coordinate.y - boxHeight - offset : coordinate.y + offset, viewBox.y);
	        } else {
	          outerStyle.visibility = 'hidden';
	        }
	      }
	
	      outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	        transform: this.props.useTranslate3d ? 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0)' : 'translate(' + translateX + 'px, ' + translateY + 'px)'
	      }));
	
	      if (isAnimationActive && active) {
	        outerStyle = _extends({}, outerStyle, (0, _reactSmooth.translateStyle)({
	          transition: 'transform ' + animationDuration + 'ms ' + animationEasing
	        }));
	      }
	
	      var cls = (0, _classnames2.default)(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, CLS_PREFIX + '-right', (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, CLS_PREFIX + '-left', (0, _DataUtils.isNumber)(translateX) && coordinate && (0, _DataUtils.isNumber)(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, CLS_PREFIX + '-bottom', (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, CLS_PREFIX + '-top', (0, _DataUtils.isNumber)(translateY) && coordinate && (0, _DataUtils.isNumber)(coordinate.y) && translateY < coordinate.y), _classNames));
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: cls,
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, _extends({}, this.props, { payload: finalPayload }))
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component), _class2.displayName = 'Tooltip', _class2.propTypes = propTypes, _class2.defaultProps = defaultProps, _temp2)) || _class;
	
	exports.default = Tooltip;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Axis of radial direction
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _Dot = __webpack_require__(165);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Polygon = __webpack_require__(534);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Text = __webpack_require__(164);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _PolarUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RADIAN = Math.PI / 180;
	var eps = 1e-5;
	
	var PolarAngleAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarAngleAxis, _Component);
	
	  function PolarAngleAxis() {
	    _classCallCheck(this, PolarAngleAxis);
	
	    return _possibleConstructorReturn(this, (PolarAngleAxis.__proto__ || Object.getPrototypeOf(PolarAngleAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarAngleAxis, [{
	    key: 'getTickLineCoord',
	
	
	    /**
	     * Calculate the coordinate of line endpoint
	     * @param  {Object} data The Data if ticks
	     * @return {Object} (x0, y0): The start point of text,
	     *                  (x1, y1): The end point close to text,
	     *                  (x2, y2): The end point close to axis
	     */
	    value: function getTickLineCoord(data) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          radius = _props.radius,
	          orientation = _props.orientation,
	          tickLine = _props.tickLine;
	
	      var tickLineSize = tickLine && tickLine.size || 8;
	      var p1 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, data.coordinate);
	      var p2 = (0, _PolarUtils.polarToCartesian)(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
	
	      return { x1: p1.x, y1: p1.y, x2: p2.x, y2: p2.y };
	    }
	    /**
	     * Get the text-anchor of each tick
	     * @param  {Object} data Data of ticks
	     * @return {String} text-anchor
	     */
	
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor(data) {
	      var orientation = this.props.orientation;
	
	      var cos = Math.cos(-data.coordinate * RADIAN);
	      var textAnchor = void 0;
	
	      if (cos > eps) {
	        textAnchor = orientation === 'outer' ? 'start' : 'end';
	      } else if (cos < -eps) {
	        textAnchor = orientation === 'outer' ? 'end' : 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          radius = _props2.radius,
	          axisLine = _props2.axisLine,
	          axisLineType = _props2.axisLineType;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (axisLineType === 'circle') {
	        return _react2.default.createElement(_Dot2.default, _extends({
	          className: 'recharts-polar-angle-axis-line'
	        }, props, {
	          cx: cx,
	          cy: cy,
	          r: radius
	        }));
	      }
	      var ticks = this.props.ticks;
	
	      var points = ticks.map(function (entry) {
	        return (0, _PolarUtils.polarToCartesian)(cx, cy, radius, entry.coordinate);
	      });
	
	      return _react2.default.createElement(_Polygon2.default, _extends({ className: 'recharts-polar-angle-axis-line' }, props, { points: points }));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-angle-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          ticks = _props3.ticks,
	          tick = _props3.tick,
	          tickLine = _props3.tickLine,
	          tickFormatter = _props3.tickFormatter,
	          stroke = _props3.stroke;
	
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	
	      var items = ticks.map(function (entry, i) {
	        var lineCoord = _this2.getTickLineCoord(entry);
	        var textAnchor = _this2.getTickTextAnchor(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i, payload: entry,
	          x: lineCoord.x2, y: lineCoord.y2
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-angle-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-polar-angle-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          radius = _props4.radius,
	          axisLine = _props4.axisLine;
	
	
	      if (radius <= 0 || !ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-angle-axis' },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks()
	      );
	    }
	  }]);
	
	  return PolarAngleAxis;
	}(_react.Component), _class2.displayName = 'PolarAngleAxis', _class2.axisType = 'angleAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  hide: _propTypes2.default.bool,
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(_ReactUtils.SCALE_TYPES), _propTypes2.default.func]),
	
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  axisLineType: _propTypes2.default.oneOf(['polygon', 'circle']),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    coordinate: _propTypes2.default.number
	  })),
	  stroke: _propTypes2.default.string,
	  orientation: _propTypes2.default.oneOf(['inner', 'outer']),
	  tickFormatter: _propTypes2.default.func,
	  allowDuplicatedCategory: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  type: 'category',
	  angleAxisId: 0,
	  scale: 'auto',
	  cx: 0,
	  cy: 0,
	  domain: [0, 'auto'],
	  orientation: 'outer',
	  axisLine: true,
	  tickLine: true,
	  tick: true,
	  hide: false,
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	exports.default = PolarAngleAxis;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _minBy2 = __webpack_require__(2444);
	
	var _minBy3 = _interopRequireDefault(_minBy2);
	
	var _maxBy2 = __webpack_require__(1006);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview The axis of polar coordinate system
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Text = __webpack_require__(164);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _PolarUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarRadiusAxis = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarRadiusAxis, _Component);
	
	  function PolarRadiusAxis() {
	    _classCallCheck(this, PolarRadiusAxis);
	
	    return _possibleConstructorReturn(this, (PolarRadiusAxis.__proto__ || Object.getPrototypeOf(PolarRadiusAxis)).apply(this, arguments));
	  }
	
	  _createClass(PolarRadiusAxis, [{
	    key: 'getTickValueCoord',
	
	
	    /**
	     * Calculate the coordinate of tick
	     * @param  {Number} coordinate The radius of tick
	     * @return {Object} (x, y)
	     */
	    value: function getTickValueCoord(_ref) {
	      var coordinate = _ref.coordinate;
	      var _props = this.props,
	          angle = _props.angle,
	          cx = _props.cx,
	          cy = _props.cy;
	
	
	      return (0, _PolarUtils.polarToCartesian)(cx, cy, coordinate, angle);
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var orientation = this.props.orientation;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = 'end';
	          break;
	        case 'right':
	          textAnchor = 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getViewBox',
	    value: function getViewBox() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          angle = _props2.angle,
	          ticks = _props2.ticks;
	
	      var maxRadiusTick = (0, _maxBy3.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	      var minRadiusTick = (0, _minBy3.default)(ticks, function (entry) {
	        return entry.coordinate || 0;
	      });
	
	      return {
	        cx: cx, cy: cy,
	        startAngle: angle,
	        endAngle: angle,
	        innerRadius: minRadiusTick.coordinate || 0,
	        outerRadius: maxRadiusTick.coordinate || 0
	      };
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy,
	          angle = _props3.angle,
	          ticks = _props3.ticks,
	          axisLine = _props3.axisLine,
	          others = _objectWithoutProperties(_props3, ['cx', 'cy', 'angle', 'ticks', 'axisLine']);
	
	      var extent = ticks.reduce(function (result, entry) {
	        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
	      }, [Infinity, -Infinity]);
	      var point0 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[0], angle);
	      var point1 = (0, _PolarUtils.polarToCartesian)(cx, cy, extent[1], angle);
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine), {
	        x1: point0.x,
	        y1: point0.y,
	        x2: point1.x,
	        y2: point1.y
	      });
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-polar-radius-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-polar-radius-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          ticks = _props4.ticks,
	          tick = _props4.tick,
	          angle = _props4.angle,
	          tickFormatter = _props4.tickFormatter,
	          stroke = _props4.stroke,
	          others = _objectWithoutProperties(_props4, ['ticks', 'tick', 'angle', 'tickFormatter', 'stroke']);
	
	      var textAnchor = this.getTickTextAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(others);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	
	      var items = ticks.map(function (entry, i) {
	        var coord = _this2.getTickValueCoord(entry);
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          transform: 'rotate(' + (90 - angle) + ', ' + coord.x + ', ' + coord.y + ')'
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, {
	          index: i
	        }, coord, {
	          payload: entry
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-polar-radius-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _this2.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value)
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          ticks = _props5.ticks,
	          axisLine = _props5.axisLine,
	          tick = _props5.tick;
	
	
	      if (!ticks || !ticks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-polar-radius-axis' },
	        axisLine && this.renderAxisLine(),
	        tick && this.renderTicks(),
	        _Label2.default.renderCallByParent(this.props, this.getViewBox())
	      );
	    }
	  }]);
	
	  return PolarRadiusAxis;
	}(_react.Component), _class2.displayName = 'PolarRadiusAxis', _class2.axisType = 'radiusAxis', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  type: _propTypes2.default.oneOf(['number', 'category']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  angle: _propTypes2.default.number,
	  tickCount: _propTypes2.default.number,
	  ticks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    coordinate: _propTypes2.default.number
	  })),
	  orientation: _propTypes2.default.oneOf(['left', 'right', 'middle']),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  domain: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto', 'dataMin', 'dataMax'])])),
	  scale: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), _propTypes2.default.func]),
	  allowDataOverflow: _propTypes2.default.bool,
	  allowDuplicatedCategory: _propTypes2.default.bool
	}), _class2.defaultProps = {
	  type: 'number',
	  radiusAxisId: 0,
	  cx: 0,
	  cy: 0,
	  angle: 0,
	  orientation: 'right',
	  stroke: '#ccc',
	  axisLine: true,
	  tick: true,
	  tickCount: 5,
	  domain: [0, 'auto'],
	  allowDataOverflow: false,
	  scale: 'auto',
	  allowDuplicatedCategory: true
	}, _temp)) || _class;
	
	exports.default = PolarRadiusAxis;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Sector
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
	
	  return sign * deltaAngle;
	};
	
	var getTangentCircle = function getTangentCircle(_ref) {
	  var cx = _ref.cx,
	      cy = _ref.cy,
	      radius = _ref.radius,
	      angle = _ref.angle,
	      sign = _ref.sign,
	      isExternal = _ref.isExternal,
	      cornerRadius = _ref.cornerRadius;
	
	  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
	  var theta = Math.asin(cornerRadius / centerRadius) / _PolarUtils.RADIAN;
	  var centerAngle = angle + sign * theta;
	  var center = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
	  // The coordinate of point which is tangent to the circle
	  var circleTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
	  // The coordinate of point which is tangent to the radius line
	  var lineTangency = (0, _PolarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * _PolarUtils.RADIAN), angle);
	
	  return { center: center, circleTangency: circleTangency, lineTangency: lineTangency, theta: theta };
	};
	
	var getSectorPath = function getSectorPath(_ref2) {
	  var cx = _ref2.cx,
	      cy = _ref2.cy,
	      innerRadius = _ref2.innerRadius,
	      outerRadius = _ref2.outerRadius,
	      startAngle = _ref2.startAngle,
	      endAngle = _ref2.endAngle;
	
	  var angle = getDeltaAngle(startAngle, endAngle);
	
	  // When the angle of sector equals to 360, star point and end point coincide
	  var tempEndAngle = startAngle + angle;
	  var outerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
	  var outerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
	
	  var path = 'M ' + outerStartPoint.x + ',' + outerStartPoint.y + '\n    A ' + outerRadius + ',' + outerRadius + ',0,\n    ' + +(Math.abs(angle) > 180) + ',' + +(startAngle > tempEndAngle) + ',\n    ' + outerEndPoint.x + ',' + outerEndPoint.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var innerStartPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
	    var innerEndPoint = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
	    path += 'L ' + innerEndPoint.x + ',' + innerEndPoint.y + '\n            A ' + innerRadius + ',' + innerRadius + ',0,\n            ' + +(Math.abs(angle) > 180) + ',' + +(startAngle <= tempEndAngle) + ',\n            ' + innerStartPoint.x + ',' + innerStartPoint.y + ' Z';
	  } else {
	    path += 'L ' + cx + ',' + cy + ' Z';
	  }
	
	  return path;
	};
	
	var getSectorWithCorner = function getSectorWithCorner(_ref3) {
	  var cx = _ref3.cx,
	      cy = _ref3.cy,
	      innerRadius = _ref3.innerRadius,
	      outerRadius = _ref3.outerRadius,
	      cornerRadius = _ref3.cornerRadius,
	      startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	
	  var _getTangentCircle = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: startAngle, sign: sign, cornerRadius: cornerRadius
	  }),
	      soct = _getTangentCircle.circleTangency,
	      solt = _getTangentCircle.lineTangency,
	      sot = _getTangentCircle.theta;
	
	  var _getTangentCircle2 = getTangentCircle({
	    cx: cx, cy: cy, radius: outerRadius, angle: endAngle, sign: -sign, cornerRadius: cornerRadius
	  }),
	      eoct = _getTangentCircle2.circleTangency,
	      eolt = _getTangentCircle2.lineTangency,
	      eot = _getTangentCircle2.theta;
	
	  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;
	
	  if (outerArcAngle < 0) {
	    return getSectorPath({
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    });
	  }
	
	  var path = 'M ' + solt.x + ',' + solt.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + soct.x + ',' + soct.y + '\n    A' + outerRadius + ',' + outerRadius + ',0,' + +(outerArcAngle > 180) + ',' + +(sign < 0) + ',' + eoct.x + ',' + eoct.y + '\n    A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eolt.x + ',' + eolt.y + '\n  ';
	
	  if (innerRadius > 0) {
	    var _getTangentCircle3 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: startAngle, sign: sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        sict = _getTangentCircle3.circleTangency,
	        silt = _getTangentCircle3.lineTangency,
	        sit = _getTangentCircle3.theta;
	
	    var _getTangentCircle4 = getTangentCircle({
	      cx: cx, cy: cy, radius: innerRadius, angle: endAngle, sign: -sign, isExternal: true, cornerRadius: cornerRadius
	    }),
	        eict = _getTangentCircle4.circleTangency,
	        eilt = _getTangentCircle4.lineTangency,
	        eit = _getTangentCircle4.theta;
	
	    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;
	
	    if (innerArcAngle < 0) {
	      return path + 'L' + cx + ',' + cy + 'Z';
	    }
	
	    path += 'L' + eilt.x + ',' + eilt.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + eict.x + ',' + eict.y + '\n      A' + innerRadius + ',' + innerRadius + ',0,' + +(innerArcAngle > 180) + ',' + +(sign > 0) + ',' + sict.x + ',' + sict.y + '\n      A' + cornerRadius + ',' + cornerRadius + ',0,0,' + +(sign < 0) + ',' + silt.x + ',' + silt.y + 'Z';
	  } else {
	    path += 'L' + cx + ',' + cy + 'Z';
	  }
	
	  return path;
	};
	
	var Sector = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sector, _Component);
	
	  function Sector() {
	    _classCallCheck(this, Sector);
	
	    return _possibleConstructorReturn(this, (Sector.__proto__ || Object.getPrototypeOf(Sector)).apply(this, arguments));
	  }
	
	  _createClass(Sector, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          innerRadius = _props.innerRadius,
	          outerRadius = _props.outerRadius,
	          cornerRadius = _props.cornerRadius,
	          startAngle = _props.startAngle,
	          endAngle = _props.endAngle,
	          className = _props.className;
	
	
	      if (outerRadius < innerRadius || startAngle === endAngle) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-sector', className);
	      var deltaRadius = outerRadius - innerRadius;
	      var cr = (0, _DataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
	      var path = void 0;
	
	      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
	        path = getSectorWithCorner({
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius,
	          cornerRadius: Math.min(cr, deltaRadius / 2),
	          startAngle: startAngle, endAngle: endAngle
	        });
	      } else {
	        path = getSectorPath({ cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle });
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        d: path
	      }));
	    }
	  }]);
	
	  return Sector;
	}(_react.Component), _class2.displayName = 'Sector', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  startAngle: 0,
	  endAngle: 0,
	  cornerRadius: 0
	}, _temp)) || _class;
	
	exports.default = Sector;

/***/ },
/* 361 */
177,
/* 362 */
[3452, 3165, 3166, 3167, 3168, 3169],
/* 363 */
[3459, 104],
/* 364 */
[3464, 263],
/* 365 */
[3465, 1370],
/* 366 */
[3472, 3123, 167],
/* 367 */
[3492, 3163],
/* 368 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 369 */
[3518, 166],
/* 370 */
[3528, 3122, 167],
/* 371 */
[3531, 104, 3203],
/* 372 */
[3536, 208, 167],
/* 373 */
[3537, 3126, 3139, 3179],
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.buffers = exports.BUFFER_OVERFLOW = undefined;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var BUFFER_OVERFLOW = exports.BUFFER_OVERFLOW = "Channel's Buffer overflow!";
	
	var ON_OVERFLOW_THROW = 1;
	var ON_OVERFLOW_DROP = 2;
	var ON_OVERFLOW_SLIDE = 3;
	var ON_OVERFLOW_EXPAND = 4;
	
	var zeroBuffer = { isEmpty: _utils.kTrue, put: _utils.noop, take: _utils.noop };
	
	function ringBuffer() {
	  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
	  var overflowAction = arguments[1];
	
	  var arr = new Array(limit);
	  var length = 0;
	  var pushIndex = 0;
	  var popIndex = 0;
	
	  var push = function push(it) {
	    arr[pushIndex] = it;
	    pushIndex = (pushIndex + 1) % limit;
	    length++;
	  };
	
	  var take = function take() {
	    if (length != 0) {
	      var it = arr[popIndex];
	      arr[popIndex] = null;
	      length--;
	      popIndex = (popIndex + 1) % limit;
	      return it;
	    }
	  };
	
	  var flush = function flush() {
	    var items = [];
	    while (length) {
	      items.push(take());
	    }
	    return items;
	  };
	
	  return {
	    isEmpty: function isEmpty() {
	      return length == 0;
	    },
	    put: function put(it) {
	      if (length < limit) {
	        push(it);
	      } else {
	        var doubledLimit = void 0;
	        switch (overflowAction) {
	          case ON_OVERFLOW_THROW:
	            throw new Error(BUFFER_OVERFLOW);
	          case ON_OVERFLOW_SLIDE:
	            arr[pushIndex] = it;
	            pushIndex = (pushIndex + 1) % limit;
	            popIndex = pushIndex;
	            break;
	          case ON_OVERFLOW_EXPAND:
	            doubledLimit = 2 * limit;
	
	            arr = flush();
	
	            length = arr.length;
	            pushIndex = arr.length;
	            popIndex = 0;
	
	            arr.length = doubledLimit;
	            limit = doubledLimit;
	
	            push(it);
	            break;
	          default:
	          // DROP
	        }
	      }
	    },
	    take: take,
	    flush: flush
	  };
	}
	
	var buffers = exports.buffers = {
	  none: function none() {
	    return zeroBuffer;
	  },
	  fixed: function fixed(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_THROW);
	  },
	  dropping: function dropping(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_DROP);
	  },
	  sliding: function sliding(limit) {
	    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
	  },
	  expanding: function expanding(initialSize) {
	    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
	  }
	};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(28)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _StyleSheetManager = __webpack_require__(1405);
	
	var _StyleSheetManager2 = _interopRequireDefault(_StyleSheetManager);
	
	var _nonce = __webpack_require__(1409);
	
	var _nonce2 = _interopRequireDefault(_nonce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/* eslint-disable no-underscore-dangle */
	
	
	var babelPluginFlowReactPropTypes_proptype_Tag = __webpack_require__(115).babelPluginFlowReactPropTypes_proptype_Tag || __webpack_require__(2).any;
	
	var ServerTag = function () {
	  function ServerTag(isLocal) {
	    _classCallCheck(this, ServerTag);
	
	    this.isLocal = isLocal;
	    this.components = {};
	    this.size = 0;
	    this.names = [];
	  }
	
	  ServerTag.prototype.isFull = function isFull() {
	    return false;
	  };
	
	  ServerTag.prototype.addComponent = function addComponent(componentId) {
	    if (false) {
	      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
	    }
	    this.components[componentId] = { componentId: componentId, css: '' };
	    this.size += 1;
	  };
	
	  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
	    var _this = this;
	
	    return Object.keys(this.components).reduce(function (styles, k) {
	      return styles + _this.components[k].css;
	    }, '');
	  };
	
	  ServerTag.prototype.inject = function inject(componentId, css, name) {
	    var comp = this.components[componentId];
	
	    if (false) {
	      throw new Error('Must add a new component before you can inject css into it');
	    }
	    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';
	
	    comp.css += css.replace(/\n*$/, '\n');
	
	    if (name) this.names.push(name);
	  };
	
	  ServerTag.prototype.toHTML = function toHTML() {
	    var attrs = ['type="text/css"', _StyleSheet.SC_ATTR + '="' + this.names.join(' ') + '"', _StyleSheet.LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      attrs.push('nonce="' + nonce + '"');
	    }
	
	    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
	  };
	
	  ServerTag.prototype.toReactElement = function toReactElement(key) {
	    var _attrs;
	
	    var attrs = (_attrs = {}, _attrs[_StyleSheet.SC_ATTR] = this.names.join(' '), _attrs[_StyleSheet.LOCAL_ATTR] = this.isLocal.toString(), _attrs);
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      attrs.nonce = nonce;
	    }
	
	    return _react2.default.createElement('style', _extends({
	      key: key,
	      type: 'text/css'
	    }, attrs, {
	      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
	    }));
	  };
	
	  ServerTag.prototype.clone = function clone() {
	    var _this2 = this;
	
	    var copy = new ServerTag(this.isLocal);
	    copy.names = [].concat(this.names);
	    copy.size = this.size;
	    copy.components = Object.keys(this.components).reduce(function (acc, key) {
	      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
	      return acc;
	    }, {});
	
	    return copy;
	  };
	
	  return ServerTag;
	}();
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    _classCallCheck(this, ServerStyleSheet);
	
	    this.instance = _StyleSheet2.default.clone(_StyleSheet2.default.instance);
	  }
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new Error("Can't collect styles once you've called getStyleTags!");
	    }
	    return _react2.default.createElement(
	      _StyleSheetManager2.default,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    if (!this.closed) {
	      _StyleSheet.clones.splice(_StyleSheet.clones.indexOf(this.instance), 1);
	      this.closed = true;
	    }
	
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    if (!this.closed) {
	      _StyleSheet.clones.splice(_StyleSheet.clones.indexOf(this.instance), 1);
	      this.closed = true;
	    }
	
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.create = function create() {
	    return new _StyleSheet2.default(function (isLocal) {
	      return new ServerTag(isLocal);
	    });
	  };
	
	  return ServerStyleSheet;
	}();
	
	exports.default = ServerStyleSheet;
	module.exports = exports['default'];

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.CONTEXT_CHANNEL_SHAPE = exports.CHANNEL_NEXT = exports.CHANNEL = undefined;
	
	var _ThemeProvider$childC, _ThemeProvider$contex;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isPlainObject = __webpack_require__(957);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _createBroadcast = __webpack_require__(1406);
	
	var _createBroadcast2 = _interopRequireDefault(_createBroadcast);
	
	var _once = __webpack_require__(3273);
	
	var _once2 = _interopRequireDefault(_once);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals React$Element */
	
	
	var babelPluginFlowReactPropTypes_proptype_Broadcast = __webpack_require__(1406).babelPluginFlowReactPropTypes_proptype_Broadcast || __webpack_require__(2).any;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = exports.CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = exports.CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = exports.CONTEXT_CHANNEL_SHAPE = _propTypes2.default.shape({
	  getTheme: _propTypes2.default.func,
	  subscribe: _propTypes2.default.func,
	  unsubscribe: _propTypes2.default.func
	});
	
	if (true) Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Theme', {
	  value: __webpack_require__(2).shape({})
	});
	
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = (0, _once2.default)(function () {
	    // eslint-disable-next-line no-console
	    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  _inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    _classCallCheck(this, ThemeProvider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	      });
	    }
	    this.broadcast = (0, _createBroadcast2.default)(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _extends2;
	
	    return _extends({}, this.context, (_extends2 = {}, _extends2[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _extends2[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _extends2));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.broadcast.publish(this.getTheme(nextProps.theme));
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	      if (false) {
	        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	      }
	      return mergedTheme;
	    }
	    if (!(0, _isPlainObject2.default)(theme)) {
	      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	    }
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(_react.Component);
	
	ThemeProvider.propTypes = {
	  children: __webpack_require__(2).any,
	  theme: __webpack_require__(2).oneOfType([__webpack_require__(2).shape({}), __webpack_require__(2).func]).isRequired
	};
	
	
	ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = _propTypes2.default.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	exports.default = ThemeProvider;

/***/ },
/* 378 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports["default"] = callMoment;
	// https://github.com/moment/moment/issues/3650
	function callMoment(moment) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	    }
	
	    return (moment["default"] || moment).apply(undefined, args);
	}

/***/ },
/* 379 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = getScroll;
	function getScroll(target, top) {
	    if (typeof window === 'undefined') {
	        return 0;
	    }
	    var prop = top ? 'pageYOffset' : 'pageXOffset';
	    var method = top ? 'scrollTop' : 'scrollLeft';
	    var isWindow = target === window;
	    var ret = isWindow ? target[prop] : target[method];
	    // ie6,7,8 standard mode
	    if (isWindow && typeof ret !== 'number') {
	        ret = window.document.documentElement[method];
	    }
	    return ret;
	}

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _cssAnimation = __webpack_require__(419);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _getRequestAnimationFrame = __webpack_require__(269);
	
	var _getRequestAnimationFrame2 = _interopRequireDefault(_getRequestAnimationFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var reqAnimFrame = (0, _getRequestAnimationFrame2['default'])();
	function animate(node, show, done) {
	    var height = void 0;
	    var requestAnimationFrameId = void 0;
	    return (0, _cssAnimation2['default'])(node, 'ant-motion-collapse', {
	        start: function start() {
	            if (!show) {
	                node.style.height = node.offsetHeight + 'px';
	                node.style.opacity = '1';
	            } else {
	                height = node.offsetHeight;
	                node.style.height = '0px';
	                node.style.opacity = '0';
	            }
	        },
	        active: function active() {
	            if (requestAnimationFrameId) {
	                (0, _getRequestAnimationFrame.cancelRequestAnimationFrame)(requestAnimationFrameId);
	            }
	            requestAnimationFrameId = reqAnimFrame(function () {
	                node.style.height = (show ? height : 0) + 'px';
	                node.style.opacity = show ? '1' : '0';
	            });
	        },
	        end: function end() {
	            if (requestAnimationFrameId) {
	                (0, _getRequestAnimationFrame.cancelRequestAnimationFrame)(requestAnimationFrameId);
	            }
	            node.style.height = '';
	            node.style.opacity = '';
	            done();
	        }
	    });
	}
	var animation = {
	    enter: function enter(node, done) {
	        return animate(node, true, done);
	    },
	    leave: function leave(node, done) {
	        return animate(node, false, done);
	    },
	    appear: function appear(node, done) {
	        return animate(node, true, done);
	    }
	};
	exports['default'] = animation;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _en_US = __webpack_require__(1156);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	var _en_US3 = __webpack_require__(387);
	
	var _en_US4 = _interopRequireDefault(_en_US3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Merge into a locale object
	var locale = {
	    lang: (0, _extends3['default'])({ placeholder: 'Select date', rangePlaceholder: ['Start date', 'End date'] }, _en_US2['default']),
	    timePickerLocale: (0, _extends3['default'])({}, _en_US4['default'])
	};
	// All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	exports['default'] = locale;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dropdown = __webpack_require__(589);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _dropdownButton = __webpack_require__(1464);
	
	var _dropdownButton2 = _interopRequireDefault(_dropdownButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_dropdown2['default'].Button = _dropdownButton2['default'];
	exports['default'] = _dropdown2['default'];

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.changeConfirmLocale = changeConfirmLocale;
	exports.getConfirmLocale = getConfirmLocale;
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var runtimeLocale = (0, _extends3['default'])({}, _default2['default'].Modal);
	function changeConfirmLocale(newLocale) {
	    if (newLocale) {
	        runtimeLocale = (0, _extends3['default'])({}, runtimeLocale, newLocale);
	    } else {
	        runtimeLocale = (0, _extends3['default'])({}, _default2['default'].Modal);
	    }
	}
	function getConfirmLocale() {
	    return runtimeLocale;
	}

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(1491);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Pagination2['default'];

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcCheckbox = __webpack_require__(1159);
	
	var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Radio = function (_React$Component) {
	    (0, _inherits3['default'])(Radio, _React$Component);
	
	    function Radio() {
	        (0, _classCallCheck3['default'])(this, Radio);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Radio.__proto__ || Object.getPrototypeOf(Radio)).apply(this, arguments));
	
	        _this.saveCheckbox = function (node) {
	            _this.rcCheckbox = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Radio, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState) || !(0, _shallowequal2['default'])(this.context.radioGroup, nextContext.radioGroup);
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.rcCheckbox.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcCheckbox.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var props = this.props,
	                context = this.context;
	
	            var prefixCls = props.prefixCls,
	                className = props.className,
	                children = props.children,
	                style = props.style,
	                restProps = __rest(props, ["prefixCls", "className", "children", "style"]);
	
	            var radioGroup = context.radioGroup;
	
	            var radioProps = (0, _extends3['default'])({}, restProps);
	            if (radioGroup) {
	                radioProps.name = radioGroup.name;
	                radioProps.onChange = radioGroup.onChange;
	                radioProps.checked = props.value === radioGroup.value;
	                radioProps.disabled = props.disabled || radioGroup.disabled;
	            }
	            var wrapperClassString = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-checked', radioProps.checked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-wrapper-disabled', radioProps.disabled), _classNames));
	            return React.createElement(
	                'label',
	                { className: wrapperClassString, style: style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave },
	                React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, radioProps, { prefixCls: prefixCls, ref: this.saveCheckbox })),
	                children !== undefined ? React.createElement(
	                    'span',
	                    null,
	                    children
	                ) : null
	            );
	        }
	    }]);
	    return Radio;
	}(React.Component);
	
	exports['default'] = Radio;
	
	Radio.defaultProps = {
	    prefixCls: 'ant-radio',
	    type: 'radio'
	};
	Radio.contextTypes = {
	    radioGroup: _propTypes2['default'].any
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _isCssAnimationSupported = __webpack_require__(1426);
	
	var _isCssAnimationSupported2 = _interopRequireDefault(_isCssAnimationSupported);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Spin = function (_React$Component) {
	    (0, _inherits3['default'])(Spin, _React$Component);
	
	    function Spin(props) {
	        (0, _classCallCheck3['default'])(this, Spin);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Spin.__proto__ || Object.getPrototypeOf(Spin)).call(this, props));
	
	        var spinning = props.spinning;
	        _this.state = {
	            spinning: spinning
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Spin, [{
	        key: 'isNestedPattern',
	        value: function isNestedPattern() {
	            return !!(this.props && this.props.children);
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (!(0, _isCssAnimationSupported2['default'])()) {
	                // Show text in IE9
	                this.setState({
	                    notCssAnimationSupported: true
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.debounceTimeout) {
	                clearTimeout(this.debounceTimeout);
	            }
	            if (this.delayTimeout) {
	                clearTimeout(this.delayTimeout);
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var currentSpinning = this.props.spinning;
	            var spinning = nextProps.spinning;
	            var delay = this.props.delay;
	
	            if (this.debounceTimeout) {
	                clearTimeout(this.debounceTimeout);
	            }
	            if (currentSpinning && !spinning) {
	                this.debounceTimeout = window.setTimeout(function () {
	                    return _this2.setState({ spinning: spinning });
	                }, 200);
	                if (this.delayTimeout) {
	                    clearTimeout(this.delayTimeout);
	                }
	            } else {
	                if (spinning && delay && !isNaN(Number(delay))) {
	                    if (this.delayTimeout) {
	                        clearTimeout(this.delayTimeout);
	                    }
	                    this.delayTimeout = window.setTimeout(function () {
	                        return _this2.setState({ spinning: spinning });
	                    }, delay);
	                } else {
	                    this.setState({ spinning: spinning });
	                }
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                className = _a.className,
	                size = _a.size,
	                prefixCls = _a.prefixCls,
	                tip = _a.tip,
	                wrapperClassName = _a.wrapperClassName,
	                indicator = _a.indicator,
	                restProps = __rest(_a, ["className", "size", "prefixCls", "tip", "wrapperClassName", "indicator"]);var _state = this.state,
	                spinning = _state.spinning,
	                notCssAnimationSupported = _state.notCssAnimationSupported;
	
	            var spinClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-spinning', spinning), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-text', !!tip || notCssAnimationSupported), _classNames), className);
	            // fix https://fb.me/react-unknown-prop
	            var divProps = (0, _omit2['default'])(restProps, ['spinning', 'delay']);
	            var spinIndicator = indicator ? indicator : React.createElement(
	                'span',
	                { className: prefixCls + '-dot' },
	                React.createElement('i', null),
	                React.createElement('i', null),
	                React.createElement('i', null),
	                React.createElement('i', null)
	            );
	            var spinElement = React.createElement(
	                'div',
	                (0, _extends3['default'])({}, divProps, { className: spinClassName }),
	                spinIndicator,
	                tip ? React.createElement(
	                    'div',
	                    { className: prefixCls + '-text' },
	                    tip
	                ) : null
	            );
	            if (this.isNestedPattern()) {
	                var _classNames2;
	
	                var animateClassName = prefixCls + '-nested-loading';
	                if (wrapperClassName) {
	                    animateClassName += ' ' + wrapperClassName;
	                }
	                var containerClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-container', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-blur', spinning), _classNames2));
	                return React.createElement(
	                    _rcAnimate2['default'],
	                    (0, _extends3['default'])({}, divProps, { component: 'div', className: animateClassName, style: null, transitionName: 'fade' }),
	                    spinning && React.createElement(
	                        'div',
	                        { key: 'loading' },
	                        spinElement
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: containerClassName, key: 'container' },
	                        this.props.children
	                    )
	                );
	            }
	            return spinElement;
	        }
	    }]);
	    return Spin;
	}(React.Component);
	
	exports['default'] = Spin;
	
	Spin.defaultProps = {
	    prefixCls: 'ant-spin',
	    spinning: true,
	    size: 'default',
	    wrapperClassName: ''
	};
	Spin.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    className: _propTypes2['default'].string,
	    spinning: _propTypes2['default'].bool,
	    size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
	    wrapperClassName: _propTypes2['default'].string,
	    indicator: _propTypes2['default'].node
	};

/***/ },
/* 387 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var locale = {
	    placeholder: 'Select time'
	};
	exports['default'] = locale;

/***/ },
/* 388 */
/***/ function(module, exports) {

	module.exports = { raw: '8.11.3' };


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var random = __webpack_require__(1570);
	var storage = __webpack_require__(1571);
	
	var DEFAULT_NAMESPACE = 'com.auth0.auth.';
	
	function TransactionManager(options) {
	  options = options || {};
	  this.namespace = options.namespace || DEFAULT_NAMESPACE;
	  this.keyLength = options.keyLength || 32;
	}
	
	TransactionManager.prototype.process = function(options) {
	  if (!options.responseType) {
	    throw new Error('responseType is required');
	  }
	  var responseTypeIncludesIdToken = options.responseType.indexOf('id_token') !== -1;
	
	  var transaction = this.generateTransaction(
	    options.appState,
	    options.state,
	    options.nonce,
	    responseTypeIncludesIdToken
	  );
	  if (!options.state) {
	    options.state = transaction.state;
	  }
	
	  if (responseTypeIncludesIdToken && !options.nonce) {
	    options.nonce = transaction.nonce;
	  }
	
	  return options;
	};
	
	TransactionManager.prototype.generateTransaction = function(appState, state, nonce, generateNonce) {
	  state = state || random.randomString(this.keyLength);
	  nonce = nonce || (generateNonce ? random.randomString(this.keyLength) : null);
	
	  storage.setItem(this.namespace + state, {
	    nonce: nonce,
	    appState: appState,
	    state: state
	  });
	
	  return {
	    state: state,
	    nonce: nonce
	  };
	};
	
	TransactionManager.prototype.getStoredTransaction = function(state) {
	  var transactionData;
	
	  transactionData = storage.getItem(this.namespace + state);
	  storage.removeItem(this.namespace + state);
	  return transactionData;
	};
	
	module.exports = TransactionManager;


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(77);
	var normalizeHeaderName = __webpack_require__(1599);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(731);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(731);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1605);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _iPhoneXMockup = __webpack_require__(3311);
	
	var _iPhoneXMockup2 = _interopRequireDefault(_iPhoneXMockup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AdPreview(props) {
	  var currentApp = props.currentApp,
	      secondApp = props.secondApp,
	      searchTerm = props.searchTerm;
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'exampleAdPreview' },
	      "广告预览"
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'exampleHolder' },
	      _react2.default.createElement(
	        'div',
	        { className: 'adExample__ad-example adExampleFull__ad-example' },
	        _react2.default.createElement('img', {
	          className: 'iPhone',
	          src: ("") + _iPhoneXMockup2.default
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'searchTerm__ad-example' },
	          searchTerm
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container__ad-example' },
	          _react2.default.createElement(
	            'div',
	            { className: 'app__ad-example isAd__ad-example' },
	            _react2.default.createElement(
	              'div',
	              { className: 'appSummary__ad-example' },
	              _react2.default.createElement(
	                'div',
	                { className: 'appThumbnail__ad-example' },
	                _react2.default.createElement('img', { src: currentApp.artworkUrl100, alt: "appIcon" })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'appDetail__ad-example' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'appName__ad-example' },
	                  currentApp.trackCensoredName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'publisher__ad-example' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'adSymbol__ad-example' },
	                      'Ad'
	                    ),
	                    currentApp.sellerName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'getButton__ad-example' },
	                "GET"
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'screenshotsContainer__ad-example' },
	              currentApp.screenshotUrls.slice(0, 3).map(function (url, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'screenshot__ad-example', key: index },
	                  _react2.default.createElement('img', { src: url, alt: "screen" })
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'app__ad-example' },
	            _react2.default.createElement(
	              'div',
	              { className: 'appSummary__ad-example' },
	              _react2.default.createElement(
	                'div',
	                { className: 'appThumbnail__ad-example' },
	                _react2.default.createElement('img', { src: secondApp.artworkUrl100, alt: "appIcon" })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'appDetail__ad-example' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'appName__ad-example' },
	                  secondApp.trackCensoredName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'publisher__ad-example' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    secondApp.sellerName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'getButton__ad-example' },
	                "GET"
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'screenshotsContainer__ad-example' },
	              secondApp.screenshotUrls.slice(0, 3).map(function (url, index) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'screenshot__ad-example', key: index },
	                  _react2.default.createElement('img', { src: url, alt: "screen" })
	                );
	              })
	            )
	          )
	        )
	      )
	    )
	  );
	} /**
	   *
	   * Header.js
	   *
	   * bladsfasdfas
	   */
	exports.default = AdPreview;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding-left: 60px;\n  padding-right: 60px;\n  background-color: rgba(60,211,207,1);\n  line-height: 38px;\n  font-family: \'Montserrat\';\n  font-size: 15px;\n  color: rgba(255,255,255,1);\n  text-align: center;\n  -webkit-letter-spacing: 0.01em;\n  -moz-letter-spacing: 0.01em;\n  -ms-letter-spacing: 0.01em;\n  letter-spacing: 0.01em;\n  border-radius: 20px;\n'], ['\n  padding-left: 60px;\n  padding-right: 60px;\n  background-color: rgba(60,211,207,1);\n  line-height: 38px;\n  font-family: \'Montserrat\';\n  font-size: 15px;\n  color: rgba(255,255,255,1);\n  text-align: center;\n  -webkit-letter-spacing: 0.01em;\n  -moz-letter-spacing: 0.01em;\n  -ms-letter-spacing: 0.01em;\n  letter-spacing: 0.01em;\n  border-radius: 20px;\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /**
	                                                                                                                                                   * A link to a certain page, an anchor tag
	                                                                                                                                                   */
	
	var ButtonAction = _styledComponents2.default.button(_templateObject);
	
	exports.default = ButtonAction;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1617);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Styles
	
	
	var OverlayLoading = function (_React$Component) {
	    _inherits(OverlayLoading, _React$Component);
	
	    function OverlayLoading(props) {
	        _classCallCheck(this, OverlayLoading);
	
	        var _this = _possibleConstructorReturn(this, (OverlayLoading.__proto__ || Object.getPrototypeOf(OverlayLoading)).call(this, props));
	
	        _this.renderType = props && props.renderAs || 'page';
	        _this.className = props && props.className || '';
	        return _this;
	    }
	
	    _createClass(OverlayLoading, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: this.renderType + ' ' + this.className },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'loader-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'ripple-effect' },
	                        _react2.default.createElement('div', null),
	                        _react2.default.createElement('div', null)
	                    ),
	                    '|'
	                )
	            );
	        }
	    }]);
	
	    return OverlayLoading;
	}(_react2.default.Component);
	
	exports.default = OverlayLoading;
	;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ButtonGroup = undefined;
	
	var _antd = __webpack_require__(43);
	
	var _button = __webpack_require__(1625);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AntButton = (0, _button.Buttons)(_antd.Button);
	var isoButton = (0, _withDirection2.default)(AntButton);
	var AntButtonGroup = (0, _button.ButtonsGroup)(_antd.Button.Group);
	var ButtonGroup = (0, _withDirection2.default)(AntButtonGroup);
	
	exports.default = isoButton;
	exports.ButtonGroup = ButtonGroup;

/***/ },
/* 395 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  apiUrl: 'http://yoursite.com/api/'
	};
	
	var siteConfig = {
	  siteName: 'ISOMORPHIC',
	  siteIcon: 'ion-flash',
	  footerText: 'Isomorphic ©2017 Created by RedQ, Inc'
	};
	
	var themeConfig = {
	  topbar: 'themedefault',
	  sidebar: 'themedefault',
	  layout: 'themedefault',
	  theme: 'themedefault'
	};
	var language = 'english';
	var AlgoliaSearchConfig = {
	  appId: '',
	  apiKey: ''
	};
	var Auth0Config = {
	  domain: '',
	  clientID: '', //
	  options: {
	    auth: {
	      autoParseHash: true,
	      redirect: false
	    },
	    languageDictionary: {
	      title: 'Isomorphic',
	      emailInputPlaceholder: 'demo@gmail.com',
	      passwordInputPlaceholder: 'demodemo'
	    },
	    icon: '',
	    theme: {
	      labeledSubmitButton: true,
	      logo: 'https://s3.amazonaws.com/redqteam.com/logo/isomorphic.png',
	      primaryColor: '#E14615',
	      authButtons: {
	        connectionName: {
	          displayName: 'Log In',
	          primaryColor: '#b7b7b7',
	          foregroundColor: '#000000',
	          icon: undefined
	        }
	      }
	    }
	  }
	};
	var firebaseConfig = {
	  apiKey: '',
	  authDomain: '',
	  databaseURL: '',
	  projectId: '',
	  storageBucket: '',
	  messagingSenderId: ''
	};
	var googleConfig = {
	  apiKey: '' //
	};
	var mapboxConfig = {
	  tileLayer: '',
	  maxZoom: '',
	  defaultZoom: '',
	  center: []
	};
	var youtubeSearchApi = '';
	exports.siteConfig = siteConfig;
	exports.themeConfig = themeConfig;
	exports.language = language;
	exports.AlgoliaSearchConfig = AlgoliaSearchConfig;
	exports.Auth0Config = Auth0Config;
	exports.firebaseConfig = firebaseConfig;
	exports.googleConfig = googleConfig;
	exports.mapboxConfig = mapboxConfig;
	exports.youtubeSearchApi = youtubeSearchApi;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DashboardWrapper = exports.WidgetColumn = exports.WidgetBox = exports.WidgetWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 10px;\n\n  @media only screen and (max-width: 767) {\n    margin-right: 0 !important;\n  }\n'], ['\n  margin: 0 10px;\n\n  @media only screen and (max-width: 767) {\n    margin-right: 0 !important;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  background-color: #ffffff;\n  border: 1px solid', ';\n\n  canvas {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .trackingAccount {\n    max-width: 180px;\n    max-height: 46px;\n    padding: 4px;\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n  padding: 30px;\n  background-color: #ffffff;\n  border: 1px solid', ';\n\n  canvas {\n    width: 100% !important;\n    height: 100% !important;\n  }\n\n  .trackingAccount {\n    max-width: 180px;\n    max-height: 46px;\n    padding: 4px;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['align-content: flex-start;'], ['align-content: flex-start;']),
	    _templateObject4 = _taggedTemplateLiteral(['\n\n.dashboard-tooltip {\n  display: inline-block;\n  margin-left: 4px;\n  border: 1px solid rgba(147, 147, 147, 1);\n  border-radius: 100%;\n  width: 14px; height: 14px;\n  line-height: 14px;\n  font-family: \'Montserrat\';\n  text-align: center;\n  font-size: .7em;\n  color: rgba(147, 147, 147, 1);\n}\n\n.exampleHolder > div {\n  margin-left: auto;\n  margin-right: auto; \n}\n@media (min-width: 768px) {\n  .exampleHolder {\n  position: absolute;\n  width: 80%;\n  right: 0;\n  } \n}\n\n.exampleHolder2 {\n  position: absolute;\n  padding: 6%;\n}\n\n@media (min-width: 850px) {\n  .exampleHolder {\n      // width: 100%; \n  } \n}\n\n.header {\n  position:relative;\n  background-color: rgba(35, 31, 32, 1);\n  padding: 29px;\n  .greenLogo{\n      margin-left: auto;\n      margin-right: auto;    \n      height: 77px;\n      width: 118px;\n  }\n  .greenLogo { height: auto; }\n}\n.header:after {\n  position: absolute;\n  display: inline-block;\n  content: \'\';\n  right: 0; bottom: -3px; left: 0;\n  height: 3px;\n  background-color: rgba(12, 183, 148, 1);\n  z-index: 1;\n}\n\n.footer {\n    background-color: rgba(35, 31, 32, 1);\n    padding: 17px;\n    .footerTitle{\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.07em;\n    }\n}\n\n.iPhone{\n  width: 100%;\n  backgroundImage: "url(" + { Background } + ")"\n  \n}\n\n\n.adExample__ad-example {\n  width: 100%;\n  max-width: 22rem;\n  overflow: hidden;\n  position: relative;\n  margin-top: 3rem;\n  }\n  @media (min-width: 768px) {\n    .adExample__ad-example {\n      margin-top: 0;\n      margin-right: 0; } }\n  @media (min-width: 1281px) {\n    .adExample__ad-example {\n      /* max-width: 24rem; */\n      } }\n  .adExample__ad-example.centered__ad-example {\n    margin-left: auto;\n    margin-right: auto; }\n\n\n\n.container__ad-example {\n  position: absolute;\n  top: 34.15133%;\n  width: 88.03030303030303%;\n  left: 6.1%; }\n\n.adExampleFull__ad-example .container__ad-example {\n  top: 18.759231905465288%; }\n\n.searchTerm__ad-example {\n  position: absolute;\n  top: 10.4%;\n  left: 18.2%;\n  font-size: 0.7rem; }\n  @media (min-width: 480px) {\n      .searchTerm__ad-example {\n      font-size: 0.8rem; } }\n\n\n.app__ad-example {\n  padding: 3.787878787878788%;\n  background: #fff; }\n  \n.app__ad-example.isAd__ad-example {\n  background: #EDF6FF; }\n\n\n.appSummary__ad-example {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.appThumbnail__ad-example {\n  width: 27.03583%;\n  margin-right: 2.9316%;\n  -ms-flex-negative: 0;\n      flex-shrink: 0; }\n.appThumbnail__ad-example > img {\n  border-radius: 16px; }\n\n.appName__ad-example {\n  font-size: 1.05em;\n  color: #333;\n  line-height: 1.2;\n  margin-bottom: 5px; }\n  \n.appDetail__ad-example {\n  font-family: "SF UI", helvetica, arial, sans-serif;\n  font-size: 0.75rem; }\n        \n.getButton__ad-example {\n  position: relative;\n  padding: 0.3rem 0.5rem;\n  border: 1px solid #3E90F4;\n  color: #3E90F4;\n  font-size: 0.65rem;\n  font-family: "SF UI", helvetica, arial, sans-serif;\n  border-radius: 3px;\n  line-height: 1; }\n  .getButton__ad-example::before {\n      content: \'+\';\n      position: absolute;\n      line-height: 1;\n      font-size: 7px;\n      font-weight: 400;\n      top: 0;\n      left: 1px; }\n\n.adSymbol__ad-example {\n  display: inline-block;\n  padding: 0 5px;\n  background: #8EC5FE;\n  color: #fff;\n  border-radius: 2px;\n  margin-right: 8px; }\n        \n.publisher__ad-example {\n  font-size: 0.9em;\n  color: #666;\n  line-height: 1.3;\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n  white-space: nowrap; }\n\n.publisher__ad-example > span {\n  display: table-cell;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.screenshotsContainer__ad-example {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 4.09%;\n  width: 100%;\n  padding-left: 10.3226%;\n  padding-right: 10.3226%; }\n  \n  .screenshot__ad-example {\n  width: 30%; }\n  .screenshot__ad-example > img {\n      width: 100%; }\n\n\n\n  // app name \n  .blackSection {\n    background-color: rgba(35, 31, 32, 1);\n    color: #fff;\n    position: relative;\n    z-index: 12;\n    .appDisplay__app-display {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n}\n\n\n\n.o-wrapper {\n    padding-top: 16px;\n\n    max-width: 1020px;\n    padding-right: 1.5rem;\n    padding-left: 1.5rem;\n    margin-right: auto;\n    margin-left: auto; }\n    @media (min-width: 768px) {\n      .o-wrapper {\n        padding-right: 40px;\n        padding-left: 40px; } }\n    @media (min-width: 1281px) {\n      .o-wrapper {\n        max-width: 1120px;\n        padding-right: 1.5rem;\n        padding-left: 1.5rem; } }\n\n.appDisplayImg__app-display {\n    padding-right: 0.75rem; }\n    .appDisplayImg__app-display > img {\n      border: 1px solid #D8D8D8;\n      width: 3.25rem;\n      height: 3.25rem;\n      max-width: none;\n      border-radius: 1rem; }\n    @media (min-width: 480px) {\n      .appDisplayImg__app-display {\n        padding-right: 1.5rem; }\n        .appDisplayImg__app-display > img {\n          width: 4.25rem;\n          height: 4.25rem; } }\n  \n.appName__app-display,\n.appLongName__app-display {\n    margin-top: 0px;\n\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    font-weight: 300;\n    color: rgba(255, 255, 255, 1);\n    text-align: left;\n    letter-spacing: 0.09em;\n    /*Text styles for S */\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    font-weight: 300;\n    color: rgba(255, 255, 255, 1);\n    text-align: left;\n}\n    // @media (min-width: 480px) {\n    //   .appName__app-display,\n    //   .appLongName__app-display {\n    //     font-size: 2rem; } }\n    // @media (min-width: 1281px) {\n    //   .appName__app-display,\n    //   .appLongName__app-display {\n    //     font-size: 2.25rem; } }\n  \n.appPublisher__app-display {\n    font-family: \'Montserrat\';\n    font-size: 14px;\n    color: rgba(255, 255, 255, 1);\n    text-align: left;\n    letter-spacing: 0.07em;\n    margin-top: 8px;\n\n}\n.appPublisher__app-display > span {\n    display: table-cell;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n@media (min-width: 480px) {\n    .appPublisher__app-display {\n    font-size: 1.2rem; } }\n  \n.appDisplayConcise__app-display .appDisplayImg__app-display {\npadding-right: 0.75rem; }\n.appDisplayConcise__app-display .appDisplayImg__app-display > img {\n    width: 36px;\n    height: 36px;\n    border-radius: 5px; }\n    // end of app name\n\n\n.responsiveBlock {\n  margin-bottom: 10px; \n  // width: 100%;  please use bootstrap element Row and Col instead\n\n  @media (min-width: 768px) {\n    // width: 48%; please use bootstrap element Row and Col instead\n  }\n  \n  @media (min-width: 1200px) {\n    // width: 24%; please use bootstrap element Row and Col instead\n  }\n}\n  \n  // -- Zay Modification\n  .round-border-wrapper {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0; padding: 0;\n    border: 1px solid rgba(255, 255, 255, 1);\n    width: 210px; height: 40px;\n    background-color: transparent;\n    line-height: 40px;\n    transition: .3s;\n    border-radius: 20px;\n\n    &.campaign-state { align-items: baseline; }\n\n    p {\n      display: inline-block;\n      font-family: \'Montserrat\';\n      font-size: 14px;\n      color: rgba(255, 255, 255, 1);\n      letter-spacing: 0.08em;\n    }\n  }\n  .round-border-wrapper:hover, .round-border-wrapper:focus {\n    background-color: rgba(255, 255, 255, .2);\n    opacity: 1;\n  }\n\n  .header {\n    padding-right: 64px;\n    padding-bottom: 13px;\n    padding-left: 55px;\n\n    .app {\n      display: inline-flex;\n      align-items: center;\n      width: calc(100% - 210px);\n      padding-right: 21px;\n\n      dt {\n        margin: 0;\n        min-width: 85px;\n        width: 85px;\n        height: 85px;\n        img { height: 78px; border-radius: 1rem; }\n      }\n\n      dd {s\n        margin: 0; margin-left: 11px;\n        padding: 0;\n        \n        h1 {\n          margin: 0;\n          font-family: \'Montserrat\';\n          font-size: 22px;\n          font-weight: 300;\n          color: rgba(255, 255, 255, 1);\n          letter-spacing: 0.09em;\n          text-transform: uppercase;\n        }\n\n        h2 {\n          margin: 0; margin-top: 8px;\n          span { display: inline-block; }\n          span:first-child {\n            padding-right: 14px;\n            border-right: 1px solid rgba(255, 255, 255, 1);\n            font-family: \'Montserrat-Light\';\n            font-size: 14px;\n            color: rgba(255, 255, 255, 1);\n            letter-spacing: 0.07em;\n          }\n          span:last-child {\n            padding-left: 14px;\n            font-family: \'Montserrat-Light\';\n            font-size: 14px;\n            color: rgba(255, 255, 255, 1);\n          }\n        }\n      }\n\n      // -- .app\n    }\n\n    button.round-border-wrapper {\n      p {\n        overflow: hidden;\n        white-space: nowrap;\n      }\n      .emulate-plus {\n        margin-right: 12px;\n        position: relative;\n        display: inline-flex;\n        width: 13px; height: 13px;\n      }\n      .emulate-plus:before, .emulate-plus:after {\n        position: absolute;\n        display: inline-block;\n        content: \'\';\n        background-color: rgba(255, 255, 255, 1);\n      }\n      .emulate-plus:before {\n        top: 50%; right: 0; left: 0;\n        height: 1px;\n        transform: translateY(-1px);\n      }\n      .emulate-plus:after {\n        top: 0; left: 50%; bottom: 0;\n        width: 1px;\n        transform: translateX(-1px);\n      }\n    }\n\n    .header-controls {\n      display: flex;\n      align-items: center;\n      border: 1px solid rgba(230, 230, 230, 0.5);\n      padding: 19px 44px 20px 40px;\n      border-radius: 7px;\n\n      dl {\n        margin: 0; padding: 0;\n        flex-grow: 1;\n\n        dt {\n          font-family: \'Montserrat\';\n          font-size: 14px;\n          color: rgba(255, 255, 255, 1);\n          letter-spacing: 0.07em;\n        }\n\n        dd {\n          font-family: \'Montserrat\';\n          font-size: 30px;\n          color: rgba(255, 255, 255, 1);\n          letter-spacing: 0.08em;\n        }\n      }\n\n      button {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(255, 255, 255, 1);\n\n        .emulate-plus { margin-right: 0; width: 8px; height: 8px; }\n        p { margin-left: 10px; }\n        img { margin-right: 12px; }\n        img + p { margin-left: 0; }\n      }\n      button:not(:first-of-type) { margin-left: 24px; }\n      button:first-of-type { width: 181px; }\n      button:first-of-type + button { width: 161px; img { width: 10px; } }\n      button:last-of-type { width: 160px; img { width: 13px; } }\n    }\n    // -- .header\n  }\n\n  .main {\n    margin: 0;\n    padding: 29px 64px 42px 55px !important;\n\n    .charts > .chart-controls {\n      display: flex;\n      align-items: center;\n      margin-bottom: 17px;\n\n      .round-border-wrapper {\n        border-color: rgba(151, 151, 151, 1);\n        background-color: transparent;\n        cursor: pointer;\n\n        img { margin-right: 11px; }\n        p, p a {\n          font-family: \'Montserrat\';\n          font-size: 15px;\n          color: rgba(35, 31, 32, 1);\n          text-align: center;\n          letter-spacing: 0.01em;\n          overflow: hidden;\n          white-space: nowrap;\n        }\n        p:only-child, a:only-child { display: block; width: 100%; line-height: 40px; text-decoration: none; }\n\n        :not(.countries) { margin-left: 22px; }\n\n        .dashboard-tooltip {\n          position: absolute;\n          top: -18px;\n          right: -8px;\n        }\n      }\n      .round-border-wrapper:hover, .round-border-wrapper:focus { background-color: rgba(100, 100, 100, .1); }\n\n      .countries { width: 199px; }\n      .download { width: 246px; img { height: 18px; } }\n\n      .round-border-wrapper.date-range {\n        position: relative;\n        width: 314px;\n\n        img { height: 21px; }\n        .isoCalendarDatePicker {\n          position: absolute;\n          top: 0; right: 0; bottom: 0; left: 0;\n          z-index: 999;\n          \n          .DateRangePicker { width: 100%; }\n          .DateRangePickerInput {\n            position: relative;\n            width: 100%; height: 40px;\n            overflow: hidden;\n            opacity: 0;\n\n            .DateInput:first-child {\n              position: absolute;\n              top: 0; right: 0; bottom: 0; left: 0;\n              width: 100%;\n              z-index: 999;\n\n              p { display: none; }\n            }\n            input { cursor: pointer; }\n          }\n\n          .DateRangePicker_picker { margin-top: -28px; }\n        }\n      }\n\n      // -- .chart-controls\n    }\n\n    .charts {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      align-content: flex-start;\n      // margin-bottom: 30px !important;\n\n      > * {\n        display: inline-block;\n        margin: 0;\n        padding: 0;\n      }\n      > :not(:last-child) {\n\n        // NOTE: removed by tom : sorry nth child styling is not easy to be extended. please use class base styling instead\n        // width: 24%;\n\n        .isoSaleWidget {\n          .isoSalePrice { line-height: 66px; font-size: 45px;}\n          .isoSaleDetails { margin-top: 19px; img { margin-left: 7px; height: 14px; cursor: pointer; } }\n\n          \n        }\n      }\n      > :last-child { \n        // margin-top: 30px; \n        width: 100%; \n       \n       }\n\n      .isoExampleWrapper {\n        margin-top: 0;\n        .rc-tabs { width: 100%; }\n      }\n      .rc-tabs-nav {\n        .rc-tabs-ink-bar { height: 0; opacity: 0; }\n        .rc-tabs-tab {\n          position: relative;\n          flex-basis: auto !important;\n          padding-right: 48px; padding-left: 40px;\n          line-height: 38px;\n          font-family: \'Montserrat\';\n          font-size: 12px;\n          color: rgba(147, 147, 147, 1);\n          letter-spacing: 0.08em;\n\n          :before {\n            position: absolute;\n            top: 0; right: 0; left: 0;\n            display: inline-block;\n            content: \'\';\n            height: 4px;\n          }\n        }\n        .rc-tabs-tab:nth-child(2):before { background-color: rgba(71, 178, 170, 1); }\n        .rc-tabs-tab:nth-child(3):before { background-color: rgba(93, 215, 255, 1); }\n        .rc-tabs-tab:nth-child(4):before { background-color: rgba(236, 184, 92, 1); }\n        .rc-tabs-tab:nth-child(5):before { background-color: rgba(114, 90, 166, 1); }\n\n        .rc-tabs-tab-active { font-weight: 700; color: rgba(64, 55, 57, 1); }\n      }\n\n      .rc-tabs-content canvas { margin: 12px 29px 20px 40px; width: calc(100% - 69px) !important; height: 344px !important; }\n      // -- charts\n    }\n\n    // .charts + * { \n    //   margin-bottom: 30px !important; \n    // }\n\n    .iphone-container { .exampleAdPreview { padding-top: 11px; padding-bottom: 21px; } }\n    .iphone-container .isoExampleWrapper {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: -13px;  \n\n      .exampleHolder2 { display: none; }\n      .exampleHolder {\n        position: relative;\n        width: 95%;\n\n        .searchTerm__ad-example { top: 9.9%; }\n        .container__ad-example { top: 15.4%; }\n      }\n    }\n\n    .tap-through-container {\n      display: flex;\n      \n      .tap-through-chart {\n        max-width: 150px;\n      }\n\n      .isoWidgetsWrapper {\n        margin: 0;\n        width: 100%;\n        padding: 0;\n\n        .isoBoxWrapper {\n          margin: 0;\n          padding: 0;\n\n          .isoExampleWrapper {\n            position: relative;\n            display: block;\n            margin-top: 0;\n            text-align: center;\n\n            label {\n              font-family: \'Montserrat\';\n              font-size: 14px;\n              color: rgba(64, 55, 57, 1);\n              text-align: left;\n              letter-spacing: 0.04em;\n              display: -webkit-inline-box;\n\n              span {\n                  display: inline-block;\n                  margin-left: 4px;\n                  border: 1px solid rgba(147, 147, 147, 1);\n                  border-radius: 100%;\n                  width: 14px; height: 14px;\n                  line-height: 14px;\n                  font-family: \'Montserrat\';\n                  text-align: center;\n                  font-size: .7em;\n                  color: rgba(147, 147, 147, 1);\n              }\n            }\n            .percentage {\n              position: absolute;\n              top: 50%; left: 50%;\n              transform: translateX(-50%) translateY(-50%);\n            }\n          }\n        }\n      }\n      // -- .tap-through-container\n    }\n\n    .tracking-accounts {\n      .isoWidgetsWrapper {\n        margin: 0;\n        margin-left: 10px;\n\n        .isoWidgetBox {\n          padding: 46px 38px 0 38px;\n          height: auto !important;\n\n          .isoExampleWrapper {\n            margin-top: 0;\n\n            .firstLine {\n              font-family: \'Montserrat\';\n              font-size: 17px;\n              color: rgba(64, 55, 57, 1);\n              letter-spacing: 0.03em;\n            }\n            .secondLine {\n              font-family: \'Montserrat\';\n              font-size: 17px;\n              color: rgba(147, 147, 147, 1);\n              text-align: center;\n              letter-spacing: 0.03em;\n            }\n            .thirdLine {\n              margin-top: 39px;\n              text-align: center;\n\n              img {\n                margin-bottom: 35px;\n                width: auto; max-width: none;\n                max-height: none;\n              }\n\n              .acc-flyer,\n              .acc-adjust,\n              .acc-tune,\n              .acc-kochava {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n              }\n\n              .acc-flyer img { height: 41px; }\n              .acc-adjust img { height: 75px; }\n              .acc-tune img { height: 35px; }\n              .acc-kochava img { height: 34px; }\n\n              // -- .thirdLine\n            }\n          }\n        }\n      }\n      // -- .tracking-accounts\n    }\n    // -- .main\n  }\n\n  @media screen and (max-width: 767px) {\n    .header {\n      margin-top: -1px;\n      padding-top: 11px;\n      padding-right: 16px;\n      padding-left: 16px;\n\n      .app {\n        margin: 0; padding: 0;\n        width: calc(100% - 30px);\n        padding-right: 4px;\n\n        dt { min-width: 64px; width: 64px; height: 64px; img { height: 64px; }}\n        dd {\n          margin-left: 13px;\n\n          h1 {\n            font-family: \'Montserrat\';\n            font-size: 22px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            text-align: left;\n            letter-spacing: 0.09em;\n          }\n          h2 {\n            span:not(p):not(:only-child) {\n              display: block;\n              margin: 0; padding: 0;\n              font-family: \'Montserrat\';\n              font-size: 12px;\n              color: rgba(255, 255, 255, 1);\n              text-align: left;\n            }\n            span:first-child:not(:only-child) { margin-bottom: 2px; border-width: 0; }\n          }\n        }\n\n        ~ button {\n          display: flex;\n          position: relative;\n          left: 100%;\n          width: 26px; height: 26px;\n          border-radius: 26px;\n          transform: translateX(-100%);\n  \n          .emulate-plus { margin: 0 auto; }\n          p { display: none; }\n        }\n        // -- .app\n      }\n\n      .header-controls {\n        margin-top: 15px;\n        padding: 19px 13px 18px 16px;\n\n        .round-border-wrapper:not(:only-child):not(:first-child) {\n          width: 40px; height: 40px;\n          border-radius: 40px;\n\n          :not(first-of-type) { margin-left: 6px; }\n          img { margin: 0; }\n          p { display: none; }\n        }\n      }\n      // -- .header\n    }\n\n    .main {\n      padding-right: 16px !important;\n      padding-left: 16px !important;\n\n      .charts {\n        > :not(:last-child) { margin-bottom: 10px; width: 100%; }\n        //> :last-child { display: none; }\n\n        .chart-controls {\n          flex-wrap: wrap;\n          .round-border-wrapper:not(:only-child) {\n            margin: 0;\n            width: 100%;\n            :first-of-type { margin-bottom: 14px; }\n          }\n\n          .download { display: none; }\n        }\n      }\n\n      .tracking-accounts {\n        .isoWidgetsWrapper {\n          margin: 0;\n          \n          .isoWidgetBox {\n            .isoExampleWrapper {\n              .thirdLine {\n                img { margin-bottom: 20px; }\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 480px) {\n    .header .app dd h1 { font-size: 16px; }\n    .header .app dd h2 > :not(p):not(:only-child):first-child { display: none; }\n\n    .header .header-controls {\n      dl dd { font-size: 21px; }\n\n      .round-border-wrapper {\n        position: relative;\n        display: block;\n        justify-content: unset;\n        align-items: unset;\n      }\n      .round-border-wrapper > * {\n        position: absolute !important;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n      \n      .add-budget > :first-child {\n        transform: translate(-100%, -50%);\n\n        + * { transform: translate(10%, -50%); }\n      }\n      \n      .campaign-state > :first-child { left: 50%; }\n    }\n  }\n  // -- /.Zay Modification\n\n  // to make charts resusable , no need to put charts inside main\n  // to make \n  \n\n\n\n\n'], ['\n\n.dashboard-tooltip {\n  display: inline-block;\n  margin-left: 4px;\n  border: 1px solid rgba(147, 147, 147, 1);\n  border-radius: 100%;\n  width: 14px; height: 14px;\n  line-height: 14px;\n  font-family: \'Montserrat\';\n  text-align: center;\n  font-size: .7em;\n  color: rgba(147, 147, 147, 1);\n}\n\n.exampleHolder > div {\n  margin-left: auto;\n  margin-right: auto; \n}\n@media (min-width: 768px) {\n  .exampleHolder {\n  position: absolute;\n  width: 80%;\n  right: 0;\n  } \n}\n\n.exampleHolder2 {\n  position: absolute;\n  padding: 6%;\n}\n\n@media (min-width: 850px) {\n  .exampleHolder {\n      // width: 100%; \n  } \n}\n\n.header {\n  position:relative;\n  background-color: rgba(35, 31, 32, 1);\n  padding: 29px;\n  .greenLogo{\n      margin-left: auto;\n      margin-right: auto;    \n      height: 77px;\n      width: 118px;\n  }\n  .greenLogo { height: auto; }\n}\n.header:after {\n  position: absolute;\n  display: inline-block;\n  content: \'\';\n  right: 0; bottom: -3px; left: 0;\n  height: 3px;\n  background-color: rgba(12, 183, 148, 1);\n  z-index: 1;\n}\n\n.footer {\n    background-color: rgba(35, 31, 32, 1);\n    padding: 17px;\n    .footerTitle{\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.07em;\n    }\n}\n\n.iPhone{\n  width: 100%;\n  backgroundImage: "url(" + { Background } + ")"\n  \n}\n\n\n.adExample__ad-example {\n  width: 100%;\n  max-width: 22rem;\n  overflow: hidden;\n  position: relative;\n  margin-top: 3rem;\n  }\n  @media (min-width: 768px) {\n    .adExample__ad-example {\n      margin-top: 0;\n      margin-right: 0; } }\n  @media (min-width: 1281px) {\n    .adExample__ad-example {\n      /* max-width: 24rem; */\n      } }\n  .adExample__ad-example.centered__ad-example {\n    margin-left: auto;\n    margin-right: auto; }\n\n\n\n.container__ad-example {\n  position: absolute;\n  top: 34.15133%;\n  width: 88.03030303030303%;\n  left: 6.1%; }\n\n.adExampleFull__ad-example .container__ad-example {\n  top: 18.759231905465288%; }\n\n.searchTerm__ad-example {\n  position: absolute;\n  top: 10.4%;\n  left: 18.2%;\n  font-size: 0.7rem; }\n  @media (min-width: 480px) {\n      .searchTerm__ad-example {\n      font-size: 0.8rem; } }\n\n\n.app__ad-example {\n  padding: 3.787878787878788%;\n  background: #fff; }\n  \n.app__ad-example.isAd__ad-example {\n  background: #EDF6FF; }\n\n\n.appSummary__ad-example {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n\n.appThumbnail__ad-example {\n  width: 27.03583%;\n  margin-right: 2.9316%;\n  -ms-flex-negative: 0;\n      flex-shrink: 0; }\n.appThumbnail__ad-example > img {\n  border-radius: 16px; }\n\n.appName__ad-example {\n  font-size: 1.05em;\n  color: #333;\n  line-height: 1.2;\n  margin-bottom: 5px; }\n  \n.appDetail__ad-example {\n  font-family: "SF UI", helvetica, arial, sans-serif;\n  font-size: 0.75rem; }\n        \n.getButton__ad-example {\n  position: relative;\n  padding: 0.3rem 0.5rem;\n  border: 1px solid #3E90F4;\n  color: #3E90F4;\n  font-size: 0.65rem;\n  font-family: "SF UI", helvetica, arial, sans-serif;\n  border-radius: 3px;\n  line-height: 1; }\n  .getButton__ad-example::before {\n      content: \'+\';\n      position: absolute;\n      line-height: 1;\n      font-size: 7px;\n      font-weight: 400;\n      top: 0;\n      left: 1px; }\n\n.adSymbol__ad-example {\n  display: inline-block;\n  padding: 0 5px;\n  background: #8EC5FE;\n  color: #fff;\n  border-radius: 2px;\n  margin-right: 8px; }\n        \n.publisher__ad-example {\n  font-size: 0.9em;\n  color: #666;\n  line-height: 1.3;\n  display: table;\n  table-layout: fixed;\n  width: 100%;\n  white-space: nowrap; }\n\n.publisher__ad-example > span {\n  display: table-cell;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.screenshotsContainer__ad-example {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  margin-top: 4.09%;\n  width: 100%;\n  padding-left: 10.3226%;\n  padding-right: 10.3226%; }\n  \n  .screenshot__ad-example {\n  width: 30%; }\n  .screenshot__ad-example > img {\n      width: 100%; }\n\n\n\n  // app name \n  .blackSection {\n    background-color: rgba(35, 31, 32, 1);\n    color: #fff;\n    position: relative;\n    z-index: 12;\n    .appDisplay__app-display {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n}\n\n\n\n.o-wrapper {\n    padding-top: 16px;\n\n    max-width: 1020px;\n    padding-right: 1.5rem;\n    padding-left: 1.5rem;\n    margin-right: auto;\n    margin-left: auto; }\n    @media (min-width: 768px) {\n      .o-wrapper {\n        padding-right: 40px;\n        padding-left: 40px; } }\n    @media (min-width: 1281px) {\n      .o-wrapper {\n        max-width: 1120px;\n        padding-right: 1.5rem;\n        padding-left: 1.5rem; } }\n\n.appDisplayImg__app-display {\n    padding-right: 0.75rem; }\n    .appDisplayImg__app-display > img {\n      border: 1px solid #D8D8D8;\n      width: 3.25rem;\n      height: 3.25rem;\n      max-width: none;\n      border-radius: 1rem; }\n    @media (min-width: 480px) {\n      .appDisplayImg__app-display {\n        padding-right: 1.5rem; }\n        .appDisplayImg__app-display > img {\n          width: 4.25rem;\n          height: 4.25rem; } }\n  \n.appName__app-display,\n.appLongName__app-display {\n    margin-top: 0px;\n\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    font-weight: 300;\n    color: rgba(255, 255, 255, 1);\n    text-align: left;\n    letter-spacing: 0.09em;\n    /*Text styles for S */\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    font-weight: 300;\n    color: rgba(255, 255, 255, 1);\n    text-align: left;\n}\n    // @media (min-width: 480px) {\n    //   .appName__app-display,\n    //   .appLongName__app-display {\n    //     font-size: 2rem; } }\n    // @media (min-width: 1281px) {\n    //   .appName__app-display,\n    //   .appLongName__app-display {\n    //     font-size: 2.25rem; } }\n  \n.appPublisher__app-display {\n    font-family: \'Montserrat\';\n    font-size: 14px;\n    color: rgba(255, 255, 255, 1);\n    text-align: left;\n    letter-spacing: 0.07em;\n    margin-top: 8px;\n\n}\n.appPublisher__app-display > span {\n    display: table-cell;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n@media (min-width: 480px) {\n    .appPublisher__app-display {\n    font-size: 1.2rem; } }\n  \n.appDisplayConcise__app-display .appDisplayImg__app-display {\npadding-right: 0.75rem; }\n.appDisplayConcise__app-display .appDisplayImg__app-display > img {\n    width: 36px;\n    height: 36px;\n    border-radius: 5px; }\n    // end of app name\n\n\n.responsiveBlock {\n  margin-bottom: 10px; \n  // width: 100%;  please use bootstrap element Row and Col instead\n\n  @media (min-width: 768px) {\n    // width: 48%; please use bootstrap element Row and Col instead\n  }\n  \n  @media (min-width: 1200px) {\n    // width: 24%; please use bootstrap element Row and Col instead\n  }\n}\n  \n  // -- Zay Modification\n  .round-border-wrapper {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0; padding: 0;\n    border: 1px solid rgba(255, 255, 255, 1);\n    width: 210px; height: 40px;\n    background-color: transparent;\n    line-height: 40px;\n    transition: .3s;\n    border-radius: 20px;\n\n    &.campaign-state { align-items: baseline; }\n\n    p {\n      display: inline-block;\n      font-family: \'Montserrat\';\n      font-size: 14px;\n      color: rgba(255, 255, 255, 1);\n      letter-spacing: 0.08em;\n    }\n  }\n  .round-border-wrapper:hover, .round-border-wrapper:focus {\n    background-color: rgba(255, 255, 255, .2);\n    opacity: 1;\n  }\n\n  .header {\n    padding-right: 64px;\n    padding-bottom: 13px;\n    padding-left: 55px;\n\n    .app {\n      display: inline-flex;\n      align-items: center;\n      width: calc(100% - 210px);\n      padding-right: 21px;\n\n      dt {\n        margin: 0;\n        min-width: 85px;\n        width: 85px;\n        height: 85px;\n        img { height: 78px; border-radius: 1rem; }\n      }\n\n      dd {s\n        margin: 0; margin-left: 11px;\n        padding: 0;\n        \n        h1 {\n          margin: 0;\n          font-family: \'Montserrat\';\n          font-size: 22px;\n          font-weight: 300;\n          color: rgba(255, 255, 255, 1);\n          letter-spacing: 0.09em;\n          text-transform: uppercase;\n        }\n\n        h2 {\n          margin: 0; margin-top: 8px;\n          span { display: inline-block; }\n          span:first-child {\n            padding-right: 14px;\n            border-right: 1px solid rgba(255, 255, 255, 1);\n            font-family: \'Montserrat-Light\';\n            font-size: 14px;\n            color: rgba(255, 255, 255, 1);\n            letter-spacing: 0.07em;\n          }\n          span:last-child {\n            padding-left: 14px;\n            font-family: \'Montserrat-Light\';\n            font-size: 14px;\n            color: rgba(255, 255, 255, 1);\n          }\n        }\n      }\n\n      // -- .app\n    }\n\n    button.round-border-wrapper {\n      p {\n        overflow: hidden;\n        white-space: nowrap;\n      }\n      .emulate-plus {\n        margin-right: 12px;\n        position: relative;\n        display: inline-flex;\n        width: 13px; height: 13px;\n      }\n      .emulate-plus:before, .emulate-plus:after {\n        position: absolute;\n        display: inline-block;\n        content: \'\';\n        background-color: rgba(255, 255, 255, 1);\n      }\n      .emulate-plus:before {\n        top: 50%; right: 0; left: 0;\n        height: 1px;\n        transform: translateY(-1px);\n      }\n      .emulate-plus:after {\n        top: 0; left: 50%; bottom: 0;\n        width: 1px;\n        transform: translateX(-1px);\n      }\n    }\n\n    .header-controls {\n      display: flex;\n      align-items: center;\n      border: 1px solid rgba(230, 230, 230, 0.5);\n      padding: 19px 44px 20px 40px;\n      border-radius: 7px;\n\n      dl {\n        margin: 0; padding: 0;\n        flex-grow: 1;\n\n        dt {\n          font-family: \'Montserrat\';\n          font-size: 14px;\n          color: rgba(255, 255, 255, 1);\n          letter-spacing: 0.07em;\n        }\n\n        dd {\n          font-family: \'Montserrat\';\n          font-size: 30px;\n          color: rgba(255, 255, 255, 1);\n          letter-spacing: 0.08em;\n        }\n      }\n\n      button {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(255, 255, 255, 1);\n\n        .emulate-plus { margin-right: 0; width: 8px; height: 8px; }\n        p { margin-left: 10px; }\n        img { margin-right: 12px; }\n        img + p { margin-left: 0; }\n      }\n      button:not(:first-of-type) { margin-left: 24px; }\n      button:first-of-type { width: 181px; }\n      button:first-of-type + button { width: 161px; img { width: 10px; } }\n      button:last-of-type { width: 160px; img { width: 13px; } }\n    }\n    // -- .header\n  }\n\n  .main {\n    margin: 0;\n    padding: 29px 64px 42px 55px !important;\n\n    .charts > .chart-controls {\n      display: flex;\n      align-items: center;\n      margin-bottom: 17px;\n\n      .round-border-wrapper {\n        border-color: rgba(151, 151, 151, 1);\n        background-color: transparent;\n        cursor: pointer;\n\n        img { margin-right: 11px; }\n        p, p a {\n          font-family: \'Montserrat\';\n          font-size: 15px;\n          color: rgba(35, 31, 32, 1);\n          text-align: center;\n          letter-spacing: 0.01em;\n          overflow: hidden;\n          white-space: nowrap;\n        }\n        p:only-child, a:only-child { display: block; width: 100%; line-height: 40px; text-decoration: none; }\n\n        :not(.countries) { margin-left: 22px; }\n\n        .dashboard-tooltip {\n          position: absolute;\n          top: -18px;\n          right: -8px;\n        }\n      }\n      .round-border-wrapper:hover, .round-border-wrapper:focus { background-color: rgba(100, 100, 100, .1); }\n\n      .countries { width: 199px; }\n      .download { width: 246px; img { height: 18px; } }\n\n      .round-border-wrapper.date-range {\n        position: relative;\n        width: 314px;\n\n        img { height: 21px; }\n        .isoCalendarDatePicker {\n          position: absolute;\n          top: 0; right: 0; bottom: 0; left: 0;\n          z-index: 999;\n          \n          .DateRangePicker { width: 100%; }\n          .DateRangePickerInput {\n            position: relative;\n            width: 100%; height: 40px;\n            overflow: hidden;\n            opacity: 0;\n\n            .DateInput:first-child {\n              position: absolute;\n              top: 0; right: 0; bottom: 0; left: 0;\n              width: 100%;\n              z-index: 999;\n\n              p { display: none; }\n            }\n            input { cursor: pointer; }\n          }\n\n          .DateRangePicker_picker { margin-top: -28px; }\n        }\n      }\n\n      // -- .chart-controls\n    }\n\n    .charts {\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: space-between;\n      align-content: flex-start;\n      // margin-bottom: 30px !important;\n\n      > * {\n        display: inline-block;\n        margin: 0;\n        padding: 0;\n      }\n      > :not(:last-child) {\n\n        // NOTE: removed by tom : sorry nth child styling is not easy to be extended. please use class base styling instead\n        // width: 24%;\n\n        .isoSaleWidget {\n          .isoSalePrice { line-height: 66px; font-size: 45px;}\n          .isoSaleDetails { margin-top: 19px; img { margin-left: 7px; height: 14px; cursor: pointer; } }\n\n          \n        }\n      }\n      > :last-child { \n        // margin-top: 30px; \n        width: 100%; \n       \n       }\n\n      .isoExampleWrapper {\n        margin-top: 0;\n        .rc-tabs { width: 100%; }\n      }\n      .rc-tabs-nav {\n        .rc-tabs-ink-bar { height: 0; opacity: 0; }\n        .rc-tabs-tab {\n          position: relative;\n          flex-basis: auto !important;\n          padding-right: 48px; padding-left: 40px;\n          line-height: 38px;\n          font-family: \'Montserrat\';\n          font-size: 12px;\n          color: rgba(147, 147, 147, 1);\n          letter-spacing: 0.08em;\n\n          :before {\n            position: absolute;\n            top: 0; right: 0; left: 0;\n            display: inline-block;\n            content: \'\';\n            height: 4px;\n          }\n        }\n        .rc-tabs-tab:nth-child(2):before { background-color: rgba(71, 178, 170, 1); }\n        .rc-tabs-tab:nth-child(3):before { background-color: rgba(93, 215, 255, 1); }\n        .rc-tabs-tab:nth-child(4):before { background-color: rgba(236, 184, 92, 1); }\n        .rc-tabs-tab:nth-child(5):before { background-color: rgba(114, 90, 166, 1); }\n\n        .rc-tabs-tab-active { font-weight: 700; color: rgba(64, 55, 57, 1); }\n      }\n\n      .rc-tabs-content canvas { margin: 12px 29px 20px 40px; width: calc(100% - 69px) !important; height: 344px !important; }\n      // -- charts\n    }\n\n    // .charts + * { \n    //   margin-bottom: 30px !important; \n    // }\n\n    .iphone-container { .exampleAdPreview { padding-top: 11px; padding-bottom: 21px; } }\n    .iphone-container .isoExampleWrapper {\n      display: flex;\n      justify-content: flex-end;\n      margin-top: -13px;  \n\n      .exampleHolder2 { display: none; }\n      .exampleHolder {\n        position: relative;\n        width: 95%;\n\n        .searchTerm__ad-example { top: 9.9%; }\n        .container__ad-example { top: 15.4%; }\n      }\n    }\n\n    .tap-through-container {\n      display: flex;\n      \n      .tap-through-chart {\n        max-width: 150px;\n      }\n\n      .isoWidgetsWrapper {\n        margin: 0;\n        width: 100%;\n        padding: 0;\n\n        .isoBoxWrapper {\n          margin: 0;\n          padding: 0;\n\n          .isoExampleWrapper {\n            position: relative;\n            display: block;\n            margin-top: 0;\n            text-align: center;\n\n            label {\n              font-family: \'Montserrat\';\n              font-size: 14px;\n              color: rgba(64, 55, 57, 1);\n              text-align: left;\n              letter-spacing: 0.04em;\n              display: -webkit-inline-box;\n\n              span {\n                  display: inline-block;\n                  margin-left: 4px;\n                  border: 1px solid rgba(147, 147, 147, 1);\n                  border-radius: 100%;\n                  width: 14px; height: 14px;\n                  line-height: 14px;\n                  font-family: \'Montserrat\';\n                  text-align: center;\n                  font-size: .7em;\n                  color: rgba(147, 147, 147, 1);\n              }\n            }\n            .percentage {\n              position: absolute;\n              top: 50%; left: 50%;\n              transform: translateX(-50%) translateY(-50%);\n            }\n          }\n        }\n      }\n      // -- .tap-through-container\n    }\n\n    .tracking-accounts {\n      .isoWidgetsWrapper {\n        margin: 0;\n        margin-left: 10px;\n\n        .isoWidgetBox {\n          padding: 46px 38px 0 38px;\n          height: auto !important;\n\n          .isoExampleWrapper {\n            margin-top: 0;\n\n            .firstLine {\n              font-family: \'Montserrat\';\n              font-size: 17px;\n              color: rgba(64, 55, 57, 1);\n              letter-spacing: 0.03em;\n            }\n            .secondLine {\n              font-family: \'Montserrat\';\n              font-size: 17px;\n              color: rgba(147, 147, 147, 1);\n              text-align: center;\n              letter-spacing: 0.03em;\n            }\n            .thirdLine {\n              margin-top: 39px;\n              text-align: center;\n\n              img {\n                margin-bottom: 35px;\n                width: auto; max-width: none;\n                max-height: none;\n              }\n\n              .acc-flyer,\n              .acc-adjust,\n              .acc-tune,\n              .acc-kochava {\n                display: flex;\n                flex-direction: column;\n                justify-content: center;\n                align-items: center;\n              }\n\n              .acc-flyer img { height: 41px; }\n              .acc-adjust img { height: 75px; }\n              .acc-tune img { height: 35px; }\n              .acc-kochava img { height: 34px; }\n\n              // -- .thirdLine\n            }\n          }\n        }\n      }\n      // -- .tracking-accounts\n    }\n    // -- .main\n  }\n\n  @media screen and (max-width: 767px) {\n    .header {\n      margin-top: -1px;\n      padding-top: 11px;\n      padding-right: 16px;\n      padding-left: 16px;\n\n      .app {\n        margin: 0; padding: 0;\n        width: calc(100% - 30px);\n        padding-right: 4px;\n\n        dt { min-width: 64px; width: 64px; height: 64px; img { height: 64px; }}\n        dd {\n          margin-left: 13px;\n\n          h1 {\n            font-family: \'Montserrat\';\n            font-size: 22px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            text-align: left;\n            letter-spacing: 0.09em;\n          }\n          h2 {\n            span:not(p):not(:only-child) {\n              display: block;\n              margin: 0; padding: 0;\n              font-family: \'Montserrat\';\n              font-size: 12px;\n              color: rgba(255, 255, 255, 1);\n              text-align: left;\n            }\n            span:first-child:not(:only-child) { margin-bottom: 2px; border-width: 0; }\n          }\n        }\n\n        ~ button {\n          display: flex;\n          position: relative;\n          left: 100%;\n          width: 26px; height: 26px;\n          border-radius: 26px;\n          transform: translateX(-100%);\n  \n          .emulate-plus { margin: 0 auto; }\n          p { display: none; }\n        }\n        // -- .app\n      }\n\n      .header-controls {\n        margin-top: 15px;\n        padding: 19px 13px 18px 16px;\n\n        .round-border-wrapper:not(:only-child):not(:first-child) {\n          width: 40px; height: 40px;\n          border-radius: 40px;\n\n          :not(first-of-type) { margin-left: 6px; }\n          img { margin: 0; }\n          p { display: none; }\n        }\n      }\n      // -- .header\n    }\n\n    .main {\n      padding-right: 16px !important;\n      padding-left: 16px !important;\n\n      .charts {\n        > :not(:last-child) { margin-bottom: 10px; width: 100%; }\n        //> :last-child { display: none; }\n\n        .chart-controls {\n          flex-wrap: wrap;\n          .round-border-wrapper:not(:only-child) {\n            margin: 0;\n            width: 100%;\n            :first-of-type { margin-bottom: 14px; }\n          }\n\n          .download { display: none; }\n        }\n      }\n\n      .tracking-accounts {\n        .isoWidgetsWrapper {\n          margin: 0;\n          \n          .isoWidgetBox {\n            .isoExampleWrapper {\n              .thirdLine {\n                img { margin-bottom: 20px; }\n            }\n          }\n        }\n      }\n    }\n  }\n  \n  @media screen and (max-width: 480px) {\n    .header .app dd h1 { font-size: 16px; }\n    .header .app dd h2 > :not(p):not(:only-child):first-child { display: none; }\n\n    .header .header-controls {\n      dl dd { font-size: 21px; }\n\n      .round-border-wrapper {\n        position: relative;\n        display: block;\n        justify-content: unset;\n        align-items: unset;\n      }\n      .round-border-wrapper > * {\n        position: absolute !important;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n      }\n      \n      .add-budget > :first-child {\n        transform: translate(-100%, -50%);\n\n        + * { transform: translate(10%, -50%); }\n      }\n      \n      .campaign-state > :first-child { left: 50%; }\n    }\n  }\n  // -- /.Zay Modification\n\n  // to make charts resusable , no need to put charts inside main\n  // to make \n  \n\n\n\n\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _iPhoneXMockupInside = __webpack_require__(3310);
	
	var _iPhoneXMockupInside2 = _interopRequireDefault(_iPhoneXMockupInside);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var WidgetWrapper = _styledComponents2.default.div(_templateObject);
	
	var WidgetBox = _styledComponents2.default.div(_templateObject2, (0, _styledTheme.palette)('border', 2));
	
	var WidgetColumn = _styledComponents2.default.div(_templateObject3);
	
	var DashboardWrapper = _styledComponents2.default.div(_templateObject4);
	
	exports.WidgetWrapper = WidgetWrapper;
	exports.WidgetBox = WidgetBox;
	exports.WidgetColumn = WidgetColumn;
	exports.DashboardWrapper = DashboardWrapper;

/***/ },
/* 397 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var authActons = {
	  LOGIN_REQUEST: 'LOGIN_REQUEST',
	  LOGOUT: 'LOGOUT',
	  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
	  LOGIN_ERROR: 'LOGIN_ERROR',
	  login: function login() {
	    return {
	      type: authActons.LOGIN_REQUEST
	    };
	  },
	  logout: function logout() {
	    return {
	      type: authActons.LOGOUT
	    };
	  }
	};
	exports.default = authActons;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1761), __esModule: true };

/***/ },
/* 399 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 400 */
[3344, 1772],
/* 401 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 402 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 403 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(143);
	var dPs = __webpack_require__(1786);
	var enumBugKeys = __webpack_require__(402);
	var IE_PROTO = __webpack_require__(407)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(758)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(1777).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 405 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(120).f;
	var has = __webpack_require__(145);
	var TAG = __webpack_require__(82)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(408)('keys');
	var uid = __webpack_require__(284);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(119);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 409 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 410 */
[3350, 217],
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(119);
	var core = __webpack_require__(62);
	var LIBRARY = __webpack_require__(403);
	var wksExt = __webpack_require__(412);
	var defineProperty = __webpack_require__(120).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(82);


/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1795);
	var global = __webpack_require__(119);
	var hide = __webpack_require__(178);
	var Iterators = __webpack_require__(179);
	var TO_STRING_TAG = __webpack_require__(82)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 414 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var uint_max = Math.pow(2, 32);
	function fixup_uint32(x) {
	    var ret, x_pos;
	    ret = x > uint_max || x < 0 ? (x_pos = Math.abs(x) % uint_max, x < 0 ? uint_max - x_pos : x_pos) : x;
	    return ret;
	}
	function scrub_vec(v) {
	  var i, _i, _ref;
	  for (i = _i = 0, _ref = v.length; 0 <= _ref ? _i < _ref : _i > _ref; i = 0 <= _ref ? ++_i : --_i) {
	    v[i] = 0;
	  }
	  return false;
	}
	
	function Global() {
	  var i;
	  this.SBOX = [];
	  this.INV_SBOX = [];
	  this.SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.INV_SUB_MIX = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 4; i = ++_i) {
	      _results.push([]);
	    }
	    return _results;
	  })();
	  this.init();
	  this.RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];
	}
	
	Global.prototype.init = function() {
	  var d, i, sx, t, x, x2, x4, x8, xi, _i;
	  d = (function() {
	    var _i, _results;
	    _results = [];
	    for (i = _i = 0; _i < 256; i = ++_i) {
	      if (i < 128) {
	        _results.push(i << 1);
	      } else {
	        _results.push((i << 1) ^ 0x11b);
	      }
	    }
	    return _results;
	  })();
	  x = 0;
	  xi = 0;
	  for (i = _i = 0; _i < 256; i = ++_i) {
	    sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	    this.SBOX[x] = sx;
	    this.INV_SBOX[sx] = x;
	    x2 = d[x];
	    x4 = d[x2];
	    x8 = d[x4];
	    t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	    this.SUB_MIX[0][x] = (t << 24) | (t >>> 8);
	    this.SUB_MIX[1][x] = (t << 16) | (t >>> 16);
	    this.SUB_MIX[2][x] = (t << 8) | (t >>> 24);
	    this.SUB_MIX[3][x] = t;
	    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	    this.INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8);
	    this.INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16);
	    this.INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24);
	    this.INV_SUB_MIX[3][sx] = t;
	    if (x === 0) {
	      x = xi = 1;
	    } else {
	      x = x2 ^ d[d[d[x8 ^ x2]]];
	      xi ^= d[d[xi]];
	    }
	  }
	  return true;
	};
	
	var G = new Global();
	
	
	AES.blockSize = 4 * 4;
	
	AES.prototype.blockSize = AES.blockSize;
	
	AES.keySize = 256 / 8;
	
	AES.prototype.keySize = AES.keySize;
	
	AES.ivSize = AES.blockSize;
	
	AES.prototype.ivSize = AES.ivSize;
	
	 function bufferToArray(buf) {
	  var len = buf.length/4;
	  var out = new Array(len);
	  var i = -1;
	  while (++i < len) {
	    out[i] = buf.readUInt32BE(i * 4);
	  }
	  return out;
	 }
	function AES(key) {
	  this._key = bufferToArray(key);
	  this._doReset();
	}
	
	AES.prototype._doReset = function() {
	  var invKsRow, keySize, keyWords, ksRow, ksRows, t, _i, _j;
	  keyWords = this._key;
	  keySize = keyWords.length;
	  this._nRounds = keySize + 6;
	  ksRows = (this._nRounds + 1) * 4;
	  this._keySchedule = [];
	  for (ksRow = _i = 0; 0 <= ksRows ? _i < ksRows : _i > ksRows; ksRow = 0 <= ksRows ? ++_i : --_i) {
	    this._keySchedule[ksRow] = ksRow < keySize ? keyWords[ksRow] : (t = this._keySchedule[ksRow - 1], (ksRow % keySize) === 0 ? (t = (t << 8) | (t >>> 24), t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff], t ^= G.RCON[(ksRow / keySize) | 0] << 24) : keySize > 6 && ksRow % keySize === 4 ? t = (G.SBOX[t >>> 24] << 24) | (G.SBOX[(t >>> 16) & 0xff] << 16) | (G.SBOX[(t >>> 8) & 0xff] << 8) | G.SBOX[t & 0xff] : void 0, this._keySchedule[ksRow - keySize] ^ t);
	  }
	  this._invKeySchedule = [];
	  for (invKsRow = _j = 0; 0 <= ksRows ? _j < ksRows : _j > ksRows; invKsRow = 0 <= ksRows ? ++_j : --_j) {
	    ksRow = ksRows - invKsRow;
	    t = this._keySchedule[ksRow - (invKsRow % 4 ? 0 : 4)];
	    this._invKeySchedule[invKsRow] = invKsRow < 4 || ksRow <= 4 ? t : G.INV_SUB_MIX[0][G.SBOX[t >>> 24]] ^ G.INV_SUB_MIX[1][G.SBOX[(t >>> 16) & 0xff]] ^ G.INV_SUB_MIX[2][G.SBOX[(t >>> 8) & 0xff]] ^ G.INV_SUB_MIX[3][G.SBOX[t & 0xff]];
	  }
	  return true;
	};
	
	AES.prototype.encryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var out = this._doCryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[1], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[3], 12);
	  return buf;
	};
	
	AES.prototype.decryptBlock = function(M) {
	  M = bufferToArray(new Buffer(M));
	  var temp = [M[3], M[1]];
	  M[1] = temp[0];
	  M[3] = temp[1];
	  var out = this._doCryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX);
	  var buf = new Buffer(16);
	  buf.writeUInt32BE(out[0], 0);
	  buf.writeUInt32BE(out[3], 4);
	  buf.writeUInt32BE(out[2], 8);
	  buf.writeUInt32BE(out[1], 12);
	  return buf;
	};
	
	AES.prototype.scrub = function() {
	  scrub_vec(this._keySchedule);
	  scrub_vec(this._invKeySchedule);
	  scrub_vec(this._key);
	};
	
	AES.prototype._doCryptBlock = function(M, keySchedule, SUB_MIX, SBOX) {
	  var ksRow, round, s0, s1, s2, s3, t0, t1, t2, t3, _i, _ref;
	
	  s0 = M[0] ^ keySchedule[0];
	  s1 = M[1] ^ keySchedule[1];
	  s2 = M[2] ^ keySchedule[2];
	  s3 = M[3] ^ keySchedule[3];
	  ksRow = 4;
	  for (round = _i = 1, _ref = this._nRounds; 1 <= _ref ? _i < _ref : _i > _ref; round = 1 <= _ref ? ++_i : --_i) {
	    t0 = SUB_MIX[0][s0 >>> 24] ^ SUB_MIX[1][(s1 >>> 16) & 0xff] ^ SUB_MIX[2][(s2 >>> 8) & 0xff] ^ SUB_MIX[3][s3 & 0xff] ^ keySchedule[ksRow++];
	    t1 = SUB_MIX[0][s1 >>> 24] ^ SUB_MIX[1][(s2 >>> 16) & 0xff] ^ SUB_MIX[2][(s3 >>> 8) & 0xff] ^ SUB_MIX[3][s0 & 0xff] ^ keySchedule[ksRow++];
	    t2 = SUB_MIX[0][s2 >>> 24] ^ SUB_MIX[1][(s3 >>> 16) & 0xff] ^ SUB_MIX[2][(s0 >>> 8) & 0xff] ^ SUB_MIX[3][s1 & 0xff] ^ keySchedule[ksRow++];
	    t3 = SUB_MIX[0][s3 >>> 24] ^ SUB_MIX[1][(s0 >>> 16) & 0xff] ^ SUB_MIX[2][(s1 >>> 8) & 0xff] ^ SUB_MIX[3][s2 & 0xff] ^ keySchedule[ksRow++];
	    s0 = t0;
	    s1 = t1;
	    s2 = t2;
	    s3 = t3;
	  }
	  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
	  return [
	    fixup_uint32(t0),
	    fixup_uint32(t1),
	    fixup_uint32(t2),
	    fixup_uint32(t3)
	  ];
	
	};
	
	
	
	
	  exports.AES = AES;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var Transform = __webpack_require__(3254).Transform;
	var inherits = __webpack_require__(98);
	
	module.exports = CipherBase;
	inherits(CipherBase, Transform);
	function CipherBase() {
	  Transform.call(this);
	}
	CipherBase.prototype.update = function (data, inputEnd, outputEnc) {
	  this.write(data, inputEnd);
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	CipherBase.prototype.final = function (outputEnc) {
	  this.end();
	  var outData = new Buffer('');
	  var chunk;
	  while ((chunk = this.read())) {
	    outData = Buffer.concat([outData, chunk]);
	  }
	  if (outputEnc) {
	    outData = outData.toString(outputEnc);
	  }
	  return outData;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 417 */
/***/ function(module, exports) {

	exports['aes-128-ecb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-192-ecb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-256-ecb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 0,
	  mode: 'ECB',
	  type: 'block'
	};
	exports['aes-128-cbc'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-192-cbc'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes-256-cbc'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CBC',
	  type: 'block'
	};
	exports['aes128'] = exports['aes-128-cbc'];
	exports['aes192'] = exports['aes-192-cbc'];
	exports['aes256'] = exports['aes-256-cbc'];
	exports['aes-128-cfb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-192-cfb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-256-cfb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CFB',
	  type: 'stream'
	};
	exports['aes-128-ofb'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-192-ofb'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-256-ofb'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'OFB',
	  type: 'stream'
	};
	exports['aes-128-ctr'] = {
	  cipher: 'AES',
	  key: 128,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-192-ctr'] = {
	  cipher: 'AES',
	  key: 192,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};
	exports['aes-256-ctr'] = {
	  cipher: 'AES',
	  key: 256,
	  iv: 16,
	  mode: 'CTR',
	  type: 'stream'
	};

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(895);
	} catch (err) {
	  var index = __webpack_require__(895);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(1875);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(418);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.8. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(225);
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(148);
	var ContentBlockNode = __webpack_require__(78);
	var DraftEntity = __webpack_require__(296);
	var DraftFeatureFlags = __webpack_require__(125);
	var Immutable = __webpack_require__(26);
	var SelectionState = __webpack_require__(184);
	
	var generateRandomKey = __webpack_require__(108);
	var sanitizeDraftText = __webpack_require__(428);
	
	var List = Immutable.List,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var defaultRecord = {
	  entityMap: null,
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
	  }
	
	  ContentState.prototype.getEntityMap = function getEntityMap() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity;
	  };
	
	  ContentState.prototype.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  ContentState.prototype.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  ContentState.prototype.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__getLastCreatedEntityKey();
	  };
	
	  ContentState.prototype.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || blockMap.first().getLength() > 0;
	  };
	
	  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__create(type, mutability, data);
	    return this;
	  };
	
	  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__mergeData(key, toMerge);
	    return this;
	  };
	
	  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__replaceData(key, newData);
	    return this;
	  };
	
	  ContentState.prototype.addEntity = function addEntity(instance) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__add(instance);
	    return this;
	  };
	
	  ContentState.prototype.getEntity = function getEntity(key) {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__get(key);
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray(
	  // TODO: update flow type when we completely deprecate the old entity API
	  blocks, entityMap) {
	    // TODO: remove this when we completely deprecate the old entity API
	    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
	    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
	    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      entityMap: entityMap || DraftEntity,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
	
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlockNodeRecord({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(26),
	    Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(186);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	var DefaultDraftBlockRenderMap = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  blockquote: {
	    element: 'blockquote'
	  },
	  atomic: {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  unstyled: {
	    element: 'div',
	    aliasedElements: ['p']
	  }
	});
	
	module.exports = DefaultDraftBlockRenderMap;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(97);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(924);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	  while (searchNode && searchNode !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	    if (key != null) {
	      return key;
	    }
	    searchNode = searchNode.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ },
/* 426 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
	        return null;
	      }
	      return filterKey(contentState.getEntityMap(), entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(contentState.getEntityMap(), entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityMap, entityKey) {
	  if (entityKey) {
	    var entity = entityMap.__get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ },
/* 427 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ },
/* 428 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * @format
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ },
/* 429 */
185,
/* 430 */
185,
/* 431 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(2017);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    var ownerDocument = node.ownerDocument;
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	
	};
	
	module.exports = Style;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ },
/* 434 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(2014);
	var getUnboundedScrollPosition = __webpack_require__(2018);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var React = __webpack_require__(1);
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation. All rights reserved.
	Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	this file except in compliance with the License. You may obtain a copy of the
	License at http://www.apache.org/licenses/LICENSE-2.0
	
	THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	MERCHANTABLITY OR NON-INFRINGEMENT.
	
	See the Apache Version 2.0 License for specific language governing permissions
	and limitations under the License.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = Object.setPrototypeOf ||
	    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = Object.assign || function __assign(t) {
	    for (var s, i = 1, n = arguments.length; i < n; i++) {
	        s = arguments[i];
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	    }
	    return t;
	};
	
	function __rest(s, e) {
	    var t = {};
	    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	        t[p] = s[p];
	    if (s != null && typeof Object.getOwnPropertySymbols === "function")
	        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
	            t[p[i]] = s[p[i]];
	    return t;
	}
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	var emptyFunction_1 = emptyFunction;
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var invariant_1 = invariant;
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction_1;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	var warning_1 = warning;
	
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	var index = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	var ReactPropTypesSecret_1 = ReactPropTypesSecret;
	
	if (false) {
	  var invariant$2 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$2(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	var checkPropTypes_1 = checkPropTypes;
	
	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction_1.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = index({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret_1) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant_1(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  }
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};
	
	var index$2 = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = factoryWithThrowingShims();
	}
	});
	
	var index_1 = index$2.object;
	var index_2 = index$2.oneOfType;
	var index_3 = index$2.string;
	var index_4 = index$2.node;
	var index_5 = index$2.func;
	var index_6 = index$2.bool;
	var index_7 = index$2.element;
	
	var index$4 = createCommonjsModule(function (module, exports) {
	/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = isEqual;
	});
	
	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning$2 = function() {};
	
	if (__DEV__) {
	  warning$2 = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	var warning_1$2 = warning$2;
	
	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	var genTag = '[object GeneratorFunction]';
	var symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./;
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	var funcProto = Function.prototype;
	var objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty$1 = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty$1).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol$1 = root.Symbol;
	var splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	var nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined;
	var symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty$1.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	}
	
	var index$5 = toPath;
	
	var index$6 = createCommonjsModule(function (module, exports) {
	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = 'object' == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = cloneDeep;
	});
	
	function getIn(obj, key, def, p) {
	    if (p === void 0) { p = 0; }
	    var path = index$5(key);
	    while (obj && p < path.length) {
	        obj = obj[path[p++]];
	    }
	    return obj === undefined ? def : obj;
	}
	function setIn(obj, path, value) {
	    var res = {};
	    var resVal = res;
	    var i = 0;
	    var pathArray = index$5(path);
	    for (; i < pathArray.length - 1; i++) {
	        var currentPath = pathArray[i];
	        var currentObj = obj[currentPath];
	        if (resVal[currentPath]) {
	            resVal = resVal[currentPath];
	        }
	        else if (currentObj) {
	            resVal = resVal[currentPath] = index$6(currentObj);
	        }
	        else {
	            var nextPath = pathArray[i + 1];
	            resVal = resVal[currentPath] =
	                isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
	        }
	    }
	    resVal[pathArray[i]] = value;
	    return __assign({}, obj, res);
	}
	function setNestedObjectValues(object, value, visited, response) {
	    if (visited === void 0) { visited = new WeakMap(); }
	    if (response === void 0) { response = {}; }
	    for (var _i = 0, _a = Object.keys(object); _i < _a.length; _i++) {
	        var k = _a[_i];
	        var val = object[k];
	        if (isObject$1(val)) {
	            if (!visited.get(val)) {
	                visited.set(val, true);
	                response[k] = Array.isArray(val) ? [] : {};
	                setNestedObjectValues(val, value, visited, response[k]);
	            }
	        }
	        else {
	            response[k] = value;
	        }
	    }
	    return response;
	}
	var isReactNative = typeof window !== 'undefined' &&
	    window.navigator &&
	    window.navigator.product &&
	    window.navigator.product === 'ReactNative';
	var isFunction$1 = function (obj) { return 'function' === typeof obj; };
	var isObject$1 = function (obj) { return obj !== null && typeof obj === 'object'; };
	var isInteger = function (obj) { return String(Math.floor(Number(obj))) === obj; };
	var isEmptyChildren = function (children) {
	    return React.Children.count(children) === 0;
	};
	function isPromise(value) {
	    if (value !== null && typeof value === 'object') {
	        return value && typeof value.then === 'function';
	    }
	    return false;
	}
	
	var Field = (function (_super) {
	    __extends(Field, _super);
	    function Field() {
	        var _this = _super !== null && _super.apply(this, arguments) || this;
	        _this.handleChange = function (e) {
	            var _a = _this.context.formik, handleChange = _a.handleChange, validateOnChange = _a.validateOnChange;
	            handleChange(e);
	            if (!!validateOnChange && !!_this.props.validate) {
	                _this.runFieldValidations(e.target.value);
	            }
	        };
	        _this.handleBlur = function (e) {
	            var _a = _this.context.formik, handleBlur = _a.handleBlur, validateOnBlur = _a.validateOnBlur;
	            handleBlur(e);
	            if (validateOnBlur && _this.props.validate) {
	                _this.runFieldValidations(e.target.value);
	            }
	        };
	        _this.runFieldValidations = function (value) {
	            var setFieldError = _this.context.formik.setFieldError;
	            var _a = _this.props, name = _a.name, validate = _a.validate;
	            var maybePromise = validate(value);
	            if (isPromise(maybePromise)) {
	                maybePromise.then(function () { return setFieldError(name, undefined); }, function (error) { return setFieldError(name, error); });
	            }
	            else {
	                setFieldError(name, maybePromise);
	            }
	        };
	        return _this;
	    }
	    Field.prototype.componentWillMount = function () {
	        var _a = this.props, render = _a.render, children = _a.children, component = _a.component;
	        warning_1$2(!(component && render), 'You should not use <Field component> and <Field render> in the same <Field> component; <Field component> will be ignored');
	        warning_1$2(!(this.props.component && children && isFunction$1(children)), 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.');
	        warning_1$2(!(render && children && !isEmptyChildren(children)), 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored');
	    };
	    Field.prototype.render = function () {
	        var _a = this.props, validate = _a.validate, name = _a.name, render = _a.render, children = _a.children, _b = _a.component, component = _b === void 0 ? 'input' : _b, props = __rest(_a, ["validate", "name", "render", "children", "component"]);
	        var formik = this.context.formik;
	        var field = {
	            value: props.type === 'radio' || props.type === 'checkbox'
	                ? props.value
	                : getIn(formik.values, name),
	            name: name,
	            onChange: validate ? this.handleChange : formik.handleChange,
	            onBlur: validate ? this.handleBlur : formik.handleBlur,
	        };
	        var bag = { field: field, form: formik };
	        if (render) {
	            return render(bag);
	        }
	        if (isFunction$1(children)) {
	            return children(bag);
	        }
	        if (typeof component === 'string') {
	            return React.createElement(component, __assign({}, field, props, { children: children }));
	        }
	        return React.createElement(component, __assign({}, bag, props, { children: children }));
	    };
	    Field.contextTypes = {
	        formik: index_1,
	    };
	    Field.propTypes = {
	        name: index_3.isRequired,
	        component: index_2([index_3, index_5]),
	        render: index_5,
	        children: index_2([index_5, index_4]),
	        validate: index_5,
	    };
	    return Field;
	}(React.Component));
	
	var Form = function (props, context) { return (React.createElement("form", __assign({ onSubmit: context.formik.handleSubmit }, props))); };
	Form.contextTypes = {
	    formik: index_1,
	};
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true,
	};
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true,
	};
	var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
	var propIsEnumerable$1 = Object.prototype.propertyIsEnumerable;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') {
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	        var keys = getOwnPropertyNames(sourceComponent);
	        if (getOwnPropertySymbols$1) {
	            keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
	        }
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] &&
	                !KNOWN_STATICS[key] &&
	                (!blacklist || !blacklist[key])) {
	                if (propIsEnumerable$1.call(sourceComponent, key) ||
	                    typeof sourceComponent[key] === 'function') {
	                    try {
	                        targetComponent[key] = sourceComponent[key];
	                    }
	                    catch (e) { }
	                }
	            }
	        }
	        return targetComponent;
	    }
	    return targetComponent;
	}
	
	function withFormik(_a) {
	    var _b = _a.mapPropsToValues, mapPropsToValues = _b === void 0 ? function (vanillaProps) {
	        var val = {};
	        for (var k in vanillaProps) {
	            if (vanillaProps.hasOwnProperty(k) &&
	                typeof vanillaProps[k] !== 'function') {
	                val[k] = vanillaProps[k];
	            }
	        }
	        return val;
	    } : _b, config = __rest(_a, ["mapPropsToValues"]);
	    return function createFormik(Component) {
	        var C = (function (_super) {
	            __extends(C, _super);
	            function C() {
	                var _this = _super !== null && _super.apply(this, arguments) || this;
	                _this.validate = function (values) {
	                    return config.validate(values, _this.props);
	                };
	                _this.validationSchema = function () {
	                    return isFunction$1(config.validationSchema)
	                        ? config.validationSchema(_this.props)
	                        : config.validationSchema;
	                };
	                _this.handleSubmit = function (values, actions) {
	                    return config.handleSubmit(values, __assign({}, actions, { props: _this.props }));
	                };
	                _this.renderFormComponent = function (formikProps) {
	                    return React.createElement(Component, __assign({}, _this.props, formikProps));
	                };
	                return _this;
	            }
	            C.prototype.render = function () {
	                return (React.createElement(Formik, __assign({}, this.props, config, { validate: config.validate && this.validate, validationSchema: config.validationSchema && this.validationSchema, initialValues: mapPropsToValues(this.props), onSubmit: this.handleSubmit, render: this.renderFormComponent })));
	            };
	            return C;
	        }(React.Component));
	        return hoistNonReactStatics(C, Component);
	    };
	}
	
	var move = function (array, from, to) {
	    var copy = (array || []).slice();
	    var value = copy[from];
	    copy.splice(from, 1);
	    copy.splice(to, 0, value);
	    return copy;
	};
	var swap = function (array, indexA, indexB) {
	    var copy = (array || []).slice();
	    var a = copy[indexA];
	    copy[indexA] = copy[indexB];
	    copy[indexB] = a;
	    return copy;
	};
	var insert = function (array, index, value) {
	    var copy = (array || []).slice();
	    copy.splice(index, 0, value);
	    return copy;
	};
	var FieldArray = (function (_super) {
	    __extends(FieldArray, _super);
	    function FieldArray(props) {
	        var _this = _super.call(this, props) || this;
	        _this.updateArrayField = function (fn, alterTouched, alterErrors) {
	            var _a = _this.context.formik, setFormikState = _a.setFormikState, validateForm = _a.validateForm, values = _a.values, touched = _a.touched, errors = _a.errors;
	            var _b = _this.props, name = _b.name, validateOnChange = _b.validateOnChange;
	            setFormikState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, name, fn(getIn(values, name))), errors: alterErrors
	                    ? setIn(prevState.errors, name, fn(getIn(errors, name)))
	                    : prevState.errors, touched: alterTouched
	                    ? setIn(prevState.touched, name, fn(getIn(touched, name)))
	                    : prevState.touched })); }, function () {
	                if (validateOnChange) {
	                    validateForm();
	                }
	            });
	        };
	        _this.push = function (value) {
	            return _this.updateArrayField(function (array) { return (array || []).concat([value]); }, false, false);
	        };
	        _this.swap = function (indexA, indexB) {
	            return _this.updateArrayField(function (array) { return swap(array, indexA, indexB); }, false, false);
	        };
	        _this.move = function (from, to) {
	            return _this.updateArrayField(function (array) { return move(array, from, to); }, false, false);
	        };
	        _this.insert = function (index, value) {
	            return _this.updateArrayField(function (array) { return insert(array, index, value); }, false, false);
	        };
	        _this.unshift = function (value) {
	            var arr = [];
	            _this.updateArrayField(function (array) {
	                arr = array ? [value].concat(array) : [value];
	                return arr;
	            }, false, false);
	            return arr.length;
	        };
	        _this.remove = _this.remove.bind(_this);
	        _this.pop = _this.pop.bind(_this);
	        return _this;
	    }
	    FieldArray.prototype.remove = function (index) {
	        var result;
	        this.updateArrayField(function (array) {
	            var copy = array ? array.slice() : [];
	            if (!result) {
	                result = copy[index];
	            }
	            if (isFunction$1(copy.splice)) {
	                copy.splice(index, 1);
	            }
	            return copy;
	        }, true, true);
	        return result;
	    };
	    FieldArray.prototype.pop = function () {
	        var result;
	        this.updateArrayField(function (array) {
	            var tmp = array;
	            if (!result) {
	                result = tmp && tmp.pop && tmp.pop();
	            }
	            return tmp;
	        }, true, true);
	        return result;
	    };
	    FieldArray.prototype.render = function () {
	        var arrayHelpers = {
	            push: this.push,
	            pop: this.pop,
	            swap: this.swap,
	            move: this.move,
	            insert: this.insert,
	            unshift: this.unshift,
	            remove: this.remove,
	        };
	        var _a = this.props, component = _a.component, render = _a.render, children = _a.children, name = _a.name;
	        var props = __assign({}, arrayHelpers, { form: this.context.formik, name: name });
	        return component
	            ? React.createElement(component, props)
	            : render
	                ? render(props)
	                : children
	                    ? typeof children === 'function'
	                        ? children(props)
	                        : !isEmptyChildren(children) ? React.Children.only(children) : null
	                    : null;
	    };
	    FieldArray.defaultProps = {
	        validateOnChange: true,
	    };
	    FieldArray.contextTypes = {
	        formik: index_1,
	    };
	    return FieldArray;
	}(React.Component));
	
	var Formik = (function (_super) {
	    __extends(Formik, _super);
	    function Formik(props) {
	        var _this = _super.call(this, props) || this;
	        _this.setErrors = function (errors) {
	            _this.setState({ errors: errors });
	        };
	        _this.setTouched = function (touched) {
	            _this.setState({ touched: touched }, function () {
	                if (_this.props.validateOnBlur) {
	                    _this.runValidations(_this.state.values);
	                }
	            });
	        };
	        _this.setValues = function (values) {
	            _this.setState({ values: values }, function () {
	                if (_this.props.validateOnChange) {
	                    _this.runValidations(values);
	                }
	            });
	        };
	        _this.setStatus = function (status) {
	            _this.setState({ status: status });
	        };
	        _this.setError = function (error) {
	            if (false) {
	                console.warn("Warning: Formik's setError(error) is deprecated and may be removed in future releases. Please use Formik's setStatus(status) instead. It works identically. For more info see https://github.com/jaredpalmer/formik#setstatus-status-any--void");
	            }
	            _this.setState({ error: error });
	        };
	        _this.setSubmitting = function (isSubmitting) {
	            _this.setState({ isSubmitting: isSubmitting });
	        };
	        _this.runValidationSchema = function (values, onSuccess) {
	            var validationSchema = _this.props.validationSchema;
	            var schema = isFunction$1(validationSchema)
	                ? validationSchema()
	                : validationSchema;
	            validateYupSchema(values, schema).then(function () {
	                _this.setState({ errors: {} });
	                if (onSuccess) {
	                    onSuccess();
	                }
	            }, function (err) {
	                return _this.setState({ errors: yupToFormErrors(err), isSubmitting: false });
	            });
	        };
	        _this.runValidations = function (values) {
	            if (values === void 0) { values = _this.state.values; }
	            if (_this.props.validationSchema) {
	                _this.runValidationSchema(values);
	            }
	            if (_this.props.validate) {
	                var maybePromisedErrors = _this.props.validate(values);
	                if (isPromise(maybePromisedErrors)) {
	                    maybePromisedErrors.then(function () {
	                        _this.setState({ errors: {} });
	                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
	                }
	                else {
	                    _this.setErrors(maybePromisedErrors);
	                }
	            }
	        };
	        _this.handleChange = function (e) {
	            if (isReactNative) {
	                if (false) {
	                    console.error("Warning: Formik's handleChange does not work with React Native. Use setFieldValue and within a callback instead. For more info see https://github.com/jaredpalmer/formik#react-native");
	                }
	                return;
	            }
	            e.persist();
	            var _a = e.target, type = _a.type, name = _a.name, id = _a.id, value = _a.value, checked = _a.checked, outerHTML = _a.outerHTML;
	            var field = name ? name : id;
	            var parsed;
	            var val = /number|range/.test(type)
	                ? (parsed = parseFloat(value), Number.isNaN(parsed) ? '' : parsed)
	                : /checkbox/.test(type) ? checked : value;
	            if (!field && ("production") !== 'production') {
	                warnAboutMissingIdentifier({
	                    htmlContent: outerHTML,
	                    documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
	                    handlerName: 'handleChange',
	                });
	            }
	            _this.setState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, field, val) })); });
	            if (_this.props.validateOnChange) {
	                _this.runValidations(setIn(_this.state.values, field, val));
	            }
	        };
	        _this.setFieldValue = function (field, value, shouldValidate) {
	            if (shouldValidate === void 0) { shouldValidate = true; }
	            _this.setState(function (prevState) { return (__assign({}, prevState, { values: setIn(prevState.values, field, value) })); }, function () {
	                if (_this.props.validateOnChange && shouldValidate) {
	                    _this.runValidations(_this.state.values);
	                }
	            });
	        };
	        _this.handleSubmit = function (e) {
	            e.preventDefault();
	            _this.submitForm();
	        };
	        _this.submitForm = function () {
	            _this.setState({
	                touched: setNestedObjectValues(_this.state.values, true),
	                isSubmitting: true,
	            });
	            if (_this.props.validate) {
	                var maybePromisedErrors = _this.props.validate(_this.state.values) || {};
	                if (isPromise(maybePromisedErrors)) {
	                    maybePromisedErrors.then(function () {
	                        _this.setState({ errors: {} });
	                        _this.executeSubmit();
	                    }, function (errors) { return _this.setState({ errors: errors, isSubmitting: false }); });
	                    return;
	                }
	                else {
	                    var isValid = Object.keys(maybePromisedErrors).length === 0;
	                    _this.setState({
	                        errors: maybePromisedErrors,
	                        isSubmitting: isValid,
	                    });
	                    if (isValid) {
	                        _this.executeSubmit();
	                    }
	                }
	            }
	            else if (_this.props.validationSchema) {
	                _this.runValidationSchema(_this.state.values, _this.executeSubmit);
	            }
	            else {
	                _this.executeSubmit();
	            }
	        };
	        _this.executeSubmit = function () {
	            _this.props.onSubmit(_this.state.values, _this.getFormikActions());
	        };
	        _this.handleBlur = function (e) {
	            if (isReactNative) {
	                if (false) {
	                    console.error("Warning: Formik's handleBlur does not work with React Native. Use setFieldTouched(field, isTouched) within a callback instead. For more info see https://github.com/jaredpalmer/formik#setfieldtouched-field-string-istouched-boolean--void");
	                }
	                return;
	            }
	            e.persist();
	            var _a = e.target, name = _a.name, id = _a.id, outerHTML = _a.outerHTML;
	            var field = name ? name : id;
	            if (!field && ("production") !== 'production') {
	                warnAboutMissingIdentifier({
	                    htmlContent: outerHTML,
	                    documentationAnchorLink: 'handleblur-e-any--void',
	                    handlerName: 'handleBlur',
	                });
	            }
	            _this.setState(function (prevState) { return ({
	                touched: setIn(prevState.touched, field, true),
	            }); });
	            if (_this.props.validateOnBlur) {
	                _this.runValidations(_this.state.values);
	            }
	        };
	        _this.setFieldTouched = function (field, touched, shouldValidate) {
	            if (touched === void 0) { touched = true; }
	            if (shouldValidate === void 0) { shouldValidate = true; }
	            _this.setState(function (prevState) { return (__assign({}, prevState, { touched: setIn(prevState.touched, field, touched) })); }, function () {
	                if (_this.props.validateOnBlur && shouldValidate) {
	                    _this.runValidations(_this.state.values);
	                }
	            });
	        };
	        _this.setFieldError = function (field, message) {
	            _this.setState(function (prevState) { return (__assign({}, prevState, { errors: setIn(prevState.errors, field, message) })); });
	        };
	        _this.resetForm = function (nextValues) {
	            var values = nextValues ? nextValues : _this.props.initialValues;
	            _this.initialValues = values;
	            _this.setState({
	                isSubmitting: false,
	                errors: {},
	                touched: {},
	                error: undefined,
	                status: undefined,
	                values: values,
	            });
	        };
	        _this.handleReset = function () {
	            if (_this.props.onReset) {
	                var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());
	                if (isPromise(maybePromisedOnReset)) {
	                    maybePromisedOnReset.then(_this.resetForm);
	                }
	                else {
	                    _this.resetForm();
	                }
	            }
	            else {
	                _this.resetForm();
	            }
	        };
	        _this.setFormikState = function (s, callback) {
	            return _this.setState(s, callback);
	        };
	        _this.getFormikActions = function () {
	            return {
	                resetForm: _this.resetForm,
	                submitForm: _this.submitForm,
	                validateForm: _this.runValidations,
	                setError: _this.setError,
	                setErrors: _this.setErrors,
	                setFieldError: _this.setFieldError,
	                setFieldTouched: _this.setFieldTouched,
	                setFieldValue: _this.setFieldValue,
	                setStatus: _this.setStatus,
	                setSubmitting: _this.setSubmitting,
	                setTouched: _this.setTouched,
	                setValues: _this.setValues,
	                setFormikState: _this.setFormikState,
	            };
	        };
	        _this.getFormikComputedProps = function () {
	            var isInitialValid = _this.props.isInitialValid;
	            var dirty = !index$4(_this.initialValues, _this.state.values);
	            return {
	                dirty: dirty,
	                isValid: dirty
	                    ? _this.state.errors && Object.keys(_this.state.errors).length === 0
	                    : isInitialValid !== false && isFunction$1(isInitialValid)
	                        ? isInitialValid(_this.props)
	                        : isInitialValid,
	                initialValues: _this.initialValues,
	            };
	        };
	        _this.getFormikBag = function () {
	            return __assign({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), { handleBlur: _this.handleBlur, handleChange: _this.handleChange, handleReset: _this.handleReset, handleSubmit: _this.handleSubmit, validateOnChange: _this.props.validateOnChange, validateOnBlur: _this.props.validateOnBlur });
	        };
	        _this.state = {
	            values: props.initialValues || {},
	            errors: {},
	            touched: {},
	            isSubmitting: false,
	        };
	        _this.initialValues = props.initialValues || {};
	        return _this;
	    }
	    Formik.prototype.getChildContext = function () {
	        return {
	            formik: this.getFormikBag(),
	        };
	    };
	    Formik.prototype.componentWillReceiveProps = function (nextProps) {
	        if (this.props.enableReinitialize &&
	            !index$4(nextProps.initialValues, this.props.initialValues)) {
	            this.initialValues = nextProps.initialValues;
	            this.resetForm(nextProps.initialValues);
	        }
	    };
	    Formik.prototype.componentWillMount = function () {
	        warning_1$2(!(this.props.component && this.props.render), 'You should not use <Formik component> and <Formik render> in the same <Formik> component; <Formik render> will be ignored');
	        warning_1$2(!(this.props.component &&
	            this.props.children &&
	            !isEmptyChildren(this.props.children)), 'You should not use <Formik component> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
	        warning_1$2(!(this.props.render &&
	            this.props.children &&
	            !isEmptyChildren(this.props.children)), 'You should not use <Formik render> and <Formik children> in the same <Formik> component; <Formik children> will be ignored');
	    };
	    Formik.prototype.render = function () {
	        var _a = this.props, component = _a.component, render = _a.render, children = _a.children;
	        var props = this.getFormikBag();
	        return component
	            ? React.createElement(component, props)
	            : render
	                ? render(props)
	                : children
	                    ? typeof children === 'function'
	                        ? children(props)
	                        : !isEmptyChildren(children) ? React.Children.only(children) : null
	                    : null;
	    };
	    Formik.defaultProps = {
	        validateOnChange: true,
	        validateOnBlur: true,
	        isInitialValid: false,
	        enableReinitialize: false,
	    };
	    Formik.propTypes = {
	        validateOnChange: index_6,
	        validateOnBlur: index_6,
	        isInitialValid: index_2([index_5, index_6]),
	        initialValues: index_1,
	        onReset: index_5,
	        onSubmit: index_5.isRequired,
	        validationSchema: index_2([index_5, index_1]),
	        validate: index_5,
	        component: index_5,
	        render: index_5,
	        children: index_2([index_5, index_4]),
	        enableReinitialize: index_6,
	    };
	    Formik.childContextTypes = {
	        formik: index_1,
	    };
	    return Formik;
	}(React.Component));
	function warnAboutMissingIdentifier(_a) {
	    var htmlContent = _a.htmlContent, documentationAnchorLink = _a.documentationAnchorLink, handlerName = _a.handlerName;
	    console.error("Warning: `" + handlerName + "` has triggered and you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
	}
	function yupToFormErrors(yupError) {
	    var errors = {};
	    for (var _i = 0, _a = yupError.inner; _i < _a.length; _i++) {
	        var err = _a[_i];
	        if (!errors[err.path]) {
	            errors = setIn(errors, err.path, err.message);
	        }
	    }
	    return errors;
	}
	function validateYupSchema(data, schema, context) {
	    if (context === void 0) { context = {}; }
	    var validateData = {};
	    for (var k in data) {
	        if (data.hasOwnProperty(k)) {
	            var key = String(k);
	            validateData[key] =
	                data[key] !== '' ? data[key] : undefined;
	        }
	    }
	    return schema.validate(validateData, { abortEarly: false, context: context });
	}
	
	exports.Formik = Formik;
	exports.yupToFormErrors = yupToFormErrors;
	exports.validateYupSchema = validateYupSchema;
	exports.Field = Field;
	exports.Form = Form;
	exports.withFormik = withFormik;
	exports.move = move;
	exports.swap = swap;
	exports.insert = insert;
	exports.FieldArray = FieldArray;
	exports.getIn = getIn;
	exports.setIn = setIn;
	exports.setNestedObjectValues = setNestedObjectValues;
	exports.isReactNative = isReactNative;
	exports.isFunction = isFunction$1;
	exports.isObject = isObject$1;
	exports.isInteger = isInteger;
	exports.isEmptyChildren = isEmptyChildren;
	exports.isPromise = isPromise;
	//# sourceMappingURL=formik.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(398);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.count_occurences = count_occurences;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Counts all occurences of a symbol in a string
	function count_occurences(symbol, string) {
		var count = 0;
	
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;
	
		try {
			for (var _iterator = (0, _getIterator3.default)(string), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var character = _step.value;
	
				if (character === symbol) {
					count++;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	
		return count;
	}
	//# sourceMappingURL=helpers.js.map

/***/ },
/* 439 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = parse;
	// Parses the `text`.
	//
	// Returns `{ value, caret }` where `caret` is
	// the caret position inside `value`
	// corresponding to the `caret_position` inside `text`.
	//
	// The `text` is parsed by feeding each character sequentially to
	// `parse_character(character, value)` function
	// and appending the result (if it's not `undefined`) to `value`.
	//
	// Example:
	//
	// `text` is `8 (800) 555-35-35`,
	// `caret_position` is `4` (before the first `0`).
	// `parse_character` is `(character, value) =>
	//   if (character >= '0' && character <= '9') { return character }`.
	//
	// then `parse()` outputs `{ value: '88005553535', caret: 2 }`.
	//
	function parse(text, caret_position, parse_character) {
		var value = '';
	
		var focused_input_character_index = 0;
	
		var index = 0;
		while (index < text.length) {
			var character = parse_character(text[index], value);
	
			if (character !== undefined) {
				value += character;
	
				if (caret_position !== undefined) {
					if (caret_position === index) {
						focused_input_character_index = value.length - 1;
					} else if (caret_position > index) {
						focused_input_character_index = value.length;
					}
				}
			}
	
			index++;
		}
	
		// If caret position wasn't specified
		if (caret_position === undefined) {
			// Then set caret position to "after the last input character"
			focused_input_character_index = value.length;
		}
	
		var result = {
			value: value,
			caret: focused_input_character_index
		};
	
		return result;
	}
	//# sourceMappingURL=parse.js.map

/***/ },
/* 440 */
/***/ function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class /;
	var isES6ClassFn = function isES6ClassFn(value) {
		try {
			var fnStr = fnToStr.call(value);
			var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
			var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
			var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
			return constructorRegex.test(spaceStripped);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionObject(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ },
/* 441 */
/***/ function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ },
/* 442 */
/***/ function(module, exports) {

	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};


/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = __webpack_require__(2308);


/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);   
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var support = __webpack_require__(233);
	var utils = __webpack_require__(99);
	var crc32 = __webpack_require__(2306);
	var signature = __webpack_require__(966);
	var defaults = __webpack_require__(964);
	var base64 = __webpack_require__(442);
	var compressions = __webpack_require__(443);
	var CompressedObject = __webpack_require__(962);
	var nodeBuffer = __webpack_require__(444);
	var utf8 = __webpack_require__(2313);
	var StringWriter = __webpack_require__(2311);
	var Uint8ArrayWriter = __webpack_require__(2312);
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	var extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub 
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    // Check the name ends with a /
	    if (name.slice(-1) != "/") {
	        name += "/"; // IE doesn't like substr(-1)
	    }
	
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset) {
	    var data = compressedObject.compressedContent,
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(utfEncodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(utfEncodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(utfEncodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    "\x14\x00" +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(utfEncodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    utfEncodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    utfEncodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            type: "base64",
	            comment: null
	        });
	
	        utils.checkSupport(options.type);
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(utfEncodedComment.length, 2) +
	        // .ZIP file comment
	        utfEncodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	      
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;


/***/ },
/* 446 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.PhoneNumberSearch = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = findPhoneNumbers;
	exports.searchPhoneNumbers = searchPhoneNumbers;
	exports.sort_out_arguments = sort_out_arguments;
	
	var _parse = __webpack_require__(150);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _common = __webpack_require__(127);
	
	var _parsePreCandidate = __webpack_require__(2318);
	
	var _parsePreCandidate2 = _interopRequireDefault(_parsePreCandidate);
	
	var _isValidPreCandidate = __webpack_require__(2317);
	
	var _isValidPreCandidate2 = _interopRequireDefault(_isValidPreCandidate);
	
	var _isValidCandidate = __webpack_require__(2316);
	
	var _isValidCandidate2 = _interopRequireDefault(_isValidCandidate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// Copy-pasted from `./parse.js`.
	var VALID_PHONE_NUMBER = '[' + _common.PLUS_CHARS + ']{0,1}' + '(?:' + '[' + _common.VALID_PUNCTUATION + ']*' + '[' + _common.VALID_DIGITS + ']' + '){3,}' + '[' + _common.VALID_PUNCTUATION + _common.VALID_DIGITS + ']*';
	
	var EXTN_PATTERNS_FOR_PARSING = (0, _common.create_extension_pattern)('parsing');
	
	var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + _common.WHITESPACE + ']+');
	var WHITESPACE_IN_THE_END_PATTERN = new RegExp('[' + _common.WHITESPACE + ']+$');
	
	// // Regular expression for getting opening brackets for a valid number
	// // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
	// const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')
	
	var VALID_PRECEDING_CHARACTER_PATTERN = /[^a-zA-Z0-9]/;
	
	function findPhoneNumbers(arg_1, arg_2, arg_3, arg_4) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
		    text = _sort_out_arguments.text,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		var search = new PhoneNumberSearch(text, options, metadata.metadata);
	
		var phones = [];
	
		while (search.hasNext()) {
			phones.push(search.next());
		}
	
		return phones;
	}
	
	/**
	 * @return ES6 `for ... of` iterator.
	 */
	function searchPhoneNumbers(arg_1, arg_2, arg_3, arg_4) {
		var _sort_out_arguments2 = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
		    text = _sort_out_arguments2.text,
		    options = _sort_out_arguments2.options,
		    metadata = _sort_out_arguments2.metadata;
	
		var search = new PhoneNumberSearch(text, options, metadata.metadata);
	
		return _defineProperty({}, Symbol.iterator, function () {
			return {
				next: function next() {
					if (search.hasNext()) {
						return {
							done: false,
							value: search.next()
						};
					}
					return {
						done: true
					};
				}
			};
		});
	}
	
	/**
	 * Extracts a parseable phone number including any opening brackets, etc.
	 * @param  {string} text - Input.
	 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
	 */
	
	var PhoneNumberSearch = exports.PhoneNumberSearch = function () {
		function PhoneNumberSearch(text) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var metadata = arguments[2];
	
			_classCallCheck(this, PhoneNumberSearch);
	
			this.state = 'NOT_READY';
	
			this.text = text;
			this.options = options;
			this.metadata = metadata;
	
			this.regexp = new RegExp(VALID_PHONE_NUMBER +
			// Phone number extensions
			'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?', 'ig');
	
			// this.searching_from = 0
		}
		// Iteration tristate.
	
	
		_createClass(PhoneNumberSearch, [{
			key: 'find',
			value: function find() {
				var matches = this.regexp.exec(this.text);
	
				if (!matches) {
					return;
				}
	
				var number = matches[0];
				var startsAt = matches.index;
	
				number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
				startsAt += matches[0].length - number.length;
				number = number.replace(WHITESPACE_IN_THE_END_PATTERN, '');
	
				number = (0, _parsePreCandidate2.default)(number);
	
				var result = this.parseCandidate(number, startsAt);
	
				if (result) {
					return result;
				}
	
				// Tail recursion.
				// Try the next one if this one is not a valid phone number.
				return this.find();
			}
		}, {
			key: 'parseCandidate',
			value: function parseCandidate(number, startsAt) {
				if (!(0, _isValidPreCandidate2.default)(number, startsAt, this.text)) {
					return;
				}
	
				// Don't parse phone numbers which are non-phone numbers
				// due to being part of something else (e.g. a UUID).
				// https://github.com/catamphetamine/libphonenumber-js/issues/213
				// Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).
				if (!(0, _isValidCandidate2.default)(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
					return;
				}
	
				// // Prepend any opening brackets left behind by the
				// // `PHONE_NUMBER_START_PATTERN` regexp.
				// const text_before_number = text.slice(this.searching_from, startsAt)
				// const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
				// if (full_number_starts_at >= 0)
				// {
				// 	number   = text_before_number.slice(full_number_starts_at) + number
				// 	startsAt = full_number_starts_at
				// }
				//
				// this.searching_from = matches.lastIndex
	
				var result = (0, _parse2.default)(number, this.options, this.metadata);
	
				if (!result.phone) {
					return;
				}
	
				result.startsAt = startsAt;
				result.endsAt = startsAt + number.length;
	
				return result;
			}
		}, {
			key: 'hasNext',
			value: function hasNext() {
				if (this.state === 'NOT_READY') {
					this.last_match = this.find();
	
					if (this.last_match) {
						this.state = 'READY';
					} else {
						this.state = 'DONE';
					}
				}
	
				return this.state === 'READY';
			}
		}, {
			key: 'next',
			value: function next() {
				// Check the state and find the next match as a side-effect if necessary.
				if (!this.hasNext()) {
					throw new Error('No next element');
				}
	
				// Don't retain that memory any longer than necessary.
				var result = this.last_match;
				this.last_match = null;
				this.state = 'NOT_READY';
				return result;
			}
		}]);
	
		return PhoneNumberSearch;
	}();
	
	function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
		var text = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// If the phone number is passed as a string.
		// `parse('88005553535', ...)`.
		if (typeof arg_1 === 'string') {
			text = arg_1;
		} else throw new TypeError('A text for parsing must be a string.');
	
		// If "default country" argument is being passed
		// then move it to `options`.
		// `findNumbers('88005553535', 'RU', [options], metadata)`.
		if (typeof arg_2 === 'string') {
			if (arg_4) {
				options = _extends({ defaultCountry: arg_2 }, arg_3);
				metadata = arg_4;
			} else {
				options = { defaultCountry: arg_2 };
				metadata = arg_3;
			}
		}
		// No "default country" argument is being passed.
		// Only international phone numbers are passed.
		// `findNumbers('+78005553535', [options], metadata)`.
		else {
				if (arg_3) {
					options = arg_2;
					metadata = arg_3;
				} else {
					metadata = arg_2;
				}
			}
	
		if (!options) {
			options = {};
		}
	
		// // Apply default options.
		// if (options)
		// {
		// 	options = { ...default_options, ...options }
		// }
		// else
		// {
		// 	options = default_options
		// }
	
		return { text: text, options: options, metadata: new _metadata2.default(metadata) };
	}
	//# sourceMappingURL=findPhoneNumbers.js.map

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.FIRST_GROUP_PATTERN = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // This is a port of Google Android `libphonenumber`'s
	// `phonenumberutil.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
	
	exports.default = format;
	exports.format_national_number_using_format = format_national_number_using_format;
	exports.choose_format_for_number = choose_format_for_number;
	exports.local_to_international_style = local_to_international_style;
	exports.formatIDDSameCountryCallingCodeNumber = formatIDDSameCountryCallingCodeNumber;
	
	var _common = __webpack_require__(127);
	
	var _IDD = __webpack_require__(970);
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _RFC = __webpack_require__(305);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultOptions = {
		formatExtension: function formatExtension(number, extension, metadata) {
			return '' + number + metadata.ext() + extension;
		}
	
		// Formats a phone number
		//
		// Example use cases:
		//
		// ```js
		// format('8005553535', 'RU', 'International')
		// format('8005553535', 'RU', 'International', metadata)
		// format({ phone: '8005553535', country: 'RU' }, 'International')
		// format({ phone: '8005553535', country: 'RU' }, 'International', metadata)
		// format('+78005553535', 'National')
		// format('+78005553535', 'National', metadata)
		// ```
		//
	};function format(arg_1, arg_2, arg_3, arg_4, arg_5) {
		var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5),
		    input = _sort_out_arguments.input,
		    format_type = _sort_out_arguments.format_type,
		    options = _sort_out_arguments.options,
		    metadata = _sort_out_arguments.metadata;
	
		if (input.country && metadata.hasCountry(input.country)) {
			metadata.country(input.country);
		}
	
		var _parse_national_numbe = (0, _common.parse_national_number_and_country_calling_code)(input.phone, null, metadata),
		    countryCallingCode = _parse_national_numbe.countryCallingCode,
		    number = _parse_national_numbe.number;
	
		countryCallingCode = countryCallingCode || input.countryCallingCode;
	
		if (countryCallingCode) {
			// Check country restriction
			if (input.country && metadata.selectedCountry() && countryCallingCode !== metadata.countryCallingCode()) {
				return input.phone;
			}
	
			metadata.chooseCountryByCountryCallingCode(countryCallingCode);
		}
	
		if (!metadata.selectedCountry()) {
			return input.phone;
		}
	
		switch (format_type) {
			case 'International':
				if (!number) {
					return '+' + metadata.countryCallingCode();
				}
				number = format_national_number(number, 'International', false, metadata);
				number = '+' + metadata.countryCallingCode() + ' ' + number;
				return add_extension(number, input.ext, metadata, options.formatExtension);
	
			case 'E.164':
				// `E.164` doesn't define "phone number extensions".
				return '+' + metadata.countryCallingCode() + input.phone;
	
			case 'RFC3966':
				return (0, _RFC.formatRFC3966)({
					number: '+' + metadata.countryCallingCode() + input.phone,
					ext: input.ext
				});
	
			case 'IDD':
				if (!options.fromCountry) {
					return;
					// throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
				}
				var IDDPrefix = (0, _IDD.getIDDPrefix)(options.fromCountry, metadata.metadata);
				if (!IDDPrefix) {
					return;
				}
				if (options.humanReadable) {
					var formattedForSameCountryCallingCode = countryCallingCode && formatIDDSameCountryCallingCodeNumber(number, countryCallingCode, options.fromCountry, metadata);
					if (formattedForSameCountryCallingCode) {
						number = formattedForSameCountryCallingCode;
					} else {
						number = IDDPrefix + ' ' + metadata.countryCallingCode() + ' ' + format_national_number(number, 'International', false, metadata);
					}
					return add_extension(number, input.ext, metadata, options.formatExtension);
				}
				return '' + IDDPrefix + metadata.countryCallingCode() + number;
	
			case 'National':
				if (!number) {
					return '';
				}
				number = format_national_number(number, 'National', false, metadata);
				return add_extension(number, input.ext, metadata, options.formatExtension);
		}
	}
	
	// This was originally set to $1 but there are some countries for which the
	// first group is not used in the national pattern (e.g. Argentina) so the $1
	// group does not match correctly.  Therefore, we use \d, so that the first
	// group actually used in the pattern will be matched.
	var FIRST_GROUP_PATTERN = exports.FIRST_GROUP_PATTERN = /(\$\d)/;
	
	function format_national_number_using_format(number, format, international, enforce_national_prefix, metadata) {
		var format_pattern_matcher = new RegExp(format.pattern());
	
		// National prefix is omitted if there's no national prefix formatting rule
		// set for this country, or when this rule is set but
		// national prefix is optional for this phone number format
		// (and it is not enforced explicitly)
		var national_prefix_may_be_omitted = !format.nationalPrefixFormattingRule() || format.nationalPrefixFormattingRule() && format.nationalPrefixIsOptionalWhenFormatting() && !enforce_national_prefix;
	
		if (!international && !national_prefix_may_be_omitted) {
			return number.replace(format_pattern_matcher, format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()));
		}
	
		var formatted_number = number.replace(format_pattern_matcher, international ? format.internationalFormat() : format.format());
	
		if (international) {
			return local_to_international_style(formatted_number);
		}
	
		return formatted_number;
	}
	
	function format_national_number(number, format_as, enforce_national_prefix, metadata) {
		var format = choose_format_for_number(metadata.formats(), number);
	
		if (!format) {
			return number;
		}
	
		return format_national_number_using_format(number, format, format_as === 'International', enforce_national_prefix, metadata);
	}
	
	function choose_format_for_number(available_formats, national_number) {
		for (var _iterator = available_formats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var _format = _ref;
	
			// Validate leading digits
			if (_format.leadingDigitsPatterns().length > 0) {
				// The last leading_digits_pattern is used here, as it is the most detailed
				var last_leading_digits_pattern = _format.leadingDigitsPatterns()[_format.leadingDigitsPatterns().length - 1];
	
				// If leading digits don't match then move on to the next phone number format
				if (national_number.search(last_leading_digits_pattern) !== 0) {
					continue;
				}
			}
	
			// Check that the national number matches the phone number format regular expression
			if ((0, _common.matches_entirely)(national_number, new RegExp(_format.pattern()))) {
				return _format;
			}
		}
	}
	
	// Removes brackets and replaces dashes with spaces.
	//
	// E.g. "(999) 111-22-33" -> "999 111 22 33"
	//
	function local_to_international_style(local) {
		return local.replace(new RegExp('[' + _common.VALID_PUNCTUATION + ']+', 'g'), ' ').trim();
	}
	
	// Sort out arguments
	function sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5) {
		var input = void 0;
		var format_type = void 0;
		var options = void 0;
		var metadata = void 0;
	
		// Sort out arguments.
	
		// If the phone number is passed as a string.
		// `format('8005553535', ...)`.
		if (typeof arg_1 === 'string') {
			// If country code is supplied.
			// `format('8005553535', 'RU', 'National', [options], metadata)`.
			if (typeof arg_3 === 'string') {
				// Will be `parse()`d later in code
				input = {
					phone: arg_1,
					country: arg_2
				};
	
				format_type = arg_3;
	
				if (arg_5) {
					options = arg_4;
					metadata = arg_5;
				} else {
					metadata = arg_4;
				}
			}
			// Just an international phone number is supplied
			// `format('+78005553535', 'National', [options], metadata)`.
			else {
					// Will be `parse()`d later in code
					input = {
						phone: arg_1
					};
	
					if (typeof arg_2 !== 'string') {
						throw new Error('Format type argument not passed for `format()`');
					}
	
					format_type = arg_2;
	
					if (arg_4) {
						options = arg_3;
						metadata = arg_4;
					} else {
						metadata = arg_3;
					}
				}
		}
		// If the phone number is passed as a parsed number object.
		// `format({ phone: '8005553535', country: 'RU' }, 'National', [options], metadata)`.
		else if (is_object(arg_1) && typeof arg_1.phone === 'string') {
				input = arg_1;
				format_type = arg_2;
	
				if (arg_4) {
					options = arg_3;
					metadata = arg_4;
				} else {
					metadata = arg_3;
				}
			} else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');
	
		// Validate `format_type`.
		switch (format_type) {
			case 'International':
			case 'E.164':
			case 'National':
			case 'RFC3966':
			case 'IDD':
				break;
			default:
				throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"');
		}
	
		// Apply default options.
		if (options) {
			options = _extends({}, defaultOptions, options);
		} else {
			options = defaultOptions;
		}
	
		return { input: input, format_type: format_type, options: options, metadata: new _metadata2.default(metadata) };
	}
	
	// Babel transforms `typeof` into some "branches"
	// so istanbul will show this as "branch not covered".
	/* istanbul ignore next */
	var is_object = function is_object(_) {
		return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
	};
	
	function add_extension(number, ext, metadata, formatExtension) {
		return ext ? formatExtension(number, ext, metadata) : number;
	}
	
	function formatIDDSameCountryCallingCodeNumber(number, toCountryCallingCode, fromCountry, toCountryMetadata) {
		var fromCountryMetadata = new _metadata2.default(toCountryMetadata.metadata);
		fromCountryMetadata.country(fromCountry);
	
		// If calling within the same country calling code.
		if (toCountryCallingCode === fromCountryMetadata.countryCallingCode()) {
			// For NANPA regions, return the national format for these regions
			// but prefix it with the country calling code.
			if (toCountryCallingCode === '1') {
				return toCountryCallingCode + ' ' + format_national_number(number, 'National', false, toCountryMetadata);
			}
	
			// If regions share a country calling code, the country calling code need
			// not be dialled. This also applies when dialling within a region, so this
			// if clause covers both these cases. Technically this is the case for
			// dialling from La Reunion to other overseas departments of France (French
			// Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
			// this edge case for now and for those cases return the version including
			// country calling code. Details here:
			// http://www.petitfute.com/voyage/225-info-pratiques-reunion
			return format_national_number(number, 'National', false, toCountryMetadata);
		}
	}
	//# sourceMappingURL=format.js.map

/***/ },
/* 449 */
[3453, 152, 100],
/* 450 */
[3454, 2403, 2404, 2405, 2406, 2407],
/* 451 */
[3457, 450, 2412, 2413],
/* 452 */
[3465, 989],
/* 453 */
[3472, 2351, 112],
/* 454 */
[3482, 110, 998, 1000],
/* 455 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 456 */
[3485, 36, 459, 2422, 1014],
/* 457 */
[3498, 2327, 449, 2329, 2330, 2332, 128, 1001],
/* 458 */
[3504, 317, 111, 315, 87],
/* 459 */
[3505, 36, 155],
/* 460 */
[3531, 100, 2448],
/* 461 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(128),
	    isObjectLike = __webpack_require__(112);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 463 */
[3537, 2355, 313, 2410],
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1002),
	    isObject = __webpack_require__(87);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(2368),
	    keys = __webpack_require__(235);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 466 */
/***/ function(module, exports) {



/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(2463);
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};
	
	var keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];
	
		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}
	
		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}
	
		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}
	
		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				return (Object.keys(arguments) || '').length === 2;
			}(1, 2));
			if (!keysWorksWithArguments) {
				var originalKeys = Object.keys;
				Object.keys = function keys(object) {
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					} else {
						return originalKeys(object);
					}
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ },
/* 468 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  2:      'need dictionary',     /* Z_NEED_DICT       2  */
	  1:      'stream end',          /* Z_STREAM_END      1  */
	  0:      '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};


/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createChainedFunction = __webpack_require__(482);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _placements = __webpack_require__(2502);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function refFn(field, component) {
	  this[field] = component;
	}
	
	var Picker = (0, _createReactClass2['default'])({
	  displayName: 'Picker',
	
	  propTypes: {
	    animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
	    disabled: _propTypes2['default'].bool,
	    transitionName: _propTypes2['default'].string,
	    onChange: _propTypes2['default'].func,
	    onOpenChange: _propTypes2['default'].func,
	    children: _propTypes2['default'].func,
	    getCalendarContainer: _propTypes2['default'].func,
	    calendar: _propTypes2['default'].element,
	    style: _propTypes2['default'].object,
	    open: _propTypes2['default'].bool,
	    defaultOpen: _propTypes2['default'].bool,
	    prefixCls: _propTypes2['default'].string,
	    placement: _propTypes2['default'].any,
	    value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
	    defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
	    align: _propTypes2['default'].object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-calendar-picker',
	      style: {},
	      align: {},
	      placement: 'bottomLeft',
	      defaultOpen: false,
	      onChange: noop,
	      onOpenChange: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var open = void 0;
	    if ('open' in props) {
	      open = props.open;
	    } else {
	      open = props.defaultOpen;
	    }
	    var value = props.value || props.defaultValue;
	    this.saveCalendarRef = refFn.bind(this, 'calendarInstance');
	    return {
	      open: open,
	      value: value
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value,
	        open = nextProps.open;
	
	    if ('value' in nextProps) {
	      this.setState({
	        value: value
	      });
	    }
	    if (open !== undefined) {
	      this.setState({
	        open: open
	      });
	    }
	  },
	  componentDidUpdate: function componentDidUpdate(_, prevState) {
	    if (!prevState.open && this.state.open) {
	      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
	      this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.focusTimeout);
	  },
	  onCalendarKeyDown: function onCalendarKeyDown(event) {
	    if (event.keyCode === _KeyCode2['default'].ESC) {
	      event.stopPropagation();
	      this.close(this.focus);
	    }
	  },
	  onCalendarSelect: function onCalendarSelect(value) {
	    var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var props = this.props;
	    if (!('value' in props)) {
	      this.setState({
	        value: value
	      });
	    }
	    if (cause.source === 'keyboard' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
	      this.close(this.focus);
	    }
	    props.onChange(value);
	  },
	  onKeyDown: function onKeyDown(event) {
	    if (event.keyCode === _KeyCode2['default'].DOWN && !this.state.open) {
	      this.open();
	      event.preventDefault();
	    }
	  },
	  onCalendarOk: function onCalendarOk() {
	    this.close(this.focus);
	  },
	  onCalendarClear: function onCalendarClear() {
	    this.close(this.focus);
	  },
	  onVisibleChange: function onVisibleChange(open) {
	    this.setOpen(open);
	  },
	  getCalendarElement: function getCalendarElement() {
	    var props = this.props;
	    var state = this.state;
	    var calendarProps = props.calendar.props;
	    var value = state.value;
	
	    var defaultValue = value;
	    var extraProps = {
	      ref: this.saveCalendarRef,
	      defaultValue: defaultValue || calendarProps.defaultValue,
	      selectedValue: value,
	      onKeyDown: this.onCalendarKeyDown,
	      onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, this.onCalendarOk),
	      onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, this.onCalendarSelect),
	      onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, this.onCalendarClear)
	    };
	
	    return _react2['default'].cloneElement(props.calendar, extraProps);
	  },
	  setOpen: function setOpen(open, callback) {
	    var onOpenChange = this.props.onOpenChange;
	
	    if (this.state.open !== open) {
	      if (!('open' in this.props)) {
	        this.setState({
	          open: open
	        }, callback);
	      }
	      onOpenChange(open);
	    }
	  },
	  open: function open(callback) {
	    this.setOpen(true, callback);
	  },
	  close: function close(callback) {
	    this.setOpen(false, callback);
	  },
	  focus: function focus() {
	    if (!this.state.open) {
	      _reactDom2['default'].findDOMNode(this).focus();
	    }
	  },
	  focusCalendar: function focusCalendar() {
	    if (this.state.open && this.calendarInstance !== null) {
	      this.calendarInstance.focus();
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        placement = props.placement,
	        style = props.style,
	        getCalendarContainer = props.getCalendarContainer,
	        align = props.align,
	        animation = props.animation,
	        disabled = props.disabled,
	        transitionName = props.transitionName,
	        children = props.children;
	
	    var state = this.state;
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      {
	        popup: this.getCalendarElement(),
	        popupAlign: align,
	        builtinPlacements: _placements2['default'],
	        popupPlacement: placement,
	        action: disabled && !state.open ? [] : ['click'],
	        destroyPopupOnHide: true,
	        getPopupContainer: getCalendarContainer,
	        popupStyle: style,
	        popupAnimation: animation,
	        popupTransitionName: transitionName,
	        popupVisible: state.open,
	        onPopupVisibleChange: this.onVisibleChange,
	        prefixCls: prefixCls
	      },
	      _react2['default'].cloneElement(children(state, props), { onKeyDown: this.onKeyDown })
	    );
	  }
	});
	
	exports['default'] = Picker;
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mapSelf = __webpack_require__(1196);
	
	var _mapSelf2 = _interopRequireDefault(_mapSelf);
	
	var _MonthPanel = __webpack_require__(2501);
	
	var _MonthPanel2 = _interopRequireDefault(_MonthPanel);
	
	var _YearPanel = __webpack_require__(2504);
	
	var _YearPanel2 = _interopRequireDefault(_YearPanel);
	
	var _DecadePanel = __webpack_require__(2496);
	
	var _DecadePanel2 = _interopRequireDefault(_DecadePanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function goMonth(direction) {
	  var next = this.props.value.clone();
	  next.add(direction, 'months');
	  this.props.onValueChange(next);
	}
	
	function goYear(direction) {
	  var next = this.props.value.clone();
	  next.add(direction, 'years');
	  this.props.onValueChange(next);
	}
	
	function showIf(condition, el) {
	  return condition ? el : null;
	}
	
	var CalendarHeader = (0, _createReactClass2['default'])({
	  displayName: 'CalendarHeader',
	
	  propTypes: {
	    prefixCls: _propTypes2['default'].string,
	    value: _propTypes2['default'].object,
	    onValueChange: _propTypes2['default'].func,
	    showTimePicker: _propTypes2['default'].bool,
	    onPanelChange: _propTypes2['default'].func,
	    locale: _propTypes2['default'].object,
	    enablePrev: _propTypes2['default'].any,
	    enableNext: _propTypes2['default'].any,
	    disabledMonth: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      enableNext: 1,
	      enablePrev: 1,
	      onPanelChange: function onPanelChange() {},
	      onValueChange: function onValueChange() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.nextMonth = goMonth.bind(this, 1);
	    this.previousMonth = goMonth.bind(this, -1);
	    this.nextYear = goYear.bind(this, 1);
	    this.previousYear = goYear.bind(this, -1);
	    return { yearPanelReferer: null };
	  },
	  onMonthSelect: function onMonthSelect(value) {
	    this.props.onPanelChange(value, 'date');
	    if (this.props.onMonthSelect) {
	      this.props.onMonthSelect(value);
	    } else {
	      this.props.onValueChange(value);
	    }
	  },
	  onYearSelect: function onYearSelect(value) {
	    var referer = this.state.yearPanelReferer;
	    this.setState({ yearPanelReferer: null });
	    this.props.onPanelChange(value, referer);
	    this.props.onValueChange(value);
	  },
	  onDecadeSelect: function onDecadeSelect(value) {
	    this.props.onPanelChange(value, 'year');
	    this.props.onValueChange(value);
	  },
	  monthYearElement: function monthYearElement(showTimePicker) {
	    var _this = this;
	
	    var props = this.props;
	    var prefixCls = props.prefixCls;
	    var locale = props.locale;
	    var value = props.value;
	    var localeData = value.localeData();
	    var monthBeforeYear = locale.monthBeforeYear;
	    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
	    var year = _react2['default'].createElement(
	      'a',
	      {
	        className: prefixCls + '-year-select',
	        role: 'button',
	        onClick: showTimePicker ? null : function () {
	          return _this.showYearPanel('date');
	        },
	        title: locale.yearSelect
	      },
	      value.format(locale.yearFormat)
	    );
	    var month = _react2['default'].createElement(
	      'a',
	      {
	        className: prefixCls + '-month-select',
	        role: 'button',
	        onClick: showTimePicker ? null : this.showMonthPanel,
	        title: locale.monthSelect
	      },
	      localeData.monthsShort(value)
	    );
	    var day = void 0;
	    if (showTimePicker) {
	      day = _react2['default'].createElement(
	        'a',
	        {
	          className: prefixCls + '-day-select',
	          role: 'button'
	        },
	        value.format(locale.dayFormat)
	      );
	    }
	    var my = [];
	    if (monthBeforeYear) {
	      my = [month, day, year];
	    } else {
	      my = [year, month, day];
	    }
	    return _react2['default'].createElement(
	      'span',
	      { className: selectClassName },
	      (0, _mapSelf2['default'])(my)
	    );
	  },
	  showMonthPanel: function showMonthPanel() {
	    // null means that users' interaction doesn't change value
	    this.props.onPanelChange(null, 'month');
	  },
	  showYearPanel: function showYearPanel(referer) {
	    this.setState({ yearPanelReferer: referer });
	    this.props.onPanelChange(null, 'year');
	  },
	  showDecadePanel: function showDecadePanel() {
	    this.props.onPanelChange(null, 'decade');
	  },
	  render: function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        locale = props.locale,
	        mode = props.mode,
	        value = props.value,
	        showTimePicker = props.showTimePicker,
	        enableNext = props.enableNext,
	        enablePrev = props.enablePrev,
	        disabledMonth = props.disabledMonth;
	
	
	    var panel = null;
	    if (mode === 'month') {
	      panel = _react2['default'].createElement(_MonthPanel2['default'], {
	        locale: locale,
	        defaultValue: value,
	        rootPrefixCls: prefixCls,
	        onSelect: this.onMonthSelect,
	        onYearPanelShow: function onYearPanelShow() {
	          return _this2.showYearPanel('month');
	        },
	        disabledDate: disabledMonth,
	        cellRender: props.monthCellRender,
	        contentRender: props.monthCellContentRender
	      });
	    }
	    if (mode === 'year') {
	      panel = _react2['default'].createElement(_YearPanel2['default'], {
	        locale: locale,
	        defaultValue: value,
	        rootPrefixCls: prefixCls,
	        onSelect: this.onYearSelect,
	        onDecadePanelShow: this.showDecadePanel
	      });
	    }
	    if (mode === 'decade') {
	      panel = _react2['default'].createElement(_DecadePanel2['default'], {
	        locale: locale,
	        defaultValue: value,
	        rootPrefixCls: prefixCls,
	        onSelect: this.onDecadeSelect
	      });
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-header' },
	      _react2['default'].createElement(
	        'div',
	        { style: { position: 'relative' } },
	        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-prev-year-btn',
	          role: 'button',
	          onClick: this.previousYear,
	          title: locale.previousYear
	        })),
	        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-prev-month-btn',
	          role: 'button',
	          onClick: this.previousMonth,
	          title: locale.previousMonth
	        })),
	        this.monthYearElement(showTimePicker),
	        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-next-month-btn',
	          onClick: this.nextMonth,
	          title: locale.nextMonth
	        })),
	        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-next-year-btn',
	          onClick: this.nextYear,
	          title: locale.nextYear
	        }))
	      ),
	      panel
	    );
	  }
	});
	
	exports['default'] = CalendarHeader;
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateTHead = __webpack_require__(2495);
	
	var _DateTHead2 = _interopRequireDefault(_DateTHead);
	
	var _DateTBody = __webpack_require__(2494);
	
	var _DateTBody2 = _interopRequireDefault(_DateTBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DateTable = function (_React$Component) {
	  (0, _inherits3['default'])(DateTable, _React$Component);
	
	  function DateTable() {
	    (0, _classCallCheck3['default'])(this, DateTable);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DateTable.prototype.render = function render() {
	    var props = this.props;
	    var prefixCls = props.prefixCls;
	    return _react2['default'].createElement(
	      'table',
	      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	      _react2['default'].createElement(_DateTHead2['default'], props),
	      _react2['default'].createElement(_DateTBody2['default'], props)
	    );
	  };
	
	  return DateTable;
	}(_react2['default'].Component);
	
	exports['default'] = DateTable;
	module.exports = exports['default'];

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getNow() {
	  return (0, _moment2['default'])();
	}
	
	function getNowByCurrentStateValue(value) {
	  var ret = void 0;
	  if (value) {
	    ret = (0, _index.getTodayTime)(value);
	  } else {
	    ret = getNow();
	  }
	  return ret;
	}
	
	var CalendarMixin = {
	  propTypes: {
	    value: _propTypes2['default'].object,
	    defaultValue: _propTypes2['default'].object,
	    onKeyDown: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onKeyDown: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var value = props.value || props.defaultValue || getNow();
	    return {
	      value: value,
	      selectedValue: props.selectedValue || props.defaultSelectedValue
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var value = nextProps.value;
	    var selectedValue = nextProps.selectedValue;
	
	    if ('value' in nextProps) {
	      value = value || nextProps.defaultValue || getNowByCurrentStateValue(this.state.value);
	      this.setState({
	        value: value
	      });
	    }
	    if ('selectedValue' in nextProps) {
	      this.setState({
	        selectedValue: selectedValue
	      });
	    }
	  },
	  onSelect: function onSelect(value, cause) {
	    if (value) {
	      this.setValue(value);
	    }
	    this.setSelectedValue(value, cause);
	  },
	  renderRoot: function renderRoot(newProps) {
	    var _className;
	
	    var props = this.props;
	    var prefixCls = props.prefixCls;
	
	    var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);
	
	    return _react2['default'].createElement(
	      'div',
	      {
	        ref: this.saveRoot,
	        className: '' + (0, _classnames2['default'])(className),
	        style: this.props.style,
	        tabIndex: '0',
	        onKeyDown: this.onKeyDown
	      },
	      newProps.children
	    );
	  },
	  setSelectedValue: function setSelectedValue(selectedValue, cause) {
	    // if (this.isAllowedDate(selectedValue)) {
	    if (!('selectedValue' in this.props)) {
	      this.setState({
	        selectedValue: selectedValue
	      });
	    }
	    this.props.onSelect(selectedValue, cause);
	    // }
	  },
	  setValue: function setValue(value) {
	    var originalValue = this.state.value;
	    if (!('value' in this.props)) {
	      this.setState({
	        value: value
	      });
	    }
	    if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
	      this.props.onChange(value);
	    }
	  },
	  isAllowedDate: function isAllowedDate(value) {
	    var disabledDate = this.props.disabledDate;
	    var disabledTime = this.props.disabledTime;
	    return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
	  }
	};
	
	exports['default'] = CalendarMixin;
	module.exports = exports['default'];

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports['default'] = exportContent;
	
	var _draftJs = __webpack_require__(124);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function encodeContent(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br > \n');
	}
	
	var MentionGenerator = function () {
	  function MentionGenerator(contentState, options) {
	    (0, _classCallCheck3['default'])(this, MentionGenerator);
	
	    this.contentState = contentState;
	    this.options = options;
	  }
	
	  MentionGenerator.prototype.generate = function generate() {
	    var contentRaw = (0, _draftJs.convertToRaw)(this.contentState);
	    return this.processContent(contentRaw);
	  };
	
	  MentionGenerator.prototype.processContent = function processContent(contentRaw) {
	    var blocks = contentRaw.blocks;
	    var encode = this.options.encode;
	
	    return blocks.map(function (block) {
	      return encode ? encodeContent(block.text) : block.text;
	    }).join(encode ? '<br />\n' : '\n');
	  };
	
	  return MentionGenerator;
	}();
	
	function exportContent(contentState) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return new MentionGenerator(contentState, options).generate();
	}
	module.exports = exports['default'];

/***/ },
/* 474 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getSearchWord;
	function getWord(text, position) {
	  var str = String(text);
	  /* eslint no-bitwise:0 */
	  var pos = Number(position) >>> 0;
	
	  // Search for the word's beginning and end.
	  var left = str.slice(0, pos + 1).search(/\S+$/);
	  var right = str.slice(pos).search(/\s/);
	
	  if (right < 0) {
	    return {
	      word: str.slice(left),
	      begin: left,
	      end: str.length
	    };
	  }
	
	  // Return the word, using the located bounds to extract it from the string.
	  return {
	    word: str.slice(left, right + pos),
	    begin: left,
	    end: right + pos
	  };
	}
	
	function getSearchWord(editorState, selection) {
	  var anchorKey = selection.getAnchorKey();
	  var anchorOffset = selection.getAnchorOffset() - 1;
	  var currentContent = editorState.getCurrentContent();
	  var currentBlock = currentContent.getBlockForKey(anchorKey);
	  if (currentBlock) {
	    var blockText = currentBlock.getText();
	    return getWord(blockText, anchorOffset);
	  }
	  return '';
	}
	module.exports = exports['default'];

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.argumentContainer = argumentContainer;
	exports.identity = identity;
	exports.flattenArray = flattenArray;
	exports.treeTraverse = treeTraverse;
	exports.flattenFields = flattenFields;
	exports.normalizeValidateRules = normalizeValidateRules;
	exports.getValidateTriggers = getValidateTriggers;
	exports.getValueFromEvent = getValueFromEvent;
	exports.getErrorStrs = getErrorStrs;
	exports.getParams = getParams;
	exports.isEmptyObject = isEmptyObject;
	exports.hasRules = hasRules;
	exports.startsWith = startsWith;
	
	var _hoistNonReactStatics = __webpack_require__(231);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
	}
	
	function argumentContainer(Container, WrappedComponent) {
	  /* eslint no-param-reassign:0 */
	  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
	  Container.WrappedComponent = WrappedComponent;
	  return (0, _hoistNonReactStatics2['default'])(Container, WrappedComponent);
	}
	
	function identity(obj) {
	  return obj;
	}
	
	function flattenArray(arr) {
	  return Array.prototype.concat.apply([], arr);
	}
	
	function treeTraverse() {
	  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var tree = arguments[1];
	  var isLeafNode = arguments[2];
	  var errorMessage = arguments[3];
	  var callback = arguments[4];
	
	  if (isLeafNode(path, tree)) {
	    callback(path, tree);
	  } else if (tree === undefined) {
	    return;
	  } else if (Array.isArray(tree)) {
	    tree.forEach(function (subTree, index) {
	      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
	    });
	  } else {
	    // It's object and not a leaf node
	    if ((typeof tree === 'undefined' ? 'undefined' : (0, _typeof3['default'])(tree)) !== 'object') {
	      console.error(errorMessage);
	      return;
	    }
	    Object.keys(tree).forEach(function (subTreeKey) {
	      var subTree = tree[subTreeKey];
	      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
	    });
	  }
	}
	
	function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
	  var fields = {};
	  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
	    fields[path] = node;
	  });
	  return fields;
	}
	
	function normalizeValidateRules(validate, rules, validateTrigger) {
	  var validateRules = validate.map(function (item) {
	    var newItem = (0, _extends3['default'])({}, item, {
	      trigger: item.trigger || []
	    });
	    if (typeof newItem.trigger === 'string') {
	      newItem.trigger = [newItem.trigger];
	    }
	    return newItem;
	  });
	  if (rules) {
	    validateRules.push({
	      trigger: validateTrigger ? [].concat(validateTrigger) : [],
	      rules: rules
	    });
	  }
	  return validateRules;
	}
	
	function getValidateTriggers(validateRules) {
	  return validateRules.filter(function (item) {
	    return !!item.rules && item.rules.length;
	  }).map(function (item) {
	    return item.trigger;
	  }).reduce(function (pre, curr) {
	    return pre.concat(curr);
	  }, []);
	}
	
	function getValueFromEvent(e) {
	  // To support custom element
	  if (!e || !e.target) {
	    return e;
	  }
	  var target = e.target;
	
	  return target.type === 'checkbox' ? target.checked : target.value;
	}
	
	function getErrorStrs(errors) {
	  if (errors) {
	    return errors.map(function (e) {
	      if (e && e.message) {
	        return e.message;
	      }
	      return e;
	    });
	  }
	  return errors;
	}
	
	function getParams(ns, opt, cb) {
	  var names = ns;
	  var options = opt;
	  var callback = cb;
	  if (cb === undefined) {
	    if (typeof names === 'function') {
	      callback = names;
	      options = {};
	      names = undefined;
	    } else if (Array.isArray(names)) {
	      if (typeof options === 'function') {
	        callback = options;
	        options = {};
	      } else {
	        options = options || {};
	      }
	    } else {
	      callback = options;
	      options = names || {};
	      names = undefined;
	    }
	  }
	  return {
	    names: names,
	    options: options,
	    callback: callback
	  };
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function hasRules(validate) {
	  if (validate) {
	    return validate.some(function (item) {
	      return item.rules && item.rules.length;
	    });
	  }
	  return false;
	}
	
	function startsWith(str, prefix) {
	  return str.lastIndexOf(prefix, 0) === 0;
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_STYLE = undefined;
	exports.getValuePropValue = getValuePropValue;
	exports.getPropValue = getPropValue;
	exports.isMultiple = isMultiple;
	exports.isCombobox = isCombobox;
	exports.isMultipleOrTags = isMultipleOrTags;
	exports.isMultipleOrTagsOrCombobox = isMultipleOrTagsOrCombobox;
	exports.isSingleMode = isSingleMode;
	exports.toArray = toArray;
	exports.preventDefaultEvent = preventDefaultEvent;
	exports.findIndexInValueByKey = findIndexInValueByKey;
	exports.findIndexInValueByLabel = findIndexInValueByLabel;
	exports.getSelectKeys = getSelectKeys;
	exports.findFirstMenuItem = findFirstMenuItem;
	exports.includesSeparators = includesSeparators;
	exports.splitBySeparators = splitBySeparators;
	exports.defaultFilterFn = defaultFilterFn;
	exports.validateOptionValue = validateOptionValue;
	exports.saveRef = saveRef;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getValuePropValue(child) {
	  var props = child.props;
	  if ('value' in props) {
	    return props.value;
	  }
	  if (child.key) {
	    return child.key;
	  }
	  if (child.type && child.type.isSelectOptGroup && props.label) {
	    return props.label;
	  }
	  throw new Error('Need at least a key or a value or a label (only for OptGroup) for ' + child);
	}
	
	function getPropValue(child, prop) {
	  if (prop === 'value') {
	    return getValuePropValue(child);
	  }
	  return child.props[prop];
	}
	
	function isMultiple(props) {
	  return props.multiple;
	}
	
	function isCombobox(props) {
	  return props.combobox;
	}
	
	function isMultipleOrTags(props) {
	  return props.multiple || props.tags;
	}
	
	function isMultipleOrTagsOrCombobox(props) {
	  return isMultipleOrTags(props) || isCombobox(props);
	}
	
	function isSingleMode(props) {
	  return !isMultipleOrTagsOrCombobox(props);
	}
	
	function toArray(value) {
	  var ret = value;
	  if (value === undefined) {
	    ret = [];
	  } else if (!Array.isArray(value)) {
	    ret = [value];
	  }
	  return ret;
	}
	
	function preventDefaultEvent(e) {
	  e.preventDefault();
	}
	
	function findIndexInValueByKey(value, key) {
	  var index = -1;
	  for (var i = 0; i < value.length; i++) {
	    if (value[i].key === key) {
	      index = i;
	      break;
	    }
	  }
	  return index;
	}
	
	function findIndexInValueByLabel(value, label) {
	  var index = -1;
	  for (var i = 0; i < value.length; i++) {
	    if (toArray(value[i].label).join('') === label) {
	      index = i;
	      break;
	    }
	  }
	  return index;
	}
	
	function getSelectKeys(menuItems, value) {
	  if (value === null || value === undefined) {
	    return [];
	  }
	  var selectedKeys = [];
	  _react2['default'].Children.forEach(menuItems, function (item) {
	    if (item.type.isMenuItemGroup) {
	      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
	    } else {
	      var itemValue = getValuePropValue(item);
	      var itemKey = item.key;
	      if (findIndexInValueByKey(value, itemValue) !== -1 && itemKey) {
	        selectedKeys.push(itemKey);
	      }
	    }
	  });
	  return selectedKeys;
	}
	
	var UNSELECTABLE_STYLE = exports.UNSELECTABLE_STYLE = {
	  userSelect: 'none',
	  WebkitUserSelect: 'none'
	};
	
	var UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_ATTRIBUTE = {
	  unselectable: 'unselectable'
	};
	
	function findFirstMenuItem(children) {
	  for (var i = 0; i < children.length; i++) {
	    var child = children[i];
	    if (child.type.isMenuItemGroup) {
	      var found = findFirstMenuItem(child.props.children);
	      if (found) {
	        return found;
	      }
	    } else if (!child.props.disabled) {
	      return child;
	    }
	  }
	  return null;
	}
	
	function includesSeparators(string, separators) {
	  for (var i = 0; i < separators.length; ++i) {
	    if (string.lastIndexOf(separators[i]) > 0) {
	      return true;
	    }
	  }
	  return false;
	}
	
	function splitBySeparators(string, separators) {
	  var reg = new RegExp('[' + separators.join() + ']');
	  return string.split(reg).filter(function (token) {
	    return token;
	  });
	}
	
	function defaultFilterFn(input, child) {
	  if (child.props.disabled) {
	    return false;
	  }
	  var value = String(getPropValue(child, this.props.optionFilterProp));
	  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
	}
	
	function validateOptionValue(value, props) {
	  if (isSingleMode(props) || isMultiple(props)) {
	    return;
	  }
	  if (typeof value !== 'string') {
	    throw new Error('Invalid `value` of type `' + typeof value + '` supplied to Option, ' + 'expected `string` when `tags/combobox` is `true`.');
	  }
	}
	
	function saveRef(instance, name) {
	  return function (node) {
	    instance[name] = node;
	  };
	}

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isEventFromHandle = isEventFromHandle;
	exports.isValueOutOfRange = isValueOutOfRange;
	exports.isNotTouchEvent = isNotTouchEvent;
	exports.getClosestPoint = getClosestPoint;
	exports.getPrecision = getPrecision;
	exports.getMousePosition = getMousePosition;
	exports.getTouchPosition = getTouchPosition;
	exports.getHandleCenterPosition = getHandleCenterPosition;
	exports.ensureValueInRange = ensureValueInRange;
	exports.ensureValuePrecision = ensureValuePrecision;
	exports.pauseEvent = pauseEvent;
	exports.getKeyboardValueMutator = getKeyboardValueMutator;
	
	var _reactDom = __webpack_require__(14);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isEventFromHandle(e, handles) {
	  return Object.keys(handles).some(function (key) {
	    return e.target === (0, _reactDom.findDOMNode)(handles[key]);
	  });
	}
	
	function isValueOutOfRange(value, _ref) {
	  var min = _ref.min,
	      max = _ref.max;
	
	  return value < min || value > max;
	}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getClosestPoint(val, _ref2) {
	  var marks = _ref2.marks,
	      step = _ref2.step,
	      min = _ref2.min;
	
	  var points = Object.keys(marks).map(parseFloat);
	  if (step !== null) {
	    var closestStep = Math.round((val - min) / step) * step + min;
	    points.push(closestStep);
	  }
	  var diffs = points.map(function (point) {
	    return Math.abs(val - point);
	  });
	  return points[diffs.indexOf(Math.min.apply(Math, diffs))];
	}
	
	function getPrecision(step) {
	  var stepString = step.toString();
	  var precision = 0;
	  if (stepString.indexOf('.') >= 0) {
	    precision = stepString.length - stepString.indexOf('.') - 1;
	  }
	  return precision;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getHandleCenterPosition(vertical, handle) {
	  var coords = handle.getBoundingClientRect();
	  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
	}
	
	function ensureValueInRange(val, _ref3) {
	  var max = _ref3.max,
	      min = _ref3.min;
	
	  if (val <= min) {
	    return min;
	  }
	  if (val >= max) {
	    return max;
	  }
	  return val;
	}
	
	function ensureValuePrecision(val, props) {
	  var step = props.step;
	
	  var closestPoint = getClosestPoint(val, props);
	  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	function getKeyboardValueMutator(e) {
	  switch (e.keyCode) {
	    case _KeyCode2['default'].UP:
	    case _KeyCode2['default'].RIGHT:
	      return function (value, props) {
	        return value + props.step;
	      };
	
	    case _KeyCode2['default'].DOWN:
	    case _KeyCode2['default'].LEFT:
	      return function (value, props) {
	        return value - props.step;
	      };
	
	    case _KeyCode2['default'].END:
	      return function (value, props) {
	        return props.max;
	      };
	    case _KeyCode2['default'].HOME:
	      return function (value, props) {
	        return props.min;
	      };
	    case _KeyCode2['default'].PAGE_UP:
	      return function (value, props) {
	        return value + props.step * 2;
	      };
	    case _KeyCode2['default'].PAGE_DOWN:
	      return function (value, props) {
	        return value - props.step * 2;
	      };
	
	    default:
	      return undefined;
	  }
	}

/***/ },
/* 478 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  saveRef: function saveRef(name) {
	    var _this = this;
	
	    return function (node) {
	      _this[name] = node;
	    };
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utils = __webpack_require__(156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      styles: {}
	    };
	  },
	  onTabClick: function onTabClick(key) {
	    this.props.onTabClick(key);
	  },
	  getTabs: function getTabs() {
	    var _this = this;
	
	    var _props = this.props,
	        children = _props.panels,
	        activeKey = _props.activeKey,
	        prefixCls = _props.prefixCls,
	        tabBarGutter = _props.tabBarGutter;
	
	    var rst = [];
	
	    _react2['default'].Children.forEach(children, function (child, index) {
	      if (!child) {
	        return;
	      }
	      var key = child.key;
	      var cls = activeKey === key ? prefixCls + '-tab-active' : '';
	      cls += ' ' + prefixCls + '-tab';
	      var events = {};
	      if (child.props.disabled) {
	        cls += ' ' + prefixCls + '-tab-disabled';
	      } else {
	        events = {
	          onClick: _this.onTabClick.bind(_this, key)
	        };
	      }
	      var ref = {};
	      if (activeKey === key) {
	        ref.ref = _this.saveRef('activeTab');
	      }
	      (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
	      rst.push(_react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          role: 'tab',
	          'aria-disabled': child.props.disabled ? 'true' : 'false',
	          'aria-selected': activeKey === key ? 'true' : 'false'
	        }, events, {
	          className: cls,
	          key: key,
	          style: { marginRight: tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter }
	        }, ref),
	        child.props.tab
	      ));
	    });
	
	    return rst;
	  },
	  getRootNode: function getRootNode(contents) {
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        onKeyDown = _props2.onKeyDown,
	        className = _props2.className,
	        extraContent = _props2.extraContent,
	        style = _props2.style,
	        tabBarPosition = _props2.tabBarPosition,
	        restProps = (0, _objectWithoutProperties3['default'])(_props2, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition']);
	
	    var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
	    var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
	    var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
	    var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
	    var children = contents;
	    if (extraContent) {
	      children = [(0, _react.cloneElement)(extraContent, {
	        key: 'extra',
	        style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
	      }), (0, _react.cloneElement)(contents, { key: 'content' })];
	      children = topOrBottom ? children : children.reverse();
	    }
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({
	        role: 'tablist',
	        className: cls,
	        tabIndex: '0',
	        ref: this.saveRef('root'),
	        onKeyDown: onKeyDown,
	        style: style
	      }, (0, _utils.getDataAttr)(restProps)),
	      children
	    );
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 480 */
[3341, 2606, 1182, 329],
/* 481 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var SHOW_ALL = exports.SHOW_ALL = 'SHOW_ALL';
	var SHOW_PARENT = exports.SHOW_PARENT = 'SHOW_PARENT';
	var SHOW_CHILD = exports.SHOW_CHILD = 'SHOW_CHILD';

/***/ },
/* 482 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createChainedFunction;
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  var args = [].slice.call(arguments, 0);
	  if (args.length === 1) {
	    return args[0];
	  }
	
	  return function chainedFunction() {
	    for (var i = 0; i < args.length; i++) {
	      if (args[i] && args[i].apply) {
	        args[i].apply(this, arguments);
	      }
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 483 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = compareObjects;
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	
	  var keysMap = {};
	  var i = void 0,
	      len = void 0;
	
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	
	    if (aValue === bValue) {
	      continue;
	    }
	
	    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
	      return true;
	    }
	
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(322);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _Button = __webpack_require__(241);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  vertical: _propTypes2.default.bool,
	  justified: _propTypes2.default.bool,
	
	  /**
	   * Display block buttons; only useful when used with the "vertical" prop.
	   * @type {bool}
	   */
	  block: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var block = _ref.block,
	        vertical = _ref.vertical;
	    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
	  })
	};
	
	var defaultProps = {
	  block: false,
	  justified: false,
	  vertical: false
	};
	
	var ButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ButtonGroup, _React$Component);
	
	  function ButtonGroup() {
	    (0, _classCallCheck3.default)(this, ButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonGroup.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        block = _props.block,
	        justified = _props.justified,
	        vertical = _props.vertical,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['block', 'justified', 'vertical', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps)] = !vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'vertical')] = vertical, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2[(0, _bootstrapUtils.prefix)(_Button2.default.defaultProps, 'block')] = block, _extends2));
	
	    return _react2.default.createElement('div', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonGroup;
	}(_react2.default.Component);
	
	ButtonGroup.propTypes = propTypes;
	ButtonGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-group', ButtonGroup);
	module.exports = exports['default'];

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  label: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  label: 'Close'
	};
	
	var CloseButton = function (_React$Component) {
	  (0, _inherits3.default)(CloseButton, _React$Component);
	
	  function CloseButton() {
	    (0, _classCallCheck3.default)(this, CloseButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CloseButton.prototype.render = function render() {
	    var _props = this.props,
	        label = _props.label,
	        onClick = _props.onClick;
	
	    return _react2.default.createElement(
	      'button',
	      {
	        type: 'button',
	        className: 'close',
	        onClick: onClick
	      },
	      _react2.default.createElement(
	        'span',
	        { 'aria-hidden': 'true' },
	        '\xD7'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      )
	    );
	  };
	
	  return CloseButton;
	}(_react2.default.Component);
	
	CloseButton.propTypes = propTypes;
	CloseButton.defaultProps = defaultProps;
	
	exports.default = CloseButton;
	module.exports = exports['default'];

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _style = __webpack_require__(294);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Transition = __webpack_require__(1248);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _capitalize = __webpack_require__(1217);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MARGINS = {
	  height: ['marginTop', 'marginBottom'],
	  width: ['marginLeft', 'marginRight']
	};
	
	// reading a dimension prop will cause the browser to recalculate,
	// which will let our animations work
	function triggerBrowserReflow(node) {
	  node.offsetHeight; // eslint-disable-line no-unused-expressions
	}
	
	function getDimensionValue(dimension, elem) {
	  var value = elem['offset' + (0, _capitalize2.default)(dimension)];
	  var margins = MARGINS[dimension];
	
	  return value + parseInt((0, _style2.default)(elem, margins[0]), 10) + parseInt((0, _style2.default)(elem, margins[1]), 10);
	}
	
	var propTypes = {
	  /**
	   * Show the component; triggers the expand or collapse animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is collapsed
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the expand animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * Duration of the collapse animation in milliseconds, to ensure that
	   * finishing callbacks are fired even if the original browser transition end
	   * events are canceled
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * Callback fired before the component expands
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to expand
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has expanded
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the component collapses
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the component starts to collapse
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the component has collapsed
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * The dimension used when collapsing, or a function that returns the
	   * dimension
	   *
	   * _Note: Bootstrap only partially supports 'width'!
	   * You will need to supply your own CSS animation for the `.width` CSS class._
	   */
	  dimension: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['height', 'width']), _propTypes2.default.func]),
	
	  /**
	   * Function that returns the height or width of the animating DOM node
	   *
	   * Allows for providing some custom logic for how much the Collapse component
	   * should animate in its specified dimension. Called with the current
	   * dimension prop value and the DOM node.
	   */
	  getDimensionValue: _propTypes2.default.func,
	
	  /**
	   * ARIA role of collapsible element
	   */
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  in: false,
	  timeout: 300,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  dimension: 'height',
	  getDimensionValue: getDimensionValue
	};
	
	var Collapse = function (_React$Component) {
	  (0, _inherits3.default)(Collapse, _React$Component);
	
	  function Collapse(props, context) {
	    (0, _classCallCheck3.default)(this, Collapse);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleEntered = _this.handleEntered.bind(_this);
	    _this.handleExit = _this.handleExit.bind(_this);
	    _this.handleExiting = _this.handleExiting.bind(_this);
	    return _this;
	  }
	
	  Collapse.prototype._dimension = function _dimension() {
	    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
	  };
	
	  // for testing
	
	
	  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
	    return elem['scroll' + (0, _capitalize2.default)(dimension)] + 'px';
	  };
	
	  /* -- Expanding -- */
	
	
	  Collapse.prototype.handleEnter = function handleEnter(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.handleEntered = function handleEntered(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = null;
	  };
	
	  Collapse.prototype.handleEntering = function handleEntering(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
	  };
	
	  /* -- Collapsing -- */
	
	
	  Collapse.prototype.handleExit = function handleExit(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
	    triggerBrowserReflow(elem);
	  };
	
	  Collapse.prototype.handleExiting = function handleExiting(elem) {
	    var dimension = this._dimension();
	    elem.style[dimension] = '0';
	  };
	
	  Collapse.prototype.render = function render() {
	    var _props = this.props,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);
	
	
	    delete props.dimension;
	    delete props.getDimensionValue;
	
	    var handleEnter = (0, _createChainedFunction2.default)(this.handleEnter, onEnter);
	    var handleEntering = (0, _createChainedFunction2.default)(this.handleEntering, onEntering);
	    var handleEntered = (0, _createChainedFunction2.default)(this.handleEntered, onEntered);
	    var handleExit = (0, _createChainedFunction2.default)(this.handleExit, onExit);
	    var handleExiting = (0, _createChainedFunction2.default)(this.handleExiting, onExiting);
	
	    var classes = {
	      width: this._dimension() === 'width'
	    };
	
	    return _react2.default.createElement(_Transition2.default, (0, _extends3.default)({}, props, {
	      'aria-expanded': props.role ? props.in : null,
	      className: (0, _classnames2.default)(className, classes),
	      exitedClassName: 'collapse',
	      exitingClassName: 'collapsing',
	      enteredClassName: 'collapse in',
	      enteringClassName: 'collapsing',
	      onEnter: handleEnter,
	      onEntering: handleEntering,
	      onEntered: handleEntered,
	      onExit: handleExit,
	      onExiting: handleExiting
	    }));
	  };
	
	  return Collapse;
	}(_react2.default.Component);
	
	Collapse.propTypes = propTypes;
	Collapse.defaultProps = defaultProps;
	
	exports.default = Collapse;
	module.exports = exports['default'];

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
	   */
	  glyph: _propTypes2.default.string.isRequired
	};
	
	var Glyphicon = function (_React$Component) {
	  (0, _inherits3.default)(Glyphicon, _React$Component);
	
	  function Glyphicon() {
	    (0, _classCallCheck3.default)(this, Glyphicon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Glyphicon.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        glyph = _props.glyph,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['glyph', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, glyph)] = true, _extends2));
	
	    return _react2.default.createElement('span', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Glyphicon;
	}(_react2.default.Component);
	
	Glyphicon.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('glyphicon', Glyphicon);
	module.exports = exports['default'];

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _uncontrollable = __webpack_require__(267);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAB = 'tab';
	var PANE = 'pane';
	
	var idPropType = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
	
	var propTypes = {
	  /**
	   * HTML id attribute, required if no `generateChildId` prop
	   * is specified.
	   */
	  id: function id(props) {
	    var error = null;
	
	    if (!props.generateChildId) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      error = idPropType.apply(undefined, [props].concat(args));
	
	      if (!error && !props.id) {
	        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
	      }
	    }
	
	    return error;
	  },
	
	
	  /**
	   * A function that takes an `eventKey` and `type` and returns a unique id for
	   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
	   * function, meaning it should always return the _same_ id for the same set
	   * of inputs. The default value requires that an `id` to be set for the
	   * `<TabContainer>`.
	   *
	   * The `type` argument will either be `"tab"` or `"pane"`.
	   *
	   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
	   */
	  generateChildId: _propTypes2.default.func,
	
	  /**
	   * A callback fired when a tab is selected.
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * The `eventKey` of the currently active tab.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any
	};
	
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var TabContainer = function (_React$Component) {
	  (0, _inherits3.default)(TabContainer, _React$Component);
	
	  function TabContainer() {
	    (0, _classCallCheck3.default)(this, TabContainer);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  TabContainer.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        activeKey = _props.activeKey,
	        onSelect = _props.onSelect,
	        generateChildId = _props.generateChildId,
	        id = _props.id;
	
	
	    var getId = generateChildId || function (key, type) {
	      return id ? id + '-' + type + '-' + key : null;
	    };
	
	    return {
	      $bs_tabContainer: {
	        activeKey: activeKey,
	        onSelect: onSelect,
	        getTabId: function getTabId(key) {
	          return getId(key, TAB);
	        },
	        getPaneId: function getPaneId(key) {
	          return getId(key, PANE);
	        }
	      }
	    };
	  };
	
	  TabContainer.prototype.render = function render() {
	    var _props2 = this.props,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children']);
	
	
	    delete props.generateChildId;
	    delete props.onSelect;
	    delete props.activeKey;
	
	    return _react2.default.cloneElement(_react2.default.Children.only(children), props);
	  };
	
	  return TabContainer;
	}(_react2.default.Component);
	
	TabContainer.propTypes = propTypes;
	TabContainer.childContextTypes = childContextTypes;
	
	exports.default = (0, _uncontrollable2.default)(TabContainer, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Sets a default animation strategy for all children `<TabPane>`s. Use
	   * `false` to disable, `true` to enable the default `<Fade>` animation or any
	   * `<Transition>` component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when they are no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any
	  })
	};
	
	var childContextTypes = {
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3.default)(TabContent, _React$Component);
	
	  function TabContent(props, context) {
	    (0, _classCallCheck3.default)(this, TabContent);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
	    _this.handlePaneExited = _this.handlePaneExited.bind(_this);
	
	    // Active entries in state will be `null` unless `animation` is set. Need
	    // to track active child in case keys swap and the active child changes
	    // but the active key does not.
	    _this.state = {
	      activeKey: null,
	      activeChild: null
	    };
	    return _this;
	  }
	
	  TabContent.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit;
	
	
	    var stateActiveKey = this.state.activeKey;
	    var containerActiveKey = this.getContainerActiveKey();
	
	    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
	    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
	
	    return {
	      $bs_tabContent: {
	        bsClass: bsClass,
	        animation: animation,
	        activeKey: activeKey,
	        mountOnEnter: mountOnEnter,
	        unmountOnExit: unmountOnExit,
	        onPaneEnter: this.handlePaneEnter,
	        onPaneExited: this.handlePaneExited,
	        exiting: exiting
	      }
	    };
	  };
	
	  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!nextProps.animation && this.state.activeChild) {
	      this.setState({ activeKey: null, activeChild: null });
	    }
	  };
	
	  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
	    var tabContainer = this.context.$bs_tabContainer;
	    return tabContainer && tabContainer.activeKey;
	  };
	
	  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
	    if (!this.props.animation) {
	      return false;
	    }
	
	    // It's possible that this child should be transitioning out.
	    if (childKey !== this.getContainerActiveKey()) {
	      return false;
	    }
	
	    this.setState({
	      activeKey: childKey,
	      activeChild: child
	    });
	
	    return true;
	  };
	
	  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
	    // This might happen as everything is unmounting.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState(function (_ref) {
	      var activeChild = _ref.activeChild;
	
	      if (activeChild !== child) {
	        return null;
	      }
	
	      return {
	        activeKey: null,
	        activeChild: null
	      };
	    });
	  };
	
	  TabContent.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        className = _props2.className,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'className']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'content'))
	    }));
	  };
	
	  return TabContent;
	}(_react2.default.Component);
	
	TabContent.propTypes = propTypes;
	TabContent.defaultProps = defaultProps;
	TabContent.contextTypes = contextTypes;
	TabContent.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab', TabContent);
	module.exports = exports['default'];

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureDayPicker = exports.defaultProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(240);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _throttle = __webpack_require__(464);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isTouchDevice = __webpack_require__(188);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _OutsideClickHandler = __webpack_require__(335);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CalendarMonthGrid = __webpack_require__(1224);
	
	var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);
	
	var _DayPickerNavigation = __webpack_require__(2722);
	
	var _DayPickerNavigation2 = _interopRequireDefault(_DayPickerNavigation);
	
	var _DayPickerKeyboardShortcuts = __webpack_require__(2721);
	
	var _DayPickerKeyboardShortcuts2 = _interopRequireDefault(_DayPickerKeyboardShortcuts);
	
	var _getCalendarMonthWidth = __webpack_require__(1238);
	
	var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);
	
	var _getActiveElement = __webpack_require__(2729);
	
	var _getActiveElement2 = _interopRequireDefault(_getActiveElement);
	
	var _isDayVisible = __webpack_require__(491);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _ScrollableOrientationShape = __webpack_require__(193);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MONTH_PADDING = 23;
	var DAY_PICKER_PADDING = 9;
	var PREV_TRANSITION = 'prev';
	var NEXT_TRANSITION = 'next';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	
	  // calendar presentation props
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  onOutsideClick: _propTypes2['default'].func,
	  hidden: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  renderCalendarInfo: _propTypes2['default'].func,
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onMultiplyScrollableMonths: _propTypes2['default'].func, // VERTICAL_SCROLLABLE daypickers only
	
	  // month props
	  renderMonth: _propTypes2['default'].func,
	
	  // day props
	  modifiers: _propTypes2['default'].object,
	  renderDay: _propTypes2['default'].func,
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	
	  // accessibility props
	  isFocused: _propTypes2['default'].bool,
	  getFirstFocusableDay: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // internationalization
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases))
	}));
	
	var defaultProps = exports.defaultProps = {
	  // calendar presentation props
	  enableOutsideDays: false,
	  numberOfMonths: 2,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	  hidden: false,
	  initialVisibleMonth: function () {
	    function initialVisibleMonth() {
	      return (0, _moment2['default'])();
	    }
	
	    return initialVisibleMonth;
	  }(),
	  firstDayOfWeek: null,
	  renderCalendarInfo: null,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	
	  // navigation props
	  navPrev: null,
	  navNext: null,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onMultiplyScrollableMonths: function () {
	    function onMultiplyScrollableMonths() {}
	
	    return onMultiplyScrollableMonths;
	  }(),
	
	
	  // month props
	  renderMonth: null,
	
	  // day props
	  modifiers: {},
	  renderDay: null,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	
	  // accessibility props
	  isFocused: false,
	  getFirstFocusableDay: null,
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  showKeyboardShortcuts: false,
	
	  // internationalization
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases
	};
	
	var DayPicker = function (_React$Component) {
	  _inherits(DayPicker, _React$Component);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	    var currentMonth = props.hidden ? (0, _moment2['default'])() : props.initialVisibleMonth();
	
	    var focusedDate = currentMonth.clone().startOf('month');
	    if (props.getFirstFocusableDay) {
	      focusedDate = props.getFirstFocusableDay(currentMonth);
	    }
	
	    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth2['default'])(props.daySize) : 0;
	
	    _this.hasSetInitialVisibleMonth = !props.hidden;
	    _this.state = {
	      currentMonth: currentMonth,
	      monthTransition: null,
	      translationValue: translationValue,
	      scrollableMonthMultiple: 1,
	      calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(props.daySize),
	      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
	      nextFocusedDate: null,
	      showKeyboardShortcuts: props.showKeyboardShortcuts,
	      onKeyboardShortcutsPanelClose: function () {
	        function onKeyboardShortcutsPanelClose() {}
	
	        return onKeyboardShortcutsPanelClose;
	      }(),
	
	      isTouchDevice: (0, _isTouchDevice2['default'])(),
	      withMouseInteractions: true,
	      hasSetHeight: false
	    };
	
	    _this.calendarMonthHeights = [];
	    _this.calendarMonthGridHeight = 0;
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	    _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_this);
	    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);
	
	    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_this);
	    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_this);
	
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_this);
	    _this.setCalendarMonthHeights = _this.setCalendarMonthHeights.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var hidden = nextProps.hidden,
	            isFocused = nextProps.isFocused,
	            showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
	            onBlur = nextProps.onBlur;
	        var currentMonth = this.state.currentMonth;
	
	
	        if (!hidden) {
	          if (!this.hasSetInitialVisibleMonth) {
	            this.hasSetInitialVisibleMonth = true;
	            this.setState({
	              currentMonth: nextProps.initialVisibleMonth()
	            });
	          }
	        }
	
	        if (nextProps.daySize !== this.props.daySize) {
	          this.setState({
	            calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(nextProps.daySize)
	          });
	        }
	
	        if (isFocused !== this.props.isFocused) {
	          if (isFocused) {
	            var focusedDate = this.getFocusedDay(currentMonth);
	
	            var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	            if (nextProps.showKeyboardShortcuts) {
	              // the ? shortcut came from the input and we should return input there once it is close
	              onKeyboardShortcutsPanelClose = onBlur;
	            }
	
	            this.setState({
	              showKeyboardShortcuts: showKeyboardShortcuts,
	              onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
	              focusedDate: focusedDate,
	              withMouseInteractions: false
	            });
	          } else {
	            this.setState({ focusedDate: null });
	          }
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var isFocused = this.props.isFocused;
	        var focusedDate = this.state.focusedDate;
	
	
	        if (!prevProps.isFocused && isFocused && !focusedDate) {
	          this.container.focus();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	
	        this.setState({ withMouseInteractions: false });
	
	        var _props = this.props,
	            onBlur = _props.onBlur,
	            isRTL = _props.isRTL;
	        var _state = this.state,
	            focusedDate = _state.focusedDate,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	        if (!focusedDate) return;
	
	        var newFocusedDate = focusedDate.clone();
	
	        var didTransitionMonth = false;
	
	        // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
	        // return it to wherever it was before when the panel was opened
	        var activeElement = (0, _getActiveElement2['default'])();
	        var onKeyboardShortcutsPanelClose = function () {
	          function onKeyboardShortcutsPanelClose() {
	            if (activeElement) activeElement.focus();
	          }
	
	          return onKeyboardShortcutsPanelClose;
	        }();
	
	        switch (e.key) {
	          case 'ArrowUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'ArrowLeft':
	            e.preventDefault();
	            if (isRTL) {
	              newFocusedDate.add(1, 'day');
	            } else {
	              newFocusedDate.subtract(1, 'day');
	            }
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'Home':
	            e.preventDefault();
	            newFocusedDate.startOf('week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'PageUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'month');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'ArrowDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'ArrowRight':
	            e.preventDefault();
	            if (isRTL) {
	              newFocusedDate.subtract(1, 'day');
	            } else {
	              newFocusedDate.add(1, 'day');
	            }
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'End':
	            e.preventDefault();
	            newFocusedDate.endOf('week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'PageDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'month');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case '?':
	            this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
	            break;
	
	          case 'Escape':
	            if (showKeyboardShortcuts) {
	              this.closeKeyboardShortcutsPanel();
	            } else {
	              onBlur();
	            }
	            break;
	
	          default:
	            break;
	        }
	
	        // If there was a month transition, do not update the focused date until the transition has
	        // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
	        // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition
	        if (!didTransitionMonth) {
	          this.setState({
	            focusedDate: newFocusedDate
	          });
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick(nextFocusedDate, e) {
	        var _props2 = this.props,
	            numberOfMonths = _props2.numberOfMonths,
	            isRTL = _props2.isRTL;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	
	        if (e) e.preventDefault();
	
	        var translationValue = this.isVertical() ? this.calendarMonthHeights[0] : calendarMonthWidth;
	
	        if (this.isHorizontal()) {
	          if (isRTL) {
	            translationValue = -2 * calendarMonthWidth;
	          }
	
	          var newMonthHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(this.calendarMonthHeights.slice(0, numberOfMonths))));
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: PREV_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick(nextFocusedDate, e) {
	        var isRTL = this.props.isRTL;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	
	        if (e) e.preventDefault();
	
	        var translationValue = this.isVertical() ? -this.calendarMonthHeights[1] : -calendarMonthWidth;
	
	        if (this.isHorizontal()) {
	          if (isRTL) {
	            translationValue = 0;
	          }
	          var newMonthHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(this.calendarMonthHeights.slice(2))));
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: NEXT_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'getFirstVisibleIndex',
	    value: function () {
	      function getFirstVisibleIndex() {
	        var orientation = this.props.orientation;
	        var monthTransition = this.state.monthTransition;
	
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) return 0;
	
	        var firstVisibleMonthIndex = 1;
	        if (monthTransition === PREV_TRANSITION) {
	          firstVisibleMonthIndex -= 1;
	        } else if (monthTransition === NEXT_TRANSITION) {
	          firstVisibleMonthIndex += 1;
	        }
	
	        return firstVisibleMonthIndex;
	      }
	
	      return getFirstVisibleIndex;
	    }()
	  }, {
	    key: 'getFocusedDay',
	    value: function () {
	      function getFocusedDay(newMonth) {
	        var _props3 = this.props,
	            getFirstFocusableDay = _props3.getFirstFocusableDay,
	            numberOfMonths = _props3.numberOfMonths;
	
	
	        var focusedDate = void 0;
	        if (getFirstFocusableDay) {
	          focusedDate = getFirstFocusableDay(newMonth);
	        }
	
	        if (newMonth && (!focusedDate || !(0, _isDayVisible2['default'])(focusedDate, newMonth, numberOfMonths))) {
	          focusedDate = newMonth.clone().startOf('month');
	        }
	
	        return focusedDate;
	      }
	
	      return getFocusedDay;
	    }()
	  }, {
	    key: 'setCalendarMonthHeights',
	    value: function () {
	      function setCalendarMonthHeights(calendarMonthHeights) {
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var lastVisibleMonthIndex = firstVisibleMonthIndex + numberOfMonths;
	
	        this.calendarMonthHeights = calendarMonthHeights;
	        var visibleCalendarMonthHeights = calendarMonthHeights.filter(function (_, i) {
	          return i >= firstVisibleMonthIndex && i < lastVisibleMonthIndex;
	        });
	        this.calendarMonthGridHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarMonthHeights))) + MONTH_PADDING;
	        this.setState({ hasSetHeight: true });
	      }
	
	      return setCalendarMonthHeights;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'setTransitionContainerRef',
	    value: function () {
	      function setTransitionContainerRef(ref) {
	        this.transitionContainer = ref;
	      }
	
	      return setTransitionContainerRef;
	    }()
	  }, {
	    key: 'maybeTransitionNextMonth',
	    value: function () {
	      function maybeTransitionNextMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _state2 = this.state,
	            currentMonth = _state2.currentMonth,
	            focusedDate = _state2.focusedDate;
	
	
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onNextMonthClick(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionNextMonth;
	    }()
	  }, {
	    key: 'maybeTransitionPrevMonth',
	    value: function () {
	      function maybeTransitionPrevMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            focusedDate = _state3.focusedDate;
	
	
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onPrevMonthClick(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionPrevMonth;
	    }()
	  }, {
	    key: 'multiplyScrollableMonths',
	    value: function () {
	      function multiplyScrollableMonths(e) {
	        var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;
	
	        if (e) e.preventDefault();
	
	        if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);
	
	        this.setState({
	          scrollableMonthMultiple: this.state.scrollableMonthMultiple + 1
	        });
	      }
	
	      return multiplyScrollableMonths;
	    }()
	  }, {
	    key: 'isHorizontal',
	    value: function () {
	      function isHorizontal() {
	        return this.props.orientation === _constants.HORIZONTAL_ORIENTATION;
	      }
	
	      return isHorizontal;
	    }()
	  }, {
	    key: 'isVertical',
	    value: function () {
	      function isVertical() {
	        return this.props.orientation === _constants.VERTICAL_ORIENTATION || this.props.orientation === _constants.VERTICAL_SCROLLABLE;
	      }
	
	      return isVertical;
	    }()
	  }, {
	    key: 'updateStateAfterMonthTransition',
	    value: function () {
	      function updateStateAfterMonthTransition() {
	        var _props4 = this.props,
	            onPrevMonthClick = _props4.onPrevMonthClick,
	            onNextMonthClick = _props4.onNextMonthClick;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            monthTransition = _state4.monthTransition,
	            focusedDate = _state4.focusedDate,
	            nextFocusedDate = _state4.nextFocusedDate,
	            withMouseInteractions = _state4.withMouseInteractions,
	            calendarMonthWidth = _state4.calendarMonthWidth;
	
	
	        if (!monthTransition) return;
	
	        var newMonth = currentMonth.clone();
	        if (monthTransition === PREV_TRANSITION) {
	          if (onPrevMonthClick) onPrevMonthClick();
	          newMonth.subtract(1, 'month');
	        } else if (monthTransition === NEXT_TRANSITION) {
	          if (onNextMonthClick) onNextMonthClick();
	          newMonth.add(1, 'month');
	        }
	
	        var newFocusedDate = null;
	        if (nextFocusedDate) {
	          newFocusedDate = nextFocusedDate;
	        } else if (!focusedDate && !withMouseInteractions) {
	          newFocusedDate = this.getFocusedDay(newMonth);
	        }
	
	        this.setState({
	          currentMonth: newMonth,
	          monthTransition: null,
	          translationValue: this.props.isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
	          nextFocusedDate: null,
	          focusedDate: newFocusedDate
	        }, function () {
	          // we don't want to focus on the relevant calendar day after a month transition
	          // if the user is navigating around using a mouse
	          if (withMouseInteractions) {
	            var activeElement = (0, _getActiveElement2['default'])();
	            if (activeElement && activeElement !== document.body) {
	              activeElement.blur();
	            }
	          }
	        });
	      }
	
	      return updateStateAfterMonthTransition;
	    }()
	  }, {
	    key: 'adjustDayPickerHeight',
	    value: function () {
	      function adjustDayPickerHeight(newMonthHeight) {
	        var monthHeight = newMonthHeight + MONTH_PADDING;
	        if (monthHeight !== this.calendarMonthGridHeight) {
	          this.calendarMonthGridHeight = monthHeight;
	          this.transitionContainer.style.height = String(monthHeight) + 'px';
	        }
	      }
	
	      return adjustDayPickerHeight;
	    }()
	  }, {
	    key: 'openKeyboardShortcutsPanel',
	    value: function () {
	      function openKeyboardShortcutsPanel(onCloseCallBack) {
	        this.setState({
	          showKeyboardShortcuts: true,
	          onKeyboardShortcutsPanelClose: onCloseCallBack
	        });
	      }
	
	      return openKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'closeKeyboardShortcutsPanel',
	    value: function () {
	      function closeKeyboardShortcutsPanel() {
	        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	
	        if (onKeyboardShortcutsPanelClose) {
	          onKeyboardShortcutsPanelClose();
	        }
	
	        this.setState({
	          onKeyboardShortcutsPanelClose: null,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return closeKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'renderNavigation',
	    value: function () {
	      function renderNavigation() {
	        var _this2 = this;
	
	        var _props5 = this.props,
	            navPrev = _props5.navPrev,
	            navNext = _props5.navNext,
	            orientation = _props5.orientation,
	            phrases = _props5.phrases,
	            isRTL = _props5.isRTL;
	
	
	        var onNextMonthClick = void 0;
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          onNextMonthClick = this.multiplyScrollableMonths;
	        } else {
	          onNextMonthClick = function () {
	            function onNextMonthClick(e) {
	              _this2.onNextMonthClick(null, e);
	            }
	
	            return onNextMonthClick;
	          }();
	        }
	
	        return _react2['default'].createElement(_DayPickerNavigation2['default'], {
	          onPrevMonthClick: function () {
	            function onPrevMonthClick(e) {
	              _this2.onPrevMonthClick(null, e);
	            }
	
	            return onPrevMonthClick;
	          }(),
	          onNextMonthClick: onNextMonthClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          orientation: orientation,
	          phrases: phrases,
	          isRTL: isRTL
	        });
	      }
	
	      return renderNavigation;
	    }()
	  }, {
	    key: 'renderWeekHeader',
	    value: function () {
	      function renderWeekHeader(index) {
	        var _props6 = this.props,
	            daySize = _props6.daySize,
	            orientation = _props6.orientation,
	            weekDayFormat = _props6.weekDayFormat,
	            styles = _props6.styles;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var horizontalStyle = {
	          left: index * calendarMonthWidth
	        };
	        var verticalStyle = {
	          marginLeft: -calendarMonthWidth / 2
	        };
	
	        var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation
	        if (this.isHorizontal()) {
	          weekHeaderStyle = horizontalStyle;
	        } else if (this.isVertical() && !verticalScrollable) {
	          weekHeaderStyle = verticalStyle;
	        }
	
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        if (firstDayOfWeek == null) {
	          firstDayOfWeek = _moment2['default'].localeData().firstDayOfWeek();
	        }
	
	        var header = [];
	        for (var i = 0; i < 7; i += 1) {
	          header.push(_react2['default'].createElement(
	            'li',
	            _extends({ key: i }, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_li, { width: daySize })),
	            _react2['default'].createElement(
	              'small',
	              null,
	              (0, _moment2['default'])().day((i + firstDayOfWeek) % 7).format(weekDayFormat)
	            )
	          ));
	        }
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle), {
	            key: 'week-' + String(index)
	          }),
	          _react2['default'].createElement(
	            'ul',
	            (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_ul),
	            header
	          )
	        );
	      }
	
	      return renderWeekHeader;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var _state5 = this.state,
	            calendarMonthWidth = _state5.calendarMonthWidth,
	            currentMonth = _state5.currentMonth,
	            monthTransition = _state5.monthTransition,
	            translationValue = _state5.translationValue,
	            scrollableMonthMultiple = _state5.scrollableMonthMultiple,
	            focusedDate = _state5.focusedDate,
	            showKeyboardShortcuts = _state5.showKeyboardShortcuts,
	            isTouch = _state5.isTouchDevice,
	            hasSetHeight = _state5.hasSetHeight;
	        var _props7 = this.props,
	            enableOutsideDays = _props7.enableOutsideDays,
	            numberOfMonths = _props7.numberOfMonths,
	            orientation = _props7.orientation,
	            modifiers = _props7.modifiers,
	            withPortal = _props7.withPortal,
	            onDayClick = _props7.onDayClick,
	            onDayMouseEnter = _props7.onDayMouseEnter,
	            onDayMouseLeave = _props7.onDayMouseLeave,
	            firstDayOfWeek = _props7.firstDayOfWeek,
	            renderMonth = _props7.renderMonth,
	            renderDay = _props7.renderDay,
	            renderCalendarInfo = _props7.renderCalendarInfo,
	            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
	            onOutsideClick = _props7.onOutsideClick,
	            monthFormat = _props7.monthFormat,
	            daySize = _props7.daySize,
	            isFocused = _props7.isFocused,
	            isRTL = _props7.isRTL,
	            styles = _props7.styles,
	            phrases = _props7.phrases,
	            verticalHeight = _props7.verticalHeight;
	
	
	        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
	        var weekHeaders = [];
	        for (var i = 0; i < numOfWeekHeaders; i += 1) {
	          weekHeaders.push(this.renderWeekHeader(i));
	        }
	
	        var verticalScrollable = this.props.orientation === _constants.VERTICAL_SCROLLABLE;
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var horizontalWidth = calendarMonthWidth * numberOfMonths + 2 * DAY_PICKER_PADDING;
	
	        var dayPickerStyle = {
	          width: this.isHorizontal() && horizontalWidth,
	
	          // These values are to center the datepicker (approximately) on the page
	          marginLeft: this.isHorizontal() && withPortal && -horizontalWidth / 2,
	          marginTop: this.isHorizontal() && withPortal && -calendarMonthWidth / 2
	        };
	
	        var height = void 0;
	        if (this.isHorizontal()) {
	          height = this.calendarMonthGridHeight;
	        } else if (this.isVertical() && !verticalScrollable && !withPortal) {
	          // If the user doesn't set a desired height,
	          // we default back to this kind of made-up value that generally looks good
	          height = verticalHeight || 1.75 * calendarMonthWidth;
	        }
	
	        var transitionContainerStyle = {
	          width: this.isHorizontal() && horizontalWidth,
	          height: height
	        };
	
	        var isCalendarMonthGridAnimating = monthTransition !== null;
	        var transformType = this.isVertical() ? 'translateY' : 'translateX';
	        var transformValue = transformType + '(' + String(translationValue) + 'px)';
	
	        var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
	
	        var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;
	        if (this.isVertical()) {
	          keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
	        }
	
	        var isHorizontalAndAnimating = this.isHorizontal() && isCalendarMonthGridAnimating;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            role: 'application',
	            'aria-label': phrases.calendarLabel
	          }, (0, _reactWithStyles.css)(styles.DayPicker, this.isHorizontal() && styles.DayPicker__horizontal, this.isVertical() && styles.DayPicker__vertical, verticalScrollable && styles.DayPicker__verticalScrollable, this.isHorizontal() && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !hasSetHeight && styles.DayPicker__hidden)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(
	              'div',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeaders, this.isHorizontal() && styles.DayPicker_weekHeaders__horizontal), {
	                'aria-hidden': 'true',
	                role: 'presentation'
	              }),
	              weekHeaders
	            ),
	            _react2['default'].createElement(
	              'div',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_focusRegion), {
	                ref: this.setContainerRef,
	                onClick: function () {
	                  function onClick(e) {
	                    e.stopPropagation();
	                  }
	
	                  return onClick;
	                }(),
	                onKeyDown: (0, _throttle2['default'])(this.onKeyDown, 300),
	                onMouseUp: function () {
	                  function onMouseUp() {
	                    _this3.setState({ withMouseInteractions: true });
	                  }
	
	                  return onMouseUp;
	                }(),
	                role: 'region',
	                tabIndex: -1
	              }),
	              !verticalScrollable && this.renderNavigation(),
	              _react2['default'].createElement(
	                'div',
	                _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_transitionContainer, isHorizontalAndAnimating && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
	                  ref: this.setTransitionContainerRef
	                }),
	                _react2['default'].createElement(_CalendarMonthGrid2['default'], {
	                  setCalendarMonthHeights: this.setCalendarMonthHeights,
	                  transformValue: transformValue,
	                  enableOutsideDays: enableOutsideDays,
	                  firstVisibleMonthIndex: firstVisibleMonthIndex,
	                  initialMonth: currentMonth,
	                  isAnimating: isCalendarMonthGridAnimating,
	                  modifiers: modifiers,
	                  orientation: orientation,
	                  numberOfMonths: numberOfMonths * scrollableMonthMultiple,
	                  onDayClick: onDayClick,
	                  onDayMouseEnter: onDayMouseEnter,
	                  onDayMouseLeave: onDayMouseLeave,
	                  renderMonth: renderMonth,
	                  renderDay: renderDay,
	                  onMonthTransitionEnd: this.updateStateAfterMonthTransition,
	                  monthFormat: monthFormat,
	                  daySize: daySize,
	                  firstDayOfWeek: firstDayOfWeek,
	                  isFocused: shouldFocusDate,
	                  focusedDate: focusedDate,
	                  phrases: phrases,
	                  isRTL: isRTL
	                }),
	                verticalScrollable && this.renderNavigation()
	              ),
	              !isTouch && !hideKeyboardShortcutsPanel && _react2['default'].createElement(_DayPickerKeyboardShortcuts2['default'], {
	                block: this.isVertical() && !withPortal,
	                buttonLocation: keyboardShortcutButtonLocation,
	                showKeyboardShortcutsPanel: showKeyboardShortcuts,
	                openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
	                closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
	                phrases: phrases
	              })
	            ),
	            renderCalendarInfo && renderCalendarInfo()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPicker;
	}(_react2['default'].Component);
	
	DayPicker.propTypes = propTypes;
	DayPicker.defaultProps = defaultProps;
	
	exports.PureDayPicker = DayPicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DayPicker: {
	      background: color.background,
	      position: 'relative',
	      textAlign: 'left'
	    },
	
	    DayPicker__horizontal: {
	      background: color.background,
	      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)',
	      borderRadius: 3
	    },
	
	    DayPicker__verticalScrollable: {
	      height: '100%'
	    },
	
	    DayPicker__hidden: {
	      visibility: 'hidden'
	    },
	
	    DayPicker_portal__horizontal: {
	      boxShadow: 'none',
	      position: 'absolute',
	      left: '50%',
	      top: '50%'
	    },
	
	    DayPicker_portal__vertical: {
	      position: 'initial'
	    },
	
	    DayPicker_focusRegion: {
	      outline: 'none'
	    },
	
	    DayPicker_weekHeaders: {
	      position: 'relative'
	    },
	
	    DayPicker_weekHeaders__horizontal: {
	      marginLeft: 9
	    },
	
	    DayPicker_weekHeader: {
	      color: color.placeholderText,
	      position: 'absolute',
	      top: 62,
	      zIndex: zIndex + 2,
	      padding: '0 13px',
	      textAlign: 'left'
	    },
	
	    DayPicker_weekHeader__vertical: {
	      left: '50%'
	    },
	
	    DayPicker_weekHeader__verticalScrollable: {
	      top: 0,
	      display: 'table-row',
	      borderBottom: '1px solid ' + String(color.core.border),
	      background: color.background,
	      marginLeft: 0,
	      left: 0,
	      width: '100%',
	      textAlign: 'center'
	    },
	
	    DayPicker_weekHeader_ul: {
	      listStyle: 'none',
	      margin: '1px 0',
	      paddingLeft: 0,
	      paddingRight: 0
	    },
	
	    DayPicker_weekHeader_li: {
	      display: 'inline-block',
	      textAlign: 'center'
	    },
	
	    DayPicker_transitionContainer: {
	      position: 'relative',
	      overflow: 'hidden',
	      borderRadius: 3
	    },
	
	    DayPicker_transitionContainer__horizontal: {
	      transition: 'height 0.2s ease-in-out'
	    },
	
	    DayPicker_transitionContainer__vertical: {
	      width: '100%'
	    },
	
	    DayPicker_transitionContainer__verticalScrollable: {
	      paddingTop: 20,
	      height: '100%',
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      overflowY: 'scroll'
	    }
	  };
	})(DayPicker);

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isDayVisible;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _isBeforeDay = __webpack_require__(245);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _isAfterDay = __webpack_require__(244);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
	  var firstDayOfFirstMonth = month.clone().startOf('month');
	  if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
	  if ((0, _isBeforeDay2['default'])(day, firstDayOfFirstMonth)) return false;
	
	  var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
	  if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
	  return !(0, _isAfterDay2['default'])(day, lastDayOfLastMonth);
	}

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(195);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.DISPLAY_FORMAT);
	}

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.reactJsonView=t(require("react")):e.reactJsonView=t(e.React)}("undefined"!=typeof self?self:this,function(e){return function(e){function t(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return e[r].call(a.exports,a,a.exports,t),a.l=!0,a.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=60)}([function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e,t,n){return e||console.error("theme has not been set"),f(e)(t,n)}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=r;var o=n(64),i=n(65),s=function(e){return e&&e.__esModule?e:{default:e}}(i),u=n(66),l=function(e){return{backgroundColor:e.base00,ellipsisColor:e.base09,braceColor:e.base07,expandedIcon:e.base0D,collapsedIcon:e.base0E,keyColor:e.base07,arrayKeyColor:e.base0C,objectSize:e.base04,copyToClipboard:e.base0F,copyToClipboardCheck:e.base0D,objectBorder:e.base02,dataTypes:{boolean:e.base0E,date:e.base0D,float:e.base0B,function:e.base0D,integer:e.base0F,string:e.base09,nan:e.base08,null:e.base0A,undefined:e.base05,regexp:e.base0A,background:e.base02},editVariable:{editIcon:e.base0E,cancelIcon:e.base09,removeIcon:e.base09,addIcon:e.base0E,checkIcon:e.base0E,background:e.base01,color:e.base0A,border:e.base07},addKeyModal:{background:e.base05,border:e.base04,color:e.base0A,labelColor:e.base01},validationFailure:{background:e.base09,iconColor:e.base01,fontColor:e.base01}}},c=function(e){var t=l(e);return{"app-container":{fontFamily:s.default.globalFontFamily,cursor:s.default.globalCursor,backgroundColor:t.backgroundColor,position:"relative"},ellipsis:{display:"inline-block",color:t.ellipsisColor,fontSize:s.default.ellipsisFontSize,lineHeight:s.default.ellipsisLineHeight,cursor:s.default.ellipsisCursor},"brace-row":{display:"inline-block",cursor:"pointer"},brace:{display:"inline-block",cursor:s.default.braceCursor,fontWeight:s.default.braceFontWeight,color:t.braceColor},"expanded-icon":{color:t.expandedIcon},"collapsed-icon":{color:t.collapsedIcon},colon:{display:"inline-block",margin:s.default.keyMargin,color:t.keyColor,verticalAlign:"top"},objectKeyVal:function(e,n){return{style:a({paddingTop:s.default.keyValPaddingTop,paddingRight:s.default.keyValPaddingRight,paddingBottom:s.default.keyValPaddingBottom,borderLeft:s.default.keyValBorderLeft+" "+t.objectBorder,":hover":{paddingLeft:n.paddingLeft-1+"px",borderLeft:s.default.keyValBorderHover+" "+t.objectBorder}},n)}},"object-key-val-no-border":{padding:s.default.keyValPadding},"pushed-content":{marginLeft:s.default.pushedContentMarginLeft},variableValue:function(e,t){return{style:a({display:"inline-block",paddingRight:s.default.variableValuePaddingRight,position:"relative"},t)}},"object-name":{display:"inline-block",color:t.keyColor,letterSpacing:s.default.keyLetterSpacing,fontStyle:s.default.keyFontStyle,verticalAlign:s.default.keyVerticalAlign,opacity:s.default.keyOpacity,":hover":{opacity:s.default.keyOpacityHover}},"array-key":{display:"inline-block",color:t.arrayKeyColor,letterSpacing:s.default.keyLetterSpacing,fontStyle:s.default.keyFontStyle,verticalAlign:s.default.keyVerticalAlign,opacity:s.default.keyOpacity,":hover":{opacity:s.default.keyOpacityHover}},"object-size":{color:t.objectSize,borderRadius:s.default.objectSizeBorderRadius,fontStyle:s.default.objectSizeFontStyle,margin:s.default.objectSizeMargin,cursor:"default"},"data-type-label":{fontSize:s.default.dataTypeFontSize,marginRight:s.default.dataTypeMarginRight,opacity:s.default.datatypeOpacity},boolean:{display:"inline-block",color:t.dataTypes.boolean},date:{display:"inline-block",color:t.dataTypes.date},"date-value":{marginLeft:s.default.dateValueMarginLeft},float:{display:"inline-block",color:t.dataTypes.float},function:{display:"inline-block",color:t.dataTypes.function,cursor:"pointer",whiteSpace:"pre-line"},"function-value":{fontStyle:"italic"},integer:{display:"inline-block",color:t.dataTypes.integer},string:{display:"inline-block",color:t.dataTypes.string},nan:{display:"inline-block",color:t.dataTypes.nan,fontSize:s.default.nanFontSize,fontWeight:s.default.nanFontWeight,backgroundColor:t.dataTypes.background,padding:s.default.nanPadding,borderRadius:s.default.nanBorderRadius},null:{display:"inline-block",color:t.dataTypes.null,fontSize:s.default.nullFontSize,fontWeight:s.default.nullFontWeight,backgroundColor:t.dataTypes.background,padding:s.default.nullPadding,borderRadius:s.default.nullBorderRadius},undefined:{display:"inline-block",color:t.dataTypes.undefined,fontSize:s.default.undefinedFontSize,padding:s.default.undefinedPadding,borderRadius:s.default.undefinedBorderRadius,backgroundColor:t.dataTypes.background},regexp:{display:"inline-block",color:t.dataTypes.regexp},"copy-to-clipboard":{cursor:s.default.clipboardCursor},"copy-icon":{color:t.copyToClipboard,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight,verticalAlign:"top"},"copy-icon-copied":{color:t.copyToClipboardCheck,marginLeft:s.default.clipboardCheckMarginLeft},"array-group-meta-data":{display:"inline-block",padding:s.default.arrayGroupMetaPadding},"object-meta-data":{display:"inline-block",padding:s.default.metaDataPadding},"icon-container":{display:"inline-block",width:s.default.iconContainerWidth},tooltip:{padding:s.default.tooltipPadding},removeVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.removeIcon,cursor:s.default.iconCursor,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight},addVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.addIcon,cursor:s.default.iconCursor,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight},editVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.editIcon,cursor:s.default.iconCursor,fontSize:s.default.iconFontSize,marginRight:s.default.iconMarginRight},"edit-icon-container":{display:"inline-block",verticalAlign:"top"},"check-icon":{display:"inline-block",cursor:s.default.iconCursor,color:t.editVariable.checkIcon,fontSize:s.default.iconFontSize,paddingRight:s.default.iconPaddingRight},"cancel-icon":{display:"inline-block",cursor:s.default.iconCursor,color:t.editVariable.cancelIcon,fontSize:s.default.iconFontSize,paddingRight:s.default.iconPaddingRight},"edit-input":{display:"inline-block",minHeight:s.default.editInputHeight,minWidth:s.default.editInputMinWidth,borderRadius:s.default.editInputBorderRadius,backgroundColor:t.editVariable.background,color:t.editVariable.color,padding:s.default.editInputPadding,marginRight:s.default.editInputMarginRight,fontFamily:s.default.editInputFontFamily},"detected-row":{paddingTop:s.default.detectedRowPaddingTop},"key-modal-request":{position:s.default.addKeyCoverPosition,top:s.default.addKeyCoverPositionPx,left:s.default.addKeyCoverPositionPx,right:s.default.addKeyCoverPositionPx,bottom:s.default.addKeyCoverPositionPx,backgroundColor:s.default.addKeyCoverBackground},"key-modal":{width:s.default.addKeyModalWidth,backgroundColor:t.addKeyModal.background,marginLeft:s.default.addKeyModalMargin,marginRight:s.default.addKeyModalMargin,padding:s.default.addKeyModalPadding,borderRadius:s.default.addKeyModalRadius,marginTop:"15px",position:"relative"},"key-modal-label":{color:t.addKeyModal.labelColor,marginLeft:"2px",marginBottom:"5px",fontSize:"11px"},"key-modal-input-container":{overflow:"hidden"},"key-modal-input":{width:"100%",padding:"3px 6px",fontFamily:"monospace",color:t.addKeyModal.color,border:"none",boxSizing:"border-box",borderRadius:"2px"},"key-modal-cancel":{backgroundColor:t.editVariable.removeIcon,position:"absolute",top:"0px",right:"0px",borderRadius:"0px 3px 0px 3px",cursor:"pointer"},"key-modal-cancel-icon":{color:t.addKeyModal.labelColor,fontSize:s.default.iconFontSize,transform:"rotate(45deg)"},"key-modal-submit":{color:t.editVariable.addIcon,fontSize:s.default.iconFontSize,position:"absolute",right:"2px",top:"3px",cursor:"pointer"},"function-ellipsis":{display:"inline-block",color:t.ellipsisColor,fontSize:s.default.ellipsisFontSize,lineHeight:s.default.ellipsisLineHeight,cursor:s.default.ellipsisCursor},"validation-failure":{float:"right",padding:"3px 6px",borderRadius:"2px",cursor:"pointer",color:t.validationFailure.fontColor,backgroundColor:t.validationFailure.background},"validation-failure-label":{marginRight:"6px"},"validation-failure-clear":{position:"relative",verticalAlign:"top",cursor:"pointer",color:t.validationFailure.iconColor,fontSize:s.default.iconFontSize,transform:"rotate(45deg)"}}},f=function(e){var t=o.rjv_default;return!1!==e&&"none"!==e||(t=o.rjv_grey),(0,u.createStyling)(c,{defaultBase16:t})(e)}},function(e,t){var n=e.exports={version:"2.5.3"};"number"==typeof __e&&(__e=n)},function(e,t,n){var r=n(32)("wks"),a=n(22),o=n(5).Symbol,i="function"==typeof o;(e.exports=function(e){return r[e]||(r[e]=i&&o[e]||(i?o:a)("Symbol."+e))}).store=r},function(e,t,n){"use strict";function r(e){var t=a(e);return"number"==t&&(t=isNaN(e)?"nan":(0|e)!=e?"float":"integer"),t}function a(e){return{}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase()}function o(e){var t=["base00","base01","base02","base03","base04","base05","base06","base07","base08","base09","base0A","base0B","base0C","base0D","base0E","base0F"];if("object"==r(e)){for(var n=0;n<t.length;n++)if(!(t[n]in e))return!1;return!0}return!1}Object.defineProperty(t,"__esModule",{value:!0}),t.toType=r,t.isTheme=o},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(1),d=r(f),p=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=(e.rjvId,e.type_name),n=e.displayDataTypes,r=e.theme;return n?c.default.createElement("span",s({className:"data-type-label"},(0,d.default)(r,"data-type-label")),t):null}}]),t}(c.default.Component);t.default=p},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var r=n(9),a=n(21);e.exports=n(10)?function(e,t,n){return r.f(e,t,a(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(16),a=n(43),o=n(29),i=Object.defineProperty;t.f=n(10)?Object.defineProperty:function(e,t,n){if(r(e),t=o(t,!0),r(n),a)try{return i(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){e.exports=!n(11)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t,n){var r=n(48),a=n(27);e.exports=function(e){return r(a(e))}},function(e,t,n){"use strict";function r(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(161),l=n(14),c=function(e){return e&&e.__esModule?e:{default:e}}(l),f=n(4),d=function(e){function t(){var e,n,i,u;a(this,t);for(var l=arguments.length,c=Array(l),d=0;d<l;d++)c[d]=arguments[d];return n=i=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),i.objects={},i.set=function(e,t,n,r){void 0===i.objects[e]&&(i.objects[e]={}),void 0===i.objects[e][t]&&(i.objects[e][t]={}),i.objects[e][t][n]=r},i.get=function(e,t,n,r){return void 0===i.objects[e]||void 0===i.objects[e][t]||void 0==i.objects[e][t][n]?r:i.objects[e][t][n]},i.handleAction=function(e){var t=e.rjvId,n=e.data;switch(e.name){case"RESET":i.emit("reset-"+t);break;case"VARIABLE_UPDATED":e.data.updated_src=i.updateSrc(t,n),i.set(t,"action","variable-update",s({},n,{type:"variable-edited"})),i.emit("variable-update-"+t);break;case"VARIABLE_REMOVED":e.data.updated_src=i.updateSrc(t,n),i.set(t,"action","variable-update",s({},n,{type:"variable-removed"})),i.emit("variable-update-"+t);break;case"VARIABLE_ADDED":e.data.updated_src=i.updateSrc(t,n),i.set(t,"action","variable-update",s({},n,{type:"variable-added"})),i.emit("variable-update-"+t);break;case"ADD_VARIABLE_KEY_REQUEST":i.set(t,"action","new-key-request",n),i.emit("add-key-request-"+t)}},i.updateSrc=function(e,t){var n=t.name,a=t.namespace,o=t.new_value,s=(t.existing_value,t.variable_removed);a.shift();var u=i.get(e,"global","src"),l=i.deepCopy(u,[].concat(r(a))),c=l,d=!0,p=!1,b=void 0;try{for(var h,y=a[Symbol.iterator]();!(d=(h=y.next()).done);d=!0)c=c[h.value]}catch(e){p=!0,b=e}finally{try{!d&&y.return&&y.return()}finally{if(p)throw b}}return s?"array"==(0,f.toType)(c)?c.splice(n,1):delete c[n]:null!==n?c[n]=o:l=o,i.set(e,"global","src",l),l},i.deepCopy=function(e,t){var n=(0,f.toType)(e),a=void 0,o=t.shift();return"array"==n?a=[].concat(r(e)):"object"==n&&(a=s({},e)),void 0!==o&&(a[o]=i.deepCopy(e[o],t)),a},u=n,o(i,u)}return i(t,e),t}(u.EventEmitter),p=new d;c.default.register(p.handleAction.bind(p)),t.default=p},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(162),a=new r.Dispatcher;t.default=a},function(e,t,n){"use strict";function r(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function s(e){return e||(e={}),{style:u({verticalAlign:"middle"},e,{color:e.color?e.color:d,height:"1em",width:"1em"})}}Object.defineProperty(t,"__esModule",{value:!0}),t.CheckCircle=t.Edit=t.Add=t.AddCircle=t.RemoveCircle=t.Clippy=t.ArrowDown=t.ArrowRight=t.SquarePlus=t.SquareMinus=t.CirclePlus=t.CircleMinus=void 0;var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=function(e){return e&&e.__esModule?e:{default:e}}(c),d="#000000";t.CircleMinus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 24 24",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("path",{d:"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"})))}}]),t}(f.default.Component),t.CirclePlus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 24 24",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("path",{d:"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"})))}}]),t}(f.default.Component),t.SquareMinus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]),a=s(t).style;return f.default.createElement("span",n,f.default.createElement("svg",{fill:a.color,width:a.height,height:a.width,style:a,viewBox:"0 0 1792 1792"},f.default.createElement("path",{d:"M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"})))}}]),t}(f.default.Component),t.SquarePlus=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]),a=s(t).style;return f.default.createElement("span",n,f.default.createElement("svg",{fill:a.color,width:a.height,height:a.width,style:a,viewBox:"0 0 1792 1792"},f.default.createElement("path",{d:"M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"})))}}]),t}(f.default.Component),t.ArrowRight=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",{style:u({},s(t).style,{paddingLeft:"2px",verticalAlign:"top"}),viewBox:"0 0 15 15",fill:"currentColor"},f.default.createElement("path",{d:"M0 14l6-6-6-6z"})))}}]),t}(f.default.Component),t.ArrowDown=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",{style:u({},s(t).style,{paddingLeft:"2px",verticalAlign:"top"}),viewBox:"0 0 15 15",fill:"currentColor"},f.default.createElement("path",{d:"M0 5l6 6 6-6z"})))}}]),t}(f.default.Component),t.Clippy=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z"}))))}}]),t}(f.default.Component),t.RemoveCircle=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),t}(f.default.Component),t.AddCircle=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),t}(f.default.Component),t.Add=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z"}))))}}]),t}(f.default.Component),t.Edit=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z"}))))}}]),t}(f.default.Component),t.CheckCircle=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),l(t,[{key:"render",value:function(){var e=this.props,t=e.style,n=r(e,["style"]);return f.default.createElement("span",n,f.default.createElement("svg",u({},s(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),f.default.createElement("g",null,f.default.createElement("path",{d:"m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),t}(f.default.Component)},function(e,t,n){var r=n(17);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t){e.exports={}},function(e,t,n){var r=n(47),a=n(33);e.exports=Object.keys||function(e){return r(e,a)}},function(e,t,n){var r=n(5),a=n(2),o=n(71),i=n(8),s=function(e,t,n){var u,l,c,f=e&s.F,d=e&s.G,p=e&s.S,b=e&s.P,h=e&s.B,y=e&s.W,v=d?a:a[t]||(a[t]={}),m=v.prototype,g=d?r:p?r[t]:(r[t]||{}).prototype;d&&(n=t);for(u in n)(l=!f&&g&&void 0!==g[u])&&u in v||(c=l?g[u]:n[u],v[u]=d&&"function"!=typeof g[u]?n[u]:h&&l?o(c,r):y&&g[u]==c?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(c):b&&"function"==typeof c?o(Function.call,c):c,b&&((v.virtual||(v.virtual={}))[u]=c,e&s.R&&m&&!m[u]&&i(m,u,c)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,e.exports=s},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=r(c),d=n(4),p=n(41),b=n(170),h=r(b),y=n(56),v=r(y),m=n(57),g=r(m),_=n(58),j=r(_),O=n(13),E=r(O),w=n(59),x=n(1),C=r(x),k=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return P.call(n),n.state=n.initializeState(e),n}return s(t,e),l(t,[{key:"componentWillReceiveProps",value:function(e){this.setState(this.initializeState(e))}},{key:"getBraceStart",value:function(e,t){var n=this,r=this.props,a=r.src,o=r.theme,i=r.iconStyle;if("array_group"==r.parent_type)return f.default.createElement("span",null,f.default.createElement("span",(0,C.default)(o,"brace"),"array"==e?"[":"{"),t?this.getObjectMetaData(a):null);var s=t?w.ExpandedIcon:w.CollapsedIcon;return f.default.createElement("span",null,f.default.createElement("span",u({onClick:function(e){n.toggleCollapsed()}},(0,C.default)(o,"brace-row")),f.default.createElement("div",u({className:"icon-container"},(0,C.default)(o,"icon-container")),f.default.createElement(s,{theme:o,iconStyle:i})),f.default.createElement(j.default,this.props),f.default.createElement("span",(0,C.default)(o,"brace"),"array"==e?"[":"{")),t?this.getObjectMetaData(a):null)}},{key:"render",value:function(){var e=this.props,t=e.depth,n=e.src,r=(e.namespace,e.name,e.type,e.parent_type),o=e.theme,i=e.jsvRoot,s=e.iconStyle,l=a(e,["depth","src","namespace","name","type","parent_type","theme","jsvRoot","iconStyle"]),c=this.state,d=c.object_type,p=c.expanded,b={};return i||"array_group"===r?"array_group"===r&&(b.borderLeft=0,b.display="inline"):b.paddingLeft=5*this.props.indentWidth,f.default.createElement("div",u({className:"object-key-val"},(0,C.default)(o,i?"jsv-root":"objectKeyVal",b)),this.getBraceStart(d,p),p?this.getObjectContent(t,n,u({theme:o,iconStyle:s},l)):this.getEllipsis(),f.default.createElement("span",{className:"brace-row"},f.default.createElement("span",{style:u({},(0,C.default)(o,"brace").style,{paddingLeft:p?"3px":"0px"})},"array"==d?"]":"}"),p?null:this.getObjectMetaData(n)))}}]),t}(f.default.Component),P=function(){var e=this;this.state={},this.initializeState=function(t){var n=Object.keys(t.src).length,r=(!1===t.collapsed||!0!==t.collapsed&&t.collapsed>t.depth)&&(!t.shouldCollapse||!1===t.shouldCollapse({name:t.name,src:t.src,type:(0,d.toType)(t.src),namespace:t.namespace}))&&0!==n,a={rjvId:t.rjvId,state_key:t.namespace.join("."),namespace:t.namespace,indentWidth:t.indentWidth,expanded:E.default.get(t.rjvId,t.namespace,"expanded",r),object_type:"array"==t.type?"array":"object",parent_type:"array"==t.type?"array":"object",size:n};return u({},e.state,a)},this.toggleCollapsed=function(){e.state.expanded=!e.state.expanded,E.default.set(e.state.rjvId,e.state.namespace,"expanded",e.state.expanded),e.setState(e.state)},this.getObjectContent=function(t,n,r){return f.default.createElement("div",{className:"pushed-content object-container"},f.default.createElement("div",u({className:"object-content"},(0,C.default)(e.props.theme,"pushed-content")),e.renderObjectContents(n,r)))},this.getEllipsis=function(){return 0===e.state.size?null:f.default.createElement("div",u({},(0,C.default)(e.props.theme,"ellipsis"),{className:"node-ellipsis",onClick:e.toggleCollapsed}),"...")},this.getObjectMetaData=function(t){var n=e.props,r=(n.rjvId,n.theme,e.state.size);return f.default.createElement(v.default,u({size:r},e.props))},this.renderObjectContents=function(t,n){var r=e.props,a=r.depth,o=r.parent_type,i=r.index_offset,s=r.groupArraysAfterLength,l=e.state,c=l.namespace,d=l.object_type,b=(n.theme,[]),y=void 0;for(var v in t)if(y=new M(v,t[v]),"array_group"==o&&i&&(y.name=parseInt(y.name)+i),t.hasOwnProperty(v))if("object"==y.type)b.push(f.default.createElement(p.JsonObject,u({key:y.name,depth:a+1,name:y.name,src:y.value,namespace:c.concat(y.name),parent_type:d},n)));else if("array"==y.type){var m=p.JsonObject;s&&y.value.length>s&&(m=g.default),b.push(f.default.createElement(m,u({key:y.name,depth:a+1,name:y.name,src:y.value,namespace:c.concat(y.name),type:"array",parent_type:d},n)))}else b.push(f.default.createElement(h.default,u({key:y.name+"_"+c,variable:y,singleIndent:5,namespace:c,type:e.props.type},n)));return b}},M=function e(t,n){o(this,e),this.name=t,this.value=n,this.type=(0,d.toType)(n)};t.default=k},function(e,t,n){"use strict";var r=n(70)(!0);n(42)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t){e.exports=!0},function(e,t,n){var r=n(17);e.exports=function(e,t){if(!r(e))return e;var n,a;if(t&&"function"==typeof(n=e.toString)&&!r(a=n.call(e)))return a;if("function"==typeof(n=e.valueOf)&&!r(a=n.call(e)))return a;if(!t&&"function"==typeof(n=e.toString)&&!r(a=n.call(e)))return a;throw TypeError("Can't convert object to primitive value")}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(32)("keys"),a=n(22);e.exports=function(e){return r[e]||(r[e]=a(e))}},function(e,t,n){var r=n(5),a=r["__core-js_shared__"]||(r["__core-js_shared__"]={});e.exports=function(e){return a[e]||(a[e]={})}},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t,n){var r=n(9).f,a=n(7),o=n(3)("toStringTag");e.exports=function(e,t,n){e&&!a(e=n?e:e.prototype,o)&&r(e,o,{configurable:!0,value:t})}},function(e,t,n){var r=n(27);e.exports=function(e){return Object(r(e))}},function(e,t,n){n(80);for(var r=n(5),a=n(8),o=n(18),i=n(3)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),u=0;u<s.length;u++){var l=s[u],c=r[l],f=c&&c.prototype;f&&!f[i]&&a(f,i,l),o[l]=o.Array}},function(e,t,n){t.f=n(3)},function(e,t,n){var r=n(5),a=n(2),o=n(28),i=n(37),s=n(9).f;e.exports=function(e){var t=a.Symbol||(a.Symbol=o?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:i.f(e)})}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t){function n(e,t,n){return Math.min(Math.max(e,t),n)}e.exports=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var a=n(63);Object.defineProperty(t,"JsonBoolean",{enumerable:!0,get:function(){return r(a).default}});var o=n(158);Object.defineProperty(t,"JsonDate",{enumerable:!0,get:function(){return r(o).default}});var i=n(159);Object.defineProperty(t,"JsonFloat",{enumerable:!0,get:function(){return r(i).default}});var s=n(160);Object.defineProperty(t,"JsonFunction",{enumerable:!0,get:function(){return r(s).default}});var u=n(164);Object.defineProperty(t,"JsonNan",{enumerable:!0,get:function(){return r(u).default}});var l=n(165);Object.defineProperty(t,"JsonNull",{enumerable:!0,get:function(){return r(l).default}});var c=n(166);Object.defineProperty(t,"JsonInteger",{enumerable:!0,get:function(){return r(c).default}});var f=n(24);Object.defineProperty(t,"JsonObject",{enumerable:!0,get:function(){return r(f).default}});var d=n(167);Object.defineProperty(t,"JsonRegexp",{enumerable:!0,get:function(){return r(d).default}});var p=n(168);Object.defineProperty(t,"JsonString",{enumerable:!0,get:function(){return r(p).default}});var b=n(169);Object.defineProperty(t,"JsonUndefined",{enumerable:!0,get:function(){return r(b).default}})},function(e,t,n){"use strict";var r=n(28),a=n(20),o=n(45),i=n(8),s=n(7),u=n(18),l=n(73),c=n(34),f=n(79),d=n(3)("iterator"),p=!([].keys&&"next"in[].keys()),b=function(){return this};e.exports=function(e,t,n,h,y,v,m){l(n,t,h);var g,_,j,O=function(e){if(!p&&e in C)return C[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},E=t+" Iterator",w="values"==y,x=!1,C=e.prototype,k=C[d]||C["@@iterator"]||y&&C[y],P=!p&&k||O(y),M=y?w?O("entries"):P:void 0,S="Array"==t?C.entries||k:k;if(S&&(j=f(S.call(new e)))!==Object.prototype&&j.next&&(c(j,E,!0),r||s(j,d)||i(j,d,b)),w&&k&&"values"!==k.name&&(x=!0,P=function(){return k.call(this)}),r&&!m||!p&&!x&&C[d]||i(C,d,P),u[t]=P,u[E]=b,y)if(g={values:w?P:O("values"),keys:v?P:O("keys"),entries:M},m)for(_ in g)_ in C||o(C,_,g[_]);else a(a.P+a.F*(p||x),t,g);return g}},function(e,t,n){e.exports=!n(10)&&!n(11)(function(){return 7!=Object.defineProperty(n(44)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(17),a=n(5).document,o=r(a)&&r(a.createElement);e.exports=function(e){return o?a.createElement(e):{}}},function(e,t,n){e.exports=n(8)},function(e,t,n){var r=n(16),a=n(74),o=n(33),i=n(31)("IE_PROTO"),s=function(){},u=function(){var e,t=n(44)("iframe"),r=o.length;for(t.style.display="none",n(78).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),u=e.F;r--;)delete u.prototype[o[r]];return u()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=r(e),n=new s,s.prototype=null,n[i]=e):n=u(),void 0===t?n:a(n,t)}},function(e,t,n){var r=n(7),a=n(12),o=n(75)(!1),i=n(31)("IE_PROTO");e.exports=function(e,t){var n,s=a(e),u=0,l=[];for(n in s)n!=i&&r(s,n)&&l.push(n);for(;t.length>u;)r(s,n=t[u++])&&(~o(l,n)||l.push(n));return l}},function(e,t,n){var r=n(30);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(47),a=n(33).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,a)}},function(e,t,n){var r=n(30),a=n(3)("toStringTag"),o="Arguments"==r(function(){return arguments}()),i=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,s;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=i(t=Object(e),a))?n:o?r(t):"Object"==(s=r(t))&&"function"==typeof t.callee?"Arguments":s}},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t){function n(e){return e.match(r)}var r=/-?\d+(\.\d+)?%?/g;e.exports=n},function(e,t,n){"use strict";function r(e,t,n,r,o,i,s,u){if(a(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,o,i,s,u],f=0;l=new Error(t.replace(/%s/g,function(){return c[f++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var a=function(e){};e.exports=r},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(4);t.default=function(e){var t=(0,r.toType)(e),n=void 0;switch(t){case"undefined":n="undefined";break;case"nan":n="NaN";break;case"string":n=e;break;case"date":case"function":case"regexp":n=e.toString();break;default:try{n=JSON.stringify(e,null,"  ")}catch(e){n=""}}return n}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(4),d=n(54),p=(r(d),n(15)),b=n(1),h=r(b),y=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={copied:!1},n.handleCopy=function(){var e=document.createElement("textarea"),t=n.props,r=t.clickCallback,a=t.src,o=t.namespace;e.innerHTML=JSON.stringify(n.clipboardValue(a),null,"  "),document.body.appendChild(e),e.select(),document.execCommand("copy"),document.body.removeChild(e),n.copiedTimer=setTimeout(function(){n.setState({copied:!1})},5500),n.setState({copied:!0},function(){"function"==typeof r&&r({src:a,namespace:o,name:o[o.length-1]})})},n.getClippyIcon=function(){var e=n.props.theme;return n.state.copied?c.default.createElement("span",null,c.default.createElement(p.Clippy,s({className:"copy-icon"},(0,h.default)(e,"copy-icon"))),c.default.createElement("span",(0,h.default)(e,"copy-icon-copied"),"✔")):c.default.createElement(p.Clippy,s({className:"copy-icon"},(0,h.default)(e,"copy-icon")))},n.clipboardValue=function(e){switch((0,f.toType)(e)){case"function":case"regexp":return e.toString();default:return e}},n.copiedTimer=null,n}return i(t,e),u(t,[{key:"componentWillUnmount",value:function(){this.copiedTimer&&(clearTimeout(this.copiedTimer),this.copiedTimer=null)}},{key:"render",value:function(){var e=this.props,t=(e.src,e.theme),n=e.hidden,r=(0,h.default)(t,"copy-to-clipboard").style,a="inline";return n&&(a="none"),c.default.createElement("span",{className:"copy-to-clipboard-container"},c.default.createElement("span",{style:s({},r,{display:a}),onClick:this.handleCopy},this.getClippyIcon()))}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=n(0),c=r(l),f=n(14),d=r(f),p=n(55),b=r(p),h=n(4),y=n(15),v=n(1),m=r(v),g=function(e){function t(){var e,n,r,s;o(this,t);for(var l=arguments.length,f=Array(l),p=0;p<l;p++)f[p]=arguments[p];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(f))),r.getObjectSize=function(){var e=r.props,t=e.size,n=e.theme;if(e.displayObjectSize)return c.default.createElement("span",u({className:"object-size"},(0,m.default)(n,"object-size")),t," item",1==t?"":"s")},r.getAddAttribute=function(){var e=r.props,t=e.theme,n=e.namespace,o=e.name,i=e.src,s=e.rjvId,l=e.depth;return c.default.createElement("span",{className:"click-to-add",style:{verticalAlign:"top"}},c.default.createElement(y.AddCircle,u({className:"click-to-add-icon"},(0,m.default)(t,"addVarIcon"),{onClick:function(){var e={name:l>0?o:null,namespace:n.splice(0,n.length-1),existing_value:i,variable_removed:!1,key_name:null};"object"==(0,h.toType)(i)?d.default.dispatch({name:"ADD_VARIABLE_KEY_REQUEST",rjvId:s,data:e}):d.default.dispatch({name:"VARIABLE_ADDED",rjvId:s,data:u({},e,{new_value:[].concat(a(i),[null])})})}})))},r.getRemoveObject=function(){var e=r.props,t=e.theme,n=(e.hover,e.namespace),a=e.name,o=e.src,i=e.rjvId;if(1!=n.length)return c.default.createElement("span",{className:"click-to-remove"},c.default.createElement(y.RemoveCircle,u({className:"click-to-remove-icon"},(0,m.default)(t,"removeVarIcon"),{onClick:function(){d.default.dispatch({name:"VARIABLE_REMOVED",rjvId:i,data:{name:a,namespace:n.splice(0,n.length-1),existing_value:o,variable_removed:!0}})}})))},r.render=function(){var e=r.props,t=e.theme,n=e.onDelete,a=e.onAdd,o=e.enableClipboard,i=e.src,s=e.namespace;return c.default.createElement("div",u({},(0,m.default)(t,"object-meta-data"),{className:"object-meta-data",onClick:function(e){e.stopPropagation()}}),r.getObjectSize(),o?c.default.createElement(b.default,u({clickCallback:o},{src:i,theme:t,namespace:s})):null,!1!==a?r.getAddAttribute():null,!1!==n?r.getRemoveObject():null)},s=n,i(r,s)}return s(t,e),t}(c.default.Component);t.default=g},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},c=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),f=n(0),d=r(f),p=n(1),b=r(p),h=n(56),y=r(h),v=n(58),m=r(v),g=n(24),_=r(g),j=n(59),O=function(e){function t(e){i(this,t);var n=s(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.toggleCollapsed=function(e){n.state.expanded[e]=!n.state.expanded[e],n.setState(n.state)},n.state={expanded:{}},n}return u(t,e),c(t,[{key:"getExpandedIcon",value:function(e){var t=this.props,n=t.theme,r=t.iconStyle;return this.state.expanded[e]?d.default.createElement(j.ExpandedIcon,{theme:n,iconStyle:r}):d.default.createElement(j.CollapsedIcon,{theme:n,iconStyle:r})}},{key:"render",value:function(){var e=this,t=this.props,n=t.src,r=t.groupArraysAfterLength,i=(t.depth,t.name),s=t.theme,u=t.jsvRoot,c=t.namespace,f=(t.parent_type,o(t,["src","groupArraysAfterLength","depth","name","theme","jsvRoot","namespace","parent_type"])),p=0,h=5*this.props.indentWidth;u||(p=5*this.props.indentWidth);var v=r,g=Math.ceil(n.length/v);return d.default.createElement("div",l({className:"object-key-val"},(0,b.default)(s,u?"jsv-root":"objectKeyVal",{paddingLeft:p})),d.default.createElement(m.default,this.props),d.default.createElement("span",null,d.default.createElement(y.default,l({size:n.length},this.props))),[].concat(a(Array(g))).map(function(t,r){return d.default.createElement("div",l({key:r,className:"object-key-val array-group"},(0,b.default)(s,"objectKeyVal",{marginLeft:6,paddingLeft:h})),d.default.createElement("span",(0,b.default)(s,"brace-row"),d.default.createElement("div",l({className:"icon-container"},(0,b.default)(s,"icon-container"),{onClick:function(t){e.toggleCollapsed(r)}}),e.getExpandedIcon(r)),e.state.expanded[r]?d.default.createElement(_.default,l({key:i+r,depth:0,name:!1,collapsed:!1,groupArraysAfterLength:v,index_offset:r*v,src:n.slice(r*v,r*v+v),namespace:c,type:"array",parent_type:"array_group",theme:s},f)):d.default.createElement("span",l({},(0,b.default)(s,"brace"),{onClick:function(t){e.toggleCollapsed(r)},className:"array-group-brace"}),"[",d.default.createElement("div",l({},(0,b.default)(s,"array-group-meta-data"),{className:"array-group-meta-data"}),d.default.createElement("span",l({className:"object-size"},(0,b.default)(s,"object-size")),r*v," - ",r*v+v>n.length?n.length:r*v+v)),"]")))}))}}]),t}(d.default.Component);t.default=O},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.parent_type,n=e.namespace,r=e.theme,a=e.jsvRoot,i=e.name,u=e.name?e.name:"";return!a||!1!==i&&null!==i?"array"==t?s.default.createElement("span",o({},(0,l.default)(r,"array-key"),{key:n}),s.default.createElement("span",{className:"array-key"},u),s.default.createElement("span",(0,l.default)(r,"colon"),":")):s.default.createElement("span",o({},(0,l.default)(r,"object-name"),{key:n}),s.default.createElement("span",{className:"object-key"},s.default.createElement("span",{style:{verticalAlign:"top"}},'"'),s.default.createElement("span",null,u),s.default.createElement("span",{style:{verticalAlign:"top"}},'"')),s.default.createElement("span",(0,l.default)(r,"colon"),":")):s.default.createElement("span",null)}Object.defineProperty(t,"__esModule",{value:!0});var o=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.default=a;var i=n(0),s=r(i),u=n(1),l=r(u)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){var t=e.theme;switch(e.iconStyle){case"triangle":return u.default.createElement(f.ArrowDown,i({},(0,c.default)(t,"expanded-icon"),{className:"expanded-icon"}));case"square":return u.default.createElement(f.SquareMinus,i({},(0,c.default)(t,"expanded-icon"),{className:"expanded-icon"}));default:return u.default.createElement(f.CircleMinus,i({},(0,c.default)(t,"expanded-icon"),{className:"expanded-icon"}))}}function o(e){var t=e.theme;switch(e.iconStyle){case"triangle":return u.default.createElement(f.ArrowRight,i({},(0,c.default)(t,"collapsed-icon"),{className:"collapsed-icon"}));case"square":return u.default.createElement(f.SquarePlus,i({},(0,c.default)(t,"collapsed-icon"),{className:"collapsed-icon"}));default:return u.default.createElement(f.CirclePlus,i({},(0,c.default)(t,"collapsed-icon"),{className:"collapsed-icon"}))}}Object.defineProperty(t,"__esModule",{value:!0});var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e};t.ExpandedIcon=a,t.CollapsedIcon=o;var s=n(0),u=r(s),l=n(1),c=r(l),f=n(15)},function(e,t,n){e.exports=n(61)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){var n={};for(var r in e)t.indexOf(r)>=0||Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=e[r]);return n}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=r(c),d=n(62),p=r(d),b=n(177),h=r(b),y=n(179),v=r(y),m=n(4),g=n(13),_=r(g),j=n(1),O=r(j);n(180);var E=function(e){function t(e){o(this,t);var n=i(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return w.call(n),n.init(e),_.default.set(n.rjvId,"global","src",n.state.src),n}return s(t,e),l(t,[{key:"componentWillMount",value:function(){var e=this.getListeners();for(var t in e)_.default.on(t+"-"+this.rjvId,e[t])}},{key:"componentWillUnmount",value:function(){var e=this.getListeners();for(var t in e)_.default.removeListener(t+"-"+this.rjvId,e[t])}},{key:"render",value:function(){var e=this.state,t=e.validationFailure,n=e.validationMessage,r=e.addKeyRequest,o=e.style,i=a(e,["validationFailure","validationMessage","addKeyRequest","style"]);return this.state.addKeyRequest=!1,this.state.editKeyRequest=!1,f.default.createElement("div",{className:"react-json-view",style:u({},(0,O.default)(i.theme,"app-container").style,o)},f.default.createElement(v.default,{message:n,active:t,theme:i.theme,rjvId:this.rjvId}),f.default.createElement(p.default,u({},i,{type:(0,m.toType)(i.src),rjvId:this.rjvId})),f.default.createElement(h.default,{active:r,theme:i.theme,rjvId:this.rjvId}))}},{key:"componentWillReceiveProps",value:function(e){this.init(e),this.setState(this.state)}}]),t}(f.default.Component),w=function(){var e=this;this.state={addKeyRequest:!1,validationFailure:!1},this.rjvId=Date.now().toString(),this.defaults={src:{},name:"root",theme:"rjv-default",collapsed:!1,collapseStringsAfterLength:!1,shouldCollapse:!1,groupArraysAfterLength:100,indentWidth:4,enableClipboard:!0,displayObjectSize:!0,displayDataTypes:!0,onEdit:!1,onDelete:!1,onAdd:!1,onSelect:!1,iconStyle:"triangle",style:{},validationMessage:"Validation Error"},this.getListeners=function(){return{reset:e.resetState,"variable-update":e.updateSrc,"add-key-request":e.addKeyRequest}},this.init=function(t){for(var n in e.defaults)void 0!==t[n]?e.state[n]=t[n]:e.state[n]=e.defaults[n];e.validateInput(),_.default.set(e.rjvId,"global","src",e.state.src)},this.validateInput=function(){"object"!==(0,m.toType)(e.state.theme)||(0,m.isTheme)(e.state.theme)||(console.error("react-json-view error:","theme prop must be a theme name or valid base-16 theme object.",'defaulting to "rjv-default" theme'),e.state.theme="rjv-default"),"object"!==(0,m.toType)(e.state.src)&&"array"!==(0,m.toType)(e.state.src)&&(console.error("react-json-view error:","src property must be a valid json object"),e.state.name="ERROR",e.state.src={message:"src property must be a valid json object"})},this.updateSrc=function(){var t=_.default.get(e.rjvId,"action","variable-update"),n=t.name,r=t.namespace,a=t.new_value,o=t.existing_value,i=(t.variable_removed,t.updated_src),s=t.type,u=e.state,l=u.onEdit,c=u.onDelete,f=u.onAdd,d=void 0,p={existing_src:e.state.src,new_value:a,updated_src:i,name:n,namespace:r,existing_value:o};switch(s){case"variable-added":d=f(p);break;case"variable-edited":d=l(p);break;case"variable-removed":d=c(p)}!1!==d?(_.default.set(e.rjvId,"global","src",i),e.state.src=i):e.state.validationFailure=!0,e.setState(e.state)},this.addKeyRequest=function(){e.setState({addKeyRequest:!0})},this.resetState=function(){e.state.validationFailure=!1,e.setState(e.state)}};t.default=E},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=n(0),l=r(u),c=n(24),f=r(c),d=n(57),p=r(d),b=function(e){function t(){var e,n,r,i;a(this,t);for(var u=arguments.length,c=Array(u),d=0;d<u;d++)c[d]=arguments[d];return n=r=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(c))),r.render=function(){var e=r,t=e.props,n=[t.name],a=f.default;return t.groupArraysAfterLength&&t.src.length>t.groupArraysAfterLength&&(a=p.default),l.default.createElement("div",{className:"pretty-json-container object-container"},l.default.createElement("div",{className:"object-content"},l.default.createElement(a,s({namespace:n,depth:0,jsvRoot:!0},t))))},i=n,o(r,i)}return i(t,e),t}(l.default.Component);t.default=b},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"boolean"),c.default.createElement(d.default,s({type_name:"bool"},e)),e.value?"true":"false")}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.rjv_default={scheme:"rjv-default",author:"mac gainor",base00:"rgba(0, 0, 0, 0)",base01:"rgb(245, 245, 245)",base02:"rgb(235, 235, 235)",base03:"#93a1a1",base04:"rgba(0, 0, 0, 0.3)",base05:"#586e75",base06:"#073642",base07:"#002b36",base08:"#d33682",base09:"#cb4b16",base0A:"#dc322f",base0B:"#859900",base0C:"#6c71c4",base0D:"#586e75",base0E:"#2aa198",base0F:"#268bd2"},t.rjv_grey={scheme:"rjv-grey",author:"mac gainor",base00:"rgba(1, 1, 1, 0)",base01:"rgba(1, 1, 1, 0.1)",base02:"rgba(0, 0, 0, 0.2)",base03:"rgba(1, 1, 1, 0.3)",base04:"rgba(0, 0, 0, 0.4)",base05:"rgba(1, 1, 1, 0.5)",base06:"rgba(1, 1, 1, 0.6)",base07:"rgba(1, 1, 1, 0.7)",base08:"rgba(1, 1, 1, 0.8)",base09:"rgba(1, 1, 1, 0.8)",base0A:"rgba(1, 1, 1, 0.8)",base0B:"rgba(1, 1, 1, 0.8)",base0C:"rgba(1, 1, 1, 0.8)",base0D:"rgba(1, 1, 1, 0.8)",base0E:"rgba(1, 1, 1, 0.8)",base0F:"rgba(1, 1, 1, 0.8)"}},function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}Object.defineProperty(t,"__esModule",{value:!0});var a;t.default=(a={white:"#fff",black:"#000",transparent:"rgba(1, 1, 1, 0)",globalFontFamily:"monospace",globalCursor:"default",indentBlockWidth:"5px",braceFontWeight:"bold",braceCursor:"pointer",ellipsisFontSize:"18px",ellipsisLineHeight:"10px",ellipsisCursor:"pointer",keyMargin:"0px 5px",keyLetterSpacing:"0.5px",keyFontStyle:"none",keyBorderRadius:"3px",keyColonWeight:"bold",keyVerticalAlign:"top",keyOpacity:"0.85",keyOpacityHover:"1",keyValPaddingTop:"3px",keyValPaddingBottom:"3px",keyValPaddingRight:"5px",keyValBorderLeft:"1px solid",keyValBorderHover:"2px solid",keyValPaddingHover:"3px 5px 3px 4px",pushedContentMarginLeft:"6px",variableValuePaddingRight:"6px",nullFontSize:"11px",nullFontWeight:"bold",nullPadding:"1px 2px",nullBorderRadius:"3px",nanFontSize:"11px",nanFontWeight:"bold",nanPadding:"1px 2px",nanBorderRadius:"3px",undefinedFontSize:"11px",undefinedFontWeight:"bold",undefinedPadding:"1px 2px",undefinedBorderRadius:"3px"},r(a,"nullFontSize","11px"),r(a,"nullFontWeight","bold"),r(a,"nullPadding","1px 2px"),r(a,"nullBorderRadius","3px"),r(a,"dataTypeFontSize","11px"),r(a,"dataTypeMarginRight","4px"),r(a,"datatypeOpacity","0.8"),r(a,"objectSizeBorderRadius","3px"),r(a,"objectSizeFontStyle","italic"),r(a,"objectSizeMargin","0px 6px 0px 0px"),r(a,"clipboardCursor","pointer"),r(a,"clipboardCheckMarginLeft","-12px"),r(a,"metaDataPadding","0px 0px 0px 10px"),r(a,"arrayGroupMetaPadding","0px 0px 0px 4px"),r(a,"iconContainerWidth","17px"),r(a,"tooltipPadding","4px"),r(a,"editInputHeight","25px"),r(a,"editInputMinWidth","130px"),r(a,"editInputBorderRadius","2px"),r(a,"editInputPadding","5px"),r(a,"editInputMarginRight","4px"),r(a,"editInputFontFamily","monospace"),r(a,"iconCursor","pointer"),r(a,"iconFontSize","15px"),r(a,"iconPaddingRight","1px"),r(a,"dateValueMarginLeft","2px"),r(a,"iconMarginRight","3px"),r(a,"detectedRowPaddingTop","3px"),r(a,"addKeyCoverBackground","rgba(255, 255, 255, 0.3)"),r(a,"addKeyCoverPosition","absolute"),r(a,"addKeyCoverPositionPx","0px"),r(a,"addKeyModalWidth","200px"),r(a,"addKeyModalMargin","auto"),r(a,"addKeyModalPadding","10px"),r(a,"addKeyModalRadius","3px"),a)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0}),t.getBase16Theme=t.createStyling=t.invertTheme=void 0;var a=n(67),o=r(a),i=n(94),s=r(i),u=n(99),l=r(u),c=n(107),f=r(c),d=n(111),p=r(d),b=n(112),h=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(b),y=n(150),v=r(y),m=n(151),g=r(m),_=n(156),j=r(_),O=n(157),E=h.default,w=(0,f.default)(E),x=function(e){return e<.25?1:e<.5?.9-e:1.1-e},C=(0,j.default)(g.default,O.rgb2yuv,function(e){var t=(0,l.default)(e,3),n=t[0],r=t[1],a=t[2];return[x(n),r,a]},O.yuv2rgb,v.default),k=function(e){return function(t){return{className:[t.className,e.className].filter(Boolean).join(" "),style:(0,s.default)({},t.style||{},e.style||{})}}},P=function(e,t){if(void 0===e)return t;if(void 0===t)return e;var n=void 0===e?"undefined":(0,o.default)(e),r=void 0===t?"undefined":(0,o.default)(t);switch(n){case"string":switch(r){case"string":return[t,e].filter(Boolean).join(" ");case"object":return k({className:e,style:t});case"function":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return k({className:e})(t.apply(void 0,[n].concat(a)))}}case"object":switch(r){case"string":return k({className:t,style:e});case"object":return(0,s.default)({},t,e);case"function":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return k({style:e})(t.apply(void 0,[n].concat(a)))}}case"function":switch(r){case"string":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return e.apply(void 0,[k(n)({className:t})].concat(a))};case"object":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return e.apply(void 0,[k(n)({style:t})].concat(a))};case"function":return function(n){for(var r=arguments.length,a=Array(r>1?r-1:0),o=1;o<r;o++)a[o-1]=arguments[o];return e.apply(void 0,[t.apply(void 0,[n].concat(a))].concat(a))}}}},M=function(e,t){var n=(0,f.default)(t);for(var r in e)-1===n.indexOf(r)&&n.push(r);return n.reduce(function(n,r){return n[r]=P(e[r],t[r]),n},{})},S=function(e,t){for(var n=arguments.length,r=Array(n>2?n-2:0),a=2;a<n;a++)r[a-2]=arguments[a];if(null===t)return e;Array.isArray(t)||(t=[t]);var i=t.map(function(t){return e[t]}).filter(Boolean),u=i.reduce(function(e,t){return"string"==typeof t?e.className=[e.className,t].filter(Boolean).join(" "):"object"===(void 0===t?"undefined":(0,o.default)(t))?e.style=(0,s.default)({},e.style,t):"function"==typeof t&&(e=(0,s.default)({},e,t.apply(void 0,[e].concat(r)))),e},{className:"",style:{}});return u.className||delete u.className,0===(0,f.default)(u.style).length&&delete u.style,u},A=t.invertTheme=function(e){return(0,f.default)(e).reduce(function(t,n){return t[n]=/^base/.test(n)?C(e[n]):"scheme"===n?e[n]+":inverted":e[n],t},{})},R=(t.createStyling=(0,p.default)(function(e){for(var t=arguments.length,n=Array(t>3?t-3:0),r=3;r<t;r++)n[r-3]=arguments[r];var a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},i=a.defaultBase16,u=void 0===i?E:i,l=a.base16Themes,c=void 0===l?null:l,d=R(o,c);d&&(o=(0,s.default)({},d,o));var b=w.reduce(function(e,t){return e[t]=o[t]||u[t],e},{}),h=(0,f.default)(o).reduce(function(e,t){return-1===w.indexOf(t)?(e[t]=o[t],e):e},{}),y=e(b),v=M(h,y);return(0,p.default)(S,2).apply(void 0,[v].concat(n))},3),t.getBase16Theme=function(e,t){if(e&&e.extend&&(e=e.extend),"string"==typeof e){var n=e.split(":"),r=(0,l.default)(n,2),a=r[0],o=r[1];e=(t||{})[a]||h[a],"inverted"===o&&(e=A(e))}return e&&e.hasOwnProperty("base00")?e:void 0})},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=n(68),o=r(a),i=n(83),s=r(i),u="function"==typeof s.default&&"symbol"==typeof o.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===u(o.default)?function(e){return void 0===e?"undefined":u(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":u(e)}},function(e,t,n){e.exports={default:n(69),__esModule:!0}},function(e,t,n){n(25),n(36),e.exports=n(37).f("iterator")},function(e,t,n){var r=n(26),a=n(27);e.exports=function(e){return function(t,n){var o,i,s=String(a(t)),u=r(n),l=s.length;return u<0||u>=l?e?"":void 0:(o=s.charCodeAt(u),o<55296||o>56319||u+1===l||(i=s.charCodeAt(u+1))<56320||i>57343?e?s.charAt(u):o:e?s.slice(u,u+2):i-56320+(o-55296<<10)+65536)}}},function(e,t,n){var r=n(72);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,a){return e.call(t,n,r,a)}}return function(){return e.apply(t,arguments)}}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){"use strict";var r=n(46),a=n(21),o=n(34),i={};n(8)(i,n(3)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(i,{next:a(1,n)}),o(e,t+" Iterator")}},function(e,t,n){var r=n(9),a=n(16),o=n(19);e.exports=n(10)?Object.defineProperties:function(e,t){a(e);for(var n,i=o(t),s=i.length,u=0;s>u;)r.f(e,n=i[u++],t[n]);return e}},function(e,t,n){var r=n(12),a=n(76),o=n(77);e.exports=function(e){return function(t,n,i){var s,u=r(t),l=a(u.length),c=o(i,l);if(e&&n!=n){for(;l>c;)if((s=u[c++])!=s)return!0}else for(;l>c;c++)if((e||c in u)&&u[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(26),a=Math.min;e.exports=function(e){return e>0?a(r(e),9007199254740991):0}},function(e,t,n){var r=n(26),a=Math.max,o=Math.min;e.exports=function(e,t){return e=r(e),e<0?a(e+t,0):o(e,t)}},function(e,t,n){var r=n(5).document;e.exports=r&&r.documentElement},function(e,t,n){var r=n(7),a=n(35),o=n(31)("IE_PROTO"),i=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=a(e),r(e,o)?e[o]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?i:null}},function(e,t,n){"use strict";var r=n(81),a=n(82),o=n(18),i=n(12);e.exports=n(42)(Array,"Array",function(e,t){this._t=i(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,a(1)):"keys"==t?a(0,n):"values"==t?a(0,e[n]):a(0,[n,e[n]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(84),__esModule:!0}},function(e,t,n){n(85),n(91),n(92),n(93),e.exports=n(2).Symbol},function(e,t,n){"use strict";var r=n(5),a=n(7),o=n(10),i=n(20),s=n(45),u=n(86).KEY,l=n(11),c=n(32),f=n(34),d=n(22),p=n(3),b=n(37),h=n(38),y=n(87),v=n(88),m=n(16),g=n(17),_=n(12),j=n(29),O=n(21),E=n(46),w=n(89),x=n(90),C=n(9),k=n(19),P=x.f,M=C.f,S=w.f,A=r.Symbol,R=r.JSON,F=R&&R.stringify,T=p("_hidden"),I=p("toPrimitive"),D={}.propertyIsEnumerable,L=c("symbol-registry"),B=c("symbols"),N=c("op-symbols"),z=Object.prototype,q="function"==typeof A,V=r.QObject,H=!V||!V.prototype||!V.prototype.findChild,K=o&&l(function(){return 7!=E(M({},"a",{get:function(){return M(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=P(z,t);r&&delete z[t],M(e,t,n),r&&e!==z&&M(z,t,r)}:M,J=function(e){var t=B[e]=E(A.prototype);return t._k=e,t},W=q&&"symbol"==typeof A.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof A},U=function(e,t,n){return e===z&&U(N,t,n),m(e),t=j(t,!0),m(n),a(B,t)?(n.enumerable?(a(e,T)&&e[T][t]&&(e[T][t]=!1),n=E(n,{enumerable:O(0,!1)})):(a(e,T)||M(e,T,O(1,{})),e[T][t]=!0),K(e,t,n)):M(e,t,n)},G=function(e,t){m(e);for(var n,r=y(t=_(t)),a=0,o=r.length;o>a;)U(e,n=r[a++],t[n]);return e},$=function(e,t){return void 0===t?E(e):G(E(e),t)},Y=function(e){var t=D.call(this,e=j(e,!0));return!(this===z&&a(B,e)&&!a(N,e))&&(!(t||!a(this,e)||!a(B,e)||a(this,T)&&this[T][e])||t)},Q=function(e,t){if(e=_(e),t=j(t,!0),e!==z||!a(B,t)||a(N,t)){var n=P(e,t);return!n||!a(B,t)||a(e,T)&&e[T][t]||(n.enumerable=!0),n}},Z=function(e){for(var t,n=S(_(e)),r=[],o=0;n.length>o;)a(B,t=n[o++])||t==T||t==u||r.push(t);return r},X=function(e){for(var t,n=e===z,r=S(n?N:_(e)),o=[],i=0;r.length>i;)!a(B,t=r[i++])||n&&!a(z,t)||o.push(B[t]);return o};q||(A=function(){if(this instanceof A)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===z&&t.call(N,n),a(this,T)&&a(this[T],e)&&(this[T][e]=!1),K(this,e,O(1,n))};return o&&H&&K(z,e,{configurable:!0,set:t}),J(e)},s(A.prototype,"toString",function(){return this._k}),x.f=Q,C.f=U,n(49).f=w.f=Z,n(23).f=Y,n(39).f=X,o&&!n(28)&&s(z,"propertyIsEnumerable",Y,!0),b.f=function(e){return J(p(e))}),i(i.G+i.W+i.F*!q,{Symbol:A});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)p(ee[te++]);for(var ne=k(p.store),re=0;ne.length>re;)h(ne[re++]);i(i.S+i.F*!q,"Symbol",{for:function(e){return a(L,e+="")?L[e]:L[e]=A(e)},keyFor:function(e){if(!W(e))throw TypeError(e+" is not a symbol!");for(var t in L)if(L[t]===e)return t},useSetter:function(){H=!0},useSimple:function(){H=!1}}),i(i.S+i.F*!q,"Object",{create:$,defineProperty:U,defineProperties:G,getOwnPropertyDescriptor:Q,getOwnPropertyNames:Z,getOwnPropertySymbols:X}),R&&i(i.S+i.F*(!q||l(function(){var e=A();return"[null]"!=F([e])||"{}"!=F({a:e})||"{}"!=F(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],a=1;arguments.length>a;)r.push(arguments[a++]);if(n=t=r[1],(g(t)||void 0!==e)&&!W(e))return v(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!W(t))return t}),r[1]=t,F.apply(R,r)}}),A.prototype[I]||n(8)(A.prototype,I,A.prototype.valueOf),f(A,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(e,t,n){var r=n(22)("meta"),a=n(17),o=n(7),i=n(9).f,s=0,u=Object.isExtensible||function(){return!0},l=!n(11)(function(){return u(Object.preventExtensions({}))}),c=function(e){i(e,r,{value:{i:"O"+ ++s,w:{}}})},f=function(e,t){if(!a(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,r)){if(!u(e))return"F";if(!t)return"E";c(e)}return e[r].i},d=function(e,t){if(!o(e,r)){if(!u(e))return!0;if(!t)return!1;c(e)}return e[r].w},p=function(e){return l&&b.NEED&&u(e)&&!o(e,r)&&c(e),e},b=e.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:p}},function(e,t,n){var r=n(19),a=n(39),o=n(23);e.exports=function(e){var t=r(e),n=a.f;if(n)for(var i,s=n(e),u=o.f,l=0;s.length>l;)u.call(e,i=s[l++])&&t.push(i);return t}},function(e,t,n){var r=n(30);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(12),a=n(49).f,o={}.toString,i="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return a(e)}catch(e){return i.slice()}};e.exports.f=function(e){return i&&"[object Window]"==o.call(e)?s(e):a(r(e))}},function(e,t,n){var r=n(23),a=n(21),o=n(12),i=n(29),s=n(7),u=n(43),l=Object.getOwnPropertyDescriptor;t.f=n(10)?l:function(e,t){if(e=o(e),t=i(t,!0),u)try{return l(e,t)}catch(e){}if(s(e,t))return a(!r.f.call(e,t),e[t])}},function(e,t){},function(e,t,n){n(38)("asyncIterator")},function(e,t,n){n(38)("observable")},function(e,t,n){"use strict";t.__esModule=!0;var r=n(95),a=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=a.default||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}},function(e,t,n){e.exports={default:n(96),__esModule:!0}},function(e,t,n){n(97),e.exports=n(2).Object.assign},function(e,t,n){var r=n(20);r(r.S+r.F,"Object",{assign:n(98)})},function(e,t,n){"use strict";var r=n(19),a=n(39),o=n(23),i=n(35),s=n(48),u=Object.assign;e.exports=!u||n(11)(function(){var e={},t={},n=Symbol(),r="abcdefghijklmnopqrst";return e[n]=7,r.split("").forEach(function(e){t[e]=e}),7!=u({},e)[n]||Object.keys(u({},t)).join("")!=r})?function(e,t){for(var n=i(e),u=arguments.length,l=1,c=a.f,f=o.f;u>l;)for(var d,p=s(arguments[l++]),b=c?r(p).concat(c(p)):r(p),h=b.length,y=0;h>y;)f.call(p,d=b[y++])&&(n[d]=p[d]);return n}:u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var a=n(100),o=r(a),i=n(103),s=r(i);t.default=function(){function e(e,t){var n=[],r=!0,a=!1,o=void 0;try{for(var i,u=(0,s.default)(e);!(r=(i=u.next()).done)&&(n.push(i.value),!t||n.length!==t);r=!0);}catch(e){a=!0,o=e}finally{try{!r&&u.return&&u.return()}finally{if(a)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if((0,o.default)(Object(t)))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}()},function(e,t,n){e.exports={default:n(101),__esModule:!0}},function(e,t,n){n(36),n(25),e.exports=n(102)},function(e,t,n){var r=n(50),a=n(3)("iterator"),o=n(18);e.exports=n(2).isIterable=function(e){var t=Object(e);return void 0!==t[a]||"@@iterator"in t||o.hasOwnProperty(r(t))}},function(e,t,n){e.exports={default:n(104),__esModule:!0}},function(e,t,n){n(36),n(25),e.exports=n(105)},function(e,t,n){var r=n(16),a=n(106);e.exports=n(2).getIterator=function(e){var t=a(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return r(t.call(e))}},function(e,t,n){var r=n(50),a=n(3)("iterator"),o=n(18);e.exports=n(2).getIteratorMethod=function(e){if(void 0!=e)return e[a]||e["@@iterator"]||o[r(e)]}},function(e,t,n){e.exports={default:n(108),__esModule:!0}},function(e,t,n){n(109),e.exports=n(2).Object.keys},function(e,t,n){var r=n(35),a=n(19);n(110)("keys",function(){return function(e){return a(r(e))}})},function(e,t,n){var r=n(20),a=n(2),o=n(11);e.exports=function(e,t){var n=(a.Object||{})[e]||Object[e],i={};i[e]=t(n),r(r.S+r.F*o(function(){n(1)}),"Object",i)}},function(e,t,n){(function(t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function r(e,t){for(var n=-1,r=e?e.length:0;++n<r&&!1!==t(e[n],n,e););return e}function a(e,t){return!!(e?e.length:0)&&i(e,t,0)>-1}function o(e,t,n,r){for(var a=e.length,o=n+(r?1:-1);r?o--:++o<a;)if(t(e[o],o,e))return o;return-1}function i(e,t,n){if(t!==t)return o(e,s,n);for(var r=n-1,a=e.length;++r<a;)if(e[r]===t)return r;return-1}function s(e){return e!==e}function u(e,t){for(var n=e.length,r=0;n--;)e[n]===t&&r++;return r}function l(e,t){return null==e?void 0:e[t]}function c(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function f(e,t){for(var n=-1,r=e.length,a=0,o=[];++n<r;){var i=e[n];i!==t&&i!==K||(e[n]=K,o[a++]=n)}return o}function d(e){return I(e)?Se(e):{}}function p(e){return!(!I(e)||M(e))&&(T(e)||c(e)?Me:he).test(A(e))}function b(e,t,n,r){for(var a=-1,o=e.length,i=n.length,s=-1,u=t.length,l=Ae(o-i,0),c=Array(u+l),f=!r;++s<u;)c[s]=t[s];for(;++a<i;)(f||a<o)&&(c[n[a]]=e[a]);for(;l--;)c[s++]=e[a++];return c}function h(e,t,n,r){for(var a=-1,o=e.length,i=-1,s=n.length,u=-1,l=t.length,c=Ae(o-s,0),f=Array(c+l),d=!r;++a<c;)f[a]=e[a];for(var p=a;++u<l;)f[p+u]=t[u];for(;++i<s;)(d||a<o)&&(f[p+n[i]]=e[a++]);return f}function y(e,t){var n=-1,r=e.length;for(t||(t=Array(r));++n<r;)t[n]=e[n];return t}function v(e,t,n){function r(){return(this&&this!==je&&this instanceof r?o:e).apply(a?n:this,arguments)}var a=t&J,o=m(e);return r}function m(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=d(e.prototype),r=e.apply(n,t);return I(r)?r:n}}function g(e,t,r){function a(){for(var i=arguments.length,s=Array(i),u=i,l=w(a);u--;)s[u]=arguments[u];var c=i<3&&s[0]!==l&&s[i-1]!==l?[]:f(s,l);return(i-=c.length)<r?O(e,t,_,a.placeholder,void 0,s,c,void 0,void 0,r-i):n(this&&this!==je&&this instanceof a?o:e,this,s)}var o=m(e);return a}function _(e,t,n,r,a,o,i,s,l,c){function d(){for(var x=arguments.length,C=Array(x),k=x;k--;)C[k]=arguments[k];if(g)var P=w(d),M=u(C,P);if(r&&(C=b(C,r,a,g)),o&&(C=h(C,o,i,g)),x-=M,g&&x<c){var A=f(C,P);return O(e,t,_,d.placeholder,n,C,A,s,l,c-x)}var R=y?n:this,F=v?R[e]:e;return x=C.length,s?C=S(C,s):j&&x>1&&C.reverse(),p&&l<x&&(C.length=l),this&&this!==je&&this instanceof d&&(F=E||m(F)),F.apply(R,C)}var p=t&Z,y=t&J,v=t&W,g=t&(G|$),j=t&X,E=v?void 0:m(e);return d}function j(e,t,r,a){function o(){for(var t=-1,u=arguments.length,l=-1,c=a.length,f=Array(c+u),d=this&&this!==je&&this instanceof o?s:e;++l<c;)f[l]=a[l];for(;u--;)f[l++]=arguments[++t];return n(d,i?r:this,f)}var i=t&J,s=m(e);return o}function O(e,t,n,r,a,o,i,s,u,l){var c=t&G,f=c?i:void 0,d=c?void 0:i,p=c?o:void 0,b=c?void 0:o;t|=c?Y:Q,(t&=~(c?Q:Y))&U||(t&=~(J|W));var h=n(e,t,a,p,f,b,d,s,u,l);return h.placeholder=r,Te(h,e,t)}function E(e,t,n,r,a,o,i,s){var u=t&W;if(!u&&"function"!=typeof e)throw new TypeError(H);var l=r?r.length:0;if(l||(t&=~(Y|Q),r=a=void 0),i=void 0===i?i:Ae(N(i),0),s=void 0===s?s:N(s),l-=a?a.length:0,t&Q){var c=r,f=a;r=a=void 0}var d=[e,t,n,r,a,c,f,o,i,s];if(e=d[0],t=d[1],n=d[2],r=d[3],a=d[4],s=d[9]=null==d[9]?u?0:e.length:Ae(d[9]-l,0),!s&&t&(G|$)&&(t&=~(G|$)),t&&t!=J)p=t==G||t==$?g(e,t,s):t!=Y&&t!=(J|Y)||a.length?_.apply(void 0,d):j(e,t,n,r);else var p=v(e,t,n);return Te(p,e,t)}function w(e){return e.placeholder}function x(e,t){var n=l(e,t);return p(n)?n:void 0}function C(e){var t=e.match(fe);return t?t[1].split(de):[]}function k(e,t){var n=t.length,r=n-1;return t[r]=(n>1?"& ":"")+t[r],t=t.join(n>2?", ":" "),e.replace(ce,"{\n/* [wrapped with "+t+"] */\n")}function P(e,t){return!!(t=null==t?te:t)&&("number"==typeof e||ve.test(e))&&e>-1&&e%1==0&&e<t}function M(e){return!!xe&&xe in e}function S(e,t){for(var n=e.length,r=Re(t.length,n),a=y(e);r--;){var o=t[r];e[r]=P(o,n)?a[o]:void 0}return e}function A(e){if(null!=e){try{return Ce.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function R(e,t){return r(ae,function(n){var r="_."+n[0];t&n[1]&&!a(e,r)&&e.push(r)}),e.sort()}function F(e,t,n){t=n?void 0:t;var r=E(e,G,void 0,void 0,void 0,void 0,void 0,t);return r.placeholder=F.placeholder,r}function T(e){var t=I(e)?Pe.call(e):"";return t==oe||t==ie}function I(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function D(e){return!!e&&"object"==typeof e}function L(e){return"symbol"==typeof e||D(e)&&Pe.call(e)==se}function B(e){return e?(e=z(e))===ee||e===-ee?(e<0?-1:1)*ne:e===e?e:0:0===e?e:0}function N(e){var t=B(e),n=t%1;return t===t?n?t-n:t:0}function z(e){if("number"==typeof e)return e;if(L(e))return re;if(I(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=I(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(le,"");var n=be.test(e);return n||ye.test(e)?me(e.slice(2),n?2:8):pe.test(e)?re:+e}function q(e){return function(){return e}}function V(e){return e}var H="Expected a function",K="__lodash_placeholder__",J=1,W=2,U=4,G=8,$=16,Y=32,Q=64,Z=128,X=512,ee=1/0,te=9007199254740991,ne=1.7976931348623157e308,re=NaN,ae=[["ary",Z],["bind",J],["bindKey",W],["curry",G],["curryRight",$],["flip",X],["partial",Y],["partialRight",Q],["rearg",256]],oe="[object Function]",ie="[object GeneratorFunction]",se="[object Symbol]",ue=/[\\^$.*+?()[\]{}|]/g,le=/^\s+|\s+$/g,ce=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,fe=/\{\n\/\* \[wrapped with (.+)\] \*/,de=/,? & /,pe=/^[-+]0x[0-9a-f]+$/i,be=/^0b[01]+$/i,he=/^\[object .+?Constructor\]$/,ye=/^0o[0-7]+$/i,ve=/^(?:0|[1-9]\d*)$/,me=parseInt,ge="object"==typeof t&&t&&t.Object===Object&&t,_e="object"==typeof self&&self&&self.Object===Object&&self,je=ge||_e||Function("return this")(),Oe=Function.prototype,Ee=Object.prototype,we=je["__core-js_shared__"],xe=function(){var e=/[^.]+$/.exec(we&&we.keys&&we.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}(),Ce=Oe.toString,ke=Ee.hasOwnProperty,Pe=Ee.toString,Me=RegExp("^"+Ce.call(ke).replace(ue,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Se=Object.create,Ae=Math.max,Re=Math.min,Fe=function(){var e=x(Object,"defineProperty"),t=x.name;return t&&t.length>2?e:void 0}(),Te=Fe?function(e,t,n){var r=t+"";return Fe(e,"toString",{configurable:!0,enumerable:!1,value:q(k(r,R(C(r),n)))})}:V;F.placeholder={},e.exports=F}).call(t,n(51))},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e.default:e}t.__esModule=!0;var a=n(113);t.threezerotwofour=r(a);var o=n(114);t.apathy=r(o);var i=n(115);t.ashes=r(i);var s=n(116);t.atelierDune=r(s);var u=n(117);t.atelierForest=r(u);var l=n(118);t.atelierHeath=r(l);var c=n(119);t.atelierLakeside=r(c);var f=n(120);t.atelierSeaside=r(f);var d=n(121);t.bespin=r(d);var p=n(122);t.brewer=r(p);var b=n(123);t.bright=r(b);var h=n(124);t.chalk=r(h);var y=n(125);t.codeschool=r(y);var v=n(126);t.colors=r(v);var m=n(127);t.default=r(m);var g=n(128);t.eighties=r(g);var _=n(129);t.embers=r(_);var j=n(130);t.flat=r(j);var O=n(131);t.google=r(O);var E=n(132);t.grayscale=r(E);var w=n(133);t.greenscreen=r(w);var x=n(134);t.harmonic=r(x);var C=n(135);t.hopscotch=r(C);var k=n(136);t.isotope=r(k);var P=n(137);t.marrakesh=r(P);var M=n(138);t.mocha=r(M);var S=n(139);t.monokai=r(S);var A=n(140);t.ocean=r(A);var R=n(141);t.paraiso=r(R);var F=n(142);t.pop=r(F);var T=n(143);t.railscasts=r(T);var I=n(144);t.shapeshifter=r(I);var D=n(145);t.solarized=r(D);var L=n(146);t.summerfruit=r(L);var B=n(147);t.tomorrow=r(B);var N=n(148);t.tube=r(N);var z=n(149);t.twilight=r(z)},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"threezerotwofour",author:"jan t. sott (http://github.com/idleberg)",base00:"#090300",base01:"#3a3432",base02:"#4a4543",base03:"#5c5855",base04:"#807d7c",base05:"#a5a2a2",base06:"#d6d5d4",base07:"#f7f7f7",base08:"#db2d20",base09:"#e8bbd0",base0A:"#fded02",base0B:"#01a252",base0C:"#b5e4f4",base0D:"#01a0e4",base0E:"#a16a94",base0F:"#cdab53"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"apathy",author:"jannik siebert (https://github.com/janniks)",base00:"#031A16",base01:"#0B342D",base02:"#184E45",base03:"#2B685E",base04:"#5F9C92",base05:"#81B5AC",base06:"#A7CEC8",base07:"#D2E7E4",base08:"#3E9688",base09:"#3E7996",base0A:"#3E4C96",base0B:"#883E96",base0C:"#963E4C",base0D:"#96883E",base0E:"#4C963E",base0F:"#3E965B"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"ashes",author:"jannik siebert (https://github.com/janniks)",base00:"#1C2023",base01:"#393F45",base02:"#565E65",base03:"#747C84",base04:"#ADB3BA",base05:"#C7CCD1",base06:"#DFE2E5",base07:"#F3F4F5",base08:"#C7AE95",base09:"#C7C795",base0A:"#AEC795",base0B:"#95C7AE",base0C:"#95AEC7",base0D:"#AE95C7",base0E:"#C795AE",base0F:"#C79595"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier dune",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)",base00:"#20201d",base01:"#292824",base02:"#6e6b5e",base03:"#7d7a68",base04:"#999580",base05:"#a6a28c",base06:"#e8e4cf",base07:"#fefbec",base08:"#d73737",base09:"#b65611",base0A:"#cfb017",base0B:"#60ac39",base0C:"#1fad83",base0D:"#6684e1",base0E:"#b854d4",base0F:"#d43552"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier forest",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)",base00:"#1b1918",base01:"#2c2421",base02:"#68615e",base03:"#766e6b",base04:"#9c9491",base05:"#a8a19f",base06:"#e6e2e0",base07:"#f1efee",base08:"#f22c40",base09:"#df5320",base0A:"#d5911a",base0B:"#5ab738",base0C:"#00ad9c",base0D:"#407ee7",base0E:"#6666ea",base0F:"#c33ff3"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier heath",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)",base00:"#1b181b",base01:"#292329",base02:"#695d69",base03:"#776977",base04:"#9e8f9e",base05:"#ab9bab",base06:"#d8cad8",base07:"#f7f3f7",base08:"#ca402b",base09:"#a65926",base0A:"#bb8a35",base0B:"#379a37",base0C:"#159393",base0D:"#516aec",base0E:"#7b59c0",base0F:"#cc33cc"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier lakeside",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)",base00:"#161b1d",base01:"#1f292e",base02:"#516d7b",base03:"#5a7b8c",base04:"#7195a8",base05:"#7ea2b4",base06:"#c1e4f6",base07:"#ebf8ff",base08:"#d22d72",base09:"#935c25",base0A:"#8a8a0f",base0B:"#568c3b",base0C:"#2d8f6f",base0D:"#257fad",base0E:"#5d5db1",base0F:"#b72dd2"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"atelier seaside",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)",base00:"#131513",base01:"#242924",base02:"#5e6e5e",base03:"#687d68",base04:"#809980",base05:"#8ca68c",base06:"#cfe8cf",base07:"#f0fff0",base08:"#e6193c",base09:"#87711d",base0A:"#c3c322",base0B:"#29a329",base0C:"#1999b3",base0D:"#3d62f5",base0E:"#ad2bee",base0F:"#e619c3"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"bespin",author:"jan t. sott",base00:"#28211c",base01:"#36312e",base02:"#5e5d5c",base03:"#666666",base04:"#797977",base05:"#8a8986",base06:"#9d9b97",base07:"#baae9e",base08:"#cf6a4c",base09:"#cf7d34",base0A:"#f9ee98",base0B:"#54be0d",base0C:"#afc4db",base0D:"#5ea6ea",base0E:"#9b859d",base0F:"#937121"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"brewer",author:"timothée poisot (http://github.com/tpoisot)",base00:"#0c0d0e",base01:"#2e2f30",base02:"#515253",base03:"#737475",base04:"#959697",base05:"#b7b8b9",base06:"#dadbdc",base07:"#fcfdfe",base08:"#e31a1c",base09:"#e6550d",base0A:"#dca060",base0B:"#31a354",base0C:"#80b1d3",base0D:"#3182bd",base0E:"#756bb1",base0F:"#b15928"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"bright",author:"chris kempson (http://chriskempson.com)",base00:"#000000",base01:"#303030",base02:"#505050",base03:"#b0b0b0",base04:"#d0d0d0",base05:"#e0e0e0",base06:"#f5f5f5",base07:"#ffffff",base08:"#fb0120",base09:"#fc6d24",base0A:"#fda331",base0B:"#a1c659",base0C:"#76c7b7",base0D:"#6fb3d2",base0E:"#d381c3",base0F:"#be643c"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"chalk",author:"chris kempson (http://chriskempson.com)",base00:"#151515",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#b0b0b0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#f5f5f5",base08:"#fb9fb1",base09:"#eda987",base0A:"#ddb26f",base0B:"#acc267",base0C:"#12cfc0",base0D:"#6fc2ef",base0E:"#e1a3ee",base0F:"#deaf8f"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"codeschool",author:"brettof86",base00:"#232c31",base01:"#1c3657",base02:"#2a343a",base03:"#3f4944",base04:"#84898c",base05:"#9ea7a6",base06:"#a7cfa3",base07:"#b5d8f6",base08:"#2a5491",base09:"#43820d",base0A:"#a03b1e",base0B:"#237986",base0C:"#b02f30",base0D:"#484d79",base0E:"#c59820",base0F:"#c98344"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"colors",author:"mrmrs (http://clrs.cc)",base00:"#111111",base01:"#333333",base02:"#555555",base03:"#777777",base04:"#999999",base05:"#bbbbbb",base06:"#dddddd",base07:"#ffffff",base08:"#ff4136",base09:"#ff851b",base0A:"#ffdc00",base0B:"#2ecc40",base0C:"#7fdbff",base0D:"#0074d9",base0E:"#b10dc9",base0F:"#85144b"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"default",author:"chris kempson (http://chriskempson.com)",base00:"#181818",base01:"#282828",base02:"#383838",base03:"#585858",base04:"#b8b8b8",base05:"#d8d8d8",base06:"#e8e8e8",base07:"#f8f8f8",base08:"#ab4642",base09:"#dc9656",base0A:"#f7ca88",base0B:"#a1b56c",base0C:"#86c1b9",base0D:"#7cafc2",base0E:"#ba8baf",base0F:"#a16946"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"eighties",author:"chris kempson (http://chriskempson.com)",base00:"#2d2d2d",base01:"#393939",base02:"#515151",base03:"#747369",base04:"#a09f93",base05:"#d3d0c8",base06:"#e8e6df",base07:"#f2f0ec",base08:"#f2777a",base09:"#f99157",base0A:"#ffcc66",base0B:"#99cc99",base0C:"#66cccc",base0D:"#6699cc",base0E:"#cc99cc",base0F:"#d27b53"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"embers",author:"jannik siebert (https://github.com/janniks)",base00:"#16130F",base01:"#2C2620",base02:"#433B32",base03:"#5A5047",base04:"#8A8075",base05:"#A39A90",base06:"#BEB6AE",base07:"#DBD6D1",base08:"#826D57",base09:"#828257",base0A:"#6D8257",base0B:"#57826D",base0C:"#576D82",base0D:"#6D5782",base0E:"#82576D",base0F:"#825757"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"flat",author:"chris kempson (http://chriskempson.com)",base00:"#2C3E50",base01:"#34495E",base02:"#7F8C8D",base03:"#95A5A6",base04:"#BDC3C7",base05:"#e0e0e0",base06:"#f5f5f5",base07:"#ECF0F1",base08:"#E74C3C",base09:"#E67E22",base0A:"#F1C40F",base0B:"#2ECC71",base0C:"#1ABC9C",base0D:"#3498DB",base0E:"#9B59B6",base0F:"#be643c"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"google",author:"seth wright (http://sethawright.com)",base00:"#1d1f21",base01:"#282a2e",base02:"#373b41",base03:"#969896",base04:"#b4b7b4",base05:"#c5c8c6",base06:"#e0e0e0",base07:"#ffffff",base08:"#CC342B",base09:"#F96A38",base0A:"#FBA922",base0B:"#198844",base0C:"#3971ED",base0D:"#3971ED",base0E:"#A36AC7",base0F:"#3971ED"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"grayscale",author:"alexandre gavioli (https://github.com/alexx2/)",base00:"#101010",base01:"#252525",base02:"#464646",base03:"#525252",base04:"#ababab",base05:"#b9b9b9",base06:"#e3e3e3",base07:"#f7f7f7",base08:"#7c7c7c",base09:"#999999",base0A:"#a0a0a0",base0B:"#8e8e8e",base0C:"#868686",base0D:"#686868",base0E:"#747474",base0F:"#5e5e5e"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"green screen",author:"chris kempson (http://chriskempson.com)",base00:"#001100",base01:"#003300",base02:"#005500",base03:"#007700",base04:"#009900",base05:"#00bb00",base06:"#00dd00",base07:"#00ff00",base08:"#007700",base09:"#009900",base0A:"#007700",base0B:"#00bb00",base0C:"#005500",base0D:"#009900",base0E:"#00bb00",base0F:"#005500"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"harmonic16",author:"jannik siebert (https://github.com/janniks)",base00:"#0b1c2c",base01:"#223b54",base02:"#405c79",base03:"#627e99",base04:"#aabcce",base05:"#cbd6e2",base06:"#e5ebf1",base07:"#f7f9fb",base08:"#bf8b56",base09:"#bfbf56",base0A:"#8bbf56",base0B:"#56bf8b",base0C:"#568bbf",base0D:"#8b56bf",base0E:"#bf568b",base0F:"#bf5656"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"hopscotch",author:"jan t. sott",base00:"#322931",base01:"#433b42",base02:"#5c545b",base03:"#797379",base04:"#989498",base05:"#b9b5b8",base06:"#d5d3d5",base07:"#ffffff",base08:"#dd464c",base09:"#fd8b19",base0A:"#fdcc59",base0B:"#8fc13e",base0C:"#149b93",base0D:"#1290bf",base0E:"#c85e7c",base0F:"#b33508"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"isotope",author:"jan t. sott",base00:"#000000",base01:"#404040",base02:"#606060",base03:"#808080",base04:"#c0c0c0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#ffffff",base08:"#ff0000",base09:"#ff9900",base0A:"#ff0099",base0B:"#33ff00",base0C:"#00ffff",base0D:"#0066ff",base0E:"#cc00ff",base0F:"#3300ff"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"marrakesh",author:"alexandre gavioli (http://github.com/alexx2/)",base00:"#201602",base01:"#302e00",base02:"#5f5b17",base03:"#6c6823",base04:"#86813b",base05:"#948e48",base06:"#ccc37a",base07:"#faf0a5",base08:"#c35359",base09:"#b36144",base0A:"#a88339",base0B:"#18974e",base0C:"#75a738",base0D:"#477ca1",base0E:"#8868b3",base0F:"#b3588e"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"mocha",author:"chris kempson (http://chriskempson.com)",base00:"#3B3228",base01:"#534636",base02:"#645240",base03:"#7e705a",base04:"#b8afad",base05:"#d0c8c6",base06:"#e9e1dd",base07:"#f5eeeb",base08:"#cb6077",base09:"#d28b71",base0A:"#f4bc87",base0B:"#beb55b",base0C:"#7bbda4",base0D:"#8ab3b5",base0E:"#a89bb9",base0F:"#bb9584"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"monokai",author:"wimer hazenberg (http://www.monokai.nl)",base00:"#272822",base01:"#383830",base02:"#49483e",base03:"#75715e",base04:"#a59f85",base05:"#f8f8f2",base06:"#f5f4f1",base07:"#f9f8f5",base08:"#f92672",base09:"#fd971f",base0A:"#f4bf75",base0B:"#a6e22e",base0C:"#a1efe4",base0D:"#66d9ef",base0E:"#ae81ff",base0F:"#cc6633"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"ocean",author:"chris kempson (http://chriskempson.com)",base00:"#2b303b",base01:"#343d46",base02:"#4f5b66",base03:"#65737e",base04:"#a7adba",base05:"#c0c5ce",base06:"#dfe1e8",base07:"#eff1f5",base08:"#bf616a",base09:"#d08770",base0A:"#ebcb8b",base0B:"#a3be8c",base0C:"#96b5b4",base0D:"#8fa1b3",base0E:"#b48ead",base0F:"#ab7967"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"paraiso",author:"jan t. sott",base00:"#2f1e2e",base01:"#41323f",base02:"#4f424c",base03:"#776e71",base04:"#8d8687",base05:"#a39e9b",base06:"#b9b6b0",base07:"#e7e9db",base08:"#ef6155",base09:"#f99b15",base0A:"#fec418",base0B:"#48b685",base0C:"#5bc4bf",base0D:"#06b6ef",base0E:"#815ba4",base0F:"#e96ba8"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"pop",author:"chris kempson (http://chriskempson.com)",base00:"#000000",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#b0b0b0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#ffffff",base08:"#eb008a",base09:"#f29333",base0A:"#f8ca12",base0B:"#37b349",base0C:"#00aabb",base0D:"#0e5a94",base0E:"#b31e8d",base0F:"#7a2d00"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"railscasts",author:"ryan bates (http://railscasts.com)",base00:"#2b2b2b",base01:"#272935",base02:"#3a4055",base03:"#5a647e",base04:"#d4cfc9",base05:"#e6e1dc",base06:"#f4f1ed",base07:"#f9f7f3",base08:"#da4939",base09:"#cc7833",base0A:"#ffc66d",base0B:"#a5c261",base0C:"#519f50",base0D:"#6d9cbe",base0E:"#b6b3eb",base0F:"#bc9458"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"shapeshifter",author:"tyler benziger (http://tybenz.com)",base00:"#000000",base01:"#040404",base02:"#102015",base03:"#343434",base04:"#555555",base05:"#ababab",base06:"#e0e0e0",base07:"#f9f9f9",base08:"#e92f2f",base09:"#e09448",base0A:"#dddd13",base0B:"#0ed839",base0C:"#23edda",base0D:"#3b48e3",base0E:"#f996e2",base0F:"#69542d"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"solarized",author:"ethan schoonover (http://ethanschoonover.com/solarized)",base00:"#002b36",base01:"#073642",base02:"#586e75",base03:"#657b83",base04:"#839496",base05:"#93a1a1",base06:"#eee8d5",base07:"#fdf6e3",base08:"#dc322f",base09:"#cb4b16",base0A:"#b58900",base0B:"#859900",base0C:"#2aa198",base0D:"#268bd2",base0E:"#6c71c4",base0F:"#d33682"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"summerfruit",author:"christopher corley (http://cscorley.github.io/)",base00:"#151515",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#B0B0B0",base05:"#D0D0D0",base06:"#E0E0E0",base07:"#FFFFFF",base08:"#FF0086",base09:"#FD8900",base0A:"#ABA800",base0B:"#00C918",base0C:"#1faaaa",base0D:"#3777E6",base0E:"#AD00A1",base0F:"#cc6633"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"tomorrow",author:"chris kempson (http://chriskempson.com)",base00:"#1d1f21",base01:"#282a2e",base02:"#373b41",base03:"#969896",base04:"#b4b7b4",base05:"#c5c8c6",base06:"#e0e0e0",base07:"#ffffff",base08:"#cc6666",base09:"#de935f",base0A:"#f0c674",base0B:"#b5bd68",base0C:"#8abeb7",base0D:"#81a2be",base0E:"#b294bb",base0F:"#a3685a"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"london tube",author:"jan t. sott",base00:"#231f20",base01:"#1c3f95",base02:"#5a5758",base03:"#737171",base04:"#959ca1",base05:"#d9d8d8",base06:"#e7e7e8",base07:"#ffffff",base08:"#ee2e24",base09:"#f386a1",base0A:"#ffd204",base0B:"#00853e",base0C:"#85cebc",base0D:"#009ddc",base0E:"#98005d",base0F:"#b06110"},e.exports=t.default},function(e,t,n){"use strict";t.__esModule=!0,t.default={scheme:"twilight",author:"david hart (http://hart-dev.com)",base00:"#1e1e1e",base01:"#323537",base02:"#464b50",base03:"#5f5a60",base04:"#838184",base05:"#a7a7a7",base06:"#c3c3c3",base07:"#ffffff",base08:"#cf6a4c",base09:"#cda869",base0A:"#f9ee98",base0B:"#8f9d6a",base0C:"#afc4db",base0D:"#7587a6",base0E:"#9b859d",base0F:"#9b703f"},e.exports=t.default},function(e,t,n){function r(e){var t=Math.round(o(e,0,255)),n=t.toString(16);return 1==n.length?"0"+n:n}function a(e){var t=4===e.length?r(255*e[3]):"";return"#"+r(e[0])+r(e[1])+r(e[2])+t}var o=n(40);e.exports=a},function(e,t,n){function r(e){var t=o(e),n=u(t);return 4===t.length&&n.push(t[3]),n}function a(e){for(var t in l)if(0===e.indexOf(t))return l[t](e)}var o=n(152),i=n(153),s=n(154),u=n(155),l={"#":i,hsl:r,rgb:s};a.rgb=s,a.hsl=o,a.hex=i,e.exports=a},function(e,t,n){function r(e,t){switch(e=parseFloat(e),t){case 0:return i(e,0,360);case 1:case 2:return i(e,0,100);case 3:return i(e,0,1)}}function a(e){return o(e).map(r)}var o=n(52),i=n(40);e.exports=a},function(e,t){function n(e){for(var t="#",n=1;n<e.length;n++){var r=e.charAt(n);t+=r+r}return t}function r(e){4!==e.length&&5!==e.length||(e=n(e));var t=[parseInt(e.substring(1,3),16),parseInt(e.substring(3,5),16),parseInt(e.substring(5,7),16)];if(9===e.length){var r=parseFloat((parseInt(e.substring(7,9),16)/255).toFixed(2));t.push(r)}return t}e.exports=r},function(e,t,n){function r(e,t){return t<3?-1!=e.indexOf("%")?Math.round(255*i(parseInt(e,10),0,100)/100):i(parseInt(e,10),0,255):i(parseFloat(e),0,1)}function a(e){return o(e).map(r)}var o=n(52),i=n(40);e.exports=a},function(e,t){function n(e){var t,n,r,a,o,i=e[0]/360,s=e[1]/100,u=e[2]/100;if(0==s)return o=255*u,[o,o,o];n=u<.5?u*(1+s):u+s-u*s,t=2*u-n,a=[0,0,0];for(var l=0;l<3;l++)r=i+1/3*-(l-1),r<0&&r++,r>1&&r--,o=6*r<1?t+6*(n-t)*r:2*r<1?n:3*r<2?t+(n-t)*(2/3-r)*6:t,a[l]=255*o;return a}e.exports=n},function(e,t,n){(function(t){function n(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function r(e,t){for(var n=-1,r=t.length,a=e.length;++n<r;)e[a+n]=t[n];return e}function a(e,t,n,o,s){var u=-1,l=e.length;for(n||(n=i),s||(s=[]);++u<l;){var c=e[u];t>0&&n(c)?t>1?a(c,t-1,n,o,s):r(s,c):o||(s[s.length]=c)}return s}function o(e,t){return t=k(void 0===t?e.length-1:t,0),function(){for(var r=arguments,a=-1,o=k(r.length-t,0),i=Array(o);++a<o;)i[a]=r[t+a];a=-1;for(var s=Array(t+1);++a<t;)s[a]=r[a];return s[t]=i,n(e,this,s)}}function i(e){return P(e)||s(e)||!!(C&&e&&e[C])}function s(e){return l(e)&&O.call(e,"callee")&&(!x.call(e,"callee")||E.call(e)==h)}function u(e){return null!=e&&f(e.length)&&!c(e)}function l(e){return p(e)&&u(e)}function c(e){var t=d(e)?E.call(e):"";return t==y||t==v}function f(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=b}function d(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function p(e){return!!e&&"object"==typeof e}var b=9007199254740991,h="[object Arguments]",y="[object Function]",v="[object GeneratorFunction]",m="object"==typeof t&&t&&t.Object===Object&&t,g="object"==typeof self&&self&&self.Object===Object&&self,_=m||g||Function("return this")(),j=Object.prototype,O=j.hasOwnProperty,E=j.toString,w=_.Symbol,x=j.propertyIsEnumerable,C=w?w.isConcatSpreadable:void 0,k=Math.max,P=Array.isArray,M=function(e){return o(function(e){e=a(e,1);var t=e.length,n=t;for(void 0;n--;)if("function"!=typeof e[n])throw new TypeError("Expected a function");return function(){for(var n=0,r=t?e[n].apply(this,arguments):arguments[0];++n<t;)r=e[n].call(this,r);return r}})}();e.exports=M}).call(t,n(51))},function(e,t,n){"use strict";function r(e){var t,n,r,a=e[0],o=e[1],i=e[2];return t=1*a+0*o+1.13983*i,n=1*a+-.39465*o+-.5806*i,r=1*a+2.02311*o+0*i,t=Math.min(Math.max(0,t),1),n=Math.min(Math.max(0,n),1),r=Math.min(Math.max(0,r),1),[255*t,255*n,255*r]}function a(e){var t=e[0]/255,n=e[1]/255,r=e[2]/255;return[.299*t+.587*n+.114*r,-.14713*t+-.28886*n+.436*r,.615*t+-.51499*n+-.10001*r]}Object.defineProperty(t,"__esModule",{value:!0}),t.yuv2rgb=r,t.rgb2yuv=a},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t={weekday:"short",year:"numeric",month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"};return c.default.createElement("div",(0,b.default)(e.theme,"date"),c.default.createElement(d.default,s({type_name:"date"},e)),c.default.createElement("span",s({className:"date-value"},(0,b.default)(e.theme,"date-value")),e.value.toLocaleTimeString("en-us",t)))}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"float"),c.default.createElement(d.default,s({type_name:"float"},e)),this.props.value)}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=n(13),y=r(h),v=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return m.call(n),n.state.collapsed=y.default.get(e.rjvId,e.namespace,"collapsed",!0),n}return i(t,e),u(t,[{key:"render",value:function(){var e=this,t=this.props,n=this.state.collapsed;return c.default.createElement("div",(0,b.default)(t.theme,"function"),c.default.createElement(d.default,s({type_name:"function"},t)),c.default.createElement("span",s({},(0,b.default)(t.theme,"function-value"),{className:"rjv-function-container",onClick:function(){e.toggleCollapsed()}}),this.getFunctionDisplay(n)))}}]),t}(c.default.Component),m=function(){var e=this;this.state={collapsed:!0},this.toggleCollapsed=function(){e.state.collapsed=!e.state.collapsed,y.default.set(e.props.rjvId,e.props.namespace,"collapsed",e.state.collapsed),e.setState(e.state)},this.getFunctionDisplay=function(t){var n=e.props;return t?c.default.createElement("span",null,e.props.value.toString().slice(9,-1).replace(/\{[\s\S]+/,""),c.default.createElement("span",{className:"function-collapsed",style:{fontWeight:"bold"}},c.default.createElement("span",null,"{"),c.default.createElement("span",(0,b.default)(n.theme,"ellipsis"),"..."),c.default.createElement("span",null,"}"))):e.props.value.toString().slice(9,-1)}};t.default=v},function(e,t){function n(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function r(e){return"function"==typeof e}function a(e){return"number"==typeof e}function o(e){return"object"==typeof e&&null!==e}function i(e){return void 0===e}e.exports=n,n.EventEmitter=n,n.prototype._events=void 0,n.prototype._maxListeners=void 0,n.defaultMaxListeners=10,n.prototype.setMaxListeners=function(e){if(!a(e)||e<0||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},n.prototype.emit=function(e){var t,n,a,s,u,l;if(this._events||(this._events={}),"error"===e&&(!this._events.error||o(this._events.error)&&!this._events.error.length)){if((t=arguments[1])instanceof Error)throw t;var c=new Error('Uncaught, unspecified "error" event. ('+t+")");throw c.context=t,c}if(n=this._events[e],i(n))return!1;if(r(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:s=Array.prototype.slice.call(arguments,1),n.apply(this,s)}else if(o(n))for(s=Array.prototype.slice.call(arguments,1),l=n.slice(),a=l.length,u=0;u<a;u++)l[u].apply(this,s);return!0},n.prototype.addListener=function(e,t){var a;if(!r(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,r(t.listener)?t.listener:t),this._events[e]?o(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,o(this._events[e])&&!this._events[e].warned&&(a=i(this._maxListeners)?n.defaultMaxListeners:this._maxListeners)&&a>0&&this._events[e].length>a&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace()),this},n.prototype.on=n.prototype.addListener,n.prototype.once=function(e,t){function n(){this.removeListener(e,n),a||(a=!0,t.apply(this,arguments))}if(!r(t))throw TypeError("listener must be a function");var a=!1;return n.listener=t,this.on(e,n),this},n.prototype.removeListener=function(e,t){var n,a,i,s;if(!r(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(n=this._events[e],i=n.length,a=-1,n===t||r(n.listener)&&n.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(o(n)){for(s=i;s-- >0;)if(n[s]===t||n[s].listener&&n[s].listener===t){a=s;break}if(a<0)return this;1===n.length?(n.length=0,delete this._events[e]):n.splice(a,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},n.prototype.removeAllListeners=function(e){var t,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(n=this._events[e],r(n))this.removeListener(e,n);else if(n)for(;n.length;)this.removeListener(e,n[n.length-1]);return delete this._events[e],this},n.prototype.listeners=function(e){return this._events&&this._events[e]?r(this._events[e])?[this._events[e]]:this._events[e].slice():[]},n.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(r(t))return 1;if(t)return t.length}return 0},n.listenerCount=function(e,t){return e.listenerCount(t)}},function(e,t,n){e.exports.Dispatcher=n(163)},function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}t.__esModule=!0;var a=n(53),o=function(){function e(){r(this,e),this._callbacks={},this._isDispatching=!1,this._isHandled={},this._isPending={},this._lastID=1}return e.prototype.register=function(e){var t="ID_"+this._lastID++;return this._callbacks[t]=e,t},e.prototype.unregister=function(e){this._callbacks[e]||a(!1),delete this._callbacks[e]},e.prototype.waitFor=function(e){this._isDispatching||a(!1);for(var t=0;t<e.length;t++){var n=e[t];this._isPending[n]?this._isHandled[n]||a(!1):(this._callbacks[n]||a(!1),this._invokeCallback(n))}},e.prototype.dispatch=function(e){this._isDispatching&&a(!1),this._startDispatching(e);try{for(var t in this._callbacks)this._isPending[t]||this._invokeCallback(t)}finally{this._stopDispatching()}},e.prototype.isDispatching=function(){return this._isDispatching},e.prototype._invokeCallback=function(e){this._isPending[e]=!0,this._callbacks[e](this._pendingPayload),this._isHandled[e]=!0},e.prototype._startDispatching=function(e){for(var t in this._callbacks)this._isPending[t]=!1,this._isHandled[t]=!1;this._pendingPayload=e,this._isDispatching=!0},e.prototype._stopDispatching=function(){delete this._pendingPayload,this._isDispatching=!1},e}();e.exports=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=r(u),c=n(1),f=r(c),d=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return l.default.createElement("div",(0,f.default)(this.props.theme,"nan"),"NaN")}}]),t}(l.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=r(u),c=n(1),f=r(c),d=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return l.default.createElement("div",(0,f.default)(this.props.theme,"null"),"NULL")}}]),t}(l.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"integer"),c.default.createElement(d.default,s({type_name:"int"},e)),this.props.value)}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(1),b=r(p),h=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props;return c.default.createElement("div",(0,b.default)(e.theme,"regexp"),c.default.createElement(d.default,s({type_name:"regexp"},e)),this.props.value.toString())}}]),t}(c.default.Component);t.default=h},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(6),d=r(f),p=n(4),b=n(1),h=r(b),y=n(13),v=r(y),m=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.state={collapsed:!0},n.toggleCollapsed=function(){n.state.collapsed=!n.state.collapsed,v.default.set(n.props.rjvId,n.props.namespace,"collapsed",n.state.collapsed),n.setState(n.state)},n.state.collapsed=v.default.get(e.rjvId,e.namespace,"collapsed",!0),n}return i(t,e),u(t,[{key:"render",value:function(){var e=(this.state.collapsed,this.props),t=e.collapseStringsAfterLength,n=e.theme,r=e.value,a="integer"==(0,p.toType)(t),o={style:{cursor:"default"}};return a&&r.length>t&&(o.style.cursor="pointer",this.state.collapsed&&(r=c.default.createElement("span",null,r.substring(0,t),c.default.createElement("span",(0,h.default)(n,"ellipsis")," ...")))),c.default.createElement("div",(0,h.default)(n,"string"),c.default.createElement(d.default,s({type_name:"string"},e)),c.default.createElement("span",s({className:"string-value"},o,{onClick:this.toggleCollapsed}),'"',r,'"'))}}]),t}(c.default.Component);t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),u=n(0),l=r(u),c=n(1),f=r(c),d=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),s(t,[{key:"render",value:function(){return l.default.createElement("div",(0,f.default)(this.props.theme,"undefined"),"undefined")}}]),t}(l.default.Component);t.default=d},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},l=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),c=n(0),f=r(c),d=n(171),p=r(d),b=(n(4),n(14)),h=r(b),y=n(176),v=r(y),m=n(54),g=r(m),_=n(55),j=r(_),O=n(41),E=n(15),w=n(1),x=r(w),C=function(e){function t(){var e,n,r,a;o(this,t);for(var s=arguments.length,l=Array(s),c=0;c<s;c++)l[c]=arguments[c];return n=r=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.state={editMode:!1,editValue:"",renameKey:!1,parsedInput:{type:!1,value:null}},r.getEditIcon=function(){var e=r.props,t=e.variable,n=e.theme;return f.default.createElement("div",{className:"click-to-edit",style:{verticalAlign:"top"}},f.default.createElement(E.Edit,u({className:"click-to-edit-icon"},(0,x.default)(n,"editVarIcon"),{onClick:function(){r.prepopInput(t)}})))},r.prepopInput=function(e){var t=void 0;!1!==r.props.onEdit&&(r.state.editMode=!0,r.state.editValue=(0,g.default)(e.value),t=(0,v.default)(r.state.editValue),r.state.parsedInput={type:t.type,value:t.value},r.setState(r.state))},r.getRemoveIcon=function(){var e=r.props,t=e.variable,n=e.namespace,a=e.theme,o=e.rjvId;return f.default.createElement("div",{className:"click-to-remove",style:{verticalAlign:"top"}},f.default.createElement(E.RemoveCircle,u({className:"click-to-remove-icon"},(0,x.default)(a,"removeVarIcon"),{onClick:function(){h.default.dispatch({name:"VARIABLE_REMOVED",rjvId:o,data:{name:t.name,namespace:n,existing_value:t.value,variable_removed:!0}})}})))},r.getValue=function(e,t){var n=!t&&e.type,a=r,o=a.props;switch(n){case!1:return r.getEditInput();case"string":return f.default.createElement(O.JsonString,u({value:e.value},o));case"integer":return f.default.createElement(O.JsonInteger,u({value:e.value},o));case"float":return f.default.createElement(O.JsonFloat,u({value:e.value},o));case"boolean":return f.default.createElement(O.JsonBoolean,u({value:e.value},o));case"function":return f.default.createElement(O.JsonFunction,u({value:e.value},o));case"null":return f.default.createElement(O.JsonNull,o);case"nan":return f.default.createElement(O.JsonNan,o);case"undefined":return f.default.createElement(O.JsonUndefined,o);case"date":return f.default.createElement(O.JsonDate,u({value:e.value},o));case"regexp":return f.default.createElement(O.JsonRegexp,u({value:e.value},o));default:return f.default.createElement("div",{className:"object-value"},JSON.stringify(e.value))}},r.getEditInput=function(){var e=r.props.theme,t=r.state.editValue;return f.default.createElement("div",null,f.default.createElement(p.default,u({type:"text",inputRef:function(e){return e&&e.focus()},value:t,className:"variable-editor",onChange:function(e){var t=e.target.value,n=(0,v.default)(t);r.setState({editValue:t,parsedInput:{type:n.type,value:n.value}})},onKeyDown:function(e){switch(e.key){case"Escape":r.setState({editMode:!1,editValue:""});break;case"Enter":(e.ctrlKey||e.metaKey)&&r.submitEdit(!0)}e.stopPropagation()},placeholder:"update this value"},(0,x.default)(e,"edit-input"))),f.default.createElement("div",(0,x.default)(e,"edit-icon-container"),f.default.createElement(E.RemoveCircle,u({className:"edit-cancel"},(0,x.default)(e,"cancel-icon"),{onClick:function(){r.setState({editMode:!1,editValue:""})}})),f.default.createElement(E.CheckCircle,u({className:"edit-check string-value"},(0,x.default)(e,"check-icon"),{onClick:function(){r.submitEdit()}})),f.default.createElement("div",null,r.showDetected())))},r.submitEdit=function(e){var t=r.props,n=t.variable,a=t.namespace,o=t.rjvId,i=r.state,s=i.editValue,u=i.parsedInput,l=s;e&&u.type&&(l=u.value),r.state.editMode=!1,h.default.dispatch({name:"VARIABLE_UPDATED",rjvId:o,data:{name:n.name,namespace:a,existing_value:n.value,new_value:l,variable_removed:!1}})},r.showDetected=function(){var e=r.props,t=e.theme,n=(e.variable,e.namespace,e.rjvId,r.state.parsedInput),a=(n.type,n.value,r.getDetectedInput());if(a)return f.default.createElement("div",null,f.default.createElement("div",(0,x.default)(t,"detected-row"),a,f.default.createElement(E.CheckCircle,{className:"edit-check detected",style:u({verticalAlign:"top",paddingLeft:"3px"},(0,x.default)(t,"check-icon").style),onClick:function(){r.submitEdit(!0)}})))},r.getDetectedInput=function(){var e=r.state.parsedInput,t=e.type,n=e.value,a=r,o=a.props,i=r.props.theme;if(!1!==t)switch(t.toLowerCase()){case"object":return f.default.createElement("span",null,f.default.createElement("span",{style:u({},(0,x.default)(i,"brace").style,{cursor:"default"})},"{"),f.default.createElement("span",{style:u({},(0,x.default)(i,"ellipsis").style,{cursor:"default"})},"..."),f.default.createElement("span",{style:u({},(0,x.default)(i,"brace").style,{cursor:"default"})},"}"));case"array":return f.default.createElement("span",null,f.default.createElement("span",{style:u({},(0,x.default)(i,"brace").style,{cursor:"default"})},"["),f.default.createElement("span",{style:u({},(0,x.default)(i,"ellipsis").style,{cursor:"default"})},"..."),f.default.createElement("span",{style:u({},(0,x.default)(i,"brace").style,{cursor:"default"})},"]"));case"string":return f.default.createElement(O.JsonString,u({value:n},o));case"integer":return f.default.createElement(O.JsonInteger,u({value:n},o));case"float":return f.default.createElement(O.JsonFloat,u({value:n},o));case"boolean":return f.default.createElement(O.JsonBoolean,u({value:n},o));case"function":return f.default.createElement(O.JsonFunction,u({value:n},o));case"null":return f.default.createElement(O.JsonNull,o);case"nan":return f.default.createElement(O.JsonNan,o);case"undefined":return f.default.createElement(O.JsonUndefined,o);case"date":return f.default.createElement(O.JsonDate,u({value:new Date(n)},o))}},a=n,i(r,a)}return s(t,e),l(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.variable,r=(t.src,t.singleIndent),o=t.type,i=t.theme,s=t.namespace,l=t.indentWidth,c=t.enableClipboard,d=t.onEdit,p=t.onDelete,b=t.onSelect,h=(t.rjvId,this.state.editMode);return f.default.createElement("div",u({},(0,x.default)(i,"objectKeyVal",{paddingLeft:l*r}),{className:"variable-row",key:n.name}),"array"==o?f.default.createElement("span",u({},(0,x.default)(i,"array-key"),{key:n.name+"_"+s}),n.name,f.default.createElement("div",(0,x.default)(i,"colon"),":")):f.default.createElement("span",null,f.default.createElement("span",u({},(0,x.default)(i,"object-name"),{className:"object-key",key:n.name+"_"+s}),f.default.createElement("span",{style:{verticalAlign:"top"}},'"'),f.default.createElement("span",{style:{display:"inline-block"}},n.name),f.default.createElement("span",{style:{verticalAlign:"top"}},'"')),f.default.createElement("span",(0,x.default)(i,"colon"),":")),f.default.createElement("div",u({className:"variable-value",onClick:!1===b&&!1===d?null:function(t){var r=[].concat(a(s));(t.ctrlKey||t.metaKey)&&!1!==d?e.prepopInput(n):!1!==b&&(r.shift(),b(u({},n,{namespace:r})))}},(0,x.default)(i,"variableValue",{cursor:!1===b?"default":"pointer"})),this.getValue(n,h)),c?f.default.createElement(j.default,u({hidden:h,src:n.value,clickCallback:c},{theme:i,namespace:s})):null,!1!==d&&0==h?this.getEditIcon():null,!1!==p&&0==h?this.getRemoveIcon():null)}}]),t}(f.default.Component);t.default=C},function(e,t,n){"use strict";function r(){return r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},r.apply(this,arguments)}function a(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t}function o(e,t){if(null==e)return{};var n,r,a={},o=Object.keys(e);for(r=0;r<o.length;r++)n=o[r],t.indexOf(n)>=0||(a[n]=e[n]);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(r=0;r<i.length;r++)n=i[r],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(a[n]=e[n])}return a}function i(e,t,n,r,a){void 0===n&&(n=!1),void 0===r&&(r=null),void 0===a&&(a=null),null===b.parentNode&&document.body.appendChild(b);var o=s(e,t,n);if(null===o)return null;var i=o.paddingSize,u=o.borderSize,l=o.boxSizing,c=o.sizingStyle;Object.keys(c).forEach(function(e){b.style[e]=c[e]}),Object.keys(h).forEach(function(e){b.style.setProperty(e,h[e],"important")}),b.value=e.value||e.placeholder||"x";var f=-1/0,d=1/0,p=b.scrollHeight;"border-box"===l?p+=u:"content-box"===l&&(p-=i),b.value="x";var y=b.scrollHeight-i;return null===r&&null===a||(null!==r&&(f=y*r,"border-box"===l&&(f=f+i+u),p=Math.max(f,p)),null!==a&&(d=y*a,"border-box"===l&&(d=d+i+u),p=Math.min(d,p))),{height:p,minHeight:f,maxHeight:d,rowCount:Math.floor(p/y)}}function s(e,t,n){if(void 0===n&&(n=!1),n&&v[t])return v[t];var r=window.getComputedStyle(e);if(null===r)return null;var a=y.reduce(function(e,t){return e[t]=r.getPropertyValue(t),e},{}),o=a["box-sizing"];p&&"border-box"===o&&(a.width=parseFloat(a.width)+parseFloat(r["border-right-width"])+parseFloat(r["border-left-width"])+parseFloat(r["padding-right"])+parseFloat(r["padding-left"])+"px");var i=parseFloat(a["padding-bottom"])+parseFloat(a["padding-top"]),s=parseFloat(a["border-bottom-width"])+parseFloat(a["border-top-width"]),u={sizingStyle:a,paddingSize:i,borderSize:s,boxSizing:o};return n&&(v[t]=u),u}Object.defineProperty(t,"__esModule",{value:!0});var u=n(0),l=n.n(u),c=n(172),f=n.n(c),d="undefined"!=typeof window&&"undefined"!=typeof document,p=!!d&&!!document.documentElement.currentStyle,b=d&&document.createElement("textarea"),h={"min-height":"0","max-height":"none",height:"0",visibility:"hidden",overflow:"hidden",position:"absolute","z-index":"-1000",top:"0",right:"0"},y=["letter-spacing","line-height","font-family","font-weight","font-size","font-style","tab-size","text-rendering","text-transform","width","text-indent","padding-top","padding-right","padding-bottom","padding-left","border-top-width","border-right-width","border-bottom-width","border-left-width","box-sizing"],v={},m=function(e){return delete v[e]},g=function(e){return void 0===e&&(e=0),function(){return++e}}(),_=function(){},j=d&&window.requestAnimationFrame?[window.requestAnimationFrame,window.cancelAnimationFrame]:[setTimeout,clearTimeout],O=j[0],E=j[1],w=function(e){function t(t){var n;return n=e.call(this,t)||this,n._resizeLock=!1,n._onRootDOMNode=function(e){n._rootDOMNode=e,n.props.inputRef&&n.props.inputRef(e)},n._onChange=function(e){n._controlled||n._resizeComponent(),n.props.onChange(e)},n._resizeComponent=function(e){if(void 0===e&&(e=_),void 0===n._rootDOMNode)return void e();var t=i(n._rootDOMNode,n._uid,n.props.useCacheForDOMMeasurements,n.props.minRows,n.props.maxRows);if(null===t)return void e();var r=t.height,a=t.minHeight,o=t.maxHeight,s=t.rowCount;if(n.rowCount=s,n.state.height!==r||n.state.minHeight!==a||n.state.maxHeight!==o)return void n.setState({height:r,minHeight:a,maxHeight:o},e);e()},n.state={height:t.style&&t.style.height||0,minHeight:-1/0,maxHeight:1/0},n._uid=g(),n._controlled="string"==typeof t.value,n}a(t,e);var n=t.prototype;return n.render=function(){var e=this.props,t=(e.minRows,e.maxRows,e.onHeightChange,e.useCacheForDOMMeasurements,e.inputRef,o(e,["minRows","maxRows","onHeightChange","useCacheForDOMMeasurements","inputRef"]));return t.style=r({},t.style,{height:this.state.height}),Math.max(t.style.maxHeight||1/0,this.state.maxHeight)<this.state.height&&(t.style.overflow="hidden"),l.a.createElement("textarea",r({},t,{onChange:this._onChange,ref:this._onRootDOMNode}))},n.componentDidMount=function(){var e=this;this._resizeComponent(),this._resizeListener=function(){e._resizeLock||(e._resizeLock=!0,e._resizeComponent(function(){return e._resizeLock=!1}))},window.addEventListener("resize",this._resizeListener)},n.componentWillReceiveProps=function(){var e=this;this._clearNextFrame(),this._onNextFrameActionId=O(function(){return e._resizeComponent()})},n.componentDidUpdate=function(e,t){this.state.height!==t.height&&this.props.onHeightChange(this.state.height,this)},n.componentWillUnmount=function(){this._clearNextFrame(),window.removeEventListener("resize",this._resizeListener),m(this._uid)},n._clearNextFrame=function(){E(this._onNextFrameActionId)},t}(l.a.Component);w.propTypes={value:f.a.string,onChange:f.a.func,onHeightChange:f.a.func,useCacheForDOMMeasurements:f.a.bool,minRows:f.a.number,maxRows:f.a.number,inputRef:f.a.func},w.defaultProps={onChange:_,onHeightChange:_,useCacheForDOMMeasurements:!1},t.default=w},function(e,t,n){e.exports=n(173)()},function(e,t,n){"use strict";var r=n(174),a=n(53),o=n(175);e.exports=function(){function e(e,t,n,r,i,s){s!==o&&a(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var n={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return n.checkPropTypes=r,n.PropTypes=n,n}},function(e,t,n){"use strict";function r(e){return function(){return e}}var a=function(){};a.thatReturns=r,a.thatReturnsFalse=r(!1),a.thatReturnsTrue=r(!0),a.thatReturnsNull=r(null),a.thatReturnsThis=function(){return this},a.thatReturnsArgument=function(e){return e},e.exports=a},function(e,t,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(e,t,n){"use strict";function r(e){e=e.trim();try{if(e=JSON.stringify(JSON.parse(e)),"["==e[0])return a("array",JSON.parse(e));if("{"==e[0])return a("object",JSON.parse(e));if(e.match(/\-?\d+\.\d+/)&&e.match(/\-?\d+\.\d+/)[0]==e)return a("float",parseFloat(e));if(e.match(/\-?\d+/)&&e.match(/\-?\d+/)[0]==e)return a("integer",parseInt(e))}catch(e){}switch(e=e.toLowerCase()){case"undefined":return a("undefined",void 0);case"nan":return a("nan",NaN);case"null":return a("null",null);case"true":return a("boolean",!0);case"false":return a("boolean",!1);default:if(e=Date.parse(e))return a("date",new Date(e))}return a(!1,null)}function a(e,t){return{type:e,value:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(14),d=r(f),p=n(13),b=r(p),h=n(178),y=r(h),v=n(1),m=(r(v),function(e){function t(){var e,n,r,i;a(this,t);for(var u=arguments.length,l=Array(u),c=0;c<u;c++)l[c]=arguments[c];return n=r=o(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(l))),r.state={},r.isValid=function(e){var t=r.props.rjvId,n=b.default.get(t,"action","new-key-request");return""!=e&&-1===Object.keys(n.existing_value).indexOf(e)},r.submit=function(e){var t=r.props.rjvId,n=b.default.get(t,"action","new-key-request");n.new_value=s({},n.existing_value),n.new_value[e]=null,d.default.dispatch({name:"VARIABLE_ADDED",rjvId:t,data:n})},i=n,o(r,i)}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=e.active,n=e.theme,r=e.rjvId;return t?c.default.createElement(y.default,{rjvId:r,theme:n,isValid:this.isValid,submit:this.submit}):null}}]),t}(c.default.Component));t.default=m},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(14),d=r(f),p=n(15),b=n(1),h=r(b),y=function(e){function t(e){a(this,t);var n=o(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return n.closeModal=function(){d.default.dispatch({rjvId:n.props.rjvId,name:"RESET"})},n.submit=function(){n.props.submit(n.state.input)},n.state={input:e.input?e.input:""},n}return i(t,e),u(t,[{key:"render",value:function(){var e=this,t=this.props,n=t.theme,r=t.rjvId,a=t.isValid,o=this.state.input,i=a(o);return c.default.createElement("div",s({className:"key-modal-request"},(0,h.default)(n,"key-modal-request"),{onClick:function(){e.closeModal()}}),c.default.createElement("div",s({},(0,h.default)(n,"key-modal"),{onClick:function(e){e.stopPropagation()}}),c.default.createElement("div",(0,h.default)(n,"key-modal-label"),"Key Name:"),c.default.createElement("div",{style:{position:"relative"}},c.default.createElement("input",s({},(0,h.default)(n,"key-modal-input"),{className:"key-modal-input",ref:function(e){return e&&e.focus()},spellCheck:!1,value:o,placeholder:"...",onChange:function(t){e.setState({input:t.target.value})},onKeyPress:function(t){i&&"Enter"===t.key?e.submit():"Escape"===t.key&&e.closeModal()}})),i?c.default.createElement(p.CheckCircle,s({},(0,h.default)(n,"key-modal-submit"),{className:"key-modal-submit",onClick:function(t){return e.submit()}})):null),c.default.createElement("span",(0,h.default)(n,"key-modal-cancel"),c.default.createElement(p.Add,s({},(0,h.default)(n,"key-modal-cancel-icon"),{className:"key-modal-cancel",onClick:function(){d.default.dispatch({rjvId:r,name:"RESET"})}})))))}}]),t}(c.default.Component);t.default=y},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},u=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}(),l=n(0),c=r(l),f=n(14),d=r(f),p=n(13),b=(r(p),n(15)),h=n(1),y=r(h),v=function(e){function t(){return a(this,t),o(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return i(t,e),u(t,[{key:"render",value:function(){var e=this.props,t=e.message,n=e.active,r=e.theme,a=e.rjvId;return n?c.default.createElement("div",s({className:"validation-failure"},(0,y.default)(r,"validation-failure"),{onClick:function(){d.default.dispatch({rjvId:a,name:"RESET"})}}),c.default.createElement("span",(0,y.default)(r,"validation-failure-label"),t),c.default.createElement(b.Add,(0,y.default)(r,"validation-failure-clear"))):null}}]),t}(c.default.Component);t.default=v},function(e,t,n){var r=n(181);"string"==typeof r&&(r=[[e.i,r,""]]);var a={};a.transform=void 0,n(183)(r,a),r.locals&&(e.exports=r.locals)},function(e,t,n){t=e.exports=n(182)(!1),t.push([e.i,".react-json-view .copy-to-clipboard-container{vertical-align:top;display:none}.react-json-view .click-to-add,.react-json-view .click-to-edit,.react-json-view .click-to-remove{display:none}.react-json-view .object-content .variable-row:hover .click-to-edit,.react-json-view .object-content .variable-row:hover .click-to-remove,.react-json-view .object-key-val:hover>span>.object-meta-data>.click-to-add,.react-json-view .object-key-val:hover>span>.object-meta-data>.click-to-remove,.react-json-view .object-key-val:hover>span>.object-meta-data>.copy-to-clipboard-container,.react-json-view .variable-row:hover .copy-to-clipboard-container{display:inline-block}",""])},function(e,t){function n(e,t){var n=e[1]||"",a=e[3];if(!a)return n;if(t&&"function"==typeof btoa){var o=r(a);return[n].concat(a.sources.map(function(e){return"/*# sourceURL="+a.sourceRoot+e+" */"})).concat([o]).join("\n")}return[n].join("\n")}function r(e){return"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(e))))+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var r=n(t,e);return t[2]?"@media "+t[2]+"{"+r+"}":r}).join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},a=0;a<this.length;a++){var o=this[a][0];"number"==typeof o&&(r[o]=!0)}for(a=0;a<e.length;a++){var i=e[a];"number"==typeof i[0]&&r[i[0]]||(n&&!i[2]?i[2]=n:n&&(i[2]="("+i[2]+") and ("+n+")"),t.push(i))}},t}},function(e,t,n){function r(e,t){for(var n=0;n<e.length;n++){var r=e[n],a=b[r.id];if(a){a.refs++;for(var o=0;o<a.parts.length;o++)a.parts[o](r.parts[o]);for(;o<r.parts.length;o++)a.parts.push(c(r.parts[o],t))}else{for(var i=[],o=0;o<r.parts.length;o++)i.push(c(r.parts[o],t));b[r.id]={id:r.id,refs:1,parts:i}}}}function a(e,t){for(var n=[],r={},a=0;a<e.length;a++){var o=e[a],i=t.base?o[0]+t.base:o[0],s=o[1],u=o[2],l=o[3],c={css:s,media:u,sourceMap:l};r[i]?r[i].parts.push(c):n.push(r[i]={id:i,parts:[c]})}return n}function o(e,t){var n=y(e.insertInto);if(!n)throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");var r=g[g.length-1];if("top"===e.insertAt)r?r.nextSibling?n.insertBefore(t,r.nextSibling):n.appendChild(t):n.insertBefore(t,n.firstChild),g.push(t);else{if("bottom"!==e.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(t)}}function i(e){if(null===e.parentNode)return!1;e.parentNode.removeChild(e);var t=g.indexOf(e);t>=0&&g.splice(t,1)}function s(e){var t=document.createElement("style");return e.attrs.type="text/css",l(t,e.attrs),o(e,t),t}function u(e){var t=document.createElement("link");return e.attrs.type="text/css",e.attrs.rel="stylesheet",l(t,e.attrs),o(e,t),t}function l(e,t){Object.keys(t).forEach(function(n){e.setAttribute(n,t[n])})}function c(e,t){var n,r,a,o;if(t.transform&&e.css){if(!(o=t.transform(e.css)))return function(){};e.css=o}if(t.singleton){var l=m++;n=v||(v=s(t)),r=f.bind(null,n,l,!1),a=f.bind(null,n,l,!0)}else e.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=u(t),r=p.bind(null,n,t),a=function(){i(n),n.href&&URL.revokeObjectURL(n.href)}):(n=s(t),r=d.bind(null,n),a=function(){i(n)});return r(e),function(t){if(t){if(t.css===e.css&&t.media===e.media&&t.sourceMap===e.sourceMap)return;r(e=t)}else a()}}function f(e,t,n,r){var a=n?"":r.css;if(e.styleSheet)e.styleSheet.cssText=j(t,a);else{var o=document.createTextNode(a),i=e.childNodes;i[t]&&e.removeChild(i[t]),i.length?e.insertBefore(o,i[t]):e.appendChild(o)}}function d(e,t){var n=t.css,r=t.media;if(r&&e.setAttribute("media",r),e.styleSheet)e.styleSheet.cssText=n;else{for(;e.firstChild;)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(n))}}function p(e,t,n){var r=n.css,a=n.sourceMap,o=void 0===t.convertToAbsoluteUrls&&a;(t.convertToAbsoluteUrls||o)&&(r=_(r)),a&&(r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(a))))+" */");var i=new Blob([r],{type:"text/css"}),s=e.href;e.href=URL.createObjectURL(i),s&&URL.revokeObjectURL(s)}var b={},h=function(e){var t;return function(){return void 0===t&&(t=e.apply(this,arguments)),t}}(function(){return window&&document&&document.all&&!window.atob}),y=function(e){var t={};return function(n){return void 0===t[n]&&(t[n]=e.call(this,n)),t[n]}}(function(e){return document.querySelector(e)}),v=null,m=0,g=[],_=n(184);e.exports=function(e,t){if(false)throw new Error("The style-loader cannot be used in a non-browser environment");t=t||{},t.attrs="object"==typeof t.attrs?t.attrs:{},t.singleton||(t.singleton=h()),t.insertInto||(t.insertInto="head"),t.insertAt||(t.insertAt="bottom");var n=a(e,t);return r(n,t),function(e){for(var o=[],i=0;i<n.length;i++){var s=n[i],u=b[s.id];u.refs--,o.push(u)}e&&r(a(e,t),t);for(var i=0;i<o.length;i++){var u=o[i];if(0===u.refs){for(var l=0;l<u.parts.length;l++)u.parts[l]();delete b[u.id]}}}};var j=function(){var e=[];return function(t,n){return e[t]=n,e.filter(Boolean).join("\n")}}()},function(e,t){e.exports=function(e){var t="undefined"!=typeof window&&window.location;if(!t)throw new Error("fixUrls requires window.location");if(!e||"string"!=typeof e)return e;var n=t.protocol+"//"+t.host,r=n+t.pathname.replace(/\/[^\/]*$/,"/");return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi,function(e,t){var a=t.trim().replace(/^"(.*)"$/,function(e,t){return t}).replace(/^'(.*)'$/,function(e,t){return t});if(/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(a))return e;var o;return o=0===a.indexOf("//")?a:0===a.indexOf("/")?n+a:r+a.replace(/^\.\//,""),"url("+JSON.stringify(o)+")"})}}])});

/***/ },
/* 494 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 495 */
/***/ function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ },
/* 496 */
/***/ function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 497 */
/***/ function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports =  false
	  ? require('./src/immutable')
	  : __webpack_require__(2799);


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFieldActions = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _batchActions = __webpack_require__(341);
	
	var _batchActions2 = _interopRequireDefault(_batchActions);
	
	var _getValidity = __webpack_require__(507);
	
	var _getValidity2 = _interopRequireDefault(_getValidity);
	
	var _isValidityValid = __webpack_require__(1268);
	
	var _isValidityValid2 = _interopRequireDefault(_isValidityValid);
	
	var _isValidityInvalid = __webpack_require__(509);
	
	var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);
	
	var _invertValidity = __webpack_require__(508);
	
	var _invertValidity2 = _interopRequireDefault(_invertValidity);
	
	var _track = __webpack_require__(255);
	
	var _getForm = __webpack_require__(251);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _getFieldFromState = __webpack_require__(250);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _nullAction = __webpack_require__(343);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var defaultStrategies = {
	  get: _get3.default,
	  getForm: _getForm2.default,
	  getFieldFromState: _getFieldFromState2.default
	};
	
	function createFieldActions() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategies;
	
	  var addIntent = function addIntent(model, intent) {
	    return {
	      type: _actionTypes2.default.ADD_INTENT,
	      model: model,
	      intent: intent
	    };
	  };
	
	  var clearIntents = function clearIntents(model, intents) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return {
	      type: _actionTypes2.default.CLEAR_INTENTS,
	      model: model,
	      intents: intents,
	      options: options
	    };
	  };
	
	  var focus = function focus(model, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return _extends({
	      type: _actionTypes2.default.FOCUS,
	      model: model,
	      value: value
	    }, options);
	  };
	
	  var silentFocus = function silentFocus(model, value) {
	    return focus(model, value, {
	      silent: true
	    });
	  };
	
	  var blur = function blur(model) {
	    return {
	      type: _actionTypes2.default.BLUR,
	      model: model
	    };
	  };
	
	  var setPristine = function setPristine(model) {
	    return {
	      type: _actionTypes2.default.SET_PRISTINE,
	      model: model
	    };
	  };
	
	  var setDirty = function setDirty(model) {
	    return {
	      type: _actionTypes2.default.SET_DIRTY,
	      model: model
	    };
	  };
	
	  var setInitial = function setInitial(model) {
	    return {
	      type: _actionTypes2.default.SET_INITIAL,
	      model: model
	    };
	  };
	
	  var setPending = function setPending(model) {
	    var pending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var options = arguments[2];
	    return _extends({
	      type: _actionTypes2.default.SET_PENDING,
	      model: model,
	      pending: pending
	    }, options);
	  };
	
	  var setValidating = function setValidating(model) {
	    var validating = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	      type: _actionTypes2.default.SET_VALIDATING,
	      model: model,
	      validating: validating
	    };
	  };
	
	  var setValidity = function setValidity(model, validity) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return _extends({
	      type: options.errors ? _actionTypes2.default.SET_ERRORS : _actionTypes2.default.SET_VALIDITY,
	      model: model
	    }, options, _defineProperty({}, options.errors ? 'errors' : 'validity', validity));
	  };
	
	  var resetValidity = function resetValidity(model) {
	    var omitKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    return {
	      type: _actionTypes2.default.RESET_VALIDITY,
	      model: model,
	      omitKeys: omitKeys
	    };
	  };
	
	  var setFieldsValidity = function setFieldsValidity(model, fieldsValidity) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return {
	      type: _actionTypes2.default.SET_FIELDS_VALIDITY,
	      model: model,
	      fieldsValidity: fieldsValidity,
	      options: options
	    };
	  };
	
	  var setErrors = function setErrors(model, errors) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return setValidity(model, errors, _extends({}, options, {
	      errors: true
	    }));
	  };
	
	  var setFieldsErrors = function setFieldsErrors(model, fieldsErrors, options) {
	    return setFieldsValidity(model, fieldsErrors, _extends({}, options, {
	      errors: true
	    }));
	  };
	
	  var resetErrors = resetValidity;
	
	  var setTouched = function setTouched(model) {
	    return {
	      type: _actionTypes2.default.SET_TOUCHED,
	      model: model
	    };
	  };
	
	  var setUntouched = function setUntouched(model) {
	    return {
	      type: _actionTypes2.default.SET_UNTOUCHED,
	      model: model
	    };
	  };
	
	  var asyncSetValidity = function asyncSetValidity(model, validator) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function (dispatch, getState) {
	      var value = s.get(getState(), model);
	
	      dispatch(setValidating(model, true));
	
	      var done = function done(validity) {
	        dispatch(setValidity(model, validity, _extends({
	          async: true
	        }, options)));
	      };
	
	      var immediateResult = validator(value, done);
	
	      if (typeof immediateResult !== 'undefined') {
	        done(immediateResult);
	      }
	    };
	  };
	
	  var asyncSetErrors = function asyncSetErrors(model, validator) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return asyncSetValidity(model, validator, _extends({
	      errors: true
	    }, options));
	  };
	
	  var setSubmitted = function setSubmitted(model) {
	    var submitted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    return {
	      type: _actionTypes2.default.SET_SUBMITTED,
	      model: model,
	      submitted: submitted
	    };
	  };
	
	  var setSubmitFailed = function setSubmitFailed(model) {
	    var submitFailed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	    var options = arguments[2];
	    return _extends({
	      type: _actionTypes2.default.SET_SUBMIT_FAILED,
	      model: model,
	      submitFailed: submitFailed
	    }, options);
	  };
	
	  var submit = function submit(model, promise) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (typeof promise === 'undefined') {
	      return addIntent(model, { type: 'submit' });
	    }
	
	    return function (dispatch, getState) {
	      if (options.validate) {
	        var form = s.getForm(getState(), model);
	
	        (0, _invariant2.default)(form, 'Unable to submit form with validation. ' + 'Could not find form for "%s" in the store.', model);
	
	        if (!form.$form.valid) {
	          return dispatch(_nullAction2.default);
	        }
	
	        dispatch(setPending(model, true));
	      } else if (options.validators || options.errors) {
	        var validators = options.validators || options.errors;
	        var isErrors = options.errors;
	        var value = s.get(getState(), model);
	        var validity = (0, _getValidity2.default)(validators, value);
	        var valid = options.errors ? !(0, _isValidityInvalid2.default)(validity) : (0, _isValidityValid2.default)(validity);
	
	        if (!valid) {
	          return dispatch(isErrors ? setErrors(model, validity) : setValidity(model, validity));
	        }
	
	        dispatch((0, _batchActions2.default)(model, [setValidity(model, isErrors ? (0, _invertValidity2.default)(validity) : validity), setPending(model, true)]));
	      } else {
	        dispatch(setPending(model, true));
	      }
	
	      var errorsAction = options.fields ? setFieldsErrors : setErrors;
	
	      promise.then(function (response) {
	        dispatch((0, _batchActions2.default)(model, [setSubmitted(model, true), setValidity(model, response)]));
	      }).catch(function (rejection) {
	        var error = rejection instanceof Error ? rejection.message : rejection;
	
	        dispatch((0, _batchActions2.default)(model, [setSubmitFailed(model), errorsAction(model, error, { async: true })]));
	      });
	
	      return promise;
	    };
	  };
	
	  var submitFields = function submitFields(model, promise) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return submit(model, promise, _extends({}, options, {
	      fields: true
	    }));
	  };
	
	  var validSubmit = function validSubmit(model, promise) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return submit(model, promise, _extends({}, options, {
	      validate: true
	    }));
	  };
	
	  var validate = function validate(model, validators) {
	    return function (dispatch, getState) {
	      var value = s.get(getState(), model);
	      var validity = (0, _getValidity2.default)(validators, value);
	
	      dispatch(setValidity(model, validity));
	    };
	  };
	
	  var validateErrors = function validateErrors(model, errorValidators) {
	    return function (dispatch, getState) {
	      var value = s.get(getState(), model);
	      var errors = (0, _getValidity2.default)(errorValidators, value);
	
	      dispatch(setValidity(model, errors, { errors: true }));
	    };
	  };
	
	  var validateFields = function validateFields(model, fieldValidators) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return function (dispatch, getState) {
	      var modelValue = s.get(getState(), model);
	
	      var fieldsValidity = (0, _mapValues2.default)(fieldValidators, function (validator, field) {
	        var fieldValue = field ? s.get(modelValue, field) : modelValue;
	
	        var fieldValidity = (0, _getValidity2.default)(validator, fieldValue);
	
	        return fieldValidity;
	      });
	
	      var fieldsValiditySetter = options.errors ? setFieldsErrors : setFieldsValidity;
	
	      dispatch(fieldsValiditySetter(model, fieldsValidity));
	    };
	  };
	
	  var validateFieldsErrors = function validateFieldsErrors(model, fieldErrorsValidators) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    return validateFields(model, fieldErrorsValidators, _extends({}, options, {
	      errors: true
	    }));
	  };
	
	  return (0, _mapValues2.default)({
	    blur: blur,
	    focus: focus,
	    silentFocus: silentFocus,
	    submit: submit,
	    submitFields: submitFields,
	    validSubmit: validSubmit,
	    setDirty: setDirty,
	    setErrors: setErrors,
	    setInitial: setInitial,
	    setPending: setPending,
	    setValidating: setValidating,
	    setPristine: setPristine,
	    setSubmitted: setSubmitted,
	    setSubmitFailed: setSubmitFailed,
	    setTouched: setTouched,
	    setUntouched: setUntouched,
	    setValidity: setValidity,
	    setFieldsValidity: setFieldsValidity,
	    setFieldsErrors: setFieldsErrors,
	    resetValidity: resetValidity,
	    resetErrors: resetErrors,
	    validate: validate,
	    validateErrors: validateErrors,
	    validateFields: validateFields,
	    validateFieldsErrors: validateFieldsErrors,
	    asyncSetValidity: asyncSetValidity,
	    asyncSetErrors: asyncSetErrors,
	    addIntent: addIntent,
	    clearIntents: clearIntents
	  }, _track.trackable);
	}
	
	exports.createFieldActions = createFieldActions;
	exports.default = createFieldActions();

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createControlClass = undefined;
	
	var _actions = __webpack_require__(198);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _getFieldFromState = __webpack_require__(250);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _controlComponentFactory = __webpack_require__(2789);
	
	var _controlComponentFactory2 = _interopRequireDefault(_controlComponentFactory);
	
	var _reactDom = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategy = {
	  get: _get3.default,
	  getFieldFromState: _getFieldFromState2.default,
	  actions: _actions2.default,
	  findDOMNode: _reactDom.findDOMNode
	};
	
	exports.createControlClass = _controlComponentFactory2.default;
	exports.default = (0, _controlComponentFactory2.default)(defaultStrategy);

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFormClass = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _shallowEqual = __webpack_require__(201);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _omit = __webpack_require__(200);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _actions = __webpack_require__(198);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _getValidity = __webpack_require__(507);
	
	var _getValidity2 = _interopRequireDefault(_getValidity);
	
	var _invertValidators = __webpack_require__(2810);
	
	var _invertValidators2 = _interopRequireDefault(_invertValidators);
	
	var _isValidityInvalid = __webpack_require__(509);
	
	var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);
	
	var _isValid = __webpack_require__(247);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _getForm = __webpack_require__(251);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _getModel = __webpack_require__(252);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _getField = __webpack_require__(2807);
	
	var _getField2 = _interopRequireDefault(_getField);
	
	var _deepCompareChildren = __webpack_require__(1266);
	
	var _deepCompareChildren2 = _interopRequireDefault(_deepCompareChildren);
	
	var _containsEvent = __webpack_require__(1265);
	
	var _containsEvent2 = _interopRequireDefault(_containsEvent);
	
	var _mergeValidity = __webpack_require__(1270);
	
	var _mergeValidity2 = _interopRequireDefault(_mergeValidity);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  validators: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  errors: _propTypes2.default.object,
	  validateOn: _propTypes2.default.oneOf(['change', 'submit']),
	  model: _propTypes2.default.string.isRequired,
	  modelValue: _propTypes2.default.any,
	  formValue: _propTypes2.default.object,
	  onSubmit: _propTypes2.default.func,
	  onSubmitFailed: _propTypes2.default.func,
	  dispatch: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  store: _propTypes2.default.shape({
	    subscribe: _propTypes2.default.func,
	    dispatch: _propTypes2.default.func,
	    getState: _propTypes2.default.func
	  }),
	  storeSubscription: _propTypes2.default.any,
	  onUpdate: _propTypes2.default.func,
	  onChange: _propTypes2.default.func,
	  getRef: _propTypes2.default.func,
	  getDispatch: _propTypes2.default.func,
	  onBeforeSubmit: _propTypes2.default.func,
	  hideNativeErrors: _propTypes2.default.bool,
	
	  // standard HTML attributes
	  action: _propTypes2.default.string,
	  noValidate: _propTypes2.default.bool
	};
	
	var htmlAttributes = ['action', 'noValidate'];
	var disallowedPropTypeKeys = Object.keys(propTypes).filter(function (key) {
	  return htmlAttributes.indexOf(key) === -1;
	});
	
	var defaultStrategy = {
	  get: _get3.default,
	  getForm: _getForm2.default,
	  actions: _actions2.default
	};
	
	function createFormClass() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  var Form = function (_Component) {
	    _inherits(Form, _Component);
	
	    function Form(props) {
	      _classCallCheck(this, Form);
	
	      var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	      _this.handleSubmit = _this.handleSubmit.bind(_this);
	      _this.handleReset = _this.handleReset.bind(_this);
	      _this.handleValidSubmit = _this.handleValidSubmit.bind(_this);
	      _this.handleInvalidSubmit = _this.handleInvalidSubmit.bind(_this);
	      _this.attachNode = _this.attachNode.bind(_this);
	
	      _this.state = {
	        lastSubmitEvent: null
	      };
	      return _this;
	    }
	
	    _createClass(Form, [{
	      key: 'getChildContext',
	      value: function getChildContext() {
	        return {
	          model: this.props.model,
	          localStore: this.props.store
	        };
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if ((0, _containsEvent2.default)(this.props.validateOn, 'change')) {
	          this.validate(this.props, true);
	        }
	
	        if (this.props.getDispatch) {
	          this.props.getDispatch(this.props.dispatch);
	        }
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if ((0, _containsEvent2.default)(nextProps.validateOn, 'change')) {
	          this.validate(nextProps);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _deepCompareChildren2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate(prevProps) {
	        this.handleIntents();
	
	        if (!(0, _shallowEqual2.default)(prevProps.formValue, this.props.formValue)) {
	          this.handleUpdate();
	        }
	
	        if (!(0, _shallowEqual2.default)(prevProps.modelValue, this.props.modelValue)) {
	          this.handleChange();
	        }
	      }
	    }, {
	      key: 'handleUpdate',
	      value: function handleUpdate() {
	        if (this.props.onUpdate) {
	          this.props.onUpdate(this.props.formValue);
	        }
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange() {
	        if (this.props.onChange) {
	          this.props.onChange(this.props.modelValue);
	        }
	      }
	    }, {
	      key: 'attachNode',
	      value: function attachNode(node) {
	        if (!node) return;
	
	        this._node = node;
	
	        this._node.submit = this.handleSubmit;
	        if (this.props.getRef) this.props.getRef(node);
	      }
	    }, {
	      key: 'validate',
	      value: function validate(nextProps) {
	        var _this2 = this;
	
	        var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var submit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var _props = this.props,
	            model = _props.model,
	            dispatch = _props.dispatch,
	            formValue = _props.formValue,
	            modelValue = _props.modelValue;
	        var validators = nextProps.validators,
	            errors = nextProps.errors;
	
	
	        if (!formValue) return;
	
	        if (!validators && !errors && modelValue !== nextProps.modelValue) {
	          return;
	        }
	
	        var validatorsChanged = validators !== this.props.validators || errors !== this.props.errors;
	        var fieldKeys = (validators ? Object.keys(validators) : []).concat(errors ? Object.keys(errors) : []);
	
	        var fieldsErrors = {};
	        var validityChanged = false;
	
	        var keysToValidate = [];
	
	        fieldKeys.forEach(function (key) {
	          if (!!~keysToValidate.indexOf(key)) return;
	
	          var valuesChanged = key === '' ? modelValue !== nextProps.modelValue : s.get(modelValue, key) !== s.get(nextProps.modelValue, key);
	
	          if (submit || initial || valuesChanged || validators && _this2.props.validators[key] !== validators[key] || errors && _this2.props.errors[key] !== errors[key] || !!~key.indexOf('[]')) {
	            keysToValidate.push(key);
	          }
	        });
	
	        var validateField = function validateField(field, errorValidator) {
	          if (!!~field.indexOf('[]')) {
	            var _field$split = field.split('[]'),
	                _field$split2 = _slicedToArray(_field$split, 2),
	                parentModel = _field$split2[0],
	                childModel = _field$split2[1];
	
	            var nextValue = parentModel ? s.get(nextProps.modelValue, parentModel) : nextProps.modelValue;
	
	            nextValue.forEach(function (subValue, index) {
	              validateField(parentModel + '[' + index + ']' + childModel, errorValidator);
	            });
	          } else {
	            var _nextValue = field ? s.get(nextProps.modelValue, field) : nextProps.modelValue;
	
	            var currentErrors = (0, _getField2.default)(formValue, field).errors;
	            var fieldErrors = (0, _getValidity2.default)(errorValidator, _nextValue);
	
	            if (!validityChanged && !(0, _shallowEqual2.default)(fieldErrors, currentErrors)) {
	              validityChanged = true;
	            }
	
	            fieldsErrors[field] = (0, _mergeValidity2.default)(fieldsErrors[field], fieldErrors);
	          }
	        };
	
	        keysToValidate.forEach(function (field) {
	          if (validators && validators[field]) {
	            validateField(field, (0, _invertValidators2.default)(validators[field]));
	          }
	          if (errors && errors[field]) {
	            validateField(field, errors[field]);
	          }
	        });
	
	        if (typeof validators === 'function') {
	          var nextValue = nextProps.modelValue;
	          var currentValue = modelValue;
	
	          if (!submit && !initial && !validatorsChanged && nextValue === currentValue) {
	            // If neither the validators nor the values have changed,
	            // the validity didn't change.
	            return;
	          }
	
	          var multiFieldErrors = (0, _getValidity2.default)(validators, nextValue);
	
	          if (multiFieldErrors) {
	            Object.keys(multiFieldErrors).forEach(function (key) {
	              // key will be the model value to apply errors to.
	              var fieldErrors = multiFieldErrors[key];
	              var currentErrors = (0, _getField2.default)(formValue, key).errors;
	
	              // Invert validators
	              Object.keys(fieldErrors).forEach(function (validationName) {
	                fieldErrors[validationName] = !fieldErrors[validationName];
	              });
	
	              if (!validityChanged && !(0, _shallowEqual2.default)(fieldErrors, currentErrors)) {
	                validityChanged = true;
	              }
	
	              fieldsErrors[key] = (0, _mergeValidity2.default)(fieldsErrors[key], fieldErrors);
	            });
	          }
	        }
	
	        // Compute form-level validity
	        if (!fieldsErrors.hasOwnProperty('') && !~fieldKeys.indexOf('')) {
	          fieldsErrors[''] = false;
	          validityChanged = validityChanged || (0, _isValidityInvalid2.default)(formValue.$form.errors);
	        }
	
	        if (validityChanged) {
	          dispatch(s.actions.setFieldsErrors(model, fieldsErrors, { merge: true }));
	        }
	
	        if (submit) {
	          dispatch(s.actions.addIntent(model, { type: 'submit' }));
	        }
	      }
	    }, {
	      key: 'handleValidSubmit',
	      value: function handleValidSubmit(options) {
	        var _props2 = this.props,
	            dispatch = _props2.dispatch,
	            model = _props2.model,
	            modelValue = _props2.modelValue,
	            onSubmit = _props2.onSubmit;
	
	
	        dispatch(s.actions.setPending(model, true, options));
	
	        if (onSubmit) onSubmit(modelValue, this.state.lastSubmitEvent);
	      }
	    }, {
	      key: 'handleInvalidSubmit',
	      value: function handleInvalidSubmit(options) {
	        var _props3 = this.props,
	            onSubmitFailed = _props3.onSubmitFailed,
	            formValue = _props3.formValue,
	            dispatch = _props3.dispatch;
	
	
	        if (onSubmitFailed) {
	          onSubmitFailed(formValue);
	        }
	
	        dispatch(s.actions.setSubmitFailed(this.props.model, true, options));
	      }
	    }, {
	      key: 'handleReset',
	      value: function handleReset(e) {
	        if (e) e.preventDefault();
	
	        this.props.dispatch(s.actions.reset(this.props.model));
	      }
	    }, {
	      key: 'handleIntents',
	      value: function handleIntents() {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            formValue = _props4.formValue,
	            noValidate = _props4.noValidate;
	
	
	        formValue.$form.intents.forEach(function (intent) {
	          switch (intent.type) {
	            case 'submit':
	              {
	                if (noValidate || (0, _isValid2.default)(formValue, { async: false })) {
	                  _this3.handleValidSubmit({ clearIntents: intent });
	                } else {
	                  _this3.handleInvalidSubmit({ clearIntents: intent });
	                }
	
	                return;
	              }
	
	            default:
	              return;
	          }
	        });
	      }
	    }, {
	      key: 'handleSubmit',
	      value: function handleSubmit(e) {
	        if (e && !this.props.action) e.preventDefault();
	        if (e && e.persist) e.persist();
	
	        var _props5 = this.props,
	            modelValue = _props5.modelValue,
	            formValue = _props5.formValue,
	            onSubmit = _props5.onSubmit,
	            validators = _props5.validators,
	            onBeforeSubmit = _props5.onBeforeSubmit;
	
	
	        if (onBeforeSubmit) onBeforeSubmit(e);
	
	        var formValid = formValue ? formValue.$form.valid : true;
	
	        if (!validators && onSubmit && formValid) {
	          onSubmit(modelValue, e);
	
	          return modelValue;
	        }
	
	        this.setState({ lastSubmitEvent: e });
	
	        this.validate(this.props, false, true);
	
	        return modelValue;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props6 = this.props,
	            component = _props6.component,
	            children = _props6.children,
	            formValue = _props6.formValue,
	            hideNativeErrors = _props6.hideNativeErrors,
	            noValidate = _props6.noValidate;
	
	
	        var allowedProps = (0, _omit2.default)(this.props, disallowedPropTypeKeys);
	        var renderableChildren = typeof children === 'function' ? children(formValue) : children;
	
	        return _react2.default.createElement(component, _extends({}, allowedProps, {
	          onSubmit: this.handleSubmit,
	          onReset: this.handleReset,
	          ref: this.attachNode,
	          noValidate: hideNativeErrors || noValidate
	        }), renderableChildren);
	      }
	    }]);
	
	    return Form;
	  }(_react.Component);
	
	   false ? Form.propTypes = propTypes : void 0;
	
	  Form.defaultProps = {
	    validateOn: 'change',
	    component: 'form'
	  };
	
	  Form.childContextTypes = {
	    model: _propTypes2.default.any,
	    localStore: _propTypes2.default.shape({
	      subscribe: _propTypes2.default.func,
	      dispatch: _propTypes2.default.func,
	      getState: _propTypes2.default.func
	    })
	  };
	
	  function mapStateToProps(state, _ref) {
	    var model = _ref.model;
	
	    var modelString = (0, _getModel2.default)(model, state);
	    var form = s.getForm(state, modelString);
	
	    (0, _invariant2.default)(form, 'Unable to create Form component. ' + 'Could not find form for "%s" in the store.', modelString);
	
	    return {
	      model: modelString,
	      modelValue: s.get(state, modelString),
	      formValue: form
	    };
	  }
	
	  return (0, _reactRedux.connect)(mapStateToProps)(Form);
	}
	
	exports.createFormClass = createFormClass;
	exports.default = createFormClass();

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createBatchReducer(reducer, initialState) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var transformAction = options.transformAction;
	
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments[1];
	
	    var transformedAction = transformAction ? transformAction(action) : action;
	
	    if (transformedAction.type === _actionTypes2.default.BATCH) {
	      return transformedAction.actions.reduce(reducer, state);
	    }
	
	    return reducer(state, transformedAction);
	  };
	}
	
	exports.default = createBatchReducer;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createModelReducerEnhancer = undefined;
	
	var _modelReducer2 = __webpack_require__(344);
	
	var _modelReducer3 = _interopRequireDefault(_modelReducer2);
	
	var _nullAction = __webpack_require__(343);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createModelReducerEnhancer() {
	  var modelReducerCreator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _modelReducer3.default;
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return function modelReducerEnhancer(reducer, model) {
	    var initialState = void 0;
	    try {
	      initialState = reducer(undefined, _nullAction2.default);
	    } catch (error) {
	      initialState = null;
	    }
	
	    var _modelReducer = modelReducerCreator(model, initialState, options);
	
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	      var action = arguments[1];
	
	      var updatedState = _modelReducer(state, action);
	
	      return reducer(updatedState, action);
	    };
	  };
	}
	
	var modelReducerEnhancer = createModelReducerEnhancer(_modelReducer3.default);
	
	exports.createModelReducerEnhancer = createModelReducerEnhancer;
	exports.default = modelReducerEnhancer;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createForms = exports.createFormCombiner = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _modeledEnhancer = __webpack_require__(504);
	
	var _modeledEnhancer2 = _interopRequireDefault(_modeledEnhancer);
	
	var _modelReducer = __webpack_require__(344);
	
	var _modelReducer2 = _interopRequireDefault(_modelReducer);
	
	var _formReducer = __webpack_require__(248);
	
	var _formReducer2 = _interopRequireDefault(_formReducer);
	
	var _redux = __webpack_require__(56);
	
	var _identity = __webpack_require__(199);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _nullAction = __webpack_require__(343);
	
	var _nullAction2 = _interopRequireDefault(_nullAction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var defaults = {
	  key: 'forms',
	  plugins: []
	};
	
	function getSubModelString(model, subModel) {
	  if (!model) return subModel;
	
	  return model + '.' + subModel;
	}
	
	var defaultStrategy = {
	  modelReducer: _modelReducer2.default,
	  formReducer: _formReducer2.default,
	  modeled: _modeledEnhancer2.default,
	  toJS: _identity2.default
	};
	
	function createFormCombiner() {
	  var strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  function createForms(forms) {
	    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var formKeys = Object.keys(forms);
	    var modelReducers = {};
	    var initialFormState = {};
	    var optionsWithDefaults = _extends({}, defaults, options);
	
	    var key = optionsWithDefaults.key,
	        plugins = optionsWithDefaults.plugins,
	        formOptions = _objectWithoutProperties(optionsWithDefaults, ['key', 'plugins']);
	
	    formKeys.forEach(function (formKey) {
	      var formValue = forms[formKey];
	      var subModel = getSubModelString(model, formKey);
	
	      if (typeof formValue === 'function') {
	        var initialState = void 0;
	        try {
	          initialState = formValue(undefined, _nullAction2.default);
	        } catch (error) {
	          initialState = null;
	        }
	
	        modelReducers[formKey] = strategy.modeled(formValue, subModel);
	        initialFormState[formKey] = initialState;
	      } else {
	        modelReducers[formKey] = strategy.modelReducer(subModel, formValue);
	        initialFormState[formKey] = strategy.toJS(formValue);
	      }
	    });
	
	    return _extends({}, modelReducers, _defineProperty({}, key, function (state, action) {
	      return strategy.formReducer(model, initialFormState, _extends({
	        plugins: plugins
	      }, formOptions))(state, action);
	    }));
	  }
	
	  function combineForms(forms) {
	    var model = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var mappedReducers = createForms(forms, model, options);
	
	    return (0, _redux.combineReducers)(mappedReducers);
	  }
	
	  return {
	    createForms: createForms,
	    combineForms: combineForms
	  };
	}
	
	var _createFormCombiner = createFormCombiner(),
	    defaultCombineForms = _createFormCombiner.combineForms,
	    defaultCreateForms = _createFormCombiner.createForms;
	
	exports.default = defaultCombineForms;
	exports.createFormCombiner = createFormCombiner;
	exports.createForms = defaultCreateForms;

/***/ },
/* 506 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = endsWith;
	function endsWith(string, subString) {
	  if (typeof string !== 'string') return false;
	
	  var lastIndex = string.lastIndexOf(subString);
	
	  return lastIndex !== -1 && lastIndex + subString.length === string.length;
	}

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getValidity;
	
	var _getValue = __webpack_require__(253);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getValidity(validators, value) {
	  var modelValue = (0, _getValue2.default)(value);
	
	  if (typeof validators === 'function') {
	    return validators(modelValue);
	  }
	
	  return (0, _mapValues2.default)(validators, function (validator) {
	    return getValidity(validator, modelValue);
	  });
	}

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invertValidity;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function invertValidity(validity) {
	  if ((0, _isPlainObject2.default)(validity)) {
	    return (0, _mapValues2.default)(validity, invertValidity);
	  }
	
	  return !validity;
	}

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidityInvalid;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidityInvalid(errors) {
	  if (Array.isArray(errors)) {
	    return errors.some(isValidityInvalid);
	  }
	
	  if ((0, _isPlainObject2.default)(errors)) {
	    return Object.keys(errors).some(function (key) {
	      return isValidityInvalid(errors[key]);
	    });
	  }
	
	  return !!errors;
	}

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.createIteratee = createIteratee;
	exports.iterateeValue = iterateeValue;
	
	var _identity = __webpack_require__(199);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategy = {
	  get: _get3.default
	};
	
	function createIteratee() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  function matcher(object) {
	    return function (compareObject) {
	      if (compareObject === object) return true;
	
	      return Object.keys(object).every(function (key) {
	        return s.get(object, key) === s.get(compareObject, key);
	      });
	    };
	  }
	
	  function propChecker(prop) {
	    return function (object) {
	      return object && !!s.get(object, prop);
	    };
	  }
	
	  return function (value) {
	    if (typeof value === 'function') {
	      return value;
	    }
	
	    if (value === null) {
	      return _identity2.default;
	    }
	
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      return matcher(value);
	    }
	
	    return propChecker(value);
	  };
	}
	
	var iteratee = createIteratee();
	
	function iterateeValue(data, value) {
	  if (typeof value === 'function') {
	    return value(data);
	  }
	
	  if (!Array.isArray(value) && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' && typeof value !== 'string') {
	    return !!value;
	  }
	
	  return iteratee(value)(data);
	}
	
	exports.default = iteratee;

/***/ },
/* 511 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(348);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(349);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.defaultFilterOptions = exports.defaultClearRenderer = exports.defaultArrowRenderer = exports.defaultMenuRenderer = exports.Option = exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;
	
	var _Select = __webpack_require__(350);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Async = __webpack_require__(1290);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _AsyncCreatable = __webpack_require__(2859);
	
	var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);
	
	var _Creatable = __webpack_require__(1291);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Value = __webpack_require__(1293);
	
	var _Value2 = _interopRequireDefault(_Value);
	
	var _Option = __webpack_require__(1292);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _defaultMenuRenderer = __webpack_require__(516);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _defaultArrowRenderer = __webpack_require__(1294);
	
	var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);
	
	var _defaultClearRenderer = __webpack_require__(1295);
	
	var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);
	
	var _defaultFilterOptions = __webpack_require__(515);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_Select2.default.Async = _Async2.default;
	_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
	_Select2.default.Creatable = _Creatable2.default;
	_Select2.default.Value = _Value2.default;
	_Select2.default.Option = _Option2.default;
	
	exports.default = _Select2.default;
	exports.Async = _Async2.default;
	exports.AsyncCreatable = _AsyncCreatable2.default;
	exports.Creatable = _Creatable2.default;
	exports.Value = _Value2.default;
	exports.Option = _Option2.default;
	exports.defaultMenuRenderer = _defaultMenuRenderer2.default;
	exports.defaultArrowRenderer = _defaultArrowRenderer2.default;
	exports.defaultClearRenderer = _defaultClearRenderer2.default;
	exports.defaultFilterOptions = _defaultFilterOptions2.default;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stripDiacritics = __webpack_require__(1296);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	var _trim = __webpack_require__(2861);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isValid = function isValid(value) {
		return typeof value !== 'undefined' && value !== null && value !== '';
	};
	
	var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
		if (props.ignoreAccents) {
			filterValue = (0, _stripDiacritics2.default)(filterValue);
		}
	
		if (props.ignoreCase) {
			filterValue = filterValue.toLowerCase();
		}
	
		if (props.trimFilter) {
			filterValue = (0, _trim2.default)(filterValue);
		}
	
		if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
			return i[props.valueKey];
		});
	
		return options.filter(function (option) {
			if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
			if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
			if (!filterValue) return true;
	
			var value = option[props.valueKey];
			var label = option[props.labelKey];
			var hasValue = isValid(value);
			var hasLabel = isValid(label);
	
			if (!hasValue && !hasLabel) {
				return false;
			}
	
			var valueTest = hasValue ? String(value) : null;
			var labelTest = hasLabel ? String(label) : null;
	
			if (props.ignoreAccents) {
				if (valueTest && props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
				if (labelTest && props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
			}
	
			if (props.ignoreCase) {
				if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
				if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
			}
	
			return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
		});
	};
	
	exports.default = filterOptions;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var menuRenderer = function menuRenderer(_ref) {
		var focusedOption = _ref.focusedOption,
		    focusOption = _ref.focusOption,
		    inputValue = _ref.inputValue,
		    instancePrefix = _ref.instancePrefix,
		    onFocus = _ref.onFocus,
		    onOptionRef = _ref.onOptionRef,
		    onSelect = _ref.onSelect,
		    optionClassName = _ref.optionClassName,
		    optionComponent = _ref.optionComponent,
		    optionRenderer = _ref.optionRenderer,
		    options = _ref.options,
		    removeValue = _ref.removeValue,
		    selectValue = _ref.selectValue,
		    valueArray = _ref.valueArray,
		    valueKey = _ref.valueKey;
	
		var Option = optionComponent;
	
		return options.map(function (option, i) {
			var isSelected = valueArray && valueArray.some(function (x) {
				return x[valueKey] === option[valueKey];
			});
			var isFocused = option === focusedOption;
			var optionClass = (0, _classnames2.default)(optionClassName, {
				'Select-option': true,
				'is-selected': isSelected,
				'is-focused': isFocused,
				'is-disabled': option.disabled
			});
	
			return _react2.default.createElement(
				Option,
				{
					className: optionClass,
					focusOption: focusOption,
					inputValue: inputValue,
					instancePrefix: instancePrefix,
					isDisabled: option.disabled,
					isFocused: isFocused,
					isSelected: isSelected,
					key: 'option-' + i + '-' + option[valueKey],
					onFocus: onFocus,
					onSelect: onSelect,
					option: option,
					optionIndex: i,
					ref: function ref(_ref2) {
						onOptionRef(_ref2, isFocused);
					},
					removeValue: removeValue,
					selectValue: selectValue
				},
				optionRenderer(option, i, inputValue)
			);
		});
	};
	
	menuRenderer.propTypes = {
		focusOption: _propTypes2.default.func,
		focusedOption: _propTypes2.default.object,
		inputValue: _propTypes2.default.string,
		instancePrefix: _propTypes2.default.string,
		onFocus: _propTypes2.default.func,
		onOptionRef: _propTypes2.default.func,
		onSelect: _propTypes2.default.func,
		optionClassName: _propTypes2.default.string,
		optionComponent: _propTypes2.default.func,
		optionRenderer: _propTypes2.default.func,
		options: _propTypes2.default.array,
		removeValue: _propTypes2.default.func,
		selectValue: _propTypes2.default.func,
		valueArray: _propTypes2.default.array,
		valueKey: _propTypes2.default.string
	};
	
	exports.default = menuRenderer;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _trackHelper = __webpack_require__(1298);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = {
	  initialize: function initialize(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    var currentSlide = props.rtl ? slideCount - 1 - props.initialSlide : props.initialSlide;
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      currentSlide: currentSlide,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	
	      this.autoPlay(); // once we're set up, trigger the initial autoplay.
	    });
	  },
	  update: function update(props) {
	    var slickList = _reactDom2.default.findDOMNode(this.list);
	    // This method has mostly same code as initialize method.
	    // Refactor it
	    var slideCount = _react2.default.Children.count(props.children);
	    var listWidth = this.getWidth(slickList);
	    var trackWidth = this.getWidth(_reactDom2.default.findDOMNode(this.track));
	    var slideWidth;
	
	    if (!props.vertical) {
	      var centerPaddingAdj = props.centerMode && parseInt(props.centerPadding) * 2;
	      slideWidth = (this.getWidth(_reactDom2.default.findDOMNode(this)) - centerPaddingAdj) / props.slidesToShow;
	    } else {
	      slideWidth = this.getWidth(_reactDom2.default.findDOMNode(this));
	    }
	
	    var slideHeight = this.getHeight(slickList.querySelector('[data-index="0"]'));
	    var listHeight = slideHeight * props.slidesToShow;
	
	    // pause slider if autoplay is set to false
	    if (!props.autoplay) {
	      this.pause();
	    } else {
	      this.autoPlay();
	    }
	
	    this.setState({
	      slideCount: slideCount,
	      slideWidth: slideWidth,
	      listWidth: listWidth,
	      trackWidth: trackWidth,
	      slideHeight: slideHeight,
	      listHeight: listHeight
	    }, function () {
	
	      var targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, props, this.state));
	      // getCSS function needs previously set state
	      var trackStyle = (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: targetLeft }, props, this.state));
	
	      this.setState({ trackStyle: trackStyle });
	    });
	  },
	  getWidth: function getWidth(elem) {
	    return elem && (elem.getBoundingClientRect().width || elem.offsetWidth) || 0;
	  },
	  getHeight: function getHeight(elem) {
	    return elem && (elem.getBoundingClientRect().height || elem.offsetHeight) || 0;
	  },
	
	  adaptHeight: function adaptHeight() {
	    if (this.props.adaptiveHeight) {
	      var selector = '[data-index="' + this.state.currentSlide + '"]';
	      if (this.list) {
	        var slickList = _reactDom2.default.findDOMNode(this.list);
	        slickList.style.height = slickList.querySelector(selector).offsetHeight + 'px';
	      }
	    }
	  },
	  canGoNext: function canGoNext(opts) {
	    var canGo = true;
	    if (!opts.infinite) {
	      if (opts.centerMode) {
	        // check if current slide is last slide
	        if (opts.currentSlide >= opts.slideCount - 1) {
	          canGo = false;
	        }
	      } else {
	        // check if all slides are shown in slider
	        if (opts.slideCount <= opts.slidesToShow || opts.currentSlide >= opts.slideCount - opts.slidesToShow) {
	          canGo = false;
	        }
	      }
	    }
	    return canGo;
	  },
	  slideHandler: function slideHandler(index) {
	    var _this = this;
	
	    // Functionality of animateSlide and postSlide is merged into this function
	    // console.log('slideHandler', index);
	    var targetSlide, currentSlide;
	    var targetLeft, currentLeft;
	    var callback;
	
	    if (this.props.waitForAnimate && this.state.animating) {
	      return;
	    }
	
	    if (this.props.fade) {
	      currentSlide = this.state.currentSlide;
	
	      // Don't change slide if it's not infite and current slide is the first or last slide.
	      if (this.props.infinite === false && (index < 0 || index >= this.state.slideCount)) {
	        return;
	      }
	
	      //  Shifting targetSlide back into the range
	      if (index < 0) {
	        targetSlide = index + this.state.slideCount;
	      } else if (index >= this.state.slideCount) {
	        targetSlide = index - this.state.slideCount;
	      } else {
	        targetSlide = index;
	      }
	
	      if (this.props.lazyLoad && this.state.lazyLoadedList.indexOf(targetSlide) < 0) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(targetSlide)
	        });
	      }
	
	      callback = function callback() {
	        _this.setState({
	          animating: false
	        });
	        if (_this.props.afterChange) {
	          _this.props.afterChange(targetSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: targetSlide
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	
	      if (this.props.beforeChange) {
	        this.props.beforeChange(this.state.currentSlide, targetSlide);
	      }
	
	      this.autoPlay();
	      return;
	    }
	
	    targetSlide = index;
	    if (targetSlide < 0) {
	      if (this.props.infinite === false) {
	        currentSlide = 0;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = this.state.slideCount - this.state.slideCount % this.props.slidesToScroll;
	      } else {
	        currentSlide = this.state.slideCount + targetSlide;
	      }
	    } else if (targetSlide >= this.state.slideCount) {
	      if (this.props.infinite === false) {
	        currentSlide = this.state.slideCount - this.props.slidesToShow;
	      } else if (this.state.slideCount % this.props.slidesToScroll !== 0) {
	        currentSlide = 0;
	      } else {
	        currentSlide = targetSlide - this.state.slideCount;
	      }
	    } else {
	      currentSlide = targetSlide;
	    }
	
	    targetLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: targetSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	
	    if (this.props.infinite === false) {
	      targetLeft = currentLeft;
	    }
	
	    if (this.props.beforeChange) {
	      this.props.beforeChange(this.state.currentSlide, currentSlide);
	    }
	
	    if (this.props.lazyLoad) {
	      var loaded = true;
	      var slidesToLoad = [];
	      for (var i = targetSlide; i < targetSlide + this.props.slidesToShow; i++) {
	        loaded = loaded && this.state.lazyLoadedList.indexOf(i) >= 0;
	        if (!loaded) {
	          slidesToLoad.push(i);
	        }
	      }
	      if (!loaded) {
	        this.setState({
	          lazyLoadedList: this.state.lazyLoadedList.concat(slidesToLoad)
	        });
	      }
	    }
	
	    // Slide Transition happens here.
	    // animated transition happens to target Slide and
	    // non - animated transition happens to current Slide
	    // If CSS transitions are false, directly go the current slide.
	
	    if (this.props.useCSS === false) {
	
	      this.setState({
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      }, function () {
	        if (this.props.afterChange) {
	          this.props.afterChange(currentSlide);
	        }
	      });
	    } else {
	
	      var nextStateChanges = {
	        animating: false,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state)),
	        swipeLeft: null
	      };
	
	      callback = function callback() {
	        _this.setState(nextStateChanges);
	        if (_this.props.afterChange) {
	          _this.props.afterChange(currentSlide);
	        }
	        delete _this.animationEndCallback;
	      };
	
	      this.setState({
	        animating: true,
	        currentSlide: currentSlide,
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: targetLeft }, this.props, this.state))
	      }, function () {
	        this.animationEndCallback = setTimeout(callback, this.props.speed);
	      });
	    }
	
	    this.autoPlay();
	  },
	  swipeDirection: function swipeDirection(touchObject) {
	    var xDist, yDist, r, swipeAngle;
	
	    xDist = touchObject.startX - touchObject.curX;
	    yDist = touchObject.startY - touchObject.curY;
	    r = Math.atan2(yDist, xDist);
	
	    swipeAngle = Math.round(r * 180 / Math.PI);
	    if (swipeAngle < 0) {
	      swipeAngle = 360 - Math.abs(swipeAngle);
	    }
	    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	      return this.props.rtl === false ? 'left' : 'right';
	    }
	    if (swipeAngle >= 135 && swipeAngle <= 225) {
	      return this.props.rtl === false ? 'right' : 'left';
	    }
	    if (this.props.verticalSwiping === true) {
	      if (swipeAngle >= 35 && swipeAngle <= 135) {
	        return 'down';
	      } else {
	        return 'up';
	      }
	    }
	
	    return 'vertical';
	  },
	  play: function play() {
	    var nextIndex;
	
	    if (!this.state.mounted) {
	      return false;
	    }
	
	    if (this.props.rtl) {
	      nextIndex = this.state.currentSlide - this.props.slidesToScroll;
	    } else {
	      if (this.canGoNext(_extends({}, this.props, this.state))) {
	        nextIndex = this.state.currentSlide + this.props.slidesToScroll;
	      } else {
	        return false;
	      }
	    }
	
	    this.slideHandler(nextIndex);
	  },
	  autoPlay: function autoPlay() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	    }
	    if (this.props.autoplay) {
	      this.setState({
	        autoPlayTimer: setTimeout(this.play, this.props.autoplaySpeed)
	      });
	    }
	  },
	  pause: function pause() {
	    if (this.state.autoPlayTimer) {
	      clearTimeout(this.state.autoPlayTimer);
	      this.setState({
	        autoPlayTimer: null
	      });
	    }
	  }
	};
	
	exports.default = helpers;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.providerContextTypes = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// TODO(jez) 'sync' and 'async' are bad tag names.
	// TODO(jez) What if redux also uses this.context.tag?
	var providerContextTypes = exports.providerContextTypes = {
	  tag: _propTypes2.default.string.isRequired,
	  stripe: _propTypes2.default.object,
	  addStripeLoadListener: _propTypes2.default.func
	};
	
	var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
	  /**
	   * Note that this is not meant to be a generic memoization solution.
	   * This is specifically a solution for `StripeProvider`s being initialized
	   * and destroyed regularly (with the same set of props) when users only
	   * use `StripeProvider` for the subtree that contains their checkout form.
	   */
	  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
	  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);
	
	  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
	  window.Stripe.__cachedInstances[cacheKey] = stripe;
	
	  return stripe;
	};
	
	var ensureStripeShape = function ensureStripeShape(stripe) {
	  if (stripe && stripe.elements && stripe.createSource && stripe.createToken) {
	    return stripe;
	  } else {
	    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
	  }
	};
	
	var Provider = function (_React$Component) {
	  _inherits(Provider, _React$Component);
	
	  // on the other hand: childContextTypes is *required* to use context.
	  function Provider(props) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    if (_this.props.apiKey && _this.props.stripe) {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
	    } else if (_this.props.apiKey) {
	      if (!window.Stripe) {
	        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
	      } else {
	        var _this$props = _this.props,
	            _apiKey = _this$props.apiKey,
	            _children = _this$props.children,
	            _stripe = _this$props.stripe,
	            options = _objectWithoutProperties(_this$props, ['apiKey', 'children', 'stripe']);
	
	        _this._meta = {
	          tag: 'sync',
	          stripe: getOrCreateStripe(_apiKey, options)
	        };
	      }
	    } else if (_this.props.stripe) {
	      // If we already have a stripe instance (in the constructor), we can behave synchronously.
	      _this._meta = {
	        tag: 'sync',
	        stripe: ensureStripeShape(_this.props.stripe)
	      };
	    } else if (_this.props.stripe === null) {
	      _this._meta = {
	        tag: 'async',
	        stripe: null
	      };
	    } else {
	      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
	    }
	
	    _this._didWarn = false;
	    _this._didWakeUpListeners = false;
	    _this._listeners = [];
	    return _this;
	  }
	  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.
	
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    // getChildContext is run after the constructor, so we WILL have access to
	    // the initial state.
	    //
	    // However, context doesn't update in respnse to state changes like you
	    // might expect: context is pulled by the child, not pushed by the parent.
	    if (this._meta.tag === 'sync') {
	      return {
	        tag: 'sync',
	        stripe: this._meta.stripe
	      };
	    } else {
	      return {
	        tag: 'async',
	        addStripeLoadListener: function addStripeLoadListener(fn) {
	          if (_this2._meta.stripe) {
	            fn(_this2._meta.stripe);
	          } else {
	            _this2._listeners.push(fn);
	          }
	        }
	      };
	    }
	  };
	
	  Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var apiKeyChanged = this.props.apiKey && nextProps.apiKey && this.props.apiKey !== nextProps.apiKey;
	
	    var stripeInstanceChanged = this.props.stripe && nextProps.stripe && this.props.stripe !== nextProps.stripe;
	    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
	      this._didWarn = true;
	      // eslint-disable-next-line no-console
	      console.error('StripeProvider does not support changing the apiKey parameter.');
	      return;
	    }
	
	    if (!this._didWakeUpListeners && nextProps.stripe) {
	      // Wake up the listeners if we've finally been given a StripeShape
	      this._didWakeUpListeners = true;
	      var _stripe2 = ensureStripeShape(nextProps.stripe);
	      this._meta.stripe = _stripe2;
	      this._listeners.forEach(function (fn) {
	        fn(_stripe2);
	      });
	    }
	  };
	
	  Provider.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react2.default.Component);
	
	Provider.propTypes = {
	  apiKey: _propTypes2.default.string,
	  // PropTypes.object is the only way we can accept a Stripe instance
	  // eslint-disable-next-line react/forbid-prop-types
	  stripe: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	Provider.childContextTypes = providerContextTypes;
	Provider.defaultProps = {
	  apiKey: undefined,
	  stripe: undefined,
	  children: null
	};
	exports.default = Provider;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Format = __webpack_require__(223);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _decorativeAxisTicks = __webpack_require__(2920);
	
	var _decorativeAxisTicks2 = _interopRequireDefault(_decorativeAxisTicks);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-manipulable-axis rv-xy-plot__axis';
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];
	
	var DecorativeAxis = function (_AbstractSeries) {
	  _inherits(DecorativeAxis, _AbstractSeries);
	
	  function DecorativeAxis() {
	    _classCallCheck(this, DecorativeAxis);
	
	    return _possibleConstructorReturn(this, (DecorativeAxis.__proto__ || Object.getPrototypeOf(DecorativeAxis)).apply(this, arguments));
	  }
	
	  _createClass(DecorativeAxis, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          axisStart = _props.axisStart,
	          axisEnd = _props.axisEnd,
	          axisDomain = _props.axisDomain,
	          numberOfTicks = _props.numberOfTicks,
	          tickValue = _props.tickValue,
	          tickSize = _props.tickSize,
	          style = _props.style;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(DecorativeAxis, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        _react2.default.createElement('line', _extends({}, _extends({
	          x1: x({ x: axisStart.x }),
	          x2: x({ x: axisEnd.x }),
	          y1: y({ y: axisStart.y }),
	          y2: y({ y: axisEnd.y })
	        }, style.line), { className: 'rv-xy-plot__axis__line' })),
	        _react2.default.createElement(
	          'g',
	          { className: 'rv-xy-manipulable-axis__ticks' },
	          (0, _decorativeAxisTicks2.default)({
	            axisDomain: axisDomain,
	            axisEnd: { x: x(axisEnd), y: y(axisEnd) },
	            axisStart: { x: x(axisStart), y: y(axisStart) },
	            numberOfTicks: numberOfTicks,
	            tickValue: tickValue,
	            tickSize: tickSize,
	            style: style
	          })
	        )
	      );
	    }
	  }]);
	
	  return DecorativeAxis;
	}(_abstractSeries2.default);
	
	var DEFAULT_FORMAT = (0, _d3Format.format)('.2r');
	
	DecorativeAxis.defaultProps = {
	  className: '',
	  numberOfTicks: 10,
	  tickValue: function tickValue(d) {
	    return DEFAULT_FORMAT(d);
	  },
	  tickSize: 5,
	  style: {
	    line: {
	      strokeWidth: 1
	    },
	    ticks: {
	      strokeWidth: 2
	    },
	    text: {}
	  }
	};
	DecorativeAxis.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  axisDomain: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	  axisEnd: _propTypes2.default.shape({
	    x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }).isRequired,
	  axisStart: _propTypes2.default.shape({
	    x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }).isRequired,
	  className: _propTypes2.default.string,
	  numberOfTicks: _propTypes2.default.number,
	  tickValue: _propTypes2.default.func,
	  tickSize: _propTypes2.default.number,
	  style: _propTypes2.default.shape({
	    line: _propTypes2.default.object,
	    ticks: _propTypes2.default.object,
	    text: _propTypes2.default.object
	  })
	});
	DecorativeAxis.displayName = 'DecorativeAxis';
	exports.default = DecorativeAxis;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VERTICAL = _axisUtils.DIRECTION.VERTICAL,
	    HORIZONTAL = _axisUtils.DIRECTION.HORIZONTAL;
	
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf([VERTICAL, HORIZONTAL]),
	  attr: _propTypes2.default.string.isRequired,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	
	  style: _propTypes2.default.object,
	
	  tickValues: _propTypes2.default.array,
	  tickTotal: _propTypes2.default.number,
	
	  animation: _animation.AnimationPropType,
	
	  // generally supplied by xyplot
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	
	var defaultProps = {
	  direction: VERTICAL
	};
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];
	
	var GridLines = function (_PureComponent) {
	  _inherits(GridLines, _PureComponent);
	
	  function GridLines() {
	    _classCallCheck(this, GridLines);
	
	    return _possibleConstructorReturn(this, (GridLines.__proto__ || Object.getPrototypeOf(GridLines)).apply(this, arguments));
	  }
	
	  _createClass(GridLines, [{
	    key: '_getDefaultProps',
	    value: function _getDefaultProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginLeft = _props.marginLeft,
	          direction = _props.direction;
	
	      return {
	        left: marginLeft,
	        top: marginTop,
	        width: innerWidth,
	        height: innerHeight,
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(direction === VERTICAL ? innerWidth : innerHeight)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animation = this.props.animation;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(GridLines, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultProps(), this.props);
	
	      var attr = props.attr,
	          direction = props.direction,
	          width = props.width,
	          height = props.height,
	          style = props.style,
	          tickTotal = props.tickTotal,
	          tickValues = props.tickValues,
	          top = props.top,
	          left = props.left;
	
	      var isVertical = direction === VERTICAL;
	      var tickXAttr = isVertical ? 'y' : 'x';
	      var tickYAttr = isVertical ? 'x' : 'y';
	      var length = isVertical ? height : width;
	
	      var scale = (0, _scalesUtils.getAttributeScale)(props, attr);
	      var values = (0, _axisUtils.getTickValues)(scale, tickTotal, tickValues);
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + left + ',' + top + ')',
	          className: 'rv-xy-plot__grid-lines' },
	        values.map(function (v, i) {
	          var _pathProps;
	
	          var pos = scale(v);
	          var pathProps = (_pathProps = {}, _defineProperty(_pathProps, tickYAttr + '1', pos), _defineProperty(_pathProps, tickYAttr + '2', pos), _defineProperty(_pathProps, tickXAttr + '1', 0), _defineProperty(_pathProps, tickXAttr + '2', length), _pathProps);
	          return _react2.default.createElement('line', _extends({}, pathProps, {
	            key: i,
	            className: 'rv-xy-plot__grid-lines__line',
	            style: style }));
	        })
	      );
	    }
	  }]);
	
	  return GridLines;
	}(_react.PureComponent);
	
	GridLines.displayName = 'GridLines';
	GridLines.defaultProps = defaultProps;
	GridLines.propTypes = propTypes;
	GridLines.requiresSVG = true;
	
	exports.default = GridLines;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _d3Shape = __webpack_require__(107);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _scalesUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--arc';
	var ATTRIBUTES = ['radius', 'angle'];
	
	var defaultProps = {
	  center: { x: 0, y: 0 },
	  arcClassName: '',
	  className: '',
	  style: {}
	};
	
	/**
	 * Prepare the internal representation of row for real use.
	 * This is necessary because d3 insists on starting at 12 oclock and moving
	 * clockwise, rather than starting at 3 oclock and moving counter clockwise
	 * as one might expect from polar
	 * @param {Object} row - coordinate object to be modifed
	 * @return {Object} angle corrected object
	 */
	function modifyRow(row) {
	  var radius = row.radius,
	      angle = row.angle,
	      angle0 = row.angle0;
	
	  var truedAngle = -1 * angle + Math.PI / 2;
	  var truedAngle0 = -1 * angle0 + Math.PI / 2;
	  return _extends({}, row, {
	    x: radius * Math.cos(truedAngle),
	    y: radius * Math.sin(truedAngle),
	    angle: truedAngle,
	    angle0: truedAngle0
	  });
	}
	
	var ArcSeries = function (_AbstractSeries) {
	  _inherits(ArcSeries, _AbstractSeries);
	
	  function ArcSeries(props) {
	    _classCallCheck(this, ArcSeries);
	
	    var _this = _possibleConstructorReturn(this, (ArcSeries.__proto__ || Object.getPrototypeOf(ArcSeries)).call(this, props));
	
	    var scaleProps = _this._getAllScaleProps(props);
	    _this.state = { scaleProps: scaleProps };
	    return _this;
	  }
	
	  _createClass(ArcSeries, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ scaleProps: this._getAllScaleProps(nextProps) });
	    }
	
	    /**
	     * Get the map of scales from the props.
	     * @param {Object} props Props.
	     * @param {Array} data Array of all data.
	     * @returns {Object} Map of scales.
	     * @private
	     */
	
	  }, {
	    key: '_getAllScaleProps',
	    value: function _getAllScaleProps(props) {
	      var defaultScaleProps = this._getDefaultScaleProps(props);
	      var userScaleProps = (0, _scalesUtils.extractScalePropsFromProps)(props, ATTRIBUTES);
	      var missingScaleProps = (0, _scalesUtils.getMissingScaleProps)(_extends({}, defaultScaleProps, userScaleProps), props.data, ATTRIBUTES);
	
	      return _extends({}, defaultScaleProps, userScaleProps, missingScaleProps);
	    }
	
	    /**
	     * Get the list of scale-related settings that should be applied by default.
	     * @param {Object} props Object of props.
	     * @returns {Object} Defaults.
	     * @private
	     */
	
	  }, {
	    key: '_getDefaultScaleProps',
	    value: function _getDefaultScaleProps(props) {
	      var innerWidth = props.innerWidth,
	          innerHeight = props.innerHeight;
	
	      var radius = Math.min(innerWidth / 2, innerHeight / 2);
	      return {
	        radiusRange: [0, radius],
	        _radiusValue: radius,
	        angleType: 'literal'
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          arcClassName = _props.arcClassName,
	          animation = _props.animation,
	          className = _props.className,
	          center = _props.center,
	          data = _props.data,
	          disableSeries = _props.disableSeries,
	          hideSeries = _props.hideSeries,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        var cloneData = data.map(function (d) {
	          return _extends({}, d);
	        });
	        return _react2.default.createElement(
	          'g',
	          { className: 'rv-xy-plot__series--arc__animation-wrapper' },
	          _react2.default.createElement(
	            _animation2.default,
	            _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS, data: cloneData }),
	            _react2.default.createElement(ArcSeries, _extends({}, this.props, { animation: null, disableSeries: true, data: cloneData }))
	          ),
	          _react2.default.createElement(ArcSeries, _extends({}, this.props, { animation: null, hideSeries: true, style: { stroke: 'red' } }))
	        );
	      }
	
	      var scaleProps = this.state.scaleProps;
	      var radiusDomain = scaleProps.radiusDomain;
	      // need to generate our own functors as abstract series doesnt have anythign for us
	
	      var radius = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'radius');
	      var radius0 = (0, _scalesUtils.getAttr0Functor)(scaleProps, 'radius');
	      var angle = (0, _scalesUtils.getAttributeFunctor)(scaleProps, 'angle');
	      var angle0 = (0, _scalesUtils.getAttr0Functor)(scaleProps, 'angle');
	      // but it does have good color support!
	      var fill = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var stroke = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacity = this._getAttributeFunctor('opacity');
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          onMouseOver: this._seriesMouseOverHandler,
	          onMouseOut: this._seriesMouseOutHandler,
	          onClick: this._seriesClickHandler,
	          onContextMenu: this._seriesRightClickHandler,
	          ref: 'container',
	          opacity: hideSeries ? 0 : 1,
	          pointerEvents: disableSeries ? 'none' : 'all',
	          transform: 'translate(' + (marginLeft + x(center)) + ',' + (marginTop + y(center)) + ')' },
	        data.map(function (row, i) {
	          var noRadius = radiusDomain[1] === radiusDomain[0];
	          var arcArg = {
	            innerRadius: noRadius ? 0 : radius0(row),
	            outerRadius: radius(row),
	            startAngle: angle0(row) || 0,
	            endAngle: angle(row)
	          };
	          var arcedData = (0, _d3Shape.arc)();
	          var rowStyle = row.style || {};
	          var rowClassName = row.className || '';
	          return _react2.default.createElement('path', {
	            style: _extends({
	              opacity: opacity && opacity(row),
	              stroke: stroke && stroke(row),
	              fill: fill && fill(row)
	            }, style, rowStyle),
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(modifyRow(row), e);
	            },
	            onContextMenu: function onContextMenu(e) {
	              return _this2._valueRightClickHandler(modifyRow(row), e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(modifyRow(row), e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(modifyRow(row), e);
	            },
	            key: i,
	            className: predefinedClassName + '-path ' + arcClassName + ' ' + rowClassName,
	            d: arcedData(arcArg)
	          });
	        })
	      );
	    }
	  }]);
	
	  return ArcSeries;
	}(_abstractSeries2.default);
	
	ArcSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, (0, _scalesUtils.getScalePropTypesByAttribute)('radius'), (0, _scalesUtils.getScalePropTypesByAttribute)('angle'), {
	  center: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }),
	  arcClassName: _propTypes2.default.string
	});
	ArcSeries.defaultProps = defaultProps;
	ArcSeries.displayName = 'ArcSeries';
	
	exports.default = ArcSeries;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(107);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _theme = __webpack_require__(48);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _reactUtils = __webpack_require__(203);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';
	
	var STROKE_STYLES = {
	  dashed: '6, 2',
	  solid: null
	};
	
	var LineSeries = function (_AbstractSeries) {
	  _inherits(LineSeries, _AbstractSeries);
	
	  function LineSeries() {
	    _classCallCheck(this, LineSeries);
	
	    return _possibleConstructorReturn(this, (LineSeries.__proto__ || Object.getPrototypeOf(LineSeries)).apply(this, arguments));
	  }
	
	  _createClass(LineSeries, [{
	    key: '_renderLine',
	    value: function _renderLine(data, x, y, curve, getNull) {
	      var line = d3Shape.line();
	      if (curve !== null) {
	        if (typeof curve === 'string' && d3Shape[curve]) {
	          line = line.curve(d3Shape[curve]);
	        } else if (typeof curve === 'function') {
	          line = line.curve(curve);
	        }
	      }
	      line = line.defined(getNull);
	      line = line.x(x).y(y);
	      return line(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data;
	
	
	      if (this.props.nullAccessor) {
	        (0, _reactUtils.warning)('nullAccessor has been renamed to getNull', true);
	      }
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(LineSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _props2 = this.props,
	          curve = _props2.curve,
	          marginLeft = _props2.marginLeft,
	          marginTop = _props2.marginTop,
	          strokeDasharray = _props2.strokeDasharray,
	          strokeStyle = _props2.strokeStyle,
	          strokeWidth = _props2.strokeWidth,
	          style = _props2.style;
	
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
	      var newOpacity = this._getAttributeValue('opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	      var getNull = this.props.nullAccessor || this.props.getNull;
	      var d = this._renderLine(data, x, y, curve, getNull);
	
	      return _react2.default.createElement('path', {
	        d: d,
	        className: predefinedClassName + ' ' + className,
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        onContextMenu: this._seriesRightClickHandler,
	        style: _extends({
	          opacity: opacity,
	          strokeDasharray: STROKE_STYLES[strokeStyle] || strokeDasharray,
	          strokeWidth: strokeWidth,
	          stroke: stroke
	        }, style)
	      });
	    }
	  }]);
	
	  return LineSeries;
	}(_abstractSeries2.default);
	
	LineSeries.displayName = 'LineSeries';
	LineSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeStyle: _propTypes2.default.oneOf(Object.keys(STROKE_STYLES)),
	  curve: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  getNull: _propTypes2.default.func
	});
	LineSeries.defaultProps = {
	  strokeStyle: 'solid',
	  style: {},
	  opacity: 1,
	  curve: null,
	  className: '',
	  getNull: function getNull() {
	    return true;
	  }
	};
	
	exports.default = LineSeries;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _reactUtils = __webpack_require__(203);
	
	var _theme = __webpack_require__(48);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--mark';
	var DEFAULT_STROKE_WIDTH = 1;
	
	var MarkSeries = function (_AbstractSeries) {
	  _inherits(MarkSeries, _AbstractSeries);
	
	  function MarkSeries() {
	    _classCallCheck(this, MarkSeries);
	
	    return _possibleConstructorReturn(this, (MarkSeries.__proto__ || Object.getPrototypeOf(MarkSeries)).apply(this, arguments));
	  }
	
	  _createClass(MarkSeries, [{
	    key: '_renderCircle',
	    value: function _renderCircle(d, i, strokeWidth, style, scalingFunctions) {
	      var _this2 = this;
	
	      var fill = scalingFunctions.fill,
	          opacity = scalingFunctions.opacity,
	          size = scalingFunctions.size,
	          stroke = scalingFunctions.stroke,
	          x = scalingFunctions.x,
	          y = scalingFunctions.y;
	
	
	      var attrs = {
	        r: size ? size(d) : _theme.DEFAULT_SIZE,
	        cx: x(d),
	        cy: y(d),
	        style: _extends({
	          opacity: opacity ? opacity(d) : _theme.DEFAULT_OPACITY,
	          stroke: stroke && stroke(d),
	          fill: fill && fill(d),
	          strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
	        }, style),
	        key: i,
	        onClick: function onClick(e) {
	          return _this2._valueClickHandler(d, e);
	        },
	        onContextMenu: function onContextMenu(e) {
	          return _this2._valueRightClickHandler(d, e);
	        },
	        onMouseOver: function onMouseOver(e) {
	          return _this2._valueMouseOverHandler(d, e);
	        },
	        onMouseOut: function onMouseOut(e) {
	          return _this2._valueMouseOutHandler(d, e);
	        }
	      };
	      return _react2.default.createElement('circle', attrs);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          strokeWidth = _props.strokeWidth,
	          style = _props.style;
	
	
	      if (this.props.nullAccessor) {
	        (0, _reactUtils.warning)('nullAccessor has been renamed to getNull', true);
	      }
	
	      var getNull = this.props.nullAccessor || this.props.getNull;
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(MarkSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var scalingFunctions = {
	        fill: this._getAttributeFunctor('fill') || this._getAttributeFunctor('color'),
	        opacity: this._getAttributeFunctor('opacity'),
	        size: this._getAttributeFunctor('size'),
	        stroke: this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color'),
	        x: this._getAttributeFunctor('x'),
	        y: this._getAttributeFunctor('y')
	      };
	
	      return _react2.default.createElement(
	        'g',
	        {
	          className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')'
	        },
	        data.map(function (d, i) {
	          return getNull(d) && _this3._renderCircle(d, i, strokeWidth, style, scalingFunctions);
	        })
	      );
	    }
	  }]);
	
	  return MarkSeries;
	}(_abstractSeries2.default);
	
	MarkSeries.displayName = 'MarkSeries';
	MarkSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  getNull: _propTypes2.default.func,
	  strokeWidth: _propTypes2.default.number
	});
	MarkSeries.defaultProps = {
	  getNull: function getNull() {
	    return true;
	  }
	};
	
	exports.default = MarkSeries;

/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--polygon';
	var DEFAULT_COLOR = '#12939A';
	
	var generatePath = function generatePath(data, xFunctor, yFunctor) {
	  return data.reduce(function (res, row, i) {
	    return res + ' ' + (i ? 'L' : 'M') + xFunctor(row) + ' ' + yFunctor(row);
	  }, '') + ' Z';
	};
	
	var PolygonSeries = function (_AbstractSeries) {
	  _inherits(PolygonSeries, _AbstractSeries);
	
	  function PolygonSeries() {
	    _classCallCheck(this, PolygonSeries);
	
	    return _possibleConstructorReturn(this, (PolygonSeries.__proto__ || Object.getPrototypeOf(PolygonSeries)).apply(this, arguments));
	  }
	
	  _createClass(PolygonSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          color = _props.color,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(PolygonSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	
	      return _react2.default.createElement('path', {
	        className: predefinedClassName + ' ' + className,
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        onContextMenu: this._seriesRightClickHandler,
	        fill: color || DEFAULT_COLOR,
	        style: style,
	        d: generatePath(data, xFunctor, yFunctor),
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        ref: 'container'
	      });
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes);
	    }
	  }]);
	
	  return PolygonSeries;
	}(_abstractSeries2.default);
	
	PolygonSeries.displayName = 'PolygonSeries';
	
	exports.default = PolygonSeries;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Color = __webpack_require__(122);
	
	var _theme = __webpack_require__(48);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	var RectSeriesCanvas = function (_AbstractSeries) {
	  _inherits(RectSeriesCanvas, _AbstractSeries);
	
	  function RectSeriesCanvas() {
	    _classCallCheck(this, RectSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (RectSeriesCanvas.__proto__ || Object.getPrototypeOf(RectSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(RectSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          linePosAttr = props.linePosAttr,
	          lineSizeAttr = props.lineSizeAttr,
	          marginLeft = props.marginLeft,
	          marginTop = props.marginTop,
	          valuePosAttr = props.valuePosAttr;
	
	      if (!data || data.length === 0) {
	        return;
	      }
	
	      var line = (0, _scalesUtils.getAttributeFunctor)(props, linePosAttr);
	      var line0 = (0, _scalesUtils.getAttr0Functor)(props, linePosAttr);
	      var value = (0, _scalesUtils.getAttributeFunctor)(props, valuePosAttr);
	      var value0 = (0, _scalesUtils.getAttr0Functor)(props, valuePosAttr);
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var stroke = (0, _scalesUtils.getAttributeFunctor)(props, 'stroke') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacity = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      data.forEach(function (row) {
	        var fillColor = (0, _d3Color.rgb)(fill(row));
	        var strokeColor = (0, _d3Color.rgb)(stroke(row));
	        var rowOpacity = opacity(row) || _theme.DEFAULT_OPACITY;
	
	        var linePos = line0(row);
	        var valuePos = Math.min(value0(row), value(row));
	        var x = valuePosAttr === 'x' ? valuePos : linePos;
	        var y = valuePosAttr === 'y' ? valuePos : linePos;
	
	        var lineSize = Math.abs(line(row) - line0(row));
	        var valueSize = Math.abs(-value0(row) + value(row));
	        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
	        var width = lineSizeAttr === 'width' ? lineSize : valueSize;
	
	        ctx.beginPath();
	        ctx.rect(x + marginLeft, y + marginTop, width, height);
	        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
	        ctx.fill();
	        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
	        ctx.stroke();
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return RectSeriesCanvas;
	}(_abstractSeries2.default);
	
	RectSeriesCanvas.displayName = 'RectSeriesCanvas';
	RectSeriesCanvas.defaultProps = {
	  linePosAttr: _propTypes2.default.string.isRequired,
	  valuePosAttr: _propTypes2.default.string.isRequired,
	  lineSizeAttr: _propTypes2.default.string.isRequired,
	  valueSizeAttr: _propTypes2.default.string.isRequired
	};
	
	RectSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = RectSeriesCanvas;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--rect';
	
	var RectSeries = function (_AbstractSeries) {
	  _inherits(RectSeries, _AbstractSeries);
	
	  function RectSeries() {
	    _classCallCheck(this, RectSeries);
	
	    return _possibleConstructorReturn(this, (RectSeries.__proto__ || Object.getPrototypeOf(RectSeries)).apply(this, arguments));
	  }
	
	  _createClass(RectSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          linePosAttr = _props.linePosAttr,
	          lineSizeAttr = _props.lineSizeAttr,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style,
	          valuePosAttr = _props.valuePosAttr,
	          valueSizeAttr = _props.valueSizeAttr;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(RectSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var lineFunctor = this._getAttributeFunctor(linePosAttr);
	      var line0Functor = this._getAttr0Functor(linePosAttr);
	      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
	      var value0Functor = this._getAttr0Functor(valuePosAttr);
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var _attrs;
	
	          var attrs = (_attrs = {
	            style: _extends({
	              opacity: opacityFunctor && opacityFunctor(d),
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d)
	            }, style)
	          }, _defineProperty(_attrs, linePosAttr, line0Functor(d)), _defineProperty(_attrs, lineSizeAttr, Math.abs(lineFunctor(d) - line0Functor(d))), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
	            return _this2._valueClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onContextMenu', function onContextMenu(e) {
	            return _this2._valueRightClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
	            return _this2._valueMouseOverHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
	            return _this2._valueMouseOutHandler(d, e);
	          }), _defineProperty(_attrs, 'key', i), _attrs);
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes, {
	        linePosAttr: _propTypes2.default.string,
	        valuePosAttr: _propTypes2.default.string,
	        lineSizeAttr: _propTypes2.default.string,
	        valueSizeAttr: _propTypes2.default.string
	      });
	    }
	  }]);
	
	  return RectSeries;
	}(_abstractSeries2.default);
	
	RectSeries.displayName = 'RectSeries';
	
	exports.default = RectSeries;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(321);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(222);
	util.inherits = __webpack_require__(98);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(3316)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(1325);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(375).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(1324);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(163);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(163);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = _isUint8Array(chunk) && !state.objectMode;
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101), __webpack_require__(562).setImmediate, (function() { return this; }())))

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(1322);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(527);
	exports.Duplex = __webpack_require__(163);
	exports.Transform = __webpack_require__(1323);
	exports.PassThrough = __webpack_require__(2967);


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isNaN2 = __webpack_require__(319);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _get2 = __webpack_require__(153);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Area
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Curve = __webpack_require__(206);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(165);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Area = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Area, _Component);
	
	  function Area() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Area);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Area.__proto__ || Object.getPrototypeOf(Area)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: true }, _this.id = (0, _DataUtils.uniqueId)('recharts-area-'), _this.cachePrevData = function (points, baseLine) {
	      _this.setState({
	        prevPoints: points,
	        prevBaseLine: baseLine
	      });
	    }, _this.handleAnimationEnd = function () {
	      var onAnimationEnd = _this.props.onAnimationEnd;
	
	
	      _this.setState({ isAnimationFinished: true });
	
	      if ((0, _isFunction3.default)(onAnimationEnd)) {
	        onAnimationEnd();
	      }
	    }, _this.handleAnimationStart = function () {
	      var onAnimationStart = _this.props.onAnimationStart;
	
	      _this.setState({ isAnimationFinished: false });
	
	      if ((0, _isFunction3.default)(onAnimationStart)) {
	        onAnimationStart();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Area, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points,
	          baseLine = _props.baseLine;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points, baseLine);
	      }
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots() {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          dot = _props2.dot,
	          points = _props2.points,
	          dataKey = _props2.dataKey;
	
	      var areaProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, areaProps, customDotProps, dotEvents, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          value: entry.value,
	          payload: entry.payload
	        });
	
	        return _this2.constructor.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-area-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderHorizontalRect',
	    value: function renderHorizontalRect(alpha) {
	      var _props3 = this.props,
	          baseLine = _props3.baseLine,
	          points = _props3.points,
	          strokeWidth = _props3.strokeWidth;
	
	      var startX = points[0].x;
	      var endX = points[points.length - 1].x;
	      var width = alpha * Math.abs(startX - endX);
	      var maxY = Math.max.apply(null, points.map(function (entry) {
	        return entry.y || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxY = Math.max(baseLine, maxY);
	      } else if (baseLine && (0, _isArray3.default)(baseLine) && baseLine.length) {
	        maxY = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.y || 0;
	        })), maxY);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxY)) {
	        return _react2.default.createElement('rect', {
	          x: startX < endX ? startX : startX - width,
	          y: 0,
	          width: width,
	          height: maxY + (strokeWidth || 1)
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderVerticalRect',
	    value: function renderVerticalRect(alpha) {
	      var _props4 = this.props,
	          baseLine = _props4.baseLine,
	          points = _props4.points,
	          strokeWidth = _props4.strokeWidth;
	
	      var startY = points[0].y;
	      var endY = points[points.length - 1].y;
	      var height = alpha * Math.abs(startY - endY);
	      var maxX = Math.max.apply(null, points.map(function (entry) {
	        return entry.x || 0;
	      }));
	
	      if ((0, _DataUtils.isNumber)(baseLine)) {
	        maxX = Math.max(baseLine, maxX);
	      } else if (baseLine && (0, _isArray3.default)(baseLine) && baseLine.length) {
	        maxX = Math.max(Math.max.apply(null, baseLine.map(function (entry) {
	          return entry.x || 0;
	        })), maxX);
	      }
	
	      if ((0, _DataUtils.isNumber)(maxX)) {
	        return _react2.default.createElement('rect', {
	          x: 0,
	          y: startY < endY ? startY : startY - height,
	          width: maxX + (strokeWidth || 1),
	          height: height
	        });
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderClipRect',
	    value: function renderClipRect(alpha) {
	      var layout = this.props.layout;
	
	
	      if (layout === 'vertical') {
	        return this.renderVerticalRect(alpha);
	      }
	
	      return this.renderHorizontalRect(alpha);
	    }
	  }, {
	    key: 'renderAreaStatically',
	    value: function renderAreaStatically(points, baseLine, needClip) {
	      var _props5 = this.props,
	          layout = _props5.layout,
	          type = _props5.type,
	          stroke = _props5.stroke,
	          connectNulls = _props5.connectNulls,
	          isRange = _props5.isRange;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { clipPath: needClip ? 'url(#clipPath-' + this.id + ')' : null },
	        _react2.default.createElement(_Curve2.default, _extends({}, this.props, {
	          points: points,
	          baseLine: baseLine,
	          stroke: 'none',
	          className: 'recharts-area-area'
	        })),
	        stroke !== 'none' && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: points
	        })),
	        stroke !== 'none' && isRange && _react2.default.createElement(_Curve2.default, _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          className: 'recharts-area-curve',
	          layout: layout,
	          type: type,
	          connectNulls: connectNulls,
	          fill: 'none',
	          points: baseLine
	        }))
	      );
	    }
	  }, {
	    key: 'renderAreaWithAnimation',
	    value: function renderAreaWithAnimation(needClip) {
	      var _this3 = this;
	
	      var _props6 = this.props,
	          points = _props6.points,
	          baseLine = _props6.baseLine,
	          isAnimationActive = _props6.isAnimationActive,
	          animationBegin = _props6.animationBegin,
	          animationDuration = _props6.animationDuration,
	          animationEasing = _props6.animationEasing,
	          animationId = _props6.animationId,
	          id = _props6.id;
	      var _state = this.state,
	          prevPoints = _state.prevPoints,
	          prevBaseLine = _state.prevBaseLine;
	
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'area-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          if (prevPoints) {
	            // update animtaion
	            var stepPoints = points.map(function (entry, index) {
	              if (prevPoints[index]) {
	                var prev = prevPoints[index];
	                var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	              }
	
	              return entry;
	            });
	            var stepBaseLine = void 0;
	
	            if ((0, _DataUtils.isNumber)(baseLine)) {
	              var interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, baseLine);
	              stepBaseLine = interpolator(t);
	            } else if ((0, _isNil3.default)(baseLine) || (0, _isNaN3.default)(baseLine)) {
	              var _interpolator = (0, _DataUtils.interpolateNumber)(prevBaseLine, 0);
	              stepBaseLine = _interpolator(t);
	            } else {
	              stepBaseLine = baseLine.map(function (entry, index) {
	                if (prevBaseLine[index]) {
	                  var prev = prevBaseLine[index];
	                  var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                  var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                  return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	                }
	
	                return entry;
	              });
	            }
	
	            return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip);
	          }
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _react2.default.createElement(
	              'defs',
	              null,
	              _react2.default.createElement(
	                'clipPath',
	                { id: 'animationClipPath-' + clipPathId },
	                _this3.renderClipRect(t)
	              )
	            ),
	            _react2.default.createElement(
	              _Layer2.default,
	              { clipPath: 'url(#animationClipPath-' + clipPathId + ')' },
	              _this3.renderAreaStatically(points, baseLine, needClip)
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderArea',
	    value: function renderArea(needClip) {
	      var _props7 = this.props,
	          points = _props7.points,
	          baseLine = _props7.baseLine,
	          isAnimationActive = _props7.isAnimationActive;
	      var _state2 = this.state,
	          prevPoints = _state2.prevPoints,
	          prevBaseLine = _state2.prevBaseLine,
	          totalLength = _state2.totalLength;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual3.default)(prevPoints, points) || !(0, _isEqual3.default)(prevBaseLine, baseLine))) {
	        return this.renderAreaWithAnimation(needClip);
	      }
	
	      return this.renderAreaStatically(points, baseLine, needClip);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props8 = this.props,
	          hide = _props8.hide,
	          dot = _props8.dot,
	          points = _props8.points,
	          className = _props8.className,
	          top = _props8.top,
	          left = _props8.left,
	          xAxis = _props8.xAxis,
	          yAxis = _props8.yAxis,
	          width = _props8.width,
	          height = _props8.height,
	          isAnimationActive = _props8.isAnimationActive,
	          id = _props8.id;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint ? this.renderArea(needClip) : null,
	        (dot || hasSinglePoint) && this.renderDots(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Area;
	}(_react.Component), _class2.displayName = 'Area', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  connectNulls: _propTypes2.default.bool,
	
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // dot configuration
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object, _propTypes2.default.bool]),
	  hide: _propTypes2.default.bool,
	  // have curve configuration
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  baseLine: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	  isRange: _propTypes2.default.bool,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array])
	  })),
	
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  stroke: '#3182bd',
	  fill: '#3182bd',
	  fillOpacity: 0.6,
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'line',
	  connectNulls: false,
	  // points of area
	  points: [],
	  dot: false,
	  activeDot: true,
	  hide: false,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getBaseValue = function (props, xAxis, yAxis) {
	  var layout = props.layout,
	      baseValue = props.baseValue;
	
	
	  if ((0, _DataUtils.isNumber)(baseValue)) {
	    return baseValue;
	  }
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var domain = numericAxis.scale.domain();
	
	  if (numericAxis.type === 'number') {
	    var max = Math.max(domain[0], domain[1]);
	    var min = Math.min(domain[0], domain[1]);
	
	    if (baseValue === 'dataMin') {
	      return min;
	    }
	    if (baseValue === 'dataMax') {
	      return max;
	    }
	
	    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
	  }
	
	  if (baseValue === 'dataMin') {
	    return domain[0];
	  }
	  if (baseValue === 'dataMax') {
	    return domain[1];
	  }
	
	  return domain[0];
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      bandSize = _ref3.bandSize,
	      dataKey = _ref3.dataKey,
	      stackedData = _ref3.stackedData,
	      dataStartIndex = _ref3.dataStartIndex,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	  var layout = props.layout;
	
	  var hasStack = stackedData && stackedData.length;
	  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
	  var isRange = false;
	
	  var points = displayedData.map(function (entry, index) {
	    var value = void 0;
	
	    if (hasStack) {
	      value = stackedData[dataStartIndex + index];
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      } else {
	        isRange = true;
	      }
	    }
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value[1]) ? null : yAxis.scale(value[1]),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value[1]) ? null : xAxis.scale(value[1]),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  var baseLine = void 0;
	  if (hasStack || isRange) {
	    baseLine = points.map(function (entry) {
	      if (layout === 'horizontal') {
	        return {
	          x: entry.x,
	          y: !(0, _isNil3.default)((0, _get3.default)(entry, 'value[0]')) ? yAxis.scale((0, _get3.default)(entry, 'value[0]')) : null
	        };
	      }
	      return {
	        x: !(0, _isNil3.default)((0, _get3.default)(entry, 'value[0]')) ? xAxis.scale((0, _get3.default)(entry, 'value[0]')) : null,
	        y: entry.y
	      };
	    });
	  } else if (layout === 'horizontal') {
	    baseLine = yAxis.scale(baseValue);
	  } else {
	    baseLine = xAxis.scale(baseValue);
	  }
	
	  return _extends({ points: points, baseLine: baseLine, layout: layout, isRange: isRange }, offset);
	}, _class2.renderDotItem = function (option, props) {
	  var dotItem = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    dotItem = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    dotItem = option(props);
	  } else {
	    dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-area-dot' }));
	  }
	
	  return dotItem;
	}, _temp2)) || _class;
	
	exports.default = Area;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Rectangle = __webpack_require__(207);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ErrorBar = __webpack_require__(257);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Cell = __webpack_require__(258);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Bar, _Component);
	
	  function Bar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Bar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bar.__proto__ || Object.getPrototypeOf(Bar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-bar-'), _this.cachePrevData = function (data) {
	      _this.setState({ prevData: data });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param {Object} props Props for the component
	   * @param {Object} item        An instance of Bar
	   * @param {Array} barPosition  The offset and size of each bar
	   * @param {Object} xAxis       The configuration of x-axis
	   * @param {Object} yAxis       The configuration of y-axis
	   * @param {Array} stackedData  The stacked data of a bar item
	   * @return{Array} Composed data
	   */
	
	
	  _createClass(Bar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          data = _props.data;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: 'renderRectangle',
	    value: function renderRectangle(option, props) {
	      var rectangle = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rectangle = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rectangle = option(props);
	      } else {
	        rectangle = _react2.default.createElement(_Rectangle2.default, props);
	      }
	
	      return rectangle;
	    }
	  }, {
	    key: 'renderRectanglesStatically',
	    value: function renderRectanglesStatically(data) {
	      var _this2 = this;
	
	      var shape = this.props.shape;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return data && data.map(function (entry, i) {
	        var props = _extends({}, baseProps, entry, { index: i });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-bar-rectangle'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	            key: 'rectangle-' + i
	          }),
	          _this2.renderRectangle(shape, props)
	        );
	      });
	    }
	  }, {
	    key: 'renderRectanglesWithAnimation',
	    value: function renderRectanglesWithAnimation() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          data = _props2.data,
	          layout = _props2.layout,
	          isAnimationActive = _props2.isAnimationActive,
	          animationBegin = _props2.animationBegin,
	          animationDuration = _props2.animationDuration,
	          animationEasing = _props2.animationEasing,
	          animationId = _props2.animationId;
	      var prevData = this.state.prevData;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'bar-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = data.map(function (entry, index) {
	            var prev = prevData && prevData[index];
	
	            if (prev) {
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	              var interpolatorWidth = (0, _DataUtils.interpolateNumber)(prev.width, entry.width);
	              var interpolatorHeight = (0, _DataUtils.interpolateNumber)(prev.height, entry.height);
	
	              return _extends({}, entry, {
	                x: interpolatorX(t),
	                y: interpolatorY(t),
	                width: interpolatorWidth(t),
	                height: interpolatorHeight(t)
	              });
	            }
	
	            if (layout === 'horizontal') {
	              var _interpolatorHeight = (0, _DataUtils.interpolateNumber)(0, entry.height);
	              var h = _interpolatorHeight(t);
	
	              return _extends({}, entry, {
	                y: entry.y + entry.height - h,
	                height: h
	              });
	            }
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.width);
	            var w = interpolator(t);
	
	            return _extends({}, entry, { width: w });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderRectanglesStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderRectangles',
	    value: function renderRectangles() {
	      var _props3 = this.props,
	          data = _props3.data,
	          isAnimationActive = _props3.isAnimationActive;
	      var prevData = this.state.prevData;
	
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual3.default)(prevData, data))) {
	        return this.renderRectanglesWithAnimation();
	      }
	
	      return this.renderRectanglesStatically(data);
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _this4 = this;
	
	      var data = this.props.data;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	
	      return data.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ['value', 'background']);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _extends({}, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: 'background-bar-' + i,
	          className: 'recharts-bar-background-rectangle'
	        });
	
	        return _this4.renderRectangle(background, props);
	      });
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          data = _props4.data,
	          xAxis = _props4.xAxis,
	          yAxis = _props4.yAxis,
	          layout = _props4.layout,
	          children = _props4.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react2.default.cloneElement(item, {
	          key: 'error-bar-' + i,
	          data: data,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          offset: offset,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          hide = _props5.hide,
	          data = _props5.data,
	          className = _props5.className,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          left = _props5.left,
	          top = _props5.top,
	          width = _props5.width,
	          height = _props5.height,
	          isAnimationActive = _props5.isAnimationActive,
	          background = _props5.background,
	          id = _props5.id;
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-bar', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        _react2.default.createElement(
	          _Layer2.default,
	          {
	            className: 'recharts-bar-rectangles',
	            clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
	          },
	          background ? this.renderBackground() : null,
	          this.renderRectangles()
	        ),
	        this.renderErrorBar(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, data)
	      );
	    }
	  }]);
	
	  return Bar;
	}(_react.Component), _class2.displayName = 'Bar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  layout: _propTypes2.default.oneOf(['vertical', 'horizontal']),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  stackId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  barSize: _propTypes2.default.number,
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	  hide: _propTypes2.default.bool,
	
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number,
	    radius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.array]),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array])
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  animationId: _propTypes2.default.number,
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  legendType: 'rect',
	  minPointSize: 0,
	  hide: false,
	  // data of bar
	  data: [],
	  layout: 'vertical',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'ease',
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      item = _ref3.item,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      stackedData = _ref3.stackedData,
	      dataStartIndex = _ref3.dataStartIndex,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	  if (!pos) {
	    return [];
	  }
	
	  var layout = props.layout;
	  var _item$props = item.props,
	      dataKey = _item$props.dataKey,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({ props: props, numericAxis: numericAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  var rects = displayedData.map(function (entry, index) {
	    var value = void 0,
	        x = void 0,
	        y = void 0,
	        width = void 0,
	        height = void 0,
	        background = void 0;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'horizontal') {
	      x = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: xAxis,
	        ticks: xAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      y = yAxis.scale(value[1]);
	      width = pos.size;
	      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
	      background = { x: x, y: yAxis.y, width: width, height: yAxis.height };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
	
	        y -= delta;
	        height += delta;
	      }
	    } else {
	      x = xAxis.scale(value[0]);
	      y = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: yAxis,
	        ticks: yAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
	      height = pos.size;
	      background = { x: xAxis.x, y: y, width: xAxis.width, height: height };
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
	        width += _delta;
	      }
	    }
	
	    return _extends({}, entry, {
	      x: x, y: y, width: width, height: height, value: stackedData ? value : value[1],
	      payload: entry,
	      background: background
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return _extends({ data: rects, layout: layout }, offset);
	}, _temp2)) || _class;
	
	exports.default = Bar;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Line
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Curve = __webpack_require__(206);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Dot = __webpack_require__(165);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _ErrorBar = __webpack_require__(257);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Line = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Line, _Component);
	
	  function Line() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Line.__proto__ || Object.getPrototypeOf(Line)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: true,
	      totalLength: 0
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-line-'), _this.cachePrevData = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.pathRef = function (node) {
	      _this.mainCurve = node;
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	      _this.props.onAnimationEnd();
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	      _this.props.onAnimationStart();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param {Object} props The props from the component
	   * @param  {Object} xAxis   The configuration of x-axis
	   * @param  {Object} yAxis   The configuration of y-axis
	   * @param  {String} dataKey The unique key of a group
	   * @return {Array}  Composed data
	   */
	
	
	  _createClass(Line, [{
	    key: 'componentDidMount',
	
	
	    /* eslint-disable  react/no-did-mount-set-state */
	    value: function componentDidMount() {
	      if (!this.props.isAnimationActive) {
	        return;
	      }
	
	      var totalLength = this.getTotalLength();
	      this.setState({ totalLength: totalLength });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: 'getTotalLength',
	    value: function getTotalLength() {
	      var curveDom = this.mainCurve;
	
	      try {
	        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
	      } catch (err) {
	        return 0;
	      }
	    }
	  }, {
	    key: 'getStrokeDasharray',
	    value: function getStrokeDasharray(length, totalLength, lines) {
	      var lineLength = lines.reduce(function (pre, next) {
	        return pre + next;
	      });
	
	      var count = parseInt(length / lineLength, 10);
	      var remainLength = length % lineLength;
	      var restLength = totalLength - length;
	
	      var remainLines = [];
	      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
	        if (sum + lines[i] > remainLength) {
	          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
	          break;
	        }
	      }
	
	      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
	
	      return [].concat(_toConsumableArray(this.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
	        return line + 'px';
	      }).join(', ');
	    }
	  }, {
	    key: 'repeat',
	    value: function repeat(lines, count) {
	      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
	      var result = [];
	
	      for (var i = 0; i < count; ++i) {
	        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
	      }
	
	      return result;
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props2 = this.props,
	          points = _props2.points,
	          xAxis = _props2.xAxis,
	          yAxis = _props2.yAxis,
	          layout = _props2.layout,
	          children = _props2.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatter(dataPoint, dataKey) {
	        return {
	          x: dataPoint.x,
	          y: dataPoint.y,
	          value: dataPoint.value,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: layout,
	          dataPointFormatter: dataPointFormatter
	        });
	      });
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        var className = (0, _classnames2.default)('recharts-line-dot', option ? option.className : '');
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: className }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots(needClip, clipPathId) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props3 = this.props,
	          dot = _props3.dot,
	          points = _props3.points,
	          dataKey = _props3.dataKey;
	
	      var lineProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	      var dotEvents = (0, _ReactUtils.filterEventAttributes)(dot);
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, lineProps, customDotProps, dotEvents, {
	          value: entry.value,
	          dataKey: dataKey,
	          cx: entry.x, cy: entry.y, index: i, payload: entry.payload
	        });
	
	        return _this2.renderDotItem(dot, dotProps);
	      });
	      var dotsProps = {
	        clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        _extends({ className: 'recharts-line-dots', key: 'dots' }, dotsProps),
	        dots
	      );
	    }
	  }, {
	    key: 'renderCurveStatically',
	    value: function renderCurveStatically(points, needClip, clipPathId, props) {
	      var _props4 = this.props,
	          type = _props4.type,
	          layout = _props4.layout,
	          connectNulls = _props4.connectNulls,
	          id = _props4.id;
	
	      var curveProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        fill: 'none',
	        className: 'recharts-line-curve',
	        clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null,
	        points: points
	      }, props, {
	        type: type, layout: layout, connectNulls: connectNulls
	      });
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, curveProps, { pathRef: this.pathRef }));
	    }
	  }, {
	    key: 'renderCurveWithAnimation',
	    value: function renderCurveWithAnimation(needClip, clipPathId) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          points = _props5.points,
	          strokeDasharray = _props5.strokeDasharray,
	          isAnimationActive = _props5.isAnimationActive,
	          animationBegin = _props5.animationBegin,
	          animationDuration = _props5.animationDuration,
	          animationEasing = _props5.animationEasing,
	          animationId = _props5.animationId,
	          width = _props5.width,
	          height = _props5.height,
	          other = _objectWithoutProperties(_props5, ['points', 'strokeDasharray', 'isAnimationActive', 'animationBegin', 'animationDuration', 'animationEasing', 'animationId', 'width', 'height']);
	
	      var _state = this.state,
	          prevPoints = _state.prevPoints,
	          totalLength = _state.totalLength;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'line-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          if (prevPoints) {
	            var stepData = points.map(function (entry, index) {
	              if (prevPoints[index]) {
	                var prev = prevPoints[index];
	                var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	                var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	                return _extends({}, entry, { x: _interpolatorX(t), y: _interpolatorY(t) });
	              }
	
	              // magic number of faking previous x and y location
	              var interpolatorX = (0, _DataUtils.interpolateNumber)(width * 2, entry.x);
	              var interpolatorY = (0, _DataUtils.interpolateNumber)(height / 2, entry.y);
	              return _extends({}, entry, { x: interpolatorX(t), y: interpolatorY(t) });
	            });
	            return _this3.renderCurveStatically(stepData, needClip, clipPathId);
	          }
	          var interpolator = (0, _DataUtils.interpolateNumber)(0, totalLength);
	          var curLength = interpolator(t);
	          var currentStrokeDasharray = void 0;
	
	          if (strokeDasharray) {
	            var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
	              return parseFloat(num);
	            });
	            currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
	          } else {
	            currentStrokeDasharray = curLength + 'px ' + (totalLength - curLength) + 'px';
	          }
	
	          return _this3.renderCurveStatically(points, needClip, clipPathId, {
	            strokeDasharray: currentStrokeDasharray
	          });
	        }
	      );
	    }
	  }, {
	    key: 'renderCurve',
	    value: function renderCurve(needClip, clipPathId) {
	      var _props6 = this.props,
	          points = _props6.points,
	          isAnimationActive = _props6.isAnimationActive;
	      var _state2 = this.state,
	          prevPoints = _state2.prevPoints,
	          totalLength = _state2.totalLength;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderCurveWithAnimation(needClip, clipPathId);
	      }
	
	      return this.renderCurveStatically(points, needClip, clipPathId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          hide = _props7.hide,
	          dot = _props7.dot,
	          points = _props7.points,
	          className = _props7.className,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          top = _props7.top,
	          left = _props7.left,
	          width = _props7.width,
	          height = _props7.height,
	          isAnimationActive = _props7.isAnimationActive,
	          id = _props7.id;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var hasSinglePoint = points.length === 1;
	      var layerClass = (0, _classnames2.default)('recharts-line', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        !hasSinglePoint && this.renderCurve(needClip, clipPathId),
	        this.renderErrorBar(),
	        (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Line;
	}(_react.Component), _class2.displayName = 'Line', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  unit: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxis: _propTypes2.default.object,
	  xAxis: _propTypes2.default.object,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  connectNulls: _propTypes2.default.bool,
	  hide: _propTypes2.default.bool,
	
	  // whether have dot in line
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationEnd: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
	  animationId: _propTypes2.default.number,
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  connectNulls: false,
	  activeDot: true,
	  dot: true,
	  legendType: 'line',
	  stroke: '#3182bd',
	  strokeWidth: 1,
	  fill: '#fff',
	  points: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  hide: false,
	
	  onAnimationStart: function onAnimationStart() {},
	  onAnimationEnd: function onAnimationEnd() {}
	}, _class2.getComposedData = function (_ref3) {
	  var props = _ref3.props,
	      xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      xAxisTicks = _ref3.xAxisTicks,
	      yAxisTicks = _ref3.yAxisTicks,
	      dataKey = _ref3.dataKey,
	      bandSize = _ref3.bandSize,
	      displayedData = _ref3.displayedData,
	      offset = _ref3.offset;
	  var layout = props.layout;
	
	
	  var points = displayedData.map(function (entry, index) {
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	
	    if (layout === 'horizontal') {
	      return {
	        x: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: xAxis, ticks: xAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	        y: (0, _isNil3.default)(value) ? null : yAxis.scale(value),
	        value: value,
	        payload: entry
	      };
	    }
	
	    return {
	      x: (0, _isNil3.default)(value) ? null : xAxis.scale(value),
	      y: (0, _ChartUtils.getCateCoordinateOfLine)({ axis: yAxis, ticks: yAxisTicks, bandSize: bandSize, entry: entry, index: index }),
	      value: value,
	      payload: entry
	    };
	  });
	
	  return _extends({ points: points, layout: layout }, offset);
	}, _temp2)) || _class;
	
	exports.default = Line;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of scatters
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _ZAxis = __webpack_require__(356);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _Curve = __webpack_require__(206);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Symbols = __webpack_require__(535);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ErrorBar = __webpack_require__(257);
	
	var _ErrorBar2 = _interopRequireDefault(_ErrorBar);
	
	var _Cell = __webpack_require__(258);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scatter = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Scatter, _Component);
	
	  function Scatter() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Scatter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scatter.__proto__ || Object.getPrototypeOf(Scatter)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevPoints = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _this.id = (0, _DataUtils.uniqueId)('recharts-scatter-'), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Compose the data of each group
	   * @param  {Object} xAxis   The configuration of x-axis
	   * @param  {Object} yAxis   The configuration of y-axis
	   * @param  {String} dataKey The unique key of a group
	   * @return {Array}  Composed data
	   */
	
	
	  _createClass(Scatter, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevPoints(points);
	      }
	    }
	  }, {
	    key: 'renderSymbolItem',
	    value: function renderSymbolItem(option, props) {
	      var symbol = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        symbol = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        symbol = option(props);
	      } else {
	        symbol = _react2.default.createElement(_Symbols2.default, _extends({}, props, { type: option }));
	      }
	
	      return symbol;
	    }
	  }, {
	    key: 'renderSymbolsStatically',
	    value: function renderSymbolsStatically(points) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          shape = _props2.shape,
	          activeShape = _props2.activeShape,
	          activeIndex = _props2.activeIndex;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	
	      return points.map(function (entry, i) {
	        var props = _extends({ key: 'symbol-' + i }, baseProps, entry);
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-scatter-symbol'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	            key: 'symbol-' + i
	          }),
	          _this2.renderSymbolItem(activeIndex === i ? activeShape : shape, props)
	        );
	      });
	    }
	  }, {
	    key: 'renderSymbolsWithAnimation',
	    value: function renderSymbolsWithAnimation() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          points = _props3.points,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationId = _props3.animationId;
	      var prevPoints = this.state.prevPoints;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'pie-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = points.map(function (entry, index) {
	            var prev = prevPoints && prevPoints[index];
	
	            if (prev) {
	              var interpolatorCx = (0, _DataUtils.interpolateNumber)(prev.cx, entry.cx);
	              var interpolatorCy = (0, _DataUtils.interpolateNumber)(prev.cy, entry.cy);
	              var interpolatorSize = (0, _DataUtils.interpolateNumber)(prev.size, entry.size);
	
	              return _extends({}, entry, {
	                cx: interpolatorCx(t),
	                cy: interpolatorCy(t),
	                size: interpolatorSize(t)
	              });
	            }
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(0, entry.size);
	
	            return _extends({}, entry, { size: interpolator(t) });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderSymbolsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSymbols',
	    value: function renderSymbols() {
	      var _props4 = this.props,
	          points = _props4.points,
	          isAnimationActive = _props4.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderSymbolsWithAnimation();
	      }
	
	      return this.renderSymbolsStatically(points);
	    }
	  }, {
	    key: 'renderErrorBar',
	    value: function renderErrorBar() {
	      var isAnimationActive = this.props.isAnimationActive;
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	
	      var _props5 = this.props,
	          points = _props5.points,
	          xAxis = _props5.xAxis,
	          yAxis = _props5.yAxis,
	          children = _props5.children;
	
	      var errorBarItems = (0, _ReactUtils.findAllByType)(children, _ErrorBar2.default);
	
	      if (!errorBarItems) {
	        return null;
	      }
	
	      function dataPointFormatterY(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.y,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      function dataPointFormatterX(dataPoint, dataKey) {
	        return {
	          x: dataPoint.cx,
	          y: dataPoint.cy,
	          value: dataPoint.x,
	          errorVal: (0, _ChartUtils.getValueByDataKey)(dataPoint, dataKey)
	        };
	      }
	
	      return errorBarItems.map(function (item, i) {
	        var direction = item.props.direction;
	
	
	        return _react2.default.cloneElement(item, {
	          key: i,
	          data: points,
	          xAxis: xAxis,
	          yAxis: yAxis,
	          layout: direction === 'x' ? 'vertical' : 'horizontal',
	          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
	        });
	      });
	    }
	  }, {
	    key: 'renderLine',
	    value: function renderLine() {
	      var _props6 = this.props,
	          points = _props6.points,
	          line = _props6.line,
	          lineType = _props6.lineType,
	          lineJointType = _props6.lineJointType;
	
	      var scatterProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLineProps = (0, _ReactUtils.getPresentationAttributes)(line);
	      var linePoints = void 0,
	          lineItem = void 0;
	
	      if (lineType === 'joint') {
	        linePoints = points.map(function (entry) {
	          return { x: entry.cx, y: entry.cy };
	        });
	      } else if (lineType === 'fitting') {
	        var _getLinearRegression = (0, _DataUtils.getLinearRegression)(points),
	            xmin = _getLinearRegression.xmin,
	            xmax = _getLinearRegression.xmax,
	            a = _getLinearRegression.a,
	            b = _getLinearRegression.b;
	
	        var linearExp = function linearExp(x) {
	          return a * x + b;
	        };
	        linePoints = [{ x: xmin, y: linearExp(xmin) }, { x: xmax, y: linearExp(xmax) }];
	      }
	      var lineProps = _extends({}, scatterProps, {
	        fill: 'none',
	        stroke: scatterProps && scatterProps.fill
	      }, customLineProps, {
	        points: linePoints
	      });
	
	      if (_react2.default.isValidElement(line)) {
	        lineItem = _react2.default.cloneElement(line, lineProps);
	      } else if ((0, _isFunction3.default)(line)) {
	        lineItem = line(lineProps);
	      } else {
	        lineItem = _react2.default.createElement(_Curve2.default, _extends({}, lineProps, { type: lineJointType }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-scatter-line', key: 'recharts-scatter-line' },
	        lineItem
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          hide = _props7.hide,
	          points = _props7.points,
	          line = _props7.line,
	          className = _props7.className,
	          xAxis = _props7.xAxis,
	          yAxis = _props7.yAxis,
	          left = _props7.left,
	          top = _props7.top,
	          width = _props7.width,
	          height = _props7.height,
	          id = _props7.id;
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	      var _state = this.state,
	          isAnimationActive = _state.isAnimationActive,
	          isAnimationFinished = _state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-scatter', className);
	      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
	      var clipPathId = (0, _isNil3.default)(id) ? this.id : id;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          clipPath: needClip ? 'url(#clipPath-' + clipPathId + ')' : null
	        },
	        needClip ? _react2.default.createElement(
	          'defs',
	          null,
	          _react2.default.createElement(
	            'clipPath',
	            { id: 'clipPath-' + clipPathId },
	            _react2.default.createElement('rect', { x: left, y: top, width: width, height: height })
	          )
	        ) : null,
	        line && this.renderLine(),
	        this.renderErrorBar(),
	        _react2.default.createElement(
	          _Layer2.default,
	          { key: 'recharts-scatter-symbols' },
	          this.renderSymbols()
	        ),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Scatter;
	}(_react.Component), _class2.displayName = 'Scatter', _class2.propTypes = _extends({}, _ReactUtils.EVENT_ATTRIBUTES, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  zAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  line: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  lineType: _propTypes2.default.oneOf(['fitting', 'joint']),
	  lineJointType: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), _propTypes2.default.func]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  activeIndex: _propTypes2.default.number,
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), _propTypes2.default.element, _propTypes2.default.func]),
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    size: _propTypes2.default.number,
	    node: _propTypes2.default.shape({
	      x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	      y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	      z: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	    }),
	    payload: _propTypes2.default.any
	  })),
	  hide: _propTypes2.default.bool,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  xAxisId: 0,
	  yAxisId: 0,
	  zAxisId: 0,
	  legendType: 'circle',
	  lineType: 'joint',
	  lineJointType: 'linear',
	  data: [],
	  shape: 'circle',
	  hide: false,
	
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 400,
	  animationEasing: 'linear'
	}, _class2.getComposedData = function (_ref3) {
	  var xAxis = _ref3.xAxis,
	      yAxis = _ref3.yAxis,
	      zAxis = _ref3.zAxis,
	      item = _ref3.item,
	      displayedData = _ref3.displayedData,
	      onItemMouseLeave = _ref3.onItemMouseLeave,
	      onItemMouseEnter = _ref3.onItemMouseEnter,
	      offset = _ref3.offset,
	      xAxisTicks = _ref3.xAxisTicks;
	
	  var cells = (0, _ReactUtils.findAllByType)(item.props.children, _Cell2.default);
	  var xAxisDataKey = (0, _isNil3.default)(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
	  var yAxisDataKey = (0, _isNil3.default)(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
	  var zAxisDataKey = zAxis && zAxis.dataKey;
	  var defaultRangeZ = zAxis ? zAxis.range : _ZAxis2.default.defaultProps.range;
	  var defaultZ = defaultRangeZ && defaultRangeZ[0];
	  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
	  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
	  var points = displayedData.map(function (entry, index) {
	    var x = entry[xAxisDataKey];
	    var y = entry[yAxisDataKey];
	    var z = !(0, _isNil3.default)(zAxisDataKey) && entry[zAxisDataKey] || '-';
	    var tooltipPayload = [{ name: xAxis.name || xAxis.dataKey, unit: xAxis.unit || '', value: x, payload: entry }, { name: yAxis.name || yAxis.dataKey, unit: yAxis.unit || '', value: y, payload: entry }];
	
	    if (z !== '-') {
	      tooltipPayload.push({
	        name: zAxis.name || zAxis.dataKey, unit: zAxis.unit || '', value: z, payload: entry
	      });
	    }
	    var cx = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: xAxis, ticks: xAxisTicks, bandSize: xBandSize, entry: entry, index: index
	    });
	    var cy = (0, _ChartUtils.getCateCoordinateOfLine)({
	      axis: yAxis, ticks: xAxisTicks, bandSize: yBandSize, entry: entry, index: index
	    });
	    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
	    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
	
	    return _extends({}, entry, { cx: cx, cy: cy,
	      x: cx - radius,
	      y: cy - radius,
	      xAxis: xAxis, yAxis: yAxis, zAxis: zAxis,
	      width: 2 * radius,
	      height: 2 * radius,
	      size: size,
	      node: { x: x, y: y, z: z },
	      tooltipPayload: tooltipPayload,
	      tooltipPosition: { x: cx, y: cy },
	      payload: entry
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return _extends({
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter,
	    points: points
	  }, offset);
	}, _temp2)) || _class;
	
	exports.default = Scatter;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Legend
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DefaultLegendContent = __webpack_require__(2986);
	
	var _DefaultLegendContent2 = _interopRequireDefault(_DefaultLegendContent);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderContent = function renderContent(content, props) {
	  if (_react2.default.isValidElement(content)) {
	    return _react2.default.cloneElement(content, props);
	  } else if ((0, _isFunction3.default)(content)) {
	    return content(props);
	  }
	
	  return _react2.default.createElement(_DefaultLegendContent2.default, props);
	};
	
	var EPS = 1;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var Legend = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Legend, _Component);
	
	  function Legend() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Legend);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Legend.__proto__ || Object.getPrototypeOf(Legend)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      boxWidth: -1,
	      boxHeight: -1
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Legend, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateBBox();
	    }
	  }, {
	    key: 'getBBox',
	    value: function getBBox() {
	      var _state = this.state,
	          boxWidth = _state.boxWidth,
	          boxHeight = _state.boxHeight;
	
	
	      if (boxWidth >= 0 && boxHeight >= 0) {
	        return { width: boxWidth, height: boxHeight };
	      }
	
	      return null;
	    }
	  }, {
	    key: 'getDefaultPosition',
	    value: function getDefaultPosition(style) {
	      var _props = this.props,
	          layout = _props.layout,
	          align = _props.align,
	          verticalAlign = _props.verticalAlign,
	          margin = _props.margin,
	          chartWidth = _props.chartWidth,
	          chartHeight = _props.chartHeight;
	
	      var hPos = void 0,
	          vPos = void 0;
	
	      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
	        if (align === 'center' && layout === 'vertical') {
	          var box = this.getBBox() || { width: 0 };
	          hPos = { left: ((chartWidth || 0) - box.width) / 2 };
	        } else {
	          hPos = align === 'right' ? { right: margin && margin.right || 0 } : { left: margin && margin.left || 0 };
	        }
	      }
	
	      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
	        if (verticalAlign === 'middle') {
	          var _box = this.getBBox() || { height: 0 };
	          vPos = { top: ((chartHeight || 0) - _box.height) / 2 };
	        } else {
	          vPos = verticalAlign === 'bottom' ? { bottom: margin && margin.bottom || 0 } : { top: margin && margin.top || 0 };
	        }
	      }
	
	      return _extends({}, hPos, vPos);
	    }
	  }, {
	    key: 'updateBBox',
	    value: function updateBBox() {
	      var _state2 = this.state,
	          boxWidth = _state2.boxWidth,
	          boxHeight = _state2.boxHeight;
	      var onBBoxUpdate = this.props.onBBoxUpdate;
	
	
	      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
	        var box = this.wrapperNode.getBoundingClientRect();
	
	        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
	          this.setState({
	            boxWidth: box.width,
	            boxHeight: box.height
	          }, function () {
	            if (onBBoxUpdate) {
	              onBBoxUpdate(box);
	            }
	          });
	        }
	      } else if (boxWidth !== -1 || boxHeight !== -1) {
	        this.setState({
	          boxWidth: -1,
	          boxHeight: -1
	        }, function () {
	          if (onBBoxUpdate) {
	            onBBoxUpdate(null);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          content = _props2.content,
	          width = _props2.width,
	          height = _props2.height,
	          wrapperStyle = _props2.wrapperStyle;
	
	      var outerStyle = _extends({
	        position: 'absolute',
	        width: width || 'auto',
	        height: height || 'auto'
	      }, this.getDefaultPosition(wrapperStyle), wrapperStyle);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'recharts-legend-wrapper',
	          style: outerStyle,
	          ref: function ref(node) {
	            _this2.wrapperNode = node;
	          }
	        },
	        renderContent(content, this.props)
	      );
	    }
	  }], [{
	    key: 'getWithHeight',
	    value: function getWithHeight(item, chartWidth) {
	      var layout = item.props.layout;
	
	
	      if (layout === 'vertical' && (0, _DataUtils.isNumber)(item.props.height)) {
	        return {
	          height: item.props.height
	        };
	      } else if (layout === 'horizontal') {
	        return {
	          width: item.props.width || chartWidth
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Legend;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  wrapperStyle: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    left: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    right: _propTypes2.default.number
	  }),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onBBoxUpdate: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'bottom'
	}, _temp2)) || _class;
	
	exports.default = Legend;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polygon
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPolygonPoints = function getPolygonPoints(points) {
	  return points.reduce(function (result, entry) {
	    if (entry.x === +entry.x && entry.y === +entry.y) {
	      result.push([entry.x, entry.y]);
	    }
	
	    return result;
	  }, []).join(' ');
	};
	
	var Polygon = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Polygon, _Component);
	
	  function Polygon() {
	    _classCallCheck(this, Polygon);
	
	    return _possibleConstructorReturn(this, (Polygon.__proto__ || Object.getPrototypeOf(Polygon)).apply(this, arguments));
	  }
	
	  _createClass(Polygon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          points = _props.points,
	          className = _props.className;
	
	
	      if (!points || !points.length) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-polygon', className);
	
	      return _react2.default.createElement('polygon', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        className: layerClass,
	        points: getPolygonPoints(points)
	      }));
	    }
	  }]);
	
	  return Polygon;
	}(_react.Component), _class2.displayName = 'Polygon', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number
	  }))
	}), _temp)) || _class;
	
	exports.default = Polygon;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Curve
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(107);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SYMBOL_FACTORIES = {
	  symbolCircle: _d3Shape.symbolCircle, symbolCross: _d3Shape.symbolCross, symbolDiamond: _d3Shape.symbolDiamond,
	  symbolSquare: _d3Shape.symbolSquare, symbolStar: _d3Shape.symbolStar, symbolTriangle: _d3Shape.symbolTriangle, symbolWye: _d3Shape.symbolWye
	};
	var RADIAN = Math.PI / 180;
	
	var getSymbolFactory = function getSymbolFactory(type) {
	  var name = 'symbol' + type.slice(0, 1).toUpperCase() + type.slice(1);
	
	  return SYMBOL_FACTORIES[name] || _d3Shape.symbolCircle;
	};
	
	var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
	  if (sizeType === 'area') {
	    return size;
	  }
	
	  switch (type) {
	    case 'cross':
	      return 5 * size * size / 9;
	    case 'diamond':
	      return 0.5 * size * size / Math.sqrt(3);
	    case 'square':
	      return size * size;
	    case 'star':
	      {
	        var angle = 18 * RADIAN;
	
	        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
	      }
	    case 'triangle':
	      return Math.sqrt(3) * size * size / 4;
	    case 'wye':
	      return (21 - 10 * Math.sqrt(3)) * size * size / 8;
	    default:
	      return Math.PI * size * size / 4;
	  }
	};
	
	var Symbols = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Symbols, _Component);
	
	  function Symbols() {
	    _classCallCheck(this, Symbols);
	
	    return _possibleConstructorReturn(this, (Symbols.__proto__ || Object.getPrototypeOf(Symbols)).apply(this, arguments));
	  }
	
	  _createClass(Symbols, [{
	    key: 'getPath',
	
	
	    /**
	     * Calculate the path of curve
	     * @return {String} path
	     */
	    value: function getPath() {
	      var _props = this.props,
	          size = _props.size,
	          sizeType = _props.sizeType,
	          type = _props.type;
	
	      var symbolFactory = getSymbolFactory(type);
	      var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
	
	      return symbol();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          className = _props2.className,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          size = _props2.size;
	
	
	      if (cx === +cx && cy === +cy && size === +size) {
	        return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	          className: (0, _classnames2.default)('recharts-symbols', className),
	          transform: 'translate(' + cx + ', ' + cy + ')',
	          d: this.getPath()
	        }));
	      }
	
	      return null;
	    }
	  }]);
	
	  return Symbols;
	}(_react.Component), _class2.displayName = 'Symbols', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  size: _propTypes2.default.number,
	  sizeType: _propTypes2.default.oneOf(['area', 'diameter'])
	}), _class2.defaultProps = {
	  type: 'circle',
	  size: 64,
	  sizeType: 'area'
	}, _temp)) || _class;
	
	exports.default = Symbols;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateChartCoordinate = exports.getOffset = exports.getStringSize = exports.getStyleString = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ReactUtils = __webpack_require__(20);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var stringCache = {
	  widthCache: {},
	  cacheCount: 0
	};
	var MAX_CACHE_NUM = 2000;
	var SPAN_STYLE = {
	  position: 'absolute',
	  top: '-20000px',
	  left: 0,
	  padding: 0,
	  margin: 0,
	  border: 'none',
	  whiteSpace: 'pre'
	};
	var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
	var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
	
	function autoCompleteStyle(name, value) {
	  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
	    return value + 'px';
	  }
	
	  return value;
	}
	
	function camelToMiddleLine(text) {
	  var strs = text.split('');
	
	  var formatStrs = strs.reduce(function (result, entry) {
	    if (entry === entry.toUpperCase()) {
	      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
	    }
	
	    return [].concat(_toConsumableArray(result), [entry]);
	  }, []);
	
	  return formatStrs.join('');
	}
	
	var getStyleString = exports.getStyleString = function getStyleString(style) {
	  return Object.keys(style).reduce(function (result, s) {
	    return '' + result + camelToMiddleLine(s) + ':' + autoCompleteStyle(s, style[s]) + ';';
	  }, '');
	};
	
	var getStringSize = exports.getStringSize = function getStringSize(text) {
	  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (text === undefined || text === null || (0, _ReactUtils.isSsr)()) {
	    return { width: 0, height: 0 };
	  }
	
	  var str = '' + text;
	  var styleString = getStyleString(style);
	  var cacheKey = str + '-' + styleString;
	
	  if (stringCache.widthCache[cacheKey]) {
	    return stringCache.widthCache[cacheKey];
	  }
	
	  try {
	    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
	    if (!measurementSpan) {
	      measurementSpan = document.createElement('span');
	      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
	      document.body.appendChild(measurementSpan);
	    }
	    // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
	    // https://en.wikipedia.org/wiki/Content_Security_Policy
	    var measurementSpanStyle = _extends({}, SPAN_STYLE, style);
	    Object.keys(measurementSpanStyle).map(function (styleKey) {
	      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
	      return styleKey;
	    });
	
	    measurementSpan.textContent = str;
	
	    var rect = measurementSpan.getBoundingClientRect();
	    var result = { width: rect.width, height: rect.height };
	
	    stringCache.widthCache[cacheKey] = result;
	
	    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
	      stringCache.cacheCount = 0;
	      stringCache.widthCache = {};
	    }
	
	    return result;
	  } catch (e) {
	    return { width: 0, height: 0 };
	  }
	};
	
	var getOffset = exports.getOffset = function getOffset(el) {
	  var html = el.ownerDocument.documentElement;
	  var box = { top: 0, left: 0 };
	
	  // If we don't have gBCR, just use 0,0 rather than error
	  // BlackBerry 5, iOS 3 (original iPhone)
	  if (typeof el.getBoundingClientRect !== 'undefined') {
	    box = el.getBoundingClientRect();
	  }
	
	  return {
	    top: box.top + window.pageYOffset - html.clientTop,
	    left: box.left + window.pageXOffset - html.clientLeft
	  };
	};
	
	/**
	 * Calculate coordinate of cursor in chart
	 * @param  {Object} event  Event object
	 * @param  {Object} offset The offset of main part in the svg element
	 * @return {Object}        {chartX, chartY}
	 */
	var calculateChartCoordinate = exports.calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
	  return {
	    chartX: Math.round(event.pageX - offset.left),
	    chartY: Math.round(event.pageY - offset.top)
	  };
	};

/***/ },
/* 537 */
62,
/* 538 */
[3345, 361],
/* 539 */
119,
/* 540 */
217,
/* 541 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 542 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 543 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownKeys;
	function ownKeys(object) {
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ },
/* 544 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var prefix = exports.prefix = '@@redux-form/';
	
	var ARRAY_INSERT = exports.ARRAY_INSERT = prefix + 'ARRAY_INSERT';
	var ARRAY_MOVE = exports.ARRAY_MOVE = prefix + 'ARRAY_MOVE';
	var ARRAY_POP = exports.ARRAY_POP = prefix + 'ARRAY_POP';
	var ARRAY_PUSH = exports.ARRAY_PUSH = prefix + 'ARRAY_PUSH';
	var ARRAY_REMOVE = exports.ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
	var ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
	var ARRAY_SHIFT = exports.ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
	var ARRAY_SPLICE = exports.ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
	var ARRAY_UNSHIFT = exports.ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
	var ARRAY_SWAP = exports.ARRAY_SWAP = prefix + 'ARRAY_SWAP';
	var AUTOFILL = exports.AUTOFILL = prefix + 'AUTOFILL';
	var BLUR = exports.BLUR = prefix + 'BLUR';
	var CHANGE = exports.CHANGE = prefix + 'CHANGE';
	var CLEAR_FIELDS = exports.CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
	var CLEAR_SUBMIT = exports.CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
	var CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
	var CLEAR_ASYNC_ERROR = exports.CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
	var DESTROY = exports.DESTROY = prefix + 'DESTROY';
	var FOCUS = exports.FOCUS = prefix + 'FOCUS';
	var INITIALIZE = exports.INITIALIZE = prefix + 'INITIALIZE';
	var REGISTER_FIELD = exports.REGISTER_FIELD = prefix + 'REGISTER_FIELD';
	var RESET = exports.RESET = prefix + 'RESET';
	var RESET_SECTION = exports.RESET_SECTION = prefix + 'RESET_SECTION';
	var SET_SUBMIT_FAILED = exports.SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
	var SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
	var START_ASYNC_VALIDATION = exports.START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
	var START_SUBMIT = exports.START_SUBMIT = prefix + 'START_SUBMIT';
	var STOP_ASYNC_VALIDATION = exports.STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
	var STOP_SUBMIT = exports.STOP_SUBMIT = prefix + 'STOP_SUBMIT';
	var SUBMIT = exports.SUBMIT = prefix + 'SUBMIT';
	var TOUCH = exports.TOUCH = prefix + 'TOUCH';
	var UNREGISTER_FIELD = exports.UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
	var UNTOUCH = exports.UNTOUCH = prefix + 'UNTOUCH';
	var UPDATE_SYNC_ERRORS = exports.UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
	var UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasError = __webpack_require__(3054);
	
	var _hasError2 = _interopRequireDefault(_hasError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsValid = function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	
	  var hasError = (0, _hasError2.default)(structure);
	  return function (form, getFormState) {
	    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + '.syncError');
	      if (syncError) {
	        return false;
	      }
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + '.error');
	        if (error) {
	          return false;
	        }
	      }
	      var syncErrors = getIn(formState, form + '.syncErrors');
	      var asyncErrors = getIn(formState, form + '.asyncErrors');
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + '.registeredFields');
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	};
	exports.default = createIsValid;

/***/ },
/* 546 */
[3453, 166, 104],
/* 547 */
[3454, 3170, 3171, 3172, 3173, 3174],
/* 548 */
[3458, 362, 3187, 3188, 3189, 3190, 3191],
/* 549 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 550 */
[3505, 92, 372],
/* 551 */
110,
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(366);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ },
/* 553 */
[3534, 208, 140],
/* 554 */
461,
/* 555 */
[3538, 1362, 1367, 264],
/* 556 */
[3539, 365, 3119, 3127],
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	Object.defineProperty(exports, 'take', {
	  enumerable: true,
	  get: function get() {
	    return _io.take;
	  }
	});
	Object.defineProperty(exports, 'takem', {
	  enumerable: true,
	  get: function get() {
	    return _io.takem;
	  }
	});
	Object.defineProperty(exports, 'put', {
	  enumerable: true,
	  get: function get() {
	    return _io.put;
	  }
	});
	Object.defineProperty(exports, 'all', {
	  enumerable: true,
	  get: function get() {
	    return _io.all;
	  }
	});
	Object.defineProperty(exports, 'race', {
	  enumerable: true,
	  get: function get() {
	    return _io.race;
	  }
	});
	Object.defineProperty(exports, 'call', {
	  enumerable: true,
	  get: function get() {
	    return _io.call;
	  }
	});
	Object.defineProperty(exports, 'apply', {
	  enumerable: true,
	  get: function get() {
	    return _io.apply;
	  }
	});
	Object.defineProperty(exports, 'cps', {
	  enumerable: true,
	  get: function get() {
	    return _io.cps;
	  }
	});
	Object.defineProperty(exports, 'fork', {
	  enumerable: true,
	  get: function get() {
	    return _io.fork;
	  }
	});
	Object.defineProperty(exports, 'spawn', {
	  enumerable: true,
	  get: function get() {
	    return _io.spawn;
	  }
	});
	Object.defineProperty(exports, 'join', {
	  enumerable: true,
	  get: function get() {
	    return _io.join;
	  }
	});
	Object.defineProperty(exports, 'cancel', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancel;
	  }
	});
	Object.defineProperty(exports, 'select', {
	  enumerable: true,
	  get: function get() {
	    return _io.select;
	  }
	});
	Object.defineProperty(exports, 'actionChannel', {
	  enumerable: true,
	  get: function get() {
	    return _io.actionChannel;
	  }
	});
	Object.defineProperty(exports, 'cancelled', {
	  enumerable: true,
	  get: function get() {
	    return _io.cancelled;
	  }
	});
	Object.defineProperty(exports, 'flush', {
	  enumerable: true,
	  get: function get() {
	    return _io.flush;
	  }
	});
	Object.defineProperty(exports, 'getContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.getContext;
	  }
	});
	Object.defineProperty(exports, 'setContext', {
	  enumerable: true,
	  get: function get() {
	    return _io.setContext;
	  }
	});
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _io.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _io.throttle;
	  }
	});

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.qEnd = undefined;
	exports.safeName = safeName;
	exports.default = fsmIterator;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var done = { done: true, value: undefined };
	var qEnd = exports.qEnd = {};
	
	function safeName(patternOrChannel) {
	  if (_utils.is.channel(patternOrChannel)) {
	    return 'channel';
	  } else if (Array.isArray(patternOrChannel)) {
	    return String(patternOrChannel.map(function (entry) {
	      return String(entry);
	    }));
	  } else {
	    return String(patternOrChannel);
	  }
	}
	
	function fsmIterator(fsm, q0) {
	  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'iterator';
	
	  var updateState = void 0,
	      qNext = q0;
	
	  function next(arg, error) {
	    if (qNext === qEnd) {
	      return done;
	    }
	
	    if (error) {
	      qNext = qEnd;
	      throw error;
	    } else {
	      updateState && updateState(arg);
	
	      var _fsm$qNext = fsm[qNext](),
	          q = _fsm$qNext[0],
	          output = _fsm$qNext[1],
	          _updateState = _fsm$qNext[2];
	
	      qNext = q;
	      updateState = _updateState;
	      return qNext === qEnd ? done : output;
	    }
	  }
	
	  return (0, _utils.makeIterator)(next, function (error) {
	    return next(null, error);
	  }, name, true);
	}

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(101)))

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isStyledComponent;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	function isStyledComponent(target) /* : %checks */{
	  return typeof target === 'function' && typeof target.styledComponentId === 'string';
	}
	module.exports = exports['default'];

/***/ },
/* 561 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = doHash;
	// murmurhash2 via https://gist.github.com/raycmorgan/588423
	
	function doHash(str, seed) {
	  var m = 0x5bd1e995;
	  var r = 24;
	  var h = seed ^ str.length;
	  var length = str.length;
	  var currentIndex = 0;
	
	  while (length >= 4) {
	    var k = UInt32(str, currentIndex);
	
	    k = Umul32(k, m);
	    k ^= k >>> r;
	    k = Umul32(k, m);
	
	    h = Umul32(h, m);
	    h ^= k;
	
	    currentIndex += 4;
	    length -= 4;
	  }
	
	  switch (length) {
	    case 3:
	      h ^= UInt16(str, currentIndex);
	      h ^= str.charCodeAt(currentIndex + 2) << 16;
	      h = Umul32(h, m);
	      break;
	
	    case 2:
	      h ^= UInt16(str, currentIndex);
	      h = Umul32(h, m);
	      break;
	
	    case 1:
	      h ^= str.charCodeAt(currentIndex);
	      h = Umul32(h, m);
	      break;
	  }
	
	  h ^= h >>> 13;
	  h = Umul32(h, m);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	function UInt32(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
	}
	
	function UInt16(str, pos) {
	  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
	}
	
	function Umul32(n, m) {
	  n = n | 0;
	  m = m | 0;
	  var nlo = n & 0xffff;
	  var nhi = n >>> 16;
	  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
	  return res;
	}
	module.exports = exports["default"];

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(559);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/american_express.08b69990.png";

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/android_pay.903af36f.png";

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/apple_pay.3a18fe89.png";

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/master.2288b579.png";

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/visa.32d52906.png";

/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAoCAYAAAGa4aq5AAAAAXNSR0IArs4c6QAAAlJJREFUWAntVrFuFDEQ9fjuI/gIOiR+gUWEq5KrIIgmHb8ASEhADR0dkGqTKrmIo8oPQMkXgJS0tChZZ8Z3z4y9Xu8eHEKC22bWM+/NW4899hqTe24d1S7nX8VXHdcvBE/V7PCea5r3gYzsNnj4JRoQIpr7cTJd+KvZwQ5ywApBv/sEqSPSgARsMQiQtzyzC+0IXws9djTzyXQkIJ9WAmTtfbCqo/rSBxGYb23viwMsAEBoza34tX8jGIoQPplf9PLpomhMRNQEgITIu9GmCTxRE6TCUkgsAzaMFFMnIF7AM+fMNRCglBLhRwKMW1aIILeC7CguSI4A3z9BtPSY5/MVcxpspc+qk4PnXYRo5wCk1ypdX2BaRE0KoOVuwlhstBwgyb6UIDn6JlbOOtmW8o4nEDVpZM1NDyDzHadDSvZETcIJgcyy4XNkWyJ1kW8f19tWtwqAObs8s3YlxpzXY/RbDpz6GCsXgr8UQnFSUN94QyxU6L8tzsnW9DP35A9u14dd9WmdAF1A8fs7xrl3xrkFj4wjsru4tEtcxAYJ+lOjad5KB4KoLSdpjLUPhggXBfuE5DDjpg45hggHsP7inJBPNqIn7tI9A5YMfeEb/qVJZl8SjgQ7hZblujOrb1w05pMWnE92rsu4j/uTswK4JIiEfcLhRwWEUjmGCCJPVpjM+ZiM3TPUvBEgiz36cHd6CNLv2OWO3Zdfd26jV4v8di9awz6BVWbYlSvbV13gdfg3guuoYpRjU9KoHOsYbEoaVZFvv/PEcRaN/9Tg6enp+FdzXwF8BVk6oy1SHQAAAABJRU5ErkJggg=="

/***/ },
/* 569 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 570 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAiCAYAAAFuG2qBAAAAAXNSR0IArs4c6QAAA6ZJREFUWAnVWD9P3DAUfw6hVGxwS78CK4yAGIG9AkRhuhZu4BAfBbHcgcrUIgHqjliQELABAwx8BCqhO9QFlXJc6l8Snx2fnfNFoZQnObbf/+ck79lmxKFSqQToEwAkx0Yt4BCPvRYXUIC4lwTGIkLcs/39/Xe1Wu0xwson4zaafBqzRwSv2fxNwlhQLrcMA8fwCPmE8diGNL66yhVKjbARSUi70QjGoc61wYTUK7SVy60FECjRS58EZmmJaHQ0mmGMpkJizR1cY9Vq9Rt/NQuqEtu4UCj0sabvB6zRsPEk8NVKhTwjs1izBHs0aQ/awKSikgK6Zsynp1V+SgoUi0TLy5IB4+NjOecj+dGoaGgGKN8Kpgjax6ANNEaV7kPKFbj/9+GL8xqNhc9ra2RcYldtGt/N+Dgdz8+Th6/iy8pKZ+W9vUQjI1EbHtbUtU+HTk5CpHmN2vmJSiWijQ1JSVlHyUSWlyA4xNsTc7VXaVNTRIeHKrU1Tn5HLXSXA8+uxk6BDSyDaMhZKgg8+oMDlZIYpxtQWR/bcq9KtY49JOObsTErQ4uwtSWjgdeOEJaG+7u7X03Pe+8o48IWMMZ2SqXSYpj+J3Z2aOj01EXQiSfwffq6vk48mX4P30GeyuEBMgIyA/+JP7n/aPh7xdpfXRE9PaVGE6cd5v4VXVwQnZ9HDX+1I7gbcFSos72igcnJZJlWXUPSQy4STaVpY3sEKflF05E6tRtIFXMn2j9TVGO1Qm9uSq17e0RHR9G8w67EbuDhgQj5R4Bq4OwsSRM8hv7FlyibgS5St32J9HBFmtDxHebZIuigFGTUGNQaxjdSdf7LDDjIdM0SboBxFqnXaj9fykjXXjkK8KW/HygUPviolgGvlnkXNUc/MrHFu9IB+O6JUp930czkmaOQ2PXC9/x/AhwDRZHQe/2I6OhwGlv+AfT12e2l0exSqZT8A0g1lz/RPVGrtvv7iebm+MnIIC5uFVR+MQbNVEVQcHd3iVA/uwSDBw4aJiaItrcdGDWW2VkiNBPc3qYekUwiwL35TyhbAE1ct+UMGXVmCwBneWxeTE0/RatxiltBk5zlfkAVN42zBWDS9Eq4Nx9AtiyUttrVKhGODPr+GFX5+jpNMhMNAXDN/IaS5/RcrgFx5r+8zOSMqxB8jSHwcM+CCa5DsIlXiILpv+nhG3yErwD4Hl5VhWeCen2bPT9/5Ds8bGbcr7BCVf/sEfBT0mPQ0/NjcHCwODMz8+cvz9VzI4HsixgAAAAASUVORK5CYII="

/***/ },
/* 571 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAiCAYAAAFuG2qBAAAAAXNSR0IArs4c6QAAA/NJREFUWAnVWLlLHFEY/83oamE8EDUqeBBRm2hQt1IbD0QQEixtBDv/AbGxV9RGaw88CsEimogiKEHEzgMlWqgETJV4bkIKWVwn75vZNzsz+2Z3JpmB5MEy332+t++QwMb7YFChr2kQUamrU9QRCmlfhssmqZYWIBRSSakmxuGhjkrHtbUFX9LSvuuUKCCtBIPPzLNkZDAzSuq7SEQjcjP19SQjSRSRUZrDsahIg2uRijA5YpBz3Q/ZMWgRqg7NrwrK1kijIoBBSKcxIBaTkXpzo2Hn50aqCpsryNn5+eLQGF/6FAxes+ozieTjVTj80lw/UcL390B7u2ptJSXFJocEzsRJNza6qFJTE/D4qPkQlDa+Snt7AC9nVRVAORhGvAIxSdBmiHOwESay7SQT6bBwFLVxP1nj3kYi8TKivsRLaXlGe8XZV7KMI0mCTLNCaJxL/uG37PlZ1XRXI2pnX5/mkrc2SQDirlmVhoeBoyOgogI4PtYm2cAAUFYG5OVpP6tOFHfmoLMTWF4GLi9jZsbGgOJiYG0tbq7FhABnDurqYsu7txeYnzfaSAi76wGZcmGcxGWaqzSl/Brq1vA1Le3bE1tEXjlhhpRs4LZlf79AXZlsEwOft7qTrS0gN1dHEwKCf6EP7M8xC7hRaxNnPKE1Z0xavD/YBPav+CwO2tLcO2DldDOcO3h40OyOjOinCieOnC00spTFWsabeXYGLCw4se9gJW9uAoEAkJ4eM9jWBtCKLiwERkdjdAGUPIPycqCnx6w6Oanh/Ehh5pqw5D2orgYyMkxKOjI9rYN2QPIMSHN3V9up7+6AwUFgagooKgIyM+3s6nRnDkic7+wdHTFYN2MPJC+RVXdoyEpJiLt3kNBcPPP/dUB7DGuwIn1kh3Iv9wJjkdQDMN1FvN5wjE78gqk6peFwYSoPXrip2Xl3s9nZ2bDSDTcFK8uKR0+lEsUu8/b6sWlaHXuF81gpdt9XmVdB29nxP4GlJeDgwM7/X9OdbwVuXF1cAP39QHc3MDsL5OQAXV3A6iqwvc2O89659aYDT2w2GkdlJVBaCszMsP8KdkSj09TiIkBXGGvwVl2jHQewN6WgiwVV++oqsUu6f9GPj9ZWYHycY3/09aYDNGWur90HcHrq6nwrcuBNAnToo9eTuTlHZzCUlADr68DGhrY+RJE5pHkzhbizmhpgZ4dj2re5GaA1QYvZh+FtAqIAJya0G4uI5wHN/wQaGjwI096EN2vA3r7vHFlSr+C++/HFAcUuZyvKLVmn5xA/H4q8yoBipFhp0BsRS4I9HLI7wX0g8PmXJOXRcyzbO1U68f6lQRWn0F+wwHPD4ddvTk6ufwOiNBy80+q2iAAAAABJRU5ErkJggg=="

/***/ },
/* 572 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 573 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAiCAYAAAFuG2qBAAAAAXNSR0IArs4c6QAAA+JJREFUWAntGH9IE1H4u21ua5uGIyHTsKLSQYFIZPZLAouESUHBokIioaxYRiJBGERQRCBYopL9/CcNsYIULLP6I8iQpVAQiKJBYipohW1q06373nbH3fbuurkbKvTg7t77fn/vfe993z0G2OZ2u/34FTUEWm8c83PtW8ZOPz4aIdX7qiJ+KEJsdd7jEdDW292G4kIfhqaYYRg/g4qRf6zsAREzaMslXx15s6+W1kro6f0AjiCAV27PPwelZx9zdEDVgViCWFl9hqfkdHEATic35lVwAO4rnAQOhl8qQ//XLhBNjoCDyrBmVZaARNxlRn+O+8xxBkYMpo98rk+v+InlSOSctn5spfvAMdO+VB96WmtptAQWxtDy4ib8HukH8PuoTGEM9r0l8MeWDQ1Nl6kMfNAIsTnZBwEfWgvTQCMSwiSDTEgk7JOF6xoeYA4/rxLC+X7ouvCIYCc0OHm8yQjWd89Ag1EhJZwnnkvHM0W4Ip6jSHVRVy1UyOzsDGi1OuC24IYDF8Ct0UDy8rWhpGFjRQq8M9NQWX0UThbVgklvgoanV2D8xxA4iwMHU5hUAUCRAqPBLDqvjjiuCkTId2O+Bho8jNlIkjcjCiyDqWF7Snoem2UUHWJKdfk9k35L0jIN2ZkZdefB7Z2m8s51o8XXXAPdxoxAOpQSTtWoEDhx+iIwpiVM7BdZoUFzJltYHuBRIZePaG4q2snfh/vA7AvkrLE+F5HDnU80oUKYoimqbyyHhOTAwWaIt5IaqO1NnVCOZF+RAr3eCI8aL8GW4hqwOcpJgbVrR6GkUCFCkQJn8UOYmnaDhj1SRkYHYH9BGRiNFqEcyb6iNUDuosJKImR1WqakMBpCkQc0RqWw/wqkZ4otW0jhT/sjkOaKDEMKYEw421as3x0Z68KgJg54PB4fZku5pCZn7r8Snhwv4iQrTznGYFWKS6zhUn0skqacDVHhglUv2h7zbRyVoQqYF70DilOBgskQkcx6p2Cws5nAUjcXgDbOKMKrNYiJA17PL3DdLwU2RomdQ90vYdPxCogzLVXLbl6OaiHU/vYuVNw6BK6uFvBOTvDGoyZ0BGGIQxqkVaup5oA1MYXY1NHZxJbrCWCzO0Gr07OhYyB9hHV0PiE0VmuAVg0nVAuhrMx8sJgTAa9dau6cgNQUGzhOBe5r2l7fhs/N1zE1gz2/BNLX5ahhO5HB35kI7+AikT4viYw1EK/FsKkWQkTaPLz+OzAPky5SufhXgC3iSLap3+eEWF4UiaYtmgFbieLVDTa8IyKXTvhPkJmUlmdh/3+56jQaHbHkxRLa5/aA/0tve3xuzp6/t3dpuS3RbM0AAAAASUVORK5CYII="

/***/ },
/* 574 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 575 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAiCAYAAAFuG2qBAAAAAXNSR0IArs4c6QAABNpJREFUWAntWWtsFFUUPnc7QKukYBTcpvDHKOGRWEPwlxQShP7SGDTBtjxksSZGY1xKl9KCIBZaWsoWovBD64NXIZgaExMTHv2hARP41YegwcYE2doFDIlAKJTOjvc7wx2n05kws3HMmnh+3HPvud+599zHuefMriBJvb29BvgogrCsbIuxaFGdYSdG2wWqrkH9/IKXR42ChuhZ+EqF+HBLh7NHdHf3GJGIGC0fSBvkNjHmEShGw82W+LF0qXuH6+Kk0v3JC1k/Hv+Y+dEVJeZ4LqUGSxWwufk1gilTnp3pAjVFAlMXX7zsCXB28A5ebmhzyj3bYt++rwfnz38i6omwdRjvbK0UixfXG5mMQZo2nlpbV1NNzRd0qHyWDfZ3NT1vNmkAKwIYNCX2KnNnke7ro8iOHasIuwMaGRl2Ysa0PY90DFIK+uQM2vXOb9363GUzppPn3XDTyOzdStrIjZtufa6yiJTySbv2ugiNSwPEB1da+lQ0kfhSnkOMqqs/Y2gyuYbrind+8JLLEN6iu3mCfp+QRxpuha7n0/DwXXkMI3wUOHRd17kOGWhwT7v3aF49dW8S39X16w9QS8tqAt+5M0Z1dYcpkdhvyaB/+8JFr2E85daexuNH+KriIsF6kKor3nLljOdAXh2Rg0lzBXsLUiZmnA2q6opPK7J1+qvekzDeoqJ3q/xpBET9piaYtGRBQFWfcDhzfn6+MTQ05FMjOEwsW9ZUUVVVejgaLXSEgeCDWRqZDNGpH9JP17xVxJ4pxMO0bt0B2rUrJvnnjFN1xYM62kCBRgU6pXkCXNO2tjdo7dpPmMMHcD2TySrpze18db1eWctqZ0UISs+dab4tuv6QtPxTuYLXmcMXmptXWrLa2oP00aPXnEM8sH1HerK1AgyqnAqaqq748ePvP3BAJ4AfbAgxeGNjJdXXd9D27RW0caPp2aoOTM8zS8ACETyZU5Jz537iXEVxpBBnz16wZGhnQwjivrco27fIM6nKxmKnDlbAb9HPL6wKtLe+wU0J87GbGiv3rRMEOCDBvIK8wolB9AJheYJUw+5ASr7BSCsAnvP9V751ggAtR8vGifxMZIXMku6TfvCBMIgxqVTK0JAc9QVS9Q+WCfByDjix2HMdxcWT/WvmABIbQ63tleLEidMZREsENcOIcAYP+xDIpOdbbWUzMsmMjIgqeXfisnnV1dh+OY63v7+fkE7wWwpFBE0QAicMR6C0t5FUghB+QE6cygezeXN5wIAFRxqpYy0AQdnccTN3R3C2t5WBCNR2ucJt2HCITfg3TgAT4YkAWQtQJ6AMVTut2oyWhVPubCeHehU0VI5vMxA/pFy5/0mAJAI7vGnTUQY422pBTjmDZTHtvbiqhsqRtIOsBWzbVs7OWVu7nzuamlYyV21leEOD+cWt5PjIhlNv3nyM8fqNW8xDL6KP8BT/+BXaM+7X0G3HBPdkqgKyTqCrq5EF/5VCObG1gLDifVgbop5RawFh5BNhGY9x/z+BMHfXz9hjTuCXyrf96OUORn52gzQZtWQ8FjS5bCFxPXdM9LYEP0ygV9quTdJF+k+NotfnzqLHhnWaoMsF5TDh99E/xuexhbCdf3Ti/ydefD5Jc558nIqmCorgB8gcJPywNXjVoPP9V4xvuqpLvus88hfIKR8egYlt3wAAAABJRU5ErkJggg=="

/***/ },
/* 576 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAAGzs1ytAAAAAXNSR0IArs4c6QAAAHpJREFUOBHtUkEOwCAI072G/7+G32zrshJFZ7LDErLABbBYoVJUdS+nwW8IaF1ywUDWZZVsIlJZDt+T4eS2R6CjIu20+otDe519ciDk7IbYtAGC3gcp/v2AQXQO0sbw3X4t2/1uMb/rLYb41Xz+8ipPYlMnpUgpTAELDk8QNAueSKmGAAAAAElFTkSuQmCC"

/***/ },
/* 577 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAaCAYAAAHAhEzrAAAAAXNSR0IArs4c6QAAAklJREFUSA2tVc9rE0EUnjczRVrskrYXD4J4E4KHQkg3NrsgCB4EofEsCCVFQRREKP4ZHkQpWkX0lB8rCBYEBZuDORQKXqVQxJ+IUq3m0uL6Xtq3O7PutklwILz3ffO9byYzmRcxs/z6jdgdEuNxJELCBOLBbMxgBszaWtJEU2NyzFksH9u0SAI8NCcA4l3TKx3p4rmVlRGe4Ci/drZ+z7Taf5iguLN0GHYXvLC6miMyWp0AD2uTIOBT4JcgWp0AK0Wl1V6LwG4SeUqAWw3PvZwUMI6ETFBE77tNv1S1OD4+k7RyCY+Csns+1dESIgCQlejbJCelhDONsvuMeUuohDpV94sveNKK51rtmxaRAXb2CBDq8VGnls//ytDFF7b97ecmHvSdLGHqt9YjQ7laofDDLLIulie2O1sbleX2fcYUUx1NgdbORO1E/vu+wq4bXql1jqZTlAN8aXpuNXWPLJKgzgaee4hwqiM+jQ/4NA5zAcV/HJWC00kRCQ1HWA989yiRaaPrqECc3EtEhfHxgFjToZqt+cVXaY69crGhVQHrQsFsMD310qJ7ABmGcSU1G3wU1fq0+zxms7N9Dc1SbC7vpQzn6uXSksmbeV+GZiG2ko9SqIsNr/jU5Ac3NFxw55/xc6nhTz35L4bsjed9z/ghMt1fxCb6WGnnCj1RqhzIEAAeOgcPXH0wObmRXL53Q4BFPayvJVtRX4a4k4Uc5K7z32OyOA3bO8R2i2dyW42Pzu/VctOMmNN43W/xdpYmhvWNhUKhwxODxr9Ux7LtjTwTmwAAAABJRU5ErkJggg=="

/***/ },
/* 578 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_STAGE":"fake"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(3318);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(3317);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(101)))

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(176);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports['default'] = throttleByAnimationFrame;
	exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;
	
	var _getRequestAnimationFrame = __webpack_require__(269);
	
	var _getRequestAnimationFrame2 = _interopRequireDefault(_getRequestAnimationFrame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var reqAnimFrame = (0, _getRequestAnimationFrame2['default'])();
	function throttleByAnimationFrame(fn) {
	    var requestId = void 0;
	    var later = function later(args) {
	        return function () {
	            requestId = null;
	            fn.apply(undefined, (0, _toConsumableArray3['default'])(args));
	        };
	    };
	    var throttled = function throttled() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        if (requestId == null) {
	            requestId = reqAnimFrame(later(args));
	        }
	    };
	    throttled.cancel = function () {
	        return (0, _getRequestAnimationFrame.cancelRequestAnimationFrame)(requestId);
	    };
	    return throttled;
	}
	function throttleByAnimationFrameDecorator() {
	    return function (target, key, descriptor) {
	        var fn = descriptor.value;
	        var definingProperty = false;
	        return {
	            configurable: true,
	            get: function get() {
	                if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	                    return fn;
	                }
	                var boundFn = throttleByAnimationFrame(fn.bind(this));
	                definingProperty = true;
	                Object.defineProperty(this, key, {
	                    value: boundFn,
	                    configurable: true,
	                    writable: true
	                });
	                definingProperty = false;
	                return boundFn;
	            }
	        };
	    };
	}

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _getScroll = __webpack_require__(379);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _throttleByAnimationFrame = __webpack_require__(580);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof3["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	function getTargetRect(target) {
	    return target !== window ? target.getBoundingClientRect() : { top: 0, left: 0, bottom: 0 };
	}
	function getOffset(element, target) {
	    var elemRect = element.getBoundingClientRect();
	    var targetRect = getTargetRect(target);
	    var scrollTop = (0, _getScroll2["default"])(target, true);
	    var scrollLeft = (0, _getScroll2["default"])(target, false);
	    var docElem = window.document.body;
	    var clientTop = docElem.clientTop || 0;
	    var clientLeft = docElem.clientLeft || 0;
	    return {
	        top: elemRect.top - targetRect.top + scrollTop - clientTop,
	        left: elemRect.left - targetRect.left + scrollLeft - clientLeft,
	        width: elemRect.width,
	        height: elemRect.height
	    };
	}
	function noop() {}
	function getDefaultTarget() {
	    return typeof window !== 'undefined' ? window : null;
	}
	
	var Affix = function (_React$Component) {
	    (0, _inherits3["default"])(Affix, _React$Component);
	
	    function Affix() {
	        (0, _classCallCheck3["default"])(this, Affix);
	
	        var _this = (0, _possibleConstructorReturn3["default"])(this, (Affix.__proto__ || Object.getPrototypeOf(Affix)).apply(this, arguments));
	
	        _this.events = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
	        _this.eventHandlers = {};
	        _this.state = {
	            affixStyle: undefined,
	            placeholderStyle: undefined
	        };
	        _this.saveFixedNode = function (node) {
	            _this.fixedNode = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3["default"])(Affix, [{
	        key: "setAffixStyle",
	        value: function setAffixStyle(e, affixStyle) {
	            var _this2 = this;
	
	            var _props = this.props,
	                _props$onChange = _props.onChange,
	                onChange = _props$onChange === undefined ? noop : _props$onChange,
	                _props$target = _props.target,
	                target = _props$target === undefined ? getDefaultTarget : _props$target;
	
	            var originalAffixStyle = this.state.affixStyle;
	            var isWindow = target() === window;
	            if (e.type === 'scroll' && originalAffixStyle && affixStyle && isWindow) {
	                return;
	            }
	            if ((0, _shallowequal2["default"])(affixStyle, originalAffixStyle)) {
	                return;
	            }
	            this.setState({ affixStyle: affixStyle }, function () {
	                var affixed = !!_this2.state.affixStyle;
	                if (affixStyle && !originalAffixStyle || !affixStyle && originalAffixStyle) {
	                    onChange(affixed);
	                }
	            });
	        }
	    }, {
	        key: "setPlaceholderStyle",
	        value: function setPlaceholderStyle(placeholderStyle) {
	            var originalPlaceholderStyle = this.state.placeholderStyle;
	            if ((0, _shallowequal2["default"])(placeholderStyle, originalPlaceholderStyle)) {
	                return;
	            }
	            this.setState({ placeholderStyle: placeholderStyle });
	        }
	    }, {
	        key: "updatePosition",
	        value: function updatePosition(e) {
	            var _props2 = this.props,
	                offsetTop = _props2.offsetTop,
	                offsetBottom = _props2.offsetBottom,
	                offset = _props2.offset,
	                _props2$target = _props2.target,
	                target = _props2$target === undefined ? getDefaultTarget : _props2$target;
	
	            var targetNode = target();
	            // Backwards support
	            offsetTop = offsetTop || offset;
	            var scrollTop = (0, _getScroll2["default"])(targetNode, true);
	            var affixNode = ReactDOM.findDOMNode(this);
	            var elemOffset = getOffset(affixNode, targetNode);
	            var elemSize = {
	                width: this.fixedNode.offsetWidth,
	                height: this.fixedNode.offsetHeight
	            };
	            var offsetMode = {
	                top: false,
	                bottom: false
	            };
	            // Default to `offsetTop=0`.
	            if (typeof offsetTop !== 'number' && typeof offsetBottom !== 'number') {
	                offsetMode.top = true;
	                offsetTop = 0;
	            } else {
	                offsetMode.top = typeof offsetTop === 'number';
	                offsetMode.bottom = typeof offsetBottom === 'number';
	            }
	            var targetRect = getTargetRect(targetNode);
	            var targetInnerHeight = targetNode.innerHeight || targetNode.clientHeight;
	            if (scrollTop > elemOffset.top - offsetTop && offsetMode.top) {
	                // Fixed Top
	                var width = elemOffset.width;
	                var top = targetRect.top + offsetTop;
	                this.setAffixStyle(e, {
	                    position: 'fixed',
	                    top: top,
	                    left: targetRect.left + elemOffset.left,
	                    width: width
	                });
	                this.setPlaceholderStyle({
	                    width: width,
	                    height: elemSize.height
	                });
	            } else if (scrollTop < elemOffset.top + elemSize.height + offsetBottom - targetInnerHeight && offsetMode.bottom) {
	                // Fixed Bottom
	                var targetBottomOffet = targetNode === window ? 0 : window.innerHeight - targetRect.bottom;
	                var _width = elemOffset.width;
	                this.setAffixStyle(e, {
	                    position: 'fixed',
	                    bottom: targetBottomOffet + offsetBottom,
	                    left: targetRect.left + elemOffset.left,
	                    width: _width
	                });
	                this.setPlaceholderStyle({
	                    width: _width,
	                    height: elemOffset.height
	                });
	            } else {
	                var affixStyle = this.state.affixStyle;
	
	                if (e.type === 'resize' && affixStyle && affixStyle.position === 'fixed' && affixNode.offsetWidth) {
	                    this.setAffixStyle(e, (0, _extends3["default"])({}, affixStyle, { width: affixNode.offsetWidth }));
	                } else {
	                    this.setAffixStyle(e, null);
	                }
	                this.setPlaceholderStyle(null);
	            }
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this3 = this;
	
	            var target = this.props.target || getDefaultTarget;
	            // Wait for parent component ref has its value
	            this.timeout = setTimeout(function () {
	                _this3.setTargetEventListeners(target);
	            });
	        }
	    }, {
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            if (this.props.target !== nextProps.target) {
	                this.clearEventListeners();
	                this.setTargetEventListeners(nextProps.target);
	                // Mock Event object.
	                this.updatePosition({});
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            this.clearEventListeners();
	            clearTimeout(this.timeout);
	            this.updatePosition.cancel();
	        }
	    }, {
	        key: "setTargetEventListeners",
	        value: function setTargetEventListeners(getTarget) {
	            var _this4 = this;
	
	            var target = getTarget();
	            if (!target) {
	                return;
	            }
	            this.clearEventListeners();
	            this.events.forEach(function (eventName) {
	                _this4.eventHandlers[eventName] = (0, _addEventListener2["default"])(target, eventName, _this4.updatePosition);
	            });
	        }
	    }, {
	        key: "clearEventListeners",
	        value: function clearEventListeners() {
	            var _this5 = this;
	
	            this.events.forEach(function (eventName) {
	                var handler = _this5.eventHandlers[eventName];
	                if (handler && handler.remove) {
	                    handler.remove();
	                }
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var className = (0, _classnames2["default"])((0, _defineProperty3["default"])({}, this.props.prefixCls || 'ant-affix', this.state.affixStyle));
	            var props = (0, _omit2["default"])(this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']);
	            var placeholderStyle = (0, _extends3["default"])({}, this.state.placeholderStyle, this.props.style);
	            return React.createElement(
	                "div",
	                (0, _extends3["default"])({}, props, { style: placeholderStyle }),
	                React.createElement(
	                    "div",
	                    { className: className, ref: this.saveFixedNode, style: this.state.affixStyle },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	    return Affix;
	}(React.Component);
	
	exports["default"] = Affix;
	
	Affix.propTypes = {
	    offsetTop: _propTypes2["default"].number,
	    offsetBottom: _propTypes2["default"].number,
	    target: _propTypes2["default"].func
	};
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "updatePosition", null);

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var BreadcrumbItem = function (_React$Component) {
	    (0, _inherits3['default'])(BreadcrumbItem, _React$Component);
	
	    function BreadcrumbItem() {
	        (0, _classCallCheck3['default'])(this, BreadcrumbItem);
	        return (0, _possibleConstructorReturn3['default'])(this, (BreadcrumbItem.__proto__ || Object.getPrototypeOf(BreadcrumbItem)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(BreadcrumbItem, [{
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                separator = _a.separator,
	                children = _a.children,
	                restProps = __rest(_a, ["prefixCls", "separator", "children"]);
	            var link = void 0;
	            if ('href' in this.props) {
	                link = React.createElement(
	                    'a',
	                    (0, _extends3['default'])({ className: prefixCls + '-link' }, restProps),
	                    children
	                );
	            } else {
	                link = React.createElement(
	                    'span',
	                    (0, _extends3['default'])({ className: prefixCls + '-link' }, restProps),
	                    children
	                );
	            }
	            if (children) {
	                return React.createElement(
	                    'span',
	                    null,
	                    link,
	                    React.createElement(
	                        'span',
	                        { className: prefixCls + '-separator' },
	                        separator
	                    )
	                );
	            }
	            return null;
	        }
	    }]);
	    return BreadcrumbItem;
	}(React.Component);
	
	exports['default'] = BreadcrumbItem;
	
	BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
	BreadcrumbItem.defaultProps = {
	    prefixCls: 'ant-breadcrumb',
	    separator: '/'
	};
	BreadcrumbItem.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    separator: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].element]),
	    href: _propTypes2['default'].string
	};

/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var PREFIX_CLS = exports.PREFIX_CLS = 'ant-fullcalendar';

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _en_US = __webpack_require__(381);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _en_US2['default'];

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcCheckbox = __webpack_require__(1159);
	
	var _rcCheckbox2 = _interopRequireDefault(_rcCheckbox);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Checkbox = function (_React$Component) {
	    (0, _inherits3['default'])(Checkbox, _React$Component);
	
	    function Checkbox() {
	        (0, _classCallCheck3['default'])(this, Checkbox);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
	
	        _this.saveCheckbox = function (node) {
	            _this.rcCheckbox = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Checkbox, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState) || !(0, _shallowequal2['default'])(this.context.checkboxGroup, nextContext.checkboxGroup);
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.rcCheckbox.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcCheckbox.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props,
	                context = this.context;
	
	            var prefixCls = props.prefixCls,
	                className = props.className,
	                children = props.children,
	                indeterminate = props.indeterminate,
	                style = props.style,
	                onMouseEnter = props.onMouseEnter,
	                onMouseLeave = props.onMouseLeave,
	                restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
	
	            var checkboxGroup = context.checkboxGroup;
	
	            var checkboxProps = (0, _extends3['default'])({}, restProps);
	            if (checkboxGroup) {
	                checkboxProps.onChange = function () {
	                    return checkboxGroup.toggleOption({ label: children, value: props.value });
	                };
	                checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
	                checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
	            }
	            var classString = (0, _classnames2['default'])(className, (0, _defineProperty3['default'])({}, prefixCls + '-wrapper', true));
	            var checkboxClass = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-indeterminate', indeterminate));
	            return React.createElement(
	                'label',
	                { className: classString, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
	                React.createElement(_rcCheckbox2['default'], (0, _extends3['default'])({}, checkboxProps, { prefixCls: prefixCls, className: checkboxClass, ref: this.saveCheckbox })),
	                children !== undefined ? React.createElement(
	                    'span',
	                    null,
	                    children
	                ) : null
	            );
	        }
	    }]);
	    return Checkbox;
	}(React.Component);
	
	exports['default'] = Checkbox;
	
	Checkbox.defaultProps = {
	    prefixCls: 'ant-checkbox',
	    indeterminate: false
	};
	Checkbox.contextTypes = {
	    checkboxGroup: _propTypes2['default'].any
	};

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _ca_ES = __webpack_require__(2498);
	
	var _ca_ES2 = _interopRequireDefault(_ca_ES);
	
	var _ca_ES3 = __webpack_require__(600);
	
	var _ca_ES4 = _interopRequireDefault(_ca_ES3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Merge into a locale object
	var locale = {
	    lang: (0, _extends3['default'])({ placeholder: 'Seleccionar data', rangePlaceholder: ['Data inicial', 'Data final'] }, _ca_ES2['default']),
	    timePickerLocale: (0, _extends3['default'])({}, _ca_ES4['default'])
	};
	// All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	exports['default'] = locale;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _fr_FR = __webpack_require__(2499);
	
	var _fr_FR2 = _interopRequireDefault(_fr_FR);
	
	var _fr_FR3 = __webpack_require__(601);
	
	var _fr_FR4 = _interopRequireDefault(_fr_FR3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Merge into a locale object
	var locale = {
	    lang: (0, _extends3['default'])({ placeholder: 'Sélectionner une date', rangePlaceholder: ['Date de début', 'Date de fin'] }, _fr_FR2['default']),
	    timePickerLocale: (0, _extends3['default'])({}, _fr_FR4['default'])
	};
	// All settings at:
	// https://github.com/ant-design/ant-design/issues/424
	exports['default'] = locale;

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _it_IT = __webpack_require__(2500);
	
	var _it_IT2 = _interopRequireDefault(_it_IT);
	
	var _it_IT3 = __webpack_require__(602);
	
	var _it_IT4 = _interopRequireDefault(_it_IT3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Merge into a locale object
	var locale = {
	    lang: (0, _extends3['default'])({ placeholder: 'Selezionare la data', rangePlaceholder: ['Data d\'inizio', 'Data di fine'] }, _it_IT2['default']),
	    timePickerLocale: (0, _extends3['default'])({}, _it_IT4['default'])
	};
	// All settings at:
	// https://github.com/ant-design/ant-design/issues/424
	exports['default'] = locale;

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcDropdown = __webpack_require__(2517);
	
	var _rcDropdown2 = _interopRequireDefault(_rcDropdown);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Dropdown = function (_React$Component) {
	    (0, _inherits3['default'])(Dropdown, _React$Component);
	
	    function Dropdown() {
	        (0, _classCallCheck3['default'])(this, Dropdown);
	        return (0, _possibleConstructorReturn3['default'])(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Dropdown, [{
	        key: 'getTransitionName',
	        value: function getTransitionName() {
	            var _props = this.props,
	                _props$placement = _props.placement,
	                placement = _props$placement === undefined ? '' : _props$placement,
	                transitionName = _props.transitionName;
	
	            if (transitionName !== undefined) {
	                return transitionName;
	            }
	            if (placement.indexOf('top') >= 0) {
	                return 'slide-down';
	            }
	            return 'slide-up';
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var overlay = this.props.overlay;
	
	            var overlayProps = overlay.props;
	            (0, _warning2['default'])(!overlayProps.mode || overlayProps.mode === 'vertical', 'mode="' + overlayProps.mode + '" is not supported for Dropdown\'s Menu.');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                children = _props2.children,
	                prefixCls = _props2.prefixCls,
	                overlay = _props2.overlay,
	                trigger = _props2.trigger,
	                disabled = _props2.disabled;
	
	            var dropdownTrigger = React.cloneElement(children, {
	                className: (0, _classnames2['default'])(children.props.className, prefixCls + '-trigger'),
	                disabled: disabled
	            });
	            // menu cannot be selectable in dropdown defaultly
	            var overlayProps = overlay && overlay.props;
	            var selectable = overlayProps && 'selectable' in overlayProps ? overlayProps.selectable : false;
	            var fixedModeOverlay = React.cloneElement(overlay, {
	                mode: 'vertical',
	                selectable: selectable
	            });
	            return React.createElement(
	                _rcDropdown2['default'],
	                (0, _extends3['default'])({}, this.props, { transitionName: this.getTransitionName(), trigger: disabled ? [] : trigger, overlay: fixedModeOverlay }),
	                dropdownTrigger
	            );
	        }
	    }]);
	    return Dropdown;
	}(React.Component);
	
	exports['default'] = Dropdown;
	
	Dropdown.defaultProps = {
	    prefixCls: 'ant-dropdown',
	    mouseEnterDelay: 0.15,
	    mouseLeaveDelay: 0.1,
	    placement: 'bottomLeft'
	};

/***/ },
/* 590 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var FIELD_META_PROP = exports.FIELD_META_PROP = 'data-__meta';
	var FIELD_DATA_PROP = exports.FIELD_DATA_PROP = 'data-__field';

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var stringOrNumber = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	var objectOrNumber = _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].number]);
	
	var Col = function (_React$Component) {
	    (0, _inherits3['default'])(Col, _React$Component);
	
	    function Col() {
	        (0, _classCallCheck3['default'])(this, Col);
	        return (0, _possibleConstructorReturn3['default'])(this, (Col.__proto__ || Object.getPrototypeOf(Col)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Col, [{
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var props = this.props;
	
	            var span = props.span,
	                order = props.order,
	                offset = props.offset,
	                push = props.push,
	                pull = props.pull,
	                className = props.className,
	                children = props.children,
	                _props$prefixCls = props.prefixCls,
	                prefixCls = _props$prefixCls === undefined ? 'ant-col' : _props$prefixCls,
	                others = __rest(props, ["span", "order", "offset", "push", "pull", "className", "children", "prefixCls"]);
	
	            var sizeClassObj = {};
	            ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
	                var _extends2;
	
	                var sizeProps = {};
	                if (typeof props[size] === 'number') {
	                    sizeProps.span = props[size];
	                } else if ((0, _typeof3['default'])(props[size]) === 'object') {
	                    sizeProps = props[size] || {};
	                }
	                delete others[size];
	                sizeClassObj = (0, _extends4['default'])({}, sizeClassObj, (_extends2 = {}, (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-' + sizeProps.span, sizeProps.span !== undefined), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-order-' + sizeProps.order, sizeProps.order || sizeProps.order === 0), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-offset-' + sizeProps.offset, sizeProps.offset || sizeProps.offset === 0), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-push-' + sizeProps.push, sizeProps.push || sizeProps.push === 0), (0, _defineProperty3['default'])(_extends2, prefixCls + '-' + size + '-pull-' + sizeProps.pull, sizeProps.pull || sizeProps.pull === 0), _extends2));
	            });
	            var classes = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + span, span !== undefined), (0, _defineProperty3['default'])(_classNames, prefixCls + '-order-' + order, order), (0, _defineProperty3['default'])(_classNames, prefixCls + '-offset-' + offset, offset), (0, _defineProperty3['default'])(_classNames, prefixCls + '-push-' + push, push), (0, _defineProperty3['default'])(_classNames, prefixCls + '-pull-' + pull, pull), _classNames), className, sizeClassObj);
	            return React.createElement(
	                'div',
	                (0, _extends4['default'])({}, others, { className: classes }),
	                children
	            );
	        }
	    }]);
	    return Col;
	}(React.Component);
	
	exports['default'] = Col;
	
	Col.propTypes = {
	    span: stringOrNumber,
	    order: stringOrNumber,
	    offset: stringOrNumber,
	    push: stringOrNumber,
	    pull: stringOrNumber,
	    className: _propTypes2['default'].string,
	    children: _propTypes2['default'].node,
	    xs: objectOrNumber,
	    sm: objectOrNumber,
	    md: objectOrNumber,
	    lg: objectOrNumber,
	    xl: objectOrNumber,
	    xxl: objectOrNumber
	};

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	var enquire = void 0;
	if (typeof window !== 'undefined') {
	    var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	        return {
	            media: mediaQuery,
	            matches: false,
	            addListener: function addListener() {},
	            removeListener: function removeListener() {}
	        };
	    };
	    window.matchMedia = window.matchMedia || matchMediaPolyfill;
	    enquire = __webpack_require__(933);
	}
	
	var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
	var responsiveMap = {
	    xs: '(max-width: 575px)',
	    sm: '(min-width: 576px)',
	    md: '(min-width: 768px)',
	    lg: '(min-width: 992px)',
	    xl: '(min-width: 1200px)',
	    xxl: '(min-width: 1600px)'
	};
	
	var Row = function (_React$Component) {
	    (0, _inherits3['default'])(Row, _React$Component);
	
	    function Row() {
	        (0, _classCallCheck3['default'])(this, Row);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
	
	        _this.state = {
	            screens: {}
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Row, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            Object.keys(responsiveMap).map(function (screen) {
	                return enquire.register(responsiveMap[screen], {
	                    match: function match() {
	                        if ((0, _typeof3['default'])(_this2.props.gutter) !== 'object') {
	                            return;
	                        }
	                        _this2.setState(function (prevState) {
	                            return {
	                                screens: (0, _extends5['default'])({}, prevState.screens, (0, _defineProperty3['default'])({}, screen, true))
	                            };
	                        });
	                    },
	                    unmatch: function unmatch() {
	                        if ((0, _typeof3['default'])(_this2.props.gutter) !== 'object') {
	                            return;
	                        }
	                        _this2.setState(function (prevState) {
	                            return {
	                                screens: (0, _extends5['default'])({}, prevState.screens, (0, _defineProperty3['default'])({}, screen, false))
	                            };
	                        });
	                    },
	                    // Keep a empty destory to avoid triggering unmatch when unregister
	                    destroy: function destroy() {}
	                });
	            });
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            Object.keys(responsiveMap).map(function (screen) {
	                return enquire.unregister(responsiveMap[screen]);
	            });
	        }
	    }, {
	        key: 'getGutter',
	        value: function getGutter() {
	            var gutter = this.props.gutter;
	
	            if ((typeof gutter === 'undefined' ? 'undefined' : (0, _typeof3['default'])(gutter)) === 'object') {
	                for (var i = 0; i <= responsiveArray.length; i++) {
	                    var breakpoint = responsiveArray[i];
	                    if (this.state.screens[breakpoint] && gutter[breakpoint] !== undefined) {
	                        return gutter[breakpoint];
	                    }
	                }
	            }
	            return gutter;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                type = _a.type,
	                justify = _a.justify,
	                align = _a.align,
	                className = _a.className,
	                style = _a.style,
	                children = _a.children,
	                _a$prefixCls = _a.prefixCls,
	                prefixCls = _a$prefixCls === undefined ? 'ant-row' : _a$prefixCls,
	                others = __rest(_a, ["type", "justify", "align", "className", "style", "children", "prefixCls"]);
	            var gutter = this.getGutter();
	            var classes = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, !type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type + '-' + justify, type && justify), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type + '-' + align, type && align), _classNames), className);
	            var rowStyle = gutter > 0 ? (0, _extends5['default'])({ marginLeft: gutter / -2, marginRight: gutter / -2 }, style) : style;
	            var cols = _react.Children.map(children, function (col) {
	                if (!col) {
	                    return null;
	                }
	                if (col.props && gutter > 0) {
	                    return (0, _react.cloneElement)(col, {
	                        style: (0, _extends5['default'])({ paddingLeft: gutter / 2, paddingRight: gutter / 2 }, col.props.style)
	                    });
	                }
	                return col;
	            });
	            var otherProps = (0, _extends5['default'])({}, others);
	            delete otherProps.gutter;
	            return React.createElement(
	                'div',
	                (0, _extends5['default'])({}, otherProps, { className: classes, style: rowStyle }),
	                cols
	            );
	        }
	    }]);
	    return Row;
	}(React.Component);
	
	exports['default'] = Row;
	
	Row.defaultProps = {
	    gutter: 0
	};
	Row.propTypes = {
	    type: _propTypes2['default'].string,
	    align: _propTypes2['default'].string,
	    justify: _propTypes2['default'].string,
	    className: _propTypes2['default'].string,
	    children: _propTypes2['default'].node,
	    gutter: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].number]),
	    prefixCls: _propTypes2['default'].string
	};

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function fixControlledValue(value) {
	    if (typeof value === 'undefined' || value === null) {
	        return '';
	    }
	    return value;
	}
	
	var Input = function (_React$Component) {
	    (0, _inherits3['default'])(Input, _React$Component);
	
	    function Input() {
	        (0, _classCallCheck3['default'])(this, Input);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
	
	        _this.handleKeyDown = function (e) {
	            var _this$props = _this.props,
	                onPressEnter = _this$props.onPressEnter,
	                onKeyDown = _this$props.onKeyDown;
	
	            if (e.keyCode === 13 && onPressEnter) {
	                onPressEnter(e);
	            }
	            if (onKeyDown) {
	                onKeyDown(e);
	            }
	        };
	        _this.saveInput = function (node) {
	            _this.input = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Input, [{
	        key: 'focus',
	        value: function focus() {
	            this.input.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.input.blur();
	        }
	    }, {
	        key: 'getInputClassName',
	        value: function getInputClassName() {
	            var _classNames;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                size = _props.size,
	                disabled = _props.disabled;
	
	            return (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
	        }
	    }, {
	        key: 'renderLabeledInput',
	        value: function renderLabeledInput(children) {
	            var _classNames3;
	
	            var props = this.props;
	            // Not wrap when there is not addons
	            if (!props.addonBefore && !props.addonAfter) {
	                return children;
	            }
	            var wrapperClassName = props.prefixCls + '-group';
	            var addonClassName = wrapperClassName + '-addon';
	            var addonBefore = props.addonBefore ? React.createElement(
	                'span',
	                { className: addonClassName },
	                props.addonBefore
	            ) : null;
	            var addonAfter = props.addonAfter ? React.createElement(
	                'span',
	                { className: addonClassName },
	                props.addonAfter
	            ) : null;
	            var className = (0, _classnames2['default'])(props.prefixCls + '-wrapper', (0, _defineProperty3['default'])({}, wrapperClassName, addonBefore || addonAfter));
	            var groupClassName = (0, _classnames2['default'])(props.prefixCls + '-group-wrapper', (_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames3, props.prefixCls + '-group-wrapper-lg', props.size === 'large'), _classNames3));
	            // Need another wrapper for changing display:table to display:inline-block
	            // and put style prop in wrapper
	            if (addonBefore || addonAfter) {
	                return React.createElement(
	                    'span',
	                    { className: groupClassName, style: props.style },
	                    React.createElement(
	                        'span',
	                        { className: className },
	                        addonBefore,
	                        React.cloneElement(children, { style: null }),
	                        addonAfter
	                    )
	                );
	            }
	            return React.createElement(
	                'span',
	                { className: className },
	                addonBefore,
	                children,
	                addonAfter
	            );
	        }
	    }, {
	        key: 'renderLabeledIcon',
	        value: function renderLabeledIcon(children) {
	            var _classNames4;
	
	            var props = this.props;
	
	            if (!('prefix' in props || 'suffix' in props)) {
	                return children;
	            }
	            var prefix = props.prefix ? React.createElement(
	                'span',
	                { className: props.prefixCls + '-prefix' },
	                props.prefix
	            ) : null;
	            var suffix = props.suffix ? React.createElement(
	                'span',
	                { className: props.prefixCls + '-suffix' },
	                props.suffix
	            ) : null;
	            var affixWrapperCls = (0, _classnames2['default'])(props.className, props.prefixCls + '-affix-wrapper', (_classNames4 = {}, (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames4, props.prefixCls + '-affix-wrapper-lg', props.size === 'large'), _classNames4));
	            return React.createElement(
	                'span',
	                { className: affixWrapperCls, style: props.style },
	                prefix,
	                React.cloneElement(children, { style: null, className: this.getInputClassName() }),
	                suffix
	            );
	        }
	    }, {
	        key: 'renderInput',
	        value: function renderInput() {
	            var _props2 = this.props,
	                value = _props2.value,
	                className = _props2.className;
	            // Fix https://fb.me/react-unknown-prop
	
	            var otherProps = (0, _omit2['default'])(this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix']);
	            if ('value' in this.props) {
	                otherProps.value = fixControlledValue(value);
	                // Input elements must be either controlled or uncontrolled,
	                // specify either the value prop, or the defaultValue prop, but not both.
	                delete otherProps.defaultValue;
	            }
	            return this.renderLabeledIcon(React.createElement('input', (0, _extends3['default'])({}, otherProps, { className: (0, _classnames2['default'])(this.getInputClassName(), className), onKeyDown: this.handleKeyDown, ref: this.saveInput })));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return this.renderLabeledInput(this.renderInput());
	        }
	    }]);
	    return Input;
	}(React.Component);
	
	exports['default'] = Input;
	
	Input.defaultProps = {
	    prefixCls: 'ant-input',
	    type: 'text',
	    disabled: false
	};
	Input.propTypes = {
	    type: _propTypes2['default'].string,
	    id: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	    size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
	    maxLength: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	    disabled: _propTypes2['default'].bool,
	    value: _propTypes2['default'].any,
	    defaultValue: _propTypes2['default'].any,
	    className: _propTypes2['default'].string,
	    addonBefore: _propTypes2['default'].node,
	    addonAfter: _propTypes2['default'].node,
	    prefixCls: _propTypes2['default'].string,
	    autosize: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	    onPressEnter: _propTypes2['default'].func,
	    onKeyDown: _propTypes2['default'].func,
	    onKeyUp: _propTypes2['default'].func,
	    onFocus: _propTypes2['default'].func,
	    onBlur: _propTypes2['default'].func,
	    prefix: _propTypes2['default'].node,
	    suffix: _propTypes2['default'].node
	};

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _default2['default'];

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _rcMenu = __webpack_require__(191);
	
	var _rcMenu2 = _interopRequireDefault(_rcMenu);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _openAnimation = __webpack_require__(380);
	
	var _openAnimation2 = _interopRequireDefault(_openAnimation);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _SubMenu = __webpack_require__(1484);
	
	var _SubMenu2 = _interopRequireDefault(_SubMenu);
	
	var _MenuItem = __webpack_require__(1483);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Menu = function (_React$Component) {
	    (0, _inherits3['default'])(Menu, _React$Component);
	
	    function Menu(props) {
	        (0, _classCallCheck3['default'])(this, Menu);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props));
	
	        _this.inlineOpenKeys = [];
	        _this.handleClick = function (e) {
	            _this.handleOpenChange([]);
	            var onClick = _this.props.onClick;
	
	            if (onClick) {
	                onClick(e);
	            }
	        };
	        _this.handleOpenChange = function (openKeys) {
	            _this.setOpenKeys(openKeys);
	            var onOpenChange = _this.props.onOpenChange;
	
	            if (onOpenChange) {
	                onOpenChange(openKeys);
	            }
	        };
	        (0, _warning2['default'])(!('onOpen' in props || 'onClose' in props), '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
	        (0, _warning2['default'])(!('inlineCollapsed' in props && props.mode !== 'inline'), '`inlineCollapsed` should only be used when Menu\'s `mode` is inline.');
	        var openKeys = void 0;
	        if ('defaultOpenKeys' in props) {
	            openKeys = props.defaultOpenKeys;
	        } else if ('openKeys' in props) {
	            openKeys = props.openKeys;
	        }
	        _this.state = {
	            openKeys: openKeys || []
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Menu, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                inlineCollapsed: this.getInlineCollapsed(),
	                antdMenuTheme: this.props.theme
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps, nextContext) {
	            var prefixCls = this.props.prefixCls;
	
	            if (this.props.mode === 'inline' && nextProps.mode !== 'inline') {
	                this.switchModeFromInline = true;
	            }
	            if ('openKeys' in nextProps) {
	                this.setState({ openKeys: nextProps.openKeys });
	                return;
	            }
	            if (nextProps.inlineCollapsed && !this.props.inlineCollapsed || nextContext.siderCollapsed && !this.context.siderCollapsed) {
	                this.switchModeFromInline = !!this.state.openKeys.length && !!(0, _reactDom.findDOMNode)(this).querySelectorAll('.' + prefixCls + '-submenu-open').length;
	                this.inlineOpenKeys = this.state.openKeys;
	                this.setState({ openKeys: [] });
	            }
	            if (!nextProps.inlineCollapsed && this.props.inlineCollapsed || !nextContext.siderCollapsed && this.context.siderCollapsed) {
	                this.setState({ openKeys: this.inlineOpenKeys });
	                this.inlineOpenKeys = [];
	            }
	        }
	    }, {
	        key: 'setOpenKeys',
	        value: function setOpenKeys(openKeys) {
	            if (!('openKeys' in this.props)) {
	                this.setState({ openKeys: openKeys });
	            }
	        }
	    }, {
	        key: 'getRealMenuMode',
	        value: function getRealMenuMode() {
	            var inlineCollapsed = this.getInlineCollapsed();
	            if (this.switchModeFromInline && inlineCollapsed) {
	                return 'inline';
	            }
	            var mode = this.props.mode;
	
	            return inlineCollapsed ? 'vertical' : mode;
	        }
	    }, {
	        key: 'getInlineCollapsed',
	        value: function getInlineCollapsed() {
	            var inlineCollapsed = this.props.inlineCollapsed;
	
	            if (this.context.siderCollapsed !== undefined) {
	                return this.context.siderCollapsed;
	            }
	            return inlineCollapsed;
	        }
	    }, {
	        key: 'getMenuOpenAnimation',
	        value: function getMenuOpenAnimation(menuMode) {
	            var _this2 = this;
	
	            var _props = this.props,
	                openAnimation = _props.openAnimation,
	                openTransitionName = _props.openTransitionName;
	
	            var menuOpenAnimation = openAnimation || openTransitionName;
	            if (openAnimation === undefined && openTransitionName === undefined) {
	                switch (menuMode) {
	                    case 'horizontal':
	                        menuOpenAnimation = 'slide-up';
	                        break;
	                    case 'vertical':
	                    case 'vertical-left':
	                    case 'vertical-right':
	                        // When mode switch from inline
	                        // submenu should hide without animation
	                        if (this.switchModeFromInline) {
	                            menuOpenAnimation = '';
	                            this.switchModeFromInline = false;
	                        } else {
	                            menuOpenAnimation = 'zoom-big';
	                        }
	                        break;
	                    case 'inline':
	                        menuOpenAnimation = (0, _extends3['default'])({}, _openAnimation2['default'], { leave: function leave(node, done) {
	                                return _openAnimation2['default'].leave(node, function () {
	                                    // Make sure inline menu leave animation finished before mode is switched
	                                    _this2.switchModeFromInline = false;
	                                    _this2.setState({});
	                                    // when inlineCollapsed change false to true, all submenu will be unmounted,
	                                    // so that we don't need handle animation leaving.
	                                    if (_this2.getRealMenuMode() === 'vertical') {
	                                        return;
	                                    }
	                                    done();
	                                });
	                            } });
	                        break;
	                    default:
	                }
	            }
	            return menuOpenAnimation;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                prefixCls = _props2.prefixCls,
	                className = _props2.className,
	                theme = _props2.theme;
	
	            var menuMode = this.getRealMenuMode();
	            var menuOpenAnimation = this.getMenuOpenAnimation(menuMode);
	            var menuClassName = (0, _classnames2['default'])(className, prefixCls + '-' + theme, (0, _defineProperty3['default'])({}, prefixCls + '-inline-collapsed', this.getInlineCollapsed()));
	            var menuProps = {
	                openKeys: this.state.openKeys,
	                onOpenChange: this.handleOpenChange,
	                className: menuClassName,
	                mode: menuMode
	            };
	            if (menuMode !== 'inline') {
	                // closing vertical popup submenu after click it
	                menuProps.onClick = this.handleClick;
	                menuProps.openTransitionName = menuOpenAnimation;
	            } else {
	                menuProps.openAnimation = menuOpenAnimation;
	            }
	            // https://github.com/ant-design/ant-design/issues/8587
	            var collapsedWidth = this.context.collapsedWidth;
	
	            if (this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px')) {
	                return null;
	            }
	            return React.createElement(_rcMenu2['default'], (0, _extends3['default'])({}, this.props, menuProps));
	        }
	    }]);
	    return Menu;
	}(React.Component);
	
	exports['default'] = Menu;
	
	Menu.Divider = _rcMenu.Divider;
	Menu.Item = _MenuItem2['default'];
	Menu.SubMenu = _SubMenu2['default'];
	Menu.ItemGroup = _rcMenu.ItemGroup;
	Menu.defaultProps = {
	    prefixCls: 'ant-menu',
	    className: '',
	    theme: 'light'
	};
	Menu.childContextTypes = {
	    inlineCollapsed: _propTypes2['default'].bool,
	    antdMenuTheme: _propTypes2['default'].string
	};
	Menu.contextTypes = {
	    siderCollapsed: _propTypes2['default'].bool,
	    collapsedWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcDialog = __webpack_require__(2514);
	
	var _rcDialog2 = _interopRequireDefault(_rcDialog);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _button = __webpack_require__(142);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _locale = __webpack_require__(383);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var mousePosition = void 0;
	var mousePositionEventBinded = void 0;
	
	var Modal = function (_React$Component) {
	    (0, _inherits3['default'])(Modal, _React$Component);
	
	    function Modal() {
	        (0, _classCallCheck3['default'])(this, Modal);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).apply(this, arguments));
	
	        _this.handleCancel = function (e) {
	            var onCancel = _this.props.onCancel;
	            if (onCancel) {
	                onCancel(e);
	            }
	        };
	        _this.handleOk = function (e) {
	            var onOk = _this.props.onOk;
	            if (onOk) {
	                onOk(e);
	            }
	        };
	        _this.renderFooter = function (locale) {
	            var _this$props = _this.props,
	                okText = _this$props.okText,
	                okType = _this$props.okType,
	                cancelText = _this$props.cancelText,
	                confirmLoading = _this$props.confirmLoading;
	
	            return React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    _button2['default'],
	                    { onClick: _this.handleCancel },
	                    cancelText || locale.cancelText
	                ),
	                React.createElement(
	                    _button2['default'],
	                    { type: okType, loading: confirmLoading, onClick: _this.handleOk },
	                    okText || locale.okText
	                )
	            );
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Modal, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (mousePositionEventBinded) {
	                return;
	            }
	            // 只有点击事件支持从鼠标位置动画展开
	            (0, _addEventListener2['default'])(document.documentElement, 'click', function (e) {
	                mousePosition = {
	                    x: e.pageX,
	                    y: e.pageY
	                };
	                // 100ms 内发生过点击事件，则从点击位置动画展示
	                // 否则直接 zoom 展示
	                // 这样可以兼容非点击方式展开
	                setTimeout(function () {
	                    return mousePosition = null;
	                }, 100);
	            });
	            mousePositionEventBinded = true;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                footer = _props.footer,
	                visible = _props.visible;
	
	            var defaultFooter = React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Modal', defaultLocale: (0, _locale.getConfirmLocale)() },
	                this.renderFooter
	            );
	            return React.createElement(_rcDialog2['default'], (0, _extends3['default'])({}, this.props, { footer: footer === undefined ? defaultFooter : footer, visible: visible, mousePosition: mousePosition, onClose: this.handleCancel }));
	        }
	    }]);
	    return Modal;
	}(React.Component);
	
	exports['default'] = Modal;
	
	Modal.defaultProps = {
	    prefixCls: 'ant-modal',
	    width: 520,
	    transitionName: 'zoom',
	    maskTransitionName: 'fade',
	    confirmLoading: false,
	    visible: false,
	    okType: 'primary'
	};
	Modal.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    onOk: _propTypes2['default'].func,
	    onCancel: _propTypes2['default'].func,
	    okText: _propTypes2['default'].node,
	    cancelText: _propTypes2['default'].node,
	    width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	    confirmLoading: _propTypes2['default'].bool,
	    visible: _propTypes2['default'].bool,
	    align: _propTypes2['default'].object,
	    footer: _propTypes2['default'].node,
	    title: _propTypes2['default'].node,
	    closable: _propTypes2['default'].bool
	};

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _progress = __webpack_require__(1494);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _progress2['default'];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _rcTabs = __webpack_require__(1538);
	
	var _rcTabs2 = _interopRequireDefault(_rcTabs);
	
	var _ScrollableInkTabBar = __webpack_require__(1534);
	
	var _ScrollableInkTabBar2 = _interopRequireDefault(_ScrollableInkTabBar);
	
	var _TabContent = __webpack_require__(724);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isFlexSupported = __webpack_require__(1427);
	
	var _isFlexSupported2 = _interopRequireDefault(_isFlexSupported);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tabs = function (_React$Component) {
	    (0, _inherits3['default'])(Tabs, _React$Component);
	
	    function Tabs() {
	        (0, _classCallCheck3['default'])(this, Tabs);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
	
	        _this.createNewTab = function (targetKey) {
	            var onEdit = _this.props.onEdit;
	            if (onEdit) {
	                onEdit(targetKey, 'add');
	            }
	        };
	        _this.removeTab = function (targetKey, e) {
	            e.stopPropagation();
	            if (!targetKey) {
	                return;
	            }
	            var onEdit = _this.props.onEdit;
	            if (onEdit) {
	                onEdit(targetKey, 'remove');
	            }
	        };
	        _this.handleChange = function (activeKey) {
	            var onChange = _this.props.onChange;
	            if (onChange) {
	                onChange(activeKey);
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Tabs, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var NO_FLEX = ' no-flex';
	            var tabNode = ReactDOM.findDOMNode(this);
	            if (tabNode && !(0, _isFlexSupported2['default'])() && tabNode.className.indexOf(NO_FLEX) === -1) {
	                tabNode.className += NO_FLEX;
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this2 = this;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                size = _props.size,
	                _props$type = _props.type,
	                type = _props$type === undefined ? 'line' : _props$type,
	                tabPosition = _props.tabPosition,
	                children = _props.children,
	                tabBarExtraContent = _props.tabBarExtraContent,
	                tabBarStyle = _props.tabBarStyle,
	                hideAdd = _props.hideAdd,
	                onTabClick = _props.onTabClick,
	                onPrevClick = _props.onPrevClick,
	                onNextClick = _props.onNextClick,
	                _props$animated = _props.animated,
	                animated = _props$animated === undefined ? true : _props$animated;
	
	            var _ref = (typeof animated === 'undefined' ? 'undefined' : (0, _typeof3['default'])(animated)) === 'object' ? {
	                inkBarAnimated: animated.inkBar, tabPaneAnimated: animated.tabPane
	            } : {
	                inkBarAnimated: animated, tabPaneAnimated: animated
	            },
	                inkBarAnimated = _ref.inkBarAnimated,
	                tabPaneAnimated = _ref.tabPaneAnimated;
	            // card tabs should not have animation
	
	
	            if (type !== 'line') {
	                tabPaneAnimated = 'animated' in this.props ? tabPaneAnimated : false;
	            }
	            (0, _warning2['default'])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs[type=card|editable-card] doesn\'t have small or large size, it\'s by designed.');
	            var cls = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', tabPosition === 'left' || tabPosition === 'right'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, !!size), (0, _defineProperty3['default'])(_classNames, prefixCls + '-card', type.indexOf('card') >= 0), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-no-animation', !tabPaneAnimated), _classNames));
	            // only card type tabs can be added and closed
	            var childrenWithClose = [];
	            if (type === 'editable-card') {
	                childrenWithClose = [];
	                React.Children.forEach(children, function (child, index) {
	                    var closable = child.props.closable;
	                    closable = typeof closable === 'undefined' ? true : closable;
	                    var closeIcon = closable ? React.createElement(_icon2['default'], { type: 'close', onClick: function onClick(e) {
	                            return _this2.removeTab(child.key, e);
	                        } }) : null;
	                    childrenWithClose.push(React.cloneElement(child, {
	                        tab: React.createElement(
	                            'div',
	                            { className: closable ? undefined : prefixCls + '-tab-unclosable' },
	                            child.props.tab,
	                            closeIcon
	                        ),
	                        key: child.key || index
	                    }));
	                });
	                // Add new tab handler
	                if (!hideAdd) {
	                    tabBarExtraContent = React.createElement(
	                        'span',
	                        null,
	                        React.createElement(_icon2['default'], { type: 'plus', className: prefixCls + '-new-tab', onClick: this.createNewTab }),
	                        tabBarExtraContent
	                    );
	                }
	            }
	            tabBarExtraContent = tabBarExtraContent ? React.createElement(
	                'div',
	                { className: prefixCls + '-extra-content' },
	                tabBarExtraContent
	            ) : null;
	            var renderTabBar = function renderTabBar() {
	                return React.createElement(_ScrollableInkTabBar2['default'], { inkBarAnimated: inkBarAnimated, extraContent: tabBarExtraContent, onTabClick: onTabClick, onPrevClick: onPrevClick, onNextClick: onNextClick, style: tabBarStyle });
	            };
	            return React.createElement(
	                _rcTabs2['default'],
	                (0, _extends3['default'])({}, this.props, { className: cls, tabBarPosition: tabPosition, renderTabBar: renderTabBar, renderTabContent: function renderTabContent() {
	                        return React.createElement(_TabContent2['default'], { animated: tabPaneAnimated, animatedWithMargin: true });
	                    }, onChange: this.handleChange }),
	                childrenWithClose.length > 0 ? childrenWithClose : children
	            );
	        }
	    }]);
	    return Tabs;
	}(React.Component);
	
	exports['default'] = Tabs;
	
	Tabs.TabPane = _rcTabs.TabPane;
	Tabs.defaultProps = {
	    prefixCls: 'ant-tabs',
	    hideAdd: false
	};

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _moment = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(_moment);
	
	var _TimePicker = __webpack_require__(2619);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _en_US = __webpack_require__(387);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function generateShowHourMinuteSecond(format) {
	    // Ref: http://momentjs.com/docs/#/parsing/string-format/
	    return {
	        showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
	        showMinute: format.indexOf('m') > -1,
	        showSecond: format.indexOf('s') > -1
	    };
	}
	
	var TimePicker = function (_React$Component) {
	    (0, _inherits3['default'])(TimePicker, _React$Component);
	
	    function TimePicker(props) {
	        (0, _classCallCheck3['default'])(this, TimePicker);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));
	
	        _this.handleChange = function (value) {
	            if (!('value' in _this.props)) {
	                _this.setState({ value: value });
	            }
	            var _this$props = _this.props,
	                onChange = _this$props.onChange,
	                _this$props$format = _this$props.format,
	                format = _this$props$format === undefined ? 'HH:mm:ss' : _this$props$format;
	
	            if (onChange) {
	                onChange(value, value && value.format(format) || '');
	            }
	        };
	        _this.handleOpenClose = function (_ref) {
	            var open = _ref.open;
	            var onOpenChange = _this.props.onOpenChange;
	
	            if (onOpenChange) {
	                onOpenChange(open);
	            }
	        };
	        _this.saveTimePicker = function (timePickerRef) {
	            _this.timePickerRef = timePickerRef;
	        };
	        _this.renderTimePicker = function (locale) {
	            var props = (0, _extends3['default'])({}, _this.props);
	            delete props.defaultValue;
	            var format = _this.getDefaultFormat();
	            var className = (0, _classnames2['default'])(props.className, (0, _defineProperty3['default'])({}, props.prefixCls + '-' + props.size, !!props.size));
	            var addon = function addon(panel) {
	                return props.addon ? React.createElement(
	                    'div',
	                    { className: props.prefixCls + '-panel-addon' },
	                    props.addon(panel)
	                ) : null;
	            };
	            return React.createElement(_TimePicker2['default'], (0, _extends3['default'])({}, generateShowHourMinuteSecond(format), props, { ref: _this.saveTimePicker, format: format, className: className, value: _this.state.value, placeholder: props.placeholder === undefined ? locale.placeholder : props.placeholder, onChange: _this.handleChange, onOpen: _this.handleOpenClose, onClose: _this.handleOpenClose, addon: addon }));
	        };
	        var value = props.value || props.defaultValue;
	        if (value && !moment.isMoment(value)) {
	            throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
	        }
	        _this.state = {
	            value: value
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(TimePicker, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                this.setState({ value: nextProps.value });
	            }
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.timePickerRef.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.timePickerRef.blur();
	        }
	    }, {
	        key: 'getDefaultFormat',
	        value: function getDefaultFormat() {
	            var _props = this.props,
	                format = _props.format,
	                use12Hours = _props.use12Hours;
	
	            if (format) {
	                return format;
	            } else if (use12Hours) {
	                return 'h:mm:ss a';
	            }
	            return 'HH:mm:ss';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'TimePicker', defaultLocale: _en_US2['default'] },
	                this.renderTimePicker
	            );
	        }
	    }]);
	    return TimePicker;
	}(React.Component);
	
	exports['default'] = TimePicker;
	
	TimePicker.defaultProps = {
	    prefixCls: 'ant-time-picker',
	    align: {
	        offset: [0, -2]
	    },
	    disabled: false,
	    disabledHours: undefined,
	    disabledMinutes: undefined,
	    disabledSeconds: undefined,
	    hideDisabledOptions: false,
	    placement: 'bottomLeft',
	    transitionName: 'slide-up',
	    focusOnOpen: true
	};

/***/ },
/* 600 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var locale = {
	    placeholder: 'Seleccionar hora'
	};
	exports['default'] = locale;

/***/ },
/* 601 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var locale = {
	    placeholder: 'Sélectionner l\'heure'
	};
	exports['default'] = locale;

/***/ },
/* 602 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var locale = {
	    placeholder: 'Selezionare il tempo'
	};
	exports['default'] = locale;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _input = __webpack_require__(271);
	
	var _input2 = _interopRequireDefault(_input);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Search = function (_React$Component) {
	    (0, _inherits3['default'])(Search, _React$Component);
	
	    function Search() {
	        (0, _classCallCheck3['default'])(this, Search);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
	
	        _this.handleChange = function (e) {
	            var onChange = _this.props.onChange;
	            if (onChange) {
	                onChange(e);
	            }
	        };
	        _this.handleClear = function (e) {
	            e.preventDefault();
	            var handleClear = _this.props.handleClear;
	            if (handleClear) {
	                handleClear(e);
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Search, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                placeholder = _props.placeholder,
	                value = _props.value,
	                prefixCls = _props.prefixCls;
	
	            var icon = value && value.length > 0 ? React.createElement(
	                'a',
	                { href: '#', className: prefixCls + '-action', onClick: this.handleClear },
	                React.createElement(_icon2['default'], { type: 'cross-circle' })
	            ) : React.createElement(
	                'span',
	                { className: prefixCls + '-action' },
	                React.createElement(_icon2['default'], { type: 'search' })
	            );
	            return React.createElement(
	                'div',
	                null,
	                React.createElement(_input2['default'], { placeholder: placeholder, className: prefixCls, value: value, ref: 'input', onChange: this.handleChange }),
	                icon
	            );
	        }
	    }]);
	    return Search;
	}(React.Component);
	
	exports['default'] = Search;
	
	Search.defaultProps = {
	    placeholder: ''
	};

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcUpload = __webpack_require__(2634);
	
	var _rcUpload2 = _interopRequireDefault(_rcUpload);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _UploadList = __webpack_require__(1526);
	
	var _UploadList2 = _interopRequireDefault(_UploadList);
	
	var _utils = __webpack_require__(1528);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Upload = function (_React$Component) {
	    (0, _inherits3['default'])(Upload, _React$Component);
	
	    function Upload(props) {
	        (0, _classCallCheck3['default'])(this, Upload);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Upload.__proto__ || Object.getPrototypeOf(Upload)).call(this, props));
	
	        _this.onStart = function (file) {
	            var targetItem = void 0;
	            var nextFileList = _this.state.fileList.concat();
	            targetItem = (0, _utils.fileToObject)(file);
	            targetItem.status = 'uploading';
	            nextFileList.push(targetItem);
	            _this.onChange({
	                file: targetItem,
	                fileList: nextFileList
	            });
	            // fix ie progress
	            if (!window.FormData) {
	                _this.autoUpdateProgress(0, targetItem);
	            }
	        };
	        _this.onSuccess = function (response, file) {
	            _this.clearProgressTimer();
	            try {
	                if (typeof response === 'string') {
	                    response = JSON.parse(response);
	                }
	            } catch (e) {}
	            var fileList = _this.state.fileList;
	            var targetItem = (0, _utils.getFileItem)(file, fileList);
	            // removed
	            if (!targetItem) {
	                return;
	            }
	            targetItem.status = 'done';
	            targetItem.response = response;
	            _this.onChange({
	                file: (0, _extends3['default'])({}, targetItem),
	                fileList: fileList
	            });
	        };
	        _this.onProgress = function (e, file) {
	            var fileList = _this.state.fileList;
	            var targetItem = (0, _utils.getFileItem)(file, fileList);
	            // removed
	            if (!targetItem) {
	                return;
	            }
	            targetItem.percent = e.percent;
	            _this.onChange({
	                event: e,
	                file: (0, _extends3['default'])({}, targetItem),
	                fileList: _this.state.fileList
	            });
	        };
	        _this.onError = function (error, response, file) {
	            _this.clearProgressTimer();
	            var fileList = _this.state.fileList;
	            var targetItem = (0, _utils.getFileItem)(file, fileList);
	            // removed
	            if (!targetItem) {
	                return;
	            }
	            targetItem.error = error;
	            targetItem.response = response;
	            targetItem.status = 'error';
	            _this.onChange({
	                file: (0, _extends3['default'])({}, targetItem),
	                fileList: fileList
	            });
	        };
	        _this.handleManualRemove = function (file) {
	            _this.upload.abort(file);
	            file.status = 'removed'; // eslint-disable-line
	            _this.handleRemove(file);
	        };
	        _this.onChange = function (info) {
	            var updateState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	            if (!('fileList' in _this.props) && updateState) {
	                _this.setState({ fileList: info.fileList });
	            }
	            var onChange = _this.props.onChange;
	
	            if (onChange) {
	                onChange(info);
	            }
	        };
	        _this.onFileDrop = function (e) {
	            _this.setState({
	                dragState: e.type
	            });
	        };
	        _this.beforeUpload = function (file, fileList) {
	            if (!_this.props.beforeUpload) {
	                return true;
	            }
	            var result = _this.props.beforeUpload(file, fileList);
	            if (result === false) {
	                _this.onChange({
	                    file: file,
	                    fileList: fileList
	                }, false);
	                return false;
	            } else if (result && result.then) {
	                return result;
	            }
	            return true;
	        };
	        _this.saveUpload = function (node) {
	            _this.upload = node;
	        };
	        _this.renderUploadList = function (locale) {
	            var _this$props = _this.props,
	                showUploadList = _this$props.showUploadList,
	                listType = _this$props.listType,
	                onPreview = _this$props.onPreview;
	            var showRemoveIcon = showUploadList.showRemoveIcon,
	                showPreviewIcon = showUploadList.showPreviewIcon;
	
	            return React.createElement(_UploadList2['default'], { listType: listType, items: _this.state.fileList, onPreview: onPreview, onRemove: _this.handleManualRemove, showRemoveIcon: showRemoveIcon, showPreviewIcon: showPreviewIcon, locale: (0, _extends3['default'])({}, locale, _this.props.locale) });
	        };
	        _this.state = {
	            fileList: props.fileList || props.defaultFileList || [],
	            dragState: 'drop'
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Upload, [{
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.clearProgressTimer();
	        }
	    }, {
	        key: 'autoUpdateProgress',
	        value: function autoUpdateProgress(_, file) {
	            var _this2 = this;
	
	            var getPercent = (0, _utils.genPercentAdd)();
	            var curPercent = 0;
	            this.clearProgressTimer();
	            this.progressTimer = setInterval(function () {
	                curPercent = getPercent(curPercent);
	                _this2.onProgress({
	                    percent: curPercent
	                }, file);
	            }, 200);
	        }
	    }, {
	        key: 'handleRemove',
	        value: function handleRemove(file) {
	            var _this3 = this;
	
	            var onRemove = this.props.onRemove;
	
	            Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
	                // Prevent removing file
	                if (ret === false) {
	                    return;
	                }
	                var removedFileList = (0, _utils.removeFileItem)(file, _this3.state.fileList);
	                if (removedFileList) {
	                    _this3.onChange({
	                        file: file,
	                        fileList: removedFileList
	                    });
	                }
	            });
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('fileList' in nextProps) {
	                this.setState({
	                    fileList: nextProps.fileList || []
	                });
	            }
	        }
	    }, {
	        key: 'clearProgressTimer',
	        value: function clearProgressTimer() {
	            clearInterval(this.progressTimer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames2;
	
	            var _props = this.props,
	                _props$prefixCls = _props.prefixCls,
	                prefixCls = _props$prefixCls === undefined ? '' : _props$prefixCls,
	                className = _props.className,
	                showUploadList = _props.showUploadList,
	                listType = _props.listType,
	                type = _props.type,
	                disabled = _props.disabled,
	                children = _props.children;
	
	            var rcUploadProps = (0, _extends3['default'])({ onStart: this.onStart, onError: this.onError, onProgress: this.onProgress, onSuccess: this.onSuccess }, this.props, { beforeUpload: this.beforeUpload });
	            delete rcUploadProps.className;
	            var uploadList = showUploadList ? React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Upload', defaultLocale: _default2['default'].Upload },
	                this.renderUploadList
	            ) : null;
	            if (type === 'drag') {
	                var _classNames;
	
	                var dragCls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag-uploading', this.state.fileList.some(function (file) {
	                    return file.status === 'uploading';
	                })), (0, _defineProperty3['default'])(_classNames, prefixCls + '-drag-hover', this.state.dragState === 'dragover'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
	                return React.createElement(
	                    'span',
	                    { className: className },
	                    React.createElement(
	                        'div',
	                        { className: dragCls, onDrop: this.onFileDrop, onDragOver: this.onFileDrop, onDragLeave: this.onFileDrop },
	                        React.createElement(
	                            _rcUpload2['default'],
	                            (0, _extends3['default'])({}, rcUploadProps, { ref: this.saveUpload, className: prefixCls + '-btn' }),
	                            React.createElement(
	                                'div',
	                                { className: prefixCls + '-drag-container' },
	                                children
	                            )
	                        )
	                    ),
	                    uploadList
	                );
	            }
	            var uploadButtonCls = (0, _classnames2['default'])(prefixCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-select', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-select-' + listType, true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-disabled', disabled), _classNames2));
	            var uploadButton = React.createElement(
	                'div',
	                { className: uploadButtonCls, style: { display: children ? '' : 'none' } },
	                React.createElement(_rcUpload2['default'], (0, _extends3['default'])({}, rcUploadProps, { ref: this.saveUpload }))
	            );
	            if (listType === 'picture-card') {
	                return React.createElement(
	                    'span',
	                    { className: className },
	                    uploadList,
	                    uploadButton
	                );
	            }
	            return React.createElement(
	                'span',
	                { className: className },
	                uploadButton,
	                uploadList
	            );
	        }
	    }]);
	    return Upload;
	}(React.Component);
	
	exports['default'] = Upload;
	
	Upload.defaultProps = {
	    prefixCls: 'ant-upload',
	    type: 'select',
	    multiple: false,
	    action: '',
	    data: {},
	    accept: '',
	    beforeUpload: _utils.T,
	    showUploadList: true,
	    listType: 'text',
	    className: '',
	    disabled: false,
	    supportServerRender: true
	};

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        ss : '%d sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        ss : '%d ثانية',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        ss : '%d ثانية',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        ss : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        ss : '%d saniyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        ss : 'sekondi %d',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        ss : '%d সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        ss : '%d སྐར་ཆ།',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        ss : '%d eilenn',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        ss : '%d segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        ss : '%d ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        ss: '%d eiliad',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        ss : '%d sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        ss : '%d Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        ss : 'd% ސިކުންތު',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        ss : '%d δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        ss : '%d seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        ss : '%d sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY h:mm A',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'ss': [number + 'sekundi', number + 'sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        ss : '%d segundo',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        ss : 'ثانیه d%',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'ss':
	            return isFuture ? 'sekunnin' : 'sekuntia';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        ss : '%d sekundir',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        ss : '%d secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        ss : '%d sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        ss : '%d diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        ss : '%d segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'ss': [number + ' secondanim', number + ' second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        ss: '%d સેકંડ',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        ss : '%d שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        ss : '%d सेकंड',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            if (number === 1) {
	                result += 'sekunda';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sekunde';
	            } else {
	                result += 'sekundi';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        ss     : translate,
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'ss':
	            return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        ss : '%d վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        ss : '%d detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'ss':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	            }
	            return result + 'sekúnda';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        ss : '%d secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        ss : '%d秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        ss : '%d detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        ss : '%d წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        ss : '%d секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        ss: '%d វិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        ss : '%d ಸೆಕೆಂಡುಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 667 */
[3334, 9],
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        ss : '%d секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        ss : '%d Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        ss : '%d ວິນາທີ' ,
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss' : 'sekundė_sekundžių_sekundes',
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        ss : translate,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekund', 'sekunda', 'sekundi'],
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        ss: '%d hēkona',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        ss : '%d секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        ss : '%d സെക്കൻഡ്',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'ss': output = '%d सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'ss': output = '%d सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        ss: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        ss : '%d saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mt = moment.defineLocale('mt', {
	    months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	    monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	    weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	    weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	    weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Illum fil-]LT',
	        nextDay : '[Għada fil-]LT',
	        nextWeek : 'dddd [fil-]LT',
	        lastDay : '[Il-bieraħ fil-]LT',
	        lastWeek : 'dddd [li għadda] [fil-]LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'f’ %s',
	        past : '%s ilu',
	        s : 'ftit sekondi',
	        ss : '%d sekondi',
	        m : 'minuta',
	        mm : '%d minuti',
	        h : 'siegħa',
	        hh : '%d siegħat',
	        d : 'ġurnata',
	        dd : '%d ġranet',
	        M : 'xahar',
	        MM : '%d xhur',
	        y : 'sena',
	        yy : '%d sni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mt;
	
	})));


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        ss : '%d စက္ကန့်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        ss : '%d sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        ss : '%d सेकेण्ड',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        ss : '%d seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        ss : '%d sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        ss : '%d ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'ss':
	            return result + (plural(number) ? 'sekundy' : 'sekund');
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 689 */
[3335, 9],
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'ss': 'secunde',
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        ss : relativeTimeWithPlural,
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., H:mm',
	        LLLL : 'dddd, D MMMM YYYY г., H:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        ss : '%d سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        ss: '%d sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        ss : 'තත්පර %d',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'sekundy' : 'sekúnd');
	            } else {
	                return result + 'sekundami';
	            }
	            break;
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        ss : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'ss':
	            if (number === 1) {
	                result += withoutSuffix ? 'sekundo' : 'sekundi';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	            } else {
	                result += withoutSuffix || isFuture ? 'sekund' : 'sekund';
	            }
	            return result;
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        ss     : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        ss : '%d sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['секунда', 'секунде', 'секунди'],
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        ss: ['sekunda', 'sekunde', 'sekundi'],
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        ss     : translator.translate,
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        ss : '%d mzuzwana',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        ss : '%d sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        ss : 'sekunde %d',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        ss : '%d விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        ss : '%d సెకన్లు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        ss : 'minutu %d',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        ss : '%d วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        ss : '%d segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'ss':
	            return numberNoun + ' lup';
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        ss : translate,
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        ss : '%d saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        ss : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'ss': [number + ' secunds', '' + number + ' secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        ss : '%d imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        ss : '%d ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        ss : relativeTimeWithPlural,
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        ss : '%d سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        ss : '%d soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        ss : '%d фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        ss : '%d giây' ,
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        ss : '%d s~écóñ~ds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        ss :'aayá %d',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah点mm分',
	        LLLL : 'YYYY年M月D日ddddAh点mm分',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        ss : '%d 秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(9)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日dddd HH:mm',
	        l : 'YYYY/M/D',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        ss : '%d 秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 724 */
[3338, 171],
/* 725 */
[3339, 171],
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(44);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	
	var RequestBuilder = __webpack_require__(273);
	var qs = __webpack_require__(236);
	var objectHelper = __webpack_require__(76);
	var assert = __webpack_require__(117);
	var responseHandler = __webpack_require__(172);
	var parametersWhitelist = __webpack_require__(1567);
	var Warn = __webpack_require__(274);
	
	var PasswordlessAuthentication = __webpack_require__(1564);
	var DBConnection = __webpack_require__(1563);
	
	/**
	 * Creates a new Auth0 Authentication API client
	 * @constructor
	 * @param {Object} options
	 * @param {String} options.domain your Auth0 domain
	 * @param {String} options.clientID your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @see {@link https://auth0.com/docs/api/authentication}
	 */
	function Authentication(options) {
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      domain: { type: 'string', message: 'domain option is required' },
	      clientID: { type: 'string', message: 'clientID option is required' },
	      responseType: { optional: true, type: 'string', message: 'responseType is not valid' },
	      responseMode: { optional: true, type: 'string', message: 'responseMode is not valid' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri is not valid' },
	      scope: { optional: true, type: 'string', message: 'scope is not valid' },
	      audience: { optional: true, type: 'string', message: 'audience is not valid' },
	      _disableDeprecationWarnings: {
	        optional: true,
	        type: 'boolean',
	        message: '_disableDeprecationWarnings option is not valid'
	      },
	      _sendTelemetry: {
	        optional: true,
	        type: 'boolean',
	        message: '_sendTelemetry option is not valid'
	      },
	      _telemetryInfo: {
	        optional: true,
	        type: 'object',
	        message: '_telemetryInfo option is not valid'
	      }
	    }
	  );
	  /* eslint-enable */
	
	  this.baseOptions = options;
	
	  this.baseOptions._sendTelemetry = this.baseOptions._sendTelemetry === false
	    ? this.baseOptions._sendTelemetry
	    : true;
	
	  this.baseOptions.rootUrl = 'https://' + this.baseOptions.domain;
	
	  this.request = new RequestBuilder(this.baseOptions);
	
	  this.passwordless = new PasswordlessAuthentication(this.request, this.baseOptions);
	  this.dbConnection = new DBConnection(this.request, this.baseOptions);
	
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * Builds and returns the `/authorize` url in order to initialize a new authN/authZ transaction
	 *
	 * @method buildAuthorizeUrl
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 * @see {@link https://auth0.com/docs/api/authentication#social}
	 */
	Authentication.prototype.buildAuthorizeUrl = function(options) {
	  var params;
	  var qString;
	
	  assert.check(options, { type: 'object', message: 'options parameter is not valid' });
	
	  params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience'
	    ])
	    .with(options);
	
	  /* eslint-disable */
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      clientID: { type: 'string', message: 'clientID option is required' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri option is required' },
	      responseType: { type: 'string', message: 'responseType option is required' },
	      nonce: {
	        type: 'string',
	        message: 'nonce option is required',
	        condition: function(o) {
	          return o.responseType.indexOf('code') === -1 && o.responseType.indexOf('id_token') !== -1;
	        }
	      },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	  /* eslint-enable */
	
	  // eslint-disable-next-line
	  if (this.baseOptions._sendTelemetry) {
	    params.auth0Client = this.request.getTelemetryData();
	  }
	
	  if (params.connection_scope && assert.isArray(params.connection_scope)) {
	    params.connection_scope = params.connection_scope.join(',');
	  }
	
	  params = objectHelper.toSnakeCase(params, ['auth0Client']);
	  params = parametersWhitelist.oauthAuthorizeParams(this.warn, params);
	
	  qString = qs.stringify(params);
	
	  return urljoin(this.baseOptions.rootUrl, 'authorize', '?' + qString);
	};
	
	/**
	 * Builds and returns the Logout url in order to initialize a new authN/authZ transaction
	 *
	 * If you want to navigate the user to a specific URL after the logout, set that URL at the returnTo parameter. The URL should be included in any the appropriate Allowed Logout URLs list:
	 *
	 * - If the client_id parameter is included, the returnTo URL must be listed in the Allowed Logout URLs set at the client level (see Setting Allowed Logout URLs at the App Level).
	 * - If the client_id parameter is NOT included, the returnTo URL must be listed in the Allowed Logout URLs set at the account level (see Setting Allowed Logout URLs at the Account Level).
	 * @method buildLogoutUrl
	 * @param {Object} options
	 * @param {String} [options.clientID] identifier of your client
	 * @param {String} [options.returnTo] URL to be redirected after the logout
	 * @param {Boolean} [options.federated] tells Auth0 if it should logout the user also from the IdP.
	 * @see {@link https://auth0.com/docs/api/authentication#logout}
	 */
	Authentication.prototype.buildLogoutUrl = function(options) {
	  var params;
	  var qString;
	
	  assert.check(options, {
	    optional: true,
	    type: 'object',
	    message: 'options parameter is not valid'
	  });
	
	  params = objectHelper.merge(this.baseOptions, ['clientID']).with(options || {});
	
	  // eslint-disable-next-line
	  if (this.baseOptions._sendTelemetry) {
	    params.auth0Client = this.request.getTelemetryData();
	  }
	
	  params = objectHelper.toSnakeCase(params, ['auth0Client', 'returnTo']);
	
	  qString = qs.stringify(params);
	
	  return urljoin(this.baseOptions.rootUrl, 'v2', 'logout', '?' + qString);
	};
	
	/**
	 * @callback authorizeCallback
	 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
	 * @param {Object} [result] result of the Auth request
	 * @param {String} [result.accessToken] token that allows access to the specified resource server (identified by the audience parameter or by default Auth0's /userinfo endpoint)
	 * @param {Number} [result.expiresIn] number of seconds until the access token expires
	 * @param {String} [result.idToken] token that identifies the user
	 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all clients can request them or the resource server might not allow them.
	 */
	
	/**
	 * @callback tokenCallback
	 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
	 * @param {Object} [result] result of the Auth request
	 * @param {String} result.accessToken token that allows access to the specified resource server (identified by the audience parameter or by default Auth0's /userinfo endpoint)
	 * @param {Number} result.expiresIn number of seconds until the access token expires
	 * @param {String} [result.idToken] token that identifies the user
	 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all clients can request them or the resource server might not allow them.
	 */
	
	/**
	 * Makes a call to the `oauth/token` endpoint with `password` grant type to login to the default directory.
	 *
	 * @method loginWithDefaultDirectory
	 * @param {Object} options
	 * @param {String} options.username email or username of the user that will perform Auth
	 * @param {String} options.password the password of the user that will perform Auth
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {tokenCallback} cb function called with the result of the request
	 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
	 */
	Authentication.prototype.loginWithDefaultDirectory = function(options, cb) {
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      username: { type: 'string', message: 'username option is required' },
	      password: { type: 'string', message: 'password option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	
	  options.grantType = 'password';
	
	  return this.oauthToken(options, cb);
	};
	
	/**
	 * Makes a call to the `oauth/token` endpoint with `password-realm` grant type
	 *
	 * @method login
	 * @param {Object} options
	 * @param {String} options.username email or username of the user that will perform Auth
	 * @param {String} options.password the password of the user that will perform Auth
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {Object} options.realm the HRD domain or the connection name where the user belongs to. e.g. `Username-Password-Authentication`
	 * @param {tokenCallback} cb function called with the result of the request
	 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
	 */
	Authentication.prototype.login = function(options, cb) {
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      username: { type: 'string', message: 'username option is required' },
	      password: { type: 'string', message: 'password option is required' },
	      realm: { type: 'string', message: 'realm option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	
	  options.grantType = 'http://auth0.com/oauth/grant-type/password-realm';
	
	  return this.oauthToken(options, cb);
	};
	
	/**
	 * Makes a call to the `oauth/token` endpoint
	 *
	 * @method oauthToken
	 * @private
	 */
	Authentication.prototype.oauthToken = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(options, { type: 'object', message: 'options parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'oauth', 'token');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID', 'scope', 'audience']).with(options);
	
	  assert.check(
	    body,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      clientID: { type: 'string', message: 'clientID option is required' },
	      grantType: { type: 'string', message: 'grantType option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	  body = parametersWhitelist.oauthTokenParams(this.warn, body);
	
	  body.grant_type = body.grant_type;
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * Performs authentication calling `/oauth/ro` endpoint with username
	 * and password for a given connection name.
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link login} or {@link loginWithDefaultDirectory}.
	 *
	 * @method loginWithResourceOwner
	 * @param {Object} options
	 * @param {String} options.username email or username of the user that will perform Auth
	 * @param {String} options.password the password of the user that will perform Auth
	 * @param {Object} options.connection the connection name where the user belongs to. e.g. `Username-Password-Authentication`
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.device] name of the device/browser where the Auth was requested
	 * @param {tokenCallback} cb function called with the result of the request
	 */
	Authentication.prototype.loginWithResourceOwner = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      username: { type: 'string', message: 'username option is required' },
	      password: { type: 'string', message: 'password option is required' },
	      connection: { type: 'string', message: 'connection option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'oauth', 'ro');
	
	  body = objectHelper
	    .merge(this.baseOptions, ['clientID', 'scope'])
	    .with(options, ['username', 'password', 'scope', 'connection', 'device']);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  body.grant_type = body.grant_type || 'password';
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * Makes a call to the `/ssodata` endpoint.
	 * We recommend to avoid using this method and rely on your tenant hosted login page and using prompt=none via {@link renewAuth} method.
	 *
	 * @method getSSOData
	 * @param {Boolean} withActiveDirectories tells Auth0 to return AD data
	 * @param {Function} cb
	 */
	Authentication.prototype.getSSOData = function(withActiveDirectories, cb) {
	  var url;
	  var params = '';
	
	  if (typeof withActiveDirectories === 'function') {
	    cb = withActiveDirectories;
	    withActiveDirectories = false;
	  }
	
	  assert.check(withActiveDirectories, {
	    type: 'boolean',
	    message: 'withActiveDirectories parameter is not valid'
	  });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  if (withActiveDirectories) {
	    params =
	      '?' +
	      qs.stringify({
	        ldaps: 1,
	        client_id: this.baseOptions.clientID
	      });
	  }
	
	  url = urljoin(this.baseOptions.rootUrl, 'user', 'ssodata', params);
	
	  return this.request.get(url, { noHeaders: true }).withCredentials().end(responseHandler(cb));
	};
	
	/**
	 * @callback userInfoCallback
	 * @param {Error} [err] error returned by Auth0
	 * @param {Object} [userInfo] user information
	 */
	
	/**
	 * Makes a call to the `/userinfo` endpoint and returns the user profile
	 *
	 * @method userInfo
	 * @param {String} accessToken token issued to a user after Auth
	 * @param {userInfoCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#get-user-info}
	 */
	Authentication.prototype.userInfo = function(accessToken, cb) {
	  var url;
	
	  assert.check(accessToken, { type: 'string', message: 'accessToken parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'userinfo');
	
	  return this.request
	    .get(url)
	    .set('Authorization', 'Bearer ' + accessToken)
	    .end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	/**
	 * @callback delegationCallback
	 * @param {Error} [err] error returned by Auth0 with the reason why the delegation failed
	 * @param {Object} [result] result of the delegation request. The payload depends on what ai type was used
	 */
	
	/**
	 * Makes a call to the `/delegation` endpoint with either an `id_token` or `refresh_token`
	 *
	 * @method delegation
	 * @param {Object} options
	 * @param {String} [options.clientID] client identifier
	 * @param {String} options.grantType  grant type used for delegation. The only valid value is `urn:ietf:params:oauth:grant-type:jwt-bearer`
	 * @param {String} [options.idToken] valid token of the user issued after Auth. If no `refresh_token` is provided this parameter is required
	 * @param {String} [options.refreshToken] valid refresh token of the user issued after Auth. If no `id_token` is provided this parameter is required
	 * @param {String} [options.target] the target client id of the delegation
	 * @param {String} [options.scope] either `openid` or `openid profile email`
	 * @param {String} [options.apiType] the api to be called
	 * @param {delegationCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#delegation}
	 */
	Authentication.prototype.delegation = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      grant_type: { type: 'string', message: 'grant_type option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'delegation');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID']).with(options);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * Fetches the user country based on the ip.
	 *
	 * @method getUserCountry
	 * @private
	 * @param {Function} cb
	 */
	Authentication.prototype.getUserCountry = function(cb) {
	  var url;
	
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'user', 'geoloc', 'country');
	
	  return this.request.get(url).end(responseHandler(cb));
	};
	
	module.exports = Authentication;


/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	var base64 = __webpack_require__(414);
	
	function padding(str) {
	  var mod = str.length % 4;
	  var pad = 4 - mod;
	
	  if (mod === 0) {
	    return str;
	  }
	
	  return str + new Array(1 + pad).join('=');
	}
	
	function stringToByteArray(str) {
	  var arr = new Array(str.length);
	  for (var a = 0; a < str.length; a++) {
	    arr[a] = str.charCodeAt(a);
	  }
	  return arr;
	}
	
	function byteArrayToString(array) {
	  var result = '';
	  for (var i = 0; i < array.length; i++) {
	    result += String.fromCharCode(array[i]);
	  }
	  return result;
	}
	
	function encode(str) {
	  return base64
	    .fromByteArray(stringToByteArray(str))
	    .replace(/\+/g, '-') // Convert '+' to '-'
	    .replace(/\//g, '_'); // Convert '/' to '_'
	}
	
	function decode(str) {
	  str = padding(str)
	    .replace(/-/g, '+') // Convert '-' to '+'
	    .replace(/_/g, '/'); // Convert '_' to '/'
	
	  return byteArrayToString(base64.toByteArray(str));
	}
	
	module.exports = {
	  encode: encode,
	  decode: decode
	};


/***/ },
/* 729 */
/***/ function(module, exports) {

	function buildResponse(error, description) {
	  return {
	    error: error,
	    errorDescription: description
	  };
	}
	
	function invalidJwt(description) {
	  return buildResponse('invalid_token', description);
	}
	
	module.exports = {
	  buildResponse: buildResponse,
	  invalidJwt: invalidJwt
	};


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	var windowHelper = __webpack_require__(105);
	
	function IframeHandler(options) {
	  this.url = options.url;
	  this.callback = options.callback;
	  this.timeout = options.timeout || 60 * 1000;
	  this.timeoutCallback = options.timeoutCallback || null;
	  this.eventListenerType = options.eventListenerType || 'message';
	  this.iframe = null;
	  this.timeoutHandle = null;
	  this._destroyTimeout = null;
	  this.transientMessageEventListener = null;
	  this.proxyEventListener = null;
	  // If no event identifier specified, set default
	  this.eventValidator = options.eventValidator || {
	    isValid: function() {
	      return true;
	    }
	  };
	
	  if (typeof this.callback !== 'function') {
	    throw new Error('options.callback must be a function');
	  }
	}
	
	IframeHandler.prototype.init = function() {
	  var _this = this;
	  var _window = windowHelper.getWindow();
	
	  this.iframe = _window.document.createElement('iframe');
	  this.iframe.style.display = 'none';
	
	  // Workaround to avoid using bind that does not work in IE8
	  this.proxyEventListener = function(e) {
	    _this.eventListener(e);
	  };
	
	  switch (this.eventListenerType) {
	    case 'message':
	      this.eventSourceObject = _window;
	      break;
	    case 'load':
	      this.eventSourceObject = this.iframe;
	      break;
	    default:
	      throw new Error('Unsupported event listener type: ' + this.eventListenerType);
	  }
	
	  this.eventSourceObject.addEventListener(this.eventListenerType, this.proxyEventListener, false);
	
	  _window.document.body.appendChild(this.iframe);
	  this.iframe.src = this.url;
	
	  this.timeoutHandle = setTimeout(function() {
	    _this.timeoutHandler();
	  }, this.timeout);
	};
	
	IframeHandler.prototype.eventListener = function(event) {
	  var eventData = { event: event, sourceObject: this.eventSourceObject };
	
	  if (!this.eventValidator.isValid(eventData)) {
	    return;
	  }
	
	  this.destroy();
	  this.callback(eventData);
	};
	
	IframeHandler.prototype.timeoutHandler = function() {
	  this.destroy();
	  if (this.timeoutCallback) {
	    this.timeoutCallback();
	  }
	};
	
	IframeHandler.prototype.destroy = function() {
	  var _this = this;
	  var _window = windowHelper.getWindow();
	
	  clearTimeout(this.timeoutHandle);
	
	  this._destroyTimeout = setTimeout(function() {
	    _this.eventSourceObject.removeEventListener(
	      _this.eventListenerType,
	      _this.proxyEventListener,
	      false
	    );
	    _window.document.body.removeChild(_this.iframe);
	  }, 0);
	};
	
	module.exports = IframeHandler;


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	var settle = __webpack_require__(1591);
	var buildURL = __webpack_require__(1594);
	var parseHeaders = __webpack_require__(1600);
	var isURLSameOrigin = __webpack_require__(1598);
	var createError = __webpack_require__(734);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1593);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(1596);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ },
/* 732 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(1590);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ },
/* 735 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	var CircularProgressBar = function (_React$Component) {
	    _inherits(CircularProgressBar, _React$Component);
	
	    function CircularProgressBar(props) {
	        _classCallCheck(this, CircularProgressBar);
	
	        var _this = _possibleConstructorReturn(this, (CircularProgressBar.__proto__ || Object.getPrototypeOf(CircularProgressBar)).call(this, props));
	
	        _this.ArcWidth = props.arcWidth;
	        _this.ArcData = props.arcData;
	
	        _this.StrokeWidth = props.strokeWidth;
	        _this.StrokeColor = props.strokeColor;
	
	        _this.Percent = props.percentage;
	        _this.TextData = null;
	
	        _this.CanvasWidth = _this.ArcWidth + _this.StrokeWidth / 2 + 10;
	
	        _this.ArcData.push({
	            percentage: _this.Percent / 100,
	            strokeColor: _this.StrokeColor
	        });
	        if (props.textData) {
	            _this.TextData = {
	                TextColor: props.textData.fontColor || "#000000",
	                FontSize: props.textData.fontSize || "16px"
	            };
	        }
	        return _this;
	    }
	
	    _createClass(CircularProgressBar, [{
	        key: '_drawArc',
	        value: function _drawArc(ctx, percentage, strokeWidth, strokeColor) {
	            var starting = Math.PI * 1.5;
	            var ending = Math.PI * (1.5 + 2 * percentage);
	
	            ctx.beginPath();
	            ctx.arc(this.CanvasWidth / 2, this.CanvasWidth / 2, this.ArcWidth / 2 - 0.5, starting, ending);
	            ctx.lineWidth = strokeWidth;
	            ctx.strokeStyle = strokeColor;
	            ctx.stroke();
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this._updateCanvas();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this._updateCanvas();
	        }
	    }, {
	        key: '_updateCanvas',
	        value: function _updateCanvas() {
	            var _this2 = this;
	
	            var ctx = this.refs.canvas.getContext('2d');
	            ctx.clearRect(0, 0, this.CanvasWidth, this.CanvasWidth);
	            this.ArcData.map(function (data) {
	                return _this2._drawArc(ctx, data.percentage, _this2.StrokeWidth, data.strokeColor);
	            });
	
	            if (this.TextData) {
	                ctx.fillStyle = this.TextData.TextColor;
	                ctx.font = this.TextData.FontSize + ' Roboto';
	                ctx.textBaseline = 'middle';
	                ctx.textAlign = "center";
	                ctx.fillText(this.Percent + '%', this.CanvasWidth / 2, this.CanvasWidth / 2);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('canvas', { ref: 'canvas', width: this.CanvasWidth, height: this.CanvasWidth });
	        }
	    }]);
	
	    return CircularProgressBar;
	}(_react2.default.Component);
	
	CircularProgressBar.propTypes = {
	    arcWidth: _propTypes2.default.number.isRequired,
	    arcData: _propTypes2.default.arrayOf(_propTypes2.default.any).isRequired,
	    strokeWidth: _propTypes2.default.number.isRequired,
	    strokeColor: _propTypes2.default.string.isRequired,
	    percentage: _propTypes2.default.number.isRequired,
	    textData: _propTypes2.default.object
	};
	
	exports.default = CircularProgressBar;

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppInfo = function (_React$Component) {
	    _inherits(AppInfo, _React$Component);
	
	    function AppInfo() {
	        _classCallCheck(this, AppInfo);
	
	        return _possibleConstructorReturn(this, (AppInfo.__proto__ || Object.getPrototypeOf(AppInfo)).apply(this, arguments));
	    }
	
	    _createClass(AppInfo, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement('div', { className: 'fill ' + this.props.className });
	        }
	    }]);
	
	    return AppInfo;
	}(_react2.default.Component);
	
	exports.default = AppInfo;
	;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _button = __webpack_require__(394);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _Wrapper = __webpack_require__(1612);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _gogochart_greenlogo = __webpack_require__(1416);
	
	var _gogochart_greenlogo2 = _interopRequireDefault(_gogochart_greenlogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// -- React Libraries
	
	
	// -- Styles
	
	
	// -- Resources
	
	
	var LoginButton = function (_React$Component) {
	    _inherits(LoginButton, _React$Component);
	
	    function LoginButton() {
	        _classCallCheck(this, LoginButton);
	
	        return _possibleConstructorReturn(this, (LoginButton.__proto__ || Object.getPrototypeOf(LoginButton)).apply(this, arguments));
	    }
	
	    _createClass(LoginButton, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                null,
	                _react2.default.createElement(
	                    _button2.default,
	                    { onClick: function onClick() {
	                            return _this2.props.history.push('/home');
	                        }, className: 'sign-in' },
	                    this.props.children
	                )
	            );
	        }
	    }]);
	
	    return LoginButton;
	}(_react2.default.Component);
	
	exports.default = LoginButton;
	;

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CheckboxGroup = undefined;
	
	var _antd = __webpack_require__(43);
	
	var _checkbox = __webpack_require__(1626);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkbox = (0, _checkbox2.default)(_antd.Checkbox);
	var CheckboxGroup = _antd.Checkbox.Group;
	
	exports.default = checkbox;
	exports.CheckboxGroup = CheckboxGroup;

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _themedefault = __webpack_require__(741);
	
	var _themedefault2 = _interopRequireDefault(_themedefault);
	
	var _theme = __webpack_require__(1642);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var themes = {
	  themedefault: _themedefault2.default,
	  theme2: _theme2.default
	};
	exports.default = themes;

/***/ },
/* 741 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var theme = {};
	
	theme.palette = {
	  primary: ['#4482FF', // 0: Default
	  '#3A78F5', // 1: Darken 4%
	  '#3775F2', // 2: Darken 5%
	  'rgba(68, 130, 255, 0.2)', // 3: Fade 20%
	  '#4C8AFF', // 4: Lighten 3%
	  'rgba(68, 130, 255, 0.75)', // 5: Fade 75%
	  '#6AA8FF', // 6: Lighten 15%
	  '#63A1FF', // 7: Lighten 12%
	  '#3F7DFA', // 8: Darken 2%
	  '#3369e7', // 9: Algolia color
	  '#5896FF', // 10: Lighten 8%
	  '#2b69e6', // 11:
	  '#236cfe', // 12: darken 10%
	  '#4d88ff'],
	  secondary: ['#2d3446', // 0: DarkBlue
	  '#f1f3f6', // 1: LightBluish
	  '#788195', // 2: LightBlue
	  '#E4E6E9', // 3: LightBluish Darken 5%
	  '#364d79', // 4:
	  '#202739', // 5: DarkBlue Darken 5%
	  '#f5f6f8', // 6: LighterBluish
	  '#e9ebf1', // 7: DarkBluish
	  '#F6F8FB', // 8: LighterBluish Lighten 2%
	  '#E9EBEE', // 9: LighterBluish Darken 3%
	  '#1a1a1a'],
	  color: ['#FEAC01', // 0: Orange
	  '#42299a', // 1: Purple
	  '#F75D81', // 2: Pink
	  '#7ED321', // 3: LimeGreen
	  '#39435f', // 4: BlueShade
	  '#FFCA28', // 5: Yellow
	  '#F2BD1B', // 6: Yellow Darken 5%
	  '#3b5998', // 7: Facebook
	  '#344e86', // 8: Facebook Darken 5%
	  '#dd4b39', // 9: Google Plus
	  '#d73925', // 10: Google Plus Darken 5%
	  '#e14615', // 11: Auth0
	  '#ca3f13', // 12: Auth0
	  '#e0364c'],
	  warning: ['#ffbf00'],
	  success: ['#00b16a'],
	  error: ['#f64744', // 0: Error
	  '#EC3D3A', // 1: Darken 4%
	  '#FF5B58'],
	  grayscale: ['#bababa', // 0: GreyShade
	  '#c1c1c1', // 1: GreyDark
	  '#D8D8D8', // 2: Grey
	  '#f1f1f1', // 3: GreyAlt
	  '#F3F3F3', // 4: GreyLight
	  '#fafafa', // 5: DarkWhite
	  '#F9F9F9', // 6: DarkerWhite
	  '#fcfcfc', // 7: #fff Darken 1%
	  '#eeeeee', // 8:
	  '#fbfbfb', // 9:
	  '#f5f5f5', // 10:
	  '#f7f8f9'],
	  text: ['#323332', // 0: Heading
	  '#595959', // 1: HeadingLight
	  '#979797', // 2: Text
	  '#797979', // 3: TextDark
	  '#6a6c6a'],
	  border: ['#e9e9e9', // 0: Border
	  '#d8d8d8', // 1: BorderDark
	  '#ebebeb', // 2: BorderLight
	  '#d3d3d3', // 3:
	  'rgba(228, 228, 228, 0.65)'],
	
	  calendar: ['#905', // 0:
	  '#690', // 1:
	  '#a67f59', // 2:
	  '#07a', // 3:
	  '#dd4a68', // 4:
	  '#e90']
	};
	
	theme.fonts = {
	  primary: 'Roboto, sans-serif',
	  pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace'
	};
	
	exports.default = theme;

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STRIPE_PUBLISHABLE =  false ? 'pk_live_pm1Cwv134bfnK41GjqKCD78h' : 'pk_test_zUQdZfb8NC1P6FgKnWP4Q5N3';
	
	exports.default = STRIPE_PUBLISHABLE;

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _index = __webpack_require__(281);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(280);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _Wrapper = __webpack_require__(1659);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var GridAppName = function (_React$Component) {
	    _inherits(GridAppName, _React$Component);
	
	    function GridAppName(props) {
	        _classCallCheck(this, GridAppName);
	
	        var _this = _possibleConstructorReturn(this, (GridAppName.__proto__ || Object.getPrototypeOf(GridAppName)).call(this, props));
	
	        _this.appName = props.data.name;
	
	        _this.isFormatOk = props.data.isFormatOk;
	        _this.isBrandOk = props.data.isBrandOk;
	        _this.isLengthOk = props.data.isLengthOk;
	
	        _this.brandLength = props.data.brandLength;
	        _this.nameLength = props.data.nameLength;
	        return _this;
	    }
	
	    _createClass(GridAppName, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'grid-score-summaries' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary-title' },
	                    '\u5E94\u7528\u540D\u79F0: ',
	                    this.appName
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'grid-container' },
	                    _react2.default.createElement(_index2.default, { ok: this.isFormatOk, title: '\u683C\u5F0F' }),
	                    _react2.default.createElement(
	                        _index2.default,
	                        { ok: this.isBrandOk, title: '\u54C1\u724C\u540D\u79F0' },
	                        this.brandLength,
	                        '\u4E2A\u5B57\u5143'
	                    ),
	                    _react2.default.createElement(
	                        _index2.default,
	                        { ok: this.isLengthOk, title: '\u957F\u5EA6 ' },
	                        this.nameLength,
	                        '\u4E2A\u5B57\u5143'
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isFormatOk && "很好！" },
	                        this.isFormatOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u4F7F\u7528\u7684\u5E94\u7528\u540D\u79F0\u683C\u5F0F\u4E3A',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u201D\u54C1\u724C\u540D\u79F0 - \u5173\u952E\u8BCD"'
	                            ),
	                            '\uFF0C\u4F60\u7684\u6392\u540D\u4F1A\u56E0\u800C\u6392\u5F97\u66F4\u9AD8\u3002'
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u5E94\u8BE5\u4F7F\u7528',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u201D\u54C1\u724C\u540D\u79F0 - \u5173\u952E\u8BCD"'
	                            ),
	                            '\u4E3A\u5E94\u7528\u540D\u79F0\u683C\u5F0F\uFF0C\u4F60\u7684\u6392\u540D\u4F1A\u56E0\u800C\u6392\u5F97\u66F4\u9AD8\u3002'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isBrandOk && "很好！" },
	                        this.isBrandOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u7684\u54C1\u724C\u540D\u79F0\u7684\u957F\u5EA6\u9002\u5408\u4EFB\u4F55\u88C5\u7F6E\u3002'
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u7684\u54C1\u724C\u540D\u79F0\u592A\u957F\u4E86\uFF0C\u8BD5\u8BD5\u51CF\u5C11\u523024\u4E2A\u5B57\u5143\u4EE5\u5185\u3002'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isLengthOk && "很好！" },
	                        this.isLengthOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u7684\u54C1\u724C\u540D\u79F0\u7684\u957F\u5EA6\u62E5\u6709\u6700\u5927\u4F18\u52BF\u3002'
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u6700\u5C11\u4F7F\u752820\u4E2A\u5B57\u5143\u6765\u8986\u76D6\u66F4\u591A\u76F8\u5173\u5173\u952E\u8BCD\u3002'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        '- \u628A',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u5173\u952E\u8BCD'
	                        ),
	                        '\u5305\u542B\u5728\u4F60\u7684\u5E94\u7528\u540D\u79F0\u5185'
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        '- \u8981\u4EE4',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u6BCF\u4E2A\u88C5\u7F6E\u90FD\u80FD\u83B7\u5F97\u6700\u4F73\u5C55\u793A'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        '- \u6BCF\u4E2A\u5E94\u7528\u540D\u79F0\u7684\u6700\u4F73\u957F\u5EA6\u4E3A',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '30\u4E2A\u5B57\u5143'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GridAppName;
	}(_react2.default.Component);
	
	exports.default = GridAppName;
	;

/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(281);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(280);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _Wrapper = __webpack_require__(1661);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var GridDescription = function (_React$Component) {
	    _inherits(GridDescription, _React$Component);
	
	    function GridDescription(props) {
	        _classCallCheck(this, GridDescription);
	
	        var _this = _possibleConstructorReturn(this, (GridDescription.__proto__ || Object.getPrototypeOf(GridDescription)).call(this, props));
	
	        _this.description = props.data.description;
	        _this.isLengthOk = props.data.isLengthOk;
	        _this.isSpellOk = props.data.isSpellOk;
	        _this.descriptionLength = props.data.descriptionLength;
	        _this.spellLines = props.data.spellLines;
	        return _this;
	    }
	
	    _createClass(GridDescription, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: "grid-score-summaries" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "summary-title" },
	                    "\u82F9\u679C\u5546\u5E97\u5185\u7684\u63CF\u8FF0"
	                ),
	                _react2.default.createElement("div", { className: "app-description", dangerouslySetInnerHTML: {
	                        __html: (this.description || "").replace("\r\n", "<br />").replace(/[\r\n]/gi, "<br />")
	                    }
	                }),
	                _react2.default.createElement(
	                    "div",
	                    { className: "grid-container" },
	                    _react2.default.createElement(
	                        _index2.default,
	                        { ok: this.isLengthOk, title: "\u957F\u5EA6" },
	                        this.descriptionLength,
	                        "\u4E2A\u5B57\u5143"
	                    ),
	                    _react2.default.createElement(_index2.default, { ok: this.isSpellOk, title: "\u6587\u6CD5\u68C0\u67E5" }),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isLengthOk && "很好！" },
	                        this.isLengthOk && _react2.default.createElement(
	                            "div",
	                            null,
	                            "\u5E94\u7528\u63CF\u8FF0\u7684\u957F\u5EA6\u5728\u4E00\u4E2A\u5408\u7406\u8303\u56F4\u5185\u3002"
	                        ) || _react2.default.createElement(
	                            "div",
	                            null,
	                            "\u5E94\u7528\u63CF\u8FF0\u592A",
	                            this.descriptionLength > 3385 && "长" || "短",
	                            "\uFF0C\u5C1D\u8BD5\u63A7\u5236\u5728589\u81F33385\u4E2A\u5B57\u5143\u5185\u3002"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isSpellOk && "很好！", className: "spell-check-content" },
	                        this.isSpellOk && _react2.default.createElement(
	                            "div",
	                            null,
	                            "\u4F60\u7684\u63CF\u8FF0\u6CA1\u6709\u6587\u6CD5\u95EE\u9898\u3002"
	                        ) || _react2.default.createElement(
	                            "div",
	                            null,
	                            "\u4F60\u7684\u63CF\u8FF0\u6709\u6587\u6CD5\u95EE\u9898\uFF0C\u8BF7\u4F18\u5316\u4E00\u4E0B\u3002"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        "- ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "\u9996100\u540D\u7684\u5E94\u7528\u91CC\uFF0C\u670990\uFF05"
	                        ),
	                        "\u7684\u63CF\u8FF0\u90FD\u5728589\u81F33385\u4E2A\u5B57\u5143\u5185\u3002",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement("br", null),
	                        "- ",
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            "\u53EA\u67095%\u7528\u6237\u4F1A\u6309\u201C\u5C55\u5F00\u201D"
	                        ),
	                        "\u89C2\u770B\u88AB\u6536\u8D77\u7684\u63CF\u8FF0\u3002",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement("br", null),
	                        "- \u5229\u7528\u7B80\u660E\u548C\u5438\u775B\u7684\u5B57\u773C\uFF0C\u5E76\u52A0\u5165CTA\uFF08\u7528\u6237\u884C\u4E3A\u53F7\u53EC\uFF09\u5438\u5F15\u7528\u6237\u3002",
	                        _react2.default.createElement("br", null),
	                        _react2.default.createElement("br", null),
	                        "- \u7528\u6237\u4F1A\u6839\u636E\u5E94\u7528\u7684\u7B80\u4ECB\u6765\u9009\u62E9\u4E0B\u8F7D\u4E0E\u5426\u3002"
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GridDescription;
	}(_react2.default.Component);
	
	exports.default = GridDescription;
	;

/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactSwipeable = __webpack_require__(2880);
	
	var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);
	
	var _index = __webpack_require__(281);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(280);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _Wrapper = __webpack_require__(1662);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var Screenshots = function (_React$Component) {
	    _inherits(Screenshots, _React$Component);
	
	    function Screenshots(props) {
	        _classCallCheck(this, Screenshots);
	
	        var _this = _possibleConstructorReturn(this, (Screenshots.__proto__ || Object.getPrototypeOf(Screenshots)).call(this, props));
	
	        _this.urlCollection = props.urls;
	        _this.right = -1;
	        _this.left = +1;
	        _this.state = { imageIndex: 0 };
	        return _this;
	    }
	
	    _createClass(Screenshots, [{
	        key: 'onSwiped',
	        value: function onSwiped(operator) {
	            var index = this.state.imageIndex + operator;
	            if (index < 0) index = this.urlCollection.length - 1;
	            if (index >= this.urlCollection.length) index = 0;
	
	            this.setState({ imageIndex: index });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            {
	                var screenshotComponents = this.urlCollection.map(function (url, index) {
	                    return _react2.default.createElement(
	                        'div',
	                        { key: index },
	                        _react2.default.createElement('img', { src: url })
	                    );
	                });
	                var bubbleComponents = this.urlCollection.map(function (url, index) {
	                    return _react2.default.createElement('div', { key: index, className: 'shot-bubble ' + (this.state.imageIndex == index ? "activated-shot-bubble" : "") });
	                }.bind(this));
	            }
	            return this.urlCollection && this.urlCollection.length > 0 && _react2.default.createElement(
	                'div',
	                { className: 'screenshots' },
	                _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { minWidth: 768 },
	                    screenshotComponents
	                ),
	                _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { maxWidth: 767 },
	                    _react2.default.createElement(
	                        _reactSwipeable2.default,
	                        {
	                            className: 'swipe',
	                            trackMouse: true,
	                            style: { touchAction: 'none' },
	                            preventDefaultTouchmoveEvent: true,
	                            onSwipedLeft: function onSwipedLeft() {
	                                return _this2.onSwiped(_this2.left);
	                            },
	                            onSwipedRight: function onSwipedRight() {
	                                return _this2.onSwiped(_this2.right);
	                            }
	                        },
	                        _react2.default.createElement('img', { src: this.urlCollection[this.state.imageIndex] })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'shot-bubbles' },
	                    bubbleComponents
	                )
	            );
	        }
	    }]);
	
	    return Screenshots;
	}(_react2.default.Component);
	
	var GridGraphics = function (_React$Component2) {
	    _inherits(GridGraphics, _React$Component2);
	
	    function GridGraphics(props) {
	        _classCallCheck(this, GridGraphics);
	
	        var _this3 = _possibleConstructorReturn(this, (GridGraphics.__proto__ || Object.getPrototypeOf(GridGraphics)).call(this, props));
	
	        _this3.screenshots = props.data.screenshots;
	        _this3.isQuantityOk = props.data.isQuantityOk;
	        _this3.isShapeOk = props.data.isShapeOk;
	        _this3.isPreviewVideoOk = props.data.isPreviewVideoOk;
	        return _this3;
	    }
	
	    _createClass(GridGraphics, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'grid-score-summaries' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary-title' },
	                    '\u5C4F\u5E55\u622A\u56FE'
	                ),
	                _react2.default.createElement(Screenshots, { urls: this.screenshots }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'grid-container' },
	                    _react2.default.createElement(_index2.default, { ok: this.isQuantityOk, title: '\u6570\u91CF' }),
	                    _react2.default.createElement(_index2.default, { ok: this.isShapeOk, title: '\u5F62\u72B6' }),
	                    _react2.default.createElement(_index2.default, { ok: this.isPreviewVideoOk, title: '\u9884\u89C8\u5F71\u7247' }),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isQuantityOk && "很好！" },
	                        this.isQuantityOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u5145\u5206',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u8FD0\u7528\u4E86\u4E94\u5F20\u5C4F\u5E55\u622A\u56FE\u3002'
	                            )
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            this.screenshots.length > 5 && "你的屏幕截图太多，把数量控制在五张以内。" || "你的屏幕截图太少，把数量控制在五张以内。"
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isShapeOk && "很好！" },
	                        this.isShapeOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u7684\u5C4F\u5E55\u622A\u56FE\u90FD\u4FDD\u6301\u5782\u76F4\u3002'
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u5E94\u8BE5\u628A\u5C4F\u5E55\u622A\u56FE\u4FDD\u6301',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u5782\u76F4\u3002'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isPreviewVideoOk && "很好！" },
	                        this.isPreviewVideoOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u6709\u4E00\u4E2A\u9884\u89C8\u5F71\u7247\u3002'
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u5E94\u8BE5\u8981\u5728\u622A\u56FE\u90E8\u5206\u52A0\u5165',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u9884\u89C8\u5F71\u7247\u3002'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '- \u5229\u7528\u5C4F\u5E55\u622A\u56FE\u4ECB\u7ECD\u5E94\u7528\u7684',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u529F\u80FD\u548C\u7279\u70B9'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '- \u5728\u5C4F\u5E55\u622A\u56FE\u4E2D\u52A0\u5165\u6587\u5B57\u80FD\u591F\u4EE4\u7528\u6237\u66F4\u52A0\u660E\u767D\u5E94\u7528\u7684\u529F\u80FD\u3002'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        '- \u82E5\u4F60\u7684\u5C4F\u5E55\u622A\u56FE\u4FDD\u6301\u5782\u76F4\uFF0C\u80FD\u8BA9\u624B\u673A\u7528\u6237\u5728',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u7A84\u957F\u7684\u9875\u9762'
	                        ),
	                        '\u770B\u5230\u66F4\u591A\u622A\u56FE\u3002',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        '- \u4E0D\u59A8\u5728\u5C4F\u5E55\u622A\u56FE\u4E2D\u52A0\u5165\u6587\u5B57\uFF0C\u4F46\u8C28\u8BB0\u4F7F\u7528\u4E00\u4E2A',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u7B80\u6D01\u7684\u80CC\u666F\u3002'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '- \u5145\u5206\u5229\u7528',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u9996\u4E94\u79D2'
	                            ),
	                            '\u83B7\u5F97\u7528\u6237\u7684\u5173\u6CE8'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '- \u8981\u5C55\u793A\u51FA\u5E94\u7528\u4E2D',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u6700\u597D\u7684\u529F\u80FD'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '- \u4F60\u7684\u9884\u89C8\u5F71\u7247\u8981\u5728\u9759\u97F3\u7684\u60C5\u51B5\u4E0B\u4E5F\u80FD\u8BA9\u7528\u6237\u660E\u767D'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '- \u5F71\u7247\u4E2D\u4E0D\u8981\u5FD8\u4E86\u5305\u542B',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                'CTA\uFF08\u7528\u6237\u884C\u4E3A\u53F7\u53EC\uFF09'
	                            ),
	                            '\u5728\u5185'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GridGraphics;
	}(_react2.default.Component);
	
	exports.default = GridGraphics;
	;

/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _recharts = __webpack_require__(2989);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _index = __webpack_require__(281);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(280);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(1668);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _Wrapper = __webpack_require__(1664);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _trophy = __webpack_require__(3314);
	
	var _trophy2 = _interopRequireDefault(_trophy);
	
	var _warning = __webpack_require__(3315);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	// -- Resources
	
	
	var GridRating = function (_React$Component) {
	    _inherits(GridRating, _React$Component);
	
	    function GridRating(props) {
	        _classCallCheck(this, GridRating);
	
	        var _this = _possibleConstructorReturn(this, (GridRating.__proto__ || Object.getPrototypeOf(GridRating)).call(this, props));
	
	        _this.filterReviews = function (reviews) {
	            var sortedReviews = reviews || [];
	            var latestBest = null;
	            var latestWorst = null;
	            var secondLatestWorst = null;
	
	            sortedReviews = sortedReviews.sort(function (review1, review2) {
	                return parseInt(review1["id"].label) - parseInt(review2["id"].label);
	            }).reverse();
	            sortedReviews.map(function (review) {
	                var rating = parseInt(review["im:rating"].label);
	                if (!latestBest || rating > parseInt(latestBest["im:rating"].label)) latestBest = review;
	                if (!latestWorst || rating < parseInt(latestWorst["im:rating"].label)) latestWorst = review;
	            });
	
	            if (latestWorst) sortedReviews.map(function (review) {
	                var rating = parseInt(review["im:rating"].label);
	
	                if (review["id"].label != latestWorst["id"].label) if (!secondLatestWorst || rating < parseInt(secondLatestWorst["im:rating"].label)) secondLatestWorst = review;
	            });
	
	            if (sortedReviews) {
	                this.review1 = latestBest;
	                this.review2 = latestWorst;
	                this.review3 = secondLatestWorst;
	            }
	
	            return reviews;
	        }.bind(_this);
	
	        _this.state = { reviewsExpanded: false };
	
	        _this.isRatingsOk = props.data.isRatingsOk;
	        _this.isReviewsOk = props.data.isReviewsOk;
	
	        _this.averageRating = props.data.averageRating;
	        _this.appRatingCount = props.data.appUserRatingCount < 1000 ? props.data.appUserRatingCount : (props.data.appUserRatingCount / 1000).toFixed(1) + "千";
	
	        _this.sentimentAnalyze = [{ subject: "正评", score: props.data.sentimentAnalyze.positive || 0 }, { subject: "负评", score: props.data.sentimentAnalyze.negative || 0 }, { subject: "中性", score: props.data.sentimentAnalyze.neutral || 0 }];
	
	        _this.review1 = null;
	        _this.review2 = null;
	        _this.review3 = null;
	
	        _this.filterReviews(props.data.reviews);
	        return _this;
	    }
	
	    _createClass(GridRating, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'grid-score-summaries' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'summary-title' },
	                    '\u8BC4\u5206\u53CA\u8BC4\u8BBA',
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'ratings' },
	                        _react2.default.createElement('img', { className: 'rating-icon', src: this.isRatingsOk ? _trophy2.default : _warning2.default }),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                (this.averageRating || 0).toFixed(1)
	                            ),
	                            '\xA0/\xA05'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u5171',
	                            this.appRatingCount,
	                            '\u4E2A\u8BC4\u5206'
	                        )
	                    )
	                ),
	                this.review1 && _react2.default.createElement(
	                    'div',
	                    { className: 'reviews' },
	                    this.review1 && _react2.default.createElement(_index6.default, { className: 'review', review: this.review1, isExpanded: this.state.reviewsExpanded }),
	                    this.review2 && _react2.default.createElement(_index6.default, { className: 'review', review: this.review2, isExpanded: this.state.reviewsExpanded }),
	                    this.review3 && _react2.default.createElement(_index6.default, { className: 'review', review: this.review3, isExpanded: this.state.reviewsExpanded }),
	                    _react2.default.createElement(
	                        'button',
	                        { className: 'reviews-toggle', onClick: function onClick() {
	                                _this2.setState({ reviewsExpanded: !_this2.state.reviewsExpanded });
	                            } },
	                        _react2.default.createElement('i', { className: 'fa fa-caret-' + (this.state.reviewsExpanded && "up" || "down") })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'grid-container' },
	                    _react2.default.createElement(_index2.default, { ok: this.isRatingsOk, title: '\u5E73\u5747\u8BC4\u5206' }),
	                    _react2.default.createElement(_index2.default, { ok: this.isReviewsOk, title: '\u60C5\u611F\u5206\u6790' }),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isRatingsOk && "很好！" },
	                        this.isRatingsOk && _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u7684\u5E73\u5747\u8BC4\u5206\u5728\u56DB\u5206\u4EE5\u4E0A\uFF0C',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u591A\u4E8E90\uFF05\u7684\u7528\u6237'
	                            ),
	                            '\u613F\u610F\u4E0B\u8F7D\u8BC4\u5206\u9AD8\u4E8E\u56DB\u5206\u7684\u5E94\u7528\u3002'
	                        ) || _react2.default.createElement(
	                            'div',
	                            null,
	                            '\u4F60\u7684\u8BC4\u5206\u9700\u8981\u4F18\u5316\u3002',
	                            _react2.default.createElement(
	                                'span',
	                                null,
	                                '\u53EA\u6709\u5C11\u4E8E50\uFF05\u7684\u7528\u6237'
	                            ),
	                            '\u4F1A\u4E0B\u8F7D\u8BC4\u5206\u4F4E\u4E8E\u56DB\u5206\u7684\u5E94\u7528\u3002'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: this.isReviewsOk && "很好！" },
	                        this.sentimentAnalyze && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _reactResponsive2.default,
	                                { maxWidth: 480 },
	                                _react2.default.createElement(
	                                    _recharts.RadarChart,
	                                    { cx: 160, cy: 95, width: 320, height: 190, data: this.sentimentAnalyze },
	                                    _react2.default.createElement(_recharts.PolarGrid, null),
	                                    _react2.default.createElement(_recharts.PolarAngleAxis, { dataKey: 'subject' }),
	                                    _react2.default.createElement(_recharts.Radar, { dataKey: 'score', stroke: '#8884d8', fill: '#8884d8', fillOpacity: 0.6 })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactResponsive2.default,
	                                { minWidth: 481, maxWidth: 767 },
	                                _react2.default.createElement(
	                                    _recharts.RadarChart,
	                                    { cx: 210, cy: 125, width: 420, height: 250, data: this.sentimentAnalyze },
	                                    _react2.default.createElement(_recharts.PolarGrid, null),
	                                    _react2.default.createElement(_recharts.PolarAngleAxis, { dataKey: 'subject' }),
	                                    _react2.default.createElement(_recharts.Radar, { dataKey: 'score', stroke: '#8884d8', fill: '#8884d8', fillOpacity: 0.6 })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactResponsive2.default,
	                                { minWidth: 768, maxWidth: 991 },
	                                _react2.default.createElement(
	                                    _recharts.RadarChart,
	                                    { cx: 140, cy: 83, width: 280, height: 166, data: this.sentimentAnalyze },
	                                    _react2.default.createElement(_recharts.PolarGrid, null),
	                                    _react2.default.createElement(_recharts.PolarAngleAxis, { dataKey: 'subject' }),
	                                    _react2.default.createElement(_recharts.Radar, { dataKey: 'score', stroke: '#8884d8', fill: '#8884d8', fillOpacity: 0.6 })
	                                )
	                            ),
	                            _react2.default.createElement(
	                                _reactResponsive2.default,
	                                { minWidth: 992 },
	                                _react2.default.createElement(
	                                    _recharts.RadarChart,
	                                    { cx: 210, cy: 125, width: 420, height: 250, data: this.sentimentAnalyze },
	                                    _react2.default.createElement(_recharts.PolarGrid, null),
	                                    _react2.default.createElement(_recharts.PolarAngleAxis, { dataKey: 'subject' }),
	                                    _react2.default.createElement(_recharts.Radar, { dataKey: 'score', stroke: '#8884d8', fill: '#8884d8', fillOpacity: 0.6 })
	                                )
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        _index4.default,
	                        { title: "小窍门:" },
	                        '- ',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '59%\u7684\u7528\u6237'
	                        ),
	                        '\u4F1A\u4E8E\u4E0B\u8F7D\u65B0\u7684\u5E94\u7528\u524D\u68C0\u89C6\u5B83\u7684\u8BC4\u5206',
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        '- \u5BF9\u5E94\u7528\u611F\u5230\u6EE1\u610F\u7684\u7528\u6237\u4F1A\u6BD4\u8F83\u613F\u610F\u7559\u4E0B\u6B63\u8BC4\uFF0C\u53EF\u4EE5\u5728\u5E94\u7528\u4E2D',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u8BF7\u6C42\u7528\u6237\u8BC4\u5206'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement('br', null),
	                        '- \u5B9A\u671F\u68C0\u89C6\u8D1F\u8BC4\uFF0C',
	                        _react2.default.createElement(
	                            'span',
	                            null,
	                            '\u56DE\u5E94\u7528\u6237\u7684\u9700\u6C42\u548C\u89E3\u51B3\u5E94\u7528\u7684\u95EE\u9898\u3002'
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return GridRating;
	}(_react2.default.Component);
	
	exports.default = GridRating;
	;

/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(288);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _antd = __webpack_require__(43);
	
	var _reactRedux = __webpack_require__(40);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _AdPreview = __webpack_require__(391);
	
	var _AdPreview2 = _interopRequireDefault(_AdPreview);
	
	var _antTables = __webpack_require__(1721);
	
	var _config = __webpack_require__(1688);
	
	var rechartConfigs = _interopRequireWildcard(_config);
	
	var _contentHolder = __webpack_require__(215);
	
	var _contentHolder2 = _interopRequireDefault(_contentHolder);
	
	var _tooltip = __webpack_require__(277);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _simpleDonutChart = __webpack_require__(1686);
	
	var _simpleDonutChart2 = _interopRequireDefault(_simpleDonutChart);
	
	var _box = __webpack_require__(1634);
	
	var _box2 = _interopRequireDefault(_box);
	
	var _config2 = __webpack_require__(1687);
	
	var configs = _interopRequireWildcard(_config2);
	
	var _reactChartjs = __webpack_require__(2712);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _widgetsWrapper = __webpack_require__(1696);
	
	var _widgetsWrapper2 = _interopRequireDefault(_widgetsWrapper);
	
	var _widgetBox = __webpack_require__(1695);
	
	var _widgetBox2 = _interopRequireDefault(_widgetBox);
	
	var _saleWidget = __webpack_require__(1693);
	
	var _saleWidget2 = _interopRequireDefault(_saleWidget);
	
	var _style = __webpack_require__(396);
	
	var _apps_flyer = __webpack_require__(3309);
	
	var _apps_flyer2 = _interopRequireDefault(_apps_flyer);
	
	var _adjust = __webpack_require__(3308);
	
	var _adjust2 = _interopRequireDefault(_adjust);
	
	var _tune = __webpack_require__(3312);
	
	var _tune2 = _interopRequireDefault(_tune);
	
	var _Kochava = __webpack_require__(3307);
	
	var _Kochava2 = _interopRequireDefault(_Kochava);
	
	var _running = __webpack_require__(577);
	
	var _running2 = _interopRequireDefault(_running);
	
	var _pause = __webpack_require__(576);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _refresh = __webpack_require__(3306);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _calendar = __webpack_require__(3301);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _download = __webpack_require__(3302);
	
	var _download2 = _interopRequireDefault(_download);
	
	var _reactCircularProgressbar = __webpack_require__(2713);
	
	var _reactCircularProgressbar2 = _interopRequireDefault(_reactCircularProgressbar);
	
	__webpack_require__(1994);
	
	var _rcTabs = __webpack_require__(480);
	
	var _rcTabs2 = _interopRequireDefault(_rcTabs);
	
	var _TabContent = __webpack_require__(329);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _ScrollableInkTabBar = __webpack_require__(2601);
	
	var _ScrollableInkTabBar2 = _interopRequireDefault(_ScrollableInkTabBar);
	
	__webpack_require__(429);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _redux = __webpack_require__(56);
	
	var _reactDates = __webpack_require__(1624);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(2717);
	
	__webpack_require__(940);
	
	var _reactWorldFlags = __webpack_require__(2964);
	
	var _reactWorldFlags2 = _interopRequireDefault(_reactWorldFlags);
	
	var _dropdown = __webpack_require__(276);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _reactResponsiveModal = __webpack_require__(1275);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _ButtonAction = __webpack_require__(392);
	
	var _ButtonAction2 = _interopRequireDefault(_ButtonAction);
	
	var _index = __webpack_require__(1690);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(736);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(393);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _nprogress = __webpack_require__(320);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _reactStripeElements = __webpack_require__(256);
	
	var _CheckoutForm = __webpack_require__(1691);
	
	var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);
	
	var _stripe = __webpack_require__(742);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	var _reactFlagsSelect = __webpack_require__(196);
	
	var _reactFlagsSelect2 = _interopRequireDefault(_reactFlagsSelect);
	
	__webpack_require__(185);
	
	var _reactDataExport = __webpack_require__(1220);
	
	var _reactDataExport2 = _interopRequireDefault(_reactDataExport);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	
	// -- Components
	
	var ExcelFile = _reactDataExport2.default.ExcelFile;
	var ExcelSheet = _reactDataExport2.default.ExcelFile.ExcelSheet;
	var ExcelColumn = _reactDataExport2.default.ExcelFile.ExcelColumn;
	
	var tableDataList = (0, _clone2.default)(_antTables.dataList);
	tableDataList.size = 5;
	
	var data1 = {
	  labels: ['Red', 'Green'],
	  datasets: [{
	    data: [300, 50],
	    backgroundColor: ['#FF6384', '#36A2EB'],
	    hoverBackgroundColor: ['#FF6384', '#36A2EB']
	  }]
	};
	
	var downLoadsData = {
	  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
	  datasets: [{
	    label: 'Downloads',
	    fill: false,
	    lineTension: 0.1,
	    backgroundColor: 'rgba(75,192,192,0.4)',
	    borderColor: 'rgba(71, 214, 204, 1)',
	    borderCapStyle: 'butt',
	    borderDash: [],
	    borderDashOffset: 0.0,
	    borderJoinStyle: 'miter',
	    pointBorderColor: 'rgba(71, 214, 204, 1)',
	    pointBackgroundColor: '#fff',
	    pointBorderWidth: 2,
	    pointHoverRadius: 5,
	    pointHoverBackgroundColor: 'rgba(71, 214, 204, 1)',
	    pointHoverBorderColor: 'rgba(71, 214, 204, 1)',
	    pointHoverBorderWidth: 2,
	    pointRadius: 3,
	    pointHitRadius: 5,
	    data: [231, 31, 84, 73, 46, 117, 279]
	  }]
	};
	
	var cpaData = {
	  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
	  datasets: [{
	    label: 'CPA',
	    fill: false,
	    lineTension: 0.1,
	    backgroundColor: 'rgba(75,192,192,0.4)',
	    borderColor: 'rgba(93, 215, 255, 1)',
	    borderCapStyle: 'butt',
	    borderDash: [],
	    borderDashOffset: 0.0,
	    borderJoinStyle: 'miter',
	    pointBorderColor: 'rgba(93, 215, 255, 1)',
	    pointBackgroundColor: '#fff',
	    pointBorderWidth: 2,
	    pointHoverRadius: 5,
	    pointHoverBackgroundColor: 'rgba(93, 215, 255, 1)',
	    pointHoverBorderColor: 'rgba(93, 215, 255, 1)',
	    pointHoverBorderWidth: 2,
	    pointRadius: 3,
	    pointHitRadius: 5,
	    data: [0.93, 0.86, 0.71, 1.29, 0.68, 0.79, 0.78, 0.86]
	  }]
	};
	
	var budgetSpendData = {
	  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
	  datasets: [{
	    label: 'Budget Spent',
	    fill: false,
	    lineTension: 0.1,
	    backgroundColor: 'rgba(75,192,192,0.4)',
	    borderColor: 'rgba(236, 184, 92, 1)',
	    borderCapStyle: 'butt',
	    borderDash: [],
	    borderDashOffset: 0.0,
	    borderJoinStyle: 'miter',
	    pointBorderColor: 'rgba(236, 184, 92, 1)',
	    pointBackgroundColor: '#fff',
	    pointBorderWidth: 2,
	    pointHoverRadius: 5,
	    pointHoverBackgroundColor: 'rgba(236, 184, 92, 1)',
	    pointHoverBorderColor: 'rgba(236, 184, 92, 1)',
	    pointHoverBorderWidth: 2,
	    pointRadius: 3,
	    pointHitRadius: 5,
	    data: [214.83, 26.66, 59.64, 94.17, 31.28, 92.43, 217.62, 736.63]
	  }]
	};
	
	var conversionRateData = {
	  labels: ['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
	  datasets: [{
	    label: 'Conversion Rate',
	    fill: false,
	    lineTension: 0.1,
	    backgroundColor: 'rgba(75,192,192,0.4)',
	    borderColor: 'rgba(114, 90, 166, 1)',
	    borderCapStyle: 'butt',
	    borderDash: [],
	    borderDashOffset: 0.0,
	    borderJoinStyle: 'miter',
	    pointBorderColor: 'rgba(114, 90, 166, 1)',
	    pointBackgroundColor: '#fff',
	    pointBorderWidth: 2,
	    pointHoverRadius: 5,
	    pointHoverBackgroundColor: 'rgba(114, 90, 166, 1)',
	    pointHoverBorderColor: 'rgba(114, 90, 166, 1)',
	    pointHoverBorderWidth: 2,
	    pointRadius: 3,
	    pointHitRadius: 5,
	    data: [76.74, 72.09, 75.00, 82.95, 70.77, 79.59, 81.58, 78.42]
	  }]
	};
	
	var Dashboard = function (_Component) {
	  _inherits(Dashboard, _Component);
	
	  function Dashboard(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Dashboard);
	
	    var _this = _possibleConstructorReturn(this, (Dashboard.__proto__ || Object.getPrototypeOf(Dashboard)).call(this, props));
	
	    _this.onRegionSelected = function (item) {
	      console.log('on region selected : ', item);
	
	      if (item.key === 'ALL') {
	        /**
	         * not yet handled
	         */
	      } else if (_this.state.appRecord) {
	        var appRecord = _this.state.appRecord;
	        var region = item.key;
	        var pIndex = appRecord.performanceByRegion.findIndex(function (item) {
	          return item.region === region;
	        });
	        var dIndex = appRecord.discoveryByRegion.findIndex(function (item) {
	          return item.region === region;
	        });
	        _this.setState({
	          currentRegion: {
	            region: region,
	            pCid: appRecord.performanceByRegion[pIndex].campaignId,
	            dCid: appRecord.discoveryByRegion[dIndex].campaignId
	          }
	        });
	      }
	    };
	
	    _this.handleAddCampClick = function (event) {
	      _this.props.history.push('/campaign/list');
	    };
	
	    _this.goToAso = function (event) {
	      var params = _this.props.match.params;
	
	      _this.props.history.push('/aso/' + params.appId);
	    };
	
	    _this.changeCampaignState = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(isSwitchingOn) {
	        var Status, getAccessToken, headers, request, CampaignIDs;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                Status = isSwitchingOn ? "ENABLED" : "PAUSED";
	
	                _this.setState({ isCampaignRunning: isSwitchingOn });
	
	                getAccessToken = _this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                request = {
	                  campaign: {
	                    status: Status
	                    // Whether user intends to run this campaign/adgroup or not. ENABLED, PAUSED
	                  } };
	                CampaignIDs = [_this.state.currentRegion.pCid, _this.state.currentRegion.dCid];
	                _context2.next = 8;
	                return Promise.all(CampaignIDs.map(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(cid) {
	                    var requestResponse, updatedCampaign;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            requestResponse = void 0;
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return _axios2.default.post(_server2.default + '/user/campaigns/cid/' + cid, request, { headers: headers });
	
	                          case 4:
	                            requestResponse = _context.sent;
	                            updatedCampaign = requestResponse.data.response.data;
	
	                            console.log('[Dashboard][changeCampaignState] ', cid, updatedCampaign);
	                            _context.next = 12;
	                            break;
	
	                          case 9:
	                            _context.prev = 9;
	                            _context.t0 = _context['catch'](1);
	
	                            console.error('[Dashboard][changeCampaignState] ', cid, _context.t0);
	
	                          case 12:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2, [[1, 9]]);
	                  }));
	
	                  return function (_x2) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()));
	
	              case 8:
	                _this.updateResult(true, null);
	
	              case 9:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onBudgetComfirmed = function (budget, region) {
	      if (false) {
	        var appRecord = _this.state.appRecord;
	
	        // const dIndex = appRecord.discoveryByRegion.findIndex(item => item.region === region);
	        // const pIndex = appRecord.performanceByRegion.findIndex(item => item.region === region);
	        // const dCid = appRecord.discoveryByRegion[dIndex].campaignId;
	        // const pCid = appRecord.discoveryByRegion[dIndex].campaignId;
	
	        console.log(budget, region);
	        var params = _this.props.match.params;
	
	        _this.setState({
	          addBudgetData: {
	            budget: budget,
	            region: region,
	            appId: params.appId
	          }
	        });
	        _this.onCloseAddBudgetModal();
	        _this.onOpenCheckoutModal();
	      }
	    };
	
	    _this.updateResult = function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(success, text) {
	        var _this$state, currentRegion, startDate, endDate, pRowReporting, dRowReporting, pData, dData;
	
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                if (!success) {
	                  _context3.next = 21;
	                  break;
	                }
	
	                _this.onCloseCheckoutModal();
	
	                _this$state = _this.state, currentRegion = _this$state.currentRegion, startDate = _this$state.startDate, endDate = _this$state.endDate;
	
	
	                _nprogress2.default.start();
	
	                _this.setState({ isReportLoading: true });
	                _context3.next = 7;
	                return _this.getCampaignReportingData(currentRegion.pCid, (0, _moment2.default)(startDate).format('YYYY-MM-DD'), (0, _moment2.default)(endDate).format('YYYY-MM-DD'));
	
	              case 7:
	                pRowReporting = _context3.sent;
	                _context3.next = 10;
	                return _this.getCampaignReportingData(currentRegion.dCid, (0, _moment2.default)(startDate).format('YYYY-MM-DD'), (0, _moment2.default)(endDate).format('YYYY-MM-DD'));
	
	              case 10:
	                dRowReporting = _context3.sent;
	                _context3.next = 13;
	                return _this.getCampaignMetaData(currentRegion.pCid);
	
	              case 13:
	                pData = _context3.sent;
	                _context3.next = 16;
	                return _this.getCampaignMetaData(currentRegion.dCid);
	
	              case 16:
	                dData = _context3.sent;
	
	                _nprogress2.default.done();
	                _this.setState({ isReportLoading: false });
	
	                console.log(pData, dData, pRowReporting, dRowReporting);
	                _this.updateReport(pData, dData, pRowReporting, dRowReporting);
	
	              case 21:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this2);
	      }));
	
	      return function (_x3, _x4) {
	        return _ref3.apply(this, arguments);
	      };
	    }();
	
	    _this.updateError = function (err) {};
	
	    _this.onOpenAddBudgetModal = function () {
	      _this.setState({ isShowBudgetModal: true });
	    };
	
	    _this.onCloseAddBudgetModal = function () {
	      _this.setState({ isShowBudgetModal: false });
	    };
	
	    _this.onOpenCheckoutModal = function () {
	      _this.setState({ isShowCheckoutModal: true });
	    };
	
	    _this.onCloseCheckoutModal = function () {
	      _this.setState({ isShowCheckoutModal: false });
	    };
	
	    _this.componentDidUpdate = function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(prevProps, prevState) {
	        var _this$state2, currentRegion, startDate, endDate, _endDate, _startDate, pRowReporting, dRowReporting, pData, dData;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this$state2 = _this.state, currentRegion = _this$state2.currentRegion, startDate = _this$state2.startDate, endDate = _this$state2.endDate;
	
	                if (currentRegion) {
	                  if (!prevState.currentRegion || currentRegion.region !== prevState.currentRegion.region) {
	                    /**
	                     * change in currenEregion
	                     */
	                    _endDate = (0, _moment2.default)(); //.format('YYYY-MM-DD');      
	
	                    _startDate = (0, _moment2.default)(_endDate).subtract(20, 'days');
	
	                    _this.setState({ startDate: _startDate, endDate: _endDate });
	                  }
	                }
	
	                if (!(startDate && endDate && startDate !== prevState.startDate || startDate && endDate && endDate !== prevState.endDate)) {
	                  _context4.next = 22;
	                  break;
	                }
	
	                console.log(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
	                _nprogress2.default.start();
	
	                _this.setState({ isReportLoading: true });
	                _context4.next = 8;
	                return _this.getCampaignReportingData(currentRegion.pCid, (0, _moment2.default)(startDate).format('YYYY-MM-DD'), (0, _moment2.default)(endDate).format('YYYY-MM-DD'));
	
	              case 8:
	                pRowReporting = _context4.sent;
	                _context4.next = 11;
	                return _this.getCampaignReportingData(currentRegion.dCid, (0, _moment2.default)(startDate).format('YYYY-MM-DD'), (0, _moment2.default)(endDate).format('YYYY-MM-DD'));
	
	              case 11:
	                dRowReporting = _context4.sent;
	                _context4.next = 14;
	                return _this.getCampaignMetaData(currentRegion.pCid);
	
	              case 14:
	                pData = _context4.sent;
	                _context4.next = 17;
	                return _this.getCampaignMetaData(currentRegion.dCid);
	
	              case 17:
	                dData = _context4.sent;
	
	                _nprogress2.default.done();
	                _this.setState({ isReportLoading: false });
	
	                console.log('asdfasd', pData, dData, pRowReporting, dRowReporting);
	                _this.updateReport(pData, dData, pRowReporting, dRowReporting);
	
	              case 22:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this2);
	      }));
	
	      return function (_x5, _x6) {
	        return _ref4.apply(this, arguments);
	      };
	    }();
	
	    _this.updateReport = function (pData, dData, pReporting, dReporting) {
	      console.log(dData, pData, pReporting);
	      /*
	      avgCPA:{amount: "0.6667", currency: "USD"}
	      avgCPT:{amount: "0.3333", currency: "USD"}
	      conversionRate:0.5
	      conversions:1
	      conversionsLATOff:1
	      conversionsLATOn:0
	      conversionsNewDownloads:0
	      conversionsRedownloads:1
	      date:"2018-06-09"
	      impressions:6
	      localSpend:{amount: "0.6667", currency: "USD"}
	      taps:2
	      ttr:0.3333*/
	      /*
	      {id: 156549698, 
	        orgId: 379480, 
	        name: "DEV-B13IAQFlQ-331177714-GB-D",
	         budgetAmount: {…}, 
	         dailyBudgetAmount: null, …}
	         adGroups: (2) [{…}, {…}]
	         adamId: 331177714
	         additionalDetail: null
	         budgetAmount: {amount: "0.6666666667", currency: "USD"}
	         budgetOrders: []dailyBudgetAmount: null
	         deleted: falsedis
	         playStatus: "ON_HOLD"
	         endTime: null
	         id: 156549698
	         locInvoiceDetails: null
	         modificationTime: "2018-06-18T04:22:07.750"
	         name: "DEV-B13IAQFlQ-331177714-GB-D"
	         negativeKeywords: []
	         orgId: 379480
	         paymentModel: "PAYG"
	         referenceLabel: null
	         servingStateReasons: ["TOTAL_BUDGET_EXHAUSTED"]
	         servingStatus: "NOT_RUNNING"
	         startTime: "2018-06-09T10:48:36.120"
	         status: "ENABLED"
	         storefront: "GB"
	      */
	
	      var totalSpent = pReporting.totalData ? parseFloat(pReporting.totalData.localSpend.amount) + parseFloat(dReporting.totalData.localSpend.amount) : 0;
	      var totalNewDownloads = pReporting.totalData ? parseFloat(pReporting.totalData.conversionsNewDownloads) + parseFloat(dReporting.totalData.conversionsNewDownloads) : 0;
	      var totalReDownloads = pReporting.totalData ? parseFloat(pReporting.totalData.conversionsRedownloads) + parseFloat(dReporting.totalData.conversionsRedownloads) : 0;
	      var avgCPA = pReporting.totalData ? (parseFloat(pReporting.totalData.avgCPA.amount) + parseFloat(dReporting.totalData.avgCPA.amount)) / 2.0 : 0;
	      var conversionRate = pReporting.totalData ? (parseFloat(pReporting.totalData.conversionRate) + parseFloat(dReporting.totalData.conversionRate)) / 2.0 : 0;
	      var ttr = pReporting.totalData ? (parseFloat(pReporting.totalData.ttr) + parseFloat(dReporting.totalData.ttr)) / 2.0 : 0;
	      var labels = pReporting.granularity.map(function (item) {
	        return (0, _moment2.default)(item.date).format('MM/DD');
	      });
	      var budgetLeft = (parseFloat(pData.budgetAmount.amount) + parseFloat(dData.budgetAmount.amount) - totalSpent).toFixed(2);
	      var cpaData = {
	        labels: labels, //['3/11', '3/12', '3/13', '3/14', '3/15', '3/16', '3/17'],
	        datasets: [{
	          label: 'CPA',
	          fill: false,
	          lineTension: 0.1,
	          backgroundColor: 'rgba(75,192,192,0.4)',
	          borderColor: 'rgba(93, 215, 255, 1)',
	          borderCapStyle: 'butt',
	          borderDash: [],
	          borderDashOffset: 0.0,
	          borderJoinStyle: 'miter',
	          pointBorderColor: 'rgba(93, 215, 255, 1)',
	          pointBackgroundColor: '#fff',
	          pointBorderWidth: 2,
	          pointHoverRadius: 5,
	          pointHoverBackgroundColor: 'rgba(93, 215, 255, 1)',
	          pointHoverBorderColor: 'rgba(93, 215, 255, 1)',
	          pointHoverBorderWidth: 2,
	          pointRadius: 3,
	          pointHitRadius: 5,
	          data: pReporting.granularity.map(function (item) {
	            return parseFloat(item.avgCPA.amount);
	          })
	        }]
	      };
	      var downLoadsData = {
	        labels: labels,
	        datasets: [{
	          label: 'Downloads',
	          fill: false,
	          lineTension: 0.1,
	          backgroundColor: 'rgba(75,192,192,0.4)',
	          borderColor: 'rgba(71, 214, 204, 1)',
	          borderCapStyle: 'butt',
	          borderDash: [],
	          borderDashOffset: 0.0,
	          borderJoinStyle: 'miter',
	          pointBorderColor: 'rgba(71, 214, 204, 1)',
	          pointBackgroundColor: '#fff',
	          pointBorderWidth: 2,
	          pointHoverRadius: 5,
	          pointHoverBackgroundColor: 'rgba(71, 214, 204, 1)',
	          pointHoverBorderColor: 'rgba(71, 214, 204, 1)',
	          pointHoverBorderWidth: 2,
	          pointRadius: 3,
	          pointHitRadius: 5,
	          data: pReporting.granularity.map(function (item) {
	            return item.conversionsNewDownloads + item.conversionsRedownloads;
	          })
	        }]
	      };
	      var budgetSpendData = {
	        labels: labels,
	        datasets: [{
	          label: 'Budget Spent',
	          fill: false,
	          lineTension: 0.1,
	          backgroundColor: 'rgba(75,192,192,0.4)',
	          borderColor: 'rgba(236, 184, 92, 1)',
	          borderCapStyle: 'butt',
	          borderDash: [],
	          borderDashOffset: 0.0,
	          borderJoinStyle: 'miter',
	          pointBorderColor: 'rgba(236, 184, 92, 1)',
	          pointBackgroundColor: '#fff',
	          pointBorderWidth: 2,
	          pointHoverRadius: 5,
	          pointHoverBackgroundColor: 'rgba(236, 184, 92, 1)',
	          pointHoverBorderColor: 'rgba(236, 184, 92, 1)',
	          pointHoverBorderWidth: 2,
	          pointRadius: 3,
	          pointHitRadius: 5,
	          data: pReporting.granularity.map(function (item) {
	            return parseFloat(item.localSpend.amount);
	          })
	        }]
	      };
	
	      var conversionRateData = {
	        labels: labels,
	        datasets: [{
	          label: 'Conversion Rate',
	          fill: false,
	          lineTension: 0.1,
	          backgroundColor: 'rgba(75,192,192,0.4)',
	          borderColor: 'rgba(114, 90, 166, 1)',
	          borderCapStyle: 'butt',
	          borderDash: [],
	          borderDashOffset: 0.0,
	          borderJoinStyle: 'miter',
	          pointBorderColor: 'rgba(114, 90, 166, 1)',
	          pointBackgroundColor: '#fff',
	          pointBorderWidth: 2,
	          pointHoverRadius: 5,
	          pointHoverBackgroundColor: 'rgba(114, 90, 166, 1)',
	          pointHoverBorderColor: 'rgba(114, 90, 166, 1)',
	          pointHoverBorderWidth: 2,
	          pointRadius: 3,
	          pointHitRadius: 5,
	          data: pReporting.granularity.map(function (item) {
	            return item.conversionRate;
	          })
	        }]
	      };
	      _this.setState({ currentReport: {
	          budgetLeft: budgetLeft,
	          totalSpent: totalSpent,
	          totalDownloads: totalNewDownloads + totalReDownloads,
	          avgCPA: avgCPA,
	          conversionRate: conversionRate,
	          cpaData: cpaData,
	          downLoadsData: downLoadsData,
	          budgetSpendData: budgetSpendData,
	          conversionRateData: conversionRateData,
	          startTime: (0, _moment2.default)(pData.startTime),
	          ttr: ttr
	        } });
	    };
	
	    _moment2.default.locale('zh-cn');
	
	    _this.state = {
	      startDate: null,
	      endDate: null,
	      isShowBudgetModal: false,
	      isShowCheckoutModal: false,
	      storeInfo: null,
	      searchAdsInfo: null,
	      appRecord: null, //storing cid in each region
	      currentRegion: null,
	      isReportLoading: false,
	      stripe: null,
	      addBudgetData: null,
	      isCampaignRunning: false
	    };
	    _this.onDatesChange = _this.onDatesChange.bind(_this);
	    _this.onFocusChange = _this.onFocusChange.bind(_this);
	    _this.goToAso = _this.goToAso.bind(_this);
	    _this.onRegionSelected = _this.onRegionSelected.bind(_this);
	    _this.getCampaignReportingData = _this.getCampaignReportingData.bind(_this);
	    _this.getCampaignMetaData = _this.getCampaignMetaData.bind(_this);
	    _this.updateReport = _this.updateReport.bind(_this);
	    _this.onBudgetComfirmed = _this.onBudgetComfirmed.bind(_this);
	    return _this;
	  }
	
	  _createClass(Dashboard, [{
	    key: 'onDatesChange',
	    value: function onDatesChange(_ref5) {
	      var startDate = _ref5.startDate,
	          endDate = _ref5.endDate;
	
	      console.log('ondates change : ', startDate, endDate);
	      this.setState({ startDate: startDate, endDate: endDate });
	
	      // console.log( moment(startDate).format('YYYY-MM-DD'))
	    }
	  }, {
	    key: 'onFocusChange',
	    value: function onFocusChange(focusedInput) {
	      this.setState({ focusedInput: focusedInput });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	        var _this3 = this;
	
	        var params, storeInfo, searchAdsInfo, appRecord, currentRegion, region, pCid, dIndex, _props$auth, userProfile, getProfile;
	
	        return _regenerator2.default.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                params = this.props.match.params;
	                _context5.next = 3;
	                return this.getItunesStoreData(params.appId);
	
	              case 3:
	                storeInfo = _context5.sent;
	                _context5.next = 6;
	                return this.getSearchAdsData(params.appId);
	
	              case 6:
	                searchAdsInfo = _context5.sent;
	
	                console.log('searchAdsInfo : ', searchAdsInfo); //appId complu
	
	                this.setState({ storeInfo: storeInfo, searchAdsInfo: searchAdsInfo, appId: params.appId });
	                console.log('params : ', params); //appId complu
	                //dcid pcid // region
	                // itunesAppInfo
	
	                if (true) {
	                  _context5.next = 17;
	                  break;
	                }
	
	                _context5.next = 13;
	                return this.getAppRecord(params.appId);
	
	              case 13:
	                appRecord = _context5.sent;
	                currentRegion = void 0;
	
	                if (!params.dcid || !params.pcid || !params.region) {
	                  region = appRecord.performanceByRegion[0].region;
	                  pCid = appRecord.performanceByRegion[0].campaignId;
	                  /**
	                   * dIndex must be > -1 due to current camapgin creation mehcnaism 
	                   */
	
	                  dIndex = appRecord.discoveryByRegion.findIndex(function (item) {
	                    return item.region === region;
	                  });
	
	                  currentRegion = {
	                    region: region,
	                    pCid: pCid,
	                    dCid: appRecord.discoveryByRegion[dIndex].campaignId
	                  };
	                } else {
	                  currentRegion = {
	                    region: params.region,
	                    pCid: params.pcid,
	                    dCid: params.dcid
	                  };
	                }
	                this.setState({ appRecord: appRecord, currentRegion: currentRegion });
	
	              case 17:
	
	                //load stripe
	                if (window.Stripe) {
	                  this.setState({ stripe: window.Stripe(_stripe2.default) });
	                } else {
	                  document.querySelector('#stripe-js').addEventListener('load', function () {
	                    // Create Stripe instance once Stripe.js loads
	                    _this3.setState({ stripe: window.Stripe(_stripe2.default) });
	                  });
	                }
	
	                //load profile
	                this.setState({ profile: {} });
	                _props$auth = this.props.auth, userProfile = _props$auth.userProfile, getProfile = _props$auth.getProfile;
	
	                if (!userProfile) {
	                  getProfile(function (err, profile) {
	                    _this3.setState({ profile: profile });
	                  });
	                } else {
	                  this.setState({ profile: userProfile });
	                }
	
	              case 21:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, this);
	      }));
	
	      function componentDidMount() {
	        return _ref6.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'getItunesStoreData',
	
	
	    /**
	     * to be redux saga 
	     * @param {*} appId 
	     * @param {*} country 
	     */
	    value: function () {
	      var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(appId, country) {
	        var API_PUBLIC_SEARCH, response, results;
	        return _regenerator2.default.wrap(function _callee6$(_context6) {
	          while (1) {
	            switch (_context6.prev = _context6.next) {
	              case 0:
	                API_PUBLIC_SEARCH = 'https://itunes.apple.com/lookup';
	                _context6.prev = 1;
	                _context6.next = 4;
	                return _axios2.default.post(API_PUBLIC_SEARCH, {}, { params: { id: appId, 'Authorization': 'Bear xsjsjsjsjkss', country: country } });
	
	              case 4:
	                response = _context6.sent;
	
	                console.log('[getItunesStoreData] ', response.data.results); // error is not defined
	                results = response.data.results;
	
	                if (!(results.length > 0)) {
	                  _context6.next = 11;
	                  break;
	                }
	
	                return _context6.abrupt('return', results[0]);
	
	              case 11:
	                return _context6.abrupt('return', null);
	
	              case 12:
	                _context6.next = 18;
	                break;
	
	              case 14:
	                _context6.prev = 14;
	                _context6.t0 = _context6['catch'](1);
	
	                console.log('[getItunesStoreData] ', _context6.t0); // error is not defined
	                return _context6.abrupt('return', null);
	
	              case 18:
	              case 'end':
	                return _context6.stop();
	            }
	          }
	        }, _callee6, this, [[1, 14]]);
	      }));
	
	      function getItunesStoreData(_x7, _x8) {
	        return _ref7.apply(this, arguments);
	      }
	
	      return getItunesStoreData;
	    }()
	
	    //to be redux saga
	
	  }, {
	    key: 'getSearchAdsData',
	    value: function () {
	      var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(appId) {
	        var API_PUBLIC_SEARCH, response;
	        return _regenerator2.default.wrap(function _callee7$(_context7) {
	          while (1) {
	            switch (_context7.prev = _context7.next) {
	              case 0:
	                API_PUBLIC_SEARCH = _server2.default + '/searchads/public/search/';
	                _context7.prev = 1;
	                _context7.next = 4;
	                return _axios2.default.get(API_PUBLIC_SEARCH, { params: { searchValue: appId } });
	
	              case 4:
	                response = _context7.sent;
	
	                console.log('[getSearchAdsData] ', response.data);
	
	                if (!(response.data.length > 0)) {
	                  _context7.next = 10;
	                  break;
	                }
	
	                return _context7.abrupt('return', response.data[0]);
	
	              case 10:
	                return _context7.abrupt('return', null);
	
	              case 11:
	                _context7.next = 17;
	                break;
	
	              case 13:
	                _context7.prev = 13;
	                _context7.t0 = _context7['catch'](1);
	                return _context7.abrupt('return', []);
	
	              case 17:
	              case 'end':
	                return _context7.stop();
	            }
	          }
	        }, _callee7, this, [[1, 13]]);
	      }));
	
	      function getSearchAdsData(_x9) {
	        return _ref8.apply(this, arguments);
	      }
	
	      return getSearchAdsData;
	    }()
	  }, {
	    key: 'getAppRecord',
	    value: function () {
	      var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(appId) {
	        var getAccessToken, headers, response;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                getAccessToken = this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                _context8.prev = 2;
	                _context8.next = 5;
	                return _axios2.default.get(_server2.default + '/user/campaigns/appid/' + appId, { headers: headers });
	
	              case 5:
	                response = _context8.sent;
	
	                console.log('[getAppRecord] ', response.data.response);
	                return _context8.abrupt('return', response.data.response);
	
	              case 10:
	                _context8.prev = 10;
	                _context8.t0 = _context8['catch'](2);
	
	                //no error for this api except network / timeout issue
	                console.log('[getAppRecord] ', _context8.t0);
	                return _context8.abrupt('return', []);
	
	              case 14:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this, [[2, 10]]);
	      }));
	
	      function getAppRecord(_x10) {
	        return _ref9.apply(this, arguments);
	      }
	
	      return getAppRecord;
	    }()
	
	    /**
	     * 
	     * @param {*} cid 
	     */
	
	  }, {
	    key: 'getCampaignMetaData',
	    value: function () {
	      var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(cid) {
	        var getAccessToken, headers, response;
	        return _regenerator2.default.wrap(function _callee9$(_context9) {
	          while (1) {
	            switch (_context9.prev = _context9.next) {
	              case 0:
	                getAccessToken = this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	
	
	                this.setState({ isCampaignRunning: false });
	                _context9.prev = 3;
	                _context9.next = 6;
	                return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + cid, { headers: headers });
	
	              case 6:
	                response = _context9.sent;
	
	                console.log('[getCampaignMetaData] ', cid, response.data.response.data);
	
	                if (response.data.response.data.storefront == this.state.currentRegion.region) {
	                  this.setState({
	                    isCampaignRunning: response.data.response.data.servingStatus == "RUNNING"
	                  });
	                }
	
	                return _context9.abrupt('return', response.data.response.data);
	
	              case 12:
	                _context9.prev = 12;
	                _context9.t0 = _context9['catch'](3);
	
	                console.log('[getCampaignMetaData] ', cid, _context9.t0);
	                return _context9.abrupt('return', null);
	
	              case 16:
	              case 'end':
	                return _context9.stop();
	            }
	          }
	        }, _callee9, this, [[3, 12]]);
	      }));
	
	      function getCampaignMetaData(_x11) {
	        return _ref10.apply(this, arguments);
	      }
	
	      return getCampaignMetaData;
	    }()
	    /**
	     * 
	     * @param {*} cid campaign id in search ads 
	     * @param {*} startDate string formateed YYYY-MM-DD
	     * @param {*} endDate string formateed YYYY-MM-DD
	     */
	
	  }, {
	    key: 'getCampaignReportingData',
	    value: function () {
	      var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(cid, startDate, endDate) {
	        var getAccessToken, headers, responseTotal, responseGranularity, totalData, granularity;
	        return _regenerator2.default.wrap(function _callee10$(_context10) {
	          while (1) {
	            switch (_context10.prev = _context10.next) {
	              case 0:
	                getAccessToken = this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                _context10.prev = 2;
	                _context10.next = 5;
	                return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + cid + '/adgroups/rowtotals/' + startDate + '/' + endDate, { headers: headers });
	
	              case 5:
	                responseTotal = _context10.sent;
	                _context10.next = 8;
	                return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + cid + '/adgroups/granularity/' + startDate + '/' + endDate, { headers: headers });
	
	              case 8:
	                responseGranularity = _context10.sent;
	
	                if (!(responseTotal.data.response.pagination.totalResults > 0)) {
	                  _context10.next = 16;
	                  break;
	                }
	
	                totalData = responseTotal.data.response.data.reportingDataResponse.row[0].total;
	                granularity = responseGranularity.data.response.data.reportingDataResponse.row[0].granularity;
	
	                console.log('[getCampaignReportingData] ', cid, totalData, granularity);
	                return _context10.abrupt('return', {
	                  totalData: totalData,
	                  granularity: granularity
	                });
	
	              case 16:
	                return _context10.abrupt('return', {
	                  totalData: null,
	                  granularity: []
	                });
	
	              case 17:
	                _context10.next = 23;
	                break;
	
	              case 19:
	                _context10.prev = 19;
	                _context10.t0 = _context10['catch'](2);
	
	                console.log('[getCampaignReportingData] ', cid, _context10.t0);
	                return _context10.abrupt('return', {
	                  totalData: null,
	                  granularity: []
	                });
	
	              case 23:
	              case 'end':
	                return _context10.stop();
	            }
	          }
	        }, _callee10, this, [[2, 19]]);
	      }));
	
	      function getCampaignReportingData(_x12, _x13, _x14) {
	        return _ref11.apply(this, arguments);
	      }
	
	      return getCampaignReportingData;
	    }()
	  }, {
	    key: 'translateCnName',
	    value: function translateCnName(region) {
	      var customFlagLabels = {
	        "US": "美国",
	        "GB": "英国",
	        "CA": "加拿大",
	        "CH": "瑞士",
	        "MX": "墨西哥",
	        "ZH": "ZH",
	        "AU": "澳大利亚",
	        "NZ": "新西兰",
	        "IT": "義大利",
	        "FR": "法國",
	        "DE": "德國",
	        "ES": "西班牙",
	        "JP": "日本",
	        "KR": "韓國"
	      };
	      var CnName = customFlagLabels[region];
	      if (!CnName || CnName.length <= 0) return region;
	      return CnName;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	      var _props = this.props,
	          searchTerm = _props.searchTerm,
	          currentApp = _props.currentApp,
	          secondApp = _props.secondApp,
	          campaign = _props.campaign;
	      var _state = this.state,
	          storeInfo = _state.storeInfo,
	          searchAdsInfo = _state.searchAdsInfo,
	          currentRegion = _state.currentRegion,
	          appRecord = _state.appRecord,
	          currentReport = _state.currentReport,
	          isReportLoading = _state.isReportLoading;
	
	
	      var wisgetPageStyle = {
	        display: 'flex',
	        flexFlow: 'row wrap',
	        alignItems: 'flex-start',
	        padding: '15px',
	        overflow: 'hidden',
	        background: '#F3F3F3'
	      };
	
	      // const stackConfig = {
	      //   ...rechartConfigs.StackedAreaChart,
	      //   width: window.innerWidth < 450 ? 300 : 500
	      // };
	
	      var start = (0, _moment2.default)();
	      var end = (0, _moment2.default)();
	
	      var menuSubmenu =
	      // if ( process.env.REACT_APP_STAGE === 'fake'){
	      _react2.default.createElement(
	        _dropdown.DropdownMenu,
	        { onClick: function onClick(value) {
	            return _this4.onRegionSelected(value);
	          } },
	        _react2.default.createElement(
	          _dropdown.MenuItem,
	          { key: "ALL" },
	          "所有已投放國家"
	        ),
	        searchAdsInfo && searchAdsInfo.storeFrontCountryCodes && searchAdsInfo.storeFrontCountryCodes.map(function (region) {
	          return _react2.default.createElement(
	            _dropdown.MenuItem,
	            { key: region },
	            _react2.default.createElement(_reactWorldFlags2.default, { style: { width: '36px' }, code: region }),
	            _this4.translateCnName(region)
	          );
	        })
	      );
	
	      return _react2.default.createElement(
	        _style.DashboardWrapper,
	        null,
	        this.state.isReportLoading && _react2.default.createElement(_index6.default, null),
	        _react2.default.createElement(
	          'style',
	          null,
	          "\
	        .ant-tooltip-content { position: relative; }\
	        .ant-tooltip-inner {\
	          padding: 18px;\
	          padding-bottom: 21px;\
	          background-color: rgba(0, 0, 0, .65);\
	          line-height: 16px;\
	          font-family: 'Montserrat';\
	          font-size: 13px;\
	          font-weight: 300;\
	          color: rgba(255, 255, 255, 1);\
	          letter-spacing: 0.04em;\
	          border-radius: 10px;\
	          text-shadow: 0 0 1px #555;\
	        }\
	        .ant-tooltip-placement-top .ant-tooltip-arrow {\
	          position: absolute;\
	          bottom: 0;\
	          border-top-color: rgba(0, 0, 0, .4);\
	          transform: translateY(100%);\
	        }\
	      "
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          ("fake") !== 'fake' && _react2.default.createElement(
	            'dl',
	            { className: 'app' },
	            _react2.default.createElement(
	              'dt',
	              null,
	              _react2.default.createElement('img', { src: storeInfo ? storeInfo.artworkUrl100 : '', alt: 'screen' })
	            ),
	            _react2.default.createElement(
	              'dd',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                storeInfo ? storeInfo.trackCensoredName : ''
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  storeInfo ? storeInfo.sellerName : ''
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  currentReport && currentReport.startTime && currentReport.startTime.format("于YYYY年MM月DD日 (dddd)开始")
	                )
	              )
	            )
	          ),
	          ("fake") === 'fake' && _react2.default.createElement(
	            'dl',
	            { className: 'app' },
	            _react2.default.createElement(
	              'dt',
	              null,
	              _react2.default.createElement('img', { src: currentApp.artworkUrl100, alt: 'screen' })
	            ),
	            _react2.default.createElement(
	              'dd',
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                currentApp.trackCensoredName
	              ),
	              _react2.default.createElement(
	                'h2',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  currentApp.sellerName
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'Started on ',
	                  currentReport ? currentReport.startTime : "Tue, Jan 24, 2018"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { className: 'round-border-wrapper', onClick: this.handleAddCampClick },
	            _react2.default.createElement('div', { className: 'emulate-plus' }),
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u6DFB\u52A0\u5E7F\u544A\u9879\u76EE'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'header-controls' },
	            _react2.default.createElement(
	              'dl',
	              { className: 'budget-left' },
	              _react2.default.createElement(
	                'dt',
	                null,
	                '\u4F59\u989D'
	              ),
	              _react2.default.createElement(
	                'dd',
	                null,
	                currentReport ? '$ ' + currentReport.budgetLeft : '$ --'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'round-border-wrapper add-budget',
	                onClick: function onClick() {
	                  _this4.onOpenAddBudgetModal();
	                }
	              },
	              _react2.default.createElement('div', { className: 'emulate-plus' }),
	              _react2.default.createElement(
	                'span',
	                null,
	                '$'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '\u589E\u52A0\u9884\u7B97'
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'round-border-wrapper campaign-state',
	                onClick: function onClick() {
	                  _this4.changeCampaignState(!_this4.state.isCampaignRunning);
	                }
	              },
	              _react2.default.createElement('img', { src: this.state.isCampaignRunning && _running2.default || _pause2.default }),
	              _react2.default.createElement(
	                'p',
	                null,
	                this.state.isCampaignRunning && "运行中" || "已暂停"
	              )
	            ),
	            _react2.default.createElement(
	              'button',
	              { className: 'round-border-wrapper refresh', onClick: function onClick() {
	                  _this4.updateResult(true, null);
	                } },
	              _react2.default.createElement('img', { src: _refresh2.default }),
	              _react2.default.createElement(
	                'p',
	                null,
	                '\u5237\u65B0'
	              )
	            )
	          ),
	          !isReportLoading && _react2.default.createElement(_index2.default, {
	            defaultBudget: 1000.00,
	            budgetLeft: currentReport ? currentReport.budgetLeft : 259.54,
	            defaultRegion: currentRegion ? currentRegion.region : 'US',
	            storeFrontCountryCodes: searchAdsInfo ? searchAdsInfo.storeFrontCountryCodes : [],
	            onBudgetComfirmed: this.onBudgetComfirmed,
	            isOpened: this.state.isShowBudgetModal,
	            onClose: function onClose() {
	              _this4.onCloseAddBudgetModal();
	            }
	          }),
	          this.state.addBudgetData && _react2.default.createElement(
	            _reactResponsiveModal2.default,
	            {
	              open: this.state.isShowCheckoutModal,
	              onClose: function onClose() {
	                _this4.onCloseCheckoutModal();
	              },
	              center: true,
	              classNames: { modal: 'checkout-modal' } },
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                ' Appid : ',
	                this.state.addBudgetData.appId
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                ' region : ',
	                this.state.addBudgetData.region
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                ' budget : USD ',
	                this.state.addBudgetData.budget
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-info' },
	              _react2.default.createElement(
	                _reactStripeElements.StripeProvider,
	                { stripe: this.state.stripe },
	                _react2.default.createElement(
	                  _reactStripeElements.Elements,
	                  null,
	                  _react2.default.createElement(_CheckoutForm2.default, {
	                    fontSize: '18px',
	                    updateResult: this.updateResult.bind(this),
	                    updateError: this.updateError.bind(this),
	                    campaign: this.state.campaign,
	                    currentApp: currentApp,
	                    auth: this.props.auth,
	                    profile: this.state.profile,
	                    addBudgetData: this.state.addBudgetData
	                  })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: wisgetPageStyle, className: 'main' },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: rowStyle, gutter: 0, justify: 'start' },
	            _react2.default.createElement(
	              _antd.Col,
	              { sm: 24, xs: 24, md: 16, lg: 18, xl: 18, style: colStyle, className: 'charts' },
	              _react2.default.createElement(
	                _antd.Row,
	                { style: rowStyle, gutter: 0, justify: 'start' },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { md: 24, sm: 24, xs: 24, style: colStyle, className: 'charts' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'chart-controls' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'round-border-wrapper countries' },
	                      _react2.default.createElement(
	                        _dropdown2.default,
	                        { overlay: menuSubmenu },
	                        _react2.default.createElement(
	                          'p',
	                          null,
	                          _react2.default.createElement(
	                            'a',
	                            { className: 'ant-dropdown-link' },
	                            currentRegion ? _react2.default.createElement(
	                              'span',
	                              null,
	                              _react2.default.createElement(_reactWorldFlags2.default, { style: { width: '36px' }, code: currentRegion.region }),
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                this.translateCnName(currentRegion.region)
	                              )
	                            ) : "全部已投放国家"
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'round-border-wrapper date-range' },
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement('img', { src: _calendar2.default }),
	                        this.state.startDate && this.state.endDate && (0, _moment2.default)(this.state.startDate).format('YYYY-MM-DD') + '->' + (0, _moment2.default)(this.state.endDate).format('YYYY-MM-DD')
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'isoCalendarDatePicker' },
	                        _react2.default.createElement(_reactDates.DateRangePicker, {
	                          lang: 'zh-cn',
	                          startDate: this.state.startDate // momentPropTypes.momentObj or null,
	                          , startDateId: 'your_unique_start_date_id' // PropTypes.string.isRequired,
	                          , endDate: this.state.endDate // momentPropTypes.momentObj or null,
	                          , endDateId: 'your_unique_end_date_id' // PropTypes.string.isRequired,
	                          , focusedInput: this.state.focusedInput // PropTypes.oneOf([START_DATE, END_DATE]) or null,
	                          , onDatesChange: this.onDatesChange,
	                          onFocusChange: this.onFocusChange,
	                          isOutsideRange: function isOutsideRange() {
	                            return false;
	                          }
	                        })
	                      )
	                    ),
	                    _react2.default.createElement(
	                      ExcelFile,
	                      { element: _react2.default.createElement(
	                          'button',
	                          { className: 'round-border-wrapper download' },
	                          _react2.default.createElement('img', { src: _download2.default }),
	                          _react2.default.createElement(
	                            'p',
	                            null,
	                            '\u4E0B\u8F7D\u6570\u636E\u62A5\u544A'
	                          )
	                        ) },
	                      _react2.default.createElement(
	                        ExcelSheet,
	                        { data: downLoadsData.datasets[0].data.map(function (v) {
	                            return { value: v };
	                          }), name: 'Dashboard CSV data' },
	                        downLoadsData.labels.map(function (label, index) {
	                          return _react2.default.createElement(ExcelColumn, { label: label, value: 'value' });
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                { style: rowStyle, gutter: 16, justify: 'start' },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { sm: 24, xs: 24, md: 12, lg: 12, xl: 6, style: colStyle },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'responsiveBlock' },
	                    _react2.default.createElement(_saleWidget2.default, {
	                      top: '#47B2AA',
	                      price: currentReport ? currentReport.totalDownloads : "--",
	                      details: "下载量",
	                      fontColor: '#403739',
	                      tooltipTitle: 'Number of users who downloaded the app.',
	                      tooltip: _react2.default.createElement(
	                        'span',
	                        { className: "dashboard-tooltip" },
	                        '?'
	                      ),
	                      tooltipPlacement: 'bottom'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { sm: 24, xs: 24, md: 12, lg: 12, xl: 6, style: colStyle },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'responsiveBlock' },
	                    _react2.default.createElement(_saleWidget2.default, {
	                      top: 'rgba(93, 215, 255, 1)',
	                      price: currentReport ? "$ " + currentReport.avgCPA.toFixed(2) : "$ --",
	                      details: "获客成本",
	                      fontColor: '#403739',
	                      tooltipTitle: 'The average amount of budget paid to acquire a single install.',
	                      tooltip: _react2.default.createElement(
	                        'span',
	                        { className: "dashboard-tooltip" },
	                        '?'
	                      ),
	                      tooltipPlacement: 'bottom'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { sm: 24, xs: 24, md: 12, lg: 12, xl: 6, style: colStyle },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'responsiveBlock' },
	                    _react2.default.createElement(_saleWidget2.default, {
	                      top: 'rgba(235, 183, 99, 1)',
	                      price: currentReport ? "$ " + currentReport.totalSpent.toFixed(2) : "$ --",
	                      details: "预算消耗",
	                      fontColor: '#403739',
	                      tooltipTitle: 'Total amount of budget spent.',
	                      tooltip: _react2.default.createElement(
	                        'span',
	                        { className: "dashboard-tooltip" },
	                        '?'
	                      ),
	                      tooltipPlacement: 'bottom'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { sm: 24, xs: 24, md: 12, lg: 12, xl: 6, style: colStyle },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'responsiveBlock' },
	                    _react2.default.createElement(_saleWidget2.default, {
	                      price: currentReport ? currentReport.conversionRate * 100 + "%" : "--%",
	                      details: "转化率",
	                      fontColor: '#403739',
	                      tooltipTitle: 'Percentage of users who downloaded the app out of total number of visitors who arrived at the App Store page.',
	                      tooltip: _react2.default.createElement(
	                        'span',
	                        { className: "dashboard-tooltip" },
	                        '?'
	                      ),
	                      tooltipPlacement: 'bottom'
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                { style: rowStyle, gutter: 16, justify: 'start' },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { md: 24, sm: 24, xs: 24, style: colStyle, className: 'charts' },
	                  _react2.default.createElement(
	                    _box2.default,
	                    null,
	                    _react2.default.createElement(
	                      _contentHolder2.default,
	                      null,
	                      _react2.default.createElement(
	                        _rcTabs2.default,
	                        {
	                          defaultActiveKey: '1',
	                          renderTabBar: function renderTabBar() {
	                            return _react2.default.createElement(_ScrollableInkTabBar2.default, {
	                              pageSize: 4,
	                              speed: 5
	                            });
	                          },
	                          renderTabContent: function renderTabContent() {
	                            return _react2.default.createElement(_TabContent2.default, null);
	                          }
	                        },
	                        _react2.default.createElement(
	                          _rcTabs.TabPane,
	                          { tab: '\u4E0B\u8F7D\u91CF', key: '1' },
	                          _react2.default.createElement(_reactChartjs.Line, { data: currentReport ? currentReport.downLoadsData : downLoadsData, options: { maintainAspectRatio: false } })
	                        ),
	                        _react2.default.createElement(
	                          _rcTabs.TabPane,
	                          { tab: '\u83B7\u5BA2\u6210\u672C', key: '2' },
	                          _react2.default.createElement(_reactChartjs.Line, { data: currentReport ? currentReport.cpaData : cpaData, options: { maintainAspectRatio: false } })
	                        ),
	                        _react2.default.createElement(
	                          _rcTabs.TabPane,
	                          { tab: '\u9884\u7B97\u6D88\u8017', key: '3' },
	                          _react2.default.createElement(_reactChartjs.Line, { data: currentReport ? currentReport.budgetSpendData : budgetSpendData, options: { maintainAspectRatio: false } })
	                        ),
	                        _react2.default.createElement(
	                          _rcTabs.TabPane,
	                          { tab: '\u8F6C\u5316\u7387', key: '4' },
	                          _react2.default.createElement(_reactChartjs.Line, { data: currentReport ? currentReport.conversionRateData : conversionRateData, options: { maintainAspectRatio: false } })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { sm: 24, xs: 24, md: 8, lg: 6, xl: 6, style: colStyle, className: 'iphone-container' },
	              _react2.default.createElement(
	                _contentHolder2.default,
	                null,
	                ("fake") === 'fake' && currentApp && secondApp && searchTerm && _react2.default.createElement(_AdPreview2.default, {
	                  currentApp: currentApp,
	                  secondApp: secondApp,
	                  searchTerm: searchTerm
	                }),
	                ("fake") !== 'fake' && storeInfo && _react2.default.createElement(_AdPreview2.default, {
	                  currentApp: storeInfo,
	                  secondApp: storeInfo,
	                  searchTerm: 'search'
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: rowStyle, gutter: 0, justify: 'start' },
	            _react2.default.createElement(
	              _antd.Col,
	              { md: 8, sm: 24, xs: 24, style: colStyle, className: 'tap-through-container' },
	              _react2.default.createElement(
	                _widgetsWrapper2.default,
	                null,
	                _react2.default.createElement(
	                  _box2.default,
	                  { title: '' },
	                  _react2.default.createElement(
	                    _contentHolder2.default,
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { style: { padding: '46px 38px' } },
	                      _react2.default.createElement(
	                        'label',
	                        { style: { 'paddingBottom': '14px' } },
	                        '\u70B9\u51FB\u8F6C\u5316\u7387',
	                        _react2.default.createElement(
	                          _tooltip2.default,
	                          { title: "Percentage of number of users who tap through to arrive at the App Store page out of total number of users who viewed the ad." },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'dashboard-tooltip' },
	                            '?'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(_index4.default, {
	                          arcWidth: 130,
	                          arcData: [{ percentage: 1, strokeColor: "#cfc9de" }],
	                          strokeWidth: 8,
	                          strokeColor: 'rgba(114, 92, 164, 1)',
	                          percentage: currentReport ? (currentReport.ttr * 100).toFixed(1) : "0.0",
	                          textData: {
	                            fontColor: "rgba(114, 92, 164, 1)",
	                            fontSize: "35px"
	                          }
	                        })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: { display: 'block', 'paddingTop': '14px', 'textAlign': 'center' } },
	                        _react2.default.createElement(
	                          _ButtonAction2.default,
	                          {
	                            onClick: this.goToAso,
	                            style: { margin: '0 auto' }
	                          },
	                          'ASO\u4F18\u5316'
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { md: 16, sm: 24, xs: 24, style: colStyle, className: 'tracking-accounts' },
	              _react2.default.createElement(
	                _widgetsWrapper2.default,
	                null,
	                _react2.default.createElement(
	                  _widgetBox2.default,
	                  { height: 300 },
	                  _react2.default.createElement(
	                    _contentHolder2.default,
	                    null,
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'firstLine' },
	                      '\u6295\u8D44\u56DE\u62A5\u7387 (ROI) ',
	                      _react2.default.createElement(
	                        _tooltip2.default,
	                        { title: "Profitability ratio of total revenue to total budget spent." },
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'dashboard-tooltip' },
	                          '?'
	                        )
	                      ),
	                      _react2.default.createElement('br', null),
	                      _react2.default.createElement('br', null)
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'secondLine' },
	                      '\u8FDE\u63A5\u4F60\u7684\u76D1\u6D4B\u5E73\u53F0\u5E10\u6237\u83B7\u5F97\u6295\u8D44\u56DE\u62A5\u7387\u6570\u636E'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'thirdLine' },
	                      _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start' },
	                        _react2.default.createElement(_antd.Col, { md: 4, sm: 24, xs: 24 }),
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 8, sm: 24, xs: 24, className: 'acc-flyer' },
	                          _react2.default.createElement('img', { className: 'trackingAccount', src: ("") + _apps_flyer2.default })
	                        ),
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 8, sm: 24, xs: 24, className: 'acc-adjust' },
	                          _react2.default.createElement('img', { className: 'trackingAccount', src: ("") + _adjust2.default })
	                        ),
	                        _react2.default.createElement(_antd.Col, { md: 4, sm: 24, xs: 24 }),
	                        _react2.default.createElement(_antd.Col, { md: 4, sm: 24, xs: 24 }),
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 8, sm: 24, xs: 24, className: 'acc-tune' },
	                          _react2.default.createElement('img', { className: 'trackingAccount', src: ("") + _tune2.default })
	                        ),
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 8, sm: 24, xs: 24, className: 'acc-kochava' },
	                          _react2.default.createElement('img', { className: 'trackingAccount', src: ("") + _Kochava2.default })
	                        ),
	                        _react2.default.createElement(_antd.Col, { md: 4, sm: 24, xs: 24 })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Dashboard;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	
	  };
	}
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    auth0SignUp: state.get('deep').auth0SignUp,
	    auth0SignIn: state.get('deep').auth0SignIn,
	    campaign: state.get('campaign'),
	    isLoggedIn: false, //state.Auth.get('idToken') !== null ? true : false,
	    currentApp: state.getIn(['ItunesSearch', 'currentApp']),
	    secondApp: state.getIn(['ItunesSearch', 'secondApp']),
	    searchTerm: state.getIn(['ItunesSearch', 'searchTerm'])
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Dashboard);

/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HomeWrapper = exports.WidgetWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 10px;\n\n  @media only screen and (max-width: 767) {\n    margin-right: 0 !important;\n  }\n\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-bottom: 20px;\n'], ['\n  margin: 0 10px;\n\n  @media only screen and (max-width: 767) {\n    margin-right: 0 !important;\n  }\n\n  padding-left: 20px;\n  padding-right: 20px;\n  padding-bottom: 20px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n\n// temp fix for ugly textarea\n    input:not([type="radio"]):not([type="checkbox"]), textarea {\n        padding: 0rem; \n    }\n    .ant-col-md-12 {\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n\n    .rc-tabs-top{\n        overflow-y: hidden;\n    }\n    .rc-tabs-ink-bar{\n        background-color: rgba(60, 211, 207, 1);\n    }\n    .rc-tabs-tab{\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(64, 55, 57, 1);\n    }\n    .rc-tabs-tab:hover {\n        color: rgba(64, 55, 57, 1);\n    }\n    .rc-tabs-tab-active {\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(64, 55, 57, 1);\n    } \n    .rc-tabs-tab-active:hover {\n        color: rgba(64, 55, 57, 1);\n    }\n\n    .inputWrapper {\n        padding-left: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n        margin-bottom: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            padding-right: 20px;\n            display: flex;\n\n            div {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n            input {\n                width: 100%;\n                border: none;\n            }\n\n            input:focus{\n                outline: unset;\n            }\n\n            input[type=number] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n                width: 3px;\n                border-left: 1px solid rgba(151, 151, 151, 1);\n            }\n            \n        }\n        \n        .react-tagsinput {\n            width: 213px;\n            border: 1px solid rgba(151,151,151,1);\n            border-radius: 20px;\n            display: -webkit-inline-box;\n\n            span {\n                padding-left: 10px;\n            }\n        }\n    \n        label {\n            left: -32px;\n            position: relative;\n            width: 213px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .isoInputWrapper {\n        margin-bottom: 15px;\n        justify-content: center;\n        align-items: center;\n        vertical-align: center;\n        display: flex;\n        border: 1px solid rgba(147, 147, 147, 1);\n        border-radius: 20px;\n\n        &:last-of-type {\n          margin-bottom: 0;\n        }\n        .searchIcon{\n          width: 18px;\n          height: 18px;\n        }\n      \n        .searchInput{\n          width: 250px;\n          display: inline-block;\n\n          .Select-control {\n            border: none;\n            background-color: rgba(0,0,0,0.1);\n\n            .Select-input:focus {\n                background: rgba(255, 255, 255, 1);\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                color: rgba(147, 147, 147, 1);\n                text-align: justify;\n                letter-spacing: 0.04em;\n            }\n          }\n          .Select-placeholder {\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n          .Select-value{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n\n          input{\n            border: none;\n          }\n          \n        }\n        .regionInput{\n          display: inline-block;\n          .country-flag img{\n            top: 0;\n          }\n\n          span{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n          }\n        }\n    }\n\n\n    // ENd of resuable componetns\n\n    .blackSection {\n        background-color: rgba(35, 31, 32, 1);\n        color: #fff;\n        position: relative;\n        z-index: 12;\n        box-shadow: 0px 2px 4px 0px rgba(122, 122, 122, 0.5);\n        .appDisplay__app-display {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center; }\n    }\n\n    \n\n    .o-wrapper {\n        padding-top: 16px;\n\n        max-width: 1020px;\n        padding-right: 1.5rem;\n        padding-left: 1.5rem;\n        margin-right: auto;\n        margin-left: auto; }\n        @media (min-width: 768px) {\n          .o-wrapper {\n            padding-right: 40px;\n            padding-left: 40px; } }\n        @media (min-width: 1281px) {\n          .o-wrapper {\n            max-width: 1120px;\n            padding-right: 1.5rem;\n            padding-left: 1.5rem; } }\n\n    .appDisplayImg__app-display {\n        padding-right: 0.75rem; }\n        .appDisplayImg__app-display > img {\n          border: 1px solid #D8D8D8;\n          width: 3.25rem;\n          height: 3.25rem;\n          max-width: none;\n          border-radius: 1rem; }\n        @media (min-width: 480px) {\n          .appDisplayImg__app-display {\n            padding-right: 1.5rem; }\n            .appDisplayImg__app-display > img {\n              width: 4.25rem;\n              height: 4.25rem; } }\n      \n    .appName__app-display,\n    .appLongName__app-display {\n        margin-top: 0px;\n\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(255, 255, 255, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n        /*Text styles for S */\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(255, 255, 255, 1);\n        text-align: left;\n    }\n        // @media (min-width: 480px) {\n        //   .appName__app-display,\n        //   .appLongName__app-display {\n        //     font-size: 2rem; } }\n        // @media (min-width: 1281px) {\n        //   .appName__app-display,\n        //   .appLongName__app-display {\n        //     font-size: 2.25rem; } }\n      \n    .appPublisher__app-display {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(255, 255, 255, 1);\n        text-align: left;\n        letter-spacing: 0.07em;\n        margin-top: 8px;\n\n    }\n    .appPublisher__app-display > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    @media (min-width: 480px) {\n        .appPublisher__app-display {\n        font-size: 1.2rem; } }\n      \n    .appDisplayConcise__app-display .appDisplayImg__app-display {\n    padding-right: 0.75rem; }\n    .appDisplayConcise__app-display .appDisplayImg__app-display > img {\n        width: 36px;\n        height: 36px;\n        border-radius: 5px; }\n    \n\n\n\n    .mainAppScreen {\n        background: rgba(243, 243, 243, 1);\n        background-size: cover;\n        display: table;\n        height: 100%;\n        width: 100%;\n        width: 100%;\n        min-height: 100vh;\n        height: 100vh;\n    }\n\n    .startWrapper {\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n\n        .firstLine {\n            font-family: \'Montserrat\';\n            font-size: 20px;\n            color: rgba(64, 55, 57, 1);\n            margin-bottom: 20px;\n\n        }\n\n        .secondLine {\n            font-family: \'Montserrat-Light\';\n            font-size: 16px;\n            color: rgba(64, 55, 57, 1);\n            text-align: center;\n            letter-spacing: 0.03em;\n            line-height: 18px;\n            margin-bottom: 26px;\n\n        }\n    }\n    \n    .exampleHolder > div {\n        margin-left: auto;\n        margin-right: auto; \n    }\n    @media (min-width: 768px) {\n        .exampleHolder {\n        position: absolute;\n        width: 80%;\n        right: 0;\n        } \n    }\n    \n    @media (min-width: 850px) {\n        .exampleHolder {\n            width: 100%; \n        } \n    }\n    \n    \n    .iPhone{\n        width: 100%;\n        z-index: 999;\n    }\n\n\n    .adExample__ad-example {\n        width: 100%;\n        max-width: 22rem;\n        overflow: hidden;\n        position: relative;\n        margin-top: 3rem;\n        }\n        @media (min-width: 768px) {\n          .adExample__ad-example {\n            margin-top: 0;\n            margin-right: 0; } }\n        @media (min-width: 1281px) {\n          .adExample__ad-example {\n            /* max-width: 24rem; */\n            } }\n        .adExample__ad-example.centered__ad-example {\n          margin-left: auto;\n          margin-right: auto; }\n\n    \n\n    .container__ad-example {\n        position: absolute;\n        top: 34.15133%;\n        width: 88.03030303030303%;\n        left: 6.1%; }\n\n    .adExampleFull__ad-example .container__ad-example {\n        top: 18.759231905465288%; }\n\n    .searchTerm__ad-example {\n        position: absolute;\n        top: 14.9%;\n        left: 14.2%;\n        font-size: 0.7rem; }\n        @media (min-width: 480px) {\n            .searchTerm__ad-example {\n            font-size: 0.8rem; } }\n\n\n    .app__ad-example {\n        padding: 3.787878787878788%;\n        background: #fff; }\n        \n    .app__ad-example.isAd__ad-example {\n        background: #EDF6FF; }\n    \n\n    .appSummary__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n\n    .appThumbnail__ad-example {\n        width: 27.03583%;\n        margin-right: 2.9316%;\n        -ms-flex-negative: 0;\n            flex-shrink: 0; }\n    .appThumbnail__ad-example > img {\n        border-radius: 16px; }\n\n    .appName__ad-example {\n        font-size: 1.05em;\n        color: #333;\n        line-height: 1.2;\n        margin-bottom: 5px; }\n        \n    .appDetail__ad-example {\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        font-size: 0.75rem; }\n              \n    .getButton__ad-example {\n        position: relative;\n        padding: 0.3rem 0.5rem;\n        border: 1px solid #3E90F4;\n        color: #3E90F4;\n        font-size: 0.65rem;\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        border-radius: 3px;\n        line-height: 1; }\n        .getButton__ad-example::before {\n            content: \'+\';\n            position: absolute;\n            line-height: 1;\n            font-size: 7px;\n            font-weight: 400;\n            top: 0;\n            left: 1px; }\n    \n    .adSymbol__ad-example {\n        display: inline-block;\n        padding: 0 5px;\n        background: #8EC5FE;\n        color: #fff;\n        border-radius: 2px;\n        margin-right: 8px; }\n              \n    .publisher__ad-example {\n        font-size: 0.9em;\n        color: #666;\n        line-height: 1.3;\n        display: table;\n        table-layout: fixed;\n        width: 100%;\n        white-space: nowrap; }\n\n    .publisher__ad-example > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n\n    .screenshotsContainer__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n        margin-top: 4.09%;\n        width: 100%;\n        // padding-left: 10.3226%;\n        // padding-right: 10.3226%; \n    }\n        \n    .screenshot__ad-example {\n        width: 30%; \n    }\n    .screenshot__ad-example > img {\n        width: 100%; \n    }\n\n    .exampleHolder {\n        position: relative;\n\n        .searchTerm__ad-example { \n            top: 9.5%; \n            left: 19.2%; \n            z-index: 999;\n        }\n        .container__ad-example { top: 15.4%; width: 87.5%; }\n    }\n\n\n\n    .isoWidgetsWrapper{\n\n        margin-left: auto;\n        margin-right: auto;\n        // height: 487px;\n        width: 343px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n\n    .searchTerm__ad-example { top: 72px !important; }\n\n    @media screen and (min-width: 850px) {\n        .searchTerm__ad-example { top: 72px !important; }\n    }\n\n    @media screen and (min-width: 768px) and (max-width: 849px) {\n        .searchTerm__ad-example { top: 58px !important; }\n    }\n\n    @media screen and (max-width: 767px) {\n        .searchTerm__ad-example { top: 10.2% !important; }\n    }\n'], ['\n\n// temp fix for ugly textarea\n    input:not([type="radio"]):not([type="checkbox"]), textarea {\n        padding: 0rem; \n    }\n    .ant-col-md-12 {\n        margin-left: auto;\n        margin-right: auto;\n    }\n    \n\n    .rc-tabs-top{\n        overflow-y: hidden;\n    }\n    .rc-tabs-ink-bar{\n        background-color: rgba(60, 211, 207, 1);\n    }\n    .rc-tabs-tab{\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(64, 55, 57, 1);\n    }\n    .rc-tabs-tab:hover {\n        color: rgba(64, 55, 57, 1);\n    }\n    .rc-tabs-tab-active {\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(64, 55, 57, 1);\n    } \n    .rc-tabs-tab-active:hover {\n        color: rgba(64, 55, 57, 1);\n    }\n\n    .inputWrapper {\n        padding-left: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n        margin-bottom: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            padding-right: 20px;\n            display: flex;\n\n            div {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n            input {\n                width: 100%;\n                border: none;\n            }\n\n            input:focus{\n                outline: unset;\n            }\n\n            input[type=number] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n                width: 3px;\n                border-left: 1px solid rgba(151, 151, 151, 1);\n            }\n            \n        }\n        \n        .react-tagsinput {\n            width: 213px;\n            border: 1px solid rgba(151,151,151,1);\n            border-radius: 20px;\n            display: -webkit-inline-box;\n\n            span {\n                padding-left: 10px;\n            }\n        }\n    \n        label {\n            left: -32px;\n            position: relative;\n            width: 213px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .isoInputWrapper {\n        margin-bottom: 15px;\n        justify-content: center;\n        align-items: center;\n        vertical-align: center;\n        display: flex;\n        border: 1px solid rgba(147, 147, 147, 1);\n        border-radius: 20px;\n\n        &:last-of-type {\n          margin-bottom: 0;\n        }\n        .searchIcon{\n          width: 18px;\n          height: 18px;\n        }\n      \n        .searchInput{\n          width: 250px;\n          display: inline-block;\n\n          .Select-control {\n            border: none;\n            background-color: rgba(0,0,0,0.1);\n\n            .Select-input:focus {\n                background: rgba(255, 255, 255, 1);\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                color: rgba(147, 147, 147, 1);\n                text-align: justify;\n                letter-spacing: 0.04em;\n            }\n          }\n          .Select-placeholder {\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n          .Select-value{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n\n          input{\n            border: none;\n          }\n          \n        }\n        .regionInput{\n          display: inline-block;\n          .country-flag img{\n            top: 0;\n          }\n\n          span{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n          }\n        }\n    }\n\n\n    // ENd of resuable componetns\n\n    .blackSection {\n        background-color: rgba(35, 31, 32, 1);\n        color: #fff;\n        position: relative;\n        z-index: 12;\n        box-shadow: 0px 2px 4px 0px rgba(122, 122, 122, 0.5);\n        .appDisplay__app-display {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center; }\n    }\n\n    \n\n    .o-wrapper {\n        padding-top: 16px;\n\n        max-width: 1020px;\n        padding-right: 1.5rem;\n        padding-left: 1.5rem;\n        margin-right: auto;\n        margin-left: auto; }\n        @media (min-width: 768px) {\n          .o-wrapper {\n            padding-right: 40px;\n            padding-left: 40px; } }\n        @media (min-width: 1281px) {\n          .o-wrapper {\n            max-width: 1120px;\n            padding-right: 1.5rem;\n            padding-left: 1.5rem; } }\n\n    .appDisplayImg__app-display {\n        padding-right: 0.75rem; }\n        .appDisplayImg__app-display > img {\n          border: 1px solid #D8D8D8;\n          width: 3.25rem;\n          height: 3.25rem;\n          max-width: none;\n          border-radius: 1rem; }\n        @media (min-width: 480px) {\n          .appDisplayImg__app-display {\n            padding-right: 1.5rem; }\n            .appDisplayImg__app-display > img {\n              width: 4.25rem;\n              height: 4.25rem; } }\n      \n    .appName__app-display,\n    .appLongName__app-display {\n        margin-top: 0px;\n\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(255, 255, 255, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n        /*Text styles for S */\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(255, 255, 255, 1);\n        text-align: left;\n    }\n        // @media (min-width: 480px) {\n        //   .appName__app-display,\n        //   .appLongName__app-display {\n        //     font-size: 2rem; } }\n        // @media (min-width: 1281px) {\n        //   .appName__app-display,\n        //   .appLongName__app-display {\n        //     font-size: 2.25rem; } }\n      \n    .appPublisher__app-display {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(255, 255, 255, 1);\n        text-align: left;\n        letter-spacing: 0.07em;\n        margin-top: 8px;\n\n    }\n    .appPublisher__app-display > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    @media (min-width: 480px) {\n        .appPublisher__app-display {\n        font-size: 1.2rem; } }\n      \n    .appDisplayConcise__app-display .appDisplayImg__app-display {\n    padding-right: 0.75rem; }\n    .appDisplayConcise__app-display .appDisplayImg__app-display > img {\n        width: 36px;\n        height: 36px;\n        border-radius: 5px; }\n    \n\n\n\n    .mainAppScreen {\n        background: rgba(243, 243, 243, 1);\n        background-size: cover;\n        display: table;\n        height: 100%;\n        width: 100%;\n        width: 100%;\n        min-height: 100vh;\n        height: 100vh;\n    }\n\n    .startWrapper {\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n\n        .firstLine {\n            font-family: \'Montserrat\';\n            font-size: 20px;\n            color: rgba(64, 55, 57, 1);\n            margin-bottom: 20px;\n\n        }\n\n        .secondLine {\n            font-family: \'Montserrat-Light\';\n            font-size: 16px;\n            color: rgba(64, 55, 57, 1);\n            text-align: center;\n            letter-spacing: 0.03em;\n            line-height: 18px;\n            margin-bottom: 26px;\n\n        }\n    }\n    \n    .exampleHolder > div {\n        margin-left: auto;\n        margin-right: auto; \n    }\n    @media (min-width: 768px) {\n        .exampleHolder {\n        position: absolute;\n        width: 80%;\n        right: 0;\n        } \n    }\n    \n    @media (min-width: 850px) {\n        .exampleHolder {\n            width: 100%; \n        } \n    }\n    \n    \n    .iPhone{\n        width: 100%;\n        z-index: 999;\n    }\n\n\n    .adExample__ad-example {\n        width: 100%;\n        max-width: 22rem;\n        overflow: hidden;\n        position: relative;\n        margin-top: 3rem;\n        }\n        @media (min-width: 768px) {\n          .adExample__ad-example {\n            margin-top: 0;\n            margin-right: 0; } }\n        @media (min-width: 1281px) {\n          .adExample__ad-example {\n            /* max-width: 24rem; */\n            } }\n        .adExample__ad-example.centered__ad-example {\n          margin-left: auto;\n          margin-right: auto; }\n\n    \n\n    .container__ad-example {\n        position: absolute;\n        top: 34.15133%;\n        width: 88.03030303030303%;\n        left: 6.1%; }\n\n    .adExampleFull__ad-example .container__ad-example {\n        top: 18.759231905465288%; }\n\n    .searchTerm__ad-example {\n        position: absolute;\n        top: 14.9%;\n        left: 14.2%;\n        font-size: 0.7rem; }\n        @media (min-width: 480px) {\n            .searchTerm__ad-example {\n            font-size: 0.8rem; } }\n\n\n    .app__ad-example {\n        padding: 3.787878787878788%;\n        background: #fff; }\n        \n    .app__ad-example.isAd__ad-example {\n        background: #EDF6FF; }\n    \n\n    .appSummary__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n\n    .appThumbnail__ad-example {\n        width: 27.03583%;\n        margin-right: 2.9316%;\n        -ms-flex-negative: 0;\n            flex-shrink: 0; }\n    .appThumbnail__ad-example > img {\n        border-radius: 16px; }\n\n    .appName__ad-example {\n        font-size: 1.05em;\n        color: #333;\n        line-height: 1.2;\n        margin-bottom: 5px; }\n        \n    .appDetail__ad-example {\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        font-size: 0.75rem; }\n              \n    .getButton__ad-example {\n        position: relative;\n        padding: 0.3rem 0.5rem;\n        border: 1px solid #3E90F4;\n        color: #3E90F4;\n        font-size: 0.65rem;\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        border-radius: 3px;\n        line-height: 1; }\n        .getButton__ad-example::before {\n            content: \'+\';\n            position: absolute;\n            line-height: 1;\n            font-size: 7px;\n            font-weight: 400;\n            top: 0;\n            left: 1px; }\n    \n    .adSymbol__ad-example {\n        display: inline-block;\n        padding: 0 5px;\n        background: #8EC5FE;\n        color: #fff;\n        border-radius: 2px;\n        margin-right: 8px; }\n              \n    .publisher__ad-example {\n        font-size: 0.9em;\n        color: #666;\n        line-height: 1.3;\n        display: table;\n        table-layout: fixed;\n        width: 100%;\n        white-space: nowrap; }\n\n    .publisher__ad-example > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n\n    .screenshotsContainer__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n        margin-top: 4.09%;\n        width: 100%;\n        // padding-left: 10.3226%;\n        // padding-right: 10.3226%; \n    }\n        \n    .screenshot__ad-example {\n        width: 30%; \n    }\n    .screenshot__ad-example > img {\n        width: 100%; \n    }\n\n    .exampleHolder {\n        position: relative;\n\n        .searchTerm__ad-example { \n            top: 9.5%; \n            left: 19.2%; \n            z-index: 999;\n        }\n        .container__ad-example { top: 15.4%; width: 87.5%; }\n    }\n\n\n\n    .isoWidgetsWrapper{\n\n        margin-left: auto;\n        margin-right: auto;\n        // height: 487px;\n        width: 343px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n\n    .searchTerm__ad-example { top: 72px !important; }\n\n    @media screen and (min-width: 850px) {\n        .searchTerm__ad-example { top: 72px !important; }\n    }\n\n    @media screen and (min-width: 768px) and (max-width: 849px) {\n        .searchTerm__ad-example { top: 58px !important; }\n    }\n\n    @media screen and (max-width: 767px) {\n        .searchTerm__ad-example { top: 10.2% !important; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var WidgetWrapper = _styledComponents2.default.div(_templateObject);
	var HomeWrapper = _styledComponents2.default.div(_templateObject2);
	// export default WithDirection(HomeWrapper);
	exports.WidgetWrapper = WidgetWrapper;
	exports.HomeWrapper = HomeWrapper;

/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DeleteCell = exports.EditableCell = exports.TextCell = exports.LinkCell = exports.ImageCell = exports.DateCell = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imageCell = __webpack_require__(1720);
	
	var _imageCell2 = _interopRequireDefault(_imageCell);
	
	var _antd = __webpack_require__(43);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DateCell = function DateCell(data) {
	  return _react2.default.createElement(
	    'p',
	    null,
	    data.toLocaleString()
	  );
	};
	var ImageCell = function ImageCell(src) {
	  return _react2.default.createElement(_imageCell2.default, { src: src });
	};
	var LinkCell = function LinkCell(link, href) {
	  return _react2.default.createElement(
	    'a',
	    { href: href ? href : '#' },
	    link
	  );
	};
	var TextCell = function TextCell(text) {
	  return _react2.default.createElement(
	    'p',
	    null,
	    text
	  );
	};
	
	var EditableCell = function (_Component) {
	  _inherits(EditableCell, _Component);
	
	  function EditableCell(props) {
	    _classCallCheck(this, EditableCell);
	
	    var _this = _possibleConstructorReturn(this, (EditableCell.__proto__ || Object.getPrototypeOf(EditableCell)).call(this, props));
	
	    _this.handleChange = _this.handleChange.bind(_this);
	    _this.check = _this.check.bind(_this);
	    _this.edit = _this.edit.bind(_this);
	    _this.state = {
	      value: _this.props.value,
	      editable: false
	    };
	    return _this;
	  }
	
	  _createClass(EditableCell, [{
	    key: 'handleChange',
	    value: function handleChange(event) {
	      var value = event.target.value;
	      this.setState({ value: value });
	    }
	  }, {
	    key: 'check',
	    value: function check() {
	      this.setState({ editable: false });
	      if (this.props.onChange) {
	        this.props.onChange(this.state.value, this.props.columnsKey, this.props.index);
	      }
	    }
	  }, {
	    key: 'edit',
	    value: function edit() {
	      this.setState({ editable: true });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          editable = _state.editable;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'isoEditData' },
	        editable ? _react2.default.createElement(
	          'div',
	          { className: 'isoEditDataWrapper' },
	          _react2.default.createElement(_antd.Input, {
	            value: value,
	            onChange: this.handleChange,
	            onPressEnter: this.check
	          }),
	          _react2.default.createElement(_antd.Icon, { type: 'check', className: 'isoEditIcon', onClick: this.check })
	        ) : _react2.default.createElement(
	          'p',
	          { className: 'isoDataWrapper' },
	          value || ' ',
	          _react2.default.createElement(_antd.Icon, { type: 'edit', className: 'isoEditIcon', onClick: this.edit })
	        )
	      );
	    }
	  }]);
	
	  return EditableCell;
	}(_react.Component);
	
	var DeleteCell = function (_Component2) {
	  _inherits(DeleteCell, _Component2);
	
	  function DeleteCell() {
	    _classCallCheck(this, DeleteCell);
	
	    return _possibleConstructorReturn(this, (DeleteCell.__proto__ || Object.getPrototypeOf(DeleteCell)).apply(this, arguments));
	  }
	
	  _createClass(DeleteCell, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          index = _props.index,
	          onDeleteCell = _props.onDeleteCell;
	
	      return _react2.default.createElement(
	        _antd.Popconfirm,
	        {
	          title: 'Sure to delete?',
	          okText: 'DELETE',
	          cancelText: 'No',
	          onConfirm: function onConfirm() {
	            return onDeleteCell(index);
	          }
	        },
	        _react2.default.createElement(
	          'a',
	          null,
	          'Delete'
	        )
	      );
	    }
	  }]);
	
	  return DeleteCell;
	}(_react.Component);
	
	exports.DateCell = DateCell;
	exports.ImageCell = ImageCell;
	exports.LinkCell = LinkCell;
	exports.TextCell = TextCell;
	exports.EditableCell = EditableCell;
	exports.DeleteCell = DeleteCell;

/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearToken = clearToken;
	exports.getToken = getToken;
	exports.timeDifference = timeDifference;
	
	var _immutable = __webpack_require__(35);
	
	function clearToken() {
	  localStorage.removeItem('id_token');
	}
	
	function getToken() {
	  try {
	    var idToken = localStorage.getItem('id_token');
	    return new _immutable.Map({ idToken: idToken });
	  } catch (err) {
	    clearToken();
	    return new _immutable.Map();
	  }
	}
	
	function timeDifference(givenTime) {
	  givenTime = new Date(givenTime);
	  var milliseconds = new Date().getTime() - givenTime.getTime();
	  var numberEnding = function numberEnding(number) {
	    return number > 1 ? 's' : '';
	  };
	  var number = function number(num) {
	    return num > 9 ? '' + num : '0' + num;
	  };
	  var getTime = function getTime() {
	    var temp = Math.floor(milliseconds / 1000);
	    var years = Math.floor(temp / 31536000);
	    if (years) {
	      var month = number(givenTime.getUTCMonth() + 1);
	      var day = number(givenTime.getUTCDate());
	      var year = givenTime.getUTCFullYear() % 100;
	      return day + '-' + month + '-' + year;
	    }
	    var days = Math.floor((temp %= 31536000) / 86400);
	    if (days) {
	      if (days < 28) {
	        return days + ' day' + numberEnding(days);
	      } else {
	        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	        var _month = months[givenTime.getUTCMonth()];
	        var _day = number(givenTime.getUTCDate());
	        return _day + ' ' + _month;
	      }
	    }
	    var hours = Math.floor((temp %= 86400) / 3600);
	    if (hours) {
	      return hours + ' hour' + numberEnding(hours) + ' ago';
	    }
	    var minutes = Math.floor((temp %= 3600) / 60);
	    if (minutes) {
	      return minutes + ' minute' + numberEnding(minutes) + ' ago';
	    }
	    return 'a few seconds ago';
	  };
	  return getTime();
	}

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _enUS = __webpack_require__(1738);
	
	var _enUS2 = _interopRequireDefault(_enUS);
	
	var _zhHansCN = __webpack_require__(1742);
	
	var _zhHansCN2 = _interopRequireDefault(_zhHansCN);
	
	var _ar_SA = __webpack_require__(1737);
	
	var _ar_SA2 = _interopRequireDefault(_ar_SA);
	
	var _it_IT = __webpack_require__(1741);
	
	var _it_IT2 = _interopRequireDefault(_it_IT);
	
	var _es_ES = __webpack_require__(1739);
	
	var _es_ES2 = _interopRequireDefault(_es_ES);
	
	var _fr_FR = __webpack_require__(1740);
	
	var _fr_FR2 = _interopRequireDefault(_fr_FR);
	
	var _reactIntl = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppLocale = {
	  en: _enUS2.default,
	  zh: _zhHansCN2.default,
	  sa: _ar_SA2.default,
	  it: _it_IT2.default,
	  es: _es_ES2.default,
	  fr: _fr_FR2.default
	};
	(0, _reactIntl.addLocaleData)(AppLocale.en.data);
	(0, _reactIntl.addLocaleData)(AppLocale.zh.data);
	(0, _reactIntl.addLocaleData)(AppLocale.sa.data);
	(0, _reactIntl.addLocaleData)(AppLocale.it.data);
	(0, _reactIntl.addLocaleData)(AppLocale.es.data);
	(0, _reactIntl.addLocaleData)(AppLocale.fr.data);
	
	exports.default = AppLocale;

/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reduxActions = __webpack_require__(1345);
	
	// export const REQUEST_SUGGEST = 'REQUEST_SUGGEST';
	// export const SUCCESS_SUGGEST = 'SUCCESS_SUGGEST';
	// export const FAILURE_SUGGEST = 'FAILURE_SUGGEST';
	// export const requestSuggest = createAction(REQUEST_SUGGEST);
	// export const successSuggest = createAction(SUCCESS_SUGGEST);
	// export const failureSuggest = createAction(FAILURE_SUGGEST);
	
	// export const CLEAR_SUGGESTS = 'CLEAR_SUGGESTS';
	// export const clearSuggests = createAction(CLEAR_SUGGESTS);
	
	// export const SET_KEYWORD = 'SET_KEYWORD';
	// export const CLEAR_KEYWORD = 'CLEAR_KEYWORD';
	// export const setKeyword = createAction(SET_KEYWORD);
	// export const clearKeyword = createAction(CLEAR_KEYWORD);
	
	// export const SET_SELECTED = 'SET_SELECTED';
	
	
	var actions = {
	
	  REQUEST_SUGGEST: 'REQUEST_SUGGEST',
	  SUCCESS_SUGGEST: 'SUCCESS_SUGGEST',
	  SET_SELECTED: 'SET_SELECTED',
	
	  setSelectedResult: function setSelectedResult(searchTerm) {
	    return {
	      type: actions.SET_SEARCH_TERM,
	      searchTerm: searchTerm
	    };
	  }
	};
	exports.default = actions;

/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1760), __esModule: true };

/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1763), __esModule: true };

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1765), __esModule: true };

/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1766), __esModule: true };

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(399);
	var TAG = __webpack_require__(82)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 758 */
[3346, 217, 119],
/* 759 */
[3348, 144, 177, 758],
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(399);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(403);
	var $export = __webpack_require__(96);
	var redefine = __webpack_require__(767);
	var hide = __webpack_require__(178);
	var has = __webpack_require__(145);
	var Iterators = __webpack_require__(179);
	var $iterCreate = __webpack_require__(1781);
	var setToStringTag = __webpack_require__(406);
	var getPrototypeOf = __webpack_require__(764);
	var ITERATOR = __webpack_require__(82)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(219);
	var createDesc = __webpack_require__(220);
	var toIObject = __webpack_require__(146);
	var toPrimitive = __webpack_require__(410);
	var has = __webpack_require__(145);
	var IE8_DOM_DEFINE = __webpack_require__(759);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(144) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(765);
	var hiddenKeys = __webpack_require__(402).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(145);
	var toObject = __webpack_require__(283);
	var IE_PROTO = __webpack_require__(407)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(145);
	var toIObject = __webpack_require__(146);
	var arrayIndexOf = __webpack_require__(1774)(false);
	var IE_PROTO = __webpack_require__(407)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys = __webpack_require__(218);
	var toIObject = __webpack_require__(146);
	var isEnum = __webpack_require__(219).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) if (isEnum.call(O, key = keys[i++])) {
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(178);


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(409);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(757);
	var ITERATOR = __webpack_require__(82)('iterator');
	var Iterators = __webpack_require__(179);
	module.exports = __webpack_require__(62).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = function (crypto, password, keyLen, ivLen) {
	  keyLen = keyLen/8;
	  ivLen = ivLen || 0;
	  var ki = 0;
	  var ii = 0;
	  var key = new Buffer(keyLen);
	  var iv = new Buffer(ivLen);
	  var addmd = 0;
	  var md, md_buf;
	  var i;
	  while (true) {
	    md = crypto.createHash('md5');
	    if(addmd++ > 0) {
	       md.update(md_buf);
	    }
	    md.update(password);
	    md_buf = md.digest();
	    i = 0;
	    if(keyLen > 0) {
	      while(true) {
	        if(keyLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	        key[ki++] = md_buf[i];
	        keyLen--;
	        i++;
	       }
	    }
	    if(ivLen > 0 && i !== md_buf.length) {
	      while(true) {
	        if(ivLen === 0) {
	          break;
	        }
	        if(i === md_buf.length) {
	          break;
	        }
	       iv[ii++] = md_buf[i];
	       ivLen--;
	       i++;
	     }
	   }
	   if(keyLen === 0 && ivLen === 0) {
	      break;
	    }
	  }
	  for(i=0;i<md_buf.length;i++) {
	    md_buf[i] = 0;
	  }
	  return {
	    key: key,
	    iv: iv
	  };
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var xor = __webpack_require__(286);
	exports.encrypt = function (self, block) {
	  var data = xor(block, self._prev);
	  self._prev = self._cipher.encryptBlock(data);
	  return self._prev;
	};
	exports.decrypt = function (self, block) {
	  var pad = self._prev;
	  self._prev = block;
	  var out = self._cipher.decryptBlock(block);
	  return xor(out, pad);
	};

/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(286);
	exports.encrypt = function (self, data, decrypt) {
	  var out = new Buffer('');
	  var len;
	  while (data.length) {
	    if (self._cache.length === 0) {
	      self._cache = self._cipher.encryptBlock(self._prev);
	      self._prev = new Buffer('');
	    }
	    if (self._cache.length <= data.length) {
	      len = self._cache.length;
	      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)]);
	      data = data.slice(len);
	    } else {
	      out = Buffer.concat([out, encryptStart(self, data, decrypt)]);
	      break;
	    }
	  }
	  return out;
	};
	function encryptStart(self, data, decrypt) {
	  var len = data.length;
	  var out = xor(data, self._cache);
	  self._cache = self._cache.slice(len);
	  self._prev = Buffer.concat([self._prev, decrypt?data:out]);
	  return out;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(286);
	function getBlock(self) {
	  var out = self._cipher.encryptBlock(self._prev);
	  incr32(self._prev);
	  return out;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	function incr32(iv) {
	  var len = iv.length;
	  var item;
	  while (len--) {
	    item = iv.readUInt8(len);
	    if (item === 255) {
	      iv.writeUInt8(0, len);
	    } else {
	      item++;
	      iv.writeUInt8(item, len);
	      break;
	    }
	  }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 774 */
/***/ function(module, exports) {

	exports.encrypt = function (self, block) {
	  return self._cipher.encryptBlock(block);
	};
	exports.decrypt = function (self, block) {
	  return self._cipher.decryptBlock(block);
	};

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(286);
	function getBlock(self) {
	  self._prev = self._cipher.encryptBlock(self._prev);
	  return self._prev;
	}
	exports.encrypt = function (self, chunk) {
	  while (self._cache.length < chunk.length) {
	    self._cache = Buffer.concat([self._cache, getBlock(self)]);
	  }
	  var pad = self._cache.slice(0, chunk.length);
	  self._cache = self._cache.slice(chunk.length);
	  return xor(chunk, pad);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(415);
	var Transform = __webpack_require__(416);
	var inherits = __webpack_require__(98);
	
	inherits(StreamCipher, Transform);
	module.exports = StreamCipher;
	function StreamCipher(mode, key, iv, decrypt) {
	  if (!(this instanceof StreamCipher)) {
	    return new StreamCipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  this._cache = new Buffer('');
	  this._secCache = new Buffer('');
	  this._decrypt = decrypt;
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	StreamCipher.prototype._transform = function (chunk, _, next) {
	  next(null, this._mode.encrypt(this, chunk, this._decrypt));
	};
	StreamCipher.prototype._flush = function (next) {
	  this._cipher.scrub();
	  next();
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 777 */
[3351, 10],
/* 778 */
[3352, 10],
/* 779 */
[3353, 10],
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 781 */
[3354, 10],
/* 782 */
[3355, 10],
/* 783 */
[3356, 10],
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 785 */
[3357, 10],
/* 786 */
[3358, 10],
/* 787 */
[3359, 10],
/* 788 */
[3360, 10],
/* 789 */
[3361, 10],
/* 790 */
[3362, 10],
/* 791 */
[3363, 10],
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : '[el] D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : '[el] D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : '[el] dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 793 */
[3364, 10],
/* 794 */
[3365, 10],
/* 795 */
[3366, 10],
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._März_April_Mai_Juni_Juli_Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 800 */
[3367, 10],
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 802 */
[3368, 10],
/* 803 */
[3369, 10],
/* 804 */
[3370, 10],
/* 805 */
[3371, 10],
/* 806 */
[3372, 10],
/* 807 */
[3373, 10],
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 810 */
[3374, 10],
/* 811 */
[3375, 10],
/* 812 */
[3376, 10],
/* 813 */
[3377, 10],
/* 814 */
[3378, 10],
/* 815 */
[3379, 10],
/* 816 */
[3380, 10],
/* 817 */
[3381, 10],
/* 818 */
[3382, 10],
/* 819 */
[3383, 10],
/* 820 */
[3384, 10],
/* 821 */
[3385, 10],
/* 822 */
[3386, 10],
/* 823 */
[3387, 10],
/* 824 */
[3388, 10],
/* 825 */
[3389, 10],
/* 826 */
[3390, 10],
/* 827 */
[3391, 10],
/* 828 */
[3392, 10],
/* 829 */
[3393, 10],
/* 830 */
[3394, 10],
/* 831 */
[3395, 10],
/* 832 */
[3396, 10],
/* 833 */
[3397, 10],
/* 834 */
[3398, 10],
/* 835 */
[3399, 10],
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 837 */
[3400, 10],
/* 838 */
[3401, 10],
/* 839 */
[3402, 10],
/* 840 */
[3403, 10],
/* 841 */
[3404, 10],
/* 842 */
[3405, 10],
/* 843 */
[3406, 10],
/* 844 */
[3407, 10],
/* 845 */
[3408, 10],
/* 846 */
[3409, 10],
/* 847 */
[3410, 10],
/* 848 */
[3411, 10],
/* 849 */
[3412, 10],
/* 850 */
[3413, 10],
/* 851 */
[3414, 10],
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 854 */
[3415, 10],
/* 855 */
[3416, 10],
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 859 */
[3417, 10],
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 861 */
[3418, 10],
/* 862 */
[3419, 10],
/* 863 */
[3420, 10],
/* 864 */
[3421, 10],
/* 865 */
[3422, 10],
/* 866 */
[3423, 10],
/* 867 */
[3424, 10],
/* 868 */
[3425, 10],
/* 869 */
[3426, 10],
/* 870 */
[3427, 10],
/* 871 */
[3428, 10],
/* 872 */
[3429, 10],
/* 873 */
[3430, 10],
/* 874 */
[3431, 10],
/* 875 */
[3432, 10],
/* 876 */
[3433, 10],
/* 877 */
[3434, 10],
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(10)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 879 */
[3435, 10],
/* 880 */
[3436, 10],
/* 881 */
[3437, 10],
/* 882 */
[3438, 10],
/* 883 */
[3439, 10],
/* 884 */
[3440, 10],
/* 885 */
[3441, 10],
/* 886 */
[3442, 10],
/* 887 */
[3443, 10],
/* 888 */
[3444, 10],
/* 889 */
[3445, 10],
/* 890 */
[3446, 10],
/* 891 */
[3447, 10],
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	
	/**
	 * Helper function to get relative position for an event
	 * @param {Event|IEvent} event - The event to get the position for
	 * @param {Chart} chart - The chart
	 * @returns {Point} the event position
	 */
	function getRelativePosition(e, chart) {
		if (e.native) {
			return {
				x: e.x,
				y: e.y
			};
		}
	
		return helpers.getRelativePosition(e, chart);
	}
	
	/**
	 * Helper function to traverse all of the visible elements in the chart
	 * @param chart {chart} the chart
	 * @param handler {Function} the callback to execute for each visible item
	 */
	function parseVisibleItems(chart, handler) {
		var datasets = chart.data.datasets;
		var meta, i, j, ilen, jlen;
	
		for (i = 0, ilen = datasets.length; i < ilen; ++i) {
			if (!chart.isDatasetVisible(i)) {
				continue;
			}
	
			meta = chart.getDatasetMeta(i);
			for (j = 0, jlen = meta.data.length; j < jlen; ++j) {
				var element = meta.data[j];
				if (!element._view.skip) {
					handler(element);
				}
			}
		}
	}
	
	/**
	 * Helper function to get the items that intersect the event position
	 * @param items {ChartElement[]} elements to filter
	 * @param position {Point} the point to be nearest to
	 * @return {ChartElement[]} the nearest items
	 */
	function getIntersectItems(chart, position) {
		var elements = [];
	
		parseVisibleItems(chart, function(element) {
			if (element.inRange(position.x, position.y)) {
				elements.push(element);
			}
		});
	
		return elements;
	}
	
	/**
	 * Helper function to get the items nearest to the event position considering all visible items in teh chart
	 * @param chart {Chart} the chart to look at elements from
	 * @param position {Point} the point to be nearest to
	 * @param intersect {Boolean} if true, only consider items that intersect the position
	 * @param distanceMetric {Function} function to provide the distance between points
	 * @return {ChartElement[]} the nearest items
	 */
	function getNearestItems(chart, position, intersect, distanceMetric) {
		var minDistance = Number.POSITIVE_INFINITY;
		var nearestItems = [];
	
		parseVisibleItems(chart, function(element) {
			if (intersect && !element.inRange(position.x, position.y)) {
				return;
			}
	
			var center = element.getCenterPoint();
			var distance = distanceMetric(position, center);
	
			if (distance < minDistance) {
				nearestItems = [element];
				minDistance = distance;
			} else if (distance === minDistance) {
				// Can have multiple items at the same distance in which case we sort by size
				nearestItems.push(element);
			}
		});
	
		return nearestItems;
	}
	
	/**
	 * Get a distance metric function for two points based on the
	 * axis mode setting
	 * @param {String} axis the axis mode. x|y|xy
	 */
	function getDistanceMetricForAxis(axis) {
		var useX = axis.indexOf('x') !== -1;
		var useY = axis.indexOf('y') !== -1;
	
		return function(pt1, pt2) {
			var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
			var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
			return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
		};
	}
	
	function indexMode(chart, e, options) {
		var position = getRelativePosition(e, chart);
		// Default axis for index mode is 'x' to match old behaviour
		options.axis = options.axis || 'x';
		var distanceMetric = getDistanceMetricForAxis(options.axis);
		var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
		var elements = [];
	
		if (!items.length) {
			return [];
		}
	
		chart.data.datasets.forEach(function(dataset, datasetIndex) {
			if (chart.isDatasetVisible(datasetIndex)) {
				var meta = chart.getDatasetMeta(datasetIndex);
				var element = meta.data[items[0]._index];
	
				// don't count items that are skipped (null data)
				if (element && !element._view.skip) {
					elements.push(element);
				}
			}
		});
	
		return elements;
	}
	
	/**
	 * @interface IInteractionOptions
	 */
	/**
	 * If true, only consider items that intersect the point
	 * @name IInterfaceOptions#boolean
	 * @type Boolean
	 */
	
	/**
	 * Contains interaction related functions
	 * @namespace Chart.Interaction
	 */
	module.exports = {
		// Helper function for different modes
		modes: {
			single: function(chart, e) {
				var position = getRelativePosition(e, chart);
				var elements = [];
	
				parseVisibleItems(chart, function(element) {
					if (element.inRange(position.x, position.y)) {
						elements.push(element);
						return elements;
					}
				});
	
				return elements.slice(0, 1);
			},
	
			/**
			 * @function Chart.Interaction.modes.label
			 * @deprecated since version 2.4.0
			 * @todo remove at version 3
			 * @private
			 */
			label: indexMode,
	
			/**
			 * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
			 * @function Chart.Interaction.modes.index
			 * @since v2.4.0
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			index: indexMode,
	
			/**
			 * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
			 * If the options.intersect is false, we find the nearest item and return the items in that dataset
			 * @function Chart.Interaction.modes.dataset
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use during interaction
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			dataset: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
	
				if (items.length > 0) {
					items = chart.getDatasetMeta(items[0]._datasetIndex).data;
				}
	
				return items;
			},
	
			/**
			 * @function Chart.Interaction.modes.x-axis
			 * @deprecated since version 2.4.0. Use index mode and intersect == true
			 * @todo remove at version 3
			 * @private
			 */
			'x-axis': function(chart, e) {
				return indexMode(chart, e, {intersect: false});
			},
	
			/**
			 * Point mode returns all elements that hit test based on the event position
			 * of the event
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			point: function(chart, e) {
				var position = getRelativePosition(e, chart);
				return getIntersectItems(chart, position);
			},
	
			/**
			 * nearest mode returns the element closest to the point
			 * @function Chart.Interaction.modes.intersect
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			nearest: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				options.axis = options.axis || 'xy';
				var distanceMetric = getDistanceMetricForAxis(options.axis);
				var nearestItems = getNearestItems(chart, position, options.intersect, distanceMetric);
	
				// We have multiple items at the same distance from the event. Now sort by smallest
				if (nearestItems.length > 1) {
					nearestItems.sort(function(a, b) {
						var sizeA = a.getArea();
						var sizeB = b.getArea();
						var ret = sizeA - sizeB;
	
						if (ret === 0) {
							// if equal sort by dataset index
							ret = a._datasetIndex - b._datasetIndex;
						}
	
						return ret;
					});
				}
	
				// Return only 1 item
				return nearestItems.slice(0, 1);
			},
	
			/**
			 * x mode returns the elements that hit-test at the current x coordinate
			 * @function Chart.Interaction.modes.x
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			x: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inXRange(position.x)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			},
	
			/**
			 * y mode returns the elements that hit-test at the current y coordinate
			 * @function Chart.Interaction.modes.y
			 * @param chart {chart} the chart we are returning items from
			 * @param e {Event} the event we are find things at
			 * @param options {IInteractionOptions} options to use
			 * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
			 */
			y: function(chart, e, options) {
				var position = getRelativePosition(e, chart);
				var items = [];
				var intersectsItem = false;
	
				parseVisibleItems(chart, function(element) {
					if (element.inYRange(position.y)) {
						items.push(element);
					}
	
					if (element.inRange(position.x, position.y)) {
						intersectsItem = true;
					}
				});
	
				// If we want to trigger on an intersect and we don't have any items
				// that intersect the position, return nothing
				if (options.intersect && !intersectsItem) {
					items = [];
				}
				return items;
			}
		}
	};


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	var basic = __webpack_require__(1844);
	var dom = __webpack_require__(1845);
	
	// @TODO Make possible to select another platform at build time.
	var implementation = dom._enabled ? dom : basic;
	
	/**
	 * @namespace Chart.platform
	 * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
	 * @since 2.4.0
	 */
	module.exports = helpers.extend({
		/**
		 * @since 2.7.0
		 */
		initialize: function() {},
	
		/**
		 * Called at chart construction time, returns a context2d instance implementing
		 * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
		 * @param {*} item - The native item from which to acquire context (platform specific)
		 * @param {Object} options - The chart options
		 * @returns {CanvasRenderingContext2D} context2d instance
		 */
		acquireContext: function() {},
	
		/**
		 * Called at chart destruction time, releases any resources associated to the context
		 * previously returned by the acquireContext() method.
		 * @param {CanvasRenderingContext2D} context - The context2d instance
		 * @returns {Boolean} true if the method succeeded, else false
		 */
		releaseContext: function() {},
	
		/**
		 * Registers the specified listener on the given chart.
		 * @param {Chart} chart - Chart from which to listen for event
		 * @param {String} type - The ({@link IEvent}) type to listen for
		 * @param {Function} listener - Receives a notification (an object that implements
		 * the {@link IEvent} interface) when an event of the specified type occurs.
		 */
		addEventListener: function() {},
	
		/**
		 * Removes the specified listener previously registered with addEventListener.
		 * @param {Chart} chart -Chart from which to remove the listener
		 * @param {String} type - The ({@link IEvent}) type to remove
		 * @param {Function} listener - The listener function to remove from the event target.
		 */
		removeEventListener: function() {}
	
	}, implementation);
	
	/**
	 * @interface IPlatform
	 * Allows abstracting platform dependencies away from the chart
	 * @borrows Chart.platform.acquireContext as acquireContext
	 * @borrows Chart.platform.releaseContext as releaseContext
	 * @borrows Chart.platform.addEventListener as addEventListener
	 * @borrows Chart.platform.removeEventListener as removeEventListener
	 */
	
	/**
	 * @interface IEvent
	 * @prop {String} type - The event type name, possible values are:
	 * 'contextmenu', 'mouseenter', 'mousedown', 'mousemove', 'mouseup', 'mouseout',
	 * 'click', 'dblclick', 'keydown', 'keypress', 'keyup' and 'resize'
	 * @prop {*} native - The original native event (null for emulated events, e.g. 'resize')
	 * @prop {Number} x - The mouse x position, relative to the canvas (null for incompatible events)
	 * @prop {Number} y - The mouse y position, relative to the canvas (null for incompatible events)
	 */


/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var convert = __webpack_require__(1857);
	var string = __webpack_require__(1855);
	
	var Color = function (obj) {
		if (obj instanceof Color) {
			return obj;
		}
		if (!(this instanceof Color)) {
			return new Color(obj);
		}
	
		this.valid = false;
		this.values = {
			rgb: [0, 0, 0],
			hsl: [0, 0, 0],
			hsv: [0, 0, 0],
			hwb: [0, 0, 0],
			cmyk: [0, 0, 0, 0],
			alpha: 1
		};
	
		// parse Color() argument
		var vals;
		if (typeof obj === 'string') {
			vals = string.getRgba(obj);
			if (vals) {
				this.setValues('rgb', vals);
			} else if (vals = string.getHsla(obj)) {
				this.setValues('hsl', vals);
			} else if (vals = string.getHwb(obj)) {
				this.setValues('hwb', vals);
			}
		} else if (typeof obj === 'object') {
			vals = obj;
			if (vals.r !== undefined || vals.red !== undefined) {
				this.setValues('rgb', vals);
			} else if (vals.l !== undefined || vals.lightness !== undefined) {
				this.setValues('hsl', vals);
			} else if (vals.v !== undefined || vals.value !== undefined) {
				this.setValues('hsv', vals);
			} else if (vals.w !== undefined || vals.whiteness !== undefined) {
				this.setValues('hwb', vals);
			} else if (vals.c !== undefined || vals.cyan !== undefined) {
				this.setValues('cmyk', vals);
			}
		}
	};
	
	Color.prototype = {
		isValid: function () {
			return this.valid;
		},
		rgb: function () {
			return this.setSpace('rgb', arguments);
		},
		hsl: function () {
			return this.setSpace('hsl', arguments);
		},
		hsv: function () {
			return this.setSpace('hsv', arguments);
		},
		hwb: function () {
			return this.setSpace('hwb', arguments);
		},
		cmyk: function () {
			return this.setSpace('cmyk', arguments);
		},
	
		rgbArray: function () {
			return this.values.rgb;
		},
		hslArray: function () {
			return this.values.hsl;
		},
		hsvArray: function () {
			return this.values.hsv;
		},
		hwbArray: function () {
			var values = this.values;
			if (values.alpha !== 1) {
				return values.hwb.concat([values.alpha]);
			}
			return values.hwb;
		},
		cmykArray: function () {
			return this.values.cmyk;
		},
		rgbaArray: function () {
			var values = this.values;
			return values.rgb.concat([values.alpha]);
		},
		hslaArray: function () {
			var values = this.values;
			return values.hsl.concat([values.alpha]);
		},
		alpha: function (val) {
			if (val === undefined) {
				return this.values.alpha;
			}
			this.setValues('alpha', val);
			return this;
		},
	
		red: function (val) {
			return this.setChannel('rgb', 0, val);
		},
		green: function (val) {
			return this.setChannel('rgb', 1, val);
		},
		blue: function (val) {
			return this.setChannel('rgb', 2, val);
		},
		hue: function (val) {
			if (val) {
				val %= 360;
				val = val < 0 ? 360 + val : val;
			}
			return this.setChannel('hsl', 0, val);
		},
		saturation: function (val) {
			return this.setChannel('hsl', 1, val);
		},
		lightness: function (val) {
			return this.setChannel('hsl', 2, val);
		},
		saturationv: function (val) {
			return this.setChannel('hsv', 1, val);
		},
		whiteness: function (val) {
			return this.setChannel('hwb', 1, val);
		},
		blackness: function (val) {
			return this.setChannel('hwb', 2, val);
		},
		value: function (val) {
			return this.setChannel('hsv', 2, val);
		},
		cyan: function (val) {
			return this.setChannel('cmyk', 0, val);
		},
		magenta: function (val) {
			return this.setChannel('cmyk', 1, val);
		},
		yellow: function (val) {
			return this.setChannel('cmyk', 2, val);
		},
		black: function (val) {
			return this.setChannel('cmyk', 3, val);
		},
	
		hexString: function () {
			return string.hexString(this.values.rgb);
		},
		rgbString: function () {
			return string.rgbString(this.values.rgb, this.values.alpha);
		},
		rgbaString: function () {
			return string.rgbaString(this.values.rgb, this.values.alpha);
		},
		percentString: function () {
			return string.percentString(this.values.rgb, this.values.alpha);
		},
		hslString: function () {
			return string.hslString(this.values.hsl, this.values.alpha);
		},
		hslaString: function () {
			return string.hslaString(this.values.hsl, this.values.alpha);
		},
		hwbString: function () {
			return string.hwbString(this.values.hwb, this.values.alpha);
		},
		keyword: function () {
			return string.keyword(this.values.rgb, this.values.alpha);
		},
	
		rgbNumber: function () {
			var rgb = this.values.rgb;
			return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
		},
	
		luminosity: function () {
			// http://www.w3.org/TR/WCAG20/#relativeluminancedef
			var rgb = this.values.rgb;
			var lum = [];
			for (var i = 0; i < rgb.length; i++) {
				var chan = rgb[i] / 255;
				lum[i] = (chan <= 0.03928) ? chan / 12.92 : Math.pow(((chan + 0.055) / 1.055), 2.4);
			}
			return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
		},
	
		contrast: function (color2) {
			// http://www.w3.org/TR/WCAG20/#contrast-ratiodef
			var lum1 = this.luminosity();
			var lum2 = color2.luminosity();
			if (lum1 > lum2) {
				return (lum1 + 0.05) / (lum2 + 0.05);
			}
			return (lum2 + 0.05) / (lum1 + 0.05);
		},
	
		level: function (color2) {
			var contrastRatio = this.contrast(color2);
			if (contrastRatio >= 7.1) {
				return 'AAA';
			}
	
			return (contrastRatio >= 4.5) ? 'AA' : '';
		},
	
		dark: function () {
			// YIQ equation from http://24ways.org/2010/calculating-color-contrast
			var rgb = this.values.rgb;
			var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
			return yiq < 128;
		},
	
		light: function () {
			return !this.dark();
		},
	
		negate: function () {
			var rgb = [];
			for (var i = 0; i < 3; i++) {
				rgb[i] = 255 - this.values.rgb[i];
			}
			this.setValues('rgb', rgb);
			return this;
		},
	
		lighten: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] += hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		darken: function (ratio) {
			var hsl = this.values.hsl;
			hsl[2] -= hsl[2] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		saturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] += hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		desaturate: function (ratio) {
			var hsl = this.values.hsl;
			hsl[1] -= hsl[1] * ratio;
			this.setValues('hsl', hsl);
			return this;
		},
	
		whiten: function (ratio) {
			var hwb = this.values.hwb;
			hwb[1] += hwb[1] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		blacken: function (ratio) {
			var hwb = this.values.hwb;
			hwb[2] += hwb[2] * ratio;
			this.setValues('hwb', hwb);
			return this;
		},
	
		greyscale: function () {
			var rgb = this.values.rgb;
			// http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
			var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
			this.setValues('rgb', [val, val, val]);
			return this;
		},
	
		clearer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha - (alpha * ratio));
			return this;
		},
	
		opaquer: function (ratio) {
			var alpha = this.values.alpha;
			this.setValues('alpha', alpha + (alpha * ratio));
			return this;
		},
	
		rotate: function (degrees) {
			var hsl = this.values.hsl;
			var hue = (hsl[0] + degrees) % 360;
			hsl[0] = hue < 0 ? 360 + hue : hue;
			this.setValues('hsl', hsl);
			return this;
		},
	
		/**
		 * Ported from sass implementation in C
		 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
		 */
		mix: function (mixinColor, weight) {
			var color1 = this;
			var color2 = mixinColor;
			var p = weight === undefined ? 0.5 : weight;
	
			var w = 2 * p - 1;
			var a = color1.alpha() - color2.alpha();
	
			var w1 = (((w * a === -1) ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
			var w2 = 1 - w1;
	
			return this
				.rgb(
					w1 * color1.red() + w2 * color2.red(),
					w1 * color1.green() + w2 * color2.green(),
					w1 * color1.blue() + w2 * color2.blue()
				)
				.alpha(color1.alpha() * p + color2.alpha() * (1 - p));
		},
	
		toJSON: function () {
			return this.rgb();
		},
	
		clone: function () {
			// NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
			// making the final build way to big to embed in Chart.js. So let's do it manually,
			// assuming that values to clone are 1 dimension arrays containing only numbers,
			// except 'alpha' which is a number.
			var result = new Color();
			var source = this.values;
			var target = result.values;
			var value, type;
	
			for (var prop in source) {
				if (source.hasOwnProperty(prop)) {
					value = source[prop];
					type = ({}).toString.call(value);
					if (type === '[object Array]') {
						target[prop] = value.slice(0);
					} else if (type === '[object Number]') {
						target[prop] = value;
					} else {
						console.error('unexpected color value:', value);
					}
				}
			}
	
			return result;
		}
	};
	
	Color.prototype.spaces = {
		rgb: ['red', 'green', 'blue'],
		hsl: ['hue', 'saturation', 'lightness'],
		hsv: ['hue', 'saturation', 'value'],
		hwb: ['hue', 'whiteness', 'blackness'],
		cmyk: ['cyan', 'magenta', 'yellow', 'black']
	};
	
	Color.prototype.maxes = {
		rgb: [255, 255, 255],
		hsl: [360, 100, 100],
		hsv: [360, 100, 100],
		hwb: [360, 100, 100],
		cmyk: [100, 100, 100, 100]
	};
	
	Color.prototype.getValues = function (space) {
		var values = this.values;
		var vals = {};
	
		for (var i = 0; i < space.length; i++) {
			vals[space.charAt(i)] = values[space][i];
		}
	
		if (values.alpha !== 1) {
			vals.a = values.alpha;
		}
	
		// {r: 255, g: 255, b: 255, a: 0.4}
		return vals;
	};
	
	Color.prototype.setValues = function (space, vals) {
		var values = this.values;
		var spaces = this.spaces;
		var maxes = this.maxes;
		var alpha = 1;
		var i;
	
		this.valid = true;
	
		if (space === 'alpha') {
			alpha = vals;
		} else if (vals.length) {
			// [10, 10, 10]
			values[space] = vals.slice(0, space.length);
			alpha = vals[space.length];
		} else if (vals[space.charAt(0)] !== undefined) {
			// {r: 10, g: 10, b: 10}
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[space.charAt(i)];
			}
	
			alpha = vals.a;
		} else if (vals[spaces[space][0]] !== undefined) {
			// {red: 10, green: 10, blue: 10}
			var chans = spaces[space];
	
			for (i = 0; i < space.length; i++) {
				values[space][i] = vals[chans[i]];
			}
	
			alpha = vals.alpha;
		}
	
		values.alpha = Math.max(0, Math.min(1, (alpha === undefined ? values.alpha : alpha)));
	
		if (space === 'alpha') {
			return false;
		}
	
		var capped;
	
		// cap values of the space prior converting all values
		for (i = 0; i < space.length; i++) {
			capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
			values[space][i] = Math.round(capped);
		}
	
		// convert to all the other color spaces
		for (var sname in spaces) {
			if (sname !== space) {
				values[sname] = convert[space][sname](values[space]);
			}
		}
	
		return true;
	};
	
	Color.prototype.setSpace = function (space, args) {
		var vals = args[0];
	
		if (vals === undefined) {
			// color.rgb()
			return this.getValues(space);
		}
	
		// color.rgb(10, 10, 10)
		if (typeof vals === 'number') {
			vals = Array.prototype.slice.call(args);
		}
	
		this.setValues(space, vals);
		return this;
	};
	
	Color.prototype.setChannel = function (space, index, val) {
		var svalues = this.values[space];
		if (val === undefined) {
			// color.red()
			return svalues[index];
		} else if (val === svalues[index]) {
			// color.red(color.red())
			return this;
		}
	
		// color.red(100)
		svalues[index] = val;
		this.setValues(space, svalues);
	
		return this;
	};
	
	if (typeof window !== 'undefined') {
		window.Color = Color;
	}
	
	module.exports = Color;


/***/ },
/* 895 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var emptyObject = __webpack_require__(300);
	var _invariant = __webpack_require__(18);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(3249)
	
	var md5 = toConstructor(__webpack_require__(1870))
	var rmd160 = toConstructor(__webpack_require__(3236))
	
	function toConstructor (fn) {
	  return function () {
	    var buffers = []
	    var m= {
	      update: function (data, enc) {
	        if(!Buffer.isBuffer(data)) data = new Buffer(data, enc)
	        buffers.push(data)
	        return this
	      },
	      digest: function (enc) {
	        var buf = Buffer.concat(buffers)
	        var r = fn(buf)
	        buffers = null
	        return enc ? r.toString(enc) : r
	      }
	    }
	    return m
	  }
	}
	
	module.exports = function (alg) {
	  if('md5' === alg) return new md5()
	  if('rmd160' === alg) return new rmd160()
	  return createHash(alg)
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-hierarchy/ Version 1.1.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	var cluster = function() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	};
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	var node_count = function() {
	  return this.eachAfter(count);
	};
	
	var node_each = function(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	};
	
	var node_eachBefore = function(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	};
	
	var node_eachAfter = function(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	};
	
	var node_sum = function(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	};
	
	var node_sort = function(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	};
	
	var node_path = function(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	};
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	var node_ancestors = function() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	};
	
	var node_descendants = function() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	};
	
	var node_leaves = function() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	};
	
	var node_links = function() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	};
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	var enclose = function(circles) {
	  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	};
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(a, b, c) {
	  var ax = a.x,
	      ay = a.y,
	      da = b.r + c.r,
	      db = a.r + c.r,
	      dx = b.x - ax,
	      dy = b.y - ay,
	      dc = dx * dx + dy * dy;
	  if (dc) {
	    var x = 0.5 + ((db *= db) - (da *= da)) / (2 * dc),
	        y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	    c.x = ax + x * dx + y * dy;
	    c.y = ay + x * dy - y * dx;
	  } else {
	    c.x = ax + db;
	    c.y = ay;
	  }
	}
	
	function intersects(a, b) {
	  var dx = b.x - a.x,
	      dy = b.y - a.y,
	      dr = a.r + b.r;
	  return dr * dr - 1e-6 > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	var siblings = function(circles) {
	  packEnclose(circles);
	  return circles;
	};
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	var index = function() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	};
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	var roundNode = function(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	};
	
	var treemapDice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	};
	
	var partition = function() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	};
	
	var keyPrefix = "$";
	var preroot = {depth: -1};
	var ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	var stratify = function() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	};
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	var tree = function() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	};
	
	var treemapSlice = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	};
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = ((function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	}))(phi);
	
	var index$1 = function() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	};
	
	var binary = function(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	};
	
	var sliceDice = function(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	};
	
	var resquarify = ((function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	}))(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packSiblings = siblings;
	exports.packEnclose = enclose;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	exports.treemapResquarify = resquarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.1.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(420)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newYear(y) {
	  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, newDate) {
	    return function(string) {
	      var d = newYear(1900),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newYear(d.y)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = newDate(newYear(d.y)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return newDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", localDate);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier, utcDate);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"};
	var numberRe = /^\s*\d+/;
	var percentRe = /^%/;
	var requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	
	
	
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-voronoi/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	function x(d) {
	  return d[0];
	}
	
	function y(d) {
	  return d[1];
	}
	
	function RedBlackTree() {
	  this._ = null; // root node
	}
	
	function RedBlackNode(node) {
	  node.U = // parent node
	  node.C = // color - true for red, false for black
	  node.L = // left node
	  node.R = // right node
	  node.P = // previous node
	  node.N = null; // next node
	}
	
	RedBlackTree.prototype = {
	  constructor: RedBlackTree,
	
	  insert: function(after, node) {
	    var parent, grandpa, uncle;
	
	    if (after) {
	      node.P = after;
	      node.N = after.N;
	      if (after.N) after.N.P = node;
	      after.N = node;
	      if (after.R) {
	        after = after.R;
	        while (after.L) after = after.L;
	        after.L = node;
	      } else {
	        after.R = node;
	      }
	      parent = after;
	    } else if (this._) {
	      after = RedBlackFirst(this._);
	      node.P = null;
	      node.N = after;
	      after.P = after.L = node;
	      parent = after;
	    } else {
	      node.P = node.N = null;
	      this._ = node;
	      parent = null;
	    }
	    node.L = node.R = null;
	    node.U = parent;
	    node.C = true;
	
	    after = node;
	    while (parent && parent.C) {
	      grandpa = parent.U;
	      if (parent === grandpa.L) {
	        uncle = grandpa.R;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.R) {
	            RedBlackRotateLeft(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateRight(this, grandpa);
	        }
	      } else {
	        uncle = grandpa.L;
	        if (uncle && uncle.C) {
	          parent.C = uncle.C = false;
	          grandpa.C = true;
	          after = grandpa;
	        } else {
	          if (after === parent.L) {
	            RedBlackRotateRight(this, parent);
	            after = parent;
	            parent = after.U;
	          }
	          parent.C = false;
	          grandpa.C = true;
	          RedBlackRotateLeft(this, grandpa);
	        }
	      }
	      parent = after.U;
	    }
	    this._.C = false;
	  },
	
	  remove: function(node) {
	    if (node.N) node.N.P = node.P;
	    if (node.P) node.P.N = node.N;
	    node.N = node.P = null;
	
	    var parent = node.U,
	        sibling,
	        left = node.L,
	        right = node.R,
	        next,
	        red;
	
	    if (!left) next = right;
	    else if (!right) next = left;
	    else next = RedBlackFirst(right);
	
	    if (parent) {
	      if (parent.L === node) parent.L = next;
	      else parent.R = next;
	    } else {
	      this._ = next;
	    }
	
	    if (left && right) {
	      red = next.C;
	      next.C = node.C;
	      next.L = left;
	      left.U = next;
	      if (next !== right) {
	        parent = next.U;
	        next.U = node.U;
	        node = next.R;
	        parent.L = node;
	        next.R = right;
	        right.U = next;
	      } else {
	        next.U = parent;
	        parent = next;
	        node = next.R;
	      }
	    } else {
	      red = node.C;
	      node = next;
	    }
	
	    if (node) node.U = parent;
	    if (red) return;
	    if (node && node.C) { node.C = false; return; }
	
	    do {
	      if (node === this._) break;
	      if (node === parent.L) {
	        sibling = parent.R;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateLeft(this, parent);
	          sibling = parent.R;
	        }
	        if ((sibling.L && sibling.L.C)
	            || (sibling.R && sibling.R.C)) {
	          if (!sibling.R || !sibling.R.C) {
	            sibling.L.C = false;
	            sibling.C = true;
	            RedBlackRotateRight(this, sibling);
	            sibling = parent.R;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.R.C = false;
	          RedBlackRotateLeft(this, parent);
	          node = this._;
	          break;
	        }
	      } else {
	        sibling = parent.L;
	        if (sibling.C) {
	          sibling.C = false;
	          parent.C = true;
	          RedBlackRotateRight(this, parent);
	          sibling = parent.L;
	        }
	        if ((sibling.L && sibling.L.C)
	          || (sibling.R && sibling.R.C)) {
	          if (!sibling.L || !sibling.L.C) {
	            sibling.R.C = false;
	            sibling.C = true;
	            RedBlackRotateLeft(this, sibling);
	            sibling = parent.L;
	          }
	          sibling.C = parent.C;
	          parent.C = sibling.L.C = false;
	          RedBlackRotateRight(this, parent);
	          node = this._;
	          break;
	        }
	      }
	      sibling.C = true;
	      node = parent;
	      parent = parent.U;
	    } while (!node.C);
	
	    if (node) node.C = false;
	  }
	};
	
	function RedBlackRotateLeft(tree, node) {
	  var p = node,
	      q = node.R,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.R = q.L;
	  if (p.R) p.R.U = p;
	  q.L = p;
	}
	
	function RedBlackRotateRight(tree, node) {
	  var p = node,
	      q = node.L,
	      parent = p.U;
	
	  if (parent) {
	    if (parent.L === p) parent.L = q;
	    else parent.R = q;
	  } else {
	    tree._ = q;
	  }
	
	  q.U = parent;
	  p.U = q;
	  p.L = q.R;
	  if (p.L) p.L.U = p;
	  q.R = p;
	}
	
	function RedBlackFirst(node) {
	  while (node.L) node = node.L;
	  return node;
	}
	
	function createEdge(left, right, v0, v1) {
	  var edge = [null, null],
	      index = edges.push(edge) - 1;
	  edge.left = left;
	  edge.right = right;
	  if (v0) setEdgeEnd(edge, left, right, v0);
	  if (v1) setEdgeEnd(edge, right, left, v1);
	  cells[left.index].halfedges.push(index);
	  cells[right.index].halfedges.push(index);
	  return edge;
	}
	
	function createBorderEdge(left, v0, v1) {
	  var edge = [v0, v1];
	  edge.left = left;
	  return edge;
	}
	
	function setEdgeEnd(edge, left, right, vertex) {
	  if (!edge[0] && !edge[1]) {
	    edge[0] = vertex;
	    edge.left = left;
	    edge.right = right;
	  } else if (edge.left === right) {
	    edge[1] = vertex;
	  } else {
	    edge[0] = vertex;
	  }
	}
	
	// Liang–Barsky line clipping.
	function clipEdge(edge, x0, y0, x1, y1) {
	  var a = edge[0],
	      b = edge[1],
	      ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (!(t0 > 0) && !(t1 < 1)) return true; // TODO Better check?
	
	  if (t0 > 0) edge[0] = [ax + t0 * dx, ay + t0 * dy];
	  if (t1 < 1) edge[1] = [ax + t1 * dx, ay + t1 * dy];
	  return true;
	}
	
	function connectEdge(edge, x0, y0, x1, y1) {
	  var v1 = edge[1];
	  if (v1) return true;
	
	  var v0 = edge[0],
	      left = edge.left,
	      right = edge.right,
	      lx = left[0],
	      ly = left[1],
	      rx = right[0],
	      ry = right[1],
	      fx = (lx + rx) / 2,
	      fy = (ly + ry) / 2,
	      fm,
	      fb;
	
	  if (ry === ly) {
	    if (fx < x0 || fx >= x1) return;
	    if (lx > rx) {
	      if (!v0) v0 = [fx, y0];
	      else if (v0[1] >= y1) return;
	      v1 = [fx, y1];
	    } else {
	      if (!v0) v0 = [fx, y1];
	      else if (v0[1] < y0) return;
	      v1 = [fx, y0];
	    }
	  } else {
	    fm = (lx - rx) / (ry - ly);
	    fb = fy - fm * fx;
	    if (fm < -1 || fm > 1) {
	      if (lx > rx) {
	        if (!v0) v0 = [(y0 - fb) / fm, y0];
	        else if (v0[1] >= y1) return;
	        v1 = [(y1 - fb) / fm, y1];
	      } else {
	        if (!v0) v0 = [(y1 - fb) / fm, y1];
	        else if (v0[1] < y0) return;
	        v1 = [(y0 - fb) / fm, y0];
	      }
	    } else {
	      if (ly < ry) {
	        if (!v0) v0 = [x0, fm * x0 + fb];
	        else if (v0[0] >= x1) return;
	        v1 = [x1, fm * x1 + fb];
	      } else {
	        if (!v0) v0 = [x1, fm * x1 + fb];
	        else if (v0[0] < x0) return;
	        v1 = [x0, fm * x0 + fb];
	      }
	    }
	  }
	
	  edge[0] = v0;
	  edge[1] = v1;
	  return true;
	}
	
	function clipEdges(x0, y0, x1, y1) {
	  var i = edges.length,
	      edge;
	
	  while (i--) {
	    if (!connectEdge(edge = edges[i], x0, y0, x1, y1)
	        || !clipEdge(edge, x0, y0, x1, y1)
	        || !(Math.abs(edge[0][0] - edge[1][0]) > epsilon
	            || Math.abs(edge[0][1] - edge[1][1]) > epsilon)) {
	      delete edges[i];
	    }
	  }
	}
	
	function createCell(site) {
	  return cells[site.index] = {
	    site: site,
	    halfedges: []
	  };
	}
	
	function cellHalfedgeAngle(cell, edge) {
	  var site = cell.site,
	      va = edge.left,
	      vb = edge.right;
	  if (site === vb) vb = va, va = site;
	  if (vb) return Math.atan2(vb[1] - va[1], vb[0] - va[0]);
	  if (site === va) va = edge[1], vb = edge[0];
	  else va = edge[0], vb = edge[1];
	  return Math.atan2(va[0] - vb[0], vb[1] - va[1]);
	}
	
	function cellHalfedgeStart(cell, edge) {
	  return edge[+(edge.left !== cell.site)];
	}
	
	function cellHalfedgeEnd(cell, edge) {
	  return edge[+(edge.left === cell.site)];
	}
	
	function sortCellHalfedges() {
	  for (var i = 0, n = cells.length, cell, halfedges, j, m; i < n; ++i) {
	    if ((cell = cells[i]) && (m = (halfedges = cell.halfedges).length)) {
	      var index = new Array(m),
	          array = new Array(m);
	      for (j = 0; j < m; ++j) index[j] = j, array[j] = cellHalfedgeAngle(cell, edges[halfedges[j]]);
	      index.sort(function(i, j) { return array[j] - array[i]; });
	      for (j = 0; j < m; ++j) array[j] = halfedges[index[j]];
	      for (j = 0; j < m; ++j) halfedges[j] = array[j];
	    }
	  }
	}
	
	function clipCells(x0, y0, x1, y1) {
	  var nCells = cells.length,
	      iCell,
	      cell,
	      site,
	      iHalfedge,
	      halfedges,
	      nHalfedges,
	      start,
	      startX,
	      startY,
	      end,
	      endX,
	      endY,
	      cover = true;
	
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      site = cell.site;
	      halfedges = cell.halfedges;
	      iHalfedge = halfedges.length;
	
	      // Remove any dangling clipped edges.
	      while (iHalfedge--) {
	        if (!edges[halfedges[iHalfedge]]) {
	          halfedges.splice(iHalfedge, 1);
	        }
	      }
	
	      // Insert any border edges as necessary.
	      iHalfedge = 0, nHalfedges = halfedges.length;
	      while (iHalfedge < nHalfedges) {
	        end = cellHalfedgeEnd(cell, edges[halfedges[iHalfedge]]), endX = end[0], endY = end[1];
	        start = cellHalfedgeStart(cell, edges[halfedges[++iHalfedge % nHalfedges]]), startX = start[0], startY = start[1];
	        if (Math.abs(endX - startX) > epsilon || Math.abs(endY - startY) > epsilon) {
	          halfedges.splice(iHalfedge, 0, edges.push(createBorderEdge(site, end,
	              Math.abs(endX - x0) < epsilon && y1 - endY > epsilon ? [x0, Math.abs(startX - x0) < epsilon ? startY : y1]
	              : Math.abs(endY - y1) < epsilon && x1 - endX > epsilon ? [Math.abs(startY - y1) < epsilon ? startX : x1, y1]
	              : Math.abs(endX - x1) < epsilon && endY - y0 > epsilon ? [x1, Math.abs(startX - x1) < epsilon ? startY : y0]
	              : Math.abs(endY - y0) < epsilon && endX - x0 > epsilon ? [Math.abs(startY - y0) < epsilon ? startX : x0, y0]
	              : null)) - 1);
	          ++nHalfedges;
	        }
	      }
	
	      if (nHalfedges) cover = false;
	    }
	  }
	
	  // If there weren’t any edges, have the closest site cover the extent.
	  // It doesn’t matter which corner of the extent we measure!
	  if (cover) {
	    var dx, dy, d2, dc = Infinity;
	
	    for (iCell = 0, cover = null; iCell < nCells; ++iCell) {
	      if (cell = cells[iCell]) {
	        site = cell.site;
	        dx = site[0] - x0;
	        dy = site[1] - y0;
	        d2 = dx * dx + dy * dy;
	        if (d2 < dc) dc = d2, cover = cell;
	      }
	    }
	
	    if (cover) {
	      var v00 = [x0, y0], v01 = [x0, y1], v11 = [x1, y1], v10 = [x1, y0];
	      cover.halfedges.push(
	        edges.push(createBorderEdge(site = cover.site, v00, v01)) - 1,
	        edges.push(createBorderEdge(site, v01, v11)) - 1,
	        edges.push(createBorderEdge(site, v11, v10)) - 1,
	        edges.push(createBorderEdge(site, v10, v00)) - 1
	      );
	    }
	  }
	
	  // Lastly delete any cells with no edges; these were entirely clipped.
	  for (iCell = 0; iCell < nCells; ++iCell) {
	    if (cell = cells[iCell]) {
	      if (!cell.halfedges.length) {
	        delete cells[iCell];
	      }
	    }
	  }
	}
	
	var circlePool = [];
	
	var firstCircle;
	
	function Circle() {
	  RedBlackNode(this);
	  this.x =
	  this.y =
	  this.arc =
	  this.site =
	  this.cy = null;
	}
	
	function attachCircle(arc) {
	  var lArc = arc.P,
	      rArc = arc.N;
	
	  if (!lArc || !rArc) return;
	
	  var lSite = lArc.site,
	      cSite = arc.site,
	      rSite = rArc.site;
	
	  if (lSite === rSite) return;
	
	  var bx = cSite[0],
	      by = cSite[1],
	      ax = lSite[0] - bx,
	      ay = lSite[1] - by,
	      cx = rSite[0] - bx,
	      cy = rSite[1] - by;
	
	  var d = 2 * (ax * cy - ay * cx);
	  if (d >= -epsilon2) return;
	
	  var ha = ax * ax + ay * ay,
	      hc = cx * cx + cy * cy,
	      x = (cy * ha - ay * hc) / d,
	      y = (ax * hc - cx * ha) / d;
	
	  var circle = circlePool.pop() || new Circle;
	  circle.arc = arc;
	  circle.site = cSite;
	  circle.x = x + bx;
	  circle.y = (circle.cy = y + by) + Math.sqrt(x * x + y * y); // y bottom
	
	  arc.circle = circle;
	
	  var before = null,
	      node = circles._;
	
	  while (node) {
	    if (circle.y < node.y || (circle.y === node.y && circle.x <= node.x)) {
	      if (node.L) node = node.L;
	      else { before = node.P; break; }
	    } else {
	      if (node.R) node = node.R;
	      else { before = node; break; }
	    }
	  }
	
	  circles.insert(before, circle);
	  if (!before) firstCircle = circle;
	}
	
	function detachCircle(arc) {
	  var circle = arc.circle;
	  if (circle) {
	    if (!circle.P) firstCircle = circle.N;
	    circles.remove(circle);
	    circlePool.push(circle);
	    RedBlackNode(circle);
	    arc.circle = null;
	  }
	}
	
	var beachPool = [];
	
	function Beach() {
	  RedBlackNode(this);
	  this.edge =
	  this.site =
	  this.circle = null;
	}
	
	function createBeach(site) {
	  var beach = beachPool.pop() || new Beach;
	  beach.site = site;
	  return beach;
	}
	
	function detachBeach(beach) {
	  detachCircle(beach);
	  beaches.remove(beach);
	  beachPool.push(beach);
	  RedBlackNode(beach);
	}
	
	function removeBeach(beach) {
	  var circle = beach.circle,
	      x = circle.x,
	      y = circle.cy,
	      vertex = [x, y],
	      previous = beach.P,
	      next = beach.N,
	      disappearing = [beach];
	
	  detachBeach(beach);
	
	  var lArc = previous;
	  while (lArc.circle
	      && Math.abs(x - lArc.circle.x) < epsilon
	      && Math.abs(y - lArc.circle.cy) < epsilon) {
	    previous = lArc.P;
	    disappearing.unshift(lArc);
	    detachBeach(lArc);
	    lArc = previous;
	  }
	
	  disappearing.unshift(lArc);
	  detachCircle(lArc);
	
	  var rArc = next;
	  while (rArc.circle
	      && Math.abs(x - rArc.circle.x) < epsilon
	      && Math.abs(y - rArc.circle.cy) < epsilon) {
	    next = rArc.N;
	    disappearing.push(rArc);
	    detachBeach(rArc);
	    rArc = next;
	  }
	
	  disappearing.push(rArc);
	  detachCircle(rArc);
	
	  var nArcs = disappearing.length,
	      iArc;
	  for (iArc = 1; iArc < nArcs; ++iArc) {
	    rArc = disappearing[iArc];
	    lArc = disappearing[iArc - 1];
	    setEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	  }
	
	  lArc = disappearing[0];
	  rArc = disappearing[nArcs - 1];
	  rArc.edge = createEdge(lArc.site, rArc.site, null, vertex);
	
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function addBeach(site) {
	  var x = site[0],
	      directrix = site[1],
	      lArc,
	      rArc,
	      dxl,
	      dxr,
	      node = beaches._;
	
	  while (node) {
	    dxl = leftBreakPoint(node, directrix) - x;
	    if (dxl > epsilon) node = node.L; else {
	      dxr = x - rightBreakPoint(node, directrix);
	      if (dxr > epsilon) {
	        if (!node.R) {
	          lArc = node;
	          break;
	        }
	        node = node.R;
	      } else {
	        if (dxl > -epsilon) {
	          lArc = node.P;
	          rArc = node;
	        } else if (dxr > -epsilon) {
	          lArc = node;
	          rArc = node.N;
	        } else {
	          lArc = rArc = node;
	        }
	        break;
	      }
	    }
	  }
	
	  createCell(site);
	  var newArc = createBeach(site);
	  beaches.insert(lArc, newArc);
	
	  if (!lArc && !rArc) return;
	
	  if (lArc === rArc) {
	    detachCircle(lArc);
	    rArc = createBeach(lArc.site);
	    beaches.insert(newArc, rArc);
	    newArc.edge = rArc.edge = createEdge(lArc.site, newArc.site);
	    attachCircle(lArc);
	    attachCircle(rArc);
	    return;
	  }
	
	  if (!rArc) { // && lArc
	    newArc.edge = createEdge(lArc.site, newArc.site);
	    return;
	  }
	
	  // else lArc !== rArc
	  detachCircle(lArc);
	  detachCircle(rArc);
	
	  var lSite = lArc.site,
	      ax = lSite[0],
	      ay = lSite[1],
	      bx = site[0] - ax,
	      by = site[1] - ay,
	      rSite = rArc.site,
	      cx = rSite[0] - ax,
	      cy = rSite[1] - ay,
	      d = 2 * (bx * cy - by * cx),
	      hb = bx * bx + by * by,
	      hc = cx * cx + cy * cy,
	      vertex = [(cy * hb - by * hc) / d + ax, (bx * hc - cx * hb) / d + ay];
	
	  setEdgeEnd(rArc.edge, lSite, rSite, vertex);
	  newArc.edge = createEdge(lSite, site, null, vertex);
	  rArc.edge = createEdge(site, rSite, null, vertex);
	  attachCircle(lArc);
	  attachCircle(rArc);
	}
	
	function leftBreakPoint(arc, directrix) {
	  var site = arc.site,
	      rfocx = site[0],
	      rfocy = site[1],
	      pby2 = rfocy - directrix;
	
	  if (!pby2) return rfocx;
	
	  var lArc = arc.P;
	  if (!lArc) return -Infinity;
	
	  site = lArc.site;
	  var lfocx = site[0],
	      lfocy = site[1],
	      plby2 = lfocy - directrix;
	
	  if (!plby2) return lfocx;
	
	  var hl = lfocx - rfocx,
	      aby2 = 1 / pby2 - 1 / plby2,
	      b = hl / plby2;
	
	  if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	
	  return (rfocx + lfocx) / 2;
	}
	
	function rightBreakPoint(arc, directrix) {
	  var rArc = arc.N;
	  if (rArc) return leftBreakPoint(rArc, directrix);
	  var site = arc.site;
	  return site[1] === directrix ? site[0] : Infinity;
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var beaches;
	var cells;
	var circles;
	var edges;
	
	function triangleArea(a, b, c) {
	  return (a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]);
	}
	
	function lexicographic(a, b) {
	  return b[1] - a[1]
	      || b[0] - a[0];
	}
	
	function Diagram(sites, extent) {
	  var site = sites.sort(lexicographic).pop(),
	      x,
	      y,
	      circle;
	
	  edges = [];
	  cells = new Array(sites.length);
	  beaches = new RedBlackTree;
	  circles = new RedBlackTree;
	
	  while (true) {
	    circle = firstCircle;
	    if (site && (!circle || site[1] < circle.y || (site[1] === circle.y && site[0] < circle.x))) {
	      if (site[0] !== x || site[1] !== y) {
	        addBeach(site);
	        x = site[0], y = site[1];
	      }
	      site = sites.pop();
	    } else if (circle) {
	      removeBeach(circle.arc);
	    } else {
	      break;
	    }
	  }
	
	  sortCellHalfedges();
	
	  if (extent) {
	    var x0 = +extent[0][0],
	        y0 = +extent[0][1],
	        x1 = +extent[1][0],
	        y1 = +extent[1][1];
	    clipEdges(x0, y0, x1, y1);
	    clipCells(x0, y0, x1, y1);
	  }
	
	  this.edges = edges;
	  this.cells = cells;
	
	  beaches =
	  circles =
	  edges =
	  cells = null;
	}
	
	Diagram.prototype = {
	  constructor: Diagram,
	
	  polygons: function() {
	    var edges = this.edges;
	
	    return this.cells.map(function(cell) {
	      var polygon = cell.halfedges.map(function(i) { return cellHalfedgeStart(cell, edges[i]); });
	      polygon.data = cell.site.data;
	      return polygon;
	    });
	  },
	
	  triangles: function() {
	    var triangles = [],
	        edges = this.edges;
	
	    this.cells.forEach(function(cell, i) {
	      if (!(m = (halfedges = cell.halfedges).length)) return;
	      var site = cell.site,
	          halfedges,
	          j = -1,
	          m,
	          s0,
	          e1 = edges[halfedges[m - 1]],
	          s1 = e1.left === site ? e1.right : e1.left;
	
	      while (++j < m) {
	        s0 = s1;
	        e1 = edges[halfedges[j]];
	        s1 = e1.left === site ? e1.right : e1.left;
	        if (s0 && s1 && i < s0.index && i < s1.index && triangleArea(site, s0, s1) < 0) {
	          triangles.push([site.data, s0.data, s1.data]);
	        }
	      }
	    });
	
	    return triangles;
	  },
	
	  links: function() {
	    return this.edges.filter(function(edge) {
	      return edge.right;
	    }).map(function(edge) {
	      return {
	        source: edge.left.data,
	        target: edge.right.data
	      };
	    });
	  },
	
	  find: function(x, y, radius) {
	    var that = this, i0, i1 = that._found || 0, n = that.cells.length, cell;
	
	    // Use the previously-found cell, or start with an arbitrary one.
	    while (!(cell = that.cells[i1])) if (++i1 >= n) return null;
	    var dx = x - cell.site[0], dy = y - cell.site[1], d2 = dx * dx + dy * dy;
	
	    // Traverse the half-edges to find a closer cell, if any.
	    do {
	      cell = that.cells[i0 = i1], i1 = null;
	      cell.halfedges.forEach(function(e) {
	        var edge = that.edges[e], v = edge.left;
	        if ((v === cell.site || !v) && !(v = edge.right)) return;
	        var vx = x - v[0], vy = y - v[1], v2 = vx * vx + vy * vy;
	        if (v2 < d2) d2 = v2, i1 = v.index;
	      });
	    } while (i1 !== null);
	
	    that._found = i0;
	
	    return radius == null || d2 <= radius * radius ? cell.site : null;
	  }
	};
	
	var voronoi = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      extent = null;
	
	  function voronoi(data) {
	    return new Diagram(data.map(function(d, i) {
	      var s = [Math.round(x$$1(d, i, data) / epsilon) * epsilon, Math.round(y$$1(d, i, data) / epsilon) * epsilon];
	      s.index = i;
	      s.data = d;
	      return s;
	    }), extent);
	  }
	
	  voronoi.polygons = function(data) {
	    return voronoi(data).polygons();
	  };
	
	  voronoi.links = function(data) {
	    return voronoi(data).links();
	  };
	
	  voronoi.triangles = function(data) {
	    return voronoi(data).triangles();
	  };
	
	  voronoi.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : x$$1;
	  };
	
	  voronoi.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant(+_), voronoi) : y$$1;
	  };
	
	  voronoi.extent = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[+_[0][0], +_[0][1]], [+_[1][0], +_[1][1]]], voronoi) : extent && [[extent[0][0], extent[0][1]], [extent[1][0], extent[1][1]]];
	  };
	
	  voronoi.size = function(_) {
	    return arguments.length ? (extent = _ == null ? null : [[0, 0], [+_[0], +_[1]]], voronoi) : extent && [extent[1][0] - extent[0][0], extent[1][1] - extent[0][1]];
	  };
	
	  return voronoi;
	};
	
	exports.voronoi = voronoi;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(1881);
	var isArguments = __webpack_require__(1880);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	function getOffsetParent(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return null;
	  }
	  // ie 这个也不是完全可行
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = void 0;
	  var positionStyle = _utils2['default'].css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : element.parentNode;
	  }
	
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	  return null;
	}
	
	exports['default'] = getOffsetParent;
	module.exports = exports['default'];

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = activeElement;
	
	var _ownerDocument = __webpack_require__(182);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function activeElement() {
	  var doc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _ownerDocument2.default)();
	
	  try {
	    return doc.activeElement;
	  } catch (e) {/* ie throws if no active element */}
	}
	module.exports = exports['default'];

/***/ },
/* 904 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offset;
	
	var _contains = __webpack_require__(183);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _isWindow = __webpack_require__(293);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(182);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function offset(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      win = (0, _isWindow2.default)(doc),
	      docElem = doc && doc.documentElement,
	      box = { top: 0, left: 0, height: 0, width: 0 };
	
	  if (!doc) return;
	
	  // Make sure it's not a disconnected DOM node
	  if (!(0, _contains2.default)(docElem, node)) return box;
	
	  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();
	
	  // IE8 getBoundingClientRect doesn't support width & height
	  box = {
	    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
	    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
	    width: (box.width == null ? node.offsetWidth : box.width) || 0,
	    height: (box.height == null ? node.offsetHeight : box.height) || 0
	  };
	
	  return box;
	}
	module.exports = exports['default'];

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(293);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var transform = 'transform';
	var prefix = void 0,
	    transitionEnd = void 0,
	    animationEnd = void 0;
	var transitionProperty = void 0,
	    transitionDuration = void 0,
	    transitionTiming = void 0,
	    transitionDelay = void 0;
	var animationName = void 0,
	    animationDuration = void 0,
	    animationTiming = void 0,
	    animationDelay = void 0;
	
	if (_inDOM2.default) {
	  var _getTransitionPropert = getTransitionProperties();
	
	  prefix = _getTransitionPropert.prefix;
	  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
	  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
	
	
	  exports.transform = transform = prefix + '-' + transform;
	  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
	  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
	  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
	  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';
	
	  exports.animationName = animationName = prefix + '-animation-name';
	  exports.animationDuration = animationDuration = prefix + '-animation-duration';
	  exports.animationTiming = animationTiming = prefix + '-animation-delay';
	  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
	}
	
	exports.transform = transform;
	exports.transitionProperty = transitionProperty;
	exports.transitionTiming = transitionTiming;
	exports.transitionDelay = transitionDelay;
	exports.transitionDuration = transitionDuration;
	exports.transitionEnd = transitionEnd;
	exports.animationName = animationName;
	exports.animationDuration = animationDuration;
	exports.animationTiming = animationTiming;
	exports.animationDelay = animationDelay;
	exports.animationEnd = animationEnd;
	exports.default = {
	  transform: transform,
	  end: transitionEnd,
	  property: transitionProperty,
	  timing: transitionTiming,
	  delay: transitionDelay,
	  duration: transitionDuration
	};
	
	
	function getTransitionProperties() {
	  var style = document.createElement('div').style;
	
	  var vendorMap = {
	    O: function O(e) {
	      return 'o' + e.toLowerCase();
	    },
	    Moz: function Moz(e) {
	      return e.toLowerCase();
	    },
	    Webkit: function Webkit(e) {
	      return 'webkit' + e;
	    },
	    ms: function ms(e) {
	      return 'MS' + e;
	    }
	  };
	
	  var vendors = Object.keys(vendorMap);
	
	  var transitionEnd = void 0,
	      animationEnd = void 0;
	  var prefix = '';
	
	  for (var i = 0; i < vendors.length; i++) {
	    var vendor = vendors[i];
	
	    if (vendor + 'TransitionProperty' in style) {
	      prefix = '-' + vendor.toLowerCase();
	      transitionEnd = vendorMap[vendor]('TransitionEnd');
	      animationEnd = vendorMap[vendor]('AnimationEnd');
	      break;
	    }
	  }
	
	  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
	
	  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
	
	  style = null;
	
	  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
	}

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelizeStyleName;
	
	var _camelize = __webpack_require__(1906);
	
	var _camelize2 = _interopRequireDefault(_camelize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^-ms-/; /**
	                          * Copyright 2014-2015, Facebook, Inc.
	                          * All rights reserved.
	                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
	                          */
	function camelizeStyleName(string) {
	  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
	}
	module.exports = exports['default'];

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (recalc) {
	  if (!size || recalc) {
	    if (_inDOM2.default) {
	      var scrollDiv = document.createElement('div');
	
	      scrollDiv.style.position = 'absolute';
	      scrollDiv.style.top = '-9999px';
	      scrollDiv.style.width = '50px';
	      scrollDiv.style.height = '50px';
	      scrollDiv.style.overflow = 'scroll';
	
	      document.body.appendChild(scrollDiv);
	      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	    }
	  }
	
	  return size;
	};
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var size = void 0;
	
	module.exports = exports['default'];

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var emptyFunction = __webpack_require__(67);
	var findRangesImmutable = __webpack_require__(227);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat,
	    Record = Immutable.Record;
	
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(contentState, block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ },
/* 911 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorLeaf = __webpack_require__(1921);
	var DraftOffsetKey = __webpack_require__(226);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(14);
	var Scroll = __webpack_require__(943);
	var Style = __webpack_require__(432);
	var UnicodeBidi = __webpack_require__(944);
	var UnicodeBidiDirection = __webpack_require__(433);
	
	var cx = __webpack_require__(186);
	var getElementPosition = __webpack_require__(2015);
	var getScrollPosition = __webpack_require__(435);
	var getViewportDimensions = __webpack_require__(2019);
	var invariant = __webpack_require__(18);
	var nullthrows = __webpack_require__(84);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	};
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	
	var DraftEditorBlock = function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  };
	
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	
	
	  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = ReactDOM.findDOMNode(this);
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta = void 0;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          block: block,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : null,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      var decoratorKey = leafSet.get('decoratorKey');
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	      // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	
	      return React.createElement(
	        DecoratorComponent,
	        _extends({}, decoratorProps, {
	          contentState: _this2.props.contentState,
	          decoratedText: decoratedText,
	          dir: dir,
	          key: decoratorOffsetKey,
	          entityKey: block.getEntityAt(leafSet.get('start')),
	          offsetKey: decoratorOffsetKey }),
	        leaves
	      );
	    }).toArray();
	  };
	
	  DraftEditorBlock.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        offsetKey = _props.offsetKey;
	
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	
	    return React.createElement(
	      'div',
	      { 'data-offset-key': offsetKey, className: className },
	      this._renderChildren()
	    );
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	module.exports = DraftEditorBlock;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * @legacyServerCallableInstance
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(26);
	
	var Record = Immutable.Record;
	
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = function (_DraftEntityInstanceR) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
	  }
	
	  DraftEntityInstance.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  DraftEntityInstance.prototype.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  DraftEntityInstance.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(2006);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'\u2018\u2019]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ },
/* 915 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	var SelectionState = __webpack_require__(184);
	
	var adjustBlockDepthForContentState = __webpack_require__(1931);
	var nullthrows = __webpack_require__(84);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    var contentState = editorState.getCurrentContent();
	    var entityMap = contentState.getEntityMap();
	    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && entityMap.__get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        // they may have custom editor commands; ignore those
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
	      var withoutAtomicBlock = content.merge({
	        blockMap: blockMap,
	        selectionAfter: selection
	      });
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).reverse().skipWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of the first styled block, or
	   * an empty styled block, changes block to 'unstyled'. Returns null if
	   * block or selection does not meet that criteria.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	
	      var firstBlock = content.getFirstBlock();
	      if (block.getLength() > 0 && block !== firstBlock) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _knownListItemDepthCl,
	    _assign = __webpack_require__(25);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(148);
	var ContentBlockNode = __webpack_require__(78);
	var DefaultDraftBlockRenderMap = __webpack_require__(423);
	var DraftEntity = __webpack_require__(296);
	var DraftFeatureFlags = __webpack_require__(125);
	var Immutable = __webpack_require__(26);
	
	var _require = __webpack_require__(26),
	    Set = _require.Set;
	
	var URI = __webpack_require__(2007);
	
	var cx = __webpack_require__(186);
	var generateRandomKey = __webpack_require__(108);
	var getSafeBodyFromHTML = __webpack_require__(923);
	var invariant = __webpack_require__(18);
	var sanitizeDraftText = __webpack_require__(428);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    OrderedSet = Immutable.OrderedSet;
	
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g');
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
	
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	
	var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
	
	var lastBlock = void 0;
	
	var EMPTY_CHUNK = {
	  text: '',
	  inlines: [],
	  entities: [],
	  blocks: []
	};
	
	var EMPTY_BLOCK = {
	  children: List(),
	  depth: 0,
	  key: '',
	  type: ''
	};
	
	var getListBlockType = function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	};
	
	var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  var tags = Set([]);
	
	  blockRenderMap.forEach(function (draftBlock) {
	    if (draftBlock.aliasedElements) {
	      draftBlock.aliasedElements.forEach(function (tag) {
	        tags = tags.add(tag);
	      });
	    }
	
	    tags = tags.add(draftBlock.element);
	  });
	
	  return tags.filter(function (tag) {
	    return tag && tag !== unstyledElement;
	  }).toArray().sort();
	};
	
	// custom element conversions
	var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	};
	
	var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
	    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
	      return alias === tag;
	    });
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	};
	
	var processInlineTag = function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    var htmlElement = node;
	    currentStyle = currentStyle.withMutations(function (style) {
	      var fontWeight = htmlElement.style.fontWeight;
	      var fontStyle = htmlElement.style.fontStyle;
	      var textDecoration = htmlElement.style.textDecoration;
	
	      if (boldValues.indexOf(fontWeight) >= 0) {
	        style.add('BOLD');
	      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	        style.remove('BOLD');
	      }
	
	      if (fontStyle === 'italic') {
	        style.add('ITALIC');
	      } else if (fontStyle === 'normal') {
	        style.remove('ITALIC');
	      }
	
	      if (textDecoration === 'underline') {
	        style.add('UNDERLINE');
	      }
	      if (textDecoration === 'line-through') {
	        style.add('STRIKETHROUGH');
	      }
	      if (textDecoration === 'none') {
	        style.remove('UNDERLINE');
	        style.remove('STRIKETHROUGH');
	      }
	    }).toOrderedSet();
	  }
	  return currentStyle;
	};
	
	var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInA = A.text.slice(-1);
	  var firstInB = B.text.slice(0, 1);
	
	  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (lastInA === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	};
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	};
	
	var hasValidLinkText = function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
	};
	
	var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return _extends({}, EMPTY_CHUNK, {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities
	  });
	};
	
	var getSoftNewlineChunk = function getSoftNewlineChunk() {
	  return _extends({}, EMPTY_CHUNK, {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1)
	  });
	};
	
	var getChunkedBlock = function getChunkedBlock() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _extends({}, EMPTY_BLOCK, props);
	};
	
	var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
	  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [getChunkedBlock({
	      parent: parentKey,
	      key: generateRandomKey(),
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    })]
	  };
	};
	
	/**
	 *  If we're pasting from one DraftEditor to another we can check to see if
	 *  existing list item depth classes are being used and preserve this style
	 */
	var getListItemDepth = function getListItemDepth(node) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
	    if (node.classList.contains(depthClass)) {
	      depth = knownListItemDepthClasses[depthClass];
	    }
	  });
	  return depth;
	};
	
	var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
	  var lastLastBlock = lastBlock;
	  var nodeName = node.nodeName.toLowerCase();
	  var newEntityMap = entityMap;
	  var nextBlockType = 'unstyled';
	  var newBlock = false;
	  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
	  var chunk = _extends({}, EMPTY_CHUNK);
	  var newChunk = null;
	  var blockKey = void 0;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var _text = node.textContent;
	    var nodeTextContent = _text.trim();
	
	    // We should not create blocks for leading spaces that are
	    // existing around ol/ul and their children list items
	    if (lastList && nodeTextContent === '' && node.parentElement) {
	      var parentNodeName = node.parentElement.nodeName.toLowerCase();
	      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
	        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
	      }
	    }
	
	    if (nodeTextContent === '' && inBlock !== 'pre') {
	      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      _text = _text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      chunk: {
	        text: _text,
	        inlines: Array(_text.length).fill(inlineStyle),
	        entities: Array(_text.length).fill(inEntity),
	        blocks: []
	      },
	      entityMap: entityMap
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
	      return {
	        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
	        entityMap: entityMap
	      };
	    }
	    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
	  }
	
	  // IMG tags
	  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
	    var image = node;
	    var entityConfig = {};
	
	    imgAttr.forEach(function (attr) {
	      var imageAttribute = image.getAttribute(attr);
	      if (imageAttribute) {
	        entityConfig[attr] = imageAttribute;
	      }
	    });
	    // Forcing this node to have children because otherwise no entity will be
	    // created for this node.
	    // The child text node cannot just have a space or return as content -
	    // we strip those out.
	    // See https://github.com/facebook/draft-js/issues/231 for some context.
	    node.textContent = '\uD83D\uDCF7';
	
	    // TODO: update this when we remove DraftEntity entirely
	    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
	  }
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
	    depth = getListItemDepth(node, depth);
	  }
	
	  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
	  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
	  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;
	
	  // Block Tags
	  if (inListBlock || inBlockOrHasNestedBlocks) {
	    chunk = getBlockDividerChunk(blockType, depth, parentKey);
	    blockKey = chunk.blocks[0].key;
	    inBlock = nodeName;
	    newBlock = !experimentalTreeDataSupport;
	  }
	
	  // this is required so that we can handle 'ul' and 'ol'
	  if (inListBlock) {
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
	      (function () {
	        var anchor = child;
	        var entityConfig = {};
	
	        anchorAttr.forEach(function (attr) {
	          var anchorAttribute = anchor.getAttribute(attr);
	          if (anchorAttribute) {
	            entityConfig[attr] = anchorAttribute;
	          }
	        });
	
	        entityConfig.url = new URI(anchor.href).toString();
	        // TODO: update this when we remove DraftEntity completely
	        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
	      })();
	    } else {
	      entityId = undefined;
	    }
	
	    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
	        generatedChunk = _genFragment.chunk,
	        maybeUpdatedEntityMap = _genFragment.entityMap;
	
	    newChunk = generatedChunk;
	    newEntityMap = maybeUpdatedEntityMap;
	
	    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  var chunk = fragment.chunk;
	  var newEntityMap = fragment.entityMap;
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
	      type: 'unstyled',
	      depth: 0
	    }));
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
	  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
	    return null;
	  }
	
	  var initialState = {
	    cacheRef: {},
	    contentBlocks: []
	  };
	
	  var start = 0;
	
	  var rawBlocks = chunk.blocks,
	      rawInlines = chunk.inlines,
	      rawEntities = chunk.entities;
	
	
	  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	
	    var block = rawBlocks[index];
	    var end = start + textBlock.length;
	    var inlines = rawInlines.slice(start, end);
	    var entities = rawEntities.slice(start, end);
	    var characterList = List(inlines.map(function (style, index) {
	      var data = { style: style, entity: null };
	      if (entities[index]) {
	        data.entity = entities[index];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    var depth = block.depth,
	        type = block.type,
	        parent = block.parent;
	
	
	    var key = block.key || generateRandomKey();
	    var parentTextNodeKey = null; // will be used to store container text nodes
	
	    // childrens add themselves to their parents since we are iterating in order
	    if (parent) {
	      var parentIndex = acc.cacheRef[parent];
	      var parentRecord = acc.contentBlocks[parentIndex];
	
	      // if parent has text we need to split it into a separate unstyled element
	      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
	        var parentCharacterList = parentRecord.getCharacterList();
	        var parentText = parentRecord.getText();
	        parentTextNodeKey = generateRandomKey();
	
	        var textNode = new ContentBlockNode({
	          key: parentTextNodeKey,
	          text: parentText,
	          characterList: parentCharacterList,
	          parent: parent,
	          nextSibling: key
	        });
	
	        acc.contentBlocks.push(textNode);
	
	        parentRecord = parentRecord.withMutations(function (block) {
	          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
	        });
	      }
	
	      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
	    }
	
	    var blockNode = new BlockNodeRecord({
	      key: key,
	      parent: parent,
	      type: type,
	      depth: depth,
	      text: textBlock,
	      characterList: characterList,
	      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
	      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
	    });
	
	    // insert node
	    acc.contentBlocks.push(blockNode);
	
	    // cache ref for building links
	    acc.cacheRef[blockNode.key] = index;
	
	    return acc;
	  }, initialState).contentBlocks;
	};
	
	var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
	  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
	
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  // TODO: replace DraftEntity with an OrderedMap here
	  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);
	
	  if (chunkData == null) {
	    return null;
	  }
	
	  var chunk = chunkData.chunk,
	      entityMap = chunkData.entityMap;
	
	  var contentBlocks = convertChunkToContentBlocks(chunk);
	
	  return {
	    contentBlocks: contentBlocks,
	    entityMap: entityMap
	  };
	};
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(424);
	var Keys = __webpack_require__(431);
	var UserAgent = __webpack_require__(97);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
	    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @format
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(425);
	var getSelectionOffsetKeyForNode = __webpack_require__(924);
	var getUpdatedSelectionState = __webpack_require__(926);
	var invariant = __webpack_require__(18);
	var nullthrows = __webpack_require__(84);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && (
	  // data-blocks has no offset
	  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && (
	  // data-blocks has no offset
	  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(297);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNextDelimiterBlockKey
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var ContentBlockNode = __webpack_require__(78);
	
	var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
	  var isExperimentalTreeBlock = block instanceof ContentBlockNode;
	
	  if (!isExperimentalTreeBlock) {
	    return null;
	  }
	
	  var nextSiblingKey = block.getNextSiblingKey();
	
	  if (nextSiblingKey) {
	    return nextSiblingKey;
	  }
	
	  var parent = block.getParentKey();
	
	  if (!parent) {
	    return null;
	  }
	
	  var nextNonDescendantBlock = blockMap.get(parent);
	  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
	    var parentKey = nextNonDescendantBlock.getParentKey();
	    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  if (!nextNonDescendantBlock) {
	    return null;
	  }
	
	  return nextNonDescendantBlock.getNextSiblingKey();
	};
	
	module.exports = getNextDelimiterBlockKey;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(97);
	
	var invariant = __webpack_require__(18);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	/* eslint-disable consistent-return */
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(97);
	
	var invariant = __webpack_require__(18);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ },
/* 924 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	function getSelectionOffsetKeyForNode(node) {
	  if (node instanceof Element) {
	    var offsetKey = node.getAttribute('data-offset-key');
	    if (offsetKey) {
	      return offsetKey;
	    }
	    for (var ii = 0; ii < node.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    var result = reader.result;
	    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
	    callback(result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(226);
	
	var nullthrows = __webpack_require__(84);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ },
/* 927 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ },
/* 928 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ },
/* 929 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule randomizeBlockMapKeys
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(78);
	var Immutable = __webpack_require__(26);
	
	var generateRandomKey = __webpack_require__(108);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
	  var newKeysRef = {};
	
	  // we keep track of root blocks in order to update subsequent sibling links
	  var lastRootBlock = void 0;
	
	  return OrderedMap(blockMap.withMutations(function (blockMapState) {
	    blockMapState.forEach(function (block, index) {
	      var oldKey = block.getKey();
	      var nextKey = block.getNextSiblingKey();
	      var prevKey = block.getPrevSiblingKey();
	      var childrenKeys = block.getChildKeys();
	      var parentKey = block.getParentKey();
	
	      // new key that we will use to build linking
	      var key = generateRandomKey();
	
	      // we will add it here to re-use it later
	      newKeysRef[oldKey] = key;
	
	      if (nextKey) {
	        var nextBlock = blockMapState.get(nextKey);
	        if (nextBlock) {
	          blockMapState.setIn([nextKey, 'prevSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'nextSibling'], null);
	        }
	      }
	
	      if (prevKey) {
	        var prevBlock = blockMapState.get(prevKey);
	        if (prevBlock) {
	          blockMapState.setIn([prevKey, 'nextSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'prevSibling'], null);
	        }
	      }
	
	      if (parentKey && blockMapState.get(parentKey)) {
	        var parentBlock = blockMapState.get(parentKey);
	        var parentChildrenList = parentBlock.getChildKeys();
	        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
	      } else {
	        // blocks will then be treated as root block nodes
	        blockMapState.setIn([oldKey, 'parent'], null);
	
	        if (lastRootBlock) {
	          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
	          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
	        }
	
	        lastRootBlock = blockMapState.get(oldKey);
	      }
	
	      childrenKeys.forEach(function (childKey) {
	        var childBlock = blockMapState.get(childKey);
	        if (childBlock) {
	          blockMapState.setIn([childKey, 'parent'], key);
	        } else {
	          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
	            return child !== childKey;
	          }));
	        }
	      });
	    });
	  }).toArray().map(function (block) {
	    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
	  }));
	};
	
	var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
	  return OrderedMap(blockMap.toArray().map(function (block) {
	    var key = generateRandomKey();
	    return [key, block.set('key', key)];
	  }));
	};
	
	var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	
	  if (!isTreeBasedBlockMap) {
	    return randomizeContentBlockKeys(blockMap);
	  }
	
	  return randomizeContentBlockNodeKeys(blockMap);
	};
	
	module.exports = randomizeBlockMapKeys;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	
	var findRangesImmutable = __webpack_require__(227);
	var invariant = __webpack_require__(18);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	  var entityMap = contentState.getEntityMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(entityMap, block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = entityMap.__get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
	          start = _getRemovalRange.start,
	          end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ },
/* 932 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(1979);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 934 */
/***/ function(module, exports) {

	var has = Object.prototype.hasOwnProperty;
	module.exports = function assign(target, source) {
		if (Object.assign) {
			return Object.assign(target, source);
		}
		for (var key in source) {
			if (has.call(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ },
/* 935 */
/***/ function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ },
/* 936 */
/***/ function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ },
/* 937 */
/***/ function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ },
/* 938 */
/***/ function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ },
/* 939 */
/***/ function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ },
/* 940 */
185,
/* 941 */
185,
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(2005);
	
	var createArrayFromMixed = __webpack_require__(2012);
	var emptyFunction = __webpack_require__(67);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ },
/* 943 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(433);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',
	
	  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',
	
	  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ },
/* 945 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 946 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var define = __webpack_require__(224);
	var isSymbol = __webpack_require__(958);
	
	var globalKey = '__ global cache key __';
	/* istanbul ignore else */
	// eslint-disable-next-line no-restricted-properties
	if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
		// eslint-disable-next-line no-restricted-properties
		globalKey = Symbol['for'](globalKey);
	}
	
	var trueThunk = function () {
		return true;
	};
	
	var ensureCache = function ensureCache() {
		if (!global[globalKey]) {
			var properties = {};
			properties[globalKey] = {};
			var predicates = {};
			predicates[globalKey] = trueThunk;
			define(global, properties, predicates);
		}
		return global[globalKey];
	};
	
	var cache = ensureCache();
	
	var isPrimitive = function isPrimitive(val) {
		return val === null || (typeof val !== 'object' && typeof val !== 'function');
	};
	
	var getPrimitiveKey = function getPrimitiveKey(val) {
		if (isSymbol(val)) {
			return Symbol.prototype.valueOf.call(val);
		}
		return typeof val + ' | ' + String(val);
	};
	
	var requirePrimitiveKey = function requirePrimitiveKey(val) {
		if (!isPrimitive(val)) {
			throw new TypeError('key must not be an object');
		}
	};
	
	var globalCache = {
		clear: function clear() {
			delete global[globalKey];
			cache = ensureCache();
		},
	
		'delete': function deleteKey(key) {
			requirePrimitiveKey(key);
			delete cache[getPrimitiveKey(key)];
			return !globalCache.has(key);
		},
	
		get: function get(key) {
			requirePrimitiveKey(key);
			return cache[getPrimitiveKey(key)];
		},
	
		has: function has(key) {
			requirePrimitiveKey(key);
			return getPrimitiveKey(key) in cache;
		},
	
		set: function set(key, value) {
			requirePrimitiveKey(key);
			var primitiveKey = getPrimitiveKey(key);
			var props = {};
			props[primitiveKey] = value;
			var predicates = {};
			predicates[primitiveKey] = trueThunk;
			define(cache, props, predicates);
			return globalCache.has(key);
		},
	
		setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
			if (globalCache.has(key)) {
				return globalCache.get(key);
			}
			var item = valueThunk();
			globalCache.set(key, item);
			return item;
		}
	};
	
	module.exports = globalCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 948 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(304);
	
	var _PathUtils = __webpack_require__(187);
	
	var _createTransitionManager = __webpack_require__(437);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(187);
	
	var _LocationUtils = __webpack_require__(304);
	
	var _createTransitionManager = __webpack_require__(437);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	var base64 = __webpack_require__(414);
	
	function padding(str) {
	  var mod = (str.length % 4);
	  var pad = 4 - mod;
	
	  if (mod === 0) {
	    return str;
	  }
	
	  return str + (new Array(1 + pad)).join('=');
	}
	
	function byteArrayToString(array) {
	  var result = "";
	  for (var i = 0; i < array.length; i++) {
	    result += String.fromCharCode(array[i]);
	  }
	  return result;
	}
	
	function stringToByteArray(str) {
	  var arr = new Array(str.length);
	  for (var a = 0; a < str.length; a++) {
	    arr[a] = str.charCodeAt(a);
	  }
	  return arr;
	}
	
	function byteArrayToHex(raw) {
	  var HEX = '';
	
	  for (var i = 0; i < raw.length; i++) {
	    var _hex = raw[i].toString(16);
	    HEX += (_hex.length === 2 ? _hex : '0' + _hex);
	  }
	
	  return HEX;
	}
	
	function encodeString(str) {
	  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
	    return String.fromCharCode('0x' + p1);
	  }))
	  .replace(/\+/g, '-') // Convert '+' to '-'
	  .replace(/\//g, '_'); // Convert '/' to '_';
	}
	
	function decodeToString(str) {
	  str = padding(str)
	    .replace(/\-/g, '+') // Convert '-' to '+'
	    .replace(/_/g, '/'); // Convert '_' to '/'
	
	  return decodeURIComponent(atob(str).split('').map(function (c) {
	    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	  }).join(''));
	}
	
	function decodeToHEX(str) {
	  return byteArrayToHex(base64.toByteArray(padding(str)));
	}
	
	module.exports = {
	  encodeString: encodeString,
	  decodeToString: decodeToString,
	  byteArrayToString: byteArrayToString,
	  stringToByteArray: stringToByteArray,
	  padding: padding,
	  byteArrayToHex: byteArrayToHex,
	  decodeToHEX: decodeToHEX
	};


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = format;
	
	var _templateFormatter = __webpack_require__(953);
	
	var _templateFormatter2 = _interopRequireDefault(_templateFormatter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Formats `value` value preserving `caret` at the same character.
	//
	// `{ value, caret }` attribute is the result of `parse()` function call.
	//
	// Returns `{ text, caret }` where the new `caret` is the caret position
	// inside `text` text corresponding to the original `caret` position inside `value`.
	//
	// `formatter(value)` is a function returning `{ text, template }`.
	//
	// `text` is the `value` value formatted using `template`.
	// It may either cut off the non-filled right part of the `template`
	// or it may fill the non-filled character placeholders
	// in the right part of the `template` with `spacer`
	// which is a space (' ') character by default.
	//
	// `template` is the template used to format the `value`.
	// It can be either a full-length template or a partial template.
	//
	// `formatter` can also be a string — a `template`
	// where character placeholders are denoted by 'x'es.
	// In this case `formatter` function is automatically created.
	//
	// Example:
	//
	// `value` is '880',
	// `caret` is `2` (before the first `0`)
	//
	// `formatter` is `'880' =>
	//   { text: '8 (80 )', template: 'x (xxx) xxx-xx-xx' }`
	//
	// The result is `{ text: '8 (80 )', caret: 4 }`.
	//
	function format(value, caret, formatter) {
		if (typeof formatter === 'string') {
			formatter = (0, _templateFormatter2.default)(formatter);
		}
	
		var _ref = formatter(value) || {},
		    text = _ref.text,
		    template = _ref.template;
	
		if (text === undefined) {
			text = value;
		}
	
		if (template) {
			if (caret === undefined) {
				caret = text.length;
			} else {
				var index = 0;
				var found = false;
	
				var possibly_last_input_character_index = -1;
	
				while (index < text.length && index < template.length) {
					// Character placeholder found
					if (text[index] !== template[index]) {
						if (caret === 0) {
							found = true;
							caret = index;
							break;
						}
	
						possibly_last_input_character_index = index;
	
						caret--;
					}
	
					index++;
				}
	
				// If the caret was positioned after last input character,
				// then the text caret index is just after the last input character.
				if (!found) {
					caret = possibly_last_input_character_index + 1;
				}
			}
		}
	
		return { text: text, caret: caret };
	}
	//# sourceMappingURL=format.js.map

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(398);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	exports.default = function (template) {
		var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
		var should_close_braces = arguments[2];
	
		if (!template) {
			return function (value) {
				return { text: value };
			};
		}
	
		var characters_in_template = (0, _helpers.count_occurences)(placeholder, template);
	
		return function (value) {
			if (!value) {
				return { text: '', template: template };
			}
	
			var value_character_index = 0;
			var filled_in_template = '';
	
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;
	
			try {
				for (var _iterator = (0, _getIterator3.default)(template), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var character = _step.value;
	
					if (character !== placeholder) {
						filled_in_template += character;
						continue;
					}
	
					filled_in_template += value[value_character_index];
					value_character_index++;
	
					// If the last available value character has been filled in,
					// then return the filled in template
					// (either trim the right part or retain it,
					//  if no more character placeholders in there)
					if (value_character_index === value.length) {
						// If there are more character placeholders
						// in the right part of the template
						// then simply trim it.
						if (value.length < characters_in_template) {
							break;
						}
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
	
			if (should_close_braces) {
				filled_in_template = (0, _closeBraces2.default)(filled_in_template, template);
			}
	
			return { text: filled_in_template, template: template };
		};
	};
	
	var _helpers = __webpack_require__(438);
	
	var _closeBraces = __webpack_require__(2268);
	
	var _closeBraces2 = _interopRequireDefault(_closeBraces);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=template formatter.js.map

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = {}
	
	exports.ReactInput        = __webpack_require__(2267).default
	exports.templateParser    = __webpack_require__(2272).default
	exports.templateFormatter = __webpack_require__(953).default
	exports.parseDigit        = __webpack_require__(2271).default
	exports.parse             = __webpack_require__(439).default
	exports.format            = __webpack_require__(952).default
	
	exports.onChange       = __webpack_require__(232).onChange
	exports.onPaste        = __webpack_require__(232).onPaste
	exports.onCut          = __webpack_require__(232).onCut
	exports.onKeyDown      = __webpack_require__(232).onKeyDown
	
	// exports['default'] = ...

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(2282)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(3330);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ },
/* 956 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(2291);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	
	  if (isObjectObject(o) === false) return false;
	
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 958 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') { return false; }
			return symStringRegex.test(symToStr.call(value));
		};
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') { return true; }
			if (toStr.call(value) !== '[object Symbol]') { return false; }
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false;
		};
	}


/***/ },
/* 959 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 960 */
/***/ function(module, exports) {

	module.exports = {
		"version": "1.2.15",
		"country_calling_codes": {
			"1": [
				"US",
				"AG",
				"AI",
				"AS",
				"BB",
				"BM",
				"BS",
				"CA",
				"DM",
				"DO",
				"GD",
				"GU",
				"JM",
				"KN",
				"KY",
				"LC",
				"MP",
				"MS",
				"PR",
				"SX",
				"TC",
				"TT",
				"VC",
				"VG",
				"VI"
			],
			"7": [
				"RU",
				"KZ"
			],
			"20": [
				"EG"
			],
			"27": [
				"ZA"
			],
			"30": [
				"GR"
			],
			"31": [
				"NL"
			],
			"32": [
				"BE"
			],
			"33": [
				"FR"
			],
			"34": [
				"ES"
			],
			"36": [
				"HU"
			],
			"39": [
				"IT",
				"VA"
			],
			"40": [
				"RO"
			],
			"41": [
				"CH"
			],
			"43": [
				"AT"
			],
			"44": [
				"GB",
				"GG",
				"IM",
				"JE"
			],
			"45": [
				"DK"
			],
			"46": [
				"SE"
			],
			"47": [
				"NO",
				"SJ"
			],
			"48": [
				"PL"
			],
			"49": [
				"DE"
			],
			"51": [
				"PE"
			],
			"52": [
				"MX"
			],
			"53": [
				"CU"
			],
			"54": [
				"AR"
			],
			"55": [
				"BR"
			],
			"56": [
				"CL"
			],
			"57": [
				"CO"
			],
			"58": [
				"VE"
			],
			"60": [
				"MY"
			],
			"61": [
				"AU",
				"CC",
				"CX"
			],
			"62": [
				"ID"
			],
			"63": [
				"PH"
			],
			"64": [
				"NZ"
			],
			"65": [
				"SG"
			],
			"66": [
				"TH"
			],
			"81": [
				"JP"
			],
			"82": [
				"KR"
			],
			"84": [
				"VN"
			],
			"86": [
				"CN"
			],
			"90": [
				"TR"
			],
			"91": [
				"IN"
			],
			"92": [
				"PK"
			],
			"93": [
				"AF"
			],
			"94": [
				"LK"
			],
			"95": [
				"MM"
			],
			"98": [
				"IR"
			],
			"211": [
				"SS"
			],
			"212": [
				"MA",
				"EH"
			],
			"213": [
				"DZ"
			],
			"216": [
				"TN"
			],
			"218": [
				"LY"
			],
			"220": [
				"GM"
			],
			"221": [
				"SN"
			],
			"222": [
				"MR"
			],
			"223": [
				"ML"
			],
			"224": [
				"GN"
			],
			"225": [
				"CI"
			],
			"226": [
				"BF"
			],
			"227": [
				"NE"
			],
			"228": [
				"TG"
			],
			"229": [
				"BJ"
			],
			"230": [
				"MU"
			],
			"231": [
				"LR"
			],
			"232": [
				"SL"
			],
			"233": [
				"GH"
			],
			"234": [
				"NG"
			],
			"235": [
				"TD"
			],
			"236": [
				"CF"
			],
			"237": [
				"CM"
			],
			"238": [
				"CV"
			],
			"239": [
				"ST"
			],
			"240": [
				"GQ"
			],
			"241": [
				"GA"
			],
			"242": [
				"CG"
			],
			"243": [
				"CD"
			],
			"244": [
				"AO"
			],
			"245": [
				"GW"
			],
			"246": [
				"IO"
			],
			"247": [
				"AC"
			],
			"248": [
				"SC"
			],
			"249": [
				"SD"
			],
			"250": [
				"RW"
			],
			"251": [
				"ET"
			],
			"252": [
				"SO"
			],
			"253": [
				"DJ"
			],
			"254": [
				"KE"
			],
			"255": [
				"TZ"
			],
			"256": [
				"UG"
			],
			"257": [
				"BI"
			],
			"258": [
				"MZ"
			],
			"260": [
				"ZM"
			],
			"261": [
				"MG"
			],
			"262": [
				"RE",
				"YT"
			],
			"263": [
				"ZW"
			],
			"264": [
				"NA"
			],
			"265": [
				"MW"
			],
			"266": [
				"LS"
			],
			"267": [
				"BW"
			],
			"268": [
				"SZ"
			],
			"269": [
				"KM"
			],
			"290": [
				"SH",
				"TA"
			],
			"291": [
				"ER"
			],
			"297": [
				"AW"
			],
			"298": [
				"FO"
			],
			"299": [
				"GL"
			],
			"350": [
				"GI"
			],
			"351": [
				"PT"
			],
			"352": [
				"LU"
			],
			"353": [
				"IE"
			],
			"354": [
				"IS"
			],
			"355": [
				"AL"
			],
			"356": [
				"MT"
			],
			"357": [
				"CY"
			],
			"358": [
				"FI",
				"AX"
			],
			"359": [
				"BG"
			],
			"370": [
				"LT"
			],
			"371": [
				"LV"
			],
			"372": [
				"EE"
			],
			"373": [
				"MD"
			],
			"374": [
				"AM"
			],
			"375": [
				"BY"
			],
			"376": [
				"AD"
			],
			"377": [
				"MC"
			],
			"378": [
				"SM"
			],
			"380": [
				"UA"
			],
			"381": [
				"RS"
			],
			"382": [
				"ME"
			],
			"383": [
				"XK"
			],
			"385": [
				"HR"
			],
			"386": [
				"SI"
			],
			"387": [
				"BA"
			],
			"389": [
				"MK"
			],
			"420": [
				"CZ"
			],
			"421": [
				"SK"
			],
			"423": [
				"LI"
			],
			"500": [
				"FK"
			],
			"501": [
				"BZ"
			],
			"502": [
				"GT"
			],
			"503": [
				"SV"
			],
			"504": [
				"HN"
			],
			"505": [
				"NI"
			],
			"506": [
				"CR"
			],
			"507": [
				"PA"
			],
			"508": [
				"PM"
			],
			"509": [
				"HT"
			],
			"590": [
				"GP",
				"BL",
				"MF"
			],
			"591": [
				"BO"
			],
			"592": [
				"GY"
			],
			"593": [
				"EC"
			],
			"594": [
				"GF"
			],
			"595": [
				"PY"
			],
			"596": [
				"MQ"
			],
			"597": [
				"SR"
			],
			"598": [
				"UY"
			],
			"599": [
				"CW",
				"BQ"
			],
			"670": [
				"TL"
			],
			"672": [
				"NF"
			],
			"673": [
				"BN"
			],
			"674": [
				"NR"
			],
			"675": [
				"PG"
			],
			"676": [
				"TO"
			],
			"677": [
				"SB"
			],
			"678": [
				"VU"
			],
			"679": [
				"FJ"
			],
			"680": [
				"PW"
			],
			"681": [
				"WF"
			],
			"682": [
				"CK"
			],
			"683": [
				"NU"
			],
			"685": [
				"WS"
			],
			"686": [
				"KI"
			],
			"687": [
				"NC"
			],
			"688": [
				"TV"
			],
			"689": [
				"PF"
			],
			"690": [
				"TK"
			],
			"691": [
				"FM"
			],
			"692": [
				"MH"
			],
			"800": [
				"001"
			],
			"808": [
				"001"
			],
			"850": [
				"KP"
			],
			"852": [
				"HK"
			],
			"853": [
				"MO"
			],
			"855": [
				"KH"
			],
			"856": [
				"LA"
			],
			"870": [
				"001"
			],
			"878": [
				"001"
			],
			"880": [
				"BD"
			],
			"881": [
				"001"
			],
			"882": [
				"001"
			],
			"883": [
				"001"
			],
			"886": [
				"TW"
			],
			"888": [
				"001"
			],
			"960": [
				"MV"
			],
			"961": [
				"LB"
			],
			"962": [
				"JO"
			],
			"963": [
				"SY"
			],
			"964": [
				"IQ"
			],
			"965": [
				"KW"
			],
			"966": [
				"SA"
			],
			"967": [
				"YE"
			],
			"968": [
				"OM"
			],
			"970": [
				"PS"
			],
			"971": [
				"AE"
			],
			"972": [
				"IL"
			],
			"973": [
				"BH"
			],
			"974": [
				"QA"
			],
			"975": [
				"BT"
			],
			"976": [
				"MN"
			],
			"977": [
				"NP"
			],
			"979": [
				"001"
			],
			"992": [
				"TJ"
			],
			"993": [
				"TM"
			],
			"994": [
				"AZ"
			],
			"995": [
				"GE"
			],
			"996": [
				"KG"
			],
			"998": [
				"UZ"
			]
		},
		"countries": {
			"AC": [
				"247",
				"00",
				"[46]\\d{4}|[01589]\\d{5}",
				[
					5,
					6
				]
			],
			"AD": [
				"376",
				"00",
				"[16]\\d{5,8}|[37-9]\\d{5}",
				[
					6,
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"[136-9]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"180",
							"180[02]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"690"
						]
					]
				]
			],
			"AE": [
				"971",
				"00",
				"[2-79]\\d{7,8}|800\\d{2,9}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"([2-4679])(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-4679][2-8]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"([479]00)(\\d)(\\d{5})",
						"$1 $2 $3",
						[
							"[479]00"
						],
						"$1"
					],
					[
						"([68]00)(\\d{2,9})",
						"$1 $2",
						[
							"[68]00"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"AF": [
				"93",
				"00",
				"[2-7]\\d{8}",
				[
					9
				],
				[
					[
						"([2-7]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2-7]"
						]
					]
				],
				"0",
				"0$1"
			],
			"AG": [
				"1",
				"011",
				"[2589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"268"
			],
			"AI": [
				"1",
				"011",
				"[2589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"264"
			],
			"AL": [
				"355",
				"00",
				"[2-57]\\d{7}|6\\d{8}|8\\d{5,7}|9\\d{5}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(4)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[0-6]"
						]
					],
					[
						"(6\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2358][2-5]|4[7-9]"
						]
					],
					[
						"(\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"[235][16-9]|[79]|8[016-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"AM": [
				"374",
				"00",
				"[1-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"1|47"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"4[1349]|[5-7]|88|9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[23]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"8|90"
						],
						"0 $1"
					]
				],
				"0",
				"(0$1)"
			],
			"AO": [
				"244",
				"00",
				"[29]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"AR": [
				"54",
				"00",
				"11\\d{8}|[2368]\\d{9}|9\\d{10}",
				[
					10,
					11
				],
				[
					[
						"([68]\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[68]"
						]
					],
					[
						"(9)(11)(\\d{4})(\\d{4})",
						"$2 15-$3-$4",
						[
							"911"
						],
						0,
						0,
						"$1 $2 $3-$4"
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9(?:2[2-4689]|3[3-8])",
							"9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))",
							"9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"
						],
						0,
						0,
						"$1 $2 $3-$4"
					],
					[
						"(9)(\\d{4})(\\d{2})(\\d{4})",
						"$2 15-$3-$4",
						[
							"9[23]"
						],
						0,
						0,
						"$1 $2 $3-$4"
					],
					[
						"(11)(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"11"
						],
						0,
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))",
							"2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"
						],
						0,
						1
					],
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2-$3",
						[
							"[23]"
						],
						0,
						1
					]
				],
				"0",
				"0$1",
				"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?",
				"9$1"
			],
			"AS": [
				"1",
				"011",
				"[5689]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"684"
			],
			"AT": [
				"43",
				"00",
				"[1-9]\\d{3,12}",
				[
					4,
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(1)(\\d{3,12})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(5\\d)(\\d{3,5})",
						"$1 $2",
						[
							"5[079]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"5[079]"
						]
					],
					[
						"(5\\d)(\\d{4})(\\d{4,7})",
						"$1 $2 $3",
						[
							"5[079]"
						]
					],
					[
						"(\\d{3})(\\d{3,10})",
						"$1 $2",
						[
							"(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"
						]
					],
					[
						"(\\d{4})(\\d{3,9})",
						"$1 $2",
						[
							"2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"
						]
					]
				],
				"0",
				"0$1"
			],
			"AU": [
				"61",
				"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011)|001[14-689]",
				"1\\d{4,9}|[2-578]\\d{8}",
				[
					5,
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|[45]"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[389]0",
							"1(?:[38]0|9)0"
						]
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						]
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						]
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						]
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}",
						[
							9
						]
					],
					[
						"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12457-9]|9[017-9])\\d{6}",
						[
							9
						]
					],
					[
						"180(?:0\\d{3}|2)\\d{3}",
						[
							7,
							10
						]
					],
					[
						"19(?:0[0126]\\d|[679])\\d{5}",
						[
							8,
							10
						]
					],
					[
						"500\\d{6}",
						[
							9
						]
					],
					0,
					0,
					[
						"16\\d{3,7}",
						[
							5,
							6,
							7,
							8,
							9
						]
					],
					[
						"550\\d{6}",
						[
							9
						]
					],
					[
						"13(?:00\\d{3}|45[0-4]|\\d)\\d{3}",
						[
							6,
							8,
							10
						]
					]
				],
				"0011"
			],
			"AW": [
				"297",
				"00",
				"[25-9]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"AX": [
				"358",
				"00|99(?:[01469]|5(?:11|3[23]|41|5[59]|77|88|9[09]))",
				"1\\d{5,11}|[35]\\d{5,9}|2\\d{4,9}|4\\d{5,10}|6\\d{7,9}|7\\d{4,9}|8\\d{6,9}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"(?:[1-3]0|[6-8])0"
						]
					],
					[
						"(75\\d{3})",
						"$1",
						[
							"75[12]"
						]
					],
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{4,10})",
						"$1 $2",
						[
							"[14]|2[09]|50|7[135]"
						]
					],
					[
						"(\\d)(\\d{4,11})",
						"$1 $2",
						[
							"[25689][1-8]|3"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"18[1-8]\\d{3,9}",
						[
							6,
							7,
							8,
							9,
							10,
							11,
							12
						]
					],
					[
						"4\\d{5,10}|50\\d{4,8}",
						[
							6,
							7,
							8,
							9,
							10,
							11
						]
					],
					[
						"800\\d{4,7}",
						[
							7,
							8,
							9,
							10
						]
					],
					[
						"[67]00\\d{5,6}",
						[
							8,
							9
						]
					],
					0,
					0,
					[
						"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{2,7})",
						[
							5,
							6,
							7,
							8,
							9,
							10
						]
					]
				],
				"00"
			],
			"AZ": [
				"994",
				"00",
				"[1-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1[28]|2(?:[0-36]|[45]2)|365"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[4-8]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"BA": [
				"387",
				"00",
				"[3-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2-$3",
						[
							"[3-5]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[1-356]|[7-9]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"6[047]"
						]
					]
				],
				"0",
				"0$1"
			],
			"BB": [
				"1",
				"011",
				"[2589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"246"
			],
			"BD": [
				"880",
				"00",
				"[2-79]\\d{5,9}|1\\d{9}|8[0-7]\\d{4,8}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(2)(\\d{7,8})",
						"$1-$2",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{4,6})",
						"$1-$2",
						[
							"[3-79]1"
						]
					],
					[
						"(\\d{4})(\\d{3,6})",
						"$1-$2",
						[
							"1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[01367])"
						]
					],
					[
						"(\\d{3})(\\d{3,7})",
						"$1-$2",
						[
							"[3-79][2-9]|8"
						]
					]
				],
				"0",
				"0$1"
			],
			"BE": [
				"32",
				"00",
				"[1-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4[5-9]"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|4[23]|9[2-4]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[156]|7[018]|8(?:0[1-9]|[1-79])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:80|9)0"
						]
					]
				],
				"0",
				"0$1"
			],
			"BF": [
				"226",
				"00",
				"[25-7]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BG": [
				"359",
				"00",
				"[23567]\\d{5,7}|[489]\\d{6,8}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(2)(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"2"
						]
					],
					[
						"(2)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"43[124-7]|70[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"43[124-7]|70[1-9]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"99[69]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"48|8[7-9]|9[08]"
						]
					]
				],
				"0",
				"0$1"
			],
			"BH": [
				"973",
				"00",
				"[136-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"BI": [
				"257",
				"00",
				"[2367]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"BJ": [
				"229",
				"00",
				"[2689]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2689]"
						]
					]
				]
			],
			"BL": [
				"590",
				"00",
				"[56]\\d{8}",
				[
					9
				],
				[
					[
						"([56]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"590|69[01]"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"590(?:2[7-9]|5[12]|87)\\d{4}"
					],
					[
						"69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"
					]
				]
			],
			"BM": [
				"1",
				"011",
				"[4589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"441"
			],
			"BN": [
				"673",
				"00",
				"[2-578]\\d{6}",
				[
					7
				],
				[
					[
						"([2-578]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[2-578]"
						]
					]
				]
			],
			"BO": [
				"591",
				"00(1\\d)?",
				"[23467]\\d{7}|8\\d{8}",
				[
					8,
					9
				],
				[
					[
						"([234])(\\d{7})",
						"$1 $2",
						[
							"[2-4]"
						]
					],
					[
						"([67]\\d{7})",
						"$1",
						[
							"[67]"
						]
					],
					[
						"(800)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				],
				"0",
				0,
				"0(1\\d)?"
			],
			"BQ": [
				"599",
				"00",
				"[347]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-7]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"(?:318[023]|41(?:6[023]|70)|7(?:1[578]|50)\\d)\\d{3}"
					],
					[
						"(?:31(?:8[14-8]|9[14578])|416[145-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"
					]
				]
			],
			"BR": [
				"55",
				"00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
				"[1-46-9]\\d{7,10}|5(?:[0-4]\\d{7,9}|5(?:[2-8]\\d{7}|9\\d{7,8}))",
				[
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"300|4(?:0[02]|37)",
							"300|4(?:0(?:0|20)|370)"
						]
					],
					[
						"([3589]00)(\\d{2,3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3589]00"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2-$3",
						[
							"[1-9][1-9]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{5})(\\d{4})",
						"$1 $2-$3",
						[
							"[1-9][1-9]9"
						],
						"($1)"
					]
				],
				"0",
				0,
				"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
				"$2"
			],
			"BS": [
				"1",
				"011?",
				"[2589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"242",
				0,
				"011"
			],
			"BT": [
				"975",
				"00",
				"[1-8]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"1|77"
						]
					],
					[
						"([2-8])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-68]|7[246]"
						]
					]
				]
			],
			"BW": [
				"267",
				"00",
				"[2-79]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-6]"
						]
					],
					[
						"(7\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(90)(\\d{5})",
						"$1 $2",
						[
							"90"
						]
					]
				]
			],
			"BY": [
				"375",
				"810",
				"[1-4]\\d{8}|8(?:0(?:0\\d{3,7}|[13]\\d{7})|(?:10|20\\d)\\d{7})|9\\d{9,10}",
				[
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"17[0-3589]|2[4-9]|[34]",
							"17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"
						],
						"8 0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])",
							"1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"
						],
						"8 0$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{3})",
						"$1 $2-$3",
						[
							"1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
							"1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
						],
						"8 0$1"
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8[01]|9"
						],
						"8 $1"
					],
					[
						"(82\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"82"
						],
						"8 $1"
					],
					[
						"(800)(\\d{3})",
						"$1 $2",
						[
							"800"
						],
						"8 $1"
					],
					[
						"(800)(\\d{2})(\\d{2,4})",
						"$1 $2 $3",
						[
							"800"
						],
						"8 $1"
					]
				],
				"8",
				0,
				"8?0?",
				0,
				0,
				0,
				0,
				"8~10"
			],
			"BZ": [
				"501",
				"00",
				"[2-8]\\d{6}|0\\d{10}",
				[
					7,
					11
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[2-8]"
						]
					],
					[
						"(0)(800)(\\d{4})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"080",
							"0800"
						]
					]
				]
			],
			"CA": [
				"1",
				"011",
				"[2-9]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:0[04]|13|22|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"
					],
					[
						""
					],
					[
						"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
					],
					[
						"900[2-9]\\d{6}"
					],
					[
						"5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}"
					]
				]
			],
			"CC": [
				"61",
				"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]",
				"[1458]\\d{5,9}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|[45]"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[389]0",
							"1(?:[38]0|9)0"
						]
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						]
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						]
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						]
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:08|22|68)|4[29]8|62\\d|70[23]|959))\\d{3}",
						[
							9
						]
					],
					[
						"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}",
						[
							9
						]
					],
					[
						"180(?:0\\d{3}|2)\\d{3}",
						[
							7,
							10
						]
					],
					[
						"19(?:0[0126]\\d|[679])\\d{5}",
						[
							8,
							10
						]
					],
					[
						"500\\d{6}",
						[
							9
						]
					],
					0,
					0,
					0,
					[
						"550\\d{6}",
						[
							9
						]
					],
					[
						"13(?:00\\d{2})?\\d{4}",
						[
							6,
							10
						]
					]
				],
				"0011"
			],
			"CD": [
				"243",
				"00",
				"[2-6]\\d{6}|[18]\\d{6,8}|9\\d{8}",
				[
					7,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"12"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[0-2459]|9"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[1-6]"
						]
					]
				],
				"0",
				"0$1"
			],
			"CF": [
				"236",
				"00",
				"[278]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"CG": [
				"242",
				"00",
				"[028]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"801"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[02]"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				]
			],
			"CH": [
				"41",
				"00",
				"[2-9]\\d{8}|860\\d{9}",
				[
					9
				],
				[
					[
						"([2-9]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]|[89]1"
						]
					],
					[
						"([89]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8[047]|90"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"860"
						]
					]
				],
				"0",
				"0$1"
			],
			"CI": [
				"225",
				"00",
				"[02-8]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"CK": [
				"682",
				"00",
				"[2-8]\\d{4}",
				[
					5
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2"
					]
				]
			],
			"CL": [
				"56",
				"(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0",
				"1230\\d{7}|[2-46-9]\\d{8,10}|5[1-3578]\\d{7}",
				[
					9,
					10,
					11
				],
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[23]"
						],
						"($1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[357]|4[1-35]|6[13-57]|8(?:0[1-9]|[1-9])"
						],
						"($1)"
					],
					[
						"(9)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(44)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"44"
						]
					],
					[
						"([68]00)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[68]00"
						]
					],
					[
						"(600)(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"600"
						]
					],
					[
						"(1230)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"123",
							"1230"
						]
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"219"
						],
						"($1)"
					]
				]
			],
			"CM": [
				"237",
				"00",
				"[2368]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"([26])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[26]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|88"
						]
					]
				]
			],
			"CN": [
				"86",
				"(?:1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))?00",
				"[1-7]\\d{6,11}|8[0-357-9]\\d{6,9}|9\\d{7,10}",
				[
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"([48]00)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[48]00"
						]
					],
					[
						"(\\d{2})(\\d{5,6})",
						"$1 $2",
						[
							"(?:10|2\\d)[19]",
							"(?:10|2\\d)(?:10|9[56])",
							"(?:10|2\\d)(?:100|9[56])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"[3-9]",
							"[3-9]\\d\\d[19]",
							"[3-9]\\d\\d(?:10|9[56])"
						],
						"0$1"
					],
					[
						"(21)(\\d{4})(\\d{4,6})",
						"$1 $2 $3",
						[
							"21"
						],
						"0$1",
						1
					],
					[
						"([12]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"10[1-9]|2[02-9]",
							"10[1-9]|2[02-9]",
							"10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"
						],
						"0$1",
						1
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"807",
							"8078"
						],
						"0$1",
						1
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[3-57-9]|66)"
						]
					],
					[
						"(10800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"108",
							"1080",
							"10800"
						]
					],
					[
						"(\\d{3})(\\d{7,8})",
						"$1 $2",
						[
							"950"
						]
					]
				],
				"0",
				0,
				"(1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))|0",
				0,
				0,
				0,
				0,
				"00"
			],
			"CO": [
				"57",
				"00(?:4(?:[14]4|56)|[579])",
				"(?:[13]\\d{0,3}|[24-8])\\d{7}",
				[
					8,
					10,
					11
				],
				[
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"1(?:[2-7]|8[2-9]|9[0-3])|[24-8]",
							"1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"
						],
						"($1)"
					],
					[
						"(\\d{3})(\\d{7})",
						"$1 $2",
						[
							"3"
						]
					],
					[
						"(1)(\\d{3})(\\d{7})",
						"$1-$2-$3",
						[
							"1(?:80|9[04])",
							"1(?:800|9(?:0[01]|4[78]))"
						],
						"0$1",
						0,
						"$1 $2 $3"
					]
				],
				"0",
				0,
				"0([3579]|4(?:44|56))?"
			],
			"CR": [
				"506",
				"00",
				"[24-9]\\d{7,9}",
				[
					8,
					10
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[24-7]|8[3-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[89]0"
						]
					]
				],
				0,
				0,
				"(19(?:0[012468]|1[09]|20|66|77|99))"
			],
			"CU": [
				"53",
				"119",
				"[2-57]\\d{5,7}",
				[
					6,
					7,
					8
				],
				[
					[
						"(\\d)(\\d{6,7})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{2})(\\d{4,6})",
						"$1 $2",
						[
							"[2-4]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"5"
						],
						"0$1"
					]
				],
				"0",
				"(0$1)"
			],
			"CV": [
				"238",
				"0",
				"[2-59]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"CW": [
				"599",
				"00",
				"[134679]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-7]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"9(?:[48]\\d{2}|50\\d|7(?:2[0-24]|[34]\\d|6[35-7]|77|8[7-9]))\\d{4}",
						[
							8
						]
					],
					[
						"9(?:5(?:[12467]\\d|3[01])|6(?:[15-9]\\d|3[01]))\\d{4}",
						[
							8
						]
					],
					0,
					0,
					0,
					0,
					0,
					[
						"955\\d{5}",
						[
							8
						]
					],
					0,
					[
						"60[0-2]\\d{4}",
						[
							7
						]
					]
				]
			],
			"CX": [
				"61",
				"(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]",
				"[1458]\\d{5,9}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"([2378])(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[2378]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"14|[45]"
						],
						"0$1"
					],
					[
						"(16)(\\d{3,4})",
						"$1 $2",
						[
							"16"
						],
						"0$1"
					],
					[
						"(16)(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"16"
						],
						"0$1"
					],
					[
						"(1[389]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[389]0",
							"1(?:[38]0|9)0"
						]
					],
					[
						"(180)(2\\d{3})",
						"$1 $2",
						[
							"180",
							"1802"
						]
					],
					[
						"(19\\d)(\\d{3})",
						"$1 $2",
						[
							"19[13]"
						]
					],
					[
						"(19\\d{2})(\\d{4})",
						"$1 $2",
						[
							"19[679]"
						]
					],
					[
						"(13)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"13[1-9]"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:21|49|78|81)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
						[
							9
						]
					],
					[
						"14(?:5\\d|71)\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[12547-9]|9[017-9])\\d{6}",
						[
							9
						]
					],
					[
						"180(?:0\\d{3}|2)\\d{3}",
						[
							7,
							10
						]
					],
					[
						"19(?:0[0126]\\d|[679])\\d{5}",
						[
							8,
							10
						]
					],
					[
						"500\\d{6}",
						[
							9
						]
					],
					0,
					0,
					0,
					[
						"550\\d{6}",
						[
							9
						]
					],
					[
						"13(?:00\\d{2})?\\d{4}",
						[
							6,
							8,
							10
						]
					]
				],
				"0011"
			],
			"CY": [
				"357",
				"00",
				"[257-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2"
					]
				]
			],
			"CZ": [
				"420",
				"00",
				"[2-8]\\d{8}|9\\d{8,11}",
				[
					9
				],
				[
					[
						"([2-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8]|9[015-7]"
						]
					],
					[
						"(96\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"96"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"9[36]"
						]
					]
				]
			],
			"DE": [
				"49",
				"00",
				"[1-35-9]\\d{3,14}|4(?:[0-8]\\d{3,12}|9(?:[0-37]\\d|4(?:[1-35-8]|4\\d?)|5\\d{1,2}|6[1-8]\\d?)\\d{2,8})",
				[
					4,
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12,
					13,
					14,
					15
				],
				[
					[
						"(1\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"1[67]"
						]
					],
					[
						"(15\\d{3})(\\d{6})",
						"$1 $2",
						[
							"15[0568]"
						]
					],
					[
						"(1\\d{3})(\\d{7})",
						"$1 $2",
						[
							"15"
						]
					],
					[
						"(\\d{2})(\\d{3,11})",
						"$1 $2",
						[
							"3[02]|40|[68]9"
						]
					],
					[
						"(\\d{3})(\\d{3,11})",
						"$1 $2",
						[
							"2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)",
							"2(?:0[1-389]|1(?:[14]|2[0-8])|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"
						]
					],
					[
						"(\\d{4})(\\d{2,11})",
						"$1 $2",
						[
							"[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])",
							"[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[13468]|8[13568])|6(?:0[1356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"
						]
					],
					[
						"(3\\d{4})(\\d{1,10})",
						"$1 $2",
						[
							"3"
						]
					],
					[
						"(800)(\\d{7,12})",
						"$1 $2",
						[
							"800"
						]
					],
					[
						"(\\d{3})(\\d)(\\d{4,10})",
						"$1 $2 $3",
						[
							"1(?:37|80)|900",
							"1(?:37|80)|900[1359]"
						]
					],
					[
						"(1\\d{2})(\\d{5,11})",
						"$1 $2",
						[
							"181"
						]
					],
					[
						"(18\\d{3})(\\d{6})",
						"$1 $2",
						[
							"185",
							"1850",
							"18500"
						]
					],
					[
						"(18\\d{2})(\\d{7})",
						"$1 $2",
						[
							"18[68]"
						]
					],
					[
						"(18\\d)(\\d{8})",
						"$1 $2",
						[
							"18[2-579]"
						]
					],
					[
						"(700)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"700"
						]
					],
					[
						"(138)(\\d{4})",
						"$1 $2",
						[
							"138"
						]
					],
					[
						"(15[013-68])(\\d{2})(\\d{8})",
						"$1 $2 $3",
						[
							"15[013-68]"
						]
					],
					[
						"(15[279]\\d)(\\d{2})(\\d{7})",
						"$1 $2 $3",
						[
							"15[279]"
						]
					],
					[
						"(1[67]\\d)(\\d{2})(\\d{7,8})",
						"$1 $2 $3",
						[
							"1(?:6[023]|7)"
						]
					]
				],
				"0",
				"0$1"
			],
			"DJ": [
				"253",
				"00",
				"[27]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"DK": [
				"45",
				"00",
				"[2-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				]
			],
			"DM": [
				"1",
				"011",
				"[57-9]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"767"
			],
			"DO": [
				"1",
				"011",
				"[589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"8[024]9"
			],
			"DZ": [
				"213",
				"00",
				"(?:[1-4]|[5-9]\\d)\\d{7}",
				[
					8,
					9
				],
				[
					[
						"([1-4]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[1-4]"
						]
					],
					[
						"([5-8]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-8]"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"9"
						]
					]
				],
				"0",
				"0$1"
			],
			"EC": [
				"593",
				"00",
				"1\\d{9,10}|[2-8]\\d{7}|9\\d{8}",
				[
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2-$3",
						[
							"[247]|[356][2-8]"
						],
						0,
						0,
						"$1-$2-$3"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"9"
						],
						"0$1"
					],
					[
						"(1800)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"EE": [
				"372",
				"00",
				"[3-9]\\d{6,7}|800\\d{6,7}",
				[
					7,
					8,
					10
				],
				[
					[
						"([3-79]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]",
							"[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"
						]
					],
					[
						"(70)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"70"
						]
					],
					[
						"(8000)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800",
							"8000"
						]
					],
					[
						"([458]\\d{3})(\\d{3,4})",
						"$1 $2",
						[
							"40|5|8(?:00|[1-5])",
							"40|5|8(?:00[1-9]|[1-5])"
						]
					]
				]
			],
			"EG": [
				"20",
				"00",
				"1\\d{4,9}|[24-6]\\d{8}|3\\d{7}|[89]\\d{8,9}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{7,8})",
						"$1 $2",
						[
							"[23]"
						]
					],
					[
						"(\\d{2})(\\d{6,7})",
						"$1 $2",
						[
							"1(?:3|5[239])|[4-6]|[89][2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[0-25]|[89]00"
						]
					]
				],
				"0",
				"0$1"
			],
			"EH": [
				"212",
				"00",
				"[5-9]\\d{8}",
				[
					9
				],
				[
					[
						"([5-7]\\d{2})(\\d{6})",
						"$1-$2",
						[
							"5(?:2[015-7]|3[0-4])|[67]"
						]
					],
					[
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						]
					],
					[
						"(5\\d{4})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29|38)[89]"
						]
					],
					[
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:4[067]|5[03])"
						]
					],
					[
						"(8[09])(\\d{7})",
						"$1-$2",
						[
							"8(?:0|9[013-9])"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				"528[89]"
			],
			"ER": [
				"291",
				"00",
				"[178]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"ES": [
				"34",
				"00",
				"[5-9]\\d{8}",
				[
					9
				],
				[
					[
						"([89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					],
					[
						"([5-9]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[568]|[79][0-8]"
						]
					]
				]
			],
			"ET": [
				"251",
				"00",
				"[1-59]\\d{8}",
				[
					9
				],
				[
					[
						"([1-59]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-59]"
						]
					]
				],
				"0",
				"0$1"
			],
			"FI": [
				"358",
				"00|99(?:[01469]|5(?:11|3[23]|41|5[59]|77|88|9[09]))",
				"1\\d{4,11}|[2-9]\\d{4,10}",
				[
					5,
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{3})(\\d{3,7})",
						"$1 $2",
						[
							"(?:[1-3]0|[6-8])0"
						]
					],
					[
						"(75\\d{3})",
						"$1",
						[
							"75[12]"
						]
					],
					[
						"(116\\d{3})",
						"$1",
						[
							"116"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{4,10})",
						"$1 $2",
						[
							"[14]|2[09]|50|7[135]"
						]
					],
					[
						"(\\d)(\\d{4,11})",
						"$1 $2",
						[
							"[25689][1-8]|3"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				[
					[
						"1(?:[3569][1-8]\\d{3,9}|[47]\\d{5,10})|2[1-8]\\d{3,9}|3(?:[1-8]\\d{3,9}|9\\d{4,8})|[5689][1-8]\\d{3,9}"
					],
					[
						"4(?:[0-8]\\d{4,9}|9\\d{3,8})|50\\d{4,8}",
						[
							6,
							7,
							8,
							9,
							10,
							11
						]
					],
					[
						"800\\d{4,7}",
						[
							7,
							8,
							9,
							10
						]
					],
					[
						"[67]00\\d{5,6}",
						[
							8,
							9
						]
					],
					0,
					0,
					[
						"[13]0\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})",
						[
							5,
							6,
							7,
							8,
							9,
							10
						]
					]
				],
				"00"
			],
			"FJ": [
				"679",
				"0(?:0|52)",
				"[2-9]\\d{6}|0\\d{10}",
				[
					7,
					11
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-9]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"FK": [
				"500",
				"00",
				"[2-7]\\d{4}",
				[
					5
				]
			],
			"FM": [
				"691",
				"00",
				"[39]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"FO": [
				"298",
				"00",
				"[2-9]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{6})",
						"$1"
					]
				],
				0,
				0,
				"(10(?:01|[12]0|88))"
			],
			"FR": [
				"33",
				"00",
				"[1-9]\\d{8}",
				[
					9
				],
				[
					[
						"([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"[1-79]"
						]
					],
					[
						"(8\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						],
						"0 $1"
					]
				],
				"0",
				"0$1"
			],
			"GA": [
				"241",
				"00",
				"0?\\d{7}",
				[
					7,
					8
				],
				[
					[
						"(\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-7]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				]
			],
			"GB": [
				"44",
				"00",
				"\\d{7,10}",
				[
					7,
					9,
					10
				],
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				[
					[
						"2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-48]|[46][0-4]|5[0-26-9]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}",
						[
							9,
							10
						]
					],
					[
						"7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}",
						[
							10
						]
					],
					[
						"80(?:0(?:1111|\\d{6,7})|8\\d{7})"
					],
					[
						"(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}",
						[
							10
						]
					],
					[
						"70\\d{8}",
						[
							10
						]
					],
					0,
					[
						"(?:3[0347]|55)\\d{8}",
						[
							10
						]
					],
					[
						"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
						[
							10
						]
					],
					[
						"56\\d{8}",
						[
							10
						]
					],
					[
						"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",
						[
							7,
							10
						]
					]
				],
				0,
				" x"
			],
			"GD": [
				"1",
				"011",
				"[4589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"473"
			],
			"GE": [
				"995",
				"00",
				"[34578]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[348]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5|790"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7"
						],
						"0$1"
					]
				],
				"0"
			],
			"GF": [
				"594",
				"00",
				"[56]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"GG": [
				"44",
				"00",
				"[135789]\\d{6,9}",
				[
					7,
					9,
					10
				],
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"1481[25-9]\\d{5}",
						[
							10
						]
					],
					[
						"7(?:781\\d|839\\d|911[17])\\d{5}",
						[
							10
						]
					],
					[
						"80(?:0(?:1111|\\d{6,7})|8\\d{7})"
					],
					[
						"(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}",
						[
							10
						]
					],
					[
						"70\\d{8}",
						[
							10
						]
					],
					0,
					[
						"(?:3[0347]|55)\\d{8}",
						[
							10
						]
					],
					[
						"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",
						[
							10
						]
					],
					[
						"56\\d{8}",
						[
							10
						]
					],
					[
						"8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",
						[
							7,
							10
						]
					]
				]
			],
			"GH": [
				"233",
				"00",
				"[235]\\d{8}|8\\d{7}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"GI": [
				"350",
				"00",
				"[256]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"2"
						]
					]
				]
			],
			"GL": [
				"299",
				"00",
				"[1-689]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"GM": [
				"220",
				"00",
				"[2-9]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"GN": [
				"224",
				"00",
				"[367]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"3"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[67]"
						]
					]
				]
			],
			"GP": [
				"590",
				"00",
				"[56]\\d{8}",
				[
					9
				],
				[
					[
						"([56]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"590|69[01]"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				[
					[
						"590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"
					],
					[
						"69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"
					]
				]
			],
			"GQ": [
				"240",
				"00",
				"[23589]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[235]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"[89]"
						]
					]
				]
			],
			"GR": [
				"30",
				"00",
				"[26-9]\\d{9}",
				[
					10
				],
				[
					[
						"([27]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"21|7"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[2-9]1|[689]"
						]
					],
					[
						"(2\\d{3})(\\d{6})",
						"$1 $2",
						[
							"2[2-9][02-9]"
						]
					]
				]
			],
			"GT": [
				"502",
				"00",
				"[2-7]\\d{7}|1[89]\\d{9}",
				[
					8,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					]
				]
			],
			"GU": [
				"1",
				"011",
				"[5689]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"671"
			],
			"GW": [
				"245",
				"00",
				"(?:4(?:0\\d{5}|4\\d{7})|9\\d{8})",
				[
					7,
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"44|9[5-7]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"40"
						]
					]
				]
			],
			"GY": [
				"592",
				"001",
				"[2-46-9]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"HK": [
				"852",
				"00(?:[126-9]|30|5[09])?",
				"[2-7]\\d{7}|8[0-4]\\d{6,7}|9\\d{4,10}",
				[
					5,
					6,
					7,
					8,
					9,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[2-7]|[89](?:0[1-9]|[1-9])"
						]
					],
					[
						"(800)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800"
						]
					],
					[
						"(900)(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"900"
						]
					],
					[
						"(900)(\\d{2,5})",
						"$1 $2",
						[
							"900"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"HN": [
				"504",
				"00",
				"[237-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1-$2"
					]
				]
			],
			"HR": [
				"385",
				"00",
				"[1-7]\\d{5,8}|[89]\\d{6,8}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(1)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"([2-5]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-5]"
						]
					],
					[
						"(9\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(6[01])(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"6[01]"
						]
					],
					[
						"([67]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[67]"
						]
					],
					[
						"(80[01])(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"80[01]"
						]
					],
					[
						"(80[01])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"80[01]"
						]
					]
				],
				"0",
				"0$1"
			],
			"HT": [
				"509",
				"00",
				"[2-489]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3"
					]
				]
			],
			"HU": [
				"36",
				"00",
				"[1-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(1)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-9]"
						]
					]
				],
				"06",
				"($1)"
			],
			"ID": [
				"62",
				"0(?:0[1789]|10(?:00|1[67]))",
				"(?:[1-79]\\d{6,10}|8\\d{7,11})",
				[
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"(\\d{2})(\\d{5,8})",
						"$1 $2",
						[
							"2[124]|[36]1"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{5,8})",
						"$1 $2",
						[
							"2[035-9]|[36][02-9]|[4579]"
						],
						"(0$1)"
					],
					[
						"(8\\d{2})(\\d{3,4})(\\d{3})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						]
					],
					[
						"(8\\d{2})(\\d{4})(\\d{4,5})",
						"$1-$2-$3",
						[
							"8[1-35-9]"
						]
					],
					[
						"(1)(500)(\\d{3})",
						"$1 $2 $3",
						[
							"150",
							"1500"
						],
						"$1"
					],
					[
						"(177)(\\d{6,8})",
						"$1 $2",
						[
							"177"
						]
					],
					[
						"(800)(\\d{5,7})",
						"$1 $2",
						[
							"800"
						]
					],
					[
						"(804)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"804"
						]
					],
					[
						"(80\\d)(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"80[79]"
						]
					]
				],
				"0",
				"0$1"
			],
			"IE": [
				"353",
				"00",
				"[124-9]\\d{6,9}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"(1)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"2[24-9]|47|58|6[237-9]|9[35-9]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"40[24]|50[45]"
						]
					],
					[
						"(48)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"48"
						]
					],
					[
						"(818)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"818"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[24-69]|7[14]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"76|8[35-9]"
						],
						"0$1"
					],
					[
						"(8\\d)(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"8[35-9]5"
						],
						"0$1"
					],
					[
						"(700)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"700"
						],
						"0$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:5|8[059])",
							"1(?:5|8[059]0)"
						],
						"$1"
					]
				],
				"0",
				"(0$1)"
			],
			"IL": [
				"972",
				"0(?:0|1[2-9])",
				"1\\d{6,11}|[2-589]\\d{3}(?:\\d{3,6})?|6\\d{3}|7\\d{6,9}",
				[
					4,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"([2-489])(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2-489]"
						],
						"0$1"
					],
					[
						"([57]\\d)(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]"
						],
						"0$1"
					],
					[
						"(153)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"153"
						]
					],
					[
						"(1)([7-9]\\d{2})(\\d{3})(\\d{3})",
						"$1-$2-$3-$4",
						[
							"1[7-9]"
						]
					],
					[
						"(1255)(\\d{3})",
						"$1-$2",
						[
							"125",
							"1255"
						]
					],
					[
						"(1200)(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"120",
							"1200"
						]
					],
					[
						"(1212)(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"121",
							"1212"
						]
					],
					[
						"(1599)(\\d{6})",
						"$1-$2",
						[
							"159",
							"1599"
						]
					],
					[
						"(151)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1-$2 $3-$4",
						[
							"151"
						]
					],
					[
						"(\\d{4})",
						"*$1",
						[
							"[2-689]"
						]
					]
				],
				"0"
			],
			"IM": [
				"44",
				"00",
				"[135789]\\d{6,9}",
				[
					10
				],
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"1624[5-8]\\d{5}"
					],
					[
						"7(?:4576|[59]24\\d|624[0-4689])\\d{5}"
					],
					[
						"808162\\d{4}"
					],
					[
						"(?:872299|90[0167]624)\\d{4}"
					],
					[
						"70\\d{8}"
					],
					0,
					[
						"3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}"
					],
					0,
					[
						"56\\d{8}"
					],
					[
						"8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"
					]
				]
			],
			"IN": [
				"91",
				"00",
				"008\\d{9}|1\\d{7,12}|[2-9]\\d{9,10}",
				[
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(\\d{8})",
						"$1",
						[
							"561",
							"5616",
							"56161"
						],
						"$1"
					],
					[
						"(\\d{5})(\\d{5})",
						"$1 $2",
						[
							"6(?:0[02]|12|2[03689]|3[05-9]|9[019])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9",
							"6(?:0(?:0|26)|127|2(?:0[0-49]|3[589]|[68][0-39]|9[0-46])|3(?:0[0-39]|5[0-46-9]|6[0-2]|7[015-79]|[89][0-79])|9[019])|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9",
							"6(?:0(?:0|26)|1279|2(?:0[0-49]|3[589]|[68][0-39]|9[0-46])|3(?:0[0-39]|5[0-46-9]|6[0-2]|7[015-79]|[89][0-79])|9[019])|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[024-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[04-9]))|1(?:[02-57-9]|1(?:[0-35-9]|4[0-46-9])|6(?:[089]|7[02-8]))|2(?:[014](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|[16](?:[089]|7[02-8])|2(?:[09]|7[02-8]|8[0-689]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-8]))|9(?:[02-9]|1(?:[0289]|7[02-8])))|9"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"11|2[02]|33|4[04]|79[1-9]|80[2-46]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"
						]
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1(?:[23579]|[468][1-9])|[2-8]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"008"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"140"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"160",
							"1600"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"180",
							"1800"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{2,4})(\\d{4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"186",
							"1860"
						],
						"$1"
					],
					[
						"(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"18[06]"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				0,
				0,
				1
			],
			"IO": [
				"246",
				"00",
				"3\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"IQ": [
				"964",
				"00",
				"[1-7]\\d{7,9}",
				[
					8,
					9,
					10
				],
				[
					[
						"(1)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"([2-6]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-6]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"0",
				"0$1"
			],
			"IR": [
				"98",
				"00",
				"[1-8]\\d{5,9}|9(?:[0-4]\\d{8}|9\\d{8})",
				[
					6,
					7,
					10
				],
				[
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-8]"
						]
					],
					[
						"(\\d{2})(\\d{4,5})",
						"$1 $2",
						[
							"[1-8]"
						]
					],
					[
						"(\\d{4,5})",
						"$1",
						[
							"96"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				"0$1"
			],
			"IS": [
				"354",
				"1(?:0(?:01|10|20)|100)|00",
				"[4-9]\\d{6}|38\\d{7}",
				[
					7,
					9
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[4-9]"
						]
					],
					[
						"(3\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"IT": [
				"39",
				"00",
				"[01589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9})",
				[
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|55"
						]
					],
					[
						"(0[26])(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(0[26])(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(0\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[
						"(0\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(0\\d{3})(\\d{2,6})",
						"$1 $2",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13]|8(?:00|4[08]|9[59])",
							"[13]|8(?:00|4[08]|9(?:5[5-9]|9))"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894",
							"894[5-9]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"0(?:[26]\\d{4,9}|(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2346]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[34578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7})"
					],
					[
						"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
						[
							9,
							10,
							11
						]
					],
					[
						"80(?:0\\d{6}|3\\d{3})",
						[
							6,
							9
						]
					],
					[
						"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
						[
							6,
							8,
							9,
							10
						]
					],
					[
						"1(?:78\\d|99)\\d{6}",
						[
							9,
							10
						]
					],
					0,
					0,
					0,
					[
						"55\\d{8}",
						[
							10
						]
					],
					[
						"84(?:[08]\\d{6}|[17]\\d{3})",
						[
							6,
							9
						]
					]
				]
			],
			"JE": [
				"44",
				"00",
				"[135789]\\d{6,9}",
				[
					10
				],
				[
					[
						"(7\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7(?:[1-57-9]|62)",
							"7(?:[1-57-9]|624)"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2|5[56]|7[06]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[02-9]1|1)|3|9[018]"
						]
					],
					[
						"(\\d{5})(\\d{4,5})",
						"$1 $2",
						[
							"1(?:38|5[23]|69|76|94)",
							"1(?:(?:38|69)7|5(?:24|39)|768|946)",
							"1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
						]
					],
					[
						"(1\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(800)(\\d{4})",
						"$1 $2",
						[
							"800",
							"8001",
							"80011",
							"800111",
							"8001111"
						]
					],
					[
						"(845)(46)(4\\d)",
						"$1 $2 $3",
						[
							"845",
							"8454",
							"84546",
							"845464"
						]
					],
					[
						"(8\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8(?:4[2-5]|7[0-3])"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"80"
						]
					],
					[
						"(800)(\\d{6})",
						"$1 $2",
						[
							"800"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"1534[0-24-8]\\d{5}"
					],
					[
						"7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}"
					],
					[
						"80(?:07(?:35|81)|8901)\\d{4}"
					],
					[
						"(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
					],
					[
						"701511\\d{4}"
					],
					0,
					[
						"3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}"
					],
					[
						"76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}"
					],
					[
						"56\\d{8}"
					],
					[
						"8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"
					]
				]
			],
			"JM": [
				"1",
				"011",
				"[589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"876"
			],
			"JO": [
				"962",
				"00",
				"[235-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2356]|87"
						],
						"(0$1)"
					],
					[
						"(7)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"7[457-9]"
						]
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"70"
						]
					],
					[
						"(\\d{3})(\\d{5,6})",
						"$1 $2",
						[
							"8[0158]|9"
						]
					]
				],
				"0",
				"0$1"
			],
			"JP": [
				"81",
				"010",
				"[1-9]\\d{8,9}|00(?:[36]\\d{7,14}|7\\d{5,7}|8\\d{7})",
				[
					8,
					9,
					10,
					11,
					12,
					13,
					14,
					15,
					16,
					17
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1-$2-$3",
						[
							"(?:12|57|99)0"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"800"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[2579]0|80[1-9]"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))",
							"1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"1(?:2[3-6]|3[3-9]|4[2-6]|5[2-8]|[68][2-7]|7[2-689]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))",
							"1(?:2[3-6]|3[3-9]|4[2-6]|5(?:[236-8]|[45][2-69])|[68][2-7]|7[2-689]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|6[1-9]|7[2-8]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4[02-9]|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)",
							"1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])",
							"1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93(?:31|4))"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{4})",
						"$1-$2-$3",
						[
							"2(?:[34]7|[56]9|74|9[14-79])|82|993"
						]
					],
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"3|4(?:2[09]|7[01])|6[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"[2479][1-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"KE": [
				"254",
				"000",
				"20\\d{6,7}|[4-9]\\d{6,9}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"[24-6]"
						]
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1",
				"005|0"
			],
			"KG": [
				"996",
				"00",
				"[235-8]\\d{8,9}",
				[
					9,
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[25-7]|31[25]"
						]
					],
					[
						"(\\d{4})(\\d{5})",
						"$1 $2",
						[
							"3(?:1[36]|[2-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d)(\\d{3})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"KH": [
				"855",
				"00[14-9]",
				"[1-9]\\d{7,9}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1\\d[1-9]|[2-9]"
						],
						"0$1"
					],
					[
						"(1[89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[89]0",
							"1[89]00"
						]
					]
				],
				"0"
			],
			"KI": [
				"686",
				"00",
				"[2458]\\d{4}|3\\d{4,7}|[67]\\d{7}",
				[
					5,
					8
				],
				0,
				0,
				0,
				"0"
			],
			"KM": [
				"269",
				"00",
				"[3478]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"KN": [
				"1",
				"011",
				"[589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"869"
			],
			"KP": [
				"850",
				"00|99",
				"1\\d{9}|[28]\\d{7}",
				[
					8,
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"8"
						]
					]
				],
				"0",
				"0$1"
			],
			"KR": [
				"82",
				"00(?:[1259]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
				"00(?:3\\d{8,9}|7\\d{9,11})|[1-7]\\d{4,9}|8\\d{8}",
				[
					5,
					6,
					8,
					9,
					10,
					11,
					12,
					13,
					14
				],
				[
					[
						"(\\d{2})(\\d{3,4})",
						"$1-$2",
						[
							"(?:3[1-3]|[46][1-4]|5[1-5])1"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"1(?:5[246-9]|6[046-8]|8[03579])",
							"1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"
						],
						"$1"
					],
					[
						"(\\d{5})",
						"$1",
						[
							"1[016-9]1",
							"1[016-9]11",
							"1[016-9]114"
						]
					],
					[
						"(\\d)(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"2[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1-$2-$3",
						[
							"60[2-9]|80"
						]
					],
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1-$2-$3",
						[
							"1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1-$2-$3",
						[
							"[57]0"
						]
					]
				],
				"0",
				"0$1",
				"0(8[1-46-8]|85\\d{2})?"
			],
			"KW": [
				"965",
				"00",
				"[12569]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{4})(\\d{3,4})",
						"$1 $2",
						[
							"[16]|2(?:[0-35-9]|4[0-35-9])|52[25]|9[0-24-9]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"244|5(?:[015]|6[56])"
						]
					]
				]
			],
			"KY": [
				"1",
				"011",
				"[3589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"345"
			],
			"KZ": [
				"7",
				"810",
				"(?:33\\d|7\\d{2}|80[089])\\d{7}",
				[
					10
				],
				[
					[
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[3489]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"8",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}"
					],
					[
						"7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}"
					],
					[
						"800\\d{7}"
					],
					[
						"809\\d{7}"
					],
					[
						"808\\d{7}"
					],
					0,
					0,
					0,
					[
						"751\\d{7}"
					]
				],
				"8~10"
			],
			"LA": [
				"856",
				"00",
				"[2-8]\\d{7,9}",
				[
					8,
					9,
					10
				],
				[
					[
						"(20)(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"([2-8]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13]|3[14]|[4-8]"
						]
					],
					[
						"(30)(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"30"
						]
					]
				],
				"0",
				"0$1"
			],
			"LB": [
				"961",
				"00",
				"[13-9]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
						],
						"0$1"
					],
					[
						"([7-9]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7(?:[01]|6[013-9]|8[89]|9[1-3])|[89][01]"
						]
					]
				],
				"0"
			],
			"LC": [
				"1",
				"011",
				"[5789]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"758"
			],
			"LI": [
				"423",
				"00",
				"6\\d{8}|[23789]\\d{6}",
				[
					7,
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[237-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6[56]"
						]
					],
					[
						"(69)(7\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"697"
						]
					]
				],
				"0",
				0,
				"0|10(?:01|20|66)"
			],
			"LK": [
				"94",
				"00",
				"[1-9]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[1-689]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"0",
				"0$1"
			],
			"LR": [
				"231",
				"00",
				"2\\d{7,8}|[378]\\d{8}|4\\d{6}|5\\d{6,8}",
				[
					7,
					8,
					9
				],
				[
					[
						"(2\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([4-5])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[45]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23578]"
						]
					]
				],
				"0",
				"0$1"
			],
			"LS": [
				"266",
				"00",
				"[2568]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"LT": [
				"370",
				"00",
				"[3-9]\\d{7}",
				[
					8
				],
				[
					[
						"([34]\\d)(\\d{6})",
						"$1 $2",
						[
							"37|4(?:1|5[45]|6[2-4])"
						]
					],
					[
						"([3-6]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"3[148]|4(?:[24]|6[09])|528|6"
						]
					],
					[
						"([7-9]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"8 $1"
					],
					[
						"(5)(2\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"52[0-79]"
						]
					]
				],
				"8",
				"(8-$1)",
				"[08]",
				0,
				1
			],
			"LU": [
				"352",
				"00",
				"[24-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5[013-9]\\d{1,8})",
				[
					4,
					5,
					6,
					7,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1 $2",
						[
							"[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"20"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"20"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
						"$1 $2 $3 $4 $5",
						[
							"2(?:[0367]|4[3-8])"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})",
						"$1 $2 $3 $4",
						[
							"2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"70|80[01]|90[015]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"6"
						]
					]
				],
				0,
				0,
				"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"
			],
			"LV": [
				"371",
				"00",
				"[2689]\\d{7}",
				[
					8
				],
				[
					[
						"([2689]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2689]"
						]
					]
				]
			],
			"LY": [
				"218",
				"00",
				"[25679]\\d{8}",
				[
					9
				],
				[
					[
						"([25-79]\\d)(\\d{7})",
						"$1-$2",
						[
							"[25-79]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MA": [
				"212",
				"00",
				"[5-9]\\d{8}",
				[
					9
				],
				[
					[
						"([5-7]\\d{2})(\\d{6})",
						"$1-$2",
						[
							"5(?:2[015-7]|3[0-4])|[67]"
						]
					],
					[
						"([58]\\d{3})(\\d{5})",
						"$1-$2",
						[
							"5(?:2[2-489]|3[5-9]|92)|892",
							"5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|924)|892"
						]
					],
					[
						"(5\\d{4})(\\d{4})",
						"$1-$2",
						[
							"5(?:29|38)",
							"5(?:29|38)[89]"
						]
					],
					[
						"([5]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:4[067]|5[03])"
						]
					],
					[
						"(8[09])(\\d{7})",
						"$1-$2",
						[
							"8(?:0|9[013-9])"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				[
					[
						"5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])\\d|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])\\d|4[067]\\d{2}|5[03]\\d{2})\\d{4}"
					],
					[
						"(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[017]))\\d{6}"
					],
					[
						"80\\d{7}"
					],
					[
						"89\\d{7}"
					],
					0,
					0,
					0,
					0,
					[
						"5924[01]\\d{4}"
					]
				]
			],
			"MC": [
				"377",
				"00",
				"[34689]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[39]"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"4"
						]
					],
					[
						"(6)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4 $5",
						[
							"6"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"8"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"MD": [
				"373",
				"00",
				"[235-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"22|3"
						]
					],
					[
						"([25-7]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"2[13-9]|[5-7]"
						]
					],
					[
						"([89]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1"
			],
			"ME": [
				"382",
				"00",
				"[2-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[2-57-9]|6[036-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MF": [
				"590",
				"00",
				"[56]\\d{8}",
				[
					9
				],
				[
					[
						"([56]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"590|69[01]"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				[
					[
						"590(?:0[079]|13|2[79]|30|43|5[0-268]|7[79]|87)\\d{4}"
					],
					[
						"69(?:0\\d{2}|1(?:2[29]|3[0-5]))\\d{4}"
					]
				]
			],
			"MG": [
				"261",
				"00",
				"[23]\\d{8}",
				[
					9
				],
				[
					[
						"([23]\\d)(\\d{2})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MH": [
				"692",
				"011",
				"[2-6]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2"
					]
				],
				"1"
			],
			"MK": [
				"389",
				"00",
				"[2-578]\\d{7}",
				[
					8
				],
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([347]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[347]"
						]
					],
					[
						"([58]\\d{2})(\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[58]"
						]
					]
				],
				"0",
				"0$1"
			],
			"ML": [
				"223",
				"00",
				"[24-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[24-9]"
						]
					]
				]
			],
			"MM": [
				"95",
				"00",
				"[178]\\d{5,7}|[24-6]\\d{5,8}|9(?:[279]\\d{0,2}|5|[34]\\d{1,2}|6(?:\\d{1,2})?|8(?:\\d{2})?)\\d{6}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"1|2[245]"
						]
					],
					[
						"(2)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"251"
						]
					],
					[
						"(\\d)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"16|2"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"432|67|81"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[4-8]"
						]
					],
					[
						"(9)(\\d{3})(\\d{4,6})",
						"$1 $2 $3",
						[
							"9(?:2[0-4]|[35-9]|4[137-9])"
						]
					],
					[
						"(9)([34]\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"9(?:3[0-36]|4[0-57-9])"
						]
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"92[56]"
						]
					],
					[
						"(9)(\\d{3})(\\d{3})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"93"
						]
					]
				],
				"0",
				"0$1"
			],
			"MN": [
				"976",
				"001",
				"[12]\\d{7,9}|[57-9]\\d{7}",
				[
					8,
					9,
					10
				],
				[
					[
						"([12]\\d)(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[12]1"
						]
					],
					[
						"([12]2\\d)(\\d{5,6})",
						"$1 $2",
						[
							"[12]2[1-3]"
						]
					],
					[
						"([12]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[12](?:27|[3-5])",
							"[12](?:27|[3-5]\\d)2"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[57-9]"
						],
						"$1"
					],
					[
						"([12]\\d{4})(\\d{4,5})",
						"$1 $2",
						[
							"[12](?:27|[3-5])",
							"[12](?:27|[3-5]\\d)[4-9]"
						]
					]
				],
				"0",
				"0$1"
			],
			"MO": [
				"853",
				"00",
				"[268]\\d{7}",
				[
					8
				],
				[
					[
						"([268]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[268]"
						]
					]
				]
			],
			"MP": [
				"1",
				"011",
				"[5689]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"670"
			],
			"MQ": [
				"596",
				"00",
				"[56]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				"0",
				"0$1"
			],
			"MR": [
				"222",
				"00",
				"[2-48]\\d{7}",
				[
					8
				],
				[
					[
						"([2-48]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[2-48]"
						]
					]
				]
			],
			"MS": [
				"1",
				"011",
				"[5689]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"664"
			],
			"MT": [
				"356",
				"00",
				"[2357-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"MU": [
				"230",
				"0(?:0|[2-7]0|33)",
				"[2-9]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"([2-46-9]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[2-46-9]"
						]
					],
					[
						"(5\\d{3})(\\d{4})",
						"$1 $2",
						[
							"5"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"020"
			],
			"MV": [
				"960",
				"0(?:0|19)",
				"[346-8]\\d{6,9}|9(?:00\\d{7}|\\d{6})",
				[
					7,
					10
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[3467]|9(?:0[1-9]|[1-9])"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]00"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"MW": [
				"265",
				"00",
				"(?:1(?:\\d{2})?|[2789]\\d{2}|31\\d)\\d{6}",
				[
					7,
					9
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1"
						]
					],
					[
						"(2\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[17-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"31"
						]
					]
				],
				"0",
				"0$1"
			],
			"MX": [
				"52",
				"0[09]",
				"[1-9]\\d{9,10}",
				[
					10,
					11
				],
				[
					[
						"([358]\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"33|55|81"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"
						]
					],
					[
						"(1)([358]\\d)(\\d{4})(\\d{4})",
						"044 $2 $3 $4",
						[
							"1(?:33|55|81)"
						],
						"$1",
						0,
						"$1 $2 $3 $4"
					],
					[
						"(1)(\\d{3})(\\d{3})(\\d{4})",
						"044 $2 $3 $4",
						[
							"1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"
						],
						"$1",
						0,
						"$1 $2 $3 $4"
					]
				],
				"01",
				"01 $1",
				"0[12]|04[45](\\d{10})",
				"1$1",
				1
			],
			"MY": [
				"60",
				"00",
				"[13-9]\\d{7,9}",
				[
					8,
					9,
					10
				],
				[
					[
						"([4-79])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"[4-79]"
						],
						"0$1"
					],
					[
						"(3)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"3"
						],
						"0$1"
					],
					[
						"([18]\\d)(\\d{3})(\\d{3,4})",
						"$1-$2 $3",
						[
							"1[02-46-9][1-9]|8"
						],
						"0$1"
					],
					[
						"(1)([36-8]00)(\\d{2})(\\d{4})",
						"$1-$2-$3-$4",
						[
							"1[36-8]0",
							"1[36-8]00"
						]
					],
					[
						"(11)(\\d{4})(\\d{4})",
						"$1-$2 $3",
						[
							"11"
						],
						"0$1"
					],
					[
						"(15[49])(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"15[49]"
						],
						"0$1"
					]
				],
				"0"
			],
			"MZ": [
				"258",
				"00",
				"[28]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"([28]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2|8[2-7]"
						]
					],
					[
						"(80\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"80"
						]
					]
				]
			],
			"NA": [
				"264",
				"00",
				"[68]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(8\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"8[1-35]"
						]
					],
					[
						"(6\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"6"
						]
					],
					[
						"(88)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"88"
						]
					],
					[
						"(870)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"870"
						]
					]
				],
				"0",
				"0$1"
			],
			"NC": [
				"687",
				"00",
				"[2-57-9]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1.$2.$3",
						[
							"[2-46-9]|5[0-4]"
						]
					]
				]
			],
			"NE": [
				"227",
				"00",
				"[0289]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"09|[289]"
						]
					],
					[
						"(08)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"08"
						]
					]
				]
			],
			"NF": [
				"672",
				"00",
				"[13]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"(\\d)(\\d{5})",
						"$1 $2",
						[
							"3"
						]
					]
				]
			],
			"NG": [
				"234",
				"009",
				"[1-6]\\d{5,8}|9\\d{5,9}|[78]\\d{5,13}",
				[
					7,
					8,
					10,
					11,
					12,
					13,
					14
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[12]|9(?:0[3-9]|[1-9])"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"70|8[01]|90[235-9]"
						]
					],
					[
						"([78]00)(\\d{4})(\\d{4,5})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"([78]00)(\\d{5})(\\d{5,6})",
						"$1 $2 $3",
						[
							"[78]00"
						]
					],
					[
						"(78)(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"78"
						]
					]
				],
				"0",
				"0$1"
			],
			"NI": [
				"505",
				"00",
				"[125-8]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"NL": [
				"31",
				"00",
				"1\\d{4,8}|[2-7]\\d{8}|[89]\\d{6,9}",
				[
					5,
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"([1-578]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[035]|2[0346]|3[03568]|4[0356]|5[0358]|7|8[4578]"
						]
					],
					[
						"([1-5]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
						]
					],
					[
						"(6)(\\d{8})",
						"$1 $2",
						[
							"6[0-57-9]"
						]
					],
					[
						"(66)(\\d{7})",
						"$1 $2",
						[
							"66"
						]
					],
					[
						"(14)(\\d{3,4})",
						"$1 $2",
						[
							"14"
						],
						"$1"
					],
					[
						"([89]0\\d)(\\d{4,7})",
						"$1 $2",
						[
							"[89]0"
						]
					]
				],
				"0",
				"0$1"
			],
			"NO": [
				"47",
				"00",
				"0\\d{4}|[2-9]\\d{7}",
				[
					5,
					8
				],
				[
					[
						"([489]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]"
						]
					],
					[
						"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",
						[
							8
						]
					],
					[
						"(?:4[015-8]|5[89]|9\\d)\\d{6}",
						[
							8
						]
					],
					[
						"80[01]\\d{5}",
						[
							8
						]
					],
					[
						"82[09]\\d{5}",
						[
							8
						]
					],
					[
						"880\\d{5}",
						[
							8
						]
					],
					0,
					[
						"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}"
					],
					0,
					[
						"85[0-5]\\d{5}",
						[
							8
						]
					],
					[
						"810(?:0[0-6]|[2-8]\\d)\\d{3}",
						[
							8
						]
					]
				]
			],
			"NP": [
				"977",
				"00",
				"[1-8]\\d{7}|9(?:[1-69]\\d{6,8}|7[2-6]\\d{5,7}|8\\d{8})",
				[
					8,
					10
				],
				[
					[
						"(1)(\\d{7})",
						"$1-$2",
						[
							"1[2-6]"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1-$2",
						[
							"1[01]|[2-8]|9(?:[1-69]|7[15-9])"
						]
					],
					[
						"(9\\d{2})(\\d{7})",
						"$1-$2",
						[
							"9(?:6[013]|7[245]|8)"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"NR": [
				"674",
				"00",
				"[458]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"NU": [
				"683",
				"00",
				"[1-5]\\d{3}",
				[
					4
				]
			],
			"NZ": [
				"64",
				"0(?:0|161)",
				"6[235-9]\\d{6}|[2-57-9]\\d{7,9}",
				[
					8,
					9,
					10
				],
				[
					[
						"(\\d)(\\d{3})(\\d{4})",
						"$1-$2 $3",
						[
							"240|[346]|7[2-57-9]|9[1-9]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"21"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,5})",
						"$1 $2 $3",
						[
							"2(?:1[1-9]|[69]|7[0-35-9])|70|86"
						]
					],
					[
						"(2\\d)(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[028]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"90"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:10|74)|5|[89]0"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"OM": [
				"968",
				"00",
				"(?:5|[279]\\d)\\d{6}|800\\d{5,6}",
				[
					7,
					8,
					9
				],
				[
					[
						"(2\\d)(\\d{6})",
						"$1 $2",
						[
							"2"
						]
					],
					[
						"([79]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[79]"
						]
					],
					[
						"([58]00)(\\d{4,6})",
						"$1 $2",
						[
							"[58]00"
						]
					]
				]
			],
			"PA": [
				"507",
				"00",
				"[1-9]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[1-57-9]"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1-$2",
						[
							"6"
						]
					]
				]
			],
			"PE": [
				"51",
				"19(?:1[124]|77|90)00",
				"[14-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(1)(\\d{7})",
						"$1 $2",
						[
							"1"
						]
					],
					[
						"([4-8]\\d)(\\d{6})",
						"$1 $2",
						[
							"[4-7]|8[2-4]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"80"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						],
						"$1"
					]
				],
				"0",
				"(0$1)",
				0,
				0,
				0,
				0,
				0,
				0,
				" Anexo "
			],
			"PF": [
				"689",
				"00",
				"4\\d{5,7}|8\\d{7}",
				[
					6,
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"4[09]|8[79]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"44"
						]
					]
				]
			],
			"PG": [
				"675",
				"140[1-3]|00",
				"[1-9]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[13-689]|27"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"20|7"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"PH": [
				"63",
				"00",
				"1\\d{10,12}|2\\d{5,7}|[3-7]\\d{8}|8\\d{7,9}|9\\d{9}",
				[
					6,
					8,
					9,
					10,
					11,
					12,
					13
				],
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(2)(\\d{5})",
						"$1 $2",
						[
							"2"
						],
						"(0$1)"
					],
					[
						"(\\d{4})(\\d{4,6})",
						"$1 $2",
						[
							"3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])",
							"3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
						],
						"(0$1)"
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"346|4(?:27|9[35])|883",
							"3469|4(?:279|9(?:30|56))|8834"
						],
						"(0$1)"
					],
					[
						"([3-8]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[3-8]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"81|9"
						],
						"0$1"
					],
					[
						"(1800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"180",
							"1800"
						]
					],
					[
						"(1800)(\\d{1,2})(\\d{3})(\\d{4})",
						"$1 $2 $3 $4",
						[
							"180",
							"1800"
						]
					]
				],
				"0"
			],
			"PK": [
				"92",
				"00",
				"1\\d{8}|[2-8]\\d{5,11}|9(?:[013-9]\\d{4,10}|2\\d(?:111\\d{6}|\\d{3,7}))",
				[
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"([89]00)(\\d{3})(\\d{2})",
						"$1 $2 $3",
						[
							"[89]00"
						],
						"0$1"
					],
					[
						"(1\\d{3})(\\d{5})",
						"$1 $2",
						[
							"1"
						],
						"$1"
					],
					[
						"(\\d{2})(\\d{7,8})",
						"$1 $2",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{6,7})",
						"$1 $2",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-469]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"
						]
					],
					[
						"(58\\d{3})(\\d{5})",
						"$1 $2",
						[
							"58[126]"
						]
					],
					[
						"(3\\d{2})(\\d{7})",
						"$1 $2",
						[
							"3"
						],
						"0$1"
					],
					[
						"(\\d{2})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11",
							"(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"
						]
					],
					[
						"(\\d{3})(111)(\\d{3})(\\d{3})",
						"$1 $2 $3 $4",
						[
							"2[349]|45|54|60|72|8[2-5]|9[2-9]",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11",
							"(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"
						]
					]
				],
				"0",
				"(0$1)"
			],
			"PL": [
				"48",
				"00",
				"[1-57-9]\\d{6,8}|6\\d{5,8}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d{3})(\\d{3})",
						"$1 $2",
						[
							"11[68]|64"
						]
					],
					[
						"(\\d{5})",
						"$1",
						[
							"19"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"64"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"26|39|45|5[0137]|6[0469]|7[02389]|8[08]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"
						]
					]
				]
			],
			"PM": [
				"508",
				"00",
				"[45]\\d{5}",
				[
					6
				],
				[
					[
						"([45]\\d)(\\d{2})(\\d{2})",
						"$1 $2 $3",
						[
							"[45]"
						]
					]
				],
				"0",
				"0$1"
			],
			"PR": [
				"1",
				"011",
				"[5789]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"787|939"
			],
			"PS": [
				"970",
				"00",
				"1\\d{9}|[24589]\\d{7,8}",
				[
					8,
					9,
					10
				],
				[
					[
						"([2489])(2\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[2489]2"
						]
					],
					[
						"(5[69]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"5[69]"
						]
					],
					[
						"(1[78]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[78]0",
							"1[78]00"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"PT": [
				"351",
				"00",
				"[2-46-9]\\d{8}",
				[
					9
				],
				[
					[
						"(2\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2[12]"
						]
					],
					[
						"([2-46-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2[3-9]|[346-9]"
						]
					]
				]
			],
			"PW": [
				"680",
				"01[12]",
				"[2-9]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"PY": [
				"595",
				"00",
				"5[0-5]\\d{4,7}|[2-46-9]\\d{5,8}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
						],
						"(0$1)"
					],
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"[2-9]0"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"870",
							"8700"
						]
					],
					[
						"(\\d{3})(\\d{4,5})",
						"$1 $2",
						[
							"[2-8][1-9]"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[2-8][1-9]"
						],
						"0$1"
					]
				],
				"0"
			],
			"QA": [
				"974",
				"00",
				"[2-8]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"([28]\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[28]"
						]
					],
					[
						"([3-7]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[3-7]"
						]
					]
				]
			],
			"RE": [
				"262",
				"00",
				"[268]\\d{8}",
				[
					9
				],
				[
					[
						"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[268]"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				"262|69|8"
			],
			"RO": [
				"40",
				"00",
				"[23]\\d{5,8}|[7-9]\\d{8}",
				[
					6,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[23]1"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"[23]1"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[23][3-7]|[7-9]"
						]
					],
					[
						"(2\\d{2})(\\d{3})",
						"$1 $2",
						[
							"2[3-6]"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				0,
				0,
				" int "
			],
			"RS": [
				"381",
				"00",
				"[126-9]\\d{4,11}|3(?:[0-79]\\d{3,10}|8[2-9]\\d{2,9})",
				[
					6,
					7,
					8,
					9,
					10,
					11,
					12
				],
				[
					[
						"([23]\\d{2})(\\d{4,9})",
						"$1 $2",
						[
							"(?:2[389]|39)0"
						]
					],
					[
						"([1-3]\\d)(\\d{5,10})",
						"$1 $2",
						[
							"1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"
						]
					],
					[
						"(6\\d)(\\d{6,8})",
						"$1 $2",
						[
							"6"
						]
					],
					[
						"([89]\\d{2})(\\d{3,9})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(7[26])(\\d{4,9})",
						"$1 $2",
						[
							"7[26]"
						]
					],
					[
						"(7[08]\\d)(\\d{4,9})",
						"$1 $2",
						[
							"7[08]"
						]
					]
				],
				"0",
				"0$1"
			],
			"RU": [
				"7",
				"810",
				"[347-9]\\d{9}",
				[
					10
				],
				[
					[
						"([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"[3489]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					]
				],
				"8",
				"8 ($1)",
				0,
				0,
				1,
				0,
				[
					[
						"(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}"
					],
					[
						"9\\d{9}"
					],
					[
						"80[04]\\d{7}"
					],
					[
						"80[39]\\d{7}"
					],
					[
						"808\\d{7}"
					]
				],
				"8~10"
			],
			"RW": [
				"250",
				"00",
				"[027-9]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(2\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([7-9]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[7-9]"
						],
						"0$1"
					],
					[
						"(0\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"0"
						]
					]
				],
				"0"
			],
			"SA": [
				"966",
				"00",
				"[15]\\d{8}|8\\d{9}|92\\d{7}",
				[
					9,
					10
				],
				[
					[
						"(1\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[1-467]"
						]
					],
					[
						"(5\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"5"
						]
					],
					[
						"(92\\d{2})(\\d{5})",
						"$1 $2",
						[
							"92"
						],
						"$1"
					],
					[
						"(800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						],
						"$1"
					],
					[
						"(811)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"811"
						]
					]
				],
				"0",
				"0$1"
			],
			"SB": [
				"677",
				"0[01]",
				"[1-9]\\d{4,6}",
				[
					5,
					7
				],
				[
					[
						"(\\d{2})(\\d{5})",
						"$1 $2",
						[
							"[7-9]"
						]
					]
				]
			],
			"SC": [
				"248",
				"0(?:[02]|10?)",
				"[24689]\\d{5,6}",
				[
					7
				],
				[
					[
						"(\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[246]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"SD": [
				"249",
				"00",
				"[19]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"SE": [
				"46",
				"00",
				"[1-35-9]\\d{5,11}|4\\d{6,8}",
				[
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"(8)(\\d{2,3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"8"
						],
						0,
						0,
						"$1 $2 $3 $4"
					],
					[
						"([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"
						],
						0,
						0,
						"$1 $2 $3 $4"
					],
					[
						"([1-469]\\d)(\\d{3})(\\d{2})",
						"$1-$2 $3",
						[
							"[12][136]|3[356]|4[0246]|6[03]|90"
						],
						0,
						0,
						"$1 $2 $3"
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						0,
						0,
						"$1 $2 $3 $4"
					],
					[
						"(\\d{3})(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"
						],
						0,
						0,
						"$1 $2 $3"
					],
					[
						"(7\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4",
						[
							"7"
						],
						0,
						0,
						"$1 $2 $3 $4"
					],
					[
						"(77)(\\d{2})(\\d{2})",
						"$1-$2$3",
						[
							"77"
						],
						0,
						0,
						"$1 $2 $3"
					],
					[
						"(20)(\\d{2,3})(\\d{2})",
						"$1-$2 $3",
						[
							"20"
						],
						0,
						0,
						"$1 $2 $3"
					],
					[
						"(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})",
						"$1-$2 $3 $4",
						[
							"9[034]"
						],
						0,
						0,
						"$1 $2 $3 $4"
					],
					[
						"(9[034]\\d)(\\d{4})",
						"$1-$2",
						[
							"9[034]"
						],
						0,
						0,
						"$1 $2"
					],
					[
						"(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1-$2 $3 $4 $5",
						[
							"25[245]|67[3-6]"
						],
						0,
						0,
						"$1 $2 $3 $4 $5"
					]
				],
				"0",
				"0$1"
			],
			"SG": [
				"65",
				"0[0-3]\\d",
				"[36]\\d{7}|[17-9]\\d{7,10}",
				[
					8,
					10,
					11
				],
				[
					[
						"([3689]\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[369]|8[1-9]"
						]
					],
					[
						"(1[89]00)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1[89]0",
							"1[89]00"
						]
					],
					[
						"(7000)(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"700",
							"7000"
						]
					],
					[
						"(800)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				]
			],
			"SH": [
				"290",
				"00",
				"[256]\\d{4}|8\\d{3}",
				[
					4,
					5
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"2(?:[0-57-9]\\d|6[4-9])\\d{2}"
					],
					[
						"[56]\\d{4}",
						[
							5
						]
					],
					0,
					0,
					0,
					0,
					0,
					0,
					[
						"262\\d{2}",
						[
							5
						]
					]
				]
			],
			"SI": [
				"386",
				"00",
				"[1-7]\\d{6,7}|[89]\\d{4,7}",
				[
					5,
					6,
					7,
					8
				],
				[
					[
						"(\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[12]|[34][24-8]|5[2-8]|7[3-8]"
						],
						"(0$1)"
					],
					[
						"([3-7]\\d)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[37][01]|4[0139]|51|6"
						]
					],
					[
						"([89][09])(\\d{3,6})",
						"$1 $2",
						[
							"[89][09]"
						]
					],
					[
						"([58]\\d{2})(\\d{5})",
						"$1 $2",
						[
							"59|8[1-3]"
						]
					]
				],
				"0",
				"0$1"
			],
			"SJ": [
				"47",
				"00",
				"0\\d{4}|[45789]\\d{7}",
				[
					5,
					8
				],
				[
					[
						"([489]\\d{2})(\\d{2})(\\d{3})",
						"$1 $2 $3",
						[
							"[489]"
						]
					],
					[
						"([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[235-7]"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"79\\d{6}",
						[
							8
						]
					],
					[
						"(?:4[015-8]|5[89]|9\\d)\\d{6}",
						[
							8
						]
					],
					[
						"80[01]\\d{5}",
						[
							8
						]
					],
					[
						"82[09]\\d{5}",
						[
							8
						]
					],
					[
						"880\\d{5}",
						[
							8
						]
					],
					0,
					[
						"0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}"
					],
					0,
					[
						"85[0-5]\\d{5}",
						[
							8
						]
					],
					[
						"810(?:0[0-6]|[2-8]\\d)\\d{3}",
						[
							8
						]
					]
				]
			],
			"SK": [
				"421",
				"00",
				"(?:[2-68]\\d{5,8}|9\\d{6,8})",
				[
					6,
					7,
					9
				],
				[
					[
						"(2)(1[67])(\\d{3,4})",
						"$1 $2 $3",
						[
							"21[67]"
						]
					],
					[
						"([3-5]\\d)(\\d{2})(\\d{2,3})",
						"$1 $2 $3",
						[
							"[3-5]"
						]
					],
					[
						"(2)(\\d{3})(\\d{3})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"2"
						]
					],
					[
						"([3-5]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1/$2 $3 $4",
						[
							"[3-5]"
						]
					],
					[
						"([689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[689]"
						]
					],
					[
						"(9090)(\\d{3})",
						"$1 $2",
						[
							"909",
							"9090"
						]
					]
				],
				"0",
				"0$1"
			],
			"SL": [
				"232",
				"00",
				"[2-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{6})",
						"$1 $2"
					]
				],
				"0",
				"(0$1)"
			],
			"SM": [
				"378",
				"00",
				"[05-7]\\d{7,9}",
				[
					8,
					10
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[5-7]"
						]
					],
					[
						"(0549)(\\d{6})",
						"$1 $2",
						[
							"054",
							"0549"
						],
						0,
						0,
						"($1) $2"
					],
					[
						"(\\d{6})",
						"0549 $1",
						[
							"[89]"
						],
						0,
						0,
						"(0549) $1"
					]
				],
				0,
				0,
				"([89]\\d{5})",
				"0549$1"
			],
			"SN": [
				"221",
				"00",
				"[3789]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[379]"
						]
					],
					[
						"(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8"
						]
					]
				]
			],
			"SO": [
				"252",
				"00",
				"[1-9]\\d{5,8}",
				[
					6,
					7,
					8,
					9
				],
				[
					[
						"(\\d{6})",
						"$1",
						[
							"[134]"
						]
					],
					[
						"(\\d)(\\d{6})",
						"$1 $2",
						[
							"[13-5]|2[0-79]"
						]
					],
					[
						"(\\d)(\\d{7})",
						"$1 $2",
						[
							"24|[67]"
						]
					],
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						[
							"8[125]"
						]
					],
					[
						"(\\d{2})(\\d{5,7})",
						"$1 $2",
						[
							"15|28|6[1-35-9]|799|9[2-9]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"3[59]|4[89]|6[24-6]|79|8[08]|90"
						]
					]
				],
				"0"
			],
			"SR": [
				"597",
				"00",
				"[2-8]\\d{5,6}",
				[
					6,
					7
				],
				[
					[
						"(\\d{3})(\\d{3})",
						"$1-$2",
						[
							"[2-4]|5[2-58]"
						]
					],
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1-$2-$3",
						[
							"56"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1-$2",
						[
							"[6-8]"
						]
					]
				]
			],
			"SS": [
				"211",
				"00",
				"[19]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						0,
						"0$1"
					]
				],
				"0"
			],
			"ST": [
				"239",
				"00",
				"[29]\\d{6}",
				[
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2"
					]
				]
			],
			"SV": [
				"503",
				"00",
				"[267]\\d{7}|[89]\\d{6}(?:\\d{4})?",
				[
					7,
					8,
					11
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[267]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				]
			],
			"SX": [
				"1",
				"011",
				"[5789]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"721"
			],
			"SY": [
				"963",
				"00",
				"[1-59]\\d{7,8}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-5]"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				1
			],
			"SZ": [
				"268",
				"00",
				"[0237]\\d{7}|900\\d{6}",
				[
					8,
					9
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[0237]"
						]
					],
					[
						"(\\d{5})(\\d{4})",
						"$1 $2",
						[
							"900"
						]
					]
				]
			],
			"TA": [
				"290",
				"00",
				"8\\d{3}",
				[
					4
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"8\\d{3}"
					]
				]
			],
			"TC": [
				"1",
				"011",
				"[5689]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"649"
			],
			"TD": [
				"235",
				"00|16",
				"[2679]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4"
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				0,
				"00"
			],
			"TG": [
				"228",
				"00",
				"[279]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[279]"
						]
					]
				]
			],
			"TH": [
				"66",
				"00[1-9]",
				"1\\d{8,9}|[2-9]\\d{7,8}",
				[
					8,
					9,
					10
				],
				[
					[
						"(2)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"2"
						]
					],
					[
						"([13-9]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"14|[3-9]"
						]
					],
					[
						"(1[89]00)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"1[89]0",
							"1[89]00"
						],
						"$1"
					]
				],
				"0",
				"0$1"
			],
			"TJ": [
				"992",
				"810",
				"[3-57-9]\\d{8}",
				[
					9
				],
				[
					[
						"([349]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[34]7|91[78]"
						]
					],
					[
						"([457-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"4[148]|[578]|9(?:[0235-9]|1[59])"
						]
					],
					[
						"(331700)(\\d)(\\d{2})",
						"$1 $2 $3",
						[
							"331",
							"3317",
							"33170",
							"331700"
						]
					],
					[
						"(\\d{4})(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"3[1-5]",
							"3(?:[1245]|3(?:[02-9]|1[0-589]))"
						]
					]
				],
				"8",
				0,
				0,
				0,
				1,
				0,
				0,
				"8~10"
			],
			"TK": [
				"690",
				"00",
				"[2-47]\\d{3,6}",
				[
					4,
					5,
					6,
					7
				]
			],
			"TL": [
				"670",
				"00",
				"[2-489]\\d{6}|7\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[2-489]|70"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"7[3-8]"
						]
					]
				]
			],
			"TM": [
				"993",
				"810",
				"[1-6]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"12"
						]
					],
					[
						"(\\d{2})(\\d{6})",
						"$1 $2",
						[
							"6"
						],
						"8 $1"
					],
					[
						"(\\d{3})(\\d)(\\d{2})(\\d{2})",
						"$1 $2-$3-$4",
						[
							"13|[2-5]"
						]
					]
				],
				"8",
				"(8 $1)",
				0,
				0,
				0,
				0,
				0,
				"8~10"
			],
			"TN": [
				"216",
				"00",
				"[2-57-9]\\d{7}",
				[
					8
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				]
			],
			"TO": [
				"676",
				"00",
				"[02-8]\\d{4,6}",
				[
					5,
					7
				],
				[
					[
						"(\\d{2})(\\d{3})",
						"$1-$2",
						[
							"[1-6]|7[0-4]|8[05]"
						]
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"7[5-9]|8[46-9]"
						]
					],
					[
						"(\\d{4})(\\d{3})",
						"$1 $2",
						[
							"0"
						]
					]
				]
			],
			"TR": [
				"90",
				"00",
				"[2-589]\\d{9}|444\\d{4}",
				[
					7,
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[23]|4(?:[0-35-9]|4[0-35-9])"
						],
						"(0$1)"
					],
					[
						"(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"5(?:[02-69]|1[06])"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"51|[89]"
						],
						"0$1"
					],
					[
						"(444)(\\d{1})(\\d{3})",
						"$1 $2 $3",
						[
							"444"
						]
					]
				],
				"0",
				0,
				0,
				0,
				1
			],
			"TT": [
				"1",
				"011",
				"[589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"868"
			],
			"TV": [
				"688",
				"00",
				"[279]\\d{4,6}",
				[
					5,
					6,
					7
				]
			],
			"TW": [
				"886",
				"0(?:0[25679]|19)",
				"2\\d{6,8}|[3-689]\\d{7,8}|7\\d{7,9}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"(20)(\\d)(\\d{4})",
						"$1 $2 $3",
						[
							"202"
						]
					],
					[
						"([258]0)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"20[013-9]|50[0-46-9]|80[0-79]"
						]
					],
					[
						"([2-8])(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"[25][2-8]|[346]|[78][1-9]"
						]
					],
					[
						"(9\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9"
						]
					],
					[
						"(70)(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"70"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				0,
				0,
				"#"
			],
			"TZ": [
				"255",
				"00[056]",
				"\\d{9}",
				[
					7,
					9
				],
				[
					[
						"([24]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[24]"
						]
					],
					[
						"([67]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[67]"
						]
					],
					[
						"([89]\\d{2})(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[89]"
						]
					]
				],
				"0",
				"0$1"
			],
			"UA": [
				"380",
				"00",
				"[3-9]\\d{8}",
				[
					9
				],
				[
					[
						"([3-9]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]",
							"[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"
						]
					],
					[
						"([3-689]\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90",
							"3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"
						]
					],
					[
						"([3-6]\\d{3})(\\d{5})",
						"$1 $2",
						[
							"3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])",
							"3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"
						]
					]
				],
				"0",
				"0$1",
				0,
				0,
				0,
				0,
				0,
				"0~0"
			],
			"UG": [
				"256",
				"00[057]",
				"\\d{9}",
				[
					9
				],
				[
					[
						"(\\d{3})(\\d{6})",
						"$1 $2",
						[
							"20[0-8]|4(?:6[45]|[7-9])|[7-9]",
							"20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"
						]
					],
					[
						"(\\d{2})(\\d{7})",
						"$1 $2",
						[
							"3|4(?:[1-5]|6[0-36-9])"
						]
					],
					[
						"(2024)(\\d{5})",
						"$1 $2",
						[
							"202",
							"2024"
						]
					]
				],
				"0",
				"0$1"
			],
			"US": [
				"1",
				"011",
				"[2-9]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				1,
				0,
				[
					[
						"(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[16]|5[017]|6[0-279]|78|8[012])|7(?:0[1-46-8]|1[02-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-258]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[014678]|4[0179]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"
					],
					[
						""
					],
					[
						"8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
					],
					[
						"900[2-9]\\d{6}"
					],
					[
						"5(?:(?:00|22|33|44|66|77|88)[2-9]|21[23])\\d{6}"
					]
				]
			],
			"UY": [
				"598",
				"0(?:1[3-9]\\d|0)",
				"[2489]\\d{6,7}",
				[
					7,
					8
				],
				[
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"[24]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"9[1-9]"
						],
						"0$1"
					],
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[89]0"
						],
						"0$1"
					]
				],
				"0",
				0,
				0,
				0,
				0,
				0,
				0,
				"00",
				" int. "
			],
			"UZ": [
				"998",
				"810",
				"[679]\\d{8}",
				[
					9
				],
				[
					[
						"([679]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[679]"
						]
					]
				],
				"8",
				"8 $1",
				0,
				0,
				0,
				0,
				0,
				"8~10"
			],
			"VA": [
				"39",
				"00",
				"(?:0(?:878\\d{5}|6698\\d{5})|[1589]\\d{5,10}|3(?:[12457-9]\\d{8}|[36]\\d{7,9}))",
				[
					6,
					8,
					9,
					10,
					11
				],
				[
					[
						"(\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[26]|55"
						]
					],
					[
						"(0[26])(\\d{4})(\\d{5})",
						"$1 $2 $3",
						[
							"0[26]"
						]
					],
					[
						"(0[26])(\\d{4,6})",
						"$1 $2",
						[
							"0[26]"
						]
					],
					[
						"(0\\d{2})(\\d{3,4})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][0159]"
						]
					],
					[
						"(\\d{3})(\\d{3,6})",
						"$1 $2",
						[
							"0[13-57-9][0159]|8(?:03|4[17]|9[245])",
							"0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"
						]
					],
					[
						"(0\\d{3})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(0\\d{3})(\\d{2,6})",
						"$1 $2",
						[
							"0[13-57-9][2-46-8]"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[13]|8(?:00|4[08]|9[59])",
							"[13]|8(?:00|4[08]|9(?:5[5-9]|9))"
						]
					],
					[
						"(\\d{4})(\\d{4})",
						"$1 $2",
						[
							"894",
							"894[5-9]"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"3"
						]
					]
				],
				0,
				0,
				0,
				0,
				0,
				0,
				[
					[
						"06698\\d{5}",
						[
							10
						]
					],
					[
						"3(?:[12457-9]\\d{8}|6\\d{7,8}|3\\d{7,9})",
						[
							9,
							10,
							11
						]
					],
					[
						"80(?:0\\d{6}|3\\d{3})",
						[
							6,
							9
						]
					],
					[
						"0878\\d{5}|1(?:44|6[346])\\d{6}|89(?:2\\d{3}|4(?:[0-4]\\d{2}|[5-9]\\d{4})|5(?:[0-4]\\d{2}|[5-9]\\d{6})|9\\d{6})",
						[
							6,
							8,
							9,
							10
						]
					],
					[
						"1(?:78\\d|99)\\d{6}",
						[
							9,
							10
						]
					],
					0,
					0,
					0,
					[
						"55\\d{8}",
						[
							10
						]
					],
					[
						"84(?:[08]\\d{6}|[17]\\d{3})",
						[
							6,
							9
						]
					]
				]
			],
			"VC": [
				"1",
				"011",
				"[5789]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"784"
			],
			"VE": [
				"58",
				"00",
				"[24589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{7})",
						"$1-$2"
					]
				],
				"0",
				"0$1"
			],
			"VG": [
				"1",
				"011",
				"[2589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"284"
			],
			"VI": [
				"1",
				"011",
				"[3589]\\d{9}",
				[
					10
				],
				[
					[
						"(\\d{3})(\\d{3})(\\d{4})",
						"($1) $2-$3",
						0,
						0,
						0,
						"$1-$2-$3"
					]
				],
				"1",
				0,
				0,
				0,
				0,
				"340"
			],
			"VN": [
				"84",
				"00",
				"1\\d{6,9}|2\\d{9}|6\\d{6,7}|7\\d{6}|8\\d{6,8}|9\\d{8}",
				[
					7,
					8,
					9,
					10
				],
				[
					[
						"([17]99)(\\d{4})",
						"$1 $2",
						[
							"[17]99"
						]
					],
					[
						"(\\d{2})(\\d{4})(\\d{4})",
						"$1 $2 $3",
						[
							"2[48]"
						]
					],
					[
						"(80)(\\d{5})",
						"$1 $2",
						[
							"80"
						]
					],
					[
						"(69\\d)(\\d{4,5})",
						"$1 $2",
						[
							"69"
						]
					],
					[
						"(\\d{3})(\\d{4})(\\d{3})",
						"$1 $2 $3",
						[
							"2[0-35-79]"
						]
					],
					[
						"([89]\\d)(\\d{3})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"8(?:8|9[89])|9"
						]
					],
					[
						"(1[2689]\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"1(?:[26]|8[68]|99)"
						]
					],
					[
						"(86[89])(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"86[89]"
						]
					],
					[
						"(1[89]00)(\\d{4,6})",
						"$1 $2",
						[
							"1[89]0",
							"1[89]00"
						],
						"$1"
					]
				],
				"0",
				"0$1",
				0,
				0,
				1
			],
			"VU": [
				"678",
				"00",
				"[2-57-9]\\d{4,6}",
				[
					5,
					7
				],
				[
					[
						"(\\d{3})(\\d{4})",
						"$1 $2",
						[
							"[579]"
						]
					]
				]
			],
			"WF": [
				"681",
				"00",
				"[4-8]\\d{5}",
				[
					6
				],
				[
					[
						"(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3"
					]
				]
			],
			"WS": [
				"685",
				"0",
				"[2-578]\\d{4,9}|6[1-9]\\d{3}",
				[
					5,
					6,
					7,
					10
				],
				[
					[
						"(8\\d{2})(\\d{3,7})",
						"$1 $2",
						[
							"8"
						]
					],
					[
						"(7\\d)(\\d{5})",
						"$1 $2",
						[
							"7"
						]
					],
					[
						"(\\d{5})",
						"$1",
						[
							"[2-6]"
						]
					]
				]
			],
			"XK": [
				"383",
				"00",
				"[23][89]\\d{6,7}|4[3-79]\\d{6}|[89]00\\d{5}",
				[
					8,
					9
				],
				[
					[
						"(\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"[23][89]|4[3-79]"
						]
					],
					[
						"(\\d{3})(\\d{5})",
						"$1 $2",
						[
							"[89]00"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3})",
						"$1 $2 $3"
					]
				],
				"0",
				"0$1"
			],
			"YE": [
				"967",
				"00",
				"[1-7]\\d{6,8}",
				[
					7,
					8,
					9
				],
				[
					[
						"([1-7])(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[1-6]|7[24-68]"
						]
					],
					[
						"(7\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"7[0137]"
						]
					]
				],
				"0",
				"0$1"
			],
			"YT": [
				"262",
				"00",
				"[268]\\d{8}",
				[
					9
				],
				[
					[
						"([268]\\d{2})(\\d{2})(\\d{2})(\\d{2})",
						"$1 $2 $3 $4",
						[
							"[268]"
						]
					]
				],
				"0",
				0,
				0,
				0,
				0,
				"269|63"
			],
			"ZA": [
				"27",
				"00",
				"[1-79]\\d{8}|8\\d{4,8}",
				[
					5,
					6,
					7,
					8,
					9
				],
				[
					[
						"(860)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"860"
						]
					],
					[
						"(\\d{2})(\\d{3,4})",
						"$1 $2",
						[
							"8[1-4]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{2,3})",
						"$1 $2 $3",
						[
							"8[1-4]"
						]
					],
					[
						"(\\d{2})(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-79]|8(?:[0-57]|6[1-9])"
						]
					]
				],
				"0",
				"0$1"
			],
			"ZM": [
				"260",
				"00",
				"[289]\\d{8}",
				[
					9
				],
				[
					[
						"(\\d{2})(\\d{4})",
						"$1 $2",
						0,
						"$1"
					],
					[
						"([1-8])(\\d{2})(\\d{4})",
						"$1 $2 $3",
						[
							"[1-8]"
						],
						"$1"
					],
					[
						"([29]\\d)(\\d{7})",
						"$1 $2",
						[
							"[29]"
						]
					],
					[
						"(800)(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"800"
						]
					]
				],
				"0",
				"0$1"
			],
			"ZW": [
				"263",
				"00",
				"2(?:[0-57-9]\\d{3,8}|6(?:[14]\\d{7}|\\d{4}))|[13-69]\\d{4,9}|7\\d{8}|8[06]\\d{5,8}",
				[
					5,
					6,
					7,
					8,
					9,
					10
				],
				[
					[
						"([49])(\\d{3})(\\d{2,4})",
						"$1 $2 $3",
						[
							"4|9[2-9]"
						]
					],
					[
						"(7\\d)(\\d{3})(\\d{4})",
						"$1 $2 $3",
						[
							"7"
						]
					],
					[
						"(86\\d{2})(\\d{3})(\\d{3})",
						"$1 $2 $3",
						[
							"86[24]"
						]
					],
					[
						"([2356]\\d{2})(\\d{3,5})",
						"$1 $2",
						[
							"2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"
						]
					],
					[
						"(\\d{3})(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"
						]
					],
					[
						"([1-356]\\d)(\\d{3,5})",
						"$1 $2",
						[
							"1[3-9]|2[02569]|3[0-69]|5[05689]|6"
						]
					],
					[
						"([235]\\d)(\\d{3})(\\d{3,4})",
						"$1 $2 $3",
						[
							"[23]9|54"
						]
					],
					[
						"([25]\\d{3})(\\d{3,5})",
						"$1 $2",
						[
							"(?:25|54)8",
							"258[23]|5483"
						]
					],
					[
						"(8\\d{3})(\\d{6})",
						"$1 $2",
						[
							"86"
						]
					],
					[
						"(80\\d)(\\d{4})",
						"$1 $2",
						[
							"80"
						]
					]
				],
				"0",
				"0$1"
			],
			"001": [
				"979",
				0,
				"\\d{9}",
				[
					9
				],
				[
					[
						"(\\d)(\\d{4})(\\d{4})",
						"$1 $2 $3"
					]
				]
			]
		}
	};

/***/ },
/* 961 */
/***/ function(module, exports) {

	exports = module.exports = stringify
	exports.getSerialize = serializer
	
	function stringify(obj, replacer, spaces, cycleReplacer) {
	  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
	}
	
	function serializer(replacer, cycleReplacer) {
	  var stack = [], keys = []
	
	  if (cycleReplacer == null) cycleReplacer = function(key, value) {
	    if (stack[0] === value) return "[Circular ~]"
	    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
	  }
	
	  return function(key, value) {
	    if (stack.length > 0) {
	      var thisPos = stack.indexOf(this)
	      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
	      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
	      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
	    }
	    else stack.push(value)
	
	    return replacer == null ? value : replacer.call(this, key, value)
	  }
	}


/***/ },
/* 962 */
/***/ function(module, exports) {

	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(99);
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;


/***/ },
/* 964 */
/***/ function(module, exports) {

	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.comment = null;


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64 = __webpack_require__(442);
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);
	    
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = __webpack_require__(445);
	JSZip.prototype.load = __webpack_require__(2309);
	JSZip.support = __webpack_require__(233);
	JSZip.defaults = __webpack_require__(964);
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = __webpack_require__(2307);
	
	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = __webpack_require__(443);
	module.exports = JSZip;


/***/ },
/* 966 */
/***/ function(module, exports) {

	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(963);
	var utils = __webpack_require__(99);
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig);
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var DataReader = __webpack_require__(963);
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	    }
	}
	Uint8ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	Uint8ArrayReader.prototype.byteAt = function(i) {
	    return this.data[i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.DIGIT_PLACEHOLDER = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // This is an enhanced port of Google Android `libphonenumber`'s
	// `asyoutypeformatter.js` of 17th November, 2016.
	//
	// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js
	
	exports.close_dangling_braces = close_dangling_braces;
	exports.count_occurences = count_occurences;
	exports.repeat = repeat;
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _common = __webpack_require__(127);
	
	var _parse = __webpack_require__(150);
	
	var _format = __webpack_require__(448);
	
	var _types = __webpack_require__(306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Used in phone number format template creation.
	// Could be any digit, I guess.
	var DUMMY_DIGIT = '9';
	var DUMMY_DIGIT_MATCHER = new RegExp(DUMMY_DIGIT, 'g');
	// I don't know why is it exactly `15`
	var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
	// Create a phone number consisting only of the digit 9 that matches the
	// `number_pattern` by applying the pattern to the "longest phone number" string.
	var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);
	
	// The digits that have not been entered yet will be represented by a \u2008,
	// the punctuation space.
	var DIGIT_PLACEHOLDER = exports.DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
	var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);
	var DIGIT_PLACEHOLDER_MATCHER_GLOBAL = new RegExp(DIGIT_PLACEHOLDER, 'g');
	
	// A pattern that is used to match character classes in regular expressions.
	// An example of a character class is "[1-4]".
	var CHARACTER_CLASS_PATTERN = /\[([^\[\]])*\]/g;
	
	// Any digit in a regular expression that actually denotes a digit. For
	// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
	// (8 and 0) are standalone digits, but the rest are not.
	// Two look-aheads are needed because the number following \\d could be a
	// two-digit number, since the phone number can be as long as 15 digits.
	var STANDALONE_DIGIT_PATTERN = /\d(?=[^,}][^,}])/g;
	
	// A pattern that is used to determine if a `format` is eligible
	// to be used by the "as you type formatter".
	// It is eligible when the `format` contains groups of the dollar sign
	// followed by a single digit, separated by valid phone number punctuation.
	// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
	// getting into the output of the "as you type formatter".
	var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + _common.VALID_PUNCTUATION + ']*' + '(\\$\\d[' + _common.VALID_PUNCTUATION + ']*)+' + '$');
	
	// This is the minimum length of the leading digits of a phone number
	// to guarantee the first "leading digits pattern" for a phone number format
	// to be preemptive.
	var MIN_LEADING_DIGITS_LENGTH = 3;
	
	var VALID_INCOMPLETE_PHONE_NUMBER = '[' + _common.PLUS_CHARS + ']{0,1}' + '[' + _common.VALID_PUNCTUATION + _common.VALID_DIGITS + ']*';
	
	var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i');
	
	var AsYouType = function () {
	
		/**
	  * @param {string} [country_code] - The default country used for parsing non-international phone numbers.
	  * @param {Object} metadata
	  */
		function AsYouType(country_code, metadata) {
			_classCallCheck(this, AsYouType);
	
			this.options = {};
	
			this.metadata = new _metadata2.default(metadata);
	
			if (country_code && this.metadata.hasCountry(country_code)) {
				this.default_country = country_code;
			}
	
			this.reset();
		}
		// Not setting `options` to a constructor argument
		// not to break backwards compatibility
		// for older versions of the library.
	
	
		_createClass(AsYouType, [{
			key: 'input',
			value: function input(text) {
				// Parse input
	
				var extracted_number = (0, _parse.extract_formatted_phone_number)(text) || '';
	
				// Special case for a lone '+' sign
				// since it's not considered a possible phone number.
				if (!extracted_number) {
					if (text && text.indexOf('+') >= 0) {
						extracted_number = '+';
					}
				}
	
				// Validate possible first part of a phone number
				if (!(0, _common.matches_entirely)(extracted_number, VALID_INCOMPLETE_PHONE_NUMBER_PATTERN)) {
					return this.current_output;
				}
	
				return this.process_input((0, _common.parse_phone_number_digits)(extracted_number));
			}
		}, {
			key: 'process_input',
			value: function process_input(input) {
				// If an out of position '+' sign detected
				// (or a second '+' sign),
				// then just drop it from the input.
				if (input[0] === '+') {
					if (!this.parsed_input) {
						this.parsed_input += '+';
	
						// If a default country was set
						// then reset it because an explicitly international
						// phone number is being entered
						this.reset_countriness();
					}
	
					input = input.slice(1);
				}
	
				// Raw phone number
				this.parsed_input += input;
	
				// // Reset phone number validation state
				// this.valid = false
	
				// Add digits to the national number
				this.national_number += input;
	
				// TODO: Deprecated: rename `this.national_number`
				// to `this.nationalNumber` and remove `.getNationalNumber()`.
	
				// Try to format the parsed input
	
				if (this.is_international()) {
					if (!this.countryCallingCode) {
						// No need to format anything
						// if there's no national phone number.
						// (e.g. just the country calling code)
						if (!this.national_number) {
							// Return raw phone number
							return this.parsed_input;
						}
	
						// If one looks at country phone codes
						// then he can notice that no one country phone code
						// is ever a (leftmost) substring of another country phone code.
						// So if a valid country code is extracted so far
						// then it means that this is the country code.
	
						// If no country phone code could be extracted so far,
						// then just return the raw phone number,
						// because it has no way of knowing
						// how to format the phone number so far.
						if (!this.extract_country_calling_code()) {
							// Return raw phone number
							return this.parsed_input;
						}
	
						// Initialize country-specific data
						this.initialize_phone_number_formats_for_this_country_calling_code();
						this.reset_format();
						this.determine_the_country();
					}
					// `this.country` could be `undefined`,
					// for instance, when there is ambiguity
					// in a form of several different countries
					// each corresponding to the same country phone code
					// (e.g. NANPA: USA, Canada, etc),
					// and there's not enough digits entered
					// to reliably determine the country
					// the phone number belongs to.
					// Therefore, in cases of such ambiguity,
					// each time something is input,
					// try to determine the country
					// (if it's not determined yet).
					else if (!this.country) {
							this.determine_the_country();
						}
				} else {
					// Some national prefixes are substrings of other national prefixes
					// (for the same country), therefore try to extract national prefix each time
					// because a longer national prefix might be available at some point in time.
	
					var previous_national_prefix = this.national_prefix;
					this.national_number = this.national_prefix + this.national_number;
	
					// Possibly extract a national prefix
					this.extract_national_prefix();
	
					if (this.national_prefix !== previous_national_prefix) {
						// National number has changed
						// (due to another national prefix been extracted)
						// therefore national number has changed
						// therefore reset all previous formatting data.
						// (and leading digits matching state)
						this.matching_formats = this.available_formats;
						this.reset_format();
					}
				}
	
				if (!this.should_format()) {
					return this.format_as_non_formatted_number();
				}
	
				// Check the available phone number formats
				// based on the currently available leading digits.
				this.match_formats_by_leading_digits();
	
				// Format the phone number (given the next digits)
				var formatted_national_phone_number = this.format_national_phone_number(input);
	
				// If the phone number could be formatted,
				// then return it, possibly prepending with country phone code
				// (for international phone numbers only)
				if (formatted_national_phone_number) {
					return this.full_phone_number(formatted_national_phone_number);
				}
	
				// If the phone number couldn't be formatted,
				// then just fall back to the raw phone number.
				return this.parsed_input;
			}
		}, {
			key: 'format_as_non_formatted_number',
			value: function format_as_non_formatted_number() {
				if (this.is_international() && this.countryCallingCode) {
					if (this.national_number) {
						// For convenience, the public `.template` property
						// contains the whole international number
						// if the phone number being input is international:
						// 'x' for the '+' sign, 'x'es for the country phone code,
						// a spacebar and then the template for the national number digits.
						this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + repeat(DIGIT_PLACEHOLDER, this.national_number.length);
	
						return '+' + this.countryCallingCode + ' ' + this.national_number;
					}
	
					return '+' + this.countryCallingCode;
				}
	
				return this.parsed_input;
			}
		}, {
			key: 'format_national_phone_number',
			value: function format_national_phone_number(next_digits) {
				// Format the next phone number digits
				// using the previously chosen phone number format.
				//
				// This is done here because if `attempt_to_format_complete_phone_number`
				// was placed before this call then the `template`
				// wouldn't reflect the situation correctly (and would therefore be inconsistent)
				//
				var national_number_formatted_with_previous_format = void 0;
				if (this.chosen_format) {
					national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits);
				}
	
				// See if the input digits can be formatted properly already. If not,
				// use the results from format_next_national_number_digits(), which does formatting
				// based on the formatting pattern chosen.
	
				var formatted_number = this.attempt_to_format_complete_phone_number();
	
				// Just because a phone number doesn't have a suitable format
				// that doesn't mean that the phone is invalid
				// because phone number formats only format phone numbers,
				// they don't validate them and some (rare) phone numbers
				// are meant to stay non-formatted.
				if (formatted_number) {
					// if (this.country)
					// {
					// 	this.valid = true
					// }
	
					return formatted_number;
				}
	
				// For some phone number formats national prefix
	
				// If the previously chosen phone number format
				// didn't match the next (current) digit being input
				// (leading digits pattern didn't match).
				if (this.choose_another_format()) {
					// And a more appropriate phone number format
					// has been chosen for these `leading digits`,
					// then format the national phone number (so far)
					// using the newly selected phone number pattern.
	
					// Will return `undefined` if it couldn't format
					// the supplied national number
					// using the selected phone number pattern.
	
					return this.reformat_national_number();
				}
	
				// If could format the next (current) digit
				// using the previously chosen phone number format
				// then return the formatted number so far.
	
				// If no new phone number format could be chosen,
				// and couldn't format the supplied national number
				// using the selected phone number pattern,
				// then it will return `undefined`.
	
				return national_number_formatted_with_previous_format;
			}
		}, {
			key: 'reset',
			value: function reset() {
				// Input stripped of non-phone-number characters.
				// Can only contain a possible leading '+' sign and digits.
				this.parsed_input = '';
	
				this.current_output = '';
	
				// This contains the national prefix that has been extracted. It contains only
				// digits without formatting.
				this.national_prefix = '';
	
				this.national_number = '';
	
				this.reset_countriness();
	
				this.reset_format();
	
				// this.valid = false
	
				return this;
			}
		}, {
			key: 'reset_country',
			value: function reset_country() {
				if (this.is_international()) {
					this.country = undefined;
				} else {
					this.country = this.default_country;
				}
			}
		}, {
			key: 'reset_countriness',
			value: function reset_countriness() {
				this.reset_country();
	
				if (this.default_country && !this.is_international()) {
					this.metadata.country(this.default_country);
					this.countryCallingCode = this.metadata.countryCallingCode();
	
					this.initialize_phone_number_formats_for_this_country_calling_code();
				} else {
					this.metadata.country(undefined);
					this.countryCallingCode = undefined;
	
					this.available_formats = [];
					this.matching_formats = this.available_formats;
				}
			}
		}, {
			key: 'reset_format',
			value: function reset_format() {
				this.chosen_format = undefined;
				this.template = undefined;
				this.partially_populated_template = undefined;
				this.last_match_position = -1;
			}
	
			// Format each digit of national phone number (so far)
			// using the newly selected phone number pattern.
	
		}, {
			key: 'reformat_national_number',
			value: function reformat_national_number() {
				// Format each digit of national phone number (so far)
				// using the selected phone number pattern.
				return this.format_next_national_number_digits(this.national_number);
			}
		}, {
			key: 'initialize_phone_number_formats_for_this_country_calling_code',
			value: function initialize_phone_number_formats_for_this_country_calling_code() {
				// Get all "eligible" phone number formats for this country
				this.available_formats = this.metadata.formats().filter(function (format) {
					return ELIGIBLE_FORMAT_PATTERN.test(format.internationalFormat());
				});
	
				this.matching_formats = this.available_formats;
			}
		}, {
			key: 'match_formats_by_leading_digits',
			value: function match_formats_by_leading_digits() {
				var leading_digits = this.national_number;
	
				// "leading digits" pattern list starts with
				// one of a maximum length of 3 digits,
				// and then with each additional digit
				// a more precise "leading digits" pattern is specified.
	
				var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH;
	
				if (index_of_leading_digits_pattern < 0) {
					index_of_leading_digits_pattern = 0;
				}
	
				this.matching_formats = this.matching_formats.filter(function (format) {
					var leading_digits_pattern_count = format.leadingDigitsPatterns().length;
	
					// Keep everything that isn't restricted by leading digits.
					if (leading_digits_pattern_count === 0) {
						return true;
					}
	
					var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_pattern_count - 1);
					var leading_digits_pattern = format.leadingDigitsPatterns()[leading_digits_pattern_index];
	
					// Brackets are required for `^` to be applied to
					// all or-ed (`|`) parts, not just the first one.
					return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits);
				});
	
				// If there was a phone number format chosen
				// and it no longer holds given the new leading digits then reset it.
				// The test for this `if` condition is marked as:
				// "Reset a chosen format when it no longer holds given the new leading digits".
				// To construct a valid test case for this one can find a country
				// in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
				// and yielding another format for 4 `<leadingDigits>` (Australia in this case).
				if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
					this.reset_format();
				}
			}
		}, {
			key: 'should_format',
			value: function should_format() {
				// Start matching any formats at all when the national number
				// entered so far is at least 3 digits long,
				// otherwise format matching would give false negatives
				// like when the digits entered so far are `2`
				// and the leading digits pattern is `21` –
				// it's quite obvious in this case that the format could be the one
				// but due to the absence of further digits it would give false negative.
				//
				// Google could have provided leading digits patterns starting
				// with a single digit but they chose not to (for whatever reasons).
				//
				return this.national_number >= MIN_LEADING_DIGITS_LENGTH;
			}
	
			// Check to see if there is an exact pattern match for these digits. If so, we
			// should use this instead of any other formatting template whose
			// `leadingDigitsPattern` also matches the input.
	
		}, {
			key: 'attempt_to_format_complete_phone_number',
			value: function attempt_to_format_complete_phone_number() {
				for (var _iterator = this.matching_formats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
					var _ref;
	
					if (_isArray) {
						if (_i >= _iterator.length) break;
						_ref = _iterator[_i++];
					} else {
						_i = _iterator.next();
						if (_i.done) break;
						_ref = _i.value;
					}
	
					var format = _ref;
	
					var matcher = new RegExp('^(?:' + format.pattern() + ')$');
	
					if (!matcher.test(this.national_number)) {
						continue;
					}
	
					if (!this.is_format_applicable(format)) {
						continue;
					}
	
					// To leave the formatter in a consistent state
					this.reset_format();
					this.chosen_format = format;
	
					var formatted_number = (0, _format.format_national_number_using_format)(this.national_number, format, this.is_international(), this.national_prefix.length > 0, this.metadata);
	
					// Set `this.template` and `this.partially_populated_template`.
					//
					// `else` case doesn't ever happen
					// with the current metadata,
					// but just in case.
					//
					/* istanbul ignore else */
					if (this.create_formatting_template(format)) {
						// Populate `this.partially_populated_template`
						this.reformat_national_number();
					} else {
						// Prepend `+CountryCode` in case of an international phone number
						var full_number = this.full_phone_number(formatted_number);
						this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
						this.partially_populated_template = full_number;
					}
	
					return formatted_number;
				}
			}
	
			// Prepends `+CountryCode` in case of an international phone number
	
		}, {
			key: 'full_phone_number',
			value: function full_phone_number(formatted_national_number) {
				if (this.is_international()) {
					return '+' + this.countryCallingCode + ' ' + formatted_national_number;
				}
	
				return formatted_national_number;
			}
	
			// Extracts the country calling code from the beginning
			// of the entered `national_number` (so far),
			// and places the remaining input into the `national_number`.
	
		}, {
			key: 'extract_country_calling_code',
			value: function extract_country_calling_code() {
				var _parse_national_numbe = (0, _common.parse_national_number_and_country_calling_code)(this.parsed_input, this.default_country, this.metadata),
				    countryCallingCode = _parse_national_numbe.countryCallingCode,
				    number = _parse_national_numbe.number;
	
				if (!countryCallingCode) {
					return;
				}
	
				this.countryCallingCode = countryCallingCode;
				this.national_number = number;
	
				this.metadata.chooseCountryByCountryCallingCode(countryCallingCode);
				return this.metadata.selectedCountry() !== undefined;
			}
		}, {
			key: 'extract_national_prefix',
			value: function extract_national_prefix() {
				this.national_prefix = '';
	
				if (!this.metadata.selectedCountry()) {
					return;
				}
	
				// Only strip national prefixes for non-international phone numbers
				// because national prefixes can't be present in international phone numbers.
				// Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
				// first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
				// and then it would assume that's a valid number which it isn't.
				// So no forgiveness for grandmas here.
				// The issue asking for this fix:
				// https://github.com/catamphetamine/libphonenumber-js/issues/159
	
				var _strip_national_prefi = (0, _parse.strip_national_prefix_and_carrier_code)(this.national_number, this.metadata),
				    potential_national_number = _strip_national_prefi.number;
	
				// We require that the NSN remaining after stripping the national prefix and
				// carrier code be long enough to be a possible length for the region.
				// Otherwise, we don't do the stripping, since the original number could be
				// a valid short number.
	
	
				if (!this.metadata.possibleLengths() || this.is_possible_number(this.national_number) && !this.is_possible_number(potential_national_number)) {
					// Verify the parsed national (significant) number for this country
					var national_number_rule = new RegExp(this.metadata.nationalNumberPattern());
					//
					// If the original number (before stripping national prefix) was viable,
					// and the resultant number is not, then prefer the original phone number.
					// This is because for some countries (e.g. Russia) the same digit could be both
					// a national prefix and a leading digit of a valid national phone number,
					// like `8` is the national prefix for Russia and both
					// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
					if ((0, _common.matches_entirely)(this.national_number, national_number_rule) && !(0, _common.matches_entirely)(potential_national_number, national_number_rule)) {
						return;
					}
				}
	
				this.national_prefix = this.national_number.slice(0, this.national_number.length - potential_national_number.length);
				this.national_number = potential_national_number;
	
				return this.national_prefix;
			}
		}, {
			key: 'is_possible_number',
			value: function is_possible_number(number) {
				var validation_result = (0, _types.check_number_length_for_type)(number, undefined, this.metadata);
				switch (validation_result) {
					case 'IS_POSSIBLE':
						return true;
					// case 'IS_POSSIBLE_LOCAL_ONLY':
					// 	return !this.is_international()
					default:
						return false;
				}
			}
		}, {
			key: 'choose_another_format',
			value: function choose_another_format() {
				// When there are multiple available formats, the formatter uses the first
				// format where a formatting template could be created.
				for (var _iterator2 = this.matching_formats, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
					var _ref2;
	
					if (_isArray2) {
						if (_i2 >= _iterator2.length) break;
						_ref2 = _iterator2[_i2++];
					} else {
						_i2 = _iterator2.next();
						if (_i2.done) break;
						_ref2 = _i2.value;
					}
	
					var format = _ref2;
	
					// If this format is currently being used
					// and is still possible, then stick to it.
					if (this.chosen_format === format) {
						return;
					}
	
					// If this `format` is suitable for "as you type",
					// then extract the template from this format
					// and use it to format the phone number being input.
	
					if (!this.is_format_applicable(format)) {
						continue;
					}
	
					if (!this.create_formatting_template(format)) {
						continue;
					}
	
					this.chosen_format = format;
	
					// With a new formatting template, the matched position
					// using the old template needs to be reset.
					this.last_match_position = -1;
	
					return true;
				}
	
				// No format matches the phone number,
				// therefore set `country` to `undefined`
				// (or to the default country).
				this.reset_country();
	
				// No format matches the national phone number entered
				this.reset_format();
			}
		}, {
			key: 'is_format_applicable',
			value: function is_format_applicable(format) {
				// If national prefix is mandatory for this phone number format
				// and the user didn't input the national prefix,
				// then this phone number format isn't suitable.
				if (!this.is_international() && !this.national_prefix && format.nationalPrefixIsMandatoryWhenFormatting()) {
					return false;
				}
	
				return true;
			}
		}, {
			key: 'create_formatting_template',
			value: function create_formatting_template(format) {
				// The formatter doesn't format numbers when numberPattern contains '|', e.g.
				// (20|3)\d{4}. In those cases we quickly return.
				// (Though there's no such format in current metadata)
				/* istanbul ignore if */
				if (format.pattern().indexOf('|') >= 0) {
					return;
				}
	
				// Get formatting template for this phone number format
				var template = this.get_template_for_phone_number_format_pattern(format);
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (!template) {
					return;
				}
	
				// This one is for national number only
				this.partially_populated_template = template;
	
				// For convenience, the public `.template` property
				// contains the whole international number
				// if the phone number being input is international:
				// 'x' for the '+' sign, 'x'es for the country phone code,
				// a spacebar and then the template for the formatted national number.
				if (this.is_international()) {
					this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + template;
				}
				// For local numbers, replace national prefix
				// with a digit placeholder.
				else {
						this.template = template.replace(/\d/g, DIGIT_PLACEHOLDER);
					}
	
				// This one is for the full phone number
				return this.template;
			}
	
			// Generates formatting template for a phone number format
	
		}, {
			key: 'get_template_for_phone_number_format_pattern',
			value: function get_template_for_phone_number_format_pattern(format) {
				// A very smart trick by the guys at Google
				var number_pattern = format.pattern()
				// Replace anything in the form of [..] with \d
				.replace(CHARACTER_CLASS_PATTERN, '\\d')
				// Replace any standalone digit (not the one in `{}`) with \d
				.replace(STANDALONE_DIGIT_PATTERN, '\\d');
	
				// This match will always succeed,
				// because the "longest dummy phone number"
				// has enough length to accomodate any possible
				// national phone number format pattern.
				var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0];
	
				// If the national number entered is too long
				// for any phone number format, then abort.
				if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
					return;
				}
	
				// Prepare the phone number format
				var number_format = this.get_format_format(format);
	
				// Get a formatting template which can be used to efficiently format
				// a partial number where digits are added one by one.
	
				// Below `strict_pattern` is used for the
				// regular expression (with `^` and `$`).
				// This wasn't originally in Google's `libphonenumber`
				// and I guess they don't really need it
				// because they're not using "templates" to format phone numbers
				// but I added `strict_pattern` after encountering
				// South Korean phone number formatting bug.
				//
				// Non-strict regular expression bug demonstration:
				//
				// this.national_number : `111111111` (9 digits)
				//
				// number_pattern : (\d{2})(\d{3,4})(\d{4})
				// number_format : `$1 $2 $3`
				// dummy_phone_number_matching_format_pattern : `9999999999` (10 digits)
				//
				// '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
				//
				// template : xx xxxx xxxx
				//
				// But the correct template in this case is `xx xxx xxxx`.
				// The template was generated incorrectly because of the
				// `{3,4}` variability in the `number_pattern`.
				//
				// The fix is, if `this.national_number` has already sufficient length
				// to satisfy the `number_pattern` completely then `this.national_number` is used
				// instead of `dummy_phone_number_matching_format_pattern`.
	
				var strict_pattern = new RegExp('^' + number_pattern + '$');
				var national_number_dummy_digits = this.national_number.replace(/\d/g, DUMMY_DIGIT);
	
				// If `this.national_number` has already sufficient length
				// to satisfy the `number_pattern` completely then use it
				// instead of `dummy_phone_number_matching_format_pattern`.
				if (strict_pattern.test(national_number_dummy_digits)) {
					dummy_phone_number_matching_format_pattern = national_number_dummy_digits;
				}
	
				// Generate formatting template for this phone number format
				return dummy_phone_number_matching_format_pattern
				// Format the dummy phone number according to the format
				.replace(new RegExp(number_pattern), number_format)
				// Replace each dummy digit with a DIGIT_PLACEHOLDER
				.replace(DUMMY_DIGIT_MATCHER, DIGIT_PLACEHOLDER);
			}
		}, {
			key: 'format_next_national_number_digits',
			value: function format_next_national_number_digits(digits) {
				// Using `.split('')` to iterate through a string here
				// to avoid requiring `Symbol.iterator` polyfill.
				// `.split('')` is generally not safe for Unicode,
				// but in this particular case for `digits` it is safe.
				// for (const digit of digits)
				for (var _iterator3 = digits.split(''), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
					var _ref3;
	
					if (_isArray3) {
						if (_i3 >= _iterator3.length) break;
						_ref3 = _iterator3[_i3++];
					} else {
						_i3 = _iterator3.next();
						if (_i3.done) break;
						_ref3 = _i3.value;
					}
	
					var digit = _ref3;
	
					// If there is room for more digits in current `template`,
					// then set the next digit in the `template`,
					// and return the formatted digits so far.
	
					// If more digits are entered than the current format could handle
					if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
						// Reset the current format,
						// so that the new format will be chosen
						// in a subsequent `this.choose_another_format()` call
						// later in code.
						this.chosen_format = undefined;
						this.template = undefined;
						this.partially_populated_template = undefined;
						return;
					}
	
					this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER);
					this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
				}
	
				// Return the formatted phone number so far
				return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1).replace(DIGIT_PLACEHOLDER_MATCHER_GLOBAL, ' ');
			}
		}, {
			key: 'is_international',
			value: function is_international() {
				return this.parsed_input && this.parsed_input[0] === '+';
			}
		}, {
			key: 'get_format_format',
			value: function get_format_format(format) {
				if (this.is_international()) {
					return (0, _format.local_to_international_style)(format.internationalFormat());
				}
	
				// If national prefix formatting rule is set
				// for this phone number format
				if (format.nationalPrefixFormattingRule()) {
					// If the user did input the national prefix
					// (or if the national prefix formatting rule does not require national prefix)
					// then maybe make it part of the phone number template
					if (this.national_prefix || !format.usesNationalPrefix()) {
						// Make the national prefix part of the phone number template
						return format.format().replace(_format.FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule());
					}
				}
	
				return format.format();
			}
	
			// Determines the country of the phone number
			// entered so far based on the country phone code
			// and the national phone number.
	
		}, {
			key: 'determine_the_country',
			value: function determine_the_country() {
				this.country = (0, _parse.find_country_code)(this.countryCallingCode, this.national_number, this.metadata);
			}
		}, {
			key: 'getNationalNumber',
			value: function getNationalNumber() {
				return this.national_number;
			}
		}]);
	
		return AsYouType;
	}();
	
	exports.default = AsYouType;
	function close_dangling_braces(template, cut_before) {
		var retained_template = template.slice(0, cut_before);
	
		var opening_braces = count_occurences('(', retained_template);
		var closing_braces = count_occurences(')', retained_template);
	
		var dangling_braces = opening_braces - closing_braces;
	
		while (dangling_braces > 0 && cut_before < template.length) {
			if (template[cut_before] === ')') {
				dangling_braces--;
			}
			cut_before++;
		}
	
		return template.slice(0, cut_before);
	}
	
	// Counts all occurences of a symbol in a string.
	// Unicode-unsafe (because using `.split()`).
	function count_occurences(symbol, string) {
		var count = 0;
	
		// Using `.split('')` to iterate through a string here
		// to avoid requiring `Symbol.iterator` polyfill.
		// `.split('')` is generally not safe for Unicode,
		// but in this particular case for counting brackets it is safe.
		// for (const character of string)
		for (var _iterator4 = string.split(''), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
			var _ref4;
	
			if (_isArray4) {
				if (_i4 >= _iterator4.length) break;
				_ref4 = _iterator4[_i4++];
			} else {
				_i4 = _iterator4.next();
				if (_i4.done) break;
				_ref4 = _i4.value;
			}
	
			var character = _ref4;
	
			if (character === symbol) {
				count++;
			}
		}
	
		return count;
	}
	
	// Repeats a string (or a symbol) N times.
	// http://stackoverflow.com/questions/202605/repeat-string-javascript
	function repeat(string, times) {
		if (times < 1) {
			return '';
		}
	
		var result = '';
	
		while (times > 1) {
			if (times & 1) {
				result += string;
			}
	
			times >>= 1;
			string += string;
		}
	
		return result + string;
	}
	//# sourceMappingURL=AsYouType.js.map

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getIDDPrefix = getIDDPrefix;
	exports.stripIDDPrefix = stripIDDPrefix;
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _common = __webpack_require__(127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CAPTURING_DIGIT_PATTERN = new RegExp('([' + _common.VALID_DIGITS + '])');
	
	/**
	 * Pattern that makes it easy to distinguish whether a region has a single
	 * international dialing prefix or not. If a region has a single international
	 * prefix (e.g. 011 in USA), it will be represented as a string that contains
	 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
	 * the tone. If there are multiple available international prefixes in a
	 * region, they will be represented as a regex string that always contains one
	 * or more characters that are not ASCII digits or a tilde.
	 */
	var SINGLE_IDD_PREFIX = /[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?/;
	
	// export function isSingleIDDPrefix(IDDPrefix)
	// {
	// 	return matches_entirely(IDDPrefix, SINGLE_IDD_PREFIX)
	// }
	
	// For regions that have multiple IDD prefixes
	// a preferred IDD prefix is returned.
	function getIDDPrefix(country, metadata) {
		var countryMetadata = new _metadata2.default(metadata);
		countryMetadata.country(country);
	
		if ((0, _common.matches_entirely)(countryMetadata.IDDPrefix(), SINGLE_IDD_PREFIX)) {
			return countryMetadata.IDDPrefix();
		}
	
		return countryMetadata.defaultIDDPrefix();
	}
	
	function stripIDDPrefix(number, country, metadata) {
		if (!country) {
			return;
		}
	
		// Check if the number is IDD-prefixed.
	
		var countryMetadata = new _metadata2.default(metadata);
		countryMetadata.country(country);
	
		var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
	
		if (number.search(IDDPrefixPattern) !== 0) {
			return;
		}
	
		// Strip IDD prefix.
		number = number.slice(number.match(IDDPrefixPattern)[0].length);
	
		// Some kind of a weird edge case.
		// No explanation from Google given.
		var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
		/* istanbul ignore next */
		if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
			if (matchedGroups[1] === '0') {
				return;
			}
		}
	
		return number;
	}
	//# sourceMappingURL=IDD.js.map

/***/ },
/* 971 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.limit = limit;
	exports.trimAfterFirstMatch = trimAfterFirstMatch;
	exports.startsWith = startsWith;
	exports.endsWith = endsWith;
	/** Returns a regular expression quantifier with an upper and lower limit. */
	function limit(lower, upper) {
		if (lower < 0 || upper <= 0 || upper < lower) {
			throw new TypeError();
		}
		return "{" + lower + "," + upper + "}";
	}
	
	/**
	 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
	 * returning the trimmed version.
	 */
	function trimAfterFirstMatch(regexp, string) {
		var index = string.search(regexp);
	
		if (index >= 0) {
			return string.slice(0, index);
		}
	
		return string;
	}
	
	function startsWith(string, substring) {
		return string.indexOf(substring) === 0;
	}
	
	function endsWith(string, substring) {
		return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
	}
	//# sourceMappingURL=util.js.map

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = {}
	
	// Deprecated: remove `parse()` export in 2.0.0.
	// (renamed to `parseNumber()`)
	exports.parse              = __webpack_require__(150).default
	exports.parseNumber        = __webpack_require__(150).default
	// Deprecated: remove `format()` export in 2.0.0.
	// (renamed to `formatNumber()`)
	exports.format             = __webpack_require__(448).default
	exports.formatNumber       = __webpack_require__(448).default
	exports.getNumberType      = __webpack_require__(306).default
	exports.isValidNumber      = __webpack_require__(2321).default
	exports.findPhoneNumbers   = __webpack_require__(447).default
	exports.searchPhoneNumbers = __webpack_require__(447).searchPhoneNumbers
	exports.PhoneNumberSearch  = __webpack_require__(447).PhoneNumberSearch
	exports.AsYouType          = __webpack_require__(969).default
	
	// `DIGITS` are used by `react-phone-number-input`.
	// `DIGIT_PLACEHOLDER` is used by `react-phone-number-input`.
	exports.DIGITS            = __webpack_require__(127).DIGIT_MAPPINGS
	exports.DIGIT_PLACEHOLDER = __webpack_require__(969).DIGIT_PLACEHOLDER
	
	exports.getCountryCallingCode = __webpack_require__(2320).default
	// `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.
	exports.getPhoneCode = exports.getCountryCallingCode
	
	exports.Metadata = __webpack_require__(109).default
	exports.getExtPrefix = __webpack_require__(109).getExtPrefix
	
	exports.parseRFC3966 = __webpack_require__(305).parseRFC3966
	exports.formatRFC3966 = __webpack_require__(305).formatRFC3966
	
	// exports['default'] = ...

/***/ },
/* 973 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 974 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 975 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
	}
	
	module.exports = toPath;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 976 */
[3458, 308, 2415, 2416, 2417, 2418, 2419],
/* 977 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(985);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 979 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 980 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 981 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 982 */
[3467, 2345, 235],
/* 983 */
[3468, 456, 234],
/* 984 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.gt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is greater than `other`,
	 *  else `false`.
	 */
	function baseGt(value, other) {
	  return value > other;
	}
	
	module.exports = baseGt;


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(981),
	    baseIsNaN = __webpack_require__(2353),
	    strictIndexOf = __webpack_require__(2420);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 986 */
[3478, 993, 2409],
/* 987 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.lt` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if `value` is less than `other`,
	 *  else `false`.
	 */
	function baseLt(value, other) {
	  return value < other;
	}
	
	module.exports = baseLt;


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(310),
	    isArrayLike = __webpack_require__(111);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 989 */
[3487, 152],
/* 990 */
[3488, 451, 2337, 455],
/* 991 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 992 */
[3499, 456, 318, 36, 315, 461, 234],
/* 993 */
368,
/* 994 */
[3507, 87],
/* 995 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 996 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 997 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 998 */
[3520, 2333],
/* 999 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 1000 */
[3522, 2363, 2414],
/* 1001 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(87),
	    now = __webpack_require__(2445),
	    toNumber = __webpack_require__(1013);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(2347),
	    hasPath = __webpack_require__(992);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 1004 */
[3530, 111, 112],
/* 1005 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(311),
	    baseGt = __webpack_require__(984),
	    baseIteratee = __webpack_require__(85);
	
	/**
	 * This method is like `_.max` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.maxBy(objects, function(o) { return o.n; });
	 * // => { 'n': 2 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.maxBy(objects, 'n');
	 * // => { 'n': 2 }
	 */
	function maxBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
	    : undefined;
	}
	
	module.exports = maxBy;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(311),
	    baseLt = __webpack_require__(987),
	    identity = __webpack_require__(110);
	
	/**
	 * Computes the minimum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * _.min([4, 2, 8, 6]);
	 * // => 2
	 *
	 * _.min([]);
	 * // => undefined
	 */
	function min(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseLt)
	    : undefined;
	}
	
	module.exports = min;


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(2378);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(2362);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(312),
	    baseOrderBy = __webpack_require__(2358),
	    baseRest = __webpack_require__(454),
	    isIterateeCall = __webpack_require__(458);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(1013);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(1011);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 1013 */
[3543, 87, 155],
/* 1014 */
[3544, 2367],
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.storeShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  setState: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 1016 */
[3351, 8],
/* 1017 */
[3352, 8],
/* 1018 */
[3353, 8],
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 1020 */
[3354, 8],
/* 1021 */
[3355, 8],
/* 1022 */
[3356, 8],
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 1024 */
[3357, 8],
/* 1025 */
[3358, 8],
/* 1026 */
[3359, 8],
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	// Language contact person : Abdoufata Kane : https://github.com/abdoufata
	
	var bm = moment.defineLocale('bm', {
	    months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	    monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	    weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	    weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	    weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'MMMM [tile] D [san] YYYY',
	        LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bi lɛrɛ] LT',
	        nextDay : '[Sini lɛrɛ] LT',
	        nextWeek : 'dddd [don lɛrɛ] LT',
	        lastDay : '[Kunu lɛrɛ] LT',
	        lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s kɔnɔ',
	        past : 'a bɛ %s bɔ',
	        s : 'sanga dama dama',
	        m : 'miniti kelen',
	        mm : 'miniti %d',
	        h : 'lɛrɛ kelen',
	        hh : 'lɛrɛ %d',
	        d : 'tile kelen',
	        dd : 'tile %d',
	        M : 'kalo kelen',
	        MM : 'kalo %d',
	        y : 'san kelen',
	        yy : 'san %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return bm;
	
	})));


/***/ },
/* 1028 */
[3360, 8],
/* 1029 */
[3361, 8],
/* 1030 */
[3362, 8],
/* 1031 */
[3363, 8],
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : {
	        standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	        isFormat: /D[oD]?(\s)+MMMM/
	    },
	    monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [de] YYYY',
	        ll : 'D MMM YYYY',
	        LLL : 'D MMMM [de] YYYY [a les] H:mm',
	        lll : 'D MMM YYYY, H:mm',
	        LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	        llll : 'ddd D MMM YYYY, H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 1033 */
[3364, 8],
/* 1034 */
[3365, 8],
/* 1035 */
[3366, 8],
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay : '[i dag kl.] LT',
	        nextDay : '[i morgen kl.] LT',
	        nextWeek : 'på dddd [kl.] LT',
	        lastDay : '[i går kl.] LT',
	        lastWeek : '[i] dddd[s kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// based on: https://www.bk.admin.ch/dokumentation/sprachen/04915/05016/index.html?lang=de#
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deCh = moment.defineLocale('de-ch', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH.mm',
	        LTS: 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH.mm',
	        LLLL : 'dddd, D. MMMM YYYY HH.mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deCh;
	
	})));


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 1040 */
[3367, 8],
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return this._monthsNominativeEl;
	        } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 1042 */
[3368, 8],
/* 1043 */
[3369, 8],
/* 1044 */
[3370, 8],
/* 1045 */
[3371, 8],
/* 1046 */
[3372, 8],
/* 1047 */
[3373, 8],
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse: monthsParse,
	    longMonthsParse: monthsParse,
	    shortMonthsParse: monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish(United State) [es-us]
	//! author : bustta : https://github.com/bustta
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esUs = moment.defineLocale('es-us', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'MM/DD/YYYY',
	        LL : 'MMMM [de] D [de] YYYY',
	        LLL : 'MMMM [de] D [de] YYYY H:mm',
	        LLLL : 'dddd, MMMM [de] D [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return esUs;
	
	})));


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortDot;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsRegex : monthsRegex,
	    monthsShortRegex : monthsRegex,
	    monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	    monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 1051 */
[3374, 8],
/* 1052 */
[3375, 8],
/* 1053 */
[3376, 8],
/* 1054 */
[3377, 8],
/* 1055 */
[3378, 8],
/* 1056 */
[3379, 8],
/* 1057 */
[3380, 8],
/* 1058 */
[3381, 8],
/* 1059 */
[3382, 8],
/* 1060 */
[3383, 8],
/* 1061 */
[3384, 8],
/* 1062 */
[3385, 8],
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	        '1': '૧',
	        '2': '૨',
	        '3': '૩',
	        '4': '૪',
	        '5': '૫',
	        '6': '૬',
	        '7': '૭',
	        '8': '૮',
	        '9': '૯',
	        '0': '૦'
	    };
	var numberMap = {
	        '૧': '1',
	        '૨': '2',
	        '૩': '3',
	        '૪': '4',
	        '૫': '5',
	        '૬': '6',
	        '૭': '7',
	        '૮': '8',
	        '૯': '9',
	        '૦': '0'
	    };
	
	var gu = moment.defineLocale('gu', {
	    months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	    monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	    weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	    weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	    longDateFormat: {
	        LT: 'A h:mm વાગ્યે',
	        LTS: 'A h:mm:ss વાગ્યે',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	        LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	    },
	    calendar: {
	        sameDay: '[આજ] LT',
	        nextDay: '[કાલે] LT',
	        nextWeek: 'dddd, LT',
	        lastDay: '[ગઇકાલે] LT',
	        lastWeek: '[પાછલા] dddd, LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%s મા',
	        past: '%s પેહલા',
	        s: 'અમુક પળો',
	        m: 'એક મિનિટ',
	        mm: '%d મિનિટ',
	        h: 'એક કલાક',
	        hh: '%d કલાક',
	        d: 'એક દિવસ',
	        dd: '%d દિવસ',
	        M: 'એક મહિનો',
	        MM: '%d મહિનો',
	        y: 'એક વર્ષ',
	        yy: '%d વર્ષ'
	    },
	    preparse: function (string) {
	        return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'રાત') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'સવાર') {
	            return hour;
	        } else if (meridiem === 'બપોર') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'સાંજ') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'રાત';
	        } else if (hour < 10) {
	            return 'સવાર';
	        } else if (hour < 17) {
	            return 'બપોર';
	        } else if (hour < 20) {
	            return 'સાંજ';
	        } else {
	            return 'રાત';
	        }
	    },
	    week: {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return gu;
	
	})));


/***/ },
/* 1064 */
[3386, 8],
/* 1065 */
[3387, 8],
/* 1066 */
[3388, 8],
/* 1067 */
[3389, 8],
/* 1068 */
[3390, 8],
/* 1069 */
[3391, 8],
/* 1070 */
[3392, 8],
/* 1071 */
[3393, 8],
/* 1072 */
[3394, 8],
/* 1073 */
[3395, 8],
/* 1074 */
[3396, 8],
/* 1075 */
[3397, 8],
/* 1076 */
[3398, 8],
/* 1077 */
[3399, 8],
/* 1078 */
[3334, 8],
/* 1079 */
[3400, 8],
/* 1080 */
[3401, 8],
/* 1081 */
[3402, 8],
/* 1082 */
[3403, 8],
/* 1083 */
[3404, 8],
/* 1084 */
[3405, 8],
/* 1085 */
[3406, 8],
/* 1086 */
[3407, 8],
/* 1087 */
[3408, 8],
/* 1088 */
[3409, 8],
/* 1089 */
[3410, 8],
/* 1090 */
[3411, 8],
/* 1091 */
[3412, 8],
/* 1092 */
[3413, 8],
/* 1093 */
[3414, 8],
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 1096 */
[3415, 8],
/* 1097 */
[3416, 8],
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (!momentToFormat) {
	            return monthsNominative;
	        } else if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W niedzielę o] LT';
	
	                case 2:
	                    return '[We wtorek o] LT';
	
	                case 3:
	                    return '[W środę o] LT';
	
	                case 6:
	                    return '[W sobotę o] LT';
	
	                default:
	                    return '[W] dddd [o] LT';
	            }
	        },
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 1099 */
[3335, 8],
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 1101 */
[3417, 8],
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 1103 */
[3418, 8],
/* 1104 */
[3419, 8],
/* 1105 */
[3420, 8],
/* 1106 */
[3421, 8],
/* 1107 */
[3422, 8],
/* 1108 */
[3423, 8],
/* 1109 */
[3424, 8],
/* 1110 */
[3425, 8],
/* 1111 */
[3426, 8],
/* 1112 */
[3427, 8],
/* 1113 */
[3428, 8],
/* 1114 */
[3429, 8],
/* 1115 */
[3430, 8],
/* 1116 */
[3431, 8],
/* 1117 */
[3432, 8],
/* 1118 */
[3433, 8],
/* 1119 */
[3434, 8],
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(8)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[gelecek] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 1121 */
[3435, 8],
/* 1122 */
[3436, 8],
/* 1123 */
[3437, 8],
/* 1124 */
[3438, 8],
/* 1125 */
[3439, 8],
/* 1126 */
[3440, 8],
/* 1127 */
[3441, 8],
/* 1128 */
[3442, 8],
/* 1129 */
[3443, 8],
/* 1130 */
[3444, 8],
/* 1131 */
[3445, 8],
/* 1132 */
[3446, 8],
/* 1133 */
[3447, 8],
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var keys = __webpack_require__(467);
	var bind = __webpack_require__(302);
	var canBeObject = function (obj) {
		return typeof obj !== 'undefined' && obj !== null;
	};
	var hasSymbols = __webpack_require__(2464)();
	var toObject = Object;
	var push = bind.call(Function.call, Array.prototype.push);
	var propIsEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	module.exports = function assign(target, source1) {
		if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
		var objTarget = toObject(target);
		var s, source, i, props, syms, value, key;
		for (s = 1; s < arguments.length; ++s) {
			source = toObject(arguments[s]);
			props = keys(source);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				syms = getSymbols(source);
				for (i = 0; i < syms.length; ++i) {
					key = syms[i];
					if (propIsEnumerable(source, key)) {
						push(props, key);
					}
				}
			}
			for (i = 0; i < props.length; ++i) {
				key = props[i];
				value = source[key];
				if (propIsEnumerable(source, key)) {
					objTarget[key] = value;
				}
			}
		}
		return objTarget;
	};


/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1134);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		// v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		// note: this does not detect the bug unless there's 20 characters
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		// Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		// which is 72% slower than our shim, and Firefox 40's native implementation.
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(1984);
	var has = __webpack_require__(303);
	var bind = __webpack_require__(302);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function values(O) {
		var obj = ES.RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				vals.push(obj[key]);
			}
		}
		return vals;
	};


/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(224);
	
	var implementation = __webpack_require__(1136);
	var getPolyfill = __webpack_require__(1138);
	var shim = __webpack_require__(2466);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1136);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	// String encode/decode helpers
	'use strict';
	
	
	var utils = __webpack_require__(130);
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var q = 0; q < 256; q++) {
	  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
	}
	_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
	      c2 = str.charCodeAt(m_pos + 1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for (var i = 0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function (buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function (str) {
	  var buf = new utils.Buf8(str.length);
	  for (var i = 0, len = buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len * 2);
	
	  for (out = 0, i = 0; i < len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function (buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max - 1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};


/***/ },
/* 1140 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0,
	      s2 = ((adler >>> 16) & 0xffff) |0,
	      n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;


/***/ },
/* 1141 */
/***/ function(module, exports) {

	'use strict';
	
	
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};


/***/ },
/* 1142 */
/***/ function(module, exports) {

	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for (var n = 0; n < 256; n++) {
	    c = n;
	    for (var k = 0; k < 8; k++) {
	      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable,
	      end = pos + len;
	
	  crc ^= -1;
	
	  for (var i = pos; i < end; i++) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;


/***/ },
/* 1143 */
/***/ function(module, exports) {

	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;


/***/ },
/* 1144 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1145 */
/***/ function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	module.exports = {
	    'default': 'RFC3986',
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return value;
	        }
	    },
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};


/***/ },
/* 1146 */
/***/ function(module, exports) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty;
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    var obj;
	
	    while (queue.length) {
	        var item = queue.pop();
	        obj = item.obj[item.prop];
	
	        if (Array.isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted.push(obj[j]);
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	
	    return obj;
	};
	
	exports.arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? Object.create(null) : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	exports.merge = function merge(target, source, options) {
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        } else if (typeof target === 'object') {
	            if (options.plainObjects || options.allowPrototypes || !has.call(Object.prototype, source)) {
	                target[source] = true;
	            }
	        } else {
	            return [target, source];
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        return [target].concat(source);
	    }
	
	    var mergeTarget = target;
	    if (Array.isArray(target) && !Array.isArray(source)) {
	        mergeTarget = exports.arrayToObject(target, options);
	    }
	
	    if (Array.isArray(target) && Array.isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                if (target[i] && typeof target[i] === 'object') {
	                    target[i] = exports.merge(target[i], item, options);
	                } else {
	                    target.push(item);
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            acc[key] = exports.merge(acc[key], value, options);
	        } else {
	            acc[key] = value;
	        }
	        return acc;
	    }, mergeTarget);
	};
	
	exports.assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        acc[key] = source[key];
	        return acc;
	    }, target);
	};
	
	exports.decode = function (str) {
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	exports.encode = function encode(str) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = typeof str === 'string' ? str : String(str);
	
	    var out = '';
	    for (var i = 0; i < string.length; ++i) {
	        var c = string.charCodeAt(i);
	
	        if (
	            c === 0x2D // -
	            || c === 0x2E // .
	            || c === 0x5F // _
	            || c === 0x7E // ~
	            || (c >= 0x30 && c <= 0x39) // 0-9
	            || (c >= 0x41 && c <= 0x5A) // a-z
	            || (c >= 0x61 && c <= 0x7A) // A-Z
	        ) {
	            out += string.charAt(i);
	            continue;
	        }
	
	        if (c < 0x80) {
	            out = out + hexTable[c];
	            continue;
	        }
	
	        if (c < 0x800) {
	            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        if (c < 0xD800 || c >= 0xE000) {
	            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
	            continue;
	        }
	
	        i += 1;
	        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
	        out += hexTable[0xF0 | (c >> 18)]
	            + hexTable[0x80 | ((c >> 12) & 0x3F)]
	            + hexTable[0x80 | ((c >> 6) & 0x3F)]
	            + hexTable[0x80 | (c & 0x3F)];
	    }
	
	    return out;
	};
	
	exports.compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = [];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
	                queue.push({ obj: obj, prop: key });
	                refs.push(val);
	            }
	        }
	    }
	
	    return compactQueue(queue);
	};
	
	exports.isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	exports.isBuffer = function isBuffer(obj) {
	    if (obj === null || typeof obj === 'undefined') {
	        return false;
	    }
	
	    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
	};


/***/ },
/* 1147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _CalendarHeader = __webpack_require__(470);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _CalendarFooter = __webpack_require__(1149);
	
	var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);
	
	var _CalendarMixin = __webpack_require__(472);
	
	var _CalendarMixin2 = _interopRequireDefault(_CalendarMixin);
	
	var _CommonMixin = __webpack_require__(326);
	
	var _CommonMixin2 = _interopRequireDefault(_CommonMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MonthCalendar = (0, _createReactClass2['default'])({
	  displayName: 'MonthCalendar',
	
	  propTypes: {
	    monthCellRender: _propTypes2['default'].func,
	    dateCellRender: _propTypes2['default'].func
	  },
	  mixins: [_CommonMixin2['default'], _CalendarMixin2['default']],
	
	  getInitialState: function getInitialState() {
	    return { mode: 'month' };
	  },
	  onKeyDown: function onKeyDown(event) {
	    var keyCode = event.keyCode;
	    var ctrlKey = event.ctrlKey || event.metaKey;
	    var stateValue = this.state.value;
	    var disabledDate = this.props.disabledDate;
	
	    var value = stateValue;
	    switch (keyCode) {
	      case _KeyCode2['default'].DOWN:
	        value = stateValue.clone();
	        value.add(3, 'months');
	        break;
	      case _KeyCode2['default'].UP:
	        value = stateValue.clone();
	        value.add(-3, 'months');
	        break;
	      case _KeyCode2['default'].LEFT:
	        value = stateValue.clone();
	        if (ctrlKey) {
	          value.add(-1, 'years');
	        } else {
	          value.add(-1, 'months');
	        }
	        break;
	      case _KeyCode2['default'].RIGHT:
	        value = stateValue.clone();
	        if (ctrlKey) {
	          value.add(1, 'years');
	        } else {
	          value.add(1, 'months');
	        }
	        break;
	      case _KeyCode2['default'].ENTER:
	        if (!disabledDate || !disabledDate(stateValue)) {
	          this.onSelect(stateValue);
	        }
	        event.preventDefault();
	        return 1;
	      default:
	        return undefined;
	    }
	    if (value !== stateValue) {
	      this.setValue(value);
	      event.preventDefault();
	      return 1;
	    }
	  },
	  handlePanelChange: function handlePanelChange(_, mode) {
	    if (mode !== 'date') {
	      this.setState({ mode: mode });
	    }
	  },
	  render: function render() {
	    var props = this.props,
	        state = this.state;
	    var mode = state.mode,
	        value = state.value;
	
	    var children = _react2['default'].createElement(
	      'div',
	      { className: props.prefixCls + '-month-calendar-content' },
	      _react2['default'].createElement(
	        'div',
	        { className: props.prefixCls + '-month-header-wrap' },
	        _react2['default'].createElement(_CalendarHeader2['default'], {
	          prefixCls: props.prefixCls,
	          mode: mode,
	          value: value,
	          locale: props.locale,
	          disabledMonth: props.disabledDate,
	          monthCellRender: props.monthCellRender,
	          monthCellContentRender: props.monthCellContentRender,
	          onMonthSelect: this.onSelect,
	          onValueChange: this.setValue,
	          onPanelChange: this.handlePanelChange
	        })
	      ),
	      _react2['default'].createElement(_CalendarFooter2['default'], {
	        prefixCls: props.prefixCls,
	        renderFooter: props.renderFooter
	      })
	    );
	    return this.renderRoot({
	      className: props.prefixCls + '-month-calendar',
	      children: children
	    });
	  }
	});
	
	exports['default'] = MonthCalendar;
	module.exports = exports['default'];

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mapSelf = __webpack_require__(1196);
	
	var _mapSelf2 = _interopRequireDefault(_mapSelf);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TodayButton = __webpack_require__(1152);
	
	var _TodayButton2 = _interopRequireDefault(_TodayButton);
	
	var _OkButton = __webpack_require__(1150);
	
	var _OkButton2 = _interopRequireDefault(_OkButton);
	
	var _TimePickerButton = __webpack_require__(1151);
	
	var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarFooter = (0, _createReactClass2['default'])({
	  displayName: 'CalendarFooter',
	
	  propTypes: {
	    prefixCls: _propTypes2['default'].string,
	    showDateInput: _propTypes2['default'].bool,
	    disabledTime: _propTypes2['default'].any,
	    timePicker: _propTypes2['default'].element,
	    selectedValue: _propTypes2['default'].any,
	    showOk: _propTypes2['default'].bool,
	    onSelect: _propTypes2['default'].func,
	    value: _propTypes2['default'].object,
	    renderFooter: _propTypes2['default'].func,
	    defaultValue: _propTypes2['default'].object
	  },
	
	  onSelect: function onSelect(value) {
	    this.props.onSelect(value);
	  },
	  getRootDOMNode: function getRootDOMNode() {
	    return _reactDom2['default'].findDOMNode(this);
	  },
	  render: function render() {
	    var props = this.props;
	    var value = props.value,
	        prefixCls = props.prefixCls,
	        showOk = props.showOk,
	        timePicker = props.timePicker,
	        renderFooter = props.renderFooter;
	
	    var footerEl = null;
	    var extraFooter = renderFooter();
	    if (props.showToday || timePicker || extraFooter) {
	      var _cx;
	
	      var nowEl = void 0;
	      if (props.showToday) {
	        nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, { value: value }));
	      }
	      var okBtn = void 0;
	      if (showOk === true || showOk !== false && !!props.timePicker) {
	        okBtn = _react2['default'].createElement(_OkButton2['default'], props);
	      }
	      var timePickerBtn = void 0;
	      if (!!props.timePicker) {
	        timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
	      }
	
	      var footerBtn = void 0;
	      if (nowEl || timePickerBtn || okBtn) {
	        footerBtn = _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-footer-btn' },
	          (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn])
	        );
	      }
	      var cls = (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-footer'] = true, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
	      footerEl = _react2['default'].createElement(
	        'div',
	        { className: cls },
	        extraFooter,
	        footerBtn
	      );
	    }
	    return footerEl;
	  }
	});
	
	exports['default'] = CalendarFooter;
	module.exports = exports['default'];

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = OkButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function OkButton(_ref) {
	  var prefixCls = _ref.prefixCls,
	      locale = _ref.locale,
	      okDisabled = _ref.okDisabled,
	      onOk = _ref.onOk;
	
	  var className = prefixCls + "-ok-btn";
	  if (okDisabled) {
	    className += " " + prefixCls + "-ok-btn-disabled";
	  }
	  return _react2["default"].createElement(
	    "a",
	    {
	      className: className,
	      role: "button",
	      onClick: okDisabled ? null : onOk
	    },
	    locale.ok
	  );
	}
	module.exports = exports['default'];

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = TimePickerButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TimePickerButton(_ref) {
	  var _classnames;
	
	  var prefixCls = _ref.prefixCls,
	      locale = _ref.locale,
	      showTimePicker = _ref.showTimePicker,
	      onOpenTimePicker = _ref.onOpenTimePicker,
	      onCloseTimePicker = _ref.onCloseTimePicker,
	      timePickerDisabled = _ref.timePickerDisabled;
	
	  var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
	  var onClick = null;
	  if (!timePickerDisabled) {
	    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
	  }
	  return _react2['default'].createElement(
	    'a',
	    {
	      className: className,
	      role: 'button',
	      onClick: onClick
	    },
	    showTimePicker ? locale.dateSelect : locale.timeSelect
	  );
	}
	module.exports = exports['default'];

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = TodayButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TodayButton(_ref) {
	  var prefixCls = _ref.prefixCls,
	      locale = _ref.locale,
	      value = _ref.value,
	      timePicker = _ref.timePicker,
	      disabled = _ref.disabled,
	      disabledDate = _ref.disabledDate,
	      onToday = _ref.onToday,
	      text = _ref.text;
	
	  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
	  var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
	  var isDisabled = disabledToday || disabled;
	  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
	  return _react2['default'].createElement(
	    'a',
	    {
	      className: prefixCls + '-today-btn ' + disabledTodayClass,
	      role: 'button',
	      onClick: isDisabled ? null : onToday,
	      title: (0, _util.getTodayTimeStr)(value)
	    },
	    localeNow
	  );
	}
	module.exports = exports['default'];

/***/ },
/* 1153 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  DATE_ROW_COUNT: 6,
	  DATE_COL_COUNT: 7
	};
	module.exports = exports['default'];

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DateInput = (0, _createReactClass2['default'])({
	  displayName: 'DateInput',
	
	  propTypes: {
	    prefixCls: _propTypes2['default'].string,
	    timePicker: _propTypes2['default'].object,
	    value: _propTypes2['default'].object,
	    disabledTime: _propTypes2['default'].any,
	    format: _propTypes2['default'].string,
	    locale: _propTypes2['default'].object,
	    disabledDate: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    onClear: _propTypes2['default'].func,
	    placeholder: _propTypes2['default'].string,
	    onSelect: _propTypes2['default'].func,
	    selectedValue: _propTypes2['default'].object
	  },
	
	  getInitialState: function getInitialState() {
	    var selectedValue = this.props.selectedValue;
	    return {
	      str: selectedValue && selectedValue.format(this.props.format) || '',
	      invalid: false
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    this.cachedSelectionStart = this.dateInputInstance.selectionStart;
	    this.cachedSelectionEnd = this.dateInputInstance.selectionEnd;
	    // when popup show, click body will call this, bug!
	    var selectedValue = nextProps.selectedValue;
	    this.setState({
	      str: selectedValue && selectedValue.format(nextProps.format) || '',
	      invalid: false
	    });
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    if (!this.state.invalid) {
	      this.dateInputInstance.setSelectionRange(this.cachedSelectionStart, this.cachedSelectionEnd);
	    }
	  },
	  onInputChange: function onInputChange(event) {
	    var str = event.target.value;
	    this.setState({
	      str: str
	    });
	    var value = void 0;
	    var _props = this.props,
	        disabledDate = _props.disabledDate,
	        format = _props.format,
	        onChange = _props.onChange;
	
	    if (str) {
	      var parsed = (0, _moment2['default'])(str, format, true);
	      if (!parsed.isValid()) {
	        this.setState({
	          invalid: true
	        });
	        return;
	      }
	      value = this.props.value.clone();
	      value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());
	
	      if (value && (!disabledDate || !disabledDate(value))) {
	        var originalValue = this.props.selectedValue;
	        if (originalValue && value) {
	          if (!originalValue.isSame(value)) {
	            onChange(value);
	          }
	        } else if (originalValue !== value) {
	          onChange(value);
	        }
	      } else {
	        this.setState({
	          invalid: true
	        });
	        return;
	      }
	    } else {
	      onChange(null);
	    }
	    this.setState({
	      invalid: false
	    });
	  },
	  onClear: function onClear() {
	    this.setState({
	      str: ''
	    });
	    this.props.onClear(null);
	  },
	  getRootDOMNode: function getRootDOMNode() {
	    return _reactDom2['default'].findDOMNode(this);
	  },
	  focus: function focus() {
	    if (this.dateInputInstance) {
	      this.dateInputInstance.focus();
	    }
	  },
	  saveDateInput: function saveDateInput(dateInput) {
	    this.dateInputInstance = dateInput;
	  },
	  render: function render() {
	    var props = this.props;
	    var _state = this.state,
	        invalid = _state.invalid,
	        str = _state.str;
	    var locale = props.locale,
	        prefixCls = props.prefixCls,
	        placeholder = props.placeholder;
	
	    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-input-wrap' },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-date-input-wrap' },
	        _react2['default'].createElement('input', {
	          ref: this.saveDateInput,
	          className: prefixCls + '-input ' + invalidClass,
	          value: str,
	          disabled: props.disabled,
	          placeholder: placeholder,
	          onChange: this.onInputChange
	        })
	      ),
	      props.showClear ? _react2['default'].createElement('a', {
	        className: prefixCls + '-clear-btn',
	        role: 'button',
	        title: locale.clear,
	        onClick: this.onClear
	      }) : null
	    );
	  }
	});
	
	exports['default'] = DateInput;
	module.exports = exports['default'];

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Calendar = __webpack_require__(2491);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Calendar2['default'];
	module.exports = exports['default'];

/***/ },
/* 1156 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: 'Today',
	  now: 'Now',
	  backToToday: 'Back to today',
	  ok: 'Ok',
	  clear: 'Clear',
	  month: 'Month',
	  year: 'Year',
	  timeSelect: 'Select time',
	  dateSelect: 'Select date',
	  monthSelect: 'Choose a month',
	  yearSelect: 'Choose a year',
	  decadeSelect: 'Choose a decade',
	  yearFormat: 'YYYY',
	  dateFormat: 'M/D/YYYY',
	  dayFormat: 'D',
	  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
	  monthBeforeYear: true,
	  previousMonth: 'Previous month (PageUp)',
	  nextMonth: 'Next month (PageDown)',
	  previousYear: 'Last year (Control + left)',
	  nextYear: 'Next year (Control + right)',
	  previousDecade: 'Last decade',
	  nextDecade: 'Next decade',
	  previousCentury: 'Last century',
	  nextCentury: 'Next century'
	};
	module.exports = exports['default'];

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _index = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROW = 4;
	var COL = 3;
	
	function chooseMonth(month) {
	  var next = this.state.value.clone();
	  next.month(month);
	  this.setAndSelectValue(next);
	}
	
	function noop() {}
	
	var MonthTable = function (_Component) {
	  (0, _inherits3['default'])(MonthTable, _Component);
	
	  function MonthTable(props) {
	    (0, _classCallCheck3['default'])(this, MonthTable);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _this.state = {
	      value: props.value
	    };
	    return _this;
	  }
	
	  MonthTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if ('value' in nextProps) {
	      this.setState({
	        value: nextProps.value
	      });
	    }
	  };
	
	  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
	    this.setState({
	      value: value
	    });
	    this.props.onSelect(value);
	  };
	
	  MonthTable.prototype.months = function months() {
	    var value = this.state.value;
	    var current = value.clone();
	    var months = [];
	    var index = 0;
	    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
	      months[rowIndex] = [];
	      for (var colIndex = 0; colIndex < COL; colIndex++) {
	        current.month(index);
	        var content = (0, _index.getMonthName)(current);
	        months[rowIndex][colIndex] = {
	          value: index,
	          content: content,
	          title: content
	        };
	        index++;
	      }
	    }
	    return months;
	  };
	
	  MonthTable.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var value = this.state.value;
	    var today = (0, _index.getTodayTime)(value);
	    var months = this.months();
	    var currentMonth = value.month();
	    var prefixCls = props.prefixCls,
	        locale = props.locale,
	        contentRender = props.contentRender,
	        cellRender = props.cellRender;
	
	    var monthsEls = months.map(function (month, index) {
	      var tds = month.map(function (monthData) {
	        var _classNameMap;
	
	        var disabled = false;
	        if (props.disabledDate) {
	          var testValue = value.clone();
	          testValue.month(monthData.value);
	          disabled = props.disabledDate(testValue);
	        }
	        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
	        var cellEl = void 0;
	        if (cellRender) {
	          var currentValue = value.clone();
	          currentValue.month(monthData.value);
	          cellEl = cellRender(currentValue, locale);
	        } else {
	          var content = void 0;
	          if (contentRender) {
	            var _currentValue = value.clone();
	            _currentValue.month(monthData.value);
	            content = contentRender(_currentValue, locale);
	          } else {
	            content = monthData.content;
	          }
	          cellEl = _react2['default'].createElement(
	            'a',
	            { className: prefixCls + '-month' },
	            content
	          );
	        }
	        return _react2['default'].createElement(
	          'td',
	          {
	            role: 'gridcell',
	            key: monthData.value,
	            onClick: disabled ? null : chooseMonth.bind(_this2, monthData.value),
	            title: monthData.title,
	            className: (0, _classnames2['default'])(classNameMap)
	          },
	          cellEl
	        );
	      });
	      return _react2['default'].createElement(
	        'tr',
	        { key: index, role: 'row' },
	        tds
	      );
	    });
	
	    return _react2['default'].createElement(
	      'table',
	      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	      _react2['default'].createElement(
	        'tbody',
	        { className: prefixCls + '-tbody' },
	        monthsEls
	      )
	    );
	  };
	
	  return MonthTable;
	}(_react.Component);
	
	MonthTable.defaultProps = {
	  onSelect: noop
	};
	MonthTable.propTypes = {
	  onSelect: _propTypes2['default'].func,
	  cellRender: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object
	};
	exports['default'] = MonthTable;
	module.exports = exports['default'];

/***/ },
/* 1158 */
/***/ function(module, exports) {

	function arrayTreeFilter(data, filterFn, options) {
	  options = options || {};
	  options.childrenKeyName = options.childrenKeyName || 'children';
	  var children = data || [];
	  var result = [];
	  var level = 0;
	  var foundItem;
	  do {
	    var foundItem = children.filter(function(item) {
	      return filterFn(item, level);
	    })[0];
	    if (!foundItem) {
	      break;
	    }
	    result.push(foundItem);
	    children = foundItem[options.childrenKeyName] || [];
	    level += 1;
	  } while(children.length > 0);
	  return result;
	}
	
	module.exports = arrayTreeFilter;


/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Checkbox = __webpack_require__(2508);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Checkbox2['default'];
	module.exports = exports['default'];

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _Collapse = __webpack_require__(2509);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Collapse2['default'];
	var Panel = exports.Panel = _Collapse2['default'].Panel;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Nav = function (_Component) {
	  (0, _inherits3['default'])(Nav, _Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  Nav.prototype.render = function render() {
	    var props = this.props;
	
	    return _react2['default'].createElement('div', props);
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports['default'] = Nav;
	module.exports = exports['default'];

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getMentions;
	
	var _getRegExp = __webpack_require__(1164);
	
	var _getRegExp2 = _interopRequireDefault(_getRegExp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getMentions(contentState) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '@';
	
	  var regex = (0, _getRegExp2['default'])(prefix);
	  var entities = [];
	  contentState.getBlockMap().forEach(function (block) {
	    var blockText = block.getText();
	    var matchArr = void 0;
	    while ((matchArr = regex.exec(blockText)) !== null) {
	      // eslint-disable-line
	      entities.push(matchArr[0].trim());
	    }
	  });
	  return entities;
	}
	module.exports = exports['default'];

/***/ },
/* 1163 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getOffset;
	function getOffset(element, container) {
	  var rect = element.getBoundingClientRect();
	  if (rect.width || rect.height) {
	    var elementContainer = container || element.parentElement;
	    return {
	      top: rect.top - elementContainer.clientTop,
	      left: rect.left - elementContainer.clientLeft
	    };
	  }
	  return rect;
	}
	module.exports = exports['default'];

/***/ },
/* 1164 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getRegExp;
	function getRegExp(prefix) {
	  var prefixArray = Array.isArray(prefix) ? prefix : [prefix];
	  var prefixToken = prefixArray.join('').replace(/(\$|\^)/g, '\\$1');
	
	  if (prefixArray.length > 1) {
	    prefixToken = '[' + prefixToken + ']';
	  }
	
	  return new RegExp('(\\s|^)(' + prefixToken + ')[^\\s]*', 'g');
	}
	module.exports = exports['default'];

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(176);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _asyncValidator = __webpack_require__(1541);
	
	var _asyncValidator2 = _interopRequireDefault(_asyncValidator);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _get = __webpack_require__(153);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _has = __webpack_require__(1003);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _set = __webpack_require__(1009);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _createFieldsStore = __webpack_require__(2540);
	
	var _createFieldsStore2 = _interopRequireDefault(_createFieldsStore);
	
	var _utils = __webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DEFAULT_TRIGGER = 'onChange';
	
	function createBaseForm() {
	  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var validateMessages = option.validateMessages,
	      onFieldsChange = option.onFieldsChange,
	      onValuesChange = option.onValuesChange,
	      _option$mapProps = option.mapProps,
	      mapProps = _option$mapProps === undefined ? _utils.identity : _option$mapProps,
	      mapPropsToFields = option.mapPropsToFields,
	      fieldNameProp = option.fieldNameProp,
	      fieldMetaProp = option.fieldMetaProp,
	      fieldDataProp = option.fieldDataProp,
	      _option$formPropName = option.formPropName,
	      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
	      withRef = option.withRef;
	
	
	  return function decorate(WrappedComponent) {
	    var Form = (0, _createReactClass2['default'])({
	      displayName: 'Form',
	
	      mixins: mixins,
	
	      getInitialState: function getInitialState() {
	        var _this = this;
	
	        var fields = mapPropsToFields && mapPropsToFields(this.props);
	        this.fieldsStore = (0, _createFieldsStore2['default'])(fields || {});
	
	        this.instances = {};
	        this.cachedBind = {};
	        this.clearedFieldMetaCache = {};
	        // HACK: https://github.com/ant-design/ant-design/issues/6406
	        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
	          return _this[key] = function () {
	            var _fieldsStore;
	
	            if (false) {
	              (0, _warning2['default'])(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
	            }
	            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
	          };
	        });
	
	        return {
	          submitting: false
	        };
	      },
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (mapPropsToFields) {
	          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
	        }
	      },
	      onCollectCommon: function onCollectCommon(name, action, args) {
	        var fieldMeta = this.fieldsStore.getFieldMeta(name);
	        if (fieldMeta[action]) {
	          fieldMeta[action].apply(fieldMeta, (0, _toConsumableArray3['default'])(args));
	        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
	          var _fieldMeta$originalPr;
	
	          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, (0, _toConsumableArray3['default'])(args));
	        }
	        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, (0, _toConsumableArray3['default'])(args)) : _utils.getValueFromEvent.apply(undefined, (0, _toConsumableArray3['default'])(args));
	        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
	          var valuesAll = this.fieldsStore.getAllValues();
	          var valuesAllSet = {};
	          valuesAll[name] = value;
	          Object.keys(valuesAll).forEach(function (key) {
	            return (0, _set2['default'])(valuesAllSet, key, valuesAll[key]);
	          });
	          onValuesChange(this.props, (0, _set2['default'])({}, name, value), valuesAllSet);
	        }
	        var field = this.fieldsStore.getField(name);
	        return { name: name, field: (0, _extends3['default'])({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
	      },
	      onCollect: function onCollect(name_, action) {
	        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          args[_key - 2] = arguments[_key];
	        }
	
	        var _onCollectCommon = this.onCollectCommon(name_, action, args),
	            name = _onCollectCommon.name,
	            field = _onCollectCommon.field,
	            fieldMeta = _onCollectCommon.fieldMeta;
	
	        var validate = fieldMeta.validate;
	
	        var newField = (0, _extends3['default'])({}, field, {
	          dirty: (0, _utils.hasRules)(validate)
	        });
	        this.setFields((0, _defineProperty3['default'])({}, name, newField));
	      },
	      onCollectValidate: function onCollectValidate(name_, action) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
	            field = _onCollectCommon2.field,
	            fieldMeta = _onCollectCommon2.fieldMeta;
	
	        var newField = (0, _extends3['default'])({}, field, {
	          dirty: true
	        });
	        this.validateFieldsInternal([newField], {
	          action: action,
	          options: {
	            firstFields: !!fieldMeta.validateFirst
	          }
	        });
	      },
	      getCacheBind: function getCacheBind(name, action, fn) {
	        if (!this.cachedBind[name]) {
	          this.cachedBind[name] = {};
	        }
	        var cache = this.cachedBind[name];
	        if (!cache[action]) {
	          cache[action] = fn.bind(this, name, action);
	        }
	        return cache[action];
	      },
	      recoverClearedField: function recoverClearedField(name) {
	        if (this.clearedFieldMetaCache[name]) {
	          this.fieldsStore.setFields((0, _defineProperty3['default'])({}, name, this.clearedFieldMetaCache[name].field));
	          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
	          delete this.clearedFieldMetaCache[name];
	        }
	      },
	      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
	        var _this2 = this;
	
	        var props = this.getFieldProps(name, fieldOption);
	        return function (fieldElem) {
	          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
	          var originalProps = fieldElem.props;
	          if (false) {
	            var valuePropName = fieldMeta.valuePropName;
	            (0, _warning2['default'])(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
	            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
	            (0, _warning2['default'])(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
	          }
	          fieldMeta.originalProps = originalProps;
	          fieldMeta.ref = fieldElem.ref;
	          return _react2['default'].cloneElement(fieldElem, (0, _extends3['default'])({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
	        };
	      },
	      getFieldProps: function getFieldProps(name) {
	        var _this3 = this;
	
	        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (!name) {
	          throw new Error('Must call `getFieldProps` with valid name string!');
	        }
	        if (false) {
	          (0, _warning2['default'])(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`.');
	          (0, _warning2['default'])(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
	        }
	
	        delete this.clearedFieldMetaCache[name];
	
	        var fieldOption = (0, _extends3['default'])({
	          name: name,
	          trigger: DEFAULT_TRIGGER,
	          valuePropName: 'value',
	          validate: []
	        }, usersFieldOption);
	
	        var rules = fieldOption.rules,
	            trigger = fieldOption.trigger,
	            _fieldOption$validate = fieldOption.validateTrigger,
	            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
	            validate = fieldOption.validate;
	
	
	        var fieldMeta = this.fieldsStore.getFieldMeta(name);
	        if ('initialValue' in fieldOption) {
	          fieldMeta.initialValue = fieldOption.initialValue;
	        }
	
	        var inputProps = (0, _extends3['default'])({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
	          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
	        });
	        if (fieldNameProp) {
	          inputProps[fieldNameProp] = name;
	        }
	
	        var validateRules = (0, _utils.normalizeValidateRules)(validate, rules, validateTrigger);
	        var validateTriggers = (0, _utils.getValidateTriggers)(validateRules);
	        validateTriggers.forEach(function (action) {
	          if (inputProps[action]) return;
	          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
	        });
	
	        // make sure that the value will be collect
	        if (trigger && validateTriggers.indexOf(trigger) === -1) {
	          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
	        }
	
	        var meta = (0, _extends3['default'])({}, fieldMeta, fieldOption, {
	          validate: validateRules
	        });
	        this.fieldsStore.setFieldMeta(name, meta);
	        if (fieldMetaProp) {
	          inputProps[fieldMetaProp] = meta;
	        }
	
	        if (fieldDataProp) {
	          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
	        }
	
	        return inputProps;
	      },
	      getFieldInstance: function getFieldInstance(name) {
	        return this.instances[name];
	      },
	      getRules: function getRules(fieldMeta, action) {
	        var actionRules = fieldMeta.validate.filter(function (item) {
	          return !action || item.trigger.indexOf(action) >= 0;
	        }).map(function (item) {
	          return item.rules;
	        });
	        return (0, _utils.flattenArray)(actionRules);
	      },
	      setFields: function setFields(maybeNestedFields) {
	        var _this4 = this;
	
	        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
	        this.fieldsStore.setFields(fields);
	        if (onFieldsChange) {
	          var changedFields = Object.keys(fields).reduce(function (acc, name) {
	            return (0, _set2['default'])(acc, name, _this4.fieldsStore.getField(name));
	          }, {});
	          onFieldsChange(this.props, changedFields, this.fieldsStore.getNestedAllFields());
	        }
	        this.forceUpdate();
	      },
	      resetFields: function resetFields(ns) {
	        var _this5 = this;
	
	        var newFields = this.fieldsStore.resetFields(ns);
	        if (Object.keys(newFields).length > 0) {
	          this.setFields(newFields);
	        }
	        if (ns) {
	          var names = Array.isArray(ns) ? ns : [ns];
	          names.forEach(function (name) {
	            return delete _this5.clearedFieldMetaCache[name];
	          });
	        } else {
	          this.clearedFieldMetaCache = {};
	        }
	      },
	      setFieldsValue: function setFieldsValue(changedValues) {
	        var fieldsMeta = this.fieldsStore.fieldsMeta;
	
	        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
	        var newFields = Object.keys(values).reduce(function (acc, name) {
	          var isRegistered = fieldsMeta[name];
	          if (false) {
	            (0, _warning2['default'])(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
	          }
	          if (isRegistered) {
	            var value = values[name];
	            acc[name] = {
	              value: value
	            };
	          }
	          return acc;
	        }, {});
	        this.setFields(newFields);
	        if (onValuesChange) {
	          var allValues = this.fieldsStore.getAllValues();
	          onValuesChange(this.props, changedValues, allValues);
	        }
	      },
	      saveRef: function saveRef(name, _, component) {
	        if (!component) {
	          // after destroy, delete data
	          this.clearedFieldMetaCache[name] = {
	            field: this.fieldsStore.getField(name),
	            meta: this.fieldsStore.getFieldMeta(name)
	          };
	          this.fieldsStore.clearField(name);
	          delete this.instances[name];
	          delete this.cachedBind[name];
	          return;
	        }
	        this.recoverClearedField(name);
	        var fieldMeta = this.fieldsStore.getFieldMeta(name);
	        if (fieldMeta) {
	          var ref = fieldMeta.ref;
	          if (ref) {
	            if (typeof ref === 'string') {
	              throw new Error('can not set ref string for ' + name);
	            }
	            ref(component);
	          }
	        }
	        this.instances[name] = component;
	      },
	      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
	        var _this6 = this;
	
	        var fieldNames = _ref.fieldNames,
	            action = _ref.action,
	            _ref$options = _ref.options,
	            options = _ref$options === undefined ? {} : _ref$options;
	
	        var allRules = {};
	        var allValues = {};
	        var allFields = {};
	        var alreadyErrors = {};
	        fields.forEach(function (field) {
	          var name = field.name;
	          if (options.force !== true && field.dirty === false) {
	            if (field.errors) {
	              (0, _set2['default'])(alreadyErrors, name, { errors: field.errors });
	            }
	            return;
	          }
	          var fieldMeta = _this6.fieldsStore.getFieldMeta(name);
	          var newField = (0, _extends3['default'])({}, field);
	          newField.errors = undefined;
	          newField.validating = true;
	          newField.dirty = true;
	          allRules[name] = _this6.getRules(fieldMeta, action);
	          allValues[name] = newField.value;
	          allFields[name] = newField;
	        });
	        this.setFields(allFields);
	        // in case normalize
	        Object.keys(allValues).forEach(function (f) {
	          allValues[f] = _this6.fieldsStore.getFieldValue(f);
	        });
	        if (callback && (0, _utils.isEmptyObject)(allFields)) {
	          callback((0, _utils.isEmptyObject)(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
	          return;
	        }
	        var validator = new _asyncValidator2['default'](allRules);
	        if (validateMessages) {
	          validator.messages(validateMessages);
	        }
	        validator.validate(allValues, options, function (errors) {
	          var errorsGroup = (0, _extends3['default'])({}, alreadyErrors);
	          if (errors && errors.length) {
	            errors.forEach(function (e) {
	              var fieldName = e.field;
	              if (!(0, _has2['default'])(errorsGroup, fieldName)) {
	                (0, _set2['default'])(errorsGroup, fieldName, { errors: [] });
	              }
	              var fieldErrors = (0, _get2['default'])(errorsGroup, fieldName.concat('.errors'));
	              fieldErrors.push(e);
	            });
	          }
	          var expired = [];
	          var nowAllFields = {};
	          Object.keys(allRules).forEach(function (name) {
	            var fieldErrors = (0, _get2['default'])(errorsGroup, name);
	            var nowField = _this6.fieldsStore.getField(name);
	            // avoid concurrency problems
	            if (nowField.value !== allValues[name]) {
	              expired.push({
	                name: name
	              });
	            } else {
	              nowField.errors = fieldErrors && fieldErrors.errors;
	              nowField.value = allValues[name];
	              nowField.validating = false;
	              nowField.dirty = false;
	              nowAllFields[name] = nowField;
	            }
	          });
	          _this6.setFields(nowAllFields);
	          if (callback) {
	            if (expired.length) {
	              expired.forEach(function (_ref2) {
	                var name = _ref2.name;
	
	                var fieldErrors = [{
	                  message: name + ' need to revalidate',
	                  field: name
	                }];
	                (0, _set2['default'])(errorsGroup, name, {
	                  expired: true,
	                  errors: fieldErrors
	                });
	              });
	            }
	
	            callback((0, _utils.isEmptyObject)(errorsGroup) ? null : errorsGroup, _this6.fieldsStore.getFieldsValue(fieldNames));
	          }
	        });
	      },
	      validateFields: function validateFields(ns, opt, cb) {
	        var _this7 = this;
	
	        var _getParams = (0, _utils.getParams)(ns, opt, cb),
	            names = _getParams.names,
	            callback = _getParams.callback,
	            options = _getParams.options;
	
	        var fieldNames = names ? this.fieldsStore.getValidFieldsFullName(names) : this.fieldsStore.getValidFieldsName();
	        var fields = fieldNames.filter(function (name) {
	          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
	          return (0, _utils.hasRules)(fieldMeta.validate);
	        }).map(function (name) {
	          var field = _this7.fieldsStore.getField(name);
	          field.value = _this7.fieldsStore.getFieldValue(name);
	          return field;
	        });
	        if (!fields.length) {
	          if (callback) {
	            callback(null, this.fieldsStore.getFieldsValue(fieldNames));
	          }
	          return;
	        }
	        if (!('firstFields' in options)) {
	          options.firstFields = fieldNames.filter(function (name) {
	            var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
	            return !!fieldMeta.validateFirst;
	          });
	        }
	        this.validateFieldsInternal(fields, {
	          fieldNames: fieldNames,
	          options: options
	        }, callback);
	      },
	      isSubmitting: function isSubmitting() {
	        if (false) {
	          (0, _warning2['default'])(false, '`isSubmitting` is deprecated. ' + 'Actually, it\'s more convenient to handle submitting status by yourself.');
	        }
	        return this.state.submitting;
	      },
	      submit: function submit(callback) {
	        var _this8 = this;
	
	        if (false) {
	          (0, _warning2['default'])(false, '`submit` is deprecated.' + 'Actually, it\'s more convenient to handle submitting status by yourself.');
	        }
	        var fn = function fn() {
	          _this8.setState({
	            submitting: false
	          });
	        };
	        this.setState({
	          submitting: true
	        });
	        callback(fn);
	      },
	      render: function render() {
	        var _props = this.props,
	            wrappedComponentRef = _props.wrappedComponentRef,
	            restProps = (0, _objectWithoutProperties3['default'])(_props, ['wrappedComponentRef']);
	
	        var formProps = (0, _defineProperty3['default'])({}, formPropName, this.getForm());
	        if (withRef) {
	          if (false) {
	            (0, _warning2['default'])(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
	          }
	          formProps.ref = 'wrappedComponent';
	        } else if (wrappedComponentRef) {
	          formProps.ref = wrappedComponentRef;
	        }
	        var props = mapProps.call(this, (0, _extends3['default'])({}, formProps, restProps));
	        return _react2['default'].createElement(WrappedComponent, props);
	      }
	    });
	
	    return (0, _utils.argumentContainer)(Form, WrappedComponent);
	  };
	}
	
	exports['default'] = createBaseForm;
	module.exports = exports['default'];

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.isFormField = isFormField;
	exports["default"] = createFormField;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Field = function Field(fields) {
	  (0, _classCallCheck3["default"])(this, Field);
	
	  (0, _extends3["default"])(this, fields);
	};
	
	function isFormField(obj) {
	  return obj instanceof Field;
	}
	
	function createFormField(field) {
	  if (isFormField(field)) {
	    return field;
	  }
	  return new Field(field);
	}

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _createChainedFunction = __webpack_require__(482);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domScrollIntoView = __webpack_require__(295);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _util = __webpack_require__(327);
	
	var _DOMWrap = __webpack_require__(2546);
	
	var _DOMWrap2 = _interopRequireDefault(_DOMWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function allDisabled(arr) {
	  if (!arr.length) {
	    return true;
	  }
	  return arr.every(function (c) {
	    return !!c.props.disabled;
	  });
	}
	
	function getActiveKey(props, originalActiveKey) {
	  var activeKey = originalActiveKey;
	  var children = props.children,
	      eventKey = props.eventKey;
	
	  if (activeKey) {
	    var found = void 0;
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (c && !c.props.disabled && activeKey === (0, _util.getKeyFromChildrenIndex)(c, eventKey, i)) {
	        found = true;
	      }
	    });
	    if (found) {
	      return activeKey;
	    }
	  }
	  activeKey = null;
	  if (props.defaultActiveFirst) {
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (!activeKey && c && !c.props.disabled) {
	        activeKey = (0, _util.getKeyFromChildrenIndex)(c, eventKey, i);
	      }
	    });
	    return activeKey;
	  }
	  return activeKey;
	}
	
	function saveRef(index, subIndex, c) {
	  if (c) {
	    if (subIndex !== undefined) {
	      this.instanceArray[index] = this.instanceArray[index] || [];
	      this.instanceArray[index][subIndex] = c;
	    } else {
	      this.instanceArray[index] = c;
	    }
	  }
	}
	
	var MenuMixin = {
	  propTypes: {
	    focusable: _propTypes2['default'].bool,
	    multiple: _propTypes2['default'].bool,
	    style: _propTypes2['default'].object,
	    defaultActiveFirst: _propTypes2['default'].bool,
	    visible: _propTypes2['default'].bool,
	    activeKey: _propTypes2['default'].string,
	    selectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultSelectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultOpenKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    openKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    children: _propTypes2['default'].any
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      prefixCls: 'rc-menu',
	      className: '',
	      mode: 'vertical',
	      level: 1,
	      inlineIndent: 24,
	      visible: true,
	      focusable: true,
	      style: {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    return {
	      activeKey: getActiveKey(props, props.activeKey)
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var props = void 0;
	    if ('activeKey' in nextProps) {
	      props = {
	        activeKey: getActiveKey(nextProps, nextProps.activeKey)
	      };
	    } else {
	      var originalActiveKey = this.state.activeKey;
	      var activeKey = getActiveKey(nextProps, originalActiveKey);
	      // fix: this.setState(), parent.render(),
	      if (activeKey !== originalActiveKey) {
	        props = {
	          activeKey: activeKey
	        };
	      }
	    }
	    if (props) {
	      this.setState(props);
	    }
	  },
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	    return this.props.visible || nextProps.visible;
	  },
	  componentWillMount: function componentWillMount() {
	    this.instanceArray = [];
	  },
	
	
	  // all keyboard events callbacks run from here at first
	  onKeyDown: function onKeyDown(e, callback) {
	    var _this = this;
	
	    var keyCode = e.keyCode;
	    var handled = void 0;
	    this.getFlatInstanceArray().forEach(function (obj) {
	      if (obj && obj.props.active && obj.onKeyDown) {
	        handled = obj.onKeyDown(e);
	      }
	    });
	    if (handled) {
	      return 1;
	    }
	    var activeItem = null;
	    if (keyCode === _KeyCode2['default'].UP || keyCode === _KeyCode2['default'].DOWN) {
	      activeItem = this.step(keyCode === _KeyCode2['default'].UP ? -1 : 1);
	    }
	    if (activeItem) {
	      e.preventDefault();
	      this.setState({
	        activeKey: activeItem.props.eventKey
	      }, function () {
	        (0, _domScrollIntoView2['default'])(_reactDom2['default'].findDOMNode(activeItem), _reactDom2['default'].findDOMNode(_this), {
	          onlyScrollIfNeeded: true
	        });
	        // https://github.com/react-component/menu/commit/9899a9672f6f028ec3cdf773f1ecea5badd2d33e
	        if (typeof callback === 'function') {
	          callback(activeItem);
	        }
	      });
	      return 1;
	    } else if (activeItem === undefined) {
	      e.preventDefault();
	      this.setState({
	        activeKey: null
	      });
	      return 1;
	    }
	  },
	  onItemHover: function onItemHover(e) {
	    var key = e.key,
	        hover = e.hover;
	
	    this.setState({
	      activeKey: hover ? key : null
	    });
	  },
	  getFlatInstanceArray: function getFlatInstanceArray() {
	    var instanceArray = this.instanceArray;
	    var hasInnerArray = instanceArray.some(function (a) {
	      return Array.isArray(a);
	    });
	    if (hasInnerArray) {
	      instanceArray = [];
	      this.instanceArray.forEach(function (a) {
	        if (Array.isArray(a)) {
	          instanceArray.push.apply(instanceArray, a);
	        } else {
	          instanceArray.push(a);
	        }
	      });
	      this.instanceArray = instanceArray;
	    }
	    return instanceArray;
	  },
	  renderCommonMenuItem: function renderCommonMenuItem(child, i, subIndex, extraProps) {
	    var state = this.state;
	    var props = this.props;
	    var key = (0, _util.getKeyFromChildrenIndex)(child, props.eventKey, i);
	    var childProps = child.props;
	    var isActive = key === state.activeKey;
	    var newChildProps = (0, _extends3['default'])({
	      mode: props.mode,
	      level: props.level,
	      inlineIndent: props.inlineIndent,
	      renderMenuItem: this.renderMenuItem,
	      rootPrefixCls: props.prefixCls,
	      index: i,
	      parentMenu: this,
	      ref: childProps.disabled ? undefined : (0, _createChainedFunction2['default'])(child.ref, saveRef.bind(this, i, subIndex)),
	      eventKey: key,
	      active: !childProps.disabled && isActive,
	      multiple: props.multiple,
	      onClick: this.onClick,
	      onItemHover: this.onItemHover,
	      openTransitionName: this.getOpenTransitionName(),
	      openAnimation: props.openAnimation,
	      subMenuOpenDelay: props.subMenuOpenDelay,
	      subMenuCloseDelay: props.subMenuCloseDelay,
	      forceSubMenuRender: props.forceSubMenuRender,
	      onOpenChange: this.onOpenChange,
	      onDeselect: this.onDeselect,
	      onSelect: this.onSelect
	    }, extraProps);
	    if (props.mode === 'inline') {
	      newChildProps.triggerSubMenuAction = 'click';
	    }
	    return _react2['default'].cloneElement(child, newChildProps);
	  },
	  renderRoot: function renderRoot(props) {
	    this.instanceArray = [];
	    var className = (0, _classnames2['default'])(props.prefixCls, props.className, props.prefixCls + '-' + props.mode);
	    var domProps = {
	      className: className,
	      role: 'menu',
	      'aria-activedescendant': ''
	    };
	    if (props.id) {
	      domProps.id = props.id;
	    }
	    if (props.focusable) {
	      domProps.tabIndex = '0';
	      domProps.onKeyDown = this.onKeyDown;
	    }
	    return (
	      // ESLint is not smart enough to know that the type of `children` was checked.
	      /* eslint-disable */
	      _react2['default'].createElement(
	        _DOMWrap2['default'],
	        (0, _extends3['default'])({
	          style: props.style,
	          tag: 'ul',
	          hiddenClassName: props.prefixCls + '-hidden',
	          visible: props.visible
	        }, domProps),
	        _react2['default'].Children.map(props.children, this.renderMenuItem)
	      )
	      /*eslint-enable */
	
	    );
	  },
	  step: function step(direction) {
	    var children = this.getFlatInstanceArray();
	    var activeKey = this.state.activeKey;
	    var len = children.length;
	    if (!len) {
	      return null;
	    }
	    if (direction < 0) {
	      children = children.concat().reverse();
	    }
	    // find current activeIndex
	    var activeIndex = -1;
	    children.every(function (c, ci) {
	      if (c && c.props.eventKey === activeKey) {
	        activeIndex = ci;
	        return false;
	      }
	      return true;
	    });
	    if (!this.props.defaultActiveFirst && activeIndex !== -1) {
	      if (allDisabled(children.slice(activeIndex, len - 1))) {
	        return undefined;
	      }
	    }
	    var start = (activeIndex + 1) % len;
	    var i = start;
	    for (;;) {
	      var child = children[i];
	      if (!child || child.props.disabled) {
	        i = (i + 1 + len) % len;
	        // complete a loop
	        if (i === start) {
	          return null;
	        }
	      } else {
	        return child;
	      }
	    }
	  }
	};
	
	exports['default'] = MenuMixin;
	module.exports = exports['default'];

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Notification = __webpack_require__(2555);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Notification2['default'];
	module.exports = exports['default'];

/***/ },
/* 1169 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  ZERO: 48,
	  NINE: 57,
	
	  NUMPAD_ZERO: 96,
	  NUMPAD_NINE: 105,
	
	  BACKSPACE: 8,
	  DELETE: 46,
	  ENTER: 13,
	
	  ARROW_UP: 38,
	  ARROW_DOWN: 40
	};
	module.exports = exports['default'];

/***/ },
/* 1170 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '/ page',
	  jump_to: 'Goto',
	  jump_to_confirm: 'confirm',
	  page: '',
	
	  // Pagination.jsx
	  prev_page: 'Previous Page',
	  next_page: 'Next Page',
	  prev_5: 'Previous 5 Pages',
	  next_5: 'Next 5 Pages',
	  prev_3: 'Previous 3 Pages',
	  next_3: 'Next 3 Pages'
	};
	module.exports = exports['default'];

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var enhancer = function enhancer(WrappedComponent) {
	  return function (_WrappedComponent) {
	    (0, _inherits3['default'])(Progress, _WrappedComponent);
	
	    function Progress() {
	      (0, _classCallCheck3['default'])(this, Progress);
	      return (0, _possibleConstructorReturn3['default'])(this, _WrappedComponent.apply(this, arguments));
	    }
	
	    Progress.prototype.componentDidUpdate = function componentDidUpdate() {
	      if (!this.path) {
	        return;
	      }
	      var pathStyle = this.path.style;
	      pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
	      var now = Date.now();
	      if (this.prevTimeStamp && now - this.prevTimeStamp < 100) {
	        pathStyle.transitionDuration = '0s, 0s';
	      }
	      this.prevTimeStamp = Date.now();
	    };
	
	    Progress.prototype.render = function render() {
	      return _WrappedComponent.prototype.render.call(this);
	    };
	
	    return Progress;
	  }(WrappedComponent);
	};
	
	exports['default'] = enhancer;
	module.exports = exports['default'];

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.propTypes = exports.defaultProps = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultProps = exports.defaultProps = {
	  className: '',
	  percent: 0,
	  prefixCls: 'rc-progress',
	  strokeColor: '#2db7f5',
	  strokeLinecap: 'round',
	  strokeWidth: 1,
	  style: {},
	  trailColor: '#D9D9D9',
	  trailWidth: 1
	};
	
	var propTypes = exports.propTypes = {
	  className: _propTypes2['default'].string,
	  percent: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  prefixCls: _propTypes2['default'].string,
	  strokeColor: _propTypes2['default'].string,
	  strokeLinecap: _propTypes2['default'].oneOf(['butt', 'round', 'square']),
	  strokeWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  style: _propTypes2['default'].object,
	  trailColor: _propTypes2['default'].string,
	  trailWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SelectPropTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function valueType(props, propName, componentName) {
	  var basicType = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]);
	
	  var labelInValueShape = _propTypes2['default'].shape({
	    key: basicType.isRequired,
	    label: _propTypes2['default'].node
	  });
	  if (props.labelInValue) {
	    var validate = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(labelInValueShape), labelInValueShape]);
	    var error = validate.apply(undefined, arguments);
	    if (error) {
	      return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + ('when you set `labelInValue` to `true`, `' + propName + '` should in ') + 'shape of `{ key: string | number, label?: ReactNode }`.');
	    }
	  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
	    return new Error('Invalid prop `' + propName + '` of type `string` supplied to `' + componentName + '`, ' + 'expected `array` when `multiple` or `tags` is `true`.');
	  } else {
	    var _validate = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(basicType), basicType]);
	    return _validate.apply(undefined, arguments);
	  }
	}
	
	var SelectPropTypes = exports.SelectPropTypes = {
	  defaultActiveFirstOption: _propTypes2['default'].bool,
	  multiple: _propTypes2['default'].bool,
	  filterOption: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  showSearch: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  allowClear: _propTypes2['default'].bool,
	  showArrow: _propTypes2['default'].bool,
	  tags: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].string,
	  optionLabelProp: _propTypes2['default'].string,
	  optionFilterProp: _propTypes2['default'].string,
	  animation: _propTypes2['default'].string,
	  choiceTransitionName: _propTypes2['default'].string,
	  onChange: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  onSearch: _propTypes2['default'].func,
	  onPopupScroll: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onInputKeyDown: _propTypes2['default'].func,
	  placeholder: _propTypes2['default'].any,
	  onDeselect: _propTypes2['default'].func,
	  labelInValue: _propTypes2['default'].bool,
	  value: valueType,
	  defaultValue: valueType,
	  dropdownStyle: _propTypes2['default'].object,
	  maxTagTextLength: _propTypes2['default'].number,
	  maxTagCount: _propTypes2['default'].number,
	  maxTagPlaceholder: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	  tokenSeparators: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  getInputElement: _propTypes2['default'].func,
	  showAction: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
	};

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SelectPropTypes = exports.OptGroup = exports.Option = undefined;
	
	var _Select = __webpack_require__(2574);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Option = __webpack_require__(2573);
	
	var _Option2 = _interopRequireDefault(_Option);
	
	var _PropTypes = __webpack_require__(1173);
	
	var _OptGroup = __webpack_require__(2572);
	
	var _OptGroup2 = _interopRequireDefault(_OptGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Select2['default'].Option = _Option2['default'];
	_Select2['default'].OptGroup = _OptGroup2['default'];
	exports.Option = _Option2['default'];
	exports.OptGroup = _OptGroup2['default'];
	exports.SelectPropTypes = _PropTypes.SelectPropTypes;
	exports['default'] = _Select2['default'];

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Track = __webpack_require__(1177);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(1178);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(477);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable react/prop-types */
	var Range = function (_React$Component) {
	  (0, _inherits3['default'])(Range, _React$Component);
	
	  function Range(props) {
	    (0, _classCallCheck3['default'])(this, Range);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({ handle: null });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var count = props.count,
	        min = props.min,
	        max = props.max;
	
	    var initialValue = Array.apply(null, Array(count + 1)).map(function () {
	      return min;
	    });
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    var bounds = value.map(function (v) {
	      return _this.trimAlignValue(v);
	    });
	    var recent = bounds[0] === max ? 0 : bounds.length - 1;
	
	    _this.state = {
	      handle: null,
	      recent: recent,
	      bounds: bounds
	    };
	    return _this;
	  }
	
	  Range.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	    if (this.props.min === nextProps.min && this.props.max === nextProps.max && (0, _shallowequal2['default'])(this.props.value, nextProps.value)) {
	      return;
	    }
	    var bounds = this.state.bounds;
	
	    var value = nextProps.value || bounds;
	    var nextBounds = value.map(function (v) {
	      return _this2.trimAlignValue(v, nextProps);
	    });
	    if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
	      return v === bounds[i];
	    })) return;
	
	    this.setState({ bounds: nextBounds });
	    if (bounds.some(function (v) {
	      return utils.isValueOutOfRange(v, nextProps);
	    })) {
	      this.props.onChange(nextBounds);
	    }
	  };
	
	  Range.prototype.onChange = function onChange(state) {
	    var props = this.props;
	    var isNotControlled = !('value' in props);
	    if (isNotControlled) {
	      this.setState(state);
	    } else if (state.handle !== undefined) {
	      this.setState({ handle: state.handle });
	    }
	
	    var data = (0, _extends3['default'])({}, this.state, state);
	    var changedValue = data.bounds;
	    props.onChange(changedValue);
	  };
	
	  Range.prototype.onStart = function onStart(position) {
	    var props = this.props;
	    var state = this.state;
	    var bounds = this.getValue();
	    props.onBeforeChange(bounds);
	
	    var value = this.calcValueByPos(position);
	    this.startValue = value;
	    this.startPosition = position;
	
	    var closestBound = this.getClosestBound(value);
	    var boundNeedMoving = this.getBoundNeedMoving(value, closestBound);
	
	    this.setState({
	      handle: boundNeedMoving,
	      recent: boundNeedMoving
	    });
	
	    var prevValue = bounds[boundNeedMoving];
	    if (value === prevValue) return;
	
	    var nextBounds = [].concat(state.bounds);
	    nextBounds[boundNeedMoving] = value;
	    this.onChange({ bounds: nextBounds });
	  };
	
	  Range.prototype.onMove = function onMove(e, position) {
	    utils.pauseEvent(e);
	    var props = this.props;
	    var state = this.state;
	
	    var value = this.calcValueByPos(position);
	    var oldValue = state.bounds[state.handle];
	    if (value === oldValue) return;
	
	    var nextBounds = [].concat(state.bounds);
	    nextBounds[state.handle] = value;
	    var nextHandle = state.handle;
	    if (props.pushable !== false) {
	      var originalValue = state.bounds[nextHandle];
	      this.pushSurroundingHandles(nextBounds, nextHandle, originalValue);
	    } else if (props.allowCross) {
	      nextBounds.sort(function (a, b) {
	        return a - b;
	      });
	      nextHandle = nextBounds.indexOf(value);
	    }
	    this.onChange({
	      handle: nextHandle,
	      bounds: nextBounds
	    });
	  };
	
	  Range.prototype.onKeyboard = function onKeyboard() {
	    (0, _warning2['default'])(true, 'Keyboard support is not yet supported for ranges.');
	  };
	
	  Range.prototype.getValue = function getValue() {
	    return this.state.bounds;
	  };
	
	  Range.prototype.getClosestBound = function getClosestBound(value) {
	    var bounds = this.state.bounds;
	
	    var closestBound = 0;
	    for (var i = 1; i < bounds.length - 1; ++i) {
	      if (value > bounds[i]) {
	        closestBound = i;
	      }
	    }
	    if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
	      closestBound = closestBound + 1;
	    }
	    return closestBound;
	  };
	
	  Range.prototype.getBoundNeedMoving = function getBoundNeedMoving(value, closestBound) {
	    var _state = this.state,
	        bounds = _state.bounds,
	        recent = _state.recent;
	
	    var boundNeedMoving = closestBound;
	    var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
	
	    if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
	      boundNeedMoving = recent;
	    }
	
	    if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
	      boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
	    }
	    return boundNeedMoving;
	  };
	
	  Range.prototype.getLowerBound = function getLowerBound() {
	    return this.state.bounds[0];
	  };
	
	  Range.prototype.getUpperBound = function getUpperBound() {
	    var bounds = this.state.bounds;
	
	    return bounds[bounds.length - 1];
	  };
	
	  /**
	   * Returns an array of possible slider points, taking into account both
	   * `marks` and `step`. The result is cached.
	   */
	
	
	  Range.prototype.getPoints = function getPoints() {
	    var _props = this.props,
	        marks = _props.marks,
	        step = _props.step,
	        min = _props.min,
	        max = _props.max;
	
	    var cache = this._getPointsCache;
	    if (!cache || cache.marks !== marks || cache.step !== step) {
	      var pointsObject = (0, _extends3['default'])({}, marks);
	      if (step !== null) {
	        for (var point = min; point <= max; point += step) {
	          pointsObject[point] = point;
	        }
	      }
	      var points = Object.keys(pointsObject).map(parseFloat);
	      points.sort(function (a, b) {
	        return a - b;
	      });
	      this._getPointsCache = { marks: marks, step: step, points: points };
	    }
	    return this._getPointsCache.points;
	  };
	
	  Range.prototype.pushSurroundingHandles = function pushSurroundingHandles(bounds, handle, originalValue) {
	    var threshold = this.props.pushable;
	
	    var value = bounds[handle];
	
	    var direction = 0;
	    if (bounds[handle + 1] - value < threshold) {
	      direction = +1; // push to right
	    }
	    if (value - bounds[handle - 1] < threshold) {
	      direction = -1; // push to left
	    }
	
	    if (direction === 0) {
	      return;
	    }
	
	    var nextHandle = handle + direction;
	    var diffToNext = direction * (bounds[nextHandle] - value);
	    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	      // revert to original value if pushing is impossible
	      bounds[handle] = originalValue;
	    }
	  };
	
	  Range.prototype.pushHandle = function pushHandle(bounds, handle, direction, amount) {
	    var originalValue = bounds[handle];
	    var currentValue = bounds[handle];
	    while (direction * (currentValue - originalValue) < amount) {
	      if (!this.pushHandleOnePoint(bounds, handle, direction)) {
	        // can't push handle enough to create the needed `amount` gap, so we
	        // revert its position to the original value
	        bounds[handle] = originalValue;
	        return false;
	      }
	      currentValue = bounds[handle];
	    }
	    // the handle was pushed enough to create the needed `amount` gap
	    return true;
	  };
	
	  Range.prototype.pushHandleOnePoint = function pushHandleOnePoint(bounds, handle, direction) {
	    var points = this.getPoints();
	    var pointIndex = points.indexOf(bounds[handle]);
	    var nextPointIndex = pointIndex + direction;
	    if (nextPointIndex >= points.length || nextPointIndex < 0) {
	      // reached the minimum or maximum available point, can't push anymore
	      return false;
	    }
	    var nextHandle = handle + direction;
	    var nextValue = points[nextPointIndex];
	    var threshold = this.props.pushable;
	
	    var diffToNext = direction * (bounds[nextHandle] - nextValue);
	    if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	      // couldn't push next handle, so we won't push this one either
	      return false;
	    }
	    // push the handle
	    bounds[handle] = nextValue;
	    return true;
	  };
	
	  Range.prototype.trimAlignValue = function trimAlignValue(v) {
	    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	    var valInRange = utils.ensureValueInRange(v, mergedProps);
	    var valNotConflict = this.ensureValueNotConflict(valInRange, mergedProps);
	    return utils.ensureValuePrecision(valNotConflict, mergedProps);
	  };
	
	  Range.prototype.ensureValueNotConflict = function ensureValueNotConflict(val, _ref) {
	    var allowCross = _ref.allowCross;
	
	    var state = this.state || {};
	    var handle = state.handle,
	        bounds = state.bounds;
	    /* eslint-disable eqeqeq */
	
	    if (!allowCross && handle != null) {
	      if (handle > 0 && val <= bounds[handle - 1]) {
	        return bounds[handle - 1];
	      }
	      if (handle < bounds.length - 1 && val >= bounds[handle + 1]) {
	        return bounds[handle + 1];
	      }
	    }
	    /* eslint-enable eqeqeq */
	    return val;
	  };
	
	  Range.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state2 = this.state,
	        handle = _state2.handle,
	        bounds = _state2.bounds;
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        vertical = _props2.vertical,
	        included = _props2.included,
	        disabled = _props2.disabled,
	        min = _props2.min,
	        max = _props2.max,
	        handleGenerator = _props2.handle,
	        trackStyle = _props2.trackStyle,
	        handleStyle = _props2.handleStyle;
	
	
	    var offsets = bounds.map(function (v) {
	      return _this3.calcOffset(v);
	    });
	
	    var handleClassName = prefixCls + '-handle';
	    var handles = bounds.map(function (v, i) {
	      var _classNames;
	
	      return handleGenerator({
	        className: (0, _classnames2['default'])((_classNames = {}, _classNames[handleClassName] = true, _classNames[handleClassName + '-' + (i + 1)] = true, _classNames)),
	        vertical: vertical,
	        offset: offsets[i],
	        value: v,
	        dragging: handle === i,
	        index: i,
	        min: min,
	        max: max,
	        disabled: disabled,
	        style: handleStyle[i],
	        ref: function ref(h) {
	          return _this3.saveHandle(i, h);
	        }
	      });
	    });
	
	    var tracks = bounds.slice(0, -1).map(function (_, index) {
	      var _classNames2;
	
	      var i = index + 1;
	      var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, _classNames2[prefixCls + '-track'] = true, _classNames2[prefixCls + '-track-' + i] = true, _classNames2));
	      return _react2['default'].createElement(_Track2['default'], {
	        className: trackClassName,
	        vertical: vertical,
	        included: included,
	        offset: offsets[i - 1],
	        length: offsets[i] - offsets[i - 1],
	        style: trackStyle[index],
	        key: i
	      });
	    });
	
	    return { tracks: tracks, handles: handles };
	  };
	
	  return Range;
	}(_react2['default'].Component);
	
	Range.displayName = 'Range';
	Range.propTypes = {
	  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  count: _propTypes2['default'].number,
	  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
	  allowCross: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool
	};
	Range.defaultProps = {
	  count: 1,
	  allowCross: true,
	  pushable: false
	};
	exports['default'] = (0, _createSlider2['default'])(Range);
	module.exports = exports['default'];

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Track = __webpack_require__(1177);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(1178);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(477);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable react/prop-types */
	var Slider = function (_React$Component) {
	  (0, _inherits3['default'])(Slider, _React$Component);
	
	  function Slider(props) {
	    (0, _classCallCheck3['default'])(this, Slider);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onEnd = function () {
	      _this.setState({ dragging: false });
	      _this.removeDocumentEvents();
	      _this.props.onAfterChange(_this.getValue());
	    };
	
	    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
	    var value = props.value !== undefined ? props.value : defaultValue;
	
	    _this.state = {
	      value: _this.trimAlignValue(value),
	      dragging: false
	    };
	    if (false) {
	      (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
	      (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
	    }
	    return _this;
	  }
	
	  Slider.prototype.componentDidMount = function componentDidMount() {
	    var _props = this.props,
	        autoFocus = _props.autoFocus,
	        disabled = _props.disabled;
	
	    if (autoFocus && !disabled) {
	      this.focus();
	    }
	  };
	
	  Slider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
	
	    var prevValue = this.state.value;
	    var value = nextProps.value !== undefined ? nextProps.value : prevValue;
	    var nextValue = this.trimAlignValue(value, nextProps);
	    if (nextValue === prevValue) return;
	
	    this.setState({ value: nextValue });
	    if (utils.isValueOutOfRange(value, nextProps)) {
	      this.props.onChange(nextValue);
	    }
	  };
	
	  Slider.prototype.onChange = function onChange(state) {
	    var props = this.props;
	    var isNotControlled = !('value' in props);
	    if (isNotControlled) {
	      this.setState(state);
	    }
	
	    var changedValue = state.value;
	    props.onChange(changedValue);
	  };
	
	  Slider.prototype.onStart = function onStart(position) {
	    this.setState({ dragging: true });
	    var props = this.props;
	    var prevValue = this.getValue();
	    props.onBeforeChange(prevValue);
	
	    var value = this.calcValueByPos(position);
	    this.startValue = value;
	    this.startPosition = position;
	
	    if (value === prevValue) return;
	
	    this.onChange({ value: value });
	  };
	
	  Slider.prototype.onMove = function onMove(e, position) {
	    utils.pauseEvent(e);
	    var oldValue = this.state.value;
	
	    var value = this.calcValueByPos(position);
	    if (value === oldValue) return;
	
	    this.onChange({ value: value });
	  };
	
	  Slider.prototype.onKeyboard = function onKeyboard(e) {
	    var valueMutator = utils.getKeyboardValueMutator(e);
	
	    if (valueMutator) {
	      utils.pauseEvent(e);
	      var state = this.state;
	      var oldValue = state.value;
	      var mutatedValue = valueMutator(oldValue, this.props);
	      var value = this.trimAlignValue(mutatedValue);
	      if (value === oldValue) return;
	
	      this.onChange({ value: value });
	    }
	  };
	
	  Slider.prototype.getValue = function getValue() {
	    return this.state.value;
	  };
	
	  Slider.prototype.getLowerBound = function getLowerBound() {
	    return this.props.min;
	  };
	
	  Slider.prototype.getUpperBound = function getUpperBound() {
	    return this.state.value;
	  };
	
	  Slider.prototype.trimAlignValue = function trimAlignValue(v) {
	    var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	    var val = utils.ensureValueInRange(v, mergedProps);
	    return utils.ensureValuePrecision(val, mergedProps);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        vertical = _props2.vertical,
	        included = _props2.included,
	        disabled = _props2.disabled,
	        minimumTrackStyle = _props2.minimumTrackStyle,
	        trackStyle = _props2.trackStyle,
	        handleStyle = _props2.handleStyle,
	        min = _props2.min,
	        max = _props2.max,
	        handleGenerator = _props2.handle;
	    var _state = this.state,
	        value = _state.value,
	        dragging = _state.dragging;
	
	    var offset = this.calcOffset(value);
	    var handle = handleGenerator({
	      className: prefixCls + '-handle',
	      vertical: vertical,
	      offset: offset,
	      value: value,
	      dragging: dragging,
	      disabled: disabled,
	      min: min,
	      max: max,
	      index: 0,
	      style: handleStyle[0] || handleStyle,
	      ref: function ref(h) {
	        return _this2.saveHandle(0, h);
	      }
	    });
	
	    var _trackStyle = trackStyle[0] || trackStyle;
	    var track = _react2['default'].createElement(_Track2['default'], {
	      className: prefixCls + '-track',
	      vertical: vertical,
	      included: included,
	      offset: 0,
	      length: offset,
	      style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
	    });
	
	    return { tracks: track, handles: handle };
	  };
	
	  return Slider;
	}(_react2['default'].Component);
	
	Slider.propTypes = {
	  defaultValue: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  disabled: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool
	};
	exports['default'] = (0, _createSlider2['default'])(Slider);
	module.exports = exports['default'];

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Track = function Track(props) {
	  var className = props.className,
	      included = props.included,
	      vertical = props.vertical,
	      offset = props.offset,
	      length = props.length,
	      style = props.style;
	
	
	  var positonStyle = vertical ? {
	    bottom: offset + '%',
	    height: length + '%'
	  } : {
	    left: offset + '%',
	    width: length + '%'
	  };
	
	  var elStyle = (0, _extends3['default'])({
	    visibility: included ? 'visible' : 'hidden'
	  }, style, positonStyle);
	  return _react2['default'].createElement('div', { className: className, style: elStyle });
	}; /* eslint-disable react/prop-types */
	exports['default'] = Track;
	module.exports = exports['default'];

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSlider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Steps = __webpack_require__(2577);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Marks = __webpack_require__(2576);
	
	var _Marks2 = _interopRequireDefault(_Marks);
	
	var _Handle = __webpack_require__(328);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _utils = __webpack_require__(477);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function createSlider(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    (0, _inherits3['default'])(ComponentEnhancer, _Component);
	
	    function ComponentEnhancer(props) {
	      (0, _classCallCheck3['default'])(this, ComponentEnhancer);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	      _this.onMouseDown = function (e) {
	        if (e.button !== 0) {
	          return;
	        }
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getMousePosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.removeDocumentEvents();
	        _this.onStart(position);
	        _this.addDocumentMouseEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onTouchStart = function (e) {
	        if (utils.isNotTouchEvent(e)) return;
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getTouchPosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.onStart(position);
	        _this.addDocumentTouchEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onFocus = function (e) {
	        var _this$props = _this.props,
	            onFocus = _this$props.onFocus,
	            vertical = _this$props.vertical;
	
	        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
	          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
	          _this.dragOffset = 0;
	          _this.onStart(handlePosition);
	          utils.pauseEvent(e);
	          if (onFocus) {
	            onFocus(e);
	          }
	        }
	      };
	
	      _this.onBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        _this.onEnd(e);
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.onMouseUp = function () {
	        _this.onEnd();
	        _this.removeDocumentEvents();
	      };
	
	      _this.onMouseMove = function (e) {
	        if (!_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	        var position = utils.getMousePosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onTouchMove = function (e) {
	        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	
	        var position = utils.getTouchPosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onKeyDown = function (e) {
	        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.onKeyboard(e);
	        }
	      };
	
	      _this.saveSlider = function (slider) {
	        _this.sliderRef = slider;
	      };
	
	      if (false) {
	        var step = props.step,
	            max = props.max,
	            min = props.min;
	
	        (0, _warning2['default'])(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
	      }
	      _this.handlesRefs = {};
	      return _this;
	    }
	
	    ComponentEnhancer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (_Component.prototype.componentWillUnmount) _Component.prototype.componentWillUnmount.call(this);
	      this.removeDocumentEvents();
	    };
	
	    ComponentEnhancer.prototype.componentDidMount = function componentDidMount() {
	      // Snapshot testing cannot handle refs, so be sure to null-check this.
	      this.document = this.sliderRef && this.sliderRef.ownerDocument;
	    };
	
	    ComponentEnhancer.prototype.addDocumentTouchEvents = function addDocumentTouchEvents() {
	      // just work for Chrome iOS Safari and Android Browser
	      this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
	      this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
	    };
	
	    ComponentEnhancer.prototype.addDocumentMouseEvents = function addDocumentMouseEvents() {
	      this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
	      this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
	    };
	
	    ComponentEnhancer.prototype.removeDocumentEvents = function removeDocumentEvents() {
	      /* eslint-disable no-unused-expressions */
	      this.onTouchMoveListener && this.onTouchMoveListener.remove();
	      this.onTouchUpListener && this.onTouchUpListener.remove();
	
	      this.onMouseMoveListener && this.onMouseMoveListener.remove();
	      this.onMouseUpListener && this.onMouseUpListener.remove();
	      /* eslint-enable no-unused-expressions */
	    };
	
	    ComponentEnhancer.prototype.focus = function focus() {
	      if (!this.props.disabled) {
	        this.handlesRefs[0].focus();
	      }
	    };
	
	    ComponentEnhancer.prototype.blur = function blur() {
	      if (!this.props.disabled) {
	        this.handlesRefs[0].blur();
	      }
	    };
	
	    ComponentEnhancer.prototype.getSliderStart = function getSliderStart() {
	      var slider = this.sliderRef;
	      var rect = slider.getBoundingClientRect();
	
	      return this.props.vertical ? rect.top : rect.left;
	    };
	
	    ComponentEnhancer.prototype.getSliderLength = function getSliderLength() {
	      var slider = this.sliderRef;
	      if (!slider) {
	        return 0;
	      }
	
	      var coords = slider.getBoundingClientRect();
	      return this.props.vertical ? coords.height : coords.width;
	    };
	
	    ComponentEnhancer.prototype.calcValue = function calcValue(offset) {
	      var _props = this.props,
	          vertical = _props.vertical,
	          min = _props.min,
	          max = _props.max;
	
	      var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
	      var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	      return value;
	    };
	
	    ComponentEnhancer.prototype.calcValueByPos = function calcValueByPos(position) {
	      var pixelOffset = position - this.getSliderStart();
	      var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	      return nextValue;
	    };
	
	    ComponentEnhancer.prototype.calcOffset = function calcOffset(value) {
	      var _props2 = this.props,
	          min = _props2.min,
	          max = _props2.max;
	
	      var ratio = (value - min) / (max - min);
	      return ratio * 100;
	    };
	
	    ComponentEnhancer.prototype.saveHandle = function saveHandle(index, handle) {
	      this.handlesRefs[index] = handle;
	    };
	
	    ComponentEnhancer.prototype.render = function render() {
	      var _classNames;
	
	      var _props3 = this.props,
	          prefixCls = _props3.prefixCls,
	          className = _props3.className,
	          marks = _props3.marks,
	          dots = _props3.dots,
	          step = _props3.step,
	          included = _props3.included,
	          disabled = _props3.disabled,
	          vertical = _props3.vertical,
	          min = _props3.min,
	          max = _props3.max,
	          children = _props3.children,
	          maximumTrackStyle = _props3.maximumTrackStyle,
	          style = _props3.style,
	          railStyle = _props3.railStyle,
	          dotStyle = _props3.dotStyle,
	          activeDotStyle = _props3.activeDotStyle;
	
	      var _Component$prototype$ = _Component.prototype.render.call(this),
	          tracks = _Component$prototype$.tracks,
	          handles = _Component$prototype$.handles;
	
	      var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, _classNames[prefixCls + '-with-marks'] = Object.keys(marks).length, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-vertical'] = vertical, _classNames[className] = className, _classNames));
	      return _react2['default'].createElement(
	        'div',
	        {
	          ref: this.saveSlider,
	          className: sliderClassName,
	          onTouchStart: disabled ? noop : this.onTouchStart,
	          onMouseDown: disabled ? noop : this.onMouseDown,
	          onMouseUp: disabled ? noop : this.onMouseUp,
	          onKeyDown: disabled ? noop : this.onKeyDown,
	          onFocus: disabled ? noop : this.onFocus,
	          onBlur: disabled ? noop : this.onBlur,
	          style: style
	        },
	        _react2['default'].createElement('div', {
	          className: prefixCls + '-rail',
	          style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
	        }),
	        tracks,
	        _react2['default'].createElement(_Steps2['default'], {
	          prefixCls: prefixCls,
	          vertical: vertical,
	          marks: marks,
	          dots: dots,
	          step: step,
	          included: included,
	          lowerBound: this.getLowerBound(),
	          upperBound: this.getUpperBound(),
	          max: max,
	          min: min,
	          dotStyle: dotStyle,
	          activeDotStyle: activeDotStyle
	        }),
	        handles,
	        _react2['default'].createElement(_Marks2['default'], {
	          className: prefixCls + '-mark',
	          vertical: vertical,
	          marks: marks,
	          included: included,
	          lowerBound: this.getLowerBound(),
	          upperBound: this.getUpperBound(),
	          max: max,
	          min: min
	        }),
	        children
	      );
	    };
	
	    return ComponentEnhancer;
	  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
	    min: _propTypes2['default'].number,
	    max: _propTypes2['default'].number,
	    step: _propTypes2['default'].number,
	    marks: _propTypes2['default'].object,
	    included: _propTypes2['default'].bool,
	    className: _propTypes2['default'].string,
	    prefixCls: _propTypes2['default'].string,
	    disabled: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any,
	    onBeforeChange: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    onAfterChange: _propTypes2['default'].func,
	    handle: _propTypes2['default'].func,
	    dots: _propTypes2['default'].bool,
	    vertical: _propTypes2['default'].bool,
	    style: _propTypes2['default'].object,
	    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    railStyle: _propTypes2['default'].object,
	    dotStyle: _propTypes2['default'].object,
	    activeDotStyle: _propTypes2['default'].object,
	    autoFocus: _propTypes2['default'].bool,
	    onFocus: _propTypes2['default'].func,
	    onBlur: _propTypes2['default'].func
	  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
	    prefixCls: 'rc-slider',
	    className: '',
	    min: 0,
	    max: 100,
	    step: 1,
	    marks: {},
	    handle: function handle(_ref) {
	      var index = _ref.index,
	          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);
	
	      delete restProps.dragging;
	      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
	    },
	
	    onBeforeChange: noop,
	    onChange: noop,
	    onAfterChange: noop,
	    included: true,
	    disabled: false,
	    dots: false,
	    vertical: false,
	    trackStyle: [{}],
	    handleStyle: [{}],
	    railStyle: {},
	    dotStyle: {},
	    activeDotStyle: {}
	  }), _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _miniStore = __webpack_require__(190);
	
	var _ColGroup = __webpack_require__(2587);
	
	var _ColGroup2 = _interopRequireDefault(_ColGroup);
	
	var _TableHeader = __webpack_require__(2597);
	
	var _TableHeader2 = _interopRequireDefault(_TableHeader);
	
	var _TableRow = __webpack_require__(1180);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _ExpandableRow = __webpack_require__(2592);
	
	var _ExpandableRow2 = _interopRequireDefault(_ExpandableRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var BaseTable = function (_React$Component) {
	  (0, _inherits3['default'])(BaseTable, _React$Component);
	
	  function BaseTable() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, BaseTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleRowHover = function (isHover, key) {
	      _this.props.store.setState({
	        currentHoverKey: isHover ? key : null
	      });
	    }, _this.renderRows = function (renderData, indent) {
	      var ancestorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	      var table = _this.context.table;
	      var columnManager = table.columnManager,
	          components = table.components;
	      var _table$props = table.props,
	          prefixCls = _table$props.prefixCls,
	          childrenColumnName = _table$props.childrenColumnName,
	          rowClassName = _table$props.rowClassName,
	          rowRef = _table$props.rowRef,
	          onRowClick = _table$props.onRowClick,
	          onRowDoubleClick = _table$props.onRowDoubleClick,
	          onRowContextMenu = _table$props.onRowContextMenu,
	          onRowMouseEnter = _table$props.onRowMouseEnter,
	          onRowMouseLeave = _table$props.onRowMouseLeave,
	          onRow = _table$props.onRow;
	      var _this$props = _this.props,
	          getRowKey = _this$props.getRowKey,
	          fixed = _this$props.fixed,
	          expander = _this$props.expander;
	
	
	      var rows = [];
	
	      var _loop = function _loop(i) {
	        var record = renderData[i];
	        var key = getRowKey(record, i);
	        var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);
	
	        var onHoverProps = {};
	        if (columnManager.isAnyColumnsFixed()) {
	          onHoverProps.onHover = _this.handleRowHover;
	        }
	
	        var leafColumns = void 0;
	        if (fixed === 'left') {
	          leafColumns = columnManager.leftLeafColumns();
	        } else if (fixed === 'right') {
	          leafColumns = columnManager.rightLeafColumns();
	        } else {
	          leafColumns = columnManager.leafColumns();
	        }
	
	        var rowPrefixCls = prefixCls + '-row';
	
	        var row = _react2['default'].createElement(
	          _ExpandableRow2['default'],
	          (0, _extends3['default'])({}, expander.props, {
	            fixed: fixed,
	            index: i,
	            prefixCls: rowPrefixCls,
	            record: record,
	            key: key,
	            rowKey: key,
	            onRowClick: onRowClick,
	            needIndentSpaced: expander.needIndentSpaced,
	            onExpandedChange: expander.handleExpandChange
	          }),
	          function (expandableRow) {
	            return (// eslint-disable-line
	              _react2['default'].createElement(_TableRow2['default'], (0, _extends3['default'])({
	                fixed: fixed,
	                indent: indent,
	                className: className,
	                record: record,
	                index: i,
	                prefixCls: rowPrefixCls,
	                childrenColumnName: childrenColumnName,
	                columns: leafColumns,
	                onRow: onRow,
	                onRowDoubleClick: onRowDoubleClick,
	                onRowContextMenu: onRowContextMenu,
	                onRowMouseEnter: onRowMouseEnter,
	                onRowMouseLeave: onRowMouseLeave
	              }, onHoverProps, {
	                rowKey: key,
	                ancestorKeys: ancestorKeys,
	                ref: rowRef(record, i, indent),
	                components: components
	              }, expandableRow))
	            );
	          }
	        );
	
	        rows.push(row);
	
	        expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
	      };
	
	      for (var i = 0; i < renderData.length; i++) {
	        _loop(i);
	      }
	      return rows;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  BaseTable.prototype.render = function render() {
	    var table = this.context.table;
	    var components = table.components;
	    var _table$props2 = table.props,
	        prefixCls = _table$props2.prefixCls,
	        scroll = _table$props2.scroll,
	        data = _table$props2.data,
	        getBodyWrapper = _table$props2.getBodyWrapper;
	    var _props = this.props,
	        expander = _props.expander,
	        tableClassName = _props.tableClassName,
	        hasHead = _props.hasHead,
	        hasBody = _props.hasBody,
	        fixed = _props.fixed,
	        columns = _props.columns;
	
	    var tableStyle = {};
	
	    if (!fixed && scroll.x) {
	      // not set width, then use content fixed width
	      if (scroll.x === true) {
	        tableStyle.tableLayout = 'fixed';
	      } else {
	        tableStyle.width = scroll.x;
	      }
	    }
	
	    var Table = hasBody ? components.table : 'table';
	    var BodyWrapper = components.body.wrapper;
	
	    var body = void 0;
	    if (hasBody) {
	      body = _react2['default'].createElement(
	        BodyWrapper,
	        { className: prefixCls + '-tbody' },
	        this.renderRows(data, 0)
	      );
	      if (getBodyWrapper) {
	        body = getBodyWrapper(body);
	      }
	    }
	
	    return _react2['default'].createElement(
	      Table,
	      { className: tableClassName, style: tableStyle, key: 'table' },
	      _react2['default'].createElement(_ColGroup2['default'], { columns: columns, fixed: fixed }),
	      hasHead && _react2['default'].createElement(_TableHeader2['default'], { expander: expander, columns: columns, fixed: fixed }),
	      body
	    );
	  };
	
	  return BaseTable;
	}(_react2['default'].Component);
	
	BaseTable.propTypes = {
	  fixed: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  columns: _propTypes2['default'].array.isRequired,
	  tableClassName: _propTypes2['default'].string.isRequired,
	  hasHead: _propTypes2['default'].bool.isRequired,
	  hasBody: _propTypes2['default'].bool.isRequired,
	  store: _propTypes2['default'].object.isRequired,
	  expander: _propTypes2['default'].object.isRequired,
	  getRowKey: _propTypes2['default'].func
	};
	BaseTable.contextTypes = {
	  table: _propTypes2['default'].any
	};
	exports['default'] = (0, _miniStore.connect)()(BaseTable);
	module.exports = exports['default'];

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _miniStore = __webpack_require__(190);
	
	var _TableCell = __webpack_require__(2596);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _utils = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TableRow = function (_React$Component) {
	  (0, _inherits3['default'])(TableRow, _React$Component);
	
	  function TableRow(props) {
	    (0, _classCallCheck3['default'])(this, TableRow);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onRowClick = function (event) {
	      var _this$props = _this.props,
	          record = _this$props.record,
	          index = _this$props.index,
	          onRowClick = _this$props.onRowClick;
	
	      if (onRowClick) {
	        onRowClick(record, index, event);
	      }
	    };
	
	    _this.onRowDoubleClick = function (event) {
	      var _this$props2 = _this.props,
	          record = _this$props2.record,
	          index = _this$props2.index,
	          onRowDoubleClick = _this$props2.onRowDoubleClick;
	
	      if (onRowDoubleClick) {
	        onRowDoubleClick(record, index, event);
	      }
	    };
	
	    _this.onContextMenu = function (event) {
	      var _this$props3 = _this.props,
	          record = _this$props3.record,
	          index = _this$props3.index,
	          onRowContextMenu = _this$props3.onRowContextMenu;
	
	      if (onRowContextMenu) {
	        onRowContextMenu(record, index, event);
	      }
	    };
	
	    _this.onMouseEnter = function (event) {
	      var _this$props4 = _this.props,
	          record = _this$props4.record,
	          index = _this$props4.index,
	          onRowMouseEnter = _this$props4.onRowMouseEnter,
	          onHover = _this$props4.onHover,
	          rowKey = _this$props4.rowKey;
	
	      onHover(true, rowKey);
	      if (onRowMouseEnter) {
	        onRowMouseEnter(record, index, event);
	      }
	    };
	
	    _this.onMouseLeave = function (event) {
	      var _this$props5 = _this.props,
	          record = _this$props5.record,
	          index = _this$props5.index,
	          onRowMouseLeave = _this$props5.onRowMouseLeave,
	          onHover = _this$props5.onHover,
	          rowKey = _this$props5.rowKey;
	
	      onHover(false, rowKey);
	      if (onRowMouseLeave) {
	        onRowMouseLeave(record, index, event);
	      }
	    };
	
	    _this.shouldRender = props.visible;
	    return _this;
	  }
	
	  TableRow.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldRender) {
	      this.saveRowRef();
	    }
	  };
	
	  TableRow.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.visible || !this.props.visible && nextProps.visible) {
	      this.shouldRender = true;
	    }
	  };
	
	  TableRow.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return !!(this.props.visible || nextProps.visible);
	  };
	
	  TableRow.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.shouldRender && !this.rowRef) {
	      this.saveRowRef();
	    }
	  };
	
	  TableRow.prototype.setHeight = function setHeight() {
	    var _props = this.props,
	        store = _props.store,
	        rowKey = _props.rowKey;
	
	    var _store$getState = store.getState(),
	        expandedRowsHeight = _store$getState.expandedRowsHeight;
	
	    var height = this.rowRef.getBoundingClientRect().height;
	    expandedRowsHeight[rowKey] = height;
	    store.setState({ expandedRowsHeight: expandedRowsHeight });
	  };
	
	  TableRow.prototype.getStyle = function getStyle() {
	    var _props2 = this.props,
	        height = _props2.height,
	        visible = _props2.visible;
	
	
	    if (height && height !== this.style.height) {
	      this.style = (0, _extends3['default'])({}, this.style, { height: height });
	    }
	
	    if (!visible && !this.style.display) {
	      this.style = (0, _extends3['default'])({}, this.style, { display: 'none' });
	    }
	
	    return this.style;
	  };
	
	  TableRow.prototype.saveRowRef = function saveRowRef() {
	    this.rowRef = _reactDom2['default'].findDOMNode(this);
	
	    if (!this.props.fixed && this.props.expandedRow) {
	      this.setHeight();
	    }
	  };
	
	  TableRow.prototype.render = function render() {
	    if (!this.shouldRender) {
	      return null;
	    }
	
	    var _props3 = this.props,
	        prefixCls = _props3.prefixCls,
	        columns = _props3.columns,
	        record = _props3.record,
	        index = _props3.index,
	        onRow = _props3.onRow,
	        indent = _props3.indent,
	        indentSize = _props3.indentSize,
	        hovered = _props3.hovered,
	        height = _props3.height,
	        visible = _props3.visible,
	        components = _props3.components,
	        hasExpandIcon = _props3.hasExpandIcon,
	        renderExpandIcon = _props3.renderExpandIcon,
	        renderExpandIconCell = _props3.renderExpandIconCell;
	
	
	    var BodyRow = components.body.row;
	    var BodyCell = components.body.cell;
	
	    var className = this.props.className;
	
	
	    if (hovered) {
	      className += ' ' + prefixCls + '-hover';
	    }
	
	    var cells = [];
	
	    renderExpandIconCell(cells);
	
	    for (var i = 0; i < columns.length; i++) {
	      var column = columns[i];
	
	      (0, _utils.warningOnce)(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');
	
	      cells.push(_react2['default'].createElement(_TableCell2['default'], {
	        prefixCls: prefixCls,
	        record: record,
	        indentSize: indentSize,
	        indent: indent,
	        index: index,
	        column: column,
	        key: column.key || column.dataIndex,
	        expandIcon: hasExpandIcon(i) && renderExpandIcon(),
	        component: BodyCell
	      }));
	    }
	
	    var rowClassName = (prefixCls + ' ' + className + ' ' + prefixCls + '-level-' + indent).trim();
	
	    var rowProps = onRow(record, index);
	    var customStyle = rowProps ? rowProps.style : {};
	    var style = { height: height };
	
	    if (!visible) {
	      style.display = 'none';
	    }
	
	    style = (0, _extends3['default'])({}, style, customStyle);
	
	    return _react2['default'].createElement(
	      BodyRow,
	      (0, _extends3['default'])({
	        onClick: this.onRowClick,
	        onDoubleClick: this.onRowDoubleClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onContextMenu: this.onContextMenu,
	        className: rowClassName
	      }, rowProps, {
	        style: style
	      }),
	      cells
	    );
	  };
	
	  return TableRow;
	}(_react2['default'].Component);
	
	TableRow.propTypes = {
	  onRow: _propTypes2['default'].func,
	  onRowClick: _propTypes2['default'].func,
	  onRowDoubleClick: _propTypes2['default'].func,
	  onRowContextMenu: _propTypes2['default'].func,
	  onRowMouseEnter: _propTypes2['default'].func,
	  onRowMouseLeave: _propTypes2['default'].func,
	  record: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  onHover: _propTypes2['default'].func,
	  columns: _propTypes2['default'].array,
	  height: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  index: _propTypes2['default'].number,
	  rowKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]).isRequired,
	  className: _propTypes2['default'].string,
	  indent: _propTypes2['default'].number,
	  indentSize: _propTypes2['default'].number,
	  hasExpandIcon: _propTypes2['default'].func.isRequired,
	  hovered: _propTypes2['default'].bool.isRequired,
	  visible: _propTypes2['default'].bool.isRequired,
	  store: _propTypes2['default'].object.isRequired,
	  fixed: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  renderExpandIcon: _propTypes2['default'].func,
	  renderExpandIconCell: _propTypes2['default'].func,
	  components: _propTypes2['default'].any,
	  expandedRow: _propTypes2['default'].bool
	};
	TableRow.defaultProps = {
	  onRow: function onRow() {},
	
	  expandIconColumnIndex: 0,
	  expandRowByClick: false,
	  onHover: function onHover() {},
	  hasExpandIcon: function hasExpandIcon() {},
	  renderExpandIcon: function renderExpandIcon() {},
	  renderExpandIconCell: function renderExpandIconCell() {}
	};
	
	
	function getRowHeight(state, props) {
	  var expandedRowsHeight = state.expandedRowsHeight,
	      fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
	  var fixed = props.fixed,
	      index = props.index,
	      rowKey = props.rowKey;
	
	
	  if (!fixed) {
	    return null;
	  }
	
	  if (expandedRowsHeight[rowKey]) {
	    return expandedRowsHeight[rowKey];
	  }
	
	  if (fixedColumnsBodyRowsHeight[index]) {
	    return fixedColumnsBodyRowsHeight[index];
	  }
	
	  return null;
	}
	
	exports['default'] = (0, _miniStore.connect)(function (state, props) {
	  var currentHoverKey = state.currentHoverKey,
	      expandedRowKeys = state.expandedRowKeys;
	  var rowKey = props.rowKey,
	      ancestorKeys = props.ancestorKeys;
	
	  var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
	    return ~expandedRowKeys.indexOf(k);
	  });
	
	  return {
	    visible: visible,
	    hovered: currentHoverKey === rowKey,
	    height: getRowHeight(state, props)
	  };
	})(TableRow);
	module.exports = exports['default'];

/***/ },
/* 1181 */
[3336, 156],
/* 1182 */
[3339, 156],
/* 1183 */
[3459, 1184],
/* 1184 */
[3521, 2608],
/* 1185 */
87,
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(2617);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Combobox = __webpack_require__(2616);
	
	var _Combobox2 = _interopRequireDefault(_Combobox);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function generateOptions(length, disabledOptions, hideDisabledOptions) {
	  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	
	  var arr = [];
	  for (var value = 0; value < length; value += step) {
	    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
	      arr.push(value);
	    }
	  }
	  return arr;
	}
	
	var Panel = function (_Component) {
	  (0, _inherits3['default'])(Panel, _Component);
	
	  function Panel(props) {
	    (0, _classCallCheck3['default'])(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Panel.__proto__ || Object.getPrototypeOf(Panel)).call(this, props));
	
	    _this.onChange = function (newValue) {
	      _this.setState({ value: newValue });
	      _this.props.onChange(newValue);
	    };
	
	    _this.onCurrentSelectPanelChange = function (currentSelectPanel) {
	      _this.setState({ currentSelectPanel: currentSelectPanel });
	    };
	
	    _this.state = {
	      value: props.value,
	      selectionRange: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Panel, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value;
	      if (value) {
	        this.setState({
	          value: value
	        });
	      }
	    }
	  }, {
	    key: 'close',
	
	
	    // https://github.com/ant-design/ant-design/issues/5829
	    value: function close() {
	      this.props.onEsc();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          placeholder = _props.placeholder,
	          disabledHours = _props.disabledHours,
	          disabledMinutes = _props.disabledMinutes,
	          disabledSeconds = _props.disabledSeconds,
	          hideDisabledOptions = _props.hideDisabledOptions,
	          allowEmpty = _props.allowEmpty,
	          showHour = _props.showHour,
	          showMinute = _props.showMinute,
	          showSecond = _props.showSecond,
	          format = _props.format,
	          defaultOpenValue = _props.defaultOpenValue,
	          clearText = _props.clearText,
	          onEsc = _props.onEsc,
	          addon = _props.addon,
	          use12Hours = _props.use12Hours,
	          onClear = _props.onClear,
	          focusOnOpen = _props.focusOnOpen,
	          onKeyDown = _props.onKeyDown,
	          hourStep = _props.hourStep,
	          minuteStep = _props.minuteStep,
	          secondStep = _props.secondStep;
	      var _state = this.state,
	          value = _state.value,
	          currentSelectPanel = _state.currentSelectPanel;
	
	      var disabledHourOptions = disabledHours();
	      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
	      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
	      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
	      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
	      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
	
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-inner', true), (0, _defineProperty3['default'])(_classNames, className, !!className), _classNames)) },
	        _react2['default'].createElement(_Header2['default'], {
	          clearText: clearText,
	          prefixCls: prefixCls,
	          defaultOpenValue: defaultOpenValue,
	          value: value,
	          currentSelectPanel: currentSelectPanel,
	          onEsc: onEsc,
	          format: format,
	          placeholder: placeholder,
	          hourOptions: hourOptions,
	          minuteOptions: minuteOptions,
	          secondOptions: secondOptions,
	          disabledHours: disabledHours,
	          disabledMinutes: disabledMinutes,
	          disabledSeconds: disabledSeconds,
	          onChange: this.onChange,
	          onClear: onClear,
	          allowEmpty: allowEmpty,
	          focusOnOpen: focusOnOpen,
	          onKeyDown: onKeyDown
	        }),
	        _react2['default'].createElement(_Combobox2['default'], {
	          prefixCls: prefixCls,
	          value: value,
	          defaultOpenValue: defaultOpenValue,
	          format: format,
	          onChange: this.onChange,
	          showHour: showHour,
	          showMinute: showMinute,
	          showSecond: showSecond,
	          hourOptions: hourOptions,
	          minuteOptions: minuteOptions,
	          secondOptions: secondOptions,
	          disabledHours: disabledHours,
	          disabledMinutes: disabledMinutes,
	          disabledSeconds: disabledSeconds,
	          onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
	          use12Hours: use12Hours
	        }),
	        addon(this)
	      );
	    }
	  }]);
	  return Panel;
	}(_react.Component);
	
	Panel.propTypes = {
	  clearText: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  defaultOpenValue: _propTypes2['default'].object,
	  value: _propTypes2['default'].object,
	  placeholder: _propTypes2['default'].string,
	  format: _propTypes2['default'].string,
	  disabledHours: _propTypes2['default'].func,
	  disabledMinutes: _propTypes2['default'].func,
	  disabledSeconds: _propTypes2['default'].func,
	  hideDisabledOptions: _propTypes2['default'].bool,
	  onChange: _propTypes2['default'].func,
	  onEsc: _propTypes2['default'].func,
	  allowEmpty: _propTypes2['default'].bool,
	  showHour: _propTypes2['default'].bool,
	  showMinute: _propTypes2['default'].bool,
	  showSecond: _propTypes2['default'].bool,
	  onClear: _propTypes2['default'].func,
	  use12Hours: _propTypes2['default'].bool,
	  hourStep: _propTypes2['default'].number,
	  minuteStep: _propTypes2['default'].number,
	  secondStep: _propTypes2['default'].number,
	  addon: _propTypes2['default'].func,
	  focusOnOpen: _propTypes2['default'].bool,
	  onKeyDown: _propTypes2['default'].func
	};
	Panel.defaultProps = {
	  prefixCls: 'rc-time-picker-panel',
	  onChange: noop,
	  onClear: noop,
	  disabledHours: noop,
	  disabledMinutes: noop,
	  disabledSeconds: noop,
	  defaultOpenValue: (0, _moment2['default'])(),
	  use12Hours: false,
	  addon: noop,
	  onKeyDown: noop
	};
	exports['default'] = Panel;
	module.exports = exports['default'];

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(2621);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ },
/* 1188 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TreeNode = function (_React$Component) {
	  (0, _inherits3['default'])(TreeNode, _React$Component);
	
	  function TreeNode() {
	    (0, _classCallCheck3['default'])(this, TreeNode);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  return TreeNode;
	}(_react2['default'].Component);
	
	TreeNode.propTypes = {
	  value: _propTypes2['default'].string
	};
	exports['default'] = TreeNode;
	module.exports = exports['default'];

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_STYLE = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getValuePropValue = getValuePropValue;
	exports.getPropValue = getPropValue;
	exports.isCombobox = isCombobox;
	exports.isMultipleOrTags = isMultipleOrTags;
	exports.isMultipleOrTagsOrCombobox = isMultipleOrTagsOrCombobox;
	exports.isSingleMode = isSingleMode;
	exports.toArray = toArray;
	exports.preventDefaultEvent = preventDefaultEvent;
	exports.labelCompatible = labelCompatible;
	exports.isInclude = isInclude;
	exports.isPositionPrefix = isPositionPrefix;
	exports.loopAllChildren = loopAllChildren;
	exports.flatToHierarchy = flatToHierarchy;
	exports.filterParentPosition = filterParentPosition;
	exports.handleCheckState = handleCheckState;
	exports.getTreeNodesStates = getTreeNodesStates;
	exports.recursiveCloneChildren = recursiveCloneChildren;
	exports.filterAllCheckedData = filterAllCheckedData;
	exports.processSimpleTreeData = processSimpleTreeData;
	exports.saveRef = saveRef;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getValuePropValue(child) {
	  var props = child.props;
	  if ('value' in props) {
	    return props.value;
	  }
	  if (child.key) {
	    return child.key;
	  }
	  throw new Error('no key or value for ' + child);
	} /* eslint no-loop-func: 0*/
	function getPropValue(child, prop) {
	  if (prop === 'value') {
	    return getValuePropValue(child);
	  }
	  return child.props[prop];
	}
	
	function isCombobox(props) {
	  return props.combobox;
	}
	
	function isMultipleOrTags(props) {
	  return !!(props.multiple || props.tags || props.treeCheckable);
	}
	
	function isMultipleOrTagsOrCombobox(props) {
	  return isMultipleOrTags(props) || isCombobox(props);
	}
	
	function isSingleMode(props) {
	  return !isMultipleOrTagsOrCombobox(props);
	}
	
	function toArray(value) {
	  var ret = value;
	  if (value === undefined) {
	    ret = [];
	  } else if (!Array.isArray(value)) {
	    ret = [value];
	  }
	  return ret;
	}
	
	function preventDefaultEvent(e) {
	  e.preventDefault();
	}
	
	var UNSELECTABLE_STYLE = exports.UNSELECTABLE_STYLE = {
	  userSelect: 'none',
	  WebkitUserSelect: 'none'
	};
	
	var UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_ATTRIBUTE = {
	  unselectable: 'unselectable'
	};
	
	function labelCompatible(prop) {
	  var newProp = prop;
	  if (newProp === 'label') {
	    newProp = 'title';
	  }
	  return newProp;
	}
	
	function isInclude(smallArray, bigArray) {
	  // attention: [0,0,1] [0,0,10]
	  return smallArray.every(function (ii, i) {
	    return ii === bigArray[i];
	  });
	}
	
	function isPositionPrefix(smallPos, bigPos) {
	  if (!bigPos || !smallPos) {
	    // console.log(smallPos, bigPos);
	    return false;
	  }
	  if (bigPos.length < smallPos.length) {
	    return false;
	  }
	  // attention: "0-0-1" "0-0-10"
	  if (bigPos.length > smallPos.length && bigPos.charAt(smallPos.length) !== '-') {
	    return false;
	  }
	  return bigPos.substr(0, smallPos.length) === smallPos;
	}
	
	/*
	export function getCheckedKeys(node, checkedKeys, allCheckedNodesKeys) {
	  const nodeKey = node.props.eventKey;
	  let newCks = [...checkedKeys];
	  let nodePos;
	  const unCheck = allCheckedNodesKeys.some(item => {
	    if (item.key === nodeKey) {
	      nodePos = item.pos;
	      return true;
	    }
	  });
	  if (unCheck) {
	    newCks = [];
	    allCheckedNodesKeys.forEach(item => {
	      if (isPositionPrefix(item.pos, nodePos) || isPositionPrefix(nodePos, item.pos)) {
	        return;
	      }
	      newCks.push(item.key);
	    });
	  } else {
	    newCks.push(nodeKey);
	  }
	  return newCks;
	}
	*/
	
	function getChildrenlength(children) {
	  var len = 1;
	  if (Array.isArray(children)) {
	    len = children.length;
	  }
	  return len;
	}
	
	function getSiblingPosition(index, len, siblingPosition) {
	  if (len === 1) {
	    siblingPosition.first = true;
	    siblingPosition.last = true;
	  } else {
	    siblingPosition.first = index === 0;
	    siblingPosition.last = index === len - 1;
	  }
	  return siblingPosition;
	}
	
	function loopAllChildren(childs, callback, parent) {
	  var loop = function loop(children, level, _parent) {
	    var len = getChildrenlength(children);
	    _react2['default'].Children.forEach(children, function handler(item, index) {
	      // eslint-disable-line
	      var pos = level + '-' + index;
	      if (item && item.props.children && item.type) {
	        loop(item.props.children, pos, { node: item, pos: pos });
	      }
	      if (item) {
	        callback(item, index, pos, item.key || pos, getSiblingPosition(index, len, {}), _parent);
	      }
	    });
	  };
	  loop(childs, 0, parent);
	}
	
	// export function loopAllChildren(childs, callback) {
	//   const loop = (children, level) => {
	//     React.Children.forEach(children, (item, index) => {
	//       const pos = `${level}-${index}`;
	//       if (item && item.props.children) {
	//         loop(item.props.children, pos);
	//       }
	//       if (item) {
	//         callback(item, index, pos, getValuePropValue(item));
	//       }
	//     });
	//   };
	//   loop(childs, 0);
	// }
	
	function flatToHierarchy(arr) {
	  if (!arr.length) {
	    return arr;
	  }
	  var hierarchyNodes = [];
	  var levelObj = {};
	  arr.forEach(function (item) {
	    if (!item.pos) {
	      return;
	    }
	    var posLen = item.pos.split('-').length;
	    if (!levelObj[posLen]) {
	      levelObj[posLen] = [];
	    }
	    levelObj[posLen].push(item);
	  });
	  var levelArr = Object.keys(levelObj).sort(function (a, b) {
	    return b - a;
	  });
	  // const s = Date.now();
	  // todo: there are performance issues!
	  levelArr.reduce(function (pre, cur) {
	    if (cur && cur !== pre) {
	      levelObj[pre].forEach(function (item) {
	        var haveParent = false;
	        levelObj[cur].forEach(function (ii) {
	          if (isPositionPrefix(ii.pos, item.pos)) {
	            haveParent = true;
	            if (!ii.children) {
	              ii.children = [];
	            }
	            ii.children.push(item);
	          }
	        });
	        if (!haveParent) {
	          hierarchyNodes.push(item);
	        }
	      });
	    }
	    return cur;
	  });
	  // console.log(Date.now() - s);
	  return levelObj[levelArr[levelArr.length - 1]].concat(hierarchyNodes);
	}
	
	// arr.length === 628, use time: ~20ms
	function filterParentPosition(arr) {
	  var levelObj = {};
	  arr.forEach(function (item) {
	    var posLen = item.split('-').length;
	    if (!levelObj[posLen]) {
	      levelObj[posLen] = [];
	    }
	    levelObj[posLen].push(item);
	  });
	  var levelArr = Object.keys(levelObj).sort();
	
	  var _loop = function _loop(i) {
	    if (levelArr[i + 1]) {
	      levelObj[levelArr[i]].forEach(function (ii) {
	        var _loop2 = function _loop2(j) {
	          levelObj[levelArr[j]].forEach(function (_i, index) {
	            if (isPositionPrefix(ii, _i)) {
	              levelObj[levelArr[j]][index] = null;
	            }
	          });
	          levelObj[levelArr[j]] = levelObj[levelArr[j]].filter(function (p) {
	            return p;
	          });
	        };
	
	        for (var j = i + 1; j < levelArr.length; j++) {
	          _loop2(j);
	        }
	      });
	    }
	  };
	
	  for (var i = 0; i < levelArr.length; i++) {
	    _loop(i);
	  }
	  var nArr = [];
	  levelArr.forEach(function (i) {
	    nArr = nArr.concat(levelObj[i]);
	  });
	  return nArr;
	}
	// console.log(filterParentPosition(
	// ['0-2', '0-3-3', '0-10', '0-10-0', '0-0-1', '0-0', '0-1-1', '0-1']
	// ));
	
	function stripTail(str) {
	  var arr = str.match(/(.+)(-[^-]+)$/);
	  var st = '';
	  if (arr && arr.length === 3) {
	    st = arr[1];
	  }
	  return st;
	}
	function splitPosition(pos) {
	  return pos.split('-');
	}
	
	// todo: do optimization.
	function handleCheckState(obj, checkedPositionArr, checkIt) {
	  // console.log(stripTail('0-101-000'));
	  // let s = Date.now();
	  var objKeys = Object.keys(obj);
	
	  objKeys.forEach(function (i, index) {
	    var iArr = splitPosition(i);
	    var saved = false;
	    checkedPositionArr.forEach(function (_pos) {
	      var _posArr = splitPosition(_pos);
	      if (iArr.length > _posArr.length && isInclude(_posArr, iArr)) {
	        obj[i].halfChecked = false;
	        obj[i].checked = checkIt;
	        objKeys[index] = null;
	      }
	      if (iArr[0] === _posArr[0] && iArr[1] === _posArr[1]) {
	        saved = true;
	      }
	    });
	    if (!saved) {
	      objKeys[index] = null;
	    }
	  });
	  objKeys = objKeys.filter(function (i) {
	    return i;
	  }); // filter non null;
	
	  var _loop3 = function _loop3(_pIndex) {
	    // loop to set ancestral nodes's `checked` or `halfChecked`
	    var loop = function loop(__pos) {
	      var _posLen = splitPosition(__pos).length;
	      if (_posLen <= 2) {
	        // e.g. '0-0', '0-1'
	        return;
	      }
	      var sibling = 0;
	      var siblingChecked = 0;
	      var parentPosition = stripTail(__pos);
	      objKeys.forEach(function (i /* , index*/) {
	        var iArr = splitPosition(i);
	        if (iArr.length === _posLen && isInclude(splitPosition(parentPosition), iArr)) {
	          sibling++;
	          if (obj[i].checked) {
	            siblingChecked++;
	            var _i = checkedPositionArr.indexOf(i);
	            if (_i > -1) {
	              checkedPositionArr.splice(_i, 1);
	              if (_i <= _pIndex) {
	                _pIndex--;
	              }
	            }
	          } else if (obj[i].halfChecked) {
	            siblingChecked += 0.5;
	          }
	          // objKeys[index] = null;
	        }
	      });
	      // objKeys = objKeys.filter(i => i); // filter non null;
	      var parent = obj[parentPosition];
	      // not check, checked, halfChecked
	      if (siblingChecked === 0) {
	        parent.checked = false;
	        parent.halfChecked = false;
	      } else if (siblingChecked === sibling) {
	        parent.checked = true;
	        parent.halfChecked = false;
	      } else {
	        parent.halfChecked = true;
	        parent.checked = false;
	      }
	      loop(parentPosition);
	    };
	    loop(checkedPositionArr[_pIndex], _pIndex);
	    pIndex = _pIndex;
	  };
	
	  for (var pIndex = 0; pIndex < checkedPositionArr.length; pIndex++) {
	    _loop3(pIndex);
	  }
	  // console.log(Date.now()-s, objKeys.length, checkIt);
	}
	
	function getCheck(treeNodesStates, checkedPositions) {
	  var halfCheckedKeys = [];
	  var checkedKeys = [];
	  var checkedNodes = [];
	  Object.keys(treeNodesStates).forEach(function (item) {
	    var itemObj = treeNodesStates[item];
	    if (itemObj.checked) {
	      checkedKeys.push(itemObj.key);
	      // checkedNodes.push(getValuePropValue(itemObj.node));
	      checkedNodes.push((0, _extends3['default'])({}, itemObj, { pos: item }));
	    } else if (itemObj.halfChecked) {
	      halfCheckedKeys.push(itemObj.key);
	    }
	  });
	  return {
	    halfCheckedKeys: halfCheckedKeys, checkedKeys: checkedKeys, checkedNodes: checkedNodes, treeNodesStates: treeNodesStates, checkedPositions: checkedPositions
	  };
	}
	
	function getTreeNodesStates(children, values) {
	  var checkedPositions = [];
	  var treeNodesStates = {};
	  loopAllChildren(children, function (item, index, pos, keyOrPos, siblingPosition) {
	    treeNodesStates[pos] = {
	      node: item,
	      key: keyOrPos,
	      checked: false,
	      halfChecked: false,
	      siblingPosition: siblingPosition
	    };
	    if (values.indexOf(getValuePropValue(item)) !== -1) {
	      treeNodesStates[pos].checked = true;
	      checkedPositions.push(pos);
	    }
	  });
	
	  handleCheckState(treeNodesStates, filterParentPosition(checkedPositions.sort()), true);
	
	  return getCheck(treeNodesStates, checkedPositions);
	}
	
	// can add extra prop to every node.
	function recursiveCloneChildren(children) {
	  var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (ch) {
	    return ch;
	  };
	
	  // return React.Children.map(children, child => {
	  return Array.from(children).map(function (child) {
	    var newChild = cb(child);
	    if (newChild && newChild.props && newChild.props.children) {
	      return _react2['default'].cloneElement(newChild, {}, recursiveCloneChildren(newChild.props.children, cb));
	    }
	    return newChild;
	  });
	}
	// const newChildren = recursiveCloneChildren(children, child => {
	//   const extraProps = {};
	//   if (child && child.type && child.type.xxx) {
	//     extraProps._prop = true;
	//     return React.cloneElement(child, extraProps);
	//   }
	//   return child;
	// });
	
	
	function recursiveGen(children) {
	  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  return _react2['default'].Children.map(children, function (child, index) {
	    var pos = level + '-' + index;
	    var o = {
	      title: child.props.title,
	      label: child.props.label || child.props.title,
	      value: child.props.value,
	      key: child.key,
	      _pos: pos
	    };
	    if (child.props.children) {
	      o.children = recursiveGen(child.props.children, pos);
	    }
	    return o;
	  });
	}
	
	function recursive(children, cb) {
	  children.forEach(function (item) {
	    cb(item);
	    if (item.children) {
	      recursive(item.children, cb);
	    }
	  });
	}
	
	// Get the tree's checkedNodes (todo: can merge to the `handleCheckState` function)
	// If one node checked, it's all children nodes checked.
	// If sibling nodes all checked, the parent checked.
	function filterAllCheckedData(vs, treeNodes) {
	  var vals = [].concat(vs);
	  if (!vals.length) {
	    return vals;
	  }
	
	  var data = recursiveGen(treeNodes);
	  var checkedNodesPositions = [];
	
	  function checkChildren(children) {
	    children.forEach(function (item) {
	      if (item.__checked) {
	        return;
	      }
	      var ci = vals.indexOf(item.value);
	      var childs = item.children;
	      if (ci > -1) {
	        item.__checked = true;
	        checkedNodesPositions.push({ node: item, pos: item._pos });
	        vals.splice(ci, 1);
	        if (childs) {
	          recursive(childs, function (child) {
	            child.__checked = true;
	            checkedNodesPositions.push({ node: child, pos: child._pos });
	          });
	        }
	      } else {
	        if (childs) {
	          checkChildren(childs);
	        }
	      }
	    });
	  }
	
	  function checkParent(children) {
	    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { root: true };
	
	    var siblingChecked = 0;
	    children.forEach(function (item) {
	      var childs = item.children;
	      if (childs && !item.__checked && !item.__halfChecked) {
	        var p = checkParent(childs, item);
	        if (p.__checked) {
	          siblingChecked++;
	        } else if (p.__halfChecked) {
	          siblingChecked += 0.5;
	        }
	      } else if (item.__checked) {
	        siblingChecked++;
	      } else if (item.__halfChecked) {
	        siblingChecked += 0.5;
	      }
	    });
	    var len = children.length;
	    if (siblingChecked === len) {
	      parent.__checked = true;
	      checkedNodesPositions.push({ node: parent, pos: parent._pos });
	    } else if (siblingChecked < len && siblingChecked > 0) {
	      parent.__halfChecked = true;
	    }
	    if (parent.root) {
	      return children;
	    }
	    return parent;
	  }
	  checkChildren(data);
	  checkParent(data);
	
	  checkedNodesPositions.forEach(function (i, index) {
	    // clear private metadata
	    delete checkedNodesPositions[index].node.__checked;
	    delete checkedNodesPositions[index].node._pos;
	    // create the same structure of `onCheck`'s return.
	    checkedNodesPositions[index].node.props = {
	      title: checkedNodesPositions[index].node.title,
	      label: checkedNodesPositions[index].node.label || checkedNodesPositions[index].node.title,
	      value: checkedNodesPositions[index].node.value
	    };
	    if (checkedNodesPositions[index].node.children) {
	      checkedNodesPositions[index].node.props.children = checkedNodesPositions[index].node.children;
	    }
	    delete checkedNodesPositions[index].node.title;
	    delete checkedNodesPositions[index].node.label;
	    delete checkedNodesPositions[index].node.value;
	    delete checkedNodesPositions[index].node.children;
	  });
	  return checkedNodesPositions;
	}
	
	function processSimpleTreeData(treeData, format) {
	  function unflatten2(array) {
	    var _ref;
	
	    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (_ref = {}, _ref[format.id] = format.rootPId, _ref);
	
	    var children = [];
	    for (var i = 0; i < array.length; i++) {
	      array[i] = (0, _extends3['default'])({}, array[i]); // copy, can not corrupts original data
	      if (array[i][format.pId] === parent[format.id]) {
	        array[i].key = array[i][format.id];
	        children.push(array[i]);
	        array.splice(i--, 1);
	      }
	    }
	    if (children.length) {
	      parent.children = children;
	      children.forEach(function (child) {
	        return unflatten2(array, child);
	      });
	    }
	    if (parent[format.id] === format.rootPId) {
	      return children;
	    }
	  }
	  return unflatten2(treeData);
	}
	
	function saveRef(instance, name) {
	  return function (node) {
	    instance[name] = node;
	  };
	}

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.contextTypes = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _util = __webpack_require__(2627);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var contextTypes = exports.contextTypes = {
	  rcTree: _propTypes2['default'].shape({
	    selectable: _propTypes2['default'].bool
	  })
	};
	
	var Tree = function (_React$Component) {
	  (0, _inherits3['default'])(Tree, _React$Component);
	
	  function Tree(props) {
	    (0, _classCallCheck3['default'])(this, Tree);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var checkedKeys = _this.calcCheckedKeys(props);
	    _this.state = {
	      expandedKeys: _this.calcExpandedKeys(props),
	      checkedKeys: checkedKeys.checkedKeys,
	      halfCheckedKeys: checkedKeys.halfCheckedKeys,
	      selectedKeys: _this.calcSelectedKeys(props),
	      dragNodesKeys: '',
	      dragOverNodeKey: '',
	      dropNodeKey: ''
	    };
	    return _this;
	  }
	
	  Tree.prototype.getChildContext = function getChildContext() {
	    var selectable = this.props.selectable;
	
	    return {
	      rcTree: {
	        selectable: selectable
	      }
	    };
	  };
	
	  Tree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var props = this.props;
	
	    var newState = {};
	    var expandedKeys = nextProps.expandedKeys !== props.expandedKeys ? this.calcExpandedKeys(nextProps, true) : undefined;
	    if (expandedKeys) {
	      newState.expandedKeys = expandedKeys;
	    }
	
	    var checkedKeys = nextProps.checkedKeys !== props.checkedKeys || props.loadData ? this.calcCheckedKeys(nextProps, true) : undefined;
	    if (checkedKeys) {
	      newState.checkedKeys = checkedKeys.checkedKeys;
	      newState.halfCheckedKeys = checkedKeys.halfCheckedKeys;
	    }
	
	    var selectedKeys = nextProps.selectedKeys !== props.selectedKeys ? this.calcSelectedKeys(nextProps, true) : undefined;
	    if (selectedKeys) {
	      newState.selectedKeys = selectedKeys;
	    }
	    this.setState(newState);
	  };
	
	  Tree.prototype.onDragStart = function onDragStart(e, treeNode) {
	    this.dragNode = treeNode;
	    var newState = {
	      dragNodesKeys: this.getDragNodesKeys(treeNode)
	    };
	    var expandedKeys = this.getExpandedKeys(treeNode, false);
	    if (expandedKeys) {
	      newState.expandedKeys = expandedKeys;
	    }
	    this.setState(newState);
	    this.props.onDragStart({
	      event: e,
	      node: treeNode
	    });
	  };
	
	  Tree.prototype.onDragEnter = function onDragEnter(e, treeNode) {
	    var _this2 = this;
	
	    var dropPosition = this.calcDropPosition(e, treeNode);
	    if (this.dragNode.props.eventKey === treeNode.props.eventKey && dropPosition === 0) {
	      this.setState({
	        dragOverNodeKey: '',
	        dropPosition: null
	      });
	      return;
	    }
	    this.setState({
	      dragOverNodeKey: treeNode.props.eventKey,
	      dropPosition: dropPosition
	    });
	
	    if (!this.delayedDragEnterLogic) {
	      this.delayedDragEnterLogic = {};
	    }
	    Object.keys(this.delayedDragEnterLogic).forEach(function (key) {
	      clearTimeout(_this2.delayedDragEnterLogic[key]);
	    });
	    this.delayedDragEnterLogic[treeNode.props.pos] = setTimeout(function () {
	      var expandedKeys = _this2.getExpandedKeys(treeNode, true);
	      if (expandedKeys) {
	        _this2.setState({ expandedKeys: expandedKeys });
	      }
	      _this2.props.onDragEnter({
	        event: e,
	        node: treeNode,
	        expandedKeys: expandedKeys && [].concat(expandedKeys) || [].concat(_this2.state.expandedKeys)
	      });
	    }, 400);
	  };
	
	  Tree.prototype.onDragOver = function onDragOver(e, treeNode) {
	    this.props.onDragOver({ event: e, node: treeNode });
	  };
	
	  Tree.prototype.onDragLeave = function onDragLeave(e, treeNode) {
	    this.props.onDragLeave({ event: e, node: treeNode });
	  };
	
	  Tree.prototype.onDrop = function onDrop(e, treeNode) {
	    var state = this.state;
	
	    var eventKey = treeNode.props.eventKey;
	    this.setState({
	      dragOverNodeKey: '',
	      dropNodeKey: eventKey
	    });
	    if (state.dragNodesKeys.indexOf(eventKey) > -1) {
	      (0, _warning2['default'])(false, 'Can not drop to dragNode(include it\'s children node)');
	      return;
	    }
	
	    var posArr = treeNode.props.pos.split('-');
	    var res = {
	      event: e,
	      node: treeNode,
	      dragNode: this.dragNode,
	      dragNodesKeys: [].concat(state.dragNodesKeys),
	      dropPosition: state.dropPosition + Number(posArr[posArr.length - 1])
	    };
	    if (state.dropPosition !== 0) {
	      res.dropToGap = true;
	    }
	    this.props.onDrop(res);
	  };
	
	  Tree.prototype.onDragEnd = function onDragEnd(e, treeNode) {
	    this.setState({
	      dragOverNodeKey: ''
	    });
	    this.props.onDragEnd({ event: e, node: treeNode });
	  };
	
	  Tree.prototype.onExpand = function onExpand(treeNode) {
	    var _this3 = this;
	
	    var props = this.props,
	        state = this.state;
	
	    var expanded = !treeNode.props.expanded;
	    var expandedKeys = [].concat(state.expandedKeys);
	    var eventKey = treeNode.props.eventKey;
	
	    var index = expandedKeys.indexOf(eventKey);
	    if (expanded && index === -1) {
	      expandedKeys.push(eventKey);
	    } else if (!expanded && index > -1) {
	      expandedKeys.splice(index, 1);
	    }
	
	    var controlled = 'expandedKeys' in props;
	    if (!controlled) {
	      this.setState({ expandedKeys: expandedKeys });
	    }
	    props.onExpand(expandedKeys, { node: treeNode, expanded: expanded });
	
	    // After data loaded, need set new expandedKeys
	    if (expanded && props.loadData) {
	      return props.loadData(treeNode).then(function () {
	        if (!controlled) {
	          _this3.setState({ expandedKeys: expandedKeys });
	        }
	      });
	    }
	  };
	
	  Tree.prototype.onSelect = function onSelect(treeNode) {
	    var props = this.props,
	        state = this.state;
	
	    var eventKey = treeNode.props.eventKey;
	    var selected = !treeNode.props.selected;
	
	    var selectedKeys = [].concat(state.selectedKeys);
	    if (!selected) {
	      var index = selectedKeys.indexOf(eventKey);
	      selectedKeys.splice(index, 1);
	    } else if (!props.multiple) {
	      selectedKeys = [eventKey];
	    } else {
	      selectedKeys.push(eventKey);
	    }
	
	    // TODO: can be optimized if we remove selectedNodes in API
	    var selectedNodes = [];
	    if (selectedKeys.length) {
	      (0, _util.traverseTreeNodes)(props.children, function (item) {
	        if (selectedKeys.indexOf(item.key) !== -1) {
	          selectedNodes.push(item);
	        }
	      });
	    }
	
	    if (!('selectedKeys' in props)) {
	      this.setState({
	        selectedKeys: selectedKeys
	      });
	    }
	
	    var eventObj = {
	      event: 'select',
	      selected: selected,
	      node: treeNode,
	      selectedNodes: selectedNodes
	    };
	    props.onSelect(selectedKeys, eventObj);
	  };
	
	  Tree.prototype.onMouseEnter = function onMouseEnter(e, treeNode) {
	    this.props.onMouseEnter({ event: e, node: treeNode });
	  };
	
	  Tree.prototype.onMouseLeave = function onMouseLeave(e, treeNode) {
	    this.props.onMouseLeave({ event: e, node: treeNode });
	  };
	
	  Tree.prototype.onContextMenu = function onContextMenu(e, treeNode) {
	    if (this.props.onRightClick) {
	      e.preventDefault();
	      this.props.onRightClick({ event: e, node: treeNode });
	    }
	  };
	
	  // all keyboard events callbacks run from here at first
	
	
	  Tree.prototype.getOpenTransitionName = function getOpenTransitionName() {
	    var props = this.props;
	    var transitionName = props.openTransitionName;
	    var animationName = props.openAnimation;
	    if (!transitionName && typeof animationName === 'string') {
	      return props.prefixCls + '-open-' + animationName;
	    }
	    return transitionName;
	  };
	
	  Tree.prototype.getDragNodesKeys = function getDragNodesKeys(treeNode) {
	    var dragNodesKeys = [];
	    (0, _util.traverseTreeNodes)(treeNode.props.children, function (item, index, pos, key) {
	      if ((0, _util.isPositionPrefix)(treeNode.props.pos, pos)) {
	        dragNodesKeys.push(key);
	      }
	    });
	    dragNodesKeys.push(treeNode.props.eventKey || treeNode.props.pos);
	    return dragNodesKeys;
	  };
	
	  Tree.prototype.getExpandedKeys = function getExpandedKeys(treeNode, expand) {
	    var eventKey = treeNode.props.eventKey;
	    var expandedKeys = this.state.expandedKeys;
	    var expandedIndex = expandedKeys.indexOf(eventKey);
	    if (!expand && expandedIndex > -1) {
	      var exKeys = [].concat(expandedKeys);
	      exKeys.splice(expandedIndex, 1);
	      return exKeys;
	    }
	    if (expand && expandedKeys.indexOf(eventKey) === -1) {
	      return expandedKeys.concat([eventKey]);
	    }
	  };
	
	  Tree.prototype.generateTreeNodesStates = function generateTreeNodesStates(children, checkedKeys) {
	    var checkedPositions = [];
	    var treeNodesStates = {};
	    (0, _util.traverseTreeNodes)(children, function (item, _, pos, key, childrenPos, parentPos) {
	      treeNodesStates[pos] = {
	        node: item,
	        key: key,
	        checked: false,
	        halfChecked: false,
	        disabled: item.props.disabled,
	        disableCheckbox: item.props.disableCheckbox,
	        childrenPos: childrenPos,
	        parentPos: parentPos
	      };
	      if (checkedKeys.indexOf(key) !== -1) {
	        treeNodesStates[pos].checked = true;
	        checkedPositions.push(pos);
	      }
	    });
	    checkedPositions.forEach(function (checkedPosition) {
	      (0, _util.updateCheckState)(treeNodesStates, checkedPosition, true);
	    });
	    return treeNodesStates;
	  };
	
	  Tree.prototype.calcExpandedKeys = function calcExpandedKeys(props, isNotInit) {
	    var expandedKeys = props.expandedKeys || (isNotInit ? undefined : props.defaultExpandedKeys);
	    if (!expandedKeys) {
	      return undefined;
	    }
	    var expandAll = isNotInit ? false : props.defaultExpandAll;
	    if (!expandAll && !props.autoExpandParent) {
	      return expandedKeys;
	    }
	
	    var expandedPositionArr = [];
	    if (props.autoExpandParent) {
	      (0, _util.traverseTreeNodes)(props.children, function (item, index, pos, key) {
	        if (expandedKeys.indexOf(key) > -1) {
	          expandedPositionArr.push(pos);
	        }
	      });
	    }
	    var filterExpandedKeysSet = {};
	    (0, _util.traverseTreeNodes)(props.children, function (item, index, pos, key) {
	      if (expandAll) {
	        filterExpandedKeysSet[key] = true;
	      } else if (props.autoExpandParent) {
	        var isCurrentParentOfExpanded = expandedPositionArr.some(function (p) {
	          return (0, _util.isPositionPrefix)(pos, p);
	        });
	        if (isCurrentParentOfExpanded) {
	          filterExpandedKeysSet[key] = true;
	        }
	      }
	    });
	    var filterExpandedKeys = Object.keys(filterExpandedKeysSet);
	    return filterExpandedKeys.length ? filterExpandedKeys : expandedKeys;
	  };
	
	  Tree.prototype.calcCheckedKeys = function calcCheckedKeys(props, isNotInit) {
	    if (!props.checkable) {
	      return { checkedKeys: [], halfCheckedKeys: [] };
	    }
	
	    var checkedKeys = props.checkedKeys || (isNotInit && !props.loadData ? undefined : props.defaultCheckedKeys);
	    if (!checkedKeys) {
	      return undefined;
	    }
	    if (Array.isArray(checkedKeys)) {
	      checkedKeys = { checkedKeys: checkedKeys, halfCheckedKeys: [] };
	    } else if (typeof checkedKeys === 'object') {
	      checkedKeys = { checkedKeys: checkedKeys.checked, halfCheckedKeys: checkedKeys.halfChecked };
	    }
	
	    if (!props.checkStrictly) {
	      var checked = checkedKeys.checkedKeys || [];
	      var treeNodesStates = this.generateTreeNodesStates(props.children, checked);
	      return (0, _util.getCheck)(treeNodesStates);
	    }
	
	    return checkedKeys;
	  };
	
	  Tree.prototype.calcSelectedKeys = function calcSelectedKeys(props, isNotInit) {
	    var selectedKeys = props.selectedKeys || (isNotInit ? undefined : props.defaultSelectedKeys);
	    if (!selectedKeys) {
	      return undefined;
	    }
	    if (props.multiple) {
	      return [].concat(selectedKeys);
	    }
	    if (selectedKeys.length) {
	      return [selectedKeys[0]];
	    }
	    return selectedKeys;
	  };
	
	  Tree.prototype.calcDropPosition = function calcDropPosition(e, treeNode) {
	    var offsetTop = (0, _util.getOffset)(treeNode.selectHandle).top;
	    var offsetHeight = treeNode.selectHandle.offsetHeight;
	    var pageY = e.pageY;
	    var gapHeight = 2; // TODO: remove hard code
	    if (pageY > offsetTop + offsetHeight - gapHeight) {
	      return 1;
	    }
	    if (pageY < offsetTop + gapHeight) {
	      return -1;
	    }
	    return 0;
	  };
	
	  Tree.prototype.renderTreeNode = function renderTreeNode(child, index) {
	    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var state = this.state,
	        props = this.props;
	
	    var pos = level + '-' + index;
	    var key = child.key || pos;
	
	    var childProps = {
	      root: this,
	      eventKey: key,
	      pos: pos,
	      loadData: props.loadData,
	      prefixCls: props.prefixCls,
	      showIcon: props.showIcon,
	      draggable: props.draggable,
	      dragOver: state.dragOverNodeKey === key && state.dropPosition === 0,
	      dragOverGapTop: state.dragOverNodeKey === key && state.dropPosition === -1,
	      dragOverGapBottom: state.dragOverNodeKey === key && state.dropPosition === 1,
	      expanded: state.expandedKeys.indexOf(key) !== -1,
	      selected: state.selectedKeys.indexOf(key) !== -1,
	      openTransitionName: this.getOpenTransitionName(),
	      openAnimation: props.openAnimation,
	      filterTreeNode: this.filterTreeNode
	    };
	    if (props.checkable) {
	      childProps.checkable = props.checkable;
	      childProps.checked = state.checkedKeys.indexOf(key) !== -1;
	      childProps.halfChecked = state.halfCheckedKeys.indexOf(key) !== -1;
	    }
	    return _react2['default'].cloneElement(child, childProps);
	  };
	
	  Tree.prototype.render = function render() {
	    var _classNames;
	
	    var props = this.props;
	    var className = (0, _classnames2['default'])(props.prefixCls, props.className, (_classNames = {}, _classNames[props.prefixCls + '-show-line'] = props.showLine, _classNames));
	    var domProps = {};
	    if (props.focusable) {
	      domProps.tabIndex = '0';
	      domProps.onKeyDown = this.onKeyDown;
	    }
	
	    return _react2['default'].createElement(
	      'ul',
	      (0, _extends3['default'])({}, domProps, {
	        className: className,
	        role: 'tree-node',
	        unselectable: 'on'
	      }),
	      _react2['default'].Children.map(props.children, this.renderTreeNode, this)
	    );
	  };
	
	  return Tree;
	}(_react2['default'].Component);
	
	Tree.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  showLine: _propTypes2['default'].bool,
	  showIcon: _propTypes2['default'].bool,
	  selectable: _propTypes2['default'].bool,
	  multiple: _propTypes2['default'].bool,
	  checkable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	  checkStrictly: _propTypes2['default'].bool,
	  draggable: _propTypes2['default'].bool,
	  autoExpandParent: _propTypes2['default'].bool,
	  defaultExpandAll: _propTypes2['default'].bool,
	  defaultExpandedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  expandedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  defaultCheckedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  checkedKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].string), _propTypes2['default'].object]),
	  defaultSelectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  selectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  onExpand: _propTypes2['default'].func,
	  onCheck: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  loadData: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onRightClick: _propTypes2['default'].func,
	  onDragStart: _propTypes2['default'].func,
	  onDragEnter: _propTypes2['default'].func,
	  onDragOver: _propTypes2['default'].func,
	  onDragLeave: _propTypes2['default'].func,
	  onDrop: _propTypes2['default'].func,
	  onDragEnd: _propTypes2['default'].func,
	  filterTreeNode: _propTypes2['default'].func,
	  openTransitionName: _propTypes2['default'].string,
	  openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object])
	};
	Tree.childContextTypes = contextTypes;
	Tree.defaultProps = {
	  prefixCls: 'rc-tree',
	  showLine: false,
	  showIcon: true,
	  selectable: true,
	  multiple: false,
	  checkable: false,
	  checkStrictly: false,
	  draggable: false,
	  autoExpandParent: true,
	  defaultExpandAll: false,
	  defaultExpandedKeys: [],
	  defaultCheckedKeys: [],
	  defaultSelectedKeys: [],
	  onExpand: noop,
	  onCheck: noop,
	  onSelect: noop,
	  onDragStart: noop,
	  onDragEnter: noop,
	  onDragOver: noop,
	  onDragLeave: noop,
	  onDrop: noop,
	  onDragEnd: noop,
	  onMouseEnter: noop,
	  onMouseLeave: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onCheck = function (treeNode) {
	    var props = _this4.props,
	        state = _this4.state;
	
	    var checked = !treeNode.props.checked || treeNode.props.halfChecked;
	    var eventObj = {
	      event: 'check',
	      node: treeNode,
	      checked: checked
	    };
	
	    if (props.checkStrictly) {
	      var eventKey = treeNode.props.eventKey;
	      var checkedKeys = [].concat(state.checkedKeys);
	      var index = checkedKeys.indexOf(eventKey);
	      if (checked && index === -1) {
	        checkedKeys.push(eventKey);
	      }
	      if (!checked && index > -1) {
	        checkedKeys.splice(index, 1);
	      }
	
	      eventObj.checkedNodes = [];
	      (0, _util.traverseTreeNodes)(props.children, function (item) {
	        if (checkedKeys.indexOf(item.key) !== -1) {
	          eventObj.checkedNodes.push(item);
	        }
	      });
	
	      if (!('checkedKeys' in props)) {
	        _this4.setState({
	          checkedKeys: checkedKeys
	        });
	      }
	      props.onCheck((0, _util.getStrictlyValue)(checkedKeys, state.halfCheckedKeys), eventObj);
	    } else {
	      var treeNodesStates = _this4.generateTreeNodesStates(props.children, state.checkedKeys);
	      treeNodesStates[treeNode.props.pos].checked = checked;
	      treeNodesStates[treeNode.props.pos].halfChecked = false;
	      (0, _util.updateCheckState)(treeNodesStates, treeNode.props.pos, checked);
	
	      var checkKeys = (0, _util.getCheck)(treeNodesStates);
	      eventObj.checkedNodes = checkKeys.checkedNodes;
	      eventObj.checkedNodesPositions = checkKeys.checkedNodesPositions; // TODO: not in API
	      eventObj.halfCheckedKeys = checkKeys.halfCheckedKeys; // TODO: not in API
	
	      if (!('checkedKeys' in props)) {
	        _this4.setState({
	          checkedKeys: checkKeys.checkedKeys,
	          halfCheckedKeys: checkKeys.halfCheckedKeys
	        });
	      }
	      props.onCheck(checkKeys.checkedKeys, eventObj);
	    }
	  };
	
	  this.onKeyDown = function (e) {
	    e.preventDefault();
	  };
	
	  this.filterTreeNode = function (treeNode) {
	    var filterTreeNode = _this4.props.filterTreeNode;
	    if (typeof filterTreeNode !== 'function' || treeNode.props.disabled) {
	      return false;
	    }
	    return filterTreeNode.call(_this4, treeNode);
	  };
	};
	
	exports['default'] = Tree;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TreeNode = undefined;
	
	var _Tree = __webpack_require__(1191);
	
	var _Tree2 = _interopRequireDefault(_Tree);
	
	var _TreeNode = __webpack_require__(2626);
	
	var _TreeNode2 = _interopRequireDefault(_TreeNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Tree2['default'].TreeNode = _TreeNode2['default'];
	
	exports.TreeNode = _TreeNode2['default'];
	exports['default'] = _Tree2['default'];

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getPopupClassNameFromAlign = getPopupClassNameFromAlign;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2) {
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getPopupClassNameFromAlign(builtinPlacements, prefixCls, align) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ },
/* 1195 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = uid;
	var now = +new Date();
	var index = 0;
	
	function uid() {
	  return "rc-upload-" + now + "-" + ++index;
	}
	module.exports = exports['default'];

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = mapSelf;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function mirror(o) {
	  return o;
	}
	
	function mapSelf(children) {
	  // return ReactFragment
	  return _react2['default'].Children.map(children, mirror);
	}
	module.exports = exports['default'];

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Portal = function (_React$Component) {
	  (0, _inherits3['default'])(Portal, _React$Component);
	
	  function Portal() {
	    (0, _classCallCheck3['default'])(this, Portal);
	    return (0, _possibleConstructorReturn3['default'])(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: 'createContainer',
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: 'removeContainer',
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this._container) {
	        return _reactDom2['default'].createPortal(this.props.children, this._container);
	      }
	      return null;
	    }
	  }]);
	  return Portal;
	}(_react2['default'].Component);
	
	Portal.propTypes = {
	  getContainer: _propTypes2['default'].func.isRequired,
	  children: _propTypes2['default'].node.isRequired,
	  didUpdate: _propTypes2['default'].func
	};
	exports['default'] = Portal;
	module.exports = exports['default'];

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports['default'] = getContainerRenderMixin;
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function defaultGetContainer() {
	  var container = document.createElement('div');
	  document.body.appendChild(container);
	  return container;
	}
	
	function getContainerRenderMixin(config) {
	  var _config$autoMount = config.autoMount,
	      autoMount = _config$autoMount === undefined ? true : _config$autoMount,
	      _config$autoDestroy = config.autoDestroy,
	      autoDestroy = _config$autoDestroy === undefined ? true : _config$autoDestroy,
	      isVisible = config.isVisible,
	      isForceRender = config.isForceRender,
	      getComponent = config.getComponent,
	      _config$getContainer = config.getContainer,
	      getContainer = _config$getContainer === undefined ? defaultGetContainer : _config$getContainer;
	
	
	  var mixin = void 0;
	
	  function _renderComponent(instance, componentArg, ready) {
	    if (!isVisible || instance._component || isVisible(instance) || isForceRender && isForceRender(instance)) {
	      if (!instance._container) {
	        instance._container = getContainer(instance);
	      }
	      var component = void 0;
	      if (instance.getComponent) {
	        component = instance.getComponent(componentArg);
	      } else {
	        component = getComponent(instance, componentArg);
	      }
	      _reactDom2['default'].unstable_renderSubtreeIntoContainer(instance, component, instance._container, function callback() {
	        instance._component = this;
	        if (ready) {
	          ready.call(this);
	        }
	      });
	    }
	  }
	
	  if (autoMount) {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      componentDidMount: function componentDidMount() {
	        _renderComponent(this);
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        _renderComponent(this);
	      }
	    });
	  }
	
	  if (!autoMount || !autoDestroy) {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      renderComponent: function renderComponent(componentArg, ready) {
	        _renderComponent(this, componentArg, ready);
	      }
	    });
	  }
	
	  function _removeContainer(instance) {
	    if (instance._container) {
	      var container = instance._container;
	      _reactDom2['default'].unmountComponentAtNode(container);
	      container.parentNode.removeChild(container);
	      instance._container = null;
	    }
	  }
	
	  if (autoDestroy) {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      componentWillUnmount: function componentWillUnmount() {
	        _removeContainer(this);
	      }
	    });
	  } else {
	    mixin = (0, _extends3['default'])({}, mixin, {
	      removeContainer: function removeContainer() {
	        _removeContainer(this);
	      }
	    });
	  }
	
	  return mixin;
	}
	module.exports = exports['default'];

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * If set to true, renders `span` instead of `a`
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * `href` attribute for the inner `a` element
	   */
	  href: _propTypes2.default.string,
	  /**
	   * `title` attribute for the inner `a` element
	   */
	  title: _propTypes2.default.node,
	  /**
	   * `target` attribute for the inner `a` element
	   */
	  target: _propTypes2.default.string
	};
	
	var defaultProps = {
	  active: false
	};
	
	var BreadcrumbItem = function (_React$Component) {
	  (0, _inherits3.default)(BreadcrumbItem, _React$Component);
	
	  function BreadcrumbItem() {
	    (0, _classCallCheck3.default)(this, BreadcrumbItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  BreadcrumbItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        href = _props.href,
	        title = _props.title,
	        target = _props.target,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'href', 'title', 'target', 'className']);
	
	    // Don't try to render these props on non-active <span>.
	
	    var linkProps = { href: href, title: title, target: target };
	
	    return _react2.default.createElement(
	      'li',
	      { className: (0, _classnames2.default)(className, { active: active }) },
	      active ? _react2.default.createElement('span', props) : _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, linkProps))
	    );
	  };
	
	  return BreadcrumbItem;
	}(_react2.default.Component);
	
	BreadcrumbItem.propTypes = propTypes;
	BreadcrumbItem.defaultProps = defaultProps;
	
	exports.default = BreadcrumbItem;
	module.exports = exports['default'];

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionEvents = __webpack_require__(2709);
	
	var _TransitionEvents2 = _interopRequireDefault(_TransitionEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should use a timeout instead of TransitionEvents, or else just
	// not wait until transition end to trigger continuing animations.
	
	var propTypes = {
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  onAnimateOutEnd: _propTypes2.default.func,
	  active: _propTypes2.default.bool,
	  animateIn: _propTypes2.default.bool,
	  animateOut: _propTypes2.default.bool,
	  index: _propTypes2.default.number
	};
	
	var defaultProps = {
	  active: false,
	  animateIn: false,
	  animateOut: false
	};
	
	var CarouselItem = function (_React$Component) {
	  (0, _inherits3.default)(CarouselItem, _React$Component);
	
	  function CarouselItem(props, context) {
	    (0, _classCallCheck3.default)(this, CarouselItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);
	
	    _this.state = {
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.active !== nextProps.active) {
	      this.setState({ direction: null });
	    }
	  };
	
	  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _this2 = this;
	
	    var active = this.props.active;
	
	    var prevActive = prevProps.active;
	
	    if (!active && prevActive) {
	      _TransitionEvents2.default.addEndEventListener(_reactDom2.default.findDOMNode(this), this.handleAnimateOutEnd);
	    }
	
	    if (active !== prevActive) {
	      setTimeout(function () {
	        return _this2.startAnimation();
	      }, 20);
	    }
	  };
	
	  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.isUnmounted = true;
	  };
	
	  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    if (this.props.onAnimateOutEnd) {
	      this.props.onAnimateOutEnd(this.props.index);
	    }
	  };
	
	  CarouselItem.prototype.startAnimation = function startAnimation() {
	    if (this.isUnmounted) {
	      return;
	    }
	
	    this.setState({
	      direction: this.props.direction === 'prev' ? 'right' : 'left'
	    });
	  };
	
	  CarouselItem.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        active = _props.active,
	        animateIn = _props.animateIn,
	        animateOut = _props.animateOut,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);
	
	
	    delete props.onAnimateOutEnd;
	    delete props.index;
	
	    var classes = {
	      item: true,
	      active: active && !animateIn || animateOut
	    };
	    if (direction && active && animateIn) {
	      classes[direction] = true;
	    }
	    if (this.state.direction && (animateIn || animateOut)) {
	      classes[this.state.direction] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselItem;
	}(_react2.default.Component);
	
	CarouselItem.propTypes = propTypes;
	CarouselItem.defaultProps = defaultProps;
	
	exports.default = CarouselItem;
	module.exports = exports['default'];

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Button = __webpack_require__(241);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  noCaret: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  useAnchor: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  open: false,
	  useAnchor: false,
	  bsRole: 'toggle'
	};
	
	var DropdownToggle = function (_React$Component) {
	  (0, _inherits3.default)(DropdownToggle, _React$Component);
	
	  function DropdownToggle() {
	    (0, _classCallCheck3.default)(this, DropdownToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownToggle.prototype.render = function render() {
	    var _props = this.props,
	        noCaret = _props.noCaret,
	        open = _props.open,
	        useAnchor = _props.useAnchor,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);
	
	
	    delete props.bsRole;
	
	    var Component = useAnchor ? _SafeAnchor2.default : _Button2.default;
	    var useCaret = !noCaret;
	
	    // This intentionally forwards bsSize and bsStyle (if set) to the
	    // underlying component, to allow it to render size and style variants.
	
	    // FIXME: Should this really fall back to `title` as children?
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, props, {
	        role: 'button',
	        className: (0, _classnames2.default)(className, bsClass),
	        'aria-haspopup': true,
	        'aria-expanded': open
	      }),
	      children || props.title,
	      useCaret && ' ',
	      useCaret && _react2.default.createElement('span', { className: 'caret' })
	    );
	  };
	
	  return DropdownToggle;
	}(_react2.default.Component);
	
	DropdownToggle.propTypes = propTypes;
	DropdownToggle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-toggle', DropdownToggle);
	module.exports = exports['default'];

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Turn any fixed-width grid layout into a full-width layout by this property.
	   *
	   * Adds `container-fluid` class.
	   */
	  fluid: _propTypes2.default.bool,
	  /**
	   * You can use a custom element for this component
	   */
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div',
	  fluid: false
	};
	
	var Grid = function (_React$Component) {
	  (0, _inherits3.default)(Grid, _React$Component);
	
	  function Grid() {
	    (0, _classCallCheck3.default)(this, Grid);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Grid.prototype.render = function render() {
	    var _props = this.props,
	        fluid = _props.fluid,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['fluid', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.prefix)(bsProps, fluid && 'fluid');
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Grid;
	}(_react2.default.Component);
	
	Grid.propTypes = propTypes;
	Grid.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('container', Grid);
	module.exports = exports['default'];

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(175);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.any,
	  disabled: _propTypes2.default.any,
	  header: _propTypes2.default.node,
	  listItem: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  href: _propTypes2.default.string,
	  type: _propTypes2.default.string
	};
	
	var defaultProps = {
	  listItem: false
	};
	
	var ListGroupItem = function (_React$Component) {
	  (0, _inherits3.default)(ListGroupItem, _React$Component);
	
	  function ListGroupItem() {
	    (0, _classCallCheck3.default)(this, ListGroupItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
	    if (_react2.default.isValidElement(header)) {
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, headingClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'h4',
	      { className: headingClassName },
	      header
	    );
	  };
	
	  ListGroupItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        className = _props.className,
	        header = _props.header,
	        listItem = _props.listItem,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active,
	      disabled: disabled
	    });
	
	    var Component = void 0;
	
	    if (elementProps.href) {
	      Component = 'a';
	    } else if (elementProps.onClick) {
	      Component = 'button';
	      elementProps.type = elementProps.type || 'button';
	    } else if (listItem) {
	      Component = 'li';
	    } else {
	      Component = 'span';
	    }
	
	    elementProps.className = (0, _classnames2.default)(className, classes);
	
	    // TODO: Deprecate `header` prop.
	    if (header) {
	      return _react2.default.createElement(
	        Component,
	        elementProps,
	        this.renderHeader(header, (0, _bootstrapUtils.prefix)(bsProps, 'heading')),
	        _react2.default.createElement(
	          'p',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'text') },
	          children
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      Component,
	      elementProps,
	      children
	    );
	  };
	
	  return ListGroupItem;
	}(_react2.default.Component);
	
	ListGroupItem.propTypes = propTypes;
	ListGroupItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group-item', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ListGroupItem));
	module.exports = exports['default'];

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalBody = function (_React$Component) {
	  (0, _inherits3.default)(ModalBody, _React$Component);
	
	  function ModalBody() {
	    (0, _classCallCheck3.default)(this, ModalBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalBody;
	}(_react2.default.Component);
	
	ModalBody.propTypes = propTypes;
	ModalBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-body', ModalBody);
	module.exports = exports['default'];

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var ModalFooter = function (_React$Component) {
	  (0, _inherits3.default)(ModalFooter, _React$Component);
	
	  function ModalFooter() {
	    (0, _classCallCheck3.default)(this, ModalFooter);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalFooter.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalFooter;
	}(_react2.default.Component);
	
	ModalFooter.propTypes = propTypes;
	ModalFooter.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-footer', ModalFooter);
	module.exports = exports['default'];

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _CloseButton = __webpack_require__(485);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `aria-label` should be `closeLabel`.
	
	var propTypes = {
	  /**
	   * Provides an accessible label for the close
	   * button. It is used for Assistive Technology when the label text is not
	   * readable.
	   */
	  closeLabel: _propTypes2.default.string,
	
	  /**
	   * Specify whether the Component should contain a close button
	   */
	  closeButton: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired when the close button is clicked. If used directly inside
	   * a Modal component, the onHide will automatically be propagated up to the
	   * parent Modal `onHide`.
	   */
	  onHide: _propTypes2.default.func
	};
	
	var defaultProps = {
	  closeLabel: 'Close',
	  closeButton: false
	};
	
	var contextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var ModalHeader = function (_React$Component) {
	  (0, _inherits3.default)(ModalHeader, _React$Component);
	
	  function ModalHeader() {
	    (0, _classCallCheck3.default)(this, ModalHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalHeader.prototype.render = function render() {
	    var _props = this.props,
	        closeLabel = _props.closeLabel,
	        closeButton = _props.closeButton,
	        onHide = _props.onHide,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);
	
	
	    var modal = this.context.$bs_modal;
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      closeButton && _react2.default.createElement(_CloseButton2.default, {
	        label: closeLabel,
	        onClick: (0, _createChainedFunction2.default)(modal && modal.onHide, onHide)
	      }),
	      children
	    );
	  };
	
	  return ModalHeader;
	}(_react2.default.Component);
	
	ModalHeader.propTypes = propTypes;
	ModalHeader.defaultProps = defaultProps;
	ModalHeader.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-header', ModalHeader);
	module.exports = exports['default'];

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var ModalTitle = function (_React$Component) {
	  (0, _inherits3.default)(ModalTitle, _React$Component);
	
	  function ModalTitle() {
	    (0, _classCallCheck3.default)(this, ModalTitle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalTitle.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ModalTitle;
	}(_react2.default.Component);
	
	ModalTitle.propTypes = propTypes;
	ModalTitle.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal-title', ModalTitle);
	module.exports = exports['default'];

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(446);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _all = __webpack_require__(322);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
	
	// TODO: This `bsStyle` is very unlike the others. Should we rename it?
	
	// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
	// Consider renaming or replacing them.
	
	var propTypes = {
	  /**
	   * Marks the NavItem with a matching `eventKey` as active. Has a
	   * higher precedence over `activeHref`.
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Marks the child NavItem with a matching `href` prop as active.
	   */
	  activeHref: _propTypes2.default.string,
	
	  /**
	   * NavItems are be positioned vertically.
	   */
	  stacked: _propTypes2.default.bool,
	
	  justified: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var justified = _ref.justified,
	        navbar = _ref.navbar;
	    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
	  }),
	
	  /**
	   * A callback fired when a NavItem is selected.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * ARIA role for the Nav, in the context of a TabContainer, the default will
	   * be set to "tablist", but can be overridden by the Nav when set explicitly.
	   *
	   * When the role is set to "tablist" NavItem focus is managed according to
	   * the ARIA authoring practices for tabs:
	   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
	   */
	  role: _propTypes2.default.string,
	
	  /**
	   * Apply styling an alignment for use in a Navbar. This prop will be set
	   * automatically when the Nav is used inside a Navbar.
	   */
	  navbar: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the right. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullRight: _propTypes2.default.bool,
	
	  /**
	   * Float the Nav to the left. When `navbar` is `true` the appropriate
	   * contextual classes are added as well.
	   */
	  pullLeft: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  justified: false,
	  pullRight: false,
	  pullLeft: false,
	  stacked: false
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    onSelect: _propTypes2.default.func
	  }),
	
	  $bs_tabContainer: _propTypes2.default.shape({
	    activeKey: _propTypes2.default.any,
	    onSelect: _propTypes2.default.func.isRequired,
	    getTabId: _propTypes2.default.func.isRequired,
	    getPaneId: _propTypes2.default.func.isRequired
	  })
	};
	
	var Nav = function (_React$Component) {
	  (0, _inherits3.default)(Nav, _React$Component);
	
	  function Nav() {
	    (0, _classCallCheck3.default)(this, Nav);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    if (!this._needsRefocus) {
	      return;
	    }
	
	    this._needsRefocus = false;
	
	    var children = this.props.children;
	
	    var _getActiveProps = this.getActiveProps(),
	        activeKey = _getActiveProps.activeKey,
	        activeHref = _getActiveProps.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    });
	
	    var childrenArray = _ValidComponentChildren2.default.toArray(children);
	    var activeChildIndex = childrenArray.indexOf(activeChild);
	
	    var childNodes = _reactDom2.default.findDOMNode(this).children;
	    var activeNode = childNodes && childNodes[activeChildIndex];
	
	    if (!activeNode || !activeNode.firstChild) {
	      return;
	    }
	
	    activeNode.firstChild.focus();
	  };
	
	  Nav.prototype.getActiveProps = function getActiveProps() {
	    var tabContainer = this.context.$bs_tabContainer;
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;
	
	      return tabContainer;
	    }
	
	    return this.props;
	  };
	
	  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
	    var _this3 = this;
	
	    var children = this.props.children;
	
	    var validChildren = children.filter(function (child) {
	      return child.props.eventKey != null && !child.props.disabled;
	    });
	
	    var _getActiveProps2 = this.getActiveProps(),
	        activeKey = _getActiveProps2.activeKey,
	        activeHref = _getActiveProps2.activeHref;
	
	    var activeChild = _ValidComponentChildren2.default.find(children, function (child) {
	      return _this3.isActive(child, activeKey, activeHref);
	    });
	
	    // This assumes the active child is not disabled.
	    var activeChildIndex = validChildren.indexOf(activeChild);
	    if (activeChildIndex === -1) {
	      // Something has gone wrong. Select the first valid child we can find.
	      return validChildren[0];
	    }
	
	    var nextIndex = activeChildIndex + offset;
	    var numValidChildren = validChildren.length;
	
	    if (nextIndex >= numValidChildren) {
	      nextIndex = 0;
	    } else if (nextIndex < 0) {
	      nextIndex = numValidChildren - 1;
	    }
	
	    return validChildren[nextIndex];
	  };
	
	  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
	    var _this4 = this;
	
	    if (!tabContainer && navRole !== 'tablist') {
	      // No tab props here.
	      return null;
	    }
	
	    var _child$props = child.props,
	        id = _child$props.id,
	        controls = _child$props['aria-controls'],
	        eventKey = _child$props.eventKey,
	        role = _child$props.role,
	        onKeyDown = _child$props.onKeyDown,
	        tabIndex = _child$props.tabIndex;
	
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      id = tabContainer.getTabId(eventKey);
	      controls = tabContainer.getPaneId(eventKey);
	    }
	
	    if (navRole === 'tablist') {
	      role = role || 'tab';
	      onKeyDown = (0, _createChainedFunction2.default)(function (event) {
	        return _this4.handleTabKeyDown(onSelect, event);
	      }, onKeyDown);
	      tabIndex = active ? tabIndex : -1;
	    }
	
	    return {
	      id: id,
	      role: role,
	      onKeyDown: onKeyDown,
	      'aria-controls': controls,
	      tabIndex: tabIndex
	    };
	  };
	
	  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
	    var nextActiveChild = void 0;
	
	    switch (event.keyCode) {
	      case _keycode2.default.codes.left:
	      case _keycode2.default.codes.up:
	        nextActiveChild = this.getNextActiveChild(-1);
	        break;
	      case _keycode2.default.codes.right:
	      case _keycode2.default.codes.down:
	        nextActiveChild = this.getNextActiveChild(1);
	        break;
	      default:
	        // It was a different key; don't handle this keypress.
	        return;
	    }
	
	    event.preventDefault();
	
	    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
	      onSelect(nextActiveChild.props.eventKey);
	    }
	
	    this._needsRefocus = true;
	  };
	
	  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
	    var props = _ref2.props;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  Nav.prototype.render = function render() {
	    var _extends2,
	        _this5 = this;
	
	    var _props = this.props,
	        stacked = _props.stacked,
	        justified = _props.justified,
	        onSelect = _props.onSelect,
	        propsRole = _props.role,
	        propsNavbar = _props.navbar,
	        pullRight = _props.pullRight,
	        pullLeft = _props.pullLeft,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);
	
	
	    var tabContainer = this.context.$bs_tabContainer;
	    var role = propsRole || (tabContainer ? 'tablist' : null);
	
	    var _getActiveProps3 = this.getActiveProps(),
	        activeKey = _getActiveProps3.activeKey,
	        activeHref = _getActiveProps3.activeHref;
	
	    delete props.activeKey; // Accessed via this.getActiveProps().
	    delete props.activeHref; // Accessed via this.getActiveProps().
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'stacked')] = stacked, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'justified')] = justified, _extends2));
	
	    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
	    var pullLeftClassName = void 0;
	    var pullRightClassName = void 0;
	
	    if (navbar) {
	      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	      classes[(0, _bootstrapUtils.prefix)(navbarProps, 'nav')] = true;
	
	      pullRightClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'right');
	      pullLeftClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'left');
	    } else {
	      pullRightClassName = 'pull-right';
	      pullLeftClassName = 'pull-left';
	    }
	
	    classes[pullRightClassName] = pullRight;
	    classes[pullLeftClassName] = pullLeft;
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends4.default)({}, elementProps, {
	        role: role,
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var active = _this5.isActive(child, activeKey, activeHref);
	        var childOnSelect = (0, _createChainedFunction2.default)(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
	
	        return (0, _react.cloneElement)(child, (0, _extends4.default)({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
	          active: active,
	          activeKey: activeKey,
	          activeHref: activeHref,
	          onSelect: childOnSelect
	        }));
	      })
	    );
	  };
	
	  return Nav;
	}(_react2.default.Component);
	
	Nav.propTypes = propTypes;
	Nav.defaultProps = defaultProps;
	Nav.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('nav', (0, _bootstrapUtils.bsStyles)(['tabs', 'pills'], Nav));
	module.exports = exports['default'];

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  active: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  active: false,
	  disabled: false
	};
	
	var NavItem = function (_React$Component) {
	  (0, _inherits3.default)(NavItem, _React$Component);
	
	  function NavItem(props, context) {
	    (0, _classCallCheck3.default)(this, NavItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  NavItem.prototype.handleClick = function handleClick(e) {
	    if (this.props.onSelect) {
	      e.preventDefault();
	
	      if (!this.props.disabled) {
	        this.props.onSelect(this.props.eventKey, e);
	      }
	    }
	  };
	
	  NavItem.prototype.render = function render() {
	    var _props = this.props,
	        active = _props.active,
	        disabled = _props.disabled,
	        onClick = _props.onClick,
	        className = _props.className,
	        style = _props.style,
	        props = (0, _objectWithoutProperties3.default)(_props, ['active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    // These are injected down by `<Nav>` for building `<SubNav>`s.
	    delete props.activeKey;
	    delete props.activeHref;
	
	    if (!props.role) {
	      if (props.href === '#') {
	        props.role = 'button';
	      }
	    } else if (props.role === 'tab') {
	      props['aria-selected'] = active;
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return NavItem;
	}(_react2.default.Component);
	
	NavItem.propTypes = propTypes;
	NavItem.defaultProps = defaultProps;
	
	exports.default = NavItem;
	module.exports = exports['default'];

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarBrand = function (_React$Component) {
	  (0, _inherits3.default)(NavbarBrand, _React$Component);
	
	  function NavbarBrand() {
	    (0, _classCallCheck3.default)(this, NavbarBrand);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarBrand.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'brand');
	
	    if (_react2.default.isValidElement(children)) {
	      return _react2.default.cloneElement(children, {
	        className: (0, _classnames2.default)(children.props.className, className, bsClassName)
	      });
	    }
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }),
	      children
	    );
	  };
	
	  return NavbarBrand;
	}(_react2.default.Component);
	
	NavbarBrand.contextTypes = contextTypes;
	
	exports.default = NavbarBrand;
	module.exports = exports['default'];

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Overlay = __webpack_require__(2767);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(332);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	  /**
	   * A callback invoked by the overlay when it wishes to be hidden. Required if
	   * `rootClose` is specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Use animation
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Sets the direction of the Overlay.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left'])
	});
	
	var defaultProps = {
	  animation: _Fade2.default,
	  rootClose: false,
	  show: false,
	  placement: 'right'
	};
	
	var Overlay = function (_React$Component) {
	  (0, _inherits3.default)(Overlay, _React$Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        animation = _props.animation,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['animation', 'children']);
	
	
	    var transition = animation === true ? _Fade2.default : animation || null;
	
	    var child = void 0;
	
	    if (!transition) {
	      child = (0, _react.cloneElement)(children, {
	        className: (0, _classnames2.default)(children.props.className, 'in')
	      });
	    } else {
	      child = children;
	    }
	
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        transition: transition
	      }),
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = propTypes;
	Overlay.defaultProps = defaultProps;
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  disabled: _propTypes2.default.bool,
	  previous: _propTypes2.default.bool,
	  next: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  onSelect: _propTypes2.default.func,
	  eventKey: _propTypes2.default.any
	};
	
	var defaultProps = {
	  disabled: false,
	  previous: false,
	  next: false
	};
	
	var PagerItem = function (_React$Component) {
	  (0, _inherits3.default)(PagerItem, _React$Component);
	
	  function PagerItem(props, context) {
	    (0, _classCallCheck3.default)(this, PagerItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	    return _this;
	  }
	
	  PagerItem.prototype.handleSelect = function handleSelect(e) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (onSelect || disabled) {
	      e.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, e);
	    }
	  };
	
	  PagerItem.prototype.render = function render() {
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        previous = _props2.previous,
	        next = _props2.next,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);
	
	
	    delete props.onSelect;
	    delete props.eventKey;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { disabled: disabled, previous: previous, next: next }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleSelect)
	      }))
	    );
	  };
	
	  return PagerItem;
	}(_react2.default.Component);
	
	PagerItem.propTypes = propTypes;
	PagerItem.defaultProps = defaultProps;
	
	exports.default = PagerItem;
	module.exports = exports['default'];

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should be `<Pagination.Item>`.
	
	// TODO: This should use `componentClass` like other components.
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  className: _propTypes2.default.string,
	  eventKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: _SafeAnchor2.default,
	  active: false,
	  disabled: false
	};
	
	var PaginationButton = function (_React$Component) {
	  (0, _inherits3.default)(PaginationButton, _React$Component);
	
	  function PaginationButton(props, context) {
	    (0, _classCallCheck3.default)(this, PaginationButton);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  PaginationButton.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  PaginationButton.prototype.render = function render() {
	    var _props2 = this.props,
	        Component = _props2.componentClass,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);
	
	
	    if (Component === _SafeAnchor2.default) {
	      // Assume that custom components want `eventKey`.
	      delete props.eventKey;
	    }
	
	    delete props.onSelect;
	
	    return _react2.default.createElement(
	      'li',
	      {
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(Component, (0, _extends3.default)({}, props, {
	        disabled: disabled,
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return PaginationButton;
	}(_react2.default.Component);
	
	PaginationButton.propTypes = propTypes;
	PaginationButton.defaultProps = defaultProps;
	
	exports.default = PaginationButton;
	module.exports = exports['default'];

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(754);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  accordion: _propTypes2.default.bool,
	  activeKey: _propTypes2.default.any,
	  defaultActiveKey: _propTypes2.default.any,
	  onSelect: _propTypes2.default.func,
	  role: _propTypes2.default.string
	};
	
	var defaultProps = {
	  accordion: false
	};
	
	// TODO: Use uncontrollable.
	
	var PanelGroup = function (_React$Component) {
	  (0, _inherits3.default)(PanelGroup, _React$Component);
	
	  function PanelGroup(props, context) {
	    (0, _classCallCheck3.default)(this, PanelGroup);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleSelect = _this.handleSelect.bind(_this);
	
	    _this.state = {
	      activeKey: props.defaultActiveKey
	    };
	    return _this;
	  }
	
	  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
	    e.preventDefault();
	
	    if (this.props.onSelect) {
	      this.props.onSelect(key, e);
	    }
	
	    if (this.state.activeKey === key) {
	      key = null;
	    }
	
	    this.setState({ activeKey: key });
	  };
	
	  PanelGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        accordion = _props.accordion,
	        propsActiveKey = _props.activeKey,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['accordion', 'activeKey', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultActiveKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeKey = void 0;
	    if (accordion) {
	      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
	      elementProps.role = elementProps.role || 'tablist';
	    }
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var childProps = {
	          bsStyle: child.props.bsStyle || bsProps.bsStyle
	        };
	
	        if (accordion) {
	          (0, _assign2.default)(childProps, {
	            headerRole: 'tab',
	            panelRole: 'tabpanel',
	            collapsible: true,
	            expanded: child.props.eventKey === activeKey,
	            onSelect: (0, _createChainedFunction2.default)(_this2.handleSelect, child.props.onSelect)
	          });
	        }
	
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return PanelGroup;
	}(_react2.default.Component);
	
	PanelGroup.propTypes = propTypes;
	PanelGroup.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel-group', PanelGroup);
	module.exports = exports['default'];

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _Fade = __webpack_require__(332);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uniquely identify the `<TabPane>` among its siblings.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
	   * `true` to enable the default `<Fade>` animation or any `<Transition>`
	   * component.
	   */
	  animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	
	  /** @private * */
	  id: _propTypes2.default.string,
	
	  /** @private * */
	  'aria-labelledby': _propTypes2.default.string,
	
	  /**
	   * If not explicitly specified and rendered in the context of a
	   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
	   * If otherwise not explicitly specified, `tab-pane`.
	   */
	  bsClass: _propTypes2.default.string,
	
	  /**
	   * Transition onEnter callback when animation is not `false`
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Transition onEntering callback when animation is not `false`
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Transition onEntered callback when animation is not `false`
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Transition onExit callback when animation is not `false`
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Transition onExiting callback when animation is not `false`
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Transition onExited callback when animation is not `false`
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the tab (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var contextTypes = {
	  $bs_tabContainer: _propTypes2.default.shape({
	    getTabId: _propTypes2.default.func,
	    getPaneId: _propTypes2.default.func
	  }),
	  $bs_tabContent: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    animation: _propTypes2.default.oneOfType([_propTypes2.default.bool, _elementType2.default]),
	    activeKey: _propTypes2.default.any,
	    mountOnEnter: _propTypes2.default.bool,
	    unmountOnExit: _propTypes2.default.bool,
	    onPaneEnter: _propTypes2.default.func.isRequired,
	    onPaneExited: _propTypes2.default.func.isRequired,
	    exiting: _propTypes2.default.bool.isRequired
	  })
	};
	
	/**
	 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
	 * conflict with the top level one.
	 */
	var childContextTypes = {
	  $bs_tabContainer: _propTypes2.default.oneOf([null])
	};
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3.default)(TabPane, _React$Component);
	
	  function TabPane(props, context) {
	    (0, _classCallCheck3.default)(this, TabPane);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEnter = _this.handleEnter.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	
	    _this.in = false;
	    return _this;
	  }
	
	  TabPane.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_tabContainer: null
	    };
	  };
	
	  TabPane.prototype.componentDidMount = function componentDidMount() {
	    if (this.shouldBeIn()) {
	      // In lieu of the action event firing.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.in) {
	      if (!this.shouldBeIn()) {
	        // We shouldn't be active any more. Notify the parent.
	        this.handleExited();
	      }
	    } else if (this.shouldBeIn()) {
	      // We are the active child. Notify the parent.
	      this.handleEnter();
	    }
	  };
	
	  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.in) {
	      // In lieu of the action event firing.
	      this.handleExited();
	    }
	  };
	
	  TabPane.prototype.getAnimation = function getAnimation() {
	    if (this.props.animation != null) {
	      return this.props.animation;
	    }
	
	    var tabContent = this.context.$bs_tabContent;
	    return tabContent && tabContent.animation;
	  };
	
	  TabPane.prototype.handleEnter = function handleEnter() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
	  };
	
	  TabPane.prototype.handleExited = function handleExited() {
	    var tabContent = this.context.$bs_tabContent;
	    if (!tabContent) {
	      return;
	    }
	
	    tabContent.onPaneExited(this);
	    this.in = false;
	  };
	
	  TabPane.prototype.isActive = function isActive() {
	    var tabContent = this.context.$bs_tabContent;
	    var activeKey = tabContent && tabContent.activeKey;
	
	    return this.props.eventKey === activeKey;
	  };
	
	  TabPane.prototype.shouldBeIn = function shouldBeIn() {
	    return this.getAnimation() && this.isActive();
	  };
	
	  TabPane.prototype.render = function render() {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        className = _props.className,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        propsMountOnEnter = _props.mountOnEnter,
	        propsUnmountOnExit = _props.unmountOnExit,
	        props = (0, _objectWithoutProperties3.default)(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);
	    var _context = this.context,
	        tabContent = _context.$bs_tabContent,
	        tabContainer = _context.$bs_tabContainer;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['animation']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var active = this.isActive();
	    var animation = this.getAnimation();
	
	    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
	    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;
	
	    if (!active && !animation && unmountOnExit) {
	      return null;
	    }
	
	    var Transition = animation === true ? _Fade2.default : animation || null;
	
	    if (tabContent) {
	      bsProps.bsClass = (0, _bootstrapUtils.prefix)(tabContent, 'pane');
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      active: active
	    });
	
	    if (tabContainer) {
	       false ? (0, _warning2.default)(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
	
	      elementProps.id = tabContainer.getPaneId(eventKey);
	      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
	    }
	
	    var pane = _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'tabpanel',
	      'aria-hidden': !active,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (Transition) {
	      var exiting = tabContent && tabContent.exiting;
	
	      return _react2.default.createElement(
	        Transition,
	        {
	          'in': active && !exiting,
	          onEnter: (0, _createChainedFunction2.default)(this.handleEnter, onEnter),
	          onEntering: onEntering,
	          onEntered: onEntered,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: (0, _createChainedFunction2.default)(this.handleExited, onExited),
	          mountOnEnter: mountOnEnter,
	          unmountOnExit: unmountOnExit
	        },
	        pane
	      );
	    }
	
	    return pane;
	  };
	
	  return TabPane;
	}(_react2.default.Component);
	
	TabPane.propTypes = propTypes;
	TabPane.contextTypes = contextTypes;
	TabPane.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tab-pane', TabPane);
	module.exports = exports['default'];

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(241);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * The `<input>` `type`
	   * @type {[type]}
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']),
	
	  /**
	   * The HTML input name, used to group like checkboxes or radio buttons together
	   * semantically
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
	   */
	  checked: _propTypes2.default.bool,
	
	  /**
	   * The disabled state of both the label and input
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * [onChange description]
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * The value of the input, and unique identifier in the ToggleButtonGroup
	   */
	  value: _propTypes2.default.any.isRequired
	};
	
	var ToggleButton = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButton, _React$Component);
	
	  function ToggleButton() {
	    (0, _classCallCheck3.default)(this, ToggleButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButton.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        name = _props.name,
	        checked = _props.checked,
	        type = _props.type,
	        onChange = _props.onChange,
	        value = _props.value,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);
	
	    var disabled = props.disabled;
	
	    return _react2.default.createElement(
	      _Button2.default,
	      (0, _extends3.default)({}, props, {
	        active: !!checked,
	        componentClass: 'label'
	      }),
	      _react2.default.createElement('input', {
	        name: name,
	        type: type,
	        autoComplete: 'off',
	        value: value,
	        checked: !!checked,
	        disabled: !!disabled,
	        onChange: onChange
	      }),
	      children
	    );
	  };
	
	  return ToggleButton;
	}(_react2.default.Component);
	
	ToggleButton.propTypes = propTypes;
	
	exports.default = ToggleButton;
	module.exports = exports['default'];

/***/ },
/* 1217 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = capitalize;
	function capitalize(string) {
	  return "" + string.charAt(0).toUpperCase() + string.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExcelColumn = function (_React$Component) {
	    _inherits(ExcelColumn, _React$Component);
	
	    function ExcelColumn() {
	        _classCallCheck(this, ExcelColumn);
	
	        return _possibleConstructorReturn(this, (ExcelColumn.__proto__ || Object.getPrototypeOf(ExcelColumn)).apply(this, arguments));
	    }
	
	    _createClass(ExcelColumn, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return ExcelColumn;
	}(_react2.default.Component);
	
	ExcelColumn.propsTypes = {
	    label: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.func]).isRequired
	};
	exports.default = ExcelColumn;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExcelColumn = __webpack_require__(1218);
	
	var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExcelSheet = function (_React$Component) {
	    _inherits(ExcelSheet, _React$Component);
	
	    function ExcelSheet() {
	        _classCallCheck(this, ExcelSheet);
	
	        return _possibleConstructorReturn(this, (ExcelSheet.__proto__ || Object.getPrototypeOf(ExcelSheet)).apply(this, arguments));
	    }
	
	    _createClass(ExcelSheet, [{
	        key: "render",
	        value: function render() {
	            return null;
	        }
	    }]);
	
	    return ExcelSheet;
	}(_react2.default.Component);
	
	ExcelSheet.propsTypes = {
	    name: _propTypes2.default.string.isRequired,
	    data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    dataSet: _propTypes2.default.arrayOf(_propTypes2.default.object),
	    value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.func]).isRequired,
	    children: _propTypes2.default.arrayOf(function (propValue, key) {
	        var type = propValue[key];
	
	        if (type !== _ExcelColumn2.default) {
	            throw new Error("<ExcelSheet> can only have <ExcelColumn> as children");
	        }
	    }).isRequired
	};
	exports.default = ExcelSheet;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ExcelFile = __webpack_require__(2714);
	
	var _ExcelFile2 = _interopRequireDefault(_ExcelFile);
	
	var _ExcelSheet = __webpack_require__(1219);
	
	var _ExcelSheet2 = _interopRequireDefault(_ExcelSheet);
	
	var _ExcelColumn = __webpack_require__(1218);
	
	var _ExcelColumn2 = _interopRequireDefault(_ExcelColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_ExcelFile2.default.ExcelSheet = _ExcelSheet2.default;
	_ExcelFile2.default.ExcelColumn = _ExcelColumn2.default;
	
	var ReactExport = {
	    ExcelFile: _ExcelFile2.default
	};
	
	exports.default = ReactExport;
	
	exports.modules = {
	    ExcelFile: _ExcelFile2.default,
	    ExcelSheet: _ExcelSheet2.default,
	    ExcelColumn: _ExcelColumn2.default
	};

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureCalendarDay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(240);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _getPhrase = __webpack_require__(2731);
	
	var _getPhrase2 = _interopRequireDefault(_getPhrase);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes2['default'].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].instanceOf(Set),
	  isFocused: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].oneOf([0, -1]),
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderDay: _propTypes2['default'].func,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultProps = {
	  day: (0, _moment2['default'])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderDay: null,
	
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CalendarDay = function (_React$Component) {
	  _inherits(CalendarDay, _React$Component);
	
	  function CalendarDay() {
	    var _ref;
	
	    _classCallCheck(this, CalendarDay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call.apply(_ref, [this].concat(args)));
	
	    _this.setButtonRef = _this.setButtonRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarDay, [{
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            isFocused = _props.isFocused,
	            tabIndex = _props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'setButtonRef',
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            day = _props2.day,
	            daySize = _props2.daySize,
	            isOutsideDay = _props2.isOutsideDay,
	            modifiers = _props2.modifiers,
	            renderDay = _props2.renderDay,
	            tabIndex = _props2.tabIndex,
	            styles = _props2.styles,
	            _props2$phrases = _props2.phrases,
	            chooseAvailableDate = _props2$phrases.chooseAvailableDate,
	            dateIsUnavailable = _props2$phrases.dateIsUnavailable;
	
	
	        if (!day) return _react2['default'].createElement('td', null);
	
	        var formattedDate = { date: String(day.format('dddd')) + ', ' + String(day.format('LL')) };
	
	        var ariaLabel = modifiers.has(_constants.BLOCKED_MODIFIER) ? (0, _getPhrase2['default'])(dateIsUnavailable, formattedDate) : (0, _getPhrase2['default'])(chooseAvailableDate, formattedDate);
	
	        var daySizeStyles = {
	          width: daySize,
	          height: daySize - 1
	        };
	
	        var useDefaultCursor = modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
	
	        var selected = modifiers.has('selected') || modifiers.has('selected-start') || modifiers.has('selected-end');
	
	        var hoveredSpan = !selected && (modifiers.has('hovered-span') || modifiers.has('after-hovered-start'));
	
	        var isOutsideRange = modifiers.has('blocked-out-of-range');
	
	        return _react2['default'].createElement(
	          'td',
	          (0, _reactWithStyles.css)(styles.CalendarDay_container, isOutsideDay && styles.CalendarDay__outside, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('last-in-range') && styles.CalendarDay__last_in_range, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && styles.CalendarDay__selected, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles),
	          _react2['default'].createElement(
	            'button',
	            _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay_button, useDefaultCursor && styles.CalendarDay_button__default), {
	              type: 'button',
	              ref: this.setButtonRef,
	              'aria-label': ariaLabel,
	              onMouseEnter: function () {
	                function onMouseEnter(e) {
	                  _this2.onDayMouseEnter(day, e);
	                }
	
	                return onMouseEnter;
	              }(),
	              onMouseLeave: function () {
	                function onMouseLeave(e) {
	                  _this2.onDayMouseLeave(day, e);
	                }
	
	                return onMouseLeave;
	              }(),
	              onMouseUp: function () {
	                function onMouseUp(e) {
	                  e.currentTarget.blur();
	                }
	
	                return onMouseUp;
	              }(),
	              onClick: function () {
	                function onClick(e) {
	                  _this2.onDayClick(day, e);
	                }
	
	                return onClick;
	              }(),
	              tabIndex: tabIndex
	            }),
	            renderDay ? renderDay(day, modifiers) : day.format('D')
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarDay;
	}(_react2['default'].Component);
	
	CalendarDay.propTypes = propTypes;
	CalendarDay.defaultProps = defaultProps;
	
	exports.PureCalendarDay = CalendarDay;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    CalendarDay_container: {
	      border: '1px solid ' + String(color.core.borderLight),
	      padding: 0,
	      boxSizing: 'border-box',
	      color: color.text,
	      background: '#fff',
	
	      ':hover': {
	        background: color.core.borderLight,
	        border: '1px double ' + String(color.core.borderLight),
	        color: 'inherit'
	      }
	    },
	
	    CalendarDay_button: {
	      position: 'relative',
	      height: '100%',
	      width: '100%',
	      textAlign: 'center',
	      background: 'none',
	      border: 0,
	      margin: 0,
	      padding: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	
	      ':active': {
	        outline: 0
	      }
	    },
	
	    CalendarDay_button__default: {
	      cursor: 'default'
	    },
	
	    CalendarDay__outside: {
	      border: 0,
	
	      background: color.outside.backgroundColor,
	      color: color.outside.color
	    },
	
	    CalendarDay__blocked_minimum_nights: {
	      background: color.minimumNights.backgroundColor,
	      border: '1px solid ' + String(color.minimumNights.borderColor),
	      color: color.minimumNights.color,
	
	      ':hover': {
	        background: color.minimumNights.backgroundColor_hover,
	        color: color.minimumNights.color_active
	      },
	
	      ':active': {
	        background: color.minimumNights.backgroundColor_active,
	        color: color.minimumNights.color_active
	      }
	    },
	
	    CalendarDay__highlighted_calendar: {
	      background: color.highlighted.backgroundColor,
	      color: color.highlighted.color,
	
	      ':hover': {
	        background: color.highlighted.backgroundColor_hover,
	        color: color.highlighted.color_active
	      },
	
	      ':active': {
	        background: color.highlighted.backgroundColor_active,
	        color: color.highlighted.color_active
	      }
	    },
	
	    CalendarDay__selected_span: {
	      background: color.selectedSpan.backgroundColor,
	      border: '1px solid ' + String(color.selectedSpan.borderColor),
	      color: color.selectedSpan.color,
	
	      ':hover': {
	        background: color.selectedSpan.backgroundColor_hover,
	        border: '1px solid ' + String(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      },
	
	      ':active': {
	        background: color.selectedSpan.backgroundColor_active,
	        border: '1px solid ' + String(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      }
	    },
	
	    CalendarDay__last_in_range: {
	      borderRight: color.core.primary
	    },
	
	    CalendarDay__selected: {
	      background: color.selected.backgroundColor,
	      border: '1px solid ' + String(color.selected.borderColor),
	      color: color.selected.color,
	
	      ':hover': {
	        background: color.selected.backgroundColor_hover,
	        border: '1px solid ' + String(color.selected.borderColor),
	        color: color.selected.color_active
	      },
	
	      ':active': {
	        background: color.selected.backgroundColor_active,
	        border: '1px solid ' + String(color.selected.borderColor),
	        color: color.selected.color_active
	      }
	    },
	
	    CalendarDay__hovered_span: {
	      background: color.hoveredSpan.backgroundColor,
	      border: '1px solid ' + String(color.hoveredSpan.borderColor),
	      color: color.hoveredSpan.color,
	
	      ':hover': {
	        background: color.hoveredSpan.backgroundColor_hover,
	        border: '1px solid ' + String(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      },
	
	      ':active': {
	        background: color.hoveredSpan.backgroundColor_active,
	        border: '1px solid ' + String(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      }
	    },
	
	    CalendarDay__blocked_calendar: {
	      background: color.blocked_calendar.backgroundColor,
	      border: '1px solid ' + String(color.blocked_calendar.borderColor),
	      color: color.blocked_calendar.color,
	
	      ':hover': {
	        background: color.blocked_calendar.backgroundColor_hover,
	        border: '1px solid ' + String(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      },
	
	      ':active': {
	        background: color.blocked_calendar.backgroundColor_active,
	        border: '1px solid ' + String(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      }
	    },
	
	    CalendarDay__blocked_out_of_range: {
	      background: color.blocked_out_of_range.backgroundColor,
	      border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	      color: color.blocked_out_of_range.color,
	
	      ':hover': {
	        background: color.blocked_out_of_range.backgroundColor_hover,
	        border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      },
	
	      ':active': {
	        background: color.blocked_out_of_range.backgroundColor_active,
	        border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      }
	    },
	
	    CalendarDay__selected_start: {},
	    CalendarDay__selected_end: {}
	
	  };
	})(CalendarDay);

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarIcon = function () {
	  function CalendarIcon(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z'
	      })
	    );
	  }
	
	  return CalendarIcon;
	}();
	
	CalendarIcon.defaultProps = {
	  xmlns: 'http://www.w3.org/2000/svg',
	  viewBox: '0 0 1393.1 1500'
	};
	exports['default'] = CalendarIcon;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(240);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CalendarDay = __webpack_require__(1221);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	var _calculateDimension = __webpack_require__(2728);
	
	var _calculateDimension2 = _interopRequireDefault(_calculateDimension);
	
	var _getCalendarMonthWeeks = __webpack_require__(2730);
	
	var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);
	
	var _isSameDay = __webpack_require__(194);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _toISODateString = __webpack_require__(336);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _ScrollableOrientationShape = __webpack_require__(193);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-array-index-key: 0 */
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  month: _reactMomentProptypes2['default'].momentObj,
	  isVisible: _propTypes2['default'].bool,
	  enableOutsideDays: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].object,
	  orientation: _ScrollableOrientationShape2['default'],
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderMonth: _propTypes2['default'].func,
	  renderDay: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  setMonthHeight: _propTypes2['default'].func,
	
	  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
	  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultProps = {
	  month: (0, _moment2['default'])(),
	  isVisible: true,
	  enableOutsideDays: false,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  daySize: _constants.DAY_SIZE,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderMonth: null,
	  renderDay: null,
	  firstDayOfWeek: null,
	  setMonthHeight: function () {
	    function setMonthHeight() {}
	
	    return setMonthHeight;
	  }(),
	
	
	  focusedDate: null,
	  isFocused: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY', // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CalendarMonth = function (_React$Component) {
	  _inherits(CalendarMonth, _React$Component);
	
	  function CalendarMonth(props) {
	    _classCallCheck(this, CalendarMonth);
	
	    var _this = _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).call(this, props));
	
	    _this.state = {
	      weeks: (0, _getCalendarMonthWeeks2['default'])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : props.firstDayOfWeek)
	    };
	
	    _this.setCaptionRef = _this.setCaptionRef.bind(_this);
	    _this.setGridRef = _this.setGridRef.bind(_this);
	    _this.setMonthHeight = _this.setMonthHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarMonth, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setMonthHeightTimeout = setTimeout(this.setMonthHeight, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var month = nextProps.month,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            firstDayOfWeek = nextProps.firstDayOfWeek;
	
	        if (!month.isSame(this.props.month) || enableOutsideDays !== this.props.enableOutsideDays || firstDayOfWeek !== this.props.firstDayOfWeek) {
	          this.setState({
	            weeks: (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays, firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : firstDayOfWeek)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.setMonthHeightTimeout) {
	          clearTimeout(this.setMonthHeightTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'setMonthHeight',
	    value: function () {
	      function setMonthHeight() {
	        var setMonthHeight = this.props.setMonthHeight;
	
	        var captionHeight = (0, _calculateDimension2['default'])(this.captionRef, 'height', true, true);
	        var gridHeight = (0, _calculateDimension2['default'])(this.gridRef, 'height');
	
	        setMonthHeight(captionHeight + gridHeight + 1);
	      }
	
	      return setMonthHeight;
	    }()
	  }, {
	    key: 'setCaptionRef',
	    value: function () {
	      function setCaptionRef(ref) {
	        this.captionRef = ref;
	      }
	
	      return setCaptionRef;
	    }()
	  }, {
	    key: 'setGridRef',
	    value: function () {
	      function setGridRef(ref) {
	        this.gridRef = ref;
	      }
	
	      return setGridRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            month = _props.month,
	            monthFormat = _props.monthFormat,
	            orientation = _props.orientation,
	            isVisible = _props.isVisible,
	            modifiers = _props.modifiers,
	            onDayClick = _props.onDayClick,
	            onDayMouseEnter = _props.onDayMouseEnter,
	            onDayMouseLeave = _props.onDayMouseLeave,
	            renderMonth = _props.renderMonth,
	            renderDay = _props.renderDay,
	            daySize = _props.daySize,
	            focusedDate = _props.focusedDate,
	            isFocused = _props.isFocused,
	            styles = _props.styles,
	            phrases = _props.phrases;
	        var weeks = this.state.weeks;
	
	        var monthTitle = renderMonth ? renderMonth(month) : month.format(monthFormat);
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonth, orientation === _constants.HORIZONTAL_ORIENTATION && styles.CalendarMonth__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.CalendarMonth__vertical, verticalScrollable && styles.CalendarMonth__verticalScrollable), {
	            'data-visible': isVisible
	          }),
	          _react2['default'].createElement(
	            'div',
	            _extends({
	              ref: this.setCaptionRef
	            }, (0, _reactWithStyles.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)),
	            _react2['default'].createElement(
	              'strong',
	              null,
	              monthTitle
	            )
	          ),
	          _react2['default'].createElement(
	            'table',
	            _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonth_table), {
	              role: 'presentation'
	            }),
	            _react2['default'].createElement(
	              'tbody',
	              { ref: this.setGridRef },
	              weeks.map(function (week, i) {
	                return _react2['default'].createElement(
	                  'tr',
	                  { key: i },
	                  week.map(function (day, dayOfWeek) {
	                    return _react2['default'].createElement(_CalendarDay2['default'], {
	                      day: day,
	                      daySize: daySize,
	                      isOutsideDay: !day || day.month() !== month.month(),
	                      tabIndex: isVisible && (0, _isSameDay2['default'])(day, focusedDate) ? 0 : -1,
	                      isFocused: isFocused,
	                      key: dayOfWeek,
	                      onDayMouseEnter: onDayMouseEnter,
	                      onDayMouseLeave: onDayMouseLeave,
	                      onDayClick: onDayClick,
	                      renderDay: renderDay,
	                      phrases: phrases,
	                      modifiers: modifiers[(0, _toISODateString2['default'])(day)]
	                    });
	                  })
	                );
	              })
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonth;
	}(_react2['default'].Component);
	
	CalendarMonth.propTypes = propTypes;
	CalendarMonth.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      font = _ref$reactDates.font,
	      spacing = _ref$reactDates.spacing;
	  return {
	    CalendarMonth: {
	      background: color.background,
	      textAlign: 'center',
	      padding: '0 13px',
	      verticalAlign: 'top',
	      userSelect: 'none'
	    },
	
	    CalendarMonth_table: {
	      borderCollapse: 'collapse',
	      borderSpacing: 0
	    },
	
	    CalendarMonth_caption: {
	      color: color.text,
	      fontSize: font.captionSize,
	      textAlign: 'center',
	      paddingTop: spacing.captionPaddingTop,
	      paddingBottom: spacing.captionPaddingBottom,
	      captionSide: 'initial'
	    },
	
	    CalendarMonth_caption__verticalScrollable: {
	      paddingTop: 12,
	      paddingBottom: 7
	    }
	  };
	})(CalendarMonth);

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(240);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _consolidatedEvents = __webpack_require__(289);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CalendarMonth = __webpack_require__(1223);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _isTransitionEndSupported = __webpack_require__(2734);
	
	var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);
	
	var _getTransformStyles = __webpack_require__(2732);
	
	var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
	var _getCalendarMonthWidth = __webpack_require__(1238);
	
	var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);
	
	var _toISOMonthString = __webpack_require__(337);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _isAfterDay = __webpack_require__(244);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _ScrollableOrientationShape = __webpack_require__(193);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  enableOutsideDays: _propTypes2['default'].bool,
	  firstVisibleMonthIndex: _propTypes2['default'].number,
	  initialMonth: _reactMomentProptypes2['default'].momentObj,
	  isAnimating: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  modifiers: _propTypes2['default'].object,
	  orientation: _ScrollableOrientationShape2['default'],
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  onMonthTransitionEnd: _propTypes2['default'].func,
	  renderMonth: _propTypes2['default'].func,
	  renderDay: _propTypes2['default'].func,
	  transformValue: _propTypes2['default'].string,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
	  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  setCalendarMonthHeights: _propTypes2['default'].func,
	  isRTL: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultProps = {
	  enableOutsideDays: false,
	  firstVisibleMonthIndex: 0,
	  initialMonth: (0, _moment2['default'])(),
	  isAnimating: false,
	  numberOfMonths: 1,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  onMonthTransitionEnd: function () {
	    function onMonthTransitionEnd() {}
	
	    return onMonthTransitionEnd;
	  }(),
	
	  renderMonth: null,
	  renderDay: null,
	  transformValue: 'none',
	  daySize: _constants.DAY_SIZE,
	  focusedDate: null,
	  isFocused: false,
	  firstDayOfWeek: null,
	  setCalendarMonthHeights: function () {
	    function setCalendarMonthHeights() {}
	
	    return setCalendarMonthHeights;
	  }(),
	
	  isRTL: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY', // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
	  var month = initialMonth.clone();
	  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
	
	  var months = [];
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    months.push(month);
	    month = month.clone().add(1, 'month');
	  }
	
	  return months;
	}
	
	var CalendarMonthGrid = function (_React$Component) {
	  _inherits(CalendarMonthGrid, _React$Component);
	
	  function CalendarMonthGrid(props) {
	    _classCallCheck(this, CalendarMonthGrid);
	
	    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));
	
	    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
	    _this.state = {
	      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
	    };
	
	    _this.calendarMonthHeights = [];
	
	    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
	    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarMonthGrid, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        var setCalendarMonthHeights = this.props.setCalendarMonthHeights;
	
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
	
	        this.setCalendarMonthHeightsTimeout = setTimeout(function () {
	          setCalendarMonthHeights(_this2.calendarMonthHeights);
	        }, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var initialMonth = nextProps.initialMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            orientation = nextProps.orientation;
	        var months = this.state.months;
	
	
	        var hasMonthChanged = !this.props.initialMonth.isSame(initialMonth, 'month');
	        var hasNumberOfMonthsChanged = this.props.numberOfMonths !== numberOfMonths;
	        var newMonths = months;
	
	        if (hasMonthChanged && !hasNumberOfMonthsChanged) {
	          if ((0, _isAfterDay2['default'])(initialMonth, this.props.initialMonth)) {
	            newMonths = months.slice(1);
	            newMonths.push(months[months.length - 1].clone().add(1, 'month'));
	          } else {
	            newMonths = months.slice(0, months.length - 1);
	            newMonths.unshift(months[0].clone().subtract(1, 'month'));
	          }
	        }
	
	        if (hasNumberOfMonthsChanged) {
	          var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	          newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
	        }
	
	        this.setState({
	          months: newMonths
	        });
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this3 = this;
	
	        var _props = this.props,
	            isAnimating = _props.isAnimating,
	            onMonthTransitionEnd = _props.onMonthTransitionEnd,
	            setCalendarMonthHeights = _props.setCalendarMonthHeights;
	
	        // For IE9, immediately call onMonthTransitionEnd instead of
	        // waiting for the animation to complete
	
	        if (!this.isTransitionEndSupported && isAnimating) {
	          onMonthTransitionEnd();
	        }
	
	        if (!isAnimating && prevProps.isAnimating) {
	          this.setCalendarMonthHeightsTimeout = setTimeout(function () {
	            setCalendarMonthHeights(_this3.calendarMonthHeights);
	          }, 0);
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.setCalendarMonthHeightsTimeout) {
	          clearTimeout(this.setCalendarMonthHeightsTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onTransitionEnd',
	    value: function () {
	      function onTransitionEnd() {
	        this.props.onMonthTransitionEnd();
	      }
	
	      return onTransitionEnd;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'setMonthHeight',
	    value: function () {
	      function setMonthHeight(height, i) {
	        if (this.calendarMonthHeights[i]) {
	          if (i === 0) {
	            this.calendarMonthHeights = [height].concat(this.calendarMonthHeights.slice(0, -1));
	          } else if (i === this.calendarMonthHeights.length - 1) {
	            this.calendarMonthHeights = this.calendarMonthHeights.slice(1).concat(height);
	          }
	        } else {
	          this.calendarMonthHeights[i] = height;
	        }
	      }
	
	      return setMonthHeight;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this4 = this;
	
	        var _props2 = this.props,
	            enableOutsideDays = _props2.enableOutsideDays,
	            firstVisibleMonthIndex = _props2.firstVisibleMonthIndex,
	            isAnimating = _props2.isAnimating,
	            modifiers = _props2.modifiers,
	            numberOfMonths = _props2.numberOfMonths,
	            monthFormat = _props2.monthFormat,
	            orientation = _props2.orientation,
	            transformValue = _props2.transformValue,
	            daySize = _props2.daySize,
	            onDayMouseEnter = _props2.onDayMouseEnter,
	            onDayMouseLeave = _props2.onDayMouseLeave,
	            onDayClick = _props2.onDayClick,
	            renderMonth = _props2.renderMonth,
	            renderDay = _props2.renderDay,
	            onMonthTransitionEnd = _props2.onMonthTransitionEnd,
	            firstDayOfWeek = _props2.firstDayOfWeek,
	            focusedDate = _props2.focusedDate,
	            isFocused = _props2.isFocused,
	            isRTL = _props2.isRTL,
	            styles = _props2.styles,
	            phrases = _props2.phrases;
	        var months = this.state.months;
	
	        var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
	        var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	
	        var calendarMonthWidth = (0, _getCalendarMonthWidth2['default'])(daySize);
	
	        var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && {
	            transition: 'transform 0.2s ease-in-out'
	          }, (0, _object2['default'])({}, (0, _getTransformStyles2['default'])(transformValue), {
	            width: width
	          })), {
	            ref: this.setContainerRef,
	            onTransitionEnd: onMonthTransitionEnd
	          }),
	          months.map(function (month, i) {
	            var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
	            var hideForAnimation = i === 0 && !isVisible;
	            var showForAnimation = i === 0 && isAnimating && isVisible;
	            var monthString = (0, _toISOMonthString2['default'])(month);
	            return _react2['default'].createElement(
	              'div',
	              _extends({
	                key: monthString
	              }, (0, _reactWithStyles.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
	                position: 'absolute',
	                left: -calendarMonthWidth
	              }, showForAnimation && !isVertical && isRTL && {
	                position: 'absolute',
	                right: 0
	              }, showForAnimation && isVertical && {
	                position: 'absolute',
	                top: -_this4.calendarMonthHeights[0]
	              })),
	              _react2['default'].createElement(_CalendarMonth2['default'], {
	                month: month,
	                isVisible: isVisible,
	                enableOutsideDays: enableOutsideDays,
	                modifiers: modifiers[monthString],
	                monthFormat: monthFormat,
	                orientation: orientation,
	                onDayMouseEnter: onDayMouseEnter,
	                onDayMouseLeave: onDayMouseLeave,
	                onDayClick: onDayClick,
	                renderMonth: renderMonth,
	                renderDay: renderDay,
	                firstDayOfWeek: firstDayOfWeek,
	                daySize: daySize,
	                focusedDate: isVisible ? focusedDate : null,
	                isFocused: isFocused,
	                phrases: phrases,
	                setMonthHeight: function () {
	                  function setMonthHeight(height) {
	                    _this4.setMonthHeight(height, i);
	                  }
	
	                  return setMonthHeight;
	                }()
	              })
	            );
	          })
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonthGrid;
	}(_react2['default'].Component);
	
	CalendarMonthGrid.propTypes = propTypes;
	CalendarMonthGrid.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    CalendarMonthGrid: {
	      background: color.background,
	      textAlign: 'left',
	      zIndex: zIndex
	    },
	
	    CalendarMonthGrid__animating: {
	      zIndex: zIndex + 1
	    },
	
	    CalendarMonthGrid__horizontal: {
	      position: 'absolute',
	      left: 9
	    },
	
	    CalendarMonthGrid__vertical: {
	      margin: '0 auto'
	    },
	
	    CalendarMonthGrid__vertical_scrollable: {
	      margin: '0 auto',
	      overflowY: 'scroll'
	    },
	
	    CalendarMonthGrid_month__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      minHeight: '100%'
	    },
	
	    CalendarMonthGrid_month__hideForAnimation: {
	      position: 'absolute',
	      zIndex: zIndex - 1,
	      opacity: 0,
	      pointerEvents: 'none'
	    }
	  };
	})(CalendarMonthGrid);

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _throttle = __webpack_require__(464);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isTouchDevice = __webpack_require__(188);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _OpenDirectionShape = __webpack_require__(192);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string, // also used as label
	  displayValue: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	  focused: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	
	  onChange: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDownShiftTab: _propTypes2['default'].func,
	  onKeyDownTab: _propTypes2['default'].func,
	
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool // describes actual DOM focus
	}));
	
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  disabled: false,
	  required: false,
	  readOnly: null,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  // accessibility
	  isFocused: false
	};
	
	var DateInput = function (_React$Component) {
	  _inherits(DateInput, _React$Component);
	
	  function DateInput(props) {
	    _classCallCheck(this, DateInput);
	
	    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
	
	    _this.state = {
	      dateString: '',
	      isTouchDevice: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.setInputRef = _this.setInputRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (!this.props.displayValue && nextProps.displayValue) {
	          this.setState({
	            dateString: ''
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            focused = _props.focused,
	            isFocused = _props.isFocused;
	
	        if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;
	
	        if (focused && isFocused) {
	          this.inputRef.focus();
	        } else {
	          this.inputRef.blur();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onChange',
	    value: function () {
	      function onChange(e) {
	        var _props2 = this.props,
	            onChange = _props2.onChange,
	            onKeyDownQuestionMark = _props2.onKeyDownQuestionMark;
	
	        var dateString = e.target.value;
	
	        // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
	        // special case the `?` key so that it always triggers the appropriate callback, instead of
	        // modifying the input value
	        if (dateString[dateString.length - 1] === '?') {
	          onKeyDownQuestionMark(e);
	        } else {
	          this.setState({ dateString: dateString });
	          onChange(dateString);
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	
	        var _props3 = this.props,
	            onKeyDownShiftTab = _props3.onKeyDownShiftTab,
	            onKeyDownTab = _props3.onKeyDownTab,
	            onKeyDownArrowDown = _props3.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _props3.onKeyDownQuestionMark;
	        var key = e.key;
	
	        if (key === 'Tab') {
	          if (e.shiftKey) {
	            onKeyDownShiftTab(e);
	          } else {
	            onKeyDownTab(e);
	          }
	        } else if (key === 'ArrowDown') {
	          onKeyDownArrowDown(e);
	        } else if (key === '?') {
	          e.preventDefault();
	          onKeyDownQuestionMark(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'setInputRef',
	    value: function () {
	      function setInputRef(ref) {
	        this.inputRef = ref;
	      }
	
	      return setInputRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _state = this.state,
	            dateString = _state.dateString,
	            isTouch = _state.isTouchDevice;
	        var _props4 = this.props,
	            id = _props4.id,
	            placeholder = _props4.placeholder,
	            displayValue = _props4.displayValue,
	            screenReaderMessage = _props4.screenReaderMessage,
	            focused = _props4.focused,
	            showCaret = _props4.showCaret,
	            onFocus = _props4.onFocus,
	            disabled = _props4.disabled,
	            required = _props4.required,
	            readOnly = _props4.readOnly,
	            openDirection = _props4.openDirection,
	            styles = _props4.styles;
	
	
	        var value = displayValue || dateString || '';
	        var screenReaderMessageId = 'DateInput__screen-reader-message-' + String(id);
	
	        var withCaret = showCaret && focused;
	
	        return _react2['default'].createElement(
	          'div',
	          (0, _reactWithStyles.css)(styles.DateInput, withCaret && styles.DateInput__withCaret, disabled && styles.DateInput__disabled, withCaret && openDirection === _constants.OPEN_DOWN && styles.DateInput__openDown, withCaret && openDirection === _constants.OPEN_UP && styles.DateInput__openUp),
	          _react2['default'].createElement('input', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_input, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
	            'aria-label': placeholder,
	            type: 'text',
	            id: id,
	            name: id,
	            ref: this.setInputRef,
	            value: value,
	            onChange: this.onChange,
	            onKeyDown: (0, _throttle2['default'])(this.onKeyDown, 300),
	            onFocus: onFocus,
	            placeholder: placeholder,
	            autoComplete: 'off',
	            disabled: disabled,
	            readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
	            required: required,
	            'aria-describedby': screenReaderMessage && screenReaderMessageId
	          })),
	          screenReaderMessage && _react2['default'].createElement(
	            'p',
	            _extends({}, (0, _reactWithStyles.css)(styles.DateInput_screenReaderMessage), { id: screenReaderMessageId }),
	            screenReaderMessage
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateInput;
	}(_react2['default'].Component);
	
	DateInput.propTypes = propTypes;
	DateInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      border = _ref$reactDates.border,
	      color = _ref$reactDates.color,
	      sizing = _ref$reactDates.sizing,
	      spacing = _ref$reactDates.spacing,
	      font = _ref$reactDates.font,
	      zIndex = _ref$reactDates.zIndex;
	
	  var inputHeight = parseInt(font.input.lineHeight, 10) + 2 * spacing.inputPadding + 2 * spacing.displayTextPaddingVertical;
	
	  return {
	    DateInput: {
	      fontWeight: 200,
	      fontSize: font.input.size,
	      lineHeight: font.input.lineHeight,
	      color: color.placeholderText,
	      margin: 0,
	      padding: spacing.inputPadding,
	
	      background: color.background,
	      position: 'relative',
	      display: 'inline-block',
	      width: sizing.inputWidth,
	      verticalAlign: 'middle'
	    },
	
	    DateInput__withCaret: {
	      ':before': {
	        content: '""',
	        display: 'inline-block',
	        position: 'absolute',
	        bottom: 'auto',
	        border: sizing.tooltipArrowWidth / 2 + 'px solid transparent',
	        left: 22,
	        zIndex: zIndex + 2
	      },
	
	      ':after': {
	        content: '""',
	        display: 'inline-block',
	        position: 'absolute',
	        bottom: 'auto',
	        border: sizing.tooltipArrowWidth / 2 + 'px solid transparent',
	        left: 22,
	        zIndex: zIndex + 2
	      }
	    },
	
	    DateInput__openUp: {
	      ':before': {
	        borderBottom: 0,
	        top: inputHeight - spacing.inputMarginBottom,
	        borderTopColor: 'rgba(0, 0, 0, 0.1)'
	      },
	
	      ':after': {
	        borderBottom: 0,
	        top: inputHeight - spacing.inputMarginBottom - 1,
	        borderTopColor: color.background
	      }
	    },
	
	    DateInput__openDown: {
	      ':before': {
	        borderTop: 0,
	        top: spacing.inputMarginBottom - sizing.tooltipArrowWidth / 2,
	        borderBottomColor: 'rgba(0, 0, 0, 0.1)'
	      },
	
	      ':after': {
	        borderTop: 0,
	        top: spacing.inputMarginBottom - sizing.tooltipArrowWidth / 2 + 1,
	        borderBottomColor: color.background
	      }
	    },
	
	    DateInput__disabled: {
	      background: color.disabled,
	      color: color.textDisabled
	    },
	
	    DateInput_input: {
	      fontWeight: 200,
	      fontSize: font.input.size,
	      color: color.text,
	      width: '100%',
	      padding: String(spacing.displayTextPaddingVertical) + 'px ' + String(spacing.displayTextPaddingHorizontal) + 'px',
	      border: border.input.border,
	      borderTop: border.input.borderTop,
	      borderRight: border.input.borderRight,
	      borderBottom: border.input.borderBottom,
	      borderLeft: border.input.borderLeft
	    },
	
	    DateInput_input__readOnly: {
	      userSelect: 'none'
	    },
	
	    DateInput_input__focused: {
	      outline: border.input.outlineFocused,
	      background: color.backgroundFocused,
	      border: border.input.borderFocused,
	      borderTop: border.input.borderTopFocused,
	      borderRight: border.input.borderRightFocused,
	      borderBottom: border.input.borderBottomFocused,
	      borderLeft: border.input.borderLeftFocused
	    },
	
	    DateInput_input__disabled: {
	      background: color.disabled,
	      fontStyle: font.input.styleDisabled
	    },
	
	    DateInput_screenReaderMessage: {
	      border: 0,
	      clip: 'rect(0, 0, 0, 0)',
	      height: 1,
	      margin: -1,
	      overflow: 'hidden',
	      padding: 0,
	      position: 'absolute',
	      width: 1
	    }
	  };
	})(DateInput);

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _OpenDirectionShape = __webpack_require__(192);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DateInput = __webpack_require__(1225);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _IconPositionShape = __webpack_require__(243);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _RightArrow = __webpack_require__(1231);
	
	var _RightArrow2 = _interopRequireDefault(_RightArrow);
	
	var _LeftArrow = __webpack_require__(1230);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _CloseButton = __webpack_require__(242);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _CalendarIcon = __webpack_require__(1222);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  startDateId: _propTypes2['default'].string,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	
	  endDateId: _propTypes2['default'].string,
	  endDatePlaceholderText: _propTypes2['default'].string,
	
	  onStartDateFocus: _propTypes2['default'].func,
	  onEndDateFocus: _propTypes2['default'].func,
	  onStartDateChange: _propTypes2['default'].func,
	  onEndDateChange: _propTypes2['default'].func,
	  onStartDateShiftTab: _propTypes2['default'].func,
	  onEndDateTab: _propTypes2['default'].func,
	  onClearDates: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  startDate: _propTypes2['default'].string,
	  endDate: _propTypes2['default'].string,
	
	  isStartDateFocused: _propTypes2['default'].bool,
	  isEndDateFocused: _propTypes2['default'].bool,
	  showClearDates: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  startDateId: _constants.START_DATE,
	  endDateId: _constants.END_DATE,
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  screenReaderMessage: '',
	  onStartDateFocus: function () {
	    function onStartDateFocus() {}
	
	    return onStartDateFocus;
	  }(),
	  onEndDateFocus: function () {
	    function onEndDateFocus() {}
	
	    return onEndDateFocus;
	  }(),
	  onStartDateChange: function () {
	    function onStartDateChange() {}
	
	    return onStartDateChange;
	  }(),
	  onEndDateChange: function () {
	    function onEndDateChange() {}
	
	    return onEndDateChange;
	  }(),
	  onStartDateShiftTab: function () {
	    function onStartDateShiftTab() {}
	
	    return onStartDateShiftTab;
	  }(),
	  onEndDateTab: function () {
	    function onEndDateTab() {}
	
	    return onEndDateTab;
	  }(),
	  onClearDates: function () {
	    function onClearDates() {}
	
	    return onClearDates;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  startDate: '',
	  endDate: '',
	
	  isStartDateFocused: false,
	  isEndDateFocused: false,
	  showClearDates: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	
	  // accessibility
	  isFocused: false,
	
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	
	  isRTL: false
	};
	
	function DateRangePickerInput(_ref) {
	  var startDate = _ref.startDate,
	      startDateId = _ref.startDateId,
	      startDatePlaceholderText = _ref.startDatePlaceholderText,
	      screenReaderMessage = _ref.screenReaderMessage,
	      isStartDateFocused = _ref.isStartDateFocused,
	      onStartDateChange = _ref.onStartDateChange,
	      onStartDateFocus = _ref.onStartDateFocus,
	      onStartDateShiftTab = _ref.onStartDateShiftTab,
	      endDate = _ref.endDate,
	      endDateId = _ref.endDateId,
	      endDatePlaceholderText = _ref.endDatePlaceholderText,
	      isEndDateFocused = _ref.isEndDateFocused,
	      onEndDateChange = _ref.onEndDateChange,
	      onEndDateFocus = _ref.onEndDateFocus,
	      onEndDateTab = _ref.onEndDateTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      onClearDates = _ref.onClearDates,
	      showClearDates = _ref.showClearDates,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      openDirection = _ref.openDirection,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      customInputIcon = _ref.customInputIcon,
	      customArrowIcon = _ref.customArrowIcon,
	      customCloseIcon = _ref.customCloseIcon,
	      isFocused = _ref.isFocused,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react2['default'].createElement(_CalendarIcon2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon_svg));
	  var arrowIcon = customArrowIcon || (isRTL ? _react2['default'].createElement(_LeftArrow2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg)) : _react2['default'].createElement(_RightArrow2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg)));
	  var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates_svg));
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement(
	    'button',
	    _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon), {
	      type: 'button',
	      disabled: disabled,
	      'aria-label': phrases.focusStartDate,
	      onClick: onKeyDownArrowDown
	    }),
	    calendarIcon
	  );
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl),
	    inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon,
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: startDateId,
	      placeholder: startDatePlaceholderText,
	      displayValue: startDate,
	      screenReaderMessage: screenReaderText,
	      focused: isStartDateFocused,
	      isFocused: isFocused,
	      disabled: disabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      openDirection: openDirection,
	      onChange: onStartDateChange,
	      onFocus: onStartDateFocus,
	      onKeyDownShiftTab: onStartDateShiftTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark
	    }),
	    _react2['default'].createElement(
	      'div',
	      _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow), {
	        'aria-hidden': 'true',
	        role: 'presentation'
	      }),
	      arrowIcon
	    ),
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: endDateId,
	      placeholder: endDatePlaceholderText,
	      displayValue: endDate,
	      screenReaderMessage: screenReaderText,
	      focused: isEndDateFocused,
	      isFocused: isFocused,
	      disabled: disabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      openDirection: openDirection,
	      onChange: onEndDateChange,
	      onFocus: onEndDateFocus,
	      onKeyDownTab: onEndDateTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark
	    }),
	    showClearDates && _react2['default'].createElement(
	      'button',
	      _extends({
	        type: 'button',
	        'aria-label': phrases.clearDates
	      }, (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
	        onClick: onClearDates,
	        disabled: disabled
	      }),
	      closeIcon
	    ),
	    inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon
	  );
	}
	
	DateRangePickerInput.propTypes = propTypes;
	DateRangePickerInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      sizing = _ref2$reactDates.sizing;
	  return {
	    DateRangePickerInput: {
	      backgroundColor: color.background,
	      border: '1px solid ' + String(color.core.grayLighter),
	      display: 'inline-block'
	    },
	
	    DateRangePickerInput__disabled: {
	      background: color.disabled
	    },
	
	    DateRangePickerInput__rtl: {
	      direction: 'rtl'
	    },
	
	    DateRangePickerInput_arrow: {
	      display: 'inline-block',
	      verticalAlign: 'middle'
	    },
	
	    DateRangePickerInput_arrow_svg: {
	      verticalAlign: 'middle',
	      fill: color.text,
	      height: sizing.arrowWidth,
	      width: sizing.arrowWidth
	    },
	
	    DateRangePickerInput_clearDates: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 10px 0 5px',
	
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	
	    DateRangePickerInput_clearDates__hide: {
	      visibility: 'hidden'
	    },
	
	    DateRangePickerInput_clearDates_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	
	    DateRangePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px'
	    },
	
	    DateRangePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	})(DateRangePickerInput);

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _OpenDirectionShape = __webpack_require__(192);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _DateRangePickerInput = __webpack_require__(1226);
	
	var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);
	
	var _IconPositionShape = __webpack_require__(243);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _toMomentObject = __webpack_require__(195);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _toLocalizedDateString = __webpack_require__(492);
	
	var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
	var _isInclusivelyAfterDay = __webpack_require__(246);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _isBeforeDay = __webpack_require__(245);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  startDateId: _propTypes2['default'].string,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  isStartDateFocused: _propTypes2['default'].bool,
	
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  endDateId: _propTypes2['default'].string,
	  endDatePlaceholderText: _propTypes2['default'].string,
	  isEndDateFocused: _propTypes2['default'].bool,
	
	  screenReaderMessage: _propTypes2['default'].string,
	  showClearDates: _propTypes2['default'].bool,
	  showCaret: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDates: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  minimumNights: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideRange: _propTypes2['default'].func,
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	  onDatesChange: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool,
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  startDate: null,
	  startDateId: _constants.START_DATE,
	  startDatePlaceholderText: 'Start Date',
	  isStartDateFocused: false,
	
	  endDate: null,
	  endDateId: _constants.END_DATE,
	  endDatePlaceholderText: 'End Date',
	  isEndDateFocused: false,
	
	  screenReaderMessage: '',
	  showClearDates: false,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  withFullScreenPortal: false,
	  minimumNights: 1,
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	
	  // accessibility
	  isFocused: false,
	
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	
	  isRTL: false
	};
	
	var DateRangePickerInputController = function (_React$Component) {
	  _inherits(DateRangePickerInputController, _React$Component);
	
	  function DateRangePickerInputController(props) {
	    _classCallCheck(this, DateRangePickerInputController);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePickerInputController.__proto__ || Object.getPrototypeOf(DateRangePickerInputController)).call(this, props));
	
	    _this.onClearFocus = _this.onClearFocus.bind(_this);
	    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
	    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
	    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
	    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
	    _this.clearDates = _this.clearDates.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePickerInputController, [{
	    key: 'onClearFocus',
	    value: function () {
	      function onClearFocus() {
	        var _props = this.props,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose,
	            startDate = _props.startDate,
	            endDate = _props.endDate;
	
	
	        onFocusChange(null);
	        onClose({ startDate: startDate, endDate: endDate });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: 'onEndDateChange',
	    value: function () {
	      function onEndDateChange(endDateString) {
	        var _props2 = this.props,
	            startDate = _props2.startDate,
	            isOutsideRange = _props2.isOutsideRange,
	            minimumNights = _props2.minimumNights,
	            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
	            onDatesChange = _props2.onDatesChange;
	
	
	        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());
	
	        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days')));
	        if (isEndDateValid) {
	          onDatesChange({ startDate: startDate, endDate: endDate });
	          if (!keepOpenOnDateSelect) this.onClearFocus();
	        } else {
	          onDatesChange({
	            startDate: startDate,
	            endDate: null
	          });
	        }
	      }
	
	      return onEndDateChange;
	    }()
	  }, {
	    key: 'onEndDateFocus',
	    value: function () {
	      function onEndDateFocus() {
	        var _props3 = this.props,
	            startDate = _props3.startDate,
	            onFocusChange = _props3.onFocusChange,
	            withFullScreenPortal = _props3.withFullScreenPortal,
	            disabled = _props3.disabled;
	
	
	        if (!startDate && withFullScreenPortal && !disabled) {
	          // When the datepicker is full screen, we never want to focus the end date first
	          // because there's no indication that that is the case once the datepicker is open and it
	          // might confuse the user
	          onFocusChange(_constants.START_DATE);
	        } else if (!disabled) {
	          onFocusChange(_constants.END_DATE);
	        }
	      }
	
	      return onEndDateFocus;
	    }()
	  }, {
	    key: 'onStartDateChange',
	    value: function () {
	      function onStartDateChange(startDateString) {
	        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());
	
	        var endDate = this.props.endDate;
	        var _props4 = this.props,
	            isOutsideRange = _props4.isOutsideRange,
	            minimumNights = _props4.minimumNights,
	            onDatesChange = _props4.onDatesChange,
	            onFocusChange = _props4.onFocusChange;
	
	        var isStartDateValid = startDate && !isOutsideRange(startDate);
	        if (isStartDateValid) {
	          if (startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days'))) {
	            endDate = null;
	          }
	
	          onDatesChange({ startDate: startDate, endDate: endDate });
	          onFocusChange(_constants.END_DATE);
	        } else {
	          onDatesChange({
	            startDate: null,
	            endDate: endDate
	          });
	        }
	      }
	
	      return onStartDateChange;
	    }()
	  }, {
	    key: 'onStartDateFocus',
	    value: function () {
	      function onStartDateFocus() {
	        if (!this.props.disabled) {
	          this.props.onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return onStartDateFocus;
	    }()
	  }, {
	    key: 'getDisplayFormat',
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: 'getDateString',
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	        return (0, _toLocalizedDateString2['default'])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: 'clearDates',
	    value: function () {
	      function clearDates() {
	        var _props5 = this.props,
	            onDatesChange = _props5.onDatesChange,
	            reopenPickerOnClearDates = _props5.reopenPickerOnClearDates,
	            onFocusChange = _props5.onFocusChange;
	
	        onDatesChange({ startDate: null, endDate: null });
	        if (reopenPickerOnClearDates) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return clearDates;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props6 = this.props,
	            startDate = _props6.startDate,
	            startDateId = _props6.startDateId,
	            startDatePlaceholderText = _props6.startDatePlaceholderText,
	            isStartDateFocused = _props6.isStartDateFocused,
	            endDate = _props6.endDate,
	            endDateId = _props6.endDateId,
	            endDatePlaceholderText = _props6.endDatePlaceholderText,
	            isEndDateFocused = _props6.isEndDateFocused,
	            screenReaderMessage = _props6.screenReaderMessage,
	            showClearDates = _props6.showClearDates,
	            showCaret = _props6.showCaret,
	            showDefaultInputIcon = _props6.showDefaultInputIcon,
	            inputIconPosition = _props6.inputIconPosition,
	            customInputIcon = _props6.customInputIcon,
	            customArrowIcon = _props6.customArrowIcon,
	            customCloseIcon = _props6.customCloseIcon,
	            disabled = _props6.disabled,
	            required = _props6.required,
	            readOnly = _props6.readOnly,
	            openDirection = _props6.openDirection,
	            isFocused = _props6.isFocused,
	            phrases = _props6.phrases,
	            onKeyDownArrowDown = _props6.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _props6.onKeyDownQuestionMark,
	            isRTL = _props6.isRTL;
	
	
	        var startDateString = this.getDateString(startDate);
	        var endDateString = this.getDateString(endDate);
	
	        return _react2['default'].createElement(_DateRangePickerInput2['default'], {
	          startDate: startDateString,
	          startDateId: startDateId,
	          startDatePlaceholderText: startDatePlaceholderText,
	          isStartDateFocused: isStartDateFocused,
	          endDate: endDateString,
	          endDateId: endDateId,
	          endDatePlaceholderText: endDatePlaceholderText,
	          isEndDateFocused: isEndDateFocused,
	          isFocused: isFocused,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          showCaret: showCaret,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          customInputIcon: customInputIcon,
	          customArrowIcon: customArrowIcon,
	          customCloseIcon: customCloseIcon,
	          phrases: phrases,
	          onStartDateChange: this.onStartDateChange,
	          onStartDateFocus: this.onStartDateFocus,
	          onStartDateShiftTab: this.onClearFocus,
	          onEndDateChange: this.onEndDateChange,
	          onEndDateFocus: this.onEndDateFocus,
	          onEndDateTab: this.onClearFocus,
	          showClearDates: showClearDates,
	          onClearDates: this.clearDates,
	          screenReaderMessage: screenReaderMessage,
	          onKeyDownArrowDown: onKeyDownArrowDown,
	          onKeyDownQuestionMark: onKeyDownQuestionMark,
	          isRTL: isRTL
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePickerInputController;
	}(_react2['default'].Component);
	
	exports['default'] = DateRangePickerInputController;
	
	
	DateRangePickerInputController.propTypes = propTypes;
	DateRangePickerInputController.defaultProps = defaultProps;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _object3 = __webpack_require__(1137);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isTouchDevice = __webpack_require__(188);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _isInclusivelyAfterDay = __webpack_require__(246);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _isNextDay = __webpack_require__(1241);
	
	var _isNextDay2 = _interopRequireDefault(_isNextDay);
	
	var _isSameDay = __webpack_require__(194);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isAfterDay = __webpack_require__(244);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _isBeforeDay = __webpack_require__(245);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _getVisibleDays = __webpack_require__(1240);
	
	var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);
	
	var _isDayVisible = __webpack_require__(491);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _toISODateString = __webpack_require__(336);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _toISOMonthString = __webpack_require__(337);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _FocusedInputShape = __webpack_require__(1235);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _ScrollableOrientationShape = __webpack_require__(193);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(37);
	
	var _DayPicker = __webpack_require__(490);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  onDatesChange: _propTypes2['default'].func,
	
	  focusedInput: _FocusedInputShape2['default'],
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  minimumNights: _propTypes2['default'].number,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayBlocked: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // DayPicker props
	  renderMonth: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onOutsideClick: _propTypes2['default'].func,
	  renderDay: _propTypes2['default'].func,
	  renderCalendarInfo: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	
	  // accessibility
	  onBlur: _propTypes2['default'].func,
	  isFocused: _propTypes2['default'].bool,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  startDate: undefined, // TODO: use null
	  endDate: undefined, // TODO: use null
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	
	
	  focusedInput: null,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  keepOpenOnDateSelect: false,
	  minimumNights: 1,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	
	  // DayPicker props
	  renderMonth: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  daySize: _constants.DAY_SIZE,
	
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	
	  renderDay: null,
	  renderCalendarInfo: null,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  isFocused: false,
	  showKeyboardShortcuts: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	
	  isRTL: false
	};
	
	var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
	  if (focusedInput === _constants.START_DATE) {
	    return phrases.chooseAvailableStartDate;
	  } else if (focusedInput === _constants.END_DATE) {
	    return phrases.chooseAvailableEndDate;
	  }
	  return phrases.chooseAvailableDate;
	};
	
	var DayPickerRangeController = function (_React$Component) {
	  _inherits(DayPickerRangeController, _React$Component);
	
	  function DayPickerRangeController(props) {
	    _classCallCheck(this, DayPickerRangeController);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerRangeController.__proto__ || Object.getPrototypeOf(DayPickerRangeController)).call(this, props));
	
	    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
	    _this.today = (0, _moment2['default'])();
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      'selected-start': function () {
	        function selectedStart(day) {
	          return _this.isStartDate(day);
	        }
	
	        return selectedStart;
	      }(),
	      'selected-end': function () {
	        function selectedEnd(day) {
	          return _this.isEndDate(day);
	        }
	
	        return selectedEnd;
	      }(),
	      'blocked-minimum-nights': function () {
	        function blockedMinimumNights(day) {
	          return _this.doesNotMeetMinimumNights(day);
	        }
	
	        return blockedMinimumNights;
	      }(),
	      'selected-span': function () {
	        function selectedSpan(day) {
	          return _this.isInSelectedSpan(day);
	        }
	
	        return selectedSpan;
	      }(),
	      'last-in-range': function () {
	        function lastInRange(day) {
	          return _this.isLastInRange(day);
	        }
	
	        return lastInRange;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      'hovered-span': function () {
	        function hoveredSpan(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredSpan;
	      }(),
	      'after-hovered-start': function () {
	        function afterHoveredStart(day) {
	          return _this.isDayAfterHoveredStartDate(day);
	        }
	
	        return afterHoveredStart;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    // initialize phrases
	    // set the appropriate CalendarDay phrase based on focusedInput
	
	
	    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      phrases: (0, _object2['default'])({}, props.phrases, {
	        chooseAvailableDate: chooseAvailableDate
	      }),
	      visibleDays: visibleDays
	    };
	
	    _this.onDayClick = _this.onDayClick.bind(_this);
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_this);
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
	    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerRangeController, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var startDate = nextProps.startDate,
	            endDate = nextProps.endDate,
	            focusedInput = nextProps.focusedInput,
	            minimumNights = nextProps.minimumNights,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            phrases = nextProps.phrases,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	
	
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== this.props.isOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== this.props.isDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== this.props.isDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        var didStartDateChange = startDate !== this.props.startDate;
	        var didEndDateChange = endDate !== this.props.endDate;
	        var didFocusChange = focusedInput !== this.props.focusedInput;
	
	        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focusedInput && didFocusChange) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var modifiers = {};
	
	        if (didStartDateChange) {
	          modifiers = this.deleteModifier(modifiers, this.props.startDate, 'selected-start');
	          modifiers = this.addModifier(modifiers, startDate, 'selected-start');
	        }
	
	        if (didEndDateChange) {
	          modifiers = this.deleteModifier(modifiers, this.props.endDate, 'selected-end');
	          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
	        }
	
	        if (didStartDateChange || didEndDateChange) {
	          if (this.props.startDate && this.props.endDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, this.props.startDate, this.props.endDate.clone().add(1, 'day'), 'selected-span');
	          }
	
	          if (startDate && endDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
	
	            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
	          }
	        }
	
	        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
	          var startSpan = startDate.clone().add(1, 'day');
	          var endSpan = startDate.clone().add(minimumNights + 1, 'days');
	          modifiers = this.addModifierToRange(modifiers, startSpan, endSpan, 'after-hovered-start');
	        }
	
	        if (minimumNights > 0 || minimumNights !== this.props.minimumNights) {
	          if (didFocusChange || didStartDateChange) {
	            var _startSpan = this.props.startDate ? this.props.startDate : this.today;
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan, _startSpan.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
	          }
	
	          if (startDate && focusedInput === _constants.END_DATE) {
	            modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
	          }
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object4['default'])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment2['default'])(day);
	
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment2['default'])();
	        if (!(0, _isSameDay2['default'])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	
	        if (didFocusChange || phrases !== this.props.phrases) {
	          // set the appropriate CalendarDay phrase based on focusedInput
	          var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
	
	          this.setState({
	            phrases: (0, _object2['default'])({}, phrases, {
	              chooseAvailableDate: chooseAvailableDate
	            })
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var _props = this.props,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            minimumNights = _props.minimumNights,
	            onBlur = _props.onBlur;
	
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	
	        var _props2 = this.props,
	            focusedInput = _props2.focusedInput,
	            onFocusChange = _props2.onFocusChange,
	            onClose = _props2.onClose;
	        var _props3 = this.props,
	            startDate = _props3.startDate,
	            endDate = _props3.endDate;
	
	
	        if (focusedInput === _constants.START_DATE) {
	          onFocusChange(_constants.END_DATE);
	
	          startDate = day;
	
	          if ((0, _isInclusivelyAfterDay2['default'])(day, endDate)) {
	            endDate = null;
	          }
	        } else if (focusedInput === _constants.END_DATE) {
	          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');
	
	          if (!startDate) {
	            endDate = day;
	            onFocusChange(_constants.START_DATE);
	          } else if ((0, _isInclusivelyAfterDay2['default'])(day, firstAllowedEndDate)) {
	            endDate = day;
	            if (!keepOpenOnDateSelect) {
	              onFocusChange(null);
	              onClose({ startDate: startDate, endDate: endDate });
	            }
	          } else {
	            startDate = day;
	            endDate = null;
	          }
	        }
	
	        this.props.onDatesChange({ startDate: startDate, endDate: endDate });
	        onBlur();
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _props4 = this.props,
	            startDate = _props4.startDate,
	            endDate = _props4.endDate,
	            focusedInput = _props4.focusedInput,
	            minimumNights = _props4.minimumNights;
	        var _state = this.state,
	            hoverDate = _state.hoverDate,
	            visibleDays = _state.visibleDays;
	
	
	        if (focusedInput) {
	          var modifiers = {};
	          modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	          modifiers = this.addModifier(modifiers, day, 'hovered');
	
	          if (startDate && !endDate && focusedInput === _constants.END_DATE) {
	            if ((0, _isAfterDay2['default'])(hoverDate, startDate)) {
	              var endSpan = hoverDate.clone().add(1, 'day');
	              modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	            }
	
	            if (!this.isBlocked(day) && (0, _isAfterDay2['default'])(day, startDate)) {
	              var _endSpan = day.clone().add(1, 'day');
	              modifiers = this.addModifierToRange(modifiers, startDate, _endSpan, 'hovered-span');
	            }
	          }
	
	          if (!startDate && endDate && focusedInput === _constants.START_DATE) {
	            if ((0, _isBeforeDay2['default'])(hoverDate, endDate)) {
	              modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	            }
	
	            if (!this.isBlocked(day) && (0, _isBeforeDay2['default'])(day, endDate)) {
	              modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
	            }
	          }
	
	          if (startDate) {
	            var startSpan = startDate.clone().add(1, 'day');
	            var _endSpan2 = startDate.clone().add(minimumNights + 1, 'days');
	            modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan2, 'after-hovered-start');
	
	            if ((0, _isSameDay2['default'])(day, startDate)) {
	              var newStartSpan = startDate.clone().add(1, 'day');
	              var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
	              modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
	            }
	          }
	
	          this.setState({
	            hoverDate: day,
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day) {
	        var _props5 = this.props,
	            startDate = _props5.startDate,
	            endDate = _props5.endDate,
	            minimumNights = _props5.minimumNights;
	        var _state2 = this.state,
	            hoverDate = _state2.hoverDate,
	            visibleDays = _state2.visibleDays;
	
	        if (this.isTouchDevice || !hoverDate) return;
	
	        var modifiers = {};
	        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	
	        if (startDate && !endDate && (0, _isAfterDay2['default'])(hoverDate, startDate)) {
	          var endSpan = hoverDate.clone().add(1, 'day');
	          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	        }
	
	        if (!startDate && endDate && (0, _isAfterDay2['default'])(endDate, hoverDate)) {
	          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	        }
	
	        if (startDate && (0, _isSameDay2['default'])(day, startDate)) {
	          var startSpan = startDate.clone().add(1, 'day');
	          var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');
	          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');
	        }
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick() {
	        var _props6 = this.props,
	            onPrevMonthClick = _props6.onPrevMonthClick,
	            numberOfMonths = _props6.numberOfMonths,
	            enableOutsideDays = _props6.enableOutsideDays;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            visibleDays = _state3.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var prevMonth = currentMonth.clone().subtract(2, 'months');
	        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays, true);
	
	        var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        });
	
	        onPrevMonthClick(newCurrentMonth.clone());
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick() {
	        var _props7 = this.props,
	            onNextMonthClick = _props7.onNextMonthClick,
	            numberOfMonths = _props7.numberOfMonths,
	            enableOutsideDays = _props7.enableOutsideDays;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            visibleDays = _state4.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays, true);
	
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        });
	
	        onNextMonthClick(newCurrentMonth.clone());
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'onMultiplyScrollableMonths',
	    value: function () {
	      function onMultiplyScrollableMonths() {
	        var _props8 = this.props,
	            numberOfMonths = _props8.numberOfMonths,
	            enableOutsideDays = _props8.enableOutsideDays;
	        var _state5 = this.state,
	            currentMonth = _state5.currentMonth,
	            visibleDays = _state5.visibleDays;
	
	
	        var numberOfVisibleMonths = Object.keys(visibleDays).length;
	        var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
	        var newVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, numberOfMonths, enableOutsideDays, true);
	
	        this.setState({
	          visibleDays: (0, _object2['default'])({}, visibleDays, this.getModifiers(newVisibleDays))
	        });
	      }
	
	      return onMultiplyScrollableMonths;
	    }()
	  }, {
	    key: 'getFirstFocusableDay',
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _props9 = this.props,
	            startDate = _props9.startDate,
	            endDate = _props9.endDate,
	            focusedInput = _props9.focusedInput,
	            minimumNights = _props9.minimumNights,
	            numberOfMonths = _props9.numberOfMonths;
	
	
	        var focusedDate = newMonth.clone().startOf('month');
	        if (focusedInput === _constants.START_DATE && startDate) {
	          focusedDate = startDate.clone();
	        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
	          focusedDate = startDate.clone().add(minimumNights, 'days');
	        } else if (focusedInput === _constants.END_DATE && endDate) {
	          focusedDate = endDate.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day);
	          });
	
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: 'getModifiers',
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: 'getModifiersForDay',
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: 'getStateForNewMonth',
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            orientation = nextProps.orientation,
	            startDate = nextProps.startDate;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
	          return startDate;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
	        return { currentMonth: currentMonth, visibleDays: visibleDays };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: 'setDayPickerRef',
	    value: function () {
	      function setDayPickerRef(ref) {
	        this.dayPicker = ref;
	      }
	
	      return setDayPickerRef;
	    }()
	  }, {
	    key: 'addModifier',
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _props10 = this.props,
	            numberOfVisibleMonths = _props10.numberOfMonths,
	            enableOutsideDays = _props10.enableOutsideDays,
	            orientation = _props10.orientation;
	        var _state6 = this.state,
	            firstVisibleMonth = _state6.currentMonth,
	            visibleDays = _state6.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: 'addModifierToRange',
	    value: function () {
	      function addModifierToRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	
	        var spanStart = start.clone();
	        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
	          days = this.addModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return addModifierToRange;
	    }()
	  }, {
	    key: 'deleteModifier',
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _props11 = this.props,
	            numberOfVisibleMonths = _props11.numberOfMonths,
	            enableOutsideDays = _props11.enableOutsideDays,
	            orientation = _props11.orientation;
	        var _state7 = this.state,
	            firstVisibleMonth = _state7.currentMonth,
	            visibleDays = _state7.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers['delete'](modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers['delete'](modifier);
	          updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: 'deleteModifierFromRange',
	    value: function () {
	      function deleteModifierFromRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	
	        var spanStart = start.clone();
	        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
	          days = this.deleteModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return deleteModifierFromRange;
	    }()
	  }, {
	    key: 'doesNotMeetMinimumNights',
	    value: function () {
	      function doesNotMeetMinimumNights(day) {
	        var _props12 = this.props,
	            startDate = _props12.startDate,
	            isOutsideRange = _props12.isOutsideRange,
	            focusedInput = _props12.focusedInput,
	            minimumNights = _props12.minimumNights;
	
	        if (focusedInput !== _constants.END_DATE) return false;
	
	        if (startDate) {
	          var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
	          return dayDiff < minimumNights && dayDiff >= 0;
	        }
	        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
	      }
	
	      return doesNotMeetMinimumNights;
	    }()
	  }, {
	    key: 'isDayAfterHoveredStartDate',
	    value: function () {
	      function isDayAfterHoveredStartDate(day) {
	        var _props13 = this.props,
	            startDate = _props13.startDate,
	            endDate = _props13.endDate,
	            minimumNights = _props13.minimumNights;
	
	        var _ref = this.state || {},
	            hoverDate = _ref.hoverDate;
	
	        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay2['default'])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay2['default'])(hoverDate, startDate);
	      }
	
	      return isDayAfterHoveredStartDate;
	    }()
	  }, {
	    key: 'isEndDate',
	    value: function () {
	      function isEndDate(day) {
	        return (0, _isSameDay2['default'])(day, this.props.endDate);
	      }
	
	      return isEndDate;
	    }()
	  }, {
	    key: 'isHovered',
	    value: function () {
	      function isHovered(day) {
	        var _ref2 = this.state || {},
	            hoverDate = _ref2.hoverDate;
	
	        var focusedInput = this.props.focusedInput;
	
	        return !!focusedInput && (0, _isSameDay2['default'])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: 'isInHoveredSpan',
	    value: function () {
	      function isInHoveredSpan(day) {
	        var _props14 = this.props,
	            startDate = _props14.startDate,
	            endDate = _props14.endDate;
	
	        var _ref3 = this.state || {},
	            hoverDate = _ref3.hoverDate;
	
	        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
	        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));
	
	        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
	
	        return (isForwardRange || isBackwardRange) && isValidDayHovered;
	      }
	
	      return isInHoveredSpan;
	    }()
	  }, {
	    key: 'isInSelectedSpan',
	    value: function () {
	      function isInSelectedSpan(day) {
	        var _props15 = this.props,
	            startDate = _props15.startDate,
	            endDate = _props15.endDate;
	
	        return day.isBetween(startDate, endDate);
	      }
	
	      return isInSelectedSpan;
	    }()
	  }, {
	    key: 'isLastInRange',
	    value: function () {
	      function isLastInRange(day) {
	        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
	      }
	
	      return isLastInRange;
	    }()
	  }, {
	    key: 'isStartDate',
	    value: function () {
	      function isStartDate(day) {
	        return (0, _isSameDay2['default'])(day, this.props.startDate);
	      }
	
	      return isStartDate;
	    }()
	  }, {
	    key: 'isBlocked',
	    value: function () {
	      function isBlocked(day) {
	        var _props16 = this.props,
	            isDayBlocked = _props16.isDayBlocked,
	            isOutsideRange = _props16.isOutsideRange;
	
	        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: 'isToday',
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay2['default'])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props17 = this.props,
	            numberOfMonths = _props17.numberOfMonths,
	            orientation = _props17.orientation,
	            monthFormat = _props17.monthFormat,
	            renderMonth = _props17.renderMonth,
	            navPrev = _props17.navPrev,
	            navNext = _props17.navNext,
	            onOutsideClick = _props17.onOutsideClick,
	            withPortal = _props17.withPortal,
	            enableOutsideDays = _props17.enableOutsideDays,
	            firstDayOfWeek = _props17.firstDayOfWeek,
	            hideKeyboardShortcutsPanel = _props17.hideKeyboardShortcutsPanel,
	            daySize = _props17.daySize,
	            focusedInput = _props17.focusedInput,
	            renderDay = _props17.renderDay,
	            renderCalendarInfo = _props17.renderCalendarInfo,
	            onBlur = _props17.onBlur,
	            isFocused = _props17.isFocused,
	            showKeyboardShortcuts = _props17.showKeyboardShortcuts,
	            isRTL = _props17.isRTL,
	            weekDayFormat = _props17.weekDayFormat,
	            verticalHeight = _props17.verticalHeight;
	        var _state8 = this.state,
	            currentMonth = _state8.currentMonth,
	            phrases = _state8.phrases,
	            visibleDays = _state8.visibleDays;
	
	
	        return _react2['default'].createElement(_DayPicker2['default'], {
	          ref: this.setDayPickerRef,
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
	          monthFormat: monthFormat,
	          renderMonth: renderMonth,
	          withPortal: withPortal,
	          hidden: !focusedInput,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          daySize: daySize,
	          onOutsideClick: onOutsideClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          renderDay: renderDay,
	          renderCalendarInfo: renderCalendarInfo,
	          firstDayOfWeek: firstDayOfWeek,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          phrases: phrases,
	          isRTL: isRTL,
	          weekDayFormat: weekDayFormat,
	          verticalHeight: verticalHeight
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerRangeController;
	}(_react2['default'].Component);
	
	exports['default'] = DayPickerRangeController;
	
	
	DayPickerRangeController.propTypes = propTypes;
	DayPickerRangeController.defaultProps = defaultProps;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _object3 = __webpack_require__(1137);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isTouchDevice = __webpack_require__(188);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _isSameDay = __webpack_require__(194);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isAfterDay = __webpack_require__(244);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _getVisibleDays = __webpack_require__(1240);
	
	var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);
	
	var _isDayVisible = __webpack_require__(491);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _toISODateString = __webpack_require__(336);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _toISOMonthString = __webpack_require__(337);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _ScrollableOrientationShape = __webpack_require__(193);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(37);
	
	var _DayPicker = __webpack_require__(490);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	var _OutsideClickHandler = __webpack_require__(335);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  date: _reactMomentProptypes2['default'].momentObj,
	  onDateChange: _propTypes2['default'].func,
	
	  focused: _propTypes2['default'].bool,
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayBlocked: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // DayPicker props
	  renderMonth: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onOutsideClick: _propTypes2['default'].func,
	  renderDay: _propTypes2['default'].func,
	  renderCalendarInfo: _propTypes2['default'].func,
	
	  // accessibility
	  onBlur: _propTypes2['default'].func,
	  isFocused: _propTypes2['default'].bool,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  date: undefined, // TODO: use null
	  onDateChange: function () {
	    function onDateChange() {}
	
	    return onDateChange;
	  }(),
	
	
	  focused: false,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  keepOpenOnDateSelect: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	
	  // DayPicker props
	  renderMonth: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  daySize: _constants.DAY_SIZE,
	  verticalHeight: null,
	
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	
	  onOutsideClick: null,
	
	  renderDay: null,
	  renderCalendarInfo: null,
	
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  isFocused: false,
	  showKeyboardShortcuts: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	
	  isRTL: false
	};
	
	var DayPickerSingleDateController = function (_React$Component) {
	  _inherits(DayPickerSingleDateController, _React$Component);
	
	  function DayPickerSingleDateController(props) {
	    _classCallCheck(this, DayPickerSingleDateController);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerSingleDateController.__proto__ || Object.getPrototypeOf(DayPickerSingleDateController)).call(this, props));
	
	    _this.isTouchDevice = false;
	    _this.today = (0, _moment2['default'])();
	
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      selected: function () {
	        function selected(day) {
	          return _this.isSelected(day);
	        }
	
	        return selected;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      visibleDays: visibleDays
	    };
	
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
	    _this.onDayClick = _this.onDayClick.bind(_this);
	
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerSingleDateController, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var date = nextProps.date,
	            focused = nextProps.focused,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	
	
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== this.props.isOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== this.props.isDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== this.props.isDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focused && focused) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var didDateChange = date !== this.props.date;
	        var didFocusChange = focused !== this.props.focused;
	
	        var modifiers = {};
	
	        if (didDateChange) {
	          modifiers = this.deleteModifier(modifiers, this.props.date, 'selected');
	          modifiers = this.addModifier(modifiers, date, 'selected');
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object4['default'])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment2['default'])(day);
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment2['default'])();
	        if (!(0, _isSameDay2['default'])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentWillUpdate',
	    value: function () {
	      function componentWillUpdate() {
	        this.today = (0, _moment2['default'])();
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	        var _props = this.props,
	            onDateChange = _props.onDateChange,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose;
	
	
	        onDateChange(day);
	        if (!keepOpenOnDateSelect) {
	          onFocusChange({ focused: false });
	          onClose({ date: day });
	        }
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _state = this.state,
	            hoverDate = _state.hoverDate,
	            visibleDays = _state.visibleDays;
	
	
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	        modifiers = this.addModifier(modifiers, day, 'hovered');
	
	        this.setState({
	          hoverDate: day,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave() {
	        var _state2 = this.state,
	            hoverDate = _state2.hoverDate,
	            visibleDays = _state2.visibleDays;
	
	        if (this.isTouchDevice || !hoverDate) return;
	
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick() {
	        var _props2 = this.props,
	            onPrevMonthClick = _props2.onPrevMonthClick,
	            numberOfMonths = _props2.numberOfMonths,
	            enableOutsideDays = _props2.enableOutsideDays;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            visibleDays = _state3.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var prevMonth = currentMonth.clone().subtract(1, 'month');
	        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays);
	
	        this.setState({
	          currentMonth: prevMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        });
	
	        onPrevMonthClick(prevMonth.clone());
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick() {
	        var _props3 = this.props,
	            onNextMonthClick = _props3.onNextMonthClick,
	            numberOfMonths = _props3.numberOfMonths,
	            enableOutsideDays = _props3.enableOutsideDays;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            visibleDays = _state4.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays);
	
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        });
	
	        onNextMonthClick(newCurrentMonth.clone());
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'getFirstFocusableDay',
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            date = _props4.date,
	            numberOfMonths = _props4.numberOfMonths;
	
	
	        var focusedDate = newMonth.clone().startOf('month');
	        if (date) {
	          focusedDate = date.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day) && (0, _isAfterDay2['default'])(day, focusedDate);
	          });
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: 'getModifiers',
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: 'getModifiersForDay',
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: 'getStateForNewMonth',
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            date = nextProps.date,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
	          return date;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays));
	        return { currentMonth: currentMonth, visibleDays: visibleDays };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: 'addModifier',
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _props5 = this.props,
	            numberOfVisibleMonths = _props5.numberOfMonths,
	            enableOutsideDays = _props5.enableOutsideDays,
	            orientation = _props5.orientation;
	        var _state5 = this.state,
	            firstVisibleMonth = _state5.currentMonth,
	            visibleDays = _state5.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: 'deleteModifier',
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _props6 = this.props,
	            numberOfVisibleMonths = _props6.numberOfMonths,
	            enableOutsideDays = _props6.enableOutsideDays,
	            orientation = _props6.orientation;
	        var _state6 = this.state,
	            firstVisibleMonth = _state6.currentMonth,
	            visibleDays = _state6.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers['delete'](modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers['delete'](modifier);
	          updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: 'isBlocked',
	    value: function () {
	      function isBlocked(day) {
	        var _props7 = this.props,
	            isDayBlocked = _props7.isDayBlocked,
	            isOutsideRange = _props7.isOutsideRange;
	
	        return isDayBlocked(day) || isOutsideRange(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: 'isHovered',
	    value: function () {
	      function isHovered(day) {
	        var _ref = this.state || {},
	            hoverDate = _ref.hoverDate;
	
	        return (0, _isSameDay2['default'])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: 'isSelected',
	    value: function () {
	      function isSelected(day) {
	        return (0, _isSameDay2['default'])(day, this.props.date);
	      }
	
	      return isSelected;
	    }()
	  }, {
	    key: 'isToday',
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay2['default'])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props8 = this.props,
	            numberOfMonths = _props8.numberOfMonths,
	            orientation = _props8.orientation,
	            monthFormat = _props8.monthFormat,
	            renderMonth = _props8.renderMonth,
	            navPrev = _props8.navPrev,
	            navNext = _props8.navNext,
	            withPortal = _props8.withPortal,
	            focused = _props8.focused,
	            enableOutsideDays = _props8.enableOutsideDays,
	            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
	            daySize = _props8.daySize,
	            firstDayOfWeek = _props8.firstDayOfWeek,
	            renderDay = _props8.renderDay,
	            renderCalendarInfo = _props8.renderCalendarInfo,
	            isFocused = _props8.isFocused,
	            isRTL = _props8.isRTL,
	            phrases = _props8.phrases,
	            onOutsideClick = _props8.onOutsideClick,
	            onBlur = _props8.onBlur,
	            showKeyboardShortcuts = _props8.showKeyboardShortcuts,
	            weekDayFormat = _props8.weekDayFormat,
	            verticalHeight = _props8.verticalHeight;
	        var _state7 = this.state,
	            currentMonth = _state7.currentMonth,
	            visibleDays = _state7.visibleDays;
	
	
	        var dayPickerComponent = _react2['default'].createElement(_DayPicker2['default'], {
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          monthFormat: monthFormat,
	          withPortal: withPortal,
	          hidden: !focused,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          firstDayOfWeek: firstDayOfWeek,
	          navPrev: navPrev,
	          navNext: navNext,
	          renderMonth: renderMonth,
	          renderDay: renderDay,
	          renderCalendarInfo: renderCalendarInfo,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          phrases: phrases,
	          daySize: daySize,
	          isRTL: isRTL,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          weekDayFormat: weekDayFormat,
	          verticalHeight: verticalHeight
	        });
	
	        if (onOutsideClick) {
	          return _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            {
	              onOutsideClick: onOutsideClick
	            },
	            dayPickerComponent
	          );
	        }
	
	        return dayPickerComponent;
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerSingleDateController;
	}(_react2['default'].Component);
	
	exports['default'] = DayPickerSingleDateController;
	
	
	DayPickerSingleDateController.propTypes = propTypes;
	DayPickerSingleDateController.defaultProps = defaultProps;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LeftArrow = function () {
	  function LeftArrow(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z'
	      })
	    );
	  }
	
	  return LeftArrow;
	}();
	
	LeftArrow.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = LeftArrow;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var RightArrow = function () {
	  function RightArrow(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z'
	      })
	    );
	  }
	
	  return RightArrow;
	}();
	
	RightArrow.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = RightArrow;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _DateInput = __webpack_require__(1225);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _IconPositionShape = __webpack_require__(243);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _CloseButton = __webpack_require__(242);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _CalendarIcon = __webpack_require__(1222);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	var _OpenDirectionShape = __webpack_require__(192);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string, // also used as label
	  displayValue: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	  focused: _propTypes2['default'].bool,
	  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  showClearDate: _propTypes2['default'].bool,
	  customCloseIcon: _propTypes2['default'].node,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  isRTL: _propTypes2['default'].bool,
	  onChange: _propTypes2['default'].func,
	  onClearDate: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDownShiftTab: _propTypes2['default'].func,
	  onKeyDownTab: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerInputPhrases))
	}));
	
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  isFocused: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customCloseIcon: null,
	  customInputIcon: null,
	  isRTL: false,
	
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onClearDate: function () {
	    function onClearDate() {}
	
	    return onClearDate;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  // i18n
	  phrases: _defaultPhrases.SingleDatePickerInputPhrases
	};
	
	function SingleDatePickerInput(_ref) {
	  var id = _ref.id,
	      placeholder = _ref.placeholder,
	      displayValue = _ref.displayValue,
	      focused = _ref.focused,
	      isFocused = _ref.isFocused,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      showClearDate = _ref.showClearDate,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      phrases = _ref.phrases,
	      onClearDate = _ref.onClearDate,
	      onChange = _ref.onChange,
	      onFocus = _ref.onFocus,
	      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
	      onKeyDownTab = _ref.onKeyDownTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      screenReaderMessage = _ref.screenReaderMessage,
	      customCloseIcon = _ref.customCloseIcon,
	      customInputIcon = _ref.customInputIcon,
	      openDirection = _ref.openDirection,
	      isRTL = _ref.isRTL,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react2['default'].createElement(_CalendarIcon2['default'], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon_svg));
	  var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate_svg));
	
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement(
	    'button',
	    _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon), {
	      type: 'button',
	      disabled: disabled,
	      'aria-label': phrases.focusStartDate,
	      onClick: onFocus
	    }),
	    calendarIcon
	  );
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl),
	    inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon,
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: id,
	      placeholder: placeholder // also used as label
	      , displayValue: displayValue,
	      screenReaderMessage: screenReaderText,
	      focused: focused,
	      isFocused: isFocused,
	      disabled: disabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      onChange: onChange,
	      onFocus: onFocus,
	      onKeyDownShiftTab: onKeyDownShiftTab,
	      onKeyDownTab: onKeyDownTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      openDirection: openDirection
	    }),
	    showClearDate && _react2['default'].createElement(
	      'button',
	      _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
	        type: 'button',
	        'aria-label': phrases.clearDate,
	        disabled: disabled,
	        onMouseEnter: this.onClearDateMouseEnter,
	        onMouseLeave: this.onClearDateMouseLeave,
	        onClick: onClearDate
	      }),
	      closeIcon
	    ),
	    inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon
	  );
	}
	
	SingleDatePickerInput.propTypes = propTypes;
	SingleDatePickerInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    SingleDatePickerInput: {
	      backgroundColor: color.background,
	      border: '1px solid ' + String(color.core.border)
	    },
	
	    SingleDatePickerInput__rtl: {
	      direction: 'rtl'
	    },
	
	    SingleDatePickerInput__disabled: {
	      backgroundColor: color.disabled
	    },
	
	    SingleDatePickerInput_clearDate: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 10px 0 5px',
	
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	
	    SingleDatePickerInput_clearDate__hide: {
	      visibility: 'hidden'
	    },
	
	    SingleDatePickerInput_clearDate_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	
	    SingleDatePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px'
	    },
	
	    SingleDatePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	})(SingleDatePickerInput);

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _FocusedInputShape = __webpack_require__(1235);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _IconPositionShape = __webpack_require__(243);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _OrientationShape = __webpack_require__(1236);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _AnchorDirectionShape = __webpack_require__(1233);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	var _OpenDirectionShape = __webpack_require__(192);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  // required props for a functional interactive DateRangePicker
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  onDatesChange: _propTypes2['default'].func.isRequired,
	
	  focusedInput: _FocusedInputShape2['default'],
	  onFocusChange: _propTypes2['default'].func.isRequired,
	
	  onClose: _propTypes2['default'].func,
	
	  // input related props
	  startDateId: _propTypes2['default'].string.isRequired,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  endDateId: _propTypes2['default'].string.isRequired,
	  endDatePlaceholderText: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  screenReaderInputMessage: _propTypes2['default'].string,
	  showClearDates: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	
	  // calendar presentation and interaction related props
	  renderMonth: _propTypes2['default'].func,
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  openDirection: _OpenDirectionShape2['default'],
	  horizontalMargin: _propTypes2['default'].number,
	  withPortal: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  initialVisibleMonth: _propTypes2['default'].func,
	  numberOfMonths: _propTypes2['default'].number,
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDates: _propTypes2['default'].bool,
	  renderCalendarInfo: _propTypes2['default'].func,
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation related props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	
	  // day presentation and interaction related props
	  renderDay: _propTypes2['default'].func,
	  minimumNights: _propTypes2['default'].number,
	  enableOutsideDays: _propTypes2['default'].bool,
	  isDayBlocked: _propTypes2['default'].func,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // internationalization props
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerPhrases))
	};

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(133);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _IconPositionShape = __webpack_require__(243);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _OrientationShape = __webpack_require__(1236);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _AnchorDirectionShape = __webpack_require__(1233);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	var _OpenDirectionShape = __webpack_require__(192);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DayOfWeekShape = __webpack_require__(158);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  // required props for a functional interactive SingleDatePicker
	  date: _reactMomentProptypes2['default'].momentObj,
	  onDateChange: _propTypes2['default'].func.isRequired,
	
	  focused: _propTypes2['default'].bool,
	  onFocusChange: _propTypes2['default'].func.isRequired,
	
	  // input related props
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  screenReaderInputMessage: _propTypes2['default'].string,
	  showClearDate: _propTypes2['default'].bool,
	  customCloseIcon: _propTypes2['default'].node,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	
	  // calendar presentation and interaction related props
	  renderMonth: _propTypes2['default'].func,
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  openDirection: _OpenDirectionShape2['default'],
	  horizontalMargin: _propTypes2['default'].number,
	  withPortal: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  numberOfMonths: _propTypes2['default'].number,
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDate: _propTypes2['default'].bool,
	  renderCalendarInfo: _propTypes2['default'].func,
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation related props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  // day presentation and interaction related props
	  renderDay: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  isDayBlocked: _propTypes2['default'].func,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // internationalization props
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerPhrases))
	};

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCalendarMonthWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var CALENDAR_MONTH_PADDING = 9;
	
	function getCalendarMonthWidth(daySize) {
	  return 7 * (daySize + 1) + 2 * (CALENDAR_MONTH_PADDING + 1);
	}

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getResponsiveContainerStyles;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
	  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
	  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
	  var calculatedMargin = margin || 0;
	
	  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
	}

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getVisibleDays;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toISOMonthString = __webpack_require__(337);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
	  if (!_moment2['default'].isMoment(month)) return {};
	
	  var visibleDaysByMonth = {};
	  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    var visibleDays = [];
	
	    // set utc offset to get correct dates in future (when timezone changes)
	    var baseDate = currentMonth.clone();
	    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
	    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
	
	    var currentDay = firstOfMonth.clone();
	
	    // days belonging to the previous month
	    if (enableOutsideDays) {
	      for (var j = 0; j < currentDay.weekday(); j += 1) {
	        var prevDay = currentDay.clone().subtract(j + 1, 'day');
	        visibleDays.unshift(prevDay);
	      }
	    }
	
	    while (currentDay < lastOfMonth) {
	      visibleDays.push(currentDay.clone());
	      currentDay.add(1, 'day');
	    }
	
	    if (enableOutsideDays) {
	      // weekday() returns the index of the day of the week according to the locale
	      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
	      if (currentDay.weekday() !== 0) {
	        // days belonging to the next month
	        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
	          var nextDay = currentDay.clone().add(count, 'day');
	          visibleDays.push(nextDay);
	        }
	      }
	    }
	
	    visibleDaysByMonth[(0, _toISOMonthString2['default'])(currentMonth)] = visibleDays;
	    currentMonth = currentMonth.clone().add(1, 'month');
	  }
	
	  return visibleDaysByMonth;
	}

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isNextDay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(194);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isNextDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
	  return (0, _isSameDay2['default'])(nextDay, b);
	}

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./ad.svg": 2027,
		"./ae.svg": 2028,
		"./af.svg": 2029,
		"./ag.svg": 2030,
		"./ai.svg": 2031,
		"./al.svg": 2032,
		"./am.svg": 2033,
		"./ao.svg": 2034,
		"./ar.svg": 2035,
		"./as.svg": 2036,
		"./at.svg": 2037,
		"./au.svg": 2038,
		"./aw.svg": 2039,
		"./az.svg": 2040,
		"./ba.svg": 2041,
		"./bb.svg": 2042,
		"./bd.svg": 2043,
		"./be.svg": 2044,
		"./bf.svg": 2045,
		"./bg.svg": 2046,
		"./bh.svg": 2047,
		"./bi.svg": 2048,
		"./bj.svg": 2049,
		"./bm.svg": 2050,
		"./bo.svg": 2051,
		"./br.svg": 2052,
		"./bs.svg": 2053,
		"./bt.svg": 2054,
		"./bw.svg": 2055,
		"./by.svg": 2056,
		"./bz.svg": 2057,
		"./ca.svg": 2058,
		"./cd.svg": 2059,
		"./cf.svg": 2060,
		"./cg.svg": 2061,
		"./ch.svg": 2062,
		"./ci.svg": 2063,
		"./ck.svg": 2064,
		"./cl.svg": 2065,
		"./cm.svg": 2066,
		"./cn.svg": 2067,
		"./co.svg": 2068,
		"./cr.svg": 2069,
		"./cu.svg": 2070,
		"./cv.svg": 2071,
		"./cw.svg": 2072,
		"./cy.svg": 2073,
		"./cz.svg": 2074,
		"./de.svg": 2075,
		"./dj.svg": 2076,
		"./dk.svg": 2077,
		"./dm.svg": 2078,
		"./do.svg": 2079,
		"./dz.svg": 2080,
		"./ec.svg": 2081,
		"./ee.svg": 2082,
		"./eg.svg": 2083,
		"./er.svg": 2084,
		"./es.svg": 2085,
		"./et.svg": 2086,
		"./fi.svg": 2087,
		"./fj.svg": 2088,
		"./fk.svg": 2089,
		"./fm.svg": 2090,
		"./fo.svg": 2091,
		"./fr.svg": 2092,
		"./ga.svg": 2093,
		"./gb.svg": 2094,
		"./gd.svg": 2095,
		"./ge.svg": 2096,
		"./gg.svg": 2097,
		"./gh.svg": 2098,
		"./gi.svg": 2099,
		"./gl.svg": 2100,
		"./gm.svg": 2101,
		"./gn.svg": 2102,
		"./gq.svg": 2103,
		"./gr.svg": 2104,
		"./gt.svg": 2105,
		"./gu.svg": 2106,
		"./gw.svg": 2107,
		"./hk.svg": 2108,
		"./hn.svg": 2109,
		"./hr.svg": 2110,
		"./ht.svg": 2111,
		"./hu.svg": 2112,
		"./id.svg": 2113,
		"./ie.svg": 2114,
		"./il.svg": 2115,
		"./im.svg": 2116,
		"./in.svg": 2117,
		"./io.svg": 2118,
		"./iq.svg": 2119,
		"./ir.svg": 2120,
		"./is.svg": 2121,
		"./it.svg": 2122,
		"./je.svg": 2123,
		"./jm.svg": 2124,
		"./jo.svg": 2125,
		"./jp.svg": 2126,
		"./ke.svg": 2127,
		"./kg.svg": 2128,
		"./kh.svg": 2129,
		"./ki.svg": 2130,
		"./km.svg": 2131,
		"./kn.svg": 2132,
		"./kp.svg": 2133,
		"./kr.svg": 2134,
		"./kw.svg": 2135,
		"./ky.svg": 2136,
		"./kz.svg": 2137,
		"./la.svg": 2138,
		"./lb.svg": 2139,
		"./li.svg": 2140,
		"./lk.svg": 2141,
		"./lr.svg": 2142,
		"./ls.svg": 2143,
		"./lt.svg": 2144,
		"./lu.svg": 2145,
		"./lv.svg": 2146,
		"./ly.svg": 2147,
		"./ma.svg": 2148,
		"./mc.svg": 2149,
		"./md.svg": 2150,
		"./me.svg": 2151,
		"./mg.svg": 2152,
		"./mh.svg": 2153,
		"./mk.svg": 2154,
		"./ml.svg": 2155,
		"./mm.svg": 2156,
		"./mn.svg": 2157,
		"./mo.svg": 2158,
		"./mp.svg": 2159,
		"./mq.svg": 2160,
		"./mr.svg": 2161,
		"./ms.svg": 2162,
		"./mt.svg": 2163,
		"./mu.svg": 2164,
		"./mv.svg": 2165,
		"./mw.svg": 2166,
		"./mx.svg": 2167,
		"./my.svg": 2168,
		"./mz.svg": 2169,
		"./na.svg": 2170,
		"./nato.svg": 2171,
		"./ne.svg": 2172,
		"./nf.svg": 2173,
		"./ng.svg": 2174,
		"./ni.svg": 2175,
		"./nl.svg": 2176,
		"./no.svg": 2177,
		"./np.svg": 2178,
		"./nr.svg": 2179,
		"./nu.svg": 2180,
		"./nz.svg": 2181,
		"./om.svg": 2182,
		"./pa.svg": 2183,
		"./pe.svg": 2184,
		"./pf.svg": 2185,
		"./pg.svg": 2186,
		"./ph.svg": 2187,
		"./pk.svg": 2188,
		"./pl.svg": 2189,
		"./pn.svg": 2190,
		"./pr.svg": 2191,
		"./ps.svg": 2192,
		"./pt.svg": 2193,
		"./pw.svg": 2194,
		"./py.svg": 2195,
		"./qa.svg": 2196,
		"./ro.svg": 2197,
		"./rs.svg": 2198,
		"./ru.svg": 2199,
		"./rw.svg": 2200,
		"./sa.svg": 2201,
		"./sb.svg": 2202,
		"./sc.svg": 2203,
		"./sd.svg": 2204,
		"./se.svg": 2205,
		"./sg.svg": 2206,
		"./si.svg": 2207,
		"./sk.svg": 2208,
		"./sl.svg": 2209,
		"./sm.svg": 2210,
		"./sn.svg": 2211,
		"./so.svg": 2212,
		"./sr.svg": 2213,
		"./ss.svg": 2214,
		"./st.svg": 2215,
		"./sv.svg": 2216,
		"./sx.svg": 2217,
		"./sy.svg": 2218,
		"./sz.svg": 2219,
		"./tc.svg": 2220,
		"./td.svg": 2221,
		"./tg.svg": 2222,
		"./th.svg": 2223,
		"./tibet.svg": 2224,
		"./tj.svg": 2225,
		"./tk.svg": 2226,
		"./tm.svg": 2227,
		"./tn.svg": 2228,
		"./to.svg": 2229,
		"./tr.svg": 2230,
		"./tt.svg": 2231,
		"./tv.svg": 2232,
		"./tw.svg": 2233,
		"./tz.svg": 2234,
		"./ua.svg": 2235,
		"./ug.svg": 2236,
		"./us.svg": 2237,
		"./uy.svg": 2238,
		"./uz.svg": 2239,
		"./ve.svg": 2240,
		"./vi.svg": 2241,
		"./vn.svg": 2242,
		"./vu.svg": 2243,
		"./ws.svg": 2244,
		"./ye.svg": 2245,
		"./za.svg": 2246,
		"./zm.svg": 2247,
		"./zw.svg": 2248
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1242;


/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(2862);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(901);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(2739);
	
	var _HelmetConstants = __webpack_require__(1244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ },
/* 1244 */
/***/ function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ },
/* 1245 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(323);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(340);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(197);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _LegacyPortal = __webpack_require__(2764);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
	
	      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
	    }, _this.getMountNode = function () {
	      return _this._portalContainerNode;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this.setContainer();
	    this.forceUpdate(this.props.onRendered);
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.container !== this.props.container) {
	      this.setContainer(nextProps);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._portalContainerNode = null;
	  };
	
	  Portal.prototype.render = function render() {
	    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
	module.exports = exports['default'];

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _contains = __webpack_require__(183);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _addEventListener = __webpack_require__(1249);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ownerDocument = __webpack_require__(197);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var escapeKeyCode = 27;
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * The `<RootCloseWrapper/>` component registers your callback on the document
	 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
	 * style behavior where your callback is triggered when the user tries to
	 * interact with the rest of the document or hits the `esc` key.
	 */
	
	var RootCloseWrapper = function (_React$Component) {
	  _inherits(RootCloseWrapper, _React$Component);
	
	  function RootCloseWrapper(props, context) {
	    _classCallCheck(this, RootCloseWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.addEventListeners = function () {
	      var event = _this.props.event;
	
	      var doc = (0, _ownerDocument2.default)(_this);
	
	      // Use capture for this listener so it fires before React's listener, to
	      // avoid false positives in the contains() check below if the target DOM
	      // element is removed in the React mouse callback.
	      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);
	
	      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);
	
	      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
	    };
	
	    _this.removeEventListeners = function () {
	      if (_this.documentMouseCaptureListener) {
	        _this.documentMouseCaptureListener.remove();
	      }
	
	      if (_this.documentMouseListener) {
	        _this.documentMouseListener.remove();
	      }
	
	      if (_this.documentKeyupListener) {
	        _this.documentKeyupListener.remove();
	      }
	    };
	
	    _this.handleMouseCapture = function (e) {
	      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
	    };
	
	    _this.handleMouse = function (e) {
	      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.handleKeyUp = function (e) {
	      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
	        _this.props.onRootClose(e);
	      }
	    };
	
	    _this.preventMouseRootClose = false;
	    return _this;
	  }
	
	  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (!this.props.disabled) {
	      this.addEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!this.props.disabled && prevProps.disabled) {
	      this.addEventListeners();
	    } else if (this.props.disabled && !prevProps.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (!this.props.disabled) {
	      this.removeEventListeners();
	    }
	  };
	
	  RootCloseWrapper.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RootCloseWrapper;
	}(_react2.default.Component);
	
	RootCloseWrapper.displayName = 'RootCloseWrapper';
	
	RootCloseWrapper.propTypes = {
	  /**
	   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
	   */
	  onRootClose: _propTypes2.default.func,
	  /**
	   * Children to render.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Choose which document mouse event to bind to.
	   */
	  event: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	RootCloseWrapper.defaultProps = {
	  event: 'click'
	};
	
	exports.default = RootCloseWrapper;
	module.exports = exports['default'];

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _on = __webpack_require__(292);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _properties = __webpack_require__(907);
	
	var _properties2 = _interopRequireDefault(_properties);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var transitionEndEvent = _properties2.default.end;
	
	var UNMOUNTED = exports.UNMOUNTED = 0;
	var EXITED = exports.EXITED = 1;
	var ENTERING = exports.ENTERING = 2;
	var ENTERED = exports.ENTERED = 3;
	var EXITING = exports.EXITING = 4;
	
	/**
	 * The Transition component lets you define and run css transitions with a simple declarative api.
	 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
	 * but is specifically optimized for transitioning a single child "in" or "out".
	 *
	 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
	 * The extensive set of lifecycle callbacks means you have control over
	 * the transitioning now at each step of the way.
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.updateStatus = function () {
	      if (_this.nextStatus !== null) {
	        // nextStatus will always be ENTERING or EXITING.
	        _this.cancelNextCallback();
	        var node = _reactDom2.default.findDOMNode(_this);
	
	        if (_this.nextStatus === ENTERING) {
	          _this.props.onEnter(node);
	
	          _this.safeSetState({ status: ENTERING }, function () {
	            _this.props.onEntering(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: ENTERED }, function () {
	                _this.props.onEntered(node);
	              });
	            });
	          });
	        } else {
	          _this.props.onExit(node);
	
	          _this.safeSetState({ status: EXITING }, function () {
	            _this.props.onExiting(node);
	
	            _this.onTransitionEnd(node, function () {
	              _this.safeSetState({ status: EXITED }, function () {
	                _this.props.onExited(node);
	              });
	            });
	          });
	        }
	
	        _this.nextStatus = null;
	      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
	        _this.setState({ status: UNMOUNTED });
	      }
	    };
	
	    _this.cancelNextCallback = function () {
	      if (_this.nextCallback !== null) {
	        _this.nextCallback.cancel();
	        _this.nextCallback = null;
	      }
	    };
	
	    _this.safeSetState = function (nextState, callback) {
	      // This shouldn't be necessary, but there are weird race conditions with
	      // setState callbacks and unmounting in testing, so always make sure that
	      // we can cancel any pending setState callbacks after we unmount.
	      _this.setState(nextState, _this.setNextCallback(callback));
	    };
	
	    _this.setNextCallback = function (callback) {
	      var active = true;
	
	      _this.nextCallback = function (event) {
	        if (active) {
	          active = false;
	          _this.nextCallback = null;
	
	          callback(event);
	        }
	      };
	
	      _this.nextCallback.cancel = function () {
	        active = false;
	      };
	
	      return _this.nextCallback;
	    };
	
	    _this.onTransitionEnd = function (node, handler) {
	      _this.setNextCallback(handler);
	
	      if (node) {
	        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
	        setTimeout(_this.nextCallback, _this.props.timeout);
	      } else {
	        setTimeout(_this.nextCallback, 0);
	      }
	    };
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (props.transitionAppear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var status = this.state.status;
	
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        childProps = _objectWithoutProperties(_props, ['children', 'className']);
	
	    Object.keys(Transition.propTypes).forEach(function (key) {
	      return delete childProps[key];
	    });
	
	    var transitionClassName = void 0;
	    if (status === EXITED) {
	      transitionClassName = this.props.exitedClassName;
	    } else if (status === ENTERING) {
	      transitionClassName = this.props.enteringClassName;
	    } else if (status === ENTERED) {
	      transitionClassName = this.props.enteredClassName;
	    } else if (status === EXITING) {
	      transitionClassName = this.props.exitingClassName;
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, _extends({}, childProps, {
	      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
	    }));
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.propTypes = {
	  /**
	   * Show the component; triggers the enter or exit animation
	   */
	  in: _propTypes2.default.bool,
	
	  /**
	   * Wait until the first "enter" transition to mount the component (add it to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount the component (remove it from the DOM) when it is not shown
	   */
	  unmountOnExit: _propTypes2.default.bool,
	
	  /**
	   * Run the enter animation when the component mounts, if it is initially
	   * shown
	   */
	  transitionAppear: _propTypes2.default.bool,
	
	  /**
	   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
	   * transition indefinately if the browser transitionEnd events are
	   * canceled or interrupted.
	   *
	   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
	   * setting this to the duration of your animation (or a bit above it).
	   */
	  timeout: _propTypes2.default.number,
	
	  /**
	   * CSS class or classes applied when the component is exited
	   */
	  exitedClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is exiting
	   */
	  exitingClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied when the component is entered
	   */
	  enteredClassName: _propTypes2.default.string,
	  /**
	   * CSS class or classes applied while the component is entering
	   */
	  enteringClassName: _propTypes2.default.string,
	
	  /**
	   * Callback fired before the "entering" classes are applied
	   */
	  onEnter: _propTypes2.default.func,
	  /**
	   * Callback fired after the "entering" classes are applied
	   */
	  onEntering: _propTypes2.default.func,
	  /**
	   * Callback fired after the "enter" classes are applied
	   */
	  onEntered: _propTypes2.default.func,
	  /**
	   * Callback fired before the "exiting" classes are applied
	   */
	  onExit: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exiting" classes are applied
	   */
	  onExiting: _propTypes2.default.func,
	  /**
	   * Callback fired after the "exited" classes are applied
	   */
	  onExited: _propTypes2.default.func
	};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.displayName = 'Transition';
	
	Transition.defaultProps = {
	  in: false,
	  unmountOnExit: false,
	  transitionAppear: false,
	
	  timeout: 5000,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	exports.default = Transition;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (node, event, handler, capture) {
	  (0, _on2.default)(node, event, handler, capture);
	
	  return {
	    remove: function remove() {
	      (0, _off2.default)(node, event, handler, capture);
	    }
	  };
	};
	
	var _on = __webpack_require__(292);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(421);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isOverflowing;
	
	var _isWindow = __webpack_require__(293);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	var _ownerDocument = __webpack_require__(182);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBody(node) {
	  return node && node.tagName.toLowerCase() === 'body';
	}
	
	function bodyIsOverflowing(node) {
	  var doc = (0, _ownerDocument2.default)(node);
	  var win = (0, _isWindow2.default)(doc);
	  var fullWidth = win.innerWidth;
	
	  // Support: ie8, no innerWidth
	  if (!fullWidth) {
	    var documentElementRect = doc.documentElement.getBoundingClientRect();
	    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	  }
	
	  return doc.body.clientWidth < fullWidth;
	}
	
	function isOverflowing(container) {
	  var win = (0, _isWindow2.default)(container);
	
	  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
	}
	module.exports = exports['default'];

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp, _initialiseProps;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(494);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InputSmart = __webpack_require__(2777);
	
	var _InputSmart2 = _interopRequireDefault(_InputSmart);
	
	var _InputBasic = __webpack_require__(2776);
	
	var _InputBasic2 = _interopRequireDefault(_InputBasic);
	
	var _InternationalIcon = __webpack_require__(2778);
	
	var _InternationalIcon2 = _interopRequireDefault(_InternationalIcon);
	
	var _Flag = __webpack_require__(2775);
	
	var _Flag2 = _interopRequireDefault(_Flag);
	
	var _inputControl = __webpack_require__(2782);
	
	var _countries = __webpack_require__(1253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Allows passing custom `libphonenumber-js` metadata
	// to reduce the overall bundle size.
	var PhoneNumberInput = (0, _reactLifecyclesCompat.polyfill)(_class = (_temp = _class2 = function (_PureComponent) {
		_inherits(PhoneNumberInput, _PureComponent);
	
		function PhoneNumberInput(props) {
			_classCallCheck(this, PhoneNumberInput);
	
			var _this = _possibleConstructorReturn(this, (PhoneNumberInput.__proto__ || Object.getPrototypeOf(PhoneNumberInput)).call(this, props));
	
			_initialiseProps.call(_this);
	
			var _this$props = _this.props,
			    value = _this$props.value,
			    country = _this$props.country,
			    countries = _this$props.countries,
			    labels = _this$props.labels,
			    international = _this$props.international,
			    metadata = _this$props.metadata;
	
			// Will be removed in version 2.x.
	
			if (typeof _this.props.internationalIcon !== 'function') {
				throw new Error("You're passing a custom `internationalIcon` property to `react-phone-number-input` component. In the latest version it may only be a React component (a class or a function), not a React element. Wrap `internationalIcon` into a function to resolve the error: `() => internationalIcon`.");
			}
	
			var parsed_number = (0, _inputControl.parsePhoneNumber)(value, metadata);
	
			var pre_selected_country = (0, _inputControl.getPreSelectedCountry)(parsed_number, country, countries, international, metadata);
	
			_this.state = {
				// Workaround for `this.props` inside `getDerivedStateFromProps()`.
				props: _this.props,
	
				// The country selected.
				country: pre_selected_country,
	
				// Generate country `<select/>` options.
				country_select_options: generate_country_select_options(_this.props),
	
				// `parsed_input` state property holds non-formatted user's input.
				// The reason is that there's no way of finding out
				// in which form should `value` be displayed: international or national.
				// E.g. if `value` is `+78005553535` then it could be input
				// by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
				// Hence storing just `value`is not sufficient for correct formatting.
				// E.g. if a user entered `8 (800) 555-35-35`
				// then value is `+78005553535` and `parsed_input` is `88005553535`
				// and if a user entered `+7 800 555 35 35`
				// then value is `+78005553535` and `parsed_input` is `+78005553535`.
				parsed_input: generateParsedInput(value, parsed_number, _this.props),
	
				// `value` property is duplicated in state.
				// The reason is that `getDerivedStateFromProps()`
				// needs this `value` to compare to the new `value` property
				// to find out if `parsed_input` needs updating:
				// If the `value` property changed externally
				// then it won't be equal to state `value`
				// in which case `parsed_input` and `country` get updated.
				value: value
			};
			return _this;
		}
	
		// Country `<select/>` `onChange` handler.
	
	
		// Phone number `<input/>` `onKeyDown` handler.
	
	
		// `<input/>` `onChange` handler.
		// Updates `value` property accordingly.
		// (so that they are kept in sync).
		// `parsed_input` must be a parsed phone number
		// or an empty string.
		// E.g.: `""`, `"+"`, `"+123"`, `"123"`.
	
	
		// This `onBlur` interceptor is a workaround for `redux-form`
		// so that it gets the up-to-date `value` in its `onBlur` handler.
		// Without this fix it just gets the actual (raw) input field textual value.
		// E.g. `+7 800 555 35 35` instead of `+78005553535`.
		//
		// A developer is not supposed to pass this `onBlur` property manually.
		// Instead, `redux-form` passes `onBlur` to this component automatically
		// and this component patches that `onBlur` handler (a hacky way but works).
		//
	
	
		// When country `<select/>` is toggled.
	
	
		_createClass(PhoneNumberInput, [{
			key: 'onCountryChange',
	
	
			// Some people requested an `onCountryChange` event listener.
			// No valid reason was given other than compliance with some legacy code
			// which stored both phone number and country in a database.
			// https://github.com/catamphetamine/react-phone-number-input/issues/128
			value: function onCountryChange(new_country) {
				var onCountryChange = this.props.onCountryChange;
				var country = this.state.country;
	
	
				if (onCountryChange && new_country !== country) {
					onCountryChange(new_country);
				}
			}
	
			// Can be called externally.
	
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    name = _props.name,
				    disabled = _props.disabled,
				    autoComplete = _props.autoComplete,
				    countrySelectTabIndex = _props.countrySelectTabIndex,
				    showCountrySelect = _props.showCountrySelect,
				    style = _props.style,
				    className = _props.className,
				    inputClassName = _props.inputClassName,
				    getInputClassName = _props.getInputClassName,
				    countrySelectProperties = _props.countrySelectProperties,
				    error = _props.error,
				    indicateInvalid = _props.indicateInvalid,
				    CountrySelectComponent = _props.countrySelectComponent,
				    inputComponent = _props.inputComponent,
				    smartCaret = _props.smartCaret,
				    ext = _props.ext,
				    countries = _props.countries,
				    labels = _props.labels,
				    _ = _props.country,
				    flags = _props.flags,
				    flagComponent = _props.flagComponent,
				    flagsPath = _props.flagsPath,
				    international = _props.international,
				    internationalIcon = _props.internationalIcon,
				    displayInitialValueAsLocalNumber = _props.displayInitialValueAsLocalNumber,
				    onCountryChange = _props.onCountryChange,
				    countrySelectHidesPhoneInputField = _props.countrySelectHidesPhoneInputField,
				    locale = _props.locale,
				    metadata = _props.metadata,
				    phoneNumberInputProps = _objectWithoutProperties(_props, ['name', 'disabled', 'autoComplete', 'countrySelectTabIndex', 'showCountrySelect', 'style', 'className', 'inputClassName', 'getInputClassName', 'countrySelectProperties', 'error', 'indicateInvalid', 'countrySelectComponent', 'inputComponent', 'smartCaret', 'ext', 'countries', 'labels', 'country', 'flags', 'flagComponent', 'flagsPath', 'international', 'internationalIcon', 'displayInitialValueAsLocalNumber', 'onCountryChange', 'countrySelectHidesPhoneInputField', 'locale', 'metadata']);
	
				var _state = this.state,
				    country = _state.country,
				    hidePhoneInputField = _state.hidePhoneInputField,
				    country_select_options = _state.country_select_options,
				    parsed_input = _state.parsed_input;
	
	
				var InputComponent = inputComponent || (smartCaret ? _InputSmart2.default : _InputBasic2.default);
	
				// Extract `countrySelectProperties` from `this.props`
				// also removing them from `phoneNumberInputProps`.
				var _countrySelectProps = {};
				if (countrySelectProperties) {
					for (var key in countrySelectProperties) {
						if (this.props.hasOwnProperty(key)) {
							_countrySelectProps[countrySelectProperties[key]] = this.props[key];
							delete phoneNumberInputProps[key];
						}
					}
				}
	
				return _react2.default.createElement(
					'div',
					{
						style: style,
						className: (0, _classnames2.default)('react-phone-number-input', {
							'react-phone-number-input--invalid': error && indicateInvalid
						}, className) },
					_react2.default.createElement(
						'div',
						{ className: 'react-phone-number-input__row' },
						showCountrySelect && _react2.default.createElement(CountrySelectComponent, _extends({}, _countrySelectProps, {
							ref: this.storeCountrySelectInstance,
							name: name ? name + '__country' : undefined,
							value: country,
							options: country_select_options,
							onChange: this.onCountrySelected,
							disabled: disabled,
							tabIndex: countrySelectTabIndex,
							hidePhoneInputField: this.hidePhoneInputField,
							focusPhoneInputField: this.focus,
							className: 'react-phone-number-input__country' })),
						!hidePhoneInputField && _react2.default.createElement(InputComponent, _extends({
							type: 'tel',
							name: name
						}, phoneNumberInputProps, {
							ref: this.storePhoneNumberInputInstance,
							metadata: metadata,
							country: country,
							value: parsed_input || '',
							onChange: this.onChange,
							onBlur: this.onBlur,
							onKeyDown: this.onPhoneNumberKeyDown,
							disabled: disabled,
							autoComplete: autoComplete,
							className: (0, _classnames2.default)('react-phone-number-input__phone',
							// Will be uncommented for version 2.x
							// {
							// 	'react-phone-number-input__phone--disabled' : disabled,
							// 	'react-phone-number-input__phone--invalid'  : error && indicateInvalid
							// },
							inputClassName, getInputClassName && getInputClassName({ disabled: disabled, invalid: error && indicateInvalid })) })),
						ext && !hidePhoneInputField && _react2.default.createElement(
							'label',
							{ className: 'react-phone-number-input__ext' },
							labels && labels.ext || 'ext.',
							_react2.default.cloneElement(ext, {
								type: ext.props.type === undefined ? 'number' : ext.props.type,
								className: (0, _classnames2.default)('react-phone-number-input__ext-input',
								// Will be uncommented for version 2.x
								// {
								// 	'react-phone-number-input__phone--disabled' : disabled,
								// },
								inputClassName, getInputClassName && getInputClassName({ disabled: disabled }), ext.props.className)
							})
						)
					),
					error && indicateInvalid && _react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('react-phone-number-input__error', 'rrui__input-error') },
						error
					)
				);
			}
		}], [{
			key: 'getDerivedStateFromProps',
			value: function getDerivedStateFromProps(props, state) {
				var country = state.country,
				    hasChangedCountry = state.hasChangedCountry,
				    value = state.value,
				    _state$props = state.props,
				    old_default_country = _state$props.country,
				    old_value = _state$props.value;
				var metadata = props.metadata,
				    new_default_country = props.country,
				    new_value = props.value;
	
				// Emulate `prevProps` via `state.props`.
	
				var new_state = { props: props
	
					// If `countries` or `labels` or `international` changed
					// then re-generate country `<select/>` options.
				};if (props.countries !== state.props.countries || props.labels !== state.props.labels || props.international !== state.props.international) {
					new_state.country_select_options = generate_country_select_options(props);
				}
	
				// If the default country changed.
				// (e.g. in case of ajax GeoIP detection after page loaded)
				// then select it but only if the user didn't previously select
				// another country and no phone number has been entered so far.
				// Because if the user has already started inputting a phone number
				// then he's okay with no country being selected at all ("International")
				// and doesn't want to be disturbed, doesn't want his input to be screwed, etc.
				if (new_default_country !== old_default_country && !hasChangedCountry && !value && !new_value) {
					return _extends({}, new_state, {
						country: new_default_country
					});
				}
				// If a new `value` is set externally.
				// (e.g. as a result of an ajax API request
				//  to get user's phone after page loaded)
				// The first part — `new_value !== old_value` —
				// is basically `props.value !== prevProps.value`
				// so it means "if value property was changed externally".
				// The second part — `new_value !== value` —
				// is for ignoring the `getDerivedStateFromProps()` call
				// which happens in `this.onChange()` right after `this.setState()`.
				// If this `getDerivedStateFromProps()` call isn't ignored
				// then the country flag would reset on each input.
				else if (new_value !== old_value && new_value !== value) {
						var parsed_number = (0, _inputControl.parsePhoneNumber)(new_value, metadata);
	
						return _extends({}, new_state, {
							parsed_input: generateParsedInput(new_value, parsed_number, props),
							value: new_value,
							country: new_value ? parsed_number.country : country
						});
					}
	
				// Maybe `new_state.country_select_options` changed.
				// In any case, update `prevProps`.
				return new_state;
			}
		}]);
	
		return PhoneNumberInput;
	}(_react.PureComponent), _class2.propTypes = {
		// Phone number in E.164 format.
		// E.g. "+12223333333" for USA.
		value: _propTypes2.default.string,
	
		// `onChange` handler is called each time
		// the phone number `<input/>` is edited.
		onChange: _propTypes2.default.func.isRequired,
	
		// `onBlur` is usually passed by `redux-form`.
		onBlur: _propTypes2.default.func,
	
		// `onKeyDown` handler (e.g. to handle Enter key press).
		onKeyDown: _propTypes2.default.func,
	
		// Some people requested an `onCountryChange` event listener.
		// No valid reason was given other than compliance with some legacy code
		// which stored both phone number and country in a database.
		// https://github.com/catamphetamine/react-phone-number-input/issues/128
		onCountryChange: _propTypes2.default.func,
	
		// Disables both the phone number `<input/>`
		// and the country `<select/>`.
		// (is `false` by default)
		disabled: _propTypes2.default.bool.isRequired,
	
		// Web browser's "autocomplete" feature
		// remembers the phone number being input
		// and can also autofill the `<input/>`
		// with previously remembered phone numbers.
		//
		// Default value: "tel".
		//
		// https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
		//
		// "So when should you use autocomplete="off"?
		//  One example is when you've implemented your own version
		//  of autocomplete for search. Another example is any form field
		//  where users will input and submit different kinds of information
		//  where it would not be useful to have the browser remember
		//  what was submitted previously".
		//
		autoComplete: _propTypes2.default.string.isRequired,
	
		// Should the initially passed phone number `value`
		// be converted to a national phone number for its country.
		// (is `false` by default)
		displayInitialValueAsLocalNumber: _propTypes2.default.bool.isRequired,
	
		// The country to be selected by default.
		// Two-letter country code ("ISO 3166-1 alpha-2").
		country: _propTypes2.default.string,
	
		// Only these countries will be available for selection.
		// Includes all countries by default.
		countries: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
	
		// Custom country `<select/>` option names.
		// E.g. `{ ZZ: 'Международный', RU: 'Россия', US: 'США', ... }`
		labels: _propTypes2.default.objectOf(_propTypes2.default.string),
	
		// Country flag icon components.
		// By default flag icons are inserted as `<img/>`s
		// with their `src` pointed to `flag-icon-css` github repo.
		// There might be cases (e.g. an offline application)
		// where having a large (3 megabyte) `<svg/>` flags
		// bundle is more appropriate.
		// `import flags from 'react-phone-number-input/flags'`.
		flags: _propTypes2.default.objectOf(_propTypes2.default.func),
	
		// Flag icon component.
		flagComponent: _propTypes2.default.func.isRequired,
	
		// A base URL path for national flag SVG icons.
		// By default it uses the ones from `flag-icon-css` github repo.
		flagsPath: _propTypes2.default.string.isRequired,
	
		// Whether to add the "International" option
		// to the list of countries.
		// By default it's added if the list of `countries` hasn't been overridden.
		international: _propTypes2.default.bool,
	
		// Custom "International" country `<select/>` option icon.
		internationalIcon: _propTypes2.default.func.isRequired,
	
		// Whether to show country `<select/>`.
		// (is `true` by default)
		showCountrySelect: _propTypes2.default.bool.isRequired,
	
		// HTML `tabindex` attribute for the country `<select/>`.
		countrySelectTabIndex: _propTypes2.default.number,
	
		// `<Phone/>` component CSS style object.
		style: _propTypes2.default.object,
	
		// `<Phone/>` component CSS class.
		className: _propTypes2.default.string,
	
		// `<input/>` CSS class.
		// Both for the phone number `<input/>` and
		// `react-responsive-ui` `<Select/>` autocomplete input.
		inputClassName: _propTypes2.default.string,
	
		// Returns phone number `<input/>` CSS class string.
		// Receives an object of shape `{ disabled : boolean?, invalid : boolean? }`.
		getInputClassName: _propTypes2.default.func,
	
		// Country `<select/>` component.
		//
		// Receives properties:
		//
		// * `name : string?` — HTML `name` attribute.
		// * `value : string?` — The currently selected country code.
		// * `onChange(value : string?)` — Updates the `value`.
		// * `options : object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value : string?, label : string, icon : React.Component }`.
		// * `disabled : boolean?` — HTML `disabled` attribute.
		// * `tabIndex : (number|string)?` — HTML `tabIndex` attribute.
		// * `className : string` — CSS class name.
		//
		// Optional properties (should be ignored unless needed):
		//
		// * `hidePhoneInputField(hide : boolean)` — Can be called to show/hide phone input field. Takes `hide : boolean` argument. E.g. `react-responsive-ui` `<Select/>` uses this to hide phone number input when country select is expanded.
		// * `focusPhoneInputField()` — Can be called to manually focus phone input field. E.g. `react-responsive-ui` `<Select/>` uses this to focus phone number input after country selection in a timeout (after the phone input field is no longer hidden).
		//
		countrySelectComponent: _propTypes2.default.func.isRequired,
	
		// Phone number `<input/>` component.
		//
		// Receives properties:
		//
		// * `value : string` — The parsed phone number. E.g.: `""`, `"+"`, `"+123"`, `"123"`.
		// * `onChange(value : string)` — Updates the `value`.
		// * `country : string?` — The currently selected country. `undefined` means "International" (no country selected).
		// * `metadata : object` — `libphonenumber-js` metadata.
		// * All other properties should be passed through to the underlying `<input/>`.
		//
		// Must also implement `.focus()` method.
		//
		inputComponent: _propTypes2.default.func,
	
		// Set to `false` to use `inputComponent={InputBasic}`
		// instead of `input-format`'s `<ReactInput/>`.
		// Is `true` by default.
		smartCaret: _propTypes2.default.bool.isRequired,
	
		// For example, `react-responsive-ui` `<Select/>`
		// hides the phone number input field when expanded.
		// Is `false` by default.
		countrySelectHidesPhoneInputField: _propTypes2.default.bool.isRequired,
	
		// Phone number extension element.
		ext: _propTypes2.default.node,
	
		// An error message shown below the phone number `<input/>`.
		error: _propTypes2.default.string,
	
		// The `error` is shown only when `indicateInvalid` is true.
		indicateInvalid: _propTypes2.default.bool,
	
		// Translation.
		locale: _propTypes2.default.objectOf(_propTypes2.default.string),
	
		// `libphonenumber-js` metadata
		metadata: _propTypes2.default.shape({
			country_calling_codes: _propTypes2.default.object.isRequired,
			countries: _propTypes2.default.object.isRequired
		}).isRequired
	}, _class2.defaultProps = {
		// Not disabled.
		disabled: false,
	
		// Remember (and autofill) the value as a phone number.
		autoComplete: 'tel',
	
		// Include all countries.
		countries: _countries.countries,
	
		// Flag icon component.
		flagComponent: _Flag2.default,
	
		// By default use icons from `flag-icon-css` github repo.
		flagsPath: 'https://lipis.github.io/flag-icon-css/flags/4x3/',
	
		// Default "International" country `<select/>` option icon (globe).
		internationalIcon: _InternationalIcon2.default,
	
		// Show country `<select/>`.
		showCountrySelect: true,
	
		// Don't convert the initially passed phone number `value`
		// to a national phone number for its country.
		// The reason is that the newer generation grows up when
		// there are no stationary phones and therefore everyone inputs
		// phone numbers with a `+` in their smartphones
		// so phone numbers written in international form
		// are gradually being considered more natural than local ones.
		displayInitialValueAsLocalNumber: false,
	
		// Set to `false` to use `inputComponent={InputBasic}`
		// instead of `input-format`'s `<ReactInput/>`.
		// Is `true` by default.
		smartCaret: true,
	
		// `react-responsive-ui` `<Select/>` sets this to true
		// to hide the phone number input field when expanded.
		countrySelectHidesPhoneInputField: false
	}, _initialiseProps = function _initialiseProps() {
		var _this2 = this;
	
		this.onCountrySelected = function (new_country) {
			var _props2 = _this2.props,
			    metadata = _props2.metadata,
			    onChange = _props2.onChange,
			    countrySelectHidesPhoneInputField = _props2.countrySelectHidesPhoneInputField;
			var _state2 = _this2.state,
			    old_parsed_input = _state2.parsed_input,
			    old_country = _state2.country;
	
			// After the new `country` has been selected,
			// if the phone number `<input/>` holds any digits
			// then migrate those digits for the new `country`.
	
			var new_parsed_input = (0, _inputControl.migrateParsedInputForNewCountry)(old_parsed_input, old_country, new_country, metadata);
	
			var new_value = (0, _inputControl.e164)(new_parsed_input, new_country, metadata);
	
			_this2.onCountryChange(new_country);
	
			// Focus the phone number `<input/>` upon country selection.
			// The default behaviour.
			if (!countrySelectHidesPhoneInputField) {
				_this2.focus();
			}
	
			_this2.setState({
				country: new_country,
				hasChangedCountry: true,
				parsed_input: new_parsed_input,
				value: new_value
			}, function () {
				// Update the new `value` property.
				// Doing it after the `state` has been updated
				// because `onChange()` will trigger `getDerivedStateFromProps()`
				// with the new `value` which will be compared to `state.value` there.
				onChange(new_value);
	
				// Focus the phone number `<input/>` upon country selection.
				// Doing it in a `setState()` callback because the phone number
				// `<input/>` is hidden while country `<select/>` is expanded.
				if (countrySelectHidesPhoneInputField) {
					_this2.focus();
				}
			});
		};
	
		this.onPhoneNumberKeyDown = function (event) {
			var onKeyDown = _this2.props.onKeyDown;
	
			// Actually "Down arrow" key is used for showing "autocomplete" ("autofill") options.
			// (e.g. previously entered phone numbers for `autoComplete="tel"`)
			// // Expand country `<select/>`` on "Down arrow" key press.
			// if (event.keyCode === 40) {
			// 	this.country_select.toggle()
			// }
	
			if (onKeyDown) {
				onKeyDown(event);
			}
		};
	
		this.onChange = function (parsed_input) {
			var _props3 = _this2.props,
			    onChange = _props3.onChange,
			    countries = _props3.countries,
			    international = _props3.international,
			    metadata = _props3.metadata;
			var country = _this2.state.country;
	
	
			if (parsed_input) {
				// If the phone number being input is an international one
				// then tries to derive the country from the phone number.
				// (regardless of whether there's any country currently selected)
				if (parsed_input[0] === '+') {
					country = (0, _inputControl.getCountryForParsedInput)(parsed_input, country, countries, international, metadata);
	
					_this2.onCountryChange(country);
				}
				// If this `onChange()` event was triggered
				// as a result of selecting "International" country
				// then force-prepend a `+` sign if the phone number
				// `<input/>` value isn't in international format.
				else if (!country) {
						parsed_input = '+' + parsed_input;
					}
			}
	
			// Generate the new `value` property.
			var value = (0, _inputControl.e164)(parsed_input, country, metadata);
	
			_this2.setState({
				parsed_input: parsed_input,
				value: value,
				country: country
			},
			// Update the new `value` property.
			// Doing it after the `state` has been updated
			// because `onChange()` will trigger `getDerivedStateFromProps()`
			// with the new `value` which will be compared to `state.value` there.
			function () {
				return onChange(value);
			});
		};
	
		this.onBlur = function (event) {
			var onBlur = _this2.props.onBlur;
			var value = _this2.state.value;
	
	
			if (!onBlur) {
				return;
			}
	
			// `event` is React's `SyntheticEvent`.
			// Its `.value` is read-only therefore cloning it.
			var _event = _extends({}, event, {
				target: _extends({}, event.target, {
					value: value
				})
	
				// For `redux-form` event detection.
				// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
			});_event.stopPropagation = event.stopPropagation;
			_event.preventDefault = event.preventDefault;
	
			return onBlur(_event);
		};
	
		this.hidePhoneInputField = function (hide) {
			_this2.setState({
				hidePhoneInputField: hide
			});
		};
	
		this.focus = function () {
			return _this2.number_input.focus();
		};
	
		this.storeCountrySelectInstance = function (_) {
			return _this2.country_select = _;
		};
	
		this.storePhoneNumberInputInstance = function (_) {
			return _this2.number_input = _;
		};
	}, _temp)) || _class;
	
	// Generates country `<select/>` options.
	
	
	exports.default = PhoneNumberInput;
	function generate_country_select_options(props) {
		var countries = props.countries,
		    labels = props.labels,
		    international = props.international;
	
	
		return (0, _inputControl.getCountrySelectOptions)(countries, labels, international).map(function (_ref) {
			var value = _ref.value,
			    label = _ref.label;
			return {
				value: value,
				label: label,
				icon: createCountrySelectOptionIconComponent(value, label, props)
			};
		});
	}
	
	function createCountrySelectOptionIconComponent(value, label, props) {
		var flags = props.flags,
		    flagsPath = props.flagsPath,
		    FlagComponent = props.flagComponent,
		    InternationalIcon = props.internationalIcon;
	
	
		if (value) {
			return function (props) {
				return _react2.default.createElement(FlagComponent, {
					country: value,
					flags: flags,
					flagsPath: flagsPath,
					className: props ? props.className : undefined });
			};
		}
	
		return function (props) {
			return _react2.default.createElement(
				'div',
				{
					className: (0, _classnames2.default)('react-phone-number-input__icon', 'react-phone-number-input__icon--international', props && props.className) },
				_react2.default.createElement(InternationalIcon, null)
			);
		};
	}
	
	function generateParsedInput(value, parsed_number, props) {
		var displayInitialValueAsLocalNumber = props.displayInitialValueAsLocalNumber,
		    metadata = props.metadata;
	
		// If the `value` (E.164 phone number)
		// belongs to the currently selected country
		// and `displayInitialValueAsLocalNumber` property is `true`
		// then convert `value` (E.164 phone number)
		// to a local phone number digits.
		// E.g. '+78005553535' -> '88005553535'.
	
		if (displayInitialValueAsLocalNumber && parsed_number.country) {
			return (0, _inputControl.generateNationalNumberDigits)(parsed_number, metadata);
		}
	
		return value;
	}
	//# sourceMappingURL=PhoneInput.js.map

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metadata = __webpack_require__(960);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _PhoneInputReactResponsiveUI = __webpack_require__(2781);
	
	var _PhoneInputReactResponsiveUI2 = _interopRequireDefault(_PhoneInputReactResponsiveUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneInputReactResponsiveUIDefaultMetadata = function (_Component) {
		_inherits(PhoneInputReactResponsiveUIDefaultMetadata, _Component);
	
		function PhoneInputReactResponsiveUIDefaultMetadata() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhoneInputReactResponsiveUIDefaultMetadata);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputReactResponsiveUIDefaultMetadata.__proto__ || Object.getPrototypeOf(PhoneInputReactResponsiveUIDefaultMetadata)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PhoneInputReactResponsiveUIDefaultMetadata, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_PhoneInputReactResponsiveUI2.default, _extends({}, this.props, {
					ref: this.storeInputRef,
					metadata: _metadata2.default }));
			}
	
			// Proxy `.focus()` method.
	
		}, {
			key: 'focus',
			value: function focus() {
				return this.input.focus();
			}
		}]);
	
		return PhoneInputReactResponsiveUIDefaultMetadata;
	}(_react.Component);
	
	exports.default = PhoneInputReactResponsiveUIDefaultMetadata;
	//# sourceMappingURL=PhoneInputReactResponsiveUIDefaultMetadata.js.map

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.countries = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); // A list of all country names
	// sorted by country code.
	
	
	var _countries = __webpack_require__(2294);
	
	var _countries2 = _interopRequireDefault(_countries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A list of all country codes.
	var countries = exports.countries = [];
	
	// Country code to country name map.
	var default_country_names = {
		// From ISO 3166-1:2006(E/F):
		//
		// 8.1.3   User-assigned code elements
		//
		// If users need code elements to represent country names not included
		// in this part of ISO 3166, the series of letters AA, QM to QZ, XA
		// to XZ, and ZZ, and the series AAA to AAZ, QMA to QZZ, XAA to XZZ,
		// and ZZA to ZZZ respectively, and the series of numbers 900 to 999
		// are available. These users should inform the ISO 3166/MA of such use.
		//
		ZZ: 'International'
	
		// Populate country codes and country names.
	};for (var _iterator = _countries2.default, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;
	
		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}
	
		var country = _ref;
	
		var _country = _slicedToArray(country, 2),
		    code = _country[0],
		    name = _country[1];
	
		countries.push(code);
		default_country_names[code] = name;
	}
	
	exports.default = default_country_names;
	//# sourceMappingURL=countries.js.map

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formatPhoneNumber;
	
	var _custom = __webpack_require__(972);
	
	/**
	 * Formats a (possibly incomplete) phone number.
	 * The phone number can be either in E.164 format
	 * or in a form of national number digits.
	 * Is used for `input-format`'s `format()` function.
	 * https://github.com/catamphetamine/input-format
	 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
	 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
	 * @return {object} `{ text : string, template : string }`
	 */
	function formatPhoneNumber(value, country, metadata) {
	  // "As you type" formatter.
	  var formatter = new _custom.AsYouType(country, metadata);
	
	  // Format the number.
	  var text = formatter.input(value);
	
	  return { text: text, template: formatter.template };
	}
	//# sourceMappingURL=formatPhoneNumber.js.map

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = parsePhoneNumberCharacters;
	exports.parsePhoneNumberCharacter = parsePhoneNumberCharacter;
	
	var _inputFormat = __webpack_require__(954);
	
	/**
	 * Parses phone number characters from a string.
	 * @param  {string} string
	 * @return {string}
	 * @example
	 * ```js
	 * parsePhoneNumberCharacters('8 (800) 555')
	 * // Outputs '8800555'.
	 * parsePhoneNumberCharacters('+7 800 555')
	 * // Outputs '+7800555'.
	 * ```
	 */
	function parsePhoneNumberCharacters(string) {
		var result = '';
	
		// Using `.split('')` here instead of normal `for ... of`
		// because the importing application doesn't neccessarily include an ES6 polyfill.
		// The `.split('')` approach discards "exotic" UTF-8 characters
		// (the ones consisting of four bytes) but digits
		// (including non-European ones) don't fall into that range
		// so such "exotic" characters would be discarded anyway.
		for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var character = _ref;
	
			result += parsePhoneNumberCharacter(character, result) || '';
		}
	
		return result;
	}
	
	/**
	 * `input-format` `parse()` function.
	 * https://github.com/catamphetamine/input-format
	 * @param  {string} character - Yet another character from raw input string.
	 * @param  {string} value - The value parsed so far.
	 * @param  {object} meta - Optional custom use-case-specific metadata.
	 * @return {string?} The parsed character.
	 */
	function parsePhoneNumberCharacter(character, value) {
		// Only allow a leading `+`.
		if (character === '+') {
			// If this `+` is not the first parsed character
			// then discard it.
			if (value) {
				return;
			}
	
			return '+';
		}
	
		// Allow digits.
		return (0, _inputFormat.parseDigit)(character);
	}
	//# sourceMappingURL=parsePhoneNumberCharacters.js.map

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoundShape = (_temp = _class = function (_React$Component) {
	  _inherits(RoundShape, _React$Component);
	
	  function RoundShape() {
	    _classCallCheck(this, RoundShape);
	
	    return _possibleConstructorReturn(this, (RoundShape.__proto__ || Object.getPrototypeOf(RoundShape)).apply(this, arguments));
	  }
	
	  _createClass(RoundShape, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          color = _props.color;
	
	
	      var defaultStyles = {
	        backgroundColor: color,
	        borderRadius: '500rem',
	        width: '100%',
	        height: '100%'
	      };
	
	      var classes = ['round-shape', className].filter(function (c) {
	        return c;
	      }).join(' ');
	
	      return _react2.default.createElement('div', { className: classes, style: _extends({}, defaultStyles, style) });
	    }
	  }]);
	
	  return RoundShape;
	}(_react2.default.Component), _class.propTypes = {
	  color: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	}, _temp);
	exports.default = RoundShape;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextRow = __webpack_require__(1258);
	
	var _TextRow2 = _interopRequireDefault(_TextRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextBlock = (_temp2 = _class = function (_React$Component) {
	  _inherits(TextBlock, _React$Component);
	
	  function TextBlock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextBlock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextBlock.__proto__ || Object.getPrototypeOf(TextBlock)).call.apply(_ref, [this].concat(args))), _this), _this.getRowStyle = function (i) {
	      var _this$props = _this.props,
	          rows = _this$props.rows,
	          color = _this$props.color,
	          widths = _this$props.widths;
	
	
	      return {
	        backgroundColor: color,
	        maxHeight: 100 / (rows * 2 - 1) + '%',
	        width: widths[(i + widths.length) % widths.length] + '%'
	      };
	    }, _this.getRows = function () {
	      var _this$props2 = _this.props,
	          rows = _this$props2.rows,
	          lineSpacing = _this$props2.lineSpacing;
	
	      var range = [].concat(_toConsumableArray(Array(rows)));
	      return range.map(function (x, i) {
	        return _react2.default.createElement(_TextRow2.default, {
	          style: _this.getRowStyle(i),
	          lineSpacing: i !== 0 ? lineSpacing : 0,
	          key: i
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TextBlock, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          className = _props.className;
	
	
	      var classes = ['text-block', className].filter(function (c) {
	        return c;
	      }).join(' ');
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, style: _extends({}, style, { width: '100%' }) },
	        this.getRows()
	      );
	    }
	  }]);
	
	  return TextBlock;
	}(_react2.default.Component), _class.propTypes = {
	  rows: _propTypes2.default.number.isRequired,
	  color: _propTypes2.default.string.isRequired,
	  lineSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  widths: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _class.defaultProps = {
	  widths: [97, 100, 94, 90, 98, 95, 98, 40]
	}, _temp2);
	exports.default = TextBlock;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TextRow = (_temp = _class = function (_React$Component) {
	  _inherits(TextRow, _React$Component);
	
	  function TextRow() {
	    _classCallCheck(this, TextRow);
	
	    return _possibleConstructorReturn(this, (TextRow.__proto__ || Object.getPrototypeOf(TextRow)).apply(this, arguments));
	  }
	
	  _createClass(TextRow, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          maxHeight = _props.maxHeight,
	          color = _props.color,
	          lineSpacing = _props.lineSpacing,
	          style = _props.style;
	
	
	      var defaultStyles = {
	        maxHeight: maxHeight,
	        width: '100%',
	        height: '1em',
	        backgroundColor: color,
	        marginTop: lineSpacing
	      };
	
	      var classes = ['text-row', className].filter(function (c) {
	        return c;
	      }).join(' ');
	
	      return _react2.default.createElement('div', {
	        className: classes,
	        style: _extends({}, defaultStyles, style)
	      });
	    }
	  }]);
	
	  return TextRow;
	}(_react2.default.Component), _class.propTypes = {
	  className: _propTypes2.default.string,
	  color: _propTypes2.default.string,
	  lineSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  style: _propTypes2.default.object
	}, _class.defaultProps = {
	  lineSpacing: '0.7em'
	}, _temp);
	exports.default = TextRow;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));
	
	    _this.state = { active: false };
	    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    _this.portal = null;
	    _this.node = null;
	    return _this;
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mouseup', this.handleOutsideMouseClick);
	        document.addEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal(newProps);
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
	        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal(true);
	    }
	  }, {
	    key: 'handleWrapperClick',
	    value: function handleWrapperClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      if (this.state.active) {
	        return;
	      }
	      this.openPortal();
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      this.setState({ active: true });
	      this.renderPortal(props);
	      this.props.onOpen(this.node);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      var _this2 = this;
	
	      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
	        if (_this2.node) {
	          _reactDom2.default.unmountComponentAtNode(_this2.node);
	          document.body.removeChild(_this2.node);
	        }
	        _this2.portal = null;
	        _this2.node = null;
	
	        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;
	
	        if (finalIsUnmounted !== true) {
	          _this2.setState({ active: false });
	        }
	      };
	
	      if (this.state.active) {
	        if (this.props.beforeClose) {
	          this.props.beforeClose(this.node, resetPortalState);
	        } else {
	          resetPortalState();
	        }
	
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	
	      var root = (0, _reactDom.findDOMNode)(this.portal);
	      if (root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        document.body.appendChild(this.node);
	      }
	
	      var children = props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof props.children.type === 'function') {
	        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.element.isRequired,
	  openByClickOn: _propTypes2.default.element,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  isOpened: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  beforeClose: _propTypes2.default.func,
	  onUpdate: _propTypes2.default.func
	};
	
	Portal.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {},
	  onUpdate: function onUpdate() {}
	};
	module.exports = exports['default'];


/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createModelActions = createModelActions;
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _identity = __webpack_require__(199);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _getValue = __webpack_require__(253);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isMulti = __webpack_require__(346);
	
	var _isMulti2 = _interopRequireDefault(_isMulti);
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _track = __webpack_require__(255);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStrategies = {
	  get: _get3.default,
	  getValue: _getValue2.default,
	  splice: _icepick2.default.splice,
	  merge: _icepick2.default.merge,
	  remove: _icepick2.default.dissoc,
	  push: _icepick2.default.push,
	  length: function length(value) {
	    return value.length;
	  },
	  object: {},
	  array: []
	};
	
	function optionsFromArgs(args, index) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (typeof index === 'undefined') return undefined;
	
	  return _extends({}, options, args[index]);
	}
	
	function createModelActions() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategies;
	
	  var change = function change(model, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    // option defaults
	    var changeOptions = _extends({
	      silent: false,
	      multi: (0, _isMulti2.default)(model),
	      external: true
	    }, options);
	
	    if (typeof value === 'function') {
	      return function (dispatch, getState) {
	        var modelValue = s.get(getState(), model);
	
	        return dispatch(change(model, value(modelValue), options));
	      };
	    }
	
	    return _extends({
	      type: _actionTypes2.default.CHANGE,
	      model: model,
	      value: s.getValue(value)
	    }, changeOptions);
	  };
	
	  function createModifierAction(modifier, defaultValue, optionsIndex, getOptions) {
	    var actionCreator = function actionCreator(model) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return function (dispatch, getState) {
	        var modelValue = s.get(getState(), model, defaultValue);
	        var value = modifier.apply(undefined, [modelValue].concat(args));
	
	        var options = getOptions ? getOptions.apply(undefined, [value].concat(args)) : undefined;
	
	        dispatch(change(model, value, optionsFromArgs(args, optionsIndex - 1, options)));
	      };
	    };
	
	    return actionCreator;
	  }
	
	  var xor = createModifierAction(function (value, item) {
	    var iteratee = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (_item) {
	      return _item === item;
	    };
	
	    var valueWithoutItem = value.filter(function (_item) {
	      return !iteratee(_item);
	    });
	
	    return s.length(value) === s.length(valueWithoutItem) ? s.push(value, item) : valueWithoutItem;
	  }, s.array, 3);
	
	  var push = createModifierAction(function (value, item) {
	    return s.push(value || s.array, item);
	  }, s.array, 2);
	
	  var toggle = createModifierAction(function (value) {
	    return !value;
	  }, undefined, 1);
	
	  var checkWithValue = function checkWithValue(model, value) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    var currentValue = options.currentValue;
	
	
	    if ((0, _isMulti2.default)(model)) {
	      var valueWithItem = currentValue || s.array;
	      var valueWithoutItem = (valueWithItem || s.array).filter(function (item) {
	        return item !== value;
	      });
	      var multiValue = s.length(valueWithoutItem) === s.length(valueWithItem) ? s.push(valueWithItem, value) : valueWithoutItem;
	
	      return change(model, multiValue);
	    }
	
	    if (typeof value === 'undefined') {
	      return change(model, !currentValue);
	    }
	    return change(model, value);
	  };
	
	  var check = function check(model, value) {
	    return function (dispatch, getState) {
	      var modelValue = s.get(getState(), model);
	
	      var action = checkWithValue(model, value, {
	        currentValue: modelValue
	      });
	
	      dispatch(action);
	    };
	  };
	
	  var filter = createModifierAction(function (value, iteratee) {
	    return value.filter(iteratee);
	  }, s.array, 2);
	
	  var reset = function reset(model) {
	    return {
	      type: _actionTypes2.default.RESET,
	      model: model
	    };
	  };
	
	  var map = createModifierAction(function (value) {
	    var iteratee = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity2.default;
	    return value.map(iteratee);
	  }, s.array, 2);
	
	  var remove = createModifierAction(function (value, index) {
	    return s.splice(value, index, 1);
	  }, s.array, 2, function (_, index) {
	    return { removeKeys: [index] };
	  });
	
	  var move = createModifierAction(function (value, indexFrom, indexTo) {
	    if (indexFrom >= s.length(value) || indexTo >= s.length(value)) {
	      throw new Error('Error moving array item: invalid bounds ' + indexFrom + ', ' + indexTo);
	    }
	
	    var item = s.get(value, indexFrom);
	    var removed = s.splice(value, indexFrom, 1);
	    var inserted = s.splice(removed, indexTo, 0, item);
	
	    return inserted;
	  }, s.array, 3);
	
	  var merge = createModifierAction(s.merge, {}, 3);
	
	  var omit = createModifierAction(function (value) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	    var propsArray = typeof props === 'string' ? [props] : props;
	
	    var newValue = propsArray.reduce(function (acc, prop) {
	      return s.remove(acc, prop);
	    }, value);
	
	    return newValue;
	  }, {}, 2, function (_, props) {
	    return { removeKeys: props };
	  });
	
	  var load = function load(model, values, options) {
	    return change(model, values, _extends({
	      silent: true,
	      load: true
	    }, options));
	  };
	
	  return (0, _mapValues2.default)({
	    change: change,
	    xor: xor,
	    push: push,
	    toggle: toggle,
	    check: check,
	    checkWithValue: checkWithValue,
	    filter: filter,
	    reset: reset,
	    map: map,
	    remove: remove,
	    move: move,
	    merge: merge,
	    omit: omit,
	    load: load
	  }, _track.trackable);
	}
	
	exports.default = createModelActions();

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createErrorsClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _map = __webpack_require__(1269);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _iteratee = __webpack_require__(510);
	
	var _iteratee2 = _interopRequireDefault(_iteratee);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _omit = __webpack_require__(200);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _getForm = __webpack_require__(251);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _getFieldFromState = __webpack_require__(250);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _getModel = __webpack_require__(252);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _isValid = __webpack_require__(247);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _resolveModel = __webpack_require__(347);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _shallowEqual = __webpack_require__(201);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultStrategy = {
	  get: _get3.default,
	  getForm: _getForm2.default,
	  getFieldFromState: _getFieldFromState2.default
	};
	
	var propTypes = {
	  // Computed props
	  modelValue: _propTypes2.default.any,
	  formValue: _propTypes2.default.object,
	  fieldValue: _propTypes2.default.object,
	
	  // Provided props
	  model: _propTypes2.default.string.isRequired,
	  messages: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func, _propTypes2.default.bool])),
	  show: _propTypes2.default.any,
	  wrapper: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func, _propTypes2.default.element]),
	  dispatch: _propTypes2.default.func,
	  dynamic: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
	  store: _propTypes2.default.shape({
	    subscribe: _propTypes2.default.func,
	    dispatch: _propTypes2.default.func,
	    getState: _propTypes2.default.func
	  }),
	  storeSubscription: _propTypes2.default.any
	};
	
	function showErrors(field, form) {
	  var show = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (typeof show === 'function') {
	    return show(field, form);
	  }
	
	  if (!Array.isArray(show) && (typeof show === 'undefined' ? 'undefined' : _typeof(show)) !== 'object' && typeof show !== 'string') {
	    return !!show;
	  }
	
	  return (0, _iteratee2.default)(show)(field);
	}
	
	function createErrorsClass() {
	  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultStrategy;
	
	  var Errors = function (_Component) {
	    _inherits(Errors, _Component);
	
	    function Errors() {
	      _classCallCheck(this, Errors);
	
	      return _possibleConstructorReturn(this, (Errors.__proto__ || Object.getPrototypeOf(Errors)).apply(this, arguments));
	    }
	
	    _createClass(Errors, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var fieldValue = nextProps.fieldValue,
	            formValue = nextProps.formValue;
	        var dynamic = this.props.dynamic;
	
	
	        if (dynamic) {
	          return !(0, _shallowEqual2.default)(this.props, nextProps);
	        }
	
	        return fieldValue !== this.props.fieldValue || formValue !== this.props.formValue;
	      }
	    }, {
	      key: 'mapErrorMessages',
	      value: function mapErrorMessages(errors) {
	        var _this2 = this;
	
	        var messages = this.props.messages;
	
	
	        if (typeof errors === 'string') {
	          return this.renderError(errors, 'error');
	        }
	
	        if (!errors) return null;
	
	        return (0, _map2.default)(errors, function (error, key) {
	          var message = messages[key];
	
	          if (error) {
	            if (message || typeof error === 'string') {
	              return _this2.renderError(message || error, key);
	            } else if ((0, _isPlainObject2.default)(error)) {
	              return _this2.mapErrorMessages(error);
	            }
	          }
	
	          return false;
	        }).reduce(function (a, b) {
	          return b ? a.concat(b) : a;
	        }, []);
	      }
	    }, {
	      key: 'renderError',
	      value: function renderError(message, key) {
	        var _props = this.props,
	            component = _props.component,
	            model = _props.model,
	            modelValue = _props.modelValue,
	            fieldValue = _props.fieldValue,
	            errors = _props.fieldValue.errors;
	
	
	        var errorProps = {
	          key: key,
	          model: model,
	          modelValue: modelValue,
	          fieldValue: fieldValue
	        };
	
	        var messageString = typeof message === 'function' ? message(modelValue, errors[key]) : message;
	
	        if (!messageString) return null;
	
	        var allowedProps = typeof component === 'function' ? errorProps : { key: key };
	
	        return _react2.default.createElement(component, allowedProps, messageString);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props2 = this.props,
	            fieldValue = _props2.fieldValue,
	            formValue = _props2.formValue,
	            show = _props2.show,
	            wrapper = _props2.wrapper;
	
	
	        var allowedProps = typeof wrapper === 'function' ? this.props : (0, _omit2.default)(this.props, Object.keys(propTypes));
	
	        if (!showErrors(fieldValue, formValue, show)) {
	          return null;
	        }
	
	        var errorMessages = (0, _isValid2.default)(fieldValue) ? null : this.mapErrorMessages(fieldValue.errors);
	
	        if (!errorMessages) return null;
	
	        return _react2.default.createElement(wrapper, allowedProps, errorMessages);
	      }
	    }]);
	
	    return Errors;
	  }(_react.Component);
	
	   false ? Errors.propTypes = propTypes : void 0;
	
	  Errors.defaultProps = {
	    wrapper: 'div',
	    component: 'span',
	    messages: {},
	    show: true,
	    dynamic: true
	  };
	
	  function mapStateToProps(state, _ref) {
	    var model = _ref.model;
	
	    var modelString = (0, _getModel2.default)(model, state);
	
	    var form = s.getForm(state, modelString);
	    (0, _invariant2.default)(form, 'Unable to retrieve errors. ' + 'Could not find form for "%s" in the store.', modelString);
	
	    var formValue = form.$form;
	    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
	
	    return {
	      model: modelString,
	      modelValue: s.get(state, modelString),
	      formValue: formValue,
	      fieldValue: fieldValue
	    };
	  }
	
	  return (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Errors));
	}
	
	exports.createErrorsClass = createErrorsClass;
	exports.default = createErrorsClass();

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _getModel = __webpack_require__(252);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _omit = __webpack_require__(200);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _resolveModel = __webpack_require__(347);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  model: _propTypes2.default.string.isRequired,
	  component: _propTypes2.default.any,
	  dispatch: _propTypes2.default.func,
	  store: _propTypes2.default.shape({
	    subscribe: _propTypes2.default.func,
	    dispatch: _propTypes2.default.func,
	    getState: _propTypes2.default.func
	  }),
	  storeSubscription: _propTypes2.default.any
	};
	
	var Fieldset = function (_Component) {
	  _inherits(Fieldset, _Component);
	
	  function Fieldset() {
	    _classCallCheck(this, Fieldset);
	
	    return _possibleConstructorReturn(this, (Fieldset.__proto__ || Object.getPrototypeOf(Fieldset)).apply(this, arguments));
	  }
	
	  _createClass(Fieldset, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return { model: this.props.model };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var component = this.props.component;
	
	
	      var allowedProps = (0, _omit2.default)(this.props, Object.keys(propTypes));
	
	      return _react2.default.createElement(component, allowedProps);
	    }
	  }]);
	
	  return Fieldset;
	}(_react.Component);
	
	Fieldset.displayName = 'Fieldset';
	
	Fieldset.childContextTypes = {
	  model: _propTypes2.default.any
	};
	
	 false ? Fieldset.propTypes = propTypes : void 0;
	
	Fieldset.defaultProps = {
	  component: 'div'
	};
	
	function mapStateToProps(state, _ref) {
	  var model = _ref.model;
	
	  var modelString = (0, _getModel2.default)(model, state);
	
	  return {
	    model: modelString
	  };
	}
	
	exports.default = (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Fieldset));

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isValid = exports.track = exports.getModel = exports.getField = exports.form = exports.batched = exports.modeled = exports.createFieldClass = exports.Fieldset = exports.Errors = exports.LocalForm = exports.Form = exports.Control = exports.Field = exports.controls = exports.actionTypes = exports.actions = exports.initialFieldState = exports.createForms = exports.combineForms = exports.modelReducer = exports.formReducer = undefined;
	
	var _actions = __webpack_require__(198);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _fieldComponent = __webpack_require__(2791);
	
	var _fieldComponent2 = _interopRequireDefault(_fieldComponent);
	
	var _fieldsetComponent = __webpack_require__(1262);
	
	var _fieldsetComponent2 = _interopRequireDefault(_fieldsetComponent);
	
	var _controlComponent = __webpack_require__(501);
	
	var _controlComponent2 = _interopRequireDefault(_controlComponent);
	
	var _formComponent = __webpack_require__(502);
	
	var _formComponent2 = _interopRequireDefault(_formComponent);
	
	var _localFormComponent = __webpack_require__(2792);
	
	var _localFormComponent2 = _interopRequireDefault(_localFormComponent);
	
	var _errorsComponent = __webpack_require__(1261);
	
	var _errorsComponent2 = _interopRequireDefault(_errorsComponent);
	
	var _controlPropsMap = __webpack_require__(342);
	
	var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);
	
	var _modeledEnhancer = __webpack_require__(504);
	
	var _modeledEnhancer2 = _interopRequireDefault(_modeledEnhancer);
	
	var _batchedEnhancer = __webpack_require__(503);
	
	var _batchedEnhancer2 = _interopRequireDefault(_batchedEnhancer);
	
	var _formReducer = __webpack_require__(248);
	
	var _formReducer2 = _interopRequireDefault(_formReducer);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _formsReducer = __webpack_require__(505);
	
	var _formsReducer2 = _interopRequireDefault(_formsReducer);
	
	var _modelReducer = __webpack_require__(344);
	
	var _modelReducer2 = _interopRequireDefault(_modelReducer);
	
	var _track = __webpack_require__(255);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _isValid = __webpack_require__(247);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _getFieldFromState = __webpack_require__(250);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _form = __webpack_require__(2794);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.formReducer = _formReducer2.default;
	exports.modelReducer = _modelReducer2.default;
	exports.combineForms = _formsReducer2.default;
	exports.createForms = _formsReducer.createForms;
	exports.initialFieldState = _initialFieldState2.default;
	exports.actions = _actions2.default;
	exports.actionTypes = _actionTypes2.default;
	exports.controls = _controlPropsMap2.default;
	exports.Field = _fieldComponent2.default;
	exports.Control = _controlComponent2.default;
	exports.Form = _formComponent2.default;
	exports.LocalForm = _localFormComponent2.default;
	exports.Errors = _errorsComponent2.default;
	exports.Fieldset = _fieldsetComponent2.default;
	exports.createFieldClass = _fieldComponent.createFieldClass;
	exports.modeled = _modeledEnhancer2.default;
	exports.batched = _batchedEnhancer2.default;
	exports.form = _form2.default;
	exports.getField = _getFieldFromState2.default;
	exports.getModel = _get2.default;
	exports.track = _track2.default;
	exports.isValid = _isValid2.default;

/***/ },
/* 1264 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = arraysEqual;
	function arraysEqual(firstArray, secondArray) {
	  return firstArray && secondArray && firstArray.length === secondArray.length && firstArray.every(function (item, index) {
	    return item === secondArray[index];
	  });
	}

/***/ },
/* 1265 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = containsEvent;
	function containsEvent(events, event) {
	  if (typeof events === 'string') {
	    return events === event;
	  }
	
	  return !!~events.indexOf(event);
	}

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.compareChildren = compareChildren;
	exports.default = deepCompareChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowCompare = __webpack_require__(3253);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _shallowEqual = __webpack_require__(201);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function compareChildren(props, nextProps) {
	  var children = props.children;
	  var nextChildren = nextProps.children;
	
	  // If the number of children changed, then children are different.
	  // If there are no children, use shallowCompare in parent function
	  // to determine if component should update (false && true == false)
	
	  if (_react2.default.Children.count(children) !== _react2.default.Children.count(nextChildren) || !_react2.default.Children.count(children) || !_react2.default.Children.count(nextChildren)) {
	    return true;
	  }
	
	  var childrenArray = _react2.default.Children.toArray(children);
	  var nextChildrenArray = _react2.default.Children.toArray(nextChildren);
	
	  // React.Children.toArray strip's `false` children so lengths
	  // can change
	  if (childrenArray.length !== nextChildrenArray.length) {
	    return false;
	  }
	
	  return [].concat(childrenArray).some(function (child, i) {
	    var nextChild = nextChildrenArray[i];
	
	    if (!child.props || !nextChild.props) {
	      return !(0, _shallowEqual2.default)(child, nextChild);
	    }
	
	    /* eslint-disable no-use-before-define */
	    return deepCompareChildren(child, nextChild.props, nextChild.state);
	  });
	}
	
	function deepCompareChildren(instance, nextProps, nextState) {
	  if (!instance.props.children) return (0, _shallowCompare2.default)(instance, nextProps, nextState);
	
	  return (0, _shallowCompare2.default)(instance, nextProps, nextState) || compareChildren(instance.props, nextProps);
	}

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFormValue;
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _toArray = __webpack_require__(2818);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFormValue(form) {
	  if (form && !form.$form) {
	    return typeof form.loadedValue !== 'undefined' ? form.loadedValue : form.initialValue;
	  }
	
	  var result = (0, _mapValues2.default)(form, function (field, key) {
	    if (key === '$form') return undefined;
	
	    return getFormValue(field);
	  });
	
	  delete result.$form;
	
	  var isArray = form && form.$form && Array.isArray(form.$form.value);
	
	  return isArray ? (0, _toArray2.default)(result) : result;
	}

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValidityValid;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidityValid(validity) {
	  if ((0, _isPlainObject2.default)(validity)) {
	    return Object.keys(validity).every(function (key) {
	      return isValidityValid(validity[key]);
	    });
	  }
	
	  return !!validity;
	}

/***/ },
/* 1269 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = map;
	function map(values, iteratee) {
	  if (Array.isArray(values)) {
	    return values.map(iteratee);
	  }
	
	  var result = Object.keys(values).map(function (key) {
	    return iteratee(values[key], key, values);
	  });
	
	  return result;
	}

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeValidity;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _icepick = __webpack_require__(126);
	
	function mergeValidity(fieldValidity, actionValidity) {
	  if (!(0, _isPlainObject.isObjectLike)(fieldValidity) || !(0, _isPlainObject.isObjectLike)(actionValidity)) {
	    // can't merge string/boolean validity with keyed validity
	    return actionValidity;
	  }
	
	  return (0, _icepick.merge)(fieldValidity, actionValidity);
	}

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(231);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(2829);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(1273);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(1274);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(511);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var cx = _interopDefault(__webpack_require__(7));
	var PropTypes = _interopDefault(__webpack_require__(2835));
	var reactLifecyclesCompat = __webpack_require__(494);
	var Portal = _interopDefault(__webpack_require__(2751));
	var CSSTransition = _interopDefault(__webpack_require__(2902));
	var noScroll = _interopDefault(__webpack_require__(2462));
	
	var CloseIcon = function CloseIcon(_ref) {
	  var classes = _ref.classes,
	      classNames = _ref.classNames,
	      styles = _ref.styles,
	      closeIconSize = _ref.closeIconSize,
	      closeIconSvgPath = _ref.closeIconSvgPath,
	      onClickCloseIcon = _ref.onClickCloseIcon;
	  return React__default.createElement(
	    'button',
	    {
	      className: cx(classes.closeButton, classNames.closeButton),
	      style: styles.closeButton,
	      onClick: onClickCloseIcon
	    },
	    React__default.createElement(
	      'svg',
	      {
	        className: cx(classes.closeIcon, classNames.closeIcon),
	        style: styles.closeIcon,
	        xmlns: 'http://www.w3.org/2000/svg',
	        width: closeIconSize,
	        height: closeIconSize,
	        viewBox: '0 0 36 36'
	      },
	      closeIconSvgPath
	    )
	  );
	};
	
	CloseIcon.propTypes = {
	  classNames: PropTypes.object.isRequired,
	  styles: PropTypes.object.isRequired,
	  classes: PropTypes.object.isRequired,
	  closeIconSize: PropTypes.number.isRequired,
	  closeIconSvgPath: PropTypes.node.isRequired,
	  onClickCloseIcon: PropTypes.func.isRequired
	};
	
	function styleInject(css, ref) {
	  if ( ref === void 0 ) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') { return; }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".styles_overlay__CLSq- {\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  padding: 1.2rem;\n}\n.styles_overlayCenter__YHoO7 {\n  align-items: center;\n}\n.styles_modal__gNwvD {\n  max-width: 800px;\n  position: relative;\n  padding: 1.2rem;\n  background: #ffffff;\n  background-clip: padding-box;\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);\n}\n.styles_closeButton__20ID4 {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  display: flex;\n}\n.styles_closeIcon__1QwbI {\n}\n.styles_transitionEnter__3j_-a {\n  opacity: 0.01;\n}\n.styles_transitionEnterActive___eQs7 {\n  opacity: 1;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.styles_transitionExit__1KmEf {\n  opacity: 1;\n}\n.styles_transitionExitActive__1nQXw {\n  opacity: 0.01;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n";
	var cssClasses = { "overlay": "styles_overlay__CLSq-", "overlayCenter": "styles_overlayCenter__YHoO7", "modal": "styles_modal__gNwvD", "closeButton": "styles_closeButton__20ID4", "closeIcon": "styles_closeIcon__1QwbI", "transitionEnter": "styles_transitionEnter__3j_-a", "transitionEnterActive": "styles_transitionEnterActive___eQs7", "transitionExit": "styles_transitionExit__1KmEf", "transitionExitActive": "styles_transitionExitActive__1nQXw" };
	styleInject(css, { "insertAt": "top" });
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  _createClass(Modal, null, [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (!prevState.showPortal && nextProps.open) {
	        return {
	          showPortal: true
	        };
	      }
	      return null;
	    }
	  }]);
	
	  function Modal(props) {
	    _classCallCheck(this, Modal);
	
	    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));
	
	    _this.handleOpen = function () {
	      _this.blockScroll();
	      document.addEventListener('keydown', _this.handleKeydown);
	    };
	
	    _this.handleClose = function () {
	      _this.unblockScroll();
	      document.removeEventListener('keydown', _this.handleKeydown);
	    };
	
	    _this.handleClickOverlay = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (!_this.shouldClose) {
	        _this.shouldClose = null;
	        return;
	      }
	
	      if (_this.props.onOverlayClick) {
	        _this.props.onOverlayClick(event);
	      }
	
	      if (_this.props.closeOnOverlayClick) {
	        _this.props.onClose(event);
	      }
	
	      _this.shouldClose = null;
	    };
	
	    _this.handleClickCloseIcon = function (event) {
	      _this.props.onClose(event);
	    };
	
	    _this.handleKeydown = function (event) {
	      if (event.keyCode !== 27) {
	        return;
	      }
	
	      if (_this.props.onEscKeyDown) {
	        _this.props.onEscKeyDown(event);
	      }
	
	      if (_this.props.closeOnEsc) {
	        _this.props.onClose(event);
	      }
	    };
	
	    _this.handleModalEvent = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleEntered = function () {
	      if (_this.props.onEntered) {
	        _this.props.onEntered();
	      }
	    };
	
	    _this.handleExited = function () {
	      if (_this.props.onExited) {
	        _this.props.onExited();
	      }
	
	      _this.setState({ showPortal: false });
	      _this.unblockScroll();
	    };
	
	    _this.unblockScroll = function () {
	      var openedModals = document.getElementsByClassName(_this.props.classes.modal);
	      if (openedModals.length === 1) {
	        noScroll.off();
	      }
	    };
	
	    _this.state = {
	      showPortal: props.open
	    };
	    _this.shouldClose = null;
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Block scroll when initial prop is open
	      if (this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.showPortal && !this.state.showPortal) {
	        this.handleClose();
	      } else if (!prevProps.open && this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.open) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: 'blockScroll',
	
	
	    // eslint-disable-next-line class-methods-use-this
	    value: function blockScroll() {
	      noScroll.on();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          open = _props.open,
	          center = _props.center,
	          classes = _props.classes,
	          classNames = _props.classNames,
	          styles = _props.styles,
	          showCloseIcon = _props.showCloseIcon,
	          closeIconSize = _props.closeIconSize,
	          closeIconSvgPath = _props.closeIconSvgPath,
	          animationDuration = _props.animationDuration;
	      var showPortal = this.state.showPortal;
	
	
	      if (!showPortal) {
	        return null;
	      }
	
	      return React__default.createElement(
	        Portal,
	        null,
	        React__default.createElement(
	          CSSTransition,
	          {
	            'in': open,
	            appear: true,
	            classNames: {
	              appear: classNames.transitionEnter || classes.transitionEnter,
	              appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
	              enter: classNames.transitionEnter || classes.transitionEnter,
	              enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
	              exit: classNames.transitionExit || classes.transitionExit,
	              exitActive: classNames.transitionExitActive || classes.transitionExitActive
	            },
	            timeout: animationDuration,
	            onEntered: this.handleEntered,
	            onExited: this.handleExited
	          },
	          React__default.createElement(
	            'div',
	            {
	              className: cx(classes.overlay, center ? classes.overlayCenter : null, classNames.overlay),
	              onClick: this.handleClickOverlay,
	              style: styles.overlay
	            },
	            React__default.createElement(
	              'div',
	              {
	                className: cx(classes.modal, classNames.modal),
	                style: styles.modal,
	                onMouseDown: this.handleModalEvent,
	                onMouseUp: this.handleModalEvent,
	                onClick: this.handleModalEvent
	              },
	              this.props.children,
	              showCloseIcon && React__default.createElement(CloseIcon, {
	                classes: classes,
	                classNames: classNames,
	                styles: styles,
	                closeIconSize: closeIconSize,
	                closeIconSvgPath: closeIconSvgPath,
	                onClickCloseIcon: this.handleClickCloseIcon
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	Modal.propTypes = {
	  /**
	   * Is the modal closable when user press esc key.
	   */
	  closeOnEsc: PropTypes.bool,
	  /**
	   * Is the modal closable when user click on overlay.
	   */
	  closeOnOverlayClick: PropTypes.bool,
	  /**
	   * Callback fired when the Modal is open and the animation is finished.
	   */
	  onEntered: PropTypes.func,
	  /**
	   * Callback fired when the Modal has exited and the animation is finished.
	   */
	  onExited: PropTypes.func,
	  /**
	   * Callback fired when the Modal is requested to be closed by a click on the overlay or when user press esc key.
	   */
	  onClose: PropTypes.func.isRequired,
	  /**
	   * Callback fired when the escape key is pressed.
	   */
	  onEscKeyDown: PropTypes.func,
	  /**
	   * Callback fired when the overlay is clicked.
	   */
	  onOverlayClick: PropTypes.func,
	  /**
	   * Control if the modal is open or not.
	   */
	  open: PropTypes.bool.isRequired,
	  /**
	   * An object containing classNames to style the modal, can have properties 'overlay' (classname for overlay div), 'modal' (classname for modal content div), 'closeButton' (classname for the button that contain the close icon), 'closeIcon' (classname for close icon svg). You can customize the transition with 'transitionEnter', 'transitionEnterActive', 'transitionExit', 'transitionExitActive'
	   */
	  classNames: PropTypes.object,
	  /**
	   * An object containing the styles objects to style the modal, can have properties 'overlay', 'modal', 'closeButton', 'closeIcon'.
	   */
	  styles: PropTypes.object,
	  /**
	   * The content of the modal.
	   */
	  children: PropTypes.node,
	  /**
	   * @internal
	   */
	  classes: PropTypes.object,
	  /**
	   * Is the dialog centered (**when you don't have a lot of content**).
	   */
	  center: PropTypes.bool,
	  /**
	   * Show the close icon.
	   */
	  showCloseIcon: PropTypes.bool,
	  /**
	   * Close icon size.
	   */
	  closeIconSize: PropTypes.number,
	  /**
	   * A valid svg path to show as icon.
	   */
	  closeIconSvgPath: PropTypes.node,
	  /**
	   * Animation duration in milliseconds.
	   */
	  animationDuration: PropTypes.number
	};
	
	Modal.defaultProps = {
	  classes: cssClasses,
	  closeOnEsc: true,
	  closeOnOverlayClick: true,
	  onEntered: null,
	  onExited: null,
	  onEscKeyDown: null,
	  onOverlayClick: null,
	  showCloseIcon: true,
	  closeIconSize: 28,
	  closeIconSvgPath: React__default.createElement('path', { d: 'M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z' }),
	  classNames: {},
	  styles: {},
	  children: null,
	  center: false,
	  animationDuration: 500
	};
	
	reactLifecyclesCompat.polyfill(Modal);
	
	module.exports = Modal;
	//# sourceMappingURL=index.js.map


/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(513);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1278 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.ConnectedRouter = undefined;
	
	var _reducer = __webpack_require__(1280);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(1278);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _ConnectedRouter2 = __webpack_require__(2849);
	
	var _ConnectedRouter3 = _interopRequireDefault(_ConnectedRouter2);
	
	var _middleware = __webpack_require__(2850);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ConnectedRouter = _ConnectedRouter3.default;
	exports.routerMiddleware = _middleware2.default;

/***/ },
/* 1280 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  location: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { location: payload });
	  }
	
	  return state;
	}

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(950);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(348);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(2260);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(187);
	
	var _Router = __webpack_require__(348);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(349);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.MemoryRouter = undefined;
	
	var _MemoryRouter2 = __webpack_require__(1281);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _Prompt2 = __webpack_require__(1282);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(1283);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(513);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(348);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(1284);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(1285);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(349);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(1287);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(231);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(513);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1540);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Autocomplete Search component
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               **/
	
	
	var Search = function (_Component) {
	  _inherits(Search, _Component);
	
	  _createClass(Search, null, [{
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        initialSelected: [],
	        placeholder: '— None',
	        NotFoundPlaceholder: 'Please search for some items...',
	        maxSelected: 100,
	        multiple: false
	      };
	    }
	  }, {
	    key: 'propTypes',
	    get: function get() {
	      return {
	        items: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object).isRequired,
	        initialSelected: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.object)]),
	        onItemsChanged: _react2.default.PropTypes.func,
	        placeholder: _react2.default.PropTypes.string,
	        NotFoundPlaceholder: _react2.default.PropTypes.string,
	        maxSelected: _react2.default.PropTypes.number,
	        multiple: _react2.default.PropTypes.bool,
	        onKeyChange: _react2.default.PropTypes.func,
	        getItemsAsync: _react2.default.PropTypes.func
	      };
	    }
	  }]);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
	
	    _this.state = {
	      menuItems: [],
	      selectedItems: [],
	      searchValue: '',
	      menuVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var initialSelected = this.props.initialSelected;
	
	      if (initialSelected instanceof Array) {
	        this.setSelected(initialSelected);
	      } else {
	        this.addSelected(initialSelected);
	      }
	    }
	  }, {
	    key: 'SearchItemInArrayObjects',
	    value: function SearchItemInArrayObjects(items, input, searchKey) {
	      var reg = new RegExp(input.split('').join('\\w*').replace(/\W/, ''), 'i');
	      return items.filter(function (item) {
	        if (reg.test(item[searchKey])) {
	          return item;
	        }
	      });
	    }
	  }, {
	    key: 'selectMenuItem',
	    value: function selectMenuItem(item) {
	      var multiple = this.props.multiple;
	
	      multiple ? this.addSelected(item) : this.setSelected([item]);
	      this.hideMenu();
	    }
	  }, {
	    key: 'showMenu',
	    value: function showMenu() {
	      this.setState({ menuVisible: true });
	    }
	  }, {
	    key: 'hideMenu',
	    value: function hideMenu() {
	      this.setState({ menuVisible: false });
	      this.resetPlaceholder();
	    }
	  }, {
	    key: 'triggerItemsChanged',
	    value: function triggerItemsChanged() {
	      if (this.props.onItemsChanged !== undefined) {
	        this.props.onItemsChanged(this.state.selectedItems);
	      }
	    }
	  }, {
	    key: 'triggerKeyChange',
	    value: function triggerKeyChange(searchValue) {
	      if (this.props.onKeyChange !== undefined) {
	        this.props.onKeyChange(searchValue);
	      }
	    }
	  }, {
	    key: 'triggerGetItemsAsync',
	    value: function triggerGetItemsAsync(searchValue) {
	      var _this2 = this;
	
	      if (this.props.getItemsAsync !== undefined) {
	        this.props.getItemsAsync(searchValue, function () {
	          _this2.updateSearchValue(searchValue);
	        });
	      }
	    }
	  }, {
	    key: 'setSelected',
	    value: function setSelected(selected) {
	      var _this3 = this;
	
	      this.setState({ selectedItems: selected }, function () {
	        _this3.triggerItemsChanged();
	      });
	    }
	  }, {
	    key: 'addSelected',
	    value: function addSelected(selected) {
	      var _this4 = this;
	
	      var items = this.state.selectedItems;
	      items.push(selected);
	      this.setState({ selectedItems: items }, function () {
	        _this4.triggerItemsChanged();
	      });
	    }
	  }, {
	    key: 'removeSelected',
	    value: function removeSelected(itemId) {
	      var _this5 = this;
	
	      var items = this.state.selectedItems;
	      var itemsUpdated = items.filter(function (i) {
	        return i.id != itemId;
	      });
	      this.setState({ selectedItems: itemsUpdated }, function () {
	        _this5.triggerItemsChanged();
	      });
	    }
	  }, {
	    key: 'updateSearchValue',
	    value: function updateSearchValue(value) {
	      var _this6 = this;
	
	      var items = this.props.items;
	
	      this.setState({ searchValue: value }, function () {
	        var menuItems = _this6.SearchItemInArrayObjects(items, _this6.state.searchValue, 'value');
	        _this6.setMenuItems(menuItems);
	      });
	    }
	  }, {
	    key: 'showAllMenuItems',
	    value: function showAllMenuItems() {
	      var items = this.props.items;
	
	      this.setState({ searchValue: '' });
	      var menuItems = this.SearchItemInArrayObjects(items, '', 'value');
	      this.setMenuItems(menuItems);
	    }
	  }, {
	    key: 'setMenuItems',
	    value: function setMenuItems(items) {
	      var getItemsAsync = this.props.getItemsAsync;
	
	      this.setState({ menuItems: items });
	      if (items.length || getItemsAsync != undefined) {
	        this.showMenu();
	      } else {
	        this.hideMenu();
	      }
	    }
	  }, {
	    key: 'itemSelected',
	    value: function itemSelected(itemId) {
	      var selectedItems = this.state.selectedItems;
	
	      var item = selectedItems.find(function (s) {
	        return s.id === itemId;
	      });
	      return item != undefined ? true : false;
	    }
	  }, {
	    key: 'focusInput',
	    value: function focusInput() {
	      var _this7 = this;
	
	      this.showAllMenuItems();
	      _reactDom2.default.findDOMNode(this.refs.searchInput).placeholder = '';
	      _reactDom2.default.findDOMNode(this.refs.searchInput).value = '';
	      this.blurTimeout = setTimeout(function () {
	        _reactDom2.default.findDOMNode(_this7.refs.searchInput).focus();
	      }, 100);
	    }
	  }, {
	    key: 'blurInput',
	    value: function blurInput() {
	      var _this8 = this;
	
	      this.blurTimeout = setTimeout(function () {
	        _reactDom2.default.findDOMNode(_this8.refs.searchInput).blur();
	        _this8.hideMenu();
	      }, 100);
	    }
	  }, {
	    key: 'resetPlaceholder',
	    value: function resetPlaceholder() {
	      var placeholder = _reactDom2.default.findDOMNode(this.refs.placeholder);
	      placeholder = this.props.placeholder;
	    }
	  }, {
	    key: 'handleRemove',
	    value: function handleRemove(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.removeSelected(e.target.dataset.id);
	    }
	  }, {
	    key: 'handleFocus',
	    value: function handleFocus(e) {
	      this.focusInput();
	    }
	  }, {
	    key: 'handleBlur',
	    value: function handleBlur(e) {
	      this.blurInput();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.focusInput();
	    }
	  }, {
	    key: 'handleItemClick',
	    value: function handleItemClick(e) {
	      this.focusInput();
	    }
	  }, {
	    key: 'handleSelect',
	    value: function handleSelect(e) {
	      var element = e.currentTarget.children[0];
	      var item = { id: parseInt(element.dataset.id), value: element.innerHTML.replace(/&amp;/g, '&') };
	      this.selectMenuItem(item);
	    }
	  }, {
	    key: 'handleKeyChange',
	    value: function handleKeyChange(e) {
	      var getItemsAsync = this.props.getItemsAsync;
	
	      var value = this.refs.searchInput.value;
	      this.triggerKeyChange(value);
	      if (getItemsAsync != undefined) {
	        this.triggerGetItemsAsync(value);
	      } else {
	        this.updateSearchValue(value);
	      }
	    }
	  }, {
	    key: 'renderMenuItems',
	    value: function renderMenuItems() {
	      var _this9 = this;
	
	      var _state = this.state,
	          menuItems = _state.menuItems,
	          selectedItems = _state.selectedItems;
	      var NotFoundPlaceholder = this.props.NotFoundPlaceholder;
	
	      if (!menuItems.length) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'autocomplete__item autocomplete__item--disabled' },
	          _react2.default.createElement(
	            'span',
	            { 'data-id': 0 },
	            NotFoundPlaceholder
	          )
	        );
	      }
	
	      var items = menuItems.map(function (item, i) {
	        if (_this9.itemSelected(item.id)) {
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: 'autocomplete__item autocomplete__item--disabled' },
	            _react2.default.createElement('span', { key: i, 'data-id': item.id, dangerouslySetInnerHTML: { __html: item.value } })
	          );
	        } else {
	          return _react2.default.createElement(
	            'li',
	            { key: i, className: 'autocomplete__item', onClick: _this9.handleSelect.bind(_this9) },
	            _react2.default.createElement('span', { key: i, 'data-id': item.id, dangerouslySetInnerHTML: { __html: item.value } })
	          );
	        }
	      });
	      return items;
	    }
	  }, {
	    key: 'renderSelectedItems',
	    value: function renderSelectedItems() {
	      var _this10 = this;
	
	      var selectedItems = this.state.selectedItems;
	      var _props = this.props,
	          multiple = _props.multiple,
	          placeholder = _props.placeholder;
	
	      if (!selectedItems.length && multiple) return;
	
	      if (!selectedItems.length && !multiple) {
	        return _react2.default.createElement(
	          'li',
	          { className: 'autocomplete__item autocomplete__item--selected autocomplete__item__dropdown',
	            onClick: this.handleItemClick.bind(this) },
	          _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: placeholder } }),
	          _react2.default.createElement('span', { className: 'autocomplete__dropdown' })
	        );
	      }
	
	      var items = selectedItems.map(function (item, i) {
	        var itemClass = 'autocomplete__item autocomplete__item--selected autocomplete__item__dropdown';
	        var dropDown = _react2.default.createElement('span', { className: 'autocomplete__dropdown' });
	        var icon = _react2.default.createElement('span', { 'data-id': item.id, className: 'autocomplete__close',
	          onClick: _this10.handleRemove.bind(_this10) });
	
	        if (multiple) {
	          dropDown = null;
	          itemClass = 'autocomplete__item autocomplete__item--selected';
	        }
	
	        return _react2.default.createElement(
	          'li',
	          { key: i, className: itemClass, onClick: _this10.handleItemClick.bind(_this10) },
	          _react2.default.createElement('span', { 'data-id': item.id, dangerouslySetInnerHTML: { __html: item.value } }),
	          icon,
	          dropDown
	        );
	      });
	      return items;
	    }
	  }, {
	    key: 'renderInput',
	    value: function renderInput() {
	      var _props2 = this.props,
	          maxSelected = _props2.maxSelected,
	          multiple = _props2.multiple;
	      var selectedItems = this.state.selectedItems;
	
	      var inputClass = 'autocomplete__input';
	      if (multiple && selectedItems.length >= maxSelected) {
	        inputClass = 'autocomplete__input autocomplete__input--hidden';
	      }
	
	      return _react2.default.createElement('input', { type: 'text',
	        className: inputClass,
	        ref: 'searchInput',
	        placeholder: this.props.placeholder,
	        onClick: this.handleClick.bind(this),
	        onFocus: this.handleFocus.bind(this),
	        onBlur: this.handleBlur.bind(this),
	        onKeyUp: this.handleKeyChange.bind(this) });
	    }
	  }, {
	    key: 'getMenuClass',
	    value: function getMenuClass() {
	      var _props3 = this.props,
	          maxSelected = _props3.maxSelected,
	          multiple = _props3.multiple;
	      var _state2 = this.state,
	          menuVisible = _state2.menuVisible,
	          selectedItems = _state2.selectedItems;
	
	      var menuClass = 'autocomplete__menu autocomplete__menu--hidden';
	      if (menuVisible && !multiple) {
	        menuClass = 'autocomplete__menu';
	      }
	      if (menuVisible && selectedItems.length < maxSelected) {
	        menuClass = 'autocomplete__menu';
	      }
	      return menuClass;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var multiple = this.props.multiple;
	
	      var menuClass = this.getMenuClass();
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'autocomplete' },
	        _react2.default.createElement(
	          'div',
	          { className: 'autocomplete__selected' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'autocomplete__items' },
	            this.renderSelectedItems()
	          )
	        ),
	        multiple && this.renderInput(),
	        _react2.default.createElement(
	          'div',
	          { className: 'autocomplete__menu--wrap' },
	          _react2.default.createElement(
	            'div',
	            { className: menuClass, ref: 'autocomplete' },
	            !multiple && this.renderInput(),
	            _react2.default.createElement(
	              'ul',
	              { className: 'autocomplete__items' },
	              this.renderMenuItems()
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react.Component);
	
	exports.default = Search;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Select = __webpack_require__(350);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _stripDiacritics = __webpack_require__(1296);
	
	var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
		autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
		cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
		children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
		ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
		ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
		loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
		loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
		_propTypes2.default.string, _propTypes2.default.node]),
		multi: _propTypes2.default.bool, // multi-value input
		noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
		_propTypes2.default.string, _propTypes2.default.node]),
		onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
		onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
		options: _propTypes2.default.array.isRequired, // array of options
		placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
		_propTypes2.default.string, _propTypes2.default.node]),
		searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
		_propTypes2.default.string, _propTypes2.default.node]),
		value: _propTypes2.default.any // initial field value
	};
	
	var defaultCache = {};
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var defaultProps = {
		autoload: true,
		cache: defaultCache,
		children: defaultChildren,
		ignoreAccents: true,
		ignoreCase: true,
		loadingPlaceholder: 'Loading...',
		options: [],
		searchPromptText: 'Type to search'
	};
	
	var Async = function (_Component) {
		_inherits(Async, _Component);
	
		function Async(props, context) {
			_classCallCheck(this, Async);
	
			var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));
	
			_this._cache = props.cache === defaultCache ? {} : props.cache;
	
			_this.state = {
				inputValue: '',
				isLoading: false,
				options: props.options
			};
	
			_this.onInputChange = _this.onInputChange.bind(_this);
			return _this;
		}
	
		_createClass(Async, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var autoload = this.props.autoload;
	
	
				if (autoload) {
					this.loadOptions('');
				}
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (nextProps.options !== this.props.options) {
					this.setState({
						options: nextProps.options
					});
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this._callback = null;
			}
		}, {
			key: 'loadOptions',
			value: function loadOptions(inputValue) {
				var _this2 = this;
	
				var loadOptions = this.props.loadOptions;
	
				var cache = this._cache;
	
				if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
					this._callback = null;
	
					this.setState({
						isLoading: false,
						options: cache[inputValue]
					});
	
					return;
				}
	
				var callback = function callback(error, data) {
					var options = data && data.options || [];
	
					if (cache) {
						cache[inputValue] = options;
					}
	
					if (callback === _this2._callback) {
						_this2._callback = null;
	
						_this2.setState({
							isLoading: false,
							options: options
						});
					}
				};
	
				// Ignore all but the most recent request
				this._callback = callback;
	
				var promise = loadOptions(inputValue, callback);
				if (promise) {
					promise.then(function (data) {
						return callback(null, data);
					}, function (error) {
						return callback(error);
					});
				}
	
				if (this._callback && !this.state.isLoading) {
					this.setState({
						isLoading: true
					});
				}
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(inputValue) {
				var _props = this.props,
				    ignoreAccents = _props.ignoreAccents,
				    ignoreCase = _props.ignoreCase,
				    onInputChange = _props.onInputChange;
	
				var newInputValue = inputValue;
	
				if (onInputChange) {
					var value = onInputChange(newInputValue);
					// Note: != used deliberately here to catch undefined and null
					if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
						newInputValue = '' + value;
					}
				}
	
				var transformedInputValue = newInputValue;
	
				if (ignoreAccents) {
					transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
				}
	
				if (ignoreCase) {
					transformedInputValue = transformedInputValue.toLowerCase();
				}
	
				this.setState({ inputValue: newInputValue });
				this.loadOptions(transformedInputValue);
	
				// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
				return newInputValue;
			}
		}, {
			key: 'noResultsText',
			value: function noResultsText() {
				var _props2 = this.props,
				    loadingPlaceholder = _props2.loadingPlaceholder,
				    noResultsText = _props2.noResultsText,
				    searchPromptText = _props2.searchPromptText;
				var _state = this.state,
				    inputValue = _state.inputValue,
				    isLoading = _state.isLoading;
	
	
				if (isLoading) {
					return loadingPlaceholder;
				}
				if (inputValue && noResultsText) {
					return noResultsText;
				}
				return searchPromptText;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this3 = this;
	
				var _props3 = this.props,
				    children = _props3.children,
				    loadingPlaceholder = _props3.loadingPlaceholder,
				    placeholder = _props3.placeholder;
				var _state2 = this.state,
				    isLoading = _state2.isLoading,
				    options = _state2.options;
	
	
				var props = {
					noResultsText: this.noResultsText(),
					placeholder: isLoading ? loadingPlaceholder : placeholder,
					options: isLoading && loadingPlaceholder ? [] : options,
					ref: function ref(_ref) {
						return _this3.select = _ref;
					}
				};
	
				return children(_extends({}, this.props, props, {
					isLoading: isLoading,
					onInputChange: this.onInputChange
				}));
			}
		}]);
	
		return Async;
	}(_react.Component);
	
	exports.default = Async;
	
	
	Async.propTypes = propTypes;
	Async.defaultProps = defaultProps;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _defaultFilterOptions = __webpack_require__(515);
	
	var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);
	
	var _defaultMenuRenderer = __webpack_require__(516);
	
	var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);
	
	var _Select = __webpack_require__(350);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CreatableSelect = function (_React$Component) {
		_inherits(CreatableSelect, _React$Component);
	
		function CreatableSelect(props, context) {
			_classCallCheck(this, CreatableSelect);
	
			var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));
	
			_this.filterOptions = _this.filterOptions.bind(_this);
			_this.menuRenderer = _this.menuRenderer.bind(_this);
			_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
			_this.onInputChange = _this.onInputChange.bind(_this);
			_this.onOptionSelect = _this.onOptionSelect.bind(_this);
			return _this;
		}
	
		_createClass(CreatableSelect, [{
			key: 'createNewOption',
			value: function createNewOption() {
				var _props = this.props,
				    isValidNewOption = _props.isValidNewOption,
				    newOptionCreator = _props.newOptionCreator,
				    onNewOptionClick = _props.onNewOptionClick,
				    _props$options = _props.options,
				    options = _props$options === undefined ? [] : _props$options;
	
	
				if (isValidNewOption({ label: this.inputValue })) {
					var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
					var _isOptionUnique = this.isOptionUnique({ option: option, options: options });
	
					// Don't add the same option twice.
					if (_isOptionUnique) {
						if (onNewOptionClick) {
							onNewOptionClick(option);
						} else {
							options.unshift(option);
	
							this.select.selectValue(option);
						}
					}
				}
			}
		}, {
			key: 'filterOptions',
			value: function filterOptions() {
				var _props2 = this.props,
				    filterOptions = _props2.filterOptions,
				    isValidNewOption = _props2.isValidNewOption,
				    promptTextCreator = _props2.promptTextCreator;
	
				// TRICKY Check currently selected options as well.
				// Don't display a create-prompt for a value that's selected.
				// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
	
				var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];
	
				var filteredOptions = filterOptions.apply(undefined, arguments) || [];
	
				if (isValidNewOption({ label: this.inputValue })) {
					var _newOptionCreator = this.props.newOptionCreator;
	
	
					var option = _newOptionCreator({
						label: this.inputValue,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});
	
					// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
					// For multi-selects, this would remove it from the filtered list.
					var _isOptionUnique2 = this.isOptionUnique({
						option: option,
						options: excludeOptions.concat(filteredOptions)
					});
	
					if (_isOptionUnique2) {
						var prompt = promptTextCreator(this.inputValue);
	
						this._createPlaceholderOption = _newOptionCreator({
							label: prompt,
							labelKey: this.labelKey,
							valueKey: this.valueKey
						});
	
						filteredOptions.unshift(this._createPlaceholderOption);
					}
				}
	
				return filteredOptions;
			}
		}, {
			key: 'isOptionUnique',
			value: function isOptionUnique(_ref) {
				var option = _ref.option,
				    options = _ref.options;
				var isOptionUnique = this.props.isOptionUnique;
	
	
				options = options || this.props.options;
	
				return isOptionUnique({
					labelKey: this.labelKey,
					option: option,
					options: options,
					valueKey: this.valueKey
				});
			}
		}, {
			key: 'menuRenderer',
			value: function menuRenderer(params) {
				var menuRenderer = this.props.menuRenderer;
	
	
				return menuRenderer(_extends({}, params, {
					onSelect: this.onOptionSelect,
					selectValue: this.onOptionSelect
				}));
			}
		}, {
			key: 'onInputChange',
			value: function onInputChange(input) {
				var onInputChange = this.props.onInputChange;
	
				// This value may be needed in between Select mounts (when this.select is null)
	
				this.inputValue = input;
	
				if (onInputChange) {
					this.inputValue = onInputChange(input);
				}
	
				return this.inputValue;
			}
		}, {
			key: 'onInputKeyDown',
			value: function onInputKeyDown(event) {
				var _props3 = this.props,
				    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
				    onInputKeyDown = _props3.onInputKeyDown;
	
				var focusedOption = this.select.getFocusedOption();
	
				if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
					this.createNewOption();
	
					// Prevent decorated Select from doing anything additional with this keyDown event
					event.preventDefault();
				} else if (onInputKeyDown) {
					onInputKeyDown(event);
				}
			}
		}, {
			key: 'onOptionSelect',
			value: function onOptionSelect(option) {
				if (option === this._createPlaceholderOption) {
					this.createNewOption();
				} else {
					this.select.selectValue(option);
				}
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props4 = this.props,
				    refProp = _props4.ref,
				    restProps = _objectWithoutProperties(_props4, ['ref']);
	
				var children = this.props.children;
	
				// We can't use destructuring default values to set the children,
				// because it won't apply work if `children` is null. A falsy check is
				// more reliable in real world use-cases.
	
				if (!children) {
					children = defaultChildren;
				}
	
				var props = _extends({}, restProps, {
					allowCreate: true,
					filterOptions: this.filterOptions,
					menuRenderer: this.menuRenderer,
					onInputChange: this.onInputChange,
					onInputKeyDown: this.onInputKeyDown,
					ref: function ref(_ref2) {
						_this2.select = _ref2;
	
						// These values may be needed in between Select mounts (when this.select is null)
						if (_ref2) {
							_this2.labelKey = _ref2.props.labelKey;
							_this2.valueKey = _ref2.props.valueKey;
						}
						if (refProp) {
							refProp(_ref2);
						}
					}
				});
	
				return children(props);
			}
		}]);
	
		return CreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	var isOptionUnique = function isOptionUnique(_ref3) {
		var option = _ref3.option,
		    options = _ref3.options,
		    labelKey = _ref3.labelKey,
		    valueKey = _ref3.valueKey;
	
		if (!options || !options.length) {
			return true;
		}
	
		return options.filter(function (existingOption) {
			return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
		}).length === 0;
	};
	
	var isValidNewOption = function isValidNewOption(_ref4) {
		var label = _ref4.label;
		return !!label;
	};
	
	var newOptionCreator = function newOptionCreator(_ref5) {
		var label = _ref5.label,
		    labelKey = _ref5.labelKey,
		    valueKey = _ref5.valueKey;
	
		var option = {};
		option[valueKey] = label;
		option[labelKey] = label;
		option.className = 'Select-create-option-placeholder';
	
		return option;
	};
	
	var promptTextCreator = function promptTextCreator(label) {
		return 'Create option "' + label + '"';
	};
	
	var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
		var keyCode = _ref6.keyCode;
	
		switch (keyCode) {
			case 9: // TAB
			case 13: // ENTER
			case 188:
				// COMMA
				return true;
			default:
				return false;
		}
	};
	
	// Default prop methods
	CreatableSelect.isOptionUnique = isOptionUnique;
	CreatableSelect.isValidNewOption = isValidNewOption;
	CreatableSelect.newOptionCreator = newOptionCreator;
	CreatableSelect.promptTextCreator = promptTextCreator;
	CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;
	
	CreatableSelect.defaultProps = {
		filterOptions: _defaultFilterOptions2.default,
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		menuRenderer: _defaultMenuRenderer2.default,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	};
	
	CreatableSelect.propTypes = {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2.default.func,
	
		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2.default.any,
	
		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2.default.func,
	
		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2.default.func,
	
		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2.default.any,
	
		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2.default.func,
	
		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2.default.func,
	
		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2.default.func,
	
		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2.default.func,
	
		// See Select.propTypes.options
		options: _propTypes2.default.array,
	
		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2.default.func,
	
		ref: _propTypes2.default.func,
	
		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2.default.func
	};
	
	exports.default = CreatableSelect;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _blockEvent = __webpack_require__(2860);
	
	var _blockEvent2 = _interopRequireDefault(_blockEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = function (_React$Component) {
		_inherits(Option, _React$Component);
	
		function Option(props) {
			_classCallCheck(this, Option);
	
			var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
			_this.handleMouseMove = _this.handleMouseMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.onFocus = _this.onFocus.bind(_this);
			return _this;
		}
	
		_createClass(Option, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onSelect(this.props.option, event);
			}
		}, {
			key: 'handleMouseEnter',
			value: function handleMouseEnter(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleMouseMove',
			value: function handleMouseMove(event) {
				this.onFocus(event);
			}
		}, {
			key: 'handleTouchEnd',
			value: function handleTouchEnd(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				this.handleMouseDown(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'onFocus',
			value: function onFocus(event) {
				if (!this.props.isFocused) {
					this.props.onFocus(this.props.option, event);
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    option = _props.option,
				    instancePrefix = _props.instancePrefix,
				    optionIndex = _props.optionIndex;
	
				var className = (0, _classnames2.default)(this.props.className, option.className);
	
				return option.disabled ? _react2.default.createElement(
					'div',
					{ className: className,
						onMouseDown: _blockEvent2.default,
						onClick: _blockEvent2.default },
					this.props.children
				) : _react2.default.createElement(
					'div',
					{ className: className,
						style: option.style,
						role: 'option',
						'aria-label': option.label,
						onMouseDown: this.handleMouseDown,
						onMouseEnter: this.handleMouseEnter,
						onMouseMove: this.handleMouseMove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove,
						onTouchEnd: this.handleTouchEnd,
						id: instancePrefix + '-option-' + optionIndex,
						title: option.title },
					this.props.children
				);
			}
		}]);
	
		return Option;
	}(_react2.default.Component);
	
	Option.propTypes = {
		children: _propTypes2.default.node,
		className: _propTypes2.default.string, // className (based on mouse position)
		instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2.default.bool, // the option is disabled
		isFocused: _propTypes2.default.bool, // the option is focused
		isSelected: _propTypes2.default.bool, // the option is selected
		onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
		onSelect: _propTypes2.default.func, // method to handle click on option element
		onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
		option: _propTypes2.default.object.isRequired, // object that is base for that option
		optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
	};
	
	exports.default = Option;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Value = function (_React$Component) {
		_inherits(Value, _React$Component);
	
		function Value(props) {
			_classCallCheck(this, Value);
	
			var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));
	
			_this.handleMouseDown = _this.handleMouseDown.bind(_this);
			_this.onRemove = _this.onRemove.bind(_this);
			_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
			_this.handleTouchMove = _this.handleTouchMove.bind(_this);
			_this.handleTouchStart = _this.handleTouchStart.bind(_this);
			return _this;
		}
	
		_createClass(Value, [{
			key: 'handleMouseDown',
			value: function handleMouseDown(event) {
				if (event.type === 'mousedown' && event.button !== 0) {
					return;
				}
				if (this.props.onClick) {
					event.stopPropagation();
					this.props.onClick(this.props.value, event);
					return;
				}
				if (this.props.value.href) {
					event.stopPropagation();
				}
			}
		}, {
			key: 'onRemove',
			value: function onRemove(event) {
				event.preventDefault();
				event.stopPropagation();
				this.props.onRemove(this.props.value);
			}
		}, {
			key: 'handleTouchEndRemove',
			value: function handleTouchEndRemove(event) {
				// Check if the view is being dragged, In this case
				// we don't want to fire the click event (because the user only wants to scroll)
				if (this.dragging) return;
	
				// Fire the mouse events
				this.onRemove(event);
			}
		}, {
			key: 'handleTouchMove',
			value: function handleTouchMove() {
				// Set a flag that the view is being dragged
				this.dragging = true;
			}
		}, {
			key: 'handleTouchStart',
			value: function handleTouchStart() {
				// Set a flag that the view is not being dragged
				this.dragging = false;
			}
		}, {
			key: 'renderRemoveIcon',
			value: function renderRemoveIcon() {
				if (this.props.disabled || !this.props.onRemove) return;
				return _react2.default.createElement(
					'span',
					{ className: 'Select-value-icon',
						'aria-hidden': 'true',
						onMouseDown: this.onRemove,
						onTouchEnd: this.handleTouchEndRemove,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove },
					'\xD7'
				);
			}
		}, {
			key: 'renderLabel',
			value: function renderLabel() {
				var className = 'Select-value-label';
				return this.props.onClick || this.props.value.href ? _react2.default.createElement(
					'a',
					{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					this.props.children
				) : _react2.default.createElement(
					'span',
					{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
					this.props.children
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
						style: this.props.value.style,
						title: this.props.value.title
					},
					this.renderRemoveIcon(),
					this.renderLabel()
				);
			}
		}]);
	
		return Value;
	}(_react2.default.Component);
	
	Value.propTypes = {
		children: _propTypes2.default.node,
		disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
		id: _propTypes2.default.string, // Unique id for the value - used for aria
		onClick: _propTypes2.default.func, // method to handle click on value label
		onRemove: _propTypes2.default.func, // method to handle removal of the value
		value: _propTypes2.default.object.isRequired // the option object for this value
	};
	
	exports.default = Value;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowRenderer = function arrowRenderer(_ref) {
		var onMouseDown = _ref.onMouseDown;
	
		return _react2.default.createElement('span', {
			className: 'Select-arrow',
			onMouseDown: onMouseDown
		});
	};
	
	arrowRenderer.propTypes = {
		onMouseDown: _propTypes2.default.func
	};
	
	exports.default = arrowRenderer;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clearRenderer = function clearRenderer() {
		return _react2.default.createElement('span', {
			className: 'Select-clear',
			dangerouslySetInnerHTML: { __html: '&times;' }
		});
	};
	
	exports.default = clearRenderer;

/***/ },
/* 1296 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];
	
	var stripDiacritics = function stripDiacritics(str) {
		for (var i = 0; i < map.length; i++) {
			str = str.replace(map[i].letters, map[i].base);
		}
		return str;
	};
	
	exports.default = stripDiacritics;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	    className: '',
	    accessibility: true,
	    adaptiveHeight: false,
	    arrows: true,
	    autoplay: false,
	    autoplaySpeed: 3000,
	    centerMode: false,
	    centerPadding: '50px',
	    cssEase: 'ease',
	    customPaging: function customPaging(i) {
	        return _react2.default.createElement(
	            'button',
	            null,
	            i + 1
	        );
	    },
	    dots: false,
	    dotsClass: 'slick-dots',
	    draggable: true,
	    easing: 'linear',
	    edgeFriction: 0.35,
	    fade: false,
	    focusOnSelect: false,
	    infinite: true,
	    initialSlide: 0,
	    lazyLoad: false,
	    pauseOnHover: true,
	    responsive: null,
	    rtl: false,
	    slide: 'div',
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    speed: 500,
	    swipe: true,
	    swipeToSlide: false,
	    touchMove: true,
	    touchThreshold: 5,
	    useCSS: true,
	    variableWidth: false,
	    vertical: false,
	    waitForAnimate: true,
	    afterChange: null,
	    beforeChange: null,
	    edgeEvent: null,
	    init: null,
	    swipeEvent: null,
	    // nextArrow, prevArrow are react componets
	    nextArrow: null,
	    prevArrow: null
	};
	
	module.exports = defaultProps;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = undefined;
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error('Keys Missing', spec);
	};
	
	var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
	
	  var trackWidth, trackHeight;
	
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    if (spec.variableWidth) {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    } else if (spec.centerMode) {
	      trackWidth = (spec.slideCount + 2 * (spec.slidesToShow + 1)) * spec.slideWidth;
	    } else {
	      trackWidth = (spec.slideCount + 2 * spec.slidesToShow) * spec.slideWidth;
	    }
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    WebkitTransform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transform: !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)',
	    transition: '',
	    WebkitTransition: '',
	    msTransform: !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)'
	  };
	
	  if (trackWidth) {
	    (0, _objectAssign2.default)(style, { width: trackWidth });
	  }
	
	  if (trackHeight) {
	    (0, _objectAssign2.default)(style, { height: trackHeight });
	  }
	
	  // Fallback for IE8
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + 'px';
	    } else {
	      style.marginTop = spec.left + 'px';
	    }
	  }
	
	  return style;
	};
	
	var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
	
	  var style = getTrackCSS(spec);
	  // useCSS is true by default so it can be undefined
	  style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
	  style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
	  return style;
	};
	
	var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
	
	  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
	
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (spec.fade) {
	    return 0;
	  }
	
	  if (spec.infinite) {
	    if (spec.slideCount >= spec.slidesToShow) {
	      slideOffset = spec.slideWidth * spec.slidesToShow * -1;
	      verticalOffset = spec.slideHeight * spec.slidesToShow * -1;
	    }
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        if (spec.slideIndex > spec.slideCount) {
	          slideOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideWidth * -1;
	          verticalOffset = (spec.slidesToShow - (spec.slideIndex - spec.slideCount)) * spec.slideHeight * -1;
	        } else {
	          slideOffset = spec.slideCount % spec.slidesToScroll * spec.slideWidth * -1;
	          verticalOffset = spec.slideCount % spec.slidesToScroll * spec.slideHeight * -1;
	        }
	      }
	    }
	  } else {
	
	    if (spec.slideCount % spec.slidesToScroll !== 0) {
	      if (spec.slideIndex + spec.slidesToScroll > spec.slideCount && spec.slideCount > spec.slidesToShow) {
	        var slidesToOffset = spec.slidesToShow - spec.slideCount % spec.slidesToScroll;
	        slideOffset = slidesToOffset * spec.slideWidth;
	      }
	    }
	  }
	
	  if (spec.centerMode) {
	    if (spec.infinite) {
	      slideOffset += spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    } else {
	      slideOffset = spec.slideWidth * Math.floor(spec.slidesToShow / 2);
	    }
	  }
	
	  if (!spec.vertical) {
	    targetLeft = spec.slideIndex * spec.slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = spec.slideIndex * spec.slideHeight * -1 + verticalOffset;
	  }
	
	  if (spec.variableWidth === true) {
	    var targetSlideIndex;
	    if (spec.slideCount <= spec.slidesToShow || spec.infinite === false) {
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[spec.slideIndex];
	    } else {
	      targetSlideIndex = spec.slideIndex + spec.slidesToShow;
	      targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).childNodes[targetSlideIndex];
	    }
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	    if (spec.centerMode === true) {
	      if (spec.infinite === false) {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex];
	      } else {
	        targetSlide = _reactDom2.default.findDOMNode(spec.trackRef).children[spec.slideIndex + spec.slidesToShow + 1];
	      }
	
	      if (targetSlide) {
	        targetLeft = targetSlide.offsetLeft * -1 + (spec.listWidth - targetSlide.offsetWidth) / 2;
	      }
	    }
	  }
	
	  return targetLeft;
	};

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateManager = __webpack_require__(2873);
	
	var _AnimateManager2 = _interopRequireDefault(_AnimateManager);
	
	var _PureRender = __webpack_require__(2874);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _easing = __webpack_require__(1300);
	
	var _configUpdate = __webpack_require__(2875);
	
	var _configUpdate2 = _interopRequireDefault(_configUpdate);
	
	var _util = __webpack_require__(351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Animate = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Animate, _Component);
	
	  function Animate(props, context) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));
	
	    var _this$props = _this.props,
	        isActive = _this$props.isActive,
	        attributeName = _this$props.attributeName,
	        from = _this$props.from,
	        to = _this$props.to,
	        steps = _this$props.steps,
	        children = _this$props.children;
	
	
	    _this.handleStyleChange = _this.handleStyleChange.bind(_this);
	    _this.changeStyle = _this.changeStyle.bind(_this);
	
	    if (!isActive) {
	      _this.state = { style: {} };
	
	      // if children is a function and animation is not active, set style to 'to'
	      if (typeof children === 'function') {
	        _this.state = { style: to };
	      }
	
	      return _possibleConstructorReturn(_this);
	    }
	
	    if (steps && steps.length) {
	      _this.state = { style: steps[0].style };
	    } else if (from) {
	      if (typeof children === 'function') {
	        _this.state = {
	          style: from
	        };
	
	        return _possibleConstructorReturn(_this);
	      }
	      _this.state = {
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      };
	    } else {
	      _this.state = { style: {} };
	    }
	    return _this;
	  }
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isActive = _props.isActive,
	          canBegin = _props.canBegin;
	
	
	      this.mounted = true;
	
	      if (!isActive || !canBegin) {
	        return;
	      }
	
	      this.runAnimation(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isActive = nextProps.isActive,
	          canBegin = nextProps.canBegin,
	          attributeName = nextProps.attributeName,
	          shouldReAnimate = nextProps.shouldReAnimate;
	
	
	      if (!canBegin) {
	        return;
	      }
	
	      if (!isActive) {
	        this.setState({
	          style: attributeName ? _defineProperty({}, attributeName, nextProps.to) : nextProps.to
	        });
	
	        return;
	      }
	
	      var animateProps = ['to', 'canBegin', 'isActive'];
	
	      if ((0, _isEqual3.default)(this.props.to, nextProps.to) && this.props.canBegin && this.props.isActive) {
	        return;
	      }
	
	      var isTriggered = !this.props.canBegin || !this.props.isActive;
	
	      if (this.manager) {
	        this.manager.stop();
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	
	      var from = isTriggered || shouldReAnimate ? nextProps.from : this.props.to;
	
	      this.setState({
	        style: attributeName ? _defineProperty({}, attributeName, from) : from
	      });
	
	      this.runAnimation(_extends({}, nextProps, {
	        from: from,
	        begin: 0
	      }));
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	
	      if (this.unSubscribe) {
	        this.unSubscribe();
	      }
	
	      if (this.manager) {
	        this.manager.stop();
	        this.manager = null;
	      }
	
	      if (this.stopJSAnimation) {
	        this.stopJSAnimation();
	      }
	    }
	  }, {
	    key: 'runJSAnimation',
	    value: function runJSAnimation(props) {
	      var _this2 = this;
	
	      var from = props.from,
	          to = props.to,
	          duration = props.duration,
	          easing = props.easing,
	          begin = props.begin,
	          onAnimationEnd = props.onAnimationEnd,
	          onAnimationStart = props.onAnimationStart;
	
	      var startAnimation = (0, _configUpdate2.default)(from, to, (0, _easing.configEasing)(easing), duration, this.changeStyle);
	
	      var finalStartAnimation = function finalStartAnimation() {
	        _this2.stopJSAnimation = startAnimation();
	      };
	
	      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'runStepAnimation',
	    value: function runStepAnimation(props) {
	      var _this3 = this;
	
	      var steps = props.steps,
	          begin = props.begin,
	          onAnimationStart = props.onAnimationStart;
	      var _steps$ = steps[0],
	          initialStyle = _steps$.style,
	          _steps$$duration = _steps$.duration,
	          initialTime = _steps$$duration === undefined ? 0 : _steps$$duration;
	
	
	      var addStyle = function addStyle(sequence, nextItem, index) {
	        if (index === 0) {
	          return sequence;
	        }
	
	        var duration = nextItem.duration,
	            _nextItem$easing = nextItem.easing,
	            easing = _nextItem$easing === undefined ? 'ease' : _nextItem$easing,
	            style = nextItem.style,
	            nextProperties = nextItem.properties,
	            onAnimationEnd = nextItem.onAnimationEnd;
	
	
	        var preItem = index > 0 ? steps[index - 1] : nextItem;
	        var properties = nextProperties || Object.keys(style);
	
	        if (typeof easing === 'function' || easing === 'spring') {
	          return [].concat(_toConsumableArray(sequence), [_this3.runJSAnimation.bind(_this3, {
	            from: preItem.style,
	            to: style,
	            duration: duration,
	            easing: easing
	          }), duration]);
	        }
	
	        var transition = (0, _util.getTransitionVal)(properties, duration, easing);
	        var newStyle = _extends({}, preItem.style, style, {
	          transition: transition
	        });
	
	        return [].concat(_toConsumableArray(sequence), [newStyle, duration, onAnimationEnd]).filter(_util.identity);
	      };
	
	      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
	    }
	  }, {
	    key: 'runAnimation',
	    value: function runAnimation(props) {
	      if (!this.manager) {
	        this.manager = (0, _AnimateManager2.default)();
	      }
	      var begin = props.begin,
	          duration = props.duration,
	          attributeName = props.attributeName,
	          propsFrom = props.from,
	          propsTo = props.to,
	          easing = props.easing,
	          onAnimationStart = props.onAnimationStart,
	          onAnimationEnd = props.onAnimationEnd,
	          steps = props.steps,
	          children = props.children;
	
	
	      var manager = this.manager;
	
	      this.unSubscribe = manager.subscribe(this.handleStyleChange);
	
	      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
	        this.runJSAnimation(props);
	        return;
	      }
	
	      if (steps.length > 1) {
	        this.runStepAnimation(props);
	        return;
	      }
	
	      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
	      var transition = (0, _util.getTransitionVal)(Object.keys(to), duration, easing);
	
	      manager.start([onAnimationStart, begin, _extends({}, to, { transition: transition }), duration, onAnimationEnd]);
	    }
	  }, {
	    key: 'handleStyleChange',
	    value: function handleStyleChange(style) {
	      this.changeStyle(style);
	    }
	  }, {
	    key: 'changeStyle',
	    value: function changeStyle(style) {
	      if (this.mounted) {
	        this.setState({
	          style: style
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          begin = _props2.begin,
	          duration = _props2.duration,
	          attributeName = _props2.attributeName,
	          easing = _props2.easing,
	          isActive = _props2.isActive,
	          steps = _props2.steps,
	          from = _props2.from,
	          to = _props2.to,
	          canBegin = _props2.canBegin,
	          onAnimationEnd = _props2.onAnimationEnd,
	          shouldReAnimate = _props2.shouldReAnimate,
	          onAnimationReStart = _props2.onAnimationReStart,
	          others = _objectWithoutProperties(_props2, ['children', 'begin', 'duration', 'attributeName', 'easing', 'isActive', 'steps', 'from', 'to', 'canBegin', 'onAnimationEnd', 'shouldReAnimate', 'onAnimationReStart']);
	
	      var count = _react.Children.count(children);
	      var stateStyle = (0, _util.translateStyle)(this.state.style);
	
	      if (typeof children === 'function') {
	        return children(stateStyle);
	      }
	
	      if (!isActive || count === 0) {
	        return children;
	      }
	
	      var cloneContainer = function cloneContainer(container) {
	        var _container$props = container.props,
	            _container$props$styl = _container$props.style,
	            style = _container$props$styl === undefined ? {} : _container$props$styl,
	            className = _container$props.className;
	
	
	        var res = (0, _react.cloneElement)(container, _extends({}, others, {
	          style: _extends({}, style, stateStyle),
	          className: className
	        }));
	        return res;
	      };
	
	      if (count === 1) {
	        var onlyChild = _react.Children.only(children);
	
	        return cloneContainer(_react.Children.only(children));
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react.Children.map(children, function (child) {
	          return cloneContainer(child);
	        })
	      );
	    }
	  }]);
	
	  return Animate;
	}(_react.Component), _class2.displayName = 'Animate', _class2.propTypes = {
	  from: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  to: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  attributeName: _propTypes2.default.string,
	  // animation duration
	  duration: _propTypes2.default.number,
	  begin: _propTypes2.default.number,
	  easing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    duration: _propTypes2.default.number.isRequired,
	    style: _propTypes2.default.object.isRequired,
	    easing: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), _propTypes2.default.func]),
	    // transition css properties(dash case), optional
	    properties: _propTypes2.default.arrayOf('string'),
	    onAnimationEnd: _propTypes2.default.func
	  })),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	  isActive: _propTypes2.default.bool,
	  canBegin: _propTypes2.default.bool,
	  onAnimationEnd: _propTypes2.default.func,
	  // decide if it should reanimate with initial from style when props change
	  shouldReAnimate: _propTypes2.default.bool,
	  onAnimationStart: _propTypes2.default.func,
	  onAnimationReStart: _propTypes2.default.func
	}, _class2.defaultProps = {
	  begin: 0,
	  duration: 1000,
	  from: '',
	  to: '',
	  attributeName: '',
	  easing: 'ease',
	  isActive: true,
	  canBegin: true,
	  steps: [],
	  onAnimationEnd: function onAnimationEnd() {},
	  onAnimationStart: function onAnimationStart() {}
	}, _temp)) || _class;
	
	exports.default = Animate;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configEasing = exports.configSpring = exports.configBezier = undefined;
	
	var _util = __webpack_require__(351);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ACCURACY = 1e-4;
	
	var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
	  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
	};
	
	var multyTime = function multyTime(params, t) {
	  return params.map(function (param, i) {
	    return param * Math.pow(t, i);
	  }).reduce(function (pre, curr) {
	    return pre + curr;
	  });
	};
	
	var cubicBezier = function cubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	
	    return multyTime(params, t);
	  };
	};
	
	var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
	  return function (t) {
	    var params = cubicBezierFactor(c1, c2);
	    var newParams = [].concat(_toConsumableArray(params.map(function (param, i) {
	      return param * i;
	    }).slice(1)), [0]);
	
	    return multyTime(newParams, t);
	  };
	};
	
	// calculate cubic-bezier using Newton's method
	var configBezier = exports.configBezier = function configBezier() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var x1 = args[0],
	      y1 = args[1],
	      x2 = args[2],
	      y2 = args[3];
	
	
	  if (args.length === 1) {
	    switch (args[0]) {
	      case 'linear':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease':
	        x1 = 0.25;
	        y1 = 0.1;
	        x2 = 0.25;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 1.0;
	        y2 = 1.0;
	
	        break;
	      case 'ease-out':
	        x1 = 0.42;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      case 'ease-in-out':
	        x1 = 0.0;
	        y1 = 0.0;
	        x2 = 0.58;
	        y2 = 1.0;
	
	        break;
	      default:
	        (0, _util.warn)(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\', instead received %s', args);
	    }
	  }
	
	  (0, _util.warn)([x1, x2, y1, y2].every(function (num) {
	    return typeof num === 'number' && num >= 0 && num <= 1;
	  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
	
	  var curveX = cubicBezier(x1, x2);
	  var curveY = cubicBezier(y1, y2);
	  var derCurveX = derivativeCubicBezier(x1, x2);
	  var rangeValue = function rangeValue(value) {
	    if (value > 1) {
	      return 1;
	    } else if (value < 0) {
	      return 0;
	    }
	
	    return value;
	  };
	
	  var bezier = function bezier(_t) {
	    var t = _t > 1 ? 1 : _t;
	    var x = t;
	
	    for (var i = 0; i < 8; ++i) {
	      var evalT = curveX(x) - t;
	      var derVal = derCurveX(x);
	
	      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
	        return curveY(x);
	      }
	
	      x = rangeValue(x - evalT / derVal);
	    }
	
	    return curveY(x);
	  };
	
	  bezier.isStepper = false;
	
	  return bezier;
	};
	
	var configSpring = exports.configSpring = function configSpring() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$stiff = config.stiff,
	      stiff = _config$stiff === undefined ? 100 : _config$stiff,
	      _config$damping = config.damping,
	      damping = _config$damping === undefined ? 8 : _config$damping,
	      _config$dt = config.dt,
	      dt = _config$dt === undefined ? 17 : _config$dt;
	
	  var stepper = function stepper(currX, destX, currV) {
	    var FSpring = -(currX - destX) * stiff;
	    var FDamping = currV * damping;
	    var newV = currV + (FSpring - FDamping) * dt / 1000;
	    var newX = currV * dt / 1000 + currX;
	
	    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
	      return [destX, 0];
	    }
	    return [newX, newV];
	  };
	
	  stepper.isStepper = true;
	  stepper.dt = dt;
	
	  return stepper;
	};
	
	var configEasing = exports.configEasing = function configEasing() {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var easing = args[0];
	
	
	  if (typeof easing === 'string') {
	    switch (easing) {
	      case 'ease':
	      case 'ease-in-out':
	      case 'ease-out':
	      case 'ease-in':
	      case 'linear':
	        return configBezier(easing);
	      case 'spring':
	        return configSpring();
	      default:
	        (0, _util.warn)(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\', \'linear\' and \'spring\', instead  received %s', args);
	    }
	  }
	
	  if (typeof easing === 'function') {
	    return easing;
	  }
	
	  (0, _util.warn)(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
	
	  return null;
	};

/***/ },
/* 1301 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var shallowEqual = function shallowEqual(a, b) {
	  var keysA = Object.keys(a);
	  var keysB = Object.keys(b);
	
	  return keysA.length === keysB.length && keysA.every(function (key) {
	    return b.hasOwnProperty(key) && b[key] === a[key];
	  });
	};
	
	exports.default = shallowEqual;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(354);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(129);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _ = _lodash2.default.runInContext();
	
	// Processes a ReactElement by iterating over its props, looking for
	// props which are specified by `handlersToWrap`. Matching props will
	// be passed to the derived class to be wrapped in a throttling function
	
	var Base = function () {
	  function Base(el, handlersToWrap, time) {
	    var _this = this;
	
	    _classCallCheck(this, Base);
	
	    this.element = function () {
	      return _this._el || (_this._el = _this._processElement());
	    };
	
	    this._processElement = function () {
	      _this.handlers = _this._wrapHandlers();
	      return _react2.default.cloneElement(_this.el, _this.handlers);
	    };
	
	    this._extractHandlers = function () {
	      return _.pickBy(_this.el.props, _this._shouldWrapHandler);
	    };
	
	    this._wrapHandlers = function () {
	      return _.mapValues(_this._extractHandlers(), _this._wrapHandler);
	    };
	
	    this._shouldWrapHandler = function (handler, handlerName) {
	      return _.isFunction(handler) && _this.time > 0 && _this.handlersToWrap.includes(handlerName);
	    };
	
	    if (this.constructor === Base) {
	      throw new Error('Can\'t instantiate abstract class!');
	    }
	
	    // Array of handler names which we should wrap
	    this.handlersToWrap = handlersToWrap;
	
	    // Throttle interval/delay
	    this.time = time;
	
	    // Element that we are processing
	    this.el = el;
	
	    // Array of handlers which we have wrapped (so we can unwrap them)
	    this.handlers = [];
	  }
	
	  // How the processed element is made public, memoized
	
	
	  // Clone the element, overwriting unwrapped handlers with their wrapped versions
	
	
	  // Find the handlers which should be wrapped by the throttling function
	
	
	  // Pass each handler to the derived class to be wrapped
	
	
	  _createClass(Base, [{
	    key: 'destroy',
	
	
	    // Cancel timers related to throttling
	    value: function destroy() {
	      _.values(this.handlers).forEach(this._cancelThrottle);
	    }
	
	    // Lodash provides cancel methods on throttle/debounce wrappers
	
	  }, {
	    key: '_cancelThrottle',
	    value: function _cancelThrottle(handler) {
	      handler.cancel && handler.cancel();
	    }
	  }]);
	
	  return Base;
	}();
	
	exports.default = Base;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	var _lodash = __webpack_require__(129);
	
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      result,
	      timerId,
	      lastCallTime = 0,
	      lastInvokeTime = 0,
	      leading = false,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = (0, _lodash.toNumber)(wait) || 0;
	  if ((0, _lodash.isObject)(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && Math.max((0, _lodash.toNumber)(options.maxWait) || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxWait === false ? result : nativeMin(result, maxWait - timeSinceLastInvoke);
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return !lastCallTime || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxWait !== false && timeSinceLastInvoke >= maxWait;
	  }
	
	  function timerExpired() {
	    var time = (0, _lodash.now)();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    clearTimeout(timerId);
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastCallTime = lastInvokeTime = 0;
	    lastArgs = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge((0, _lodash.now)());
	  }
	
	  function debounced() {
	    var time = (0, _lodash.now)(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = (0, _lodash.cloneDeep)(Array.prototype.slice.call(arguments));
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      // Handle invocations in a tight loop.
	      clearTimeout(timerId);
	      timerId = setTimeout(timerExpired, wait);
	      return invokeFunc(lastCallTime);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(354);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Base = function (_Component) {
	  _inherits(Base, _Component);
	
	  function Base(props) {
	    _classCallCheck(this, Base);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Base).call(this, props));
	
	    _this.render = function () {
	      return _this._throttler.element();
	    };
	
	    _this.el = _react2.default.Children.only(props.children);
	    _this.handlersToWrap = props.handler.length ? [props.handler] : props.handlers;
	    return _this;
	  }
	
	  _createClass(Base, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._throttler.destroy();
	    }
	  }]);
	
	  return Base;
	}(_react.Component);
	
	exports.default = Base;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(353),
	    _assign = __webpack_require__(25);
	
	var ReactNoopUpdateQueue = __webpack_require__(1308);
	
	var canDefineProperty = __webpack_require__(1309);
	var emptyObject = __webpack_require__(300);
	var invariant = __webpack_require__(18);
	var lowPriorityWarning = __webpack_require__(2899);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 1306 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 1307 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(301);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;
	
	var _propTypes = __webpack_require__(355);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _PropTypes = __webpack_require__(1311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
	var EXITED = exports.EXITED = 'exited';
	var ENTERING = exports.ENTERING = 'entering';
	var ENTERED = exports.ENTERED = 'entered';
	var EXITING = exports.EXITING = 'exiting';
	
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the components.
	 * It's up to you to give meaning and effect to those states. For example we can
	 * add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import Transition from 'react-transition-group/Transition';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {(state) => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
	 * What it does do is track transition states over time so you can update the
	 * component (such as by adding styles or classes) when it changes states.
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component begins the
	 * "Enter" stage. During this stage, the component will shift from its current transition state,
	 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
	 * it's complete. Let's take the following example:
	 *
	 * ```jsx
	 * state = { in: false };
	 *
	 * toggleEnterState = () => {
	 *   this.setState({ in: true });
	 * }
	 *
	 * render() {
	 *   return (
	 *     <div>
	 *       <Transition in={this.state.in} timeout={500} />
	 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state and
	 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
	 *
	 * ## Timing
	 *
	 * Timing is often the trickiest part of animation, mistakes can result in slight delays
	 * that are hard to pin down. A common example is when you want to add an exit transition,
	 * you should set the desired final styles when the state is `'exiting'`. That's when the
	 * transition to those styles will start and, if you matched the `timeout` prop with the
	 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
	 *
	 * > **Note**: For simpler transitions the `Transition` component might be enough, but
	 * > take into account that it's platform-agnostic, while the `CSSTransition` component
	 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * > in order to make more complex transitions more predictable. For example, even though
	 * > classes `example-enter` and `example-enter-active` are applied immediately one after
	 * > another, you can still transition from one to the other because of the forced reflow
	 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
	 * > for more info). Take this into account when choosing between `Transition` and
	 * > `CSSTransition`.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 */
	
	var Transition = function (_React$Component) {
	  _inherits(Transition, _React$Component);
	
	  function Transition(props, context) {
	    _classCallCheck(this, Transition);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    var parentGroup = context.transitionGroup;
	    // In the context of a TransitionGroup all enters are really appears
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	
	    var initialStatus = void 0;
	    _this.nextStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.nextStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = { status: initialStatus };
	
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.prototype.getChildContext = function getChildContext() {
	    return { transitionGroup: null }; // allows for nested Transitions
	  };
	
	  Transition.prototype.componentDidMount = function componentDidMount() {
	    this.updateStatus(true);
	  };
	
	  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _ref = this.pendingState || this.state,
	        status = _ref.status;
	
	    if (nextProps.in) {
	      if (status === UNMOUNTED) {
	        this.setState({ status: EXITED });
	      }
	      if (status !== ENTERING && status !== ENTERED) {
	        this.nextStatus = ENTERING;
	      }
	    } else {
	      if (status === ENTERING || status === ENTERED) {
	        this.nextStatus = EXITING;
	      }
	    }
	  };
	
	  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.updateStatus();
	  };
	
	  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  Transition.prototype.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	
	    var exit = void 0,
	        enter = void 0,
	        appear = void 0;
	
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter;
	      appear = timeout.appear;
	    }
	    return { exit: exit, enter: enter, appear: appear };
	  };
	
	  Transition.prototype.updateStatus = function updateStatus() {
	    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var nextStatus = this.nextStatus;
	
	    if (nextStatus !== null) {
	      this.nextStatus = null;
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	      var node = _reactDom2.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({ status: UNMOUNTED });
	    }
	  };
	
	  Transition.prototype.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	
	    var timeouts = this.getTimeouts();
	
	    // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	    if (!mounting && !enter) {
	      this.safeSetState({ status: ENTERED }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	
	    this.safeSetState({ status: ENTERING }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      // FIXME: appear timeout?
	      _this2.onTransitionEnd(node, timeouts.enter, function () {
	        _this2.safeSetState({ status: ENTERED }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	
	    var timeouts = this.getTimeouts();
	
	    // no exit animation skip right to EXITED
	    if (!exit) {
	      this.safeSetState({ status: EXITED }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	    this.props.onExit(node);
	
	    this.safeSetState({ status: EXITING }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({ status: EXITED }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
	    var _this4 = this;
	
	    // We need to track pending updates for instances where a cWRP fires quickly
	    // after cDM and before the state flushes, which would double trigger a
	    // transition
	    this.pendingState = nextState;
	
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, function () {
	      _this4.pendingState = null;
	      callback();
	    });
	  };
	
	  Transition.prototype.setNextCallback = function setNextCallback(callback) {
	    var _this5 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this5.nextCallback = null;
	
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	
	    if (node) {
	      if (this.props.addEndListener) {
	        this.props.addEndListener(node, this.nextCallback);
	      }
	      if (timeout != null) {
	        setTimeout(this.nextCallback, timeout);
	      }
	    } else {
	      setTimeout(this.nextCallback, 0);
	    }
	  };
	
	  Transition.prototype.render = function render() {
	    var status = this.state.status;
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _props = this.props,
	        children = _props.children,
	        childProps = _objectWithoutProperties(_props, ['children']);
	    // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react2.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	
	
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element.
	   * This function is called with the current transition status
	   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
	   * to apply context specific props to a component.
	   *
	   * ```jsx
	   * <Transition timeout={150}>
	   *   {(status) => (
	   *     <MyComponent className={`fade fade-${status}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided
	   *
	   * You may specify a single timeout for all transitions like: `timeout={500}`,
	   * or individually like:
	   *
	   * ```jsx
	   * timeout={{
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * @type {number | { enter?: number, exit?: number }}
	   */
	  timeout: function timeout(props) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	    return pt.apply(undefined, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func
	} : {};
	
	// Name the function so it is clearer in the documentation
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	exports.default = Transition;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = undefined;
	exports.transitionTimeout = transitionTimeout;
	
	var _propTypes = __webpack_require__(355);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function transitionTimeout(transitionType) {
	  var timeoutPropName = 'transition' + transitionType + 'Timeout';
	  var enabledPropName = 'transition' + transitionType;
	
	  return function (props) {
	    // If the transition is enabled
	    if (props[enabledPropName]) {
	      // If no timeout duration is provided
	      if (props[timeoutPropName] == null) {
	        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');
	
	        // If the duration isn't a number
	      } else if (typeof props[timeoutPropName] !== 'number') {
	        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
	      }
	    }
	
	    return null;
	  };
	}
	
	var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
	  enter: _propTypes2.default.number,
	  exit: _propTypes2.default.number
	}).isRequired]);
	
	var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  active: _propTypes2.default.string
	}), _propTypes2.default.shape({
	  enter: _propTypes2.default.string,
	  enterDone: _propTypes2.default.string,
	  enterActive: _propTypes2.default.string,
	  exit: _propTypes2.default.string,
	  exitDone: _propTypes2.default.string,
	  exitActive: _propTypes2.default.string
	})]);

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _discreteColorLegendItem = __webpack_require__(2913);
	
	var _discreteColorLegendItem2 = _interopRequireDefault(_discreteColorLegendItem);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function DiscreteColorLegend(_ref) {
	  var className = _ref.className,
	      colors = _ref.colors,
	      height = _ref.height,
	      items = _ref.items,
	      onItemClick = _ref.onItemClick,
	      onItemMouseEnter = _ref.onItemMouseEnter,
	      onItemMouseLeave = _ref.onItemMouseLeave,
	      orientation = _ref.orientation,
	      width = _ref.width;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-discrete-color-legend ' + orientation + ' ' + className, style: { width: width, height: height } },
	    items.map(function (item, i) {
	      return _react2.default.createElement(_discreteColorLegendItem2.default, {
	        title: item.title ? item.title : item,
	        color: item.color ? item.color : colors[i % colors.length],
	        disabled: Boolean(item.disabled),
	        orientation: orientation,
	        key: i,
	        onClick: onItemClick ? function (e) {
	          return onItemClick(item, i, e);
	        } : null,
	        onMouseEnter: onItemMouseEnter ? function (e) {
	          return onItemMouseEnter(item, i, e);
	        } : null,
	        onMouseLeave: onItemMouseEnter ? function (e) {
	          return onItemMouseLeave(item, i, e);
	        } : null
	      });
	    })
	  );
	}
	
	DiscreteColorLegend.displayName = 'DiscreteColorLegendItem';
	DiscreteColorLegend.propTypes = {
	  className: _propTypes2.default.string,
	  items: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
	    title: _propTypes2.default.string.isRequired,
	    color: _propTypes2.default.string,
	    disabled: _propTypes2.default.bool
	  }), _propTypes2.default.string.isRequired, _propTypes2.default.element])).isRequired,
	  onItemClick: _propTypes2.default.func,
	  onItemMouseEnter: _propTypes2.default.func,
	  onItemMouseLeave: _propTypes2.default.func,
	  height: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['vertical', 'horizontal'])
	};
	
	DiscreteColorLegend.defaultProps = {
	  className: '',
	  colors: _theme.DISCRETE_COLOR_RANGE,
	  orientation: 'vertical'
	};
	
	exports.default = DiscreteColorLegend;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(80);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _axisLine = __webpack_require__(2917);
	
	var _axisLine2 = _interopRequireDefault(_axisLine);
	
	var _axisTicks = __webpack_require__(2918);
	
	var _axisTicks2 = _interopRequireDefault(_axisTicks);
	
	var _axisTitle = __webpack_require__(2919);
	
	var _axisTitle2 = _interopRequireDefault(_axisTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultAnimatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickSize', 'tickTotal', 'tickSizeInner', 'tickSizeOuter'];
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]),
	  attr: _propTypes2.default.string.isRequired,
	  attrAxis: _propTypes2.default.string,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	
	  style: _propTypes2.default.object,
	
	  className: _propTypes2.default.string,
	  hideTicks: _propTypes2.default.bool,
	  hideLine: _propTypes2.default.bool,
	  on0: _propTypes2.default.bool,
	  tickLabelAngle: _propTypes2.default.number,
	  tickSize: _propTypes2.default.number,
	  tickSizeInner: _propTypes2.default.number,
	  tickSizeOuter: _propTypes2.default.number,
	  tickPadding: _propTypes2.default.number,
	  tickValues: _propTypes2.default.array,
	  tickFormat: _propTypes2.default.func,
	  tickTotal: _propTypes2.default.number,
	
	  // Not expected to be used by the users.
	  // TODO: Add underscore to these properties later.
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	
	var defaultProps = {
	  className: '',
	  on0: false,
	  style: {},
	  tickSize: 6,
	  tickPadding: 8,
	  orientation: BOTTOM
	};
	
	var predefinedClassName = 'rv-xy-plot__axis';
	var VERTICAL_CLASS_NAME = 'rv-xy-plot__axis--vertical';
	var HORIZONTAL_CLASS_NAME = 'rv-xy-plot__axis--horizontal';
	
	var Axis = function (_PureComponent) {
	  _inherits(Axis, _PureComponent);
	
	  function Axis() {
	    _classCallCheck(this, Axis);
	
	    return _possibleConstructorReturn(this, (Axis.__proto__ || Object.getPrototypeOf(Axis)).apply(this, arguments));
	  }
	
	  _createClass(Axis, [{
	    key: '_getDefaultAxisProps',
	
	
	    /**
	     * Define the default values depending on the data passed from the outside.
	     * @returns {*} Object of default properties.
	     * @private
	     */
	    value: function _getDefaultAxisProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginBottom = _props.marginBottom,
	          marginLeft = _props.marginLeft,
	          marginRight = _props.marginRight,
	          orientation = _props.orientation;
	
	      if (orientation === BOTTOM) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerWidth),
	          top: innerHeight + marginTop,
	          left: marginLeft,
	          width: innerWidth,
	          height: marginBottom
	        };
	      } else if (orientation === TOP) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerWidth),
	          top: 0,
	          left: marginLeft,
	          width: innerWidth,
	          height: marginTop
	        };
	      } else if (orientation === LEFT) {
	        return {
	          tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerHeight),
	          top: marginTop,
	          left: 0,
	          width: marginLeft,
	          height: innerHeight
	        };
	      }
	      return {
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(innerHeight),
	        top: marginTop,
	        left: marginLeft + innerWidth,
	        width: marginRight,
	        height: innerHeight
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var animation = this.props.animation;
	
	
	      if (animation) {
	        var animatedProps = animation.nonAnimatedProps ? defaultAnimatedProps.filter(function (prop) {
	          return animation.nonAnimatedProps.indexOf(prop) < 0;
	        }) : defaultAnimatedProps;
	
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(Axis, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultAxisProps(), this.props);
	
	      var attrAxis = props.attrAxis,
	          className = props.className,
	          height = props.height,
	          hideLine = props.hideLine,
	          hideTicks = props.hideTicks,
	          left = props.left,
	          marginTop = props.marginTop,
	          on0 = props.on0,
	          orientation = props.orientation,
	          style = props.style,
	          title = props.title,
	          top = props.top,
	          width = props.width;
	
	      var isVertical = [LEFT, RIGHT].indexOf(orientation) > -1;
	      var axisClassName = isVertical ? VERTICAL_CLASS_NAME : HORIZONTAL_CLASS_NAME;
	
	      var leftPos = left;
	      var topPos = top;
	      if (on0) {
	        var scale = (0, _scalesUtils.getAttributeScale)(props, attrAxis);
	        if (isVertical) {
	          leftPos = scale(0);
	        } else {
	          topPos = marginTop + scale(0);
	        }
	      }
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + leftPos + ',' + topPos + ')',
	          className: predefinedClassName + ' ' + axisClassName + ' ' + className,
	          style: style },
	        !hideLine && _react2.default.createElement(_axisLine2.default, {
	          height: height,
	          width: width,
	          orientation: orientation,
	          style: _extends({}, style, style.line)
	        }),
	        !hideTicks && _react2.default.createElement(_axisTicks2.default, _extends({}, props, { style: _extends({}, style, style.ticks) })),
	        title ? _react2.default.createElement(_axisTitle2.default, {
	          title: title,
	          height: height,
	          width: width,
	          style: _extends({}, style, style.title),
	          orientation: orientation }) : null
	      );
	    }
	  }]);
	
	  return Axis;
	}(_react.PureComponent);
	
	Axis.displayName = 'Axis';
	Axis.propTypes = propTypes;
	Axis.defaultProps = defaultProps;
	Axis.requiresSVG = true;
	
	exports.default = Axis;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Color = __webpack_require__(122);
	
	var _theme = __webpack_require__(48);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	function getScaleDistance(props, attr) {
	  var scaleObject = (0, _scalesUtils.getScaleObjectFromProps)(props, attr);
	  return scaleObject ? scaleObject.distance : 0;
	}
	
	var BarSeriesCanvas = function (_AbstractSeries) {
	  _inherits(BarSeriesCanvas, _AbstractSeries);
	
	  function BarSeriesCanvas() {
	    _classCallCheck(this, BarSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (BarSeriesCanvas.__proto__ || Object.getPrototypeOf(BarSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(BarSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          linePosAttr = props.linePosAttr,
	          lineSizeAttr = props.lineSizeAttr,
	          valuePosAttr = props.valuePosAttr,
	          marginTop = props.marginTop,
	          marginBottom = props.marginBottom;
	
	      if (!data || data.length === 0) {
	        return;
	      }
	
	      var distance = getScaleDistance(props, linePosAttr);
	      var line = (0, _scalesUtils.getAttributeFunctor)(props, linePosAttr);
	      var value = (0, _scalesUtils.getAttributeFunctor)(props, valuePosAttr);
	      var value0 = (0, _scalesUtils.getAttr0Functor)(props, valuePosAttr);
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var stroke = (0, _scalesUtils.getAttributeFunctor)(props, 'stroke') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacity = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      var itemSize = distance / 2 * 0.85;
	
	      var _getStackParams = (0, _seriesUtils.getStackParams)(props),
	          sameTypeTotal = _getStackParams.sameTypeTotal,
	          sameTypeIndex = _getStackParams.sameTypeIndex;
	
	      data.forEach(function (row) {
	        var fillColor = (0, _d3Color.rgb)(fill(row));
	        var strokeColor = (0, _d3Color.rgb)(stroke(row));
	        var rowOpacity = opacity(row) || _theme.DEFAULT_OPACITY;
	
	        var linePos = line(row) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex;
	        var valuePos = Math.min(value0(row), value(row));
	        var x = valuePosAttr === 'x' ? valuePos : linePos;
	        var y = valuePosAttr === 'y' ? valuePos : linePos;
	
	        var lineSize = itemSize * 2 / sameTypeTotal;
	        var valueSize = Math.abs(-value0(row) + value(row));
	        var height = lineSizeAttr === 'height' ? lineSize : valueSize;
	        var width = lineSizeAttr === 'width' ? lineSize : valueSize;
	
	        ctx.beginPath();
	        ctx.rect(x + marginBottom, y + marginTop, width, height);
	        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
	        ctx.fill();
	        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
	        ctx.stroke();
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return BarSeriesCanvas;
	}(_abstractSeries2.default);
	
	BarSeriesCanvas.displayName = 'BarSeriesCanvas';
	BarSeriesCanvas.defaultProps = {
	  linePosAttr: _propTypes2.default.string.isRequired,
	  valuePosAttr: _propTypes2.default.string.isRequired,
	  lineSizeAttr: _propTypes2.default.string.isRequired,
	  valueSizeAttr: _propTypes2.default.string.isRequired
	};
	
	BarSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = BarSeriesCanvas;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--bar';
	
	var BarSeries = function (_AbstractSeries) {
	  _inherits(BarSeries, _AbstractSeries);
	
	  function BarSeries() {
	    _classCallCheck(this, BarSeries);
	
	    return _possibleConstructorReturn(this, (BarSeries.__proto__ || Object.getPrototypeOf(BarSeries)).apply(this, arguments));
	  }
	
	  _createClass(BarSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          linePosAttr = _props.linePosAttr,
	          lineSizeAttr = _props.lineSizeAttr,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style,
	          valuePosAttr = _props.valuePosAttr,
	          valueSizeAttr = _props.valueSizeAttr;
	
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(BarSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var _getStackParams = (0, _seriesUtils.getStackParams)(this.props),
	          sameTypeTotal = _getStackParams.sameTypeTotal,
	          sameTypeIndex = _getStackParams.sameTypeIndex;
	
	      var distance = this._getScaleDistance(linePosAttr);
	      var lineFunctor = this._getAttributeFunctor(linePosAttr);
	      var valueFunctor = this._getAttributeFunctor(valuePosAttr);
	      var value0Functor = this._getAttr0Functor(valuePosAttr);
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	
	      var itemSize = distance / 2 * 0.85;
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var _attrs;
	
	          var attrs = (_attrs = {
	            style: _extends({
	              opacity: opacityFunctor && opacityFunctor(d),
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d)
	            }, style)
	          }, _defineProperty(_attrs, linePosAttr, lineFunctor(d) - itemSize + itemSize * 2 / sameTypeTotal * sameTypeIndex), _defineProperty(_attrs, lineSizeAttr, itemSize * 2 / sameTypeTotal), _defineProperty(_attrs, valuePosAttr, Math.min(value0Functor(d), valueFunctor(d))), _defineProperty(_attrs, valueSizeAttr, Math.abs(-value0Functor(d) + valueFunctor(d))), _defineProperty(_attrs, 'onClick', function onClick(e) {
	            return _this2._valueClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onContextMenu', function onContextMenu(e) {
	            return _this2._valueRightClickHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOver', function onMouseOver(e) {
	            return _this2._valueMouseOverHandler(d, e);
	          }), _defineProperty(_attrs, 'onMouseOut', function onMouseOut(e) {
	            return _this2._valueMouseOutHandler(d, e);
	          }), _defineProperty(_attrs, 'key', i), _attrs);
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return _extends({}, _abstractSeries2.default.propTypes, {
	        linePosAttr: _propTypes2.default.string,
	        valuePosAttr: _propTypes2.default.string,
	        lineSizeAttr: _propTypes2.default.string,
	        valueSizeAttr: _propTypes2.default.string,
	        cluster: _propTypes2.default.string
	      });
	    }
	  }]);
	
	  return BarSeries;
	}(_abstractSeries2.default);
	
	BarSeries.displayName = 'BarSeries';
	
	exports.default = BarSeries;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeries = __webpack_require__(522);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _markSeries = __webpack_require__(523);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = _extends({}, _lineSeries2.default.propTypes, {
	  lineStyle: _propTypes2.default.object,
	  markStyle: _propTypes2.default.object
	});
	
	var LineMarkSeries = function (_AbstractSeries) {
	  _inherits(LineMarkSeries, _AbstractSeries);
	
	  function LineMarkSeries() {
	    _classCallCheck(this, LineMarkSeries);
	
	    return _possibleConstructorReturn(this, (LineMarkSeries.__proto__ || Object.getPrototypeOf(LineMarkSeries)).apply(this, arguments));
	  }
	
	  _createClass(LineMarkSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          lineStyle = _props.lineStyle,
	          markStyle = _props.markStyle,
	          style = _props.style;
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'rv-xy-plot__series rv-xy-plot__series--linemark' },
	        _react2.default.createElement(_lineSeries2.default, _extends({}, this.props, { style: _extends({}, style, lineStyle) })),
	        _react2.default.createElement(_markSeries2.default, _extends({}, this.props, { style: _extends({}, style, markStyle) }))
	      );
	    }
	  }], [{
	    key: 'defaultProps',
	    get: function get() {
	      return _extends({}, _lineSeries2.default.defaultProps, {
	        lineStyle: {},
	        markStyle: {}
	      });
	    }
	  }]);
	
	  return LineMarkSeries;
	}(_abstractSeries2.default);
	
	LineMarkSeries.displayName = 'LineMarkSeries';
	LineMarkSeries.propTypes = propTypes;
	
	exports.default = LineMarkSeries;

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Color = __webpack_require__(122);
	
	var _theme = __webpack_require__(48);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	var LineSeriesCanvas = function (_AbstractSeries) {
	  _inherits(LineSeriesCanvas, _AbstractSeries);
	
	  function LineSeriesCanvas() {
	    _classCallCheck(this, LineSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (LineSeriesCanvas.__proto__ || Object.getPrototypeOf(LineSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(LineSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          marginLeft = props.marginLeft,
	          marginTop = props.marginTop,
	          strokeWidth = props.strokeWidth,
	          strokeDasharray = props.strokeDasharray;
	
	      if (!data || data.length === 0) {
	        return;
	      }
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(props, 'x');
	      var y = (0, _scalesUtils.getAttributeFunctor)(props, 'y');
	      var stroke = (0, _scalesUtils.getAttributeValue)(props, 'stroke') || (0, _scalesUtils.getAttributeValue)(props, 'color');
	      var strokeColor = (0, _d3Color.rgb)(stroke);
	      var newOpacity = (0, _scalesUtils.getAttributeValue)(props, 'opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	
	      ctx.beginPath();
	      ctx.moveTo(x(data[0]) + marginLeft, y(data[0]) + marginTop);
	      data.forEach(function (row) {
	        return ctx.lineTo(x(row) + marginLeft, y(row) + marginTop);
	      });
	
	      ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + opacity + ')';
	      ctx.lineWidth = strokeWidth;
	      if (strokeDasharray) {
	        ctx.setLineDash(strokeDasharray);
	      }
	      ctx.stroke();
	      // set back to default
	      ctx.lineWidth = 1;
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return LineSeriesCanvas;
	}(_abstractSeries2.default);
	
	LineSeriesCanvas.displayName = 'LineSeriesCanvas';
	LineSeriesCanvas.defaultProps = {
	  strokeWidth: 1,
	  strokeDasharray: ''
	};
	
	LineSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeWidth: _propTypes2.default.number
	});
	
	exports.default = LineSeriesCanvas;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _d3Color = __webpack_require__(122);
	
	var _theme = __webpack_require__(48);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var MarkSeriesCanvas = function (_AbstractSeries) {
	  _inherits(MarkSeriesCanvas, _AbstractSeries);
	
	  function MarkSeriesCanvas() {
	    _classCallCheck(this, MarkSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (MarkSeriesCanvas.__proto__ || Object.getPrototypeOf(MarkSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(MarkSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      var data = props.data,
	          marginLeft = props.marginLeft,
	          marginTop = props.marginTop;
	
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(props, 'x');
	      var y = (0, _scalesUtils.getAttributeFunctor)(props, 'y');
	      var size = (0, _scalesUtils.getAttributeFunctor)(props, 'size') || function (p) {
	        return _theme.DEFAULT_SIZE;
	      };
	      var fill = (0, _scalesUtils.getAttributeFunctor)(props, 'fill') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var stroke = (0, _scalesUtils.getAttributeFunctor)(props, 'stroke') || (0, _scalesUtils.getAttributeFunctor)(props, 'color');
	      var opacity = (0, _scalesUtils.getAttributeFunctor)(props, 'opacity');
	
	      data.forEach(function (row) {
	        var fillColor = (0, _d3Color.rgb)(fill(row));
	        var strokeColor = (0, _d3Color.rgb)(stroke(row));
	        var rowOpacity = opacity(row) || _theme.DEFAULT_OPACITY;
	        ctx.beginPath();
	        ctx.arc(x(row) + marginLeft, y(row) + marginTop, size(row), 0, 2 * Math.PI);
	        ctx.fillStyle = 'rgba(' + fillColor.r + ', ' + fillColor.g + ', ' + fillColor.b + ', ' + rowOpacity + ')';
	        ctx.fill();
	        ctx.strokeStyle = 'rgba(' + strokeColor.r + ', ' + strokeColor.g + ', ' + strokeColor.b + ', ' + rowOpacity + ')';
	        ctx.stroke();
	      });
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return MarkSeriesCanvas;
	}(_abstractSeries2.default);
	
	MarkSeriesCanvas.displayName = 'MarkSeriesCanvas';
	MarkSeriesCanvas.defaultProps = {};
	
	MarkSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = MarkSeriesCanvas;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeries = __webpack_require__(526);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VerticalRectSeries = function (_AbstractSeries) {
	  _inherits(VerticalRectSeries, _AbstractSeries);
	
	  function VerticalRectSeries() {
	    _classCallCheck(this, VerticalRectSeries);
	
	    return _possibleConstructorReturn(this, (VerticalRectSeries.__proto__ || Object.getPrototypeOf(VerticalRectSeries)).apply(this, arguments));
	  }
	
	  _createClass(VerticalRectSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_rectSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = false;
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return VerticalRectSeries;
	}(_abstractSeries2.default);
	
	VerticalRectSeries.displayName = 'VerticalRectSeries';
	
	exports.default = VerticalRectSeries;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Voronoi = __webpack_require__(900);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NOOP = function NOOP(f) {
	  return f;
	};
	
	function Voronoi(_ref) {
	  var className = _ref.className,
	      extent = _ref.extent,
	      nodes = _ref.nodes,
	      onBlur = _ref.onBlur,
	      _onClick = _ref.onClick,
	      _onMouseUp = _ref.onMouseUp,
	      _onMouseDown = _ref.onMouseDown,
	      onHover = _ref.onHover,
	      polygonStyle = _ref.polygonStyle,
	      style = _ref.style,
	      x = _ref.x,
	      y = _ref.y;
	
	  // Create a voronoi with each node center points
	  var voronoiInstance = (0, _d3Voronoi.voronoi)().x(x).y(y).extent(extent);
	
	  return _react2.default.createElement(
	    'g',
	    { className: className + ' rv-voronoi', style: style },
	    voronoiInstance.polygons(nodes).map(function (d, i) {
	      return _react2.default.createElement('path', {
	        className: 'rv-voronoi__cell ' + (d.data && d.data.className || ''),
	        d: 'M' + d.join('L') + 'Z',
	        onClick: function onClick() {
	          return _onClick(d.data);
	        },
	        onMouseUp: function onMouseUp() {
	          return _onMouseUp(d.data);
	        },
	        onMouseDown: function onMouseDown() {
	          return _onMouseDown(d.data);
	        },
	        onMouseOver: function onMouseOver() {
	          return onHover(d.data);
	        },
	        onMouseOut: function onMouseOut() {
	          return onBlur(d.data);
	        },
	        fill: 'none',
	        style: _extends({
	          pointerEvents: 'all'
	        }, polygonStyle, d.data && d.data.style),
	        key: i });
	    })
	  );
	}
	
	Voronoi.requiresSVG = true;
	
	Voronoi.defaultProps = {
	  className: '',
	  onBlur: NOOP,
	  onClick: NOOP,
	  onHover: NOOP,
	  onMouseDown: NOOP,
	  onMouseUp: NOOP,
	  x: function x(d) {
	    return d.x;
	  },
	  y: function y(d) {
	    return d.y;
	  }
	};
	
	Voronoi.propTypes = {
	  className: _propTypes2.default.string,
	  extent: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)).isRequired,
	  nodes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onHover: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  x: _propTypes2.default.func,
	  y: _propTypes2.default.func
	};
	
	exports.default = Voronoi;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _globalCache = __webpack_require__(947);
	
	var _globalCache2 = _interopRequireDefault(_globalCache);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var styleInterface = void 0;
	var styleTheme = void 0;
	var makeFromThemes = {};
	var internalId = 0;
	
	function registerTheme(theme) {
	  styleTheme = {
	    theme: theme,
	    styles: {}
	  };
	}
	
	function registerInterface(interfaceToRegister) {
	  styleInterface = interfaceToRegister;
	}
	
	function create(makeFromTheme, createWithDirection) {
	  // Get an id to associate with this stylesheet
	  var id = internalId;
	  internalId += 1;
	
	  var _styleTheme = styleTheme,
	      theme = _styleTheme.theme,
	      styles = _styleTheme.styles;
	
	  styles[id] = createWithDirection(makeFromTheme(theme));
	
	  makeFromThemes[id] = makeFromTheme;
	
	  return function () {
	    return styleTheme.styles[id];
	  };
	}
	
	function createLTR(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.create);
	}
	
	function createRTL(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
	}
	
	function get() {
	  return styleTheme.theme;
	}
	
	function resolve() {
	  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  return styleInterface.resolve(styles);
	}
	
	function resolveNoRTL() {
	  for (var _len2 = arguments.length, styles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    styles[_key2] = arguments[_key2];
	  }
	
	  if (styleInterface.resolveNoRTL) {
	    return styleInterface.resolveNoRTL(styles);
	  }
	
	  return resolve(styles);
	}
	
	function flush() {
	  if (styleInterface.flush) {
	    styleInterface.flush();
	  }
	}
	
	// Using globalCache in order to export a singleton. This file may be imported
	// in several places, which otherwise stomps over any registered themes and
	// resets to just the defaults.
	exports['default'] = _globalCache2['default'].setIfMissingThenGet('react-with-styles ThemedStyleSheet', function () {
	  return {
	    registerTheme: registerTheme,
	    registerInterface: registerInterface,
	    create: createLTR,
	    createRTL: createRTL,
	    get: get,
	    resolveNoRTL: resolveNoRTL,
	    resolve: resolve,
	    flush: flush
	  };
	});

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(321);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(959);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(298).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(1325);
	/*</replacement>*/
	
	// TODO(bmeurer): Change this back to const once hole checks are
	// properly optimized away early in Ignition+TurboFan.
	/*<replacement>*/
	var Buffer = __webpack_require__(375).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(222);
	util.inherits = __webpack_require__(98);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(3333);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(2968);
	var destroyImpl = __webpack_require__(1324);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(163);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(1404).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(163);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(1404).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(101)))

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(163);
	
	/*<replacement>*/
	var util = __webpack_require__(222);
	util.inherits = __webpack_require__(98);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return stream.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(321);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(298).EventEmitter;


/***/ },
/* 1326 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var identity = function identity(i) {
	  return i;
	};
	
	var PLACE_HOLDER = exports.PLACE_HOLDER = {
	  '@@functional/placeholder': true
	};
	
	var isPlaceHolder = function isPlaceHolder(val) {
	  return val === PLACE_HOLDER;
	};
	
	var curry0 = function curry0(fn) {
	  return function _curried() {
	    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
	      return _curried;
	    }
	
	    return fn.apply(undefined, arguments);
	  };
	};
	
	var curryN = function curryN(n, fn) {
	  if (n === 1) {
	    return fn;
	  }
	
	  return curry0(function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var argsLength = args.filter(function (arg) {
	      return arg !== PLACE_HOLDER;
	    }).length;
	
	    if (argsLength >= n) {
	      return fn.apply(undefined, args);
	    }
	
	    return curryN(n - argsLength, curry0(function () {
	      for (var _len2 = arguments.length, restArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        restArgs[_key2] = arguments[_key2];
	      }
	
	      var newArgs = args.map(function (arg) {
	        return isPlaceHolder(arg) ? restArgs.shift() : arg;
	      });
	
	      return fn.apply(undefined, _toConsumableArray(newArgs).concat(restArgs));
	    }));
	  });
	};
	
	var curry = exports.curry = function curry(fn) {
	  return curryN(fn.length, fn);
	};
	
	var range = exports.range = function range(begin, end) {
	  var arr = [];
	
	  for (var i = begin; i < end; ++i) {
	    arr[i - begin] = i;
	  }
	
	  return arr;
	};
	
	var map = exports.map = curry(function (fn, arr) {
	  if (Array.isArray(arr)) {
	    return arr.map(fn);
	  }
	
	  return Object.keys(arr).map(function (key) {
	    return arr[key];
	  }).map(fn);
	});
	
	var compose = exports.compose = function compose() {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  if (!args.length) {
	    return identity;
	  }
	
	  var fns = args.reverse();
	  // first function can receive multiply arguments
	  var firstFn = fns[0];
	  var tailsFn = fns.slice(1);
	
	  return function () {
	    return tailsFn.reduce(function (res, fn) {
	      return fn(res);
	    }, firstFn.apply(undefined, arguments));
	  };
	};
	
	var reverse = exports.reverse = function reverse(arr) {
	  if (Array.isArray(arr)) {
	    return arr.reverse();
	  }
	
	  // can be string
	  return arr.split('').reverse.join('');
	};
	
	var memoize = exports.memoize = function memoize(fn) {
	  var lastArgs = null;
	  var lastResult = null;
	
	  return function () {
	    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	      args[_key4] = arguments[_key4];
	    }
	
	    if (lastArgs && args.every(function (val, i) {
	      return val === lastArgs[i];
	    })) {
	      return lastResult;
	    }
	
	    lastArgs = args;
	    lastResult = fn.apply(undefined, args);
	
	    return lastResult;
	  };
	};

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _range2 = __webpack_require__(1008);
	
	var _range3 = _interopRequireDefault(_range2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Brush
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _d3Scale = __webpack_require__(1339);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(164);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _DataUtils = __webpack_require__(39);
	
	var _CssPrefixUtils = __webpack_require__(2992);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Brush = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Brush, _Component);
	
	  function Brush(props) {
	    _classCallCheck(this, Brush);
	
	    var _this = _possibleConstructorReturn(this, (Brush.__proto__ || Object.getPrototypeOf(Brush)).call(this, props));
	
	    _this.handleDrag = function (e) {
	      if (_this.leaveTimer) {
	        clearTimeout(_this.leaveTimer);
	        _this.leaveTimer = null;
	      }
	
	      if (_this.state.isTravellerMoving) {
	        _this.handleTravellerMove(e);
	      } else if (_this.state.isSlideMoving) {
	        _this.handleSlideDrag(e);
	      }
	    };
	
	    _this.handleTouchMove = function (e) {
	      if (e.changedTouches != null && e.changedTouches.length > 0) {
	        _this.handleDrag(e.changedTouches[0]);
	      }
	    };
	
	    _this.handleDragEnd = function () {
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: false
	      });
	    };
	
	    _this.handleLeaveWrapper = function () {
	      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
	        _this.leaveTimer = setTimeout(_this.handleDragEnd, 1000);
	      }
	    };
	
	    _this.handleEnterSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: true
	      });
	    };
	
	    _this.handleLeaveSlideOrTraveller = function () {
	      _this.setState({
	        isTextActive: false
	      });
	    };
	
	    _this.handleSlideDragStart = function (e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      _this.setState({
	        isTravellerMoving: false,
	        isSlideMoving: true,
	        slideMoveStartX: event.pageX
	      });
	    };
	
	    _this.travellerDragStartHandlers = {
	      startX: _this.handleTravellerDragStart.bind(_this, 'startX'),
	      endX: _this.handleTravellerDragStart.bind(_this, 'endX')
	    };
	
	    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
	    return _this;
	  }
	
	  _createClass(Brush, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          x = _props.x,
	          travellerWidth = _props.travellerWidth,
	          updateId = _props.updateId;
	
	
	      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
	        this.setState(this.updateScale(nextProps));
	      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
	        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
	        this.scaleValues = this.scale.domain().map(function (entry) {
	          return _this2.scale(entry);
	        });
	
	        this.setState({
	          startX: this.scale(nextProps.startIndex),
	          endX: this.scale(nextProps.endIndex)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.scale = null;
	      this.scaleValues = null;
	
	      if (this.leaveTimer) {
	        clearTimeout(this.leaveTimer);
	        this.leaveTimer = null;
	      }
	    }
	  }, {
	    key: 'getIndexInRange',
	    value: function getIndexInRange(range, x) {
	      var len = range.length;
	      var start = 0;
	      var end = len - 1;
	
	      while (end - start > 1) {
	        var middle = Math.floor((start + end) / 2);
	
	        if (range[middle] > x) {
	          end = middle;
	        } else {
	          start = middle;
	        }
	      }
	
	      return x >= range[end] ? end : start;
	    }
	  }, {
	    key: 'getIndex',
	    value: function getIndex(_ref) {
	      var startX = _ref.startX,
	          endX = _ref.endX;
	      var _props2 = this.props,
	          gap = _props2.gap,
	          data = _props2.data;
	
	      var lastIndex = data.length - 1;
	      var min = Math.min(startX, endX);
	      var max = Math.max(startX, endX);
	      var minIndex = this.getIndexInRange(this.scaleValues, min);
	      var maxIndex = this.getIndexInRange(this.scaleValues, max);
	      return {
	        startIndex: minIndex - minIndex % gap,
	        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
	      };
	    }
	  }, {
	    key: 'getTextOfTick',
	    value: function getTextOfTick(index) {
	      var _props3 = this.props,
	          data = _props3.data,
	          tickFormatter = _props3.tickFormatter,
	          dataKey = _props3.dataKey;
	
	      var text = (0, _ChartUtils.getValueByDataKey)(data[index], dataKey, index);
	
	      return (0, _isFunction3.default)(tickFormatter) ? tickFormatter(text) : text;
	    }
	  }, {
	    key: 'handleSlideDrag',
	    value: function handleSlideDrag(e) {
	      var _state = this.state,
	          slideMoveStartX = _state.slideMoveStartX,
	          startX = _state.startX,
	          endX = _state.endX;
	      var _props4 = this.props,
	          x = _props4.x,
	          width = _props4.width,
	          travellerWidth = _props4.travellerWidth,
	          startIndex = _props4.startIndex,
	          endIndex = _props4.endIndex,
	          onChange = _props4.onChange;
	
	      var delta = e.pageX - slideMoveStartX;
	
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - startX, x - endX);
	      }
	      var newIndex = this.getIndex({
	        startX: startX + delta,
	        endX: endX + delta
	      });
	
	      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
	        onChange(newIndex);
	      }
	
	      this.setState({
	        startX: startX + delta,
	        endX: endX + delta,
	        slideMoveStartX: e.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerDragStart',
	    value: function handleTravellerDragStart(id, e) {
	      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
	
	      this.setState({
	        isSlideMoving: false,
	        isTravellerMoving: true,
	        movingTravellerId: id,
	        brushMoveStartX: event.pageX
	      });
	    }
	  }, {
	    key: 'handleTravellerMove',
	    value: function handleTravellerMove(e) {
	      var _setState;
	
	      var _state2 = this.state,
	          brushMoveStartX = _state2.brushMoveStartX,
	          movingTravellerId = _state2.movingTravellerId,
	          endX = _state2.endX,
	          startX = _state2.startX;
	
	      var prevValue = this.state[movingTravellerId];
	
	      var _props5 = this.props,
	          x = _props5.x,
	          width = _props5.width,
	          travellerWidth = _props5.travellerWidth,
	          onChange = _props5.onChange,
	          gap = _props5.gap,
	          data = _props5.data;
	
	      var params = { startX: this.state.startX, endX: this.state.endX };
	
	      var delta = e.pageX - brushMoveStartX;
	      if (delta > 0) {
	        delta = Math.min(delta, x + width - travellerWidth - prevValue);
	      } else if (delta < 0) {
	        delta = Math.max(delta, x - prevValue);
	      }
	
	      params[movingTravellerId] = prevValue + delta;
	
	      var newIndex = this.getIndex(params);
	      var startIndex = newIndex.startIndex,
	          endIndex = newIndex.endIndex;
	
	      var isFullGap = function isFullGap() {
	        var lastIndex = data.length - 1;
	        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
	          return true;
	        }
	        return false;
	      };
	
	      this.setState((_setState = {}, _defineProperty(_setState, movingTravellerId, prevValue + delta), _defineProperty(_setState, 'brushMoveStartX', e.pageX), _setState), function () {
	        if (onChange) {
	          if (isFullGap()) {
	            onChange(newIndex);
	          }
	        }
	      });
	    }
	  }, {
	    key: 'updateScale',
	    value: function updateScale(props) {
	      var _this3 = this;
	
	      var data = props.data,
	          startIndex = props.startIndex,
	          endIndex = props.endIndex,
	          x = props.x,
	          width = props.width,
	          travellerWidth = props.travellerWidth;
	
	      var len = data.length;
	      this.scale = (0, _d3Scale.scalePoint)().domain((0, _range3.default)(0, len)).range([x, x + width - travellerWidth]);
	      this.scaleValues = this.scale.domain().map(function (entry) {
	        return _this3.scale(entry);
	      });
	      return {
	        isTextActive: false,
	        isSlideMoving: false,
	        isTravellerMoving: false,
	        startX: this.scale(startIndex),
	        endX: this.scale(endIndex)
	      };
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          fill = _props6.fill,
	          stroke = _props6.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        stroke: stroke,
	        fill: fill,
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, {
	    key: 'renderPanorama',
	    value: function renderPanorama() {
	      var _props7 = this.props,
	          x = _props7.x,
	          y = _props7.y,
	          width = _props7.width,
	          height = _props7.height,
	          data = _props7.data,
	          children = _props7.children,
	          padding = _props7.padding;
	
	      var chartElement = _react.Children.only(children);
	
	      if (!chartElement) {
	        return null;
	      }
	
	      return _react2.default.cloneElement(chartElement, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        margin: padding,
	        compact: true,
	        data: data
	      });
	    }
	  }, {
	    key: 'renderTraveller',
	    value: function renderTraveller(travellerX, id) {
	      var _props8 = this.props,
	          y = _props8.y,
	          travellerWidth = _props8.travellerWidth,
	          height = _props8.height,
	          stroke = _props8.stroke;
	
	      var lineY = Math.floor(y + height / 2) - 1;
	      var x = Math.max(travellerX, this.props.x);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: 'recharts-brush-traveller',
	          onMouseEnter: this.handleEnterSlideOrTraveller,
	          onMouseLeave: this.handleLeaveSlideOrTraveller,
	          onMouseDown: this.travellerDragStartHandlers[id],
	          onTouchStart: this.travellerDragStartHandlers[id],
	          style: { cursor: 'col-resize' }
	        },
	        _react2.default.createElement('rect', {
	          x: x,
	          y: y,
	          width: travellerWidth,
	          height: height,
	          fill: stroke,
	          stroke: 'none'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY,
	          x2: x + travellerWidth - 1,
	          y2: lineY,
	          fill: 'none',
	          stroke: '#fff'
	        }),
	        _react2.default.createElement('line', {
	          x1: x + 1,
	          y1: lineY + 2,
	          x2: x + travellerWidth - 1,
	          y2: lineY + 2,
	          fill: 'none',
	          stroke: '#fff'
	        })
	      );
	    }
	  }, {
	    key: 'renderSlide',
	    value: function renderSlide(startX, endX) {
	      var _props9 = this.props,
	          y = _props9.y,
	          height = _props9.height,
	          stroke = _props9.stroke;
	
	
	      return _react2.default.createElement('rect', {
	        className: 'recharts-brush-slide',
	        onMouseEnter: this.handleEnterSlideOrTraveller,
	        onMouseLeave: this.handleLeaveSlideOrTraveller,
	        onMouseDown: this.handleSlideDragStart,
	        onTouchStart: this.handleSlideDragStart,
	        style: { cursor: 'move' },
	        stroke: 'none',
	        fill: stroke,
	        fillOpacity: 0.2,
	        x: Math.min(startX, endX),
	        y: y,
	        width: Math.abs(endX - startX),
	        height: height
	      });
	    }
	  }, {
	    key: 'renderText',
	    value: function renderText() {
	      var _props10 = this.props,
	          startIndex = _props10.startIndex,
	          endIndex = _props10.endIndex,
	          y = _props10.y,
	          height = _props10.height,
	          travellerWidth = _props10.travellerWidth,
	          stroke = _props10.stroke;
	      var _state3 = this.state,
	          startX = _state3.startX,
	          endX = _state3.endX;
	
	      var offset = 5;
	      var attrs = {
	        pointerEvents: 'none',
	        fill: stroke
	      };
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-brush-texts' },
	        _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            textAnchor: 'end',
	            verticalAnchor: 'middle',
	            x: Math.min(startX, endX) - offset,
	            y: y + height / 2
	          }, attrs),
	          this.getTextOfTick(startIndex)
	        ),
	        _react2.default.createElement(
	          _Text2.default,
	          _extends({
	            textAnchor: 'start',
	            verticalAnchor: 'middle',
	            x: Math.max(startX, endX) + travellerWidth + offset,
	            y: y + height / 2
	          }, attrs),
	          this.getTextOfTick(endIndex)
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props11 = this.props,
	          data = _props11.data,
	          className = _props11.className,
	          children = _props11.children,
	          x = _props11.x,
	          y = _props11.y,
	          width = _props11.width,
	          height = _props11.height;
	      var _state4 = this.state,
	          startX = _state4.startX,
	          endX = _state4.endX,
	          isTextActive = _state4.isTextActive,
	          isSlideMoving = _state4.isSlideMoving,
	          isTravellerMoving = _state4.isTravellerMoving;
	
	
	      if (!data || !data.length || !(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || width <= 0 || height <= 0) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-brush', className);
	      var isPanoramic = _react2.default.Children.count(children) === 1;
	      var style = (0, _CssPrefixUtils.generatePrefixStyle)('userSelect', 'none');
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        {
	          className: layerClass,
	          onMouseMove: this.handleDrag,
	          onMouseLeave: this.handleLeaveWrapper,
	          onMouseUp: this.handleDragEnd,
	          onTouchEnd: this.handleDragEnd,
	          onTouchMove: this.handleTouchMove,
	          style: style
	        },
	        this.renderBackground(),
	        isPanoramic && this.renderPanorama(),
	        this.renderSlide(startX, endX),
	        this.renderTraveller(startX, 'startX'),
	        this.renderTraveller(endX, 'endX'),
	        (isTextActive || isSlideMoving || isTravellerMoving) && this.renderText()
	      );
	    }
	  }]);
	
	  return Brush;
	}(_react.Component), _class2.displayName = 'Brush', _class2.propTypes = {
	  className: _propTypes2.default.string,
	
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number.isRequired,
	  travellerWidth: _propTypes2.default.number,
	  gap: _propTypes2.default.number,
	  padding: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  }),
	
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.array,
	  startIndex: _propTypes2.default.number,
	  endIndex: _propTypes2.default.number,
	  tickFormatter: _propTypes2.default.func,
	
	  children: _propTypes2.default.node,
	
	  onChange: _propTypes2.default.func,
	  updateId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class2.defaultProps = {
	  height: 40,
	  travellerWidth: 5,
	  gap: 1,
	  fill: '#fff',
	  stroke: '#666',
	  padding: { top: 1, right: 1, bottom: 1, left: 1 }
	}, _temp)) || _class;
	
	exports.default = Brush;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Cartesian Axis
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _DOMUtils = __webpack_require__(536);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Text = __webpack_require__(164);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianAxis = (_temp = _class = function (_Component) {
	  _inherits(CartesianAxis, _Component);
	
	  function CartesianAxis() {
	    _classCallCheck(this, CartesianAxis);
	
	    return _possibleConstructorReturn(this, (CartesianAxis.__proto__ || Object.getPrototypeOf(CartesianAxis)).apply(this, arguments));
	  }
	
	  _createClass(CartesianAxis, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_ref, state) {
	      var viewBox = _ref.viewBox,
	          restProps = _objectWithoutProperties(_ref, ['viewBox']);
	
	      // props.viewBox is sometimes generated every time -
	      // check that specially as object equality is likely to fail
	      var _props = this.props,
	          viewBoxOld = _props.viewBox,
	          restPropsOld = _objectWithoutProperties(_props, ['viewBox']);
	
	      return !(0, _PureRender.shallowEqual)(viewBox, viewBoxOld) || !(0, _PureRender.shallowEqual)(restProps, restPropsOld) || !(0, _PureRender.shallowEqual)(state, this.state);
	    }
	
	    /**
	     * Calculate the coordinates of endpoints in ticks
	     * @param  {Object} data The data of a simple tick
	     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
	     *  (x2, y2): The coordinate of endpoint close to axis
	     */
	
	  }, {
	    key: 'getTickLineCoord',
	    value: function getTickLineCoord(data) {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          width = _props2.width,
	          height = _props2.height,
	          orientation = _props2.orientation,
	          tickSize = _props2.tickSize,
	          mirror = _props2.mirror,
	          tickMargin = _props2.tickMargin;
	
	      var x1 = void 0,
	          x2 = void 0,
	          y1 = void 0,
	          y2 = void 0,
	          tx = void 0,
	          ty = void 0;
	
	      var sign = mirror ? -1 : 1;
	      var finalTickSize = data.tickSize || tickSize;
	      var tickCoord = (0, _DataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
	
	      switch (orientation) {
	        case 'top':
	          x1 = x2 = data.coordinate;
	          y2 = y + !mirror * height;
	          y1 = y2 - sign * finalTickSize;
	          ty = y1 - sign * tickMargin;
	          tx = tickCoord;
	          break;
	        case 'left':
	          y1 = y2 = data.coordinate;
	          x2 = x + !mirror * width;
	          x1 = x2 - sign * finalTickSize;
	          tx = x1 - sign * tickMargin;
	          ty = tickCoord;
	          break;
	        case 'right':
	          y1 = y2 = data.coordinate;
	          x2 = x + mirror * width;
	          x1 = x2 + sign * finalTickSize;
	          tx = x1 + sign * tickMargin;
	          ty = tickCoord;
	          break;
	        default:
	          x1 = x2 = data.coordinate;
	          y2 = y + mirror * height;
	          y1 = y2 + sign * finalTickSize;
	          ty = y1 + sign * tickMargin;
	          tx = tickCoord;
	          break;
	      }
	
	      return { line: { x1: x1, y1: y1, x2: x2, y2: y2 }, tick: { x: tx, y: ty } };
	    }
	  }, {
	    key: 'getTickTextAnchor',
	    value: function getTickTextAnchor() {
	      var _props3 = this.props,
	          orientation = _props3.orientation,
	          mirror = _props3.mirror;
	
	      var textAnchor = void 0;
	
	      switch (orientation) {
	        case 'left':
	          textAnchor = mirror ? 'start' : 'end';
	          break;
	        case 'right':
	          textAnchor = mirror ? 'end' : 'start';
	          break;
	        default:
	          textAnchor = 'middle';
	          break;
	      }
	
	      return textAnchor;
	    }
	  }, {
	    key: 'getTickVerticalAnchor',
	    value: function getTickVerticalAnchor() {
	      var _props4 = this.props,
	          orientation = _props4.orientation,
	          mirror = _props4.mirror;
	
	      var verticalAnchor = 'end';
	
	      switch (orientation) {
	        case 'left':
	        case 'right':
	          verticalAnchor = 'middle';
	          break;
	        case 'top':
	          verticalAnchor = mirror ? 'start' : 'end';
	          break;
	        default:
	          verticalAnchor = mirror ? 'end' : 'start';
	          break;
	      }
	
	      return verticalAnchor;
	    }
	  }, {
	    key: 'renderAxisLine',
	    value: function renderAxisLine() {
	      var _props5 = this.props,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height,
	          orientation = _props5.orientation,
	          axisLine = _props5.axisLine,
	          mirror = _props5.mirror;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, (0, _ReactUtils.getPresentationAttributes)(axisLine));
	
	      if (orientation === 'top' || orientation === 'bottom') {
	        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
	        props = _extends({}, props, {
	          x1: x,
	          y1: y + needHeight * height,
	          x2: x + width,
	          y2: y + needHeight * height
	        });
	      } else {
	        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
	        props = _extends({}, props, {
	          x1: x + needWidth * width,
	          y1: y,
	          x2: x + needWidth * width,
	          y2: y + height
	        });
	      }
	
	      return _react2.default.createElement('line', _extends({ className: 'recharts-cartesian-axis-line' }, props));
	    }
	  }, {
	    key: 'renderTickItem',
	    value: function renderTickItem(option, props, value) {
	      var tickItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        tickItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        tickItem = option(props);
	      } else {
	        tickItem = _react2.default.createElement(
	          _Text2.default,
	          _extends({}, props, {
	            className: 'recharts-cartesian-axis-tick-value'
	          }),
	          value
	        );
	      }
	
	      return tickItem;
	    }
	
	    /**
	     * render the ticks
	     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
	     * @return {ReactComponent} renderedTicks
	     */
	
	  }, {
	    key: 'renderTicks',
	    value: function renderTicks(ticks) {
	      var _this2 = this;
	
	      var _props6 = this.props,
	          tickLine = _props6.tickLine,
	          stroke = _props6.stroke,
	          tick = _props6.tick,
	          tickFormatter = _props6.tickFormatter,
	          unit = _props6.unit;
	
	      var finalTicks = CartesianAxis.getTicks(_extends({}, this.props, { ticks: ticks }));
	      var textAnchor = this.getTickTextAnchor();
	      var verticalAnchor = this.getTickVerticalAnchor();
	      var axisProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customTickProps = (0, _ReactUtils.getPresentationAttributes)(tick);
	      var tickLineProps = _extends({}, axisProps, { fill: 'none' }, (0, _ReactUtils.getPresentationAttributes)(tickLine));
	      var items = finalTicks.map(function (entry, i) {
	        var _getTickLineCoord = _this2.getTickLineCoord(entry),
	            lineCoord = _getTickLineCoord.line,
	            tickCoord = _getTickLineCoord.tick;
	
	        var tickProps = _extends({
	          textAnchor: textAnchor,
	          verticalAnchor: verticalAnchor
	        }, axisProps, {
	          stroke: 'none', fill: stroke
	        }, customTickProps, tickCoord, {
	          index: i, payload: entry,
	          visibleTicksCount: finalTicks.length
	        });
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-cartesian-axis-tick',
	            key: 'tick-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          tickLine && _react2.default.createElement('line', _extends({
	            className: 'recharts-cartesian-axis-tick-line'
	          }, tickLineProps, lineCoord)),
	          tick && _this2.renderTickItem(tick, tickProps, '' + ((0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value) + (unit || ''))
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-axis-ticks' },
	        items
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props7 = this.props,
	          axisLine = _props7.axisLine,
	          width = _props7.width,
	          height = _props7.height,
	          ticksGenerator = _props7.ticksGenerator,
	          className = _props7.className,
	          hide = _props7.hide;
	
	
	      if (hide) {
	        return null;
	      }
	
	      var _props8 = this.props,
	          ticks = _props8.ticks,
	          noTicksProps = _objectWithoutProperties(_props8, ['ticks']);
	
	      var finalTicks = ticks;
	
	      if ((0, _isFunction3.default)(ticksGenerator)) {
	        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
	      }
	
	      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-cartesian-axis', className) },
	        axisLine && this.renderAxisLine(),
	        this.renderTicks(finalTicks),
	        _Label2.default.renderCallByParent(this.props)
	      );
	    }
	  }], [{
	    key: 'getTicks',
	    value: function getTicks(props) {
	      var tick = props.tick,
	          ticks = props.ticks,
	          viewBox = props.viewBox,
	          minTickGap = props.minTickGap,
	          orientation = props.orientation,
	          interval = props.interval,
	          tickFormatter = props.tickFormatter,
	          unit = props.unit;
	
	
	      if (!ticks || !ticks.length || !tick) {
	        return [];
	      }
	
	      if ((0, _DataUtils.isNumber)(interval) || (0, _ReactUtils.isSsr)()) {
	        return CartesianAxis.getNumberIntervalTicks(ticks, (0, _DataUtils.isNumber)(interval) ? interval : 0);
	      }
	
	      if (interval === 'preserveStartEnd') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
	        }, true);
	      } else if (interval === 'preserveStart') {
	        return CartesianAxis.getTicksStart({
	          ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
	        });
	      }
	
	      return CartesianAxis.getTicksEnd({
	        ticks: ticks, tickFormatter: tickFormatter, viewBox: viewBox, orientation: orientation, minTickGap: minTickGap, unit: unit
	      });
	    }
	  }, {
	    key: 'getNumberIntervalTicks',
	    value: function getNumberIntervalTicks(ticks, interval) {
	      return ticks.filter(function (entry, i) {
	        return i % (interval + 1) === 0;
	      });
	    }
	  }, {
	    key: 'getTicksStart',
	    value: function getTicksStart(_ref2, preserveEnd) {
	      var ticks = _ref2.ticks,
	          tickFormatter = _ref2.tickFormatter,
	          viewBox = _ref2.viewBox,
	          orientation = _ref2.orientation,
	          minTickGap = _ref2.minTickGap,
	          unit = _ref2.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var result = (ticks || []).slice();
	      var unitSize = unit ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      if (preserveEnd) {
	        // Try to guarantee the tail to be displayed
	        var tail = ticks[len - 1];
	        var tailContent = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(tail.value) : tail.value;
	        var tailSize = (0, _DOMUtils.getStringSize)(tailContent)[sizeKey] + unitSize;
	        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
	        result[len - 1] = tail = _extends({}, tail, {
	          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
	        });
	
	        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
	
	        if (isTailShow) {
	          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
	          result[len - 1] = _extends({}, tail, { isShow: true });
	        }
	      }
	
	      var count = preserveEnd ? len - 1 : len;
	      for (var i = 0; i < count; i++) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (i === 0) {
	          var gap = sign * (entry.coordinate - sign * size / 2 - start);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          start = entry.tickCoord + sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }, {
	    key: 'getTicksEnd',
	    value: function getTicksEnd(_ref3) {
	      var ticks = _ref3.ticks,
	          tickFormatter = _ref3.tickFormatter,
	          viewBox = _ref3.viewBox,
	          orientation = _ref3.orientation,
	          minTickGap = _ref3.minTickGap,
	          unit = _ref3.unit;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
	      var unitSize = unit ? (0, _DOMUtils.getStringSize)(unit)[sizeKey] : 0;
	      var result = (ticks || []).slice();
	      var len = result.length;
	      var sign = len >= 2 ? (0, _DataUtils.mathSign)(result[1].coordinate - result[0].coordinate) : 1;
	
	      var start = void 0,
	          end = void 0;
	
	      if (sign === 1) {
	        start = sizeKey === 'width' ? x : y;
	        end = sizeKey === 'width' ? x + width : y + height;
	      } else {
	        start = sizeKey === 'width' ? x + width : y + height;
	        end = sizeKey === 'width' ? x : y;
	      }
	
	      for (var i = len - 1; i >= 0; i--) {
	        var entry = result[i];
	        var content = (0, _isFunction3.default)(tickFormatter) ? tickFormatter(entry.value) : entry.value;
	        var size = (0, _DOMUtils.getStringSize)(content)[sizeKey] + unitSize;
	
	        if (i === len - 1) {
	          var gap = sign * (entry.coordinate + sign * size / 2 - end);
	          result[i] = entry = _extends({}, entry, {
	            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
	          });
	        } else {
	          result[i] = entry = _extends({}, entry, { tickCoord: entry.coordinate });
	        }
	
	        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
	
	        if (isShow) {
	          end = entry.tickCoord - sign * (size / 2 + minTickGap);
	          result[i] = _extends({}, entry, { isShow: true });
	        }
	      }
	
	      return result.filter(function (entry) {
	        return entry.isShow;
	      });
	    }
	  }]);
	
	  return CartesianAxis;
	}(_react.Component), _class.displayName = 'CartesianAxis', _class.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  orientation: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']),
	  // The viewBox of svg
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	  tick: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  axisLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  tickLine: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
	  mirror: _propTypes2.default.bool,
	  tickMargin: _propTypes2.default.number.isRequired,
	
	  minTickGap: _propTypes2.default.number,
	  ticks: _propTypes2.default.array,
	  tickSize: _propTypes2.default.number,
	  stroke: _propTypes2.default.string,
	  tickFormatter: _propTypes2.default.func,
	  ticksGenerator: _propTypes2.default.func,
	  interval: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
	}), _class.defaultProps = {
	  x: 0,
	  y: 0,
	  width: 0,
	  height: 0,
	  viewBox: { x: 0, y: 0, width: 0, height: 0 },
	  // The orientation of axis
	  orientation: 'bottom',
	  // The ticks
	  ticks: [],
	
	  stroke: '#666',
	  tickLine: true,
	  axisLine: true,
	  tick: true,
	  mirror: false,
	
	  minTickGap: 5,
	  // The width or height of tick
	  tickSize: 6,
	  tickMargin: 2,
	  interval: 'preserveEnd'
	}, _temp);
	exports.default = CartesianAxis;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Line
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	var _CartesianUtils = __webpack_require__(139);
	
	var _Rectangle = __webpack_require__(207);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceArea = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceArea, _Component);
	
	  function ReferenceArea() {
	    _classCallCheck(this, ReferenceArea);
	
	    return _possibleConstructorReturn(this, (ReferenceArea.__proto__ || Object.getPrototypeOf(ReferenceArea)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceArea, [{
	    key: 'getRect',
	    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
	      var _props = this.props,
	          xValue1 = _props.x1,
	          xValue2 = _props.x2,
	          yValue1 = _props.y1,
	          yValue2 = _props.y2,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	
	      var scale = _CartesianUtils.LabeledScaleHelper.create({ x: xAxis.scale, y: yAxis.scale });
	
	      var p1 = {
	        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
	        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
	      };
	
	      var p2 = {
	        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
	        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
	      };
	
	      if (scale.isInRange(p1) && scale.isInRange(p2)) {
	        return (0, _CartesianUtils.rectWithPoints)(p1, p2);
	      }
	
	      return null;
	    }
	  }, {
	    key: 'renderRect',
	    value: function renderRect(option, props) {
	      var rect = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        rect = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        rect = option(props);
	      } else {
	        rect = _react2.default.createElement(_Rectangle2.default, _extends({}, props, {
	          className: 'recharts-reference-area-rect'
	        }));
	      }
	
	      return rect;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x1 = _props2.x1,
	          x2 = _props2.x2,
	          y1 = _props2.y1,
	          y2 = _props2.y2,
	          className = _props2.className;
	
	
	      var hasX1 = (0, _DataUtils.isNumOrStr)(x1);
	      var hasX2 = (0, _DataUtils.isNumOrStr)(x2);
	      var hasY1 = (0, _DataUtils.isNumOrStr)(y1);
	      var hasY2 = (0, _DataUtils.isNumOrStr)(y2);
	
	      if (!hasX1 && !hasX2 && !hasY1 && !hasY2) {
	        return null;
	      }
	
	      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);
	
	      if (!rect) {
	        return null;
	      }
	
	      var shape = this.props.shape;
	
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-area', className) },
	        this.renderRect(shape, _extends({}, this.props, rect)),
	        _Label2.default.renderCallByParent(this.props, rect)
	      );
	    }
	  }]);
	
	  return ReferenceArea;
	}(_react.Component), _class2.displayName = 'ReferenceArea', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  x2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y1: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y2: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#ccc',
	  fillOpacity: 0.5,
	  stroke: 'none',
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceArea;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Reference Dot
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Dot = __webpack_require__(165);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DataUtils = __webpack_require__(39);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReferenceDot = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceDot, _Component);
	
	  function ReferenceDot() {
	    _classCallCheck(this, ReferenceDot);
	
	    return _possibleConstructorReturn(this, (ReferenceDot.__proto__ || Object.getPrototypeOf(ReferenceDot)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceDot, [{
	    key: 'getCoordinate',
	    value: function getCoordinate() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          xAxis = _props.xAxis,
	          yAxis = _props.yAxis;
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({ x: xAxis.scale, y: yAxis.scale });
	
	      var result = scales.apply({ x: x, y: y }, { bandAware: true });
	
	      return scales.isInRange(result) ? result : null;
	    }
	  }, {
	    key: 'renderDot',
	    value: function renderDot(option, props) {
	      var dot = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dot = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dot = option(props);
	      } else {
	        dot = _react2.default.createElement(_Dot2.default, _extends({}, props, {
	          cx: props.cx,
	          cy: props.cy,
	          className: 'recharts-reference-dot-dot'
	        }));
	      }
	
	      return dot;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          x = _props2.x,
	          y = _props2.y,
	          r = _props2.r;
	
	      var isX = (0, _DataUtils.isNumOrStr)(x);
	      var isY = (0, _DataUtils.isNumOrStr)(y);
	
	      if (!isX || !isY) {
	        return null;
	      }
	
	      var coordinate = this.getCoordinate();
	
	      if (!coordinate) {
	        return null;
	      }
	
	      var cx = coordinate.x,
	          cy = coordinate.y;
	      var _props3 = this.props,
	          shape = _props3.shape,
	          className = _props3.className;
	
	
	      var dotProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        cx: cx,
	        cy: cy
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-dot', className) },
	        this.renderDot(shape, dotProps),
	        _Label2.default.renderCallByParent(this.props, {
	          x: cx - r,
	          y: cy - r,
	          width: 2 * r,
	          height: 2 * r
	        })
	      );
	    }
	  }]);
	
	  return ReferenceDot;
	}(_react.Component), _class2.displayName = 'ReferenceDot', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  r: _propTypes2.default.number,
	
	  xAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	  yAxis: _propTypes2.default.shape({ scale: _propTypes2.default.func }),
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element])
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  r: 10,
	  fill: '#fff',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceDot;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview Reference Line
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _DataUtils = __webpack_require__(39);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var renderLine = function renderLine(option, props) {
	  var line = void 0;
	
	  if (_react2.default.isValidElement(option)) {
	    line = _react2.default.cloneElement(option, props);
	  } else if ((0, _isFunction3.default)(option)) {
	    line = option(props);
	  } else {
	    line = _react2.default.createElement('line', _extends({}, props, {
	      className: 'recharts-reference-line-line'
	    }));
	  }
	
	  return line;
	};
	
	var ReferenceLine = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(ReferenceLine, _Component);
	
	  function ReferenceLine() {
	    _classCallCheck(this, ReferenceLine);
	
	    return _possibleConstructorReturn(this, (ReferenceLine.__proto__ || Object.getPrototypeOf(ReferenceLine)).apply(this, arguments));
	  }
	
	  _createClass(ReferenceLine, [{
	    key: 'getEndPoints',
	    value: function getEndPoints(scales, isFixedX, isFixedY) {
	      var viewBox = this.props.viewBox;
	      var x = viewBox.x,
	          y = viewBox.y,
	          width = viewBox.width,
	          height = viewBox.height;
	
	
	      if (isFixedY) {
	        var _props = this.props,
	            yCoord = _props.y,
	            orientation = _props.yAxis.orientation;
	
	        var coord = scales.y.apply(yCoord);
	        if (scales.y.isInRange(coord)) {
	          var points = [{ x: x + width, y: coord }, { x: x, y: coord }];
	          return orientation === 'left' ? points.reverse() : points;
	        }
	      } else if (isFixedX) {
	        var _props2 = this.props,
	            xCoord = _props2.x,
	            _orientation = _props2.xAxis.orientation;
	
	        var _coord = scales.x.apply(xCoord);
	        if (scales.x.isInRange(_coord)) {
	          var _points = [{ x: _coord, y: y + height }, { x: _coord, y: y }];
	          return _orientation === 'top' ? _points.reverse() : _points;
	        }
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          fixedX = _props3.x,
	          fixedY = _props3.y,
	          xAxis = _props3.xAxis,
	          yAxis = _props3.yAxis,
	          shape = _props3.shape,
	          className = _props3.className;
	
	
	      var scales = _CartesianUtils.LabeledScaleHelper.create({ x: xAxis.scale, y: yAxis.scale });
	
	      var isX = (0, _DataUtils.isNumOrStr)(fixedX);
	      var isY = (0, _DataUtils.isNumOrStr)(fixedY);
	
	      var endPoints = this.getEndPoints(scales, isX, isY);
	      if (!endPoints) {
	        return null;
	      }
	
	      var _endPoints = _slicedToArray(endPoints, 2),
	          _endPoints$ = _endPoints[0],
	          x1 = _endPoints$.x,
	          y1 = _endPoints$.y,
	          _endPoints$2 = _endPoints[1],
	          x2 = _endPoints$2.x,
	          y2 = _endPoints$2.y;
	
	      var props = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), (0, _ReactUtils.filterEventAttributes)(this.props), {
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: (0, _classnames2.default)('recharts-reference-line', className) },
	        renderLine(shape, props),
	        _Label2.default.renderCallByParent(this.props, (0, _CartesianUtils.rectWithCoords)({ x1: x1, y1: y1, x2: x2, y2: y2 }))
	      );
	    }
	  }]);
	
	  return ReferenceLine;
	}(_react.Component), _class2.displayName = 'ReferenceLine', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  viewBox: _propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    width: _propTypes2.default.number,
	    height: _propTypes2.default.number
	  }),
	
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	
	  isFront: _propTypes2.default.bool,
	  alwaysShow: _propTypes2.default.bool,
	  x: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  y: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  className: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  yAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  xAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  shape: _propTypes2.default.func
	}), _class2.defaultProps = {
	  isFront: false,
	  alwaysShow: false,
	  xAxisId: 0,
	  yAxisId: 0,
	  fill: 'none',
	  stroke: '#ccc',
	  fillOpacity: 1,
	  strokeWidth: 1
	}, _temp)) || _class;
	
	exports.default = ReferenceLine;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isPlainObject2 = __webpack_require__(88);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNil2 = __webpack_require__(63);
	
	var _isNil3 = _interopRequireDefault(_isNil2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render sectors of a pie
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Sector = __webpack_require__(360);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Curve = __webpack_require__(206);
	
	var _Curve2 = _interopRequireDefault(_Curve);
	
	var _Text = __webpack_require__(164);
	
	var _Text2 = _interopRequireDefault(_Text);
	
	var _Label = __webpack_require__(137);
	
	var _Label2 = _interopRequireDefault(_Label);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _Cell = __webpack_require__(258);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _LogUtils = __webpack_require__(1336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Pie = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Pie, _Component);
	
	  function Pie() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Pie);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pie.__proto__ || Object.getPrototypeOf(Pie)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false, isAnimationStarted: false }, _this.id = (0, _DataUtils.uniqueId)('recharts-pie-'), _this.cachePrevData = function (sectors) {
	      _this.setState({ prevSectors: sectors });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({
	        isAnimationFinished: true
	      });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({
	        isAnimationStarted: true
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Pie, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          sectors = _props.sectors;
	
	
	      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
	        this.cachePrevData([]);
	      } else if (nextProps.animationId !== animationId) {
	        this.cachePrevData(sectors);
	      }
	    }
	  }, {
	    key: 'getTextAnchor',
	    value: function getTextAnchor(x, cx) {
	      if (x > cx) {
	        return 'start';
	      } else if (x < cx) {
	        return 'end';
	      }
	
	      return 'middle';
	    }
	  }, {
	    key: 'isActiveIndex',
	    value: function isActiveIndex(i) {
	      var activeIndex = this.props.activeIndex;
	
	
	      if (Array.isArray(activeIndex)) {
	        return activeIndex.indexOf(i) !== -1;
	      }
	
	      return i === activeIndex;
	    }
	  }, {
	    key: 'renderLabelLineItem',
	    value: function renderLabelLineItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Curve2.default, _extends({}, props, { type: 'linear', className: 'recharts-pie-label-line' }));
	    }
	  }, {
	    key: 'renderLabelItem',
	    value: function renderLabelItem(option, props, value) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      }
	      var label = value;
	      if ((0, _isFunction3.default)(option)) {
	        label = option(props);
	        if (_react2.default.isValidElement(label)) {
	          return label;
	        }
	      }
	
	      return _react2.default.createElement(
	        _Text2.default,
	        _extends({}, props, {
	          alignmentBaseline: 'middle',
	          className: 'recharts-pie-label-text'
	        }),
	        label
	      );
	    }
	  }, {
	    key: 'renderLabels',
	    value: function renderLabels(sectors) {
	      var _this2 = this;
	
	      var isAnimationActive = this.props.isAnimationActive;
	
	
	      if (isAnimationActive && !this.state.isAnimationFinished) {
	        return null;
	      }
	      var _props2 = this.props,
	          label = _props2.label,
	          labelLine = _props2.labelLine,
	          dataKey = _props2.dataKey,
	          valueKey = _props2.valueKey;
	
	      var pieProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customLabelProps = (0, _ReactUtils.getPresentationAttributes)(label);
	      var customLabelLineProps = (0, _ReactUtils.getPresentationAttributes)(labelLine);
	      var offsetRadius = label && label.offsetRadius || 20;
	
	      var labels = sectors.map(function (entry, i) {
	        var midAngle = (entry.startAngle + entry.endAngle) / 2;
	        var endPoint = (0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);
	        var labelProps = _extends({}, pieProps, entry, {
	          stroke: 'none'
	        }, customLabelProps, {
	          index: i,
	          textAnchor: _this2.getTextAnchor(endPoint.x, entry.cx)
	        }, endPoint);
	        var lineProps = _extends({}, pieProps, entry, {
	          fill: 'none',
	          stroke: entry.fill
	        }, customLabelLineProps, {
	          index: i,
	          points: [(0, _PolarUtils.polarToCartesian)(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint]
	        });
	        var realDataKey = dataKey;
	        // TODO: compatible to lower versions
	        if ((0, _isNil3.default)(dataKey) && (0, _isNil3.default)(valueKey)) {
	          realDataKey = 'value';
	        } else if ((0, _isNil3.default)(dataKey)) {
	          realDataKey = valueKey;
	        }
	
	        return _react2.default.createElement(
	          _Layer2.default,
	          { key: 'label-' + i },
	          labelLine && _this2.renderLabelLineItem(labelLine, lineProps),
	          _this2.renderLabelItem(label, labelProps, (0, _ChartUtils.getValueByDataKey)(entry, realDataKey))
	        );
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-pie-labels' },
	        labels
	      );
	    }
	  }, {
	    key: 'renderSectorItem',
	    value: function renderSectorItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      } else if ((0, _isPlainObject3.default)(option)) {
	        return _react2.default.createElement(_Sector2.default, _extends({}, props, option));
	      }
	
	      return _react2.default.createElement(_Sector2.default, props);
	    }
	  }, {
	    key: 'renderSectorsStatically',
	    value: function renderSectorsStatically(sectors) {
	      var _this3 = this;
	
	      var activeShape = this.props.activeShape;
	
	
	      return sectors.map(function (entry, i) {
	        return _react2.default.createElement(
	          _Layer2.default,
	          _extends({
	            className: 'recharts-pie-sector'
	          }, (0, _ReactUtils.filterEventsOfChild)(_this3.props, entry, i), {
	            key: 'sector-' + i
	          }),
	          _this3.renderSectorItem(_this3.isActiveIndex(i) ? activeShape : null, entry)
	        );
	      });
	    }
	  }, {
	    key: 'renderSectorsWithAnimation',
	    value: function renderSectorsWithAnimation() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          sectors = _props3.sectors,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          animationId = _props3.animationId;
	      var prevSectors = this.state.prevSectors;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'pie-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = [];
	          var first = sectors && sectors[0];
	          var curAngle = first.startAngle;
	
	          sectors.forEach(function (entry, index) {
	            var prev = prevSectors && prevSectors[index];
	            var paddingAngle = index > 0 ? entry.paddingAngle : 0;
	
	            if (prev) {
	              var angleIp = (0, _DataUtils.interpolateNumber)(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);
	              var latest = _extends({}, entry, {
	                startAngle: curAngle + paddingAngle,
	                endAngle: curAngle + angleIp(t) + paddingAngle
	              });
	
	              stepData.push(latest);
	              curAngle = latest.endAngle;
	            } else {
	              var endAngle = entry.endAngle,
	                  startAngle = entry.startAngle;
	
	              var interpolatorAngle = (0, _DataUtils.interpolateNumber)(0, endAngle - startAngle);
	              var deltaAngle = interpolatorAngle(t);
	              var _latest = _extends({}, entry, {
	                startAngle: curAngle + paddingAngle,
	                endAngle: curAngle + deltaAngle + paddingAngle
	              });
	
	              stepData.push(_latest);
	              curAngle = _latest.endAngle;
	            }
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this4.renderSectorsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors() {
	      var _props4 = this.props,
	          sectors = _props4.sectors,
	          isAnimationActive = _props4.isAnimationActive;
	      var prevSectors = this.state.prevSectors;
	
	
	      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !(0, _isEqual3.default)(prevSectors, sectors))) {
	        return this.renderSectorsWithAnimation();
	      }
	      return this.renderSectorsStatically(sectors);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          hide = _props5.hide,
	          sectors = _props5.sectors,
	          className = _props5.className,
	          label = _props5.label,
	          cx = _props5.cx,
	          cy = _props5.cy,
	          innerRadius = _props5.innerRadius,
	          outerRadius = _props5.outerRadius,
	          isAnimationActive = _props5.isAnimationActive,
	          prevSectors = _props5.prevSectors,
	          id = _props5.id;
	
	
	      if (hide || !sectors || !sectors.length || !(0, _DataUtils.isNumber)(cx) || !(0, _DataUtils.isNumber)(cy) || !(0, _DataUtils.isNumber)(innerRadius) || !(0, _DataUtils.isNumber)(outerRadius)) {
	        return null;
	      }
	
	      var layerClass = (0, _classnames2.default)('recharts-pie', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        _react2.default.createElement(
	          'g',
	          { clipPath: 'url(#' + ((0, _isNil3.default)(id) ? this.id : id) + ')' },
	          this.renderSectors()
	        ),
	        label && this.renderLabels(sectors),
	        _Label2.default.renderCallByParent(this.props, null, false),
	        (!isAnimationActive || prevSectors && (0, _isEqual3.default)(prevSectors, sectors)) && _LabelList2.default.renderCallByParent(this.props, sectors, false)
	      );
	    }
	  }]);
	
	  return Pie;
	}(_react.Component), _class2.displayName = 'Pie', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  animationId: _propTypes2.default.number,
	  cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startAngle: _propTypes2.default.number,
	  endAngle: _propTypes2.default.number,
	  paddingAngle: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  valueKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  minAngle: _propTypes2.default.number,
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  maxRadius: _propTypes2.default.number,
	
	  sectors: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  hide: _propTypes2.default.bool,
	  labelLine: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.shape({
	    offsetRadius: _propTypes2.default.number
	  }), _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.bool]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
	  id: _propTypes2.default.string
	}), _class2.defaultProps = {
	  stroke: '#fff',
	  fill: '#808080',
	  legendType: 'rect',
	  // The abscissa of pole
	  cx: '50%',
	  // The ordinate of pole
	  cy: '50%',
	  // The start angle of first sector
	  startAngle: 0,
	  // The direction of drawing sectors
	  endAngle: 360,
	  // The inner radius of sectors
	  innerRadius: 0,
	  // The outer radius of sectors
	  outerRadius: '80%',
	  paddingAngle: 0,
	  labelLine: true,
	  hide: false,
	  minAngle: 0,
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 400,
	  animationDuration: 1500,
	  animationEasing: 'ease',
	  nameKey: 'name'
	}, _class2.parseDeltaAngle = function (_ref3) {
	  var startAngle = _ref3.startAngle,
	      endAngle = _ref3.endAngle;
	
	  var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	  return sign * deltaAngle;
	}, _class2.getRealPieData = function (item) {
	  var _item$props = item.props,
	      data = _item$props.data,
	      children = _item$props.children;
	
	  var presentationProps = (0, _ReactUtils.getPresentationAttributes)(item.props);
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	
	  if (data && data.length) {
	    return data.map(function (entry, index) {
	      return _extends({
	        payload: entry
	      }, presentationProps, entry, cells && cells[index] && cells[index].props);
	    });
	  }
	
	  if (cells && cells.length) {
	    return cells.map(function (cell) {
	      return _extends({}, presentationProps, cell.props);
	    });
	  }
	
	  return [];
	}, _class2.parseCoordinateOfPie = function (item, offset) {
	  var top = offset.top,
	      left = offset.left,
	      width = offset.width,
	      height = offset.height;
	
	  var maxPieRadius = (0, _PolarUtils.getMaxRadius)(width, height);
	  var cx = left + (0, _DataUtils.getPercentValue)(item.props.cx, width, width / 2);
	  var cy = top + (0, _DataUtils.getPercentValue)(item.props.cy, height, height / 2);
	  var innerRadius = (0, _DataUtils.getPercentValue)(item.props.innerRadius, maxPieRadius, 0);
	  var outerRadius = (0, _DataUtils.getPercentValue)(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
	  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
	
	  return { cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, maxRadius: maxRadius };
	}, _class2.getComposedData = function (_ref4) {
	  var item = _ref4.item,
	      offset = _ref4.offset,
	      onItemMouseLeave = _ref4.onItemMouseLeave,
	      onItemMouseEnter = _ref4.onItemMouseEnter;
	
	  var pieData = Pie.getRealPieData(item);
	  if (!pieData || !pieData.length) {
	    return [];
	  }
	
	  var _item$props2 = item.props,
	      cornerRadius = _item$props2.cornerRadius,
	      startAngle = _item$props2.startAngle,
	      endAngle = _item$props2.endAngle,
	      paddingAngle = _item$props2.paddingAngle,
	      dataKey = _item$props2.dataKey,
	      nameKey = _item$props2.nameKey,
	      valueKey = _item$props2.valueKey;
	
	  var minAngle = Math.abs(item.props.minAngle);
	  var coordinate = Pie.parseCoordinateOfPie(item, offset);
	  var len = pieData.length;
	  var deltaAngle = Pie.parseDeltaAngle({ startAngle: startAngle, endAngle: endAngle });
	  var absDeltaAngle = Math.abs(deltaAngle);
	  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
	  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
	  var realDataKey = dataKey;
	
	  if ((0, _isNil3.default)(dataKey) && (0, _isNil3.default)(valueKey)) {
	    (0, _LogUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
	    realDataKey = 'value';
	  } else if ((0, _isNil3.default)(dataKey)) {
	    (0, _LogUtils.warn)(false, 'Use "dataKey" to specify the value of pie,\n      the props "valueKey" will be deprecated in 1.1.0');
	    realDataKey = valueKey;
	  }
	
	  var sum = pieData.reduce(function (result, entry) {
	    var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	    return result + ((0, _DataUtils.isNumber)(val) ? val : 0);
	  }, 0);
	  var sectors = void 0;
	
	  if (sum > 0) {
	    var prev = void 0;
	    sectors = pieData.map(function (entry, i) {
	      var val = (0, _ChartUtils.getValueByDataKey)(entry, realDataKey, 0);
	      var name = (0, _ChartUtils.getValueByDataKey)(entry, nameKey, i);
	      var percent = ((0, _DataUtils.isNumber)(val) ? val : 0) / sum;
	      var tempStartAngle = void 0;
	
	      if (i) {
	        tempStartAngle = prev.endAngle + (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle;
	      } else {
	        tempStartAngle = startAngle;
	      }
	
	      var tempEndAngle = tempStartAngle + (0, _DataUtils.mathSign)(deltaAngle) * (minAngle + percent * realTotalAngle);
	      var midAngle = (tempStartAngle + tempEndAngle) / 2;
	      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
	      var tooltipPayload = [{ name: name, value: val, payload: entry }];
	      var tooltipPosition = (0, _PolarUtils.polarToCartesian)(coordinate.cx, coordinate.cy, middleRadius, midAngle);
	
	      prev = _extends({
	        percent: percent, cornerRadius: cornerRadius, name: name, tooltipPayload: tooltipPayload, midAngle: midAngle, middleRadius: middleRadius, tooltipPosition: tooltipPosition
	      }, entry, coordinate, {
	        value: (0, _ChartUtils.getValueByDataKey)(entry, realDataKey),
	        startAngle: tempStartAngle,
	        endAngle: tempEndAngle,
	        payload: entry,
	        paddingAngle: (0, _DataUtils.mathSign)(deltaAngle) * paddingAngle
	      });
	
	      return prev;
	    });
	  }
	
	  return _extends({}, coordinate, {
	    sectors: sectors,
	    data: pieData,
	    onMouseLeave: onItemMouseLeave,
	    onMouseEnter: onItemMouseEnter
	  });
	}, _temp2)) || _class;
	
	exports.default = Pie;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Radar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DataUtils = __webpack_require__(39);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _ChartUtils = __webpack_require__(69);
	
	var _Polygon = __webpack_require__(534);
	
	var _Polygon2 = _interopRequireDefault(_Polygon);
	
	var _Dot = __webpack_require__(165);
	
	var _Dot2 = _interopRequireDefault(_Dot);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Radar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Radar, _Component);
	
	  function Radar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Radar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Radar.__proto__ || Object.getPrototypeOf(Radar)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isAnimationFinished: false }, _this.cachePrevData = function (points) {
	      _this.setState({ prevPoints: points });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _this.handleMouseEnter = function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	
	      if (onMouseEnter) {
	        onMouseEnter(_this.props, e);
	      }
	    }, _this.handleMouseLeave = function (e) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	
	      if (onMouseLeave) {
	        onMouseLeave(_this.props, e);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Radar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          points = _props.points;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(points);
	      }
	    }
	  }, {
	    key: 'renderDotItem',
	    value: function renderDotItem(option, props) {
	      var dotItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        dotItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        dotItem = option(props);
	      } else {
	        dotItem = _react2.default.createElement(_Dot2.default, _extends({}, props, { className: 'recharts-radar-dot' }));
	      }
	
	      return dotItem;
	    }
	  }, {
	    key: 'renderDots',
	    value: function renderDots(points) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          dot = _props2.dot,
	          dataKey = _props2.dataKey;
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(this.props);
	      var customDotProps = (0, _ReactUtils.getPresentationAttributes)(dot);
	
	      var dots = points.map(function (entry, i) {
	        var dotProps = _extends({
	          key: 'dot-' + i,
	          r: 3
	        }, baseProps, customDotProps, {
	          dataKey: dataKey,
	          cx: entry.x,
	          cy: entry.y,
	          index: i,
	          playload: entry
	        });
	
	        return _this2.renderDotItem(dot, dotProps);
	      });
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-dots' },
	        dots
	      );
	    }
	  }, {
	    key: 'renderPolygonStatically',
	    value: function renderPolygonStatically(points) {
	      var _props3 = this.props,
	          shape = _props3.shape,
	          dot = _props3.dot;
	
	
	      var radar = void 0;
	      if (_react2.default.isValidElement(shape)) {
	        radar = _react2.default.cloneElement(shape, _extends({}, this.props, { points: points }));
	      } else if ((0, _isFunction3.default)(shape)) {
	        radar = shape(_extends({}, this.props, { points: points }));
	      } else {
	        radar = _react2.default.createElement(_Polygon2.default, _extends({}, (0, _ReactUtils.filterEventAttributes)(this.props), {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	          points: points
	        }));
	      }
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-radar-polygon' },
	        radar,
	        dot ? this.renderDots(points) : null
	      );
	    }
	  }, {
	    key: 'renderPolygonWithAnimation',
	    value: function renderPolygonWithAnimation() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          points = _props4.points,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationId = _props4.animationId;
	      var prevPoints = this.state.prevPoints;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'radar-' + animationId,
	          onAnimationEnd: this.handleAnimationEnd,
	          onAnimationStart: this.handleAnimationStart
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = points.map(function (entry, index) {
	            var prev = prevPoints && prevPoints[index];
	
	            if (prev) {
	              var _interpolatorX = (0, _DataUtils.interpolateNumber)(prev.x, entry.x);
	              var _interpolatorY = (0, _DataUtils.interpolateNumber)(prev.y, entry.y);
	
	              return _extends({}, entry, {
	                x: _interpolatorX(t),
	                y: _interpolatorY(t)
	              });
	            }
	
	            var interpolatorX = (0, _DataUtils.interpolateNumber)(entry.cx, entry.x);
	            var interpolatorY = (0, _DataUtils.interpolateNumber)(entry.cy, entry.y);
	
	            return _extends({}, entry, {
	              x: interpolatorX(t),
	              y: interpolatorY(t)
	            });
	          });
	
	          return _this3.renderPolygonStatically(stepData);
	        }
	      );
	    }
	  }, {
	    key: 'renderPolygon',
	    value: function renderPolygon() {
	      var _props5 = this.props,
	          points = _props5.points,
	          isAnimationActive = _props5.isAnimationActive;
	      var prevPoints = this.state.prevPoints;
	
	
	      if (isAnimationActive && points && points.length && (!prevPoints || !(0, _isEqual3.default)(prevPoints, points))) {
	        return this.renderPolygonWithAnimation();
	      }
	
	      return this.renderPolygonStatically(points);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          hide = _props6.hide,
	          className = _props6.className,
	          points = _props6.points,
	          isAnimationActive = _props6.isAnimationActive;
	
	
	      if (hide || !points || !points.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-radar', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        this.renderPolygon(),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(this.props, points)
	      );
	    }
	  }]);
	
	  return Radar;
	}(_react.Component), _class2.displayName = 'Radar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.func]).isRequired,
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  points: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number,
	    y: _propTypes2.default.number,
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    angle: _propTypes2.default.number,
	    radius: _propTypes2.default.number,
	    value: _propTypes2.default.number,
	    payload: _propTypes2.default.object
	  })),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  activeDot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  // whether have dot in poly line
	  dot: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.bool]),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  hide: _propTypes2.default.bool,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  isAnimationActive: _propTypes2.default.bool,
	  animationId: _propTypes2.default.number,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  hide: false,
	  activeDot: true,
	  dot: false,
	  legendType: 'rect',
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref3) {
	  var radiusAxis = _ref3.radiusAxis,
	      angleAxis = _ref3.angleAxis,
	      displayedData = _ref3.displayedData,
	      dataKey = _ref3.dataKey,
	      bandSize = _ref3.bandSize;
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	
	  var points = displayedData.map(function (entry, i) {
	    var name = (0, _ChartUtils.getValueByDataKey)(entry, angleAxis.dataKey, i);
	    var value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey, 0);
	    var angle = angleAxis.scale(name) + (bandSize || 0);
	    var radius = radiusAxis.scale(value);
	    return _extends({}, (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle), {
	      name: name, value: value, cx: cx, cy: cy, radius: radius, angle: angle,
	      payload: entry
	    });
	  });
	
	  return { points: points };
	}, _temp2)) || _class;
	
	exports.default = Radar;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2; /**
	                              * @fileOverview Render a group of radial bar
	                              */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _Sector = __webpack_require__(360);
	
	var _Sector2 = _interopRequireDefault(_Sector);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _LabelList = __webpack_require__(138);
	
	var _LabelList2 = _interopRequireDefault(_LabelList);
	
	var _Cell = __webpack_require__(258);
	
	var _Cell2 = _interopRequireDefault(_Cell);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadialBar = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(RadialBar, _Component);
	
	  function RadialBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RadialBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadialBar.__proto__ || Object.getPrototypeOf(RadialBar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isAnimationFinished: false
	    }, _this.cachePrevData = function (data) {
	      _this.setState({ prevData: data });
	    }, _this.handleAnimationEnd = function () {
	      _this.setState({ isAnimationFinished: true });
	    }, _this.handleAnimationStart = function () {
	      _this.setState({ isAnimationFinished: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RadialBar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          animationId = _props.animationId,
	          data = _props.data;
	
	
	      if (nextProps.animationId !== animationId) {
	        this.cachePrevData(data);
	      }
	    }
	  }, {
	    key: 'getDeltaAngle',
	    value: function getDeltaAngle() {
	      var _props2 = this.props,
	          startAngle = _props2.startAngle,
	          endAngle = _props2.endAngle;
	
	      var sign = (0, _DataUtils.mathSign)(endAngle - startAngle);
	      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
	
	      return sign * deltaAngle;
	    }
	  }, {
	    key: 'renderSectorShape',
	    value: function renderSectorShape(shape, props) {
	      var sectorShape = void 0;
	
	      if (_react2.default.isValidElement(shape)) {
	        sectorShape = _react2.default.cloneElement(shape, props);
	      } else if ((0, _isFunction3.default)(shape)) {
	        sectorShape = shape(props);
	      } else {
	        sectorShape = _react2.default.createElement(_Sector2.default, props);
	      }
	
	      return sectorShape;
	    }
	  }, {
	    key: 'renderSectorsStatically',
	    value: function renderSectorsStatically(sectors) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          shape = _props3.shape,
	          activeShape = _props3.activeShape,
	          activeIndex = _props3.activeIndex,
	          cornerRadius = _props3.cornerRadius,
	          others = _objectWithoutProperties(_props3, ['shape', 'activeShape', 'activeIndex', 'cornerRadius']);
	
	      var baseProps = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return sectors.map(function (entry, i) {
	        var props = _extends({}, baseProps, {
	          cornerRadius: cornerRadius
	        }, entry, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i), {
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-sector'
	        });
	
	        return _this2.renderSectorShape(i === activeIndex ? activeShape : shape, props);
	      });
	    }
	  }, {
	    key: 'renderSectorsWithAnimation',
	    value: function renderSectorsWithAnimation() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          data = _props4.data,
	          isAnimationActive = _props4.isAnimationActive,
	          animationBegin = _props4.animationBegin,
	          animationDuration = _props4.animationDuration,
	          animationEasing = _props4.animationEasing,
	          animationId = _props4.animationId;
	      var prevData = this.state.prevData;
	
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          begin: animationBegin,
	          duration: animationDuration,
	          isActive: isAnimationActive,
	          easing: animationEasing,
	          from: { t: 0 },
	          to: { t: 1 },
	          key: 'radialBar-' + animationId,
	          onAnimationStart: this.handleAnimationStart,
	          onAnimationEnd: this.handleAnimationEnd
	        },
	        function (_ref2) {
	          var t = _ref2.t;
	
	          var stepData = data.map(function (entry, index) {
	            var prev = prevData && prevData[index];
	
	            if (prev) {
	              var interpolatorStartAngle = (0, _DataUtils.interpolateNumber)(prev.startAngle, entry.startAngle);
	              var interpolatorEndAngle = (0, _DataUtils.interpolateNumber)(prev.endAngle, entry.endAngle);
	
	              return _extends({}, entry, {
	                startAngle: interpolatorStartAngle(t),
	                endAngle: interpolatorEndAngle(t)
	              });
	            }
	            var endAngle = entry.endAngle,
	                startAngle = entry.startAngle;
	
	            var interpolator = (0, _DataUtils.interpolateNumber)(startAngle, endAngle);
	
	            return _extends({}, entry, { endAngle: interpolator(t) });
	          });
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            null,
	            _this3.renderSectorsStatically(stepData)
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderSectors',
	    value: function renderSectors() {
	      var _props5 = this.props,
	          data = _props5.data,
	          isAnimationActive = _props5.isAnimationActive;
	      var prevData = this.state.prevData;
	
	
	      if (isAnimationActive && data && data.length && (!prevData || !(0, _isEqual3.default)(prevData, data))) {
	        return this.renderSectorsWithAnimation();
	      }
	
	      return this.renderSectorsStatically(data);
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground(sectors) {
	      var _this4 = this;
	
	      var cornerRadius = this.props.cornerRadius;
	
	      var backgroundProps = (0, _ReactUtils.getPresentationAttributes)(this.props.background);
	
	      return sectors.map(function (entry, i) {
	        // eslint-disable-next-line no-unused-vars
	        var value = entry.value,
	            background = entry.background,
	            rest = _objectWithoutProperties(entry, ['value', 'background']);
	
	        if (!background) {
	          return null;
	        }
	
	        var props = _extends({
	          cornerRadius: cornerRadius
	        }, rest, {
	          fill: '#eee'
	        }, background, backgroundProps, (0, _ReactUtils.filterEventsOfChild)(_this4.props, entry, i), {
	          index: i,
	          key: 'sector-' + i,
	          className: 'recharts-radial-bar-background-sector'
	        });
	
	        return _this4.renderSectorShape(background, props);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          hide = _props6.hide,
	          data = _props6.data,
	          className = _props6.className,
	          background = _props6.background,
	          isAnimationActive = _props6.isAnimationActive;
	
	
	      if (hide || !data || !data.length) {
	        return null;
	      }
	
	      var isAnimationFinished = this.state.isAnimationFinished;
	
	      var layerClass = (0, _classnames2.default)('recharts-area', className);
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: layerClass },
	        background && _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-background' },
	          this.renderBackground(data)
	        ),
	        _react2.default.createElement(
	          _Layer2.default,
	          { className: 'recharts-radial-bar-sectors' },
	          this.renderSectors(data)
	        ),
	        (!isAnimationActive || isAnimationFinished) && _LabelList2.default.renderCallByParent(_extends({}, this.props, {
	          clockWise: this.getDeltaAngle() < 0
	        }), data)
	      );
	    }
	  }]);
	
	  return RadialBar;
	}(_react.Component), _class2.displayName = 'RadialBar', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  className: _propTypes2.default.string,
	  angleAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  radiusAxisId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  shape: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.element]),
	  activeShape: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.element]),
	  activeIndex: _propTypes2.default.number,
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]).isRequired,
	
	  cornerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  minPointSize: _propTypes2.default.number,
	  maxBarSize: _propTypes2.default.number,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    cx: _propTypes2.default.number,
	    cy: _propTypes2.default.number,
	    innerRadius: _propTypes2.default.number,
	    outerRadius: _propTypes2.default.number,
	    value: _propTypes2.default.value
	  })),
	  legendType: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES),
	  label: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.element, _propTypes2.default.object]),
	  background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.element]),
	  hide: _propTypes2.default.bool,
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
	}), _class2.defaultProps = {
	  angleAxisId: 0,
	  radiusAxisId: 0,
	  minPointSize: 0,
	  hide: false,
	  legendType: 'rect',
	  data: [],
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'ease'
	}, _class2.getComposedData = function (_ref3) {
	  var item = _ref3.item,
	      props = _ref3.props,
	      radiusAxis = _ref3.radiusAxis,
	      radiusAxisTicks = _ref3.radiusAxisTicks,
	      angleAxis = _ref3.angleAxis,
	      angleAxisTicks = _ref3.angleAxisTicks,
	      displayedData = _ref3.displayedData,
	      dataKey = _ref3.dataKey,
	      stackedData = _ref3.stackedData,
	      barPosition = _ref3.barPosition,
	      bandSize = _ref3.bandSize,
	      dataStartIndex = _ref3.dataStartIndex;
	
	  var pos = (0, _ChartUtils.findPositionOfBar)(barPosition, item);
	  if (!pos) {
	    return [];
	  }
	
	  var cx = angleAxis.cx,
	      cy = angleAxis.cy;
	  var layout = props.layout;
	  var _item$props = item.props,
	      children = _item$props.children,
	      minPointSize = _item$props.minPointSize;
	
	  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
	  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
	  var baseValue = (0, _ChartUtils.getBaseValueOfBar)({ props: props, numericAxis: numericAxis });
	  var cells = (0, _ReactUtils.findAllByType)(children, _Cell2.default);
	  var sectors = displayedData.map(function (entry, index) {
	    var value = void 0,
	        innerRadius = void 0,
	        outerRadius = void 0,
	        startAngle = void 0,
	        endAngle = void 0,
	        backgroundSector = void 0;
	
	    if (stackedData) {
	      value = (0, _ChartUtils.truncateByDomain)(stackedData[dataStartIndex + index], stackedDomain);
	    } else {
	      value = (0, _ChartUtils.getValueByDataKey)(entry, dataKey);
	      if (!(0, _isArray3.default)(value)) {
	        value = [baseValue, value];
	      }
	    }
	
	    if (layout === 'radial') {
	      innerRadius = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: radiusAxis,
	        ticks: radiusAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = angleAxis.scale(value[1]);
	      startAngle = angleAxis.scale(value[0]);
	      outerRadius = innerRadius + pos.size;
	      var deltaAngle = endAngle - startAngle;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
	        var delta = (0, _DataUtils.mathSign)(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
	
	        endAngle += delta;
	      }
	      backgroundSector = {
	        background: {
	          cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: props.startAngle,
	          endAngle: props.endAngle
	        }
	      };
	    } else {
	      innerRadius = radiusAxis.scale(value[0]);
	      outerRadius = radiusAxis.scale(value[1]);
	      startAngle = (0, _ChartUtils.getCateCoordinateOfBar)({
	        axis: angleAxis,
	        ticks: angleAxisTicks,
	        bandSize: bandSize,
	        offset: pos.offset,
	        entry: entry,
	        index: index
	      });
	      endAngle = startAngle + pos.size;
	      var deltaRadius = outerRadius - innerRadius;
	
	      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
	        var _delta = (0, _DataUtils.mathSign)(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));
	        outerRadius += _delta;
	      }
	    }
	
	    return _extends({}, entry, backgroundSector, {
	      payload: entry,
	      value: stackedData ? value : value[1],
	      cx: cx, cy: cy, innerRadius: innerRadius, outerRadius: outerRadius, startAngle: startAngle, endAngle: endAngle
	    }, cells && cells[index] && cells[index].props);
	  });
	
	  return { data: sectors, layout: layout };
	}, _temp2)) || _class;
	
	exports.default = RadialBar;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cross
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(39);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Cross = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Cross, _Component);
	
	  function Cross() {
	    _classCallCheck(this, Cross);
	
	    return _possibleConstructorReturn(this, (Cross.__proto__ || Object.getPrototypeOf(Cross)).apply(this, arguments));
	  }
	
	  _createClass(Cross, [{
	    key: 'getPath',
	    value: function getPath(x, y, width, height, top, left) {
	      return 'M' + x + ',' + top + 'v' + height + 'M' + left + ',' + y + 'h' + width;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          x = _props.x,
	          y = _props.y,
	          width = _props.width,
	          height = _props.height,
	          top = _props.top,
	          left = _props.left,
	          className = _props.className;
	
	
	      if (!(0, _DataUtils.isNumber)(x) || !(0, _DataUtils.isNumber)(y) || !(0, _DataUtils.isNumber)(width) || !(0, _DataUtils.isNumber)(height) || !(0, _DataUtils.isNumber)(top) || !(0, _DataUtils.isNumber)(left)) {
	        return null;
	      }
	
	      return _react2.default.createElement('path', _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        className: (0, _classnames2.default)('recharts-cross', className),
	        d: this.getPath(x, y, width, height, top, left)
	      }));
	    }
	  }]);
	
	  return Cross;
	}(_react.Component), _class2.displayName = 'Cross', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  className: _propTypes2.default.string
	}), _class2.defaultProps = {
	  x: 0,
	  y: 0,
	  top: 0,
	  left: 0,
	  width: 0,
	  height: 0
	}, _temp)) || _class;
	
	exports.default = Cross;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint no-console: 0 */
	var isDev = ("production") !== 'production';
	
	var warn = exports.warn = function warn(condition, format, a, b, c, d, e, f) {
	  if (isDev && typeof console !== 'undefined' && console.warn) {
	    if (format === undefined) {
	      console.warn('LogUtils requires an error message argument');
	    }
	
	    if (!condition) {
	      if (format === undefined) {
	        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	      } else {
	        var args = [a, b, c, d, e, f];
	        var argIndex = 0;
	
	        console.warn(format.replace(/%s/g, function () {
	          return args[argIndex++];
	        }));
	      }
	    }
	  }
	};

/***/ },
/* 1337 */
[3347, 3002, 3003, 538],
/* 1338 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.6. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(147), __webpack_require__(290), __webpack_require__(291), __webpack_require__(223), __webpack_require__(420), __webpack_require__(899), __webpack_require__(122)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	var array = Array.prototype;
	
	var map$1 = array.map;
	var slice = array.slice;
	
	var implicit = {name: "implicit"};
	
	function ordinal(range$$1) {
	  var index = d3Collection.map(),
	      domain = [],
	      unknown = implicit;
	
	  range$$1 = range$$1 == null ? [] : slice.call(range$$1);
	
	  function scale(d) {
	    var key = d + "", i = index.get(key);
	    if (!i) {
	      if (unknown !== implicit) return unknown;
	      index.set(key, i = domain.push(d));
	    }
	    return range$$1[(i - 1) % range$$1.length];
	  }
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [], index = d3Collection.map();
	    var i = -1, n = _.length, d, key;
	    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	    return scale;
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), scale) : range$$1.slice();
	  };
	
	  scale.unknown = function(_) {
	    return arguments.length ? (unknown = _, scale) : unknown;
	  };
	
	  scale.copy = function() {
	    return ordinal()
	        .domain(domain)
	        .range(range$$1)
	        .unknown(unknown);
	  };
	
	  return scale;
	}
	
	function band() {
	  var scale = ordinal().unknown(undefined),
	      domain = scale.domain,
	      ordinalRange = scale.range,
	      range$$1 = [0, 1],
	      step,
	      bandwidth,
	      round = false,
	      paddingInner = 0,
	      paddingOuter = 0,
	      align = 0.5;
	
	  delete scale.unknown;
	
	  function rescale() {
	    var n = domain().length,
	        reverse = range$$1[1] < range$$1[0],
	        start = range$$1[reverse - 0],
	        stop = range$$1[1 - reverse];
	    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	    if (round) step = Math.floor(step);
	    start += (stop - start - step * (n - paddingInner)) * align;
	    bandwidth = step * (1 - paddingInner);
	    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	    var values = d3Array.range(n).map(function(i) { return start + step * i; });
	    return ordinalRange(reverse ? values.reverse() : values);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = [+_[0], +_[1]], rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = [+_[0], +_[1]], round = true, rescale();
	  };
	
	  scale.bandwidth = function() {
	    return bandwidth;
	  };
	
	  scale.step = function() {
	    return step;
	  };
	
	  scale.round = function(_) {
	    return arguments.length ? (round = !!_, rescale()) : round;
	  };
	
	  scale.padding = function(_) {
	    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingInner = function(_) {
	    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	  };
	
	  scale.paddingOuter = function(_) {
	    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	  };
	
	  scale.align = function(_) {
	    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	  };
	
	  scale.copy = function() {
	    return band()
	        .domain(domain())
	        .range(range$$1)
	        .round(round)
	        .paddingInner(paddingInner)
	        .paddingOuter(paddingOuter)
	        .align(align);
	  };
	
	  return rescale();
	}
	
	function pointish(scale) {
	  var copy = scale.copy;
	
	  scale.padding = scale.paddingOuter;
	  delete scale.paddingInner;
	  delete scale.paddingOuter;
	
	  scale.copy = function() {
	    return pointish(copy());
	  };
	
	  return scale;
	}
	
	function point() {
	  return pointish(band().paddingInner(1));
	}
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var number = function(x) {
	  return +x;
	};
	
	var unit = [0, 1];
	
	function deinterpolateLinear(a, b) {
	  return (b -= (a = +a))
	      ? function(x) { return (x - a) / b; }
	      : constant(b);
	}
	
	function deinterpolateClamp(deinterpolate) {
	  return function(a, b) {
	    var d = deinterpolate(a = +a, b = +b);
	    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	  };
	}
	
	function reinterpolateClamp(reinterpolate) {
	  return function(a, b) {
	    var r = reinterpolate(a = +a, b = +b);
	    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	  };
	}
	
	function bimap(domain, range$$1, deinterpolate, reinterpolate) {
	  var d0 = domain[0], d1 = domain[1], r0 = range$$1[0], r1 = range$$1[1];
	  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	  return function(x) { return r0(d0(x)); };
	}
	
	function polymap(domain, range$$1, deinterpolate, reinterpolate) {
	  var j = Math.min(domain.length, range$$1.length) - 1,
	      d = new Array(j),
	      r = new Array(j),
	      i = -1;
	
	  // Reverse descending domains.
	  if (domain[j] < domain[0]) {
	    domain = domain.slice().reverse();
	    range$$1 = range$$1.slice().reverse();
	  }
	
	  while (++i < j) {
	    d[i] = deinterpolate(domain[i], domain[i + 1]);
	    r[i] = reinterpolate(range$$1[i], range$$1[i + 1]);
	  }
	
	  return function(x) {
	    var i = d3Array.bisect(domain, x, 1, j) - 1;
	    return r[i](d[i](x));
	  };
	}
	
	function copy(source, target) {
	  return target
	      .domain(source.domain())
	      .range(source.range())
	      .interpolate(source.interpolate())
	      .clamp(source.clamp());
	}
	
	// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	function continuous(deinterpolate, reinterpolate) {
	  var domain = unit,
	      range$$1 = unit,
	      interpolate$$1 = d3Interpolate.interpolate,
	      clamp = false,
	      piecewise,
	      output,
	      input;
	
	  function rescale() {
	    piecewise = Math.min(domain.length, range$$1.length) > 2 ? polymap : bimap;
	    output = input = null;
	    return scale;
	  }
	
	  function scale(x) {
	    return (output || (output = piecewise(domain, range$$1, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate$$1)))(+x);
	  }
	
	  scale.invert = function(y) {
	    return (input || (input = piecewise(range$$1, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.rangeRound = function(_) {
	    return range$$1 = slice.call(_), interpolate$$1 = d3Interpolate.interpolateRound, rescale();
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, rescale()) : clamp;
	  };
	
	  scale.interpolate = function(_) {
	    return arguments.length ? (interpolate$$1 = _, rescale()) : interpolate$$1;
	  };
	
	  return rescale();
	}
	
	var tickFormat = function(domain, count, specifier) {
	  var start = domain[0],
	      stop = domain[domain.length - 1],
	      step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	      precision;
	  specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	  switch (specifier.type) {
	    case "s": {
	      var value = Math.max(Math.abs(start), Math.abs(stop));
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	      return d3Format.formatPrefix(specifier, value);
	    }
	    case "":
	    case "e":
	    case "g":
	    case "p":
	    case "r": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	      break;
	    }
	    case "f":
	    case "%": {
	      if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	      break;
	    }
	  }
	  return d3Format.format(specifier);
	};
	
	function linearish(scale) {
	  var domain = scale.domain;
	
	  scale.ticks = function(count) {
	    var d = domain();
	    return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return tickFormat(domain(), count, specifier);
	  };
	
	  scale.nice = function(count) {
	    if (count == null) count = 10;
	
	    var d = domain(),
	        i0 = 0,
	        i1 = d.length - 1,
	        start = d[i0],
	        stop = d[i1],
	        step;
	
	    if (stop < start) {
	      step = start, start = stop, stop = step;
	      step = i0, i0 = i1, i1 = step;
	    }
	
	    step = d3Array.tickIncrement(start, stop, count);
	
	    if (step > 0) {
	      start = Math.floor(start / step) * step;
	      stop = Math.ceil(stop / step) * step;
	      step = d3Array.tickIncrement(start, stop, count);
	    } else if (step < 0) {
	      start = Math.ceil(start * step) / step;
	      stop = Math.floor(stop * step) / step;
	      step = d3Array.tickIncrement(start, stop, count);
	    }
	
	    if (step > 0) {
	      d[i0] = Math.floor(start / step) * step;
	      d[i1] = Math.ceil(stop / step) * step;
	      domain(d);
	    } else if (step < 0) {
	      d[i0] = Math.ceil(start * step) / step;
	      d[i1] = Math.floor(stop * step) / step;
	      domain(d);
	    }
	
	    return scale;
	  };
	
	  return scale;
	}
	
	function linear() {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber);
	
	  scale.copy = function() {
	    return copy(scale, linear());
	  };
	
	  return linearish(scale);
	}
	
	function identity() {
	  var domain = [0, 1];
	
	  function scale(x) {
	    return +x;
	  }
	
	  scale.invert = scale;
	
	  scale.domain = scale.range = function(_) {
	    return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	  };
	
	  scale.copy = function() {
	    return identity().domain(domain);
	  };
	
	  return linearish(scale);
	}
	
	var nice = function(domain, interval) {
	  domain = domain.slice();
	
	  var i0 = 0,
	      i1 = domain.length - 1,
	      x0 = domain[i0],
	      x1 = domain[i1],
	      t;
	
	  if (x1 < x0) {
	    t = i0, i0 = i1, i1 = t;
	    t = x0, x0 = x1, x1 = t;
	  }
	
	  domain[i0] = interval.floor(x0);
	  domain[i1] = interval.ceil(x1);
	  return domain;
	};
	
	function deinterpolate(a, b) {
	  return (b = Math.log(b / a))
	      ? function(x) { return Math.log(x / a) / b; }
	      : constant(b);
	}
	
	function reinterpolate(a, b) {
	  return a < 0
	      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	}
	
	function pow10(x) {
	  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	}
	
	function powp(base) {
	  return base === 10 ? pow10
	      : base === Math.E ? Math.exp
	      : function(x) { return Math.pow(base, x); };
	}
	
	function logp(base) {
	  return base === Math.E ? Math.log
	      : base === 10 && Math.log10
	      || base === 2 && Math.log2
	      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	}
	
	function reflect(f) {
	  return function(x) {
	    return -f(-x);
	  };
	}
	
	function log() {
	  var scale = continuous(deinterpolate, reinterpolate).domain([1, 10]),
	      domain = scale.domain,
	      base = 10,
	      logs = logp(10),
	      pows = powp(10);
	
	  function rescale() {
	    logs = logp(base), pows = powp(base);
	    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	    return scale;
	  }
	
	  scale.base = function(_) {
	    return arguments.length ? (base = +_, rescale()) : base;
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain(_), rescale()) : domain();
	  };
	
	  scale.ticks = function(count) {
	    var d = domain(),
	        u = d[0],
	        v = d[d.length - 1],
	        r;
	
	    if (r = v < u) i = u, u = v, v = i;
	
	    var i = logs(u),
	        j = logs(v),
	        p,
	        k,
	        t,
	        n = count == null ? 10 : +count,
	        z = [];
	
	    if (!(base % 1) && j - i < n) {
	      i = Math.round(i) - 1, j = Math.round(j) + 1;
	      if (u > 0) for (; i < j; ++i) {
	        for (k = 1, p = pows(i); k < base; ++k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      } else for (; i < j; ++i) {
	        for (k = base - 1, p = pows(i); k >= 1; --k) {
	          t = p * k;
	          if (t < u) continue;
	          if (t > v) break;
	          z.push(t);
	        }
	      }
	    } else {
	      z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	    }
	
	    return r ? z.reverse() : z;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	    if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	    if (count === Infinity) return specifier;
	    if (count == null) count = 10;
	    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	    return function(d) {
	      var i = d / pows(Math.round(logs(d)));
	      if (i * base < base - 0.5) i *= base;
	      return i <= k ? specifier(d) : "";
	    };
	  };
	
	  scale.nice = function() {
	    return domain(nice(domain(), {
	      floor: function(x) { return pows(Math.floor(logs(x))); },
	      ceil: function(x) { return pows(Math.ceil(logs(x))); }
	    }));
	  };
	
	  scale.copy = function() {
	    return copy(scale, log().base(base));
	  };
	
	  return scale;
	}
	
	function raise(x, exponent) {
	  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	}
	
	function pow() {
	  var exponent = 1,
	      scale = continuous(deinterpolate, reinterpolate),
	      domain = scale.domain;
	
	  function deinterpolate(a, b) {
	    return (b = raise(b, exponent) - (a = raise(a, exponent)))
	        ? function(x) { return (raise(x, exponent) - a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    b = raise(b, exponent) - (a = raise(a, exponent));
	    return function(t) { return raise(a + b * t, 1 / exponent); };
	  }
	
	  scale.exponent = function(_) {
	    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	  };
	
	  scale.copy = function() {
	    return copy(scale, pow().exponent(exponent));
	  };
	
	  return linearish(scale);
	}
	
	function sqrt() {
	  return pow().exponent(0.5);
	}
	
	function quantile$1() {
	  var domain = [],
	      range$$1 = [],
	      thresholds = [];
	
	  function rescale() {
	    var i = 0, n = Math.max(1, range$$1.length);
	    thresholds = new Array(n - 1);
	    while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	    return scale;
	  }
	
	  function scale(x) {
	    if (!isNaN(x = +x)) return range$$1[d3Array.bisect(thresholds, x)];
	  }
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN] : [
	      i > 0 ? thresholds[i - 1] : domain[0],
	      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	    ];
	  };
	
	  scale.domain = function(_) {
	    if (!arguments.length) return domain.slice();
	    domain = [];
	    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	    domain.sort(d3Array.ascending);
	    return rescale();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), rescale()) : range$$1.slice();
	  };
	
	  scale.quantiles = function() {
	    return thresholds.slice();
	  };
	
	  scale.copy = function() {
	    return quantile$1()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	function quantize() {
	  var x0 = 0,
	      x1 = 1,
	      n = 1,
	      domain = [0.5],
	      range$$1 = [0, 1];
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  function rescale() {
	    var i = -1;
	    domain = new Array(n);
	    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	    return scale;
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (n = (range$$1 = slice.call(_)).length - 1, rescale()) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return i < 0 ? [NaN, NaN]
	        : i < 1 ? [x0, domain[0]]
	        : i >= n ? [domain[n - 1], x1]
	        : [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return quantize()
	        .domain([x0, x1])
	        .range(range$$1);
	  };
	
	  return linearish(scale);
	}
	
	function threshold() {
	  var domain = [0.5],
	      range$$1 = [0, 1],
	      n = 1;
	
	  function scale(x) {
	    if (x <= x) return range$$1[d3Array.bisect(domain, x, 0, n)];
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : domain.slice();
	  };
	
	  scale.range = function(_) {
	    return arguments.length ? (range$$1 = slice.call(_), n = Math.min(domain.length, range$$1.length - 1), scale) : range$$1.slice();
	  };
	
	  scale.invertExtent = function(y) {
	    var i = range$$1.indexOf(y);
	    return [domain[i - 1], domain[i]];
	  };
	
	  scale.copy = function() {
	    return threshold()
	        .domain(domain)
	        .range(range$$1);
	  };
	
	  return scale;
	}
	
	var durationSecond = 1000;
	var durationMinute = durationSecond * 60;
	var durationHour = durationMinute * 60;
	var durationDay = durationHour * 24;
	var durationWeek = durationDay * 7;
	var durationMonth = durationDay * 30;
	var durationYear = durationDay * 365;
	
	function date(t) {
	  return new Date(t);
	}
	
	function number$1(t) {
	  return t instanceof Date ? +t : +new Date(+t);
	}
	
	function calendar(year, month, week, day, hour, minute, second, millisecond, format$$1) {
	  var scale = continuous(deinterpolateLinear, d3Interpolate.interpolateNumber),
	      invert = scale.invert,
	      domain = scale.domain;
	
	  var formatMillisecond = format$$1(".%L"),
	      formatSecond = format$$1(":%S"),
	      formatMinute = format$$1("%I:%M"),
	      formatHour = format$$1("%I %p"),
	      formatDay = format$$1("%a %d"),
	      formatWeek = format$$1("%b %d"),
	      formatMonth = format$$1("%B"),
	      formatYear = format$$1("%Y");
	
	  var tickIntervals = [
	    [second,  1,      durationSecond],
	    [second,  5,  5 * durationSecond],
	    [second, 15, 15 * durationSecond],
	    [second, 30, 30 * durationSecond],
	    [minute,  1,      durationMinute],
	    [minute,  5,  5 * durationMinute],
	    [minute, 15, 15 * durationMinute],
	    [minute, 30, 30 * durationMinute],
	    [  hour,  1,      durationHour  ],
	    [  hour,  3,  3 * durationHour  ],
	    [  hour,  6,  6 * durationHour  ],
	    [  hour, 12, 12 * durationHour  ],
	    [   day,  1,      durationDay   ],
	    [   day,  2,  2 * durationDay   ],
	    [  week,  1,      durationWeek  ],
	    [ month,  1,      durationMonth ],
	    [ month,  3,  3 * durationMonth ],
	    [  year,  1,      durationYear  ]
	  ];
	
	  function tickFormat(date) {
	    return (second(date) < date ? formatMillisecond
	        : minute(date) < date ? formatSecond
	        : hour(date) < date ? formatMinute
	        : day(date) < date ? formatHour
	        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	        : year(date) < date ? formatMonth
	        : formatYear)(date);
	  }
	
	  function tickInterval(interval, start, stop, step) {
	    if (interval == null) interval = 10;
	
	    // If a desired tick count is specified, pick a reasonable tick interval
	    // based on the extent of the domain and a rough estimate of tick size.
	    // Otherwise, assume interval is already a time interval and use it.
	    if (typeof interval === "number") {
	      var target = Math.abs(stop - start) / interval,
	          i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	      if (i === tickIntervals.length) {
	        step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	        interval = year;
	      } else if (i) {
	        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	        step = i[1];
	        interval = i[0];
	      } else {
	        step = d3Array.tickStep(start, stop, interval);
	        interval = millisecond;
	      }
	    }
	
	    return step == null ? interval : interval.every(step);
	  }
	
	  scale.invert = function(y) {
	    return new Date(invert(y));
	  };
	
	  scale.domain = function(_) {
	    return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	  };
	
	  scale.ticks = function(interval, step) {
	    var d = domain(),
	        t0 = d[0],
	        t1 = d[d.length - 1],
	        r = t1 < t0,
	        t;
	    if (r) t = t0, t0 = t1, t1 = t;
	    t = tickInterval(interval, t0, t1, step);
	    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	    return r ? t.reverse() : t;
	  };
	
	  scale.tickFormat = function(count, specifier) {
	    return specifier == null ? tickFormat : format$$1(specifier);
	  };
	
	  scale.nice = function(interval, step) {
	    var d = domain();
	    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	        ? domain(nice(d, interval))
	        : scale;
	  };
	
	  scale.copy = function() {
	    return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format$$1));
	  };
	
	  return scale;
	}
	
	var time = function() {
	  return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	};
	
	var utcTime = function() {
	  return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	};
	
	var colors = function(s) {
	  return s.match(/.{6}/g).map(function(x) {
	    return "#" + x;
	  });
	};
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var rainbow = d3Color.cubehelix();
	
	var rainbow$1 = function(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  rainbow.h = 360 * t - 100;
	  rainbow.s = 1.5 - 1.5 * ts;
	  rainbow.l = 0.8 - 0.9 * ts;
	  return rainbow + "";
	};
	
	function ramp(range$$1) {
	  var n = range$$1.length;
	  return function(t) {
	    return range$$1[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	function sequential(interpolator) {
	  var x0 = 0,
	      x1 = 1,
	      clamp = false;
	
	  function scale(x) {
	    var t = (x - x0) / (x1 - x0);
	    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	  }
	
	  scale.domain = function(_) {
	    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	  };
	
	  scale.clamp = function(_) {
	    return arguments.length ? (clamp = !!_, scale) : clamp;
	  };
	
	  scale.interpolator = function(_) {
	    return arguments.length ? (interpolator = _, scale) : interpolator;
	  };
	
	  scale.copy = function() {
	    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	  };
	
	  return linearish(scale);
	}
	
	exports.scaleBand = band;
	exports.scalePoint = point;
	exports.scaleIdentity = identity;
	exports.scaleLinear = linear;
	exports.scaleLog = log;
	exports.scaleOrdinal = ordinal;
	exports.scaleImplicit = implicit;
	exports.scalePow = pow;
	exports.scaleSqrt = sqrt;
	exports.scaleQuantile = quantile$1;
	exports.scaleQuantize = quantize;
	exports.scaleThreshold = threshold;
	exports.scaleTime = time;
	exports.scaleUtc = utcTime;
	exports.schemeCategory10 = category10;
	exports.schemeCategory20b = category20b;
	exports.schemeCategory20c = category20c;
	exports.schemeCategory20 = category20;
	exports.interpolateCubehelixDefault = cubehelix$1;
	exports.interpolateRainbow = rainbow$1;
	exports.interpolateWarm = warm;
	exports.interpolateCool = cool;
	exports.interpolateViridis = viridis;
	exports.interpolateMagma = magma;
	exports.interpolateInferno = inferno;
	exports.interpolatePlasma = plasma;
	exports.scaleSequential = sequential;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1340 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
	// eslint-disable-next-line max-len
	var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
	var namespacer = '/';
	
	function camelCase(string) {
	  return string.match(wordPattern).reduce(function (camelCased, word, index) {
	    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
	  }, '');
	}
	
	exports.default = function (type) {
	  return type.split(namespacer).map(camelCase).join(namespacer);
	};

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ACTION_TYPE_DELIMITER = undefined;
	exports.default = combineActions;
	
	var _isString = __webpack_require__(154);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(24);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isEmpty = __webpack_require__(2436);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _toString = __webpack_require__(1014);
	
	var _toString2 = _interopRequireDefault(_toString);
	
	var _isSymbol = __webpack_require__(155);
	
	var _isSymbol2 = _interopRequireDefault(_isSymbol);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ACTION_TYPE_DELIMITER = exports.ACTION_TYPE_DELIMITER = '||';
	
	function isValidActionType(type) {
	  return (0, _isString2.default)(type) || (0, _isFunction2.default)(type) || (0, _isSymbol2.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty2.default)(types)) {
	    return false;
	  }
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant2.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString2.default).join(ACTION_TYPE_DELIMITER);
	  return { toString: function toString() {
	      return combinedActionType;
	    } };
	}

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createAction;
	
	var _identity = __webpack_require__(110);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isFunction = __webpack_require__(24);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNull = __webpack_require__(2437);
	
	var _isNull2 = _interopRequireDefault(_isNull);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type) {
	  var payloadCreator = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
	  var metaCreator = arguments[2];
	
	  (0, _invariant2.default)((0, _isFunction2.default)(payloadCreator) || (0, _isNull2.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	
	  var finalPayloadCreator = (0, _isNull2.default)(payloadCreator) || payloadCreator === _identity2.default ? _identity2.default : function (head) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
	  };
	
	  var hasMeta = (0, _isFunction2.default)(metaCreator);
	  var typeString = type.toString();
	
	  var actionCreator = function actionCreator() {
	    var payload = finalPayloadCreator.apply(undefined, arguments);
	    var action = { type: type };
	
	    if (payload instanceof Error) {
	      action.error = true;
	    }
	
	    if (payload !== undefined) {
	      action.payload = payload;
	    }
	
	    if (hasMeta) {
	      action.meta = metaCreator.apply(undefined, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return typeString;
	  };
	
	  return actionCreator;
	}

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unflattenActionCreators = exports.flattenReducerMap = exports.flattenActionMap = undefined;
	
	var _camelCase = __webpack_require__(1340);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _ownKeys = __webpack_require__(543);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _hasGeneratorInterface = __webpack_require__(3032);
	
	var _hasGeneratorInterface2 = _interopRequireDefault(_hasGeneratorInterface);
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultNamespace = '/';
	
	var flattenWhenNode = function flattenWhenNode(predicate) {
	  return function flatten(map) {
	    var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];
	    var partialFlatMap = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	    var partialFlatActionType = arguments.length <= 3 || arguments[3] === undefined ? '' : arguments[3];
	
	    function connectNamespace(type) {
	      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
	    }
	
	    (0, _ownKeys2.default)(map).forEach(function (type) {
	      var nextNamespace = connectNamespace(type);
	      var mapValue = map[type];
	
	      if (!predicate(mapValue)) {
	        partialFlatMap[nextNamespace] = map[type];
	      } else {
	        flatten(map[type], namespace, partialFlatMap, nextNamespace);
	      }
	    });
	
	    return partialFlatMap;
	  };
	};
	
	var flattenActionMap = flattenWhenNode(_isPlainObject2.default);
	var flattenReducerMap = flattenWhenNode(function (node) {
	  return (0, _isPlainObject2.default)(node) && !(0, _hasGeneratorInterface2.default)(node);
	});
	
	function unflattenActionCreators(flatActionCreators) {
	  var namespace = arguments.length <= 1 || arguments[1] === undefined ? defaultNamespace : arguments[1];
	
	  function unflatten(flatActionType) {
	    var partialNestedActionCreators = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	    var partialFlatActionTypePath = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];
	
	    var nextNamespace = (0, _camelCase2.default)(partialFlatActionTypePath.shift());
	    if (partialFlatActionTypePath.length) {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    } else {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    }
	  }
	
	  var nestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    return unflatten(type, nestedActionCreators, type.split(namespace));
	  });
	  return nestedActionCreators;
	}
	
	exports.flattenActionMap = flattenActionMap;
	exports.flattenReducerMap = flattenReducerMap;
	exports.unflattenActionCreators = unflattenActionCreators;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = handleAction;
	
	var _isFunction = __webpack_require__(24);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _identity = __webpack_require__(110);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isNil = __webpack_require__(63);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _isUndefined = __webpack_require__(2438);
	
	var _isUndefined2 = _interopRequireDefault(_isUndefined);
	
	var _includes = __webpack_require__(2434);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _combineActions = __webpack_require__(1341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type) {
	  var reducer = arguments.length <= 1 || arguments[1] === undefined ? _identity2.default : arguments[1];
	  var defaultState = arguments[2];
	
	  var types = type.toString().split(_combineActions.ACTION_TYPE_DELIMITER);
	  (0, _invariant2.default)(!(0, _isUndefined2.default)(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
	  (0, _invariant2.default)((0, _isFunction2.default)(reducer) || (0, _isPlainObject2.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction2.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil2.default)(aReducer) ? _identity2.default : aReducer;
	  });
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var nextReducer = _ref2[0];
	  var throwReducer = _ref2[1];
	
	
	  return function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	    var actionType = action.type;
	
	    if (!actionType || !(0, _includes2.default)(types, actionType.toString())) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineActions = exports.handleActions = exports.handleAction = exports.createActions = exports.createAction = undefined;
	
	var _createAction = __webpack_require__(1342);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _handleAction = __webpack_require__(1344);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _handleActions = __webpack_require__(3031);
	
	var _handleActions2 = _interopRequireDefault(_handleActions);
	
	var _combineActions = __webpack_require__(1341);
	
	var _combineActions2 = _interopRequireDefault(_combineActions);
	
	var _createActions = __webpack_require__(3030);
	
	var _createActions2 = _interopRequireDefault(_createActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createAction = _createAction2.default;
	exports.createActions = _createActions2.default;
	exports.handleAction = _handleAction2.default;
	exports.handleActions = _handleActions2.default;
	exports.combineActions = _combineActions2.default;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _es6Error = __webpack_require__(1988);
	
	var _es6Error2 = _interopRequireDefault(_es6Error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SubmissionError = function (_ExtendableError) {
	  _inherits(SubmissionError, _ExtendableError);
	
	  function SubmissionError(errors) {
	    _classCallCheck(this, SubmissionError);
	
	    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));
	
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error2.default);
	
	exports.default = SubmissionError;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _actionTypes = __webpack_require__(544);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: { form: form, field: field, index: index },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: { form: form, field: field, from: from, to: to }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: { form: form, field: field, index: index }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: { form: form, field: field }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: { form: form, field: field }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: { form: form, field: field, index: index, removeNum: removeNum }
	  };
	  if (value !== undefined) {
	    action.payload = value;
	  }
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	  return { type: _actionTypes.ARRAY_SWAP, meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: { form: form, field: field },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: { form: form, field: field, touch: touch },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: { form: form }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: { form: form, field: field }
	  };
	};
	
	var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
	  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    fields[_key - 3] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.CLEAR_FIELDS,
	    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    form[_key2] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: { form: form }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: { form: form, field: field }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty) {
	  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, type: type }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: { form: form }
	  };
	};
	
	var resetSection = function resetSection(form) {
	  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    sections[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.RESET_SECTION,
	    meta: { form: form, sections: sections }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: { form: form, field: field }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: { form: form },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: { form: form },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: { form: form }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: { form: form, fields: fields },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: { form: form, fields: fields },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    fields[_key6 - 1] = arguments[_key6];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var unregisterField = function unregisterField(form, name) {
	  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: { form: form },
	    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    fields[_key7 - 1] = arguments[_key7];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: { form: form, fields: fields }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form) {
	  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var error = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: { form: form },
	    payload: { syncErrors: syncErrors, error: error }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form) {
	  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var warning = arguments[2];
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: { form: form },
	    payload: { syncWarnings: syncWarnings, warning: warning }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearFields: clearFields,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  resetSection: resetSection,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	
	exports.default = actions;

/***/ },
/* 1348 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var processProps = function processProps(type, props, _value, deepEqual) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return _extends({}, props, {
	      checked: !!value
	    });
	  }
	  if (type === 'radio') {
	    return _extends({}, props, {
	      checked: deepEqual(value, _value),
	      value: _value
	    });
	  }
	  if (type === 'select-multiple') {
	    return _extends({}, props, {
	      value: value || []
	    });
	  }
	  if (type === 'file') {
	    return _extends({}, props, {
	      value: value || undefined
	    });
	  }
	  return props;
	};
	
	var createFieldProps = function createFieldProps(_ref2, name, _ref) {
	  var getIn = _ref2.getIn,
	      toJS = _ref2.toJS,
	      deepEqual = _ref2.deepEqual;
	
	  var asyncError = _ref.asyncError,
	      asyncValidating = _ref.asyncValidating,
	      onBlur = _ref.onBlur,
	      onChange = _ref.onChange,
	      onDrop = _ref.onDrop,
	      onDragStart = _ref.onDragStart,
	      dirty = _ref.dirty,
	      dispatch = _ref.dispatch,
	      onFocus = _ref.onFocus,
	      form = _ref.form,
	      format = _ref.format,
	      initial = _ref.initial,
	      parse = _ref.parse,
	      pristine = _ref.pristine,
	      props = _ref.props,
	      state = _ref.state,
	      submitError = _ref.submitError,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      validate = _ref.validate,
	      value = _ref.value,
	      _value = _ref._value,
	      warn = _ref.warn,
	      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value, deepEqual),
	    meta: _extends({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: _extends({}, custom, props)
	  };
	};
	
	exports.default = createFieldProps;

/***/ },
/* 1349 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	  switch (trigger) {
	    case 'blur':
	    case 'change':
	      // blurring
	      return true;
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	    default:
	      return false;
	  }
	};
	exports.default = defaultShouldAsyncValidate;

/***/ },
/* 1350 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldError = function defaultShouldError(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldError;

/***/ },
/* 1351 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldValidate;

/***/ },
/* 1352 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var defaultShouldWarn = function defaultShouldWarn(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	exports.default = defaultShouldWarn;

/***/ },
/* 1353 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	exports.default = isEvent;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getValue = __webpack_require__(3050);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _isReactNative = __webpack_require__(1356);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	
	  // read value from input
	  var value = (0, _getValue2.default)(event, _isReactNative2.default);
	
	  // parse value if we have a parser
	  if (parse) {
	    value = parse(value, name);
	  }
	
	  // normalize value
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	exports.default = onChangeValue;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(1353);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent2.default)(event);
	  if (is) {
	    event.preventDefault();
	  }
	  return is;
	};
	exports.default = silenceEvent;

/***/ },
/* 1356 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	
	exports.default = isReactNative;

/***/ },
/* 1357 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsPristine = function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      var formState = nonNullGetFormState(state);
	      var initial = getIn(formState, form + '.initial') || empty;
	      var values = getIn(formState, form + '.values') || initial;
	      return deepEqual(initial, values);
	    };
	  };
	};
	
	exports.default = createIsPristine;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(209);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath3.default)(field);
	  var length = path.length;
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	exports.default = getIn;

/***/ },
/* 1359 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	exports.default = keys;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(552);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  var propsEqual = (0, _isEqualWith3.default)(instance.props, nextProps, customizer);
	  var stateEqual = (0, _isEqualWith3.default)(instance.state, nextState, customizer);
	
	  return !propsEqual || !stateEqual;
	};
	
	exports.default = shallowCompare;

/***/ },
/* 1361 */
[3460, 104],
/* 1362 */
[3462, 3137, 370, 92, 371, 549, 373],
/* 1363 */
151,
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(365),
	    eq = __webpack_require__(263);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 1365 */
[3466, 3147],
/* 1366 */
[3468, 1368, 262],
/* 1367 */
[3478, 368, 3177],
/* 1368 */
[3485, 92, 550, 1379, 1382],
/* 1369 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 1370 */
[3487, 166],
/* 1371 */
[3488, 3111, 3116, 3140],
/* 1372 */
991,
/* 1373 */
[3495, 1377],
/* 1374 */
[3498, 3107, 546, 3109, 3110, 3112, 208, 1380],
/* 1375 */
[3507, 140],
/* 1376 */
996,
/* 1377 */
997,
/* 1378 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  return key == '__proto__'
	    ? undefined
	    : object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(3176);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 1380 */
1001,
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(1362),
	    baseKeysIn = __webpack_require__(3128),
	    isArrayLike = __webpack_require__(264);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 1382 */
[3544, 3138],
/* 1383 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (action) {
	  return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=getStateName.js.map

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.purgeStoredState = exports.persistStore = exports.getStoredState = exports.createTransform = exports.createPersistor = exports.autoRehydrate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxPersist = __webpack_require__(3216);
	
	var _reduxPersistTransformImmutable = __webpack_require__(3219);
	
	var _reduxPersistTransformImmutable2 = _interopRequireDefault(_reduxPersistTransformImmutable);
	
	var _operators = __webpack_require__(3212);
	
	var operators = _interopRequireWildcard(_operators);
	
	var _reconciler = __webpack_require__(3213);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var extendConfig = function extendConfig(config) {
	  var incomingTransforms = config.transforms || [];
	  var records = config.records || null;
	  var transforms = incomingTransforms;
	  if (!config.skipImmutableTransform) {
	    transforms = [].concat(_toConsumableArray(incomingTransforms), [(0, _reduxPersistTransformImmutable2.default)({ records: records })]);
	  }
	  return _extends({ stateReconciler: _reconciler.stateReconciler }, config, operators, { transforms: transforms });
	};
	
	var autoRehydrate = function autoRehydrate() {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _reduxPersist.autoRehydrate.apply(undefined, [extendConfig(config)].concat(args));
	};
	
	var createPersistor = function createPersistor(store) {
	  for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	    args[_key2 - 2] = arguments[_key2];
	  }
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _reduxPersist.createPersistor.apply(undefined, [store, extendConfig(config)].concat(args));
	};
	
	var persistStore = function persistStore(store) {
	  for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	    args[_key3 - 2] = arguments[_key3];
	  }
	
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return _reduxPersist.persistStore.apply(undefined, [store, extendConfig(config)].concat(args));
	};
	
	var getStoredState = function getStoredState() {
	  for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    args[_key4 - 1] = arguments[_key4];
	  }
	
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _reduxPersist.getStoredState.apply(undefined, [extendConfig(config)].concat(args));
	};
	
	exports.autoRehydrate = autoRehydrate;
	exports.createPersistor = createPersistor;
	exports.createTransform = _reduxPersist.createTransform;
	exports.getStoredState = getStoredState;
	exports.persistStore = persistStore;
	exports.purgeStoredState = _reduxPersist.purgeStoredState;

/***/ },
/* 1385 */
[3548, 265, 1386, 1388],
/* 1386 */
[3549, 1389],
/* 1387 */
[3550, 265, 1386],
/* 1388 */
[3553, 265],
/* 1389 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	var hasNativeSupport = typeof global !== 'undefined' && typeof global.setImmediate !== 'undefined';
	var setImmediate = hasNativeSupport ? function (fn, ms) {
	  return global.setImmediate(fn, ms);
	} : function (fn, ms) {
	  return setTimeout(fn, ms);
	};
	
	exports.default = setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1390 */
[3548, 266, 1391, 1393],
/* 1391 */
[3549, 1394],
/* 1392 */
[3550, 266, 1391],
/* 1393 */
[3553, 266],
/* 1394 */
1389,
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TASK_CANCEL = exports.CHANNEL_END = exports.NOT_ITERATOR_ERROR = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = proc;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var _scheduler = /*#__PURE__*/__webpack_require__(1398);
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	var _channel = /*#__PURE__*/__webpack_require__(210);
	
	var _buffers = /*#__PURE__*/__webpack_require__(374);
	
	function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }
	
	var NOT_ITERATOR_ERROR = exports.NOT_ITERATOR_ERROR = 'proc first argument (Saga function result) must be an iterator';
	
	var CHANNEL_END = exports.CHANNEL_END = {
	  toString: function toString() {
	    return '@@redux-saga/CHANNEL_END';
	  }
	};
	var TASK_CANCEL = exports.TASK_CANCEL = {
	  toString: function toString() {
	    return '@@redux-saga/TASK_CANCEL';
	  }
	};
	
	var matchers = {
	  wildcard: function wildcard() {
	    return _utils.kTrue;
	  },
	  default: function _default(pattern) {
	    return (typeof pattern === 'undefined' ? 'undefined' : _typeof(pattern)) === 'symbol' ? function (input) {
	      return input.type === pattern;
	    } : function (input) {
	      return input.type === String(pattern);
	    };
	  },
	  array: function array(patterns) {
	    return function (input) {
	      return patterns.some(function (p) {
	        return matcher(p)(input);
	      });
	    };
	  },
	  predicate: function predicate(_predicate) {
	    return function (input) {
	      return _predicate(input);
	    };
	  }
	};
	
	function matcher(pattern) {
	  // prettier-ignore
	  return (pattern === '*' ? matchers.wildcard : _utils.is.array(pattern) ? matchers.array : _utils.is.stringableFunc(pattern) ? matchers.default : _utils.is.func(pattern) ? matchers.predicate : matchers.default)(pattern);
	}
	
	/**
	  Used to track a parent task and its forks
	  In the new fork model, forked tasks are attached by default to their parent
	  We model this using the concept of Parent task && main Task
	  main task is the main flow of the current Generator, the parent tasks is the
	  aggregation of the main tasks + all its forked tasks.
	  Thus the whole model represents an execution tree with multiple branches (vs the
	  linear execution tree in sequential (non parallel) programming)
	
	  A parent tasks has the following semantics
	  - It completes if all its forks either complete or all cancelled
	  - If it's cancelled, all forks are cancelled as well
	  - It aborts if any uncaught error bubbles up from forks
	  - If it completes, the return value is the one returned by the main task
	**/
	function forkQueue(name, mainTask, cb) {
	  var tasks = [],
	      result = void 0,
	      completed = false;
	  addTask(mainTask);
	
	  function abort(err) {
	    cancelAll();
	    cb(err, true);
	  }
	
	  function addTask(task) {
	    tasks.push(task);
	    task.cont = function (res, isErr) {
	      if (completed) {
	        return;
	      }
	
	      (0, _utils.remove)(tasks, task);
	      task.cont = _utils.noop;
	      if (isErr) {
	        abort(res);
	      } else {
	        if (task === mainTask) {
	          result = res;
	        }
	        if (!tasks.length) {
	          completed = true;
	          cb(result);
	        }
	      }
	    };
	    // task.cont.cancel = task.cancel
	  }
	
	  function cancelAll() {
	    if (completed) {
	      return;
	    }
	    completed = true;
	    tasks.forEach(function (t) {
	      t.cont = _utils.noop;
	      t.cancel();
	    });
	    tasks = [];
	  }
	
	  return {
	    addTask: addTask,
	    cancelAll: cancelAll,
	    abort: abort,
	    getTasks: function getTasks() {
	      return tasks;
	    },
	    taskNames: function taskNames() {
	      return tasks.map(function (t) {
	        return t.name;
	      });
	    }
	  };
	}
	
	function createTaskIterator(_ref) {
	  var context = _ref.context,
	      fn = _ref.fn,
	      args = _ref.args;
	
	  if (_utils.is.iterator(fn)) {
	    return fn;
	  }
	
	  // catch synchronous failures; see #152 and #441
	  var result = void 0,
	      error = void 0;
	  try {
	    result = fn.apply(context, args);
	  } catch (err) {
	    error = err;
	  }
	
	  // i.e. a generator function returns an iterator
	  if (_utils.is.iterator(result)) {
	    return result;
	  }
	
	  // do not bubble up synchronous failures for detached forks
	  // instead create a failed task. See #152 and #441
	  return error ? (0, _utils.makeIterator)(function () {
	    throw error;
	  }) : (0, _utils.makeIterator)(function () {
	    var pc = void 0;
	    var eff = { done: false, value: result };
	    var ret = function ret(value) {
	      return { done: true, value: value };
	    };
	    return function (arg) {
	      if (!pc) {
	        pc = true;
	        return eff;
	      } else {
	        return ret(arg);
	      }
	    };
	  }());
	}
	
	var wrapHelper = function wrapHelper(helper) {
	  return { fn: helper };
	};
	
	function proc(iterator) {
	  var subscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	    return _utils.noop;
	  };
	  var dispatch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.noop;
	  var getState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _utils.noop;
	  var parentContext = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
	  var parentEffectId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
	  var name = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 'anonymous';
	  var cont = arguments[8];
	
	  (0, _utils.check)(iterator, _utils.is.iterator, NOT_ITERATOR_ERROR);
	
	  var effectsString = '[...effects]';
	  var runParallelEffect = (0, _utils.deprecate)(runAllEffect, (0, _utils.updateIncentive)(effectsString, 'all(' + effectsString + ')'));
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	  var log = logger || _utils.log;
	  var logError = function logError(err) {
	    var message = err.sagaStack;
	
	    if (!message && err.stack) {
	      message = err.stack.split('\n')[0].indexOf(err.message) !== -1 ? err.stack : 'Error: ' + err.message + '\n' + err.stack;
	    }
	
	    log('error', 'uncaught at ' + name, message || err.message || err);
	  };
	  var stdChannel = (0, _channel.stdChannel)(subscribe);
	  var taskContext = Object.create(parentContext);
	  /**
	    Tracks the current effect cancellation
	    Each time the generator progresses. calling runEffect will set a new value
	    on it. It allows propagating cancellation to child effects
	  **/
	  next.cancel = _utils.noop;
	
	  /**
	    Creates a new task descriptor for this generator, We'll also create a main task
	    to track the main flow (besides other forked tasks)
	  **/
	  var task = newTask(parentEffectId, name, iterator, cont);
	  var mainTask = { name: name, cancel: cancelMain, isRunning: true };
	  var taskQueue = forkQueue(name, mainTask, end);
	
	  /**
	    cancellation of the main task. We'll simply resume the Generator with a Cancel
	  **/
	  function cancelMain() {
	    if (mainTask.isRunning && !mainTask.isCancelled) {
	      mainTask.isCancelled = true;
	      next(TASK_CANCEL);
	    }
	  }
	
	  /**
	    This may be called by a parent generator to trigger/propagate cancellation
	    cancel all pending tasks (including the main task), then end the current task.
	     Cancellation propagates down to the whole execution tree holded by this Parent task
	    It's also propagated to all joiners of this task and their execution tree/joiners
	     Cancellation is noop for terminated/Cancelled tasks tasks
	  **/
	  function cancel() {
	    /**
	      We need to check both Running and Cancelled status
	      Tasks can be Cancelled but still Running
	    **/
	    if (iterator._isRunning && !iterator._isCancelled) {
	      iterator._isCancelled = true;
	      taskQueue.cancelAll();
	      /**
	        Ending with a Never result will propagate the Cancellation to all joiners
	      **/
	      end(TASK_CANCEL);
	    }
	  }
	  /**
	    attaches cancellation logic to this task's continuation
	    this will permit cancellation to propagate down the call chain
	  **/
	  cont && (cont.cancel = cancel);
	
	  // tracks the running status
	  iterator._isRunning = true;
	
	  // kicks up the generator
	  next();
	
	  // then return the task descriptor to the caller
	  return task;
	
	  /**
	    This is the generator driver
	    It's a recursive async/continuation function which calls itself
	    until the generator terminates or throws
	  **/
	  function next(arg, isErr) {
	    // Preventive measure. If we end up here, then there is really something wrong
	    if (!mainTask.isRunning) {
	      throw new Error('Trying to resume an already finished generator');
	    }
	
	    try {
	      var result = void 0;
	      if (isErr) {
	        result = iterator.throw(arg);
	      } else if (arg === TASK_CANCEL) {
	        /**
	          getting TASK_CANCEL automatically cancels the main task
	          We can get this value here
	           - By cancelling the parent task manually
	          - By joining a Cancelled task
	        **/
	        mainTask.isCancelled = true;
	        /**
	          Cancels the current effect; this will propagate the cancellation down to any called tasks
	        **/
	        next.cancel();
	        /**
	          If this Generator has a `return` method then invokes it
	          This will jump to the finally block
	        **/
	        result = _utils.is.func(iterator.return) ? iterator.return(TASK_CANCEL) : { done: true, value: TASK_CANCEL };
	      } else if (arg === CHANNEL_END) {
	        // We get CHANNEL_END by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
	        result = _utils.is.func(iterator.return) ? iterator.return() : { done: true };
	      } else {
	        result = iterator.next(arg);
	      }
	
	      if (!result.done) {
	        runEffect(result.value, parentEffectId, '', next);
	      } else {
	        /**
	          This Generator has ended, terminate the main task and notify the fork queue
	        **/
	        mainTask.isMainRunning = false;
	        mainTask.cont && mainTask.cont(result.value);
	      }
	    } catch (error) {
	      if (mainTask.isCancelled) {
	        logError(error);
	      }
	      mainTask.isMainRunning = false;
	      mainTask.cont(error, true);
	    }
	  }
	
	  function end(result, isErr) {
	    iterator._isRunning = false;
	    stdChannel.close();
	    if (!isErr) {
	      iterator._result = result;
	      iterator._deferredEnd && iterator._deferredEnd.resolve(result);
	    } else {
	      if (result instanceof Error) {
	        Object.defineProperty(result, 'sagaStack', {
	          value: 'at ' + name + ' \n ' + (result.sagaStack || result.stack),
	          configurable: true
	        });
	      }
	      if (!task.cont) {
	        if (result instanceof Error && onError) {
	          onError(result);
	        } else {
	          logError(result);
	        }
	      }
	      iterator._error = result;
	      iterator._isAborted = true;
	      iterator._deferredEnd && iterator._deferredEnd.reject(result);
	    }
	    task.cont && task.cont(result, isErr);
	    task.joiners.forEach(function (j) {
	      return j.cb(result, isErr);
	    });
	    task.joiners = null;
	  }
	
	  function runEffect(effect, parentEffectId) {
	    var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	    var cb = arguments[3];
	
	    var effectId = (0, _utils.uid)();
	    sagaMonitor && sagaMonitor.effectTriggered({ effectId: effectId, parentEffectId: parentEffectId, label: label, effect: effect });
	
	    /**
	      completion callback and cancel callback are mutually exclusive
	      We can't cancel an already completed effect
	      And We can't complete an already cancelled effectId
	    **/
	    var effectSettled = void 0;
	
	    // Completion callback passed to the appropriate effect runner
	    function currCb(res, isErr) {
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      cb.cancel = _utils.noop; // defensive measure
	      if (sagaMonitor) {
	        isErr ? sagaMonitor.effectRejected(effectId, res) : sagaMonitor.effectResolved(effectId, res);
	      }
	      cb(res, isErr);
	    }
	    // tracks down the current cancel
	    currCb.cancel = _utils.noop;
	
	    // setup cancellation logic on the parent cb
	    cb.cancel = function () {
	      // prevents cancelling an already completed effect
	      if (effectSettled) {
	        return;
	      }
	
	      effectSettled = true;
	      /**
	        propagates cancel downward
	        catch uncaught cancellations errors; since we can no longer call the completion
	        callback, log errors raised during cancellations into the console
	      **/
	      try {
	        currCb.cancel();
	      } catch (err) {
	        logError(err);
	      }
	      currCb.cancel = _utils.noop; // defensive measure
	
	      sagaMonitor && sagaMonitor.effectCancelled(effectId);
	    };
	
	    /**
	      each effect runner must attach its own logic of cancellation to the provided callback
	      it allows this generator to propagate cancellation downward.
	       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
	      And the setup must occur before calling the callback
	       This is a sort of inversion of control: called async functions are responsible
	      for completing the flow by calling the provided continuation; while caller functions
	      are responsible for aborting the current flow by calling the attached cancel function
	       Library users can attach their own cancellation logic to promises by defining a
	      promise[CANCEL] method in their returned promises
	      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
	    **/
	    var data = void 0;
	    // prettier-ignore
	    return (
	      // Non declarative effect
	      _utils.is.promise(effect) ? resolvePromise(effect, currCb) : _utils.is.helper(effect) ? runForkEffect(wrapHelper(effect), effectId, currCb) : _utils.is.iterator(effect) ? resolveIterator(effect, effectId, name, currCb)
	
	      // declarative effects
	      : _utils.is.array(effect) ? runParallelEffect(effect, effectId, currCb) : (data = _io.asEffect.take(effect)) ? runTakeEffect(data, currCb) : (data = _io.asEffect.put(effect)) ? runPutEffect(data, currCb) : (data = _io.asEffect.all(effect)) ? runAllEffect(data, effectId, currCb) : (data = _io.asEffect.race(effect)) ? runRaceEffect(data, effectId, currCb) : (data = _io.asEffect.call(effect)) ? runCallEffect(data, effectId, currCb) : (data = _io.asEffect.cps(effect)) ? runCPSEffect(data, currCb) : (data = _io.asEffect.fork(effect)) ? runForkEffect(data, effectId, currCb) : (data = _io.asEffect.join(effect)) ? runJoinEffect(data, currCb) : (data = _io.asEffect.cancel(effect)) ? runCancelEffect(data, currCb) : (data = _io.asEffect.select(effect)) ? runSelectEffect(data, currCb) : (data = _io.asEffect.actionChannel(effect)) ? runChannelEffect(data, currCb) : (data = _io.asEffect.flush(effect)) ? runFlushEffect(data, currCb) : (data = _io.asEffect.cancelled(effect)) ? runCancelledEffect(data, currCb) : (data = _io.asEffect.getContext(effect)) ? runGetContextEffect(data, currCb) : (data = _io.asEffect.setContext(effect)) ? runSetContextEffect(data, currCb) : /* anything else returned as is */currCb(effect)
	    );
	  }
	
	  function resolvePromise(promise, cb) {
	    var cancelPromise = promise[_utils.CANCEL];
	    if (_utils.is.func(cancelPromise)) {
	      cb.cancel = cancelPromise;
	    } else if (_utils.is.func(promise.abort)) {
	      cb.cancel = function () {
	        return promise.abort();
	      };
	      // TODO: add support for the fetch API, whenever they get around to
	      // adding cancel support
	    }
	    promise.then(cb, function (error) {
	      return cb(error, true);
	    });
	  }
	
	  function resolveIterator(iterator, effectId, name, cb) {
	    proc(iterator, subscribe, dispatch, getState, taskContext, options, effectId, name, cb);
	  }
	
	  function runTakeEffect(_ref2, cb) {
	    var channel = _ref2.channel,
	        pattern = _ref2.pattern,
	        maybe = _ref2.maybe;
	
	    channel = channel || stdChannel;
	    var takeCb = function takeCb(inp) {
	      return inp instanceof Error ? cb(inp, true) : (0, _channel.isEnd)(inp) && !maybe ? cb(CHANNEL_END) : cb(inp);
	    };
	    try {
	      channel.take(takeCb, matcher(pattern));
	    } catch (err) {
	      return cb(err, true);
	    }
	    cb.cancel = takeCb.cancel;
	  }
	
	  function runPutEffect(_ref3, cb) {
	    var channel = _ref3.channel,
	        action = _ref3.action,
	        resolve = _ref3.resolve;
	
	    /**
	      Schedule the put in case another saga is holding a lock.
	      The put will be executed atomically. ie nested puts will execute after
	      this put has terminated.
	    **/
	    (0, _scheduler.asap)(function () {
	      var result = void 0;
	      try {
	        result = (channel ? channel.put : dispatch)(action);
	      } catch (error) {
	        // If we have a channel or `put.resolve` was used then bubble up the error.
	        if (channel || resolve) return cb(error, true);
	        logError(error);
	      }
	
	      if (resolve && _utils.is.promise(result)) {
	        resolvePromise(result, cb);
	      } else {
	        return cb(result);
	      }
	    });
	    // Put effects are non cancellables
	  }
	
	  function runCallEffect(_ref4, effectId, cb) {
	    var context = _ref4.context,
	        fn = _ref4.fn,
	        args = _ref4.args;
	
	    var result = void 0;
	    // catch synchronous failures; see #152
	    try {
	      result = fn.apply(context, args);
	    } catch (error) {
	      return cb(error, true);
	    }
	    return _utils.is.promise(result) ? resolvePromise(result, cb) : _utils.is.iterator(result) ? resolveIterator(result, effectId, fn.name, cb) : cb(result);
	  }
	
	  function runCPSEffect(_ref5, cb) {
	    var context = _ref5.context,
	        fn = _ref5.fn,
	        args = _ref5.args;
	
	    // CPS (ie node style functions) can define their own cancellation logic
	    // by setting cancel field on the cb
	
	    // catch synchronous failures; see #152
	    try {
	      var cpsCb = function cpsCb(err, res) {
	        return _utils.is.undef(err) ? cb(res) : cb(err, true);
	      };
	      fn.apply(context, args.concat(cpsCb));
	      if (cpsCb.cancel) {
	        cb.cancel = function () {
	          return cpsCb.cancel();
	        };
	      }
	    } catch (error) {
	      return cb(error, true);
	    }
	  }
	
	  function runForkEffect(_ref6, effectId, cb) {
	    var context = _ref6.context,
	        fn = _ref6.fn,
	        args = _ref6.args,
	        detached = _ref6.detached;
	
	    var taskIterator = createTaskIterator({ context: context, fn: fn, args: args });
	
	    try {
	      (0, _scheduler.suspend)();
	      var _task = proc(taskIterator, subscribe, dispatch, getState, taskContext, options, effectId, fn.name, detached ? null : _utils.noop);
	
	      if (detached) {
	        cb(_task);
	      } else {
	        if (taskIterator._isRunning) {
	          taskQueue.addTask(_task);
	          cb(_task);
	        } else if (taskIterator._error) {
	          taskQueue.abort(taskIterator._error);
	        } else {
	          cb(_task);
	        }
	      }
	    } finally {
	      (0, _scheduler.flush)();
	    }
	    // Fork effects are non cancellables
	  }
	
	  function runJoinEffect(t, cb) {
	    if (t.isRunning()) {
	      var joiner = { task: task, cb: cb };
	      cb.cancel = function () {
	        return (0, _utils.remove)(t.joiners, joiner);
	      };
	      t.joiners.push(joiner);
	    } else {
	      t.isAborted() ? cb(t.error(), true) : cb(t.result());
	    }
	  }
	
	  function runCancelEffect(taskToCancel, cb) {
	    if (taskToCancel === _utils.SELF_CANCELLATION) {
	      taskToCancel = task;
	    }
	    if (taskToCancel.isRunning()) {
	      taskToCancel.cancel();
	    }
	    cb();
	    // cancel effects are non cancellables
	  }
	
	  function runAllEffect(effects, effectId, cb) {
	    var keys = Object.keys(effects);
	
	    if (!keys.length) {
	      return cb(_utils.is.array(effects) ? [] : {});
	    }
	
	    var completedCount = 0;
	    var completed = void 0;
	    var results = {};
	    var childCbs = {};
	
	    function checkEffectEnd() {
	      if (completedCount === keys.length) {
	        completed = true;
	        cb(_utils.is.array(effects) ? _utils.array.from(_extends({}, results, { length: keys.length })) : results);
	      }
	    }
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	        if (isErr || (0, _channel.isEnd)(res) || res === CHANNEL_END || res === TASK_CANCEL) {
	          cb.cancel();
	          cb(res, isErr);
	        } else {
	          results[key] = res;
	          completedCount++;
	          checkEffectEnd();
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	
	    keys.forEach(function (key) {
	      return runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runRaceEffect(effects, effectId, cb) {
	    var completed = void 0;
	    var keys = Object.keys(effects);
	    var childCbs = {};
	
	    keys.forEach(function (key) {
	      var chCbAtKey = function chCbAtKey(res, isErr) {
	        if (completed) {
	          return;
	        }
	
	        if (isErr) {
	          // Race Auto cancellation
	          cb.cancel();
	          cb(res, true);
	        } else if (!(0, _channel.isEnd)(res) && res !== CHANNEL_END && res !== TASK_CANCEL) {
	          var _response;
	
	          cb.cancel();
	          completed = true;
	          var response = (_response = {}, _response[key] = res, _response);
	          cb(_utils.is.array(effects) ? [].slice.call(_extends({}, response, { length: keys.length })) : response);
	        }
	      };
	      chCbAtKey.cancel = _utils.noop;
	      childCbs[key] = chCbAtKey;
	    });
	
	    cb.cancel = function () {
	      // prevents unnecessary cancellation
	      if (!completed) {
	        completed = true;
	        keys.forEach(function (key) {
	          return childCbs[key].cancel();
	        });
	      }
	    };
	    keys.forEach(function (key) {
	      if (completed) {
	        return;
	      }
	      runEffect(effects[key], effectId, key, childCbs[key]);
	    });
	  }
	
	  function runSelectEffect(_ref7, cb) {
	    var selector = _ref7.selector,
	        args = _ref7.args;
	
	    try {
	      var state = selector.apply(undefined, [getState()].concat(args));
	      cb(state);
	    } catch (error) {
	      cb(error, true);
	    }
	  }
	
	  function runChannelEffect(_ref8, cb) {
	    var pattern = _ref8.pattern,
	        buffer = _ref8.buffer;
	
	    var match = matcher(pattern);
	    match.pattern = pattern;
	    cb((0, _channel.eventChannel)(subscribe, buffer || _buffers.buffers.fixed(), match));
	  }
	
	  function runCancelledEffect(data, cb) {
	    cb(!!mainTask.isCancelled);
	  }
	
	  function runFlushEffect(channel, cb) {
	    channel.flush(cb);
	  }
	
	  function runGetContextEffect(prop, cb) {
	    cb(taskContext[prop]);
	  }
	
	  function runSetContextEffect(props, cb) {
	    _utils.object.assign(taskContext, props);
	    cb();
	  }
	
	  function newTask(id, name, iterator, cont) {
	    var _done, _ref9, _mutatorMap;
	
	    iterator._deferredEnd = null;
	    return _ref9 = {}, _ref9[_utils.TASK] = true, _ref9.id = id, _ref9.name = name, _done = 'done', _mutatorMap = {}, _mutatorMap[_done] = _mutatorMap[_done] || {}, _mutatorMap[_done].get = function () {
	      if (iterator._deferredEnd) {
	        return iterator._deferredEnd.promise;
	      } else {
	        var def = (0, _utils.deferred)();
	        iterator._deferredEnd = def;
	        if (!iterator._isRunning) {
	          iterator._error ? def.reject(iterator._error) : def.resolve(iterator._result);
	        }
	        return def.promise;
	      }
	    }, _ref9.cont = cont, _ref9.joiners = [], _ref9.cancel = cancel, _ref9.isRunning = function isRunning() {
	      return iterator._isRunning;
	    }, _ref9.isCancelled = function isCancelled() {
	      return iterator._isCancelled;
	    }, _ref9.isAborted = function isAborted() {
	      return iterator._isAborted;
	    }, _ref9.result = function result() {
	      return iterator._result;
	    }, _ref9.error = function error() {
	      return iterator._error;
	    }, _ref9.setContext = function setContext(props) {
	      (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('task', props));
	      _utils.object.assign(taskContext, props);
	    }, _defineEnumerableProperties(_ref9, _mutatorMap), _ref9;
	  }
	}

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runSaga = runSaga;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var _proc = /*#__PURE__*/__webpack_require__(1395);
	
	var _proc2 = /*#__PURE__*/_interopRequireDefault(_proc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RUN_SAGA_SIGNATURE = 'runSaga(storeInterface, saga, ...args)';
	var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ': saga argument must be a Generator function!';
	
	function runSaga(storeInterface, saga) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var iterator = void 0;
	
	  if (_utils.is.iterator(storeInterface)) {
	    if (false) {
	      (0, _utils.log)('warn', 'runSaga(iterator, storeInterface) has been deprecated in favor of ' + RUN_SAGA_SIGNATURE);
	    }
	    iterator = storeInterface;
	    storeInterface = saga;
	  } else {
	    (0, _utils.check)(saga, _utils.is.func, NON_GENERATOR_ERR);
	    iterator = saga.apply(undefined, args);
	    (0, _utils.check)(iterator, _utils.is.iterator, NON_GENERATOR_ERR);
	  }
	
	  var _storeInterface = storeInterface,
	      subscribe = _storeInterface.subscribe,
	      dispatch = _storeInterface.dispatch,
	      getState = _storeInterface.getState,
	      context = _storeInterface.context,
	      sagaMonitor = _storeInterface.sagaMonitor,
	      logger = _storeInterface.logger,
	      onError = _storeInterface.onError;
	
	
	  var effectId = (0, _utils.uid)();
	
	  if (sagaMonitor) {
	    // monitors are expected to have a certain interface, let's fill-in any missing ones
	    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || _utils.noop;
	    sagaMonitor.effectResolved = sagaMonitor.effectResolved || _utils.noop;
	    sagaMonitor.effectRejected = sagaMonitor.effectRejected || _utils.noop;
	    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || _utils.noop;
	    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || _utils.noop;
	
	    sagaMonitor.effectTriggered({ effectId: effectId, root: true, parentEffectId: 0, effect: { root: true, saga: saga, args: args } });
	  }
	
	  var task = (0, _proc2.default)(iterator, subscribe, (0, _utils.wrapSagaDispatch)(dispatch), getState, context, { sagaMonitor: sagaMonitor, logger: logger, onError: onError }, effectId, saga.name);
	
	  if (sagaMonitor) {
	    sagaMonitor.effectResolved(effectId, task);
	  }
	
	  return task;
	}

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttleHelper = exports.takeLatestHelper = exports.takeEveryHelper = exports.throttle = exports.takeLatest = exports.takeEvery = undefined;
	
	var _takeEvery = /*#__PURE__*/__webpack_require__(3227);
	
	var _takeEvery2 = /*#__PURE__*/_interopRequireDefault(_takeEvery);
	
	var _takeLatest = /*#__PURE__*/__webpack_require__(3228);
	
	var _takeLatest2 = /*#__PURE__*/_interopRequireDefault(_takeLatest);
	
	var _throttle = /*#__PURE__*/__webpack_require__(3229);
	
	var _throttle2 = /*#__PURE__*/_interopRequireDefault(_throttle);
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deprecationWarning = function deprecationWarning(helperName) {
	  return 'import { ' + helperName + ' } from \'redux-saga\' has been deprecated in favor of import { ' + helperName + ' } from \'redux-saga/effects\'.\nThe latter will not work with yield*, as helper effects are wrapped automatically for you in fork effect.\nTherefore yield ' + helperName + ' will return task descriptor to your saga and execute next lines of code.';
	};
	
	var takeEvery = /*#__PURE__*/(0, _utils.deprecate)(_takeEvery2.default, /*#__PURE__*/deprecationWarning('takeEvery'));
	var takeLatest = /*#__PURE__*/(0, _utils.deprecate)(_takeLatest2.default, /*#__PURE__*/deprecationWarning('takeLatest'));
	var throttle = /*#__PURE__*/(0, _utils.deprecate)(_throttle2.default, /*#__PURE__*/deprecationWarning('throttle'));
	
	exports.takeEvery = takeEvery;
	exports.takeLatest = takeLatest;
	exports.throttle = throttle;
	exports.takeEveryHelper = _takeEvery2.default;
	exports.takeLatestHelper = _takeLatest2.default;
	exports.throttleHelper = _throttle2.default;

/***/ },
/* 1398 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.asap = asap;
	exports.suspend = suspend;
	exports.flush = flush;
	var queue = [];
	/**
	  Variable to hold a counting semaphore
	  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
	    already suspended)
	  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
	    triggers flushing the queued tasks.
	**/
	var semaphore = 0;
	
	/**
	  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
	  and flushed after this task has finished (assuming the scheduler endup in a released
	  state).
	**/
	function exec(task) {
	  try {
	    suspend();
	    task();
	  } finally {
	    release();
	  }
	}
	
	/**
	  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
	**/
	function asap(task) {
	  queue.push(task);
	
	  if (!semaphore) {
	    suspend();
	    flush();
	  }
	}
	
	/**
	  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
	  scheduler is released.
	**/
	function suspend() {
	  semaphore++;
	}
	
	/**
	  Puts the scheduler in a `released` state.
	**/
	function release() {
	  semaphore--;
	}
	
	/**
	  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
	**/
	function flush() {
	  release();
	
	  var task = void 0;
	  while (!semaphore && (task = queue.shift()) !== undefined) {
	    exec(task);
	  }
	}

/***/ },
/* 1399 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(3287);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 1401 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	    labels: __webpack_require__(2296),
	    scoringStrategy: __webpack_require__(3244)
	};


/***/ },
/* 1403 */
/***/ function(module, exports) {

	module.exports = function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(375).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StyleSheetManager$ch;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(376);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StyleSheetManager = function (_Component) {
	  _inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    _classCallCheck(this, StyleSheetManager);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[_StyleSheet.CONTEXT_KEY] = this.props.sheet, _ref;
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(_react.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[_StyleSheet.CONTEXT_KEY] = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StyleSheet2.default), _propTypes2.default.instanceOf(_ServerStyleSheet2.default)]).isRequired, _StyleSheetManager$ch);
	
	StyleSheetManager.propTypes = {
	  sheet: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StyleSheet2.default), _propTypes2.default.instanceOf(_ServerStyleSheet2.default)]).isRequired
	};
	
	exports.default = StyleSheetManager;
	module.exports = exports['default'];

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	if (true) Object.defineProperty(exports, "babelPluginFlowReactPropTypes_proptype_Broadcast", {
	  value: __webpack_require__(2).shape({
	    publish: __webpack_require__(2).func.isRequired,
	    subscribe: __webpack_require__(2).func.isRequired,
	    unsubscribe: __webpack_require__(2).func.isRequired
	  })
	});
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var _listener = listeners[key];
	      if (_listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      _listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	exports.default = createBroadcast;
	module.exports = exports["default"];

/***/ },
/* 1407 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	};
	
	module.exports = exports["default"];

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.objToCss = undefined;
	
	var _hyphenateStyleName = __webpack_require__(2020);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _isPlainObject = __webpack_require__(957);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	var objToCss = exports.objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if ((0, _isPlainObject2.default)(obj[key])) return objToCss(obj[key], key);
	    return (0, _hyphenateStyleName2.default)(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      return [].concat(ruleSet, flatten(chunk, executionContext));
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
	    }
	
	    /* Handle objects */
	    return ruleSet.concat(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    (0, _isPlainObject2.default)(chunk) ? objToCss(chunk) : chunk.toString());
	  }, []);
	};
	
	exports.default = flatten;

/***/ },
/* 1409 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	};
	/* eslint-disable camelcase, no-undef */
	
	module.exports = exports['default'];

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  console.warn("Using browser-only version of superagent in non-browser environment");
	  root = this;
	}
	
	var Emitter = __webpack_require__(1859);
	var RequestBase = __webpack_require__(3284);
	var isObject = __webpack_require__(1411);
	var ResponseBase = __webpack_require__(3285);
	var Agent = __webpack_require__(3283);
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Expose `request`.
	 */
	
	var request = exports = module.exports = function(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new exports.Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new exports.Request('GET', method);
	  }
	
	  return new exports.Request(method, url);
	}
	
	exports.Request = Request;
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  throw Error("Browser-only version of superagent could not find XHR");
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    pushEncodedKeyValuePair(pairs, key, obj[key]);
	  }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (val != null) {
	    if (Array.isArray(val)) {
	      val.forEach(function(v) {
	        pushEncodedKeyValuePair(pairs, key, v);
	      });
	    } else if (isObject(val)) {
	      for(var subkey in val) {
	        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	      }
	    } else {
	      pairs.push(encodeURIComponent(key)
	        + '=' + encodeURIComponent(val));
	    }
	  } else if (val === null) {
	    pairs.push(encodeURIComponent(key));
	  }
	}
	
	/**
	 * Expose serialization method.
	 */
	
	request.serializeObject = serialize;
	
	/**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var pair;
	  var pos;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    pos = pair.indexOf('=');
	    if (pos == -1) {
	      obj[decodeURIComponent(pair)] = '';
	    } else {
	      obj[decodeURIComponent(pair.slice(0, pos))] =
	        decodeURIComponent(pair.slice(pos + 1));
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'text/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	request.serialize = {
	  'application/x-www-form-urlencoded': serialize,
	  'application/json': JSON.stringify,
	};
	
	/**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse,
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    if (index === -1) { // could be empty line, just skip it
	      continue;
	    }
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req) {
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  var status = this.xhr.status;
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	  this._setStatusProperties(status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this._setHeaderProperties(this.header);
	
	  if (null === this.text && req._responseType) {
	    this.body = this.xhr.response;
	  } else {
	    this.body = this.req.method != 'HEAD'
	      ? this._parseBody(this.text ? this.text : this.xhr.response)
	      : null;
	  }
	}
	
	ResponseBase(Response.prototype);
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype._parseBody = function(str) {
	  var parse = request.parse[this.type];
	  if (this.req._parser) {
	    return this.req._parser(this, str);
	  }
	  if (!parse && isJSON(this.type)) {
	    parse = request.parse['application/json'];
	  }
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {}; // preserves header name case
	  this._header = {}; // coerces header names to lowercase
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      if (self.xhr) {
	        // ie9 doesn't have 'response' property
	        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
	        // issue #876: return the http status code if the response parsing fails
	        err.status = self.xhr.status ? self.xhr.status : null;
	        err.statusCode = err.status; // backwards-compat only
	      } else {
	        err.rawResponse = null;
	        err.status = null;
	      }
	
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    var new_err;
	    try {
	      if (!self._isResponseOK(res)) {
	        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	      }
	    } catch(custom_err) {
	      new_err = custom_err; // ok() callback can throw
	    }
	
	    // #1000 don't catch errors from the callback to avoid double calling it
	    if (new_err) {
	      new_err.original = err;
	      new_err.response = res;
	      new_err.status = res.status;
	      self.callback(new_err, res);
	    } else {
	      self.callback(null, res);
	    }
	  });
	}
	
	/**
	 * Mixin `Emitter` and `RequestBase`.
	 */
	
	Emitter(Request.prototype);
	RequestBase(Request.prototype);
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} [pass] optional in case of using 'bearer' as type
	 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass, options){
	  if (1 === arguments.length) pass = '';
	  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
	    options = pass;
	    pass = '';
	  }
	  if (!options) {
	    options = {
	      type: 'function' === typeof btoa ? 'basic' : 'auto',
	    };
	  }
	
	  var encoder = function(string) {
	    if ('function' === typeof btoa) {
	      return btoa(string);
	    }
	    throw new Error('Cannot use basic auth, btoa is not a function');
	  };
	
	  return this._auth(user, pass, options, encoder);
	};
	
	/**
	 * Add query-string `val`.
	 *
	 * Examples:
	 *
	 *   request.get('/shoes')
	 *     .query('size=10')
	 *     .query({ color: 'blue' })
	 *
	 * @param {Object|String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `options` (or filename).
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String|Object} options
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, options){
	  if (file) {
	    if (this._data) {
	      throw Error("superagent can't mix .send() and .attach()");
	    }
	
	    this._getFormData().append(field, file, options || file.name);
	  }
	  return this;
	};
	
	Request.prototype._getFormData = function(){
	  if (!this._formData) {
	    this._formData = new root.FormData();
	  }
	  return this._formData;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  if (this._shouldRetry(err, res)) {
	    return this._retry();
	  }
	
	  var fn = this._callback;
	  this.clearTimeout();
	
	  if (err) {
	    if (this._maxRetries) err.retries = this._retries - 1;
	    this.emit('error', err);
	  }
	
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	// This only warns, because the request is still likely to work
	Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
	  console.warn("This is not supported in browser version of superagent");
	  return this;
	};
	
	// This throws, because it can't send/receive data as expected
	Request.prototype.pipe = Request.prototype.write = function(){
	  throw Error("Streaming is not supported in browser version of superagent");
	};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	Request.prototype._isHost = function _isHost(obj) {
	  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
	  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
	}
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  if (this._endCalled) {
	    console.warn("Warning: .end() was called twice. This is not supported in superagent");
	  }
	  this._endCalled = true;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // querystring
	  this._finalizeQueryString();
	
	  return this._end();
	};
	
	Request.prototype._end = function() {
	  var self = this;
	  var xhr = (this.xhr = request.getXHR());
	  var data = this._formData || this._data;
	
	  this._setTimeouts();
	
	  // state change
	  xhr.onreadystatechange = function(){
	    var readyState = xhr.readyState;
	    if (readyState >= 2 && self._responseTimeoutTimer) {
	      clearTimeout(self._responseTimeoutTimer);
	    }
	    if (4 != readyState) {
	      return;
	    }
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (!status) {
	      if (self.timedout || self._aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(direction, e) {
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = direction;
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    try {
	      xhr.onprogress = handleProgress.bind(null, 'download');
	      if (xhr.upload) {
	        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
	      }
	    } catch(e) {
	      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	      // Reported here:
	      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	    }
	  }
	
	  // initiate request
	  try {
	    if (this.username && this.password) {
	      xhr.open(this.method, this.url, true, this.username, this.password);
	    } else {
	      xhr.open(this.method, this.url, true);
	    }
	  } catch (err) {
	    // see #1149
	    return this.callback(err);
	  }
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	    // serialize stuff
	    var contentType = this._header['content-type'];
	    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) {
	      serialize = request.serialize['application/json'];
	    }
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	
	    if (this.header.hasOwnProperty(field))
	      xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  if (this._responseType) {
	    xhr.responseType = this._responseType;
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	request.agent = function() {
	  return new Agent();
	};
	
	["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
	  Agent.prototype[method.toLowerCase()] = function(url, fn) {
	    var req = new request.Request(method, url);
	    this._setDefaults(req);
	    if (fn) {
	      req.end(fn);
	    }
	    return req;
	  };
	});
	
	Agent.prototype.del = Agent.prototype['delete'];
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn) {
	  var req = request('GET', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn) {
	  var req = request('HEAD', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * OPTIONS query to `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.options = function(url, data, fn) {
	  var req = request('OPTIONS', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, data, fn) {
	  var req = request('DELETE', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	}
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn) {
	  var req = request('PATCH', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} [data]
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn) {
	  var req = request('POST', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} [data] or fn
	 * @param {Function} [fn]
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn) {
	  var req = request('PUT', url);
	  if ('function' == typeof data) (fn = data), (data = null);
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};


/***/ },
/* 1411 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return null !== obj && 'object' === typeof obj;
	}
	
	module.exports = isObject;


/***/ },
/* 1412 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAoCAYAAADpE0oSAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAABzElEQVRYCe2WPUsDQRCGZxZttNLOKkQLwdLUglqIBNtYiCD5FxaCB1Zi4w9QULQypRaiQtTYCFomYJNolcpKDIhy4+7BHpuPvcxmCxHu4Jj9mJnn5t29vQP4owtduRQEol6pPiJBDhA/MaSVbLl055rHCaygrw+18zCkvAYhQguGYXbysvSixzhWcJyUj4I2KrVjExqNE4zAN5Try4Vpbi7lx6pYQ4lo3ZZcVt6UlS9wK+8L5kD1w7jAE8EuUFe4dY1tUPmkHxoSWYSq2SeCCc6a9wRboXIdBeCRCZKv1AUinppjHHgXOAmqNg8BvJsQ1c7OzWy4wtvA/aC2HYtBELrCY/CgUF29KzwC+0IHgUfg+n3toPNwcHknNVjZvpXn1zLKT7wtFXLyQCyqjr4GhcbxSWv+9bOl/OI1joMcjz4d12ltlWs/kbkqPcsK9+Tdkif3E4GYt+1eHcS1Gg4C9+P8SDsqPvHI7AVoLK5uh/JbFc8J3J26OduM+8xGl9TMOG+3FOwtITdBKjVXKW+/VGpvCbkJUqm5Snn7pVJ7S8hNkErNVcrb7x9JLahpliuovW/OJbWdKx4agxP5q3otf09J2tvRcThMAtjmfgEvaQStHJxUdAAAAABJRU5ErkJggg=="

/***/ },
/* 1413 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAoCAYAAADpE0oSAAAAAXNSR0IArs4c6QAAAfRJREFUWAntlz1Lw0AYx58ntAi+LDo5+JZBIR0VXFpr8QUXcQouioN+AEF0EzL4FVxcRFCX4KQUEUXBuW4KDrV0EhzqoOKg5LxLTZuEJM3lgi65IZfn7n/PL88/SXtBiNBeVLXzvQanQCAPCJfpbljo0/VPnlQSj9jSftRglRCYJABI+5nvV1i25sL2kcAGYq8DYLhix6R3EAnsnYpvNAHz+SWgTqwWMI9vaWI1n18C6sRqAfP4liZW8/kloE6sFjCPb+m/WZ1i11meVvvpVvUEARSCuCdnlQ3UNIOvBn91eWpxGMA4Yvmpale+0rfMipHgNgWP0a1qOxhkvXL7cEA0LRY3nubUEQTjxspPGZvVWXXUMzkhZCkOOIPCF1xTmHM7TMuug9tSO4jwbDdLFO4Pxf2BC71kguXicRXSUIgL7gdFxEN5QlljBTasls/1xzjgQdChnLJiPbQNMLsKUXhYqKNiFrAWFc4DZRxHxWyAtVbwuqp5pO9nj9fTy+6p3d7mCvqZaQ/c535V0FX39L3MWHqa5I1+snZZMeuDoOa8Xex17gv3Ev+OtYIyWWDFVm4eeBhoaDAThoGHhXKBW8F5oNxgG/zO/ENhA7RJEhYHs8q89eNQHw0+hrrH7hSVgponEp4BIR0EoSTnMuM8UHe+P41/AOeVAkVXPWxSAAAAAElFTkSuQmCC"

/***/ },
/* 1414 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAoCAYAAADt5povAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAABuUlEQVRYCe2XvU7DMBDH70zFK1AEPAEzz0ArpVvLxMfGBjMLEl9CMLMxAWKA0i4tEmXq2/AWyXHn1lUq3NjXVkyx5Drp/e9+yd+25ADM2S6Gw8o8qahNqvW6OwRplxPXyODNd9K61tQwGrHVYnrL4xYBrEJGV0m/vaGpoQcSrucBhFDN34eu9cBQxUC8BAYM0odLS/WeBTJKSwMG6cOlpXrPAhmlpQGD9OHSUr1ngYx/t7RS73caBNmjfTDE00HS+gg8pCpc77ebfMJ7kCQEc2wERgRV6Xzse9vttQ9UFQvEtc/OPtd9d/WFNWUpP4nhA+6TCAvqRIVsjSx7lpr5BAGccM/cn1bAwkWgPphl8JSZr8ZeB4w5WhZ0JowZsj7s6w6S5usyoMUwZnCb+LsoNAY2BZSbeaGxMGHw1P1tRQV465wR0LbLwhU8h5Qu86vRrgc7ZyMbnVZGL1ACM6GEP4S0KRppUjwWNtbbPO+PD8oIrs8faZ5W9GZO7k10QRn90LxidB0DE2UQKKIQNBYWDSyCamAqoIMSZS9AY2cQCREP7XYSQUSbbPwIrd2naPAOEVLbge41MGH8An3977WSKyyYAAAAAElFTkSuQmCC"

/***/ },
/* 1415 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAoCAYAAADt5povAAAAAXNSR0IArs4c6QAAAZ9JREFUWAntmL9OwzAQxu8cHoeNlwgqdGoKAwIm3oCFAdiQGOkT8GcqbI1EmPoCrDwBqujKilDM2a2jRHaSM2ZgcKTI8tnf/XxfnCgJgueRzqZXJDnVMoHXxSA780mBPpPT/OlASnkHUq50CBJRHBY7owduHsGdqGBQlrcVTAkloIrpMWYiVoUGJgGcC6QkJQhxxKm0F9gHM4Vxoc4VmyT9MKSiV4eunmFvK9AF01UYArWEW9RjHKgT2ApL8KLGIyJ8qmvnA7WArTBKnEj53ABSR28UD2gD2AXr2oE+0Ar4W5ipmAvVwFCYD1Sk+WOmnhZ6h62V3HvKgOptV6Xbs+lI0KPq5q9gBtwGJc6kuoZqckhlBmZaBSXAcf2WUWMCQZwgwnJ97unVGVVg+zIc3xNhv8qvWD45B/l067uEV6NBwLdimG2aPqdtWMoRhM6JwFAHLX201LIkNBAtDXXQ0kdLLUtCA9HSUActfbTUsiQ08L8tpc+zZaNClB+NPqPjVWG+O17Qa985vep9Ue53kInXHwzGetxTLufzDfdIf/QHGgjkZFPRjkwAAAAASUVORK5CYII="

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gogochart_greenlogo.bcda2c8f.png";

/***/ },
/* 1417 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 1418 */
/***/ function(module, exports) {

	var WinChan = (function() {
	  var RELAY_FRAME_NAME = "__winchan_relay_frame";
	  var CLOSE_CMD = "die";
	
	  // a portable addListener implementation
	  function addListener(w, event, cb) {
	    if(w.attachEvent) w.attachEvent('on' + event, cb);
	    else if (w.addEventListener) w.addEventListener(event, cb, false);
	  }
	
	  // a portable removeListener implementation
	  function removeListener(w, event, cb) {
	    if(w.detachEvent) w.detachEvent('on' + event, cb);
	    else if (w.removeEventListener) w.removeEventListener(event, cb, false);
	  }
	
	
	  // checking for IE8 or above
	  function isInternetExplorer() {
	    if (typeof navigator === 'undefined') {
	      return false;
	    }
	
	    var rv = -1; // Return value assumes failure.
	    var ua = navigator.userAgent;
	    if (navigator.appName === 'Microsoft Internet Explorer') {
	      var re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");
	      if (re.exec(ua) != null)
	        rv = parseFloat(RegExp.$1);
	    }
	    // IE > 11
	    else if (ua.indexOf("Trident") > -1) {
	      var re = new RegExp("rv:([0-9]{2,2}[\.0-9]{0,})");
	      if (re.exec(ua) !== null) {
	        rv = parseFloat(RegExp.$1);
	      }
	    }
	
	    return rv >= 8;
	  }
	
	  // checking Mobile Firefox (Fennec)
	  function isFennec() {
	    try {
	      // We must check for both XUL and Java versions of Fennec.  Both have
	      // distinct UA strings.
	      var userAgent = navigator.userAgent;
	      return (userAgent.indexOf('Fennec/') != -1) ||  // XUL
	             (userAgent.indexOf('Firefox/') != -1 && userAgent.indexOf('Android') != -1);   // Java
	    } catch(e) {}
	    return false;
	  }
	
	  // feature checking to see if this platform is supported at all
	  function isSupported() {
	    return (typeof window !== 'undefined' && window.JSON && window.JSON.stringify &&
	            window.JSON.parse && window.postMessage);
	  }
	
	  // given a URL, extract the origin. Taken from: https://github.com/firebase/firebase-simple-login/blob/d2cb95b9f812d8488bdbfba51c3a7c153ba1a074/js/src/simple-login/transports/WinChan.js#L25-L30
	  function extractOrigin(url) {
	    if (!/^https?:\/\//.test(url)) url = window.location.href;
	    var m = /^(https?:\/\/[\-_a-zA-Z\.0-9:]+)/.exec(url);
	    if (m) return m[1];
	    return url;
	  }
	
	  // find the relay iframe in the opener
	  function findRelay() {
	    var loc = window.location;
	    var frames = window.opener.frames;
	    for (var i = frames.length - 1; i >= 0; i--) {
	      try {
	        if (frames[i].location.protocol === window.location.protocol &&
	            frames[i].location.host === window.location.host &&
	            frames[i].name === RELAY_FRAME_NAME)
	        {
	          return frames[i];
	        }
	      } catch(e) { }
	    }
	    return;
	  }
	
	  var isIE = isInternetExplorer();
	
	  if (isSupported()) {
	    /*  General flow:
	     *                  0. user clicks
	     *  (IE SPECIFIC)   1. caller adds relay iframe (served from trusted domain) to DOM
	     *                  2. caller opens window (with content from trusted domain)
	     *                  3. window on opening adds a listener to 'message'
	     *  (IE SPECIFIC)   4. window on opening finds iframe
	     *                  5. window checks if iframe is "loaded" - has a 'doPost' function yet
	     *  (IE SPECIFIC5)  5a. if iframe.doPost exists, window uses it to send ready event to caller
	     *  (IE SPECIFIC5)  5b. if iframe.doPost doesn't exist, window waits for frame ready
	     *  (IE SPECIFIC5)  5bi. once ready, window calls iframe.doPost to send ready event
	     *                  6. caller upon reciept of 'ready', sends args
	     */
	    return {
	      open: function(opts, cb) {
	        if (!cb) throw "missing required callback argument";
	
	        // test required options
	        var err;
	        if (!opts.url) err = "missing required 'url' parameter";
	        if (!opts.relay_url) err = "missing required 'relay_url' parameter";
	        if (err) setTimeout(function() { cb(err); }, 0);
	
	        // supply default options
	        if (!opts.window_name) opts.window_name = null;
	        if (!opts.window_features || isFennec()) opts.window_features = undefined;
	
	        // opts.params may be undefined
	
	        var iframe;
	
	        // sanity check, are url and relay_url the same origin?
	        var origin = opts.origin || extractOrigin(opts.url);
	        if (origin !== extractOrigin(opts.relay_url)) {
	          return setTimeout(function() {
	            cb('invalid arguments: origin of url and relay_url must match');
	          }, 0);
	        }
	
	        var messageTarget;
	
	        if (isIE) {
	          // first we need to add a "relay" iframe to the document that's served
	          // from the target domain.  We can postmessage into a iframe, but not a
	          // window
	          iframe = document.createElement("iframe");
	          // iframe.setAttribute('name', framename);
	          iframe.setAttribute('src', opts.relay_url);
	          iframe.style.display = "none";
	          iframe.setAttribute('name', RELAY_FRAME_NAME);
	          document.body.appendChild(iframe);
	          messageTarget = iframe.contentWindow;
	        }
	
	        var w = opts.popup || window.open(opts.url, opts.window_name, opts.window_features);
	        if (opts.popup) {
	          w.location.href = opts.url;
	        }
	
	        if (!messageTarget) messageTarget = w;
	
	        // lets listen in case the window blows up before telling us
	        var closeInterval = setInterval(function() {
	          if (w && w.closed) {
	            cleanup();
	            if (cb) {
	              cb('User closed the popup window');
	              cb = null;
	            }
	          }
	        }, 500);
	
	        var req = JSON.stringify({a: 'request', d: opts.params});
	
	        // cleanup on unload
	        function cleanup() {
	          if (iframe) document.body.removeChild(iframe);
	          iframe = undefined;
	          if (closeInterval) closeInterval = clearInterval(closeInterval);
	          removeListener(window, 'message', onMessage);
	          removeListener(window, 'unload', cleanup);
	          if (w) {
	            try {
	              w.close();
	            } catch (securityViolation) {
	              // This happens in Opera 12 sometimes
	              // see https://github.com/mozilla/browserid/issues/1844
	              messageTarget.postMessage(CLOSE_CMD, origin);
	            }
	          }
	          w = messageTarget = undefined;
	        }
	
	        addListener(window, 'unload', cleanup);
	
	        function onMessage(e) {
	          if (e.origin !== origin) { return; }
	          try {
	            var d = JSON.parse(e.data);
	          } catch(err) {
	            if (cb) {
	              cb(err);
	            } else {
	              throw err;
	            }
	          }
	
	          if (d.a === 'ready') {
	            messageTarget.postMessage(req, origin);
	          } else if (d.a === 'error') {
	            cleanup();
	            if (cb) {
	              cb(d.d);
	              cb = null;
	            }
	          } else if (d.a === 'response') {
	            cleanup();
	            if (cb) {
	              cb(null, d.d);
	              cb = null;
	            }
	          }
	        }
	
	        addListener(window, 'message', onMessage);
	
	        return {
	          close: cleanup,
	          focus: function() {
	            if (w) {
	              try {
	                w.focus();
	              } catch (e) {
	                // IE7 blows up here, do nothing
	              }
	            }
	          }
	        };
	      },
	      onOpen: function(cb) {
	        var o = "*";
	        var msgTarget = isIE ? findRelay() : window.opener;
	        if (!msgTarget) throw "can't find relay frame";
	        function doPost(msg) {
	          msg = JSON.stringify(msg);
	          if (isIE) msgTarget.doPost(msg, o);
	          else msgTarget.postMessage(msg, o);
	        }
	
	        function onMessage(e) {
	          // only one message gets through, but let's make sure it's actually
	          // the message we're looking for (other code may be using
	          // postmessage) - we do this by ensuring the payload can
	          // be parsed, and it's got an 'a' (action) value of 'request'.
	          var d;
	          try {
	            d = JSON.parse(e.data);
	          } catch(err) { }
	          if (!d || d.a !== 'request') return;
	          removeListener(window, 'message', onMessage);
	          o = e.origin;
	          if (cb) {
	            // this setTimeout is critically important for IE8 -
	            // in ie8 sometimes addListener for 'message' can synchronously
	            // cause your callback to be invoked.  awesome.
	            setTimeout(function() {
	              cb(o, d.d, function(r) {
	                cb = undefined;
	                doPost({a: 'response', d: r});
	              });
	            }, 0);
	          }
	        }
	
	        function onDie(e) {
	          if (e.data === CLOSE_CMD) {
	            try { window.close(); } catch (o_O) {}
	          }
	        }
	        addListener(isIE ? msgTarget : window, 'message', onMessage);
	        addListener(isIE ? msgTarget : window, 'message', onDie);
	
	        // we cannot post to our parent that we're ready before the iframe
	        // is loaded. (IE specific possible failure)
	        try {
	          doPost({a: "ready"});
	        } catch(e) {
	          // this code should never be exectued outside IE
	          addListener(msgTarget, 'load', function(e) {
	            doPost({a: "ready"});
	          });
	        }
	
	        // if window is unloaded and the client hasn't called cb, it's an error
	        var onUnload = function() {
	          try {
	            // IE8 doesn't like this...
	            removeListener(isIE ? msgTarget : window, 'message', onDie);
	          } catch (ohWell) { }
	          if (cb) doPost({ a: 'error', d: 'client closed window' });
	          cb = undefined;
	          // explicitly close the window, in case the client is trying to reload or nav
	          try { window.close(); } catch (e) { }
	        };
	        addListener(window, 'unload', onUnload);
	        return {
	          detach: function() {
	            removeListener(window, 'unload', onUnload);
	          }
	        };
	      }
	    };
	  } else {
	    return {
	      open: function(url, winopts, arg, cb) {
	        setTimeout(function() { cb("unsupported browser"); }, 0);
	      },
	      onOpen: function(cb) {
	        setTimeout(function() { cb("unsupported browser"); }, 0);
	      }
	    };
	  }
	})();
	
	if (typeof module !== 'undefined' && module.exports) {
	  module.exports = WinChan;
	}


/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(Buffer) {/*!
	
	JSZip - A Javascript class for generating and reading zip files
	<http://stuartk.com/jszip>
	
	(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
	Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.
	
	JSZip uses the library pako released under the MIT license :
	https://github.com/nodeca/pako/blob/master/LICENSE
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.JSZip=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;
	
	},{}],3:[function(_dereq_,module,exports){
	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = _dereq_('./flate');
	
	},{"./flate":8}],4:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./utils":21}],5:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;
	
	},{"./utils":21}],6:[function(_dereq_,module,exports){
	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.comment = null;
	
	},{}],7:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	
	
	},{"./utils":21}],8:[function(_dereq_,module,exports){
	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = _dereq_("pako");
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input) {
	    return pako.deflateRaw(input);
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};
	
	},{"pako":24}],9:[function(_dereq_,module,exports){
	'use strict';
	
	var base64 = _dereq_('./base64');
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZip(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZip)) return new JSZip(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZip();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZip.prototype = _dereq_('./object');
	JSZip.prototype.load = _dereq_('./load');
	JSZip.support = _dereq_('./support');
	JSZip.defaults = _dereq_('./defaults');
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZip.utils = _dereq_('./deprecatedPublicUtils');
	
	JSZip.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZip.compressions = _dereq_('./compressions');
	module.exports = JSZip;
	
	},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
	'use strict';
	var base64 = _dereq_('./base64');
	var ZipEntries = _dereq_('./zipEntries');
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = options || {};
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileName, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileComment.length ? input.fileComment : null,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};
	
	},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	module.exports = function(data, encoding){
	    return new Buffer(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],12:[function(_dereq_,module,exports){
	'use strict';
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;
	
	},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var utils = _dereq_('./utils');
	var crc32 = _dereq_('./crc32');
	var signature = _dereq_('./signature');
	var defaults = _dereq_('./defaults');
	var base64 = _dereq_('./base64');
	var compressions = _dereq_('./compressions');
	var CompressedObject = _dereq_('./compressedObject');
	var nodeBuffer = _dereq_('./nodeBuffer');
	var utf8 = _dereq_('./utf8');
	var StringWriter = _dereq_('./stringWriter');
	var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	var extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    // Check the name ends with a /
	    if (name.slice(-1) != "/") {
	        name += "/"; // IE doesn't like substr(-1)
	    }
	
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset) {
	    var data = compressedObject.compressedContent,
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	    // date
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
	    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(utfEncodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(utfEncodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(utfEncodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    "\x14\x00" +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(utfEncodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    utfEncodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    utfEncodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            type: "base64",
	            comment: null
	        });
	
	        utils.checkSupport(options.type);
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(utfEncodedComment.length, 2) +
	        // .ZIP file comment
	        utfEncodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;
	
	},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";
	
	},{}],15:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	var utils = _dereq_('./utils');
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig);
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;
	
	},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;
	
	},{"./utils":21}],17:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],18:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	    }
	}
	Uint8ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	Uint8ArrayReader.prototype.byteAt = function(i) {
	    return this.data[i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;
	
	},{"./dataReader":5}],19:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;
	
	},{"./utils":21}],20:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	var support = _dereq_('./support');
	var nodeBuffer = _dereq_('./nodeBuffer');
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var compressions = _dereq_('./compressions');
	var nodeBuffer = _dereq_('./nodeBuffer');
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: "application/zip"
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob('application/zip');
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	
	
	},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var NodeBufferReader = _dereq_('./nodeBufferReader');
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	var utils = _dereq_('./utils');
	var sig = _dereq_('./signature');
	var ZipEntry = _dereq_('./zipEntry');
	var support = _dereq_('./support');
	var jszipProto = _dereq_('./object');
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        this.zipComment = this.reader.readString(this.zipCommentLength);
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded.
	        this.zipComment = jszipProto.utf8decode(this.zipComment);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset === -1) {
	            throw new Error("Corrupted zip : can't find end of central directory");
	        }
	        this.reader.setIndex(offset);
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset === -1) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;
	
	},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var utils = _dereq_('./utils');
	var CompressedObject = _dereq_('./compressedObject');
	var jszipProto = _dereq_('./object');
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readString(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readString(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readString(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readString(this.fileCommentLength);
	
	        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
	        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
	    },
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        if (this.useUTF8()) {
	            this.fileName = jszipProto.utf8decode(this.fileName);
	            this.fileComment = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileName = upath;
	            }
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileComment = ucomment;
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;
	
	},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = _dereq_('./lib/utils/common').assign;
	
	var deflate   = _dereq_('./lib/deflate');
	var inflate   = _dereq_('./lib/inflate');
	var constants = _dereq_('./lib/zlib/constants');
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;
	},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_deflate = _dereq_('./zlib/deflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	var Deflate = function(options) {
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new zstream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	};
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data. Strings will be converted to
	 *   utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Deflate#onEnd]].
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate alrorythm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;
	},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_inflate = _dereq_('./zlib/inflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var c = _dereq_('./zlib/constants');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	var gzheader = _dereq_('./zlib/gzheader');
	
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	var Inflate = function(options) {
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new zstream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new gzheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	};
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Inflate#onEnd]].
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell inflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;
	
	},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof(source) !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	},{}],28:[function(_dereq_,module,exports){
	// String encode/decode helpers
	'use strict';
	
	
	var utils = _dereq_('./common');
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for(var i=0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function(buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function(str) {
	  var buf = new utils.Buf8(str.length);
	  for(var i=0, len=buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len*2);
	
	  for (out=0, i=0; i<len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function(buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max-1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	},{"./common":27}],29:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0
	    , s2 = ((adler >>> 16) & 0xffff) |0
	    , n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	},{}],30:[function(_dereq_,module,exports){
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};
	},{}],31:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for(var n =0; n < 256; n++){
	    c = n;
	    for(var k =0; k < 8; k++){
	      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable
	    , end = pos + len;
	
	  crc = crc ^ (-1);
	
	  for (var i = pos; i < end; i++ ) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	},{}],32:[function(_dereq_,module,exports){
	'use strict';
	
	var utils   = _dereq_('../utils/common');
	var trees   = _dereq_('./trees');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var msg   = _dereq_('./messages');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only (s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH-1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH-1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length-1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH-1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	};
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
	  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  s.d_buf = s.lit_bufsize >> 1;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg){
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	/* =========================================================================
	 * Copy the source state to the destination state
	 */
	//function deflateCopy(dest, source) {
	//
	//}
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
	'use strict';
	
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;
	},{}],34:[function(_dereq_,module,exports){
	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  var window;                 /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var inflate_fast = _dereq_('./inffast');
	var inflate_table = _dereq_('./inftrees');
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function ZSWAP32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window,src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = ZSWAP32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = {bits: state.distbits};
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
	        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	      base = extra = work;    /* dummy value--not used */
	      end = 19;
	  } else if (type === LENS) {
	      base = lbase;
	      base_index -= 257;
	      extra = lext;
	      extra_index -= 257;
	      end = 256;
	  } else {                    /* DISTS */
	      base = dbase;
	      extra = dext;
	      end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i=0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};
	
	},{"../utils/common":27}],37:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = {
	  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
	  '1':    'stream end',          /* Z_STREAM_END      1  */
	  '0':    '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	},{}],38:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES+2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	};
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	var TreeDesc = function(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	};
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short (s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n*2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n-base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length-1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m*2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
	        tree[m*2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n*2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES-1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1<<extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length-1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0 ; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1<<extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for ( ; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n*2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n*2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES+1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n*2 + 1]/*.Len*/ = 5;
	    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n*2;
	  var _m2 = m*2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code+LITERALS+1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n*2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node*2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6*2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count-3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count-3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count-11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3*(max_blindex+1) + 5+5+4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes-1,   5);
	  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES<<1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len+3+7) >>> 3;
	    static_lenb = (s.static_len+3+7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc*2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize-1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
	},{"../utils/common":27}],39:[function(_dereq_,module,exports){
	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	},{}]},{},[9])
	(9)
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 1420 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports['default'];

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _EventBaseObject = __webpack_require__(1420);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = void 0;
	    var deltaY = void 0;
	    var delta = void 0;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = void 0;
	    var doc = void 0;
	    var body = void 0;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2["default"].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = void 0;
	  var l = void 0;
	  var prop = void 0;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2["default"].prototype;
	
	(0, _objectAssign2["default"])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports["default"] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = addEventListener;
	
	var _EventObject = __webpack_require__(1421);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function addEventListener(target, eventType, callback) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2["default"](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    target.addEventListener(eventType, wrapCallback, false);
	    return {
	      remove: function remove() {
	        target.removeEventListener(eventType, wrapCallback, false);
	      }
	    };
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	var adverbs = [
	  'absolutel',
	  'accidentall',
	  'additionall',
	  'allegedl',
	  'alternativel',
	  'angril',
	  'anxiousl',
	  'approximatel',
	  'awkwardl',
	  'badl',
	  'barel',
	  'beautifull',
	  'blindl',
	  'boldl',
	  'bravel',
	  'brightl',
	  'briskl',
	  'bristl',
	  'bubbl',
	  'busil',
	  'calml',
	  'carefull',
	  'carelessl',
	  'cautiousl',
	  'cheerfull',
	  'clearl',
	  'closel',
	  'coldl',
	  'completel',
	  'consequentl',
	  'correctl',
	  'courageousl',
	  'crinkl',
	  'cruell',
	  'crumbl',
	  'cuddl',
	  'currentl',
	  'dail',
	  'daringl',
	  'deadl',
	  'definitel',
	  'deliberatel',
	  'doubtfull',
	  'dumbl',
	  'eagerl',
	  'earl',
	  'easil',
	  'elegantl',
	  'enormousl',
	  'enthusiasticall',
	  'equall',
	  'especiall',
	  'eventuall',
	  'exactl',
	  'exceedingl',
	  'exclusivel',
	  'extremel',
	  'fairl',
	  'faithfull',
	  'fatall',
	  'fiercel',
	  'finall',
	  'fondl',
	  'foolishl',
	  'fortunatel',
	  'frankl',
	  'franticall',
	  'generousl',
	  'gentl',
	  'giggl',
	  'gladl',
	  'gracefull',
	  'greedil',
	  'happil',
	  'hardl',
	  'hastil',
	  'healthil',
	  'heartil',
	  'helpfull',
	  'honestl',
	  'hourl',
	  'hungril',
	  'hurriedl',
	  'immediatel',
	  'impatientl',
	  'inadequatel',
	  'ingeniousl',
	  'innocentl',
	  'inquisitivel',
	  'interestingl',
	  'irritabl',
	  'jiggl',
	  'joyousl',
	  'justl',
	  'kindl',
	  'largel',
	  'latel',
	  'lazil',
	  'likel',
	  'literall',
	  'lonel',
	  'loosel',
	  'loudl',
	  'loudl',
	  'luckil',
	  'madl',
	  'man',
	  'mentall',
	  'mildl',
	  'monthl',
	  'mortall',
	  'mostl',
	  'mysteriousl',
	  'neatl',
	  'nervousl',
	  'nightl',
	  'noisil',
	  'normall',
	  'obedientl',
	  'occasionall',
	  'onl',
	  'openl',
	  'painfull',
	  'particularl',
	  'patientl',
	  'perfectl',
	  'politel',
	  'poorl',
	  'powerfull',
	  'presumabl',
	  'previousl',
	  'promptl',
	  'punctuall',
	  'quarterl',
	  'quickl',
	  'quietl',
	  'rapidl',
	  'rarel',
	  'reall',
	  'recentl',
	  'recklessl',
	  'regularl',
	  'relativel',
	  'reluctantl',
	  'remarkabl',
	  'repeatedl',
	  'rightfull',
	  'roughl',
	  'rudel',
	  'sadl',
	  'safel',
	  'selfishl',
	  'sensibl',
	  'seriousl',
	  'sharpl',
	  'shortl',
	  'shyl',
	  'significantl',
	  'silentl',
	  'simpl',
	  'sleepil',
	  'slowl',
	  'smartl',
	  'smell',
	  'smoothl',
	  'softl',
	  'solemnl',
	  'sparkl',
	  'speedil',
	  'stealthil',
	  'sternl',
	  'stupidl',
	  'substantiall',
	  'successfull',
	  'suddenl',
	  'surprisingl',
	  'suspiciousl',
	  'swiftl',
	  'tenderl',
	  'tensel',
	  'thoughtfull',
	  'tightl',
	  'timel',
	  'truthfull',
	  'unexpectedl',
	  'unfortunatel',
	  'usuall',
	  'ver',
	  'victoriousl',
	  'violentl',
	  'vivaciousl',
	  'warml',
	  'waverl',
	  'weakl',
	  'wearil',
	  'weekl',
	  'wildl',
	  'wisel',
	  'worldl',
	  'wrinkl',
	  'yearl'
	];
	
	var weakens = [
	  'just',
	  'maybe',
	  'stuff',
	  'things'
	];
	
	var adverbRegex = new RegExp(
	  '\\b(' +
	  '(' + adverbs.join('|') + ')(y)' +
	  '|(' + weakens.join('|') + '))\\b', 'gi');
	var matcher = __webpack_require__(1424);
	
	module.exports = function (text) {
	  return matcher(adverbRegex, text, "adverbs");
	};


/***/ },
/* 1424 */
/***/ function(module, exports) {

	var matcher = function(regex, text, type) {
	  var results = [];
	
	  while (result = regex.exec(text)) {
	    results.push({index: result.index, offset: result[0].length});
	  }
	
	  return results;
	};
	
	module.exports = matcher;


/***/ },
/* 1425 */
/***/ function(module, exports) {

	function noop() {
	  return null;
	}
	noop.isRequired = noop;
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  elementType: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  range: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ },
/* 1426 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var animation = void 0;
	function isCssAnimationSupported() {
	    if (animation !== undefined) {
	        return animation;
	    }
	    var domPrefixes = 'Webkit Moz O ms Khtml'.split(' ');
	    var elm = document.createElement('div');
	    if (elm.style.animationName !== undefined) {
	        animation = true;
	    }
	    if (animation !== undefined) {
	        for (var i = 0; i < domPrefixes.length; i++) {
	            if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
	                animation = true;
	                break;
	            }
	        }
	    }
	    animation = animation || false;
	    return animation;
	}
	exports['default'] = isCssAnimationSupported;

/***/ },
/* 1427 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = isFlexSupported;
	function isFlexSupported() {
	    if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	        var documentElement = window.document.documentElement;
	
	        return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
	    }
	    return false;
	}

/***/ },
/* 1428 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = triggerEvent;
	function triggerEvent(el, type) {
	    if ('createEvent' in document) {
	        // modern browsers, IE9+
	        var e = document.createEvent('HTMLEvents');
	        e.initEvent(type, false, true);
	        el.dispatchEvent(e);
	    }
	}

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var Alert = function (_React$Component) {
	    (0, _inherits3['default'])(Alert, _React$Component);
	
	    function Alert(props) {
	        (0, _classCallCheck3['default'])(this, Alert);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Alert.__proto__ || Object.getPrototypeOf(Alert)).call(this, props));
	
	        _this.handleClose = function (e) {
	            e.preventDefault();
	            var dom = ReactDOM.findDOMNode(_this);
	            dom.style.height = dom.offsetHeight + 'px';
	            // Magic code
	            // 重复一次后才能正确设置 height
	            dom.style.height = dom.offsetHeight + 'px';
	            _this.setState({
	                closing: false
	            });
	            (_this.props.onClose || noop)(e);
	        };
	        _this.animationEnd = function () {
	            _this.setState({
	                closed: true,
	                closing: true
	            });
	        };
	        _this.state = {
	            closing: true,
	            closed: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Alert, [{
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props,
	                closable = _props.closable,
	                description = _props.description,
	                type = _props.type,
	                _props$prefixCls = _props.prefixCls,
	                prefixCls = _props$prefixCls === undefined ? 'ant-alert' : _props$prefixCls,
	                message = _props.message,
	                closeText = _props.closeText,
	                showIcon = _props.showIcon,
	                banner = _props.banner,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                style = _props.style;
	            // banner模式默认有 Icon
	
	            showIcon = banner && showIcon === undefined ? true : showIcon;
	            // banner模式默认为警告
	            type = banner && type === undefined ? 'warning' : type || 'info';
	            var iconType = '';
	            switch (type) {
	                case 'success':
	                    iconType = 'check-circle';
	                    break;
	                case 'info':
	                    iconType = 'info-circle';
	                    break;
	                case 'error':
	                    iconType = 'cross-circle';
	                    break;
	                case 'warning':
	                    iconType = 'exclamation-circle';
	                    break;
	                default:
	                    iconType = 'default';
	            }
	            // use outline icon in alert with description
	            if (!!description) {
	                iconType += '-o';
	            }
	            var alertCls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-close', !this.state.closing), (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-description', !!description), (0, _defineProperty3['default'])(_classNames, prefixCls + '-no-icon', !showIcon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-banner', !!banner), _classNames), className);
	            // closeable when closeText is assigned
	            if (closeText) {
	                closable = true;
	            }
	            var closeIcon = closable ? React.createElement(
	                'a',
	                { onClick: this.handleClose, className: prefixCls + '-close-icon' },
	                closeText || React.createElement(_icon2['default'], { type: 'cross' })
	            ) : null;
	            return this.state.closed ? null : React.createElement(
	                _rcAnimate2['default'],
	                { component: '', showProp: 'data-show', transitionName: prefixCls + '-slide-up', onEnd: this.animationEnd },
	                React.createElement(
	                    'div',
	                    { 'data-show': this.state.closing, className: alertCls, style: style },
	                    showIcon ? React.createElement(_icon2['default'], { className: prefixCls + '-icon', type: iconType }) : null,
	                    React.createElement(
	                        'span',
	                        { className: prefixCls + '-message' },
	                        message
	                    ),
	                    React.createElement(
	                        'span',
	                        { className: prefixCls + '-description' },
	                        description
	                    ),
	                    closeIcon
	                )
	            );
	        }
	    }]);
	    return Alert;
	}(React.Component);
	
	exports['default'] = Alert;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _affix = __webpack_require__(581);
	
	var _affix2 = _interopRequireDefault(_affix);
	
	var _getScroll = __webpack_require__(379);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _getRequestAnimationFrame = __webpack_require__(269);
	
	var _getRequestAnimationFrame2 = _interopRequireDefault(_getRequestAnimationFrame);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getDefaultTarget() {
	    return window;
	}
	function getOffsetTop(element) {
	    if (!element) {
	        return 0;
	    }
	    if (!element.getClientRects().length) {
	        return 0;
	    }
	    var rect = element.getBoundingClientRect();
	    if (rect.width || rect.height) {
	        var doc = element.ownerDocument;
	        var docElem = doc.documentElement;
	        return rect.top - docElem.clientTop;
	    }
	    return rect.top;
	}
	function easeInOutCubic(t, b, c, d) {
	    var cc = c - b;
	    t /= d / 2;
	    if (t < 1) {
	        return cc / 2 * t * t * t + b;
	    }
	    return cc / 2 * ((t -= 2) * t * t + 2) + b;
	}
	var reqAnimFrame = (0, _getRequestAnimationFrame2['default'])();
	var sharpMatcherRegx = /#([^#]+)$/;
	function scrollTo(href) {
	    var offsetTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var target = arguments[2];
	    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
	
	    var scrollTop = (0, _getScroll2['default'])(target(), true);
	    var sharpLinkMatch = sharpMatcherRegx.exec(href);
	    if (!sharpLinkMatch) {
	        return;
	    }
	    var targetElement = document.getElementById(sharpLinkMatch[1]);
	    if (!targetElement) {
	        return;
	    }
	    var eleOffsetTop = getOffsetTop(targetElement);
	    var targetScrollTop = scrollTop + eleOffsetTop - offsetTop;
	    var startTime = Date.now();
	    var frameFunc = function frameFunc() {
	        var timestamp = Date.now();
	        var time = timestamp - startTime;
	        window.scrollTo(window.pageXOffset, easeInOutCubic(time, scrollTop, targetScrollTop, 450));
	        if (time < 450) {
	            reqAnimFrame(frameFunc);
	        } else {
	            callback();
	        }
	    };
	    reqAnimFrame(frameFunc);
	    history.pushState(null, '', href);
	}
	
	var Anchor = function (_React$Component) {
	    (0, _inherits3['default'])(Anchor, _React$Component);
	
	    function Anchor(props) {
	        (0, _classCallCheck3['default'])(this, Anchor);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props));
	
	        _this.handleScroll = function () {
	            if (_this.animating) {
	                return;
	            }
	            var _this$props = _this.props,
	                offsetTop = _this$props.offsetTop,
	                bounds = _this$props.bounds;
	
	            _this.setState({
	                activeLink: _this.getCurrentAnchor(offsetTop, bounds)
	            });
	        };
	        _this.handleScrollTo = function (link) {
	            var _this$props2 = _this.props,
	                offsetTop = _this$props2.offsetTop,
	                _this$props2$target = _this$props2.target,
	                target = _this$props2$target === undefined ? getDefaultTarget : _this$props2$target;
	
	            _this.animating = true;
	            _this.setState({ activeLink: link });
	            scrollTo(link, offsetTop, target, function () {
	                _this.animating = false;
	            });
	        };
	        _this.updateInk = function () {
	            if (typeof document === 'undefined') {
	                return;
	            }
	            var prefixCls = _this.props.prefixCls;
	
	            var linkNode = ReactDOM.findDOMNode(_this).getElementsByClassName(prefixCls + '-link-title-active')[0];
	            if (linkNode) {
	                _this.inkNode.style.top = linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5 + 'px';
	            }
	        };
	        _this.saveInkNode = function (node) {
	            _this.inkNode = node;
	        };
	        _this.state = {
	            activeLink: null
	        };
	        _this.links = [];
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Anchor, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	                antAnchor: {
	                    registerLink: function registerLink(link) {
	                        if (!_this2.links.includes(link)) {
	                            _this2.links.push(link);
	                        }
	                    },
	                    unregisterLink: function unregisterLink(link) {
	                        var index = _this2.links.indexOf(link);
	                        if (index !== -1) {
	                            _this2.links.splice(index, 1);
	                        }
	                    },
	                    activeLink: this.state.activeLink,
	                    scrollTo: this.handleScrollTo
	                }
	            };
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var getTarget = this.props.target || getDefaultTarget;
	            this.scrollEvent = (0, _addEventListener2['default'])(getTarget(), 'scroll', this.handleScroll);
	            this.handleScroll();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.scrollEvent) {
	                this.scrollEvent.remove();
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.updateInk();
	        }
	    }, {
	        key: 'getCurrentAnchor',
	        value: function getCurrentAnchor() {
	            var offsetTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	            var bounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	
	            var activeLink = '';
	            if (typeof document === 'undefined') {
	                return activeLink;
	            }
	            var linkSections = [];
	            this.links.forEach(function (link) {
	                var sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
	                if (!sharpLinkMatch) {
	                    return;
	                }
	                var target = document.getElementById(sharpLinkMatch[1]);
	                if (target && getOffsetTop(target) < offsetTop + bounds) {
	                    var top = getOffsetTop(target);
	                    linkSections.push({
	                        link: link,
	                        top: top
	                    });
	                }
	            });
	            if (linkSections.length) {
	                var maxSection = linkSections.reduce(function (prev, curr) {
	                    return curr.top > prev.top ? curr : prev;
	                });
	                return maxSection.link;
	            }
	            return '';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                style = _props.style,
	                offsetTop = _props.offsetTop,
	                affix = _props.affix,
	                showInkInFixed = _props.showInkInFixed,
	                children = _props.children;
	            var activeLink = this.state.activeLink;
	
	            var inkClass = (0, _classnames2['default'])(prefixCls + '-ink-ball', {
	                visible: activeLink
	            });
	            var wrapperClass = (0, _classnames2['default'])(className, prefixCls + '-wrapper');
	            var anchorClass = (0, _classnames2['default'])(prefixCls, {
	                'fixed': !affix && !showInkInFixed
	            });
	            var wrapperStyle = (0, _extends3['default'])({ maxHeight: offsetTop ? 'calc(100vh - ' + offsetTop + 'px)' : '100vh' }, style);
	            var anchorContent = React.createElement(
	                'div',
	                { className: wrapperClass, style: wrapperStyle },
	                React.createElement(
	                    'div',
	                    { className: anchorClass },
	                    React.createElement(
	                        'div',
	                        { className: prefixCls + '-ink' },
	                        React.createElement('span', { className: inkClass, ref: this.saveInkNode })
	                    ),
	                    children
	                )
	            );
	            return !affix ? anchorContent : React.createElement(
	                _affix2['default'],
	                { offsetTop: offsetTop },
	                anchorContent
	            );
	        }
	    }]);
	    return Anchor;
	}(React.Component);
	
	exports['default'] = Anchor;
	
	Anchor.defaultProps = {
	    prefixCls: 'ant-anchor',
	    affix: true,
	    showInkInFixed: false
	};
	Anchor.childContextTypes = {
	    antAnchor: _propTypes2['default'].object
	};

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var AnchorLink = function (_React$Component) {
	    (0, _inherits3['default'])(AnchorLink, _React$Component);
	
	    function AnchorLink() {
	        (0, _classCallCheck3['default'])(this, AnchorLink);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (AnchorLink.__proto__ || Object.getPrototypeOf(AnchorLink)).apply(this, arguments));
	
	        _this.handleClick = function () {
	            _this.context.antAnchor.scrollTo(_this.props.href);
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(AnchorLink, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.context.antAnchor.registerLink(this.props.href);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.context.antAnchor.unregisterLink(this.props.href);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                href = _props.href,
	                title = _props.title,
	                children = _props.children;
	
	            var active = this.context.antAnchor.activeLink === href;
	            var wrapperClassName = (0, _classnames2['default'])(prefixCls + '-link', (0, _defineProperty3['default'])({}, prefixCls + '-link-active', active));
	            var titleClassName = (0, _classnames2['default'])(prefixCls + '-link-title', (0, _defineProperty3['default'])({}, prefixCls + '-link-title-active', active));
	            return React.createElement(
	                'div',
	                { className: wrapperClassName },
	                React.createElement(
	                    'a',
	                    { className: titleClassName, href: href, title: typeof title === 'string' ? title : '', onClick: this.handleClick },
	                    title
	                ),
	                children
	            );
	        }
	    }]);
	    return AnchorLink;
	}(React.Component);
	
	exports['default'] = AnchorLink;
	
	AnchorLink.defaultProps = {
	    prefixCls: 'ant-anchor',
	    href: '#'
	};
	AnchorLink.contextTypes = {
	    antAnchor: _propTypes2['default'].object
	};

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Anchor = __webpack_require__(1430);
	
	var _Anchor2 = _interopRequireDefault(_Anchor);
	
	var _AnchorLink = __webpack_require__(1431);
	
	var _AnchorLink2 = _interopRequireDefault(_AnchorLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Anchor2['default'].Link = _AnchorLink2['default'];
	exports['default'] = _Anchor2['default'];

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputElement = function (_React$Component) {
	    (0, _inherits3['default'])(InputElement, _React$Component);
	
	    function InputElement() {
	        (0, _classCallCheck3['default'])(this, InputElement);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).apply(this, arguments));
	
	        _this.focus = function () {
	            _this.ele.focus ? _this.ele.focus() : ReactDOM.findDOMNode(_this.ele).focus();
	        };
	        _this.blur = function () {
	            _this.ele.blur ? _this.ele.blur() : ReactDOM.findDOMNode(_this.ele).blur();
	        };
	        _this.saveRef = function (ele) {
	            _this.ele = ele;
	            var childRef = _this.props.children.ref;
	
	            if (typeof childRef === 'function') {
	                childRef(ele);
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(InputElement, [{
	        key: 'render',
	        value: function render() {
	            return React.cloneElement(this.props.children, (0, _extends3['default'])({}, this.props, { ref: this.saveRef }), null);
	        }
	    }]);
	    return InputElement;
	}(React.Component);
	
	exports['default'] = InputElement;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcSelect = __webpack_require__(1174);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _select = __webpack_require__(211);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _input = __webpack_require__(271);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _InputElement = __webpack_require__(1433);
	
	var _InputElement2 = _interopRequireDefault(_InputElement);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSelectOptionOrSelectOptGroup(child) {
	    return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
	}
	
	var AutoComplete = function (_React$Component) {
	    (0, _inherits3['default'])(AutoComplete, _React$Component);
	
	    function AutoComplete() {
	        (0, _classCallCheck3['default'])(this, AutoComplete);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (AutoComplete.__proto__ || Object.getPrototypeOf(AutoComplete)).apply(this, arguments));
	
	        _this.getInputElement = function () {
	            var children = _this.props.children;
	
	            var element = children && React.isValidElement(children) && children.type !== _rcSelect.Option ? React.Children.only(_this.props.children) : React.createElement(_input2['default'], null);
	            var elementProps = (0, _extends3['default'])({}, element.props);
	            // https://github.com/ant-design/ant-design/pull/7742
	            delete elementProps.children;
	            return React.createElement(
	                _InputElement2['default'],
	                elementProps,
	                element
	            );
	        };
	        _this.saveSelect = function (node) {
	            _this.select = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(AutoComplete, [{
	        key: 'focus',
	        value: function focus() {
	            this.select.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.select.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props,
	                size = _props.size,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                notFoundContent = _props.notFoundContent,
	                prefixCls = _props.prefixCls,
	                optionLabelProp = _props.optionLabelProp,
	                dataSource = _props.dataSource,
	                children = _props.children;
	
	            var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-search', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-auto-complete', true), _classNames));
	            var options = void 0;
	            var childArray = React.Children.toArray(children);
	            if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
	                options = children;
	            } else {
	                options = dataSource ? dataSource.map(function (item) {
	                    if (React.isValidElement(item)) {
	                        return item;
	                    }
	                    switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3['default'])(item)) {
	                        case 'string':
	                            return React.createElement(
	                                _rcSelect.Option,
	                                { key: item },
	                                item
	                            );
	                        case 'object':
	                            return React.createElement(
	                                _rcSelect.Option,
	                                { key: item.value },
	                                item.text
	                            );
	                        default:
	                            throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
	                    }
	                }) : [];
	            }
	            return React.createElement(
	                _select2['default'],
	                (0, _extends3['default'])({}, this.props, { className: cls, mode: 'combobox', optionLabelProp: optionLabelProp, getInputElement: this.getInputElement, notFoundContent: notFoundContent, ref: this.saveSelect }),
	                options
	            );
	        }
	    }]);
	    return AutoComplete;
	}(React.Component);
	
	exports['default'] = AutoComplete;
	
	AutoComplete.Option = _rcSelect.Option;
	AutoComplete.OptGroup = _rcSelect.OptGroup;
	AutoComplete.defaultProps = {
	    prefixCls: 'ant-select',
	    transitionName: 'slide-up',
	    optionLabelProp: 'children',
	    choiceTransitionName: 'zoom',
	    showSearch: false,
	    filterOption: false
	};

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Avatar = function (_React$Component) {
	    (0, _inherits3['default'])(Avatar, _React$Component);
	
	    function Avatar(props) {
	        (0, _classCallCheck3['default'])(this, Avatar);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call(this, props));
	
	        _this.setScale = function () {
	            var childrenNode = _this.avatarChildren;
	            if (childrenNode) {
	                var childrenWidth = childrenNode.offsetWidth;
	                var avatarWidth = ReactDOM.findDOMNode(_this).getBoundingClientRect().width;
	                // add 4px gap for each side to get better performance
	                if (avatarWidth - 8 < childrenWidth) {
	                    _this.setState({
	                        scale: (avatarWidth - 8) / childrenWidth
	                    });
	                } else {
	                    _this.setState({
	                        scale: 1
	                    });
	                }
	            }
	        };
	        _this.handleImgLoadError = function () {
	            return _this.setState({ isImgExist: false });
	        };
	        _this.state = {
	            scale: 1,
	            isImgExist: true
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Avatar, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.setScale();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate(prevProps, prevState) {
	            if (prevProps.children !== this.props.children || prevState.scale !== this.state.scale && this.state.scale === 1) {
	                this.setScale();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _classNames2,
	                _this2 = this;
	
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                shape = _a.shape,
	                size = _a.size,
	                src = _a.src,
	                icon = _a.icon,
	                className = _a.className,
	                others = __rest(_a, ["prefixCls", "shape", "size", "src", "icon", "className"]);
	            var sizeCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), _classNames));
	            var classString = (0, _classnames2['default'])(prefixCls, className, sizeCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-image', src), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-icon', icon), _classNames2));
	            var children = this.props.children;
	            if (src && this.state.isImgExist) {
	                children = React.createElement('img', { src: src, onError: this.handleImgLoadError });
	            } else if (icon) {
	                children = React.createElement(_icon2['default'], { type: icon });
	            } else {
	                var childrenNode = this.avatarChildren;
	                if (childrenNode || this.state.scale !== 1) {
	                    var childrenStyle = {
	                        msTransform: 'scale(' + this.state.scale + ')',
	                        WebkitTransform: 'scale(' + this.state.scale + ')',
	                        transform: 'scale(' + this.state.scale + ')',
	                        position: 'absolute',
	                        display: 'inline-block',
	                        left: 'calc(50% - ' + Math.round(childrenNode.offsetWidth / 2) + 'px)'
	                    };
	                    children = React.createElement(
	                        'span',
	                        { className: prefixCls + '-string', ref: function ref(span) {
	                                return _this2.avatarChildren = span;
	                            }, style: childrenStyle },
	                        children
	                    );
	                } else {
	                    children = React.createElement(
	                        'span',
	                        { className: prefixCls + '-string', ref: function ref(span) {
	                                return _this2.avatarChildren = span;
	                            } },
	                        children
	                    );
	                }
	            }
	            return React.createElement(
	                'span',
	                (0, _extends3['default'])({}, others, { className: classString }),
	                children
	            );
	        }
	    }]);
	    return Avatar;
	}(React.Component);
	
	exports['default'] = Avatar;
	
	Avatar.defaultProps = {
	    prefixCls: 'ant-avatar',
	    shape: 'circle',
	    size: 'default'
	};

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _getScroll = __webpack_require__(379);
	
	var _getScroll2 = _interopRequireDefault(_getScroll);
	
	var _getRequestAnimationFrame = __webpack_require__(269);
	
	var _getRequestAnimationFrame2 = _interopRequireDefault(_getRequestAnimationFrame);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var reqAnimFrame = (0, _getRequestAnimationFrame2['default'])();
	var easeInOutCubic = function easeInOutCubic(t, b, c, d) {
	    var cc = c - b;
	    t /= d / 2;
	    if (t < 1) {
	        return cc / 2 * t * t * t + b;
	    } else {
	        return cc / 2 * ((t -= 2) * t * t + 2) + b;
	    }
	};
	function noop() {}
	function getDefaultTarget() {
	    return window;
	}
	
	var BackTop = function (_React$Component) {
	    (0, _inherits3['default'])(BackTop, _React$Component);
	
	    function BackTop(props) {
	        (0, _classCallCheck3['default'])(this, BackTop);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (BackTop.__proto__ || Object.getPrototypeOf(BackTop)).call(this, props));
	
	        _this.getCurrentScrollTop = function () {
	            var getTarget = _this.props.target || getDefaultTarget;
	            var targetNode = getTarget();
	            if (targetNode === window) {
	                return window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;
	            }
	            return targetNode.scrollTop;
	        };
	        _this.scrollToTop = function (e) {
	            var scrollTop = _this.getCurrentScrollTop();
	            var startTime = Date.now();
	            var frameFunc = function frameFunc() {
	                var timestamp = Date.now();
	                var time = timestamp - startTime;
	                _this.setScrollTop(easeInOutCubic(time, scrollTop, 0, 450));
	                if (time < 450) {
	                    reqAnimFrame(frameFunc);
	                }
	            };
	            reqAnimFrame(frameFunc);
	            (_this.props.onClick || noop)(e);
	        };
	        _this.handleScroll = function () {
	            var _this$props = _this.props,
	                visibilityHeight = _this$props.visibilityHeight,
	                _this$props$target = _this$props.target,
	                target = _this$props$target === undefined ? getDefaultTarget : _this$props$target;
	
	            var scrollTop = (0, _getScroll2['default'])(target(), true);
	            _this.setState({
	                visible: scrollTop > visibilityHeight
	            });
	        };
	        _this.state = {
	            visible: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(BackTop, [{
	        key: 'setScrollTop',
	        value: function setScrollTop(value) {
	            var getTarget = this.props.target || getDefaultTarget;
	            var targetNode = getTarget();
	            if (targetNode === window) {
	                document.body.scrollTop = value;
	                document.documentElement.scrollTop = value;
	            } else {
	                targetNode.scrollTop = value;
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var getTarget = this.props.target || getDefaultTarget;
	            this.scrollEvent = (0, _addEventListener2['default'])(getTarget(), 'scroll', this.handleScroll);
	            this.handleScroll();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.scrollEvent) {
	                this.scrollEvent.remove();
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                _props$prefixCls = _props.prefixCls,
	                prefixCls = _props$prefixCls === undefined ? 'ant-back-top' : _props$prefixCls,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                children = _props.children;
	
	            var classString = (0, _classnames2['default'])(prefixCls, className);
	            var defaultElement = React.createElement(
	                'div',
	                { className: prefixCls + '-content' },
	                React.createElement('div', { className: prefixCls + '-icon' })
	            );
	            // fix https://fb.me/react-unknown-prop
	            var divProps = (0, _omit2['default'])(this.props, ['prefixCls', 'className', 'children', 'visibilityHeight', 'target']);
	            var backTopBtn = this.state.visible ? React.createElement(
	                'div',
	                (0, _extends3['default'])({}, divProps, { className: classString, onClick: this.scrollToTop }),
	                children || defaultElement
	            ) : null;
	            return React.createElement(
	                _rcAnimate2['default'],
	                { component: '', transitionName: 'fade' },
	                backTopBtn
	            );
	        }
	    }]);
	    return BackTop;
	}(React.Component);
	
	exports['default'] = BackTop;
	
	BackTop.defaultProps = {
	    visibilityHeight: 400
	};

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getNumberArray(num) {
	    return num ? num.toString().split('').reverse().map(function (i) {
	        return Number(i);
	    }) : [];
	}
	
	var ScrollNumber = function (_Component) {
	    (0, _inherits3['default'])(ScrollNumber, _Component);
	
	    function ScrollNumber(props) {
	        (0, _classCallCheck3['default'])(this, ScrollNumber);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollNumber.__proto__ || Object.getPrototypeOf(ScrollNumber)).call(this, props));
	
	        _this.state = {
	            animateStarted: true,
	            count: props.count
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(ScrollNumber, [{
	        key: 'getPositionByNum',
	        value: function getPositionByNum(num, i) {
	            if (this.state.animateStarted) {
	                return 10 + num;
	            }
	            var currentDigit = getNumberArray(this.state.count)[i];
	            var lastDigit = getNumberArray(this.lastCount)[i];
	            // 同方向则在同一侧切换数字
	            if (this.state.count > this.lastCount) {
	                if (currentDigit >= lastDigit) {
	                    return 10 + num;
	                }
	                return 20 + num;
	            }
	            if (currentDigit <= lastDigit) {
	                return 10 + num;
	            }
	            return num;
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            if ('count' in nextProps) {
	                if (this.state.count === nextProps.count) {
	                    return;
	                }
	                this.lastCount = this.state.count;
	                // 复原数字初始位置
	                this.setState({
	                    animateStarted: true
	                }, function () {
	                    // 等待数字位置复原完毕
	                    // 开始设置完整的数字
	                    setTimeout(function () {
	                        _this2.setState({
	                            animateStarted: false,
	                            count: nextProps.count
	                        }, function () {
	                            var onAnimated = _this2.props.onAnimated;
	                            if (onAnimated) {
	                                onAnimated();
	                            }
	                        });
	                    }, 5);
	                });
	            }
	        }
	    }, {
	        key: 'renderNumberList',
	        value: function renderNumberList(position) {
	            var childrenToReturn = [];
	            for (var i = 0; i < 30; i++) {
	                var currentClassName = position === i ? 'current' : '';
	                childrenToReturn.push(React.createElement(
	                    'p',
	                    { key: i.toString(), className: currentClassName },
	                    i % 10
	                ));
	            }
	            return childrenToReturn;
	        }
	    }, {
	        key: 'renderCurrentNumber',
	        value: function renderCurrentNumber(num, i) {
	            var position = this.getPositionByNum(num, i);
	            var removeTransition = this.state.animateStarted || getNumberArray(this.lastCount)[i] === undefined;
	            return (0, _react.createElement)('span', {
	                className: this.props.prefixCls + '-only',
	                style: {
	                    transition: removeTransition && 'none',
	                    msTransform: 'translateY(' + -position * 100 + '%)',
	                    WebkitTransform: 'translateY(' + -position * 100 + '%)',
	                    transform: 'translateY(' + -position * 100 + '%)'
	                },
	                key: i
	            }, this.renderNumberList(position));
	        }
	    }, {
	        key: 'renderNumberElement',
	        value: function renderNumberElement() {
	            var _this3 = this;
	
	            var state = this.state;
	            if (!state.count || isNaN(state.count)) {
	                return state.count;
	            }
	            return getNumberArray(state.count).map(function (num, i) {
	                return _this3.renderCurrentNumber(num, i);
	            }).reverse();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                className = _props.className,
	                style = _props.style,
	                title = _props.title,
	                _props$component = _props.component,
	                component = _props$component === undefined ? 'sup' : _props$component;
	            // fix https://fb.me/react-unknown-prop
	
	            var restProps = (0, _omit2['default'])(this.props, ['count', 'onAnimated', 'component', 'prefixCls']);
	            var newProps = (0, _extends3['default'])({}, restProps, { className: (0, _classnames2['default'])(prefixCls, className), title: title });
	            // allow specify the border
	            // mock border-color by box-shadow for compatible with old usage:
	            // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
	            if (style && style.borderColor) {
	                newProps.style.boxShadow = '0 0 0 1px ' + style.borderColor + ' inset';
	            }
	            return (0, _react.createElement)(component, newProps, this.renderNumberElement());
	        }
	    }]);
	    return ScrollNumber;
	}(_react.Component);
	
	exports['default'] = ScrollNumber;
	
	ScrollNumber.defaultProps = {
	    prefixCls: 'ant-scroll-number',
	    count: null,
	    onAnimated: function onAnimated() {}
	};

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _ScrollNumber = __webpack_require__(1437);
	
	var _ScrollNumber2 = _interopRequireDefault(_ScrollNumber);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Badge = function (_React$Component) {
	    (0, _inherits3['default'])(Badge, _React$Component);
	
	    function Badge() {
	        (0, _classCallCheck3['default'])(this, Badge);
	        return (0, _possibleConstructorReturn3['default'])(this, (Badge.__proto__ || Object.getPrototypeOf(Badge)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Badge, [{
	        key: 'render',
	        value: function render() {
	            var _classNames, _classNames2, _classNames3;
	
	            var _a = this.props,
	                count = _a.count,
	                showZero = _a.showZero,
	                prefixCls = _a.prefixCls,
	                scrollNumberPrefixCls = _a.scrollNumberPrefixCls,
	                overflowCount = _a.overflowCount,
	                className = _a.className,
	                style = _a.style,
	                children = _a.children,
	                dot = _a.dot,
	                status = _a.status,
	                text = _a.text,
	                offset = _a.offset,
	                restProps = __rest(_a, ["count", "showZero", "prefixCls", "scrollNumberPrefixCls", "overflowCount", "className", "style", "children", "dot", "status", "text", "offset"]);
	            var isDot = dot || status;
	            var displayCount = count > overflowCount ? overflowCount + '+' : count;
	            // dot mode don't need count
	            if (isDot) {
	                displayCount = '';
	            }
	            var isZero = displayCount === '0' || displayCount === 0;
	            var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
	            var hidden = (isEmpty || isZero && !showZero) && !isDot;
	            var statusCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-status-dot', !!status), (0, _defineProperty3['default'])(_classNames, prefixCls + '-status-' + status, !!status), _classNames));
	            var scrollNumberCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-dot', isDot), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-count', !isDot), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-multiple-words', count && count.toString && count.toString().length > 1), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-status-' + status, !!status), _classNames2));
	            var badgeCls = (0, _classnames2['default'])(className, prefixCls, (_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, prefixCls + '-status', !!status), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-not-a-wrapper', !children), _classNames3));
	            var styleWithOffset = offset ? (0, _extends3['default'])({ marginTop: offset[0], marginLeft: offset[1] }, style) : style;
	            // <Badge status="success" />
	            if (!children && status) {
	                return React.createElement(
	                    'span',
	                    { className: badgeCls, style: styleWithOffset },
	                    React.createElement('span', { className: statusCls }),
	                    React.createElement(
	                        'span',
	                        { className: prefixCls + '-status-text' },
	                        text
	                    )
	                );
	            }
	            var scrollNumber = hidden ? null : React.createElement(_ScrollNumber2['default'], { prefixCls: scrollNumberPrefixCls, 'data-show': !hidden, className: scrollNumberCls, count: displayCount, title: count, style: styleWithOffset });
	            var statusText = hidden || !text ? null : React.createElement(
	                'span',
	                { className: prefixCls + '-status-text' },
	                text
	            );
	            return React.createElement(
	                'span',
	                (0, _extends3['default'])({}, restProps, { className: badgeCls }),
	                children,
	                React.createElement(
	                    _rcAnimate2['default'],
	                    { component: '', showProp: 'data-show', transitionName: children ? prefixCls + '-zoom' : '', transitionAppear: true },
	                    scrollNumber
	                ),
	                statusText
	            );
	        }
	    }]);
	    return Badge;
	}(React.Component);
	
	exports['default'] = Badge;
	
	Badge.defaultProps = {
	    prefixCls: 'ant-badge',
	    scrollNumberPrefixCls: 'ant-scroll-number',
	    count: null,
	    showZero: false,
	    dot: false,
	    overflowCount: 99
	};
	Badge.propTypes = {
	    count: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	    showZero: _propTypes2['default'].bool,
	    dot: _propTypes2['default'].bool,
	    overflowCount: _propTypes2['default'].number
	};

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _BreadcrumbItem = __webpack_require__(582);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getBreadcrumbName(route, params) {
	    if (!route.breadcrumbName) {
	        return null;
	    }
	    var paramsKeys = Object.keys(params).join('|');
	    var name = route.breadcrumbName.replace(new RegExp(':(' + paramsKeys + ')', 'g'), function (replacement, key) {
	        return params[key] || replacement;
	    });
	    return name;
	}
	function defaultItemRender(route, params, routes, paths) {
	    var isLastItem = routes.indexOf(route) === routes.length - 1;
	    var name = getBreadcrumbName(route, params);
	    return isLastItem ? React.createElement(
	        'span',
	        null,
	        name
	    ) : React.createElement(
	        'a',
	        { href: '#/' + paths.join('/') },
	        name
	    );
	}
	
	var Breadcrumb = function (_React$Component) {
	    (0, _inherits3['default'])(Breadcrumb, _React$Component);
	
	    function Breadcrumb() {
	        (0, _classCallCheck3['default'])(this, Breadcrumb);
	        return (0, _possibleConstructorReturn3['default'])(this, (Breadcrumb.__proto__ || Object.getPrototypeOf(Breadcrumb)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Breadcrumb, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var props = this.props;
	            (0, _warning2['default'])(!('linkRender' in props || 'nameRender' in props), '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var crumbs = void 0;
	            var _props = this.props,
	                separator = _props.separator,
	                prefixCls = _props.prefixCls,
	                style = _props.style,
	                className = _props.className,
	                routes = _props.routes,
	                _props$params = _props.params,
	                params = _props$params === undefined ? {} : _props$params,
	                children = _props.children,
	                _props$itemRender = _props.itemRender,
	                itemRender = _props$itemRender === undefined ? defaultItemRender : _props$itemRender;
	
	            if (routes && routes.length > 0) {
	                var paths = [];
	                crumbs = routes.map(function (route) {
	                    route.path = route.path || '';
	                    var path = route.path.replace(/^\//, '');
	                    Object.keys(params).forEach(function (key) {
	                        path = path.replace(':' + key, params[key]);
	                    });
	                    if (path) {
	                        paths.push(path);
	                    }
	                    return React.createElement(
	                        _BreadcrumbItem2['default'],
	                        { separator: separator, key: route.breadcrumbName || path },
	                        itemRender(route, params, routes, paths)
	                    );
	                });
	            } else if (children) {
	                crumbs = React.Children.map(children, function (element, index) {
	                    if (!element) {
	                        return element;
	                    }
	                    (0, _warning2['default'])(element.type && element.type.__ANT_BREADCRUMB_ITEM, 'Breadcrumb only accepts Breadcrumb.Item as it\'s children');
	                    return (0, _react.cloneElement)(element, {
	                        separator: separator,
	                        key: index
	                    });
	                });
	            }
	            return React.createElement(
	                'div',
	                { className: (0, _classnames2['default'])(className, prefixCls), style: style },
	                crumbs
	            );
	        }
	    }]);
	    return Breadcrumb;
	}(React.Component);
	
	exports['default'] = Breadcrumb;
	
	Breadcrumb.defaultProps = {
	    prefixCls: 'ant-breadcrumb',
	    separator: '/'
	};
	Breadcrumb.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    separator: _propTypes2['default'].node,
	    routes: _propTypes2['default'].array,
	    params: _propTypes2['default'].object,
	    linkRender: _propTypes2['default'].func,
	    nameRender: _propTypes2['default'].func
	};

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Breadcrumb = __webpack_require__(1439);
	
	var _Breadcrumb2 = _interopRequireDefault(_Breadcrumb);
	
	var _BreadcrumbItem = __webpack_require__(582);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Breadcrumb2['default'].Item = _BreadcrumbItem2['default'];
	exports['default'] = _Breadcrumb2['default'];

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	    var _props$prefixCls = props.prefixCls,
	        prefixCls = _props$prefixCls === undefined ? 'ant-btn-group' : _props$prefixCls,
	        size = props.size,
	        className = props.className,
	        others = __rest(props, ["prefixCls", "size", "className"]);
	    // large => lg
	    // small => sm
	
	
	    var sizeCls = '';
	    switch (size) {
	        case 'large':
	            sizeCls = 'lg';
	            break;
	        case 'small':
	            sizeCls = 'sm';
	        default:
	            break;
	    }
	    var classes = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-' + sizeCls, sizeCls), className);
	    return React.createElement('div', (0, _extends3['default'])({}, others, { className: classes }));
	};
	exports['default'] = ButtonGroup;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	function isString(str) {
	    return typeof str === 'string';
	}
	// Insert one space between two chinese characters automatically.
	function insertSpace(child, needInserted) {
	    // Check the child if is undefined or null.
	    if (child == null) {
	        return;
	    }
	    var SPACE = needInserted ? ' ' : '';
	    // strictNullChecks oops.
	    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	        return React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
	    }
	    if (typeof child === 'string') {
	        if (isTwoCNChar(child)) {
	            child = child.split('').join(SPACE);
	        }
	        return React.createElement(
	            'span',
	            null,
	            child
	        );
	    }
	    return child;
	}
	
	var Button = function (_React$Component) {
	    (0, _inherits3['default'])(Button, _React$Component);
	
	    function Button(props) {
	        (0, _classCallCheck3['default'])(this, Button);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this, props));
	
	        _this.handleClick = function (e) {
	            // Add click effect
	            _this.setState({ clicked: true });
	            clearTimeout(_this.timeout);
	            _this.timeout = window.setTimeout(function () {
	                return _this.setState({ clicked: false });
	            }, 500);
	            var onClick = _this.props.onClick;
	            if (onClick) {
	                onClick(e);
	            }
	        };
	        _this.state = {
	            loading: props.loading,
	            clicked: false,
	            hasTwoCNChar: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Button, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            // Fix for HOC usage like <FormatMessage />
	            var buttonText = (0, _reactDom.findDOMNode)(this).innerText;
	            if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	                this.setState({
	                    hasTwoCNChar: true
	                });
	            }
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _this2 = this;
	
	            var currentLoading = this.props.loading;
	            var loading = nextProps.loading;
	            if (currentLoading) {
	                clearTimeout(this.delayTimeout);
	            }
	            if (typeof loading !== 'boolean' && loading && loading.delay) {
	                this.delayTimeout = window.setTimeout(function () {
	                    return _this2.setState({ loading: loading });
	                }, loading.delay);
	            } else {
	                this.setState({ loading: loading });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.timeout) {
	                clearTimeout(this.timeout);
	            }
	            if (this.delayTimeout) {
	                clearTimeout(this.delayTimeout);
	            }
	        }
	    }, {
	        key: 'isNeedInserted',
	        value: function isNeedInserted() {
	            var _props = this.props,
	                loading = _props.loading,
	                icon = _props.icon,
	                children = _props.children;
	
	            var iconType = loading ? 'loading' : icon;
	            return React.Children.count(children) === 1 && (!iconType || iconType === 'loading');
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this3 = this;
	
	            var _a = this.props,
	                type = _a.type,
	                shape = _a.shape,
	                size = _a.size,
	                className = _a.className,
	                htmlType = _a.htmlType,
	                children = _a.children,
	                icon = _a.icon,
	                prefixCls = _a.prefixCls,
	                ghost = _a.ghost,
	                others = __rest(_a, ["type", "shape", "size", "className", "htmlType", "children", "icon", "prefixCls", "ghost"]);var _state = this.state,
	                loading = _state.loading,
	                clicked = _state.clicked,
	                hasTwoCNChar = _state.hasTwoCNChar;
	            // large => lg
	            // small => sm
	
	            var sizeCls = '';
	            switch (size) {
	                case 'large':
	                    sizeCls = 'lg';
	                    break;
	                case 'small':
	                    sizeCls = 'sm';
	                default:
	                    break;
	            }
	            var ComponentProp = others.href ? 'a' : 'button';
	            var classes = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + type, type), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + shape, shape), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-icon-only', !children && icon), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-clicked', clicked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-background-ghost', ghost), (0, _defineProperty3['default'])(_classNames, prefixCls + '-two-chinese-chars', hasTwoCNChar), _classNames));
	            var iconType = loading ? 'loading' : icon;
	            var iconNode = iconType ? React.createElement(_icon2['default'], { type: iconType }) : null;
	            var kids = children || children === 0 ? React.Children.map(children, function (child) {
	                return insertSpace(child, _this3.isNeedInserted());
	            }) : null;
	            return React.createElement(
	                ComponentProp,
	                (0, _extends3['default'])({}, (0, _omit2['default'])(others, ['loading']), { type: others.href ? undefined : htmlType || 'button', className: classes, onClick: this.handleClick }),
	                iconNode,
	                kids
	            );
	        }
	    }]);
	    return Button;
	}(React.Component);
	
	exports['default'] = Button;
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	    prefixCls: 'ant-btn',
	    loading: false,
	    ghost: false
	};
	Button.propTypes = {
	    type: _propTypes2['default'].string,
	    shape: _propTypes2['default'].oneOf(['circle', 'circle-outline']),
	    size: _propTypes2['default'].oneOf(['large', 'default', 'small']),
	    htmlType: _propTypes2['default'].oneOf(['submit', 'button', 'reset']),
	    onClick: _propTypes2['default'].func,
	    loading: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	    className: _propTypes2['default'].string,
	    icon: _propTypes2['default'].string
	};

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Constants = __webpack_require__(583);
	
	var _select = __webpack_require__(211);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _radio = __webpack_require__(272);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Option = _select2['default'].Option;
	
	var Header = function (_React$Component) {
	    (0, _inherits3['default'])(Header, _React$Component);
	
	    function Header() {
	        (0, _classCallCheck3['default'])(this, Header);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
	
	        _this.onYearChange = function (year) {
	            var newValue = _this.props.value.clone();
	            newValue.year(parseInt(year, 10));
	            var onValueChange = _this.props.onValueChange;
	            if (onValueChange) {
	                onValueChange(newValue);
	            }
	        };
	        _this.onMonthChange = function (month) {
	            var newValue = _this.props.value.clone();
	            newValue.month(parseInt(month, 10));
	            var onValueChange = _this.props.onValueChange;
	            if (onValueChange) {
	                onValueChange(newValue);
	            }
	        };
	        _this.onTypeChange = function (e) {
	            var onTypeChange = _this.props.onTypeChange;
	            if (onTypeChange) {
	                onTypeChange(e.target.value);
	            }
	        };
	        _this.getCalenderHeaderNode = function (node) {
	            _this.calenderHeaderNode = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Header, [{
	        key: 'getYearSelectElement',
	        value: function getYearSelectElement(year) {
	            var _this2 = this;
	
	            var _props = this.props,
	                yearSelectOffset = _props.yearSelectOffset,
	                yearSelectTotal = _props.yearSelectTotal,
	                locale = _props.locale,
	                prefixCls = _props.prefixCls,
	                fullscreen = _props.fullscreen;
	
	            var start = year - yearSelectOffset;
	            var end = start + yearSelectTotal;
	            var suffix = locale.year === '年' ? '年' : '';
	            var options = [];
	            for (var index = start; index < end; index++) {
	                options.push(React.createElement(
	                    Option,
	                    { key: '' + index },
	                    index + suffix
	                ));
	            }
	            return React.createElement(
	                _select2['default'],
	                { size: fullscreen ? 'default' : 'small', dropdownMatchSelectWidth: false, className: prefixCls + '-year-select', onChange: this.onYearChange, value: String(year), getPopupContainer: function getPopupContainer() {
	                        return _this2.calenderHeaderNode;
	                    } },
	                options
	            );
	        }
	    }, {
	        key: 'getMonthsLocale',
	        value: function getMonthsLocale(value) {
	            var current = value.clone();
	            var localeData = value.localeData();
	            var months = [];
	            for (var i = 0; i < 12; i++) {
	                current.month(i);
	                months.push(localeData.monthsShort(current));
	            }
	            return months;
	        }
	    }, {
	        key: 'getMonthSelectElement',
	        value: function getMonthSelectElement(month, months) {
	            var _this3 = this;
	
	            var props = this.props;
	            var prefixCls = props.prefixCls,
	                fullscreen = props.fullscreen;
	
	            var options = [];
	            for (var index = 0; index < 12; index++) {
	                options.push(React.createElement(
	                    Option,
	                    { key: '' + index },
	                    months[index]
	                ));
	            }
	            return React.createElement(
	                _select2['default'],
	                { size: fullscreen ? 'default' : 'small', dropdownMatchSelectWidth: false, className: prefixCls + '-month-select', value: String(month), onChange: this.onMonthChange, getPopupContainer: function getPopupContainer() {
	                        return _this3.calenderHeaderNode;
	                    } },
	                options
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                type = _props2.type,
	                value = _props2.value,
	                prefixCls = _props2.prefixCls,
	                locale = _props2.locale,
	                fullscreen = _props2.fullscreen;
	
	            var yearSelect = this.getYearSelectElement(value.year());
	            var monthSelect = type === 'date' ? this.getMonthSelectElement(value.month(), this.getMonthsLocale(value)) : null;
	            var size = fullscreen ? 'default' : 'small';
	            var typeSwitch = React.createElement(
	                _radio.Group,
	                { onChange: this.onTypeChange, value: type, size: size },
	                React.createElement(
	                    _radio.Button,
	                    { value: 'date' },
	                    locale.month
	                ),
	                React.createElement(
	                    _radio.Button,
	                    { value: 'month' },
	                    locale.year
	                )
	            );
	            return React.createElement(
	                'div',
	                { className: prefixCls + '-header', ref: this.getCalenderHeaderNode },
	                yearSelect,
	                monthSelect,
	                typeSwitch
	            );
	        }
	    }]);
	    return Header;
	}(React.Component);
	
	exports['default'] = Header;
	
	Header.defaultProps = {
	    prefixCls: _Constants.PREFIX_CLS + '-header',
	    yearSelectOffset: 10,
	    yearSelectTotal: 20
	};

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(_moment);
	
	var _FullCalendar = __webpack_require__(2492);
	
	var _FullCalendar2 = _interopRequireDefault(_FullCalendar);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _Constants = __webpack_require__(583);
	
	var _Header = __webpack_require__(1443);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _callMoment = __webpack_require__(378);
	
	var _callMoment2 = _interopRequireDefault(_callMoment);
	
	var _en_US = __webpack_require__(584);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {
	    return null;
	}
	function zerofixed(v) {
	    if (v < 10) {
	        return '0' + v;
	    }
	    return '' + v;
	}
	
	var Calendar = function (_React$Component) {
	    (0, _inherits3['default'])(Calendar, _React$Component);
	
	    function Calendar(props) {
	        (0, _classCallCheck3['default'])(this, Calendar);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));
	
	        _this.monthCellRender = function (value) {
	            var _this$props = _this.props,
	                prefixCls = _this$props.prefixCls,
	                _this$props$monthCell = _this$props.monthCellRender,
	                monthCellRender = _this$props$monthCell === undefined ? noop : _this$props$monthCell;
	
	            return React.createElement(
	                'div',
	                { className: prefixCls + '-month' },
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-value' },
	                    value.localeData().monthsShort(value)
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-content' },
	                    monthCellRender(value)
	                )
	            );
	        };
	        _this.dateCellRender = function (value) {
	            var _this$props2 = _this.props,
	                prefixCls = _this$props2.prefixCls,
	                _this$props2$dateCell = _this$props2.dateCellRender,
	                dateCellRender = _this$props2$dateCell === undefined ? noop : _this$props2$dateCell;
	
	            return React.createElement(
	                'div',
	                { className: prefixCls + '-date' },
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-value' },
	                    zerofixed(value.date())
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-content' },
	                    dateCellRender(value)
	                )
	            );
	        };
	        _this.setValue = function (value, way) {
	            if (!('value' in _this.props)) {
	                _this.setState({ value: value });
	            }
	            if (way === 'select') {
	                if (_this.props.onSelect) {
	                    _this.props.onSelect(value);
	                }
	            } else if (way === 'changePanel') {
	                _this.onPanelChange(value, _this.state.mode);
	            }
	        };
	        _this.setType = function (type) {
	            var mode = type === 'date' ? 'month' : 'year';
	            if (_this.state.mode !== mode) {
	                _this.setState({ mode: mode });
	                _this.onPanelChange(_this.state.value, mode);
	            }
	        };
	        _this.onHeaderValueChange = function (value) {
	            _this.setValue(value, 'changePanel');
	        };
	        _this.onHeaderTypeChange = function (type) {
	            _this.setType(type);
	        };
	        _this.onSelect = function (value) {
	            _this.setValue(value, 'select');
	        };
	        _this.renderCalendar = function (locale, localeCode) {
	            var state = _this.state,
	                props = _this.props;
	            var value = state.value,
	                mode = state.mode;
	
	            if (value && localeCode) {
	                value.locale(localeCode);
	            }
	            var prefixCls = props.prefixCls,
	                style = props.style,
	                className = props.className,
	                fullscreen = props.fullscreen,
	                dateFullCellRender = props.dateFullCellRender,
	                monthFullCellRender = props.monthFullCellRender;
	
	            var type = mode === 'year' ? 'month' : 'date';
	            var cls = className || '';
	            if (fullscreen) {
	                cls += ' ' + prefixCls + '-fullscreen';
	            }
	            var monthCellRender = monthFullCellRender || _this.monthCellRender;
	            var dateCellRender = dateFullCellRender || _this.dateCellRender;
	            return React.createElement(
	                'div',
	                { className: cls, style: style },
	                React.createElement(_Header2['default'], { fullscreen: fullscreen, type: type, value: value, locale: locale.lang, prefixCls: prefixCls, onTypeChange: _this.onHeaderTypeChange, onValueChange: _this.onHeaderValueChange }),
	                React.createElement(_FullCalendar2['default'], (0, _extends3['default'])({}, props, { Select: noop, locale: locale.lang, type: type, prefixCls: prefixCls, showHeader: false, value: value, monthCellRender: monthCellRender, dateCellRender: dateCellRender, onSelect: _this.onSelect }))
	            );
	        };
	        var value = props.value || props.defaultValue || (0, _callMoment2['default'])(moment);
	        if (!moment.isMoment(value)) {
	            throw new Error('The value/defaultValue of Calendar must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/calendar-value');
	        }
	        _this.state = {
	            value: value,
	            mode: props.mode
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Calendar, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                this.setState({
	                    value: nextProps.value
	                });
	            }
	        }
	    }, {
	        key: 'onPanelChange',
	        value: function onPanelChange(value, mode) {
	            var onPanelChange = this.props.onPanelChange;
	
	            if (onPanelChange) {
	                onPanelChange(value, mode);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Calendar', defaultLocale: _en_US2['default'] },
	                this.renderCalendar
	            );
	        }
	    }]);
	    return Calendar;
	}(React.Component);
	
	exports['default'] = Calendar;
	
	Calendar.defaultProps = {
	    locale: {},
	    fullscreen: true,
	    prefixCls: _Constants.PREFIX_CLS,
	    mode: 'month',
	    onSelect: noop,
	    onPanelChange: noop
	};
	Calendar.propTypes = {
	    monthCellRender: _propTypes2['default'].func,
	    dateCellRender: _propTypes2['default'].func,
	    monthFullCellRender: _propTypes2['default'].func,
	    dateFullCellRender: _propTypes2['default'].func,
	    fullscreen: _propTypes2['default'].bool,
	    locale: _propTypes2['default'].object,
	    prefixCls: _propTypes2['default'].string,
	    className: _propTypes2['default'].string,
	    style: _propTypes2['default'].object,
	    onPanelChange: _propTypes2['default'].func,
	    value: _propTypes2['default'].object,
	    onSelect: _propTypes2['default'].func
	};

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ca_ES = __webpack_require__(586);
	
	var _ca_ES2 = _interopRequireDefault(_ca_ES);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _ca_ES2['default'];

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fr_FR = __webpack_require__(587);
	
	var _fr_FR2 = _interopRequireDefault(_fr_FR);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _fr_FR2['default'];

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _it_IT = __webpack_require__(588);
	
	var _it_IT2 = _interopRequireDefault(_it_IT);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _it_IT2['default'];

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	exports['default'] = function (props) {
	    var _props$prefixCls = props.prefixCls,
	        prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
	        className = props.className,
	        others = __rest(props, ["prefixCls", "className"]);
	
	    var classString = (0, _classnames2['default'])(prefixCls + '-grid', className);
	    return React.createElement('div', (0, _extends3['default'])({}, others, { className: classString }));
	};

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	exports['default'] = function (props) {
	    var _props$prefixCls = props.prefixCls,
	        prefixCls = _props$prefixCls === undefined ? 'ant-card' : _props$prefixCls,
	        className = props.className,
	        avatar = props.avatar,
	        title = props.title,
	        description = props.description,
	        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	    var classString = (0, _classnames2['default'])(prefixCls + '-meta', className);
	    var avatarDom = avatar ? React.createElement(
	        'div',
	        { className: prefixCls + '-meta-avatar' },
	        avatar
	    ) : null;
	    var titleDom = title ? React.createElement(
	        'div',
	        { className: prefixCls + '-meta-title' },
	        title
	    ) : null;
	    var descriptionDom = description ? React.createElement(
	        'div',
	        { className: prefixCls + '-meta-description' },
	        description
	    ) : null;
	    var MetaDetail = titleDom || descriptionDom ? React.createElement(
	        'div',
	        { className: prefixCls + '-meta-detail' },
	        titleDom,
	        descriptionDom
	    ) : null;
	    return React.createElement(
	        'div',
	        (0, _extends3['default'])({}, others, { className: classString }),
	        avatarDom,
	        MetaDetail
	    );
	};

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _Grid = __webpack_require__(1448);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Meta = __webpack_require__(1449);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _tabs = __webpack_require__(598);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _throttleByAnimationFrame = __webpack_require__(580);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
	    var c = arguments.length,
	        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	        d;
	    if ((typeof Reflect === "undefined" ? "undefined" : (0, _typeof3["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    }return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Card = function (_React$Component) {
	    (0, _inherits3["default"])(Card, _React$Component);
	
	    function Card() {
	        (0, _classCallCheck3["default"])(this, Card);
	
	        var _this = (0, _possibleConstructorReturn3["default"])(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));
	
	        _this.state = {
	            widerPadding: false
	        };
	        _this.onTabChange = function (key) {
	            if (_this.props.onTabChange) {
	                _this.props.onTabChange(key);
	            }
	        };
	        _this.saveRef = function (node) {
	            _this.container = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3["default"])(Card, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            this.updateWiderPadding();
	            this.resizeEvent = (0, _addEventListener2["default"])(window, 'resize', this.updateWiderPadding);
	            if ('noHovering' in this.props) {
	                (0, _warning2["default"])(!this.props.noHovering, '`noHovering` of Card is deperated, you can remove it safely or use `hoverable` instead.');
	                (0, _warning2["default"])(!!this.props.noHovering, '`noHovering={false}` of Card is deperated, use `hoverable` instead.');
	            }
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            if (this.resizeEvent) {
	                this.resizeEvent.remove();
	            }
	            this.updateWiderPadding.cancel();
	        }
	    }, {
	        key: "updateWiderPadding",
	        value: function updateWiderPadding() {
	            var _this2 = this;
	
	            if (!this.container) {
	                return;
	            }
	            // 936 is a magic card width pixer number indicated by designer
	            var WIDTH_BOUDARY_PX = 936;
	            if (this.container.offsetWidth >= WIDTH_BOUDARY_PX && !this.state.widerPadding) {
	                this.setState({ widerPadding: true }, function () {
	                    _this2.updateWiderPaddingCalled = true; // first render without css transition
	                });
	            }
	            if (this.container.offsetWidth < WIDTH_BOUDARY_PX && this.state.widerPadding) {
	                this.setState({ widerPadding: false }, function () {
	                    _this2.updateWiderPaddingCalled = true; // first render without css transition
	                });
	            }
	        }
	    }, {
	        key: "isContainGrid",
	        value: function isContainGrid() {
	            var containGrid = void 0;
	            React.Children.forEach(this.props.children, function (element) {
	                if (element && element.type && element.type === _Grid2["default"]) {
	                    containGrid = true;
	                }
	            });
	            return containGrid;
	        }
	    }, {
	        key: "getAction",
	        value: function getAction(actions) {
	            if (!actions || !actions.length) {
	                return null;
	            }
	            var actionList = actions.map(function (action, index) {
	                return React.createElement(
	                    "li",
	                    { style: { width: 100 / actions.length + "%" }, key: "action-" + index },
	                    React.createElement(
	                        "span",
	                        null,
	                        action
	                    )
	                );
	            });
	            return actionList;
	        }
	        // For 2.x compatible
	
	    }, {
	        key: "getCompatibleHoverable",
	        value: function getCompatibleHoverable() {
	            var _props = this.props,
	                noHovering = _props.noHovering,
	                hoverable = _props.hoverable;
	
	            if ('noHovering' in this.props) {
	                return !noHovering || hoverable;
	            }
	            return !!hoverable;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                _a$prefixCls = _a.prefixCls,
	                prefixCls = _a$prefixCls === undefined ? 'ant-card' : _a$prefixCls,
	                className = _a.className,
	                extra = _a.extra,
	                bodyStyle = _a.bodyStyle,
	                noHovering = _a.noHovering,
	                hoverable = _a.hoverable,
	                title = _a.title,
	                loading = _a.loading,
	                _a$bordered = _a.bordered,
	                bordered = _a$bordered === undefined ? true : _a$bordered,
	                type = _a.type,
	                cover = _a.cover,
	                actions = _a.actions,
	                tabList = _a.tabList,
	                children = _a.children,
	                others = __rest(_a, ["prefixCls", "className", "extra", "bodyStyle", "noHovering", "hoverable", "title", "loading", "bordered", "type", "cover", "actions", "tabList", "children"]);
	            var classString = (0, _classnames2["default"])(prefixCls, className, (_classNames = {}, (0, _defineProperty3["default"])(_classNames, prefixCls + "-loading", loading), (0, _defineProperty3["default"])(_classNames, prefixCls + "-bordered", bordered), (0, _defineProperty3["default"])(_classNames, prefixCls + "-hoverable", this.getCompatibleHoverable()), (0, _defineProperty3["default"])(_classNames, prefixCls + "-wider-padding", this.state.widerPadding), (0, _defineProperty3["default"])(_classNames, prefixCls + "-padding-transition", this.updateWiderPaddingCalled), (0, _defineProperty3["default"])(_classNames, prefixCls + "-contain-grid", this.isContainGrid()), (0, _defineProperty3["default"])(_classNames, prefixCls + "-contain-tabs", tabList && tabList.length), (0, _defineProperty3["default"])(_classNames, prefixCls + "-type-" + type, !!type), _classNames));
	            var loadingBlock = React.createElement(
	                "div",
	                { className: prefixCls + "-loading-content" },
	                React.createElement("p", { className: prefixCls + "-loading-block", style: { width: '94%' } }),
	                React.createElement(
	                    "p",
	                    null,
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '28%' } }),
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '62%' } })
	                ),
	                React.createElement(
	                    "p",
	                    null,
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '22%' } }),
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '66%' } })
	                ),
	                React.createElement(
	                    "p",
	                    null,
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '56%' } }),
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '39%' } })
	                ),
	                React.createElement(
	                    "p",
	                    null,
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '21%' } }),
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '15%' } }),
	                    React.createElement("span", { className: prefixCls + "-loading-block", style: { width: '40%' } })
	                )
	            );
	            var head = void 0;
	            var tabs = tabList && tabList.length ? React.createElement(
	                _tabs2["default"],
	                { className: prefixCls + "-head-tabs", size: "large", onChange: this.onTabChange },
	                tabList.map(function (item) {
	                    return React.createElement(_tabs2["default"].TabPane, { tab: item.tab, key: item.key });
	                })
	            ) : null;
	            if (title || extra || tabs) {
	                head = React.createElement(
	                    "div",
	                    { className: prefixCls + "-head" },
	                    React.createElement(
	                        "div",
	                        { className: prefixCls + "-head-wrapper" },
	                        title && React.createElement(
	                            "div",
	                            { className: prefixCls + "-head-title" },
	                            title
	                        ),
	                        extra && React.createElement(
	                            "div",
	                            { className: prefixCls + "-extra" },
	                            extra
	                        )
	                    ),
	                    tabs
	                );
	            }
	            var coverDom = cover ? React.createElement(
	                "div",
	                { className: prefixCls + "-cover" },
	                cover
	            ) : null;
	            var body = React.createElement(
	                "div",
	                { className: prefixCls + "-body", style: bodyStyle },
	                loading ? loadingBlock : React.createElement(
	                    "div",
	                    null,
	                    children
	                )
	            );
	            var actionDom = actions && actions.length ? React.createElement(
	                "ul",
	                { className: prefixCls + "-actions" },
	                this.getAction(actions)
	            ) : null;
	            var divProps = (0, _omit2["default"])(others, ['onTabChange']);
	            return React.createElement(
	                "div",
	                (0, _extends3["default"])({}, divProps, { className: classString, ref: this.saveRef }),
	                head,
	                coverDom,
	                children ? body : null,
	                actionDom
	            );
	        }
	    }]);
	    return Card;
	}(React.Component);
	
	exports["default"] = Card;
	
	Card.Grid = _Grid2["default"];
	Card.Meta = _Meta2["default"];
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Card.prototype, "updateWiderPadding", null);

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _lodash = __webpack_require__(307);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	if (typeof window !== 'undefined') {
	    var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	        return {
	            media: mediaQuery,
	            matches: false,
	            addListener: function addListener() {},
	            removeListener: function removeListener() {}
	        };
	    };
	    window.matchMedia = window.matchMedia || matchMediaPolyfill;
	}
	// Use require over import (will be lifted up)
	// make sure matchMedia polyfill run before require('react-slick')
	// Fix https://github.com/ant-design/ant-design/issues/6560
	// Fix https://github.com/ant-design/ant-design/issues/3308
	var SlickCarousel = __webpack_require__(2865)['default'];
	
	var Carousel = function (_React$Component) {
	    (0, _inherits3['default'])(Carousel, _React$Component);
	
	    function Carousel(props) {
	        (0, _classCallCheck3['default'])(this, Carousel);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, props));
	
	        _this.onWindowResized = function () {
	            // Fix https://github.com/ant-design/ant-design/issues/2550
	            var autoplay = _this.props.autoplay;
	
	            if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
	                _this.slick.innerSlider.autoPlay();
	            }
	        };
	        _this.saveSlick = function (node) {
	            _this.slick = node;
	        };
	        _this.onWindowResized = (0, _lodash2['default'])(_this.onWindowResized, 500, {
	            leading: false
	        });
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Carousel, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var autoplay = this.props.autoplay;
	
	            if (autoplay) {
	                window.addEventListener('resize', this.onWindowResized);
	            }
	            // https://github.com/ant-design/ant-design/issues/7191
	            this.innerSlider = this.slick && this.slick.innerSlider;
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            var autoplay = this.props.autoplay;
	
	            if (autoplay) {
	                window.removeEventListener('resize', this.onWindowResized);
	                this.onWindowResized.cancel();
	            }
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            this.slick.slickNext();
	        }
	    }, {
	        key: 'prev',
	        value: function prev() {
	            this.slick.slickPrev();
	        }
	    }, {
	        key: 'goTo',
	        value: function goTo(slide) {
	            this.slick.slickGoTo(slide);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = (0, _extends3['default'])({}, this.props);
	            if (props.effect === 'fade') {
	                props.fade = true;
	            }
	            var className = props.prefixCls;
	            if (props.vertical) {
	                className = className + ' ' + className + '-vertical';
	            }
	            return React.createElement(
	                'div',
	                { className: className },
	                React.createElement(SlickCarousel, (0, _extends3['default'])({ ref: this.saveSlick }, props))
	            );
	        }
	    }]);
	    return Carousel;
	}(React.Component);
	
	exports['default'] = Carousel;
	
	Carousel.defaultProps = {
	    dots: true,
	    arrows: false,
	    prefixCls: 'ant-carousel',
	    draggable: false
	};

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcCascader = __webpack_require__(2507);
	
	var _rcCascader2 = _interopRequireDefault(_rcCascader);
	
	var _arrayTreeFilter = __webpack_require__(1539);
	
	var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _input = __webpack_require__(271);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	function highlightKeyword(str, keyword, prefixCls) {
	    return str.split(keyword).map(function (node, index) {
	        return index === 0 ? node : [React.createElement(
	            'span',
	            { className: prefixCls + '-menu-item-keyword', key: 'seperator' },
	            keyword
	        ), node];
	    });
	}
	function defaultFilterOption(inputValue, path) {
	    return path.some(function (option) {
	        return option.label.indexOf(inputValue) > -1;
	    });
	}
	function defaultRenderFilteredOption(inputValue, path, prefixCls) {
	    return path.map(function (_ref, index) {
	        var label = _ref.label;
	
	        var node = label.indexOf(inputValue) > -1 ? highlightKeyword(label, inputValue, prefixCls) : label;
	        return index === 0 ? node : [' / ', node];
	    });
	}
	function defaultSortFilteredOption(a, b, inputValue) {
	    function callback(elem) {
	        return elem.label.indexOf(inputValue) > -1;
	    }
	    return a.findIndex(callback) - b.findIndex(callback);
	}
	var defaultDisplayRender = function defaultDisplayRender(label) {
	    return label.join(' / ');
	};
	
	var Cascader = function (_React$Component) {
	    (0, _inherits3['default'])(Cascader, _React$Component);
	
	    function Cascader(props) {
	        (0, _classCallCheck3['default'])(this, Cascader);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).call(this, props));
	
	        _this.handleChange = function (value, selectedOptions) {
	            _this.setState({ inputValue: '' });
	            if (selectedOptions[0].__IS_FILTERED_OPTION) {
	                var unwrappedValue = value[0];
	                var unwrappedSelectedOptions = selectedOptions[0].path;
	                _this.setValue(unwrappedValue, unwrappedSelectedOptions);
	                return;
	            }
	            _this.setValue(value, selectedOptions);
	        };
	        _this.handlePopupVisibleChange = function (popupVisible) {
	            if (!('popupVisible' in _this.props)) {
	                _this.setState({
	                    popupVisible: popupVisible,
	                    inputFocused: popupVisible,
	                    inputValue: popupVisible ? _this.state.inputValue : ''
	                });
	            }
	            var onPopupVisibleChange = _this.props.onPopupVisibleChange;
	            if (onPopupVisibleChange) {
	                onPopupVisibleChange(popupVisible);
	            }
	        };
	        _this.handleInputBlur = function () {
	            _this.setState({
	                inputFocused: false
	            });
	        };
	        _this.handleInputClick = function (e) {
	            var _this$state = _this.state,
	                inputFocused = _this$state.inputFocused,
	                popupVisible = _this$state.popupVisible;
	            // Prevent `Trigger` behaviour.
	
	            if (inputFocused || popupVisible) {
	                e.stopPropagation();
	                e.nativeEvent.stopImmediatePropagation();
	            }
	        };
	        _this.handleKeyDown = function (e) {
	            if (e.keyCode === _KeyCode2['default'].BACKSPACE) {
	                e.stopPropagation();
	            }
	        };
	        _this.handleInputChange = function (e) {
	            var inputValue = e.target.value;
	            _this.setState({ inputValue: inputValue });
	        };
	        _this.setValue = function (value) {
	            var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	            if (!('value' in _this.props)) {
	                _this.setState({ value: value });
	            }
	            var onChange = _this.props.onChange;
	            if (onChange) {
	                onChange(value, selectedOptions);
	            }
	        };
	        _this.clearSelection = function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            if (!_this.state.inputValue) {
	                _this.setValue([]);
	                _this.handlePopupVisibleChange(false);
	            } else {
	                _this.setState({ inputValue: '' });
	            }
	        };
	        _this.saveInput = function (node) {
	            _this.input = node;
	        };
	        _this.state = {
	            value: props.value || props.defaultValue || [],
	            inputValue: '',
	            inputFocused: false,
	            popupVisible: props.popupVisible,
	            flattenOptions: props.showSearch && _this.flattenTree(props.options, props.changeOnSelect)
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Cascader, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                this.setState({ value: nextProps.value || [] });
	            }
	            if ('popupVisible' in nextProps) {
	                this.setState({ popupVisible: nextProps.popupVisible });
	            }
	            if (nextProps.showSearch && this.props.options !== nextProps.options) {
	                this.setState({ flattenOptions: this.flattenTree(nextProps.options, nextProps.changeOnSelect) });
	            }
	        }
	    }, {
	        key: 'getLabel',
	        value: function getLabel() {
	            var _props = this.props,
	                options = _props.options,
	                _props$displayRender = _props.displayRender,
	                displayRender = _props$displayRender === undefined ? defaultDisplayRender : _props$displayRender;
	
	            var value = this.state.value;
	            var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
	            var selectedOptions = (0, _arrayTreeFilter2['default'])(options, function (o, level) {
	                return o.value === unwrappedValue[level];
	            });
	            var label = selectedOptions.map(function (o) {
	                return o.label;
	            });
	            return displayRender(label, selectedOptions);
	        }
	    }, {
	        key: 'flattenTree',
	        value: function flattenTree(options, changeOnSelect) {
	            var _this2 = this;
	
	            var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	            var flattenOptions = [];
	            options.forEach(function (option) {
	                var path = ancestor.concat(option);
	                if (changeOnSelect || !option.children || !option.children.length) {
	                    flattenOptions.push(path);
	                }
	                if (option.children) {
	                    flattenOptions = flattenOptions.concat(_this2.flattenTree(option.children, changeOnSelect, path));
	                }
	            });
	            return flattenOptions;
	        }
	    }, {
	        key: 'generateFilteredOptions',
	        value: function generateFilteredOptions(prefixCls) {
	            var _this3 = this;
	
	            var _props2 = this.props,
	                showSearch = _props2.showSearch,
	                notFoundContent = _props2.notFoundContent;
	            var _showSearch$filter = showSearch.filter,
	                filter = _showSearch$filter === undefined ? defaultFilterOption : _showSearch$filter,
	                _showSearch$render = showSearch.render,
	                render = _showSearch$render === undefined ? defaultRenderFilteredOption : _showSearch$render,
	                _showSearch$sort = showSearch.sort,
	                sort = _showSearch$sort === undefined ? defaultSortFilteredOption : _showSearch$sort;
	            var _state = this.state,
	                flattenOptions = _state.flattenOptions,
	                inputValue = _state.inputValue;
	
	            var filtered = flattenOptions.filter(function (path) {
	                return filter(_this3.state.inputValue, path);
	            }).sort(function (a, b) {
	                return sort(a, b, inputValue);
	            });
	            if (filtered.length > 0) {
	                return filtered.map(function (path) {
	                    return {
	                        __IS_FILTERED_OPTION: true,
	                        path: path,
	                        label: render(inputValue, path, prefixCls),
	                        value: path.map(function (o) {
	                            return o.value;
	                        }),
	                        disabled: path.some(function (o) {
	                            return o.disabled;
	                        })
	                    };
	                });
	            }
	            return [{ label: notFoundContent, value: 'ANT_CASCADER_NOT_FOUND', disabled: true }];
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.input.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.input.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames, _classNames2, _classNames3;
	
	            var props = this.props,
	                state = this.state;
	
	            var prefixCls = props.prefixCls,
	                inputPrefixCls = props.inputPrefixCls,
	                children = props.children,
	                placeholder = props.placeholder,
	                size = props.size,
	                disabled = props.disabled,
	                className = props.className,
	                style = props.style,
	                allowClear = props.allowClear,
	                _props$showSearch = props.showSearch,
	                showSearch = _props$showSearch === undefined ? false : _props$showSearch,
	                otherProps = __rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch"]);
	
	            var value = state.value;
	            var sizeCls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, inputPrefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, inputPrefixCls + '-sm', size === 'small'), _classNames));
	            var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
	            var arrowCls = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-picker-arrow', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-picker-arrow-expand', state.popupVisible), _classNames2));
	            var pickerCls = (0, _classnames2['default'])(className, prefixCls + '-picker', (_classNames3 = {}, (0, _defineProperty3['default'])(_classNames3, prefixCls + '-picker-with-value', state.inputValue), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-picker-disabled', disabled), (0, _defineProperty3['default'])(_classNames3, prefixCls + '-picker-' + size, !!size), _classNames3));
	            // Fix bug of https://github.com/facebook/react/pull/5004
	            // and https://fb.me/react-unknown-prop
	            var inputProps = (0, _omit2['default'])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent']);
	            var options = props.options;
	            if (state.inputValue) {
	                options = this.generateFilteredOptions(prefixCls);
	            }
	            // Dropdown menu should keep previous status until it is fully closed.
	            if (!state.popupVisible) {
	                options = this.cachedOptions;
	            } else {
	                this.cachedOptions = options;
	            }
	            var dropdownMenuColumnStyle = {};
	            var isNotFound = (options || []).length === 1 && options[0].value === 'ANT_CASCADER_NOT_FOUND';
	            if (isNotFound) {
	                dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
	            }
	            // The default value of `matchInputWidth` is `true`
	            var resultListMatchInputWidth = showSearch.matchInputWidth === false ? false : true;
	            if (resultListMatchInputWidth && state.inputValue && this.input) {
	                dropdownMenuColumnStyle.width = this.input.input.offsetWidth;
	            }
	            var input = children || React.createElement(
	                'span',
	                { style: style, className: pickerCls },
	                React.createElement(
	                    'span',
	                    { className: prefixCls + '-picker-label' },
	                    this.getLabel()
	                ),
	                React.createElement(_input2['default'], (0, _extends3['default'])({}, inputProps, { ref: this.saveInput, prefixCls: inputPrefixCls, placeholder: value && value.length > 0 ? undefined : placeholder, className: prefixCls + '-input ' + sizeCls, value: state.inputValue, disabled: disabled, readOnly: !showSearch, autoComplete: 'off', onClick: showSearch ? this.handleInputClick : undefined, onBlur: showSearch ? this.handleInputBlur : undefined, onKeyDown: this.handleKeyDown, onChange: showSearch ? this.handleInputChange : undefined })),
	                clearIcon,
	                React.createElement(_icon2['default'], { type: 'down', className: arrowCls })
	            );
	            return React.createElement(
	                _rcCascader2['default'],
	                (0, _extends3['default'])({}, props, { options: options, value: value, popupVisible: state.popupVisible, onPopupVisibleChange: this.handlePopupVisibleChange, onChange: this.handleChange, dropdownMenuColumnStyle: dropdownMenuColumnStyle }),
	                input
	            );
	        }
	    }]);
	    return Cascader;
	}(React.Component);
	
	exports['default'] = Cascader;
	
	Cascader.defaultProps = {
	    prefixCls: 'ant-cascader',
	    inputPrefixCls: 'ant-input',
	    placeholder: 'Please select',
	    transitionName: 'slide-up',
	    popupPlacement: 'bottomLeft',
	    options: [],
	    disabled: false,
	    allowClear: true,
	    notFoundContent: 'Not Found'
	};

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(176);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _Checkbox = __webpack_require__(585);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CheckboxGroup = function (_React$Component) {
	    (0, _inherits3['default'])(CheckboxGroup, _React$Component);
	
	    function CheckboxGroup(props) {
	        (0, _classCallCheck3['default'])(this, CheckboxGroup);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).call(this, props));
	
	        _this.toggleOption = function (option) {
	            var optionIndex = _this.state.value.indexOf(option.value);
	            var value = [].concat((0, _toConsumableArray3['default'])(_this.state.value));
	            if (optionIndex === -1) {
	                value.push(option.value);
	            } else {
	                value.splice(optionIndex, 1);
	            }
	            if (!('value' in _this.props)) {
	                _this.setState({ value: value });
	            }
	            var onChange = _this.props.onChange;
	            if (onChange) {
	                onChange(value);
	            }
	        };
	        _this.state = {
	            value: props.value || props.defaultValue || []
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(CheckboxGroup, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                checkboxGroup: {
	                    toggleOption: this.toggleOption,
	                    value: this.state.value,
	                    disabled: this.props.disabled
	                }
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                this.setState({
	                    value: nextProps.value || []
	                });
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
	        }
	    }, {
	        key: 'getOptions',
	        value: function getOptions() {
	            var options = this.props.options;
	            // https://github.com/Microsoft/TypeScript/issues/7960
	
	            return options.map(function (option) {
	                if (typeof option === 'string') {
	                    return {
	                        label: option,
	                        value: option
	                    };
	                }
	                return option;
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = this.props,
	                state = this.state;
	            var prefixCls = props.prefixCls,
	                className = props.className,
	                style = props.style,
	                options = props.options;
	
	            var children = props.children;
	            if (options && options.length > 0) {
	                children = this.getOptions().map(function (option) {
	                    return React.createElement(
	                        _Checkbox2['default'],
	                        { key: option.value, disabled: 'disabled' in option ? option.disabled : props.disabled, value: option.value, checked: state.value.indexOf(option.value) !== -1, onChange: function onChange() {
	                                return _this2.toggleOption(option);
	                            }, className: prefixCls + '-item' },
	                        option.label
	                    );
	                });
	            }
	            var classString = (0, _classnames2['default'])(prefixCls, className);
	            return React.createElement(
	                'div',
	                { className: classString, style: style },
	                children
	            );
	        }
	    }]);
	    return CheckboxGroup;
	}(React.Component);
	
	exports['default'] = CheckboxGroup;
	
	CheckboxGroup.defaultProps = {
	    options: [],
	    prefixCls: 'ant-checkbox-group'
	};
	CheckboxGroup.propTypes = {
	    defaultValue: _propTypes2['default'].array,
	    value: _propTypes2['default'].array,
	    options: _propTypes2['default'].array.isRequired,
	    onChange: _propTypes2['default'].func
	};
	CheckboxGroup.childContextTypes = {
	    checkboxGroup: _propTypes2['default'].any
	};

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _grid = __webpack_require__(270);
	
	exports['default'] = _grid.Col;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcCollapse = __webpack_require__(1160);
	
	var _rcCollapse2 = _interopRequireDefault(_rcCollapse);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _openAnimation = __webpack_require__(380);
	
	var _openAnimation2 = _interopRequireDefault(_openAnimation);
	
	var _CollapsePanel = __webpack_require__(1456);
	
	var _CollapsePanel2 = _interopRequireDefault(_CollapsePanel);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Collapse = function (_React$Component) {
	    (0, _inherits3['default'])(Collapse, _React$Component);
	
	    function Collapse() {
	        (0, _classCallCheck3['default'])(this, Collapse);
	        return (0, _possibleConstructorReturn3['default'])(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Collapse, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                bordered = _props.bordered;
	
	            var collapseClassName = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-borderless', !bordered), className);
	            return React.createElement(_rcCollapse2['default'], (0, _extends3['default'])({}, this.props, { className: collapseClassName }));
	        }
	    }]);
	    return Collapse;
	}(React.Component);
	
	exports['default'] = Collapse;
	
	Collapse.Panel = _CollapsePanel2['default'];
	Collapse.defaultProps = {
	    prefixCls: 'ant-collapse',
	    bordered: true,
	    openAnimation: (0, _extends3['default'])({}, _openAnimation2['default'], {
	        appear: function appear() {}
	    })
	};

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcCollapse = __webpack_require__(1160);
	
	var _rcCollapse2 = _interopRequireDefault(_rcCollapse);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CollapsePanel = function (_React$Component) {
	    (0, _inherits3['default'])(CollapsePanel, _React$Component);
	
	    function CollapsePanel() {
	        (0, _classCallCheck3['default'])(this, CollapsePanel);
	        return (0, _possibleConstructorReturn3['default'])(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(CollapsePanel, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                _props$showArrow = _props.showArrow,
	                showArrow = _props$showArrow === undefined ? true : _props$showArrow;
	
	            var collapsePanelClassName = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-no-arrow', !showArrow), className);
	            return React.createElement(_rcCollapse2['default'].Panel, (0, _extends3['default'])({}, this.props, { className: collapsePanelClassName }));
	        }
	    }]);
	    return CollapsePanel;
	}(React.Component);
	
	exports['default'] = CollapsePanel;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Collapse = __webpack_require__(1455);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Collapse2['default'];

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(1759);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _moment = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(_moment);
	
	var _RangeCalendar = __webpack_require__(2493);
	
	var _RangeCalendar2 = _interopRequireDefault(_RangeCalendar);
	
	var _Picker = __webpack_require__(469);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _callMoment = __webpack_require__(378);
	
	var _callMoment2 = _interopRequireDefault(_callMoment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* tslint:disable jsx-no-multiline-js */
	function getShowDateFromValue(value) {
	    var _value = (0, _slicedToArray3['default'])(value, 2),
	        start = _value[0],
	        end = _value[1];
	    // value could be an empty array, then we should not reset showDate
	
	
	    if (!start && !end) {
	        return;
	    }
	    var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
	    return [start, newEnd];
	}
	function formatValue(value, format) {
	    return value && value.format(format) || '';
	}
	function pickerValueAdapter(value) {
	    if (!value) {
	        return;
	    }
	    if (Array.isArray(value)) {
	        return value;
	    }
	    return [value, value.clone().add(1, 'month')];
	}
	function isEmptyArray(arr) {
	    if (Array.isArray(arr)) {
	        return arr.length === 0 || arr.every(function (i) {
	            return !i;
	        });
	    }
	    return false;
	}
	function fixLocale(value, localeCode) {
	    if (!localeCode) {
	        return;
	    }
	    if (!value || value.length === 0) {
	        return;
	    }
	    if (value[0]) {
	        value[0].locale(localeCode);
	    }
	    if (value[1]) {
	        value[1].locale(localeCode);
	    }
	}
	
	var RangePicker = function (_React$Component) {
	    (0, _inherits3['default'])(RangePicker, _React$Component);
	
	    function RangePicker(props) {
	        (0, _classCallCheck3['default'])(this, RangePicker);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (RangePicker.__proto__ || Object.getPrototypeOf(RangePicker)).call(this, props));
	
	        _this.clearSelection = function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            _this.setState({ value: [] });
	            _this.handleChange([]);
	        };
	        _this.clearHoverValue = function () {
	            return _this.setState({ hoverValue: [] });
	        };
	        _this.handleChange = function (value) {
	            var props = _this.props;
	            if (!('value' in props)) {
	                _this.setState(function (_ref) {
	                    var showDate = _ref.showDate;
	                    return {
	                        value: value,
	                        showDate: getShowDateFromValue(value) || showDate
	                    };
	                });
	            }
	            props.onChange(value, [formatValue(value[0], props.format), formatValue(value[1], props.format)]);
	        };
	        _this.handleOpenChange = function (open) {
	            if (!('open' in _this.props)) {
	                _this.setState({ open: open });
	            }
	            if (open === false) {
	                _this.clearHoverValue();
	            }
	            var onOpenChange = _this.props.onOpenChange;
	
	            if (onOpenChange) {
	                onOpenChange(open);
	            }
	        };
	        _this.handleShowDateChange = function (showDate) {
	            return _this.setState({ showDate: showDate });
	        };
	        _this.handleHoverChange = function (hoverValue) {
	            return _this.setState({ hoverValue: hoverValue });
	        };
	        _this.savePicker = function (node) {
	            _this.picker = node;
	        };
	        _this.renderFooter = function () {
	            var _this$props = _this.props,
	                prefixCls = _this$props.prefixCls,
	                ranges = _this$props.ranges,
	                renderExtraFooter = _this$props.renderExtraFooter;
	
	            if (!ranges && !renderExtraFooter) {
	                return null;
	            }
	            var customFooter = renderExtraFooter ? React.createElement(
	                'div',
	                { className: prefixCls + '-footer-extra', key: 'extra' },
	                renderExtraFooter.apply(undefined, arguments)
	            ) : null;
	            var operations = Object.keys(ranges || {}).map(function (range) {
	                var value = ranges[range];
	                return React.createElement(
	                    'a',
	                    { key: range, onClick: function onClick() {
	                            return _this.setValue(value, true);
	                        }, onMouseEnter: function onMouseEnter() {
	                            return _this.setState({ hoverValue: value });
	                        }, onMouseLeave: _this.clearHoverValue },
	                    range
	                );
	            });
	            var rangeNode = React.createElement(
	                'div',
	                { className: prefixCls + '-footer-extra ' + prefixCls + '-range-quick-selector', key: 'range' },
	                operations
	            );
	            return [rangeNode, customFooter];
	        };
	        var value = props.value || props.defaultValue || [];
	        if (value[0] && !moment.isMoment(value[0]) || value[1] && !moment.isMoment(value[1])) {
	            throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
	        }
	        var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
	        _this.state = {
	            value: value,
	            showDate: pickerValueAdapter(pickerValue || (0, _callMoment2['default'])(moment)),
	            open: props.open,
	            hoverValue: []
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(RangePicker, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                var state = this.state;
	                var value = nextProps.value || [];
	                this.setState({
	                    value: value,
	                    showDate: getShowDateFromValue(value) || state.showDate
	                });
	            }
	            if ('open' in nextProps) {
	                this.setState({
	                    open: nextProps.open
	                });
	            }
	        }
	    }, {
	        key: 'setValue',
	        value: function setValue(value, hidePanel) {
	            this.handleChange(value);
	            if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
	                this.setState({ open: false });
	            }
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.picker.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.picker.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this2 = this;
	
	            var state = this.state,
	                props = this.props;
	            var value = state.value,
	                showDate = state.showDate,
	                hoverValue = state.hoverValue,
	                open = state.open;
	            var prefixCls = props.prefixCls,
	                popupStyle = props.popupStyle,
	                style = props.style,
	                disabledDate = props.disabledDate,
	                disabledTime = props.disabledTime,
	                showTime = props.showTime,
	                showToday = props.showToday,
	                ranges = props.ranges,
	                onOk = props.onOk,
	                locale = props.locale,
	                localeCode = props.localeCode,
	                format = props.format,
	                dateRender = props.dateRender,
	                onCalendarChange = props.onCalendarChange;
	
	            fixLocale(value, localeCode);
	            fixLocale(showDate, localeCode);
	            (0, _warning2['default'])(!('onOK' in props), 'It should be `RangePicker[onOk]`, instead of `onOK`!');
	            var calendarClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-time', showTime), (0, _defineProperty3['default'])(_classNames, prefixCls + '-range-with-ranges', ranges), _classNames));
	            // 需要选择时间时，点击 ok 时才触发 onChange
	            var pickerChangeHandler = {
	                onChange: this.handleChange
	            };
	            var calendarProps = {
	                onOk: this.handleChange
	            };
	            if (props.timePicker) {
	                pickerChangeHandler.onChange = function (changedValue) {
	                    return _this2.handleChange(changedValue);
	                };
	            } else {
	                calendarProps = {};
	            }
	            if ('mode' in props) {
	                calendarProps.mode = props.mode;
	            }
	            var startPlaceholder = 'placeholder' in props ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
	            var endPlaceholder = 'placeholder' in props ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
	            var calendar = React.createElement(_RangeCalendar2['default'], (0, _extends3['default'])({}, calendarProps, { onChange: onCalendarChange, format: format, prefixCls: prefixCls, className: calendarClassName, renderFooter: this.renderFooter, timePicker: props.timePicker, disabledDate: disabledDate, disabledTime: disabledTime, dateInputPlaceholder: [startPlaceholder, endPlaceholder], locale: locale.lang, onOk: onOk, dateRender: dateRender, value: showDate, onValueChange: this.handleShowDateChange, hoverValue: hoverValue, onHoverChange: this.handleHoverChange, onPanelChange: props.onPanelChange, showToday: showToday }));
	            // default width for showTime
	            var pickerStyle = {};
	            if (props.showTime) {
	                pickerStyle.width = style && style.width || 350;
	            }
	            var clearIcon = !props.disabled && props.allowClear && value && (value[0] || value[1]) ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
	            var input = function input(_ref2) {
	                var inputValue = _ref2.value;
	
	                var start = inputValue[0];
	                var end = inputValue[1];
	                return React.createElement(
	                    'span',
	                    { className: props.pickerInputClass },
	                    React.createElement('input', { disabled: props.disabled, readOnly: true, value: start && start.format(props.format) || '', placeholder: startPlaceholder, className: prefixCls + '-range-picker-input', tabIndex: -1 }),
	                    React.createElement(
	                        'span',
	                        { className: prefixCls + '-range-picker-separator' },
	                        ' ~ '
	                    ),
	                    React.createElement('input', { disabled: props.disabled, readOnly: true, value: end && end.format(props.format) || '', placeholder: endPlaceholder, className: prefixCls + '-range-picker-input', tabIndex: -1 }),
	                    clearIcon,
	                    React.createElement('span', { className: prefixCls + '-picker-icon' })
	                );
	            };
	            return React.createElement(
	                'span',
	                { ref: this.savePicker, className: (0, _classnames2['default'])(props.className, props.pickerClass), style: (0, _extends3['default'])({}, style, pickerStyle), tabIndex: props.disabled ? -1 : 0, onFocus: props.onFocus, onBlur: props.onBlur },
	                React.createElement(
	                    _Picker2['default'],
	                    (0, _extends3['default'])({}, props, pickerChangeHandler, { calendar: calendar, value: value, open: open, onOpenChange: this.handleOpenChange, prefixCls: prefixCls + '-picker-container', style: popupStyle }),
	                    input
	                )
	            );
	        }
	    }]);
	    return RangePicker;
	}(React.Component);
	
	exports['default'] = RangePicker;
	
	RangePicker.defaultProps = {
	    prefixCls: 'ant-calendar',
	    allowClear: true,
	    showToday: false
	};

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _moment = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(_moment);
	
	var _rcCalendar = __webpack_require__(1155);
	
	var _rcCalendar2 = _interopRequireDefault(_rcCalendar);
	
	var _Picker = __webpack_require__(469);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function formatValue(value, format) {
	    return value && value.format(format) || '';
	}
	
	var WeekPicker = function (_React$Component) {
	    (0, _inherits3['default'])(WeekPicker, _React$Component);
	
	    function WeekPicker(props) {
	        (0, _classCallCheck3['default'])(this, WeekPicker);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (WeekPicker.__proto__ || Object.getPrototypeOf(WeekPicker)).call(this, props));
	
	        _this.weekDateRender = function (current) {
	            var selectedValue = _this.state.value;
	            var prefixCls = _this.props.prefixCls;
	
	            if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
	                return React.createElement(
	                    'div',
	                    { className: prefixCls + '-selected-day' },
	                    React.createElement(
	                        'div',
	                        { className: prefixCls + '-date' },
	                        current.date()
	                    )
	                );
	            }
	            return React.createElement(
	                'div',
	                { className: prefixCls + '-calendar-date' },
	                current.date()
	            );
	        };
	        _this.handleChange = function (value) {
	            if (!('value' in _this.props)) {
	                _this.setState({ value: value });
	            }
	            _this.props.onChange(value, formatValue(value, _this.props.format));
	        };
	        _this.clearSelection = function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            _this.handleChange(null);
	        };
	        _this.saveInput = function (node) {
	            _this.input = node;
	        };
	        var value = props.value || props.defaultValue;
	        if (value && !moment.isMoment(value)) {
	            throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	        }
	        _this.state = {
	            value: value
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(WeekPicker, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                this.setState({ value: nextProps.value });
	            }
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.input.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.input.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                className = _props.className,
	                disabled = _props.disabled,
	                pickerClass = _props.pickerClass,
	                popupStyle = _props.popupStyle,
	                pickerInputClass = _props.pickerInputClass,
	                format = _props.format,
	                allowClear = _props.allowClear,
	                locale = _props.locale,
	                localeCode = _props.localeCode,
	                disabledDate = _props.disabledDate;
	
	            var pickerValue = this.state.value;
	            if (pickerValue && localeCode) {
	                pickerValue.locale(localeCode);
	            }
	            var placeholder = 'placeholder' in this.props ? this.props.placeholder : locale.lang.placeholder;
	            var calendar = React.createElement(_rcCalendar2['default'], { showWeekNumber: true, dateRender: this.weekDateRender, prefixCls: prefixCls, format: format, locale: locale.lang, showDateInput: false, showToday: false, disabledDate: disabledDate });
	            var clearIcon = !disabled && allowClear && this.state.value ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
	            var input = function input(_ref) {
	                var value = _ref.value;
	
	                return React.createElement(
	                    'span',
	                    null,
	                    React.createElement('input', { ref: _this2.saveInput, disabled: disabled, readOnly: true, value: value && value.format(format) || '', placeholder: placeholder, className: pickerInputClass, onFocus: _this2.props.onFocus, onBlur: _this2.props.onBlur }),
	                    clearIcon,
	                    React.createElement('span', { className: prefixCls + '-picker-icon' })
	                );
	            };
	            return React.createElement(
	                'span',
	                { className: (0, _classnames2['default'])(className, pickerClass) },
	                React.createElement(
	                    _Picker2['default'],
	                    (0, _extends3['default'])({}, this.props, { calendar: calendar, prefixCls: prefixCls + '-picker-container', value: pickerValue, onChange: this.handleChange, style: popupStyle }),
	                    input
	                )
	            );
	        }
	    }]);
	    return WeekPicker;
	}(React.Component);
	
	exports['default'] = WeekPicker;
	
	WeekPicker.defaultProps = {
	    format: 'YYYY-wo',
	    allowClear: true
	};

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createPicker;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _moment = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(_moment);
	
	var _MonthCalendar = __webpack_require__(1148);
	
	var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);
	
	var _Picker = __webpack_require__(469);
	
	var _Picker2 = _interopRequireDefault(_Picker);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _callMoment = __webpack_require__(378);
	
	var _callMoment2 = _interopRequireDefault(_callMoment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function createPicker(TheCalendar) {
	    return _a = function (_React$Component) {
	        (0, _inherits3['default'])(CalenderWrapper, _React$Component);
	
	        function CalenderWrapper(props) {
	            (0, _classCallCheck3['default'])(this, CalenderWrapper);
	
	            var _this = (0, _possibleConstructorReturn3['default'])(this, (CalenderWrapper.__proto__ || Object.getPrototypeOf(CalenderWrapper)).call(this, props));
	
	            _this.renderFooter = function () {
	                var _this$props = _this.props,
	                    prefixCls = _this$props.prefixCls,
	                    renderExtraFooter = _this$props.renderExtraFooter;
	
	                return renderExtraFooter ? React.createElement(
	                    'div',
	                    { className: prefixCls + '-footer-extra' },
	                    renderExtraFooter.apply(undefined, arguments)
	                ) : null;
	            };
	            _this.clearSelection = function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	                _this.handleChange(null);
	            };
	            _this.handleChange = function (value) {
	                var props = _this.props;
	                if (!('value' in props)) {
	                    _this.setState({ value: value });
	                }
	                props.onChange(value, value && value.format(props.format) || '');
	            };
	            _this.saveInput = function (node) {
	                _this.input = node;
	            };
	            var value = props.value || props.defaultValue;
	            if (value && !moment.isMoment(value)) {
	                throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	            }
	            _this.state = {
	                value: value
	            };
	            return _this;
	        }
	
	        (0, _createClass3['default'])(CalenderWrapper, [{
	            key: 'componentWillReceiveProps',
	            value: function componentWillReceiveProps(nextProps) {
	                if ('value' in nextProps) {
	                    this.setState({
	                        value: nextProps.value
	                    });
	                }
	            }
	        }, {
	            key: 'focus',
	            value: function focus() {
	                this.input.focus();
	            }
	        }, {
	            key: 'blur',
	            value: function blur() {
	                this.input.blur();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var _classNames,
	                    _this2 = this;
	
	                var value = this.state.value;
	
	                var props = (0, _omit2['default'])(this.props, ['onChange']);
	                var prefixCls = props.prefixCls,
	                    locale = props.locale,
	                    localeCode = props.localeCode;
	
	                var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
	                var disabledTime = props.showTime ? props.disabledTime : null;
	                var calendarClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-time', props.showTime), (0, _defineProperty3['default'])(_classNames, prefixCls + '-month', _MonthCalendar2['default'] === TheCalendar), _classNames));
	                var pickerProps = {};
	                var calendarProps = {};
	                if (props.showTime) {
	                    calendarProps = {
	                        // fix https://github.com/ant-design/ant-design/issues/1902
	                        onSelect: this.handleChange
	                    };
	                } else {
	                    pickerProps = {
	                        onChange: this.handleChange
	                    };
	                }
	                if ('mode' in props) {
	                    calendarProps.mode = props.mode;
	                }
	                (0, _warning2['default'])(!('onOK' in props), 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
	                var calendar = React.createElement(TheCalendar, (0, _extends3['default'])({}, calendarProps, { disabledDate: props.disabledDate, disabledTime: disabledTime, locale: locale.lang, timePicker: props.timePicker, defaultValue: props.defaultPickerValue || (0, _callMoment2['default'])(moment), dateInputPlaceholder: placeholder, prefixCls: prefixCls, className: calendarClassName, onOk: props.onOk, dateRender: props.dateRender, format: props.format, showToday: props.showToday, monthCellContentRender: props.monthCellContentRender, renderFooter: this.renderFooter, onPanelChange: props.onPanelChange }));
	                var clearIcon = !props.disabled && props.allowClear && value ? React.createElement(_icon2['default'], { type: 'cross-circle', className: prefixCls + '-picker-clear', onClick: this.clearSelection }) : null;
	                var input = function input(_ref) {
	                    var inputValue = _ref.value;
	                    return React.createElement(
	                        'div',
	                        null,
	                        React.createElement('input', { ref: _this2.saveInput, disabled: props.disabled, readOnly: true, value: inputValue && inputValue.format(props.format) || '', placeholder: placeholder, className: props.pickerInputClass }),
	                        clearIcon,
	                        React.createElement('span', { className: prefixCls + '-picker-icon' })
	                    );
	                };
	                var pickerValue = value;
	                if (pickerValue && localeCode) {
	                    pickerValue.locale(localeCode);
	                }
	                return React.createElement(
	                    'span',
	                    { className: (0, _classnames2['default'])(props.className, props.pickerClass), style: props.style, onFocus: props.onFocus, onBlur: props.onBlur },
	                    React.createElement(
	                        _Picker2['default'],
	                        (0, _extends3['default'])({}, props, pickerProps, { calendar: calendar, value: pickerValue, prefixCls: prefixCls + '-picker-container', style: props.popupStyle }),
	                        input
	                    )
	                );
	            }
	        }]);
	        return CalenderWrapper;
	    }(React.Component), _a.defaultProps = {
	        prefixCls: 'ant-calendar',
	        allowClear: true,
	        showToday: true
	    }, _a;
	    var _a;
	}

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _rcCalendar = __webpack_require__(1155);
	
	var _rcCalendar2 = _interopRequireDefault(_rcCalendar);
	
	var _MonthCalendar = __webpack_require__(1148);
	
	var _MonthCalendar2 = _interopRequireDefault(_MonthCalendar);
	
	var _createPicker = __webpack_require__(1460);
	
	var _createPicker2 = _interopRequireDefault(_createPicker);
	
	var _wrapPicker = __webpack_require__(1462);
	
	var _wrapPicker2 = _interopRequireDefault(_wrapPicker);
	
	var _RangePicker = __webpack_require__(1458);
	
	var _RangePicker2 = _interopRequireDefault(_RangePicker);
	
	var _WeekPicker = __webpack_require__(1459);
	
	var _WeekPicker2 = _interopRequireDefault(_WeekPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DatePicker = (0, _wrapPicker2['default'])((0, _createPicker2['default'])(_rcCalendar2['default']));
	var MonthPicker = (0, _wrapPicker2['default'])((0, _createPicker2['default'])(_MonthCalendar2['default']), 'YYYY-MM');
	(0, _extends3['default'])(DatePicker, {
	    RangePicker: (0, _wrapPicker2['default'])(_RangePicker2['default']),
	    MonthPicker: MonthPicker,
	    WeekPicker: (0, _wrapPicker2['default'])(_WeekPicker2['default'], 'YYYY-wo')
	});
	exports['default'] = DatePicker;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = wrapPicker;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Panel = __webpack_require__(1186);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _timePicker = __webpack_require__(599);
	
	var _en_US = __webpack_require__(381);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getColumns(_ref) {
	    var showHour = _ref.showHour,
	        showMinute = _ref.showMinute,
	        showSecond = _ref.showSecond,
	        use12Hours = _ref.use12Hours;
	
	    var column = 0;
	    if (showHour) {
	        column += 1;
	    }
	    if (showMinute) {
	        column += 1;
	    }
	    if (showSecond) {
	        column += 1;
	    }
	    if (use12Hours) {
	        column += 1;
	    }
	    return column;
	}
	function wrapPicker(Picker, defaultFormat) {
	    return _a = function (_React$Component) {
	        (0, _inherits3['default'])(PickerWrapper, _React$Component);
	
	        function PickerWrapper() {
	            (0, _classCallCheck3['default'])(this, PickerWrapper);
	
	            var _this = (0, _possibleConstructorReturn3['default'])(this, (PickerWrapper.__proto__ || Object.getPrototypeOf(PickerWrapper)).apply(this, arguments));
	
	            _this.handleOpenChange = function (open) {
	                var onOpenChange = _this.props.onOpenChange;
	
	                onOpenChange(open);
	            };
	            _this.handleFocus = function (e) {
	                var onFocus = _this.props.onFocus;
	
	                if (onFocus) {
	                    onFocus(e);
	                }
	            };
	            _this.handleBlur = function (e) {
	                var onBlur = _this.props.onBlur;
	
	                if (onBlur) {
	                    onBlur(e);
	                }
	            };
	            _this.savePicker = function (node) {
	                _this.picker = node;
	            };
	            _this.getDefaultLocale = function () {
	                var result = (0, _extends3['default'])({}, _en_US2['default'], _this.props.locale);
	                result.lang = (0, _extends3['default'])({}, result.lang, (_this.props.locale || {}).lang);
	                return result;
	            };
	            _this.renderPicker = function (locale, localeCode) {
	                var _classNames2;
	
	                var props = _this.props;
	                var prefixCls = props.prefixCls,
	                    inputPrefixCls = props.inputPrefixCls;
	
	                var pickerClass = (0, _classnames2['default'])(prefixCls + '-picker', (0, _defineProperty3['default'])({}, prefixCls + '-picker-' + props.size, !!props.size));
	                var pickerInputClass = (0, _classnames2['default'])(prefixCls + '-picker-input', inputPrefixCls, (_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-lg', props.size === 'large'), (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames2, inputPrefixCls + '-disabled', props.disabled), _classNames2));
	                var timeFormat = props.showTime && props.showTime.format || 'HH:mm:ss';
	                var rcTimePickerProps = (0, _extends3['default'])({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat), { format: timeFormat, use12Hours: props.showTime && props.showTime.use12Hours });
	                var columns = getColumns(rcTimePickerProps);
	                var timePickerCls = prefixCls + '-time-picker-column-' + columns;
	                var timePicker = props.showTime ? React.createElement(_Panel2['default'], (0, _extends3['default'])({}, rcTimePickerProps, props.showTime, { prefixCls: prefixCls + '-time-picker', className: timePickerCls, placeholder: locale.timePickerLocale.placeholder, transitionName: 'slide-up' })) : null;
	                return React.createElement(Picker, (0, _extends3['default'])({}, props, { ref: _this.savePicker, pickerClass: pickerClass, pickerInputClass: pickerInputClass, locale: locale, localeCode: localeCode, timePicker: timePicker, onOpenChange: _this.handleOpenChange, onFocus: _this.handleFocus, onBlur: _this.handleBlur }));
	            };
	            return _this;
	        }
	
	        (0, _createClass3['default'])(PickerWrapper, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                var _props = this.props,
	                    autoFocus = _props.autoFocus,
	                    disabled = _props.disabled;
	
	                if (autoFocus && !disabled) {
	                    this.focus();
	                }
	            }
	        }, {
	            key: 'focus',
	            value: function focus() {
	                this.picker.focus();
	            }
	        }, {
	            key: 'blur',
	            value: function blur() {
	                this.picker.blur();
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                return React.createElement(
	                    _LocaleReceiver2['default'],
	                    { componentName: 'DatePicker', defaultLocale: this.getDefaultLocale },
	                    this.renderPicker
	                );
	            }
	        }]);
	        return PickerWrapper;
	    }(React.Component), _a.defaultProps = {
	        format: defaultFormat || 'YYYY-MM-DD',
	        transitionName: 'slide-up',
	        popupStyle: {},
	        onChange: function onChange() {},
	        onOk: function onOk() {},
	        onOpenChange: function onOpenChange() {},
	
	        locale: {},
	        prefixCls: 'ant-calendar',
	        inputPrefixCls: 'ant-input'
	    }, _a;
	    var _a;
	}

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports['default'] = Divider;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	function Divider(_a) {
	    var _classNames;
	
	    var _a$prefixCls = _a.prefixCls,
	        prefixCls = _a$prefixCls === undefined ? 'ant' : _a$prefixCls,
	        _a$type = _a.type,
	        type = _a$type === undefined ? 'horizontal' : _a$type,
	        className = _a.className,
	        children = _a.children,
	        dashed = _a.dashed,
	        restProps = __rest(_a, ["prefixCls", "type", "className", "children", "dashed"]);
	
	    var classString = (0, _classnames2['default'])(className, prefixCls + '-divider', prefixCls + '-divider-' + type, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-divider-with-text', children), (0, _defineProperty3['default'])(_classNames, prefixCls + '-divider-dashed', !!dashed), _classNames));
	    return React.createElement(
	        'div',
	        (0, _extends3['default'])({ className: classString }, restProps),
	        children && React.createElement(
	            'span',
	            { className: prefixCls + '-divider-inner-text' },
	            children
	        )
	    );
	}

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _button = __webpack_require__(142);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _dropdown = __webpack_require__(589);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var ButtonGroup = _button2['default'].Group;
	
	var DropdownButton = function (_React$Component) {
	    (0, _inherits3['default'])(DropdownButton, _React$Component);
	
	    function DropdownButton() {
	        (0, _classCallCheck3['default'])(this, DropdownButton);
	        return (0, _possibleConstructorReturn3['default'])(this, (DropdownButton.__proto__ || Object.getPrototypeOf(DropdownButton)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(DropdownButton, [{
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                type = _a.type,
	                disabled = _a.disabled,
	                onClick = _a.onClick,
	                children = _a.children,
	                prefixCls = _a.prefixCls,
	                className = _a.className,
	                overlay = _a.overlay,
	                trigger = _a.trigger,
	                align = _a.align,
	                visible = _a.visible,
	                onVisibleChange = _a.onVisibleChange,
	                placement = _a.placement,
	                getPopupContainer = _a.getPopupContainer,
	                restProps = __rest(_a, ["type", "disabled", "onClick", "children", "prefixCls", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer"]);
	            var dropdownProps = {
	                align: align,
	                overlay: overlay,
	                disabled: disabled,
	                trigger: disabled ? [] : trigger,
	                onVisibleChange: onVisibleChange,
	                placement: placement,
	                getPopupContainer: getPopupContainer
	            };
	            if ('visible' in this.props) {
	                dropdownProps.visible = visible;
	            }
	            return React.createElement(
	                ButtonGroup,
	                (0, _extends3['default'])({}, restProps, { className: (0, _classnames2['default'])(prefixCls, className) }),
	                React.createElement(
	                    _button2['default'],
	                    { type: type, disabled: disabled, onClick: onClick },
	                    children
	                ),
	                React.createElement(
	                    _dropdown2['default'],
	                    dropdownProps,
	                    React.createElement(
	                        _button2['default'],
	                        { type: type },
	                        React.createElement(_icon2['default'], { type: 'down' })
	                    )
	                )
	            );
	        }
	    }]);
	    return DropdownButton;
	}(React.Component);
	
	exports['default'] = DropdownButton;
	
	DropdownButton.defaultProps = {
	    placement: 'bottomRight',
	    type: 'default',
	    prefixCls: 'ant-dropdown-button'
	};

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _createDOMForm = __webpack_require__(2539);
	
	var _createDOMForm2 = _interopRequireDefault(_createDOMForm);
	
	var _createFormField = __webpack_require__(1166);
	
	var _createFormField2 = _interopRequireDefault(_createFormField);
	
	var _PureRenderMixin = __webpack_require__(239);
	
	var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormItem = __webpack_require__(1466);
	
	var _FormItem2 = _interopRequireDefault(_FormItem);
	
	var _constants = __webpack_require__(590);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Form = function (_React$Component) {
	    (0, _inherits3['default'])(Form, _React$Component);
	
	    function Form(props) {
	        (0, _classCallCheck3['default'])(this, Form);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));
	
	        (0, _warning2['default'])(!props.form, 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Form, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _PureRenderMixin2['default'].shouldComponentUpdate.apply(this, args);
	        }
	    }, {
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var layout = this.props.layout;
	
	            return {
	                vertical: layout === 'vertical'
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                hideRequiredMark = _props.hideRequiredMark,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                layout = _props.layout;
	
	            var formClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-horizontal', layout === 'horizontal'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', layout === 'vertical'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-inline', layout === 'inline'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-hide-required-mark', hideRequiredMark), _classNames), className);
	            var formProps = (0, _omit2['default'])(this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark']);
	            return React.createElement('form', (0, _extends3['default'])({}, formProps, { className: formClassName }));
	        }
	    }]);
	    return Form;
	}(React.Component);
	
	exports['default'] = Form;
	
	Form.defaultProps = {
	    prefixCls: 'ant-form',
	    layout: 'horizontal',
	    hideRequiredMark: false,
	    onSubmit: function onSubmit(e) {
	        e.preventDefault();
	    }
	};
	Form.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    layout: _propTypes2['default'].oneOf(['horizontal', 'inline', 'vertical']),
	    children: _propTypes2['default'].any,
	    onSubmit: _propTypes2['default'].func,
	    hideRequiredMark: _propTypes2['default'].bool
	};
	Form.childContextTypes = {
	    vertical: _propTypes2['default'].bool
	};
	Form.Item = _FormItem2['default'];
	Form.createFormField = _createFormField2['default'];
	Form.create = function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return (0, _createDOMForm2['default'])((0, _extends3['default'])({ fieldNameProp: 'id' }, options, { fieldMetaProp: _constants.FIELD_META_PROP, fieldDataProp: _constants.FIELD_DATA_PROP }));
	};

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PureRenderMixin = __webpack_require__(239);
	
	var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);
	
	var _row = __webpack_require__(592);
	
	var _row2 = _interopRequireDefault(_row);
	
	var _col = __webpack_require__(591);
	
	var _col2 = _interopRequireDefault(_col);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _constants = __webpack_require__(590);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FormItem = function (_React$Component) {
	    (0, _inherits3['default'])(FormItem, _React$Component);
	
	    function FormItem() {
	        (0, _classCallCheck3['default'])(this, FormItem);
	
	        // Resolve duplicated ids bug between different forms
	        // https://github.com/ant-design/ant-design/issues/7351
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (FormItem.__proto__ || Object.getPrototypeOf(FormItem)).apply(this, arguments));
	
	        _this.onLabelClick = function (e) {
	            var label = _this.props.label;
	
	            var id = _this.props.id || _this.getId();
	            if (!id) {
	                return;
	            }
	            var controls = document.querySelectorAll('[id="' + id + '"]');
	            if (controls.length !== 1) {
	                // Only prevent in default situation
	                // Avoid preventing event in `label={<a href="xx">link</a>}``
	                if (typeof label === 'string') {
	                    e.preventDefault();
	                }
	                var control = ReactDOM.findDOMNode(_this).querySelector('[id="' + id + '"]');
	                if (control && control.focus) {
	                    control.focus();
	                }
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(FormItem, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            (0, _warning2['default'])(this.getControls(this.props.children, true).length <= 1, '`Form.Item` cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _PureRenderMixin2['default'].shouldComponentUpdate.apply(this, args);
	        }
	    }, {
	        key: 'getHelpMsg',
	        value: function getHelpMsg() {
	            var props = this.props;
	            var onlyControl = this.getOnlyControl();
	            if (props.help === undefined && onlyControl) {
	                var errors = this.getField().errors;
	                return errors ? errors.map(function (e) {
	                    return e.message;
	                }).join(', ') : '';
	            }
	            return props.help;
	        }
	    }, {
	        key: 'getControls',
	        value: function getControls(children, recursively) {
	            var controls = [];
	            var childrenArray = React.Children.toArray(children);
	            for (var i = 0; i < childrenArray.length; i++) {
	                if (!recursively && controls.length > 0) {
	                    break;
	                }
	                var child = childrenArray[i];
	                if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
	                    continue;
	                }
	                if (!child.props) {
	                    continue;
	                }
	                if (_constants.FIELD_META_PROP in child.props) {
	                    controls.push(child);
	                } else if (child.props.children) {
	                    controls = controls.concat(this.getControls(child.props.children, recursively));
	                }
	            }
	            return controls;
	        }
	    }, {
	        key: 'getOnlyControl',
	        value: function getOnlyControl() {
	            var child = this.getControls(this.props.children, false)[0];
	            return child !== undefined ? child : null;
	        }
	    }, {
	        key: 'getChildProp',
	        value: function getChildProp(prop) {
	            var child = this.getOnlyControl();
	            return child && child.props && child.props[prop];
	        }
	    }, {
	        key: 'getId',
	        value: function getId() {
	            return this.getChildProp('id');
	        }
	    }, {
	        key: 'getMeta',
	        value: function getMeta() {
	            return this.getChildProp(_constants.FIELD_META_PROP);
	        }
	    }, {
	        key: 'getField',
	        value: function getField() {
	            return this.getChildProp(_constants.FIELD_DATA_PROP);
	        }
	    }, {
	        key: 'renderHelp',
	        value: function renderHelp() {
	            var prefixCls = this.props.prefixCls;
	            var help = this.getHelpMsg();
	            var children = help ? React.createElement(
	                'div',
	                { className: prefixCls + '-explain', key: 'help' },
	                help
	            ) : null;
	            return React.createElement(
	                _rcAnimate2['default'],
	                { transitionName: 'show-help', component: '', transitionAppear: true, key: 'help' },
	                children
	            );
	        }
	    }, {
	        key: 'renderExtra',
	        value: function renderExtra() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                extra = _props.extra;
	
	            return extra ? React.createElement(
	                'div',
	                { className: prefixCls + '-extra' },
	                extra
	            ) : null;
	        }
	    }, {
	        key: 'getValidateStatus',
	        value: function getValidateStatus() {
	            var onlyControl = this.getOnlyControl();
	            if (!onlyControl) {
	                return '';
	            }
	            var field = this.getField();
	            if (field.validating) {
	                return 'validating';
	            }
	            if (field.errors) {
	                return 'error';
	            }
	            var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;
	            if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
	                return 'success';
	            }
	            return '';
	        }
	    }, {
	        key: 'renderValidateWrapper',
	        value: function renderValidateWrapper(c1, c2, c3) {
	            var props = this.props;
	            var onlyControl = this.getOnlyControl;
	            var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
	            var classes = this.props.prefixCls + '-item-control';
	            if (validateStatus) {
	                classes = (0, _classnames2['default'])(this.props.prefixCls + '-item-control', {
	                    'has-feedback': props.hasFeedback || validateStatus === 'validating',
	                    'has-success': validateStatus === 'success',
	                    'has-warning': validateStatus === 'warning',
	                    'has-error': validateStatus === 'error',
	                    'is-validating': validateStatus === 'validating'
	                });
	            }
	            return React.createElement(
	                'div',
	                { className: classes },
	                c1,
	                c2,
	                c3
	            );
	        }
	    }, {
	        key: 'renderWrapper',
	        value: function renderWrapper(children) {
	            var _props2 = this.props,
	                prefixCls = _props2.prefixCls,
	                wrapperCol = _props2.wrapperCol;
	
	            var className = (0, _classnames2['default'])(prefixCls + '-item-control-wrapper', wrapperCol && wrapperCol.className);
	            return React.createElement(
	                _col2['default'],
	                (0, _extends3['default'])({}, wrapperCol, { className: className, key: 'wrapper' }),
	                children
	            );
	        }
	    }, {
	        key: 'isRequired',
	        value: function isRequired() {
	            var required = this.props.required;
	
	            if (required !== undefined) {
	                return required;
	            }
	            if (this.getOnlyControl()) {
	                var meta = this.getMeta() || {};
	                var validate = meta.validate || [];
	                return validate.filter(function (item) {
	                    return !!item.rules;
	                }).some(function (item) {
	                    return item.rules.some(function (rule) {
	                        return rule.required;
	                    });
	                });
	            }
	            return false;
	        }
	    }, {
	        key: 'renderLabel',
	        value: function renderLabel() {
	            var _props3 = this.props,
	                prefixCls = _props3.prefixCls,
	                label = _props3.label,
	                labelCol = _props3.labelCol,
	                colon = _props3.colon,
	                id = _props3.id;
	
	            var context = this.context;
	            var required = this.isRequired();
	            var labelColClassName = (0, _classnames2['default'])(prefixCls + '-item-label', labelCol && labelCol.className);
	            var labelClassName = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, prefixCls + '-item-required', required));
	            var labelChildren = label;
	            // Keep label is original where there should have no colon
	            var haveColon = colon && !context.vertical;
	            // Remove duplicated user input colon
	            if (haveColon && typeof label === 'string' && label.trim() !== '') {
	                labelChildren = label.replace(/[：|:]\s*$/, '');
	            }
	            return label ? React.createElement(
	                _col2['default'],
	                (0, _extends3['default'])({}, labelCol, { className: labelColClassName, key: 'label' }),
	                React.createElement(
	                    'label',
	                    { htmlFor: id || this.getId(), className: labelClassName, title: typeof label === 'string' ? label : '', onClick: this.onLabelClick },
	                    labelChildren
	                )
	            ) : null;
	        }
	    }, {
	        key: 'renderChildren',
	        value: function renderChildren() {
	            var children = this.props.children;
	
	            return [this.renderLabel(), this.renderWrapper(this.renderValidateWrapper(children, this.renderHelp(), this.renderExtra()))];
	        }
	    }, {
	        key: 'renderFormItem',
	        value: function renderFormItem(children) {
	            var _itemClassName;
	
	            var props = this.props;
	            var prefixCls = props.prefixCls;
	            var style = props.style;
	            var itemClassName = (_itemClassName = {}, (0, _defineProperty3['default'])(_itemClassName, prefixCls + '-item', true), (0, _defineProperty3['default'])(_itemClassName, prefixCls + '-item-with-help', !!this.getHelpMsg()), (0, _defineProperty3['default'])(_itemClassName, prefixCls + '-item-no-colon', !props.colon), (0, _defineProperty3['default'])(_itemClassName, '' + props.className, !!props.className), _itemClassName);
	            return React.createElement(
	                _row2['default'],
	                { className: (0, _classnames2['default'])(itemClassName), style: style },
	                children
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.renderChildren();
	            return this.renderFormItem(children);
	        }
	    }]);
	    return FormItem;
	}(React.Component);
	
	exports['default'] = FormItem;
	
	FormItem.defaultProps = {
	    hasFeedback: false,
	    prefixCls: 'ant-form',
	    colon: true
	};
	FormItem.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    label: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]),
	    labelCol: _propTypes2['default'].object,
	    help: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].bool]),
	    validateStatus: _propTypes2['default'].oneOf(['', 'success', 'warning', 'error', 'validating']),
	    hasFeedback: _propTypes2['default'].bool,
	    wrapperCol: _propTypes2['default'].object,
	    className: _propTypes2['default'].string,
	    id: _propTypes2['default'].string,
	    children: _propTypes2['default'].node,
	    colon: _propTypes2['default'].bool
	};
	FormItem.contextTypes = {
	    vertical: _propTypes2['default'].bool
	};

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Form = __webpack_require__(1465);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Form2['default'];

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcInputNumber = __webpack_require__(2545);
	
	var _rcInputNumber2 = _interopRequireDefault(_rcInputNumber);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var InputNumber = function (_React$Component) {
	    (0, _inherits3['default'])(InputNumber, _React$Component);
	
	    function InputNumber() {
	        (0, _classCallCheck3['default'])(this, InputNumber);
	        return (0, _possibleConstructorReturn3['default'])(this, (InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(InputNumber, [{
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this2 = this;
	
	            var _a = this.props,
	                className = _a.className,
	                size = _a.size,
	                others = __rest(_a, ["className", "size"]);
	            var inputNumberClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, this.props.prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, this.props.prefixCls + '-sm', size === 'small'), _classNames), className);
	            return React.createElement(_rcInputNumber2['default'], (0, _extends3['default'])({ ref: function ref(c) {
	                    return _this2.inputNumberRef = c;
	                }, className: inputNumberClass }, others));
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.inputNumberRef.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.inputNumberRef.blur();
	        }
	    }]);
	    return InputNumber;
	}(React.Component);
	
	exports['default'] = InputNumber;
	
	InputNumber.defaultProps = {
	    prefixCls: 'ant-input-number',
	    step: 1
	};

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Group = function Group(props) {
	    var _classNames;
	
	    var _props$prefixCls = props.prefixCls,
	        prefixCls = _props$prefixCls === undefined ? 'ant-input-group' : _props$prefixCls,
	        _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className;
	
	    var cls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', props.size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', props.size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-compact', props.compact), _classNames), className);
	    return React.createElement(
	        'span',
	        { className: cls, style: props.style },
	        props.children
	    );
	};
	exports['default'] = Group;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Input = __webpack_require__(593);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _button = __webpack_require__(142);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Search = function (_React$Component) {
	    (0, _inherits3['default'])(Search, _React$Component);
	
	    function Search() {
	        (0, _classCallCheck3['default'])(this, Search);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Search.__proto__ || Object.getPrototypeOf(Search)).apply(this, arguments));
	
	        _this.onSearch = function () {
	            var onSearch = _this.props.onSearch;
	
	            if (onSearch) {
	                onSearch(_this.input.input.value);
	            }
	            _this.input.focus();
	        };
	        _this.saveInput = function (node) {
	            _this.input = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Search, [{
	        key: 'focus',
	        value: function focus() {
	            this.input.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.input.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                className = _a.className,
	                prefixCls = _a.prefixCls,
	                inputPrefixCls = _a.inputPrefixCls,
	                size = _a.size,
	                enterButton = _a.enterButton,
	                suffix = _a.suffix,
	                others = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "enterButton", "suffix"]);
	            delete others.onSearch;
	            var buttonOrIcon = enterButton ? React.createElement(
	                _button2['default'],
	                { className: prefixCls + '-button', type: 'primary', size: size, onClick: this.onSearch, key: 'enterButton' },
	                enterButton === true ? React.createElement(_icon2['default'], { type: 'search' }) : enterButton
	            ) : React.createElement(_icon2['default'], { className: prefixCls + '-icon', type: 'search', key: 'searchIcon' });
	            var searchSuffix = suffix ? [suffix, buttonOrIcon] : buttonOrIcon;
	            var inputClassName = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-enter-button', !!enterButton), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, !!size), _classNames));
	            return React.createElement(_Input2['default'], (0, _extends3['default'])({ onPressEnter: this.onSearch }, others, { size: size, className: inputClassName, prefixCls: inputPrefixCls, suffix: searchSuffix, ref: this.saveInput }));
	        }
	    }]);
	    return Search;
	}(React.Component);
	
	exports['default'] = Search;
	
	Search.defaultProps = {
	    inputPrefixCls: 'ant-input',
	    prefixCls: 'ant-input-search',
	    enterButton: false
	};

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _calculateNodeHeight = __webpack_require__(1472);
	
	var _calculateNodeHeight2 = _interopRequireDefault(_calculateNodeHeight);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function onNextFrame(cb) {
	    if (window.requestAnimationFrame) {
	        return window.requestAnimationFrame(cb);
	    }
	    return window.setTimeout(cb, 1);
	}
	function clearNextFrameAction(nextFrameId) {
	    if (window.cancelAnimationFrame) {
	        window.cancelAnimationFrame(nextFrameId);
	    } else {
	        window.clearTimeout(nextFrameId);
	    }
	}
	
	var TextArea = function (_React$Component) {
	    (0, _inherits3['default'])(TextArea, _React$Component);
	
	    function TextArea() {
	        (0, _classCallCheck3['default'])(this, TextArea);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));
	
	        _this.state = {
	            textareaStyles: {}
	        };
	        _this.resizeTextarea = function () {
	            var autosize = _this.props.autosize;
	
	            if (!autosize || !_this.textAreaRef) {
	                return;
	            }
	            var minRows = autosize ? autosize.minRows : null;
	            var maxRows = autosize ? autosize.maxRows : null;
	            var textareaStyles = (0, _calculateNodeHeight2['default'])(_this.textAreaRef, false, minRows, maxRows);
	            _this.setState({ textareaStyles: textareaStyles });
	        };
	        _this.handleTextareaChange = function (e) {
	            if (!('value' in _this.props)) {
	                _this.resizeTextarea();
	            }
	            var onChange = _this.props.onChange;
	
	            if (onChange) {
	                onChange(e);
	            }
	        };
	        _this.handleKeyDown = function (e) {
	            var _this$props = _this.props,
	                onPressEnter = _this$props.onPressEnter,
	                onKeyDown = _this$props.onKeyDown;
	
	            if (e.keyCode === 13 && onPressEnter) {
	                onPressEnter(e);
	            }
	            if (onKeyDown) {
	                onKeyDown(e);
	            }
	        };
	        _this.saveTextAreaRef = function (textArea) {
	            _this.textAreaRef = textArea;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(TextArea, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.resizeTextarea();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            // Re-render with the new content then recalculate the height as required.
	            if (this.props.value !== nextProps.value) {
	                if (this.nextFrameActionId) {
	                    clearNextFrameAction(this.nextFrameActionId);
	                }
	                this.nextFrameActionId = onNextFrame(this.resizeTextarea);
	            }
	        }
	    }, {
	        key: 'focus',
	        value: function focus() {
	            this.textAreaRef.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.textAreaRef.blur();
	        }
	    }, {
	        key: 'getTextAreaClassName',
	        value: function getTextAreaClassName() {
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                className = _props.className,
	                disabled = _props.disabled;
	
	            return (0, _classnames2['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-disabled', disabled));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var otherProps = (0, _omit2['default'])(props, ['prefixCls', 'onPressEnter', 'autosize']);
	            var style = (0, _extends3['default'])({}, props.style, this.state.textareaStyles);
	            // Fix https://github.com/ant-design/ant-design/issues/6776
	            // Make sure it could be reset when using form.getFieldDecorator
	            if ('value' in otherProps) {
	                otherProps.value = otherProps.value || '';
	            }
	            return React.createElement('textarea', (0, _extends3['default'])({}, otherProps, { className: this.getTextAreaClassName(), style: style, onKeyDown: this.handleKeyDown, onChange: this.handleTextareaChange, ref: this.saveTextAreaRef }));
	        }
	    }]);
	    return TextArea;
	}(React.Component);
	
	exports['default'] = TextArea;
	
	TextArea.defaultProps = {
	    prefixCls: 'ant-input'
	};

/***/ },
/* 1472 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports['default'] = calculateNodeHeight;
	// Thanks to https://github.com/andreypopp/react-textarea-autosize/
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var HIDDEN_TEXTAREA_STYLE = '\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea = void 0;
	function calculateNodeStyling(node) {
	    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	    if (useCache && computedStyleCache[nodeRef]) {
	        return computedStyleCache[nodeRef];
	    }
	    var style = window.getComputedStyle(node);
	    var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	    var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	    var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	    var sizingStyle = SIZING_STYLE.map(function (name) {
	        return name + ':' + style.getPropertyValue(name);
	    }).join(';');
	    var nodeInfo = {
	        sizingStyle: sizingStyle,
	        paddingSize: paddingSize,
	        borderSize: borderSize,
	        boxSizing: boxSizing
	    };
	    if (useCache && nodeRef) {
	        computedStyleCache[nodeRef] = nodeInfo;
	    }
	    return nodeInfo;
	}
	function calculateNodeHeight(uiTextNode) {
	    var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	    var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	    if (!hiddenTextarea) {
	        hiddenTextarea = document.createElement('textarea');
	        document.body.appendChild(hiddenTextarea);
	    }
	    // Fix wrap="off" issue
	    // https://github.com/ant-design/ant-design/issues/6577
	    if (uiTextNode.getAttribute('wrap')) {
	        hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
	    } else {
	        hiddenTextarea.removeAttribute('wrap');
	    }
	    // Copy all CSS properties that have an impact on the height of the content in
	    // the textbox
	
	    var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	        paddingSize = _calculateNodeStyling.paddingSize,
	        borderSize = _calculateNodeStyling.borderSize,
	        boxSizing = _calculateNodeStyling.boxSizing,
	        sizingStyle = _calculateNodeStyling.sizingStyle;
	    // Need to have the overflow attribute to hide the scrollbar otherwise
	    // text-lines will not calculated properly as the shadow will technically be
	    // narrower for content
	
	
	    hiddenTextarea.setAttribute('style', sizingStyle + ';' + HIDDEN_TEXTAREA_STYLE);
	    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	    var minHeight = Number.MIN_SAFE_INTEGER;
	    var maxHeight = Number.MAX_SAFE_INTEGER;
	    var height = hiddenTextarea.scrollHeight;
	    var overflowY = void 0;
	    if (boxSizing === 'border-box') {
	        // border-box: add border, since height = content + padding + border
	        height = height + borderSize;
	    } else if (boxSizing === 'content-box') {
	        // remove padding, since height = content
	        height = height - paddingSize;
	    }
	    if (minRows !== null || maxRows !== null) {
	        // measure height of a textarea with a single row
	        hiddenTextarea.value = '';
	        var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	        if (minRows !== null) {
	            minHeight = singleRowHeight * minRows;
	            if (boxSizing === 'border-box') {
	                minHeight = minHeight + paddingSize + borderSize;
	            }
	            height = Math.max(minHeight, height);
	        }
	        if (maxRows !== null) {
	            maxHeight = singleRowHeight * maxRows;
	            if (boxSizing === 'border-box') {
	                maxHeight = maxHeight + paddingSize + borderSize;
	            }
	            overflowY = height > maxHeight ? '' : 'hidden';
	            height = Math.min(maxHeight, height);
	        }
	    }
	    // Remove scroll bar flash when autosize without maxRows
	    if (!maxRows) {
	        overflowY = 'hidden';
	    }
	    return { height: height, minHeight: minHeight, maxHeight: maxHeight, overflowY: overflowY };
	}

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	if (typeof window !== 'undefined') {
	    var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	        return {
	            media: mediaQuery,
	            matches: false,
	            addListener: function addListener() {},
	            removeListener: function removeListener() {}
	        };
	    };
	    window.matchMedia = window.matchMedia || matchMediaPolyfill;
	}
	
	var dimensionMap = {
	    xs: '480px',
	    sm: '576px',
	    md: '768px',
	    lg: '992px',
	    xl: '1200px',
	    xxl: '1600px'
	};
	var generateId = function () {
	    var i = 0;
	    return function () {
	        var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	        i += 1;
	        return '' + prefix + i;
	    };
	}();
	
	var Sider = function (_React$Component) {
	    (0, _inherits3['default'])(Sider, _React$Component);
	
	    function Sider(props) {
	        (0, _classCallCheck3['default'])(this, Sider);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Sider.__proto__ || Object.getPrototypeOf(Sider)).call(this, props));
	
	        _this.responsiveHandler = function (mql) {
	            _this.setState({ below: mql.matches });
	            if (_this.state.collapsed !== mql.matches) {
	                _this.setCollapsed(mql.matches, 'responsive');
	            }
	        };
	        _this.setCollapsed = function (collapsed, type) {
	            if (!('collapsed' in _this.props)) {
	                _this.setState({
	                    collapsed: collapsed
	                });
	            }
	            var onCollapse = _this.props.onCollapse;
	
	            if (onCollapse) {
	                onCollapse(collapsed, type);
	            }
	        };
	        _this.toggle = function () {
	            var collapsed = !_this.state.collapsed;
	            _this.setCollapsed(collapsed, 'clickTrigger');
	        };
	        _this.belowShowChange = function () {
	            _this.setState({ belowShow: !_this.state.belowShow });
	        };
	        _this.uniqueId = generateId('ant-sider-');
	        var matchMedia = void 0;
	        if (typeof window !== 'undefined') {
	            matchMedia = window.matchMedia;
	        }
	        if (matchMedia && props.breakpoint && props.breakpoint in dimensionMap) {
	            _this.mql = matchMedia('(max-width: ' + dimensionMap[props.breakpoint] + ')');
	        }
	        var collapsed = void 0;
	        if ('collapsed' in props) {
	            collapsed = props.collapsed;
	        } else {
	            collapsed = props.defaultCollapsed;
	        }
	        _this.state = {
	            collapsed: collapsed,
	            below: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Sider, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                siderCollapsed: this.state.collapsed,
	                collapsedWidth: this.props.collapsedWidth
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('collapsed' in nextProps) {
	                this.setState({
	                    collapsed: nextProps.collapsed
	                });
	            }
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.mql) {
	                this.mql.addListener(this.responsiveHandler);
	                this.responsiveHandler(this.mql);
	            }
	            if (this.context.siderHook) {
	                this.context.siderHook.addSider(this.uniqueId);
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.mql) {
	                this.mql.removeListener(this.responsiveHandler);
	            }
	            if (this.context.siderHook) {
	                this.context.siderHook.removeSider(this.uniqueId);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                className = _a.className,
	                collapsible = _a.collapsible,
	                reverseArrow = _a.reverseArrow,
	                trigger = _a.trigger,
	                style = _a.style,
	                width = _a.width,
	                collapsedWidth = _a.collapsedWidth,
	                others = __rest(_a, ["prefixCls", "className", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth"]);
	            var divProps = (0, _omit2['default'])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint']);
	            var siderWidth = this.state.collapsed ? collapsedWidth : width;
	            // special trigger when collapsedWidth == 0
	            var zeroWidthTrigger = collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px' ? React.createElement(
	                'span',
	                { onClick: this.toggle, className: prefixCls + '-zero-width-trigger' },
	                React.createElement(_icon2['default'], { type: 'bars' })
	            ) : null;
	            var iconObj = {
	                'expanded': reverseArrow ? React.createElement(_icon2['default'], { type: 'right' }) : React.createElement(_icon2['default'], { type: 'left' }),
	                'collapsed': reverseArrow ? React.createElement(_icon2['default'], { type: 'left' }) : React.createElement(_icon2['default'], { type: 'right' })
	            };
	            var status = this.state.collapsed ? 'collapsed' : 'expanded';
	            var defaultTrigger = iconObj[status];
	            var triggerDom = trigger !== null ? zeroWidthTrigger || React.createElement(
	                'div',
	                { className: prefixCls + '-trigger', onClick: this.toggle, style: { width: siderWidth } },
	                trigger || defaultTrigger
	            ) : null;
	            var divStyle = (0, _extends3['default'])({}, style, { flex: '0 0 ' + siderWidth + 'px', maxWidth: siderWidth + 'px', minWidth: siderWidth + 'px', width: siderWidth + 'px' });
	            var siderCls = (0, _classnames2['default'])(className, prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-collapsed', !!this.state.collapsed), (0, _defineProperty3['default'])(_classNames, prefixCls + '-has-trigger', !!trigger), (0, _defineProperty3['default'])(_classNames, prefixCls + '-below', !!this.state.below), (0, _defineProperty3['default'])(_classNames, prefixCls + '-zero-width', siderWidth === 0 || siderWidth === '0' || siderWidth === '0px'), _classNames));
	            return React.createElement(
	                'div',
	                (0, _extends3['default'])({ className: siderCls }, divProps, { style: divStyle }),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-children' },
	                    this.props.children
	                ),
	                collapsible || this.state.below && zeroWidthTrigger ? triggerDom : null
	            );
	        }
	    }]);
	    return Sider;
	}(React.Component);
	
	exports['default'] = Sider;
	
	Sider.__ANT_LAYOUT_SIDER = true;
	Sider.defaultProps = {
	    prefixCls: 'ant-layout-sider',
	    collapsible: false,
	    defaultCollapsed: false,
	    reverseArrow: false,
	    width: 200,
	    collapsedWidth: 80,
	    style: {}
	};
	Sider.childContextTypes = {
	    siderCollapsed: _propTypes2['default'].bool,
	    collapsedWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string])
	};
	Sider.contextTypes = {
	    siderHook: _propTypes2['default'].object
	};

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _layout = __webpack_require__(1475);
	
	var _layout2 = _interopRequireDefault(_layout);
	
	var _Sider = __webpack_require__(1473);
	
	var _Sider2 = _interopRequireDefault(_Sider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_layout2['default'].Sider = _Sider2['default'];
	exports['default'] = _layout2['default'];

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _toConsumableArray2 = __webpack_require__(176);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	function generator(props) {
	    return function (BasicComponent) {
	        return function (_React$Component) {
	            (0, _inherits3['default'])(Adapter, _React$Component);
	
	            function Adapter() {
	                (0, _classCallCheck3['default'])(this, Adapter);
	                return (0, _possibleConstructorReturn3['default'])(this, (Adapter.__proto__ || Object.getPrototypeOf(Adapter)).apply(this, arguments));
	            }
	
	            (0, _createClass3['default'])(Adapter, [{
	                key: 'render',
	                value: function render() {
	                    var prefixCls = props.prefixCls;
	
	                    return React.createElement(BasicComponent, (0, _extends3['default'])({ prefixCls: prefixCls }, this.props));
	                }
	            }]);
	            return Adapter;
	        }(React.Component);
	    };
	}
	
	var Basic = function (_React$Component2) {
	    (0, _inherits3['default'])(Basic, _React$Component2);
	
	    function Basic() {
	        (0, _classCallCheck3['default'])(this, Basic);
	        return (0, _possibleConstructorReturn3['default'])(this, (Basic.__proto__ || Object.getPrototypeOf(Basic)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Basic, [{
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                className = _a.className,
	                children = _a.children,
	                others = __rest(_a, ["prefixCls", "className", "children"]);
	            var divCls = (0, _classnames2['default'])(className, prefixCls);
	            return React.createElement(
	                'div',
	                (0, _extends3['default'])({ className: divCls }, others),
	                children
	            );
	        }
	    }]);
	    return Basic;
	}(React.Component);
	
	var BasicLayout = function (_React$Component3) {
	    (0, _inherits3['default'])(BasicLayout, _React$Component3);
	
	    function BasicLayout() {
	        (0, _classCallCheck3['default'])(this, BasicLayout);
	
	        var _this3 = (0, _possibleConstructorReturn3['default'])(this, (BasicLayout.__proto__ || Object.getPrototypeOf(BasicLayout)).apply(this, arguments));
	
	        _this3.state = { siders: [] };
	        return _this3;
	    }
	
	    (0, _createClass3['default'])(BasicLayout, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            var _this4 = this;
	
	            return {
	                siderHook: {
	                    addSider: function addSider(id) {
	                        _this4.setState({
	                            siders: [].concat((0, _toConsumableArray3['default'])(_this4.state.siders), [id])
	                        });
	                    },
	                    removeSider: function removeSider(id) {
	                        _this4.setState({
	                            siders: _this4.state.siders.filter(function (currentId) {
	                                return currentId !== id;
	                            })
	                        });
	                    }
	                }
	            };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                className = _a.className,
	                children = _a.children,
	                others = __rest(_a, ["prefixCls", "className", "children"]);
	            var divCls = (0, _classnames2['default'])(className, prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-has-sider', this.state.siders.length > 0));
	            return React.createElement(
	                'div',
	                (0, _extends3['default'])({ className: divCls }, others),
	                children
	            );
	        }
	    }]);
	    return BasicLayout;
	}(React.Component);
	
	BasicLayout.childContextTypes = {
	    siderHook: _propTypes2['default'].object
	};
	var Layout = generator({
	    prefixCls: 'ant-layout'
	})(BasicLayout);
	var Header = generator({
	    prefixCls: 'ant-layout-header'
	})(Basic);
	var Footer = generator({
	    prefixCls: 'ant-layout-footer'
	})(Basic);
	var Content = generator({
	    prefixCls: 'ant-layout-content'
	})(Basic);
	Layout.Header = Header;
	Layout.Footer = Footer;
	Layout.Content = Content;
	exports['default'] = Layout;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.Meta = undefined;
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _grid = __webpack_require__(270);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	var Meta = exports.Meta = function Meta(props) {
	    var _props$prefixCls = props.prefixCls,
	        prefixCls = _props$prefixCls === undefined ? 'ant-list' : _props$prefixCls,
	        className = props.className,
	        avatar = props.avatar,
	        title = props.title,
	        description = props.description,
	        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	    var classString = (0, _classnames2['default'])(prefixCls + '-item-meta', className);
	    var content = React.createElement(
	        'div',
	        { className: prefixCls + '-item-meta-content' },
	        title && React.createElement(
	            'h4',
	            { className: prefixCls + '-item-meta-title' },
	            title
	        ),
	        description && React.createElement(
	            'div',
	            { className: prefixCls + '-item-meta-description' },
	            description
	        )
	    );
	    return React.createElement(
	        'div',
	        (0, _extends3['default'])({}, others, { className: classString }),
	        avatar && React.createElement(
	            'div',
	            { className: prefixCls + '-item-meta-avatar' },
	            avatar
	        ),
	        (title || description) && content
	    );
	};
	function getGrid(grid, t) {
	    return grid[t] && Math.floor(24 / grid[t]);
	}
	var GridColumns = ['', 1, 2, 3, 4, 6, 8, 12, 24];
	
	var Item = function (_React$Component) {
	    (0, _inherits3['default'])(Item, _React$Component);
	
	    function Item() {
	        (0, _classCallCheck3['default'])(this, Item);
	        return (0, _possibleConstructorReturn3['default'])(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Item, [{
	        key: 'render',
	        value: function render() {
	            var grid = this.context.grid;
	            var _a = this.props,
	                _a$prefixCls = _a.prefixCls,
	                prefixCls = _a$prefixCls === undefined ? 'ant-list' : _a$prefixCls,
	                children = _a.children,
	                actions = _a.actions,
	                extra = _a.extra,
	                className = _a.className,
	                others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);
	            var classString = (0, _classnames2['default'])(prefixCls + '-item', className);
	            var metaContent = [];
	            var otherContent = [];
	            React.Children.forEach(children, function (element) {
	                if (element && element.type && element.type === Meta) {
	                    metaContent.push(element);
	                } else {
	                    otherContent.push(element);
	                }
	            });
	            var contentClassString = (0, _classnames2['default'])(prefixCls + '-item-content', (0, _defineProperty3['default'])({}, prefixCls + '-item-content-single', metaContent.length < 1));
	            var content = otherContent.length > 0 ? React.createElement(
	                'div',
	                { className: contentClassString },
	                otherContent
	            ) : null;
	            var actionsContent = void 0;
	            if (actions && actions.length > 0) {
	                var actionsContentItem = function actionsContentItem(action, i) {
	                    return React.createElement(
	                        'li',
	                        { key: prefixCls + '-item-action-' + i },
	                        action,
	                        i !== actions.length - 1 && React.createElement('em', { className: prefixCls + '-item-action-split' })
	                    );
	                };
	                actionsContent = React.createElement(
	                    'ul',
	                    { className: prefixCls + '-item-action' },
	                    actions.map(function (action, i) {
	                        return actionsContentItem(action, i);
	                    })
	                );
	            }
	            var extraContent = React.createElement(
	                'div',
	                { className: prefixCls + '-item-extra-wrap' },
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-item-main' },
	                    metaContent,
	                    content,
	                    actionsContent
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-item-extra' },
	                    extra
	                )
	            );
	            var mainContent = grid ? React.createElement(
	                _grid.Col,
	                { span: getGrid(grid, 'column'), xs: getGrid(grid, 'xs'), sm: getGrid(grid, 'sm'), md: getGrid(grid, 'md'), lg: getGrid(grid, 'lg'), xl: getGrid(grid, 'xl'), xxl: getGrid(grid, 'xxl') },
	                React.createElement(
	                    'div',
	                    (0, _extends3['default'])({}, others, { className: classString }),
	                    extra && extraContent,
	                    !extra && metaContent,
	                    !extra && content,
	                    !extra && actionsContent
	                )
	            ) : React.createElement(
	                'div',
	                (0, _extends3['default'])({}, others, { className: classString }),
	                extra && extraContent,
	                !extra && metaContent,
	                !extra && content,
	                !extra && actionsContent
	            );
	            return mainContent;
	        }
	    }]);
	    return Item;
	}(React.Component);
	
	exports['default'] = Item;
	
	Item.Meta = Meta;
	Item.propTypes = {
	    column: _propTypes2['default'].oneOf(GridColumns),
	    xs: _propTypes2['default'].oneOf(GridColumns),
	    sm: _propTypes2['default'].oneOf(GridColumns),
	    md: _propTypes2['default'].oneOf(GridColumns),
	    lg: _propTypes2['default'].oneOf(GridColumns),
	    xl: _propTypes2['default'].oneOf(GridColumns),
	    xxl: _propTypes2['default'].oneOf(GridColumns)
	};
	Item.contextTypes = {
	    grid: _propTypes2['default'].any
	};

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _spin = __webpack_require__(386);
	
	var _spin2 = _interopRequireDefault(_spin);
	
	var _pagination = __webpack_require__(384);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _grid = __webpack_require__(270);
	
	var _Item = __webpack_require__(1476);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var List = function (_React$Component) {
	    (0, _inherits3['default'])(List, _React$Component);
	
	    function List() {
	        (0, _classCallCheck3['default'])(this, List);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
	
	        _this.keys = {};
	        _this.renderItem = function (item, index) {
	            var _this$props = _this.props,
	                dataSource = _this$props.dataSource,
	                renderItem = _this$props.renderItem,
	                rowKey = _this$props.rowKey;
	
	            var key = void 0;
	            if (typeof rowKey === 'function') {
	                key = rowKey(dataSource[index]);
	            } else if (typeof rowKey === 'string') {
	                key = dataSource[rowKey];
	            } else {
	                key = dataSource.key;
	            }
	            if (!key) {
	                key = 'list-item-' + index;
	            }
	            _this.keys[index] = key;
	            return renderItem(item, index);
	        };
	        _this.renderEmpty = function (contextLocale) {
	            var locale = (0, _extends3['default'])({}, contextLocale, _this.props.locale);
	            return React.createElement(
	                'div',
	                { className: _this.props.prefixCls + '-empty-text' },
	                locale.emptyText
	            );
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(List, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                grid: this.props.grid
	            };
	        }
	    }, {
	        key: 'isSomethingAfterLastTtem',
	        value: function isSomethingAfterLastTtem() {
	            var _props = this.props,
	                loadMore = _props.loadMore,
	                pagination = _props.pagination,
	                footer = _props.footer;
	
	            return !!(loadMore || pagination || footer);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames,
	                _this2 = this;
	
	            var _a = this.props,
	                bordered = _a.bordered,
	                split = _a.split,
	                className = _a.className,
	                children = _a.children,
	                itemLayout = _a.itemLayout,
	                loadMore = _a.loadMore,
	                pagination = _a.pagination,
	                prefixCls = _a.prefixCls,
	                grid = _a.grid,
	                dataSource = _a.dataSource,
	                size = _a.size,
	                rowKey = _a.rowKey,
	                renderItem = _a.renderItem,
	                header = _a.header,
	                footer = _a.footer,
	                loading = _a.loading,
	                rest = __rest(_a, ["bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "prefixCls", "grid", "dataSource", "size", "rowKey", "renderItem", "header", "footer", "loading"]);
	            var loadingProp = loading;
	            if (typeof loadingProp === 'boolean') {
	                loadingProp = {
	                    spinning: loadingProp
	                };
	            }
	            var isLoading = loadingProp && loadingProp.spinning;
	            // large => lg
	            // small => sm
	            var sizeCls = '';
	            switch (size) {
	                case 'large':
	                    sizeCls = 'lg';
	                    break;
	                case 'small':
	                    sizeCls = 'sm';
	                default:
	                    break;
	            }
	            var classString = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', itemLayout === 'vertical'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + sizeCls, sizeCls), (0, _defineProperty3['default'])(_classNames, prefixCls + '-split', split), (0, _defineProperty3['default'])(_classNames, prefixCls + '-bordered', bordered), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', isLoading), (0, _defineProperty3['default'])(_classNames, prefixCls + '-grid', grid), (0, _defineProperty3['default'])(_classNames, prefixCls + '-something-after-last-item', this.isSomethingAfterLastTtem()), _classNames));
	            var paginationContent = React.createElement(
	                'div',
	                { className: prefixCls + '-pagination' },
	                React.createElement(_pagination2['default'], pagination)
	            );
	            var childrenContent = void 0;
	            childrenContent = isLoading && React.createElement('div', { style: { minHeight: 53 } });
	            if (dataSource.length > 0) {
	                var items = dataSource.map(function (item, index) {
	                    return _this2.renderItem(item, index);
	                });
	                var childrenList = React.Children.map(items, function (child, index) {
	                    return React.cloneElement(child, {
	                        key: _this2.keys[index]
	                    });
	                });
	                childrenContent = grid ? React.createElement(
	                    _grid.Row,
	                    { gutter: grid.gutter },
	                    childrenList
	                ) : childrenList;
	            } else if (!children && !isLoading) {
	                childrenContent = React.createElement(
	                    _LocaleReceiver2['default'],
	                    { componentName: 'Table', defaultLocale: _default2['default'].Table },
	                    this.renderEmpty
	                );
	            }
	            var content = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    _spin2['default'],
	                    loadingProp,
	                    childrenContent
	                ),
	                loadMore,
	                !loadMore && pagination ? paginationContent : null
	            );
	            return React.createElement(
	                'div',
	                (0, _extends3['default'])({ className: classString }, rest),
	                header && React.createElement(
	                    'div',
	                    { className: prefixCls + '-header' },
	                    header
	                ),
	                content,
	                children,
	                footer && React.createElement(
	                    'div',
	                    { className: prefixCls + '-footer' },
	                    footer
	                )
	            );
	        }
	    }]);
	    return List;
	}(React.Component);
	
	exports['default'] = List;
	
	List.Item = _Item2['default'];
	List.childContextTypes = {
	    grid: _propTypes2['default'].any
	};
	List.defaultProps = {
	    dataSource: [],
	    prefixCls: 'ant-list',
	    bordered: false,
	    split: true,
	    loading: false,
	    pagination: false
	};

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ca_ES = __webpack_require__(2560);
	
	var _ca_ES2 = _interopRequireDefault(_ca_ES);
	
	var _ca_ES3 = __webpack_require__(586);
	
	var _ca_ES4 = _interopRequireDefault(_ca_ES3);
	
	var _ca_ES5 = __webpack_require__(600);
	
	var _ca_ES6 = _interopRequireDefault(_ca_ES5);
	
	var _ca_ES7 = __webpack_require__(1445);
	
	var _ca_ES8 = _interopRequireDefault(_ca_ES7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	    locale: 'ca',
	    Pagination: _ca_ES2['default'],
	    DatePicker: _ca_ES4['default'],
	    TimePicker: _ca_ES6['default'],
	    Calendar: _ca_ES8['default'],
	    Table: {
	        filterTitle: 'Filtrar Menu',
	        filterConfirm: 'OK',
	        filterReset: 'Restablir',
	        emptyText: 'Sense dades'
	    },
	    Modal: {
	        okText: 'OK',
	        cancelText: 'Cancel·lar',
	        justOkText: 'OK'
	    },
	    Popconfirm: {
	        okText: 'OK',
	        cancelText: 'Cancel·lar'
	    },
	    Transfer: {
	        notFoundContent: 'No trobat',
	        searchPlaceholder: 'Cercar aquí',
	        itemUnit: 'item',
	        itemsUnit: 'items'
	    },
	    Select: {
	        notFoundContent: 'No trobat'
	    }
	};

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _fr_FR = __webpack_require__(2561);
	
	var _fr_FR2 = _interopRequireDefault(_fr_FR);
	
	var _fr_FR3 = __webpack_require__(587);
	
	var _fr_FR4 = _interopRequireDefault(_fr_FR3);
	
	var _fr_FR5 = __webpack_require__(601);
	
	var _fr_FR6 = _interopRequireDefault(_fr_FR5);
	
	var _fr_FR7 = __webpack_require__(1446);
	
	var _fr_FR8 = _interopRequireDefault(_fr_FR7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	    locale: 'fr',
	    Pagination: _fr_FR2['default'],
	    DatePicker: _fr_FR4['default'],
	    TimePicker: _fr_FR6['default'],
	    Calendar: _fr_FR8['default'],
	    Table: {
	        filterTitle: 'Filtrer',
	        filterConfirm: 'OK',
	        filterReset: 'Réinitialiser',
	        emptyText: 'Aucune donnée'
	    },
	    Modal: {
	        okText: 'OK',
	        cancelText: 'Annuler',
	        justOkText: 'OK'
	    },
	    Popconfirm: {
	        okText: 'OK',
	        cancelText: 'Annuler'
	    },
	    Transfer: {
	        notFoundContent: 'Pas de résultat',
	        searchPlaceholder: 'Recherche',
	        itemUnit: 'élément',
	        itemsUnit: 'éléments'
	    },
	    Select: {
	        notFoundContent: 'Pas de résultat'
	    }
	};

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(9);
	
	var moment = _interopRequireWildcard(_moment);
	
	var _locale = __webpack_require__(383);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function setMomentLocale(locale) {
	    if (locale && locale.locale) {
	        moment.locale(locale.locale);
	    } else {
	        moment.locale('en');
	    }
	}
	
	var LocaleProvider = function (_React$Component) {
	    (0, _inherits3['default'])(LocaleProvider, _React$Component);
	
	    function LocaleProvider() {
	        (0, _classCallCheck3['default'])(this, LocaleProvider);
	        return (0, _possibleConstructorReturn3['default'])(this, (LocaleProvider.__proto__ || Object.getPrototypeOf(LocaleProvider)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(LocaleProvider, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                antLocale: (0, _extends3['default'])({}, this.props.locale, { exist: true })
	            };
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            setMomentLocale(this.props.locale);
	            this.componentDidUpdate();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var locale = this.props.locale;
	
	            var nextLocale = nextProps.locale;
	            if (locale !== nextLocale) {
	                setMomentLocale(nextProps.locale);
	            }
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var locale = this.props.locale;
	
	            (0, _locale.changeConfirmLocale)(locale && locale.Modal);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            (0, _locale.changeConfirmLocale)();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.Children.only(this.props.children);
	        }
	    }]);
	    return LocaleProvider;
	}(React.Component);
	
	exports['default'] = LocaleProvider;
	
	LocaleProvider.propTypes = {
	    locale: _propTypes2['default'].object
	};
	LocaleProvider.defaultProps = {
	    locale: {}
	};
	LocaleProvider.childContextTypes = {
	    antLocale: _propTypes2['default'].object
	};

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _it_IT = __webpack_require__(2562);
	
	var _it_IT2 = _interopRequireDefault(_it_IT);
	
	var _it_IT3 = __webpack_require__(588);
	
	var _it_IT4 = _interopRequireDefault(_it_IT3);
	
	var _it_IT5 = __webpack_require__(602);
	
	var _it_IT6 = _interopRequireDefault(_it_IT5);
	
	var _it_IT7 = __webpack_require__(1447);
	
	var _it_IT8 = _interopRequireDefault(_it_IT7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	    locale: 'it',
	    Pagination: _it_IT2['default'],
	    DatePicker: _it_IT4['default'],
	    TimePicker: _it_IT6['default'],
	    Calendar: _it_IT8['default'],
	    Table: {
	        filterTitle: 'Menu Filtro',
	        filterConfirm: 'OK',
	        filterReset: 'Reset',
	        emptyText: 'Nessun dato',
	        selectAll: 'Seleziona pagina corrente',
	        selectInvert: 'Selezionare Inverti'
	    },
	    Modal: {
	        okText: 'OK',
	        cancelText: 'Annulla',
	        justOkText: 'OK'
	    },
	    Popconfirm: {
	        okText: 'OK',
	        cancelText: 'Annulla'
	    },
	    Transfer: {
	        notFoundContent: 'Non trovato',
	        searchPlaceholder: 'Cerca qui',
	        itemUnit: 'articolo',
	        itemsUnit: 'elementi'
	    },
	    Select: {
	        notFoundContent: 'Non trovato'
	    },
	    Upload: {
	        uploading: 'Caricamento...',
	        removeFile: 'Rimuovi il file',
	        uploadError: 'Errore di caricamento',
	        previewFile: 'Anteprima file'
	    }
	};

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcEditorMention = __webpack_require__(2534);
	
	var _rcEditorMention2 = _interopRequireDefault(_rcEditorMention);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Mention = function (_React$Component) {
	    (0, _inherits3['default'])(Mention, _React$Component);
	
	    function Mention(props) {
	        (0, _classCallCheck3['default'])(this, Mention);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Mention.__proto__ || Object.getPrototypeOf(Mention)).call(this, props));
	
	        _this.onSearchChange = function (value, prefix) {
	            if (_this.props.onSearchChange) {
	                return _this.props.onSearchChange(value, prefix);
	            }
	            return _this.defaultSearchChange(value);
	        };
	        _this.onChange = function (editorState) {
	            if (_this.props.onChange) {
	                _this.props.onChange(editorState);
	            }
	        };
	        _this.onFocus = function (ev) {
	            _this.setState({
	                focus: true
	            });
	            if (_this.props.onFocus) {
	                _this.props.onFocus(ev);
	            }
	        };
	        _this.onBlur = function (ev) {
	            _this.setState({
	                focus: false
	            });
	            if (_this.props.onBlur) {
	                _this.props.onBlur(ev);
	            }
	        };
	        _this.focus = function () {
	            _this.mentionEle._editor.focus();
	        };
	        _this.mentionRef = function (ele) {
	            _this.mentionEle = ele;
	        };
	        _this.state = {
	            suggestions: props.suggestions,
	            focus: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Mention, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var suggestions = nextProps.suggestions;
	
	            if (!(0, _shallowequal2['default'])(suggestions, this.props.suggestions)) {
	                this.setState({
	                    suggestions: suggestions
	                });
	            }
	        }
	    }, {
	        key: 'defaultSearchChange',
	        value: function defaultSearchChange(value) {
	            var searchValue = value.toLowerCase();
	            var filteredSuggestions = (this.props.suggestions || []).filter(function (suggestion) {
	                if (suggestion.type && suggestion.type === _rcEditorMention.Nav) {
	                    return suggestion.props.value ? suggestion.props.value.toLowerCase().indexOf(searchValue) !== -1 : true;
	                }
	                return suggestion.toLowerCase().indexOf(searchValue) !== -1;
	            });
	            this.setState({
	                suggestions: filteredSuggestions
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                prefixCls = _props.prefixCls,
	                loading = _props.loading,
	                placement = _props.placement;
	            var _state = this.state,
	                suggestions = _state.suggestions,
	                focus = _state.focus;
	
	            var cls = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-active', focus), (0, _defineProperty3['default'])(_classNames, prefixCls + '-placement-top', placement === 'top'), _classNames));
	            var notFoundContent = loading ? React.createElement(_icon2['default'], { type: 'loading' }) : this.props.notFoundContent;
	            return React.createElement(_rcEditorMention2['default'], (0, _extends3['default'])({}, this.props, { className: cls, ref: this.mentionRef, onSearchChange: this.onSearchChange, onChange: this.onChange, onFocus: this.onFocus, onBlur: this.onBlur, suggestions: suggestions, notFoundContent: notFoundContent }));
	        }
	    }]);
	    return Mention;
	}(React.Component);
	
	exports['default'] = Mention;
	
	Mention.getMentions = _rcEditorMention.getMentions;
	Mention.defaultProps = {
	    prefixCls: 'ant-mention',
	    notFoundContent: '无匹配结果，轻敲空格完成输入',
	    loading: false,
	    multiLines: false,
	    placement: 'bottom'
	};
	Mention.Nav = _rcEditorMention.Nav;
	Mention.toString = _rcEditorMention.toString;
	Mention.toContentState = _rcEditorMention.toEditorState;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcMenu = __webpack_require__(191);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _tooltip = __webpack_require__(170);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MenuItem = function (_React$Component) {
	    (0, _inherits3['default'])(MenuItem, _React$Component);
	
	    function MenuItem() {
	        (0, _classCallCheck3['default'])(this, MenuItem);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).apply(this, arguments));
	
	        _this.onKeyDown = function (e) {
	            _this.menuItem.onKeyDown(e);
	        };
	        _this.saveMenuItem = function (menuItem) {
	            _this.menuItem = menuItem;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(MenuItem, [{
	        key: 'render',
	        value: function render() {
	            var inlineCollapsed = this.context.inlineCollapsed;
	
	            var props = this.props;
	            return React.createElement(
	                _tooltip2['default'],
	                { title: inlineCollapsed && props.level === 1 ? props.children : '', placement: 'right', overlayClassName: props.rootPrefixCls + '-inline-collapsed-tooltip' },
	                React.createElement(_rcMenu.Item, (0, _extends3['default'])({}, props, { ref: this.saveMenuItem }))
	            );
	        }
	    }]);
	    return MenuItem;
	}(React.Component);
	
	MenuItem.contextTypes = {
	    inlineCollapsed: _propTypes2['default'].bool
	};
	MenuItem.isMenuItem = 1;
	exports['default'] = MenuItem;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcMenu = __webpack_require__(191);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SubMenu = function (_React$Component) {
	    (0, _inherits3['default'])(SubMenu, _React$Component);
	
	    function SubMenu() {
	        (0, _classCallCheck3['default'])(this, SubMenu);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (SubMenu.__proto__ || Object.getPrototypeOf(SubMenu)).apply(this, arguments));
	
	        _this.onKeyDown = function (e) {
	            _this.subMenu.onKeyDown(e);
	        };
	        _this.saveSubMenu = function (subMenu) {
	            _this.subMenu = subMenu;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(SubMenu, [{
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                rootPrefixCls = _props.rootPrefixCls,
	                className = _props.className;
	
	            var theme = this.context.antdMenuTheme;
	            return React.createElement(_rcMenu.SubMenu, (0, _extends3['default'])({}, this.props, { ref: this.saveSubMenu, popupClassName: (0, _classnames2['default'])(rootPrefixCls + '-' + theme, className) }));
	        }
	    }]);
	    return SubMenu;
	}(React.Component);
	
	SubMenu.contextTypes = {
	    antdMenuTheme: _propTypes2['default'].string
	};
	exports['default'] = SubMenu;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcNotification = __webpack_require__(1168);
	
	var _rcNotification2 = _interopRequireDefault(_rcNotification);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var defaultDuration = 3;
	var defaultTop = void 0;
	var messageInstance = void 0;
	var key = 1;
	var prefixCls = 'ant-message';
	var getContainer = void 0;
	function getMessageInstance(callback) {
	    if (messageInstance) {
	        callback(messageInstance);
	        return;
	    }
	    _rcNotification2['default'].newInstance({
	        prefixCls: prefixCls,
	        transitionName: 'move-up',
	        style: { top: defaultTop },
	        getContainer: getContainer
	    }, function (instance) {
	        if (messageInstance) {
	            callback(messageInstance);
	            return;
	        }
	        messageInstance = instance;
	        callback(instance);
	    });
	}
	function notice(content) {
	    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDuration;
	    var type = arguments[2];
	    var onClose = arguments[3];
	
	    var iconType = {
	        info: 'info-circle',
	        success: 'check-circle',
	        error: 'cross-circle',
	        warning: 'exclamation-circle',
	        loading: 'loading'
	    }[type];
	    if (typeof duration === 'function') {
	        onClose = duration;
	        duration = defaultDuration;
	    }
	    var target = key++;
	    getMessageInstance(function (instance) {
	        instance.notice({
	            key: target,
	            duration: duration,
	            style: {},
	            content: React.createElement(
	                'div',
	                { className: prefixCls + '-custom-content ' + prefixCls + '-' + type },
	                React.createElement(_icon2['default'], { type: iconType }),
	                React.createElement(
	                    'span',
	                    null,
	                    content
	                )
	            ),
	            onClose: onClose
	        });
	    });
	    return function () {
	        if (messageInstance) {
	            messageInstance.removeNotice(target);
	        }
	    };
	}
	exports['default'] = {
	    info: function info(content, duration, onClose) {
	        return notice(content, duration, 'info', onClose);
	    },
	    success: function success(content, duration, onClose) {
	        return notice(content, duration, 'success', onClose);
	    },
	    error: function error(content, duration, onClose) {
	        return notice(content, duration, 'error', onClose);
	    },
	
	    // Departed usage, please use warning()
	    warn: function warn(content, duration, onClose) {
	        return notice(content, duration, 'warning', onClose);
	    },
	    warning: function warning(content, duration, onClose) {
	        return notice(content, duration, 'warning', onClose);
	    },
	    loading: function loading(content, duration, onClose) {
	        return notice(content, duration, 'loading', onClose);
	    },
	    config: function config(options) {
	        if (options.top !== undefined) {
	            defaultTop = options.top;
	            messageInstance = null; // delete messageInstance for new defaultTop
	        }
	        if (options.duration !== undefined) {
	            defaultDuration = options.duration;
	        }
	        if (options.prefixCls !== undefined) {
	            prefixCls = options.prefixCls;
	        }
	        if (options.getContainer !== undefined) {
	            getContainer = options.getContainer;
	        }
	    },
	    destroy: function destroy() {
	        if (messageInstance) {
	            messageInstance.destroy();
	            messageInstance = null;
	        }
	    }
	};

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _button = __webpack_require__(142);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ActionButton = function (_React$Component) {
	    (0, _inherits3['default'])(ActionButton, _React$Component);
	
	    function ActionButton(props) {
	        (0, _classCallCheck3['default'])(this, ActionButton);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (ActionButton.__proto__ || Object.getPrototypeOf(ActionButton)).call(this, props));
	
	        _this.onClick = function () {
	            var _this$props = _this.props,
	                actionFn = _this$props.actionFn,
	                closeModal = _this$props.closeModal;
	
	            if (actionFn) {
	                var ret = void 0;
	                if (actionFn.length) {
	                    ret = actionFn(closeModal);
	                } else {
	                    ret = actionFn();
	                    if (!ret) {
	                        closeModal();
	                    }
	                }
	                if (ret && ret.then) {
	                    _this.setState({ loading: true });
	                    ret.then(function () {
	                        // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
	                        // this.setState({ loading: false });
	                        closeModal.apply(undefined, arguments);
	                    }, function () {
	                        // See: https://github.com/ant-design/ant-design/issues/6183
	                        _this.setState({ loading: false });
	                    });
	                }
	            } else {
	                closeModal();
	            }
	        };
	        _this.state = {
	            loading: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(ActionButton, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            if (this.props.autoFocus) {
	                var $this = ReactDOM.findDOMNode(this);
	                this.timeoutId = setTimeout(function () {
	                    return $this.focus();
	                });
	            }
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.timeoutId);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                children = _props.children;
	
	            var loading = this.state.loading;
	            return React.createElement(
	                _button2['default'],
	                { type: type, onClick: this.onClick, loading: loading },
	                children
	            );
	        }
	    }]);
	    return ActionButton;
	}(React.Component);
	
	exports['default'] = ActionButton;

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports['default'] = confirm;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _Modal = __webpack_require__(596);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _ActionButton = __webpack_require__(1486);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	var _locale = __webpack_require__(383);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var IS_REACT_16 = !!ReactDOM.createPortal;
	var ConfirmDialog = function ConfirmDialog(props) {
	    var onCancel = props.onCancel,
	        onOk = props.onOk,
	        close = props.close,
	        zIndex = props.zIndex,
	        afterClose = props.afterClose,
	        visible = props.visible;
	
	    var iconType = props.iconType || 'question-circle';
	    var okType = props.okType || 'primary';
	    var prefixCls = props.prefixCls || 'ant-confirm';
	    // 默认为 true，保持向下兼容
	    var okCancel = 'okCancel' in props ? props.okCancel : true;
	    var width = props.width || 416;
	    var style = props.style || {};
	    // 默认为 false，保持旧版默认行为
	    var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
	    var runtimeLocale = (0, _locale.getConfirmLocale)();
	    var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
	    var cancelText = props.cancelText || runtimeLocale.cancelText;
	    var classString = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + props.type, props.className);
	    var cancelButton = okCancel && React.createElement(
	        _ActionButton2['default'],
	        { actionFn: onCancel, closeModal: close },
	        cancelText
	    );
	    return React.createElement(
	        _Modal2['default'],
	        { className: classString, onCancel: close.bind(undefined, { triggerCancel: true }), visible: visible, title: '', transitionName: 'zoom', footer: '', maskTransitionName: 'fade', maskClosable: maskClosable, style: style, width: width, zIndex: zIndex, afterClose: afterClose },
	        React.createElement(
	            'div',
	            { className: prefixCls + '-body-wrapper' },
	            React.createElement(
	                'div',
	                { className: prefixCls + '-body' },
	                React.createElement(_icon2['default'], { type: iconType }),
	                React.createElement(
	                    'span',
	                    { className: prefixCls + '-title' },
	                    props.title
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-content' },
	                    props.content
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: prefixCls + '-btns' },
	                cancelButton,
	                React.createElement(
	                    _ActionButton2['default'],
	                    { type: okType, actionFn: onOk, closeModal: close, autoFocus: true },
	                    okText
	                )
	            )
	        )
	    );
	};
	function confirm(config) {
	    var div = document.createElement('div');
	    document.body.appendChild(div);
	    function close() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        if (IS_REACT_16) {
	            render((0, _extends3['default'])({}, config, { close: close, visible: false, afterClose: destroy.bind.apply(destroy, [this].concat(args)) }));
	        } else {
	            destroy.apply(undefined, args);
	        }
	    }
	    function destroy() {
	        var unmountResult = ReactDOM.unmountComponentAtNode(div);
	        if (unmountResult && div.parentNode) {
	            div.parentNode.removeChild(div);
	        }
	
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        var triggerCancel = args && args.length && args.some(function (param) {
	            return param && param.triggerCancel;
	        });
	        if (config.onCancel && triggerCancel) {
	            config.onCancel.apply(config, args);
	        }
	    }
	    function render(props) {
	        ReactDOM.render(React.createElement(ConfirmDialog, props), div);
	    }
	    render((0, _extends3['default'])({}, config, { visible: true, close: close }));
	    return {
	        destroy: close
	    };
	}

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Modal = __webpack_require__(596);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _confirm = __webpack_require__(1487);
	
	var _confirm2 = _interopRequireDefault(_confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Modal2['default'].info = function (props) {
	    var config = (0, _extends3['default'])({ type: 'info', iconType: 'info-circle', okCancel: false }, props);
	    return (0, _confirm2['default'])(config);
	};
	_Modal2['default'].success = function (props) {
	    var config = (0, _extends3['default'])({ type: 'success', iconType: 'check-circle', okCancel: false }, props);
	    return (0, _confirm2['default'])(config);
	};
	_Modal2['default'].error = function (props) {
	    var config = (0, _extends3['default'])({ type: 'error', iconType: 'cross-circle', okCancel: false }, props);
	    return (0, _confirm2['default'])(config);
	};
	_Modal2['default'].warning = _Modal2['default'].warn = function (props) {
	    var config = (0, _extends3['default'])({ type: 'warning', iconType: 'exclamation-circle', okCancel: false }, props);
	    return (0, _confirm2['default'])(config);
	};
	_Modal2['default'].confirm = function (props) {
	    var config = (0, _extends3['default'])({ type: 'confirm', okCancel: true }, props);
	    return (0, _confirm2['default'])(config);
	};
	exports['default'] = _Modal2['default'];

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcNotification = __webpack_require__(1168);
	
	var _rcNotification2 = _interopRequireDefault(_rcNotification);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var notificationInstance = {};
	var defaultDuration = 4.5;
	var defaultTop = 24;
	var defaultBottom = 24;
	var defaultPlacement = 'topRight';
	var defaultGetContainer = void 0;
	function setNotificationConfig(options) {
	    var duration = options.duration,
	        placement = options.placement,
	        bottom = options.bottom,
	        top = options.top,
	        getContainer = options.getContainer;
	
	    if (duration !== undefined) {
	        defaultDuration = duration;
	    }
	    if (placement !== undefined) {
	        defaultPlacement = placement;
	    }
	    if (bottom !== undefined) {
	        defaultBottom = bottom;
	    }
	    if (top !== undefined) {
	        defaultTop = top;
	    }
	    if (getContainer !== undefined) {
	        defaultGetContainer = getContainer;
	    }
	}
	function getPlacementStyle(placement) {
	    var style = void 0;
	    switch (placement) {
	        case 'topLeft':
	            style = {
	                left: 0,
	                top: defaultTop,
	                bottom: 'auto'
	            };
	            break;
	        case 'topRight':
	            style = {
	                right: 0,
	                top: defaultTop,
	                bottom: 'auto'
	            };
	            break;
	        case 'bottomLeft':
	            style = {
	                left: 0,
	                top: 'auto',
	                bottom: defaultBottom
	            };
	            break;
	        default:
	            style = {
	                right: 0,
	                top: 'auto',
	                bottom: defaultBottom
	            };
	            break;
	    }
	    return style;
	}
	function getNotificationInstance(prefixCls, placement, callback) {
	    var cacheKey = prefixCls + '-' + placement;
	    if (notificationInstance[cacheKey]) {
	        callback(notificationInstance[cacheKey]);
	        return;
	    }
	    _rcNotification2['default'].newInstance({
	        prefixCls: prefixCls,
	        className: prefixCls + '-' + placement,
	        style: getPlacementStyle(placement),
	        getContainer: defaultGetContainer
	    }, function (notification) {
	        notificationInstance[cacheKey] = notification;
	        callback(notification);
	    });
	}
	var typeToIcon = {
	    success: 'check-circle-o',
	    info: 'info-circle-o',
	    error: 'cross-circle-o',
	    warning: 'exclamation-circle-o'
	};
	function notice(args) {
	    var outerPrefixCls = args.prefixCls || 'ant-notification';
	    var prefixCls = outerPrefixCls + '-notice';
	    var duration = args.duration === undefined ? defaultDuration : args.duration;
	    var iconNode = null;
	    if (args.icon) {
	        iconNode = React.createElement(
	            'span',
	            { className: prefixCls + '-icon' },
	            args.icon
	        );
	    } else if (args.type) {
	        var iconType = typeToIcon[args.type];
	        iconNode = React.createElement(_icon2['default'], { className: prefixCls + '-icon ' + prefixCls + '-icon-' + args.type, type: iconType });
	    }
	    var autoMarginTag = !args.description && iconNode ? React.createElement('span', { className: prefixCls + '-message-single-line-auto-margin' }) : null;
	    getNotificationInstance(outerPrefixCls, args.placement || defaultPlacement, function (notification) {
	        notification.notice({
	            content: React.createElement(
	                'div',
	                { className: iconNode ? prefixCls + '-with-icon' : '' },
	                iconNode,
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-message' },
	                    autoMarginTag,
	                    args.message
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-description' },
	                    args.description
	                ),
	                args.btn ? React.createElement(
	                    'span',
	                    { className: prefixCls + '-btn' },
	                    args.btn
	                ) : null
	            ),
	            duration: duration,
	            closable: true,
	            onClose: args.onClose,
	            key: args.key,
	            style: args.style || {},
	            className: args.className
	        });
	    });
	}
	var api = {
	    open: notice,
	    close: function close(key) {
	        Object.keys(notificationInstance).forEach(function (cacheKey) {
	            return notificationInstance[cacheKey].removeNotice(key);
	        });
	    },
	
	    config: setNotificationConfig,
	    destroy: function destroy() {
	        Object.keys(notificationInstance).forEach(function (cacheKey) {
	            notificationInstance[cacheKey].destroy();
	            delete notificationInstance[cacheKey];
	        });
	    }
	};
	['success', 'info', 'warning', 'error'].forEach(function (type) {
	    api[type] = function (args) {
	        return api.open((0, _extends3['default'])({}, args, { type: type }));
	    };
	});
	api.warn = api.warning;
	exports['default'] = api;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _select = __webpack_require__(211);
	
	var _select2 = _interopRequireDefault(_select);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MiniSelect = function (_React$Component) {
	    (0, _inherits3['default'])(MiniSelect, _React$Component);
	
	    function MiniSelect() {
	        (0, _classCallCheck3['default'])(this, MiniSelect);
	        return (0, _possibleConstructorReturn3['default'])(this, (MiniSelect.__proto__ || Object.getPrototypeOf(MiniSelect)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(MiniSelect, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(_select2['default'], (0, _extends3['default'])({ size: 'small' }, this.props));
	        }
	    }]);
	    return MiniSelect;
	}(React.Component);
	
	exports['default'] = MiniSelect;
	
	MiniSelect.Option = _select2['default'].Option;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcPagination = __webpack_require__(2559);
	
	var _rcPagination2 = _interopRequireDefault(_rcPagination);
	
	var _en_US = __webpack_require__(1170);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _select = __webpack_require__(211);
	
	var _select2 = _interopRequireDefault(_select);
	
	var _MiniSelect = __webpack_require__(1490);
	
	var _MiniSelect2 = _interopRequireDefault(_MiniSelect);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Pagination = function (_React$Component) {
	    (0, _inherits3['default'])(Pagination, _React$Component);
	
	    function Pagination() {
	        (0, _classCallCheck3['default'])(this, Pagination);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));
	
	        _this.renderPagination = function (locale) {
	            var _a = _this.props,
	                className = _a.className,
	                size = _a.size,
	                restProps = __rest(_a, ["className", "size"]);
	            var isSmall = size === 'small';
	            return React.createElement(_rcPagination2['default'], (0, _extends3['default'])({}, restProps, { className: (0, _classnames2['default'])(className, { mini: isSmall }), selectComponentClass: isSmall ? _MiniSelect2['default'] : _select2['default'], locale: locale }));
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Pagination, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Pagination', defaultLocale: _en_US2['default'] },
	                this.renderPagination
	            );
	        }
	    }]);
	    return Pagination;
	}(React.Component);
	
	exports['default'] = Pagination;
	
	Pagination.defaultProps = {
	    prefixCls: 'ant-pagination',
	    selectPrefixCls: 'ant-select'
	};

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _tooltip = __webpack_require__(170);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _button = __webpack_require__(142);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Popconfirm = function (_React$Component) {
	    (0, _inherits3['default'])(Popconfirm, _React$Component);
	
	    function Popconfirm(props) {
	        (0, _classCallCheck3['default'])(this, Popconfirm);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Popconfirm.__proto__ || Object.getPrototypeOf(Popconfirm)).call(this, props));
	
	        _this.onConfirm = function (e) {
	            _this.setVisible(false);
	            var onConfirm = _this.props.onConfirm;
	
	            if (onConfirm) {
	                onConfirm.call(_this, e);
	            }
	        };
	        _this.onCancel = function (e) {
	            _this.setVisible(false);
	            var onCancel = _this.props.onCancel;
	
	            if (onCancel) {
	                onCancel.call(_this, e);
	            }
	        };
	        _this.onVisibleChange = function (visible) {
	            _this.setVisible(visible);
	        };
	        _this.saveTooltip = function (node) {
	            _this.tooltip = node;
	        };
	        _this.renderOverlay = function (popconfirmLocale) {
	            var _this$props = _this.props,
	                prefixCls = _this$props.prefixCls,
	                title = _this$props.title,
	                cancelText = _this$props.cancelText,
	                okText = _this$props.okText,
	                okType = _this$props.okType;
	
	            return React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-inner-content' },
	                    React.createElement(
	                        'div',
	                        { className: prefixCls + '-message' },
	                        React.createElement(_icon2['default'], { type: 'exclamation-circle' }),
	                        React.createElement(
	                            'div',
	                            { className: prefixCls + '-message-title' },
	                            title
	                        )
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: prefixCls + '-buttons' },
	                        React.createElement(
	                            _button2['default'],
	                            { onClick: _this.onCancel, size: 'small' },
	                            cancelText || popconfirmLocale.cancelText
	                        ),
	                        React.createElement(
	                            _button2['default'],
	                            { onClick: _this.onConfirm, type: okType, size: 'small' },
	                            okText || popconfirmLocale.okText
	                        )
	                    )
	                )
	            );
	        };
	        _this.state = {
	            visible: props.visible
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Popconfirm, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('visible' in nextProps) {
	                this.setState({ visible: nextProps.visible });
	            }
	        }
	    }, {
	        key: 'getPopupDomNode',
	        value: function getPopupDomNode() {
	            return this.tooltip.getPopupDomNode();
	        }
	    }, {
	        key: 'setVisible',
	        value: function setVisible(visible) {
	            var props = this.props;
	            if (!('visible' in props)) {
	                this.setState({ visible: visible });
	            }
	            var onVisibleChange = props.onVisibleChange;
	
	            if (onVisibleChange) {
	                onVisibleChange(visible);
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                placement = _a.placement,
	                restProps = __rest(_a, ["prefixCls", "placement"]);
	            var overlay = React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Popconfirm', defaultLocale: _default2['default'].Popconfirm },
	                this.renderOverlay
	            );
	            return React.createElement(_tooltip2['default'], (0, _extends3['default'])({}, restProps, { prefixCls: prefixCls, placement: placement, onVisibleChange: this.onVisibleChange, visible: this.state.visible, overlay: overlay, ref: this.saveTooltip }));
	        }
	    }]);
	    return Popconfirm;
	}(React.Component);
	
	exports['default'] = Popconfirm;
	
	Popconfirm.defaultProps = {
	    prefixCls: 'ant-popover',
	    transitionName: 'zoom-big',
	    placement: 'top',
	    trigger: 'click',
	    okType: 'primary'
	};

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _tooltip = __webpack_require__(170);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popover = function (_React$Component) {
	    (0, _inherits3['default'])(Popover, _React$Component);
	
	    function Popover() {
	        (0, _classCallCheck3['default'])(this, Popover);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));
	
	        _this.saveTooltip = function (node) {
	            _this.tooltip = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Popover, [{
	        key: 'getPopupDomNode',
	        value: function getPopupDomNode() {
	            return this.tooltip.getPopupDomNode();
	        }
	    }, {
	        key: 'getOverlay',
	        value: function getOverlay() {
	            var _props = this.props,
	                title = _props.title,
	                prefixCls = _props.prefixCls,
	                content = _props.content;
	
	            (0, _warning2['default'])(!('overlay' in this.props), 'Popover[overlay] is removed, please use Popover[content] instead, ' + 'see: https://u.ant.design/popover-content');
	            return React.createElement(
	                'div',
	                null,
	                title && React.createElement(
	                    'div',
	                    { className: prefixCls + '-title' },
	                    title
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-inner-content' },
	                    content
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var props = (0, _extends3['default'])({}, this.props);
	            delete props.title;
	            return React.createElement(_tooltip2['default'], (0, _extends3['default'])({}, props, { ref: this.saveTooltip, overlay: this.getOverlay() }));
	        }
	    }]);
	    return Popover;
	}(React.Component);
	
	exports['default'] = Popover;
	
	Popover.defaultProps = {
	    prefixCls: 'ant-popover',
	    placement: 'top',
	    transitionName: 'zoom-big',
	    trigger: 'hover',
	    mouseEnterDelay: 0.1,
	    mouseLeaveDelay: 0.1,
	    overlayStyle: {}
	};

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _rcProgress = __webpack_require__(2566);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var statusColorMap = {
	    normal: '#108ee9',
	    exception: '#ff5500',
	    success: '#87d068'
	};
	
	var Progress = function (_React$Component) {
	    (0, _inherits3['default'])(Progress, _React$Component);
	
	    function Progress() {
	        (0, _classCallCheck3['default'])(this, Progress);
	        return (0, _possibleConstructorReturn3['default'])(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Progress, [{
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var props = this.props;
	
	            var prefixCls = props.prefixCls,
	                className = props.className,
	                _props$percent = props.percent,
	                percent = _props$percent === undefined ? 0 : _props$percent,
	                status = props.status,
	                format = props.format,
	                trailColor = props.trailColor,
	                size = props.size,
	                type = props.type,
	                strokeWidth = props.strokeWidth,
	                width = props.width,
	                showInfo = props.showInfo,
	                _props$gapDegree = props.gapDegree,
	                gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
	                gapPosition = props.gapPosition,
	                restProps = __rest(props, ["prefixCls", "className", "percent", "status", "format", "trailColor", "size", "type", "strokeWidth", "width", "showInfo", "gapDegree", "gapPosition"]);
	
	            var progressStatus = parseInt(percent.toString(), 10) >= 100 && !('status' in props) ? 'success' : status || 'normal';
	            var progressInfo = void 0;
	            var progress = void 0;
	            var textFormatter = format || function (percentNumber) {
	                return percentNumber + '%';
	            };
	            if (showInfo) {
	                var text = void 0;
	                var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
	                if (progressStatus === 'exception') {
	                    text = format ? textFormatter(percent) : React.createElement(_icon2['default'], { type: 'cross' + iconType });
	                } else if (progressStatus === 'success') {
	                    text = format ? textFormatter(percent) : React.createElement(_icon2['default'], { type: 'check' + iconType });
	                } else {
	                    text = textFormatter(percent);
	                }
	                progressInfo = React.createElement(
	                    'span',
	                    { className: prefixCls + '-text' },
	                    text
	                );
	            }
	            if (type === 'line') {
	                var percentStyle = {
	                    width: percent + '%',
	                    height: strokeWidth || (size === 'small' ? 6 : 8)
	                };
	                progress = React.createElement(
	                    'div',
	                    null,
	                    React.createElement(
	                        'div',
	                        { className: prefixCls + '-outer' },
	                        React.createElement(
	                            'div',
	                            { className: prefixCls + '-inner' },
	                            React.createElement('div', { className: prefixCls + '-bg', style: percentStyle })
	                        )
	                    ),
	                    progressInfo
	                );
	            } else if (type === 'circle' || type === 'dashboard') {
	                var circleSize = width || 120;
	                var circleStyle = {
	                    width: circleSize,
	                    height: circleSize,
	                    fontSize: circleSize * 0.15 + 6
	                };
	                var circleWidth = strokeWidth || 6;
	                var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
	                var gapDeg = gapDegree || type === 'dashboard' && 75;
	                progress = React.createElement(
	                    'div',
	                    { className: prefixCls + '-inner', style: circleStyle },
	                    React.createElement(_rcProgress.Circle, { percent: percent, strokeWidth: circleWidth, trailWidth: circleWidth, strokeColor: statusColorMap[progressStatus], trailColor: trailColor, prefixCls: prefixCls, gapDegree: gapDeg, gapPosition: gapPos }),
	                    progressInfo
	                );
	            }
	            var classString = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + (type === 'dashboard' && 'circle' || type), true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-status-' + progressStatus, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-show-info', showInfo), (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + size, size), _classNames), className);
	            return React.createElement(
	                'div',
	                (0, _extends3['default'])({}, restProps, { className: classString }),
	                progress
	            );
	        }
	    }]);
	    return Progress;
	}(React.Component);
	
	exports['default'] = Progress;
	
	Progress.defaultProps = {
	    type: 'line',
	    percent: 0,
	    showInfo: true,
	    trailColor: '#f3f3f3',
	    prefixCls: 'ant-progress',
	    size: 'default'
	};
	Progress.propTypes = {
	    status: _propTypes2['default'].oneOf(['normal', 'exception', 'active', 'success']),
	    type: _propTypes2['default'].oneOf(['line', 'circle', 'dashboard']),
	    showInfo: _propTypes2['default'].bool,
	    percent: _propTypes2['default'].number,
	    width: _propTypes2['default'].number,
	    strokeWidth: _propTypes2['default'].number,
	    trailColor: _propTypes2['default'].string,
	    format: _propTypes2['default'].func,
	    gapDegree: _propTypes2['default'].number,
	    'default': _propTypes2['default'].oneOf(['default', 'small'])
	};

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _radio = __webpack_require__(385);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getCheckedValue(children) {
	    var value = null;
	    var matched = false;
	    React.Children.forEach(children, function (radio) {
	        if (radio && radio.props && radio.props.checked) {
	            value = radio.props.value;
	            matched = true;
	        }
	    });
	    return matched ? { value: value } : undefined;
	}
	
	var RadioGroup = function (_React$Component) {
	    (0, _inherits3['default'])(RadioGroup, _React$Component);
	
	    function RadioGroup(props) {
	        (0, _classCallCheck3['default'])(this, RadioGroup);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (RadioGroup.__proto__ || Object.getPrototypeOf(RadioGroup)).call(this, props));
	
	        _this.onRadioChange = function (ev) {
	            var lastValue = _this.state.value;
	            var value = ev.target.value;
	
	            if (!('value' in _this.props)) {
	                _this.setState({
	                    value: value
	                });
	            }
	            var onChange = _this.props.onChange;
	            if (onChange && value !== lastValue) {
	                onChange(ev);
	            }
	        };
	        var value = void 0;
	        if ('value' in props) {
	            value = props.value;
	        } else if ('defaultValue' in props) {
	            value = props.defaultValue;
	        } else {
	            var checkedValue = getCheckedValue(props.children);
	            value = checkedValue && checkedValue.value;
	        }
	        _this.state = {
	            value: value
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(RadioGroup, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return {
	                radioGroup: {
	                    onChange: this.onRadioChange,
	                    value: this.state.value,
	                    disabled: this.props.disabled,
	                    name: this.props.name
	                }
	            };
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            if ('value' in nextProps) {
	                this.setState({
	                    value: nextProps.value
	                });
	            } else {
	                var checkedValue = getCheckedValue(nextProps.children);
	                if (checkedValue) {
	                    this.setState({
	                        value: checkedValue.value
	                    });
	                }
	            }
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = this.props;
	            var _props$prefixCls = props.prefixCls,
	                prefixCls = _props$prefixCls === undefined ? 'ant-radio-group' : _props$prefixCls,
	                _props$className = props.className,
	                className = _props$className === undefined ? '' : _props$className,
	                options = props.options;
	
	            var classString = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-' + props.size, props.size), className);
	            var children = props.children;
	            // 如果存在 options, 优先使用
	            if (options && options.length > 0) {
	                children = options.map(function (option, index) {
	                    if (typeof option === 'string') {
	                        return React.createElement(
	                            _radio2['default'],
	                            { key: index, disabled: _this2.props.disabled, value: option, onChange: _this2.onRadioChange, checked: _this2.state.value === option },
	                            option
	                        );
	                    } else {
	                        return React.createElement(
	                            _radio2['default'],
	                            { key: index, disabled: option.disabled || _this2.props.disabled, value: option.value, onChange: _this2.onRadioChange, checked: _this2.state.value === option.value },
	                            option.label
	                        );
	                    }
	                });
	            }
	            return React.createElement(
	                'div',
	                { className: classString, style: props.style, onMouseEnter: props.onMouseEnter, onMouseLeave: props.onMouseLeave, id: props.id },
	                children
	            );
	        }
	    }]);
	    return RadioGroup;
	}(React.Component);
	
	exports['default'] = RadioGroup;
	
	RadioGroup.defaultProps = {
	    disabled: false
	};
	RadioGroup.childContextTypes = {
	    radioGroup: _propTypes2['default'].any
	};

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _radio = __webpack_require__(385);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var RadioButton = function (_React$Component) {
	    (0, _inherits3['default'])(RadioButton, _React$Component);
	
	    function RadioButton() {
	        (0, _classCallCheck3['default'])(this, RadioButton);
	        return (0, _possibleConstructorReturn3['default'])(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(RadioButton, [{
	        key: 'render',
	        value: function render() {
	            var radioProps = (0, _extends3['default'])({}, this.props);
	            if (this.context.radioGroup) {
	                radioProps.onChange = this.context.radioGroup.onChange;
	                radioProps.checked = this.props.value === this.context.radioGroup.value;
	                radioProps.disabled = this.props.disabled || this.context.radioGroup.disabled;
	            }
	            return React.createElement(_radio2['default'], radioProps);
	        }
	    }]);
	    return RadioButton;
	}(React.Component);
	
	exports['default'] = RadioButton;
	
	RadioButton.defaultProps = {
	    prefixCls: 'ant-radio-button'
	};
	RadioButton.contextTypes = {
	    radioGroup: _propTypes2['default'].any
	};

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcRate = __webpack_require__(2569);
	
	var _rcRate2 = _interopRequireDefault(_rcRate);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Rate = function (_React$Component) {
	    (0, _inherits3['default'])(Rate, _React$Component);
	
	    function Rate() {
	        (0, _classCallCheck3['default'])(this, Rate);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Rate.__proto__ || Object.getPrototypeOf(Rate)).apply(this, arguments));
	
	        _this.saveRate = function (node) {
	            _this.rcRate = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Rate, [{
	        key: 'focus',
	        value: function focus() {
	            this.rcRate.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcRate.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(_rcRate2['default'], (0, _extends3['default'])({ ref: this.saveRate }, this.props));
	        }
	    }]);
	    return Rate;
	}(React.Component);
	
	exports['default'] = Rate;
	
	Rate.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    character: _propTypes2['default'].node
	};
	Rate.defaultProps = {
	    prefixCls: 'ant-rate',
	    character: React.createElement(_icon2['default'], { type: 'star' })
	};

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _grid = __webpack_require__(270);
	
	exports['default'] = _grid.Row;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Slider = __webpack_require__(1176);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Range = __webpack_require__(1175);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Handle = __webpack_require__(328);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _tooltip = __webpack_require__(170);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Slider = function (_React$Component) {
	    (0, _inherits3['default'])(Slider, _React$Component);
	
	    function Slider(props) {
	        (0, _classCallCheck3['default'])(this, Slider);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	        _this.toggleTooltipVisible = function (index, visible) {
	            _this.setState(function (_ref) {
	                var visibles = _ref.visibles;
	                return {
	                    visibles: (0, _extends4['default'])({}, visibles, (0, _defineProperty3['default'])({}, index, visible))
	                };
	            });
	        };
	        _this.handleWithTooltip = function (_a) {
	            var value = _a.value,
	                dragging = _a.dragging,
	                index = _a.index,
	                restProps = __rest(_a, ["value", "dragging", "index"]);
	
	            var _this$props = _this.props,
	                tooltipPrefixCls = _this$props.tooltipPrefixCls,
	                tipFormatter = _this$props.tipFormatter;
	            var visibles = _this.state.visibles;
	
	            var visible = tipFormatter ? visibles[index] || dragging : false;
	            return React.createElement(
	                _tooltip2['default'],
	                { prefixCls: tooltipPrefixCls, title: tipFormatter ? tipFormatter(value) : '', visible: visible, placement: 'top', transitionName: 'zoom-down', key: index },
	                React.createElement(_Handle2['default'], (0, _extends4['default'])({}, restProps, { value: value, onMouseEnter: function onMouseEnter() {
	                        return _this.toggleTooltipVisible(index, true);
	                    }, onMouseLeave: function onMouseLeave() {
	                        return _this.toggleTooltipVisible(index, false);
	                    } }))
	            );
	        };
	        _this.saveSlider = function (node) {
	            _this.rcSlider = node;
	        };
	        _this.state = {
	            visibles: {}
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Slider, [{
	        key: 'focus',
	        value: function focus() {
	            this.rcSlider.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcSlider.focus();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                range = _a.range,
	                restProps = __rest(_a, ["range"]);
	            if (range) {
	                return React.createElement(_Range2['default'], (0, _extends4['default'])({}, restProps, { ref: this.saveSlider, handle: this.handleWithTooltip }));
	            }
	            return React.createElement(_Slider2['default'], (0, _extends4['default'])({}, restProps, { ref: this.saveSlider, handle: this.handleWithTooltip }));
	        }
	    }]);
	    return Slider;
	}(React.Component);
	
	exports['default'] = Slider;
	
	Slider.defaultProps = {
	    prefixCls: 'ant-slider',
	    tooltipPrefixCls: 'ant-tooltip',
	    tipFormatter: function tipFormatter(value) {
	        return value.toString();
	    }
	};

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcSteps = __webpack_require__(2582);
	
	var _rcSteps2 = _interopRequireDefault(_rcSteps);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Steps = function (_React$Component) {
	    (0, _inherits3['default'])(Steps, _React$Component);
	
	    function Steps() {
	        (0, _classCallCheck3['default'])(this, Steps);
	        return (0, _possibleConstructorReturn3['default'])(this, (Steps.__proto__ || Object.getPrototypeOf(Steps)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Steps, [{
	        key: 'render',
	        value: function render() {
	            return React.createElement(_rcSteps2['default'], this.props);
	        }
	    }]);
	    return Steps;
	}(React.Component);
	
	exports['default'] = Steps;
	
	Steps.Step = _rcSteps2['default'].Step;
	Steps.defaultProps = {
	    prefixCls: 'ant-steps',
	    iconPrefix: 'ant',
	    current: 0
	};
	Steps.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    iconPrefix: _propTypes2['default'].string,
	    current: _propTypes2['default'].number
	};

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcSwitch = __webpack_require__(2585);
	
	var _rcSwitch2 = _interopRequireDefault(_rcSwitch);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Switch = function (_React$Component) {
	    (0, _inherits3['default'])(Switch, _React$Component);
	
	    function Switch() {
	        (0, _classCallCheck3['default'])(this, Switch);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).apply(this, arguments));
	
	        _this.saveSwitch = function (node) {
	            _this.rcSwitch = node;
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Switch, [{
	        key: 'focus',
	        value: function focus() {
	            this.rcSwitch.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcSwitch.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                size = _props.size,
	                loading = _props.loading,
	                _props$className = _props.className,
	                className = _props$className === undefined ? '' : _props$className;
	
	            var classes = (0, _classnames2['default'])(className, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-small', size === 'small'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-loading', loading), _classNames));
	            return React.createElement(_rcSwitch2['default'], (0, _extends3['default'])({}, (0, _omit2['default'])(this.props, ['loading']), { className: classes, ref: this.saveSwitch }));
	        }
	    }]);
	    return Switch;
	}(React.Component);
	
	exports['default'] = Switch;
	
	Switch.defaultProps = {
	    prefixCls: 'ant-switch'
	};
	Switch.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    // HACK: https://github.com/ant-design/ant-design/issues/5368
	    // size=default and size=large are the same
	    size: _propTypes2['default'].oneOf(['small', 'default', 'large']),
	    className: _propTypes2['default'].string
	};

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Column = function (_React$Component) {
	  (0, _inherits3['default'])(Column, _React$Component);
	
	  function Column() {
	    (0, _classCallCheck3['default'])(this, Column);
	    return (0, _possibleConstructorReturn3['default'])(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
	  }
	
	  return Column;
	}(React.Component);
	
	exports['default'] = Column;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ColumnGroup = function (_React$Component) {
	  (0, _inherits3['default'])(ColumnGroup, _React$Component);
	
	  function ColumnGroup() {
	    (0, _classCallCheck3['default'])(this, ColumnGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, (ColumnGroup.__proto__ || Object.getPrototypeOf(ColumnGroup)).apply(this, arguments));
	  }
	
	  return ColumnGroup;
	}(React.Component);
	
	exports['default'] = ColumnGroup;
	
	ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	exports['default'] = function (props) {
	    return React.createElement(
	        'div',
	        { className: props.className, onClick: props.onClick },
	        props.children
	    );
	};

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _checkbox = __webpack_require__(169);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _radio = __webpack_require__(272);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SelectionBox = function (_React$Component) {
	    (0, _inherits3['default'])(SelectionBox, _React$Component);
	
	    function SelectionBox(props) {
	        (0, _classCallCheck3['default'])(this, SelectionBox);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (SelectionBox.__proto__ || Object.getPrototypeOf(SelectionBox)).call(this, props));
	
	        _this.state = {
	            checked: _this.getCheckState(props)
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(SelectionBox, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.subscribe();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.unsubscribe) {
	                this.unsubscribe();
	            }
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe() {
	            var _this2 = this;
	
	            var store = this.props.store;
	
	            this.unsubscribe = store.subscribe(function () {
	                var checked = _this2.getCheckState(_this2.props);
	                _this2.setState({ checked: checked });
	            });
	        }
	    }, {
	        key: 'getCheckState',
	        value: function getCheckState(props) {
	            var store = props.store,
	                defaultSelection = props.defaultSelection,
	                rowIndex = props.rowIndex;
	
	            var checked = false;
	            if (store.getState().selectionDirty) {
	                checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
	            } else {
	                checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
	            }
	            return checked;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                type = _props.type,
	                rowIndex = _props.rowIndex,
	                disabled = _props.disabled,
	                onChange = _props.onChange;
	            var checked = this.state.checked;
	
	            if (type === 'radio') {
	                return React.createElement(_radio2['default'], { disabled: disabled, onChange: onChange, value: rowIndex, checked: checked });
	            }
	            return React.createElement(_checkbox2['default'], { checked: checked, disabled: disabled, onChange: onChange });
	        }
	    }]);
	    return SelectionBox;
	}(React.Component);
	
	exports['default'] = SelectionBox;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _checkbox = __webpack_require__(169);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _dropdown = __webpack_require__(382);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _menu = __webpack_require__(595);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SelectionCheckboxAll = function (_React$Component) {
	    (0, _inherits3['default'])(SelectionCheckboxAll, _React$Component);
	
	    function SelectionCheckboxAll(props) {
	        (0, _classCallCheck3['default'])(this, SelectionCheckboxAll);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (SelectionCheckboxAll.__proto__ || Object.getPrototypeOf(SelectionCheckboxAll)).call(this, props));
	
	        _this.handleSelectAllChagne = function (e) {
	            var checked = e.target.checked;
	            _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
	        };
	        _this.defaultSelections = props.hideDefaultSelections ? [] : [{
	            key: 'all',
	            text: props.locale.selectAll,
	            onSelect: function onSelect() {}
	        }, {
	            key: 'invert',
	            text: props.locale.selectInvert,
	            onSelect: function onSelect() {}
	        }];
	        _this.state = {
	            checked: _this.getCheckState(props),
	            indeterminate: _this.getIndeterminateState(props)
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(SelectionCheckboxAll, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.subscribe();
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.setCheckState(nextProps);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            if (this.unsubscribe) {
	                this.unsubscribe();
	            }
	        }
	    }, {
	        key: 'subscribe',
	        value: function subscribe() {
	            var _this2 = this;
	
	            var store = this.props.store;
	
	            this.unsubscribe = store.subscribe(function () {
	                _this2.setCheckState(_this2.props);
	            });
	        }
	    }, {
	        key: 'checkSelection',
	        value: function checkSelection(data, type, byDefaultChecked) {
	            var _props = this.props,
	                store = _props.store,
	                getCheckboxPropsByItem = _props.getCheckboxPropsByItem,
	                getRecordKey = _props.getRecordKey;
	            // type should be 'every' | 'some'
	
	            if (type === 'every' || type === 'some') {
	                return byDefaultChecked ? data[type](function (item, i) {
	                    return getCheckboxPropsByItem(item, i).defaultChecked;
	                }) : data[type](function (item, i) {
	                    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
	                });
	            }
	            return false;
	        }
	    }, {
	        key: 'setCheckState',
	        value: function setCheckState(props) {
	            var checked = this.getCheckState(props);
	            var indeterminate = this.getIndeterminateState(props);
	            if (checked !== this.state.checked) {
	                this.setState({ checked: checked });
	            }
	            if (indeterminate !== this.state.indeterminate) {
	                this.setState({ indeterminate: indeterminate });
	            }
	        }
	    }, {
	        key: 'getCheckState',
	        value: function getCheckState(props) {
	            var store = props.store,
	                data = props.data;
	
	            var checked = void 0;
	            if (!data.length) {
	                checked = false;
	            } else {
	                checked = store.getState().selectionDirty ? this.checkSelection(data, 'every', false) : this.checkSelection(data, 'every', false) || this.checkSelection(data, 'every', true);
	            }
	            return checked;
	        }
	    }, {
	        key: 'getIndeterminateState',
	        value: function getIndeterminateState(props) {
	            var store = props.store,
	                data = props.data;
	
	            var indeterminate = void 0;
	            if (!data.length) {
	                indeterminate = false;
	            } else {
	                indeterminate = store.getState().selectionDirty ? this.checkSelection(data, 'some', false) && !this.checkSelection(data, 'every', false) : this.checkSelection(data, 'some', false) && !this.checkSelection(data, 'every', false) || this.checkSelection(data, 'some', true) && !this.checkSelection(data, 'every', true);
	            }
	            return indeterminate;
	        }
	    }, {
	        key: 'renderMenus',
	        value: function renderMenus(selections) {
	            var _this3 = this;
	
	            return selections.map(function (selection, index) {
	                return React.createElement(
	                    _menu2['default'].Item,
	                    { key: selection.key || index },
	                    React.createElement(
	                        'div',
	                        { onClick: function onClick() {
	                                _this3.props.onSelect(selection.key, index, selection.onSelect);
	                            } },
	                        selection.text
	                    )
	                );
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props2 = this.props,
	                disabled = _props2.disabled,
	                prefixCls = _props2.prefixCls,
	                selections = _props2.selections,
	                getPopupContainer = _props2.getPopupContainer;
	            var _state = this.state,
	                checked = _state.checked,
	                indeterminate = _state.indeterminate;
	
	            var selectionPrefixCls = prefixCls + '-selection';
	            var customSelections = null;
	            if (selections) {
	                var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
	                var menu = React.createElement(
	                    _menu2['default'],
	                    { className: selectionPrefixCls + '-menu', selectedKeys: [] },
	                    this.renderMenus(newSelections)
	                );
	                customSelections = newSelections.length > 0 ? React.createElement(
	                    _dropdown2['default'],
	                    { overlay: menu, getPopupContainer: getPopupContainer },
	                    React.createElement(
	                        'div',
	                        { className: selectionPrefixCls + '-down' },
	                        React.createElement(_icon2['default'], { type: 'down' })
	                    )
	                ) : null;
	            }
	            return React.createElement(
	                'div',
	                { className: selectionPrefixCls },
	                React.createElement(_checkbox2['default'], { className: (0, _classnames2['default'])((0, _defineProperty3['default'])({}, selectionPrefixCls + '-select-all-custom', customSelections)), checked: checked, indeterminate: indeterminate, disabled: disabled, onChange: this.handleSelectAllChagne }),
	                customSelections
	            );
	        }
	    }]);
	    return SelectionCheckboxAll;
	}(React.Component);
	
	exports['default'] = SelectionCheckboxAll;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(3);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _rcTable = __webpack_require__(2599);
	
	var _rcTable2 = _interopRequireDefault(_rcTable);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _pagination = __webpack_require__(384);
	
	var _pagination2 = _interopRequireDefault(_pagination);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _spin = __webpack_require__(386);
	
	var _spin2 = _interopRequireDefault(_spin);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _filterDropdown = __webpack_require__(1510);
	
	var _filterDropdown2 = _interopRequireDefault(_filterDropdown);
	
	var _createStore = __webpack_require__(1509);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _SelectionBox = __webpack_require__(1505);
	
	var _SelectionBox2 = _interopRequireDefault(_SelectionBox);
	
	var _SelectionCheckboxAll = __webpack_require__(1506);
	
	var _SelectionCheckboxAll2 = _interopRequireDefault(_SelectionCheckboxAll);
	
	var _Column = __webpack_require__(1502);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _ColumnGroup = __webpack_require__(1503);
	
	var _ColumnGroup2 = _interopRequireDefault(_ColumnGroup);
	
	var _createBodyRow = __webpack_require__(1508);
	
	var _createBodyRow2 = _interopRequireDefault(_createBodyRow);
	
	var _util = __webpack_require__(1512);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	function noop() {}
	function stopPropagation(e) {
	    e.stopPropagation();
	    if (e.nativeEvent.stopImmediatePropagation) {
	        e.nativeEvent.stopImmediatePropagation();
	    }
	}
	var defaultPagination = {
	    onChange: noop,
	    onShowSizeChange: noop
	};
	/**
	 * Avoid creating new object, so that parent component's shouldComponentUpdate
	 * can works appropriately。
	 */
	var emptyObject = {};
	
	var Table = function (_React$Component) {
	    (0, _inherits3['default'])(Table, _React$Component);
	
	    function Table(props) {
	        (0, _classCallCheck3['default'])(this, Table);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));
	
	        _this.getCheckboxPropsByItem = function (item, index) {
	            var _this$props$rowSelect = _this.props.rowSelection,
	                rowSelection = _this$props$rowSelect === undefined ? {} : _this$props$rowSelect;
	
	            if (!rowSelection.getCheckboxProps) {
	                return {};
	            }
	            var key = _this.getRecordKey(item, index);
	            // Cache checkboxProps
	            if (!_this.CheckboxPropsCache[key]) {
	                _this.CheckboxPropsCache[key] = rowSelection.getCheckboxProps(item);
	            }
	            return _this.CheckboxPropsCache[key];
	        };
	        _this.onRow = function (record, index) {
	            var _this$props = _this.props,
	                onRow = _this$props.onRow,
	                prefixCls = _this$props.prefixCls;
	
	            var custom = onRow ? onRow(record, index) : {};
	            return (0, _extends5['default'])({}, custom, { prefixCls: prefixCls, store: _this.store, rowKey: _this.getRecordKey(record, index) });
	        };
	        _this.handleFilter = function (column, nextFilters) {
	            var props = _this.props;
	            var pagination = (0, _extends5['default'])({}, _this.state.pagination);
	            var filters = (0, _extends5['default'])({}, _this.state.filters, (0, _defineProperty3['default'])({}, _this.getColumnKey(column), nextFilters));
	            // Remove filters not in current columns
	            var currentColumnKeys = [];
	            (0, _util.treeMap)(_this.columns, function (c) {
	                if (!c.children) {
	                    currentColumnKeys.push(_this.getColumnKey(c));
	                }
	            });
	            Object.keys(filters).forEach(function (columnKey) {
	                if (currentColumnKeys.indexOf(columnKey) < 0) {
	                    delete filters[columnKey];
	                }
	            });
	            if (props.pagination) {
	                // Reset current prop
	                pagination.current = 1;
	                pagination.onChange(pagination.current);
	            }
	            var newState = {
	                pagination: pagination,
	                filters: {}
	            };
	            var filtersToSetState = (0, _extends5['default'])({}, filters);
	            // Remove filters which is controlled
	            _this.getFilteredValueColumns().forEach(function (col) {
	                var columnKey = _this.getColumnKey(col);
	                if (columnKey) {
	                    delete filtersToSetState[columnKey];
	                }
	            });
	            if (Object.keys(filtersToSetState).length > 0) {
	                newState.filters = filtersToSetState;
	            }
	            // Controlled current prop will not respond user interaction
	            if ((0, _typeof3['default'])(props.pagination) === 'object' && 'current' in props.pagination) {
	                newState.pagination = (0, _extends5['default'])({}, pagination, { current: _this.state.pagination.current });
	            }
	            _this.setState(newState, function () {
	                _this.store.setState({
	                    selectionDirty: false
	                });
	                var onChange = _this.props.onChange;
	                if (onChange) {
	                    onChange.apply(null, _this.prepareParamsArguments((0, _extends5['default'])({}, _this.state, { selectionDirty: false, filters: filters,
	                        pagination: pagination })));
	                }
	            });
	        };
	        _this.handleSelect = function (record, rowIndex, e) {
	            var checked = e.target.checked;
	            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
	            var key = _this.getRecordKey(record, rowIndex);
	            if (checked) {
	                selectedRowKeys.push(_this.getRecordKey(record, rowIndex));
	            } else {
	                selectedRowKeys = selectedRowKeys.filter(function (i) {
	                    return key !== i;
	                });
	            }
	            _this.store.setState({
	                selectionDirty: true
	            });
	            _this.setSelectedRowKeys(selectedRowKeys, {
	                selectWay: 'onSelect',
	                record: record,
	                checked: checked
	            });
	        };
	        _this.handleRadioSelect = function (record, rowIndex, e) {
	            var checked = e.target.checked;
	            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
	            var key = _this.getRecordKey(record, rowIndex);
	            selectedRowKeys = [key];
	            _this.store.setState({
	                selectionDirty: true
	            });
	            _this.setSelectedRowKeys(selectedRowKeys, {
	                selectWay: 'onSelect',
	                record: record,
	                checked: checked
	            });
	        };
	        _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
	            var data = _this.getFlatCurrentPageData();
	            var defaultSelection = _this.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	            var selectedRowKeys = _this.store.getState().selectedRowKeys.concat(defaultSelection);
	            var changeableRowKeys = data.filter(function (item, i) {
	                return !_this.getCheckboxPropsByItem(item, i).disabled;
	            }).map(function (item, i) {
	                return _this.getRecordKey(item, i);
	            });
	            var changeRowKeys = [];
	            var selectWay = '';
	            var checked = void 0;
	            // handle default selection
	            switch (selectionKey) {
	                case 'all':
	                    changeableRowKeys.forEach(function (key) {
	                        if (selectedRowKeys.indexOf(key) < 0) {
	                            selectedRowKeys.push(key);
	                            changeRowKeys.push(key);
	                        }
	                    });
	                    selectWay = 'onSelectAll';
	                    checked = true;
	                    break;
	                case 'removeAll':
	                    changeableRowKeys.forEach(function (key) {
	                        if (selectedRowKeys.indexOf(key) >= 0) {
	                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	                            changeRowKeys.push(key);
	                        }
	                    });
	                    selectWay = 'onSelectAll';
	                    checked = false;
	                    break;
	                case 'invert':
	                    changeableRowKeys.forEach(function (key) {
	                        if (selectedRowKeys.indexOf(key) < 0) {
	                            selectedRowKeys.push(key);
	                        } else {
	                            selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	                        }
	                        changeRowKeys.push(key);
	                        selectWay = 'onSelectInvert';
	                    });
	                    break;
	                default:
	                    break;
	            }
	            _this.store.setState({
	                selectionDirty: true
	            });
	            // when select custom selection, callback selections[n].onSelect
	            var rowSelection = _this.props.rowSelection;
	
	            var customSelectionStartIndex = 2;
	            if (rowSelection && rowSelection.hideDefaultSelections) {
	                customSelectionStartIndex = 0;
	            }
	            if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
	                return onSelectFunc(changeableRowKeys);
	            }
	            _this.setSelectedRowKeys(selectedRowKeys, {
	                selectWay: selectWay,
	                checked: checked,
	                changeRowKeys: changeRowKeys
	            });
	        };
	        _this.handlePageChange = function (current) {
	            for (var _len = arguments.length, otherArguments = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                otherArguments[_key - 1] = arguments[_key];
	            }
	
	            var props = _this.props;
	            var pagination = (0, _extends5['default'])({}, _this.state.pagination);
	            if (current) {
	                pagination.current = current;
	            } else {
	                pagination.current = pagination.current || 1;
	            }
	            pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
	            var newState = {
	                pagination: pagination
	            };
	            // Controlled current prop will not respond user interaction
	            if (props.pagination && (0, _typeof3['default'])(props.pagination) === 'object' && 'current' in props.pagination) {
	                newState.pagination = (0, _extends5['default'])({}, pagination, { current: _this.state.pagination.current });
	            }
	            _this.setState(newState);
	            _this.store.setState({
	                selectionDirty: false
	            });
	            var onChange = _this.props.onChange;
	            if (onChange) {
	                onChange.apply(null, _this.prepareParamsArguments((0, _extends5['default'])({}, _this.state, { selectionDirty: false, pagination: pagination })));
	            }
	        };
	        _this.renderSelectionBox = function (type) {
	            return function (_, record, index) {
	                var rowIndex = _this.getRecordKey(record, index); // 从 1 开始
	                var props = _this.getCheckboxPropsByItem(record, index);
	                var handleChange = function handleChange(e) {
	                    type === 'radio' ? _this.handleRadioSelect(record, rowIndex, e) : _this.handleSelect(record, rowIndex, e);
	                };
	                return React.createElement(
	                    'span',
	                    { onClick: stopPropagation },
	                    React.createElement(_SelectionBox2['default'], { type: type, store: _this.store, rowIndex: rowIndex, disabled: props.disabled, onChange: handleChange, defaultSelection: _this.getDefaultSelection() })
	                );
	            };
	        };
	        _this.getRecordKey = function (record, index) {
	            var rowKey = _this.props.rowKey;
	            var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	            (0, _warning2['default'])(recordKey !== undefined, 'Each record in dataSource of table should have a unique `key` prop, or set `rowKey` to an unique primary key,' + 'see https://u.ant.design/table-row-key');
	            return recordKey === undefined ? index : recordKey;
	        };
	        _this.getPopupContainer = function () {
	            return ReactDOM.findDOMNode(_this);
	        };
	        _this.handleShowSizeChange = function (current, pageSize) {
	            var pagination = _this.state.pagination;
	            pagination.onShowSizeChange(current, pageSize);
	            var nextPagination = (0, _extends5['default'])({}, pagination, { pageSize: pageSize,
	                current: current });
	            _this.setState({ pagination: nextPagination });
	            var onChange = _this.props.onChange;
	            if (onChange) {
	                onChange.apply(null, _this.prepareParamsArguments((0, _extends5['default'])({}, _this.state, { pagination: nextPagination })));
	            }
	        };
	        _this.renderTable = function (contextLocale) {
	            var _classNames;
	
	            var locale = (0, _extends5['default'])({}, contextLocale, _this.props.locale);
	            var _a = _this.props,
	                style = _a.style,
	                loading = _a.loading,
	                className = _a.className,
	                prefixCls = _a.prefixCls,
	                showHeader = _a.showHeader,
	                restProps = __rest(_a, ["style", "loading", "className", "prefixCls", "showHeader"]);
	            var data = _this.getCurrentPageData();
	            var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false;
	            var classString = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + _this.props.size, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-bordered', _this.props.bordered), (0, _defineProperty3['default'])(_classNames, prefixCls + '-empty', !data.length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-without-column-header', !showHeader), _classNames));
	            var columns = _this.renderRowSelection(locale);
	            columns = _this.renderColumnsDropdown(columns, locale);
	            columns = columns.map(function (column, i) {
	                var newColumn = (0, _extends5['default'])({}, column);
	                newColumn.key = _this.getColumnKey(newColumn, i);
	                return newColumn;
	            });
	            var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
	            if ('expandIconColumnIndex' in restProps) {
	                expandIconColumnIndex = restProps.expandIconColumnIndex;
	            }
	            return React.createElement(_rcTable2['default'], (0, _extends5['default'])({ key: 'table' }, restProps, { onRow: _this.onRow, components: _this.components, prefixCls: prefixCls, data: data, columns: columns, showHeader: showHeader, className: classString, expandIconColumnIndex: expandIconColumnIndex, expandIconAsCell: expandIconAsCell, emptyText: !loading && locale.emptyText }));
	        };
	        (0, _warning2['default'])(!('columnsPageRange' in props || 'columnsPageSize' in props), '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
	        _this.columns = props.columns || (0, _util.normalizeColumns)(props.children);
	        _this.createComponents(props.components);
	        _this.state = (0, _extends5['default'])({}, _this.getDefaultSortOrder(_this.columns), {
	            // 减少状态
	            filters: _this.getFiltersFromColumns(), pagination: _this.getDefaultPagination(props) });
	        _this.CheckboxPropsCache = {};
	        _this.store = (0, _createStore2['default'])({
	            selectedRowKeys: (props.rowSelection || {}).selectedRowKeys || [],
	            selectionDirty: false
	        });
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Table, [{
	        key: 'getDefaultSelection',
	        value: function getDefaultSelection() {
	            var _this2 = this;
	
	            var _props$rowSelection = this.props.rowSelection,
	                rowSelection = _props$rowSelection === undefined ? {} : _props$rowSelection;
	
	            if (!rowSelection.getCheckboxProps) {
	                return [];
	            }
	            return this.getFlatData().filter(function (item, rowIndex) {
	                return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
	            }).map(function (record, rowIndex) {
	                return _this2.getRecordKey(record, rowIndex);
	            });
	        }
	    }, {
	        key: 'getDefaultPagination',
	        value: function getDefaultPagination(props) {
	            var pagination = props.pagination || {};
	            return this.hasPagination(props) ? (0, _extends5['default'])({}, defaultPagination, pagination, { current: pagination.defaultCurrent || pagination.current || 1, pageSize: pagination.defaultPageSize || pagination.pageSize || 10 }) : {};
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            this.columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
	            if ('pagination' in nextProps || 'pagination' in this.props) {
	                this.setState(function (previousState) {
	                    var newPagination = (0, _extends5['default'])({}, defaultPagination, previousState.pagination, nextProps.pagination);
	                    newPagination.current = newPagination.current || 1;
	                    newPagination.pageSize = newPagination.pageSize || 10;
	                    return { pagination: nextProps.pagination !== false ? newPagination : emptyObject };
	                });
	            }
	            if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
	                this.store.setState({
	                    selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
	                });
	                var rowSelection = this.props.rowSelection;
	
	                if (rowSelection && nextProps.rowSelection.getCheckboxProps !== rowSelection.getCheckboxProps) {
	                    this.CheckboxPropsCache = {};
	                }
	            }
	            if ('dataSource' in nextProps && nextProps.dataSource !== this.props.dataSource) {
	                this.store.setState({
	                    selectionDirty: false
	                });
	                this.CheckboxPropsCache = {};
	            }
	            if (this.getSortOrderColumns(this.columns).length > 0) {
	                var sortState = this.getSortStateFromColumns(this.columns);
	                if (sortState.sortColumn !== this.state.sortColumn || sortState.sortOrder !== this.state.sortOrder) {
	                    this.setState(sortState);
	                }
	            }
	            var filteredValueColumns = this.getFilteredValueColumns(this.columns);
	            if (filteredValueColumns.length > 0) {
	                var filtersFromColumns = this.getFiltersFromColumns(this.columns);
	                var newFilters = (0, _extends5['default'])({}, this.state.filters);
	                Object.keys(filtersFromColumns).forEach(function (key) {
	                    newFilters[key] = filtersFromColumns[key];
	                });
	                if (this.isFiltersChanged(newFilters)) {
	                    this.setState({ filters: newFilters });
	                }
	            }
	            this.createComponents(nextProps.components, this.props.components);
	        }
	    }, {
	        key: 'setSelectedRowKeys',
	        value: function setSelectedRowKeys(selectedRowKeys, _ref) {
	            var _this3 = this;
	
	            var selectWay = _ref.selectWay,
	                record = _ref.record,
	                checked = _ref.checked,
	                changeRowKeys = _ref.changeRowKeys;
	            var _props$rowSelection2 = this.props.rowSelection,
	                rowSelection = _props$rowSelection2 === undefined ? {} : _props$rowSelection2;
	
	            if (rowSelection && !('selectedRowKeys' in rowSelection)) {
	                this.store.setState({ selectedRowKeys: selectedRowKeys });
	            }
	            var data = this.getFlatData();
	            if (!rowSelection.onChange && !rowSelection[selectWay]) {
	                return;
	            }
	            var selectedRows = data.filter(function (row, i) {
	                return selectedRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
	            });
	            if (rowSelection.onChange) {
	                rowSelection.onChange(selectedRowKeys, selectedRows);
	            }
	            if (selectWay === 'onSelect' && rowSelection.onSelect) {
	                rowSelection.onSelect(record, checked, selectedRows);
	            } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
	                var changeRows = data.filter(function (row, i) {
	                    return changeRowKeys.indexOf(_this3.getRecordKey(row, i)) >= 0;
	                });
	                rowSelection.onSelectAll(checked, selectedRows, changeRows);
	            } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
	                rowSelection.onSelectInvert(selectedRowKeys);
	            }
	        }
	    }, {
	        key: 'hasPagination',
	        value: function hasPagination(props) {
	            return (props || this.props).pagination !== false;
	        }
	    }, {
	        key: 'isFiltersChanged',
	        value: function isFiltersChanged(filters) {
	            var _this4 = this;
	
	            var filtersChanged = false;
	            if (Object.keys(filters).length !== Object.keys(this.state.filters).length) {
	                filtersChanged = true;
	            } else {
	                Object.keys(filters).forEach(function (columnKey) {
	                    if (filters[columnKey] !== _this4.state.filters[columnKey]) {
	                        filtersChanged = true;
	                    }
	                });
	            }
	            return filtersChanged;
	        }
	    }, {
	        key: 'getSortOrderColumns',
	        value: function getSortOrderColumns(columns) {
	            return (0, _util.flatFilter)(columns || this.columns || [], function (column) {
	                return 'sortOrder' in column;
	            });
	        }
	    }, {
	        key: 'getFilteredValueColumns',
	        value: function getFilteredValueColumns(columns) {
	            return (0, _util.flatFilter)(columns || this.columns || [], function (column) {
	                return typeof column.filteredValue !== 'undefined';
	            });
	        }
	    }, {
	        key: 'getFiltersFromColumns',
	        value: function getFiltersFromColumns(columns) {
	            var _this5 = this;
	
	            var filters = {};
	            this.getFilteredValueColumns(columns).forEach(function (col) {
	                var colKey = _this5.getColumnKey(col);
	                filters[colKey] = col.filteredValue;
	            });
	            return filters;
	        }
	    }, {
	        key: 'getDefaultSortOrder',
	        value: function getDefaultSortOrder(columns) {
	            var definedSortState = this.getSortStateFromColumns(columns);
	            var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
	                return column.defaultSortOrder != null;
	            })[0];
	            if (defaultSortedColumn && !definedSortState.sortColumn) {
	                return {
	                    sortColumn: defaultSortedColumn,
	                    sortOrder: defaultSortedColumn.defaultSortOrder
	                };
	            }
	            return definedSortState;
	        }
	    }, {
	        key: 'getSortStateFromColumns',
	        value: function getSortStateFromColumns(columns) {
	            // return first column which sortOrder is not falsy
	            var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
	                return col.sortOrder;
	            })[0];
	            if (sortedColumn) {
	                return {
	                    sortColumn: sortedColumn,
	                    sortOrder: sortedColumn.sortOrder
	                };
	            }
	            return {
	                sortColumn: null,
	                sortOrder: null
	            };
	        }
	    }, {
	        key: 'getSorterFn',
	        value: function getSorterFn() {
	            var _state = this.state,
	                sortOrder = _state.sortOrder,
	                sortColumn = _state.sortColumn;
	
	            if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
	                return;
	            }
	            return function (a, b) {
	                var result = sortColumn.sorter(a, b);
	                if (result !== 0) {
	                    return sortOrder === 'descend' ? -result : result;
	                }
	                return 0;
	            };
	        }
	    }, {
	        key: 'toggleSortOrder',
	        value: function toggleSortOrder(order, column) {
	            var _state2 = this.state,
	                sortColumn = _state2.sortColumn,
	                sortOrder = _state2.sortOrder;
	            // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
	
	            var isSortColumn = this.isSortColumn(column);
	            if (!isSortColumn) {
	                sortOrder = order;
	                sortColumn = column;
	            } else {
	                if (sortOrder === order) {
	                    sortOrder = '';
	                    sortColumn = null;
	                } else {
	                    sortOrder = order;
	                }
	            }
	            var newState = {
	                sortOrder: sortOrder,
	                sortColumn: sortColumn
	            };
	            // Controlled
	            if (this.getSortOrderColumns().length === 0) {
	                this.setState(newState);
	            }
	            var onChange = this.props.onChange;
	            if (onChange) {
	                onChange.apply(null, this.prepareParamsArguments((0, _extends5['default'])({}, this.state, newState)));
	            }
	        }
	    }, {
	        key: 'renderRowSelection',
	        value: function renderRowSelection(locale) {
	            var _this6 = this;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                rowSelection = _props.rowSelection;
	
	            var columns = this.columns.concat();
	            if (rowSelection) {
	                var data = this.getFlatCurrentPageData().filter(function (item, index) {
	                    if (rowSelection.getCheckboxProps) {
	                        return !_this6.getCheckboxPropsByItem(item, index).disabled;
	                    }
	                    return true;
	                });
	                var selectionColumnClass = (0, _classnames2['default'])(prefixCls + '-selection-column', (0, _defineProperty3['default'])({}, prefixCls + '-selection-column-custom', rowSelection.selections));
	                var selectionColumn = {
	                    key: 'selection-column',
	                    render: this.renderSelectionBox(rowSelection.type),
	                    className: selectionColumnClass,
	                    fixed: rowSelection.fixed
	                };
	                if (rowSelection.type !== 'radio') {
	                    var checkboxAllDisabled = data.every(function (item, index) {
	                        return _this6.getCheckboxPropsByItem(item, index).disabled;
	                    });
	                    selectionColumn.title = React.createElement(_SelectionCheckboxAll2['default'], { store: this.store, locale: locale, data: data, getCheckboxPropsByItem: this.getCheckboxPropsByItem, getRecordKey: this.getRecordKey, disabled: checkboxAllDisabled, prefixCls: prefixCls, onSelect: this.handleSelectRow, selections: rowSelection.selections, hideDefaultSelections: rowSelection.hideDefaultSelections, getPopupContainer: this.getPopupContainer });
	                }
	                if ('fixed' in rowSelection) {
	                    selectionColumn.fixed = rowSelection.fixed;
	                } else if (columns.some(function (column) {
	                    return column.fixed === 'left' || column.fixed === true;
	                })) {
	                    selectionColumn.fixed = 'left';
	                }
	                if (columns[0] && columns[0].key === 'selection-column') {
	                    columns[0] = selectionColumn;
	                } else {
	                    columns.unshift(selectionColumn);
	                }
	            }
	            return columns;
	        }
	    }, {
	        key: 'getColumnKey',
	        value: function getColumnKey(column, index) {
	            return column.key || column.dataIndex || index;
	        }
	    }, {
	        key: 'getMaxCurrent',
	        value: function getMaxCurrent(total) {
	            var _state$pagination = this.state.pagination,
	                current = _state$pagination.current,
	                pageSize = _state$pagination.pageSize;
	
	            if ((current - 1) * pageSize >= total) {
	                return Math.floor((total - 1) / pageSize) + 1;
	            }
	            return current;
	        }
	    }, {
	        key: 'isSortColumn',
	        value: function isSortColumn(column) {
	            var sortColumn = this.state.sortColumn;
	
	            if (!column || !sortColumn) {
	                return false;
	            }
	            return this.getColumnKey(sortColumn) === this.getColumnKey(column);
	        }
	    }, {
	        key: 'renderColumnsDropdown',
	        value: function renderColumnsDropdown(columns, locale) {
	            var _this7 = this;
	
	            var _props2 = this.props,
	                prefixCls = _props2.prefixCls,
	                dropdownPrefixCls = _props2.dropdownPrefixCls;
	            var sortOrder = this.state.sortOrder;
	
	            return (0, _util.treeMap)(columns, function (originColumn, i) {
	                var column = (0, _extends5['default'])({}, originColumn);
	                var key = _this7.getColumnKey(column, i);
	                var filterDropdown = void 0;
	                var sortButton = void 0;
	                if (column.filters && column.filters.length > 0 || column.filterDropdown) {
	                    var colFilters = _this7.state.filters[key] || [];
	                    filterDropdown = React.createElement(_filterDropdown2['default'], { locale: locale, column: column, selectedKeys: colFilters, confirmFilter: _this7.handleFilter, prefixCls: prefixCls + '-filter', dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown', getPopupContainer: _this7.getPopupContainer });
	                }
	                if (column.sorter) {
	                    var isSortColumn = _this7.isSortColumn(column);
	                    if (isSortColumn) {
	                        column.className = (0, _classnames2['default'])(column.className, (0, _defineProperty3['default'])({}, prefixCls + '-column-sort', sortOrder));
	                    }
	                    var isAscend = isSortColumn && sortOrder === 'ascend';
	                    var isDescend = isSortColumn && sortOrder === 'descend';
	                    sortButton = React.createElement(
	                        'div',
	                        { className: prefixCls + '-column-sorter' },
	                        React.createElement(
	                            'span',
	                            { className: prefixCls + '-column-sorter-up ' + (isAscend ? 'on' : 'off'), title: '\u2191', onClick: function onClick() {
	                                    return _this7.toggleSortOrder('ascend', column);
	                                } },
	                            React.createElement(_icon2['default'], { type: 'caret-up' })
	                        ),
	                        React.createElement(
	                            'span',
	                            { className: prefixCls + '-column-sorter-down ' + (isDescend ? 'on' : 'off'), title: '\u2193', onClick: function onClick() {
	                                    return _this7.toggleSortOrder('descend', column);
	                                } },
	                            React.createElement(_icon2['default'], { type: 'caret-down' })
	                        )
	                    );
	                }
	                column.title = React.createElement(
	                    'span',
	                    null,
	                    column.title,
	                    sortButton,
	                    filterDropdown
	                );
	                return column;
	            });
	        }
	    }, {
	        key: 'renderPagination',
	        value: function renderPagination() {
	            // 强制不需要分页
	            if (!this.hasPagination()) {
	                return null;
	            }
	            var size = 'default';
	            var pagination = this.state.pagination;
	
	            if (pagination.size) {
	                size = pagination.size;
	            } else if (this.props.size === 'middle' || this.props.size === 'small') {
	                size = 'small';
	            }
	            var total = pagination.total || this.getLocalData().length;
	            return total > 0 ? React.createElement(_pagination2['default'], (0, _extends5['default'])({ key: 'pagination' }, pagination, { className: (0, _classnames2['default'])(pagination.className, this.props.prefixCls + '-pagination'), onChange: this.handlePageChange, total: total, size: size, current: this.getMaxCurrent(total), onShowSizeChange: this.handleShowSizeChange })) : null;
	        }
	        // Get pagination, filters, sorter
	
	    }, {
	        key: 'prepareParamsArguments',
	        value: function prepareParamsArguments(state) {
	            var pagination = (0, _extends5['default'])({}, state.pagination);
	            // remove useless handle function in Table.onChange
	            delete pagination.onChange;
	            delete pagination.onShowSizeChange;
	            var filters = state.filters;
	            var sorter = {};
	            if (state.sortColumn && state.sortOrder) {
	                sorter.column = state.sortColumn;
	                sorter.order = state.sortOrder;
	                sorter.field = state.sortColumn.dataIndex;
	                sorter.columnKey = this.getColumnKey(state.sortColumn);
	            }
	            return [pagination, filters, sorter];
	        }
	    }, {
	        key: 'findColumn',
	        value: function findColumn(myKey) {
	            var _this8 = this;
	
	            var column = void 0;
	            (0, _util.treeMap)(this.columns, function (c) {
	                if (_this8.getColumnKey(c) === myKey) {
	                    column = c;
	                }
	            });
	            return column;
	        }
	    }, {
	        key: 'getCurrentPageData',
	        value: function getCurrentPageData() {
	            var data = this.getLocalData();
	            var current = void 0;
	            var pageSize = void 0;
	            var state = this.state;
	            // 如果没有分页的话，默认全部展示
	            if (!this.hasPagination()) {
	                pageSize = Number.MAX_VALUE;
	                current = 1;
	            } else {
	                pageSize = state.pagination.pageSize;
	                current = this.getMaxCurrent(state.pagination.total || data.length);
	            }
	            // 分页
	            // ---
	            // 当数据量少于等于每页数量时，直接设置数据
	            // 否则进行读取分页数据
	            if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
	                data = data.filter(function (_, i) {
	                    return i >= (current - 1) * pageSize && i < current * pageSize;
	                });
	            }
	            return data;
	        }
	    }, {
	        key: 'getFlatData',
	        value: function getFlatData() {
	            return (0, _util.flatArray)(this.getLocalData());
	        }
	    }, {
	        key: 'getFlatCurrentPageData',
	        value: function getFlatCurrentPageData() {
	            return (0, _util.flatArray)(this.getCurrentPageData());
	        }
	    }, {
	        key: 'recursiveSort',
	        value: function recursiveSort(data, sorterFn) {
	            var _this9 = this;
	
	            var _props$childrenColumn = this.props.childrenColumnName,
	                childrenColumnName = _props$childrenColumn === undefined ? 'children' : _props$childrenColumn;
	
	            return data.sort(sorterFn).map(function (item) {
	                return item[childrenColumnName] ? (0, _extends5['default'])({}, item, (0, _defineProperty3['default'])({}, childrenColumnName, _this9.recursiveSort(item[childrenColumnName], sorterFn))) : item;
	            });
	        }
	    }, {
	        key: 'getLocalData',
	        value: function getLocalData() {
	            var _this10 = this;
	
	            var state = this.state;
	            var dataSource = this.props.dataSource;
	
	            var data = dataSource || [];
	            // 优化本地排序
	            data = data.slice(0);
	            var sorterFn = this.getSorterFn();
	            if (sorterFn) {
	                data = this.recursiveSort(data, sorterFn);
	            }
	            // 筛选
	            if (state.filters) {
	                Object.keys(state.filters).forEach(function (columnKey) {
	                    var col = _this10.findColumn(columnKey);
	                    if (!col) {
	                        return;
	                    }
	                    var values = state.filters[columnKey] || [];
	                    if (values.length === 0) {
	                        return;
	                    }
	                    var onFilter = col.onFilter;
	                    data = onFilter ? data.filter(function (record) {
	                        return values.some(function (v) {
	                            return onFilter(v, record);
	                        });
	                    }) : data;
	                });
	            }
	            return data;
	        }
	    }, {
	        key: 'createComponents',
	        value: function createComponents() {
	            var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            var prevComponents = arguments[1];
	
	            var bodyRow = components && components.body && components.body.row;
	            var preBodyRow = prevComponents && prevComponents.body && prevComponents.body.row;
	            if (!this.components || bodyRow !== preBodyRow) {
	                this.components = (0, _extends5['default'])({}, components);
	                this.components.body = (0, _extends5['default'])({}, components.body, { row: (0, _createBodyRow2['default'])(bodyRow) });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props3 = this.props,
	                style = _props3.style,
	                className = _props3.className,
	                prefixCls = _props3.prefixCls;
	
	            var data = this.getCurrentPageData();
	            var table = React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Table', defaultLocale: _default2['default'].Table },
	                this.renderTable
	            );
	            // if there is no pagination or no data,
	            // the height of spin should decrease by half of pagination
	            var paginationPatchClass = this.hasPagination() && data && data.length !== 0 ? prefixCls + '-with-pagination' : prefixCls + '-without-pagination';
	            var loading = this.props.loading;
	            if (typeof loading === 'boolean') {
	                loading = {
	                    spinning: loading
	                };
	            }
	            return React.createElement(
	                'div',
	                { className: (0, _classnames2['default'])(prefixCls + '-wrapper', className), style: style },
	                React.createElement(
	                    _spin2['default'],
	                    (0, _extends5['default'])({}, loading, { className: loading ? paginationPatchClass + ' ' + prefixCls + '-spin-holder' : '' }),
	                    table,
	                    this.renderPagination()
	                )
	            );
	        }
	    }]);
	    return Table;
	}(React.Component);
	
	exports['default'] = Table;
	
	Table.Column = _Column2['default'];
	Table.ColumnGroup = _ColumnGroup2['default'];
	Table.propTypes = {
	    dataSource: _propTypes2['default'].array,
	    columns: _propTypes2['default'].array,
	    prefixCls: _propTypes2['default'].string,
	    useFixedHeader: _propTypes2['default'].bool,
	    rowSelection: _propTypes2['default'].object,
	    className: _propTypes2['default'].string,
	    size: _propTypes2['default'].string,
	    loading: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	    bordered: _propTypes2['default'].bool,
	    onChange: _propTypes2['default'].func,
	    locale: _propTypes2['default'].object,
	    dropdownPrefixCls: _propTypes2['default'].string
	};
	Table.defaultProps = {
	    dataSource: [],
	    prefixCls: 'ant-table',
	    useFixedHeader: false,
	    rowSelection: null,
	    className: '',
	    size: 'large',
	    loading: false,
	    bordered: false,
	    indentSize: 20,
	    locale: {},
	    rowKey: 'key',
	    showHeader: true
	};

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createTableRow;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function createTableRow() {
	    var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';
	
	    var BodyRow = function (_React$Component) {
	        (0, _inherits3['default'])(BodyRow, _React$Component);
	
	        function BodyRow(props) {
	            (0, _classCallCheck3['default'])(this, BodyRow);
	
	            var _this = (0, _possibleConstructorReturn3['default'])(this, (BodyRow.__proto__ || Object.getPrototypeOf(BodyRow)).call(this, props));
	
	            _this.store = props.store;
	
	            var _this$store$getState = _this.store.getState(),
	                selectedRowKeys = _this$store$getState.selectedRowKeys;
	
	            _this.state = {
	                selected: selectedRowKeys.indexOf(props.rowKey) >= 0
	            };
	            return _this;
	        }
	
	        (0, _createClass3['default'])(BodyRow, [{
	            key: 'componentDidMount',
	            value: function componentDidMount() {
	                this.subscribe();
	            }
	        }, {
	            key: 'componentWillUnmount',
	            value: function componentWillUnmount() {
	                if (this.unsubscribe) {
	                    this.unsubscribe();
	                }
	            }
	        }, {
	            key: 'subscribe',
	            value: function subscribe() {
	                var _this2 = this;
	
	                var _props = this.props,
	                    store = _props.store,
	                    rowKey = _props.rowKey;
	
	                this.unsubscribe = store.subscribe(function () {
	                    var _store$getState = _this2.store.getState(),
	                        selectedRowKeys = _store$getState.selectedRowKeys;
	
	                    var selected = selectedRowKeys.indexOf(rowKey) >= 0;
	                    if (selected !== _this2.state.selected) {
	                        _this2.setState({ selected: selected });
	                    }
	                });
	            }
	        }, {
	            key: 'render',
	            value: function render() {
	                var rowProps = (0, _omit2['default'])(this.props, ['prefixCls', 'rowKey', 'store']);
	                var className = (0, _classnames3['default'])(this.props.className, (0, _defineProperty3['default'])({}, this.props.prefixCls + '-row-selected', this.state.selected));
	                return React.createElement(
	                    Component,
	                    (0, _extends3['default'])({}, rowProps, { className: className }),
	                    this.props.children
	                );
	            }
	        }]);
	        return BodyRow;
	    }(React.Component);
	
	    return BodyRow;
	}

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports["default"] = createStore;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function createStore(initialState) {
	    var state = initialState;
	    var listeners = [];
	    function setState(partial) {
	        state = (0, _extends3["default"])({}, state, partial);
	        for (var i = 0; i < listeners.length; i++) {
	            listeners[i]();
	        }
	    }
	    function getState() {
	        return state;
	    }
	    function subscribe(listener) {
	        listeners.push(listener);
	        return function unsubscribe() {
	            var index = listeners.indexOf(listener);
	            listeners.splice(index, 1);
	        };
	    }
	    return {
	        setState: setState,
	        getState: getState,
	        subscribe: subscribe
	    };
	}

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _rcMenu = __webpack_require__(191);
	
	var _rcMenu2 = _interopRequireDefault(_rcMenu);
	
	var _domClosest = __webpack_require__(1892);
	
	var _domClosest2 = _interopRequireDefault(_domClosest);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _dropdown = __webpack_require__(382);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _checkbox = __webpack_require__(169);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _radio = __webpack_require__(272);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _FilterDropdownMenuWrapper = __webpack_require__(1504);
	
	var _FilterDropdownMenuWrapper2 = _interopRequireDefault(_FilterDropdownMenuWrapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FilterMenu = function (_React$Component) {
	    (0, _inherits3['default'])(FilterMenu, _React$Component);
	
	    function FilterMenu(props) {
	        (0, _classCallCheck3['default'])(this, FilterMenu);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (FilterMenu.__proto__ || Object.getPrototypeOf(FilterMenu)).call(this, props));
	
	        _this.setNeverShown = function (column) {
	            var rootNode = ReactDOM.findDOMNode(_this);
	            var filterBelongToScrollBody = !!(0, _domClosest2['default'])(rootNode, '.ant-table-scroll');
	            if (filterBelongToScrollBody) {
	                // When fixed column have filters, there will be two dropdown menus
	                // Filter dropdown menu inside scroll body should never be shown
	                // To fix https://github.com/ant-design/ant-design/issues/5010 and
	                // https://github.com/ant-design/ant-design/issues/7909
	                _this.neverShown = !!column.fixed;
	            }
	        };
	        _this.setSelectedKeys = function (_ref) {
	            var selectedKeys = _ref.selectedKeys;
	
	            _this.setState({ selectedKeys: selectedKeys });
	        };
	        _this.handleClearFilters = function () {
	            _this.setState({
	                selectedKeys: []
	            }, _this.handleConfirm);
	        };
	        _this.handleConfirm = function () {
	            _this.setVisible(false);
	            _this.confirmFilter();
	        };
	        _this.onVisibleChange = function (visible) {
	            _this.setVisible(visible);
	            if (!visible) {
	                _this.confirmFilter();
	            }
	        };
	        _this.handleMenuItemClick = function (info) {
	            if (info.keyPath.length <= 1) {
	                return;
	            }
	            var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
	            if (_this.state.selectedKeys.indexOf(info.key) >= 0) {
	                // deselect SubMenu child
	                delete keyPathOfSelectedItem[info.key];
	            } else {
	                // select SubMenu child
	                keyPathOfSelectedItem[info.key] = info.keyPath;
	            }
	            _this.setState({ keyPathOfSelectedItem: keyPathOfSelectedItem });
	        };
	        _this.renderFilterIcon = function () {
	            var _this$props = _this.props,
	                column = _this$props.column,
	                locale = _this$props.locale,
	                prefixCls = _this$props.prefixCls;
	
	            var filterIcon = column.filterIcon;
	            var dropdownSelectedClass = _this.props.selectedKeys.length > 0 ? prefixCls + '-selected' : '';
	            return filterIcon ? React.cloneElement(filterIcon, {
	                title: locale.filterTitle,
	                className: (0, _classnames2['default'])(filterIcon.className, (0, _defineProperty3['default'])({}, prefixCls + '-icon', true))
	            }) : React.createElement(_icon2['default'], { title: locale.filterTitle, type: 'filter', className: dropdownSelectedClass });
	        };
	        var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
	        _this.state = {
	            selectedKeys: props.selectedKeys,
	            keyPathOfSelectedItem: {},
	            visible: visible
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(FilterMenu, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var column = this.props.column;
	
	            this.setNeverShown(column);
	        }
	    }, {
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var column = nextProps.column;
	
	            this.setNeverShown(column);
	            var newState = {};
	            if ('selectedKeys' in nextProps) {
	                newState.selectedKeys = nextProps.selectedKeys;
	            }
	            if ('filterDropdownVisible' in column) {
	                newState.visible = column.filterDropdownVisible;
	            }
	            if (Object.keys(newState).length > 0) {
	                this.setState(newState);
	            }
	        }
	    }, {
	        key: 'setVisible',
	        value: function setVisible(visible) {
	            var column = this.props.column;
	
	            if (!('filterDropdownVisible' in column)) {
	                this.setState({ visible: visible });
	            }
	            if (column.onFilterDropdownVisibleChange) {
	                column.onFilterDropdownVisibleChange(visible);
	            }
	        }
	    }, {
	        key: 'confirmFilter',
	        value: function confirmFilter() {
	            if (this.state.selectedKeys !== this.props.selectedKeys) {
	                this.props.confirmFilter(this.props.column, this.state.selectedKeys);
	            }
	        }
	    }, {
	        key: 'renderMenuItem',
	        value: function renderMenuItem(item) {
	            var column = this.props.column;
	
	            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
	            var input = multiple ? React.createElement(_checkbox2['default'], { checked: this.state.selectedKeys.indexOf(item.value.toString()) >= 0 }) : React.createElement(_radio2['default'], { checked: this.state.selectedKeys.indexOf(item.value.toString()) >= 0 });
	            return React.createElement(
	                _rcMenu.Item,
	                { key: item.value },
	                input,
	                React.createElement(
	                    'span',
	                    null,
	                    item.text
	                )
	            );
	        }
	    }, {
	        key: 'hasSubMenu',
	        value: function hasSubMenu() {
	            var _props$column$filters = this.props.column.filters,
	                filters = _props$column$filters === undefined ? [] : _props$column$filters;
	
	            return filters.some(function (item) {
	                return !!(item.children && item.children.length > 0);
	            });
	        }
	    }, {
	        key: 'renderMenus',
	        value: function renderMenus(items) {
	            var _this2 = this;
	
	            return items.map(function (item) {
	                if (item.children && item.children.length > 0) {
	                    var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
	
	                    var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
	                        return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
	                    });
	                    var subMenuCls = containSelected ? _this2.props.dropdownPrefixCls + '-submenu-contain-selected' : '';
	                    return React.createElement(
	                        _rcMenu.SubMenu,
	                        { title: item.text, className: subMenuCls, key: item.value.toString() },
	                        _this2.renderMenus(item.children)
	                    );
	                }
	                return _this2.renderMenuItem(item);
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                column = _props.column,
	                locale = _props.locale,
	                prefixCls = _props.prefixCls,
	                dropdownPrefixCls = _props.dropdownPrefixCls,
	                getPopupContainer = _props.getPopupContainer;
	            // default multiple selection in filter dropdown
	
	            var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
	            var dropdownMenuClass = (0, _classnames2['default'])((0, _defineProperty3['default'])({}, dropdownPrefixCls + '-menu-without-submenu', !this.hasSubMenu()));
	            var menus = column.filterDropdown ? React.createElement(
	                _FilterDropdownMenuWrapper2['default'],
	                null,
	                column.filterDropdown
	            ) : React.createElement(
	                _FilterDropdownMenuWrapper2['default'],
	                { className: prefixCls + '-dropdown' },
	                React.createElement(
	                    _rcMenu2['default'],
	                    { multiple: multiple, onClick: this.handleMenuItemClick, prefixCls: dropdownPrefixCls + '-menu', className: dropdownMenuClass, onSelect: this.setSelectedKeys, onDeselect: this.setSelectedKeys, selectedKeys: this.state.selectedKeys },
	                    this.renderMenus(column.filters)
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-dropdown-btns' },
	                    React.createElement(
	                        'a',
	                        { className: prefixCls + '-dropdown-link confirm', onClick: this.handleConfirm },
	                        locale.filterConfirm
	                    ),
	                    React.createElement(
	                        'a',
	                        { className: prefixCls + '-dropdown-link clear', onClick: this.handleClearFilters },
	                        locale.filterReset
	                    )
	                )
	            );
	            return React.createElement(
	                _dropdown2['default'],
	                { trigger: ['click'], overlay: menus, visible: this.neverShown ? false : this.state.visible, onVisibleChange: this.onVisibleChange, getPopupContainer: getPopupContainer, forceRender: true },
	                this.renderFilterIcon()
	            );
	        }
	    }]);
	    return FilterMenu;
	}(React.Component);
	
	exports['default'] = FilterMenu;
	
	FilterMenu.defaultProps = {
	    handleFilter: function handleFilter() {},
	
	    column: {}
	};

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Table = __webpack_require__(1507);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Table2['default'];

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(176);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.flatArray = flatArray;
	exports.treeMap = treeMap;
	exports.flatFilter = flatFilter;
	exports.normalizeColumns = normalizeColumns;
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function flatArray() {
	    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	    var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
	
	    var result = [];
	    var loop = function loop(array) {
	        array.forEach(function (item) {
	            if (item[childrenName]) {
	                var newItem = (0, _extends3['default'])({}, item);
	                delete newItem[childrenName];
	                result.push(newItem);
	                if (item[childrenName].length > 0) {
	                    loop(item[childrenName]);
	                }
	            } else {
	                result.push(item);
	            }
	        });
	    };
	    loop(data);
	    return result;
	}
	function treeMap(tree, mapper) {
	    var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	
	    return tree.map(function (node, index) {
	        var extra = {};
	        if (node[childrenName]) {
	            extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
	        }
	        return (0, _extends3['default'])({}, mapper(node, index), extra);
	    });
	}
	function flatFilter(tree, callback) {
	    return tree.reduce(function (acc, node) {
	        if (callback(node)) {
	            acc.push(node);
	        }
	        if (node.children) {
	            var children = flatFilter(node.children, callback);
	            acc.push.apply(acc, (0, _toConsumableArray3['default'])(children));
	        }
	        return acc;
	    }, []);
	}
	function normalizeColumns(elements) {
	    var columns = [];
	    React.Children.forEach(elements, function (element) {
	        if (!React.isValidElement(element)) {
	            return;
	        }
	        var column = (0, _extends3['default'])({}, element.props);
	        if (element.key) {
	            column.key = element.key;
	        }
	        if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
	            column.children = normalizeColumns(column.children);
	        }
	        columns.push(column);
	    });
	    return columns;
	}

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var CheckableTag = function (_React$Component) {
	    (0, _inherits3['default'])(CheckableTag, _React$Component);
	
	    function CheckableTag() {
	        (0, _classCallCheck3['default'])(this, CheckableTag);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (CheckableTag.__proto__ || Object.getPrototypeOf(CheckableTag)).apply(this, arguments));
	
	        _this.handleClick = function () {
	            var _this$props = _this.props,
	                checked = _this$props.checked,
	                onChange = _this$props.onChange;
	
	            if (onChange) {
	                onChange(!checked);
	            }
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(CheckableTag, [{
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                _a$prefixCls = _a.prefixCls,
	                prefixCls = _a$prefixCls === undefined ? 'ant-tag' : _a$prefixCls,
	                className = _a.className,
	                checked = _a.checked,
	                restProps = __rest(_a, ["prefixCls", "className", "checked"]);
	            var cls = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-checkable', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-checkable-checked', checked), _classNames), className);
	            delete restProps.onChange; // TypeScript cannot check delete now.
	            return React.createElement('div', (0, _extends3['default'])({}, restProps, { className: cls, onClick: this.handleClick }));
	        }
	    }]);
	    return CheckableTag;
	}(React.Component);
	
	exports['default'] = CheckableTag;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _omit = __webpack_require__(58);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _CheckableTag = __webpack_require__(1513);
	
	var _CheckableTag2 = _interopRequireDefault(_CheckableTag);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Tag = function (_React$Component) {
	    (0, _inherits3['default'])(Tag, _React$Component);
	
	    function Tag(props) {
	        (0, _classCallCheck3['default'])(this, Tag);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Tag.__proto__ || Object.getPrototypeOf(Tag)).call(this, props));
	
	        _this.close = function (e) {
	            var onClose = _this.props.onClose;
	            if (onClose) {
	                onClose(e);
	            }
	            if (e.defaultPrevented) {
	                return;
	            }
	            var dom = ReactDOM.findDOMNode(_this);
	            dom.style.width = dom.getBoundingClientRect().width + 'px';
	            // It's Magic Code, don't know why
	            dom.style.width = dom.getBoundingClientRect().width + 'px';
	            _this.setState({
	                closing: true
	            });
	        };
	        _this.animationEnd = function (_, existed) {
	            if (!existed && !_this.state.closed) {
	                _this.setState({
	                    closed: true,
	                    closing: false
	                });
	                var afterClose = _this.props.afterClose;
	                if (afterClose) {
	                    afterClose();
	                }
	            }
	        };
	        _this.state = {
	            closing: false,
	            closed: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Tag, [{
	        key: 'isPresetColor',
	        value: function isPresetColor(color) {
	            if (!color) {
	                return false;
	            }
	            return (/^(pink|red|yellow|orange|cyan|green|blue|purple|geekblue|magenta|volcano|gold|lime)(-inverse)?$/.test(color)
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                closable = _a.closable,
	                color = _a.color,
	                className = _a.className,
	                children = _a.children,
	                style = _a.style,
	                otherProps = __rest(_a, ["prefixCls", "closable", "color", "className", "children", "style"]);
	            var closeIcon = closable ? React.createElement(_icon2['default'], { type: 'cross', onClick: this.close }) : '';
	            var isPresetColor = this.isPresetColor(color);
	            var classString = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-' + color, isPresetColor), (0, _defineProperty3['default'])(_classNames, prefixCls + '-has-color', color && !isPresetColor), (0, _defineProperty3['default'])(_classNames, prefixCls + '-close', this.state.closing), _classNames), className);
	            // fix https://fb.me/react-unknown-prop
	            var divProps = (0, _omit2['default'])(otherProps, ['onClose', 'afterClose']);
	            var tagStyle = (0, _extends3['default'])({ backgroundColor: color && !isPresetColor ? color : null }, style);
	            var tag = this.state.closed ? null : React.createElement(
	                'div',
	                (0, _extends3['default'])({ 'data-show': !this.state.closing }, divProps, { className: classString, style: tagStyle }),
	                React.createElement(
	                    'span',
	                    { className: prefixCls + '-text' },
	                    children
	                ),
	                closeIcon
	            );
	            return React.createElement(
	                _rcAnimate2['default'],
	                { component: '', showProp: 'data-show', transitionName: prefixCls + '-zoom', transitionAppear: true, onEnd: this.animationEnd },
	                tag
	            );
	        }
	    }]);
	    return Tag;
	}(React.Component);
	
	exports['default'] = Tag;
	
	Tag.CheckableTag = _CheckableTag2['default'];
	Tag.defaultProps = {
	    prefixCls: 'ant-tag',
	    closable: false
	};

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TimelineItem = __webpack_require__(1516);
	
	var _TimelineItem2 = _interopRequireDefault(_TimelineItem);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var Timeline = function (_React$Component) {
	    (0, _inherits3['default'])(Timeline, _React$Component);
	
	    function Timeline() {
	        (0, _classCallCheck3['default'])(this, Timeline);
	        return (0, _possibleConstructorReturn3['default'])(this, (Timeline.__proto__ || Object.getPrototypeOf(Timeline)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Timeline, [{
	        key: 'render',
	        value: function render() {
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                children = _a.children,
	                pending = _a.pending,
	                className = _a.className,
	                restProps = __rest(_a, ["prefixCls", "children", "pending", "className"]);
	            var pendingNode = typeof pending === 'boolean' ? null : pending;
	            var classString = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-pending', !!pending), className);
	            // Remove falsy items
	            var falsylessItems = React.Children.toArray(children).filter(function (item) {
	                return !!item;
	            });
	            var items = React.Children.map(falsylessItems, function (ele, idx) {
	                return React.cloneElement(ele, {
	                    last: idx === React.Children.count(falsylessItems) - 1
	                });
	            });
	            var pendingItem = !!pending ? React.createElement(
	                _TimelineItem2['default'],
	                { pending: !!pending, dot: React.createElement(_icon2['default'], { type: 'loading' }) },
	                pendingNode
	            ) : null;
	            return React.createElement(
	                'ul',
	                (0, _extends3['default'])({}, restProps, { className: classString }),
	                items,
	                pendingItem
	            );
	        }
	    }]);
	    return Timeline;
	}(React.Component);
	
	exports['default'] = Timeline;
	
	Timeline.Item = _TimelineItem2['default'];
	Timeline.defaultProps = {
	    prefixCls: 'ant-timeline'
	};

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var TimelineItem = function (_React$Component) {
	    (0, _inherits3['default'])(TimelineItem, _React$Component);
	
	    function TimelineItem() {
	        (0, _classCallCheck3['default'])(this, TimelineItem);
	        return (0, _possibleConstructorReturn3['default'])(this, (TimelineItem.__proto__ || Object.getPrototypeOf(TimelineItem)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(TimelineItem, [{
	        key: 'render',
	        value: function render() {
	            var _classNames, _classNames2;
	
	            var _a = this.props,
	                prefixCls = _a.prefixCls,
	                className = _a.className,
	                _a$color = _a.color,
	                color = _a$color === undefined ? '' : _a$color,
	                last = _a.last,
	                children = _a.children,
	                pending = _a.pending,
	                dot = _a.dot,
	                restProps = __rest(_a, ["prefixCls", "className", "color", "last", "children", "pending", "dot"]);
	            var itemClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-last', last), (0, _defineProperty3['default'])(_classNames, prefixCls + '-item-pending', pending), _classNames), className);
	            var dotClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-item-head', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-item-head-custom', dot), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-item-head-' + color, true), _classNames2));
	            return React.createElement(
	                'li',
	                (0, _extends3['default'])({}, restProps, { className: itemClassName }),
	                React.createElement('div', { className: prefixCls + '-item-tail' }),
	                React.createElement(
	                    'div',
	                    { className: dotClassName, style: { borderColor: /blue|red|green/.test(color) ? null : color } },
	                    dot
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-item-content' },
	                    children
	                )
	            );
	        }
	    }]);
	    return TimelineItem;
	}(React.Component);
	
	exports['default'] = TimelineItem;
	
	TimelineItem.defaultProps = {
	    prefixCls: 'ant-timeline',
	    color: 'blue',
	    last: false,
	    pending: false
	};

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Timeline = __webpack_require__(1515);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Timeline2['default'];

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getOverflowOptions = getOverflowOptions;
	exports['default'] = getPlacements;
	
	var _placements = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var autoAdjustOverflowEnabled = {
	    adjustX: 1,
	    adjustY: 1
	};
	var autoAdjustOverflowDisabled = {
	    adjustX: 0,
	    adjustY: 0
	};
	var targetOffset = [0, 0];
	function getOverflowOptions(autoAdjustOverflow) {
	    if (typeof autoAdjustOverflow === 'boolean') {
	        return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
	    }
	    return (0, _extends3['default'])({}, autoAdjustOverflowDisabled, autoAdjustOverflow);
	}
	function getPlacements() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var _config$arrowWidth = config.arrowWidth,
	        arrowWidth = _config$arrowWidth === undefined ? 5 : _config$arrowWidth,
	        _config$horizontalArr = config.horizontalArrowShift,
	        horizontalArrowShift = _config$horizontalArr === undefined ? 16 : _config$horizontalArr,
	        _config$verticalArrow = config.verticalArrowShift,
	        verticalArrowShift = _config$verticalArrow === undefined ? 12 : _config$verticalArrow,
	        _config$autoAdjustOve = config.autoAdjustOverflow,
	        autoAdjustOverflow = _config$autoAdjustOve === undefined ? true : _config$autoAdjustOve;
	
	    var placementMap = {
	        left: {
	            points: ['cr', 'cl'],
	            offset: [-4, 0]
	        },
	        right: {
	            points: ['cl', 'cr'],
	            offset: [4, 0]
	        },
	        top: {
	            points: ['bc', 'tc'],
	            offset: [0, -4]
	        },
	        bottom: {
	            points: ['tc', 'bc'],
	            offset: [0, 4]
	        },
	        topLeft: {
	            points: ['bl', 'tc'],
	            offset: [-(horizontalArrowShift + arrowWidth), -4]
	        },
	        leftTop: {
	            points: ['tr', 'cl'],
	            offset: [-4, -(verticalArrowShift + arrowWidth)]
	        },
	        topRight: {
	            points: ['br', 'tc'],
	            offset: [horizontalArrowShift + arrowWidth, -4]
	        },
	        rightTop: {
	            points: ['tl', 'cr'],
	            offset: [4, -(verticalArrowShift + arrowWidth)]
	        },
	        bottomRight: {
	            points: ['tr', 'bc'],
	            offset: [horizontalArrowShift + arrowWidth, 4]
	        },
	        rightBottom: {
	            points: ['bl', 'cr'],
	            offset: [4, verticalArrowShift + arrowWidth]
	        },
	        bottomLeft: {
	            points: ['tl', 'bc'],
	            offset: [-(horizontalArrowShift + arrowWidth), 4]
	        },
	        leftBottom: {
	            points: ['br', 'cl'],
	            offset: [-4, verticalArrowShift + arrowWidth]
	        }
	    };
	    Object.keys(placementMap).forEach(function (key) {
	        placementMap[key] = config.arrowPointAtCenter ? (0, _extends3['default'])({}, placementMap[key], { overflow: getOverflowOptions(autoAdjustOverflow), targetOffset: targetOffset }) : (0, _extends3['default'])({}, _placements.placements[key], { overflow: getOverflowOptions(autoAdjustOverflow) });
	    });
	    return placementMap;
	}

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(176);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _list = __webpack_require__(1521);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _operation = __webpack_require__(1522);
	
	var _operation2 = _interopRequireDefault(_operation);
	
	var _search = __webpack_require__(603);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _default = __webpack_require__(116);
	
	var _default2 = _interopRequireDefault(_default);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var Transfer = function (_React$Component) {
	    (0, _inherits3['default'])(Transfer, _React$Component);
	
	    function Transfer(props) {
	        (0, _classCallCheck3['default'])(this, Transfer);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (Transfer.__proto__ || Object.getPrototypeOf(Transfer)).call(this, props));
	
	        _this.moveTo = function (direction) {
	            var _this$props = _this.props,
	                _this$props$targetKey = _this$props.targetKeys,
	                targetKeys = _this$props$targetKey === undefined ? [] : _this$props$targetKey,
	                _this$props$dataSourc = _this$props.dataSource,
	                dataSource = _this$props$dataSourc === undefined ? [] : _this$props$dataSourc,
	                onChange = _this$props.onChange;
	            var _this$state = _this.state,
	                sourceSelectedKeys = _this$state.sourceSelectedKeys,
	                targetSelectedKeys = _this$state.targetSelectedKeys;
	
	            var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys;
	            // filter the disabled options
	            var newMoveKeys = moveKeys.filter(function (key) {
	                return !dataSource.some(function (data) {
	                    return !!(key === data.key && data.disabled);
	                });
	            });
	            // move items to target box
	            var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
	                return newMoveKeys.indexOf(targetKey) === -1;
	            });
	            // empty checked keys
	            var oppositeDirection = direction === 'right' ? 'left' : 'right';
	            _this.setState((0, _defineProperty3['default'])({}, _this.getSelectedKeysName(oppositeDirection), []));
	            _this.handleSelectChange(oppositeDirection, []);
	            if (onChange) {
	                onChange(newTargetKeys, direction, newMoveKeys);
	            }
	        };
	        _this.moveToLeft = function () {
	            return _this.moveTo('left');
	        };
	        _this.moveToRight = function () {
	            return _this.moveTo('right');
	        };
	        _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
	            var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
	            var currentKeys = filteredDataSource.map(function (item) {
	                return item.key;
	            });
	            // Only operate current keys from original selected keys
	            var newKeys1 = originalSelectedKeys.filter(function (key) {
	                return currentKeys.indexOf(key) === -1;
	            });
	            var newKeys2 = [].concat((0, _toConsumableArray3['default'])(originalSelectedKeys));
	            currentKeys.forEach(function (key) {
	                if (newKeys2.indexOf(key) === -1) {
	                    newKeys2.push(key);
	                }
	            });
	            var holder = checkAll ? newKeys1 : newKeys2;
	            _this.handleSelectChange(direction, holder);
	            if (!_this.props.selectedKeys) {
	                _this.setState((0, _defineProperty3['default'])({}, _this.getSelectedKeysName(direction), holder));
	            }
	        };
	        _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
	            return _this.handleSelectAll('left', filteredDataSource, checkAll);
	        };
	        _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
	            return _this.handleSelectAll('right', filteredDataSource, checkAll);
	        };
	        _this.handleFilter = function (direction, e) {
	            _this.setState((0, _defineProperty3['default'])({}, direction + 'Filter', e.target.value));
	            if (_this.props.onSearchChange) {
	                _this.props.onSearchChange(direction, e);
	            }
	        };
	        _this.handleLeftFilter = function (e) {
	            return _this.handleFilter('left', e);
	        };
	        _this.handleRightFilter = function (e) {
	            return _this.handleFilter('right', e);
	        };
	        _this.handleClear = function (direction) {
	            _this.setState((0, _defineProperty3['default'])({}, direction + 'Filter', ''));
	        };
	        _this.handleLeftClear = function () {
	            return _this.handleClear('left');
	        };
	        _this.handleRightClear = function () {
	            return _this.handleClear('right');
	        };
	        _this.handleSelect = function (direction, selectedItem, checked) {
	            var _this$state2 = _this.state,
	                sourceSelectedKeys = _this$state2.sourceSelectedKeys,
	                targetSelectedKeys = _this$state2.targetSelectedKeys;
	
	            var holder = direction === 'left' ? [].concat((0, _toConsumableArray3['default'])(sourceSelectedKeys)) : [].concat((0, _toConsumableArray3['default'])(targetSelectedKeys));
	            var index = holder.indexOf(selectedItem.key);
	            if (index > -1) {
	                holder.splice(index, 1);
	            }
	            if (checked) {
	                holder.push(selectedItem.key);
	            }
	            _this.handleSelectChange(direction, holder);
	            if (!_this.props.selectedKeys) {
	                _this.setState((0, _defineProperty3['default'])({}, _this.getSelectedKeysName(direction), holder));
	            }
	        };
	        _this.handleLeftSelect = function (selectedItem, checked) {
	            return _this.handleSelect('left', selectedItem, checked);
	        };
	        _this.handleRightSelect = function (selectedItem, checked) {
	            return _this.handleSelect('right', selectedItem, checked);
	        };
	        _this.handleScroll = function (direction, e) {
	            var onScroll = _this.props.onScroll;
	
	            if (onScroll) {
	                onScroll(direction, e);
	            }
	        };
	        _this.handleLeftScroll = function (e) {
	            return _this.handleScroll('left', e);
	        };
	        _this.handleRightScroll = function (e) {
	            return _this.handleScroll('right', e);
	        };
	        _this.renderTransfer = function (locale) {
	            var _this$props2 = _this.props,
	                _this$props2$prefixCl = _this$props2.prefixCls,
	                prefixCls = _this$props2$prefixCl === undefined ? 'ant-transfer' : _this$props2$prefixCl,
	                className = _this$props2.className,
	                _this$props2$operatio = _this$props2.operations,
	                operations = _this$props2$operatio === undefined ? [] : _this$props2$operatio,
	                showSearch = _this$props2.showSearch,
	                notFoundContent = _this$props2.notFoundContent,
	                searchPlaceholder = _this$props2.searchPlaceholder,
	                body = _this$props2.body,
	                footer = _this$props2.footer,
	                listStyle = _this$props2.listStyle,
	                filterOption = _this$props2.filterOption,
	                render = _this$props2.render,
	                lazy = _this$props2.lazy;
	            var _this$state3 = _this.state,
	                leftFilter = _this$state3.leftFilter,
	                rightFilter = _this$state3.rightFilter,
	                sourceSelectedKeys = _this$state3.sourceSelectedKeys,
	                targetSelectedKeys = _this$state3.targetSelectedKeys;
	
	            var _this$splitDataSource = _this.splitDataSource(_this.props),
	                leftDataSource = _this$splitDataSource.leftDataSource,
	                rightDataSource = _this$splitDataSource.rightDataSource;
	
	            var leftActive = targetSelectedKeys.length > 0;
	            var rightActive = sourceSelectedKeys.length > 0;
	            var cls = (0, _classnames2['default'])(className, prefixCls);
	            var titles = _this.getTitles(locale);
	            return React.createElement(
	                'div',
	                { className: cls },
	                React.createElement(_list2['default'], { prefixCls: prefixCls + '-list', titleText: titles[0], dataSource: leftDataSource, filter: leftFilter, filterOption: filterOption, style: listStyle, checkedKeys: sourceSelectedKeys, handleFilter: _this.handleLeftFilter, handleClear: _this.handleLeftClear, handleSelect: _this.handleLeftSelect, handleSelectAll: _this.handleLeftSelectAll, render: render, showSearch: showSearch, searchPlaceholder: searchPlaceholder || locale.searchPlaceholder, notFoundContent: notFoundContent || locale.notFoundContent, itemUnit: locale.itemUnit, itemsUnit: locale.itemsUnit, body: body, footer: footer, lazy: lazy, onScroll: _this.handleLeftScroll }),
	                React.createElement(_operation2['default'], { className: prefixCls + '-operation', rightActive: rightActive, rightArrowText: operations[0], moveToRight: _this.moveToRight, leftActive: leftActive, leftArrowText: operations[1], moveToLeft: _this.moveToLeft }),
	                React.createElement(_list2['default'], { prefixCls: prefixCls + '-list', titleText: titles[1], dataSource: rightDataSource, filter: rightFilter, filterOption: filterOption, style: listStyle, checkedKeys: targetSelectedKeys, handleFilter: _this.handleRightFilter, handleClear: _this.handleRightClear, handleSelect: _this.handleRightSelect, handleSelectAll: _this.handleRightSelectAll, render: render, showSearch: showSearch, searchPlaceholder: searchPlaceholder || locale.searchPlaceholder, notFoundContent: notFoundContent || locale.notFoundContent, itemUnit: locale.itemUnit, itemsUnit: locale.itemsUnit, body: body, footer: footer, lazy: lazy, onScroll: _this.handleRightScroll })
	            );
	        };
	        var _props$selectedKeys = props.selectedKeys,
	            selectedKeys = _props$selectedKeys === undefined ? [] : _props$selectedKeys,
	            _props$targetKeys = props.targetKeys,
	            targetKeys = _props$targetKeys === undefined ? [] : _props$targetKeys;
	
	        _this.state = {
	            leftFilter: '',
	            rightFilter: '',
	            sourceSelectedKeys: selectedKeys.filter(function (key) {
	                return targetKeys.indexOf(key) === -1;
	            }),
	            targetSelectedKeys: selectedKeys.filter(function (key) {
	                return targetKeys.indexOf(key) > -1;
	            })
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(Transfer, [{
	        key: 'componentWillReceiveProps',
	        value: function componentWillReceiveProps(nextProps) {
	            var _state = this.state,
	                sourceSelectedKeys = _state.sourceSelectedKeys,
	                targetSelectedKeys = _state.targetSelectedKeys;
	
	            if (nextProps.targetKeys !== this.props.targetKeys || nextProps.dataSource !== this.props.dataSource) {
	                // clear cached splited dataSource
	                this.splitedDataSource = null;
	                if (!nextProps.selectedKeys) {
	                    // clear key nolonger existed
	                    // clear checkedKeys according to targetKeys
	                    var dataSource = nextProps.dataSource,
	                        _nextProps$targetKeys = nextProps.targetKeys,
	                        targetKeys = _nextProps$targetKeys === undefined ? [] : _nextProps$targetKeys;
	
	                    var newSourceSelectedKeys = [];
	                    var newTargetSelectedKeys = [];
	                    dataSource.forEach(function (_ref) {
	                        var key = _ref.key;
	
	                        if (sourceSelectedKeys.includes(key) && !targetKeys.includes(key)) {
	                            newSourceSelectedKeys.push(key);
	                        }
	                        if (targetSelectedKeys.includes(key) && targetKeys.includes(key)) {
	                            newTargetSelectedKeys.push(key);
	                        }
	                    });
	                    this.setState({
	                        sourceSelectedKeys: newSourceSelectedKeys,
	                        targetSelectedKeys: newTargetSelectedKeys
	                    });
	                }
	            }
	            if (nextProps.selectedKeys) {
	                var _targetKeys = nextProps.targetKeys || [];
	                this.setState({
	                    sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	                        return !_targetKeys.includes(key);
	                    }),
	                    targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	                        return _targetKeys.includes(key);
	                    })
	                });
	            }
	        }
	    }, {
	        key: 'splitDataSource',
	        value: function splitDataSource(props) {
	            if (this.splitedDataSource) {
	                return this.splitedDataSource;
	            }
	            var dataSource = props.dataSource,
	                rowKey = props.rowKey,
	                _props$targetKeys2 = props.targetKeys,
	                targetKeys = _props$targetKeys2 === undefined ? [] : _props$targetKeys2;
	
	            var leftDataSource = [];
	            var rightDataSource = new Array(targetKeys.length);
	            dataSource.forEach(function (record) {
	                if (rowKey) {
	                    record.key = rowKey(record);
	                }
	                // rightDataSource should be ordered by targetKeys
	                // leftDataSource should be ordered by dataSource
	                var indexOfKey = targetKeys.indexOf(record.key);
	                if (indexOfKey !== -1) {
	                    rightDataSource[indexOfKey] = record;
	                } else {
	                    leftDataSource.push(record);
	                }
	            });
	            this.splitedDataSource = {
	                leftDataSource: leftDataSource,
	                rightDataSource: rightDataSource
	            };
	            return this.splitedDataSource;
	        }
	    }, {
	        key: 'handleSelectChange',
	        value: function handleSelectChange(direction, holder) {
	            var _state2 = this.state,
	                sourceSelectedKeys = _state2.sourceSelectedKeys,
	                targetSelectedKeys = _state2.targetSelectedKeys;
	
	            var onSelectChange = this.props.onSelectChange;
	            if (!onSelectChange) {
	                return;
	            }
	            if (direction === 'left') {
	                onSelectChange(holder, targetSelectedKeys);
	            } else {
	                onSelectChange(sourceSelectedKeys, holder);
	            }
	        }
	    }, {
	        key: 'getTitles',
	        value: function getTitles(transferLocale) {
	            var props = this.props;
	
	            if (props.titles) {
	                return props.titles;
	            }
	            return transferLocale.titles;
	        }
	    }, {
	        key: 'getSelectedKeysName',
	        value: function getSelectedKeysName(direction) {
	            return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Transfer', defaultLocale: _default2['default'].Transfer },
	                this.renderTransfer
	            );
	        }
	    }]);
	    return Transfer;
	}(React.Component);
	// For high-level customized Transfer @dqaria
	
	
	exports['default'] = Transfer;
	Transfer.List = _list2['default'];
	Transfer.Operation = _operation2['default'];
	Transfer.Search = _search2['default'];
	Transfer.defaultProps = {
	    dataSource: [],
	    render: noop,
	    showSearch: false
	};
	Transfer.propTypes = {
	    prefixCls: _propTypes2['default'].string,
	    dataSource: _propTypes2['default'].array,
	    render: _propTypes2['default'].func,
	    targetKeys: _propTypes2['default'].array,
	    onChange: _propTypes2['default'].func,
	    height: _propTypes2['default'].number,
	    listStyle: _propTypes2['default'].object,
	    className: _propTypes2['default'].string,
	    titles: _propTypes2['default'].array,
	    operations: _propTypes2['default'].array,
	    showSearch: _propTypes2['default'].bool,
	    filterOption: _propTypes2['default'].func,
	    searchPlaceholder: _propTypes2['default'].string,
	    notFoundContent: _propTypes2['default'].node,
	    body: _propTypes2['default'].func,
	    footer: _propTypes2['default'].func,
	    rowKey: _propTypes2['default'].func,
	    lazy: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].bool])
	};

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRenderMixin = __webpack_require__(239);
	
	var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);
	
	var _reactLazyLoad = __webpack_require__(2747);
	
	var _reactLazyLoad2 = _interopRequireDefault(_reactLazyLoad);
	
	var _checkbox = __webpack_require__(169);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Item = function (_React$Component) {
	    (0, _inherits3['default'])(Item, _React$Component);
	
	    function Item() {
	        (0, _classCallCheck3['default'])(this, Item);
	        return (0, _possibleConstructorReturn3['default'])(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Item, [{
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _PureRenderMixin2['default'].shouldComponentUpdate.apply(this, args);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _classNames;
	
	            var _props = this.props,
	                renderedText = _props.renderedText,
	                renderedEl = _props.renderedEl,
	                item = _props.item,
	                lazy = _props.lazy,
	                checked = _props.checked,
	                prefixCls = _props.prefixCls,
	                onClick = _props.onClick;
	
	            var className = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-content-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-content-item-disabled', item.disabled), _classNames));
	            var listItem = React.createElement(
	                'li',
	                { className: className, title: renderedText, onClick: item.disabled ? undefined : function () {
	                        return onClick(item);
	                    } },
	                React.createElement(_checkbox2['default'], { checked: checked, disabled: item.disabled }),
	                React.createElement(
	                    'span',
	                    null,
	                    renderedEl
	                )
	            );
	            var children = null;
	            if (lazy) {
	                var lazyProps = (0, _extends3['default'])({ height: 32, offset: 500, throttle: 0, debounce: false }, lazy);
	                children = React.createElement(
	                    _reactLazyLoad2['default'],
	                    lazyProps,
	                    listItem
	                );
	            } else {
	                children = listItem;
	            }
	            return children;
	        }
	    }]);
	    return Item;
	}(React.Component);
	
	exports['default'] = Item;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PureRenderMixin = __webpack_require__(239);
	
	var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);
	
	var _checkbox = __webpack_require__(169);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _search = __webpack_require__(603);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _item = __webpack_require__(1520);
	
	var _item2 = _interopRequireDefault(_item);
	
	var _triggerEvent = __webpack_require__(1428);
	
	var _triggerEvent2 = _interopRequireDefault(_triggerEvent);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	function isRenderResultPlainObject(result) {
	    return result && !React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
	}
	
	var TransferList = function (_React$Component) {
	    (0, _inherits3['default'])(TransferList, _React$Component);
	
	    function TransferList(props) {
	        (0, _classCallCheck3['default'])(this, TransferList);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (TransferList.__proto__ || Object.getPrototypeOf(TransferList)).call(this, props));
	
	        _this.handleSelect = function (selectedItem) {
	            var checkedKeys = _this.props.checkedKeys;
	
	            var result = checkedKeys.some(function (key) {
	                return key === selectedItem.key;
	            });
	            _this.props.handleSelect(selectedItem, !result);
	        };
	        _this.handleFilter = function (e) {
	            _this.props.handleFilter(e);
	            if (!e.target.value) {
	                return;
	            }
	            // Manually trigger scroll event for lazy search bug
	            // https://github.com/ant-design/ant-design/issues/5631
	            _this.triggerScrollTimer = window.setTimeout(function () {
	                var listNode = ReactDOM.findDOMNode(_this).querySelectorAll('.ant-transfer-list-content')[0];
	                if (listNode) {
	                    (0, _triggerEvent2['default'])(listNode, 'scroll');
	                }
	            }, 0);
	        };
	        _this.handleClear = function () {
	            _this.props.handleClear();
	        };
	        _this.matchFilter = function (text, item) {
	            var _this$props = _this.props,
	                filter = _this$props.filter,
	                filterOption = _this$props.filterOption;
	
	            if (filterOption) {
	                return filterOption(filter, item);
	            }
	            return text.indexOf(filter) >= 0;
	        };
	        _this.renderItem = function (item) {
	            var _this$props$render = _this.props.render,
	                render = _this$props$render === undefined ? noop : _this$props$render;
	
	            var renderResult = render(item);
	            var isRenderResultPlain = isRenderResultPlainObject(renderResult);
	            return {
	                renderedText: isRenderResultPlain ? renderResult.value : renderResult,
	                renderedEl: isRenderResultPlain ? renderResult.label : renderResult
	            };
	        };
	        _this.state = {
	            mounted: false
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(TransferList, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            this.timer = window.setTimeout(function () {
	                _this2.setState({
	                    mounted: true
	                });
	            }, 0);
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            clearTimeout(this.timer);
	            clearTimeout(this.triggerScrollTimer);
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate() {
	            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                args[_key] = arguments[_key];
	            }
	
	            return _PureRenderMixin2['default'].shouldComponentUpdate.apply(this, args);
	        }
	    }, {
	        key: 'getCheckStatus',
	        value: function getCheckStatus(filteredDataSource) {
	            var checkedKeys = this.props.checkedKeys;
	
	            if (checkedKeys.length === 0) {
	                return 'none';
	            } else if (filteredDataSource.every(function (item) {
	                return checkedKeys.indexOf(item.key) >= 0;
	            })) {
	                return 'all';
	            }
	            return 'part';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                dataSource = _props.dataSource,
	                titleText = _props.titleText,
	                checkedKeys = _props.checkedKeys,
	                lazy = _props.lazy,
	                _props$body = _props.body,
	                body = _props$body === undefined ? noop : _props$body,
	                _props$footer = _props.footer,
	                footer = _props$footer === undefined ? noop : _props$footer,
	                showSearch = _props.showSearch,
	                style = _props.style,
	                filter = _props.filter,
	                searchPlaceholder = _props.searchPlaceholder,
	                notFoundContent = _props.notFoundContent,
	                itemUnit = _props.itemUnit,
	                itemsUnit = _props.itemsUnit,
	                onScroll = _props.onScroll;
	            // Custom Layout
	
	            var footerDom = footer((0, _extends3['default'])({}, this.props));
	            var bodyDom = body((0, _extends3['default'])({}, this.props));
	            var listCls = (0, _classnames2['default'])(prefixCls, (0, _defineProperty3['default'])({}, prefixCls + '-with-footer', !!footerDom));
	            var filteredDataSource = [];
	            var totalDataSource = [];
	            var showItems = dataSource.map(function (item) {
	                var _renderItem = _this3.renderItem(item),
	                    renderedText = _renderItem.renderedText,
	                    renderedEl = _renderItem.renderedEl;
	
	                if (filter && filter.trim() && !_this3.matchFilter(renderedText, item)) {
	                    return null;
	                }
	                // all show items
	                totalDataSource.push(item);
	                if (!item.disabled) {
	                    // response to checkAll items
	                    filteredDataSource.push(item);
	                }
	                var checked = checkedKeys.indexOf(item.key) >= 0;
	                return React.createElement(_item2['default'], { key: item.key, item: item, lazy: lazy, renderedText: renderedText, renderedEl: renderedEl, checked: checked, prefixCls: prefixCls, onClick: _this3.handleSelect });
	            });
	            var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
	            var search = showSearch ? React.createElement(
	                'div',
	                { className: prefixCls + '-body-search-wrapper' },
	                React.createElement(_search2['default'], { prefixCls: prefixCls + '-search', onChange: this.handleFilter, handleClear: this.handleClear, placeholder: searchPlaceholder, value: filter })
	            ) : null;
	            var listBody = bodyDom || React.createElement(
	                'div',
	                { className: showSearch ? prefixCls + '-body ' + prefixCls + '-body-with-search' : prefixCls + '-body' },
	                search,
	                React.createElement(
	                    _rcAnimate2['default'],
	                    { component: 'ul', componentProps: { onScroll: onScroll }, className: prefixCls + '-content', transitionName: this.state.mounted ? prefixCls + '-content-item-highlight' : '', transitionLeave: false },
	                    showItems
	                ),
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-body-not-found' },
	                    notFoundContent
	                )
	            );
	            var listFooter = footerDom ? React.createElement(
	                'div',
	                { className: prefixCls + '-footer' },
	                footerDom
	            ) : null;
	            var checkStatus = this.getCheckStatus(filteredDataSource);
	            var checkedAll = checkStatus === 'all';
	            var checkAllCheckbox = React.createElement(_checkbox2['default'], { ref: 'checkbox', checked: checkedAll, indeterminate: checkStatus === 'part', onChange: function onChange() {
	                    return _this3.props.handleSelectAll(filteredDataSource, checkedAll);
	                } });
	            return React.createElement(
	                'div',
	                { className: listCls, style: style },
	                React.createElement(
	                    'div',
	                    { className: prefixCls + '-header' },
	                    checkAllCheckbox,
	                    React.createElement(
	                        'span',
	                        { className: prefixCls + '-header-selected' },
	                        React.createElement(
	                            'span',
	                            null,
	                            (checkedKeys.length > 0 ? checkedKeys.length + '/' : '') + totalDataSource.length,
	                            ' ',
	                            unit
	                        ),
	                        React.createElement(
	                            'span',
	                            { className: prefixCls + '-header-title' },
	                            titleText
	                        )
	                    )
	                ),
	                listBody,
	                listFooter
	            );
	        }
	    }]);
	    return TransferList;
	}(React.Component);
	
	exports['default'] = TransferList;
	
	TransferList.defaultProps = {
	    dataSource: [],
	    titleText: '',
	    showSearch: false,
	    render: noop,
	    lazy: {}
	};

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _button = __webpack_require__(142);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var Operation = function (_React$Component) {
	  (0, _inherits3['default'])(Operation, _React$Component);
	
	  function Operation() {
	    (0, _classCallCheck3['default'])(this, Operation);
	    return (0, _possibleConstructorReturn3['default'])(this, (Operation.__proto__ || Object.getPrototypeOf(Operation)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(Operation, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$moveToLeft = _props.moveToLeft,
	          moveToLeft = _props$moveToLeft === undefined ? noop : _props$moveToLeft,
	          _props$moveToRight = _props.moveToRight,
	          moveToRight = _props$moveToRight === undefined ? noop : _props$moveToRight,
	          _props$leftArrowText = _props.leftArrowText,
	          leftArrowText = _props$leftArrowText === undefined ? '' : _props$leftArrowText,
	          _props$rightArrowText = _props.rightArrowText,
	          rightArrowText = _props$rightArrowText === undefined ? '' : _props$rightArrowText,
	          leftActive = _props.leftActive,
	          rightActive = _props.rightActive,
	          className = _props.className;
	
	      return React.createElement(
	        'div',
	        { className: className },
	        React.createElement(
	          _button2['default'],
	          { type: 'primary', size: 'small', disabled: !leftActive, onClick: moveToLeft, icon: 'left' },
	          leftArrowText
	        ),
	        React.createElement(
	          _button2['default'],
	          { type: 'primary', size: 'small', disabled: !rightActive, onClick: moveToRight, icon: 'right' },
	          rightArrowText
	        )
	      );
	    }
	  }]);
	  return Operation;
	}(React.Component);
	
	exports['default'] = Operation;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcTreeSelect = __webpack_require__(2625);
	
	var _rcTreeSelect2 = _interopRequireDefault(_rcTreeSelect);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _LocaleReceiver = __webpack_require__(75);
	
	var _LocaleReceiver2 = _interopRequireDefault(_LocaleReceiver);
	
	var _warning = __webpack_require__(74);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var TreeSelect = function (_React$Component) {
	    (0, _inherits3['default'])(TreeSelect, _React$Component);
	
	    function TreeSelect(props) {
	        (0, _classCallCheck3['default'])(this, TreeSelect);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (TreeSelect.__proto__ || Object.getPrototypeOf(TreeSelect)).call(this, props));
	
	        _this.saveTreeSelect = function (node) {
	            _this.rcTreeSelect = node;
	        };
	        _this.renderTreeSelect = function (locale) {
	            var _classNames;
	
	            var _a = _this.props,
	                prefixCls = _a.prefixCls,
	                className = _a.className,
	                size = _a.size,
	                notFoundContent = _a.notFoundContent,
	                dropdownStyle = _a.dropdownStyle,
	                restProps = __rest(_a, ["prefixCls", "className", "size", "notFoundContent", "dropdownStyle"]);
	            var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-lg', size === 'large'), (0, _defineProperty3['default'])(_classNames, prefixCls + '-sm', size === 'small'), _classNames), className);
	            var checkable = restProps.treeCheckable;
	            if (checkable) {
	                checkable = React.createElement('span', { className: prefixCls + '-tree-checkbox-inner' });
	            }
	            return React.createElement(_rcTreeSelect2['default'], (0, _extends3['default'])({}, restProps, { prefixCls: prefixCls, className: cls, dropdownStyle: (0, _extends3['default'])({ maxHeight: '100vh', overflow: 'auto' }, dropdownStyle), treeCheckable: checkable, notFoundContent: notFoundContent || locale.notFoundContent, ref: _this.saveTreeSelect }));
	        };
	        (0, _warning2['default'])(props.multiple !== false || !props.treeCheckable, '`multiple` will alway be `true` when `treeCheckable` is true');
	        return _this;
	    }
	
	    (0, _createClass3['default'])(TreeSelect, [{
	        key: 'focus',
	        value: function focus() {
	            this.rcTreeSelect.focus();
	        }
	    }, {
	        key: 'blur',
	        value: function blur() {
	            this.rcTreeSelect.blur();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return React.createElement(
	                _LocaleReceiver2['default'],
	                { componentName: 'Select', defaultLocale: {} },
	                this.renderTreeSelect
	            );
	        }
	    }]);
	    return TreeSelect;
	}(React.Component);
	
	exports['default'] = TreeSelect;
	
	TreeSelect.TreeNode = _rcTreeSelect.TreeNode;
	TreeSelect.SHOW_ALL = _rcTreeSelect.SHOW_ALL;
	TreeSelect.SHOW_PARENT = _rcTreeSelect.SHOW_PARENT;
	TreeSelect.SHOW_CHILD = _rcTreeSelect.SHOW_CHILD;
	TreeSelect.defaultProps = {
	    prefixCls: 'ant-select',
	    transitionName: 'slide-up',
	    choiceTransitionName: 'zoom',
	    showSearch: false,
	    dropdownClassName: 'ant-select-tree-dropdown'
	};

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcTree = __webpack_require__(1192);
	
	var _rcTree2 = _interopRequireDefault(_rcTree);
	
	var _openAnimation = __webpack_require__(380);
	
	var _openAnimation2 = _interopRequireDefault(_openAnimation);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tree = function (_React$Component) {
	    (0, _inherits3['default'])(Tree, _React$Component);
	
	    function Tree() {
	        (0, _classCallCheck3['default'])(this, Tree);
	        return (0, _possibleConstructorReturn3['default'])(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Tree, [{
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	            var prefixCls = props.prefixCls,
	                className = props.className;
	
	            var checkable = props.checkable;
	            return React.createElement(
	                _rcTree2['default'],
	                (0, _extends3['default'])({}, props, { className: className, checkable: checkable ? React.createElement('span', { className: prefixCls + '-checkbox-inner' }) : checkable }),
	                this.props.children
	            );
	        }
	    }]);
	    return Tree;
	}(React.Component);
	
	exports['default'] = Tree;
	
	Tree.TreeNode = _rcTree.TreeNode;
	Tree.defaultProps = {
	    prefixCls: 'ant-tree',
	    checkable: false,
	    showIcon: false,
	    openAnimation: _openAnimation2['default']
	};

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Upload = __webpack_require__(604);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Dragger = function (_React$Component) {
	    (0, _inherits3['default'])(Dragger, _React$Component);
	
	    function Dragger() {
	        (0, _classCallCheck3['default'])(this, Dragger);
	        return (0, _possibleConstructorReturn3['default'])(this, (Dragger.__proto__ || Object.getPrototypeOf(Dragger)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Dragger, [{
	        key: 'render',
	        value: function render() {
	            var props = this.props;
	
	            return React.createElement(_Upload2['default'], (0, _extends3['default'])({}, props, { type: 'drag', style: (0, _extends3['default'])({}, props.style, { height: props.height }) }));
	        }
	    }]);
	    return Dragger;
	}(React.Component);
	
	exports['default'] = Dragger;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _icon = __webpack_require__(33);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _tooltip = __webpack_require__(170);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _progress = __webpack_require__(597);
	
	var _progress2 = _interopRequireDefault(_progress);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
	var previewFile = function previewFile(file, callback) {
	    var reader = new FileReader();
	    reader.onloadend = function () {
	        return callback(reader.result);
	    };
	    reader.readAsDataURL(file);
	};
	
	var UploadList = function (_React$Component) {
	    (0, _inherits3['default'])(UploadList, _React$Component);
	
	    function UploadList() {
	        (0, _classCallCheck3['default'])(this, UploadList);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (UploadList.__proto__ || Object.getPrototypeOf(UploadList)).apply(this, arguments));
	
	        _this.handleClose = function (file) {
	            var onRemove = _this.props.onRemove;
	
	            if (onRemove) {
	                onRemove(file);
	            }
	        };
	        _this.handlePreview = function (file, e) {
	            var onPreview = _this.props.onPreview;
	
	            if (!onPreview) {
	                return;
	            }
	            e.preventDefault();
	            return onPreview(file);
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(UploadList, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            var _this2 = this;
	
	            if (this.props.listType !== 'picture' && this.props.listType !== 'picture-card') {
	                return;
	            }
	            (this.props.items || []).forEach(function (file) {
	                if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File) || file.thumbUrl !== undefined) {
	                    return;
	                }
	                /*eslint-disable */
	                file.thumbUrl = '';
	                /*eslint-enable */
	                previewFile(file.originFileObj, function (previewDataUrl) {
	                    /*eslint-disable */
	                    file.thumbUrl = previewDataUrl;
	                    /*eslint-enable */
	                    _this2.forceUpdate();
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this,
	                _classNames2;
	
	            var _props = this.props,
	                prefixCls = _props.prefixCls,
	                _props$items = _props.items,
	                items = _props$items === undefined ? [] : _props$items,
	                listType = _props.listType,
	                showPreviewIcon = _props.showPreviewIcon,
	                showRemoveIcon = _props.showRemoveIcon,
	                locale = _props.locale;
	
	            var list = items.map(function (file) {
	                var _classNames;
	
	                var progress = void 0;
	                var icon = React.createElement(_icon2['default'], { type: file.status === 'uploading' ? 'loading' : 'paper-clip' });
	                if (listType === 'picture' || listType === 'picture-card') {
	                    if (file.status === 'uploading' || !file.thumbUrl && !file.url) {
	                        if (listType === 'picture-card') {
	                            icon = React.createElement(
	                                'div',
	                                { className: prefixCls + '-list-item-uploading-text' },
	                                locale.uploading
	                            );
	                        } else {
	                            icon = React.createElement(_icon2['default'], { className: prefixCls + '-list-item-thumbnail', type: 'picture' });
	                        }
	                    } else {
	                        icon = React.createElement(
	                            'a',
	                            { className: prefixCls + '-list-item-thumbnail', onClick: function onClick(e) {
	                                    return _this3.handlePreview(file, e);
	                                }, href: file.url || file.thumbUrl, target: '_blank', rel: 'noopener noreferrer' },
	                            React.createElement('img', { src: file.thumbUrl || file.url, alt: file.name })
	                        );
	                    }
	                }
	                if (file.status === 'uploading') {
	                    // show loading icon if upload progress listener is disabled
	                    var loadingProgress = 'percent' in file ? React.createElement(_progress2['default'], (0, _extends3['default'])({ type: 'line' }, _this3.props.progressAttr, { percent: file.percent })) : null;
	                    progress = React.createElement(
	                        'div',
	                        { className: prefixCls + '-list-item-progress', key: 'progress' },
	                        loadingProgress
	                    );
	                }
	                var infoUploadingClass = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-list-item', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-list-item-' + file.status, true), _classNames));
	                var preview = file.url ? React.createElement(
	                    'a',
	                    (0, _extends3['default'])({}, file.linkProps, { href: file.url, target: '_blank', rel: 'noopener noreferrer', className: prefixCls + '-list-item-name', onClick: function onClick(e) {
	                            return _this3.handlePreview(file, e);
	                        }, title: file.name }),
	                    file.name
	                ) : React.createElement(
	                    'span',
	                    { className: prefixCls + '-list-item-name', onClick: function onClick(e) {
	                            return _this3.handlePreview(file, e);
	                        }, title: file.name },
	                    file.name
	                );
	                var style = file.url || file.thumbUrl ? undefined : {
	                    pointerEvents: 'none',
	                    opacity: 0.5
	                };
	                var previewIcon = showPreviewIcon ? React.createElement(
	                    'a',
	                    { href: file.url || file.thumbUrl, target: '_blank', rel: 'noopener noreferrer', style: style, onClick: function onClick(e) {
	                            return _this3.handlePreview(file, e);
	                        }, title: locale.previewFile },
	                    React.createElement(_icon2['default'], { type: 'eye-o' })
	                ) : null;
	                var removeIcon = showRemoveIcon ? React.createElement(_icon2['default'], { type: 'delete', title: locale.removeFile, onClick: function onClick() {
	                        return _this3.handleClose(file);
	                    } }) : null;
	                var removeIconCross = showRemoveIcon ? React.createElement(_icon2['default'], { type: 'cross', title: locale.removeFile, onClick: function onClick() {
	                        return _this3.handleClose(file);
	                    } }) : null;
	                var actions = listType === 'picture-card' && file.status !== 'uploading' ? React.createElement(
	                    'span',
	                    { className: prefixCls + '-list-item-actions' },
	                    previewIcon,
	                    removeIcon
	                ) : removeIconCross;
	                var message = void 0;
	                if (file.response && typeof file.response === 'string') {
	                    message = file.response;
	                } else {
	                    message = file.error && file.error.statusText || locale.uploadError;
	                }
	                var iconAndPreview = file.status === 'error' ? React.createElement(
	                    _tooltip2['default'],
	                    { title: message },
	                    icon,
	                    preview
	                ) : React.createElement(
	                    'span',
	                    null,
	                    icon,
	                    preview
	                );
	                return React.createElement(
	                    'div',
	                    { className: infoUploadingClass, key: file.uid },
	                    React.createElement(
	                        'div',
	                        { className: prefixCls + '-list-item-info' },
	                        iconAndPreview
	                    ),
	                    actions,
	                    React.createElement(
	                        _rcAnimate2['default'],
	                        { transitionName: 'fade', component: '' },
	                        progress
	                    )
	                );
	            });
	            var listClassNames = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-list', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-list-' + listType, true), _classNames2));
	            var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
	            return React.createElement(
	                _rcAnimate2['default'],
	                { transitionName: prefixCls + '-' + animationDirection, component: 'div', className: listClassNames },
	                list
	            );
	        }
	    }]);
	    return UploadList;
	}(React.Component);
	
	exports['default'] = UploadList;
	
	UploadList.defaultProps = {
	    listType: 'text',
	    progressAttr: {
	        strokeWidth: 2,
	        showInfo: false
	    },
	    prefixCls: 'ant-upload',
	    showRemoveIcon: true,
	    showPreviewIcon: true
	};

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Upload = __webpack_require__(604);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	var _Dragger = __webpack_require__(1525);
	
	var _Dragger2 = _interopRequireDefault(_Dragger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Upload2['default'].Dragger = _Dragger2['default'];
	exports['default'] = _Upload2['default'];

/***/ },
/* 1528 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.T = T;
	exports.fileToObject = fileToObject;
	exports.genPercentAdd = genPercentAdd;
	exports.getFileItem = getFileItem;
	exports.removeFileItem = removeFileItem;
	function T() {
	    return true;
	}
	// Fix IE file.status problem
	// via coping a new Object
	function fileToObject(file) {
	    return {
	        lastModified: file.lastModified,
	        lastModifiedDate: file.lastModifiedDate,
	        name: file.filename || file.name,
	        size: file.size,
	        type: file.type,
	        uid: file.uid,
	        response: file.response,
	        error: file.error,
	        percent: 0,
	        originFileObj: file
	    };
	}
	/**
	 * 生成Progress percent: 0.1 -> 0.98
	 *   - for ie
	 */
	function genPercentAdd() {
	    var k = 0.1;
	    var i = 0.01;
	    var end = 0.98;
	    return function (s) {
	        var start = s;
	        if (start >= end) {
	            return start;
	        }
	        start += k;
	        k = k - i;
	        if (k < 0.001) {
	            k = 0.001;
	        }
	        return start * 100;
	    };
	}
	function getFileItem(file, fileList) {
	    var matchKey = file.uid !== undefined ? 'uid' : 'name';
	    return fileList.filter(function (item) {
	        return item[matchKey] === file[matchKey];
	    })[0];
	}
	function removeFileItem(file, fileList) {
	    var matchKey = file.uid !== undefined ? 'uid' : 'name';
	    var removed = fileList.filter(function (item) {
	        return item[matchKey] !== file[matchKey];
	    });
	    if (removed.length === fileList.length) {
	        return null;
	    }
	    return removed;
	}

/***/ },
/* 1529 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _package = { version: '3.1.6' };
	
	exports['default'] = _package.version;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 605,
		"./af.js": 605,
		"./ar": 612,
		"./ar-dz": 606,
		"./ar-dz.js": 606,
		"./ar-kw": 607,
		"./ar-kw.js": 607,
		"./ar-ly": 608,
		"./ar-ly.js": 608,
		"./ar-ma": 609,
		"./ar-ma.js": 609,
		"./ar-sa": 610,
		"./ar-sa.js": 610,
		"./ar-tn": 611,
		"./ar-tn.js": 611,
		"./ar.js": 612,
		"./az": 613,
		"./az.js": 613,
		"./be": 614,
		"./be.js": 614,
		"./bg": 615,
		"./bg.js": 615,
		"./bm": 616,
		"./bm.js": 616,
		"./bn": 617,
		"./bn.js": 617,
		"./bo": 618,
		"./bo.js": 618,
		"./br": 619,
		"./br.js": 619,
		"./bs": 620,
		"./bs.js": 620,
		"./ca": 621,
		"./ca.js": 621,
		"./cs": 622,
		"./cs.js": 622,
		"./cv": 623,
		"./cv.js": 623,
		"./cy": 624,
		"./cy.js": 624,
		"./da": 625,
		"./da.js": 625,
		"./de": 628,
		"./de-at": 626,
		"./de-at.js": 626,
		"./de-ch": 627,
		"./de-ch.js": 627,
		"./de.js": 628,
		"./dv": 629,
		"./dv.js": 629,
		"./el": 630,
		"./el.js": 630,
		"./en-au": 631,
		"./en-au.js": 631,
		"./en-ca": 632,
		"./en-ca.js": 632,
		"./en-gb": 633,
		"./en-gb.js": 633,
		"./en-ie": 634,
		"./en-ie.js": 634,
		"./en-nz": 635,
		"./en-nz.js": 635,
		"./eo": 636,
		"./eo.js": 636,
		"./es": 639,
		"./es-do": 637,
		"./es-do.js": 637,
		"./es-us": 638,
		"./es-us.js": 638,
		"./es.js": 639,
		"./et": 640,
		"./et.js": 640,
		"./eu": 641,
		"./eu.js": 641,
		"./fa": 642,
		"./fa.js": 642,
		"./fi": 643,
		"./fi.js": 643,
		"./fo": 644,
		"./fo.js": 644,
		"./fr": 647,
		"./fr-ca": 645,
		"./fr-ca.js": 645,
		"./fr-ch": 646,
		"./fr-ch.js": 646,
		"./fr.js": 647,
		"./fy": 648,
		"./fy.js": 648,
		"./gd": 649,
		"./gd.js": 649,
		"./gl": 650,
		"./gl.js": 650,
		"./gom-latn": 651,
		"./gom-latn.js": 651,
		"./gu": 652,
		"./gu.js": 652,
		"./he": 653,
		"./he.js": 653,
		"./hi": 654,
		"./hi.js": 654,
		"./hr": 655,
		"./hr.js": 655,
		"./hu": 656,
		"./hu.js": 656,
		"./hy-am": 657,
		"./hy-am.js": 657,
		"./id": 658,
		"./id.js": 658,
		"./is": 659,
		"./is.js": 659,
		"./it": 660,
		"./it.js": 660,
		"./ja": 661,
		"./ja.js": 661,
		"./jv": 662,
		"./jv.js": 662,
		"./ka": 663,
		"./ka.js": 663,
		"./kk": 664,
		"./kk.js": 664,
		"./km": 665,
		"./km.js": 665,
		"./kn": 666,
		"./kn.js": 666,
		"./ko": 667,
		"./ko.js": 667,
		"./ky": 668,
		"./ky.js": 668,
		"./lb": 669,
		"./lb.js": 669,
		"./lo": 670,
		"./lo.js": 670,
		"./lt": 671,
		"./lt.js": 671,
		"./lv": 672,
		"./lv.js": 672,
		"./me": 673,
		"./me.js": 673,
		"./mi": 674,
		"./mi.js": 674,
		"./mk": 675,
		"./mk.js": 675,
		"./ml": 676,
		"./ml.js": 676,
		"./mr": 677,
		"./mr.js": 677,
		"./ms": 679,
		"./ms-my": 678,
		"./ms-my.js": 678,
		"./ms.js": 679,
		"./mt": 680,
		"./mt.js": 680,
		"./my": 681,
		"./my.js": 681,
		"./nb": 682,
		"./nb.js": 682,
		"./ne": 683,
		"./ne.js": 683,
		"./nl": 685,
		"./nl-be": 684,
		"./nl-be.js": 684,
		"./nl.js": 685,
		"./nn": 686,
		"./nn.js": 686,
		"./pa-in": 687,
		"./pa-in.js": 687,
		"./pl": 688,
		"./pl.js": 688,
		"./pt": 690,
		"./pt-br": 689,
		"./pt-br.js": 689,
		"./pt.js": 690,
		"./ro": 691,
		"./ro.js": 691,
		"./ru": 692,
		"./ru.js": 692,
		"./sd": 693,
		"./sd.js": 693,
		"./se": 694,
		"./se.js": 694,
		"./si": 695,
		"./si.js": 695,
		"./sk": 696,
		"./sk.js": 696,
		"./sl": 697,
		"./sl.js": 697,
		"./sq": 698,
		"./sq.js": 698,
		"./sr": 700,
		"./sr-cyrl": 699,
		"./sr-cyrl.js": 699,
		"./sr.js": 700,
		"./ss": 701,
		"./ss.js": 701,
		"./sv": 702,
		"./sv.js": 702,
		"./sw": 703,
		"./sw.js": 703,
		"./ta": 704,
		"./ta.js": 704,
		"./te": 705,
		"./te.js": 705,
		"./tet": 706,
		"./tet.js": 706,
		"./th": 707,
		"./th.js": 707,
		"./tl-ph": 708,
		"./tl-ph.js": 708,
		"./tlh": 709,
		"./tlh.js": 709,
		"./tr": 710,
		"./tr.js": 710,
		"./tzl": 711,
		"./tzl.js": 711,
		"./tzm": 713,
		"./tzm-latn": 712,
		"./tzm-latn.js": 712,
		"./tzm.js": 713,
		"./uk": 714,
		"./uk.js": 714,
		"./ur": 715,
		"./ur.js": 715,
		"./uz": 717,
		"./uz-latn": 716,
		"./uz-latn.js": 716,
		"./uz.js": 717,
		"./vi": 718,
		"./vi.js": 718,
		"./x-pseudo": 719,
		"./x-pseudo.js": 719,
		"./yo": 720,
		"./yo.js": 720,
		"./zh-cn": 721,
		"./zh-cn.js": 721,
		"./zh-hk": 722,
		"./zh-hk.js": 722,
		"./zh-tw": 723,
		"./zh-tw.js": 723
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1530;


/***/ },
/* 1531 */
[3336, 171],
/* 1532 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40 // also NUM_SOUTH
	};
	module.exports = exports['default'];

/***/ },
/* 1533 */
478,
/* 1534 */
[3337, 1531, 1535, 1536, 1533],
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames5 = __webpack_require__(7);
	
	var _classnames6 = _interopRequireDefault(_classnames5);
	
	var _utils = __webpack_require__(171);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _lodash = __webpack_require__(307);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      scrollAnimated: true,
	      onPrevClick: function onPrevClick() {},
	      onNextClick: function onNextClick() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.offset = 0;
	    return {
	      next: false,
	      prev: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.componentDidUpdate();
	    var debouncedResize = (0, _lodash2['default'])(function () {
	      _this.setNextPrev();
	      _this.scrollToActiveTab();
	    }, 200);
	    this.resizeEvent = (0, _addEventListener2['default'])(window, 'resize', debouncedResize);
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var props = this.props;
	    if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
	      this.setOffset(0);
	      return;
	    }
	    var nextPrev = this.setNextPrev();
	    // wait next, prev show hide
	    /* eslint react/no-did-update-set-state:0 */
	    if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
	      this.setState({}, this.scrollToActiveTab);
	    } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
	      // can not use props.activeKey
	      this.scrollToActiveTab();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.resizeEvent) {
	      this.resizeEvent.remove();
	    }
	  },
	  setNextPrev: function setNextPrev() {
	    var navNode = this.nav;
	    var navNodeWH = this.getOffsetWH(navNode);
	    var navWrapNode = this.navWrap;
	    var navWrapNodeWH = this.getOffsetWH(navWrapNode);
	    var offset = this.offset;
	
	    var minOffset = navWrapNodeWH - navNodeWH;
	    var _state = this.state,
	        next = _state.next,
	        prev = _state.prev;
	
	    if (minOffset >= 0) {
	      next = false;
	      this.setOffset(0, false);
	      offset = 0;
	    } else if (minOffset < offset) {
	      next = true;
	    } else {
	      next = false;
	      this.setOffset(minOffset, false);
	      offset = minOffset;
	    }
	
	    if (offset < 0) {
	      prev = true;
	    } else {
	      prev = false;
	    }
	
	    this.setNext(next);
	    this.setPrev(prev);
	    return {
	      next: next,
	      prev: prev
	    };
	  },
	  getOffsetWH: function getOffsetWH(node) {
	    var tabBarPosition = this.props.tabBarPosition;
	    var prop = 'offsetWidth';
	    if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	      prop = 'offsetHeight';
	    }
	    return node[prop];
	  },
	  getOffsetLT: function getOffsetLT(node) {
	    var tabBarPosition = this.props.tabBarPosition;
	    var prop = 'left';
	    if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	      prop = 'top';
	    }
	    return node.getBoundingClientRect()[prop];
	  },
	  setOffset: function setOffset(offset) {
	    var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var target = Math.min(0, offset);
	    if (this.offset !== target) {
	      this.offset = target;
	      var navOffset = {};
	      var tabBarPosition = this.props.tabBarPosition;
	      var navStyle = this.nav.style;
	      var transformSupported = (0, _utils.isTransformSupported)(navStyle);
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        if (transformSupported) {
	          navOffset = {
	            value: 'translate3d(0,' + target + 'px,0)'
	          };
	        } else {
	          navOffset = {
	            name: 'top',
	            value: target + 'px'
	          };
	        }
	      } else {
	        if (transformSupported) {
	          navOffset = {
	            value: 'translate3d(' + target + 'px,0,0)'
	          };
	        } else {
	          navOffset = {
	            name: 'left',
	            value: target + 'px'
	          };
	        }
	      }
	      if (transformSupported) {
	        (0, _utils.setTransform)(navStyle, navOffset.value);
	      } else {
	        navStyle[navOffset.name] = navOffset.value;
	      }
	      if (checkNextPrev) {
	        this.setNextPrev();
	      }
	    }
	  },
	  setPrev: function setPrev(v) {
	    if (this.state.prev !== v) {
	      this.setState({
	        prev: v
	      });
	    }
	  },
	  setNext: function setNext(v) {
	    if (this.state.next !== v) {
	      this.setState({
	        next: v
	      });
	    }
	  },
	  isNextPrevShown: function isNextPrevShown(state) {
	    if (state) {
	      return state.next || state.prev;
	    }
	    return this.state.next || this.state.prev;
	  },
	  prevTransitionEnd: function prevTransitionEnd(e) {
	    if (e.propertyName !== 'opacity') {
	      return;
	    }
	    var container = this.container;
	
	    this.scrollToActiveTab({
	      target: container,
	      currentTarget: container
	    });
	  },
	  scrollToActiveTab: function scrollToActiveTab(e) {
	    var activeTab = this.activeTab,
	        navWrap = this.navWrap;
	
	    if (e && e.target !== e.currentTarget || !activeTab) {
	      return;
	    }
	
	    // when not scrollable or enter scrollable first time, don't emit scrolling
	    var needToSroll = this.isNextPrevShown() && this.lastNextPrevShown;
	    this.lastNextPrevShown = this.isNextPrevShown();
	    if (!needToSroll) {
	      return;
	    }
	
	    var activeTabWH = this.getOffsetWH(activeTab);
	    var navWrapNodeWH = this.getOffsetWH(navWrap);
	    var offset = this.offset;
	
	    var wrapOffset = this.getOffsetLT(navWrap);
	    var activeTabOffset = this.getOffsetLT(activeTab);
	    if (wrapOffset > activeTabOffset) {
	      offset += wrapOffset - activeTabOffset;
	      this.setOffset(offset);
	    } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
	      offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
	      this.setOffset(offset);
	    }
	  },
	  prev: function prev(e) {
	    this.props.onPrevClick(e);
	    var navWrapNode = this.navWrap;
	    var navWrapNodeWH = this.getOffsetWH(navWrapNode);
	    var offset = this.offset;
	
	    this.setOffset(offset + navWrapNodeWH);
	  },
	  next: function next(e) {
	    this.props.onNextClick(e);
	    var navWrapNode = this.navWrap;
	    var navWrapNodeWH = this.getOffsetWH(navWrapNode);
	    var offset = this.offset;
	
	    this.setOffset(offset - navWrapNodeWH);
	  },
	  getScrollBarNode: function getScrollBarNode(content) {
	    var _classnames, _classnames2, _classnames3, _classnames4;
	
	    var _state2 = this.state,
	        next = _state2.next,
	        prev = _state2.prev;
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        scrollAnimated = _props.scrollAnimated;
	
	    var showNextPrev = prev || next;
	
	    var prevButton = _react2['default'].createElement(
	      'span',
	      {
	        onClick: prev ? this.prev : null,
	        unselectable: 'unselectable',
	        className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
	        onTransitionEnd: this.prevTransitionEnd
	      },
	      _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
	    );
	
	    var nextButton = _react2['default'].createElement(
	      'span',
	      {
	        onClick: next ? this.next : null,
	        unselectable: 'unselectable',
	        className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
	      },
	      _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
	    );
	
	    var navClassName = prefixCls + '-nav';
	    var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));
	
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
	        key: 'container',
	        ref: this.saveRef('container')
	      },
	      prevButton,
	      nextButton,
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-nav-wrap', ref: this.saveRef('navWrap') },
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-nav-scroll' },
	          _react2['default'].createElement(
	            'div',
	            { className: navClasses, ref: this.saveRef('nav') },
	            content
	          )
	        )
	      )
	    );
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _utils = __webpack_require__(171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      styles: {}
	    };
	  },
	  onTabClick: function onTabClick(key) {
	    this.props.onTabClick(key);
	  },
	  getTabs: function getTabs() {
	    var _this = this;
	
	    var _props = this.props,
	        children = _props.panels,
	        activeKey = _props.activeKey,
	        prefixCls = _props.prefixCls;
	
	    var rst = [];
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      var key = child.key;
	      var cls = activeKey === key ? prefixCls + '-tab-active' : '';
	      cls += ' ' + prefixCls + '-tab';
	      var events = {};
	      if (child.props.disabled) {
	        cls += ' ' + prefixCls + '-tab-disabled';
	      } else {
	        events = {
	          onClick: _this.onTabClick.bind(_this, key)
	        };
	      }
	      var ref = {};
	      if (activeKey === key) {
	        ref.ref = _this.saveRef('activeTab');
	      }
	      (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
	      rst.push(_react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          role: 'tab',
	          'aria-disabled': child.props.disabled ? 'true' : 'false',
	          'aria-selected': activeKey === key ? 'true' : 'false'
	        }, events, {
	          className: cls,
	          key: key
	        }, ref),
	        child.props.tab
	      ));
	    });
	
	    return rst;
	  },
	  getRootNode: function getRootNode(contents) {
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        onKeyDown = _props2.onKeyDown,
	        className = _props2.className,
	        extraContent = _props2.extraContent,
	        style = _props2.style,
	        tabBarPosition = _props2.tabBarPosition,
	        restProps = (0, _objectWithoutProperties3['default'])(_props2, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition']);
	
	    var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
	    var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
	    var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
	    var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
	    var children = contents;
	    if (extraContent) {
	      children = [(0, _react.cloneElement)(extraContent, {
	        key: 'extra',
	        style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
	      }), (0, _react.cloneElement)(contents, { key: 'content' })];
	      children = topOrBottom ? children : children.reverse();
	    }
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({
	        role: 'tablist',
	        className: cls,
	        tabIndex: '0',
	        ref: this.saveRef('root'),
	        onKeyDown: onKeyDown,
	        style: style
	      }, (0, _utils.getDataAttr)(restProps)),
	      children
	    );
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1537 */
[3340, 1532, 725, 171],
/* 1538 */
[3341, 1537, 725, 724],
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.arrayTreeFilter = factory());
	}(this, (function () { 'use strict';
	
	function arrayTreeFilter(data, filterFn, options) {
	  options = options || {};
	  options.childrenKeyName = options.childrenKeyName || 'children';
	  var children = data || [];
	  var result = [];
	  var level = 0;
	  var foundItem;
	  do {
	    var foundItem = children.filter(function(item) {
	      return filterFn(item, level);
	    })[0];
	    if (!foundItem) {
	      break;
	    }
	    result.push(foundItem);
	    children = foundItem[options.childrenKeyName] || [];
	    level += 1;
	  } while(children.length > 0);
	  return result;
	}
	
	return arrayTreeFilter;
	
	})));


/***/ },
/* 1540 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(44);
	
	var _validator = __webpack_require__(1553);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(1542);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : (0, _typeof3['default'])(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments[2];
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return;
	    }
	    function complete(results) {
	      var i = void 0;
	      var field = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          errors = errors.concat.apply(errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        for (i = 0; i < errors.length; i++) {
	          field = errors[i].field;
	          fields[field] = fields[field] || [];
	          fields[field].push(errors[i]);
	        }
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = (0, _extends3['default'])({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = (0, _extends3['default'])({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && ((0, _typeof3['default'])(rule.fields) === 'object' || (0, _typeof3['default'])(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	      function addFullfield(key, schema) {
	        return (0, _extends3['default'])({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (errors.length) {
	          (0, _util.warning)('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if (options.first && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else if (options.error) {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            } else {
	              errors = [];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = (0, _extends3['default'])({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            doIt(errs && errs.length ? errors.concat(errs) : errs);
	          });
	        }
	      }
	
	      var res = rule.validator(rule, data.value, cb, data.source, options);
	      if (res && res.then) {
	        res.then(function () {
	          return cb();
	        }, function (e) {
	          return cb(e);
	        });
	      }
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2['default'].required;
	    }
	    return _validator2['default'][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2['default'][type] = validator;
	};
	
	Schema.messages = _messages2.messages;
	
	exports['default'] = Schema;
	module.exports = exports['default'];

/***/ },
/* 1542 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    'default': 'Validation error on field %s',
	    required: '%s is required',
	    'enum': '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      boolean: '%s is not a %s',
	      integer: '%s is not an %s',
	      float: '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(44);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(44);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern) {
	    if (rule.pattern instanceof RegExp) {
	      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
	      // flag is accidentally set to `true`, which in a validation scenario
	      // is not necessary and the result might be misleading
	      rule.pattern.lastIndex = 0;
	      if (!rule.pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    } else if (typeof rule.pattern === 'string') {
	      var _pattern = new RegExp(rule.pattern);
	      if (!_pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    }
	  }
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(44);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (str || arr) {
	    val = value.length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports['default'] = range;
	module.exports = exports['default'];

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _util = __webpack_require__(44);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(726);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  // http://emailregex.com/
	  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  float: function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2['default'])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(44);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports['default'] = whitespace;
	module.exports = exports['default'];

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = array;
	module.exports = exports['default'];

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _util = __webpack_require__(44);
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = boolean;
	module.exports = exports['default'];

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      if (value) {
	        _rule2['default'].range(rule, value.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = date;
	module.exports = exports['default'];

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2['default'][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = floatFn;
	module.exports = exports['default'];

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _string = __webpack_require__(1561);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _method = __webpack_require__(1555);
	
	var _method2 = _interopRequireDefault(_method);
	
	var _number = __webpack_require__(1556);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _boolean = __webpack_require__(1549);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _regexp = __webpack_require__(1559);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _integer = __webpack_require__(1554);
	
	var _integer2 = _interopRequireDefault(_integer);
	
	var _float = __webpack_require__(1552);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _array = __webpack_require__(1548);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _object = __webpack_require__(1557);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _enum = __webpack_require__(1551);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(1558);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	var _date = __webpack_require__(1550);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _required = __webpack_require__(1560);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _type = __webpack_require__(1562);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  string: _string2['default'],
	  method: _method2['default'],
	  number: _number2['default'],
	  boolean: _boolean2['default'],
	  regexp: _regexp2['default'],
	  integer: _integer2['default'],
	  float: _float2['default'],
	  array: _array2['default'],
	  object: _object2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default'],
	  date: _date2['default'],
	  url: _type2['default'],
	  hex: _type2['default'],
	  email: _type2['default'],
	  required: _required2['default']
	};
	module.exports = exports['default'];

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = integer;
	module.exports = exports['default'];

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = method;
	module.exports = exports['default'];

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = number;
	module.exports = exports['default'];

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = object;
	module.exports = exports['default'];

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = regexp;
	module.exports = exports['default'];

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : (0, _typeof3['default'])(value);
	  _rule2['default'].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	      _rule2['default'].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2['default'].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = string;
	module.exports = exports['default'];

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rule = __webpack_require__(65);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(44);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	
	var objectHelper = __webpack_require__(76);
	var assert = __webpack_require__(117);
	var responseHandler = __webpack_require__(172);
	
	function DBConnection(request, options) {
	  this.baseOptions = options;
	  this.request = request;
	}
	
	/**
	 * @callback signUpCallback
	 * @param {Error} [err] error returned by Auth0 with the reason why the signup failed
	 * @param {Object} [result] result of the signup request
	 * @param {Object} result.email user's email
	 * @param {Object} result.emailVerified if the user's email was verified
	 */
	
	/**
	 * Creates a new user in a Auth0 Database connection
	 *
	 * @method signup
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {Object} [options.userMetadata] additional signup attributes used for creating the user. Will be stored in `user_metadata`
	 * @param {signUpCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#signup}
	 */
	DBConnection.prototype.signup = function(options, cb) {
	  var url;
	  var body;
	  var metadata;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      email: { type: 'string', message: 'email option is required' },
	      password: { type: 'string', message: 'password option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'dbconnections', 'signup');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID']).with(options);
	
	  metadata = body.user_metadata || body.userMetadata;
	
	  body = objectHelper.blacklist(body, ['scope', 'userMetadata', 'user_metadata']);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  if (metadata) {
	    body.user_metadata = metadata;
	  }
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	/**
	 * @callback changePasswordCallback
	 * @param {Error} [err] error returned by Auth0 with the reason why the request failed
	 */
	
	/**
	 * Request an email with instruction to change a user's password
	 *
	 * @method changePassword
	 * @param {Object} options
	 * @param {String} options.email address where the user will recieve the change password email. It should match the user's email in Auth0
	 * @param {String} options.connection name of the connection where the user was created
	 * @param {changePasswordCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#change-password}
	 */
	DBConnection.prototype.changePassword = function(options, cb) {
	  var url;
	  var body;
	
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      email: { type: 'string', message: 'email option is required' }
	    }
	  );
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'dbconnections', 'change_password');
	
	  body = objectHelper.merge(this.baseOptions, ['clientID']).with(options, ['email', 'connection']);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	module.exports = DBConnection;


/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	
	var objectHelper = __webpack_require__(76);
	var assert = __webpack_require__(117);
	var qs = __webpack_require__(236);
	var responseHandler = __webpack_require__(172);
	
	function PasswordlessAuthentication(request, options) {
	  this.baseOptions = options;
	  this.request = request;
	}
	
	PasswordlessAuthentication.prototype.buildVerifyUrl = function(options) {
	  var params;
	  var qString;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      verificationCode: { type: 'string', message: 'verificationCode option is required' },
	      phoneNumber: {
	        optional: false,
	        type: 'string',
	        message: 'phoneNumber option is required',
	        condition: function(o) {
	          return !o.email;
	        }
	      },
	      email: {
	        optional: false,
	        type: 'string',
	        message: 'email option is required',
	        condition: function(o) {
	          return !o.phoneNumber;
	        }
	      }
	    }
	  );
	  /* eslint-enable */
	
	  params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'protocol',
	      'nonce'
	    ])
	    .with(options);
	
	  // eslint-disable-next-line
	  if (this.baseOptions._sendTelemetry) {
	    params.auth0Client = this.request.getTelemetryData();
	  }
	
	  params = objectHelper.toSnakeCase(params, ['auth0Client']);
	
	  qString = qs.stringify(params);
	
	  return urljoin(this.baseOptions.rootUrl, 'passwordless', 'verify_redirect', '?' + qString);
	};
	
	PasswordlessAuthentication.prototype.start = function(options, cb) {
	  var url;
	  var body;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      send: {
	        type: 'string',
	        message: 'send option is required',
	        values: ['link', 'code'],
	        value_message: 'send is not valid ([link, code])'
	      },
	      phoneNumber: {
	        optional: true,
	        type: 'string',
	        message: 'phoneNumber option is required',
	        condition: function(o) {
	          return o.send === 'code' || !o.email;
	        }
	      },
	      email: {
	        optional: true,
	        type: 'string',
	        message: 'email option is required',
	        condition: function(o) {
	          return o.send === 'link' || !o.phoneNumber;
	        }
	      },
	      authParams: { optional: true, type: 'object', message: 'authParams option is required' }
	    }
	  );
	  /* eslint-enable */
	
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'passwordless', 'start');
	
	  body = objectHelper
	    .merge(this.baseOptions, ['clientID', 'responseType', 'redirectUri', 'scope'])
	    .with(options);
	
	  if (body.scope) {
	    body.authParams = body.authParams || {};
	    body.authParams.scope = body.scope;
	  }
	
	  if (body.redirectUri) {
	    body.authParams = body.authParams || {};
	    body.authParams.redirect_uri = body.redirectUri;
	  }
	
	  if (body.responseType) {
	    body.authParams = body.authParams || {};
	    body.authParams.response_type = body.responseType;
	  }
	
	  delete body.redirectUri;
	  delete body.responseType;
	  delete body.scope;
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client', 'authParams']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	PasswordlessAuthentication.prototype.verify = function(options, cb) {
	  var url;
	  var cleanOption;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      connection: { type: 'string', message: 'connection option is required' },
	      verificationCode: { type: 'string', message: 'verificationCode option is required' },
	      phoneNumber: {
	        optional: false,
	        type: 'string',
	        message: 'phoneNumber option is required',
	        condition: function(o) {
	          return !o.email;
	        }
	      },
	      email: {
	        optional: false,
	        type: 'string',
	        message: 'email option is required',
	        condition: function(o) {
	          return !o.phoneNumber;
	        }
	      }
	    }
	  );
	  /* eslint-enable */
	
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  cleanOption = objectHelper.pick(options, [
	    'connection',
	    'verificationCode',
	    'phoneNumber',
	    'email',
	    'auth0Client'
	  ]);
	  cleanOption = objectHelper.toSnakeCase(cleanOption, ['auth0Client']);
	
	  url = urljoin(this.baseOptions.rootUrl, 'passwordless', 'verify');
	
	  return this.request.post(url).send(cleanOption).end(responseHandler(cb));
	};
	
	module.exports = PasswordlessAuthentication;


/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	var windowHandler = __webpack_require__(105);
	var base64Url = __webpack_require__(728);
	
	function create(name, value, days) {
	  var date;
	  var expires;
	
	  if (
	    windowHandler.getDocument().cookie === undefined ||
	    windowHandler.getDocument().cookie === null
	  ) {
	    throw new Error('cookie storage not available');
	  }
	
	  if (days) {
	    var timeToExpire = days * 24 * 60 * 60 * 1000;
	    date = new Date();
	    date.setTime(date.getTime() + timeToExpire);
	    expires = '; expires=' + date.toGMTString();
	  } else {
	    expires = '';
	  }
	
	  windowHandler.getDocument().cookie = name + '=' + base64Url.encode(value) + expires + '; path=/';
	}
	
	function read(name) {
	  var i;
	  var cookie;
	  var cookies;
	  var nameEQ = name + '=';
	
	  if (
	    windowHandler.getDocument().cookie === undefined ||
	    windowHandler.getDocument().cookie === null
	  ) {
	    throw new Error('cookie storage not available');
	  }
	
	  cookies = windowHandler.getDocument().cookie.split(';');
	
	  for (i = 0; i < cookies.length; i++) {
	    cookie = cookies[i];
	    while (cookie.charAt(0) === ' ') {
	      cookie = cookie.substring(1, cookie.length);
	    }
	    if (cookie.indexOf(nameEQ) === 0) {
	      return base64Url.decode(cookie.substring(nameEQ.length, cookie.length));
	    }
	  }
	
	  return null;
	}
	
	function erase(name) {
	  create(name, '', -1);
	}
	
	module.exports = {
	  create: create,
	  read: read,
	  erase: erase
	};


/***/ },
/* 1566 */
/***/ function(module, exports) {

	/* eslint-disable no-continue */
	
	function get() {
	  if (!Object.assign) {
	    return objectAssignPolyfill;
	  }
	
	  return Object.assign;
	}
	
	function objectAssignPolyfill(target) {
	  'use strict';
	  if (target === undefined || target === null) {
	    throw new TypeError('Cannot convert first argument to object');
	  }
	
	  var to = Object(target);
	  for (var i = 1; i < arguments.length; i++) {
	    var nextSource = arguments[i];
	    if (nextSource === undefined || nextSource === null) {
	      continue;
	    }
	
	    var keysArray = Object.keys(Object(nextSource));
	    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
	      var nextKey = keysArray[nextIndex];
	      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
	      if (desc !== undefined && desc.enumerable) {
	        to[nextKey] = nextSource[nextKey];
	      }
	    }
	  }
	  return to;
	}
	
	module.exports = {
	  get: get,
	  objectAssignPolyfill: objectAssignPolyfill
	};


/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	var objectHelper = __webpack_require__(76);
	
	var tokenParams = [
	  // auth0
	  'realm',
	  'audience',
	  // oauth2
	  'client_id',
	  'client_secret',
	  'redirect_uri',
	  'scope',
	  'code',
	  'grant_type',
	  'username',
	  'password',
	  'refresh_token',
	  'assertion',
	  'client_assertion',
	  'client_assertion_type',
	  'code_verifier'
	];
	
	var authorizeParams = [
	  // auth0
	  'connection',
	  'connection_scope',
	  'auth0Client',
	  'owp',
	  'device',
	  'realm',
	
	  'protocol',
	  '_csrf',
	  '_intstate',
	  'login_ticket',
	
	  // oauth2
	  'client_id',
	  'response_type',
	  'response_mode',
	  'redirect_uri',
	  'audience',
	  'scope',
	  'state',
	  'nonce',
	  'display',
	  'prompt',
	  'max_age',
	  'ui_locales',
	  'claims_locales',
	  'id_token_hint',
	  'login_hint',
	  'acr_values',
	  'claims',
	  'registration',
	  'request',
	  'request_uri',
	  'code_challenge',
	  'code_challenge_method'
	];
	
	function oauthAuthorizeParams(warn, params) {
	  var notAllowed = objectHelper.getKeysNotIn(params, authorizeParams);
	
	  if (notAllowed.length > 0) {
	    warn.warning(
	      'Following parameters are not allowed on the `/authorize` endpoint: [' +
	        notAllowed.join(',') +
	        ']'
	    );
	  }
	
	  return params;
	}
	
	function oauthTokenParams(warn, params) {
	  return objectHelper.pick(params, tokenParams);
	}
	
	module.exports = {
	  oauthTokenParams: oauthTokenParams,
	  oauthAuthorizeParams: oauthAuthorizeParams
	};


/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	var version = __webpack_require__(388);
	
	function PluginHandler(webAuth, plugins) {
	  this.plugins = plugins;
	
	  for (var a = 0; a < this.plugins.length; a++) {
	    if (this.plugins[a].version !== version.raw) {
	      var pluginName = '';
	
	      if (this.plugins[a].constructor && this.plugins[a].constructor.name) {
	        pluginName = this.plugins[a].constructor.name;
	      }
	
	      throw new Error(
	        'Plugin ' +
	          pluginName +
	          ' version (' +
	          this.plugins[a].version +
	          ') ' +
	          'is not compatible with the SDK version (' +
	          version.raw +
	          ')'
	      );
	    }
	
	    this.plugins[a].setWebAuth(webAuth);
	  }
	}
	
	PluginHandler.prototype.get = function(extensibilityPoint) {
	  for (var a = 0; a < this.plugins.length; a++) {
	    if (this.plugins[a].supports(extensibilityPoint)) {
	      return this.plugins[a].init();
	    }
	  }
	
	  return null;
	};
	
	module.exports = PluginHandler;


/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable no-restricted-syntax */
	/* eslint-disable guard-for-in */
	var WinChan = __webpack_require__(1418);
	
	var windowHandler = __webpack_require__(105);
	var objectHelper = __webpack_require__(76);
	var qs = __webpack_require__(236);
	
	function PopupHandler() {
	  this._current_popup = null;
	}
	
	PopupHandler.prototype.calculatePosition = function(options) {
	  var width = options.width || 500;
	  var height = options.height || 600;
	  var _window = windowHandler.getWindow();
	
	  var screenX = typeof _window.screenX !== 'undefined' ? _window.screenX : _window.screenLeft;
	  var screenY = typeof _window.screenY !== 'undefined' ? _window.screenY : _window.screenTop;
	
	  var outerWidth = typeof _window.outerWidth !== 'undefined'
	    ? _window.outerWidth
	    : _window.document.body.clientWidth;
	
	  var outerHeight = typeof _window.outerHeight !== 'undefined'
	    ? _window.outerHeight
	    : _window.document.body.clientHeight;
	
	  var left = (outerWidth - width) / 2;
	  var top = (outerHeight - height) / 2;
	
	  return { width: width, height: height, left: screenX + left, top: screenY + top };
	};
	
	PopupHandler.prototype.preload = function(options) {
	  var _this = this;
	  var _window = windowHandler.getWindow();
	  var popupPosition = this.calculatePosition(options.popupOptions || {});
	  var popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions);
	  var url = options.url || 'about:blank';
	  var windowFeatures = qs.stringify(popupOptions, {
	    encode: false,
	    delimiter: ','
	  });
	
	  if (this._current_popup && !this._current_popup.closed) {
	    return this._current_popup;
	  }
	
	  this._current_popup = _window.open(url, 'auth0_signup_popup', windowFeatures);
	
	  this._current_popup.kill = function() {
	    this.close();
	    _this._current_popup = null;
	  };
	
	  return this._current_popup;
	};
	
	PopupHandler.prototype.load = function(url, relayUrl, options, cb) {
	  var _this = this;
	  var popupPosition = this.calculatePosition(options.popupOptions || {});
	  var popupOptions = objectHelper.merge(popupPosition).with(options.popupOptions);
	
	  var winchanOptions = objectHelper
	    .merge({
	      url: url,
	      relay_url: relayUrl,
	      window_features: qs.stringify(popupOptions, {
	        delimiter: ',',
	        encode: false
	      }),
	      popup: this._current_popup
	    })
	    .with(options);
	
	  var popup = WinChan.open(winchanOptions, function(err, data) {
	    _this._current_popup = null;
	    return cb(err, data);
	  });
	
	  popup.focus();
	
	  return popup;
	};
	
	module.exports = PopupHandler;


/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	var windowHelper = __webpack_require__(105);
	
	function randomString(length) {
	  // eslint-disable-next-line
	  var bytes = new Uint8Array(length);
	  var result = [];
	  var charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
	
	  var cryptoObj = windowHelper.getWindow().crypto || windowHelper.getWindow().msCrypto;
	  if (!cryptoObj) {
	    return null;
	  }
	
	  var random = cryptoObj.getRandomValues(bytes);
	
	  for (var a = 0; a < random.length; a++) {
	    result.push(charset[random[a] % charset.length]);
	  }
	
	  return result.join('');
	}
	
	module.exports = {
	  randomString: randomString
	};


/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	var StorageHandler = __webpack_require__(1574);
	var storage;
	
	function getStorage(force) {
	  if (!storage || force) {
	    storage = new StorageHandler();
	  }
	  return storage;
	}
	
	module.exports = {
	  getItem: function(key) {
	    var value = getStorage().getItem(key);
	    return value ? JSON.parse(value) : value;
	  },
	  removeItem: function(key) {
	    return getStorage().removeItem(key);
	  },
	  setItem: function(key, value) {
	    var json = JSON.stringify(value);
	    return getStorage().setItem(key, json);
	  },
	  reload: function() {
	    getStorage(true);
	  }
	};


/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	var cookies = __webpack_require__(1565);
	
	function CookieStorage() {}
	
	CookieStorage.prototype.getItem = function(key) {
	  return cookies.read(key);
	};
	
	CookieStorage.prototype.removeItem = function(key) {
	  cookies.erase(key);
	};
	
	CookieStorage.prototype.setItem = function(key, value) {
	  cookies.create(key, value, 1);
	};
	
	module.exports = CookieStorage;


/***/ },
/* 1573 */
/***/ function(module, exports) {

	function DummyStorage() {}
	
	DummyStorage.prototype.getItem = function() {
	  return null;
	};
	
	DummyStorage.prototype.removeItem = function() {};
	
	DummyStorage.prototype.setItem = function() {};
	
	module.exports = DummyStorage;


/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	var windowHandler = __webpack_require__(105);
	var DummyStorage = __webpack_require__(1573);
	var CookieStorage = __webpack_require__(1572);
	var Warn = __webpack_require__(274);
	
	function StorageHandler() {
	  this.warn = new Warn({});
	  this.storage = windowHandler.getWindow().localStorage || new CookieStorage();
	}
	
	StorageHandler.prototype.failover = function() {
	  if (this.storage instanceof DummyStorage) {
	    this.warn.warning('DummyStorage: ignore failover');
	    return;
	  } else if (this.storage instanceof CookieStorage) {
	    this.warn.warning('CookieStorage: failing over DummyStorage');
	    this.storage = new DummyStorage();
	  } else {
	    this.warn.warning('LocalStorage: failing over CookieStorage');
	    this.storage = new CookieStorage();
	  }
	};
	
	StorageHandler.prototype.getItem = function(key) {
	  try {
	    return this.storage.getItem(key);
	  } catch (e) {
	    this.warn.warning(e);
	    this.failover();
	    return this.getItem(key);
	  }
	};
	
	StorageHandler.prototype.removeItem = function(key) {
	  try {
	    return this.storage.removeItem(key);
	  } catch (e) {
	    this.warn.warning(e);
	    this.failover();
	    return this.removeItem(key);
	  }
	};
	
	StorageHandler.prototype.setItem = function(key, value) {
	  try {
	    return this.storage.setItem(key, value);
	  } catch (e) {
	    this.warn.warning(e);
	    this.failover();
	    return this.setItem(key, value);
	  }
	};
	
	module.exports = StorageHandler;


/***/ },
/* 1575 */
/***/ function(module, exports) {

	// given a URL, extract the origin. Taken from: https://github.com/firebase/firebase-simple-login/blob/d2cb95b9f812d8488bdbfba51c3a7c153ba1a074/js/src/simple-login/transports/WinChan.js#L25-L30
	function extractOrigin(url) {
	  if (!/^https?:\/\//.test(url)) url = window.location.href;
	  var m = /^(https?:\/\/[-_a-zA-Z.0-9:]+)/.exec(url);
	  if (m) return m[1];
	  return url;
	}
	
	module.exports = {
	  extractOrigin: extractOrigin
	};


/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	var Authentication = __webpack_require__(727);
	var Management = __webpack_require__(1577);
	var WebAuth = __webpack_require__(1579);
	var version = __webpack_require__(388);
	
	module.exports = {
	  Authentication: Authentication,
	  Management: Management,
	  WebAuth: WebAuth,
	  version: version.raw
	};


/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	
	var RequestBuilder = __webpack_require__(273);
	var assert = __webpack_require__(117);
	var responseHandler = __webpack_require__(172);
	
	/**
	 * Auth0 Management API Client (methods allowed to be called from the browser only)
	 * @constructor
	 * @param {Object} options
	 * @param {Object} options.domain your Auth0 acount domain
	 * @param {Object} options.token a valid API token
	 */
	function Management(options) {
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      domain: { type: 'string', message: 'domain option is required' },
	      token: { type: 'string', message: 'token option is required' },
	      _sendTelemetry: {
	        optional: true,
	        type: 'boolean',
	        message: '_sendTelemetry option is not valid'
	      },
	      _telemetryInfo: {
	        optional: true,
	        type: 'object',
	        message: '_telemetryInfo option is not valid'
	      }
	    }
	  );
	  /* eslint-enable */
	
	  this.baseOptions = options;
	
	  this.baseOptions.headers = { Authorization: 'Bearer ' + this.baseOptions.token };
	
	  this.request = new RequestBuilder(this.baseOptions);
	  this.baseOptions.rootUrl = urljoin('https://' + this.baseOptions.domain, 'api', 'v2');
	}
	
	/**
	 * @callback userCallback
	 * @param {Error} [err] failure reason for the failed request to Management API
	 * @param {Object} [result] user profile
	 */
	
	/**
	 * Returns the user profile
	 *
	 * @method getUser
	 * @param {String} userId identifier of the user to retrieve
	 * @param {userCallback} cb
	 * @see https://auth0.com/docs/api/management/v2#!/Users/get_users_by_id
	 */
	Management.prototype.getUser = function(userId, cb) {
	  var url;
	
	  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'users', userId);
	
	  return this.request.get(url).end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	/**
	 * Updates the user metdata. It will patch the user metdata with the attributes sent.
	 *
	 *
	 * @method patchUserMetadata
	 * @param {String} userId
	 * @param {Object} userMetadata
	 * @param {userCallback} cb
	 * @see   {@link https://auth0.com/docs/api/management/v2#!/Users/patch_users_by_id}
	 */
	Management.prototype.patchUserMetadata = function(userId, userMetadata, cb) {
	  var url;
	
	  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
	  assert.check(userMetadata, { type: 'object', message: 'userMetadata parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  url = urljoin(this.baseOptions.rootUrl, 'users', userId);
	
	  return this.request
	    .patch(url)
	    .send({ user_metadata: userMetadata })
	    .end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	/**
	 * Link two users
	 *
	 * @method linkUser
	 * @param {String} userId
	 * @param {String} secondaryUserToken
	 * @param {userCallback} cb
	 * @see   {@link https://auth0.com/docs/api/management/v2#!/Users/post_identities}
	 */
	Management.prototype.linkUser = function(userId, secondaryUserToken, cb) {
	  var url;
	  /* eslint-disable */
	  assert.check(userId, { type: 'string', message: 'userId parameter is not valid' });
	  assert.check(secondaryUserToken, {
	    type: 'string',
	    message: 'secondaryUserToken parameter is not valid'
	  });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	  /* eslint-enable */
	
	  url = urljoin(this.baseOptions.rootUrl, 'users', userId, 'identities');
	
	  return this.request
	    .post(url)
	    .send({ link_with: secondaryUserToken })
	    .end(responseHandler(cb, { ignoreCasing: true }));
	};
	
	module.exports = Management;


/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	
	var windowHelper = __webpack_require__(105);
	var objectHelper = __webpack_require__(76);
	var RequestBuilder = __webpack_require__(273);
	
	function CrossOriginAuthentication(webAuth, options) {
	  this.webAuth = webAuth;
	  this.baseOptions = options;
	  this.request = new RequestBuilder(options);
	}
	
	function getFragment(name) {
	  var theWindow = windowHelper.getWindow();
	  var value = '&' + theWindow.location.hash.substring(1);
	  var parts = value.split('&' + name + '=');
	  if (parts.length === 2) {
	    return parts.pop().split('&').shift();
	  }
	}
	
	function createKey(origin, coId) {
	  return ['co/verifier', encodeURIComponent(origin), encodeURIComponent(coId)].join('/');
	}
	
	/**
	 * Logs in the user with username and password using the cross origin authentication (/co/authenticate) flow. You can use either `username` or `email` to identify the user, but `username` will take precedence over `email`.
	 * This only works when 3rd party cookies are enabled in the browser. After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 *
	 * @method login
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.username] Username (mutually exclusive with email)
	 * @param {String} [options.email] Email  (mutually exclusive with username)
	 * @param {String} options.password Password
	 * @param {String} [options.realm] Realm used to authenticate the user, it can be a realm name or a database connection name
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	CrossOriginAuthentication.prototype.login = function(options, cb) {
	  var _this = this;
	  var theWindow = windowHelper.getWindow();
	  var url = urljoin(this.baseOptions.rootUrl, '/co/authenticate');
	  var authenticateBody = {
	    client_id: options.clientID || this.baseOptions.clientID,
	    username: options.username || options.email
	  };
	  if (options.password) {
	    authenticateBody.password = options.password;
	  }
	  if (options.otp) {
	    authenticateBody.otp = options.otp;
	  }
	  var realm = options.realm || this.baseOptions.realm;
	
	  if (realm) {
	    var credentialType =
	      options.credentialType ||
	      this.baseOptions.credentialType ||
	      'http://auth0.com/oauth/grant-type/password-realm';
	    authenticateBody.realm = realm;
	    authenticateBody.credential_type = credentialType;
	  } else {
	    authenticateBody.credential_type = 'password';
	  }
	  this.request.post(url).withCredentials().send(authenticateBody).end(function(err, data) {
	    if (err) {
	      var errorObject = (err.response && err.response.body) || {
	        error: 'request_error',
	        error_description: JSON.stringify(err)
	      };
	      return cb(errorObject);
	    }
	    options = objectHelper.blacklist(options, ['username', 'password', 'credentialType', 'otp']);
	    var authorizeOptions = objectHelper
	      .merge(options)
	      .with({ loginTicket: data.body.login_ticket });
	    var key = createKey(_this.baseOptions.rootUrl, data.body.co_id);
	    theWindow.sessionStorage[key] = data.body.co_verifier;
	    _this.webAuth.authorize(authorizeOptions);
	  });
	};
	
	function tryGetVerifier(theWindow, key) {
	  try {
	    var verifier = theWindow.sessionStorage[key];
	    theWindow.sessionStorage.removeItem(key);
	    return verifier;
	  } catch (e) {
	    return '';
	  }
	}
	
	/**
	 * Runs the callback code for the cross origin authentication call. This method is meant to be called by the cross origin authentication callback url.
	 *
	 * @method callback
	 */
	CrossOriginAuthentication.prototype.callback = function() {
	  var targetOrigin = decodeURIComponent(getFragment('origin'));
	  var theWindow = windowHelper.getWindow();
	
	  theWindow.addEventListener('message', function(evt) {
	    if (evt.data.type !== 'co_verifier_request') {
	      return;
	    }
	    var key = createKey(evt.origin, evt.data.request.id);
	    var verifier = tryGetVerifier(theWindow, key);
	
	    evt.source.postMessage(
	      {
	        type: 'co_verifier_response',
	        response: {
	          verifier: verifier
	        }
	      },
	      evt.origin
	    );
	  });
	
	  theWindow.parent.postMessage({ type: 'ready' }, targetOrigin);
	};
	
	module.exports = CrossOriginAuthentication;


/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	var IdTokenVerifier = __webpack_require__(2265);
	
	var assert = __webpack_require__(117);
	var error = __webpack_require__(729);
	var qs = __webpack_require__(236);
	var PluginHandler = __webpack_require__(1568);
	var windowHelper = __webpack_require__(105);
	var objectHelper = __webpack_require__(76);
	var TransactionManager = __webpack_require__(389);
	var Authentication = __webpack_require__(727);
	var Redirect = __webpack_require__(1581);
	var Popup = __webpack_require__(1580);
	var SilentAuthenticationHandler = __webpack_require__(1582);
	var CrossOriginAuthentication = __webpack_require__(1578);
	var WebMessageHandler = __webpack_require__(1584);
	
	/**
	 * Handles all the browser's AuthN/AuthZ flows
	 * @constructor
	 * @param {Object} options
	 * @param {String} options.domain your Auth0 domain
	 * @param {String} options.clientID your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {Array} [options.plugins]
	 * @param {Number} [options._timesToRetryFailedRequests] Number of times to retry a failed request, according to {@link https://github.com/visionmedia/superagent/blob/master/lib/should-retry.js}
	 * @see {@link https://auth0.com/docs/api/authentication}
	 */
	function WebAuth(options) {
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      domain: { type: 'string', message: 'domain option is required' },
	      clientID: { type: 'string', message: 'clientID option is required' },
	      responseType: { optional: true, type: 'string', message: 'responseType is not valid' },
	      responseMode: { optional: true, type: 'string', message: 'responseMode is not valid' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri is not valid' },
	      scope: { optional: true, type: 'string', message: 'scope is not valid' },
	      audience: { optional: true, type: 'string', message: 'audience is not valid' },
	      leeway: { optional: true, type: 'number', message: 'leeway is not valid' },
	      plugins: { optional: true, type: 'array', message: 'plugins is not valid' },
	      _disableDeprecationWarnings: {
	        optional: true,
	        type: 'boolean',
	        message: '_disableDeprecationWarnings option is not valid'
	      },
	      _sendTelemetry: {
	        optional: true,
	        type: 'boolean',
	        message: '_sendTelemetry option is not valid'
	      },
	      _telemetryInfo: {
	        optional: true,
	        type: 'object',
	        message: '_telemetryInfo option is not valid'
	      },
	      _timesToRetryFailedRequests: {
	        optional: true,
	        type: 'number',
	        message: '_timesToRetryFailedRequests option is not valid'
	      }
	    }
	  );
	
	  if (options.overrides) {
	    assert.check(
	      options.overrides,
	      { type: 'object', message: 'overrides option is not valid' },
	      {
	        __tenant: { type: 'string', message: '__tenant option is required' },
	        __token_issuer: { type: 'string', message: '__token_issuer option is required' }
	      }
	    );
	  }
	  /* eslint-enable */
	
	  this.baseOptions = options;
	  this.baseOptions.plugins = new PluginHandler(this, this.baseOptions.plugins || []);
	
	  this.baseOptions._sendTelemetry = this.baseOptions._sendTelemetry === false
	    ? this.baseOptions._sendTelemetry
	    : true;
	
	  this.baseOptions._timesToRetryFailedRequests = options._timesToRetryFailedRequests
	    ? parseInt(options._timesToRetryFailedRequests, 0)
	    : 0;
	
	  this.baseOptions.tenant =
	    (this.baseOptions.overrides && this.baseOptions.overrides.__tenant) ||
	    this.baseOptions.domain.split('.')[0];
	
	  this.baseOptions.token_issuer =
	    (this.baseOptions.overrides && this.baseOptions.overrides.__token_issuer) ||
	    'https://' + this.baseOptions.domain + '/';
	
	  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
	
	  this.client = new Authentication(this.baseOptions);
	  this.redirect = new Redirect(this.client, this.baseOptions);
	  this.popup = new Popup(this, this.baseOptions);
	  this.crossOriginAuthentication = new CrossOriginAuthentication(this, this.baseOptions);
	  this.webMessageHandler = new WebMessageHandler(this);
	}
	
	/**
	 * Parse the url hash and extract the Auth response from a Auth flow started with {@link authorize}
	 *
	 * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
	 * by the `/.well-known/jwks.json` endpoint of your account.
	 * Tokens signed with other algorithms, e.g. HS256 will not be accepted.
	 *
	 * @method parseHash
	 * @param {Object} options
	 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
	 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
	 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
	 * @param {authorizeCallback} cb
	 */
	WebAuth.prototype.parseHash = function(options, cb) {
	  var parsedQs;
	  var err;
	
	  if (!cb && typeof options === 'function') {
	    cb = options;
	    options = {};
	  } else {
	    options = options || {};
	  }
	
	  var _window = windowHelper.getWindow();
	
	  var hashStr = options.hash === undefined ? _window.location.hash : options.hash;
	  hashStr = hashStr.replace(/^#?\/?/, '');
	
	  parsedQs = qs.parse(hashStr);
	
	  if (parsedQs.hasOwnProperty('error')) {
	    err = error.buildResponse(parsedQs.error, parsedQs.error_description);
	
	    if (parsedQs.state) {
	      err.state = parsedQs.state;
	    }
	
	    return cb(err);
	  }
	
	  if (
	    !parsedQs.hasOwnProperty('access_token') &&
	    !parsedQs.hasOwnProperty('id_token') &&
	    !parsedQs.hasOwnProperty('refresh_token')
	  ) {
	    return cb(null, null);
	  }
	  return this.validateAuthenticationResponse(options, parsedQs, cb);
	};
	
	/**
	 * Validates an Auth response from a Auth flow started with {@link authorize}
	 *
	 * Only validates id_tokens signed by Auth0 using the RS256 algorithm using the public key exposed
	 * by the `/.well-known/jwks.json` endpoint of your account.
	 * Tokens signed with other algorithms, e.g. HS256 will not be accepted.
	 *
	 * @method validateAuthenticationResponse
	 * @param {Object} options
	 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
	 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
	 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
	 * @param {authorizeCallback} cb
	 */
	WebAuth.prototype.validateAuthenticationResponse = function(options, parsedHash, cb) {
	  var _this = this;
	  var state = parsedHash.state;
	  var transaction = this.transactionManager.getStoredTransaction(state);
	  var transactionStateMatchesState = transaction && transaction.state === state;
	  if (state && !transactionStateMatchesState) {
	    return cb({
	      error: 'invalid_token',
	      errorDescription: '`state` does not match.'
	    });
	  }
	  var transactionNonce = options.nonce || (transaction && transaction.nonce) || null;
	
	  var appState = (transaction && transaction.appState) || null;
	
	  if (!parsedHash.id_token) {
	    return cb(null, buildParseHashResponse(parsedHash, appState, null));
	  }
	  return this.validateToken(parsedHash.id_token, transactionNonce, function(
	    validationError,
	    payload
	  ) {
	    if (!validationError) {
	      return cb(null, buildParseHashResponse(parsedHash, appState, payload));
	    }
	    if (validationError.error !== 'invalid_token') {
	      return cb(validationError);
	    }
	    // if it's an invalid_token error, decode the token
	    var decodedToken = new IdTokenVerifier().decode(parsedHash.id_token);
	    // if the alg is not HS256, return the raw error
	    if (decodedToken.header.alg !== 'HS256') {
	      return cb(validationError);
	    }
	    // if the alg is HS256, use the /userinfo endpoint to build the payload
	    return _this.client.userInfo(parsedHash.access_token, function(errUserInfo, profile) {
	      // if the /userinfo request fails, use the validationError instead
	      if (errUserInfo) {
	        return cb(validationError);
	      }
	      return cb(null, buildParseHashResponse(parsedHash, appState, profile));
	    });
	  });
	};
	
	function buildParseHashResponse(qsParams, appState, token) {
	  return {
	    accessToken: qsParams.access_token || null,
	    idToken: qsParams.id_token || null,
	    idTokenPayload: token || null,
	    appState: appState || null,
	    refreshToken: qsParams.refresh_token || null,
	    state: qsParams.state || null,
	    expiresIn: qsParams.expires_in ? parseInt(qsParams.expires_in, 10) : null,
	    tokenType: qsParams.token_type || null,
	    scope: qsParams.scope || null
	  };
	}
	
	/**
	 * @callback validateTokenCallback
	 * @param {Error} [err] error returned by while validating the token
	 * @param {Object} [payload] claims stored in the token
	 */
	
	/**
	 * Decodes the a JWT and verifies its nonce value
	 *
	 * @method validateToken
	 * @private
	 * @param {String} token
	 * @param {String} nonce
	 * @param {validateTokenCallback} cb
	 */
	WebAuth.prototype.validateToken = function(token, nonce, cb) {
	  var verifier = new IdTokenVerifier({
	    issuer: this.baseOptions.token_issuer,
	    audience: this.baseOptions.clientID,
	    leeway: this.baseOptions.leeway || 0,
	    __disableExpirationCheck: this.baseOptions.__disableExpirationCheck
	  });
	
	  verifier.verify(token, nonce, function(err, payload) {
	    if (err) {
	      return cb(error.invalidJwt(err.message));
	    }
	
	    cb(null, payload);
	  });
	};
	
	/**
	 * Executes a silent authentication transaction under the hood in order to fetch a new tokens for the current session.
	 * This method requires that all Auth is performed with {@link authorize}
	 * Watch out! If you're not using the hosted login page to do social logins, you have to use your own [social connection keys](https://manage.auth0.com/#/connections/social). If you use Auth0's dev keys, you'll always get `login_required` as an error when calling this method.
	 *
	 * @method renewAuth
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {String} [options.postMessageDataType] identifier data type to look for in postMessage event data, where events are initiated from silent callback urls, before accepting a message event is the event expected. A value of false means any postMessage event will trigger a callback.
	 * @param {String} [options.postMessageOrigin] origin of redirectUri to expect postMessage response from.  Defaults to the origin of the receiving window. Only used if usePostMessage is truthy.
	 * @param {String} [options.timeout] value in milliseconds used to timeout when the `/authorize` call is failing as part of the silent authentication with postmessage enabled due to a configuration.
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 */
	WebAuth.prototype.renewAuth = function(options, cb) {
	  var handler;
	  var usePostMessage = !!options.usePostMessage;
	  var postMessageDataType = options.postMessageDataType || false;
	  var postMessageOrigin = options.postMessageOrigin || windowHelper.getWindow().origin;
	  var timeout = options.timeout;
	  var _this = this;
	
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'responseType',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  params.responseType = params.responseType || 'token';
	  params.responseMode = params.responseMode || 'fragment';
	  params = this.transactionManager.process(params);
	
	  assert.check(params, { type: 'object', message: 'options parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  params.prompt = 'none';
	
	  params = objectHelper.blacklist(params, [
	    'usePostMessage',
	    'tenant',
	    'postMessageDataType',
	    'postMessageOrigin'
	  ]);
	
	  handler = SilentAuthenticationHandler.create({
	    authenticationUrl: this.client.buildAuthorizeUrl(params),
	    postMessageDataType: postMessageDataType,
	    postMessageOrigin: postMessageOrigin,
	    timeout: timeout
	  });
	
	  handler.login(usePostMessage, function(err, hash) {
	    if (typeof hash === 'object') {
	      // hash was already parsed, so we just return it.
	      // it's here to be backwards compatible and should be removed in the next major version.
	      return cb(err, hash);
	    }
	    _this.parseHash({ hash: hash }, cb);
	  });
	};
	
	/**
	 * Renews an existing session on Auth0's servers using `response_mode=web_message`
	 *
	 * @method checkSession
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {String} [options.timeout] value in milliseconds used to timeout when the `/authorize` call is failing as part of the silent authentication with postmessage enabled due to a configuration.
	 */
	WebAuth.prototype.checkSession = function(options, cb) {
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'responseType',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  if (!options.nonce) {
	    params = this.transactionManager.process(params);
	  }
	
	  assert.check(params, { type: 'object', message: 'options parameter is not valid' });
	  assert.check(cb, { type: 'function', message: 'cb parameter is not valid' });
	
	  params = objectHelper.blacklist(params, ['usePostMessage', 'tenant', 'postMessageDataType']);
	  this.webMessageHandler.run(params, cb);
	};
	
	/**
	 * Request an email with instruction to change a user's password
	 *
	 * @method changePassword
	 * @param {Object} options
	 * @param {String} options.email address where the user will recieve the change password email. It should match the user's email in Auth0
	 * @param {String} options.connection name of the connection where the user was created
	 * @param {changePasswordCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#change-password}
	 */
	WebAuth.prototype.changePassword = function(options, cb) {
	  return this.client.dbConnection.changePassword(options, cb);
	};
	
	/**
	 * Starts a passwordless authentication transaction.
	 *
	 * @method passwordlessStart
	 * @param {Object} options
	 * @param {String} options.send what will be sent via email which could be `link` or `code`. For SMS `code` is the only one valud
	 * @param {String} [options.phoneNumber] phone number where to send the `code`. This parameter is mutually exclusive with `email`
	 * @param {String} [options.email] email where to send the `code` or `link`. This parameter is mutually exclusive with `phoneNumber`
	 * @param {String} options.connection name of the passwordless connection
	 * @param {Object} [options.authParams] additional Auth parameters when using `link`
	 * @param {Function} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#passwordless}
	 */
	WebAuth.prototype.passwordlessStart = function(options, cb) {
	  var authParams = objectHelper
	    .merge(this.baseOptions, [
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options.authParams);
	
	  options.authParams = this.transactionManager.process(authParams);
	  return this.client.passwordless.start(options, cb);
	};
	
	/**
	 * Creates a new user in a Auth0 Database connection
	 *
	 * @method signup
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {signUpCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#signup}
	 */
	WebAuth.prototype.signup = function(options, cb) {
	  return this.client.dbConnection.signup(options, cb);
	};
	
	/**
	 * Redirects to the hosted login page (`/authorize`) in order to start a new authN/authZ transaction.
	 * After that, you'll have to use the {@link parseHash} function at the specified `redirectUri`.
	 *
	 * @method authorize
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. The `query` value is only supported when `responseType` is `code`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 */
	WebAuth.prototype.authorize = function(options) {
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  params = this.transactionManager.process(params);
	
	  windowHelper.redirect(this.client.buildAuthorizeUrl(params));
	};
	
	/**
	 * Signs up a new user, automatically logs the user in after the signup and returns the user token.
	 * The login will be done using /oauth/token with password-realm grant type.
	 *
	 * @method signupAndAuthorize
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {tokenCallback} cb
	 * @see   {@link https://auth0.com/docs/api/authentication#signup}
	 * @see   {@link https://auth0.com/docs/api-auth/grant/password}
	 */
	WebAuth.prototype.signupAndAuthorize = function(options, cb) {
	  var _this = this;
	
	  return this.client.dbConnection.signup(
	    objectHelper.blacklist(options, ['popupHandler']),
	    function(err) {
	      if (err) {
	        return cb(err);
	      }
	      options.realm = options.connection;
	      if (!options.username) {
	        options.username = options.email;
	      }
	      _this.client.login(options, cb);
	    }
	  );
	};
	
	/**
	 * @callback crossOriginLoginCallback
	 * @param {Error} [err] Authentication error returned by Auth0 with the reason why the request failed
	 */
	
	/**
	 * Logs in the user with username and password using the cross origin authentication (/co/authenticate) flow. You can use either `username` or `email` to identify the user, but `username` will take precedence over `email`.
	 * Some browsers might not be able to successfully authenticate if 3rd party cookies are disabled in your browser. [See here for more information.]{@link https://auth0.com/docs/cross-origin-authentication}.
	 * After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 *
	 * @method login
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.username] Username (mutually exclusive with email)
	 * @param {String} [options.email] Email (mutually exclusive with username)
	 * @param {String} options.password Password
	 * @param {String} [options.realm] Realm used to authenticate the user, it can be a realm name or a database connection name
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	WebAuth.prototype.login = function(options, cb) {
	  this.crossOriginAuthentication.login(options, cb);
	};
	
	/**
	 * Logs in the user by verifying the verification code (OTP) using the cross origin authentication (/co/authenticate) flow. You can use either `phoneNumber` or `email` to identify the user.
	 * This only works when 3rd party cookies are enabled in the browser. After the /co/authenticate call, you'll have to use the {@link parseHash} function at the `redirectUri` specified in the constructor.
	 *
	 * @method login
	 * @param {Object} options options used in the {@link authorize} call after the login_ticket is acquired
	 * @param {String} [options.phoneNumber] Phone Number (mutually exclusive with email)
	 * @param {String} [options.email] Email (mutually exclusive with username)
	 * @param {String} options.verificationCode Verification Code (OTP)
	 * @param {String} options.connection Passwordless connection to use. It can either be 'sms' or 'email'.
	 * @param {crossOriginLoginCallback} cb Callback function called only when an authentication error, like invalid username or password, occurs. For other types of errors, there will be a redirect to the `redirectUri`.
	 */
	WebAuth.prototype.passwordlessLogin = function(options, cb) {
	  var loginOptions = objectHelper.extend(
	    {
	      credentialType: 'http://auth0.com/oauth/grant-type/passwordless/otp',
	      realm: options.connection,
	      username: options.email || options.phoneNumber,
	      otp: options.verificationCode
	    },
	    objectHelper.blacklist(options, ['connection', 'email', 'phoneNumber', 'verificationCode'])
	  );
	  this.crossOriginAuthentication.login(loginOptions, cb);
	};
	
	/**
	 * Runs the callback code for the cross origin authentication call. This method is meant to be called by the cross origin authentication callback url.
	 *
	 * @method crossOriginAuthenticationCallback
	 */
	WebAuth.prototype.crossOriginAuthenticationCallback = function() {
	  this.crossOriginAuthentication.callback();
	};
	
	/**
	 * Redirects to the auth0 logout endpoint
	 *
	 * If you want to navigate the user to a specific URL after the logout, set that URL at the returnTo parameter. The URL should be included in any the appropriate Allowed Logout URLs list:
	 *
	 * - If the client_id parameter is included, the returnTo URL must be listed in the Allowed Logout URLs set at the client level (see Setting Allowed Logout URLs at the App Level).
	 * - If the client_id parameter is NOT included, the returnTo URL must be listed in the Allowed Logout URLs set at the account level (see Setting Allowed Logout URLs at the Account Level).
	 *
	 * @method logout
	 * @param {Object} options
	 * @param {String} [options.clientID] identifier of your client
	 * @param {String} [options.returnTo] URL to be redirected after the logout
	 * @param {Boolean} [options.federated] tells Auth0 if it should logout the user also from the IdP.
	 * @see   {@link https://auth0.com/docs/api/authentication#logout}
	 */
	WebAuth.prototype.logout = function(options) {
	  windowHelper.redirect(this.client.buildLogoutUrl(options));
	};
	
	/**
	 * Verifies the passwordless TOTP and redirects to finish the passwordless transaction
	 *
	 * @method passwordlessVerify
	 * @param {Object} options
	 * @param {String} options.type `sms` or `email`
	 * @param {String} options.phoneNumber only if type = sms
	 * @param {String} options.email only if type = email
	 * @param {String} options.connection the connection name
	 * @param {String} options.verificationCode the TOTP code
	 * @param {Function} cb
	 */
	WebAuth.prototype.passwordlessVerify = function(options, cb) {
	  var _this = this;
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'responseType',
	      'responseMode',
	      'redirectUri',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  params = this.transactionManager.process(params);
	  return this.client.passwordless.verify(params, function(err) {
	    if (err) {
	      return cb(err);
	    }
	    return windowHelper.redirect(_this.client.passwordless.buildVerifyUrl(params));
	  });
	};
	
	module.exports = WebAuth;


/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	var WinChan = __webpack_require__(1418);
	
	var urlHelper = __webpack_require__(1575);
	var assert = __webpack_require__(117);
	var responseHandler = __webpack_require__(172);
	var PopupHandler = __webpack_require__(1569);
	var objectHelper = __webpack_require__(76);
	var Warn = __webpack_require__(274);
	var TransactionManager = __webpack_require__(389);
	
	function Popup(webAuth, options) {
	  this.baseOptions = options;
	  this.client = webAuth.client;
	  this.webAuth = webAuth;
	
	  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * Returns a new instance of the popup handler
	 *
	 * @method buildPopupHandler
	 * @private
	 */
	Popup.prototype.buildPopupHandler = function() {
	  var pluginHandler = this.baseOptions.plugins.get('popup.getPopupHandler');
	
	  if (pluginHandler) {
	    return pluginHandler.getPopupHandler();
	  }
	
	  return new PopupHandler();
	};
	
	/**
	 * Initializes the popup window and returns the instance to be used later in order to avoid being blocked by the browser.
	 *
	 * @method preload
	 * @param {Object} options receives the window height and width and any other window feature to be sent to window.open
	 */
	Popup.prototype.preload = function(options) {
	  options = options || {};
	
	  var popup = this.buildPopupHandler();
	
	  popup.preload(options);
	  return popup;
	};
	
	/**
	 * Internal use.
	 *
	 * @method getPopupHandler
	 * @private
	 */
	Popup.prototype.getPopupHandler = function(options, preload) {
	  if (options.popupHandler) {
	    return options.popupHandler;
	  }
	
	  if (preload) {
	    return this.preload(options);
	  }
	
	  return this.buildPopupHandler();
	};
	
	/**
	 * Handles the popup logic for the callback page.
	 *
	 * @method callback
	 * @param {Object} options
	 * @param {String} options.hash the url hash. If not provided it will extract from window.location.hash
	 * @param {String} [options.state] value originally sent in `state` parameter to {@link authorize} to mitigate XSRF
	 * @param {String} [options.nonce] value originally sent in `nonce` parameter to {@link authorize} to prevent replay attacks
	 * @param {String} [options._idTokenVerification] makes parseHash perform or skip `id_token` verification. We **strongly** recommend validating the `id_token` yourself if you disable the verification.
	 * @see   {@link parseHash}
	 */
	Popup.prototype.callback = function(options) {
	  var _this = this;
	  WinChan.onOpen(function(popupOrigin, r, cb) {
	    _this.webAuth.parseHash(options || {}, function(err, data) {
	      return cb(err || data);
	    });
	  });
	};
	
	/**
	 * Shows inside a new window the hosted login page (`/authorize`) in order to start a new authN/authZ transaction and post its result using `postMessage`.
	 *
	 * @method authorize
	 * @param {Object} options
	 * @param {String} [options.domain] your Auth0 domain
	 * @param {String} [options.clientID] your Auth0 client identifier obtained when creating the client in the Auth0 Dashboard
	 * @param {String} options.redirectUri url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} options.responseType type of the response used by OAuth 2.0 flow. It can be any space separated list of the values `code`, `token`, `id_token`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0}
	 * @param {String} [options.responseMode] how the Auth response is encoded and redirected back to the client. Supported values are `query`, `fragment` and `form_post`. {@link https://openid.net/specs/oauth-v2-multiple-response-types-1_0.html#ResponseModes}
	 * @param {String} [options.state] value used to mitigate XSRF attacks. {@link https://auth0.com/docs/protocols/oauth2/oauth-state}
	 * @param {String} [options.nonce] value used to mitigate replay attacks when using Implicit Grant. {@link https://auth0.com/docs/api-auth/tutorials/nonce}
	 * @param {String} [options.scope] scopes to be requested during Auth. e.g. `openid email`
	 * @param {String} [options.audience] identifier of the resource server who will consume the access token issued after Auth
	 * @param {Boolean} [options.owp] determines if Auth0 should render the relay page or not and the caller is responsible of handling the response.
	 * @param {authorizeCallback} cb
	 * @see {@link https://auth0.com/docs/api/authentication#authorize-client}
	 */
	Popup.prototype.authorize = function(options, cb) {
	  var popup;
	  var url;
	  var relayUrl;
	  var popOpts = {};
	
	  var pluginHandler = this.baseOptions.plugins.get('popup.authorize');
	
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'scope',
	      'domain',
	      'audience',
	      'tenant',
	      'responseType',
	      'redirectUri',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(objectHelper.blacklist(options, ['popupHandler']));
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  // the relay page should not be necesary as long it happens in the same domain
	  // (a redirectUri shoul be provided). It is necesary when using OWP
	  relayUrl = urljoin(this.baseOptions.rootUrl, 'relay.html');
	
	  // if a owp is enabled, it should use the owp flag
	  if (options.owp) {
	    // used by server to render the relay page instead of sending the chunk in the
	    // url to the callback
	    params.owp = true;
	  } else {
	    popOpts.origin = urlHelper.extractOrigin(params.redirectUri);
	    relayUrl = params.redirectUri;
	  }
	
	  if (options.popupOptions) {
	    popOpts.popupOptions = objectHelper.pick(options.popupOptions, ['width', 'height']);
	  }
	
	  if (pluginHandler) {
	    params = pluginHandler.processParams(params);
	  }
	
	  params = this.transactionManager.process(params);
	
	  delete params.domain;
	
	  url = this.client.buildAuthorizeUrl(params);
	
	  popup = this.getPopupHandler(options);
	
	  return popup.load(url, relayUrl, popOpts, responseHandler(cb));
	};
	
	/**
	 * Performs authentication with username/email and password with a database connection inside a new window
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link authorize} or {@link login}.
	 *
	 * @method loginWithCredentials
	 * @param {Object} options
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used. It can be any of the values `code` and `token`
	 * @param {String} [options.responseMode] how the AuthN response is encoded and redirected back to the client. Supported values are `query` and `fragment`
	 * @param {String} [options.scope] scopes to be requested during AuthN. e.g. `openid email`
	 * @param {credentialsCallback} cb
	 */
	Popup.prototype.loginWithCredentials = function(options, cb) {
	  var params;
	  var popup;
	  var url;
	  var relayUrl;
	
	  /* eslint-disable */
	  assert.check(
	    options,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      clientID: { optional: true, type: 'string', message: 'clientID option is required' },
	      redirectUri: { optional: true, type: 'string', message: 'redirectUri option is required' },
	      responseType: { optional: true, type: 'string', message: 'responseType option is required' },
	      scope: { optional: true, type: 'string', message: 'scope option is required' },
	      audience: { optional: true, type: 'string', message: 'audience option is required' }
	    }
	  );
	  /* eslint-enable */
	
	  popup = this.getPopupHandler(options);
	
	  options = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'scope',
	      'domain',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(objectHelper.blacklist(options, ['popupHandler']));
	
	  params = objectHelper.pick(options, ['clientID', 'domain']);
	  params.options = objectHelper.toSnakeCase(
	    objectHelper.pick(options, ['password', 'connection', 'state', 'scope', '_csrf', 'device'])
	  );
	  params.options.username = options.username || options.email;
	
	  url = urljoin(this.baseOptions.rootUrl, 'sso_dbconnection_popup', options.clientID);
	  relayUrl = urljoin(this.baseOptions.rootUrl, 'relay.html');
	
	  return popup.load(url, relayUrl, { params: params }, responseHandler(cb));
	};
	
	/**
	 * Verifies the passwordless TOTP and redirects to finish the passwordless transaction
	 *
	 * @method passwordlessVerify
	 * @param {Object} options
	 * @param {String} options.type `sms` or `email`
	 * @param {String} options.phoneNumber only if type = sms
	 * @param {String} options.email only if type = email
	 * @param {String} options.connection the connection name
	 * @param {String} options.verificationCode the TOTP code
	 * @param {Function} cb
	 */
	Popup.prototype.passwordlessVerify = function(options, cb) {
	  var _this = this;
	  return this.client.passwordless.verify(
	    objectHelper.blacklist(options, ['popupHandler']),
	    function(err) {
	      if (err) {
	        return cb(err);
	      }
	
	      options.username = options.phoneNumber || options.email;
	      options.password = options.verificationCode;
	
	      delete options.email;
	      delete options.phoneNumber;
	      delete options.verificationCode;
	      delete options.type;
	
	      _this.client.loginWithResourceOwner(options, cb);
	    }
	  );
	};
	
	/**
	 * Signs up a new user and automatically logs the user in after the signup.
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link authorize} or {@link signupAndAuthorize}.
	 *
	 * @method signupAndLogin
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {credentialsCallback} cb
	 */
	Popup.prototype.signupAndLogin = function(options, cb) {
	  var _this = this;
	
	  // Preload popup to avoid the browser to block it since the login happens later
	  var popupHandler = this.getPopupHandler(options, true);
	  options.popupHandler = popupHandler;
	
	  return this.client.dbConnection.signup(
	    objectHelper.blacklist(options, ['popupHandler']),
	    function(err) {
	      if (err) {
	        if (popupHandler._current_popup) {
	          popupHandler._current_popup.kill();
	        }
	        return cb(err);
	      }
	      _this.loginWithCredentials(options, cb);
	    }
	  );
	};
	
	module.exports = Popup;


/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	var UsernamePassword = __webpack_require__(1583);
	var objectHelper = __webpack_require__(76);
	var Warn = __webpack_require__(274);
	var assert = __webpack_require__(117);
	
	function Redirect(client, options) {
	  this.baseOptions = options;
	  this.client = client;
	
	  this.warn = new Warn({
	    disableWarnings: !!options._disableDeprecationWarnings
	  });
	}
	
	/**
	 * @callback credentialsCallback
	 * @param {Error} [err] error returned by Auth0 with the reason of the Auth failure
	 * @param {Object} [result] result of the AuthN request
	 * @param {String} result.accessToken token that can be used with {@link userinfo}
	 * @param {String} [result.idToken] token that identifies the user
	 * @param {String} [result.refreshToken] token that can be used to get new access tokens from Auth0. Note that not all clients can request them or the resource server might not allow them.
	 */
	
	/**
	 * Performs authentication with username/email and password with a database connection
	 *
	 * This method is not compatible with API Auth so if you need to fetch API tokens with audience
	 * you should use {@link authorize} or {@link login}.
	 *
	 * @method loginWithCredentials
	 * @param {Object} options
	 * @param {String} [options.redirectUri] url that the Auth0 will redirect after Auth with the Authorization Response
	 * @param {String} [options.responseType] type of the response used. It can be any of the values `code` and `token`
	 * @param {String} [options.responseMode] how the AuthN response is encoded and redirected back to the client. Supported values are `query` and `fragment`
	 * @param {String} [options.scope] scopes to be requested during AuthN. e.g. `openid email`
	 * @param {credentialsCallback} cb
	 */
	Redirect.prototype.loginWithCredentials = function(options, cb) {
	  var usernamePassword;
	
	  var params = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'tenant',
	      'responseType',
	      'responseMode',
	      'scope',
	      'audience',
	      '_csrf',
	      'state',
	      '_intstate',
	      'nonce'
	    ])
	    .with(options);
	
	  assert.check(
	    params,
	    { type: 'object', message: 'options parameter is not valid' },
	    {
	      responseType: { type: 'string', message: 'responseType option is required' }
	    }
	  );
	
	  usernamePassword = new UsernamePassword(this.baseOptions);
	  return usernamePassword.login(params, function(err, data) {
	    if (err) {
	      return cb(err);
	    }
	    return usernamePassword.callback(data);
	  });
	};
	
	/**
	 * Signs up a new user and automatically logs the user in after the signup.
	 *
	 * @method signupAndLogin
	 * @param {Object} options
	 * @param {String} options.email user email address
	 * @param {String} options.password user password
	 * @param {String} options.connection name of the connection where the user will be created
	 * @param {credentialsCallback} cb
	 */
	Redirect.prototype.signupAndLogin = function(options, cb) {
	  var _this = this;
	  return this.client.dbConnection.signup(options, function(err) {
	    if (err) {
	      return cb(err);
	    }
	    return _this.loginWithCredentials(options, cb);
	  });
	};
	
	module.exports = Redirect;


/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	var IframeHandler = __webpack_require__(730);
	var windowHelper = __webpack_require__(105);
	
	function SilentAuthenticationHandler(options) {
	  this.authenticationUrl = options.authenticationUrl;
	  this.timeout = options.timeout || 60 * 1000;
	  this.handler = null;
	  this.postMessageDataType = options.postMessageDataType || false;
	  this.postMessageOrigin = options.postMessageOrigin || windowHelper.getWindow().origin;
	}
	
	SilentAuthenticationHandler.create = function(options) {
	  return new SilentAuthenticationHandler(options);
	};
	
	SilentAuthenticationHandler.prototype.login = function(usePostMessage, callback) {
	  this.handler = new IframeHandler({
	    auth0: this.auth0,
	    url: this.authenticationUrl,
	    eventListenerType: usePostMessage ? 'message' : 'load',
	    callback: this.getCallbackHandler(callback, usePostMessage),
	    timeout: this.timeout,
	    eventValidator: this.getEventValidator(),
	    timeoutCallback: function() {
	      callback(null, '#error=timeout&error_description=Timeout+during+authentication+renew.');
	    },
	    usePostMessage: usePostMessage || false
	  });
	
	  this.handler.init();
	};
	
	SilentAuthenticationHandler.prototype.getEventValidator = function() {
	  var _this = this;
	  return {
	    isValid: function(eventData) {
	      switch (eventData.event.type) {
	        case 'message':
	          // Message must come from the expected origin and iframe window.
	          if (
	            eventData.event.origin !== _this.postMessageOrigin ||
	            eventData.event.source !== _this.handler.iframe.contentWindow
	          ) {
	            return false;
	          }
	
	          // Default behaviour, return all message events from the iframe.
	          if (_this.postMessageDataType === false) {
	            return true;
	          }
	
	          return (
	            eventData.event.data.type && eventData.event.data.type === _this.postMessageDataType
	          );
	
	        case 'load': // Fall through to default
	        default:
	          return true;
	      }
	    }
	  };
	};
	
	SilentAuthenticationHandler.prototype.getCallbackHandler = function(callback, usePostMessage) {
	  return function(eventData) {
	    var callbackValue;
	    if (!usePostMessage) {
	      callbackValue = eventData.sourceObject.contentWindow.location.hash;
	    } else if (typeof eventData.event.data === 'object' && eventData.event.data.hash) {
	      callbackValue = eventData.event.data.hash;
	    } else {
	      callbackValue = eventData.event.data;
	    }
	    callback(null, callbackValue);
	  };
	};
	
	module.exports = SilentAuthenticationHandler;


/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	
	var objectHelper = __webpack_require__(76);
	var RequestBuilder = __webpack_require__(273);
	var responseHandler = __webpack_require__(172);
	var windowHelper = __webpack_require__(105);
	var TransactionManager = __webpack_require__(389);
	
	function UsernamePassword(options) {
	  this.baseOptions = options;
	  this.request = new RequestBuilder(options);
	  this.transactionManager = new TransactionManager(this.baseOptions.transaction);
	}
	
	UsernamePassword.prototype.login = function(options, cb) {
	  var url;
	  var body;
	
	  url = urljoin(this.baseOptions.rootUrl, 'usernamepassword', 'login');
	
	  options.username = options.username || options.email; // eslint-disable-line
	
	  options = objectHelper.blacklist(options, ['email']); // eslint-disable-line
	
	  body = objectHelper
	    .merge(this.baseOptions, [
	      'clientID',
	      'redirectUri',
	      'tenant',
	      'responseType',
	      'responseMode',
	      'scope',
	      'audience'
	    ])
	    .with(options);
	  body = this.transactionManager.process(body);
	
	  body = objectHelper.toSnakeCase(body, ['auth0Client']);
	
	  return this.request.post(url).send(body).end(responseHandler(cb));
	};
	
	UsernamePassword.prototype.callback = function(formHtml) {
	  var div;
	  var form;
	  var _document = windowHelper.getDocument();
	
	  div = _document.createElement('div');
	  div.innerHTML = formHtml;
	  form = _document.body.appendChild(div).children[0];
	
	  form.submit();
	};
	
	module.exports = UsernamePassword;


/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	var IframeHandler = __webpack_require__(730);
	var objectHelper = __webpack_require__(76);
	
	function runWebMessageFlow(authorizeUrl, options, callback) {
	  var handler = new IframeHandler({
	    url: authorizeUrl,
	    eventListenerType: 'message',
	    callback: function(eventData) {
	      callback(null, eventData);
	    },
	    timeout: options.timeout,
	    eventValidator: {
	      isValid: function(eventData) {
	        return eventData.event.data.type === 'authorization_response';
	      }
	    },
	    timeoutCallback: function() {
	      callback({
	        error: 'timeout',
	        error_description: 'Timeout during executing web_message communication'
	      });
	    }
	  });
	  handler.init();
	}
	
	function WebMessageHandler(webAuth) {
	  this.webAuth = webAuth;
	}
	
	WebMessageHandler.prototype.run = function(options, cb) {
	  var _this = this;
	  options.responseMode = 'web_message';
	  options.prompt = 'none';
	  runWebMessageFlow(this.webAuth.client.buildAuthorizeUrl(options), options, function(
	    err,
	    eventData
	  ) {
	    var error = err;
	    if (!err && eventData.event.data.response.error) {
	      error = objectHelper.pick(eventData.event.data.response, ['error', 'error_description']);
	    }
	    if (error) {
	      return cb(error);
	    }
	    var parsedHash = eventData.event.data.response;
	    _this.webAuth.validateAuthenticationResponse(options, parsedHash, cb);
	  });
	};
	
	module.exports = WebMessageHandler;


/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	var bind = __webpack_require__(735);
	var Axios = __webpack_require__(1587);
	var defaults = __webpack_require__(390);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(732);
	axios.CancelToken = __webpack_require__(1586);
	axios.isCancel = __webpack_require__(733);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(1601);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(732);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(390);
	var utils = __webpack_require__(77);
	var InterceptorManager = __webpack_require__(1588);
	var dispatchRequest = __webpack_require__(1589);
	var isAbsoluteURL = __webpack_require__(1597);
	var combineURLs = __webpack_require__(1595);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	var transformData = __webpack_require__(1592);
	var isCancel = __webpack_require__(733);
	var defaults = __webpack_require__(390);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ },
/* 1590 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(734);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 1593 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ },
/* 1595 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 1597 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(77);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 1601 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(157);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Admin = function (_Component) {
	  _inherits(Admin, _Component);
	
	  function Admin() {
	    _classCallCheck(this, Admin);
	
	    return _possibleConstructorReturn(this, (Admin.__proto__ || Object.getPrototypeOf(Admin)).apply(this, arguments));
	  }
	
	  _createClass(Admin, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ message: '' });
	    }
	  }, {
	    key: 'adminPing',
	    value: function adminPing() {
	      var _this2 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.post(_server2.default + '/admin', {}, { headers: headers }).then(function (response) {
	        return _this2.setState({ message: response.data.message });
	      }).catch(function (error) {
	        return _this2.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var message = this.state.message;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'You are an Admin!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Only users who have a',
	          ' ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'scope'
	          ),
	          ' ',
	          'of',
	          ' ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'write:messages'
	          ),
	          ' ',
	          'in their',
	          ' ',
	          _react2.default.createElement(
	            'code',
	            null,
	            'access_token'
	          ),
	          ' ',
	          'can see this area.'
	        ),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Call an Admin endpoint'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', onClick: this.adminPing.bind(this) },
	          'Post a Message'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          message
	        )
	      );
	    }
	  }]);
	
	  return Admin;
	}(_react.Component);
	
	exports.default = Admin;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(157);
	
	__webpack_require__(1999);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AppHeader = function (_Component) {
	  _inherits(AppHeader, _Component);
	
	  function AppHeader() {
	    _classCallCheck(this, AppHeader);
	
	    return _possibleConstructorReturn(this, (AppHeader.__proto__ || Object.getPrototypeOf(AppHeader)).apply(this, arguments));
	  }
	
	  _createClass(AppHeader, [{
	    key: 'goTo',
	    value: function goTo(route) {
	      this.props.history.replace('/' + route);
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      this.props.auth.login();
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.props.auth.logout();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props$auth = this.props.auth,
	          isAuthenticated = _props$auth.isAuthenticated,
	          userHasScopes = _props$auth.userHasScopes;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactBootstrap.Navbar,
	          { fluid: true },
	          _react2.default.createElement(
	            _reactBootstrap.Navbar.Header,
	            null,
	            _react2.default.createElement(
	              _reactBootstrap.Navbar.Brand,
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: '#' },
	                'Project X'
	              )
	            ),
	            _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.goTo.bind(this, 'home')
	              },
	              'Home'
	            ),
	            !isAuthenticated() && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.login.bind(this)
	              },
	              'Log In'
	            ),
	            isAuthenticated() && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.goTo.bind(this, 'profile')
	              },
	              'Profile'
	            ),
	            isAuthenticated() && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.goTo.bind(this, 'addCampaign')
	              },
	              'Add Campaign'
	            ),
	            isAuthenticated() && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.goTo.bind(this, 'campaign')
	              },
	              'Edit Campaign'
	            ),
	            isAuthenticated() && userHasScopes(['write:messages']) && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.goTo.bind(this, 'admin')
	              },
	              'Admin'
	            ),
	            isAuthenticated() && _react2.default.createElement(
	              _reactBootstrap.Button,
	              {
	                bsStyle: 'primary',
	                className: 'btn-margin',
	                onClick: this.logout.bind(this)
	              },
	              'Log Out'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return AppHeader;
	}(_react.Component);
	
	exports.default = AppHeader;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _auth0Js = __webpack_require__(1576);
	
	var _auth0Js2 = _interopRequireDefault(_auth0Js);
	
	var _auth = __webpack_require__(1643);
	
	var _history = __webpack_require__(1735);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Auth = function () {
	  function Auth() {
	    _classCallCheck(this, Auth);
	
	    this.fakeProfile = {
	      "sub": "google-oauth2|113428671036294433095",
	      "given_name": "Tom",
	      "family_name": "Lee",
	      "nickname": "leehc114",
	      "name": "Tom Lee",
	      "picture": "https://lh5.googleusercontent.com/-A6Z9MM3tHss/AAAAAAAAAAI/AAAAAAAAGKQ/_NQzRXdeylM/photo.jpg",
	      "gender": "male",
	      "locale": "en",
	      "updated_at": "2018-03-18T22:57:09.640Z",
	      "email": "leehc114@gmail.com",
	      "email_verified": true
	    };
	    this.fakeAccessToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik5qQkNSa0kxTmtKR056VXhNekV4TTBNd0" + "5rUkJPVUZCUVRjMk1ETTNORE16UlVWQ016Z3pRUSJ9.eyJpc3MiOiJodHRwczovL3Byb" + "2plY3QteHguYXUuYXV0aDAuY29tLyIsInN1YiI6Imdvb2dsZS1vYXV0aDJ8MTEzNDI4N" + "jcxMDM2Mjk0NDMzMDk1IiwiYXVkIjpbImh0dHA6Ly9sb2NhbGhvc3QvIiwiaHR0cHM6L" + "y9wcm9qZWN0LXh4LmF1LmF1dGgwLmNvbS91c2VyaW5mbyJdLCJpYXQiOjE1MjE0MTQxN" + "TMsImV4cCI6MTUyMTQyMTM1MywiYXpwIjoiT2NpS0hJRXZBTnZPeUVpNE9kR2c2VE5mY" + "m03LV9rVkciLCJzY29wZSI6Im9wZW5pZCBwcm9maWxlIGVtYWlsIn0.V3O8zznjPgw4_V3wsa3kVJ7ExQF684hKVGTWx8YHnSRTlqNSYmmwe-rBYHIoF61vqW7vW6_etc88HrlKoAczmdNkTPLaval0ONtvQ5dY-fkn6Ll-fsXggQkzjcpCYetXc91o_z4WGLwaMx5a7FJfe8HVZWqUzpjMr0s7D_HbOSUiB6iFOSOdSrit0OqzfbmndBvgacWuD8QNXilClH3AA-f_O3OGWmy92MKqInQTbw8Z8E3tPhGHlG8dI15xug-ejm-CcrIpJExBE2BR" + "ILzxeoHuH2JQwD8bA9vXyrZZ-ufxz9wnwEcw8_Q_zgtuD5_SlbjC4CM9_nHJfoVZRDaXFA";
	    this.fakeIdToken = "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ik5qQkNSa0kxTmtKR056VXhNekV4TTBNd05rUkJPVUZCUVRjMk1ETTNORE16UlVWQ016Z3pRUSJ9.eyJnaXZlbl9uYW1lIjoiVG9tIiwiZmFtaWx5X25hbWUiOiJMZWUiLCJuaWNrbmFtZSI6ImxlZWhjMTE0IiwibmFtZSI6IlRvbSBMZWUiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDUuZ29vZ2xldXNlcmNvbnRlbnQuY29tLy1BNlo5TU0zdEhzcy9BQUFBQUFBQUFBSS9BQUFBQUFBQUdLUS9fTlF6UlhkZXlsTS9waG90by5qcGciLCJnZW5kZXIiOiJtYWxlIiwibG9jYWxlIjoiZW4iLCJ1cGRhdGVkX2F0IjoiMjAxOC0wMy0xOFQyMzowMjozMy43ODlaIiwiZW1haWwiOiJsZWVoYzExNEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9wcm9qZWN0LXh4LmF1LmF1dGgwLmNvbS8iLCJzdWIiOiJnb29nbGUtb2F1dGgyfDExMzQyODY3MTAzNjI5NDQzMzA5NSIsImF1ZCI6Ik9jaUtISUV2QU52T3lFaTRPZEdnNlROZmJtNy1fa1ZHIiwiaWF0IjoxNTIxNDE0MTUzLCJleHAiOjE1MjE0NTAxNTMsImF0X2hhc2giOiJ4LUZhT3U3UXBZMVhnSW1MVEFTMllBIiwibm9uY2UiOiJLaWpwSzRibVFLYnRaYnpZbmFkMlpmc1YybTF-QTNFbiJ9.bRqDhiIGxe0bhYvKJx5feTBxLBGRIPeChXE30U935NQGvL2JU6okDtt_GiSYGUYPwfrREhA--dWbLY-yQYcnvoiVcADS2S14IHHsUnz80UbXHvNO6VrKL8FKKTVcMcm5IGkKyINBwDx5jzXrf11ShEknBbuh450e1No-HT8n_rC35CcnuTdVhuU40B8XsxSm7KuE1N4SiWYalnHzwTHYcV5SfUQDgXNCn3fBmc2u81egYSOQyiHgAY0oPZhnpFNkn7T8gYPZOQLjmXcqbA1W5w5KbAUtq3AyBX3iaPZsi8DONUpPrEnEndhlTxZ4h24Gp_zuXUBX5LcsBk8ypc-RJQ";
	    this.fakeExpireAt = "1521421358221";
	    this.fakeScope = "openid profile email";
	    this.requestedScopes = 'openid email profile ';
	    this.auth0 = new _auth0Js2.default.WebAuth({
	      domain: _auth.AUTH_CONFIG.domain,
	      clientID: _auth.AUTH_CONFIG.clientId,
	      redirectUri: _auth.AUTH_CONFIG.callbackUrl,
	      audience: _auth.AUTH_CONFIG.apiUrl,
	      responseType: 'token id_token',
	      scope: this.requestedScopes
	    });
	
	    this.login = this.login.bind(this);
	    this.logout = this.logout.bind(this);
	    this.fakeLogin = this.fakeLogin.bind(this);
	    this.handleAuthentication = this.handleAuthentication.bind(this);
	    this.isAuthenticated = this.isAuthenticated.bind(this);
	    this.userHasScopes = this.userHasScopes.bind(this);
	    this.getAccessToken = this.getAccessToken.bind(this);
	    this.getProfile = this.getProfile.bind(this);
	    this.goToHome = this.goToHome.bind(this);
	    this.getProfileFake = this.getProfileFake.bind(this);
	    this.loginWithCredentials = this.loginWithCredentials.bind(this);
	
	    this.googleLogin = this.googleLogin.bind(this);
	    this.passwordLogin = this.passwordLogin.bind(this);
	  }
	  // requestedScopes = 'openid profile read:messages write:messages';
	
	
	  _createClass(Auth, [{
	    key: 'login',
	    value: function login() {
	      this.auth0.authorize();
	    }
	  }, {
	    key: 'googleLogin',
	    value: function googleLogin() {
	      this.auth0.authorize({
	        // connection: 'google'
	      });
	    }
	  }, {
	    key: 'fakeLogin',
	    value: function fakeLogin() {
	      if (true) {
	
	        localStorage.setItem('access_token', this.fakeAccessToken);
	        localStorage.setItem('id_token', this.fakeIdToken);
	        localStorage.setItem('expires_at', this.fakeExpireAt);
	        localStorage.setItem('scopes', this.fakeScope);
	        this.goToHome();
	      }
	    }
	  }, {
	    key: 'passwordLogin',
	    value: function passwordLogin(username, password) {
	      var _this = this;
	
	      return new Promise(function (resolve, reject) {
	
	        _this.auth0.login({
	          realm: 'Username-Password-Authentication',
	          username: username,
	          password: password
	        }, function (err, authResult) {
	          // console.log ( 'passwordLogin ', authResult, ' ', err);
	          resolve({ message: err, result: authResult });
	        });
	        // setTimeout(() => {
	        //   if(bool) {
	        //     resolve('Promise resolved after 5 seconds');
	        //   } else {
	        //     reject('Promise rejected after 5 seconds');
	        //   }
	        // }, 5000);   
	      });
	    }
	  }, {
	    key: 'loginWithCredentials',
	    value: function loginWithCredentials(username, password) {
	      this.auth0.redirect.loginWithCredentials({
	        connection: 'Username-Password-Authentication',
	        username: username,
	        password: password,
	        scope: 'openid'
	      }, function (err, authResult) {
	        console.log('loginWithCredentials ', authResult, ' ', err);
	        // Auth tokens in the result or an error
	      });
	    }
	  }, {
	    key: 'handleAuthentication',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _this2 = this;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('handleAuthentication');
	
	                try {
	                  this.auth0.parseHash(function (err, authResult) {
	                    if (authResult && authResult.accessToken && authResult.idToken) {
	                      _this2.setSession(authResult);
	
	                      console.log(' handle authentication ', authResult);
	                      _this2.getProfile(function () {
	                        var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(err, profile) {
	                          var headers;
	                          return _regenerator2.default.wrap(function _callee$(_context) {
	                            while (1) {
	                              switch (_context.prev = _context.next) {
	                                case 0:
	                                  console.log('token: ', _this2.getAccessToken());
	
	                                  headers = { 'Authorization': 'Bearer ' + _this2.getAccessToken()
	                                    // const user = await axios.get(`${API_URL}/`, { headers } )
	
	                                  };
	                                  _axios2.default.post(_server2.default + '/user', { profile: profile }, { headers: headers }).then(function (user) {
	                                    console.log('/user success ' + user.data);
	                                    _this2.goToHome();
	                                    // this.setState({ message: response.data.message })
	                                  }).catch(function (error) {
	                                    console.log('/user error ' + error);
	                                    _this2.goToHome();
	                                    return _this2.setState({ message: error.message });
	                                  });
	
	                                case 3:
	                                case 'end':
	                                  return _context.stop();
	                              }
	                            }
	                          }, _callee, _this2);
	                        }));
	
	                        return function (_x, _x2) {
	                          return _ref2.apply(this, arguments);
	                        };
	                      }());
	                    } else if (err) {
	                      console.log(err);
	
	                      alert('Error: ' + err.error + '. Check the console for further details.');
	                      _this2.goToHome();
	                    }
	                  });
	                } catch (e) {
	                  console.log(e);
	                  this.goToHome();
	                }
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function handleAuthentication() {
	        return _ref.apply(this, arguments);
	      }
	
	      return handleAuthentication;
	    }()
	  }, {
	    key: 'setSession',
	    value: function setSession(authResult) {
	      // Set the time that the access token will expire at
	      var expiresAt = JSON.stringify(authResult.expiresIn * 1000 + new Date().getTime());
	      // If there is a value on the `scope` param from the authResult,
	      // use it to set scopes in the session for the user. Otherwise
	      // use the scopes as requested. If no scopes were requested,
	      // set it to nothing
	      var scopes = authResult.scope || this.requestedScopes || '';
	
	      localStorage.setItem('access_token', authResult.accessToken);
	      localStorage.setItem('id_token', authResult.idToken);
	      localStorage.setItem('expires_at', expiresAt);
	      localStorage.setItem('scopes', JSON.stringify(scopes));
	
	      // navigate to the home route
	      // history.replace('/home');
	      // window.location.reload(); 
	    }
	  }, {
	    key: 'getAccessToken',
	    value: function getAccessToken() {
	      var accessToken = localStorage.getItem('access_token');
	      if (!accessToken) {
	        throw new Error('No access token found');
	      }
	      return accessToken;
	    }
	  }, {
	    key: 'getProfileFake',
	    value: function getProfileFake() {
	      console.log(this.fakeProfile);
	      return this.fakeProfile;
	    }
	  }, {
	    key: 'getProfile',
	    value: function getProfile(cb) {
	      var _this3 = this;
	
	      if (true) {
	        this.userProfile = this.fakeProfile;
	        console.log(this.userProfile);
	        return this.userProfile;
	      }
	
	      var accessToken = this.getAccessToken();
	      this.auth0.client.userInfo(accessToken, function (err, profile) {
	        if (profile) {
	          _this3.userProfile = profile;
	        }
	        cb(err, profile);
	      });
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      // Clear access token and ID token from local storage
	      localStorage.removeItem('access_token');
	      localStorage.removeItem('id_token');
	      localStorage.removeItem('expires_at');
	      localStorage.removeItem('scopes');
	      this.userProfile = null;
	      // navigate to the home route
	      console.log('logout now');
	      _history2.default.push('/');
	      window.location.reload();
	    }
	  }, {
	    key: 'isAuthenticated',
	    value: function isAuthenticated() {
	      // console.log( 'process.env.REACT_APP_STAGE ' , process.env.REACT_APP_STAGE)
	      if (true) {
	        var result = localStorage.getItem('expires_at') ? true : false;
	        return result;
	      }
	
	      // Check whether the current time is past the
	      // access token's expiry time
	      var expiresAt = JSON.parse(localStorage.getItem('expires_at'));
	      return new Date().getTime() < expiresAt;
	    }
	  }, {
	    key: 'userHasScopes',
	    value: function userHasScopes(scopes) {
	      var grantedScopes = JSON.parse(localStorage.getItem('scopes')).split(' ');
	      return scopes.every(function (scope) {
	        return grantedScopes.includes(scope);
	      });
	    }
	  }, {
	    key: 'goToHome',
	    value: function goToHome() {
	      /* let it handle redirection*/
	
	      _history2.default.replace('/addCampaign');
	      window.location.reload();
	    }
	  }]);
	
	  return Auth;
	}();
	
	exports.default = Auth;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    // iphone \n    .iPhone{\n        width: 100%;\n        z-index: 9;\n    }\n    margin-left: auto;\n    margin-right: auto;\n    .exampleHolder{\n        margin-left: auto;\n    margin-right: auto;\n    }\n       \n    .exampleAdPreview {\n        padding: 12px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: justify;\n        text-align: center;\n    }\n\n    .adExample__ad-example {\n        width: 100%;\n        max-width: 22rem;\n        overflow: hidden;\n        position: relative;\n        margin-top: 3rem;\n        }\n        @media (min-width: 768px) {\n        .adExample__ad-example {\n            margin-top: 0;\n            margin-right: 0; } }\n        @media (min-width: 1281px) {\n        .adExample__ad-example {\n            /* max-width: 24rem; */\n            } }\n        .adExample__ad-example.centered__ad-example {\n        margin-left: auto;\n        margin-right: auto; }\n\n\n\n    .container__ad-example {\n        position: absolute;\n        top: 34.15133%;\n        width: width: 87.5%; \n        left: 6.1%; }\n\n    .adExampleFull__ad-example .container__ad-example {\n        top: 15.4%;\n     }\n    \n    .searchTerm__ad-example {\n        position: absolute;\n        top: 14.9%;\n        left: 14.2%;\n        font-size: 0.7rem; }\n        @media (min-width: 480px) {\n            .searchTerm__ad-example {\n            font-size: 0.8rem; } }\n\n\n    .app__ad-example {\n        padding: 3.787878787878788%;\n        background: #fff; }\n        \n    .app__ad-example.isAd__ad-example {\n        background: #EDF6FF; }\n\n\n    .appSummary__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n\n    .appThumbnail__ad-example {\n        width: 27.03583%;\n        margin-right: 2.9316%;\n        -ms-flex-negative: 0;\n            flex-shrink: 0; }\n    .appThumbnail__ad-example > img {\n        border-radius: 16px; }\n\n    .appName__ad-example {\n        font-size: 1.05em;\n        color: #333;\n        line-height: 1.2;\n        margin-bottom: 5px; }\n        \n    .appDetail__ad-example {\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        font-size: 0.75rem; }\n            \n    .getButton__ad-example {\n        position: relative;\n        padding: 0.3rem 0.5rem;\n        border: 1px solid #3E90F4;\n        color: #3E90F4;\n        font-size: 0.65rem;\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        border-radius: 3px;\n        line-height: 1; }\n        .getButton__ad-example::before {\n            content: \'+\';\n            position: absolute;\n            line-height: 1;\n            font-size: 7px;\n            font-weight: 400;\n            top: 0;\n            left: 1px; }\n\n    .adSymbol__ad-example {\n        display: inline-block;\n        padding: 0 5px;\n        background: #8EC5FE;\n        color: #fff;\n        border-radius: 2px;\n        margin-right: 8px; }\n            \n    .publisher__ad-example {\n        font-size: 0.9em;\n        color: #666;\n        line-height: 1.3;\n        display: table;\n        table-layout: fixed;\n        width: 100%;\n        white-space: nowrap; }\n\n    .publisher__ad-example > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n\n    .screenshotsContainer__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n        margin-top: 4.09%;\n        width: 100%;\n        // padding-left: 10.3226%;\n        // padding-right: 10.3226%; \n    }\n        \n    .screenshot__ad-example {\n        width: 30%; \n    }\n    .screenshot__ad-example > img {\n        width: 100%; \n    }\n\n    //end of iphone x\n    .searchTerm__ad-example { top: 9.5%; left: 19.2%; z-index: 1002}\n    .container__ad-example { top: 15.4%; width: 87.5%; }\n'], ['\n    // iphone \n    .iPhone{\n        width: 100%;\n        z-index: 9;\n    }\n    margin-left: auto;\n    margin-right: auto;\n    .exampleHolder{\n        margin-left: auto;\n    margin-right: auto;\n    }\n       \n    .exampleAdPreview {\n        padding: 12px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: justify;\n        text-align: center;\n    }\n\n    .adExample__ad-example {\n        width: 100%;\n        max-width: 22rem;\n        overflow: hidden;\n        position: relative;\n        margin-top: 3rem;\n        }\n        @media (min-width: 768px) {\n        .adExample__ad-example {\n            margin-top: 0;\n            margin-right: 0; } }\n        @media (min-width: 1281px) {\n        .adExample__ad-example {\n            /* max-width: 24rem; */\n            } }\n        .adExample__ad-example.centered__ad-example {\n        margin-left: auto;\n        margin-right: auto; }\n\n\n\n    .container__ad-example {\n        position: absolute;\n        top: 34.15133%;\n        width: width: 87.5%; \n        left: 6.1%; }\n\n    .adExampleFull__ad-example .container__ad-example {\n        top: 15.4%;\n     }\n    \n    .searchTerm__ad-example {\n        position: absolute;\n        top: 14.9%;\n        left: 14.2%;\n        font-size: 0.7rem; }\n        @media (min-width: 480px) {\n            .searchTerm__ad-example {\n            font-size: 0.8rem; } }\n\n\n    .app__ad-example {\n        padding: 3.787878787878788%;\n        background: #fff; }\n        \n    .app__ad-example.isAd__ad-example {\n        background: #EDF6FF; }\n\n\n    .appSummary__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center; }\n\n    .appThumbnail__ad-example {\n        width: 27.03583%;\n        margin-right: 2.9316%;\n        -ms-flex-negative: 0;\n            flex-shrink: 0; }\n    .appThumbnail__ad-example > img {\n        border-radius: 16px; }\n\n    .appName__ad-example {\n        font-size: 1.05em;\n        color: #333;\n        line-height: 1.2;\n        margin-bottom: 5px; }\n        \n    .appDetail__ad-example {\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        font-size: 0.75rem; }\n            \n    .getButton__ad-example {\n        position: relative;\n        padding: 0.3rem 0.5rem;\n        border: 1px solid #3E90F4;\n        color: #3E90F4;\n        font-size: 0.65rem;\n        font-family: "SF UI", helvetica, arial, sans-serif;\n        border-radius: 3px;\n        line-height: 1; }\n        .getButton__ad-example::before {\n            content: \'+\';\n            position: absolute;\n            line-height: 1;\n            font-size: 7px;\n            font-weight: 400;\n            top: 0;\n            left: 1px; }\n\n    .adSymbol__ad-example {\n        display: inline-block;\n        padding: 0 5px;\n        background: #8EC5FE;\n        color: #fff;\n        border-radius: 2px;\n        margin-right: 8px; }\n            \n    .publisher__ad-example {\n        font-size: 0.9em;\n        color: #666;\n        line-height: 1.3;\n        display: table;\n        table-layout: fixed;\n        width: 100%;\n        white-space: nowrap; }\n\n    .publisher__ad-example > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n\n    .screenshotsContainer__ad-example {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -ms-flex-pack: distribute;\n            justify-content: space-around;\n        margin-top: 4.09%;\n        width: 100%;\n        // padding-left: 10.3226%;\n        // padding-right: 10.3226%; \n    }\n        \n    .screenshot__ad-example {\n        width: 30%; \n    }\n    .screenshot__ad-example > img {\n        width: 100%; \n    }\n\n    //end of iphone x\n    .searchTerm__ad-example { top: 9.5%; left: 19.2%; z-index: 1002}\n    .container__ad-example { top: 15.4%; width: 87.5%; }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /**
	                                                                                                                                                   * A Footer saying < current year > @ gogochart only.. lol
	                                                                                                                                                   */
	
	var Footer = _styledComponents2.default.div(_templateObject);
	
	exports.default = Footer;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _loading = __webpack_require__(2249);
	
	var _loading2 = _interopRequireDefault(_loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Callback = function (_Component) {
	  _inherits(Callback, _Component);
	
	  function Callback() {
	    _classCallCheck(this, Callback);
	
	    return _possibleConstructorReturn(this, (Callback.__proto__ || Object.getPrototypeOf(Callback)).apply(this, arguments));
	  }
	
	  _createClass(Callback, [{
	    key: 'render',
	    value: function render() {
	      var style = {
	        position: 'absolute',
	        display: 'flex',
	        justifyContent: 'center',
	        height: '100vh',
	        width: '100vw',
	        top: 0,
	        bottom: 0,
	        left: 0,
	        right: 0,
	        backgroundColor: 'white'
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: style },
	        _react2.default.createElement('img', { src: _loading2.default, alt: 'loading' })
	      );
	    }
	  }]);
	
	  return Callback;
	}(_react.Component);
	
	exports.default = Callback;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 50px;\n    background-color: rgba(42, 38, 39, 1);\n    color: #fff;\n    letter-spacing: 0.07em;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 50px;\n    background-color: rgba(42, 38, 39, 1);\n    color: #fff;\n    letter-spacing: 0.07em;\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PrimaryWrapper = exports.Wrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n\n  .header {\n    display: block; background-color: rgba(35, 31, 32, 1); letter-spacing: 0.07em;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 64px;\n  }\n  .header-row { display: flex; justify-content: space-between; align-items: center; flex-grow: 1; }\n  .header-row:first-child { padding-top: 14px; }\n  .header-row:last-child { padding-bottom: 17px; }\n\n  /* Logo */\n  .header-row .logo-container { width: 125px; }\n  .header-row .logo-container a { display: block; }\n\n  nav { z-index: 99; }\n\n  @media screen and (max-width: 767px) {\n      .header { padding: 0 14px; }\n      .sign-in { padding: 4px; height: auto; border-radius: 3px; }\n  }\n\n  @media screen and (min-width: 768px) and (max-width: 991px) {\n      .header { padding: 0 28px; }\n  }\n\n  // .header {\n\n  //   .avatarIcon{\n  //     height: 33px;\n  //     width: 33px;\n  //   }\n    \n  //   padding: 29px 64px;\n  //   background-color: rgba(35, 31, 32, 1);\n  //   text-align: center;\n\n  //   .logo {\n  //     img { height: 56px; }\n  //   }\n\n  //   nav {\n  //     position: absolute;\n  //     top: 48px; right: 64px;\n  //     z-index: 1;\n\n  //     // -- Not logged in\n  //     button:only-child {\n  //       margin: 0;\n  //       border: 1px solid rgba(255, 255, 255, 1);\n  //       padding: 0;\n  //       width: 169px; height: 40px;\n  //       background-color: transparent;\n  //       line-height: 40px;\n  //       font-family: \'Montserrat\';\n  //       font-size: 14px;\n  //       color: rgba(255, 255, 255, 1);\n  //       text-align: center;\n  //       letter-spacing: 0.08em;\n  //       border-radius: 20px;\n  //       transform: translateY(-25%);\n  //     }\n  //     button:only-child:focus, button:only-child:active, button:only-child:hover {\n  //       outline-width: 0;\n  //       border-color: rgba(35, 31, 32, 1);\n  //       background-color: rgba(255, 255, 255, 1);\n  //       color: rgba(35, 31, 32, 1);\n  //       opacity: 1;\n  //     }\n\n  //     // -- Logged in\n  //     > div {\n  //       display: flex;\n  //       align-items: center;\n  //       font-family: \'Montserrat\';\n  //       font-size: 14px;\n  //       font-weight: 300;\n  //       color: rgba(255, 255, 255, 1);\n  //       text-align: center;\n  //       letter-spacing: 0.01em;\n\n  //       > div:first-child { margin-right: 20px; }\n\n  //       > div:first-child + div { display: flex; align-items: center; }\n  //       .nav-bars {\n  //         margin-left: 21px;\n  //         span {\n  //           display: block;\n  //           margin-top: 3px; margin-bottom: 6px;\n  //           height: 2px;\n  //           width: 26px;\n  //           background-color: rgba(255, 255, 255, 1);\n  //         }\n  //       }\n  //     }\n\n  //     // -- nav\n  //   }\n\n  //   // -- .header\n  // }\n  // // .header:after {\n  // //   position: absolute;\n  // //   right: 0; bottom: -3px; left: 0;\n  // //   display: inline-block;\n  // //   content: \'\';\n  // //   height: 3px;\n  // //   background-color: rgba(12,183,148,1);\n  // //   z-index: 1;\n  // // }\n\n  \n\n  // @media screen and (max-width: 767px) {\n  //   .header {\n  //     padding: 16px;\n      \n  //     nav {\n  //       position: static;\n  //       top: auto; right: auto;\n\n  //       // -- Not logged in\n  //       button:only-child { margin-top: 14px; height: 30px; line-height: 30px; transform: none; }\n\n  //       // -- Logged in\n  //       > div {\n  //         position: absolute;\n  //         top: 16px; right: 16px;\n\n  //         > :first-child { display: none; }\n  //       }\n  //     }\n  //   }\n  // }\n\n'], ['\n\n  .header {\n    display: block; background-color: rgba(35, 31, 32, 1); letter-spacing: 0.07em;\n    display: flex;\n    justify-content: space-between;\n    padding: 0 64px;\n  }\n  .header-row { display: flex; justify-content: space-between; align-items: center; flex-grow: 1; }\n  .header-row:first-child { padding-top: 14px; }\n  .header-row:last-child { padding-bottom: 17px; }\n\n  /* Logo */\n  .header-row .logo-container { width: 125px; }\n  .header-row .logo-container a { display: block; }\n\n  nav { z-index: 99; }\n\n  @media screen and (max-width: 767px) {\n      .header { padding: 0 14px; }\n      .sign-in { padding: 4px; height: auto; border-radius: 3px; }\n  }\n\n  @media screen and (min-width: 768px) and (max-width: 991px) {\n      .header { padding: 0 28px; }\n  }\n\n  // .header {\n\n  //   .avatarIcon{\n  //     height: 33px;\n  //     width: 33px;\n  //   }\n    \n  //   padding: 29px 64px;\n  //   background-color: rgba(35, 31, 32, 1);\n  //   text-align: center;\n\n  //   .logo {\n  //     img { height: 56px; }\n  //   }\n\n  //   nav {\n  //     position: absolute;\n  //     top: 48px; right: 64px;\n  //     z-index: 1;\n\n  //     // -- Not logged in\n  //     button:only-child {\n  //       margin: 0;\n  //       border: 1px solid rgba(255, 255, 255, 1);\n  //       padding: 0;\n  //       width: 169px; height: 40px;\n  //       background-color: transparent;\n  //       line-height: 40px;\n  //       font-family: \'Montserrat\';\n  //       font-size: 14px;\n  //       color: rgba(255, 255, 255, 1);\n  //       text-align: center;\n  //       letter-spacing: 0.08em;\n  //       border-radius: 20px;\n  //       transform: translateY(-25%);\n  //     }\n  //     button:only-child:focus, button:only-child:active, button:only-child:hover {\n  //       outline-width: 0;\n  //       border-color: rgba(35, 31, 32, 1);\n  //       background-color: rgba(255, 255, 255, 1);\n  //       color: rgba(35, 31, 32, 1);\n  //       opacity: 1;\n  //     }\n\n  //     // -- Logged in\n  //     > div {\n  //       display: flex;\n  //       align-items: center;\n  //       font-family: \'Montserrat\';\n  //       font-size: 14px;\n  //       font-weight: 300;\n  //       color: rgba(255, 255, 255, 1);\n  //       text-align: center;\n  //       letter-spacing: 0.01em;\n\n  //       > div:first-child { margin-right: 20px; }\n\n  //       > div:first-child + div { display: flex; align-items: center; }\n  //       .nav-bars {\n  //         margin-left: 21px;\n  //         span {\n  //           display: block;\n  //           margin-top: 3px; margin-bottom: 6px;\n  //           height: 2px;\n  //           width: 26px;\n  //           background-color: rgba(255, 255, 255, 1);\n  //         }\n  //       }\n  //     }\n\n  //     // -- nav\n  //   }\n\n  //   // -- .header\n  // }\n  // // .header:after {\n  // //   position: absolute;\n  // //   right: 0; bottom: -3px; left: 0;\n  // //   display: inline-block;\n  // //   content: \'\';\n  // //   height: 3px;\n  // //   background-color: rgba(12,183,148,1);\n  // //   z-index: 1;\n  // // }\n\n  \n\n  // @media screen and (max-width: 767px) {\n  //   .header {\n  //     padding: 16px;\n      \n  //     nav {\n  //       position: static;\n  //       top: auto; right: auto;\n\n  //       // -- Not logged in\n  //       button:only-child { margin-top: 14px; height: 30px; line-height: 30px; transform: none; }\n\n  //       // -- Logged in\n  //       > div {\n  //         position: absolute;\n  //         top: 16px; right: 16px;\n\n  //         > :first-child { display: none; }\n  //       }\n  //     }\n  //   }\n  // }\n\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  .header:after {\n    position: absolute;\n    right: 0; bottom: -3px; left: 0;\n    display: inline-block;\n    content: \'\';\n    height: 3px;\n    background-color: rgba(12,183,148,1);\n    z-index: 1;\n  }\n'], ['\n  .header:after {\n    position: absolute;\n    right: 0; bottom: -3px; left: 0;\n    display: inline-block;\n    content: \'\';\n    height: 3px;\n    background-color: rgba(12,183,148,1);\n    z-index: 1;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var PrimaryWrapper = Wrapper.extend(_templateObject2);
	
	exports.Wrapper = Wrapper;
	exports.PrimaryWrapper = PrimaryWrapper;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _gogochart_greenlogo = __webpack_require__(1416);
	
	var _gogochart_greenlogo2 = _interopRequireDefault(_gogochart_greenlogo);
	
	var _avatar = __webpack_require__(3300);
	
	var _avatar2 = _interopRequireDefault(_avatar);
	
	var _dropdown = __webpack_require__(276);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _button = __webpack_require__(394);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1608);
	
	var _Logo = __webpack_require__(173);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Menu = __webpack_require__(213);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index = __webpack_require__(738);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Header(props) {
	  var handleMenuClick = function handleMenuClick(event) {
	    console.log(event);
	
	    switch (event.key) {
	      case "account":
	        props.history.push('/me/account');
	        break;
	      case "billing":
	        props.history.push('/me/billing');
	        break;
	
	      case "logout":
	        props.auth.logout();
	
	        break;
	
	      default:
	
	        break;
	    }
	  };
	  var menu = _react2.default.createElement(
	    _dropdown.DropdownMenu,
	    { className: 'accDropDown', onClick: handleMenuClick },
	    _react2.default.createElement(
	      _dropdown.MenuItem,
	      { className: 'accDropDownMenuItem', key: 'account' },
	      "My account"
	    ),
	    _react2.default.createElement(
	      _dropdown.MenuItem,
	      { className: 'accDropDownMenuItem', key: 'billing' },
	      "Billing Info"
	    ),
	    _react2.default.createElement(
	      _dropdown.MenuItem,
	      { className: 'accDropDownMenuItem', key: 'logout' },
	      "Logout"
	    )
	  );
	
	  var isAuthenticated = props.auth.isAuthenticated;
	
	
	  return _react2.default.createElement(
	    _Wrapper.Wrapper,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'header' },
	      _react2.default.createElement(
	        'div',
	        { className: 'header-row' },
	        _react2.default.createElement(_Logo2.default, { isClickable: true, history: props.history }),
	        props.auth.isAuthenticated() && _react2.default.createElement(_Menu2.default, { history: props.history, auth: props.auth }) || _react2.default.createElement(
	          _index2.default,
	          { history: props.history },
	          'SIGN UP / LOGIN'
	        )
	      )
	    )
	  );
	} /**
	   *
	   * Header.js
	   *
	   * bladsfasdfas
	   */
	exports.default = Header;
	
	
	{/* <div className="logo"
	   onClick={ () => props.history.push(`${'/'}`) }> 
	   <img src={process.env.PUBLIC_URL + GreenLogo} />
	  </div>
	  <nav>
	   {
	     isAuthenticated() && (
	       <div>
	         <div>
	           { "HI GoGoChart"}
	         </div>
	         <Dropdown overlay={menu} trigger={['click']}>
	           <div>
	             <img
	               className="avatarIcon"
	               src={process.env.PUBLIC_URL + Avatar}
	             />
	              <div className="nav-bars">
	               <span></span>
	               <span></span>
	               <span></span>
	             </div>
	           </div>
	         </Dropdown>
	       </div>
	     )
	   }
	   {
	     !isAuthenticated() && (
	       <Button  
	         onClick={ () => this.props.history.push(`${'/home'}`) } 
	         type="primary" 
	         className="loginSignUp">
	         {/* <Button  onClick={this.login.bind(this)} type="primary" className="loginSignUp"> * /}
	         SIGN UP / LOGIN
	       </Button>
	     )
	   }
	  </nav> */}

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    justify-self: flex-start;\n    margin: 0 14px;\n\n    .app-logo-container { margin-right: 24px; min-width: 68px; width: 68px; height: 68px; }\n    .app-logo-container img { width: 100%; height: 100%; border-radius: 16px; }\n\n    .info-container { display: flex; flex-direction: column; justify-content: space-around; }\n    .app-name, .app-information {\n        font-family: \'Montserrat\';\n        font-weight: 300;\n        font-size: 22px;\n        color: rgba(255, 255, 255, 1);\n        letter-spacing: 0.09em;\n    }\n    .app-information { font-size: 14px; }\n\n    @media screen and (max-width: 767px) {\n        margin: 0;\n\n        .app-logo-container { margin: 0; min-width: 50px; width: 50px; height: 50px; }\n        .app-logo-container img { border: 1px solid rgba(255, 255, 255, .4); border-radius: 10px; }\n        .info-container { display: none; }\n    }\n'], ['\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    justify-self: flex-start;\n    margin: 0 14px;\n\n    .app-logo-container { margin-right: 24px; min-width: 68px; width: 68px; height: 68px; }\n    .app-logo-container img { width: 100%; height: 100%; border-radius: 16px; }\n\n    .info-container { display: flex; flex-direction: column; justify-content: space-around; }\n    .app-name, .app-information {\n        font-family: \'Montserrat\';\n        font-weight: 300;\n        font-size: 22px;\n        color: rgba(255, 255, 255, 1);\n        letter-spacing: 0.09em;\n    }\n    .app-information { font-size: 14px; }\n\n    @media screen and (max-width: 767px) {\n        margin: 0;\n\n        .app-logo-container { margin: 0; min-width: 50px; width: 50px; height: 50px; }\n        .app-logo-container img { border: 1px solid rgba(255, 255, 255, .4); border-radius: 10px; }\n        .info-container { display: none; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1610);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// Styles
	
	
	var AppInfo = function (_React$Component) {
	    _inherits(AppInfo, _React$Component);
	
	    function AppInfo() {
	        _classCallCheck(this, AppInfo);
	
	        return _possibleConstructorReturn(this, (AppInfo.__proto__ || Object.getPrototypeOf(AppInfo)).apply(this, arguments));
	    }
	
	    _createClass(AppInfo, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'app-info', style: this.props.style },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'app-logo-container' },
	                    _react2.default.createElement('img', { src: this.props.url })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'info-container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'app-name' },
	                        this.props.appName
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'app-information' },
	                        this.props.children
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppInfo;
	}(_react2.default.Component);
	
	exports.default = AppInfo;
	;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .sign-in {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #fff;\n        height: 40px;\n        padding: 0 28px;\n        background-color: transparent;\n        color: #fff;\n        border-radius: 100px;\n    }\n    .sign-in:hover { background-color: #fff; color: rgba(35, 31, 32, 1); opacity: 1; }\n\n    @media screen and (max-width: 767px) {\n        .sign-in { padding: 4px; height: auto; border-radius: 3px; }\n    }\n'], ['\n    .sign-in {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #fff;\n        height: 40px;\n        padding: 0 28px;\n        background-color: transparent;\n        color: #fff;\n        border-radius: 100px;\n    }\n    .sign-in:hover { background-color: #fff; color: rgba(35, 31, 32, 1); opacity: 1; }\n\n    @media screen and (max-width: 767px) {\n        .sign-in { padding: 4px; height: auto; border-radius: 3px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    cursor: pointer;\n\n    .header-avatar { padding: 0 14px; }\n\n    .nav-bars { margin-left: 14px; }\n    .nav-bars span {\n        display: block;\n        margin-top: 3px;\n        margin-bottom: 6px;\n        height: 2px;\n        width: 26px;\n        background-color: #fff;\n    }\n\n    nav {\n        position: absolute;\n        top: 100%; right: -14px;\n        display: none;\n        padding-top: 11px;\n        z-index: 2;\n    }\n    :focus nav,\n    :hover nav { display: block; }\n\n    nav ul {\n        display: flex;\n        flex-direction: column;\n        border: 2px solid rgba(12, 183, 148, 1);\n        background-color: rgba(35, 31, 32, 1);\n        box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, .3);\n    }\n    nav li {\n        min-width: 175px;\n        padding: 10px 35px;\n        text-transform: uppercase;\n        text-align: center;\n        white-space: nowrap;\n        cursor: pointer;\n        transition: .3s;\n    }\n    nav li:hover { background-color: #fff; color: rgba(35, 31, 32, 1); }\n\n    :after {\n        position: absolute;\n        top: 90%;\n        right: 0;\n        left: 0;\n        height: 100%;\n        display: none;\n        content: \'\';\n        background-color: transparent;\n        z-index: 1;\n    }\n    &:hover:after { display: inline-block; }\n\n    @media screen and (max-width: 767px) {\n        .header-avatar { display: none; }    \n        .nav-bars { margin-left: 7px; }\n    }\n\n    @media screen and (min-width: 768px) and (max-width: 991px) {\n        .header-avatar { padding: 0 7px; }\n    }\n'], ['\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    cursor: pointer;\n\n    .header-avatar { padding: 0 14px; }\n\n    .nav-bars { margin-left: 14px; }\n    .nav-bars span {\n        display: block;\n        margin-top: 3px;\n        margin-bottom: 6px;\n        height: 2px;\n        width: 26px;\n        background-color: #fff;\n    }\n\n    nav {\n        position: absolute;\n        top: 100%; right: -14px;\n        display: none;\n        padding-top: 11px;\n        z-index: 2;\n    }\n    :focus nav,\n    :hover nav { display: block; }\n\n    nav ul {\n        display: flex;\n        flex-direction: column;\n        border: 2px solid rgba(12, 183, 148, 1);\n        background-color: rgba(35, 31, 32, 1);\n        box-shadow: 1px 1px 5px 1px rgba(0, 0, 0, .3);\n    }\n    nav li {\n        min-width: 175px;\n        padding: 10px 35px;\n        text-transform: uppercase;\n        text-align: center;\n        white-space: nowrap;\n        cursor: pointer;\n        transition: .3s;\n    }\n    nav li:hover { background-color: #fff; color: rgba(35, 31, 32, 1); }\n\n    :after {\n        position: absolute;\n        top: 90%;\n        right: 0;\n        left: 0;\n        height: 100%;\n        display: none;\n        content: \'\';\n        background-color: transparent;\n        z-index: 1;\n    }\n    &:hover:after { display: inline-block; }\n\n    @media screen and (max-width: 767px) {\n        .header-avatar { display: none; }    \n        .nav-bars { margin-left: 7px; }\n    }\n\n    @media screen and (min-width: 768px) and (max-width: 991px) {\n        .header-avatar { padding: 0 7px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: block;\n    background-color: rgba(35, 31, 32, 1);\n    letter-spacing: 0.07em;\n    z-index: 10;\n\n    :after {\n        display: ', ';\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12, 183, 148, 1); \n    }\n\n    .header-row { display: flex; justify-content: space-between; align-items: center; padding: 0 64px; }\n    .header-row:first-child { padding-top: 14px; }\n    .header-row:last-child { padding-bottom: 17px; }\n\n    .header-row .fill { flex-grow: 1; margin-bottom: 0; height: 1px; }\n\n    /* Logo */\n    .header-row .logo-container { min-width: 125px; width: 125px; }\n    .header-row .logo-container a { display: block; }\n\n    .search-app-bar { width: auto; }\n\n    @media screen and (max-width: 767px) {\n        .header-row { flex-wrap: wrap; align-items: flex-start; padding: 0 14px; }\n        .header-row > *:not(:last-child) { margin-bottom: 14px; }\n        .search-app-bar { min-width: 80%; }\n    }\n\n    @media screen and (min-width: 768px) and (max-width: 991px) {\n        .header-row { padding: 0 28px; }\n    }\n'], ['\n    display: block;\n    background-color: rgba(35, 31, 32, 1);\n    letter-spacing: 0.07em;\n    z-index: 10;\n\n    :after {\n        display: ', ';\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12, 183, 148, 1); \n    }\n\n    .header-row { display: flex; justify-content: space-between; align-items: center; padding: 0 64px; }\n    .header-row:first-child { padding-top: 14px; }\n    .header-row:last-child { padding-bottom: 17px; }\n\n    .header-row .fill { flex-grow: 1; margin-bottom: 0; height: 1px; }\n\n    /* Logo */\n    .header-row .logo-container { min-width: 125px; width: 125px; }\n    .header-row .logo-container a { display: block; }\n\n    .search-app-bar { width: auto; }\n\n    @media screen and (max-width: 767px) {\n        .header-row { flex-wrap: wrap; align-items: flex-start; padding: 0 14px; }\n        .header-row > *:not(:last-child) { margin-bottom: 14px; }\n        .search-app-bar { min-width: 80%; }\n    }\n\n    @media screen and (min-width: 768px) and (max-width: 991px) {\n        .header-row { padding: 0 28px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	    return props.theme === "no-border-deco" ? "none" : "block";
	});
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  text-align: center;\n  margin: 4em 0;\n  margin-left: auto;\n  margin-right: auto;\n  \n\n  .submitBtn{\n    border-width: 0;\n    height: 38px;\n    width: 100%;\n    background-color: rgba(60, 211, 207, 1);\n    border-radius: 22px;\n  }\n  div {\n    font-family: \'Montserrat\';\n    cursor: pointer;\n    display: inline;\n  }\n    height: 38px;\n    width: 300px;\n    background-color: rgba(60, 211, 207, 1);\n    border-radius: 19px;\n    line-height: 38px;\n    text-align: center;\n    font-family: \'Montserrat\';\n    font-size: 15px;\n    color: rgba(255, 255, 255, 1);\n    text-align: center;\n    letter-spacing: 0.01em;\n'], ['\n  width: 100%;\n  text-align: center;\n  margin: 4em 0;\n  margin-left: auto;\n  margin-right: auto;\n  \n\n  .submitBtn{\n    border-width: 0;\n    height: 38px;\n    width: 100%;\n    background-color: rgba(60, 211, 207, 1);\n    border-radius: 22px;\n  }\n  div {\n    font-family: \'Montserrat\';\n    cursor: pointer;\n    display: inline;\n  }\n    height: 38px;\n    width: 300px;\n    background-color: rgba(60, 211, 207, 1);\n    border-radius: 19px;\n    line-height: 38px;\n    text-align: center;\n    font-family: \'Montserrat\';\n    font-size: 15px;\n    color: rgba(255, 255, 255, 1);\n    text-align: center;\n    letter-spacing: 0.01em;\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = Wrapper;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Wrapper = __webpack_require__(1615);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function MainButton(props) {
	  // Render an anchor tag
	  //   let button = (
	  //     <A href={props.href} onClick={props.onClick}>
	  //       {Children.toArray(props.children)}
	  //     </A>
	  //   );
	
	  // If the Button has a handleRoute prop, we want to render a button
	  //   if (props.handleRoute) {
	  var button = _react2.default.createElement(
	    'div',
	    { onClick: props.handleRoute },
	    _react.Children.toArray(props.children)
	  );
	  if (props.type && props.type === 'submit') {
	    button = _react2.default.createElement(
	      'div',
	      { onClick: props.handleRoute },
	      _react2.default.createElement(
	        'button',
	        { className: 'submitBtn', type: 'submit' },
	        _react.Children.toArray(props.children)
	      )
	    );
	  }
	
	  //   }
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    null,
	    button
	  );
	}
	
	// import A from './A';
	// import StyledButton from './StyledButton';
	/**
	 *
	 * MainButton.js
	 *
	 * A common button, if you pass it a prop "route" it'll render a link to a react-router route
	 * otherwise it'll render a link with an onclick
	 */
	
	MainButton.propTypes = {
	  handleRoute: _propTypes2.default.func,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func
	  //   children: PropTypes.node.isRequired,
	};
	
	exports.default = MainButton;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 999999;\n\n    :before {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        content: \'\';\n        background-color: rgba(0, 0, 0, 0.5);\n    }\n    \n    .loader-container {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    .ripple-effect {\n        display: inline-block;\n        position: relative;\n        width: 64px;\n        height: 64px;\n      }\n      .ripple-effect div {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        border: 4px solid #fff;\n        opacity: 1;\n        border-radius: 50%;\n        animation: ripple-effect 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n        transform: translate(-50%, -50%);\n      }\n      .ripple-effect div:nth-child(2) {\n        animation-delay: -0.5s;\n      }\n      @keyframes ripple-effect {\n        0% {\n          width: 0;\n          height: 0;\n          opacity: 1;\n        }\n        100% {\n          width: 58px;\n          height: 58px;\n          opacity: 0;\n        }\n      }\n      \n'], ['\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 999999;\n\n    :before {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        display: block;\n        content: \'\';\n        background-color: rgba(0, 0, 0, 0.5);\n    }\n    \n    .loader-container {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n    }\n\n    .ripple-effect {\n        display: inline-block;\n        position: relative;\n        width: 64px;\n        height: 64px;\n      }\n      .ripple-effect div {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        border: 4px solid #fff;\n        opacity: 1;\n        border-radius: 50%;\n        animation: ripple-effect 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n        transform: translate(-50%, -50%);\n      }\n      .ripple-effect div:nth-child(2) {\n        animation-delay: -0.5s;\n      }\n      @keyframes ripple-effect {\n        0% {\n          width: 0;\n          height: 0;\n          opacity: 1;\n        }\n        100% {\n          width: 58px;\n          height: 58px;\n          opacity: 0;\n        }\n      }\n      \n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    height: 100%;\n\n    .flag-select {\n        margin: 0; margin-left: 7px;\n        height: 100%;\n        border-right: 1px solid rgba(151, 151, 151, 1);\n        padding: 0; padding-right: 7px;\n    }\n    .flag-select * { top: unset; right: unset; bottom: unset; left: unset; }\n\n    .flag-select > * {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n        height: 100%;\n        padding: 0;\n    }\n    .flag-select > * > * { display: inline-block; height: auto !important; }\n\n    .flag-select .country-flag { display: inline-flex; align-items: center; min-width: 65px; }\n    .flag-select .country-flag img { width: 24px; height: auto; }\n    .flag-select .country-flag img ~ * { padding-left: 4px; }\n\n    .flag-select .flag-options {\n        justify-content: flex-start;\n        left: 8px;\n        margin-top: -4px;\n        display: block;\n        width: 110%;\n        max-height: unset;\n        height: auto;\n    }\n    .flag-select .flag-options .has-label {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n        padding: 0 7px;\n        min-height: 35px;\n        overflow-x: hidden;\n    }\n\n    @media screen and (max-width: 767px) {\n        .flag-select .country-flag { min-width: 40px;}\n        .flag-select .country-flag img { width: 20px; }\n        .flag-select .country-flag img ~ * { padding-left: 2px; }\n    }\n'], ['\n    height: 100%;\n\n    .flag-select {\n        margin: 0; margin-left: 7px;\n        height: 100%;\n        border-right: 1px solid rgba(151, 151, 151, 1);\n        padding: 0; padding-right: 7px;\n    }\n    .flag-select * { top: unset; right: unset; bottom: unset; left: unset; }\n\n    .flag-select > * {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n        height: 100%;\n        padding: 0;\n    }\n    .flag-select > * > * { display: inline-block; height: auto !important; }\n\n    .flag-select .country-flag { display: inline-flex; align-items: center; min-width: 65px; }\n    .flag-select .country-flag img { width: 24px; height: auto; }\n    .flag-select .country-flag img ~ * { padding-left: 4px; }\n\n    .flag-select .flag-options {\n        justify-content: flex-start;\n        left: 8px;\n        margin-top: -4px;\n        display: block;\n        width: 110%;\n        max-height: unset;\n        height: auto;\n    }\n    .flag-select .flag-options .has-label {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n        padding: 0 7px;\n        min-height: 35px;\n        overflow-x: hidden;\n    }\n\n    @media screen and (max-width: 767px) {\n        .flag-select .country-flag { min-width: 40px;}\n        .flag-select .country-flag img { width: 20px; }\n        .flag-select .country-flag img ~ * { padding-left: 2px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    display: flex;\n    height: 100%;\n\n    &.two-lines-result { max-width: 70%; }\n\n    .Select {\n        flex-grow: 1;\n        display: flex;\n        max-width: 100%;\n        height: 100%;\n        margin: 0 7px;\n        z-index: 1;\n    }\n    .Select-arrow-zone,\n    .Select-clear-zone,\n    .Select-loading-zone { display: none; }\n\n    .Select .Select-control {\n        display: flex;\n        align-items: center;\n        border-width: 0;\n        height: 100%;\n        background-color: transparent !important;\n        box-shadow: none !important;\n\n        .Select-multi-value-wrapper { max-width: 100%; }\n        .Select-placeholder { right: unset; padding-right: 0; padding-left: 21px; }\n\n        .Select-input { max-width: 100%; padding-right: 0; }\n        .Select-input input {\n            box-sizing: border-box !important;\n            border-width: 0;\n            min-width: 20vw;\n            max-width: 100%;\n            width: auto !important;\n            height: 100%;\n            padding-right: 0;\n    \n            &:focus { outline-width: 0; }\n        }\n    }\n\n    .Select-menu-outer {\n        top: 100%;\n        bottom: unset;\n        transform: translate(-7px, 1px);\n\n        .Select-option { display: flex; justify-content: space-between; align-items: center; }\n        .Select-option img {\n            margin-right: 10px;\n            display: inline-block;\n            width: 40px;\n            height: 40px;\n            border-radius: 3px;\n        }\n        .Select-option .app-name { flex-grow: 1; }\n    }\n\n    .two-lines-result {\n        .Select-menu-outer .Select-option { flex-wrap: wrap; justify-content: flex-start; }\n        .Select-menu-outer .Select-option:nth-child(even):not(:hover) { background-color: #efefef; }\n        .Select-menu-outer .Select-option .app-name { width: calc(100% - 50px); word-break: break-word; }\n\n        .Select-menu-outer .Select-option .owner {\n            margin-top: 2px;\n            border-top: 1px solid rgba(0, 0, 0, .3);\n            width: 100%;\n            padding-top: 2px;\n            padding-left: 15%;\n            text-align: right;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n'], ['\n    flex-grow: 1;\n    display: flex;\n    height: 100%;\n\n    &.two-lines-result { max-width: 70%; }\n\n    .Select {\n        flex-grow: 1;\n        display: flex;\n        max-width: 100%;\n        height: 100%;\n        margin: 0 7px;\n        z-index: 1;\n    }\n    .Select-arrow-zone,\n    .Select-clear-zone,\n    .Select-loading-zone { display: none; }\n\n    .Select .Select-control {\n        display: flex;\n        align-items: center;\n        border-width: 0;\n        height: 100%;\n        background-color: transparent !important;\n        box-shadow: none !important;\n\n        .Select-multi-value-wrapper { max-width: 100%; }\n        .Select-placeholder { right: unset; padding-right: 0; padding-left: 21px; }\n\n        .Select-input { max-width: 100%; padding-right: 0; }\n        .Select-input input {\n            box-sizing: border-box !important;\n            border-width: 0;\n            min-width: 20vw;\n            max-width: 100%;\n            width: auto !important;\n            height: 100%;\n            padding-right: 0;\n    \n            &:focus { outline-width: 0; }\n        }\n    }\n\n    .Select-menu-outer {\n        top: 100%;\n        bottom: unset;\n        transform: translate(-7px, 1px);\n\n        .Select-option { display: flex; justify-content: space-between; align-items: center; }\n        .Select-option img {\n            margin-right: 10px;\n            display: inline-block;\n            width: 40px;\n            height: 40px;\n            border-radius: 3px;\n        }\n        .Select-option .app-name { flex-grow: 1; }\n    }\n\n    .two-lines-result {\n        .Select-menu-outer .Select-option { flex-wrap: wrap; justify-content: flex-start; }\n        .Select-menu-outer .Select-option:nth-child(even):not(:hover) { background-color: #efefef; }\n        .Select-menu-outer .Select-option .app-name { width: calc(100% - 50px); word-break: break-word; }\n\n        .Select-menu-outer .Select-option .owner {\n            margin-top: 2px;\n            border-top: 1px solid rgba(0, 0, 0, .3);\n            width: 100%;\n            padding-top: 2px;\n            padding-left: 15%;\n            text-align: right;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 0 auto; display: inline-block; max-width: 60vw; width: 100%;\n    \n    .search-app-bar-border-wrapper {\n        display: flex;\n        align-items: center;\n        border: 1px solid rgba(151, 151, 151, 1);\n        border-radius: 20px;\n        height: 40px;\n        background-color: rgba(255, 255, 255, 1);\n        padding: 0 10px;\n    }\n\n    .search-app-bar-border-wrapper > img {\n        position: absolute;\n        top: 50%;\n        right: 9px;\n        margin-right: 10px;\n        height: 18px;\n        transform: translateY(-50%);\n    }\n\n    @media screen and (max-width: 767px) {\n        max-width: 100%;\n    }\n'], ['\n    margin: 0 auto; display: inline-block; max-width: 60vw; width: 100%;\n    \n    .search-app-bar-border-wrapper {\n        display: flex;\n        align-items: center;\n        border: 1px solid rgba(151, 151, 151, 1);\n        border-radius: 20px;\n        height: 40px;\n        background-color: rgba(255, 255, 255, 1);\n        padding: 0 10px;\n    }\n\n    .search-app-bar-border-wrapper > img {\n        position: absolute;\n        top: 50%;\n        right: 9px;\n        margin-right: 10px;\n        height: 18px;\n        transform: translateY(-50%);\n    }\n\n    @media screen and (max-width: 767px) {\n        max-width: 100%;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antd = __webpack_require__(43);
	
	exports.default = _antd.Collapse; // import React from 'react';
	// import { Collapse } from 'antd';
	// import { CollapseStyleWrapper } from './collapse.style';
	//
	// const Panel = Collapse.Panel;
	// export { Panel };
	// export default props =>
	//   <CollapseStyleWrapper>
	//     <Collapse {...props}>
	//       {props.children}
	//     </Collapse>
	//   </CollapseStyleWrapper>;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antd = __webpack_require__(43);
	
	exports.default = _antd.Form;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Textarea = exports.InputGroup = exports.InputSearch = undefined;
	
	var _antd = __webpack_require__(43);
	
	var _input = __webpack_require__(1628);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Search = _antd.Input.Search,
	    TextArea = _antd.Input.TextArea,
	    Group = _antd.Input.Group;
	
	
	var WDStyledInput = (0, _input.InputWrapper)(_antd.Input);
	var StyledInput = (0, _withDirection2.default)(WDStyledInput);
	
	var WDInputGroup = (0, _input.InputGroupWrapper)(Group);
	var InputGroup = (0, _withDirection2.default)(WDInputGroup);
	
	var WDInputSearch = (0, _input.InputSearchWrapper)(Search);
	var InputSearch = (0, _withDirection2.default)(WDInputSearch);
	
	var WDTextarea = (0, _input.TextAreaWrapper)(TextArea);
	var Textarea = (0, _withDirection2.default)(WDTextarea);
	
	exports.default = StyledInput;
	exports.InputSearch = InputSearch;
	exports.InputGroup = InputGroup;
	exports.Textarea = Textarea;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SingleDatePicker = exports.DateRangePicker = undefined;
	
	var _reactDates = __webpack_require__(2716);
	
	__webpack_require__(940);
	
	exports.DateRangePicker = _reactDates.DateRangePicker;
	exports.SingleDatePicker = _reactDates.SingleDatePicker;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GhostButtons = exports.RadioButtons = exports.ButtonsGroup = exports.Buttons = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  &.ant-btn {\n    display: inline-block;\n    margin-bottom: 0;\n    font-weight: 500;\n    text-align: center;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    line-height: 1.5;\n    padding: 0 25px;\n    font-size: 14px;\n    border-radius: 4px;\n    height: 36px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    position: relative;\n    color: ', ';\n    border-color: ', ';\n    ', ';\n\n    &:hover {\n      border-color: ', ';\n      color: ', ';\n    }\n\n    > .anticon + span,\n    > span + .anticon {\n      margin: ', ';\n    }\n\n    .anticon-right {\n      transform: ', ';\n    }\n\n    .anticon-left {\n      transform: ', ';\n    }\n\n    &.ant-btn-primary {\n      background-color: ', ';\n      border-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n        border-color: ', ';\n        color: #fff;\n      }\n    }\n\n    &.ant-btn-sm {\n      padding: 0 15px;\n      height: 28px;\n      font-size: 12px;\n\n      &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {\n        padding: ', ';\n        .anticon {\n          margin: ', ';\n        }\n      }\n    }\n\n    &.ant-btn-lg {\n      padding: 0 35px;\n      font-size: 14px;\n      height: 42px;\n    }\n\n    &.ant-btn-primary {\n      color: #ffffff;\n    }\n\n    &.ant-btn-dashed {\n      border-style: dashed;\n      border-color: ', ';\n\n      &:hover {\n        color: ', ';\n        border-color: ', ';\n      }\n    }\n\n    &.ant-btn-danger {\n      background-color: ', ';\n      border-color: ', ';\n      color: #ffffff;\n\n      &:hover {\n        background-color: ', ';\n        border-color: ', ';\n      }\n\n      &.ant-btn-background-ghost {\n        color: ', ';\n        background-color: transparent;\n        border-color: ', ';\n\n        &:hover {\n          color: ', ';\n          border-color: ', ';\n        }\n      }\n    }\n\n    &.ant-btn-circle,\n    &.ant-btn-circle-outline {\n      width: 35px;\n      padding: 0;\n      font-size: 14px;\n      border-radius: 50%;\n      height: 35px;\n\n      &.ant-btn-sm {\n        padding: 0;\n        height: 28px;\n        width: 28px;\n        font-size: 12px;\n      }\n\n      &.ant-btn-lg {\n        padding: 0;\n        font-size: 14px;\n        height: 42px;\n        width: 42px;\n      }\n    }\n\n    &.ant-btn.disabled,\n    &.ant-btn[disabled],\n    &.ant-btn.disabled:hover,\n    &.ant-btn[disabled]:hover,\n    &.ant-btn.disabled:focus,\n    &.ant-btn[disabled]:focus,\n    &.ant-btn.disabled:active,\n    &.ant-btn[disabled]:active,\n    &.ant-btn.disabled.active,\n    &.ant-btn[disabled].active {\n      color: ', ';\n      background-color: #f7f7f7;\n      border-color: ', ';\n      cursor: not-allowed;\n    }\n\n    &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)\n      .anticon {\n      margin: ', ';\n    }\n\n    &.isoButton {\n      display: inline-block;\n      margin-bottom: 0;\n      font-weight: 500;\n      text-align: center;\n      -ms-touch-action: manipulation;\n      touch-action: manipulation;\n      cursor: pointer;\n      background-image: none;\n      border: 0;\n      white-space: nowrap;\n      line-height: 1.5;\n      padding: 0 25px;\n      font-size: 13px;\n      border-radius: 4px;\n      height: 35px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      position: relative;\n      color: #ffffff;\n      background-color: ', ';\n      ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n\n      &.isoBtnSm {\n        padding: 0 15px;\n        height: 28px;\n        font-size: 12px;\n      }\n\n      &.isoBtnLg {\n        padding: 0 35px;\n        font-size: 14px;\n        height: 42px;\n      }\n    }\n  }\n\n  + .ant-btn-group {\n    margin-left: ', ' !important;\n    margin-right: ', ' !important;\n  }\n'], ['\n  &.ant-btn {\n    display: inline-block;\n    margin-bottom: 0;\n    font-weight: 500;\n    text-align: center;\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n    cursor: pointer;\n    background-image: none;\n    border: 1px solid transparent;\n    white-space: nowrap;\n    line-height: 1.5;\n    padding: 0 25px;\n    font-size: 14px;\n    border-radius: 4px;\n    height: 36px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    position: relative;\n    color: ', ';\n    border-color: ', ';\n    ', ';\n\n    &:hover {\n      border-color: ', ';\n      color: ', ';\n    }\n\n    > .anticon + span,\n    > span + .anticon {\n      margin: ', ';\n    }\n\n    .anticon-right {\n      transform: ', ';\n    }\n\n    .anticon-left {\n      transform: ', ';\n    }\n\n    &.ant-btn-primary {\n      background-color: ', ';\n      border-color: ', ';\n\n      &:hover {\n        background-color: ', ';\n        border-color: ', ';\n        color: #fff;\n      }\n    }\n\n    &.ant-btn-sm {\n      padding: 0 15px;\n      height: 28px;\n      font-size: 12px;\n\n      &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {\n        padding: ', ';\n        .anticon {\n          margin: ', ';\n        }\n      }\n    }\n\n    &.ant-btn-lg {\n      padding: 0 35px;\n      font-size: 14px;\n      height: 42px;\n    }\n\n    &.ant-btn-primary {\n      color: #ffffff;\n    }\n\n    &.ant-btn-dashed {\n      border-style: dashed;\n      border-color: ', ';\n\n      &:hover {\n        color: ', ';\n        border-color: ', ';\n      }\n    }\n\n    &.ant-btn-danger {\n      background-color: ', ';\n      border-color: ', ';\n      color: #ffffff;\n\n      &:hover {\n        background-color: ', ';\n        border-color: ', ';\n      }\n\n      &.ant-btn-background-ghost {\n        color: ', ';\n        background-color: transparent;\n        border-color: ', ';\n\n        &:hover {\n          color: ', ';\n          border-color: ', ';\n        }\n      }\n    }\n\n    &.ant-btn-circle,\n    &.ant-btn-circle-outline {\n      width: 35px;\n      padding: 0;\n      font-size: 14px;\n      border-radius: 50%;\n      height: 35px;\n\n      &.ant-btn-sm {\n        padding: 0;\n        height: 28px;\n        width: 28px;\n        font-size: 12px;\n      }\n\n      &.ant-btn-lg {\n        padding: 0;\n        font-size: 14px;\n        height: 42px;\n        width: 42px;\n      }\n    }\n\n    &.ant-btn.disabled,\n    &.ant-btn[disabled],\n    &.ant-btn.disabled:hover,\n    &.ant-btn[disabled]:hover,\n    &.ant-btn.disabled:focus,\n    &.ant-btn[disabled]:focus,\n    &.ant-btn.disabled:active,\n    &.ant-btn[disabled]:active,\n    &.ant-btn.disabled.active,\n    &.ant-btn[disabled].active {\n      color: ', ';\n      background-color: #f7f7f7;\n      border-color: ', ';\n      cursor: not-allowed;\n    }\n\n    &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)\n      .anticon {\n      margin: ', ';\n    }\n\n    &.isoButton {\n      display: inline-block;\n      margin-bottom: 0;\n      font-weight: 500;\n      text-align: center;\n      -ms-touch-action: manipulation;\n      touch-action: manipulation;\n      cursor: pointer;\n      background-image: none;\n      border: 0;\n      white-space: nowrap;\n      line-height: 1.5;\n      padding: 0 25px;\n      font-size: 13px;\n      border-radius: 4px;\n      height: 35px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      position: relative;\n      color: #ffffff;\n      background-color: ', ';\n      ', ';\n\n      &:hover {\n        background-color: ', ';\n      }\n\n      &.isoBtnSm {\n        padding: 0 15px;\n        height: 28px;\n        font-size: 12px;\n      }\n\n      &.isoBtnLg {\n        padding: 0 35px;\n        font-size: 14px;\n        height: 42px;\n      }\n    }\n  }\n\n  + .ant-btn-group {\n    margin-left: ', ' !important;\n    margin-right: ', ' !important;\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  .ant-radio-button-wrapper {\n    height: 35px;\n    line-height: 33px;\n    color: ', ';\n    border: 1px solid ', ';\n    border-left: 0;\n    background: #fff;\n    padding: 0 20px;\n\n    &:hover,\n    &.ant-radio-button-wrapper-focused {\n      color: ', ';\n    }\n\n    &.ant-radio-button-wrapper-checked {\n      background: #fff;\n      border-color: ', ';\n      color: ', ';\n      box-shadow: -1px 0 0 0 ', ';\n    }\n  }\n'], ['\n  .ant-radio-button-wrapper {\n    height: 35px;\n    line-height: 33px;\n    color: ', ';\n    border: 1px solid ', ';\n    border-left: 0;\n    background: #fff;\n    padding: 0 20px;\n\n    &:hover,\n    &.ant-radio-button-wrapper-focused {\n      color: ', ';\n    }\n\n    &.ant-radio-button-wrapper-checked {\n      background: #fff;\n      border-color: ', ';\n      color: ', ';\n      box-shadow: -1px 0 0 0 ', ';\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  &.ant-btn-group {\n    .ant-btn {\n      margin: 0;\n      margin-right: 0;\n      display: inline-block;\n      margin-bottom: 0;\n      font-weight: 500;\n      text-align: center;\n      -ms-touch-action: manipulation;\n      touch-action: manipulation;\n      cursor: pointer;\n      background-image: none;\n      border: 1px solid transparent;\n      border-color: ', ';\n      white-space: nowrap;\n      line-height: 1.5;\n      padding: 0 8px;\n      font-size: 14px;\n      border-radius: 4px;\n      height: 36px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      position: relative;\n      ', ';\n\n      &:hover {\n        border-color: ', ';\n      }\n\n      &.ant-btn-dashed {\n        border-style: dashed;\n\n        &:hover {\n          border-color: ', ';\n        }\n      }\n\n      &.ant-btn-primary {\n        border-color: ', ';\n\n        &:hover {\n          border-color: ', ';\n        }\n      }\n    }\n\n    > .ant-btn:first-child:not(:last-child) {\n      border-radius: ', ';\n    }\n\n    > .ant-btn:last-child:not(:first-child) {\n      border-radius: ', ';\n    }\n\n    .ant-btn-primary:last-child:not(:first-child),\n    .ant-btn-primary + .ant-btn-primary {\n      border-left-color: ', ';\n      border-right-color: ', ';\n    }\n\n    .ant-btn-primary:first-child:not(:last-child) {\n      border-left-color: ', ';\n      border-right-color: ', ';\n    }\n\n    .ant-btn + .ant-btn,\n    + .ant-btn {\n      margin-left: ', ' !important;\n      margin-right: ', ' !important;\n    }\n\n    &.ant-btn-group-lg {\n      > .ant-btn {\n        padding: 0 35px;\n        font-size: 14px;\n        height: 42px;\n      }\n    }\n\n    &.ant-btn-group-sm {\n      > .ant-btn {\n        padding: 0 15px;\n        height: 28px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  &.ant-btn-group + &.ant-btn-group {\n    margin-left: ', ' !important;\n    margin-right: ', ' !important;\n  }\n'], ['\n  &.ant-btn-group {\n    .ant-btn {\n      margin: 0;\n      margin-right: 0;\n      display: inline-block;\n      margin-bottom: 0;\n      font-weight: 500;\n      text-align: center;\n      -ms-touch-action: manipulation;\n      touch-action: manipulation;\n      cursor: pointer;\n      background-image: none;\n      border: 1px solid transparent;\n      border-color: ', ';\n      white-space: nowrap;\n      line-height: 1.5;\n      padding: 0 8px;\n      font-size: 14px;\n      border-radius: 4px;\n      height: 36px;\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      -ms-user-select: none;\n      user-select: none;\n      position: relative;\n      ', ';\n\n      &:hover {\n        border-color: ', ';\n      }\n\n      &.ant-btn-dashed {\n        border-style: dashed;\n\n        &:hover {\n          border-color: ', ';\n        }\n      }\n\n      &.ant-btn-primary {\n        border-color: ', ';\n\n        &:hover {\n          border-color: ', ';\n        }\n      }\n    }\n\n    > .ant-btn:first-child:not(:last-child) {\n      border-radius: ', ';\n    }\n\n    > .ant-btn:last-child:not(:first-child) {\n      border-radius: ', ';\n    }\n\n    .ant-btn-primary:last-child:not(:first-child),\n    .ant-btn-primary + .ant-btn-primary {\n      border-left-color: ', ';\n      border-right-color: ', ';\n    }\n\n    .ant-btn-primary:first-child:not(:last-child) {\n      border-left-color: ', ';\n      border-right-color: ', ';\n    }\n\n    .ant-btn + .ant-btn,\n    + .ant-btn {\n      margin-left: ', ' !important;\n      margin-right: ', ' !important;\n    }\n\n    &.ant-btn-group-lg {\n      > .ant-btn {\n        padding: 0 35px;\n        font-size: 14px;\n        height: 42px;\n      }\n    }\n\n    &.ant-btn-group-sm {\n      > .ant-btn {\n        padding: 0 15px;\n        height: 28px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  &.ant-btn-group + &.ant-btn-group {\n    margin-left: ', ' !important;\n    margin-right: ', ' !important;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  .ant-btn-background-ghost {\n    background: transparent !important;\n    border-color: #fff;\n    color: #fff;\n\n    &.ant-btn-primary {\n      color: ', ';\n      background-color: transparent;\n      border-color: ', ';\n    }\n  }\n'], ['\n  .ant-btn-background-ghost {\n    background: transparent !important;\n    border-color: #fff;\n    color: #fff;\n\n    &.ant-btn-primary {\n      color: ', ';\n      background-color: transparent;\n      border-color: ', ';\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _styleUtil = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Buttons = function Buttons(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 0.5em 0 0' : '0 0 0 0.5em';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'rotate(0)';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'rotate(0)';
	  }, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 10), (0, _styledTheme.palette)('primary', 10), function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 24px 0 15px' : '0 15px 0 24px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 -17px 0 0' : '0 0 0 -17px';
	  }, (0, _styledTheme.palette)('border', 1), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('error', 0), (0, _styledTheme.palette)('error', 0), (0, _styledTheme.palette)('error', 2), (0, _styledTheme.palette)('error', 2), (0, _styledTheme.palette)('error', 0), (0, _styledTheme.palette)('error', 0), (0, _styledTheme.palette)('error', 2), (0, _styledTheme.palette)('error', 2), (0, _styledTheme.palette)('grayscale', 2), (0, _styledTheme.palette)('border', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 -14px 0 0' : '0 0 0 -14px';
	  }, (0, _styledTheme.palette)('primary', 0), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 2), function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : '-1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '-1px' : '0';
	  });
	};
	
	var RadioButtons = function RadioButtons(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject2, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('border', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	};
	
	var ButtonsGroup = function ButtonsGroup(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject3, (0, _styledTheme.palette)('border', 1), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 10), function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '4px 0 0 4px' : '0 4px 4px 0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? (0, _styledTheme.palette)('primary', 0) : (0, _styledTheme.palette)('primary', 2);
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? (0, _styledTheme.palette)('primary', 2) : (0, _styledTheme.palette)('primary', 0);
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? (0, _styledTheme.palette)('primary', 2) : (0, _styledTheme.palette)('primary', 0);
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? (0, _styledTheme.palette)('primary', 0) : (0, _styledTheme.palette)('primary', 2);
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : '-1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '-1px' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : '-1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '-1px' : '0';
	  });
	};
	
	var GhostButtons = function GhostButtons(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject4, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	};
	
	exports.Buttons = Buttons;
	exports.ButtonsGroup = ButtonsGroup;
	exports.RadioButtons = RadioButtons;
	exports.GhostButtons = GhostButtons;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  &.ant-checkbox-wrapper {\n    font-size: 13px;\n    color: ', ';\n\n    .ant-checkbox-checked .ant-checkbox-inner,\n    .ant-checkbox-indeterminate .ant-checkbox-inner {\n      background-color: ', ';\n      border-color: ', ';\n    }\n\n    .ant-checkbox:hover .ant-checkbox-inner,\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n      border-color: ', ';\n    }\n\n    &:hover {\n      .ant-checkbox-inner {\n        border-color: ', ';\n      }\n    }\n  }\n'], ['\n  &.ant-checkbox-wrapper {\n    font-size: 13px;\n    color: ', ';\n\n    .ant-checkbox-checked .ant-checkbox-inner,\n    .ant-checkbox-indeterminate .ant-checkbox-inner {\n      background-color: ', ';\n      border-color: ', ';\n    }\n\n    .ant-checkbox:hover .ant-checkbox-inner,\n    .ant-checkbox-input:focus + .ant-checkbox-inner {\n      border-color: ', ';\n    }\n\n    &:hover {\n      .ant-checkbox-inner {\n        border-color: ', ';\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AntCheckbox = function AntCheckbox(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	};
	
	exports.default = AntCheckbox;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DropdownMenus = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n\n  &.ant-dropdown-button {\n    &.ant-btn-group > .ant-btn:first-child:not(:last-child) {\n      border-radius: ', ';\n    }\n\n    &.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n      border-radius: ', ';\n    }\n\n    &.ant-btn-group .ant-btn + .ant-btn {\n      margin: ', ';\n    }\n  }\n\n  .ant-dropdown-link {\n    font-size: 13px;\n    color: ', ';\n\n    &:hover {\n      color: ', ';\n    }\n  }\n'], ['\n  display: inline-block;\n\n  &.ant-dropdown-button {\n    &.ant-btn-group > .ant-btn:first-child:not(:last-child) {\n      border-radius: ', ';\n    }\n\n    &.ant-btn-group > .ant-btn:last-child:not(:first-child) {\n      border-radius: ', ';\n    }\n\n    &.ant-btn-group .ant-btn + .ant-btn {\n      margin: ', ';\n    }\n  }\n\n  .ant-dropdown-link {\n    font-size: 13px;\n    color: ', ';\n\n    &:hover {\n      color: ', ';\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  .ant-dropdown-menu-item {\n    a {\n      font-size: 13px;\n      color: ', ';\n    }\n  }\n\n  .ant-dropdown-menu-item,\n  .ant-dropdown-menu-submenu-title {\n    a {\n      font-size: 13px;\n      color: ', ';\n    }\n\n    &:hover {\n      background-color: ', ';\n      // background-color: rgba(0, 0, 0, 1);\n    }\n  }\n'], ['\n  .ant-dropdown-menu-item {\n    a {\n      font-size: 13px;\n      color: ', ';\n    }\n  }\n\n  .ant-dropdown-menu-item,\n  .ant-dropdown-menu-submenu-title {\n    a {\n      font-size: 13px;\n      color: ', ';\n    }\n\n    &:hover {\n      background-color: ', ';\n      // background-color: rgba(0, 0, 0, 1);\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DropdownWrapper = function DropdownWrapper(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0  0 4px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '4px 0 0 4px' : '0 4px 4px 0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 -1px 0 0' : '0 0 0 -1px';
	  }, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 2));
	};
	
	var DropdownMenus = function DropdownMenus(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject2, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('secondary', 1));
	};
	
	exports.default = DropdownWrapper;
	exports.DropdownMenus = DropdownMenus;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TextAreaWrapper = exports.InputSearchWrapper = exports.InputGroupWrapper = exports.InputWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  &.ant-input {\n    padding: 4px 10px;\n    width: 100%;\n    height: 35px;\n    cursor: text;\n    text-align: ', ';\n    font-size: 13px;\n    line-height: 1.5;\n    color: ', ';\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid ', ';\n    ', ';\n    ', ';\n\n    &:focus {\n      border-color: ', ';\n    }\n\n    &.ant-input-lg {\n      height: 42px;\n      padding: 6px 10px;\n    }\n\n    &.ant-input-sm {\n      padding: 1px 10px;\n      height: 30px;\n    }\n\n    &::-webkit-input-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n\n    &:-moz-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n\n    &::-moz-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n    &:-ms-input-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n  }\n'], ['\n  &.ant-input {\n    padding: 4px 10px;\n    width: 100%;\n    height: 35px;\n    cursor: text;\n    text-align: ', ';\n    font-size: 13px;\n    line-height: 1.5;\n    color: ', ';\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid ', ';\n    ', ';\n    ', ';\n\n    &:focus {\n      border-color: ', ';\n    }\n\n    &.ant-input-lg {\n      height: 42px;\n      padding: 6px 10px;\n    }\n\n    &.ant-input-sm {\n      padding: 1px 10px;\n      height: 30px;\n    }\n\n    &::-webkit-input-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n\n    &:-moz-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n\n    &::-moz-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n    &:-ms-input-placeholder {\n      text-align: ', ';\n      color: ', ';\n    }\n  }\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  &.ant-input-group {\n    margin-bottom: 10px;\n\n    .ant-select-auto-complete {\n      margin-right: ', ';\n    }\n\n    .ant-input {\n      &:first-child {\n        border-radius: ', ';\n      }\n    }\n\n    .ant-input-group-addon:not(:first-child):not(:last-child),\n    .ant-input-group-wrap:not(:first-child):not(:last-child),\n    > .ant-input:not(:first-child):not(:last-child) {\n      padding: 0 7px;\n      border-left-width: ', ';\n      margin-right: ', ';\n    }\n\n    .ant-input-group-addon {\n      padding: 4px 7px;\n      font-size: 12px;\n      color: ', ';\n      text-align: center;\n      background-color: ', ';\n      border: 1px solid ', ';\n      ', ';\n\n      &:first-child {\n        border-right-width: ', ';\n        border-left-width: ', ';\n        border-radius: ', ';\n      }\n\n      &:last-child {\n        border-right-width: ', ';\n        border-left-width: ', ';\n        border-radius: ', ';\n      }\n\n      .ant-select {\n        .ant-select-selection {\n          background-color: inherit;\n          margin: -1px;\n          border: 1px solid transparent;\n          ', ';\n        }\n      }\n    }\n\n    .ant-input-group-addon:not(:first-child):not(:last-child),\n    .ant-input-group-wrap:not(:first-child):not(:last-child) {\n      border-left: 0;\n      border-right: 0;\n    }\n\n    & > .ant-input:not(:first-child):not(:last-child) {\n      ', ';\n    }\n\n    .ant-input:first-child:last-child {\n      border-radius: 4px;\n    }\n\n    &.ant-input-group-compact > * {\n      border-right-width: ', ';\n    }\n\n    &.ant-input-group-compact > .ant-select > .ant-select-selection,\n    &.ant-input-group-compact > .ant-calendar-picker .ant-input,\n    &.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n    &.ant-input-group-compact > .ant-cascader-picker .ant-input,\n    &.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n    &.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n      border-right-width: ', ';\n    }\n\n    &.ant-input-group-compact > *:first-child,\n    &.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n    &.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n    &.ant-input-group-compact\n      > .ant-select-auto-complete:first-child\n      .ant-input,\n    &.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n    &.ant-input-group-compact\n      > .ant-mention-wrapper:first-child\n      .ant-mention-editor,\n    &.ant-input-group-compact\n      > .ant-time-picker:first-child\n      .ant-time-picker-input {\n      border-radius: ', ';\n      border-left-width: 1px\n        ', ';\n    }\n\n    &.ant-input-group-compact > *:last-child,\n    &.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n    &.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n    &.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n    &.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n    &.ant-input-group-compact\n      > .ant-mention-wrapper:last-child\n      .ant-mention-editor,\n    &.ant-input-group-compact\n      > .ant-time-picker:last-child\n      .ant-time-picker-input {\n      border-radius: ', ';\n      border-right-width: ', ';\n    }\n\n    .ant-calendar-picker-clear,\n    .ant-calendar-picker-icon {\n      right: ', ';\n      left: ', ';\n    }\n  }\n\n  &.ant-input-group-lg {\n    .ant-input,\n    > .ant-input-group-addon {\n      padding: 6px 10px;\n      height: 35px;\n    }\n  }\n'], ['\n  &.ant-input-group {\n    margin-bottom: 10px;\n\n    .ant-select-auto-complete {\n      margin-right: ', ';\n    }\n\n    .ant-input {\n      &:first-child {\n        border-radius: ', ';\n      }\n    }\n\n    .ant-input-group-addon:not(:first-child):not(:last-child),\n    .ant-input-group-wrap:not(:first-child):not(:last-child),\n    > .ant-input:not(:first-child):not(:last-child) {\n      padding: 0 7px;\n      border-left-width: ', ';\n      margin-right: ', ';\n    }\n\n    .ant-input-group-addon {\n      padding: 4px 7px;\n      font-size: 12px;\n      color: ', ';\n      text-align: center;\n      background-color: ', ';\n      border: 1px solid ', ';\n      ', ';\n\n      &:first-child {\n        border-right-width: ', ';\n        border-left-width: ', ';\n        border-radius: ', ';\n      }\n\n      &:last-child {\n        border-right-width: ', ';\n        border-left-width: ', ';\n        border-radius: ', ';\n      }\n\n      .ant-select {\n        .ant-select-selection {\n          background-color: inherit;\n          margin: -1px;\n          border: 1px solid transparent;\n          ', ';\n        }\n      }\n    }\n\n    .ant-input-group-addon:not(:first-child):not(:last-child),\n    .ant-input-group-wrap:not(:first-child):not(:last-child) {\n      border-left: 0;\n      border-right: 0;\n    }\n\n    & > .ant-input:not(:first-child):not(:last-child) {\n      ', ';\n    }\n\n    .ant-input:first-child:last-child {\n      border-radius: 4px;\n    }\n\n    &.ant-input-group-compact > * {\n      border-right-width: ', ';\n    }\n\n    &.ant-input-group-compact > .ant-select > .ant-select-selection,\n    &.ant-input-group-compact > .ant-calendar-picker .ant-input,\n    &.ant-input-group-compact > .ant-select-auto-complete .ant-input,\n    &.ant-input-group-compact > .ant-cascader-picker .ant-input,\n    &.ant-input-group-compact > .ant-mention-wrapper .ant-mention-editor,\n    &.ant-input-group-compact > .ant-time-picker .ant-time-picker-input {\n      border-right-width: ', ';\n    }\n\n    &.ant-input-group-compact > *:first-child,\n    &.ant-input-group-compact > .ant-select:first-child > .ant-select-selection,\n    &.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input,\n    &.ant-input-group-compact\n      > .ant-select-auto-complete:first-child\n      .ant-input,\n    &.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input,\n    &.ant-input-group-compact\n      > .ant-mention-wrapper:first-child\n      .ant-mention-editor,\n    &.ant-input-group-compact\n      > .ant-time-picker:first-child\n      .ant-time-picker-input {\n      border-radius: ', ';\n      border-left-width: 1px\n        ', ';\n    }\n\n    &.ant-input-group-compact > *:last-child,\n    &.ant-input-group-compact > .ant-select:last-child > .ant-select-selection,\n    &.ant-input-group-compact > .ant-calendar-picker:last-child .ant-input,\n    &.ant-input-group-compact > .ant-select-auto-complete:last-child .ant-input,\n    &.ant-input-group-compact > .ant-cascader-picker:last-child .ant-input,\n    &.ant-input-group-compact\n      > .ant-mention-wrapper:last-child\n      .ant-mention-editor,\n    &.ant-input-group-compact\n      > .ant-time-picker:last-child\n      .ant-time-picker-input {\n      border-radius: ', ';\n      border-right-width: ', ';\n    }\n\n    .ant-calendar-picker-clear,\n    .ant-calendar-picker-icon {\n      right: ', ';\n      left: ', ';\n    }\n  }\n\n  &.ant-input-group-lg {\n    .ant-input,\n    > .ant-input-group-addon {\n      padding: 6px 10px;\n      height: 35px;\n    }\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  &.ant-input {\n    padding: 4px 10px;\n    width: 100%;\n    height: auto;\n    cursor: text;\n    font-size: 13px;\n    line-height: 1.5;\n    color: ', ';\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid ', ';\n    ', ';\n    ', ';\n\n    &:focus {\n      border-color: ', ';\n    }\n\n    &::-webkit-input-placeholder {\n      color: ', ';\n    }\n\n    &:-moz-placeholder {\n      color: ', ';\n    }\n\n    &::-moz-placeholder {\n      color: ', ';\n    }\n    &:-ms-input-placeholder {\n      color: ', ';\n    }\n  }\n'], ['\n  &.ant-input {\n    padding: 4px 10px;\n    width: 100%;\n    height: auto;\n    cursor: text;\n    font-size: 13px;\n    line-height: 1.5;\n    color: ', ';\n    background-color: #fff;\n    background-image: none;\n    border: 1px solid ', ';\n    ', ';\n    ', ';\n\n    &:focus {\n      border-color: ', ';\n    }\n\n    &::-webkit-input-placeholder {\n      color: ', ';\n    }\n\n    &:-moz-placeholder {\n      color: ', ';\n    }\n\n    &::-moz-placeholder {\n      color: ', ';\n    }\n    &:-ms-input-placeholder {\n      color: ', ';\n    }\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  &.ant-input-affix-wrapper {\n    .ant-input {\n      padding: 4px 10px;\n      width: 100%;\n      height: 35px;\n      cursor: text;\n      font-size: 13px;\n      line-height: 1.5;\n      color: ', ';\n      background-color: #fff;\n      background-image: none;\n      border: 1px solid ', ';\n      ', ';\n      ', ';\n\n      &:focus {\n        border-color: ', ';\n      }\n\n      &.ant-input-lg {\n        height: 42px;\n        padding: 6px 10px;\n      }\n\n      &.ant-input-sm {\n        padding: 1px 10px;\n        height: 30px;\n      }\n\n      &::-webkit-input-placeholder {\n        color: ', ';\n      }\n\n      &:-moz-placeholder {\n        color: ', ';\n      }\n\n      &::-moz-placeholder {\n        color: ', ';\n      }\n      &:-ms-input-placeholder {\n        color: ', ';\n      }\n    }\n\n    .ant-input-suffix {\n      right: ', ';\n      left: ', ';\n    }\n\n    .ant-input-ant-input-prefix {\n      right: ', ';\n      left: ', ';\n    }\n\n    .ant-input-search-icon {\n      color: ', ';\n\n      &:hover {\n        color: ', ';\n      }\n    }\n  }\n'], ['\n  &.ant-input-affix-wrapper {\n    .ant-input {\n      padding: 4px 10px;\n      width: 100%;\n      height: 35px;\n      cursor: text;\n      font-size: 13px;\n      line-height: 1.5;\n      color: ', ';\n      background-color: #fff;\n      background-image: none;\n      border: 1px solid ', ';\n      ', ';\n      ', ';\n\n      &:focus {\n        border-color: ', ';\n      }\n\n      &.ant-input-lg {\n        height: 42px;\n        padding: 6px 10px;\n      }\n\n      &.ant-input-sm {\n        padding: 1px 10px;\n        height: 30px;\n      }\n\n      &::-webkit-input-placeholder {\n        color: ', ';\n      }\n\n      &:-moz-placeholder {\n        color: ', ';\n      }\n\n      &::-moz-placeholder {\n        color: ', ';\n      }\n      &:-ms-input-placeholder {\n        color: ', ';\n      }\n    }\n\n    .ant-input-suffix {\n      right: ', ';\n      left: ', ';\n    }\n\n    .ant-input-ant-input-prefix {\n      right: ', ';\n      left: ', ';\n    }\n\n    .ant-input-search-icon {\n      color: ', ';\n\n      &:hover {\n        color: ', ';\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _styleUtil = __webpack_require__(278);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var InputWrapper = function InputWrapper(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	  }, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.borderRadius)('4px'), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	  }, (0, _styledTheme.palette)('grayscale', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	  }, (0, _styledTheme.palette)('grayscale', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	  }, (0, _styledTheme.palette)('grayscale', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	  }, (0, _styledTheme.palette)('grayscale', 0));
	};
	var InputGroupWrapper = function InputGroupWrapper(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject2, function (props) {
	    return props['data-rtl'] === 'rtl' ? '-1px' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : '1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '-1px' : '0';
	  }, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('grayscale', 4), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.transition)(), function (props) {
	    return props['data-rtl'] === 'rtl' ? '1px' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : '1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : '1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '1px' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '4px 0 0 4px' : '0 4px 4px 0';
	  }, (0, _styleUtil.boxShadow)(), '' /* border-left: 0; */, function (props) {
	    return props['data-rtl'] === 'rtl' ? '1px ' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '1px ' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 4px 4px 0' : '4px 0 0 4px';
	  }, '' /* border-right-width: ${props =>
	        props['data-rtl'] === 'rtl' ? '1px' : '0'}; */, function (props) {
	    return props['data-rtl'] === 'rtl' ? '4px 0 0 4px' : '0 4px 4px 0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 ' : '1px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'inherit' : '8px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '8px' : 'inherit';
	  });
	};
	
	var TextAreaWrapper = function TextAreaWrapper(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject3, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.borderRadius)('4px'), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0));
	};
	
	var InputSearchWrapper = function InputSearchWrapper(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject4, (0, _styledTheme.palette)('text', 1), (0, _styledTheme.palette)('border', 0), (0, _styleUtil.borderRadius)('4px'), (0, _styleUtil.transition)(), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('grayscale', 0), function (props) {
	    return props['data-rtl'] === 'rtl' ? 'inherit' : '7px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '7px' : 'inherit';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '7px' : 'inherit';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'inherit' : '7px';
	  }, (0, _styledTheme.palette)('grayscale', 0), (0, _styledTheme.palette)('primary', 0));
	};
	
	exports.InputWrapper = InputWrapper;
	exports.InputGroupWrapper = InputGroupWrapper;
	exports.InputSearchWrapper = InputSearchWrapper;
	exports.TextAreaWrapper = TextAreaWrapper;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  &.ant-switch-checked {\n    border-color: ', ';\n    background-color: ', ';\n  }\n'], ['\n  &.ant-switch-checked {\n    border-color: ', ';\n    background-color: ', ';\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AntSwitch = function AntSwitch(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	};
	
	exports.default = AntSwitch;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  &.ant-tabs {\n    &:not(.ant-tabs-vertical) {\n      > .ant-tabs-content-animated {\n        display: ', ';\n      }\n    }\n\n    .ant-tabs-nav {\n      .ant-tabs-tab {\n        margin: ', ';\n\n        .anticon:not(.anticon-close) {\n          margin: ', ';\n\n          &.anticon-close{\n            right: ', ';;\n            left: ', ';;\n          }\n        }\n      }\n    }\n\n    .ant-tabs-tab-prev {\n      left: ', ';\n      right ', ';\n      transform: ', ';\n\n    }\n\n    .ant-tabs-tab-next {\n      left: ', ';\n      right ', ';\n      transform: ', ';\n    }\n\n    &.ant-tabs-vertical{\n      .ant-tabs-tab-prev,\n      .ant-tabs-tab-next{\n        transform: rotate(0);\n      }\n    }\n  }\n'], ['\n  &.ant-tabs {\n    &:not(.ant-tabs-vertical) {\n      > .ant-tabs-content-animated {\n        display: ', ';\n      }\n    }\n\n    .ant-tabs-nav {\n      .ant-tabs-tab {\n        margin: ', ';\n\n        .anticon:not(.anticon-close) {\n          margin: ', ';\n\n          &.anticon-close{\n            right: ', ';;\n            left: ', ';;\n          }\n        }\n      }\n    }\n\n    .ant-tabs-tab-prev {\n      left: ', ';\n      right ', ';\n      transform: ', ';\n\n    }\n\n    .ant-tabs-tab-next {\n      left: ', ';\n      right ', ';\n      transform: ', ';\n    }\n\n    &.ant-tabs-vertical{\n      .ant-tabs-tab-prev,\n      .ant-tabs-tab-next{\n        transform: rotate(0);\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AntTab = function AntTab(ComponentName) {
	  return (0, _styledComponents2.default)(ComponentName)(_templateObject, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'block' : 'flex';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 0 0 24px' : '0 24px 0 0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0 0 0 8px' : '0 8px 0 0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'inherit' : '2px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '2px' : 'inherit';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'inherit' : '0';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '2px' : 'inherit';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'rotate(0)';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? '0' : 'inherit';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'inherit' : '2px';
	  }, function (props) {
	    return props['data-rtl'] === 'rtl' ? 'rotate(180deg)' : 'rotate(0)';
	  });
	};
	
	exports.default = AntTab;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antd = __webpack_require__(43);
	
	var _switch = __webpack_require__(1629);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Switches = (0, _switch2.default)(_antd.Switch);
	
	exports.default = Switches;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antd = __webpack_require__(43);
	
	exports.default = _antd.Table;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabPane = undefined;
	
	var _antd = __webpack_require__(43);
	
	var _tab = __webpack_require__(1630);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import '../../style/UI-Component/tab/tab.css';
	var WDTabs = (0, _tab2.default)(_antd.Tabs);
	var TabPane = _antd.Tabs.TabPane;
	var isoTabs = (0, _withDirection2.default)(WDTabs);
	
	exports.default = isoTabs;
	exports.TabPane = TabPane;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _boxTitle = __webpack_require__(1636);
	
	var _boxTitle2 = _interopRequireDefault(_boxTitle);
	
	var _box = __webpack_require__(1635);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _box.BoxWrapper,
	    { className: 'isoBoxWrapper' },
	    _react2.default.createElement(_boxTitle2.default, { title: props.title, subtitle: props.subtitle }),
	    props.children
	  );
	};

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoxWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  background-color: #ffffff;\n  border: 1px solid ', ';\n  margin: 0 17px 30px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media only screen and (max-width: 767px) {\n    padding: 20px;\n    margin: 0 10px 30px;\n  }\n\n  &.half {\n    width: calc(50% - 34px);\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n  }\n'], ['\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  background-color: #ffffff;\n  border: 1px solid ', ';\n  margin: 0 17px 30px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media only screen and (max-width: 767px) {\n    padding: 20px;\n    margin: 0 10px 30px;\n  }\n\n  &.half {\n    width: calc(50% - 34px);\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var BoxWrapper = _styledComponents2.default.div(_templateObject, (0, _styledTheme.palette)('border', 0));
	
	exports.BoxWrapper = BoxWrapper;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _boxTitle = __webpack_require__(1637);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    props.title ? _react2.default.createElement(
	      _boxTitle.BoxTitle,
	      { className: 'isoBoxTitle' },
	      ' ',
	      props.title,
	      ' '
	    ) : '',
	    props.subtitle ? _react2.default.createElement(
	      _boxTitle.BoxSubTitle,
	      { className: 'isoBoxSubTitle' },
	      ' ',
	      props.subtitle,
	      ' '
	    ) : ''
	  );
	};

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BoxSubTitle = exports.BoxTitle = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-size: 14px;\n  font-weight: 500;\n  color: ', ';\n  margin: 0;\n  margin-bottom: 5px;\n'], ['\n  font-size: 14px;\n  font-weight: 500;\n  color: ', ';\n  margin: 0;\n  margin-bottom: 5px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 13px;\n  font-weight: 400;\n  color: ', ';\n  line-height: 24px;\n'], ['\n  font-size: 13px;\n  font-weight: 400;\n  color: ', ';\n  line-height: 24px;\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var BoxTitle = _styledComponents2.default.h3(_templateObject, (0, _styledTheme.palette)('text', 0));
	
	var BoxSubTitle = _styledComponents2.default.p(_templateObject2, (0, _styledTheme.palette)('text', 3));
	
	exports.BoxTitle = BoxTitle;
	exports.BoxSubTitle = BoxSubTitle;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ContentHolderWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  margin-top: 30px;\n\n  @media only screen and (max-width: 767) {\n    margin: 30px;\n  }\n\n  -webkit-overflow-scrolling: touch;\n  .percentage {\n    padding: 130px 0;\n    position: absolute;\n    text-align: center\n    width: 100%;\n    // font-family: \'Montserrat\';\nfont-size: 32px;\n    color: rgb(104, 207, 240);\n    letter-spacing: 0.03em;\n  }\n\n  .iPhone{\n    width: 80%;\n    display: block;\n    margin: 0 auto;\n  }\n  .firstLine{\n    font-size: 17px;\n    color: rgba(64, 55, 57, 1);\n    text-align: center;\n    letter-spacing: 0.03em;\n    /*Text styles for Connect wi */\n    font-family: \'Montserrat\';\n    font-size: 17px;\n    color: rgba(147, 147, 147, 1);\n    text-align: center;\n    letter-spacing: 0.03em;\n  }\n\n\n  .demoBtn {\n    margin-right: ', ';\n    margin-left: ', ';\n  }\n\n  .demoBtnsWrapper {\n    &:nth-child(1) {\n      margin-left: ', ';\n      margin-right: ', ';\n      white-space: nowrap;\n    }\n\n    &:nth-child(2) {\n      width: 70px;\n      float: ', ';\n    }\n\n    &:nth-child(3) {\n      width: 70px;\n      margin-left: ', ';\n      margin-right: ', ';\n    }\n\n    &:nth-child(4) {\n      margin-left: ', ';\n      margin-right: ', ';\n      clear: both;\n      white-space: nowrap;\n    }\n\n    @media only screen and (max-width: 480px) {\n      margin-left: ', ';\n      white-space: nowrap;\n      margin-right: ', ';\n      float: none !important;\n    }\n\n    .demoPosBtn {\n      width: 70px;\n      margin-right: ', ';\n      margin-left: ', ';\n      margin-bottom: 8px;\n      padding: 0;\n\n      @media only screen and (max-width: 480px) {\n        width: 65px;\n      }\n    }\n  }\n\n  .ant-btn {\n    &:not(.demoPosBtn) {\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .tooltipBtn {\n    display: inline-block;\n    line-height: 32px;\n    height: 32px;\n    width: 70px;\n    font-size: 14px;\n    text-align: center;\n    background: ', ';\n    margin-right: ', ';\n    margin-left: ', ';\n    margin-bottom: 6px;\n    border-radius: 6px;\n  }\n\n  .ant-progress {\n    &.ant-progress-circle {\n      margin-right: ', ';\n      margin-left: ', ';\n\n      &:last-child {\n        margin-right: ', ';\n        margin-left: ', ';\n      }\n    }\n  }\n\n  strong {\n    font-weight: 700;\n    font-size: 14px;\n  }\n'], ['\n  margin-top: 30px;\n\n  @media only screen and (max-width: 767) {\n    margin: 30px;\n  }\n\n  -webkit-overflow-scrolling: touch;\n  .percentage {\n    padding: 130px 0;\n    position: absolute;\n    text-align: center\n    width: 100%;\n    // font-family: \'Montserrat\';\nfont-size: 32px;\n    color: rgb(104, 207, 240);\n    letter-spacing: 0.03em;\n  }\n\n  .iPhone{\n    width: 80%;\n    display: block;\n    margin: 0 auto;\n  }\n  .firstLine{\n    font-size: 17px;\n    color: rgba(64, 55, 57, 1);\n    text-align: center;\n    letter-spacing: 0.03em;\n    /*Text styles for Connect wi */\n    font-family: \'Montserrat\';\n    font-size: 17px;\n    color: rgba(147, 147, 147, 1);\n    text-align: center;\n    letter-spacing: 0.03em;\n  }\n\n\n  .demoBtn {\n    margin-right: ', ';\n    margin-left: ', ';\n  }\n\n  .demoBtnsWrapper {\n    &:nth-child(1) {\n      margin-left: ', ';\n      margin-right: ', ';\n      white-space: nowrap;\n    }\n\n    &:nth-child(2) {\n      width: 70px;\n      float: ', ';\n    }\n\n    &:nth-child(3) {\n      width: 70px;\n      margin-left: ', ';\n      margin-right: ', ';\n    }\n\n    &:nth-child(4) {\n      margin-left: ', ';\n      margin-right: ', ';\n      clear: both;\n      white-space: nowrap;\n    }\n\n    @media only screen and (max-width: 480px) {\n      margin-left: ', ';\n      white-space: nowrap;\n      margin-right: ', ';\n      float: none !important;\n    }\n\n    .demoPosBtn {\n      width: 70px;\n      margin-right: ', ';\n      margin-left: ', ';\n      margin-bottom: 8px;\n      padding: 0;\n\n      @media only screen and (max-width: 480px) {\n        width: 65px;\n      }\n    }\n  }\n\n  .ant-btn {\n    &:not(.demoPosBtn) {\n      &:last-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .tooltipBtn {\n    display: inline-block;\n    line-height: 32px;\n    height: 32px;\n    width: 70px;\n    font-size: 14px;\n    text-align: center;\n    background: ', ';\n    margin-right: ', ';\n    margin-left: ', ';\n    margin-bottom: 6px;\n    border-radius: 6px;\n  }\n\n  .ant-progress {\n    &.ant-progress-circle {\n      margin-right: ', ';\n      margin-left: ', ';\n\n      &:last-child {\n        margin-right: ', ';\n        margin-left: ', ';\n      }\n    }\n  }\n\n  strong {\n    font-weight: 700;\n    font-size: 14px;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var WDContentHolderWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '10px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '10px' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '70px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '70px' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? 'right' : 'left';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '295px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '295px' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '70px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '70px' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '8px' : '0 !important';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0 !important' : '8px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '8px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '8px' : '0';
	}, (0, _styledTheme.palette)('secondary', 1), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'auto' : '6px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '6px' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '15px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '15px' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '0';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '0' : '0';
	});
	
	var ContentHolderWrapper = (0, _withDirection2.default)(WDContentHolderWrapper);
	
	exports.ContentHolderWrapper = ContentHolderWrapper;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(338);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InjectMassage = function InjectMassage(props) {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, props);
	};
	exports.default = (0, _reactIntl.injectIntl)(InjectMassage, {
	  withRef: false
	});

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layoutWrapper = __webpack_require__(1641);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _layoutWrapper.LayoutContentWrapper,
	    Object.assign({
	      className: props.className != null ? props.className + ' isoLayoutContentWrapper' : 'isoLayoutContentWrapper'
	    }, props),
	    props.children
	  );
	};

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LayoutContentWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  padding: 50px 20px;\n  display: flex;\n  flex-flow: row wrap;\n  overflow: hidden;\n\n  @media only screen and (max-width: 767px) {\n    padding: 50px 20px;\n  }\n\n  @media (max-width: 580px) {\n    padding: 15px;\n  }\n'], ['\n  padding: 50px 20px;\n  display: flex;\n  flex-flow: row wrap;\n  overflow: hidden;\n\n  @media only screen and (max-width: 767px) {\n    padding: 50px 20px;\n  }\n\n  @media (max-width: 580px) {\n    padding: 15px;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var LayoutContentWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.LayoutContentWrapper = LayoutContentWrapper;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _themedefault = __webpack_require__(741);
	
	var _themedefault2 = _interopRequireDefault(_themedefault);
	
	var _clone = __webpack_require__(288);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = (0, _clone2.default)(_themedefault2.default);
	theme.palette.primary = ['#f00'];
	theme.palette.secondary = ['#0f0'];
	exports.default = theme;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var config = void 0;
	//apiurl ==> api audience
	switch (("fake")) {
	  case 'local':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'http://localhost:3000/callback'
	    };
	    break;
	  case 'development':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'https://project-y.gogochart.com/callback'
	    };
	    break;
	  case 'aliyun-dev':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'https://project-y.gogochart.com/callback'
	    };
	    break;
	  case 'production':
	    config = {
	      domain: 'projectx.au.auth0.com',
	      apiUrl: 'https://prdapi.gogochart.com/',
	      clientId: 'P2NblPndrakfGq4UO1mQNYaWLIVep72B',
	      callbackUrl: 'https://project-x.gogochart.com/callback'
	    };
	    break;
	  case 'fake':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      //callbackUrl: 'http://project-y.gogochart.com/callback',
	      callbackUrl: 'http://localhost:3000/callback'
	    };
	    break;
	  case 'local-y':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'http://localhost:3000/callback'
	    };
	    break;
	  case 'dev-zay':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'http://zay.gogochart.com/callback'
	    };
	    break;
	  case 'dev-wesley':
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'http://wesley.gogochart.com/callback'
	    };
	    break;
	  default:
	    config = {
	      domain: 'project-xx.au.auth0.com',
	      clientId: 'OciKHIEvANvOyEi4OdGg6TNfbm7-_kVG',
	      apiUrl: 'http://localhost/',
	      callbackUrl: 'http://localhost:3000/callback'
	    };
	}
	console.log(config);
	var AUTH_CONFIG = exports.AUTH_CONFIG = config;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.clearKeyword = exports.setKeyword = exports.CLEAR_KEYWORD = exports.SET_KEYWORD = exports.clearSuggests = exports.CLEAR_SUGGESTS = exports.failureSuggest = exports.successSuggest = exports.requestSuggest = exports.FAILURE_SUGGEST = exports.SUCCESS_SUGGEST = exports.REQUEST_SUGGEST = undefined;
	
	var _reduxActions = __webpack_require__(1345);
	
	var REQUEST_SUGGEST = exports.REQUEST_SUGGEST = 'REQUEST_SUGGEST';
	var SUCCESS_SUGGEST = exports.SUCCESS_SUGGEST = 'SUCCESS_SUGGEST';
	var FAILURE_SUGGEST = exports.FAILURE_SUGGEST = 'FAILURE_SUGGEST';
	var requestSuggest = exports.requestSuggest = (0, _reduxActions.createAction)(REQUEST_SUGGEST);
	var successSuggest = exports.successSuggest = (0, _reduxActions.createAction)(SUCCESS_SUGGEST);
	var failureSuggest = exports.failureSuggest = (0, _reduxActions.createAction)(FAILURE_SUGGEST);
	
	var CLEAR_SUGGESTS = exports.CLEAR_SUGGESTS = 'CLEAR_SUGGESTS';
	var clearSuggests = exports.clearSuggests = (0, _reduxActions.createAction)(CLEAR_SUGGESTS);
	
	var SET_KEYWORD = exports.SET_KEYWORD = 'SET_KEYWORD';
	var CLEAR_KEYWORD = exports.CLEAR_KEYWORD = 'CLEAR_KEYWORD';
	var setKeyword = exports.setKeyword = (0, _reduxActions.createAction)(SET_KEYWORD);
	var clearKeyword = exports.clearKeyword = (0, _reduxActions.createAction)(CLEAR_KEYWORD);

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(157);
	
	var _reactSearch = __webpack_require__(1289);
	
	var _reactSearch2 = _interopRequireDefault(_reactSearch);
	
	var _reactAutosuggest = __webpack_require__(2641);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(40);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _actions = __webpack_require__(1644);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _style = __webpack_require__(1646);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AddCampaign = function (_Component) {
	  _inherits(AddCampaign, _Component);
	
	  function AddCampaign(props) {
	    _classCallCheck(this, AddCampaign);
	
	    var _this = _possibleConstructorReturn(this, (AddCampaign.__proto__ || Object.getPrototypeOf(AddCampaign)).call(this, props));
	
	    _this.renderSuggestion = function (suggestion, _ref) {
	      var query = _ref.query;
	
	      console.log(suggestion);
	      return _react2.default.createElement(
	        'span',
	        null,
	        suggestion.appName
	      );
	    };
	
	    _this.state = {
	      repos: [],
	      campaignList: [{ "id": 36110145, "orgId": 379480, "name": "kawa US", "budgetAmount": { "amount": "10", "currency": "USD" },
	        "dailyBudgetAmount": { "amount": "1", "currency": "USD" }, "adamId": 1025397186, "referenceLabel": null,
	        "negativeKeywords": [], "paymentModel": "PAYG", "locInvoiceDetails": null,
	        "adGroups": [{ "id": 36061494, "campaignId": 36110145, "name": "Trial 1", "cpaGoal": { "amount": "0.5", "currency": "USD" },
	          "storefronts": ["US"], "startTime": "2017-09-22T16:00:00.000", "endTime": null, "automatedKeywordsOptIn": true,
	          "defaultCpcBid": { "amount": "0.43", "currency": "USD" },
	          "keywords": [{ "id": 36126077, "adGroupId": 36061494, "text": "best coffee", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.392", "deleted": false }, { "id": 36126078, "adGroupId": 36061494, "text": "cafe", "status": "ACTIVE", "matchType": "BROAD", "bidAmount": { "amount": "0.05", "currency": "USD" },
	            "modificationTime": "2017-09-27T10:52:49.893", "deleted": false }, { "id": 36126079, "adGroupId": 36061494, "text": "coffee", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.05", "currency": "USD" }, "modificationTime": "2017-09-27T10:52:40.297", "deleted": false }, { "id": 36126080, "adGroupId": 36061494, "text": "countdown", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.409", "deleted": false }, { "id": 36127301, "adGroupId": 36061494, "text": "food delivery", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.413", "deleted": false }, { "id": 36127302, "adGroupId": 36061494, "text": "text free", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.418", "deleted": false }, { "id": 36127303, "adGroupId": 36061494, "text": "grindr", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.423", "deleted": false }, { "id": 36127304, "adGroupId": 36061494, "text": "kawa", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.427", "deleted": false }, { "id": 36127305, "adGroupId": 36061494, "text": "kawa coffee", "status": "ACTIVE", "matchType": "BROAD",
	            "bidAmount": { "amount": "0.01", "currency": "USD" }, "modificationTime": "2017-09-23T08:06:10.431", "deleted": false }],
	          "negativeKeywords": [], "targetingDimensions": { "age": null, "gender": null, "country": null, "adminArea": null, "locality": null,
	            "deviceClass": { "included": ["IPHONE"], "excluded": null }, "daypart": null,
	            "appDownloaders": { "included": [], "excluded": ["1025397186"] } }, "orgId": 379480, "modificationTime": "2017-09-28T11:48:28.666",
	          "status": "ENABLED", "servingStatus": "RUNNING", "servingStateReasons": null, "displayStatus": "RUNNING", "deleted": false }],
	        "budgetOrders": [], "displayStatus": "RUNNING",
	        "startTime": "2017-09-22T16:00:00.000", "endTime": null, "status": "ENABLED", "servingStatus": "RUNNING", "additionalDetail": null,
	        "servingStateReasons": null, "storefront": "US", "modificationTime": "2017-11-05T04:20:16.958", "deleted": false }]
	    };
	    return _this;
	  }
	
	  _createClass(AddCampaign, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ message: '' });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken()
	        // axios.get(`${API_URL}/searchads/campaigns/find`, { headers } )
	        // .then((response)=>{
	        //   // const raw_data = response.data;
	        //   console.log(response.data);
	
	        //   const campaignList = response.data;
	        //   this.setState(
	        //     { campaignList }
	        //   )
	        // })
	      };
	    }
	  }, {
	    key: 'createCampaign',
	    value: function createCampaign() {
	      var _this2 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      console.log(headers);
	
	      _axios2.default.post(_server2.default + '/searchads/campaigns/create/', {}, { headers: headers }).then(function (response) {
	        return _this2.setState({ message: 'asdfsdf' });
	      }).catch(function (error) {
	        return _this2.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'ping',
	    value: function ping() {
	      var _this3 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.get(_server2.default + '/public', { headers: headers }).then(function (response) {
	        return _this3.setState({ message: response.data.message });
	      }).catch(function (error) {
	        return _this3.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'HiItems',
	    value: function HiItems(items) {
	      console.log(items);
	    }
	  }, {
	    key: 'securedPing',
	    value: function securedPing() {
	      var _this4 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.get(_server2.default + '/searchads', { headers: headers }).then(function (response) {
	        return _this4.setState({ message: JSON.parse(response.data.message) });
	      }).catch(function (error) {
	        return _this4.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'getItemsAsync',
	    value: function getItemsAsync(searchValue, cb) {
	      var _this5 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.get(_server2.default + '/searchads/search/apps', { params: { searchValue: searchValue }, headers: headers }).then(function (response) {
	        console.log(response.data);
	        if (response.data != undefined) {
	          var itemData = response.data;
	          console.log(itemData);
	          var items = itemData.map(function (res, i) {
	            return { id: i, value: res.appName + ' ---- ' + res.developerName };
	          });
	          console.log(' items ', items);
	
	          _this5.setState({ repos: items });
	          cb(searchValue);
	        }
	        // this.setState({ message: JSON.parse(response.data.message) })
	      }).catch(function (error) {
	        console.log(error.message);
	        _this5.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e, _ref2) {
	      var newValue = _ref2.newValue;
	
	      this.props.dispatch((0, _actions.setKeyword)(newValue));
	    }
	  }, {
	    key: 'handleSuggest',
	    value: function handleSuggest(_ref3) {
	      var value = _ref3.value;
	
	      this.props.dispatch((0, _actions.requestSuggest)(value));
	    }
	  }, {
	    key: 'handleClear',
	    value: function handleClear() {
	      this.props.dispatch((0, _actions.clearSuggests)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var message = this.state.message;
	      var currentApp = this.props.currentApp;
	
	      console.log('search', this.props.search.toJS());
	
	      var _props$search$toJS = this.props.search.toJS(),
	          suggests = _props$search$toJS.suggests,
	          keyword = _props$search$toJS.keyword;
	
	      var props = {
	        value: keyword,
	        onChange: this.handleChange.bind(this)
	      };
	
	      if (currentApp) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/addCampaign/appId/' + currentApp.adamId });
	      } else {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' });
	      }
	      var isAuthenticated = this.props.auth.isAuthenticated;
	
	
	      return _react2.default.createElement(
	        _style2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Make a Call to the Server ',
	            currentApp
	          ),
	          !isAuthenticated() && _react2.default.createElement(
	            'p',
	            null,
	            'Log in to call a private (secured) server endpoint.'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', onClick: this.ping.bind(this) },
	            'Ping'
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', onClick: this.createCampaign.bind(this) },
	            'Create Campaign'
	          ),
	          ' ',
	          isAuthenticated() && _react2.default.createElement(
	            _reactBootstrap.Button,
	            { bsStyle: 'primary', onClick: this.securedPing.bind(this) },
	            'Call Private'
	          ),
	          _react2.default.createElement(
	            'h2',
	            null,
	            message
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_reactAutosuggest2.default, {
	              suggestions: suggests,
	              onSuggestionsFetchRequested: this.handleSuggest.bind(this),
	              onSuggestionsClearRequested: this.handleClear.bind(this),
	              renderSuggestion: this.renderSuggestion.bind(this),
	              getSuggestionValue: function getSuggestionValue(s) {
	                return s.appName;
	              },
	              inputProps: props,
	              onSuggestionSelected: function onSuggestionSelected(event, data) {
	                console.log(data);
	                _this6.props.history.push('/addCampaign/appId/' + data.suggestion.adamId);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AddCampaign;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    search: state.get('search'),
	    currentApp: state.getIn(['App', 'currentApp'])
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(AddCampaign);

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n\n\n    \n'], ['\n\n\n    \n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CampaignWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(CampaignWrapper);

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .ant-collapse {\n    background-color: transparent;\n    border-radius: 0;\n    border: 0;\n\n    > .ant-collapse-item {\n      background-color: #fff;\n      border-radius: 4px;\n      border: 1px solid ', ';\n      margin-bottom: 5px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      > .ant-collapse-header {\n        height: 42px;\n        line-height: 22px;\n        padding-left: ', ';\n        padding-right: ', ';\n        font-size: 14px;\n        font-weight: 500;\n        color: ', ';\n        cursor: pointer;\n        position: relative;\n        background-color: ', ';\n\n        ', ';\n        ', ';\n\n        .arrow {\n          font-size: 16px;\n          transform: ', ';\n          left: \'16px\';\n          // right: ', ';\n          // left: ', ';\n        }\n\n        &[aria-expanded=\'true\'] {\n          .arrow {\n            font-size: 16px;\n          }\n        }\n      }\n\n      .ant-collapse-content {\n        border-top: 1px solid ', ';\n        ', ';\n\n        p {\n          font-size: 13px;\n          color: ', ';\n          font-family: \'Montserrat\';\n        }\n      }\n\n      &.ant-collapse-item-active {\n        > .ant-collapse-header {\n          .arrow {\n            transform: ', ';\n          }\n        }\n      }\n    }\n\n    &.ant-collapse-borderless {\n      > .ant-collapse-item {\n        border-radius: 0;\n        border: 0;\n\n        > .ant-collapse-header {\n          background-color: ', ';\n          ', ';\n        }\n\n        .ant-collapse-content {\n          border-top: 0;\n          ', ';\n        }\n      }\n    }\n  }\n'], ['\n  .ant-collapse {\n    background-color: transparent;\n    border-radius: 0;\n    border: 0;\n\n    > .ant-collapse-item {\n      background-color: #fff;\n      border-radius: 4px;\n      border: 1px solid ', ';\n      margin-bottom: 5px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n\n      > .ant-collapse-header {\n        height: 42px;\n        line-height: 22px;\n        padding-left: ', ';\n        padding-right: ', ';\n        font-size: 14px;\n        font-weight: 500;\n        color: ', ';\n        cursor: pointer;\n        position: relative;\n        background-color: ', ';\n\n        ', ';\n        ', ';\n\n        .arrow {\n          font-size: 16px;\n          transform: ', ';\n          left: \'16px\';\n          // right: ', ';\n          // left: ', ';\n        }\n\n        &[aria-expanded=\'true\'] {\n          .arrow {\n            font-size: 16px;\n          }\n        }\n      }\n\n      .ant-collapse-content {\n        border-top: 1px solid ', ';\n        ', ';\n\n        p {\n          font-size: 13px;\n          color: ', ';\n          font-family: \'Montserrat\';\n        }\n      }\n\n      &.ant-collapse-item-active {\n        > .ant-collapse-header {\n          .arrow {\n            transform: ', ';\n          }\n        }\n      }\n    }\n\n    &.ant-collapse-borderless {\n      > .ant-collapse-item {\n        border-radius: 0;\n        border: 0;\n\n        > .ant-collapse-header {\n          background-color: ', ';\n          ', ';\n        }\n\n        .ant-collapse-content {\n          border-top: 0;\n          ', ';\n        }\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _styleUtil = __webpack_require__(278);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CollapseStyleWrapper = _styledComponents2.default.div(_templateObject, (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? '32px' : '16px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '16px' : '32px';
	}, (0, _styledTheme.palette)('text', 0), (0, _styledTheme.palette)('grayscale', 6), (0, _styleUtil.transition)(0.4), (0, _styleUtil.borderRadius)('4px 4px 0 0'), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'scale(0.75) rotate(180deg)' : 'scale(0.75) rotate(0)';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? 'auto' : '16px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '16px' : 'auto';
	}, (0, _styledTheme.palette)('border', 0), (0, _styleUtil.borderRadius)('0 0 4px 4px'), (0, _styledTheme.palette)('text', 3), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'scale(0.75) rotate(90deg)' : 'scale(0.75) rotate(90deg)';
	}, (0, _styledTheme.palette)('secondary', 1), (0, _styleUtil.borderRadius)(), (0, _styleUtil.borderRadius)());
	
	exports.default = (0, _withDirection2.default)(CollapseStyleWrapper);

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 1.5rem;\n  align-items: center; \n  margin: 5px 10px;\n'], ['\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 1.5rem;\n  align-items: center; \n  margin: 5px 10px;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n  line-height: 1.5;\n    padding: 0.7rem 1rem;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    // width: 100%;\n    height: 3rem;\n'], ['\n  line-height: 1.5;\n    padding: 0.7rem 1rem;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    // width: 100%;\n    height: 3rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(43);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(40);
	
	var _immutable = __webpack_require__(499);
	
	var _reactTagsinput = __webpack_require__(2881);
	
	var _reactTagsinput2 = _interopRequireDefault(_reactTagsinput);
	
	__webpack_require__(1998);
	
	__webpack_require__(1993);
	
	var _rcSlider = __webpack_require__(2579);
	
	var _rcSlider2 = _interopRequireDefault(_rcSlider);
	
	var _tooltip = __webpack_require__(277);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _collapse = __webpack_require__(1621);
	
	var _collapse2 = _interopRequireDefault(_collapse);
	
	var _lodash = __webpack_require__(129);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _reactFlagsSelect = __webpack_require__(196);
	
	var _reactFlagsSelect2 = _interopRequireDefault(_reactFlagsSelect);
	
	__webpack_require__(185);
	
	var _reactSelect = __webpack_require__(514);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(430);
	
	var _contentHolder = __webpack_require__(215);
	
	var _contentHolder2 = _interopRequireDefault(_contentHolder);
	
	var _AdPreview = __webpack_require__(391);
	
	var _AdPreview2 = _interopRequireDefault(_AdPreview);
	
	var _search = __webpack_require__(578);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _plus_hover = __webpack_require__(3305);
	
	var _plus_hover2 = _interopRequireDefault(_plus_hover);
	
	var _download_green_arrow = __webpack_require__(568);
	
	var _download_green_arrow2 = _interopRequireDefault(_download_green_arrow);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _style = __webpack_require__(1649);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _actions = __webpack_require__(752);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actions3 = __webpack_require__(216);
	
	var _actions4 = _interopRequireDefault(_actions3);
	
	var _redux = __webpack_require__(56);
	
	var _collapse3 = __webpack_require__(1647);
	
	var _collapse4 = _interopRequireDefault(_collapse3);
	
	var _formik = __webpack_require__(436);
	
	var _ButtonAction = __webpack_require__(392);
	
	var _ButtonAction2 = _interopRequireDefault(_ButtonAction);
	
	var _index = __webpack_require__(275);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _tooltip3 = __webpack_require__(3313);
	
	var _tooltip4 = _interopRequireDefault(_tooltip3);
	
	var _country = __webpack_require__(279);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	// -- Resources
	
	
	var Panel = _collapse2.default.Panel;
	var Collapse = function Collapse(props) {
	  return _react2.default.createElement(
	    _collapse4.default,
	    null,
	    _react2.default.createElement(
	      _collapse2.default,
	      props,
	      props.children
	    )
	  );
	};
	
	var GravatarOption = (0, _createReactClass2.default)({
	  propTypes: {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    isDisabled: _propTypes2.default.bool,
	    isFocused: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    onFocus: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    option: _propTypes2.default.object.isRequired
	  },
	  handleMouseDown: function handleMouseDown(event) {
	    event.preventDefault();
	    event.stopPropagation();
	    this.props.onSelect(this.props.option, event);
	  },
	  handleMouseEnter: function handleMouseEnter(event) {
	    this.props.onFocus(this.props.option, event);
	  },
	  handleMouseMove: function handleMouseMove(event) {
	    if (this.props.isFocused) return;
	    this.props.onFocus(this.props.option, event);
	  },
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.className,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove,
	        title: this.props.option.title },
	      _react2.default.createElement(
	        'div',
	        { className: 'app-div-anchor' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('img', { src: this.props.option.options.artworkUrl60 })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          this.props.children
	        )
	      )
	    );
	  }
	});
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var SplitInput = _styledComponents2.default.input(_templateObject2);
	var MyTextInput = function MyTextInput(props) {
	  return _react2.default.createElement(SplitInput, props);
	};
	
	var AddCampaignForm = function (_Component) {
	  _inherits(AddCampaignForm, _Component);
	
	  _createClass(AddCampaignForm, [{
	    key: 'getCountiresData',
	
	
	    //to be redux saga
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(appName) {
	        var API_PUBLIC_SEARCH, response;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                API_PUBLIC_SEARCH = _server2.default + '/searchads/public/search/';
	                _context.prev = 1;
	                _context.next = 4;
	                return _axios2.default.get(API_PUBLIC_SEARCH, { params: { searchValue: appName } });
	
	              case 4:
	                response = _context.sent;
	
	                console.log('[getCountiresData] ', response.data);
	
	                return _context.abrupt('return', response.data);
	
	              case 9:
	                _context.prev = 9;
	                _context.t0 = _context['catch'](1);
	                return _context.abrupt('return', []);
	
	              case 13:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[1, 9]]);
	      }));
	
	      function getCountiresData(_x) {
	        return _ref.apply(this, arguments);
	      }
	
	      return getCountiresData;
	    }()
	  }]);
	
	  function AddCampaignForm(props) {
	    _classCallCheck(this, AddCampaignForm);
	
	    var _this = _possibleConstructorReturn(this, (AddCampaignForm.__proto__ || Object.getPrototypeOf(AddCampaignForm)).call(this, props));
	
	    _this.onSelectFlag = function (countryCode) {
	      _this.props.onCountryCodeUpdated(countryCode);
	    };
	
	    _this.onSelectAsyncChange = function (app) {
	      _this.setState({
	        value: app
	      });
	
	      var _this$state = _this.state,
	          optionList = _this$state.optionList,
	          input = _this$state.input;
	
	      if (optionList && optionList.length > 1) {
	        _this.props.appSelected(app.value, optionList[1].value);
	      } else if (optionList && optionList.length === 1) {
	        _this.props.appSelected(app.value, app.value);
	      } else {
	        _this.props.appSelected(app.value, null);
	      }
	      _this.props.onSearchTermUpdated(input);
	    };
	
	    _this.getApps = function (input) {
	      if (!input) {
	        return Promise.resolve({ options: [] });
	      }
	      _this.setState({ input: input });
	
	      return _axios2.default.get('https://itunes.apple.com/search', { params: { term: input, country: _this.props.countryCode, entity: 'software' } }).then(function (response) {
	        if (response.data) {
	          var itemData = response.data.results;
	          var items = itemData.map(function (item, i) {
	            return {
	              key: i,
	              label: item.trackCensoredName,
	              id: i,
	              value: {
	                adamId: item.trackId,
	                artworkUrl60: item.artworkUrl60,
	                artworkUrl100: item.artworkUrl100,
	                name: item.trackCensoredName,
	                trackCensoredName: item.trackCensoredName,
	                sellerName: item.sellerName,
	                screenshotUrls: item.screenshotUrls,
	                bundleId: item.bundleId
	              },
	              options: item
	            };
	          });
	          // console.log( ' itunes search ' , items );
	
	          _this.setState({ optionList: items });
	          return { options: items };
	        }
	      }).catch(function (error) {
	        console.log(error.message);
	      });
	    };
	
	    _this.state = {
	      request: null,
	      repos: [],
	      adamId: null
	    };
	    return _this;
	  }
	
	  _createClass(AddCampaignForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log('componentDidMount');
	
	      if (this.props.currentApp) {
	        this.retrieveData();
	      } else {
	        console.log('[ current npp not found]', this.props.currentApp);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(prevProps, prevState) {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('componentDidUpdate');
	
	                if (this.props.currentApp && this.props.currentApp.adamId !== prevProps.currentApp.adamId) {
	                  this.retrieveData();
	                } else {}
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidUpdate(_x2, _x3) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'getAppRecord',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(appId) {
	        var getAccessToken, headers, response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                getAccessToken = this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                _context3.prev = 2;
	                _context3.next = 5;
	                return _axios2.default.get(_server2.default + '/user/campaigns/appid/' + appId, { headers: headers });
	
	              case 5:
	                response = _context3.sent;
	
	                console.log('[getAppRecord] ', response.data.response);
	                //dirty fix
	                if (response.data.response) {
	                  this.props.history.push('/dashboard/' + appId);
	                }
	                return _context3.abrupt('return', response.data.response);
	
	              case 11:
	                _context3.prev = 11;
	                _context3.t0 = _context3['catch'](2);
	
	                //no error for this api except network / timeout issue
	                console.log('[getAppRecord] ', _context3.t0);
	                return _context3.abrupt('return', []);
	
	              case 15:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[2, 11]]);
	      }));
	
	      function getAppRecord(_x4) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getAppRecord;
	    }()
	    /*
	    * TODO: This call should also retrieve previous budget split state.
	    */
	
	  }, {
	    key: 'retrieveData',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _props$currentApp, name, sellerName, adamId, appRecord, results;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _props$currentApp = this.props.currentApp, name = _props$currentApp.name, sellerName = _props$currentApp.sellerName, adamId = _props$currentApp.adamId;
	
	                console.log(' update component ', adamId);
	
	                _context4.next = 4;
	                return this.getAppRecord(adamId);
	
	              case 4:
	                appRecord = _context4.sent;
	
	                console.log(' update component ');
	
	                _context4.next = 8;
	                return this.getCountiresData(adamId);
	
	              case 8:
	                results = _context4.sent;
	
	                console.log(results, name, sellerName);
	
	                //adamId of undefinied
	                // let index = _.findIndex( results, result => result.appName === name /*&& result.developerName === sellerName*/ )
	
	
	                if (!(results.length === 0)) {
	                  _context4.next = 13;
	                  break;
	                }
	
	                //adamId not existed? if it does not exist then it is not good for campagin creadtion
	                console.log("adamId : " + adamId + " not found");
	                return _context4.abrupt('return');
	
	              case 13:
	
	                //compare appName and developerName
	                console.log('getCountiresData result', results[0]);
	
	                this.props.updateStorefronts(results[0].storeFrontCountryCodes);
	
	              case 15:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function retrieveData() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return retrieveData;
	    }()
	  }, {
	    key: 'goTo',
	    value: function goTo(route) {
	      this.props.history.push('' + route);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      console.log('currentApp ', this.props.currentApp);
	      var request = this.state.request;
	      var _props = this.props,
	          searchTerm = _props.searchTerm,
	          campaign = _props.campaign,
	          currentApp = _props.currentApp,
	          secondApp = _props.secondApp,
	          countryCode = _props.countryCode,
	          budgetSplit = _props.budgetSplit;
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	
	
	      console.log(' country code : ', countryCode);
	      if (!currentApp) {
	        return _react2.default.createElement('div', null);
	      }
	
	      var formInitialValues = {
	        'selectAllCountries': true,
	        'depositAmount': campaign.get('depositAmount'),
	        'maxCPA': campaign.get('maxCPA'),
	        'currency': campaign.get('currency'),
	        'budgetSplit': budgetSplit,
	        'maxAmountForKeyword': campaign.get('maxAmountForKeyword'),
	        'positiveKeywords': campaign.get('positiveKeywords'),
	        'negativeKeywords': campaign.get('negativeKeywords'),
	        'submitTerms': true,
	        'isEvenlySplit': campaign.get('isEvenlySplit')
	      };
	      console.log(budgetSplit + ' formInitialValues');
	
	      return _react2.default.createElement(
	        _style2.default,
	        { style: { backgroundColor: 'rgba(243, 243, 243, 1)' } },
	        _react2.default.createElement(
	          'style',
	          null,
	          "\
	        .ant-tooltip-content { position: relative; }\
	        .ant-tooltip-inner {\
	          padding: 18px;\
	          padding-bottom: 21px;\
	          background-color: rgba(0, 0, 0, .65);\
	          line-height: 16px;\
	          font-family: 'Montserrat';\
	          font-size: 13px;\
	          font-weight: 300;\
	          color: rgba(255, 255, 255, 1);\
	          letter-spacing: 0.04em;\
	          border-radius: 10px;\
	          text-shadow: 0 0 1px #555;\
	        }\
	        .ant-tooltip-placement-top .ant-tooltip-arrow {\
	          position: absolute;\
	          bottom: 0;\
	          border-top-color: rgba(0, 0, 0, .4);\
	          transform: translateY(100%);\
	        }\
	      "
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'header' },
	          _react2.default.createElement(
	            'div',
	            null,
	            '\u53EA\u9700\u51E0\u6B65\uFF0C\u4F60\u5C31\u80FD\u83B7\u5F97\u4F18\u8D28\u4E0B\u8F7D\u91CF'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(_formik.Formik, {
	            enableReinitialize: true,
	            initialValues: formInitialValues,
	            validate: function validate(values) {
	              var errors = {};
	              if (!values.submitTerms) {
	                errors.submitTerms = 'Required';
	              }
	              return errors;
	            },
	            onSubmit: function onSubmit(values, actions) {
	              console.log('Add campaign form', values, actions);
	
	              var adamId = _this2.props.currentApp.adamId;
	              var orderRequest = Object.assign({}, values, { adamId: adamId });
	              console.log('campaign request to be submitted : ', orderRequest);
	
	              _this2.props.addCampaign(orderRequest);
	              _this2.props.history.push({ pathname: '/addCampaign/confirm', state: { orderRequest: orderRequest } });
	            },
	
	            render: function render(_ref5) {
	              var handleSubmit = _ref5.handleSubmit,
	                  handleChange = _ref5.handleChange,
	                  handleBlur = _ref5.handleBlur,
	                  setFieldValue = _ref5.setFieldValue,
	                  values = _ref5.values,
	                  errors = _ref5.errors,
	                  dirty = _ref5.dirty,
	                  touched = _ref5.touched;
	
	              console.log('form state changes', 'values', values, 'errors', errors, 'dirty', dirty, 'touched', touched);
	
	              return _react2.default.createElement(_formik.FieldArray, { name: 'budgetSplit', render: function render(arrayHelpers) {
	                  return _react2.default.createElement(
	                    'form',
	                    { onSubmit: handleSubmit },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'section__section blackSection' },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'o-wrapper' },
	                        _react2.default.createElement(
	                          _antd.Row,
	                          { style: rowStyle, gutter: 0, justify: 'start' },
	                          _react2.default.createElement(
	                            _antd.Col,
	                            { md: 15, sm: 24, xs: 24, style: colStyle },
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'appDisplay__app-display' },
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'appDisplayImg__app-display' },
	                                _react2.default.createElement('img', { src: currentApp.artworkUrl100, alt: 'screen' })
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                null,
	                                _react2.default.createElement(
	                                  'h1',
	                                  { className: 'appLongName__app-display' },
	                                  currentApp.trackCensoredName
	                                ),
	                                _react2.default.createElement(
	                                  'h2',
	                                  { className: 'appPublisher__app-display' },
	                                  _react2.default.createElement(
	                                    'span',
	                                    null,
	                                    currentApp.sellerName
	                                  )
	                                )
	                              )
	                            )
	                          ),
	                          _react2.default.createElement(
	                            _antd.Col,
	                            { md: 9, sm: 24, xs: 24, style: colStyle },
	                            _react2.default.createElement(_index2.default, {
	                              auth: _this2.props.auth,
	                              goTo: _this2.goTo.bind(_this2),
	                              value: _this2.state.value,
	                              onChange: _this2.onChange,
	                              backspaceRemoves: _this2.state.backspaceRemoves,
	                              placeholder: '\u66F4\u6362APP' })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      null,
	                      '\u9884\u7B97'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'section__section blackSection' },
	                      _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start' },
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 24, sm: 24, xs: 24 },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'inputWrapper' },
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              '\u4F60\u7684\u9884\u7B97\u662F\u591A\u5C11\uFF1F'
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start' },
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 12, sm: 12, xs: 24, style: colStyle },
	                          _react2.default.createElement(
	                            _contentHolder2.default,
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper', style: { marginBottom: '32px' } },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'depositAmount' },
	                                '\u9884\u7B97\u91D1\u989D:',
	                                _react2.default.createElement(
	                                  _tooltip2.default,
	                                  { title: "Your campaign will stop once this has been spent - you can top this up at any time." },
	                                  _react2.default.createElement('img', { src: _tooltip4.default, className: 'tooltip-label' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  '$  '
	                                ),
	                                _react2.default.createElement('input', { type: 'number', name: 'depositAmount', step: '.01', min: '0', value: values.depositAmount, onChange: handleChange })
	                              )
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 12, sm: 12, xs: 24, style: colStyle },
	                          _react2.default.createElement(
	                            _contentHolder2.default,
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'maxCPA' },
	                                '\u76EE\u6807\u83B7\u5BA2\u6210\u672C:',
	                                _react2.default.createElement(
	                                  _tooltip2.default,
	                                  { title: "The most you are willing to pay for a single user to download your app." },
	                                  _react2.default.createElement('img', { src: _tooltip4.default, className: 'tooltip-label' })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(
	                                  'div',
	                                  null,
	                                  '$  '
	                                ),
	                                _react2.default.createElement('input', { type: 'number', name: 'maxCPA', step: '.01', min: '0', value: values.maxCPA, onChange: handleChange })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      values.isEvenlySplit && _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start', className: 'BudgetTC' },
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 24, sm: 24, xs: 24, style: colStyle },
	                          _react2.default.createElement(
	                            'p',
	                            { className: 'budgetText' },
	                            '\u4F60\u7684\u603B\u9884\u7B97\u662F',
	                            '$ ',
	                            _react2.default.createElement(
	                              'span',
	                              { className: 'budget-cost' },
	                              values.depositAmount
	                            ),
	                            '\u7F8E\u91D1\uFF0C \u6211\u4EEC\u7684\u667A\u80FD\u7CFB\u7EDF\u4F1A\u4E3A\u4F60\u7CBE\u51C6\u6295\u653E\u5230\u5404\u4E2A\u53EF\u7528\u5E94\u7528\u5E02\u573A\u3002'
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start', hidden: true },
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 8, sm: 12, xs: 24, style: colStyle },
	                          _react2.default.createElement(
	                            _contentHolder2.default,
	                            null,
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'field' },
	                                _react2.default.createElement(
	                                  'label',
	                                  null,
	                                  'Choose your Currency'
	                                ),
	                                _react2.default.createElement('input', { type: 'text', name: 'currency', value: values.currency, onChange: handleChange })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      values.isEvenlySplit && _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start' },
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 24, sm: 24, xs: 24, style: colStyle },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'budgetSimpleWrapper' },
	                            _react2.default.createElement(
	                              'div',
	                              null,
	                              _react2.default.createElement('input', { type: 'checkbox',
	                                name: 'selectAllCountries',
	                                checked: values.selectAllCountries,
	                                onChange: function onChange(e) {
	
	                                  handleChange(e);
	
	                                  var selectedCountries = [];
	
	                                  values.budgetSplit.forEach(function (budgetItem, index) {
	                                    if (!budgetItem.display) return;
	
	                                    setFieldValue('budgetSplit.' + index + '.selected', e.target.checked);
	                                    if (e.target.checked) {
	                                      selectedCountries.push(index);
	                                    } else {
	                                      setFieldValue('budgetSplit.' + index + '.value', 0);
	                                    }
	                                  });
	
	                                  var storefrontCount = selectedCountries.length;
	                                  var newAmount = +parseFloat(values.depositAmount / storefrontCount).toFixed(2);
	                                  selectedCountries.forEach(function (index) {
	                                    setFieldValue('budgetSplit.' + index + '.value', newAmount);
	                                  });
	                                }
	                              }),
	                              _react2.default.createElement(
	                                'span',
	                                { className: 'allCountryLabel' },
	                                '\u5168\u90E8\u53EF\u6295\u653E\u56FD\u5BB6'
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'ant-row' },
	                              values.budgetSplit.map(function (budgetItem, index) {
	                                var regionCode = budgetItem.key;
	                                var selected = budgetItem.selected;
	
	                                if (!budgetItem.display) {
	                                  return null;
	                                }
	                                return _react2.default.createElement(
	                                  'div',
	                                  { className: 'ant-col-6', key: regionCode },
	                                  _react2.default.createElement('input', {
	                                    type: 'checkbox',
	                                    name: 'budgetSplit.' + index + '.selected',
	                                    checked: budgetItem.selected,
	                                    onChange: function onChange(e) {
	
	                                      handleChange(e);
	
	                                      var selectedCountries = [];
	                                      var isOtherCountriesSameStatus = true;
	
	                                      values.budgetSplit.forEach(function (v, k) {
	                                        if (!v.display || k === index) return;
	
	                                        if (v.selected !== e.target.checked) {
	                                          isOtherCountriesSameStatus = false;
	                                        }
	
	                                        if (v.selected) {
	                                          selectedCountries.push(k);
	                                        }
	                                      });
	
	                                      if (isOtherCountriesSameStatus) {
	                                        setFieldValue('selectAllCountries', e.target.checked);
	                                      } else {
	                                        setFieldValue('selectAllCountries', false);
	                                      }
	
	                                      if (e.target.checked) {
	                                        selectedCountries.push(index);
	                                      }
	
	                                      var storefrontCount = selectedCountries.length;
	                                      var newAmount = +parseFloat(values.depositAmount / storefrontCount).toFixed(2);
	                                      values.budgetSplit.forEach(function (budgetItem, index) {
	                                        if (selectedCountries.indexOf(index) > -1) {
	                                          setFieldValue('budgetSplit.' + index + '.value', newAmount);
	                                        } else {
	                                          setFieldValue('budgetSplit.' + index + '.value', 0);
	                                        }
	                                      });
	                                    }
	                                  }),
	                                  _react2.default.createElement(_reactFlagsSelect2.default, {
	                                    className: 'regionInput',
	                                    defaultCountry: regionCode,
	                                    customLabels: _country.FLAG_LABELS,
	                                    showSelectedLabel: true,
	                                    disabled: true })
	                                );
	                              })
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        Collapse,
	                        { bordered: false, className: 'advanced-settings', onChange: function onChange(key) {
	                            var isEvenlySplit = !(key.indexOf("1") > -1);
	                            setFieldValue('isEvenlySplit', isEvenlySplit);
	
	                            var storefrontCount = values.budgetSplit.filter(function (b) {
	                              return b.selected;
	                            }).length;
	                            var newAmount = +parseFloat(values.depositAmount / storefrontCount).toFixed(2);
	                            if (isEvenlySplit) {
	                              values.budgetSplit.forEach(function (v, k) {
	                                if (v.selected) {
	                                  setFieldValue('budgetSplit.' + k + '.value', newAmount);
	                                } else {
	                                  setFieldValue('budgetSplit.' + k + '.value', 0);
	                                }
	                              });
	                            }
	                          } },
	                        _react2.default.createElement(
	                          Panel,
	                          {
	                            header: _react2.default.createElement(
	                              'div',
	                              { style: { display: 'inline', verticalAlign: 'middle' } },
	                              ' ',
	                              "进阶设定",
	                              ' ',
	                              _react2.default.createElement(
	                                'span',
	                                null,
	                                ' ',
	                                "（选填）",
	                                ' '
	                              ),
	                              ' '
	                            ),
	                            key: '1'
	                          },
	                          _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                              'label',
	                              null,
	                              '\u4F60\u60F3\u5982\u4F55\u5206\u914D\u4F60\u7684\u9884\u7B97\uFF1F'
	                            ),
	                            _react2.default.createElement(
	                              'p',
	                              null,
	                              '\u4F60\u7684\u603B\u9884\u7B97\u662F',
	                              values.depositAmount,
	                              '\u7F8E\u91D1\uFF0C\u8BF7\u6309\u9700\u8981\u5206\u914D\u5230\u5404\u4E2A\u5E94\u7528\u5E02\u573A\u3002'
	                            ),
	                            values.budgetSplit.map(function (budgetItem, index) {
	                              var regionCode = budgetItem.key;
	                              if (!budgetItem.display || !budgetItem.selected) {
	                                return null;
	                              }
	                              // console.log( '[budgetItem]', budgetItem)
	
	                              var percentValue = budgetItem.value / values.depositAmount * 100;
	
	                              // console.log( '[percentValue]', percentValue)
	                              return _react2.default.createElement(
	                                Wrapper,
	                                { key: regionCode },
	                                _react2.default.createElement(_reactFlagsSelect2.default, {
	                                  className: 'regionInput',
	                                  defaultCountry: regionCode,
	                                  customLabels: _country.FLAG_LABELS,
	                                  showSelectedLabel: true,
	                                  disabled: true }),
	                                _react2.default.createElement(_rcSlider2.default, {
	                                  ref: function ref(_ref6) {
	                                    _ref6 && _ref6.sliderRef.getElementsByClassName("rc-slider-track")[0].setAttribute("desc", _ref6.state.value + '%');
	                                    _ref6 && _ref6.sliderRef.setAttribute("desc", _ref6.state.value + '%');
	                                    _ref6 && _ref6.sliderRef.parentElement.setAttribute("desc", _ref6.state.value + '%');
	                                  },
	                                  key: 'slider-' + regionCode,
	                                  min: 0, max: 100,
	                                  value: percentValue,
	                                  step: 1,
	                                  onChange: function onChange(value) {
	
	                                    if (values.budgetSplit.filter(function (v) {
	                                      return v.selected;
	                                    }).length === 1) return; // Can't adjust if only 1 country is selected
	
	                                    var thisAmount = value / 100 * values.depositAmount;
	                                    var deltaAmount = thisAmount - values.budgetSplit[index].value;
	
	                                    console.log('country', values.budgetSplit[index].key, 'this amount', thisAmount, 'delta', deltaAmount);
	
	                                    if (deltaAmount > 0) {
	                                      // Subtract from other storefronts on pro rata basis to compensate the surplus in deposit allocated
	                                      values.budgetSplit.forEach(function (v, k) {
	                                        if (k !== index && v.selected) {
	                                          var newAmount = v.value - deltaAmount;
	                                          if (newAmount < 0) {
	                                            deltaAmount = -newAmount;
	                                            newAmount = 0;
	                                          } else {
	                                            deltaAmount = 0;
	                                          }
	
	                                          newAmount = +parseFloat(newAmount).toFixed(2);
	                                          console.log('update budget item', v.key, v.value, 'new amount', newAmount);
	                                          setFieldValue('budgetSplit.' + k + '.value', newAmount);
	                                        }
	                                      });
	                                    } else {
	                                      // Add surplus to other storefronts so the total remains the same
	                                      var storefrontCount = values.budgetSplit.filter(function (b) {
	                                        return b.selected;
	                                      }).length;
	                                      values.budgetSplit.forEach(function (v, k) {
	                                        if (k !== index && v.selected) {
	                                          var newAmount = v.value + -deltaAmount / (storefrontCount - 1);
	                                          newAmount = +parseFloat(newAmount).toFixed(2);
	                                          console.log('update budget item', v.key, v.value, 'new amount', newAmount);
	                                          setFieldValue('budgetSplit.' + k + '.value', newAmount);
	                                        }
	                                      });
	                                    }
	
	                                    thisAmount = +parseFloat(thisAmount).toFixed(2);
	                                    // console.log('update budget item', index, 'new amount', thisAmount)
	                                    setFieldValue('budgetSplit.' + index + '.value', thisAmount);
	                                  } }),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'inputWrapper' },
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'FormTextInput' },
	                                    _react2.default.createElement(
	                                      'div',
	                                      null,
	                                      '$  '
	                                    ),
	                                    _react2.default.createElement('input', { type: 'number', name: 'budgetSplit.' + index + '.value', min: '0', step: '.01', max: values.depositAmount, value: budgetItem.value, onChange: function onChange(e) {
	
	                                        if (values.budgetSplit.filter(function (v) {
	                                          return v.selected;
	                                        }).length === 1) return; // Can't adjust if only 1 country is selected
	
	                                        var thisAmount = +e.target.value;
	                                        if (thisAmount > values.depositAmount) {
	                                          thisAmount = values.depositAmount;
	                                        }
	                                        var deltaAmount = thisAmount - values.budgetSplit[index].value;
	
	                                        console.log('country', values.budgetSplit[index].key, 'this amount', thisAmount, 'delta', deltaAmount);
	
	                                        if (deltaAmount > 0) {
	                                          // Subtract from other storefronts on pro rata basis to compensate the surplus in deposit allocated
	                                          values.budgetSplit.forEach(function (v, k) {
	                                            if (k !== index && v.selected) {
	                                              var newAmount = v.value - deltaAmount;
	                                              if (newAmount < 0) {
	                                                deltaAmount = -newAmount;
	                                                newAmount = 0;
	                                              } else {
	                                                deltaAmount = 0;
	                                              }
	
	                                              newAmount = +parseFloat(newAmount).toFixed(2);
	                                              console.log('update budget item', v.key, v.value, 'new amount', newAmount);
	                                              setFieldValue('budgetSplit.' + k + '.value', newAmount);
	                                            }
	                                          });
	                                        } else {
	                                          // Add surplus to other storefronts so the total remains the same
	                                          var storefrontCount = values.budgetSplit.filter(function (b) {
	                                            return b.selected;
	                                          }).length;
	                                          values.budgetSplit.forEach(function (v, k) {
	                                            if (k !== index && v.selected) {
	                                              var newAmount = v.value + -deltaAmount / (storefrontCount - 1);
	                                              newAmount = +parseFloat(newAmount).toFixed(2);
	                                              console.log('update budget item', v.key, v.value, 'new amount', newAmount);
	                                              setFieldValue('budgetSplit.' + k + '.value', newAmount);
	                                            }
	                                          });
	                                        }
	
	                                        thisAmount = +parseFloat(thisAmount).toFixed(2);
	                                        // console.log('update budget item', index, 'new amount', thisAmount)
	                                        setFieldValue('budgetSplit.' + index + '.value', thisAmount);
	                                      } })
	                                  )
	                                )
	                              );
	                            }),
	                            _react2.default.createElement(
	                              _antd.Row,
	                              { style: rowStyle, gutter: 0, justify: 'start' },
	                              _react2.default.createElement(
	                                _antd.Col,
	                                { md: 24, sm: 24, xs: 24 },
	                                _react2.default.createElement(
	                                  'p',
	                                  null,
	                                  '\u6709\u54EA\u4E9B\u7279\u5B9A\u5173\u952E\u8BCD\u4F60\u5E0C\u671B\u52A0\u5165\u7ADE\u4EF7\uFF1F'
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _antd.Col,
	                                { md: 8, sm: 12, xs: 24, style: colStyle },
	                                _react2.default.createElement(
	                                  _contentHolder2.default,
	                                  null,
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'inputWrapper' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      '\u6DFB\u52A0\u7279\u5B9A\u5173\u952E\u8BCD:',
	                                      _react2.default.createElement(
	                                        _tooltip2.default,
	                                        { title: "You don't need to add any keywords here unless you sure they are more valuable to you." },
	                                        _react2.default.createElement('img', { src: _tooltip4.default, className: 'tooltip-label' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(_reactTagsinput2.default, {
	                                      onKeyPress: function onKeyPress(e) {
	                                        if (e.key === 'Enter') e.preventDefault();
	                                      },
	                                      value: values.positiveKeywords,
	                                      onChange: function onChange(tags) {
	                                        setFieldValue('positiveKeywords', tags);
	                                      } }),
	                                    _react2.default.createElement('img', { src: _plus_hover2.default })
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _antd.Col,
	                                { md: 8, sm: 12, xs: 24, style: colStyle },
	                                _react2.default.createElement(
	                                  _contentHolder2.default,
	                                  null,
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'inputWrapper' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      { htmlFor: 'maxAmountForKeyword' },
	                                      '\u6700\u9AD8\u6D88\u8D39\u91D1\u989D\u9650\u5236:',
	                                      _react2.default.createElement(
	                                        _tooltip2.default,
	                                        { title: "The maximum amount you are willing to pay for a customer for these keywords." },
	                                        _react2.default.createElement('img', { src: _tooltip4.default, className: 'tooltip-label' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      'div',
	                                      { className: 'FormTextInput' },
	                                      _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        '$  '
	                                      ),
	                                      _react2.default.createElement('input', { type: 'number', name: 'maxAmountForKeyword', step: '.01', min: '0', value: values.maxAmountForKeyword, onChange: handleChange })
	                                    )
	                                  )
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _antd.Col,
	                                { md: 8, sm: 12, xs: 24, style: colStyle },
	                                _react2.default.createElement(
	                                  _contentHolder2.default,
	                                  null,
	                                  _react2.default.createElement(
	                                    'div',
	                                    { className: 'inputWrapper' },
	                                    _react2.default.createElement(
	                                      'label',
	                                      null,
	                                      '\u6DFB\u52A0\u5426\u5B9A\u5173\u952E\u8BCD:',
	                                      _react2.default.createElement(
	                                        _tooltip2.default,
	                                        { title: "The negative keywords that you don't want your app to show up for." },
	                                        _react2.default.createElement('img', { src: _tooltip4.default, className: 'tooltip-label' })
	                                      )
	                                    ),
	                                    _react2.default.createElement(_reactTagsinput2.default, {
	                                      onKeyPress: function onKeyPress(e) {
	                                        if (e.key === 'Enter') e.preventDefault();
	                                      },
	                                      value: values.negativeKeywords,
	                                      onChange: function onChange(tags) {
	                                        setFieldValue('negativeKeywords', tags);
	                                      } }),
	                                    _react2.default.createElement('img', { src: _plus_hover2.default })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement('div', { className: _this2.props.className }),
	                      _react2.default.createElement(
	                        _antd.Row,
	                        { style: rowStyle, gutter: 0, justify: 'start' },
	                        _react2.default.createElement(
	                          _antd.Col,
	                          { md: 24, sm: 24, xs: 24, style: colStyle },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'campaign-holder' },
	                            _react2.default.createElement(
	                              _antd.Row,
	                              { style: rowStyle, gutter: 0, justify: 'start' },
	                              _react2.default.createElement(
	                                _antd.Col,
	                                { md: 10, sm: 24, xs: 24, style: colStyle },
	                                _react2.default.createElement(
	                                  _contentHolder2.default,
	                                  null,
	                                  _react2.default.createElement(_AdPreview2.default, {
	                                    currentApp: currentApp,
	                                    secondApp: secondApp,
	                                    searchTerm: searchTerm
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement(
	                                _antd.Col,
	                                { md: 14, sm: 24, xs: 24, style: colStyle },
	                                _react2.default.createElement(
	                                  'button',
	                                  { className: 'btn-create-campaign', type: 'submit' },
	                                  '\u521B\u5EFA\u5EE3\u544A\u9805\u76EE',
	                                  _react2.default.createElement('img', { src: _download_green_arrow2.default, alt: 'down-green-arrow' })
	                                ),
	                                _react2.default.createElement(
	                                  'div',
	                                  { className: 'submit-terms' },
	                                  _react2.default.createElement('input', { type: 'checkbox', id: 'submitTerms', checked: values.submitTerms, onChange: handleChange }),
	                                  _react2.default.createElement(
	                                    'label',
	                                    { htmlFor: 'submitTerms' },
	                                    '\u52FE\u9009\u8FD9\u4E2A\u9879\u76EE\u8868\u793A\u4F60\u540C\u610F\u6211\u4EEC\u5411\u4F60\u53D1\u653E\u6700\u65B0\u8D44\u8BAF\u53CA\u4F18\u60E0\u3002'
	                                  ),
	                                  errors.submitTerms && touched.submitTerms ? _react2.default.createElement(
	                                    'small',
	                                    null,
	                                    'Please confirm to proceed.'
	                                  ) : _react2.default.createElement('small', null),
	                                  _react2.default.createElement(
	                                    'div',
	                                    null,
	                                    '\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610FProject X\u5E73\u53F0',
	                                    _react2.default.createElement(
	                                      'a',
	                                      { href: '#' },
	                                      '\u670D\u52A1\u534F\u8BAE'
	                                    ),
	                                    '.'
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  );
	                } });
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return AddCampaignForm;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    appSelected: (0, _redux.bindActionCreators)(_actions4.default.appSelected, dispatch),
	    onSearchTermUpdated: function onSearchTermUpdated(searchTerm) {
	      return dispatch(_actions4.default.searchTermUpdated(searchTerm));
	    },
	    onSearchAdsResultLocated: function onSearchAdsResultLocated(searchAppResult) {
	      return dispatch(_actions2.default.setSelectedResult(searchAppResult));
	    },
	    onCountryCodeUpdated: function onCountryCodeUpdated(countryCode) {
	      return dispatch(_actions4.default.countryCodeUpdated(countryCode));
	    },
	    updateScrollValue: function updateScrollValue(model, value) {
	      return dispatch(_immutable.actions.change(model, value));
	    },
	    updateStorefronts: function updateStorefronts(storefonts) {
	      dispatch({
	        type: 'UPDATE_STOREFRONTS',
	        value: storefonts
	      });
	    },
	    addCampaign: function addCampaign(campaign) {
	      dispatch({
	        type: 'ADD_CAMPAIGN',
	        value: campaign
	      });
	    }
	  };
	}
	function mapStateToProps(state) {
	  return {
	    search: state.get('search'),
	    campaign: state.get('campaign'),
	    budgetSplit: state.getIn(['campaign', 'budgetSplit']),
	    currentApp: state.getIn(['ItunesSearch', 'currentApp']),
	    secondApp: state.getIn(['ItunesSearch', 'secondApp']),
	    searchTerm: state.getIn(['ItunesSearch', 'searchTerm']),
	    countryCode: state.getIn(['ItunesSearch', 'countryCode']) && 'US'
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AddCampaignForm);

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .blackSection {\n        // background: #333333;\n        // color: #fff;\n        position: relative;\n        z-index: 12;\n\n        .appDisplay__app-display {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center; }\n    }\n    .o-wrapper {\n        padding-top: 16px;\n\n        max-width: 1020px;\n        padding-right: 1.5rem;\n        padding-left: 1.5rem;                                  \n        margin-right: auto;\n        margin-left: auto; }\n        @media (min-width: 768px) {\n        .o-wrapper {\n            padding-right: 40px;\n            padding-left: 40px; } }\n        @media (min-width: 1281px) {\n        .o-wrapper {\n            max-width: 1120px;\n            padding-right: 1.5rem;\n            padding-left: 1.5rem; } }\n\n    .appDisplayImg__app-display {\n        padding-right: 0.75rem; }\n        .appDisplayImg__app-display > img {\n        border: 1px solid #D8D8D8;\n        width: 3.25rem;\n        height: 3.25rem;\n        max-width: none;\n        border-radius: 1rem; }\n        @media (min-width: 480px) {\n        .appDisplayImg__app-display {\n            padding-right: 1.5rem; }\n            .appDisplayImg__app-display > img {\n            width: 4.25rem;\n            height: 4.25rem; } }\n  \n    .appName__app-display,\n    .appLongName__app-display {\n        margin-top: 0px;\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        color: rgba(64, 55, 57, 1);;\n        text-align: left;\n        letter-spacing: 0.09em;\n        font-size: 22px;\n        font-weight: 300;\n\n    }\n  \n    .appPublisher__app-display {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.07em;\n        margin-top: 8px;\n    }\n    .appPublisher__app-display > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    @media (min-width: 480px) {\n        .appPublisher__app-display {\n        font-size: 1.2rem; } }\n  \n    .appDisplayConcise__app-display .appDisplayImg__app-display {\n         padding-right: 0.75rem; }\n    .appDisplayConcise__app-display .appDisplayImg__app-display > img {\n        width: 36px;\n        height: 36px;\n        border-radius: 5px; }\n\n\n\n    \n\n    .inputWrapper {\n        padding-left: 10px;\n        // padding-right: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            max-width: 213px;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            display: -webkit-inline-box;\n    \n            div {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n    \n            input[type=number], input[type=text] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n                width: 3px;\n                border-left: 1px solid rgba(151, 151, 151, 1);\n            }\n            \n        }\n        \n        .react-tagsinput {\n            width: 213px;\n            border: 1px solid rgba(151,151,151,1);\n            border-radius: 20px;\n            display: -webkit-inline-box;\n\n            span {\n                padding-left: 10px;\n                font-family: \'Montserrat-Light\';\n                font-size: 16px;\n                margin: 2px;\n            }\n        }\n    \n        label {\n            width: 213px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .regionInput{\n          display: inline-block;\n          .country-flag img{\n            top: 0;\n          }\n\n          span{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n          }\n        }\n    .isoInputWrapper {\n        margin-bottom: 15px;\n        justify-content: center;\n        align-items: center;\n        vertical-align: center;\n        display: flex;\n        border: 1px solid rgba(147, 147, 147, 1);\n        border-radius: 20px;\n\n        &:last-of-type {\n          margin-bottom: 0;\n        }\n        .searchIcon{\n            position: absolute;\n            top: 50%; right: 11px;\n            width: 18px;\n            height: 18px;\n            transform: translateY(-50%);\n        }\n      \n        .searchInput{\n          width: 250px;\n          display: inline-block;\n\n          .Select-control {\n            border: none;\n            background-color: rgba(0,0,0,0.1);\n\n            .Select-input:focus {\n                background: rgba(255, 255, 255, 1);\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                color: rgba(147, 147, 147, 1);\n                text-align: justify;\n                letter-spacing: 0.04em;\n            }\n          }\n          .Select-placeholder {\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n          .Select-value{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n\n          input{\n            border: none;\n          }\n          \n        }\n       \n    }\n\n\n\n\n\n    .exampleHolder > div {\n        margin-left: auto;\n        margin-right: auto; \n    }\n    @media (min-width: 768px) {\n        .exampleHolder {\n        position: absolute;\n        width: 80%;\n        right: 0;\n        } \n    }\n    \n    @media (min-width: 850px) {\n        .exampleHolder {\n            width: 100%; \n        } \n    }\n\n    .budgetText{\n        font-family: \'Montserrat\';\n        font-size: 10px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.04em;\n        line-height: 18px;\n    }\n    \n    .react-tagsinput-tag{\n        background-color: transparent;\n        1px solid rgba(147, 147, 147, 1);\n    }\n\n    .isoWidgetsWrapper{\n\n        margin-left: auto;\n        margin-right: auto;\n        height: 487px;\n        width: 343px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n    .footer {\n        background-color: rgba(35, 31, 32, 1);\n        padding: 17px;\n        .footerTitle{\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(255, 255, 255, 1);\n            text-align: center;\n            letter-spacing: 0.07em;\n        }\n    }\n\n    .budgetSimpleWrapper{\n        .allCountryLabel{\n            padding: 0 8px;\n            font-family: \'Roboto\';\n            color: rgba(64,55,57,1);\n        }\n        .country-label{\n            font-family: \'Roboto\';\n            font-size: 12px;\n            color: rgba(64,55,57,1);\n        }\n    }\n    \n    // -- Simpliefed modification by Tom\n    \n\n    \n    // -- Zay modification\n    .header {\n        margin-bottom: 36px;\n        position:relative;\n        background-color: rgba(35, 31, 32, 1);\n        padding: 29px;\n        .greenLogo{\n            margin-left: auto;\n            margin-right: auto;    \n            height: 77px;\n            width: 118px;\n        }\n\n        .greenLogo { height: auto; }\n        \n        *:last-child {\n            // margin-top: 34px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            font-weight: 300;\n            color: rgba(219, 219, 219, 1);\n            text-align: center;\n            letter-spacing: 0.08em;\n        }\n    }\n    .header:after {\n        position: absolute;\n        display: inline-block;\n        content: \'\';\n        right: 0; bottom: -3px; left: 0;\n        height: 3px;\n        background-color: rgba(12, 183, 148, 1);\n    }\n    \n    .container {\n        margin-bottom: 42px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n        .container > form > .blackSection:first-child { z-index: 13; }\n        .container form > * { margin: 0 -15px; }\n        .container form > .blackSection { background-color: rgba(249, 249, 249, 1); }\n            .container .o-wrapper { max-width: auto; max-width: unset; max-width: none; }\n            .container .o-wrapper { min-height: 160px; padding-top: 42px; padding-right: 39px; padding-left: 45px; }\n                .container .o-wrapper .appDisplay__app-display h1 { text-transform: uppercase; }\n                .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select {\n                    padding-bottom: 0;\n                    border-right: 1px solid rgba(151, 151, 151, 1);\n\n                    span.country-flag {\n                        display: inline-block;\n                        width: auto !important;\n                        height: auto !important;\n                        line-height: 38px;\n\n                        img { width: auto; height: 1.5em; }\n                        img + span { display: inline-block; line-height: 1.5em; }\n                    }\n                }\n                .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select + .searchInput {\n                    width: 55%;\n                    .Select-control {\n                        position: relative;\n                        background-color: transparent;\n                        line-height: 38px;\n\n                        > *, .Select-placeholder { display: inline-block; line-height: 38px; }\n                        .Select-placeholder { position: absolute; top: 0; right: 0; left: 0; }\n                        .Select-input { display: block !important; height: 38px; }\n                        .Select-loading-zone { position: absolute; right: 20px; }\n                        .Select-arrow-zone { display: none; }\n                        input:focus, input:active { outline-width: 0; }\n\n                        > * > div { line-height: 38px; }\n                        input { width: auto !important; padding: 0; line-height: 38px; }\n                    }\n                }\n                .container .o-wrapper .isoSignInForm .isoInputWrapper {\n                    .flag-select + .Select.is-focused:not(.is-open) > .Select-control {\n                        box-shadow: none;\n                    }\n                }\n\n                .container .o-wrapper .isoSignInForm {\n                    max-width: 300px;\n                    float: right;\n\n                    .isoInputWrapper {\n                        height: 40px;\n\n                        .searchInput {\n                            height: 40px;\n                            line-height: 40px;\n\n                            .Select-control,\n                            .Select-multi-value-wrapper,\n                            .Select-placeholder,\n                            .Select-input,\n                            input {\n                                display: inline-block;\n                                height: 40px;\n                                line-height: 40px;\n                            }\n\n                            .Select-value { padding-right: 74px; }\n                            .Select-clear-zone { position: absolute; top: 50%; right: 4px; transform: translateY(-50%); }\n                        }\n                    }\n                    \n                    .Select-menu-outer {\n                      top: auto; right: -19px; bottom: 0; left: -1px;\n                      width: auto;\n                      transform: translateY(100%);\n                      background-color: rgba(255, 255, 255, .5);\n      \n                      .Select-option {\n                        height: 64px;\n                        padding: 12px; 2px;\n                        \n                        .app-div-anchor {\n                            display: flex;\n                            justify-content: flex-start !important;\n                            align-items: center;\n\n                            div {\n                                img {\n                                    display: inline-block;\n                                    margin: 0; padding: 0;\n                                    width: 40px; height: 40px;\n                                    border-radius: 3px;\n                                }\n                                :first-child { flex-basis: 40px; width: 40px; min-width: 40px; }\n                                :last-child {\n                                    flex-grow: 1;\n                                    padding-right: 2px;\n                                    padding-left: 11px;\n                                    text-align: left;\n                                    white-space: nowrap;\n                                    overflow: hidden;\n                                    text-overflow: ellipsis;\n                                }\n                            }\n                        }\n                      }\n                    }\n                }\n        .container .blackSection:first-child ~ * { padding-right: 50px; padding-left: 64px; }\n        .container .blackSection:first-child + div {\n            line-height: 60px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-transform: uppercase;\n        }\n\n        .container .blackSection ~ .blackSection {\n            padding-top: 24px;\n\n            > div:first-child {\n                margin-bottom: 20px;\n\n                + div > div { margin-bottom: 0 !important; }\n            }\n            .isoExampleWrapper {\n                margin-top: 0;\n                input { background-color: transparent; }\n                input:focus, input:active { outline-width: 0; }\n            }\n\n            .inputWrapper {\n                padding: 0;\n                text-align: left;\n                \n                img {\n                    width: 16px;\n                }\n\n                // label {\n                //     margin-bottom: 8px;\n                //     display: block;\n                //     width: auto;\n\n                //     span {\n                //         display: inline-block;\n                //         margin-left: 4px;\n                //         border: 1px solid rgba(147, 147, 147, 1);\n                //         border-radius: 100%;\n                //         width: 14px; height: 14px;\n                //         line-height: 14px;\n                //         font-family: \'Montserrat\';\n                //         text-align: center;\n                //         font-size: .7em;\n                //         color: rgba(147, 147, 147, 1);\n                //     }\n                // }\n\n                .FormTextInput {\n                    margin-left: -7px;\n                    padding-right: 4px;\n\n                    > :first-child { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }\n                }\n            }\n            \n            .BudgetTC p { margin-top: 29px; margin-bottom: 39px; font-size: 11px; color: rgba(64, 55, 57, 1); }\n\n            .advanced-settings {\n                margin-right: -50px;\n                margin-left: -64px;\n\n                .ant-collapse-header {\n                    height: 60px;\n                    padding: 0 50px 0 64px;\n                    background-color: rgba(252, 252, 252, 1);\n                    line-height: 60px;\n                    font-family: \'Montserrat\';\n                    color: rgba(64, 55, 57, 1);\n                    letter-spacing: 0.08em;\n\n                    .arrow { line-height: 60px; float: right; }\n                    .arrow + div {\n                        font-size: 14px;\n                        font-weight: 700;\n                        text-transform: uppercase;\n                        letter-spacing: 0.08em;\n\n                        @media screen and (max-width: 767px) { letter-spacing: 0.04em; }\n\n                        span { color: rgba(147, 147, 147, 1); }\n                    }\n                }\n\n                .ant-collapse-item { background-color: transparent; }\n                .ant-collapse-content {\n                    background-color: rgba(219, 219, 219, 0.35);\n                    padding: 0 50px 0 64px;\n\n                    label:first-child {\n                        margin-top: 23px;\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.04em;\n                    }\n\n                    label:first-child + p { font-family: \'Montserrat\'; font-size: 11px; margin-bottom: 17px; }\n\n                    label ~ div {\n                        margin: 0; margin-bottom: 27.5px; margin-left: -10px;\n\n                        .regionInput {\n                            position: relative;\n                            margin: 0;\n                            padding: 0;\n                            border-radius: 20px;\n                            width: 101px;\n                            background-color: #fff;\n                            line-height: 41px;\n                            text-align: center;\n\n                            img { width: 24px; height: 18px; }\n                            .country-label {\n                                width: 17px;\n                                line-height: 16px;\n                                font-family: \'Roboto\';\n                                font-size: 12px;\n                                color: rgba(64, 55, 57, 1);\n                                letter-spacing: 0.04em;\n                            }\n                        }\n                        &[desc=\'0%\'] > .regionInput:after {\n                            position: absolute;\n                            top: 0; right: 0; bottom: 0; left: 0;\n                            display: inline-block;\n                            content: \'\';\n                            border-radius: 20px;\n                            background-color: rgba(216, 216, 216, 0.6);\n                        }\n\n                        .rc-slider {\n                            width: 60%;\n                            margin-left: 11px;\n                            margin-right: 37px;\n\n                            .rc-slider-rail { height: 2px; }\n                            .rc-slider-track { border-width: 2px; border-color: rgba(60, 211, 207, 1); height: 2px; }\n                                .rc-slider-track:after {\n                                    position: absolute;\n                                    top: 50%; right: 0;\n                                    display: inline-block;\n                                    content: attr(desc);\n                                    border: 1px solid rgba(0, 0, 0, .1);\n                                    border-radius: 31px;\n                                    background-color: rgba(255, 255, 255, 1);\n                                    width: 31px; height: 31px;\n                                    line-height: 31px;\n                                    text-align: center;\n                                    font-family: \'Montserrat\';\n                                    font-size: 10px;\n                                    font-weight: 300;\n                                    color: rgba(64, 55, 57, 1);\n                                    letter-spacing: 0.04em;\n                                    transform: translateX(50%) translateY(-50%);\n                                    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.17);\n                                }\n                                .rc-slider-track[desc=\'0%\']:after { right: -10px; content: \'\'; }\n                            [role="slider"] { opacity: 0; }\n                        }\n\n                        .rc-slider ~ .inputWrapper {\n                            input { background-color: transparent; }\n                            input:focus, input:active { outline-width: 0; }\n                        }    \n\n                        [desc=\'0%\'] ~ .inputWrapper {\n                            .FormTextInput {\n                                border-color: rgba(216, 216, 216, 0.6);\n                                \n                                * { color: rgba(216, 216, 216, 0.6); }\n                                input { border-color: rgba(216, 216, 216, 0.6); }\n                            }\n                        }\n                    }\n\n                    > .ant-collapse-content-box { margin-bottom: 0; }\n                    label ~ div:last-child { margin-bottom: 0; }\n                }\n\n                .tagInputWrapper{\n                    margin: 0 -50px 0 -64px;\n                    width: auto !important;\n                    background-color: rgba(219, 219, 219, 0.35);\n                    padding: 0 50px 0 64px;\n                }\n                .inputWrapper {\n                    position: relative;\n                    margin: 0; padding: 0;\n                    \n                    label ~ .react-tagsinput {\n                        margin: 0; margin-left: -7px;\n                        padding: 0;\n                        background-color: transparent;\n                        line-height: 41px;\n\n                        span { padding: 0; margin-left: 21px; }\n\n                        + img {\n                            position: absolute;\n                            bottom: 15px;\n                            width: 20px;\n                            height: 19px;\n                            line-height: 19px;\n                            transform: translateX(-44px);\n                        }\n                    }\n                    input { \n                        font-family: \'Montserrat-Light\';\n                        font-size: 16px;\n                        margin: 0; \n                        margin-left: 21px;\n                        border-width: 0; \n                        background-color: \n                        transparent; padding: 0; \n                        line-height: 41px; \n                    }\n                    input:focus, input:active { outline-width: 0; }\n                    label ~ .FormTextInput input { border-left-width: 1px; padding-left: 14px; }\n                }\n            }\n\n            > :last-child, > :nth-last-child(2) {\n                margin: 0 -50px 0 -64px;\n                width: auto !important;\n                background-color: rgba(219, 219, 219, 0.35);\n                padding: 0 50px 0 64px;\n\n               \n            }\n\n            > :nth-last-child(2) {\n                p:first-child {\n                    margin-top: 25px;\n                    margin-bottom: 16px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(64, 55, 57, 1);\n                    letter-spacing: 0.04em;\n                }\n            }\n\n            > :last-child {\n                background-color: rgba(255, 255, 255, 1);\n\n                .campaign-holder {\n                    margin-top: 19px;\n                    margin-bottom: 42px;\n                    border: 1px solid rgba(170, 170, 170, 0.5);\n                    padding: 20px 10%;\n\n                    .isoExampleWrapper {\n                        margin: 0;\n                        .exampleHolder {\n                            position: relative;\n\n                            // .searchTerm__ad-example { top: 9.5%; left: 19.2%; }\n                            // .container__ad-example { top: 15.4%; width: 87.5%; }\n                        }\n                    }\n                    .btn-create-campaign {\n                        margin-top: 86px;\n                        margin-left: 65px;\n                        max-width: 270px;\n                        width: 100%;\n                        padding: 0;\n                        background-color: rgba(60, 211, 207, 1);\n\n                        line-height: 38px;\n                        font-family: \'Montserrat\';\n                        font-size: 15px;\n                        color: rgba(255, 255, 255, 1);\n                        text-align: center;\n                        letter-spacing: 0.01em;\n                        border-radius: 20px;\n\n                        img {\n                            height: 18px;\n                            transform: rotate(90deg) translateY(-14px);\n                            filter: brightness(0) invert(1);\n                        }\n                    }\n\n                    .btn-create-campaign + * {\n                        margin-top: 20px;\n                        margin-left: 65px;\n                        padding: 0;\n\n                        input[type=\'checkbox\'] {\n                            position: absolute;\n                            margin-left: -10px;\n                            transform: translateX(-100%);\n                        }\n\n                        label {\n                            margin: 0;\n                            line-height: 18px;\n                            font-family: \'Montserrat\';\n                            font-size: 12px;\n                            font-weight: 300;\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n\n                            + small {\n                                margin-top: 3px;\n                                font-family: \'Roboto\';\n                                font-size: 10px;\n                                color: rgba(221, 66, 85, 1);\n\n                                + div {\n                                    margin-top: 27px;\n                                    line-height: 18px;\n                                    font-family: \'Montserrat\';\n                                    font-size: 12px;\n                                    font-weight: 300;\n                                    color: rgba(64, 55, 57, 1);\n                                    letter-spacing: 0.04em;\n\n                                    a {\n                                        line-height: 18px;\n                                        font-family: \'Montserrat\';\n                                        font-size: 12px;\n                                        font-weight: 300;\n                                        color: rgba(60, 211, 207, 1);\n                                        letter-spacing: 0.04em;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        \n        @media screen and (max-width: 767px) {\n            .container {\n                margin-right: 16px;\n                margin-left: 16px;\n\n                .o-wrapper {\n                    padding-top: 12px; padding-right: 32px; padding-left: 17px;\n\n                    .appDisplay__app-display img { width: 85px; height: auto; }\n                }\n\n                .blackSection:first-child + div { padding-left: 21px; }\n                .blackSection:first-child ~ .blackSection {\n                    padding-right: 24px;\n                    padding-left: 11px;\n\n                    .inputWrapper .FormTextInput { margin-left: 0; }\n\n                    > div:first-child { margin-bottom: 16px; }\n                    > div:first-child + div {\n                        > *:not(:first-child) { margin-top: 25px; }\n                    }\n\n                    .advanced-settings {\n                        margin-right: -24px; margin-left: -11px;\n                        .ant-collapse-header { padding-left: 21px; }\n                        .ant-collapse-content {\n                            padding-top: 9px;\n                            padding-right: 11px;\n                            padding-left: 12px;\n\n                            label ~ div {\n                                margin-left: 0;\n                                flex-wrap: wrap;\n\n                                .flag-select { min-width: 101px; }\n                                .rc-slider { margin-top: 29px; margin-bottom: 28px; width: 100%; }\n                            }\n\n                            label ~ div:not(:last-child) { margin-bottom: 50px; }\n                        }\n                    }\n\n                    > :nth-last-child(2) {\n                        margin-right: -24px;\n                        margin-left: -11px;\n                        padding-right: 11px;\n                        padding-left: 12px;\n\n                        > *:not(:first-child) {\n                            margin-bottom: 31px !important;\n                            padding-left: 8px;\n\n                            label + * { margin-left: 0; }\n                        }\n                        > *:last-child { margin-bottom: 42px; }\n                    }\n\n                    > :last-child {\n                        margin-right: -24px;\n                        margin-left: -11px;\n                        padding-right: 11px;\n                        padding-left: 12px;\n\n                        .campaign-holder {\n                            margin-top: 23px;\n\n                            .adExample__ad-example.adExampleFull__ad-example { margin-top: 0; }\n                            .btn-create-campaign { margin: 0; margin-top: 25px; max-width: none; }\n                            .submit-terms {\n                                margin-left: 17px;\n                                \n                                input[type=\'checkbox\'] { margin-left: -3px; }\n                                > *:last-child { margin-left: -20px; }\n                            }\n                        }\n                    }\n                    // -- .blackSection:first-child ~ .blackSection\n                }\n                // -- .container\n            }\n        }\n        // @media screen and (min-width: 768px) {\n        //     .container .o-wrapper { padding-top: 42px; }\n        //     .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select + .searchInput { width: 70%; }\n            \n        //     .container .blackSection:first-child ~ * { padding-right: 25px; padding-left: 32px; }\n        // }\n        // @media screen and (min-width: 1200px) {\n        //     .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select { margin-left: -28px; }\n        // }\n\n        // @media screen and (max-width: 767px) {\n        //     .regionInput { width: 30%; }\n        //     .rc-slider { width: 50%; }\n        //     .rc-slider + .inputWrapper { margin-top: 10px; width: 100%; text-align: right; }\n        // }                    \n        \n        // @media screen and (min-width: 992px) {\n        //     .campaign-holder { padding: 20px 95px 20px 97px; }\n        // }\n        // @media screen and (max-width: 991px) {\n        //     .campaign-holder {\n        //         button { margin-top: 43px !important; }\n        //         button, button ~ * { margin-left: 32px !important; }\n        //     }\n        // }\n        // @media screen and (max-width: 767px) {\n        //     .campaign-holder {\n        //         .adExample__ad-example.adExampleFull__ad-example { margin-top: 5%; }\n\n        //         button, button ~ * { margin-left: 0 !important; }\n        //         .submit-terms input[type=\'checkbox\'] { margin-left: -3px; }\n        //     }\n        // }\n    // -- /.Zay modification\n\n    .searchTerm__ad-example { top: 72px !important; }\n    .tooltip-label { margin-left: 4px; width: 17px; }\n\n    @media screen and (max-width: 767px) {\n        .searchTerm__ad-example { top: 10.2% !important; }\n    }\n\n    @media screen and (min-width: 768px) {\n        .searchTerm__ad-example { top: 58px !important; }\n    }\n    \n    @media screen and (min-width: 850px) {\n        .searchTerm__ad-example { top: 40px !important; }\n    }\n    \n    @media screen and (min-width: 992px) {\n        .searchTerm__ad-example { top: 57px !important; }\n    }\n\n    @media screen and (min-width: 1199px) {\n        .searchTerm__ad-example { top: 72px !important; }\n    }\n\n\n\n    \n\n\n'], ['\n    .blackSection {\n        // background: #333333;\n        // color: #fff;\n        position: relative;\n        z-index: 12;\n\n        .appDisplay__app-display {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -webkit-box-align: center;\n                -ms-flex-align: center;\n                    align-items: center; }\n    }\n    .o-wrapper {\n        padding-top: 16px;\n\n        max-width: 1020px;\n        padding-right: 1.5rem;\n        padding-left: 1.5rem;                                  \n        margin-right: auto;\n        margin-left: auto; }\n        @media (min-width: 768px) {\n        .o-wrapper {\n            padding-right: 40px;\n            padding-left: 40px; } }\n        @media (min-width: 1281px) {\n        .o-wrapper {\n            max-width: 1120px;\n            padding-right: 1.5rem;\n            padding-left: 1.5rem; } }\n\n    .appDisplayImg__app-display {\n        padding-right: 0.75rem; }\n        .appDisplayImg__app-display > img {\n        border: 1px solid #D8D8D8;\n        width: 3.25rem;\n        height: 3.25rem;\n        max-width: none;\n        border-radius: 1rem; }\n        @media (min-width: 480px) {\n        .appDisplayImg__app-display {\n            padding-right: 1.5rem; }\n            .appDisplayImg__app-display > img {\n            width: 4.25rem;\n            height: 4.25rem; } }\n  \n    .appName__app-display,\n    .appLongName__app-display {\n        margin-top: 0px;\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        color: rgba(64, 55, 57, 1);;\n        text-align: left;\n        letter-spacing: 0.09em;\n        font-size: 22px;\n        font-weight: 300;\n\n    }\n  \n    .appPublisher__app-display {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.07em;\n        margin-top: 8px;\n    }\n    .appPublisher__app-display > span {\n        display: table-cell;\n        overflow: hidden;\n        text-overflow: ellipsis; }\n    @media (min-width: 480px) {\n        .appPublisher__app-display {\n        font-size: 1.2rem; } }\n  \n    .appDisplayConcise__app-display .appDisplayImg__app-display {\n         padding-right: 0.75rem; }\n    .appDisplayConcise__app-display .appDisplayImg__app-display > img {\n        width: 36px;\n        height: 36px;\n        border-radius: 5px; }\n\n\n\n    \n\n    .inputWrapper {\n        padding-left: 10px;\n        // padding-right: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            max-width: 213px;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            display: -webkit-inline-box;\n    \n            div {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n    \n            input[type=number], input[type=text] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n                width: 3px;\n                border-left: 1px solid rgba(151, 151, 151, 1);\n            }\n            \n        }\n        \n        .react-tagsinput {\n            width: 213px;\n            border: 1px solid rgba(151,151,151,1);\n            border-radius: 20px;\n            display: -webkit-inline-box;\n\n            span {\n                padding-left: 10px;\n                font-family: \'Montserrat-Light\';\n                font-size: 16px;\n                margin: 2px;\n            }\n        }\n    \n        label {\n            width: 213px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .regionInput{\n          display: inline-block;\n          .country-flag img{\n            top: 0;\n          }\n\n          span{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n          }\n        }\n    .isoInputWrapper {\n        margin-bottom: 15px;\n        justify-content: center;\n        align-items: center;\n        vertical-align: center;\n        display: flex;\n        border: 1px solid rgba(147, 147, 147, 1);\n        border-radius: 20px;\n\n        &:last-of-type {\n          margin-bottom: 0;\n        }\n        .searchIcon{\n            position: absolute;\n            top: 50%; right: 11px;\n            width: 18px;\n            height: 18px;\n            transform: translateY(-50%);\n        }\n      \n        .searchInput{\n          width: 250px;\n          display: inline-block;\n\n          .Select-control {\n            border: none;\n            background-color: rgba(0,0,0,0.1);\n\n            .Select-input:focus {\n                background: rgba(255, 255, 255, 1);\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                color: rgba(147, 147, 147, 1);\n                text-align: justify;\n                letter-spacing: 0.04em;\n            }\n          }\n          .Select-placeholder {\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n          .Select-value{\n            font-size: 14px;\n            color: rgba(147, 147, 147, 1);\n            text-align: justify;\n            letter-spacing: 0.04em;\n            line-height: 17px;\n            font-family: \'Montserrat\';\n          }\n\n          input{\n            border: none;\n          }\n          \n        }\n       \n    }\n\n\n\n\n\n    .exampleHolder > div {\n        margin-left: auto;\n        margin-right: auto; \n    }\n    @media (min-width: 768px) {\n        .exampleHolder {\n        position: absolute;\n        width: 80%;\n        right: 0;\n        } \n    }\n    \n    @media (min-width: 850px) {\n        .exampleHolder {\n            width: 100%; \n        } \n    }\n\n    .budgetText{\n        font-family: \'Montserrat\';\n        font-size: 10px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.04em;\n        line-height: 18px;\n    }\n    \n    .react-tagsinput-tag{\n        background-color: transparent;\n        1px solid rgba(147, 147, 147, 1);\n    }\n\n    .isoWidgetsWrapper{\n\n        margin-left: auto;\n        margin-right: auto;\n        height: 487px;\n        width: 343px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n    .footer {\n        background-color: rgba(35, 31, 32, 1);\n        padding: 17px;\n        .footerTitle{\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(255, 255, 255, 1);\n            text-align: center;\n            letter-spacing: 0.07em;\n        }\n    }\n\n    .budgetSimpleWrapper{\n        .allCountryLabel{\n            padding: 0 8px;\n            font-family: \'Roboto\';\n            color: rgba(64,55,57,1);\n        }\n        .country-label{\n            font-family: \'Roboto\';\n            font-size: 12px;\n            color: rgba(64,55,57,1);\n        }\n    }\n    \n    // -- Simpliefed modification by Tom\n    \n\n    \n    // -- Zay modification\n    .header {\n        margin-bottom: 36px;\n        position:relative;\n        background-color: rgba(35, 31, 32, 1);\n        padding: 29px;\n        .greenLogo{\n            margin-left: auto;\n            margin-right: auto;    \n            height: 77px;\n            width: 118px;\n        }\n\n        .greenLogo { height: auto; }\n        \n        *:last-child {\n            // margin-top: 34px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            font-weight: 300;\n            color: rgba(219, 219, 219, 1);\n            text-align: center;\n            letter-spacing: 0.08em;\n        }\n    }\n    .header:after {\n        position: absolute;\n        display: inline-block;\n        content: \'\';\n        right: 0; bottom: -3px; left: 0;\n        height: 3px;\n        background-color: rgba(12, 183, 148, 1);\n    }\n    \n    .container {\n        margin-bottom: 42px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n        .container > form > .blackSection:first-child { z-index: 13; }\n        .container form > * { margin: 0 -15px; }\n        .container form > .blackSection { background-color: rgba(249, 249, 249, 1); }\n            .container .o-wrapper { max-width: auto; max-width: unset; max-width: none; }\n            .container .o-wrapper { min-height: 160px; padding-top: 42px; padding-right: 39px; padding-left: 45px; }\n                .container .o-wrapper .appDisplay__app-display h1 { text-transform: uppercase; }\n                .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select {\n                    padding-bottom: 0;\n                    border-right: 1px solid rgba(151, 151, 151, 1);\n\n                    span.country-flag {\n                        display: inline-block;\n                        width: auto !important;\n                        height: auto !important;\n                        line-height: 38px;\n\n                        img { width: auto; height: 1.5em; }\n                        img + span { display: inline-block; line-height: 1.5em; }\n                    }\n                }\n                .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select + .searchInput {\n                    width: 55%;\n                    .Select-control {\n                        position: relative;\n                        background-color: transparent;\n                        line-height: 38px;\n\n                        > *, .Select-placeholder { display: inline-block; line-height: 38px; }\n                        .Select-placeholder { position: absolute; top: 0; right: 0; left: 0; }\n                        .Select-input { display: block !important; height: 38px; }\n                        .Select-loading-zone { position: absolute; right: 20px; }\n                        .Select-arrow-zone { display: none; }\n                        input:focus, input:active { outline-width: 0; }\n\n                        > * > div { line-height: 38px; }\n                        input { width: auto !important; padding: 0; line-height: 38px; }\n                    }\n                }\n                .container .o-wrapper .isoSignInForm .isoInputWrapper {\n                    .flag-select + .Select.is-focused:not(.is-open) > .Select-control {\n                        box-shadow: none;\n                    }\n                }\n\n                .container .o-wrapper .isoSignInForm {\n                    max-width: 300px;\n                    float: right;\n\n                    .isoInputWrapper {\n                        height: 40px;\n\n                        .searchInput {\n                            height: 40px;\n                            line-height: 40px;\n\n                            .Select-control,\n                            .Select-multi-value-wrapper,\n                            .Select-placeholder,\n                            .Select-input,\n                            input {\n                                display: inline-block;\n                                height: 40px;\n                                line-height: 40px;\n                            }\n\n                            .Select-value { padding-right: 74px; }\n                            .Select-clear-zone { position: absolute; top: 50%; right: 4px; transform: translateY(-50%); }\n                        }\n                    }\n                    \n                    .Select-menu-outer {\n                      top: auto; right: -19px; bottom: 0; left: -1px;\n                      width: auto;\n                      transform: translateY(100%);\n                      background-color: rgba(255, 255, 255, .5);\n      \n                      .Select-option {\n                        height: 64px;\n                        padding: 12px; 2px;\n                        \n                        .app-div-anchor {\n                            display: flex;\n                            justify-content: flex-start !important;\n                            align-items: center;\n\n                            div {\n                                img {\n                                    display: inline-block;\n                                    margin: 0; padding: 0;\n                                    width: 40px; height: 40px;\n                                    border-radius: 3px;\n                                }\n                                :first-child { flex-basis: 40px; width: 40px; min-width: 40px; }\n                                :last-child {\n                                    flex-grow: 1;\n                                    padding-right: 2px;\n                                    padding-left: 11px;\n                                    text-align: left;\n                                    white-space: nowrap;\n                                    overflow: hidden;\n                                    text-overflow: ellipsis;\n                                }\n                            }\n                        }\n                      }\n                    }\n                }\n        .container .blackSection:first-child ~ * { padding-right: 50px; padding-left: 64px; }\n        .container .blackSection:first-child + div {\n            line-height: 60px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-transform: uppercase;\n        }\n\n        .container .blackSection ~ .blackSection {\n            padding-top: 24px;\n\n            > div:first-child {\n                margin-bottom: 20px;\n\n                + div > div { margin-bottom: 0 !important; }\n            }\n            .isoExampleWrapper {\n                margin-top: 0;\n                input { background-color: transparent; }\n                input:focus, input:active { outline-width: 0; }\n            }\n\n            .inputWrapper {\n                padding: 0;\n                text-align: left;\n                \n                img {\n                    width: 16px;\n                }\n\n                // label {\n                //     margin-bottom: 8px;\n                //     display: block;\n                //     width: auto;\n\n                //     span {\n                //         display: inline-block;\n                //         margin-left: 4px;\n                //         border: 1px solid rgba(147, 147, 147, 1);\n                //         border-radius: 100%;\n                //         width: 14px; height: 14px;\n                //         line-height: 14px;\n                //         font-family: \'Montserrat\';\n                //         text-align: center;\n                //         font-size: .7em;\n                //         color: rgba(147, 147, 147, 1);\n                //     }\n                // }\n\n                .FormTextInput {\n                    margin-left: -7px;\n                    padding-right: 4px;\n\n                    > :first-child { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }\n                }\n            }\n            \n            .BudgetTC p { margin-top: 29px; margin-bottom: 39px; font-size: 11px; color: rgba(64, 55, 57, 1); }\n\n            .advanced-settings {\n                margin-right: -50px;\n                margin-left: -64px;\n\n                .ant-collapse-header {\n                    height: 60px;\n                    padding: 0 50px 0 64px;\n                    background-color: rgba(252, 252, 252, 1);\n                    line-height: 60px;\n                    font-family: \'Montserrat\';\n                    color: rgba(64, 55, 57, 1);\n                    letter-spacing: 0.08em;\n\n                    .arrow { line-height: 60px; float: right; }\n                    .arrow + div {\n                        font-size: 14px;\n                        font-weight: 700;\n                        text-transform: uppercase;\n                        letter-spacing: 0.08em;\n\n                        @media screen and (max-width: 767px) { letter-spacing: 0.04em; }\n\n                        span { color: rgba(147, 147, 147, 1); }\n                    }\n                }\n\n                .ant-collapse-item { background-color: transparent; }\n                .ant-collapse-content {\n                    background-color: rgba(219, 219, 219, 0.35);\n                    padding: 0 50px 0 64px;\n\n                    label:first-child {\n                        margin-top: 23px;\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.04em;\n                    }\n\n                    label:first-child + p { font-family: \'Montserrat\'; font-size: 11px; margin-bottom: 17px; }\n\n                    label ~ div {\n                        margin: 0; margin-bottom: 27.5px; margin-left: -10px;\n\n                        .regionInput {\n                            position: relative;\n                            margin: 0;\n                            padding: 0;\n                            border-radius: 20px;\n                            width: 101px;\n                            background-color: #fff;\n                            line-height: 41px;\n                            text-align: center;\n\n                            img { width: 24px; height: 18px; }\n                            .country-label {\n                                width: 17px;\n                                line-height: 16px;\n                                font-family: \'Roboto\';\n                                font-size: 12px;\n                                color: rgba(64, 55, 57, 1);\n                                letter-spacing: 0.04em;\n                            }\n                        }\n                        &[desc=\'0%\'] > .regionInput:after {\n                            position: absolute;\n                            top: 0; right: 0; bottom: 0; left: 0;\n                            display: inline-block;\n                            content: \'\';\n                            border-radius: 20px;\n                            background-color: rgba(216, 216, 216, 0.6);\n                        }\n\n                        .rc-slider {\n                            width: 60%;\n                            margin-left: 11px;\n                            margin-right: 37px;\n\n                            .rc-slider-rail { height: 2px; }\n                            .rc-slider-track { border-width: 2px; border-color: rgba(60, 211, 207, 1); height: 2px; }\n                                .rc-slider-track:after {\n                                    position: absolute;\n                                    top: 50%; right: 0;\n                                    display: inline-block;\n                                    content: attr(desc);\n                                    border: 1px solid rgba(0, 0, 0, .1);\n                                    border-radius: 31px;\n                                    background-color: rgba(255, 255, 255, 1);\n                                    width: 31px; height: 31px;\n                                    line-height: 31px;\n                                    text-align: center;\n                                    font-family: \'Montserrat\';\n                                    font-size: 10px;\n                                    font-weight: 300;\n                                    color: rgba(64, 55, 57, 1);\n                                    letter-spacing: 0.04em;\n                                    transform: translateX(50%) translateY(-50%);\n                                    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.17);\n                                }\n                                .rc-slider-track[desc=\'0%\']:after { right: -10px; content: \'\'; }\n                            [role="slider"] { opacity: 0; }\n                        }\n\n                        .rc-slider ~ .inputWrapper {\n                            input { background-color: transparent; }\n                            input:focus, input:active { outline-width: 0; }\n                        }    \n\n                        [desc=\'0%\'] ~ .inputWrapper {\n                            .FormTextInput {\n                                border-color: rgba(216, 216, 216, 0.6);\n                                \n                                * { color: rgba(216, 216, 216, 0.6); }\n                                input { border-color: rgba(216, 216, 216, 0.6); }\n                            }\n                        }\n                    }\n\n                    > .ant-collapse-content-box { margin-bottom: 0; }\n                    label ~ div:last-child { margin-bottom: 0; }\n                }\n\n                .tagInputWrapper{\n                    margin: 0 -50px 0 -64px;\n                    width: auto !important;\n                    background-color: rgba(219, 219, 219, 0.35);\n                    padding: 0 50px 0 64px;\n                }\n                .inputWrapper {\n                    position: relative;\n                    margin: 0; padding: 0;\n                    \n                    label ~ .react-tagsinput {\n                        margin: 0; margin-left: -7px;\n                        padding: 0;\n                        background-color: transparent;\n                        line-height: 41px;\n\n                        span { padding: 0; margin-left: 21px; }\n\n                        + img {\n                            position: absolute;\n                            bottom: 15px;\n                            width: 20px;\n                            height: 19px;\n                            line-height: 19px;\n                            transform: translateX(-44px);\n                        }\n                    }\n                    input { \n                        font-family: \'Montserrat-Light\';\n                        font-size: 16px;\n                        margin: 0; \n                        margin-left: 21px;\n                        border-width: 0; \n                        background-color: \n                        transparent; padding: 0; \n                        line-height: 41px; \n                    }\n                    input:focus, input:active { outline-width: 0; }\n                    label ~ .FormTextInput input { border-left-width: 1px; padding-left: 14px; }\n                }\n            }\n\n            > :last-child, > :nth-last-child(2) {\n                margin: 0 -50px 0 -64px;\n                width: auto !important;\n                background-color: rgba(219, 219, 219, 0.35);\n                padding: 0 50px 0 64px;\n\n               \n            }\n\n            > :nth-last-child(2) {\n                p:first-child {\n                    margin-top: 25px;\n                    margin-bottom: 16px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(64, 55, 57, 1);\n                    letter-spacing: 0.04em;\n                }\n            }\n\n            > :last-child {\n                background-color: rgba(255, 255, 255, 1);\n\n                .campaign-holder {\n                    margin-top: 19px;\n                    margin-bottom: 42px;\n                    border: 1px solid rgba(170, 170, 170, 0.5);\n                    padding: 20px 10%;\n\n                    .isoExampleWrapper {\n                        margin: 0;\n                        .exampleHolder {\n                            position: relative;\n\n                            // .searchTerm__ad-example { top: 9.5%; left: 19.2%; }\n                            // .container__ad-example { top: 15.4%; width: 87.5%; }\n                        }\n                    }\n                    .btn-create-campaign {\n                        margin-top: 86px;\n                        margin-left: 65px;\n                        max-width: 270px;\n                        width: 100%;\n                        padding: 0;\n                        background-color: rgba(60, 211, 207, 1);\n\n                        line-height: 38px;\n                        font-family: \'Montserrat\';\n                        font-size: 15px;\n                        color: rgba(255, 255, 255, 1);\n                        text-align: center;\n                        letter-spacing: 0.01em;\n                        border-radius: 20px;\n\n                        img {\n                            height: 18px;\n                            transform: rotate(90deg) translateY(-14px);\n                            filter: brightness(0) invert(1);\n                        }\n                    }\n\n                    .btn-create-campaign + * {\n                        margin-top: 20px;\n                        margin-left: 65px;\n                        padding: 0;\n\n                        input[type=\'checkbox\'] {\n                            position: absolute;\n                            margin-left: -10px;\n                            transform: translateX(-100%);\n                        }\n\n                        label {\n                            margin: 0;\n                            line-height: 18px;\n                            font-family: \'Montserrat\';\n                            font-size: 12px;\n                            font-weight: 300;\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n\n                            + small {\n                                margin-top: 3px;\n                                font-family: \'Roboto\';\n                                font-size: 10px;\n                                color: rgba(221, 66, 85, 1);\n\n                                + div {\n                                    margin-top: 27px;\n                                    line-height: 18px;\n                                    font-family: \'Montserrat\';\n                                    font-size: 12px;\n                                    font-weight: 300;\n                                    color: rgba(64, 55, 57, 1);\n                                    letter-spacing: 0.04em;\n\n                                    a {\n                                        line-height: 18px;\n                                        font-family: \'Montserrat\';\n                                        font-size: 12px;\n                                        font-weight: 300;\n                                        color: rgba(60, 211, 207, 1);\n                                        letter-spacing: 0.04em;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        \n        @media screen and (max-width: 767px) {\n            .container {\n                margin-right: 16px;\n                margin-left: 16px;\n\n                .o-wrapper {\n                    padding-top: 12px; padding-right: 32px; padding-left: 17px;\n\n                    .appDisplay__app-display img { width: 85px; height: auto; }\n                }\n\n                .blackSection:first-child + div { padding-left: 21px; }\n                .blackSection:first-child ~ .blackSection {\n                    padding-right: 24px;\n                    padding-left: 11px;\n\n                    .inputWrapper .FormTextInput { margin-left: 0; }\n\n                    > div:first-child { margin-bottom: 16px; }\n                    > div:first-child + div {\n                        > *:not(:first-child) { margin-top: 25px; }\n                    }\n\n                    .advanced-settings {\n                        margin-right: -24px; margin-left: -11px;\n                        .ant-collapse-header { padding-left: 21px; }\n                        .ant-collapse-content {\n                            padding-top: 9px;\n                            padding-right: 11px;\n                            padding-left: 12px;\n\n                            label ~ div {\n                                margin-left: 0;\n                                flex-wrap: wrap;\n\n                                .flag-select { min-width: 101px; }\n                                .rc-slider { margin-top: 29px; margin-bottom: 28px; width: 100%; }\n                            }\n\n                            label ~ div:not(:last-child) { margin-bottom: 50px; }\n                        }\n                    }\n\n                    > :nth-last-child(2) {\n                        margin-right: -24px;\n                        margin-left: -11px;\n                        padding-right: 11px;\n                        padding-left: 12px;\n\n                        > *:not(:first-child) {\n                            margin-bottom: 31px !important;\n                            padding-left: 8px;\n\n                            label + * { margin-left: 0; }\n                        }\n                        > *:last-child { margin-bottom: 42px; }\n                    }\n\n                    > :last-child {\n                        margin-right: -24px;\n                        margin-left: -11px;\n                        padding-right: 11px;\n                        padding-left: 12px;\n\n                        .campaign-holder {\n                            margin-top: 23px;\n\n                            .adExample__ad-example.adExampleFull__ad-example { margin-top: 0; }\n                            .btn-create-campaign { margin: 0; margin-top: 25px; max-width: none; }\n                            .submit-terms {\n                                margin-left: 17px;\n                                \n                                input[type=\'checkbox\'] { margin-left: -3px; }\n                                > *:last-child { margin-left: -20px; }\n                            }\n                        }\n                    }\n                    // -- .blackSection:first-child ~ .blackSection\n                }\n                // -- .container\n            }\n        }\n        // @media screen and (min-width: 768px) {\n        //     .container .o-wrapper { padding-top: 42px; }\n        //     .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select + .searchInput { width: 70%; }\n            \n        //     .container .blackSection:first-child ~ * { padding-right: 25px; padding-left: 32px; }\n        // }\n        // @media screen and (min-width: 1200px) {\n        //     .container .o-wrapper .isoSignInForm .isoInputWrapper .flag-select { margin-left: -28px; }\n        // }\n\n        // @media screen and (max-width: 767px) {\n        //     .regionInput { width: 30%; }\n        //     .rc-slider { width: 50%; }\n        //     .rc-slider + .inputWrapper { margin-top: 10px; width: 100%; text-align: right; }\n        // }                    \n        \n        // @media screen and (min-width: 992px) {\n        //     .campaign-holder { padding: 20px 95px 20px 97px; }\n        // }\n        // @media screen and (max-width: 991px) {\n        //     .campaign-holder {\n        //         button { margin-top: 43px !important; }\n        //         button, button ~ * { margin-left: 32px !important; }\n        //     }\n        // }\n        // @media screen and (max-width: 767px) {\n        //     .campaign-holder {\n        //         .adExample__ad-example.adExampleFull__ad-example { margin-top: 5%; }\n\n        //         button, button ~ * { margin-left: 0 !important; }\n        //         .submit-terms input[type=\'checkbox\'] { margin-left: -3px; }\n        //     }\n        // }\n    // -- /.Zay modification\n\n    .searchTerm__ad-example { top: 72px !important; }\n    .tooltip-label { margin-left: 4px; width: 17px; }\n\n    @media screen and (max-width: 767px) {\n        .searchTerm__ad-example { top: 10.2% !important; }\n    }\n\n    @media screen and (min-width: 768px) {\n        .searchTerm__ad-example { top: 58px !important; }\n    }\n    \n    @media screen and (min-width: 850px) {\n        .searchTerm__ad-example { top: 40px !important; }\n    }\n    \n    @media screen and (min-width: 992px) {\n        .searchTerm__ad-example { top: 57px !important; }\n    }\n\n    @media screen and (min-width: 1199px) {\n        .searchTerm__ad-example { top: 72px !important; }\n    }\n\n\n\n    \n\n\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AddCampaignWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(AddCampaignWrapper);

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.App = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _antd = __webpack_require__(43);
	
	var _reactIntl = __webpack_require__(338);
	
	var _reactThrottle = __webpack_require__(2889);
	
	var _reactWindowSizeListener = __webpack_require__(2954);
	
	var _reactWindowSizeListener2 = _interopRequireDefault(_reactWindowSizeListener);
	
	var _styledComponents = __webpack_require__(16);
	
	var _actions = __webpack_require__(397);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actions3 = __webpack_require__(118);
	
	var _actions4 = _interopRequireDefault(_actions3);
	
	var _AppRouter = __webpack_require__(1651);
	
	var _AppRouter2 = _interopRequireDefault(_AppRouter);
	
	var _config = __webpack_require__(395);
	
	var _dashApp = __webpack_require__(1730);
	
	var _themes = __webpack_require__(740);
	
	var _themes2 = _interopRequireDefault(_themes);
	
	var _commonStyle = __webpack_require__(1652);
	
	var _commonStyle2 = _interopRequireDefault(_commonStyle);
	
	__webpack_require__(2000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import Sidebar from '../Sidebar/Sidebar';
	// import Topbar from '../Topbar/Topbar';
	// import ThemeSwitcher from '../../containers/ThemeSwitcher';
	
	
	var Content = _antd.Layout.Content,
	    Footer = _antd.Layout.Footer;
	var logout = _actions2.default.logout;
	var toggleAll = _actions4.default.toggleAll;
	
	var App = exports.App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var url = this.props.match.url;
	      var _props = this.props,
	          locale = _props.locale,
	          selectedTheme = _props.selectedTheme;
	
	      var currentAppLocale = _dashApp.AppLocale[locale];
	      return _react2.default.createElement(
	        _antd.LocaleProvider,
	        { locale: currentAppLocale.antd },
	        _react2.default.createElement(
	          _reactIntl.IntlProvider,
	          {
	            locale: currentAppLocale.locale,
	            messages: currentAppLocale.messages },
	          _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: _themes2.default[selectedTheme] },
	            _react2.default.createElement(
	              _commonStyle2.default,
	              null,
	              _react2.default.createElement(
	                _antd.Layout,
	                { style: { height: '100vh' } },
	                _react2.default.createElement(
	                  _reactThrottle.Debounce,
	                  { time: '1000', handler: 'onResize' },
	                  _react2.default.createElement(_reactWindowSizeListener2.default, {
	                    onResize: function onResize(windowSize) {
	                      return _this2.props.toggleAll(windowSize.windowWidth, windowSize.windowHeight);
	                    }
	                  })
	                ),
	                _react2.default.createElement(
	                  _antd.Layout,
	                  { style: { flexDirection: 'row', overflowX: 'hidden' } },
	                  _react2.default.createElement(
	                    _antd.Layout,
	                    {
	                      className: 'isoContentMainLayout',
	                      style: {
	                        height: '100vh'
	                      } },
	                    _react2.default.createElement(
	                      Content,
	                      {
	                        className: 'isomorphicContent',
	                        style: {
	                          padding: '70px 0 0',
	                          flexShrink: '0',
	                          background: '#f1f3f6'
	                        } },
	                      _react2.default.createElement(_AppRouter2.default, { url: url })
	                    ),
	                    _react2.default.createElement(
	                      Footer,
	                      {
	                        style: {
	                          background: '#ffffff',
	                          textAlign: 'center',
	                          borderTop: '1px solid #ededed'
	                        } },
	                      _config.siteConfig.footerText
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    auth: state.Auth,
	    locale: state.LanguageSwitcher.toJS().language.locale
	    // selectedTheme: state.ThemeSwitcher.toJS().changeThemes.themeName,
	  };
	}, { logout: logout, toggleAll: toggleAll })(App);

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _AsyncFunc = __webpack_require__(1733);
	
	var _AsyncFunc2 = _interopRequireDefault(_AsyncFunc);
	
	var _index = __webpack_require__(747);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import getDevRouters from '../../customApp/router';
	
	
	var AppRouter = function (_React$Component) {
	  _inherits(AppRouter, _React$Component);
	
	  function AppRouter() {
	    _classCallCheck(this, AppRouter);
	
	    return _possibleConstructorReturn(this, (AppRouter.__proto__ || Object.getPrototypeOf(AppRouter)).apply(this, arguments));
	  }
	
	  _createClass(AppRouter, [{
	    key: 'render',
	    value: function render() {
	      var url = this.props.url;
	
	      return _react2.default.createElement(
	        _reactRouterDom.Switch,
	        null,
	        _react2.default.createElement(_reactRouterDom.Route, {
	          exact: true,
	          path: url + '/',
	          component: (0, _AsyncFunc2.default)(function () {
	            return _index2.default;
	          })
	        })
	      );
	    }
	  }]);
	
	  return AppRouter;
	}(_react2.default.Component);
	
	exports.default = AppRouter;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .trigger {\n    font-size: 18px;\n    line-height: 64px;\n    padding: 0 16px;\n    cursor: pointer;\n    transition: color 0.3s;\n  }\n\n  .trigger:hover {\n    color: ', ';\n  }\n\n  .ant-layout-sider-collapsed .anticon {\n    font-size: 16px;\n  }\n\n  .ant-layout-sider-collapsed .nav-text {\n    display: none;\n  }\n\n  .ant-layout {\n    background: ', ';\n\n    &.isoContentMainLayout {\n      overflow: auto;\n      overflow-x: hidden;\n      @media only screen and (min-width: 768px) and (max-width: 1220px) {\n        width: calc(100% - 64px);\n        flex-shrink: 0;\n      }\n\n      @media only screen and (max-width: 767px) {\n        width: 100%;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  .isoLayoutContent {\n    width: 100%;\n    padding: 35px;\n    background-color: #ffffff;\n    border: 1px solid ', ';\n    height: 100%;\n  }\n\n  .isomorphicLayout {\n    width: calc(100% - 240px);\n    flex-shrink: 0;\n    overflow-x: hidden !important;\n\n    @media only screen and (max-width: 767px) {\n      width: 100%;\n    }\n\n    @media only screen and (min-width: 768px) and (max-width: 1220px) {\n      width: calc(100% - 64px);\n    }\n  }\n\n  .ant-layout-footer {\n    font-size: 13px;\n    @media (max-width: 767px) {\n      padding: 10px 20px;\n    }\n  }\n\n  button {\n    border-radius: 0;\n  }\n'], ['\n  .trigger {\n    font-size: 18px;\n    line-height: 64px;\n    padding: 0 16px;\n    cursor: pointer;\n    transition: color 0.3s;\n  }\n\n  .trigger:hover {\n    color: ', ';\n  }\n\n  .ant-layout-sider-collapsed .anticon {\n    font-size: 16px;\n  }\n\n  .ant-layout-sider-collapsed .nav-text {\n    display: none;\n  }\n\n  .ant-layout {\n    background: ', ';\n\n    &.isoContentMainLayout {\n      overflow: auto;\n      overflow-x: hidden;\n      @media only screen and (min-width: 768px) and (max-width: 1220px) {\n        width: calc(100% - 64px);\n        flex-shrink: 0;\n      }\n\n      @media only screen and (max-width: 767px) {\n        width: 100%;\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  .isoLayoutContent {\n    width: 100%;\n    padding: 35px;\n    background-color: #ffffff;\n    border: 1px solid ', ';\n    height: 100%;\n  }\n\n  .isomorphicLayout {\n    width: calc(100% - 240px);\n    flex-shrink: 0;\n    overflow-x: hidden !important;\n\n    @media only screen and (max-width: 767px) {\n      width: 100%;\n    }\n\n    @media only screen and (min-width: 768px) and (max-width: 1220px) {\n      width: calc(100% - 64px);\n    }\n  }\n\n  .ant-layout-footer {\n    font-size: 13px;\n    @media (max-width: 767px) {\n      padding: 10px 20px;\n    }\n  }\n\n  button {\n    border-radius: 0;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AppHolder = _styledComponents2.default.div(_templateObject, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('secondary', 1), (0, _styledTheme.palette)('border', 0));
	
	exports.default = AppHolder;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    margin-right: 14px;\n    margin-bottom: 36px;\n\n    .app-info { display: flex; justify-content: flex-start; }\n    .app-info .app-icon-container { margin-right: 25px; min-width: 120px; height: 120px; }\n    .app-info .app-icon-container img { width: 100%; border-radius: 20px; }\n\n    .app-description { display: flex; flex-direction: column; justify-content: space-between; }\n    .app-description .app-name {\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n        text-transform: uppercase;\n    }\n    \n    .app-details {\n        line-height: 25px;\n        font-family: \'Roboto\';\n        font-size: 15px;\n        color: rgba(147, 147, 147, 1);\n        text-align: justify;\n        letter-spacing: 0.04em;\n    }\n\n    .app-info + .app-details { margin-top: 20px; }\n\n    @media screen and (max-width: 767px) {\n        margin-right: 0;\n        margin-bottom: 30px;\n\n        .app-info .app-icon-container { margin-right: 7px; min-width: 68px; width: 68px; height: 68px; }\n        .app-description { justify-content: center; }\n        .app-description .app-name { top: -7px; }\n    }\n'], ['\n    flex-grow: 1;\n    margin-right: 14px;\n    margin-bottom: 36px;\n\n    .app-info { display: flex; justify-content: flex-start; }\n    .app-info .app-icon-container { margin-right: 25px; min-width: 120px; height: 120px; }\n    .app-info .app-icon-container img { width: 100%; border-radius: 20px; }\n\n    .app-description { display: flex; flex-direction: column; justify-content: space-between; }\n    .app-description .app-name {\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n        text-transform: uppercase;\n    }\n    \n    .app-details {\n        line-height: 25px;\n        font-family: \'Roboto\';\n        font-size: 15px;\n        color: rgba(147, 147, 147, 1);\n        text-align: justify;\n        letter-spacing: 0.04em;\n    }\n\n    .app-info + .app-details { margin-top: 20px; }\n\n    @media screen and (max-width: 767px) {\n        margin-right: 0;\n        margin-bottom: 30px;\n\n        .app-info .app-icon-container { margin-right: 7px; min-width: 68px; width: 68px; height: 68px; }\n        .app-description { justify-content: center; }\n        .app-description .app-name { top: -7px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Wrapper = __webpack_require__(1653);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	var AppHeader = function (_React$Component) {
	    _inherits(AppHeader, _React$Component);
	
	    function AppHeader() {
	        _classCallCheck(this, AppHeader);
	
	        return _possibleConstructorReturn(this, (AppHeader.__proto__ || Object.getPrototypeOf(AppHeader)).apply(this, arguments));
	    }
	
	    _createClass(AppHeader, [{
	        key: 'ConvertToPriceString',
	        value: function ConvertToPriceString(currency, price) {
	            if (price == null || price == undefined) return "-";
	            try {
	                if (parseInt(price) <= 0) return "免费";
	            } catch (ex) {}
	            return '收费';
	
	            if (currency) return currency + " " + price;
	            return price;
	        }
	    }, {
	        key: 'ConcatToGenresString',
	        value: function ConcatToGenresString(genres) {
	            var translatedGenres = genres || [];
	            translatedGenres = translatedGenres.map(function (genre) {
	                if (!genre || genre.length <= 0) return '';
	                switch (genre.toLowerCase()) {
	                    case 'games':
	                        return '游戏';
	                    case 'shopping':
	                        return '购物';
	                    case 'photo & video':
	                        return '摄影与录像';
	                    case 'education':
	                        return '教育';
	                    case 'kids':
	                        return '儿童';
	                    case 'lifestyle':
	                        return '生活';
	                    case 'health & fitness':
	                        return '健康';
	                    case 'productivity':
	                        return '效率';
	                    case 'magazines & newspapers':
	                        return '报刊杂志';
	                    case 'travel':
	                        return '旅游';
	                    case 'music':
	                        return '音乐';
	                    case 'sports':
	                        return '体育';
	                    case 'entertainment':
	                        return '娱乐';
	                    case 'news':
	                        return '新闻';
	                    case 'social networking':
	                        return '社交';
	                    case 'business':
	                        return '商务';
	                    case 'utilities':
	                        return '工具';
	                    case 'books':
	                        return '图书';
	                    case 'finance':
	                        return '财务';
	                    case 'food & drink':
	                        return '美食佳饮';
	                    case 'medical':
	                        return '医疗';
	                    case 'navigation':
	                        return '导航';
	                    case 'reference':
	                        return '参考';
	                    case 'weather':
	                        return '天气';
	                    case 'developer tool':
	                        return '开发者工具"';
	                }
	
	                return genre;
	            }).filter(function (genre) {
	                return genre.length > 0;
	            });
	            return translatedGenres ? translatedGenres.join("/") : "";
	        }
	    }, {
	        key: 'ConvertToDateString',
	        value: function ConvertToDateString(date) {
	            if (!date) return "";
	
	            var DateInstance = new Date(date);
	            return DateInstance.getFullYear() + '\u5E74' + (DateInstance.getMonth() + 1) + '\u6708' + DateInstance.getDate() + '\u65E5';
	            var monthName = DateInstance.toLocaleString("zh-cn", { month: "long" });
	
	            if (monthName.length > 3) monthName = monthName.substr(0, 3);
	            return monthName + " " + DateInstance.getDate() + ", " + DateInstance.getFullYear();
	        }
	    }, {
	        key: 'GetAppDetails',
	        value: function GetAppDetails(props) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'app-details' },
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    '\u5F00\u53D1\u5546\uFF1A ',
	                    props.publisher
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    '\u4EF7\u683C\uFF1A ',
	                    this.ConvertToPriceString(props.currency, props.price),
	                    ' | \u7C7B\u522B: ',
	                    this.ConcatToGenresString(props.category)
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    '\u7248\u672C\uFF1A ',
	                    props.version,
	                    ' | \u53D1\u884C\u65E5\u671F\uFF1A ',
	                    this.ConvertToDateString(props.releaseDate),
	                    ' | \u6700\u540E\u66F4\u65B0\u65E5\u671F\uFF1A ',
	                    this.ConvertToDateString(props.lastUpdated)
	                )
	            );
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'app-header' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'app-info' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'app-icon-container' },
	                        _react2.default.createElement('img', { src: this.props.imgUrl })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'app-description' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'app-name' },
	                            this.props.appName
	                        ),
	                        _react2.default.createElement(
	                            _reactResponsive2.default,
	                            { minWidth: 768 },
	                            this.GetAppDetails(this.props)
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { maxWidth: 767 },
	                    this.GetAppDetails(this.props)
	                )
	            );
	        }
	    }]);
	
	    return AppHeader;
	}(_react2.default.Component);
	
	exports.default = AppHeader;
	;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    // -- First line\n    .app-score { display: flex; flex-direction: column; align-items: center; }\n\n    .app-score small {\n        font-family: \'Montserrat\';\n        font-size: 16px;\n        color: rgba(12, 183, 148, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n    }\n    .app-score small + * {\n        font-family: \'Montserrat\';\n        font-size: 30px;\n        color: rgba(12, 183, 148, 1);\n        text-align: left;\n        letter-spacing: 0.2em;\n    }\n\n    // -- Second line\n    .app-header-controls { margin-top: 21px; display: flex; justify-content: flex-end; }\n\n    .flag-border-wrapper {\n        display: block;\n        border: 1px solid rgba(151, 151, 151, 1);\n        width: 115px;\n        padding: 8px 24px;\n        background-color: rgba(255, 255, 255, 1);\n        border-radius: 20px;\n\n        .flag-select, .selected--flag--option { display: block; margin: 0; padding: 0; }\n\n        .selected--flag--option { display: flex; justify-content: center; align-items: center; }\n\n        .country-flag {\n            display:flex;\n            align-items: center;\n            width: auto !important;\n            height: 24px !important;\n            min-width: 65px;\n        }\n        .country-flag img { top: unset; width: auto; height: 24px; }\n\n        .arrow-down { height: 24px; padding-top: 0; }\n\n        .flag-options { left: -30%; right: -30%; max-height: unset; }\n        .flag-select .flag-option.has-label { width: 100%; padding: 0; }\n        .flag-select .flag-option.has-label .country-flag { justify-content: center; align-items: center; height: auto !important; padding: 4px 7px; }\n        .flag-select .flag-option img + span { padding: 0; padding-left: 7px; }\n    }\n\n    @media screen and (max-width: 767px) {\n        flex-direction: row;\n        justify-content: space-between;\n        flex-grow: 1;\n\n        .app-score small { font-size: 12px; }\n        .app-header-controls { margin-top: 0; }\n    }\n'], ['\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    // -- First line\n    .app-score { display: flex; flex-direction: column; align-items: center; }\n\n    .app-score small {\n        font-family: \'Montserrat\';\n        font-size: 16px;\n        color: rgba(12, 183, 148, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n    }\n    .app-score small + * {\n        font-family: \'Montserrat\';\n        font-size: 30px;\n        color: rgba(12, 183, 148, 1);\n        text-align: left;\n        letter-spacing: 0.2em;\n    }\n\n    // -- Second line\n    .app-header-controls { margin-top: 21px; display: flex; justify-content: flex-end; }\n\n    .flag-border-wrapper {\n        display: block;\n        border: 1px solid rgba(151, 151, 151, 1);\n        width: 115px;\n        padding: 8px 24px;\n        background-color: rgba(255, 255, 255, 1);\n        border-radius: 20px;\n\n        .flag-select, .selected--flag--option { display: block; margin: 0; padding: 0; }\n\n        .selected--flag--option { display: flex; justify-content: center; align-items: center; }\n\n        .country-flag {\n            display:flex;\n            align-items: center;\n            width: auto !important;\n            height: 24px !important;\n            min-width: 65px;\n        }\n        .country-flag img { top: unset; width: auto; height: 24px; }\n\n        .arrow-down { height: 24px; padding-top: 0; }\n\n        .flag-options { left: -30%; right: -30%; max-height: unset; }\n        .flag-select .flag-option.has-label { width: 100%; padding: 0; }\n        .flag-select .flag-option.has-label .country-flag { justify-content: center; align-items: center; height: auto !important; padding: 4px 7px; }\n        .flag-select .flag-option img + span { padding: 0; padding-left: 7px; }\n    }\n\n    @media screen and (max-width: 767px) {\n        flex-direction: row;\n        justify-content: space-between;\n        flex-grow: 1;\n\n        .app-score small { font-size: 12px; }\n        .app-header-controls { margin-top: 0; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _reactFlagsSelect = __webpack_require__(196);
	
	var _reactFlagsSelect2 = _interopRequireDefault(_reactFlagsSelect);
	
	var _index = __webpack_require__(1658);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(185);
	
	var _Wrapper = __webpack_require__(1655);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _country = __webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var AppScore = function (_React$Component) {
	    _inherits(AppScore, _React$Component);
	
	    function AppScore(props) {
	        _classCallCheck(this, AppScore);
	
	        var _this = _possibleConstructorReturn(this, (AppScore.__proto__ || Object.getPrototypeOf(AppScore)).call(this, props));
	
	        _this.score = 0;
	        for (var key in props.scores) {
	            _this.score += props.scores[key];
	        }return _this;
	    }
	
	    _createClass(AppScore, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'app-summary' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'app-score' },
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        'APP\u6574\u4F53\u5206\u6570'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        this.score,
	                        '/10'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'app-header-controls' },
	                    false && this.props.report && _react2.default.createElement(
	                        'div',
	                        { className: 'report-border-wrapper' },
	                        _react2.default.createElement(_index2.default, { report: this.props.report })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'flag-border-wrapper' },
	                        _react2.default.createElement(_reactFlagsSelect2.default, {
	                            className: 'regionInput',
	                            defaultCountry: this.props.countryCode ? this.props.countryCode.toUpperCase() : "US",
	                            countries: _country.COUNTRIES,
	                            customLabels: _country.FLAG_LABELS,
	                            placeholder: 'Select Language',
	                            showSelectedLabel: true
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppScore;
	}(_react2.default.Component);
	
	exports.default = AppScore;
	;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin-right: 11px;\n    min-width: 40px;\n\n    button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n        border: 1px solid rgba(151, 151, 151, 1);\n        width: 40px;\n        height: 40px;\n        padding: 0;\n        background-color: rgba(255, 255, 255, 1);\n        border-radius: 40px;\n        transition: .3s;\n    }\n    button:hover { background-color: rgba(239, 239, 239, 1); }\n    button img { width: 18px; }\n\n    @media screen and (max-width: 767px) {\n        margin-right: 8px;\n    }\n'], ['\n    margin-right: 11px;\n    min-width: 40px;\n\n    button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n        border: 1px solid rgba(151, 151, 151, 1);\n        width: 40px;\n        height: 40px;\n        padding: 0;\n        background-color: rgba(255, 255, 255, 1);\n        border-radius: 40px;\n        transition: .3s;\n    }\n    button:hover { background-color: rgba(239, 239, 239, 1); }\n    button img { width: 18px; }\n\n    @media screen and (max-width: 767px) {\n        margin-right: 8px;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDataExport = __webpack_require__(1220);
	
	var _reactDataExport2 = _interopRequireDefault(_reactDataExport);
	
	var _ButtonAction = __webpack_require__(392);
	
	var _ButtonAction2 = _interopRequireDefault(_ButtonAction);
	
	var _Wrapper = __webpack_require__(1657);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _download_aso = __webpack_require__(3303);
	
	var _download_aso2 = _interopRequireDefault(_download_aso);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	// -- Others
	
	
	var ExcelFile = _reactDataExport2.default.ExcelFile;
	var ExcelSheet = _reactDataExport2.default.ExcelFile.ExcelSheet;
	var ExcelColumn = _reactDataExport2.default.ExcelFile.ExcelColumn;
	
	var AppScoreReport = function (_React$Component) {
	    _inherits(AppScoreReport, _React$Component);
	
	    function AppScoreReport() {
	        _classCallCheck(this, AppScoreReport);
	
	        return _possibleConstructorReturn(this, (AppScoreReport.__proto__ || Object.getPrototypeOf(AppScoreReport)).apply(this, arguments));
	    }
	
	    _createClass(AppScoreReport, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'app-summary' },
	                _react2.default.createElement(
	                    ExcelFile,
	                    { element: _react2.default.createElement(
	                            _ButtonAction2.default,
	                            { title: 'Download Data' },
	                            _react2.default.createElement('img', { src: _download_aso2.default })
	                        ) },
	                    _react2.default.createElement(
	                        ExcelSheet,
	                        { data: this.props.report, name: 'Employees' },
	                        _react2.default.createElement(ExcelColumn, { label: 'Category', value: 'cat' }),
	                        _react2.default.createElement(ExcelColumn, { label: 'Sub Category', value: 'subCat' }),
	                        _react2.default.createElement(ExcelColumn, { label: 'Result', value: 'result' }),
	                        _react2.default.createElement(ExcelColumn, { label: 'Detail', value: 'detail' }),
	                        _react2.default.createElement(ExcelColumn, { label: 'Insightful Tip 1', value: 'tip1' }),
	                        _react2.default.createElement(ExcelColumn, { label: 'Insightful Tip 2', value: 'tip2' }),
	                        _react2.default.createElement(ExcelColumn, { label: 'Insightful Tip 3', value: 'tip3' })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppScoreReport;
	}(_react2.default.Component);
	
	exports.default = AppScoreReport;
	;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["    \n    .summary-title { margin-bottom: 24px; }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: 33% 33% 33%;\n        grid-column-gap: 8px;\n        grid-row-gap: 3px;\n    }\n\n    @media screen and (max-width: 767px) {\n        .grid-container { grid-template-columns: 100%; }\n        \n        .grid-container > *:nth-child(4) { grid-row: 2; }\n        .grid-container > *:nth-child(7) { grid-row: 3; }\n\n        .grid-container > *:nth-child(5) { grid-row: 5; }\n        .grid-container > *:nth-child(8) { grid-row: 6; }\n\n        .grid-container > *:nth-child(6) { grid-row: 8; }\n        .grid-container > *:nth-child(9) { grid-row: 9; }\n    }\n"], ["    \n    .summary-title { margin-bottom: 24px; }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: 33% 33% 33%;\n        grid-column-gap: 8px;\n        grid-row-gap: 3px;\n    }\n\n    @media screen and (max-width: 767px) {\n        .grid-container { grid-template-columns: 100%; }\n        \n        .grid-container > *:nth-child(4) { grid-row: 2; }\n        .grid-container > *:nth-child(7) { grid-row: 3; }\n\n        .grid-container > *:nth-child(5) { grid-row: 5; }\n        .grid-container > *:nth-child(8) { grid-row: 6; }\n\n        .grid-container > *:nth-child(6) { grid-row: 8; }\n        .grid-container > *:nth-child(9) { grid-row: 9; }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    background-color: rgba(255, 255, 255, 1);\n    padding: 22px 24px;\n    line-height: 22px;\n    color: rgba(64, 55, 57, 1);\n    text-align: left;\n\n    .content-title {\n        font-family: 'Montserrat';\n        font-size: 16px;\n        letter-spacing: 0.03em;\n    }\n\n    .content-explain,\n    .content-explain > div {\n        font-family: 'Montserrat-Light';\n        font-size: 14px;\n        font-weight: 300;\n        letter-spacing: 0.04em;\n    }\n    .content-explain span { font-family: 'Montserrat-Light'; color: rgba(12, 183, 148, 1); }\n"], ["\n    background-color: rgba(255, 255, 255, 1);\n    padding: 22px 24px;\n    line-height: 22px;\n    color: rgba(64, 55, 57, 1);\n    text-align: left;\n\n    .content-title {\n        font-family: 'Montserrat';\n        font-size: 16px;\n        letter-spacing: 0.03em;\n    }\n\n    .content-explain,\n    .content-explain > div {\n        font-family: 'Montserrat-Light';\n        font-size: 14px;\n        font-weight: 300;\n        letter-spacing: 0.04em;\n    }\n    .content-explain span { font-family: 'Montserrat-Light'; color: rgba(12, 183, 148, 1); }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    .summary-title { margin-bottom: 19px; }\n\n    .app-description {\n        margin-bottom: 25px;\n        line-height: 18px;\n        font-family: 'Roboto';\n        font-size: 14px;\n        font-weight: 600;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 1px;\n    }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: 50% 50%;\n        grid-column-gap: 6px;\n        grid-row-gap: 2px;\n    }\n\n    .spell-check-content {\n        grid-row-start: 2;\n        grid-row-end: 4;\n        grid-column-start: 2;\n        grid-column-end: 3;\n    }\n\n    @media screen and (max-width: 767px) {\n        .app-description { padding: 0 17px; text-align: justify; font-weight: 300; }\n\n        .grid-container { grid-template-columns: 100%; }\n        .spell-check-content {\n            grid-row-start: auto;\n            grid-row-end: auto;\n            grid-column-start: auto;\n            grid-column-end: auto;\n        }\n\n        .grid-container > *:nth-child(3) { grid-row: 2; }\n        .grid-container > *:nth-child(5) { grid-row: 3; }\n    }\n"], ["\n    .summary-title { margin-bottom: 19px; }\n\n    .app-description {\n        margin-bottom: 25px;\n        line-height: 18px;\n        font-family: 'Roboto';\n        font-size: 14px;\n        font-weight: 600;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 1px;\n    }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: 50% 50%;\n        grid-column-gap: 6px;\n        grid-row-gap: 2px;\n    }\n\n    .spell-check-content {\n        grid-row-start: 2;\n        grid-row-end: 4;\n        grid-column-start: 2;\n        grid-column-end: 3;\n    }\n\n    @media screen and (max-width: 767px) {\n        .app-description { padding: 0 17px; text-align: justify; font-weight: 300; }\n\n        .grid-container { grid-template-columns: 100%; }\n        .spell-check-content {\n            grid-row-start: auto;\n            grid-row-end: auto;\n            grid-column-start: auto;\n            grid-column-end: auto;\n        }\n\n        .grid-container > *:nth-child(3) { grid-row: 2; }\n        .grid-container > *:nth-child(5) { grid-row: 3; }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    .summary-title { margin-bottom: 21px; }\n\n    .screenshots {\n        display: grid;\n        grid-template-columns: repeat(5, 1fr);\n        grid-column-gap: 3px;\n        margin-bottom: 26px;\n    }\n    .screenshots img { max-width: 100%; }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        grid-column-gap: 6px;\n        grid-row-gap: 3px;\n    }\n\n    @media screen and (max-width: 767px) {\n        .screenshots { display: block; padding: 0 17px; }\n        .screenshots .shot-bubbles { display: flex; justify-content: center; margin-top: 21px; }\n        .screenshots .shot-bubble {\n            margin: 0 6px;\n            display: inline-block;\n            width: 6px; height: 6px;\n            background-color: rgba(219, 219, 219, 1);\n            border-radius: 6px;\n            transition: .3s;\n        }\n        .screenshots .activated-shot-bubble { background-color: rgba(60, 211, 207, 1); }\n\n        .grid-container { grid-template-columns: 100%; }\n        \n        .grid-container > *:nth-child(4) { grid-row: 2; }\n        .grid-container > *:nth-child(7) { grid-row: 3; }\n        \n        .grid-container > *:nth-child(5) { grid-row: 5; }\n        .grid-container > *:nth-child(8) { grid-row: 6; }\n        \n        .grid-container > *:nth-child(6) { grid-row: 8; }\n        .grid-container > *:nth-child(9) { grid-row: 9; }\n    }\n"], ["\n    .summary-title { margin-bottom: 21px; }\n\n    .screenshots {\n        display: grid;\n        grid-template-columns: repeat(5, 1fr);\n        grid-column-gap: 3px;\n        margin-bottom: 26px;\n    }\n    .screenshots img { max-width: 100%; }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n        grid-column-gap: 6px;\n        grid-row-gap: 3px;\n    }\n\n    @media screen and (max-width: 767px) {\n        .screenshots { display: block; padding: 0 17px; }\n        .screenshots .shot-bubbles { display: flex; justify-content: center; margin-top: 21px; }\n        .screenshots .shot-bubble {\n            margin: 0 6px;\n            display: inline-block;\n            width: 6px; height: 6px;\n            background-color: rgba(219, 219, 219, 1);\n            border-radius: 6px;\n            transition: .3s;\n        }\n        .screenshots .activated-shot-bubble { background-color: rgba(60, 211, 207, 1); }\n\n        .grid-container { grid-template-columns: 100%; }\n        \n        .grid-container > *:nth-child(4) { grid-row: 2; }\n        .grid-container > *:nth-child(7) { grid-row: 3; }\n        \n        .grid-container > *:nth-child(5) { grid-row: 5; }\n        .grid-container > *:nth-child(8) { grid-row: 6; }\n        \n        .grid-container > *:nth-child(6) { grid-row: 8; }\n        .grid-container > *:nth-child(9) { grid-row: 9; }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    position: relative;\n    height: 90px;\n    padding: 21px 22px 21px 26px;\n    background-color: rgba(255, 255, 255, 1);\n    color: rgba(12, 183, 148, 1);\n    text-align: left;\n    letter-spacing: 0.08em;\n\n    .header-text { line-height: 26px; font-family: 'Montserrat'; font-size: 22px; text-transform: uppercase; }\n    .header-explain { line-height: 19px; font-family: 'Montserrat'; font-size: 16px; font-weight: 300; }\n    .header-icon {\n        position: absolute;\n        top: 22px; right: 22px;\n        width: 32px;\n        height: 32px;\n    }\n    .header-icon img { width: 100%; }\n\n    @media screen and (max-width: 767px) {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        margin-top: 9px;\n\n        .header-icon { top: 50%; transform: translateY(-50%); }\n    }\n"], ["\n    position: relative;\n    height: 90px;\n    padding: 21px 22px 21px 26px;\n    background-color: rgba(255, 255, 255, 1);\n    color: rgba(12, 183, 148, 1);\n    text-align: left;\n    letter-spacing: 0.08em;\n\n    .header-text { line-height: 26px; font-family: 'Montserrat'; font-size: 22px; text-transform: uppercase; }\n    .header-explain { line-height: 19px; font-family: 'Montserrat'; font-size: 16px; font-weight: 300; }\n    .header-icon {\n        position: absolute;\n        top: 22px; right: 22px;\n        width: 32px;\n        height: 32px;\n    }\n    .header-icon img { width: 100%; }\n\n    @media screen and (max-width: 767px) {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        margin-top: 9px;\n\n        .header-icon { top: 50%; transform: translateY(-50%); }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["    \n    .summary-title { margin-bottom: 24px; }\n    .summary-title .ratings {\n        display: flex;\n        align-items: baseline;\n        margin-top: 24px;\n        font-size: 18px;\n        font-weight: 700;\n        color: #999;\n        text-transform: none;\n    }\n    .summary-title .ratings > * { margin-right: 28px; }\n    .summary-title .rating-icon { align-self: end; height: 100px; }\n    .summary-title .ratings span {\n        font-size: 70px;\n        font-weight: 700;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: -0.5px;\n    }\n\n    .reviews {\n        display: grid;\n        grid-template-columns: 33% 33% 33%;\n        grid-column-gap: 0.5%;\n        margin-bottom: 24px;\n    }\n    .reviews .reviews-toggle {\n        grid-column-start: 1;\n        grid-column-end: 4;\n        background-color: #efefef;\n        font-size: 24px;\n        text-align: center;\n    }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: 49.5% 49.5%;\n        grid-column-gap: 1%;\n        grid-row-gap: 3px;\n    }\n\n    .grid-content .recharts-wrapper {\n        display: flex;\n        justify-content: center;\n        width: 100% !important;\n        text-align: center;\n    }\n    .grid-content .recharts-wrapper svg {\n        margin: 0 auto;\n        margin-top: 28px;\n    }\n    .grid-content:last-child {\n        grid-column-start: 1;\n        grid-column-end: 3;\n    }\n\n    @media screen and (max-width: 480px) {\n        .ratings { flex-wrap: wrap; justify-content: center; }\n        .ratings img ~ * { margin: 0 7px !important; }\n        .ratings img ~ :last-child { flex-grow: 1; text-align: center; }\n\n        .reviews {\n            grid-template-columns: 100%;\n            grid-column-gap: 0;\n            grid-row-gap: 4px;\n            margin-bottom: 24px;\n        }\n        .reviews .review:last-child { display: none; }\n        .reviews .reviews-toggle { display: none; }\n\n        .grid-container { grid-template-columns: 100%; }\n        \n        .grid-container > *:nth-child(3) { grid-row: 2; }\n        .grid-container > *:nth-child(5) { grid-row: 3; }\n        .grid-content:last-child { grid-column-end: 2; }\n    }\n"], ["    \n    .summary-title { margin-bottom: 24px; }\n    .summary-title .ratings {\n        display: flex;\n        align-items: baseline;\n        margin-top: 24px;\n        font-size: 18px;\n        font-weight: 700;\n        color: #999;\n        text-transform: none;\n    }\n    .summary-title .ratings > * { margin-right: 28px; }\n    .summary-title .rating-icon { align-self: end; height: 100px; }\n    .summary-title .ratings span {\n        font-size: 70px;\n        font-weight: 700;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: -0.5px;\n    }\n\n    .reviews {\n        display: grid;\n        grid-template-columns: 33% 33% 33%;\n        grid-column-gap: 0.5%;\n        margin-bottom: 24px;\n    }\n    .reviews .reviews-toggle {\n        grid-column-start: 1;\n        grid-column-end: 4;\n        background-color: #efefef;\n        font-size: 24px;\n        text-align: center;\n    }\n\n    .grid-container {\n        display: grid;\n        grid-template-columns: 49.5% 49.5%;\n        grid-column-gap: 1%;\n        grid-row-gap: 3px;\n    }\n\n    .grid-content .recharts-wrapper {\n        display: flex;\n        justify-content: center;\n        width: 100% !important;\n        text-align: center;\n    }\n    .grid-content .recharts-wrapper svg {\n        margin: 0 auto;\n        margin-top: 28px;\n    }\n    .grid-content:last-child {\n        grid-column-start: 1;\n        grid-column-end: 3;\n    }\n\n    @media screen and (max-width: 480px) {\n        .ratings { flex-wrap: wrap; justify-content: center; }\n        .ratings img ~ * { margin: 0 7px !important; }\n        .ratings img ~ :last-child { flex-grow: 1; text-align: center; }\n\n        .reviews {\n            grid-template-columns: 100%;\n            grid-column-gap: 0;\n            grid-row-gap: 4px;\n            margin-bottom: 24px;\n        }\n        .reviews .review:last-child { display: none; }\n        .reviews .reviews-toggle { display: none; }\n\n        .grid-container { grid-template-columns: 100%; }\n        \n        .grid-container > *:nth-child(3) { grid-row: 2; }\n        .grid-container > *:nth-child(5) { grid-row: 3; }\n        .grid-content:last-child { grid-column-end: 2; }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    margin: 36px 61px;\n\n    .title {\n        margin-bottom: 36px;\n        font-family: 'Montserrat';\n        font-size: 22px;\n        color: rgba(12, 183, 148, 1);\n        text-align: center;\n        letter-spacing: 0.04em;\n    }\n\n    .landing-content-wrapper {\n        border: 1px solid rgba(219, 219, 219, 1);\n        cursor: pointer;\n\n        + .landing-content-wrapper { margin-top: 23px; }\n    }\n\n    .landing-headlines { display: flex; box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5); }\n    .headlines {\n        flex-grow: 1;\n        padding: 0 14px;\n        background-color: rgba(252, 252, 252, 1);\n        line-height: 42px;\n        font-family: 'Montserrat';\n        font-size: 15px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n    }\n\n    .landing-contents { display: flex; padding-top: 16px; padding-bottom: 62px; }\n    .contents {\n        max-width: 100%;\n        padding: 0 14px;\n        line-height: 24px;\n        font-family: 'Montserrat';\n        font-size: 18px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.04em;\n    }\n"], ["\n    margin: 36px 61px;\n\n    .title {\n        margin-bottom: 36px;\n        font-family: 'Montserrat';\n        font-size: 22px;\n        color: rgba(12, 183, 148, 1);\n        text-align: center;\n        letter-spacing: 0.04em;\n    }\n\n    .landing-content-wrapper {\n        border: 1px solid rgba(219, 219, 219, 1);\n        cursor: pointer;\n\n        + .landing-content-wrapper { margin-top: 23px; }\n    }\n\n    .landing-headlines { display: flex; box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5); }\n    .headlines {\n        flex-grow: 1;\n        padding: 0 14px;\n        background-color: rgba(252, 252, 252, 1);\n        line-height: 42px;\n        font-family: 'Montserrat';\n        font-size: 15px;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n    }\n\n    .landing-contents { display: flex; padding-top: 16px; padding-bottom: 62px; }\n    .contents {\n        max-width: 100%;\n        padding: 0 14px;\n        line-height: 24px;\n        font-family: 'Montserrat';\n        font-size: 18px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: center;\n        letter-spacing: 0.04em;\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _Wrapper = __webpack_require__(1665);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	var Landing = function (_React$Component) {
	    _inherits(Landing, _React$Component);
	
	    function Landing() {
	        _classCallCheck(this, Landing);
	
	        return _possibleConstructorReturn(this, (Landing.__proto__ || Object.getPrototypeOf(Landing)).apply(this, arguments));
	    }
	
	    _createClass(Landing, [{
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: 'landing', onClick: this.props.onClick },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'title' },
	                    'SEE HOW TO IMPOVE YOUR APP PERFORMANCE!'
	                ),
	                _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { minWidth: 768 },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'landing-content-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-headlines' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'headlines' },
	                                'App Name'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'headlines' },
	                                'Description'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'headlines' },
	                                'Graphics'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-contents' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'contents' },
	                                'View app title diagnosis and recommendations.'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'contents' },
	                                'View app desciption diagnosis and recommendations.'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'contents' },
	                                'View app graphics diagnosis and recommendations.'
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    _reactResponsive2.default,
	                    { maxWidth: 767 },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'landing-content-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-headlines' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'headlines' },
	                                'App Name'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-contents' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'contents' },
	                                'View app title diagnosis and recommendations.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'landing-content-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-headlines' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'headlines' },
	                                'Description'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-contents' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'contents' },
	                                'View app desciption diagnosis and recommendations.'
	                            )
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'landing-content-wrapper' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-headlines' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'headlines' },
	                                'Graphics'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'landing-contents' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'contents' },
	                                'View app graphics diagnosis and recommendations.'
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Landing;
	}(_react2.default.Component);
	
	exports.default = Landing;
	;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    align-self: baseline;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: 28px;\n    padding-bottom: 42px;\n    background-color: #fff;\n\n    .header-row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    \n    .rating-emoji { font-size: 32px; }\n    \n    .author span {\n        display: inline-block;\n        min-width: 130px;\n        padding: 4px 14px;\n        background-color: #a565bc;\n        text-align: center;\n        color: #fff;\n        border-radius: 30px;\n    }\n\n    .title {\n        margin-top: 14px;\n        margin-bottom: 14px;\n        border-bottom: 1px solid #eee;\n        padding-bottom: 7px;\n        min-height: 70px;\n        font-size: larger;\n        font-weight: 700;\n    }\n\n    .ratings {\n        position: absolute;\n        right: 28px;\n        bottom: 14px;\n        font-size: 14px;\n        color: #adff2f;\n    }\n\n    @media screen and (min-width: 481px) {\n        .content.collapsed {\n            position: relative;\n            padding-top: 50%;\n        }\n        .content.collapsed p {\n            position: absolute;\n            top: 0;\n            left: 0;\n            max-height: 100%;\n            overflow: hidden;\n        }\n\n        .content.collapsed {\n            position: relative;\n            padding-top: 50%;\n        }\n        .content.collapsed p {\n            position: absolute;\n            top: 0;\n            left: 0;\n            max-height: 100%;\n            overflow: hidden;\n        }\n    }\n"], ["\n    align-self: baseline;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    padding: 28px;\n    padding-bottom: 42px;\n    background-color: #fff;\n\n    .header-row {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n    \n    .rating-emoji { font-size: 32px; }\n    \n    .author span {\n        display: inline-block;\n        min-width: 130px;\n        padding: 4px 14px;\n        background-color: #a565bc;\n        text-align: center;\n        color: #fff;\n        border-radius: 30px;\n    }\n\n    .title {\n        margin-top: 14px;\n        margin-bottom: 14px;\n        border-bottom: 1px solid #eee;\n        padding-bottom: 7px;\n        min-height: 70px;\n        font-size: larger;\n        font-weight: 700;\n    }\n\n    .ratings {\n        position: absolute;\n        right: 28px;\n        bottom: 14px;\n        font-size: 14px;\n        color: #adff2f;\n    }\n\n    @media screen and (min-width: 481px) {\n        .content.collapsed {\n            position: relative;\n            padding-top: 50%;\n        }\n        .content.collapsed p {\n            position: absolute;\n            top: 0;\n            left: 0;\n            max-height: 100%;\n            overflow: hidden;\n        }\n\n        .content.collapsed {\n            position: relative;\n            padding-top: 50%;\n        }\n        .content.collapsed p {\n            position: absolute;\n            top: 0;\n            left: 0;\n            max-height: 100%;\n            overflow: hidden;\n        }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1667);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	__webpack_require__(2001);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	var ReviewBlock = function (_React$Component) {
	    _inherits(ReviewBlock, _React$Component);
	
	    function ReviewBlock(props) {
	        _classCallCheck(this, ReviewBlock);
	
	        var _this = _possibleConstructorReturn(this, (ReviewBlock.__proto__ || Object.getPrototypeOf(ReviewBlock)).call(this, props));
	
	        _this.authorName = props.review.author.name.label;
	        _this.rating = parseInt(props.review["im:rating"].label);
	
	        _this.title = props.review.title.label;
	        _this.review = props.review.content.label;
	
	        _this.state = { isExpanded: props.isExpanded };
	        return _this;
	    }
	
	    _createClass(ReviewBlock, [{
	        key: "componentWillReceiveProps",
	        value: function componentWillReceiveProps(nextProps) {
	            this.setState({ isExpanded: nextProps.isExpanded });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            {
	                var starsComponent = Array.apply(null, Array(this.rating)).map(function (value, index) {
	                    return _react2.default.createElement("i", { key: index, className: "fa fa-star" });
	                }.bind(this));
	            }
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: this.props.className },
	                _react2.default.createElement(
	                    "div",
	                    { className: "header-row" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "rating-emoji" },
	                        this.rating >= 4 && _react2.default.createElement("i", { className: "far fa-smile" }) || _react2.default.createElement("i", { className: "far fa-meh" })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "author" },
	                        _react2.default.createElement(
	                            "span",
	                            null,
	                            this.authorName
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "title" },
	                    this.title
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "content " + (this.state.isExpanded && "expanded" || "collapsed") },
	                    _react2.default.createElement("p", { dangerouslySetInnerHTML: {
	                            __html: this.state.isExpanded && this.review.replace("\r\n", "<br /><br />").replace(/[\r\n]/gi, "<br /><br />") || this.review
	                        } })
	                ),
	                _react2.default.createElement(
	                    "div",
	                    { className: "ratings" },
	                    starsComponent
	                )
	            );
	        }
	    }]);
	
	    return ReviewBlock;
	}(_react2.default.Component);
	
	exports.default = ReviewBlock;
	;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    opacity: 0;\n    transition: .3s;\n\n    .section-selector-wrapper {\n        margin: 0 18px auto;\n        border: 1px solid rgba(151, 151, 151, 1);\n        border-radius: 22px;\n        text-transform: uppercase;\n    }\n\n    .section-selector { text-align: center; }\n\n    .section-selected {\n        position: relative;\n        display: inline-block;\n        width: auto;\n        line-height: 43px;\n        font-family: 'Montserrat';\n        font-size: 15px;\n        color: rgba(35, 31, 32, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n    }\n    .section-selected:after {\n        position: absolute;\n        top: 46%; right: -21px;\n        display: inline-block;\n        content: '';\n        width: 5px; height: 5px;\n        border: 1px solid rgba(158, 163, 180, 1);\n        border-top-width: 0;\n        border-left-width: 0;\n        transform: translateY(-50%) rotate(45deg);\n        transition: .3s;\n    }\n    .selecting .section-selected:after { transform: translateY(0%) rotate(225deg); }\n\n    .section-options {\n        position: absolute;\n        top: -100%; right: 20%;\n        height: 0;\n        border: 1px solid #eee;\n        padding: 0 28px;\n        background-color: rgba(255, 255, 255, 1);\n        opacity: 0;\n        overflow: hidden;\n        z-index: 1;\n        box-shadow: 0 6px 10px 0 rgba(200, 200, 200, 0.1);\n        border-radius: 5px;\n    }\n    .selecting .section-options {\n        top: 100%; right: 0;\n        height: auto;\n        text-align: center;\n        opacity: 1;\n        transition: .3s;\n    }\n\n    .section-options .options { position: relative; line-height: 62px;}\n    .section-options .options:not(:last-child):after {\n        position: absolute;\n        bottom: 0;\n        display: block;\n        content: '';\n        width: 100%; height: 1px;\n        background-color: #ddd;\n    }\n"], ["\n    opacity: 0;\n    transition: .3s;\n\n    .section-selector-wrapper {\n        margin: 0 18px auto;\n        border: 1px solid rgba(151, 151, 151, 1);\n        border-radius: 22px;\n        text-transform: uppercase;\n    }\n\n    .section-selector { text-align: center; }\n\n    .section-selected {\n        position: relative;\n        display: inline-block;\n        width: auto;\n        line-height: 43px;\n        font-family: 'Montserrat';\n        font-size: 15px;\n        color: rgba(35, 31, 32, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n    }\n    .section-selected:after {\n        position: absolute;\n        top: 46%; right: -21px;\n        display: inline-block;\n        content: '';\n        width: 5px; height: 5px;\n        border: 1px solid rgba(158, 163, 180, 1);\n        border-top-width: 0;\n        border-left-width: 0;\n        transform: translateY(-50%) rotate(45deg);\n        transition: .3s;\n    }\n    .selecting .section-selected:after { transform: translateY(0%) rotate(225deg); }\n\n    .section-options {\n        position: absolute;\n        top: -100%; right: 20%;\n        height: 0;\n        border: 1px solid #eee;\n        padding: 0 28px;\n        background-color: rgba(255, 255, 255, 1);\n        opacity: 0;\n        overflow: hidden;\n        z-index: 1;\n        box-shadow: 0 6px 10px 0 rgba(200, 200, 200, 0.1);\n        border-radius: 5px;\n    }\n    .selecting .section-options {\n        top: 100%; right: 0;\n        height: auto;\n        text-align: center;\n        opacity: 1;\n        transition: .3s;\n    }\n\n    .section-options .options { position: relative; line-height: 62px;}\n    .section-options .options:not(:last-child):after {\n        position: absolute;\n        bottom: 0;\n        display: block;\n        content: '';\n        width: 100%; height: 1px;\n        background-color: #ddd;\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(743);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(744);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(745);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(746);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _Wrapper = __webpack_require__(1669);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var DropdownList = function (_React$Component) {
	    _inherits(DropdownList, _React$Component);
	
	    function DropdownList() {
	        _classCallCheck(this, DropdownList);
	
	        var _this = _possibleConstructorReturn(this, (DropdownList.__proto__ || Object.getPrototypeOf(DropdownList)).call(this));
	
	        _this.state = {
	            isSelecting: false,
	            selectedIndex: 0
	        };
	        return _this;
	    }
	
	    _createClass(DropdownList, [{
	        key: "onSelect",
	        value: function onSelect(option) {
	            this.setState({ isSelecting: false });
	            for (var i = 0; i < this.props.options.length; i++) {
	                if (this.props.options[i].key == option.key) {
	                    this.setState({ selectedIndex: i });
	                    break;
	                }
	            }
	            this.props.onClick(option);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this2 = this;
	
	            {
	                var $this = this;
	                var optionComponents = this.props.options.map(function (option) {
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "options", key: option.key, onClick: function onClick() {
	                                $this.onSelect(option);
	                            } },
	                        option.text
	                    );
	                });
	            }
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: "section-selector-wrapper",
	                    onClick: function onClick() {
	                        _this2.setState({ isSelecting: !_this2.state.isSelecting });
	                    }
	                },
	                _react2.default.createElement(
	                    "div",
	                    { className: "section-selector " + (this.state.isSelecting ? "selecting" : "") },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "section-selected" },
	                        this.props.options[this.state.selectedIndex].text
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "section-options" },
	                        optionComponents
	                    )
	                )
	            );
	        }
	    }]);
	
	    return DropdownList;
	}(_react2.default.Component);
	
	var ScoreSummarySelects = function (_React$Component2) {
	    _inherits(ScoreSummarySelects, _React$Component2);
	
	    function ScoreSummarySelects(props) {
	        _classCallCheck(this, ScoreSummarySelects);
	
	        var _this3 = _possibleConstructorReturn(this, (ScoreSummarySelects.__proto__ || Object.getPrototypeOf(ScoreSummarySelects)).call(this, props));
	
	        _this3.availableOptions = [{ key: "app-name", text: "应用名称" }, { key: "app-description", text: "描述" }, { key: "app-graphics", text: "图像" }, { key: "app-ratings", text: "评分及评论" }];
	
	        _this3.appNameAnalyze = props.analyzes.appName;
	        _this3.appDescriptionAnalyze = props.analyzes.appDescription;
	        _this3.appGraphicsAnalyze = props.analyzes.appGraphics;
	        _this3.appRatingsAndReviewsAnalyze = props.analyzes.appRatingsAndReviews;
	
	        _this3.state = { className: _this3.availableOptions[0].key };
	        return _this3;
	    }
	
	    _createClass(ScoreSummarySelects, [{
	        key: "handleDropDownChange",
	        value: function handleDropDownChange(option) {
	            this.setState({ className: option.key });
	        }
	    }, {
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            setTimeout(function () {
	                this.setState({ opacity: 1 });
	            }.bind(this), 1);
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _this4 = this;
	
	            console.log(' data : ' + this.props.data);
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { style: { opacity: this.state.opacity || 0 }, className: this.state.className },
	                _react2.default.createElement(DropdownList, {
	                    options: this.availableOptions,
	                    onClick: function onClick(option) {
	                        _this4.handleDropDownChange(option);
	                    }
	                }),
	                this.state.className == "app-description" && _react2.default.createElement(_index4.default
	                // appDescription={this.props.app.description}
	                // isLengthOK={true}
	                // isSpellCheckOK={true}
	                // lengthLength={this.props.app.description.length}
	                // data={this.props.data}
	                , { data: this.appDescriptionAnalyze
	                }) || this.state.className == "app-graphics" && _react2.default.createElement(_index6.default
	                // screenshotUrls={this.props.app.screenshotUrls}
	                // isQuantityOK={true}
	                // isShapeOK={false}
	                // isPreviewVideoOK={false}
	                // data={this.props.data}
	                , { data: this.appGraphicsAnalyze
	                }) || this.state.className == "app-name" && _react2.default.createElement(_index2.default
	                // appName={this.props.app.trackName}
	                // isFormatOK={true}
	                // isBrandingOK={true}
	                // isLengthOK={true}
	                // brandingLength={15}
	                // lengthLength={30}
	                // data={this.props.data}
	                , { data: this.appNameAnalyze
	                }) || _react2.default.createElement(_index8.default, {
	                    data: this.appRatingsAndReviewsAnalyze
	                })
	            );
	        }
	    }]);
	
	    return ScoreSummarySelects;
	}(_react2.default.Component);
	
	exports.default = ScoreSummarySelects;
	;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(["\n    opacity: 0;\n    transition: .3s;\n\n    [role='tablist'] {\n        display: flex;\n        background-color: rgba(252, 252, 252, 1);\n        box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n    }\n\n    [role='tab'] {\n        flex-grow: 1;\n        position:relative;\n        margin: 0;\n        padding: 0;\n        line-height: 42px;\n        font-family: 'Montserrat';\n        font-size: 19px;\n        color: rgba(147, 147, 147, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n\n        :after {\n            position: absolute;\n            right: 0; bottom: 0; left: 0;\n            display: inline-block;\n            content: '';\n            height: 0;\n            background-color: rgba(71, 178, 170, 1);\n            transition: .1s;\n        }\n    }\n    \n    [role='tab'][aria-selected='true'] {\n        border: 1px solid rgba(235, 235, 235, 1);\n        background-color: rgba(241, 241, 241, 1);\n        color: rgba(64, 55, 57, 1);\n\n        :after { height: 4px; transition: .3s; }\n    }\n"], ["\n    opacity: 0;\n    transition: .3s;\n\n    [role='tablist'] {\n        display: flex;\n        background-color: rgba(252, 252, 252, 1);\n        box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n    }\n\n    [role='tab'] {\n        flex-grow: 1;\n        position:relative;\n        margin: 0;\n        padding: 0;\n        line-height: 42px;\n        font-family: 'Montserrat';\n        font-size: 19px;\n        color: rgba(147, 147, 147, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n\n        :after {\n            position: absolute;\n            right: 0; bottom: 0; left: 0;\n            display: inline-block;\n            content: '';\n            height: 0;\n            background-color: rgba(71, 178, 170, 1);\n            transition: .1s;\n        }\n    }\n    \n    [role='tab'][aria-selected='true'] {\n        border: 1px solid rgba(235, 235, 235, 1);\n        background-color: rgba(241, 241, 241, 1);\n        color: rgba(64, 55, 57, 1);\n\n        :after { height: 4px; transition: .3s; }\n    }\n"]);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rcTabs = __webpack_require__(480);
	
	var _rcTabs2 = _interopRequireDefault(_rcTabs);
	
	var _TabContent = __webpack_require__(329);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabBar = __webpack_require__(2605);
	
	var _TabBar2 = _interopRequireDefault(_TabBar);
	
	var _index = __webpack_require__(743);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(744);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(745);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(746);
	
	var _index8 = _interopRequireDefault(_index7);
	
	__webpack_require__(429);
	
	var _Wrapper = __webpack_require__(1671);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var ScoreSummaryTabs = function (_React$Component) {
	    _inherits(ScoreSummaryTabs, _React$Component);
	
	    function ScoreSummaryTabs(props) {
	        _classCallCheck(this, ScoreSummaryTabs);
	
	        var _this = _possibleConstructorReturn(this, (ScoreSummaryTabs.__proto__ || Object.getPrototypeOf(ScoreSummaryTabs)).call(this, props));
	
	        _this.appNameAnalyze = props.analyzes.appName;
	        _this.appDescriptionAnalyze = props.analyzes.appDescription;
	        _this.appGraphicsAnalyze = props.analyzes.appGraphics;
	        _this.appRatingsAndReviewsAnalyze = props.analyzes.appRatingsAndReviews;
	
	        _this.state = {};
	        return _this;
	    }
	
	    _createClass(ScoreSummaryTabs, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            setTimeout(function () {
	                this.setState({ opacity: 1 });
	            }.bind(this), 1);
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { style: { opacity: this.state.opacity || 0 } },
	                _react2.default.createElement(
	                    _rcTabs2.default,
	                    {
	                        className: 'tabs'
	                        // onChange={callback}
	                        , renderTabBar: function renderTabBar() {
	                            return _react2.default.createElement(_TabBar2.default, null);
	                        },
	                        renderTabContent: function renderTabContent() {
	                            return _react2.default.createElement(_TabContent2.default, null);
	                        }
	                    },
	                    _react2.default.createElement(
	                        _rcTabs.TabPane,
	                        { tab: '\u5E94\u7528\u540D\u79F0', key: '1' },
	                        _react2.default.createElement(_index2.default
	                        // appName={this.props.app.trackName}
	                        // isFormatOK={true}
	                        // isBrandingOK={true}
	                        // isLengthOK={true}
	                        // brandingLength={15}
	                        // lengthLength={30}
	                        // data={this.props.data}
	                        , { data: this.appNameAnalyze
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _rcTabs.TabPane,
	                        { tab: '\u63CF\u8FF0', key: '2' },
	                        _react2.default.createElement(_index4.default
	                        // appDescription={this.props.app.description}
	                        // isLengthOK={true}
	                        // isSpellCheckOK={true}
	                        // lengthLength={this.props.app.description.length}
	                        // data={this.props.data}
	                        , { data: this.appDescriptionAnalyze
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _rcTabs.TabPane,
	                        { tab: '\u56FE\u50CF', key: '3' },
	                        _react2.default.createElement(_index6.default
	                        // screenshotUrls={this.props.app.screenshotUrls}
	                        // isQuantityOK={true}
	                        // isShapeOK={false}
	                        // isPreviewVideoOK={false}
	                        // data={this.props.data}
	                        , { data: this.appGraphicsAnalyze
	                        })
	                    ),
	                    _react2.default.createElement(
	                        _rcTabs.TabPane,
	                        { tab: '\u8BC4\u5206\u53CA\u8BC4\u8BBA', key: '4' },
	                        _react2.default.createElement(_index8.default
	                        // appId={this.props.app.trackId}
	                        // country={this.props.country}
	                        // appAverageUserRating={this.props.app.averageUserRating}
	                        // appUserRatingCount={this.props.app.userRatingCount}
	                        // data={this.props.data}
	                        , { data: this.appRatingsAndReviewsAnalyze
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ScoreSummaryTabs;
	}(_react2.default.Component);
	
	exports.default = ScoreSummaryTabs;
	;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .content-wrapper {\n    position: relative;\n    margin: 0 auto;\n    max-width: 1200px;\n    min-height: 708px;\n    width: 100%;\n    background-color: rgb(249, 249, 249);\n  }\n\n  .loading-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 700;\n    text-transform: uppercase;\n    z-index: 1;\n\n    :before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      content: \'\';\n      background-color: rgba(0, 0, 0, .5);\n    }\n\n    span { font-size: 28px; text-shadow: 0 0 1px #000; }\n  }\n\n  .app-summaries {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 36px;\n    padding: 40px 42px;\n    padding-bottom: 0;\n  }\n\n  .grid-score-summaries { padding: 26px 43px 36px 43px; }\n  .grid-score-summaries .summary-title {\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    font-weight: 600;\n    color: rgba(64, 55, 57, 1);\n    text-align: left;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n  }\n\n  .consultant-request-wrapper {\n    position: relative;\n    margin: 0 auto;\n    margin-bottom: 28px;\n    border: 1px solid rgba(60, 211, 207, 1);\n    width: 600px;\n    background-color: rgba(12, 183, 148, 1);\n    cursor: pointer;\n    border-radius: 30px;\n    box-shadow: 0px 4px 0px 0px rgba(37, 156, 153, 1);\n\n    :active { top: 2px; box-shadow: 0px 2px 0px 0px rgba(37, 156, 153, 1); }\n  }\n  .consultant-request-wrapper .consultant-request {\n    padding: 17px 28px;\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    color: rgba(255, 255, 255, 1);\n    text-align: center;\n    letter-spacing: 0.01em;\n    text-transform: uppercase;\n  }\n\n  @media screen and (max-width: 767px) {\n    .content-wrapper { padding: 0 16px auto; }\n    \n    .app-summaries { flex-wrap: wrap; margin-bottom: 0; padding: 21px 19px; }\n\n    .grid-score-summaries { padding: 32px 5px 11px 5px; }\n    .summary-title { padding: 0 17px; text-align: justify; }\n\n    .consultant-request-wrapper { width: auto; margin: 0 21px auto; margin-bottom: 28px; border-radius: 55px; }\n  }\n'], ['\n  .content-wrapper {\n    position: relative;\n    margin: 0 auto;\n    max-width: 1200px;\n    min-height: 708px;\n    width: 100%;\n    background-color: rgb(249, 249, 249);\n  }\n\n  .loading-overlay {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-weight: 700;\n    text-transform: uppercase;\n    z-index: 1;\n\n    :before {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      left: 0;\n      display: block;\n      content: \'\';\n      background-color: rgba(0, 0, 0, .5);\n    }\n\n    span { font-size: 28px; text-shadow: 0 0 1px #000; }\n  }\n\n  .app-summaries {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 36px;\n    padding: 40px 42px;\n    padding-bottom: 0;\n  }\n\n  .grid-score-summaries { padding: 26px 43px 36px 43px; }\n  .grid-score-summaries .summary-title {\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    font-weight: 600;\n    color: rgba(64, 55, 57, 1);\n    text-align: left;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n  }\n\n  .consultant-request-wrapper {\n    position: relative;\n    margin: 0 auto;\n    margin-bottom: 28px;\n    border: 1px solid rgba(60, 211, 207, 1);\n    width: 600px;\n    background-color: rgba(12, 183, 148, 1);\n    cursor: pointer;\n    border-radius: 30px;\n    box-shadow: 0px 4px 0px 0px rgba(37, 156, 153, 1);\n\n    :active { top: 2px; box-shadow: 0px 2px 0px 0px rgba(37, 156, 153, 1); }\n  }\n  .consultant-request-wrapper .consultant-request {\n    padding: 17px 28px;\n    font-family: \'Montserrat\';\n    font-size: 22px;\n    color: rgba(255, 255, 255, 1);\n    text-align: center;\n    letter-spacing: 0.01em;\n    text-transform: uppercase;\n  }\n\n  @media screen and (max-width: 767px) {\n    .content-wrapper { padding: 0 16px auto; }\n    \n    .app-summaries { flex-wrap: wrap; margin-bottom: 0; padding: 21px 19px; }\n\n    .grid-score-summaries { padding: 32px 5px 11px 5px; }\n    .summary-title { padding: 0 17px; text-align: justify; }\n\n    .consultant-request-wrapper { width: auto; margin: 0 21px auto; margin-bottom: 28px; border-radius: 55px; }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var AsoAnalyticWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(AsoAnalyticWrapper);

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _redux = __webpack_require__(56);
	
	var _sentiment = __webpack_require__(3245);
	
	var _sentiment2 = _interopRequireDefault(_sentiment);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactResponsive = __webpack_require__(159);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	var _lodash = __webpack_require__(129);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _writeGood = __webpack_require__(3326);
	
	var _writeGood2 = _interopRequireDefault(_writeGood);
	
	var _index = __webpack_require__(214);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Logo = __webpack_require__(173);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Menu = __webpack_require__(213);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index3 = __webpack_require__(212);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(1654);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(1656);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _index9 = __webpack_require__(1666);
	
	var _index10 = _interopRequireDefault(_index9);
	
	var _index11 = __webpack_require__(1672);
	
	var _index12 = _interopRequireDefault(_index11);
	
	var _index13 = __webpack_require__(1670);
	
	var _index14 = _interopRequireDefault(_index13);
	
	__webpack_require__(941);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _Wrapper = __webpack_require__(1673);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	// -- React Libraries
	
	
	// -- Libraries
	
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	
	// Components
	
	
	// Styles
	
	var dataSet1 = [{
	  cat: "App Name",
	  subCat: 'Format',
	  result: 'Remind',
	  detail: 'You should use the <span>"Brand Name - Keywords"</span> format. You can rank higher for the keywords in your name.',
	  tip1: 'To include relevant keywords in app name.',
	  status: '15 character(s)'
	}, {
	  cat: "App Name",
	  subCat: 'Branding',
	  result: 'Great',
	  detail: 'The brand name length is optimal for proper on every device.',
	  tip1: 'For optimal presentation on every device.'
	}, {
	  cat: "App Name",
	  subCat: 'Length',
	  result: 'Great',
	  detail: 'You are taking maximum advantage from the title length.',
	  tip1: 'The maximum length of an app name is 30-characters long.'
	}, {
	  cat: 'Description',
	  subCat: 'Length',
	  result: 'Great',
	  detail: '90% of top 100 apps use less than 3385 characters for their description in the US app store.',
	  tip1: 'Based on the descripitons from the top 100 apps 90% top 100 apps use more than 589 characters, 90% of top 100 apps use less than 3385 characters.',
	  tip2: 'Only average 5% of users will click the “more’ button to view the expanded description.',
	  tip3: ' Use conise and eye-catching words, and include call-to-action to get the users excited.'
	}, {
	  cat: 'Description',
	  subCat: 'Spell Check',
	  result: 'Great',
	  detail: 'There is no spelling mistake in your description'
	}, {
	  cat: 'Graphics',
	  subCat: 'Quantity',
	  result: 'Great',
	  detail: 'Your made used of 5 screenshots.',
	  tip1: 'Showcasee more function and features of the app.'
	}, {
	  cat: 'Graphics',
	  subCat: 'SHAPE',
	  result: 'Great',
	  detail: 'Keep your screenshots vertical.',
	  tip1: 'User can see more screenshots on the narrow screens when the screenshots are vertical.',
	  tip2: 'Adding text on your screenshot could help, but make sure they are on a clean background.'
	}, {
	  cat: 'Graphics',
	  subCat: 'PREVIEW VIDEO',
	  result: 'Remind',
	  detail: 'Your should add a preview video on screenshots.',
	  tip1: 'Use the first 5 seconds to grab the viewer’s attention.',
	  tip2: 'Focus on the best features, instead of all features.',
	  tip3: 'Your video should make sense even with the sound turned off'
	  // tip4: ' Inclue a call-to-action.'
	}];
	
	var _getReviews = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(appId, country, page, maxPage) {
	    var response, entries, links, reviews, lastLink, lastPageDescription, lastPage;
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            if (page <= 0) page = 1;
	
	            if (!(page > maxPage)) {
	              _context.next = 3;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 3:
	            _context.next = 5;
	            return _axios2.default.post('https://itunes.apple.com/' + country + '/rss/customerreviews/page=' + page + '/id=' + appId + '/sortBy=mostRecent/json');
	
	          case 5:
	            response = _context.sent;
	
	            if (response) {
	              _context.next = 8;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 8:
	            if (response.data) {
	              _context.next = 10;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 10:
	            if (response.data.feed) {
	              _context.next = 12;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 12:
	            if (response.data.feed.entry) {
	              _context.next = 14;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 14:
	            if (!(response.data.feed.entry.length <= 1)) {
	              _context.next = 16;
	              break;
	            }
	
	            return _context.abrupt('return', []);
	
	          case 16:
	            entries = response.data.feed.entry;
	            links = response.data.feed.link ? response.data.feed.link : {};
	            reviews = entries.filter(function (entry, index) {
	              return index > 0;
	            }).filter(function (entry) {
	              return entry["im:rating"];
	            }).filter(function (entry) {
	              return entry["im:rating"].label;
	            });
	
	
	            links = links.filter(function (link) {
	              return link.attributes && link.attributes.rel && link.attributes.rel == "last" && link.attributes.href;
	            });
	            if (links.length > 0) {
	              lastLink = links[0].attributes.href.toString();
	              lastPageDescription = new RegExp(/\/page=[0-9]+\//i).exec(lastLink).toString();
	
	              if (lastPageDescription && lastPageDescription.length > 0) {
	                lastPage = parseInt(/[0-9]+/.exec(lastPageDescription).toString());
	
	                if (lastPage < maxPage) maxPage = lastPage;
	              }
	            }
	
	            _context.t0 = reviews;
	            _context.next = 24;
	            return _getReviews(appId, country, page + 1, maxPage);
	
	          case 24:
	            _context.t1 = _context.sent;
	            return _context.abrupt('return', _context.t0.concat.call(_context.t0, _context.t1));
	
	          case 26:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function _getReviews(_x, _x2, _x3, _x4) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var AsoAnalytic = function (_Component) {
	  _inherits(AsoAnalytic, _Component);
	
	  function AsoAnalytic(props) {
	    _classCallCheck(this, AsoAnalytic);
	
	    var _this = _possibleConstructorReturn(this, (AsoAnalytic.__proto__ || Object.getPrototypeOf(AsoAnalytic)).call(this, props));
	
	    _this.getAnalyzes = function () {
	      return {
	        appName: this.state.appName,
	        appDescription: this.state.appDescription,
	        appGraphics: this.state.appGraphics,
	        appRatingsAndReviews: this.state.appRatingsAndReviews
	      };
	    };
	
	    _this.getReviews = function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(appId, maxPageOfReviews) {
	        var countryCode, reviews;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                countryCode = this.state.country ? this.state.country.toUpperCase() : "US";
	                _context2.next = 3;
	                return _getReviews(appId, countryCode, 1, maxPageOfReviews);
	
	              case 3:
	                reviews = _context2.sent;
	
	                this.analyzeReviews(reviews);
	
	              case 5:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      return function (_x5, _x6) {
	        return _ref2.apply(this, arguments);
	      };
	    }().bind(_this);
	
	    _this.analyzeAppName = function (appName) {
	      var isFormatOk = false;
	      var isBrandOk = false;
	      var isLengthOk = false;
	      var brandLength = 0;
	      var nameLength = 0;
	
	      var appNameDivider = appName.indexOf(":");
	      if (appNameDivider === -1) appNameDivider = appName.indexOf("-");
	
	      var brandName = appNameDivider !== -1 && appName.substring(0, appNameDivider) || appName;
	
	      var appNameFormatData = _lodash2.default.find(dataSet1, { cat: "App Name", subCat: 'Format' });
	      var appNameBrandingData = _lodash2.default.find(dataSet1, { cat: "App Name", subCat: 'Branding' });
	      var appNameLengthData = _lodash2.default.find(dataSet1, { cat: "App Name", subCat: 'Length' });
	
	      brandLength = brandName.length;
	      nameLength = appName.length;
	
	      isFormatOk = appNameDivider !== -1;
	      isBrandOk = brandLength <= 24;
	      isLengthOk = nameLength >= 30;
	
	      appNameFormatData.result = isFormatOk && 'Great' || 'Remind';
	      appNameBrandingData.result = isBrandOk && 'Great' || 'Remind';
	      appNameLengthData.result = isLengthOk && 'Great' || 'Remind';
	
	      appNameBrandingData.status = brandLength + ' character(s)';
	      appNameLengthData.status = nameLength + ' character(s)';
	
	      dataSet1[0] = appNameFormatData;
	      dataSet1[1] = appNameBrandingData;
	      dataSet1[2] = appNameLengthData;
	
	      var scores = (isFormatOk ? 1 : 0) + (isBrandOk ? 1 : 0) + (isLengthOk ? 1 : 0);
	
	      this.setState({
	        scores: {
	          appName: scores,
	          appDescription: this.state.scores.appDescription,
	          appGraphics: this.state.scores.appGraphics,
	          appRatingsAndReviews: this.state.scores.appRatingsAndReviews
	        },
	        appName: {
	          name: appName,
	          isFormatOk: isFormatOk,
	          isBrandOk: isBrandOk,
	          isLengthOk: isLengthOk,
	          brandLength: brandLength,
	          nameLength: nameLength
	        }
	      });
	    };
	
	    _this.analyzeAppDescription = function (description) {
	      var isLengthOk = false;
	      var isSpellOk = false;
	      var descriptionLength = 0;
	      var spellLines = [];
	
	      var descriptionLengthData = _lodash2.default.find(dataSet1, { cat: "Description", subCat: 'Length' });
	      var descriptionSpellCheckData = _lodash2.default.find(dataSet1, { cat: "Description", subCat: 'Spell Check' });
	
	      descriptionLength = description.length;
	      spellLines = (0, _writeGood2.default)(description, { passive: false, adverb: false, weasel: false });
	
	      isLengthOk = descriptionLength > 590 && descriptionLength <= 3385;
	      isSpellOk = spellLines.length <= 0;
	
	      descriptionLengthData.result = isLengthOk && 'Great' || 'Remind';
	      descriptionSpellCheckData.result = isSpellOk && 'Great' || 'Remind';
	
	      descriptionLengthData.status = descriptionLength + ' character(s)';
	      descriptionSpellCheckData.suggestions = spellLines;
	
	      dataSet1[3] = descriptionLengthData;
	      dataSet1[4] = descriptionSpellCheckData;
	
	      var scores = (isLengthOk ? 1 : 0) + (isSpellOk ? 1 : 0);
	
	      this.setState({
	        scores: {
	          appName: this.state.scores.appName,
	          appDescription: scores,
	          appGraphics: this.state.scores.appGraphics,
	          appRatingsAndReviews: this.state.scores.appRatingsAndReviews
	        },
	        appDescription: {
	          description: description,
	          isLengthOk: isLengthOk,
	          isSpellOk: isSpellOk,
	          descriptionLength: descriptionLength,
	          spellLines: spellLines
	        }
	      });
	    };
	
	    _this.analyzeAppGraphics = function (screenshots) {
	      var isQuantityOk = false;
	      var isShapeOk = true;
	      var isPreviewVideoOk = false;
	
	      isQuantityOk = screenshots.length === 5;
	
	      var graphicsQuantityData = _lodash2.default.find(dataSet1, { cat: "Graphics", subCat: 'Quantity' });
	
	      graphicsQuantityData.result = isQuantityOk && 'Great' || 'Remind';
	
	      dataSet1[5] = graphicsQuantityData;
	
	      var scores = (isQuantityOk ? 1 : 0) + (isShapeOk ? 1 : 0) + (isPreviewVideoOk ? 1 : 0);
	
	      this.setState({
	        scores: {
	          appName: this.state.scores.appName,
	          appDescription: this.state.scores.appDescription,
	          appGraphics: scores,
	          appRatingsAndReviews: this.state.scores.appRatingsAndReviews
	        },
	        appGraphics: {
	          screenshots: screenshots,
	          isQuantityOk: isQuantityOk,
	          isShapeOk: isShapeOk,
	          isPreviewVideoOk: isPreviewVideoOk
	        }
	      });
	    };
	
	    _this.analyzeRating = function (appAverageUserRating, appUserRatingCount) {
	      var isRatingsOk = appAverageUserRating >= 4;
	
	      var scores = this.state.scores.appRatingsAndReviews + (isRatingsOk ? 1 : 0);
	
	      this.setState({
	        scores: {
	          appName: this.state.scores.appName,
	          appDescription: this.state.scores.appDescription,
	          appGraphics: this.state.scores.appGraphics,
	          appRatingsAndReviews: scores
	        },
	        appRatingsAndReviews: {
	          reviews: this.state.appRatingsAndReviews.reviews,
	          isRatingsOk: isRatingsOk,
	          isReviewsOk: this.state.appRatingsAndReviews.isReviewsOk,
	          averageRating: appAverageUserRating || 0,
	          appUserRatingCount: appUserRatingCount || 0,
	          sentimentAnalyze: this.state.sentimentAnalyze
	        }
	      });
	    };
	
	    _this.analyzeReviews = function (reviews) {
	      var isReviewsOk = false;
	      var PositiveScores = [];
	      var NegativeScores = [];
	      var NeutralScores = [];
	
	      if (reviews.length > 0) reviews.map(function (review) {
	        var sentimentAnalyze = new _sentiment2.default().analyze(review.content.label);
	        var positives = sentimentAnalyze.positive;
	        var negatives = sentimentAnalyze.negative;
	        if (positives.length > negatives.length) PositiveScores.push(1);else if (negatives.length > positives.length) NegativeScores.push(1);else NeutralScores.push(1);
	      });
	
	      PositiveScores = PositiveScores.length;
	      NegativeScores = NegativeScores.length;
	      NeutralScores = NeutralScores.length;
	      isReviewsOk = PositiveScores > NegativeScores;
	
	      var scores = this.state.scores.appRatingsAndReviews + (isReviewsOk ? 1 : 0);
	
	      this.setState({
	        scores: {
	          appName: this.state.scores.appName,
	          appDescription: this.state.scores.appDescription,
	          appGraphics: this.state.scores.appGraphics,
	          appRatingsAndReviews: scores
	        },
	        appRatingsAndReviews: {
	          reviews: reviews,
	          isRatingsOk: this.state.appRatingsAndReviews.isRatingsOk,
	          isReviewsOk: PositiveScores > NegativeScores,
	          averageRating: this.state.appRatingsAndReviews.averageRating,
	          appUserRatingCount: this.state.appRatingsAndReviews.appUserRatingCount,
	          sentimentAnalyze: {
	            positive: PositiveScores,
	            negative: NegativeScores,
	            neutral: NeutralScores
	          }
	        }
	      });
	    }.bind(_this);
	
	    _this.state = {
	      itunesLookUp: null,
	      isLanding: false,
	      scores: {
	        appName: 0,
	        appDescription: 0,
	        appGraphics: 0,
	        appRatingsAndReviews: 0
	      },
	      appName: {
	        name: '',
	        isFormatOk: false,
	        isBrandOk: false,
	        isLengthOk: false,
	        brandLength: 0,
	        nameLength: 0
	      },
	      appDescription: {
	        description: '',
	        isLengthOk: false,
	        isSpellOk: false,
	        descriptionLength: 0,
	        spellLines: []
	      },
	      appGraphics: {
	        screenshots: [],
	        isQuantityOk: false,
	        isShapeOk: false,
	        isPreviewVideoOk: false
	      },
	      appRatingsAndReviews: {
	        reviews: [],
	        isRatingsOk: false,
	        isReviewsOk: false,
	        averageRating: 0,
	        appUserRatingCount: 1,
	        sentimentAnalyze: {}
	      }
	    };
	
	    _this.getItunesStoreData = _this.getItunesStoreData.bind(_this);
	    return _this;
	  }
	
	  _createClass(AsoAnalytic, [{
	    key: 'getItunesStoreData',
	
	
	    //to be redux saga
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(appId, country) {
	        var API_PUBLIC_SEARCH, results, response, itunesLookUp;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                API_PUBLIC_SEARCH = 'https://itunes.apple.com/lookup';
	                results = [];
	                _context3.prev = 2;
	                _context3.next = 5;
	                return _axios2.default.post(API_PUBLIC_SEARCH, {}, { params: { id: appId, country: country, 'Authorization': 'Bear xsjsjsjsjkss' } });
	
	              case 5:
	                response = _context3.sent;
	
	
	                console.log('[getItunesStoreData] ', response.data.results); // error is not defined
	                results = response.data.results;
	                _context3.next = 13;
	                break;
	
	              case 10:
	                _context3.prev = 10;
	                _context3.t0 = _context3['catch'](2);
	
	                console.log('[getItunesStoreData] ', _context3.t0); // error is not defined
	
	              case 13:
	                itunesLookUp = results[0];
	
	
	                this.analyzeAppName(itunesLookUp.trackName);
	                this.analyzeAppDescription(itunesLookUp.description);
	                this.analyzeAppGraphics(itunesLookUp.screenshotUrls);
	                this.analyzeRating(itunesLookUp.averageUserRating, itunesLookUp.userRatingCount);
	
	                _context3.next = 20;
	                return this.getReviews(itunesLookUp.trackId, 5);
	
	              case 20:
	
	                results.length > 0 && this.setState({ itunesLookUp: itunesLookUp, asoReport: dataSet1 });
	                console.log(this.state.itunesLookUp);
	
	              case 22:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[2, 10]]);
	      }));
	
	      function getItunesStoreData(_x7, _x8) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getItunesStoreData;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      console.log(' componentWillReceiveProps');
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      console.log(' componentDidUpdate');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var params = this.props.match.params;
	
	
	      console.log(params.appId);
	      this.getItunesStoreData(params.appId, null);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _Wrapper2.default,
	        { className: 'page-wrapper' },
	        _react2.default.createElement(
	          _index2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(_Logo2.default, { isClickable: true, history: this.props.history }),
	            _react2.default.createElement(_Menu2.default, { history: this.props.history, auth: this.props.auth })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'content-wrapper' },
	            !this.state.itunesLookUp && _react2.default.createElement(
	              'div',
	              { className: 'loading-overlay' },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u8F7D\u5165\u4E2D'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'app-summaries' },
	              this.state.itunesLookUp != null && _react2.default.createElement(_index6.default, {
	                imgUrl: this.state.itunesLookUp.artworkUrl100,
	                appName: this.state.itunesLookUp.trackName,
	                publisher: this.state.itunesLookUp.sellerName,
	                currency: this.state.itunesLookUp.currency,
	                price: this.state.itunesLookUp.price,
	                category: this.state.itunesLookUp.genres,
	                version: this.state.itunesLookUp.version,
	                releaseDate: this.state.itunesLookUp.releaseDate,
	                lastUpdated: this.state.itunesLookUp.currentVersionReleaseDate
	              }),
	              this.state.asoReport && _react2.default.createElement(_index8.default, {
	                score: this.state.score,
	                scores: this.state.scores,
	                maxScore: this.maxScore,
	                countryCode: this.props.countryCode,
	                report: dataSet1 })
	            ),
	            this.state.isLanding && _react2.default.createElement(_index10.default, { onClick: function onClick() {
	                _this2.setState({ isLanding: false });
	              } }) || this.state.itunesLookUp && _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                { minWidth: 768 },
	                _react2.default.createElement(_index12.default, {
	                  app: this.state.itunesLookUp,
	                  data: this.state.asoReport,
	                  country: this.state.country ? this.state.country.toUpperCase() : "US",
	                  analyzes: this.getAnalyzes()
	                })
	              ),
	              _react2.default.createElement(
	                _reactResponsive2.default,
	                { maxWidth: 767 },
	                _react2.default.createElement(_index14.default, {
	                  app: this.state.itunesLookUp,
	                  data: this.state.asoReport,
	                  country: this.state.country ? this.state.country.toUpperCase() : "US",
	                  analyzes: this.getAnalyzes()
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'consultant-request-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'consultant-request', onClick: function onClick() {
	                  return document.location = "https://gogochart.cn/Contact-Us.html";
	                } },
	              '\u5373\u65F6\u83B7\u5F97\u514D\u8D39\u54A8\u8BE2\uFF01'
	            )
	          )
	        ),
	        _react2.default.createElement(_index4.default, null)
	      );
	    }
	  }]);
	
	  return AsoAnalytic;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setApp: function setApp(app) {
	      return dispatch(appSelected(app));
	    },
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	  };
	}
	function mapStateToProps(state) {
	  var campaign = state.get('deep').campaign;
	  return {
	    search: state.get('search'),
	    campaign: campaign,
	    currentApp: state.getIn(['App', 'currentApp']),
	    secondApp: state.getIn(['App', 'secondApp']),
	    searchTerm: state.getIn(['App', 'searchTerm']),
	    countryCode: state.getIn(['ItunesSearch', 'countryCode']) && 'US'
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AsoAnalytic);

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-evenly;\n    padding-right: 14px;\n\n    dl {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        margin: 0;\n        padding: 0;\n        text-align: center;\n    }\n    dt, dd { margin: 0; font-family: \'Roboto\'; }\n    dt {\n        margin-bottom: 13px;\n        font-size: 14px;\n        color: rgba(147, 147, 147, 1);\n        text-align: center;\n    }\n    dd {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 30px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 0.02em;\n    }\n\n    .cost {\n        padding-right: 14px;\n        \n        dd { display: flex; align-items: center; }\n        img { margin-left: 21px; width: 12px; height: 18px; }\n        // img.arrow-up { margin-bottom: 14px;}\n    }\n\n    .rate {\n        div {\n            display: inline-block;\n            margin-left: 11px;\n            border: 2px solid rgba(207, 201, 222, 1);\n            height: 21px;\n            width: 21px;\n            border-radius: 21px;\n        }\n    }\n\n    &.breakdown {\n        justify-content: space-between;\n        width: 275px;\n        \n        dt { font-size: 12px; }\n        dd { font-size: 21px; }\n\n        //.rate { text-align: right; }\n    }\n\n    @media screen and (max-width: 767px) {\n        width: 100%;\n        padding: 0;\n\n        &.breakdown {\n            justify-content: center;\n            margin-bottom: 14px;\n            width: 100%;\n            padding-right: 7px;\n        }\n    }\n\n    @media screen and (max-width: 480px) {\n        flex-grow: 1;\n        justify-content: center;\n\n        dl:not(:only-child) {\n            margin-bottom: 14px;\n            width: 50%;\n\n            dt { font-size: 12px; }\n            dd {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 16px;\n            }\n        }\n\n        .cost { padding-right: 7px; }\n    }\n'], ['\n    display: flex;\n    justify-content: space-evenly;\n    padding-right: 14px;\n\n    dl {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        margin: 0;\n        padding: 0;\n        text-align: center;\n    }\n    dt, dd { margin: 0; font-family: \'Roboto\'; }\n    dt {\n        margin-bottom: 13px;\n        font-size: 14px;\n        color: rgba(147, 147, 147, 1);\n        text-align: center;\n    }\n    dd {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 30px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 0.02em;\n    }\n\n    .cost {\n        padding-right: 14px;\n        \n        dd { display: flex; align-items: center; }\n        img { margin-left: 21px; width: 12px; height: 18px; }\n        // img.arrow-up { margin-bottom: 14px;}\n    }\n\n    .rate {\n        div {\n            display: inline-block;\n            margin-left: 11px;\n            border: 2px solid rgba(207, 201, 222, 1);\n            height: 21px;\n            width: 21px;\n            border-radius: 21px;\n        }\n    }\n\n    &.breakdown {\n        justify-content: space-between;\n        width: 275px;\n        \n        dt { font-size: 12px; }\n        dd { font-size: 21px; }\n\n        //.rate { text-align: right; }\n    }\n\n    @media screen and (max-width: 767px) {\n        width: 100%;\n        padding: 0;\n\n        &.breakdown {\n            justify-content: center;\n            margin-bottom: 14px;\n            width: 100%;\n            padding-right: 7px;\n        }\n    }\n\n    @media screen and (max-width: 480px) {\n        flex-grow: 1;\n        justify-content: center;\n\n        dl:not(:only-child) {\n            margin-bottom: 14px;\n            width: 50%;\n\n            dt { font-size: 12px; }\n            dd {\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                font-size: 16px;\n            }\n        }\n\n        .cost { padding-right: 7px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1675);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _index = __webpack_require__(736);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _arrow_green = __webpack_require__(1414);
	
	var _arrow_green2 = _interopRequireDefault(_arrow_green);
	
	var _arrow_green3 = __webpack_require__(1415);
	
	var _arrow_green4 = _interopRequireDefault(_arrow_green3);
	
	var _arrowRed = __webpack_require__(1412);
	
	var _arrowRed2 = _interopRequireDefault(_arrowRed);
	
	var _arrowRed3 = __webpack_require__(1413);
	
	var _arrowRed4 = _interopRequireDefault(_arrowRed3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	// -- Components
	
	
	// -- Resources
	
	
	var CampaignDashboard = function (_React$Component) {
	    _inherits(CampaignDashboard, _React$Component);
	
	    function CampaignDashboard(props) {
	        _classCallCheck(this, CampaignDashboard);
	
	        var _this = _possibleConstructorReturn(this, (CampaignDashboard.__proto__ || Object.getPrototypeOf(CampaignDashboard)).call(this, props));
	
	        _this.CPA = "---";
	        _this.CR = "---";
	
	        var PerformanceCPAs = 0;
	        var PerformanceCRs = 0;
	        var DiscoveryCPAs = 0;
	        var DiscoveryCRs = 0;
	        var NumberOfPerformace = 0;
	        var NumberOfDiscovery = 0;
	
	        var sumRecords = function sumRecords(data) {
	            if (data.pTotalData && data.pTotalData.total) {
	                PerformanceCPAs += data.pTotalData.total.avgCPA.amount;
	                PerformanceCRs += data.pTotalData.total.conversionRate;
	                NumberOfPerformace += 1;
	            }
	
	            if (data.dTotalData && data.dTotalData.total) {
	                DiscoveryCPAs += data.dTotalData.total.avgCPA.amount;
	                DiscoveryCRs += data.dTotalData.total.conversionRate;
	                NumberOfDiscovery += 1;
	            }
	        };
	        var roundTo2Places = function roundTo2Places(number) {
	            return Math.round(number * 100) / 100;
	        };
	
	        if (Array.isArray(props.data)) {
	            props.data.map(function (data) {
	                sumRecords(data);
	            });
	        } else {
	            console.table(props.data);
	            sumRecords(props.data);
	        }
	
	        if (NumberOfPerformace > 0) {
	            PerformanceCPAs = PerformanceCPAs / NumberOfPerformace;
	            PerformanceCRs = PerformanceCRs / NumberOfPerformace;
	        }
	        if (NumberOfDiscovery > 0) {
	            DiscoveryCPAs = DiscoveryCPAs / NumberOfDiscovery;
	            DiscoveryCRs = DiscoveryCRs / NumberOfDiscovery;
	        }
	
	        _this.CPA = PerformanceCPAs + DiscoveryCPAs;
	        _this.CR = PerformanceCRs + DiscoveryCRs;
	
	        _this.CPA = _this.CPA > 0 ? roundTo2Places(_this.CPA / (NumberOfPerformace > 0 && NumberOfDiscovery > 0 ? 2 : 1)) : -1;
	        _this.CR = _this.CR > 0 ? roundTo2Places(_this.CR / (NumberOfPerformace > 0 && NumberOfDiscovery > 0 ? 2 : 1) * 100) : -1;
	        return _this;
	    }
	
	    _createClass(CampaignDashboard, [{
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: this.props.className },
	                _react2.default.createElement(
	                    "dl",
	                    { className: "cost" },
	                    _react2.default.createElement(
	                        "dt",
	                        null,
	                        "\u83B7\u5BA2\u6210\u672C"
	                    ),
	                    _react2.default.createElement(
	                        "dd",
	                        null,
	                        "\u7F8E\u91D1 ",
	                        this.CPA >= 0 ? this.CPA : "--",
	                        _react2.default.createElement("img", { src: _arrowRed2.default, className: "arrow-up" })
	                    )
	                ),
	                _react2.default.createElement(
	                    "dl",
	                    { className: "rate" },
	                    _react2.default.createElement(
	                        "dt",
	                        null,
	                        "\u8F6C\u5316\u7387"
	                    ),
	                    _react2.default.createElement(
	                        "dd",
	                        null,
	                        this.CR >= 0 ? this.CR : "--",
	                        " %\xA0",
	                        _react2.default.createElement(_index2.default, {
	                            arcWidth: 21,
	                            arcData: [{ percentage: 1, strokeWidth: 2, strokeColor: "#cfc9de" }, { percentage: this.CR >= 0 ? this.CR / 100 : 0, strokeWidth: 2, strokeColor: "#9995a2" }],
	                            strokeWidth: 2,
	                            strokeColor: "#9995a2",
	                            percentage: this.CR >= 0 ? this.CR : 0
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CampaignDashboard;
	}(_react2.default.Component);
	
	exports.default = CampaignDashboard;
	;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    list-style-type: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n    padding: 26px 33px 26px 39px;\n    background-color: rgba(249, 249, 249, 1);\n\n    > * { width: 100%; }\n\n    .loading-overlay {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: rgba(0, 0, 0, .3);\n    }\n\n    .loading-word {\n        flex-grow: 1;\n        align-self: center;\n        text-align: center;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n\n    .row-wrapper { display: flex; flex-wrap: wrap; }\n\n    a {\n        flex-grow: 1;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n    }\n    a:hover { text-decoration: none; }\n\n    .app-header {\n        display: inline-flex;\n        margin: 0;\n        margin-bottom: 14px;\n        width: 100%;\n        max-width: 370px;\n        padding-right: 14px;\n    }\n    .app-header dt { margin-right: 11px; min-width: 85px; width: 85px; }\n    .app-header dt img { border-radius: 16px; width: 100%; }\n\n    .app-header dd {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n    }\n    .app-header dd .app-name,\n    .app-header dd .app-desc {\n        display: block;\n        line-height: 1.1;\n        font-family: \'Montserrat\';\n        color: rgba(64, 55, 57, 1);\n    }\n    .app-header dd .app-name {\n        font-size: 22px;\n        font-weight: 300;\n        letter-spacing: 0.09em;\n        text-transform: uppercase;\n    }\n    .app-header dd .app-desc {\n        font-size: 14px;\n        text-align: left;\n        letter-spacing: 0.07em;\n    }\n\n    .breakdowns {\n        position: relative;\n        bottom: -26px;\n        margin-top: 7px;\n        border-top: 1px solid rgba(0, 0, 0, .1);\n        width: 100%;\n    }\n    .breakdowns button {\n        width: 100%;\n        padding: 14px 7px;\n        background-color: transparent;\n\n        &:hover { outline-width: 0; border-width: 0; }\n        &:not(:only-child) { border-top: 1px solid rgba(0, 0, 0, .1); }\n    }\n\n    .breakdowns li {\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        padding: 14px 0 14px 56px;\n    }\n    .breakdowns li .region-description img { margin-right: 7px; width: 42px; }\n\n    @media screen and (max-width: 991px) {\n        @media screen and (min-width: 768px) {\n            a { justify-content: center; }\n            a > :only-child { max-width: 100%; }\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        a { flex-wrap: wrap; width: calc(100% - 71px); }\n\n        .breakdowns li { padding-left: 0; }\n        .breakdowns li .region-description { min-width: 80px; padding-right: 7px; }\n    }\n\n    @media screen and (max-width: 480px) {\n        justify-content: start;\n        padding: 26px 17px;\n\n        a { width: 100%; }\n        .app-header dt { min-width: 50px; width: 50px; }\n        .app-header dt img { border-radius: 10px; }\n\n        .app-name { margin-bottom: 7px; font-size: 18px; }\n        .app-desc { font-size: 16px; }\n\n        .breakdowns li { flex-wrap: wrap; padding-bottom: 28px; }\n        .breakdowns li:not(:last-child) { border-bottom: 1px solid rgba(0, 0, 0, .1); }\n        .breakdowns li .region-description { flex-grow: 1; align-self: flex-end; order: 1; text-align: center; }\n        .breakdowns li .region-description ~ .breakdown:last-child { order: 2; }\n    }\n'], ['\n    position: relative;\n    list-style-type: none;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    margin-bottom: 14px;\n    padding: 26px 33px 26px 39px;\n    background-color: rgba(249, 249, 249, 1);\n\n    > * { width: 100%; }\n\n    .loading-overlay {\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: rgba(0, 0, 0, .3);\n    }\n\n    .loading-word {\n        flex-grow: 1;\n        align-self: center;\n        text-align: center;\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n\n    .row-wrapper { display: flex; flex-wrap: wrap; }\n\n    a {\n        flex-grow: 1;\n        display: flex;\n        justify-content: flex-start;\n        align-items: center;\n    }\n    a:hover { text-decoration: none; }\n\n    .app-header {\n        display: inline-flex;\n        margin: 0;\n        margin-bottom: 14px;\n        width: 100%;\n        max-width: 370px;\n        padding-right: 14px;\n    }\n    .app-header dt { margin-right: 11px; min-width: 85px; width: 85px; }\n    .app-header dt img { border-radius: 16px; width: 100%; }\n\n    .app-header dd {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n    }\n    .app-header dd .app-name,\n    .app-header dd .app-desc {\n        display: block;\n        line-height: 1.1;\n        font-family: \'Montserrat\';\n        color: rgba(64, 55, 57, 1);\n    }\n    .app-header dd .app-name {\n        font-size: 22px;\n        font-weight: 300;\n        letter-spacing: 0.09em;\n        text-transform: uppercase;\n    }\n    .app-header dd .app-desc {\n        font-size: 14px;\n        text-align: left;\n        letter-spacing: 0.07em;\n    }\n\n    .breakdowns {\n        position: relative;\n        bottom: -26px;\n        margin-top: 7px;\n        border-top: 1px solid rgba(0, 0, 0, .1);\n        width: 100%;\n    }\n    .breakdowns button {\n        width: 100%;\n        padding: 14px 7px;\n        background-color: transparent;\n\n        &:hover { outline-width: 0; border-width: 0; }\n        &:not(:only-child) { border-top: 1px solid rgba(0, 0, 0, .1); }\n    }\n\n    .breakdowns li {\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        padding: 14px 0 14px 56px;\n    }\n    .breakdowns li .region-description img { margin-right: 7px; width: 42px; }\n\n    @media screen and (max-width: 991px) {\n        @media screen and (min-width: 768px) {\n            a { justify-content: center; }\n            a > :only-child { max-width: 100%; }\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        a { flex-wrap: wrap; width: calc(100% - 71px); }\n\n        .breakdowns li { padding-left: 0; }\n        .breakdowns li .region-description { min-width: 80px; padding-right: 7px; }\n    }\n\n    @media screen and (max-width: 480px) {\n        justify-content: start;\n        padding: 26px 17px;\n\n        a { width: 100%; }\n        .app-header dt { min-width: 50px; width: 50px; }\n        .app-header dt img { border-radius: 10px; }\n\n        .app-name { margin-bottom: 7px; font-size: 18px; }\n        .app-desc { font-size: 16px; }\n\n        .breakdowns li { flex-wrap: wrap; padding-bottom: 28px; }\n        .breakdowns li:not(:last-child) { border-bottom: 1px solid rgba(0, 0, 0, .1); }\n        .breakdowns li .region-description { flex-grow: 1; align-self: flex-end; order: 1; text-align: center; }\n        .breakdowns li .region-description ~ .breakdown:last-child { order: 2; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.li(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _getPerformances2 = function () {
	    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee3(authHeader, campaign) {
	        var _this = this;
	
	        var performances, endDate, startDate, performanceMap, discoveryMap, campaignMapForAppId;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	            while (1) {
	                switch (_context3.prev = _context3.next) {
	                    case 0:
	                        performances = [];
	                        endDate = (0, _moment2.default)(); //.format('YYYY-MM-DD');
	
	                        startDate = (0, _moment2.default)(endDate).subtract(20, 'days');
	                        _context3.next = 5;
	                        return Promise.all(campaign.performanceByRegion.map(function () {
	                            var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(region) {
	                                var reportResponse, totalData, searchadsCampaign, response;
	                                return _regenerator2.default.wrap(function _callee$(_context) {
	                                    while (1) {
	                                        switch (_context.prev = _context.next) {
	                                            case 0:
	                                                reportResponse = void 0, totalData = void 0;
	
	                                                if (!region.campaignId) {
	                                                    _context.next = 13;
	                                                    break;
	                                                }
	
	                                                _context.prev = 2;
	                                                _context.next = 5;
	                                                return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + region.campaignId + '/adgroups/rowtotals/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'), { headers: { 'Authorization': authHeader } });
	
	                                            case 5:
	                                                reportResponse = _context.sent;
	
	                                                if (reportResponse.data.response.pagination.totalResults > 0) {
	                                                    totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
	                                                }
	
	                                                console.log('[CampaignItem][AdGroups] ', region.campaignId, reportResponse.data.response);
	                                                _context.next = 13;
	                                                break;
	
	                                            case 10:
	                                                _context.prev = 10;
	                                                _context.t0 = _context['catch'](2);
	
	                                                console.log('[CampaignItem][AdGroups] ', region.campaignId, _context.t0);
	
	                                            case 13:
	
	                                                //get p cid to check status : RUNNING / NOT_RUNNING
	                                                searchadsCampaign = void 0;
	                                                _context.prev = 14;
	                                                _context.next = 17;
	                                                return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + region.campaignId, { headers: { 'Authorization': authHeader } });
	
	                                            case 17:
	                                                response = _context.sent;
	
	                                                console.log('[CampaignItem][Detail] ', response.data.response.data); // error is not defined
	                                                searchadsCampaign = response.data.response.data;
	                                                _context.next = 25;
	                                                break;
	
	                                            case 22:
	                                                _context.prev = 22;
	                                                _context.t1 = _context['catch'](14);
	
	                                                console.log('[CampaignItem][Detail] ', _context.t1); // error is not defined
	
	                                            case 25:
	                                                return _context.abrupt('return', {
	                                                    appId: campaign.appId, //primary id
	                                                    region: region.region,
	                                                    pCid: region.campaignId,
	                                                    pReportAdGroup: reportResponse.data.response,
	                                                    pTotalData: totalData,
	                                                    emAdGroupId: region.emAdGroupId,
	                                                    key: campaign.appId + region.region,
	                                                    servingStatus: searchadsCampaign.servingStatus,
	                                                    appNamePrefix: 'DEV-' + campaign.shortId + '-' + campaign.appId
	                                                });
	
	                                            case 26:
	                                            case 'end':
	                                                return _context.stop();
	                                        }
	                                    }
	                                }, _callee, _this, [[2, 10], [14, 22]]);
	                            }));
	
	                            return function (_x3) {
	                                return _ref2.apply(this, arguments);
	                            };
	                        }()));
	
	                    case 5:
	                        performanceMap = _context3.sent;
	                        _context3.next = 8;
	                        return Promise.all(campaign.discoveryByRegion.map(function () {
	                            var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(region) {
	                                var reportResponse, totalData;
	                                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                                    while (1) {
	                                        switch (_context2.prev = _context2.next) {
	                                            case 0:
	                                                reportResponse = void 0, totalData = void 0;
	
	                                                if (!region.campaignId) {
	                                                    _context2.next = 13;
	                                                    break;
	                                                }
	
	                                                _context2.prev = 2;
	                                                _context2.next = 5;
	                                                return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + region.campaignId + '/adgroups/rowtotals/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'), { headers: { 'Authorization': authHeader } });
	
	                                            case 5:
	                                                reportResponse = _context2.sent;
	
	                                                if (reportResponse.data.response.pagination.totalResults > 0) {
	                                                    totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
	                                                }
	                                                console.log('[CampaignItem][AdGroups] ', region.campaignId, reportResponse.data);
	                                                _context2.next = 13;
	                                                break;
	
	                                            case 10:
	                                                _context2.prev = 10;
	                                                _context2.t0 = _context2['catch'](2);
	
	                                                console.log('[CampaignItem][AdGroups] ', region.campaignId, _context2.t0);
	
	                                            case 13:
	                                                return _context2.abrupt('return', {
	                                                    appId: campaign.appId, //primary id
	                                                    region: region.region,
	                                                    dCid: region.campaignId,
	                                                    dReportAdGroup: reportResponse.data.response,
	                                                    dTotalData: totalData,
	                                                    smAdGroupId: region.smAdGroupId,
	                                                    bmAdGroupId: region.bmAdGroupId
	                                                });
	
	                                            case 14:
	                                            case 'end':
	                                                return _context2.stop();
	                                        }
	                                    }
	                                }, _callee2, _this, [[2, 10]]);
	                            }));
	
	                            return function (_x4) {
	                                return _ref3.apply(this, arguments);
	                            };
	                        }()));
	
	                    case 8:
	                        discoveryMap = _context3.sent;
	                        campaignMapForAppId = _lodash2.default.map(performanceMap, function (obj) {
	                            return _lodash2.default.assign(obj, _lodash2.default.find(discoveryMap, {
	                                appId: obj.appId,
	                                region: obj.region
	                            }));
	                        });
	                        return _context3.abrupt('return', campaignMapForAppId);
	
	                    case 11:
	                    case 'end':
	                        return _context3.stop();
	                }
	            }
	        }, _callee3, this);
	    }));
	
	    return function _getPerformances2(_x, _x2) {
	        return _ref.apply(this, arguments);
	    };
	}();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(129);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _index = __webpack_require__(1676);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(1680);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _AU = __webpack_require__(569);
	
	var _AU2 = _interopRequireDefault(_AU);
	
	var _Canada = __webpack_require__(571);
	
	var _Canada2 = _interopRequireDefault(_Canada);
	
	var _CH = __webpack_require__(570);
	
	var _CH2 = _interopRequireDefault(_CH);
	
	var _GB = __webpack_require__(572);
	
	var _GB2 = _interopRequireDefault(_GB);
	
	var _MX = __webpack_require__(573);
	
	var _MX2 = _interopRequireDefault(_MX);
	
	var _NZ = __webpack_require__(574);
	
	var _NZ2 = _interopRequireDefault(_NZ);
	
	var _US = __webpack_require__(575);
	
	var _US2 = _interopRequireDefault(_US);
	
	var _Wrapper = __webpack_require__(1677);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // -- React Libraries
	
	
	// -- Libraries
	
	
	// -- Variables
	
	
	// -- Components
	
	
	// -- Resources
	
	
	// -- Styles
	
	
	var CampaignItem = function (_React$Component) {
	    _inherits(CampaignItem, _React$Component);
	
	    function CampaignItem(props) {
	        _classCallCheck(this, CampaignItem);
	
	        var _this2 = _possibleConstructorReturn(this, (CampaignItem.__proto__ || Object.getPrototypeOf(CampaignItem)).call(this, props));
	
	        _this2.state = { isShowDetails: false, isHidden: false };
	
	        _this2.AuthHeader = _this2.props.authHeader || '';
	        _this2.AppID = props.campaign.appId;
	        _this2.RegionalCampaigns = props.campaign.discoveryByRegion.map(function (region) {
	            return { region: region.region, campaignID: region.campaignId, performance: null };
	        });
	
	        _this2.setState({
	            appItem: null,
	            performances: null
	        });
	
	        _this2._getItunesStoreData(_this2.AppID, -1);
	        _this2._getPerformances();
	        return _this2;
	    }
	
	    _createClass(CampaignItem, [{
	        key: '_getItunesStoreData',
	        value: function () {
	            var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(appId, storeIndex) {
	                var countryCode, Results, response;
	                return _regenerator2.default.wrap(function _callee4$(_context4) {
	                    while (1) {
	                        switch (_context4.prev = _context4.next) {
	                            case 0:
	                                if (!(storeIndex >= this.RegionalCampaigns.length)) {
	                                    _context4.next = 2;
	                                    break;
	                                }
	
	                                return _context4.abrupt('return');
	
	                            case 2:
	                                countryCode = storeIndex >= 0 && this.RegionalCampaigns[storeIndex].region || null;
	                                Results = null;
	                                _context4.prev = 4;
	                                _context4.t1 = countryCode;
	
	                                if (!_context4.t1) {
	                                    _context4.next = 10;
	                                    break;
	                                }
	
	                                _context4.next = 9;
	                                return _axios2.default.post('https://itunes.apple.com/lookup', {}, { params: { id: appId, 'Authorization': this.AuthHeader, country: countryCode } });
	
	                            case 9:
	                                _context4.t1 = _context4.sent;
	
	                            case 10:
	                                _context4.t0 = _context4.t1;
	
	                                if (_context4.t0) {
	                                    _context4.next = 15;
	                                    break;
	                                }
	
	                                _context4.next = 14;
	                                return _axios2.default.post('https://itunes.apple.com/lookup', {}, { params: { id: appId, 'Authorization': this.AuthHeader } });
	
	                            case 14:
	                                _context4.t0 = _context4.sent;
	
	                            case 15:
	                                response = _context4.t0;
	
	
	                                Results = response && response.data && response.data.results || null;
	                                _context4.next = 22;
	                                break;
	
	                            case 19:
	                                _context4.prev = 19;
	                                _context4.t2 = _context4['catch'](4);
	
	                                console.log('[CampaignItem][iTunesStore] ', _context4.t2); // error is not defined
	
	                            case 22:
	                                if (!(!Results || Results.length <= 0)) {
	                                    _context4.next = 25;
	                                    break;
	                                }
	
	                                this._getItunesStoreData(appId, countryCode && storeIndex + 1 || 0);
	                                return _context4.abrupt('return');
	
	                            case 25:
	
	                                this.setState({ appItem: Results[0] });
	
	                            case 26:
	                            case 'end':
	                                return _context4.stop();
	                        }
	                    }
	                }, _callee4, this, [[4, 19]]);
	            }));
	
	            function _getItunesStoreData(_x5, _x6) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return _getItunesStoreData;
	        }()
	    }, {
	        key: '_getPerformances',
	        value: function () {
	            var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	                var Performances;
	                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                    while (1) {
	                        switch (_context5.prev = _context5.next) {
	                            case 0:
	                                _context5.next = 2;
	                                return _getPerformances2(this.AuthHeader, this.props.campaign);
	
	                            case 2:
	                                Performances = _context5.sent;
	
	                                this.setState({
	                                    performances: Performances,
	                                    isHidden: Performances.length <= 0
	                                });
	
	                            case 4:
	                            case 'end':
	                                return _context5.stop();
	                        }
	                    }
	                }, _callee5, this);
	            }));
	
	            function _getPerformances() {
	                return _ref5.apply(this, arguments);
	            }
	
	            return _getPerformances;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this4 = this;
	
	            /**
	             * using third party lib instead , dun use any asset image anymore
	             */
	            var _Flags = {
	                "AU": _AU2.default,
	                "CA": _Canada2.default,
	                "CH": _CH2.default,
	                "US": _US2.default,
	                "GB": _GB2.default,
	                "MX": _MX2.default,
	                "NZ": _NZ2.default
	            };
	
	            var _CountriesName = {
	                "AU": "澳大利亚",
	                "CA": "加拿大",
	                "CH": "瑞士",
	                "US": "美国",
	                "GB": "英国",
	                "MX": "墨西哥",
	                "NZ": "新西兰"
	            };
	
	            var _changeState = function (countryCode, isSwitchingOn) {
	                var _this3 = this;
	
	                var Performances = this.state.performances;
	                var Status = isSwitchingOn ? "ENABLED" : "PAUSED";
	
	                this.setState({ performances: null });
	
	                console.log("[ChangeState] ", { countryCode: countryCode, isTurnOn: isSwitchingOn });
	                // If no country code then apply to all countries, otherwise apply to the selected country only
	                Performances.map(function () {
	                    var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(performance) {
	                        var IsRunning, CampaignIDs, request;
	                        return _regenerator2.default.wrap(function _callee7$(_context7) {
	                            while (1) {
	                                switch (_context7.prev = _context7.next) {
	                                    case 0:
	                                        if (!(!countryCode || performance.region == countryCode)) {
	                                            _context7.next = 9;
	                                            break;
	                                        }
	
	                                        IsRunning = performance.servingStatus === "RUNNING";
	
	                                        if (!(IsRunning === isSwitchingOn)) {
	                                            _context7.next = 4;
	                                            break;
	                                        }
	
	                                        return _context7.abrupt('return');
	
	                                    case 4:
	
	                                        console.table(performance); //return;
	
	                                        CampaignIDs = [performance.pCid, performance.dCid];
	                                        request = {
	                                            campaign: {
	                                                status: Status
	                                                // Whether user intends to run this campaign/adgroup or not. ENABLED, PAUSED
	                                            } };
	                                        _context7.next = 9;
	                                        return Promise.all(CampaignIDs.map(function () {
	                                            var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(cid) {
	                                                var requestResponse, updatedCampaign;
	                                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                                    while (1) {
	                                                        switch (_context6.prev = _context6.next) {
	                                                            case 0:
	                                                                requestResponse = void 0;
	                                                                _context6.prev = 1;
	                                                                _context6.next = 4;
	                                                                return _axios2.default.post(_server2.default + '/user/campaigns/cid/' + cid, request, { headers: { 'Authorization': _this3.AuthHeader } });
	
	                                                            case 4:
	                                                                requestResponse = _context6.sent;
	                                                                updatedCampaign = requestResponse.data.response.data;
	
	                                                                console.log('[CampaignItem][ChangeState] ', cid, updatedCampaign);
	                                                                _context6.next = 12;
	                                                                break;
	
	                                                            case 9:
	                                                                _context6.prev = 9;
	                                                                _context6.t0 = _context6['catch'](1);
	
	                                                                console.error('[CampaignItem][ChangeState] ', cid, _context6.t0);
	
	                                                            case 12:
	                                                            case 'end':
	                                                                return _context6.stop();
	                                                        }
	                                                    }
	                                                }, _callee6, _this3, [[1, 9]]);
	                                            }));
	
	                                            return function (_x8) {
	                                                return _ref7.apply(this, arguments);
	                                            };
	                                        }()));
	
	                                    case 9:
	                                    case 'end':
	                                        return _context7.stop();
	                                }
	                            }
	                        }, _callee7, _this3);
	                    }));
	
	                    return function (_x7) {
	                        return _ref6.apply(this, arguments);
	                    };
	                }());
	
	                this._getPerformances();
	            }.bind(this);
	
	            var _getFlag = function _getFlag(countryCode) {
	                return countryCode && _Flags[countryCode] && _react2.default.createElement('img', { src: _Flags[countryCode] }) || _react2.default.createElement('span', null);
	            };
	
	            var _getCountryName = function _getCountryName(countryCode) {
	                return countryCode && _CountriesName[countryCode] && _CountriesName[countryCode] || '';
	            };
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { key: this.props.campaign.appId, style: this.state.isHidden && { display: 'none' } || {} },
	                (!this.state.appItem || !this.state.performances) && _react2.default.createElement('div', { className: 'loading-overlay' }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'row-wrapper' },
	                    this.state.appItem && _react2.default.createElement(
	                        _reactRouterDom.Link,
	                        {
	                            to: '/dashboard/' + this.AppID
	                        },
	                        _react2.default.createElement(
	                            'dl',
	                            { className: 'app-header' },
	                            _react2.default.createElement(
	                                'dt',
	                                null,
	                                _react2.default.createElement('img', { src: this.state.appItem.artworkUrl100, alt: 'screen' })
	                            ),
	                            _react2.default.createElement(
	                                'dd',
	                                null,
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'app-name' },
	                                    this.state.appItem.trackCensoredName
	                                ),
	                                _react2.default.createElement(
	                                    'span',
	                                    { className: 'app-desc' },
	                                    this.state.appItem.sellerName
	                                )
	                            )
	                        ),
	                        this.state.performances && _react2.default.createElement(_index2.default, { data: this.state.performances })
	                    ),
	                    this.state.performances && _react2.default.createElement(_index4.default, {
	                        id: this.AppID,
	                        data: this.state.performances,
	                        onChange: _changeState
	                    })
	                ),
	                !this.state.performances && _react2.default.createElement(
	                    'div',
	                    { className: 'loading-word' },
	                    '\u8F7D\u5165\u4E2D...'
	                ) || _react2.default.createElement(
	                    'div',
	                    { className: 'breakdowns' },
	                    !this.state.isShowDetails && _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                                _this4.setState({ isShowDetails: true });
	                            } },
	                        '\u5C55\u5F00'
	                    ) || _react2.default.createElement(
	                        'ul',
	                        null,
	                        this.state.performances.map(function (data) {
	                            return _react2.default.createElement(
	                                'li',
	                                { key: 'campaign-' + data.dCid },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'region-description' },
	                                    _getFlag(data.region),
	                                    _getCountryName(data.region)
	                                ),
	                                _react2.default.createElement(_index2.default, { data: data, className: 'breakdown' }),
	                                _react2.default.createElement(_index4.default, {
	                                    id: data.dCid,
	                                    region: data.region,
	                                    data: data,
	                                    onChange: _changeState,
	                                    className: 'breakdown'
	                                })
	                            );
	                        })
	                    ),
	                    this.state.isShowDetails && _react2.default.createElement(
	                        'button',
	                        { onClick: function onClick() {
	                                _this4.setState({ isShowDetails: false });
	                            } },
	                        '\u6536\u8D77'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return CampaignItem;
	}(_react2.default.Component);
	
	exports.default = CampaignItem;
	;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    align-self: center;\n    input { display: none; }\n\n    input:checked ~ label {\n        border-color: rgba(12, 183, 148, 1);\n        padding-left: 28px;\n        background-color: rgba(12, 183, 148, 1);\n\n        .running { display: block; }\n        img.running { height: 13px; }\n    }\n    input:not(:checked) ~ label {\n        .paused { display: block; }\n        img.paused { height: 12px; }\n    }\n\n    label {\n        display: inline-block;\n        border: 2px solid rgba(229, 229, 229, 1);\n        height: 43px;\n        width: 71px;\n        padding-left: 0;\n        background-color: rgba(255, 255, 255, 1);\n        cursor: pointer;\n        border-radius: 39px;\n        transition: padding-left .3s;\n\n        span {\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n            height: 39px;\n            width: 39px;\n            background-color: rgba(255, 255, 255, 1);\n            border: 1px solid rgba(0, 0, 0, 0.1);\n            border-radius: 39px;\n            box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.17);\n\n            img { display: none; }\n        }\n\n        p {\n            position: absolute;\n            right: 0; bottom: -24px; left: 0;\n            display: none;\n\n            :after {\n                display: block;\n                content: attr(class);\n                font-family: \'Montserrat\';\n                font-size: 12px;\n                font-weight: 300;\n                color: rgba(64,55,57,1);\n                text-align: center;\n                text-transform: uppercase;\n                transform: translateY(100%;)\n            }\n            \n            &.running:after { content: \'\u8FD0\u884C\u4E2D\'; }\n            &.paused:after { content: \'\u6682\u505C\'; }\n        }\n        p.paused:after { color: rgba(170, 170, 170, 1); }\n    }\n\n    @media screen and (max-width: 991px) {\n        @media screen and (min-width: 768px) {\n\n            &:not(.breakdown) {\n                display: flex;\n                justify-content: center;\n                width: 100%;\n            }\n        }\n    }\n\n    @media screen and (max-width: 480px) {\n        flex-grow: 1;\n        display: flex;\n        justify-content: center;\n    }\n'], ['\n    align-self: center;\n    input { display: none; }\n\n    input:checked ~ label {\n        border-color: rgba(12, 183, 148, 1);\n        padding-left: 28px;\n        background-color: rgba(12, 183, 148, 1);\n\n        .running { display: block; }\n        img.running { height: 13px; }\n    }\n    input:not(:checked) ~ label {\n        .paused { display: block; }\n        img.paused { height: 12px; }\n    }\n\n    label {\n        display: inline-block;\n        border: 2px solid rgba(229, 229, 229, 1);\n        height: 43px;\n        width: 71px;\n        padding-left: 0;\n        background-color: rgba(255, 255, 255, 1);\n        cursor: pointer;\n        border-radius: 39px;\n        transition: padding-left .3s;\n\n        span {\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n            height: 39px;\n            width: 39px;\n            background-color: rgba(255, 255, 255, 1);\n            border: 1px solid rgba(0, 0, 0, 0.1);\n            border-radius: 39px;\n            box-shadow: 0px 4px 2px 0px rgba(0, 0, 0, 0.17);\n\n            img { display: none; }\n        }\n\n        p {\n            position: absolute;\n            right: 0; bottom: -24px; left: 0;\n            display: none;\n\n            :after {\n                display: block;\n                content: attr(class);\n                font-family: \'Montserrat\';\n                font-size: 12px;\n                font-weight: 300;\n                color: rgba(64,55,57,1);\n                text-align: center;\n                text-transform: uppercase;\n                transform: translateY(100%;)\n            }\n            \n            &.running:after { content: \'\u8FD0\u884C\u4E2D\'; }\n            &.paused:after { content: \'\u6682\u505C\'; }\n        }\n        p.paused:after { color: rgba(170, 170, 170, 1); }\n    }\n\n    @media screen and (max-width: 991px) {\n        @media screen and (min-width: 768px) {\n\n            &:not(.breakdown) {\n                display: flex;\n                justify-content: center;\n                width: 100%;\n            }\n        }\n    }\n\n    @media screen and (max-width: 480px) {\n        flex-grow: 1;\n        display: flex;\n        justify-content: center;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1679);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _running = __webpack_require__(577);
	
	var _running2 = _interopRequireDefault(_running);
	
	var _pause = __webpack_require__(576);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	// -- Resources
	
	
	var CampaignState = function (_React$Component) {
	    _inherits(CampaignState, _React$Component);
	
	    function CampaignState(props) {
	        _classCallCheck(this, CampaignState);
	
	        var _this = _possibleConstructorReturn(this, (CampaignState.__proto__ || Object.getPrototypeOf(CampaignState)).call(this, props));
	
	        _this.ID = props.id;
	        _this.Region = props.region;
	        _this.IsRunning = false;
	
	        if (Array.isArray(props.data)) {
	            _this.IsRunning = props.data.find(function (data) {
	                return data.servingStatus.toString().toUpperCase() === "RUNNING";
	            }) != null;
	        } else {
	            _this.IsRunning = props.data.servingStatus.toString().toUpperCase() === "RUNNING";
	        }
	        return _this;
	    }
	
	    _createClass(CampaignState, [{
	        key: 'render',
	        value: function render() {
	            var _changeState = function () {
	                this.props.onChange(this.Region, !this.IsRunning);
	            }.bind(this);
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: this.props.className },
	                _react2.default.createElement('input', { type: 'checkbox',
	                    checked: this.IsRunning
	                    // id={this.prop.item.pCid + ' ' + this.prop.item.dCid} 
	                    , id: this.props.id,
	                    onChange: function onChange() {
	                        _changeState();
	                    }
	                }),
	                _react2.default.createElement(
	                    'label',
	                    { className: 'switch-wrapper', htmlFor: this.props.id },
	                    _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('img', { src: _running2.default, className: 'running' }),
	                        _react2.default.createElement('img', { src: _pause2.default, className: 'paused' })
	                    ),
	                    _react2.default.createElement('p', { className: 'running' }),
	                    _react2.default.createElement('p', { className: 'paused' })
	                )
	            );
	        }
	    }]);
	
	    return CampaignState;
	}(_react2.default.Component);
	
	exports.default = CampaignState;
	;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    margin: 0 auto;\n    width: 100%;\n    max-width: 893px;\n    padding-right: 15px;\n    padding-left: 15px;\n\n    li.loading {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 26px 33px 26px 39px;\n        background-color: rgba(0, 0, 0, .3);\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n'], ['\n    margin: 0 auto;\n    width: 100%;\n    max-width: 893px;\n    padding-right: 15px;\n    padding-left: 15px;\n\n    li.loading {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding: 26px 33px 26px 39px;\n        background-color: rgba(0, 0, 0, .3);\n        font-weight: 700;\n        text-transform: uppercase;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.ul(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _index = __webpack_require__(1678);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Wrapper = __webpack_require__(1681);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Libraries
	
	
	// -- Variables
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var CampaignsHolder = function (_React$Component) {
	    _inherits(CampaignsHolder, _React$Component);
	
	    function CampaignsHolder(props) {
	        _classCallCheck(this, CampaignsHolder);
	
	        var _this = _possibleConstructorReturn(this, (CampaignsHolder.__proto__ || Object.getPrototypeOf(CampaignsHolder)).call(this, props));
	
	        _this.AuthHeader = _this.props.authHeader || '';
	        _this.state = {
	            campaignList: null
	        };
	
	        _this._getCampaignsOfUser();
	        return _this;
	    }
	
	    _createClass(CampaignsHolder, [{
	        key: '_getCampaignsOfUser',
	        value: function () {
	            var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	                var headers, response;
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                headers = { 'Authorization': this.AuthHeader };
	                                _context.next = 3;
	                                return _axios2.default.get(_server2.default + '/user/campaigns', { headers: headers });
	
	                            case 3:
	                                response = _context.sent;
	
	                                this.setState({ campaignList: response.data });
	
	                            case 5:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function _getCampaignsOfUser() {
	                return _ref.apply(this, arguments);
	            }
	
	            return _getCampaignsOfUser;
	        }()
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                null,
	                !this.state.campaignList && _react2.default.createElement(
	                    'li',
	                    { className: 'loading' },
	                    '\u8F7D\u5165\u4E2D...'
	                ) || this.state.campaignList.map(function (campaign) {
	                    return _react2.default.createElement(_index2.default, {
	                        authHeader: _this2.AuthHeader,
	                        campaign: campaign
	                    });
	                })
	            );
	        }
	    }]);
	
	    return CampaignsHolder;
	}(_react2.default.Component);
	
	exports.default = CampaignsHolder;
	;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactRedux = __webpack_require__(40);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _redux = __webpack_require__(56);
	
	var _reactBootstrap = __webpack_require__(157);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _reactJsonView = __webpack_require__(493);
	
	var _reactJsonView2 = _interopRequireDefault(_reactJsonView);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(129);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _index = __webpack_require__(214);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Logo = __webpack_require__(173);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Menu = __webpack_require__(213);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _FillRow = __webpack_require__(737);
	
	var _FillRow2 = _interopRequireDefault(_FillRow);
	
	var _index3 = __webpack_require__(275);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(212);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(1682);
	
	var _index8 = _interopRequireDefault(_index7);
	
	var _style = __webpack_require__(1684);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _arrow_green = __webpack_require__(1415);
	
	var _arrow_green2 = _interopRequireDefault(_arrow_green);
	
	var _arrowRed = __webpack_require__(1413);
	
	var _arrowRed2 = _interopRequireDefault(_arrowRed);
	
	var _arrow_green3 = __webpack_require__(1414);
	
	var _arrow_green4 = _interopRequireDefault(_arrow_green3);
	
	var _arrowRed3 = __webpack_require__(1412);
	
	var _arrowRed4 = _interopRequireDefault(_arrowRed3);
	
	var _running = __webpack_require__(577);
	
	var _running2 = _interopRequireDefault(_running);
	
	var _pause = __webpack_require__(576);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	// import SearchIcon from '../../image/search.png';
	// import ReactFlagsSelect from 'react-flags-select';
	//import Select from 'react-select';
	
	// -- Libraries
	
	
	// -- Variables
	
	
	// -- Components
	
	
	// -- Styles
	
	
	// -- Resources
	
	var GravatarOption = (0, _createReactClass2.default)({
	  propTypes: {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    isDisabled: _propTypes2.default.bool,
	    isFocused: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    onFocus: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    option: _propTypes2.default.object.isRequired
	  },
	  handleMouseDown: function handleMouseDown(event) {
	    event.preventDefault();
	    event.stopPropagation();
	    this.props.onSelect(this.props.option, event);
	  },
	  handleMouseEnter: function handleMouseEnter(event) {
	    this.props.onFocus(this.props.option, event);
	  },
	  handleMouseMove: function handleMouseMove(event) {
	    if (this.props.isFocused) return;
	    this.props.onFocus(this.props.option, event);
	  },
	  render: function render() {
	    var gravatarStyle = {
	      borderRadius: 3,
	      display: 'inline-block',
	      marginRight: 10,
	      position: 'relative',
	      top: -2,
	      verticalAlign: 'middle',
	      width: '40px',
	      height: '40px'
	    };
	    var logoStyle = {
	      width: '56px',
	      height: '56px'
	    };
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.className,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove,
	        title: this.props.option.title },
	      _react2.default.createElement('img', {
	        style: gravatarStyle,
	        src: this.props.option.options.artworkUrl60
	      }),
	      _react2.default.createElement(
	        'span',
	        { className: 'span' },
	        this.props.children
	      )
	    );
	  }
	});
	
	var CampaignList = function (_Component) {
	  _inherits(CampaignList, _Component);
	
	  function CampaignList(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CampaignList);
	
	    var _this = _possibleConstructorReturn(this, (CampaignList.__proto__ || Object.getPrototypeOf(CampaignList)).call(this, props));
	
	    _this.onStatusChanged = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee2(pCid, dCid, status) {
	        var getAccessToken, headers, cidList, request, cidResults;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                // 'ENABLED' : 'PAUSED'
	                console.log('on onStatusChanged click , ', pCid, dCid, status);
	
	                getAccessToken = _this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                cidList = [pCid, dCid];
	                request = {
	                  campaign: {
	                    status: status
	                    // Whether user intends to run this campaign/adgroup or not. ENABLED, PAUSED
	                  } };
	                _context2.next = 7;
	                return Promise.all(cidList.map(function () {
	                  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(cid) {
	                    var requestResponse, updatedCampaign, index, items;
	                    return _regenerator2.default.wrap(function _callee$(_context) {
	                      while (1) {
	                        switch (_context.prev = _context.next) {
	                          case 0:
	                            requestResponse = void 0;
	                            _context.prev = 1;
	                            _context.next = 4;
	                            return _axios2.default.post(_server2.default + '/user/campaigns/cid/' + cid, request, { headers: headers });
	
	                          case 4:
	                            requestResponse = _context.sent;
	                            updatedCampaign = requestResponse.data.response.data;
	
	                            console.log('[campaigns update] ', cid, updatedCampaign);
	
	                            index = _this.state.globalCampaignList.findIndex(function (item) {
	                              return item.pCid === pCid;
	                            });
	
	                            /**
	                             * TODO show pop up for no chnage
	                             * servingStateReason = updatedCampaign.servingStateReasons[0]
	                             */
	                            //
	
	                            items = Object.assign(_this.state.globalCampaignList); // Pull the entire items object out. Using object.assign is a good idea for objects.
	
	                            if (items[index].servingStatus !== updatedCampaign.servingStatus) {
	                              items[index].servingStatus = updatedCampaign.servingStatus; // update the items object as needed
	                              _this.setState({ globalCampaignList: items }); // Pu
	                            }
	
	                            _context.next = 15;
	                            break;
	
	                          case 12:
	                            _context.prev = 12;
	                            _context.t0 = _context['catch'](1);
	
	                            console.log('[campaigns update] ', cid, _context.t0);
	
	                          case 15:
	                            return _context.abrupt('return', requestResponse);
	
	                          case 16:
	                          case 'end':
	                            return _context.stop();
	                        }
	                      }
	                    }, _callee, _this2, [[1, 12]]);
	                  }));
	
	                  return function (_x4) {
	                    return _ref2.apply(this, arguments);
	                  };
	                }()));
	
	              case 7:
	                cidResults = _context2.sent;
	
	              case 8:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.onSelectFlag = function (countryCode) {
	      _this.props.onCountryCodeUpdated(countryCode);
	    };
	
	    _this.onChange = function (app) {
	      _this.setState({
	        value: app
	      });
	
	      var _this$state = _this.state,
	          optionList = _this$state.optionList,
	          input = _this$state.input;
	
	      if (optionList && optionList.length > 1) {
	        _this.props.appSelected(app.value, optionList[1].value);
	      } else if (optionList && optionList.length === 1) {
	        _this.props.appSelected(app.value, app.value);
	      } else {
	        _this.props.appSelected(app.value, null);
	      }
	      _this.props.searchTermUpdated(input);
	
	      if (_this.props.auth.isAuthenticated()) {
	        _this.props.history.push('/addCampaign/appId/' + app.value.adamId);
	      } else {
	        _this.props.history.pus('/home');
	      }
	    };
	
	    _this.getApps = function (input) {
	      if (!input) {
	        return Promise.resolve({ options: [] });
	      }
	      _this.setState({ input: input });
	      return _axios2.default.post('https://itunes.apple.com/search', {}, { params: { term: input, country: _this.props.countryCode, entity: 'software' } }).then(function (response) {
	        if (response.data != undefined) {
	          var itemData = response.data.results;
	          var items = itemData.map(function (item, i) {
	            return {
	              key: i,
	              label: item.trackCensoredName,
	              id: i,
	              value: {
	                adamId: item.trackId,
	                artworkUrl60: item.artworkUrl60,
	                artworkUrl100: item.artworkUrl100,
	                name: item.trackCensoredName,
	                trackCensoredName: item.trackCensoredName,
	                sellerName: item.sellerName,
	                screenshotUrls: item.screenshotUrls,
	                bundleId: item.bundleId
	              },
	              options: item
	            };
	          });
	          console.log(' items ', items);
	
	          _this.setState({ optionList: items });
	          return { options: items };
	        }
	      }).catch(function (error) {
	        console.log(error.message);
	      });
	      // return fetch(`https://api.github.com/search/users?q=${input}`)
	      // .then((response) => response.json())
	      // .then((json) => {
	      // 	return { options: json.items };
	      // });
	    };
	
	    _this.state = {
	      updated: false,
	      campaignList: null,
	      redirectToReferrer: false,
	      optionList: null,
	      globalCampaignList: []
	    };
	    _this.onStatusChanged.bind(_this);
	    return _this;
	  }
	  /**
	   * to be deprecated
	   */
	
	
	  _createClass(CampaignList, [{
	    key: 'getItunesStoreData',
	
	
	    /**
	     * to be redux saga 
	     * @param {*} appId 
	     * @param {*} country 
	     */
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(appId, country) {
	        var API_PUBLIC_SEARCH, results, getAccessToken, response;
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                API_PUBLIC_SEARCH = 'https://itunes.apple.com/lookup';
	
	                console.log('[getItunesStoreData] ', 'prepare'); // error is not defined
	
	                results = [];
	                _context3.prev = 3;
	                getAccessToken = this.props.auth.getAccessToken;
	                _context3.next = 7;
	                return _axios2.default.post(API_PUBLIC_SEARCH, {}, { params: { id: appId, 'Authorization': 'Bearer ' + getAccessToken(), country: country } });
	
	              case 7:
	                response = _context3.sent;
	
	
	                console.log('[getItunesStoreData] ', response.data.results); // error is not defined
	                results = response.data.results;
	                _context3.next = 15;
	                break;
	
	              case 12:
	                _context3.prev = 12;
	                _context3.t0 = _context3['catch'](3);
	
	                console.log('[getItunesStoreData] ', _context3.t0); // error is not defined
	
	              case 15:
	                if (!(results.length > 0)) {
	                  _context3.next = 19;
	                  break;
	                }
	
	                return _context3.abrupt('return', results[0]);
	
	              case 19:
	                return _context3.abrupt('return', null);
	
	              case 20:
	                console.log(this.state.itunesLookUp);
	
	              case 21:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, this, [[3, 12]]);
	      }));
	
	      function getItunesStoreData(_x5, _x6) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return getItunesStoreData;
	    }()
	  }, {
	    key: 'componentWillMount',
	    value: function () {
	      var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	        var _this3 = this;
	
	        var _props$auth, userProfile, getProfile, getProfileFake, app1, app2;
	
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _props$auth = this.props.auth, userProfile = _props$auth.userProfile, getProfile = _props$auth.getProfile, getProfileFake = _props$auth.getProfileFake;
	
	
	                if (true) {
	                  this.setState({ profile: getProfileFake() });
	                } else {
	                  if (!userProfile) {
	                    getProfile(function (err, profile) {
	                      _this3.setState({ profile: profile });
	                    });
	                  } else {
	                    this.setState({ profile: userProfile });
	                  }
	                }
	
	                app1 = { "adamId": 331177714, "artworkUrl60": "http://is5.mzstatic.com/image/thumb/Purple62/v4/7a/df/45/7adf4578-c3aa-7d77-859a-1777707c04ca/source/60x60bb.jpg", "artworkUrl100": "http://is5.mzstatic.com/image/thumb/Purple62/v4/7a/df/45/7adf4578-c3aa-7d77-859a-1777707c04ca/source/100x100bb.jpg", "name": "Starbucks", "trackCensoredName": "Starbucks", "sellerName": "Starbucks Coffee Company", "screenshotUrls": ["http://is1.mzstatic.com/image/thumb/Purple128/v4/50/78/96/50789699-c577-e6de-69d4-9da2a447957f/source/392x696bb.jpg", "http://is5.mzstatic.com/image/thumb/Purple128/v4/5e/d2/13/5ed2137c-f924-ab77-e488-b44fb21aeaf4/source/392x696bb.jpg", "http://is1.mzstatic.com/image/thumb/Purple128/v4/2c/b4/77/2cb4777b-0324-981b-98ae-b04fe27f7e76/source/392x696bb.jpg", "http://is5.mzstatic.com/image/thumb/Purple128/v4/3f/13/db/3f13db32-49b2-b9d6-3d24-edb17246d7ea/source/392x696bb.jpg", "http://is5.mzstatic.com/image/thumb/Purple128/v4/91/01/5e/91015e72-8010-db3e-c911-798e28d595c9/source/392x696bb.jpg"] };
	                app2 = { "adamId": 424779886, "artworkUrl60": "http://is5.mzstatic.com/image/thumb/Purple128/v4/fb/56/d4/fb56d459-a4f5-213c-bfcf-8de5b55904b5/source/60x60bb.jpg", "artworkUrl100": "http://is5.mzstatic.com/image/thumb/Purple128/v4/fb/56/d4/fb56d459-a4f5-213c-bfcf-8de5b55904b5/source/100x100bb.jpg", "name": "Secret Menu for Starbucks!", "trackCensoredName": "Secret Menu for Starbucks!", "sellerName": "Sepia Software LLC", "screenshotUrls": ["http://is5.mzstatic.com/image/thumb/Purple111/v4/e0/04/67/e0046721-6516-087b-8561-3a3b175c2b1d/source/392x696bb.jpg", "http://is4.mzstatic.com/image/thumb/Purple111/v4/1b/fd/de/1bfddef4-4c54-1e8f-8eb3-58f85e4867f6/source/392x696bb.jpg", "http://is3.mzstatic.com/image/thumb/Purple122/v4/90/ff/91/90ff9156-25e1-517c-60f9-19bfe266d761/source/392x696bb.jpg"] };
	
	                this.setState({
	                  app1: app1, app2: app2
	                });
	
	                if (true) {
	
	                  this.props.appSelected(app1, app2);
	                }
	
	              case 6:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, this);
	      }));
	
	      function componentWillMount() {
	        return _ref4.apply(this, arguments);
	      }
	
	      return componentWillMount;
	    }()
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	        var _this4 = this;
	
	        var getAccessToken, headers, results, globalCampaignList, campaignList, response;
	        return _regenerator2.default.wrap(function _callee8$(_context8) {
	          while (1) {
	            switch (_context8.prev = _context8.next) {
	              case 0:
	                getAccessToken = this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                results = [];
	                globalCampaignList = [], campaignList = [];
	
	                if (true) {
	                  _context8.next = 18;
	                  break;
	                }
	
	                _context8.prev = 5;
	                _context8.next = 8;
	                return _axios2.default.get(_server2.default + '/user/campaigns', { headers: headers });
	
	              case 8:
	                response = _context8.sent;
	
	                console.log('[getAccessToken] ', response.data); // error is not defined
	                campaignList = response.data;
	                _context8.next = 16;
	                break;
	
	              case 13:
	                _context8.prev = 13;
	                _context8.t0 = _context8['catch'](5);
	
	                console.log('[getAccessToken] ', _context8.t0); // error is not defined
	
	              case 16:
	                _context8.next = 18;
	                return Promise.all(campaignList.forEach(function () {
	                  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(appItem) {
	                    var endDate, startDate, storeInfo, performanceMap, discoveryMap, campaignMapForAppId;
	                    return _regenerator2.default.wrap(function _callee7$(_context7) {
	                      while (1) {
	                        switch (_context7.prev = _context7.next) {
	                          case 0:
	                            endDate = (0, _moment2.default)(); //.format('YYYY-MM-DD');      
	
	                            startDate = (0, _moment2.default)(endDate).subtract(20, 'days');
	
	                            console.log(startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD'));
	                            /**
	                             * store info
	                             */
	                            storeInfo = null; //await this.getItunesStoreData(appItem.appId); 
	
	                            //https://medium.com/@antonioval/making-array-iteration-easy-when-using-async-await-6315c3225838
	
	                            _context7.next = 6;
	                            return Promise.all(appItem.performanceByRegion.map(function () {
	                              var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(item) {
	                                var reportResponse, totalData, searchadsCampaign, _response;
	
	                                return _regenerator2.default.wrap(function _callee5$(_context5) {
	                                  while (1) {
	                                    switch (_context5.prev = _context5.next) {
	                                      case 0:
	                                        reportResponse = void 0, totalData = void 0;
	
	                                        if (!item.campaignId) {
	                                          _context5.next = 13;
	                                          break;
	                                        }
	
	                                        _context5.prev = 2;
	                                        _context5.next = 5;
	                                        return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + item.campaignId + '/adgroups/rowtotals/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'), { headers: headers });
	
	                                      case 5:
	                                        reportResponse = _context5.sent;
	
	                                        if (reportResponse.data.response.pagination.totalResults > 0) {
	                                          totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
	                                        }
	                                        // if ( data.reportingDataResponse.row[])
	                                        console.log('[campaigns adgroups] ', item.campaignId, reportResponse.data.response);
	                                        _context5.next = 13;
	                                        break;
	
	                                      case 10:
	                                        _context5.prev = 10;
	                                        _context5.t0 = _context5['catch'](2);
	
	                                        console.log('[campaigns adgroups] ', item.campaignId, _context5.t0);
	
	                                      case 13:
	
	                                        //get p cid to check status : RUNNING / NOT_RUNNING
	                                        searchadsCampaign = void 0;
	                                        _context5.prev = 14;
	                                        _context5.next = 17;
	                                        return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + item.campaignId, { headers: headers });
	
	                                      case 17:
	                                        _response = _context5.sent;
	
	                                        console.log('[get campagin detail] ', _response.data.response.data); // error is not defined
	                                        searchadsCampaign = _response.data.response.data;
	                                        _context5.next = 25;
	                                        break;
	
	                                      case 22:
	                                        _context5.prev = 22;
	                                        _context5.t1 = _context5['catch'](14);
	
	                                        console.log('[get campagin detail]  ', _context5.t1); // error is not defined
	
	                                      case 25:
	                                        return _context5.abrupt('return', {
	                                          appId: appItem.appId, //primary id
	                                          region: item.region,
	                                          pCid: item.campaignId,
	                                          pReportAdGroup: reportResponse.data.response,
	                                          pTotalData: totalData,
	                                          emAdGroupId: item.emAdGroupId,
	                                          key: appItem.appId + item.region,
	                                          storeInfo: storeInfo,
	                                          servingStatus: searchadsCampaign.servingStatus,
	                                          appNamePrefix: 'DEV-' + appItem.user.shortId + '-' + appItem.appId
	                                        });
	
	                                      case 26:
	                                      case 'end':
	                                        return _context5.stop();
	                                    }
	                                  }
	                                }, _callee5, _this4, [[2, 10], [14, 22]]);
	                              }));
	
	                              return function (_x8) {
	                                return _ref7.apply(this, arguments);
	                              };
	                            }()));
	
	                          case 6:
	                            performanceMap = _context7.sent;
	                            _context7.next = 9;
	                            return Promise.all(appItem.discoveryByRegion.map(function () {
	                              var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(item) {
	                                var reportResponse, totalData;
	                                return _regenerator2.default.wrap(function _callee6$(_context6) {
	                                  while (1) {
	                                    switch (_context6.prev = _context6.next) {
	                                      case 0:
	                                        // console.log('campaignMapForAppId', campaignMapForAppId)
	                                        reportResponse = void 0, totalData = void 0;
	
	                                        if (!item.campaignId) {
	                                          _context6.next = 13;
	                                          break;
	                                        }
	
	                                        _context6.prev = 2;
	                                        _context6.next = 5;
	                                        return _axios2.default.get(_server2.default + '/user/campaigns/cid/' + item.campaignId + '/adgroups/rowtotals/' + startDate.format('YYYY-MM-DD') + '/' + endDate.format('YYYY-MM-DD'), { headers: headers });
	
	                                      case 5:
	                                        reportResponse = _context6.sent;
	
	                                        if (reportResponse.data.response.pagination.totalResults > 0) {
	                                          totalData = reportResponse.data.response.data.reportingDataResponse.row[0];
	                                        }
	                                        console.log('[campaigns adgroups] ', item.campaignId, reportResponse.data);
	                                        _context6.next = 13;
	                                        break;
	
	                                      case 10:
	                                        _context6.prev = 10;
	                                        _context6.t0 = _context6['catch'](2);
	
	                                        console.log('[campaigns adgroups] ', item.campaignId, _context6.t0);
	
	                                      case 13:
	                                        return _context6.abrupt('return', {
	                                          appId: appItem.appId, //primary id
	                                          region: item.region,
	                                          dCid: item.campaignId,
	                                          dReportAdGroup: reportResponse.data.response,
	                                          dTotalData: totalData,
	
	                                          smAdGroupId: item.smAdGroupId,
	                                          bmAdGroupId: item.bmAdGroupId,
	                                          storeInfo: storeInfo
	                                        });
	
	                                      case 14:
	                                      case 'end':
	                                        return _context6.stop();
	                                    }
	                                  }
	                                }, _callee6, _this4, [[2, 10]]);
	                              }));
	
	                              return function (_x9) {
	                                return _ref8.apply(this, arguments);
	                              };
	                            }()));
	
	                          case 9:
	                            discoveryMap = _context7.sent;
	                            campaignMapForAppId = _lodash2.default.map(performanceMap, function (obj) {
	                              return _lodash2.default.assign(obj, _lodash2.default.find(discoveryMap, {
	                                appId: obj.appId,
	                                region: obj.region
	                              }));
	                            });
	
	
	                            globalCampaignList = _lodash2.default.unionBy(_this4.state.globalCampaignList, campaignMapForAppId);
	                            console.log('globalCampaignList  : ', globalCampaignList);
	
	                            _this4.setState({
	                              globalCampaignList: globalCampaignList
	                            });
	
	                          case 14:
	                          case 'end':
	                            return _context7.stop();
	                        }
	                      }
	                    }, _callee7, _this4);
	                  }));
	
	                  return function (_x7) {
	                    return _ref6.apply(this, arguments);
	                  };
	                }()));
	
	              case 18:
	              case 'end':
	                return _context8.stop();
	            }
	          }
	        }, _callee8, this, [[5, 13]]);
	      }));
	
	      function componentDidMount() {
	        return _ref5.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      console.log(' componentWillUpdate');
	      //check difference
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      console.log(' componentWillReceiveProps');
	    }
	  }, {
	    key: 'goTo',
	    value: function goTo(route) {
	      this.props.history.push('' + route);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          profile = _state.profile,
	          globalCampaignList = _state.globalCampaignList;
	
	      console.log("globalCampaignList render " + globalCampaignList);
	      console.log("props in render " + this.props);
	      var appDetail = this.state.appDetail;
	      var _props = this.props,
	          searchTerm = _props.searchTerm,
	          campaign = _props.campaign;
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	      var _state2 = this.state,
	          app1 = _state2.app1,
	          app2 = _state2.app2;
	
	      var currentApp = app1;
	      var secondApp = app2;
	      var content = _react2.default.createElement('div', null);
	      // If we have budgetSplit, render them
	
	      if (globalCampaignList) {
	        //console.table(globalCampaignList);
	        content = _react2.default.createElement('div', null)
	        //         <div className="campaign-list">
	        //           <ul>
	        //           {
	        //             globalCampaignList.map((item) => {
	        //               console.log( 'campaign in render ' , item)
	        //               const storeInfo = item.storeInfo;
	        //               const dTotalData = item.dTotalData;
	        //               const pTotalData = item.pTotalData;
	        //               return (
	        //                 <div>
	        //               <li>
	        //               <Link key={ item.appId} to={`/dashboard/${item.appId}/region/${item.region}/pcid/${item.pCid}/dcid/${item.dCid}` }>
	        //               <dl className="app-header">
	        //                 <dt>
	        //                   <img src={ storeInfo && storeInfo.artworkUrl100} alt="screen"/>
	        //                 </dt>
	
	        //                 <dd>
	        //                   <span className="app-name">{ storeInfo && storeInfo.trackCensoredName }</span>
	        //                   <span className="app-desc">{ 'Region : ' + item.region + ' ' + item.appNamePrefix}</span>
	        //                   <span className="app-desc">{ 'p cid : ' + item.pCid }</span>
	        //                   <span className="app-desc">{ 'd cid : ' + item.dCid }</span>
	        //                   <span className="app-desc">{ storeInfo && storeInfo.sellerName }</span>
	        //                 </dd>
	        //               </dl>
	        //               </Link>
	        //               <dl className="cost">
	        //                 <dt>Cost Per Acquisition</dt>
	        //                 <dd>
	        //                   P: ${ pTotalData ? pTotalData.total.avgCPA.amount : ' --- '}
	        //                   <img src={ RedUpArrow } className="arrow-up"/>
	        //                 </dd>
	        //                 <dd>
	        //                   D:${ pTotalData ? pTotalData.total.avgCPA.amount : ' --- '}
	        //                   <img src={ RedUpArrow } className="arrow-up"/>
	        //                 </dd>
	        //               </dl>
	
	        //               <dl className="rate">
	        //                 <dt>Conversion Rate</dt>
	        //                 <dd>
	        //                   { pTotalData ? pTotalData.total.conversionRate * 100 + '%' : ' --- '}
	        //                   <div></div>
	        //                 </dd>
	        //                 <dd>
	        //                   { dTotalData ? dTotalData.total.conversionRate * 100 + '%' : ' --- '}
	        //                   <div></div>
	        //                 </dd>
	        //               </dl>
	
	        //               <div className="status"  >
	        //                 <input type="checkbox" 
	        //                   checked={item.servingStatus === 'RUNNING' ? true : false } 
	        //                   id={item.pCid + ' ' + item.dCid} 
	        //                   onChange={(event) => this.onStatusChanged(item.pCid, item.dCid,  event.target.checked? 'ENABLED' : 'PAUSED')}
	        //                   />
	        //                 <label htmlFor={item.pCid + ' ' + item.dCid} className="switch-wrapper">
	        //                   <span>
	        //                     <img src={ RunningIcon } className="running"/>
	        //                     <img src={ PauseIcon } className="paused"/>
	        //                   </span>
	
	        //                   <p className="running"></p>
	        //                   <p className="paused"></p>
	        //                 </label>
	        //               </div>
	        //             </li>
	        //             <ReactJson src={item} collapsed={ false}/>
	
	        // </div>
	        //             )
	        //               }
	        //             )
	        //           }
	        //           </ul>
	        //         </div>
	
	        ;
	      }
	
	      /**
	       * for fake
	       */
	      if (true) {
	        content = _react2.default.createElement(
	          'div',
	          { className: 'campaign-list' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { key: currentApp.adamId, to: '/dashboard/' + currentApp.adamId },
	                _react2.default.createElement(
	                  'dl',
	                  { className: 'app-header' },
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    _react2.default.createElement('img', { src: currentApp.artworkUrl100, alt: 'screen' })
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'app-name' },
	                      currentApp.trackCensoredName
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'app-desc' },
	                      currentApp.sellerName
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'dl',
	                { className: 'cost' },
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  'Cost Per Acquisition'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  '$1.71',
	                  _react2.default.createElement('img', { src: _arrowRed4.default, className: 'arrow-up' })
	                )
	              ),
	              _react2.default.createElement(
	                'dl',
	                { className: 'rate' },
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  'Conversion Rate'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  '67.21%',
	                  _react2.default.createElement('div', null)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'status' },
	                _react2.default.createElement('input', { type: 'checkbox', id: 'test1' }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'test1', className: 'switch-wrapper' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: _running2.default, className: 'running' }),
	                    _react2.default.createElement('img', { src: _pause2.default, className: 'paused' })
	                  ),
	                  _react2.default.createElement('p', { className: 'running' }),
	                  _react2.default.createElement('p', { className: 'paused' })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { key: secondApp.adamId, to: '/dashboard/' + secondApp.adamId },
	                _react2.default.createElement(
	                  'dl',
	                  { className: 'app-header' },
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    _react2.default.createElement('img', { src: secondApp.artworkUrl100, alt: 'screen' })
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'app-name' },
	                      secondApp.trackCensoredName
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'app-desc' },
	                      secondApp.sellerName
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'dl',
	                { className: 'cost' },
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  'Cost Per Acquisition'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  '$0.87',
	                  _react2.default.createElement('img', { src: _arrow_green4.default })
	                )
	              ),
	              _react2.default.createElement(
	                'dl',
	                { className: 'rate' },
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  'Conversion Rate'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  '72.60%',
	                  _react2.default.createElement('div', null)
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'status' },
	                _react2.default.createElement('input', { type: 'checkbox', id: 'test2' }),
	                _react2.default.createElement(
	                  'label',
	                  { htmlFor: 'test2', className: 'switch-wrapper' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement('img', { src: _running2.default, className: 'running' }),
	                    _react2.default.createElement('img', { src: _pause2.default, className: 'paused' })
	                  ),
	                  _react2.default.createElement('p', { className: 'running' }),
	                  _react2.default.createElement('p', { className: 'paused' })
	                )
	              )
	            )
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        _style2.default,
	        { className: 'page-wrapper' },
	        _react2.default.createElement(
	          _index2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(_Logo2.default, { isClickable: true, history: this.props.history }),
	            _react2.default.createElement(_Menu2.default, { history: this.props.history, auth: this.props.auth })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(
	              'h1',
	              null,
	              '\u5E7F\u544A\u9879\u76EE\u5217\u8868'
	            ),
	            _react2.default.createElement(_FillRow2.default, { className: 'hidden-xs' }),
	            _react2.default.createElement(_index4.default, {
	              auth: this.props.auth,
	              goTo: this.goTo.bind(this),
	              selectClassName: 'two-lines-result',
	              value: this.state.value,
	              onChange: this.onChange,
	              backspaceRemoves: this.state.backspaceRemoves,
	              placeholder: '\u641C\u7D22\u4F60\u7684\u5E94\u7528\u540D\u79F0\u6216App ID'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'campaign-list' },
	          _react2.default.createElement(_index8.default, {
	            authHeader: 'Bearer ' + this.props.auth.getAccessToken()
	          })
	        ),
	        content,
	        _react2.default.createElement('div', { className: 'profile-area' }),
	        _react2.default.createElement(_index6.default, null)
	      );
	    }
	  }]);
	
	  return CampaignList;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setApp: function setApp(app) {
	      return dispatch(appSelected(app));
	    },
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	
	  };
	}
	function mapStateToProps(state) {
	  var campaign = state.get('deep').campaign;
	  return {
	    search: state.get('search'),
	    campaign: campaign,
	    currentApp: state.getIn(['App', 'currentApp']),
	    secondApp: state.getIn(['App', 'secondApp']),
	    searchTerm: state.getIn(['App', 'searchTerm']),
	    countryCode: state.getIn(['ItunesSearch', 'countryCode']) && 'US'
	
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CampaignList);

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .header-row {\n        h1 {\n            margin: 0;\n            line-height: 36px;\n            font-family: \'Montserrat\';\n            font-size: 18px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            letter-spacing: 0.06em;\n        }\n\n        &:first-child { margin-bottom: 14px; }\n    }\n\n    @media screen and (max-width: 767px) {\n        header-row:first-child { margin-bottom: 0; }\n        .campaign-list { padding: 26px 16px 104px 16px; }\n    }\n'], ['\n    .header-row {\n        h1 {\n            margin: 0;\n            line-height: 36px;\n            font-family: \'Montserrat\';\n            font-size: 18px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            letter-spacing: 0.06em;\n        }\n\n        &:first-child { margin-bottom: 14px; }\n    }\n\n    @media screen and (max-width: 767px) {\n        header-row:first-child { margin-bottom: 0; }\n        .campaign-list { padding: 26px 16px 104px 16px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var CampaignListWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(CampaignListWrapper);

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .isoChartControl {\n    display: flex;\n    align-items: center;\n    margin-left: ', ';\n    margin-right: ', ';\n    margin-bottom: 20px;\n\n    span {\n      font-size: 13px;\n      color: ', ';\n      font-weight: 400;\n      margin-right: ', ';\n      margin-left: ', ';\n    }\n\n    button {\n      border: 1px solid ', ';\n      padding: 0 10px;\n      border-radius: 0;\n      position: relative;\n\n      span {\n        margin: 0;\n      }\n\n      &:last-child {\n        margin-left: ', ';\n        margin-right: ', ';\n      }\n\n      &:hover {\n        color: ', ';\n        border-color: ', ';\n        z-index: 1;\n\n        span {\n          color: ', ';\n        }\n      }\n    }\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .isoChartControl {\n    display: flex;\n    align-items: center;\n    margin-left: ', ';\n    margin-right: ', ';\n    margin-bottom: 20px;\n\n    span {\n      font-size: 13px;\n      color: ', ';\n      font-weight: 400;\n      margin-right: ', ';\n      margin-left: ', ';\n    }\n\n    button {\n      border: 1px solid ', ';\n      padding: 0 10px;\n      border-radius: 0;\n      position: relative;\n\n      span {\n        margin: 0;\n      }\n\n      &:last-child {\n        margin-left: ', ';\n        margin-right: ', ';\n      }\n\n      &:hover {\n        color: ', ';\n        border-color: ', ';\n        z-index: 1;\n\n        span {\n          color: ', ';\n        }\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ChartWrapper = _styledComponents2.default.div(_templateObject, function (props) {
	  return props['data-rtl'] === 'rtl' ? 'inherit' : 'auto';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? 'auto' : 'inherit';
	}, (0, _styledTheme.palette)('text', 1), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'inherit' : '15px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '15px' : 'inherit';
	}, (0, _styledTheme.palette)('border', 0), function (props) {
	  return props['data-rtl'] === 'rtl' ? 'inherit' : '-1px';
	}, function (props) {
	  return props['data-rtl'] === 'rtl' ? '-1px' : 'inherit';
	}, (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	
	exports.default = (0, _withDirection2.default)(ChartWrapper);

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactVis = __webpack_require__(2910);
	
	var _chart = __webpack_require__(1685);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleDonutChart = function (_Component) {
	  _inherits(SimpleDonutChart, _Component);
	
	  function SimpleDonutChart() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SimpleDonutChart);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SimpleDonutChart.__proto__ || Object.getPrototypeOf(SimpleDonutChart)).call.apply(_ref, [this].concat(args))), _this), _this.state = { value: false }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SimpleDonutChart, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var value = this.state.value;
	      var _props = this.props,
	          datas = _props.datas,
	          width = _props.width,
	          height = _props.height,
	          innerRadius = _props.innerRadius,
	          radius = _props.radius,
	          colorRange = _props.colorRange;
	
	      return _react2.default.createElement(
	        _chart2.default,
	        { className: 'isoChartWrapper' },
	        _react2.default.createElement(_reactVis.RadialChart, {
	          className: 'donut-chart-example',
	          innerRadius: innerRadius,
	          radius: radius,
	          data: datas,
	          colorRange: colorRange,
	          onValueMouseOver: function onValueMouseOver(v) {
	            return _this2.setState({ value: v });
	          },
	          onSeriesMouseOut: function onSeriesMouseOut(v) {
	            return _this2.setState({ value: false });
	          },
	          width: width,
	          height: height
	        })
	      );
	    }
	  }]);
	
	  return SimpleDonutChart;
	}(_react.Component);
	
	exports.default = SimpleDonutChart;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StreamGraph = exports.ComplexChart = exports.CandleStick = exports.AnimatedSunburst = exports.BasicSunburst = exports.DynamicTreeMap = exports.SimpleTreeMap = exports.CustomRadius = exports.SimpleDonutChart2 = exports.SimpleDonutChart = exports.SimpleRadialChart = exports.DynamicCrosshairScatterplot = exports.DynamicProgrammaticRightedgehints = exports.CircularGridLines = exports.CustomScales = exports.ClusteredStackedBarChart = exports.AreaChartElevated = exports.StackedHorizontalBarChart = exports.LineMark = exports.LineSeries = undefined;
	
	var _d3Shape = __webpack_require__(107);
	
	var _largeData = __webpack_require__(2298);
	
	var _largeData2 = _interopRequireDefault(_largeData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var width = 300;
	var height = 300;
	
	var buildCSData = function buildCSData(total) {
	  var result = Array(total).fill(0).map(function (x, i) {
	    var values = [Math.random(), Math.random(), Math.random(), Math.random()].sort().map(function (d) {
	      return Math.floor(d * 100);
	    });
	    var y = (values[2] + values[1]) / 2;
	    return {
	      x: i,
	      y: y,
	      yHigh: values[3],
	      yOpen: values[2],
	      yClose: values[1],
	      yLow: values[0],
	      color: y < 25 ? '#ff6384' : '#48A6F2',
	      opacity: y > 75 ? 0.7 : 1
	    };
	  });
	  return result;
	};
	var LineSeries = {
	  componentName: 'LineSeries',
	  key: 'LineSeries',
	  title: 'Line Series',
	  width: width,
	  height: height,
	  datas: [{
	    className: 'first-series',
	    data: [{ x: 1, y: 3 }, { x: 2, y: 5 }, { x: 3, y: 15 }, { x: 4, y: 12 }]
	  }, {
	    className: 'second-series',
	    data: null
	  }, {
	    className: 'third-series',
	    curve: 'curveMonotoneX',
	    strokeDasharray: '7, 3',
	    data: [{ x: 1, y: 10 }, { x: 2, y: 4 }, { x: 3, y: 2 }, { x: 4, y: 15 }]
	  }, {
	    className: 'fourth-series',
	    curve: _d3Shape.curveCatmullRom.alpha(0.5),
	    strokeDasharray: '7, 3',
	    data: [{ x: 1, y: 7 }, { x: 2, y: 11 }, { x: 3, y: 9 }, { x: 4, y: 2 }]
	  }]
	};
	var LineMark = {
	  componentName: 'LineMark',
	  key: 'LineMark',
	  title: 'Line Mark Series',
	  width: width,
	  height: height,
	  datas: [
	  // {
	  //   className: 'linemark-series-example',
	  //   data: [{ x: 1, y: 10 }, { x: 2, y: 5 }, { x: 3, y: 15 }],
	  // },
	  {
	    className: 'linemark-series-example-2',
	    curve: 'curveMonotoneX',
	    data: [{ x: 1, y: 11 }, { x: 1.5, y: 29 }, { x: 3, y: 7 }, { x: 9, y: 11 }]
	  }]
	};
	var AreaChartElevated = {
	  componentName: 'AreaChartElevated',
	  key: 'AreaChartElevated',
	  title: 'Area Chart Elevated',
	  width: width,
	  height: height,
	  datas: [{
	    className: 'area-elevated-line-series',
	    color: 'rgba(72,166,242,0.4)',
	    data: [{ x: 1, y: 10, y0: 1 }, { x: 2, y: 25, y0: 5 }, { x: 3, y: 15, y0: 3 }]
	  }, {
	    className: 'area-elevated-line-series-2',
	    color: 'rgba(255,99,132,0.4)',
	    data: [{ x: 1, y: 5, y0: 6 }, { x: 2, y: 20, y0: 11 }, { x: 3, y: 10, y0: 9 }]
	  }, {
	    className: 'area-elevated-line-series-3',
	    color: 'rgba(72,166,242,0.4)',
	    data: [{ x: 1, y: 5.5 }, { x: 2, y: 15 }, { x: 3, y: 9 }]
	  }]
	};
	var StackedHorizontalBarChart = {
	  componentName: 'StackedHorizontalBarChart',
	  key: 'StackedHorizontalBarChart',
	  title: 'Stacked Horizontal Bar Chart',
	  width: width,
	  height: height,
	  datas: [{
	    color: 'rgba(72,166,242,0.4)',
	    data: [{ y: 2, x: 10 }, { y: 4, x: 5 }, { y: 5, x: 15 }]
	  }, {
	    color: 'rgba(255,99,132,0.4)',
	    data: [{ y: 2, x: 12 }, { y: 4, x: 2 }, { y: 5, x: 11 }]
	  }]
	};
	var ClusteredStackedBarChart = {
	  componentName: 'ClusteredStackedBarChart',
	  key: 'ClusteredStackedBarChart',
	  title: 'Clustered Stacked Bar Chart',
	  width: width,
	  height: 300,
	  orientationItems: [{
	    title: 'Apples',
	    color: 'rgba(255,99,132,0.4)'
	  }, {
	    title: 'Oranges',
	    color: 'rgba(72,166,242,0.4)'
	  }],
	  datas: [{
	    cluster: '2015',
	    color: 'rgba(255,99,132,0.4)',
	    data: [{ x: 'Q1', y: 10 }, { x: 'Q2', y: 5 }, { x: 'Q3', y: 15 }, { x: 'Q4', y: 20 }]
	  }, {
	    cluster: '2015',
	    color: 'rgba(72,166,242,0.4)',
	    data: [{ x: 'Q1', y: 3 }, { x: 'Q2', y: 7 }, { x: 'Q3', y: 2 }, { x: 'Q4', y: 1 }]
	  }, {
	    cluster: '2016',
	    color: 'rgba(255,99,132,0.4)',
	    data: [{ x: 'Q1', y: 3 }, { x: 'Q2', y: 8 }, { x: 'Q3', y: 11 }, { x: 'Q4', y: 19 }]
	  }, {
	    cluster: '2016',
	    color: 'rgba(72,166,242,0.4)',
	    data: [{ x: 'Q1', y: 22 }, { x: 'Q2', y: 2 }, { x: 'Q3', y: 22 }, { x: 'Q4', y: 18 }]
	  }]
	};
	var CustomScales = {
	  componentName: 'CustomScales',
	  key: 'CustomScales',
	  title: 'Custom Scales',
	  width: width,
	  height: height,
	  datas: [{
	    data: [{ x: 1, y: 3 }, { x: 2, y: 5 }, { x: 3, y: 15 }, { x: 4, y: 12 }]
	  }, {
	    data: null
	  }, {
	    data: [{ x: 1, y: 10 }, { x: 2, y: 4 }, { x: 4, y: 2 }, { x: 5, y: 15 }]
	  }]
	};
	var CircularGridLines = {
	  componentName: 'CircularGridLines',
	  key: 'CircularGridLines',
	  title: 'Circular Grid Lines',
	  width: width,
	  height: height,
	  xDomain: [-3, 3],
	  yDomain: [-3, 3],
	  strokeWidth: 2,
	  sizeRange: [5, 15],
	  datas: [{ r: 1, theta: Math.PI / 3, size: 30 }, { r: 1.7, theta: 2 * Math.PI / 3, size: 10 }, { r: 2, theta: Math.PI, size: 1 }, { r: 3, theta: 3 * Math.PI / 2, size: 12 }, { r: 2.5, theta: Math.PI / 4, size: 4 }, { r: 0, theta: Math.PI / 4, size: 1 }]
	};
	var DynamicProgrammaticRightedgehints = {
	  componentName: 'DynamicProgrammaticRightedgehints',
	  key: 'DynamicProgrammaticRightedgehints',
	  title: 'Dynamic Programmatic Right Edge Hints',
	  width: width,
	  height: height,
	  xMax: 4,
	  datas: [{ x: 1, y: 5 }, { x: 2, y: 12 }, { x: 3, y: 8 }, { x: 4, y: 15 }]
	};
	var DynamicCrosshairScatterplot = {
	  componentName: 'DynamicCrosshairScatterplot',
	  key: 'DynamicCrosshairScatterplot',
	  title: 'Dynamic Crosshair Scatterplot',
	  width: width,
	  height: height,
	  xDomain: [1, 3],
	  yDomain: [4, 14],
	  xRange: [40, 290],
	  yRange: [260, 10],
	  extent: [[40, 10], [290, 260]],
	  sizeRange: [5, 13],
	  datas: [{ x: 1, y: 4, size: 9 }, { x: 1, y: 5, size: 18 }, { x: 1, y: 10, size: 5 }, { x: 1, y: 11, size: 29 }, { x: 1, y: 13.9, size: 5 }, { x: 1, y: 14, size: 8 }, { x: 1.5, y: 11.8, size: 25 }, { x: 1.7, y: 9, size: 30 }, { x: 2, y: 5, size: 11 }, { x: 2.1, y: 11.8, size: 28 }, { x: 2.4, y: 7.9, size: 14 }, { x: 2.4, y: 13.5, size: 20 }, { x: 2.7, y: 13.7, size: 14 }, { x: 2.9, y: 7.7, size: 26 }, { x: 3, y: 5.4, size: 6 }]
	};
	var SimpleRadialChart = {
	  componentName: 'SimpleRadialChart',
	  key: 'SimpleRadialChart',
	  title: 'simple Radial Chart',
	  width: width,
	  height: height,
	  colorRange: [0, 10],
	  colorDomain: [0, 100],
	  datas: [{ angle: 1, color: '#89DAC1', label: 'green', opacity: 0.2 }, { angle: 2, color: '#F6D18A', label: 'yellow' }, { angle: 5, color: '#1E96BE', label: 'cyan' }, { angle: 3, color: '#DA70BF', label: 'magenta' }, { angle: 5, color: '#F6D18A', label: 'yellow again' }]
	};
	var SimpleDonutChart = {
	  componentName: 'SimpleDonutChart',
	  key: 'SimpleDonutChart',
	  title: 'Simple Donut Chart',
	  width: width,
	  height: height,
	  innerRadius: 120,
	  radius: 140,
	  datas: [{ angle: 2 }, { angle: 6 }, { angle: 2 }, { angle: 3 }, { angle: 1 }]
	};
	
	var SimpleDonutChart2 = {
	  componentName: 'SimpleDonutChart',
	  key: 'SimpleDonutChart',
	  title: 'Simple Donut Chart',
	  width: width,
	  height: height,
	  colorRange: ['#d0f3ff', '#68cff0'],
	  innerRadius: 90,
	  radius: 104,
	  datas: [{ angle: 6, colorType: "literal" }, { angle: 4, colorType: "literal" }]
	};
	var CustomRadius = {
	  componentName: 'CustomRadius',
	  key: 'CustomRadius',
	  title: 'Custom Radius',
	  width: width,
	  height: height,
	  radiusDomain: [0, 20],
	  tickTotal: 20,
	  rRange: [0, 150],
	  datas: [{ angle: 1, id: 1, radius: 10 }, {
	    angle: 2,
	    label: 'Super Custom label',
	    subLabel: 'With annotation',
	    id: 2,
	    radius: 20
	  }, { angle: 5, id: 3, radius: 5, label: 'Alt Label' }, { angle: 3, id: 4, radius: 14 }, { angle: 5, id: 5, adius: 12, subLabel: 'Sub Label only' }]
	};
	var SimpleTreeMap = {
	  componentName: 'SimpleTreeMap',
	  key: 'SimpleTreeMap',
	  title: 'Simple Tree Map',
	  width: width,
	  height: height,
	  datas: _largeData2.default
	};
	var DynamicTreeMap = {
	  componentName: 'DynamicTreeMap',
	  key: 'DynamicTreeMap',
	  title: 'Dynamic Tree Map',
	  width: width,
	  height: height
	};
	var BasicSunburst = {
	  componentName: 'BasicSunburst',
	  key: 'BasicSunburst',
	  title: 'Basic Sunburst',
	  width: width,
	  height: height,
	  datas: _largeData2.default
	};
	var AnimatedSunburst = {
	  componentName: 'AnimatedSunburst',
	  key: 'AnimatedSunburst',
	  title: 'Animated Sunburst',
	  width: width,
	  height: height
	};
	var CandleStick = {
	  componentName: 'CandleStick',
	  key: 'CandleStick',
	  title: 'Candle Stick',
	  height: height,
	  datas: buildCSData(30)
	};
	var ComplexChart = {
	  componentName: 'ComplexChart',
	  key: 'ComplexChart',
	  title: 'Complex Chart'
	};
	var StreamGraph = {
	  componentName: 'StreamGraph',
	  key: 'StreamGraph',
	  title: 'Stream Graph'
	};
	
	exports.LineSeries = LineSeries;
	exports.LineMark = LineMark;
	exports.StackedHorizontalBarChart = StackedHorizontalBarChart;
	exports.AreaChartElevated = AreaChartElevated;
	exports.ClusteredStackedBarChart = ClusteredStackedBarChart;
	exports.CustomScales = CustomScales;
	exports.CircularGridLines = CircularGridLines;
	exports.DynamicProgrammaticRightedgehints = DynamicProgrammaticRightedgehints;
	exports.DynamicCrosshairScatterplot = DynamicCrosshairScatterplot;
	exports.SimpleRadialChart = SimpleRadialChart;
	exports.SimpleDonutChart = SimpleDonutChart;
	exports.SimpleDonutChart2 = SimpleDonutChart2;
	exports.CustomRadius = CustomRadius;
	exports.SimpleTreeMap = SimpleTreeMap;
	exports.DynamicTreeMap = DynamicTreeMap;
	exports.BasicSunburst = BasicSunburst;
	exports.AnimatedSunburst = AnimatedSunburst;
	exports.CandleStick = CandleStick;
	exports.ComplexChart = ComplexChart;
	exports.StreamGraph = StreamGraph;

/***/ },
/* 1688 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var width = 350;
	var height = 350;
	var colors = ['#BAA6CA', '#B7DCFA', '#FFE69A', '#788195'];
	var datas = [{ name: 'Page A', uv: 4000, pv: 2400, amt: 2400 }, { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 }, { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 }, { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 }, { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 }, { name: 'Page F', uv: 2390, pv: 3800, amt: 2500 }, { name: 'Page G', uv: 3490, pv: 4300, amt: 2100 }];
	var SimpleLineCharts = {
	  componentName: 'SimpleLineCharts',
	  key: 'SimpleLineCharts',
	  title: 'Simple Line Charts',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	var CustomizedDotLineChart = {
	  componentName: 'CustomizedDotLineChart',
	  key: 'CustomizedDotLineChart',
	  title: 'Customized Dot Line Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: [Object.assign({}, datas[0], { fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z' }), Object.assign({}, datas[1], { fillColor: '#ff6384', svg: 'M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z' }), Object.assign({}, datas[2], { fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z' }), Object.assign({}, datas[3], { fillColor: '#ff6384', svg: 'M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z' }), Object.assign({}, datas[4], { fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z' }), Object.assign({}, datas[5], { fillColor: '#ff6384', svg: 'M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z' }), Object.assign({}, datas[6], { fillColor: '#48A6F2', svg: 'M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z' })]
	};
	var SimpleBarChart = {
	  componentName: 'SimpleBarChart',
	  key: 'SimpleBarChart',
	  title: 'Simple Bar Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	var MixBarChart = {
	  componentName: 'MixBarChart',
	  key: 'MixBarChart',
	  title: 'Mix Bar Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: [{ name: 'Page A', uv: 4000, female: 2400, male: 2400 }, { name: 'Page B', uv: 3000, female: 1398, male: 2210 }, { name: 'Page C', uv: 2000, female: 9800, male: 2290 }, { name: 'Page D', uv: 2780, female: 3908, male: 2000 }, { name: 'Page E', uv: 1890, female: 4800, male: 2181 }, { name: 'Page F', uv: 2390, female: 3800, male: 2500 }, { name: 'Page G', uv: 3490, female: 4300, male: 2100 }]
	};
	var CustomShapeBarChart = {
	  componentName: 'CustomShapeBarChart',
	  key: 'CustomShapeBarChart',
	  title: 'Custom Shape Bar Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: MixBarChart.datas
	};
	var BiaxialBarChart = {
	  componentName: 'BiaxialBarChart',
	  key: 'BiaxialBarChart',
	  title: 'Biaxial Bar Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	var SimpleAreaChart = {
	  componentName: 'SimpleAreaChart',
	  key: 'SimpleAreaChart',
	  title: 'Simple Area Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	var StackedAreaChart = {
	  componentName: 'StackedAreaChart',
	  key: 'StackedAreaChart',
	  title: 'Stacked Area Chart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	var LineBarAreaComposedChart = {
	  componentName: 'LineBarAreaComposedChart',
	  key: 'LineBarAreaComposedChart',
	  title: 'Line Bar Area ComposedChart',
	  width: width,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	var CustomActiveShapePieChart = {
	  componentName: 'CustomActiveShapePieChart',
	  key: 'CustomActiveShapePieChart',
	  title: 'Custom Active Shape Pie Chart',
	  width: 600,
	  height: height,
	  colors: colors,
	  dataKey: 'value',
	  datas: [{ name: 'Group A', value: 400 }, { name: 'Group B', value: 300 }, { name: 'Group C', value: 300 }, { name: 'Group D', value: 200 }]
	};
	var SpecifiedDomainRadarChart = {
	  componentName: 'SpecifiedDomainRadarChart',
	  key: 'SpecifiedDomainRadarChart',
	  title: 'Specified Domain Radar Chart',
	  width: 600,
	  height: 500,
	  colors: colors,
	  angle: 30,
	  domain: [0, 150],
	  cx: 300,
	  cy: 250,
	  outerRadius: 150,
	  datas: [{ subject: 'Math', A: 120, B: 110, fullMark: 150 }, { subject: 'Chinese', A: 98, B: 130, fullMark: 150 }, { subject: 'English', A: 86, B: 130, fullMark: 150 }, { subject: 'Geography', A: 99, B: 100, fullMark: 150 }, { subject: 'Physics', A: 85, B: 90, fullMark: 150 }, { subject: 'History', A: 65, B: 85, fullMark: 150 }]
	};
	var SimpleRadialBarChart = {
	  componentName: 'SimpleRadialBarChart',
	  key: 'SimpleRadialBarChart',
	  title: 'Simple Radial Bar Chart',
	  width: 600,
	  height: 300,
	  datas: [{ name: '18-24', uv: 31.47, pv: 2400, fill: '#8884d8' }, { name: '25-29', uv: 26.69, pv: 4567, fill: '#83a6ed' }, { name: '30-34', uv: 15.69, pv: 1398, fill: '#8dd1e1' }, { name: '35-39', uv: 8.22, pv: 9800, fill: '#82ca9d' }, { name: '40-49', uv: 8.63, pv: 3908, fill: '#a4de6c' }, { name: '50+', uv: 2.63, pv: 4800, fill: '#d0ed57' }, { name: 'unknow', uv: 6.67, pv: 4800, fill: '#ffc658' }]
	};
	var LegendEffectOpacity = {
	  componentName: 'LegendEffectOpacity',
	  key: 'LegendEffectOpacity',
	  title: 'Legend Effect Opacity',
	  width: 600,
	  height: height,
	  colors: colors,
	  datas: datas
	};
	
	exports.SimpleLineCharts = SimpleLineCharts;
	exports.CustomizedDotLineChart = CustomizedDotLineChart;
	exports.SimpleBarChart = SimpleBarChart;
	exports.MixBarChart = MixBarChart;
	exports.CustomShapeBarChart = CustomShapeBarChart;
	exports.BiaxialBarChart = BiaxialBarChart;
	exports.SimpleAreaChart = SimpleAreaChart;
	exports.StackedAreaChart = StackedAreaChart;
	exports.LineBarAreaComposedChart = LineBarAreaComposedChart;
	exports.CustomActiveShapePieChart = CustomActiveShapePieChart;
	exports.SpecifiedDomainRadarChart = SpecifiedDomainRadarChart;
	exports.SimpleRadialBarChart = SimpleRadialBarChart;
	exports.LegendEffectOpacity = LegendEffectOpacity;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    min-width: 800px;\n\n    > * { padding: 0 64px; }\n    h2 {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        min-height: 60px;\n        background-color: rgba(252, 252, 252, 1);\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n        box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 + * {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        min-height: 60px;\n        background-color: rgba(219, 219, 219, 0.35);\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 + * * {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(35, 31, 32, 1);\n        letter-spacing: 0.01em;\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 ~ :last-child {\n        padding-top: 14px;\n        padding-bottom: 42px;\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 ~ :last-child > :first-child {\n        margin-bottom: 17px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.04em;\n    }\n\n    .border-wrapper { display: inline-flex; margin-bottom: 30px; border-radius: 19px; height: 38px; }\n\n    // -- Budget Selector\n    .budget-selector {\n        justify-content: flex-start;\n        align-items: center;\n        border: 1px solid rgba(151, 151, 151, 1);\n    }\n    .budget-selector input:only-child {\n        flex-grow: 1;\n        border-width: 0;\n        height: 38px;\n        background-color: transparent;\n        padding-right: 13px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: right;\n        letter-spacing: 0.04em;\n        box-shadow: none;\n    }\n    .budget-selector input:only-child:focus { outline-width: 0; }\n\n    .symbol-wrapper {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 41px;\n        height: 38px;\n        padding-left: 5px;\n        min-width: 41px;\n        border-right: 1px solid rgba(151, 151, 151, 1);\n    }\n    .symbol-wrapper div {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(147, 147, 147, 1);\n        letter-spacing: 0.07em;\n    }\n\n    // -- Add Budget Button\n    button.border-wrapper {\n        justify-content: center;\n        padding: 0 21px;\n        background-color: rgba(60, 211, 207, 1);\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        letter-spacing: 0.01em;\n    }\n\n    @media screen and (max-width: 767px) {\n        min-width: unset;\n        width: calc(100vw - 32px);\n\n        > * { padding: 0 25px; }\n    }\n'], ['\n    min-width: 800px;\n\n    > * { padding: 0 64px; }\n    h2 {\n        display: flex;\n        align-items: center;\n        margin: 0;\n        min-height: 60px;\n        background-color: rgba(252, 252, 252, 1);\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n        box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 + * {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        min-height: 60px;\n        background-color: rgba(219, 219, 219, 0.35);\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 + * * {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(35, 31, 32, 1);\n        letter-spacing: 0.01em;\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 ~ :last-child {\n        padding-top: 14px;\n        padding-bottom: 42px;\n    }\n\n    /*\n    please user classname instead to improve readability\n    */\n    h2 ~ :last-child > :first-child {\n        margin-bottom: 17px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.04em;\n    }\n\n    .border-wrapper { display: inline-flex; margin-bottom: 30px; border-radius: 19px; height: 38px; }\n\n    // -- Budget Selector\n    .budget-selector {\n        justify-content: flex-start;\n        align-items: center;\n        border: 1px solid rgba(151, 151, 151, 1);\n    }\n    .budget-selector input:only-child {\n        flex-grow: 1;\n        border-width: 0;\n        height: 38px;\n        background-color: transparent;\n        padding-right: 13px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        color: rgba(64, 55, 57, 1);\n        text-align: right;\n        letter-spacing: 0.04em;\n        box-shadow: none;\n    }\n    .budget-selector input:only-child:focus { outline-width: 0; }\n\n    .symbol-wrapper {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 41px;\n        height: 38px;\n        padding-left: 5px;\n        min-width: 41px;\n        border-right: 1px solid rgba(151, 151, 151, 1);\n    }\n    .symbol-wrapper div {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(147, 147, 147, 1);\n        letter-spacing: 0.07em;\n    }\n\n    // -- Add Budget Button\n    button.border-wrapper {\n        justify-content: center;\n        padding: 0 21px;\n        background-color: rgba(60, 211, 207, 1);\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        letter-spacing: 0.01em;\n    }\n\n    @media screen and (max-width: 767px) {\n        min-width: unset;\n        width: calc(100vw - 32px);\n\n        > * { padding: 0 25px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactResponsiveModal = __webpack_require__(1275);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _dropdown = __webpack_require__(276);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _Wrapper = __webpack_require__(1689);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _US = __webpack_require__(575);
	
	var _US2 = _interopRequireDefault(_US);
	
	var _AU = __webpack_require__(569);
	
	var _AU2 = _interopRequireDefault(_AU);
	
	var _Canada = __webpack_require__(571);
	
	var _Canada2 = _interopRequireDefault(_Canada);
	
	var _CH = __webpack_require__(570);
	
	var _CH2 = _interopRequireDefault(_CH);
	
	var _GB = __webpack_require__(572);
	
	var _GB2 = _interopRequireDefault(_GB);
	
	var _MX = __webpack_require__(573);
	
	var _MX2 = _interopRequireDefault(_MX);
	
	var _NZ = __webpack_require__(574);
	
	var _NZ2 = _interopRequireDefault(_NZ);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// -- React Libraries
	
	
	// -- Styles
	
	
	var AddBudgetModal = function (_React$Component) {
	    _inherits(AddBudgetModal, _React$Component);
	
	    function AddBudgetModal(props) {
	        _classCallCheck(this, AddBudgetModal);
	
	        var _this = _possibleConstructorReturn(this, (AddBudgetModal.__proto__ || Object.getPrototypeOf(AddBudgetModal)).call(this, props));
	
	        _this.onRegionSelected = function (item) {
	            console.log('on region selected : ', item);
	
	            if (item.key === 'ALL') {
	                /**
	                 * not yet handled
	                 */
	            } else {
	                _this.setState({
	                    region: item.key
	                });
	            }
	        };
	
	        _this.state = {
	            budget: _this.props.defaultBudget,
	            region: _this.props.defaultRegion
	        };
	        _this.handleChange = _this.handleChange.bind(_this);
	        return _this;
	    }
	
	    _createClass(AddBudgetModal, [{
	        key: 'handleChange',
	        value: function handleChange(event) {
	            this.setState({ budget: event.target.value });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var _state = this.state,
	                budget = _state.budget,
	                region = _state.region;
	
	
	            var menuSubmenu = _react2.default.createElement(
	                _dropdown.DropdownMenu,
	                { onClick: function onClick(value) {
	                        return _this2.onRegionSelected(value);
	                    } },
	                this.props.storeFrontCountryCodes && this.props.storeFrontCountryCodes.map(function (region) {
	                    var flag = void 0;
	                    /**
	                    * should use the flag lib for consistency
	                    **/
	                    switch (region) {
	                        case 'AU':
	                            flag = _AU2.default;break;
	                        case 'CA':
	                            flag = _Canada2.default;break;
	                        case 'CH':
	                            flag = _CH2.default;break;
	                        case 'GB':
	                            flag = _GB2.default;break;
	                        case 'MX':
	                            flag = _MX2.default;break;
	                        case 'NZ':
	                            flag = _NZ2.default;break;
	                        case 'US':
	                            flag = _US2.default;break;
	                    }
	
	                    return _react2.default.createElement(
	                        _dropdown.MenuItem,
	                        { key: region },
	                        _react2.default.createElement('img', { style: { width: '36px' }, src: flag, alt: region }),
	                        region
	                    );
	                })
	            );
	
	            return _react2.default.createElement(
	                _reactResponsiveModal2.default,
	                {
	                    open: this.props.isOpened,
	                    onClose: this.props.onClose,
	                    center: true,
	                    classNames: { modal: 'custom-modal' } },
	                _react2.default.createElement(
	                    'style',
	                    null,
	                    "\
	                    .custom-modal { padding: 0; }\
	                    .custom-modal > button { top: 21px; right: 21px; }\
	                    .custom-modal > button svg { width: 18px; height: 18px; color: rgba(61, 61, 61, 1); }\
	                "
	                ),
	                _react2.default.createElement(
	                    _Wrapper2.default,
	                    null,
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'Add More Budget'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'You have ',
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                '$',
	                                this.props.budgetLeft
	                            ),
	                            '\xA0of your total budget left.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'How much do you want to spend?'
	                        ),
	                        false && _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'round-border-wrapper countries' },
	                                _react2.default.createElement(
	                                    _dropdown2.default,
	                                    { overlay: menuSubmenu },
	                                    _react2.default.createElement(
	                                        'a',
	                                        { className: 'ant-dropdown-link' },
	                                        region || "ALL COUNTRIES"
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'border-wrapper budget-selector' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'symbol-wrapper' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        null,
	                                        '$'
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'input-wrapper' },
	                                    _react2.default.createElement('input', {
	                                        value: budget,
	                                        onChange: this.handleChange })
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                'button',
	                                {
	                                    onClick: function onClick() {
	                                        return _this2.props.onBudgetComfirmed && _this2.props.onBudgetComfirmed(budget, region);
	                                    },
	                                    className: 'border-wrapper' },
	                                'Add $ ',
	                                budget
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AddBudgetModal;
	}(_react2.default.Component);
	
	exports.default = AddBudgetModal;
	;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJsonView = __webpack_require__(493);
	
	var _reactJsonView2 = _interopRequireDefault(_reactJsonView);
	
	var _reactStripeElements = __webpack_require__(256);
	
	var _american_express = __webpack_require__(563);
	
	var _american_express2 = _interopRequireDefault(_american_express);
	
	var _android_pay = __webpack_require__(564);
	
	var _android_pay2 = _interopRequireDefault(_android_pay);
	
	var _apple_pay = __webpack_require__(565);
	
	var _apple_pay2 = _interopRequireDefault(_apple_pay);
	
	var _visa = __webpack_require__(567);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _master = __webpack_require__(566);
	
	var _master2 = _interopRequireDefault(_master);
	
	var _download_green_arrow = __webpack_require__(568);
	
	var _download_green_arrow2 = _interopRequireDefault(_download_green_arrow);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _formStyle = __webpack_require__(1692);
	
	var _formStyle2 = _interopRequireDefault(_formStyle);
	
	var _checkbox = __webpack_require__(739);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _nprogress = __webpack_require__(320);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _index = __webpack_require__(393);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// -- Components
	
	
	var handleBlur = function handleBlur() {
	  // console.log('[blur]');
	};
	var handleChange = function handleChange(change) {
	  // console.log('[change]', change);
	};
	var handleClick = function handleClick() {
	  // console.log('[click]');
	};
	var handleFocus = function handleFocus() {
	  // console.log('[focus]');
	};
	var handleReady = function handleReady() {
	  // console.log('[ready]');
	};
	
	var createOptions = function createOptions(fontSize) {
	  return {
	    style: {
	      base: {
	        fontSize: fontSize,
	        color: '#424770',
	        letterSpacing: '0.025em',
	        fontFamily: 'Source Code Pro, Menlo, monospace',
	        '::placeholder': {
	          color: '#aab7c4'
	        }
	      },
	      invalid: {
	        color: '#9e2146'
	      }
	    }
	  };
	};
	
	var CheckoutForm = function (_React$Component) {
	  _inherits(CheckoutForm, _React$Component);
	
	  function CheckoutForm(props) {
	    _classCallCheck(this, CheckoutForm);
	
	    var _this = _possibleConstructorReturn(this, (CheckoutForm.__proto__ || Object.getPrototypeOf(CheckoutForm)).call(this, props));
	
	    _this.handleAddressChange = function (ev) {
	      _this.setState({ address: ev.target.value });
	    };
	
	    _this.handleCityChange = function (ev) {
	      _this.setState({ city: ev.target.value });
	    };
	
	    _this.handleStateChange = function (ev) {
	      _this.setState({ state: ev.target.value });
	    };
	
	    _this.handleCountryChange = function (ev) {
	      _this.setState({ country: ev.target.value });
	    };
	
	    _this.handlePostalCodeChange = function (ev) {
	      _this.setState({ postalCode: ev.target.value });
	    };
	
	    _this.handleNameChange = function (ev) {
	      _this.setState({ name: ev.target.value });
	    };
	
	    _this.handleEmailChange = function (ev) {
	      _this.setState({ email: ev.target.value });
	    };
	
	    _this.handleSubmit = function (ev) {
	
	      // We don't want to let default form submission happen here, which would refresh the page.
	      _this.setState({ response: null, needLoading: true });
	      var campaign = _this.props.campaign;
	      // process.env.REACT_APP_STAGE === 'fake' && this.props.history.push(`/dashboard/` + campaign.adamId);
	
	      var _this$props$addBudget = _this.props.addBudgetData,
	          appId = _this$props$addBudget.appId,
	          budget = _this$props$addBudget.budget,
	          region = _this$props$addBudget.region;
	      var _this$props$currentAp = _this.props.currentApp,
	          bundleId = _this$props$currentAp.bundleId,
	          appName = _this$props$currentAp.appName;
	      var getAccessToken = _this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	
	      ev.preventDefault();
	
	      _this.props.stripe.createToken({
	        name: _this.props.profile.name, // card holder name
	        // address_line1: this.state.address,
	        email: _this.props.profile.email
	      }).then(function (payload) {
	        // axios.post(`${API_URL}/searchads/campaigns/create/`, request, { headers } )
	        // .then(response => {
	        //   this.setState({ message: 'asdfsdf', response: response.data})
	        //   this.props.history.push(`/profile`) 
	        // })
	        // .catch(error => this.setState({ message: error.message }));
	
	        console.log('Received Stripe token:', payload);
	        console.log('Received campaign:', campaign);
	        console.log('Received appName:', appName);
	        // return;
	        _nprogress2.default.start();
	        var postData = {
	          token: payload.token,
	          appId: appId,
	          region: region,
	          budget: parseFloat(budget)
	        };
	        _this.setState({ postData: postData });
	
	        _axios2.default.post(_server2.default + '/order/budget/', postData, { headers: headers }).then(function (response) {
	          _nprogress2.default.done();
	
	          console.log(response);
	          // this.props.history.push(`/dashboard/` + campaign.adamId  );
	
	          _this.props.updateResult(true, response);
	          // this.props.isFinishPurhcase(response)
	          // this.props.history.push(`/profile`) 
	          console.log(' 200 ');
	        }).catch(function (error) {
	          _nprogress2.default.done();
	
	          var response = error.response;
	          _this.setState({ response: response.data });
	          console.log(' 500 ', response);
	          _this.props.updateError(false, response.data);
	        });
	      });
	    };
	
	    _this.state = {
	      needLoading: false
	      // email: '',
	      // name: '',
	      // address: '',
	      // city: '',
	      // state: '',
	      // country: 'HK',
	      // postal_code: '',
	      // referalToken: ''
	    };
	
	    // this.handleEmailChange = this.handleEmailChange.bind(this);
	    // this.handlePasswordChange = this.handlePasswordChange.bind(this);
	    return _this;
	  }
	
	  _createClass(CheckoutForm, [{
	    key: 'render',
	    value: function render() {
	      var _arguments = arguments;
	
	      console.log(' API_URL : ', _server2.default, ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_STAGE":"fake"}));
	      return _react2.default.createElement(
	        _formStyle2.default,
	        null,
	        this.state.needLoading && _react2.default.createElement(_index2.default, null),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            'label',
	            { className: 'StripeLabel' },
	            _react2.default.createElement(_reactStripeElements.CardElement, Object.assign({
	              hidePostalCode: true,
	              onBlur: handleBlur,
	              onChange: handleChange,
	              onFocus: handleFocus,
	              onReady: handleReady
	            }, createOptions(this.props.fontSize)))
	          ),
	          _react2.default.createElement('div', { className: 'my-input', id: 'card-element' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { className: 'visa', src: _visa2.default, alt: 'visa' }),
	            _react2.default.createElement('img', { className: 'master', src: _master2.default, alt: 'master' }),
	            _react2.default.createElement('img', { className: 'ae', src: _american_express2.default, alt: 'ae' }),
	            _react2.default.createElement('img', { className: 'apple-pay', src: _apple_pay2.default, alt: 'apple-pay' }),
	            _react2.default.createElement('img', { className: 'android-pay', src: _android_pay2.default, alt: 'android-pay' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _checkbox2.default,
	              { handleChick: function handleChick() {
	                  console.log(_arguments);
	                } },
	              _react2.default.createElement(
	                'span',
	                { className: 'remeber-card' },
	                'Save this card'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit',
	              className: 'btn-create-campaign',
	              onClick: this.handleSubmit },
	            'CONFIRM PAYMENT ',
	            _react2.default.createElement('img', { src: _download_green_arrow2.default })
	          ),
	          this.state.response && _react2.default.createElement(_reactJsonView2.default, { src: this.state.response }),
	          this.state.response && _react2.default.createElement(_reactJsonView2.default, { src: this.state.postData })
	        )
	      );
	    }
	  }]);
	
	  return CheckoutForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(CheckoutForm);

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .btn {\n        display: block;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        padding: 1rem 2rem;\n        text-transform: uppercase;\n        font-size: 0.8rem;\n        background: #1695A3;\n        color: white;\n        border: none;\n        border-radius: 3px;\n        margin: 0.5rem 0;\n    }\n    .btn-create-campaign {\n        margin-top: 86px;\n        max-width: 270px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60, 211, 207, 1);\n\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n\n        img {\n            height: 18px;\n            transform: rotate(90deg) translateY(-14px);\n            filter: brightness(0) invert(1);\n        }\n    }\n\n    .visa, .master, .ae, .apple-pay, .android-pay { margin-right: 21px; width: 65px; height: 65px; }\n    .master {       }\n    .ae {           }\n    .apple-pay {    }\n    .android-pay {  }\n\n    h2 + * * {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(35, 31, 32, 1);\n        letter-spacing: 0.01em;\n    }\n'], ['\n    .btn {\n        display: block;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        padding: 1rem 2rem;\n        text-transform: uppercase;\n        font-size: 0.8rem;\n        background: #1695A3;\n        color: white;\n        border: none;\n        border-radius: 3px;\n        margin: 0.5rem 0;\n    }\n    .btn-create-campaign {\n        margin-top: 86px;\n        max-width: 270px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60, 211, 207, 1);\n\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n\n        img {\n            height: 18px;\n            transform: rotate(90deg) translateY(-14px);\n            filter: brightness(0) invert(1);\n        }\n    }\n\n    .visa, .master, .ae, .apple-pay, .android-pay { margin-right: 21px; width: 65px; height: 65px; }\n    .master {       }\n    .ae {           }\n    .apple-pay {    }\n    .android-pay {  }\n\n    h2 + * * {\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(35, 31, 32, 1);\n        letter-spacing: 0.01em;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SplitFormWrapper = _styledComponents2.default.div(_templateObject);
	
	// export default WithDirection(OrderSummaryWrapper);
	exports.default = SplitFormWrapper;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(1694);
	
	var _tooltip = __webpack_require__(277);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import ToolTipIcon from '../../../image/tooltip.png';
	
	
	var SaleWidget = function (_Component) {
	  _inherits(SaleWidget, _Component);
	
	  function SaleWidget() {
	    _classCallCheck(this, SaleWidget);
	
	    return _possibleConstructorReturn(this, (SaleWidget.__proto__ || Object.getPrototypeOf(SaleWidget)).apply(this, arguments));
	  }
	
	  _createClass(SaleWidget, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          fontColor = _props.fontColor,
	          label = _props.label,
	          price = _props.price,
	          details = _props.details,
	          top = _props.top,
	          tooltip = _props.tooltip,
	          tooltipTitle = _props.tooltipTitle,
	          _props$tooltipPlaceme = _props.tooltipPlacement,
	          tooltipPlacement = _props$tooltipPlaceme === undefined ? 'top' : _props$tooltipPlaceme;
	
	
	      var textColor = {
	        color: fontColor
	      };
	
	      return _react2.default.createElement(
	        _style.SaleWidgetWrapper,
	        { className: 'isoSaleWidget', top: top },
	        _react2.default.createElement('div', { className: 'top' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'wrapper' },
	          _react2.default.createElement(
	            'span',
	            { className: 'isoSalePrice', style: textColor },
	            price
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'isoSaleDetails' },
	            details,
	            _react2.default.createElement(
	              _tooltip2.default,
	              { placement: tooltipPlacement, title: tooltipTitle },
	              tooltip
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return SaleWidget;
	}(_react.Component);
	
	exports.default = SaleWidget;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SaleWidgetWrapper = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  overflow: hidden;\n  border-top-color: coral;\n  // border: 1px solid ', ';\n  .wrapper{\n    padding: 30px;\n  }\n  .top{\n    position: absolute;\n    width:100%;\n    height: 4px;\n    background-color: ', ';\n  }\n  .isoSaleLabel {\n   \n    font-weight: 700;\n    line-height: 1.2;\n    text-transform: uppercase;\n    color: ', ';\n    margin: 0 0 20px;\n  }\n\n  .isoSalePrice {\n    // font-family: \'Roboto\';\n    font-size: 50px;\n    font-weight: 300;\n    line-height: 1.2;\n    margin: 0 0 20px;\n  }\n\n  .isoSaleDetails {\n    font-family: \'Roboto\', sans-serif;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: ', ';\n    margin: 0;\n  }\n'], ['\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  overflow: hidden;\n  border-top-color: coral;\n  // border: 1px solid ', ';\n  .wrapper{\n    padding: 30px;\n  }\n  .top{\n    position: absolute;\n    width:100%;\n    height: 4px;\n    background-color: ', ';\n  }\n  .isoSaleLabel {\n   \n    font-weight: 700;\n    line-height: 1.2;\n    text-transform: uppercase;\n    color: ', ';\n    margin: 0 0 20px;\n  }\n\n  .isoSalePrice {\n    // font-family: \'Roboto\';\n    font-size: 50px;\n    font-weight: 300;\n    line-height: 1.2;\n    margin: 0 0 20px;\n  }\n\n  .isoSaleDetails {\n    font-family: \'Roboto\', sans-serif;\n    font-size: 13px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: ', ';\n    margin: 0;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SaleWidgetWrapper = _styledComponents2.default.div(_templateObject, (0, _styledTheme.palette)('border', 2), function (props) {
	  return props.top ? props.top : '#725CA4';
	}, (0, _styledTheme.palette)('text', 0), (0, _styledTheme.palette)('text', 2));
	
	exports.SaleWidgetWrapper = SaleWidgetWrapper;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(396);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsoWidgetBox = function (_Component) {
	  _inherits(IsoWidgetBox, _Component);
	
	  function IsoWidgetBox() {
	    _classCallCheck(this, IsoWidgetBox);
	
	    return _possibleConstructorReturn(this, (IsoWidgetBox.__proto__ || Object.getPrototypeOf(IsoWidgetBox)).apply(this, arguments));
	  }
	
	  _createClass(IsoWidgetBox, [{
	    key: 'render',
	    value: function render() {
	      var children = this.props.children;
	
	
	      var boxStyle = {
	        height: this.props.height,
	        padding: this.props.padding
	      };
	
	      return _react2.default.createElement(
	        _style.WidgetBox,
	        { className: 'isoWidgetBox', style: boxStyle },
	        children
	      );
	    }
	  }]);
	
	  return IsoWidgetBox;
	}(_react.Component);
	
	exports.default = IsoWidgetBox;

/***/ },
/* 1696 */
[3342, 396],
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _antd = __webpack_require__(43);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _contentHolder = __webpack_require__(215);
	
	var _contentHolder2 = _interopRequireDefault(_contentHolder);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _rcTabs = __webpack_require__(480);
	
	var _rcTabs2 = _interopRequireDefault(_rcTabs);
	
	var _TabContent = __webpack_require__(329);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _SwipeableInkTabBar = __webpack_require__(2603);
	
	var _SwipeableInkTabBar2 = _interopRequireDefault(_SwipeableInkTabBar);
	
	__webpack_require__(429);
	
	var _redux = __webpack_require__(56);
	
	var _style = __webpack_require__(748);
	
	var _widgetsWrapper = __webpack_require__(1698);
	
	var _widgetsWrapper2 = _interopRequireDefault(_widgetsWrapper);
	
	var _MainButton = __webpack_require__(1616);
	
	var _MainButton2 = _interopRequireDefault(_MainButton);
	
	var _immutable = __webpack_require__(499);
	
	var _search = __webpack_require__(578);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _reactFlagsSelect = __webpack_require__(196);
	
	var _reactFlagsSelect2 = _interopRequireDefault(_reactFlagsSelect);
	
	__webpack_require__(185);
	
	var _reactSelect = __webpack_require__(514);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	__webpack_require__(430);
	
	var _AdPreview = __webpack_require__(391);
	
	var _AdPreview2 = _interopRequireDefault(_AdPreview);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _index = __webpack_require__(214);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Logo = __webpack_require__(173);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _index3 = __webpack_require__(1611);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _FillRow = __webpack_require__(737);
	
	var _FillRow2 = _interopRequireDefault(_FillRow);
	
	var _index5 = __webpack_require__(275);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	// const { login, googleLogin } = authAction;
	
	var GravatarOption = (0, _createReactClass2.default)({
	  propTypes: {
	    children: _propTypes2.default.node,
	    className: _propTypes2.default.string,
	    isDisabled: _propTypes2.default.bool,
	    isFocused: _propTypes2.default.bool,
	    isSelected: _propTypes2.default.bool,
	    onFocus: _propTypes2.default.func,
	    onSelect: _propTypes2.default.func,
	    option: _propTypes2.default.object.isRequired
	  },
	  handleMouseDown: function handleMouseDown(event) {
	    event.preventDefault();
	    event.stopPropagation();
	    this.props.onSelect(this.props.option, event);
	  },
	  handleMouseEnter: function handleMouseEnter(event) {
	    this.props.onFocus(this.props.option, event);
	  },
	  handleMouseMove: function handleMouseMove(event) {
	    if (this.props.isFocused) return;
	    this.props.onFocus(this.props.option, event);
	  },
	  render: function render() {
	    var gravatarStyle = {
	      borderRadius: 3,
	      display: 'inline-block',
	      marginRight: 10,
	      position: 'relative',
	      top: -2,
	      verticalAlign: 'middle',
	      width: '40px',
	      height: '40px'
	    };
	    var logoStyle = {
	      width: '56px',
	      height: '56px'
	    };
	    console.log(this.props.option);
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.className,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseMove: this.handleMouseMove,
	        title: this.props.option.title },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement('img', {
	          style: gravatarStyle,
	          src: this.props.option.options.artworkUrl60
	        })
	      ),
	      this.props.children
	    );
	  }
	});
	
	var Home = function (_Component) {
	  _inherits(Home, _Component);
	
	  function Home() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Home);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Home.__proto__ || Object.getPrototypeOf(Home)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      updated: false,
	      campaignList: null,
	      redirectToReferrer: false,
	      optionList: null
	    }, _this.handleGoogleAuth = function (e) {
	      e.preventDefault();
	      console.log(' handleGoogleAuth');
	      _this.props.auth.googleLogin();
	    }, _this.onChange = function (app) {
	      _this.setState({
	        value: app
	      });
	
	      var _this$state = _this.state,
	          optionList = _this$state.optionList,
	          input = _this$state.input;
	
	      if (optionList && optionList.length > 1) {
	        _this.props.appSelected(app.value, optionList[1].value);
	      } else if (optionList && optionList.length === 1) {
	        _this.props.appSelected(app.value, app.value);
	      } else {
	        _this.props.appSelected(app.value, null);
	      }
	      _this.props.searchTermUpdated(input);
	    }, _this.getApps = function (input) {
	      if (!input) {
	        return Promise.resolve({ options: [] });
	      }
	      _this.setState({ input: input });
	
	      return _axios2.default.get('https://itunes.apple.com/search', { params: { term: input, country: 'us', entity: 'software' } }).then(function (response) {
	        if (response.data != undefined) {
	          var itemData = response.data.results;
	          var items = itemData.map(function (item, i) {
	            return {
	              key: i,
	              label: item.trackCensoredName,
	              id: i,
	              value: {
	                adamId: item.artistId,
	                artworkUrl60: item.artworkUrl60,
	                artworkUrl100: item.artworkUrl100,
	                name: item.trackCensoredName,
	                trackCensoredName: item.trackCensoredName,
	                sellerName: item.sellerName,
	                screenshotUrls: item.screenshotUrls
	              },
	              options: item
	            };
	          });
	          console.log(' items ', items);
	
	          _this.setState({ optionList: items });
	          return { options: items };
	        }
	      }).catch(function (error) {
	        console.log(error.message);
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Home, [{
	    key: 'handleSignUpSubmit',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(signUpData) {
	        var request, signupResponse, loginResponse, errorResponse;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('singupdata: ', signUpData, ("fake"));
	
	                if (false) {
	                  _context.next = 6;
	                  break;
	                }
	
	                console.log('fakeLogin: ');
	
	                this.props.auth.fakeLogin();
	                _context.next = 28;
	                break;
	
	              case 6:
	                if (!(signUpData.password !== signUpData.confirmPassword)) {
	                  _context.next = 10;
	                  break;
	                }
	
	                this.setState({ signupResponse: {
	                    message: {
	                      error: "invalid_input",
	                      error_description: "Password and Confirm Password do not match."
	                    }
	                  } });
	                _context.next = 28;
	                break;
	
	              case 10:
	                _context.prev = 10;
	
	                this.setState({ signupResponse: null });
	                request = {
	                  email: signUpData.emailAddress,
	                  firstname: signUpData.firstName,
	                  lastname: signUpData.lastName,
	                  password: signUpData.password
	                };
	                _context.next = 15;
	                return _axios2.default.post(_server2.default + '/user/create/', request, {});
	
	              case 15:
	                signupResponse = _context.sent;
	
	                this.setState({ signupResponse: signupResponse });
	                console.log('signupResponse', signupResponse);
	                _context.next = 20;
	                return this.props.auth.passwordLogin(signUpData.emailAddress, signUpData.password);
	
	              case 20:
	                loginResponse = _context.sent;
	                _context.next = 28;
	                break;
	
	              case 23:
	                _context.prev = 23;
	                _context.t0 = _context['catch'](10);
	                errorResponse = _context.t0.response.data.error;
	
	                console.log('errorResponse', errorResponse);
	
	                this.setState({ signupResponse: {
	                    message: {
	                      error: errorResponse.code,
	                      error_description: errorResponse.message
	                    }
	                  } });
	
	              case 28:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[10, 23]]);
	      }));
	
	      function handleSignUpSubmit(_x) {
	        return _ref2.apply(this, arguments);
	      }
	
	      return handleSignUpSubmit;
	    }()
	  }, {
	    key: 'handleSignInSubmit',
	    value: function () {
	      var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(signInData) {
	        var loginResponse;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                console.log('singindata: ', signInData);
	                // let result = this.props.auth.passwordLogin('dsfasdf', 'dasfaf');
	                console.log('signin');
	
	                if (false) {
	                  _context2.next = 6;
	                  break;
	                }
	
	                this.props.auth.fakeLogin();
	                _context2.next = 18;
	                break;
	
	              case 6:
	                _context2.prev = 6;
	
	                this.setState({ loginResponse: null });
	                _context2.next = 10;
	                return this.props.auth.passwordLogin(signInData.emailAddress, signInData.password);
	
	              case 10:
	                loginResponse = _context2.sent;
	
	                this.setState({ loginResponse: loginResponse });
	                console.log('loginResponse', loginResponse);
	                _context2.next = 18;
	                break;
	
	              case 15:
	                _context2.prev = 15;
	                _context2.t0 = _context2['catch'](6);
	
	                console.log(_context2.t0);
	
	              case 18:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this, [[6, 15]]);
	      }));
	
	      function handleSignInSubmit(_x2) {
	        return _ref3.apply(this, arguments);
	      }
	
	      return handleSignInSubmit;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	
	      if (!prevState.loginResponse && this.state.loginResponse) {
	
	        console.log(' loginResponsechanged');
	      }
	    }
	  }, {
	    key: 'login',
	    value: function login() {
	      console.log('login');
	      this.props.auth.login();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      //https://itunes.apple.com/lookup?id=1155618808
	
	      var _props = this.props,
	          searchTerm = _props.searchTerm,
	          currentApp = _props.currentApp,
	          secondApp = _props.secondApp;
	      // const { isAuthenticated, login } = auth;
	
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	
	
	      return _react2.default.createElement(
	        _style.HomeWrapper,
	        null,
	        _react2.default.createElement(
	          _index2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(_Logo2.default, { isClickable: true, history: this.props.history }),
	            _react2.default.createElement(_FillRow2.default, { className: 'hidden-md hidden-lg' }),
	            currentApp && _react2.default.createElement(
	              _index4.default,
	              {
	                url: currentApp.artworkUrl100,
	                appName: currentApp.trackCensoredName
	              },
	              currentApp.sellerName
	            ),
	            _react2.default.createElement(_FillRow2.default, { className: 'hidden-xs' }),
	            _react2.default.createElement(_index6.default, {
	              goTo: function goTo(route) {
	                return _this2.props.history.push('' + route);
	              },
	              selectClassName: 'two-lines-result',
	              value: this.state.value,
	              onChange: this.onChange,
	              backspaceRemoves: this.state.backspaceRemoves,
	              placeholder: '\u641C\u7D22\u4F60\u7684\u5E94\u7528\u540D\u79F0\u6216App ID'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'mainAppScreen' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              _antd.Row,
	              { style: rowStyle, gutter: 0, justify: 'start' },
	              _react2.default.createElement(
	                _antd.Col,
	                { md: 12, sm: 12, xs: 24, style: colStyle },
	                _react2.default.createElement(
	                  _contentHolder2.default,
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'startWrapper' },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'firstLine' },
	                      '\u7ACB\u5373\u958B\u59CB\uFF0C'
	                    ),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'secondLine' },
	                      '\u628A\u4F60\u7684\u5E94\u7528\u5C55\u793A\u5728\u5BF9\u7684\u7528\u6237\u773C\u524D\u5427\uFF01'
	                    ),
	                    _react2.default.createElement(
	                      _widgetsWrapper2.default,
	                      null,
	                      _react2.default.createElement(
	                        _rcTabs2.default,
	                        {
	                          defaultActiveKey: '1',
	                          renderTabBar: function renderTabBar() {
	                            return _react2.default.createElement(_SwipeableInkTabBar2.default, {
	                              pageSize: 2,
	                              speed: 5
	                            });
	                          },
	                          renderTabContent: function renderTabContent() {
	                            return _react2.default.createElement(_TabContent2.default, null);
	                          }
	                        },
	                        _react2.default.createElement(
	                          _rcTabs.TabPane,
	                          { tab: '\u6CE8\u518C', key: '1' },
	                          _react2.default.createElement(
	                            _immutable.Form,
	                            {
	                              model: 'deep.auth0SignUp',
	                              onSubmit: function onSubmit(signUp) {
	                                return _this2.handleSignUpSubmit(signUp);
	                              }
	                            },
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            false && _react2.default.createElement(
	                              _MainButton2.default,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { onClick: function onClick(e) {
	                                    return _this2.handleGoogleAuth(e);
	                                  } },
	                                "SIGN UP WITH GOOGLE"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.emailAddress' },
	                                '\u90AE\u7BB1'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.emailAddress',
	                                  id: 'deep.auth0SignUp.emailAddress',
	                                  type: 'text' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.firstName' },
	                                '\u6635\u79F0'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.firstName',
	                                  id: 'deep.auth0SignUp.firstName',
	                                  type: 'text' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper', hidden: true },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.lastName' },
	                                'Last Name'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.lastName',
	                                  id: 'deep.auth0SignUp.lastName',
	                                  type: 'text',
	                                  value: '' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.password' },
	                                '\u5BC6\u7801'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.password',
	                                  id: 'deep.auth0SignUp.password',
	                                  type: 'password' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.confirmPassword' },
	                                '\u786E\u8BA4\u5BC6\u7801'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.confirmPassword',
	                                  id: 'deep.auth0SignUp.confirmPassword',
	                                  type: 'password' })
	                              )
	                            ),
	                            this.state.signupResponse && this.state.signupResponse.message && _react2.default.createElement(
	                              'div',
	                              { className: 'errorMsg' },
	                              this.state.signupResponse.message.error_description
	                            ),
	                            _react2.default.createElement(
	                              _MainButton2.default,
	                              { type: 'submit' },
	                              " 注册"
	                            )
	                          )
	                        ),
	                        _react2.default.createElement(
	                          _rcTabs.TabPane,
	                          { tab: '\u767B\u5F55', key: '2' },
	                          _react2.default.createElement(
	                            _immutable.Form,
	                            {
	                              model: 'deep.auth0SignUp',
	                              onSubmit: function onSubmit(signUp) {
	                                return _this2.handleSignInSubmit(signUp);
	                              }
	
	                            },
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement('br', null),
	                            false && _react2.default.createElement(
	                              _MainButton2.default,
	                              null,
	                              _react2.default.createElement(
	                                'div',
	                                { onClick: this.handleGoogleAuth.bind(this) },
	                                "LOGIN WITH GOOGLE"
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.emailAddress' },
	                                '\u90AE\u7BB1'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.emailAddress',
	                                  id: 'deep.auth0SignUp.emailAddress',
	                                  type: 'text' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              'div',
	                              { className: 'inputWrapper' },
	                              _react2.default.createElement(
	                                'label',
	                                { htmlFor: 'deep.auth0SignUp.password' },
	                                '\u5BC6\u7801'
	                              ),
	                              _react2.default.createElement(
	                                'div',
	                                { className: 'FormTextInput' },
	                                _react2.default.createElement(_immutable.Control.text, {
	                                  model: 'deep.auth0SignUp.password',
	                                  id: 'deep.auth0SignUp.password',
	                                  type: 'password' })
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _MainButton2.default,
	                              { type: 'submit' },
	                              "登录"
	                            ),
	                            this.state.loginResponse && this.state.loginResponse.message && _react2.default.createElement(
	                              'div',
	                              { className: 'errorMsg' },
	                              this.state.loginResponse.message.error_description
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              currentApp && secondApp && _react2.default.createElement(
	                _antd.Col,
	                { md: 12, sm: 12, xs: 24, style: colStyle },
	                _react2.default.createElement(
	                  _contentHolder2.default,
	                  null,
	                  _react2.default.createElement(_AdPreview2.default, {
	                    currentApp: currentApp,
	                    secondApp: secondApp,
	                    searchTerm: searchTerm
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Home;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setApp: function setApp(app) {
	      return dispatch(appSelected(app));
	    },
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	
	  };
	}
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    auth0SignUp: state.get('deep').auth0SignUp,
	    auth0SignIn: state.get('deep').auth0SignIn,
	    isLoggedIn: false, //state.Auth.get('idToken') !== null ? true : false,
	    currentApp: state.getIn(['ItunesSearch', 'currentApp']),
	    secondApp: state.getIn(['ItunesSearch', 'secondApp']),
	    searchTerm: state.getIn(['ItunesSearch', 'searchTerm'])
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Home);

/***/ },
/* 1698 */
[3342, 748],
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _reactRedux = __webpack_require__(40);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _reactHelmet = __webpack_require__(1243);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _style = __webpack_require__(1700);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _actions = __webpack_require__(216);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _redux = __webpack_require__(56);
	
	var _lodash = __webpack_require__(129);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _index = __webpack_require__(214);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Logo = __webpack_require__(173);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Menu = __webpack_require__(213);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index3 = __webpack_require__(738);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(212);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _index7 = __webpack_require__(275);
	
	var _index8 = _interopRequireDefault(_index7);
	
	__webpack_require__(941);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// -- React Libraries
	
	
	// -- Libraries
	
	
	// Components
	
	
	// Styles
	
	
	var Headline = (0, _createReactClass2.default)({
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'headline' },
	      this.props.children
	    );
	  }
	});
	var Secondline = (0, _createReactClass2.default)({
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.children
	    );
	  }
	});
	
	var Landing = function (_Component) {
	  _inherits(Landing, _Component);
	
	  function Landing() {
	    _classCallCheck(this, Landing);
	
	    var _this = _possibleConstructorReturn(this, (Landing.__proto__ || Object.getPrototypeOf(Landing)).call(this));
	
	    _this.state = {
	      redirectToReferrer: false,
	      optionList: null,
	      hasCampaigns: false
	    };
	    return _this;
	  }
	
	  _createClass(Landing, [{
	    key: 'login',
	    value: function login() {
	      console.log('login');
	      this.props.auth.login();
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      console.log('logout');
	      this.props.auth.logout();
	    }
	  }, {
	    key: 'goTo',
	    value: function goTo(route) {
	      this.props.history.push('' + route);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var getAccessToken, headers, response, campaignList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                console.log('didmount');
	
	                if (true) {
	                  _context.next = 15;
	                  break;
	                }
	
	                getAccessToken = this.props.auth.getAccessToken;
	                headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	                _context.prev = 4;
	                _context.next = 7;
	                return _axios2.default.get(_server2.default + '/user/campaigns', { headers: headers });
	
	              case 7:
	                response = _context.sent;
	                campaignList = response.data;
	
	                if (campaignList.length > 0) {
	                  this.setState({
	                    hasCampaigns: true
	                  });
	                }
	                _context.next = 15;
	                break;
	
	              case 12:
	                _context.prev = 12;
	                _context.t0 = _context['catch'](4);
	
	                console.log('[getAccessToken] ', _context.t0); // error is not defined
	
	              case 15:
	
	                this.props.appSelected(null, null);
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[4, 12]]);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.isLoggedIn !== nextProps.isLoggedIn && nextProps.isLoggedIn === true) {
	        this.setState({ redirectToReferrer: true });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var from = { pathname: '/dashboard' };
	      var redirectToReferrer = this.state.redirectToReferrer;
	      var isLoggedIn = this.props.isLoggedIn;
	      var isAuthenticated = this.props.auth.isAuthenticated;
	
	
	      var title = "Project X";
	      var description = "Best platform for Apple Search Ads";
	
	      if (("fake") === 'fake' && isAuthenticated()) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/campaign' } });
	      } else if (isAuthenticated() && this.state.hasCampaigns) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/campaign' } });
	      }
	      if (redirectToReferrer) {
	        return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: '/dashboard' } });
	      }
	
	      return _react2.default.createElement(
	        _style2.default,
	        { className: 'page-wrapper', style: { backgroundColor: "rgba(255, 255, 255, 1)" } },
	        _react2.default.createElement(
	          _reactHelmet2.default,
	          {
	            title: title,
	            meta: [{ 'name': 'description', 'content': description }, { 'property': 'og:type', 'content': 'article' }, { 'property': 'og:title', 'content': title }, { 'property': 'og:description', 'content': description }],
	            description: 'Best platform for Apple Search Ads' },
	          _react2.default.createElement('meta', { charSet: 'utf-8' }),
	          _react2.default.createElement(
	            'title',
	            null,
	            ' ',
	            title,
	            ' '
	          ),
	          _react2.default.createElement('link', { rel: 'canonical', href: 'https://project-x.gogochart.com/' }),
	          _react2.default.createElement('meta', { name: 'description', content: description })
	        ),
	        _react2.default.createElement(
	          _index2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(_Logo2.default, { isClickable: false, history: this.props.history }),
	            this.props.auth.isAuthenticated() && _react2.default.createElement(_Menu2.default, { history: this.props.history, auth: this.props.auth }) || _react2.default.createElement(
	              _index4.default,
	              { history: this.props.history },
	              '\u6CE8\u518C/\u767B\u5F55'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              Headline,
	              null,
	              '\u7ACB\u9A6C\u83B7\u5F97\u771F\u5B9E\u7528\u6237\uFF01'
	            ),
	            _react2.default.createElement(
	              Secondline,
	              null,
	              '65%\u7684\u4E0B\u8F7D\u76F4\u63A5\u6765\u81EAAPP\u5546\u57CE'
	            ),
	            _react2.default.createElement(
	              Secondline,
	              null,
	              '\u73B0\u5728\u5F00\u59CB\u83B7\u53D6\u4F18\u8D28\u7528\u6237\uFF01'
	            )
	          ),
	          _react2.default.createElement(_index8.default, {
	            placeholder: '\u641C\u7D22\u4F60\u7684\u5E94\u7528\u540D\u79F0\u6216App ID',
	            auth: this.props.auth,
	            goTo: this.goTo.bind(this) })
	        ),
	        _react2.default.createElement(_index6.default, null)
	      );
	    }
	  }]);
	
	  return Landing;
	}(_react.Component);
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {};
	};
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return {
	    isLoggedIn: state.getIn(['Auth', 'idToken']) !== null ? true : false,
	    countryCode: state.getIn(['ItunesSearch', 'countryCode']) && 'US'
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Landing);

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  // -- Zay modification\n  .headline {\n    margin: 0 48px;\n    line-height: 40px;\n    font-family: \'Montserrat\';\n    font-size: 24px;\n    color: rgba(64, 55, 57, 1);\n    text-align: center;\n    letter-spacing: 0.07em;\n\n    + :not(.headline) {  margin-top: 27px; }\n  }\n\n  .headline ~ * {\n    margin: 0 48px;\n    line-height: 30px;\n    font-family: \'Montserrat\';\n    font-size: 16px;\n    font-weight: 300;\n    color: rgba(64, 55, 57, 1);\n    text-align: center;\n    letter-spacing: 0.07em;\n  }\n\n  .search-app-bar { margin-top: 50px; }\n\n  .footer {\n    padding-bottom: 28px;\n    background-color: transparent;\n    color: rgba(151, 151, 151, 1);\n  }\n\n  @media screen and (max-width: 767px) {\n    .headline, .headline ~ * { margin: 0 14px; }\n    .search-app-bar { max-width: 95vw; }\n    .footer { padding-bottom: 42px; }\n  }\n'], ['\n  // -- Zay modification\n  .headline {\n    margin: 0 48px;\n    line-height: 40px;\n    font-family: \'Montserrat\';\n    font-size: 24px;\n    color: rgba(64, 55, 57, 1);\n    text-align: center;\n    letter-spacing: 0.07em;\n\n    + :not(.headline) {  margin-top: 27px; }\n  }\n\n  .headline ~ * {\n    margin: 0 48px;\n    line-height: 30px;\n    font-family: \'Montserrat\';\n    font-size: 16px;\n    font-weight: 300;\n    color: rgba(64, 55, 57, 1);\n    text-align: center;\n    letter-spacing: 0.07em;\n  }\n\n  .search-app-bar { margin-top: 50px; }\n\n  .footer {\n    padding-bottom: 28px;\n    background-color: transparent;\n    color: rgba(151, 151, 151, 1);\n  }\n\n  @media screen and (max-width: 767px) {\n    .headline, .headline ~ * { margin: 0 14px; }\n    .search-app-bar { max-width: 95vw; }\n    .footer { padding-bottom: 42px; }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var LandingStyleWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = (0, _withDirection2.default)(LandingStyleWrapper);

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _style = __webpack_require__(1702);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _actions = __webpack_require__(216);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _redux = __webpack_require__(56);
	
	var _antd = __webpack_require__(43);
	
	var _contentHolder = __webpack_require__(215);
	
	var _contentHolder2 = _interopRequireDefault(_contentHolder);
	
	var _dropdown = __webpack_require__(276);
	
	var _dropdown2 = _interopRequireDefault(_dropdown);
	
	var _formik = __webpack_require__(436);
	
	var _reactPhoneNumberInput = __webpack_require__(2783);
	
	var _reactPhoneNumberInput2 = _interopRequireDefault(_reactPhoneNumberInput);
	
	__webpack_require__(1995);
	
	__webpack_require__(1996);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	
	var MyAccount = function (_Component) {
	  _inherits(MyAccount, _Component);
	
	  function MyAccount(props) {
	    _classCallCheck(this, MyAccount);
	
	    var _this = _possibleConstructorReturn(this, (MyAccount.__proto__ || Object.getPrototypeOf(MyAccount)).call(this, props));
	
	    _this.state = {
	      primaryContactEditable: false,
	      changePassword: false,
	      profile: null
	    };
	
	    if (props && props.auth) props.auth.getProfile(function (err, profile) {
	      this.setState({ profile: profile });
	      console.log(this.state.profile);
	    }.bind(_this));
	
	    _this.onClickPrimaryContactEdit = _this.onClickPrimaryContactEdit.bind(_this);
	    _this.onClickChangePassword = _this.onClickChangePassword.bind(_this);
	    return _this;
	  }
	
	  _createClass(MyAccount, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      console.log(' componentWillUpdate');
	      //check difference
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      console.log(' componentWillReceiveProps');
	    }
	  }, {
	    key: 'createCampaignFake',
	    value: function createCampaignFake(campaign) {}
	  }, {
	    key: 'onClickPrimaryContactEdit',
	    value: function onClickPrimaryContactEdit() {
	      this.setState({
	        primaryContactEditable: !this.state.primaryContactEditable
	      });
	    }
	  }, {
	    key: 'onClickChangePassword',
	    value: function onClickChangePassword() {
	      this.setState({
	        changePassword: !this.state.changePassword
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      // console.log( this.props)
	      // const { appDetail } = this.state;
	      // const { searchTerm, campaign, currentApp, secondApp} = this.props;    
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	
	
	      return _react2.default.createElement(
	        _style2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'account-menu' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'account', className: 'active' },
	                '\u6211\u7684\u5E10\u6237'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'billing' },
	                '\u4ED8\u6B3E\u8D44\u6599'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u6211\u7684\u5E10\u6237\u8D44\u6599'
	              ),
	              this.state.changePassword ? null : _react2.default.createElement(
	                'a',
	                { href: 'javascript:void(0)', onClick: this.onClickChangePassword },
	                '\u66F4\u6539\u5BC6\u7801'
	              )
	            ),
	            _react2.default.createElement(_formik.Formik, {
	              initialValues: { password: '*********' },
	              validate: function validate(values) {},
	              onSubmit: function onSubmit(values) {
	                console.log('change password');
	                console.table(values);
	                _this2.setState({
	                  changePassword: false
	                });
	              },
	              render: function render(_ref) {
	                var handleSubmit = _ref.handleSubmit,
	                    handleChange = _ref.handleChange,
	                    handleBlur = _ref.handleBlur,
	                    setFieldValue = _ref.setFieldValue,
	                    values = _ref.values,
	                    errors = _ref.errors,
	                    dirty = _ref.dirty,
	                    touched = _ref.touched;
	
	                return _react2.default.createElement(
	                  'form',
	                  { onSubmit: handleSubmit },
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        'dt',
	                        null,
	                        '\u5E10\u53F7'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        'dd',
	                        null,
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'bill-attn-to' },
	                          _this2.state.profile && _this2.state.profile.email
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        'dt',
	                        null,
	                        '\u5BC6\u7801'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this2.state.changePassword ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this2.state.changePassword, type: 'password', name: 'password', value: values.password })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _this2.state.changePassword ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        'dt',
	                        null,
	                        '\u786E\u8BA4\u5BC6\u7801'
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this2.state.changePassword ? "noteditable" : "") },
	                            _react2.default.createElement('input', { type: 'password', name: 'confirmPassword' })
	                          )
	                        )
	                      )
	                    )
	                  ) : null,
	                  _this2.state.changePassword ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn-savechanges', type: 'submit' },
	                      '\u4FDD\u5B58'
	                    )
	                  ) : null
	                );
	              } }),
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u8054\u7EDC\u8D44\u8BAF'
	              ),
	              this.state.primaryContactEditable ? null : _react2.default.createElement(
	                'a',
	                { href: 'javascript:void(0)', onClick: this.onClickPrimaryContactEdit },
	                '\u4FEE\u6539'
	              )
	            ),
	            _react2.default.createElement(_formik.Formik, {
	              initialValues: {
	                accountId: this.state.profile && this.state.profile.email,
	                password: '***********',
	                firstName: '',
	                lastName: '',
	                countryCode: '+852',
	                phone: '+852 ',
	                email: this.state.profile && this.state.profile.email
	              },
	              validate: function validate(values) {},
	              onSubmit: function onSubmit(values) {
	                console.log('edit primary contact');
	                console.table(values);
	                _this2.setState({
	                  primaryContactEditable: false
	                });
	              },
	              render: function render(_ref2) {
	                var handleSubmit = _ref2.handleSubmit,
	                    handleChange = _ref2.handleChange,
	                    handleBlur = _ref2.handleBlur,
	                    setFieldValue = _ref2.setFieldValue,
	                    values = _ref2.values,
	                    errors = _ref2.errors,
	                    dirty = _ref2.dirty,
	                    touched = _ref2.touched;
	
	                return _react2.default.createElement(
	                  'form',
	                  { onSubmit: handleSubmit },
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'firstName' },
	                            '\u6635\u79F0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this2.state.primaryContactEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this2.state.primaryContactEditable, type: 'text', name: 'firstName', value: _this2.state.profile && _this2.state.profile.nickname, onChange: handleChange })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper', hidden: true },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'lastName' },
	                            'Last Name'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this2.state.primaryContactEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this2.state.primaryContactEditable, type: 'text', name: 'lastName', value: values.lastName, onChange: handleChange })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'phone' },
	                            '\u8054\u7EDC\u7535\u8BDD'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this2.state.primaryContactEditable ? "noteditable" : "") },
	                            _react2.default.createElement(_reactPhoneNumberInput2.default, {
	                              country: 'HK',
	                              disabled: !_this2.state.primaryContactEditable,
	                              value: values.phone,
	                              onChange: function onChange(value) {
	                                return setFieldValue('phone', value);
	                              } })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'email' },
	                            '\u90AE\u7BB1'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this2.state.primaryContactEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this2.state.primaryContactEditable, type: 'email', name: 'email', value: _this2.state.profile && _this2.state.profile.email, onChange: handleChange })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _this2.state.primaryContactEditable ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn-savechanges', type: 'submit' },
	                      '\u4FDD\u5B58'
	                    )
	                  ) : null
	                );
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyAccount;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setApp: function setApp(app) {
	      return dispatch(appSelected(app));
	    },
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	
	  };
	}
	function mapStateToProps(state) {
	  var campaign = state.get('campaign');
	  return {
	    search: state.get('search'),
	    campaign: campaign,
	    currentApp: state.getIn(['App', 'currentApp']),
	    secondApp: state.getIn(['App', 'secondApp']),
	    searchTerm: state.getIn(['App', 'searchTerm'])
	
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MyAccount);

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .account-menu {\n        position: relative;\n        margin: 0; margin-top: -1px;\n        padding: 13px 0 36px 0;\n        background-color: rgba(35, 31, 32, 1);\n        line-height: 17px;\n\n        ul {\n            margin: 0 auto;\n            display: flex;\n            justify-content: space-around;\n            width: 30%;\n            min-width: 240px;\n            max-width: 320px;\n\n            li { list-style-type: none; display: inline-block; text-align: right; }\n            li:not(:first-child) { text-align: left; }\n        }\n        a {\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            text-align: center;\n            letter-spacing: 0.08em;\n            text-transform: uppercase;\n        }\n        a.active { color: rgba(12, 183, 148, 1); }\n        // -- .account-menu\n    }    \n    .account-menu:after {\n        position: absolute;\n        right: 0; bottom: -3px; left: 0;\n        display: inline-block;\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12,183,148,1);\n        z-index: 1;\n    }\n\n    @media screen and (max-width: 767px) {\n        .account-menu {\n            ul {\n                width: 70%;\n                max-width: 300px;\n\n                li, li:not(:first-child) { width: 50%; text-align: center; }\n                a { line-height: 20px; letter-spacing: 0.06em; }\n            }\n        }\n    }\n\n    .main {\n        margin: 0;\n        padding: 0; padding-top: 44px; padding-bottom: 70px;\n        background-color: rgba(243, 243, 243, 1);\n\n        .info {\n            margin: 0 auto;\n            padding: 0;\n            width: 100%;\n            max-width: 698px;\n            background-color: rgba(249, 249, 249, 1);\n\n            > * { padding-right: 48px; padding-left: 64px ;}\n            h2 {\n                display: flex;\n                justify-content: space-between;\n                margin-top: 22px; margin-bottom: 21px;\n                font-weight: 700;\n                color: rgba(64, 55, 57, 1);\n                letter-spacing: 0.08em;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n                text-transform: uppercase;\n                \n                > span { font-family: \'Montserrat\'; font-size: 14px; line-height:60px;}\n                a, a span {\n                    font-family: \'Montserrat\';\n                    font-size: 15px;\n                    color: rgba(12, 183, 148, 1);\n                    text-align: right;\n                    letter-spacing: 0.01em;\n                    text-transform: capitalize;\n                    line-height:60px;\n                }\n                // -- h2\n            }\n            // -- .info\n        }\n        // -- .main\n    }\n    \n    @media screen and (max-width: 767px) {\n        .main {\n            padding-right: 16px; padding-left: 16px;\n            .info {\n                > * { padding-right: 22px; padding-left: 21px ;}\n\n                .desktop { display: none; }\n            }\n        }\n    }\n\n    .isoExampleWrapper {\n        margin-top: 0;\n        input { background-color: transparent; width: 100%;}\n        input[type=password], input[type=text],input[type=tel],input[type=email],input[type=number] {\n            &:focus, &:active {\n                outline-width: 0;\n            }\n        }\n        input[disabled] {\n            border-color: rgba(216,216,216,0.6);\n            color: rgba(0,0,0,0.5);\n            background-color: transparent;\n        }\n    }\n\n    .inputWrapper {\n        padding: 0;\n        text-align: left;\n        \n        label {\n            margin-bottom: 8px;\n            display: block;\n            width: auto;\n\n            span {\n                display: inline-block;\n                margin-left: 4px;\n                border: 1px solid rgba(147, 147, 147, 1);\n                border-radius: 100%;\n                width: 14px; height: 14px;\n                line-height: 14px;\n                font-family: \'Montserrat\';\n                font-size: .7em;\n                color: rgba(147, 147, 147, 1);\n            }\n        }\n\n        .FormTextInput {\n            margin-left: -7px;\n            padding-right: 4px;\n\n            > :first-child:not(.react-phone-number-input*) { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }\n        }\n    }\n\n    .inputWrapper {\n        padding-left: 10px;\n        // padding-right: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            width: 242px;\n            max-width: 242px;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            display: -webkit-inline-box;\n    \n            div:not(.react-phone-number-input*) {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n    \n            input[type=password], input[type=number], input[type=text], input[type=email], input[type=tel] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n            }\n            \n            input[type=tel] {\n                border-left: 1px solid rgba(151, 151, 151, 1);\n                width: 0px;\n            }\n\n            &.noteditable {\n                border-color: transparent;\n            }\n        }\n    \n        label {\n            width: 242px;\n            max-width: 242px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .btn-savechanges {\n        margin: 32px 0;\n        max-width: 242px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60,211,207,1);\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255,255,255,1);\n        text-align: center;\n        -webkit-letter-spacing: 0.01em;\n        -moz-letter-spacing: 0.01em;\n        -ms-letter-spacing: 0.01em;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n    }\n\n    .react-phone-number-input__icon {\n        img {\n            vertical-align: initial;\n        }\n    }\n'], ['\n    .account-menu {\n        position: relative;\n        margin: 0; margin-top: -1px;\n        padding: 13px 0 36px 0;\n        background-color: rgba(35, 31, 32, 1);\n        line-height: 17px;\n\n        ul {\n            margin: 0 auto;\n            display: flex;\n            justify-content: space-around;\n            width: 30%;\n            min-width: 240px;\n            max-width: 320px;\n\n            li { list-style-type: none; display: inline-block; text-align: right; }\n            li:not(:first-child) { text-align: left; }\n        }\n        a {\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            text-align: center;\n            letter-spacing: 0.08em;\n            text-transform: uppercase;\n        }\n        a.active { color: rgba(12, 183, 148, 1); }\n        // -- .account-menu\n    }    \n    .account-menu:after {\n        position: absolute;\n        right: 0; bottom: -3px; left: 0;\n        display: inline-block;\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12,183,148,1);\n        z-index: 1;\n    }\n\n    @media screen and (max-width: 767px) {\n        .account-menu {\n            ul {\n                width: 70%;\n                max-width: 300px;\n\n                li, li:not(:first-child) { width: 50%; text-align: center; }\n                a { line-height: 20px; letter-spacing: 0.06em; }\n            }\n        }\n    }\n\n    .main {\n        margin: 0;\n        padding: 0; padding-top: 44px; padding-bottom: 70px;\n        background-color: rgba(243, 243, 243, 1);\n\n        .info {\n            margin: 0 auto;\n            padding: 0;\n            width: 100%;\n            max-width: 698px;\n            background-color: rgba(249, 249, 249, 1);\n\n            > * { padding-right: 48px; padding-left: 64px ;}\n            h2 {\n                display: flex;\n                justify-content: space-between;\n                margin-top: 22px; margin-bottom: 21px;\n                font-weight: 700;\n                color: rgba(64, 55, 57, 1);\n                letter-spacing: 0.08em;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n                text-transform: uppercase;\n                \n                > span { font-family: \'Montserrat\'; font-size: 14px; line-height:60px;}\n                a, a span {\n                    font-family: \'Montserrat\';\n                    font-size: 15px;\n                    color: rgba(12, 183, 148, 1);\n                    text-align: right;\n                    letter-spacing: 0.01em;\n                    text-transform: capitalize;\n                    line-height:60px;\n                }\n                // -- h2\n            }\n            // -- .info\n        }\n        // -- .main\n    }\n    \n    @media screen and (max-width: 767px) {\n        .main {\n            padding-right: 16px; padding-left: 16px;\n            .info {\n                > * { padding-right: 22px; padding-left: 21px ;}\n\n                .desktop { display: none; }\n            }\n        }\n    }\n\n    .isoExampleWrapper {\n        margin-top: 0;\n        input { background-color: transparent; width: 100%;}\n        input[type=password], input[type=text],input[type=tel],input[type=email],input[type=number] {\n            &:focus, &:active {\n                outline-width: 0;\n            }\n        }\n        input[disabled] {\n            border-color: rgba(216,216,216,0.6);\n            color: rgba(0,0,0,0.5);\n            background-color: transparent;\n        }\n    }\n\n    .inputWrapper {\n        padding: 0;\n        text-align: left;\n        \n        label {\n            margin-bottom: 8px;\n            display: block;\n            width: auto;\n\n            span {\n                display: inline-block;\n                margin-left: 4px;\n                border: 1px solid rgba(147, 147, 147, 1);\n                border-radius: 100%;\n                width: 14px; height: 14px;\n                line-height: 14px;\n                font-family: \'Montserrat\';\n                font-size: .7em;\n                color: rgba(147, 147, 147, 1);\n            }\n        }\n\n        .FormTextInput {\n            margin-left: -7px;\n            padding-right: 4px;\n\n            > :first-child:not(.react-phone-number-input*) { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }\n        }\n    }\n\n    .inputWrapper {\n        padding-left: 10px;\n        // padding-right: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            width: 242px;\n            max-width: 242px;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            display: -webkit-inline-box;\n    \n            div:not(.react-phone-number-input*) {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n    \n            input[type=password], input[type=number], input[type=text], input[type=email], input[type=tel] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n            }\n            \n            input[type=tel] {\n                border-left: 1px solid rgba(151, 151, 151, 1);\n                width: 0px;\n            }\n\n            &.noteditable {\n                border-color: transparent;\n            }\n        }\n    \n        label {\n            width: 242px;\n            max-width: 242px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .btn-savechanges {\n        margin: 32px 0;\n        max-width: 242px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60,211,207,1);\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255,255,255,1);\n        text-align: center;\n        -webkit-letter-spacing: 0.01em;\n        -moz-letter-spacing: 0.01em;\n        -ms-letter-spacing: 0.01em;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n    }\n\n    .react-phone-number-input__icon {\n        img {\n            vertical-align: initial;\n        }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var MyAccountWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(MyAccountWrapper);

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _style = __webpack_require__(1704);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _redux = __webpack_require__(56);
	
	var _antd = __webpack_require__(43);
	
	var _contentHolder = __webpack_require__(215);
	
	var _contentHolder2 = _interopRequireDefault(_contentHolder);
	
	var _american_express = __webpack_require__(563);
	
	var _american_express2 = _interopRequireDefault(_american_express);
	
	var _android_pay = __webpack_require__(564);
	
	var _android_pay2 = _interopRequireDefault(_android_pay);
	
	var _apple_pay = __webpack_require__(565);
	
	var _apple_pay2 = _interopRequireDefault(_apple_pay);
	
	var _visa = __webpack_require__(567);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _master = __webpack_require__(566);
	
	var _master2 = _interopRequireDefault(_master);
	
	var _tooltip = __webpack_require__(277);
	
	var _tooltip2 = _interopRequireDefault(_tooltip);
	
	var _formik = __webpack_require__(436);
	
	var _reactStripeElements = __webpack_require__(256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	
	var _UpdateCreditCardForm = function (_React$Component) {
	  _inherits(_UpdateCreditCardForm, _React$Component);
	
	  function _UpdateCreditCardForm(props) {
	    _classCallCheck(this, _UpdateCreditCardForm);
	
	    return _possibleConstructorReturn(this, (_UpdateCreditCardForm.__proto__ || Object.getPrototypeOf(_UpdateCreditCardForm)).call(this, props));
	  }
	
	  _createClass(_UpdateCreditCardForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { width: '100%' } },
	        _react2.default.createElement(_reactStripeElements.CardElement, null)
	      );
	    }
	  }]);
	
	  return _UpdateCreditCardForm;
	}(_react2.default.Component);
	
	var UpdateCreditCardForm = (0, _reactStripeElements.injectStripe)(_UpdateCreditCardForm);
	
	var MyBilling = function (_Component) {
	  _inherits(MyBilling, _Component);
	
	  function MyBilling(props) {
	    _classCallCheck(this, MyBilling);
	
	    var _this2 = _possibleConstructorReturn(this, (MyBilling.__proto__ || Object.getPrototypeOf(MyBilling)).call(this, props));
	
	    _this2.state = {
	      billingInfoEditable: false,
	      creditCardEditable: false
	    };
	    _this2.onClickBillingInfoEdit = _this2.onClickBillingInfoEdit.bind(_this2);
	    _this2.onClickCreditCardEdit = _this2.onClickCreditCardEdit.bind(_this2);
	    return _this2;
	  }
	
	  _createClass(MyBilling, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      console.log(' componentWillUpdate');
	      //check difference
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      console.log(' componentWillReceiveProps');
	    }
	  }, {
	    key: 'createCampaignFake',
	    value: function createCampaignFake(campaign) {}
	  }, {
	    key: 'onClickBillingInfoEdit',
	    value: function onClickBillingInfoEdit() {
	      this.setState({
	        billingInfoEditable: !this.state.billingInfoEditable
	      });
	    }
	  }, {
	    key: 'onClickCreditCardEdit',
	    value: function onClickCreditCardEdit() {
	      this.setState({
	        creditCardEditable: !this.state.creditCardEditable
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // console.log( this.props)
	      // const { appDetail } = this.state;
	      // const { searchTerm, campaign, currentApp, secondApp} = this.props;    
	      // const { rowStyle, colStyle } = basicStyle;
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	
	
	      return _react2.default.createElement(
	        _style2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'account-menu' },
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'account' },
	                '\u6211\u7684\u5E10\u6237'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'a',
	                { href: 'billing', className: 'active' },
	                '\u4ED8\u6B3E\u8D44\u6599'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u4FE1\u7528\u5361\u8D44\u6599'
	              ),
	              this.state.creditCardEditable ? null : _react2.default.createElement(
	                'a',
	                { href: 'javascript:void(0)', onClick: this.onClickCreditCardEdit },
	                '\u4FEE\u6539'
	              )
	            ),
	            _react2.default.createElement(_formik.Formik, {
	              initialValues: {
	                cardNumber: '**** **** **** ****',
	                expiryDate: '24/24',
	                cvc: '***'
	              },
	              validate: function validate(values) {},
	              onSubmit: function onSubmit(values, actions) {
	                console.log('update card details');
	                console.table(values);
	                _this3.setState({
	                  creditCardEditable: false
	                });
	              },
	              render: function render(_ref) {
	                var handleSubmit = _ref.handleSubmit,
	                    handleChange = _ref.handleChange,
	                    handleBlur = _ref.handleBlur,
	                    setFieldValue = _ref.setFieldValue,
	                    values = _ref.values,
	                    errors = _ref.errors,
	                    dirty = _ref.dirty,
	                    touched = _ref.touched;
	
	                return _react2.default.createElement(
	                  'form',
	                  { onSubmit: handleSubmit },
	                  _this3.state.creditCardEditable ? null : _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 4, sm: 24, xs: 24 },
	                      _react2.default.createElement('img', { style: {}, className: 'card-type', src: _visa2.default, alt: 'visa' })
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'cardNumber' },
	                            '\u4FE1\u7528\u5361\u53F7\u7801'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.creditCardEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: true, type: 'text', name: 'cardNumber', value: values.cardNumber })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 4, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'expiryDate' },
	                            '\u5230\u671F\u65E5'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.creditCardEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: true, type: 'text', name: 'expiryDate', value: values.expiryDate })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 4, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'cvc' },
	                            'CVC'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.creditCardEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: true, type: 'text', name: 'cvc', value: values.cvc })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _this3.state.creditCardEditable ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _reactStripeElements.StripeProvider,
	                      { apiKey: 'pk_test_6pRNASCoBOKtIshFeQd4XMUh' },
	                      _react2.default.createElement(
	                        _reactStripeElements.Elements,
	                        null,
	                        _react2.default.createElement(UpdateCreditCardForm, null)
	                      )
	                    )
	                  ) : null,
	                  _this3.state.creditCardEditable ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 3, sm: 4, xs: 4, style: colStyle },
	                      _react2.default.createElement('img', { className: 'card-type', src: _visa2.default, alt: 'visa' })
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 3, sm: 4, xs: 4, style: colStyle },
	                      _react2.default.createElement('img', { className: 'card-type', src: _master2.default, alt: 'master' })
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 3, sm: 4, xs: 4, style: colStyle },
	                      _react2.default.createElement('img', { className: 'card-type', src: _american_express2.default, alt: 'ae' })
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 3, sm: 4, xs: 4, style: colStyle },
	                      _react2.default.createElement('img', { className: 'card-type', src: _apple_pay2.default, alt: 'apple-pay' })
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 3, sm: 4, xs: 4, style: colStyle },
	                      _react2.default.createElement('img', { className: 'card-type', src: _android_pay2.default, alt: 'android-pay' })
	                    )
	                  ) : null,
	                  _this3.state.creditCardEditable ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn-savechanges', type: 'submit' },
	                      '\u4FDD\u5B58'
	                    )
	                  ) : null
	                );
	              }
	            }),
	            _react2.default.createElement(
	              'h2',
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u5E10\u5355\u8D44\u6599'
	              ),
	              this.state.billingInfoEditable ? null : _react2.default.createElement(
	                'a',
	                { href: 'javascript:void(0)', onClick: this.onClickBillingInfoEdit },
	                '\u4FEE\u6539'
	              )
	            ),
	            _react2.default.createElement(_formik.Formik, {
	              initialValues: {
	                firstName: 'Sam',
	                lastName: 'Harris',
	                addr1: '4/F ABC House',
	                addr2: '23 DEF Road',
	                region1: 'Tsim Sha Tsui',
	                region2: '',
	                zipOrPostalCode: '',
	                country: 'Hong Kong'
	              },
	              validate: function validate(values) {},
	              onSubmit: function onSubmit(values, actions) {
	                console.log('my billing address');
	                console.table(values);
	                _this3.setState({
	                  billingInfoEditable: false
	                });
	              },
	              render: function render(_ref2) {
	                var handleSubmit = _ref2.handleSubmit,
	                    handleChange = _ref2.handleChange,
	                    handleBlur = _ref2.handleBlur,
	                    setFieldValue = _ref2.setFieldValue,
	                    values = _ref2.values,
	                    errors = _ref2.errors,
	                    dirty = _ref2.dirty,
	                    touched = _ref2.touched;
	
	                return _react2.default.createElement(
	                  'form',
	                  { onSubmit: handleSubmit },
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'firstName' },
	                            '\u6635\u79F0'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'firstName', value: values.firstName, onChange: handleChange })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper', hidden: true },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'lastName' },
	                            'Last Name'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'lastName', value: values.lastName, onChange: handleChange })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'addr1' },
	                            '\u5730\u5740'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'addr1', value: values.addr1, onChange: handleChange })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle, hidden: true },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement('label', { htmlFor: 'addr2' }),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'addr2', value: values.addr2, onChange: handleChange })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle, hidden: true },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'region1' },
	                            'City/Town/District'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'region1', value: values.region1, onChange: handleChange })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'region2' },
	                            'State/Province/Country/Region'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'region2', value: values.region2, onChange: handleChange })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle, hidden: true },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'zipOrPostalCode' },
	                            'ZIP/Postal Code'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'zipOrPostalCode', value: values.zipOrPostalCode, onChange: handleChange })
	                          )
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      _antd.Col,
	                      { md: 12, sm: 24, xs: 24, style: colStyle },
	                      _react2.default.createElement(
	                        _contentHolder2.default,
	                        null,
	                        _react2.default.createElement(
	                          'div',
	                          { className: 'inputWrapper' },
	                          _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'country' },
	                            '\u57CE\u5E02'
	                          ),
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'FormTextInput ' + (!_this3.state.billingInfoEditable ? "noteditable" : "") },
	                            _react2.default.createElement('input', { disabled: !_this3.state.billingInfoEditable, type: 'text', name: 'country', value: values.country, onChange: handleChange })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _this3.state.billingInfoEditable ? _react2.default.createElement(
	                    _antd.Row,
	                    { style: rowStyle },
	                    _react2.default.createElement(
	                      'button',
	                      { className: 'btn-savechanges', type: 'submit' },
	                      '\u4FDD\u5B58'
	                    )
	                  ) : null
	                );
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MyBilling;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setApp: function setApp(app) {
	      return dispatch(appSelected(app));
	    },
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	
	  };
	}
	function mapStateToProps(state) {
	  // const campaign  = state.get('deep').campaign;
	  return {
	    search: state.get('search'),
	    // campaign: campaign,
	    currentApp: state.getIn(['App', 'currentApp']),
	    secondApp: state.getIn(['App', 'secondApp']),
	    searchTerm: state.getIn(['App', 'searchTerm'])
	
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MyBilling);

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .account-menu {\n        position: relative;\n        margin: 0; margin-top: -1px;\n        padding: 13px 0 36px 0;\n        background-color: rgba(35, 31, 32, 1);\n        line-height: 17px;\n\n        ul {\n            margin: 0 auto;\n            display: flex;\n            justify-content: space-around;\n            width: 30%;\n            min-width: 240px;\n            max-width: 320px;\n\n            li { list-style-type: none; display: inline-block; text-align: right; }\n            li:not(:first-child) { text-align: left; }\n        }\n        a {\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            text-align: center;\n            letter-spacing: 0.08em;\n            text-transform: uppercase;\n        }\n        a.active { color: rgba(12, 183, 148, 1); }\n        // -- .account-menu\n    }    \n    .account-menu:after {\n        position: absolute;\n        right: 0; bottom: -3px; left: 0;\n        display: inline-block;\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12,183,148,1);\n        z-index: 1;\n    }\n\n    @media screen and (max-width: 767px) {\n        .account-menu {\n            ul {\n                width: 70%;\n                max-width: 300px;\n\n                li, li:not(:first-child) { width: 50%; text-align: center; }\n                a { line-height: 20px; letter-spacing: 0.06em; }\n            }\n        }\n    }\n\n    .main {\n        margin: 0;\n        padding: 0; padding-top: 44px; padding-bottom: 70px;\n        background-color: rgba(243, 243, 243, 1);\n\n        .info {\n            margin: 0 auto;\n            padding: 0;\n            width: 100%;\n            max-width: 698px;\n            background-color: rgba(249, 249, 249, 1);\n\n            > * { padding-right: 48px; padding-left: 64px ;}\n            h2 {\n                display: flex;\n                justify-content: space-between;\n                margin-top: 22px; margin-bottom: 21px;\n                font-weight: 700;\n                color: rgba(64, 55, 57, 1);\n                letter-spacing: 0.08em;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n                text-transform: uppercase;\n                \n                > span { font-family: \'Montserrat\'; font-size: 14px; line-height: 60px;}\n                a, a span {\n                    font-family: \'Montserrat\';\n                    font-size: 15px;\n                    color: rgba(12, 183, 148, 1);\n                    text-align: right;\n                    letter-spacing: 0.01em;\n                    text-transform: capitalize;\n                    line-height: 60px;\n                }\n                // -- h2\n            }\n            \n            h2:first-child + dl { padding-top: 6px; display: flex; align-items: center; }\n            dl ~ dl { padding-top: 17px; }\n            \n            h2:first-child + dl dt {\n                position: relative;\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                height: 63px;\n                background-color: rgba(230, 230, 230, 0.5);\n                border-radius: 10px;\n                \n                img { height: 13px; }\n            }\n            dl {\n                dt, dd { vertical-align: top; display: inline-block; }\n\n                dt {\n                    margin-right: 54px;\n                    width: 70px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(35, 31, 32, 1);\n                    letter-spacing: 0.01em;\n                }\n                dd {\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    font-weight: 700;\n                    color: rgba(151, 151, 151, 1);\n                    letter-spacing: 0.01em;\n                    \n                    span { display: block; }\n                    span:not(:first-child) { padding-top: 7px; }\n                }\n                // -- dl\n            }\n            dl:last-child { padding-bottom: 63px; }\n            // -- .info\n        }\n        // -- .main\n    }\n    \n    @media screen and (max-width: 767px) {\n        .main {\n            padding-right: 16px; padding-left: 16px;\n            .info {\n                > * { padding-right: 22px; padding-left: 21px ;}\n\n                .desktop { display: none; }\n\n                h2 ~ dl:last-child {\n                    display: flex;\n                    justify-content: center;\n\n                    dd { width: 50%; }\n                }\n            }\n        }\n    }\n\n\n    .isoExampleWrapper {\n        margin-top: 0;\n        input { background-color: transparent; width: 100%;}\n        input[type=password], input[type=text],input[type=tel],input[type=email],input[type=number] {\n            &:focus, &:active {\n                outline-width: 0;\n            }\n        }\n        input[disabled] {\n            border-color: rgba(216,216,216,0.6);\n            color: rgba(0,0,0,0.5);\n            background-color: transparent;\n        }\n    }\n\n    .inputWrapper {\n        padding: 0;\n        text-align: left;\n        \n        label {\n            margin-bottom: 8px;\n            display: block;\n            width: auto;\n\n            span {\n                display: inline-block;\n                margin-left: 4px;\n                border: 1px solid rgba(147, 147, 147, 1);\n                border-radius: 100%;\n                width: 14px;\n                height: 14px;\n                text-align: center;\n                line-height: 14px;\n                font-family: \'Montserrat\';\n                font-size: .7em;\n                color: rgba(147, 147, 147, 1);\n            }\n        }\n\n        .FormTextInput {\n            margin-left: -7px;\n            padding-right: 4px;\n\n            > :first-child { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }\n        }\n    }\n\n    .inputWrapper {\n        padding-left: 10px;\n        // padding-right: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            width: 100%;\n            max-width: 100%;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            display: -webkit-inline-box;\n    \n            div {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n            &.noteditable {\n                border-color: transparent;\n            }\n\n            input[type=password], input[type=number], input[type=text], input[type=email], input[type=tel] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n                //border-left: 1px solid rgba(151, 151, 151, 1);\n            }\n            \n        }\n    \n        label {\n            width: 242px;\n            max-width: 242px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .card-type {\n        width: 48px;\n        min-width: 48px;\n    }\n\n    .btn-savechanges {\n        margin: 32px 0;\n        max-width: 242px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60,211,207,1);\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255,255,255,1);\n        text-align: center;\n        -webkit-letter-spacing: 0.01em;\n        -moz-letter-spacing: 0.01em;\n        -ms-letter-spacing: 0.01em;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n    }\n'], ['\n    .account-menu {\n        position: relative;\n        margin: 0; margin-top: -1px;\n        padding: 13px 0 36px 0;\n        background-color: rgba(35, 31, 32, 1);\n        line-height: 17px;\n\n        ul {\n            margin: 0 auto;\n            display: flex;\n            justify-content: space-around;\n            width: 30%;\n            min-width: 240px;\n            max-width: 320px;\n\n            li { list-style-type: none; display: inline-block; text-align: right; }\n            li:not(:first-child) { text-align: left; }\n        }\n        a {\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            text-align: center;\n            letter-spacing: 0.08em;\n            text-transform: uppercase;\n        }\n        a.active { color: rgba(12, 183, 148, 1); }\n        // -- .account-menu\n    }    \n    .account-menu:after {\n        position: absolute;\n        right: 0; bottom: -3px; left: 0;\n        display: inline-block;\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12,183,148,1);\n        z-index: 1;\n    }\n\n    @media screen and (max-width: 767px) {\n        .account-menu {\n            ul {\n                width: 70%;\n                max-width: 300px;\n\n                li, li:not(:first-child) { width: 50%; text-align: center; }\n                a { line-height: 20px; letter-spacing: 0.06em; }\n            }\n        }\n    }\n\n    .main {\n        margin: 0;\n        padding: 0; padding-top: 44px; padding-bottom: 70px;\n        background-color: rgba(243, 243, 243, 1);\n\n        .info {\n            margin: 0 auto;\n            padding: 0;\n            width: 100%;\n            max-width: 698px;\n            background-color: rgba(249, 249, 249, 1);\n\n            > * { padding-right: 48px; padding-left: 64px ;}\n            h2 {\n                display: flex;\n                justify-content: space-between;\n                margin-top: 22px; margin-bottom: 21px;\n                font-weight: 700;\n                color: rgba(64, 55, 57, 1);\n                letter-spacing: 0.08em;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n                text-transform: uppercase;\n                \n                > span { font-family: \'Montserrat\'; font-size: 14px; line-height: 60px;}\n                a, a span {\n                    font-family: \'Montserrat\';\n                    font-size: 15px;\n                    color: rgba(12, 183, 148, 1);\n                    text-align: right;\n                    letter-spacing: 0.01em;\n                    text-transform: capitalize;\n                    line-height: 60px;\n                }\n                // -- h2\n            }\n            \n            h2:first-child + dl { padding-top: 6px; display: flex; align-items: center; }\n            dl ~ dl { padding-top: 17px; }\n            \n            h2:first-child + dl dt {\n                position: relative;\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                height: 63px;\n                background-color: rgba(230, 230, 230, 0.5);\n                border-radius: 10px;\n                \n                img { height: 13px; }\n            }\n            dl {\n                dt, dd { vertical-align: top; display: inline-block; }\n\n                dt {\n                    margin-right: 54px;\n                    width: 70px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(35, 31, 32, 1);\n                    letter-spacing: 0.01em;\n                }\n                dd {\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    font-weight: 700;\n                    color: rgba(151, 151, 151, 1);\n                    letter-spacing: 0.01em;\n                    \n                    span { display: block; }\n                    span:not(:first-child) { padding-top: 7px; }\n                }\n                // -- dl\n            }\n            dl:last-child { padding-bottom: 63px; }\n            // -- .info\n        }\n        // -- .main\n    }\n    \n    @media screen and (max-width: 767px) {\n        .main {\n            padding-right: 16px; padding-left: 16px;\n            .info {\n                > * { padding-right: 22px; padding-left: 21px ;}\n\n                .desktop { display: none; }\n\n                h2 ~ dl:last-child {\n                    display: flex;\n                    justify-content: center;\n\n                    dd { width: 50%; }\n                }\n            }\n        }\n    }\n\n\n    .isoExampleWrapper {\n        margin-top: 0;\n        input { background-color: transparent; width: 100%;}\n        input[type=password], input[type=text],input[type=tel],input[type=email],input[type=number] {\n            &:focus, &:active {\n                outline-width: 0;\n            }\n        }\n        input[disabled] {\n            border-color: rgba(216,216,216,0.6);\n            color: rgba(0,0,0,0.5);\n            background-color: transparent;\n        }\n    }\n\n    .inputWrapper {\n        padding: 0;\n        text-align: left;\n        \n        label {\n            margin-bottom: 8px;\n            display: block;\n            width: auto;\n\n            span {\n                display: inline-block;\n                margin-left: 4px;\n                border: 1px solid rgba(147, 147, 147, 1);\n                border-radius: 100%;\n                width: 14px;\n                height: 14px;\n                text-align: center;\n                line-height: 14px;\n                font-family: \'Montserrat\';\n                font-size: .7em;\n                color: rgba(147, 147, 147, 1);\n            }\n        }\n\n        .FormTextInput {\n            margin-left: -7px;\n            padding-right: 4px;\n\n            > :first-child { margin-left: -7px; padding: 0 8px; padding-right: 4px; line-height: 22px; }\n        }\n    }\n\n    .inputWrapper {\n        padding-left: 10px;\n        // padding-right: 10px;\n        font-family: \'Montserrat\';\n        font-size: 20px;\n        color: rgba(64, 55, 57, 1);\n        letter-spacing: 0.03em;\n        line-height: 18px;\n        font-family: \'Montserrat-Light\';\n        font-size: 16px;\n\n        .FormTextInput {\n            height: 40px;\n            width: 100%;\n            max-width: 100%;\n            border: 1px solid rgba(151, 151, 151, 1);\n            border-radius: 20px;\n            padding-left: 20px;\n            display: -webkit-inline-box;\n    \n            div {\n                margin: 8px;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                font-weight: 300;\n                color: rgba(147, 147, 147, 1);\n                text-align: left;\n                letter-spacing: 0.07em;\n            }\n    \n            &.noteditable {\n                border-color: transparent;\n            }\n\n            input[type=password], input[type=number], input[type=text], input[type=email], input[type=tel] {\n                height: 38px;                \n                min-width: 9rem;\n                border: none;\n                //border-left: 1px solid rgba(151, 151, 151, 1);\n            }\n            \n        }\n    \n        label {\n            width: 242px;\n            max-width: 242px;\n            height: 17px;\n            font-family: \'Montserrat\';\n            font-size: 14px;\n            color: rgba(64, 55, 57, 1);\n            text-align: left;\n            letter-spacing: 0.04em;\n            display: -webkit-inline-box;\n        }\n    \n    }\n\n    .card-type {\n        width: 48px;\n        min-width: 48px;\n    }\n\n    .btn-savechanges {\n        margin: 32px 0;\n        max-width: 242px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60,211,207,1);\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255,255,255,1);\n        text-align: center;\n        -webkit-letter-spacing: 0.01em;\n        -moz-letter-spacing: 0.01em;\n        -ms-letter-spacing: 0.01em;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var MyBillingWrapper = _styledComponents2.default.div(_templateObject);
	exports.default = (0, _withDirection2.default)(MyBillingWrapper);

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJsonView = __webpack_require__(493);
	
	var _reactJsonView2 = _interopRequireDefault(_reactJsonView);
	
	var _reactStripeElements = __webpack_require__(256);
	
	var _american_express = __webpack_require__(563);
	
	var _american_express2 = _interopRequireDefault(_american_express);
	
	var _android_pay = __webpack_require__(564);
	
	var _android_pay2 = _interopRequireDefault(_android_pay);
	
	var _apple_pay = __webpack_require__(565);
	
	var _apple_pay2 = _interopRequireDefault(_apple_pay);
	
	var _visa = __webpack_require__(567);
	
	var _visa2 = _interopRequireDefault(_visa);
	
	var _master = __webpack_require__(566);
	
	var _master2 = _interopRequireDefault(_master);
	
	var _download_green_arrow = __webpack_require__(568);
	
	var _download_green_arrow2 = _interopRequireDefault(_download_green_arrow);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _formStyle = __webpack_require__(1706);
	
	var _formStyle2 = _interopRequireDefault(_formStyle);
	
	var _checkbox = __webpack_require__(739);
	
	var _checkbox2 = _interopRequireDefault(_checkbox);
	
	var _nprogress = __webpack_require__(320);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _index = __webpack_require__(393);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// -- Components
	
	
	var handleBlur = function handleBlur() {
	  // console.log('[blur]');
	};
	var handleChange = function handleChange(change) {
	  // console.log('[change]', change);
	};
	var handleClick = function handleClick() {
	  // console.log('[click]');
	};
	var handleFocus = function handleFocus() {
	  // console.log('[focus]');
	};
	var handleReady = function handleReady() {
	  // console.log('[ready]');
	};
	
	var createOptions = function createOptions(fontSize) {
	  return {
	    style: {
	      base: {
	        fontSize: fontSize,
	        color: '#424770',
	        letterSpacing: '0.025em',
	        fontFamily: 'Source Code Pro, Menlo, monospace',
	        '::placeholder': {
	          color: '#aab7c4'
	        }
	      },
	      invalid: {
	        color: '#9e2146'
	      }
	    }
	  };
	};
	
	var SplitForm = function (_React$Component) {
	  _inherits(SplitForm, _React$Component);
	
	  function SplitForm(props) {
	    _classCallCheck(this, SplitForm);
	
	    var _this = _possibleConstructorReturn(this, (SplitForm.__proto__ || Object.getPrototypeOf(SplitForm)).call(this, props));
	
	    _this.handleAddressChange = function (ev) {
	      _this.setState({ address: ev.target.value });
	    };
	
	    _this.handleCityChange = function (ev) {
	      _this.setState({ city: ev.target.value });
	    };
	
	    _this.handleStateChange = function (ev) {
	      _this.setState({ state: ev.target.value });
	    };
	
	    _this.handleCountryChange = function (ev) {
	      _this.setState({ country: ev.target.value });
	    };
	
	    _this.handlePostalCodeChange = function (ev) {
	      _this.setState({ postalCode: ev.target.value });
	    };
	
	    _this.handleNameChange = function (ev) {
	      _this.setState({ name: ev.target.value });
	    };
	
	    _this.handleEmailChange = function (ev) {
	      _this.setState({ email: ev.target.value });
	    };
	
	    _this.handleSubmit = function (ev) {
	
	      // We don't want to let default form submission happen here, which would refresh the page.
	      _this.setState({ response: null, isNeedLoading: true });
	      var campaign = _this.props.campaign;
	      ("fake") === 'fake' && _this.props.history.push('/dashboard/' + campaign.adamId);
	
	      var _this$props$currentAp = _this.props.currentApp,
	          bundleId = _this$props$currentAp.bundleId,
	          appName = _this$props$currentAp.appName;
	      var getAccessToken = _this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	
	      ev.preventDefault();
	      // console.log('form submit :', ev)
	      _this.props.stripe.createToken({
	        name: _this.props.profile.name,
	        // address_line1: this.state.address,
	        email: _this.props.profile.email
	      }).then(function (payload) {
	        // axios.post(`${API_URL}/searchads/campaigns/create/`, request, { headers } )
	        // .then(response => {
	        //   this.setState({ message: 'asdfsdf', response: response.data})
	        //   this.props.history.push(`/profile`) 
	        // })
	        // .catch(error => this.setState({ message: error.message }));
	
	        console.log('Received Stripe token:', payload);
	        console.log('Received campaign:', campaign);
	        console.log('Received appName:', appName);
	        // return;
	        _nprogress2.default.start();
	        _axios2.default.post(_server2.default + '/order/simple/', {
	          token: payload.token,
	          campaign: campaign,
	          appName: appName,
	          bundleId: bundleId
	        }, { headers: headers }).then(function (response) {
	          _nprogress2.default.done();
	
	          _this.setState({ message: 'asdfsdf', response: response.data });
	
	          var campaignGroupId = response.data.campaignSer.shortId;
	          var campaignId = response.data.campaignSer.searchAdsCampaign;
	          console.log(response);
	          _this.props.history.push('/dashboard/' + campaign.adamId);
	
	          // this.props.isFinishPurhcase(response)
	          // this.props.history.push(`/profile`) 
	          console.log(' 200 ');
	        }).catch(function (error) {
	          _nprogress2.default.done();
	          _this.setState({ isNeedLoading: false });
	
	          var response = error.response;
	          _this.setState({ response: response.data });
	          console.log(' 500 ', response);
	          _this.props.updateError(false, response.data);
	        });
	      });
	    };
	
	    _this.state = {
	      // email: '',
	      // name: '',
	      // address: '',
	      // city: '',
	      // state: '',
	      // country: 'HK',
	      // postal_code: '',
	      // referalToken: ''
	      isNeedLoading: false
	    };
	
	    // this.handleEmailChange = this.handleEmailChange.bind(this);
	    // this.handlePasswordChange = this.handlePasswordChange.bind(this);
	    return _this;
	  }
	
	  _createClass(SplitForm, [{
	    key: 'render',
	    value: function render() {
	      var _arguments = arguments;
	
	      console.log(' API_URL : ', _server2.default, ({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_STAGE":"fake"}));
	      return _react2.default.createElement(
	        _formStyle2.default,
	        null,
	        this.state.isNeedLoading && _react2.default.createElement(_index2.default, null),
	        _react2.default.createElement(
	          'form',
	          { onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            'label',
	            { className: 'StripeLabel' },
	            _react2.default.createElement(_reactStripeElements.CardElement, Object.assign({
	              hidePostalCode: true,
	              onBlur: handleBlur,
	              onChange: handleChange,
	              onFocus: handleFocus,
	              onReady: handleReady
	            }, createOptions(this.props.fontSize)))
	          ),
	          _react2.default.createElement('div', { className: 'my-input', id: 'card-element' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { className: 'visa', src: _visa2.default, alt: 'visa' }),
	            _react2.default.createElement('img', { className: 'master', src: _master2.default, alt: 'master' }),
	            _react2.default.createElement('img', { className: 'ae', src: _american_express2.default, alt: 'ae' }),
	            _react2.default.createElement('img', { className: 'apple-pay', src: _apple_pay2.default, alt: 'apple-pay' }),
	            _react2.default.createElement('img', { className: 'android-pay', src: _android_pay2.default, alt: 'android-pay' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              _checkbox2.default,
	              { handleChick: function handleChick() {
	                  console.log(_arguments);
	                } },
	              _react2.default.createElement(
	                'span',
	                { className: 'remeber-card' },
	                '\u50A8\u5B58\u6B64\u5361'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit',
	              className: 'btn-create-campaign',
	              onClick: this.handleSubmit },
	            '\u786E\u8BA4\u4ED8\u6B3E ',
	            _react2.default.createElement('img', { src: _download_green_arrow2.default })
	          ),
	          this.state.response && _react2.default.createElement(_reactJsonView2.default, { src: this.state.response }),
	          this.state.response && _react2.default.createElement(_reactJsonView2.default, { src: this.props.campaign })
	        )
	      );
	    }
	  }]);
	
	  return SplitForm;
	}(_react2.default.Component);
	
	exports.default = (0, _reactStripeElements.injectStripe)(SplitForm);

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .btn {\n        display: block;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        padding: 1rem 2rem;\n        text-transform: uppercase;\n        font-size: 0.8rem;\n        background: #1695A3;\n        color: white;\n        border: none;\n        border-radius: 3px;\n        margin: 0.5rem 0;\n    }\n    .btn-create-campaign {\n        margin-top: 86px;\n        max-width: 270px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60, 211, 207, 1);\n\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n\n        img {\n            height: 18px;\n            transform: rotate(90deg) translateY(-14px);\n            filter: brightness(0) invert(1);\n        }\n    }\n\n    .visa, .master, .ae, .apple-pay, .android-pay { margin-right: 21px; width: 65px; height: 65px; }\n    .master {       }\n    .ae {           }\n    .apple-pay {    }\n    .android-pay {  }\n'], ['\n    .btn {\n        display: block;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        padding: 1rem 2rem;\n        text-transform: uppercase;\n        font-size: 0.8rem;\n        background: #1695A3;\n        color: white;\n        border: none;\n        border-radius: 3px;\n        margin: 0.5rem 0;\n    }\n    .btn-create-campaign {\n        margin-top: 86px;\n        max-width: 270px;\n        width: 100%;\n        padding: 0;\n        background-color: rgba(60, 211, 207, 1);\n\n        line-height: 38px;\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n        border-radius: 20px;\n\n        img {\n            height: 18px;\n            transform: rotate(90deg) translateY(-14px);\n            filter: brightness(0) invert(1);\n        }\n    }\n\n    .visa, .master, .ae, .apple-pay, .android-pay { margin-right: 21px; width: 65px; height: 65px; }\n    .master {       }\n    .ae {           }\n    .apple-pay {    }\n    .android-pay {  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SplitFormWrapper = _styledComponents2.default.div(_templateObject);
	
	// export default WithDirection(OrderSummaryWrapper);
	exports.default = SplitFormWrapper;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(157);
	
	var _antd = __webpack_require__(43);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _reactRedux = __webpack_require__(40);
	
	var _reactRouter = __webpack_require__(1286);
	
	var _immutable = __webpack_require__(35);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _immutable3 = __webpack_require__(499);
	
	var _style = __webpack_require__(1708);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _reactStripeElements = __webpack_require__(256);
	
	var _SplitForm = __webpack_require__(1705);
	
	var _SplitForm2 = _interopRequireDefault(_SplitForm);
	
	var _stripe = __webpack_require__(742);
	
	var _stripe2 = _interopRequireDefault(_stripe);
	
	var _reactFlagsSelect = __webpack_require__(196);
	
	var _reactFlagsSelect2 = _interopRequireDefault(_reactFlagsSelect);
	
	__webpack_require__(185);
	
	var _country = __webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var OrderReview = function (_Component) {
	  _inherits(OrderReview, _Component);
	
	  function OrderReview(props) {
	    _classCallCheck(this, OrderReview);
	
	    var _this = _possibleConstructorReturn(this, (OrderReview.__proto__ || Object.getPrototypeOf(OrderReview)).call(this, props));
	
	    _this.updateResult = function (success, text) {
	      if (success) {} else {}
	    };
	
	    _this.updateError = function (err) {};
	
	    _this.state = {
	      stripe: null,
	      campaign: null
	    };
	
	    return _this;
	  }
	
	  _createClass(OrderReview, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.setState({ profile: {} });
	      var _props$auth = this.props.auth,
	          userProfile = _props$auth.userProfile,
	          getProfile = _props$auth.getProfile;
	
	      if (!userProfile) {
	        getProfile(function (err, profile) {
	          _this2.setState({ profile: profile });
	        });
	      } else {
	        this.setState({ profile: userProfile });
	      }
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      console.log(' componentWillUpdate');
	      //check difference
	    }
	    // componentDidReceiveProps(){
	    //   console.log( ' componentWillReceiveProps')
	
	    // }
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      if (window.Stripe) {
	        this.setState({ stripe: window.Stripe(_stripe2.default) });
	      } else {
	        document.querySelector('#stripe-js').addEventListener('load', function () {
	          // Create Stripe instance once Stripe.js loads
	          _this3.setState({ stripe: window.Stripe(_stripe2.default) });
	        });
	      }
	      var recievedMessage = this.props.location.state.orderRequest;
	      console.log(JSON.stringify(recievedMessage));
	
	      this.setState({
	        campaign: recievedMessage
	      });
	      console.log(recievedMessage);
	      console.log(_stripe2.default, ' ', _server2.default);
	    }
	  }, {
	    key: 'createCampaign',
	    value: function createCampaign(campaign) {
	      var _this4 = this;
	
	      var adamId = this.props.match.params.appId;
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      console.log(headers);
	      var positiveKeywords = campaign.boostedKeywords;
	      var negativeKeywords = campaign.negativeKeywords;
	
	      var request = Object.assign({}, campaign, { adamId: adamId, positiveKeywords: positiveKeywords, negativeKeywords: negativeKeywords });
	      console.log('campaign to be submitted : ', request);
	      this.setState({ request: request });
	      _axios2.default.post(_server2.default + '/searchads/campaigns/create/', request, { headers: headers }).then(function (response) {
	        _this4.setState({ message: 'asdfsdf', response: response.data });
	        _this4.props.history.push('/profile');
	      }).catch(function (error) {
	        return _this4.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      console.log(this.props);
	      var _state = this.state,
	          appDetail = _state.appDetail,
	          campaign = _state.campaign;
	      var _props = this.props,
	          searchTerm = _props.searchTerm,
	          currentApp = _props.currentApp;
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	
	
	      if (!campaign) {
	        return _react2.default.createElement('div', null);
	      }
	
	      if (!currentApp) {
	        return _react2.default.createElement(_reactRouter.Redirect, { to: '/' });
	      }
	
	      return _react2.default.createElement(
	        _style2.default,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'sub-header' },
	          '\u8BA2\u5355\u6458\u8981'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'main' },
	          _react2.default.createElement(
	            'div',
	            { className: 'info' },
	            _react2.default.createElement(
	              'dl',
	              { className: 'app-header' },
	              _react2.default.createElement(
	                'dt',
	                null,
	                _react2.default.createElement('img', { src: currentApp.artworkUrl100, alt: 'screen' })
	              ),
	              _react2.default.createElement(
	                'dd',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  { className: 'app-name' },
	                  currentApp.trackCensoredName
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { className: 'app-stores' },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u82F9\u679C\u5546\u5E97:'
	                  ),
	                  campaign && this.state.campaign.budgetSplit.map(function (item, index) {
	                    var regionCode = item.key;
	
	                    if (item.value > 0.0) {
	                      return _react2.default.createElement(_reactFlagsSelect2.default, {
	                        key: regionCode,
	                        className: 'regionInput',
	                        defaultCountry: regionCode,
	                        customLabels: _country.FLAG_LABELS,
	                        showSelectedLabel: false,
	                        disabled: true });
	                    } else {
	                      return null;
	                    }
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              '\u4F60\u7684\u8BA2\u5355'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'summary' },
	              _react2.default.createElement(
	                'table',
	                null,
	                _react2.default.createElement(
	                  'tbody',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      '\u8BA1\u5212\u9884\u7B97'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      '\u7F8E\u91D1',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'budget' },
	                        '$',
	                        campaign.depositAmount
	                      )
	                    )
	                  )
	                ),
	                _react2.default.createElement(
	                  'tfoot',
	                  null,
	                  _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                      'th',
	                      null,
	                      '\u603B\u4ED8:'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      '\u7F8E\u91D1',
	                      _react2.default.createElement(
	                        'span',
	                        { className: 'total-amount' },
	                        '$',
	                        campaign.depositAmount
	                      )
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'promotion-code' },
	              _react2.default.createElement(
	                'dl',
	                null,
	                _react2.default.createElement(
	                  'dt',
	                  null,
	                  '\u4F7F\u7528\u4F18\u60E0\u7801'
	                ),
	                _react2.default.createElement(
	                  'dd',
	                  null,
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'border-wrapper' },
	                    _react2.default.createElement('input', { type: 'text', required: true }),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'placeholder' },
	                      '\u4F18\u60E0\u7801'
	                    ),
	                    _react2.default.createElement(
	                      'button',
	                      null,
	                      '\u5E94\u7528'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'h2',
	              null,
	              '\u4ED8\u6B3E\u8BE6\u60C5'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'card-info' },
	              _react2.default.createElement(
	                _reactStripeElements.StripeProvider,
	                { stripe: this.state.stripe },
	                _react2.default.createElement(
	                  _reactStripeElements.Elements,
	                  null,
	                  _react2.default.createElement(_SplitForm2.default, {
	                    fontSize: '18px',
	                    updateResult: this.updateResult.bind(this),
	                    updateError: this.updateError.bind(this),
	                    campaign: this.state.campaign,
	                    auth: this.props.auth,
	                    profile: this.state.profile,
	                    currentApp: currentApp,
	                    history: this.props.history
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return OrderReview;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {};
	}
	
	function mapStateToProps(state) {
	  return {
	    search: state.get('search'),
	    currentApp: state.getIn(['ItunesSearch', 'currentApp']),
	    secondApp: state.getIn(['ItunesSearch', 'secondApp']),
	    searchTerm: state.getIn(['ItunesSearch', 'searchTerm'])
	
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrderReview);

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n'], ['\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n.ant-tooltip-content { position: relative; }\n          .ant-tooltip-inner {\n            padding: 18px;\n            padding-bottom: 21px;\n            background-color: rgba(0, 0, 0, .65);\n            line-height: 16px;\n            font-family: \'Montserrat\';\n            font-size: 13px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            letter-spacing: 0.04em;\n            border-radius: 10px;\n            text-shadow: 0 0 1px #555;\n          }\n          .ant-tooltip-placement-top .ant-tooltip-arrow {\n            position: absolute;\n            bottom: 0;            border-top-color: rgba(0, 0, 0, .4);\n            transform: translateY(100%);\n          }\n    .sub-header {\n        position: relative;\n        margin: 0; margin-top: -1px;\n        padding: 13px 0 36px 0;\n        background-color: rgba(35, 31, 32, 1);\n        line-height: 17px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(219, 219, 219, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n        // -- .sub-header\n    }\n    .sub-header:after {\n        position: absolute;\n        right: 0; bottom: -3px; left: 0;\n        display: inline-block;\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12,183,148,1);\n        z-index: 1;\n    }\n\n    .main {\n        margin: 0;\n        padding: 0; padding-top: 44px; padding-bottom: 70px;\n        background-color: rgba(243, 243, 243, 1);\n\n        .info {\n            margin: 0 auto;\n            padding: 0;\n            width: 100%;\n            max-width: 893px;\n            background-color: rgba(249, 249, 249, 1);\n\n            > * { padding-right: 48px; padding-left: 64px ; }\n            .app-header {\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                margin-bottom: 38px;\n                padding-top: 42px; padding-left: -25px;\n\n                dt { width: 85px; height: 78px; }\n                dt img { border-radius: 1rem; }\n\n                dd {\n                    .app-name,\n                    .app-stores {\n                        display: block;\n                        padding-left: 11px;\n                    }\n                    .app-name {\n                        font-family: \'Montserrat\';\n                        font-size: 22px;\n                        font-weight: 300;\n                        color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.09em;\n                    }\n                    .app-stores {\n                        margin-top: 8px;\n                        max-width: 600px;\n                        font-family: \'Roboto\', sans-serif;\n                        font-size: 14px;\n                        color: rgba(147, 147, 147, 1);\n                        text-align: justify;\n                        letter-spacing: 0.04em;\n\n                        img { margin-left: 7px; width: 24px; }\n                    }\n                }\n                // -- .app-header\n            }\n                \n            h2 {\n                margin-top: 0; margin-bottom: 21px;\n                line-height: 60px;\n                font-weight: 700;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                color: rgba(64, 55, 57, 1);\n                letter-spacing: 0.08em;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n                text-transform: uppercase;\n            }\n\n            .summary {\n                table {\n                    tbody {\n                        border-bottom: 1px solid rgba(219, 219, 219, 1);\n                        > tr:first-child th {\n                            font-family: \'Montserrat\';\n                            font-size: 14px;\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n                            line-height: 15px;\n                        }\n                        > tr:first-child td {\n                            font-family: \'Montserrat-Light\';\n                            font-size: 12px;\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n                            line-height: 15px;\n                        }\n                    }\n                    \n                    th, td { padding-bottom: 16px; }\n                    th {\n                        padding-right: 60px;\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.04em;\n                        line-height: 15px;\n                    }\n                    td {\n                        font-family: \'Montserrat-Light\';\n                        font-size: 12px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.04em;\n                        line-height: 15px;\n\n                        span { padding-left: 11px; font-size: 14px; font-family: \'Montserrat-Light\'; }\n                    }\n\n                    tfoot {\n                        th, td {\n                            padding-top: 16px;\n                            padding-bottom: 47px;\n                            font-family: \'Montserrat\';\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n                            line-height: 15px;\n                        }\n                        th, td span { font-size: 14px; font-weight: 700; }\n                    }\n                    // -- table\n                }\n                \n                p {\n                    margin-bottom: 57px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(12, 183, 148, 1);\n                    letter-spacing: 0.04em;\n                }\n                // -- .summary\n            }\n\n            .promotion-code {\n                padding-top: 18px; padding-bottom: 18px;\n                background-color: rgba(219, 219, 219, 0.35);\n\n                dl {\n                    margin-top: 0; margin-bottom: 0;\n\n                    dt {\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.04em;\n                    }\n\n                    .border-wrapper{\n                        input:valid + .placeholder { display: none; }\n                        input { margin-right: 31px; width: 220px; }\n                        button {\n                            margin-right: 5px; margin-left: 2px;\n                            display: inline-block;\n                            border-left: 1px solid rgba(151, 151, 151, 1);\n                            width: 65px;\n                            background-color: transparent;\n                            font-family: \'Montserrat\';\n                            font-size: 14px;\n                            color: rgba(64, 55, 57, 1);\n                            text-align: center;\n                            letter-spacing: 0.04em;\n                            text-transform: uppercase;\n                        }\n                    }\n                }\n                // -- .promotion-code\n            }\n\n            .card-info {\n                padding-bottom: 42px;\n\n                dl + dl { margin-left: 44px; }\n                dt {\n                    display: flex;\n                    align-items: flex-start;\n                    line-height: 17px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(35, 31, 32, 1);\n                    letter-spacing: 0.01em;\n                }\n                dl { margin-bottom: 0; }\n\n                .card-number .border-wrapper input { margin-right: 70px; width: 155px; }\n                .card-number img { margin-right: 21px; height: 10px; }\n                .card-exp-date .border-wrapper input { margin-right: 51px; width: 60px; }\n                .card-exp-date .placeholder { color: rgba(219, 219, 219, 1); }\n                .card-cvc .border-wrapper input { margin-right: 0; width: 84px; }\n                .card-cvc dt {\n                    span {\n                        display: inline-flex;\n                        justify-content: center;\n                        align-items: center;\n                        margin-left: 7px;\n                        border: 1px solid rgba(147, 147, 147, 1);\n                        width: 14px; height: 14px;\n                        font-family: \'Roboto\', sans-serif;\n                        font-size: 11px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.07em;\n                        border-radius: 14px;\n                    }\n                }\n\n                dl + p {\n                    margin-top: 20px;\n                    display: flex;\n                    align-items: center;\n\n                    img:not(:first-child) { margin-left: 25px; }\n                }\n\n                dl + p + p {\n                    margin-top: 20px;\n                    \n                    * { display: inline-block; margin: 0; padding: 0; vertical-align: middle; }\n                    label {\n                        margin: 0;\n                        margin-left: 10px;\n                        font-family: \'Montserrat\';\n                        font-size: 12px;\n                        font-weight: 300;\n                        color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.04em;\n                    }\n                }\n\n                dl ~ button {\n                    margin: 0; margin-top: 24px; margin-left: -18px;\n                    background-color: rgba(60, 211, 207, 1);\n                    padding: 10px 50px 10px 43px;\n                    font-family: \'Montserrat\';\n                    font-size: 15px;\n                    color: rgba(255, 255, 255, 1);\n                    text-align: center;\n                    letter-spacing: 0.01em;\n                    border-radius: 20px;\n                    \n                    img {\n                        height: 18px;\n                        transform: rotate(90deg) translateY(-14px);\n                        filter: brightness(0) invert(1);\n                    }\n                }\n                // -- .card-info\n            }\n        }\n\n        .info {\n            dl {\n                display: inline-block;\n\n                .border-wrapper {\n                    position: relative;\n                    display: inline-flex;\n                    align-items: center;\n                    margin-top: 10px; margin-left: -12px;\n                    border: 1px solid rgba(151, 151, 151, 1);\n                    padding-left: 24px;\n                    line-height: 40px;\n                    border-radius: 20px;\n                 \n                    > * { margin: 0; padding: 0; }\n\n                    input:focus, input:active { outline-width: 0; }\n                    input[type=number]::-webkit-inner-spin-button, \n                    input[type=number]::-webkit-outer-spin-button { \n                        -webkit-appearance: none; \n                        margin: 0; \n                    }\n                    input {\n                        outline-width: 0;\n                        border-width: 0;\n                        min-width: none; min-width: auto; min-width: unset;\n                        background-color: transparent;\n                        z-index: 1; \n                    }\n                    input.not-empty + .placeholder { opacity: 0; }\n                    .placeholder {\n                        position: absolute;\n                        left: 24px;\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.04em;\n                    }   \n                }\n            }\n\n            .card-info {\n                .remeber-card {\n                    font-family: \'Montserrat-Light\';\n                    color: rgba(147,147,147,1);\n                }\n            }\n        }\n\n        @media screen and (max-width: 767px) {\n            padding: 34px 16px 104px 16px;\n            \n            .info {\n                > * { padding-right: 15px; padding-left: 16px ; }\n                .app-header {\n                    padding-top: 18px;\n                    .app-stores span { display: block; }\n                    .app-stores span ~ img { margin-left: 0; margin-right: 7px; }\n                }\n                .promotion-code dl, .card-info dl {\n                    dt { text-indent: 2px; }\n                    .border-wrapper {\n                        margin-left: -8px;\n\n                        input { max-width: 50vw; }\n                        .placeholder { right: 72px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n                    }\n                }\n                .card-info {\n                    dl:not(:first-child) { margin-top: 32px; }\n                    dl:not(:last-of-type) { margin-left: 0; }\n                    dl:last-of-type { margin-left: 41px; }\n\n                    dl ~ button { margin-left: 36px; }\n                }\n            }\n        }\n        // -- .main\n    }\n'], ['\n.ant-tooltip-content { position: relative; }\n          .ant-tooltip-inner {\n            padding: 18px;\n            padding-bottom: 21px;\n            background-color: rgba(0, 0, 0, .65);\n            line-height: 16px;\n            font-family: \'Montserrat\';\n            font-size: 13px;\n            font-weight: 300;\n            color: rgba(255, 255, 255, 1);\n            letter-spacing: 0.04em;\n            border-radius: 10px;\n            text-shadow: 0 0 1px #555;\n          }\n          .ant-tooltip-placement-top .ant-tooltip-arrow {\n            position: absolute;\n            bottom: 0;\\\n            border-top-color: rgba(0, 0, 0, .4);\n            transform: translateY(100%);\n          }\n    .sub-header {\n        position: relative;\n        margin: 0; margin-top: -1px;\n        padding: 13px 0 36px 0;\n        background-color: rgba(35, 31, 32, 1);\n        line-height: 17px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(219, 219, 219, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n        // -- .sub-header\n    }\n    .sub-header:after {\n        position: absolute;\n        right: 0; bottom: -3px; left: 0;\n        display: inline-block;\n        content: \'\';\n        height: 3px;\n        background-color: rgba(12,183,148,1);\n        z-index: 1;\n    }\n\n    .main {\n        margin: 0;\n        padding: 0; padding-top: 44px; padding-bottom: 70px;\n        background-color: rgba(243, 243, 243, 1);\n\n        .info {\n            margin: 0 auto;\n            padding: 0;\n            width: 100%;\n            max-width: 893px;\n            background-color: rgba(249, 249, 249, 1);\n\n            > * { padding-right: 48px; padding-left: 64px ; }\n            .app-header {\n                display: inline-flex;\n                justify-content: center;\n                align-items: center;\n                margin-bottom: 38px;\n                padding-top: 42px; padding-left: -25px;\n\n                dt { width: 85px; height: 78px; }\n                dt img { border-radius: 1rem; }\n\n                dd {\n                    .app-name,\n                    .app-stores {\n                        display: block;\n                        padding-left: 11px;\n                    }\n                    .app-name {\n                        font-family: \'Montserrat\';\n                        font-size: 22px;\n                        font-weight: 300;\n                        color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.09em;\n                    }\n                    .app-stores {\n                        margin-top: 8px;\n                        max-width: 600px;\n                        font-family: \'Roboto\', sans-serif;\n                        font-size: 14px;\n                        color: rgba(147, 147, 147, 1);\n                        text-align: justify;\n                        letter-spacing: 0.04em;\n\n                        img { margin-left: 7px; width: 24px; }\n                    }\n                }\n                // -- .app-header\n            }\n                \n            h2 {\n                margin-top: 0; margin-bottom: 21px;\n                line-height: 60px;\n                font-weight: 700;\n                font-family: \'Montserrat\';\n                font-size: 14px;\n                color: rgba(64, 55, 57, 1);\n                letter-spacing: 0.08em;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);\n                text-transform: uppercase;\n            }\n\n            .summary {\n                table {\n                    tbody {\n                        border-bottom: 1px solid rgba(219, 219, 219, 1);\n                        > tr:first-child th {\n                            font-family: \'Montserrat\';\n                            font-size: 14px;\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n                            line-height: 15px;\n                        }\n                        > tr:first-child td {\n                            font-family: \'Montserrat-Light\';\n                            font-size: 12px;\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n                            line-height: 15px;\n                        }\n                    }\n                    \n                    th, td { padding-bottom: 16px; }\n                    th {\n                        padding-right: 60px;\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.04em;\n                        line-height: 15px;\n                    }\n                    td {\n                        font-family: \'Montserrat-Light\';\n                        font-size: 12px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.04em;\n                        line-height: 15px;\n\n                        span { padding-left: 11px; font-size: 14px; font-family: \'Montserrat-Light\'; }\n                    }\n\n                    tfoot {\n                        th, td {\n                            padding-top: 16px;\n                            padding-bottom: 47px;\n                            font-family: \'Montserrat\';\n                            color: rgba(64, 55, 57, 1);\n                            letter-spacing: 0.04em;\n                            line-height: 15px;\n                        }\n                        th, td span { font-size: 14px; font-weight: 700; }\n                    }\n                    // -- table\n                }\n                \n                p {\n                    margin-bottom: 57px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(12, 183, 148, 1);\n                    letter-spacing: 0.04em;\n                }\n                // -- .summary\n            }\n\n            .promotion-code {\n                padding-top: 18px; padding-bottom: 18px;\n                background-color: rgba(219, 219, 219, 0.35);\n\n                dl {\n                    margin-top: 0; margin-bottom: 0;\n\n                    dt {\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.04em;\n                    }\n\n                    .border-wrapper{\n                        input:valid + .placeholder { display: none; }\n                        input { margin-right: 31px; width: 220px; }\n                        button {\n                            margin-right: 5px; margin-left: 2px;\n                            display: inline-block;\n                            border-left: 1px solid rgba(151, 151, 151, 1);\n                            width: 65px;\n                            background-color: transparent;\n                            font-family: \'Montserrat\';\n                            font-size: 14px;\n                            color: rgba(64, 55, 57, 1);\n                            text-align: center;\n                            letter-spacing: 0.04em;\n                            text-transform: uppercase;\n                        }\n                    }\n                }\n                // -- .promotion-code\n            }\n\n            .card-info {\n                padding-bottom: 42px;\n\n                dl + dl { margin-left: 44px; }\n                dt {\n                    display: flex;\n                    align-items: flex-start;\n                    line-height: 17px;\n                    font-family: \'Montserrat\';\n                    font-size: 14px;\n                    color: rgba(35, 31, 32, 1);\n                    letter-spacing: 0.01em;\n                }\n                dl { margin-bottom: 0; }\n\n                .card-number .border-wrapper input { margin-right: 70px; width: 155px; }\n                .card-number img { margin-right: 21px; height: 10px; }\n                .card-exp-date .border-wrapper input { margin-right: 51px; width: 60px; }\n                .card-exp-date .placeholder { color: rgba(219, 219, 219, 1); }\n                .card-cvc .border-wrapper input { margin-right: 0; width: 84px; }\n                .card-cvc dt {\n                    span {\n                        display: inline-flex;\n                        justify-content: center;\n                        align-items: center;\n                        margin-left: 7px;\n                        border: 1px solid rgba(147, 147, 147, 1);\n                        width: 14px; height: 14px;\n                        font-family: \'Roboto\', sans-serif;\n                        font-size: 11px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.07em;\n                        border-radius: 14px;\n                    }\n                }\n\n                dl + p {\n                    margin-top: 20px;\n                    display: flex;\n                    align-items: center;\n\n                    img:not(:first-child) { margin-left: 25px; }\n                }\n\n                dl + p + p {\n                    margin-top: 20px;\n                    \n                    * { display: inline-block; margin: 0; padding: 0; vertical-align: middle; }\n                    label {\n                        margin: 0;\n                        margin-left: 10px;\n                        font-family: \'Montserrat\';\n                        font-size: 12px;\n                        font-weight: 300;\n                        color: rgba(64, 55, 57, 1);\n                        letter-spacing: 0.04em;\n                    }\n                }\n\n                dl ~ button {\n                    margin: 0; margin-top: 24px; margin-left: -18px;\n                    background-color: rgba(60, 211, 207, 1);\n                    padding: 10px 50px 10px 43px;\n                    font-family: \'Montserrat\';\n                    font-size: 15px;\n                    color: rgba(255, 255, 255, 1);\n                    text-align: center;\n                    letter-spacing: 0.01em;\n                    border-radius: 20px;\n                    \n                    img {\n                        height: 18px;\n                        transform: rotate(90deg) translateY(-14px);\n                        filter: brightness(0) invert(1);\n                    }\n                }\n                // -- .card-info\n            }\n        }\n\n        .info {\n            dl {\n                display: inline-block;\n\n                .border-wrapper {\n                    position: relative;\n                    display: inline-flex;\n                    align-items: center;\n                    margin-top: 10px; margin-left: -12px;\n                    border: 1px solid rgba(151, 151, 151, 1);\n                    padding-left: 24px;\n                    line-height: 40px;\n                    border-radius: 20px;\n                 \n                    > * { margin: 0; padding: 0; }\n\n                    input:focus, input:active { outline-width: 0; }\n                    input[type=number]::-webkit-inner-spin-button, \n                    input[type=number]::-webkit-outer-spin-button { \n                        -webkit-appearance: none; \n                        margin: 0; \n                    }\n                    input {\n                        outline-width: 0;\n                        border-width: 0;\n                        min-width: none; min-width: auto; min-width: unset;\n                        background-color: transparent;\n                        z-index: 1; \n                    }\n                    input.not-empty + .placeholder { opacity: 0; }\n                    .placeholder {\n                        position: absolute;\n                        left: 24px;\n                        font-family: \'Montserrat\';\n                        font-size: 14px;\n                        color: rgba(147, 147, 147, 1);\n                        letter-spacing: 0.04em;\n                    }   \n                }\n            }\n\n            .card-info {\n                .remeber-card {\n                    font-family: \'Montserrat-Light\';\n                    color: rgba(147,147,147,1);\n                }\n            }\n        }\n\n        @media screen and (max-width: 767px) {\n            padding: 34px 16px 104px 16px;\n            \n            .info {\n                > * { padding-right: 15px; padding-left: 16px ; }\n                .app-header {\n                    padding-top: 18px;\n                    .app-stores span { display: block; }\n                    .app-stores span ~ img { margin-left: 0; margin-right: 7px; }\n                }\n                .promotion-code dl, .card-info dl {\n                    dt { text-indent: 2px; }\n                    .border-wrapper {\n                        margin-left: -8px;\n\n                        input { max-width: 50vw; }\n                        .placeholder { right: 72px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n                    }\n                }\n                .card-info {\n                    dl:not(:first-child) { margin-top: 32px; }\n                    dl:not(:last-of-type) { margin-left: 0; }\n                    dl:last-of-type { margin-left: 41px; }\n\n                    dl ~ button { margin-left: 36px; }\n                }\n            }\n        }\n        // -- .main\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var SplitFormWrapper = _styledComponents2.default.div(_templateObject);
	
	var OrderSummaryWrapper = _styledComponents2.default.div(_templateObject2);
	// export default WithDirection(OrderSummaryWrapper);
	exports.default = OrderSummaryWrapper;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    flex-grow: 1;\n    margin-right: 14px;\n\n    .app-info { display: flex; justify-content: flex-start; }\n    .app-info .app-icon-container { margin-right: 25px; min-width: 80px; width: 80px; height: 80px; }\n    .app-info .app-icon-container img { width: 100%; border-radius: 20px; }\n\n    .app-description { display: flex; flex-direction: column; justify-content: space-evenly; }\n    .app-description .app-name {\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n        text-transform: uppercase;\n    }\n\n    .app-stores {\n        display: flex;\n        align-items: center; \n        font-family: \'Roboto\';\n        font-size: 14px;\n        color: rgba(147, 147, 147, 1);\n        text-align: justify;\n        letter-spacing: 0.04em;\n    }\n    .app-stores .stores { margin-left: 14px; }\n    .app-stores .stores img:not(:first-child) { margin-left: 7px; }\n    .app-stores .stores img { width: 24px; height: 18px; }\n\n    @media screen and (max-width: 767px) {\n        margin-bottom: 30px;\n\n        .app-info .app-icon-container { margin-right: 11px; min-width: 70px; width: 70px; height: 70px; }\n\n        .app-description .app-name { line-height: 1; }\n\n        .app-stores { flex-wrap: wrap; }\n        .app-stores .stores { flex-grow: 1; margin-left: 0; }\n        .app-stores .stores img:not(:only-child) { margin-right: 7px; margin-left: 0;}\n    }\n'], ['\n    flex-grow: 1;\n    margin-right: 14px;\n\n    .app-info { display: flex; justify-content: flex-start; }\n    .app-info .app-icon-container { margin-right: 25px; min-width: 80px; width: 80px; height: 80px; }\n    .app-info .app-icon-container img { width: 100%; border-radius: 20px; }\n\n    .app-description { display: flex; flex-direction: column; justify-content: space-evenly; }\n    .app-description .app-name {\n        font-family: \'Montserrat\';\n        font-size: 22px;\n        font-weight: 300;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.09em;\n        text-transform: uppercase;\n    }\n\n    .app-stores {\n        display: flex;\n        align-items: center; \n        font-family: \'Roboto\';\n        font-size: 14px;\n        color: rgba(147, 147, 147, 1);\n        text-align: justify;\n        letter-spacing: 0.04em;\n    }\n    .app-stores .stores { margin-left: 14px; }\n    .app-stores .stores img:not(:first-child) { margin-left: 7px; }\n    .app-stores .stores img { width: 24px; height: 18px; }\n\n    @media screen and (max-width: 767px) {\n        margin-bottom: 30px;\n\n        .app-info .app-icon-container { margin-right: 11px; min-width: 70px; width: 70px; height: 70px; }\n\n        .app-description .app-name { line-height: 1; }\n\n        .app-stores { flex-wrap: wrap; }\n        .app-stores .stores { flex-grow: 1; margin-left: 0; }\n        .app-stores .stores img:not(:only-child) { margin-right: 7px; margin-left: 0;}\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Wrapper = __webpack_require__(1709);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _AU = __webpack_require__(569);
	
	var _AU2 = _interopRequireDefault(_AU);
	
	var _Canada = __webpack_require__(571);
	
	var _Canada2 = _interopRequireDefault(_Canada);
	
	var _CH = __webpack_require__(570);
	
	var _CH2 = _interopRequireDefault(_CH);
	
	var _GB = __webpack_require__(572);
	
	var _GB2 = _interopRequireDefault(_GB);
	
	var _MX = __webpack_require__(573);
	
	var _MX2 = _interopRequireDefault(_MX);
	
	var _NZ = __webpack_require__(574);
	
	var _NZ2 = _interopRequireDefault(_NZ);
	
	var _US = __webpack_require__(575);
	
	var _US2 = _interopRequireDefault(_US);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Styles
	
	
	// -- Resources
	
	
	var AppInfo = function (_React$Component) {
	    _inherits(AppInfo, _React$Component);
	
	    function AppInfo() {
	        _classCallCheck(this, AppInfo);
	
	        return _possibleConstructorReturn(this, (AppInfo.__proto__ || Object.getPrototypeOf(AppInfo)).apply(this, arguments));
	    }
	
	    _createClass(AppInfo, [{
	        key: "ConvertToPriceString",
	        value: function ConvertToPriceString(currency, price) {
	            if (price == null || price == undefined) return "-";
	            try {
	                if (parseInt(price) <= 0) return "Free";
	            } catch (ex) {}
	
	            if (currency) return currency + " " + price;
	            return price;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            return _react2.default.createElement(
	                _Wrapper2.default,
	                { className: "app-header" },
	                _react2.default.createElement(
	                    "div",
	                    { className: "app-info" },
	                    _react2.default.createElement(
	                        "div",
	                        { className: "app-icon-container" },
	                        _react2.default.createElement("img", { src: this.props.imgUrl })
	                    ),
	                    _react2.default.createElement(
	                        "div",
	                        { className: "app-description" },
	                        _react2.default.createElement(
	                            "div",
	                            { className: "app-name" },
	                            this.props.appName
	                        ),
	                        _react2.default.createElement(
	                            "div",
	                            { className: "app-stores" },
	                            "Apple App Store:",
	                            _react2.default.createElement(
	                                "div",
	                                { className: "stores" },
	                                _react2.default.createElement("img", { src: _AU2.default }),
	                                _react2.default.createElement("img", { src: _Canada2.default }),
	                                _react2.default.createElement("img", { src: _CH2.default }),
	                                _react2.default.createElement("img", { src: _GB2.default }),
	                                _react2.default.createElement("img", { src: _MX2.default }),
	                                _react2.default.createElement("img", { src: _NZ2.default }),
	                                _react2.default.createElement("img", { src: _US2.default })
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return AppInfo;
	}(_react2.default.Component);
	
	exports.default = AppInfo;
	;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 42px;\n    border-bottom: 1px solid rgba(219, 219, 219, 1);\n    padding-bottom: 34px;\n\n    .price {\n        font-family: \'Montserrat\';\n        font-size: 16px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n    }\n\n    @media screen and (max-width: 767px) {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n'], ['\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 42px;\n    border-bottom: 1px solid rgba(219, 219, 219, 1);\n    padding-bottom: 34px;\n\n    .price {\n        font-family: \'Montserrat\';\n        font-size: 16px;\n        color: rgba(64, 55, 57, 1);\n        text-align: left;\n        letter-spacing: 0.08em;\n        text-transform: uppercase;\n    }\n\n    @media screen and (max-width: 767px) {\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var StyleWrapper = _styledComponents2.default.div(_templateObject);
	
	exports.default = (0, _withDirection2.default)(StyleWrapper);

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(1710);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Wrapper = __webpack_require__(1711);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // -- React Libraries
	
	
	// -- Components
	
	
	// -- Styles
	
	
	var OrderSummary = function (_React$Component) {
	  _inherits(OrderSummary, _React$Component);
	
	  function OrderSummary() {
	    _classCallCheck(this, OrderSummary);
	
	    return _possibleConstructorReturn(this, (OrderSummary.__proto__ || Object.getPrototypeOf(OrderSummary)).apply(this, arguments));
	  }
	
	  _createClass(OrderSummary, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _Wrapper2.default,
	        { className: "order-summary" },
	        _react2.default.createElement(_index2.default, {
	          appName: this.props.appName,
	          imgUrl: this.props.imgUrl
	        }),
	        _react2.default.createElement(
	          "div",
	          { className: "price" },
	          "Total Amount: $ ",
	          this.props.price
	        )
	      );
	    }
	  }]);
	
	  return OrderSummary;
	}(_react2.default.Component);
	
	exports.default = OrderSummary;
	;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _redux = __webpack_require__(56);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _index = __webpack_require__(214);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Logo = __webpack_require__(173);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _Menu = __webpack_require__(213);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _index3 = __webpack_require__(212);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(1712);
	
	var _index6 = _interopRequireDefault(_index5);
	
	var _style = __webpack_require__(1714);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _basicStyle = __webpack_require__(106);
	
	var _basicStyle2 = _interopRequireDefault(_basicStyle);
	
	var _arrow_white = __webpack_require__(3299);
	
	var _arrow_white2 = _interopRequireDefault(_arrow_white);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// -- React Libraries
	
	
	// -- Libraries
	
	
	var appSelected = _actions2.default.appSelected,
	    searchTermUpdated = _actions2.default.searchTermUpdated;
	
	// -- Components
	
	
	// -- Styles
	
	
	// -- Resources
	
	var OrderSuccess = function (_Component) {
	  _inherits(OrderSuccess, _Component);
	
	  function OrderSuccess(props) {
	    _classCallCheck(this, OrderSuccess);
	
	    var _this = _possibleConstructorReturn(this, (OrderSuccess.__proto__ || Object.getPrototypeOf(OrderSuccess)).call(this, props));
	
	    _this.state = {
	      stripe: null
	    };
	    return _this;
	  }
	
	  _createClass(OrderSuccess, [{
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      console.log(' componentWillUpdate');
	      //check difference
	    }
	  }, {
	    key: 'createCampaignFake',
	    value: function createCampaignFake(campaign) {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      console.log(this.props);
	
	      var appDetail = this.state.appDetail;
	      var _props = this.props,
	          searchTerm = _props.searchTerm,
	          campaign = _props.campaign,
	          currentApp = _props.currentApp,
	          secondApp = _props.secondApp;
	      var rowStyle = _basicStyle2.default.rowStyle,
	          colStyle = _basicStyle2.default.colStyle;
	
	
	      return _react2.default.createElement(
	        _style2.default,
	        { className: 'page-wrapper' },
	        _react2.default.createElement(
	          _index2.default,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(_Logo2.default, { isClickable: true, history: this.props.history }),
	            _react2.default.createElement(_Menu2.default, { history: this.props.history, auth: this.props.auth })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'header-row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'subtitle' },
	              'Thank you, your payment was successful.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'content-wrapper' },
	            _react2.default.createElement(_index6.default, {
	              appName: 'Starbucks app',
	              imgUrl: 'https://is3-ssl.mzstatic.com/image/thumb/Purple125/v4/ed/f9/b8/edf9b88a-ee19-6028-e7f3-6aceebef61b5/source/100x100bb.jpg',
	              price: 82.87
	            }),
	            _react2.default.createElement(
	              'div',
	              { className: 'message' },
	              'A receipt will be sent to your email shortly.'
	            ),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'order-callback',
	                  onClick: function onClick() {
	                    _this2.props.history.push("/dashboard");
	                  }
	                },
	                'View campaign performance',
	                _react2.default.createElement('img', { src: _arrow_white2.default })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_index4.default, null)
	      );
	    }
	  }]);
	
	  return OrderSuccess;
	}(_react.Component);
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setApp: function setApp(app) {
	      return dispatch(appSelected(app));
	    },
	    appSelected: (0, _redux.bindActionCreators)(appSelected, dispatch),
	    searchTermUpdated: (0, _redux.bindActionCreators)(searchTermUpdated, dispatch)
	
	  };
	}
	function mapStateToProps(state) {
	  var campaign = state.get('deep').campaign;
	  return {
	    search: state.get('search'),
	    campaign: campaign,
	    currentApp: state.getIn(['App', 'currentApp']),
	    secondApp: state.getIn(['App', 'secondApp']),
	    searchTerm: state.getIn(['App', 'searchTerm'])
	
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(OrderSuccess);

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    .subtitle {\n        flex-grow: 1;\n        margin-top: 14px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(219, 219, 219, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n    }\n\n    .header-wrapper + * { align-items: center; }\n    .content-wrapper {\n        width: 893px;\n        padding: 42px 39px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n\n    .message {\n        font-family: \'Montserrat\';\n        font-size: 16px;\n        color: rgba(147, 147, 147, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n    }\n\n    button {\n        display: flex;\n        align-items: center;\n        margin: 0 auto;\n        margin-top: 42px;\n        padding: 7px 21px;\n        background-color: rgba(60, 211, 207, 1);\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n        text-transform: uppercase;\n        border-radius: 21px;\n    }\n    button img { margin-left: 7px; width: 21px; height: auto; }\n\n    @media screen and (max-width: 767px) {\n        .content-wrapper {\n            margin: 0 15px;\n            width: auto;\n            padding: 18px 16px;\n        }\n\n        button { padding: 7px 14px; }\n    }\n'], ['\n    .subtitle {\n        flex-grow: 1;\n        margin-top: 14px;\n        font-family: \'Montserrat\';\n        font-size: 14px;\n        font-weight: 300;\n        color: rgba(219, 219, 219, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n    }\n\n    .header-wrapper + * { align-items: center; }\n    .content-wrapper {\n        width: 893px;\n        padding: 42px 39px;\n        background-color: rgba(255, 255, 255, 1);\n    }\n\n    .message {\n        font-family: \'Montserrat\';\n        font-size: 16px;\n        color: rgba(147, 147, 147, 1);\n        text-align: center;\n        letter-spacing: 0.08em;\n    }\n\n    button {\n        display: flex;\n        align-items: center;\n        margin: 0 auto;\n        margin-top: 42px;\n        padding: 7px 21px;\n        background-color: rgba(60, 211, 207, 1);\n        font-family: \'Montserrat\';\n        font-size: 15px;\n        color: rgba(255, 255, 255, 1);\n        text-align: center;\n        letter-spacing: 0.01em;\n        text-transform: uppercase;\n        border-radius: 21px;\n    }\n    button img { margin-left: 7px; width: 21px; height: auto; }\n\n    @media screen and (max-width: 767px) {\n        .content-wrapper {\n            margin: 0 15px;\n            width: auto;\n            padding: 18px 16px;\n        }\n\n        button { padding: 7px 14px; }\n    }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	exports.default = (0, _withDirection2.default)(_styledComponents2.default.div(_templateObject));

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(157);
	
	var _server = __webpack_require__(61);
	
	var _reactSearch = __webpack_require__(1289);
	
	var _reactSearch2 = _interopRequireDefault(_reactSearch);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Ping = function (_Component) {
	  _inherits(Ping, _Component);
	
	  function Ping(props) {
	    _classCallCheck(this, Ping);
	
	    var _this = _possibleConstructorReturn(this, (Ping.__proto__ || Object.getPrototypeOf(Ping)).call(this, props));
	
	    _this.state = { repos: [] };
	    return _this;
	  }
	
	  _createClass(Ping, [{
	    key: 'HiItems',
	    value: function HiItems(items) {
	      console.log(items);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ message: '' });
	    }
	  }, {
	    key: 'ping',
	    value: function ping() {
	      var _this2 = this;
	
	      _axios2.default.get(_server.API_URL + '/public').then(function (response) {
	        return _this2.setState({ message: response.data.message });
	      }).catch(function (error) {
	        return _this2.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'securedPing',
	    value: function securedPing() {
	      var _this3 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.get(_server.API_URL + '/searchads', { headers: headers }).then(function (response) {
	        return _this3.setState({ message: JSON.parse(response.data.message) });
	      }).catch(function (error) {
	        return _this3.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'getItemsAsync',
	    value: function getItemsAsync(searchValue, cb) {
	      var _this4 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.get(_server.API_URL + '/searchads/search/apps', { params: { searchValue: searchValue }, headers: headers }).then(function (response) {
	        if (response.data != undefined) {
	          var itemData = JSON.parse(response.data).data;
	          console.log(itemData);
	          var items = itemData.map(function (res, i) {
	            return { id: i, value: res.appName + ' ---- ' + res.developerName };
	          });
	          console.log(' items ', items);
	
	          _this4.setState({ repos: items });
	          cb(searchValue);
	        }
	        // this.setState({ message: JSON.parse(response.data.message) })
	      }).catch(function (error) {
	        return _this4.setState({ message: error.message });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var isAuthenticated = this.props.auth.isAuthenticated;
	      var message = this.state.message;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Make a Call to the Server'
	        ),
	        !isAuthenticated() && _react2.default.createElement(
	          'p',
	          null,
	          'Log in to call a private (secured) server endpoint.'
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', onClick: this.ping.bind(this) },
	          'Ping'
	        ),
	        ' ',
	        isAuthenticated() && _react2.default.createElement(
	          _reactBootstrap.Button,
	          { bsStyle: 'primary', onClick: this.securedPing.bind(this) },
	          'Call Private'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          message
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactSearch2.default, { items: this.state.repos,
	            multiple: false,
	            getItemsAsync: this.getItemsAsync.bind(this),
	            onItemsChanged: this.HiItems.bind(this) })
	        )
	      );
	    }
	  }]);
	
	  return Ping;
	}(_react.Component);
	
	exports.default = Ping;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__(157);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _server = __webpack_require__(61);
	
	var _server2 = _interopRequireDefault(_server);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _style = __webpack_require__(1717);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Profile = function (_Component) {
	  _inherits(Profile, _Component);
	
	  function Profile() {
	    _classCallCheck(this, Profile);
	
	    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
	  }
	
	  _createClass(Profile, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.setState({ profile: {} });
	      var _props$auth = this.props.auth,
	          userProfile = _props$auth.userProfile,
	          getProfile = _props$auth.getProfile;
	
	      if (!userProfile) {
	        getProfile(function (err, profile) {
	          _this2.setState({ profile: profile });
	        });
	      } else {
	        this.setState({ profile: userProfile });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var getAccessToken = this.props.auth.getAccessToken;
	
	      var headers = { 'Authorization': 'Bearer ' + getAccessToken() };
	      _axios2.default.get(_server2.default + '/user/campaigns', { headers: headers }).then(function (response) {
	        // const raw_data = response.data;
	        // console.log(response.data);
	
	        var campaignList = response.data;
	        _this3.setState({ campaignList: campaignList });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          profile = _state.profile,
	          campaignList = _state.campaignList;
	
	      console.log(this.state.campaignList);
	      var content = _react2.default.createElement('div', null);
	      // If we have budgetSplit, render them
	      if (campaignList) {
	        content = campaignList.map(function (item) {
	          console.log(item);
	
	          if (item && item.searchAdsIds.length > 0) {
	            console.log(item.searchAdsIds);
	
	            return _react2.default.createElement(
	              'section',
	              null,
	              _react2.default.createElement(
	                'div',
	                null,
	                ' App Name Ref:',
	                item.startTime
	              ),
	              item.searchAdsIds.map(function (campaignID) {
	                return _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _reactRouterDom.Link,
	                    { key: campaignID, to: '/campaign/' + campaignID },
	                    'Go to campaign Detail : ',
	                    campaignID
	                  )
	                );
	              })
	            );
	          } else if (item && item.searchAdsCampaign) {
	            var campaignID = item.searchAdsCampaign;
	            console.log(campaignID);
	
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouterDom.Link,
	                { key: campaignID, to: '/campaign/' + campaignID },
	                'Go to campaign Detail : ',
	                campaignID
	              )
	            );
	          } else {
	            return _react2.default.createElement(
	              'div',
	              null,
	              'dd'
	            );
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'profile-area' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            profile.name
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { header: 'Profile' },
	            _react2.default.createElement('img', { src: profile.picture, alt: 'profile' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactBootstrap.ControlLabel,
	                null,
	                _react2.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'user' }),
	                ' Nickname'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                profile.nickname
	              )
	            ),
	            _react2.default.createElement(
	              'pre',
	              null,
	              JSON.stringify(profile, null, 2)
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Panel,
	            { header: 'Campaign' },
	            _react2.default.createElement(
	              'div',
	              null,
	              content
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Profile;
	}(_react.Component);
	
	exports.default = Profile;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .profile-area img {\n    max-width: 150px;\n    margin-bottom: 20px;\n  }\n\n  .panel-body h3 {\n    margin-top: 0;\n  }\n'], ['\n  .profile-area img {\n    max-width: 150px;\n    margin-bottom: 20px;\n  }\n\n  .panel-body h3 {\n    margin-top: 0;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _withDirection = __webpack_require__(17);
	
	var _withDirection2 = _interopRequireDefault(_withDirection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var ProfileWrapper = _styledComponents2.default.div(_templateObject);
	// export default WithDirection(OrderSummaryWrapper);
	exports.default = ProfileWrapper;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tableinfos = exports.columns = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(288);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _intlMessages = __webpack_require__(1639);
	
	var _intlMessages2 = _interopRequireDefault(_intlMessages);
	
	var _helperCells = __webpack_require__(749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderCell = function renderCell(object, type, key) {
	  var value = object[key];
	  switch (type) {
	    case 'ImageCell':
	      return (0, _helperCells.ImageCell)(value);
	    case 'DateCell':
	      return (0, _helperCells.DateCell)(value);
	    case 'LinkCell':
	      return (0, _helperCells.LinkCell)(value);
	    default:
	      return (0, _helperCells.TextCell)(value);
	  }
	};
	
	var columns = [{
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.image' }),
	  key: 'avatar',
	  width: '1%',
	  className: 'isoImageCell',
	  render: function render(object) {
	    return renderCell(object, 'ImageCell', 'avatar');
	  }
	}, {
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.firstName' }),
	  key: 'firstName',
	  width: 100,
	  render: function render(object) {
	    return renderCell(object, 'TextCell', 'firstName');
	  }
	}, {
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.lastName' }),
	  key: 'lastName',
	  width: 100,
	  render: function render(object) {
	    return renderCell(object, 'TextCell', 'lastName');
	  }
	}, {
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.city' }),
	  key: 'city',
	  width: 200,
	  render: function render(object) {
	    return renderCell(object, 'TextCell', 'city');
	  }
	}, {
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.street' }),
	  key: 'street',
	  width: 200,
	  render: function render(object) {
	    return renderCell(object, 'TextCell', 'street');
	  }
	}, {
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.email' }),
	  key: 'email',
	  width: 200,
	  render: function render(object) {
	    return renderCell(object, 'LinkCell', 'email');
	  }
	}, {
	  title: _react2.default.createElement(_intlMessages2.default, { id: 'antTable.title.dob' }),
	  key: 'date',
	  width: 200,
	  render: function render(object) {
	    return renderCell(object, 'DateCell', 'date');
	  }
	}];
	var smallColumns = [columns[1], columns[2], columns[3], columns[4]];
	var sortColumns = [Object.assign({}, columns[1], { sorter: true }), Object.assign({}, columns[2], { sorter: true }), Object.assign({}, columns[3], { sorter: true }), Object.assign({}, columns[4], { sorter: true })];
	var editColumns = [Object.assign({}, columns[1], { width: 300 }), Object.assign({}, columns[2], { width: 300 }), columns[3], columns[4]];
	var groupColumns = [columns[0], {
	  title: 'Name',
	  children: [columns[1], columns[2]]
	}, {
	  title: 'Address',
	  children: [columns[3], columns[4]]
	}];
	var tableinfos = [{
	  title: 'Simple Table',
	  value: 'simple',
	  columns: (0, _clone2.default)(smallColumns)
	}, {
	  title: 'Sortable Table',
	  value: 'sortView',
	  columns: (0, _clone2.default)(sortColumns)
	}, {
	  title: 'Search Text',
	  value: 'filterView',
	  columns: (0, _clone2.default)(smallColumns)
	}, {
	  title: 'Editable View',
	  value: 'editView',
	  columns: (0, _clone2.default)(editColumns)
	}, {
	  title: 'Grouping View',
	  value: 'groupView',
	  columns: (0, _clone2.default)(groupColumns)
	}, {
	  title: 'Customized View',
	  value: 'customizedView',
	  columns: (0, _clone2.default)(columns)
	}];
	exports.columns = columns;
	exports.tableinfos = tableinfos;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  .ant-tabs-content {\n    margin-top: 40px;\n  }\n\n  .ant-tabs-nav {\n    > div {\n      color: ', ';\n\n      &.ant-tabs-ink-bar {\n        background-color: ', ';\n      }\n\n      &.ant-tabs-tab-active {\n        color: ', ';\n      }\n    }\n  }\n'], ['\n  .ant-tabs-content {\n    margin-top: 40px;\n  }\n\n  .ant-tabs-nav {\n    > div {\n      color: ', ';\n\n      &.ant-tabs-ink-bar {\n        background-color: ', ';\n      }\n\n      &.ant-tabs-tab-active {\n        color: ', ';\n      }\n    }\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var TableDemoStyle = _styledComponents2.default.div(_templateObject, (0, _styledTheme.palette)('secondary', 2), (0, _styledTheme.palette)('primary', 0), (0, _styledTheme.palette)('primary', 0));
	
	exports.default = TableDemoStyle;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PendingPool = {};
	var ReadyPool = {};
	
	var ImageCell = function (_Component) {
	  _inherits(ImageCell, _Component);
	
	  function ImageCell(props) {
	    _classCallCheck(this, ImageCell);
	
	    var _this = _possibleConstructorReturn(this, (ImageCell.__proto__ || Object.getPrototypeOf(ImageCell)).call(this, props));
	
	    _this.loadImage = _this.loadImage.bind(_this);
	    _this.onLoadImage = _this.onLoadImage.bind(_this);
	    _this.state = {
	      ready: false
	    };
	    return _this;
	  }
	
	  _createClass(ImageCell, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadImage(this.props.src);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.src !== this.props.src) {
	        this.setState({ src: null });
	        this.loadImage(nextProps.src);
	      }
	    }
	  }, {
	    key: 'loadImage',
	    value: function loadImage(src) {
	      if (ReadyPool[src]) {
	        this.setState({ src: src });
	        return;
	      }
	
	      if (PendingPool[src]) {
	        PendingPool[src].push(this.onLoadImage);
	        return;
	      }
	      PendingPool[src] = [this.onLoadImage];
	
	      var img = new Image();
	      img.onload = function () {
	        PendingPool[src].forEach(function (callback) {
	          callback(src);
	        });
	        delete PendingPool[src];
	        img.onload = null;
	        src = undefined;
	      };
	      img.src = src;
	    }
	  }, {
	    key: 'onLoadImage',
	    value: function onLoadImage(src) {
	      ReadyPool[src] = true;
	      if (src === this.props.src) {
	        this.setState({
	          src: src
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var style = this.state.src ? {
	        backgroundImage: 'url(' + this.state.src + ')',
	        width: '70px',
	        height: '70px',
	        backgroundSize: 'cover'
	      } : undefined;
	      return _react2.default.createElement('div', { className: 'exampleImage', style: style });
	    }
	  }]);
	
	  return ImageCell;
	}(_react.Component);
	
	exports.default = ImageCell;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dataList = exports.tableinfos = exports.TableViews = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tabs = __webpack_require__(1633);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	var _layoutWrapper = __webpack_require__(1640);
	
	var _layoutWrapper2 = _interopRequireDefault(_layoutWrapper);
	
	var _demo = __webpack_require__(1719);
	
	var _demo2 = _interopRequireDefault(_demo);
	
	var _fakeData = __webpack_require__(1729);
	
	var _fakeData2 = _interopRequireDefault(_fakeData);
	
	var _configs = __webpack_require__(1718);
	
	var _tableViews = __webpack_require__(1726);
	
	var TableViews = _interopRequireWildcard(_tableViews);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var dataList = new _fakeData2.default(10);
	
	var AntTable = function (_Component) {
	  _inherits(AntTable, _Component);
	
	  function AntTable() {
	    _classCallCheck(this, AntTable);
	
	    return _possibleConstructorReturn(this, (AntTable.__proto__ || Object.getPrototypeOf(AntTable)).apply(this, arguments));
	  }
	
	  _createClass(AntTable, [{
	    key: 'renderTable',
	    value: function renderTable(tableInfo) {
	      var Component = void 0;
	      switch (tableInfo.value) {
	        case 'sortView':
	          Component = TableViews.SortView;
	          break;
	        case 'filterView':
	          Component = TableViews.FilterView;
	          break;
	        case 'editView':
	          Component = TableViews.EditView;
	          break;
	        case 'groupView':
	          Component = TableViews.GroupView;
	          break;
	        case 'customizedView':
	          Component = TableViews.CustomizedView;
	          break;
	        default:
	          Component = TableViews.SimpleView;
	      }
	      return _react2.default.createElement(Component, { tableInfo: tableInfo, dataList: dataList });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _layoutWrapper2.default,
	        null,
	        _react2.default.createElement(
	          _demo2.default,
	          { className: 'isoLayoutContent' },
	          _react2.default.createElement(
	            _tabs2.default,
	            { className: 'isoTableDisplayTab' },
	            _configs.tableinfos.map(function (tableInfo) {
	              return _react2.default.createElement(
	                _tabs.TabPane,
	                { tab: tableInfo.title, key: tableInfo.value },
	                _this2.renderTable(tableInfo)
	              );
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return AntTable;
	}(_react.Component);
	
	exports.default = AntTable;
	exports.TableViews = TableViews;
	exports.tableinfos = _configs.tableinfos;
	exports.dataList = dataList;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antTable = __webpack_require__(174);
	
	var _antTable2 = _interopRequireDefault(_antTable);
	
	var _switch = __webpack_require__(1631);
	
	var _switch2 = _interopRequireDefault(_switch);
	
	var _form = __webpack_require__(1622);
	
	var _form2 = _interopRequireDefault(_form);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _form2.default.Item;
	
	var expandedRowRender = function expandedRowRender(record) {
	  return _react2.default.createElement(
	    'p',
	    null,
	    record.firstName + ' lives in ' + record.city
	  );
	};
	var title = function title() {
	  return 'Here is title';
	};
	var showHeader = true;
	var footer = function footer() {
	  return 'Here is footer';
	};
	var scroll = { y: 240 };
	
	var toggleOptions = [{
	  defaultValue: true,
	  title: 'Bordered',
	  key: 'bordered'
	}, {
	  defaultValue: true,
	  title: 'Loading',
	  key: 'loading'
	}, {
	  defaultValue: true,
	  title: 'Pagination',
	  key: 'pagination'
	}, {
	  defaultValue: title,
	  title: 'Title',
	  key: 'title'
	}, {
	  defaultValue: showHeader,
	  title: 'Show Header',
	  key: 'showHeader'
	}, {
	  defaultValue: footer,
	  title: 'Footer',
	  key: 'footer'
	}, {
	  defaultValue: expandedRowRender,
	  title: 'Expanded Row Render',
	  key: 'expandedRowRender'
	}, {
	  defaultValue: {},
	  title: 'Checkbox',
	  key: 'rowSelection'
	}, {
	  defaultValue: scroll,
	  title: 'Scrollable',
	  key: 'scroll'
	}];
	
	var CustomizedView = function (_Component) {
	  _inherits(CustomizedView, _Component);
	
	  function CustomizedView(props) {
	    _classCallCheck(this, CustomizedView);
	
	    var _this = _possibleConstructorReturn(this, (CustomizedView.__proto__ || Object.getPrototypeOf(CustomizedView)).call(this, props));
	
	    _this.renderSwitch = _this.renderSwitch.bind(_this);
	    _this.state = {
	      bordered: undefined,
	      loading: undefined,
	      pagination: true,
	      size: 'default',
	      expandedRowRender: expandedRowRender,
	      title: title,
	      showHeader: showHeader,
	      footer: footer,
	      rowSelection: {},
	      scroll: undefined
	    };
	    return _this;
	  }
	
	  _createClass(CustomizedView, [{
	    key: 'renderSwitch',
	    value: function renderSwitch(option) {
	      var _this2 = this;
	
	      var checked = this.state[option.key] !== undefined;
	      var onChange = function onChange() {
	        if (!checked) {
	          _this2.setState(_defineProperty({}, option.key, option.defaultValue));
	        } else {
	          _this2.setState(_defineProperty({}, option.key, undefined));
	        }
	      };
	      return _react2.default.createElement(
	        FormItem,
	        { label: option.title, key: option.key },
	        _react2.default.createElement(_switch2.default, { checked: checked, onChange: onChange })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(
	        _antTable.CustomizedTableWrapper,
	        { className: 'isoCustomizedTableWrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'isoCustomizedTableControlBar' },
	          _react2.default.createElement(
	            _form2.default,
	            { layout: 'inline' },
	            toggleOptions.map(function (option) {
	              return _this3.renderSwitch(option);
	            })
	          )
	        ),
	        _react2.default.createElement(_antTable2.default, Object.assign({}, this.state, {
	          columns: this.props.tableInfo.columns,
	          dataSource: this.props.dataList.getAll(),
	          className: 'isoCustomizedTable'
	        }))
	      );
	    }
	  }]);
	
	  return CustomizedView;
	}(_react.Component);
	
	exports.default = CustomizedView;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _clone = __webpack_require__(288);
	
	var _clone2 = _interopRequireDefault(_clone);
	
	var _antTable = __webpack_require__(174);
	
	var _antTable2 = _interopRequireDefault(_antTable);
	
	var _helperCells = __webpack_require__(749);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CustomizedView = function (_Component) {
	  _inherits(CustomizedView, _Component);
	
	  function CustomizedView(props) {
	    _classCallCheck(this, CustomizedView);
	
	    var _this = _possibleConstructorReturn(this, (CustomizedView.__proto__ || Object.getPrototypeOf(CustomizedView)).call(this, props));
	
	    _this.onDeleteCell = function (index) {
	      var dataList = _this.state.dataList;
	
	      dataList.splice(index, 1);
	      _this.setState({ dataList: dataList });
	    };
	
	    _this.onCellChange = _this.onCellChange.bind(_this);
	    _this.onDeleteCell = _this.onDeleteCell.bind(_this);
	    _this.state = {
	      columns: _this.createcolumns((0, _clone2.default)(_this.props.tableInfo.columns)),
	      dataList: _this.props.dataList.getAll()
	    };
	    return _this;
	  }
	
	  _createClass(CustomizedView, [{
	    key: 'createcolumns',
	    value: function createcolumns(columns) {
	      var _this2 = this;
	
	      var editColumnRender = function editColumnRender(text, record, index) {
	        return _react2.default.createElement(_helperCells.EditableCell, {
	          index: index,
	          columnsKey: columns[0].key,
	          value: text[columns[0].key],
	          onChange: _this2.onCellChange
	        });
	      };
	      columns[0].render = editColumnRender;
	      var deleteColumn = {
	        title: 'operation',
	        dataIndex: 'operation',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(_helperCells.DeleteCell, { index: index, onDeleteCell: _this2.onDeleteCell });
	        }
	      };
	      columns.push(deleteColumn);
	      return columns;
	    }
	  }, {
	    key: 'onCellChange',
	    value: function onCellChange(value, columnsKey, index) {
	      var dataList = this.state.dataList;
	
	      dataList[index][columnsKey] = value;
	      this.setState({ dataList: dataList });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          columns = _state.columns,
	          dataList = _state.dataList;
	
	
	      return _react2.default.createElement(_antTable2.default, {
	        columns: columns,
	        dataSource: dataList,
	        className: 'isoEditableTable'
	      });
	    }
	  }]);
	
	  return CustomizedView;
	}(_react.Component);
	
	exports.default = CustomizedView;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(43);
	
	var _input = __webpack_require__(1623);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _button = __webpack_require__(394);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _antTable = __webpack_require__(174);
	
	var _antTable2 = _interopRequireDefault(_antTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FilterView = function (_Component) {
	  _inherits(FilterView, _Component);
	
	  function FilterView(props) {
	    _classCallCheck(this, FilterView);
	
	    var _this = _possibleConstructorReturn(this, (FilterView.__proto__ || Object.getPrototypeOf(FilterView)).call(this, props));
	
	    _this.onSearch = _this.onSearch.bind(_this);
	    _this.onInputChange = _this.onInputChange.bind(_this);
	    _this.state = {
	      dataList: _this.props.dataList.getAll(),
	      filterDropdownVisible: false,
	      searchText: '',
	      filtered: false
	    };
	    return _this;
	  }
	
	  _createClass(FilterView, [{
	    key: 'onSearch',
	    value: function onSearch() {
	      var searchText = this.state.searchText;
	
	      searchText = searchText.toUpperCase();
	      var dataList = this.props.dataList.getAll().filter(function (data) {
	        return data['firstName'].toUpperCase().includes(searchText);
	      });
	      this.setState({
	        dataList: dataList,
	        filterDropdownVisible: false,
	        searchText: '',
	        filtered: false
	      });
	    }
	  }, {
	    key: 'onInputChange',
	    value: function onInputChange(event) {
	      this.setState({ searchText: event.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var filterDropdown = _react2.default.createElement(
	        'div',
	        { className: 'isoTableSearchBox' },
	        _react2.default.createElement(_input2.default, {
	          id: 'tableFilterInput',
	          ref: function ref(ele) {
	            return _this2.searchInput = ele;
	          },
	          placeholder: 'Search name',
	          value: this.state.searchText,
	          onChange: this.onInputChange,
	          onPressEnter: this.onSearch
	        }),
	        _react2.default.createElement(
	          _button2.default,
	          { type: 'primary', onClick: this.onSearch },
	          'Search'
	        )
	      );
	      var columns = this.props.tableInfo.columns;
	      columns[0] = Object.assign({}, columns[0], {
	        filterDropdown: filterDropdown,
	        filterIcon: _react2.default.createElement(_antd.Icon, {
	          type: 'search',
	          style: { color: this.state.filtered ? '#108ee9' : '#aaa' }
	        }),
	        filterDropdownVisible: this.state.filterDropdownVisible,
	        onFilterDropdownVisibleChange: function onFilterDropdownVisibleChange(visible) {
	          return _this2.setState({ filterDropdownVisible: visible }, function () {
	            return document.getElementById('tableFilterInput').focus();
	          });
	        }
	      });
	      return _react2.default.createElement(_antTable2.default, {
	        columns: columns,
	        onChange: this.onChange,
	        dataSource: this.state.dataList,
	        className: 'isoSearchableTable'
	      });
	    }
	  }]);
	
	  return FilterView;
	}(_react.Component);
	
	exports.default = FilterView;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antTable = __webpack_require__(174);
	
	var _antTable2 = _interopRequireDefault(_antTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GroupView = function (_Component) {
	  _inherits(GroupView, _Component);
	
	  function GroupView() {
	    _classCallCheck(this, GroupView);
	
	    return _possibleConstructorReturn(this, (GroupView.__proto__ || Object.getPrototypeOf(GroupView)).apply(this, arguments));
	  }
	
	  _createClass(GroupView, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antTable2.default, {
	        columns: this.props.tableInfo.columns,
	        dataSource: this.props.dataList.getAll(),
	        className: 'isoGroupTable'
	      });
	    }
	  }]);
	
	  return GroupView;
	}(_react.Component);
	
	exports.default = GroupView;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditView = exports.GroupView = exports.FilterView = exports.CustomizedView = exports.SortView = exports.SimpleView = undefined;
	
	var _customizedView = __webpack_require__(1722);
	
	var _customizedView2 = _interopRequireDefault(_customizedView);
	
	var _simpleView = __webpack_require__(1727);
	
	var _simpleView2 = _interopRequireDefault(_simpleView);
	
	var _sortView = __webpack_require__(1728);
	
	var _sortView2 = _interopRequireDefault(_sortView);
	
	var _filterView = __webpack_require__(1724);
	
	var _filterView2 = _interopRequireDefault(_filterView);
	
	var _groupView = __webpack_require__(1725);
	
	var _groupView2 = _interopRequireDefault(_groupView);
	
	var _editView = __webpack_require__(1723);
	
	var _editView2 = _interopRequireDefault(_editView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.SimpleView = _simpleView2.default;
	exports.SortView = _sortView2.default;
	exports.CustomizedView = _customizedView2.default;
	exports.FilterView = _filterView2.default;
	exports.GroupView = _groupView2.default;
	exports.EditView = _editView2.default;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antTable = __webpack_require__(174);
	
	var _antTable2 = _interopRequireDefault(_antTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleView = function (_Component) {
	  _inherits(SimpleView, _Component);
	
	  function SimpleView() {
	    _classCallCheck(this, SimpleView);
	
	    return _possibleConstructorReturn(this, (SimpleView.__proto__ || Object.getPrototypeOf(SimpleView)).apply(this, arguments));
	  }
	
	  _createClass(SimpleView, [{
	    key: 'render',
	    value: function render() {
	      var dataSource = this.props.dataSource || this.props.dataList.getAll();
	      var columns = this.props.columns || this.props.tableInfo.columns;
	      return _react2.default.createElement(_antTable2.default, {
	        pagination: false,
	        columns: columns,
	        dataSource: dataSource,
	        className: 'isoSimpleTable'
	      });
	    }
	  }]);
	
	  return SimpleView;
	}(_react.Component);
	
	exports.default = SimpleView;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antTable = __webpack_require__(174);
	
	var _antTable2 = _interopRequireDefault(_antTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SortView = function (_Component) {
	  _inherits(SortView, _Component);
	
	  function SortView(props) {
	    _classCallCheck(this, SortView);
	
	    var _this = _possibleConstructorReturn(this, (SortView.__proto__ || Object.getPrototypeOf(SortView)).call(this, props));
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.state = {
	      dataList: _this.props.dataList.getAll()
	    };
	    return _this;
	  }
	
	  _createClass(SortView, [{
	    key: 'onChange',
	    value: function onChange(pagination, filters, sorter) {
	      var dataList = this.props.dataList;
	
	      if (sorter && sorter.columnKey && sorter.order) {
	        if (sorter.order === 'ascend') {
	          dataList.getSortAsc(sorter.columnKey);
	        } else {
	          dataList.getSortDesc(sorter.columnKey);
	        }
	        this.setState({ dataList: dataList.getAll() });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antTable2.default, {
	        columns: this.props.tableInfo.columns,
	        onChange: this.onChange,
	        dataSource: this.state.dataList,
	        className: 'isoSortingTable'
	      });
	    }
	  }]);
	
	  return SortView;
	}(_react.Component);
	
	exports.default = SortView;

/***/ },
/* 1729 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var tableData = JSON.parse('[{\n  "id": 0,\n  "key": 0,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/bluefx_/128.jpg",\n  "city": "Lake Zelda",\n  "email": "Lonny79@hotmail.com",\n  "firstName": "Emelia",\n  "lastName": "Gislason",\n  "street": "Kulas Shoals",\n  "zipCode": "52677",\n  "date": "2016-09-27T08:18:56.302Z",\n  "bs": "back-end optimize e-markets",\n  "catchPhrase": "Devolved heuristic focus group",\n  "companyName": "Kessler LLC",\n  "words": "dignissimos et natus",\n  "sentence": "Illum molestiae saepe eaque odit magnam veritatis eligendi est qui."\n}, {\n  "id": 1,\n  "key": 1,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/jnmnrd/128.jpg",\n  "city": "East Pierce",\n  "email": "Lucinda_Gottlieb@hotmail.com",\n  "firstName": "Cloyd",\n  "lastName": "Armstrong",\n  "street": "Lyla Heights",\n  "zipCode": "64903",\n  "date": "2016-10-08T06:30:16.347Z",\n  "bs": "seamless mesh vortals",\n  "catchPhrase": "Managed background migration",\n  "companyName": "Doyle and Sons",\n  "words": "voluptatum dignissimos possimus",\n  "sentence": "Aut similique a qui."\n}, {\n  "id": 2,\n  "key": 2,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/damenleeturks/128.jpg",\n  "city": "Sibylside",\n  "email": "Ransom.Bergstrom@gmail.com",\n  "firstName": "Rahul",\n  "lastName": "Funk",\n  "street": "Jolie Shoals",\n  "zipCode": "46659",\n  "date": "2017-05-16T02:02:32.105Z",\n  "bs": "bleeding-edge enhance e-commerce",\n  "catchPhrase": "Public-key intermediate hardware",\n  "companyName": "Champlin and Sons",\n  "words": "est est corrupti",\n  "sentence": "Qui consequatur aut dignissimos error qui praesentium sit et unde."\n}, {\n  "id": 3,\n  "key": 3,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/keryilmaz/128.jpg",\n  "city": "Anaisshire",\n  "email": "Loyce.Upton@hotmail.com",\n  "firstName": "Hilbert",\n  "lastName": "Langosh",\n  "street": "Sim Station",\n  "zipCode": "22101",\n  "date": "2017-01-28T01:56:10.609Z",\n  "bs": "24/7 orchestrate communities",\n  "catchPhrase": "Team-oriented fault-tolerant help-desk",\n  "companyName": "Shields Inc",\n  "words": "aut perspiciatis totam",\n  "sentence": "Ut omnis et."\n}, {\n  "id": 4,\n  "key": 4,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/romanbulah/128.jpg",\n  "city": "North Brad",\n  "email": "Cassidy48@hotmail.com",\n  "firstName": "Cloyd",\n  "lastName": "Wilderman",\n  "street": "Ruecker Turnpike",\n  "zipCode": "93686",\n  "date": "2016-12-30T12:07:39.922Z",\n  "bs": "sticky e-enable metrics",\n  "catchPhrase": "Re-engineered intangible methodology",\n  "companyName": "Hoeger Inc",\n  "words": "iusto ut voluptatem",\n  "sentence": "Praesentium sit exercitationem aut."\n}, {\n  "id": 5,\n  "key": 5,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/claudioguglieri/128.jpg",\n  "city": "Goyetteside",\n  "email": "Tamia.Abbott98@hotmail.com",\n  "firstName": "Jonatan",\n  "lastName": "Gutmann",\n  "street": "Donnelly Mountains",\n  "zipCode": "92491-2242",\n  "date": "2016-10-14T20:54:07.802Z",\n  "bs": "B2C reintermediate initiatives",\n  "catchPhrase": "Upgradable leading edge access",\n  "companyName": "Greenholt and Sons",\n  "words": "deserunt vel expedita",\n  "sentence": "Sed dolorem amet voluptatem sed quasi."\n}, {\n  "id": 6,\n  "key": 6,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/BillSKenney/128.jpg",\n  "city": "West Terrence",\n  "email": "Tina.Stehr66@hotmail.com",\n  "firstName": "Verdie",\n  "lastName": "O\'Conner",\n  "street": "Windler Mountains",\n  "zipCode": "93882",\n  "date": "2017-02-20T15:34:54.827Z",\n  "bs": "one-to-one deploy technologies",\n  "catchPhrase": "Multi-lateral 24 hour workforce",\n  "companyName": "Herzog - Pagac",\n  "words": "maiores sit distinctio",\n  "sentence": "Rem illum voluptatibus asperiores."\n}, {\n  "id": 7,\n  "key": 7,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/okseanjay/128.jpg",\n  "city": "Dietrichfort",\n  "email": "Hobart_Bashirian67@hotmail.com",\n  "firstName": "Elza",\n  "lastName": "Hoeger",\n  "street": "Howe Stravenue",\n  "zipCode": "11044",\n  "date": "2016-09-15T07:33:19.033Z",\n  "bs": "wireless generate methodologies",\n  "catchPhrase": "Optional background secured line",\n  "companyName": "Corwin LLC",\n  "words": "sit dolores aut",\n  "sentence": "Non non sit quas."\n}, {\n  "id": 8,\n  "key": 8,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/haligaliharun/128.jpg",\n  "city": "Kaitlynmouth",\n  "email": "Jefferey33@hotmail.com",\n  "firstName": "Gennaro",\n  "lastName": "Waters",\n  "street": "O\'Hara Radial",\n  "zipCode": "91831",\n  "date": "2017-01-14T19:25:48.665Z",\n  "bs": "open-source morph convergence",\n  "catchPhrase": "Polarised interactive protocol",\n  "companyName": "Osinski, Gleason and Schimmel",\n  "words": "sapiente et praesentium",\n  "sentence": "Omnis in voluptatibus enim unde nobis."\n}, {\n  "id": 9,\n  "key": 9,\n  "avatar": "https://s3.amazonaws.com/uifaces/faces/twitter/mhaligowski/128.jpg",\n  "city": "Hammeschester",\n  "email": "Hildegard.Durgan@yahoo.com",\n  "firstName": "Erling",\n  "lastName": "Armstrong",\n  "street": "Fanny Lights",\n  "zipCode": "96737-2299",\n  "date": "2016-11-13T03:00:06.957Z",\n  "bs": "magnetic utilize infrastructures",\n  "catchPhrase": "Phased reciprocal firmware",\n  "companyName": "Walker - Cartwright",\n  "words": "ut qui excepturi",\n  "sentence": "Culpa dolore nisi vero non."\n}]');
	var sortOption = {};
	
	var fakeData = function () {
	  function fakeData(size) {
	    _classCallCheck(this, fakeData);
	
	    this.size = size || 2000;
	    this.datas = [];
	    this.sortKey = null;
	    this.sortDir = null;
	  }
	
	  _createClass(fakeData, [{
	    key: 'dataModel',
	    value: function dataModel(index) {
	      return tableData[index];
	    }
	  }, {
	    key: 'getObjectAt',
	    value: function getObjectAt(index) {
	      if (index < 0 || index > this.size) {
	        return undefined;
	      }
	      if (this.datas[index] === undefined) {
	        this.datas[index] = this.dataModel(index);
	      }
	      return this.datas[index];
	    }
	  }, {
	    key: 'getAll',
	    value: function getAll() {
	      if (this.datas.length < this.size) {
	        for (var i = 0; i < this.size; i++) {
	          this.getObjectAt(i);
	        }
	      }
	      return this.datas.slice();
	    }
	  }, {
	    key: 'getSize',
	    value: function getSize() {
	      return this.size;
	    }
	  }, {
	    key: 'getSortAsc',
	    value: function getSortAsc(sortKey) {
	      sortOption.sortKey = sortKey;
	      sortOption.sortDir = 'ASC';
	      return this.datas.sort(this.sort);
	    }
	  }, {
	    key: 'getSortDesc',
	    value: function getSortDesc(sortKey) {
	      sortOption.sortKey = sortKey;
	      sortOption.sortDir = 'DESC';
	      return this.datas.sort(this.sort);
	    }
	  }, {
	    key: 'sort',
	    value: function sort(optionA, optionB) {
	      var valueA = optionA[sortOption.sortKey].toUpperCase();
	      var valueB = optionB[sortOption.sortKey].toUpperCase();
	      var sortVal = 0;
	      if (valueA > valueB) {
	        sortVal = 1;
	      }
	      if (valueA < valueB) {
	        sortVal = -1;
	      }
	      if (sortVal !== 0 && sortOption.sortDir === 'DESC') {
	        return sortVal * -1;
	      }
	      return sortVal;
	    }
	  }]);
	
	  return fakeData;
	}();
	
	exports.default = fakeData;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AppLocale = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _languageProvider = __webpack_require__(751);
	
	var _languageProvider2 = _interopRequireDefault(_languageProvider);
	
	var _config = __webpack_require__(282);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { themeConfig } from './config';
	// import DashAppHolder from './dashAppStyle';
	// import 'antd/dist/antd.css';
	
	// import { Provider } from 'react-redux';
	// import { store, history } from './redux/store';
	// import PublicRoutes from './router';
	// import { ThemeProvider } from 'styled-components';
	// import { LocaleProvider } from 'antd';
	// import { IntlProvider } from 'react-intl';
	// import themes from './config/themes';
	var currentAppLocale = _languageProvider2.default[(0, _config.getCurrentLanguage)(_config2.default.defaultLanguage || 'english').locale];
	
	exports.AppLocale = _languageProvider2.default;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n  font-family: ', ';\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  a,\n  p,\n  li,\n  input,\n  textarea,\n  span,\n  div,\n  img,\n  svg {\n    &::selection {\n      background: ', ';\n      color: #fff;\n    }\n  }\n\n  .ant-row:not(.ant-form-item) {\n    ', ';\n    &:before,\n    &:after {\n      display: none;\n    }\n  }\n\n  .ant-row > div {\n    padding: 0;\n  }\n\n  .isoLeftRightComponent {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .isoCenterComponent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n'], ['\n  font-family: ', ';\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  a,\n  p,\n  li,\n  input,\n  textarea,\n  span,\n  div,\n  img,\n  svg {\n    &::selection {\n      background: ', ';\n      color: #fff;\n    }\n  }\n\n  .ant-row:not(.ant-form-item) {\n    ', ';\n    &:before,\n    &:after {\n      display: none;\n    }\n  }\n\n  .ant-row > div {\n    padding: 0;\n  }\n\n  .isoLeftRightComponent {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n  .isoCenterComponent {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _styledTheme = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var DashAppHolder = _styledComponents2.default.div(_templateObject, (0, _styledTheme.font)('primary', 0), (0, _styledTheme.palette)('primary', 0), '' /* margin-left: -8px;
	                                                                                                                                                      margin-right: -8px; */);
	
	exports.default = DashAppHolder;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _templateObject = _taggedTemplateLiteral(['\n@import url(\'https://fonts.googleapis.com/css?family=Roboto\');\n@font-face {\n  font-family: Montserrat;\n  src:  url(', '/fonts/Montserrat-Regular.otf) format(\'opentype\');\n  font-weight: regular;\n\n}\n\n@font-face {\n  font-family: Montserrat-Light;\n  src:  url(', '/fonts/Montserrat-Light.otf) format(\'opentype\');\n  font-weight: light\n}\n\n  html,\n  body {\n    height: 100%;\n    width: 100%;\n  }\n\n  body {\n    font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif, \'Montserrat\';\n  }\n\n  body.fontLoaded {\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif, \'Montserrat\';\n  }\n\n  #app {\n    background-color: #fafafa;\n    min-height: 100%;\n    min-width: 100%;\n  }\n\n  p,\n  label {\n    font-family: Georgia, Times, \'Times New Roman\', serif;\n    line-height: 1.5em;\n  }\n\n//bad pracgtise \n.react-autosuggest__container {\n  position: relative;\n}\n\n.react-autosuggest__input {\n  width: 240px;\n  height: 30px;\n  padding: 10px 20px;\n  font-family: Helvetica, sans-serif;\n  font-weight: 300;\n  font-size: 16px;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n}\n\n.react-autosuggest__input:focus {\n  outline: none;\n}\n\n.react-autosuggest__container--open .react-autosuggest__input {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.react-autosuggest__suggestions-container {\n  display: none;\n}\n\n.react-autosuggest__container--open .react-autosuggest__suggestions-container {\n  display: block;\n  position: absolute;\n  top: 51px;\n  width: 280px;\n  border: 1px solid #aaa;\n  background-color: #fff;\n  font-family: Helvetica, sans-serif;\n  font-weight: 300;\n  font-size: 16px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  z-index: 2;\n}\n\n.react-autosuggest__suggestions-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.react-autosuggest__suggestion {\n  cursor: pointer;\n  padding: 10px 20px;\n}\n\n.react-autosuggest__suggestion:not(:first-child) {\n  border-top: 1px solid #ddd;\n}\n\n.react-autosuggest__suggestion--focused {\n  background-color: #0C7EAF;\n  color: #fff;\n}\n\n.suggestion-content {\n  display: flex;\n  align-items: center;\n  background-repeat: no-repeat;\n}\n\n.dancounsell {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/dancounsell/48.jpg);\n}\n\n.ladylexy {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/ladylexy/48.jpg);\n}\n\n.mtnmissy {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/mtnmissy/48.jpg);\n}\n\n.steveodom {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/steveodom/48.jpg);\n}\n\n.name {\n  margin-left: 68px;\n  line-height: 45px;\n}\n\n.highlight {\n  color: #ee0000;\n  font-weight: bold;\n}\n\n.react-autosuggest__suggestion--focused .highlight {\n  color: #120000;\n}\n\n//bad 2\n@import url(https://fonts.googleapis.com/css?family=Lato:400,300);\n\n// $color-border: #CDCDCD;\n// $color-label: darken($color-border, 20%);\n// $color-primary: #1695A3;\n\n.field {\n  display: block;\n  margin-bottom: 0.5rem;\n}\nlabel {\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1.4rem;\n  font-weight: 600;\n  color: darken(#CDCDCD, 20%);\n}\n\ninput:not([type="radio"]):not([type="checkbox"]), textarea {\n  appearance: none;\n  border: 1px solid #CDCDCD;\n  font-size: 1rem;\n  padding: 0.5rem;\n  min-width: 10rem;\n  \n  &:focus {\n    outline: 2px solid #1695A3;\n  }\n}\n\ninput[type="radio"], input[type="checkbox"] {\n  margin-right: 0.5rem;\n}\n\n button {\n   display: block;\n   appearance: none;\n//   padding: 1rem 2rem;\n   text-transform: uppercase;\n//   font-size: 0.8rem;\n//   // background: #1695A3;\n//   color: white;\n   border: none;\n//   border-radius: 3px;\n//   margin: 0.5rem 0;\n  \n   &:hover {\n     opacity: 0.8;\n   }\n  \n//   + button {\n//     margin-left: 1rem;\n//   }\n  \n   &.secondary {\n     color: #1695A3;\n     background: transparent;\n     border: 1px solid #1695A3;\n   }\n }\n\n button:focus {outline:0;}\n\n\n*, *:before, *:after {\n  box-sizing: border-box;\n  position: relative;\n}\n\nbody {\n  font-family: Lato, Helvetica, sans-serif;\n  // padding: 1rem;\n}\n\nbody, html {\n  font-size: 16px;\n  height: 100%;\n  width: 100%;\n  margin: 0;\n}\n\nimg {\n  max-width: 100%;\n  font-style: italic;\n  vertical-align: middle;\n}\n\n//header dropdown menu\n.accDropDown{\n\n  // height: 187px;\n  width: 177px;\n  background-color: rgba(35, 31, 32, 1);\n  box-shadow: 0px 2px 7px 0px rgba(123, 123, 123, 0.34);\n}\n\n.accDropDownMenuItem {\n  font-family: \'Montserrat\';\n  font-size: 14px;\n  font-weight: 300;\n    color: rgba(255, 255, 255, 1);\n  text-align: center;\n  letter-spacing: 0.09em;\n}\n//end of header dropdown menu\n\n.StripeElement {\n  display: block;\n  margin: 10px 0 20px 0;\n  max-width: 500px;\n  padding: 10px 14px;\n  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;\n  border-radius: 4px;\n  background: white;\n}\n\n.StripeElement--focus {\n  box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;\n  -webkit-transition: all 150ms ease;\n  transition: all 150ms ease;\n}\n\n.StripeElement.PaymentRequestButton {\n  padding: 0;\n}\n\n'], ['\n@import url(\'https://fonts.googleapis.com/css?family=Roboto\');\n@font-face {\n  font-family: Montserrat;\n  src:  url(', '/fonts/Montserrat-Regular.otf) format(\'opentype\');\n  font-weight: regular;\n\n}\n\n@font-face {\n  font-family: Montserrat-Light;\n  src:  url(', '/fonts/Montserrat-Light.otf) format(\'opentype\');\n  font-weight: light\n}\n\n  html,\n  body {\n    height: 100%;\n    width: 100%;\n  }\n\n  body {\n    font-family: \'Helvetica Neue\', Helvetica, Arial, sans-serif, \'Montserrat\';\n  }\n\n  body.fontLoaded {\n    font-family: \'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif, \'Montserrat\';\n  }\n\n  #app {\n    background-color: #fafafa;\n    min-height: 100%;\n    min-width: 100%;\n  }\n\n  p,\n  label {\n    font-family: Georgia, Times, \'Times New Roman\', serif;\n    line-height: 1.5em;\n  }\n\n//bad pracgtise \n.react-autosuggest__container {\n  position: relative;\n}\n\n.react-autosuggest__input {\n  width: 240px;\n  height: 30px;\n  padding: 10px 20px;\n  font-family: Helvetica, sans-serif;\n  font-weight: 300;\n  font-size: 16px;\n  border: 1px solid #aaa;\n  border-radius: 4px;\n}\n\n.react-autosuggest__input:focus {\n  outline: none;\n}\n\n.react-autosuggest__container--open .react-autosuggest__input {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.react-autosuggest__suggestions-container {\n  display: none;\n}\n\n.react-autosuggest__container--open .react-autosuggest__suggestions-container {\n  display: block;\n  position: absolute;\n  top: 51px;\n  width: 280px;\n  border: 1px solid #aaa;\n  background-color: #fff;\n  font-family: Helvetica, sans-serif;\n  font-weight: 300;\n  font-size: 16px;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n  z-index: 2;\n}\n\n.react-autosuggest__suggestions-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none;\n}\n\n.react-autosuggest__suggestion {\n  cursor: pointer;\n  padding: 10px 20px;\n}\n\n.react-autosuggest__suggestion:not(:first-child) {\n  border-top: 1px solid #ddd;\n}\n\n.react-autosuggest__suggestion--focused {\n  background-color: #0C7EAF;\n  color: #fff;\n}\n\n.suggestion-content {\n  display: flex;\n  align-items: center;\n  background-repeat: no-repeat;\n}\n\n.dancounsell {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/dancounsell/48.jpg);\n}\n\n.ladylexy {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/ladylexy/48.jpg);\n}\n\n.mtnmissy {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/mtnmissy/48.jpg);\n}\n\n.steveodom {\n  background-image: url(https://s3.amazonaws.com/uifaces/faces/twitter/steveodom/48.jpg);\n}\n\n.name {\n  margin-left: 68px;\n  line-height: 45px;\n}\n\n.highlight {\n  color: #ee0000;\n  font-weight: bold;\n}\n\n.react-autosuggest__suggestion--focused .highlight {\n  color: #120000;\n}\n\n//bad 2\n@import url(https://fonts.googleapis.com/css?family=Lato:400,300);\n\n// $color-border: #CDCDCD;\n// $color-label: darken($color-border, 20%);\n// $color-primary: #1695A3;\n\n.field {\n  display: block;\n  margin-bottom: 0.5rem;\n}\nlabel {\n  display: block;\n  font-size: 0.8rem;\n  line-height: 1.4rem;\n  font-weight: 600;\n  color: darken(#CDCDCD, 20%);\n}\n\ninput:not([type="radio"]):not([type="checkbox"]), textarea {\n  appearance: none;\n  border: 1px solid #CDCDCD;\n  font-size: 1rem;\n  padding: 0.5rem;\n  min-width: 10rem;\n  \n  &:focus {\n    outline: 2px solid #1695A3;\n  }\n}\n\ninput[type="radio"], input[type="checkbox"] {\n  margin-right: 0.5rem;\n}\n\n button {\n   display: block;\n   appearance: none;\n//   padding: 1rem 2rem;\n   text-transform: uppercase;\n//   font-size: 0.8rem;\n//   // background: #1695A3;\n//   color: white;\n   border: none;\n//   border-radius: 3px;\n//   margin: 0.5rem 0;\n  \n   &:hover {\n     opacity: 0.8;\n   }\n  \n//   + button {\n//     margin-left: 1rem;\n//   }\n  \n   &.secondary {\n     color: #1695A3;\n     background: transparent;\n     border: 1px solid #1695A3;\n   }\n }\n\n button:focus {outline:0;}\n\n\n*, *:before, *:after {\n  box-sizing: border-box;\n  position: relative;\n}\n\nbody {\n  font-family: Lato, Helvetica, sans-serif;\n  // padding: 1rem;\n}\n\nbody, html {\n  font-size: 16px;\n  height: 100%;\n  width: 100%;\n  margin: 0;\n}\n\nimg {\n  max-width: 100%;\n  font-style: italic;\n  vertical-align: middle;\n}\n\n//header dropdown menu\n.accDropDown{\n\n  // height: 187px;\n  width: 177px;\n  background-color: rgba(35, 31, 32, 1);\n  box-shadow: 0px 2px 7px 0px rgba(123, 123, 123, 0.34);\n}\n\n.accDropDownMenuItem {\n  font-family: \'Montserrat\';\n  font-size: 14px;\n  font-weight: 300;\n    color: rgba(255, 255, 255, 1);\n  text-align: center;\n  letter-spacing: 0.09em;\n}\n//end of header dropdown menu\n\n.StripeElement {\n  display: block;\n  margin: 10px 0 20px 0;\n  max-width: 500px;\n  padding: 10px 14px;\n  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;\n  border-radius: 4px;\n  background: white;\n}\n\n.StripeElement--focus {\n  box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;\n  -webkit-transition: all 150ms ease;\n  transition: all 150ms ease;\n}\n\n.StripeElement.PaymentRequestButton {\n  padding: 0;\n}\n\n']);
	
	var _styledComponents = __webpack_require__(16);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	/* eslint no-unused-expressions: 0 */
	(0, _styledComponents.injectGlobal)(_templateObject, (""), (""));

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = asyncComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nprogress = __webpack_require__(320);
	
	var _nprogress2 = _interopRequireDefault(_nprogress);
	
	var _reactPlaceholder = __webpack_require__(2785);
	
	var _reactPlaceholder2 = _interopRequireDefault(_reactPlaceholder);
	
	__webpack_require__(1992);
	
	__webpack_require__(1997);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function asyncComponent(importComponent) {
	  var AsyncFunc = function (_Component) {
	    _inherits(AsyncFunc, _Component);
	
	    function AsyncFunc(props) {
	      _classCallCheck(this, AsyncFunc);
	
	      var _this = _possibleConstructorReturn(this, (AsyncFunc.__proto__ || Object.getPrototypeOf(AsyncFunc)).call(this, props));
	
	      _this.state = {
	        component: null
	      };
	      return _this;
	    }
	
	    _createClass(AsyncFunc, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        _nprogress2.default.start();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.mounted = false;
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function () {
	        var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	          var _ref2, Component;
	
	          return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	              switch (_context.prev = _context.next) {
	                case 0:
	                  this.mounted = true;
	                  _context.next = 3;
	                  return importComponent();
	
	                case 3:
	                  _ref2 = _context.sent;
	                  Component = _ref2.default;
	
	                  _nprogress2.default.done();
	                  if (this.mounted) {
	                    this.setState({
	                      component: _react2.default.createElement(Component, this.props)
	                    });
	                  }
	
	                case 7:
	                case 'end':
	                  return _context.stop();
	              }
	            }
	          }, _callee, this);
	        }));
	
	        function componentDidMount() {
	          return _ref.apply(this, arguments);
	        }
	
	        return componentDidMount;
	      }()
	    }, {
	      key: 'render',
	      value: function render() {
	        var Component = this.state.component || _react2.default.createElement('div', null);
	        return _react2.default.createElement(
	          _reactPlaceholder2.default,
	          { type: 'text', rows: 7, ready: Component !== null },
	          Component
	        );
	      }
	    }]);
	
	    return AsyncFunc;
	  }(_react.Component);
	
	  return AsyncFunc;
	}

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getInitData = getInitData;
	exports.setUrl = setUrl;
	exports.getDefaultPath = getDefaultPath;
	
	var _qs = __webpack_require__(236);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getInitData() {
	  var initData = _qs2.default.parse(window.location.search.slice(1));
	  if (initData.toggle) initData.toggle.free_shipping = initData.toggle.free_shipping === 'true' ? true : undefined;
	  return initData;
	}
	function setUrl(searchState) {
	  var search = searchState ? window.location.pathname + '?' + _qs2.default.stringify(searchState) : '';
	  window.history.pushState(searchState, null, search);
	}
	
	function getDefaultPath() {
	  var getParent = function getParent(lastRoute) {
	    var parents = {
	      ecommerce: ['shop', 'cart', 'checkout', 'card'],
	      map: ['googlemap', 'leafletmap'],
	      charts: ['googleChart', 'reecharts', 'reactVis', 'reactChart2', 'reactTrend', 'echart', 'frappeChart'],
	      Forms: ['InputField', 'editor', 'FormsWithValidation', 'progress', 'button', 'tab', 'checkbox', 'radiobox', 'transfer', 'autocomplete'],
	      uielements: ['op_badge', 'op_card', 'op_carousel', 'op_collapse', 'op_popover', 'op_tooltip', 'op_tag', 'op_timeline', 'dropdown', 'pagination', 'rating', 'tree'],
	      advancedUielements: ['reactDates', 'codeMirror', 'uppy', 'dropzone'],
	      feedback: ['alert', 'modal', 'message', 'notification', 'popconfirm', 'spin'],
	      table: ['table_ant'],
	      pages: ['404', '500', 'signin', 'signup', 'forgotpassword', 'resetpassword', 'invoice', 'comingSoon']
	    };
	    var parent = void 0;
	    Object.keys(parents).forEach(function (key) {
	      parents[key].forEach(function (p) {
	        if (p === lastRoute) {
	          parent = key;
	        }
	      });
	    });
	    return parent ? [parent, lastRoute] : [lastRoute];
	  };
	  if (window && window.location.pathname) {
	    var routes = window.location.pathname.split('/');
	    if (routes.length > 1) {
	      var lastRoute = routes[routes.length - 1];
	      if (lastRoute) {
	        return getParent(lastRoute);
	      }
	    }
	  }
	  return [];
	}

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createBrowserHistory = __webpack_require__(230);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createBrowserHistory2.default)();

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	__webpack_require__(2002);
	
	__webpack_require__(1991);
	
	var _reactRouterDom = __webpack_require__(160);
	
	var _reactRedux = __webpack_require__(40);
	
	var _styledComponents = __webpack_require__(16);
	
	var _antd = __webpack_require__(43);
	
	var _reactIntl = __webpack_require__(338);
	
	var _reactHelmet = __webpack_require__(1243);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _themes = __webpack_require__(740);
	
	var _themes2 = _interopRequireDefault(_themes);
	
	var _languageProvider = __webpack_require__(751);
	
	var _languageProvider2 = _interopRequireDefault(_languageProvider);
	
	var _config = __webpack_require__(282);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _createBrowserHistory = __webpack_require__(230);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Admin = __webpack_require__(1602);
	
	var _Admin2 = _interopRequireDefault(_Admin);
	
	var _Callback = __webpack_require__(1606);
	
	var _Callback2 = _interopRequireDefault(_Callback);
	
	var _Auth = __webpack_require__(1604);
	
	var _Auth2 = _interopRequireDefault(_Auth);
	
	var _Home = __webpack_require__(1697);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Ping = __webpack_require__(1715);
	
	var _Ping2 = _interopRequireDefault(_Ping);
	
	var _MyAccount = __webpack_require__(1701);
	
	var _MyAccount2 = _interopRequireDefault(_MyAccount);
	
	var _MyBilling = __webpack_require__(1703);
	
	var _MyBilling2 = _interopRequireDefault(_MyBilling);
	
	var _OrderReview = __webpack_require__(1707);
	
	var _OrderReview2 = _interopRequireDefault(_OrderReview);
	
	var _OrderSuccess = __webpack_require__(1713);
	
	var _OrderSuccess2 = _interopRequireDefault(_OrderSuccess);
	
	var _CampaignList = __webpack_require__(1683);
	
	var _CampaignList2 = _interopRequireDefault(_CampaignList);
	
	var _Profile = __webpack_require__(1716);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _AddCampaign = __webpack_require__(1645);
	
	var _AddCampaign2 = _interopRequireDefault(_AddCampaign);
	
	var _AddCampaignForm = __webpack_require__(1648);
	
	var _AddCampaignForm2 = _interopRequireDefault(_AddCampaignForm);
	
	var _Dashboard = __webpack_require__(747);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _AsoAnalytic = __webpack_require__(1674);
	
	var _AsoAnalytic2 = _interopRequireDefault(_AsoAnalytic);
	
	var _App = __webpack_require__(1650);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Landing = __webpack_require__(1699);
	
	var _Landing2 = _interopRequireDefault(_Landing);
	
	var _Header = __webpack_require__(1609);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(212);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _config3 = __webpack_require__(395);
	
	var _dashAppStyle = __webpack_require__(1731);
	
	var _dashAppStyle2 = _interopRequireDefault(_dashAppStyle);
	
	var _reduxPersistImmutable = __webpack_require__(1384);
	
	__webpack_require__(1732);
	
	var _store = __webpack_require__(1752);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _AppHeader = __webpack_require__(1603);
	
	var _AppHeader2 = _interopRequireDefault(_AppHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import EditCampaign from './containers/EditCampaign';
	
	
	var currentAppLocale = _languageProvider2.default[(0, _config.getCurrentLanguage)(_config2.default.defaultLanguage || 'english').locale];
	
	var auth = new _Auth2.default();
	
	var handleAuthentication = function handleAuthentication(nextState, replace) {
	  if (/access_token|id_token|error/.test(nextState.location.hash)) {
	    auth.handleAuthentication();
	  }
	};
	
	
	var initialState = {};
	// import configureStore from './configureStore';
	
	var history = (0, _createBrowserHistory2.default)();
	var store = (0, _store2.default)(initialState, history);
	// import { store, history } from './redux/store';
	
	var Preloader = function (_Component) {
	  _inherits(Preloader, _Component);
	
	  function Preloader() {
	    _classCallCheck(this, Preloader);
	
	    var _this = _possibleConstructorReturn(this, (Preloader.__proto__ || Object.getPrototypeOf(Preloader)).call(this));
	
	    _this.state = { rehydrated: false };
	    return _this;
	  }
	
	  _createClass(Preloader, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _reduxPersistImmutable.persistStore)(store, { whitelist: ['ItunesSearch'] }, function () {
	        _this2.setState({ rehydrated: true });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (!this.state.rehydrated) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _reactHelmet2.default,
	            {
	              title: 'Project X',
	
	              description: 'Best platform for Apple Search Ads' },
	            _react2.default.createElement('meta', { charSet: 'utf-8' }),
	            _react2.default.createElement(
	              'title',
	              null,
	              'Project X'
	            ),
	            _react2.default.createElement('link', { rel: 'canonical', href: 'http://project-x.gogochart.com/' }),
	            _react2.default.createElement('meta', { name: 'description', content: 'Best platform for Apple Search Ads' })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        _antd.LocaleProvider,
	        { locale: currentAppLocale.antd },
	        _react2.default.createElement(
	          _reactIntl.IntlProvider,
	          {
	            locale: currentAppLocale.locale,
	            messages: currentAppLocale.messages
	          },
	          _react2.default.createElement(
	            _styledComponents.ThemeProvider,
	            { theme: _themes2.default[_config3.themeConfig.theme] },
	            _react2.default.createElement(
	              _dashAppStyle2.default,
	              null,
	              _react2.default.createElement(
	                _reactRedux.Provider,
	                { store: store },
	                _react2.default.createElement(
	                  _reactRouterDom.BrowserRouter,
	                  { history: history },
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _reactHelmet2.default,
	                      {
	                        title: 'Project X',
	
	                        description: 'Best platform for Apple Search Ads' },
	                      _react2.default.createElement('meta', { charSet: 'utf-8' }),
	                      _react2.default.createElement(
	                        'title',
	                        null,
	                        'Project X'
	                      ),
	                      _react2.default.createElement('link', { rel: 'canonical', href: 'http://project-x.gogochart.com/' }),
	                      _react2.default.createElement('meta', { name: 'description', content: 'Best platform for Apple Search Ads' })
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Switch,
	                      null,
	                      _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render(props) {
	                          return _react2.default.createElement(_Landing2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/aso', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/home', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/payment/success', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/campaign', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/', render: function render(props) {
	                          return _react2.default.createElement(_Header2.default, Object.assign({ auth: auth }, props));
	                        } })
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Switch,
	                      null,
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/home', render: function render(props) {
	                          return _react2.default.createElement(_Home2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/profile', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Profile2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/ping', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Ping2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/addCampaign', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_AddCampaign2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/addCampaign/appId/:appId', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_AddCampaignForm2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/addCampaign/confirm', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_OrderReview2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/payment/success', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_OrderSuccess2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/aso/:appId', render: function render(props) {
	                          return _react2.default.createElement(_AsoAnalytic2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/campaign/:appId/aso', render: function render(props) {
	                          return _react2.default.createElement(_AsoAnalytic2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/campaign/', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_CampaignList2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/campaign/:campaignId', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Dashboard2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/:appId/region/:region/pcid/:pcid/dcid/:dcid', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Dashboard2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard/:appId', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Dashboard2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/dashboard', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Dashboard2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/campaign', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Dashboard2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/admin', render: function render(props) {
	                          return !auth.isAuthenticated() || !auth.userHasScopes(['write:messages']) ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_Admin2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/me/account', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_MyAccount2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/me/billing', render: function render(props) {
	                          return !auth.isAuthenticated() ? _react2.default.createElement(_reactRouterDom.Redirect, { to: '/' }) : _react2.default.createElement(_MyBilling2.default, Object.assign({ auth: auth }, props));
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/callback', render: function render(props) {
	                          handleAuthentication(props);
	                          return _react2.default.createElement(_Callback2.default, props);
	                        } })
	                    ),
	                    _react2.default.createElement(
	                      _reactRouterDom.Switch,
	                      null,
	                      _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: null }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/aso', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/payment/success', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/campaign', render: function render(props) {
	                          return null;
	                        } }),
	                      _react2.default.createElement(_reactRouterDom.Route, { path: '/', render: function render(props) {
	                          return _react2.default.createElement(_Footer2.default, Object.assign({ auth: auth }, props));
	                        } })
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Preloader;
	}(_react.Component);
	
	exports.default = Preloader;
	
	_reactDom2.default.render(_react2.default.createElement(Preloader, null), document.getElementById('root'));

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _en_US = __webpack_require__(594);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	var _ar = __webpack_require__(2741);
	
	var _ar2 = _interopRequireDefault(_ar);
	
	var _ar_SA = __webpack_require__(2299);
	
	var _ar_SA2 = _interopRequireDefault(_ar_SA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saLang = {
	  messages: Object.assign({}, _ar_SA2.default),
	  antd: _en_US2.default,
	  locale: 'ar',
	  data: _ar2.default
	};
	exports.default = saLang;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _en_US = __webpack_require__(594);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	var _en = __webpack_require__(2742);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _en_US3 = __webpack_require__(2300);
	
	var _en_US4 = _interopRequireDefault(_en_US3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { getKeys, getValues } from '../conversion';
	// getValues(enMessages);
	
	var EnLang = {
	  messages: Object.assign({}, _en_US4.default),
	  antd: _en_US2.default,
	  locale: 'en-US',
	  data: _en2.default
	};
	exports.default = EnLang;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ca_ES = __webpack_require__(1478);
	
	var _ca_ES2 = _interopRequireDefault(_ca_ES);
	
	var _es = __webpack_require__(2743);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _es_ES = __webpack_require__(2301);
	
	var _es_ES2 = _interopRequireDefault(_es_ES);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saLang = {
	  messages: Object.assign({}, _es_ES2.default),
	  antd: _ca_ES2.default,
	  locale: 'es',
	  data: _es2.default
	};
	exports.default = saLang;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fr_FR = __webpack_require__(1479);
	
	var _fr_FR2 = _interopRequireDefault(_fr_FR);
	
	var _fr = __webpack_require__(2744);
	
	var _fr2 = _interopRequireDefault(_fr);
	
	var _fr_FR3 = __webpack_require__(2302);
	
	var _fr_FR4 = _interopRequireDefault(_fr_FR3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saLang = {
	  messages: Object.assign({}, _fr_FR4.default),
	  antd: _fr_FR2.default,
	  locale: 'fr-FR',
	  data: _fr2.default
	};
	exports.default = saLang;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _it_IT = __webpack_require__(1481);
	
	var _it_IT2 = _interopRequireDefault(_it_IT);
	
	var _it = __webpack_require__(2745);
	
	var _it2 = _interopRequireDefault(_it);
	
	var _it_IT3 = __webpack_require__(2303);
	
	var _it_IT4 = _interopRequireDefault(_it_IT3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var saLang = {
	  messages: Object.assign({}, _it_IT4.default),
	  antd: _it_IT2.default,
	  locale: 'it-IT',
	  data: _it2.default
	};
	exports.default = saLang;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _zh = __webpack_require__(2746);
	
	var _zh2 = _interopRequireDefault(_zh);
	
	var _zhHans = __webpack_require__(2304);
	
	var _zhHans2 = _interopRequireDefault(_zhHans);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZhLan = {
	  messages: Object.assign({}, _zhHans2.default),
	  antd: null,
	  locale: 'zh-Hans-CN',
	  data: _zh2.default
	};
	exports.default = ZhLan;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = appReducer;
	
	var _immutable = __webpack_require__(35);
	
	var _urlSync = __webpack_require__(1734);
	
	var _actions = __webpack_require__(118);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var preKeys = (0, _urlSync.getDefaultPath)();
	
	var initState = new _immutable.Map({
	  collapsed: window.innerWidth > 1220 ? false : true,
	  view: (0, _actions.getView)(window.innerWidth),
	  height: window.innerHeight,
	  openDrawer: false,
	  openKeys: preKeys,
	  current: preKeys,
	
	  currentApp: null,
	  secondApp: null,
	  searchTerm: ''
	});
	function appReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions2.default.COLLPSE_CHANGE:
	      return state.set('collapsed', !state.get('collapsed'));
	    case _actions2.default.COLLPSE_OPEN_DRAWER:
	      return state.set('openDrawer', !state.get('openDrawer'));
	    case _actions2.default.TOGGLE_ALL:
	      if (state.get('view') !== action.view || action.height !== state.height) {
	        var height = action.height ? action.height : state.height;
	        return state.set('collapsed', action.collapsed).set('view', action.view).set('height', height);
	      }
	      break;
	    case _actions2.default.CHANGE_OPEN_KEYS:
	      return state.set('openKeys', action.openKeys);
	    case _actions2.default.CHANGE_CURRENT:
	      return state.set('current', action.current);
	
	    case _actions2.default.SET_CURRENT_APP:
	      return state.set('currentApp', action.app).set('secondApp', action.secondApp);
	    case _actions2.default.SET_SEARCH_TERM:
	      return state.set('searchTerm', action.searchTerm);
	    default:
	      return state;
	  }
	  return state;
	}

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = authReducer;
	
	var _immutable = __webpack_require__(35);
	
	var _utility = __webpack_require__(750);
	
	var _actions = __webpack_require__(397);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initState = new _immutable.Map({
	  idToken: 'secret token'
	});
	
	function authReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState.merge((0, _utility.getToken)());
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions2.default.LOGIN_SUCCESS:
	      return state.set('idToken', action.token);
	    case _actions2.default.LOGOUT:
	      return initState;
	    default:
	      return state;
	  }
	}

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.loginRequest = loginRequest;
	exports.loginSuccess = loginSuccess;
	exports.loginError = loginError;
	exports.logout = logout;
	exports.default = rootSaga;
	
	var _effects = __webpack_require__(557);
	
	var _reactRouterRedux = __webpack_require__(1279);
	
	var _utility = __webpack_require__(750);
	
	var _actions = __webpack_require__(397);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [loginRequest, loginSuccess, loginError, logout, rootSaga].map(_regenerator2.default.mark);
	
	var fakeApiCall = true; // auth0 or express JWT
	
	function loginRequest() {
	  return _regenerator2.default.wrap(function loginRequest$(_context2) {
	    while (1) {
	      switch (_context2.prev = _context2.next) {
	        case 0:
	          _context2.next = 2;
	          return (0, _effects.takeEvery)('LOGIN_REQUEST', _regenerator2.default.mark(function _callee() {
	            return _regenerator2.default.wrap(function _callee$(_context) {
	              while (1) {
	                switch (_context.prev = _context.next) {
	                  case 0:
	                    if (!fakeApiCall) {
	                      _context.next = 5;
	                      break;
	                    }
	
	                    _context.next = 3;
	                    return (0, _effects.put)({
	                      type: _actions2.default.LOGIN_SUCCESS,
	                      token: 'secret token',
	                      profile: 'Profile'
	                    });
	
	                  case 3:
	                    _context.next = 7;
	                    break;
	
	                  case 5:
	                    _context.next = 7;
	                    return (0, _effects.put)({ type: _actions2.default.LOGIN_ERROR });
	
	                  case 7:
	                  case 'end':
	                    return _context.stop();
	                }
	              }
	            }, _callee, this);
	          }));
	
	        case 2:
	        case 'end':
	          return _context2.stop();
	      }
	    }
	  }, _marked[0], this);
	}
	
	function loginSuccess() {
	  return _regenerator2.default.wrap(function loginSuccess$(_context4) {
	    while (1) {
	      switch (_context4.prev = _context4.next) {
	        case 0:
	          _context4.next = 2;
	          return (0, _effects.takeEvery)(_actions2.default.LOGIN_SUCCESS, _regenerator2.default.mark(function _callee2(payload) {
	            return _regenerator2.default.wrap(function _callee2$(_context3) {
	              while (1) {
	                switch (_context3.prev = _context3.next) {
	                  case 0:
	                    _context3.next = 2;
	                    return localStorage.setItem('id_token', payload.token);
	
	                  case 2:
	                  case 'end':
	                    return _context3.stop();
	                }
	              }
	            }, _callee2, this);
	          }));
	
	        case 2:
	        case 'end':
	          return _context4.stop();
	      }
	    }
	  }, _marked[1], this);
	}
	
	function loginError() {
	  return _regenerator2.default.wrap(function loginError$(_context6) {
	    while (1) {
	      switch (_context6.prev = _context6.next) {
	        case 0:
	          _context6.next = 2;
	          return (0, _effects.takeEvery)(_actions2.default.LOGIN_ERROR, _regenerator2.default.mark(function _callee3() {
	            return _regenerator2.default.wrap(function _callee3$(_context5) {
	              while (1) {
	                switch (_context5.prev = _context5.next) {
	                  case 0:
	                  case 'end':
	                    return _context5.stop();
	                }
	              }
	            }, _callee3, this);
	          }));
	
	        case 2:
	        case 'end':
	          return _context6.stop();
	      }
	    }
	  }, _marked[2], this);
	}
	
	function logout() {
	  return _regenerator2.default.wrap(function logout$(_context8) {
	    while (1) {
	      switch (_context8.prev = _context8.next) {
	        case 0:
	          _context8.next = 2;
	          return (0, _effects.takeEvery)(_actions2.default.LOGOUT, _regenerator2.default.mark(function _callee4() {
	            return _regenerator2.default.wrap(function _callee4$(_context7) {
	              while (1) {
	                switch (_context7.prev = _context7.next) {
	                  case 0:
	                    (0, _utility.clearToken)();
	                    _context7.next = 3;
	                    return (0, _effects.put)((0, _reactRouterRedux.push)('/'));
	
	                  case 3:
	                  case 'end':
	                    return _context7.stop();
	                }
	              }
	            }, _callee4, this);
	          }));
	
	        case 2:
	        case 'end':
	          return _context8.stop();
	      }
	    }
	  }, _marked[3], this);
	}
	function rootSaga() {
	  return _regenerator2.default.wrap(function rootSaga$(_context9) {
	    while (1) {
	      switch (_context9.prev = _context9.next) {
	        case 0:
	          _context9.next = 2;
	          return (0, _effects.all)([(0, _effects.fork)(loginRequest), (0, _effects.fork)(loginSuccess), (0, _effects.fork)(loginError), (0, _effects.fork)(logout)]);
	
	        case 2:
	        case 'end':
	          return _context9.stop();
	      }
	    }
	  }, _marked[4], this);
	}

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = itunesSearchReducer;
	
	var _immutable = __webpack_require__(35);
	
	var _actions = __webpack_require__(216);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initState = new _immutable.Map({
	  currentApp: null,
	  secondApp: null,
	  searchTerm: '',
	  countryCode: 'us'
	});
	
	function itunesSearchReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions2.default.COLLPSE_CHANGE:
	      return state.set('collapsed', !state.get('collapsed'));
	    case _actions2.default.COLLPSE_OPEN_DRAWER:
	      return state.set('openDrawer', !state.get('openDrawer'));
	    case _actions2.default.TOGGLE_ALL:
	      if (state.get('view') !== action.view || action.height !== state.height) {
	        var height = action.height ? action.height : state.height;
	        return state.set('collapsed', action.collapsed).set('view', action.view).set('height', height);
	      }
	      break;
	    case _actions2.default.CHANGE_OPEN_KEYS:
	      return state.set('openKeys', action.openKeys);
	
	    case _actions2.default.CHANGE_CURRENT:
	      return state.set('current', action.current);
	
	    case _actions2.default.SET_CURRENT_APP:
	      return state.set('currentApp', action.app).set('secondApp', action.secondApp);
	
	    case _actions2.default.SET_SEARCH_TERM:
	      return state.set('searchTerm', action.searchTerm);
	
	    case _actions2.default.SET_COUNTRY_CODE:
	      return state.set('countryCode', action.countryCode);
	
	    default:
	      return state;
	  }
	  return state;
	}

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _config = __webpack_require__(282);
	
	var actions = {
	  CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',
	  ACTIVATE_LANG_MODAL: 'ACTIVATE_LANG_MODAL',
	  switchActivation: function switchActivation() {
	    return {
	      type: actions.ACTIVATE_LANG_MODAL
	    };
	  },
	  changeLanguage: function changeLanguage(language) {
	    return {
	      type: actions.CHANGE_LANGUAGE,
	      language: (0, _config.getCurrentLanguage)(language)
	    };
	  }
	};
	exports.default = actions;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _actions2.default.ACTIVATE_LANG_MODAL:
	      return state.set('isActivated', !state.get('isActivated'));
	    case _actions2.default.CHANGE_LANGUAGE:
	      return state.set('language', action.language);
	    default:
	      return state;
	  }
	};
	
	var _immutable = __webpack_require__(35);
	
	var _config = __webpack_require__(282);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _actions = __webpack_require__(1747);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initState = new _immutable.Map({
	  isActivated: false,
	  language: (0, _config.getCurrentLanguage)(_config2.default.defaultLanguage || 'english')
	});

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reducer = __webpack_require__(1744);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _reducer3 = __webpack_require__(1743);
	
	var _reducer4 = _interopRequireDefault(_reducer3);
	
	var _reducer5 = __webpack_require__(1748);
	
	var _reducer6 = _interopRequireDefault(_reducer5);
	
	var _reducer7 = __webpack_require__(1746);
	
	var _reducer8 = _interopRequireDefault(_reducer7);
	
	var _reducer9 = __webpack_require__(1751);
	
	var _reducer10 = _interopRequireDefault(_reducer9);
	
	var _reactReduxForm = __webpack_require__(1263);
	
	var _immutable = __webpack_require__(3033);
	
	var _immutable2 = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Calendar from './calendar/reducer';
	// import Box from './box/reducer';
	// import Notes from './notes/reducer';
	// import Todos from './todos/reducer';
	// import Contacts from './contacts/reducer';
	// import DynamicChartComponent from './dynamicEchart/reducer';
	// import ThemeSwitcher from './themeSwitcher/reducer';
	// import YoutubeSearch from './youtubeSearch/reducers';
	var initialCampaignState = {
	
	  currency: 'USD',
	  weeklyBudget: '1.02',
	  budgetSplit: [{ key: 'AU', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }, { key: 'CA', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }, { key: 'CH', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }, { key: 'GB', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }, { key: 'MX', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }, { key: 'NZ', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }, { key: 'US', value: 10 / 7, percentage: 10 / 7 / 10 * 100, display: true, selected: true }],
	  depositAmount: 10,
	  // adminFee: 0.5,  // No admin fee is charged
	  discount: 0,
	  maxCPA: '2',
	  maxAmountForKeyword: '1.1',
	  range: [20, 40, 60, 80],
	  boostedKeywords: [],
	  negativeKeywords: []
	};
	
	var campaign = new _immutable2.Map({
	  currency: 'USD',
	  isEvenlySplit: true,
	  budgetSplit: [{ key: 'AU', value: 10 / 7, display: true, selected: true }, { key: 'CA', value: 10 / 7, display: true, selected: true }, { key: 'CH', value: 10 / 7, display: true, selected: true }, { key: 'GB', value: 10 / 7, display: true, selected: true }, { key: 'MX', value: 10 / 7, display: true, selected: true }, { key: 'NZ', value: 10 / 7, display: true, selected: true }, { key: 'US', value: 10 / 7, display: true, selected: true }],
	  depositAmount: 10,
	  maxCPA: 2,
	  maxAmountForKeyword: 1.1,
	  positiveKeywords: [],
	  negativeKeywords: []
	});
	
	//TODO should move to campaagin form folder inside reducer folder
	function campaignReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : campaign;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case 'ADD_CAMPAIGN':
	      console.log('ADD_CAMPAIGN', state, action);
	
	      return state;
	    case 'UPDATE_STOREFRONTS':
	      console.log('UPDATE_STOREFRONTS', state, action, state.get('budgetSplit'));
	
	      // const budgetSplit = state.get('budgetSplit');
	      var budgetSplit = action.value.map(function (countryCode) {
	        return {
	          key: countryCode,
	          value: 0,
	          display: true,
	          selected: true
	        };
	      });
	      console.log('UPDATE_STOREFRONTS', budgetSplit);
	
	      var newBudgetSplit = budgetSplit.map(function (budgetItem) {
	        if (action.value.indexOf(budgetItem.key) > -1) {
	          budgetItem.display = true;
	          budgetItem.selected = true;
	        } else {
	          budgetItem.display = false;
	          budgetItem.selected = false;
	          budgetItem.value = 0;
	        }
	        return budgetItem;
	      });
	
	      if (state.get('isEvenlySplit')) {
	        var storefrontCount = newBudgetSplit.filter(function (b) {
	          return b.selected;
	        }).length;
	        newBudgetSplit = newBudgetSplit.map(function (b) {
	          if (b.selected) {
	            var newAmount = +parseFloat(state.get('depositAmount') / storefrontCount).toFixed(2);
	            b.value = newAmount;
	          }
	          return b;
	        });
	      } else {
	        var totalBudget = newBudgetSplit.filter(function (b) {
	          return b.selected;
	        }).reduce(function (pv, cv) {
	          return pv + cv.value;
	        }, 0);
	        newBudgetSplit = newBudgetSplit.map(function (b) {
	          if (b.selected) {
	            var newAmount = +parseFloat(b.value / totalBudget * state.get('depositAmount')).toFixed(2);
	            b.value = newAmount;
	          }
	          return b;
	        });
	      }
	      return state.set('budgetSplit', newBudgetSplit);
	    default:
	      return state;
	  }
	}
	
	exports.default = {
	
	  Auth: _reducer2.default,
	  App: _reducer4.default,
	  LanguageSwitcher: _reducer6.default,
	  ItunesSearch: _reducer8.default,
	  // ThemeSwitcher,
	  // Calendar,
	  // Box,
	  // Notes,
	  // Todos,
	  // Contacts,
	  // DynamicChartComponent,
	  // YoutubeSearch,
	  search: _reducer10.default,
	  form: _immutable.reducer,
	  deep: (0, _reactReduxForm.combineForms)({
	    campaign: initialCampaignState,
	    //updateCampaign
	    auth0SignUp: {},
	    auth0SignIn: {}
	  }, 'deep'),
	  campaign: campaignReducer
	  // campaign: {
	  //   currency: 'USD',
	  //   weeklyBudget: '1.02',
	  //   budgetSplit: [
	  //     {key: 'AU', value: 10/7, selected: true},
	  //     {key: 'CA', value: 10/7, selected: true},
	  //     {key: 'CH', value: 10/7, selected: true},
	  //     {key: 'GB', value: 10/7, selected: true},
	  //     {key: 'MX', value: 10/7, selected: true},
	  //     {key: 'NZ', value: 10/7, selected: true},
	  //     {key: 'US', value: 10/7, selected: true}
	  //   ],
	  //   depositAmount: 10,
	  //   discount: 0,
	  //   maxCPA: '2',
	  //   maxAmountForKeyword: '1.1',
	  //   range: [20, 40, 60, 80],
	  //   boostedKeywords: [],
	  //   negativeKeywords: []
	  // }
	};

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(79);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	exports.default = rootSaga;
	
	var _effects = __webpack_require__(557);
	
	var _saga = __webpack_require__(1745);
	
	var _saga2 = _interopRequireDefault(_saga);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _marked = [rootSaga].map(_regenerator2.default.mark);
	
	// import contactSagas from './contacts/saga';
	// import notesSagas from './notes/saga';
	// import todosSagas from './todos/saga';
	// import cardsSagas from './card/saga';
	// import youtubeSearchSagas from './youtubeSearch/sagas';
	// import searchAdsSagas from './searchads/sagas'
	
	function rootSaga(getState) {
	  return _regenerator2.default.wrap(function rootSaga$(_context) {
	    while (1) {
	      switch (_context.prev = _context.next) {
	        case 0:
	          _context.next = 2;
	          return (0, _effects.all)([(0, _saga2.default)()]
	          // contactSagas(),
	          // notesSagas(),
	          // todosSagas(),
	          // cardsSagas(),
	          // youtubeSearchSagas(),
	          // searchAdsSagas()
	          );
	
	        case 2:
	        case 'end':
	          return _context.stop();
	      }
	    }
	  }, _marked[0], this);
	}

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(35);
	
	var _actions = __webpack_require__(752);
	
	// The initial state of the App
	var initialState = (0, _immutable.fromJS)({
	
	  keyword: '',
	  suggests: [],
	  status: '',
	  error: false,
	  selected: null
	
	});
	
	function searchReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	
	    case _actions.REQUEST_SUGGEST:
	      return state.set('status', 'working').set('error', false);
	
	    case _actions.SUCCESS_SUGGEST:
	      console.log('action', action.payload);
	      return state.set('status', 'done').set('error', false).set('suggests', action.payload.data);
	
	    case _actions.FAILURE_SUGGEST:
	      return state.set('status', 'done').set('error', true);
	
	    case _actions.CLEAR_SUGGESTS:
	      return state.set('suggests', initialState.getIn(['suggests']).slice());
	
	    case _actions.SET_KEYWORD:
	      return state.set('keyword', action.payload);
	
	    case _actions.CLEAR_KEYWORD:
	      return state.set('keyword', initialState.getIn(['keyword']));
	
	    case _actions.SET_SELECTED:
	      return state.set('selected', action.payload);
	
	    default:
	      return state;
	  }
	}
	
	exports.default = searchReducer;

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = configureStore;
	
	var _redux = __webpack_require__(56);
	
	var _createBrowserHistory = __webpack_require__(230);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _reactRouterRedux = __webpack_require__(1279);
	
	var _reduxThunk = __webpack_require__(3231);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxSaga = __webpack_require__(3225);
	
	var _reduxSaga2 = _interopRequireDefault(_reduxSaga);
	
	var _reducers = __webpack_require__(1749);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _sagas = __webpack_require__(1750);
	
	var _sagas2 = _interopRequireDefault(_sagas);
	
	var _immutable = __webpack_require__(35);
	
	var _reduxPersistImmutable = __webpack_require__(1384);
	
	var _reduxImmutable = __webpack_require__(3208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var sagaMiddleware = (0, _reduxSaga2.default)();
	
	
	var routeInitialState = (0, _immutable.fromJS)({
	  location: null
	});
	function routeReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : routeInitialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    /* istanbul ignore next */
	    case _reactRouterRedux.LOCATION_CHANGE:
	      return state.merge({
	        location: action.payload
	      });
	    default:
	      return state;
	  }
	}
	
	function configureStore() {
	  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var history = arguments[1];
	
	  // const history = createHistory();
	  var routeMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);
	
	  var middlewares = [
	  // thunk, 
	  sagaMiddleware, routeMiddleware];
	
	  var enhancers = [_redux.applyMiddleware.apply(undefined, middlewares), (0, _reduxPersistImmutable.autoRehydrate)()];
	
	  var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
	    shouldHotReload: false
	  }) : _redux.compose;
	
	  var rootReducer = (0, _reduxImmutable.combineReducers)(Object.assign({}, _reducers2.default, {
	    router: _reactRouterRedux.routerReducer
	  }));
	  console.log(rootReducer);
	
	  var store = (0, _redux.createStore)(rootReducer, (0, _immutable.fromJS)(initialState), composeEnhancers.apply(undefined, enhancers));
	  sagaMiddleware.run(_sagas2.default);
	
	  return store;
	}
	// export default { store, history };

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1762), __esModule: true };

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1764), __esModule: true };

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1767), __esModule: true };

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1768), __esModule: true };

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1770), __esModule: true };

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1771), __esModule: true };

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1753);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(398);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(285);
	__webpack_require__(1794);
	module.exports = __webpack_require__(62).Array.from;


/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(413);
	__webpack_require__(285);
	module.exports = __webpack_require__(1792);


/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(413);
	__webpack_require__(285);
	module.exports = __webpack_require__(1793);


/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1796);
	module.exports = __webpack_require__(62).Object.assign;


/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1797);
	var $Object = __webpack_require__(62).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1798);
	var $Object = __webpack_require__(62).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1803);
	module.exports = __webpack_require__(62).Object.entries;


/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1799);
	module.exports = __webpack_require__(62).Object.getPrototypeOf;


/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1800);
	module.exports = __webpack_require__(62).Object.setPrototypeOf;


/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1804);
	module.exports = __webpack_require__(62).Object.values;


/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1802);
	__webpack_require__(1801);
	__webpack_require__(1805);
	__webpack_require__(1806);
	module.exports = __webpack_require__(62).Symbol;


/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(285);
	__webpack_require__(413);
	module.exports = __webpack_require__(412).f('iterator');


/***/ },
/* 1772 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 1773 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(146);
	var toLength = __webpack_require__(768);
	var toAbsoluteIndex = __webpack_require__(1791);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(120);
	var createDesc = __webpack_require__(220);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(218);
	var gOPS = __webpack_require__(405);
	var pIE = __webpack_require__(219);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(119).document;
	module.exports = document && document.documentElement;


/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(179);
	var ITERATOR = __webpack_require__(82)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(399);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(143);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(404);
	var descriptor = __webpack_require__(220);
	var setToStringTag = __webpack_require__(406);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(178)(IteratorPrototype, __webpack_require__(82)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(82)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 1783 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(284)('meta');
	var isObject = __webpack_require__(217);
	var has = __webpack_require__(145);
	var setDesc = __webpack_require__(120).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(177)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(218);
	var gOPS = __webpack_require__(405);
	var pIE = __webpack_require__(219);
	var toObject = __webpack_require__(283);
	var IObject = __webpack_require__(760);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(177)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(120);
	var anObject = __webpack_require__(143);
	var getKeys = __webpack_require__(218);
	
	module.exports = __webpack_require__(144) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(146);
	var gOPN = __webpack_require__(763).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(96);
	var core = __webpack_require__(62);
	var fails = __webpack_require__(177);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(217);
	var anObject = __webpack_require__(143);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(400)(Function.call, __webpack_require__(762).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(409);
	var defined = __webpack_require__(401);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(409);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(143);
	var get = __webpack_require__(769);
	module.exports = __webpack_require__(62).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(757);
	var ITERATOR = __webpack_require__(82)('iterator');
	var Iterators = __webpack_require__(179);
	module.exports = __webpack_require__(62).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(400);
	var $export = __webpack_require__(96);
	var toObject = __webpack_require__(283);
	var call = __webpack_require__(1780);
	var isArrayIter = __webpack_require__(1778);
	var toLength = __webpack_require__(768);
	var createProperty = __webpack_require__(1775);
	var getIterFn = __webpack_require__(769);
	
	$export($export.S + $export.F * !__webpack_require__(1782)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(1773);
	var step = __webpack_require__(1783);
	var Iterators = __webpack_require__(179);
	var toIObject = __webpack_require__(146);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(761)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(96);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1785) });


/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(96);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(404) });


/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(96);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(144), 'Object', { defineProperty: __webpack_require__(120).f });


/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(283);
	var $getPrototypeOf = __webpack_require__(764);
	
	__webpack_require__(1788)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(96);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1789).set });


/***/ },
/* 1801 */
466,
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(119);
	var has = __webpack_require__(145);
	var DESCRIPTORS = __webpack_require__(144);
	var $export = __webpack_require__(96);
	var redefine = __webpack_require__(767);
	var META = __webpack_require__(1784).KEY;
	var $fails = __webpack_require__(177);
	var shared = __webpack_require__(408);
	var setToStringTag = __webpack_require__(406);
	var uid = __webpack_require__(284);
	var wks = __webpack_require__(82);
	var wksExt = __webpack_require__(412);
	var wksDefine = __webpack_require__(411);
	var enumKeys = __webpack_require__(1776);
	var isArray = __webpack_require__(1779);
	var anObject = __webpack_require__(143);
	var toIObject = __webpack_require__(146);
	var toPrimitive = __webpack_require__(410);
	var createDesc = __webpack_require__(220);
	var _create = __webpack_require__(404);
	var gOPNExt = __webpack_require__(1787);
	var $GOPD = __webpack_require__(762);
	var $DP = __webpack_require__(120);
	var $keys = __webpack_require__(218);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(763).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(219).f = $propertyIsEnumerable;
	  __webpack_require__(405).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(403)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(178)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(96);
	var $entries = __webpack_require__(766)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(96);
	var $values = __webpack_require__(766)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(411)('asyncIterator');


/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(411)('observable');


/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(415);
	var Transform = __webpack_require__(416);
	var inherits = __webpack_require__(98);
	var modes = __webpack_require__(417);
	var StreamCipher = __webpack_require__(776);
	var ebtk = __webpack_require__(770);
	
	inherits(Decipher, Transform);
	function Decipher(mode, key, iv) {
	  if (!(this instanceof Decipher)) {
	    return new Decipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._last = void 0;
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Decipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.decrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Decipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  if (!chunk) {
	    return next;
	  }
	
	  this.push(unpad(this._mode.decrypt(this, chunk)));
	
	  next();
	};
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 16) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  if (this.cache.length) {
	    return this.cache;
	  }
	};
	function unpad(last) {
	  var padded = last[15];
	  if (padded === 16) {
	    return;
	  }
	  return last.slice(0, 16 - padded);
	}
	
	var modelist = {
	  ECB: __webpack_require__(774),
	  CBC: __webpack_require__(771),
	  CFB: __webpack_require__(772),
	  OFB: __webpack_require__(775),
	  CTR: __webpack_require__(773)
	};
	
	module.exports = function (crypto) {
	  function createDecipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv, true);
	    }
	    return new Decipher(modelist[config.mode], password, iv);
	  }
	
	  function createDecipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createDecipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createDecipher: createDecipher,
	    createDecipheriv: createDecipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var aes = __webpack_require__(415);
	var Transform = __webpack_require__(416);
	var inherits = __webpack_require__(98);
	var modes = __webpack_require__(417);
	var ebtk = __webpack_require__(770);
	var StreamCipher = __webpack_require__(776);
	inherits(Cipher, Transform);
	function Cipher(mode, key, iv) {
	  if (!(this instanceof Cipher)) {
	    return new Cipher(mode, key, iv);
	  }
	  Transform.call(this);
	  this._cache = new Splitter();
	  this._cipher = new aes.AES(key);
	  this._prev = new Buffer(iv.length);
	  iv.copy(this._prev);
	  this._mode = mode;
	}
	Cipher.prototype._transform = function (data, _, next) {
	  this._cache.add(data);
	  var chunk;
	  var thing;
	  while ((chunk = this._cache.get())) {
	    thing = this._mode.encrypt(this, chunk);
	    this.push(thing);
	  }
	  next();
	};
	Cipher.prototype._flush = function (next) {
	  var chunk = this._cache.flush();
	  this.push(this._mode.encrypt(this, chunk));
	  this._cipher.scrub();
	  next();
	};
	
	
	function Splitter() {
	   if (!(this instanceof Splitter)) {
	    return new Splitter();
	  }
	  this.cache = new Buffer('');
	}
	Splitter.prototype.add = function (data) {
	  this.cache = Buffer.concat([this.cache, data]);
	};
	
	Splitter.prototype.get = function () {
	  if (this.cache.length > 15) {
	    var out = this.cache.slice(0, 16);
	    this.cache = this.cache.slice(16);
	    return out;
	  }
	  return null;
	};
	Splitter.prototype.flush = function () {
	  var len = 16 - this.cache.length;
	  var padBuff = new Buffer(len);
	
	  var i = -1;
	  while (++i < len) {
	    padBuff.writeUInt8(len, i);
	  }
	  var out = Buffer.concat([this.cache, padBuff]);
	  return out;
	};
	var modelist = {
	  ECB: __webpack_require__(774),
	  CBC: __webpack_require__(771),
	  CFB: __webpack_require__(772),
	  OFB: __webpack_require__(775),
	  CTR: __webpack_require__(773)
	};
	module.exports = function (crypto) {
	  function createCipheriv(suite, password, iv) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    if (typeof iv === 'string') {
	      iv = new Buffer(iv);
	    }
	    if (typeof password === 'string') {
	      password = new Buffer(password);
	    }
	    if (password.length !== config.key/8) {
	      throw new TypeError('invalid key length ' + password.length);
	    }
	    if (iv.length !== config.iv) {
	      throw new TypeError('invalid iv length ' + iv.length);
	    }
	    if (config.type === 'stream') {
	      return new StreamCipher(modelist[config.mode], password, iv);
	    }
	    return new Cipher(modelist[config.mode], password, iv);
	  }
	  function createCipher (suite, password) {
	    var config = modes[suite];
	    if (!config) {
	      throw new TypeError('invalid suite type');
	    }
	    var keys = ebtk(crypto, password, config.key, config.iv);
	    return createCipheriv(suite, keys.key, keys.iv);
	  }
	  return {
	    createCipher: createCipher,
	    createCipheriv: createCipheriv
	  };
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function (crypto, exports) {
	  exports = exports || {};
	  var ciphers = __webpack_require__(1808)(crypto);
	  exports.createCipher = ciphers.createCipher;
	  exports.createCipheriv = ciphers.createCipheriv;
	  var deciphers = __webpack_require__(1807)(crypto);
	  exports.createDecipher = deciphers.createDecipher;
	  exports.createDecipheriv = deciphers.createDecipheriv;
	  var modes = __webpack_require__(417);
	  function listCiphers () {
	    return Object.keys(modes);
	  }
	  exports.listCiphers = listCiphers;
	};
	


/***/ },
/* 1810 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 777,
		"./af.js": 777,
		"./ar": 784,
		"./ar-dz": 778,
		"./ar-dz.js": 778,
		"./ar-kw": 779,
		"./ar-kw.js": 779,
		"./ar-ly": 780,
		"./ar-ly.js": 780,
		"./ar-ma": 781,
		"./ar-ma.js": 781,
		"./ar-sa": 782,
		"./ar-sa.js": 782,
		"./ar-tn": 783,
		"./ar-tn.js": 783,
		"./ar.js": 784,
		"./az": 785,
		"./az.js": 785,
		"./be": 786,
		"./be.js": 786,
		"./bg": 787,
		"./bg.js": 787,
		"./bn": 788,
		"./bn.js": 788,
		"./bo": 789,
		"./bo.js": 789,
		"./br": 790,
		"./br.js": 790,
		"./bs": 791,
		"./bs.js": 791,
		"./ca": 792,
		"./ca.js": 792,
		"./cs": 793,
		"./cs.js": 793,
		"./cv": 794,
		"./cv.js": 794,
		"./cy": 795,
		"./cy.js": 795,
		"./da": 796,
		"./da.js": 796,
		"./de": 799,
		"./de-at": 797,
		"./de-at.js": 797,
		"./de-ch": 798,
		"./de-ch.js": 798,
		"./de.js": 799,
		"./dv": 800,
		"./dv.js": 800,
		"./el": 801,
		"./el.js": 801,
		"./en-au": 802,
		"./en-au.js": 802,
		"./en-ca": 803,
		"./en-ca.js": 803,
		"./en-gb": 804,
		"./en-gb.js": 804,
		"./en-ie": 805,
		"./en-ie.js": 805,
		"./en-nz": 806,
		"./en-nz.js": 806,
		"./eo": 807,
		"./eo.js": 807,
		"./es": 809,
		"./es-do": 808,
		"./es-do.js": 808,
		"./es.js": 809,
		"./et": 810,
		"./et.js": 810,
		"./eu": 811,
		"./eu.js": 811,
		"./fa": 812,
		"./fa.js": 812,
		"./fi": 813,
		"./fi.js": 813,
		"./fo": 814,
		"./fo.js": 814,
		"./fr": 817,
		"./fr-ca": 815,
		"./fr-ca.js": 815,
		"./fr-ch": 816,
		"./fr-ch.js": 816,
		"./fr.js": 817,
		"./fy": 818,
		"./fy.js": 818,
		"./gd": 819,
		"./gd.js": 819,
		"./gl": 820,
		"./gl.js": 820,
		"./gom-latn": 821,
		"./gom-latn.js": 821,
		"./he": 822,
		"./he.js": 822,
		"./hi": 823,
		"./hi.js": 823,
		"./hr": 824,
		"./hr.js": 824,
		"./hu": 825,
		"./hu.js": 825,
		"./hy-am": 826,
		"./hy-am.js": 826,
		"./id": 827,
		"./id.js": 827,
		"./is": 828,
		"./is.js": 828,
		"./it": 829,
		"./it.js": 829,
		"./ja": 830,
		"./ja.js": 830,
		"./jv": 831,
		"./jv.js": 831,
		"./ka": 832,
		"./ka.js": 832,
		"./kk": 833,
		"./kk.js": 833,
		"./km": 834,
		"./km.js": 834,
		"./kn": 835,
		"./kn.js": 835,
		"./ko": 836,
		"./ko.js": 836,
		"./ky": 837,
		"./ky.js": 837,
		"./lb": 838,
		"./lb.js": 838,
		"./lo": 839,
		"./lo.js": 839,
		"./lt": 840,
		"./lt.js": 840,
		"./lv": 841,
		"./lv.js": 841,
		"./me": 842,
		"./me.js": 842,
		"./mi": 843,
		"./mi.js": 843,
		"./mk": 844,
		"./mk.js": 844,
		"./ml": 845,
		"./ml.js": 845,
		"./mr": 846,
		"./mr.js": 846,
		"./ms": 848,
		"./ms-my": 847,
		"./ms-my.js": 847,
		"./ms.js": 848,
		"./my": 849,
		"./my.js": 849,
		"./nb": 850,
		"./nb.js": 850,
		"./ne": 851,
		"./ne.js": 851,
		"./nl": 853,
		"./nl-be": 852,
		"./nl-be.js": 852,
		"./nl.js": 853,
		"./nn": 854,
		"./nn.js": 854,
		"./pa-in": 855,
		"./pa-in.js": 855,
		"./pl": 856,
		"./pl.js": 856,
		"./pt": 858,
		"./pt-br": 857,
		"./pt-br.js": 857,
		"./pt.js": 858,
		"./ro": 859,
		"./ro.js": 859,
		"./ru": 860,
		"./ru.js": 860,
		"./sd": 861,
		"./sd.js": 861,
		"./se": 862,
		"./se.js": 862,
		"./si": 863,
		"./si.js": 863,
		"./sk": 864,
		"./sk.js": 864,
		"./sl": 865,
		"./sl.js": 865,
		"./sq": 866,
		"./sq.js": 866,
		"./sr": 868,
		"./sr-cyrl": 867,
		"./sr-cyrl.js": 867,
		"./sr.js": 868,
		"./ss": 869,
		"./ss.js": 869,
		"./sv": 870,
		"./sv.js": 870,
		"./sw": 871,
		"./sw.js": 871,
		"./ta": 872,
		"./ta.js": 872,
		"./te": 873,
		"./te.js": 873,
		"./tet": 874,
		"./tet.js": 874,
		"./th": 875,
		"./th.js": 875,
		"./tl-ph": 876,
		"./tl-ph.js": 876,
		"./tlh": 877,
		"./tlh.js": 877,
		"./tr": 878,
		"./tr.js": 878,
		"./tzl": 879,
		"./tzl.js": 879,
		"./tzm": 881,
		"./tzm-latn": 880,
		"./tzm-latn.js": 880,
		"./tzm.js": 881,
		"./uk": 882,
		"./uk.js": 882,
		"./ur": 883,
		"./ur.js": 883,
		"./uz": 885,
		"./uz-latn": 884,
		"./uz-latn.js": 884,
		"./uz.js": 885,
		"./vi": 886,
		"./vi.js": 886,
		"./x-pseudo": 887,
		"./x-pseudo.js": 887,
		"./yo": 888,
		"./yo.js": 888,
		"./zh-cn": 889,
		"./zh-cn.js": 889,
		"./zh-hk": 890,
		"./zh-hk.js": 890,
		"./zh-tw": 891,
		"./zh-tw.js": 891
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1811;


/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @namespace Chart
	 */
	var Chart = __webpack_require__(1831)();
	
	Chart.helpers = __webpack_require__(23);
	
	// @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
	__webpack_require__(1830)(Chart);
	
	Chart.defaults = __webpack_require__(34);
	Chart.Element = __webpack_require__(83);
	Chart.elements = __webpack_require__(121);
	Chart.Interaction = __webpack_require__(892);
	Chart.platform = __webpack_require__(893);
	
	__webpack_require__(1833)(Chart);
	__webpack_require__(1827)(Chart);
	__webpack_require__(1828)(Chart);
	__webpack_require__(1829)(Chart);
	__webpack_require__(1832)(Chart);
	__webpack_require__(1835)(Chart);
	__webpack_require__(1834)(Chart);
	__webpack_require__(1836)(Chart);
	
	__webpack_require__(1851)(Chart);
	__webpack_require__(1849)(Chart);
	__webpack_require__(1850)(Chart);
	__webpack_require__(1852)(Chart);
	__webpack_require__(1853)(Chart);
	__webpack_require__(1854)(Chart);
	
	// Controllers must be loaded after elements
	// See Chart.core.datasetController.dataElementType
	__webpack_require__(1820)(Chart);
	__webpack_require__(1821)(Chart);
	__webpack_require__(1822)(Chart);
	__webpack_require__(1823)(Chart);
	__webpack_require__(1824)(Chart);
	__webpack_require__(1825)(Chart);
	__webpack_require__(1826)(Chart);
	
	__webpack_require__(1813)(Chart);
	__webpack_require__(1814)(Chart);
	__webpack_require__(1815)(Chart);
	__webpack_require__(1816)(Chart);
	__webpack_require__(1817)(Chart);
	__webpack_require__(1818)(Chart);
	__webpack_require__(1819)(Chart);
	
	// Loading built-it plugins
	var plugins = [];
	
	plugins.push(
		__webpack_require__(1846)(Chart),
		__webpack_require__(1847)(Chart),
		__webpack_require__(1848)(Chart)
	);
	
	Chart.plugins.register(plugins);
	
	Chart.platform.initialize();
	
	module.exports = Chart;
	if (typeof window !== 'undefined') {
		window.Chart = Chart;
	}
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas instead.
	 * @namespace Chart.canvasHelpers
	 * @deprecated since version 2.6.0
	 * @todo remove at version 3
	 * @private
	 */
	Chart.canvasHelpers = Chart.helpers.canvas;


/***/ },
/* 1813 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bar = function(context, config) {
			config.type = 'bar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 1814 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Bubble = function(context, config) {
			config.type = 'bubble';
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 1815 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Doughnut = function(context, config) {
			config.type = 'doughnut';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 1816 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Line = function(context, config) {
			config.type = 'line';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 1817 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.PolarArea = function(context, config) {
			config.type = 'polarArea';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 1818 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		Chart.Radar = function(context, config) {
			config.type = 'radar';
	
			return new Chart(context, config);
		};
	
	};


/***/ },
/* 1819 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
		Chart.Scatter = function(context, config) {
			config.type = 'scatter';
			return new Chart(context, config);
		};
	};


/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('bar', {
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
	
				// Specific to Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}],
	
			yAxes: [{
				type: 'linear'
			}]
		}
	});
	
	defaults._set('horizontalBar', {
		hover: {
			mode: 'index',
			axis: 'y'
		},
	
		scales: {
			xAxes: [{
				type: 'linear',
				position: 'bottom'
			}],
	
			yAxes: [{
				position: 'left',
				type: 'category',
	
				// Specific to Horizontal Bar Controller
				categoryPercentage: 0.8,
				barPercentage: 0.9,
	
				// offset settings
				offset: true,
	
				// grid line settings
				gridLines: {
					offsetGridLines: true
				}
			}]
		},
	
		elements: {
			rectangle: {
				borderSkipped: 'left'
			}
		},
	
		tooltips: {
			callbacks: {
				title: function(item, data) {
					// Pick first xLabel for now
					var title = '';
	
					if (item.length > 0) {
						if (item[0].yLabel) {
							title = item[0].yLabel;
						} else if (data.labels.length > 0 && item[0].index < data.labels.length) {
							title = data.labels[item[0].index];
						}
					}
	
					return title;
				},
	
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					return datasetLabel + ': ' + item.xLabel;
				}
			},
			mode: 'index',
			axis: 'y'
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.bar = Chart.DatasetController.extend({
	
			dataElementType: elements.Rectangle,
	
			initialize: function() {
				var me = this;
				var meta;
	
				Chart.DatasetController.prototype.initialize.apply(me, arguments);
	
				meta = me.getMeta();
				meta.stack = me.getDataset().stack;
				meta.bar = true;
			},
	
			update: function(reset) {
				var me = this;
				var rects = me.getMeta().data;
				var i, ilen;
	
				me._ruler = me.getRuler();
	
				for (i = 0, ilen = rects.length; i < ilen; ++i) {
					me.updateElement(rects[i], i, reset);
				}
			},
	
			updateElement: function(rectangle, index, reset) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var dataset = me.getDataset();
				var custom = rectangle.custom || {};
				var rectangleOptions = chart.options.elements.rectangle;
	
				rectangle._xScale = me.getScaleForId(meta.xAxisID);
				rectangle._yScale = me.getScaleForId(meta.yAxisID);
				rectangle._datasetIndex = me.index;
				rectangle._index = index;
	
				rectangle._model = {
					datasetLabel: dataset.label,
					label: chart.data.labels[index],
					borderSkipped: custom.borderSkipped ? custom.borderSkipped : rectangleOptions.borderSkipped,
					backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleOptions.backgroundColor),
					borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleOptions.borderColor),
					borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleOptions.borderWidth)
				};
	
				me.updateElementGeometry(rectangle, index, reset);
	
				rectangle.pivot();
			},
	
			/**
			 * @private
			 */
			updateElementGeometry: function(rectangle, index, reset) {
				var me = this;
				var model = rectangle._model;
				var vscale = me.getValueScale();
				var base = vscale.getBasePixel();
				var horizontal = vscale.isHorizontal();
				var ruler = me._ruler || me.getRuler();
				var vpixels = me.calculateBarValuePixels(me.index, index);
				var ipixels = me.calculateBarIndexPixels(me.index, index, ruler);
	
				model.horizontal = horizontal;
				model.base = reset ? base : vpixels.base;
				model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
				model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
				model.height = horizontal ? ipixels.size : undefined;
				model.width = horizontal ? undefined : ipixels.size;
			},
	
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().yAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getValueScale: function() {
				return this.getScaleForId(this.getValueScaleId());
			},
	
			/**
			 * @private
			 */
			getIndexScale: function() {
				return this.getScaleForId(this.getIndexScaleId());
			},
	
			/**
			 * Returns the effective number of stacks based on groups and bar visibility.
			 * @private
			 */
			getStackCount: function(last) {
				var me = this;
				var chart = me.chart;
				var scale = me.getIndexScale();
				var stacked = scale.options.stacked;
				var ilen = last === undefined ? chart.data.datasets.length : last + 1;
				var stacks = [];
				var i, meta;
	
				for (i = 0; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					if (meta.bar && chart.isDatasetVisible(i) &&
						(stacked === false ||
						(stacked === true && stacks.indexOf(meta.stack) === -1) ||
						(stacked === undefined && (meta.stack === undefined || stacks.indexOf(meta.stack) === -1)))) {
						stacks.push(meta.stack);
					}
				}
	
				return stacks.length;
			},
	
			/**
			 * Returns the stack index for the given dataset based on groups and bar visibility.
			 * @private
			 */
			getStackIndex: function(datasetIndex) {
				return this.getStackCount(datasetIndex) - 1;
			},
	
			/**
			 * @private
			 */
			getRuler: function() {
				var me = this;
				var scale = me.getIndexScale();
				var stackCount = me.getStackCount();
				var datasetIndex = me.index;
				var pixels = [];
				var isHorizontal = scale.isHorizontal();
				var start = isHorizontal ? scale.left : scale.top;
				var end = start + (isHorizontal ? scale.width : scale.height);
				var i, ilen;
	
				for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
					pixels.push(scale.getPixelForValue(null, i, datasetIndex));
				}
	
				return {
					pixels: pixels,
					start: start,
					end: end,
					stackCount: stackCount,
					scale: scale
				};
			},
	
			/**
			 * Note: pixel values are not clamped to the scale area.
			 * @private
			 */
			calculateBarValuePixels: function(datasetIndex, index) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var scale = me.getValueScale();
				var datasets = chart.data.datasets;
				var value = scale.getRightValue(datasets[datasetIndex].data[index]);
				var stacked = scale.options.stacked;
				var stack = meta.stack;
				var start = 0;
				var i, imeta, ivalue, base, head, size;
	
				if (stacked || (stacked === undefined && stack !== undefined)) {
					for (i = 0; i < datasetIndex; ++i) {
						imeta = chart.getDatasetMeta(i);
	
						if (imeta.bar &&
							imeta.stack === stack &&
							imeta.controller.getValueScaleId() === scale.id &&
							chart.isDatasetVisible(i)) {
	
							ivalue = scale.getRightValue(datasets[i].data[index]);
							if ((value < 0 && ivalue < 0) || (value >= 0 && ivalue > 0)) {
								start += ivalue;
							}
						}
					}
				}
	
				base = scale.getPixelForValue(start);
				head = scale.getPixelForValue(start + value);
				size = (head - base) / 2;
	
				return {
					size: size,
					base: base,
					head: head,
					center: head + size / 2
				};
			},
	
			/**
			 * @private
			 */
			calculateBarIndexPixels: function(datasetIndex, index, ruler) {
				var me = this;
				var options = ruler.scale.options;
				var stackIndex = me.getStackIndex(datasetIndex);
				var pixels = ruler.pixels;
				var base = pixels[index];
				var length = pixels.length;
				var start = ruler.start;
				var end = ruler.end;
				var leftSampleSize, rightSampleSize, leftCategorySize, rightCategorySize, fullBarSize, size;
	
				if (length === 1) {
					leftSampleSize = base > start ? base - start : end - base;
					rightSampleSize = base < end ? end - base : base - start;
				} else {
					if (index > 0) {
						leftSampleSize = (base - pixels[index - 1]) / 2;
						if (index === length - 1) {
							rightSampleSize = leftSampleSize;
						}
					}
					if (index < length - 1) {
						rightSampleSize = (pixels[index + 1] - base) / 2;
						if (index === 0) {
							leftSampleSize = rightSampleSize;
						}
					}
				}
	
				leftCategorySize = leftSampleSize * options.categoryPercentage;
				rightCategorySize = rightSampleSize * options.categoryPercentage;
				fullBarSize = (leftCategorySize + rightCategorySize) / ruler.stackCount;
				size = fullBarSize * options.barPercentage;
	
				size = Math.min(
					helpers.valueOrDefault(options.barThickness, size),
					helpers.valueOrDefault(options.maxBarThickness, Infinity));
	
				base -= leftCategorySize;
				base += fullBarSize * stackIndex;
				base += (fullBarSize - size) / 2;
	
				return {
					size: size,
					base: base,
					head: base + size,
					center: base + size / 2
				};
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var scale = me.getValueScale();
				var rects = me.getMeta().data;
				var dataset = me.getDataset();
				var ilen = rects.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, chart.chartArea);
	
				for (; i < ilen; ++i) {
					if (!isNaN(scale.getRightValue(dataset.data[i]))) {
						rects[i].draw();
					}
				}
	
				helpers.canvas.unclipArea(chart.ctx);
			},
	
			setHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.hoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.hoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(rectangle) {
				var dataset = this.chart.data.datasets[rectangle._datasetIndex];
				var index = rectangle._index;
				var custom = rectangle.custom || {};
				var model = rectangle._model;
				var rectangleElementOptions = this.chart.options.elements.rectangle;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.backgroundColor, index, rectangleElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.borderColor, index, rectangleElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.borderWidth, index, rectangleElementOptions.borderWidth);
			}
		});
	
		Chart.controllers.horizontalBar = Chart.controllers.bar.extend({
			/**
			 * @private
			 */
			getValueScaleId: function() {
				return this.getMeta().xAxisID;
			},
	
			/**
			 * @private
			 */
			getIndexScaleId: function() {
				return this.getMeta().yAxisID;
			}
		});
	};


/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('bubble', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				type: 'linear', // bubble should probably use a linear scale by default
				position: 'bottom',
				id: 'x-axis-0' // need an ID so datasets can reference the scale
			}],
			yAxes: [{
				type: 'linear',
				position: 'left',
				id: 'y-axis-0'
			}]
		},
	
		tooltips: {
			callbacks: {
				title: function() {
					// Title doesn't make sense for scatter since we format the data as a point
					return '';
				},
				label: function(item, data) {
					var datasetLabel = data.datasets[item.datasetIndex].label || '';
					var dataPoint = data.datasets[item.datasetIndex].data[item.index];
					return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
				}
			}
		}
	});
	
	
	module.exports = function(Chart) {
	
		Chart.controllers.bubble = Chart.DatasetController.extend({
			/**
			 * @protected
			 */
			dataElementType: elements.Point,
	
			/**
			 * @protected
			 */
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var points = meta.data;
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				});
			},
	
			/**
			 * @protected
			 */
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var xScale = me.getScaleForId(meta.xAxisID);
				var yScale = me.getScaleForId(meta.yAxisID);
				var options = me._resolveElementOptions(point, index);
				var data = me.getDataset().data[index];
				var dsIndex = me.index;
	
				var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(typeof data === 'object' ? data : NaN, index, dsIndex);
				var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
	
				point._xScale = xScale;
				point._yScale = yScale;
				point._options = options;
				point._datasetIndex = dsIndex;
				point._index = index;
				point._model = {
					backgroundColor: options.backgroundColor,
					borderColor: options.borderColor,
					borderWidth: options.borderWidth,
					hitRadius: options.hitRadius,
					pointStyle: options.pointStyle,
					radius: reset ? 0 : options.radius,
					skip: custom.skip || isNaN(x) || isNaN(y),
					x: x,
					y: y,
				};
	
				point.pivot();
			},
	
			/**
			 * @protected
			 */
			setHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = helpers.valueOrDefault(options.hoverBackgroundColor, helpers.getHoverColor(options.backgroundColor));
				model.borderColor = helpers.valueOrDefault(options.hoverBorderColor, helpers.getHoverColor(options.borderColor));
				model.borderWidth = helpers.valueOrDefault(options.hoverBorderWidth, options.borderWidth);
				model.radius = options.radius + options.hoverRadius;
			},
	
			/**
			 * @protected
			 */
			removeHoverStyle: function(point) {
				var model = point._model;
				var options = point._options;
	
				model.backgroundColor = options.backgroundColor;
				model.borderColor = options.borderColor;
				model.borderWidth = options.borderWidth;
				model.radius = options.radius;
			},
	
			/**
			 * @private
			 */
			_resolveElementOptions: function(point, index) {
				var me = this;
				var chart = me.chart;
				var datasets = chart.data.datasets;
				var dataset = datasets[me.index];
				var custom = point.custom || {};
				var options = chart.options.elements.point;
				var resolve = helpers.options.resolve;
				var data = dataset.data[index];
				var values = {};
				var i, ilen, key;
	
				// Scriptable options
				var context = {
					chart: chart,
					dataIndex: index,
					dataset: dataset,
					datasetIndex: me.index
				};
	
				var keys = [
					'backgroundColor',
					'borderColor',
					'borderWidth',
					'hoverBackgroundColor',
					'hoverBorderColor',
					'hoverBorderWidth',
					'hoverRadius',
					'hitRadius',
					'pointStyle'
				];
	
				for (i = 0, ilen = keys.length; i < ilen; ++i) {
					key = keys[i];
					values[key] = resolve([
						custom[key],
						dataset[key],
						options[key]
					], context, index);
				}
	
				// Custom radius resolution
				values.radius = resolve([
					custom.radius,
					data ? data.r : undefined,
					dataset.radius,
					options.radius
				], context, index);
	
				return values;
			}
		});
	};


/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('doughnut', {
		animation: {
			// Boolean - Whether we animate the rotation of the Doughnut
			animateRotate: true,
			// Boolean - Whether we animate scaling the Doughnut from the centre
			animateScale: false
		},
		hover: {
			mode: 'single'
		},
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc && arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					// toggle visibility of index if exists
					if (meta.data[index]) {
						meta.data[index].hidden = !meta.data[index].hidden;
					}
				}
	
				chart.update();
			}
		},
	
		// The percentage of the chart that we cut out of the middle.
		cutoutPercentage: 50,
	
		// The rotation of the chart, where the first data arc begins.
		rotation: Math.PI * -0.5,
	
		// The total circumference of the chart.
		circumference: Math.PI * 2.0,
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(tooltipItem, data) {
					var dataLabel = data.labels[tooltipItem.index];
					var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
	
					if (helpers.isArray(dataLabel)) {
						// show value on first line of multiline label
						// need to clone because we are changing the value
						dataLabel = dataLabel.slice();
						dataLabel[0] += value;
					} else {
						dataLabel += value;
					}
	
					return dataLabel;
				}
			}
		}
	});
	
	defaults._set('pie', helpers.clone(defaults.doughnut));
	defaults._set('pie', {
		cutoutPercentage: 0
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.doughnut = Chart.controllers.pie = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			// Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
			getRingIndex: function(datasetIndex) {
				var ringIndex = 0;
	
				for (var j = 0; j < datasetIndex; ++j) {
					if (this.chart.isDatasetVisible(j)) {
						++ringIndex;
					}
				}
	
				return ringIndex;
			},
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var availableWidth = chartArea.right - chartArea.left - arcOpts.borderWidth;
				var availableHeight = chartArea.bottom - chartArea.top - arcOpts.borderWidth;
				var minSize = Math.min(availableWidth, availableHeight);
				var offset = {x: 0, y: 0};
				var meta = me.getMeta();
				var cutoutPercentage = opts.cutoutPercentage;
				var circumference = opts.circumference;
	
				// If the chart's circumference isn't a full circle, calculate minSize as a ratio of the width/height of the arc
				if (circumference < Math.PI * 2.0) {
					var startAngle = opts.rotation % (Math.PI * 2.0);
					startAngle += Math.PI * 2.0 * (startAngle >= Math.PI ? -1 : startAngle < -Math.PI ? 1 : 0);
					var endAngle = startAngle + circumference;
					var start = {x: Math.cos(startAngle), y: Math.sin(startAngle)};
					var end = {x: Math.cos(endAngle), y: Math.sin(endAngle)};
					var contains0 = (startAngle <= 0 && endAngle >= 0) || (startAngle <= Math.PI * 2.0 && Math.PI * 2.0 <= endAngle);
					var contains90 = (startAngle <= Math.PI * 0.5 && Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 2.5 && Math.PI * 2.5 <= endAngle);
					var contains180 = (startAngle <= -Math.PI && -Math.PI <= endAngle) || (startAngle <= Math.PI && Math.PI <= endAngle);
					var contains270 = (startAngle <= -Math.PI * 0.5 && -Math.PI * 0.5 <= endAngle) || (startAngle <= Math.PI * 1.5 && Math.PI * 1.5 <= endAngle);
					var cutout = cutoutPercentage / 100.0;
					var min = {x: contains180 ? -1 : Math.min(start.x * (start.x < 0 ? 1 : cutout), end.x * (end.x < 0 ? 1 : cutout)), y: contains270 ? -1 : Math.min(start.y * (start.y < 0 ? 1 : cutout), end.y * (end.y < 0 ? 1 : cutout))};
					var max = {x: contains0 ? 1 : Math.max(start.x * (start.x > 0 ? 1 : cutout), end.x * (end.x > 0 ? 1 : cutout)), y: contains90 ? 1 : Math.max(start.y * (start.y > 0 ? 1 : cutout), end.y * (end.y > 0 ? 1 : cutout))};
					var size = {width: (max.x - min.x) * 0.5, height: (max.y - min.y) * 0.5};
					minSize = Math.min(availableWidth / size.width, availableHeight / size.height);
					offset = {x: (max.x + min.x) * -0.5, y: (max.y + min.y) * -0.5};
				}
	
				chart.borderWidth = me.getMaxBorderWidth(meta.data);
				chart.outerRadius = Math.max((minSize - chart.borderWidth) / 2, 0);
				chart.innerRadius = Math.max(cutoutPercentage ? (chart.outerRadius / 100) * (cutoutPercentage) : 0, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
				chart.offsetX = offset.x * chart.outerRadius;
				chart.offsetY = offset.y * chart.outerRadius;
	
				meta.total = me.calculateTotal();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.getRingIndex(me.index));
				me.innerRadius = Math.max(me.outerRadius - chart.radiusLength, 0);
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var opts = chart.options;
				var animationOpts = opts.animation;
				var centerX = (chartArea.left + chartArea.right) / 2;
				var centerY = (chartArea.top + chartArea.bottom) / 2;
				var startAngle = opts.rotation; // non reset case handled later
				var endAngle = opts.rotation; // non reset case handled later
				var dataset = me.getDataset();
				var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / (2.0 * Math.PI));
				var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
				var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
				var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
	
					// Desired view properties
					_model: {
						x: centerX + chart.offsetX,
						y: centerY + chart.offsetY,
						startAngle: startAngle,
						endAngle: endAngle,
						circumference: circumference,
						outerRadius: outerRadius,
						innerRadius: innerRadius,
						label: valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
					}
				});
	
				var model = arc._model;
				// Resets the visual styles
				this.removeHoverStyle(arc);
	
				// Set correct angles if not resetting
				if (!reset || !animationOpts.animateRotate) {
					if (index === 0) {
						model.startAngle = opts.rotation;
					} else {
						model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
					}
	
					model.endAngle = model.startAngle + model.circumference;
				}
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			calculateTotal: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var total = 0;
				var value;
	
				helpers.each(meta.data, function(element, index) {
					value = dataset.data[index];
					if (!isNaN(value) && !element.hidden) {
						total += Math.abs(value);
					}
				});
	
				/* if (total === 0) {
					total = NaN;
				}*/
	
				return total;
			},
	
			calculateCircumference: function(value) {
				var total = this.getMeta().total;
				if (total > 0 && !isNaN(value)) {
					return (Math.PI * 2.0) * (value / total);
				}
				return 0;
			},
	
			// gets the max border or hover width to properly scale pie charts
			getMaxBorderWidth: function(arcs) {
				var max = 0;
				var index = this.index;
				var length = arcs.length;
				var borderWidth;
				var hoverWidth;
	
				for (var i = 0; i < length; i++) {
					borderWidth = arcs[i]._model ? arcs[i]._model.borderWidth : 0;
					hoverWidth = arcs[i]._chart ? arcs[i]._chart.config.data.datasets[index].hoverBorderWidth : 0;
	
					max = borderWidth > max ? borderWidth : max;
					max = hoverWidth > max ? hoverWidth : max;
				}
				return max;
			}
		});
	};


/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('line', {
		showLines: true,
		spanGaps: false,
	
		hover: {
			mode: 'label'
		},
	
		scales: {
			xAxes: [{
				type: 'category',
				id: 'x-axis-0'
			}],
			yAxes: [{
				type: 'linear',
				id: 'y-axis-0'
			}]
		}
	});
	
	module.exports = function(Chart) {
	
		function lineEnabled(dataset, options) {
			return helpers.valueOrDefault(dataset.showLine, options.showLines);
		}
	
		Chart.controllers.line = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data || [];
				var options = me.chart.options;
				var lineElementOptions = options.elements.line;
				var scale = me.getScaleForId(meta.yAxisID);
				var i, ilen, custom;
				var dataset = me.getDataset();
				var showLine = lineEnabled(dataset, options);
	
				// Update Line
				if (showLine) {
					custom = line.custom || {};
	
					// Compatibility: If the properties are defined with only the old name, use those values
					if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
						dataset.lineTension = dataset.tension;
					}
	
					// Utility
					line._scale = scale;
					line._datasetIndex = me.index;
					// Data
					line._children = points;
					// Model
					line._model = {
						// Appearance
						// The default behavior of lines is to break at null values, according
						// to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
						// This option gives lines the ability to span gaps
						spanGaps: dataset.spanGaps ? dataset.spanGaps : options.spanGaps,
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						steppedLine: custom.steppedLine ? custom.steppedLine : helpers.valueOrDefault(dataset.steppedLine, lineElementOptions.stepped),
						cubicInterpolationMode: custom.cubicInterpolationMode ? custom.cubicInterpolationMode : helpers.valueOrDefault(dataset.cubicInterpolationMode, lineElementOptions.cubicInterpolationMode),
					};
	
					line.pivot();
				}
	
				// Update Points
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					me.updateElement(points[i], i, reset);
				}
	
				if (showLine && line._model.tension !== 0) {
					me.updateBezierControlPoints();
				}
	
				// Now pivot the point for animation
				for (i = 0, ilen = points.length; i < ilen; ++i) {
					points[i].pivot();
				}
			},
	
			getPointBackgroundColor: function(point, index) {
				var backgroundColor = this.chart.options.elements.point.backgroundColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.backgroundColor) {
					backgroundColor = custom.backgroundColor;
				} else if (dataset.pointBackgroundColor) {
					backgroundColor = helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, backgroundColor);
				} else if (dataset.backgroundColor) {
					backgroundColor = dataset.backgroundColor;
				}
	
				return backgroundColor;
			},
	
			getPointBorderColor: function(point, index) {
				var borderColor = this.chart.options.elements.point.borderColor;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (custom.borderColor) {
					borderColor = custom.borderColor;
				} else if (dataset.pointBorderColor) {
					borderColor = helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, borderColor);
				} else if (dataset.borderColor) {
					borderColor = dataset.borderColor;
				}
	
				return borderColor;
			},
	
			getPointBorderWidth: function(point, index) {
				var borderWidth = this.chart.options.elements.point.borderWidth;
				var dataset = this.getDataset();
				var custom = point.custom || {};
	
				if (!isNaN(custom.borderWidth)) {
					borderWidth = custom.borderWidth;
				} else if (!isNaN(dataset.pointBorderWidth) || helpers.isArray(dataset.pointBorderWidth)) {
					borderWidth = helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, borderWidth);
				} else if (!isNaN(dataset.borderWidth)) {
					borderWidth = dataset.borderWidth;
				}
	
				return borderWidth;
			},
	
			updateElement: function(point, index, reset) {
				var me = this;
				var meta = me.getMeta();
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var datasetIndex = me.index;
				var value = dataset.data[index];
				var yScale = me.getScaleForId(meta.yAxisID);
				var xScale = me.getScaleForId(meta.xAxisID);
				var pointOptions = me.chart.options.elements.point;
				var x, y;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				x = xScale.getPixelForValue(typeof value === 'object' ? value : NaN, index, datasetIndex);
				y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);
	
				// Utility
				point._xScale = xScale;
				point._yScale = yScale;
				point._datasetIndex = datasetIndex;
				point._index = index;
	
				// Desired view properties
				point._model = {
					x: x,
					y: y,
					skip: custom.skip || isNaN(x) || isNaN(y),
					// Appearance
					radius: custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointOptions.radius),
					pointStyle: custom.pointStyle || helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointOptions.pointStyle),
					backgroundColor: me.getPointBackgroundColor(point, index),
					borderColor: me.getPointBorderColor(point, index),
					borderWidth: me.getPointBorderWidth(point, index),
					tension: meta.dataset._model ? meta.dataset._model.tension : 0,
					steppedLine: meta.dataset._model ? meta.dataset._model.steppedLine : false,
					// Tooltip
					hitRadius: custom.hitRadius || helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointOptions.hitRadius)
				};
			},
	
			calculatePointY: function(value, index, datasetIndex) {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var yScale = me.getScaleForId(meta.yAxisID);
				var sumPos = 0;
				var sumNeg = 0;
				var i, ds, dsMeta;
	
				if (yScale.options.stacked) {
					for (i = 0; i < datasetIndex; i++) {
						ds = chart.data.datasets[i];
						dsMeta = chart.getDatasetMeta(i);
						if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id && chart.isDatasetVisible(i)) {
							var stackedRightValue = Number(yScale.getRightValue(ds.data[index]));
							if (stackedRightValue < 0) {
								sumNeg += stackedRightValue || 0;
							} else {
								sumPos += stackedRightValue || 0;
							}
						}
					}
	
					var rightValue = Number(yScale.getRightValue(value));
					if (rightValue < 0) {
						return yScale.getPixelForValue(sumNeg + rightValue);
					}
					return yScale.getPixelForValue(sumPos + rightValue);
				}
	
				return yScale.getPixelForValue(value);
			},
	
			updateBezierControlPoints: function() {
				var me = this;
				var meta = me.getMeta();
				var area = me.chart.chartArea;
				var points = (meta.data || []);
				var i, ilen, point, model, controlPoints;
	
				// Only consider points that are drawn in case the spanGaps option is used
				if (meta.dataset._model.spanGaps) {
					points = points.filter(function(pt) {
						return !pt._model.skip;
					});
				}
	
				function capControlPoint(pt, min, max) {
					return Math.max(Math.min(pt, max), min);
				}
	
				if (meta.dataset._model.cubicInterpolationMode === 'monotone') {
					helpers.splineCurveMonotone(points);
				} else {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						point = points[i];
						model = point._model;
						controlPoints = helpers.splineCurve(
							helpers.previousItem(points, i)._model,
							model,
							helpers.nextItem(points, i)._model,
							meta.dataset._model.tension
						);
						model.controlPointPreviousX = controlPoints.previous.x;
						model.controlPointPreviousY = controlPoints.previous.y;
						model.controlPointNextX = controlPoints.next.x;
						model.controlPointNextY = controlPoints.next.y;
					}
				}
	
				if (me.chart.options.elements.line.capBezierPoints) {
					for (i = 0, ilen = points.length; i < ilen; ++i) {
						model = points[i]._model;
						model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
						model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
						model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
						model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
					}
				}
			},
	
			draw: function() {
				var me = this;
				var chart = me.chart;
				var meta = me.getMeta();
				var points = meta.data || [];
				var area = chart.chartArea;
				var ilen = points.length;
				var i = 0;
	
				helpers.canvas.clipArea(chart.ctx, area);
	
				if (lineEnabled(me.getDataset(), chart.options)) {
					meta.dataset.draw();
				}
	
				helpers.canvas.unclipArea(chart.ctx);
	
				// Draw the points
				for (; i < ilen; ++i) {
					points[i].draw(area);
				}
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				model.radius = custom.hoverRadius || helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth || helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var me = this;
				var dataset = me.chart.data.datasets[point._datasetIndex];
				var index = point._index;
				var custom = point.custom || {};
				var model = point._model;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
	
				model.radius = custom.radius || helpers.valueAtIndexOrDefault(dataset.pointRadius, index, me.chart.options.elements.point.radius);
				model.backgroundColor = me.getPointBackgroundColor(point, index);
				model.borderColor = me.getPointBorderColor(point, index);
				model.borderWidth = me.getPointBorderWidth(point, index);
			}
		});
	};


/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('polarArea', {
		scale: {
			type: 'radialLinear',
			angleLines: {
				display: false
			},
			gridLines: {
				circular: true
			},
			pointLabels: {
				display: false
			},
			ticks: {
				beginAtZero: true
			}
		},
	
		// Boolean - Whether to animate the rotation of the chart
		animation: {
			animateRotate: true,
			animateScale: true
		},
	
		startAngle: -0.5 * Math.PI,
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
	
			var data = chart.data;
			var datasets = data.datasets;
			var labels = data.labels;
	
			if (datasets.length) {
				for (var i = 0; i < datasets[0].data.length; ++i) {
					text.push('<li><span style="background-color:' + datasets[0].backgroundColor[i] + '"></span>');
					if (labels[i]) {
						text.push(labels[i]);
					}
					text.push('</li>');
				}
			}
	
			text.push('</ul>');
			return text.join('');
		},
		legend: {
			labels: {
				generateLabels: function(chart) {
					var data = chart.data;
					if (data.labels.length && data.datasets.length) {
						return data.labels.map(function(label, i) {
							var meta = chart.getDatasetMeta(0);
							var ds = data.datasets[0];
							var arc = meta.data[i];
							var custom = arc.custom || {};
							var valueAtIndexOrDefault = helpers.valueAtIndexOrDefault;
							var arcOpts = chart.options.elements.arc;
							var fill = custom.backgroundColor ? custom.backgroundColor : valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
							var stroke = custom.borderColor ? custom.borderColor : valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
							var bw = custom.borderWidth ? custom.borderWidth : valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
	
							return {
								text: label,
								fillStyle: fill,
								strokeStyle: stroke,
								lineWidth: bw,
								hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
	
								// Extra data used for toggling the correct item
								index: i
							};
						});
					}
					return [];
				}
			},
	
			onClick: function(e, legendItem) {
				var index = legendItem.index;
				var chart = this.chart;
				var i, ilen, meta;
	
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					meta = chart.getDatasetMeta(i);
					meta.data[index].hidden = !meta.data[index].hidden;
				}
	
				chart.update();
			}
		},
	
		// Need to override these to give a nice default
		tooltips: {
			callbacks: {
				title: function() {
					return '';
				},
				label: function(item, data) {
					return data.labels[item.index] + ': ' + item.yLabel;
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.polarArea = Chart.DatasetController.extend({
	
			dataElementType: elements.Arc,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var chart = me.chart;
				var chartArea = chart.chartArea;
				var meta = me.getMeta();
				var opts = chart.options;
				var arcOpts = opts.elements.arc;
				var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
				chart.outerRadius = Math.max((minSize - arcOpts.borderWidth / 2) / 2, 0);
				chart.innerRadius = Math.max(opts.cutoutPercentage ? (chart.outerRadius / 100) * (opts.cutoutPercentage) : 1, 0);
				chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
	
				me.outerRadius = chart.outerRadius - (chart.radiusLength * me.index);
				me.innerRadius = me.outerRadius - chart.radiusLength;
	
				meta.count = me.countVisibleElements();
	
				helpers.each(meta.data, function(arc, index) {
					me.updateElement(arc, index, reset);
				});
			},
	
			updateElement: function(arc, index, reset) {
				var me = this;
				var chart = me.chart;
				var dataset = me.getDataset();
				var opts = chart.options;
				var animationOpts = opts.animation;
				var scale = chart.scale;
				var labels = chart.data.labels;
	
				var circumference = me.calculateCircumference(dataset.data[index]);
				var centerX = scale.xCenter;
				var centerY = scale.yCenter;
	
				// If there is NaN data before us, we need to calculate the starting angle correctly.
				// We could be way more efficient here, but its unlikely that the polar area chart will have a lot of data
				var visibleCount = 0;
				var meta = me.getMeta();
				for (var i = 0; i < index; ++i) {
					if (!isNaN(dataset.data[i]) && !meta.data[i].hidden) {
						++visibleCount;
					}
				}
	
				// var negHalfPI = -0.5 * Math.PI;
				var datasetStartAngle = opts.startAngle;
				var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
				var startAngle = datasetStartAngle + (circumference * visibleCount);
				var endAngle = startAngle + (arc.hidden ? 0 : circumference);
	
				var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
	
				helpers.extend(arc, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: centerX,
						y: centerY,
						innerRadius: 0,
						outerRadius: reset ? resetRadius : distance,
						startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
						endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
						label: helpers.valueAtIndexOrDefault(labels, index, labels[index])
					}
				});
	
				// Apply border and fill style
				me.removeHoverStyle(arc);
	
				arc.pivot();
			},
	
			removeHoverStyle: function(arc) {
				Chart.DatasetController.prototype.removeHoverStyle.call(this, arc, this.chart.options.elements.arc);
			},
	
			countVisibleElements: function() {
				var dataset = this.getDataset();
				var meta = this.getMeta();
				var count = 0;
	
				helpers.each(meta.data, function(element, index) {
					if (!isNaN(dataset.data[index]) && !element.hidden) {
						count++;
					}
				});
	
				return count;
			},
	
			calculateCircumference: function(value) {
				var count = this.getMeta().count;
				if (count > 0 && !isNaN(value)) {
					return (2 * Math.PI) / count;
				}
				return 0;
			}
		});
	};


/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('radar', {
		scale: {
			type: 'radialLinear'
		},
		elements: {
			line: {
				tension: 0 // no bezier in radar
			}
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.controllers.radar = Chart.DatasetController.extend({
	
			datasetElementType: elements.Line,
	
			dataElementType: elements.Point,
	
			linkScales: helpers.noop,
	
			update: function(reset) {
				var me = this;
				var meta = me.getMeta();
				var line = meta.dataset;
				var points = meta.data;
				var custom = line.custom || {};
				var dataset = me.getDataset();
				var lineElementOptions = me.chart.options.elements.line;
				var scale = me.chart.scale;
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.tension !== undefined) && (dataset.lineTension === undefined)) {
					dataset.lineTension = dataset.tension;
				}
	
				helpers.extend(meta.dataset, {
					// Utility
					_datasetIndex: me.index,
					_scale: scale,
					// Data
					_children: points,
					_loop: true,
					// Model
					_model: {
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, lineElementOptions.tension),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : (dataset.backgroundColor || lineElementOptions.backgroundColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : (dataset.borderWidth || lineElementOptions.borderWidth),
						borderColor: custom.borderColor ? custom.borderColor : (dataset.borderColor || lineElementOptions.borderColor),
						fill: custom.fill ? custom.fill : (dataset.fill !== undefined ? dataset.fill : lineElementOptions.fill),
						borderCapStyle: custom.borderCapStyle ? custom.borderCapStyle : (dataset.borderCapStyle || lineElementOptions.borderCapStyle),
						borderDash: custom.borderDash ? custom.borderDash : (dataset.borderDash || lineElementOptions.borderDash),
						borderDashOffset: custom.borderDashOffset ? custom.borderDashOffset : (dataset.borderDashOffset || lineElementOptions.borderDashOffset),
						borderJoinStyle: custom.borderJoinStyle ? custom.borderJoinStyle : (dataset.borderJoinStyle || lineElementOptions.borderJoinStyle),
					}
				});
	
				meta.dataset.pivot();
	
				// Update Points
				helpers.each(points, function(point, index) {
					me.updateElement(point, index, reset);
				}, me);
	
				// Update bezier control points
				me.updateBezierControlPoints();
			},
			updateElement: function(point, index, reset) {
				var me = this;
				var custom = point.custom || {};
				var dataset = me.getDataset();
				var scale = me.chart.scale;
				var pointElementOptions = me.chart.options.elements.point;
				var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
	
				// Compatibility: If the properties are defined with only the old name, use those values
				if ((dataset.radius !== undefined) && (dataset.pointRadius === undefined)) {
					dataset.pointRadius = dataset.radius;
				}
				if ((dataset.hitRadius !== undefined) && (dataset.pointHitRadius === undefined)) {
					dataset.pointHitRadius = dataset.hitRadius;
				}
	
				helpers.extend(point, {
					// Utility
					_datasetIndex: me.index,
					_index: index,
					_scale: scale,
	
					// Desired view properties
					_model: {
						x: reset ? scale.xCenter : pointPosition.x, // value not used in dataset scale, but we want a consistent API between scales
						y: reset ? scale.yCenter : pointPosition.y,
	
						// Appearance
						tension: custom.tension ? custom.tension : helpers.valueOrDefault(dataset.lineTension, me.chart.options.elements.line.tension),
						radius: custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius),
						backgroundColor: custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor),
						borderColor: custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor),
						borderWidth: custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth),
						pointStyle: custom.pointStyle ? custom.pointStyle : helpers.valueAtIndexOrDefault(dataset.pointStyle, index, pointElementOptions.pointStyle),
	
						// Tooltip
						hitRadius: custom.hitRadius ? custom.hitRadius : helpers.valueAtIndexOrDefault(dataset.pointHitRadius, index, pointElementOptions.hitRadius)
					}
				});
	
				point._model.skip = custom.skip ? custom.skip : (isNaN(point._model.x) || isNaN(point._model.y));
			},
			updateBezierControlPoints: function() {
				var chartArea = this.chart.chartArea;
				var meta = this.getMeta();
	
				helpers.each(meta.data, function(point, index) {
					var model = point._model;
					var controlPoints = helpers.splineCurve(
						helpers.previousItem(meta.data, index, true)._model,
						model,
						helpers.nextItem(meta.data, index, true)._model,
						model.tension
					);
	
					// Prevent the bezier going outside of the bounds of the graph
					model.controlPointPreviousX = Math.max(Math.min(controlPoints.previous.x, chartArea.right), chartArea.left);
					model.controlPointPreviousY = Math.max(Math.min(controlPoints.previous.y, chartArea.bottom), chartArea.top);
	
					model.controlPointNextX = Math.max(Math.min(controlPoints.next.x, chartArea.right), chartArea.left);
					model.controlPointNextY = Math.max(Math.min(controlPoints.next.y, chartArea.bottom), chartArea.top);
	
					// Now pivot the point for animation
					point.pivot();
				});
			},
	
			setHoverStyle: function(point) {
				// Point
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
	
				model.radius = custom.hoverRadius ? custom.hoverRadius : helpers.valueAtIndexOrDefault(dataset.pointHoverRadius, index, this.chart.options.elements.point.hoverRadius);
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBackgroundColor, index, helpers.getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderColor, index, helpers.getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : helpers.valueAtIndexOrDefault(dataset.pointHoverBorderWidth, index, model.borderWidth);
			},
	
			removeHoverStyle: function(point) {
				var dataset = this.chart.data.datasets[point._datasetIndex];
				var custom = point.custom || {};
				var index = point._index;
				var model = point._model;
				var pointElementOptions = this.chart.options.elements.point;
	
				model.radius = custom.radius ? custom.radius : helpers.valueAtIndexOrDefault(dataset.pointRadius, index, pointElementOptions.radius);
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : helpers.valueAtIndexOrDefault(dataset.pointBackgroundColor, index, pointElementOptions.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : helpers.valueAtIndexOrDefault(dataset.pointBorderColor, index, pointElementOptions.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : helpers.valueAtIndexOrDefault(dataset.pointBorderWidth, index, pointElementOptions.borderWidth);
			}
		});
	};


/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	
	defaults._set('scatter', {
		hover: {
			mode: 'single'
		},
	
		scales: {
			xAxes: [{
				id: 'x-axis-1',    // need an ID so datasets can reference the scale
				type: 'linear',    // scatter should not use a category axis
				position: 'bottom'
			}],
			yAxes: [{
				id: 'y-axis-1',
				type: 'linear',
				position: 'left'
			}]
		},
	
		showLines: false,
	
		tooltips: {
			callbacks: {
				title: function() {
					return '';     // doesn't make sense for scatter since data are formatted as a point
				},
				label: function(item) {
					return '(' + item.xLabel + ', ' + item.yLabel + ')';
				}
			}
		}
	});
	
	module.exports = function(Chart) {
	
		// Scatter charts use line controllers
		Chart.controllers.scatter = Chart.controllers.line;
	
	};


/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		animation: {
			duration: 1000,
			easing: 'easeOutQuart',
			onProgress: helpers.noop,
			onComplete: helpers.noop
		}
	});
	
	module.exports = function(Chart) {
	
		Chart.Animation = Element.extend({
			chart: null, // the animation associated chart instance
			currentStep: 0, // the current animation step
			numSteps: 60, // default number of steps
			easing: '', // the easing to use for this animation
			render: null, // render function used by the animation service
	
			onAnimationProgress: null, // user specified callback to fire on each step of the animation
			onAnimationComplete: null, // user specified callback to fire when the animation finishes
		});
	
		Chart.animationService = {
			frameDuration: 17,
			animations: [],
			dropFrames: 0,
			request: null,
	
			/**
			 * @param {Chart} chart - The chart to animate.
			 * @param {Chart.Animation} animation - The animation that we will animate.
			 * @param {Number} duration - The animation duration in ms.
			 * @param {Boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
			 */
			addAnimation: function(chart, animation, duration, lazy) {
				var animations = this.animations;
				var i, ilen;
	
				animation.chart = chart;
	
				if (!lazy) {
					chart.animating = true;
				}
	
				for (i = 0, ilen = animations.length; i < ilen; ++i) {
					if (animations[i].chart === chart) {
						animations[i] = animation;
						return;
					}
				}
	
				animations.push(animation);
	
				// If there are no animations queued, manually kickstart a digest, for lack of a better word
				if (animations.length === 1) {
					this.requestAnimationFrame();
				}
			},
	
			cancelAnimation: function(chart) {
				var index = helpers.findIndex(this.animations, function(animation) {
					return animation.chart === chart;
				});
	
				if (index !== -1) {
					this.animations.splice(index, 1);
					chart.animating = false;
				}
			},
	
			requestAnimationFrame: function() {
				var me = this;
				if (me.request === null) {
					// Skip animation frame requests until the active one is executed.
					// This can happen when processing mouse events, e.g. 'mousemove'
					// and 'mouseout' events will trigger multiple renders.
					me.request = helpers.requestAnimFrame.call(window, function() {
						me.request = null;
						me.startDigest();
					});
				}
			},
	
			/**
			 * @private
			 */
			startDigest: function() {
				var me = this;
				var startTime = Date.now();
				var framesToDrop = 0;
	
				if (me.dropFrames > 1) {
					framesToDrop = Math.floor(me.dropFrames);
					me.dropFrames = me.dropFrames % 1;
				}
	
				me.advance(1 + framesToDrop);
	
				var endTime = Date.now();
	
				me.dropFrames += (endTime - startTime) / me.frameDuration;
	
				// Do we have more stuff to animate?
				if (me.animations.length > 0) {
					me.requestAnimationFrame();
				}
			},
	
			/**
			 * @private
			 */
			advance: function(count) {
				var animations = this.animations;
				var animation, chart;
				var i = 0;
	
				while (i < animations.length) {
					animation = animations[i];
					chart = animation.chart;
	
					animation.currentStep = (animation.currentStep || 0) + count;
					animation.currentStep = Math.min(animation.currentStep, animation.numSteps);
	
					helpers.callback(animation.render, [chart, animation], chart);
					helpers.callback(animation.onAnimationProgress, [animation], chart);
	
					if (animation.currentStep >= animation.numSteps) {
						helpers.callback(animation.onAnimationComplete, [animation], chart);
						chart.animating = false;
						animations.splice(i, 1);
					} else {
						++i;
					}
				}
			}
		};
	
		/**
		 * Provided for backward compatibility, use Chart.Animation instead
		 * @prop Chart.Animation#animationObject
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'animationObject', {
			get: function() {
				return this;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart.Animation#chart instead
		 * @prop Chart.Animation#chartInstance
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 */
		Object.defineProperty(Chart.Animation.prototype, 'chartInstance', {
			get: function() {
				return this.chart;
			},
			set: function(value) {
				this.chart = value;
			}
		});
	
	};


/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var helpers = __webpack_require__(23);
	var Interaction = __webpack_require__(892);
	var platform = __webpack_require__(893);
	
	module.exports = function(Chart) {
		var plugins = Chart.plugins;
	
		// Create a dictionary of chart types, to allow for extension of existing types
		Chart.types = {};
	
		// Store a reference to each instance - allowing us to globally resize chart instances on window resize.
		// Destroy method on the chart will remove the instance of the chart from this reference.
		Chart.instances = {};
	
		// Controllers available for dataset visualization eg. bar, line, slice, etc.
		Chart.controllers = {};
	
		/**
		 * Initializes the given config with global and chart default values.
		 */
		function initConfig(config) {
			config = config || {};
	
			// Do NOT use configMerge() for the data object because this method merges arrays
			// and so would change references to labels and datasets, preventing data updates.
			var data = config.data = config.data || {};
			data.datasets = data.datasets || [];
			data.labels = data.labels || [];
	
			config.options = helpers.configMerge(
				defaults.global,
				defaults[config.type],
				config.options || {});
	
			return config;
		}
	
		/**
		 * Updates the config of the chart
		 * @param chart {Chart} chart to update the options for
		 */
		function updateConfig(chart) {
			var newOptions = chart.options;
	
			// Update Scale(s) with options
			if (newOptions.scale) {
				chart.scale.options = newOptions.scale;
			} else if (newOptions.scales) {
				newOptions.scales.xAxes.concat(newOptions.scales.yAxes).forEach(function(scaleOptions) {
					chart.scales[scaleOptions.id].options = scaleOptions;
				});
			}
	
			// Tooltip
			chart.tooltip._options = newOptions.tooltips;
		}
	
		function positionIsHorizontal(position) {
			return position === 'top' || position === 'bottom';
		}
	
		helpers.extend(Chart.prototype, /** @lends Chart */ {
			/**
			 * @private
			 */
			construct: function(item, config) {
				var me = this;
	
				config = initConfig(config);
	
				var context = platform.acquireContext(item, config);
				var canvas = context && context.canvas;
				var height = canvas && canvas.height;
				var width = canvas && canvas.width;
	
				me.id = helpers.uid();
				me.ctx = context;
				me.canvas = canvas;
				me.config = config;
				me.width = width;
				me.height = height;
				me.aspectRatio = height ? width / height : null;
				me.options = config.options;
				me._bufferedRender = false;
	
				/**
				 * Provided for backward compatibility, Chart and Chart.Controller have been merged,
				 * the "instance" still need to be defined since it might be called from plugins.
				 * @prop Chart#chart
				 * @deprecated since version 2.6.0
				 * @todo remove at version 3
				 * @private
				 */
				me.chart = me;
				me.controller = me; // chart.chart.controller #inception
	
				// Add the chart instance to the global namespace
				Chart.instances[me.id] = me;
	
				// Define alias to the config data: `chart.data === chart.config.data`
				Object.defineProperty(me, 'data', {
					get: function() {
						return me.config.data;
					},
					set: function(value) {
						me.config.data = value;
					}
				});
	
				if (!context || !canvas) {
					// The given item is not a compatible context2d element, let's return before finalizing
					// the chart initialization but after setting basic chart / controller properties that
					// can help to figure out that the chart is not valid (e.g chart.canvas !== null);
					// https://github.com/chartjs/Chart.js/issues/2807
					console.error("Failed to create chart: can't acquire context from the given item");
					return;
				}
	
				me.initialize();
				me.update();
			},
	
			/**
			 * @private
			 */
			initialize: function() {
				var me = this;
	
				// Before init plugin notification
				plugins.notify(me, 'beforeInit');
	
				helpers.retinaScale(me, me.options.devicePixelRatio);
	
				me.bindEvents();
	
				if (me.options.responsive) {
					// Initial resize before chart draws (must be silent to preserve initial animations).
					me.resize(true);
				}
	
				// Make sure scales have IDs and are built before we build any controllers.
				me.ensureScalesHaveIDs();
				me.buildScales();
				me.initToolTip();
	
				// After init plugin notification
				plugins.notify(me, 'afterInit');
	
				return me;
			},
	
			clear: function() {
				helpers.canvas.clear(this);
				return this;
			},
	
			stop: function() {
				// Stops any current animation loop occurring
				Chart.animationService.cancelAnimation(this);
				return this;
			},
	
			resize: function(silent) {
				var me = this;
				var options = me.options;
				var canvas = me.canvas;
				var aspectRatio = (options.maintainAspectRatio && me.aspectRatio) || null;
	
				// the canvas render width and height will be casted to integers so make sure that
				// the canvas display style uses the same integer values to avoid blurring effect.
	
				// Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collased
				var newWidth = Math.max(0, Math.floor(helpers.getMaximumWidth(canvas)));
				var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers.getMaximumHeight(canvas)));
	
				if (me.width === newWidth && me.height === newHeight) {
					return;
				}
	
				canvas.width = me.width = newWidth;
				canvas.height = me.height = newHeight;
				canvas.style.width = newWidth + 'px';
				canvas.style.height = newHeight + 'px';
	
				helpers.retinaScale(me, options.devicePixelRatio);
	
				if (!silent) {
					// Notify any plugins about the resize
					var newSize = {width: newWidth, height: newHeight};
					plugins.notify(me, 'resize', [newSize]);
	
					// Notify of resize
					if (me.options.onResize) {
						me.options.onResize(me, newSize);
					}
	
					me.stop();
					me.update(me.options.responsiveAnimationDuration);
				}
			},
	
			ensureScalesHaveIDs: function() {
				var options = this.options;
				var scalesOptions = options.scales || {};
				var scaleOptions = options.scale;
	
				helpers.each(scalesOptions.xAxes, function(xAxisOptions, index) {
					xAxisOptions.id = xAxisOptions.id || ('x-axis-' + index);
				});
	
				helpers.each(scalesOptions.yAxes, function(yAxisOptions, index) {
					yAxisOptions.id = yAxisOptions.id || ('y-axis-' + index);
				});
	
				if (scaleOptions) {
					scaleOptions.id = scaleOptions.id || 'scale';
				}
			},
	
			/**
			 * Builds a map of scale ID to scale object for future lookup.
			 */
			buildScales: function() {
				var me = this;
				var options = me.options;
				var scales = me.scales = {};
				var items = [];
	
				if (options.scales) {
					items = items.concat(
						(options.scales.xAxes || []).map(function(xAxisOptions) {
							return {options: xAxisOptions, dtype: 'category', dposition: 'bottom'};
						}),
						(options.scales.yAxes || []).map(function(yAxisOptions) {
							return {options: yAxisOptions, dtype: 'linear', dposition: 'left'};
						})
					);
				}
	
				if (options.scale) {
					items.push({
						options: options.scale,
						dtype: 'radialLinear',
						isDefault: true,
						dposition: 'chartArea'
					});
				}
	
				helpers.each(items, function(item) {
					var scaleOptions = item.options;
					var scaleType = helpers.valueOrDefault(scaleOptions.type, item.dtype);
					var scaleClass = Chart.scaleService.getScaleConstructor(scaleType);
					if (!scaleClass) {
						return;
					}
	
					if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
						scaleOptions.position = item.dposition;
					}
	
					var scale = new scaleClass({
						id: scaleOptions.id,
						options: scaleOptions,
						ctx: me.ctx,
						chart: me
					});
	
					scales[scale.id] = scale;
					scale.mergeTicksOptions();
	
					// TODO(SB): I think we should be able to remove this custom case (options.scale)
					// and consider it as a regular scale part of the "scales"" map only! This would
					// make the logic easier and remove some useless? custom code.
					if (item.isDefault) {
						me.scale = scale;
					}
				});
	
				Chart.scaleService.addScalesToLayout(this);
			},
	
			buildOrUpdateControllers: function() {
				var me = this;
				var types = [];
				var newControllers = [];
	
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					var meta = me.getDatasetMeta(datasetIndex);
					var type = dataset.type || me.config.type;
	
					if (meta.type && meta.type !== type) {
						me.destroyDatasetMeta(datasetIndex);
						meta = me.getDatasetMeta(datasetIndex);
					}
					meta.type = type;
	
					types.push(meta.type);
	
					if (meta.controller) {
						meta.controller.updateIndex(datasetIndex);
					} else {
						var ControllerClass = Chart.controllers[meta.type];
						if (ControllerClass === undefined) {
							throw new Error('"' + meta.type + '" is not a chart type.');
						}
	
						meta.controller = new ControllerClass(me, datasetIndex);
						newControllers.push(meta.controller);
					}
				}, me);
	
				return newControllers;
			},
	
			/**
			 * Reset the elements of all datasets
			 * @private
			 */
			resetElements: function() {
				var me = this;
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.reset();
				}, me);
			},
	
			/**
			* Resets the chart back to it's state before the initial animation
			*/
			reset: function() {
				this.resetElements();
				this.tooltip.initialize();
			},
	
			update: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				updateConfig(me);
	
				if (plugins.notify(me, 'beforeUpdate') === false) {
					return;
				}
	
				// In case the entire data object changed
				me.tooltip._data = me.data;
	
				// Make sure dataset controllers are updated and new controllers are reset
				var newControllers = me.buildOrUpdateControllers();
	
				// Make sure all dataset controllers have correct meta data counts
				helpers.each(me.data.datasets, function(dataset, datasetIndex) {
					me.getDatasetMeta(datasetIndex).controller.buildOrUpdateElements();
				}, me);
	
				me.updateLayout();
	
				// Can only reset the new controllers after the scales have been updated
				helpers.each(newControllers, function(controller) {
					controller.reset();
				});
	
				me.updateDatasets();
	
				// Need to reset tooltip in case it is displayed with elements that are removed
				// after update.
				me.tooltip.initialize();
	
				// Last active contains items that were previously in the tooltip.
				// When we reset the tooltip, we need to clear it
				me.lastActive = [];
	
				// Do this before render so that any plugins that need final scale updates can use it
				plugins.notify(me, 'afterUpdate');
	
				if (me._bufferedRender) {
					me._bufferedRequest = {
						duration: config.duration,
						easing: config.easing,
						lazy: config.lazy
					};
				} else {
					me.render(config);
				}
			},
	
			/**
			 * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
			 * hook, in which case, plugins will not be called on `afterLayout`.
			 * @private
			 */
			updateLayout: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeLayout') === false) {
					return;
				}
	
				Chart.layoutService.update(this, this.width, this.height);
	
				/**
				 * Provided for backward compatibility, use `afterLayout` instead.
				 * @method IPlugin#afterScaleUpdate
				 * @deprecated since version 2.5.0
				 * @todo remove at version 3
				 * @private
				 */
				plugins.notify(me, 'afterScaleUpdate');
				plugins.notify(me, 'afterLayout');
			},
	
			/**
			 * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
			 * @private
			 */
			updateDatasets: function() {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsUpdate') === false) {
					return;
				}
	
				for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.updateDataset(i);
				}
	
				plugins.notify(me, 'afterDatasetsUpdate');
			},
	
			/**
			 * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
			 * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
			 * @private
			 */
			updateDataset: function(index) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index
				};
	
				if (plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
					return;
				}
	
				meta.controller.update();
	
				plugins.notify(me, 'afterDatasetUpdate', [args]);
			},
	
			render: function(config) {
				var me = this;
	
				if (!config || typeof config !== 'object') {
					// backwards compatibility
					config = {
						duration: config,
						lazy: arguments[1]
					};
				}
	
				var duration = config.duration;
				var lazy = config.lazy;
	
				if (plugins.notify(me, 'beforeRender') === false) {
					return;
				}
	
				var animationOptions = me.options.animation;
				var onComplete = function(animation) {
					plugins.notify(me, 'afterRender');
					helpers.callback(animationOptions && animationOptions.onComplete, [animation], me);
				};
	
				if (animationOptions && ((typeof duration !== 'undefined' && duration !== 0) || (typeof duration === 'undefined' && animationOptions.duration !== 0))) {
					var animation = new Chart.Animation({
						numSteps: (duration || animationOptions.duration) / 16.66, // 60 fps
						easing: config.easing || animationOptions.easing,
	
						render: function(chart, animationObject) {
							var easingFunction = helpers.easing.effects[animationObject.easing];
							var currentStep = animationObject.currentStep;
							var stepDecimal = currentStep / animationObject.numSteps;
	
							chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
						},
	
						onAnimationProgress: animationOptions.onProgress,
						onAnimationComplete: onComplete
					});
	
					Chart.animationService.addAnimation(me, animation, duration, lazy);
				} else {
					me.draw();
	
					// See https://github.com/chartjs/Chart.js/issues/3781
					onComplete(new Chart.Animation({numSteps: 0, chart: me}));
				}
	
				return me;
			},
	
			draw: function(easingValue) {
				var me = this;
	
				me.clear();
	
				if (helpers.isNullOrUndef(easingValue)) {
					easingValue = 1;
				}
	
				me.transition(easingValue);
	
				if (plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw all the scales
				helpers.each(me.boxes, function(box) {
					box.draw(me.chartArea);
				}, me);
	
				if (me.scale) {
					me.scale.draw();
				}
	
				me.drawDatasets(easingValue);
				me._drawTooltip(easingValue);
	
				plugins.notify(me, 'afterDraw', [easingValue]);
			},
	
			/**
			 * @private
			 */
			transition: function(easingValue) {
				var me = this;
	
				for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
					if (me.isDatasetVisible(i)) {
						me.getDatasetMeta(i).controller.transition(easingValue);
					}
				}
	
				me.tooltip.transition(easingValue);
			},
	
			/**
			 * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
			 * @private
			 */
			drawDatasets: function(easingValue) {
				var me = this;
	
				if (plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
					return;
				}
	
				// Draw datasets reversed to support proper line stacking
				for (var i = (me.data.datasets || []).length - 1; i >= 0; --i) {
					if (me.isDatasetVisible(i)) {
						me.drawDataset(i, easingValue);
					}
				}
	
				plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
			},
	
			/**
			 * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
			 * hook, in which case, plugins will not be called on `afterDatasetDraw`.
			 * @private
			 */
			drawDataset: function(index, easingValue) {
				var me = this;
				var meta = me.getDatasetMeta(index);
				var args = {
					meta: meta,
					index: index,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
					return;
				}
	
				meta.controller.draw(easingValue);
	
				plugins.notify(me, 'afterDatasetDraw', [args]);
			},
	
			/**
			 * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
			 * hook, in which case, plugins will not be called on `afterTooltipDraw`.
			 * @private
			 */
			_drawTooltip: function(easingValue) {
				var me = this;
				var tooltip = me.tooltip;
				var args = {
					tooltip: tooltip,
					easingValue: easingValue
				};
	
				if (plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
					return;
				}
	
				tooltip.draw();
	
				plugins.notify(me, 'afterTooltipDraw', [args]);
			},
	
			// Get the single element that was clicked on
			// @return : An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
			getElementAtEvent: function(e) {
				return Interaction.modes.single(this, e);
			},
	
			getElementsAtEvent: function(e) {
				return Interaction.modes.label(this, e, {intersect: true});
			},
	
			getElementsAtXAxis: function(e) {
				return Interaction.modes['x-axis'](this, e, {intersect: true});
			},
	
			getElementsAtEventForMode: function(e, mode, options) {
				var method = Interaction.modes[mode];
				if (typeof method === 'function') {
					return method(this, e, options);
				}
	
				return [];
			},
	
			getDatasetAtEvent: function(e) {
				return Interaction.modes.dataset(this, e, {intersect: true});
			},
	
			getDatasetMeta: function(datasetIndex) {
				var me = this;
				var dataset = me.data.datasets[datasetIndex];
				if (!dataset._meta) {
					dataset._meta = {};
				}
	
				var meta = dataset._meta[me.id];
				if (!meta) {
					meta = dataset._meta[me.id] = {
						type: null,
						data: [],
						dataset: null,
						controller: null,
						hidden: null,			// See isDatasetVisible() comment
						xAxisID: null,
						yAxisID: null
					};
				}
	
				return meta;
			},
	
			getVisibleDatasetCount: function() {
				var count = 0;
				for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
					if (this.isDatasetVisible(i)) {
						count++;
					}
				}
				return count;
			},
	
			isDatasetVisible: function(datasetIndex) {
				var meta = this.getDatasetMeta(datasetIndex);
	
				// meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
				// the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
				return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
			},
	
			generateLegend: function() {
				return this.options.legendCallback(this);
			},
	
			/**
			 * @private
			 */
			destroyDatasetMeta: function(datasetIndex) {
				var id = this.id;
				var dataset = this.data.datasets[datasetIndex];
				var meta = dataset._meta && dataset._meta[id];
	
				if (meta) {
					meta.controller.destroy();
					delete dataset._meta[id];
				}
			},
	
			destroy: function() {
				var me = this;
				var canvas = me.canvas;
				var i, ilen;
	
				me.stop();
	
				// dataset controllers need to cleanup associated data
				for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
					me.destroyDatasetMeta(i);
				}
	
				if (canvas) {
					me.unbindEvents();
					helpers.canvas.clear(me);
					platform.releaseContext(me.ctx);
					me.canvas = null;
					me.ctx = null;
				}
	
				plugins.notify(me, 'destroy');
	
				delete Chart.instances[me.id];
			},
	
			toBase64Image: function() {
				return this.canvas.toDataURL.apply(this.canvas, arguments);
			},
	
			initToolTip: function() {
				var me = this;
				me.tooltip = new Chart.Tooltip({
					_chart: me,
					_chartInstance: me, // deprecated, backward compatibility
					_data: me.data,
					_options: me.options.tooltips
				}, me);
			},
	
			/**
			 * @private
			 */
			bindEvents: function() {
				var me = this;
				var listeners = me._listeners = {};
				var listener = function() {
					me.eventHandler.apply(me, arguments);
				};
	
				helpers.each(me.options.events, function(type) {
					platform.addEventListener(me, type, listener);
					listeners[type] = listener;
				});
	
				// Elements used to detect size change should not be injected for non responsive charts.
				// See https://github.com/chartjs/Chart.js/issues/2210
				if (me.options.responsive) {
					listener = function() {
						me.resize();
					};
	
					platform.addEventListener(me, 'resize', listener);
					listeners.resize = listener;
				}
			},
	
			/**
			 * @private
			 */
			unbindEvents: function() {
				var me = this;
				var listeners = me._listeners;
				if (!listeners) {
					return;
				}
	
				delete me._listeners;
				helpers.each(listeners, function(listener, type) {
					platform.removeEventListener(me, type, listener);
				});
			},
	
			updateHoverStyle: function(elements, mode, enabled) {
				var method = enabled ? 'setHoverStyle' : 'removeHoverStyle';
				var element, i, ilen;
	
				for (i = 0, ilen = elements.length; i < ilen; ++i) {
					element = elements[i];
					if (element) {
						this.getDatasetMeta(element._datasetIndex).controller[method](element);
					}
				}
			},
	
			/**
			 * @private
			 */
			eventHandler: function(e) {
				var me = this;
				var tooltip = me.tooltip;
	
				if (plugins.notify(me, 'beforeEvent', [e]) === false) {
					return;
				}
	
				// Buffer any update calls so that renders do not occur
				me._bufferedRender = true;
				me._bufferedRequest = null;
	
				var changed = me.handleEvent(e);
				changed |= tooltip && tooltip.handleEvent(e);
	
				plugins.notify(me, 'afterEvent', [e]);
	
				var bufferedRequest = me._bufferedRequest;
				if (bufferedRequest) {
					// If we have an update that was triggered, we need to do a normal render
					me.render(bufferedRequest);
				} else if (changed && !me.animating) {
					// If entering, leaving, or changing elements, animate the change via pivot
					me.stop();
	
					// We only need to render at this point. Updating will cause scales to be
					// recomputed generating flicker & using more memory than necessary.
					me.render(me.options.hover.animationDuration, true);
				}
	
				me._bufferedRender = false;
				me._bufferedRequest = null;
	
				return me;
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event the event to handle
			 * @return {Boolean} true if the chart needs to re-render
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me.options || {};
				var hoverOptions = options.hover;
				var changed = false;
	
				me.lastActive = me.lastActive || [];
	
				// Find Active Elements for hover and tooltips
				if (e.type === 'mouseout') {
					me.active = [];
				} else {
					me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
				}
	
				// Invoke onHover hook
				// Need to call with native event here to not break backwards compatibility
				helpers.callback(options.onHover || options.hover.onHover, [e.native, me.active], me);
	
				if (e.type === 'mouseup' || e.type === 'click') {
					if (options.onClick) {
						// Use e.native here for backwards compatibility
						options.onClick.call(me, e.native, me.active);
					}
				}
	
				// Remove styling for last active (even if it may still be active)
				if (me.lastActive.length) {
					me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
				}
	
				// Built in hover styling
				if (me.active.length && hoverOptions.mode) {
					me.updateHoverStyle(me.active, hoverOptions.mode, true);
				}
	
				changed = !helpers.arrayEquals(me.active, me.lastActive);
	
				// Remember Last Actives
				me.lastActive = me.active;
	
				return changed;
			}
		});
	
		/**
		 * Provided for backward compatibility, use Chart instead.
		 * @class Chart.Controller
		 * @deprecated since version 2.6.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.Controller = Chart;
	};


/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	
	module.exports = function(Chart) {
	
		var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];
	
		/**
		 * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
		 * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
		 * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
		 */
		function listenArrayEvents(array, listener) {
			if (array._chartjs) {
				array._chartjs.listeners.push(listener);
				return;
			}
	
			Object.defineProperty(array, '_chartjs', {
				configurable: true,
				enumerable: false,
				value: {
					listeners: [listener]
				}
			});
	
			arrayEvents.forEach(function(key) {
				var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
				var base = array[key];
	
				Object.defineProperty(array, key, {
					configurable: true,
					enumerable: false,
					value: function() {
						var args = Array.prototype.slice.call(arguments);
						var res = base.apply(this, args);
	
						helpers.each(array._chartjs.listeners, function(object) {
							if (typeof object[method] === 'function') {
								object[method].apply(object, args);
							}
						});
	
						return res;
					}
				});
			});
		}
	
		/**
		 * Removes the given array event listener and cleanup extra attached properties (such as
		 * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
		 */
		function unlistenArrayEvents(array, listener) {
			var stub = array._chartjs;
			if (!stub) {
				return;
			}
	
			var listeners = stub.listeners;
			var index = listeners.indexOf(listener);
			if (index !== -1) {
				listeners.splice(index, 1);
			}
	
			if (listeners.length > 0) {
				return;
			}
	
			arrayEvents.forEach(function(key) {
				delete array[key];
			});
	
			delete array._chartjs;
		}
	
		// Base class for all dataset controllers (line, bar, etc)
		Chart.DatasetController = function(chart, datasetIndex) {
			this.initialize(chart, datasetIndex);
		};
	
		helpers.extend(Chart.DatasetController.prototype, {
	
			/**
			 * Element type used to generate a meta dataset (e.g. Chart.element.Line).
			 * @type {Chart.core.element}
			 */
			datasetElementType: null,
	
			/**
			 * Element type used to generate a meta data (e.g. Chart.element.Point).
			 * @type {Chart.core.element}
			 */
			dataElementType: null,
	
			initialize: function(chart, datasetIndex) {
				var me = this;
				me.chart = chart;
				me.index = datasetIndex;
				me.linkScales();
				me.addElements();
			},
	
			updateIndex: function(datasetIndex) {
				this.index = datasetIndex;
			},
	
			linkScales: function() {
				var me = this;
				var meta = me.getMeta();
				var dataset = me.getDataset();
	
				if (meta.xAxisID === null) {
					meta.xAxisID = dataset.xAxisID || me.chart.options.scales.xAxes[0].id;
				}
				if (meta.yAxisID === null) {
					meta.yAxisID = dataset.yAxisID || me.chart.options.scales.yAxes[0].id;
				}
			},
	
			getDataset: function() {
				return this.chart.data.datasets[this.index];
			},
	
			getMeta: function() {
				return this.chart.getDatasetMeta(this.index);
			},
	
			getScaleForId: function(scaleID) {
				return this.chart.scales[scaleID];
			},
	
			reset: function() {
				this.update(true);
			},
	
			/**
			 * @private
			 */
			destroy: function() {
				if (this._data) {
					unlistenArrayEvents(this._data, this);
				}
			},
	
			createMetaDataset: function() {
				var me = this;
				var type = me.datasetElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index
				});
			},
	
			createMetaData: function(index) {
				var me = this;
				var type = me.dataElementType;
				return type && new type({
					_chart: me.chart,
					_datasetIndex: me.index,
					_index: index
				});
			},
	
			addElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data || [];
				var metaData = meta.data;
				var i, ilen;
	
				for (i = 0, ilen = data.length; i < ilen; ++i) {
					metaData[i] = metaData[i] || me.createMetaData(i);
				}
	
				meta.dataset = meta.dataset || me.createMetaDataset();
			},
	
			addElementAndReset: function(index) {
				var element = this.createMetaData(index);
				this.getMeta().data.splice(index, 0, element);
				this.updateElement(element, index, true);
			},
	
			buildOrUpdateElements: function() {
				var me = this;
				var dataset = me.getDataset();
				var data = dataset.data || (dataset.data = []);
	
				// In order to correctly handle data addition/deletion animation (an thus simulate
				// real-time charts), we need to monitor these data modifications and synchronize
				// the internal meta data accordingly.
				if (me._data !== data) {
					if (me._data) {
						// This case happens when the user replaced the data array instance.
						unlistenArrayEvents(me._data, me);
					}
	
					listenArrayEvents(data, me);
					me._data = data;
				}
	
				// Re-sync meta data in case the user replaced the data array or if we missed
				// any updates and so make sure that we handle number of datapoints changing.
				me.resyncElements();
			},
	
			update: helpers.noop,
	
			transition: function(easingValue) {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				for (; i < ilen; ++i) {
					elements[i].transition(easingValue);
				}
	
				if (meta.dataset) {
					meta.dataset.transition(easingValue);
				}
			},
	
			draw: function() {
				var meta = this.getMeta();
				var elements = meta.data || [];
				var ilen = elements.length;
				var i = 0;
	
				if (meta.dataset) {
					meta.dataset.draw();
				}
	
				for (; i < ilen; ++i) {
					elements[i].draw();
				}
			},
	
			removeHoverStyle: function(element, elementOpts) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var model = element._model;
	
				model.backgroundColor = custom.backgroundColor ? custom.backgroundColor : valueOrDefault(dataset.backgroundColor, index, elementOpts.backgroundColor);
				model.borderColor = custom.borderColor ? custom.borderColor : valueOrDefault(dataset.borderColor, index, elementOpts.borderColor);
				model.borderWidth = custom.borderWidth ? custom.borderWidth : valueOrDefault(dataset.borderWidth, index, elementOpts.borderWidth);
			},
	
			setHoverStyle: function(element) {
				var dataset = this.chart.data.datasets[element._datasetIndex];
				var index = element._index;
				var custom = element.custom || {};
				var valueOrDefault = helpers.valueAtIndexOrDefault;
				var getHoverColor = helpers.getHoverColor;
				var model = element._model;
	
				model.backgroundColor = custom.hoverBackgroundColor ? custom.hoverBackgroundColor : valueOrDefault(dataset.hoverBackgroundColor, index, getHoverColor(model.backgroundColor));
				model.borderColor = custom.hoverBorderColor ? custom.hoverBorderColor : valueOrDefault(dataset.hoverBorderColor, index, getHoverColor(model.borderColor));
				model.borderWidth = custom.hoverBorderWidth ? custom.hoverBorderWidth : valueOrDefault(dataset.hoverBorderWidth, index, model.borderWidth);
			},
	
			/**
			 * @private
			 */
			resyncElements: function() {
				var me = this;
				var meta = me.getMeta();
				var data = me.getDataset().data;
				var numMeta = meta.data.length;
				var numData = data.length;
	
				if (numData < numMeta) {
					meta.data.splice(numData, numMeta - numData);
				} else if (numData > numMeta) {
					me.insertElements(numMeta, numData - numMeta);
				}
			},
	
			/**
			 * @private
			 */
			insertElements: function(start, count) {
				for (var i = 0; i < count; ++i) {
					this.addElementAndReset(start + i);
				}
			},
	
			/**
			 * @private
			 */
			onDataPush: function() {
				this.insertElements(this.getDataset().data.length - 1, arguments.length);
			},
	
			/**
			 * @private
			 */
			onDataPop: function() {
				this.getMeta().data.pop();
			},
	
			/**
			 * @private
			 */
			onDataShift: function() {
				this.getMeta().data.shift();
			},
	
			/**
			 * @private
			 */
			onDataSplice: function(start, count) {
				this.getMeta().data.splice(start, count);
				this.insertElements(start, arguments.length - 2);
			},
	
			/**
			 * @private
			 */
			onDataUnshift: function() {
				this.insertElements(0, arguments.length);
			}
		});
	
		Chart.DatasetController.extend = helpers.inherits;
	};


/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	/* global document: false */
	'use strict';
	
	var color = __webpack_require__(894);
	var defaults = __webpack_require__(34);
	var helpers = __webpack_require__(23);
	
	module.exports = function(Chart) {
	
		// -- Basic js utility methods
	
		helpers.configMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					var tval = target[key] || {};
					var sval = source[key];
	
					if (key === 'scales') {
						// scale config merging is complex. Add our own function here for that
						target[key] = helpers.scaleMerge(tval, sval);
					} else if (key === 'scale') {
						// used in polar area & radar charts since there is only one scale
						target[key] = helpers.merge(tval, [Chart.scaleService.getScaleDefaults(sval.type), sval]);
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.scaleMerge = function(/* objects ... */) {
			return helpers.merge(helpers.clone(arguments[0]), [].slice.call(arguments, 1), {
				merger: function(key, target, source, options) {
					if (key === 'xAxes' || key === 'yAxes') {
						var slen = source[key].length;
						var i, type, scale;
	
						if (!target[key]) {
							target[key] = [];
						}
	
						for (i = 0; i < slen; ++i) {
							scale = source[key][i];
							type = helpers.valueOrDefault(scale.type, key === 'xAxes' ? 'category' : 'linear');
	
							if (i >= target[key].length) {
								target[key].push({});
							}
	
							if (!target[key][i].type || (scale.type && scale.type !== target[key][i].type)) {
								// new/untyped scale or type changed: let's apply the new defaults
								// then merge source scale to correctly overwrite the defaults.
								helpers.merge(target[key][i], [Chart.scaleService.getScaleDefaults(type), scale]);
							} else {
								// scales type are the same
								helpers.merge(target[key][i], scale);
							}
						}
					} else {
						helpers._merger(key, target, source, options);
					}
				}
			});
		};
	
		helpers.where = function(collection, filterCallback) {
			if (helpers.isArray(collection) && Array.prototype.filter) {
				return collection.filter(filterCallback);
			}
			var filtered = [];
	
			helpers.each(collection, function(item) {
				if (filterCallback(item)) {
					filtered.push(item);
				}
			});
	
			return filtered;
		};
		helpers.findIndex = Array.prototype.findIndex ?
			function(array, callback, scope) {
				return array.findIndex(callback, scope);
			} :
			function(array, callback, scope) {
				scope = scope === undefined ? array : scope;
				for (var i = 0, ilen = array.length; i < ilen; ++i) {
					if (callback.call(scope, array[i], i, array)) {
						return i;
					}
				}
				return -1;
			};
		helpers.findNextWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to start of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = -1;
			}
			for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
		helpers.findPreviousWhere = function(arrayToSearch, filterCallback, startIndex) {
			// Default to end of the array
			if (helpers.isNullOrUndef(startIndex)) {
				startIndex = arrayToSearch.length;
			}
			for (var i = startIndex - 1; i >= 0; i--) {
				var currentItem = arrayToSearch[i];
				if (filterCallback(currentItem)) {
					return currentItem;
				}
			}
		};
	
		// -- Math methods
		helpers.isNumber = function(n) {
			return !isNaN(parseFloat(n)) && isFinite(n);
		};
		helpers.almostEquals = function(x, y, epsilon) {
			return Math.abs(x - y) < epsilon;
		};
		helpers.almostWhole = function(x, epsilon) {
			var rounded = Math.round(x);
			return (((rounded - epsilon) < x) && ((rounded + epsilon) > x));
		};
		helpers.max = function(array) {
			return array.reduce(function(max, value) {
				if (!isNaN(value)) {
					return Math.max(max, value);
				}
				return max;
			}, Number.NEGATIVE_INFINITY);
		};
		helpers.min = function(array) {
			return array.reduce(function(min, value) {
				if (!isNaN(value)) {
					return Math.min(min, value);
				}
				return min;
			}, Number.POSITIVE_INFINITY);
		};
		helpers.sign = Math.sign ?
			function(x) {
				return Math.sign(x);
			} :
			function(x) {
				x = +x; // convert to a number
				if (x === 0 || isNaN(x)) {
					return x;
				}
				return x > 0 ? 1 : -1;
			};
		helpers.log10 = Math.log10 ?
			function(x) {
				return Math.log10(x);
			} :
			function(x) {
				return Math.log(x) / Math.LN10;
			};
		helpers.toRadians = function(degrees) {
			return degrees * (Math.PI / 180);
		};
		helpers.toDegrees = function(radians) {
			return radians * (180 / Math.PI);
		};
		// Gets the angle from vertical upright to the point about a centre.
		helpers.getAngleFromPoint = function(centrePoint, anglePoint) {
			var distanceFromXCenter = anglePoint.x - centrePoint.x;
			var distanceFromYCenter = anglePoint.y - centrePoint.y;
			var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
	
			var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
	
			if (angle < (-0.5 * Math.PI)) {
				angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
			}
	
			return {
				angle: angle,
				distance: radialDistanceFromCenter
			};
		};
		helpers.distanceBetweenPoints = function(pt1, pt2) {
			return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
		};
		helpers.aliasPixel = function(pixelWidth) {
			return (pixelWidth % 2 === 0) ? 0 : 0.5;
		};
		helpers.splineCurve = function(firstPoint, middlePoint, afterPoint, t) {
			// Props to Rob Spencer at scaled innovation for his post on splining between points
			// http://scaledinnovation.com/analytics/splines/aboutSplines.html
	
			// This function must also respect "skipped" points
	
			var previous = firstPoint.skip ? middlePoint : firstPoint;
			var current = middlePoint;
			var next = afterPoint.skip ? middlePoint : afterPoint;
	
			var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
			var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
	
			var s01 = d01 / (d01 + d12);
			var s12 = d12 / (d01 + d12);
	
			// If all points are the same, s01 & s02 will be inf
			s01 = isNaN(s01) ? 0 : s01;
			s12 = isNaN(s12) ? 0 : s12;
	
			var fa = t * s01; // scaling factor for triangle Ta
			var fb = t * s12;
	
			return {
				previous: {
					x: current.x - fa * (next.x - previous.x),
					y: current.y - fa * (next.y - previous.y)
				},
				next: {
					x: current.x + fb * (next.x - previous.x),
					y: current.y + fb * (next.y - previous.y)
				}
			};
		};
		helpers.EPSILON = Number.EPSILON || 1e-14;
		helpers.splineCurveMonotone = function(points) {
			// This function calculates Bézier control points in a similar way than |splineCurve|,
			// but preserves monotonicity of the provided data and ensures no local extremums are added
			// between the dataset discrete points due to the interpolation.
			// See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
	
			var pointsWithTangents = (points || []).map(function(point) {
				return {
					model: point._model,
					deltaK: 0,
					mK: 0
				};
			});
	
			// Calculate slopes (deltaK) and initialize tangents (mK)
			var pointsLen = pointsWithTangents.length;
			var i, pointBefore, pointCurrent, pointAfter;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointAfter && !pointAfter.model.skip) {
					var slopeDeltaX = (pointAfter.model.x - pointCurrent.model.x);
	
					// In the case of two points that appear at the same x pixel, slopeDeltaX is 0
					pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
				}
	
				if (!pointBefore || pointBefore.model.skip) {
					pointCurrent.mK = pointCurrent.deltaK;
				} else if (!pointAfter || pointAfter.model.skip) {
					pointCurrent.mK = pointBefore.deltaK;
				} else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
					pointCurrent.mK = 0;
				} else {
					pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
				}
			}
	
			// Adjust tangents to ensure monotonic properties
			var alphaK, betaK, tauK, squaredMagnitude;
			for (i = 0; i < pointsLen - 1; ++i) {
				pointCurrent = pointsWithTangents[i];
				pointAfter = pointsWithTangents[i + 1];
				if (pointCurrent.model.skip || pointAfter.model.skip) {
					continue;
				}
	
				if (helpers.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
					pointCurrent.mK = pointAfter.mK = 0;
					continue;
				}
	
				alphaK = pointCurrent.mK / pointCurrent.deltaK;
				betaK = pointAfter.mK / pointCurrent.deltaK;
				squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
				if (squaredMagnitude <= 9) {
					continue;
				}
	
				tauK = 3 / Math.sqrt(squaredMagnitude);
				pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
				pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
			}
	
			// Compute control points
			var deltaX;
			for (i = 0; i < pointsLen; ++i) {
				pointCurrent = pointsWithTangents[i];
				if (pointCurrent.model.skip) {
					continue;
				}
	
				pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
				pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
				if (pointBefore && !pointBefore.model.skip) {
					deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
					pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
					pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
				}
				if (pointAfter && !pointAfter.model.skip) {
					deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
					pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
					pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
				}
			}
		};
		helpers.nextItem = function(collection, index, loop) {
			if (loop) {
				return index >= collection.length - 1 ? collection[0] : collection[index + 1];
			}
			return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
		};
		helpers.previousItem = function(collection, index, loop) {
			if (loop) {
				return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
			}
			return index <= 0 ? collection[0] : collection[index - 1];
		};
		// Implementation of the nice number algorithm used in determining where axis labels will go
		helpers.niceNum = function(range, round) {
			var exponent = Math.floor(helpers.log10(range));
			var fraction = range / Math.pow(10, exponent);
			var niceFraction;
	
			if (round) {
				if (fraction < 1.5) {
					niceFraction = 1;
				} else if (fraction < 3) {
					niceFraction = 2;
				} else if (fraction < 7) {
					niceFraction = 5;
				} else {
					niceFraction = 10;
				}
			} else if (fraction <= 1.0) {
				niceFraction = 1;
			} else if (fraction <= 2) {
				niceFraction = 2;
			} else if (fraction <= 5) {
				niceFraction = 5;
			} else {
				niceFraction = 10;
			}
	
			return niceFraction * Math.pow(10, exponent);
		};
		// Request animation polyfill - http://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
		helpers.requestAnimFrame = (function() {
			if (typeof window === 'undefined') {
				return function(callback) {
					callback();
				};
			}
			return window.requestAnimationFrame ||
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimationFrame ||
				function(callback) {
					return window.setTimeout(callback, 1000 / 60);
				};
		}());
		// -- DOM methods
		helpers.getRelativePosition = function(evt, chart) {
			var mouseX, mouseY;
			var e = evt.originalEvent || evt;
			var canvas = evt.currentTarget || evt.srcElement;
			var boundingRect = canvas.getBoundingClientRect();
	
			var touches = e.touches;
			if (touches && touches.length > 0) {
				mouseX = touches[0].clientX;
				mouseY = touches[0].clientY;
	
			} else {
				mouseX = e.clientX;
				mouseY = e.clientY;
			}
	
			// Scale mouse coordinates into canvas coordinates
			// by following the pattern laid out by 'jerryj' in the comments of
			// http://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
			var paddingLeft = parseFloat(helpers.getStyle(canvas, 'padding-left'));
			var paddingTop = parseFloat(helpers.getStyle(canvas, 'padding-top'));
			var paddingRight = parseFloat(helpers.getStyle(canvas, 'padding-right'));
			var paddingBottom = parseFloat(helpers.getStyle(canvas, 'padding-bottom'));
			var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
			var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;
	
			// We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
			// the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
			mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / (width) * canvas.width / chart.currentDevicePixelRatio);
			mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / (height) * canvas.height / chart.currentDevicePixelRatio);
	
			return {
				x: mouseX,
				y: mouseY
			};
	
		};
	
		// Private helper function to convert max-width/max-height values that may be percentages into a number
		function parseMaxStyle(styleValue, node, parentProperty) {
			var valueInPixels;
			if (typeof styleValue === 'string') {
				valueInPixels = parseInt(styleValue, 10);
	
				if (styleValue.indexOf('%') !== -1) {
					// percentage * size in dimension
					valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
				}
			} else {
				valueInPixels = styleValue;
			}
	
			return valueInPixels;
		}
	
		/**
		 * Returns if the given value contains an effective constraint.
		 * @private
		 */
		function isConstrainedValue(value) {
			return value !== undefined && value !== null && value !== 'none';
		}
	
		// Private helper to get a constraint dimension
		// @param domNode : the node to check the constraint on
		// @param maxStyle : the style that defines the maximum for the direction we are using (maxWidth / maxHeight)
		// @param percentageProperty : property of parent to use when calculating width as a percentage
		// @see http://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser
		function getConstraintDimension(domNode, maxStyle, percentageProperty) {
			var view = document.defaultView;
			var parentNode = domNode.parentNode;
			var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
			var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
			var hasCNode = isConstrainedValue(constrainedNode);
			var hasCContainer = isConstrainedValue(constrainedContainer);
			var infinity = Number.POSITIVE_INFINITY;
	
			if (hasCNode || hasCContainer) {
				return Math.min(
					hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity,
					hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
			}
	
			return 'none';
		}
		// returns Number or undefined if no constraint
		helpers.getConstraintWidth = function(domNode) {
			return getConstraintDimension(domNode, 'max-width', 'clientWidth');
		};
		// returns Number or undefined if no constraint
		helpers.getConstraintHeight = function(domNode) {
			return getConstraintDimension(domNode, 'max-height', 'clientHeight');
		};
		helpers.getMaximumWidth = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientWidth;
			}
	
			var paddingLeft = parseInt(helpers.getStyle(container, 'padding-left'), 10);
			var paddingRight = parseInt(helpers.getStyle(container, 'padding-right'), 10);
			var w = container.clientWidth - paddingLeft - paddingRight;
			var cw = helpers.getConstraintWidth(domNode);
			return isNaN(cw) ? w : Math.min(w, cw);
		};
		helpers.getMaximumHeight = function(domNode) {
			var container = domNode.parentNode;
			if (!container) {
				return domNode.clientHeight;
			}
	
			var paddingTop = parseInt(helpers.getStyle(container, 'padding-top'), 10);
			var paddingBottom = parseInt(helpers.getStyle(container, 'padding-bottom'), 10);
			var h = container.clientHeight - paddingTop - paddingBottom;
			var ch = helpers.getConstraintHeight(domNode);
			return isNaN(ch) ? h : Math.min(h, ch);
		};
		helpers.getStyle = function(el, property) {
			return el.currentStyle ?
				el.currentStyle[property] :
				document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
		};
		helpers.retinaScale = function(chart, forceRatio) {
			var pixelRatio = chart.currentDevicePixelRatio = forceRatio || window.devicePixelRatio || 1;
			if (pixelRatio === 1) {
				return;
			}
	
			var canvas = chart.canvas;
			var height = chart.height;
			var width = chart.width;
	
			canvas.height = height * pixelRatio;
			canvas.width = width * pixelRatio;
			chart.ctx.scale(pixelRatio, pixelRatio);
	
			// If no style has been set on the canvas, the render size is used as display size,
			// making the chart visually bigger, so let's enforce it to the "correct" values.
			// See https://github.com/chartjs/Chart.js/issues/3575
			canvas.style.height = height + 'px';
			canvas.style.width = width + 'px';
		};
		// -- Canvas methods
		helpers.fontString = function(pixelSize, fontStyle, fontFamily) {
			return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
		};
		helpers.longestText = function(ctx, font, arrayOfThings, cache) {
			cache = cache || {};
			var data = cache.data = cache.data || {};
			var gc = cache.garbageCollect = cache.garbageCollect || [];
	
			if (cache.font !== font) {
				data = cache.data = {};
				gc = cache.garbageCollect = [];
				cache.font = font;
			}
	
			ctx.font = font;
			var longest = 0;
			helpers.each(arrayOfThings, function(thing) {
				// Undefined strings and arrays should not be measured
				if (thing !== undefined && thing !== null && helpers.isArray(thing) !== true) {
					longest = helpers.measureText(ctx, data, gc, longest, thing);
				} else if (helpers.isArray(thing)) {
					// if it is an array lets measure each element
					// to do maybe simplify this function a bit so we can do this more recursively?
					helpers.each(thing, function(nestedThing) {
						// Undefined strings and arrays should not be measured
						if (nestedThing !== undefined && nestedThing !== null && !helpers.isArray(nestedThing)) {
							longest = helpers.measureText(ctx, data, gc, longest, nestedThing);
						}
					});
				}
			});
	
			var gcLen = gc.length / 2;
			if (gcLen > arrayOfThings.length) {
				for (var i = 0; i < gcLen; i++) {
					delete data[gc[i]];
				}
				gc.splice(0, gcLen);
			}
			return longest;
		};
		helpers.measureText = function(ctx, data, gc, longest, string) {
			var textWidth = data[string];
			if (!textWidth) {
				textWidth = data[string] = ctx.measureText(string).width;
				gc.push(string);
			}
			if (textWidth > longest) {
				longest = textWidth;
			}
			return longest;
		};
		helpers.numberOfLabelLines = function(arrayOfThings) {
			var numberOfLines = 1;
			helpers.each(arrayOfThings, function(thing) {
				if (helpers.isArray(thing)) {
					if (thing.length > numberOfLines) {
						numberOfLines = thing.length;
					}
				}
			});
			return numberOfLines;
		};
	
		helpers.color = !color ?
			function(value) {
				console.error('Color.js not found!');
				return value;
			} :
			function(value) {
				/* global CanvasGradient */
				if (value instanceof CanvasGradient) {
					value = defaults.global.defaultColor;
				}
	
				return color(value);
			};
	
		helpers.getHoverColor = function(colorValue) {
			/* global CanvasPattern */
			return (colorValue instanceof CanvasPattern) ?
				colorValue :
				helpers.color(colorValue).saturate(0.5).darken(0.1).rgbString();
		};
	};


/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	
	defaults._set('global', {
		responsive: true,
		responsiveAnimationDuration: 0,
		maintainAspectRatio: true,
		events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
		hover: {
			onHover: null,
			mode: 'nearest',
			intersect: true,
			animationDuration: 400
		},
		onClick: null,
		defaultColor: 'rgba(0,0,0,0.1)',
		defaultFontColor: '#666',
		defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
		defaultFontSize: 12,
		defaultFontStyle: 'normal',
		showLines: true,
	
		// Element defaults defined in element extensions
		elements: {},
	
		// Layout options such as padding
		layout: {
			padding: {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			}
		}
	});
	
	module.exports = function() {
	
		// Occupy the global variable of Chart, and create a simple base class
		var Chart = function(item, config) {
			this.construct(item, config);
			return this;
		};
	
		Chart.Chart = Chart;
	
		return Chart;
	};


/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	
	module.exports = function(Chart) {
	
		function filterByPosition(array, position) {
			return helpers.where(array, function(v) {
				return v.position === position;
			});
		}
	
		function sortByWeight(array, reverse) {
			array.forEach(function(v, i) {
				v._tmpIndex_ = i;
				return v;
			});
			array.sort(function(a, b) {
				var v0 = reverse ? b : a;
				var v1 = reverse ? a : b;
				return v0.weight === v1.weight ?
					v0._tmpIndex_ - v1._tmpIndex_ :
					v0.weight - v1.weight;
			});
			array.forEach(function(v) {
				delete v._tmpIndex_;
			});
		}
	
		/**
		 * @interface ILayoutItem
		 * @prop {String} position - The position of the item in the chart layout. Possible values are
		 * 'left', 'top', 'right', 'bottom', and 'chartArea'
		 * @prop {Number} weight - The weight used to sort the item. Higher weights are further away from the chart area
		 * @prop {Boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
		 * @prop {Function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
		 * @prop {Function} update - Takes two parameters: width and height. Returns size of item
		 * @prop {Function} getPadding -  Returns an object with padding on the edges
		 * @prop {Number} width - Width of item. Must be valid after update()
		 * @prop {Number} height - Height of item. Must be valid after update()
		 * @prop {Number} left - Left edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} top - Top edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} right - Right edge of the item. Set by layout system and cannot be used in update
		 * @prop {Number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
		 */
	
		// The layout service is very self explanatory.  It's responsible for the layout within a chart.
		// Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
		// It is this service's responsibility of carrying out that layout.
		Chart.layoutService = {
			defaults: {},
	
			/**
			 * Register a box to a chart.
			 * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
			 * @param {Chart} chart - the chart to use
			 * @param {ILayoutItem} item - the item to add to be layed out
			 */
			addBox: function(chart, item) {
				if (!chart.boxes) {
					chart.boxes = [];
				}
	
				// initialize item with default values
				item.fullWidth = item.fullWidth || false;
				item.position = item.position || 'top';
				item.weight = item.weight || 0;
	
				chart.boxes.push(item);
			},
	
			/**
			 * Remove a layoutItem from a chart
			 * @param {Chart} chart - the chart to remove the box from
			 * @param {Object} layoutItem - the item to remove from the layout
			 */
			removeBox: function(chart, layoutItem) {
				var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
				if (index !== -1) {
					chart.boxes.splice(index, 1);
				}
			},
	
			/**
			 * Sets (or updates) options on the given `item`.
			 * @param {Chart} chart - the chart in which the item lives (or will be added to)
			 * @param {Object} item - the item to configure with the given options
			 * @param {Object} options - the new item options.
			 */
			configure: function(chart, item, options) {
				var props = ['fullWidth', 'position', 'weight'];
				var ilen = props.length;
				var i = 0;
				var prop;
	
				for (; i < ilen; ++i) {
					prop = props[i];
					if (options.hasOwnProperty(prop)) {
						item[prop] = options[prop];
					}
				}
			},
	
			/**
			 * Fits boxes of the given chart into the given size by having each box measure itself
			 * then running a fitting algorithm
			 * @param {Chart} chart - the chart
			 * @param {Number} width - the width to fit into
			 * @param {Number} height - the height to fit into
			 */
			update: function(chart, width, height) {
				if (!chart) {
					return;
				}
	
				var layoutOptions = chart.options.layout || {};
				var padding = helpers.options.toPadding(layoutOptions.padding);
				var leftPadding = padding.left;
				var rightPadding = padding.right;
				var topPadding = padding.top;
				var bottomPadding = padding.bottom;
	
				var leftBoxes = filterByPosition(chart.boxes, 'left');
				var rightBoxes = filterByPosition(chart.boxes, 'right');
				var topBoxes = filterByPosition(chart.boxes, 'top');
				var bottomBoxes = filterByPosition(chart.boxes, 'bottom');
				var chartAreaBoxes = filterByPosition(chart.boxes, 'chartArea');
	
				// Sort boxes by weight. A higher weight is further away from the chart area
				sortByWeight(leftBoxes, true);
				sortByWeight(rightBoxes, false);
				sortByWeight(topBoxes, true);
				sortByWeight(bottomBoxes, false);
	
				// Essentially we now have any number of boxes on each of the 4 sides.
				// Our canvas looks like the following.
				// The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
				// B1 is the bottom axis
				// There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
				// These locations are single-box locations only, when trying to register a chartArea location that is already taken,
				// an error will be thrown.
				//
				// |----------------------------------------------------|
				// |                  T1 (Full Width)                   |
				// |----------------------------------------------------|
				// |    |    |                 T2                  |    |
				// |    |----|-------------------------------------|----|
				// |    |    | C1 |                           | C2 |    |
				// |    |    |----|                           |----|    |
				// |    |    |                                     |    |
				// | L1 | L2 |           ChartArea (C0)            | R1 |
				// |    |    |                                     |    |
				// |    |    |----|                           |----|    |
				// |    |    | C3 |                           | C4 |    |
				// |    |----|-------------------------------------|----|
				// |    |    |                 B1                  |    |
				// |----------------------------------------------------|
				// |                  B2 (Full Width)                   |
				// |----------------------------------------------------|
				//
				// What we do to find the best sizing, we do the following
				// 1. Determine the minimum size of the chart area.
				// 2. Split the remaining width equally between each vertical axis
				// 3. Split the remaining height equally between each horizontal axis
				// 4. Give each layout the maximum size it can be. The layout will return it's minimum size
				// 5. Adjust the sizes of each axis based on it's minimum reported size.
				// 6. Refit each axis
				// 7. Position each axis in the final location
				// 8. Tell the chart the final location of the chart area
				// 9. Tell any axes that overlay the chart area the positions of the chart area
	
				// Step 1
				var chartWidth = width - leftPadding - rightPadding;
				var chartHeight = height - topPadding - bottomPadding;
				var chartAreaWidth = chartWidth / 2; // min 50%
				var chartAreaHeight = chartHeight / 2; // min 50%
	
				// Step 2
				var verticalBoxWidth = (width - chartAreaWidth) / (leftBoxes.length + rightBoxes.length);
	
				// Step 3
				var horizontalBoxHeight = (height - chartAreaHeight) / (topBoxes.length + bottomBoxes.length);
	
				// Step 4
				var maxChartAreaWidth = chartWidth;
				var maxChartAreaHeight = chartHeight;
				var minBoxSizes = [];
	
				function getMinimumBoxSize(box) {
					var minSize;
					var isHorizontal = box.isHorizontal();
	
					if (isHorizontal) {
						minSize = box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, horizontalBoxHeight);
						maxChartAreaHeight -= minSize.height;
					} else {
						minSize = box.update(verticalBoxWidth, chartAreaHeight);
						maxChartAreaWidth -= minSize.width;
					}
	
					minBoxSizes.push({
						horizontal: isHorizontal,
						minSize: minSize,
						box: box,
					});
				}
	
				helpers.each(leftBoxes.concat(rightBoxes, topBoxes, bottomBoxes), getMinimumBoxSize);
	
				// If a horizontal box has padding, we move the left boxes over to avoid ugly charts (see issue #2478)
				var maxHorizontalLeftPadding = 0;
				var maxHorizontalRightPadding = 0;
				var maxVerticalTopPadding = 0;
				var maxVerticalBottomPadding = 0;
	
				helpers.each(topBoxes.concat(bottomBoxes), function(horizontalBox) {
					if (horizontalBox.getPadding) {
						var boxPadding = horizontalBox.getPadding();
						maxHorizontalLeftPadding = Math.max(maxHorizontalLeftPadding, boxPadding.left);
						maxHorizontalRightPadding = Math.max(maxHorizontalRightPadding, boxPadding.right);
					}
				});
	
				helpers.each(leftBoxes.concat(rightBoxes), function(verticalBox) {
					if (verticalBox.getPadding) {
						var boxPadding = verticalBox.getPadding();
						maxVerticalTopPadding = Math.max(maxVerticalTopPadding, boxPadding.top);
						maxVerticalBottomPadding = Math.max(maxVerticalBottomPadding, boxPadding.bottom);
					}
				});
	
				// At this point, maxChartAreaHeight and maxChartAreaWidth are the size the chart area could
				// be if the axes are drawn at their minimum sizes.
				// Steps 5 & 6
				var totalLeftBoxesWidth = leftPadding;
				var totalRightBoxesWidth = rightPadding;
				var totalTopBoxesHeight = topPadding;
				var totalBottomBoxesHeight = bottomPadding;
	
				// Function to fit a box
				function fitBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minBox) {
						return minBox.box === box;
					});
	
					if (minBoxSize) {
						if (box.isHorizontal()) {
							var scaleMargin = {
								left: Math.max(totalLeftBoxesWidth, maxHorizontalLeftPadding),
								right: Math.max(totalRightBoxesWidth, maxHorizontalRightPadding),
								top: 0,
								bottom: 0
							};
	
							// Don't use min size here because of label rotation. When the labels are rotated, their rotation highly depends
							// on the margin. Sometimes they need to increase in size slightly
							box.update(box.fullWidth ? chartWidth : maxChartAreaWidth, chartHeight / 2, scaleMargin);
						} else {
							box.update(minBoxSize.minSize.width, maxChartAreaHeight);
						}
					}
				}
	
				// Update, and calculate the left and right margins for the horizontal boxes
				helpers.each(leftBoxes.concat(rightBoxes), fitBox);
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				// Set the Left and Right margins for the horizontal boxes
				helpers.each(topBoxes.concat(bottomBoxes), fitBox);
	
				// Figure out how much margin is on the top and bottom of the vertical boxes
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
	
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				function finalFitVerticalBox(box) {
					var minBoxSize = helpers.findNextWhere(minBoxSizes, function(minSize) {
						return minSize.box === box;
					});
	
					var scaleMargin = {
						left: 0,
						right: 0,
						top: totalTopBoxesHeight,
						bottom: totalBottomBoxesHeight
					};
	
					if (minBoxSize) {
						box.update(minBoxSize.minSize.width, maxChartAreaHeight, scaleMargin);
					}
				}
	
				// Let the left layout know the final margin
				helpers.each(leftBoxes.concat(rightBoxes), finalFitVerticalBox);
	
				// Recalculate because the size of each layout might have changed slightly due to the margins (label rotation for instance)
				totalLeftBoxesWidth = leftPadding;
				totalRightBoxesWidth = rightPadding;
				totalTopBoxesHeight = topPadding;
				totalBottomBoxesHeight = bottomPadding;
	
				helpers.each(leftBoxes, function(box) {
					totalLeftBoxesWidth += box.width;
				});
	
				helpers.each(rightBoxes, function(box) {
					totalRightBoxesWidth += box.width;
				});
	
				helpers.each(topBoxes, function(box) {
					totalTopBoxesHeight += box.height;
				});
				helpers.each(bottomBoxes, function(box) {
					totalBottomBoxesHeight += box.height;
				});
	
				// We may be adding some padding to account for rotated x axis labels
				var leftPaddingAddition = Math.max(maxHorizontalLeftPadding - totalLeftBoxesWidth, 0);
				totalLeftBoxesWidth += leftPaddingAddition;
				totalRightBoxesWidth += Math.max(maxHorizontalRightPadding - totalRightBoxesWidth, 0);
	
				var topPaddingAddition = Math.max(maxVerticalTopPadding - totalTopBoxesHeight, 0);
				totalTopBoxesHeight += topPaddingAddition;
				totalBottomBoxesHeight += Math.max(maxVerticalBottomPadding - totalBottomBoxesHeight, 0);
	
				// Figure out if our chart area changed. This would occur if the dataset layout label rotation
				// changed due to the application of the margins in step 6. Since we can only get bigger, this is safe to do
				// without calling `fit` again
				var newMaxChartAreaHeight = height - totalTopBoxesHeight - totalBottomBoxesHeight;
				var newMaxChartAreaWidth = width - totalLeftBoxesWidth - totalRightBoxesWidth;
	
				if (newMaxChartAreaWidth !== maxChartAreaWidth || newMaxChartAreaHeight !== maxChartAreaHeight) {
					helpers.each(leftBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(rightBoxes, function(box) {
						box.height = newMaxChartAreaHeight;
					});
	
					helpers.each(topBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					helpers.each(bottomBoxes, function(box) {
						if (!box.fullWidth) {
							box.width = newMaxChartAreaWidth;
						}
					});
	
					maxChartAreaHeight = newMaxChartAreaHeight;
					maxChartAreaWidth = newMaxChartAreaWidth;
				}
	
				// Step 7 - Position the boxes
				var left = leftPadding + leftPaddingAddition;
				var top = topPadding + topPaddingAddition;
	
				function placeBox(box) {
					if (box.isHorizontal()) {
						box.left = box.fullWidth ? leftPadding : totalLeftBoxesWidth;
						box.right = box.fullWidth ? width - rightPadding : totalLeftBoxesWidth + maxChartAreaWidth;
						box.top = top;
						box.bottom = top + box.height;
	
						// Move to next point
						top = box.bottom;
	
					} else {
	
						box.left = left;
						box.right = left + box.width;
						box.top = totalTopBoxesHeight;
						box.bottom = totalTopBoxesHeight + maxChartAreaHeight;
	
						// Move to next point
						left = box.right;
					}
				}
	
				helpers.each(leftBoxes.concat(topBoxes), placeBox);
	
				// Account for chart width and height
				left += maxChartAreaWidth;
				top += maxChartAreaHeight;
	
				helpers.each(rightBoxes, placeBox);
				helpers.each(bottomBoxes, placeBox);
	
				// Step 8
				chart.chartArea = {
					left: totalLeftBoxesWidth,
					top: totalTopBoxesHeight,
					right: totalLeftBoxesWidth + maxChartAreaWidth,
					bottom: totalTopBoxesHeight + maxChartAreaHeight
				};
	
				// Step 9
				helpers.each(chartAreaBoxes, function(box) {
					box.left = chart.chartArea.left;
					box.top = chart.chartArea.top;
					box.right = chart.chartArea.right;
					box.bottom = chart.chartArea.bottom;
	
					box.update(maxChartAreaWidth, maxChartAreaHeight);
				});
			}
		};
	};


/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		plugins: {}
	});
	
	module.exports = function(Chart) {
	
		/**
		 * The plugin service singleton
		 * @namespace Chart.plugins
		 * @since 2.1.0
		 */
		Chart.plugins = {
			/**
			 * Globally registered plugins.
			 * @private
			 */
			_plugins: [],
	
			/**
			 * This identifier is used to invalidate the descriptors cache attached to each chart
			 * when a global plugin is registered or unregistered. In this case, the cache ID is
			 * incremented and descriptors are regenerated during following API calls.
			 * @private
			 */
			_cacheId: 0,
	
			/**
			 * Registers the given plugin(s) if not already registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			register: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					if (p.indexOf(plugin) === -1) {
						p.push(plugin);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Unregisters the given plugin(s) only if registered.
			 * @param {Array|Object} plugins plugin instance(s).
			 */
			unregister: function(plugins) {
				var p = this._plugins;
				([]).concat(plugins).forEach(function(plugin) {
					var idx = p.indexOf(plugin);
					if (idx !== -1) {
						p.splice(idx, 1);
					}
				});
	
				this._cacheId++;
			},
	
			/**
			 * Remove all registered plugins.
			 * @since 2.1.5
			 */
			clear: function() {
				this._plugins = [];
				this._cacheId++;
			},
	
			/**
			 * Returns the number of registered plugins?
			 * @returns {Number}
			 * @since 2.1.5
			 */
			count: function() {
				return this._plugins.length;
			},
	
			/**
			 * Returns all registered plugin instances.
			 * @returns {Array} array of plugin objects.
			 * @since 2.1.5
			 */
			getAll: function() {
				return this._plugins;
			},
	
			/**
			 * Calls enabled plugins for `chart` on the specified hook and with the given args.
			 * This method immediately returns as soon as a plugin explicitly returns false. The
			 * returned value can be used, for instance, to interrupt the current action.
			 * @param {Object} chart - The chart instance for which plugins should be called.
			 * @param {String} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
			 * @param {Array} [args] - Extra arguments to apply to the hook call.
			 * @returns {Boolean} false if any of the plugins return false, else returns true.
			 */
			notify: function(chart, hook, args) {
				var descriptors = this.descriptors(chart);
				var ilen = descriptors.length;
				var i, descriptor, plugin, params, method;
	
				for (i = 0; i < ilen; ++i) {
					descriptor = descriptors[i];
					plugin = descriptor.plugin;
					method = plugin[hook];
					if (typeof method === 'function') {
						params = [chart].concat(args || []);
						params.push(descriptor.options);
						if (method.apply(plugin, params) === false) {
							return false;
						}
					}
				}
	
				return true;
			},
	
			/**
			 * Returns descriptors of enabled plugins for the given chart.
			 * @returns {Array} [{ plugin, options }]
			 * @private
			 */
			descriptors: function(chart) {
				var cache = chart._plugins || (chart._plugins = {});
				if (cache.id === this._cacheId) {
					return cache.descriptors;
				}
	
				var plugins = [];
				var descriptors = [];
				var config = (chart && chart.config) || {};
				var options = (config.options && config.options.plugins) || {};
	
				this._plugins.concat(config.plugins || []).forEach(function(plugin) {
					var idx = plugins.indexOf(plugin);
					if (idx !== -1) {
						return;
					}
	
					var id = plugin.id;
					var opts = options[id];
					if (opts === false) {
						return;
					}
	
					if (opts === true) {
						opts = helpers.clone(defaults.global.plugins[id]);
					}
	
					plugins.push(plugin);
					descriptors.push({
						plugin: plugin,
						options: opts || {}
					});
				});
	
				cache.descriptors = descriptors;
				cache.id = this._cacheId;
				return descriptors;
			}
		};
	
		/**
		 * Plugin extension hooks.
		 * @interface IPlugin
		 * @since 2.1.0
		 */
		/**
		 * @method IPlugin#beforeInit
		 * @desc Called before initializing `chart`.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterInit
		 * @desc Called after `chart` has been initialized and before the first update.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeUpdate
		 * @desc Called before updating `chart`. If any plugin returns `false`, the update
		 * is cancelled (and thus subsequent render(s)) until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart update.
		 */
		/**
		 * @method IPlugin#afterUpdate
		 * @desc Called after `chart` has been updated and before rendering. Note that this
		 * hook will not be called if the chart update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsUpdate
	 	 * @desc Called before updating the `chart` datasets. If any plugin returns `false`,
		 * the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} false to cancel the datasets update.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#afterDatasetsUpdate
		 * @desc Called after the `chart` datasets have been updated. Note that this hook
		 * will not be called if the datasets update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @since version 2.1.5
		 */
		/**
		 * @method IPlugin#beforeDatasetUpdate
	 	 * @desc Called before updating the `chart` dataset at the given `args.index`. If any plugin
		 * returns `false`, the datasets update is cancelled until another `update` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetUpdate
	 	 * @desc Called after the `chart` datasets at the given `args.index` has been updated. Note
		 * that this hook will not be called if the datasets update has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeLayout
		 * @desc Called before laying out `chart`. If any plugin returns `false`,
		 * the layout update is cancelled until another `update` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart layout.
		 */
		/**
		 * @method IPlugin#afterLayout
		 * @desc Called after the `chart` has been layed out. Note that this hook will not
		 * be called if the layout update has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeRender
		 * @desc Called before rendering `chart`. If any plugin returns `false`,
		 * the rendering is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart rendering.
		 */
		/**
		 * @method IPlugin#afterRender
		 * @desc Called after the `chart` has been fully rendered (and animation completed). Note
		 * that this hook will not be called if the rendering has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDraw
		 * @desc Called before drawing `chart` at every animation frame specified by the given
		 * easing value. If any plugin returns `false`, the frame drawing is cancelled until
		 * another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart drawing.
		 */
		/**
		 * @method IPlugin#afterDraw
		 * @desc Called after the `chart` has been drawn for the specific easing value. Note
		 * that this hook will not be called if the drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetsDraw
	 	 * @desc Called before drawing the `chart` datasets. If any plugin returns `false`,
		 * the datasets drawing is cancelled until another `render` is triggered.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetsDraw
		 * @desc Called after the `chart` datasets have been drawn. Note that this hook
		 * will not be called if the datasets drawing has been previously cancelled.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#beforeDatasetDraw
	 	 * @desc Called before drawing the `chart` dataset at the given `args.index` (datasets
		 * are drawn in the reverse order). If any plugin returns `false`, the datasets drawing
		 * is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart datasets drawing.
		 */
		/**
		 * @method IPlugin#afterDatasetDraw
	 	 * @desc Called after the `chart` datasets at the given `args.index` have been drawn
		 * (datasets are drawn in the reverse order). Note that this hook will not be called
		 * if the datasets drawing has been previously cancelled.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Number} args.index - The dataset index.
		 * @param {Object} args.meta - The dataset metadata.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 */
		/**
	  	 * @method IPlugin#beforeTooltipDraw
		 * @desc Called before drawing the `tooltip`. If any plugin returns `false`,
		 * the tooltip drawing is cancelled until another `render` is triggered.
		 * @param {Chart} chart - The chart instance.
		 * @param {Object} args - The call arguments.
		 * @param {Object} args.tooltip - The tooltip.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
		 * @param {Object} options - The plugin options.
		 * @returns {Boolean} `false` to cancel the chart tooltip drawing.
	  	 */
		/**
	 	 * @method IPlugin#afterTooltipDraw
	  	 * @desc Called after drawing the `tooltip`. Note that this hook will not
	 	 * be called if the tooltip drawing has been previously cancelled.
	 	 * @param {Chart} chart - The chart instance.
	 	 * @param {Object} args - The call arguments.
	 	 * @param {Object} args.tooltip - The tooltip.
		 * @param {Number} args.easingValue - The current animation value, between 0.0 and 1.0.
	 	 * @param {Object} options - The plugin options.
	 	 */
		/**
		 * @method IPlugin#beforeEvent
	 	 * @desc Called before processing the specified `event`. If any plugin returns `false`,
		 * the event will be discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#afterEvent
		 * @desc Called after the `event` has been consumed. Note that this hook
		 * will not be called if the `event` has been previously discarded.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {IEvent} event - The event object.
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#resize
		 * @desc Called after the chart as been resized.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Number} size - The new canvas display size (eq. canvas.style width & height).
		 * @param {Object} options - The plugin options.
		 */
		/**
		 * @method IPlugin#destroy
		 * @desc Called after the chart as been destroyed.
		 * @param {Chart.Controller} chart - The chart instance.
		 * @param {Object} options - The plugin options.
		 */
	
		/**
		 * Provided for backward compatibility, use Chart.plugins instead
		 * @namespace Chart.pluginService
		 * @deprecated since version 2.1.5
		 * @todo remove at version 3
		 * @private
		 */
		Chart.pluginService = Chart.plugins;
	
		/**
		 * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
		 * effect, instead simply create/register plugins via plain JavaScript objects.
		 * @interface Chart.PluginBase
		 * @deprecated since version 2.5.0
		 * @todo remove at version 3
		 * @private
		 */
		Chart.PluginBase = Element.extend({});
	};


/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	var Ticks = __webpack_require__(221);
	
	defaults._set('scale', {
		display: true,
		position: 'left',
		offset: false,
	
		// grid line settings
		gridLines: {
			display: true,
			color: 'rgba(0, 0, 0, 0.1)',
			lineWidth: 1,
			drawBorder: true,
			drawOnChartArea: true,
			drawTicks: true,
			tickMarkLength: 10,
			zeroLineWidth: 1,
			zeroLineColor: 'rgba(0,0,0,0.25)',
			zeroLineBorderDash: [],
			zeroLineBorderDashOffset: 0.0,
			offsetGridLines: false,
			borderDash: [],
			borderDashOffset: 0.0
		},
	
		// scale label
		scaleLabel: {
			// display property
			display: false,
	
			// actual label
			labelString: '',
	
			// line height
			lineHeight: 1.2,
	
			// top/bottom padding
			padding: {
				top: 4,
				bottom: 4
			}
		},
	
		// label settings
		ticks: {
			beginAtZero: false,
			minRotation: 0,
			maxRotation: 50,
			mirror: false,
			padding: 0,
			reverse: false,
			display: true,
			autoSkip: true,
			autoSkipPadding: 0,
			labelOffset: 0,
			// We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
			callback: Ticks.formatters.values,
			minor: {},
			major: {}
		}
	});
	
	function labelsFromTicks(ticks) {
		var labels = [];
		var i, ilen;
	
		for (i = 0, ilen = ticks.length; i < ilen; ++i) {
			labels.push(ticks[i].label);
		}
	
		return labels;
	}
	
	function getLineValue(scale, index, offsetGridLines) {
		var lineValue = scale.getPixelForTick(index);
	
		if (offsetGridLines) {
			if (index === 0) {
				lineValue -= (scale.getPixelForTick(1) - lineValue) / 2;
			} else {
				lineValue -= (lineValue - scale.getPixelForTick(index - 1)) / 2;
			}
		}
		return lineValue;
	}
	
	module.exports = function(Chart) {
	
		function computeTextSize(context, tick, font) {
			return helpers.isArray(tick) ?
				helpers.longestText(context, font, tick) :
				context.measureText(tick).width;
		}
	
		function parseFontOptions(options) {
			var valueOrDefault = helpers.valueOrDefault;
			var globalDefaults = defaults.global;
			var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
			var style = valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle);
			var family = valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily);
	
			return {
				size: size,
				style: style,
				family: family,
				font: helpers.fontString(size, style, family)
			};
		}
	
		function parseLineHeight(options) {
			return helpers.options.toLineHeight(
				helpers.valueOrDefault(options.lineHeight, 1.2),
				helpers.valueOrDefault(options.fontSize, defaults.global.defaultFontSize));
		}
	
		Chart.Scale = Element.extend({
			/**
			 * Get the padding needed for the scale
			 * @method getPadding
			 * @private
			 * @returns {Padding} the necessary padding
			 */
			getPadding: function() {
				var me = this;
				return {
					left: me.paddingLeft || 0,
					top: me.paddingTop || 0,
					right: me.paddingRight || 0,
					bottom: me.paddingBottom || 0
				};
			},
	
			/**
			 * Returns the scale tick objects ({label, major})
			 * @since 2.7
			 */
			getTicks: function() {
				return this._ticks;
			},
	
			// These methods are ordered by lifecyle. Utilities then follow.
			// Any function defined here is inherited by all scale types.
			// Any function can be extended by the scale type
	
			mergeTicksOptions: function() {
				var ticks = this.options.ticks;
				if (ticks.minor === false) {
					ticks.minor = {
						display: false
					};
				}
				if (ticks.major === false) {
					ticks.major = {
						display: false
					};
				}
				for (var key in ticks) {
					if (key !== 'major' && key !== 'minor') {
						if (typeof ticks.minor[key] === 'undefined') {
							ticks.minor[key] = ticks[key];
						}
						if (typeof ticks.major[key] === 'undefined') {
							ticks.major[key] = ticks[key];
						}
					}
				}
			},
			beforeUpdate: function() {
				helpers.callback(this.options.beforeUpdate, [this]);
			},
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
				var i, ilen, labels, label, ticks, tick;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = helpers.extend({
					left: 0,
					right: 0,
					top: 0,
					bottom: 0
				}, margins);
				me.longestTextCache = me.longestTextCache || {};
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
	
				// Data min/max
				me.beforeDataLimits();
				me.determineDataLimits();
				me.afterDataLimits();
	
				// Ticks - `this.ticks` is now DEPRECATED!
				// Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
				// and must not be accessed directly from outside this class. `this.ticks` being
				// around for long time and not marked as private, we can't change its structure
				// without unexpected breaking changes. If you need to access the scale ticks,
				// use scale.getTicks() instead.
	
				me.beforeBuildTicks();
	
				// New implementations should return an array of objects but for BACKWARD COMPAT,
				// we still support no return (`this.ticks` internally set by calling this method).
				ticks = me.buildTicks() || [];
	
				me.afterBuildTicks();
	
				me.beforeTickToLabelConversion();
	
				// New implementations should return the formatted tick labels but for BACKWARD
				// COMPAT, we still support no return (`this.ticks` internally changed by calling
				// this method and supposed to contain only string values).
				labels = me.convertTicksToLabels(ticks) || me.ticks;
	
				me.afterTickToLabelConversion();
	
				me.ticks = labels;   // BACKWARD COMPATIBILITY
	
				// IMPORTANT: from this point, we consider that `this.ticks` will NEVER change!
	
				// BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
				for (i = 0, ilen = labels.length; i < ilen; ++i) {
					label = labels[i];
					tick = ticks[i];
					if (!tick) {
						ticks.push(tick = {
							label: label,
							major: false
						});
					} else {
						tick.label = label;
					}
				}
	
				me._ticks = ticks;
	
				// Tick Rotation
				me.beforeCalculateTickRotation();
				me.calculateTickRotation();
				me.afterCalculateTickRotation();
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: function() {
				helpers.callback(this.options.afterUpdate, [this]);
			},
	
			//
	
			beforeSetDimensions: function() {
				helpers.callback(this.options.beforeSetDimensions, [this]);
			},
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
			},
			afterSetDimensions: function() {
				helpers.callback(this.options.afterSetDimensions, [this]);
			},
	
			// Data limits
			beforeDataLimits: function() {
				helpers.callback(this.options.beforeDataLimits, [this]);
			},
			determineDataLimits: helpers.noop,
			afterDataLimits: function() {
				helpers.callback(this.options.afterDataLimits, [this]);
			},
	
			//
			beforeBuildTicks: function() {
				helpers.callback(this.options.beforeBuildTicks, [this]);
			},
			buildTicks: helpers.noop,
			afterBuildTicks: function() {
				helpers.callback(this.options.afterBuildTicks, [this]);
			},
	
			beforeTickToLabelConversion: function() {
				helpers.callback(this.options.beforeTickToLabelConversion, [this]);
			},
			convertTicksToLabels: function() {
				var me = this;
				// Convert ticks to strings
				var tickOpts = me.options.ticks;
				me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
			},
			afterTickToLabelConversion: function() {
				helpers.callback(this.options.afterTickToLabelConversion, [this]);
			},
	
			//
	
			beforeCalculateTickRotation: function() {
				helpers.callback(this.options.beforeCalculateTickRotation, [this]);
			},
			calculateTickRotation: function() {
				var me = this;
				var context = me.ctx;
				var tickOpts = me.options.ticks;
				var labels = labelsFromTicks(me._ticks);
	
				// Get the width of each grid by calculating the difference
				// between x offsets between 0 and 1.
				var tickFont = parseFontOptions(tickOpts);
				context.font = tickFont.font;
	
				var labelRotation = tickOpts.minRotation || 0;
	
				if (labels.length && me.options.display && me.isHorizontal()) {
					var originalLabelWidth = helpers.longestText(context, tickFont.font, labels, me.longestTextCache);
					var labelWidth = originalLabelWidth;
					var cosRotation, sinRotation;
	
					// Allow 3 pixels x2 padding either side for label readability
					var tickWidth = me.getPixelForTick(1) - me.getPixelForTick(0) - 6;
	
					// Max label rotation can be set or default to 90 - also act as a loop counter
					while (labelWidth > tickWidth && labelRotation < tickOpts.maxRotation) {
						var angleRadians = helpers.toRadians(labelRotation);
						cosRotation = Math.cos(angleRadians);
						sinRotation = Math.sin(angleRadians);
	
						if (sinRotation * originalLabelWidth > me.maxHeight) {
							// go back one step
							labelRotation--;
							break;
						}
	
						labelRotation++;
						labelWidth = cosRotation * originalLabelWidth;
					}
				}
	
				me.labelRotation = labelRotation;
			},
			afterCalculateTickRotation: function() {
				helpers.callback(this.options.afterCalculateTickRotation, [this]);
			},
	
			//
	
			beforeFit: function() {
				helpers.callback(this.options.beforeFit, [this]);
			},
			fit: function() {
				var me = this;
				// Reset
				var minSize = me.minSize = {
					width: 0,
					height: 0
				};
	
				var labels = labelsFromTicks(me._ticks);
	
				var opts = me.options;
				var tickOpts = opts.ticks;
				var scaleLabelOpts = opts.scaleLabel;
				var gridLineOpts = opts.gridLines;
				var display = opts.display;
				var isHorizontal = me.isHorizontal();
	
				var tickFont = parseFontOptions(tickOpts);
				var tickMarkLength = opts.gridLines.tickMarkLength;
	
				// Width
				if (isHorizontal) {
					// subtract the margins to line up with the chartArea if we are a full width scale
					minSize.width = me.isFullWidth() ? me.maxWidth - me.margins.left - me.margins.right : me.maxWidth;
				} else {
					minSize.width = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				}
	
				// height
				if (isHorizontal) {
					minSize.height = display && gridLineOpts.drawTicks ? tickMarkLength : 0;
				} else {
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Are we showing a title for the scale?
				if (scaleLabelOpts.display && display) {
					var scaleLabelLineHeight = parseLineHeight(scaleLabelOpts);
					var scaleLabelPadding = helpers.options.toPadding(scaleLabelOpts.padding);
					var deltaHeight = scaleLabelLineHeight + scaleLabelPadding.height;
	
					if (isHorizontal) {
						minSize.height += deltaHeight;
					} else {
						minSize.width += deltaHeight;
					}
				}
	
				// Don't bother fitting the ticks if we are not showing them
				if (tickOpts.display && display) {
					var largestTextWidth = helpers.longestText(me.ctx, tickFont.font, labels, me.longestTextCache);
					var tallestLabelHeightInLines = helpers.numberOfLabelLines(labels);
					var lineSpace = tickFont.size * 0.5;
					var tickPadding = me.options.ticks.padding;
	
					if (isHorizontal) {
						// A horizontal axis is more constrained by the height.
						me.longestLabelWidth = largestTextWidth;
	
						var angleRadians = helpers.toRadians(me.labelRotation);
						var cosRotation = Math.cos(angleRadians);
						var sinRotation = Math.sin(angleRadians);
	
						// TODO - improve this calculation
						var labelHeight = (sinRotation * largestTextWidth)
							+ (tickFont.size * tallestLabelHeightInLines)
							+ (lineSpace * (tallestLabelHeightInLines - 1))
							+ lineSpace; // padding
	
						minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
	
						me.ctx.font = tickFont.font;
						var firstLabelWidth = computeTextSize(me.ctx, labels[0], tickFont.font);
						var lastLabelWidth = computeTextSize(me.ctx, labels[labels.length - 1], tickFont.font);
	
						// Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
						// which means that the right padding is dominated by the font height
						if (me.labelRotation !== 0) {
							me.paddingLeft = opts.position === 'bottom' ? (cosRotation * firstLabelWidth) + 3 : (cosRotation * lineSpace) + 3; // add 3 px to move away from canvas edges
							me.paddingRight = opts.position === 'bottom' ? (cosRotation * lineSpace) + 3 : (cosRotation * lastLabelWidth) + 3;
						} else {
							me.paddingLeft = firstLabelWidth / 2 + 3; // add 3 px to move away from canvas edges
							me.paddingRight = lastLabelWidth / 2 + 3;
						}
					} else {
						// A vertical axis is more constrained by the width. Labels are the
						// dominant factor here, so get that length first and account for padding
						if (tickOpts.mirror) {
							largestTextWidth = 0;
						} else {
							// use lineSpace for consistency with horizontal axis
							// tickPadding is not implemented for horizontal
							largestTextWidth += tickPadding + lineSpace;
						}
	
						minSize.width = Math.min(me.maxWidth, minSize.width + largestTextWidth);
	
						me.paddingTop = tickFont.size / 2;
						me.paddingBottom = tickFont.size / 2;
					}
				}
	
				me.handleMargins();
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
	
			/**
			 * Handle margins and padding interactions
			 * @private
			 */
			handleMargins: function() {
				var me = this;
				if (me.margins) {
					me.paddingLeft = Math.max(me.paddingLeft - me.margins.left, 0);
					me.paddingTop = Math.max(me.paddingTop - me.margins.top, 0);
					me.paddingRight = Math.max(me.paddingRight - me.margins.right, 0);
					me.paddingBottom = Math.max(me.paddingBottom - me.margins.bottom, 0);
				}
			},
	
			afterFit: function() {
				helpers.callback(this.options.afterFit, [this]);
			},
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
			isFullWidth: function() {
				return (this.options.fullWidth);
			},
	
			// Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
			getRightValue: function(rawValue) {
				// Null and undefined values first
				if (helpers.isNullOrUndef(rawValue)) {
					return NaN;
				}
				// isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
				if (typeof rawValue === 'number' && !isFinite(rawValue)) {
					return NaN;
				}
				// If it is in fact an object, dive in one more level
				if (rawValue) {
					if (this.isHorizontal()) {
						if (rawValue.x !== undefined) {
							return this.getRightValue(rawValue.x);
						}
					} else if (rawValue.y !== undefined) {
						return this.getRightValue(rawValue.y);
					}
				}
	
				// Value is good, return it
				return rawValue;
			},
	
			/**
			 * Used to get the value to display in the tooltip for the data at the given index
			 * @param index
			 * @param datasetIndex
			 */
			getLabelForIndex: helpers.noop,
	
			/**
			 * Returns the location of the given data point. Value can either be an index or a numerical value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param value
			 * @param index
			 * @param datasetIndex
			 */
			getPixelForValue: helpers.noop,
	
			/**
			 * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 * @param pixel
			 */
			getValueForPixel: helpers.noop,
	
			/**
			 * Returns the location of the tick at the given index
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForTick: function(index) {
				var me = this;
				var offset = me.options.offset;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var tickWidth = innerWidth / Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
					var pixel = (tickWidth * index) + me.paddingLeft;
	
					if (offset) {
						pixel += tickWidth / 2;
					}
	
					var finalVal = me.left + Math.round(pixel);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				var innerHeight = me.height - (me.paddingTop + me.paddingBottom);
				return me.top + (index * (innerHeight / (me._ticks.length - 1)));
			},
	
			/**
			 * Utility for getting the pixel location of a percentage of scale
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getPixelForDecimal: function(decimal) {
				var me = this;
				if (me.isHorizontal()) {
					var innerWidth = me.width - (me.paddingLeft + me.paddingRight);
					var valueOffset = (innerWidth * decimal) + me.paddingLeft;
	
					var finalVal = me.left + Math.round(valueOffset);
					finalVal += me.isFullWidth() ? me.margins.left : 0;
					return finalVal;
				}
				return me.top + (decimal * me.height);
			},
	
			/**
			 * Returns the pixel for the minimum chart value
			 * The coordinate (0, 0) is at the upper-left corner of the canvas
			 */
			getBasePixel: function() {
				return this.getPixelForValue(this.getBaseValue());
			},
	
			getBaseValue: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0;
			},
	
			/**
			 * Returns a subset of ticks to be plotted to avoid overlapping labels.
			 * @private
			 */
			_autoSkip: function(ticks) {
				var skipRatio;
				var me = this;
				var isHorizontal = me.isHorizontal();
				var optionTicks = me.options.ticks.minor;
				var tickCount = ticks.length;
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
				var cosRotation = Math.cos(labelRotationRadians);
				var longestRotatedLabel = me.longestLabelWidth * cosRotation;
				var result = [];
				var i, tick, shouldSkip;
	
				// figure out the maximum number of gridlines to show
				var maxTicks;
				if (optionTicks.maxTicksLimit) {
					maxTicks = optionTicks.maxTicksLimit;
				}
	
				if (isHorizontal) {
					skipRatio = false;
	
					if ((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount > (me.width - (me.paddingLeft + me.paddingRight))) {
						skipRatio = 1 + Math.floor(((longestRotatedLabel + optionTicks.autoSkipPadding) * tickCount) / (me.width - (me.paddingLeft + me.paddingRight)));
					}
	
					// if they defined a max number of optionTicks,
					// increase skipRatio until that number is met
					if (maxTicks && tickCount > maxTicks) {
						skipRatio = Math.max(skipRatio, Math.floor(tickCount / maxTicks));
					}
				}
	
				for (i = 0; i < tickCount; i++) {
					tick = ticks[i];
	
					// Since we always show the last tick,we need may need to hide the last shown one before
					shouldSkip = (skipRatio > 1 && i % skipRatio > 0) || (i % skipRatio === 0 && i + skipRatio >= tickCount);
					if (shouldSkip && i !== tickCount - 1) {
						// leave tick in place but make sure it's not displayed (#4635)
						delete tick.label;
					}
					result.push(tick);
				}
				return result;
			},
	
			// Actually draw the scale on the canvas
			// @param {rectangle} chartArea : the area of the chart to draw full grid lines on
			draw: function(chartArea) {
				var me = this;
				var options = me.options;
				if (!options.display) {
					return;
				}
	
				var context = me.ctx;
				var globalDefaults = defaults.global;
				var optionTicks = options.ticks.minor;
				var optionMajorTicks = options.ticks.major || optionTicks;
				var gridLines = options.gridLines;
				var scaleLabel = options.scaleLabel;
	
				var isRotated = me.labelRotation !== 0;
				var isHorizontal = me.isHorizontal();
	
				var ticks = optionTicks.autoSkip ? me._autoSkip(me.getTicks()) : me.getTicks();
				var tickFontColor = helpers.valueOrDefault(optionTicks.fontColor, globalDefaults.defaultFontColor);
				var tickFont = parseFontOptions(optionTicks);
				var majorTickFontColor = helpers.valueOrDefault(optionMajorTicks.fontColor, globalDefaults.defaultFontColor);
				var majorTickFont = parseFontOptions(optionMajorTicks);
	
				var tl = gridLines.drawTicks ? gridLines.tickMarkLength : 0;
	
				var scaleLabelFontColor = helpers.valueOrDefault(scaleLabel.fontColor, globalDefaults.defaultFontColor);
				var scaleLabelFont = parseFontOptions(scaleLabel);
				var scaleLabelPadding = helpers.options.toPadding(scaleLabel.padding);
				var labelRotationRadians = helpers.toRadians(me.labelRotation);
	
				var itemsToDraw = [];
	
				var xTickStart = options.position === 'right' ? me.left : me.right - tl;
				var xTickEnd = options.position === 'right' ? me.left + tl : me.right;
				var yTickStart = options.position === 'bottom' ? me.top : me.bottom - tl;
				var yTickEnd = options.position === 'bottom' ? me.top + tl : me.bottom;
	
				helpers.each(ticks, function(tick, index) {
					// autoskipper skipped this tick (#4635)
					if (helpers.isNullOrUndef(tick.label)) {
						return;
					}
	
					var label = tick.label;
					var lineWidth, lineColor, borderDash, borderDashOffset;
					if (index === me.zeroLineIndex && options.offset === gridLines.offsetGridLines) {
						// Draw the first index specially
						lineWidth = gridLines.zeroLineWidth;
						lineColor = gridLines.zeroLineColor;
						borderDash = gridLines.zeroLineBorderDash;
						borderDashOffset = gridLines.zeroLineBorderDashOffset;
					} else {
						lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, index);
						lineColor = helpers.valueAtIndexOrDefault(gridLines.color, index);
						borderDash = helpers.valueOrDefault(gridLines.borderDash, globalDefaults.borderDash);
						borderDashOffset = helpers.valueOrDefault(gridLines.borderDashOffset, globalDefaults.borderDashOffset);
					}
	
					// Common properties
					var tx1, ty1, tx2, ty2, x1, y1, x2, y2, labelX, labelY;
					var textAlign = 'middle';
					var textBaseline = 'middle';
					var tickPadding = optionTicks.padding;
	
					if (isHorizontal) {
						var labelYOffset = tl + tickPadding;
	
						if (options.position === 'bottom') {
							// bottom
							textBaseline = !isRotated ? 'top' : 'middle';
							textAlign = !isRotated ? 'center' : 'right';
							labelY = me.top + labelYOffset;
						} else {
							// top
							textBaseline = !isRotated ? 'bottom' : 'middle';
							textAlign = !isRotated ? 'center' : 'left';
							labelY = me.bottom - labelYOffset;
						}
	
						var xLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (xLineValue < me.left) {
							lineColor = 'rgba(0,0,0,0)';
						}
						xLineValue += helpers.aliasPixel(lineWidth);
	
						labelX = me.getPixelForTick(index) + optionTicks.labelOffset; // x values for optionTicks (need to consider offsetLabel option)
	
						tx1 = tx2 = x1 = x2 = xLineValue;
						ty1 = yTickStart;
						ty2 = yTickEnd;
						y1 = chartArea.top;
						y2 = chartArea.bottom;
					} else {
						var isLeft = options.position === 'left';
						var labelXOffset;
	
						if (optionTicks.mirror) {
							textAlign = isLeft ? 'left' : 'right';
							labelXOffset = tickPadding;
						} else {
							textAlign = isLeft ? 'right' : 'left';
							labelXOffset = tl + tickPadding;
						}
	
						labelX = isLeft ? me.right - labelXOffset : me.left + labelXOffset;
	
						var yLineValue = getLineValue(me, index, gridLines.offsetGridLines && ticks.length > 1);
						if (yLineValue < me.top) {
							lineColor = 'rgba(0,0,0,0)';
						}
						yLineValue += helpers.aliasPixel(lineWidth);
	
						labelY = me.getPixelForTick(index) + optionTicks.labelOffset;
	
						tx1 = xTickStart;
						tx2 = xTickEnd;
						x1 = chartArea.left;
						x2 = chartArea.right;
						ty1 = ty2 = y1 = y2 = yLineValue;
					}
	
					itemsToDraw.push({
						tx1: tx1,
						ty1: ty1,
						tx2: tx2,
						ty2: ty2,
						x1: x1,
						y1: y1,
						x2: x2,
						y2: y2,
						labelX: labelX,
						labelY: labelY,
						glWidth: lineWidth,
						glColor: lineColor,
						glBorderDash: borderDash,
						glBorderDashOffset: borderDashOffset,
						rotation: -1 * labelRotationRadians,
						label: label,
						major: tick.major,
						textBaseline: textBaseline,
						textAlign: textAlign
					});
				});
	
				// Draw all of the tick labels, tick marks, and grid lines at the correct places
				helpers.each(itemsToDraw, function(itemToDraw) {
					if (gridLines.display) {
						context.save();
						context.lineWidth = itemToDraw.glWidth;
						context.strokeStyle = itemToDraw.glColor;
						if (context.setLineDash) {
							context.setLineDash(itemToDraw.glBorderDash);
							context.lineDashOffset = itemToDraw.glBorderDashOffset;
						}
	
						context.beginPath();
	
						if (gridLines.drawTicks) {
							context.moveTo(itemToDraw.tx1, itemToDraw.ty1);
							context.lineTo(itemToDraw.tx2, itemToDraw.ty2);
						}
	
						if (gridLines.drawOnChartArea) {
							context.moveTo(itemToDraw.x1, itemToDraw.y1);
							context.lineTo(itemToDraw.x2, itemToDraw.y2);
						}
	
						context.stroke();
						context.restore();
					}
	
					if (optionTicks.display) {
						// Make sure we draw text in the correct color and font
						context.save();
						context.translate(itemToDraw.labelX, itemToDraw.labelY);
						context.rotate(itemToDraw.rotation);
						context.font = itemToDraw.major ? majorTickFont.font : tickFont.font;
						context.fillStyle = itemToDraw.major ? majorTickFontColor : tickFontColor;
						context.textBaseline = itemToDraw.textBaseline;
						context.textAlign = itemToDraw.textAlign;
	
						var label = itemToDraw.label;
						if (helpers.isArray(label)) {
							for (var i = 0, y = 0; i < label.length; ++i) {
								// We just make sure the multiline element is a string here..
								context.fillText('' + label[i], 0, y);
								// apply same lineSpacing as calculated @ L#320
								y += (tickFont.size * 1.5);
							}
						} else {
							context.fillText(label, 0, 0);
						}
						context.restore();
					}
				});
	
				if (scaleLabel.display) {
					// Draw the scale label
					var scaleLabelX;
					var scaleLabelY;
					var rotation = 0;
					var halfLineHeight = parseLineHeight(scaleLabel) / 2;
	
					if (isHorizontal) {
						scaleLabelX = me.left + ((me.right - me.left) / 2); // midpoint of the width
						scaleLabelY = options.position === 'bottom'
							? me.bottom - halfLineHeight - scaleLabelPadding.bottom
							: me.top + halfLineHeight + scaleLabelPadding.top;
					} else {
						var isLeft = options.position === 'left';
						scaleLabelX = isLeft
							? me.left + halfLineHeight + scaleLabelPadding.top
							: me.right - halfLineHeight - scaleLabelPadding.top;
						scaleLabelY = me.top + ((me.bottom - me.top) / 2);
						rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
					}
	
					context.save();
					context.translate(scaleLabelX, scaleLabelY);
					context.rotate(rotation);
					context.textAlign = 'center';
					context.textBaseline = 'middle';
					context.fillStyle = scaleLabelFontColor; // render in correct colour
					context.font = scaleLabelFont.font;
					context.fillText(scaleLabel.labelString, 0, 0);
					context.restore();
				}
	
				if (gridLines.drawBorder) {
					// Draw the line at the edge of the axis
					context.lineWidth = helpers.valueAtIndexOrDefault(gridLines.lineWidth, 0);
					context.strokeStyle = helpers.valueAtIndexOrDefault(gridLines.color, 0);
					var x1 = me.left;
					var x2 = me.right;
					var y1 = me.top;
					var y2 = me.bottom;
	
					var aliasPixel = helpers.aliasPixel(context.lineWidth);
					if (isHorizontal) {
						y1 = y2 = options.position === 'top' ? me.bottom : me.top;
						y1 += aliasPixel;
						y2 += aliasPixel;
					} else {
						x1 = x2 = options.position === 'left' ? me.right : me.left;
						x1 += aliasPixel;
						x2 += aliasPixel;
					}
	
					context.beginPath();
					context.moveTo(x1, y1);
					context.lineTo(x2, y2);
					context.stroke();
				}
			}
		});
	};


/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var helpers = __webpack_require__(23);
	
	module.exports = function(Chart) {
	
		Chart.scaleService = {
			// Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
			// use the new chart options to grab the correct scale
			constructors: {},
			// Use a registration function so that we can move to an ES6 map when we no longer need to support
			// old browsers
	
			// Scale config defaults
			defaults: {},
			registerScaleType: function(type, scaleConstructor, scaleDefaults) {
				this.constructors[type] = scaleConstructor;
				this.defaults[type] = helpers.clone(scaleDefaults);
			},
			getScaleConstructor: function(type) {
				return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
			},
			getScaleDefaults: function(type) {
				// Return the scale defaults merged with the global settings so that we always use the latest ones
				return this.defaults.hasOwnProperty(type) ? helpers.merge({}, [defaults.scale, this.defaults[type]]) : {};
			},
			updateScaleDefaults: function(type, additions) {
				var me = this;
				if (me.defaults.hasOwnProperty(type)) {
					me.defaults[type] = helpers.extend(me.defaults[type], additions);
				}
			},
			addScalesToLayout: function(chart) {
				// Adds each scale to the chart.boxes array to be sized accordingly
				helpers.each(chart.scales, function(scale) {
					// Set ILayoutItem parameters for backwards compatibility
					scale.fullWidth = scale.options.fullWidth;
					scale.position = scale.options.position;
					scale.weight = scale.options.weight;
					Chart.layoutService.addBox(chart, scale);
				});
			}
		};
	};


/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		tooltips: {
			enabled: true,
			custom: null,
			mode: 'nearest',
			position: 'average',
			intersect: true,
			backgroundColor: 'rgba(0,0,0,0.8)',
			titleFontStyle: 'bold',
			titleSpacing: 2,
			titleMarginBottom: 6,
			titleFontColor: '#fff',
			titleAlign: 'left',
			bodySpacing: 2,
			bodyFontColor: '#fff',
			bodyAlign: 'left',
			footerFontStyle: 'bold',
			footerSpacing: 2,
			footerMarginTop: 6,
			footerFontColor: '#fff',
			footerAlign: 'left',
			yPadding: 6,
			xPadding: 6,
			caretPadding: 2,
			caretSize: 5,
			cornerRadius: 6,
			multiKeyBackground: '#fff',
			displayColors: true,
			borderColor: 'rgba(0,0,0,0)',
			borderWidth: 0,
			callbacks: {
				// Args are: (tooltipItems, data)
				beforeTitle: helpers.noop,
				title: function(tooltipItems, data) {
					// Pick first xLabel for now
					var title = '';
					var labels = data.labels;
					var labelCount = labels ? labels.length : 0;
	
					if (tooltipItems.length > 0) {
						var item = tooltipItems[0];
	
						if (item.xLabel) {
							title = item.xLabel;
						} else if (labelCount > 0 && item.index < labelCount) {
							title = labels[item.index];
						}
					}
	
					return title;
				},
				afterTitle: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeBody: helpers.noop,
	
				// Args are: (tooltipItem, data)
				beforeLabel: helpers.noop,
				label: function(tooltipItem, data) {
					var label = data.datasets[tooltipItem.datasetIndex].label || '';
	
					if (label) {
						label += ': ';
					}
					label += tooltipItem.yLabel;
					return label;
				},
				labelColor: function(tooltipItem, chart) {
					var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
					var activeElement = meta.data[tooltipItem.index];
					var view = activeElement._view;
					return {
						borderColor: view.borderColor,
						backgroundColor: view.backgroundColor
					};
				},
				labelTextColor: function() {
					return this._options.bodyFontColor;
				},
				afterLabel: helpers.noop,
	
				// Args are: (tooltipItems, data)
				afterBody: helpers.noop,
	
				// Args are: (tooltipItems, data)
				beforeFooter: helpers.noop,
				footer: helpers.noop,
				afterFooter: helpers.noop
			}
		}
	});
	
	module.exports = function(Chart) {
	
		/**
	 	 * Helper method to merge the opacity into a color
	 	 */
		function mergeOpacity(colorString, opacity) {
			var color = helpers.color(colorString);
			return color.alpha(opacity * color.alpha()).rgbaString();
		}
	
		// Helper to push or concat based on if the 2nd parameter is an array or not
		function pushOrConcat(base, toPush) {
			if (toPush) {
				if (helpers.isArray(toPush)) {
					// base = base.concat(toPush);
					Array.prototype.push.apply(base, toPush);
				} else {
					base.push(toPush);
				}
			}
	
			return base;
		}
	
		// Private helper to create a tooltip item model
		// @param element : the chart element (point, arc, bar) to create the tooltip item for
		// @return : new tooltip item
		function createTooltipItem(element) {
			var xScale = element._xScale;
			var yScale = element._yScale || element._scale; // handle radar || polarArea charts
			var index = element._index;
			var datasetIndex = element._datasetIndex;
	
			return {
				xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
				yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
				index: index,
				datasetIndex: datasetIndex,
				x: element._model.x,
				y: element._model.y
			};
		}
	
		/**
		 * Helper to get the reset model for the tooltip
		 * @param tooltipOpts {Object} the tooltip options
		 */
		function getBaseModel(tooltipOpts) {
			var globalDefaults = defaults.global;
			var valueOrDefault = helpers.valueOrDefault;
	
			return {
				// Positioning
				xPadding: tooltipOpts.xPadding,
				yPadding: tooltipOpts.yPadding,
				xAlign: tooltipOpts.xAlign,
				yAlign: tooltipOpts.yAlign,
	
				// Body
				bodyFontColor: tooltipOpts.bodyFontColor,
				_bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
				_bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
				_bodyAlign: tooltipOpts.bodyAlign,
				bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
				bodySpacing: tooltipOpts.bodySpacing,
	
				// Title
				titleFontColor: tooltipOpts.titleFontColor,
				_titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
				_titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
				titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
				_titleAlign: tooltipOpts.titleAlign,
				titleSpacing: tooltipOpts.titleSpacing,
				titleMarginBottom: tooltipOpts.titleMarginBottom,
	
				// Footer
				footerFontColor: tooltipOpts.footerFontColor,
				_footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
				_footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
				footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
				_footerAlign: tooltipOpts.footerAlign,
				footerSpacing: tooltipOpts.footerSpacing,
				footerMarginTop: tooltipOpts.footerMarginTop,
	
				// Appearance
				caretSize: tooltipOpts.caretSize,
				cornerRadius: tooltipOpts.cornerRadius,
				backgroundColor: tooltipOpts.backgroundColor,
				opacity: 0,
				legendColorBackground: tooltipOpts.multiKeyBackground,
				displayColors: tooltipOpts.displayColors,
				borderColor: tooltipOpts.borderColor,
				borderWidth: tooltipOpts.borderWidth
			};
		}
	
		/**
		 * Get the size of the tooltip
		 */
		function getTooltipSize(tooltip, model) {
			var ctx = tooltip._chart.ctx;
	
			var height = model.yPadding * 2; // Tooltip Padding
			var width = 0;
	
			// Count of all lines in the body
			var body = model.body;
			var combinedBodyLength = body.reduce(function(count, bodyItem) {
				return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
			}, 0);
			combinedBodyLength += model.beforeBody.length + model.afterBody.length;
	
			var titleLineCount = model.title.length;
			var footerLineCount = model.footer.length;
			var titleFontSize = model.titleFontSize;
			var bodyFontSize = model.bodyFontSize;
			var footerFontSize = model.footerFontSize;
	
			height += titleLineCount * titleFontSize; // Title Lines
			height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
			height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
			height += combinedBodyLength * bodyFontSize; // Body Lines
			height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
			height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
			height += footerLineCount * (footerFontSize); // Footer Lines
			height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing
	
			// Title width
			var widthPadding = 0;
			var maxLineWidth = function(line) {
				width = Math.max(width, ctx.measureText(line).width + widthPadding);
			};
	
			ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
			helpers.each(model.title, maxLineWidth);
	
			// Body width
			ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
			helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);
	
			// Body lines may include some extra width due to the color box
			widthPadding = model.displayColors ? (bodyFontSize + 2) : 0;
			helpers.each(body, function(bodyItem) {
				helpers.each(bodyItem.before, maxLineWidth);
				helpers.each(bodyItem.lines, maxLineWidth);
				helpers.each(bodyItem.after, maxLineWidth);
			});
	
			// Reset back to 0
			widthPadding = 0;
	
			// Footer width
			ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
			helpers.each(model.footer, maxLineWidth);
	
			// Add padding
			width += 2 * model.xPadding;
	
			return {
				width: width,
				height: height
			};
		}
	
		/**
		 * Helper to get the alignment of a tooltip given the size
		 */
		function determineAlignment(tooltip, size) {
			var model = tooltip._model;
			var chart = tooltip._chart;
			var chartArea = tooltip._chart.chartArea;
			var xAlign = 'center';
			var yAlign = 'center';
	
			if (model.y < size.height) {
				yAlign = 'top';
			} else if (model.y > (chart.height - size.height)) {
				yAlign = 'bottom';
			}
	
			var lf, rf; // functions to determine left, right alignment
			var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
			var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
			var midX = (chartArea.left + chartArea.right) / 2;
			var midY = (chartArea.top + chartArea.bottom) / 2;
	
			if (yAlign === 'center') {
				lf = function(x) {
					return x <= midX;
				};
				rf = function(x) {
					return x > midX;
				};
			} else {
				lf = function(x) {
					return x <= (size.width / 2);
				};
				rf = function(x) {
					return x >= (chart.width - (size.width / 2));
				};
			}
	
			olf = function(x) {
				return x + size.width > chart.width;
			};
			orf = function(x) {
				return x - size.width < 0;
			};
			yf = function(y) {
				return y <= midY ? 'top' : 'bottom';
			};
	
			if (lf(model.x)) {
				xAlign = 'left';
	
				// Is tooltip too wide and goes over the right side of the chart.?
				if (olf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			} else if (rf(model.x)) {
				xAlign = 'right';
	
				// Is tooltip too wide and goes outside left edge of canvas?
				if (orf(model.x)) {
					xAlign = 'center';
					yAlign = yf(model.y);
				}
			}
	
			var opts = tooltip._options;
			return {
				xAlign: opts.xAlign ? opts.xAlign : xAlign,
				yAlign: opts.yAlign ? opts.yAlign : yAlign
			};
		}
	
		/**
		 * @Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
		 */
		function getBackgroundPoint(vm, size, alignment) {
			// Background Position
			var x = vm.x;
			var y = vm.y;
	
			var caretSize = vm.caretSize;
			var caretPadding = vm.caretPadding;
			var cornerRadius = vm.cornerRadius;
			var xAlign = alignment.xAlign;
			var yAlign = alignment.yAlign;
			var paddingAndSize = caretSize + caretPadding;
			var radiusAndPadding = cornerRadius + caretPadding;
	
			if (xAlign === 'right') {
				x -= size.width;
			} else if (xAlign === 'center') {
				x -= (size.width / 2);
			}
	
			if (yAlign === 'top') {
				y += paddingAndSize;
			} else if (yAlign === 'bottom') {
				y -= size.height + paddingAndSize;
			} else {
				y -= (size.height / 2);
			}
	
			if (yAlign === 'center') {
				if (xAlign === 'left') {
					x += paddingAndSize;
				} else if (xAlign === 'right') {
					x -= paddingAndSize;
				}
			} else if (xAlign === 'left') {
				x -= radiusAndPadding;
			} else if (xAlign === 'right') {
				x += radiusAndPadding;
			}
	
			return {
				x: x,
				y: y
			};
		}
	
		Chart.Tooltip = Element.extend({
			initialize: function() {
				this._model = getBaseModel(this._options);
				this._lastActive = [];
			},
	
			// Get the title
			// Args are: (tooltipItem, data)
			getTitle: function() {
				var me = this;
				var opts = me._options;
				var callbacks = opts.callbacks;
	
				var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
				var title = callbacks.title.apply(me, arguments);
				var afterTitle = callbacks.afterTitle.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeTitle);
				lines = pushOrConcat(lines, title);
				lines = pushOrConcat(lines, afterTitle);
	
				return lines;
			},
	
			// Args are: (tooltipItem, data)
			getBeforeBody: function() {
				var lines = this._options.callbacks.beforeBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Args are: (tooltipItem, data)
			getBody: function(tooltipItems, data) {
				var me = this;
				var callbacks = me._options.callbacks;
				var bodyItems = [];
	
				helpers.each(tooltipItems, function(tooltipItem) {
					var bodyItem = {
						before: [],
						lines: [],
						after: []
					};
					pushOrConcat(bodyItem.before, callbacks.beforeLabel.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
					pushOrConcat(bodyItem.after, callbacks.afterLabel.call(me, tooltipItem, data));
	
					bodyItems.push(bodyItem);
				});
	
				return bodyItems;
			},
	
			// Args are: (tooltipItem, data)
			getAfterBody: function() {
				var lines = this._options.callbacks.afterBody.apply(this, arguments);
				return helpers.isArray(lines) ? lines : lines !== undefined ? [lines] : [];
			},
	
			// Get the footer and beforeFooter and afterFooter lines
			// Args are: (tooltipItem, data)
			getFooter: function() {
				var me = this;
				var callbacks = me._options.callbacks;
	
				var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
				var footer = callbacks.footer.apply(me, arguments);
				var afterFooter = callbacks.afterFooter.apply(me, arguments);
	
				var lines = [];
				lines = pushOrConcat(lines, beforeFooter);
				lines = pushOrConcat(lines, footer);
				lines = pushOrConcat(lines, afterFooter);
	
				return lines;
			},
	
			update: function(changed) {
				var me = this;
				var opts = me._options;
	
				// Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
				// that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
				// which breaks any animations.
				var existingModel = me._model;
				var model = me._model = getBaseModel(opts);
				var active = me._active;
	
				var data = me._data;
	
				// In the case where active.length === 0 we need to keep these at existing values for good animations
				var alignment = {
					xAlign: existingModel.xAlign,
					yAlign: existingModel.yAlign
				};
				var backgroundPoint = {
					x: existingModel.x,
					y: existingModel.y
				};
				var tooltipSize = {
					width: existingModel.width,
					height: existingModel.height
				};
				var tooltipPosition = {
					x: existingModel.caretX,
					y: existingModel.caretY
				};
	
				var i, len;
	
				if (active.length) {
					model.opacity = 1;
	
					var labelColors = [];
					var labelTextColors = [];
					tooltipPosition = Chart.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);
	
					var tooltipItems = [];
					for (i = 0, len = active.length; i < len; ++i) {
						tooltipItems.push(createTooltipItem(active[i]));
					}
	
					// If the user provided a filter function, use it to modify the tooltip items
					if (opts.filter) {
						tooltipItems = tooltipItems.filter(function(a) {
							return opts.filter(a, data);
						});
					}
	
					// If the user provided a sorting function, use it to modify the tooltip items
					if (opts.itemSort) {
						tooltipItems = tooltipItems.sort(function(a, b) {
							return opts.itemSort(a, b, data);
						});
					}
	
					// Determine colors for boxes
					helpers.each(tooltipItems, function(tooltipItem) {
						labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
						labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
					});
	
	
					// Build the Text Lines
					model.title = me.getTitle(tooltipItems, data);
					model.beforeBody = me.getBeforeBody(tooltipItems, data);
					model.body = me.getBody(tooltipItems, data);
					model.afterBody = me.getAfterBody(tooltipItems, data);
					model.footer = me.getFooter(tooltipItems, data);
	
					// Initial positioning and colors
					model.x = Math.round(tooltipPosition.x);
					model.y = Math.round(tooltipPosition.y);
					model.caretPadding = opts.caretPadding;
					model.labelColors = labelColors;
					model.labelTextColors = labelTextColors;
	
					// data points
					model.dataPoints = tooltipItems;
	
					// We need to determine alignment of the tooltip
					tooltipSize = getTooltipSize(this, model);
					alignment = determineAlignment(this, tooltipSize);
					// Final Size and Position
					backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment);
				} else {
					model.opacity = 0;
				}
	
				model.xAlign = alignment.xAlign;
				model.yAlign = alignment.yAlign;
				model.x = backgroundPoint.x;
				model.y = backgroundPoint.y;
				model.width = tooltipSize.width;
				model.height = tooltipSize.height;
	
				// Point where the caret on the tooltip points to
				model.caretX = tooltipPosition.x;
				model.caretY = tooltipPosition.y;
	
				me._model = model;
	
				if (changed && opts.custom) {
					opts.custom.call(me, model);
				}
	
				return me;
			},
			drawCaret: function(tooltipPoint, size) {
				var ctx = this._chart.ctx;
				var vm = this._view;
				var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
	
				ctx.lineTo(caretPosition.x1, caretPosition.y1);
				ctx.lineTo(caretPosition.x2, caretPosition.y2);
				ctx.lineTo(caretPosition.x3, caretPosition.y3);
			},
			getCaretPosition: function(tooltipPoint, size, vm) {
				var x1, x2, x3, y1, y2, y3;
				var caretSize = vm.caretSize;
				var cornerRadius = vm.cornerRadius;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var ptX = tooltipPoint.x;
				var ptY = tooltipPoint.y;
				var width = size.width;
				var height = size.height;
	
				if (yAlign === 'center') {
					y2 = ptY + (height / 2);
	
					if (xAlign === 'left') {
						x1 = ptX;
						x2 = x1 - caretSize;
						x3 = x1;
	
						y1 = y2 + caretSize;
						y3 = y2 - caretSize;
					} else {
						x1 = ptX + width;
						x2 = x1 + caretSize;
						x3 = x1;
	
						y1 = y2 - caretSize;
						y3 = y2 + caretSize;
					}
				} else {
					if (xAlign === 'left') {
						x2 = ptX + cornerRadius + (caretSize);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else if (xAlign === 'right') {
						x2 = ptX + width - cornerRadius - caretSize;
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					} else {
						x2 = ptX + (width / 2);
						x1 = x2 - caretSize;
						x3 = x2 + caretSize;
					}
					if (yAlign === 'top') {
						y1 = ptY;
						y2 = y1 - caretSize;
						y3 = y1;
					} else {
						y1 = ptY + height;
						y2 = y1 + caretSize;
						y3 = y1;
						// invert drawing order
						var tmp = x3;
						x3 = x1;
						x1 = tmp;
					}
				}
				return {x1: x1, x2: x2, x3: x3, y1: y1, y2: y2, y3: y3};
			},
			drawTitle: function(pt, vm, ctx, opacity) {
				var title = vm.title;
	
				if (title.length) {
					ctx.textAlign = vm._titleAlign;
					ctx.textBaseline = 'top';
	
					var titleFontSize = vm.titleFontSize;
					var titleSpacing = vm.titleSpacing;
	
					ctx.fillStyle = mergeOpacity(vm.titleFontColor, opacity);
					ctx.font = helpers.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
	
					var i, len;
					for (i = 0, len = title.length; i < len; ++i) {
						ctx.fillText(title[i], pt.x, pt.y);
						pt.y += titleFontSize + titleSpacing; // Line Height and spacing
	
						if (i + 1 === title.length) {
							pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
						}
					}
				}
			},
			drawBody: function(pt, vm, ctx, opacity) {
				var bodyFontSize = vm.bodyFontSize;
				var bodySpacing = vm.bodySpacing;
				var body = vm.body;
	
				ctx.textAlign = vm._bodyAlign;
				ctx.textBaseline = 'top';
				ctx.font = helpers.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
	
				// Before Body
				var xLinePadding = 0;
				var fillLineOfText = function(line) {
					ctx.fillText(line, pt.x + xLinePadding, pt.y);
					pt.y += bodyFontSize + bodySpacing;
				};
	
				// Before body lines
				ctx.fillStyle = mergeOpacity(vm.bodyFontColor, opacity);
				helpers.each(vm.beforeBody, fillLineOfText);
	
				var drawColorBoxes = vm.displayColors;
				xLinePadding = drawColorBoxes ? (bodyFontSize + 2) : 0;
	
				// Draw body lines now
				helpers.each(body, function(bodyItem, i) {
					var textColor = mergeOpacity(vm.labelTextColors[i], opacity);
					ctx.fillStyle = textColor;
					helpers.each(bodyItem.before, fillLineOfText);
	
					helpers.each(bodyItem.lines, function(line) {
						// Draw Legend-like boxes if needed
						if (drawColorBoxes) {
							// Fill a white rect so that colours merge nicely if the opacity is < 1
							ctx.fillStyle = mergeOpacity(vm.legendColorBackground, opacity);
							ctx.fillRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Border
							ctx.lineWidth = 1;
							ctx.strokeStyle = mergeOpacity(vm.labelColors[i].borderColor, opacity);
							ctx.strokeRect(pt.x, pt.y, bodyFontSize, bodyFontSize);
	
							// Inner square
							ctx.fillStyle = mergeOpacity(vm.labelColors[i].backgroundColor, opacity);
							ctx.fillRect(pt.x + 1, pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
							ctx.fillStyle = textColor;
						}
	
						fillLineOfText(line);
					});
	
					helpers.each(bodyItem.after, fillLineOfText);
				});
	
				// Reset back to 0 for after body
				xLinePadding = 0;
	
				// After body lines
				helpers.each(vm.afterBody, fillLineOfText);
				pt.y -= bodySpacing; // Remove last body spacing
			},
			drawFooter: function(pt, vm, ctx, opacity) {
				var footer = vm.footer;
	
				if (footer.length) {
					pt.y += vm.footerMarginTop;
	
					ctx.textAlign = vm._footerAlign;
					ctx.textBaseline = 'top';
	
					ctx.fillStyle = mergeOpacity(vm.footerFontColor, opacity);
					ctx.font = helpers.fontString(vm.footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
	
					helpers.each(footer, function(line) {
						ctx.fillText(line, pt.x, pt.y);
						pt.y += vm.footerFontSize + vm.footerSpacing;
					});
				}
			},
			drawBackground: function(pt, vm, ctx, tooltipSize, opacity) {
				ctx.fillStyle = mergeOpacity(vm.backgroundColor, opacity);
				ctx.strokeStyle = mergeOpacity(vm.borderColor, opacity);
				ctx.lineWidth = vm.borderWidth;
				var xAlign = vm.xAlign;
				var yAlign = vm.yAlign;
				var x = pt.x;
				var y = pt.y;
				var width = tooltipSize.width;
				var height = tooltipSize.height;
				var radius = vm.cornerRadius;
	
				ctx.beginPath();
				ctx.moveTo(x + radius, y);
				if (yAlign === 'top') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width - radius, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
				if (yAlign === 'center' && xAlign === 'right') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + width, y + height - radius);
				ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
				if (yAlign === 'bottom') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x + radius, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
				if (yAlign === 'center' && xAlign === 'left') {
					this.drawCaret(pt, tooltipSize);
				}
				ctx.lineTo(x, y + radius);
				ctx.quadraticCurveTo(x, y, x + radius, y);
				ctx.closePath();
	
				ctx.fill();
	
				if (vm.borderWidth > 0) {
					ctx.stroke();
				}
			},
			draw: function() {
				var ctx = this._chart.ctx;
				var vm = this._view;
	
				if (vm.opacity === 0) {
					return;
				}
	
				var tooltipSize = {
					width: vm.width,
					height: vm.height
				};
				var pt = {
					x: vm.x,
					y: vm.y
				};
	
				// IE11/Edge does not like very small opacities, so snap to 0
				var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;
	
				// Truthy/falsey value for empty tooltip
				var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
	
				if (this._options.enabled && hasTooltipContent) {
					// Draw Background
					this.drawBackground(pt, vm, ctx, tooltipSize, opacity);
	
					// Draw Title, Body, and Footer
					pt.x += vm.xPadding;
					pt.y += vm.yPadding;
	
					// Titles
					this.drawTitle(pt, vm, ctx, opacity);
	
					// Body
					this.drawBody(pt, vm, ctx, opacity);
	
					// Footer
					this.drawFooter(pt, vm, ctx, opacity);
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @returns {Boolean} true if the tooltip changed
			 */
			handleEvent: function(e) {
				var me = this;
				var options = me._options;
				var changed = false;
	
				me._lastActive = me._lastActive || [];
	
				// Find Active Elements for tooltips
				if (e.type === 'mouseout') {
					me._active = [];
				} else {
					me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
				}
	
				// Remember Last Actives
				changed = !helpers.arrayEquals(me._active, me._lastActive);
	
				// If tooltip didn't change, do not handle the target event
				if (!changed) {
					return false;
				}
	
				me._lastActive = me._active;
	
				if (options.enabled || options.custom) {
					me._eventPosition = {
						x: e.x,
						y: e.y
					};
	
					var model = me._model;
					me.update(true);
					me.pivot();
	
					// See if our tooltip position changed
					changed |= (model.x !== me._model.x) || (model.y !== me._model.y);
				}
	
				return changed;
			}
		});
	
		/**
		 * @namespace Chart.Tooltip.positioners
		 */
		Chart.Tooltip.positioners = {
			/**
			 * Average mode places the tooltip at the average position of the elements shown
			 * @function Chart.Tooltip.positioners.average
			 * @param elements {ChartElement[]} the elements being displayed in the tooltip
			 * @returns {Point} tooltip position
			 */
			average: function(elements) {
				if (!elements.length) {
					return false;
				}
	
				var i, len;
				var x = 0;
				var y = 0;
				var count = 0;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var pos = el.tooltipPosition();
						x += pos.x;
						y += pos.y;
						++count;
					}
				}
	
				return {
					x: Math.round(x / count),
					y: Math.round(y / count)
				};
			},
	
			/**
			 * Gets the tooltip position nearest of the item nearest to the event position
			 * @function Chart.Tooltip.positioners.nearest
			 * @param elements {Chart.Element[]} the tooltip elements
			 * @param eventPosition {Point} the position of the event in canvas coordinates
			 * @returns {Point} the tooltip position
			 */
			nearest: function(elements, eventPosition) {
				var x = eventPosition.x;
				var y = eventPosition.y;
				var minDistance = Number.POSITIVE_INFINITY;
				var i, len, nearestElement;
	
				for (i = 0, len = elements.length; i < len; ++i) {
					var el = elements[i];
					if (el && el.hasValue()) {
						var center = el.getCenterPoint();
						var d = helpers.distanceBetweenPoints(eventPosition, center);
	
						if (d < minDistance) {
							minDistance = d;
							nearestElement = el;
						}
					}
				}
	
				if (nearestElement) {
					var tp = nearestElement.tooltipPosition();
					x = tp.x;
					y = tp.y;
				}
	
				return {
					x: x,
					y: y
				};
			}
		};
	};


/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		elements: {
			arc: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: '#fff',
				borderWidth: 2
			}
		}
	});
	
	module.exports = Element.extend({
		inLabelRange: function(mouseX) {
			var vm = this._view;
	
			if (vm) {
				return (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2));
			}
			return false;
		},
	
		inRange: function(chartX, chartY) {
			var vm = this._view;
	
			if (vm) {
				var pointRelativePosition = helpers.getAngleFromPoint(vm, {x: chartX, y: chartY});
				var	angle = pointRelativePosition.angle;
				var distance = pointRelativePosition.distance;
	
				// Sanitise angle range
				var startAngle = vm.startAngle;
				var endAngle = vm.endAngle;
				while (endAngle < startAngle) {
					endAngle += 2.0 * Math.PI;
				}
				while (angle > endAngle) {
					angle -= 2.0 * Math.PI;
				}
				while (angle < startAngle) {
					angle += 2.0 * Math.PI;
				}
	
				// Check if within the range of the open/close angle
				var betweenAngles = (angle >= startAngle && angle <= endAngle);
				var withinRadius = (distance >= vm.innerRadius && distance <= vm.outerRadius);
	
				return (betweenAngles && withinRadius);
			}
			return false;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var halfAngle = (vm.startAngle + vm.endAngle) / 2;
			var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
			return {
				x: vm.x + Math.cos(halfAngle) * halfRadius,
				y: vm.y + Math.sin(halfAngle) * halfRadius
			};
		},
	
		getArea: function() {
			var vm = this._view;
			return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			var centreAngle = vm.startAngle + ((vm.endAngle - vm.startAngle) / 2);
			var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
	
			return {
				x: vm.x + (Math.cos(centreAngle) * rangeFromCentre),
				y: vm.y + (Math.sin(centreAngle) * rangeFromCentre)
			};
		},
	
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var sA = vm.startAngle;
			var eA = vm.endAngle;
	
			ctx.beginPath();
	
			ctx.arc(vm.x, vm.y, vm.outerRadius, sA, eA);
			ctx.arc(vm.x, vm.y, vm.innerRadius, eA, sA, true);
	
			ctx.closePath();
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = vm.borderWidth;
	
			ctx.fillStyle = vm.backgroundColor;
	
			ctx.fill();
			ctx.lineJoin = 'bevel';
	
			if (vm.borderWidth) {
				ctx.stroke();
			}
		}
	});


/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	var globalDefaults = defaults.global;
	
	defaults._set('global', {
		elements: {
			line: {
				tension: 0.4,
				backgroundColor: globalDefaults.defaultColor,
				borderWidth: 3,
				borderColor: globalDefaults.defaultColor,
				borderCapStyle: 'butt',
				borderDash: [],
				borderDashOffset: 0.0,
				borderJoinStyle: 'miter',
				capBezierPoints: true,
				fill: true, // do we fill in the area between the line and its base axis
			}
		}
	});
	
	module.exports = Element.extend({
		draw: function() {
			var me = this;
			var vm = me._view;
			var ctx = me._chart.ctx;
			var spanGaps = vm.spanGaps;
			var points = me._children.slice(); // clone array
			var globalOptionLineElements = globalDefaults.elements.line;
			var lastDrawnIndex = -1;
			var index, current, previous, currentVM;
	
			// If we are looping, adding the first point again
			if (me._loop && points.length) {
				points.push(points[0]);
			}
	
			ctx.save();
	
			// Stroke Line Options
			ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;
	
			// IE 9 and 10 do not support line dash
			if (ctx.setLineDash) {
				ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
			}
	
			ctx.lineDashOffset = vm.borderDashOffset || globalOptionLineElements.borderDashOffset;
			ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
			ctx.lineWidth = vm.borderWidth || globalOptionLineElements.borderWidth;
			ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;
	
			// Stroke Line
			ctx.beginPath();
			lastDrawnIndex = -1;
	
			for (index = 0; index < points.length; ++index) {
				current = points[index];
				previous = helpers.previousItem(points, index);
				currentVM = current._view;
	
				// First point moves to it's starting position no matter what
				if (index === 0) {
					if (!currentVM.skip) {
						ctx.moveTo(currentVM.x, currentVM.y);
						lastDrawnIndex = index;
					}
				} else {
					previous = lastDrawnIndex === -1 ? previous : points[lastDrawnIndex];
	
					if (!currentVM.skip) {
						if ((lastDrawnIndex !== (index - 1) && !spanGaps) || lastDrawnIndex === -1) {
							// There was a gap and this is the first point after the gap
							ctx.moveTo(currentVM.x, currentVM.y);
						} else {
							// Line to next point
							helpers.canvas.lineTo(ctx, previous._view, current._view);
						}
						lastDrawnIndex = index;
					}
				}
			}
	
			ctx.stroke();
			ctx.restore();
		}
	});


/***/ },
/* 1839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	var defaultColor = defaults.global.defaultColor;
	
	defaults._set('global', {
		elements: {
			point: {
				radius: 3,
				pointStyle: 'circle',
				backgroundColor: defaultColor,
				borderColor: defaultColor,
				borderWidth: 1,
				// Hover
				hitRadius: 1,
				hoverRadius: 4,
				hoverBorderWidth: 1
			}
		}
	});
	
	function xRange(mouseX) {
		var vm = this._view;
		return vm ? (Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}
	
	function yRange(mouseY) {
		var vm = this._view;
		return vm ? (Math.pow(mouseY - vm.y, 2) < Math.pow(vm.radius + vm.hitRadius, 2)) : false;
	}
	
	module.exports = Element.extend({
		inRange: function(mouseX, mouseY) {
			var vm = this._view;
			return vm ? ((Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2)) < Math.pow(vm.hitRadius + vm.radius, 2)) : false;
		},
	
		inLabelRange: xRange,
		inXRange: xRange,
		inYRange: yRange,
	
		getCenterPoint: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		},
	
		getArea: function() {
			return Math.PI * Math.pow(this._view.radius, 2);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y,
				padding: vm.radius + vm.borderWidth
			};
		},
	
		draw: function(chartArea) {
			var vm = this._view;
			var model = this._model;
			var ctx = this._chart.ctx;
			var pointStyle = vm.pointStyle;
			var radius = vm.radius;
			var x = vm.x;
			var y = vm.y;
			var color = helpers.color;
			var errMargin = 1.01; // 1.01 is margin for Accumulated error. (Especially Edge, IE.)
			var ratio = 0;
	
			if (vm.skip) {
				return;
			}
	
			ctx.strokeStyle = vm.borderColor || defaultColor;
			ctx.lineWidth = helpers.valueOrDefault(vm.borderWidth, defaults.global.elements.point.borderWidth);
			ctx.fillStyle = vm.backgroundColor || defaultColor;
	
			// Cliping for Points.
			// going out from inner charArea?
			if ((chartArea !== undefined) && ((model.x < chartArea.left) || (chartArea.right * errMargin < model.x) || (model.y < chartArea.top) || (chartArea.bottom * errMargin < model.y))) {
				// Point fade out
				if (model.x < chartArea.left) {
					ratio = (x - model.x) / (chartArea.left - model.x);
				} else if (chartArea.right * errMargin < model.x) {
					ratio = (model.x - x) / (model.x - chartArea.right);
				} else if (model.y < chartArea.top) {
					ratio = (y - model.y) / (chartArea.top - model.y);
				} else if (chartArea.bottom * errMargin < model.y) {
					ratio = (model.y - y) / (model.y - chartArea.bottom);
				}
				ratio = Math.round(ratio * 100) / 100;
				ctx.strokeStyle = color(ctx.strokeStyle).alpha(ratio).rgbString();
				ctx.fillStyle = color(ctx.fillStyle).alpha(ratio).rgbString();
			}
	
			helpers.canvas.drawPoint(ctx, pointStyle, radius, x, y);
		}
	});


/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	
	defaults._set('global', {
		elements: {
			rectangle: {
				backgroundColor: defaults.global.defaultColor,
				borderColor: defaults.global.defaultColor,
				borderSkipped: 'bottom',
				borderWidth: 0
			}
		}
	});
	
	function isVertical(bar) {
		return bar._view.width !== undefined;
	}
	
	/**
	 * Helper function to get the bounds of the bar regardless of the orientation
	 * @param bar {Chart.Element.Rectangle} the bar
	 * @return {Bounds} bounds of the bar
	 * @private
	 */
	function getBarBounds(bar) {
		var vm = bar._view;
		var x1, x2, y1, y2;
	
		if (isVertical(bar)) {
			// vertical
			var halfWidth = vm.width / 2;
			x1 = vm.x - halfWidth;
			x2 = vm.x + halfWidth;
			y1 = Math.min(vm.y, vm.base);
			y2 = Math.max(vm.y, vm.base);
		} else {
			// horizontal bar
			var halfHeight = vm.height / 2;
			x1 = Math.min(vm.x, vm.base);
			x2 = Math.max(vm.x, vm.base);
			y1 = vm.y - halfHeight;
			y2 = vm.y + halfHeight;
		}
	
		return {
			left: x1,
			top: y1,
			right: x2,
			bottom: y2
		};
	}
	
	module.exports = Element.extend({
		draw: function() {
			var ctx = this._chart.ctx;
			var vm = this._view;
			var left, right, top, bottom, signX, signY, borderSkipped;
			var borderWidth = vm.borderWidth;
	
			if (!vm.horizontal) {
				// bar
				left = vm.x - vm.width / 2;
				right = vm.x + vm.width / 2;
				top = vm.y;
				bottom = vm.base;
				signX = 1;
				signY = bottom > top ? 1 : -1;
				borderSkipped = vm.borderSkipped || 'bottom';
			} else {
				// horizontal bar
				left = vm.base;
				right = vm.x;
				top = vm.y - vm.height / 2;
				bottom = vm.y + vm.height / 2;
				signX = right > left ? 1 : -1;
				signY = 1;
				borderSkipped = vm.borderSkipped || 'left';
			}
	
			// Canvas doesn't allow us to stroke inside the width so we can
			// adjust the sizes to fit if we're setting a stroke on the line
			if (borderWidth) {
				// borderWidth shold be less than bar width and bar height.
				var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
				borderWidth = borderWidth > barSize ? barSize : borderWidth;
				var halfStroke = borderWidth / 2;
				// Adjust borderWidth when bar top position is near vm.base(zero).
				var borderLeft = left + (borderSkipped !== 'left' ? halfStroke * signX : 0);
				var borderRight = right + (borderSkipped !== 'right' ? -halfStroke * signX : 0);
				var borderTop = top + (borderSkipped !== 'top' ? halfStroke * signY : 0);
				var borderBottom = bottom + (borderSkipped !== 'bottom' ? -halfStroke * signY : 0);
				// not become a vertical line?
				if (borderLeft !== borderRight) {
					top = borderTop;
					bottom = borderBottom;
				}
				// not become a horizontal line?
				if (borderTop !== borderBottom) {
					left = borderLeft;
					right = borderRight;
				}
			}
	
			ctx.beginPath();
			ctx.fillStyle = vm.backgroundColor;
			ctx.strokeStyle = vm.borderColor;
			ctx.lineWidth = borderWidth;
	
			// Corner points, from bottom-left to bottom-right clockwise
			// | 1 2 |
			// | 0 3 |
			var corners = [
				[left, bottom],
				[left, top],
				[right, top],
				[right, bottom]
			];
	
			// Find first (starting) corner with fallback to 'bottom'
			var borders = ['bottom', 'left', 'top', 'right'];
			var startCorner = borders.indexOf(borderSkipped, 0);
			if (startCorner === -1) {
				startCorner = 0;
			}
	
			function cornerAt(index) {
				return corners[(startCorner + index) % 4];
			}
	
			// Draw rectangle from 'startCorner'
			var corner = cornerAt(0);
			ctx.moveTo(corner[0], corner[1]);
	
			for (var i = 1; i < 4; i++) {
				corner = cornerAt(i);
				ctx.lineTo(corner[0], corner[1]);
			}
	
			ctx.fill();
			if (borderWidth) {
				ctx.stroke();
			}
		},
	
		height: function() {
			var vm = this._view;
			return vm.base - vm.y;
		},
	
		inRange: function(mouseX, mouseY) {
			var inRange = false;
	
			if (this._view) {
				var bounds = getBarBounds(this);
				inRange = mouseX >= bounds.left && mouseX <= bounds.right && mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inLabelRange: function(mouseX, mouseY) {
			var me = this;
			if (!me._view) {
				return false;
			}
	
			var inRange = false;
			var bounds = getBarBounds(me);
	
			if (isVertical(me)) {
				inRange = mouseX >= bounds.left && mouseX <= bounds.right;
			} else {
				inRange = mouseY >= bounds.top && mouseY <= bounds.bottom;
			}
	
			return inRange;
		},
	
		inXRange: function(mouseX) {
			var bounds = getBarBounds(this);
			return mouseX >= bounds.left && mouseX <= bounds.right;
		},
	
		inYRange: function(mouseY) {
			var bounds = getBarBounds(this);
			return mouseY >= bounds.top && mouseY <= bounds.bottom;
		},
	
		getCenterPoint: function() {
			var vm = this._view;
			var x, y;
			if (isVertical(this)) {
				x = vm.x;
				y = (vm.y + vm.base) / 2;
			} else {
				x = (vm.x + vm.base) / 2;
				y = vm.y;
			}
	
			return {x: x, y: y};
		},
	
		getArea: function() {
			var vm = this._view;
			return vm.width * Math.abs(vm.y - vm.base);
		},
	
		tooltipPosition: function() {
			var vm = this._view;
			return {
				x: vm.x,
				y: vm.y
			};
		}
	});


/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(287);
	
	/**
	 * @namespace Chart.helpers.canvas
	 */
	var exports = module.exports = {
		/**
		 * Clears the entire canvas associated to the given `chart`.
		 * @param {Chart} chart - The chart for which to clear the canvas.
		 */
		clear: function(chart) {
			chart.ctx.clearRect(0, 0, chart.width, chart.height);
		},
	
		/**
		 * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
		 * given size (width, height) and the same `radius` for all corners.
		 * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
		 * @param {Number} x - The x axis of the coordinate for the rectangle starting point.
		 * @param {Number} y - The y axis of the coordinate for the rectangle starting point.
		 * @param {Number} width - The rectangle's width.
		 * @param {Number} height - The rectangle's height.
		 * @param {Number} radius - The rounded amount (in pixels) for the four corners.
		 * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
		 */
		roundedRect: function(ctx, x, y, width, height, radius) {
			if (radius) {
				var rx = Math.min(radius, width / 2);
				var ry = Math.min(radius, height / 2);
	
				ctx.moveTo(x + rx, y);
				ctx.lineTo(x + width - rx, y);
				ctx.quadraticCurveTo(x + width, y, x + width, y + ry);
				ctx.lineTo(x + width, y + height - ry);
				ctx.quadraticCurveTo(x + width, y + height, x + width - rx, y + height);
				ctx.lineTo(x + rx, y + height);
				ctx.quadraticCurveTo(x, y + height, x, y + height - ry);
				ctx.lineTo(x, y + ry);
				ctx.quadraticCurveTo(x, y, x + rx, y);
			} else {
				ctx.rect(x, y, width, height);
			}
		},
	
		drawPoint: function(ctx, style, radius, x, y) {
			var type, edgeLength, xOffset, yOffset, height, size;
	
			if (style && typeof style === 'object') {
				type = style.toString();
				if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
					ctx.drawImage(style, x - style.width / 2, y - style.height / 2, style.width, style.height);
					return;
				}
			}
	
			if (isNaN(radius) || radius <= 0) {
				return;
			}
	
			switch (style) {
			// Default includes circle
			default:
				ctx.beginPath();
				ctx.arc(x, y, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'triangle':
				ctx.beginPath();
				edgeLength = 3 * radius / Math.sqrt(3);
				height = edgeLength * Math.sqrt(3) / 2;
				ctx.moveTo(x - edgeLength / 2, y + height / 3);
				ctx.lineTo(x + edgeLength / 2, y + height / 3);
				ctx.lineTo(x, y - 2 * height / 3);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rect':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.fillRect(x - size, y - size, 2 * size, 2 * size);
				ctx.strokeRect(x - size, y - size, 2 * size, 2 * size);
				break;
			case 'rectRounded':
				var offset = radius / Math.SQRT2;
				var leftX = x - offset;
				var topY = y - offset;
				var sideSize = Math.SQRT2 * radius;
				ctx.beginPath();
				this.roundedRect(ctx, leftX, topY, sideSize, sideSize, radius / 2);
				ctx.closePath();
				ctx.fill();
				break;
			case 'rectRot':
				size = 1 / Math.SQRT2 * radius;
				ctx.beginPath();
				ctx.moveTo(x - size, y);
				ctx.lineTo(x, y + size);
				ctx.lineTo(x + size, y);
				ctx.lineTo(x, y - size);
				ctx.closePath();
				ctx.fill();
				break;
			case 'cross':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'crossRot':
				ctx.beginPath();
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'star':
				ctx.beginPath();
				ctx.moveTo(x, y + radius);
				ctx.lineTo(x, y - radius);
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				xOffset = Math.cos(Math.PI / 4) * radius;
				yOffset = Math.sin(Math.PI / 4) * radius;
				ctx.moveTo(x - xOffset, y - yOffset);
				ctx.lineTo(x + xOffset, y + yOffset);
				ctx.moveTo(x - xOffset, y + yOffset);
				ctx.lineTo(x + xOffset, y - yOffset);
				ctx.closePath();
				break;
			case 'line':
				ctx.beginPath();
				ctx.moveTo(x - radius, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			case 'dash':
				ctx.beginPath();
				ctx.moveTo(x, y);
				ctx.lineTo(x + radius, y);
				ctx.closePath();
				break;
			}
	
			ctx.stroke();
		},
	
		clipArea: function(ctx, area) {
			ctx.save();
			ctx.beginPath();
			ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
			ctx.clip();
		},
	
		unclipArea: function(ctx) {
			ctx.restore();
		},
	
		lineTo: function(ctx, previous, target, flip) {
			if (target.steppedLine) {
				if ((target.steppedLine === 'after' && !flip) || (target.steppedLine !== 'after' && flip)) {
					ctx.lineTo(previous.x, target.y);
				} else {
					ctx.lineTo(target.x, previous.y);
				}
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			if (!target.tension) {
				ctx.lineTo(target.x, target.y);
				return;
			}
	
			ctx.bezierCurveTo(
				flip ? previous.controlPointPreviousX : previous.controlPointNextX,
				flip ? previous.controlPointPreviousY : previous.controlPointNextY,
				flip ? target.controlPointNextX : target.controlPointPreviousX,
				flip ? target.controlPointNextY : target.controlPointPreviousY,
				target.x,
				target.y);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
	 * @namespace Chart.helpers.clear
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.clear = exports.clear;
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
	 * @namespace Chart.helpers.drawRoundedRectangle
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.drawRoundedRectangle = function(ctx) {
		ctx.beginPath();
		exports.roundedRect.apply(exports, arguments);
		ctx.closePath();
	};


/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(287);
	
	/**
	 * Easing functions adapted from Robert Penner's easing equations.
	 * @namespace Chart.helpers.easingEffects
	 * @see http://www.robertpenner.com/easing/
	 */
	var effects = {
		linear: function(t) {
			return t;
		},
	
		easeInQuad: function(t) {
			return t * t;
		},
	
		easeOutQuad: function(t) {
			return -t * (t - 2);
		},
	
		easeInOutQuad: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t;
			}
			return -0.5 * ((--t) * (t - 2) - 1);
		},
	
		easeInCubic: function(t) {
			return t * t * t;
		},
	
		easeOutCubic: function(t) {
			return (t = t - 1) * t * t + 1;
		},
	
		easeInOutCubic: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t + 2);
		},
	
		easeInQuart: function(t) {
			return t * t * t * t;
		},
	
		easeOutQuart: function(t) {
			return -((t = t - 1) * t * t * t - 1);
		},
	
		easeInOutQuart: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t;
			}
			return -0.5 * ((t -= 2) * t * t * t - 2);
		},
	
		easeInQuint: function(t) {
			return t * t * t * t * t;
		},
	
		easeOutQuint: function(t) {
			return (t = t - 1) * t * t * t * t + 1;
		},
	
		easeInOutQuint: function(t) {
			if ((t /= 0.5) < 1) {
				return 0.5 * t * t * t * t * t;
			}
			return 0.5 * ((t -= 2) * t * t * t * t + 2);
		},
	
		easeInSine: function(t) {
			return -Math.cos(t * (Math.PI / 2)) + 1;
		},
	
		easeOutSine: function(t) {
			return Math.sin(t * (Math.PI / 2));
		},
	
		easeInOutSine: function(t) {
			return -0.5 * (Math.cos(Math.PI * t) - 1);
		},
	
		easeInExpo: function(t) {
			return (t === 0) ? 0 : Math.pow(2, 10 * (t - 1));
		},
	
		easeOutExpo: function(t) {
			return (t === 1) ? 1 : -Math.pow(2, -10 * t) + 1;
		},
	
		easeInOutExpo: function(t) {
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if ((t /= 0.5) < 1) {
				return 0.5 * Math.pow(2, 10 * (t - 1));
			}
			return 0.5 * (-Math.pow(2, -10 * --t) + 2);
		},
	
		easeInCirc: function(t) {
			if (t >= 1) {
				return t;
			}
			return -(Math.sqrt(1 - t * t) - 1);
		},
	
		easeOutCirc: function(t) {
			return Math.sqrt(1 - (t = t - 1) * t);
		},
	
		easeInOutCirc: function(t) {
			if ((t /= 0.5) < 1) {
				return -0.5 * (Math.sqrt(1 - t * t) - 1);
			}
			return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
		},
	
		easeInElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
		},
	
		easeOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if (t === 1) {
				return 1;
			}
			if (!p) {
				p = 0.3;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
		},
	
		easeInOutElastic: function(t) {
			var s = 1.70158;
			var p = 0;
			var a = 1;
			if (t === 0) {
				return 0;
			}
			if ((t /= 0.5) === 2) {
				return 1;
			}
			if (!p) {
				p = 0.45;
			}
			if (a < 1) {
				a = 1;
				s = p / 4;
			} else {
				s = p / (2 * Math.PI) * Math.asin(1 / a);
			}
			if (t < 1) {
				return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
			}
			return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
		},
		easeInBack: function(t) {
			var s = 1.70158;
			return t * t * ((s + 1) * t - s);
		},
	
		easeOutBack: function(t) {
			var s = 1.70158;
			return (t = t - 1) * t * ((s + 1) * t + s) + 1;
		},
	
		easeInOutBack: function(t) {
			var s = 1.70158;
			if ((t /= 0.5) < 1) {
				return 0.5 * (t * t * (((s *= (1.525)) + 1) * t - s));
			}
			return 0.5 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2);
		},
	
		easeInBounce: function(t) {
			return 1 - effects.easeOutBounce(1 - t);
		},
	
		easeOutBounce: function(t) {
			if (t < (1 / 2.75)) {
				return 7.5625 * t * t;
			}
			if (t < (2 / 2.75)) {
				return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
			}
			if (t < (2.5 / 2.75)) {
				return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
			}
			return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
		},
	
		easeInOutBounce: function(t) {
			if (t < 0.5) {
				return effects.easeInBounce(t * 2) * 0.5;
			}
			return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
		}
	};
	
	module.exports = {
		effects: effects
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
	 * @function Chart.helpers.easingEffects
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.easingEffects = effects;


/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(287);
	
	/**
	 * @alias Chart.helpers.options
	 * @namespace
	 */
	module.exports = {
		/**
		 * Converts the given line height `value` in pixels for a specific font `size`.
		 * @param {Number|String} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
		 * @param {Number} size - The font size (in pixels) used to resolve relative `value`.
		 * @returns {Number} The effective line height in pixels (size * 1.2 if value is invalid).
		 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
		 * @since 2.7.0
		 */
		toLineHeight: function(value, size) {
			var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
			if (!matches || matches[1] === 'normal') {
				return size * 1.2;
			}
	
			value = +matches[2];
	
			switch (matches[3]) {
			case 'px':
				return value;
			case '%':
				value /= 100;
				break;
			default:
				break;
			}
	
			return size * value;
		},
	
		/**
		 * Converts the given value into a padding object with pre-computed width/height.
		 * @param {Number|Object} value - If a number, set the value to all TRBL component,
		 *  else, if and object, use defined properties and sets undefined ones to 0.
		 * @returns {Object} The padding values (top, right, bottom, left, width, height)
		 * @since 2.7.0
		 */
		toPadding: function(value) {
			var t, r, b, l;
	
			if (helpers.isObject(value)) {
				t = +value.top || 0;
				r = +value.right || 0;
				b = +value.bottom || 0;
				l = +value.left || 0;
			} else {
				t = r = b = l = +value || 0;
			}
	
			return {
				top: t,
				right: r,
				bottom: b,
				left: l,
				height: t + b,
				width: l + r
			};
		},
	
		/**
		 * Evaluates the given `inputs` sequentially and returns the first defined value.
		 * @param {Array[]} inputs - An array of values, falling back to the last value.
		 * @param {Object} [context] - If defined and the current value is a function, the value
		 * is called with `context` as first argument and the result becomes the new input.
		 * @param {Number} [index] - If defined and the current value is an array, the value
		 * at `index` become the new input.
		 * @since 2.7.0
		 */
		resolve: function(inputs, context, index) {
			var i, ilen, value;
	
			for (i = 0, ilen = inputs.length; i < ilen; ++i) {
				value = inputs[i];
				if (value === undefined) {
					continue;
				}
				if (context !== undefined && typeof value === 'function') {
					value = value(context);
				}
				if (index !== undefined && helpers.isArray(value)) {
					value = value[index];
				}
				if (value !== undefined) {
					return value;
				}
			}
		}
	};


/***/ },
/* 1844 */
/***/ function(module, exports) {

	/**
	 * Platform fallback implementation (minimal).
	 * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
	 */
	
	module.exports = {
		acquireContext: function(item) {
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			return item && item.getContext('2d') || null;
		}
	};


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Chart.Platform implementation for targeting a web browser
	 */
	
	'use strict';
	
	var helpers = __webpack_require__(23);
	
	var EXPANDO_KEY = '$chartjs';
	var CSS_PREFIX = 'chartjs-';
	var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
	var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
	var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];
	
	/**
	 * DOM event types -> Chart.js event types.
	 * Note: only events with different types are mapped.
	 * @see https://developer.mozilla.org/en-US/docs/Web/Events
	 */
	var EVENT_TYPES = {
		touchstart: 'mousedown',
		touchmove: 'mousemove',
		touchend: 'mouseup',
		pointerenter: 'mouseenter',
		pointerdown: 'mousedown',
		pointermove: 'mousemove',
		pointerup: 'mouseup',
		pointerleave: 'mouseout',
		pointerout: 'mouseout'
	};
	
	/**
	 * The "used" size is the final value of a dimension property after all calculations have
	 * been performed. This method uses the computed style of `element` but returns undefined
	 * if the computed style is not expressed in pixels. That can happen in some cases where
	 * `element` has a size relative to its parent and this last one is not yet displayed,
	 * for example because of `display: none` on a parent node.
	 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	 * @returns {Number} Size in pixels or undefined if unknown.
	 */
	function readUsedSize(element, property) {
		var value = helpers.getStyle(element, property);
		var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
		return matches ? Number(matches[1]) : undefined;
	}
	
	/**
	 * Initializes the canvas style and render size without modifying the canvas display size,
	 * since responsiveness is handled by the controller.resize() method. The config is used
	 * to determine the aspect ratio to apply in case no explicit height has been specified.
	 */
	function initCanvas(canvas, config) {
		var style = canvas.style;
	
		// NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
		// returns null or '' if no explicit value has been set to the canvas attribute.
		var renderHeight = canvas.getAttribute('height');
		var renderWidth = canvas.getAttribute('width');
	
		// Chart.js modifies some canvas values that we want to restore on destroy
		canvas[EXPANDO_KEY] = {
			initial: {
				height: renderHeight,
				width: renderWidth,
				style: {
					display: style.display,
					height: style.height,
					width: style.width
				}
			}
		};
	
		// Force canvas to display as block to avoid extra space caused by inline
		// elements, which would interfere with the responsive resize process.
		// https://github.com/chartjs/Chart.js/issues/2538
		style.display = style.display || 'block';
	
		if (renderWidth === null || renderWidth === '') {
			var displayWidth = readUsedSize(canvas, 'width');
			if (displayWidth !== undefined) {
				canvas.width = displayWidth;
			}
		}
	
		if (renderHeight === null || renderHeight === '') {
			if (canvas.style.height === '') {
				// If no explicit render height and style height, let's apply the aspect ratio,
				// which one can be specified by the user but also by charts as default option
				// (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
				canvas.height = canvas.width / (config.options.aspectRatio || 2);
			} else {
				var displayHeight = readUsedSize(canvas, 'height');
				if (displayWidth !== undefined) {
					canvas.height = displayHeight;
				}
			}
		}
	
		return canvas;
	}
	
	/**
	 * Detects support for options object argument in addEventListener.
	 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
	 * @private
	 */
	var supportsEventListenerOptions = (function() {
		var supports = false;
		try {
			var options = Object.defineProperty({}, 'passive', {
				get: function() {
					supports = true;
				}
			});
			window.addEventListener('e', null, options);
		} catch (e) {
			// continue regardless of error
		}
		return supports;
	}());
	
	// Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
	// https://github.com/chartjs/Chart.js/issues/4287
	var eventListenerOptions = supportsEventListenerOptions ? {passive: true} : false;
	
	function addEventListener(node, type, listener) {
		node.addEventListener(type, listener, eventListenerOptions);
	}
	
	function removeEventListener(node, type, listener) {
		node.removeEventListener(type, listener, eventListenerOptions);
	}
	
	function createEvent(type, chart, x, y, nativeEvent) {
		return {
			type: type,
			chart: chart,
			native: nativeEvent || null,
			x: x !== undefined ? x : null,
			y: y !== undefined ? y : null,
		};
	}
	
	function fromNativeEvent(event, chart) {
		var type = EVENT_TYPES[event.type] || event.type;
		var pos = helpers.getRelativePosition(event, chart);
		return createEvent(type, chart, pos.x, pos.y, event);
	}
	
	function throttled(fn, thisArg) {
		var ticking = false;
		var args = [];
	
		return function() {
			args = Array.prototype.slice.call(arguments);
			thisArg = thisArg || this;
	
			if (!ticking) {
				ticking = true;
				helpers.requestAnimFrame.call(window, function() {
					ticking = false;
					fn.apply(thisArg, args);
				});
			}
		};
	}
	
	// Implementation based on https://github.com/marcj/css-element-queries
	function createResizer(handler) {
		var resizer = document.createElement('div');
		var cls = CSS_PREFIX + 'size-monitor';
		var maxSize = 1000000;
		var style =
			'position:absolute;' +
			'left:0;' +
			'top:0;' +
			'right:0;' +
			'bottom:0;' +
			'overflow:hidden;' +
			'pointer-events:none;' +
			'visibility:hidden;' +
			'z-index:-1;';
	
		resizer.style.cssText = style;
		resizer.className = cls;
		resizer.innerHTML =
			'<div class="' + cls + '-expand" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:' + maxSize + 'px;' +
					'height:' + maxSize + 'px;' +
					'left:0;' +
					'top:0">' +
				'</div>' +
			'</div>' +
			'<div class="' + cls + '-shrink" style="' + style + '">' +
				'<div style="' +
					'position:absolute;' +
					'width:200%;' +
					'height:200%;' +
					'left:0; ' +
					'top:0">' +
				'</div>' +
			'</div>';
	
		var expand = resizer.childNodes[0];
		var shrink = resizer.childNodes[1];
	
		resizer._reset = function() {
			expand.scrollLeft = maxSize;
			expand.scrollTop = maxSize;
			shrink.scrollLeft = maxSize;
			shrink.scrollTop = maxSize;
		};
		var onScroll = function() {
			resizer._reset();
			handler();
		};
	
		addEventListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
		addEventListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
	
		return resizer;
	}
	
	// https://davidwalsh.name/detect-node-insertion
	function watchForRender(node, handler) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
		var proxy = expando.renderProxy = function(e) {
			if (e.animationName === CSS_RENDER_ANIMATION) {
				handler();
			}
		};
	
		helpers.each(ANIMATION_START_EVENTS, function(type) {
			addEventListener(node, type, proxy);
		});
	
		// #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
		// is removed then added back immediately (same animation frame?). Accessing the
		// `offsetParent` property will force a reflow and re-evaluate the CSS animation.
		// https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
		// https://github.com/chartjs/Chart.js/issues/4737
		expando.reflow = !!node.offsetParent;
	
		node.classList.add(CSS_RENDER_MONITOR);
	}
	
	function unwatchForRender(node) {
		var expando = node[EXPANDO_KEY] || {};
		var proxy = expando.renderProxy;
	
		if (proxy) {
			helpers.each(ANIMATION_START_EVENTS, function(type) {
				removeEventListener(node, type, proxy);
			});
	
			delete expando.renderProxy;
		}
	
		node.classList.remove(CSS_RENDER_MONITOR);
	}
	
	function addResizeListener(node, listener, chart) {
		var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
	
		// Let's keep track of this added resizer and thus avoid DOM query when removing it.
		var resizer = expando.resizer = createResizer(throttled(function() {
			if (expando.resizer) {
				return listener(createEvent('resize', chart));
			}
		}));
	
		// The resizer needs to be attached to the node parent, so we first need to be
		// sure that `node` is attached to the DOM before injecting the resizer element.
		watchForRender(node, function() {
			if (expando.resizer) {
				var container = node.parentNode;
				if (container && container !== resizer.parentNode) {
					container.insertBefore(resizer, container.firstChild);
				}
	
				// The container size might have changed, let's reset the resizer state.
				resizer._reset();
			}
		});
	}
	
	function removeResizeListener(node) {
		var expando = node[EXPANDO_KEY] || {};
		var resizer = expando.resizer;
	
		delete expando.resizer;
		unwatchForRender(node);
	
		if (resizer && resizer.parentNode) {
			resizer.parentNode.removeChild(resizer);
		}
	}
	
	function injectCSS(platform, css) {
		// http://stackoverflow.com/q/3922139
		var style = platform._style || document.createElement('style');
		if (!platform._style) {
			platform._style = style;
			css = '/* Chart.js */\n' + css;
			style.setAttribute('type', 'text/css');
			document.getElementsByTagName('head')[0].appendChild(style);
		}
	
		style.appendChild(document.createTextNode(css));
	}
	
	module.exports = {
		/**
		 * This property holds whether this platform is enabled for the current environment.
		 * Currently used by platform.js to select the proper implementation.
		 * @private
		 */
		_enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
	
		initialize: function() {
			var keyframes = 'from{opacity:0.99}to{opacity:1}';
	
			injectCSS(this,
				// DOM rendering detection
				// https://davidwalsh.name/detect-node-insertion
				'@-webkit-keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'@keyframes ' + CSS_RENDER_ANIMATION + '{' + keyframes + '}' +
				'.' + CSS_RENDER_MONITOR + '{' +
					'-webkit-animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
					'animation:' + CSS_RENDER_ANIMATION + ' 0.001s;' +
				'}'
			);
		},
	
		acquireContext: function(item, config) {
			if (typeof item === 'string') {
				item = document.getElementById(item);
			} else if (item.length) {
				// Support for array based queries (such as jQuery)
				item = item[0];
			}
	
			if (item && item.canvas) {
				// Support for any object associated to a canvas (including a context2d)
				item = item.canvas;
			}
	
			// To prevent canvas fingerprinting, some add-ons undefine the getContext
			// method, for example: https://github.com/kkapsner/CanvasBlocker
			// https://github.com/chartjs/Chart.js/issues/2807
			var context = item && item.getContext && item.getContext('2d');
	
			// `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
			// inside an iframe or when running in a protected environment. We could guess the
			// types from their toString() value but let's keep things flexible and assume it's
			// a sufficient condition if the item has a context2D which has item as `canvas`.
			// https://github.com/chartjs/Chart.js/issues/3887
			// https://github.com/chartjs/Chart.js/issues/4102
			// https://github.com/chartjs/Chart.js/issues/4152
			if (context && context.canvas === item) {
				initCanvas(item, config);
				return context;
			}
	
			return null;
		},
	
		releaseContext: function(context) {
			var canvas = context.canvas;
			if (!canvas[EXPANDO_KEY]) {
				return;
			}
	
			var initial = canvas[EXPANDO_KEY].initial;
			['height', 'width'].forEach(function(prop) {
				var value = initial[prop];
				if (helpers.isNullOrUndef(value)) {
					canvas.removeAttribute(prop);
				} else {
					canvas.setAttribute(prop, value);
				}
			});
	
			helpers.each(initial.style || {}, function(value, key) {
				canvas.style[key] = value;
			});
	
			// The canvas render size might have been changed (and thus the state stack discarded),
			// we can't use save() and restore() to restore the initial state. So make sure that at
			// least the canvas context is reset to the default state by setting the canvas width.
			// https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
			canvas.width = canvas.width;
	
			delete canvas[EXPANDO_KEY];
		},
	
		addEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				addResizeListener(canvas, listener, chart);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
			var proxies = expando.proxies || (expando.proxies = {});
			var proxy = proxies[chart.id + '_' + type] = function(event) {
				listener(fromNativeEvent(event, chart));
			};
	
			addEventListener(canvas, type, proxy);
		},
	
		removeEventListener: function(chart, type, listener) {
			var canvas = chart.canvas;
			if (type === 'resize') {
				// Note: the resize event is not supported on all browsers.
				removeResizeListener(canvas, listener);
				return;
			}
	
			var expando = listener[EXPANDO_KEY] || {};
			var proxies = expando.proxies || {};
			var proxy = proxies[chart.id + '_' + type];
			if (!proxy) {
				return;
			}
	
			removeEventListener(canvas, type, proxy);
		}
	};
	
	// DEPRECATIONS
	
	/**
	 * Provided for backward compatibility, use EventTarget.addEventListener instead.
	 * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
	 * @function Chart.helpers.addEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.addEvent = addEventListener;
	
	/**
	 * Provided for backward compatibility, use EventTarget.removeEventListener instead.
	 * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
	 * @function Chart.helpers.removeEvent
	 * @deprecated since version 2.7.0
	 * @todo remove at version 3
	 * @private
	 */
	helpers.removeEvent = removeEventListener;


/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Plugin based on discussion from the following Chart.js issues:
	 * @see https://github.com/chartjs/Chart.js/issues/2380#issuecomment-279961569
	 * @see https://github.com/chartjs/Chart.js/issues/2440#issuecomment-256461897
	 */
	
	'use strict';
	
	var defaults = __webpack_require__(34);
	var elements = __webpack_require__(121);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		plugins: {
			filler: {
				propagate: true
			}
		}
	});
	
	module.exports = function() {
	
		var mappers = {
			dataset: function(source) {
				var index = source.fill;
				var chart = source.chart;
				var meta = chart.getDatasetMeta(index);
				var visible = meta && chart.isDatasetVisible(index);
				var points = (visible && meta.dataset._children) || [];
				var length = points.length || 0;
	
				return !length ? null : function(point, i) {
					return (i < length && points[i]._view) || null;
				};
			},
	
			boundary: function(source) {
				var boundary = source.boundary;
				var x = boundary ? boundary.x : null;
				var y = boundary ? boundary.y : null;
	
				return function(point) {
					return {
						x: x === null ? point.x : x,
						y: y === null ? point.y : y,
					};
				};
			}
		};
	
		// @todo if (fill[0] === '#')
		function decodeFill(el, index, count) {
			var model = el._model || {};
			var fill = model.fill;
			var target;
	
			if (fill === undefined) {
				fill = !!model.backgroundColor;
			}
	
			if (fill === false || fill === null) {
				return false;
			}
	
			if (fill === true) {
				return 'origin';
			}
	
			target = parseFloat(fill, 10);
			if (isFinite(target) && Math.floor(target) === target) {
				if (fill[0] === '-' || fill[0] === '+') {
					target = index + target;
				}
	
				if (target === index || target < 0 || target >= count) {
					return false;
				}
	
				return target;
			}
	
			switch (fill) {
			// compatibility
			case 'bottom':
				return 'start';
			case 'top':
				return 'end';
			case 'zero':
				return 'origin';
			// supported boundaries
			case 'origin':
			case 'start':
			case 'end':
				return fill;
			// invalid fill values
			default:
				return false;
			}
		}
	
		function computeBoundary(source) {
			var model = source.el._model || {};
			var scale = source.el._scale || {};
			var fill = source.fill;
			var target = null;
			var horizontal;
	
			if (isFinite(fill)) {
				return null;
			}
	
			// Backward compatibility: until v3, we still need to support boundary values set on
			// the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
			// controllers might still use it (e.g. the Smith chart).
	
			if (fill === 'start') {
				target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
			} else if (fill === 'end') {
				target = model.scaleTop === undefined ? scale.top : model.scaleTop;
			} else if (model.scaleZero !== undefined) {
				target = model.scaleZero;
			} else if (scale.getBasePosition) {
				target = scale.getBasePosition();
			} else if (scale.getBasePixel) {
				target = scale.getBasePixel();
			}
	
			if (target !== undefined && target !== null) {
				if (target.x !== undefined && target.y !== undefined) {
					return target;
				}
	
				if (typeof target === 'number' && isFinite(target)) {
					horizontal = scale.isHorizontal();
					return {
						x: horizontal ? target : null,
						y: horizontal ? null : target
					};
				}
			}
	
			return null;
		}
	
		function resolveTarget(sources, index, propagate) {
			var source = sources[index];
			var fill = source.fill;
			var visited = [index];
			var target;
	
			if (!propagate) {
				return fill;
			}
	
			while (fill !== false && visited.indexOf(fill) === -1) {
				if (!isFinite(fill)) {
					return fill;
				}
	
				target = sources[fill];
				if (!target) {
					return false;
				}
	
				if (target.visible) {
					return fill;
				}
	
				visited.push(fill);
				fill = target.fill;
			}
	
			return false;
		}
	
		function createMapper(source) {
			var fill = source.fill;
			var type = 'dataset';
	
			if (fill === false) {
				return null;
			}
	
			if (!isFinite(fill)) {
				type = 'boundary';
			}
	
			return mappers[type](source);
		}
	
		function isDrawable(point) {
			return point && !point.skip;
		}
	
		function drawArea(ctx, curve0, curve1, len0, len1) {
			var i;
	
			if (!len0 || !len1) {
				return;
			}
	
			// building first area curve (normal)
			ctx.moveTo(curve0[0].x, curve0[0].y);
			for (i = 1; i < len0; ++i) {
				helpers.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
			}
	
			// joining the two area curves
			ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);
	
			// building opposite area curve (reverse)
			for (i = len1 - 1; i > 0; --i) {
				helpers.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
			}
		}
	
		function doFill(ctx, points, mapper, view, color, loop) {
			var count = points.length;
			var span = view.spanGaps;
			var curve0 = [];
			var curve1 = [];
			var len0 = 0;
			var len1 = 0;
			var i, ilen, index, p0, p1, d0, d1;
	
			ctx.beginPath();
	
			for (i = 0, ilen = (count + !!loop); i < ilen; ++i) {
				index = i % count;
				p0 = points[index]._view;
				p1 = mapper(p0, index, view);
				d0 = isDrawable(p0);
				d1 = isDrawable(p1);
	
				if (d0 && d1) {
					len0 = curve0.push(p0);
					len1 = curve1.push(p1);
				} else if (len0 && len1) {
					if (!span) {
						drawArea(ctx, curve0, curve1, len0, len1);
						len0 = len1 = 0;
						curve0 = [];
						curve1 = [];
					} else {
						if (d0) {
							curve0.push(p0);
						}
						if (d1) {
							curve1.push(p1);
						}
					}
				}
			}
	
			drawArea(ctx, curve0, curve1, len0, len1);
	
			ctx.closePath();
			ctx.fillStyle = color;
			ctx.fill();
		}
	
		return {
			id: 'filler',
	
			afterDatasetsUpdate: function(chart, options) {
				var count = (chart.data.datasets || []).length;
				var propagate = options.propagate;
				var sources = [];
				var meta, i, el, source;
	
				for (i = 0; i < count; ++i) {
					meta = chart.getDatasetMeta(i);
					el = meta.dataset;
					source = null;
	
					if (el && el._model && el instanceof elements.Line) {
						source = {
							visible: chart.isDatasetVisible(i),
							fill: decodeFill(el, i, count),
							chart: chart,
							el: el
						};
					}
	
					meta.$filler = source;
					sources.push(source);
				}
	
				for (i = 0; i < count; ++i) {
					source = sources[i];
					if (!source) {
						continue;
					}
	
					source.fill = resolveTarget(sources, i, propagate);
					source.boundary = computeBoundary(source);
					source.mapper = createMapper(source);
				}
			},
	
			beforeDatasetDraw: function(chart, args) {
				var meta = args.meta.$filler;
				if (!meta) {
					return;
				}
	
				var ctx = chart.ctx;
				var el = meta.el;
				var view = el._view;
				var points = el._children || [];
				var mapper = meta.mapper;
				var color = view.backgroundColor || defaults.global.defaultColor;
	
				if (mapper && color && points.length) {
					helpers.canvas.clipArea(ctx, chart.chartArea);
					doFill(ctx, points, mapper, view, color, el._loop);
					helpers.canvas.unclipArea(ctx);
				}
			}
		};
	};


/***/ },
/* 1847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		legend: {
			display: true,
			position: 'top',
			fullWidth: true,
			reverse: false,
			weight: 1000,
	
			// a callback that will handle
			onClick: function(e, legendItem) {
				var index = legendItem.datasetIndex;
				var ci = this.chart;
				var meta = ci.getDatasetMeta(index);
	
				// See controller.isDatasetVisible comment
				meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;
	
				// We hid a dataset ... rerender the chart
				ci.update();
			},
	
			onHover: null,
	
			labels: {
				boxWidth: 40,
				padding: 10,
				// Generates labels shown in the legend
				// Valid properties to return:
				// text : text to display
				// fillStyle : fill of coloured box
				// strokeStyle: stroke of coloured box
				// hidden : if this legend item refers to a hidden item
				// lineCap : cap style for line
				// lineDash
				// lineDashOffset :
				// lineJoin :
				// lineWidth :
				generateLabels: function(chart) {
					var data = chart.data;
					return helpers.isArray(data.datasets) ? data.datasets.map(function(dataset, i) {
						return {
							text: dataset.label,
							fillStyle: (!helpers.isArray(dataset.backgroundColor) ? dataset.backgroundColor : dataset.backgroundColor[0]),
							hidden: !chart.isDatasetVisible(i),
							lineCap: dataset.borderCapStyle,
							lineDash: dataset.borderDash,
							lineDashOffset: dataset.borderDashOffset,
							lineJoin: dataset.borderJoinStyle,
							lineWidth: dataset.borderWidth,
							strokeStyle: dataset.borderColor,
							pointStyle: dataset.pointStyle,
	
							// Below is extra data used for toggling the datasets
							datasetIndex: i
						};
					}, this) : [];
				}
			}
		},
	
		legendCallback: function(chart) {
			var text = [];
			text.push('<ul class="' + chart.id + '-legend">');
			for (var i = 0; i < chart.data.datasets.length; i++) {
				text.push('<li><span style="background-color:' + chart.data.datasets[i].backgroundColor + '"></span>');
				if (chart.data.datasets[i].label) {
					text.push(chart.data.datasets[i].label);
				}
				text.push('</li>');
			}
			text.push('</ul>');
			return text.join('');
		}
	});
	
	module.exports = function(Chart) {
	
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		/**
		 * Helper function to get the box width based on the usePointStyle option
		 * @param labelopts {Object} the label options on the legend
		 * @param fontSize {Number} the label font size
		 * @return {Number} width of the color box area
		 */
		function getBoxWidth(labelOpts, fontSize) {
			return labelOpts.usePointStyle ?
				fontSize * Math.SQRT2 :
				labelOpts.boxWidth;
		}
	
		Chart.Legend = Element.extend({
	
			initialize: function(config) {
				helpers.extend(this, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				this.legendHitBoxes = [];
	
				// Are we in doughnut mode which has a different data type
				this.doughnutMode = false;
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
			// Any function defined here is inherited by all legend types.
			// Any function can be extended by the legend type
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: function() {
				var me = this;
				var labelOpts = me.options.labels || {};
				var legendItems = helpers.callback(labelOpts.generateLabels, [me.chart], me) || [];
	
				if (labelOpts.filter) {
					legendItems = legendItems.filter(function(item) {
						return labelOpts.filter(item, me.chart.data);
					});
				}
	
				if (me.options.reverse) {
					legendItems.reverse();
				}
	
				me.legendItems = legendItems;
			},
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var display = opts.display;
	
				var ctx = me.ctx;
	
				var globalDefault = defaults.global;
				var valueOrDefault = helpers.valueOrDefault;
				var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
				var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
				var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
				var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
	
				// Reset hit boxes
				var hitboxes = me.legendHitBoxes = [];
	
				var minSize = me.minSize;
				var isHorizontal = me.isHorizontal();
	
				if (isHorizontal) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = display ? 10 : 0;
				} else {
					minSize.width = display ? 10 : 0;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				// Increase sizes here
				if (display) {
					ctx.font = labelFont;
	
					if (isHorizontal) {
						// Labels
	
						// Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
						var lineWidths = me.lineWidths = [0];
						var totalHeight = me.legendItems.length ? fontSize + (labelOpts.padding) : 0;
	
						ctx.textAlign = 'left';
						ctx.textBaseline = 'top';
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var width = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							if (lineWidths[lineWidths.length - 1] + width + labelOpts.padding >= me.width) {
								totalHeight += fontSize + (labelOpts.padding);
								lineWidths[lineWidths.length] = me.left;
							}
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: width,
								height: fontSize
							};
	
							lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
						});
	
						minSize.height += totalHeight;
	
					} else {
						var vPadding = labelOpts.padding;
						var columnWidths = me.columnWidths = [];
						var totalWidth = labelOpts.padding;
						var currentColWidth = 0;
						var currentColHeight = 0;
						var itemHeight = fontSize + vPadding;
	
						helpers.each(me.legendItems, function(legendItem, i) {
							var boxWidth = getBoxWidth(labelOpts, fontSize);
							var itemWidth = boxWidth + (fontSize / 2) + ctx.measureText(legendItem.text).width;
	
							// If too tall, go to new column
							if (currentColHeight + itemHeight > minSize.height) {
								totalWidth += currentColWidth + labelOpts.padding;
								columnWidths.push(currentColWidth); // previous column width
	
								currentColWidth = 0;
								currentColHeight = 0;
							}
	
							// Get max width
							currentColWidth = Math.max(currentColWidth, itemWidth);
							currentColHeight += itemHeight;
	
							// Store the hitbox width and height here. Final position will be updated in `draw`
							hitboxes[i] = {
								left: 0,
								top: 0,
								width: itemWidth,
								height: fontSize
							};
						});
	
						totalWidth += currentColWidth;
						columnWidths.push(currentColWidth);
						minSize.width += totalWidth;
					}
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				return this.options.position === 'top' || this.options.position === 'bottom';
			},
	
			// Actually draw the legend on the canvas
			draw: function() {
				var me = this;
				var opts = me.options;
				var labelOpts = opts.labels;
				var globalDefault = defaults.global;
				var lineDefault = globalDefault.elements.line;
				var legendWidth = me.width;
				var lineWidths = me.lineWidths;
	
				if (opts.display) {
					var ctx = me.ctx;
					var valueOrDefault = helpers.valueOrDefault;
					var fontColor = valueOrDefault(labelOpts.fontColor, globalDefault.defaultFontColor);
					var fontSize = valueOrDefault(labelOpts.fontSize, globalDefault.defaultFontSize);
					var fontStyle = valueOrDefault(labelOpts.fontStyle, globalDefault.defaultFontStyle);
					var fontFamily = valueOrDefault(labelOpts.fontFamily, globalDefault.defaultFontFamily);
					var labelFont = helpers.fontString(fontSize, fontStyle, fontFamily);
					var cursor;
	
					// Canvas setup
					ctx.textAlign = 'left';
					ctx.textBaseline = 'middle';
					ctx.lineWidth = 0.5;
					ctx.strokeStyle = fontColor; // for strikethrough effect
					ctx.fillStyle = fontColor; // render in correct colour
					ctx.font = labelFont;
	
					var boxWidth = getBoxWidth(labelOpts, fontSize);
					var hitboxes = me.legendHitBoxes;
	
					// current position
					var drawLegendBox = function(x, y, legendItem) {
						if (isNaN(boxWidth) || boxWidth <= 0) {
							return;
						}
	
						// Set the ctx for the box
						ctx.save();
	
						ctx.fillStyle = valueOrDefault(legendItem.fillStyle, globalDefault.defaultColor);
						ctx.lineCap = valueOrDefault(legendItem.lineCap, lineDefault.borderCapStyle);
						ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, lineDefault.borderDashOffset);
						ctx.lineJoin = valueOrDefault(legendItem.lineJoin, lineDefault.borderJoinStyle);
						ctx.lineWidth = valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth);
						ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, globalDefault.defaultColor);
						var isLineWidthZero = (valueOrDefault(legendItem.lineWidth, lineDefault.borderWidth) === 0);
	
						if (ctx.setLineDash) {
							// IE 9 and 10 do not support line dash
							ctx.setLineDash(valueOrDefault(legendItem.lineDash, lineDefault.borderDash));
						}
	
						if (opts.labels && opts.labels.usePointStyle) {
							// Recalculate x and y for drawPoint() because its expecting
							// x and y to be center of figure (instead of top left)
							var radius = fontSize * Math.SQRT2 / 2;
							var offSet = radius / Math.SQRT2;
							var centerX = x + offSet;
							var centerY = y + offSet;
	
							// Draw pointStyle as legend symbol
							helpers.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY);
						} else {
							// Draw box as legend symbol
							if (!isLineWidthZero) {
								ctx.strokeRect(x, y, boxWidth, fontSize);
							}
							ctx.fillRect(x, y, boxWidth, fontSize);
						}
	
						ctx.restore();
					};
					var fillText = function(x, y, legendItem, textWidth) {
						var halfFontSize = fontSize / 2;
						var xLeft = boxWidth + halfFontSize + x;
						var yMiddle = y + halfFontSize;
	
						ctx.fillText(legendItem.text, xLeft, yMiddle);
	
						if (legendItem.hidden) {
							// Strikethrough the text if hidden
							ctx.beginPath();
							ctx.lineWidth = 2;
							ctx.moveTo(xLeft, yMiddle);
							ctx.lineTo(xLeft + textWidth, yMiddle);
							ctx.stroke();
						}
					};
	
					// Horizontal
					var isHorizontal = me.isHorizontal();
					if (isHorizontal) {
						cursor = {
							x: me.left + ((legendWidth - lineWidths[0]) / 2),
							y: me.top + labelOpts.padding,
							line: 0
						};
					} else {
						cursor = {
							x: me.left + labelOpts.padding,
							y: me.top + labelOpts.padding,
							line: 0
						};
					}
	
					var itemHeight = fontSize + labelOpts.padding;
					helpers.each(me.legendItems, function(legendItem, i) {
						var textWidth = ctx.measureText(legendItem.text).width;
						var width = boxWidth + (fontSize / 2) + textWidth;
						var x = cursor.x;
						var y = cursor.y;
	
						if (isHorizontal) {
							if (x + width >= legendWidth) {
								y = cursor.y += itemHeight;
								cursor.line++;
								x = cursor.x = me.left + ((legendWidth - lineWidths[cursor.line]) / 2);
							}
						} else if (y + itemHeight > me.bottom) {
							x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
							y = cursor.y = me.top + labelOpts.padding;
							cursor.line++;
						}
	
						drawLegendBox(x, y, legendItem);
	
						hitboxes[i].left = x;
						hitboxes[i].top = y;
	
						// Fill the actual label
						fillText(x, y, legendItem, textWidth);
	
						if (isHorizontal) {
							cursor.x += width + (labelOpts.padding);
						} else {
							cursor.y += itemHeight;
						}
	
					});
				}
			},
	
			/**
			 * Handle an event
			 * @private
			 * @param {IEvent} event - The event to handle
			 * @return {Boolean} true if a change occured
			 */
			handleEvent: function(e) {
				var me = this;
				var opts = me.options;
				var type = e.type === 'mouseup' ? 'click' : e.type;
				var changed = false;
	
				if (type === 'mousemove') {
					if (!opts.onHover) {
						return;
					}
				} else if (type === 'click') {
					if (!opts.onClick) {
						return;
					}
				} else {
					return;
				}
	
				// Chart event already has relative position in it
				var x = e.x;
				var y = e.y;
	
				if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
					// See if we are touching one of the dataset boxes
					var lh = me.legendHitBoxes;
					for (var i = 0; i < lh.length; ++i) {
						var hitBox = lh[i];
	
						if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
							// Touching an element
							if (type === 'click') {
								// use e.native for backwards compatibility
								opts.onClick.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							} else if (type === 'mousemove') {
								// use e.native for backwards compatibility
								opts.onHover.call(me, e.native, me.legendItems[i]);
								changed = true;
								break;
							}
						}
					}
				}
	
				return changed;
			}
		});
	
		function createNewLegendAndAttach(chart, legendOpts) {
			var legend = new Chart.Legend({
				ctx: chart.ctx,
				options: legendOpts,
				chart: chart
			});
	
			layout.configure(chart, legend, legendOpts);
			layout.addBox(chart, legend);
			chart.legend = legend;
		}
	
		return {
			id: 'legend',
	
			beforeInit: function(chart) {
				var legendOpts = chart.options.legend;
	
				if (legendOpts) {
					createNewLegendAndAttach(chart, legendOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var legendOpts = chart.options.legend;
				var legend = chart.legend;
	
				if (legendOpts) {
					helpers.mergeIf(legendOpts, defaults.global.legend);
	
					if (legend) {
						layout.configure(chart, legend, legendOpts);
						legend.options = legendOpts;
					} else {
						createNewLegendAndAttach(chart, legendOpts);
					}
				} else if (legend) {
					layout.removeBox(chart, legend);
					delete chart.legend;
				}
			},
	
			afterEvent: function(chart, e) {
				var legend = chart.legend;
				if (legend) {
					legend.handleEvent(e);
				}
			}
		};
	};


/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var Element = __webpack_require__(83);
	var helpers = __webpack_require__(23);
	
	defaults._set('global', {
		title: {
			display: false,
			fontStyle: 'bold',
			fullWidth: true,
			lineHeight: 1.2,
			padding: 10,
			position: 'top',
			text: '',
			weight: 2000         // by default greater than legend (1000) to be above
		}
	});
	
	module.exports = function(Chart) {
	
		var layout = Chart.layoutService;
		var noop = helpers.noop;
	
		Chart.Title = Element.extend({
			initialize: function(config) {
				var me = this;
				helpers.extend(me, config);
	
				// Contains hit boxes for each dataset (in dataset order)
				me.legendHitBoxes = [];
			},
	
			// These methods are ordered by lifecycle. Utilities then follow.
	
			beforeUpdate: noop,
			update: function(maxWidth, maxHeight, margins) {
				var me = this;
	
				// Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
				me.beforeUpdate();
	
				// Absorb the master measurements
				me.maxWidth = maxWidth;
				me.maxHeight = maxHeight;
				me.margins = margins;
	
				// Dimensions
				me.beforeSetDimensions();
				me.setDimensions();
				me.afterSetDimensions();
				// Labels
				me.beforeBuildLabels();
				me.buildLabels();
				me.afterBuildLabels();
	
				// Fit
				me.beforeFit();
				me.fit();
				me.afterFit();
				//
				me.afterUpdate();
	
				return me.minSize;
	
			},
			afterUpdate: noop,
	
			//
	
			beforeSetDimensions: noop,
			setDimensions: function() {
				var me = this;
				// Set the unconstrained dimension before label rotation
				if (me.isHorizontal()) {
					// Reset position before calculating rotation
					me.width = me.maxWidth;
					me.left = 0;
					me.right = me.width;
				} else {
					me.height = me.maxHeight;
	
					// Reset position before calculating rotation
					me.top = 0;
					me.bottom = me.height;
				}
	
				// Reset padding
				me.paddingLeft = 0;
				me.paddingTop = 0;
				me.paddingRight = 0;
				me.paddingBottom = 0;
	
				// Reset minSize
				me.minSize = {
					width: 0,
					height: 0
				};
			},
			afterSetDimensions: noop,
	
			//
	
			beforeBuildLabels: noop,
			buildLabels: noop,
			afterBuildLabels: noop,
	
			//
	
			beforeFit: noop,
			fit: function() {
				var me = this;
				var valueOrDefault = helpers.valueOrDefault;
				var opts = me.options;
				var display = opts.display;
				var fontSize = valueOrDefault(opts.fontSize, defaults.global.defaultFontSize);
				var minSize = me.minSize;
				var lineCount = helpers.isArray(opts.text) ? opts.text.length : 1;
				var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
				var textSize = display ? (lineCount * lineHeight) + (opts.padding * 2) : 0;
	
				if (me.isHorizontal()) {
					minSize.width = me.maxWidth; // fill all the width
					minSize.height = textSize;
				} else {
					minSize.width = textSize;
					minSize.height = me.maxHeight; // fill all the height
				}
	
				me.width = minSize.width;
				me.height = minSize.height;
	
			},
			afterFit: noop,
	
			// Shared Methods
			isHorizontal: function() {
				var pos = this.options.position;
				return pos === 'top' || pos === 'bottom';
			},
	
			// Actually draw the title block on the canvas
			draw: function() {
				var me = this;
				var ctx = me.ctx;
				var valueOrDefault = helpers.valueOrDefault;
				var opts = me.options;
				var globalDefaults = defaults.global;
	
				if (opts.display) {
					var fontSize = valueOrDefault(opts.fontSize, globalDefaults.defaultFontSize);
					var fontStyle = valueOrDefault(opts.fontStyle, globalDefaults.defaultFontStyle);
					var fontFamily = valueOrDefault(opts.fontFamily, globalDefaults.defaultFontFamily);
					var titleFont = helpers.fontString(fontSize, fontStyle, fontFamily);
					var lineHeight = helpers.options.toLineHeight(opts.lineHeight, fontSize);
					var offset = lineHeight / 2 + opts.padding;
					var rotation = 0;
					var top = me.top;
					var left = me.left;
					var bottom = me.bottom;
					var right = me.right;
					var maxWidth, titleX, titleY;
	
					ctx.fillStyle = valueOrDefault(opts.fontColor, globalDefaults.defaultFontColor); // render in correct colour
					ctx.font = titleFont;
	
					// Horizontal
					if (me.isHorizontal()) {
						titleX = left + ((right - left) / 2); // midpoint of the width
						titleY = top + offset;
						maxWidth = right - left;
					} else {
						titleX = opts.position === 'left' ? left + offset : right - offset;
						titleY = top + ((bottom - top) / 2);
						maxWidth = bottom - top;
						rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
					}
	
					ctx.save();
					ctx.translate(titleX, titleY);
					ctx.rotate(rotation);
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
	
					var text = opts.text;
					if (helpers.isArray(text)) {
						var y = 0;
						for (var i = 0; i < text.length; ++i) {
							ctx.fillText(text[i], 0, y, maxWidth);
							y += lineHeight;
						}
					} else {
						ctx.fillText(text, 0, 0, maxWidth);
					}
	
					ctx.restore();
				}
			}
		});
	
		function createNewTitleBlockAndAttach(chart, titleOpts) {
			var title = new Chart.Title({
				ctx: chart.ctx,
				options: titleOpts,
				chart: chart
			});
	
			layout.configure(chart, title, titleOpts);
			layout.addBox(chart, title);
			chart.titleBlock = title;
		}
	
		return {
			id: 'title',
	
			beforeInit: function(chart) {
				var titleOpts = chart.options.title;
	
				if (titleOpts) {
					createNewTitleBlockAndAttach(chart, titleOpts);
				}
			},
	
			beforeUpdate: function(chart) {
				var titleOpts = chart.options.title;
				var titleBlock = chart.titleBlock;
	
				if (titleOpts) {
					helpers.mergeIf(titleOpts, defaults.global.title);
	
					if (titleBlock) {
						layout.configure(chart, titleBlock, titleOpts);
						titleBlock.options = titleOpts;
					} else {
						createNewTitleBlockAndAttach(chart, titleOpts);
					}
				} else if (titleBlock) {
					Chart.layoutService.removeBox(chart, titleBlock);
					delete chart.titleBlock;
				}
			}
		};
	};


/***/ },
/* 1849 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function(Chart) {
	
		// Default config for a category scale
		var defaultConfig = {
			position: 'bottom'
		};
	
		var DatasetScale = Chart.Scale.extend({
			/**
			* Internal function to get the correct labels. If data.xLabels or data.yLabels are defined, use those
			* else fall back to data.labels
			* @private
			*/
			getLabels: function() {
				var data = this.chart.data;
				return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels;
			},
	
			determineDataLimits: function() {
				var me = this;
				var labels = me.getLabels();
				me.minIndex = 0;
				me.maxIndex = labels.length - 1;
				var findIndex;
	
				if (me.options.ticks.min !== undefined) {
					// user specified min value
					findIndex = labels.indexOf(me.options.ticks.min);
					me.minIndex = findIndex !== -1 ? findIndex : me.minIndex;
				}
	
				if (me.options.ticks.max !== undefined) {
					// user specified max value
					findIndex = labels.indexOf(me.options.ticks.max);
					me.maxIndex = findIndex !== -1 ? findIndex : me.maxIndex;
				}
	
				me.min = labels[me.minIndex];
				me.max = labels[me.maxIndex];
			},
	
			buildTicks: function() {
				var me = this;
				var labels = me.getLabels();
				// If we are viewing some subset of labels, slice the original array
				me.ticks = (me.minIndex === 0 && me.maxIndex === labels.length - 1) ? labels : labels.slice(me.minIndex, me.maxIndex + 1);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var isHorizontal = me.isHorizontal();
	
				if (data.yLabels && !isHorizontal) {
					return me.getRightValue(data.datasets[datasetIndex].data[index]);
				}
				return me.ticks[index - me.minIndex];
			},
	
			// Used to get data value locations.  Value can either be an index or a numerical value
			getPixelForValue: function(value, index) {
				var me = this;
				var offset = me.options.offset;
				// 1 is added because we need the length but we have the indexes
				var offsetAmt = Math.max((me.maxIndex + 1 - me.minIndex - (offset ? 0 : 1)), 1);
	
				// If value is a data object, then index is the index in the data array,
				// not the index of the scale. We need to change that.
				var valueCategory;
				if (value !== undefined && value !== null) {
					valueCategory = me.isHorizontal() ? value.x : value.y;
				}
				if (valueCategory !== undefined || (value !== undefined && isNaN(index))) {
					var labels = me.getLabels();
					value = valueCategory || value;
					var idx = labels.indexOf(value);
					index = idx !== -1 ? idx : index;
				}
	
				if (me.isHorizontal()) {
					var valueWidth = me.width / offsetAmt;
					var widthOffset = (valueWidth * (index - me.minIndex));
	
					if (offset) {
						widthOffset += (valueWidth / 2);
					}
	
					return me.left + Math.round(widthOffset);
				}
				var valueHeight = me.height / offsetAmt;
				var heightOffset = (valueHeight * (index - me.minIndex));
	
				if (offset) {
					heightOffset += (valueHeight / 2);
				}
	
				return me.top + Math.round(heightOffset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticks[index], index + this.minIndex, null);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var offset = me.options.offset;
				var value;
				var offsetAmt = Math.max((me._ticks.length - (offset ? 0 : 1)), 1);
				var horz = me.isHorizontal();
				var valueDimension = (horz ? me.width : me.height) / offsetAmt;
	
				pixel -= horz ? me.left : me.top;
	
				if (offset) {
					pixel -= (valueDimension / 2);
				}
	
				if (pixel <= 0) {
					value = 0;
				} else {
					value = Math.round(pixel / valueDimension);
				}
	
				return value + me.minIndex;
			},
			getBasePixel: function() {
				return this.bottom;
			}
		});
	
		Chart.scaleService.registerScaleType('category', DatasetScale, defaultConfig);
	
	};


/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var helpers = __webpack_require__(23);
	var Ticks = __webpack_require__(221);
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
			ticks: {
				callback: Ticks.formatters.linear
			}
		};
	
		var LinearScale = Chart.LinearScaleBase.extend({
	
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var isHorizontal = me.isHorizontal();
				var DEFAULT_MIN = 0;
				var DEFAULT_MAX = 1;
	
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// First Calculate the range
				me.min = null;
				me.max = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (valuesPerStack[key] === undefined) {
							valuesPerStack[key] = {
								positiveValues: [],
								negativeValues: []
							};
						}
	
						// Store these per type
						var positiveValues = valuesPerStack[key].positiveValues;
						var negativeValues = valuesPerStack[key].negativeValues;
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								positiveValues[index] = positiveValues[index] || 0;
								negativeValues[index] = negativeValues[index] || 0;
	
								if (opts.relativePoints) {
									positiveValues[index] = 100;
								} else if (value < 0) {
									negativeValues[index] += value;
								} else {
									positiveValues[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var values = valuesForType.positiveValues.concat(valuesForType.negativeValues);
						var minVal = helpers.min(values);
						var maxVal = helpers.max(values);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
							});
						}
					});
				}
	
				me.min = isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
				me.max = isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				this.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var maxTicks;
				var me = this;
				var tickOpts = me.options.ticks;
	
				if (me.isHorizontal()) {
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.width / 50));
				} else {
					// The factor of 2 used to scale the font size has been experimentally determined.
					var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, defaults.global.defaultFontSize);
					maxTicks = Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(me.height / (2 * tickFontSize)));
				}
	
				return maxTicks;
			},
			// Called after the ticks are built. We need
			handleDirectionalChanges: function() {
				if (!this.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					this.ticks.reverse();
				}
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			// Utils
			getPixelForValue: function(value) {
				// This must be called after fit has been run so that
				// this.left, this.top, this.right, and this.bottom have been defined
				var me = this;
				var start = me.start;
	
				var rightValue = +me.getRightValue(value);
				var pixel;
				var range = me.end - start;
	
				if (me.isHorizontal()) {
					pixel = me.left + (me.width / range * (rightValue - start));
					return Math.round(pixel);
				}
	
				pixel = me.bottom - (me.height / range * (rightValue - start));
				return Math.round(pixel);
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var isHorizontal = me.isHorizontal();
				var innerDimension = isHorizontal ? me.width : me.height;
				var offset = (isHorizontal ? pixel - me.left : me.bottom - pixel) / innerDimension;
				return me.start + ((me.end - me.start) * offset);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.ticksAsNumbers[index]);
			}
		});
		Chart.scaleService.registerScaleType('linear', LinearScale, defaultConfig);
	
	};


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	var Ticks = __webpack_require__(221);
	
	module.exports = function(Chart) {
	
		var noop = helpers.noop;
	
		Chart.LinearScaleBase = Chart.Scale.extend({
			getRightValue: function(value) {
				if (typeof value === 'string') {
					return +value;
				}
				return Chart.Scale.prototype.getRightValue.call(this, value);
			},
	
			handleTickRangeOptions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
				// do nothing since that would make the chart weird. If the user really wants a weird chart
				// axis, they can manually override it
				if (tickOpts.beginAtZero) {
					var minSign = helpers.sign(me.min);
					var maxSign = helpers.sign(me.max);
	
					if (minSign < 0 && maxSign < 0) {
						// move the top up to 0
						me.max = 0;
					} else if (minSign > 0 && maxSign > 0) {
						// move the bottom down to 0
						me.min = 0;
					}
				}
	
				var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
				var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
	
				if (tickOpts.min !== undefined) {
					me.min = tickOpts.min;
				} else if (tickOpts.suggestedMin !== undefined) {
					if (me.min === null) {
						me.min = tickOpts.suggestedMin;
					} else {
						me.min = Math.min(me.min, tickOpts.suggestedMin);
					}
				}
	
				if (tickOpts.max !== undefined) {
					me.max = tickOpts.max;
				} else if (tickOpts.suggestedMax !== undefined) {
					if (me.max === null) {
						me.max = tickOpts.suggestedMax;
					} else {
						me.max = Math.max(me.max, tickOpts.suggestedMax);
					}
				}
	
				if (setMin !== setMax) {
					// We set the min or the max but not both.
					// So ensure that our range is good
					// Inverted or 0 length range can happen when
					// ticks.min is set, and no datasets are visible
					if (me.min >= me.max) {
						if (setMin) {
							me.max = me.min + 1;
						} else {
							me.min = me.max - 1;
						}
					}
				}
	
				if (me.min === me.max) {
					me.max++;
	
					if (!tickOpts.beginAtZero) {
						me.min--;
					}
				}
			},
			getTickLimit: noop,
			handleDirectionalChanges: noop,
	
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				// Figure out what the max number of ticks we can support it is based on the size of
				// the axis area. For now, we say that the minimum tick spacing in pixels must be 50
				// We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
				// the graph. Make sure we always have at least 2 ticks
				var maxTicks = me.getTickLimit();
				maxTicks = Math.max(2, maxTicks);
	
				var numericGeneratorOptions = {
					maxTicks: maxTicks,
					min: tickOpts.min,
					max: tickOpts.max,
					stepSize: helpers.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
				};
				var ticks = me.ticks = Ticks.generators.linear(numericGeneratorOptions, me);
	
				me.handleDirectionalChanges();
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				var me = this;
				me.ticksAsNumbers = me.ticks.slice();
				me.zeroLineIndex = me.ticks.indexOf(0);
	
				Chart.Scale.prototype.convertTicksToLabels.call(me);
			}
		});
	};


/***/ },
/* 1852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(23);
	var Ticks = __webpack_require__(221);
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'left',
	
			// label settings
			ticks: {
				callback: Ticks.formatters.logarithmic
			}
		};
	
		var LogarithmicScale = Chart.Scale.extend({
			determineDataLimits: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				var chart = me.chart;
				var data = chart.data;
				var datasets = data.datasets;
				var valueOrDefault = helpers.valueOrDefault;
				var isHorizontal = me.isHorizontal();
				function IDMatches(meta) {
					return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
				}
	
				// Calculate Range
				me.min = null;
				me.max = null;
				me.minNotZero = null;
	
				var hasStacks = opts.stacked;
				if (hasStacks === undefined) {
					helpers.each(datasets, function(dataset, datasetIndex) {
						if (hasStacks) {
							return;
						}
	
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) &&
							meta.stack !== undefined) {
							hasStacks = true;
						}
					});
				}
	
				if (opts.stacked || hasStacks) {
					var valuesPerStack = {};
	
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						var key = [
							meta.type,
							// we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
							((opts.stacked === undefined && meta.stack === undefined) ? datasetIndex : ''),
							meta.stack
						].join('.');
	
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							if (valuesPerStack[key] === undefined) {
								valuesPerStack[key] = [];
							}
	
							helpers.each(dataset.data, function(rawValue, index) {
								var values = valuesPerStack[key];
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								values[index] = values[index] || 0;
	
								if (opts.relativePoints) {
									values[index] = 100;
								} else {
									// Don't need to split positive and negative since the log scale can't handle a 0 crossing
									values[index] += value;
								}
							});
						}
					});
	
					helpers.each(valuesPerStack, function(valuesForType) {
						var minVal = helpers.min(valuesForType);
						var maxVal = helpers.max(valuesForType);
						me.min = me.min === null ? minVal : Math.min(me.min, minVal);
						me.max = me.max === null ? maxVal : Math.max(me.max, maxVal);
					});
	
				} else {
					helpers.each(datasets, function(dataset, datasetIndex) {
						var meta = chart.getDatasetMeta(datasetIndex);
						if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
							helpers.each(dataset.data, function(rawValue, index) {
								var value = +me.getRightValue(rawValue);
								if (isNaN(value) || meta.data[index].hidden) {
									return;
								}
	
								if (me.min === null) {
									me.min = value;
								} else if (value < me.min) {
									me.min = value;
								}
	
								if (me.max === null) {
									me.max = value;
								} else if (value > me.max) {
									me.max = value;
								}
	
								if (value !== 0 && (me.minNotZero === null || value < me.minNotZero)) {
									me.minNotZero = value;
								}
							});
						}
					});
				}
	
				me.min = valueOrDefault(tickOpts.min, me.min);
				me.max = valueOrDefault(tickOpts.max, me.max);
	
				if (me.min === me.max) {
					if (me.min !== 0 && me.min !== null) {
						me.min = Math.pow(10, Math.floor(helpers.log10(me.min)) - 1);
						me.max = Math.pow(10, Math.floor(helpers.log10(me.max)) + 1);
					} else {
						me.min = 1;
						me.max = 10;
					}
				}
			},
			buildTicks: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
	
				var generationOptions = {
					min: tickOpts.min,
					max: tickOpts.max
				};
				var ticks = me.ticks = Ticks.generators.logarithmic(generationOptions, me);
	
				if (!me.isHorizontal()) {
					// We are in a vertical orientation. The top value is the highest. So reverse the array
					ticks.reverse();
				}
	
				// At this point, we need to update our max and min given the tick values since we have expanded the
				// range of the scale
				me.max = helpers.max(ticks);
				me.min = helpers.min(ticks);
	
				if (tickOpts.reverse) {
					ticks.reverse();
	
					me.start = me.max;
					me.end = me.min;
				} else {
					me.start = me.min;
					me.end = me.max;
				}
			},
			convertTicksToLabels: function() {
				this.tickValues = this.ticks.slice();
	
				Chart.Scale.prototype.convertTicksToLabels.call(this);
			},
			// Get the correct tooltip label
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			getPixelForTick: function(index) {
				return this.getPixelForValue(this.tickValues[index]);
			},
			getPixelForValue: function(value) {
				var me = this;
				var start = me.start;
				var newVal = +me.getRightValue(value);
				var opts = me.options;
				var tickOpts = opts.ticks;
				var innerDimension, pixel, range;
	
				if (me.isHorizontal()) {
					range = helpers.log10(me.end) - helpers.log10(start); // todo: if start === 0
					if (newVal === 0) {
						pixel = me.left;
					} else {
						innerDimension = me.width;
						pixel = me.left + (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				} else {
					// Bottom - top since pixels increase downward on a screen
					innerDimension = me.height;
					if (start === 0 && !tickOpts.reverse) {
						range = helpers.log10(me.end) - helpers.log10(me.minNotZero);
						if (newVal === start) {
							pixel = me.bottom;
						} else if (newVal === me.minNotZero) {
							pixel = me.bottom - innerDimension * 0.02;
						} else {
							pixel = me.bottom - innerDimension * 0.02 - (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
						}
					} else if (me.end === 0 && tickOpts.reverse) {
						range = helpers.log10(me.start) - helpers.log10(me.minNotZero);
						if (newVal === me.end) {
							pixel = me.top;
						} else if (newVal === me.minNotZero) {
							pixel = me.top + innerDimension * 0.02;
						} else {
							pixel = me.top + innerDimension * 0.02 + (innerDimension * 0.98 / range * (helpers.log10(newVal) - helpers.log10(me.minNotZero)));
						}
					} else if (newVal === 0) {
						pixel = tickOpts.reverse ? me.top : me.bottom;
					} else {
						range = helpers.log10(me.end) - helpers.log10(start);
						innerDimension = me.height;
						pixel = me.bottom - (innerDimension / range * (helpers.log10(newVal) - helpers.log10(start)));
					}
				}
				return pixel;
			},
			getValueForPixel: function(pixel) {
				var me = this;
				var range = helpers.log10(me.end) - helpers.log10(me.start);
				var value, innerDimension;
	
				if (me.isHorizontal()) {
					innerDimension = me.width;
					value = me.start * Math.pow(10, (pixel - me.left) * range / innerDimension);
				} else { // todo: if start === 0
					innerDimension = me.height;
					value = Math.pow(10, (me.bottom - pixel) * range / innerDimension) / me.start;
				}
				return value;
			}
		});
		Chart.scaleService.registerScaleType('logarithmic', LogarithmicScale, defaultConfig);
	
	};


/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(34);
	var helpers = __webpack_require__(23);
	var Ticks = __webpack_require__(221);
	
	module.exports = function(Chart) {
	
		var globalDefaults = defaults.global;
	
		var defaultConfig = {
			display: true,
	
			// Boolean - Whether to animate scaling the chart from the centre
			animate: true,
			position: 'chartArea',
	
			angleLines: {
				display: true,
				color: 'rgba(0, 0, 0, 0.1)',
				lineWidth: 1
			},
	
			gridLines: {
				circular: false
			},
	
			// label settings
			ticks: {
				// Boolean - Show a backdrop to the scale label
				showLabelBackdrop: true,
	
				// String - The colour of the label backdrop
				backdropColor: 'rgba(255,255,255,0.75)',
	
				// Number - The backdrop padding above & below the label in pixels
				backdropPaddingY: 2,
	
				// Number - The backdrop padding to the side of the label in pixels
				backdropPaddingX: 2,
	
				callback: Ticks.formatters.linear
			},
	
			pointLabels: {
				// Boolean - if true, show point labels
				display: true,
	
				// Number - Point label font size in pixels
				fontSize: 10,
	
				// Function - Used to convert point labels
				callback: function(label) {
					return label;
				}
			}
		};
	
		function getValueCount(scale) {
			var opts = scale.options;
			return opts.angleLines.display || opts.pointLabels.display ? scale.chart.data.labels.length : 0;
		}
	
		function getPointLabelFontOptions(scale) {
			var pointLabelOptions = scale.options.pointLabels;
			var fontSize = helpers.valueOrDefault(pointLabelOptions.fontSize, globalDefaults.defaultFontSize);
			var fontStyle = helpers.valueOrDefault(pointLabelOptions.fontStyle, globalDefaults.defaultFontStyle);
			var fontFamily = helpers.valueOrDefault(pointLabelOptions.fontFamily, globalDefaults.defaultFontFamily);
			var font = helpers.fontString(fontSize, fontStyle, fontFamily);
	
			return {
				size: fontSize,
				style: fontStyle,
				family: fontFamily,
				font: font
			};
		}
	
		function measureLabelSize(ctx, fontSize, label) {
			if (helpers.isArray(label)) {
				return {
					w: helpers.longestText(ctx, ctx.font, label),
					h: (label.length * fontSize) + ((label.length - 1) * 1.5 * fontSize)
				};
			}
	
			return {
				w: ctx.measureText(label).width,
				h: fontSize
			};
		}
	
		function determineLimits(angle, pos, size, min, max) {
			if (angle === min || angle === max) {
				return {
					start: pos - (size / 2),
					end: pos + (size / 2)
				};
			} else if (angle < min || angle > max) {
				return {
					start: pos - size - 5,
					end: pos
				};
			}
	
			return {
				start: pos,
				end: pos + size + 5
			};
		}
	
		/**
		 * Helper function to fit a radial linear scale with point labels
		 */
		function fitWithPointLabels(scale) {
			/*
			 * Right, this is really confusing and there is a lot of maths going on here
			 * The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
			 *
			 * Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
			 *
			 * Solution:
			 *
			 * We assume the radius of the polygon is half the size of the canvas at first
			 * at each index we check if the text overlaps.
			 *
			 * Where it does, we store that angle and that index.
			 *
			 * After finding the largest index and angle we calculate how much we need to remove
			 * from the shape radius to move the point inwards by that x.
			 *
			 * We average the left and right distances to get the maximum shape radius that can fit in the box
			 * along with labels.
			 *
			 * Once we have that, we can find the centre point for the chart, by taking the x text protrusion
			 * on each side, removing that from the size, halving it and adding the left x protrusion width.
			 *
			 * This will mean we have a shape fitted to the canvas, as large as it can be with the labels
			 * and position it in the most space efficient manner
			 *
			 * https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif
			 */
	
			var plFont = getPointLabelFontOptions(scale);
	
			// Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
			// Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			var furthestLimits = {
				r: scale.width,
				l: 0,
				t: scale.height,
				b: 0
			};
			var furthestAngles = {};
			var i, textSize, pointPosition;
	
			scale.ctx.font = plFont.font;
			scale._pointLabelSizes = [];
	
			var valueCount = getValueCount(scale);
			for (i = 0; i < valueCount; i++) {
				pointPosition = scale.getPointPosition(i, largestPossibleRadius);
				textSize = measureLabelSize(scale.ctx, plFont.size, scale.pointLabels[i] || '');
				scale._pointLabelSizes[i] = textSize;
	
				// Add quarter circle to make degree 0 mean top of circle
				var angleRadians = scale.getIndexAngle(i);
				var angle = helpers.toDegrees(angleRadians) % 360;
				var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
				var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
	
				if (hLimits.start < furthestLimits.l) {
					furthestLimits.l = hLimits.start;
					furthestAngles.l = angleRadians;
				}
	
				if (hLimits.end > furthestLimits.r) {
					furthestLimits.r = hLimits.end;
					furthestAngles.r = angleRadians;
				}
	
				if (vLimits.start < furthestLimits.t) {
					furthestLimits.t = vLimits.start;
					furthestAngles.t = angleRadians;
				}
	
				if (vLimits.end > furthestLimits.b) {
					furthestLimits.b = vLimits.end;
					furthestAngles.b = angleRadians;
				}
			}
	
			scale.setReductions(largestPossibleRadius, furthestLimits, furthestAngles);
		}
	
		/**
		 * Helper function to fit a radial linear scale with no point labels
		 */
		function fit(scale) {
			var largestPossibleRadius = Math.min(scale.height / 2, scale.width / 2);
			scale.drawingArea = Math.round(largestPossibleRadius);
			scale.setCenterPoint(0, 0, 0, 0);
		}
	
		function getTextAlignForAngle(angle) {
			if (angle === 0 || angle === 180) {
				return 'center';
			} else if (angle < 180) {
				return 'left';
			}
	
			return 'right';
		}
	
		function fillText(ctx, text, position, fontSize) {
			if (helpers.isArray(text)) {
				var y = position.y;
				var spacing = 1.5 * fontSize;
	
				for (var i = 0; i < text.length; ++i) {
					ctx.fillText(text[i], position.x, y);
					y += spacing;
				}
			} else {
				ctx.fillText(text, position.x, position.y);
			}
		}
	
		function adjustPointPositionForLabelHeight(angle, textSize, position) {
			if (angle === 90 || angle === 270) {
				position.y -= (textSize.h / 2);
			} else if (angle > 270 || angle < 90) {
				position.y -= textSize.h;
			}
		}
	
		function drawPointLabels(scale) {
			var ctx = scale.ctx;
			var valueOrDefault = helpers.valueOrDefault;
			var opts = scale.options;
			var angleLineOpts = opts.angleLines;
			var pointLabelOpts = opts.pointLabels;
	
			ctx.lineWidth = angleLineOpts.lineWidth;
			ctx.strokeStyle = angleLineOpts.color;
	
			var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
	
			// Point Label Font
			var plFont = getPointLabelFontOptions(scale);
	
			ctx.textBaseline = 'top';
	
			for (var i = getValueCount(scale) - 1; i >= 0; i--) {
				if (angleLineOpts.display) {
					var outerPosition = scale.getPointPosition(i, outerDistance);
					ctx.beginPath();
					ctx.moveTo(scale.xCenter, scale.yCenter);
					ctx.lineTo(outerPosition.x, outerPosition.y);
					ctx.stroke();
					ctx.closePath();
				}
	
				if (pointLabelOpts.display) {
					// Extra 3px out for some label spacing
					var pointLabelPosition = scale.getPointPosition(i, outerDistance + 5);
	
					// Keep this in loop since we may support array properties here
					var pointLabelFontColor = valueOrDefault(pointLabelOpts.fontColor, globalDefaults.defaultFontColor);
					ctx.font = plFont.font;
					ctx.fillStyle = pointLabelFontColor;
	
					var angleRadians = scale.getIndexAngle(i);
					var angle = helpers.toDegrees(angleRadians);
					ctx.textAlign = getTextAlignForAngle(angle);
					adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
					fillText(ctx, scale.pointLabels[i] || '', pointLabelPosition, plFont.size);
				}
			}
		}
	
		function drawRadiusLine(scale, gridLineOpts, radius, index) {
			var ctx = scale.ctx;
			ctx.strokeStyle = helpers.valueAtIndexOrDefault(gridLineOpts.color, index - 1);
			ctx.lineWidth = helpers.valueAtIndexOrDefault(gridLineOpts.lineWidth, index - 1);
	
			if (scale.options.gridLines.circular) {
				// Draw circular arcs between the points
				ctx.beginPath();
				ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
				ctx.closePath();
				ctx.stroke();
			} else {
				// Draw straight lines connecting each index
				var valueCount = getValueCount(scale);
	
				if (valueCount === 0) {
					return;
				}
	
				ctx.beginPath();
				var pointPosition = scale.getPointPosition(0, radius);
				ctx.moveTo(pointPosition.x, pointPosition.y);
	
				for (var i = 1; i < valueCount; i++) {
					pointPosition = scale.getPointPosition(i, radius);
					ctx.lineTo(pointPosition.x, pointPosition.y);
				}
	
				ctx.closePath();
				ctx.stroke();
			}
		}
	
		function numberOrZero(param) {
			return helpers.isNumber(param) ? param : 0;
		}
	
		var LinearRadialScale = Chart.LinearScaleBase.extend({
			setDimensions: function() {
				var me = this;
				var opts = me.options;
				var tickOpts = opts.ticks;
				// Set the unconstrained dimension before label rotation
				me.width = me.maxWidth;
				me.height = me.maxHeight;
				me.xCenter = Math.round(me.width / 2);
				me.yCenter = Math.round(me.height / 2);
	
				var minSize = helpers.min([me.height, me.width]);
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				me.drawingArea = opts.display ? (minSize / 2) - (tickFontSize / 2 + tickOpts.backdropPaddingY) : (minSize / 2);
			},
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var min = Number.POSITIVE_INFINITY;
				var max = Number.NEGATIVE_INFINITY;
	
				helpers.each(chart.data.datasets, function(dataset, datasetIndex) {
					if (chart.isDatasetVisible(datasetIndex)) {
						var meta = chart.getDatasetMeta(datasetIndex);
	
						helpers.each(dataset.data, function(rawValue, index) {
							var value = +me.getRightValue(rawValue);
							if (isNaN(value) || meta.data[index].hidden) {
								return;
							}
	
							min = Math.min(value, min);
							max = Math.max(value, max);
						});
					}
				});
	
				me.min = (min === Number.POSITIVE_INFINITY ? 0 : min);
				me.max = (max === Number.NEGATIVE_INFINITY ? 0 : max);
	
				// Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
				me.handleTickRangeOptions();
			},
			getTickLimit: function() {
				var tickOpts = this.options.ticks;
				var tickFontSize = helpers.valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
				return Math.min(tickOpts.maxTicksLimit ? tickOpts.maxTicksLimit : 11, Math.ceil(this.drawingArea / (1.5 * tickFontSize)));
			},
			convertTicksToLabels: function() {
				var me = this;
	
				Chart.LinearScaleBase.prototype.convertTicksToLabels.call(me);
	
				// Point labels
				me.pointLabels = me.chart.data.labels.map(me.options.pointLabels.callback, me);
			},
			getLabelForIndex: function(index, datasetIndex) {
				return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
			},
			fit: function() {
				if (this.options.pointLabels.display) {
					fitWithPointLabels(this);
				} else {
					fit(this);
				}
			},
			/**
			 * Set radius reductions and determine new radius and center point
			 * @private
			 */
			setReductions: function(largestPossibleRadius, furthestLimits, furthestAngles) {
				var me = this;
				var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
				var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
				var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
				var radiusReductionBottom = -Math.max(furthestLimits.b - me.height, 0) / Math.cos(furthestAngles.b);
	
				radiusReductionLeft = numberOrZero(radiusReductionLeft);
				radiusReductionRight = numberOrZero(radiusReductionRight);
				radiusReductionTop = numberOrZero(radiusReductionTop);
				radiusReductionBottom = numberOrZero(radiusReductionBottom);
	
				me.drawingArea = Math.min(
					Math.round(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2),
					Math.round(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
				me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
			},
			setCenterPoint: function(leftMovement, rightMovement, topMovement, bottomMovement) {
				var me = this;
				var maxRight = me.width - rightMovement - me.drawingArea;
				var maxLeft = leftMovement + me.drawingArea;
				var maxTop = topMovement + me.drawingArea;
				var maxBottom = me.height - bottomMovement - me.drawingArea;
	
				me.xCenter = Math.round(((maxLeft + maxRight) / 2) + me.left);
				me.yCenter = Math.round(((maxTop + maxBottom) / 2) + me.top);
			},
	
			getIndexAngle: function(index) {
				var angleMultiplier = (Math.PI * 2) / getValueCount(this);
				var startAngle = this.chart.options && this.chart.options.startAngle ?
					this.chart.options.startAngle :
					0;
	
				var startAngleRadians = startAngle * Math.PI * 2 / 360;
	
				// Start from the top instead of right, so remove a quarter of the circle
				return index * angleMultiplier + startAngleRadians;
			},
			getDistanceFromCenterForValue: function(value) {
				var me = this;
	
				if (value === null) {
					return 0; // null always in center
				}
	
				// Take into account half font size + the yPadding of the top value
				var scalingFactor = me.drawingArea / (me.max - me.min);
				if (me.options.ticks.reverse) {
					return (me.max - value) * scalingFactor;
				}
				return (value - me.min) * scalingFactor;
			},
			getPointPosition: function(index, distanceFromCenter) {
				var me = this;
				var thisAngle = me.getIndexAngle(index) - (Math.PI / 2);
				return {
					x: Math.round(Math.cos(thisAngle) * distanceFromCenter) + me.xCenter,
					y: Math.round(Math.sin(thisAngle) * distanceFromCenter) + me.yCenter
				};
			},
			getPointPositionForValue: function(index, value) {
				return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
			},
	
			getBasePosition: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
	
				return me.getPointPositionForValue(0,
					me.beginAtZero ? 0 :
					min < 0 && max < 0 ? max :
					min > 0 && max > 0 ? min :
					0);
			},
	
			draw: function() {
				var me = this;
				var opts = me.options;
				var gridLineOpts = opts.gridLines;
				var tickOpts = opts.ticks;
				var valueOrDefault = helpers.valueOrDefault;
	
				if (opts.display) {
					var ctx = me.ctx;
					var startAngle = this.getIndexAngle(0);
	
					// Tick Font
					var tickFontSize = valueOrDefault(tickOpts.fontSize, globalDefaults.defaultFontSize);
					var tickFontStyle = valueOrDefault(tickOpts.fontStyle, globalDefaults.defaultFontStyle);
					var tickFontFamily = valueOrDefault(tickOpts.fontFamily, globalDefaults.defaultFontFamily);
					var tickLabelFont = helpers.fontString(tickFontSize, tickFontStyle, tickFontFamily);
	
					helpers.each(me.ticks, function(label, index) {
						// Don't draw a centre value (if it is minimum)
						if (index > 0 || tickOpts.reverse) {
							var yCenterOffset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
	
							// Draw circular lines around the scale
							if (gridLineOpts.display && index !== 0) {
								drawRadiusLine(me, gridLineOpts, yCenterOffset, index);
							}
	
							if (tickOpts.display) {
								var tickFontColor = valueOrDefault(tickOpts.fontColor, globalDefaults.defaultFontColor);
								ctx.font = tickLabelFont;
	
								ctx.save();
								ctx.translate(me.xCenter, me.yCenter);
								ctx.rotate(startAngle);
	
								if (tickOpts.showLabelBackdrop) {
									var labelWidth = ctx.measureText(label).width;
									ctx.fillStyle = tickOpts.backdropColor;
									ctx.fillRect(
										-labelWidth / 2 - tickOpts.backdropPaddingX,
										-yCenterOffset - tickFontSize / 2 - tickOpts.backdropPaddingY,
										labelWidth + tickOpts.backdropPaddingX * 2,
										tickFontSize + tickOpts.backdropPaddingY * 2
									);
								}
	
								ctx.textAlign = 'center';
								ctx.textBaseline = 'middle';
								ctx.fillStyle = tickFontColor;
								ctx.fillText(label, 0, -yCenterOffset);
								ctx.restore();
							}
						}
					});
	
					if (opts.angleLines.display || opts.pointLabels.display) {
						drawPointLabels(me);
					}
				}
			}
		});
		Chart.scaleService.registerScaleType('radialLinear', LinearRadialScale, defaultConfig);
	
	};


/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	/* global window: false */
	'use strict';
	
	var moment = __webpack_require__(10);
	moment = typeof moment === 'function' ? moment : window.moment;
	
	var defaults = __webpack_require__(34);
	var helpers = __webpack_require__(23);
	
	// Integer constants are from the ES6 spec.
	var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
	var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
	
	var INTERVALS = {
		millisecond: {
			common: true,
			size: 1,
			steps: [1, 2, 5, 10, 20, 50, 100, 250, 500]
		},
		second: {
			common: true,
			size: 1000,
			steps: [1, 2, 5, 10, 30]
		},
		minute: {
			common: true,
			size: 60000,
			steps: [1, 2, 5, 10, 30]
		},
		hour: {
			common: true,
			size: 3600000,
			steps: [1, 2, 3, 6, 12]
		},
		day: {
			common: true,
			size: 86400000,
			steps: [1, 2, 5]
		},
		week: {
			common: false,
			size: 604800000,
			steps: [1, 2, 3, 4]
		},
		month: {
			common: true,
			size: 2.628e9,
			steps: [1, 2, 3]
		},
		quarter: {
			common: false,
			size: 7.884e9,
			steps: [1, 2, 3, 4]
		},
		year: {
			common: true,
			size: 3.154e10
		}
	};
	
	var UNITS = Object.keys(INTERVALS);
	
	function sorter(a, b) {
		return a - b;
	}
	
	function arrayUnique(items) {
		var hash = {};
		var out = [];
		var i, ilen, item;
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			item = items[i];
			if (!hash[item]) {
				hash[item] = true;
				out.push(item);
			}
		}
	
		return out;
	}
	
	/**
	 * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
	 * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
	 * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
	 * extremity (left + width or top + height). Note that it would be more optimized to directly
	 * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
	 * to create the lookup table. The table ALWAYS contains at least two items: min and max.
	 *
	 * @param {Number[]} timestamps - timestamps sorted from lowest to highest.
	 * @param {String} distribution - If 'linear', timestamps will be spread linearly along the min
	 * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
	 * If 'series', timestamps will be positioned at the same distance from each other. In this
	 * case, only timestamps that break the time linearity are registered, meaning that in the
	 * best case, all timestamps are linear, the table contains only min and max.
	 */
	function buildLookupTable(timestamps, min, max, distribution) {
		if (distribution === 'linear' || !timestamps.length) {
			return [
				{time: min, pos: 0},
				{time: max, pos: 1}
			];
		}
	
		var table = [];
		var items = [min];
		var i, ilen, prev, curr, next;
	
		for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
			curr = timestamps[i];
			if (curr > min && curr < max) {
				items.push(curr);
			}
		}
	
		items.push(max);
	
		for (i = 0, ilen = items.length; i < ilen; ++i) {
			next = items[i + 1];
			prev = items[i - 1];
			curr = items[i];
	
			// only add points that breaks the scale linearity
			if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
				table.push({time: curr, pos: i / (ilen - 1)});
			}
		}
	
		return table;
	}
	
	// @see adapted from http://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
	function lookup(table, key, value) {
		var lo = 0;
		var hi = table.length - 1;
		var mid, i0, i1;
	
		while (lo >= 0 && lo <= hi) {
			mid = (lo + hi) >> 1;
			i0 = table[mid - 1] || null;
			i1 = table[mid];
	
			if (!i0) {
				// given value is outside table (before first item)
				return {lo: null, hi: i1};
			} else if (i1[key] < value) {
				lo = mid + 1;
			} else if (i0[key] > value) {
				hi = mid - 1;
			} else {
				return {lo: i0, hi: i1};
			}
		}
	
		// given value is outside table (after last item)
		return {lo: i1, hi: null};
	}
	
	/**
	 * Linearly interpolates the given source `value` using the table items `skey` values and
	 * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
	 * returns the position for a timestamp equal to 42. If value is out of bounds, values at
	 * index [0, 1] or [n - 1, n] are used for the interpolation.
	 */
	function interpolate(table, skey, sval, tkey) {
		var range = lookup(table, skey, sval);
	
		// Note: the lookup table ALWAYS contains at least 2 items (min and max)
		var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
		var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
	
		var span = next[skey] - prev[skey];
		var ratio = span ? (sval - prev[skey]) / span : 0;
		var offset = (next[tkey] - prev[tkey]) * ratio;
	
		return prev[tkey] + offset;
	}
	
	/**
	 * Convert the given value to a moment object using the given time options.
	 * @see http://momentjs.com/docs/#/parsing/
	 */
	function momentify(value, options) {
		var parser = options.parser;
		var format = options.parser || options.format;
	
		if (typeof parser === 'function') {
			return parser(value);
		}
	
		if (typeof value === 'string' && typeof format === 'string') {
			return moment(value, format);
		}
	
		if (!(value instanceof moment)) {
			value = moment(value);
		}
	
		if (value.isValid()) {
			return value;
		}
	
		// Labels are in an incompatible moment format and no `parser` has been provided.
		// The user might still use the deprecated `format` option to convert his inputs.
		if (typeof format === 'function') {
			return format(value);
		}
	
		return value;
	}
	
	function parse(input, scale) {
		if (helpers.isNullOrUndef(input)) {
			return null;
		}
	
		var options = scale.options.time;
		var value = momentify(scale.getRightValue(input), options);
		if (!value.isValid()) {
			return null;
		}
	
		if (options.round) {
			value.startOf(options.round);
		}
	
		return value.valueOf();
	}
	
	/**
	 * Returns the number of unit to skip to be able to display up to `capacity` number of ticks
	 * in `unit` for the given `min` / `max` range and respecting the interval steps constraints.
	 */
	function determineStepSize(min, max, unit, capacity) {
		var range = max - min;
		var interval = INTERVALS[unit];
		var milliseconds = interval.size;
		var steps = interval.steps;
		var i, ilen, factor;
	
		if (!steps) {
			return Math.ceil(range / ((capacity || 1) * milliseconds));
		}
	
		for (i = 0, ilen = steps.length; i < ilen; ++i) {
			factor = steps[i];
			if (Math.ceil(range / (milliseconds * factor)) <= capacity) {
				break;
			}
		}
	
		return factor;
	}
	
	/**
	 * Figures out what unit results in an appropriate number of auto-generated ticks
	 */
	function determineUnitForAutoTicks(minUnit, min, max, capacity) {
		var ilen = UNITS.length;
		var i, interval, factor;
	
		for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
			interval = INTERVALS[UNITS[i]];
			factor = interval.steps ? interval.steps[interval.steps.length - 1] : MAX_INTEGER;
	
			if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
				return UNITS[i];
			}
		}
	
		return UNITS[ilen - 1];
	}
	
	/**
	 * Figures out what unit to format a set of ticks with
	 */
	function determineUnitForFormatting(ticks, minUnit, min, max) {
		var duration = moment.duration(moment(max).diff(moment(min)));
		var ilen = UNITS.length;
		var i, unit;
	
		for (i = ilen - 1; i >= UNITS.indexOf(minUnit); i--) {
			unit = UNITS[i];
			if (INTERVALS[unit].common && duration.as(unit) >= ticks.length) {
				return unit;
			}
		}
	
		return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
	}
	
	function determineMajorUnit(unit) {
		for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
			if (INTERVALS[UNITS[i]].common) {
				return UNITS[i];
			}
		}
	}
	
	/**
	 * Generates a maximum of `capacity` timestamps between min and max, rounded to the
	 * `minor` unit, aligned on the `major` unit and using the given scale time `options`.
	 * Important: this method can return ticks outside the min and max range, it's the
	 * responsibility of the calling code to clamp values if needed.
	 */
	function generate(min, max, capacity, options) {
		var timeOpts = options.time;
		var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
		var major = determineMajorUnit(minor);
		var stepSize = helpers.valueOrDefault(timeOpts.stepSize, timeOpts.unitStepSize);
		var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
		var majorTicksEnabled = options.ticks.major.enabled;
		var interval = INTERVALS[minor];
		var first = moment(min);
		var last = moment(max);
		var ticks = [];
		var time;
	
		if (!stepSize) {
			stepSize = determineStepSize(min, max, minor, capacity);
		}
	
		// For 'week' unit, handle the first day of week option
		if (weekday) {
			first = first.isoWeekday(weekday);
			last = last.isoWeekday(weekday);
		}
	
		// Align first/last ticks on unit
		first = first.startOf(weekday ? 'day' : minor);
		last = last.startOf(weekday ? 'day' : minor);
	
		// Make sure that the last tick include max
		if (last < max) {
			last.add(1, minor);
		}
	
		time = moment(first);
	
		if (majorTicksEnabled && major && !weekday && !timeOpts.round) {
			// Align the first tick on the previous `minor` unit aligned on the `major` unit:
			// we first aligned time on the previous `major` unit then add the number of full
			// stepSize there is between first and the previous major time.
			time.startOf(major);
			time.add(~~((first - time) / (interval.size * stepSize)) * stepSize, minor);
		}
	
		for (; time < last; time.add(stepSize, minor)) {
			ticks.push(+time);
		}
	
		ticks.push(+time);
	
		return ticks;
	}
	
	/**
	 * Returns the right and left offsets from edges in the form of {left, right}.
	 * Offsets are added when the `offset` option is true.
	 */
	function computeOffsets(table, ticks, min, max, options) {
		var left = 0;
		var right = 0;
		var upper, lower;
	
		if (options.offset && ticks.length) {
			if (!options.time.min) {
				upper = ticks.length > 1 ? ticks[1] : max;
				lower = ticks[0];
				left = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
			if (!options.time.max) {
				upper = ticks[ticks.length - 1];
				lower = ticks.length > 1 ? ticks[ticks.length - 2] : min;
				right = (
					interpolate(table, 'time', upper, 'pos') -
					interpolate(table, 'time', lower, 'pos')
				) / 2;
			}
		}
	
		return {left: left, right: right};
	}
	
	function ticksFromTimestamps(values, majorUnit) {
		var ticks = [];
		var i, ilen, value, major;
	
		for (i = 0, ilen = values.length; i < ilen; ++i) {
			value = values[i];
			major = majorUnit ? value === +moment(value).startOf(majorUnit) : false;
	
			ticks.push({
				value: value,
				major: major
			});
		}
	
		return ticks;
	}
	
	module.exports = function(Chart) {
	
		var defaultConfig = {
			position: 'bottom',
	
			/**
			 * Data distribution along the scale:
			 * - 'linear': data are spread according to their time (distances can vary),
			 * - 'series': data are spread at the same distance from each other.
			 * @see https://github.com/chartjs/Chart.js/pull/4507
			 * @since 2.7.0
			 */
			distribution: 'linear',
	
			/**
			 * Scale boundary strategy (bypassed by min/max time options)
			 * - `data`: make sure data are fully visible, ticks outside are removed
			 * - `ticks`: make sure ticks are fully visible, data outside are truncated
			 * @see https://github.com/chartjs/Chart.js/pull/4556
			 * @since 2.7.0
			 */
			bounds: 'data',
	
			time: {
				parser: false, // false == a pattern string from http://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
				format: false, // DEPRECATED false == date objects, moment object, callback or a pattern string from http://momentjs.com/docs/#/parsing/string-format/
				unit: false, // false == automatic or override with week, month, year, etc.
				round: false, // none, or override with week, month, year, etc.
				displayFormat: false, // DEPRECATED
				isoWeekday: false, // override week start day - see http://momentjs.com/docs/#/get-set/iso-weekday/
				minUnit: 'millisecond',
	
				// defaults to unit's corresponding unitFormat below or override using pattern string from http://momentjs.com/docs/#/displaying/format/
				displayFormats: {
					millisecond: 'h:mm:ss.SSS a', // 11:20:01.123 AM,
					second: 'h:mm:ss a', // 11:20:01 AM
					minute: 'h:mm a', // 11:20 AM
					hour: 'hA', // 5PM
					day: 'MMM D', // Sep 4
					week: 'll', // Week 46, or maybe "[W]WW - YYYY" ?
					month: 'MMM YYYY', // Sept 2015
					quarter: '[Q]Q - YYYY', // Q3
					year: 'YYYY' // 2015
				},
			},
			ticks: {
				autoSkip: false,
	
				/**
				 * Ticks generation input values:
				 * - 'auto': generates "optimal" ticks based on scale size and time options.
				 * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
				 * - 'labels': generates ticks from user given `data.labels` values ONLY.
				 * @see https://github.com/chartjs/Chart.js/pull/4507
				 * @since 2.7.0
				 */
				source: 'auto',
	
				major: {
					enabled: false
				}
			}
		};
	
		var TimeScale = Chart.Scale.extend({
			initialize: function() {
				if (!moment) {
					throw new Error('Chart.js - Moment.js could not be found! You must include it before Chart.js to use the time scale. Download at https://momentjs.com');
				}
	
				this.mergeTicksOptions();
	
				Chart.Scale.prototype.initialize.call(this);
			},
	
			update: function() {
				var me = this;
				var options = me.options;
	
				// DEPRECATIONS: output a message only one time per update
				if (options.time && options.time.format) {
					console.warn('options.time.format is deprecated and replaced by options.time.parser.');
				}
	
				return Chart.Scale.prototype.update.apply(me, arguments);
			},
	
			/**
			 * Allows data to be referenced via 't' attribute
			 */
			getRightValue: function(rawValue) {
				if (rawValue && rawValue.t !== undefined) {
					rawValue = rawValue.t;
				}
				return Chart.Scale.prototype.getRightValue.call(this, rawValue);
			},
	
			determineDataLimits: function() {
				var me = this;
				var chart = me.chart;
				var timeOpts = me.options.time;
				var min = MAX_INTEGER;
				var max = MIN_INTEGER;
				var timestamps = [];
				var datasets = [];
				var labels = [];
				var i, j, ilen, jlen, data, timestamp;
	
				// Convert labels to timestamps
				for (i = 0, ilen = chart.data.labels.length; i < ilen; ++i) {
					labels.push(parse(chart.data.labels[i], me));
				}
	
				// Convert data to timestamps
				for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
					if (chart.isDatasetVisible(i)) {
						data = chart.data.datasets[i].data;
	
						// Let's consider that all data have the same format.
						if (helpers.isObject(data[0])) {
							datasets[i] = [];
	
							for (j = 0, jlen = data.length; j < jlen; ++j) {
								timestamp = parse(data[j], me);
								timestamps.push(timestamp);
								datasets[i][j] = timestamp;
							}
						} else {
							timestamps.push.apply(timestamps, labels);
							datasets[i] = labels.slice(0);
						}
					} else {
						datasets[i] = [];
					}
				}
	
				if (labels.length) {
					// Sort labels **after** data have been converted
					labels = arrayUnique(labels).sort(sorter);
					min = Math.min(min, labels[0]);
					max = Math.max(max, labels[labels.length - 1]);
				}
	
				if (timestamps.length) {
					timestamps = arrayUnique(timestamps).sort(sorter);
					min = Math.min(min, timestamps[0]);
					max = Math.max(max, timestamps[timestamps.length - 1]);
				}
	
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// In case there is no valid min/max, let's use today limits
				min = min === MAX_INTEGER ? +moment().startOf('day') : min;
				max = max === MIN_INTEGER ? +moment().endOf('day') + 1 : max;
	
				// Make sure that max is strictly higher than min (required by the lookup table)
				me.min = Math.min(min, max);
				me.max = Math.max(min + 1, max);
	
				// PRIVATE
				me._horizontal = me.isHorizontal();
				me._table = [];
				me._timestamps = {
					data: timestamps,
					datasets: datasets,
					labels: labels
				};
			},
	
			buildTicks: function() {
				var me = this;
				var min = me.min;
				var max = me.max;
				var options = me.options;
				var timeOpts = options.time;
				var timestamps = [];
				var ticks = [];
				var i, ilen, timestamp;
	
				switch (options.ticks.source) {
				case 'data':
					timestamps = me._timestamps.data;
					break;
				case 'labels':
					timestamps = me._timestamps.labels;
					break;
				case 'auto':
				default:
					timestamps = generate(min, max, me.getLabelCapacity(min), options);
				}
	
				if (options.bounds === 'ticks' && timestamps.length) {
					min = timestamps[0];
					max = timestamps[timestamps.length - 1];
				}
	
				// Enforce limits with user min/max options
				min = parse(timeOpts.min, me) || min;
				max = parse(timeOpts.max, me) || max;
	
				// Remove ticks outside the min/max range
				for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
					timestamp = timestamps[i];
					if (timestamp >= min && timestamp <= max) {
						ticks.push(timestamp);
					}
				}
	
				me.min = min;
				me.max = max;
	
				// PRIVATE
				me._unit = timeOpts.unit || determineUnitForFormatting(ticks, timeOpts.minUnit, me.min, me.max);
				me._majorUnit = determineMajorUnit(me._unit);
				me._table = buildLookupTable(me._timestamps.data, min, max, options.distribution);
				me._offsets = computeOffsets(me._table, ticks, min, max, options);
	
				return ticksFromTimestamps(ticks, me._majorUnit);
			},
	
			getLabelForIndex: function(index, datasetIndex) {
				var me = this;
				var data = me.chart.data;
				var timeOpts = me.options.time;
				var label = data.labels && index < data.labels.length ? data.labels[index] : '';
				var value = data.datasets[datasetIndex].data[index];
	
				if (helpers.isObject(value)) {
					label = me.getRightValue(value);
				}
				if (timeOpts.tooltipFormat) {
					label = momentify(label, timeOpts).format(timeOpts.tooltipFormat);
				}
	
				return label;
			},
	
			/**
			 * Function to format an individual tick mark
			 * @private
			 */
			tickFormatFunction: function(tick, index, ticks, formatOverride) {
				var me = this;
				var options = me.options;
				var time = tick.valueOf();
				var formats = options.time.displayFormats;
				var minorFormat = formats[me._unit];
				var majorUnit = me._majorUnit;
				var majorFormat = formats[majorUnit];
				var majorTime = tick.clone().startOf(majorUnit).valueOf();
				var majorTickOpts = options.ticks.major;
				var major = majorTickOpts.enabled && majorUnit && majorFormat && time === majorTime;
				var label = tick.format(formatOverride ? formatOverride : major ? majorFormat : minorFormat);
				var tickOpts = major ? majorTickOpts : options.ticks.minor;
				var formatter = helpers.valueOrDefault(tickOpts.callback, tickOpts.userCallback);
	
				return formatter ? formatter(label, index, ticks) : label;
			},
	
			convertTicksToLabels: function(ticks) {
				var labels = [];
				var i, ilen;
	
				for (i = 0, ilen = ticks.length; i < ilen; ++i) {
					labels.push(this.tickFormatFunction(moment(ticks[i].value), i, ticks));
				}
	
				return labels;
			},
	
			/**
			 * @private
			 */
			getPixelForOffset: function(time) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = interpolate(me._table, 'time', time, 'pos');
	
				return start + size * (me._offsets.left + pos) / (me._offsets.left + 1 + me._offsets.right);
			},
	
			getPixelForValue: function(value, index, datasetIndex) {
				var me = this;
				var time = null;
	
				if (index !== undefined && datasetIndex !== undefined) {
					time = me._timestamps.datasets[datasetIndex][index];
				}
	
				if (time === null) {
					time = parse(value, me);
				}
	
				if (time !== null) {
					return me.getPixelForOffset(time);
				}
			},
	
			getPixelForTick: function(index) {
				var ticks = this.getTicks();
				return index >= 0 && index < ticks.length ?
					this.getPixelForOffset(ticks[index].value) :
					null;
			},
	
			getValueForPixel: function(pixel) {
				var me = this;
				var size = me._horizontal ? me.width : me.height;
				var start = me._horizontal ? me.left : me.top;
				var pos = (size ? (pixel - start) / size : 0) * (me._offsets.left + 1 + me._offsets.left) - me._offsets.right;
				var time = interpolate(me._table, 'pos', pos, 'time');
	
				return moment(time);
			},
	
			/**
			 * Crude approximation of what the label width might be
			 * @private
			 */
			getLabelWidth: function(label) {
				var me = this;
				var ticksOpts = me.options.ticks;
				var tickLabelWidth = me.ctx.measureText(label).width;
				var angle = helpers.toRadians(ticksOpts.maxRotation);
				var cosRotation = Math.cos(angle);
				var sinRotation = Math.sin(angle);
				var tickFontSize = helpers.valueOrDefault(ticksOpts.fontSize, defaults.global.defaultFontSize);
	
				return (tickLabelWidth * cosRotation) + (tickFontSize * sinRotation);
			},
	
			/**
			 * @private
			 */
			getLabelCapacity: function(exampleTime) {
				var me = this;
	
				var formatOverride = me.options.time.displayFormats.millisecond;	// Pick the longest format for guestimation
	
				var exampleLabel = me.tickFormatFunction(moment(exampleTime), 0, [], formatOverride);
				var tickLabelWidth = me.getLabelWidth(exampleLabel);
				var innerWidth = me.isHorizontal() ? me.width : me.height;
	
				return Math.floor(innerWidth / tickLabelWidth);
			}
		});
	
		Chart.scaleService.registerScaleType('time', TimeScale, defaultConfig);
	};


/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	/* MIT license */
	var colorNames = __webpack_require__(1858);
	
	module.exports = {
	   getRgba: getRgba,
	   getHsla: getHsla,
	   getRgb: getRgb,
	   getHsl: getHsl,
	   getHwb: getHwb,
	   getAlpha: getAlpha,
	
	   hexString: hexString,
	   rgbString: rgbString,
	   rgbaString: rgbaString,
	   percentString: percentString,
	   percentaString: percentaString,
	   hslString: hslString,
	   hslaString: hslaString,
	   hwbString: hwbString,
	   keyword: keyword
	}
	
	function getRgba(string) {
	   if (!string) {
	      return;
	   }
	   var abbr =  /^#([a-fA-F0-9]{3})$/i,
	       hex =  /^#([a-fA-F0-9]{6})$/i,
	       rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
	       keyword = /(\w+)/;
	
	   var rgb = [0, 0, 0],
	       a = 1,
	       match = string.match(abbr);
	   if (match) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i] + match[i], 16);
	      }
	   }
	   else if (match = string.match(hex)) {
	      match = match[1];
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
	      }
	   }
	   else if (match = string.match(rgba)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = parseInt(match[i + 1]);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(per)) {
	      for (var i = 0; i < rgb.length; i++) {
	         rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
	      }
	      a = parseFloat(match[4]);
	   }
	   else if (match = string.match(keyword)) {
	      if (match[1] == "transparent") {
	         return [0, 0, 0, 0];
	      }
	      rgb = colorNames[match[1]];
	      if (!rgb) {
	         return;
	      }
	   }
	
	   for (var i = 0; i < rgb.length; i++) {
	      rgb[i] = scale(rgb[i], 0, 255);
	   }
	   if (!a && a != 0) {
	      a = 1;
	   }
	   else {
	      a = scale(a, 0, 1);
	   }
	   rgb[3] = a;
	   return rgb;
	}
	
	function getHsla(string) {
	   if (!string) {
	      return;
	   }
	   var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hsl);
	   if (match) {
	      var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          s = scale(parseFloat(match[2]), 0, 100),
	          l = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, s, l, a];
	   }
	}
	
	function getHwb(string) {
	   if (!string) {
	      return;
	   }
	   var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
	   var match = string.match(hwb);
	   if (match) {
	    var alpha = parseFloat(match[4]);
	      var h = scale(parseInt(match[1]), 0, 360),
	          w = scale(parseFloat(match[2]), 0, 100),
	          b = scale(parseFloat(match[3]), 0, 100),
	          a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
	      return [h, w, b, a];
	   }
	}
	
	function getRgb(string) {
	   var rgba = getRgba(string);
	   return rgba && rgba.slice(0, 3);
	}
	
	function getHsl(string) {
	  var hsla = getHsla(string);
	  return hsla && hsla.slice(0, 3);
	}
	
	function getAlpha(string) {
	   var vals = getRgba(string);
	   if (vals) {
	      return vals[3];
	   }
	   else if (vals = getHsla(string)) {
	      return vals[3];
	   }
	   else if (vals = getHwb(string)) {
	      return vals[3];
	   }
	}
	
	// generators
	function hexString(rgb) {
	   return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1])
	              + hexDouble(rgb[2]);
	}
	
	function rgbString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return rgbaString(rgba, alpha);
	   }
	   return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
	}
	
	function rgbaString(rgba, alpha) {
	   if (alpha === undefined) {
	      alpha = (rgba[3] !== undefined ? rgba[3] : 1);
	   }
	   return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2]
	           + ", " + alpha + ")";
	}
	
	function percentString(rgba, alpha) {
	   if (alpha < 1 || (rgba[3] && rgba[3] < 1)) {
	      return percentaString(rgba, alpha);
	   }
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	
	   return "rgb(" + r + "%, " + g + "%, " + b + "%)";
	}
	
	function percentaString(rgba, alpha) {
	   var r = Math.round(rgba[0]/255 * 100),
	       g = Math.round(rgba[1]/255 * 100),
	       b = Math.round(rgba[2]/255 * 100);
	   return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
	}
	
	function hslString(hsla, alpha) {
	   if (alpha < 1 || (hsla[3] && hsla[3] < 1)) {
	      return hslaString(hsla, alpha);
	   }
	   return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
	}
	
	function hslaString(hsla, alpha) {
	   if (alpha === undefined) {
	      alpha = (hsla[3] !== undefined ? hsla[3] : 1);
	   }
	   return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, "
	           + alpha + ")";
	}
	
	// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
	// (hwb have alpha optional & 1 is default value)
	function hwbString(hwb, alpha) {
	   if (alpha === undefined) {
	      alpha = (hwb[3] !== undefined ? hwb[3] : 1);
	   }
	   return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%"
	           + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
	}
	
	function keyword(rgb) {
	  return reverseNames[rgb.slice(0, 3)];
	}
	
	// helpers
	function scale(num, min, max) {
	   return Math.min(Math.max(min, num), max);
	}
	
	function hexDouble(num) {
	  var str = num.toString(16).toUpperCase();
	  return (str.length < 2) ? "0" + str : str;
	}
	
	
	//create a list of reverse color names
	var reverseNames = {};
	for (var name in colorNames) {
	   reverseNames[colorNames[name]] = name;
	}


/***/ },
/* 1856 */
/***/ function(module, exports) {

	/* MIT license */
	
	module.exports = {
	  rgb2hsl: rgb2hsl,
	  rgb2hsv: rgb2hsv,
	  rgb2hwb: rgb2hwb,
	  rgb2cmyk: rgb2cmyk,
	  rgb2keyword: rgb2keyword,
	  rgb2xyz: rgb2xyz,
	  rgb2lab: rgb2lab,
	  rgb2lch: rgb2lch,
	
	  hsl2rgb: hsl2rgb,
	  hsl2hsv: hsl2hsv,
	  hsl2hwb: hsl2hwb,
	  hsl2cmyk: hsl2cmyk,
	  hsl2keyword: hsl2keyword,
	
	  hsv2rgb: hsv2rgb,
	  hsv2hsl: hsv2hsl,
	  hsv2hwb: hsv2hwb,
	  hsv2cmyk: hsv2cmyk,
	  hsv2keyword: hsv2keyword,
	
	  hwb2rgb: hwb2rgb,
	  hwb2hsl: hwb2hsl,
	  hwb2hsv: hwb2hsv,
	  hwb2cmyk: hwb2cmyk,
	  hwb2keyword: hwb2keyword,
	
	  cmyk2rgb: cmyk2rgb,
	  cmyk2hsl: cmyk2hsl,
	  cmyk2hsv: cmyk2hsv,
	  cmyk2hwb: cmyk2hwb,
	  cmyk2keyword: cmyk2keyword,
	
	  keyword2rgb: keyword2rgb,
	  keyword2hsl: keyword2hsl,
	  keyword2hsv: keyword2hsv,
	  keyword2hwb: keyword2hwb,
	  keyword2cmyk: keyword2cmyk,
	  keyword2lab: keyword2lab,
	  keyword2xyz: keyword2xyz,
	
	  xyz2rgb: xyz2rgb,
	  xyz2lab: xyz2lab,
	  xyz2lch: xyz2lch,
	
	  lab2xyz: lab2xyz,
	  lab2rgb: lab2rgb,
	  lab2lch: lab2lch,
	
	  lch2lab: lch2lab,
	  lch2xyz: lch2xyz,
	  lch2rgb: lch2rgb
	}
	
	
	function rgb2hsl(rgb) {
	  var r = rgb[0]/255,
	      g = rgb[1]/255,
	      b = rgb[2]/255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, l;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g)/ delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  l = (min + max) / 2;
	
	  if (max == min)
	    s = 0;
	  else if (l <= 0.5)
	    s = delta / (max + min);
	  else
	    s = delta / (2 - max - min);
	
	  return [h, s * 100, l * 100];
	}
	
	function rgb2hsv(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      delta = max - min,
	      h, s, v;
	
	  if (max == 0)
	    s = 0;
	  else
	    s = (delta/max * 1000)/10;
	
	  if (max == min)
	    h = 0;
	  else if (r == max)
	    h = (g - b) / delta;
	  else if (g == max)
	    h = 2 + (b - r) / delta;
	  else if (b == max)
	    h = 4 + (r - g) / delta;
	
	  h = Math.min(h * 60, 360);
	
	  if (h < 0)
	    h += 360;
	
	  v = ((max / 255) * 1000) / 10;
	
	  return [h, s, v];
	}
	
	function rgb2hwb(rgb) {
	  var r = rgb[0],
	      g = rgb[1],
	      b = rgb[2],
	      h = rgb2hsl(rgb)[0],
	      w = 1/255 * Math.min(r, Math.min(g, b)),
	      b = 1 - 1/255 * Math.max(r, Math.max(g, b));
	
	  return [h, w * 100, b * 100];
	}
	
	function rgb2cmyk(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255,
	      c, m, y, k;
	
	  k = Math.min(1 - r, 1 - g, 1 - b);
	  c = (1 - r - k) / (1 - k) || 0;
	  m = (1 - g - k) / (1 - k) || 0;
	  y = (1 - b - k) / (1 - k) || 0;
	  return [c * 100, m * 100, y * 100, k * 100];
	}
	
	function rgb2keyword(rgb) {
	  return reverseKeywords[JSON.stringify(rgb)];
	}
	
	function rgb2xyz(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  // assume sRGB
	  r = r > 0.04045 ? Math.pow(((r + 0.055) / 1.055), 2.4) : (r / 12.92);
	  g = g > 0.04045 ? Math.pow(((g + 0.055) / 1.055), 2.4) : (g / 12.92);
	  b = b > 0.04045 ? Math.pow(((b + 0.055) / 1.055), 2.4) : (b / 12.92);
	
	  var x = (r * 0.4124) + (g * 0.3576) + (b * 0.1805);
	  var y = (r * 0.2126) + (g * 0.7152) + (b * 0.0722);
	  var z = (r * 0.0193) + (g * 0.1192) + (b * 0.9505);
	
	  return [x * 100, y *100, z * 100];
	}
	
	function rgb2lab(rgb) {
	  var xyz = rgb2xyz(rgb),
	        x = xyz[0],
	        y = xyz[1],
	        z = xyz[2],
	        l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function rgb2lch(args) {
	  return lab2lch(rgb2lab(args));
	}
	
	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	function hsl2hsv(hsl) {
	  var h = hsl[0],
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      sv, v;
	
	  if(l === 0) {
	      // no need to do calc on black
	      // also avoids divide by 0 error
	      return [0, 0, 0];
	  }
	
	  l *= 2;
	  s *= (l <= 1) ? l : 2 - l;
	  v = (l + s) / 2;
	  sv = (2 * s) / (l + s);
	  return [h, sv * 100, v * 100];
	}
	
	function hsl2hwb(args) {
	  return rgb2hwb(hsl2rgb(args));
	}
	
	function hsl2cmyk(args) {
	  return rgb2cmyk(hsl2rgb(args));
	}
	
	function hsl2keyword(args) {
	  return rgb2keyword(hsl2rgb(args));
	}
	
	
	function hsv2rgb(hsv) {
	  var h = hsv[0] / 60,
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      hi = Math.floor(h) % 6;
	
	  var f = h - Math.floor(h),
	      p = 255 * v * (1 - s),
	      q = 255 * v * (1 - (s * f)),
	      t = 255 * v * (1 - (s * (1 - f))),
	      v = 255 * v;
	
	  switch(hi) {
	    case 0:
	      return [v, t, p];
	    case 1:
	      return [q, v, p];
	    case 2:
	      return [p, v, t];
	    case 3:
	      return [p, q, v];
	    case 4:
	      return [t, p, v];
	    case 5:
	      return [v, p, q];
	  }
	}
	
	function hsv2hsl(hsv) {
	  var h = hsv[0],
	      s = hsv[1] / 100,
	      v = hsv[2] / 100,
	      sl, l;
	
	  l = (2 - s) * v;
	  sl = s * v;
	  sl /= (l <= 1) ? l : 2 - l;
	  sl = sl || 0;
	  l /= 2;
	  return [h, sl * 100, l * 100];
	}
	
	function hsv2hwb(args) {
	  return rgb2hwb(hsv2rgb(args))
	}
	
	function hsv2cmyk(args) {
	  return rgb2cmyk(hsv2rgb(args));
	}
	
	function hsv2keyword(args) {
	  return rgb2keyword(hsv2rgb(args));
	}
	
	// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
	function hwb2rgb(hwb) {
	  var h = hwb[0] / 360,
	      wh = hwb[1] / 100,
	      bl = hwb[2] / 100,
	      ratio = wh + bl,
	      i, v, f, n;
	
	  // wh + bl cant be > 1
	  if (ratio > 1) {
	    wh /= ratio;
	    bl /= ratio;
	  }
	
	  i = Math.floor(6 * h);
	  v = 1 - bl;
	  f = 6 * h - i;
	  if ((i & 0x01) != 0) {
	    f = 1 - f;
	  }
	  n = wh + f * (v - wh);  // linear interpolation
	
	  switch (i) {
	    default:
	    case 6:
	    case 0: r = v; g = n; b = wh; break;
	    case 1: r = n; g = v; b = wh; break;
	    case 2: r = wh; g = v; b = n; break;
	    case 3: r = wh; g = n; b = v; break;
	    case 4: r = n; g = wh; b = v; break;
	    case 5: r = v; g = wh; b = n; break;
	  }
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function hwb2hsl(args) {
	  return rgb2hsl(hwb2rgb(args));
	}
	
	function hwb2hsv(args) {
	  return rgb2hsv(hwb2rgb(args));
	}
	
	function hwb2cmyk(args) {
	  return rgb2cmyk(hwb2rgb(args));
	}
	
	function hwb2keyword(args) {
	  return rgb2keyword(hwb2rgb(args));
	}
	
	function cmyk2rgb(cmyk) {
	  var c = cmyk[0] / 100,
	      m = cmyk[1] / 100,
	      y = cmyk[2] / 100,
	      k = cmyk[3] / 100,
	      r, g, b;
	
	  r = 1 - Math.min(1, c * (1 - k) + k);
	  g = 1 - Math.min(1, m * (1 - k) + k);
	  b = 1 - Math.min(1, y * (1 - k) + k);
	  return [r * 255, g * 255, b * 255];
	}
	
	function cmyk2hsl(args) {
	  return rgb2hsl(cmyk2rgb(args));
	}
	
	function cmyk2hsv(args) {
	  return rgb2hsv(cmyk2rgb(args));
	}
	
	function cmyk2hwb(args) {
	  return rgb2hwb(cmyk2rgb(args));
	}
	
	function cmyk2keyword(args) {
	  return rgb2keyword(cmyk2rgb(args));
	}
	
	
	function xyz2rgb(xyz) {
	  var x = xyz[0] / 100,
	      y = xyz[1] / 100,
	      z = xyz[2] / 100,
	      r, g, b;
	
	  r = (x * 3.2406) + (y * -1.5372) + (z * -0.4986);
	  g = (x * -0.9689) + (y * 1.8758) + (z * 0.0415);
	  b = (x * 0.0557) + (y * -0.2040) + (z * 1.0570);
	
	  // assume sRGB
	  r = r > 0.0031308 ? ((1.055 * Math.pow(r, 1.0 / 2.4)) - 0.055)
	    : r = (r * 12.92);
	
	  g = g > 0.0031308 ? ((1.055 * Math.pow(g, 1.0 / 2.4)) - 0.055)
	    : g = (g * 12.92);
	
	  b = b > 0.0031308 ? ((1.055 * Math.pow(b, 1.0 / 2.4)) - 0.055)
	    : b = (b * 12.92);
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function xyz2lab(xyz) {
	  var x = xyz[0],
	      y = xyz[1],
	      z = xyz[2],
	      l, a, b;
	
	  x /= 95.047;
	  y /= 100;
	  z /= 108.883;
	
	  x = x > 0.008856 ? Math.pow(x, 1/3) : (7.787 * x) + (16 / 116);
	  y = y > 0.008856 ? Math.pow(y, 1/3) : (7.787 * y) + (16 / 116);
	  z = z > 0.008856 ? Math.pow(z, 1/3) : (7.787 * z) + (16 / 116);
	
	  l = (116 * y) - 16;
	  a = 500 * (x - y);
	  b = 200 * (y - z);
	
	  return [l, a, b];
	}
	
	function xyz2lch(args) {
	  return lab2lch(xyz2lab(args));
	}
	
	function lab2xyz(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      x, y, z, y2;
	
	  if (l <= 8) {
	    y = (l * 100) / 903.3;
	    y2 = (7.787 * (y / 100)) + (16 / 116);
	  } else {
	    y = 100 * Math.pow((l + 16) / 116, 3);
	    y2 = Math.pow(y / 100, 1/3);
	  }
	
	  x = x / 95.047 <= 0.008856 ? x = (95.047 * ((a / 500) + y2 - (16 / 116))) / 7.787 : 95.047 * Math.pow((a / 500) + y2, 3);
	
	  z = z / 108.883 <= 0.008859 ? z = (108.883 * (y2 - (b / 200) - (16 / 116))) / 7.787 : 108.883 * Math.pow(y2 - (b / 200), 3);
	
	  return [x, y, z];
	}
	
	function lab2lch(lab) {
	  var l = lab[0],
	      a = lab[1],
	      b = lab[2],
	      hr, h, c;
	
	  hr = Math.atan2(b, a);
	  h = hr * 360 / 2 / Math.PI;
	  if (h < 0) {
	    h += 360;
	  }
	  c = Math.sqrt(a * a + b * b);
	  return [l, c, h];
	}
	
	function lab2rgb(args) {
	  return xyz2rgb(lab2xyz(args));
	}
	
	function lch2lab(lch) {
	  var l = lch[0],
	      c = lch[1],
	      h = lch[2],
	      a, b, hr;
	
	  hr = h / 360 * 2 * Math.PI;
	  a = c * Math.cos(hr);
	  b = c * Math.sin(hr);
	  return [l, a, b];
	}
	
	function lch2xyz(args) {
	  return lab2xyz(lch2lab(args));
	}
	
	function lch2rgb(args) {
	  return lab2rgb(lch2lab(args));
	}
	
	function keyword2rgb(keyword) {
	  return cssKeywords[keyword];
	}
	
	function keyword2hsl(args) {
	  return rgb2hsl(keyword2rgb(args));
	}
	
	function keyword2hsv(args) {
	  return rgb2hsv(keyword2rgb(args));
	}
	
	function keyword2hwb(args) {
	  return rgb2hwb(keyword2rgb(args));
	}
	
	function keyword2cmyk(args) {
	  return rgb2cmyk(keyword2rgb(args));
	}
	
	function keyword2lab(args) {
	  return rgb2lab(keyword2rgb(args));
	}
	
	function keyword2xyz(args) {
	  return rgb2xyz(keyword2rgb(args));
	}
	
	var cssKeywords = {
	  aliceblue:  [240,248,255],
	  antiquewhite: [250,235,215],
	  aqua: [0,255,255],
	  aquamarine: [127,255,212],
	  azure:  [240,255,255],
	  beige:  [245,245,220],
	  bisque: [255,228,196],
	  black:  [0,0,0],
	  blanchedalmond: [255,235,205],
	  blue: [0,0,255],
	  blueviolet: [138,43,226],
	  brown:  [165,42,42],
	  burlywood:  [222,184,135],
	  cadetblue:  [95,158,160],
	  chartreuse: [127,255,0],
	  chocolate:  [210,105,30],
	  coral:  [255,127,80],
	  cornflowerblue: [100,149,237],
	  cornsilk: [255,248,220],
	  crimson:  [220,20,60],
	  cyan: [0,255,255],
	  darkblue: [0,0,139],
	  darkcyan: [0,139,139],
	  darkgoldenrod:  [184,134,11],
	  darkgray: [169,169,169],
	  darkgreen:  [0,100,0],
	  darkgrey: [169,169,169],
	  darkkhaki:  [189,183,107],
	  darkmagenta:  [139,0,139],
	  darkolivegreen: [85,107,47],
	  darkorange: [255,140,0],
	  darkorchid: [153,50,204],
	  darkred:  [139,0,0],
	  darksalmon: [233,150,122],
	  darkseagreen: [143,188,143],
	  darkslateblue:  [72,61,139],
	  darkslategray:  [47,79,79],
	  darkslategrey:  [47,79,79],
	  darkturquoise:  [0,206,209],
	  darkviolet: [148,0,211],
	  deeppink: [255,20,147],
	  deepskyblue:  [0,191,255],
	  dimgray:  [105,105,105],
	  dimgrey:  [105,105,105],
	  dodgerblue: [30,144,255],
	  firebrick:  [178,34,34],
	  floralwhite:  [255,250,240],
	  forestgreen:  [34,139,34],
	  fuchsia:  [255,0,255],
	  gainsboro:  [220,220,220],
	  ghostwhite: [248,248,255],
	  gold: [255,215,0],
	  goldenrod:  [218,165,32],
	  gray: [128,128,128],
	  green:  [0,128,0],
	  greenyellow:  [173,255,47],
	  grey: [128,128,128],
	  honeydew: [240,255,240],
	  hotpink:  [255,105,180],
	  indianred:  [205,92,92],
	  indigo: [75,0,130],
	  ivory:  [255,255,240],
	  khaki:  [240,230,140],
	  lavender: [230,230,250],
	  lavenderblush:  [255,240,245],
	  lawngreen:  [124,252,0],
	  lemonchiffon: [255,250,205],
	  lightblue:  [173,216,230],
	  lightcoral: [240,128,128],
	  lightcyan:  [224,255,255],
	  lightgoldenrodyellow: [250,250,210],
	  lightgray:  [211,211,211],
	  lightgreen: [144,238,144],
	  lightgrey:  [211,211,211],
	  lightpink:  [255,182,193],
	  lightsalmon:  [255,160,122],
	  lightseagreen:  [32,178,170],
	  lightskyblue: [135,206,250],
	  lightslategray: [119,136,153],
	  lightslategrey: [119,136,153],
	  lightsteelblue: [176,196,222],
	  lightyellow:  [255,255,224],
	  lime: [0,255,0],
	  limegreen:  [50,205,50],
	  linen:  [250,240,230],
	  magenta:  [255,0,255],
	  maroon: [128,0,0],
	  mediumaquamarine: [102,205,170],
	  mediumblue: [0,0,205],
	  mediumorchid: [186,85,211],
	  mediumpurple: [147,112,219],
	  mediumseagreen: [60,179,113],
	  mediumslateblue:  [123,104,238],
	  mediumspringgreen:  [0,250,154],
	  mediumturquoise:  [72,209,204],
	  mediumvioletred:  [199,21,133],
	  midnightblue: [25,25,112],
	  mintcream:  [245,255,250],
	  mistyrose:  [255,228,225],
	  moccasin: [255,228,181],
	  navajowhite:  [255,222,173],
	  navy: [0,0,128],
	  oldlace:  [253,245,230],
	  olive:  [128,128,0],
	  olivedrab:  [107,142,35],
	  orange: [255,165,0],
	  orangered:  [255,69,0],
	  orchid: [218,112,214],
	  palegoldenrod:  [238,232,170],
	  palegreen:  [152,251,152],
	  paleturquoise:  [175,238,238],
	  palevioletred:  [219,112,147],
	  papayawhip: [255,239,213],
	  peachpuff:  [255,218,185],
	  peru: [205,133,63],
	  pink: [255,192,203],
	  plum: [221,160,221],
	  powderblue: [176,224,230],
	  purple: [128,0,128],
	  rebeccapurple: [102, 51, 153],
	  red:  [255,0,0],
	  rosybrown:  [188,143,143],
	  royalblue:  [65,105,225],
	  saddlebrown:  [139,69,19],
	  salmon: [250,128,114],
	  sandybrown: [244,164,96],
	  seagreen: [46,139,87],
	  seashell: [255,245,238],
	  sienna: [160,82,45],
	  silver: [192,192,192],
	  skyblue:  [135,206,235],
	  slateblue:  [106,90,205],
	  slategray:  [112,128,144],
	  slategrey:  [112,128,144],
	  snow: [255,250,250],
	  springgreen:  [0,255,127],
	  steelblue:  [70,130,180],
	  tan:  [210,180,140],
	  teal: [0,128,128],
	  thistle:  [216,191,216],
	  tomato: [255,99,71],
	  turquoise:  [64,224,208],
	  violet: [238,130,238],
	  wheat:  [245,222,179],
	  white:  [255,255,255],
	  whitesmoke: [245,245,245],
	  yellow: [255,255,0],
	  yellowgreen:  [154,205,50]
	};
	
	var reverseKeywords = {};
	for (var key in cssKeywords) {
	  reverseKeywords[JSON.stringify(cssKeywords[key])] = key;
	}


/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	var conversions = __webpack_require__(1856);
	
	var convert = function() {
	   return new Converter();
	}
	
	for (var func in conversions) {
	  // export Raw versions
	  convert[func + "Raw"] =  (function(func) {
	    // accept array or plain args
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      return conversions[func](arg);
	    }
	  })(func);
	
	  var pair = /(\w+)2(\w+)/.exec(func),
	      from = pair[1],
	      to = pair[2];
	
	  // export rgb2hsl and ["rgb"]["hsl"]
	  convert[from] = convert[from] || {};
	
	  convert[from][to] = convert[func] = (function(func) { 
	    return function(arg) {
	      if (typeof arg == "number")
	        arg = Array.prototype.slice.call(arguments);
	      
	      var val = conversions[func](arg);
	      if (typeof val == "string" || val === undefined)
	        return val; // keyword
	
	      for (var i = 0; i < val.length; i++)
	        val[i] = Math.round(val[i]);
	      return val;
	    }
	  })(func);
	}
	
	
	/* Converter does lazy conversion and caching */
	var Converter = function() {
	   this.convs = {};
	};
	
	/* Either get the values for a space or
	  set the values for a space, depending on args */
	Converter.prototype.routeSpace = function(space, args) {
	   var values = args[0];
	   if (values === undefined) {
	      // color.rgb()
	      return this.getValues(space);
	   }
	   // color.rgb(10, 10, 10)
	   if (typeof values == "number") {
	      values = Array.prototype.slice.call(args);        
	   }
	
	   return this.setValues(space, values);
	};
	  
	/* Set the values for a space, invalidating cache */
	Converter.prototype.setValues = function(space, values) {
	   this.space = space;
	   this.convs = {};
	   this.convs[space] = values;
	   return this;
	};
	
	/* Get the values for a space. If there's already
	  a conversion for the space, fetch it, otherwise
	  compute it */
	Converter.prototype.getValues = function(space) {
	   var vals = this.convs[space];
	   if (!vals) {
	      var fspace = this.space,
	          from = this.convs[fspace];
	      vals = convert[fspace][space](from);
	
	      this.convs[space] = vals;
	   }
	  return vals;
	};
	
	["rgb", "hsl", "hsv", "cmyk", "keyword"].forEach(function(space) {
	   Converter.prototype[space] = function(vals) {
	      return this.routeSpace(space, arguments);
	   }
	});
	
	module.exports = convert;

/***/ },
/* 1858 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = {
		"aliceblue": [240, 248, 255],
		"antiquewhite": [250, 235, 215],
		"aqua": [0, 255, 255],
		"aquamarine": [127, 255, 212],
		"azure": [240, 255, 255],
		"beige": [245, 245, 220],
		"bisque": [255, 228, 196],
		"black": [0, 0, 0],
		"blanchedalmond": [255, 235, 205],
		"blue": [0, 0, 255],
		"blueviolet": [138, 43, 226],
		"brown": [165, 42, 42],
		"burlywood": [222, 184, 135],
		"cadetblue": [95, 158, 160],
		"chartreuse": [127, 255, 0],
		"chocolate": [210, 105, 30],
		"coral": [255, 127, 80],
		"cornflowerblue": [100, 149, 237],
		"cornsilk": [255, 248, 220],
		"crimson": [220, 20, 60],
		"cyan": [0, 255, 255],
		"darkblue": [0, 0, 139],
		"darkcyan": [0, 139, 139],
		"darkgoldenrod": [184, 134, 11],
		"darkgray": [169, 169, 169],
		"darkgreen": [0, 100, 0],
		"darkgrey": [169, 169, 169],
		"darkkhaki": [189, 183, 107],
		"darkmagenta": [139, 0, 139],
		"darkolivegreen": [85, 107, 47],
		"darkorange": [255, 140, 0],
		"darkorchid": [153, 50, 204],
		"darkred": [139, 0, 0],
		"darksalmon": [233, 150, 122],
		"darkseagreen": [143, 188, 143],
		"darkslateblue": [72, 61, 139],
		"darkslategray": [47, 79, 79],
		"darkslategrey": [47, 79, 79],
		"darkturquoise": [0, 206, 209],
		"darkviolet": [148, 0, 211],
		"deeppink": [255, 20, 147],
		"deepskyblue": [0, 191, 255],
		"dimgray": [105, 105, 105],
		"dimgrey": [105, 105, 105],
		"dodgerblue": [30, 144, 255],
		"firebrick": [178, 34, 34],
		"floralwhite": [255, 250, 240],
		"forestgreen": [34, 139, 34],
		"fuchsia": [255, 0, 255],
		"gainsboro": [220, 220, 220],
		"ghostwhite": [248, 248, 255],
		"gold": [255, 215, 0],
		"goldenrod": [218, 165, 32],
		"gray": [128, 128, 128],
		"green": [0, 128, 0],
		"greenyellow": [173, 255, 47],
		"grey": [128, 128, 128],
		"honeydew": [240, 255, 240],
		"hotpink": [255, 105, 180],
		"indianred": [205, 92, 92],
		"indigo": [75, 0, 130],
		"ivory": [255, 255, 240],
		"khaki": [240, 230, 140],
		"lavender": [230, 230, 250],
		"lavenderblush": [255, 240, 245],
		"lawngreen": [124, 252, 0],
		"lemonchiffon": [255, 250, 205],
		"lightblue": [173, 216, 230],
		"lightcoral": [240, 128, 128],
		"lightcyan": [224, 255, 255],
		"lightgoldenrodyellow": [250, 250, 210],
		"lightgray": [211, 211, 211],
		"lightgreen": [144, 238, 144],
		"lightgrey": [211, 211, 211],
		"lightpink": [255, 182, 193],
		"lightsalmon": [255, 160, 122],
		"lightseagreen": [32, 178, 170],
		"lightskyblue": [135, 206, 250],
		"lightslategray": [119, 136, 153],
		"lightslategrey": [119, 136, 153],
		"lightsteelblue": [176, 196, 222],
		"lightyellow": [255, 255, 224],
		"lime": [0, 255, 0],
		"limegreen": [50, 205, 50],
		"linen": [250, 240, 230],
		"magenta": [255, 0, 255],
		"maroon": [128, 0, 0],
		"mediumaquamarine": [102, 205, 170],
		"mediumblue": [0, 0, 205],
		"mediumorchid": [186, 85, 211],
		"mediumpurple": [147, 112, 219],
		"mediumseagreen": [60, 179, 113],
		"mediumslateblue": [123, 104, 238],
		"mediumspringgreen": [0, 250, 154],
		"mediumturquoise": [72, 209, 204],
		"mediumvioletred": [199, 21, 133],
		"midnightblue": [25, 25, 112],
		"mintcream": [245, 255, 250],
		"mistyrose": [255, 228, 225],
		"moccasin": [255, 228, 181],
		"navajowhite": [255, 222, 173],
		"navy": [0, 0, 128],
		"oldlace": [253, 245, 230],
		"olive": [128, 128, 0],
		"olivedrab": [107, 142, 35],
		"orange": [255, 165, 0],
		"orangered": [255, 69, 0],
		"orchid": [218, 112, 214],
		"palegoldenrod": [238, 232, 170],
		"palegreen": [152, 251, 152],
		"paleturquoise": [175, 238, 238],
		"palevioletred": [219, 112, 147],
		"papayawhip": [255, 239, 213],
		"peachpuff": [255, 218, 185],
		"peru": [205, 133, 63],
		"pink": [255, 192, 203],
		"plum": [221, 160, 221],
		"powderblue": [176, 224, 230],
		"purple": [128, 0, 128],
		"rebeccapurple": [102, 51, 153],
		"red": [255, 0, 0],
		"rosybrown": [188, 143, 143],
		"royalblue": [65, 105, 225],
		"saddlebrown": [139, 69, 19],
		"salmon": [250, 128, 114],
		"sandybrown": [244, 164, 96],
		"seagreen": [46, 139, 87],
		"seashell": [255, 245, 238],
		"sienna": [160, 82, 45],
		"silver": [192, 192, 192],
		"skyblue": [135, 206, 235],
		"slateblue": [106, 90, 205],
		"slategray": [112, 128, 144],
		"slategrey": [112, 128, 144],
		"snow": [255, 250, 250],
		"springgreen": [0, 255, 127],
		"steelblue": [70, 130, 180],
		"tan": [210, 180, 140],
		"teal": [0, 128, 128],
		"thistle": [216, 191, 216],
		"tomato": [255, 99, 71],
		"turquoise": [64, 224, 208],
		"violet": [238, 130, 238],
		"wheat": [245, 222, 179],
		"white": [255, 255, 255],
		"whitesmoke": [245, 245, 245],
		"yellow": [255, 255, 0],
		"yellowgreen": [154, 205, 50]
	};


/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ },
/* 1860 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(1863);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	          this.events[key].nextHandlers = this.events[key].handlers;
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var eventHandlers = this.getEventHandlers(eventName, options);
	        eventHandlers.handlers = eventHandlers.nextHandlers;
	        eventHandlers.handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.nextHandlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            ensureCanMutateNextEventHandlers(eventHandlers);
	            var index = eventHandlers.nextHandlers.indexOf(listener);
	            eventHandlers.nextHandlers.splice(index, 1);
	
	            if (eventHandlers.nextHandlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ },
/* 1861 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(1861);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ },
/* 1863 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(1862);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ },
/* 1865 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	/**
	 * Returns an array of hexadecimal string colors.
	 */
	var coolorsToHex = function coolorsToHex(url) {
	  return url.replace(/^.+\/([^/]+)$/, '$1').split('-').map(function (hex) {
	    return '#' + hex;
	  });
	};
	
	exports.default = coolorsToHex;

/***/ },
/* 1866 */
[3448, 1865],
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(897)
	
	var zeroBuffer = new Buffer(128)
	zeroBuffer.fill(0)
	
	module.exports = Hmac
	
	function Hmac (alg, key) {
	  if(!(this instanceof Hmac)) return new Hmac(alg, key)
	  this._opad = opad
	  this._alg = alg
	
	  var blocksize = (alg === 'sha512') ? 128 : 64
	
	  key = this._key = !Buffer.isBuffer(key) ? new Buffer(key) : key
	
	  if(key.length > blocksize) {
	    key = createHash(alg).update(key).digest()
	  } else if(key.length < blocksize) {
	    key = Buffer.concat([key, zeroBuffer], blocksize)
	  }
	
	  var ipad = this._ipad = new Buffer(blocksize)
	  var opad = this._opad = new Buffer(blocksize)
	
	  for(var i = 0; i < blocksize; i++) {
	    ipad[i] = key[i] ^ 0x36
	    opad[i] = key[i] ^ 0x5C
	  }
	
	  this._hash = createHash(alg).update(ipad)
	}
	
	Hmac.prototype.update = function (data, enc) {
	  this._hash.update(data, enc)
	  return this
	}
	
	Hmac.prototype.digest = function (enc) {
	  var h = this._hash.digest()
	  return createHash(this._alg).update(this._opad).update(h).digest(enc)
	}
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var intSize = 4;
	var zeroBuffer = new Buffer(intSize); zeroBuffer.fill(0);
	var chrsz = 8;
	
	function toArray(buf, bigEndian) {
	  if ((buf.length % intSize) !== 0) {
	    var len = buf.length + (intSize - (buf.length % intSize));
	    buf = Buffer.concat([buf, zeroBuffer], len);
	  }
	
	  var arr = [];
	  var fn = bigEndian ? buf.readInt32BE : buf.readInt32LE;
	  for (var i = 0; i < buf.length; i += intSize) {
	    arr.push(fn.call(buf, i));
	  }
	  return arr;
	}
	
	function toBuffer(arr, size, bigEndian) {
	  var buf = new Buffer(size);
	  var fn = bigEndian ? buf.writeInt32BE : buf.writeInt32LE;
	  for (var i = 0; i < arr.length; i++) {
	    fn.call(buf, arr[i], i * 4, true);
	  }
	  return buf;
	}
	
	function hash(buf, fn, hashSize, bigEndian) {
	  if (!Buffer.isBuffer(buf)) buf = new Buffer(buf);
	  var arr = fn(toArray(buf, bigEndian), buf.length * chrsz);
	  return toBuffer(arr, hashSize, bigEndian);
	}
	
	module.exports = { hash: hash };
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {var rng = __webpack_require__(1872)
	
	function error () {
	  var m = [].slice.call(arguments).join(' ')
	  throw new Error([
	    m,
	    'we accept pull requests',
	    'http://github.com/dominictarr/crypto-browserify'
	    ].join('\n'))
	}
	
	exports.createHash = __webpack_require__(897)
	
	exports.createHmac = __webpack_require__(1867)
	
	exports.randomBytes = function(size, callback) {
	  if (callback && callback.call) {
	    try {
	      callback.call(this, undefined, new Buffer(rng(size)))
	    } catch (err) { callback(err) }
	  } else {
	    return new Buffer(rng(size))
	  }
	}
	
	function each(a, f) {
	  for(var i in a)
	    f(a[i], i)
	}
	
	exports.getHashes = function () {
	  return ['sha1', 'sha256', 'sha512', 'md5', 'rmd160']
	}
	
	var p = __webpack_require__(1871)(exports)
	exports.pbkdf2 = p.pbkdf2
	exports.pbkdf2Sync = p.pbkdf2Sync
	__webpack_require__(1809)(exports, module.exports);
	
	// the least I can do is make error messages for the rest of the node.js/crypto api.
	each(['createCredentials'
	, 'createSign'
	, 'createVerify'
	, 'createDiffieHellman'
	], function (name) {
	  exports[name] = function () {
	    error('sorry,', name, 'is not implemented yet')
	  }
	})
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 1870 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.1 Copyright (C) Paul Johnston 1999 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	var helpers = __webpack_require__(1868);
	
	/*
	 * Calculate the MD5 of an array of little-endian words, and a bit length
	 */
	function core_md5(x, len)
	{
	  /* append padding */
	  x[len >> 5] |= 0x80 << ((len) % 32);
	  x[(((len + 64) >>> 9) << 4) + 14] = len;
	
	  var a =  1732584193;
	  var b = -271733879;
	  var c = -1732584194;
	  var d =  271733878;
	
	  for(var i = 0; i < x.length; i += 16)
	  {
	    var olda = a;
	    var oldb = b;
	    var oldc = c;
	    var oldd = d;
	
	    a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
	    d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
	    c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
	    b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
	    a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
	    d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
	    c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
	    b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
	    a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
	    d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
	    c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
	    b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
	    a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
	    d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
	    c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
	    b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
	
	    a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
	    d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
	    c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
	    b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
	    a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
	    d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
	    c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
	    b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
	    a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
	    d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
	    c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
	    b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
	    a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
	    d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
	    c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
	    b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
	
	    a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
	    d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
	    c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
	    b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
	    a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
	    d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
	    c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
	    b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
	    a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
	    d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
	    c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
	    b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
	    a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
	    d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
	    c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
	    b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
	
	    a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
	    d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
	    c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
	    b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
	    a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
	    d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
	    c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
	    b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
	    a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
	    d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
	    c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
	    b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
	    a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
	    d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
	    c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
	    b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
	
	    a = safe_add(a, olda);
	    b = safe_add(b, oldb);
	    c = safe_add(c, oldc);
	    d = safe_add(d, oldd);
	  }
	  return Array(a, b, c, d);
	
	}
	
	/*
	 * These functions implement the four basic operations the algorithm uses.
	 */
	function md5_cmn(q, a, b, x, s, t)
	{
	  return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s),b);
	}
	function md5_ff(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
	}
	function md5_gg(a, b, c, d, x, s, t)
	{
	  return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
	}
	function md5_hh(a, b, c, d, x, s, t)
	{
	  return md5_cmn(b ^ c ^ d, a, b, x, s, t);
	}
	function md5_ii(a, b, c, d, x, s, t)
	{
	  return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
	}
	
	/*
	 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	 * to work around bugs in some JS interpreters.
	 */
	function safe_add(x, y)
	{
	  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  return (msw << 16) | (lsw & 0xFFFF);
	}
	
	/*
	 * Bitwise rotate a 32-bit number to the left.
	 */
	function bit_rol(num, cnt)
	{
	  return (num << cnt) | (num >>> (32 - cnt));
	}
	
	module.exports = function md5(buf) {
	  return helpers.hash(buf, core_md5, 16);
	};


/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	var pbkdf2Export = __webpack_require__(2477)
	
	module.exports = function (crypto, exports) {
	  exports = exports || {}
	
	  var exported = pbkdf2Export(crypto)
	
	  exports.pbkdf2 = exported.pbkdf2
	  exports.pbkdf2Sync = exported.pbkdf2Sync
	
	  return exports
	}


/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer) {(function() {
	  var g = ('undefined' === typeof window ? global : window) || {}
	  _crypto = (
	    g.crypto || g.msCrypto || __webpack_require__(3329)
	  )
	  module.exports = function(size) {
	    // Modern Browsers
	    if(_crypto.getRandomValues) {
	      var bytes = new Buffer(size); //in browserify, this is an extended Uint8Array
	      /* This will not work in older browsers.
	       * See https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
	       */
	    
	      _crypto.getRandomValues(bytes);
	      return bytes;
	    }
	    else if (_crypto.randomBytes) {
	      return _crypto.randomBytes(size)
	    }
	    else
	      throw new Error(
	        'secure random number generation not supported by this browser\n'+
	        'use chrome, FireFox or Internet Explorer 11'
	      )
	  }
	}())
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(28).Buffer))

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(1873));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ },
/* 1875 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	      var baseEvents = EVENT_NAME_MAP[baseEventName];
	      for (var styleName in baseEvents) {
	        if (styleName in style) {
	          endEvents.push(baseEvents[styleName]);
	          break;
	        }
	      }
	    }
	  }
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	
	  endEvents: endEvents,
	
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-contour/ Version 1.1.2. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(147)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	var array = Array.prototype;
	
	var slice = array.slice;
	
	var ascending = function(a, b) {
	  return a - b;
	};
	
	var area = function(ring) {
	  var i = 0, n = ring.length, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
	  while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
	  return area;
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var contains = function(ring, hole) {
	  var i = -1, n = hole.length, c;
	  while (++i < n) if (c = ringContains(ring, hole[i])) return c;
	  return 0;
	};
	
	function ringContains(ring, point) {
	  var x = point[0], y = point[1], contains = -1;
	  for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
	    var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
	    if (segmentContains(pi, pj, point)) return 0;
	    if (((yi > y) !== (yj > y)) && ((x < (xj - xi) * (y - yi) / (yj - yi) + xi))) contains = -contains;
	  }
	  return contains;
	}
	
	function segmentContains(a, b, c) {
	  var i; return collinear(a, b, c) && within(a[i = +(a[0] === b[0])], c[i], b[i]);
	}
	
	function collinear(a, b, c) {
	  return (b[0] - a[0]) * (c[1] - a[1]) === (c[0] - a[0]) * (b[1] - a[1]);
	}
	
	function within(p, q, r) {
	  return p <= q && q <= r || r <= q && q <= p;
	}
	
	var noop = function() {};
	
	var cases = [
	  [],
	  [[[1.0, 1.5], [0.5, 1.0]]],
	  [[[1.5, 1.0], [1.0, 1.5]]],
	  [[[1.5, 1.0], [0.5, 1.0]]],
	  [[[1.0, 0.5], [1.5, 1.0]]],
	  [[[1.0, 1.5], [0.5, 1.0]], [[1.0, 0.5], [1.5, 1.0]]],
	  [[[1.0, 0.5], [1.0, 1.5]]],
	  [[[1.0, 0.5], [0.5, 1.0]]],
	  [[[0.5, 1.0], [1.0, 0.5]]],
	  [[[1.0, 1.5], [1.0, 0.5]]],
	  [[[0.5, 1.0], [1.0, 0.5]], [[1.5, 1.0], [1.0, 1.5]]],
	  [[[1.5, 1.0], [1.0, 0.5]]],
	  [[[0.5, 1.0], [1.5, 1.0]]],
	  [[[1.0, 1.5], [1.5, 1.0]]],
	  [[[0.5, 1.0], [1.0, 1.5]]],
	  []
	];
	
	var contours = function() {
	  var dx = 1,
	      dy = 1,
	      threshold = d3Array.thresholdSturges,
	      smooth = smoothLinear;
	
	  function contours(values) {
	    var tz = threshold(values);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      var domain = d3Array.extent(values), start = domain[0], stop = domain[1];
	      tz = d3Array.tickStep(start, stop, tz);
	      tz = d3Array.range(Math.floor(start / tz) * tz, Math.floor(stop / tz) * tz, tz);
	    } else {
	      tz = tz.slice().sort(ascending);
	    }
	
	    // Accumulate, smooth contour rings, assign holes to exterior rings.
	    // Based on https://github.com/mbostock/shapefile/blob/v0.6.2/shp/polygon.js
	    var layers = tz.map(function(value) {
	      var polygons = [],
	          holes = [];
	
	      isorings(values, value, function(ring) {
	        smooth(ring, values, value);
	        if (area(ring) > 0) polygons.push([ring]);
	        else holes.push(ring);
	      });
	
	      holes.forEach(function(hole) {
	        for (var i = 0, n = polygons.length, polygon; i < n; ++i) {
	          if (contains((polygon = polygons[i])[0], hole) !== -1) {
	            polygon.push(hole);
	            return;
	          }
	        }
	      });
	
	      return polygons;
	    });
	
	    return layers.map(function(polygons, i) {
	      return {
	        type: "MultiPolygon",
	        value: tz[i],
	        coordinates: polygons
	      };
	    });
	  }
	
	  // Marching squares with isolines stitched into rings.
	  // Based on https://github.com/topojson/topojson-client/blob/v3.0.0/src/stitch.js
	  function isorings(values, value, callback) {
	    var fragmentByStart = new Array,
	        fragmentByEnd = new Array,
	        x, y, t0, t1, t2, t3;
	
	    // Special case for the first row (y = -1, t2 = t3 = 0).
	    x = y = -1;
	    t1 = values[0] >= value;
	    cases[t1 << 1].forEach(stitch);
	    while (++x < dx - 1) {
	      t0 = t1, t1 = values[x + 1] >= value;
	      cases[t0 | t1 << 1].forEach(stitch);
	    }
	    cases[t1 << 0].forEach(stitch);
	
	    // General case for the intermediate rows.
	    while (++y < dy - 1) {
	      x = -1;
	      t1 = values[y * dx + dx] >= value;
	      t2 = values[y * dx] >= value;
	      cases[t1 << 1 | t2 << 2].forEach(stitch);
	      while (++x < dx - 1) {
	        t0 = t1, t1 = values[y * dx + dx + x + 1] >= value;
	        t3 = t2, t2 = values[y * dx + x + 1] >= value;
	        cases[t0 | t1 << 1 | t2 << 2 | t3 << 3].forEach(stitch);
	      }
	      cases[t1 | t2 << 3].forEach(stitch);
	    }
	
	    // Special case for the last row (y = dy - 1, t0 = t1 = 0).
	    x = -1;
	    t2 = values[y * dx] >= value;
	    cases[t2 << 2].forEach(stitch);
	    while (++x < dx - 1) {
	      t3 = t2, t2 = values[y * dx + x + 1] >= value;
	      cases[t2 << 2 | t3 << 3].forEach(stitch);
	    }
	    cases[t2 << 3].forEach(stitch);
	
	    function stitch(line) {
	      var start = [line[0][0] + x, line[0][1] + y],
	          end = [line[1][0] + x, line[1][1] + y],
	          startIndex = index(start),
	          endIndex = index(end),
	          f, g;
	      if (f = fragmentByEnd[startIndex]) {
	        if (g = fragmentByStart[endIndex]) {
	          delete fragmentByEnd[f.end];
	          delete fragmentByStart[g.start];
	          if (f === g) {
	            f.ring.push(end);
	            callback(f.ring);
	          } else {
	            fragmentByStart[f.start] = fragmentByEnd[g.end] = {start: f.start, end: g.end, ring: f.ring.concat(g.ring)};
	          }
	        } else {
	          delete fragmentByEnd[f.end];
	          f.ring.push(end);
	          fragmentByEnd[f.end = endIndex] = f;
	        }
	      } else if (f = fragmentByStart[endIndex]) {
	        if (g = fragmentByEnd[startIndex]) {
	          delete fragmentByStart[f.start];
	          delete fragmentByEnd[g.end];
	          if (f === g) {
	            f.ring.push(end);
	            callback(f.ring);
	          } else {
	            fragmentByStart[g.start] = fragmentByEnd[f.end] = {start: g.start, end: f.end, ring: g.ring.concat(f.ring)};
	          }
	        } else {
	          delete fragmentByStart[f.start];
	          f.ring.unshift(start);
	          fragmentByStart[f.start = startIndex] = f;
	        }
	      } else {
	        fragmentByStart[startIndex] = fragmentByEnd[endIndex] = {start: startIndex, end: endIndex, ring: [start, end]};
	      }
	    }
	  }
	
	  function index(point) {
	    return point[0] * 2 + point[1] * (dx + 1) * 4;
	  }
	
	  function smoothLinear(ring, values, value) {
	    ring.forEach(function(point) {
	      var x = point[0],
	          y = point[1],
	          xt = x | 0,
	          yt = y | 0,
	          v0,
	          v1 = values[yt * dx + xt];
	      if (x > 0 && x < dx && xt === x) {
	        v0 = values[yt * dx + xt - 1];
	        point[0] = x + (value - v0) / (v1 - v0) - 0.5;
	      }
	      if (y > 0 && y < dy && yt === y) {
	        v0 = values[(yt - 1) * dx + xt];
	        point[1] = y + (value - v0) / (v1 - v0) - 0.5;
	      }
	    });
	  }
	
	  contours.size = function(_) {
	    if (!arguments.length) return [dx, dy];
	    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
	    if (!(_0 > 0) || !(_1 > 0)) throw new Error("invalid size");
	    return dx = _0, dy = _1, contours;
	  };
	
	  contours.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), contours) : threshold;
	  };
	
	  contours.smooth = function(_) {
	    return arguments.length ? (smooth = _ ? smoothLinear : noop, contours) : smooth === smoothLinear;
	  };
	
	  return contours;
	};
	
	// TODO Optimize edge cases.
	// TODO Optimize index calculation.
	// TODO Optimize arguments.
	function blurX(source, target, r) {
	  var n = source.width,
	      m = source.height,
	      w = (r << 1) + 1;
	  for (var j = 0; j < m; ++j) {
	    for (var i = 0, sr = 0; i < n + r; ++i) {
	      if (i < n) {
	        sr += source.data[i + j * n];
	      }
	      if (i >= r) {
	        if (i >= w) {
	          sr -= source.data[i - w + j * n];
	        }
	        target.data[i - r + j * n] = sr / Math.min(i + 1, n - 1 + w - i, w);
	      }
	    }
	  }
	}
	
	// TODO Optimize edge cases.
	// TODO Optimize index calculation.
	// TODO Optimize arguments.
	function blurY(source, target, r) {
	  var n = source.width,
	      m = source.height,
	      w = (r << 1) + 1;
	  for (var i = 0; i < n; ++i) {
	    for (var j = 0, sr = 0; j < m + r; ++j) {
	      if (j < m) {
	        sr += source.data[i + j * n];
	      }
	      if (j >= r) {
	        if (j >= w) {
	          sr -= source.data[i + (j - w) * n];
	        }
	        target.data[i + (j - r) * n] = sr / Math.min(j + 1, m - 1 + w - j, w);
	      }
	    }
	  }
	}
	
	function defaultX(d) {
	  return d[0];
	}
	
	function defaultY(d) {
	  return d[1];
	}
	
	var density = function() {
	  var x = defaultX,
	      y = defaultY,
	      dx = 960,
	      dy = 500,
	      r = 20, // blur radius
	      k = 2, // log2(grid cell size)
	      o = r * 3, // grid offset, to pad for blur
	      n = (dx + o * 2) >> k, // grid width
	      m = (dy + o * 2) >> k, // grid height
	      threshold = constant(20);
	
	  function density(data) {
	    var values0 = new Float32Array(n * m),
	        values1 = new Float32Array(n * m);
	
	    data.forEach(function(d, i, data) {
	      var xi = (x(d, i, data) + o) >> k,
	          yi = (y(d, i, data) + o) >> k;
	      if (xi >= 0 && xi < n && yi >= 0 && yi < m) {
	        ++values0[xi + yi * n];
	      }
	    });
	
	    // TODO Optimize.
	    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
	    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
	    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
	    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
	    blurX({width: n, height: m, data: values0}, {width: n, height: m, data: values1}, r >> k);
	    blurY({width: n, height: m, data: values1}, {width: n, height: m, data: values0}, r >> k);
	
	    var tz = threshold(values0);
	
	    // Convert number of thresholds into uniform thresholds.
	    if (!Array.isArray(tz)) {
	      var stop = d3Array.max(values0);
	      tz = d3Array.tickStep(0, stop, tz);
	      tz = d3Array.range(0, Math.floor(stop / tz) * tz, tz);
	      tz.shift();
	    }
	
	    return contours()
	        .thresholds(tz)
	        .size([n, m])
	      (values0)
	        .map(transform);
	  }
	
	  function transform(geometry) {
	    geometry.value *= Math.pow(2, -2 * k); // Density in points per square pixel.
	    geometry.coordinates.forEach(transformPolygon);
	    return geometry;
	  }
	
	  function transformPolygon(coordinates) {
	    coordinates.forEach(transformRing);
	  }
	
	  function transformRing(coordinates) {
	    coordinates.forEach(transformPoint);
	  }
	
	  // TODO Optimize.
	  function transformPoint(coordinates) {
	    coordinates[0] = coordinates[0] * Math.pow(2, k) - o;
	    coordinates[1] = coordinates[1] * Math.pow(2, k) - o;
	  }
	
	  function resize() {
	    o = r * 3;
	    n = (dx + o * 2) >> k;
	    m = (dy + o * 2) >> k;
	    return density;
	  }
	
	  density.x = function(_) {
	    return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), density) : x;
	  };
	
	  density.y = function(_) {
	    return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), density) : y;
	  };
	
	  density.size = function(_) {
	    if (!arguments.length) return [dx, dy];
	    var _0 = Math.ceil(_[0]), _1 = Math.ceil(_[1]);
	    if (!(_0 >= 0) && !(_0 >= 0)) throw new Error("invalid size");
	    return dx = _0, dy = _1, resize();
	  };
	
	  density.cellSize = function(_) {
	    if (!arguments.length) return 1 << k;
	    if (!((_ = +_) >= 1)) throw new Error("invalid cell size");
	    return k = Math.floor(Math.log(_) / Math.LN2), resize();
	  };
	
	  density.thresholds = function(_) {
	    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), density) : threshold;
	  };
	
	  density.bandwidth = function(_) {
	    if (!arguments.length) return Math.sqrt(r * (r + 1));
	    if (!((_ = +_) >= 0)) throw new Error("invalid bandwidth");
	    return r = Math.round((Math.sqrt(4 * _ * _ + 1) - 1) / 2), resize();
	  };
	
	  return density;
	};
	
	exports.contours = contours;
	exports.contourDensity = density;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo/ Version 1.9.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(147)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add(temp, y, this.t);
	    add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var tau = pi * 2;
	
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}
	
	function noop() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(object, stream) {
	    streamGeometry(object.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop;
	  },
	  sphere: function() {
	    areaSum.add(tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos(phi),
	      sinPhi = sin(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos(adLambda),
	      v = k * sdLambda * sin(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
	  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon) phi1 = 90;
	    else if (deltaSum < -epsilon) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  }
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range$$1, x) {
	  return range$$1[0] <= range$$1[1] ? range$$1[0] <= x && x <= range$$1[1] : x < range$$1[0] || range$$1[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      w = asin(m), // line weight = angle
	      v = m && -w / m; // area weight multiplier
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees, asin(z / sqrt(m)) * degrees];
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos(deltaPhi),
	      sinDeltaPhi = sin(deltaPhi),
	      cosDeltaGamma = cos(deltaGamma),
	      sinDeltaGamma = sin(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos(radius),
	      sinRadius = sin(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
	}
	
	var circle = function() {
	  var center = constant([0, 0]),
	      radius = constant(90),
	      precision = constant(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees, x[1] *= degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipRejoin = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var sum = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin(lambda), -cos(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin(phi0),
	        cosPhi0 = cos(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin(phi1),
	          cosPhi1 = cos(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add(atan2(k * sign$$1 * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon || angle < epsilon && sum < -epsilon) ^ (winding & 1);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(sink) {
	    var line = clipLine(sink),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = d3Array.merge(segments);
	        var startInside = polygonContains(polygon, start);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipRejoin(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      if (pointVisible(lambda, phi)) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      line.point(lambda, phi);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      ringSink.point(lambda, phi);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi, -halfPi]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi : -pi,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi) < epsilon) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon
	      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
	          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi;
	    stream.point(-pi, phi);
	    stream.point(0, phi);
	    stream.point(pi, phi);
	    stream.point(pi, 0);
	    stream.point(pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi, -phi);
	    stream.point(-pi, 0);
	    stream.point(-pi, phi);
	  } else if (abs(from[0] - to[0]) > epsilon) {
	    var lambda = from[0] < to[0] ? pi : -pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius) {
	  var cr = cos(radius),
	      delta = 6 * radians,
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos(lambda) * cos(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (!point2 || pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon;
	            point1[1] += epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi) < epsilon,
	        meridian = polar || delta < epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipRectangle(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = d3Array.merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipRejoin(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipRectangle(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop,
	  point: noop,
	  lineStart: lengthLineStart,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin(phi), cosPhi0$1 = cos(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin(phi),
	      cosPhi = cos(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos(delta),
	      sinDelta = sin(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length(object);
	};
	
	var containsObjectType = {
	  Feature: function(object, point) {
	    return containsGeometry(object.geometry, point);
	  },
	  FeatureCollection: function(object, point) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) if (containsGeometry(features[i].geometry, point)) return true;
	    return false;
	  }
	};
	
	var containsGeometryType = {
	  Sphere: function() {
	    return true;
	  },
	  Point: function(object, point) {
	    return containsPoint(object.coordinates, point);
	  },
	  MultiPoint: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPoint(coordinates[i], point)) return true;
	    return false;
	  },
	  LineString: function(object, point) {
	    return containsLine(object.coordinates, point);
	  },
	  MultiLineString: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsLine(coordinates[i], point)) return true;
	    return false;
	  },
	  Polygon: function(object, point) {
	    return containsPolygon(object.coordinates, point);
	  },
	  MultiPolygon: function(object, point) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) if (containsPolygon(coordinates[i], point)) return true;
	    return false;
	  },
	  GeometryCollection: function(object, point) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) if (containsGeometry(geometries[i], point)) return true;
	    return false;
	  }
	};
	
	function containsGeometry(geometry, point) {
	  return geometry && containsGeometryType.hasOwnProperty(geometry.type)
	      ? containsGeometryType[geometry.type](geometry, point)
	      : false;
	}
	
	function containsPoint(coordinates, point) {
	  return distance(coordinates, point) === 0;
	}
	
	function containsLine(coordinates, point) {
	  var ab = distance(coordinates[0], coordinates[1]),
	      ao = distance(coordinates[0], point),
	      ob = distance(point, coordinates[1]);
	  return ao + ob <= ab + epsilon;
	}
	
	function containsPolygon(coordinates, point) {
	  return !!polygonContains(coordinates.map(ringRadians), pointRadians(point));
	}
	
	function ringRadians(ring) {
	  return ring = ring.map(pointRadians), ring.pop(), ring;
	}
	
	function pointRadians(point) {
	  return [point[0] * radians, point[1] * radians];
	}
	
	var contains = function(object, point) {
	  return (object && containsObjectType.hasOwnProperty(object.type)
	      ? containsObjectType[object.type]
	      : containsGeometry)(object, point);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = d3Array.range(y0, y1 - epsilon, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = d3Array.range(x0, x1 - epsilon, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	function graticule() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return d3Array.range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(d3Array.range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(d3Array.range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
	        .concat(d3Array.range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
	      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
	}
	
	function graticule10() {
	  return graticule()();
	}
	
	var interpolate = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos(y0),
	      sy0 = sin(y0),
	      cy1 = cos(y1),
	      sy1 = sin(y1),
	      kx0 = cy0 * cos(x0),
	      ky0 = cy0 * sin(x0),
	      kx1 = cy1 * cos(x1),
	      ky1 = cy1 * sin(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin(t *= d) / k,
	        A = sin(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees,
	      atan2(z, sqrt(x * x + y * y)) * degrees
	    ];
	  } : function() {
	    return [x0 * degrees, y0 * degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau);
	        break;
	      }
	    }
	  },
	  result: noop
	};
	
	var lengthSum$1 = adder();
	var lengthRing;
	var x00$2;
	var y00$2;
	var x0$4;
	var y0$4;
	
	var lengthStream$1 = {
	  point: noop,
	  lineStart: function() {
	    lengthStream$1.point = lengthPointFirst$1;
	  },
	  lineEnd: function() {
	    if (lengthRing) lengthPoint$1(x00$2, y00$2);
	    lengthStream$1.point = noop;
	  },
	  polygonStart: function() {
	    lengthRing = true;
	  },
	  polygonEnd: function() {
	    lengthRing = null;
	  },
	  result: function() {
	    var length = +lengthSum$1;
	    lengthSum$1.reset();
	    return length;
	  }
	};
	
	function lengthPointFirst$1(x, y) {
	  lengthStream$1.point = lengthPoint$1;
	  x00$2 = x0$4 = x, y00$2 = y0$4 = y;
	}
	
	function lengthPoint$1(x, y) {
	  x0$4 -= x, y0$4 -= y;
	  lengthSum$1.add(sqrt(x0$4 * x0$4 + y0$4 * y0$4));
	  x0$4 = x, y0$4 = y;
	}
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _radius: 4.5,
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    if ((_ = +_) !== this._radius) this._radius = _, this._circle = null;
	    return this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        if (this._circle == null) this._circle = circle$1(this._radius);
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    } else {
	      return null;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index = function(projection, context) {
	  var pointRadius = 4.5,
	      projectionStream,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.measure = function(object) {
	    geoStream(object, projectionStream(lengthStream$1));
	    return lengthStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = _ == null ? (projection = null, identity) : (projection = _).stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = _ == null ? (context = null, new PathString) : new PathContext(context = _);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(projection).context(context);
	};
	
	var transform = function(methods) {
	  return {
	    stream: transformer(methods)
	  };
	};
	
	function transformer(methods) {
	  return function(stream) {
	    var s = new TransformStream;
	    for (var key in methods) s[key] = methods[key];
	    s.stream = stream;
	    return s;
	  };
	}
	
	function TransformStream() {}
	
	TransformStream.prototype = {
	  constructor: TransformStream,
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fit(projection, fitBounds, object) {
	  var clip = projection.clipExtent && projection.clipExtent();
	  projection.scale(150).translate([0, 0]);
	  if (clip != null) projection.clipExtent(null);
	  geoStream(object, projection.stream(boundsStream$1));
	  fitBounds(boundsStream$1.result());
	  if (clip != null) projection.clipExtent(clip);
	  return projection;
	}
	
	function fitExtent(projection, extent, object) {
	  return fit(projection, function(b) {
	    var w = extent[1][0] - extent[0][0],
	        h = extent[1][1] - extent[0][1],
	        k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	        x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	        y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	function fitSize(projection, size, object) {
	  return fitExtent(projection, [[0, 0], size], object);
	}
	
	function fitWidth(projection, width, object) {
	  return fit(projection, function(b) {
	    var w = +width,
	        k = w / (b[1][0] - b[0][0]),
	        x = (w - k * (b[1][0] + b[0][0])) / 2,
	        y = -k * b[0][1];
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	function fitHeight(projection, height, object) {
	  return fit(projection, function(b) {
	    var h = +height,
	        k = h / (b[1][1] - b[0][1]),
	        x = -k * b[0][0],
	        y = (h - k * (b[1][1] + b[0][1])) / 2;
	    projection.scale(150 * k).translate([x, y]);
	  }, object);
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transformer({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transformer({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function transformRotate(rotate) {
	  return transformer({
	    point: function(x, y) {
	      var r = rotate(x, y);
	      return this.stream.point(r[0], r[1]);
	    }
	  });
	}
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees, point[1] * degrees];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(transformRotate(rotate)(preclip(projectResample(postclip(cacheStream = stream)))));
	  };
	
	  projection.preclip = function(_) {
	    return arguments.length ? (preclip = _, theta = undefined, reset()) : preclip;
	  };
	
	  projection.postclip = function(_) {
	    return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = function(extent, object) {
	    return fitExtent(projection, extent, object);
	  };
	
	  projection.fitSize = function(size, object) {
	    return fitSize(projection, size, object);
	  };
	
	  projection.fitWidth = function(width, object) {
	    return fitWidth(projection, width, object);
	  };
	
	  projection.fitHeight = function(height, object) {
	    return fitHeight(projection, height, object);
	  };
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin(y)) / n;
	    return [r * sin(x *= n), r0 - r * cos(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null, (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = function(extent, object) {
	    return fitExtent(albersUsa, extent, object);
	  };
	
	  albersUsa.fitSize = function(size, object) {
	    return fitSize(albersUsa, size, object);
	  };
	
	  albersUsa.fitWidth = function(width, object) {
	    return fitWidth(albersUsa, width, object);
	  };
	
	  albersUsa.fitHeight = function(height, object) {
	    return fitHeight(albersUsa, height, object);
	  };
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos(x),
	        cy = cos(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin(x),
	      k * sin(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin(c),
	        cc = cos(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      center = m.center,
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      x0 = null, y0, x1, y1; // clip extent
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), reclip()) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), reclip()) : translate();
	  };
	
	  m.center = function(_) {
	    return arguments.length ? (center(_), reclip()) : center();
	  };
	
	  m.clipExtent = function(_) {
	    return arguments.length ? (_ == null ? x0 = y0 = x1 = y1 = null : (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reclip()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  function reclip() {
	    var k = pi * scale(),
	        t = m(rotation(m.rotate()).invert([0, 0]));
	    return clipExtent(x0 == null
	        ? [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]] : project === mercatorRaw
	        ? [[Math.max(t[0] - k, x0), y0], [Math.min(t[0] + k, x1), y1]]
	        : [[x0, Math.max(t[1] - k, y0)], [x1, Math.min(t[1] + k, y1)]]);
	  }
	
	  return reclip();
	}
	
	function tany(y) {
	  return tan((halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
	    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
	    var r = f / pow(tany(y), n);
	    return [r * sin(n * x), f - r * cos(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin(nx), g - gy * cos(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos(y), k = cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function scaleTranslate(kx, ky, tx, ty) {
	  return kx === 1 && ky === 1 && tx === 0 && ty === 0 ? identity : transformer({
	    point: function(x, y) {
	      this.stream.point(x * kx + tx, y * ky + ty);
	    }
	  });
	}
	
	var identity$1 = function() {
	  var k = 1, tx = 0, ty = 0, sx = 1, sy = 1, transform$$1 = identity, // scale, translate and reflect
	      x0 = null, y0, x1, y1, // clip extent
	      postclip = identity,
	      cache,
	      cacheStream,
	      projection;
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return projection = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = transform$$1(postclip(cacheStream = stream));
	    },
	    postclip: function(_) {
	      return arguments.length ? (postclip = _, x0 = y0 = x1 = y1 = null, reset()) : postclip;
	    },
	    clipExtent: function(_) {
	      return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipRectangle(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	    },
	    scale: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate((k = +_) * sx, k * sy, tx, ty), reset()) : k;
	    },
	    translate: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate(k * sx, k * sy, tx = +_[0], ty = +_[1]), reset()) : [tx, ty];
	    },
	    reflectX: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate(k * (sx = _ ? -1 : 1), k * sy, tx, ty), reset()) : sx < 0;
	    },
	    reflectY: function(_) {
	      return arguments.length ? (transform$$1 = scaleTranslate(k * sx, k * (sy = _ ? -1 : 1), tx, ty), reset()) : sy < 0;
	    },
	    fitExtent: function(extent, object) {
	      return fitExtent(projection, extent, object);
	    },
	    fitSize: function(size, object) {
	      return fitSize(projection, size, object);
	    },
	    fitWidth: function(width, object) {
	      return fitWidth(projection, width, object);
	    },
	    fitHeight: function(height, object) {
	      return fitHeight(projection, height, object);
	    }
	  };
	};
	
	function naturalEarth1Raw(lambda, phi) {
	  var phi2 = phi * phi, phi4 = phi2 * phi2;
	  return [
	    lambda * (0.8707 - 0.131979 * phi2 + phi4 * (-0.013791 + phi4 * (0.003971 * phi2 - 0.001529 * phi4))),
	    phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4)))
	  ];
	}
	
	naturalEarth1Raw.invert = function(x, y) {
	  var phi = y, i = 25, delta;
	  do {
	    var phi2 = phi * phi, phi4 = phi2 * phi2;
	    phi -= delta = (phi * (1.007226 + phi2 * (0.015085 + phi4 * (-0.044475 + 0.028874 * phi2 - 0.005916 * phi4))) - y) /
	        (1.007226 + phi2 * (0.015085 * 3 + phi4 * (-0.044475 * 7 + 0.028874 * 9 * phi2 - 0.005916 * 11 * phi4)));
	  } while (abs(delta) > epsilon && --i > 0);
	  return [
	    x / (0.8707 + (phi2 = phi * phi) * (-0.131979 + phi2 * (-0.013791 + phi2 * phi2 * phi2 * (0.003971 - 0.001529 * phi2)))),
	    phi
	  ];
	};
	
	var naturalEarth1 = function() {
	  return projection(naturalEarth1Raw)
	      .scale(175.295);
	};
	
	function orthographicRaw(x, y) {
	  return [cos(y) * sin(x), sin(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos(y), k = 1 + cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipAntimeridian = clipAntimeridian;
	exports.geoClipCircle = clipCircle;
	exports.geoClipExtent = extent;
	exports.geoClipRectangle = clipRectangle;
	exports.geoContains = contains;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoGraticule10 = graticule10;
	exports.geoInterpolate = interpolate;
	exports.geoLength = length;
	exports.geoPath = index;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoIdentity = identity$1;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoNaturalEarth1 = naturalEarth1;
	exports.geoNaturalEarth1Raw = naturalEarth1Raw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.5. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = "";
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._ += "Z";
	    }
	  },
	  lineTo: function(x, y) {
	    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
	      }
	
	      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._ += "M" + x0 + "," + y0;
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._ += "L" + x0 + "," + y0;
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Does the angle go the wrong way? Flip the direction.
	    if (da < 0) da = da % tau + tau;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
	    }
	
	    // Is this arc non-empty? Draw an arc!
	    else if (da > epsilon) {
	      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
	  },
	  toString: function() {
	    return this._;
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/d3/d3-sankey Version 0.7.1. Copyright 2017 Mike Bostock.
	(function (global, factory) {
		 true ? factory(exports, __webpack_require__(147), __webpack_require__(290), __webpack_require__(107)) :
		typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape'], factory) :
		(factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Array,d3Collection,d3Shape) { 'use strict';
	
	function targetDepth(d) {
	  return d.target.depth;
	}
	
	function left(node) {
	  return node.depth;
	}
	
	function right(node, n) {
	  return n - 1 - node.height;
	}
	
	function justify(node, n) {
	  return node.sourceLinks.length ? node.depth : n - 1;
	}
	
	function center(node) {
	  return node.targetLinks.length ? node.depth
	      : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1
	      : 0;
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function ascendingSourceBreadth(a, b) {
	  return ascendingBreadth(a.source, b.source) || a.index - b.index;
	}
	
	function ascendingTargetBreadth(a, b) {
	  return ascendingBreadth(a.target, b.target) || a.index - b.index;
	}
	
	function ascendingBreadth(a, b) {
	  return a.y0 - b.y0;
	}
	
	function value(d) {
	  return d.value;
	}
	
	function nodeCenter(node) {
	  return (node.y0 + node.y1) / 2;
	}
	
	function weightedSource(link) {
	  return nodeCenter(link.source) * link.value;
	}
	
	function weightedTarget(link) {
	  return nodeCenter(link.target) * link.value;
	}
	
	function defaultId(d) {
	  return d.index;
	}
	
	function defaultNodes(graph) {
	  return graph.nodes;
	}
	
	function defaultLinks(graph) {
	  return graph.links;
	}
	
	function find(nodeById, id) {
	  var node = nodeById.get(id);
	  if (!node) throw new Error("missing: " + id);
	  return node;
	}
	
	var sankey = function() {
	  var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
	      dx = 24, // nodeWidth
	      py = 8, // nodePadding
	      id = defaultId,
	      align = justify,
	      nodes = defaultNodes,
	      links = defaultLinks,
	      iterations = 32;
	
	  function sankey() {
	    var graph = {nodes: nodes.apply(null, arguments), links: links.apply(null, arguments)};
	    computeNodeLinks(graph);
	    computeNodeValues(graph);
	    computeNodeDepths(graph);
	    computeNodeBreadths(graph, iterations);
	    computeLinkBreadths(graph);
	    return graph;
	  }
	
	  sankey.update = function(graph) {
	    computeLinkBreadths(graph);
	    return graph;
	  };
	
	  sankey.nodeId = function(_) {
	    return arguments.length ? (id = typeof _ === "function" ? _ : constant(_), sankey) : id;
	  };
	
	  sankey.nodeAlign = function(_) {
	    return arguments.length ? (align = typeof _ === "function" ? _ : constant(_), sankey) : align;
	  };
	
	  sankey.nodeWidth = function(_) {
	    return arguments.length ? (dx = +_, sankey) : dx;
	  };
	
	  sankey.nodePadding = function(_) {
	    return arguments.length ? (py = +_, sankey) : py;
	  };
	
	  sankey.nodes = function(_) {
	    return arguments.length ? (nodes = typeof _ === "function" ? _ : constant(_), sankey) : nodes;
	  };
	
	  sankey.links = function(_) {
	    return arguments.length ? (links = typeof _ === "function" ? _ : constant(_), sankey) : links;
	  };
	
	  sankey.size = function(_) {
	    return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
	  };
	
	  sankey.extent = function(_) {
	    return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
	  };
	
	  sankey.iterations = function(_) {
	    return arguments.length ? (iterations = +_, sankey) : iterations;
	  };
	
	  // Populate the sourceLinks and targetLinks for each node.
	  // Also, if the source and target are not objects, assume they are indices.
	  function computeNodeLinks(graph) {
	    graph.nodes.forEach(function(node, i) {
	      node.index = i;
	      node.sourceLinks = [];
	      node.targetLinks = [];
	    });
	    var nodeById = d3Collection.map(graph.nodes, id);
	    graph.links.forEach(function(link, i) {
	      link.index = i;
	      var source = link.source, target = link.target;
	      if (typeof source !== "object") source = link.source = find(nodeById, source);
	      if (typeof target !== "object") target = link.target = find(nodeById, target);
	      source.sourceLinks.push(link);
	      target.targetLinks.push(link);
	    });
	  }
	
	  // Compute the value (size) of each node by summing the associated links.
	  function computeNodeValues(graph) {
	    graph.nodes.forEach(function(node) {
	      node.value = Math.max(
	        d3Array.sum(node.sourceLinks, value),
	        d3Array.sum(node.targetLinks, value)
	      );
	    });
	  }
	
	  // Iteratively assign the depth (x-position) for each node.
	  // Nodes are assigned the maximum depth of incoming neighbors plus one;
	  // nodes with no incoming links are assigned depth zero, while
	  // nodes with no outgoing links are assigned the maximum depth.
	  function computeNodeDepths(graph) {
	    var nodes, next, x;
	
	    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	      nodes.forEach(function(node) {
	        node.depth = x;
	        node.sourceLinks.forEach(function(link) {
	          if (next.indexOf(link.target) < 0) {
	            next.push(link.target);
	          }
	        });
	      });
	    }
	
	    for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
	      nodes.forEach(function(node) {
	        node.height = x;
	        node.targetLinks.forEach(function(link) {
	          if (next.indexOf(link.source) < 0) {
	            next.push(link.source);
	          }
	        });
	      });
	    }
	
	    var kx = (x1 - x0 - dx) / (x - 1);
	    graph.nodes.forEach(function(node) {
	      node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
	    });
	  }
	
	  function computeNodeBreadths(graph) {
	    var columns = d3Collection.nest()
	        .key(function(d) { return d.x0; })
	        .sortKeys(d3Array.ascending)
	        .entries(graph.nodes)
	        .map(function(d) { return d.values; });
	
	    //
	    initializeNodeBreadth();
	    resolveCollisions();
	    for (var alpha = 1, n = iterations; n > 0; --n) {
	      relaxRightToLeft(alpha *= 0.99);
	      resolveCollisions();
	      relaxLeftToRight(alpha);
	      resolveCollisions();
	    }
	
	    function initializeNodeBreadth() {
	      var ky = d3Array.min(columns, function(nodes) {
	        return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
	      });
	
	      columns.forEach(function(nodes) {
	        nodes.forEach(function(node, i) {
	          node.y1 = (node.y0 = i) + node.value * ky;
	        });
	      });
	
	      graph.links.forEach(function(link) {
	        link.width = link.value * ky;
	      });
	    }
	
	    function relaxLeftToRight(alpha) {
	      columns.forEach(function(nodes) {
	        nodes.forEach(function(node) {
	          if (node.targetLinks.length) {
	            var dy = (d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value) - nodeCenter(node)) * alpha;
	            node.y0 += dy, node.y1 += dy;
	          }
	        });
	      });
	    }
	
	    function relaxRightToLeft(alpha) {
	      columns.slice().reverse().forEach(function(nodes) {
	        nodes.forEach(function(node) {
	          if (node.sourceLinks.length) {
	            var dy = (d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value) - nodeCenter(node)) * alpha;
	            node.y0 += dy, node.y1 += dy;
	          }
	        });
	      });
	    }
	
	    function resolveCollisions() {
	      columns.forEach(function(nodes) {
	        var node,
	            dy,
	            y = y0,
	            n = nodes.length,
	            i;
	
	        // Push any overlapping nodes down.
	        nodes.sort(ascendingBreadth);
	        for (i = 0; i < n; ++i) {
	          node = nodes[i];
	          dy = y - node.y0;
	          if (dy > 0) node.y0 += dy, node.y1 += dy;
	          y = node.y1 + py;
	        }
	
	        // If the bottommost node goes outside the bounds, push it back up.
	        dy = y - py - y1;
	        if (dy > 0) {
	          y = (node.y0 -= dy), node.y1 -= dy;
	
	          // Push any overlapping nodes back up.
	          for (i = n - 2; i >= 0; --i) {
	            node = nodes[i];
	            dy = node.y1 + py - y;
	            if (dy > 0) node.y0 -= dy, node.y1 -= dy;
	            y = node.y0;
	          }
	        }
	      });
	    }
	  }
	
	  function computeLinkBreadths(graph) {
	    graph.nodes.forEach(function(node) {
	      node.sourceLinks.sort(ascendingTargetBreadth);
	      node.targetLinks.sort(ascendingSourceBreadth);
	    });
	    graph.nodes.forEach(function(node) {
	      var y0 = node.y0, y1 = y0;
	      node.sourceLinks.forEach(function(link) {
	        link.y0 = y0 + link.width / 2, y0 += link.width;
	      });
	      node.targetLinks.forEach(function(link) {
	        link.y1 = y1 + link.width / 2, y1 += link.width;
	      });
	    });
	  }
	
	  return sankey;
	};
	
	function horizontalSource(d) {
	  return [d.source.x1, d.y0];
	}
	
	function horizontalTarget(d) {
	  return [d.target.x0, d.y1];
	}
	
	var sankeyLinkHorizontal = function() {
	  return d3Shape.linkHorizontal()
	      .source(horizontalSource)
	      .target(horizontalTarget);
	};
	
	exports.sankey = sankey;
	exports.sankeyCenter = center;
	exports.sankeyLeft = left;
	exports.sankeyRight = right;
	exports.sankeyJustify = justify;
	exports.sankeyLinkHorizontal = sankeyLinkHorizontal;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 1880 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 1881 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 1882 */
/***/ function(module, exports) {

	'use strict';
	
	var isMergeableObject = function isMergeableObject(value) {
		return isNonNullObject(value)
			&& !isSpecial(value)
	};
	
	function isNonNullObject(value) {
		return !!value && typeof value === 'object'
	}
	
	function isSpecial(value) {
		var stringValue = Object.prototype.toString.call(value);
	
		return stringValue === '[object RegExp]'
			|| stringValue === '[object Date]'
			|| isReactElement(value)
	}
	
	// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
	var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
	
	function isReactElement(value) {
		return value.$$typeof === REACT_ELEMENT_TYPE
	}
	
	function emptyTarget(val) {
	    return Array.isArray(val) ? [] : {}
	}
	
	function cloneIfNecessary(value, optionsArgument) {
	    var clone = optionsArgument && optionsArgument.clone === true;
	    return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value
	}
	
	function defaultArrayMerge(target, source, optionsArgument) {
	    var destination = target.slice();
	    source.forEach(function(e, i) {
	        if (typeof destination[i] === 'undefined') {
	            destination[i] = cloneIfNecessary(e, optionsArgument);
	        } else if (isMergeableObject(e)) {
	            destination[i] = deepmerge(target[i], e, optionsArgument);
	        } else if (target.indexOf(e) === -1) {
	            destination.push(cloneIfNecessary(e, optionsArgument));
	        }
	    });
	    return destination
	}
	
	function mergeObject(target, source, optionsArgument) {
	    var destination = {};
	    if (isMergeableObject(target)) {
	        Object.keys(target).forEach(function(key) {
	            destination[key] = cloneIfNecessary(target[key], optionsArgument);
	        });
	    }
	    Object.keys(source).forEach(function(key) {
	        if (!isMergeableObject(source[key]) || !target[key]) {
	            destination[key] = cloneIfNecessary(source[key], optionsArgument);
	        } else {
	            destination[key] = deepmerge(target[key], source[key], optionsArgument);
	        }
	    });
	    return destination
	}
	
	function deepmerge(target, source, optionsArgument) {
	    var sourceIsArray = Array.isArray(source);
	    var targetIsArray = Array.isArray(target);
	    var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
	
	    if (!sourceAndTargetTypesMatch) {
	        return cloneIfNecessary(source, optionsArgument)
	    } else if (sourceIsArray) {
	        var arrayMerge = options.arrayMerge || defaultArrayMerge;
	        return arrayMerge(target, source, optionsArgument)
	    } else {
	        return mergeObject(target, source, optionsArgument)
	    }
	}
	
	deepmerge.all = function deepmergeAll(array, optionsArgument) {
	    if (!Array.isArray(array) || array.length < 2) {
	        throw new Error('first argument should be an array with at least two elements')
	    }
	
	    // we are sure there are at least 2 values, so it is safe to have no initial value
	    return array.reduce(function(prev, next) {
	        return deepmerge(prev, next, optionsArgument)
	    })
	};
	
	var deepmerge_1 = deepmerge;
	
	module.exports = deepmerge_1;


/***/ },
/* 1883 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	var detectPassiveEvents = {
	  update: function update() {
	    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
	      var passive = false;
	      var options = Object.defineProperty({}, 'passive', {
	        get: function get() {
	          passive = true;
	        }
	      });
	      // note: have to set and remove a no-op listener instead of null
	      // (which was used previously), becasue Edge v15 throws an error
	      // when providing a null callback.
	      // https://github.com/rafrex/detect-passive-events/pull/3
	      var noop = function noop() {};
	      window.addEventListener('testPassiveEventSupport', noop, options);
	      window.removeEventListener('testPassiveEventSupport', noop, options);
	      detectPassiveEvents.hasSupport = passive;
	    }
	  }
	};
	
	detectPassiveEvents.update();
	exports.default = detectPassiveEvents;

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = _utils2['default'].clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  }
	
	  // Left edge inside and right edge outside viewport, try to resize it.
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  }
	
	  // Right edge outside viewport, try to move it.
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  }
	
	  // Top edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  }
	
	  // Top edge inside and bottom edge outside viewport, try to resize it.
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  }
	
	  // Bottom edge outside viewport, try to move it.
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return _utils2['default'].mix(pos, size);
	}
	
	exports['default'] = adjustForViewport;
	module.exports = exports['default'];

/***/ },
/* 1885 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	exports['default'] = getAlignOffset;
	module.exports = exports['default'];

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getAlignOffset = __webpack_require__(1885);
	
	var _getAlignOffset2 = _interopRequireDefault(_getAlignOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = (0, _getAlignOffset2['default'])(refNodeRegion, points[1]);
	  var p2 = (0, _getAlignOffset2['default'])(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	
	  return {
	    left: elRegion.left - diff[0] + offset[0] - targetOffset[0],
	    top: elRegion.top - diff[1] + offset[1] - targetOffset[1]
	  };
	}
	
	exports['default'] = getElFuturePos;
	module.exports = exports['default'];

/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getRegion(node) {
	  var offset = void 0;
	  var w = void 0;
	  var h = void 0;
	  if (!_utils2['default'].isWindow(node) && node.nodeType !== 9) {
	    offset = _utils2['default'].offset(node);
	    w = _utils2['default'].outerWidth(node);
	    h = _utils2['default'].outerHeight(node);
	  } else {
	    var win = _utils2['default'].getWindow(node);
	    offset = {
	      left: _utils2['default'].getWindowScrollLeft(win),
	      top: _utils2['default'].getWindowScrollTop(win)
	    };
	    w = _utils2['default'].viewportWidth(win);
	    h = _utils2['default'].viewportHeight(win);
	  }
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	exports['default'] = getRegion;
	module.exports = exports['default'];

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(902);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _isAncestorFixed = __webpack_require__(1890);
	
	var _isAncestorFixed2 = _interopRequireDefault(_isAncestorFixed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * 获得元素的显示部分的区域
	 */
	function getVisibleRectForElement(element) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = (0, _getOffsetParent2['default'])(element);
	  var doc = _utils2['default'].getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement;
	
	  // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
	    // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && _utils2['default'].css(el, 'overflow') !== 'visible') {
	      var pos = _utils2['default'].offset(el);
	      // add border
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right,
	      // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	    el = (0, _getOffsetParent2['default'])(el);
	  }
	
	  // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	  var originalPosition = null;
	  if (!_utils2['default'].isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = _utils2['default'].css(element, 'position');
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = _utils2['default'].getWindowScrollLeft(win);
	  var scrollY = _utils2['default'].getWindowScrollTop(win);
	  var viewportWidth = _utils2['default'].viewportWidth(win);
	  var viewportHeight = _utils2['default'].viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight;
	
	  // Reset element position after calculate the visible area
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if ((0, _isAncestorFixed2['default'])(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	exports['default'] = getVisibleRectForElement;
	module.exports = exports['default'];

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	var _getOffsetParent = __webpack_require__(902);
	
	var _getOffsetParent2 = _interopRequireDefault(_getOffsetParent);
	
	var _getVisibleRectForElement = __webpack_require__(1888);
	
	var _getVisibleRectForElement2 = _interopRequireDefault(_getVisibleRectForElement);
	
	var _adjustForViewport = __webpack_require__(1884);
	
	var _adjustForViewport2 = _interopRequireDefault(_adjustForViewport);
	
	var _getRegion = __webpack_require__(1887);
	
	var _getRegion2 = _interopRequireDefault(_getRegion);
	
	var _getElFuturePos = __webpack_require__(1886);
	
	var _getElFuturePos2 = _interopRequireDefault(_getElFuturePos);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// http://yiminghe.iteye.com/blog/1124720
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function isOutOfVisibleRect(target) {
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(target);
	  var targetRegion = (0, _getRegion2['default'])(target);
	
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  _utils2['default'].each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n = void 0;
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	
	function domAlign(el, refNode, align) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var target = align.target || refNode;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  // 当前节点可以被放置的显示区域
	  var visibleRect = (0, _getVisibleRectForElement2['default'])(source);
	  // 当前节点所占的区域, left/top/width/height
	  var elRegion = (0, _getRegion2['default'])(source);
	  // 参照节点所占的区域, left/top/width/height
	  var refNodeRegion = (0, _getRegion2['default'])(target);
	  // 将 offset 转换成数值，支持百分比
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, refNodeRegion);
	  // 当前节点将要被放置的位置
	  var elFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, points, offset, targetOffset);
	  // 当前节点将要所处的区域
	  var newElRegion = _utils2['default'].merge(elRegion, elFuturePos);
	
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
	
	  // 如果可视区域不能完全放置当前节点时允许调整
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTargetNotOutOfVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/ig, {
	          l: 'r',
	          r: 'l'
	        });
	        // 偏移量也反下
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/ig, {
	          t: 'b',
	          b: 't'
	        });
	        // 偏移量也反下
	        var _newOffset = flipOffset(offset, 1);
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	        var _newElFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    }
	
	    // 如果失败，重新计算当前节点将要被放置的位置
	    if (fail) {
	      elFuturePos = (0, _getElFuturePos2['default'])(elRegion, refNodeRegion, points, offset, targetOffset);
	      _utils2['default'].mix(newElRegion, elFuturePos);
	    }
	
	    // 检查反下后的位置是否可以放下了
	    // 如果仍然放不下只有指定了可以调整当前方向才调整
	    newOverflowCfg.adjustX = overflow.adjustX && isFailX(elFuturePos, elRegion, visibleRect);
	
	    newOverflowCfg.adjustY = overflow.adjustY && isFailY(elFuturePos, elRegion, visibleRect);
	
	    // 确实要调整，甚至可能会调整高度宽度
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = (0, _adjustForViewport2['default'])(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  }
	
	  // need judge to in case set fixed with in css on height auto element
	  if (newElRegion.width !== elRegion.width) {
	    _utils2['default'].css(source, 'width', _utils2['default'].width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    _utils2['default'].css(source, 'height', _utils2['default'].height(source) + newElRegion.height - elRegion.height);
	  }
	
	  // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	  _utils2['default'].offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform
	  });
	
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	
	domAlign.__getOffsetParent = _getOffsetParent2['default'];
	
	domAlign.__getVisibleRectForElement = _getVisibleRectForElement2['default'];
	
	exports['default'] = domAlign;
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	module.exports = exports['default'];

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAncestorFixed;
	
	var _utils = __webpack_require__(181);
	
	var _utils2 = _interopRequireDefault(_utils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAncestorFixed(element) {
	  if (_utils2['default'].isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = _utils2['default'].getDocument(element);
	  var body = doc.body;
	  var parent = null;
	  for (parent = element.parentNode; parent && parent !== body; parent = parent.parentNode) {
	    var positionStyle = _utils2['default'].css(parent, 'position');
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 1891 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransformName = getTransformName;
	exports.setTransitionProperty = setTransitionProperty;
	exports.getTransitionProperty = getTransitionProperty;
	exports.getTransformXY = getTransformXY;
	exports.setTransformXY = setTransformXY;
	var vendorPrefix = void 0;
	
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'TransitionProperty' : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? getVendorPrefix() + 'Transform' : 'transform';
	}
	
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	  if (name) {
	    node.style[name] = value;
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return { x: parseFloat(matrix[12] || matrix[4], 0), y: parseFloat(matrix[13] || matrix[5], 0) };
	  }
	  return {
	    x: 0,
	    y: 0
	  };
	}
	
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	  if (transform && transform !== 'none') {
	    var arr = void 0;
	    var match2d = transform.match(matrix2d);
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, 'matrix(' + arr.join(',') + ')');
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, 'matrix3d(' + arr.join(',') + ')');
	    }
	  } else {
	    setTransform(node, 'translateX(' + xy.x + 'px) translateY(' + xy.y + 'px) translateZ(0)');
	  }
	}

/***/ },
/* 1892 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var matches = __webpack_require__(1909);
	
	/**
	 * @param element {Element}
	 * @param selector {String}
	 * @param context {Element}
	 * @return {Element}
	 */
	module.exports = function (element, selector, context) {
	  context = context || document;
	  // guard against orphans
	  element = { parentNode: element };
	
	  while ((element = element.parentNode) && element !== context) {
	    if (matches(element, selector)) {
	      return element;
	    }
	  }
	};


/***/ },
/* 1893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(904);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
	}
	module.exports = exports['default'];

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasClass = exports.removeClass = exports.addClass = undefined;
	
	var _addClass = __webpack_require__(1893);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(1895);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _hasClass = __webpack_require__(904);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.addClass = _addClass2.default;
	exports.removeClass = _removeClass2.default;
	exports.hasClass = _hasClass2.default;
	exports.default = { addClass: _addClass2.default, removeClass: _removeClass2.default, hasClass: _hasClass2.default };

/***/ },
/* 1895 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	};

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = filterEvents;
	
	var _contains = __webpack_require__(183);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _querySelectorAll = __webpack_require__(1901);
	
	var _querySelectorAll2 = _interopRequireDefault(_querySelectorAll);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function filterEvents(selector, handler) {
	  return function filterHandler(e) {
	    var top = e.currentTarget,
	        target = e.target,
	        matches = (0, _querySelectorAll2.default)(top, selector);
	
	    if (matches.some(function (match) {
	      return (0, _contains2.default)(match, target);
	    })) handler.call(this, e);
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listen = exports.filter = exports.off = exports.on = undefined;
	
	var _on = __webpack_require__(292);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(421);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _filter = __webpack_require__(1896);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _listen = __webpack_require__(1898);
	
	var _listen2 = _interopRequireDefault(_listen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.on = _on2.default;
	exports.off = _off2.default;
	exports.filter = _filter2.default;
	exports.listen = _listen2.default;
	exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _on = __webpack_require__(292);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _off = __webpack_require__(421);
	
	var _off2 = _interopRequireDefault(_off);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listen = function listen() {};
	
	if (_inDOM2.default) {
	  listen = function listen(node, eventName, handler, capture) {
	    (0, _on2.default)(node, eventName, handler, capture);
	    return function () {
	      (0, _off2.default)(node, eventName, handler, capture);
	    };
	  };
	}
	
	exports.default = listen;
	module.exports = exports['default'];

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = offsetParent;
	
	var _ownerDocument = __webpack_require__(182);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _style = __webpack_require__(294);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function offsetParent(node) {
	  var doc = (0, _ownerDocument2.default)(node),
	      offsetParent = node && node.offsetParent;
	
	  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
	    offsetParent = offsetParent.offsetParent;
	  }
	
	  return offsetParent || doc.documentElement;
	}
	module.exports = exports['default'];

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = position;
	
	var _offset = __webpack_require__(905);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _offsetParent = __webpack_require__(1899);
	
	var _offsetParent2 = _interopRequireDefault(_offsetParent);
	
	var _scrollTop = __webpack_require__(906);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _scrollLeft = __webpack_require__(1902);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _style = __webpack_require__(294);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function nodeName(node) {
	  return node.nodeName && node.nodeName.toLowerCase();
	}
	
	function position(node, offsetParent) {
	  var parentOffset = { top: 0, left: 0 },
	      offset;
	
	  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
	  // because it is its only offset parent
	  if ((0, _style2.default)(node, 'position') === 'fixed') {
	    offset = node.getBoundingClientRect();
	  } else {
	    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
	    offset = (0, _offset2.default)(node);
	
	    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);
	
	    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
	    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
	  }
	
	  // Subtract parent offsets and node margins
	  return _extends({}, offset, {
	    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
	    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 1901 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = qsa;
	// Zepto.js
	// (c) 2010-2015 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	var simpleSelectorRE = /^[\w-]*$/;
	var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
	
	function qsa(element, selector) {
	  var maybeID = selector[0] === '#',
	      maybeClass = selector[0] === '.',
	      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
	      isSimple = simpleSelectorRE.test(nameOnly),
	      found;
	
	  if (isSimple) {
	    if (maybeID) {
	      element = element.getElementById ? element : document;
	      return (found = element.getElementById(nameOnly)) ? [found] : [];
	    }
	
	    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
	
	    return toArray(element.getElementsByTagName(selector));
	  }
	
	  return toArray(element.querySelectorAll(selector));
	}
	module.exports = exports['default'];

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(293);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = _getComputedStyle;
	
	var _camelizeStyle = __webpack_require__(908);
	
	var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rposition = /^(top|right|bottom|left)$/;
	var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;
	
	function _getComputedStyle(node) {
	  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
	  var doc = node.ownerDocument;
	
	  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
	    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
	    getPropertyValue: function getPropertyValue(prop) {
	      var style = node.style;
	
	      prop = (0, _camelizeStyle2.default)(prop);
	
	      if (prop == 'float') prop = 'styleFloat';
	
	      var current = node.currentStyle[prop] || null;
	
	      if (current == null && style && style[prop]) current = style[prop];
	
	      if (rnumnonpx.test(current) && !rposition.test(prop)) {
	        // Remember the original values
	        var left = style.left;
	        var runStyle = node.runtimeStyle;
	        var rsLeft = runStyle && runStyle.left;
	
	        // Put in the new values to get a computed value out
	        if (rsLeft) runStyle.left = node.currentStyle.left;
	
	        style.left = prop === 'fontSize' ? '1em' : current;
	        current = style.pixelLeft + 'px';
	
	        // Revert the changed values
	        style.left = left;
	        if (rsLeft) runStyle.left = rsLeft;
	      }
	
	      return current;
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1904 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = removeStyle;
	function removeStyle(node, key) {
	  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
	}
	module.exports = exports['default'];

/***/ },
/* 1905 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTransform;
	var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
	
	function isTransform(property) {
	  return !!(property && supportedTransforms.test(property));
	}
	module.exports = exports["default"];

/***/ },
/* 1906 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = camelize;
	var rHyphen = /-(.)/g;
	
	function camelize(string) {
	  return string.replace(rHyphen, function (_, chr) {
	    return chr.toUpperCase();
	  });
	}
	module.exports = exports["default"];

/***/ },
/* 1907 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenate;
	
	var rUpper = /([A-Z])/g;
	
	function hyphenate(string) {
	  return string.replace(rUpper, '-$1').toLowerCase();
	}
	module.exports = exports['default'];

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateStyleName;
	
	var _hyphenate = __webpack_require__(1907);
	
	var _hyphenate2 = _interopRequireDefault(_hyphenate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var msPattern = /^ms-/; /**
	                         * Copyright 2013-2014, Facebook, Inc.
	                         * All rights reserved.
	                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
	                         */
	
	function hyphenateStyleName(string) {
	  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
	}
	module.exports = exports['default'];

/***/ },
/* 1909 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determine if a DOM element matches a CSS selector
	 *
	 * @param {Element} elem
	 * @param {String} selector
	 * @return {Boolean}
	 * @api public
	 */
	
	function matches(elem, selector) {
	  // Vendor-specific implementations of `Element.prototype.matches()`.
	  var proto = window.Element.prototype;
	  var nativeMatches = proto.matches ||
	      proto.mozMatchesSelector ||
	      proto.msMatchesSelector ||
	      proto.oMatchesSelector ||
	      proto.webkitMatchesSelector;
	
	  if (!elem || elem.nodeType !== 1) {
	    return false;
	  }
	
	  var parentElem = elem.parentNode;
	
	  // use native 'matches'
	  if (nativeMatches) {
	    return nativeMatches.call(elem, selector);
	  }
	
	  // native support for `matches` is missing and a fallback is required
	  var nodes = parentElem.querySelectorAll(selector);
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i] === elem) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Expose `matches`
	 */
	
	module.exports = matches;


/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(1911);
	
	function scrollIntoView(elem, container, config) {
	  config = config || {};
	  // document 归一化到 window
	  if (container.nodeType === 9) {
	    container = util.getWindow(container);
	  }
	
	  var allowHorizontalScroll = config.allowHorizontalScroll;
	  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
	  var alignWithTop = config.alignWithTop;
	  var alignWithLeft = config.alignWithLeft;
	  var offsetTop = config.offsetTop || 0;
	  var offsetLeft = config.offsetLeft || 0;
	  var offsetBottom = config.offsetBottom || 0;
	  var offsetRight = config.offsetRight || 0;
	
	  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
	
	  var isWin = util.isWindow(container);
	  var elemOffset = util.offset(elem);
	  var eh = util.outerHeight(elem);
	  var ew = util.outerWidth(elem);
	  var containerOffset = undefined;
	  var ch = undefined;
	  var cw = undefined;
	  var containerScroll = undefined;
	  var diffTop = undefined;
	  var diffBottom = undefined;
	  var win = undefined;
	  var winScroll = undefined;
	  var ww = undefined;
	  var wh = undefined;
	
	  if (isWin) {
	    win = container;
	    wh = util.height(win);
	    ww = util.width(win);
	    winScroll = {
	      left: util.scrollLeft(win),
	      top: util.scrollTop(win)
	    };
	    // elem 相对 container 可视视窗的距离
	    diffTop = {
	      left: elemOffset.left - winScroll.left - offsetLeft,
	      top: elemOffset.top - winScroll.top - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
	      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
	    };
	    containerScroll = winScroll;
	  } else {
	    containerOffset = util.offset(container);
	    ch = container.clientHeight;
	    cw = container.clientWidth;
	    containerScroll = {
	      left: container.scrollLeft,
	      top: container.scrollTop
	    };
	    // elem 相对 container 可视视窗的距离
	    // 注意边框, offset 是边框到根节点
	    diffTop = {
	      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
	      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
	      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
	    };
	  }
	
	  if (diffTop.top < 0 || diffBottom.top > 0) {
	    // 强制向上
	    if (alignWithTop === true) {
	      util.scrollTop(container, containerScroll.top + diffTop.top);
	    } else if (alignWithTop === false) {
	      util.scrollTop(container, containerScroll.top + diffBottom.top);
	    } else {
	      // 自动调整
	      if (diffTop.top < 0) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  } else {
	    if (!onlyScrollIfNeeded) {
	      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
	      if (alignWithTop) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  }
	
	  if (allowHorizontalScroll) {
	    if (diffTop.left < 0 || diffBottom.left > 0) {
	      // 强制向上
	      if (alignWithLeft === true) {
	        util.scrollLeft(container, containerScroll.left + diffTop.left);
	      } else if (alignWithLeft === false) {
	        util.scrollLeft(container, containerScroll.left + diffBottom.left);
	      } else {
	        // 自动调整
	        if (diffTop.left < 0) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    } else {
	      if (!onlyScrollIfNeeded) {
	        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
	        if (alignWithLeft) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    }
	  }
	}
	
	module.exports = scrollIntoView;

/***/ },
/* 1911 */
/***/ function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	function getClientPosition(elem) {
	  var box = undefined;
	  var x = undefined;
	  var y = undefined;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, computedStyle_) {
	  var val = '';
	  var d = elem.ownerDocument;
	  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	var getComputedStyleX = undefined;
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = undefined;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = undefined;
	  var j = undefined;
	  var i = undefined;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = undefined;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj != null && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, extra) {
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue == null || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  }
	  if (borderBoxValueOrIsBorderBox) {
	    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
	    return val + (extra === BORDER_INDEX ? 0 : padding);
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay(elem) {
	  var val = undefined;
	  var args = arguments;
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value += 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, val) {
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var old = getOffset(elem);
	  var ret = {};
	  var current = undefined;
	  var key = undefined;
	
	  for (key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      current = parseFloat(css(elem, key)) || 0;
	      ret[key] = current + offset[key] - old[key];
	    }
	  }
	  css(elem, ret);
	}
	
	module.exports = _extends({
	  getWindow: function getWindow(node) {
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value);
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var ret = {};
	    for (var i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (var i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  scrollLeft: function scrollLeft(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollLeft(w);
	      }
	      window.scrollTo(v, getScrollTop(w));
	    } else {
	      if (v === undefined) {
	        return w.scrollLeft;
	      }
	      w.scrollLeft = v;
	    }
	  },
	  scrollTop: function scrollTop(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollTop(w);
	      }
	      window.scrollTo(getScrollLeft(w), v);
	    } else {
	      if (v === undefined) {
	        return w.scrollTop;
	      }
	      w.scrollTop = v;
	    }
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	}, domUtils);

/***/ },
/* 1912 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var BlockMapBuilder = __webpack_require__(225);
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(148);
	var ContentBlockNode = __webpack_require__(78);
	var DraftFeatureFlags = __webpack_require__(125);
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	var Immutable = __webpack_require__(26);
	var SelectionState = __webpack_require__(184);
	
	var generateRandomKey = __webpack_require__(108);
	var moveBlockInContentState = __webpack_require__(1972);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var atomicBlockConfig = {
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    };
	
	    var atomicDividerBlockConfig = {
	      key: generateRandomKey(),
	      type: 'unstyled'
	    };
	
	    if (experimentalTreeDataSupport) {
	      atomicBlockConfig = _extends({}, atomicBlockConfig, {
	        nextSibling: atomicDividerBlockConfig.key
	      });
	      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
	        prevSibling: atomicBlockConfig.key
	      });
	    }
	
	    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  },
	
	  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var withMovedAtomicBlock = void 0;
	
	    if (insertionMode === 'before' || insertionMode === 'after') {
	      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
	
	      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
	    } else {
	      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
	
	      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
	      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
	
	      if (selectionAfterRemoval.getStartOffset() === 0) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
	      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
	      } else {
	        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
	
	        var selectionAfterSplit = afterSplit.getSelectionAfter();
	        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
	
	        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
	      }
	    }
	
	    var newContent = withMovedAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'move-block');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Immutable = __webpack_require__(26);
	
	var List = Immutable.List;
	
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	      var callback = function callback( /*number*/start, /*number*/end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      };
	      strategy(block, callback, contentState);
	    });
	
	    return List(decorations);
	  };
	
	  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	
	var _require = __webpack_require__(26),
	    Map = _require.Map;
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @format
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(423);
	var DefaultDraftInlineStyle = __webpack_require__(911);
	var DraftEditorCompositionHandler = __webpack_require__(1916);
	var DraftEditorContents = __webpack_require__(1918);
	var DraftEditorDragHandler = __webpack_require__(1919);
	var DraftEditorEditHandler = __webpack_require__(1920);
	var DraftEditorPlaceholder = __webpack_require__(1922);
	var EditorState = __webpack_require__(32);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(14);
	var Scroll = __webpack_require__(943);
	var Style = __webpack_require__(432);
	var UserAgent = __webpack_require__(97);
	
	var cx = __webpack_require__(186);
	var emptyFunction = __webpack_require__(67);
	var generateRandomKey = __webpack_require__(108);
	var getDefaultKeyBinding = __webpack_require__(918);
	var getScrollPosition = __webpack_require__(435);
	var invariant = __webpack_require__(18);
	var nullthrows = __webpack_require__(84);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  edit: DraftEditorEditHandler,
	  composite: DraftEditorCompositionHandler,
	  drag: DraftEditorDragHandler,
	  cut: null,
	  render: null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	var DraftEditor = function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  function DraftEditor(props) {
	    _classCallCheck(this, DraftEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.focus = function (scrollPosition) {
	      var editorState = _this.props.editorState;
	
	      var alreadyHasFocus = editorState.getSelection().getHasFocus();
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	
	      if (!editorNode) {
	        // once in a while people call 'focus' in a setTimeout, and the node has
	        // been deleted, so it can be null in that case.
	        return;
	      }
	
	      var scrollParent = Style.getScrollParent(editorNode);
	
	      var _ref = scrollPosition || getScrollPosition(scrollParent),
	          x = _ref.x,
	          y = _ref.y;
	
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.focus();
	
	      // Restore scroll position
	      if (scrollParent === window) {
	        window.scrollTo(x, y);
	      } else {
	        Scroll.setTop(scrollParent, y);
	      }
	
	      // On Chrome and Safari, calling focus on contenteditable focuses the
	      // cursor at the first character. This is something you don't expect when
	      // you're clicking on an input element but not directly on a character.
	      // Put the cursor back where it was before the blur.
	      if (!alreadyHasFocus) {
	        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	      }
	    };
	
	    _this.blur = function () {
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.blur();
	    };
	
	    _this.setMode = function (mode) {
	      _this._handler = handlerMap[mode];
	    };
	
	    _this.exitCurrentMode = function () {
	      _this.setMode('edit');
	    };
	
	    _this.restoreEditorDOM = function (scrollPosition) {
	      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
	        _this.focus(scrollPosition);
	      });
	    };
	
	    _this.setClipboard = function (clipboard) {
	      _this._clipboard = clipboard;
	    };
	
	    _this.getClipboard = function () {
	      return _this._clipboard;
	    };
	
	    _this.update = function (editorState) {
	      _this._latestEditorState = editorState;
	      _this.props.onChange(editorState);
	    };
	
	    _this.onDragEnter = function () {
	      _this._dragCount++;
	    };
	
	    _this.onDragLeave = function () {
	      _this._dragCount--;
	      if (_this._dragCount === 0) {
	        _this.exitCurrentMode();
	      }
	    };
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = props.editorKey || generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	    _this._latestEditorState = props.editorState;
	    _this._latestCommittedEditorState = props.editorState;
	
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	
	    // See `restoreEditorDOM()`.
	    _this.state = { contentsKey: 0 };
	    return _this;
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	
	
	  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	        method && method(_this2, e);
	      }
	    };
	  };
	
	  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      var placeHolderProps = {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      };
	
	      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
	    }
	    return null;
	  };
	
	  DraftEditor.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleFn = _props.customStyleFn,
	        customStyleMap = _props.customStyleMap,
	        editorState = _props.editorState,
	        readOnly = _props.readOnly,
	        textAlignment = _props.textAlignment,
	        textDirectionality = _props.textDirectionality;
	
	
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	
	    var contentStyle = {
	      outline: 'none',
	      // fix parent-draggable Safari bug. #1326
	      userSelect: 'text',
	      WebkitUserSelect: 'text',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    };
	
	    // The aria-expanded and aria-haspopup properties should only be rendered
	    // for a combobox.
	    var ariaRole = this.props.role || 'textbox';
	    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
	
	    var editorContentsProps = {
	      blockRenderMap: blockRenderMap,
	      blockRendererFn: blockRendererFn,
	      blockStyleFn: blockStyleFn,
	      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
	      customStyleFn: customStyleFn,
	      editorKey: this._editorKey,
	      editorState: editorState,
	      key: 'contents' + this.state.contentsKey,
	      textDirectionality: textDirectionality
	    };
	
	    return React.createElement(
	      'div',
	      { className: rootClass },
	      this._renderPlaceholder(),
	      React.createElement(
	        'div',
	        {
	          className: cx('DraftEditor/editorContainer'),
	          ref: function ref(_ref3) {
	            return _this3.editorContainer = _ref3;
	          } },
	        React.createElement(
	          'div',
	          {
	            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	            'aria-controls': readOnly ? null : this.props.ariaControls,
	            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
	            'aria-expanded': readOnly ? null : ariaExpanded,
	            'aria-label': this.props.ariaLabel,
	            'aria-labelledby': this.props.ariaLabelledBy,
	            'aria-multiline': this.props.ariaMultiline,
	            autoCapitalize: this.props.autoCapitalize,
	            autoComplete: this.props.autoComplete,
	            autoCorrect: this.props.autoCorrect,
	            className: cx({
	              // Chrome's built-in translation feature mutates the DOM in ways
	              // that Draft doesn't expect (ex: adding <font> tags inside
	              // DraftEditorLeaf spans) and causes problems. We add notranslate
	              // here which makes its autotranslation skip over this subtree.
	              notranslate: !readOnly,
	              'public/DraftEditor/content': true
	            }),
	            contentEditable: !readOnly,
	            'data-testid': this.props.webDriverTestID,
	            onBeforeInput: this._onBeforeInput,
	            onBlur: this._onBlur,
	            onCompositionEnd: this._onCompositionEnd,
	            onCompositionStart: this._onCompositionStart,
	            onCopy: this._onCopy,
	            onCut: this._onCut,
	            onDragEnd: this._onDragEnd,
	            onDragEnter: this.onDragEnter,
	            onDragLeave: this.onDragLeave,
	            onDragOver: this._onDragOver,
	            onDragStart: this._onDragStart,
	            onDrop: this._onDrop,
	            onFocus: this._onFocus,
	            onInput: this._onInput,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseUp: this._onMouseUp,
	            onPaste: this._onPaste,
	            onSelect: this._onSelect,
	            ref: function ref(_ref2) {
	              return _this3.editor = _ref2;
	            },
	            role: readOnly ? null : ariaRole,
	            spellCheck: allowSpellCheck && this.props.spellCheck,
	            style: contentStyle,
	            suppressContentEditableWarning: true,
	            tabIndex: this.props.tabIndex },
	          React.createElement(DraftEditorContents, editorContentsProps)
	        )
	      )
	    );
	  };
	
	  DraftEditor.prototype.componentDidMount = function componentDidMount() {
	    this.setMode('edit');
	
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	    if (isIE) {
	      document.execCommand('AutoUrlDetect', false, false);
	    }
	  };
	
	  /**
	   * Prevent selection events from affecting the current editor state. This
	   * is mostly intended to defend against IE, which fires off `selectionchange`
	   * events regardless of whether the selection is set via the browser or
	   * programmatically. We only care about selection events that occur because
	   * of browser interaction, not re-renders and forced selections.
	   */
	
	
	  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    this._blockSelectEvents = true;
	    this._latestEditorState = nextProps.editorState;
	  };
	
	  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	    this._latestCommittedEditorState = this.props.editorState;
	  };
	
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * We attempt to preserve scroll position when focusing. You can also pass
	   * a specified scroll position (for cases like `cut` behavior where it should
	   * be restored to a known position).
	   */
	
	
	  /**
	   * Used via `this.setMode(...)`.
	   *
	   * Set the behavior mode for the editor component. This switches the current
	   * handler module to ensure that DOM events are managed appropriately for
	   * the active mode.
	   */
	
	
	  /**
	   * Used via `this.restoreEditorDOM()`.
	   *
	   * Force a complete re-render of the DraftEditorContents based on the current
	   * EditorState. This is useful when we know we are going to lose control of
	   * the DOM state (cut command, IME) and we want to make sure that
	   * reconciliation occurs on a version of the DOM that is synchronized with
	   * our EditorState.
	   */
	
	
	  /**
	   * Used via `this.setClipboard(...)`.
	   *
	   * Set the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.getClipboard()`.
	   *
	   * Retrieve the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.update(...)`.
	   *
	   * Propagate a new `EditorState` object to higher-level components. This is
	   * the method by which event handlers inform the `DraftEditor` component of
	   * state changes. A component that composes a `DraftEditor` **must** provide
	   * an `onChange` prop to receive state updates passed along from this
	   * function.
	   */
	
	
	  /**
	   * Used in conjunction with `onDragLeave()`, by counting the number of times
	   * a dragged element enters and leaves the editor (or any of its children),
	   * to determine when the dragged element absolutely leaves the editor.
	   */
	
	
	  /**
	   * See `onDragEnter()`.
	   */
	
	
	  return DraftEditor;
	}(React.Component);
	
	DraftEditor.defaultProps = {
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: emptyFunction.thatReturnsNull,
	  blockStyleFn: emptyFunction.thatReturns(''),
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	};
	
	
	module.exports = DraftEditor;

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(125);
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	var Keys = __webpack_require__(431);
	
	var getEntityKeyForSelection = __webpack_require__(426);
	var isEventHandled = __webpack_require__(228);
	var isSelectionAtLeafStart = __webpack_require__(928);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(editor, e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart(editor) {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd(editor) {
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition(editor);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(editor, e) {
	    if (!stillComposing) {
	      // If a keydown event is received after compositionend but before the
	      // 20ms timer expires (ex: type option-E then backspace, or type A then
	      // backspace in 2-Set Korean), we should immediately resolve the
	      // composition and reinterpret the key press in edit mode.
	      DraftEditorCompositionHandler.resolveComposition(editor);
	      editor._onKeyDown(e);
	      return;
	    }
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(editor, e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition(editor) {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(editor._latestEditorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      editor.restoreEditorDOM();
	    }
	
	    editor.exitCurrentMode();
	
	    if (composedChars) {
	      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
	        return;
	      }
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      editor.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents-core.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(912);
	var DraftOffsetKey = __webpack_require__(226);
	var EditorState = __webpack_require__(32);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(186);
	var joinClasses = __webpack_require__(2023);
	var nullthrows = __webpack_require__(84);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	};
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	
	var DraftEditorContents = function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap();
	
	    // Text direction has changed for one or more blocks. We must re-render.
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode();
	
	    // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  DraftEditorContents.prototype.render = function render() {
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleMap = _props.customStyleMap,
	        customStyleFn = _props.customStyleFn,
	        editorState = _props.editorState,
	        editorKey = _props.editorKey,
	        textDirectionality = _props.textDirectionality;
	
	
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	
	    var blocksAsArray = content.getBlocksAsArray();
	    var processedBlocks = [];
	
	    var currentDepth = null;
	    var lastWrapperTemplate = null;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      var _block = blocksAsArray[ii];
	      var key = _block.getKey();
	      var blockType = _block.getType();
	
	      var customRenderer = blockRendererFn(_block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        contentState: content,
	        block: _block,
	        blockProps: customProps,
	        blockStyleFn: blockStyleFn,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        key: key,
	        offsetKey: offsetKey,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	
	      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
	      var wrapperTemplate = configForType.wrapper;
	
	      var Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = _block.getDepth();
	      var className = '';
	      if (blockStyleFn) {
	        className = blockStyleFn(_block);
	      }
	
	      // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	      if (Element === 'li') {
	        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
	        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      var childProps = {
	        className: className,
	        'data-block': true,
	        'data-editor': editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	      if (customEditable !== undefined) {
	        childProps = _extends({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));
	
	      processedBlocks.push({
	        block: child,
	        wrapperTemplate: wrapperTemplate,
	        key: key,
	        offsetKey: offsetKey
	      });
	
	      if (wrapperTemplate) {
	        currentDepth = _block.getDepth();
	      } else {
	        currentDepth = null;
	      }
	      lastWrapperTemplate = wrapperTemplate;
	    }
	
	    // Group contiguous runs of blocks that have the same wrapperTemplate
	    var outputBlocks = [];
	    for (var _ii = 0; _ii < processedBlocks.length;) {
	      var info = processedBlocks[_ii];
	      if (info.wrapperTemplate) {
	        var blocks = [];
	        do {
	          blocks.push(processedBlocks[_ii].block);
	          _ii++;
	        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        _ii++;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { 'data-contents': 'true' },
	      outputBlocks
	    );
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	module.exports = DraftEditorContents;

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEditorContents = __webpack_require__(1917);
	
	module.exports = DraftEditorContents;

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DataTransfer = __webpack_require__(942);
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	
	var findAncestorOffsetKey = __webpack_require__(425);
	var getTextContentFromFiles = __webpack_require__(925);
	var getUpdatedSelectionState = __webpack_require__(926);
	var isEventHandled = __webpack_require__(228);
	var nullthrows = __webpack_require__(84);
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (typeof document.caretRangeFromPoint === 'function') {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd(editor) {
	    editor.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(editor, e) {
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = editor._latestEditorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    editor.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
	      });
	      return;
	    }
	
	    var dragType = editor._internalDrag ? 'internal' : 'external';
	    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
	      return;
	    }
	
	    if (editor._internalDrag) {
	      editor.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(1939);
	var onBlur = __webpack_require__(1940);
	var onCompositionStart = __webpack_require__(1941);
	var onCopy = __webpack_require__(1942);
	var onCut = __webpack_require__(1943);
	var onDragOver = __webpack_require__(1944);
	var onDragStart = __webpack_require__(1945);
	var onFocus = __webpack_require__(1946);
	var onInput = __webpack_require__(1947);
	var onKeyDown = __webpack_require__(1948);
	var onPaste = __webpack_require__(1949);
	var onSelect = __webpack_require__(1950);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(1923);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(14);
	
	var invariant = __webpack_require__(18);
	var setDraftEditorSelection = __webpack_require__(1974);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
	    var selection = this.props.selection;
	
	    // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _props = this.props,
	        block = _props.block,
	        start = _props.start,
	        text = _props.text;
	
	    var blockKey = block.getKey();
	    var end = start + text.length;
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    }
	
	    // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	    var node = ReactDOM.findDOMNode(this);
	    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
	    var child = node.firstChild;
	    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
	    var targetNode = void 0;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (child.tagName === 'BR') {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	  /**
	   * By making individual leaf instances aware of their context within
	   * the text of the editor, we can set our selection range more
	   * easily than we could in the non-React world.
	   *
	   * Note that this depends on our maintaining tight control over the
	   * DOM structure of the DraftEditor component. If leaves had multiple
	   * text nodes, this would be harder.
	   */
	
	  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var leafNode = ReactDOM.findDOMNode(this.leaf);
	    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
	    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	  };
	
	  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.render = function render() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var text = this.props.text;
	
	    // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _props2 = this.props,
	        customStyleMap = _props2.customStyleMap,
	        customStyleFn = _props2.customStyleFn,
	        offsetKey = _props2.offsetKey,
	        styleSet = _props2.styleSet;
	
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet, block);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement(
	      'span',
	      {
	        'data-offset-key': offsetKey,
	        ref: function ref(_ref) {
	          return _this2.leaf = _ref;
	        },
	        style: styleObj },
	      React.createElement(
	        DraftEditorTextNode,
	        null,
	        text
	      )
	    );
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(186);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  DraftEditorPlaceholder.prototype.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	
	    var contentStyle = {
	      whiteSpace: 'pre-wrap'
	    };
	
	    return React.createElement(
	      'div',
	      { className: className },
	      React.createElement(
	        'div',
	        {
	          className: cx('public/DraftEditorPlaceholder/inner'),
	          id: this.props.accessibilityID,
	          style: contentStyle },
	        this.props.text
	      )
	    );
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(14);
	var UserAgent = __webpack_require__(97);
	
	var invariant = __webpack_require__(18);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = ReactDOM.findDOMNode(this);
	    var shouldBeNewline = nextProps.children === '';
	    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
	    if (shouldBeNewline) {
	      return !isNewline(node);
	    }
	    return node.textContent !== nextProps.children;
	  };
	
	  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.render = function render() {
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	    }
	    return React.createElement(
	      'span',
	      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	      this.props.children
	    );
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ },
/* 1924 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ },
/* 1925 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags-core
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = {
	  draft_killswitch_allow_nontextnodes: false,
	  draft_segmented_entities_behavior: false,
	  draft_handlebeforeinput_composed_text: false,
	  draft_tree_data_support: false
	};
	
	module.exports = DraftFeatureFlags;

/***/ },
/* 1926 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftJsDebugLogging
	 */
	
	'use strict';
	
	module.exports = {
	  logSelectionStateFailure: function logSelectionStateFailure() {
	    return null;
	  }
	};

/***/ },
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CharacterMetadata = __webpack_require__(71);
	var ContentBlock = __webpack_require__(148);
	var ContentBlockNode = __webpack_require__(78);
	var DraftFeatureFlags = __webpack_require__(125);
	var Immutable = __webpack_require__(26);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(917);
	var generateRandomKey = __webpack_require__(108);
	var getSafeBodyFromHTML = __webpack_require__(923);
	var sanitizeDraftText = __webpack_require__(428);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character, type) {
	    return textBlocks.reduce(function (acc, textLine, index) {
	      textLine = sanitizeDraftText(textLine);
	      var key = generateRandomKey();
	
	      var blockNodeConfig = {
	        key: key,
	        type: type,
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      };
	
	      // next block updates previous block
	      if (experimentalTreeDataSupport && index !== 0) {
	        var prevSiblingIndex = index - 1;
	        // update previous block
	        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
	          nextSibling: key
	        });
	        blockNodeConfig = _extends({}, blockNodeConfig, {
	          prevSibling: previousBlock.getKey()
	        });
	      }
	
	      acc.push(new ContentBlockRecord(blockNodeConfig));
	
	      return acc;
	    }, []);
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftTreeAdapter
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var invariant = __webpack_require__(18);
	
	var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
	  var stack = [].concat(blocks).reverse();
	  while (stack.length) {
	    var _block = stack.pop();
	
	    fn(_block);
	
	    var children = _block.children;
	
	    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
	
	    stack = stack.concat([].concat(children.reverse()));
	  }
	};
	
	var isListBlock = function isListBlock(block) {
	  if (!(block && block.type)) {
	    return false;
	  }
	  var type = block.type;
	
	  return type === 'unordered-list-item' || type === 'ordered-list-item';
	};
	
	var addDepthToChildren = function addDepthToChildren(block) {
	  if (Array.isArray(block.children)) {
	    block.children = block.children.map(function (child) {
	      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
	    });
	  }
	};
	
	/**
	 * This adapter is intended to be be used as an adapter to draft tree data
	 *
	 * draft state <=====> draft tree state
	 */
	var DraftTreeAdapter = {
	  /**
	   * Converts from a tree raw state back to  draft raw state
	   */
	  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
	    var blocks = draftTreeState.blocks;
	
	    var transformedBlocks = [];
	
	    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;
	
	    if (!Array.isArray(blocks) || !blocks.length) {
	      return draftTreeState;
	    }
	
	    traverseInDepthOrder(blocks, function (block) {
	      var newBlock = _extends({}, block);
	
	      if (isListBlock(block)) {
	        newBlock.depth = newBlock.depth || 0;
	        addDepthToChildren(block);
	      }
	
	      delete newBlock.children;
	
	      transformedBlocks.push(newBlock);
	    });
	
	    draftTreeState.blocks = transformedBlocks;
	
	    return _extends({}, draftTreeState, {
	      blocks: transformedBlocks
	    });
	  },
	
	
	  /**
	   * Converts from draft raw state to tree draft state
	   */
	  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
	    var lastListDepthCacheRef = {};
	    var transformedBlocks = [];
	
	    draftState.blocks.forEach(function (block) {
	      var isList = isListBlock(block);
	      var depth = block.depth || 0;
	      var treeBlock = _extends({}, block, {
	        children: []
	      });
	
	      if (!isList) {
	        // reset the cache path
	        lastListDepthCacheRef = {};
	        transformedBlocks.push(treeBlock);
	        return;
	      }
	
	      // update our depth cache reference path
	      lastListDepthCacheRef[depth] = treeBlock;
	
	      // if we are greater than zero we must have seen a parent already
	      if (depth > 0) {
	        var parent = lastListDepthCacheRef[depth - 1];
	
	        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;
	
	        // push nested list blocks
	        parent.children.push(treeBlock);
	        return;
	      }
	
	      // push root list blocks
	      transformedBlocks.push(treeBlock);
	    });
	
	    return _extends({}, draftState, {
	      blocks: transformedBlocks
	    });
	  }
	};
	
	module.exports = DraftTreeAdapter;

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	var UnicodeBidiService = __webpack_require__(2008);
	
	var nullthrows = __webpack_require__(84);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	
	var getContentStateFragment = __webpack_require__(297);
	var nullthrows = __webpack_require__(84);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ },
/* 1931 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var applyEntityToContentBlock = __webpack_require__(1932);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(148);
	var ContentBlockNode = __webpack_require__(78);
	var DraftStringKey = __webpack_require__(915);
	
	var encodeEntityRanges = __webpack_require__(1951);
	var encodeInlineStyleRanges = __webpack_require__(1952);
	var invariant = __webpack_require__(18);
	
	var createRawBlock = function createRawBlock(block, entityStorageMap) {
	  return {
	    key: block.getKey(),
	    text: block.getText(),
	    type: block.getType(),
	    depth: block.getDepth(),
	    inlineStyleRanges: encodeInlineStyleRanges(block),
	    entityRanges: encodeEntityRanges(block, entityStorageMap),
	    data: block.getData().toObject()
	  };
	};
	
	var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
	  if (block instanceof ContentBlock) {
	    rawBlocks.push(createRawBlock(block, entityMap));
	    return;
	  }
	
	  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
	
	  var parentKey = block.getParentKey();
	  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
	    children: []
	  });
	
	  if (parentKey) {
	    blockCacheRef[parentKey].children.push(rawBlock);
	    return;
	  }
	
	  rawBlocks.push(rawBlock);
	};
	
	var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
	  var entityMap = rawState.entityMap;
	
	
	  var rawBlocks = [];
	
	  var blockCacheRef = {};
	  var entityCacheRef = {};
	  var entityStorageKey = 0;
	
	  contentState.getBlockMap().forEach(function (block) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      var entityKey = block.getEntityAt(start);
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
	      // This makes this function resilient to two entities
	      // erroneously having the same key
	      if (entityCacheRef[stringifiedEntityKey]) {
	        return;
	      }
	      entityCacheRef[stringifiedEntityKey] = entityKey;
	      // we need the `any` casting here since this is a temporary state
	      // where we will later on flip the entity map and populate it with
	      // real entity, at this stage we just need to map back the entity
	      // key used by the BlockNode
	      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
	      entityStorageKey++;
	    });
	
	    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
	  });
	
	  return {
	    blocks: rawBlocks,
	    entityMap: entityMap
	  };
	};
	
	// Flip storage map so that our storage keys map to global
	// DraftEntity keys.
	var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
	  var blocks = rawState.blocks,
	      entityMap = rawState.entityMap;
	
	
	  var rawEntityMap = {};
	
	  Object.keys(entityMap).forEach(function (key, index) {
	    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
	    rawEntityMap[index] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    blocks: blocks,
	    entityMap: rawEntityMap
	  };
	};
	
	var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
	  var rawDraftContentState = {
	    entityMap: {},
	    blocks: []
	  };
	
	  // add blocks
	  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);
	
	  // add entities
	  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
	
	  return rawDraftContentState;
	};
	
	module.exports = convertFromDraftStateToRaw;

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(148);
	var ContentBlockNode = __webpack_require__(78);
	var ContentState = __webpack_require__(422);
	var DraftEntity = __webpack_require__(296);
	var DraftFeatureFlags = __webpack_require__(125);
	var DraftTreeAdapter = __webpack_require__(1928);
	var Immutable = __webpack_require__(26);
	var SelectionState = __webpack_require__(184);
	
	var createCharacterList = __webpack_require__(1936);
	var decodeEntityRanges = __webpack_require__(1937);
	var decodeInlineStyleRanges = __webpack_require__(1938);
	var generateRandomKey = __webpack_require__(108);
	var invariant = __webpack_require__(18);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedMap = Immutable.OrderedMap;
	
	
	var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
	  var key = block.key,
	      type = block.type,
	      data = block.data,
	      text = block.text,
	      depth = block.depth;
	
	
	  var blockNodeConfig = {
	    text: text,
	    depth: depth || 0,
	    type: type || 'unstyled',
	    key: key || generateRandomKey(),
	    data: Map(data),
	    characterList: decodeCharacterList(block, entityMap)
	  };
	
	  return blockNodeConfig;
	};
	
	var decodeCharacterList = function decodeCharacterList(block, entityMap) {
	  var text = block.text,
	      rawEntityRanges = block.entityRanges,
	      rawInlineStyleRanges = block.inlineStyleRanges;
	
	
	  var entityRanges = rawEntityRanges || [];
	  var inlineStyleRanges = rawInlineStyleRanges || [];
	
	  // Translate entity range keys to the DraftEntity map.
	  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
	    return entityMap.hasOwnProperty(range.key);
	  }).map(function (range) {
	    return _extends({}, range, { key: entityMap[range.key] });
	  })));
	};
	
	var addKeyIfMissing = function addKeyIfMissing(block) {
	  return _extends({}, block, {
	    key: block.key || generateRandomKey()
	  });
	};
	
	/**
	 * Node stack is responsible to ensure we traverse the tree only once
	 * in depth order, while also providing parent refs to inner nodes to
	 * construct their links.
	 */
	var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
	  var nodesWithParentRef = nodes.map(function (block) {
	    return _extends({}, block, {
	      parentRef: parentRef
	    });
	  });
	
	  // since we pop nodes from the stack we need to insert them in reverse
	  return stack.concat(nodesWithParentRef.reverse());
	};
	
	/**
	 * This will build a tree draft content state by creating the node
	 * reference links into a single tree walk. Each node has a link
	 * reference to "parent", "children", "nextSibling" and "prevSibling"
	 * blockMap will be created using depth ordering.
	 */
	var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
	  return blocks
	  // ensure children have valid keys to enable sibling links
	  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
	    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	
	    // ensure children have valid keys to enable sibling links
	    var children = block.children.map(addKeyIfMissing);
	
	    // root level nodes
	    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
	      prevSibling: index === 0 ? null : blocks[index - 1].key,
	      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
	      children: List(children.map(function (child) {
	        return child.key;
	      }))
	    }));
	
	    // push root node to blockMap
	    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);
	
	    // this stack is used to ensure we visit all nodes respecting depth ordering
	    var stack = updateNodeStack([], children, contentBlockNode);
	
	    // start computing children nodes
	    while (stack.length > 0) {
	      // we pop from the stack and start processing this node
	      var node = stack.pop();
	
	      // parentRef already points to a converted ContentBlockNode
	      var parentRef = node.parentRef;
	      var siblings = parentRef.getChildKeys();
	      var _index = siblings.indexOf(node.key);
	      var isValidBlock = Array.isArray(node.children);
	
	      if (!isValidBlock) {
	        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	        break;
	      }
	
	      // ensure children have valid keys to enable sibling links
	      var _children = node.children.map(addKeyIfMissing);
	
	      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
	        parent: parentRef.getKey(),
	        children: List(_children.map(function (child) {
	          return child.key;
	        })),
	        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
	        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
	      }));
	
	      // push node to blockMap
	      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);
	
	      // this stack is used to ensure we visit all nodes respecting depth ordering
	      stack = updateNodeStack(stack, _children, _contentBlockNode);
	    }
	
	    return blockMap;
	  }, OrderedMap());
	};
	
	var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
	  return OrderedMap(blocks.map(function (block) {
	    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
	    return [contentBlock.getKey(), contentBlock];
	  }));
	};
	
	var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
	  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
	  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;
	
	  if (!experimentalTreeDataSupport) {
	    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
	  }
	
	  return decodeContentBlockNodes(rawBlocks, entityMap);
	};
	
	var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
	  var rawEntityMap = rawState.entityMap;
	
	  var entityMap = {};
	
	  // TODO: Update this once we completely remove DraftEntity
	  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
	    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
	        type = _rawEntityMap$rawEnti.type,
	        mutability = _rawEntityMap$rawEnti.mutability,
	        data = _rawEntityMap$rawEnti.data;
	
	    // get the key reference to created entity
	
	    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
	  });
	
	  return entityMap;
	};
	
	var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
	  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;
	
	  // decode entities
	  var entityMap = decodeRawEntityMap(rawState);
	
	  // decode blockMap
	  var blockMap = decodeRawBlocks(rawState, entityMap);
	
	  // create initial selection
	  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	
	  return new ContentState({
	    blockMap: blockMap,
	    entityMap: entityMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	};
	
	module.exports = convertFromRawToDraftState;

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(71);
	var Immutable = __webpack_require__(26);
	
	var List = Immutable.List;
	
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(149);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(26),
	    OrderedSet = _require.OrderedSet;
	
	var UnicodeUtils = __webpack_require__(149);
	
	var substr = UnicodeUtils.substr;
	
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockTree = __webpack_require__(910);
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	var UserAgent = __webpack_require__(97);
	
	var getEntityKeyForSelection = __webpack_require__(426);
	var isEventHandled = __webpack_require__(228);
	var isSelectionAtLeafStart = __webpack_require__(928);
	var nullthrows = __webpack_require__(84);
	var setImmediate = __webpack_require__(2026);
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	var FF_QUICKFIND_CHAR = "'";
	var FF_QUICKFIND_LINK_CHAR = '/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(editor, e) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var editorState = editor._latestEditorState;
	
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var selection = editorState.getSelection();
	  var selectionStart = selection.getStartOffset();
	  var selectionEnd = selection.getEndOffset();
	  var anchorKey = selection.getAnchorKey();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	
	    // If the currently selected text matches what the user is trying to
	    // replace it with, let's just update the `SelectionState`. If not, update
	    // the `ContentState` with the new text.
	    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
	    if (chars === currentlySelectedChars) {
	      editor.update(EditorState.forceSelection(editorState, selection.merge({
	        focusOffset: selectionEnd
	      })));
	    } else {
	      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    }
	    return;
	  }
	
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  // Bunch of different cases follow where we need to prevent native insertion.
	  var mustPreventNative = false;
	  if (!mustPreventNative) {
	    // Browsers tend to insert text in weird places in the DOM when typing at
	    // the start of a leaf, so we'll handle it ourselves.
	    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
	  }
	  if (!mustPreventNative) {
	    // Chrome will also split up a node into two pieces if it contains a Tab
	    // char, for no explicable reason. Seemingly caused by this commit:
	    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
	    var nativeSelection = global.getSelection();
	    // Selection is necessarily collapsed at this point due to earlier check.
	    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
	      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
	      var parentNode = nativeSelection.anchorNode.parentNode;
	      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
	    }
	  }
	  if (!mustPreventNative) {
	    // Check the old and new "fingerprints" of the current block to determine
	    // whether this insertion requires any addition or removal of text nodes,
	    // in which case we would prevent the native character insertion.
	    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
	    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	    mustPreventNative = originalFingerprint !== newFingerprint;
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = mustPreventDefaultForCharacter(chars);
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
	  }
	
	  if (mustPreventNative) {
	    e.preventDefault();
	    editor.update(newEditorState);
	    return;
	  }
	
	  // We made it all the way! Let the browser do its thing and insert the char.
	  newEditorState = EditorState.set(newEditorState, {
	    nativelyRenderedContent: newEditorState.getCurrentContent()
	  });
	  // The native event is allowed to occur. To allow user onChange handlers to
	  // change the inserted text, we wait until the text is actually inserted
	  // before we actually update our state. That way when we rerender, the text
	  // we see in the DOM will already have been inserted properly.
	  editor._pendingStateFromBeforeInput = newEditorState;
	  setImmediate(function () {
	    if (editor._pendingStateFromBeforeInput !== undefined) {
	      editor.update(editor._pendingStateFromBeforeInput);
	      editor._pendingStateFromBeforeInput = undefined;
	    }
	  });
	}
	
	module.exports = editOnBeforeInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	
	var containsNode = __webpack_require__(299);
	var getActiveElement = __webpack_require__(434);
	
	function editOnBlur(editor, e) {
	  // In a contentEditable element, when you select a range and then click
	  // another active element, this does trigger a `blur` event but will not
	  // remove the DOM selection from the contenteditable.
	  // This is consistent across all browsers, but we prefer that the editor
	  // behave like a textarea, where a `blur` event clears the DOM selection.
	  // We therefore force the issue to be certain, checking whether the active
	  // element is `body` to force it when blurring occurs within the window (as
	  // opposed to clicking to another tab or window).
	  if (getActiveElement() === document.body) {
	    var _selection = global.getSelection();
	    var editorNode = editor.editor;
	    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
	      _selection.removeAllRanges();
	    }
	  }
	
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  editor.props.onBlur && editor.props.onBlur(e);
	  editor.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart(editor, e) {
	  editor.setMode('composite');
	  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
	  // Allow composition handler to interpret the compositionstart event
	  editor._onCompositionStart(e);
	}
	
	module.exports = editOnCompositionStart;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(920);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
	}
	
	module.exports = editOnCopy;

/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	var Style = __webpack_require__(432);
	
	var getFragmentFromSelection = __webpack_require__(920);
	var getScrollPosition = __webpack_require__(435);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	  var element = e.target;
	  var scrollPosition = void 0;
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  if (element instanceof Node) {
	    scrollPosition = getScrollPosition(Style.getScrollParent(element));
	  }
	
	  var fragment = getFragmentFromSelection(editorState);
	  editor.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  editor.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    editor.restoreEditorDOM(scrollPosition);
	    editor.exitCurrentMode();
	    editor.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ },
/* 1944 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	function editOnDragOver(editor, e) {
	  editor._internalDrag = false;
	  editor.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ },
/* 1945 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	function editOnDragStart(editor) {
	  editor._internalDrag = true;
	  editor.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	var UserAgent = __webpack_require__(97);
	
	function editOnFocus(editor, e) {
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  editor.props.onFocus && editor.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  // But it looks like this is fixed in Chrome 60.0.3081.0.
	  // Other browsers also don't have this bug, so we prefer to acceptSelection
	  // when possible, to ensure that unfocusing and refocusing a Draft editor
	  // doesn't preserve the selection, matching how textareas work.
	  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
	    editor.update(EditorState.forceSelection(editorState, selection));
	  } else {
	    editor.update(EditorState.acceptSelection(editorState, selection));
	  }
	}
	
	module.exports = editOnFocus;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(125);
	var DraftModifier = __webpack_require__(66);
	var DraftOffsetKey = __webpack_require__(226);
	var EditorState = __webpack_require__(32);
	var UserAgent = __webpack_require__(97);
	
	var findAncestorOffsetKey = __webpack_require__(425);
	var nullthrows = __webpack_require__(84);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput(editor) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode,
	      isCollapsed = domSelection.isCollapsed;
	
	  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
	  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;
	
	  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
	    if (isNotTextNode) {
	      return;
	    }
	  } else {
	    if (isNotTextOrElementNode) {
	      // TODO: (t16149272) figure out context for this change
	      return;
	    }
	  }
	
	  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
	    // When typing at the beginning of a visual line, Chrome splits the text
	    // nodes into two. Why? No one knows. This commit is suspicious:
	    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
	    // To work around, we'll merge the sibling text nodes back into this one.
	    var span = anchorNode.parentNode;
	    anchorNode.nodeValue = span.textContent;
	    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
	      if (child !== anchorNode) {
	        span.removeChild(child);
	      }
	    }
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = editor._latestEditorState;
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
	      blockKey = _DraftOffsetKey$decod.blockKey,
	      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
	      leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
	      start = _editorState$getBlock.start,
	      end = _editorState$getBlock.end;
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    // This can be buggy for some Android keyboards because they don't fire
	    // standard onkeydown/pressed events and only fired editOnInput
	    // so domText is already changed by the browser and ends up being equal
	    // to modelText unexpectedly
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && content.getEntity(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	var KeyBindingUtil = __webpack_require__(424);
	var Keys = __webpack_require__(431);
	var SecondaryClipboard = __webpack_require__(1930);
	var UserAgent = __webpack_require__(97);
	
	var isEventHandled = __webpack_require__(228);
	var keyCommandBackspaceToStartOfLine = __webpack_require__(1961);
	var keyCommandBackspaceWord = __webpack_require__(1962);
	var keyCommandDeleteWord = __webpack_require__(1963);
	var keyCommandInsertNewline = __webpack_require__(1964);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(1965);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(1966);
	var keyCommandPlainBackspace = __webpack_require__(1967);
	var keyCommandPlainDelete = __webpack_require__(1968);
	var keyCommandTransposeCharacters = __webpack_require__(1969);
	var keyCommandUndo = __webpack_require__(1970);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(editor, e) {
	  var keyCode = e.which;
	  var editorState = editor._latestEditorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      editor.props.onEscape && editor.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      editor.props.onTab && editor.props.onTab(e);
	      return;
	    case Keys.UP:
	      editor.props.onUpArrow && editor.props.onUpArrow(e);
	      return;
	    case Keys.RIGHT:
	      editor.props.onRightArrow && editor.props.onRightArrow(e);
	      return;
	    case Keys.DOWN:
	      editor.props.onDownArrow && editor.props.onDownArrow(e);
	      return;
	    case Keys.LEFT:
	      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
	        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = editor.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, editor.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    editor.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(225);
	var CharacterMetadata = __webpack_require__(71);
	var DataTransfer = __webpack_require__(942);
	var DraftModifier = __webpack_require__(66);
	var DraftPasteProcessor = __webpack_require__(1927);
	var EditorState = __webpack_require__(32);
	var RichTextEditorUtil = __webpack_require__(916);
	
	var getEntityKeyForSelection = __webpack_require__(426);
	var getTextContentFromFiles = __webpack_require__(925);
	var isEventHandled = __webpack_require__(228);
	var splitTextIntoTextBlocks = __webpack_require__(1976);
	
	/**
	 * Paste content.
	 */
	function editOnPaste(editor, e) {
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = editor._latestEditorState;
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	  var editorState = editor._latestEditorState;
	
	  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!editor.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = editor.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(editor.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	      return;
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
	      if (htmlFragment) {
	        var contentBlocks = htmlFragment.contentBlocks,
	            entityMap = htmlFragment.entityMap;
	
	        if (contentBlocks) {
	          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
	          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
	          return;
	        }
	      }
	    }
	
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    editor.setClipboard(null);
	  }
	
	  if (textBlocks.length) {
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    editor.update(insertFragment(editor._latestEditorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment, entityMap) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  // TODO: merge the entity map once we stop using DraftEntity
	  // like this:
	  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);
	
	  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	var ReactDOM = __webpack_require__(14);
	
	var getDraftEditorSelection = __webpack_require__(1955);
	var invariant = __webpack_require__(18);
	
	function editOnSelect(editor) {
	  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
	    return;
	  }
	
	  var editorState = editor.props.editorState;
	  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
	  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
	  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
	  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    editor.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(915);
	var UnicodeUtils = __webpack_require__(149);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(149);
	
	var findRangesImmutable = __webpack_require__(227);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @format
	 * 
	 */
	
	var UnicodeUtils = __webpack_require__(149);
	
	var getRangeClientRects = __webpack_require__(922);
	var invariant = __webpack_require__(18);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  var documentBody = document.body;
	  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;
	
	  // forced layout here
	  documentBody.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  documentBody.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEntitySegments = __webpack_require__(1924);
	
	var getRangesForDraftEntity = __webpack_require__(1957);
	var invariant = __webpack_require__(18);
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var startEntityKey = startBlock.getEntityAt(start);
	  var endEntityKey = endBlock.getEntityAt(end - 1);
	  if (!startEntityKey && !endEntityKey) {
	    return selectionState;
	  }
	  var newSelectionState = selectionState;
	  if (startEntityKey && startEntityKey === endEntityKey) {
	    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
	  } else if (startEntityKey && endEntityKey) {
	    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: startSelectionState.getAnchorOffset(),
	      focusOffset: endSelectionState.getFocusOffset(),
	      isBackward: false
	    });
	  } else if (startEntityKey) {
	    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: _startSelectionState.getStartOffset(),
	      isBackward: false
	    });
	  } else if (endEntityKey) {
	    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      focusOffset: _endSelectionState.getEndOffset(),
	      isBackward: false
	    });
	  }
	  return newSelectionState;
	}
	
	function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entity = entityMap.__get(entityKey);
	  var mutability = entity.getMutability();
	  var sideToConsider = isEntityAtStart ? start : end;
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return sideToConsider <= range.end && sideToConsider >= range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  if (!isEntireSelectionWithinEntity) {
	    if (isEntityAtStart) {
	      end = entityRange.end;
	    } else {
	      start = entityRange.start;
	    }
	  }
	
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(919);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeClientRects = __webpack_require__(922);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    // If the first rectangle has 0 width, we use the second, this is needed
	    // because Chrome renders a 0 width rectangle when the selection contains
	    // a line break.
	    if (rects.length > 1 && rects[0].width === 0) {
	      var _rects$ = rects[1];
	      top = _rects$.top;
	      right = _rects$.right;
	      bottom = _rects$.bottom;
	      left = _rects$.left;
	    } else {
	      var _rects$2 = rects[0];
	      top = _rects$2.top;
	      right = _rects$2.right;
	      bottom = _rects$2.bottom;
	      left = _rects$2.left;
	    }
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 && rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(1956);
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top,
	      right = boundingRect.right,
	      bottom = boundingRect.bottom,
	      left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(225);
	var ContentBlockNode = __webpack_require__(78);
	var Immutable = __webpack_require__(26);
	
	var insertIntoList = __webpack_require__(927);
	var invariant = __webpack_require__(18);
	var randomizeBlockMapKeys = __webpack_require__(930);
	
	var List = Immutable.List;
	
	
	var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
	  var targetBlock = blockMap.get(targetKey);
	  var text = targetBlock.getText();
	  var chars = targetBlock.getCharacterList();
	  var finalKey = targetKey;
	  var finalOffset = targetOffset + fragmentBlock.getText().length;
	
	  var newBlock = targetBlock.merge({
	    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
	    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
	    data: fragmentBlock.getData()
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.set(targetKey, newBlock),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Appends text/characterList from the fragment first block to
	 * target block.
	 */
	var updateHead = function updateHead(block, targetOffset, fragment) {
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var headText = text.slice(0, targetOffset);
	  var headCharacters = chars.slice(0, targetOffset);
	  var appendToHead = fragment.first();
	
	  return block.merge({
	    text: headText + appendToHead.getText(),
	    characterList: headCharacters.concat(appendToHead.getCharacterList()),
	    type: headText ? block.getType() : appendToHead.getType(),
	    data: appendToHead.getData()
	  });
	};
	
	/**
	 * Appends offset text/characterList from the target block to the last
	 * fragment block.
	 */
	var updateTail = function updateTail(block, targetOffset, fragment) {
	  // Modify tail portion of block.
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var blockSize = text.length;
	  var tailText = text.slice(targetOffset, blockSize);
	  var tailCharacters = chars.slice(targetOffset, blockSize);
	  var prependToTail = fragment.last();
	
	  return prependToTail.merge({
	    text: prependToTail.getText() + tailText,
	    characterList: prependToTail.getCharacterList().concat(tailCharacters),
	    data: prependToTail.getData()
	  });
	};
	
	var getRootBlocks = function getRootBlocks(block, blockMap) {
	  var headKey = block.getKey();
	  var rootBlock = block;
	  var rootBlocks = [];
	
	  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
	  // the fragment head is used to update the target block, however when this does not happen we need
	  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
	  // fragment root block
	  if (blockMap.get(headKey)) {
	    rootBlocks.push(headKey);
	  }
	
	  while (rootBlock && rootBlock.getNextSiblingKey()) {
	    var lastSiblingKey = rootBlock.getNextSiblingKey();
	
	    if (!lastSiblingKey) {
	      break;
	    }
	
	    rootBlocks.push(lastSiblingKey);
	    rootBlock = blockMap.get(lastSiblingKey);
	  }
	
	  return rootBlocks;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
	  return blockMap.withMutations(function (blockMapState) {
	    var targetKey = targetBlock.getKey();
	    var headKey = fragmentHeadBlock.getKey();
	    var targetNextKey = targetBlock.getNextSiblingKey();
	    var targetParentKey = targetBlock.getParentKey();
	    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
	    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];
	
	    if (blockMapState.get(headKey)) {
	      // update the fragment head when it is part of the blockMap otherwise
	      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
	      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
	    } else {
	      // update the target block that had the fragment head contents merged into it
	      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
	      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
	    }
	
	    // update the last root block fragment
	    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);
	
	    // update the original target next block
	    if (targetNextKey) {
	      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
	    }
	
	    // update fragment parent links
	    fragmentRootBlocks.forEach(function (blockKey) {
	      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
	    });
	
	    // update targetBlock parent child links
	    if (targetParentKey) {
	      var targetParent = blockMap.get(targetParentKey);
	      var originalTargetParentChildKeys = targetParent.getChildKeys();
	
	      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
	      var insertionIndex = targetBlockIndex + 1;
	
	      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();
	
	      // insert fragment children
	      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
	
	      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
	    }
	  });
	};
	
	var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	  var newBlockArr = [];
	  var fragmentSize = fragment.size;
	  var target = blockMap.get(targetKey);
	  var head = fragment.first();
	  var tail = fragment.last();
	  var finalOffset = tail.getLength();
	  var finalKey = tail.getKey();
	  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
	
	  blockMap.forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    if (shouldNotUpdateFromFragmentBlock) {
	      newBlockArr.push(block);
	    } else {
	      newBlockArr.push(updateHead(block, targetOffset, fragment));
	    }
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment
	    // when we are updating the target block with the head fragment block we skip the first fragment
	    // head since its contents have already been merged with the target block otherwise we include
	    // the whole fragment
	    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      return newBlockArr.push(fragmentBlock);
	    });
	
	    // update tail
	    newBlockArr.push(updateTail(block, targetOffset, fragment));
	  });
	
	  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);
	
	  if (isTreeBasedBlockMap) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var targetBlock = blockMap.get(targetKey);
	
	  if (targetBlock instanceof ContentBlockNode) {
	    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
	  }
	
	  // When we insert a fragment with a single block we simply update the target block
	  // with the contents of the inserted fragment block
	  if (fragment.size === 1) {
	    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
	  }
	
	  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
	};
	
	module.exports = insertFragmentIntoContentState;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var insertIntoList = __webpack_require__(927);
	var invariant = __webpack_require__(18);
	
	var Repeat = Immutable.Repeat;
	
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	
	var expandRangeToStartOfLine = __webpack_require__(1953);
	var getDraftEditorSelectionWithNodes = __webpack_require__(919);
	var moveSelectionBackward = __webpack_require__(427);
	var removeTextWithStrategy = __webpack_require__(229);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(914);
	var EditorState = __webpack_require__(32);
	
	var moveSelectionBackward = __webpack_require__(427);
	var removeTextWithStrategy = __webpack_require__(229);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(914);
	var EditorState = __webpack_require__(32);
	
	var moveSelectionForward = __webpack_require__(929);
	var removeTextWithStrategy = __webpack_require__(229);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	var UnicodeUtils = __webpack_require__(149);
	
	var moveSelectionBackward = __webpack_require__(427);
	var removeTextWithStrategy = __webpack_require__(229);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	var UnicodeUtils = __webpack_require__(149);
	
	var moveSelectionForward = __webpack_require__(929);
	var removeTextWithStrategy = __webpack_require__(229);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(66);
	var EditorState = __webpack_require__(32);
	
	var getContentStateFragment = __webpack_require__(297);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(32);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule modifyBlockForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(26);
	
	var Map = Immutable.Map;
	
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(78);
	var Immutable = __webpack_require__(26);
	
	var getNextDelimiterBlockKey = __webpack_require__(921);
	var invariant = __webpack_require__(18);
	
	var OrderedMap = Immutable.OrderedMap,
	    List = Immutable.List;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
	  if (!isExperimentalTreeBlock) {
	    return blockMap;
	  }
	  // possible values of 'insertionMode' are: 'after', 'before'
	  var isInsertedAfterTarget = insertionMode === 'after';
	
	  var originalBlockKey = originalBlockToBeMoved.getKey();
	  var originalTargetKey = originalTargetBlock.getKey();
	  var originalParentKey = originalBlockToBeMoved.getParentKey();
	  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
	  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
	  var newParentKey = originalTargetBlock.getParentKey();
	  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
	  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
	
	  return blockMap.withMutations(function (blocks) {
	    // update old parent
	    transformBlock(originalParentKey, blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      return block.merge({
	        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
	      });
	    });
	
	    // update old prev
	    transformBlock(originalPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalNextSiblingKey
	      });
	    });
	
	    // update old next
	    transformBlock(originalNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalPrevSiblingKey
	      });
	    });
	
	    // update new next
	    transformBlock(newNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	
	    // update new prev
	    transformBlock(newPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalBlockKey
	      });
	    });
	
	    // update new parent
	    transformBlock(newParentKey, blocks, function (block) {
	      var newParentChildrenList = block.getChildKeys();
	      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
	
	      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
	
	      var newChildrenArray = newParentChildrenList.toArray();
	      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: newNextSiblingKey,
	        prevSibling: newPrevSiblingKey,
	        parent: newParentKey
	      });
	    });
	  });
	};
	
	var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
	  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
	
	  var targetKey = targetBlock.getKey();
	  var blockKey = blockToBeMoved.getKey();
	
	  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
	
	  var blocksToBeMoved = [blockToBeMoved];
	  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);
	
	  if (isExperimentalTreeBlock) {
	    blocksToBeMoved = [];
	    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
	      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
	      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
	
	      blocks.toSeq().skipUntil(function (block) {
	        return block.getKey() === blockKey;
	      }).takeWhile(function (block) {
	        var key = block.getKey();
	        var isBlockToBeMoved = key === blockKey;
	        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
	        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
	
	        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
	      }).forEach(function (block) {
	        blocksToBeMoved.push(block);
	        blocks['delete'](block.getKey());
	      });
	    });
	  }
	
	  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
	    return v === targetBlock;
	  });
	
	  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
	    return v === targetBlock;
	  }).skip(1);
	
	  var slicedBlocks = blocksToBeMoved.map(function (block) {
	    return [block.getKey(), block];
	  });
	
	  var newBlocks = OrderedMap();
	
	  if (insertionMode === 'before') {
	    var blockBefore = contentState.getBlockBefore(targetKey);
	
	    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
	  } else if (insertionMode === 'after') {
	    var blockAfter = contentState.getBlockAfter(targetKey);
	
	    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
	  }
	
	  return contentState.merge({
	    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
	    selectionBefore: contentState.getSelectionAfter(),
	    selectionAfter: contentState.getSelectionAfter().merge({
	      anchorKey: blockKey,
	      focusKey: blockKey
	    })
	  });
	};
	
	module.exports = moveBlockInContentState;

/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(78);
	var Immutable = __webpack_require__(26);
	
	var getNextDelimiterBlockKey = __webpack_require__(921);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	/**
	 * Ancestors needs to be preserved when there are non selected
	 * children to make sure we do not leave any orphans behind
	 */
	var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
	  var parents = [];
	
	  if (!blockKey) {
	    return parents;
	  }
	
	  var blockNode = blockMap.get(blockKey);
	  while (blockNode && blockNode.getParentKey()) {
	    var parentKey = blockNode.getParentKey();
	    if (parentKey) {
	      parents.push(parentKey);
	    }
	    blockNode = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  return parents;
	};
	
	/**
	 * Get all next delimiter keys until we hit a root delimiter and return
	 * an array of key references
	 */
	var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
	  var nextDelimiters = [];
	
	  if (!block) {
	    return nextDelimiters;
	  }
	
	  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
	  while (nextDelimiter && blockMap.get(nextDelimiter)) {
	    var _block = blockMap.get(nextDelimiter);
	    nextDelimiters.push(nextDelimiter);
	
	    // we do not need to keep checking all root node siblings, just the first occurance
	    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
	  }
	
	  return nextDelimiters;
	};
	
	var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();
	
	  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
	    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
	  }
	
	  return nextValidSiblingKey;
	};
	
	var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();
	
	  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
	    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
	  }
	
	  return prevValidSiblingKey;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
	  return blockMap.withMutations(function (blocks) {
	    // update start block if its retained
	    transformBlock(startBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update endblock if its retained
	    transformBlock(endBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update start block parent ancestors
	    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      return transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update start block next - can only happen if startBlock == endBlock
	    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: startBlock.getPrevSiblingKey()
	      });
	    });
	
	    // update start block prev
	    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block next
	    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block prev
	    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: endBlock.getNextSiblingKey()
	      });
	    });
	
	    // update end block parent ancestors
	    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update next delimiters all the way to a root delimiter
	    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
	      return transformBlock(delimiterKey, blocks, function (block) {
	        return block.merge({
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	  });
	};
	
	var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	
	  // we assume that ContentBlockNode and ContentBlocks are not mixed together
	  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;
	
	  // used to retain blocks that should not be deleted to avoid orphan children
	  var parentAncestors = [];
	
	  if (isExperimentalTreeBlock) {
	    var endBlockchildrenKeys = endBlock.getChildKeys();
	    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);
	
	    // endBlock has unselected sibblings so we can not remove its ancestors parents
	    if (endBlock.getNextSiblingKey()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors);
	    }
	
	    // endBlock has children so can not remove this block or any of its ancestors
	    if (!endBlockchildrenKeys.isEmpty()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
	    }
	
	    // we need to retain all ancestors of the next delimiter block
	    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
	  }
	
	  var characterList = void 0;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).filter(function (_, k) {
	    return parentAncestors.indexOf(k) === -1;
	  }).concat(Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  if (isExperimentalTreeBlock) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	};
	
	module.exports = removeRangeFromContentState;

/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftJsDebugLogging = __webpack_require__(1926);
	
	var containsNode = __webpack_require__(299);
	var getActiveElement = __webpack_require__(434);
	var invariant = __webpack_require__(18);
	
	function getAnonymizedDOM(node, getNodeLabels) {
	  if (!node) {
	    return '[empty]';
	  }
	
	  var anonymized = anonymizeTextWithin(node, getNodeLabels);
	  if (anonymized.nodeType === Node.TEXT_NODE) {
	    return anonymized.textContent;
	  }
	
	  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
	  return anonymized.outerHTML;
	}
	
	function anonymizeTextWithin(node, getNodeLabels) {
	  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];
	
	  if (node.nodeType === Node.TEXT_NODE) {
	    var length = node.textContent.length;
	    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
	  }
	
	  var clone = node.cloneNode();
	  if (clone.nodeType === 1 && labels.length) {
	    clone.setAttribute('data-labels', labels.join(', '));
	  }
	  var childNodes = node.childNodes;
	  for (var ii = 0; ii < childNodes.length; ii++) {
	    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
	  }
	
	  return clone;
	}
	
	function getAnonymizedEditorDOM(node, getNodeLabels) {
	  // grabbing the DOM content of the Draft editor
	  var currentNode = node;
	  while (currentNode) {
	    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
	      // found the Draft editor container
	      return getAnonymizedDOM(currentNode, getNodeLabels);
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	  return 'Could not find contentEditable parent of node';
	}
	
	function getNodeLength(node) {
	  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset, selectionState) {
	  var activeElement = getActiveElement();
	  if (selection.extend && containsNode(activeElement, node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	
	    // logging to catch bug that is being reported in t16250795
	    if (offset > getNodeLength(node)) {
	      // the call to 'selection.extend' is about to throw
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node),
	        extraParams: JSON.stringify({ offset: offset }),
	        selectionState: JSON.stringify(selectionState.toJS())
	      });
	    }
	
	    // logging to catch bug that is being reported in t18110632
	    var nodeWasFocus = node === selection.focusNode;
	    try {
	      selection.extend(node, offset);
	    } catch (e) {
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
	          var labels = [];
	          if (n === activeElement) {
	            labels.push('active element');
	          }
	          if (n === selection.anchorNode) {
	            labels.push('selection anchor node');
	          }
	          if (n === selection.focusNode) {
	            labels.push('selection focus node');
	          }
	          return labels;
	        }),
	        extraParams: JSON.stringify({
	          activeElementName: activeElement ? activeElement.nodeName : null,
	          nodeIsFocus: node === selection.focusNode,
	          nodeWasFocus: nodeWasFocus,
	          selectionRangeCount: selection.rangeCount,
	          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
	          selectionAnchorOffset: selection.anchorOffset,
	          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
	          selectionFocusOffset: selection.focusOffset,
	          message: e ? '' + e : null,
	          offset: offset
	        }, null, 2),
	        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
	      });
	      // allow the error to be thrown -
	      // better than continuing in a broken state
	      throw e;
	    }
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset, selectionState) {
	  var range = document.createRange();
	  // logging to catch bug that is being reported in t16250795
	  if (offset > getNodeLength(node)) {
	    // in this case we know that the call to 'range.setStart' is about to throw
	    DraftJsDebugLogging.logSelectionStateFailure({
	      anonymizedDom: getAnonymizedEditorDOM(node),
	      extraParams: JSON.stringify({ offset: offset }),
	      selectionState: JSON.stringify(selectionState.toJS())
	    });
	  }
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(78);
	var Immutable = __webpack_require__(26);
	
	var generateRandomKey = __webpack_require__(108);
	var invariant = __webpack_require__(18);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
	  return blockMap.withMutations(function (blocks) {
	    var originalBlockKey = originalBlock.getKey();
	    var belowBlockKey = belowBlock.getKey();
	
	    // update block parent
	    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
	      var newChildrenArray = parentChildrenList.toArray();
	
	      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update original next block
	    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: belowBlockKey
	      });
	    });
	
	    // update original block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: belowBlockKey
	      });
	    });
	
	    // update below block
	    transformBlock(belowBlockKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	  });
	};
	
	var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	  var keyBelow = generateRandomKey();
	  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();
	
	  if (isExperimentalTreeBlock) {
	    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
	
	    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
	  }
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	};
	
	module.exports = splitBlockInContentState;

/***/ },
/* 1976 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ },
/* 1977 */
/***/ function(module, exports) {

	var toBe = [
	    'am',
	    'are',
	    'aren\'t',
	    'be',
	    'been',
	    'being',
	    'he\'s',
	    'here\'s',
	    'here\'s',
	    'how\'s',
	    'i\'m',
	    'is',
	    'isn\'t',
	    'she\'s',
	    'that\'s',
	    'there\'s',
	    'they\'re',
	    'was',
	    'wasn\'t',
	    'we\'re',
	    'were',
	    'weren\'t',
	    'what\'s',
	    'where\'s',
	    'who\'s',
	    'you\'re'
	];
	
	var re = new RegExp('\\b(' + toBe.join('|') + ')\\b', 'gi');
	
	module.exports = function (text) {
	    var suggestions = [];
	    if (!text || text.length === 0) return suggestions;
	    text = text.replace(/[\u2018\u2019]/g, "'"); // convert smart quotes
	    while (match = re.exec(text)) {
	        var be = match[0].toLowerCase();
	        suggestions.push({
	            index: match.index,
	            offset: be.length
	        });
	    }
	
	    return suggestions;
	};

/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(1980);
	var each = __webpack_require__(932).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(1978);
	var Util = __webpack_require__(932);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 1980 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(303);
	var toPrimitive = __webpack_require__(1987);
	
	var toStr = Object.prototype.toString;
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var $isNaN = __webpack_require__(936);
	var $isFinite = __webpack_require__(935);
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(934);
	var sign = __webpack_require__(938);
	var mod = __webpack_require__(937);
	var isPrimitive = __webpack_require__(1985);
	var parseInteger = parseInt;
	var bind = __webpack_require__(302);
	var arraySlice = bind.call(Function.call, Array.prototype.slice);
	var strSlice = bind.call(Function.call, String.prototype.slice);
	var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(1983);
	
	var hasRegExpMatcher = __webpack_require__(2292);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, Number);
			if (typeof value === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = Math.floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new TypeError('Cannot convert a Symbol value to a string');
			}
			return String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr.call(argument) !== '[object String]') {
				throw new TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: Array.isArray || function IsArray(argument) {
			return toStr.call(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: function IsExtensible(obj) {
			if (!Object.preventExtensions) { return true; }
			if (isPrimitive(obj)) {
				return false;
			}
			return Object.isExtensible(obj);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = Math.abs(argument);
			return Math.floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && Symbol.species ? C[Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new TypeError('no constructor found');
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && Symbol.species) {
					C = this.Get(C, Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = Object.getOwnPropertyDescriptor(O, P);
			var extensible = oldDesc || (typeof Object.isExtensible !== 'function' || Object.isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			Object.defineProperty(O, P, newDesc);
			return true;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new TypeError('unable to create data property');
			}
			return success;
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new TypeError('Assertion failed: Type(S) is not String');
			}
			if (!this.IsInteger(index)) {
				throw new TypeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
			}
			if (index < 0 || index > MAX_SAFE_INTEGER) {
				throw new RangeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new TypeError('Assertion failed: Type(unicode) is not Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
			var first = S.charCodeAt(index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
			var second = S.charCodeAt(index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
			return index + 2;
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(1981);
	var assign = __webpack_require__(934);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(936);
	var $isFinite = __webpack_require__(935);
	
	var sign = __webpack_require__(938);
	var mod = __webpack_require__(937);
	
	var IsCallable = __webpack_require__(440);
	var toPrimitive = __webpack_require__(1986);
	
	var has = __webpack_require__(303);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return Number(value);
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// http://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
			// jscs:disable
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
			// jscs:enable
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			if (!this.IsPropertyDescriptor(Desc)) {
				throw new TypeError('Desc must be a Property Descriptor');
			}
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ },
/* 1984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1982);


/***/ },
/* 1985 */
939,
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(939);
	
	var isCallable = __webpack_require__(440);
	
	// https://es5.github.io/#x8.12
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O, hint) {
			var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// https://es5.github.io/#x9
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
	};


/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(939);
	var isCallable = __webpack_require__(440);
	var isDate = __webpack_require__(2290);
	var isSymbol = __webpack_require__(958);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input, PreferredType) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (PreferredType === String) {
				hint = 'string';
			} else if (PreferredType === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ },
/* 1988 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root,factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.eventListener = factory();
	  }
	}(this, function () {
		function wrap(standard, fallback) {
			return function (el, evtName, listener, useCapture) {
				if (el[standard]) {
					el[standard](evtName, listener, useCapture);
				} else if (el[fallback]) {
					el[fallback]('on' + evtName, listener);
				}
			}
		}
	
	    return {
			add: wrap('addEventListener', 'attachEvent'),
			remove: wrap('removeEventListener', 'detachEvent')
		};
	}));

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 1991 */
185,
/* 1992 */
185,
/* 1993 */
185,
/* 1994 */
185,
/* 1995 */
185,
/* 1996 */
185,
/* 1997 */
185,
/* 1998 */
185,
/* 1999 */
185,
/* 2000 */
185,
/* 2001 */
185,
/* 2002 */
185,
/* 2003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(67);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 2004 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 2005 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ },
/* 2006 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ },
/* 2007 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(944);
	var UnicodeBidiDirection = __webpack_require__(433);
	
	var invariant = __webpack_require__(18);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(3294);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ },
/* 2011 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 2013 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 2014 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  if (doc.scrollingElement) {
	    return doc.scrollingElement;
	  }
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(2016);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(299);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(2011);
	var hyphenate = __webpack_require__(945);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ },
/* 2018 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 2019 */
/***/ function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(945);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 2021 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(2021);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 2023 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ },
/* 2024 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 2025 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	// setimmediate adds setImmediate to the global. We want to make sure we export
	// the actual function.
	
	__webpack_require__(559);
	module.exports = global.setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ad.f54a24d2.svg";

/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ae.d3d1653a.svg";

/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/af.81ea5c11.svg";

/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ag.e45175f4.svg";

/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ai.97171fd6.svg";

/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/al.a4b34f80.svg";

/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/am.3bcfa4ad.svg";

/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ao.4f43867f.svg";

/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ar.5a7b57c4.svg";

/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/as.9b64c590.svg";

/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/at.dd11d23b.svg";

/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/au.186ee49e.svg";

/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/aw.a7c647c3.svg";

/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/az.3bbb7a77.svg";

/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ba.80db369e.svg";

/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bb.1d35c9c4.svg";

/***/ },
/* 2043 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bd.274a6925.svg";

/***/ },
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/be.29c96523.svg";

/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bf.048afb99.svg";

/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bg.58fff247.svg";

/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bh.888cc21c.svg";

/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bi.aaa0be4d.svg";

/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bj.91931f25.svg";

/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bm.983adcb8.svg";

/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bo.ca05d6f0.svg";

/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/br.46d00db1.svg";

/***/ },
/* 2053 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bs.544e1faf.svg";

/***/ },
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bt.ad0691b2.svg";

/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bw.dc5c813b.svg";

/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/by.76e49e58.svg";

/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/bz.ecbe86bb.svg";

/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ca.b87a932d.svg";

/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cd.9a863931.svg";

/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cf.ef296947.svg";

/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cg.46462618.svg";

/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ch.edb9e8f1.svg";

/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ci.d7c363c5.svg";

/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ck.6ab8f4f6.svg";

/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cl.44057a82.svg";

/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cm.0ceaad18.svg";

/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cn.d09f389e.svg";

/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/co.03db6da5.svg";

/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cr.fdb730f2.svg";

/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cu.aa343286.svg";

/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cv.6952a02a.svg";

/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cw.f8e767c5.svg";

/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cy.2d8320b2.svg";

/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/cz.07c46781.svg";

/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/de.63382628.svg";

/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dj.880bdfa1.svg";

/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dk.0666b274.svg";

/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dm.395b272f.svg";

/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/do.2468708c.svg";

/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/dz.60e836dc.svg";

/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ec.6d1f067e.svg";

/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ee.99102b4a.svg";

/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/eg.ce676814.svg";

/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/er.9ac1b3f4.svg";

/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/es.2d6ddad0.svg";

/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/et.80e33e46.svg";

/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fi.0361140e.svg";

/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fj.c18b1479.svg";

/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fk.bbd2971f.svg";

/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fm.801f0f9a.svg";

/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fo.1d0e9fb5.svg";

/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/fr.06aaed6d.svg";

/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ga.02fbb253.svg";

/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gb.05e392da.svg";

/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gd.6219a1ca.svg";

/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ge.09dade9d.svg";

/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gg.7beacfe4.svg";

/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gh.3dbb4781.svg";

/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gi.06692140.svg";

/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gl.df7247c9.svg";

/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gm.eab02478.svg";

/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gn.dab67d0c.svg";

/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gq.450fc5f1.svg";

/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gr.3ea5b964.svg";

/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gt.ed4b7f77.svg";

/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gu.1a167daa.svg";

/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/gw.df5e99ae.svg";

/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hk.2f704d25.svg";

/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hn.d2ad3a99.svg";

/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hr.dd86fba5.svg";

/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ht.62d3ea0b.svg";

/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/hu.cc4edf3b.svg";

/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/id.46af3977.svg";

/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ie.3a4c4325.svg";

/***/ },
/* 2115 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/il.37eb709d.svg";

/***/ },
/* 2116 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/im.775ed2e1.svg";

/***/ },
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/in.dcd52e09.svg";

/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/io.9bdce175.svg";

/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/iq.ec59ec76.svg";

/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ir.ed3de0f5.svg";

/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/is.7d3e4b12.svg";

/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/it.1264f3cf.svg";

/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/je.7e5795cf.svg";

/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/jm.0e586ac8.svg";

/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/jo.97f77f12.svg";

/***/ },
/* 2126 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/jp.6de1711c.svg";

/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ke.29bef569.svg";

/***/ },
/* 2128 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kg.e8f22dc3.svg";

/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kh.ceb12d57.svg";

/***/ },
/* 2130 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ki.51ced81a.svg";

/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/km.23f7183c.svg";

/***/ },
/* 2132 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kn.37575b90.svg";

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kp.a8ad547e.svg";

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kr.8f11b475.svg";

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kw.6398282a.svg";

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ky.96d7cc25.svg";

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/kz.7dc54aa2.svg";

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/la.826e1710.svg";

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lb.9d9481f9.svg";

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/li.c0f4e698.svg";

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lk.d53b60dc.svg";

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lr.086aea48.svg";

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ls.693e16a8.svg";

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lt.a4e8c05e.svg";

/***/ },
/* 2145 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lu.1b602322.svg";

/***/ },
/* 2146 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/lv.9243ae82.svg";

/***/ },
/* 2147 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ly.25d53dde.svg";

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ma.da2a6dcc.svg";

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mc.de8308f1.svg";

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/md.af1d5589.svg";

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/me.6a9ff78b.svg";

/***/ },
/* 2152 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mg.6f509455.svg";

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mh.2a02af85.svg";

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mk.74974773.svg";

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ml.d3aacee0.svg";

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mm.a2a82021.svg";

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mn.60217659.svg";

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mo.ffdadb73.svg";

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mp.0b32daee.svg";

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mq.2c5a49b0.svg";

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mr.6390ec01.svg";

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ms.527a9934.svg";

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mt.cb88a36d.svg";

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mu.113b304c.svg";

/***/ },
/* 2165 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mv.896b59cd.svg";

/***/ },
/* 2166 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mw.a097ecc5.svg";

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mx.9cbc6a4d.svg";

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/my.25f0898c.svg";

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/mz.0b0814e8.svg";

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/na.5ea1a432.svg";

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nato.55474920.svg";

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ne.9d501eb6.svg";

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nf.1ac92a89.svg";

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ng.e752bb6a.svg";

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ni.7c10d0c7.svg";

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nl.cedccc2e.svg";

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/no.fb65c114.svg";

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/np.5206f5fb.svg";

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nr.434904de.svg";

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nu.c4f76fcb.svg";

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/nz.1d5f4598.svg";

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/om.0e22e9d8.svg";

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pa.c4233854.svg";

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pe.7b3a96cc.svg";

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pf.141b0361.svg";

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pg.9fb81100.svg";

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ph.71128d4e.svg";

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pk.0ddc1b8d.svg";

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pl.e22f07b1.svg";

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pn.3db9944f.svg";

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pr.159fd033.svg";

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ps.1cde6f32.svg";

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pt.2e1cc5e4.svg";

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/pw.9772c55d.svg";

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/py.6b530772.svg";

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/qa.b63f6f25.svg";

/***/ },
/* 2197 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ro.2d32a154.svg";

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/rs.7bb204a0.svg";

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ru.51e78aee.svg";

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/rw.78980691.svg";

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sa.14408485.svg";

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sb.9ebf90e7.svg";

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sc.bc5125a2.svg";

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sd.a16b5900.svg";

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/se.7167df83.svg";

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sg.5049744e.svg";

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/si.181cb6b0.svg";

/***/ },
/* 2208 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sk.12f5803d.svg";

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sl.db3557fb.svg";

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sm.90073202.svg";

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sn.01fc886a.svg";

/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/so.40cc58ef.svg";

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sr.07abdb38.svg";

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ss.8d10b401.svg";

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/st.00cca93c.svg";

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sv.2b59b54c.svg";

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sx.215fd417.svg";

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sy.84c17ae8.svg";

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/sz.464385ad.svg";

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tc.6cb2c745.svg";

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/td.33aca553.svg";

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tg.210dfafe.svg";

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/th.986613b9.svg";

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tibet.23082c02.svg";

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tj.719b17ff.svg";

/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tk.e64b0977.svg";

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tm.cc63fa32.svg";

/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tn.a8755943.svg";

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/to.2aed425c.svg";

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tr.1a22d127.svg";

/***/ },
/* 2231 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tt.0fcd53b8.svg";

/***/ },
/* 2232 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tv.3d842cc9.svg";

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tw.bbb044fc.svg";

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tz.9b0ba0ba.svg";

/***/ },
/* 2235 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ua.55aaf64f.svg";

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ug.404ab22c.svg";

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/us.026a8970.svg";

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/uy.82e79aac.svg";

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/uz.bd8a19df.svg";

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ve.da0049c4.svg";

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/vi.24789c93.svg";

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/vn.55421cd5.svg";

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/vu.2a533042.svg";

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ws.13edfcff.svg";

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/ye.ad22a6ef.svg";

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/za.97ae15ae.svg";

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/zm.0c052579.svg";

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/zw.9519a519.svg";

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/loading.c5590569.svg";

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/china.4e4d59b7.svg";

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/france.bcd389de.svg";

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/italy.604345b4.svg";

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/spain.6a9dc11f.svg";

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/uk.bc48afcc.svg";

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(3321) !== null) && (__webpack_require__(1417) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ },
/* 2256 */
/***/ function(module, exports) {

	
	var hasOwn = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	module.exports = function forEach (obj, fn, ctx) {
	    if (toString.call(fn) !== '[object Function]') {
	        throw new TypeError('iterator must be a function');
	    }
	    var l = obj.length;
	    if (l === +l) {
	        for (var i = 0; i < l; i++) {
	            fn.call(ctx, obj[i], i, obj);
	        }
	    } else {
	        for (var k in obj) {
	            if (hasOwn.call(obj, k)) {
	                fn.call(ctx, obj[k], k, obj);
	            }
	        }
	    }
	};
	


/***/ },
/* 2257 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ },
/* 2258 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
	 * http://hammerjs.github.io/
	 *
	 * Copyright (c) 2016 Jorik Tangelder;
	 * Licensed under the MIT license */
	(function(window, document, exportName, undefined) {
	  'use strict';
	
	var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
	var TEST_ELEMENT = document.createElement('div');
	
	var TYPE_FUNCTION = 'function';
	
	var round = Math.round;
	var abs = Math.abs;
	var now = Date.now;
	
	/**
	 * set a timeout with a given scope
	 * @param {Function} fn
	 * @param {Number} timeout
	 * @param {Object} context
	 * @returns {number}
	 */
	function setTimeoutContext(fn, timeout, context) {
	    return setTimeout(bindFn(fn, context), timeout);
	}
	
	/**
	 * if the argument is an array, we want to execute the fn on each entry
	 * if it aint an array we don't want to do a thing.
	 * this is used by all the methods that accept a single and array argument.
	 * @param {*|Array} arg
	 * @param {String} fn
	 * @param {Object} [context]
	 * @returns {Boolean}
	 */
	function invokeArrayArg(arg, fn, context) {
	    if (Array.isArray(arg)) {
	        each(arg, context[fn], context);
	        return true;
	    }
	    return false;
	}
	
	/**
	 * walk objects and arrays
	 * @param {Object} obj
	 * @param {Function} iterator
	 * @param {Object} context
	 */
	function each(obj, iterator, context) {
	    var i;
	
	    if (!obj) {
	        return;
	    }
	
	    if (obj.forEach) {
	        obj.forEach(iterator, context);
	    } else if (obj.length !== undefined) {
	        i = 0;
	        while (i < obj.length) {
	            iterator.call(context, obj[i], i, obj);
	            i++;
	        }
	    } else {
	        for (i in obj) {
	            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
	        }
	    }
	}
	
	/**
	 * wrap a method with a deprecation warning and stack trace
	 * @param {Function} method
	 * @param {String} name
	 * @param {String} message
	 * @returns {Function} A new function wrapping the supplied method.
	 */
	function deprecate(method, name, message) {
	    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
	    return function() {
	        var e = new Error('get-stack-trace');
	        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
	            .replace(/^\s+at\s+/gm, '')
	            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
	
	        var log = window.console && (window.console.warn || window.console.log);
	        if (log) {
	            log.call(window.console, deprecationMessage, stack);
	        }
	        return method.apply(this, arguments);
	    };
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} target
	 * @param {...Object} objects_to_assign
	 * @returns {Object} target
	 */
	var assign;
	if (typeof Object.assign !== 'function') {
	    assign = function assign(target) {
	        if (target === undefined || target === null) {
	            throw new TypeError('Cannot convert undefined or null to object');
	        }
	
	        var output = Object(target);
	        for (var index = 1; index < arguments.length; index++) {
	            var source = arguments[index];
	            if (source !== undefined && source !== null) {
	                for (var nextKey in source) {
	                    if (source.hasOwnProperty(nextKey)) {
	                        output[nextKey] = source[nextKey];
	                    }
	                }
	            }
	        }
	        return output;
	    };
	} else {
	    assign = Object.assign;
	}
	
	/**
	 * extend object.
	 * means that properties in dest will be overwritten by the ones in src.
	 * @param {Object} dest
	 * @param {Object} src
	 * @param {Boolean} [merge=false]
	 * @returns {Object} dest
	 */
	var extend = deprecate(function extend(dest, src, merge) {
	    var keys = Object.keys(src);
	    var i = 0;
	    while (i < keys.length) {
	        if (!merge || (merge && dest[keys[i]] === undefined)) {
	            dest[keys[i]] = src[keys[i]];
	        }
	        i++;
	    }
	    return dest;
	}, 'extend', 'Use `assign`.');
	
	/**
	 * merge the values from src in the dest.
	 * means that properties that exist in dest will not be overwritten by src
	 * @param {Object} dest
	 * @param {Object} src
	 * @returns {Object} dest
	 */
	var merge = deprecate(function merge(dest, src) {
	    return extend(dest, src, true);
	}, 'merge', 'Use `assign`.');
	
	/**
	 * simple class inheritance
	 * @param {Function} child
	 * @param {Function} base
	 * @param {Object} [properties]
	 */
	function inherit(child, base, properties) {
	    var baseP = base.prototype,
	        childP;
	
	    childP = child.prototype = Object.create(baseP);
	    childP.constructor = child;
	    childP._super = baseP;
	
	    if (properties) {
	        assign(childP, properties);
	    }
	}
	
	/**
	 * simple function bind
	 * @param {Function} fn
	 * @param {Object} context
	 * @returns {Function}
	 */
	function bindFn(fn, context) {
	    return function boundFn() {
	        return fn.apply(context, arguments);
	    };
	}
	
	/**
	 * let a boolean value also be a function that must return a boolean
	 * this first item in args will be used as the context
	 * @param {Boolean|Function} val
	 * @param {Array} [args]
	 * @returns {Boolean}
	 */
	function boolOrFn(val, args) {
	    if (typeof val == TYPE_FUNCTION) {
	        return val.apply(args ? args[0] || undefined : undefined, args);
	    }
	    return val;
	}
	
	/**
	 * use the val2 when val1 is undefined
	 * @param {*} val1
	 * @param {*} val2
	 * @returns {*}
	 */
	function ifUndefined(val1, val2) {
	    return (val1 === undefined) ? val2 : val1;
	}
	
	/**
	 * addEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function addEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.addEventListener(type, handler, false);
	    });
	}
	
	/**
	 * removeEventListener with multiple events at once
	 * @param {EventTarget} target
	 * @param {String} types
	 * @param {Function} handler
	 */
	function removeEventListeners(target, types, handler) {
	    each(splitStr(types), function(type) {
	        target.removeEventListener(type, handler, false);
	    });
	}
	
	/**
	 * find if a node is in the given parent
	 * @method hasParent
	 * @param {HTMLElement} node
	 * @param {HTMLElement} parent
	 * @return {Boolean} found
	 */
	function hasParent(node, parent) {
	    while (node) {
	        if (node == parent) {
	            return true;
	        }
	        node = node.parentNode;
	    }
	    return false;
	}
	
	/**
	 * small indexOf wrapper
	 * @param {String} str
	 * @param {String} find
	 * @returns {Boolean} found
	 */
	function inStr(str, find) {
	    return str.indexOf(find) > -1;
	}
	
	/**
	 * split string on whitespace
	 * @param {String} str
	 * @returns {Array} words
	 */
	function splitStr(str) {
	    return str.trim().split(/\s+/g);
	}
	
	/**
	 * find if a array contains the object using indexOf or a simple polyFill
	 * @param {Array} src
	 * @param {String} find
	 * @param {String} [findByKey]
	 * @return {Boolean|Number} false when not found, or the index
	 */
	function inArray(src, find, findByKey) {
	    if (src.indexOf && !findByKey) {
	        return src.indexOf(find);
	    } else {
	        var i = 0;
	        while (i < src.length) {
	            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
	                return i;
	            }
	            i++;
	        }
	        return -1;
	    }
	}
	
	/**
	 * convert array-like objects to real arrays
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function toArray(obj) {
	    return Array.prototype.slice.call(obj, 0);
	}
	
	/**
	 * unique array with objects based on a key (like 'id') or just by the array's value
	 * @param {Array} src [{id:1},{id:2},{id:1}]
	 * @param {String} [key]
	 * @param {Boolean} [sort=False]
	 * @returns {Array} [{id:1},{id:2}]
	 */
	function uniqueArray(src, key, sort) {
	    var results = [];
	    var values = [];
	    var i = 0;
	
	    while (i < src.length) {
	        var val = key ? src[i][key] : src[i];
	        if (inArray(values, val) < 0) {
	            results.push(src[i]);
	        }
	        values[i] = val;
	        i++;
	    }
	
	    if (sort) {
	        if (!key) {
	            results = results.sort();
	        } else {
	            results = results.sort(function sortUniqueArray(a, b) {
	                return a[key] > b[key];
	            });
	        }
	    }
	
	    return results;
	}
	
	/**
	 * get the prefixed property
	 * @param {Object} obj
	 * @param {String} property
	 * @returns {String|Undefined} prefixed
	 */
	function prefixed(obj, property) {
	    var prefix, prop;
	    var camelProp = property[0].toUpperCase() + property.slice(1);
	
	    var i = 0;
	    while (i < VENDOR_PREFIXES.length) {
	        prefix = VENDOR_PREFIXES[i];
	        prop = (prefix) ? prefix + camelProp : property;
	
	        if (prop in obj) {
	            return prop;
	        }
	        i++;
	    }
	    return undefined;
	}
	
	/**
	 * get a unique id
	 * @returns {number} uniqueId
	 */
	var _uniqueId = 1;
	function uniqueId() {
	    return _uniqueId++;
	}
	
	/**
	 * get the window object of an element
	 * @param {HTMLElement} element
	 * @returns {DocumentView|Window}
	 */
	function getWindowForElement(element) {
	    var doc = element.ownerDocument || element;
	    return (doc.defaultView || doc.parentWindow || window);
	}
	
	var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
	
	var SUPPORT_TOUCH = ('ontouchstart' in window);
	var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
	var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
	
	var INPUT_TYPE_TOUCH = 'touch';
	var INPUT_TYPE_PEN = 'pen';
	var INPUT_TYPE_MOUSE = 'mouse';
	var INPUT_TYPE_KINECT = 'kinect';
	
	var COMPUTE_INTERVAL = 25;
	
	var INPUT_START = 1;
	var INPUT_MOVE = 2;
	var INPUT_END = 4;
	var INPUT_CANCEL = 8;
	
	var DIRECTION_NONE = 1;
	var DIRECTION_LEFT = 2;
	var DIRECTION_RIGHT = 4;
	var DIRECTION_UP = 8;
	var DIRECTION_DOWN = 16;
	
	var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
	var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
	var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
	
	var PROPS_XY = ['x', 'y'];
	var PROPS_CLIENT_XY = ['clientX', 'clientY'];
	
	/**
	 * create new input type manager
	 * @param {Manager} manager
	 * @param {Function} callback
	 * @returns {Input}
	 * @constructor
	 */
	function Input(manager, callback) {
	    var self = this;
	    this.manager = manager;
	    this.callback = callback;
	    this.element = manager.element;
	    this.target = manager.options.inputTarget;
	
	    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
	    // so when disabled the input events are completely bypassed.
	    this.domHandler = function(ev) {
	        if (boolOrFn(manager.options.enable, [manager])) {
	            self.handler(ev);
	        }
	    };
	
	    this.init();
	
	}
	
	Input.prototype = {
	    /**
	     * should handle the inputEvent data and trigger the callback
	     * @virtual
	     */
	    handler: function() { },
	
	    /**
	     * bind the events
	     */
	    init: function() {
	        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    },
	
	    /**
	     * unbind the events
	     */
	    destroy: function() {
	        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
	        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
	        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
	    }
	};
	
	/**
	 * create new input type manager
	 * called by the Manager constructor
	 * @param {Hammer} manager
	 * @returns {Input}
	 */
	function createInputInstance(manager) {
	    var Type;
	    var inputClass = manager.options.inputClass;
	
	    if (inputClass) {
	        Type = inputClass;
	    } else if (SUPPORT_POINTER_EVENTS) {
	        Type = PointerEventInput;
	    } else if (SUPPORT_ONLY_TOUCH) {
	        Type = TouchInput;
	    } else if (!SUPPORT_TOUCH) {
	        Type = MouseInput;
	    } else {
	        Type = TouchMouseInput;
	    }
	    return new (Type)(manager, inputHandler);
	}
	
	/**
	 * handle input events
	 * @param {Manager} manager
	 * @param {String} eventType
	 * @param {Object} input
	 */
	function inputHandler(manager, eventType, input) {
	    var pointersLen = input.pointers.length;
	    var changedPointersLen = input.changedPointers.length;
	    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
	    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));
	
	    input.isFirst = !!isFirst;
	    input.isFinal = !!isFinal;
	
	    if (isFirst) {
	        manager.session = {};
	    }
	
	    // source event is the normalized value of the domEvents
	    // like 'touchstart, mouseup, pointerdown'
	    input.eventType = eventType;
	
	    // compute scale, rotation etc
	    computeInputData(manager, input);
	
	    // emit secret event
	    manager.emit('hammer.input', input);
	
	    manager.recognize(input);
	    manager.session.prevInput = input;
	}
	
	/**
	 * extend the data with some usable properties like scale, rotate, velocity etc
	 * @param {Object} manager
	 * @param {Object} input
	 */
	function computeInputData(manager, input) {
	    var session = manager.session;
	    var pointers = input.pointers;
	    var pointersLength = pointers.length;
	
	    // store the first input to calculate the distance and direction
	    if (!session.firstInput) {
	        session.firstInput = simpleCloneInputData(input);
	    }
	
	    // to compute scale and rotation we need to store the multiple touches
	    if (pointersLength > 1 && !session.firstMultiple) {
	        session.firstMultiple = simpleCloneInputData(input);
	    } else if (pointersLength === 1) {
	        session.firstMultiple = false;
	    }
	
	    var firstInput = session.firstInput;
	    var firstMultiple = session.firstMultiple;
	    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
	
	    var center = input.center = getCenter(pointers);
	    input.timeStamp = now();
	    input.deltaTime = input.timeStamp - firstInput.timeStamp;
	
	    input.angle = getAngle(offsetCenter, center);
	    input.distance = getDistance(offsetCenter, center);
	
	    computeDeltaXY(session, input);
	    input.offsetDirection = getDirection(input.deltaX, input.deltaY);
	
	    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
	    input.overallVelocityX = overallVelocity.x;
	    input.overallVelocityY = overallVelocity.y;
	    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;
	
	    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
	    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
	
	    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
	        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);
	
	    computeIntervalInputData(session, input);
	
	    // find the correct target
	    var target = manager.element;
	    if (hasParent(input.srcEvent.target, target)) {
	        target = input.srcEvent.target;
	    }
	    input.target = target;
	}
	
	function computeDeltaXY(session, input) {
	    var center = input.center;
	    var offset = session.offsetDelta || {};
	    var prevDelta = session.prevDelta || {};
	    var prevInput = session.prevInput || {};
	
	    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
	        prevDelta = session.prevDelta = {
	            x: prevInput.deltaX || 0,
	            y: prevInput.deltaY || 0
	        };
	
	        offset = session.offsetDelta = {
	            x: center.x,
	            y: center.y
	        };
	    }
	
	    input.deltaX = prevDelta.x + (center.x - offset.x);
	    input.deltaY = prevDelta.y + (center.y - offset.y);
	}
	
	/**
	 * velocity is calculated every x ms
	 * @param {Object} session
	 * @param {Object} input
	 */
	function computeIntervalInputData(session, input) {
	    var last = session.lastInterval || input,
	        deltaTime = input.timeStamp - last.timeStamp,
	        velocity, velocityX, velocityY, direction;
	
	    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
	        var deltaX = input.deltaX - last.deltaX;
	        var deltaY = input.deltaY - last.deltaY;
	
	        var v = getVelocity(deltaTime, deltaX, deltaY);
	        velocityX = v.x;
	        velocityY = v.y;
	        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
	        direction = getDirection(deltaX, deltaY);
	
	        session.lastInterval = input;
	    } else {
	        // use latest velocity info if it doesn't overtake a minimum period
	        velocity = last.velocity;
	        velocityX = last.velocityX;
	        velocityY = last.velocityY;
	        direction = last.direction;
	    }
	
	    input.velocity = velocity;
	    input.velocityX = velocityX;
	    input.velocityY = velocityY;
	    input.direction = direction;
	}
	
	/**
	 * create a simple clone from the input used for storage of firstInput and firstMultiple
	 * @param {Object} input
	 * @returns {Object} clonedInputData
	 */
	function simpleCloneInputData(input) {
	    // make a simple copy of the pointers because we will get a reference if we don't
	    // we only need clientXY for the calculations
	    var pointers = [];
	    var i = 0;
	    while (i < input.pointers.length) {
	        pointers[i] = {
	            clientX: round(input.pointers[i].clientX),
	            clientY: round(input.pointers[i].clientY)
	        };
	        i++;
	    }
	
	    return {
	        timeStamp: now(),
	        pointers: pointers,
	        center: getCenter(pointers),
	        deltaX: input.deltaX,
	        deltaY: input.deltaY
	    };
	}
	
	/**
	 * get the center of all the pointers
	 * @param {Array} pointers
	 * @return {Object} center contains `x` and `y` properties
	 */
	function getCenter(pointers) {
	    var pointersLength = pointers.length;
	
	    // no need to loop when only one touch
	    if (pointersLength === 1) {
	        return {
	            x: round(pointers[0].clientX),
	            y: round(pointers[0].clientY)
	        };
	    }
	
	    var x = 0, y = 0, i = 0;
	    while (i < pointersLength) {
	        x += pointers[i].clientX;
	        y += pointers[i].clientY;
	        i++;
	    }
	
	    return {
	        x: round(x / pointersLength),
	        y: round(y / pointersLength)
	    };
	}
	
	/**
	 * calculate the velocity between two points. unit is in px per ms.
	 * @param {Number} deltaTime
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Object} velocity `x` and `y`
	 */
	function getVelocity(deltaTime, x, y) {
	    return {
	        x: x / deltaTime || 0,
	        y: y / deltaTime || 0
	    };
	}
	
	/**
	 * get the direction between two points
	 * @param {Number} x
	 * @param {Number} y
	 * @return {Number} direction
	 */
	function getDirection(x, y) {
	    if (x === y) {
	        return DIRECTION_NONE;
	    }
	
	    if (abs(x) >= abs(y)) {
	        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
	    }
	    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
	}
	
	/**
	 * calculate the absolute distance between two points
	 * @param {Object} p1 {x, y}
	 * @param {Object} p2 {x, y}
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} distance
	 */
	function getDistance(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	
	    return Math.sqrt((x * x) + (y * y));
	}
	
	/**
	 * calculate the angle between two coordinates
	 * @param {Object} p1
	 * @param {Object} p2
	 * @param {Array} [props] containing x and y keys
	 * @return {Number} angle
	 */
	function getAngle(p1, p2, props) {
	    if (!props) {
	        props = PROPS_XY;
	    }
	    var x = p2[props[0]] - p1[props[0]],
	        y = p2[props[1]] - p1[props[1]];
	    return Math.atan2(y, x) * 180 / Math.PI;
	}
	
	/**
	 * calculate the rotation degrees between two pointersets
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} rotation
	 */
	function getRotation(start, end) {
	    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
	}
	
	/**
	 * calculate the scale factor between two pointersets
	 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
	 * @param {Array} start array of pointers
	 * @param {Array} end array of pointers
	 * @return {Number} scale
	 */
	function getScale(start, end) {
	    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
	}
	
	var MOUSE_INPUT_MAP = {
	    mousedown: INPUT_START,
	    mousemove: INPUT_MOVE,
	    mouseup: INPUT_END
	};
	
	var MOUSE_ELEMENT_EVENTS = 'mousedown';
	var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
	
	/**
	 * Mouse events input
	 * @constructor
	 * @extends Input
	 */
	function MouseInput() {
	    this.evEl = MOUSE_ELEMENT_EVENTS;
	    this.evWin = MOUSE_WINDOW_EVENTS;
	
	    this.pressed = false; // mousedown state
	
	    Input.apply(this, arguments);
	}
	
	inherit(MouseInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function MEhandler(ev) {
	        var eventType = MOUSE_INPUT_MAP[ev.type];
	
	        // on start we want to have the left mouse button down
	        if (eventType & INPUT_START && ev.button === 0) {
	            this.pressed = true;
	        }
	
	        if (eventType & INPUT_MOVE && ev.which !== 1) {
	            eventType = INPUT_END;
	        }
	
	        // mouse must be down
	        if (!this.pressed) {
	            return;
	        }
	
	        if (eventType & INPUT_END) {
	            this.pressed = false;
	        }
	
	        this.callback(this.manager, eventType, {
	            pointers: [ev],
	            changedPointers: [ev],
	            pointerType: INPUT_TYPE_MOUSE,
	            srcEvent: ev
	        });
	    }
	});
	
	var POINTER_INPUT_MAP = {
	    pointerdown: INPUT_START,
	    pointermove: INPUT_MOVE,
	    pointerup: INPUT_END,
	    pointercancel: INPUT_CANCEL,
	    pointerout: INPUT_CANCEL
	};
	
	// in IE10 the pointer types is defined as an enum
	var IE10_POINTER_TYPE_ENUM = {
	    2: INPUT_TYPE_TOUCH,
	    3: INPUT_TYPE_PEN,
	    4: INPUT_TYPE_MOUSE,
	    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
	};
	
	var POINTER_ELEMENT_EVENTS = 'pointerdown';
	var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
	
	// IE10 has prefixed support, and case-sensitive
	if (window.MSPointerEvent && !window.PointerEvent) {
	    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
	    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
	}
	
	/**
	 * Pointer events input
	 * @constructor
	 * @extends Input
	 */
	function PointerEventInput() {
	    this.evEl = POINTER_ELEMENT_EVENTS;
	    this.evWin = POINTER_WINDOW_EVENTS;
	
	    Input.apply(this, arguments);
	
	    this.store = (this.manager.session.pointerEvents = []);
	}
	
	inherit(PointerEventInput, Input, {
	    /**
	     * handle mouse events
	     * @param {Object} ev
	     */
	    handler: function PEhandler(ev) {
	        var store = this.store;
	        var removePointer = false;
	
	        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
	        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
	        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
	
	        var isTouch = (pointerType == INPUT_TYPE_TOUCH);
	
	        // get index of the event in the store
	        var storeIndex = inArray(store, ev.pointerId, 'pointerId');
	
	        // start and mouse must be down
	        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
	            if (storeIndex < 0) {
	                store.push(ev);
	                storeIndex = store.length - 1;
	            }
	        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	            removePointer = true;
	        }
	
	        // it not found, so the pointer hasn't been down (so it's probably a hover)
	        if (storeIndex < 0) {
	            return;
	        }
	
	        // update the event in the store
	        store[storeIndex] = ev;
	
	        this.callback(this.manager, eventType, {
	            pointers: store,
	            changedPointers: [ev],
	            pointerType: pointerType,
	            srcEvent: ev
	        });
	
	        if (removePointer) {
	            // remove from the store
	            store.splice(storeIndex, 1);
	        }
	    }
	});
	
	var SINGLE_TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
	var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Touch events input
	 * @constructor
	 * @extends Input
	 */
	function SingleTouchInput() {
	    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
	    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
	    this.started = false;
	
	    Input.apply(this, arguments);
	}
	
	inherit(SingleTouchInput, Input, {
	    handler: function TEhandler(ev) {
	        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
	
	        // should we handle the touch events?
	        if (type === INPUT_START) {
	            this.started = true;
	        }
	
	        if (!this.started) {
	            return;
	        }
	
	        var touches = normalizeSingleTouches.call(this, ev, type);
	
	        // when done, reset the started state
	        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
	            this.started = false;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function normalizeSingleTouches(ev, type) {
	    var all = toArray(ev.touches);
	    var changed = toArray(ev.changedTouches);
	
	    if (type & (INPUT_END | INPUT_CANCEL)) {
	        all = uniqueArray(all.concat(changed), 'identifier', true);
	    }
	
	    return [all, changed];
	}
	
	var TOUCH_INPUT_MAP = {
	    touchstart: INPUT_START,
	    touchmove: INPUT_MOVE,
	    touchend: INPUT_END,
	    touchcancel: INPUT_CANCEL
	};
	
	var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
	
	/**
	 * Multi-user touch events input
	 * @constructor
	 * @extends Input
	 */
	function TouchInput() {
	    this.evTarget = TOUCH_TARGET_EVENTS;
	    this.targetIds = {};
	
	    Input.apply(this, arguments);
	}
	
	inherit(TouchInput, Input, {
	    handler: function MTEhandler(ev) {
	        var type = TOUCH_INPUT_MAP[ev.type];
	        var touches = getTouches.call(this, ev, type);
	        if (!touches) {
	            return;
	        }
	
	        this.callback(this.manager, type, {
	            pointers: touches[0],
	            changedPointers: touches[1],
	            pointerType: INPUT_TYPE_TOUCH,
	            srcEvent: ev
	        });
	    }
	});
	
	/**
	 * @this {TouchInput}
	 * @param {Object} ev
	 * @param {Number} type flag
	 * @returns {undefined|Array} [all, changed]
	 */
	function getTouches(ev, type) {
	    var allTouches = toArray(ev.touches);
	    var targetIds = this.targetIds;
	
	    // when there is only one touch, the process can be simplified
	    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
	        targetIds[allTouches[0].identifier] = true;
	        return [allTouches, allTouches];
	    }
	
	    var i,
	        targetTouches,
	        changedTouches = toArray(ev.changedTouches),
	        changedTargetTouches = [],
	        target = this.target;
	
	    // get target touches from touches
	    targetTouches = allTouches.filter(function(touch) {
	        return hasParent(touch.target, target);
	    });
	
	    // collect touches
	    if (type === INPUT_START) {
	        i = 0;
	        while (i < targetTouches.length) {
	            targetIds[targetTouches[i].identifier] = true;
	            i++;
	        }
	    }
	
	    // filter changed touches to only contain touches that exist in the collected target ids
	    i = 0;
	    while (i < changedTouches.length) {
	        if (targetIds[changedTouches[i].identifier]) {
	            changedTargetTouches.push(changedTouches[i]);
	        }
	
	        // cleanup removed touches
	        if (type & (INPUT_END | INPUT_CANCEL)) {
	            delete targetIds[changedTouches[i].identifier];
	        }
	        i++;
	    }
	
	    if (!changedTargetTouches.length) {
	        return;
	    }
	
	    return [
	        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
	        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
	        changedTargetTouches
	    ];
	}
	
	/**
	 * Combined touch and mouse input
	 *
	 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
	 * This because touch devices also emit mouse events while doing a touch.
	 *
	 * @constructor
	 * @extends Input
	 */
	
	var DEDUP_TIMEOUT = 2500;
	var DEDUP_DISTANCE = 25;
	
	function TouchMouseInput() {
	    Input.apply(this, arguments);
	
	    var handler = bindFn(this.handler, this);
	    this.touch = new TouchInput(this.manager, handler);
	    this.mouse = new MouseInput(this.manager, handler);
	
	    this.primaryTouch = null;
	    this.lastTouches = [];
	}
	
	inherit(TouchMouseInput, Input, {
	    /**
	     * handle mouse and touch events
	     * @param {Hammer} manager
	     * @param {String} inputEvent
	     * @param {Object} inputData
	     */
	    handler: function TMEhandler(manager, inputEvent, inputData) {
	        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
	            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);
	
	        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
	            return;
	        }
	
	        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
	        if (isTouch) {
	            recordTouches.call(this, inputEvent, inputData);
	        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
	            return;
	        }
	
	        this.callback(manager, inputEvent, inputData);
	    },
	
	    /**
	     * remove the event listeners
	     */
	    destroy: function destroy() {
	        this.touch.destroy();
	        this.mouse.destroy();
	    }
	});
	
	function recordTouches(eventType, eventData) {
	    if (eventType & INPUT_START) {
	        this.primaryTouch = eventData.changedPointers[0].identifier;
	        setLastTouch.call(this, eventData);
	    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
	        setLastTouch.call(this, eventData);
	    }
	}
	
	function setLastTouch(eventData) {
	    var touch = eventData.changedPointers[0];
	
	    if (touch.identifier === this.primaryTouch) {
	        var lastTouch = {x: touch.clientX, y: touch.clientY};
	        this.lastTouches.push(lastTouch);
	        var lts = this.lastTouches;
	        var removeLastTouch = function() {
	            var i = lts.indexOf(lastTouch);
	            if (i > -1) {
	                lts.splice(i, 1);
	            }
	        };
	        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
	    }
	}
	
	function isSyntheticEvent(eventData) {
	    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
	    for (var i = 0; i < this.lastTouches.length; i++) {
	        var t = this.lastTouches[i];
	        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
	        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
	            return true;
	        }
	    }
	    return false;
	}
	
	var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
	var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
	
	// magical touchAction value
	var TOUCH_ACTION_COMPUTE = 'compute';
	var TOUCH_ACTION_AUTO = 'auto';
	var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
	var TOUCH_ACTION_NONE = 'none';
	var TOUCH_ACTION_PAN_X = 'pan-x';
	var TOUCH_ACTION_PAN_Y = 'pan-y';
	var TOUCH_ACTION_MAP = getTouchActionProps();
	
	/**
	 * Touch Action
	 * sets the touchAction property or uses the js alternative
	 * @param {Manager} manager
	 * @param {String} value
	 * @constructor
	 */
	function TouchAction(manager, value) {
	    this.manager = manager;
	    this.set(value);
	}
	
	TouchAction.prototype = {
	    /**
	     * set the touchAction value on the element or enable the polyfill
	     * @param {String} value
	     */
	    set: function(value) {
	        // find out the touch-action by the event handlers
	        if (value == TOUCH_ACTION_COMPUTE) {
	            value = this.compute();
	        }
	
	        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
	            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
	        }
	        this.actions = value.toLowerCase().trim();
	    },
	
	    /**
	     * just re-set the touchAction value
	     */
	    update: function() {
	        this.set(this.manager.options.touchAction);
	    },
	
	    /**
	     * compute the value for the touchAction property based on the recognizer's settings
	     * @returns {String} value
	     */
	    compute: function() {
	        var actions = [];
	        each(this.manager.recognizers, function(recognizer) {
	            if (boolOrFn(recognizer.options.enable, [recognizer])) {
	                actions = actions.concat(recognizer.getTouchAction());
	            }
	        });
	        return cleanTouchActions(actions.join(' '));
	    },
	
	    /**
	     * this method is called on each input cycle and provides the preventing of the browser behavior
	     * @param {Object} input
	     */
	    preventDefaults: function(input) {
	        var srcEvent = input.srcEvent;
	        var direction = input.offsetDirection;
	
	        // if the touch action did prevented once this session
	        if (this.manager.session.prevented) {
	            srcEvent.preventDefault();
	            return;
	        }
	
	        var actions = this.actions;
	        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
	        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
	        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
	
	        if (hasNone) {
	            //do not prevent defaults if this is a tap gesture
	
	            var isTapPointer = input.pointers.length === 1;
	            var isTapMovement = input.distance < 2;
	            var isTapTouchTime = input.deltaTime < 250;
	
	            if (isTapPointer && isTapMovement && isTapTouchTime) {
	                return;
	            }
	        }
	
	        if (hasPanX && hasPanY) {
	            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
	            return;
	        }
	
	        if (hasNone ||
	            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
	            (hasPanX && direction & DIRECTION_VERTICAL)) {
	            return this.preventSrc(srcEvent);
	        }
	    },
	
	    /**
	     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
	     * @param {Object} srcEvent
	     */
	    preventSrc: function(srcEvent) {
	        this.manager.session.prevented = true;
	        srcEvent.preventDefault();
	    }
	};
	
	/**
	 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
	 * @param {String} actions
	 * @returns {*}
	 */
	function cleanTouchActions(actions) {
	    // none
	    if (inStr(actions, TOUCH_ACTION_NONE)) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
	    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
	
	    // if both pan-x and pan-y are set (different recognizers
	    // for different directions, e.g. horizontal pan but vertical swipe?)
	    // we need none (as otherwise with pan-x pan-y combined none of these
	    // recognizers will work, since the browser would handle all panning
	    if (hasPanX && hasPanY) {
	        return TOUCH_ACTION_NONE;
	    }
	
	    // pan-x OR pan-y
	    if (hasPanX || hasPanY) {
	        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
	    }
	
	    // manipulation
	    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
	        return TOUCH_ACTION_MANIPULATION;
	    }
	
	    return TOUCH_ACTION_AUTO;
	}
	
	function getTouchActionProps() {
	    if (!NATIVE_TOUCH_ACTION) {
	        return false;
	    }
	    var touchMap = {};
	    var cssSupports = window.CSS && window.CSS.supports;
	    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {
	
	        // If css.supports is not supported but there is native touch-action assume it supports
	        // all values. This is the case for IE 10 and 11.
	        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
	    });
	    return touchMap;
	}
	
	/**
	 * Recognizer flow explained; *
	 * All recognizers have the initial state of POSSIBLE when a input session starts.
	 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
	 * Example session for mouse-input: mousedown -> mousemove -> mouseup
	 *
	 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
	 * which determines with state it should be.
	 *
	 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
	 * POSSIBLE to give it another change on the next cycle.
	 *
	 *               Possible
	 *                  |
	 *            +-----+---------------+
	 *            |                     |
	 *      +-----+-----+               |
	 *      |           |               |
	 *   Failed      Cancelled          |
	 *                          +-------+------+
	 *                          |              |
	 *                      Recognized       Began
	 *                                         |
	 *                                      Changed
	 *                                         |
	 *                                  Ended/Recognized
	 */
	var STATE_POSSIBLE = 1;
	var STATE_BEGAN = 2;
	var STATE_CHANGED = 4;
	var STATE_ENDED = 8;
	var STATE_RECOGNIZED = STATE_ENDED;
	var STATE_CANCELLED = 16;
	var STATE_FAILED = 32;
	
	/**
	 * Recognizer
	 * Every recognizer needs to extend from this class.
	 * @constructor
	 * @param {Object} options
	 */
	function Recognizer(options) {
	    this.options = assign({}, this.defaults, options || {});
	
	    this.id = uniqueId();
	
	    this.manager = null;
	
	    // default is enable true
	    this.options.enable = ifUndefined(this.options.enable, true);
	
	    this.state = STATE_POSSIBLE;
	
	    this.simultaneous = {};
	    this.requireFail = [];
	}
	
	Recognizer.prototype = {
	    /**
	     * @virtual
	     * @type {Object}
	     */
	    defaults: {},
	
	    /**
	     * set options
	     * @param {Object} options
	     * @return {Recognizer}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // also update the touchAction, in case something changed about the directions/enabled state
	        this.manager && this.manager.touchAction.update();
	        return this;
	    },
	
	    /**
	     * recognize simultaneous with an other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    recognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
	            return this;
	        }
	
	        var simultaneous = this.simultaneous;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (!simultaneous[otherRecognizer.id]) {
	            simultaneous[otherRecognizer.id] = otherRecognizer;
	            otherRecognizer.recognizeWith(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRecognizeWith: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        delete this.simultaneous[otherRecognizer.id];
	        return this;
	    },
	
	    /**
	     * recognizer can only run when an other is failing
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    requireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
	            return this;
	        }
	
	        var requireFail = this.requireFail;
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        if (inArray(requireFail, otherRecognizer) === -1) {
	            requireFail.push(otherRecognizer);
	            otherRecognizer.requireFailure(this);
	        }
	        return this;
	    },
	
	    /**
	     * drop the requireFailure link. it does not remove the link on the other recognizer.
	     * @param {Recognizer} otherRecognizer
	     * @returns {Recognizer} this
	     */
	    dropRequireFailure: function(otherRecognizer) {
	        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
	            return this;
	        }
	
	        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
	        var index = inArray(this.requireFail, otherRecognizer);
	        if (index > -1) {
	            this.requireFail.splice(index, 1);
	        }
	        return this;
	    },
	
	    /**
	     * has require failures boolean
	     * @returns {boolean}
	     */
	    hasRequireFailures: function() {
	        return this.requireFail.length > 0;
	    },
	
	    /**
	     * if the recognizer can recognize simultaneous with an other recognizer
	     * @param {Recognizer} otherRecognizer
	     * @returns {Boolean}
	     */
	    canRecognizeWith: function(otherRecognizer) {
	        return !!this.simultaneous[otherRecognizer.id];
	    },
	
	    /**
	     * You should use `tryEmit` instead of `emit` directly to check
	     * that all the needed recognizers has failed before emitting.
	     * @param {Object} input
	     */
	    emit: function(input) {
	        var self = this;
	        var state = this.state;
	
	        function emit(event) {
	            self.manager.emit(event, input);
	        }
	
	        // 'panstart' and 'panmove'
	        if (state < STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	
	        emit(self.options.event); // simple 'eventName' events
	
	        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
	            emit(input.additionalEvent);
	        }
	
	        // panend and pancancel
	        if (state >= STATE_ENDED) {
	            emit(self.options.event + stateStr(state));
	        }
	    },
	
	    /**
	     * Check that all the require failure recognizers has failed,
	     * if true, it emits a gesture event,
	     * otherwise, setup the state to FAILED.
	     * @param {Object} input
	     */
	    tryEmit: function(input) {
	        if (this.canEmit()) {
	            return this.emit(input);
	        }
	        // it's failing anyway
	        this.state = STATE_FAILED;
	    },
	
	    /**
	     * can we emit?
	     * @returns {boolean}
	     */
	    canEmit: function() {
	        var i = 0;
	        while (i < this.requireFail.length) {
	            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
	                return false;
	            }
	            i++;
	        }
	        return true;
	    },
	
	    /**
	     * update the recognizer
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        // make a new copy of the inputData
	        // so we can change the inputData without messing up the other recognizers
	        var inputDataClone = assign({}, inputData);
	
	        // is is enabled and allow recognizing?
	        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
	            this.reset();
	            this.state = STATE_FAILED;
	            return;
	        }
	
	        // reset when we've reached the end
	        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
	            this.state = STATE_POSSIBLE;
	        }
	
	        this.state = this.process(inputDataClone);
	
	        // the recognizer has recognized a gesture
	        // so trigger an event
	        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
	            this.tryEmit(inputDataClone);
	        }
	    },
	
	    /**
	     * return the state of the recognizer
	     * the actual recognizing happens in this method
	     * @virtual
	     * @param {Object} inputData
	     * @returns {Const} STATE
	     */
	    process: function(inputData) { }, // jshint ignore:line
	
	    /**
	     * return the preferred touch-action
	     * @virtual
	     * @returns {Array}
	     */
	    getTouchAction: function() { },
	
	    /**
	     * called when the gesture isn't allowed to recognize
	     * like when another is being recognized or it is disabled
	     * @virtual
	     */
	    reset: function() { }
	};
	
	/**
	 * get a usable string, used as event postfix
	 * @param {Const} state
	 * @returns {String} state
	 */
	function stateStr(state) {
	    if (state & STATE_CANCELLED) {
	        return 'cancel';
	    } else if (state & STATE_ENDED) {
	        return 'end';
	    } else if (state & STATE_CHANGED) {
	        return 'move';
	    } else if (state & STATE_BEGAN) {
	        return 'start';
	    }
	    return '';
	}
	
	/**
	 * direction cons to string
	 * @param {Const} direction
	 * @returns {String}
	 */
	function directionStr(direction) {
	    if (direction == DIRECTION_DOWN) {
	        return 'down';
	    } else if (direction == DIRECTION_UP) {
	        return 'up';
	    } else if (direction == DIRECTION_LEFT) {
	        return 'left';
	    } else if (direction == DIRECTION_RIGHT) {
	        return 'right';
	    }
	    return '';
	}
	
	/**
	 * get a recognizer by name if it is bound to a manager
	 * @param {Recognizer|String} otherRecognizer
	 * @param {Recognizer} recognizer
	 * @returns {Recognizer}
	 */
	function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
	    var manager = recognizer.manager;
	    if (manager) {
	        return manager.get(otherRecognizer);
	    }
	    return otherRecognizer;
	}
	
	/**
	 * This recognizer is just used as a base for the simple attribute recognizers.
	 * @constructor
	 * @extends Recognizer
	 */
	function AttrRecognizer() {
	    Recognizer.apply(this, arguments);
	}
	
	inherit(AttrRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof AttrRecognizer
	     */
	    defaults: {
	        /**
	         * @type {Number}
	         * @default 1
	         */
	        pointers: 1
	    },
	
	    /**
	     * Used to check if it the recognizer receives valid input, like input.distance > 10.
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {Boolean} recognized
	     */
	    attrTest: function(input) {
	        var optionPointers = this.options.pointers;
	        return optionPointers === 0 || input.pointers.length === optionPointers;
	    },
	
	    /**
	     * Process the input and return the state for the recognizer
	     * @memberof AttrRecognizer
	     * @param {Object} input
	     * @returns {*} State
	     */
	    process: function(input) {
	        var state = this.state;
	        var eventType = input.eventType;
	
	        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
	        var isValid = this.attrTest(input);
	
	        // on cancel input and we've recognized before, return STATE_CANCELLED
	        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
	            return state | STATE_CANCELLED;
	        } else if (isRecognized || isValid) {
	            if (eventType & INPUT_END) {
	                return state | STATE_ENDED;
	            } else if (!(state & STATE_BEGAN)) {
	                return STATE_BEGAN;
	            }
	            return state | STATE_CHANGED;
	        }
	        return STATE_FAILED;
	    }
	});
	
	/**
	 * Pan
	 * Recognized when the pointer is down and moved in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PanRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	
	    this.pX = null;
	    this.pY = null;
	}
	
	inherit(PanRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PanRecognizer
	     */
	    defaults: {
	        event: 'pan',
	        threshold: 10,
	        pointers: 1,
	        direction: DIRECTION_ALL
	    },
	
	    getTouchAction: function() {
	        var direction = this.options.direction;
	        var actions = [];
	        if (direction & DIRECTION_HORIZONTAL) {
	            actions.push(TOUCH_ACTION_PAN_Y);
	        }
	        if (direction & DIRECTION_VERTICAL) {
	            actions.push(TOUCH_ACTION_PAN_X);
	        }
	        return actions;
	    },
	
	    directionTest: function(input) {
	        var options = this.options;
	        var hasMoved = true;
	        var distance = input.distance;
	        var direction = input.direction;
	        var x = input.deltaX;
	        var y = input.deltaY;
	
	        // lock to axis?
	        if (!(direction & options.direction)) {
	            if (options.direction & DIRECTION_HORIZONTAL) {
	                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
	                hasMoved = x != this.pX;
	                distance = Math.abs(input.deltaX);
	            } else {
	                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
	                hasMoved = y != this.pY;
	                distance = Math.abs(input.deltaY);
	            }
	        }
	        input.direction = direction;
	        return hasMoved && distance > options.threshold && direction & options.direction;
	    },
	
	    attrTest: function(input) {
	        return AttrRecognizer.prototype.attrTest.call(this, input) &&
	            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
	    },
	
	    emit: function(input) {
	
	        this.pX = input.deltaX;
	        this.pY = input.deltaY;
	
	        var direction = directionStr(input.direction);
	
	        if (direction) {
	            input.additionalEvent = this.options.event + direction;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Pinch
	 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function PinchRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(PinchRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'pinch',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
	    },
	
	    emit: function(input) {
	        if (input.scale !== 1) {
	            var inOut = input.scale < 1 ? 'in' : 'out';
	            input.additionalEvent = this.options.event + inOut;
	        }
	        this._super.emit.call(this, input);
	    }
	});
	
	/**
	 * Press
	 * Recognized when the pointer is down for x ms without any movement.
	 * @constructor
	 * @extends Recognizer
	 */
	function PressRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    this._timer = null;
	    this._input = null;
	}
	
	inherit(PressRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PressRecognizer
	     */
	    defaults: {
	        event: 'press',
	        pointers: 1,
	        time: 251, // minimal time of the pointer to be pressed
	        threshold: 9 // a minimal movement is ok, but keep it low
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_AUTO];
	    },
	
	    process: function(input) {
	        var options = this.options;
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTime = input.deltaTime > options.time;
	
	        this._input = input;
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
	            this.reset();
	        } else if (input.eventType & INPUT_START) {
	            this.reset();
	            this._timer = setTimeoutContext(function() {
	                this.state = STATE_RECOGNIZED;
	                this.tryEmit();
	            }, options.time, this);
	        } else if (input.eventType & INPUT_END) {
	            return STATE_RECOGNIZED;
	        }
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function(input) {
	        if (this.state !== STATE_RECOGNIZED) {
	            return;
	        }
	
	        if (input && (input.eventType & INPUT_END)) {
	            this.manager.emit(this.options.event + 'up', input);
	        } else {
	            this._input.timeStamp = now();
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Rotate
	 * Recognized when two or more pointer are moving in a circular motion.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function RotateRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(RotateRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof RotateRecognizer
	     */
	    defaults: {
	        event: 'rotate',
	        threshold: 0,
	        pointers: 2
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_NONE];
	    },
	
	    attrTest: function(input) {
	        return this._super.attrTest.call(this, input) &&
	            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
	    }
	});
	
	/**
	 * Swipe
	 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
	 * @constructor
	 * @extends AttrRecognizer
	 */
	function SwipeRecognizer() {
	    AttrRecognizer.apply(this, arguments);
	}
	
	inherit(SwipeRecognizer, AttrRecognizer, {
	    /**
	     * @namespace
	     * @memberof SwipeRecognizer
	     */
	    defaults: {
	        event: 'swipe',
	        threshold: 10,
	        velocity: 0.3,
	        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
	        pointers: 1
	    },
	
	    getTouchAction: function() {
	        return PanRecognizer.prototype.getTouchAction.call(this);
	    },
	
	    attrTest: function(input) {
	        var direction = this.options.direction;
	        var velocity;
	
	        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
	            velocity = input.overallVelocity;
	        } else if (direction & DIRECTION_HORIZONTAL) {
	            velocity = input.overallVelocityX;
	        } else if (direction & DIRECTION_VERTICAL) {
	            velocity = input.overallVelocityY;
	        }
	
	        return this._super.attrTest.call(this, input) &&
	            direction & input.offsetDirection &&
	            input.distance > this.options.threshold &&
	            input.maxPointers == this.options.pointers &&
	            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
	    },
	
	    emit: function(input) {
	        var direction = directionStr(input.offsetDirection);
	        if (direction) {
	            this.manager.emit(this.options.event + direction, input);
	        }
	
	        this.manager.emit(this.options.event, input);
	    }
	});
	
	/**
	 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
	 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
	 * a single tap.
	 *
	 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
	 * multi-taps being recognized.
	 * @constructor
	 * @extends Recognizer
	 */
	function TapRecognizer() {
	    Recognizer.apply(this, arguments);
	
	    // previous time and center,
	    // used for tap counting
	    this.pTime = false;
	    this.pCenter = false;
	
	    this._timer = null;
	    this._input = null;
	    this.count = 0;
	}
	
	inherit(TapRecognizer, Recognizer, {
	    /**
	     * @namespace
	     * @memberof PinchRecognizer
	     */
	    defaults: {
	        event: 'tap',
	        pointers: 1,
	        taps: 1,
	        interval: 300, // max time between the multi-tap taps
	        time: 250, // max time of the pointer to be down (like finger on the screen)
	        threshold: 9, // a minimal movement is ok, but keep it low
	        posThreshold: 10 // a multi-tap can be a bit off the initial position
	    },
	
	    getTouchAction: function() {
	        return [TOUCH_ACTION_MANIPULATION];
	    },
	
	    process: function(input) {
	        var options = this.options;
	
	        var validPointers = input.pointers.length === options.pointers;
	        var validMovement = input.distance < options.threshold;
	        var validTouchTime = input.deltaTime < options.time;
	
	        this.reset();
	
	        if ((input.eventType & INPUT_START) && (this.count === 0)) {
	            return this.failTimeout();
	        }
	
	        // we only allow little movement
	        // and we've reached an end event, so a tap is possible
	        if (validMovement && validTouchTime && validPointers) {
	            if (input.eventType != INPUT_END) {
	                return this.failTimeout();
	            }
	
	            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
	            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
	
	            this.pTime = input.timeStamp;
	            this.pCenter = input.center;
	
	            if (!validMultiTap || !validInterval) {
	                this.count = 1;
	            } else {
	                this.count += 1;
	            }
	
	            this._input = input;
	
	            // if tap count matches we have recognized it,
	            // else it has began recognizing...
	            var tapCount = this.count % options.taps;
	            if (tapCount === 0) {
	                // no failing requirements, immediately trigger the tap event
	                // or wait as long as the multitap interval to trigger
	                if (!this.hasRequireFailures()) {
	                    return STATE_RECOGNIZED;
	                } else {
	                    this._timer = setTimeoutContext(function() {
	                        this.state = STATE_RECOGNIZED;
	                        this.tryEmit();
	                    }, options.interval, this);
	                    return STATE_BEGAN;
	                }
	            }
	        }
	        return STATE_FAILED;
	    },
	
	    failTimeout: function() {
	        this._timer = setTimeoutContext(function() {
	            this.state = STATE_FAILED;
	        }, this.options.interval, this);
	        return STATE_FAILED;
	    },
	
	    reset: function() {
	        clearTimeout(this._timer);
	    },
	
	    emit: function() {
	        if (this.state == STATE_RECOGNIZED) {
	            this._input.tapCount = this.count;
	            this.manager.emit(this.options.event, this._input);
	        }
	    }
	});
	
	/**
	 * Simple way to create a manager with a default set of recognizers.
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Hammer(element, options) {
	    options = options || {};
	    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
	    return new Manager(element, options);
	}
	
	/**
	 * @const {string}
	 */
	Hammer.VERSION = '2.0.7';
	
	/**
	 * default settings
	 * @namespace
	 */
	Hammer.defaults = {
	    /**
	     * set if DOM events are being triggered.
	     * But this is slower and unused by simple implementations, so disabled by default.
	     * @type {Boolean}
	     * @default false
	     */
	    domEvents: false,
	
	    /**
	     * The value for the touchAction property/fallback.
	     * When set to `compute` it will magically set the correct value based on the added recognizers.
	     * @type {String}
	     * @default compute
	     */
	    touchAction: TOUCH_ACTION_COMPUTE,
	
	    /**
	     * @type {Boolean}
	     * @default true
	     */
	    enable: true,
	
	    /**
	     * EXPERIMENTAL FEATURE -- can be removed/changed
	     * Change the parent input target element.
	     * If Null, then it is being set the to main element.
	     * @type {Null|EventTarget}
	     * @default null
	     */
	    inputTarget: null,
	
	    /**
	     * force an input class
	     * @type {Null|Function}
	     * @default null
	     */
	    inputClass: null,
	
	    /**
	     * Default recognizer setup when calling `Hammer()`
	     * When creating a new Manager these will be skipped.
	     * @type {Array}
	     */
	    preset: [
	        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
	        [RotateRecognizer, {enable: false}],
	        [PinchRecognizer, {enable: false}, ['rotate']],
	        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
	        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
	        [TapRecognizer],
	        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
	        [PressRecognizer]
	    ],
	
	    /**
	     * Some CSS properties can be used to improve the working of Hammer.
	     * Add them to this method and they will be set when creating a new Manager.
	     * @namespace
	     */
	    cssProps: {
	        /**
	         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userSelect: 'none',
	
	        /**
	         * Disable the Windows Phone grippers when pressing an element.
	         * @type {String}
	         * @default 'none'
	         */
	        touchSelect: 'none',
	
	        /**
	         * Disables the default callout shown when you touch and hold a touch target.
	         * On iOS, when you touch and hold a touch target such as a link, Safari displays
	         * a callout containing information about the link. This property allows you to disable that callout.
	         * @type {String}
	         * @default 'none'
	         */
	        touchCallout: 'none',
	
	        /**
	         * Specifies whether zooming is enabled. Used by IE10>
	         * @type {String}
	         * @default 'none'
	         */
	        contentZooming: 'none',
	
	        /**
	         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
	         * @type {String}
	         * @default 'none'
	         */
	        userDrag: 'none',
	
	        /**
	         * Overrides the highlight color shown when the user taps a link or a JavaScript
	         * clickable element in iOS. This property obeys the alpha value, if specified.
	         * @type {String}
	         * @default 'rgba(0,0,0,0)'
	         */
	        tapHighlightColor: 'rgba(0,0,0,0)'
	    }
	};
	
	var STOP = 1;
	var FORCED_STOP = 2;
	
	/**
	 * Manager
	 * @param {HTMLElement} element
	 * @param {Object} [options]
	 * @constructor
	 */
	function Manager(element, options) {
	    this.options = assign({}, Hammer.defaults, options || {});
	
	    this.options.inputTarget = this.options.inputTarget || element;
	
	    this.handlers = {};
	    this.session = {};
	    this.recognizers = [];
	    this.oldCssProps = {};
	
	    this.element = element;
	    this.input = createInputInstance(this);
	    this.touchAction = new TouchAction(this, this.options.touchAction);
	
	    toggleCssProps(this, true);
	
	    each(this.options.recognizers, function(item) {
	        var recognizer = this.add(new (item[0])(item[1]));
	        item[2] && recognizer.recognizeWith(item[2]);
	        item[3] && recognizer.requireFailure(item[3]);
	    }, this);
	}
	
	Manager.prototype = {
	    /**
	     * set options
	     * @param {Object} options
	     * @returns {Manager}
	     */
	    set: function(options) {
	        assign(this.options, options);
	
	        // Options that need a little more setup
	        if (options.touchAction) {
	            this.touchAction.update();
	        }
	        if (options.inputTarget) {
	            // Clean up existing event listeners and reinitialize
	            this.input.destroy();
	            this.input.target = options.inputTarget;
	            this.input.init();
	        }
	        return this;
	    },
	
	    /**
	     * stop recognizing for this session.
	     * This session will be discarded, when a new [input]start event is fired.
	     * When forced, the recognizer cycle is stopped immediately.
	     * @param {Boolean} [force]
	     */
	    stop: function(force) {
	        this.session.stopped = force ? FORCED_STOP : STOP;
	    },
	
	    /**
	     * run the recognizers!
	     * called by the inputHandler function on every movement of the pointers (touches)
	     * it walks through all the recognizers and tries to detect the gesture that is being made
	     * @param {Object} inputData
	     */
	    recognize: function(inputData) {
	        var session = this.session;
	        if (session.stopped) {
	            return;
	        }
	
	        // run the touch-action polyfill
	        this.touchAction.preventDefaults(inputData);
	
	        var recognizer;
	        var recognizers = this.recognizers;
	
	        // this holds the recognizer that is being recognized.
	        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
	        // if no recognizer is detecting a thing, it is set to `null`
	        var curRecognizer = session.curRecognizer;
	
	        // reset when the last recognizer is recognized
	        // or when we're in a new session
	        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
	            curRecognizer = session.curRecognizer = null;
	        }
	
	        var i = 0;
	        while (i < recognizers.length) {
	            recognizer = recognizers[i];
	
	            // find out if we are allowed try to recognize the input for this one.
	            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
	            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
	            //      that is being recognized.
	            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
	            //      this can be setup with the `recognizeWith()` method on the recognizer.
	            if (session.stopped !== FORCED_STOP && ( // 1
	                    !curRecognizer || recognizer == curRecognizer || // 2
	                    recognizer.canRecognizeWith(curRecognizer))) { // 3
	                recognizer.recognize(inputData);
	            } else {
	                recognizer.reset();
	            }
	
	            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
	            // current active recognizer. but only if we don't already have an active recognizer
	            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
	                curRecognizer = session.curRecognizer = recognizer;
	            }
	            i++;
	        }
	    },
	
	    /**
	     * get a recognizer by its event name.
	     * @param {Recognizer|String} recognizer
	     * @returns {Recognizer|Null}
	     */
	    get: function(recognizer) {
	        if (recognizer instanceof Recognizer) {
	            return recognizer;
	        }
	
	        var recognizers = this.recognizers;
	        for (var i = 0; i < recognizers.length; i++) {
	            if (recognizers[i].options.event == recognizer) {
	                return recognizers[i];
	            }
	        }
	        return null;
	    },
	
	    /**
	     * add a recognizer to the manager
	     * existing recognizers with the same event name will be removed
	     * @param {Recognizer} recognizer
	     * @returns {Recognizer|Manager}
	     */
	    add: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'add', this)) {
	            return this;
	        }
	
	        // remove existing
	        var existing = this.get(recognizer.options.event);
	        if (existing) {
	            this.remove(existing);
	        }
	
	        this.recognizers.push(recognizer);
	        recognizer.manager = this;
	
	        this.touchAction.update();
	        return recognizer;
	    },
	
	    /**
	     * remove a recognizer by name or instance
	     * @param {Recognizer|String} recognizer
	     * @returns {Manager}
	     */
	    remove: function(recognizer) {
	        if (invokeArrayArg(recognizer, 'remove', this)) {
	            return this;
	        }
	
	        recognizer = this.get(recognizer);
	
	        // let's make sure this recognizer exists
	        if (recognizer) {
	            var recognizers = this.recognizers;
	            var index = inArray(recognizers, recognizer);
	
	            if (index !== -1) {
	                recognizers.splice(index, 1);
	                this.touchAction.update();
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * bind event
	     * @param {String} events
	     * @param {Function} handler
	     * @returns {EventEmitter} this
	     */
	    on: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	        if (handler === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            handlers[event] = handlers[event] || [];
	            handlers[event].push(handler);
	        });
	        return this;
	    },
	
	    /**
	     * unbind event, leave emit blank to remove all handlers
	     * @param {String} events
	     * @param {Function} [handler]
	     * @returns {EventEmitter} this
	     */
	    off: function(events, handler) {
	        if (events === undefined) {
	            return;
	        }
	
	        var handlers = this.handlers;
	        each(splitStr(events), function(event) {
	            if (!handler) {
	                delete handlers[event];
	            } else {
	                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
	            }
	        });
	        return this;
	    },
	
	    /**
	     * emit event to the listeners
	     * @param {String} event
	     * @param {Object} data
	     */
	    emit: function(event, data) {
	        // we also want to trigger dom events
	        if (this.options.domEvents) {
	            triggerDomEvent(event, data);
	        }
	
	        // no handlers, so skip it all
	        var handlers = this.handlers[event] && this.handlers[event].slice();
	        if (!handlers || !handlers.length) {
	            return;
	        }
	
	        data.type = event;
	        data.preventDefault = function() {
	            data.srcEvent.preventDefault();
	        };
	
	        var i = 0;
	        while (i < handlers.length) {
	            handlers[i](data);
	            i++;
	        }
	    },
	
	    /**
	     * destroy the manager and unbinds all events
	     * it doesn't unbind dom events, that is the user own responsibility
	     */
	    destroy: function() {
	        this.element && toggleCssProps(this, false);
	
	        this.handlers = {};
	        this.session = {};
	        this.input.destroy();
	        this.element = null;
	    }
	};
	
	/**
	 * add/remove the css properties as defined in manager.options.cssProps
	 * @param {Manager} manager
	 * @param {Boolean} add
	 */
	function toggleCssProps(manager, add) {
	    var element = manager.element;
	    if (!element.style) {
	        return;
	    }
	    var prop;
	    each(manager.options.cssProps, function(value, name) {
	        prop = prefixed(element.style, name);
	        if (add) {
	            manager.oldCssProps[prop] = element.style[prop];
	            element.style[prop] = value;
	        } else {
	            element.style[prop] = manager.oldCssProps[prop] || '';
	        }
	    });
	    if (!add) {
	        manager.oldCssProps = {};
	    }
	}
	
	/**
	 * trigger dom event
	 * @param {String} event
	 * @param {Object} data
	 */
	function triggerDomEvent(event, data) {
	    var gestureEvent = document.createEvent('Event');
	    gestureEvent.initEvent(event, true, true);
	    gestureEvent.gesture = data;
	    data.target.dispatchEvent(gestureEvent);
	}
	
	assign(Hammer, {
	    INPUT_START: INPUT_START,
	    INPUT_MOVE: INPUT_MOVE,
	    INPUT_END: INPUT_END,
	    INPUT_CANCEL: INPUT_CANCEL,
	
	    STATE_POSSIBLE: STATE_POSSIBLE,
	    STATE_BEGAN: STATE_BEGAN,
	    STATE_CHANGED: STATE_CHANGED,
	    STATE_ENDED: STATE_ENDED,
	    STATE_RECOGNIZED: STATE_RECOGNIZED,
	    STATE_CANCELLED: STATE_CANCELLED,
	    STATE_FAILED: STATE_FAILED,
	
	    DIRECTION_NONE: DIRECTION_NONE,
	    DIRECTION_LEFT: DIRECTION_LEFT,
	    DIRECTION_RIGHT: DIRECTION_RIGHT,
	    DIRECTION_UP: DIRECTION_UP,
	    DIRECTION_DOWN: DIRECTION_DOWN,
	    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
	    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
	    DIRECTION_ALL: DIRECTION_ALL,
	
	    Manager: Manager,
	    Input: Input,
	    TouchAction: TouchAction,
	
	    TouchInput: TouchInput,
	    MouseInput: MouseInput,
	    PointerEventInput: PointerEventInput,
	    TouchMouseInput: TouchMouseInput,
	    SingleTouchInput: SingleTouchInput,
	
	    Recognizer: Recognizer,
	    AttrRecognizer: AttrRecognizer,
	    Tap: TapRecognizer,
	    Pan: PanRecognizer,
	    Swipe: SwipeRecognizer,
	    Pinch: PinchRecognizer,
	    Rotate: RotateRecognizer,
	    Press: PressRecognizer,
	
	    on: addEventListeners,
	    off: removeEventListeners,
	    each: each,
	    merge: merge,
	    extend: extend,
	    assign: assign,
	    inherit: inherit,
	    bindFn: bindFn,
	    prefixed: prefixed
	});
	
	// this prevents errors when Hammer is loaded in the presence of an AMD
	//  style loader but by script tag, not by the loader.
	var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
	freeGlobal.Hammer = Hammer;
	
	if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	        return Hammer;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module != 'undefined' && module.exports) {
	    module.exports = Hammer;
	} else {
	    window[exportName] = Hammer;
	}
	
	})(window, document, 'Hammer');


/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(304);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(187);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(230);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(949);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(950);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 2261 */
/***/ function(module, exports) {

	function DummyCache() {}
	
	DummyCache.prototype.get = function () {
	  return null;
	};
	
	DummyCache.prototype.has = function () {
	  return false;
	};
	
	DummyCache.prototype.set = function () {
	};
	
	module.exports = DummyCache;


/***/ },
/* 2262 */
/***/ function(module, exports) {

	function ConfigurationError(message) {
	  this.name = 'ConfigurationError';
	  this.message = (message || '');
	}
	ConfigurationError.prototype = Error.prototype;
	
	function TokenValidationError(message) {
	  this.name = 'TokenValidationError';
	  this.message = (message || '');
	}
	TokenValidationError.prototype = Error.prototype;
	
	module.exports = {
	  ConfigurationError: ConfigurationError,
	  TokenValidationError: TokenValidationError
	};


/***/ },
/* 2263 */
/***/ function(module, exports, __webpack_require__) {

	var urljoin = __webpack_require__(141);
	var base64 = __webpack_require__(951);
	var request = __webpack_require__(1410);
	
	function process(jwks) {
	  var modulus = base64.decodeToHEX(jwks.n);
	  var exp = base64.decodeToHEX(jwks.e);
	
	  return {
	    modulus: modulus,
	    exp: exp
	  };
	}
	
	function getJWKS(options, cb) {
	  var url = urljoin(options.iss, '.well-known', 'jwks.json');
	
	  return request
	    .get(url)
	    .end(function (err, data) {
	      var matchingKey = null;
	      var a;
	      var key;
	
	      if (err) {
	        cb(err);
	      }
	
	      // eslint-disable-next-line no-plusplus
	      for (a = 0; a < data.body.keys.length && matchingKey === null; a++) {
	        key = data.body.keys[a];
	        if (key.kid === options.kid) {
	          matchingKey = key;
	        }
	      }
	
	      cb(null, process(matchingKey));
	    });
	}
	
	module.exports = {
	  process: process,
	  getJWKS: getJWKS
	};


/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Based on the work of Tom Wu
	http://www-cs-students.stanford.edu/~tjw/jsbn/
	http://www-cs-students.stanford.edu/~tjw/jsbn/LICENSE
	*/
	
	var BigInteger = __webpack_require__(2293).BigInteger;
	var SHA256 = __webpack_require__(1874);
	
	var DigestInfoHead = {
	  sha1: '3021300906052b0e03021a05000414',
	  sha224: '302d300d06096086480165030402040500041c',
	  sha256: '3031300d060960864801650304020105000420',
	  sha384: '3041300d060960864801650304020205000430',
	  sha512: '3051300d060960864801650304020305000440',
	  md2: '3020300c06082a864886f70d020205000410',
	  md5: '3020300c06082a864886f70d020505000410',
	  ripemd160: '3021300906052b2403020105000414'
	};
	
	var DigestAlgs = {
	  sha256: SHA256
	};
	
	function RSAVerifier(modulus, exp) {
	  this.n = null;
	  this.e = 0;
	
	  if (modulus != null && exp != null && modulus.length > 0 && exp.length > 0) {
	    this.n = new BigInteger(modulus, 16);
	    this.e = parseInt(exp, 16);
	  } else {
	    throw new Error('Invalid key data');
	  }
	}
	
	function getAlgorithmFromDigest(hDigestInfo) {
	  for (var algName in DigestInfoHead) {
	    var head = DigestInfoHead[algName];
	    var len = head.length;
	
	    if (hDigestInfo.substring(0, len) === head) {
	      return {
	        alg: algName,
	        hash: hDigestInfo.substring(len)
	      };
	    }
	  }
	  return [];
	}
	
	
	RSAVerifier.prototype.verify = function (msg, encsig) {
	  encsig = encsig.replace(/[^0-9a-f]|[\s\n]]/ig, '');
	
	  var sig = new BigInteger(encsig, 16);
	  if (sig.bitLength() > this.n.bitLength()) {
	    throw new Error('Signature does not match with the key modulus.');
	  }
	
	  var decryptedSig = sig.modPowInt(this.e, this.n);
	  var digest = decryptedSig.toString(16).replace(/^1f+00/, '');
	
	  var digestInfo = getAlgorithmFromDigest(digest);
	  if (digestInfo.length === 0) {
	    return false;
	  }
	
	  if (!DigestAlgs.hasOwnProperty(digestInfo.alg)) {
	    throw new Error('Hashing algorithm is not supported.');
	  }
	
	  var msgHash = DigestAlgs[digestInfo.alg](msg).toString();
	  return (digestInfo.hash === msgHash);
	};
	
	module.exports = RSAVerifier;


/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	var RSAVerifier = __webpack_require__(2264);
	var base64 = __webpack_require__(951);
	var jwks = __webpack_require__(2263);
	var error = __webpack_require__(2262);
	var DummyCache = __webpack_require__(2261);
	var supportedAlgs = ['RS256'];
	
	/**
	 * Creates a new id_token verifier
	 * @constructor
	 * @param {Object} parameters
	 * @param {String} parameters.issuer name of the issuer of the token
	 * that should match the `iss` claim in the id_token
	 * @param {String} parameters.audience identifies the recipients that the JWT is intended for
	 * and should match the `aud` claim
	 * @param {Object} [parameters.jwksCache] cache for JSON Web Token Keys. By default it has no cache
	 * @param {String} [parameters.expectedAlg='RS256'] algorithm in which the id_token was signed
	 * and will be used to validate
	 * @param {number} [parameters.leeway=0] number of seconds that the clock can be out of sync
	 * while validating expiration of the id_token
	 */
	function IdTokenVerifier(parameters) {
	  var options = parameters || {};
	
	  this.jwksCache = options.jwksCache || new DummyCache();
	  this.expectedAlg = options.expectedAlg || 'RS256';
	  this.issuer = options.issuer;
	  this.audience = options.audience;
	  this.leeway = options.leeway || 0;
	  this.__disableExpirationCheck = options.__disableExpirationCheck || false;
	
	  if (this.leeway < 0 || this.leeway > 60) {
	    throw new error.ConfigurationError('The leeway should be positive and lower than a minute.');
	  }
	
	  if (supportedAlgs.indexOf(this.expectedAlg) === -1) {
	    throw new error.ConfigurationError('Algorithm ' + this.expectedAlg +
	      ' is not supported. (Expected algs: [' + supportedAlgs.join(',') + '])');
	  }
	}
	
	/**
	 * @callback verifyCallback
	 * @param {Error} [err] error returned if the verify cannot be performed
	 * @param {boolean} [status] if the token is valid or not
	 */
	
	/**
	 * Verifies an id_token
	 *
	 * It will validate:
	 * - signature according to the algorithm configured in the verifier.
	 * - if nonce is present and matches the one provided
	 * - if `iss` and `aud` claims matches the configured issuer and audience
	 * - if token is not expired and valid (if the `nbf` claim is in the past)
	 *
	 * @method verify
	 * @param {String} token id_token to verify
	 * @param {String} [nonce] nonce value that should match the one in the id_token claims
	 * @param {verifyCallback} cb callback used to notify the results of the validation
	 */
	IdTokenVerifier.prototype.verify = function (token, nonce, cb) {
	  var jwt = this.decode(token);
	
	  if (jwt instanceof Error) {
	    return cb(jwt, false);
	  }
	
	  /* eslint-disable vars-on-top */
	  var headAndPayload = jwt.encoded.header + '.' + jwt.encoded.payload;
	  var signature = base64.decodeToHEX(jwt.encoded.signature);
	
	  var alg = jwt.header.alg;
	  var kid = jwt.header.kid;
	
	  var aud = jwt.payload.aud;
	  var iss = jwt.payload.iss;
	  var exp = jwt.payload.exp;
	  var nbf = jwt.payload.nbf;
	  var tnonce = jwt.payload.nonce || null;
	  /* eslint-enable vars-on-top */
	
	  if (this.issuer !== iss) {
	    return cb(new error.TokenValidationError('Issuer ' + iss + ' is not valid.'), false);
	  }
	
	  if (this.audience !== aud) {
	    return cb(new error.TokenValidationError('Audience ' + aud + ' is not valid.'), false);
	  }
	
	  if (this.expectedAlg !== alg) {
	    return cb(new error.TokenValidationError('Algorithm ' + alg +
	      ' is not supported. (Expected algs: [' + supportedAlgs.join(',') + '])'), false);
	  }
	
	  if (tnonce !== nonce) {
	    return cb(new error.TokenValidationError('Nonce does not match.'), false);
	  }
	
	  var expirationError = this.verifyExpAndNbf(exp, nbf); // eslint-disable-line vars-on-top
	
	  if (expirationError) {
	    return cb(expirationError, false);
	  }
	
	  return this.getRsaVerifier(iss, kid, function (err, rsaVerifier) {
	    if (err) {
	      return cb(err);
	    }
	    if (rsaVerifier.verify(headAndPayload, signature)) {
	      return cb(null, jwt.payload);
	    }
	    return cb(new error.TokenValidationError('Invalid signature.'));
	  });
	};
	
	/**
	 * Verifies that the `exp` and `nbf` claims are valid in the current moment.
	 *
	 * @method verifyExpAndNbf
	 * @param {String} exp value of `exp` claim
	 * @param {String} nbf value of `nbf` claim
	 * @return {boolean} if token is valid according to `exp` and `nbf`
	 */
	IdTokenVerifier.prototype.verifyExpAndNbf = function (exp, nbf) {
	  var now = new Date();
	  var expDate = new Date(0);
	  var nbfDate = new Date(0);
	
	  if (this.__disableExpirationCheck) {
	    return null;
	  }
	
	  expDate.setUTCSeconds(exp + this.leeway);
	
	  if (now > expDate) {
	    return new error.TokenValidationError('Expired token.');
	  }
	
	  if (typeof nbf === 'undefined') {
	    return null;
	  }
	  nbfDate.setUTCSeconds(nbf - this.leeway);
	  if (now < nbfDate) {
	    return new error.TokenValidationError('The token is not valid until later in the future. ' +
	      'Please check your computed clock.');
	  }
	
	  return null;
	};
	
	/**
	 * Verifies that the `exp` and `iat` claims are valid in the current moment.
	 *
	 * @method verifyExpAndIat
	 * @param {String} exp value of `exp` claim
	 * @param {String} iat value of `iat` claim
	 * @return {boolean} if token is valid according to `exp` and `iat`
	 */
	IdTokenVerifier.prototype.verifyExpAndIat = function (exp, iat) {
	  var now = new Date();
	  var expDate = new Date(0);
	  var iatDate = new Date(0);
	
	  if (this.__disableExpirationCheck) {
	    return null;
	  }
	
	  expDate.setUTCSeconds(exp + this.leeway);
	
	  if (now > expDate) {
	    return new error.TokenValidationError('Expired token.');
	  }
	
	  iatDate.setUTCSeconds(iat - this.leeway);
	
	  if (now < iatDate) {
	    return new error.TokenValidationError('The token was issued in the future. ' +
	      'Please check your computed clock.');
	  }
	  return null;
	};
	
	IdTokenVerifier.prototype.getRsaVerifier = function (iss, kid, cb) {
	  var _this = this;
	  var cachekey = iss + kid;
	
	  if (!this.jwksCache.has(cachekey)) {
	    jwks.getJWKS({
	      iss: iss,
	      kid: kid
	    }, function (err, keyInfo) {
	      if (err) {
	        cb(err);
	      }
	      _this.jwksCache.set(cachekey, keyInfo);
	      cb(null, new RSAVerifier(keyInfo.modulus, keyInfo.exp));
	    });
	  } else {
	    var keyInfo = this.jwksCache.get(cachekey); // eslint-disable-line vars-on-top
	    cb(null, new RSAVerifier(keyInfo.modulus, keyInfo.exp));
	  }
	};
	
	
	/**
	 * @typedef DecodedToken
	 * @type {Object}
	 * @property {Object} header - content of the JWT header.
	 * @property {Object} payload - token claims.
	 * @property {Object} encoded - encoded parts of the token.
	 */
	
	/**
	 * Decodes a well formed JWT without any verification
	 *
	 * @method decode
	 * @param {String} token decodes the token
	 * @return {DecodedToken} if token is valid according to `exp` and `nbf`
	 */
	IdTokenVerifier.prototype.decode = function (token) {
	  var parts = token.split('.');
	  var header;
	  var payload;
	
	  if (parts.length !== 3) {
	    return new error.TokenValidationError('Cannot decode a malformed JWT');
	  }
	
	  try {
	    header = JSON.parse(base64.decodeToString(parts[0]));
	    payload = JSON.parse(base64.decodeToString(parts[1]));
	  } catch (e) {
	    return new error.TokenValidationError('Token header or payload is not valid JSON');
	  }
	
	  return {
	    header: header,
	    payload: payload,
	    encoded: {
	      header: parts[0],
	      payload: parts[1],
	      signature: parts[2]
	    }
	  };
	};
	
	module.exports = IdTokenVerifier;


/***/ },
/* 2266 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 2267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(1755);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _parse2 = __webpack_require__(439);
	
	var _parse3 = _interopRequireDefault(_parse2);
	
	var _inputControl = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Usage:
	//
	// <ReactInput
	// 	value={this.state.phone}
	// 	onChange={phone => this.setState({ phone })}
	// 	parse={character => character}
	// 	format={value => ({ text: value, template: 'xxxxxxxx' })}/>
	//
	var ReactInput = function (_React$Component) {
		(0, _inherits3.default)(ReactInput, _React$Component);
	
		function ReactInput() {
			var _ref;
	
			var _temp, _this, _ret;
	
			(0, _classCallCheck3.default)(this, ReactInput);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ReactInput.__proto__ || (0, _getPrototypeOf2.default)(ReactInput)).call.apply(_ref, [this].concat(args))), _this), _this.storeInstance = function (instance) {
				_this.input = instance;
			}, _this.getInputElement = function () {
				return _this.input;
			}, _this.onChange = function (event) {
				var _this$props = _this.props,
				    parse = _this$props.parse,
				    format = _this$props.format;
	
	
				return (0, _inputControl.onChange)(event, _this.getInputElement(), parse, format, _this.props.onChange);
			}, _this.onPaste = function (event) {
				var _this$props2 = _this.props,
				    parse = _this$props2.parse,
				    format = _this$props2.format;
	
	
				return (0, _inputControl.onPaste)(event, _this.getInputElement(), parse, format, _this.props.onChange);
			}, _this.onCut = function (event) {
				var _this$props3 = _this.props,
				    parse = _this$props3.parse,
				    format = _this$props3.format;
	
	
				return (0, _inputControl.onCut)(event, _this.getInputElement(), parse, format, _this.props.onChange);
			}, _this.onBlur = function (event) {
				var _this$props4 = _this.props,
				    parse = _this$props4.parse,
				    onBlur = _this$props4.onBlur;
	
				// This `onBlur` interceptor is a workaround for `redux-form`,
				// so that it gets the right (parsed, not the formatted one)
				// `event.target.value` in its `onBlur` handler.
	
				if (onBlur) {
					var _event = (0, _extends3.default)({}, event, {
						target: (0, _extends3.default)({}, event.target, {
							value: (0, _parse3.default)(_this.getInputElement().value, undefined, parse).value
						})
	
						// For `redux-form` event detection.
						// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
					});_event.stopPropagation = event.stopPropagation;
					_event.preventDefault = event.preventDefault;
	
					onBlur(_event);
				}
			}, _this.onKeyDown = function (event) {
				var _this$props5 = _this.props,
				    parse = _this$props5.parse,
				    format = _this$props5.format;
	
	
				if (_this.props.onKeyDown) {
					_this.props.onKeyDown(event);
				}
	
				return (0, _inputControl.onKeyDown)(event, _this.getInputElement(), parse, format, _this.props.onChange);
			}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
		}
	
		(0, _createClass3.default)(ReactInput, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    value = _props.value,
				    parse = _props.parse,
				    format = _props.format,
				    inputComponent = _props.inputComponent,
				    rest = (0, _objectWithoutProperties3.default)(_props, ['value', 'parse', 'format', 'inputComponent']);
	
				// Non-string `inputComponent`s would work in this case
				// but it would also introduce a caret reset bug:
				// the caret position would reset on each input.
				// The origins of this bug are unknown, they may be
				// somehow related to the `ref` property
				// being intercepted by React here.
	
				return _react2.default.createElement(inputComponent, (0, _extends3.default)({}, rest, {
					ref: this.storeInstance,
					value: format(isEmpty(value) ? '' : value).text,
					onKeyDown: this.onKeyDown,
					onChange: this.onChange,
					onPaste: this.onPaste,
					onCut: this.onCut,
					onBlur: this.onBlur
				}));
			}
	
			/**
	   * Returns `<input/>` DOM Element.
	   * @return {DOMElement}
	   */
	
	
			// This handler is a workaround for `redux-form`.
	
		}, {
			key: 'focus',
	
	
			/**
	   * Focuses the `<input/>`.
	   * Can be called manually.
	   */
			value: function focus() {
				this.getInputElement().focus();
			}
		}]);
		return ReactInput;
	}(_react2.default.Component);
	
	ReactInput.propTypes = {
		// Parses a single characher of `<input/>` text.
		parse: _propTypes2.default.func.isRequired,
	
		// Formats `value` into `<input/>` text.
		format: _propTypes2.default.func.isRequired,
	
		// Renders `<input/>` by default.
		// For some reason non-default `inputComponent`
		// will reset caret position.
		inputComponent: _propTypes2.default.string.isRequired,
	
		// `<input/>` `type` attribute.
		type: _propTypes2.default.string.isRequired,
	
		// Is parsed from <input/> text.
		value: _propTypes2.default.string,
	
		// This handler is called each time `<input/>` text is changed.
		onChange: _propTypes2.default.func.isRequired,
	
		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the parsed `value` in its `onBlur` handler,
		// not the formatted text.
		onBlur: _propTypes2.default.func,
	
		// Passthrough
		onKeyDown: _propTypes2.default.func
	};
	ReactInput.defaultProps = {
		// Renders `<input/>` by default.
		// For some reason non-default `inputComponent`
		// will reset caret position.
		inputComponent: 'input',
	
		// `<input/>` `type` attribute.
		type: 'text'
	};
	exports.default = ReactInput;
	
	
	function isEmpty(value) {
		return value === undefined || value === null;
	}
	//# sourceMappingURL=ReactInput.js.map

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = close_braces;
	
	var _helpers = __webpack_require__(438);
	
	function close_braces(retained_template, template) {
		var placeholder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
		var empty_placeholder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ';
	
		var cut_before = retained_template.length;
	
		var opening_braces = (0, _helpers.count_occurences)('(', retained_template);
		var closing_braces = (0, _helpers.count_occurences)(')', retained_template);
	
		var dangling_braces = opening_braces - closing_braces;
	
		while (dangling_braces > 0 && cut_before < template.length) {
			retained_template += template[cut_before].replace(placeholder, empty_placeholder);
	
			if (template[cut_before] === ')') {
				dangling_braces--;
			}
	
			cut_before++;
		}
	
		return retained_template;
	}
	//# sourceMappingURL=close braces.js.map

/***/ },
/* 2269 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getSelection = getSelection;
	exports.getOperation = getOperation;
	exports.getCaretPosition = getCaretPosition;
	exports.setCaretPosition = setCaretPosition;
	// Gets <input/> selection bounds
	function getSelection(element) {
		// If no selection, return nothing
		if (element.selectionStart === element.selectionEnd) {
			return;
		}
	
		return { start: element.selectionStart, end: element.selectionEnd };
	}
	
	// Key codes
	var Keys = exports.Keys = {
		Backspace: 8,
		Delete: 46
	
		// Finds out the operation to be intercepted and performed
		// based on the key down event `keyCode`.
	};function getOperation(event) {
		switch (event.keyCode) {
			case Keys.Backspace:
				return 'Backspace';
	
			case Keys.Delete:
				return 'Delete';
		}
	}
	
	// Gets <input/> caret position
	function getCaretPosition(element) {
		return element.selectionStart;
	}
	
	// Sets <input/> caret position
	function setCaretPosition(element, caret_position) {
		// Sanity check
		if (caret_position === undefined) {
			return;
		}
	
		// Set caret position
		element.setSelectionRange(caret_position, caret_position);
	}
	//# sourceMappingURL=dom.js.map

/***/ },
/* 2270 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = edit;
	// Edits text `value` (if `operation` is passed) and repositions the `caret` if needed.
	//
	// Example:
	//
	// value - '88005553535'
	// caret - 2 // starting from 0; is positioned before the first zero
	// operation - 'Backspace'
	//
	// Returns
	// {
	// 	value: '8005553535'
	// 	caret: 1
	// }
	//
	// Currently supports just 'Delete' and 'Backspace' operations
	//
	function edit(value, caret, operation) {
		switch (operation) {
			case 'Backspace':
				// If there exists the previous character,
				// then erase it and reposition the caret.
				if (caret > 0) {
					// Remove the previous character
					value = value.slice(0, caret - 1) + value.slice(caret);
					// Position the caret where the previous (erased) character was
					caret--;
				}
				break;
	
			case 'Delete':
				// Remove current digit (if any)
				value = value.slice(0, caret) + value.slice(caret + 1);
				break;
		}
	
		return { value: value, caret: caret };
	}
	//# sourceMappingURL=edit.js.map

/***/ },
/* 2271 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (character, value) {
		return DIGITS[character];
	};
	
	// Copied from `libphonenumber-js`:
	// https://github.com/catamphetamine/libphonenumber-js/blob/master/source/parse.js
	//
	// These mappings map a character (key) to a specific digit that should
	// replace it for normalization purposes. Non-European digits that
	// may be used in phone numbers are mapped to a European equivalent.
	//
	// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
	//
	var DIGITS = exports.DIGITS = {
		'0': '0',
		'1': '1',
		'2': '2',
		'3': '3',
		'4': '4',
		'5': '5',
		'6': '6',
		'7': '7',
		'8': '8',
		'9': '9',
		'\uFF10': '0', // Fullwidth digit 0
		'\uFF11': '1', // Fullwidth digit 1
		'\uFF12': '2', // Fullwidth digit 2
		'\uFF13': '3', // Fullwidth digit 3
		'\uFF14': '4', // Fullwidth digit 4
		'\uFF15': '5', // Fullwidth digit 5
		'\uFF16': '6', // Fullwidth digit 6
		'\uFF17': '7', // Fullwidth digit 7
		'\uFF18': '8', // Fullwidth digit 8
		'\uFF19': '9', // Fullwidth digit 9
		'\u0660': '0', // Arabic-indic digit 0
		'\u0661': '1', // Arabic-indic digit 1
		'\u0662': '2', // Arabic-indic digit 2
		'\u0663': '3', // Arabic-indic digit 3
		'\u0664': '4', // Arabic-indic digit 4
		'\u0665': '5', // Arabic-indic digit 5
		'\u0666': '6', // Arabic-indic digit 6
		'\u0667': '7', // Arabic-indic digit 7
		'\u0668': '8', // Arabic-indic digit 8
		'\u0669': '9', // Arabic-indic digit 9
		'\u06F0': '0', // Eastern-Arabic digit 0
		'\u06F1': '1', // Eastern-Arabic digit 1
		'\u06F2': '2', // Eastern-Arabic digit 2
		'\u06F3': '3', // Eastern-Arabic digit 3
		'\u06F4': '4', // Eastern-Arabic digit 4
		'\u06F5': '5', // Eastern-Arabic digit 5
		'\u06F6': '6', // Eastern-Arabic digit 6
		'\u06F7': '7', // Eastern-Arabic digit 7
		'\u06F8': '8', // Eastern-Arabic digit 8
		'\u06F9': '9' // Eastern-Arabic digit 9
	};
	//# sourceMappingURL=parse digit.js.map

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (template, placeholder, parse) {
		if (typeof placeholder === 'function') {
			parse = placeholder;
			placeholder = 'x';
		}
	
		var max_characters = (0, _helpers.count_occurences)(placeholder, template);
	
		return function (character, value) {
			if (value.length < max_characters) {
				return parse(character, value);
			}
		};
	};
	
	var _helpers = __webpack_require__(438);
	//# sourceMappingURL=template parser.js.map

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(2275)['default'];
	exports['default'] = exports;


/***/ },
/* 2274 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Function.prototype.bind implementation from Mozilla Developer Network:
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill
	
	"use strict";
	
	var bind = Function.prototype.bind || function (oThis) {
	    if (typeof this !== 'function') {
	      // closest thing possible to the ECMAScript 5
	      // internal IsCallable function
	      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
	    }
	
	    var aArgs   = Array.prototype.slice.call(arguments, 1),
	        fToBind = this,
	        fNOP    = function() {},
	        fBound  = function() {
	          return fToBind.apply(this instanceof fNOP
	                 ? this
	                 : oThis,
	                 aArgs.concat(Array.prototype.slice.call(arguments)));
	        };
	
	    if (this.prototype) {
	      // native functions don't have a prototype
	      fNOP.prototype = this.prototype;
	    }
	    fBound.prototype = new fNOP();
	
	    return fBound;
	};
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jshint esnext: true */
	
	"use strict";
	var src$es5$$ = __webpack_require__(2274);
	exports["default"] = createFormatCache;
	
	// -----------------------------------------------------------------------------
	
	function createFormatCache(FormatConstructor) {
	    var cache = src$es5$$.objCreate(null);
	
	    return function () {
	        var args    = Array.prototype.slice.call(arguments);
	        var cacheId = getCacheId(args);
	        var format  = cacheId && cache[cacheId];
	
	        if (!format) {
	            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();
	
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	
	        return format;
	    };
	}
	
	// -- Utilities ----------------------------------------------------------------
	
	function getCacheId(inputs) {
	    // When JSON is not available in the runtime, we will not create a cache id.
	    if (typeof JSON === 'undefined') { return; }
	
	    var cacheId = [];
	
	    var i, len, input;
	
	    for (i = 0, len = inputs.length; i < len; i += 1) {
	        input = inputs[i];
	
	        if (input && typeof input === 'object') {
	            cacheId.push(orderedProps(input));
	        } else {
	            cacheId.push(input);
	        }
	    }
	
	    return JSON.stringify(cacheId);
	}
	
	function orderedProps(obj) {
	    var props = [],
	        keys  = [];
	
	    var key, i, len, prop;
	
	    for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	            keys.push(key);
	        }
	    }
	
	    var orderedKeys = keys.sort();
	
	    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
	        key  = orderedKeys[i];
	        prop = {};
	
	        prop[key] = obj[key];
	        props[i]  = prop;
	    }
	
	    return props;
	}
	
	//# sourceMappingURL=memoizer.js.map

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(2277)['default'];
	exports['default'] = exports;


/***/ },
/* 2277 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ },
/* 2278 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(956), src$es5$$ = __webpack_require__(2281), src$compiler$$ = __webpack_require__(2278), intl$messageformat$parser$$ = __webpack_require__(2276);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 2280 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(956);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 2282 */
[3449, 2279, 2280],
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(2288)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(3331);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(955), src$diff$$ = __webpack_require__(2285), src$es5$$ = __webpack_require__(2287);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = [
	    'second', 'second-short',
	    'minute', 'minute-short',
	    'hour', 'hour-short',
	    'day', 'day-short',
	    'month', 'month-short',
	    'year', 'year-short'
	];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45, 'second-short': 45,  // seconds to minute
	        minute: 45, 'minute-short': 45, // minutes to hour
	        hour  : 22, 'hour-short': 22, // hours to day
	        day   : 26, 'day-short': 26, // days to month
	        month : 11, 'month-short': 11 // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function(field) {
	        return field.indexOf('-short') < 1;
	    });
	
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ },
/* 2285 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond    : millisecond,
	        second         : second,
	        'second-short' : second,
	        minute         : minute,
	        'minute-short' : minute,
	        hour           : hour,
	        'hour-short'   : hour,
	        day            : day,
	        'day-short'    : day,
	        week           : week,
	        'week-short'   : week,
	        month          : month,
	        'month-short'  : month,
	        year           : year,
	        'year-short'   : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ },
/* 2286 */
/***/ function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"year-short":{"displayName":"yr.","relative":{"0":"this yr.","1":"next yr.","-1":"last yr."},"relativeTime":{"future":{"one":"in {0} yr.","other":"in {0} yr."},"past":{"one":"{0} yr. ago","other":"{0} yr. ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"month-short":{"displayName":"mo.","relative":{"0":"this mo.","1":"next mo.","-1":"last mo."},"relativeTime":{"future":{"one":"in {0} mo.","other":"in {0} mo."},"past":{"one":"{0} mo. ago","other":"{0} mo. ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"day-short":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"hour-short":{"displayName":"hr.","relative":{"0":"this hour"},"relativeTime":{"future":{"one":"in {0} hr.","other":"in {0} hr."},"past":{"one":"{0} hr. ago","other":"{0} hr. ago"}}},"minute":{"displayName":"minute","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"minute-short":{"displayName":"min.","relative":{"0":"this minute"},"relativeTime":{"future":{"one":"in {0} min.","other":"in {0} min."},"past":{"one":"{0} min. ago","other":"{0} min. ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}},"second-short":{"displayName":"sec.","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} sec.","other":"in {0} sec."},"past":{"one":"{0} sec. ago","other":"{0} sec. ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ },
/* 2287 */
/***/ function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	"use strict";
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ },
/* 2288 */
[3449, 2284, 2286],
/* 2289 */
/***/ function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ },
/* 2290 */
/***/ function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ },
/* 2291 */
/***/ function(module, exports) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2017, Jon Schlinkert.
	 * Released under the MIT License.
	 */
	
	'use strict';
	
	module.exports = function isObject(val) {
	  return val != null && typeof val === 'object' && Array.isArray(val) === false;
	};


/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(303);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	(function(){
	
	    // Copyright (c) 2005  Tom Wu
	    // All Rights Reserved.
	    // See "LICENSE" for details.
	
	    // Basic JavaScript BN library - subset useful for RSA encryption.
	
	    // Bits per digit
	    var dbits;
	
	    // JavaScript engine analysis
	    var canary = 0xdeadbeefcafe;
	    var j_lm = ((canary&0xffffff)==0xefcafe);
	
	    // (public) Constructor
	    function BigInteger(a,b,c) {
	      if(a != null)
	        if("number" == typeof a) this.fromNumber(a,b,c);
	        else if(b == null && "string" != typeof a) this.fromString(a,256);
	        else this.fromString(a,b);
	    }
	
	    // return new, unset BigInteger
	    function nbi() { return new BigInteger(null); }
	
	    // am: Compute w_j += (x*this_i), propagate carries,
	    // c is initial carry, returns final carry.
	    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
	    // We need to select the fastest one that works in this environment.
	
	    // am1: use a single mult and divide to get the high bits,
	    // max digit bits should be 26 because
	    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
	    function am1(i,x,w,j,c,n) {
	      while(--n >= 0) {
	        var v = x*this[i++]+w[j]+c;
	        c = Math.floor(v/0x4000000);
	        w[j++] = v&0x3ffffff;
	      }
	      return c;
	    }
	    // am2 avoids a big mult-and-extract completely.
	    // Max digit bits should be <= 30 because we do bitwise ops
	    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
	    function am2(i,x,w,j,c,n) {
	      var xl = x&0x7fff, xh = x>>15;
	      while(--n >= 0) {
	        var l = this[i]&0x7fff;
	        var h = this[i++]>>15;
	        var m = xh*l+h*xl;
	        l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);
	        c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);
	        w[j++] = l&0x3fffffff;
	      }
	      return c;
	    }
	    // Alternately, set max digit bits to 28 since some
	    // browsers slow down when dealing with 32-bit numbers.
	    function am3(i,x,w,j,c,n) {
	      var xl = x&0x3fff, xh = x>>14;
	      while(--n >= 0) {
	        var l = this[i]&0x3fff;
	        var h = this[i++]>>14;
	        var m = xh*l+h*xl;
	        l = xl*l+((m&0x3fff)<<14)+w[j]+c;
	        c = (l>>28)+(m>>14)+xh*h;
	        w[j++] = l&0xfffffff;
	      }
	      return c;
	    }
	    var inBrowser = typeof navigator !== "undefined";
	    if(inBrowser && j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
	      BigInteger.prototype.am = am2;
	      dbits = 30;
	    }
	    else if(inBrowser && j_lm && (navigator.appName != "Netscape")) {
	      BigInteger.prototype.am = am1;
	      dbits = 26;
	    }
	    else { // Mozilla/Netscape seems to prefer am3
	      BigInteger.prototype.am = am3;
	      dbits = 28;
	    }
	
	    BigInteger.prototype.DB = dbits;
	    BigInteger.prototype.DM = ((1<<dbits)-1);
	    BigInteger.prototype.DV = (1<<dbits);
	
	    var BI_FP = 52;
	    BigInteger.prototype.FV = Math.pow(2,BI_FP);
	    BigInteger.prototype.F1 = BI_FP-dbits;
	    BigInteger.prototype.F2 = 2*dbits-BI_FP;
	
	    // Digit conversions
	    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
	    var BI_RC = new Array();
	    var rr,vv;
	    rr = "0".charCodeAt(0);
	    for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
	    rr = "a".charCodeAt(0);
	    for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
	    rr = "A".charCodeAt(0);
	    for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
	
	    function int2char(n) { return BI_RM.charAt(n); }
	    function intAt(s,i) {
	      var c = BI_RC[s.charCodeAt(i)];
	      return (c==null)?-1:c;
	    }
	
	    // (protected) copy this to r
	    function bnpCopyTo(r) {
	      for(var i = this.t-1; i >= 0; --i) r[i] = this[i];
	      r.t = this.t;
	      r.s = this.s;
	    }
	
	    // (protected) set from integer value x, -DV <= x < DV
	    function bnpFromInt(x) {
	      this.t = 1;
	      this.s = (x<0)?-1:0;
	      if(x > 0) this[0] = x;
	      else if(x < -1) this[0] = x+this.DV;
	      else this.t = 0;
	    }
	
	    // return bigint initialized to value
	    function nbv(i) { var r = nbi(); r.fromInt(i); return r; }
	
	    // (protected) set from string and radix
	    function bnpFromString(s,b) {
	      var k;
	      if(b == 16) k = 4;
	      else if(b == 8) k = 3;
	      else if(b == 256) k = 8; // byte array
	      else if(b == 2) k = 1;
	      else if(b == 32) k = 5;
	      else if(b == 4) k = 2;
	      else { this.fromRadix(s,b); return; }
	      this.t = 0;
	      this.s = 0;
	      var i = s.length, mi = false, sh = 0;
	      while(--i >= 0) {
	        var x = (k==8)?s[i]&0xff:intAt(s,i);
	        if(x < 0) {
	          if(s.charAt(i) == "-") mi = true;
	          continue;
	        }
	        mi = false;
	        if(sh == 0)
	          this[this.t++] = x;
	        else if(sh+k > this.DB) {
	          this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;
	          this[this.t++] = (x>>(this.DB-sh));
	        }
	        else
	          this[this.t-1] |= x<<sh;
	        sh += k;
	        if(sh >= this.DB) sh -= this.DB;
	      }
	      if(k == 8 && (s[0]&0x80) != 0) {
	        this.s = -1;
	        if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;
	      }
	      this.clamp();
	      if(mi) BigInteger.ZERO.subTo(this,this);
	    }
	
	    // (protected) clamp off excess high words
	    function bnpClamp() {
	      var c = this.s&this.DM;
	      while(this.t > 0 && this[this.t-1] == c) --this.t;
	    }
	
	    // (public) return string representation in given radix
	    function bnToString(b) {
	      if(this.s < 0) return "-"+this.negate().toString(b);
	      var k;
	      if(b == 16) k = 4;
	      else if(b == 8) k = 3;
	      else if(b == 2) k = 1;
	      else if(b == 32) k = 5;
	      else if(b == 4) k = 2;
	      else return this.toRadix(b);
	      var km = (1<<k)-1, d, m = false, r = "", i = this.t;
	      var p = this.DB-(i*this.DB)%k;
	      if(i-- > 0) {
	        if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }
	        while(i >= 0) {
	          if(p < k) {
	            d = (this[i]&((1<<p)-1))<<(k-p);
	            d |= this[--i]>>(p+=this.DB-k);
	          }
	          else {
	            d = (this[i]>>(p-=k))&km;
	            if(p <= 0) { p += this.DB; --i; }
	          }
	          if(d > 0) m = true;
	          if(m) r += int2char(d);
	        }
	      }
	      return m?r:"0";
	    }
	
	    // (public) -this
	    function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }
	
	    // (public) |this|
	    function bnAbs() { return (this.s<0)?this.negate():this; }
	
	    // (public) return + if this > a, - if this < a, 0 if equal
	    function bnCompareTo(a) {
	      var r = this.s-a.s;
	      if(r != 0) return r;
	      var i = this.t;
	      r = i-a.t;
	      if(r != 0) return (this.s<0)?-r:r;
	      while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;
	      return 0;
	    }
	
	    // returns bit length of the integer x
	    function nbits(x) {
	      var r = 1, t;
	      if((t=x>>>16) != 0) { x = t; r += 16; }
	      if((t=x>>8) != 0) { x = t; r += 8; }
	      if((t=x>>4) != 0) { x = t; r += 4; }
	      if((t=x>>2) != 0) { x = t; r += 2; }
	      if((t=x>>1) != 0) { x = t; r += 1; }
	      return r;
	    }
	
	    // (public) return the number of bits in "this"
	    function bnBitLength() {
	      if(this.t <= 0) return 0;
	      return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));
	    }
	
	    // (protected) r = this << n*DB
	    function bnpDLShiftTo(n,r) {
	      var i;
	      for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];
	      for(i = n-1; i >= 0; --i) r[i] = 0;
	      r.t = this.t+n;
	      r.s = this.s;
	    }
	
	    // (protected) r = this >> n*DB
	    function bnpDRShiftTo(n,r) {
	      for(var i = n; i < this.t; ++i) r[i-n] = this[i];
	      r.t = Math.max(this.t-n,0);
	      r.s = this.s;
	    }
	
	    // (protected) r = this << n
	    function bnpLShiftTo(n,r) {
	      var bs = n%this.DB;
	      var cbs = this.DB-bs;
	      var bm = (1<<cbs)-1;
	      var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;
	      for(i = this.t-1; i >= 0; --i) {
	        r[i+ds+1] = (this[i]>>cbs)|c;
	        c = (this[i]&bm)<<bs;
	      }
	      for(i = ds-1; i >= 0; --i) r[i] = 0;
	      r[ds] = c;
	      r.t = this.t+ds+1;
	      r.s = this.s;
	      r.clamp();
	    }
	
	    // (protected) r = this >> n
	    function bnpRShiftTo(n,r) {
	      r.s = this.s;
	      var ds = Math.floor(n/this.DB);
	      if(ds >= this.t) { r.t = 0; return; }
	      var bs = n%this.DB;
	      var cbs = this.DB-bs;
	      var bm = (1<<bs)-1;
	      r[0] = this[ds]>>bs;
	      for(var i = ds+1; i < this.t; ++i) {
	        r[i-ds-1] |= (this[i]&bm)<<cbs;
	        r[i-ds] = this[i]>>bs;
	      }
	      if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;
	      r.t = this.t-ds;
	      r.clamp();
	    }
	
	    // (protected) r = this - a
	    function bnpSubTo(a,r) {
	      var i = 0, c = 0, m = Math.min(a.t,this.t);
	      while(i < m) {
	        c += this[i]-a[i];
	        r[i++] = c&this.DM;
	        c >>= this.DB;
	      }
	      if(a.t < this.t) {
	        c -= a.s;
	        while(i < this.t) {
	          c += this[i];
	          r[i++] = c&this.DM;
	          c >>= this.DB;
	        }
	        c += this.s;
	      }
	      else {
	        c += this.s;
	        while(i < a.t) {
	          c -= a[i];
	          r[i++] = c&this.DM;
	          c >>= this.DB;
	        }
	        c -= a.s;
	      }
	      r.s = (c<0)?-1:0;
	      if(c < -1) r[i++] = this.DV+c;
	      else if(c > 0) r[i++] = c;
	      r.t = i;
	      r.clamp();
	    }
	
	    // (protected) r = this * a, r != this,a (HAC 14.12)
	    // "this" should be the larger one if appropriate.
	    function bnpMultiplyTo(a,r) {
	      var x = this.abs(), y = a.abs();
	      var i = x.t;
	      r.t = i+y.t;
	      while(--i >= 0) r[i] = 0;
	      for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);
	      r.s = 0;
	      r.clamp();
	      if(this.s != a.s) BigInteger.ZERO.subTo(r,r);
	    }
	
	    // (protected) r = this^2, r != this (HAC 14.16)
	    function bnpSquareTo(r) {
	      var x = this.abs();
	      var i = r.t = 2*x.t;
	      while(--i >= 0) r[i] = 0;
	      for(i = 0; i < x.t-1; ++i) {
	        var c = x.am(i,x[i],r,2*i,0,1);
	        if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {
	          r[i+x.t] -= x.DV;
	          r[i+x.t+1] = 1;
	        }
	      }
	      if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);
	      r.s = 0;
	      r.clamp();
	    }
	
	    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
	    // r != q, this != m.  q or r may be null.
	    function bnpDivRemTo(m,q,r) {
	      var pm = m.abs();
	      if(pm.t <= 0) return;
	      var pt = this.abs();
	      if(pt.t < pm.t) {
	        if(q != null) q.fromInt(0);
	        if(r != null) this.copyTo(r);
	        return;
	      }
	      if(r == null) r = nbi();
	      var y = nbi(), ts = this.s, ms = m.s;
	      var nsh = this.DB-nbits(pm[pm.t-1]);   // normalize modulus
	      if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }
	      else { pm.copyTo(y); pt.copyTo(r); }
	      var ys = y.t;
	      var y0 = y[ys-1];
	      if(y0 == 0) return;
	      var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);
	      var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;
	      var i = r.t, j = i-ys, t = (q==null)?nbi():q;
	      y.dlShiftTo(j,t);
	      if(r.compareTo(t) >= 0) {
	        r[r.t++] = 1;
	        r.subTo(t,r);
	      }
	      BigInteger.ONE.dlShiftTo(ys,t);
	      t.subTo(y,y);  // "negative" y so we can replace sub with am later
	      while(y.t < ys) y[y.t++] = 0;
	      while(--j >= 0) {
	        // Estimate quotient digit
	        var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);
	        if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {   // Try it out
	          y.dlShiftTo(j,t);
	          r.subTo(t,r);
	          while(r[i] < --qd) r.subTo(t,r);
	        }
	      }
	      if(q != null) {
	        r.drShiftTo(ys,q);
	        if(ts != ms) BigInteger.ZERO.subTo(q,q);
	      }
	      r.t = ys;
	      r.clamp();
	      if(nsh > 0) r.rShiftTo(nsh,r); // Denormalize remainder
	      if(ts < 0) BigInteger.ZERO.subTo(r,r);
	    }
	
	    // (public) this mod a
	    function bnMod(a) {
	      var r = nbi();
	      this.abs().divRemTo(a,null,r);
	      if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);
	      return r;
	    }
	
	    // Modular reduction using "classic" algorithm
	    function Classic(m) { this.m = m; }
	    function cConvert(x) {
	      if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
	      else return x;
	    }
	    function cRevert(x) { return x; }
	    function cReduce(x) { x.divRemTo(this.m,null,x); }
	    function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
	    function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }
	
	    Classic.prototype.convert = cConvert;
	    Classic.prototype.revert = cRevert;
	    Classic.prototype.reduce = cReduce;
	    Classic.prototype.mulTo = cMulTo;
	    Classic.prototype.sqrTo = cSqrTo;
	
	    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
	    // justification:
	    //         xy == 1 (mod m)
	    //         xy =  1+km
	    //   xy(2-xy) = (1+km)(1-km)
	    // x[y(2-xy)] = 1-k^2m^2
	    // x[y(2-xy)] == 1 (mod m^2)
	    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
	    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
	    // JS multiply "overflows" differently from C/C++, so care is needed here.
	    function bnpInvDigit() {
	      if(this.t < 1) return 0;
	      var x = this[0];
	      if((x&1) == 0) return 0;
	      var y = x&3;       // y == 1/x mod 2^2
	      y = (y*(2-(x&0xf)*y))&0xf; // y == 1/x mod 2^4
	      y = (y*(2-(x&0xff)*y))&0xff;   // y == 1/x mod 2^8
	      y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;    // y == 1/x mod 2^16
	      // last step - calculate inverse mod DV directly;
	      // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
	      y = (y*(2-x*y%this.DV))%this.DV;       // y == 1/x mod 2^dbits
	      // we really want the negative inverse, and -DV < y < DV
	      return (y>0)?this.DV-y:-y;
	    }
	
	    // Montgomery reduction
	    function Montgomery(m) {
	      this.m = m;
	      this.mp = m.invDigit();
	      this.mpl = this.mp&0x7fff;
	      this.mph = this.mp>>15;
	      this.um = (1<<(m.DB-15))-1;
	      this.mt2 = 2*m.t;
	    }
	
	    // xR mod m
	    function montConvert(x) {
	      var r = nbi();
	      x.abs().dlShiftTo(this.m.t,r);
	      r.divRemTo(this.m,null,r);
	      if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);
	      return r;
	    }
	
	    // x/R mod m
	    function montRevert(x) {
	      var r = nbi();
	      x.copyTo(r);
	      this.reduce(r);
	      return r;
	    }
	
	    // x = x/R mod m (HAC 14.32)
	    function montReduce(x) {
	      while(x.t <= this.mt2) // pad x so am has enough room later
	        x[x.t++] = 0;
	      for(var i = 0; i < this.m.t; ++i) {
	        // faster way of calculating u0 = x[i]*mp mod DV
	        var j = x[i]&0x7fff;
	        var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;
	        // use am to combine the multiply-shift-add into one call
	        j = i+this.m.t;
	        x[j] += this.m.am(0,u0,x,i,0,this.m.t);
	        // propagate carry
	        while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }
	      }
	      x.clamp();
	      x.drShiftTo(this.m.t,x);
	      if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
	    }
	
	    // r = "x^2/R mod m"; x != r
	    function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }
	
	    // r = "xy/R mod m"; x,y != r
	    function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
	
	    Montgomery.prototype.convert = montConvert;
	    Montgomery.prototype.revert = montRevert;
	    Montgomery.prototype.reduce = montReduce;
	    Montgomery.prototype.mulTo = montMulTo;
	    Montgomery.prototype.sqrTo = montSqrTo;
	
	    // (protected) true iff this is even
	    function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }
	
	    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
	    function bnpExp(e,z) {
	      if(e > 0xffffffff || e < 1) return BigInteger.ONE;
	      var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;
	      g.copyTo(r);
	      while(--i >= 0) {
	        z.sqrTo(r,r2);
	        if((e&(1<<i)) > 0) z.mulTo(r2,g,r);
	        else { var t = r; r = r2; r2 = t; }
	      }
	      return z.revert(r);
	    }
	
	    // (public) this^e % m, 0 <= e < 2^32
	    function bnModPowInt(e,m) {
	      var z;
	      if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);
	      return this.exp(e,z);
	    }
	
	    // protected
	    BigInteger.prototype.copyTo = bnpCopyTo;
	    BigInteger.prototype.fromInt = bnpFromInt;
	    BigInteger.prototype.fromString = bnpFromString;
	    BigInteger.prototype.clamp = bnpClamp;
	    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
	    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
	    BigInteger.prototype.lShiftTo = bnpLShiftTo;
	    BigInteger.prototype.rShiftTo = bnpRShiftTo;
	    BigInteger.prototype.subTo = bnpSubTo;
	    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
	    BigInteger.prototype.squareTo = bnpSquareTo;
	    BigInteger.prototype.divRemTo = bnpDivRemTo;
	    BigInteger.prototype.invDigit = bnpInvDigit;
	    BigInteger.prototype.isEven = bnpIsEven;
	    BigInteger.prototype.exp = bnpExp;
	
	    // public
	    BigInteger.prototype.toString = bnToString;
	    BigInteger.prototype.negate = bnNegate;
	    BigInteger.prototype.abs = bnAbs;
	    BigInteger.prototype.compareTo = bnCompareTo;
	    BigInteger.prototype.bitLength = bnBitLength;
	    BigInteger.prototype.mod = bnMod;
	    BigInteger.prototype.modPowInt = bnModPowInt;
	
	    // "constants"
	    BigInteger.ZERO = nbv(0);
	    BigInteger.ONE = nbv(1);
	
	    // Copyright (c) 2005-2009  Tom Wu
	    // All Rights Reserved.
	    // See "LICENSE" for details.
	
	    // Extended JavaScript BN functions, required for RSA private ops.
	
	    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
	    // Version 1.2: square() API, isProbablePrime fix
	
	    // (public)
	    function bnClone() { var r = nbi(); this.copyTo(r); return r; }
	
	    // (public) return value as integer
	    function bnIntValue() {
	      if(this.s < 0) {
	        if(this.t == 1) return this[0]-this.DV;
	        else if(this.t == 0) return -1;
	      }
	      else if(this.t == 1) return this[0];
	      else if(this.t == 0) return 0;
	      // assumes 16 < DB < 32
	      return ((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];
	    }
	
	    // (public) return value as byte
	    function bnByteValue() { return (this.t==0)?this.s:(this[0]<<24)>>24; }
	
	    // (public) return value as short (assumes DB>=16)
	    function bnShortValue() { return (this.t==0)?this.s:(this[0]<<16)>>16; }
	
	    // (protected) return x s.t. r^x < DV
	    function bnpChunkSize(r) { return Math.floor(Math.LN2*this.DB/Math.log(r)); }
	
	    // (public) 0 if this == 0, 1 if this > 0
	    function bnSigNum() {
	      if(this.s < 0) return -1;
	      else if(this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;
	      else return 1;
	    }
	
	    // (protected) convert to radix string
	    function bnpToRadix(b) {
	      if(b == null) b = 10;
	      if(this.signum() == 0 || b < 2 || b > 36) return "0";
	      var cs = this.chunkSize(b);
	      var a = Math.pow(b,cs);
	      var d = nbv(a), y = nbi(), z = nbi(), r = "";
	      this.divRemTo(d,y,z);
	      while(y.signum() > 0) {
	        r = (a+z.intValue()).toString(b).substr(1) + r;
	        y.divRemTo(d,y,z);
	      }
	      return z.intValue().toString(b) + r;
	    }
	
	    // (protected) convert from radix string
	    function bnpFromRadix(s,b) {
	      this.fromInt(0);
	      if(b == null) b = 10;
	      var cs = this.chunkSize(b);
	      var d = Math.pow(b,cs), mi = false, j = 0, w = 0;
	      for(var i = 0; i < s.length; ++i) {
	        var x = intAt(s,i);
	        if(x < 0) {
	          if(s.charAt(i) == "-" && this.signum() == 0) mi = true;
	          continue;
	        }
	        w = b*w+x;
	        if(++j >= cs) {
	          this.dMultiply(d);
	          this.dAddOffset(w,0);
	          j = 0;
	          w = 0;
	        }
	      }
	      if(j > 0) {
	        this.dMultiply(Math.pow(b,j));
	        this.dAddOffset(w,0);
	      }
	      if(mi) BigInteger.ZERO.subTo(this,this);
	    }
	
	    // (protected) alternate constructor
	    function bnpFromNumber(a,b,c) {
	      if("number" == typeof b) {
	        // new BigInteger(int,int,RNG)
	        if(a < 2) this.fromInt(1);
	        else {
	          this.fromNumber(a,c);
	          if(!this.testBit(a-1))	// force MSB set
	            this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);
	          if(this.isEven()) this.dAddOffset(1,0); // force odd
	          while(!this.isProbablePrime(b)) {
	            this.dAddOffset(2,0);
	            if(this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a-1),this);
	          }
	        }
	      }
	      else {
	        // new BigInteger(int,RNG)
	        var x = new Array(), t = a&7;
	        x.length = (a>>3)+1;
	        b.nextBytes(x);
	        if(t > 0) x[0] &= ((1<<t)-1); else x[0] = 0;
	        this.fromString(x,256);
	      }
	    }
	
	    // (public) convert to bigendian byte array
	    function bnToByteArray() {
	      var i = this.t, r = new Array();
	      r[0] = this.s;
	      var p = this.DB-(i*this.DB)%8, d, k = 0;
	      if(i-- > 0) {
	        if(p < this.DB && (d = this[i]>>p) != (this.s&this.DM)>>p)
	          r[k++] = d|(this.s<<(this.DB-p));
	        while(i >= 0) {
	          if(p < 8) {
	            d = (this[i]&((1<<p)-1))<<(8-p);
	            d |= this[--i]>>(p+=this.DB-8);
	          }
	          else {
	            d = (this[i]>>(p-=8))&0xff;
	            if(p <= 0) { p += this.DB; --i; }
	          }
	          if((d&0x80) != 0) d |= -256;
	          if(k == 0 && (this.s&0x80) != (d&0x80)) ++k;
	          if(k > 0 || d != this.s) r[k++] = d;
	        }
	      }
	      return r;
	    }
	
	    function bnEquals(a) { return(this.compareTo(a)==0); }
	    function bnMin(a) { return(this.compareTo(a)<0)?this:a; }
	    function bnMax(a) { return(this.compareTo(a)>0)?this:a; }
	
	    // (protected) r = this op a (bitwise)
	    function bnpBitwiseTo(a,op,r) {
	      var i, f, m = Math.min(a.t,this.t);
	      for(i = 0; i < m; ++i) r[i] = op(this[i],a[i]);
	      if(a.t < this.t) {
	        f = a.s&this.DM;
	        for(i = m; i < this.t; ++i) r[i] = op(this[i],f);
	        r.t = this.t;
	      }
	      else {
	        f = this.s&this.DM;
	        for(i = m; i < a.t; ++i) r[i] = op(f,a[i]);
	        r.t = a.t;
	      }
	      r.s = op(this.s,a.s);
	      r.clamp();
	    }
	
	    // (public) this & a
	    function op_and(x,y) { return x&y; }
	    function bnAnd(a) { var r = nbi(); this.bitwiseTo(a,op_and,r); return r; }
	
	    // (public) this | a
	    function op_or(x,y) { return x|y; }
	    function bnOr(a) { var r = nbi(); this.bitwiseTo(a,op_or,r); return r; }
	
	    // (public) this ^ a
	    function op_xor(x,y) { return x^y; }
	    function bnXor(a) { var r = nbi(); this.bitwiseTo(a,op_xor,r); return r; }
	
	    // (public) this & ~a
	    function op_andnot(x,y) { return x&~y; }
	    function bnAndNot(a) { var r = nbi(); this.bitwiseTo(a,op_andnot,r); return r; }
	
	    // (public) ~this
	    function bnNot() {
	      var r = nbi();
	      for(var i = 0; i < this.t; ++i) r[i] = this.DM&~this[i];
	      r.t = this.t;
	      r.s = ~this.s;
	      return r;
	    }
	
	    // (public) this << n
	    function bnShiftLeft(n) {
	      var r = nbi();
	      if(n < 0) this.rShiftTo(-n,r); else this.lShiftTo(n,r);
	      return r;
	    }
	
	    // (public) this >> n
	    function bnShiftRight(n) {
	      var r = nbi();
	      if(n < 0) this.lShiftTo(-n,r); else this.rShiftTo(n,r);
	      return r;
	    }
	
	    // return index of lowest 1-bit in x, x < 2^31
	    function lbit(x) {
	      if(x == 0) return -1;
	      var r = 0;
	      if((x&0xffff) == 0) { x >>= 16; r += 16; }
	      if((x&0xff) == 0) { x >>= 8; r += 8; }
	      if((x&0xf) == 0) { x >>= 4; r += 4; }
	      if((x&3) == 0) { x >>= 2; r += 2; }
	      if((x&1) == 0) ++r;
	      return r;
	    }
	
	    // (public) returns index of lowest 1-bit (or -1 if none)
	    function bnGetLowestSetBit() {
	      for(var i = 0; i < this.t; ++i)
	        if(this[i] != 0) return i*this.DB+lbit(this[i]);
	      if(this.s < 0) return this.t*this.DB;
	      return -1;
	    }
	
	    // return number of 1 bits in x
	    function cbit(x) {
	      var r = 0;
	      while(x != 0) { x &= x-1; ++r; }
	      return r;
	    }
	
	    // (public) return number of set bits
	    function bnBitCount() {
	      var r = 0, x = this.s&this.DM;
	      for(var i = 0; i < this.t; ++i) r += cbit(this[i]^x);
	      return r;
	    }
	
	    // (public) true iff nth bit is set
	    function bnTestBit(n) {
	      var j = Math.floor(n/this.DB);
	      if(j >= this.t) return(this.s!=0);
	      return((this[j]&(1<<(n%this.DB)))!=0);
	    }
	
	    // (protected) this op (1<<n)
	    function bnpChangeBit(n,op) {
	      var r = BigInteger.ONE.shiftLeft(n);
	      this.bitwiseTo(r,op,r);
	      return r;
	    }
	
	    // (public) this | (1<<n)
	    function bnSetBit(n) { return this.changeBit(n,op_or); }
	
	    // (public) this & ~(1<<n)
	    function bnClearBit(n) { return this.changeBit(n,op_andnot); }
	
	    // (public) this ^ (1<<n)
	    function bnFlipBit(n) { return this.changeBit(n,op_xor); }
	
	    // (protected) r = this + a
	    function bnpAddTo(a,r) {
	      var i = 0, c = 0, m = Math.min(a.t,this.t);
	      while(i < m) {
	        c += this[i]+a[i];
	        r[i++] = c&this.DM;
	        c >>= this.DB;
	      }
	      if(a.t < this.t) {
	        c += a.s;
	        while(i < this.t) {
	          c += this[i];
	          r[i++] = c&this.DM;
	          c >>= this.DB;
	        }
	        c += this.s;
	      }
	      else {
	        c += this.s;
	        while(i < a.t) {
	          c += a[i];
	          r[i++] = c&this.DM;
	          c >>= this.DB;
	        }
	        c += a.s;
	      }
	      r.s = (c<0)?-1:0;
	      if(c > 0) r[i++] = c;
	      else if(c < -1) r[i++] = this.DV+c;
	      r.t = i;
	      r.clamp();
	    }
	
	    // (public) this + a
	    function bnAdd(a) { var r = nbi(); this.addTo(a,r); return r; }
	
	    // (public) this - a
	    function bnSubtract(a) { var r = nbi(); this.subTo(a,r); return r; }
	
	    // (public) this * a
	    function bnMultiply(a) { var r = nbi(); this.multiplyTo(a,r); return r; }
	
	    // (public) this^2
	    function bnSquare() { var r = nbi(); this.squareTo(r); return r; }
	
	    // (public) this / a
	    function bnDivide(a) { var r = nbi(); this.divRemTo(a,r,null); return r; }
	
	    // (public) this % a
	    function bnRemainder(a) { var r = nbi(); this.divRemTo(a,null,r); return r; }
	
	    // (public) [this/a,this%a]
	    function bnDivideAndRemainder(a) {
	      var q = nbi(), r = nbi();
	      this.divRemTo(a,q,r);
	      return new Array(q,r);
	    }
	
	    // (protected) this *= n, this >= 0, 1 < n < DV
	    function bnpDMultiply(n) {
	      this[this.t] = this.am(0,n-1,this,0,0,this.t);
	      ++this.t;
	      this.clamp();
	    }
	
	    // (protected) this += n << w words, this >= 0
	    function bnpDAddOffset(n,w) {
	      if(n == 0) return;
	      while(this.t <= w) this[this.t++] = 0;
	      this[w] += n;
	      while(this[w] >= this.DV) {
	        this[w] -= this.DV;
	        if(++w >= this.t) this[this.t++] = 0;
	        ++this[w];
	      }
	    }
	
	    // A "null" reducer
	    function NullExp() {}
	    function nNop(x) { return x; }
	    function nMulTo(x,y,r) { x.multiplyTo(y,r); }
	    function nSqrTo(x,r) { x.squareTo(r); }
	
	    NullExp.prototype.convert = nNop;
	    NullExp.prototype.revert = nNop;
	    NullExp.prototype.mulTo = nMulTo;
	    NullExp.prototype.sqrTo = nSqrTo;
	
	    // (public) this^e
	    function bnPow(e) { return this.exp(e,new NullExp()); }
	
	    // (protected) r = lower n words of "this * a", a.t <= n
	    // "this" should be the larger one if appropriate.
	    function bnpMultiplyLowerTo(a,n,r) {
	      var i = Math.min(this.t+a.t,n);
	      r.s = 0; // assumes a,this >= 0
	      r.t = i;
	      while(i > 0) r[--i] = 0;
	      var j;
	      for(j = r.t-this.t; i < j; ++i) r[i+this.t] = this.am(0,a[i],r,i,0,this.t);
	      for(j = Math.min(a.t,n); i < j; ++i) this.am(0,a[i],r,i,0,n-i);
	      r.clamp();
	    }
	
	    // (protected) r = "this * a" without lower n words, n > 0
	    // "this" should be the larger one if appropriate.
	    function bnpMultiplyUpperTo(a,n,r) {
	      --n;
	      var i = r.t = this.t+a.t-n;
	      r.s = 0; // assumes a,this >= 0
	      while(--i >= 0) r[i] = 0;
	      for(i = Math.max(n-this.t,0); i < a.t; ++i)
	        r[this.t+i-n] = this.am(n-i,a[i],r,0,0,this.t+i-n);
	      r.clamp();
	      r.drShiftTo(1,r);
	    }
	
	    // Barrett modular reduction
	    function Barrett(m) {
	      // setup Barrett
	      this.r2 = nbi();
	      this.q3 = nbi();
	      BigInteger.ONE.dlShiftTo(2*m.t,this.r2);
	      this.mu = this.r2.divide(m);
	      this.m = m;
	    }
	
	    function barrettConvert(x) {
	      if(x.s < 0 || x.t > 2*this.m.t) return x.mod(this.m);
	      else if(x.compareTo(this.m) < 0) return x;
	      else { var r = nbi(); x.copyTo(r); this.reduce(r); return r; }
	    }
	
	    function barrettRevert(x) { return x; }
	
	    // x = x mod m (HAC 14.42)
	    function barrettReduce(x) {
	      x.drShiftTo(this.m.t-1,this.r2);
	      if(x.t > this.m.t+1) { x.t = this.m.t+1; x.clamp(); }
	      this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);
	      this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);
	      while(x.compareTo(this.r2) < 0) x.dAddOffset(1,this.m.t+1);
	      x.subTo(this.r2,x);
	      while(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
	    }
	
	    // r = x^2 mod m; x != r
	    function barrettSqrTo(x,r) { x.squareTo(r); this.reduce(r); }
	
	    // r = x*y mod m; x,y != r
	    function barrettMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
	
	    Barrett.prototype.convert = barrettConvert;
	    Barrett.prototype.revert = barrettRevert;
	    Barrett.prototype.reduce = barrettReduce;
	    Barrett.prototype.mulTo = barrettMulTo;
	    Barrett.prototype.sqrTo = barrettSqrTo;
	
	    // (public) this^e % m (HAC 14.85)
	    function bnModPow(e,m) {
	      var i = e.bitLength(), k, r = nbv(1), z;
	      if(i <= 0) return r;
	      else if(i < 18) k = 1;
	      else if(i < 48) k = 3;
	      else if(i < 144) k = 4;
	      else if(i < 768) k = 5;
	      else k = 6;
	      if(i < 8)
	        z = new Classic(m);
	      else if(m.isEven())
	        z = new Barrett(m);
	      else
	        z = new Montgomery(m);
	
	      // precomputation
	      var g = new Array(), n = 3, k1 = k-1, km = (1<<k)-1;
	      g[1] = z.convert(this);
	      if(k > 1) {
	        var g2 = nbi();
	        z.sqrTo(g[1],g2);
	        while(n <= km) {
	          g[n] = nbi();
	          z.mulTo(g2,g[n-2],g[n]);
	          n += 2;
	        }
	      }
	
	      var j = e.t-1, w, is1 = true, r2 = nbi(), t;
	      i = nbits(e[j])-1;
	      while(j >= 0) {
	        if(i >= k1) w = (e[j]>>(i-k1))&km;
	        else {
	          w = (e[j]&((1<<(i+1))-1))<<(k1-i);
	          if(j > 0) w |= e[j-1]>>(this.DB+i-k1);
	        }
	
	        n = k;
	        while((w&1) == 0) { w >>= 1; --n; }
	        if((i -= n) < 0) { i += this.DB; --j; }
	        if(is1) {	// ret == 1, don't bother squaring or multiplying it
	          g[w].copyTo(r);
	          is1 = false;
	        }
	        else {
	          while(n > 1) { z.sqrTo(r,r2); z.sqrTo(r2,r); n -= 2; }
	          if(n > 0) z.sqrTo(r,r2); else { t = r; r = r2; r2 = t; }
	          z.mulTo(r2,g[w],r);
	        }
	
	        while(j >= 0 && (e[j]&(1<<i)) == 0) {
	          z.sqrTo(r,r2); t = r; r = r2; r2 = t;
	          if(--i < 0) { i = this.DB-1; --j; }
	        }
	      }
	      return z.revert(r);
	    }
	
	    // (public) gcd(this,a) (HAC 14.54)
	    function bnGCD(a) {
	      var x = (this.s<0)?this.negate():this.clone();
	      var y = (a.s<0)?a.negate():a.clone();
	      if(x.compareTo(y) < 0) { var t = x; x = y; y = t; }
	      var i = x.getLowestSetBit(), g = y.getLowestSetBit();
	      if(g < 0) return x;
	      if(i < g) g = i;
	      if(g > 0) {
	        x.rShiftTo(g,x);
	        y.rShiftTo(g,y);
	      }
	      while(x.signum() > 0) {
	        if((i = x.getLowestSetBit()) > 0) x.rShiftTo(i,x);
	        if((i = y.getLowestSetBit()) > 0) y.rShiftTo(i,y);
	        if(x.compareTo(y) >= 0) {
	          x.subTo(y,x);
	          x.rShiftTo(1,x);
	        }
	        else {
	          y.subTo(x,y);
	          y.rShiftTo(1,y);
	        }
	      }
	      if(g > 0) y.lShiftTo(g,y);
	      return y;
	    }
	
	    // (protected) this % n, n < 2^26
	    function bnpModInt(n) {
	      if(n <= 0) return 0;
	      var d = this.DV%n, r = (this.s<0)?n-1:0;
	      if(this.t > 0)
	        if(d == 0) r = this[0]%n;
	        else for(var i = this.t-1; i >= 0; --i) r = (d*r+this[i])%n;
	      return r;
	    }
	
	    // (public) 1/this % m (HAC 14.61)
	    function bnModInverse(m) {
	      var ac = m.isEven();
	      if((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;
	      var u = m.clone(), v = this.clone();
	      var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
	      while(u.signum() != 0) {
	        while(u.isEven()) {
	          u.rShiftTo(1,u);
	          if(ac) {
	            if(!a.isEven() || !b.isEven()) { a.addTo(this,a); b.subTo(m,b); }
	            a.rShiftTo(1,a);
	          }
	          else if(!b.isEven()) b.subTo(m,b);
	          b.rShiftTo(1,b);
	        }
	        while(v.isEven()) {
	          v.rShiftTo(1,v);
	          if(ac) {
	            if(!c.isEven() || !d.isEven()) { c.addTo(this,c); d.subTo(m,d); }
	            c.rShiftTo(1,c);
	          }
	          else if(!d.isEven()) d.subTo(m,d);
	          d.rShiftTo(1,d);
	        }
	        if(u.compareTo(v) >= 0) {
	          u.subTo(v,u);
	          if(ac) a.subTo(c,a);
	          b.subTo(d,b);
	        }
	        else {
	          v.subTo(u,v);
	          if(ac) c.subTo(a,c);
	          d.subTo(b,d);
	        }
	      }
	      if(v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
	      if(d.compareTo(m) >= 0) return d.subtract(m);
	      if(d.signum() < 0) d.addTo(m,d); else return d;
	      if(d.signum() < 0) return d.add(m); else return d;
	    }
	
	    var lowprimes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];
	    var lplim = (1<<26)/lowprimes[lowprimes.length-1];
	
	    // (public) test primality with certainty >= 1-.5^t
	    function bnIsProbablePrime(t) {
	      var i, x = this.abs();
	      if(x.t == 1 && x[0] <= lowprimes[lowprimes.length-1]) {
	        for(i = 0; i < lowprimes.length; ++i)
	          if(x[0] == lowprimes[i]) return true;
	        return false;
	      }
	      if(x.isEven()) return false;
	      i = 1;
	      while(i < lowprimes.length) {
	        var m = lowprimes[i], j = i+1;
	        while(j < lowprimes.length && m < lplim) m *= lowprimes[j++];
	        m = x.modInt(m);
	        while(i < j) if(m%lowprimes[i++] == 0) return false;
	      }
	      return x.millerRabin(t);
	    }
	
	    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
	    function bnpMillerRabin(t) {
	      var n1 = this.subtract(BigInteger.ONE);
	      var k = n1.getLowestSetBit();
	      if(k <= 0) return false;
	      var r = n1.shiftRight(k);
	      t = (t+1)>>1;
	      if(t > lowprimes.length) t = lowprimes.length;
	      var a = nbi();
	      for(var i = 0; i < t; ++i) {
	        //Pick bases at random, instead of starting at 2
	        a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);
	        var y = a.modPow(r,this);
	        if(y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
	          var j = 1;
	          while(j++ < k && y.compareTo(n1) != 0) {
	            y = y.modPowInt(2,this);
	            if(y.compareTo(BigInteger.ONE) == 0) return false;
	          }
	          if(y.compareTo(n1) != 0) return false;
	        }
	      }
	      return true;
	    }
	
	    // protected
	    BigInteger.prototype.chunkSize = bnpChunkSize;
	    BigInteger.prototype.toRadix = bnpToRadix;
	    BigInteger.prototype.fromRadix = bnpFromRadix;
	    BigInteger.prototype.fromNumber = bnpFromNumber;
	    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
	    BigInteger.prototype.changeBit = bnpChangeBit;
	    BigInteger.prototype.addTo = bnpAddTo;
	    BigInteger.prototype.dMultiply = bnpDMultiply;
	    BigInteger.prototype.dAddOffset = bnpDAddOffset;
	    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
	    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
	    BigInteger.prototype.modInt = bnpModInt;
	    BigInteger.prototype.millerRabin = bnpMillerRabin;
	
	    // public
	    BigInteger.prototype.clone = bnClone;
	    BigInteger.prototype.intValue = bnIntValue;
	    BigInteger.prototype.byteValue = bnByteValue;
	    BigInteger.prototype.shortValue = bnShortValue;
	    BigInteger.prototype.signum = bnSigNum;
	    BigInteger.prototype.toByteArray = bnToByteArray;
	    BigInteger.prototype.equals = bnEquals;
	    BigInteger.prototype.min = bnMin;
	    BigInteger.prototype.max = bnMax;
	    BigInteger.prototype.and = bnAnd;
	    BigInteger.prototype.or = bnOr;
	    BigInteger.prototype.xor = bnXor;
	    BigInteger.prototype.andNot = bnAndNot;
	    BigInteger.prototype.not = bnNot;
	    BigInteger.prototype.shiftLeft = bnShiftLeft;
	    BigInteger.prototype.shiftRight = bnShiftRight;
	    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
	    BigInteger.prototype.bitCount = bnBitCount;
	    BigInteger.prototype.testBit = bnTestBit;
	    BigInteger.prototype.setBit = bnSetBit;
	    BigInteger.prototype.clearBit = bnClearBit;
	    BigInteger.prototype.flipBit = bnFlipBit;
	    BigInteger.prototype.add = bnAdd;
	    BigInteger.prototype.subtract = bnSubtract;
	    BigInteger.prototype.multiply = bnMultiply;
	    BigInteger.prototype.divide = bnDivide;
	    BigInteger.prototype.remainder = bnRemainder;
	    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
	    BigInteger.prototype.modPow = bnModPow;
	    BigInteger.prototype.modInverse = bnModInverse;
	    BigInteger.prototype.pow = bnPow;
	    BigInteger.prototype.gcd = bnGCD;
	    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
	
	    // JSBN-specific extension
	    BigInteger.prototype.square = bnSquare;
	
	    // Expose the Barrett function
	    BigInteger.prototype.Barrett = Barrett
	
	    // BigInteger interfaces not implemented in jsbn:
	
	    // BigInteger(int signum, byte[] magnitude)
	    // double doubleValue()
	    // float floatValue()
	    // int hashCode()
	    // long longValue()
	    // static BigInteger valueOf(long val)
	
		// Random number generator - requires a PRNG backend, e.g. prng4.js
	
		// For best results, put code like
		// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
		// in your main HTML document.
	
		var rng_state;
		var rng_pool;
		var rng_pptr;
	
		// Mix in a 32-bit integer into the pool
		function rng_seed_int(x) {
		  rng_pool[rng_pptr++] ^= x & 255;
		  rng_pool[rng_pptr++] ^= (x >> 8) & 255;
		  rng_pool[rng_pptr++] ^= (x >> 16) & 255;
		  rng_pool[rng_pptr++] ^= (x >> 24) & 255;
		  if(rng_pptr >= rng_psize) rng_pptr -= rng_psize;
		}
	
		// Mix in the current time (w/milliseconds) into the pool
		function rng_seed_time() {
		  rng_seed_int(new Date().getTime());
		}
	
		// Initialize the pool with junk if needed.
		if(rng_pool == null) {
		  rng_pool = new Array();
		  rng_pptr = 0;
		  var t;
		  if(typeof window !== "undefined" && window.crypto) {
			if (window.crypto.getRandomValues) {
			  // Use webcrypto if available
			  var ua = new Uint8Array(32);
			  window.crypto.getRandomValues(ua);
			  for(t = 0; t < 32; ++t)
				rng_pool[rng_pptr++] = ua[t];
			}
			else if(navigator.appName == "Netscape" && navigator.appVersion < "5") {
			  // Extract entropy (256 bits) from NS4 RNG if available
			  var z = window.crypto.random(32);
			  for(t = 0; t < z.length; ++t)
				rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
			}
		  }
		  while(rng_pptr < rng_psize) {  // extract some randomness from Math.random()
			t = Math.floor(65536 * Math.random());
			rng_pool[rng_pptr++] = t >>> 8;
			rng_pool[rng_pptr++] = t & 255;
		  }
		  rng_pptr = 0;
		  rng_seed_time();
		  //rng_seed_int(window.screenX);
		  //rng_seed_int(window.screenY);
		}
	
		function rng_get_byte() {
		  if(rng_state == null) {
			rng_seed_time();
			rng_state = prng_newstate();
			rng_state.init(rng_pool);
			for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
			  rng_pool[rng_pptr] = 0;
			rng_pptr = 0;
			//rng_pool = null;
		  }
		  // TODO: allow reseeding after first request
		  return rng_state.next();
		}
	
		function rng_get_bytes(ba) {
		  var i;
		  for(i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();
		}
	
		function SecureRandom() {}
	
		SecureRandom.prototype.nextBytes = rng_get_bytes;
	
		// prng4.js - uses Arcfour as a PRNG
	
		function Arcfour() {
		  this.i = 0;
		  this.j = 0;
		  this.S = new Array();
		}
	
		// Initialize arcfour context from key, an array of ints, each from [0..255]
		function ARC4init(key) {
		  var i, j, t;
		  for(i = 0; i < 256; ++i)
			this.S[i] = i;
		  j = 0;
		  for(i = 0; i < 256; ++i) {
			j = (j + this.S[i] + key[i % key.length]) & 255;
			t = this.S[i];
			this.S[i] = this.S[j];
			this.S[j] = t;
		  }
		  this.i = 0;
		  this.j = 0;
		}
	
		function ARC4next() {
		  var t;
		  this.i = (this.i + 1) & 255;
		  this.j = (this.j + this.S[this.i]) & 255;
		  t = this.S[this.i];
		  this.S[this.i] = this.S[this.j];
		  this.S[this.j] = t;
		  return this.S[(t + this.S[this.i]) & 255];
		}
	
		Arcfour.prototype.init = ARC4init;
		Arcfour.prototype.next = ARC4next;
	
		// Plug in your RNG constructor here
		function prng_newstate() {
		  return new Arcfour();
		}
	
		// Pool size must be a multiple of 4 and greater than 32.
		// An array of bytes the size of the pool will be passed to init()
		var rng_psize = 256;
	
	  BigInteger.SecureRandom = SecureRandom;
	  BigInteger.BigInteger = BigInteger;
	  if (true) {
	    exports = module.exports = BigInteger;
	  } else {
	    this.BigInteger = BigInteger;
	    this.SecureRandom = SecureRandom;
	  }
	
	}).call(this);


/***/ },
/* 2294 */
/***/ function(module, exports) {

	module.exports = [
		[
			"AF",
			"Afghanistan (‫افغانستان‬‎)"
		],
		[
			"AX",
			"Åland Islands"
		],
		[
			"AL",
			"Albania (Shqipëri)"
		],
		[
			"DZ",
			"Algeria (‫الجزائر‬‎)"
		],
		[
			"AS",
			"American Samoa (Amerika Sāmoa)"
		],
		[
			"AD",
			"Andorra"
		],
		[
			"AO",
			"Angola"
		],
		[
			"AI",
			"Anguilla"
		],
		[
			"AG",
			"Antigua and Barbuda"
		],
		[
			"AR",
			"Argentina"
		],
		[
			"AM",
			"Armenia (Հայաստան)"
		],
		[
			"AW",
			"Aruba"
		],
		[
			"AU",
			"Australia"
		],
		[
			"AT",
			"Austria (Österreich)"
		],
		[
			"AZ",
			"Azerbaijan (Azərbaycan)"
		],
		[
			"BS",
			"Bahamas"
		],
		[
			"BH",
			"Bahrain (‫البحرين‬‎)"
		],
		[
			"BD",
			"Bangladesh (বাংলাদেশ)"
		],
		[
			"BB",
			"Barbados"
		],
		[
			"BY",
			"Belarus (Беларусь)"
		],
		[
			"BE",
			"Belgium (België)"
		],
		[
			"BZ",
			"Belize"
		],
		[
			"BJ",
			"Benin (Bénin)"
		],
		[
			"BM",
			"Bermuda"
		],
		[
			"BT",
			"Bhutan (འབྲུག)"
		],
		[
			"BO",
			"Bolivia"
		],
		[
			"BA",
			"Bosnia and Herzegovina"
		],
		[
			"BW",
			"Botswana"
		],
		[
			"BR",
			"Brazil (Brasil)"
		],
		[
			"IO",
			"British Indian Ocean Territory"
		],
		[
			"VG",
			"British Virgin Islands"
		],
		[
			"BN",
			"Brunei (Negara Brunei Darussalam)"
		],
		[
			"BG",
			"Bulgaria (България)"
		],
		[
			"BF",
			"Burkina Faso"
		],
		[
			"BI",
			"Burundi (Uburundi)"
		],
		[
			"KH",
			"Cambodia (កម្ពុជា)"
		],
		[
			"CM",
			"Cameroon (Cameroun)"
		],
		[
			"CA",
			"Canada"
		],
		[
			"CV",
			"Cape Verde (Kabu Verdi)"
		],
		[
			"BQ",
			"Caribbean Netherlands"
		],
		[
			"KY",
			"Cayman Islands"
		],
		[
			"CF",
			"Central African Republic"
		],
		[
			"TD",
			"Chad (Tchad)"
		],
		[
			"CL",
			"Chile"
		],
		[
			"CN",
			"China (中国)"
		],
		[
			"CX",
			"Christmas Island"
		],
		[
			"CC",
			"Cocos (Keeling) Islands"
		],
		[
			"CO",
			"Colombia"
		],
		[
			"KM",
			"Comoros (‫جزر القمر‬‎)"
		],
		[
			"CD",
			"Congo (DRC) (Kongo)"
		],
		[
			"CG",
			"Congo (Republic) (Congo-Brazzaville)"
		],
		[
			"CK",
			"Cook Islands"
		],
		[
			"CR",
			"Costa Rica"
		],
		[
			"CI",
			"Côte d’Ivoire"
		],
		[
			"HR",
			"Croatia (Hrvatska)"
		],
		[
			"CU",
			"Cuba"
		],
		[
			"CW",
			"Curaçao"
		],
		[
			"CY",
			"Cyprus (Κύπρος)"
		],
		[
			"CZ",
			"Czech Republic (Česká republika)"
		],
		[
			"DK",
			"Denmark (Danmark)"
		],
		[
			"DJ",
			"Djibouti"
		],
		[
			"DM",
			"Dominica"
		],
		[
			"DO",
			"Dominican Republic"
		],
		[
			"EC",
			"Ecuador"
		],
		[
			"EG",
			"Egypt (‫مصر‬‎)"
		],
		[
			"SV",
			"El Salvador"
		],
		[
			"GQ",
			"Equatorial Guinea (Guinea Ecuatorial)"
		],
		[
			"ER",
			"Eritrea"
		],
		[
			"EE",
			"Estonia (Eesti)"
		],
		[
			"ET",
			"Ethiopia"
		],
		[
			"FK",
			"Falkland Islands (Islas Malvinas)"
		],
		[
			"FO",
			"Faroe Islands (Føroyar)"
		],
		[
			"FJ",
			"Fiji (Matanitu Tugalala o Viti)"
		],
		[
			"FI",
			"Finland (Suomi)"
		],
		[
			"FR",
			"France (République française)"
		],
		[
			"GF",
			"French Guiana (Guyane française)"
		],
		[
			"PF",
			"French Polynesia (Polynésie française)"
		],
		[
			"GA",
			"Gabon (République gabonaise)"
		],
		[
			"GM",
			"Gambia"
		],
		[
			"GE",
			"Georgia (საქართველო)"
		],
		[
			"DE",
			"Germany (Deutschland)"
		],
		[
			"GH",
			"Ghana (Gaana)"
		],
		[
			"GI",
			"Gibraltar"
		],
		[
			"GR",
			"Greece (Ελλάδα)"
		],
		[
			"GL",
			"Greenland (Kalaallit Nunaat)"
		],
		[
			"GD",
			"Grenada"
		],
		[
			"GP",
			"Guadeloupe"
		],
		[
			"GU",
			"Guam (Guåhån)"
		],
		[
			"GT",
			"Guatemala"
		],
		[
			"GG",
			"Guernsey"
		],
		[
			"GN",
			"Guinea (Guinée)"
		],
		[
			"GW",
			"Guinea-Bissau (Guiné Bissau)"
		],
		[
			"GY",
			"Guyana"
		],
		[
			"HT",
			"Haiti (République d'Haïti)"
		],
		[
			"HN",
			"Honduras"
		],
		[
			"HK",
			"Hong Kong (香港)"
		],
		[
			"HU",
			"Hungary (Magyarország)"
		],
		[
			"IS",
			"Iceland (Ísland)"
		],
		[
			"IN",
			"India (भारत)"
		],
		[
			"ID",
			"Indonesia"
		],
		[
			"IR",
			"Iran (‫ایران‬‎)"
		],
		[
			"IQ",
			"Iraq (‫العراق‬‎)"
		],
		[
			"IE",
			"Ireland"
		],
		[
			"IM",
			"Isle of Man"
		],
		[
			"IL",
			"Israel (‫ישראל‬‎)"
		],
		[
			"IT",
			"Italy (Italia)"
		],
		[
			"JM",
			"Jamaica"
		],
		[
			"JP",
			"Japan (日本)"
		],
		[
			"JE",
			"Jersey"
		],
		[
			"JO",
			"Jordan (‫الأردن‬‎)"
		],
		[
			"KZ",
			"Kazakhstan (Казахстан)"
		],
		[
			"KE",
			"Kenya"
		],
		[
			"KI",
			"Kiribati"
		],
		[
			"KW",
			"Kuwait (‫الكويت‬‎)"
		],
		[
			"KG",
			"Kyrgyzstan (Кыргызстан)"
		],
		[
			"LA",
			"Laos (ລາວ)"
		],
		[
			"LV",
			"Latvia (Latvija)"
		],
		[
			"LB",
			"Lebanon (‫لبنان‬‎)"
		],
		[
			"LS",
			"Lesotho"
		],
		[
			"LR",
			"Liberia"
		],
		[
			"LY",
			"Libya (‫ليبيا‬‎)"
		],
		[
			"LI",
			"Liechtenstein"
		],
		[
			"LT",
			"Lithuania (Lietuva)"
		],
		[
			"LU",
			"Luxembourg (Lëtzebuerg)"
		],
		[
			"MO",
			"Macau (澳門)"
		],
		[
			"MK",
			"Macedonia (FYROM) (Македонија)"
		],
		[
			"MG",
			"Madagascar (Madagasikara)"
		],
		[
			"MW",
			"Malawi (Malaŵi)"
		],
		[
			"MY",
			"Malaysia"
		],
		[
			"MV",
			"Maldives"
		],
		[
			"ML",
			"Mali"
		],
		[
			"MT",
			"Malta"
		],
		[
			"MH",
			"Marshall Islands"
		],
		[
			"MQ",
			"Martinique"
		],
		[
			"MR",
			"Mauritania (‫موريتانيا‬‎)"
		],
		[
			"MU",
			"Mauritius (Moris)"
		],
		[
			"YT",
			"Mayotte"
		],
		[
			"MX",
			"Mexico (México)"
		],
		[
			"FM",
			"Micronesia"
		],
		[
			"MD",
			"Moldova (Republica Moldova)"
		],
		[
			"MC",
			"Monaco"
		],
		[
			"MN",
			"Mongolia (Монгол)"
		],
		[
			"ME",
			"Montenegro (Crna Gora)"
		],
		[
			"MS",
			"Montserrat"
		],
		[
			"MA",
			"Morocco (‫المغرب‬‎)"
		],
		[
			"MZ",
			"Mozambique (Moçambique)"
		],
		[
			"MM",
			"Myanmar (Burma) (မြန်မာ)"
		],
		[
			"NA",
			"Namibia (Namibië)"
		],
		[
			"NR",
			"Nauru (Repubrikin Naoero)"
		],
		[
			"NP",
			"Nepal (नेपाल)"
		],
		[
			"NL",
			"Netherlands (Nederland)"
		],
		[
			"NC",
			"New Caledonia (Nouvelle-Calédonie)"
		],
		[
			"NZ",
			"New Zealand"
		],
		[
			"NI",
			"Nicaragua"
		],
		[
			"NE",
			"Niger (Nijar)"
		],
		[
			"NG",
			"Nigeria"
		],
		[
			"NU",
			"Niue (Niuē)"
		],
		[
			"NF",
			"Norfolk Island"
		],
		[
			"KP",
			"North Korea (조선 민주주의 인민 공화국)"
		],
		[
			"MP",
			"Northern Mariana Islands"
		],
		[
			"NO",
			"Norway (Norge)"
		],
		[
			"OM",
			"Oman (‫عُمان‬‎)"
		],
		[
			"PK",
			"Pakistan (‫پاکستان‬‎)"
		],
		[
			"PW",
			"Palau (Beluu er a Belau)"
		],
		[
			"PS",
			"Palestine (‫فلسطين‬‎)"
		],
		[
			"PA",
			"Panama (Panamá)"
		],
		[
			"PG",
			"Papua New Guinea"
		],
		[
			"PY",
			"Paraguay (Tetã Paraguái)"
		],
		[
			"PE",
			"Peru (Perú)"
		],
		[
			"PH",
			"Philippines (Republika ng Pilipinas)"
		],
		[
			"PL",
			"Poland (Polska)"
		],
		[
			"PT",
			"Portugal (República Portuguesa)"
		],
		[
			"PR",
			"Puerto Rico"
		],
		[
			"QA",
			"Qatar (‫قطر‬‎)"
		],
		[
			"RE",
			"Réunion (La Réunion)"
		],
		[
			"RO",
			"Romania (România)"
		],
		[
			"RU",
			"Russia (Россия)"
		],
		[
			"RW",
			"Rwanda"
		],
		[
			"BL",
			"Saint Barthélemy (Saint-Barthélemy)"
		],
		[
			"SH",
			"Saint Helena"
		],
		[
			"KN",
			"Saint Kitts and Nevis"
		],
		[
			"LC",
			"Saint Lucia"
		],
		[
			"MF",
			"Saint Martin (Saint-Martin)"
		],
		[
			"PM",
			"Saint Pierre and Miquelon"
		],
		[
			"VC",
			"Saint Vincent and the Grenadines"
		],
		[
			"WS",
			"Samoa (Sāmoa)"
		],
		[
			"SM",
			"San Marino"
		],
		[
			"ST",
			"São Tomé and Príncipe"
		],
		[
			"SA",
			"Saudi Arabia (‫المملكة العربية السعودية‬‎)"
		],
		[
			"SN",
			"Senegal (Sénégal)"
		],
		[
			"RS",
			"Serbia (Србија)"
		],
		[
			"SC",
			"Seychelles (Repiblik Sesel)"
		],
		[
			"SL",
			"Sierra Leone"
		],
		[
			"SG",
			"Singapore (Singapura) (新加坡共和国)"
		],
		[
			"SX",
			"Sint Maarten"
		],
		[
			"SK",
			"Slovakia (Slovensko)"
		],
		[
			"SI",
			"Slovenia (Slovenija)"
		],
		[
			"SB",
			"Solomon Islands"
		],
		[
			"SO",
			"Somalia (Soomaaliya)"
		],
		[
			"ZA",
			"South Africa"
		],
		[
			"KR",
			"South Korea (대한민국)"
		],
		[
			"SS",
			"South Sudan (‫جنوب السودان‬‎)"
		],
		[
			"ES",
			"Spain (España)"
		],
		[
			"LK",
			"Sri Lanka (ශ්‍රී ලංකාව)"
		],
		[
			"SD",
			"Sudan (‫السودان‬‎)"
		],
		[
			"SR",
			"Suriname"
		],
		[
			"SJ",
			"Svalbard and Jan Mayen"
		],
		[
			"SZ",
			"Swaziland (Umbuso weSwatini)"
		],
		[
			"SE",
			"Sweden (Sverige)"
		],
		[
			"CH",
			"Switzerland (Schweiz)"
		],
		[
			"SY",
			"Syria (‫سوريا‬‎)"
		],
		[
			"TW",
			"Taiwan (台灣)"
		],
		[
			"TJ",
			"Tajikistan (Ҷумҳурии Тоҷикистон)"
		],
		[
			"TZ",
			"Tanzania"
		],
		[
			"TH",
			"Thailand (ไทย)"
		],
		[
			"TL",
			"Timor-Leste (Timór-Leste)"
		],
		[
			"TG",
			"Togo (République togolaise)"
		],
		[
			"TK",
			"Tokelau"
		],
		[
			"TO",
			"Tonga"
		],
		[
			"TT",
			"Trinidad and Tobago"
		],
		[
			"TN",
			"Tunisia (‫تونس‬‎)"
		],
		[
			"TR",
			"Turkey (Türkiye)"
		],
		[
			"TM",
			"Turkmenistan (Türkmenistan)"
		],
		[
			"TC",
			"Turks and Caicos Islands"
		],
		[
			"TV",
			"Tuvalu"
		],
		[
			"VI",
			"U.S. Virgin Islands"
		],
		[
			"UG",
			"Uganda"
		],
		[
			"UA",
			"Ukraine (Україна)"
		],
		[
			"AE",
			"United Arab Emirates (‫الإمارات العربية المتحدة‬‎)"
		],
		[
			"GB",
			"United Kingdom"
		],
		[
			"US",
			"United States"
		],
		[
			"UY",
			"Uruguay"
		],
		[
			"UZ",
			"Uzbekistan (Oʻzbekiston)"
		],
		[
			"VU",
			"Vanuatu"
		],
		[
			"VA",
			"Vatican City (Città del Vaticano)"
		],
		[
			"VE",
			"Venezuela"
		],
		[
			"VN",
			"Vietnam (Việt Nam)"
		],
		[
			"WF",
			"Wallis and Futuna (Wallis-et-Futuna)"
		],
		[
			"EH",
			"Western Sahara (‫الصحراء الغربية‬‎)"
		],
		[
			"YE",
			"Yemen (‫اليمن‬‎)"
		],
		[
			"ZM",
			"Zambia"
		],
		[
			"ZW",
			"Zimbabwe"
		]
	];

/***/ },
/* 2295 */
/***/ function(module, exports) {

	module.exports = {
		"😂": 1,
		"❤": 3,
		"♥": 3,
		"😍": 3,
		"😭": -1,
		"😘": 3,
		"😊": 3,
		"👌": 2,
		"💕": 3,
		"👏": 2,
		"😁": 2,
		"☺": 3,
		"♡": 3,
		"👍": 2,
		"😩": -2,
		"🙏": 2,
		"✌": 2,
		"😏": 1,
		"😉": 2,
		"🙌": 2,
		"🙈": 2,
		"💪": 2,
		"😄": 2,
		"😒": -2,
		"💃": 3,
		"💖": 3,
		"😃": 2,
		"😔": -1,
		"🎉": 3,
		"😜": 2,
		"🌸": 3,
		"💜": 3,
		"💙": 3,
		"✨": 1,
		"💗": 3,
		"★": 1,
		"█": -1,
		"☀": 2,
		"😡": -1,
		"😎": 2,
		"💋": 3,
		"😋": 3,
		"🙊": 2,
		"😴": -1,
		"🎶": 2,
		"💞": 3,
		"😌": 2,
		"🔫": -1,
		"💛": 3,
		"💁": 1,
		"💚": 3,
		"♫": 1,
		"😞": -1,
		"😆": 2,
		"😝": 2,
		"😪": -1,
		"😫": -1,
		"👊": 1,
		"💀": -2,
		"😀": 2,
		"😚": 3,
		"😻": 3,
		"💘": 3,
		"☕": 1,
		"👋": 2,
		"🎊": 3,
		"🍕": 2,
		"❄": 2,
		"😕": -2,
		"💔": -1,
		"😤": -2,
		"😈": 1,
		"✈": 2,
		"🔝": 2,
		"😰": -1,
		"⚽": 3,
		"😑": -2,
		"👑": 3,
		"👉": 1,
		"🍃": 1,
		"🎁": 3,
		"😠": -2,
		"🐧": 2,
		"☆": 2,
		"🍀": 1,
		"🎈": 3,
		"🎅": 1,
		"😓": -1,
		"😣": -2,
		"😐": -2,
		"✊": 2,
		"😨": -1,
		"😖": -1,
		"💤": 1,
		"💓": 3,
		"👎": -1,
		"💦": 2,
		"✔": 1,
		"😷": -1,
		"🙋": 2,
		"🎄": 2,
		"💩": -1,
		"🎵": 2,
		"😛": 3,
		"👯": 2,
		"💎": 2,
		"🌿": 1,
		"🎂": 3,
		"🌟": 1,
		"🔮": 1,
		"👫": 1,
		"🏆": 3,
		"✖": 1,
		"☝": 1,
		"😙": 3,
		"⛄": 2,
		"👅": 2,
		"♪": 2,
		"🍂": 2,
		"💏": 1,
		"🌴": 2,
		"👈": 2,
		"🌹": 3,
		"🙆": 2,
		"👻": 1,
		"💰": 1,
		"🍻": 2,
		"🙅": -2,
		"🌞": 2,
		"🍁": 2,
		"⭐": 2,
		"▪": 1,
		"🎀": 3,
		"🐷": 1,
		"🙉": 1,
		"🌺": 2,
		"💅": 1,
		"🐶": 2,
		"🌚": 2,
		"👽": 1,
		"🎤": 2,
		"👭": 2,
		"🎧": 2,
		"👆": 1,
		"🍸": 2,
		"🍷": 2,
		"®": 1,
		"🍉": 3,
		"😇": 3,
		"🏃": 2,
		"😿": -2,
		"│": 1,
		"🍺": 2,
		"▶": 1,
		"😲": -1,
		"🎸": 2,
		"🍹": 3,
		"💫": 2,
		"📚": 1,
		"😶": -1,
		"🌷": 2,
		"💝": 3,
		"💨": 1,
		"🏈": 2,
		"💍": 2,
		"☔": 1,
		"👸": 3,
		"🇪": 3,
		"░": -1,
		"🍩": 1,
		"👾": 1,
		"☁": 1,
		"🌻": 2,
		"↿": 3,
		"🐯": 2,
		"👼": 1,
		"🍔": 1,
		"😸": 2,
		"👶": 2,
		"↾": 3,
		"💐": 3,
		"🌊": 2,
		"🍦": 2,
		"🍓": 3,
		"👇": 1,
		"💆": 1,
		"🍴": 2,
		"😧": -1,
		"🇸": 2,
		"😮": 1,
		"🚫": -3,
		"😽": 2,
		"🌈": 2,
		"🙀": 1,
		"⚠": -1,
		"🎮": 2,
		"╯": -1,
		"🍆": 2,
		"🍰": 2,
		"✓": 1,
		"👐": -1,
		"🍟": 1,
		"🍌": 2,
		"💑": 3,
		"👬": -1,
		"🐣": 2,
		"🎃": 3,
		"▬": 2,
		"￼": -3,
		"🐾": 3,
		"🎓": 2,
		"🏊": 2,
		"📷": 2,
		"👄": 2,
		"🌼": 4,
		"🚶": -1,
		"🐱": 2,
		"🐸": -1,
		"🇺": 2,
		"👿": -3,
		"🚬": 2,
		"✿": 1,
		"🐒": 2,
		"🌍": 3,
		"┊": 5,
		"🐥": 3,
		"🐼": 1,
		"🎥": 1,
		"💄": 2,
		"⛔": 2,
		"🏀": 1,
		"💉": 1,
		"💟": 3,
		"🚗": 1,
		"📝": 1,
		"♦": 2,
		"💭": 1,
		"🌙": 3,
		"🐟": 3,
		"👣": 1,
		"✂": -3,
		"🗿": 2,
		"👪": -1,
		"🍭": 1,
		"🌃": 2,
		"❌": 1,
		"🐰": 3,
		"💊": 2,
		"🚨": 3,
		"😦": -2,
		"🍪": 1,
		"🍣": -2,
		"✧": 1,
		"🎆": 3,
		"🎎": 4,
		"🇩": 3,
		"✅": 2,
		"📱": 1,
		"🙍": -2,
		"🍑": 1,
		"🎼": 1,
		"🔊": 2,
		"🌌": 2,
		"🍎": 1,
		"🐻": 2,
		"╰": -1,
		"💇": 1,
		"♬": 1,
		"🔴": 2,
		"🍱": -2,
		"🍊": 2,
		"🍒": 1,
		"🐭": 3,
		"👟": 2,
		"🌎": 1,
		"🍍": 2,
		"🐮": 3,
		"📲": 1,
		"☼": 1,
		"🌅": 1,
		"🇷": 3,
		"👠": 1,
		"🌽": 2,
		"💧": -1,
		"🍬": 1,
		"😺": 2,
		"🚀": 2,
		"¦": 3,
		"💢": 1,
		"🎬": 1,
		"🍧": 1,
		"🍜": 2,
		"🐏": 3,
		"🏄": 2,
		"➤": 1,
		"⬆": 1,
		"🍋": 1,
		"🆗": 2,
		"⚪": 2,
		"📺": 2,
		"🍅": 1,
		"⛅": 2,
		"🐢": 1,
		"👙": 2,
		"🏡": 2,
		"🌾": 2,
		"◉": 1,
		"✏": 1,
		"🐬": 2,
		"🇹": 3,
		"♣": 1,
		"🐝": 1,
		"🌝": 1,
		"🇮": 3,
		"🔋": -3,
		"🐍": 1,
		"♔": 2,
		"🔵": 1,
		"😾": -2,
		"🌕": 3,
		"🐨": 2,
		"🔐": 1,
		"💿": 3,
		"🌳": 2,
		"👰": 2,
		"❀": 2,
		"⚓": 3,
		"🚴": 3,
		"▀": -1,
		"👗": 1,
		"➕": 2,
		"💬": 2,
		"▒": -1,
		"🔜": 1,
		"🍨": 1,
		"💲": 1,
		"🍙": 1,
		"🍥": -4,
		"▸": 1,
		"♛": 1,
		"😼": 1,
		"🐙": 2,
		"👨": 2,
		"🍚": 2,
		"♨": 4,
		"🎹": 1,
		"♕": 2,
		"▃": 5,
		"🇬": 1,
		"🇧": 1,
		"☠": -1,
		"🐠": 2,
		"🚹": 3,
		"💵": 2,
		"✰": 4,
		"╠": 1,
		"👛": 2,
		"🌱": 3,
		"💻": 1,
		"🌏": 1,
		"▄": -1,
		"👓": 1,
		"◄": 1,
		"⚾": -1,
		"🌲": 2,
		"👴": 1,
		"🏠": 2,
		"🍇": 1,
		"🍘": 2,
		"🐇": 1,
		"🔞": -1,
		"👵": 2,
		"◀": 1,
		"🔙": 1,
		"🌵": 1,
		"🍮": -1,
		"🎇": 3,
		"🐎": 2,
		"➔": -1,
		"🐤": 2,
		"╩": 1,
		"🌑": 2,
		"🚲": 2,
		"🐑": -1,
		"🏁": 2,
		"🎾": 3,
		"╚": 1,
		"🈹": 1,
		"👮": -2,
		"☹": -3,
		"🐵": 2,
		"✪": 1,
		"◕": 2,
		"🗼": 3,
		"▐": -1,
		"♠": 1,
		"┳": -2,
		"👺": -2,
		"🐚": 1,
		"👂": -1,
		"🗽": 1,
		"🍵": 2,
		"🆒": 2,
		"🐺": 1,
		"⇨": 2,
		"🌓": 3,
		"🔒": 1,
		"╬": -1,
		"👳": 3,
		"🌂": 1,
		"🚌": 1,
		"♩": 3,
		"🍡": -1,
		"❥": 1,
		"🎡": 1,
		"💌": 2,
		"🐩": 2,
		"🌜": 2,
		"⌚": 1,
		"🚿": 3,
		"🔆": 3,
		"🌛": 3,
		"💂": -1,
		"🐔": 1,
		"🙎": -1,
		"🏩": 2,
		"🇫": 2,
		"🔨": -1,
		"📢": 2,
		"🐦": 2,
		"🐲": -1,
		"♻": 2,
		"🌘": 3,
		"🌔": 3,
		"👖": 2,
		"😗": 3,
		"🐄": 1,
		"◟": -1,
		"🍢": -1,
		"🎨": 1,
		"⬇": 2,
		"🚼": 3,
		"🇴": 2,
		"🌗": 3,
		"🌖": 3,
		"🔅": 5,
		"👜": 1,
		"🐌": 3,
		"💼": 3,
		"🐹": 1,
		"🌠": 3,
		"🐈": 1,
		"🌁": 1,
		"⚫": 1,
		"♧": 2,
		"🏰": 1,
		"🚵": 2,
		"🎢": 2,
		"🎷": 3,
		"🎐": 1,
		"┈": -4,
		"╗": 2,
		"🌇": 3,
		"⏰": 2,
		"🚂": 1,
		"◠": 2,
		"🎿": 2,
		"🆔": 4,
		"🌒": 3,
		"🐪": 3,
		"╔": 1,
		"╝": 2,
		"👔": 2,
		"🆓": 1,
		"🐋": 1,
		"▽": 2,
		"🐛": 1,
		"👕": 2,
		"💳": 2,
		"🏧": 5,
		"💡": 3,
		"⬅": 2,
		"🐫": 2,
		"🇱": 2,
		"📹": 2,
		"👞": 2,
		"👚": 3,
		"□": -2,
		"🚣": 3,
		"🏉": 3,
		"🗻": 3,
		"╦": 2,
		"⛺": 3,
		"🐕": 1,
		"🏂": 2,
		"👡": 2,
		"📻": 2,
		"✒": 1,
		"🌰": 3,
		"🏢": 1,
		"🎒": 3,
		"⌒": 3,
		"🏫": -2,
		"📴": 4,
		"🚢": 1,
		"🚚": -1,
		"🐉": 1,
		"❒": 1,
		"🔔": 5,
		"◢": 4,
		"🏥": 1,
		"🚖": -1,
		"▌": -2,
		"☛": 2,
		"💒": 3,
		"🚤": 2,
		"🐐": 2,
		"■": -2,
		"🔚": 2,
		"🎻": 2,
		"🔷": 1,
		"🎽": 2,
		"📅": 1,
		"🎺": 3,
		"🍈": -3,
		"✉": 1,
		"◤": 5,
		"○": 3,
		"🍼": 3,
		"🚛": -2,
		"📓": 1,
		"☉": 1,
		"💴": -2,
		"➰": -1,
		"🔌": -1,
		"📕": 1,
		"📣": 2,
		"🚓": 1,
		"🐗": 3,
		"⛳": 4,
		"┻": -3,
		"┛": 3,
		"┃": 2,
		"💺": 1,
		"🏇": -1,
		"☻": 1,
		"📞": 2,
		"Ⓐ": -1,
		"🌉": 3,
		"🚩": -2,
		"✎": 3,
		"📃": 2,
		"🏨": 1,
		"📌": -3,
		"♎": -1,
		"💷": 2,
		"🚄": 3,
		"▲": 3,
		"⛵": 3,
		"🔸": 1,
		"🚜": 5,
		"🐆": 2,
		"👒": 1,
		"❕": 1,
		"🔛": 2,
		"♢": 2,
		"🇲": 2,
		"❅": 4,
		"👝": 2,
		"✞": 2,
		"◡": 1,
		"🎋": 3,
		"👥": 1,
		"🐡": 1,
		"◆": 4,
		"🔭": 2,
		"🎪": 1,
		"🐜": 3,
		"♌": 4,
		"☐": -5,
		"👷": 1,
		"🔈": 1,
		"📄": 5,
		"🚐": 4,
		"🌋": 3,
		"📡": 1,
		"🚳": 5,
		"✘": 4,
		"🅰": 1,
		"🇼": 2,
		"┓": 3,
		"┣": 3,
		"Ⓛ": 2,
		"Ⓔ": 2,
		"👤": 4,
		"🚁": 1,
		"🎠": 3,
		"🐁": -2,
		"📗": 1,
		"┐": -1,
		"♂": 1,
		"📯": -1,
		"🔩": 1,
		"👢": 4,
		"◂": 2,
		"📰": 1,
		"📶": 2,
		"🌄": 1,
		"🗾": 2,
		"🔶": 2,
		"🏤": 2,
		"🎩": 2,
		"Ⓜ": 1,
		"🔧": -4,
		"🐅": 1,
		"♮": 1,
		"🅾": -1,
		"📦": 1,
		"🚊": 1,
		"🔲": 3,
		"△": 1,
		"📆": 5,
		"❛": 2,
		"📉": 2,
		"▵": 2,
		"🔎": 3,
		"☜": 1,
		"🇯": 2,
		"🇵": 2,
		"📘": 1,
		"ⓔ": 3,
		"🔑": 1,
		"⭕": 2,
		"🔘": 1,
		"🚭": 5,
		"🚉": 3,
		"🚪": 3,
		"➳": 2,
		"🚃": 3,
		"┯": -3,
		"🆙": 2,
		"🆖": 1,
		"┗": 5,
		"Ⓞ": 2,
		"❇": 3,
		"✴": 3,
		"☊": 5,
		"🔕": -2,
		"⬛": -2,
		"🚞": 3,
		"🍶": 3,
		"🌐": 3,
		"♀": 1,
		"🚅": 3,
		"🚒": -2,
		"♋": 1,
		"♍": 3,
		"🕝": -2,
		"ⓐ": 5,
		"📙": 1,
		"Ⓢ": 1,
		"📋": 3,
		"🎱": 1,
		"🐞": 1,
		"🔺": 1,
		"ⓡ": 5,
		"♤": 3,
		"🎯": 3,
		"🔉": 3,
		"↩": 5,
		"🚾": 1,
		"🎣": -4,
		"🔣": 1,
		"❎": -5,
		"➥": 1,
		"🎌": 5,
		"◣": 1,
		"⏬": 5,
		"♭": 1,
		"ⓞ": 5,
		"🔳": 2,
		"🏭": 2,
		"🎳": -3,
		"☚": 5,
		"➽": 2,
		"➫": 2,
		"➖": -5,
		"꒰": 2,
		"꒱": 2,
		"◝": -3,
		"📑": 5,
		"ⓧ": 5,
		"🔟": 5,
		"〓": 5,
		"ⓜ": 2,
		"➠": 5,
		"🚆": 2,
		"℅": -5,
		"☃": 2,
		"🚽": 5,
		"ⓝ": 5,
		"⇦": 5,
		"👲": 2,
		"🚡": -3,
		"🔬": 5,
		"➗": -3,
		"📈": 2,
		"⏪": 2,
		"◎": 5,
		"꒦": -5,
		"📎": 5,
		"⑅": 5,
		"✭": 5,
		"♓": 2,
		"┏": 5,
		"☇": 5,
		"࿎": -5,
		"👘": 5,
		"↙": 5,
		"Ⓕ": 2,
		"Ⓦ": 2,
		"Ⓟ": 2,
		"🕑": 2,
		"🕛": 5,
		"♈": -5,
		"↬": 5,
		"✍": 5,
		"🏦": 5,
		"🔻": 5,
		"ⓟ": 5,
		"ⓕ": 5,
		"ⓘ": 5,
		"♿": 5,
		"⇗": 5,
		"⇘": 5,
		"ⓨ": 5,
		"ⓙ": 5,
		"▫": 5,
		"🔇": 5,
		"⌃": -5,
		"🔖": 5,
		"📜": 5,
		"🚝": 5,
		"┘": -5,
		"✝": -5,
		"⍣": -5,
		"📮": -5,
		"🕕": -5,
		"🔯": 5,
		"➸": 5,
		"꒵": 5,
		"🕥": -5,
		"✽": 5,
		"📼": 5,
		"🕐": -5,
		"🀄": 5,
		"✬": 5,
		"✫": 5,
		"🕔": -5,
		"❣": 5,
		"📫": 5,
		"🉐": 5,
		"🈂": -5,
		"🎰": -5,
		"҂": -5,
		"╤": -5,
		"📔": 5
	};

/***/ },
/* 2296 */
/***/ function(module, exports) {

	module.exports = {
		"abandon": -2,
		"abandoned": -2,
		"abandons": -2,
		"abducted": -2,
		"abduction": -2,
		"abductions": -2,
		"abhor": -3,
		"abhorred": -3,
		"abhorrent": -3,
		"abhors": -3,
		"abilities": 2,
		"ability": 2,
		"aboard": 1,
		"aborted": -1,
		"aborts": -1,
		"absentee": -1,
		"absentees": -1,
		"absolve": 2,
		"absolved": 2,
		"absolves": 2,
		"absolving": 2,
		"absorbed": 1,
		"abuse": -3,
		"abused": -3,
		"abuses": -3,
		"abusing": -3,
		"abusive": -3,
		"accept": 1,
		"acceptable": 1,
		"acceptance": 1,
		"accepted": 1,
		"accepting": 1,
		"accepts": 1,
		"accessible": 1,
		"accident": -2,
		"accidental": -2,
		"accidentally": -2,
		"accidents": -2,
		"acclaim": 2,
		"acclaimed": 2,
		"accolade": 2,
		"accomplish": 2,
		"accomplished": 2,
		"accomplishes": 2,
		"accomplishment": 2,
		"accomplishments": 2,
		"accusation": -2,
		"accusations": -2,
		"accuse": -2,
		"accused": -2,
		"accuses": -2,
		"accusing": -2,
		"ache": -2,
		"achievable": 1,
		"aching": -2,
		"acquit": 2,
		"acquits": 2,
		"acquitted": 2,
		"acquitting": 2,
		"acrimonious": -3,
		"active": 1,
		"adequate": 1,
		"admire": 3,
		"admired": 3,
		"admires": 3,
		"admiring": 3,
		"admit": -1,
		"admits": -1,
		"admitted": -1,
		"admonish": -2,
		"admonished": -2,
		"adopt": 1,
		"adopts": 1,
		"adorable": 3,
		"adoration": 3,
		"adore": 3,
		"adored": 3,
		"adores": 3,
		"adoring": 3,
		"adoringly": 3,
		"advanced": 1,
		"advantage": 2,
		"advantageous": 2,
		"advantageously": 2,
		"advantages": 2,
		"adventure": 2,
		"adventures": 2,
		"adventurous": 2,
		"adversary": -1,
		"advisable": 1,
		"affected": -1,
		"affection": 3,
		"affectionate": 3,
		"affectionateness": 3,
		"afflicted": -1,
		"affordable": 2,
		"affronted": -1,
		"aficionados": 2,
		"afraid": -2,
		"aggravate": -2,
		"aggravated": -2,
		"aggravates": -2,
		"aggravating": -2,
		"aggression": -2,
		"aggressions": -2,
		"aggressive": -2,
		"aggressiveness": -2,
		"aghast": -2,
		"agog": 2,
		"agonise": -3,
		"agonised": -3,
		"agonises": -3,
		"agonising": -3,
		"agonize": -3,
		"agonized": -3,
		"agonizes": -3,
		"agonizing": -3,
		"agree": 1,
		"agreeable": 2,
		"agreed": 1,
		"agreement": 1,
		"agrees": 1,
		"alarm": -2,
		"alarmed": -2,
		"alarmist": -2,
		"alarmists": -2,
		"alas": -1,
		"alert": -1,
		"alienation": -2,
		"alive": 1,
		"allegation": -2,
		"allegations": -2,
		"allergic": -2,
		"allow": 1,
		"ally": 2,
		"alone": -2,
		"altruistic": 2,
		"amaze": 2,
		"amazed": 2,
		"amazes": 2,
		"amazing": 4,
		"ambitious": 2,
		"ambivalent": -1,
		"amicable": 2,
		"amuse": 3,
		"amused": 3,
		"amusement": 3,
		"amusements": 3,
		"anger": -3,
		"angered": -3,
		"angers": -3,
		"angry": -3,
		"anguish": -3,
		"anguished": -3,
		"animosity": -2,
		"annoy": -2,
		"annoyance": -2,
		"annoyed": -2,
		"annoying": -2,
		"annoys": -2,
		"antagonistic": -2,
		"anti": -1,
		"anticipation": 1,
		"anxiety": -2,
		"anxious": -2,
		"apathetic": -3,
		"apathy": -3,
		"apeshit": -3,
		"apocalyptic": -2,
		"apologise": -1,
		"apologised": -1,
		"apologises": -1,
		"apologising": -1,
		"apologize": -1,
		"apologized": -1,
		"apologizes": -1,
		"apologizing": -1,
		"apology": -1,
		"appalled": -2,
		"appalling": -2,
		"appealing": 2,
		"appease": 2,
		"appeased": 2,
		"appeases": 2,
		"appeasing": 2,
		"applaud": 2,
		"applauded": 2,
		"applauding": 2,
		"applauds": 2,
		"applause": 2,
		"appreciate": 2,
		"appreciated": 2,
		"appreciates": 2,
		"appreciating": 2,
		"appreciation": 2,
		"apprehensive": -2,
		"appropriate": 2,
		"appropriately": 2,
		"approval": 2,
		"approved": 2,
		"approves": 2,
		"ardent": 1,
		"arrest": -2,
		"arrested": -3,
		"arrests": -2,
		"arrogant": -2,
		"arsehole": -4,
		"ashame": -2,
		"ashamed": -2,
		"ass": -4,
		"assassination": -3,
		"assassinations": -3,
		"assault": -2,
		"assaults": -2,
		"asset": 2,
		"assets": 2,
		"assfucking": -4,
		"asshole": -4,
		"astonished": 2,
		"astound": 3,
		"astounded": 3,
		"astounding": 3,
		"astoundingly": 3,
		"astounds": 3,
		"atrocious": -3,
		"atrocity": -3,
		"attack": -1,
		"attacked": -1,
		"attacking": -1,
		"attacks": -1,
		"attract": 1,
		"attracted": 1,
		"attracting": 2,
		"attraction": 2,
		"attractions": 2,
		"attractive": 2,
		"attractively": 2,
		"attractiveness": 2,
		"attracts": 1,
		"audacious": 3,
		"aura": 1,
		"authority": 1,
		"avenge": -2,
		"avenged": -2,
		"avenger": -2,
		"avengers": -2,
		"avenges": -2,
		"avenging": -2,
		"avert": -1,
		"averted": -1,
		"averts": -1,
		"avid": 2,
		"avoid": -1,
		"avoided": -1,
		"avoids": -1,
		"await": -1,
		"awaited": -1,
		"awaits": -1,
		"award": 3,
		"awarded": 3,
		"awards": 3,
		"awesome": 4,
		"awful": -3,
		"awkward": -2,
		"axe": -1,
		"axed": -1,
		"backed": 1,
		"backing": 2,
		"backs": 1,
		"bad": -3,
		"bad luck": -2,
		"badass": -3,
		"badly": -3,
		"badness": -3,
		"bailout": -2,
		"balanced": 1,
		"bamboozle": -2,
		"bamboozled": -2,
		"bamboozles": -2,
		"ban": -2,
		"banish": -1,
		"bankrupt": -3,
		"bankruptcy": -3,
		"bankster": -3,
		"banned": -2,
		"barbarian": -2,
		"barbaric": -2,
		"barbarous": -2,
		"bargain": 2,
		"barrier": -2,
		"bastard": -5,
		"bastards": -5,
		"battle": -1,
		"battled": -1,
		"battles": -1,
		"battling": -2,
		"beaten": -2,
		"beatific": 3,
		"beating": -1,
		"beauties": 3,
		"beautiful": 3,
		"beautifully": 3,
		"beautify": 3,
		"beauty": 3,
		"befit": 2,
		"befitting": 2,
		"belittle": -2,
		"belittled": -2,
		"beloved": 3,
		"benefactor": 2,
		"benefactors": 2,
		"benefit": 2,
		"benefits": 2,
		"benefitted": 2,
		"benefitting": 2,
		"benevolent": 3,
		"bereave": -2,
		"bereaved": -2,
		"bereaves": -2,
		"bereaving": -2,
		"best": 3,
		"best damn": 4,
		"betray": -3,
		"betrayal": -3,
		"betrayed": -3,
		"betraying": -3,
		"betrays": -3,
		"better": 2,
		"bias": -1,
		"biased": -2,
		"big": 1,
		"bitch": -5,
		"bitches": -5,
		"bitter": -2,
		"bitterest": -2,
		"bitterly": -2,
		"bizarre": -2,
		"blackmail": -3,
		"blackmailed": -3,
		"blackmailing": -3,
		"blackmails": -3,
		"blah": -2,
		"blame": -2,
		"blamed": -2,
		"blames": -2,
		"blaming": -2,
		"bless": 2,
		"blesses": 2,
		"blessing": 3,
		"blessings": 3,
		"blind": -1,
		"bliss": 3,
		"blissful": 3,
		"blithe": 2,
		"bloated": -1,
		"block": -1,
		"blockade": -2,
		"blockbuster": 3,
		"blocked": -1,
		"blocking": -1,
		"blocks": -1,
		"bloody": -3,
		"blurry": -2,
		"boastful": -2,
		"bold": 2,
		"boldly": 2,
		"bomb": -1,
		"boost": 1,
		"boosted": 1,
		"boosting": 1,
		"boosts": 1,
		"bore": -2,
		"bored": -2,
		"boring": -3,
		"bother": -2,
		"bothered": -2,
		"bothers": -2,
		"bothersome": -2,
		"boycott": -2,
		"boycotted": -2,
		"boycotting": -2,
		"boycotts": -2,
		"brainwashing": -3,
		"brave": 2,
		"braveness": 2,
		"bravery": 2,
		"bravura": 3,
		"breach": -2,
		"breached": -2,
		"breaches": -2,
		"breaching": -2,
		"breakthrough": 3,
		"breathtaking": 5,
		"bribe": -3,
		"bribed": -3,
		"bribes": -3,
		"bribing": -3,
		"bright": 1,
		"brightest": 2,
		"brightness": 1,
		"brilliant": 4,
		"brilliance": 3,
		"brilliances": 3,
		"brisk": 2,
		"broke": -1,
		"broken": -1,
		"brooding": -2,
		"brutal": -3,
		"brutally": -3,
		"bullied": -2,
		"bullshit": -4,
		"bully": -2,
		"bullying": -2,
		"bummer": -2,
		"buoyant": 2,
		"burden": -2,
		"burdened": -2,
		"burdening": -2,
		"burdens": -2,
		"burglar": -2,
		"burglary": -2,
		"calm": 2,
		"calmed": 2,
		"calming": 2,
		"calms": 2,
		"can't stand": -3,
		"cancel": -1,
		"cancelled": -1,
		"cancelling": -1,
		"cancels": -1,
		"cancer": -1,
		"capabilities": 1,
		"capability": 1,
		"capable": 1,
		"captivated": 3,
		"care": 2,
		"carefree": 1,
		"careful": 2,
		"carefully": 2,
		"carefulness": 2,
		"careless": -2,
		"cares": 2,
		"caring": 2,
		"cashing in": -2,
		"casualty": -2,
		"catastrophe": -3,
		"catastrophic": -4,
		"cautious": -1,
		"celebrate": 3,
		"celebrated": 3,
		"celebrates": 3,
		"celebrating": 3,
		"celebration": 3,
		"celebrations": 3,
		"censor": -2,
		"censored": -2,
		"censors": -2,
		"certain": 1,
		"chagrin": -2,
		"chagrined": -2,
		"challenge": -1,
		"champion": 2,
		"championed": 2,
		"champions": 2,
		"chance": 2,
		"chances": 2,
		"chaos": -2,
		"chaotic": -2,
		"charged": -3,
		"charges": -2,
		"charisma": 2,
		"charitable": 2,
		"charm": 3,
		"charming": 3,
		"charmingly": 3,
		"charmless": -3,
		"chastise": -3,
		"chastised": -3,
		"chastises": -3,
		"chastising": -3,
		"cheat": -3,
		"cheated": -3,
		"cheater": -3,
		"cheaters": -3,
		"cheating": -3,
		"cheats": -3,
		"cheer": 2,
		"cheered": 2,
		"cheerful": 2,
		"cheerfully": 2,
		"cheering": 2,
		"cheerless": -2,
		"cheers": 2,
		"cheery": 3,
		"cherish": 2,
		"cherished": 2,
		"cherishes": 2,
		"cherishing": 2,
		"chic": 2,
		"chide": -3,
		"chided": -3,
		"chides": -3,
		"chiding": -3,
		"childish": -2,
		"chilling": -1,
		"choke": -2,
		"choked": -2,
		"chokes": -2,
		"choking": -2,
		"clarifies": 2,
		"clarity": 2,
		"clash": -2,
		"classy": 3,
		"clean": 2,
		"cleaner": 2,
		"clear": 1,
		"cleared": 1,
		"clearly": 1,
		"clears": 1,
		"clever": 2,
		"clouded": -1,
		"clueless": -2,
		"cock": -5,
		"cocksucker": -5,
		"cocksuckers": -5,
		"cocky": -2,
		"coerced": -2,
		"coercion": -2,
		"collapse": -2,
		"collapsed": -2,
		"collapses": -2,
		"collapsing": -2,
		"collide": -1,
		"collides": -1,
		"colliding": -1,
		"collision": -2,
		"collisions": -2,
		"colluding": -3,
		"combat": -1,
		"combats": -1,
		"comedy": 1,
		"comfort": 2,
		"comfortable": 2,
		"comfortably": 2,
		"comforting": 2,
		"comforts": 2,
		"comic": 1,
		"commend": 2,
		"commended": 2,
		"commit": 1,
		"commitment": 2,
		"commits": 1,
		"committed": 1,
		"committing": 1,
		"compassion": 2,
		"compassionate": 2,
		"compelled": 1,
		"competencies": 1,
		"competent": 2,
		"competitive": 2,
		"complacent": -2,
		"complain": -2,
		"complained": -2,
		"complaining": -2,
		"complains": -2,
		"complaint": -2,
		"complaints": -2,
		"complicating": -2,
		"compliment": 2,
		"complimented": 2,
		"compliments": 2,
		"comprehensive": 2,
		"concerned": -2,
		"conciliate": 2,
		"conciliated": 2,
		"conciliates": 2,
		"conciliating": 2,
		"condemn": -2,
		"condemnation": -2,
		"condemned": -2,
		"condemns": -2,
		"confidence": 2,
		"confident": 2,
		"confidently": 2,
		"conflict": -2,
		"conflicting": -2,
		"conflictive": -2,
		"conflicts": -2,
		"confuse": -2,
		"confused": -2,
		"confusing": -2,
		"congrats": 2,
		"congratulate": 2,
		"congratulation": 2,
		"congratulations": 2,
		"consent": 2,
		"consents": 2,
		"consolable": 2,
		"conspiracy": -3,
		"constipation": -2,
		"constrained": -2,
		"contagion": -2,
		"contagions": -2,
		"contagious": -1,
		"contaminant": -2,
		"contaminants": -2,
		"contaminate": -2,
		"contaminated": -2,
		"contaminates": -2,
		"contaminating": -2,
		"contamination": -2,
		"contaminations": -2,
		"contempt": -2,
		"contemptible": -2,
		"contemptuous": -2,
		"contemptuously": -2,
		"contend": -1,
		"contender": -1,
		"contending": -1,
		"contentious": -2,
		"contestable": -2,
		"controversial": -2,
		"controversially": -2,
		"controversies": -2,
		"controversy": -2,
		"convicted": -2,
		"convince": 1,
		"convinced": 1,
		"convinces": 1,
		"convivial": 2,
		"cool": 1,
		"cool stuff": 3,
		"cornered": -2,
		"corpse": -1,
		"corrupt": -3,
		"corrupted": -3,
		"corrupting": -3,
		"corruption": -3,
		"corrupts": -3,
		"costly": -2,
		"courage": 2,
		"courageous": 2,
		"courageously": 2,
		"courageousness": 2,
		"courteous": 2,
		"courtesy": 2,
		"cover-up": -3,
		"coward": -2,
		"cowardly": -2,
		"coziness": 2,
		"cramp": -1,
		"crap": -3,
		"crappy": -3,
		"crash": -2,
		"crazier": -2,
		"craziest": -2,
		"crazy": -2,
		"creative": 2,
		"crestfallen": -2,
		"cried": -2,
		"cries": -2,
		"crime": -3,
		"crimes": -3,
		"criminal": -3,
		"criminals": -3,
		"criminate": -3,
		"criminated": -3,
		"criminates": -3,
		"crisis": -3,
		"critic": -2,
		"criticise": -2,
		"criticised": -2,
		"criticises": -2,
		"criticising": -2,
		"criticism": -2,
		"criticize": -2,
		"criticized": -2,
		"criticizes": -2,
		"criticizing": -2,
		"critics": -2,
		"critique": -2,
		"crowding": -1,
		"crude": -1,
		"cruel": -3,
		"cruelty": -3,
		"crush": -1,
		"crushed": -2,
		"crushes": -1,
		"crushing": -1,
		"cry": -1,
		"crying": -2,
		"cunning": 2,
		"cunt": -5,
		"curious": 1,
		"curse": -1,
		"cut": -1,
		"cutback": -2,
		"cutbacks": -2,
		"cute": 2,
		"cuts": -1,
		"cutting": -1,
		"cynic": -2,
		"cynical": -2,
		"cynicism": -2,
		"damage": -3,
		"damaged": -3,
		"damages": -3,
		"damaging": -3,
		"damn": -2,
		"damn cute": 3,
		"damn good": 4,
		"damned": -4,
		"damnit": -4,
		"danger": -2,
		"dangerous": -2,
		"dangerously": -2,
		"daredevil": 2,
		"daring": 2,
		"darkest": -2,
		"darkness": -1,
		"dauntless": 2,
		"dazzling": 3,
		"dead": -3,
		"deadening": -2,
		"deadlock": -2,
		"deadly": -3,
		"deafening": -1,
		"dear": 2,
		"dearly": 3,
		"death": -2,
		"deaths": -2,
		"debonair": 2,
		"debt": -2,
		"deceit": -3,
		"deceitful": -3,
		"deceive": -3,
		"deceived": -3,
		"deceives": -3,
		"deceiving": -3,
		"deception": -3,
		"deceptive": -3,
		"decisive": 1,
		"dedicated": 2,
		"dedication": 2,
		"defeat": -2,
		"defeated": -2,
		"defect": -3,
		"defective": -3,
		"defects": -3,
		"defender": 2,
		"defenders": 2,
		"defenseless": -2,
		"defer": -1,
		"deferring": -1,
		"defiant": -1,
		"deficient": -2,
		"deficiency": -2,
		"deficiencies": -2,
		"deficit": -2,
		"deformed": -2,
		"deformities": -2,
		"deformity": -2,
		"defraud": -3,
		"defrauds": -3,
		"deft": 2,
		"defunct": -2,
		"degrade": -2,
		"degraded": -2,
		"degrades": -2,
		"dehumanize": -2,
		"dehumanized": -2,
		"dehumanizes": -2,
		"dehumanizing": -2,
		"deject": -2,
		"dejected": -2,
		"dejecting": -2,
		"dejects": -2,
		"delay": -1,
		"delayed": -1,
		"delectable": 3,
		"delicious": 3,
		"delight": 3,
		"delighted": 3,
		"delightful": 3,
		"delightfully": 3,
		"delighting": 3,
		"delights": 3,
		"demand": -1,
		"demanded": -1,
		"demanding": -1,
		"demands": -1,
		"demonstration": -1,
		"demoralize": -2,
		"demoralized": -2,
		"demoralizes": -2,
		"demoralizing": -2,
		"denial": -2,
		"denials": -2,
		"denied": -2,
		"denier": -2,
		"deniers": -2,
		"denies": -2,
		"denounce": -2,
		"denounces": -2,
		"dent": -2,
		"deny": -2,
		"denying": -2,
		"deplore": -3,
		"deplored": -3,
		"deplores": -3,
		"deploring": -3,
		"deport": -2,
		"deported": -2,
		"deporting": -2,
		"deports": -2,
		"deportation": -2,
		"deportations": -2,
		"depressed": -2,
		"depressing": -2,
		"deprivation": -3,
		"derail": -2,
		"derailed": -2,
		"derails": -2,
		"derelict": -2,
		"deride": -2,
		"derided": -2,
		"derides": -2,
		"deriding": -2,
		"derision": -2,
		"desirable": 2,
		"desire": 1,
		"desired": 2,
		"desirous": 2,
		"despair": -3,
		"despairing": -3,
		"despairs": -3,
		"desperate": -3,
		"desperately": -3,
		"despondent": -3,
		"destroy": -3,
		"destroyed": -3,
		"destroying": -3,
		"destroys": -3,
		"destruction": -3,
		"destructive": -3,
		"detached": -1,
		"detain": -2,
		"detained": -2,
		"detention": -2,
		"deteriorate": -2,
		"deteriorated": -2,
		"deteriorates": -2,
		"deteriorating": -2,
		"determined": 2,
		"deterrent": -2,
		"detract": -1,
		"detracted": -1,
		"detracts": -1,
		"devastate": -2,
		"devastated": -2,
		"devastating": -2,
		"devastation": -2,
		"devastations": -2,
		"devoted": 3,
		"devotion": 2,
		"devotional": 2,
		"diamond": 1,
		"dick": -4,
		"dickhead": -4,
		"die": -3,
		"died": -3,
		"difficult": -1,
		"diffident": -2,
		"dignity": 2,
		"dilemma": -1,
		"dilligence": 2,
		"dipshit": -3,
		"dire": -3,
		"direful": -3,
		"dirt": -2,
		"dirtier": -2,
		"dirtiest": -2,
		"dirty": -2,
		"disabilities": -2,
		"disability": -2,
		"disabling": -1,
		"disadvantage": -2,
		"disadvantaged": -2,
		"disagree": -2,
		"disagreeable": -2,
		"disagreement": -2,
		"disappear": -1,
		"disappeared": -1,
		"disappears": -1,
		"disappoint": -2,
		"disappointed": -2,
		"disappointing": -2,
		"disappointment": -2,
		"disappointments": -2,
		"disappoints": -2,
		"disapproval": -2,
		"disapprovals": -2,
		"disapprove": -2,
		"disapproved": -2,
		"disapproves": -2,
		"disapproving": -2,
		"disaster": -2,
		"disasters": -2,
		"disastrous": -3,
		"disbelieve": -2,
		"discard": -1,
		"discarded": -1,
		"discarding": -1,
		"discards": -1,
		"discernment": 2,
		"discomfort": -2,
		"disconsolate": -2,
		"disconsolation": -2,
		"discontented": -2,
		"discord": -2,
		"discounted": -1,
		"discouraged": -2,
		"discredited": -2,
		"discriminate": -2,
		"discriminated": -2,
		"discriminates": -2,
		"discriminating": -2,
		"discriminatory": -2,
		"disdain": -2,
		"disease": -1,
		"diseases": -1,
		"disgrace": -2,
		"disgraced": -2,
		"disguise": -1,
		"disguised": -1,
		"disguises": -1,
		"disguising": -1,
		"disgust": -3,
		"disgusted": -3,
		"disgustful": -3,
		"disgusting": -3,
		"disheartened": -2,
		"dishonest": -2,
		"disillusioned": -2,
		"disinclined": -2,
		"disjointed": -2,
		"dislike": -2,
		"disliked": -2,
		"dislikes": -2,
		"dismal": -2,
		"dismayed": -2,
		"dismissed": -2,
		"disorder": -2,
		"disorders": -2,
		"disorganized": -2,
		"disoriented": -2,
		"disparage": -2,
		"disparaged": -2,
		"disparages": -2,
		"disparaging": -2,
		"displeased": -2,
		"displeasure": -2,
		"disproportionate": -2,
		"dispute": -2,
		"disputed": -2,
		"disputes": -2,
		"disputing": -2,
		"disqualified": -2,
		"disquiet": -2,
		"disregard": -2,
		"disregarded": -2,
		"disregarding": -2,
		"disregards": -2,
		"disrespect": -2,
		"disrespected": -2,
		"disrupt": -2,
		"disrupted": -2,
		"disrupting": -2,
		"disruption": -2,
		"disruptions": -2,
		"disruptive": -2,
		"disrupts": -2,
		"dissatisfied": -2,
		"distasteful": -2,
		"distinguished": 2,
		"distort": -2,
		"distorted": -2,
		"distorting": -2,
		"distorts": -2,
		"distract": -2,
		"distracted": -2,
		"distraction": -2,
		"distracts": -2,
		"distress": -2,
		"distressed": -2,
		"distresses": -2,
		"distressing": -2,
		"distrust": -3,
		"distrustful": -3,
		"disturb": -2,
		"disturbed": -2,
		"disturbing": -2,
		"disturbs": -2,
		"dithering": -2,
		"diverting": -1,
		"dizzy": -1,
		"dodging": -2,
		"dodgy": -2,
		"does not work": -3,
		"dolorous": -2,
		"donate": 2,
		"donated": 2,
		"donates": 2,
		"donating": 2,
		"donation": 2,
		"dont like": -2,
		"doom": -2,
		"doomed": -2,
		"doubt": -1,
		"doubted": -1,
		"doubtful": -1,
		"doubting": -1,
		"doubts": -1,
		"douche": -3,
		"douchebag": -3,
		"dour": -2,
		"downcast": -2,
		"downer": -2,
		"downhearted": -2,
		"downside": -2,
		"drag": -1,
		"dragged": -1,
		"drags": -1,
		"drained": -2,
		"dread": -2,
		"dreaded": -2,
		"dreadful": -3,
		"dreading": -2,
		"dream": 1,
		"dreams": 1,
		"dreary": -2,
		"droopy": -2,
		"drop": -1,
		"dropped": -1,
		"drown": -2,
		"drowned": -2,
		"drowns": -2,
		"drudgery": -2,
		"drunk": -2,
		"dubious": -2,
		"dud": -2,
		"dull": -2,
		"dumb": -3,
		"dumbass": -3,
		"dump": -1,
		"dumped": -2,
		"dumps": -1,
		"dupe": -2,
		"duped": -2,
		"dupery": -2,
		"durable": 2,
		"dying": -3,
		"dysfunction": -2,
		"eager": 2,
		"earnest": 2,
		"ease": 2,
		"easy": 1,
		"ecstatic": 4,
		"eerie": -2,
		"eery": -2,
		"effective": 2,
		"effectively": 2,
		"effectiveness": 2,
		"effortlessly": 2,
		"elated": 3,
		"elation": 3,
		"elegant": 2,
		"elegantly": 2,
		"embarrass": -2,
		"embarrassed": -2,
		"embarrasses": -2,
		"embarrassing": -2,
		"embarrassment": -2,
		"embezzlement": -3,
		"embittered": -2,
		"embrace": 1,
		"emergency": -2,
		"empathetic": 2,
		"empower": 2,
		"empowerment": 2,
		"emptiness": -1,
		"empty": -1,
		"enchanted": 2,
		"encourage": 2,
		"encouraged": 2,
		"encouragement": 2,
		"encourages": 2,
		"encouraging": 2,
		"endorse": 2,
		"endorsed": 2,
		"endorsement": 2,
		"endorses": 2,
		"enemies": -2,
		"enemy": -2,
		"energetic": 2,
		"engage": 1,
		"engages": 1,
		"engrossed": 1,
		"engrossing": 3,
		"enjoy": 2,
		"enjoyable": 2,
		"enjoyed": 2,
		"enjoying": 2,
		"enjoys": 2,
		"enlighten": 2,
		"enlightened": 2,
		"enlightening": 2,
		"enlightens": 2,
		"ennui": -2,
		"enrage": -2,
		"enraged": -2,
		"enrages": -2,
		"enraging": -2,
		"enrapture": 3,
		"enslave": -2,
		"enslaved": -2,
		"enslaves": -2,
		"ensure": 1,
		"ensuring": 1,
		"enterprising": 1,
		"entertaining": 2,
		"enthral": 3,
		"enthusiastic": 3,
		"entitled": 1,
		"entrusted": 2,
		"envies": -1,
		"envious": -2,
		"environment-friendly": 2,
		"envy": -1,
		"envying": -1,
		"erroneous": -2,
		"error": -2,
		"errors": -2,
		"escape": -1,
		"escapes": -1,
		"escaping": -1,
		"esteem": 2,
		"esteemed": 2,
		"ethical": 2,
		"euphoria": 3,
		"euphoric": 4,
		"evacuate": -1,
		"evacuated": -1,
		"evacuates": -1,
		"evacuating": -1,
		"evacuation": -1,
		"evergreen": 2,
		"evergreens": 2,
		"evergreening": -3,
		"eviction": -1,
		"evil": -3,
		"exacerbate": -2,
		"exacerbated": -2,
		"exacerbates": -2,
		"exacerbating": -2,
		"exaggerate": -2,
		"exaggerated": -2,
		"exaggerates": -2,
		"exaggerating": -2,
		"exasparate": -2,
		"exasperated": -2,
		"exasperates": -2,
		"exasperating": -2,
		"excellence": 3,
		"excellent": 3,
		"excite": 3,
		"excited": 3,
		"excitement": 3,
		"exciting": 3,
		"exclude": -1,
		"excluded": -2,
		"exclusion": -1,
		"exclusive": 2,
		"excruciatingly": -1,
		"excuse": -1,
		"exempt": -1,
		"exhausted": -2,
		"exhilarated": 3,
		"exhilarates": 3,
		"exhilarating": 3,
		"exonerate": 2,
		"exonerated": 2,
		"exonerates": 2,
		"exonerating": 2,
		"expand": 1,
		"expands": 1,
		"expel": -2,
		"expelled": -2,
		"expelling": -2,
		"expels": -2,
		"expertly": 2,
		"exploit": -2,
		"exploited": -2,
		"exploiting": -2,
		"exploits": -2,
		"exploration": 1,
		"explorations": 1,
		"expose": -1,
		"exposed": -1,
		"exposes": -1,
		"exposing": -1,
		"exquisite": 3,
		"extend": 1,
		"extends": 1,
		"extremist": -2,
		"extremists": -2,
		"exuberant": 4,
		"exultant": 3,
		"exultantly": 3,
		"fabulous": 4,
		"fabulously": 4,
		"fad": -2,
		"fag": -3,
		"faggot": -3,
		"faggots": -3,
		"fail": -2,
		"failed": -2,
		"failing": -2,
		"fails": -2,
		"failure": -2,
		"failures": -2,
		"fainthearted": -2,
		"fair": 2,
		"fairness": 2,
		"faith": 1,
		"faithful": 3,
		"fake": -3,
		"faker": -3,
		"fakes": -3,
		"faking": -3,
		"fallen": -2,
		"falling": -1,
		"false": -1,
		"falsely": -2,
		"falsified": -3,
		"falsify": -3,
		"fame": 1,
		"famine": -2,
		"famous": 2,
		"fan": 3,
		"fantastic": 4,
		"farce": -1,
		"fascinate": 3,
		"fascinated": 3,
		"fascinates": 3,
		"fascinating": 3,
		"fascination": 3,
		"fascist": -2,
		"fascists": -2,
		"fatal": -3,
		"fatalities": -3,
		"fatality": -3,
		"fatigue": -2,
		"fatigued": -2,
		"fatigues": -2,
		"fatiguing": -2,
		"favor": 2,
		"favorable": 2,
		"favorably": 2,
		"favored": 2,
		"favorite": 2,
		"favorited": 2,
		"favorites": 2,
		"favors": 2,
		"favour": 2,
		"favourable": 2,
		"favourably": 2,
		"favoured": 2,
		"favourite": 2,
		"favourited": 2,
		"favourites": 2,
		"favours": 2,
		"fear": -2,
		"fearful": -2,
		"fearfully": -2,
		"fearing": -2,
		"fearless": 2,
		"fearlessness": 2,
		"fearsome": -2,
		"fed up": -3,
		"feeble": -2,
		"feeling": 1,
		"felonies": -3,
		"felony": -3,
		"fertile": 2,
		"fervent": 2,
		"fervid": 2,
		"festive": 2,
		"fever": -2,
		"fiasco": -3,
		"fidgety": -2,
		"fight": -1,
		"fighting": -2,
		"fine": 2,
		"fines": -2,
		"finest": 3,
		"fire": -2,
		"fired": -2,
		"firing": -2,
		"fit": 1,
		"fitness": 1,
		"filth": -2,
		"filthy": -2,
		"flagship": 2,
		"flaw": -2,
		"flawed": -3,
		"flawless": 2,
		"flawlessly": 2,
		"flaws": -2,
		"flees": -1,
		"flop": -2,
		"flops": -2,
		"flu": -2,
		"flustered": -2,
		"focused": 2,
		"fond": 2,
		"fondness": 2,
		"fool": -2,
		"foolish": -2,
		"fools": -2,
		"forbid": -1,
		"forbidden": -2,
		"forbidding": -2,
		"forced": -1,
		"foreclosure": -2,
		"foreclosures": -2,
		"forefront": 1,
		"forget": -1,
		"forgetful": -2,
		"forgettable": -1,
		"forgive": 1,
		"forgiving": 1,
		"forgot": -1,
		"forgotten": -1,
		"fortune": 2,
		"fortunate": 2,
		"fortunately": 2,
		"foul": -3,
		"frantic": -1,
		"fraud": -4,
		"frauds": -4,
		"fraudster": -4,
		"fraudsters": -4,
		"fraudulence": -4,
		"fraudulent": -4,
		"freak": -2,
		"free": 1,
		"freedom": 2,
		"freedoms": 2,
		"frenzy": -3,
		"fresh": 1,
		"friend": 1,
		"friendliness": 2,
		"friendly": 2,
		"friendship": 2,
		"fright": -2,
		"frightened": -2,
		"frightening": -3,
		"frikin": -2,
		"frisky": 2,
		"frowning": -1,
		"fruitless": -2,
		"frustrate": -2,
		"frustrated": -2,
		"frustrates": -2,
		"frustrating": -2,
		"frustration": -2,
		"ftw": 3,
		"fuck": -4,
		"fucked": -4,
		"fucker": -4,
		"fuckers": -4,
		"fuckface": -4,
		"fuckhead": -4,
		"fuckin": -4,
		"fucking": -4,
		"fucking amazing": 4,
		"fucking beautiful": 4,
		"fucking cute": 4,
		"fucking fantastic": 4,
		"fucking good": 4,
		"fucking great": 4,
		"fucking hot": 2,
		"fucking love": 4,
		"fucking loves": 4,
		"fucking perfect": 4,
		"fucktard": -4,
		"fud": -3,
		"fuked": -4,
		"fuking": -4,
		"fulfill": 2,
		"fulfilled": 2,
		"fulfillment": 2,
		"fulfills": 2,
		"fuming": -2,
		"fun": 4,
		"funeral": -1,
		"funerals": -1,
		"funky": 2,
		"funnier": 4,
		"funny": 4,
		"furious": -3,
		"futile": -2,
		"gag": -2,
		"gagged": -2,
		"gain": 2,
		"gained": 2,
		"gaining": 2,
		"gains": 2,
		"gallant": 3,
		"gallantly": 3,
		"gallantry": 3,
		"game-changing": 3,
		"garbage": -1,
		"gem": 3,
		"generous": 2,
		"generously": 2,
		"genial": 3,
		"ghastly": -2,
		"ghost": -1,
		"giddy": -2,
		"gift": 2,
		"glad": 3,
		"glamorous": 3,
		"glamourous": 3,
		"glee": 3,
		"gleeful": 3,
		"gloom": -1,
		"gloomy": -2,
		"glorious": 2,
		"glory": 2,
		"glum": -2,
		"god": 1,
		"goddamn": -3,
		"godsend": 4,
		"gold": 2,
		"good": 3,
		"goodlooking": 3,
		"goodmorning": 1,
		"goodness": 3,
		"goodwill": 3,
		"goofiness": -2,
		"goofy": -2,
		"grace": 1,
		"graceful": 2,
		"gracious": 3,
		"grand": 3,
		"grant": 1,
		"granted": 1,
		"granting": 1,
		"grants": 1,
		"grateful": 3,
		"gratification": 2,
		"grave": -2,
		"gray": -1,
		"grisly": -2,
		"gr8": 3,
		"great": 3,
		"greater": 3,
		"greatest": 3,
		"greed": -3,
		"greedy": -2,
		"green wash": -3,
		"green washing": -3,
		"greenwash": -3,
		"greenwasher": -3,
		"greenwashers": -3,
		"greenwashing": -3,
		"greet": 1,
		"greeted": 1,
		"greeting": 1,
		"greetings": 2,
		"greets": 1,
		"grey": -1,
		"grief": -2,
		"grieved": -2,
		"grim": -2,
		"gripping": 2,
		"groan": -2,
		"groaned": -2,
		"groaning": -2,
		"groans": -2,
		"gross": -2,
		"growing": 1,
		"growth": 2,
		"growths": 2,
		"gruesome": -3,
		"guarantee": 1,
		"guilt": -3,
		"guilty": -3,
		"gullibility": -2,
		"gullible": -2,
		"gun": -1,
		"ha": 2,
		"hacked": -1,
		"haha": 3,
		"hahaha": 3,
		"hahahah": 3,
		"hail": 2,
		"hailed": 2,
		"hallelujah": 3,
		"handpicked": 1,
		"handsome": 3,
		"hapless": -2,
		"haplessness": -2,
		"happiest": 3,
		"happiness": 3,
		"happy": 3,
		"harass": -3,
		"harassed": -3,
		"harasses": -3,
		"harassing": -3,
		"harassment": -3,
		"hard": -1,
		"hardier": 2,
		"hardship": -2,
		"hardy": 2,
		"harm": -2,
		"harmed": -2,
		"harmful": -2,
		"harming": -2,
		"harmony": 2,
		"harmonious": 2,
		"harmoniously": 2,
		"harms": -2,
		"harried": -2,
		"harsh": -2,
		"harsher": -2,
		"harshest": -2,
		"harshly": -2,
		"hate": -3,
		"hated": -3,
		"hater": -3,
		"haters": -3,
		"hates": -3,
		"hating": -3,
		"hatred": -3,
		"haunt": -1,
		"haunted": -2,
		"haunting": 1,
		"haunts": -1,
		"havoc": -2,
		"hazardous": -3,
		"headache": -2,
		"healthy": 2,
		"heartbreaking": -3,
		"heartbroken": -3,
		"heartfelt": 3,
		"heartless": -2,
		"heartwarming": 3,
		"heaven": 2,
		"heavenly": 4,
		"heavyhearted": -2,
		"hehe": 2,
		"hell": -4,
		"hellish": -2,
		"help": 2,
		"helpful": 2,
		"helping": 2,
		"helpless": -2,
		"helps": 2,
		"hero": 2,
		"heroes": 2,
		"heroic": 3,
		"hesitant": -2,
		"hesitate": -2,
		"hid": -1,
		"hide": -1,
		"hideous": -3,
		"hides": -1,
		"hiding": -1,
		"highlight": 2,
		"hilarious": 2,
		"hinder": -2,
		"hindrance": -2,
		"hoax": -2,
		"hollow": -1,
		"homeless": -2,
		"homesick": -2,
		"homicide": -2,
		"homicides": -2,
		"honest": 2,
		"honor": 2,
		"honored": 2,
		"honoring": 2,
		"honour": 2,
		"honoured": 2,
		"honouring": 2,
		"hooligan": -2,
		"hooliganism": -2,
		"hooligans": -2,
		"hope": 2,
		"hopeful": 2,
		"hopefully": 2,
		"hopeless": -2,
		"hopelessness": -2,
		"hopes": 2,
		"hoping": 2,
		"horrendous": -3,
		"horrid": -3,
		"horrible": -3,
		"horrific": -3,
		"horrified": -3,
		"hospitalized": -2,
		"hostile": -2,
		"huckster": -2,
		"hug": 2,
		"huge": 1,
		"hugs": 2,
		"humane": 2,
		"humble": 1,
		"humbug": -2,
		"humerous": 3,
		"humiliated": -3,
		"humiliation": -3,
		"humor": 2,
		"humorous": 2,
		"humour": 2,
		"humourous": 2,
		"hunger": -2,
		"hurrah": 5,
		"hurt": -2,
		"hurting": -2,
		"hurts": -2,
		"hypocritical": -2,
		"hysteria": -3,
		"hysterical": -3,
		"hysterics": -3,
		"icky": -3,
		"idiocy": -3,
		"idiot": -3,
		"idiotic": -3,
		"ignorance": -2,
		"ignorant": -2,
		"ignore": -1,
		"ignored": -2,
		"ignores": -1,
		"ill": -2,
		"ill-fated": -2,
		"illegal": -3,
		"illegally": -3,
		"illegitimate": -3,
		"illiteracy": -2,
		"illness": -2,
		"illnesses": -2,
		"illogical": -2,
		"imaginative": 2,
		"imbecile": -3,
		"immobilized": -1,
		"immortal": 2,
		"immune": 1,
		"impair": -2,
		"impaired": -2,
		"impairing": -2,
		"impairment": -2,
		"impairs": -2,
		"impatient": -2,
		"impeachment": -3,
		"impeachments": -3,
		"impede": -2,
		"impeded": -2,
		"impedes": -2,
		"impeding": -2,
		"impedingly": -2,
		"imperfect": -2,
		"importance": 2,
		"important": 2,
		"impose": -1,
		"imposed": -1,
		"imposes": -1,
		"imposing": -1,
		"imposter": -2,
		"impotent": -2,
		"impress": 3,
		"impressed": 3,
		"impresses": 3,
		"impressive": 3,
		"imprisoned": -2,
		"imprisonment": -2,
		"improper": -2,
		"improperly": -2,
		"improve": 2,
		"improved": 2,
		"improvement": 2,
		"improves": 2,
		"improving": 2,
		"inability": -2,
		"inaction": -2,
		"inadequate": -2,
		"inadvertently": -2,
		"inappropriate": -2,
		"incapable": -2,
		"incapacitated": -2,
		"incapacitates": -2,
		"incapacitating": -2,
		"incense": -2,
		"incensed": -2,
		"incenses": -2,
		"incensing": -2,
		"incoherent": -2,
		"incompetence": -2,
		"incompetent": -2,
		"incomplete": -1,
		"incomprehensible": -2,
		"inconsiderate": -2,
		"inconvenience": -2,
		"inconvenient": -2,
		"increase": 1,
		"increased": 1,
		"indecisive": -2,
		"indestructible": 2,
		"indicted": -2,
		"indifference": -2,
		"indifferent": -2,
		"indignant": -2,
		"indignation": -2,
		"indoctrinate": -2,
		"indoctrinated": -2,
		"indoctrinates": -2,
		"indoctrinating": -2,
		"inediable": -2,
		"inexorable": -3,
		"inexcusable": -3,
		"ineffective": -2,
		"ineffectively": -2,
		"ineffectual": -2,
		"inefficiency": -2,
		"inefficient": -2,
		"inefficiently": -2,
		"inept": -2,
		"ineptitude": -2,
		"infantile": -2,
		"infantilized": -2,
		"infatuated": 2,
		"infatuation": 2,
		"infect": -2,
		"infected": -2,
		"infecting": -2,
		"infection": -2,
		"infections": -2,
		"infectious": -2,
		"infects": -2,
		"inferior": -2,
		"infest": -2,
		"infested": -2,
		"infesting": -2,
		"infests": -2,
		"inflamed": -2,
		"inflict": -2,
		"inflicted": -2,
		"inflicting": -2,
		"inflicts": -2,
		"influential": 2,
		"infract": -2,
		"infracted": -2,
		"infracting": -2,
		"infracts": -2,
		"infringement": -2,
		"infuriate": -2,
		"infuriated": -2,
		"infuriates": -2,
		"infuriating": -2,
		"inhibit": -1,
		"inhuman": -2,
		"injured": -2,
		"injuries": -2,
		"injury": -2,
		"injustice": -2,
		"innovate": 1,
		"innovates": 1,
		"innovation": 1,
		"innovative": 2,
		"inoperative": -2,
		"inquisition": -2,
		"inquisitive": 2,
		"insane": -2,
		"insanity": -2,
		"insecure": -2,
		"insensitive": -2,
		"insensitivity": -2,
		"insignificant": -2,
		"insipid": -2,
		"insolvent": -2,
		"insomnia": -2,
		"inspiration": 2,
		"inspirational": 2,
		"inspire": 2,
		"inspired": 2,
		"inspires": 2,
		"inspiring": 3,
		"insufficiency": -2,
		"insufficient": -2,
		"insufficiently": -2,
		"insult": -2,
		"insulted": -2,
		"insulting": -2,
		"insults": -2,
		"intact": 2,
		"integrity": 2,
		"intelligent": 2,
		"intense": 1,
		"interest": 1,
		"interested": 2,
		"interesting": 2,
		"interests": 1,
		"interrogated": -2,
		"interrupt": -2,
		"interrupted": -2,
		"interrupting": -2,
		"interruption": -2,
		"interrupts": -2,
		"intimacy": 2,
		"intimidate": -2,
		"intimidated": -2,
		"intimidates": -2,
		"intimidating": -2,
		"intimidation": -2,
		"intransigence": -2,
		"intransigency": -2,
		"intricate": 2,
		"intrigues": 1,
		"invasion": -1,
		"invincible": 2,
		"invite": 1,
		"inviting": 1,
		"invulnerable": 2,
		"irate": -3,
		"ironic": -1,
		"irony": -1,
		"irrational": -1,
		"irreparable": -2,
		"irreproducible": -2,
		"irresistible": 2,
		"irresistibly": 2,
		"irresolute": -2,
		"irresponsible": -2,
		"irresponsibly": -2,
		"irreversible": -1,
		"irreversibly": -1,
		"irritate": -3,
		"irritated": -3,
		"irritates": -3,
		"irritating": -3,
		"isolated": -1,
		"itchy": -2,
		"jackass": -4,
		"jackasses": -4,
		"jailed": -2,
		"jaunty": 2,
		"jealous": -2,
		"jealousy": -2,
		"jeopardy": -2,
		"jerk": -3,
		"jesus": 1,
		"jewel": 1,
		"jewels": 1,
		"jocular": 2,
		"join": 1,
		"joke": 2,
		"jokes": 2,
		"jolly": 2,
		"jovial": 2,
		"joy": 3,
		"joyful": 3,
		"joyfully": 3,
		"joyless": -2,
		"joyous": 3,
		"jubilant": 3,
		"jumpy": -1,
		"justice": 2,
		"justifiably": 2,
		"justified": 2,
		"keen": 1,
		"kickback": -3,
		"kickbacks": -3,
		"kidnap": -2,
		"kidnapped": -2,
		"kidnapping": -2,
		"kidnappings": -2,
		"kidnaps": -2,
		"kill": -3,
		"killed": -3,
		"killing": -3,
		"kills": -3,
		"kind": 2,
		"kind of": 0,
		"kinder": 2,
		"kindness": 2,
		"kiss": 2,
		"kudos": 3,
		"lack": -2,
		"lackadaisical": -2,
		"lag": -1,
		"lagged": -2,
		"lagging": -2,
		"lags": -2,
		"lame": -2,
		"landmark": 2,
		"lapse": -1,
		"lapsed": -1,
		"laugh": 1,
		"laughed": 1,
		"laughing": 1,
		"laughs": 1,
		"laughting": 1,
		"launched": 1,
		"lawl": 3,
		"lawsuit": -2,
		"lawsuits": -2,
		"lazy": -1,
		"leadership": 1,
		"leading": 2,
		"leak": -1,
		"leaked": -1,
		"leave": -1,
		"legal": 1,
		"legally": 1,
		"lenient": 1,
		"lethal": -2,
		"lethality": -2,
		"lethargic": -2,
		"lethargy": -2,
		"liar": -3,
		"liars": -3,
		"libelous": -2,
		"lied": -2,
		"lifeless": -1,
		"lifesaver": 4,
		"lighthearted": 1,
		"likable": 2,
		"like": 2,
		"likeable": 2,
		"liked": 2,
		"likers": 2,
		"likes": 2,
		"liking": 2,
		"limitation": -1,
		"limited": -1,
		"limits": -1,
		"litigation": -1,
		"litigious": -2,
		"lively": 2,
		"livid": -2,
		"lmao": 4,
		"lmfao": 4,
		"loathe": -3,
		"loathed": -3,
		"loathes": -3,
		"loathing": -3,
		"loathsome": -3,
		"lobbied": -2,
		"lobby": -2,
		"lobbying": -2,
		"lobbyist": -2,
		"lobbyists": -2,
		"lol": 3,
		"lolol": 4,
		"lololol": 4,
		"lolololol": 4,
		"lonely": -2,
		"lonesome": -2,
		"longing": -1,
		"lool": 3,
		"loom": -1,
		"loomed": -1,
		"looming": -1,
		"looms": -1,
		"loool": 3,
		"looool": 3,
		"loose": -3,
		"looses": -3,
		"loser": -3,
		"losing": -3,
		"loss": -3,
		"losses": -3,
		"lost": -3,
		"lousy": -2,
		"lovable": 3,
		"love": 3,
		"loved": 3,
		"lovelies": 3,
		"lovely": 3,
		"loves": 3,
		"loving": 2,
		"loving-kindness": 3,
		"lowest": -1,
		"loyal": 3,
		"loyalty": 3,
		"luck": 3,
		"luckily": 3,
		"lucky": 3,
		"lucrative": 3,
		"ludicrous": -3,
		"lugubrious": -2,
		"lunatic": -3,
		"lunatics": -3,
		"lurk": -1,
		"lurking": -1,
		"lurks": -1,
		"luxury": 2,
		"macabre": -2,
		"mad": -3,
		"maddening": -3,
		"made-up": -1,
		"madly": -3,
		"madness": -3,
		"magnificent": 3,
		"maladaption": -2,
		"maldevelopment": -2,
		"maltreatment": -2,
		"mandatory": -1,
		"manipulated": -1,
		"manipulating": -1,
		"manipulation": -1,
		"manslaughter": -3,
		"marvel": 3,
		"marvelous": 3,
		"marvels": 3,
		"masterpiece": 4,
		"masterpieces": 4,
		"matter": 1,
		"matters": 1,
		"mature": 2,
		"meaningful": 2,
		"meaningless": -2,
		"medal": 3,
		"mediocrity": -3,
		"meditative": 1,
		"melancholy": -2,
		"memorable": 1,
		"memoriam": -2,
		"menace": -2,
		"menaced": -2,
		"menaces": -2,
		"mercy": 2,
		"merry": 3,
		"mesmerizing": 3,
		"mess": -2,
		"messed": -2,
		"messing up": -2,
		"methodical": 2,
		"methodically": 2,
		"mindless": -2,
		"miracle": 4,
		"mirth": 3,
		"mirthful": 3,
		"mirthfully": 3,
		"misbehave": -2,
		"misbehaved": -2,
		"misbehaves": -2,
		"misbehaving": -2,
		"misbranding": -3,
		"miscast": -2,
		"mischief": -1,
		"mischiefs": -1,
		"misclassified": -2,
		"misclassifies": -2,
		"misclassify": -2,
		"misconduct": -2,
		"misconducted": -2,
		"misconducting": -2,
		"misconducts": -2,
		"miserable": -3,
		"miserably": -3,
		"misery": -2,
		"misfire": -2,
		"misfortune": -2,
		"misgiving": -2,
		"misinformation": -2,
		"misinformed": -2,
		"misinterpreted": -2,
		"mislead": -3,
		"misleaded": -3,
		"misleading": -3,
		"misleads": -3,
		"misplace": -2,
		"misplaced": -2,
		"misplaces": -2,
		"misplacing": -2,
		"mispricing": -3,
		"misread": -1,
		"misreport": -2,
		"misreported": -2,
		"misreporting": -2,
		"misreports": -2,
		"misrepresent": -2,
		"misrepresentation": -2,
		"misrepresentations": -2,
		"misrepresented": -2,
		"misrepresenting": -2,
		"misrepresents": -2,
		"miss": -2,
		"missed": -2,
		"missing": -2,
		"mistake": -2,
		"mistaken": -2,
		"mistakes": -2,
		"mistaking": -2,
		"misunderstand": -2,
		"misunderstanding": -2,
		"misunderstands": -2,
		"misunderstood": -2,
		"misuse": -2,
		"misused": -2,
		"misuses": -2,
		"misusing": -2,
		"moan": -2,
		"moaned": -2,
		"moaning": -2,
		"moans": -2,
		"mock": -2,
		"mocked": -2,
		"mocking": -2,
		"mocks": -2,
		"modernize": 2,
		"modernized": 2,
		"modernizes": 2,
		"modernizing": 2,
		"mongering": -2,
		"monopolize": -2,
		"monopolized": -2,
		"monopolizes": -2,
		"monopolizing": -2,
		"monotone": -1,
		"moody": -1,
		"mope": -1,
		"moping": -1,
		"moron": -3,
		"motherfucker": -5,
		"motherfucking": -5,
		"motivate": 1,
		"motivated": 2,
		"motivating": 2,
		"motivation": 1,
		"mourn": -2,
		"mourned": -2,
		"mournful": -2,
		"mourning": -2,
		"mourns": -2,
		"muddy": -2,
		"mumpish": -2,
		"murder": -2,
		"murderer": -2,
		"murdering": -3,
		"murderous": -3,
		"murders": -2,
		"murky": -2,
		"myth": -1,
		"n00b": -2,
		"naive": -2,
		"narcissism": -2,
		"nasty": -3,
		"natural": 1,
		"naïve": -2,
		"needy": -2,
		"negative": -2,
		"negativity": -2,
		"neglect": -2,
		"neglected": -2,
		"neglecting": -2,
		"neglects": -2,
		"nerves": -1,
		"nervous": -2,
		"nervously": -2,
		"nice": 3,
		"nifty": 2,
		"niggas": -5,
		"nigger": -5,
		"no": -1,
		"no fun": -3,
		"noble": 2,
		"noblest": 2,
		"noisy": -1,
		"non-approved": -2,
		"nonsense": -2,
		"noob": -2,
		"nosey": -2,
		"not good": -2,
		"not working": -3,
		"notable": 2,
		"noticeable": 2,
		"notorious": -2,
		"novel": 2,
		"numb": -1,
		"nurturing": 2,
		"nuts": -3,
		"obliterate": -2,
		"obliterated": -2,
		"obnoxious": -3,
		"obscene": -2,
		"obscenity": -2,
		"obsessed": 2,
		"obsolete": -2,
		"obstacle": -2,
		"obstacles": -2,
		"obstinate": -2,
		"obstruct": -2,
		"obstructed": -2,
		"obstructing": -2,
		"obstruction": -2,
		"obstructs": -2,
		"odd": -2,
		"offence": -2,
		"offences": -2,
		"offend": -2,
		"offended": -2,
		"offender": -2,
		"offending": -2,
		"offends": -2,
		"offense": -2,
		"offenses": -2,
		"offensive": -2,
		"offensively": -2,
		"offline": -1,
		"oks": 2,
		"ominous": 3,
		"once-in-a-lifetime": 3,
		"oops": -2,
		"opportunities": 2,
		"opportunity": 2,
		"oppressed": -2,
		"oppression": -2,
		"oppressions": -2,
		"oppressive": -2,
		"optimism": 2,
		"optimistic": 2,
		"optionless": -2,
		"ostracize": -2,
		"ostracized": -2,
		"ostracizes": -2,
		"ouch": -2,
		"outage": -2,
		"outages": -2,
		"outbreak": -2,
		"outbreaks": -2,
		"outcry": -2,
		"outmaneuvered": -2,
		"outnumbered": -2,
		"outrage": -3,
		"outraged": -3,
		"outrageous": -3,
		"outreach": 2,
		"outstanding": 5,
		"overjoyed": 4,
		"overload": -1,
		"overlooked": -1,
		"overprotective": -2,
		"overran": -2,
		"overreact": -2,
		"overreacted": -2,
		"overreacting": -2,
		"overreaction": -2,
		"overreacts": -2,
		"oversell": -2,
		"overselling": -2,
		"oversells": -2,
		"oversight": -1,
		"oversimplification": -2,
		"oversimplified": -2,
		"oversimplifies": -2,
		"oversimplify": -2,
		"oversold": -2,
		"overstatement": -2,
		"overstatements": -2,
		"overweight": -1,
		"overwrought": -3,
		"oxymoron": -1,
		"pain": -2,
		"pained": -2,
		"painful": -2,
		"panic": -3,
		"panicked": -3,
		"panics": -3,
		"paradise": 3,
		"paradox": -1,
		"pardon": 2,
		"pardoned": 2,
		"pardoning": 2,
		"pardons": 2,
		"parley": -1,
		"passion": 1,
		"passionate": 2,
		"passive": -1,
		"passively": -1,
		"pathetic": -2,
		"pay": -1,
		"peace": 2,
		"peaceful": 2,
		"peacefully": 2,
		"penalize": -2,
		"penalized": -2,
		"penalizes": -2,
		"penalizing": -2,
		"penalty": -2,
		"pensive": -1,
		"perfect": 3,
		"perfected": 2,
		"perfection": 3,
		"perfectly": 3,
		"perfects": 2,
		"peril": -2,
		"perjury": -3,
		"perpetrated": -2,
		"perpetrator": -2,
		"perpetrators": -2,
		"perplexed": -2,
		"persecute": -2,
		"persecuted": -2,
		"persecutes": -2,
		"persecuting": -2,
		"perturbed": -2,
		"pervert": -3,
		"pesky": -2,
		"pessimism": -2,
		"pessimistic": -2,
		"petrified": -2,
		"philanthropy": 2,
		"phobic": -2,
		"picturesque": 2,
		"pileup": -1,
		"pillage": -2,
		"pique": -2,
		"piqued": -2,
		"piss": -4,
		"pissed": -4,
		"pissing": -3,
		"piteous": -2,
		"pitied": -1,
		"pity": -2,
		"plague": -3,
		"plagued": -3,
		"plagues": -3,
		"plaguing": -3,
		"playful": 2,
		"pleasant": 3,
		"please": 1,
		"pleased": 3,
		"pleasurable": 3,
		"pleasure": 3,
		"plodding": -2,
		"poignant": 2,
		"pointless": -2,
		"poised": -2,
		"poison": -2,
		"poisoned": -2,
		"poisons": -2,
		"polished": 2,
		"polite": 2,
		"politeness": 2,
		"pollutant": -2,
		"pollute": -2,
		"polluted": -2,
		"polluter": -2,
		"polluters": -2,
		"pollutes": -2,
		"pollution": -2,
		"poor": -2,
		"poorer": -2,
		"poorest": -2,
		"poorly": -2,
		"popular": 3,
		"popularity": 3,
		"positive": 2,
		"positively": 2,
		"possessive": -2,
		"post-traumatic": -2,
		"postpone": -1,
		"postponed": -1,
		"postpones": -1,
		"postponing": -1,
		"poverty": -1,
		"powerful": 2,
		"powerless": -2,
		"praise": 3,
		"praised": 3,
		"praises": 3,
		"praising": 3,
		"pray": 1,
		"praying": 1,
		"prays": 1,
		"prblm": -2,
		"prblms": -2,
		"predatory": -2,
		"prepared": 1,
		"pressure": -1,
		"pressured": -2,
		"pretend": -1,
		"pretending": -1,
		"pretends": -1,
		"pretty": 1,
		"prevent": -1,
		"prevented": -1,
		"preventing": -1,
		"prevents": -1,
		"prick": -5,
		"prison": -2,
		"prisoner": -2,
		"prisoners": -2,
		"privileged": 2,
		"proactive": 2,
		"problem": -2,
		"problems": -2,
		"profit": 2,
		"profitable": 2,
		"profiteer": -2,
		"profits": 2,
		"progress": 2,
		"prohibit": -1,
		"prohibits": -1,
		"prominent": 2,
		"promise": 1,
		"promised": 1,
		"promises": 1,
		"promote": 1,
		"promoted": 1,
		"promotes": 1,
		"promoting": 1,
		"promptly": 1,
		"propaganda": -2,
		"prosecute": -1,
		"prosecuted": -2,
		"prosecutes": -1,
		"prosecution": -1,
		"prospect": 1,
		"prospects": 1,
		"prosperity": 3,
		"prosperous": 3,
		"protect": 1,
		"protected": 1,
		"protects": 1,
		"protest": -2,
		"protesters": -2,
		"protesting": -2,
		"protests": -2,
		"proud": 2,
		"proudly": 2,
		"provoke": -1,
		"provoked": -1,
		"provokes": -1,
		"provoking": -1,
		"prudence": 2,
		"pseudoscience": -3,
		"psychopathic": -2,
		"punish": -2,
		"punished": -2,
		"punishes": -2,
		"punishing": -2,
		"punitive": -2,
		"pure": 1,
		"purest": 1,
		"purposeful": 2,
		"pushy": -1,
		"puzzled": -2,
		"quaking": -2,
		"qualities": 2,
		"quality": 2,
		"questionable": -2,
		"questioned": -1,
		"questioning": -1,
		"racism": -3,
		"racist": -3,
		"racists": -3,
		"rage": -2,
		"rageful": -2,
		"rainy": -1,
		"rant": -3,
		"ranter": -3,
		"ranters": -3,
		"rants": -3,
		"rape": -4,
		"raped": -4,
		"rapist": -4,
		"rapture": 2,
		"raptured": 2,
		"raptures": 2,
		"rapturous": 4,
		"rash": -2,
		"ratified": 2,
		"reach": 1,
		"reached": 1,
		"reaches": 1,
		"reaching": 1,
		"reassure": 1,
		"reassured": 1,
		"reassures": 1,
		"reassuring": 2,
		"rebel": -2,
		"rebellion": -2,
		"rebels": -2,
		"recession": -2,
		"reckless": -2,
		"recognition": 2,
		"recommend": 2,
		"recommended": 2,
		"recommends": 2,
		"redeemed": 2,
		"refine": 1,
		"refined": 1,
		"refines": 1,
		"refreshingly": 2,
		"refuse": -2,
		"refused": -2,
		"refuses": -2,
		"refusing": -2,
		"regret": -2,
		"regretful": -2,
		"regrets": -2,
		"regretted": -2,
		"regretting": -2,
		"reigning": 1,
		"reject": -1,
		"rejected": -1,
		"rejecting": -1,
		"rejection": -2,
		"rejects": -1,
		"rejoice": 4,
		"rejoiced": 4,
		"rejoices": 4,
		"rejoicing": 4,
		"relaxed": 2,
		"relentless": -1,
		"reliability": 2,
		"reliable": 2,
		"reliably": 2,
		"reliant": 2,
		"relieve": 1,
		"relieved": 2,
		"relieves": 1,
		"relieving": 2,
		"relishing": 2,
		"remarkable": 2,
		"remorse": -2,
		"repellent": -2,
		"repercussion": -2,
		"repercussions": -2,
		"reprimand": -2,
		"reprimanded": -2,
		"reprimanding": -2,
		"reprimands": -2,
		"repulse": -1,
		"repulsed": -2,
		"repulsive": -2,
		"rescue": 2,
		"rescued": 2,
		"rescues": 2,
		"resentful": -2,
		"resign": -1,
		"resigned": -1,
		"resigning": -1,
		"resigns": -1,
		"resolute": 2,
		"resolution": 2,
		"resolve": 2,
		"resolved": 2,
		"resolves": 2,
		"resolving": 2,
		"respect": 2,
		"respected": 2,
		"respects": 2,
		"responsibility": 1,
		"responsible": 2,
		"responsive": 2,
		"restful": 2,
		"restless": -2,
		"restore": 1,
		"restored": 1,
		"restores": 1,
		"restoring": 1,
		"restrict": -2,
		"restricted": -2,
		"restricting": -2,
		"restriction": -2,
		"restrictive": -1,
		"restricts": -2,
		"retained": -1,
		"retard": -2,
		"retarded": -2,
		"retreat": -1,
		"revenge": -2,
		"revengeful": -2,
		"revered": 2,
		"revive": 2,
		"revives": 2,
		"revolting": -2,
		"reward": 2,
		"rewarded": 2,
		"rewarding": 2,
		"rewards": 2,
		"rich": 2,
		"richly": 2,
		"ridiculous": -3,
		"rig": -1,
		"rigged": -1,
		"right direction": 3,
		"righteousness": 2,
		"rightful": 2,
		"rightfully": 2,
		"rigorous": 3,
		"rigorously": 3,
		"riot": -2,
		"riots": -2,
		"rise": 1,
		"rises": 1,
		"risk": -2,
		"risks": -2,
		"risky": -2,
		"riveting": 3,
		"rob": -2,
		"robber": -2,
		"robed": -2,
		"robing": -2,
		"robs": -2,
		"robust": 2,
		"rofl": 4,
		"roflcopter": 4,
		"roflmao": 4,
		"romance": 2,
		"romantical": 2,
		"romantically": 2,
		"rose": 1,
		"rotfl": 4,
		"rotflmfao": 4,
		"rotflol": 4,
		"rotten": -3,
		"rude": -2,
		"ruin": -2,
		"ruined": -2,
		"ruining": -2,
		"ruins": -2,
		"sabotage": -2,
		"sad": -2,
		"sadden": -2,
		"saddened": -2,
		"sadly": -2,
		"safe": 1,
		"safely": 1,
		"safer": 2,
		"safety": 1,
		"salient": 1,
		"salute": 2,
		"saluted": 2,
		"salutes": 2,
		"saluting": 2,
		"salvation": 2,
		"sappy": -1,
		"sarcastic": -2,
		"satisfied": 2,
		"savange": -2,
		"savanges": -2,
		"save": 2,
		"saved": 2,
		"savings": 1,
		"scam": -2,
		"scams": -2,
		"scandal": -3,
		"scandalous": -3,
		"scandals": -3,
		"scapegoat": -2,
		"scapegoats": -2,
		"scare": -2,
		"scared": -2,
		"scar": -2,
		"scars": -2,
		"scary": -2,
		"sceptical": -2,
		"scold": -2,
		"scoop": 3,
		"scorn": -2,
		"scornful": -2,
		"scream": -2,
		"screamed": -2,
		"screaming": -2,
		"screams": -2,
		"screwed": -2,
		"screwed up": -3,
		"scum": -3,
		"scumbag": -4,
		"seamless": 2,
		"seamlessly": 2,
		"secure": 2,
		"secured": 2,
		"secures": 2,
		"sedition": -2,
		"seditious": -2,
		"seduced": -1,
		"self-abuse": -2,
		"self-confident": 2,
		"self-contradictory": -2,
		"self-deluded": -2,
		"selfish": -3,
		"selfishness": -3,
		"sentence": -2,
		"sentenced": -2,
		"sentences": -2,
		"sentencing": -2,
		"serene": 2,
		"settlement": 1,
		"settlements": 1,
		"severe": -2,
		"severely": -2,
		"sexist": -2,
		"sexistic": -2,
		"sexy": 3,
		"shaky": -2,
		"shame": -2,
		"shamed": -2,
		"shameful": -2,
		"share": 1,
		"shared": 1,
		"shares": 1,
		"shattered": -2,
		"shit": -4,
		"shithead": -4,
		"shitty": -3,
		"shock": -2,
		"shocked": -2,
		"shocking": -2,
		"shocks": -2,
		"shoody": -2,
		"shoot": -1,
		"short-sighted": -2,
		"short-sightedness": -2,
		"shortage": -2,
		"shortages": -2,
		"shrew": -4,
		"shy": -1,
		"sick": -2,
		"sickness": -2,
		"side-effect": -2,
		"side-effects": -2,
		"sigh": -2,
		"significance": 1,
		"significant": 1,
		"silencing": -1,
		"silly": -1,
		"simplicity": 1,
		"sin": -2,
		"sincere": 2,
		"sincerely": 2,
		"sincerest": 2,
		"sincerity": 2,
		"sinful": -3,
		"singleminded": -2,
		"sinister": -2,
		"sins": -2,
		"skeptic": -2,
		"skeptical": -2,
		"skepticism": -2,
		"skeptics": -2,
		"slam": -2,
		"slash": -2,
		"slashed": -2,
		"slashes": -2,
		"slashing": -2,
		"slave": -3,
		"slavery": -3,
		"slaves": -3,
		"sleeplessness": -2,
		"slick": 2,
		"slicker": 2,
		"slickest": 2,
		"slip": -1,
		"sloppy": -2,
		"sluggish": -2,
		"slumping": -1,
		"slut": -5,
		"smart": 1,
		"smarter": 2,
		"smartest": 2,
		"smear": -2,
		"smile": 2,
		"smiled": 2,
		"smiles": 2,
		"smiling": 2,
		"smog": -2,
		"smuggle": -2,
		"smuggled": -2,
		"smuggling": -2,
		"smuggles": -2,
		"sneaky": -1,
		"sneeze": -2,
		"sneezed": -2,
		"sneezes": -2,
		"sneezing": -2,
		"snub": -2,
		"snubbed": -2,
		"snubbing": -2,
		"snubs": -2,
		"sobering": 1,
		"solemn": -1,
		"solid": 2,
		"solidarity": 2,
		"solidified": 2,
		"solidifies": 2,
		"solidify": 2,
		"solidifying": 2,
		"solution": 1,
		"solutions": 1,
		"solve": 1,
		"solved": 1,
		"solves": 1,
		"solving": 1,
		"somber": -2,
		"some kind": 0,
		"son-of-a-bitch": -5,
		"soothe": 3,
		"soothed": 3,
		"soothing": 3,
		"sophisticated": 2,
		"sore": -1,
		"sorrow": -2,
		"sorrowful": -2,
		"sorry": -1,
		"spacious": 1,
		"spam": -2,
		"spammer": -3,
		"spammers": -3,
		"spamming": -2,
		"spark": 1,
		"sparkle": 3,
		"sparkles": 3,
		"sparkling": 3,
		"spearhead": 2,
		"speculative": -2,
		"spirit": 1,
		"spirited": 2,
		"spiritless": -2,
		"spiteful": -2,
		"splendid": 3,
		"spoiled": -2,
		"spoilt": -2,
		"spotless": 2,
		"sprightly": 2,
		"squander": -2,
		"squandered": -2,
		"squandering": -2,
		"squanders": -2,
		"squelched": -1,
		"stab": -2,
		"stabbed": -2,
		"stable": 2,
		"stabs": -2,
		"stall": -2,
		"stalled": -2,
		"stalling": -2,
		"stamina": 2,
		"stampede": -2,
		"stank": -2,
		"startled": -2,
		"startling": 3,
		"starve": -2,
		"starved": -2,
		"starves": -2,
		"starving": -2,
		"steadfast": 2,
		"steal": -2,
		"stealing": -2,
		"steals": -2,
		"stereotype": -2,
		"stereotyped": -2,
		"stifled": -1,
		"stimulate": 1,
		"stimulated": 1,
		"stimulates": 1,
		"stimulating": 2,
		"stingy": -2,
		"stink": -2,
		"stinked": -2,
		"stinker": -2,
		"stinking": -2,
		"stinks": -2,
		"stinky": -2,
		"stole": -2,
		"stolen": -2,
		"stop": -1,
		"stopped": -1,
		"stopping": -1,
		"stops": -1,
		"stout": 2,
		"straight": 1,
		"strange": -1,
		"strangely": -1,
		"strangled": -2,
		"strength": 2,
		"strengthen": 2,
		"strengthened": 2,
		"strengthening": 2,
		"strengthens": 2,
		"strengths": 2,
		"stress": -1,
		"stressed": -2,
		"stressor": -2,
		"stressors": -2,
		"stricken": -2,
		"strike": -1,
		"strikers": -2,
		"strikes": -1,
		"strong": 2,
		"stronger": 2,
		"strongest": 2,
		"struck": -1,
		"struggle": -2,
		"struggled": -2,
		"struggles": -2,
		"struggling": -2,
		"stubborn": -2,
		"stuck": -2,
		"stunned": -2,
		"stunning": 4,
		"stupid": -2,
		"stupidity": -3,
		"stupidly": -2,
		"suave": 2,
		"subpoena": -2,
		"substantial": 1,
		"substantially": 1,
		"subversive": -2,
		"succeed": 3,
		"succeeded": 3,
		"succeeding": 3,
		"succeeds": 3,
		"success": 2,
		"successful": 3,
		"successfully": 3,
		"suck": -3,
		"sucks": -3,
		"sue": -2,
		"sued": -2,
		"sueing": -2,
		"sues": -2,
		"suffer": -2,
		"suffered": -2,
		"sufferer": -2,
		"sufferers": -2,
		"suffering": -2,
		"suffers": -2,
		"suicidal": -2,
		"suicide": -2,
		"suicides": -2,
		"suing": -2,
		"suitable": 2,
		"suited": 2,
		"sulking": -2,
		"sulky": -2,
		"sullen": -2,
		"sunshine": 2,
		"super": 3,
		"superb": 5,
		"superior": 2,
		"support": 2,
		"supported": 2,
		"supporter": 1,
		"supporters": 1,
		"supporting": 1,
		"supportive": 2,
		"supports": 2,
		"supreme": 4,
		"survived": 2,
		"surviving": 2,
		"survivor": 2,
		"suspect": -1,
		"suspected": -1,
		"suspecting": -1,
		"suspects": -1,
		"suspend": -1,
		"suspended": -1,
		"suspicious": -2,
		"sustainability": 1,
		"sustainable": 2,
		"sustainably": 2,
		"swear": -2,
		"swearing": -2,
		"swears": -2,
		"sweet": 2,
		"sweeter": 3,
		"sweetest": 3,
		"swift": 2,
		"swiftly": 2,
		"swindle": -3,
		"swindles": -3,
		"swindling": -3,
		"sympathetic": 2,
		"sympathy": 2,
		"taint": -2,
		"tainted": -2,
		"talent": 2,
		"tard": -2,
		"tarnish": -2,
		"tarnished": -2,
		"tarnishes": -2,
		"tears": -2,
		"tender": 2,
		"tenderness": 2,
		"tense": -2,
		"tension": -1,
		"terrible": -3,
		"terribly": -3,
		"terrific": 4,
		"terrifically": 4,
		"terrified": -3,
		"terror": -3,
		"terrorist": -2,
		"terrorists": -2,
		"terrorize": -3,
		"terrorized": -3,
		"terrorizes": -3,
		"thank": 2,
		"thankful": 2,
		"thanks": 2,
		"thorny": -2,
		"thoughtful": 2,
		"thoughtless": -2,
		"threat": -2,
		"threaten": -2,
		"threatened": -2,
		"threatening": -2,
		"threatens": -2,
		"threats": -2,
		"thrilled": 5,
		"thwart": -2,
		"thwarted": -2,
		"thwarting": -2,
		"thwarts": -2,
		"timid": -2,
		"timorous": -2,
		"tired": -2,
		"tits": -2,
		"tolerance": 2,
		"tolerant": 2,
		"toothless": -2,
		"top": 2,
		"tops": 2,
		"torn": -2,
		"torture": -4,
		"tortured": -4,
		"tortures": -4,
		"torturing": -4,
		"totalitarian": -2,
		"totalitarianism": -2,
		"tout": -2,
		"touted": -2,
		"touting": -2,
		"touts": -2,
		"toxic": -3,
		"tragedies": -2,
		"tragedy": -2,
		"tragic": -2,
		"tranquil": 2,
		"transgress": -2,
		"transgressed": -2,
		"transgresses": -2,
		"transgressing": -2,
		"trap": -1,
		"trapped": -2,
		"traps": -1,
		"trauma": -3,
		"traumatic": -3,
		"travesty": -2,
		"treason": -3,
		"treasonous": -3,
		"treasure": 2,
		"treasures": 2,
		"trembling": -2,
		"tremor": -2,
		"tremors": -2,
		"tremulous": -2,
		"tribulation": -2,
		"tribute": 2,
		"tricked": -2,
		"trickery": -2,
		"triumph": 4,
		"triumphant": 4,
		"troll": -2,
		"trouble": -2,
		"troubled": -2,
		"troubles": -2,
		"troubling": -2,
		"true": 2,
		"trust": 1,
		"trusted": 2,
		"trusts": 1,
		"tumor": -2,
		"twat": -5,
		"tyran": -3,
		"tyrannic": -3,
		"tyrannical": -3,
		"tyrannically": -3,
		"tyrans": -3,
		"ubiquitous": 2,
		"ugh": -2,
		"ugliness": -3,
		"ugly": -3,
		"unable": -2,
		"unacceptable": -2,
		"unappeasable": -2,
		"unappreciated": -2,
		"unapproved": -2,
		"unattractive": -2,
		"unavailable": -1,
		"unavailing": -2,
		"unaware": -2,
		"unbearable": -2,
		"unbelievable": -1,
		"unbelieving": -1,
		"unbiased": 2,
		"uncertain": -1,
		"unclear": -1,
		"uncomfortable": -2,
		"unconcerned": -2,
		"unconfirmed": -1,
		"unconvinced": -1,
		"uncredited": -1,
		"undecided": -1,
		"undercooked": -2,
		"underestimate": -1,
		"underestimated": -1,
		"underestimates": -1,
		"underestimating": -1,
		"undermine": -2,
		"undermined": -2,
		"undermines": -2,
		"undermining": -2,
		"underperform": -2,
		"underperformed": -2,
		"underperforming": -2,
		"underperforms": -2,
		"undeserving": -2,
		"undesirable": -2,
		"uneasy": -2,
		"unemployed": -1,
		"unemployment": -2,
		"unequal": -1,
		"unequaled": 2,
		"unethical": -2,
		"uneventful": -2,
		"unfair": -2,
		"unfavorable": -2,
		"unfit": -2,
		"unfitted": -2,
		"unfocused": -2,
		"unforgivable": -3,
		"unforgiving": -2,
		"unfulfilled": -2,
		"unfunny": -2,
		"ungenerous": -2,
		"ungrateful": -3,
		"unhappy": -2,
		"unhappiness": -2,
		"unhealthy": -2,
		"unhygienic": -2,
		"unified": 1,
		"unimaginative": -2,
		"unimpressed": -2,
		"uninspired": -2,
		"unintelligent": -2,
		"unintentional": -2,
		"uninvolving": -2,
		"united": 1,
		"unjust": -2,
		"unlikely": -1,
		"unlovable": -2,
		"unloved": -2,
		"unmatched": 1,
		"unmotivated": -2,
		"unoriginal": -2,
		"unparliamentary": -2,
		"unpleasant": -2,
		"unpleasantness": -2,
		"unprofessional": -2,
		"unravel": 1,
		"unreleting": -2,
		"unresearched": -2,
		"unsafe": -2,
		"unsatisfied": -2,
		"unscientific": -2,
		"unsecured": -2,
		"unselfish": 2,
		"unsettled": -1,
		"unsold": -1,
		"unsophisticated": -2,
		"unsound": -2,
		"unstable": -2,
		"unstoppable": 2,
		"unsuccessful": -2,
		"unsuccessfully": -2,
		"unsupported": -2,
		"unsure": -1,
		"untarnished": 2,
		"untrue": -2,
		"unwanted": -2,
		"unworthy": -2,
		"uplifting": 2,
		"uproar": -3,
		"upset": -2,
		"upsets": -2,
		"upsetting": -2,
		"uptight": -2,
		"urgent": -1,
		"useful": 2,
		"usefulness": 2,
		"useless": -2,
		"uselessness": -2,
		"vague": -2,
		"validate": 1,
		"validated": 1,
		"validates": 1,
		"validating": 1,
		"vapid": -2,
		"verdict": -1,
		"verdicts": -1,
		"vested": 1,
		"vexation": -2,
		"vexing": -2,
		"vibrant": 3,
		"vicious": -2,
		"victim": -3,
		"victimization": -3,
		"victimize": -3,
		"victimized": -3,
		"victimizes": -3,
		"victimizing": -3,
		"victims": -3,
		"victor": 3,
		"victors": 3,
		"victory": 3,
		"victories": 3,
		"vigilant": 3,
		"vigor": 3,
		"vile": -3,
		"vindicate": 2,
		"vindicated": 2,
		"vindicates": 2,
		"vindicating": 2,
		"violate": -2,
		"violated": -2,
		"violates": -2,
		"violating": -2,
		"violation": -2,
		"violations": -2,
		"violence": -3,
		"violence-related": -3,
		"violent": -3,
		"violently": -3,
		"virtuous": 2,
		"virulent": -2,
		"vision": 1,
		"visionary": 3,
		"visioning": 1,
		"visions": 1,
		"vitality": 3,
		"vitamin": 1,
		"vitriolic": -3,
		"vivacious": 3,
		"vividly": 2,
		"vociferous": -1,
		"vomit": -3,
		"vomited": -3,
		"vomiting": -3,
		"vomits": -3,
		"vulnerability": -2,
		"vulnerable": -2,
		"walkout": -2,
		"walkouts": -2,
		"wanker": -3,
		"want": 1,
		"war": -2,
		"warfare": -2,
		"warm": 1,
		"warmhearted": 2,
		"warmness": 2,
		"warmth": 2,
		"warn": -2,
		"warned": -2,
		"warning": -3,
		"warnings": -3,
		"warns": -2,
		"waste": -1,
		"wasted": -2,
		"wasting": -2,
		"wavering": -1,
		"weak": -2,
		"weakened": -2,
		"weakness": -2,
		"weaknesses": -2,
		"wealth": 3,
		"wealthier": 2,
		"wealthy": 2,
		"weary": -2,
		"weep": -2,
		"weeping": -2,
		"weird": -2,
		"welcome": 2,
		"welcomed": 2,
		"welcomes": 2,
		"well-being": 2,
		"well-championed": 3,
		"well-developed": 2,
		"well-established": 2,
		"well-focused": 2,
		"well-groomed": 2,
		"well-proportioned": 2,
		"whimsical": 1,
		"whitewash": -3,
		"whore": -4,
		"wicked": -2,
		"widowed": -1,
		"willingness": 2,
		"win": 4,
		"winner": 4,
		"winning": 4,
		"wins": 4,
		"winwin": 3,
		"wisdom": 1,
		"wish": 1,
		"wishes": 1,
		"wishing": 1,
		"withdrawal": -3,
		"wits": 2,
		"woebegone": -2,
		"woeful": -3,
		"won": 3,
		"wonderful": 4,
		"wonderfully": 4,
		"woo": 3,
		"woohoo": 3,
		"wooo": 4,
		"woow": 4,
		"worn": -1,
		"worried": -3,
		"worries": -3,
		"worry": -3,
		"worrying": -3,
		"worse": -3,
		"worsen": -3,
		"worsened": -3,
		"worsening": -3,
		"worsens": -3,
		"worshiped": 3,
		"worst": -3,
		"worth": 2,
		"worthless": -2,
		"worthy": 2,
		"wow": 4,
		"wowow": 4,
		"wowww": 4,
		"wrathful": -3,
		"wreck": -2,
		"wrenching": -2,
		"wrong": -2,
		"wrongdoing": -2,
		"wrongdoings": -2,
		"wronged": -2,
		"wrongful": -2,
		"wrongfully": -2,
		"wrongly": -2,
		"wtf": -4,
		"wtff": -4,
		"wtfff": -4,
		"xo": 3,
		"xoxo": 3,
		"xoxoxo": 4,
		"xoxoxoxo": 4,
		"yeah": 1,
		"yearning": 1,
		"yeees": 2,
		"yes": 1,
		"youthful": 2,
		"yucky": -2,
		"yummy": 3,
		"zealot": -2,
		"zealots": -2,
		"zealous": 2
	};

/***/ },
/* 2297 */
/***/ function(module, exports) {

	module.exports = {
		"cant": 1,
		"can't": 1,
		"dont": 1,
		"don't": 1,
		"doesnt": 1,
		"doesn't": 1,
		"not": 1,
		"non": 1,
		"wont": 1,
		"won't": 1,
		"isnt": 1,
		"isn't": 1
	};

/***/ },
/* 2298 */
/***/ function(module, exports) {

	module.exports = {
		"children": [
			{
				"name": "analytics",
				"color": "#12939A",
				"children": [
					{
						"name": "cluster",
						"children": [
							{
								"name": "AgglomerativeCluster",
								"color": "#12939A",
								"size": 3938
							},
							{
								"name": "CommunityStructure",
								"color": "#12939A",
								"size": 3812
							},
							{
								"name": "HierarchicalCluster",
								"color": "#12939A",
								"size": 6714
							},
							{
								"name": "MergeEdge",
								"color": "#12939A",
								"size": 743
							}
						]
					},
					{
						"name": "graph",
						"children": [
							{
								"name": "BetweennessCentrality",
								"color": "#12939A",
								"size": 3534
							},
							{
								"name": "LinkDistance",
								"color": "#12939A",
								"size": 5731
							},
							{
								"name": "MaxFlowMinCut",
								"color": "#12939A",
								"size": 7840
							},
							{
								"name": "ShortestPaths",
								"color": "#12939A",
								"size": 5914
							},
							{
								"name": "SpanningTree",
								"color": "#12939A",
								"size": 3416
							}
						]
					},
					{
						"name": "optimization",
						"children": [
							{
								"name": "AspectRatioBanker",
								"color": "#12939A",
								"size": 7074
							}
						]
					}
				]
			},
			{
				"name": "animate",
				"children": [
					{
						"name": "Easing",
						"color": "#12939A",
						"size": 17010
					},
					{
						"name": "FunctionSequence",
						"color": "#12939A",
						"size": 5842
					},
					{
						"name": "interpolate",
						"children": [
							{
								"name": "ArrayInterpolator",
								"color": "#12939A",
								"size": 1983
							},
							{
								"name": "ColorInterpolator",
								"color": "#12939A",
								"size": 2047
							},
							{
								"name": "DateInterpolator",
								"color": "#12939A",
								"size": 1375
							},
							{
								"name": "Interpolator",
								"color": "#12939A",
								"size": 8746
							},
							{
								"name": "MatrixInterpolator",
								"color": "#12939A",
								"size": 2202
							},
							{
								"name": "NumberInterpolator",
								"color": "#12939A",
								"size": 1382
							},
							{
								"name": "ObjectInterpolator",
								"color": "#12939A",
								"size": 1629
							},
							{
								"name": "PointInterpolator",
								"color": "#12939A",
								"size": 1675
							},
							{
								"name": "RectangleInterpolator",
								"color": "#12939A",
								"size": 2042
							}
						]
					},
					{
						"name": "ISchedulable",
						"color": "#12939A",
						"size": 1041
					},
					{
						"name": "Parallel",
						"color": "#12939A",
						"size": 5176
					},
					{
						"name": "Pause",
						"color": "#12939A",
						"size": 449
					},
					{
						"name": "Scheduler",
						"color": "#12939A",
						"size": 5593
					},
					{
						"name": "Sequence",
						"color": "#12939A",
						"size": 5534
					},
					{
						"name": "Transition",
						"color": "#12939A",
						"size": 9201
					},
					{
						"name": "Transitioner",
						"color": "#12939A",
						"size": 19975
					},
					{
						"name": "TransitionEvent",
						"color": "#12939A",
						"size": 1116
					},
					{
						"name": "Neonate",
						"color": "#12939A",
						"size": 6006
					}
				]
			},
			{
				"name": "data",
				"children": [
					{
						"name": "converters",
						"children": [
							{
								"name": "Converters",
								"color": "#12939A",
								"size": 721
							},
							{
								"name": "DelimitedTextConverter",
								"color": "#12939A",
								"size": 4294
							},
							{
								"name": "GraphMLConverter",
								"color": "#12939A",
								"size": 9800
							},
							{
								"name": "IDataConverter",
								"color": "#12939A",
								"size": 1314
							},
							{
								"name": "JSONConverter",
								"color": "#12939A",
								"size": 2220
							}
						]
					},
					{
						"name": "DataField",
						"color": "#12939A",
						"size": 1759
					},
					{
						"name": "DataSchema",
						"color": "#12939A",
						"size": 2165
					},
					{
						"name": "DataSet",
						"color": "#12939A",
						"size": 586
					},
					{
						"name": "DataSource",
						"color": "#12939A",
						"size": 3331
					},
					{
						"name": "DataTable",
						"color": "#12939A",
						"size": 772
					},
					{
						"name": "DataUtil",
						"color": "#12939A",
						"size": 3322
					}
				]
			},
			{
				"name": "display",
				"children": [
					{
						"name": "DirtySprite",
						"color": "#12939A",
						"size": 8833
					},
					{
						"name": "LineSprite",
						"color": "#12939A",
						"size": 1732
					},
					{
						"name": "RectSprite",
						"color": "#12939A",
						"size": 3623
					},
					{
						"name": "TextSprite",
						"color": "#12939A",
						"size": 10066
					}
				]
			},
			{
				"name": "flex",
				"children": [
					{
						"name": "FlareVis",
						"color": "#12939A",
						"size": 4116
					}
				]
			},
			{
				"name": "physics",
				"children": [
					{
						"name": "DragForce",
						"color": "#12939A",
						"size": 1082
					},
					{
						"name": "GravityForce",
						"color": "#12939A",
						"size": 1336
					},
					{
						"name": "IForce",
						"color": "#12939A",
						"size": 319
					},
					{
						"name": "NBodyForce",
						"color": "#12939A",
						"size": 10498
					},
					{
						"name": "Particle",
						"color": "#12939A",
						"size": 2822
					},
					{
						"name": "Simulation",
						"color": "#12939A",
						"size": 9983
					},
					{
						"name": "Spring",
						"color": "#12939A",
						"size": 2213
					},
					{
						"name": "SpringForce",
						"color": "#12939A",
						"size": 1681
					}
				]
			},
			{
				"name": "query",
				"children": [
					{
						"name": "AggregateExpression",
						"color": "#12939A",
						"size": 1616
					},
					{
						"name": "And",
						"color": "#12939A",
						"size": 1027
					},
					{
						"name": "Arithmetic",
						"color": "#12939A",
						"size": 3891
					},
					{
						"name": "Average",
						"color": "#12939A",
						"size": 891
					},
					{
						"name": "BinaryExpression",
						"color": "#12939A",
						"size": 2893
					},
					{
						"name": "Comparison",
						"color": "#12939A",
						"size": 5103
					},
					{
						"name": "CompositeExpression",
						"color": "#12939A",
						"size": 3677
					},
					{
						"name": "Count",
						"color": "#12939A",
						"size": 781
					},
					{
						"name": "DateUtil",
						"color": "#12939A",
						"size": 4141
					},
					{
						"name": "Distinct",
						"color": "#12939A",
						"size": 933
					},
					{
						"name": "Expression",
						"color": "#12939A",
						"size": 5130
					},
					{
						"name": "ExpressionIterator",
						"color": "#12939A",
						"size": 3617
					},
					{
						"name": "Fn",
						"color": "#12939A",
						"size": 3240
					},
					{
						"name": "If",
						"color": "#12939A",
						"size": 2732
					},
					{
						"name": "IsA",
						"color": "#12939A",
						"size": 2039
					},
					{
						"name": "Literal",
						"color": "#12939A",
						"size": 1214
					},
					{
						"name": "Match",
						"color": "#12939A",
						"size": 3748
					},
					{
						"name": "Maximum",
						"color": "#12939A",
						"size": 843
					},
					{
						"name": "methods",
						"children": [
							{
								"name": "add",
								"color": "#12939A",
								"size": 593
							},
							{
								"name": "and",
								"color": "#12939A",
								"size": 330
							},
							{
								"name": "average",
								"color": "#12939A",
								"size": 287
							},
							{
								"name": "count",
								"color": "#12939A",
								"size": 277
							},
							{
								"name": "distinct",
								"color": "#12939A",
								"size": 292
							},
							{
								"name": "div",
								"color": "#12939A",
								"size": 595
							},
							{
								"name": "eq",
								"color": "#12939A",
								"size": 594
							},
							{
								"name": "fn",
								"color": "#12939A",
								"size": 460
							},
							{
								"name": "gt",
								"color": "#12939A",
								"size": 603
							},
							{
								"name": "gte",
								"color": "#12939A",
								"size": 625
							},
							{
								"name": "iff",
								"color": "#12939A",
								"size": 748
							},
							{
								"name": "isa",
								"color": "#12939A",
								"size": 461
							},
							{
								"name": "lt",
								"color": "#12939A",
								"size": 597
							},
							{
								"name": "lte",
								"color": "#12939A",
								"size": 619
							},
							{
								"name": "max",
								"color": "#12939A",
								"size": 283
							},
							{
								"name": "min",
								"color": "#12939A",
								"size": 283
							},
							{
								"name": "mod",
								"color": "#12939A",
								"size": 591
							},
							{
								"name": "mul",
								"color": "#12939A",
								"size": 603
							},
							{
								"name": "neq",
								"color": "#12939A",
								"size": 599
							},
							{
								"name": "not",
								"color": "#12939A",
								"size": 386
							},
							{
								"name": "or",
								"color": "#12939A",
								"size": 323
							},
							{
								"name": "orderby",
								"color": "#12939A",
								"size": 307
							},
							{
								"name": "range",
								"color": "#12939A",
								"size": 772
							},
							{
								"name": "select",
								"color": "#12939A",
								"size": 296
							},
							{
								"name": "stddev",
								"color": "#12939A",
								"size": 363
							},
							{
								"name": "sub",
								"color": "#12939A",
								"size": 600
							},
							{
								"name": "sum",
								"color": "#12939A",
								"size": 280
							},
							{
								"name": "update",
								"color": "#12939A",
								"size": 307
							},
							{
								"name": "variance",
								"color": "#12939A",
								"size": 335
							},
							{
								"name": "where",
								"color": "#12939A",
								"size": 299
							},
							{
								"name": "xor",
								"color": "#12939A",
								"size": 354
							},
							{
								"name": "_",
								"color": "#12939A",
								"size": 264
							}
						]
					},
					{
						"name": "Minimum",
						"color": "#12939A",
						"size": 843
					},
					{
						"name": "Not",
						"color": "#12939A",
						"size": 1554
					},
					{
						"name": "Or",
						"color": "#12939A",
						"size": 970
					},
					{
						"name": "Query",
						"color": "#12939A",
						"size": 13896
					},
					{
						"name": "Range",
						"color": "#12939A",
						"size": 1594
					},
					{
						"name": "StringUtil",
						"color": "#12939A",
						"size": 4130
					},
					{
						"name": "Sum",
						"color": "#12939A",
						"size": 791
					},
					{
						"name": "Variable",
						"color": "#12939A",
						"size": 1124
					},
					{
						"name": "Variance",
						"color": "#12939A",
						"size": 1876
					},
					{
						"name": "Xor",
						"color": "#12939A",
						"size": 1101
					}
				]
			},
			{
				"name": "scale",
				"children": [
					{
						"name": "IScaleMap",
						"color": "#FF9833",
						"size": 2105
					},
					{
						"name": "LinearScale",
						"color": "#FF9833",
						"size": 1316
					},
					{
						"name": "LogScale",
						"color": "#FF9833",
						"size": 3151
					},
					{
						"name": "OrdinalScale",
						"color": "#FF9833",
						"size": 3770
					},
					{
						"name": "QuantileScale",
						"color": "#1A3177",
						"size": 2435
					},
					{
						"name": "QuantitativeScale",
						"color": "#FF9833",
						"size": 4839
					},
					{
						"name": "RootScale",
						"color": "#FF9833",
						"size": 1756
					},
					{
						"name": "Scale",
						"color": "#FF9833",
						"size": 4268
					},
					{
						"name": "ScaleType",
						"color": "#FF9833",
						"size": 1821
					},
					{
						"name": "TimeScale",
						"color": "#FF9833",
						"size": 5833
					}
				]
			},
			{
				"name": "util",
				"children": [
					{
						"name": "Arrays",
						"color": "#12939A",
						"size": 8258
					},
					{
						"name": "Colors",
						"color": "#12939A",
						"size": 10001
					},
					{
						"name": "Dates",
						"color": "#12939A",
						"size": 8217
					},
					{
						"name": "Displays",
						"color": "#12939A",
						"size": 12555
					},
					{
						"name": "Filter",
						"color": "#12939A",
						"size": 2324
					},
					{
						"name": "Geometry",
						"color": "#12939A",
						"size": 10993
					},
					{
						"name": "heap",
						"children": [
							{
								"name": "FibonacciHeap",
								"color": "#12939A",
								"size": 9354
							},
							{
								"name": "HeapNode",
								"color": "#12939A",
								"size": 1233
							}
						]
					},
					{
						"name": "IEvaluable",
						"color": "#12939A",
						"size": 335
					},
					{
						"name": "IPredicate",
						"color": "#12939A",
						"size": 383
					},
					{
						"name": "IValueProxy",
						"color": "#12939A",
						"size": 874
					},
					{
						"name": "math",
						"children": [
							{
								"name": "DenseMatrix",
								"color": "#12939A",
								"size": 3165
							},
							{
								"name": "IMatrix",
								"color": "#12939A",
								"size": 2815
							},
							{
								"name": "SparseMatrix",
								"color": "#12939A",
								"size": 3366
							}
						]
					},
					{
						"name": "Maths",
						"color": "#12939A",
						"size": 17705
					},
					{
						"name": "Orientation",
						"color": "#12939A",
						"size": 1486
					},
					{
						"name": "palette",
						"children": [
							{
								"name": "ColorPalette",
								"color": "#12939A",
								"size": 6367
							},
							{
								"name": "Palette",
								"color": "#12939A",
								"size": 1229
							},
							{
								"name": "ShapePalette",
								"color": "#12939A",
								"size": 2059
							},
							{
								"name": "SizePalette",
								"color": "#12939A",
								"size": 2291
							}
						]
					},
					{
						"name": "Property",
						"color": "#12939A",
						"size": 5559
					},
					{
						"name": "Shapes",
						"color": "#12939A",
						"size": 19118
					},
					{
						"name": "Sort",
						"color": "#12939A",
						"size": 6887
					},
					{
						"name": "Stats",
						"color": "#12939A",
						"size": 6557
					},
					{
						"name": "Strings",
						"color": "#12939A",
						"size": 22026
					}
				]
			},
			{
				"name": "vis",
				"children": [
					{
						"name": "axis",
						"children": [
							{
								"name": "Axes",
								"color": "#12939A",
								"size": 1302
							},
							{
								"name": "Axis",
								"color": "#12939A",
								"size": 24593
							},
							{
								"name": "AxisGridLine",
								"color": "#12939A",
								"size": 652
							},
							{
								"name": "AxisLabel",
								"color": "#12939A",
								"size": 636
							},
							{
								"name": "CartesianAxes",
								"color": "#12939A",
								"size": 6703
							}
						]
					},
					{
						"name": "controls",
						"children": [
							{
								"name": "AnchorControl",
								"color": "#12939A",
								"size": 2138
							},
							{
								"name": "ClickControl",
								"color": "#12939A",
								"size": 3824
							},
							{
								"name": "Control",
								"color": "#12939A",
								"size": 1353
							},
							{
								"name": "ControlList",
								"color": "#12939A",
								"size": 4665
							},
							{
								"name": "DragControl",
								"color": "#12939A",
								"size": 2649
							},
							{
								"name": "ExpandControl",
								"color": "#12939A",
								"size": 2832
							},
							{
								"name": "HoverControl",
								"color": "#12939A",
								"size": 4896
							},
							{
								"name": "IControl",
								"color": "#12939A",
								"size": 763
							},
							{
								"name": "PanZoomControl",
								"color": "#12939A",
								"size": 5222
							},
							{
								"name": "SelectionControl",
								"color": "#12939A",
								"size": 7862
							},
							{
								"name": "TooltipControl",
								"color": "#12939A",
								"size": 8435
							}
						]
					},
					{
						"name": "data",
						"children": [
							{
								"name": "Data",
								"color": "#12939A",
								"size": 20544
							},
							{
								"name": "DataList",
								"color": "#12939A",
								"size": 19788
							},
							{
								"name": "DataSprite",
								"color": "#12939A",
								"size": 10349
							},
							{
								"name": "EdgeSprite",
								"color": "#12939A",
								"size": 3301
							},
							{
								"name": "NodeSprite",
								"color": "#12939A",
								"size": 19382
							},
							{
								"name": "render",
								"children": [
									{
										"name": "ArrowType",
										"color": "#12939A",
										"size": 698
									},
									{
										"name": "EdgeRenderer",
										"color": "#12939A",
										"size": 5569
									},
									{
										"name": "IRenderer",
										"color": "#12939A",
										"size": 353
									},
									{
										"name": "ShapeRenderer",
										"color": "#12939A",
										"size": 2247
									}
								]
							},
							{
								"name": "ScaleBinding",
								"color": "#12939A",
								"size": 11275
							},
							{
								"name": "Tree",
								"color": "#12939A",
								"size": 7147
							},
							{
								"name": "TreeBuilder",
								"color": "#12939A",
								"size": 9930
							}
						]
					},
					{
						"name": "events",
						"children": [
							{
								"name": "DataEvent",
								"color": "#12939A",
								"size": 2313
							},
							{
								"name": "SelectionEvent",
								"color": "#12939A",
								"size": 1880
							},
							{
								"name": "TooltipEvent",
								"color": "#12939A",
								"size": 1701
							},
							{
								"name": "VisualizationEvent",
								"color": "#12939A",
								"size": 1117
							}
						]
					},
					{
						"name": "legend",
						"children": [
							{
								"name": "Legend",
								"color": "#12939A",
								"size": 20859
							},
							{
								"name": "LegendItem",
								"color": "#12939A",
								"size": 4614
							},
							{
								"name": "LegendRange",
								"color": "#12939A",
								"size": 10530
							}
						]
					},
					{
						"name": "operator",
						"children": [
							{
								"name": "distortion",
								"children": [
									{
										"name": "BifocalDistortion",
										"color": "#12939A",
										"size": 4461
									},
									{
										"name": "Distortion",
										"color": "#12939A",
										"size": 6314
									},
									{
										"name": "FisheyeDistortion",
										"color": "#12939A",
										"size": 3444
									}
								]
							},
							{
								"name": "encoder",
								"children": [
									{
										"name": "ColorEncoder",
										"color": "#12939A",
										"size": 3179
									},
									{
										"name": "Encoder",
										"color": "#12939A",
										"size": 4060
									},
									{
										"name": "PropertyEncoder",
										"color": "#12939A",
										"size": 4138
									},
									{
										"name": "ShapeEncoder",
										"color": "#12939A",
										"size": 1690
									},
									{
										"name": "SizeEncoder",
										"color": "#12939A",
										"size": 1830
									}
								]
							},
							{
								"name": "filter",
								"children": [
									{
										"name": "FisheyeTreeFilter",
										"color": "#12939A",
										"size": 5219
									},
									{
										"name": "GraphDistanceFilter",
										"color": "#12939A",
										"size": 3165
									},
									{
										"name": "VisibilityFilter",
										"color": "#12939A",
										"size": 3509
									}
								]
							},
							{
								"name": "IOperator",
								"color": "#12939A",
								"size": 1286
							},
							{
								"name": "label",
								"children": [
									{
										"name": "Labeler",
										"color": "#12939A",
										"size": 9956
									},
									{
										"name": "RadialLabeler",
										"color": "#12939A",
										"size": 3899
									},
									{
										"name": "StackedAreaLabeler",
										"color": "#12939A",
										"size": 3202
									}
								]
							},
							{
								"name": "layout",
								"children": [
									{
										"name": "AxisLayout",
										"color": "#12939A",
										"size": 6725
									},
									{
										"name": "BundledEdgeRouter",
										"color": "#12939A",
										"size": 3727
									},
									{
										"name": "CircleLayout",
										"color": "#12939A",
										"size": 9317
									},
									{
										"name": "CirclePackingLayout",
										"color": "#12939A",
										"size": 12003
									},
									{
										"name": "DendrogramLayout",
										"color": "#12939A",
										"size": 4853
									},
									{
										"name": "ForceDirectedLayout",
										"color": "#12939A",
										"size": 8411
									},
									{
										"name": "IcicleTreeLayout",
										"color": "#12939A",
										"size": 4864
									},
									{
										"name": "IndentedTreeLayout",
										"color": "#12939A",
										"size": 3174
									},
									{
										"name": "Layout",
										"color": "#12939A",
										"size": 7881
									},
									{
										"name": "NodeLinkTreeLayout",
										"color": "#12939A",
										"size": 12870
									},
									{
										"name": "PieLayout",
										"color": "#12939A",
										"size": 2728
									},
									{
										"name": "RadialTreeLayout",
										"color": "#12939A",
										"size": 12348
									},
									{
										"name": "RandomLayout",
										"color": "#12939A",
										"size": 870
									},
									{
										"name": "StackedAreaLayout",
										"color": "#12939A",
										"size": 9121
									},
									{
										"name": "TreeMapLayout",
										"color": "#12939A",
										"size": 9191
									}
								]
							},
							{
								"name": "Operator",
								"color": "#12939A",
								"size": 2490
							},
							{
								"name": "OperatorList",
								"color": "#12939A",
								"size": 5248
							},
							{
								"name": "OperatorSequence",
								"color": "#12939A",
								"size": 4190
							},
							{
								"name": "OperatorSwitch",
								"color": "#12939A",
								"size": 2581
							},
							{
								"name": "SortOperator",
								"color": "#12939A",
								"size": 2023
							}
						]
					},
					{
						"name": "Visualization",
						"color": "#12939A",
						"size": 16540
					}
				]
			}
		]
	};

/***/ },
/* 2299 */
/***/ function(module, exports) {

	module.exports = {
		"sidebar.email": "البريد الإلكتروني",
		"sidebar.ecommerce": "التجارة الإلكترونية",
		"sidebar.shop": "متجر",
		"sidebar.cart": "عربة التسوق",
		"sidebar.checkout": "الدفع",
		"sidebar.cards": "بطاقات",
		"sidebar.maps": "خرائط",
		"sidebar.googleMap": "خرائط جوجل",
		"sidebar.leafletMap": "خريطة النشرة",
		"sidebar.calendar": "التقويم",
		"sidebar.notes": "ملاحظات",
		"sidebar.todos": "تودوس",
		"sidebar.contacts": "جهات الاتصال",
		"sidebar.shuffle": "خلط",
		"sidebar.charts": "الرسوم البيانية",
		"sidebar.googleCharts": "عربات غوغل",
		"sidebar.recharts": "Recharts",
		"sidebar.reactVis": "رد فيس",
		"sidebar.reactChart2": "الرد-مخطط-2",
		"sidebar.reactTrend": "الرد-تريند",
		"sidebar.eChart": "Echart",
		"sidebar.forms": "إستمارات",
		"sidebar.input": "إدخال",
		"sidebar.editor": "محرر",
		"sidebar.formsWithValidation": "نماذج مع التحقق من الصحة",
		"sidebar.progress": "تقدم",
		"sidebar.button": "زر",
		"sidebar.tab": "التبويب",
		"sidebar.checkbox": "مربع",
		"sidebar.radiobox": "Radiobox",
		"sidebar.transfer": "تحويل",
		"sidebar.autocomplete": "الإكمال التلقائي",
		"sidebar.boxOptions": "خيارات مربع",
		"sidebar.uiElements": "عناصر واجهة المستخدم",
		"sidebar.badge": "شارة",
		"sidebar.card2": "بطاقة",
		"sidebar.corusel": "إحتفال صاخب مخمور",
		"sidebar.collapse": "انهدام",
		"sidebar.popover": "البوب",
		"sidebar.tooltip": "تلميح",
		"sidebar.tag": "بطاقة",
		"sidebar.timeline": "الجدول الزمني",
		"sidebar.dropdown": "اسقاط",
		"sidebar.pagination": "ترقيم الصفحات",
		"sidebar.rating": "تقييم",
		"sidebar.tree": "شجرة",
		"sidebar.advancedElements": "العناصر المتقدمة",
		"sidebar.reactDates": "تواريخ الاستجابة",
		"sidebar.codeMirror": "كود مرآة",
		"sidebar.uppy": "وبي رافع",
		"sidebar.dropzone": "إسقاط المنطقة",
		"sidebar.feedback": "ردود الفعل",
		"sidebar.alert": "محزر",
		"sidebar.modal": "شكلي",
		"sidebar.message": "رسالة",
		"sidebar.notification": "إعلام",
		"sidebar.popConfirm": "تأكيد البوب",
		"sidebar.spin": "غزل",
		"sidebar.tables": "الجداول",
		"sidebar.antTables": "جداول النمل",
		"sidebar.pages": "صفحات",
		"sidebar.500": "500",
		"sidebar.404": "404",
		"sidebar.signIn": "تسجيل الدخول",
		"sidebar.signUp": "سجل",
		"sidebar.forgotPw": "نسيت كلمات المرور",
		"sidebar.resetPw": "إعادة تعيين كلمات المرور",
		"sidebar.invoice": "فاتورة",
		"sidebar.menuLevels": "مستويات القائمة",
		"sidebar.item1": "البند 1",
		"sidebar.item2": "البند 2",
		"sidebar.option1": "الخيار 1",
		"sidebar.option2": "الخيار 2",
		"sidebar.option3": "الخيار 3",
		"sidebar.option4": "الخيار 4",
		"sidebar.blankPage": "صفحة فارغة",
		"sidebar.githubSearch": "جيثب البحث",
		"sidebar.youtubeSearch": "بحث يوتيوب",
		"languageSwitcher.label": "غير اللغة",
		"themeSwitcher": "موضوع الجلاد",
		"themeSwitcher.Sidebar": "الشريط الجانبي",
		"themeSwitcher.Topbar": "Topbar",
		"themeSwitcher.Background": "خلفية",
		"feedback.alert.basicTitle": "العنوان الأساسي",
		"feedback.alert.successText": "نص النجاح",
		"feedback.alert.infoText": "نص المعلومات",
		"feedback.alert.warningText": "نص التحذير",
		"feedback.alert.errorText": "نص خطأ",
		"feedback.alert.closableAlertType": "نوع التنبيه القابل للإغلاق",
		"feedback.alert.iconAlertType": "رمز نوع التنبيه",
		"feedback.alert.iconInfoAlertType": "رمز معلومات نوع التنبيه",
		"feedback.alert.successTips": "نصائح النجاح",
		"feedback.alert.successTipsDescription": "وصف مفصل ونصائح حول الكتابة الناجحة.",
		"feedback.alert.informationTips": "ملاحظات إعلامية",
		"feedback.alert.informationDescription": "وصف إضافي ومعلومات حول كتابة النصوص.",
		"feedback.alert.warningTips": "تحذير",
		"feedback.alert.warningDescription": "هذا إشعار تحذير حول كتابة النصوص.",
		"feedback.alert.errorTips": "خطأ",
		"feedback.alert.errorDescription": "هذه رسالة خطأ حول كتابة النصوص.",
		"feedback.alert.modalTitle": "مشروط واحد مع تخصيص تذييل الصفحة",
		"feedback.alert.modalSubTitle": "مربع حوار أساسي مشروط.",
		"feedback.alert.successTitle": "نجاح",
		"feedback.alert.infoTitle": "معلومات",
		"feedback.alert.errorTitle": "خطأ",
		"feedback.alert.warningTitle": "تحذير",
		"feedback.alert.modalBlockTitle": "شكلي",
		"feedback.alert.confirmationModalDialogue": "حوار مشروط التأكيد",
		"feedback.alert.simpleModalDialogue": "حوار مشروط بسيط",
		"feedback.alert.message": "رسالة",
		"feedback.alert.normalMessageTitle": "رسالة عادية",
		"feedback.alert.normalMessageSubtitle": "الرسائل العادية كتعليقات.",
		"feedback.alert.displayMessage": "عرض الرسالة العادية",
		"feedback.alert.displayOtherTypeMessageTitle": "أنواع أخرى من الرسائل",
		"feedback.alert.displayOtherTypeMessageSubTitle": "رسائل النجاح وأنواع الأخطاء والإنذارات.",
		"feedback.alert.customizeDurationTitle": "تخصيص المدة",
		"feedback.alert.customizeDurationSubTitle": "أوستميز مدة عرض الرسالة من الافتراضي 1.5s إلى 10s.",
		"feedback.alert.customizeDurationButton": "تخصيص مدة العرض",
		"feedback.alert.messageLoadingTitle": "رسالة التحميل",
		"feedback.alert.messageLoadingSubTitle": "عرض مؤشر تحميل عالمي، يتم رفضه في حد ذاته بشكل غير متزامن.",
		"feedback.alert.displayLoadIndicator": "عرض مؤشر التحميل",
		"feedback.alert.notification": "إعلام",
		"feedback.alert.notificationBasicTitle": "الأساسية",
		"feedback.alert.notificationBasicSubTitle": "أبسط الاستخدام الذي يغلق مربع الإعلام بعد 4.5S.",
		"feedback.alert.notificationBasicDescription": "افتح مربع الإشعارات",
		"feedback.alert.notificationDurationTitle": "المدة التي يتم بعدها إغلاق مربع الإشعارات",
		"feedback.alert.notificationDurationSubTitle": "يمكن استخدام المدة لتحديد المدة التي يبقى فيها الإشعار مفتوحا. بعد انقضاء المدة الزمنية، يتم إغلاق الإشعار تلقائيا. إذا لم يتم تحديد القيمة الافتراضية هي 4.5 ثانية. إذا قمت بتعيين القيمة إلى 0، لن يتم إغلاق مربع الإشعار تلقائيا تلقائيا.",
		"feedback.alert.notificationwithIconTitle": "إعلام مع رمز",
		"feedback.alert.notificationwithIconSubTitle": "مربع إعلام مع رمز على الجانب الأيسر.",
		"feedback.alert.notificationwithCustomIconTitle": "إعلام مع رمز مخصص",
		"feedback.alert.notificationwithCustomIconSubTitle": "الرسائل العادية كتعليقات.",
		"feedback.alert.notificationwithCustomButtonTitle": "إعلام مع زر مخصص",
		"feedback.alert.notificationwithCustomButtonSubTitle": "الرسائل العادية كتعليقات.",
		"feedback.alert.popConfirm": "تأكيد البوب",
		"feedback.alert.popConfirm.basicTitle": "تأكيد أساسي",
		"feedback.alert.popConfirm.basicSubTitle": "المثال الأساسي.",
		"feedback.alert.popConfirm.delete": "حذف",
		"feedback.alert.popConfirm.notiWithIconTitle": "إعلام مع رمز مخصص",
		"feedback.alert.popConfirm.notiWithIconSubTitle": "الرسائل العادية كتعليقات.",
		"feedback.alert.popConfirm.TL": "TL",
		"feedback.alert.popConfirm.top": "أعلى",
		"feedback.alert.popConfirm.TR": "TR",
		"feedback.alert.popConfirm.LT": "LT",
		"feedback.alert.popConfirm.left": "اليسار",
		"feedback.alert.popConfirm.LB": "رطل",
		"feedback.alert.popConfirm.RT": "RT",
		"feedback.alert.popConfirm.right": "حق",
		"feedback.alert.popConfirm.RB": "RB",
		"feedback.alert.popConfirm.Bl": "BL",
		"feedback.alert.popConfirm.bottom": "الأسفل",
		"feedback.alert.popConfirm.BR": "BR",
		"feedback.alert.spin": "غزل",
		"feedback.alert.spin.basicTitle": "حجم تدور",
		"feedback.alert.spin.background": "تدور مع الخلفية",
		"feedback.alert.spin.backgroundDescription": "تدور مع وصف الخلفية",
		"feedback.alert.spin.loadingState": "تحميل الدولة",
		"feedback.alert.spin.alertTitle": "عنوان رسالة التنبيه",
		"feedback.alert.spin.alertDescription": "مزيد من التفاصيل حول سياق هذا التنبيه.",
		"forms.input.header": "إدخال",
		"forms.input.basicTitle": "الاستخدام الأساسي",
		"forms.input.basicSubTitle": "مثال الاستخدام الأساسي.",
		"forms.input.variationsTitle": "ثلاثة أحجام من الإدخال",
		"forms.input.variationsSubtitle": "هناك ثلاثة أحجام من مربع الإدخال  كبير (42px  ، الافتراضي (35px   والصغيرة (30px  . ملاحظة  داخل النماذج، يتم استخدام الحجم الكبير فقط.",
		"forms.input.groupTitle": "مجموعة الإدخال",
		"forms.input.groupSubTitle": "الإدخال. مثال المجموعة ملاحظة  أنت لا تحتاج كول للتحكم في العرض في الوضع المضغوط.",
		"forms.input.autoSizingTitle": "يمكنك ضبط مستوى الارتفاع لتتناسب مع المحتوى",
		"forms.input.autoSizingSubTitle": "أوتوسيزي دعامة لنوع تكستاريا من المدخلات يجعل ارتفاع لضبط تلقائيا استنادا إلى المحتوى. يمكن توفير كائن خيارات ل أوتوسيزي لتحديد الحد الأدنى والحد الأقصى لعدد الخطوط التي سوف تكستاريا ضبط تلقائيا.",
		"forms.input.prePostTabTitle": "علامة التبويب ما قبل    المشاركة",
		"forms.input.prePostTabSubTitle": "استخدام بري & أمب؛ نموذج علامات تبويب المشاركات ..",
		"forms.input.textAreaTitle": "ناحية النص",
		"forms.input.textAreaSubTitle": "بالنسبة لحالات إدخال المستخدم متعدد الخطوط، يمكن استخدام المدخلات التي لها قيمة دعامة قيمة تكستاريا.",
		"forms.input.searchTitle": "بحث",
		"forms.input.searchSubTitle": "مثال لإنشاء مربع بحث عن طريق تجميع إدخال قياسي باستخدام زر بحث",
		"forms.editor.header": "محرر",
		"forms.formsWithValidation.header": "نموذج التحقق المخصص",
		"forms.formsWithValidation.failLabel": "فشل",
		"forms.formsWithValidation.failHelp": "يجب أن يكون مزيج من الأرقام & أمب؛ الحروف الهجائية",
		"forms.formsWithValidation.warningLabel": "تحذير",
		"forms.formsWithValidation.ValidatingLabel": "التحقق من صحة",
		"forms.formsWithValidation.ValidatingHelp": "جار التحقق من صحة المعلومات ...",
		"forms.formsWithValidation.SuccessLabel": "نجاح",
		"forms.formsWithValidation.WarninghasFeedbackLabel": "تحذير",
		"forms.formsWithValidation.FailhasFeedbackLabel": "فشل",
		"forms.formsWithValidation.FailhasFeedbackHelp": "يجب أن يكون مزيج من الأرقام & أمب؛ الحروف الهجائية",
		"forms.progressBar.header": "شريط التقدم",
		"forms.progressBar.standardTitle": "شريط التقدم",
		"forms.progressBar.standardSubTitle": "شريط تقدم قياسي.",
		"forms.progressBar.circularTitle": "شريط التقدم الدائري",
		"forms.progressBar.circularSubTitle": "شريط تقدم دائري.",
		"forms.progressBar.miniTitle": "ميني حجم شريط التقدم",
		"forms.progressBar.miniSubTitle": "مناسبة لمنطقة ضيقة.",
		"forms.progressBar.miniCircularTitle": "شريط تقدم دائري أصغر.",
		"forms.progressBar.dynamicCircularTitle": "ديناميكية شريط التقدم دائرية",
		"forms.progressBar.dynamicCircularSubTitle": "شريط التقدم الديناميكي هو أفضل.",
		"forms.progressBar.customTextTitle": "تنسيق نص مخصص",
		"forms.progressBar.customTextSubTitle": "يمكنك تنسيق النص المخصص عن طريق وضع التنسيق.",
		"forms.progressBar.dashboardTitle": "لوحة القيادة",
		"forms.progressBar.dashboardSubTitle": "نمط لوحة القيادة للتقدم.",
		"forms.button.header": "وصفت",
		"forms.button.simpleButton": "نوع الزر",
		"forms.button.iconButton": "رمز الزر",
		"forms.button.simpleButtonPrimaryText": "ابتدائي",
		"forms.button.simpleButtonDefaultText": "افتراضي",
		"forms.button.simpleButtonDashedText": "متقطع",
		"forms.button.simpleButtonDangerText": "خطر",
		"forms.button.iconPrimaryButton": "بحث",
		"forms.button.iconSimpleButton": "بحث",
		"forms.button.iconCirculerButton": "بحث",
		"forms.button.iconDashedButton": "بحث",
		"forms.button.SizedButton": "حجم الزر",
		"forms.button.DisabledButton": "تم تعطيل الزر",
		"forms.button.LoadingButton": "زر التحميل",
		"forms.button.MultipleButton": "زر متعددة",
		"forms.button.groupButton": "زر المجموعة",
		"forms.Tabs.header": "علامات التبويب",
		"forms.Tabs.simpleTabTitle": "بحث",
		"forms.Tabs.simpleTabSubTitle": "تم تعطيل علامات التبويب",
		"forms.Tabs.iconTabTitle": "أيقونة علامات التبويب",
		"forms.Tabs.miniTabTitle": "ميني علامات التبويب",
		"forms.Tabs.extraTabTitle": "علامات تبويب إضافية للعمل",
		"forms.Tabs.TabpositionTitle": "موضع",
		"forms.Tabs.TabpositionSubTitle": "موضع علامات التبويب  يسار أو يمين أو أعلى أو أسفل",
		"forms.Tabs.cardTitle": "نوع بطاقة علامات التبويب",
		"forms.Tabs.editableTitle": "إضافة علامات التبويب وإغلاقها",
		"forms.Tabs.verticalTitle": "عمودي نوع علامات التبويب",
		"forms.Tabs.basicTitle": "علامات التبويب الأساسية",
		"forms.checkbox.header": "مربع",
		"forms.checkbox.basicTitle": "مربع الاختيار الأساسي",
		"forms.checkbox.basicSubTitle": "الاستخدام الأساسي لخانة الاختيار.",
		"forms.checkbox.groupTitle": "مربع الاختيار",
		"forms.checkbox.groupSubTitle": "إنشاء مجموعة من مربعات الاختيار من صفيف. استخدم تعطيل لتعطيل مربع اختيار.",
		"forms.checkbox.groupCheckTitle": "مربع الاختيار",
		"forms.checkbox.groupCheckSubTitle": "إنشاء مجموعة من مربعات الاختيار من صفيف. استخدم تعطيل لتعطيل مربع اختيار.",
		"forms.radio.header": "راديو",
		"forms.radio.simpleTitle": "الراديو الأساسي",
		"forms.radio.simpleSubTitle": "أبسط استخدام. استخدام تعطيل لتعطيل الراديو.",
		"forms.radio.groupTitle": "عمودي راديوغروب",
		"forms.radio.groupSubTitle": "عمودي راديوغروب، مع المزيد من أجهزة الراديو.",
		"forms.radio.groupSecondTitle": "RadioGroup",
		"forms.radio.groupSecondSubTitle": "مجموعة من مكونات الراديو.",
		"forms.radio.groupThirdTitle": "RadioGroup",
		"forms.radio.groupThirdSubTitle": "مجموعة من مكونات الراديو.",
		"forms.transfer.header": "تحويل",
		"forms.transfer.SubTitle": "نقل مع مربع البحث.",
		"forms.transfer.Title": "بحث",
		"forms.autocomplete.header": "الإكمال التلقائي",
		"forms.autocomplete.simpleTitle": "حسب الطلب",
		"forms.autocomplete.simpleSubTitle": "هل يمكن أن تمر AutoComplete.Option كأطفال الإكمال التلقائي، بدلا من استخدام داتسورس",
		"forms.autocomplete.customizeTitle": "تخصيص مكون الإدخال",
		"forms.autocomplete.customizeSubTitle": "تخصيص مكون الإدخال",
		"uiElements.badge.badge": "شارة",
		"uiElements.badge.basicExample": "مثال أساسي",
		"uiElements.badge.basicExampleSubTitle": "أبسط الاستخدام. سيتم إخفاء شارة عندما العد هو 0، ولكن يمكننا استخدام شوزيرو لإظهار ذلك.",
		"uiElements.badge.overflowCount": "تجاوز عدد",
		"uiElements.badge.overflowCountSubTitle": "يتم عرض أوفيرفلوكونت عندما يكون عدد أكبر من أوفيرفلوكونت. القيمة الافتراضية ل أوفيرفلوكونت هي 99.",
		"uiElements.badge.status": "الحالة",
		"uiElements.badge.statusSubTitle": "شارة مستقلة مع الوضع.",
		"uiElements.badge.success": "نجاح",
		"uiElements.badge.error": "خطأ",
		"uiElements.badge.default": "افتراضي",
		"uiElements.badge.processing": "معالجة",
		"uiElements.badge.warning": "تحذير",
		"uiElements.badge.redBadge": "شارة حمراء",
		"uiElements.badge.redBadgeSubTitle": "وهذا ببساطة عرض شارة حمراء، دون عدد معين.",
		"uiElements.badge.linkSomething": "ربط شيء",
		"uiElements.cards.cards": "بطاقات",
		"uiElements.cards.basicCard": "بطاقة أساسية",
		"uiElements.cards.basicCardSubTitle": "بطاقة أساسية تحتوي على عنوان ومحتوى ومحتوى زاوية إضافي.",
		"uiElements.cards.more": "أكثر من",
		"uiElements.cards.cardTitle": "عنوان البطاقة",
		"uiElements.cards.cardContent": "محتوى البطاقة",
		"uiElements.cards.lorem": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور إنسيدونت أوت لابور إت دولور ماغنا أليكوا. أوت إنيم أد مينيم فينيام، كويس نوسترود إكسيرسيساتيون أولامكو لابوريس نيسي أوت أليكيب إكس إي كومودو ثوسكات.",
		"uiElements.cards.noBorder": "ليس لها حدود",
		"uiElements.cards.noBorderSubTitle": "بطاقة بلا حدود على خلفية رمادية.",
		"uiElements.cards.gridCard": "بطاقة الشبكة",
		"uiElements.cards.gridCardSubTitle": "بطاقات عادة ما تتعاون مع تخطيط الشبكة في صفحة نظرة عامة.",
		"uiElements.cards.loadingCard": "تحميل البطاقة",
		"uiElements.cards.loadingCardSubTitle": "لعرض مؤشر التحميل أثناء جلب محتويات البطاقة.",
		"uiElements.cards.whateverContent": "أيا كان المحتوى",
		"uiElements.cards.customizedContentTitle": "محتوى مخصص",
		"uiElements.cards.customizedContent": "لعرض مؤشر التحميل أثناء جلب محتويات البطاقة.",
		"uiElements.cards.europeStreetBeat": "فاز شارع أوروبا",
		"uiElements.cards.instagram": "www.instagram.com",
		"uiElements.carousel.carousel": "إحتفال صاخب مخمور",
		"uiElements.carousel.verticalCarousel": "دائري عمودي",
		"uiElements.carousel.verticalCarouselSubTitle": "ترقيم الصفحات الرأسي. استخدم   فرتيكال = ترو",
		"uiElements.carousel.basicCarousel": "دائري الأساسي",
		"uiElements.carousel.basicCarouselSubTitle": "الاستخدام الأساسي",
		"uiElements.carousel.fadeInTransition": "تتلاشى في الانتقال",
		"uiElements.carousel.fadeInTransitionSubTitle": "الشرائح استخدام تتلاشى للانتقال.   تأثير = تتلاشى",
		"uiElements.carousel.scrollAutomatically": "مرر تلقائيا",
		"uiElements.carousel.scrollAutomaticallySubTitle": "توقيت التمرير إلى بطاقة المقبل    الصورة. تشغيل تلقائي",
		"uiElements.collapse.collapse": "انهدام",
		"uiElements.collapse.collapseSubTitle": "يمكن توسيع أكثر من لوحة واحدة في وقت واحد، يتم تهيئة اللوحة الأولى لتكون نشطة في هذه الحالة. وس   ديفولتاكتيفيكي =   [كينوم]",
		"uiElements.collapse.text": "الكلب هو نوع من الحيوانات المستأنسة. المعروفة عن ولائها والإخلاص، ويمكن العثور عليها كضيف ترحيب في العديد من الأسر في جميع أنحاء العالم.",
		"uiElements.collapse.headerOne": "هذا هو رأس اللوحة 1",
		"uiElements.collapse.headerTwo": "هذا هو رأس اللوحة 2",
		"uiElements.collapse.headerThree": "هذا هو رأس اللوحة 3",
		"uiElements.collapse.headerNested": "هذا هو لوحة لوحة العش",
		"uiElements.collapse.nestedExample": "مثال متداخل",
		"uiElements.collapse.nestedExampleSubTitle": "يتم دمج كولابس داخل كولابس.",
		"uiElements.collapse.borderlessExample": "مثال بلا حدود",
		"uiElements.collapse.borderlessExampleSubTitle": "نمط بلا حدود من كولابس. استخدم   بوردرد =   فالس",
		"uiElements.collapse.accordion": "أكورديون",
		"uiElements.collapse.accordionSubTitle": "وضع الأكورديون، لوحة واحدة فقط يمكن توسيعها في وقت واحد. سيتم توسيع اللوحة الأولى بشكل افتراضي. استخدام الأكورديون",
		"uiElements.popover.popover": "البوب",
		"uiElements.popover.basicExample": "مثال أساسي",
		"uiElements.popover.basicExampleSubTitle": "أبسط مثال. حجم طبقة عائمة يعتمد على محتويات المنطقة.",
		"uiElements.popover.hoverMe": "مرر لي",
		"uiElements.popover.title": "عنوان",
		"uiElements.popover.titleTrigger": "ثلاث طرق لتحريك",
		"uiElements.popover.titleTriggerSubTitle": "الماوس فوق، والتركيز والتحرك في.",
		"uiElements.popover.focusMe": "ركزني",
		"uiElements.popover.clickMe": "انقر فوق لي",
		"uiElements.popover.placement": "تحديد مستوى",
		"uiElements.popover.placementSubTitle": "تتوفر 12 خيارا للمواضع.",
		"uiElements.popover.top": "أعلى",
		"uiElements.popover.topLeft": "أعلى اليسار",
		"uiElements.popover.topRight": "اعلى اليمين",
		"uiElements.popover.leftTop": "أعلى اليسار",
		"uiElements.popover.left": "اليسار",
		"uiElements.popover.leftBottom": "أسفل اليسار",
		"uiElements.popover.rightTop": "أعلى اليمين",
		"uiElements.popover.right": "حق",
		"uiElements.popover.bottom": "الأسفل",
		"uiElements.popover.bottomLeft": "أسفل اليسار",
		"uiElements.popover.bottomRight": "أسفل يمين",
		"uiElements.popover.boxTitle": "التحكم في إغلاق مربع الحوار",
		"uiElements.popover.boxSubTitle": "استخدم دعامة مرئية للتحكم في عرض البطاقة.",
		"uiElements.popover.TR": "TR",
		"uiElements.popover.TL": "TL",
		"uiElements.popover.LT": "LT",
		"uiElements.popover.LB": "رطل",
		"uiElements.popover.RT": "RT",
		"uiElements.popover.RB": "RB",
		"uiElements.popover.BL": "BL",
		"uiElements.popover.BR": "BR",
		"uiElements.popover.close": "قريب",
		"uiElements.tooltip.tooltip": "تلميح",
		"uiElements.tooltip.tooltipContent": "تلميح المحتوى",
		"uiElements.tooltip.basicExample": "مثال أساسي",
		"uiElements.tooltip.basicExampleSubTitle": "أبسط الاستخدام.",
		"uiElements.tooltip.placementTitle": "تحديد مستوى",
		"uiElements.tooltip.placementSubTitle": "يحتوي تولتيب على 12 اختيار للمواضع.",
		"uiElements.tooltip.TL": "TL",
		"uiElements.tooltip.TR": "TR",
		"uiElements.tooltip.LT": "LT",
		"uiElements.tooltip.LB": "رطل",
		"uiElements.tooltip.RT": "RT",
		"uiElements.tooltip.RB": "RB",
		"uiElements.tooltip.BL": "BL",
		"uiElements.tooltip.BR": "BR",
		"uiElements.tooltip.bottom": "الأسفل",
		"uiElements.tooltip.right": "حق",
		"uiElements.tooltip.left": "اليسار",
		"uiElements.tooltip.top": "أعلى",
		"uiElements.tooltip.tooltipContentSpan": "سيتم عرض تلميح عندما يدخل الماوس.",
		"uiElements.tooltip.contentSpan": "تلميح المحتوى",
		"uiElements.tags.tags": "الكلمات",
		"uiElements.tags.basicExample": "مثال أساسي",
		"uiElements.tags.basicExampleSubTitle": "استخدام العلامة الأساسية، ويمكن أن يكون قابلا للإغلاق عن طريق مجموعة الممتلكات القابلة للإغلاق. كلوسابل تدعم العلامة إغلوس بعد أحداث كلوس.",
		"uiElements.tags.tagOne": "علامة 1",
		"uiElements.tags.tagTwo": "علامة 2",
		"uiElements.tags.link": "حلقة الوصل",
		"uiElements.tags.preventDefault": "منع افتراضي",
		"uiElements.tags.colorfulTag": "علامة ملونة",
		"uiElements.tags.hotTags": "العلامات الساخنة",
		"uiElements.tags.hotTagsSubTitle": "حدد الموضوعات المفضلة لديك.",
		"uiElements.tags.hots": "السواخن",
		"uiElements.tags.addRemoveDynamically": "إضافة & إزالة ديناميكيا",
		"uiElements.tags.addRemoveDynamicallySubTitle": "إنشاء مجموعة من العلامات من قبل مجموعة، يمكنك إضافة وإزالة حيوي. على أساس الحدث بعد كلوس، والتي سيتم تشغيلها في حين نهاية الرسوم المتحركة وثيق.",
		"uiElements.tags.newTag": "+ علامة جديدة",
		"uiElements.timeline.timeline": "الجدول الزمني",
		"uiElements.timeline.basicExample": "مثال أساسي",
		"uiElements.timeline.basicTimeline": "الجدول الزمني الأساسي",
		"uiElements.timeline.lastNode": "العقدة الأخيرة",
		"uiElements.timeline.lastNodeContent": "عندما يكون الجدول الزمني غير مكتمل ومستمر، ضع عقدة شبح في الماضي. سيت   بندينغ =   ترو     أور   بندينغ =   a رياكت إليمنت",
		"uiElements.timeline.seeMore": "شاهد المزيد",
		"uiElements.timeline.custom": "العادة",
		"uiElements.timeline.customContent": "تعيين عقدة كرمز أو عنصر مخصص آخر.",
		"uiElements.timeline.colorExample": "مثال على الألوان",
		"uiElements.timeline.colorExampleContent": "تعيين لون الدوائر. الأخضر يعني الانتهاء أو حالة النجاح، أحمر يعني التحذير أو الخطأ، والأزرق يعني استمرار أو حالة افتراضية أخرى.",
		"uiElements.timeline.createServiceSite": "إنشاء موقع خدمات 2015-09-01",
		"uiElements.timeline.solveInitialNetwork": "حل مشاكل الشبكة الأولية 2015-09-01",
		"uiElements.timeline.networkProblemSolved": "مشاكل الشبكة التي يتم حلها 2015-09-01",
		"uiElements.timeline.technicalTesting": "الاختبارات الفنية 2015-09-01",
		"uiElements.dropdown.dropdown": "اسقاط",
		"uiElements.dropdown.hoverDropdown": "مرر لأسفل",
		"uiElements.dropdown.hoverMe": "مرر لي",
		"uiElements.dropdown.hoverPlacement": "تحوم التنسيب المنسدلة",
		"uiElements.dropdown.hoverDisableLink": "مرر مؤشر الماوس لأسفل مع تعطيل الرابط",
		"uiElements.dropdown.clickedDropdown": "النقر المنسدلة",
		"uiElements.dropdown.buttonDropdown": "زر مع القائمة المنسدلة",
		"uiElements.pagination.pagination": "ترقيم الصفحات",
		"uiElements.pagination.basic": "الأساسية",
		"uiElements.pagination.more": "أكثر من",
		"uiElements.pagination.changer": "المغير",
		"uiElements.pagination.jumper": "سترة او قفاز او لاعب قفز",
		"uiElements.pagination.miniSize": "حجم صغير",
		"uiElements.pagination.simpleMode": "الوضع البسيط",
		"uiElements.pagination.controlled": "خاضع للسيطرة",
		"uiElements.pagination.totalNumber": "الرقم الإجمالي",
		"uiElements.rating.rating": "تقييم",
		"uiElements.rating.basicExample": "مثال أساسي",
		"uiElements.rating.basicExampleSubTitle": "أبسط الاستخدام.",
		"uiElements.rating.halfStar": "نصف نجوم",
		"uiElements.rating.halfStarSubTitle": "دعم حدد نصف النجم.",
		"uiElements.rating.showCopywriting": "عرض كتابة النصوص",
		"uiElements.rating.showCopywritingSubTitle": "إضافة مكونات الكتابة في معدل.",
		"uiElements.rating.readOnly": "يقرأ فقط",
		"uiElements.rating.readOnlySubTitle": "للقراءة فقط، لا يمكن استخدام الماوس للتفاعل.",
		"uiElements.rating.otherCharacter": "شخصية أخرى",
		"uiElements.rating.otherCharacterSubTitle": "استبدال النجمة الافتراضية إلى حرف آخر مثل الأبجدية، أرقام، إيكونفونت أو حتى كلمة الصينية.",
		"uiElements.tree.tree": "شجرة",
		"uiElements.tree.basicExample": "مثال أساسي",
		"uiElements.tree.basicExampleSubTitle": "الاستخدام الأساسي، أخبرك عن كيفية استخدام قابل للتحديد، قابل للتحديد، تعطيل، ديفولتكسانديكيس، وما إلى ذلك.",
		"uiElements.tree.basicControlledExample": "مثال تحكم أساسي",
		"uiElements.tree.basicControlledExampleSubTitle": "مثال أساسي للتحكم",
		"uiElements.tree.draggableExample": "مثال قابل للسحب",
		"uiElements.tree.draggableExampleSubTitle": "اسحب ترينود لإدراج بعد ترينود أخرى أو إدراج في ترينود الأصل الآخر.",
		"uiElements.tree.loadAsync": "تحميل البيانات بشكل غير متزامن",
		"uiElements.tree.loadAsyncSubTitle": "لتحميل البيانات بشكل غير متزامن عند النقر لتوسيع ترينود.",
		"uiElements.tree.searchableExample": "مثال قابل للبحث",
		"uiElements.tree.searchableExampleSubTitle": "شجرة قابلة للبحث",
		"uiElements.tree.treeWithLine": "شجرة مع خط",
		"shuffle.descriptionOne": "نيتسكيب 2.0 السفن، وتقديم جافا سكريبت",
		"shuffle.descriptionTwo": "جيسي جيمس غاريت يطلق مواصفات أجاكس",
		"shuffle.descriptionThree": "جكري 1.0 صدر",
		"shuffle.descriptionFour": "تلتزم suberscore.js الأولى",
		"shuffle.descriptionFive": "Backbone.js يصبح شيئا",
		"shuffle.descriptionSix": "الزاوي 1.0 صدر",
		"shuffle.descriptionSeven": "رد فعل مفتوح المصدر؛ المطورين نفرح",
		"toggle.list": "قائمة",
		"toggle.grid": "شبكة",
		"toggle.ascending": "تصاعدي",
		"toggle.descending": "تنازلي",
		"toggle.shuffle": "خلط",
		"toggle.rotate": "استدارة",
		"toggle.addItem": "اضافة عنصر",
		"toggle.removeItem": "إزالة بند",
		"contactlist.searchContacts": "اتصالات بحث",
		"contactlist.addNewContact": "إضافة جهة اتصال جديدة",
		"notes.ChoseColor": "اختر لونا لملاحظتك",
		"notes.addNote": "إضافة ملاحظة جديدة",
		"page404.title": "404",
		"page404.subTitle": "يبدو أنك قد فقدت",
		"page404.description": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
		"page404.backButton": "عودة المنزل",
		"page500.title": "500",
		"page500.subTitle": "خطأ في الخادم الداخلي",
		"page500.description": "هناك خطأ ما. الرجاء إعادة المحاولة.",
		"page500.backButton": "عودة المنزل",
		"page.forgetPassTitle": "متماثل",
		"page.forgetPassSubTitle": "هل نسيت كلمة المرور؟",
		"page.forgetPassDescription": "أدخل بريدك الإلكتروني ونرسل إليك رابط إعادة تعيين.",
		"page.sendRequest": "ارسل طلب",
		"page.resetPassTitle": "متماثل",
		"page.resetPassSubTitle": "إعادة تعيين كلمة المرور",
		"page.resetPassDescription": "أدخل كلمة مرور جديدة وقم بتأكيدها.",
		"page.resetPassSave": "حفظ",
		"page.signInTitle": "متماثل",
		"page.signInRememberMe": "تذكرنى",
		"page.signInButton": "تسجيل الدخول",
		"page.signInPreview": "اسم المستخدم  تجريبي، كلمة السر  ديموديمو، أو فقط اضغط على أي زر.",
		"page.signInFacebook": "قم بتسجيل الدخول باستخدام الفيسبوك",
		"page.signInGooglePlus": "سجل الدخول باستخدام غوغل بلوس",
		"page.signInAuth0": "سجل الدخول باستخدام أوث0",
		"page.signInForgotPass": "هل نسيت كلمة المرور",
		"page.signInCreateAccount": "إنشاء حساب إسومورفويك",
		"page.signUpTitle": "متماثل",
		"page.signUpTermsConditions": "أوافق على الشروط والأحكام",
		"page.signUpButton": "سجل",
		"page.signUpFacebook": "اشترك عبر حساب فايسبوك",
		"page.signUpGooglePlus": "اشترك مع غوغل بلوس",
		"page.signUpAuth0": "اشترك باستخدام أوث0",
		"page.signUpAlreadyAccount": "هل لديك حساب بالفعل؟ تسجيل الدخول.",
		"widget.reportswidget.label": "الإيرادات",
		"widget.reportswidget.details": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور",
		"widget.singleprogresswidget1.label": "تسويق",
		"widget.singleprogresswidget2.label": "Addvertisement",
		"widget.singleprogresswidget3.label": "الاستشارات",
		"widget.singleprogresswidget4.label": "تطوير",
		"widget.stickerwidget1.number": "210",
		"widget.stickerwidget1.text": "بريد إلكتروني غير مقروء",
		"widget.stickerwidget2.number": "1749",
		"widget.stickerwidget2.text": "تحميل الصور",
		"widget.stickerwidget3.number": "3024",
		"widget.stickerwidget3.text": "إجمالي الرسالة",
		"widget.stickerwidget4.number": "54",
		"widget.stickerwidget4.text": "أوامر المشاركة",
		"widget.salewidget1.label": "الإيرادات",
		"widget.salewidget1.price": "$ 15000",
		"widget.salewidget1.details": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور",
		"widget.salewidget2.label": "الإيرادات",
		"widget.salewidget2.price": "$ 15000",
		"widget.salewidget2.details": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور",
		"widget.salewidget3.label": "الإيرادات",
		"widget.salewidget3.price": "$ 15000",
		"widget.salewidget3.details": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور",
		"widget.salewidget4.label": "الإيرادات",
		"widget.salewidget4.price": "$ 15000",
		"widget.salewidget4.details": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور",
		"widget.cardwidget1.number": "110",
		"widget.cardwidget1.text": "رسائل جديدة",
		"widget.cardwidget2.number": "100٪",
		"widget.cardwidget2.text": "الصوت",
		"widget.cardwidget3.number": "137",
		"widget.cardwidget3.text": "موهلات",
		"widget.progresswidget1.label": "تحميل",
		"widget.progresswidget1.details": "50٪ كاملة",
		"widget.progresswidget2.label": "الدعم",
		"widget.progresswidget2.details": "80٪ العملاء راض",
		"widget.progresswidget3.label": "تحميل",
		"widget.progresswidget3.details": "65٪ كاملة",
		"widget.vcardwidget.name": "جون دو",
		"widget.vcardwidget.title": "مطور يوس",
		"widget.vcardwidget.description": "لوريم إيبسوم دولور سيت أميت، كونسكتيتور أديبيسيسينغ إليت، سيد دو إيسمود تيمبور أمت رولر كونسكتيتور أديبيسيسينغ إليت",
		"checkout.billingform.firstname": "الاسم الاول",
		"checkout.billingform.lastname": "الكنية",
		"checkout.billingform.company": "اسم الشركة",
		"checkout.billingform.email": "عنوان البريد الإلكتروني",
		"checkout.billingform.mobile": "رقم المحمول",
		"checkout.billingform.country": "بلد",
		"checkout.billingform.city": "مدينة",
		"checkout.billingform.address": "عنوان",
		"checkout.billingform.addressoptional": "شقة، جناح، وحدة الخ (اختياري",
		"checkout.billingform.checkbox": "انشئ حساب؟",
		"antTable.title.image": "صورة",
		"antTable.title.firstName": "الاسم الاول",
		"antTable.title.lastName": "الكنية",
		"antTable.title.city": "مدينة",
		"antTable.title.street": "شارع",
		"antTable.title.email": "البريد الإلكتروني",
		"antTable.title.dob": "تاريخ الميلاد",
		"Map.leaflet.basicTitle": "الخريطة الأساسية",
		"Map.leaflet.basicMarkerTitle": "خريطة أساسية (مع علامة افتراضية",
		"Map.leaflet.leafletCustomMarkerTitle": "خريطة أساسية (مع علامة رمز مخصص",
		"Map.leaflet.leafletCustomHtmlMarkerTitle": "خريطة أساسية (مع علامة هتمل مخصصة",
		"Map.leaflet.leafletMarkerClusterTitle": "الخريطة الأساسية (مع مجموعة العلامات",
		"Map.leaflet.leafletRoutingTitle": "خريطة أساسية التوجيه",
		"Component.contacts.noOption": "لم يتم العثور على جهة اتصال",
		"email.send": "إرسال",
		"email.cancel": "إلغاء",
		"email.compose": "مؤلف موسيقى",
		"email.noMessage": "الرجاء تحديد بريد للقراءة",
		"themeSwitcher.purchase": "شراء الآن",
		"themeSwitcher.settings": "إعدادات",
		"sidebar.selectbox": "تحديد"
	};

/***/ },
/* 2300 */
/***/ function(module, exports) {

	module.exports = {
		"sidebar.email": "Email",
		"sidebar.ecommerce": "Ecommerce",
		"sidebar.shop": "Shop",
		"sidebar.cart": "Cart",
		"sidebar.checkout": "Checkout",
		"sidebar.cards": "Cards",
		"sidebar.maps": "Maps",
		"sidebar.googleMap": "Google Map",
		"sidebar.leafletMap": "Leaflet Map",
		"sidebar.calendar": "Calendar",
		"sidebar.notes": "Notes",
		"sidebar.todos": "Todos",
		"sidebar.contacts": "Contacts",
		"sidebar.shuffle": "Shuffle",
		"sidebar.charts": "Charts",
		"sidebar.googleCharts": "Google Carts",
		"sidebar.recharts": "Recharts",
		"sidebar.reactVis": "React Vis",
		"sidebar.reactChart2": "React-Chart-2",
		"sidebar.reactTrend": "React-Trend",
		"sidebar.eChart": "Echart",
		"sidebar.forms": "Forms",
		"sidebar.input": "Input",
		"sidebar.editor": "Editor",
		"sidebar.formsWithValidation": "Forms With Validation",
		"sidebar.progress": "Progress",
		"sidebar.button": "Button",
		"sidebar.tab": "Tab",
		"sidebar.checkbox": "Checkbox",
		"sidebar.radiobox": "Radiobox",
		"sidebar.transfer": "Transfer",
		"sidebar.autocomplete": "AutoComplete",
		"sidebar.boxOptions": "Box Options",
		"sidebar.uiElements": "UI Elements",
		"sidebar.badge": "Badge",
		"sidebar.card2": "Card",
		"sidebar.corusel": "Carousal",
		"sidebar.collapse": "Collapse",
		"sidebar.popover": "Pop Over",
		"sidebar.tooltip": "Tooltip",
		"sidebar.tag": "Tag",
		"sidebar.timeline": "Timeline",
		"sidebar.dropdown": "Dropdown",
		"sidebar.pagination": "Pagination",
		"sidebar.rating": "Rating",
		"sidebar.tree": "Tree",
		"sidebar.advancedElements": "Advanced Elements",
		"sidebar.reactDates": "React Dates",
		"sidebar.codeMirror": "Code Mirror",
		"sidebar.uppy": "Uppy Uploader",
		"sidebar.dropzone": "Drop Zone",
		"sidebar.feedback": "Feedback",
		"sidebar.alert": "Alert",
		"sidebar.modal": "Modal",
		"sidebar.message": "Message",
		"sidebar.notification": "Notification",
		"sidebar.popConfirm": "Pop Confirm",
		"sidebar.spin": "Spin",
		"sidebar.tables": "Tables",
		"sidebar.antTables": "Ant Tables",
		"sidebar.pages": "Pages",
		"sidebar.500": "500",
		"sidebar.404": "404",
		"sidebar.signIn": "Sign In",
		"sidebar.signUp": "Sign Up",
		"sidebar.forgotPw": "Forgot Passwords",
		"sidebar.resetPw": "Reset Passwords",
		"sidebar.invoice": "Invoice",
		"sidebar.menuLevels": "Menu Levels",
		"sidebar.item1": "Item 1",
		"sidebar.item2": "Item 2",
		"sidebar.option1": "Option 1",
		"sidebar.option2": "Option 2",
		"sidebar.option3": "Option 3",
		"sidebar.option4": "Option 4",
		"sidebar.blankPage": "Blank Page",
		"sidebar.githubSearch": "Github Search",
		"sidebar.youtubeSearch": "Youtube Search",
		"languageSwitcher.label": "Change Language",
		"themeSwitcher": "Theme Switcher",
		"themeSwitcher.Sidebar": "Sidebar",
		"themeSwitcher.Topbar": "Topbar",
		"themeSwitcher.Background": "Background",
		"feedback.alert.basicTitle": "Basic Title",
		"feedback.alert.successText": "Success text",
		"feedback.alert.infoText": "Info Text",
		"feedback.alert.warningText": "Warning Text",
		"feedback.alert.errorText": "Error Text",
		"feedback.alert.closableAlertType": "Closable Alert Type",
		"feedback.alert.iconAlertType": "Icon Alert Type",
		"feedback.alert.iconInfoAlertType": "Icon Info Alert Type",
		"feedback.alert.successTips": "success tips",
		"feedback.alert.successTipsDescription": "Detailed description and advices about successful copywriting.",
		"feedback.alert.informationTips": "Informational Notes",
		"feedback.alert.informationDescription": "Additional description and informations about copywriting.",
		"feedback.alert.warningTips": "Warning",
		"feedback.alert.warningDescription": "This is a warning notice about copywriting.",
		"feedback.alert.errorTips": "Error",
		"feedback.alert.errorDescription": "This is an error message about copywriting.",
		"feedback.alert.modalTitle": "Modal one with customize Footer",
		"feedback.alert.modalSubTitle": "Basic modal dialog.",
		"feedback.alert.successTitle": "Success",
		"feedback.alert.infoTitle": "Info",
		"feedback.alert.errorTitle": "Error",
		"feedback.alert.warningTitle": "Warning",
		"feedback.alert.modalBlockTitle": "Modal",
		"feedback.alert.confirmationModalDialogue": "Confirmation modal dialog",
		"feedback.alert.simpleModalDialogue": "Simple modal dialog",
		"feedback.alert.message": "Message",
		"feedback.alert.normalMessageTitle": "Normal Message",
		"feedback.alert.normalMessageSubtitle": "Normal messages as feedbacks.",
		"feedback.alert.displayMessage": "Display normal message",
		"feedback.alert.displayOtherTypeMessageTitle": "Other Types of Message",
		"feedback.alert.displayOtherTypeMessageSubTitle": "Messages of success   error and warning types.",
		"feedback.alert.customizeDurationTitle": "Customize duration",
		"feedback.alert.customizeDurationSubTitle": "ustomize message display duration from default 1.5s to 10s.",
		"feedback.alert.customizeDurationButton": "Customized display duration",
		"feedback.alert.messageLoadingTitle": "Message of loading",
		"feedback.alert.messageLoadingSubTitle": "Display a global loading indicator   which is dismissed by itself asynchronously.",
		"feedback.alert.displayLoadIndicator": "Display a loading indicator",
		"feedback.alert.notification": "Notification",
		"feedback.alert.notificationBasicTitle": "Basic",
		"feedback.alert.notificationBasicSubTitle": "The simplest usage that close the notification box after 4.5s.",
		"feedback.alert.notificationBasicDescription": "Open the notification box",
		"feedback.alert.notificationDurationTitle": "Duration after which the notification box is closed",
		"feedback.alert.notificationDurationSubTitle": "Duration can be used to specify how long the notification stays open. After the duration time elapses   the notification closes automatically. If not specified   default value is 4.5 seconds. If you set the value to 0   the notification box will never close automatically.",
		"feedback.alert.notificationwithIconTitle": "Notification with icon",
		"feedback.alert.notificationwithIconSubTitle": "A notification box with a icon at the left side.",
		"feedback.alert.notificationwithCustomIconTitle": "Notification with custom icon",
		"feedback.alert.notificationwithCustomIconSubTitle": "Normal messages as feedbacks.",
		"feedback.alert.notificationwithCustomButtonTitle": "Notification with custom button",
		"feedback.alert.notificationwithCustomButtonSubTitle": "Normal messages as feedbacks.",
		"feedback.alert.popConfirm": "Pop Confirm",
		"feedback.alert.popConfirm.basicTitle": "Basic Confirm",
		"feedback.alert.popConfirm.basicSubTitle": "The basic example.",
		"feedback.alert.popConfirm.delete": "Delete",
		"feedback.alert.popConfirm.notiWithIconTitle": "Notification with custom icon",
		"feedback.alert.popConfirm.notiWithIconSubTitle": "Normal messages as feedbacks.",
		"feedback.alert.popConfirm.TL": "TL",
		"feedback.alert.popConfirm.top": "Top",
		"feedback.alert.popConfirm.TR": "TR",
		"feedback.alert.popConfirm.LT": "LT",
		"feedback.alert.popConfirm.left": "Left",
		"feedback.alert.popConfirm.LB": "LB",
		"feedback.alert.popConfirm.RT": "RT",
		"feedback.alert.popConfirm.right": "Right",
		"feedback.alert.popConfirm.RB": "RB",
		"feedback.alert.popConfirm.Bl": "BL",
		"feedback.alert.popConfirm.bottom": "Bottom",
		"feedback.alert.popConfirm.BR": "BR",
		"feedback.alert.spin": "Spin",
		"feedback.alert.spin.basicTitle": "Size Spin",
		"feedback.alert.spin.background": "Spin With Background",
		"feedback.alert.spin.backgroundDescription": "Spin With Background description",
		"feedback.alert.spin.loadingState": "Loading State",
		"feedback.alert.spin.alertTitle": "Alert message title",
		"feedback.alert.spin.alertDescription": "Further details about the context of this alert.",
		"forms.input.header": "Input",
		"forms.input.basicTitle": "Basic usage",
		"forms.input.basicSubTitle": "Basic usage example.",
		"forms.input.variationsTitle": "Three sizes of Input",
		"forms.input.variationsSubtitle": "There are three sizes of an Input box  large (42px  、default (35px   and small (30px  . Note  Inside of forms   only the large size is used.",
		"forms.input.groupTitle": "Input Group",
		"forms.input.groupSubTitle": "Input.Group example Note  You dont need Col to control the width in the compact mode.",
		"forms.input.autoSizingTitle": "Autosizing the height to fit the content",
		"forms.input.autoSizingSubTitle": "autosize prop for a textarea type of Input makes the height to automatically adjust based on the content. An options object can be provided to autosize to specify the minimum and maximum number of lines the textarea will automatically adjust.",
		"forms.input.prePostTabTitle": "Pre    Post tab",
		"forms.input.prePostTabSubTitle": "Using pre &amp; post tabs example..",
		"forms.input.textAreaTitle": "Textarea",
		"forms.input.textAreaSubTitle": "For multi-line user input cases   an input whose type prop has the value of textarea can be used.",
		"forms.input.searchTitle": "Search",
		"forms.input.searchSubTitle": "Example of creating a search box by grouping a standard input with a search button",
		"forms.editor.header": "Editor",
		"forms.formsWithValidation.header": "Customized Validation Form",
		"forms.formsWithValidation.failLabel": "Fail",
		"forms.formsWithValidation.failHelp": "Should be combination of numbers &amp; alphabets",
		"forms.formsWithValidation.warningLabel": "Warning",
		"forms.formsWithValidation.ValidatingLabel": "Validating",
		"forms.formsWithValidation.ValidatingHelp": "The information is being validated...",
		"forms.formsWithValidation.SuccessLabel": "Success",
		"forms.formsWithValidation.WarninghasFeedbackLabel": "Warning",
		"forms.formsWithValidation.FailhasFeedbackLabel": "Fail",
		"forms.formsWithValidation.FailhasFeedbackHelp": "Should be combination of numbers &amp; alphabets",
		"forms.progressBar.header": "Progress Bar",
		"forms.progressBar.standardTitle": "Progress bar",
		"forms.progressBar.standardSubTitle": "A standard progress bar.",
		"forms.progressBar.circularTitle": "Circular Progress bar",
		"forms.progressBar.circularSubTitle": "A circular progress bar.",
		"forms.progressBar.miniTitle": "Mini size progress bar",
		"forms.progressBar.miniSubTitle": "Appropriate for a narrow area.",
		"forms.progressBar.miniCircularTitle": "A smaller circular progress bar.",
		"forms.progressBar.dynamicCircularTitle": "Dynamic circular progress bar",
		"forms.progressBar.dynamicCircularSubTitle": "A dynamic progress bar is better.",
		"forms.progressBar.customTextTitle": "Custom text format",
		"forms.progressBar.customTextSubTitle": "You can custom text format by setting format.",
		"forms.progressBar.dashboardTitle": "Dashboard",
		"forms.progressBar.dashboardSubTitle": "A dashboard style of progress.",
		"forms.button.header": "Buttons",
		"forms.button.simpleButton": "Button Type",
		"forms.button.iconButton": "Button Icon",
		"forms.button.simpleButtonPrimaryText": "Primary",
		"forms.button.simpleButtonDefaultText": "Default",
		"forms.button.simpleButtonDashedText": "Dashed",
		"forms.button.simpleButtonDangerText": "Danger",
		"forms.button.iconPrimaryButton": "search",
		"forms.button.iconSimpleButton": "search",
		"forms.button.iconCirculerButton": "search",
		"forms.button.iconDashedButton": "search",
		"forms.button.SizedButton": "Button Size",
		"forms.button.DisabledButton": "Button Disabled",
		"forms.button.LoadingButton": "Button Loading",
		"forms.button.MultipleButton": "Multiple Button",
		"forms.button.groupButton": "Button Group",
		"forms.Tabs.header": "Tabs",
		"forms.Tabs.simpleTabTitle": "search",
		"forms.Tabs.simpleTabSubTitle": "Disabled Tabs",
		"forms.Tabs.iconTabTitle": "Icon Tabs",
		"forms.Tabs.miniTabTitle": "Mini Tabs",
		"forms.Tabs.extraTabTitle": "Extra Action Tabs",
		"forms.Tabs.TabpositionTitle": "Position",
		"forms.Tabs.TabpositionSubTitle": "Tabss position  left   right   top or bottom",
		"forms.Tabs.cardTitle": "Card Type Tabs",
		"forms.Tabs.editableTitle": "Add and Close Tabs",
		"forms.Tabs.verticalTitle": "Vertical Type Tabs",
		"forms.Tabs.basicTitle": "Basic Tabs",
		"forms.checkbox.header": "Checkbox",
		"forms.checkbox.basicTitle": "Basic Checkbox",
		"forms.checkbox.basicSubTitle": "Basic usage of checkbox.",
		"forms.checkbox.groupTitle": "Checkbox Group",
		"forms.checkbox.groupSubTitle": "Generate a group of checkboxes from an array. Use disabled to disable a checkbox.",
		"forms.checkbox.groupCheckTitle": "Checkbox Group",
		"forms.checkbox.groupCheckSubTitle": "Generate a group of checkboxes from an array. Use disabled to disable a checkbox.",
		"forms.radio.header": "Radio",
		"forms.radio.simpleTitle": "Basic Radio",
		"forms.radio.simpleSubTitle": "The simplest use. Use disabled to disable a radio.",
		"forms.radio.groupTitle": "Vertical RadioGroup",
		"forms.radio.groupSubTitle": "Vertical RadioGroup   with more radios.",
		"forms.radio.groupSecondTitle": "RadioGroup",
		"forms.radio.groupSecondSubTitle": "A group of radio components.",
		"forms.radio.groupThirdTitle": "RadioGroup",
		"forms.radio.groupThirdSubTitle": "A group of radio components.",
		"forms.transfer.header": "Transfer",
		"forms.transfer.SubTitle": "Transfer with a search box.",
		"forms.transfer.Title": "Search",
		"forms.autocomplete.header": "Autocomplete",
		"forms.autocomplete.simpleTitle": "Customized",
		"forms.autocomplete.simpleSubTitle": "You could pass AutoComplete.Option as children of AutoComplete   instead of using dataSource",
		"forms.autocomplete.customizeTitle": "Customize Input Component",
		"forms.autocomplete.customizeSubTitle": "Customize Input Component",
		"uiElements.badge.badge": "Badge",
		"uiElements.badge.basicExample": "Basic Example",
		"uiElements.badge.basicExampleSubTitle": "Simplest Usage. Badge will be hidden when count is 0   but we can use showZero to show it.",
		"uiElements.badge.overflowCount": "Overflow Count",
		"uiElements.badge.overflowCountSubTitle": "OverflowCount is displayed when count is larger than overflowCount. The default value of overflowCount is 99.",
		"uiElements.badge.status": "Status",
		"uiElements.badge.statusSubTitle": "Standalone badge with status.",
		"uiElements.badge.success": "Success",
		"uiElements.badge.error": "Error",
		"uiElements.badge.default": "Default",
		"uiElements.badge.processing": "Processing",
		"uiElements.badge.warning": "Warning",
		"uiElements.badge.redBadge": "Red badge",
		"uiElements.badge.redBadgeSubTitle": "This will simply display a red badge   without a specific count.",
		"uiElements.badge.linkSomething": "Link something",
		"uiElements.cards.cards": "Cards",
		"uiElements.cards.basicCard": "Basic card",
		"uiElements.cards.basicCardSubTitle": "A basic card containing a title   content and an extra corner content.",
		"uiElements.cards.more": "More",
		"uiElements.cards.cardTitle": "Card Title",
		"uiElements.cards.cardContent": "Card content",
		"uiElements.cards.lorem": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam   quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
		"uiElements.cards.noBorder": "No Border",
		"uiElements.cards.noBorderSubTitle": "A borderless card on a gray background.",
		"uiElements.cards.gridCard": "Grid card",
		"uiElements.cards.gridCardSubTitle": "Cards usually cooperate with grid layout in overview page.",
		"uiElements.cards.loadingCard": "Loading card",
		"uiElements.cards.loadingCardSubTitle": "Shows a loading indicator while the contents of the card is being fetched.",
		"uiElements.cards.whateverContent": "Whatever content",
		"uiElements.cards.customizedContentTitle": "Customized Content",
		"uiElements.cards.customizedContent": "Shows a loading indicator while the contents of the card is being fetched.",
		"uiElements.cards.europeStreetBeat": "Europe Street beat",
		"uiElements.cards.instagram": "www.instagram.com",
		"uiElements.carousel.carousel": "Carousal",
		"uiElements.carousel.verticalCarousel": "Vertical Carousel",
		"uiElements.carousel.verticalCarouselSubTitle": "Vertical pagination. use   vertical=true",
		"uiElements.carousel.basicCarousel": "Basic Carousel",
		"uiElements.carousel.basicCarouselSubTitle": "Basic usage",
		"uiElements.carousel.fadeInTransition": "Fade In Transition",
		"uiElements.carousel.fadeInTransitionSubTitle": "Slides use fade for transition.   effect=fade",
		"uiElements.carousel.scrollAutomatically": "Scroll Automatically",
		"uiElements.carousel.scrollAutomaticallySubTitle": "Timing of scrolling to the next card  picture. autoplay",
		"uiElements.collapse.collapse": "Collapse",
		"uiElements.collapse.collapseSubTitle": "More than one panel can be expanded at a time   the first panel is initialized to be active in this case. use   defaultActiveKey=  [keyNum]",
		"uiElements.collapse.text": "A dog is a type of domesticated animal. Known for its loyalty and faithfulness   it can be found as a welcome guest in many households across the world.",
		"uiElements.collapse.headerOne": "This is panel header 1",
		"uiElements.collapse.headerTwo": "This is panel header 2",
		"uiElements.collapse.headerThree": "This is panel header 3",
		"uiElements.collapse.headerNested": "This is panel nest panel",
		"uiElements.collapse.nestedExample": "Nested Example",
		"uiElements.collapse.nestedExampleSubTitle": "Collapse is nested inside the Collapse.",
		"uiElements.collapse.borderlessExample": "Borderless Example",
		"uiElements.collapse.borderlessExampleSubTitle": "A borderless style of Collapse. use   bordered=  false",
		"uiElements.collapse.accordion": "Accordion",
		"uiElements.collapse.accordionSubTitle": "Accordion mode   only one panel can be expanded at a time. The first panel will be expanded by default. use accordion",
		"uiElements.popover.popover": "Popover",
		"uiElements.popover.basicExample": "Basic Example",
		"uiElements.popover.basicExampleSubTitle": "The most basic example. The size of the floating layer depends on the contents region.",
		"uiElements.popover.hoverMe": "Hover me",
		"uiElements.popover.title": "Title",
		"uiElements.popover.titleTrigger": "Three ways to trigger",
		"uiElements.popover.titleTriggerSubTitle": "Mouse to click   focus and move in.",
		"uiElements.popover.focusMe": "Focus me",
		"uiElements.popover.clickMe": "Click me",
		"uiElements.popover.placement": "Placement",
		"uiElements.popover.placementSubTitle": "There are 12 placement options available.",
		"uiElements.popover.top": "Top",
		"uiElements.popover.topLeft": "Top Left",
		"uiElements.popover.topRight": "Top Right",
		"uiElements.popover.leftTop": "Left Top",
		"uiElements.popover.left": "Left",
		"uiElements.popover.leftBottom": "Left Bottom",
		"uiElements.popover.rightTop": "Right Top",
		"uiElements.popover.right": "Right",
		"uiElements.popover.bottom": "Bottom",
		"uiElements.popover.bottomLeft": "Bottom Left",
		"uiElements.popover.bottomRight": "Bottom Right",
		"uiElements.popover.boxTitle": "Controlling the close of the dialog",
		"uiElements.popover.boxSubTitle": "Use visible prop to control the display of the card.",
		"uiElements.popover.TR": "TR",
		"uiElements.popover.TL": "TL",
		"uiElements.popover.LT": "LT",
		"uiElements.popover.LB": "LB",
		"uiElements.popover.RT": "RT",
		"uiElements.popover.RB": "RB",
		"uiElements.popover.BL": "BL",
		"uiElements.popover.BR": "BR",
		"uiElements.popover.close": "Close",
		"uiElements.tooltip.tooltip": "Tooltip",
		"uiElements.tooltip.tooltipContent": "Tooltip Content",
		"uiElements.tooltip.basicExample": "Basic Example",
		"uiElements.tooltip.basicExampleSubTitle": "The simplest usage.",
		"uiElements.tooltip.placementTitle": "Placement",
		"uiElements.tooltip.placementSubTitle": "The ToolTip has 12 placements choice.",
		"uiElements.tooltip.TL": "TL",
		"uiElements.tooltip.TR": "TR",
		"uiElements.tooltip.LT": "LT",
		"uiElements.tooltip.LB": "LB",
		"uiElements.tooltip.RT": "RT",
		"uiElements.tooltip.RB": "RB",
		"uiElements.tooltip.BL": "BL",
		"uiElements.tooltip.BR": "BR",
		"uiElements.tooltip.bottom": "Bottom",
		"uiElements.tooltip.right": "Right",
		"uiElements.tooltip.left": "Left",
		"uiElements.tooltip.top": "Top",
		"uiElements.tooltip.tooltipContentSpan": "Tooltip will show when mouse enter.",
		"uiElements.tooltip.contentSpan": "Tooltip Content",
		"uiElements.tags.tags": "Tags",
		"uiElements.tags.basicExample": "Basic Example",
		"uiElements.tags.basicExampleSubTitle": "Usage of basic Tag   and it could be closable by set closable property. Closable Tag supports onClose afterClose events.",
		"uiElements.tags.tagOne": "Tag 1",
		"uiElements.tags.tagTwo": "Tag 2",
		"uiElements.tags.link": "Link",
		"uiElements.tags.preventDefault": "Prevent Default",
		"uiElements.tags.colorfulTag": "Colorful Tag",
		"uiElements.tags.hotTags": "Hot Tags",
		"uiElements.tags.hotTagsSubTitle": "Select your favourite topics.",
		"uiElements.tags.hots": "Hots",
		"uiElements.tags.addRemoveDynamically": "Add & Remove Dynamically",
		"uiElements.tags.addRemoveDynamicallySubTitle": "Generating a set of Tags by array   you can add and remove dynamically. Its based on afterClose event   which will be triggered while the close animation end.",
		"uiElements.tags.newTag": "+ New Tag",
		"uiElements.timeline.timeline": "Timeline",
		"uiElements.timeline.basicExample": "Basic Example",
		"uiElements.timeline.basicTimeline": "Basic timeline",
		"uiElements.timeline.lastNode": "Last Node",
		"uiElements.timeline.lastNodeContent": "When the timeline is incomplete and ongoing   put a ghost node at last. set   pending=  true     or   pending=  a React Element",
		"uiElements.timeline.seeMore": "See more",
		"uiElements.timeline.custom": "Custom",
		"uiElements.timeline.customContent": "Set a node as an icon or other custom element.",
		"uiElements.timeline.colorExample": "Color Example",
		"uiElements.timeline.colorExampleContent": "Set the color of circles. green means completed or success status   red means warning or error   and blue means ongoing or other default status.",
		"uiElements.timeline.createServiceSite": "Create a services site 2015-09-01",
		"uiElements.timeline.solveInitialNetwork": "Solve initial network problems 2015-09-01",
		"uiElements.timeline.networkProblemSolved": "Network problems being solved 2015-09-01",
		"uiElements.timeline.technicalTesting": "Technical testing 2015-09-01",
		"uiElements.dropdown.dropdown": "Dropdown",
		"uiElements.dropdown.hoverDropdown": "Hover Drop Down",
		"uiElements.dropdown.hoverMe": "Hover me",
		"uiElements.dropdown.hoverPlacement": "Hover Placement Drop Down",
		"uiElements.dropdown.hoverDisableLink": "Hover Drop Down with Disable link",
		"uiElements.dropdown.clickedDropdown": "Clicked Drop Down",
		"uiElements.dropdown.buttonDropdown": "Button with dropdown menu",
		"uiElements.pagination.pagination": "Pagination",
		"uiElements.pagination.basic": "Basic",
		"uiElements.pagination.more": "More",
		"uiElements.pagination.changer": "Changer",
		"uiElements.pagination.jumper": "Jumper",
		"uiElements.pagination.miniSize": "Mini Size",
		"uiElements.pagination.simpleMode": "Simple Mode",
		"uiElements.pagination.controlled": "Controlled",
		"uiElements.pagination.totalNumber": "Total Number",
		"uiElements.rating.rating": "Rating",
		"uiElements.rating.basicExample": "Basic Example",
		"uiElements.rating.basicExampleSubTitle": "The simplest usage.",
		"uiElements.rating.halfStar": "Half star",
		"uiElements.rating.halfStarSubTitle": "Support select half star.",
		"uiElements.rating.showCopywriting": "Show copywriting",
		"uiElements.rating.showCopywritingSubTitle": "Add copywriting in rate components.",
		"uiElements.rating.readOnly": "Read only",
		"uiElements.rating.readOnlySubTitle": "Read only   cant use mouse to interact.",
		"uiElements.rating.otherCharacter": "Other Character",
		"uiElements.rating.otherCharacterSubTitle": "Replace the default star to other character like alphabet   digit   iconfont or even Chinese word.",
		"uiElements.tree.tree": "Tree",
		"uiElements.tree.basicExample": "Basic example",
		"uiElements.tree.basicExampleSubTitle": "The most basic usage   tell you how to use checkable   selectable   disabled   defaultExpandKeys   and etc.",
		"uiElements.tree.basicControlledExample": "Basic controlled example",
		"uiElements.tree.basicControlledExampleSubTitle": "basic controlled example",
		"uiElements.tree.draggableExample": "Draggable example",
		"uiElements.tree.draggableExampleSubTitle": "Drag treeNode to insert after the other treeNode or insert into the other parent TreeNode.",
		"uiElements.tree.loadAsync": "Load data asynchronously",
		"uiElements.tree.loadAsyncSubTitle": "To load data asynchronously when click to expand a treeNode.",
		"uiElements.tree.searchableExample": "Searchable example",
		"uiElements.tree.searchableExampleSubTitle": "Searchable Tree",
		"uiElements.tree.treeWithLine": "Tree With Line",
		"shuffle.descriptionOne": "Netscape 2.0 ships   introducing Javascript",
		"shuffle.descriptionTwo": "Jesse James Garrett releases AJAX spec",
		"shuffle.descriptionThree": "jQuery 1.0 released",
		"shuffle.descriptionFour": "First underscore.js commit",
		"shuffle.descriptionFive": "Backbone.js becomes a thing",
		"shuffle.descriptionSix": "Angular 1.0 released",
		"shuffle.descriptionSeven": "React is open-sourced; developers rejoice",
		"toggle.list": "List",
		"toggle.grid": "Grid",
		"toggle.ascending": "Ascending",
		"toggle.descending": "Descending",
		"toggle.shuffle": "Shuffle",
		"toggle.rotate": "Rotate",
		"toggle.addItem": "Add Item",
		"toggle.removeItem": "Remove Item",
		"contactlist.searchContacts": "Search Contacts",
		"contactlist.addNewContact": "Add New Contact",
		"notes.ChoseColor": "Choose a color for your note",
		"notes.addNote": "Add New Note",
		"page404.title": "404",
		"page404.subTitle": "Looks like you got lost",
		"page404.description": "The page youre looking for doesnt exist or has been moved.",
		"page404.backButton": "BACK HOME",
		"page500.title": "500",
		"page500.subTitle": "Internal Server Error",
		"page500.description": "Something went wrong. Please try again later.",
		"page500.backButton": "BACK HOME",
		"page.forgetPassTitle": "Isomorphic",
		"page.forgetPassSubTitle": "Forgot Password?",
		"page.forgetPassDescription": "Enter your email and we send you a reset link.",
		"page.sendRequest": "Send request",
		"page.resetPassTitle": "Isomorphic",
		"page.resetPassSubTitle": "Reset Password",
		"page.resetPassDescription": "Enter new password and confirm it.",
		"page.resetPassSave": "Save",
		"page.signInTitle": "Isomorphic",
		"page.signInRememberMe": "Remember me",
		"page.signInButton": "Sign in",
		"page.signInPreview": "username: demo   password: demodemo   or just click on any button.",
		"page.signInFacebook": "Sign in with Facebook",
		"page.signInGooglePlus": "Sign in with Google Plus",
		"page.signInAuth0": "Sign in with Auth0",
		"page.signInForgotPass": "Forgot password",
		"page.signInCreateAccount": "Create an Isomorphoic account",
		"page.signUpTitle": "Isomorphic",
		"page.signUpTermsConditions": "I agree with terms and condtions",
		"page.signUpButton": "Sign Up",
		"page.signUpFacebook": "Sign up with Facebook",
		"page.signUpGooglePlus": "Sign up with Google Plus",
		"page.signUpAuth0": "Sign Up with Auth0",
		"page.signUpAlreadyAccount": "Already have an account? Sign in.",
		"widget.reportswidget.label": "Income",
		"widget.reportswidget.details": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor",
		"widget.singleprogresswidget1.label": "Marketing",
		"widget.singleprogresswidget2.label": "Addvertisement",
		"widget.singleprogresswidget3.label": "Consulting",
		"widget.singleprogresswidget4.label": "Development",
		"widget.stickerwidget1.number": "210",
		"widget.stickerwidget1.text": "Unread Email",
		"widget.stickerwidget2.number": "1749",
		"widget.stickerwidget2.text": "Image Upload",
		"widget.stickerwidget3.number": "3024",
		"widget.stickerwidget3.text": "Total Message",
		"widget.stickerwidget4.number": "54",
		"widget.stickerwidget4.text": "Orders Post",
		"widget.salewidget1.label": "Income",
		"widget.salewidget1.price": "$15000",
		"widget.salewidget1.details": "Downloads + 30%",
		"widget.salewidget2.label": "Income",
		"widget.salewidget2.price": "$15000",
		"widget.salewidget2.details": "Cost Per Acquistion",
		"widget.salewidget3.label": "Income",
		"widget.salewidget3.price": "$15000",
		"widget.salewidget3.details": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor",
		"widget.salewidget4.label": "Income",
		"widget.salewidget4.price": "$15000",
		"widget.salewidget4.details": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor",
		"widget.cardwidget1.number": "110",
		"widget.cardwidget1.text": "New Messages",
		"widget.cardwidget2.number": "100%",
		"widget.cardwidget2.text": "Volume",
		"widget.cardwidget3.number": "137",
		"widget.cardwidget3.text": "Achievement",
		"widget.progresswidget1.label": "Download",
		"widget.progresswidget1.details": "50% Complete",
		"widget.progresswidget2.label": "Support",
		"widget.progresswidget2.details": "80% Satisfied Customer",
		"widget.progresswidget3.label": "Upload",
		"widget.progresswidget3.details": "65% Complete",
		"widget.vcardwidget.name": "Jhon Doe",
		"widget.vcardwidget.title": "Sr. iOS Developer",
		"widget.vcardwidget.description": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor ammet dolar consectetur adipisicing elit",
		"checkout.billingform.firstname": "First Name",
		"checkout.billingform.lastname": "Last Name",
		"checkout.billingform.company": "Company Name",
		"checkout.billingform.email": "Email Address",
		"checkout.billingform.mobile": "Mobile No",
		"checkout.billingform.country": "Country",
		"checkout.billingform.city": "City",
		"checkout.billingform.address": "Address",
		"checkout.billingform.addressoptional": "Apartment   suite   unit etc. (optional",
		"checkout.billingform.checkbox": "Create an account?",
		"antTable.title.image": "Image",
		"antTable.title.firstName": "First Name",
		"antTable.title.lastName": "Last Name",
		"antTable.title.city": "City",
		"antTable.title.street": "Street",
		"antTable.title.email": "Email",
		"antTable.title.dob": "DOB",
		"Map.leaflet.basicTitle": "Basic Map",
		"Map.leaflet.basicMarkerTitle": "Basic Map(With Default Marker",
		"Map.leaflet.leafletCustomMarkerTitle": "Basic Map(With Custom Icon Marker)",
		"Map.leaflet.leafletCustomHtmlMarkerTitle": "Basic Map(With Custom Html Marker",
		"Map.leaflet.leafletMarkerClusterTitle": "Basic Map(With Marker Cluster",
		"Map.leaflet.leafletRoutingTitle": "Basic Map Routing",
		"Component.contacts.noOption": "No contact found",
		"email.send": "SEND",
		"email.cancel": "CANCEL",
		"email.compose": "COMPOSE",
		"email.noMessage": "Please select a mail to read",
		"themeSwitcher.purchase": "PURCHAGE NOW",
		"themeSwitcher.settings": "Settings",
		"sidebar.selectbox": "Select",
		"sidebar.frappeChart": "Frappe Charts",
		"topbar.help": "Help",
		"topbar.logout": "Logout",
		"topbar.viewAll": "View All",
		"topbar.viewCart": "View Cart",
		"topbar.totalPrice": "Total Price"
	};

/***/ },
/* 2301 */
/***/ function(module, exports) {

	module.exports = {
		"sidebar.email": "Email",
		"sidebar.ecommerce": "Ecommerce",
		"sidebar.shop": "tienda",
		"sidebar.cart": "Carro",
		"sidebar.checkout": "revisa",
		"sidebar.cards": "Divertido Tarjetas",
		"sidebar.maps": "Mapas",
		"sidebar.googleMap": "Mapa de Google",
		"sidebar.leafletMap": "Mapa del folleto",
		"sidebar.calendar": "Calendario",
		"sidebar.notes": "Notas",
		"sidebar.todos": "Todos",
		"sidebar.contacts": "Contactos",
		"sidebar.shuffle": "Barajar",
		"sidebar.charts": "Gráficos",
		"sidebar.googleCharts": "Google Carts",
		"sidebar.recharts": "Recharts",
		"sidebar.reactVis": "Reaccionar Vis",
		"sidebar.reactChart2": "React-Chart-2",
		"sidebar.reactTrend": "Reaccionar",
		"sidebar.eChart": "Echart",
		"sidebar.forms": "Formularios",
		"sidebar.input": "Entrada",
		"sidebar.editor": "Editor",
		"sidebar.formsWithValidation": "Formularios con validación",
		"sidebar.progress": "Progreso",
		"sidebar.button": "Botón",
		"sidebar.tab": "Lengüeta",
		"sidebar.checkbox": "Caja",
		"sidebar.radiobox": "Radiobox",
		"sidebar.selectbox": "Seleccionar",
		"sidebar.transfer": "Transferir",
		"sidebar.autocomplete": "Autocompletar",
		"sidebar.boxOptions": "Opciones de Caja",
		"sidebar.uiElements": "Elementos de la interfaz de usuario",
		"sidebar.badge": "Distintivo",
		"sidebar.card2": "Tarjeta",
		"sidebar.corusel": "Parranda",
		"sidebar.collapse": "Colapso",
		"sidebar.popover": "Acercarse",
		"sidebar.tooltip": "Tooltip",
		"sidebar.tag": "Etiqueta",
		"sidebar.timeline": "Cronograma",
		"sidebar.dropdown": "Desplegable",
		"sidebar.pagination": "Paginación",
		"sidebar.rating": "Clasificación",
		"sidebar.tree": "Árbol",
		"sidebar.advancedElements": "Elementos avanzados",
		"sidebar.reactDates": "Reaccionar fechas",
		"sidebar.codeMirror": "Código Espejo",
		"sidebar.uppy": "Uppy Uploader",
		"sidebar.dropzone": "Zona de descenso",
		"sidebar.feedback": "Realimentación",
		"sidebar.alert": "Alerta",
		"sidebar.modal": "Modal",
		"sidebar.message": "Mensaje",
		"sidebar.notification": "Notificación",
		"sidebar.popConfirm": "Pop confirmar",
		"sidebar.spin": "Girar",
		"sidebar.tables": "Mesas",
		"sidebar.antTables": "Tablas de hormigas",
		"sidebar.pages": "Páginas",
		"sidebar.500": "500",
		"sidebar.404": "404",
		"sidebar.signIn": "Registrarse",
		"sidebar.signUp": "Regístrate",
		"sidebar.forgotPw": "Olvidé contraseñas",
		"sidebar.resetPw": "Restablecer contraseñas",
		"sidebar.invoice": "Factura",
		"sidebar.menuLevels": "Niveles de menú",
		"sidebar.item1": "Artículo 1",
		"sidebar.item2": "Artículo 2",
		"sidebar.option1": "Opción 1",
		"sidebar.option2": "opcion 2",
		"sidebar.option3": "Opción 3",
		"sidebar.option4": "Opción 4",
		"sidebar.blankPage": "Página en blanco",
		"sidebar.githubSearch": "Github Buscar",
		"sidebar.youtubeSearch": "Búsqueda de Youtube",
		"languageSwitcher.label": "Cambiar idioma",
		"themeSwitcher": "Selector de temas",
		"themeSwitcher.Sidebar": "Barra lateral",
		"themeSwitcher.Topbar": "Barra superior",
		"themeSwitcher.Background": "Fondo",
		"feedback.alert.basicTitle": "Título Básico",
		"feedback.alert.successText": "Texto de éxito",
		"feedback.alert.infoText": "Texto de la información",
		"feedback.alert.warningText": "Texto de advertencia",
		"feedback.alert.errorText": "Texto de error",
		"feedback.alert.closableAlertType": "Tipo de Alerta Closable",
		"feedback.alert.iconAlertType": "Tipo de alerta de icono",
		"feedback.alert.iconInfoAlertType": "Tipo de Alerta",
		"feedback.alert.successTips": "consejos de éxito",
		"feedback.alert.successTipsDescription": "Descripción detallada y consejos sobre copywriting exitoso.",
		"feedback.alert.informationTips": "Notas informativas",
		"feedback.alert.informationDescription": "Descripción adicional e informaciones sobre copywriting.",
		"feedback.alert.warningTips": "Advertencia",
		"feedback.alert.warningDescription": "Este es un aviso de advertencia sobre copywriting.",
		"feedback.alert.errorTips": "Error",
		"feedback.alert.errorDescription": "Este es un mensaje de error acerca de copywriting.",
		"feedback.alert.modalTitle": "Modal uno con personalizar Footer",
		"feedback.alert.modalSubTitle": "Diálogo modal básico.",
		"feedback.alert.successTitle": "Éxito",
		"feedback.alert.infoTitle": "Información",
		"feedback.alert.errorTitle": "Error",
		"feedback.alert.warningTitle": "Advertencia",
		"feedback.alert.modalBlockTitle": "Modal",
		"feedback.alert.confirmationModalDialogue": "Cuadro de diálogo modal de confirmación",
		"feedback.alert.simpleModalDialogue": "Diálogo modal simple",
		"feedback.alert.message": "Mensaje",
		"feedback.alert.normalMessageTitle": "Mensaje normal",
		"feedback.alert.normalMessageSubtitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.displayMessage": "Mostrar mensaje normal",
		"feedback.alert.displayOtherTypeMessageTitle": "Otros tipos de mensaje",
		"feedback.alert.displayOtherTypeMessageSubTitle": "Mensajes de éxito   error y tipos de advertencia.",
		"feedback.alert.customizeDurationTitle": "Personalizar duración",
		"feedback.alert.customizeDurationSubTitle": "ustomize la duración de la exhibición del mensaje de 1.5s a 10s por defecto.",
		"feedback.alert.customizeDurationButton": "Duración de la pantalla personalizada",
		"feedback.alert.messageLoadingTitle": "Mensaje de carga",
		"feedback.alert.messageLoadingSubTitle": "Mostrar un indicador de carga global   que se descarta por sí mismo de forma asíncrona.",
		"feedback.alert.displayLoadIndicator": "Mostrar un indicador de carga",
		"feedback.alert.notification": "Notificación",
		"feedback.alert.notificationBasicTitle": "BASIC",
		"feedback.alert.notificationBasicSubTitle": "El uso más simple que cierre la caja de notificación después de 4.5s.",
		"feedback.alert.notificationBasicDescription": "Abrir el cuadro de notificación",
		"feedback.alert.notificationDurationTitle": "Duración después de la cual se cierra el cuadro de notificación",
		"feedback.alert.notificationDurationSubTitle": "La duración se puede utilizar para especificar cuánto tiempo permanece abierta la notificación. Una vez transcurrido el tiempo de duración   la notificación se cierra automáticamente. Si no se especifica   el valor predeterminado es 4  5 segundos. Si establece el valor en 0   el cuadro de notificación nunca se cerrará automáticamente.",
		"feedback.alert.notificationwithIconTitle": "Notificación con icono",
		"feedback.alert.notificationwithIconSubTitle": "Un cuadro de notificación con un icono en el lado izquierdo.",
		"feedback.alert.notificationwithCustomIconTitle": "Notificación con icono personalizado",
		"feedback.alert.notificationwithCustomIconSubTitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.notificationwithCustomButtonTitle": "Notificación con botón personalizado",
		"feedback.alert.notificationwithCustomButtonSubTitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.popConfirm": "Pop confirmar",
		"feedback.alert.popConfirm.basicTitle": "Confirmación básica",
		"feedback.alert.popConfirm.basicSubTitle": "El ejemplo básico.",
		"feedback.alert.popConfirm.delete": "Borrar",
		"feedback.alert.popConfirm.notiWithIconTitle": "Notificación con icono personalizado",
		"feedback.alert.popConfirm.notiWithIconSubTitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.popConfirm.TL": "TL",
		"feedback.alert.popConfirm.top": "Parte superior",
		"feedback.alert.popConfirm.TR": "TR",
		"feedback.alert.popConfirm.LT": "LT",
		"feedback.alert.popConfirm.left": "Izquierda",
		"feedback.alert.popConfirm.LB": "LB",
		"feedback.alert.popConfirm.RT": "RT",
		"feedback.alert.popConfirm.right": "Derecha",
		"feedback.alert.popConfirm.RB": "RB",
		"feedback.alert.popConfirm.Bl": "licenciado en Derecho",
		"feedback.alert.popConfirm.bottom": "Fondo",
		"feedback.alert.popConfirm.BR": "BR",
		"feedback.alert.spin": "Girar",
		"feedback.alert.spin.basicTitle": "Girar el tamaño",
		"feedback.alert.spin.background": "Girar con fondo",
		"feedback.alert.spin.backgroundDescription": "Descripción de Spin With Background",
		"feedback.alert.spin.loadingState": "Estado de carga ",
		"feedback.alert.spin.alertTitle": "Título del mensaje de alerta",
		"feedback.alert.spin.alertDescription": "Más detalles sobre el contexto de esta alerta.",
		"forms.input.header": "Entrada",
		"forms.input.basicTitle": "Uso básico",
		"forms.input.basicSubTitle": "Ejemplo de uso básico.",
		"forms.input.variationsTitle": "Tres tamaños de entrada",
		"forms.input.variationsSubtitle": "Hay tres tamaños de un cuadro de entrada  grande (42px     predeterminado (35px   y pequeño (30px  . Nota  Dentro de los formularios   sólo se utiliza el tamaño grande.",
		"forms.input.groupTitle": "Grupo de entrada",
		"forms.input.groupSubTitle": "Ejemplo de Input.Group Nota  No necesita Col para controlar el ancho en el modo compacto.",
		"forms.input.autoSizingTitle": "Autosizing la altura para ajustar el contenido",
		"forms.input.autoSizingSubTitle": "prop de autosize para un tipo de entrada textarea hace que la altura se ajuste automáticamente en función del contenido. Se puede proporcionar un objeto de opciones al tamaño automático para especificar el número mínimo y máximo de líneas que la zona de texto ajustará automáticamente.",
		"forms.input.prePostTabTitle": "Pestaña Pre    Post",
		"forms.input.prePostTabSubTitle": "El uso de pre & amp; post tabs ejemplo ..",
		"forms.input.textAreaTitle": "Área de texto",
		"forms.input.textAreaSubTitle": "Para casos de entrada de usuario multi-línea   se puede utilizar una entrada cuyo tipo prop tiene el valor de textarea.",
		"forms.input.searchTitle": "Buscar",
		"forms.input.searchSubTitle": "Ejemplo de creación de un cuadro de búsqueda agrupando una entrada estándar con un botón de búsqueda",
		"forms.editor.header": "Editor",
		"forms.formsWithValidation.header": "Formulario de validación personalizado",
		"forms.formsWithValidation.failLabel": "Fallar",
		"forms.formsWithValidation.failHelp": "Debe ser la combinación de números & amp; alfabetos",
		"forms.formsWithValidation.warningLabel": "Advertencia",
		"forms.formsWithValidation.ValidatingLabel": "Validando",
		"forms.formsWithValidation.ValidatingHelp": "La información está siendo validada ...",
		"forms.formsWithValidation.SuccessLabel": "Éxito",
		"forms.formsWithValidation.WarninghasFeedbackLabel": "Advertencia",
		"forms.formsWithValidation.FailhasFeedbackLabel": "Fallar",
		"forms.formsWithValidation.FailhasFeedbackHelp": "Debe ser la combinación de números & amp; alfabetos",
		"forms.progressBar.header": "Barra de progreso",
		"forms.progressBar.standardTitle": "Barra de progreso",
		"forms.progressBar.standardSubTitle": "Una barra de progreso estándar.",
		"forms.progressBar.circularTitle": "Barra de progreso circular",
		"forms.progressBar.circularSubTitle": "Una barra de progreso circular.",
		"forms.progressBar.miniTitle": "Barra de progreso de tamaño mini",
		"forms.progressBar.miniSubTitle": "Adecuado para un área estrecha.",
		"forms.progressBar.miniCircularTitle": "Una barra de progreso circular más pequeña.",
		"forms.progressBar.dynamicCircularTitle": "Barra de progreso circular dinámica",
		"forms.progressBar.dynamicCircularSubTitle": "Una barra de progreso dinámica es mejor.",
		"forms.progressBar.customTextTitle": "Formato de texto personalizado",
		"forms.progressBar.customTextSubTitle": "Puede personalizar el formato de texto configurando el formato.",
		"forms.progressBar.dashboardTitle": "Tablero",
		"forms.progressBar.dashboardSubTitle": "Un estilo de progreso en el tablero de instrumentos.",
		"forms.button.header": "Botones",
		"forms.button.simpleButton": "Tipo de botón",
		"forms.button.iconButton": "Icono de botón",
		"forms.button.simpleButtonPrimaryText": "Primario",
		"forms.button.simpleButtonDefaultText": "Defecto",
		"forms.button.simpleButtonDashedText": "Dañado",
		"forms.button.simpleButtonDangerText": "Peligro",
		"forms.button.iconPrimaryButton": "buscar",
		"forms.button.iconSimpleButton": "buscar",
		"forms.button.iconCirculerButton": "buscar",
		"forms.button.iconDashedButton": "buscar",
		"forms.button.SizedButton": "Tamaño del botón",
		"forms.button.DisabledButton": "Botón desactivado",
		"forms.button.LoadingButton": "Botón de carga",
		"forms.button.MultipleButton": "Botón múltiple",
		"forms.button.groupButton": "Grupo de botones",
		"forms.Tabs.header": "Pestañas",
		"forms.Tabs.simpleTabTitle": "buscar",
		"forms.Tabs.simpleTabSubTitle": "Pestañas inhabilitadas",
		"forms.Tabs.iconTabTitle": "Icono de las pestañas",
		"forms.Tabs.miniTabTitle": "Mini pestañas",
		"forms.Tabs.extraTabTitle": "Pestañas de acción adicionales",
		"forms.Tabs.TabpositionTitle": "Posición",
		"forms.Tabs.TabpositionSubTitle": "Posición de las pestañas  izquierda   derecha   arriba o abajo",
		"forms.Tabs.cardTitle": "Fichas de tipo de tarjeta",
		"forms.Tabs.editableTitle": "Agregar y cerrar pestañas",
		"forms.Tabs.verticalTitle": "Fichas de tipo vertical",
		"forms.Tabs.basicTitle": "Pestañas básicas",
		"forms.checkbox.header": "Caja",
		"forms.checkbox.basicTitle": "Casilla de verificación básica",
		"forms.checkbox.basicSubTitle": "Uso básico de la casilla de verificación.",
		"forms.checkbox.groupTitle": "Grupo de casillas de verificación",
		"forms.checkbox.groupSubTitle": "Genera un grupo de casillas de verificación de una matriz. Utilizar desactivado para deshabilitar una casilla de verificación.",
		"forms.checkbox.groupCheckTitle": "Grupo de casillas de verificación",
		"forms.checkbox.groupCheckSubTitle": "Genera un grupo de casillas de verificación de una matriz. Utilizar desactivado para deshabilitar una casilla de verificación.",
		"forms.radio.header": "Radio",
		"forms.radio.simpleTitle": "Radio básica",
		"forms.radio.simpleSubTitle": "El uso más simple. Utilizar desactivado para desactivar una radio.",
		"forms.radio.groupTitle": "Grupo de radio vertical",
		"forms.radio.groupSubTitle": "Vertical RadioGroup   con más radios.",
		"forms.radio.groupSecondTitle": "Grupo de radio",
		"forms.radio.groupSecondSubTitle": "Un grupo de componentes de radio.",
		"forms.radio.groupThirdTitle": "Grupo de radio",
		"forms.radio.groupThirdSubTitle": "Un grupo de componentes de radio.",
		"forms.transfer.header": "Transferir",
		"forms.transfer.SubTitle": "Transferir con un cuadro de búsqueda.",
		"forms.transfer.Title": "Buscar",
		"forms.autocomplete.header": "Autocompletar",
		"forms.autocomplete.simpleTitle": "Personalizado",
		"forms.autocomplete.simpleSubTitle": "Puede pasar AutoComplete.Option como hijos de Autocompletar   en lugar de utilizar dataSource",
		"forms.autocomplete.customizeTitle": "Personalizar el componente de entrada",
		"forms.autocomplete.customizeSubTitle": "Personalizar el componente de entrada",
		"uiElements.badge.badge": "Distintivo",
		"uiElements.badge.basicExample": "Ejemplo Básico",
		"uiElements.badge.basicExampleSubTitle": "Uso más simple. La insignia se ocultará cuando count sea 0   pero podemos usar showZero para mostrarlo.",
		"uiElements.badge.overflowCount": "Cuenta de desbordamiento",
		"uiElements.badge.overflowCountSubTitle": "OverflowCount se muestra cuando count es mayor que overflowCount. El valor predeterminado de overflowCount es 99.",
		"uiElements.badge.status": "Estado",
		"uiElements.badge.statusSubTitle": "Insignia autónoma con estado.",
		"uiElements.badge.success": "Éxito",
		"uiElements.badge.error": "Error",
		"uiElements.badge.default": "Defecto",
		"uiElements.badge.processing": "Tratamiento",
		"uiElements.badge.warning": "Advertencia",
		"uiElements.badge.redBadge": "Insignia roja",
		"uiElements.badge.redBadgeSubTitle": "Esto simplemente mostrará una insignia roja   sin un conteo específico.",
		"uiElements.badge.linkSomething": "Enlace algo",
		"uiElements.cards.cards": "Divertido Tarjetas",
		"uiElements.cards.basicCard": "Tarjeta básica",
		"uiElements.cards.basicCardSubTitle": "Una tarjeta básica que contiene un título   contenido y un contenido de esquina adicional.",
		"uiElements.cards.more": "Más",
		"uiElements.cards.cardTitle": "Título de la tarjeta",
		"uiElements.cards.cardContent": "Contenido de la tarjeta",
		"uiElements.cards.lorem": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor incididunt ut labore y dolore magna aliqua. Ut enim ad minim veniam   quis nostrud ejercicio ullamco laboris nisi ut aliquip ex y commodo consequat.",
		"uiElements.cards.noBorder": "Sin bordes",
		"uiElements.cards.noBorderSubTitle": "Una tarjeta sin fronteras sobre un fondo gris.",
		"uiElements.cards.gridCard": "Tarjeta de red",
		"uiElements.cards.gridCardSubTitle": "Las tarjetas suelen cooperar con el diseño de la cuadrícula en la página de vista general.",
		"uiElements.cards.loadingCard": "Carga de la tarjeta",
		"uiElements.cards.loadingCardSubTitle": "Muestra un indicador de carga mientras se está recuperando el contenido de la tarjeta.",
		"uiElements.cards.whateverContent": "Cualquier contenido",
		"uiElements.cards.customizedContentTitle": "Contenido personalizado",
		"uiElements.cards.customizedContent": "Muestra un indicador de carga mientras se está recuperando el contenido de la tarjeta.",
		"uiElements.cards.europeStreetBeat": "Europa Street beat",
		"uiElements.cards.instagram": "www.instagram.com",
		"uiElements.carousel.carousel": "Parranda",
		"uiElements.carousel.verticalCarousel": "Carrusel vertical",
		"uiElements.carousel.verticalCarouselSubTitle": "Paginación vertical. use   vertical = true  ",
		"uiElements.carousel.basicCarousel": "Carrusel básico",
		"uiElements.carousel.basicCarouselSubTitle": "Uso básico",
		"uiElements.carousel.fadeInTransition": "Fade In Transition",
		"uiElements.carousel.fadeInTransitionSubTitle": "Las diapositivas utilizan el fundido para la transición.   effect = fade  ",
		"uiElements.carousel.scrollAutomatically": "Desplazarse automáticamente",
		"uiElements.carousel.scrollAutomaticallySubTitle": "Tiempo de desplazamiento a la siguiente tarjeta    imagen. auto reproducción",
		"uiElements.collapse.collapse": "Colapso",
		"uiElements.collapse.collapseSubTitle": "Se puede ampliar más de un panel a la vez   el primer panel se inicializa para estar activo en este caso. use   defaultActiveKey =   [keyNum]    ",
		"uiElements.collapse.text": "Un perro es un tipo de animal domesticado. Conocido por su lealtad y fidelidad   se puede encontrar como un invitado de bienvenida en muchos hogares de todo el mundo.",
		"uiElements.collapse.headerOne": "Este es el encabezado del panel 1",
		"uiElements.collapse.headerTwo": "Se trata de la cabecera del panel 2",
		"uiElements.collapse.headerThree": "Este es el encabezado del panel 3",
		"uiElements.collapse.headerNested": "Éste es panel del nido del panel",
		"uiElements.collapse.nestedExample": "Ejemplo anidado",
		"uiElements.collapse.nestedExampleSubTitle": "Collapse está anidado dentro del Collapse.",
		"uiElements.collapse.borderlessExample": "Ejemplo sin márgenes",
		"uiElements.collapse.borderlessExampleSubTitle": "Un estilo sin fronteras de Collapse. use   bordered =   false    ",
		"uiElements.collapse.accordion": "Acordeón",
		"uiElements.collapse.accordionSubTitle": "Acordeón   sólo se puede ampliar un panel cada vez. El primer panel se ampliará de forma predeterminada. utilizar acordeón",
		"uiElements.popover.popover": "Popover",
		"uiElements.popover.basicExample": "Ejemplo Básico",
		"uiElements.popover.basicExampleSubTitle": "El ejemplo más básico. El tamaño de la capa flotante depende de la región del contenido.",
		"uiElements.popover.hoverMe": "Mírame",
		"uiElements.popover.title": "Título",
		"uiElements.popover.titleTrigger": "Tres maneras de activar",
		"uiElements.popover.titleTriggerSubTitle": "El ratón para hacer clic   enfocar y moverse.",
		"uiElements.popover.focusMe": "Enfócame",
		"uiElements.popover.clickMe": "Haz click en mi",
		"uiElements.popover.placement": "Colocación",
		"uiElements.popover.placementSubTitle": "Hay 12 opciones de colocación disponibles.",
		"uiElements.popover.top": "Parte superior",
		"uiElements.popover.topLeft": "Arriba a la izquierda",
		"uiElements.popover.topRight": "Parte superior derecha",
		"uiElements.popover.leftTop": "Parte superior izquierda",
		"uiElements.popover.left": "Izquierda",
		"uiElements.popover.leftBottom": "Abajo a la izquierda",
		"uiElements.popover.rightTop": "Justo arriba",
		"uiElements.popover.right": "Derecha",
		"uiElements.popover.bottom": "Fondo",
		"uiElements.popover.bottomLeft": "Abajo Izquierda",
		"uiElements.popover.bottomRight": "Abajo a la derecha",
		"uiElements.popover.boxTitle": "Control del cierre del diálogo",
		"uiElements.popover.boxSubTitle": "Utilice el apoyo visible para controlar la visualización de la tarjeta.",
		"uiElements.popover.TR": "TR",
		"uiElements.popover.TL": "TL",
		"uiElements.popover.LT": "LT",
		"uiElements.popover.LB": "LB",
		"uiElements.popover.RT": "RT",
		"uiElements.popover.RB": "RB",
		"uiElements.popover.BL": "licenciado en Derecho",
		"uiElements.popover.BR": "BR",
		"uiElements.popover.close": "Cerca",
		"uiElements.tooltip.tooltip": "Tooltip",
		"uiElements.tooltip.tooltipContent": "Contenido de información sobre herramientas",
		"uiElements.tooltip.basicExample": "Ejemplo Básico",
		"uiElements.tooltip.basicExampleSubTitle": "El uso más simple.",
		"uiElements.tooltip.placementTitle": "Colocación",
		"uiElements.tooltip.placementSubTitle": "La herramienta tiene 12 opciones de ubicación.",
		"uiElements.tooltip.TL": "TL",
		"uiElements.tooltip.TR": "TR",
		"uiElements.tooltip.LT": "LT",
		"uiElements.tooltip.LB": "LB",
		"uiElements.tooltip.RT": "RT",
		"uiElements.tooltip.RB": "RB",
		"uiElements.tooltip.BL": "licenciado en Derecho",
		"uiElements.tooltip.BR": "BR",
		"uiElements.tooltip.bottom": "Fondo",
		"uiElements.tooltip.right": "Derecha",
		"uiElements.tooltip.left": "Izquierda",
		"uiElements.tooltip.top": "Parte superior",
		"uiElements.tooltip.tooltipContentSpan": "La información sobre herramientas se mostrará cuando se introduzca el ratón.",
		"uiElements.tooltip.contentSpan": "Contenido de información sobre herramientas",
		"uiElements.tags.tags": "Etiquetas",
		"uiElements.tags.basicExample": "Ejemplo Básico",
		"uiElements.tags.basicExampleSubTitle": "Uso de la etiqueta básica   y podría ser cerrable por la propiedad cerrable del sistema. La etiqueta Closable soporta eventos onClose afterClose.",
		"uiElements.tags.tagOne": "Etiqueta 1",
		"uiElements.tags.tagTwo": "Etiqueta 2",
		"uiElements.tags.link": "Enlazar",
		"uiElements.tags.preventDefault": "Prevenga el Incumplimiento",
		"uiElements.tags.colorfulTag": "Etiqueta colorida",
		"uiElements.tags.hotTags": "Etiquetas populares",
		"uiElements.tags.hotTagsSubTitle": "Seleccione sus temas favoritos.",
		"uiElements.tags.hots": "Hots ",
		"uiElements.tags.addRemoveDynamically": "Agregar y eliminar dinámicamente",
		"uiElements.tags.addRemoveDynamicallySubTitle": "Generando un conjunto de etiquetas por matriz   puede agregar y quitar dinámicamente. Se basa en el evento afterClose   que se activará mientras finaliza la animación de cierre.",
		"uiElements.tags.newTag": "+ Nueva etiqueta",
		"uiElements.timeline.timeline": "Cronograma",
		"uiElements.timeline.basicExample": "Ejemplo Básico",
		"uiElements.timeline.basicTimeline": "Línea de tiempo básica",
		"uiElements.timeline.lastNode": "Ultimo nodo",
		"uiElements.timeline.lastNodeContent": "Cuando la línea de tiempo está incompleta y en curso   poner un nodo fantasma por fin. set   pending =   true     o   pending =   un elemento React    ",
		"uiElements.timeline.seeMore": "Ver más",
		"uiElements.timeline.custom": "Personalizado",
		"uiElements.timeline.customContent": "Establezca un nodo como un icono u otro elemento personalizado.",
		"uiElements.timeline.colorExample": "Ejemplo de color",
		"uiElements.timeline.colorExampleContent": "Establecer el color de los círculos. verde significa estado completado o de éxito   rojo significa advertencia o error y azul significa estado en curso u otro estado predeterminado.",
		"uiElements.timeline.createServiceSite": "Crear un sitio de servicios 2015-09-01",
		"uiElements.timeline.solveInitialNetwork": "Resolver problemas de red iniciales 2015-09-01",
		"uiElements.timeline.networkProblemSolved": "Problemas de red resueltos 2015-09-01",
		"uiElements.timeline.technicalTesting": "Pruebas técnicas 2015-09-01",
		"uiElements.dropdown.dropdown": "Desplegable",
		"uiElements.dropdown.hoverDropdown": "Desplácese",
		"uiElements.dropdown.hoverMe": "Mírame",
		"uiElements.dropdown.hoverPlacement": "Despliegue de colocación de cola",
		"uiElements.dropdown.hoverDisableLink": "Desplazamiento con desplegable",
		"uiElements.dropdown.clickedDropdown": "Desplegable pulsado",
		"uiElements.dropdown.buttonDropdown": "Botón con menú desplegable",
		"uiElements.pagination.pagination": "Paginación",
		"uiElements.pagination.basic": "BASIC",
		"uiElements.pagination.more": "Más",
		"uiElements.pagination.changer": "Cambiador",
		"uiElements.pagination.jumper": "Saltador",
		"uiElements.pagination.miniSize": "Tamaño mini",
		"uiElements.pagination.simpleMode": "Modo simple",
		"uiElements.pagination.controlled": "Revisado",
		"uiElements.pagination.totalNumber": "Numero total",
		"uiElements.rating.rating": "Clasificación",
		"uiElements.rating.basicExample": "Ejemplo Básico",
		"uiElements.rating.basicExampleSubTitle": "El uso más simple.",
		"uiElements.rating.halfStar": "Media estrella",
		"uiElements.rating.halfStarSubTitle": "Soporte de media estrella.",
		"uiElements.rating.showCopywriting": "Mostrar copywriting",
		"uiElements.rating.showCopywritingSubTitle": "Añadir copywriting en los componentes de la tarifa.",
		"uiElements.rating.readOnly": "Solo lectura",
		"uiElements.rating.readOnlySubTitle": "Sólo lectura   no puede utilizar el ratón para interactuar.",
		"uiElements.rating.otherCharacter": "Otro Personaje",
		"uiElements.rating.otherCharacterSubTitle": "Reemplace la estrella predeterminada por otro carácter como alfabeto   dígito   iconfonte o incluso palabra china.",
		"uiElements.tree.tree": "Árbol",
		"uiElements.tree.basicExample": "Ejemplo básico",
		"uiElements.tree.basicExampleSubTitle": "El uso más básico   te dirá cómo usar checkable   seleccionable   disabled   defaultExpandKeys   y etc.",
		"uiElements.tree.basicControlledExample": "Ejemplo controlado básico",
		"uiElements.tree.basicControlledExampleSubTitle": "ejemplo controlado básico",
		"uiElements.tree.draggableExample": "Ejemplo arrastrable",
		"uiElements.tree.draggableExampleSubTitle": "Arrastre treeNode para insertar después del otro treeNode o inserte en el otro TreeNode padre.",
		"uiElements.tree.loadAsync": "Cargar datos asincrónicamente",
		"uiElements.tree.loadAsyncSubTitle": "Para cargar datos asincrónicamente cuando haga clic para expandir un treeNode.",
		"uiElements.tree.searchableExample": "Ejemplo de búsqueda",
		"uiElements.tree.searchableExampleSubTitle": "Árbol de búsqueda",
		"uiElements.tree.treeWithLine": "Árbol con línea",
		"shuffle.descriptionOne": "Netscape 2.0 se expande   introduciendo Javascript",
		"shuffle.descriptionTwo": "Jesse James Garrett lanza la especificación AJAX",
		"shuffle.descriptionThree": "jQuery 1.0 publicado",
		"shuffle.descriptionFour": "Primero underscore.js commit",
		"shuffle.descriptionFive": "Backbone.js se convierte en una cosa",
		"shuffle.descriptionSix": "Angular 1.0 liberado",
		"shuffle.descriptionSeven": "Reaccionar es de código abierto; los desarrolladores se regocijan",
		"toggle.list": "Lista",
		"toggle.grid": "Cuadrícula",
		"toggle.ascending": "Ascendente",
		"toggle.descending": "Descendente",
		"toggle.shuffle": "Barajar",
		"toggle.rotate": "Girar",
		"toggle.addItem": "Añadir artículo",
		"toggle.removeItem": "Remover el artículo",
		"contactlist.searchContacts": "Buscar contactos",
		"contactlist.addNewContact": "Añadir nuevo contacto",
		"notes.ChoseColor": "Elige un color para tu nota",
		"notes.addNote": "Añadir nueva nota",
		"page404.title": "404",
		"page404.subTitle": "Parece que te has perdido",
		"page404.description": "La página que estás buscando no existe o se ha movido.",
		"page404.backButton": "VOLVER A LA CASA",
		"page500.title": "500",
		"page500.subTitle": "error de servidor interno",
		"page500.description": "Algo salió mal. Por favor   inténtelo de nuevo.",
		"page500.backButton": "VOLVER A LA CASA",
		"page.forgetPassTitle": "Isomórfico",
		"page.forgetPassSubTitle": "¿Se te olvidó tu contraseña?",
		"page.forgetPassDescription": "Introduzca su correo electrónico y le enviaremos un enlace de restablecimiento.",
		"page.sendRequest": "Enviar petición",
		"page.resetPassTitle": "Isomórfico",
		"page.resetPassSubTitle": "Restablecer la contraseña",
		"page.resetPassDescription": "Introduzca una nueva contraseña y confirme.",
		"page.resetPassSave": "Salvar",
		"page.signInTitle": "Isomórfico",
		"page.signInRememberMe": "Recuérdame",
		"page.signInButton": "Registrarse",
		"page.signInPreview": "nombre de usuario  demo   contraseña  demodemo   o simplemente haga clic en cualquier botón.",
		"page.signInFacebook": "Iniciar sesión usando Facebook",
		"page.signInGooglePlus": "Acceder con Google Plus",
		"page.signInAuth0": "Iniciar sesión con Auth0",
		"page.signInForgotPass": "Se te olvidó tu contraseña",
		"page.signInCreateAccount": "Crear una cuenta Isomorphoic",
		"page.signUpTitle": "Isomórfico",
		"page.signUpTermsConditions": "Estoy de acuerdo con los términos y condiciones",
		"page.signUpButton": "Regístrate",
		"page.signUpFacebook": "Registrate con Facebook",
		"page.signUpGooglePlus": "Regístrese con Google Plus",
		"page.signUpAuth0": "Regístrese con Auth0",
		"page.signUpAlreadyAccount": "¿Ya tienes una cuenta? Registrarse.",
		"widget.reportswidget.label": "Ingresos",
		"widget.reportswidget.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.singleprogresswidget1.label": "Márketing",
		"widget.singleprogresswidget2.label": "Addvertisement",
		"widget.singleprogresswidget3.label": "Consultante",
		"widget.singleprogresswidget4.label": "Desarrollo",
		"widget.stickerwidget1.number": "210",
		"widget.stickerwidget1.text": "Correo electrónico no leído",
		"widget.stickerwidget2.number": "1749",
		"widget.stickerwidget2.text": "Subida de imagen",
		"widget.stickerwidget3.number": "3024",
		"widget.stickerwidget3.text": "Total de mensajes",
		"widget.stickerwidget4.number": "54",
		"widget.stickerwidget4.text": "Pedidos",
		"widget.salewidget1.label": "Ingresos",
		"widget.salewidget1.price": "15000 $",
		"widget.salewidget1.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.salewidget2.label": "Ingresos",
		"widget.salewidget2.price": "15000 $",
		"widget.salewidget2.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.salewidget3.label": "Ingresos",
		"widget.salewidget3.price": "15000 $",
		"widget.salewidget3.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.salewidget4.label": "Ingresos",
		"widget.salewidget4.price": "15000 $",
		"widget.salewidget4.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.cardwidget1.number": "110",
		"widget.cardwidget1.text": "Nuevos mensajes",
		"widget.cardwidget2.number": "100%",
		"widget.cardwidget2.text": "Volumen",
		"widget.cardwidget3.number": "137",
		"widget.cardwidget3.text": "Logro",
		"widget.progresswidget1.label": "Descargar",
		"widget.progresswidget1.details": "50% Completo",
		"widget.progresswidget2.label": "Apoyo",
		"widget.progresswidget2.details": "80% de clientes satisfechos",
		"widget.progresswidget3.label": "Subir",
		"widget.progresswidget3.details": "65% Completo",
		"widget.vcardwidget.name": "Jhon Doe",
		"widget.vcardwidget.title": "Sr. Desarrollador iOS",
		"widget.vcardwidget.description": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed eiusmod tempor ammet dolar consectetur adipisicing elit",
		"checkout.billingform.firstname": "Nombre de pila",
		"checkout.billingform.lastname": "Apellido",
		"checkout.billingform.company": "nombre de empresa",
		"checkout.billingform.email": "Dirección de correo electrónico",
		"checkout.billingform.mobile": "No móviles",
		"checkout.billingform.country": "País",
		"checkout.billingform.city": "Ciudad",
		"checkout.billingform.address": "Dirección",
		"checkout.billingform.addressoptional": "Apartamento   suite   unidad   etc. (opcional  ",
		"checkout.billingform.checkbox": "¿Crea una cuenta?",
		"antTable.title.image": "Imagen",
		"antTable.title.firstName": "Nombre de pila",
		"antTable.title.lastName": "Apellido",
		"antTable.title.city": "Ciudad",
		"antTable.title.street": "Calle",
		"antTable.title.email": "Email",
		"antTable.title.dob": "DOB",
		"Map.leaflet.basicTitle": "Mapa básico",
		"Map.leaflet.basicMarkerTitle": "Mapa básico (con marcador predeterminado  ",
		"Map.leaflet.leafletCustomMarkerTitle": "Mapa básico (con marcador de icono personalizado  ",
		"Map.leaflet.leafletCustomHtmlMarkerTitle": "Mapa básico (con marcador HTML personalizado  ",
		"Map.leaflet.leafletMarkerClusterTitle": "Mapa básico (con grupo de marcadores  ",
		"Map.leaflet.leafletRoutingTitle": "Enrutamiento básico del mapa",
		"Component.contacts.noOption": "No se ha encontrado ningún contacto",
		"email.send": "ENVIAR",
		"email.cancel": "CANCELAR",
		"email.compose": "COMPONER",
		"email.noMessage": "Por favor seleccione un correo para leer",
		"themeSwitcher.purchase": "Compra ahora",
		"themeSwitcher.settings": "AJUSTES",
		"sidebar.frappeChart": "Frappe Charts",
		"topbar.help": "Ayuda",
		"topbar.logout": "Cerrar sesión",
		"topbar.viewAll": "Ver todo",
		"topbar.viewCart": "Ver carro",
		"topbar.totalPrice": "Precio total"
	};

/***/ },
/* 2302 */
/***/ function(module, exports) {

	module.exports = {
		"sidebar.email": "Email",
		"sidebar.ecommerce": "Ecommerce",
		"sidebar.shop": "tienda",
		"sidebar.cart": "Carro",
		"sidebar.checkout": "revisa",
		"sidebar.cards": "Divertido Tarjetas",
		"sidebar.maps": "Mapas",
		"sidebar.googleMap": "Mapa de Google",
		"sidebar.leafletMap": "Mapa del folleto",
		"sidebar.calendar": "Calendario",
		"sidebar.notes": "Notas",
		"sidebar.todos": "Todos",
		"sidebar.contacts": "Contactos",
		"sidebar.shuffle": "Barajar",
		"sidebar.charts": "Gráficos",
		"sidebar.googleCharts": "Google Carts",
		"sidebar.recharts": "Recharts",
		"sidebar.reactVis": "Reaccionar Vis",
		"sidebar.reactChart2": "React-Chart-2",
		"sidebar.reactTrend": "Reaccionar",
		"sidebar.eChart": "Echart",
		"sidebar.forms": "Formularios",
		"sidebar.input": "Entrada",
		"sidebar.editor": "Editor",
		"sidebar.formsWithValidation": "Formularios con validación",
		"sidebar.progress": "Progreso",
		"sidebar.button": "Botón",
		"sidebar.tab": "Lengüeta",
		"sidebar.checkbox": "Caja",
		"sidebar.radiobox": "Radiobox",
		"sidebar.transfer": "Transferir",
		"sidebar.autocomplete": "Autocompletar",
		"sidebar.boxOptions": "Opciones de Caja",
		"sidebar.uiElements": "Elementos de la interfaz de usuario",
		"sidebar.badge": "Distintivo",
		"sidebar.card2": "Tarjeta",
		"sidebar.corusel": "Parranda",
		"sidebar.collapse": "Colapso",
		"sidebar.popover": "Acercarse",
		"sidebar.tooltip": "Tooltip",
		"sidebar.tag": "Etiqueta",
		"sidebar.timeline": "Cronograma",
		"sidebar.dropdown": "Desplegable",
		"sidebar.pagination": "Paginación",
		"sidebar.rating": "Clasificación",
		"sidebar.tree": "Árbol",
		"sidebar.advancedElements": "Elementos avanzados",
		"sidebar.reactDates": "Reaccionar fechas",
		"sidebar.codeMirror": "Código Espejo",
		"sidebar.uppy": "Uppy Uploader",
		"sidebar.dropzone": "Zona de descenso",
		"sidebar.feedback": "Realimentación",
		"sidebar.alert": "Alerta",
		"sidebar.modal": "Modal",
		"sidebar.message": "Mensaje",
		"sidebar.notification": "Notificación",
		"sidebar.popConfirm": "Pop confirmar",
		"sidebar.spin": "Girar",
		"sidebar.tables": "Mesas",
		"sidebar.antTables": "Tablas de hormigas",
		"sidebar.pages": "Páginas",
		"sidebar.500": "500",
		"sidebar.404": "404",
		"sidebar.signIn": "Registrarse",
		"sidebar.signUp": "Regístrate",
		"sidebar.forgotPw": "Olvidé contraseñas",
		"sidebar.resetPw": "Restablecer contraseñas",
		"sidebar.invoice": "Factura",
		"sidebar.menuLevels": "Niveles de menú",
		"sidebar.item1": "Artículo 1",
		"sidebar.item2": "Artículo 2",
		"sidebar.option1": "Opción 1",
		"sidebar.option2": "opcion 2",
		"sidebar.option3": "Opción 3",
		"sidebar.option4": "Opción 4",
		"sidebar.blankPage": "Página en blanco",
		"sidebar.githubSearch": "Github Buscar",
		"sidebar.youtubeSearch": "Búsqueda de Youtube",
		"languageSwitcher.label": "Cambiar idioma",
		"themeSwitcher": "Selector de temas",
		"themeSwitcher.Sidebar": "Barra lateral",
		"themeSwitcher.Topbar": "Barra superior",
		"themeSwitcher.Background": "Fondo",
		"feedback.alert.basicTitle": "Título Básico",
		"feedback.alert.successText": "Texto de éxito",
		"feedback.alert.infoText": "Texto de la información",
		"feedback.alert.warningText": "Texto de advertencia",
		"feedback.alert.errorText": "Texto de error",
		"feedback.alert.closableAlertType": "Tipo de Alerta Closable",
		"feedback.alert.iconAlertType": "Tipo de alerta de icono",
		"feedback.alert.iconInfoAlertType": "Tipo de Alerta",
		"feedback.alert.successTips": "consejos de éxito",
		"feedback.alert.successTipsDescription": "Descripción detallada y consejos sobre copywriting exitoso.",
		"feedback.alert.informationTips": "Notas informativas",
		"feedback.alert.informationDescription": "Descripción adicional e informaciones sobre copywriting.",
		"feedback.alert.warningTips": "Advertencia",
		"feedback.alert.warningDescription": "Este es un aviso de advertencia sobre copywriting.",
		"feedback.alert.errorTips": "Error",
		"feedback.alert.errorDescription": "Este es un mensaje de error acerca de copywriting.",
		"feedback.alert.modalTitle": "Modal uno con personalizar Footer",
		"feedback.alert.modalSubTitle": "Diálogo modal básico.",
		"feedback.alert.successTitle": "Éxito",
		"feedback.alert.infoTitle": "Información",
		"feedback.alert.errorTitle": "Error",
		"feedback.alert.warningTitle": "Advertencia",
		"feedback.alert.modalBlockTitle": "Modal",
		"feedback.alert.confirmationModalDialogue": "Cuadro de diálogo modal de confirmación",
		"feedback.alert.simpleModalDialogue": "Diálogo modal simple",
		"feedback.alert.message": "Mensaje",
		"feedback.alert.normalMessageTitle": "Mensaje normal",
		"feedback.alert.normalMessageSubtitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.displayMessage": "Mostrar mensaje normal",
		"feedback.alert.displayOtherTypeMessageTitle": "Otros tipos de mensaje",
		"feedback.alert.displayOtherTypeMessageSubTitle": "Mensajes de éxito   error y tipos de advertencia.",
		"feedback.alert.customizeDurationTitle": "Personalizar duración",
		"feedback.alert.customizeDurationSubTitle": "ustomize la duración de la exhibición del mensaje de 1.5s a 10s por defecto.",
		"feedback.alert.customizeDurationButton": "Duración de la pantalla personalizada",
		"feedback.alert.messageLoadingTitle": "Mensaje de carga",
		"feedback.alert.messageLoadingSubTitle": "Mostrar un indicador de carga global   que se descarta por sí mismo de forma asíncrona.",
		"feedback.alert.displayLoadIndicator": "Mostrar un indicador de carga",
		"feedback.alert.notification": "Notificación",
		"feedback.alert.notificationBasicTitle": "BASIC",
		"feedback.alert.notificationBasicSubTitle": "El uso más simple que cierre la caja de notificación después de 4.5s.",
		"feedback.alert.notificationBasicDescription": "Abrir el cuadro de notificación",
		"feedback.alert.notificationDurationTitle": "Duración después de la cual se cierra el cuadro de notificación",
		"feedback.alert.notificationDurationSubTitle": "La duración se puede utilizar para especificar cuánto tiempo permanece abierta la notificación. Una vez transcurrido el tiempo de duración   la notificación se cierra automáticamente. Si no se especifica   el valor predeterminado es 4  5 segundos. Si establece el valor en 0   el cuadro de notificación nunca se cerrará automáticamente.",
		"feedback.alert.notificationwithIconTitle": "Notificación con icono",
		"feedback.alert.notificationwithIconSubTitle": "Un cuadro de notificación con un icono en el lado izquierdo.",
		"feedback.alert.notificationwithCustomIconTitle": "Notificación con icono personalizado",
		"feedback.alert.notificationwithCustomIconSubTitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.notificationwithCustomButtonTitle": "Notificación con botón personalizado",
		"feedback.alert.notificationwithCustomButtonSubTitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.popConfirm": "Pop confirmar",
		"feedback.alert.popConfirm.basicTitle": "Confirmación básica",
		"feedback.alert.popConfirm.basicSubTitle": "El ejemplo básico.",
		"feedback.alert.popConfirm.delete": "Borrar",
		"feedback.alert.popConfirm.notiWithIconTitle": "Notificación con icono personalizado",
		"feedback.alert.popConfirm.notiWithIconSubTitle": "Mensajes normales como retroalimentación.",
		"feedback.alert.popConfirm.TL": "TL",
		"feedback.alert.popConfirm.top": "Parte superior",
		"feedback.alert.popConfirm.TR": "TR",
		"feedback.alert.popConfirm.LT": "LT",
		"feedback.alert.popConfirm.left": "Izquierda",
		"feedback.alert.popConfirm.LB": "LB",
		"feedback.alert.popConfirm.RT": "RT",
		"feedback.alert.popConfirm.right": "Derecha",
		"feedback.alert.popConfirm.RB": "RB",
		"feedback.alert.popConfirm.Bl": "licenciado en Derecho",
		"feedback.alert.popConfirm.bottom": "Fondo",
		"feedback.alert.popConfirm.BR": "BR",
		"feedback.alert.spin": "Girar",
		"feedback.alert.spin.basicTitle": "Girar el tamaño",
		"feedback.alert.spin.background": "Girar con fondo",
		"feedback.alert.spin.backgroundDescription": "Descripción de Spin With Background",
		"feedback.alert.spin.loadingState": "Estado de carga",
		"feedback.alert.spin.alertTitle": "Título del mensaje de alerta",
		"feedback.alert.spin.alertDescription": "Más detalles sobre el contexto de esta alerta.",
		"forms.input.header": "Entrada",
		"forms.input.basicTitle": "Uso básico",
		"forms.input.basicSubTitle": "Ejemplo de uso básico.",
		"forms.input.variationsTitle": "Tres tamaños de entrada",
		"forms.input.variationsSubtitle": "Hay tres tamaños de un cuadro de entrada  grande (42px     predeterminado (35px   y pequeño (30px  . Nota  Dentro de los formularios   sólo se utiliza el tamaño grande.",
		"forms.input.groupTitle": "Grupo de entrada",
		"forms.input.groupSubTitle": "Ejemplo de Input.Group Nota  No necesita Col para controlar el ancho en el modo compacto.",
		"forms.input.autoSizingTitle": "Autosizing la altura para ajustar el contenido",
		"forms.input.autoSizingSubTitle": "prop de autosize para un tipo de entrada textarea hace que la altura se ajuste automáticamente en función del contenido. Se puede proporcionar un objeto de opciones al tamaño automático para especificar el número mínimo y máximo de líneas que la zona de texto ajustará automáticamente.",
		"forms.input.prePostTabTitle": "Pestaña Pre    Post",
		"forms.input.prePostTabSubTitle": "El uso de pre & amp; post tabs ejemplo ..",
		"forms.input.textAreaTitle": "Área de texto",
		"forms.input.textAreaSubTitle": "Para casos de entrada de usuario multi-línea   se puede utilizar una entrada cuyo tipo prop tiene el valor de textarea.",
		"forms.input.searchTitle": "Buscar",
		"forms.input.searchSubTitle": "Ejemplo de creación de un cuadro de búsqueda agrupando una entrada estándar con un botón de búsqueda",
		"forms.editor.header": "Editor",
		"forms.formsWithValidation.header": "Formulario de validación personalizado",
		"forms.formsWithValidation.failLabel": "Fallar",
		"forms.formsWithValidation.failHelp": "Debe ser la combinación de números & amp; alfabetos",
		"forms.formsWithValidation.warningLabel": "Advertencia",
		"forms.formsWithValidation.ValidatingLabel": "Validando",
		"forms.formsWithValidation.ValidatingHelp": "La información está siendo validada ...",
		"forms.formsWithValidation.SuccessLabel": "Éxito",
		"forms.formsWithValidation.WarninghasFeedbackLabel": "Advertencia",
		"forms.formsWithValidation.FailhasFeedbackLabel": "Fallar",
		"forms.formsWithValidation.FailhasFeedbackHelp": "Debe ser la combinación de números & amp; alfabetos",
		"forms.progressBar.header": "Barra de progreso",
		"forms.progressBar.standardTitle": "Barra de progreso",
		"forms.progressBar.standardSubTitle": "Una barra de progreso estándar.",
		"forms.progressBar.circularTitle": "Barra de progreso circular",
		"forms.progressBar.circularSubTitle": "Una barra de progreso circular.",
		"forms.progressBar.miniTitle": "Barra de progreso de tamaño mini",
		"forms.progressBar.miniSubTitle": "Adecuado para un área estrecha.",
		"forms.progressBar.miniCircularTitle": "Una barra de progreso circular más pequeña.",
		"forms.progressBar.dynamicCircularTitle": "Barra de progreso circular dinámica",
		"forms.progressBar.dynamicCircularSubTitle": "Una barra de progreso dinámica es mejor.",
		"forms.progressBar.customTextTitle": "Formato de texto personalizado",
		"forms.progressBar.customTextSubTitle": "Puede personalizar el formato de texto configurando el formato.",
		"forms.progressBar.dashboardTitle": "Tablero",
		"forms.progressBar.dashboardSubTitle": "Un estilo de progreso en el tablero de instrumentos.",
		"forms.button.header": "Botones",
		"forms.button.simpleButton": "Tipo de botón",
		"forms.button.iconButton": "Icono de botón",
		"forms.button.simpleButtonPrimaryText": "Primario",
		"forms.button.simpleButtonDefaultText": "Defecto",
		"forms.button.simpleButtonDashedText": "Dañado",
		"forms.button.simpleButtonDangerText": "Peligro",
		"forms.button.iconPrimaryButton": "buscar",
		"forms.button.iconSimpleButton": "buscar",
		"forms.button.iconCirculerButton": "buscar",
		"forms.button.iconDashedButton": "buscar",
		"forms.button.SizedButton": "Tamaño del botón",
		"forms.button.DisabledButton": "Botón desactivado",
		"forms.button.LoadingButton": "Botón de carga",
		"forms.button.MultipleButton": "Botón múltiple",
		"forms.button.groupButton": "Grupo de botones",
		"forms.Tabs.header": "Pestañas",
		"forms.Tabs.simpleTabTitle": "buscar",
		"forms.Tabs.simpleTabSubTitle": "Pestañas inhabilitadas",
		"forms.Tabs.iconTabTitle": "Icono de las pestañas",
		"forms.Tabs.miniTabTitle": "Mini pestañas",
		"forms.Tabs.extraTabTitle": "Pestañas de acción adicionales",
		"forms.Tabs.TabpositionTitle": "Posición",
		"forms.Tabs.TabpositionSubTitle": "Posición de las pestañas  izquierda   derecha   arriba o abajo",
		"forms.Tabs.cardTitle": "Fichas de tipo de tarjeta",
		"forms.Tabs.editableTitle": "Agregar y cerrar pestañas",
		"forms.Tabs.verticalTitle": "Fichas de tipo vertical",
		"forms.Tabs.basicTitle": "Pestañas básicas",
		"forms.checkbox.header": "Caja",
		"forms.checkbox.basicTitle": "Casilla de verificación básica",
		"forms.checkbox.basicSubTitle": "Uso básico de la casilla de verificación.",
		"forms.checkbox.groupTitle": "Grupo de casillas de verificación",
		"forms.checkbox.groupSubTitle": "Genera un grupo de casillas de verificación de una matriz. Utilizar desactivado para deshabilitar una casilla de verificación.",
		"forms.checkbox.groupCheckTitle": "Grupo de casillas de verificación",
		"forms.checkbox.groupCheckSubTitle": "Genera un grupo de casillas de verificación de una matriz. Utilizar desactivado para deshabilitar una casilla de verificación.",
		"forms.radio.header": "Radio",
		"forms.radio.simpleTitle": "Radio básica",
		"forms.radio.simpleSubTitle": "El uso más simple. Utilizar desactivado para desactivar una radio.",
		"forms.radio.groupTitle": "Grupo de radio vertical",
		"forms.radio.groupSubTitle": "Vertical RadioGroup   con más radios.",
		"forms.radio.groupSecondTitle": "Grupo de radio",
		"forms.radio.groupSecondSubTitle": "Un grupo de componentes de radio.",
		"forms.radio.groupThirdTitle": "Grupo de radio",
		"forms.radio.groupThirdSubTitle": "Un grupo de componentes de radio.",
		"forms.transfer.header": "Transferir",
		"forms.transfer.SubTitle": "Transferir con un cuadro de búsqueda.",
		"forms.transfer.Title": "Buscar",
		"forms.autocomplete.header": "Autocompletar",
		"forms.autocomplete.simpleTitle": "Personalizado",
		"forms.autocomplete.simpleSubTitle": "Puede pasar AutoComplete.Option como hijos de Autocompletar   en lugar de utilizar dataSource",
		"forms.autocomplete.customizeTitle": "Personalizar el componente de entrada",
		"forms.autocomplete.customizeSubTitle": "Personalizar el componente de entrada",
		"uiElements.badge.badge": "Distintivo",
		"uiElements.badge.basicExample": "Ejemplo Básico",
		"uiElements.badge.basicExampleSubTitle": "Uso más simple. La insignia se ocultará cuando count sea 0   pero podemos usar showZero para mostrarlo.",
		"uiElements.badge.overflowCount": "Cuenta de desbordamiento",
		"uiElements.badge.overflowCountSubTitle": "OverflowCount se muestra cuando count es mayor que overflowCount. El valor predeterminado de overflowCount es 99.",
		"uiElements.badge.status": "Estado",
		"uiElements.badge.statusSubTitle": "Insignia autónoma con estado.",
		"uiElements.badge.success": "Éxito",
		"uiElements.badge.error": "Error",
		"uiElements.badge.default": "Defecto",
		"uiElements.badge.processing": "Tratamiento",
		"uiElements.badge.warning": "Advertencia",
		"uiElements.badge.redBadge": "Insignia roja",
		"uiElements.badge.redBadgeSubTitle": "Esto simplemente mostrará una insignia roja   sin un conteo específico.",
		"uiElements.badge.linkSomething": "Enlace algo",
		"uiElements.cards.cards": "Divertido Tarjetas",
		"uiElements.cards.basicCard": "Tarjeta básica",
		"uiElements.cards.basicCardSubTitle": "Una tarjeta básica que contiene un título   contenido y un contenido de esquina adicional.",
		"uiElements.cards.more": "Más",
		"uiElements.cards.cardTitle": "Título de la tarjeta",
		"uiElements.cards.cardContent": "Contenido de la tarjeta",
		"uiElements.cards.lorem": "Lorem ipsum dolor sit amet   consectetur adipisicing elit   sed do eiusmod tempor incididunt ut labore y dolore magna aliqua. Ut enim ad minim veniam   quis nostrud ejercicio ullamco laboris nisi ut aliquip ex y commodo consequat.",
		"uiElements.cards.noBorder": "Sin bordes",
		"uiElements.cards.noBorderSubTitle": "Una tarjeta sin fronteras sobre un fondo gris.",
		"uiElements.cards.gridCard": "Tarjeta de red",
		"uiElements.cards.gridCardSubTitle": "Las tarjetas suelen cooperar con el diseño de la cuadrícula en la página de vista general.",
		"uiElements.cards.loadingCard": "Carga de la tarjeta",
		"uiElements.cards.loadingCardSubTitle": "Muestra un indicador de carga mientras se está recuperando el contenido de la tarjeta.",
		"uiElements.cards.whateverContent": "Cualquier contenido",
		"uiElements.cards.customizedContentTitle": "Contenido personalizado",
		"uiElements.cards.customizedContent": "Muestra un indicador de carga mientras se está recuperando el contenido de la tarjeta.",
		"uiElements.cards.europeStreetBeat": "Europa Street beat",
		"uiElements.cards.instagram": "www.instagram.com",
		"uiElements.carousel.carousel": "Parranda",
		"uiElements.carousel.verticalCarousel": "Carrusel vertical",
		"uiElements.carousel.verticalCarouselSubTitle": "Paginación vertical. use   vertical = true",
		"uiElements.carousel.basicCarousel": "Carrusel básico",
		"uiElements.carousel.basicCarouselSubTitle": "Uso básico",
		"uiElements.carousel.fadeInTransition": "Fade In Transition",
		"uiElements.carousel.fadeInTransitionSubTitle": "Las diapositivas utilizan el fundido para la transición.   effect = fade",
		"uiElements.carousel.scrollAutomatically": "Desplazarse automáticamente",
		"uiElements.carousel.scrollAutomaticallySubTitle": "Tiempo de desplazamiento a la siguiente tarjeta    imagen. auto reproducción",
		"uiElements.collapse.collapse": "Colapso",
		"uiElements.collapse.collapseSubTitle": "Se puede ampliar más de un panel a la vez   el primer panel se inicializa para estar activo en este caso. use   defaultActiveKey =   [keyNum]",
		"uiElements.collapse.text": "Un perro es un tipo de animal domesticado. Conocido por su lealtad y fidelidad   se puede encontrar como un invitado de bienvenida en muchos hogares de todo el mundo.",
		"uiElements.collapse.headerOne": "Este es el encabezado del panel 1",
		"uiElements.collapse.headerTwo": "Se trata de la cabecera del panel 2",
		"uiElements.collapse.headerThree": "Este es el encabezado del panel 3",
		"uiElements.collapse.headerNested": "Éste es panel del nido del panel",
		"uiElements.collapse.nestedExample": "Ejemplo anidado",
		"uiElements.collapse.nestedExampleSubTitle": "Collapse está anidado dentro del Collapse.",
		"uiElements.collapse.borderlessExample": "Ejemplo sin márgenes",
		"uiElements.collapse.borderlessExampleSubTitle": "Un estilo sin fronteras de Collapse. use   bordered =   false",
		"uiElements.collapse.accordion": "Acordeón",
		"uiElements.collapse.accordionSubTitle": "Acordeón   sólo se puede ampliar un panel cada vez. El primer panel se ampliará de forma predeterminada. utilizar acordeón",
		"uiElements.popover.popover": "Popover",
		"uiElements.popover.basicExample": "Ejemplo Básico",
		"uiElements.popover.basicExampleSubTitle": "El ejemplo más básico. El tamaño de la capa flotante depende de la región del contenido.",
		"uiElements.popover.hoverMe": "Mírame",
		"uiElements.popover.title": "Título",
		"uiElements.popover.titleTrigger": "Tres maneras de activar",
		"uiElements.popover.titleTriggerSubTitle": "El ratón para hacer clic   enfocar y moverse.",
		"uiElements.popover.focusMe": "Enfócame",
		"uiElements.popover.clickMe": "Haz click en mi",
		"uiElements.popover.placement": "Colocación",
		"uiElements.popover.placementSubTitle": "Hay 12 opciones de colocación disponibles.",
		"uiElements.popover.top": "Parte superior",
		"uiElements.popover.topLeft": "Arriba a la izquierda",
		"uiElements.popover.topRight": "Parte superior derecha",
		"uiElements.popover.leftTop": "Parte superior izquierda",
		"uiElements.popover.left": "Izquierda",
		"uiElements.popover.leftBottom": "Abajo a la izquierda",
		"uiElements.popover.rightTop": "Justo arriba",
		"uiElements.popover.right": "Derecha",
		"uiElements.popover.bottom": "Fondo",
		"uiElements.popover.bottomLeft": "Abajo Izquierda",
		"uiElements.popover.bottomRight": "Abajo a la derecha",
		"uiElements.popover.boxTitle": "Control del cierre del diálogo",
		"uiElements.popover.boxSubTitle": "Utilice el apoyo visible para controlar la visualización de la tarjeta.",
		"uiElements.popover.TR": "TR",
		"uiElements.popover.TL": "TL",
		"uiElements.popover.LT": "LT",
		"uiElements.popover.LB": "LB",
		"uiElements.popover.RT": "RT",
		"uiElements.popover.RB": "RB",
		"uiElements.popover.BL": "licenciado en Derecho",
		"uiElements.popover.BR": "BR",
		"uiElements.popover.close": "Cerca",
		"uiElements.tooltip.tooltip": "Tooltip",
		"uiElements.tooltip.tooltipContent": "Contenido de información sobre herramientas",
		"uiElements.tooltip.basicExample": "Ejemplo Básico",
		"uiElements.tooltip.basicExampleSubTitle": "El uso más simple.",
		"uiElements.tooltip.placementTitle": "Colocación",
		"uiElements.tooltip.placementSubTitle": "La herramienta tiene 12 opciones de ubicación.",
		"uiElements.tooltip.TL": "TL",
		"uiElements.tooltip.TR": "TR",
		"uiElements.tooltip.LT": "LT",
		"uiElements.tooltip.LB": "LB",
		"uiElements.tooltip.RT": "RT",
		"uiElements.tooltip.RB": "RB",
		"uiElements.tooltip.BL": "licenciado en Derecho",
		"uiElements.tooltip.BR": "BR",
		"uiElements.tooltip.bottom": "Fondo",
		"uiElements.tooltip.right": "Derecha",
		"uiElements.tooltip.left": "Izquierda",
		"uiElements.tooltip.top": "Parte superior",
		"uiElements.tooltip.tooltipContentSpan": "La información sobre herramientas se mostrará cuando se introduzca el ratón.",
		"uiElements.tooltip.contentSpan": "Contenido de información sobre herramientas",
		"uiElements.tags.tags": "Etiquetas",
		"uiElements.tags.basicExample": "Ejemplo Básico",
		"uiElements.tags.basicExampleSubTitle": "Uso de la etiqueta básica   y podría ser cerrable por la propiedad cerrable del sistema. La etiqueta Closable soporta eventos onClose afterClose.",
		"uiElements.tags.tagOne": "Etiqueta 1",
		"uiElements.tags.tagTwo": "Etiqueta 2",
		"uiElements.tags.link": "Enlazar",
		"uiElements.tags.preventDefault": "Prevenga el Incumplimiento",
		"uiElements.tags.colorfulTag": "Etiqueta colorida",
		"uiElements.tags.hotTags": "Etiquetas populares",
		"uiElements.tags.hotTagsSubTitle": "Seleccione sus temas favoritos.",
		"uiElements.tags.hots": "Hots",
		"uiElements.tags.addRemoveDynamically": "Agregar y eliminar dinámicamente",
		"uiElements.tags.addRemoveDynamicallySubTitle": "Generando un conjunto de etiquetas por matriz   puede agregar y quitar dinámicamente. Se basa en el evento afterClose   que se activará mientras finaliza la animación de cierre.",
		"uiElements.tags.newTag": "+ Nueva etiqueta",
		"uiElements.timeline.timeline": "Cronograma",
		"uiElements.timeline.basicExample": "Ejemplo Básico",
		"uiElements.timeline.basicTimeline": "Línea de tiempo básica",
		"uiElements.timeline.lastNode": "Ultimo nodo",
		"uiElements.timeline.lastNodeContent": "Cuando la línea de tiempo está incompleta y en curso   poner un nodo fantasma por fin. set   pending =   true     o   pending =   un elemento React",
		"uiElements.timeline.seeMore": "Ver más",
		"uiElements.timeline.custom": "Personalizado",
		"uiElements.timeline.customContent": "Establezca un nodo como un icono u otro elemento personalizado.",
		"uiElements.timeline.colorExample": "Ejemplo de color",
		"uiElements.timeline.colorExampleContent": "Establecer el color de los círculos. verde significa estado completado o de éxito   rojo significa advertencia o error y azul significa estado en curso u otro estado predeterminado.",
		"uiElements.timeline.createServiceSite": "Crear un sitio de servicios 2015-09-01",
		"uiElements.timeline.solveInitialNetwork": "Resolver problemas de red iniciales 2015-09-01",
		"uiElements.timeline.networkProblemSolved": "Problemas de red resueltos 2015-09-01",
		"uiElements.timeline.technicalTesting": "Pruebas técnicas 2015-09-01",
		"uiElements.dropdown.dropdown": "Desplegable",
		"uiElements.dropdown.hoverDropdown": "Desplácese",
		"uiElements.dropdown.hoverMe": "Mírame",
		"uiElements.dropdown.hoverPlacement": "Despliegue de colocación de cola",
		"uiElements.dropdown.hoverDisableLink": "Desplazamiento con desplegable",
		"uiElements.dropdown.clickedDropdown": "Desplegable pulsado",
		"uiElements.dropdown.buttonDropdown": "Botón con menú desplegable",
		"uiElements.pagination.pagination": "Paginación",
		"uiElements.pagination.basic": "BASIC",
		"uiElements.pagination.more": "Más",
		"uiElements.pagination.changer": "Cambiador",
		"uiElements.pagination.jumper": "Saltador",
		"uiElements.pagination.miniSize": "Tamaño mini",
		"uiElements.pagination.simpleMode": "Modo simple",
		"uiElements.pagination.controlled": "Revisado",
		"uiElements.pagination.totalNumber": "Numero total",
		"uiElements.rating.rating": "Clasificación",
		"uiElements.rating.basicExample": "Ejemplo Básico",
		"uiElements.rating.basicExampleSubTitle": "El uso más simple.",
		"uiElements.rating.halfStar": "Media estrella",
		"uiElements.rating.halfStarSubTitle": "Soporte de media estrella.",
		"uiElements.rating.showCopywriting": "Mostrar copywriting",
		"uiElements.rating.showCopywritingSubTitle": "Añadir copywriting en los componentes de la tarifa.",
		"uiElements.rating.readOnly": "Solo lectura",
		"uiElements.rating.readOnlySubTitle": "Sólo lectura   no puede utilizar el ratón para interactuar.",
		"uiElements.rating.otherCharacter": "Otro Personaje",
		"uiElements.rating.otherCharacterSubTitle": "Reemplace la estrella predeterminada por otro carácter como alfabeto   dígito   iconfonte o incluso palabra china.",
		"uiElements.tree.tree": "Árbol",
		"uiElements.tree.basicExample": "Ejemplo básico",
		"uiElements.tree.basicExampleSubTitle": "El uso más básico   te dirá cómo usar checkable   seleccionable   disabled   defaultExpandKeys   y etc.",
		"uiElements.tree.basicControlledExample": "Ejemplo controlado básico",
		"uiElements.tree.basicControlledExampleSubTitle": "ejemplo controlado básico",
		"uiElements.tree.draggableExample": "Ejemplo arrastrable",
		"uiElements.tree.draggableExampleSubTitle": "Arrastre treeNode para insertar después del otro treeNode o inserte en el otro TreeNode padre.",
		"uiElements.tree.loadAsync": "Cargar datos asincrónicamente",
		"uiElements.tree.loadAsyncSubTitle": "Para cargar datos asincrónicamente cuando haga clic para expandir un treeNode.",
		"uiElements.tree.searchableExample": "Ejemplo de búsqueda",
		"uiElements.tree.searchableExampleSubTitle": "Árbol de búsqueda",
		"uiElements.tree.treeWithLine": "Árbol con línea",
		"shuffle.descriptionOne": "Netscape 2.0 se expande   introduciendo Javascript",
		"shuffle.descriptionTwo": "Jesse James Garrett lanza la especificación AJAX",
		"shuffle.descriptionThree": "jQuery 1.0 publicado",
		"shuffle.descriptionFour": "Primero underscore.js commit",
		"shuffle.descriptionFive": "Backbone.js se convierte en una cosa",
		"shuffle.descriptionSix": "Angular 1.0 liberado",
		"shuffle.descriptionSeven": "Reaccionar es de código abierto; los desarrolladores se regocijan",
		"toggle.list": "Lista",
		"toggle.grid": "Cuadrícula",
		"toggle.ascending": "Ascendente",
		"toggle.descending": "Descendente",
		"toggle.shuffle": "Barajar",
		"toggle.rotate": "Girar",
		"toggle.addItem": "Añadir artículo",
		"toggle.removeItem": "Remover el artículo",
		"contactlist.searchContacts": "Buscar contactos",
		"contactlist.addNewContact": "Añadir nuevo contacto",
		"notes.ChoseColor": "Elige un color para tu nota",
		"notes.addNote": "Añadir nueva nota",
		"page404.title": "404",
		"page404.subTitle": "Parece que te has perdido",
		"page404.description": "La página que estás buscando no existe o se ha movido.",
		"page404.backButton": "VOLVER A LA CASA",
		"page500.title": "500",
		"page500.subTitle": "error de servidor interno",
		"page500.description": "Algo salió mal. Por favor   inténtelo de nuevo.",
		"page500.backButton": "VOLVER A LA CASA",
		"page.forgetPassTitle": "Isomórfico",
		"page.forgetPassSubTitle": "¿Se te olvidó tu contraseña?",
		"page.forgetPassDescription": "Introduzca su correo electrónico y le enviaremos un enlace de restablecimiento.",
		"page.sendRequest": "Enviar petición",
		"page.resetPassTitle": "Isomórfico",
		"page.resetPassSubTitle": "Restablecer la contraseña",
		"page.resetPassDescription": "Introduzca una nueva contraseña y confirme.",
		"page.resetPassSave": "Salvar",
		"page.signInTitle": "Isomórfico",
		"page.signInRememberMe": "Recuérdame",
		"page.signInButton": "Registrarse",
		"page.signInPreview": "nombre de usuario  demo   contraseña  demodemo   o simplemente haga clic en cualquier botón.",
		"page.signInFacebook": "Iniciar sesión usando Facebook",
		"page.signInGooglePlus": "Acceder con Google Plus",
		"page.signInAuth0": "Iniciar sesión con Auth0",
		"page.signInForgotPass": "Se te olvidó tu contraseña",
		"page.signInCreateAccount": "Crear una cuenta Isomorphoic",
		"page.signUpTitle": "Isomórfico",
		"page.signUpTermsConditions": "Estoy de acuerdo con los términos y condiciones",
		"page.signUpButton": "Regístrate",
		"page.signUpFacebook": "Registrate con Facebook",
		"page.signUpGooglePlus": "Regístrese con Google Plus",
		"page.signUpAuth0": "Regístrese con Auth0",
		"page.signUpAlreadyAccount": "¿Ya tienes una cuenta? Registrarse.",
		"widget.reportswidget.label": "Ingresos",
		"widget.reportswidget.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.singleprogresswidget1.label": "Márketing",
		"widget.singleprogresswidget2.label": "Addvertisement",
		"widget.singleprogresswidget3.label": "Consultante",
		"widget.singleprogresswidget4.label": "Desarrollo",
		"widget.stickerwidget1.number": "210",
		"widget.stickerwidget1.text": "Correo electrónico no leído",
		"widget.stickerwidget2.number": "1749",
		"widget.stickerwidget2.text": "Subida de imagen",
		"widget.stickerwidget3.number": "3024",
		"widget.stickerwidget3.text": "Total de mensajes",
		"widget.stickerwidget4.number": "54",
		"widget.stickerwidget4.text": "Pedidos",
		"widget.salewidget1.label": "Ingresos",
		"widget.salewidget1.price": "15000 $",
		"widget.salewidget1.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.salewidget2.label": "Ingresos",
		"widget.salewidget2.price": "15000 $",
		"widget.salewidget2.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.salewidget3.label": "Ingresos",
		"widget.salewidget3.price": "15000 $",
		"widget.salewidget3.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.salewidget4.label": "Ingresos",
		"widget.salewidget4.price": "15000 $",
		"widget.salewidget4.details": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed hacer eiusmod tempor",
		"widget.cardwidget1.number": "110",
		"widget.cardwidget1.text": "Nuevos mensajes",
		"widget.cardwidget2.number": "100%",
		"widget.cardwidget2.text": "Volumen",
		"widget.cardwidget3.number": "137",
		"widget.cardwidget3.text": "Logro",
		"widget.progresswidget1.label": "Descargar",
		"widget.progresswidget1.details": "50% Completo",
		"widget.progresswidget2.label": "Apoyo",
		"widget.progresswidget2.details": "80% de clientes satisfechos",
		"widget.progresswidget3.label": "Subir",
		"widget.progresswidget3.details": "65% Completo",
		"widget.vcardwidget.name": "Jhon Doe",
		"widget.vcardwidget.title": "Sr. Desarrollador iOS",
		"widget.vcardwidget.description": "Lorem ipsum dolor sentarse amet   consectetur adipisicing elit   sed eiusmod tempor ammet dolar consectetur adipisicing elit",
		"checkout.billingform.firstname": "Nombre de pila",
		"checkout.billingform.lastname": "Apellido",
		"checkout.billingform.company": "nombre de empresa",
		"checkout.billingform.email": "Dirección de correo electrónico",
		"checkout.billingform.mobile": "No móviles",
		"checkout.billingform.country": "País",
		"checkout.billingform.city": "Ciudad",
		"checkout.billingform.address": "Dirección",
		"checkout.billingform.addressoptional": "Apartamento   suite   unidad   etc. (opcional",
		"checkout.billingform.checkbox": "¿Crea una cuenta?",
		"antTable.title.image": "Imagen",
		"antTable.title.firstName": "Nombre de pila",
		"antTable.title.lastName": "Apellido",
		"antTable.title.city": "Ciudad",
		"antTable.title.street": "Calle",
		"antTable.title.email": "Email",
		"antTable.title.dob": "DOB",
		"Map.leaflet.basicTitle": "Mapa básico",
		"Map.leaflet.basicMarkerTitle": "Mapa básico (con marcador predeterminado",
		"Map.leaflet.leafletCustomMarkerTitle": "Mapa básico (con marcador de icono personalizado",
		"Map.leaflet.leafletCustomHtmlMarkerTitle": "Mapa básico (con marcador HTML personalizado",
		"Map.leaflet.leafletMarkerClusterTitle": "Mapa básico (con grupo de marcadores",
		"Map.leaflet.leafletRoutingTitle": "Enrutamiento básico del mapa",
		"Component.contacts.noOption": "No se ha encontrado ningún contacto",
		"email.send": "ENVIAR",
		"email.cancel": "CANCELAR",
		"email.compose": "COMPONER",
		"email.noMessage": "Por favor seleccione un correo para leer",
		"themeSwitcher.purchase": "Compra ahora",
		"themeSwitcher.settings": "AJUSTES",
		"sidebar.selectbox": "Seleccionar",
		"sidebar.frappeChart": "Frappe Charts",
		"topbar.help": "Aidez-moi",
		"topbar.logout": "Connectez - Out",
		"topbar.viewAll": "Connectez - Out",
		"topbar.viewCart": "Voir le panier",
		"topbar.totalPrice": "Prix ​​total"
	};

/***/ },
/* 2303 */
/***/ function(module, exports) {

	module.exports = {
		"sidebar.email": "E-mail",
		"sidebar.ecommerce": "ecommerce",
		"sidebar.shop": "Negozio",
		"sidebar.cart": "Carrello",
		"sidebar.checkout": "check-out",
		"sidebar.cards": "Carte",
		"sidebar.maps": "Mappe",
		"sidebar.googleMap": "Google Map",
		"sidebar.leafletMap": "Mappa del foglio",
		"sidebar.calendar": "Calendario",
		"sidebar.notes": "Gli appunti",
		"sidebar.todos": "Todos",
		"sidebar.contacts": "Contatti",
		"sidebar.shuffle": "rimescolare",
		"sidebar.charts": "Grafici",
		"sidebar.googleCharts": "Google Carts",
		"sidebar.recharts": "Recharts",
		"sidebar.reactVis": "React Vis",
		"sidebar.reactChart2": "React-Chart-2",
		"sidebar.reactTrend": "React-Trend",
		"sidebar.eChart": "Echart",
		"sidebar.forms": "Forme",
		"sidebar.input": "Ingresso",
		"sidebar.editor": "editore",
		"sidebar.formsWithValidation": "Forme con validazione",
		"sidebar.progress": "Progresso",
		"sidebar.button": "Pulsante",
		"sidebar.tab": "linguetta",
		"sidebar.checkbox": "casella di controllo",
		"sidebar.radiobox": "radiobox",
		"sidebar.transfer": "Trasferimento",
		"sidebar.autocomplete": "Completamento automatico",
		"sidebar.boxOptions": "Opzioni casella",
		"sidebar.uiElements": "Elementi UI",
		"sidebar.badge": "Distintivo",
		"sidebar.card2": "Carta",
		"sidebar.corusel": "gozzoviglia",
		"sidebar.collapse": "Crollo",
		"sidebar.popover": "Pop Over",
		"sidebar.tooltip": "tooltip",
		"sidebar.tag": "Etichetta",
		"sidebar.timeline": "Sequenza temporale",
		"sidebar.dropdown": "Cadere in picchiata",
		"sidebar.pagination": "paginatura",
		"sidebar.rating": "Valutazione",
		"sidebar.tree": "Albero",
		"sidebar.advancedElements": "Elementi avanzati",
		"sidebar.reactDates": "Date di reazione",
		"sidebar.codeMirror": "Specchio di codice",
		"sidebar.uppy": "Uploader Uppy",
		"sidebar.dropzone": "Zona di rilascio",
		"sidebar.feedback": "Risposta",
		"sidebar.alert": "Mettere in guardia",
		"sidebar.modal": "Modale",
		"sidebar.message": "Messaggio",
		"sidebar.notification": "Notifica",
		"sidebar.popConfirm": "Pop Conferma",
		"sidebar.spin": "Roteare",
		"sidebar.tables": "tabelle",
		"sidebar.antTables": "Ant Table",
		"sidebar.pages": "pagine",
		"sidebar.500": "500",
		"sidebar.404": "404",
		"sidebar.signIn": "Registrati",
		"sidebar.signUp": "Registrazione",
		"sidebar.forgotPw": "Hai dimenticato le password",
		"sidebar.resetPw": "Azzerare le password",
		"sidebar.invoice": "Fattura",
		"sidebar.menuLevels": "Livelli del menu",
		"sidebar.item1": "Voce 1",
		"sidebar.item2": "Articolo 2",
		"sidebar.option1": "opzione 1",
		"sidebar.option2": "Opzione 2",
		"sidebar.option3": "Opzione 3",
		"sidebar.option4": "Opzione 4",
		"sidebar.blankPage": "Pagina vuota",
		"sidebar.githubSearch": "Ricerca Github",
		"sidebar.youtubeSearch": "Cambia lingua",
		"languageSwitcher.label": "Switcher di temi",
		"themeSwitcher": "Sidebar",
		"themeSwitcher.Sidebar": "topbar",
		"themeSwitcher.Topbar": "sfondo",
		"themeSwitcher.Background": "Titolo di base",
		"feedback.alert.basicTitle": "Testo di successo",
		"feedback.alert.successText": "Info Testo",
		"feedback.alert.infoText": "Testo di avviso",
		"feedback.alert.warningText": "Testo di errore",
		"feedback.alert.errorText": "Tipo avvisi chiudibili",
		"feedback.alert.closableAlertType": "Tipo di avviso di icone",
		"feedback.alert.iconAlertType": "Tipo di avviso di informazioni sullicona",
		"feedback.alert.iconInfoAlertType": "suggerimenti di successo",
		"feedback.alert.successTips": "Descrizione dettagliata e consigli su copywriting di successo.",
		"feedback.alert.successTipsDescription": "Note informative",
		"feedback.alert.informationTips": "Descrizione e informazioni aggiuntive su copywriting.",
		"feedback.alert.informationDescription": "avvertimento",
		"feedback.alert.warningTips": "Questo è un avviso di avviso di copywriting.",
		"feedback.alert.warningDescription": "Errore",
		"feedback.alert.errorTips": "Si tratta di un messaggio di errore relativo a copywriting.",
		"feedback.alert.errorDescription": "Modale con personalizzazione di piè di pagina",
		"feedback.alert.modalTitle": "Dialogo modale di base.",
		"feedback.alert.modalSubTitle": "Successo",
		"feedback.alert.successTitle": "Informazioni",
		"feedback.alert.infoTitle": "Errore",
		"feedback.alert.errorTitle": "avvertimento",
		"feedback.alert.warningTitle": "Modale",
		"feedback.alert.modalBlockTitle": "Finestra di dialogo Modalità di conferma",
		"feedback.alert.confirmationModalDialogue": "Semplice dialogo modale",
		"feedback.alert.simpleModalDialogue": "Messaggio",
		"feedback.alert.message": "Messaggio normale",
		"feedback.alert.normalMessageTitle": "Messaggi normali come feedback.",
		"feedback.alert.normalMessageSubtitle": "Visualizza il messaggio normale",
		"feedback.alert.displayMessage": "Altri tipi di messaggio",
		"feedback.alert.displayOtherTypeMessageTitle": "Messaggi di tipo di successo   di errore e di avviso.",
		"feedback.alert.displayOtherTypeMessageSubTitle": "Personalizza durata",
		"feedback.alert.customizeDurationTitle": "personalizzare la durata della visualizzazione dei messaggi da default da 1.5s a 10s.",
		"feedback.alert.customizeDurationSubTitle": "Durata del display personalizzata",
		"feedback.alert.customizeDurationButton": "Messaggio di caricamento",
		"feedback.alert.messageLoadingTitle": "Visualizzare un indicatore globale di caricamento   che viene eliminato in modo sincrono.",
		"feedback.alert.messageLoadingSubTitle": "Visualizzare un indicatore di caricamento",
		"feedback.alert.displayLoadIndicator": "Notifica",
		"feedback.alert.notification": "Di base",
		"feedback.alert.notificationBasicTitle": "Lutilizzo più semplice che chiude la casella di notifica dopo 4.5s.",
		"feedback.alert.notificationBasicSubTitle": "Aprire la casella di notifica",
		"feedback.alert.notificationBasicDescription": "Durata dopo la chiusura della casella di notifica",
		"feedback.alert.notificationDurationTitle": "La durata può essere utilizzata per specificare la durata della notifica rimanere aperta. Dopo la scadenza della durata   la notifica si chiude automaticamente. Se non è specificato   il valore predefinito è di 4  5 secondi. Se si imposta il valore su 0   la casella di notifica non si chiude automaticamente.",
		"feedback.alert.notificationDurationSubTitle": "Notifica con icona",
		"feedback.alert.notificationwithIconTitle": "Una casella di notifica con unicona sul lato sinistro.",
		"feedback.alert.notificationwithIconSubTitle": "Notifica con icona personalizzata",
		"feedback.alert.notificationwithCustomIconTitle": "Messaggi normali come feedback.",
		"feedback.alert.notificationwithCustomIconSubTitle": "Notifica con il pulsante personalizzato",
		"feedback.alert.notificationwithCustomButtonTitle": "Messaggi normali come feedback.",
		"feedback.alert.notificationwithCustomButtonSubTitle": "Pop Conferma",
		"feedback.alert.popConfirm": "Conferma fondamentale",
		"feedback.alert.popConfirm.basicTitle": "Lesempio di base.",
		"feedback.alert.popConfirm.basicSubTitle": "Elimina",
		"feedback.alert.popConfirm.delete": "Notifica con icona personalizzata",
		"feedback.alert.popConfirm.notiWithIconTitle": "Messaggi normali come feedback.",
		"feedback.alert.popConfirm.notiWithIconSubTitle": "TL",
		"feedback.alert.popConfirm.TL": "Superiore",
		"feedback.alert.popConfirm.top": "TR",
		"feedback.alert.popConfirm.TR": "LT",
		"feedback.alert.popConfirm.LT": "Sinistra",
		"feedback.alert.popConfirm.left": "LIBBRE",
		"feedback.alert.popConfirm.LB": "RT",
		"feedback.alert.popConfirm.RT": "Destra",
		"feedback.alert.popConfirm.right": "RB",
		"feedback.alert.popConfirm.RB": "BL",
		"feedback.alert.popConfirm.Bl": "Parte inferiore",
		"feedback.alert.popConfirm.bottom": "BR",
		"feedback.alert.popConfirm.BR": "Roteare",
		"feedback.alert.spin": "Dimensioni Spin",
		"feedback.alert.spin.basicTitle": "Spin con lo sfondo",
		"feedback.alert.spin.background": "Spin con descrizione di sfondo",
		"feedback.alert.spin.backgroundDescription": "Stato di caricamento",
		"feedback.alert.spin.loadingState": "Titolo del messaggio di avviso",
		"feedback.alert.spin.alertTitle": "Ulteriori dettagli sul contesto di questo avviso.",
		"feedback.alert.spin.alertDescription": "Ingresso",
		"forms.input.header": "Utilizzo di base",
		"forms.input.basicTitle": "Esempio di utilizzo di base.",
		"forms.input.basicSubTitle": "Tre formati di ingresso",
		"forms.input.variationsTitle": "Sono disponibili tre dimensioni di una casella Input  grande (42px     predefinito (35px   e piccolo (30px  . Nota  Allinterno delle forme viene utilizzata solo la grande dimensione.",
		"forms.input.variationsSubtitle": "Gruppo di input",
		"forms.input.groupTitle": "Esempio di input.Group Nota  Non è necessario Col per controllare la larghezza nella modalità compatta.",
		"forms.input.groupSubTitle": "Autosizing laltezza per adattarsi al contenuto",
		"forms.input.autoSizingTitle": "autosize prop per un tipo di textarea dellinput rende laltezza regolabile automaticamente in base al contenuto. Può essere fornito un oggetto opzioni per autosizzare per specificare il numero minimo e massimo di righe che larea textarea regolerà automaticamente.",
		"forms.input.autoSizingSubTitle": "Scheda Pre    Post",
		"forms.input.prePostTabTitle": "Utilizzo di pre & amp; esempi di tabulazioni post ..",
		"forms.input.prePostTabSubTitle": "Textarea",
		"forms.input.textAreaTitle": "Per i casi di input utente multi-line   è possibile utilizzare un input il cui tipo prop ha il valore di textarea.",
		"forms.input.textAreaSubTitle": "Ricerca",
		"forms.input.searchTitle": "Esempio di creazione di una casella di ricerca raggruppando un input standard con un pulsante di ricerca",
		"forms.input.searchSubTitle": "editore",
		"forms.editor.header": "Modulo di convalida personalizzata",
		"forms.formsWithValidation.header": "Fallire",
		"forms.formsWithValidation.failLabel": "Dovrebbe essere combinazione di numeri & amp; alfabeti",
		"forms.formsWithValidation.failHelp": "avvertimento",
		"forms.formsWithValidation.warningLabel": "Convalida",
		"forms.formsWithValidation.ValidatingLabel": "Le informazioni vengono convalidate ...",
		"forms.formsWithValidation.ValidatingHelp": "Successo",
		"forms.formsWithValidation.SuccessLabel": "avvertimento",
		"forms.formsWithValidation.WarninghasFeedbackLabel": "Fallire",
		"forms.formsWithValidation.FailhasFeedbackLabel": "Dovrebbe essere combinazione di numeri & amp; alfabeti",
		"forms.formsWithValidation.FailhasFeedbackHelp": "Barra di avanzamento",
		"forms.progressBar.header": "Barra di avanzamento",
		"forms.progressBar.standardTitle": "Una barra di avanzamento standard.",
		"forms.progressBar.standardSubTitle": "Barra di progressione circolare",
		"forms.progressBar.circularTitle": "Una barra di avanzamento circolare.",
		"forms.progressBar.circularSubTitle": "Barra di avanzamento di taglia minima",
		"forms.progressBar.miniTitle": "Adatto per una zona stretta.",
		"forms.progressBar.miniSubTitle": "Una barra di avanzamento circolare più piccola.",
		"forms.progressBar.miniCircularTitle": "Barra di avanzamento circolare dinamica",
		"forms.progressBar.dynamicCircularTitle": "Una barra dinamica di avanzamento è migliore.",
		"forms.progressBar.dynamicCircularSubTitle": "Formato di testo personalizzato",
		"forms.progressBar.customTextTitle": "È possibile formattare il testo personalizzato impostando il formato.",
		"forms.progressBar.customTextSubTitle": "Cruscotto",
		"forms.progressBar.dashboardTitle": "Uno stile del cruscotto del progresso.",
		"forms.progressBar.dashboardSubTitle": "pulsanti",
		"forms.button.header": "Tipo di pulsante",
		"forms.button.simpleButton": "Icona pulsante",
		"forms.button.iconButton": "Primario",
		"forms.button.simpleButtonPrimaryText": "Predefinito",
		"forms.button.simpleButtonDefaultText": "tratteggiata",
		"forms.button.simpleButtonDashedText": "Pericolo",
		"forms.button.simpleButtonDangerText": "ricerca",
		"forms.button.iconPrimaryButton": "ricerca",
		"forms.button.iconSimpleButton": "ricerca",
		"forms.button.iconCirculerButton": "ricerca",
		"forms.button.iconDashedButton": "Dimensioni del pulsante",
		"forms.button.SizedButton": "Pulsante disabilitato",
		"forms.button.DisabledButton": "Caricamento del tasto",
		"forms.button.LoadingButton": "Pulsante multiplo",
		"forms.button.MultipleButton": "Gruppo di pulsanti",
		"forms.button.groupButton": "Tabs",
		"forms.Tabs.header": "ricerca",
		"forms.Tabs.simpleTabTitle": "Schede disattivate",
		"forms.Tabs.simpleTabSubTitle": "Tabulazioni delle icone",
		"forms.Tabs.iconTabTitle": "Mini schede",
		"forms.Tabs.miniTabTitle": "Schede Azione Extra",
		"forms.Tabs.extraTabTitle": "Posizione",
		"forms.Tabs.TabpositionTitle": "Posizione delle schede  sinistra   destra   superiore o inferiore",
		"forms.Tabs.TabpositionSubTitle": "Schede del tipo di scheda",
		"forms.Tabs.cardTitle": "Aggiungi e chiudi le schede",
		"forms.Tabs.editableTitle": "Schede di tipo verticale",
		"forms.Tabs.verticalTitle": "Schede di base",
		"forms.Tabs.basicTitle": "casella di controllo",
		"forms.checkbox.header": "Casella di controllo di base",
		"forms.checkbox.basicTitle": "Utilizzo di base della casella di controllo.",
		"forms.checkbox.basicSubTitle": "Gruppo di casella di controllo",
		"forms.checkbox.groupTitle": "Generare un gruppo di caselle di controllo da un array. Utilizza disabilitato per disattivare una casella di controllo.",
		"forms.checkbox.groupSubTitle": "Gruppo di casella di controllo",
		"forms.checkbox.groupCheckTitle": "Generare un gruppo di caselle di controllo da un array. Utilizza disabilitato per disattivare una casella di controllo.",
		"forms.checkbox.groupCheckSubTitle": "Radio",
		"forms.radio.header": "Radio di base",
		"forms.radio.simpleTitle": "Luso più semplice. Usare disabilitato per disattivare una radio.",
		"forms.radio.simpleSubTitle": "RadioGroup verticale",
		"forms.radio.groupTitle": "RadioGroup verticale   con più radio.",
		"forms.radio.groupSubTitle": "RadioGroup",
		"forms.radio.groupSecondTitle": "Un gruppo di componenti radio.",
		"forms.radio.groupSecondSubTitle": "RadioGroup",
		"forms.radio.groupThirdTitle": "Un gruppo di componenti radio.",
		"forms.radio.groupThirdSubTitle": "Trasferimento",
		"forms.transfer.header": "Trasferisci con una casella di ricerca.",
		"forms.transfer.SubTitle": "Ricerca",
		"forms.transfer.Title": "Completamento automatico",
		"forms.autocomplete.header": "su misura",
		"forms.autocomplete.simpleTitle": "Potresti passare AutoComplete.Option come bambini di AutoComplete   invece di utilizzare dataSource",
		"forms.autocomplete.simpleSubTitle": "Personalizza componente di input",
		"forms.autocomplete.customizeTitle": "Personalizza componente di input",
		"forms.autocomplete.customizeSubTitle": "Distintivo",
		"uiElements.badge.badge": "Esempio di base",
		"uiElements.badge.basicExample": "Uso più semplice. Il distintivo sarà nascosto quando il conteggio è 0   ma possiamo usare showZero per mostrarlo.",
		"uiElements.badge.basicExampleSubTitle": "Numero di overflow",
		"uiElements.badge.overflowCount": "OverflowCount viene visualizzato quando il conteggio è maggiore di overflowCount. Il valore predefinito di overflowCount è 99.",
		"uiElements.badge.overflowCountSubTitle": "Stato",
		"uiElements.badge.status": "Distintivo autonomo con stato.",
		"uiElements.badge.statusSubTitle": "Successo",
		"uiElements.badge.success": "Errore",
		"uiElements.badge.error": "Predefinito",
		"uiElements.badge.default": "lavorazione",
		"uiElements.badge.processing": "avvertimento",
		"uiElements.badge.warning": "Distintivo rosso",
		"uiElements.badge.redBadge": "Questo mostrerà semplicemente un distintivo rosso   senza un conteggio specifico.",
		"uiElements.badge.redBadgeSubTitle": "Collegare qualcosa",
		"uiElements.badge.linkSomething": "Carte",
		"uiElements.cards.cards": "Scheda di base",
		"uiElements.cards.basicCard": "Una scheda di base contenente un titolo   un contenuto e un contenuto aggiuntivo dangolo.",
		"uiElements.cards.basicCardSubTitle": "Di Più",
		"uiElements.cards.more": "Titolo della carta",
		"uiElements.cards.cardTitle": "Contenuto della scheda",
		"uiElements.cards.cardContent": "Il peso del peso è ridotto   lelit di adipisizione del consectetur   che rende meno efficace il lavoro e la dolce magna aliqua. Lut enim ad minim veniam   quis nostrud esercizio ullamco laboris nisi ut aliquip ex ea commodo consequat.",
		"uiElements.cards.lorem": "Nessun bordo",
		"uiElements.cards.noBorder": "Una carta senza bordi su uno sfondo grigio.",
		"uiElements.cards.noBorderSubTitle": "Scheda di griglia",
		"uiElements.cards.gridCard": "Carte di solito cooperano con il layout della griglia nella pagina di panoramica.",
		"uiElements.cards.gridCardSubTitle": "Caricamento della carta",
		"uiElements.cards.loadingCard": "Mostra un indicatore di caricamento durante il recupero del contenuto della scheda.",
		"uiElements.cards.loadingCardSubTitle": "Qualunque contenuto",
		"uiElements.cards.whateverContent": "Contenuto personalizzato",
		"uiElements.cards.customizedContentTitle": "Mostra un indicatore di caricamento durante il recupero del contenuto della scheda.",
		"uiElements.cards.customizedContent": "Europa Street beat",
		"uiElements.cards.europeStreetBeat": "www.instagram.com",
		"uiElements.cards.instagram": "gozzoviglia",
		"uiElements.carousel.carousel": "Carosello verticale",
		"uiElements.carousel.verticalCarousel": "Pagination verticale. utilizzare   vertical = true",
		"uiElements.carousel.verticalCarouselSubTitle": "Carosello di base",
		"uiElements.carousel.basicCarousel": "Utilizzo di base",
		"uiElements.carousel.basicCarouselSubTitle": "Fade in transizione",
		"uiElements.carousel.fadeInTransition": "Le diapositive utilizzano dissolvenza per la transizione.   Effetto = dissolvenza",
		"uiElements.carousel.fadeInTransitionSubTitle": "Scorri automaticamente",
		"uiElements.carousel.scrollAutomatically": "Timing di scorrimento alla scheda    immagine successiva. riproduzione automatica",
		"uiElements.carousel.scrollAutomaticallySubTitle": "Crollo",
		"uiElements.collapse.collapse": "Più di un pannello può essere espanso alla volta   il primo pannello viene inizializzato per essere attivo in questo caso. utilizzare   defaultActiveKey =   [keyNum]",
		"uiElements.collapse.collapseSubTitle": "Un cane è un tipo di animale domestico. Conosciuto per la sua fedeltà e fedeltà   si può trovare come un ospite benvenuto in molte famiglie in tutto il mondo.",
		"uiElements.collapse.text": "Questa è lintestazione del pannello 1",
		"uiElements.collapse.headerOne": "Questa è lintestazione del pannello 2",
		"uiElements.collapse.headerTwo": "Questa è lintestazione del pannello 3",
		"uiElements.collapse.headerThree": "Questo è il pannello nido del pannello",
		"uiElements.collapse.headerNested": "Esempio nidificato",
		"uiElements.collapse.nestedExample": "Il crollo è nidificato allinterno del Collapse.",
		"uiElements.collapse.nestedExampleSubTitle": "Esempio senza bordi",
		"uiElements.collapse.borderlessExample": "Uno stile senza bordo di Collapse. utilizzare   bordered =   false",
		"uiElements.collapse.borderlessExampleSubTitle": "Fisarmonica",
		"uiElements.collapse.accordion": "Modalità fisarmonica   è possibile espandere un solo pannello alla volta. Il primo pannello verrà espanso per impostazione predefinita. utilizzare la fisarmonica",
		"uiElements.collapse.accordionSubTitle": "popover",
		"uiElements.popover.popover": "Esempio di base",
		"uiElements.popover.basicExample": "Lesempio più semplice. La dimensione dello strato galleggiante dipende dalla regione dei contenuti.",
		"uiElements.popover.basicExampleSubTitle": "Allontanami",
		"uiElements.popover.hoverMe": "Titolo",
		"uiElements.popover.title": "Tre modi per attivare",
		"uiElements.popover.titleTrigger": "Mouse per fare clic   concentrarsi e muoversi.",
		"uiElements.popover.titleTriggerSubTitle": "Mi concentri",
		"uiElements.popover.focusMe": "Cliccami",
		"uiElements.popover.clickMe": "Posizionamento",
		"uiElements.popover.placement": "Sono disponibili 12 opzioni di posizionamento.",
		"uiElements.popover.placementSubTitle": "Superiore",
		"uiElements.popover.top": "A sinistra in alto",
		"uiElements.popover.topLeft": "In alto a destra",
		"uiElements.popover.topRight": "In alto a sinistra",
		"uiElements.popover.leftTop": "Sinistra",
		"uiElements.popover.left": "Sinistra inferiore",
		"uiElements.popover.leftBottom": "Destra destra",
		"uiElements.popover.rightTop": "Destra",
		"uiElements.popover.right": "Parte inferiore",
		"uiElements.popover.bottom": "In basso a sinistra",
		"uiElements.popover.bottomLeft": "In basso a destra",
		"uiElements.popover.bottomRight": "Controllare la chiusura della finestra di dialogo",
		"uiElements.popover.boxTitle": "Utilizzare un supporto visibile per controllare la visualizzazione della scheda.",
		"uiElements.popover.boxSubTitle": "TR",
		"uiElements.popover.TR": "TL",
		"uiElements.popover.TL": "LT",
		"uiElements.popover.LT": "LIBBRE",
		"uiElements.popover.LB": "RT",
		"uiElements.popover.RT": "RB",
		"uiElements.popover.RB": "BL",
		"uiElements.popover.BL": "BR",
		"uiElements.popover.BR": "Vicino",
		"uiElements.popover.close": "tooltip",
		"uiElements.tooltip.tooltip": "Contenuto del Tooltip",
		"uiElements.tooltip.tooltipContent": "Esempio di base",
		"uiElements.tooltip.basicExample": "Luso più semplice.",
		"uiElements.tooltip.basicExampleSubTitle": "Posizionamento",
		"uiElements.tooltip.placementTitle": "La ToolTip ha 12 scelta dei posizionamenti.",
		"uiElements.tooltip.placementSubTitle": "TL",
		"uiElements.tooltip.TL": "TR",
		"uiElements.tooltip.TR": "LT",
		"uiElements.tooltip.LT": "LIBBRE",
		"uiElements.tooltip.LB": "RT",
		"uiElements.tooltip.RT": "RB",
		"uiElements.tooltip.RB": "BL",
		"uiElements.tooltip.BL": "BR",
		"uiElements.tooltip.BR": "Parte inferiore",
		"uiElements.tooltip.bottom": "Destra",
		"uiElements.tooltip.right": "Sinistra",
		"uiElements.tooltip.left": "Superiore",
		"uiElements.tooltip.top": "Tooltip verrà mostrato quando il mouse entra.",
		"uiElements.tooltip.tooltipContentSpan": "Contenuto del Tooltip",
		"uiElements.tooltip.contentSpan": "tag",
		"uiElements.tags.tags": "Esempio di base",
		"uiElements.tags.basicExample": "Utilizzo di Tag di base e potrebbe essere chiuso da una proprietà chiusa configurabile. Tag Closable supporta onClose afterClose eventi.",
		"uiElements.tags.basicExampleSubTitle": "Tag 1",
		"uiElements.tags.tagOne": "Tag 2",
		"uiElements.tags.tagTwo": "collegamento",
		"uiElements.tags.link": "Impedire il default",
		"uiElements.tags.preventDefault": "Tag colorato",
		"uiElements.tags.colorfulTag": "Tag Hot",
		"uiElements.tags.hotTags": "Seleziona i tuoi argomenti preferiti.",
		"uiElements.tags.hotTagsSubTitle": "Hots",
		"uiElements.tags.hots": "Aggiungi e rimuove in modo dinamico",
		"uiElements.tags.addRemoveDynamically": "La generazione di un insieme di tag per array consente di aggiungere e rimuovere in modo dinamico. Il suo è basato sullevento afterClose   che verrà attivato mentre la fine animazione fine.",
		"uiElements.tags.addRemoveDynamicallySubTitle": "+ Nuovo tag",
		"uiElements.tags.newTag": "Sequenza temporale",
		"uiElements.timeline.timeline": "Esempio di base",
		"uiElements.timeline.basicExample": "Timeline di base",
		"uiElements.timeline.basicTimeline": "Ultimo nodo",
		"uiElements.timeline.lastNode": "Quando la timeline è incompleta e in corso   infine   metti un nodo fantasma. impostare   in attesa =   true     o   in attesa =   a React Element",
		"uiElements.timeline.lastNodeContent": "Vedi altro",
		"uiElements.timeline.seeMore": "costume",
		"uiElements.timeline.custom": "Imposta un nodo come unicona o un altro elemento personalizzato.",
		"uiElements.timeline.customContent": "Esempio di colore",
		"uiElements.timeline.colorExample": "Imposta il colore dei cerchi. verde significa stato completato o successo   rosso significa avvertimento o errore   e blu significa stato continuo o altro.",
		"uiElements.timeline.colorExampleContent": "Creare un sito di servizi per il 2015-09-01",
		"uiElements.timeline.createServiceSite": "Risolvere i problemi di rete iniziali dal 2015-09-01",
		"uiElements.timeline.solveInitialNetwork": "Problemi di rete risolti 2015-09-01",
		"uiElements.timeline.networkProblemSolved": "Test tecnici del 2015-09-01",
		"uiElements.timeline.technicalTesting": "Cadere in picchiata",
		"uiElements.dropdown.dropdown": "Disattiva a discesa",
		"uiElements.dropdown.hoverDropdown": "Allontanami",
		"uiElements.dropdown.hoverMe": "Posizionamento di posizionamento a discesa",
		"uiElements.dropdown.hoverPlacement": "Sospendi con il disattivato link",
		"uiElements.dropdown.hoverDisableLink": "Clicca su Drop Down",
		"uiElements.dropdown.clickedDropdown": "Pulsante con menu a discesa",
		"uiElements.dropdown.buttonDropdown": "paginatura",
		"uiElements.pagination.pagination": "Di base",
		"uiElements.pagination.basic": "Di Più",
		"uiElements.pagination.more": "Changer",
		"uiElements.pagination.changer": "Saltatore",
		"uiElements.pagination.jumper": "Mini formato",
		"uiElements.pagination.miniSize": "Modalità semplice",
		"uiElements.pagination.simpleMode": "Controlled",
		"uiElements.pagination.controlled": "Numero totale",
		"uiElements.pagination.totalNumber": "Valutazione",
		"uiElements.rating.rating": "Esempio di base",
		"uiElements.rating.basicExample": "Luso più semplice.",
		"uiElements.rating.basicExampleSubTitle": "Metà stella",
		"uiElements.rating.halfStar": "Sostenere selezionare la metà della stella.",
		"uiElements.rating.halfStarSubTitle": "Mostra copywriting",
		"uiElements.rating.showCopywriting": "Aggiungi copywriting in componenti di velocità.",
		"uiElements.rating.showCopywritingSubTitle": "Sola lettura",
		"uiElements.rating.readOnly": "Leggi solo   non può utilizzare il mouse per interagire.",
		"uiElements.rating.readOnlySubTitle": "Altro carattere",
		"uiElements.rating.otherCharacter": "Sostituire la stella predefinita in altri caratteri come lalfabeto   la cifra   licona o anche la parola cinese.",
		"uiElements.rating.otherCharacterSubTitle": "Albero",
		"uiElements.tree.tree": "Esempio di base",
		"uiElements.tree.basicExample": "Lutilizzo più semplice   ti dice come utilizzare controllibili   selezionabili   disattivati   defaultExpandKeys e così via.",
		"uiElements.tree.basicExampleSubTitle": "Esempio controllato di base",
		"uiElements.tree.basicControlledExample": "esempio controllato di base",
		"uiElements.tree.basicControlledExampleSubTitle": "Esempio Draggable",
		"uiElements.tree.draggableExample": "Trascinare alberoNode da inserire dopo laltro alberoNodo o inserire nellaltro albero TreeNode.",
		"uiElements.tree.draggableExampleSubTitle": "Caricare i dati in modo asincrono",
		"uiElements.tree.loadAsync": "Per caricare i dati in modo asincrono quando si fa clic per espandere un alberoNodo.",
		"uiElements.tree.loadAsyncSubTitle": "Esempio esplorabile",
		"uiElements.tree.searchableExample": "Albero ricercabile",
		"uiElements.tree.searchableExampleSubTitle": "Albero Con Linea",
		"uiElements.tree.treeWithLine": "Netscape 2.0 viene fornito   introducendo Javascript",
		"shuffle.descriptionOne": "Jesse James Garrett rilascia AJAX spec",
		"shuffle.descriptionTwo": "jQuery 1.0 è stato rilasciato",
		"shuffle.descriptionThree": "Prima sottolineare. Commit",
		"shuffle.descriptionFour": "Backbone.js diventa una cosa",
		"shuffle.descriptionFive": "Angular 1.0 è stato rilasciato",
		"shuffle.descriptionSix": "React è aperto; gli sviluppatori si rallegrano",
		"shuffle.descriptionSeven": "Elenco",
		"toggle.list": "Griglia",
		"toggle.grid": "Ascendente",
		"toggle.ascending": "Discendente",
		"toggle.descending": "rimescolare",
		"toggle.shuffle": "Ruotare",
		"toggle.rotate": "Aggiungi articolo",
		"toggle.addItem": "Rimuovi oggetto",
		"toggle.removeItem": "Cerca i contatti",
		"contactlist.searchContacts": "Aggiungi nuovo contatto",
		"contactlist.addNewContact": "Scegli un colore per la tua nota",
		"notes.ChoseColor": "Aggiungi nuova nota",
		"notes.addNote": "404",
		"page404.title": "Sembra che ti sei perso",
		"page404.subTitle": "La pagina che stai cercando non esiste o è stata spostata.",
		"page404.description": "RITORNO A CASA",
		"page404.backButton": "500",
		"page500.title": "Errore interno del server",
		"page500.subTitle": "Qualcosa è andato storto. Riprova la lettera.",
		"page500.description": "RITORNO A CASA",
		"page500.backButton": "isomorfo",
		"page.forgetPassTitle": "Ha dimenticato la password?",
		"page.forgetPassSubTitle": "Inserisci la tua email e ti inviamo un collegamento di ripristino.",
		"page.forgetPassDescription": "Invia richiesta",
		"page.sendRequest": "isomorfo",
		"page.resetPassTitle": "Resetta la password",
		"page.resetPassSubTitle": "Inserire una nuova password e confermarla.",
		"page.resetPassDescription": "Salvare",
		"page.resetPassSave": "isomorfo",
		"page.signInTitle": "Ricordati di me",
		"page.signInRememberMe": "registrati",
		"page.signInButton": "username  demo   password  demodemo   o basta cliccare su qualsiasi pulsante.",
		"page.signInPreview": "Accedi con Facebook",
		"page.signInFacebook": "Accedi con Google Plus",
		"page.signInGooglePlus": "Accedi con Auth0",
		"page.signInAuth0": "Ha dimenticato la password",
		"page.signInForgotPass": "Crea un account Isomorphoic",
		"page.signInCreateAccount": "isomorfo",
		"page.signUpTitle": "Sono daccordo con i termini e le condivisioni",
		"page.signUpTermsConditions": "Registrazione",
		"page.signUpButton": "Registrati con Facebook",
		"page.signUpFacebook": "Registrati con Google Plus",
		"page.signUpGooglePlus": "Registrati con Auth0",
		"page.signUpAuth0": "Hai già un account? Registrati.",
		"page.signUpAlreadyAccount": "Reddito",
		"widget.reportswidget.label": "Il suo peso è ridotto   è aumentato   è aumentato",
		"widget.reportswidget.details": "Marketing",
		"widget.singleprogresswidget1.label": "Addvertisement",
		"widget.singleprogresswidget2.label": "Consulenza",
		"widget.singleprogresswidget3.label": "Sviluppo",
		"widget.singleprogresswidget4.label": "210",
		"widget.stickerwidget1.number": "Email non letti",
		"widget.stickerwidget1.text": "1749",
		"widget.stickerwidget2.number": "Upload di immagini",
		"widget.stickerwidget2.text": "3024",
		"widget.stickerwidget3.number": "Messaggio totale",
		"widget.stickerwidget3.text": "54",
		"widget.stickerwidget4.number": "Ordini Post",
		"widget.stickerwidget4.text": "Reddito",
		"widget.salewidget1.label": "$ 15000",
		"widget.salewidget1.price": "Il suo peso è ridotto   è aumentato   è aumentato",
		"widget.salewidget1.details": "Reddito",
		"widget.salewidget2.label": "$ 15000",
		"widget.salewidget2.price": "Il suo peso è ridotto   è aumentato   è aumentato",
		"widget.salewidget2.details": "Reddito",
		"widget.salewidget3.label": "$ 15000",
		"widget.salewidget3.price": "Il suo peso è ridotto   è aumentato   è aumentato",
		"widget.salewidget3.details": "Reddito",
		"widget.salewidget4.label": "$ 15000",
		"widget.salewidget4.price": "Il suo peso è ridotto   è aumentato   è aumentato",
		"widget.salewidget4.details": "110",
		"widget.cardwidget1.number": "Nuovi messaggi",
		"widget.cardwidget1.text": "100%",
		"widget.cardwidget2.number": "Volume",
		"widget.cardwidget2.text": "137",
		"widget.cardwidget3.number": "realizzazione",
		"widget.cardwidget3.text": "Scaricare",
		"widget.progresswidget1.label": "50% completato",
		"widget.progresswidget1.details": "Supporto",
		"widget.progresswidget2.label": "80% Cliente soddisfatto",
		"widget.progresswidget2.details": "Caricare",
		"widget.progresswidget3.label": "65% completato",
		"widget.progresswidget3.details": "Jhon Doe",
		"widget.vcardwidget.name": "Sr. iOS Developer",
		"widget.vcardwidget.title": "Il peso è ridotto   il prezzo è basso   il prezzo è basso   il prezzo è basso",
		"widget.vcardwidget.description": "Nome di battesimo",
		"checkout.billingform.firstname": "Cognome",
		"checkout.billingform.lastname": "Nome della ditta",
		"checkout.billingform.company": "Indirizzo email",
		"checkout.billingform.email": "Mobile no",
		"checkout.billingform.mobile": "Nazione",
		"checkout.billingform.country": "Città",
		"checkout.billingform.city": "Indirizzo",
		"checkout.billingform.address": "Appartamento   suite   unità ecc. (Opzionale",
		"checkout.billingform.addressoptional": "Crea un account?",
		"checkout.billingform.checkbox": "Immagine",
		"antTable.title.image": "Nome di battesimo",
		"antTable.title.firstName": "Cognome",
		"antTable.title.lastName": "Città",
		"antTable.title.city": "strada",
		"antTable.title.street": "E-mail",
		"antTable.title.email": "DOB",
		"antTable.title.dob": "Mappa di base",
		"Map.leaflet.basicTitle": "Mappa di base (con il marcatore di default",
		"Map.leaflet.basicMarkerTitle": "Mappa di base (con il simbolo personalizzato dellicona",
		"Map.leaflet.leafletCustomMarkerTitle": "Mappa di base (con il personalizzatore Html Marker",
		"Map.leaflet.leafletCustomHtmlMarkerTitle": "Mappa di base (con cluster di marcatori",
		"Map.leaflet.leafletMarkerClusterTitle": "Routing della mappa di base",
		"Map.leaflet.leafletRoutingTitle": "Nessun contatto trovato",
		"Component.contacts.noOption": "INVIARE",
		"email.send": "ANNULLA",
		"email.cancel": "COMPORRE",
		"email.compose": "Seleziona una mail per leggere",
		"email.noMessage": "PAGARE ORA",
		"themeSwitcher.purchase": "IMPOSTAZIONI",
		"themeSwitcher.settings": "Selezionare",
		"sidebar.selectbox": "",
		"sidebar.frappeChart": "Frappe Charts",
		"topbar.help": "Aiuto",
		"topbar.logout": "Disconnettersi",
		"topbar.viewAll": "Guarda tutto",
		"topbar.viewCart": "Visualizza carrello",
		"topbar.totalPrice": "Prezzo totale"
	};

/***/ },
/* 2304 */
/***/ function(module, exports) {

	module.exports = {
		"sidebar.email": "电子邮件",
		"sidebar.ecommerce": "电子商务",
		"sidebar.shop": "店",
		"sidebar.cart": "大车",
		"sidebar.checkout": "查看",
		"sidebar.cards": "牌",
		"sidebar.maps": "地图",
		"sidebar.googleMap": "谷歌地图",
		"sidebar.leafletMap": "传单地图",
		"sidebar.calendar": "日历",
		"sidebar.notes": "笔记",
		"sidebar.todos": "待办事项",
		"sidebar.contacts": "往来",
		"sidebar.shuffle": "拖曳",
		"sidebar.charts": "图表",
		"sidebar.googleCharts": "Google购物车",
		"sidebar.recharts": "Recharts",
		"sidebar.reactVis": "反应可见",
		"sidebar.reactChart2": "反应 - 图2",
		"sidebar.reactTrend": "反应-趋势",
		"sidebar.eChart": "Echart",
		"sidebar.forms": "形式",
		"sidebar.input": "输入",
		"sidebar.editor": "编辑",
		"sidebar.formsWithValidation": "验证形式",
		"sidebar.progress": "进展",
		"sidebar.button": "按键",
		"sidebar.tab": "标签",
		"sidebar.checkbox": "复选框",
		"sidebar.radiobox": "Radiobox",
		"sidebar.transfer": "转让",
		"sidebar.autocomplete": "自动完成",
		"sidebar.boxOptions": "框选项",
		"sidebar.uiElements": "UI元素",
		"sidebar.badge": "徽章",
		"sidebar.card2": "卡",
		"sidebar.corusel": "狂欢游行",
		"sidebar.collapse": "坍方",
		"sidebar.popover": "流行",
		"sidebar.tooltip": "提示",
		"sidebar.tag": "标签",
		"sidebar.timeline": "时间线",
		"sidebar.dropdown": "落下",
		"sidebar.pagination": "分页",
		"sidebar.rating": "评分",
		"sidebar.tree": "树",
		"sidebar.advancedElements": "高级元素",
		"sidebar.reactDates": "反应日期",
		"sidebar.codeMirror": "代码镜",
		"sidebar.uppy": "Uppy上传器",
		"sidebar.dropzone": "拖放区",
		"sidebar.feedback": "反馈",
		"sidebar.alert": "警报",
		"sidebar.modal": "语气",
		"sidebar.message": "信息",
		"sidebar.notification": "通知",
		"sidebar.popConfirm": "流行确认",
		"sidebar.spin": "纺",
		"sidebar.tables": "表",
		"sidebar.antTables": "蚂蚁表",
		"sidebar.pages": "网页",
		"sidebar.500": "500",
		"sidebar.404": "404",
		"sidebar.signIn": "签到",
		"sidebar.signUp": "注册",
		"sidebar.forgotPw": "忘记密码",
		"sidebar.resetPw": "重置密码",
		"sidebar.invoice": "发票",
		"sidebar.menuLevels": "菜单级别",
		"sidebar.item1": "项目1",
		"sidebar.item2": "项目2",
		"sidebar.option1": "选项1",
		"sidebar.option2": "选项2",
		"sidebar.option3": "选项3",
		"sidebar.option4": "选项4",
		"sidebar.blankPage": "空白页",
		"sidebar.githubSearch": "Github搜索",
		"sidebar.youtubeSearch": "Youtube搜索",
		"languageSwitcher.label": "改变语言",
		"themeSwitcher": "主题切换器",
		"themeSwitcher.Sidebar": "侧边栏",
		"themeSwitcher.Topbar": "顶栏",
		"themeSwitcher.Background": "背景",
		"feedback.alert.basicTitle": "基本标题",
		"feedback.alert.successText": "成功文本",
		"feedback.alert.infoText": "信息文本",
		"feedback.alert.warningText": "警告文字",
		"feedback.alert.errorText": "错误文本",
		"feedback.alert.closableAlertType": "可关闭警报类型",
		"feedback.alert.iconAlertType": "图标警报类型",
		"feedback.alert.iconInfoAlertType": "图标信息警报类型",
		"feedback.alert.successTips": "成功提示",
		"feedback.alert.successTipsDescription": "关于成功写作的详细描述和建议。",
		"feedback.alert.informationTips": "信息备注",
		"feedback.alert.informationDescription": "关于文案的附加说明和信息。",
		"feedback.alert.warningTips": "警告",
		"feedback.alert.warningDescription": "这是关于文案的警告通知。",
		"feedback.alert.errorTips": "错误",
		"feedback.alert.errorDescription": "这是关于文案的错误信息。",
		"feedback.alert.modalTitle": "具有自定义页脚的模态",
		"feedback.alert.modalSubTitle": "基本模态对话框",
		"feedback.alert.successTitle": "成功",
		"feedback.alert.infoTitle": "信息",
		"feedback.alert.errorTitle": "错误",
		"feedback.alert.warningTitle": "警告",
		"feedback.alert.modalBlockTitle": "语气",
		"feedback.alert.confirmationModalDialogue": "确认模态对话框",
		"feedback.alert.simpleModalDialogue": "简单的模态对话框",
		"feedback.alert.message": "信息",
		"feedback.alert.normalMessageTitle": "正常讯息",
		"feedback.alert.normalMessageSubtitle": "正常消息作为反馈。",
		"feedback.alert.displayMessage": "显示正常消息",
		"feedback.alert.displayOtherTypeMessageTitle": "其他类型的消息",
		"feedback.alert.displayOtherTypeMessageSubTitle": "消息的成功，错误和警告类型。",
		"feedback.alert.customizeDurationTitle": "自定义持续时间",
		"feedback.alert.customizeDurationSubTitle": "自定义消息显示持续时间从默认值1.5s到10s。",
		"feedback.alert.customizeDurationButton": "定制显示持续时间",
		"feedback.alert.messageLoadingTitle": "加载消息",
		"feedback.alert.messageLoadingSubTitle": "显示一个全局加载指示器，它自身被异步地关闭。",
		"feedback.alert.displayLoadIndicator": "显示装载指示灯",
		"feedback.alert.notification": "通知",
		"feedback.alert.notificationBasicTitle": "基本",
		"feedback.alert.notificationBasicSubTitle": "4.5s后关闭通知框的最简单的用法。",
		"feedback.alert.notificationBasicDescription": "打开通知框",
		"feedback.alert.notificationDurationTitle": "通知框关闭之后的时间",
		"feedback.alert.notificationDurationSubTitle": "持续时间可用于指定通知保持打开的时间。持续时间过后，通知自动关闭。如果未指定，默认值为4.5秒。如果将值设置为0，则通知框将永远不会自动关闭。",
		"feedback.alert.notificationwithIconTitle": "通知图标",
		"feedback.alert.notificationwithIconSubTitle": "具有左侧图标的通知框。",
		"feedback.alert.notificationwithCustomIconTitle": "通知与自定义图标",
		"feedback.alert.notificationwithCustomIconSubTitle": "正常消息作为反馈。",
		"feedback.alert.notificationwithCustomButtonTitle": "通知使用自定义按钮",
		"feedback.alert.notificationwithCustomButtonSubTitle": "正常消息作为反馈。",
		"feedback.alert.popConfirm": "流行确认",
		"feedback.alert.popConfirm.basicTitle": "基本确认",
		"feedback.alert.popConfirm.basicSubTitle": "的基本例子。",
		"feedback.alert.popConfirm.delete": "删除",
		"feedback.alert.popConfirm.notiWithIconTitle": "通知与自定义图标",
		"feedback.alert.popConfirm.notiWithIconSubTitle": "正常消息作为反馈。",
		"feedback.alert.popConfirm.TL": "TL",
		"feedback.alert.popConfirm.top": "最佳",
		"feedback.alert.popConfirm.TR": "TR",
		"feedback.alert.popConfirm.LT": "LT",
		"feedback.alert.popConfirm.left": "剩下",
		"feedback.alert.popConfirm.LB": "磅",
		"feedback.alert.popConfirm.RT": "RT",
		"feedback.alert.popConfirm.right": "对",
		"feedback.alert.popConfirm.RB": "RB",
		"feedback.alert.popConfirm.Bl": "BL",
		"feedback.alert.popConfirm.bottom": "底部",
		"feedback.alert.popConfirm.BR": "BR",
		"feedback.alert.spin": "纺",
		"feedback.alert.spin.basicTitle": "尺寸旋转",
		"feedback.alert.spin.background": "旋转背景",
		"feedback.alert.spin.backgroundDescription": "旋转背景描述",
		"feedback.alert.spin.loadingState": "装载状态：",
		"feedback.alert.spin.alertTitle": "提醒消息标题",
		"feedback.alert.spin.alertDescription": "有关此警报的上下文的更多详细信息。",
		"forms.input.header": "输入",
		"forms.input.basicTitle": "基本用法",
		"forms.input.basicSubTitle": "基本使用示例。",
		"forms.input.variationsTitle": "三种尺寸的输入",
		"forms.input.variationsSubtitle": "输入框有三种尺寸：大（42像素），默认（35像素）和小（30像素）。注意：在表格内部，只使用大尺寸。",
		"forms.input.groupTitle": "输入组",
		"forms.input.groupSubTitle": "Input.Group示例注意：您不需要Col来控制紧凑模式下的宽度。",
		"forms.input.autoSizingTitle": "自动调整高度以适应内容",
		"forms.input.autoSizingSubTitle": "对于textarea类型的输入，autosize prop可以根据内容自动调整高度。可以提供一个选项对象来自动调整，以指定textarea将自动调整的最小和最大行数。",
		"forms.input.prePostTabTitle": "前  后选项卡",
		"forms.input.prePostTabSubTitle": "使用前＆amp;帖子标签示例..",
		"forms.input.textAreaTitle": "多行文本",
		"forms.input.textAreaSubTitle": "对于多行用户输入案例，可以使用类型prop具有textarea值的输入。",
		"forms.input.searchTitle": "搜索",
		"forms.input.searchSubTitle": "通过使用搜索按钮对标准输入进行分组来创建搜索框的示例",
		"forms.editor.header": "编辑",
		"forms.formsWithValidation.header": "定制验证表",
		"forms.formsWithValidation.failLabel": "失败",
		"forms.formsWithValidation.failHelp": "应该是数字＆amp;字母",
		"forms.formsWithValidation.warningLabel": "警告",
		"forms.formsWithValidation.ValidatingLabel": "证实",
		"forms.formsWithValidation.ValidatingHelp": "信息正在验证...",
		"forms.formsWithValidation.SuccessLabel": "成功",
		"forms.formsWithValidation.WarninghasFeedbackLabel": "警告",
		"forms.formsWithValidation.FailhasFeedbackLabel": "失败",
		"forms.formsWithValidation.FailhasFeedbackHelp": "应该是数字＆amp;字母",
		"forms.progressBar.header": "进度条",
		"forms.progressBar.standardTitle": "进度条",
		"forms.progressBar.standardSubTitle": "标准进度条。",
		"forms.progressBar.circularTitle": "循环进度栏",
		"forms.progressBar.circularSubTitle": "一个循环进度条。",
		"forms.progressBar.miniTitle": "迷你尺寸进度条",
		"forms.progressBar.miniSubTitle": "适合狭窄的地区。",
		"forms.progressBar.miniCircularTitle": "一个较小的圆形进度条。",
		"forms.progressBar.dynamicCircularTitle": "动态循环进度条",
		"forms.progressBar.dynamicCircularSubTitle": "动态进度条更好。",
		"forms.progressBar.customTextTitle": "自定义文本格式",
		"forms.progressBar.customTextSubTitle": "您可以通过设置格式自定义文本格式。",
		"forms.progressBar.dashboardTitle": "仪表板",
		"forms.progressBar.dashboardSubTitle": "仪表板风格的进步。",
		"forms.button.header": "纽扣",
		"forms.button.simpleButton": "按钮类型",
		"forms.button.iconButton": "按钮图标",
		"forms.button.simpleButtonPrimaryText": "主",
		"forms.button.simpleButtonDefaultText": "默认",
		"forms.button.simpleButtonDashedText": "虚线",
		"forms.button.simpleButtonDangerText": "危险",
		"forms.button.iconPrimaryButton": "搜索",
		"forms.button.iconSimpleButton": "搜索",
		"forms.button.iconCirculerButton": "搜索",
		"forms.button.iconDashedButton": "搜索",
		"forms.button.SizedButton": "按钮大小",
		"forms.button.DisabledButton": "按钮禁用",
		"forms.button.LoadingButton": "按钮加载",
		"forms.button.MultipleButton": "多重按钮",
		"forms.button.groupButton": "按钮组",
		"forms.Tabs.header": "标签",
		"forms.Tabs.simpleTabTitle": "搜索",
		"forms.Tabs.simpleTabSubTitle": "禁用标签",
		"forms.Tabs.iconTabTitle": "图标标签",
		"forms.Tabs.miniTabTitle": "迷你标签",
		"forms.Tabs.extraTabTitle": "额外动作标签",
		"forms.Tabs.TabpositionTitle": "位置",
		"forms.Tabs.TabpositionSubTitle": "标签的位置：左，右，上或下",
		"forms.Tabs.cardTitle": "卡类型选项卡",
		"forms.Tabs.editableTitle": "添加和关闭选项卡",
		"forms.Tabs.verticalTitle": "垂直类型标签",
		"forms.Tabs.basicTitle": "基本标签",
		"forms.checkbox.header": "复选框",
		"forms.checkbox.basicTitle": "基本复选框",
		"forms.checkbox.basicSubTitle": "复选框的基本用法",
		"forms.checkbox.groupTitle": "复选框组",
		"forms.checkbox.groupSubTitle": "从数组生成一组复选框。禁用此功能可禁用复选框。",
		"forms.checkbox.groupCheckTitle": "复选框组",
		"forms.checkbox.groupCheckSubTitle": "从数组生成一组复选框。禁用此功能可禁用复选框。",
		"forms.radio.header": "无线电",
		"forms.radio.simpleTitle": "基本电台",
		"forms.radio.simpleSubTitle": "最简单的用法禁用禁用广播。",
		"forms.radio.groupTitle": "垂直无线电组",
		"forms.radio.groupSubTitle": "垂直无线电组，更多收音机。",
		"forms.radio.groupSecondTitle": "RadioGroup中",
		"forms.radio.groupSecondSubTitle": "一组无线电组件。",
		"forms.radio.groupThirdTitle": "RadioGroup中",
		"forms.radio.groupThirdSubTitle": "一组无线电组件。",
		"forms.transfer.header": "转让",
		"forms.transfer.SubTitle": "使用搜索框转移。",
		"forms.transfer.Title": "搜索",
		"forms.autocomplete.header": "自动完成",
		"forms.autocomplete.simpleTitle": "定制",
		"forms.autocomplete.simpleSubTitle": "您可以将AutoComplete.Option作为AutoComplete的子代码，而不是使用dataSource",
		"forms.autocomplete.customizeTitle": "自定义输入组件",
		"forms.autocomplete.customizeSubTitle": "自定义输入组件",
		"uiElements.badge.badge": "徽章",
		"uiElements.badge.basicExample": "基本例子",
		"uiElements.badge.basicExampleSubTitle": "最简单的用法当count为0时，徽章将被隐藏，但是我们可以使用showZero来显示。",
		"uiElements.badge.overflowCount": "溢出计数",
		"uiElements.badge.overflowCountSubTitle": "当count大于overflowCount时，会显示OverflowCount。 overflowCount的默认值为99。",
		"uiElements.badge.status": "状态",
		"uiElements.badge.statusSubTitle": "独立徽章与状态。",
		"uiElements.badge.success": "成功",
		"uiElements.badge.error": "错误",
		"uiElements.badge.default": "默认",
		"uiElements.badge.processing": "处理",
		"uiElements.badge.warning": "警告",
		"uiElements.badge.redBadge": "红色徽章",
		"uiElements.badge.redBadgeSubTitle": "这只会显示一个红色的徽章，没有特定的数字。",
		"uiElements.badge.linkSomething": "链接一些东西",
		"uiElements.cards.cards": "牌",
		"uiElements.cards.basicCard": "基本卡",
		"uiElements.cards.basicCardSubTitle": "包含标题，内容和额外角落内容的基本卡。",
		"uiElements.cards.more": "更多",
		"uiElements.cards.cardTitle": "卡标题",
		"uiElements.cards.cardContent": "卡内容",
		"uiElements.cards.lorem": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor incididunt ut labore et dolore magna aliqua。 Ut enim ad minim veniam，quis nostrud exerciseitation ullamco laboris nisi ut aliquip ex ea commodo因此。",
		"uiElements.cards.noBorder": "没有边界",
		"uiElements.cards.noBorderSubTitle": "在灰色背景上的无边界的卡。",
		"uiElements.cards.gridCard": "网格卡",
		"uiElements.cards.gridCardSubTitle": "卡通常在概览页面中与网格布局配合使用。",
		"uiElements.cards.loadingCard": "装卡",
		"uiElements.cards.loadingCardSubTitle": "显示加载指示符，同时正在取出卡的内容。",
		"uiElements.cards.whateverContent": "无论内容",
		"uiElements.cards.customizedContentTitle": "定制内容",
		"uiElements.cards.customizedContent": "显示加载指示符，同时正在取出卡的内容。",
		"uiElements.cards.europeStreetBeat": "欧洲街拍",
		"uiElements.cards.instagram": "www.instagram.com",
		"uiElements.carousel.carousel": "狂欢游行",
		"uiElements.carousel.verticalCarousel": "垂直旋转木马",
		"uiElements.carousel.verticalCarouselSubTitle": "垂直分页。使用  vertical =true",
		"uiElements.carousel.basicCarousel": "基本转盘",
		"uiElements.carousel.basicCarouselSubTitle": "基本用法",
		"uiElements.carousel.fadeInTransition": "淡入淡出",
		"uiElements.carousel.fadeInTransitionSubTitle": "幻灯片使用淡入淡出。   效果= 淡入",
		"uiElements.carousel.scrollAutomatically": "自动滚动",
		"uiElements.carousel.scrollAutomaticallySubTitle": "滚动到下一张卡  图片的时间。自动播放",
		"uiElements.collapse.collapse": "坍方",
		"uiElements.collapse.collapseSubTitle": "一次可以扩展多个面板，在这种情况下，第一个面板被初始化为活动状态。使用  defaultActiveKey =   [keyNum]",
		"uiElements.collapse.text": "狗是一种驯养动物。以其忠诚和忠诚而闻名，可以作为世界各地许多家庭的欢迎客人。",
		"uiElements.collapse.headerOne": "这是面板标题1",
		"uiElements.collapse.headerTwo": "这是面板标题2",
		"uiElements.collapse.headerThree": "这是面板标题3",
		"uiElements.collapse.headerNested": "这是面板嵌套面板",
		"uiElements.collapse.nestedExample": "嵌套示例",
		"uiElements.collapse.nestedExampleSubTitle": "折叠嵌套在折叠中。",
		"uiElements.collapse.borderlessExample": "无边界的例子",
		"uiElements.collapse.borderlessExampleSubTitle": "无边界风格的折叠。使用  bordered =   false",
		"uiElements.collapse.accordion": "手风琴",
		"uiElements.collapse.accordionSubTitle": "手风琴模式，一次只能扩展一个面板。默认情况下，第一个面板将被扩展。使用手风琴",
		"uiElements.popover.popover": "酥料饼",
		"uiElements.popover.basicExample": "基本例子",
		"uiElements.popover.basicExampleSubTitle": "最基本的例子。浮动层的大小取决于内容区域。",
		"uiElements.popover.hoverMe": "悬停我",
		"uiElements.popover.title": "标题",
		"uiElements.popover.titleTrigger": "三种触发方式",
		"uiElements.popover.titleTriggerSubTitle": "鼠标点击，对焦和移动。",
		"uiElements.popover.focusMe": "聚焦我",
		"uiElements.popover.clickMe": "点击我",
		"uiElements.popover.placement": "放置",
		"uiElements.popover.placementSubTitle": "有12个放置选项可用。",
		"uiElements.popover.top": "最佳",
		"uiElements.popover.topLeft": "左上角",
		"uiElements.popover.topRight": "右上",
		"uiElements.popover.leftTop": "左上",
		"uiElements.popover.left": "剩下",
		"uiElements.popover.leftBottom": "左下",
		"uiElements.popover.rightTop": "右上",
		"uiElements.popover.right": "对",
		"uiElements.popover.bottom": "底部",
		"uiElements.popover.bottomLeft": "左下方",
		"uiElements.popover.bottomRight": "右下",
		"uiElements.popover.boxTitle": "控制对话框的关闭",
		"uiElements.popover.boxSubTitle": "使用可见支柱来控制显卡的显示。",
		"uiElements.popover.TR": "TR",
		"uiElements.popover.TL": "TL",
		"uiElements.popover.LT": "LT",
		"uiElements.popover.LB": "磅",
		"uiElements.popover.RT": "RT",
		"uiElements.popover.RB": "RB",
		"uiElements.popover.BL": "BL",
		"uiElements.popover.BR": "BR",
		"uiElements.popover.close": "关",
		"uiElements.tooltip.tooltip": "提示",
		"uiElements.tooltip.tooltipContent": "工具提示内容",
		"uiElements.tooltip.basicExample": "基本例子",
		"uiElements.tooltip.basicExampleSubTitle": "最简单的用法",
		"uiElements.tooltip.placementTitle": "放置",
		"uiElements.tooltip.placementSubTitle": "工具提示有12个布局选择。",
		"uiElements.tooltip.TL": "TL",
		"uiElements.tooltip.TR": "TR",
		"uiElements.tooltip.LT": "LT",
		"uiElements.tooltip.LB": "磅",
		"uiElements.tooltip.RT": "RT",
		"uiElements.tooltip.RB": "RB",
		"uiElements.tooltip.BL": "BL",
		"uiElements.tooltip.BR": "BR",
		"uiElements.tooltip.bottom": "底部",
		"uiElements.tooltip.right": "对",
		"uiElements.tooltip.left": "剩下",
		"uiElements.tooltip.top": "最佳",
		"uiElements.tooltip.tooltipContentSpan": "鼠标进入时会显示工具提示。",
		"uiElements.tooltip.contentSpan": "工具提示内容",
		"uiElements.tags.tags": "标签",
		"uiElements.tags.basicExample": "基本例子",
		"uiElements.tags.basicExampleSubTitle": "使用基本标签，它可以通过set closable属性来关闭。关闭标签支持onClose afterClose事件。",
		"uiElements.tags.tagOne": "标签1",
		"uiElements.tags.tagTwo": "标签2",
		"uiElements.tags.link": "链接",
		"uiElements.tags.preventDefault": "防止默认",
		"uiElements.tags.colorfulTag": "多彩标签",
		"uiElements.tags.hotTags": "热门标签",
		"uiElements.tags.hotTagsSubTitle": "选择您最喜欢的主题。",
		"uiElements.tags.hots": "热门活动：",
		"uiElements.tags.addRemoveDynamically": "动态添加和删除",
		"uiElements.tags.addRemoveDynamicallySubTitle": "通过数组生成一组标签，可以动态添加和删除。它基于afterClose事件，这将在关闭动画结束时触发。",
		"uiElements.tags.newTag": "+新标签",
		"uiElements.timeline.timeline": "时间线",
		"uiElements.timeline.basicExample": "基本例子",
		"uiElements.timeline.basicTimeline": "基本时间表",
		"uiElements.timeline.lastNode": "上一个节点",
		"uiElements.timeline.lastNodeContent": "当时间轴不完整和持续时，最后放一个鬼节点。 set   pending =   true    或  pending =   a React Element",
		"uiElements.timeline.seeMore": "查看更多",
		"uiElements.timeline.custom": "习惯",
		"uiElements.timeline.customContent": "将节点设置为图标或其他自定义元素。",
		"uiElements.timeline.colorExample": "颜色示例",
		"uiElements.timeline.colorExampleContent": "设置圈子的颜色。绿色表示完成或成功状态，红色表示警告或错误，蓝色表示正在进行或其他默认状态。",
		"uiElements.timeline.createServiceSite": "创建服务网站2015-09-01",
		"uiElements.timeline.solveInitialNetwork": "解决初始网络问题2015-09-01",
		"uiElements.timeline.networkProblemSolved": "网络问题正在解决2015-09-01",
		"uiElements.timeline.technicalTesting": "技术测试2015-09-01",
		"uiElements.dropdown.dropdown": "落下",
		"uiElements.dropdown.hoverDropdown": "悬停下拉",
		"uiElements.dropdown.hoverMe": "悬停我",
		"uiElements.dropdown.hoverPlacement": "悬停放置下拉",
		"uiElements.dropdown.hoverDisableLink": "悬停下拉与禁用链接",
		"uiElements.dropdown.clickedDropdown": "点击下拉",
		"uiElements.dropdown.buttonDropdown": "按钮与下拉菜单",
		"uiElements.pagination.pagination": "分页",
		"uiElements.pagination.basic": "基本",
		"uiElements.pagination.more": "更多",
		"uiElements.pagination.changer": "换",
		"uiElements.pagination.jumper": "跨接器",
		"uiElements.pagination.miniSize": "迷你尺寸",
		"uiElements.pagination.simpleMode": "简单模式",
		"uiElements.pagination.controlled": "受控",
		"uiElements.pagination.totalNumber": "总数",
		"uiElements.rating.rating": "评分",
		"uiElements.rating.basicExample": "基本例子",
		"uiElements.rating.basicExampleSubTitle": "最简单的用法",
		"uiElements.rating.halfStar": "半星",
		"uiElements.rating.halfStarSubTitle": "支持选择半星。",
		"uiElements.rating.showCopywriting": "显示文案",
		"uiElements.rating.showCopywritingSubTitle": "以速率组件添加文案。",
		"uiElements.rating.readOnly": "只读",
		"uiElements.rating.readOnlySubTitle": "只读，不能使用鼠标进行交互。",
		"uiElements.rating.otherCharacter": "其他性格",
		"uiElements.rating.otherCharacterSubTitle": "将默认明星替换为其他字符，如字母，数字，iconfont甚至中文字。",
		"uiElements.tree.tree": "树",
		"uiElements.tree.basicExample": "基本例子",
		"uiElements.tree.basicExampleSubTitle": "最基本的用法，告诉你如何使用可检查，可选择，禁用，defaultExpandKeys等。",
		"uiElements.tree.basicControlledExample": "基本控制示例",
		"uiElements.tree.basicControlledExampleSubTitle": "基本控制示例",
		"uiElements.tree.draggableExample": "可拖曳的例子",
		"uiElements.tree.draggableExampleSubTitle": "拖动treeNode插入另一个treeNode或插入到另一个父TreeNode中。",
		"uiElements.tree.loadAsync": "异步加载数据",
		"uiElements.tree.loadAsyncSubTitle": "单击以展开treeNode时异步加载数据。",
		"uiElements.tree.searchableExample": "可搜索的例子",
		"uiElements.tree.searchableExampleSubTitle": "可搜索的树",
		"uiElements.tree.treeWithLine": "树与线",
		"shuffle.descriptionOne": "Netscape 2.0发布，引入Javascript",
		"shuffle.descriptionTwo": "Jesse James Garrett发布了AJAX规范",
		"shuffle.descriptionThree": "jQuery 1.0发布",
		"shuffle.descriptionFour": "首先下划线",
		"shuffle.descriptionFive": "Backbone.js成为一件事情",
		"shuffle.descriptionSix": "角度1.0发布",
		"shuffle.descriptionSeven": "反应是开源的开发商高兴",
		"toggle.list": "名单",
		"toggle.grid": "格",
		"toggle.ascending": "上升",
		"toggle.descending": "降序",
		"toggle.shuffle": "拖曳",
		"toggle.rotate": "旋转",
		"toggle.addItem": "新增项目",
		"toggle.removeItem": "除去项目",
		"contactlist.searchContacts": "搜索联系人",
		"contactlist.addNewContact": "添加新联系人",
		"notes.ChoseColor": "为您的笔记选择一种颜色",
		"notes.addNote": "添加新注",
		"page404.title": "404",
		"page404.subTitle": "看起来你已经迷路了",
		"page404.description": "您正在寻找的页面不存在或已被移动。",
		"page404.backButton": "回家",
		"page500.title": "500",
		"page500.subTitle": "内部服务器错误",
		"page500.description": "出了些问题。请再试一次信。",
		"page500.backButton": "回家",
		"page.forgetPassTitle": "同构",
		"page.forgetPassSubTitle": "忘记密码？",
		"page.forgetPassDescription": "输入您的电子邮件，我们向您发送重置链接。",
		"page.sendRequest": "发送请求",
		"page.resetPassTitle": "同构",
		"page.resetPassSubTitle": "重设密码",
		"page.resetPassDescription": "输入新密码并进行确认。",
		"page.resetPassSave": "保存",
		"page.signInTitle": "同构",
		"page.signInRememberMe": "记住我",
		"page.signInButton": "签到",
		"page.signInPreview": "用户名：demo，密码：demodemo，或者点击任意按钮。",
		"page.signInFacebook": "用Facebook登录",
		"page.signInGooglePlus": "使用Google Plus登录",
		"page.signInAuth0": "用Auth0登录",
		"page.signInForgotPass": "忘记密码",
		"page.signInCreateAccount": "创建一个异构帐户",
		"page.signUpTitle": "同构",
		"page.signUpTermsConditions": "我同意条款和条件",
		"page.signUpButton": "注册",
		"page.signUpFacebook": "用Facebook注册",
		"page.signUpGooglePlus": "用Google Plus注册",
		"page.signUpAuth0": "注册Auth0",
		"page.signUpAlreadyAccount": "已经有账户？签到。",
		"widget.reportswidget.label": "收入",
		"widget.reportswidget.details": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor",
		"widget.singleprogresswidget1.label": "营销",
		"widget.singleprogresswidget2.label": "Addvertisement",
		"widget.singleprogresswidget3.label": "咨询",
		"widget.singleprogresswidget4.label": "发展",
		"widget.stickerwidget1.number": "210",
		"widget.stickerwidget1.text": "未读电子邮件",
		"widget.stickerwidget2.number": "1749",
		"widget.stickerwidget2.text": "图片上传",
		"widget.stickerwidget3.number": "3024",
		"widget.stickerwidget3.text": "总信息",
		"widget.stickerwidget4.number": "54",
		"widget.stickerwidget4.text": "订单发布",
		"widget.salewidget1.label": "收入",
		"widget.salewidget1.price": "$ 15000",
		"widget.salewidget1.details": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor",
		"widget.salewidget2.label": "收入",
		"widget.salewidget2.price": "$ 15000",
		"widget.salewidget2.details": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor",
		"widget.salewidget3.label": "收入",
		"widget.salewidget3.price": "$ 15000",
		"widget.salewidget3.details": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor",
		"widget.salewidget4.label": "收入",
		"widget.salewidget4.price": "$ 15000",
		"widget.salewidget4.details": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor",
		"widget.cardwidget1.number": "110",
		"widget.cardwidget1.text": "新消息",
		"widget.cardwidget2.number": "100％",
		"widget.cardwidget2.text": "卷",
		"widget.cardwidget3.number": "137",
		"widget.cardwidget3.text": "成就",
		"widget.progresswidget1.label": "下载",
		"widget.progresswidget1.details": "50％完成",
		"widget.progresswidget2.label": "支持",
		"widget.progresswidget2.details": "80％满意客户",
		"widget.progresswidget3.label": "上传",
		"widget.progresswidget3.details": "65％完成",
		"widget.vcardwidget.name": "Jhon Doe",
		"widget.vcardwidget.title": "高级iOS开发人员",
		"widget.vcardwidget.description": "Lorem ipsum dolor sit amet，consectetur adipisicing elit，sed do eiusmod tempor ammet dolar consectetur adipisicing elit",
		"checkout.billingform.firstname": "名字",
		"checkout.billingform.lastname": "姓",
		"checkout.billingform.company": "公司名",
		"checkout.billingform.email": "电子邮件地址",
		"checkout.billingform.mobile": "手机号码",
		"checkout.billingform.country": "国家",
		"checkout.billingform.city": "市",
		"checkout.billingform.address": "地址",
		"checkout.billingform.addressoptional": "公寓，套房，单位等（可选）",
		"checkout.billingform.checkbox": "创建一个帐户？",
		"antTable.title.image": "图片",
		"antTable.title.firstName": "名字",
		"antTable.title.lastName": "姓",
		"antTable.title.city": "市",
		"antTable.title.street": "街",
		"antTable.title.email": "电子邮件",
		"antTable.title.dob": "DOB",
		"Map.leaflet.basicTitle": "基本地图",
		"Map.leaflet.basicMarkerTitle": "基本地图（带默认标记）",
		"Map.leaflet.leafletCustomMarkerTitle": "基本地图（使用自定义图标标记）",
		"Map.leaflet.leafletCustomHtmlMarkerTitle": "基本地图（使用自定义Html标记）",
		"Map.leaflet.leafletMarkerClusterTitle": "基本地图（带标记群集）",
		"Map.leaflet.leafletRoutingTitle": "基本地图路由",
		"Component.contacts.noOption": "找不到联系",
		"email.send": "发送",
		"email.cancel": "取消",
		"email.compose": "撰写",
		"email.noMessage": "请选择一个邮件阅读",
		"themeSwitcher.purchase": "立即购买",
		"themeSwitcher.settings": "设置",
		"sidebar.selectbox": "选择",
		"sidebar.frappeChart": "Frappe Charts",
		"topbar.help": "帮帮我",
		"topbar.logout": "登出",
		"topbar.viewAll": "查看全部",
		"topbar.viewCart": "查看购物车",
		"topbar.totalPrice": "总价格"
	};

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(3255);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(99);
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var utils = __webpack_require__(99);
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	


/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = __webpack_require__(2467);
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input) {
	    return pako.deflateRaw(input);
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};


/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var base64 = __webpack_require__(442);
	var ZipEntries = __webpack_require__(2314);
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = options || {};
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileName, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileComment.length ? input.fileComment : null,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};


/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var Uint8ArrayReader = __webpack_require__(968);
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;


/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(99);
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;


/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(99);
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;


/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(99);
	var support = __webpack_require__(233);
	var nodeBuffer = __webpack_require__(444);
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:


/***/ },
/* 2314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(967);
	var NodeBufferReader = __webpack_require__(2310);
	var Uint8ArrayReader = __webpack_require__(968);
	var utils = __webpack_require__(99);
	var sig = __webpack_require__(966);
	var ZipEntry = __webpack_require__(2315);
	var support = __webpack_require__(233);
	var jszipProto = __webpack_require__(445);
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        this.zipComment = this.reader.readString(this.zipCommentLength);
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded.
	        this.zipComment = jszipProto.utf8decode(this.zipComment);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset === -1) {
	            throw new Error("Corrupted zip : can't find end of central directory");
	        }
	        this.reader.setIndex(offset);
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset === -1) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;


/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var StringReader = __webpack_require__(967);
	var utils = __webpack_require__(99);
	var CompressedObject = __webpack_require__(962);
	var jszipProto = __webpack_require__(445);
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readString(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readString(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readString(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readString(this.fileCommentLength);
	
	        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
	        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
	    },
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        if (this.useUTF8()) {
	            this.fileName = jszipProto.utf8decode(this.fileName);
	            this.fileComment = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileName = upath;
	            }
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileComment = ucomment;
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;


/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.LEAD_CLASS = undefined;
	exports.default = isValidCandidate;
	
	var _common = __webpack_require__(127);
	
	var _util = __webpack_require__(971);
	
	var _utf = __webpack_require__(2319);
	
	var OPENING_PARENS = '(\\[\uFF08\uFF3B'; // Copy-pasted from `PhoneNumberMatcher.js`.
	
	var CLOSING_PARENS = ')\\]\uFF09\uFF3D';
	var NON_PARENS = '[^' + OPENING_PARENS + CLOSING_PARENS + ']';
	
	var LEAD_CLASS = exports.LEAD_CLASS = '[' + OPENING_PARENS + _common.PLUS_CHARS + ']';
	
	// Punctuation that may be at the start of a phone number - brackets and plus signs.
	var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS);
	
	// Limit on the number of pairs of brackets in a phone number.
	var BRACKET_PAIR_LIMIT = (0, _util.limit)(0, 3);
	
	/**
	 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
	 * This also checks that there is something inside the brackets. Having no brackets at all is also
	 * fine.
	 *
	 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
	 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
	 * closing bracket first. We limit the sets of brackets in a phone number to four.
	 */
	var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');
	
	/**
	 * Matches strings that look like publication pages. Example:
	 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
	 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
	 *
	 * The string "211-227 (2003)" is not a telephone number.
	 */
	var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;
	
	function isValidCandidate(candidate, offset, text, leniency) {
		// Check the candidate doesn't contain any formatting
		// which would indicate that it really isn't a phone number.
		if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
			return;
		}
	
		// If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
		// by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.
		if (leniency !== 'POSSIBLE') {
			// If the candidate is not at the start of the text,
			// and does not start with phone-number punctuation,
			// check the previous character.
			if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
				var previousChar = text[offset - 1];
				// We return null if it is a latin letter or an invalid punctuation symbol.
				if ((0, _utf.isInvalidPunctuationSymbol)(previousChar) || (0, _utf.isLatinLetter)(previousChar)) {
					return false;
				}
			}
	
			var lastCharIndex = offset + candidate.length;
			if (lastCharIndex < text.length) {
				var nextChar = text[lastCharIndex];
				if ((0, _utf.isInvalidPunctuationSymbol)(nextChar) || (0, _utf.isLatinLetter)(nextChar)) {
					return false;
				}
			}
		}
	
		return true;
	}
	//# sourceMappingURL=isValidCandidate.js.map

/***/ },
/* 2317 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = isValidPreCandidate;
	// Matches strings that look like dates using "/" as a separator.
	// Examples: 3/10/2011, 31/10/96 or 08/31/95.
	var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/;
	
	// Matches timestamps.
	// Examples: "2012-01-02 08:00".
	// Note that the reg-ex does not include the
	// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.
	var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
	var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;
	
	function isValidPreCandidate(candidate, offset, text) {
		// Skip a match that is more likely to be a date.
		if (SLASH_SEPARATED_DATES.test(candidate)) {
			return false;
		}
	
		// Skip potential time-stamps.
		if (TIME_STAMPS.test(candidate)) {
			var followingText = text.slice(offset + candidate.length);
			if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
				return false;
			}
		}
	
		return true;
	}
	//# sourceMappingURL=isValidPreCandidate.js.map

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = parsePreCandidate;
	
	var _util = __webpack_require__(971);
	
	// Regular expression of characters typically used to start a second phone number for the purposes
	// of parsing. This allows us to strip off parts of the number that are actually the start of
	// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
	// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
	// extension so that the first number is parsed correctly.
	//
	// Matches a slash (\ or /) followed by a space followed by an `x`.
	//
	var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;
	
	function parsePreCandidate(candidate) {
		// Check for extra numbers at the end.
		// TODO: This is the place to start when trying to support extraction of multiple phone number
		// from split notations (+41 79 123 45 67 / 68).
		return (0, _util.trimAfterFirstMatch)(SECOND_NUMBER_START_PATTERN, candidate);
	}
	//# sourceMappingURL=parsePreCandidate.js.map

/***/ },
/* 2319 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isLatinLetter = isLatinLetter;
	exports.isInvalidPunctuationSymbol = isInvalidPunctuationSymbol;
	// Javascript doesn't support UTF-8 regular expressions.
	// So mimicking them here.
	
	// Copy-pasted from `PhoneNumberMatcher.js`.
	
	/**
	 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
	 * http://www.regular-expressions.info/unicode.html
	 * "\P{Z}" is the reverse of "\p{Z}".
	 * "\p{N}" is any kind of numeric character in any script ("Number").
	 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
	 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
	 * "\p{L}" is any kind of letter from any language ("Letter").
	 * "\p{Mn}" is "non-spacing mark".
	 *
	 * Javascript doesn't support Unicode Regular Expressions
	 * so substituting it with this explicit set of characters.
	 *
	 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
	 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
	 */
	
	var _pZ = ' \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000';
	var pZ = exports.pZ = '[' + _pZ + ']';
	var PZ = exports.PZ = '[^' + _pZ + ']';
	
	var _pN = exports._pN = '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
	// const pN = `[${_pN}]`
	
	var _pNd = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
	var pNd = exports.pNd = '[' + _pNd + ']';
	
	var _pL = exports._pL = 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
	var pL = '[' + _pL + ']';
	var pL_regexp = new RegExp(pL);
	
	var _pSc = '$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6';
	var pSc = '[' + _pSc + ']';
	var pSc_regexp = new RegExp(pSc);
	
	var _pMn = '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26';
	var pMn = '[' + _pMn + ']';
	var pMn_regexp = new RegExp(pMn);
	
	var _InBasic_Latin = '\0-\x7F';
	var _InLatin_1_Supplement = '\x80-\xFF';
	var _InLatin_Extended_A = '\u0100-\u017F';
	var _InLatin_Extended_Additional = '\u1E00-\u1EFF';
	var _InLatin_Extended_B = '\u0180-\u024F';
	var _InCombining_Diacritical_Marks = '\u0300-\u036F';
	
	var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');
	
	/**
	 * Helper method to determine if a character is a Latin-script letter or not.
	 * For our purposes, combining marks should also return true since we assume
	 * they have been added to a preceding Latin character.
	 */
	function isLatinLetter(letter) {
	  // Combining marks are a subset of non-spacing-mark.
	  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
	    return false;
	  }
	
	  return latinLetterRegexp.test(letter);
	}
	
	function isInvalidPunctuationSymbol(character) {
	  return character === '%' || pSc_regexp.test(character);
	}
	//# sourceMappingURL=utf-8.js.map

/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (country, metadata) {
		metadata = new _metadata2.default(metadata);
	
		if (!metadata.hasCountry(country)) {
			throw new Error('Unknown country: ' + country);
		}
	
		return metadata.country(country).countryCallingCode();
	};
	
	var _metadata = __webpack_require__(109);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	//# sourceMappingURL=getCountryCallingCode.js.map

/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = is_valid;
	
	var _parse = __webpack_require__(150);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _types = __webpack_require__(306);
	
	var _types2 = _interopRequireDefault(_types);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Checks if a given phone number is valid
	//
	// Example use cases:
	//
	// ```js
	// is_valid('8005553535', 'RU')
	// is_valid('8005553535', 'RU', metadata)
	// is_valid({ phone: '8005553535', country: 'RU' })
	// is_valid({ phone: '8005553535', country: 'RU' }, metadata)
	// is_valid('+78005553535')
	// is_valid('+78005553535', metadata)
	// ```
	//
	function is_valid(arg_1, arg_2, arg_3) {
		var _sort_out_arguments = (0, _types.sort_out_arguments)(arg_1, arg_2, arg_3),
		    input = _sort_out_arguments.input,
		    metadata = _sort_out_arguments.metadata;
	
		if (!input) {
			return false;
		}
	
		if (!input.country) {
			return false;
		}
	
		if (!metadata.hasCountry(input.country)) {
			throw new Error('Unknown country: ' + input.country);
		}
	
		metadata.country(input.country);
	
		if (metadata.hasTypes()) {
			return (0, _types2.default)(input, metadata.metadata) !== undefined;
		}
	
		return true;
	}
	//# sourceMappingURL=validate.js.map

/***/ },
/* 2322 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 2323 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(973),
	    isArguments = __webpack_require__(2322),
	    isArray = __webpack_require__(2323);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(70)(module)))

/***/ },
/* 2326 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2327 */
[3450, 152, 100],
/* 2328 */
[3451, 2389, 2390, 2391, 2392, 2393],
/* 2329 */
[3455, 152, 100],
/* 2330 */
[3456, 152, 100],
/* 2331 */
[3460, 100],
/* 2332 */
[3461, 152, 100],
/* 2333 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 2334 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ },
/* 2335 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.every` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 */
	function arrayEvery(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (!predicate(array[index], index, array)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = arrayEvery;


/***/ },
/* 2336 */
[3462, 2366, 318, 36, 460, 315, 463],
/* 2337 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 2338 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 2339 */
[3463, 452, 317],
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(310);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	var get = __webpack_require__(153);
	
	/**
	 * The base implementation of `_.at` without support for individual paths.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Array} Returns the picked elements.
	 */
	function baseAt(object, paths) {
	  var index = -1,
	      length = paths.length,
	      result = Array(length),
	      skip = object == null;
	
	  while (++index < length) {
	    result[index] = skip ? undefined : get(object, paths[index]);
	  }
	  return result;
	}
	
	module.exports = baseAt;


/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(451),
	    arrayIncludes = __webpack_require__(978),
	    arrayIncludesWith = __webpack_require__(979),
	    arrayMap = __webpack_require__(151),
	    baseUnary = __webpack_require__(313),
	    cacheHas = __webpack_require__(455);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(310);
	
	/**
	 * The base implementation of `_.every` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`
	 */
	function baseEvery(collection, predicate) {
	  var result = true;
	  baseEach(collection, function(value, index, collection) {
	    result = !!predicate(value, index, collection);
	    return result;
	  });
	  return result;
	}
	
	module.exports = baseEvery;


/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(310);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 2345 */
[3466, 2376],
/* 2346 */
[3469, 980, 36],
/* 2347 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 2348 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(451),
	    arrayIncludes = __webpack_require__(978),
	    arrayIncludesWith = __webpack_require__(979),
	    arrayMap = __webpack_require__(151),
	    baseUnary = __webpack_require__(313),
	    cacheHas = __webpack_require__(455);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMin = Math.min;
	
	/**
	 * The base implementation of methods like `_.intersection`, without support
	 * for iteratee shorthands, that accepts an array of arrays to inspect.
	 *
	 * @private
	 * @param {Array} arrays The arrays to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of shared values.
	 */
	function baseIntersection(arrays, iteratee, comparator) {
	  var includes = comparator ? arrayIncludesWith : arrayIncludes,
	      length = arrays[0].length,
	      othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(othLength),
	      maxLength = Infinity,
	      result = [];
	
	  while (othIndex--) {
	    var array = arrays[othIndex];
	    if (othIndex && iteratee) {
	      array = arrayMap(array, baseUnary(iteratee));
	    }
	    maxLength = nativeMin(array.length, maxLength);
	    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	      ? new SetCache(othIndex && array)
	      : undefined;
	  }
	  array = arrays[0];
	
	  var index = -1,
	      seen = caches[0];
	
	  outer:
	  while (++index < length && result.length < maxLength) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (!(seen
	          ? cacheHas(seen, computed)
	          : includes(result, computed, comparator)
	        )) {
	      othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if (!(cache
	              ? cacheHas(cache, computed)
	              : includes(arrays[othIndex], computed, comparator))
	            ) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseIntersection;


/***/ },
/* 2350 */
[3471, 128, 112],
/* 2351 */
[3473, 976, 990, 2379, 2380, 457, 36, 460, 463],
/* 2352 */
[3474, 976, 453],
/* 2353 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 2354 */
[3475, 24, 2396, 87, 1001],
/* 2355 */
[3476, 128, 461, 112],
/* 2356 */
[3479, 2352, 2383, 996],
/* 2357 */
[3480, 453, 153, 2433, 459, 994, 996, 234],
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(151),
	    baseIteratee = __webpack_require__(85),
	    baseMap = __webpack_require__(988),
	    baseSortBy = __webpack_require__(2364),
	    baseUnary = __webpack_require__(313),
	    compareMultiple = __webpack_require__(2371),
	    identity = __webpack_require__(110);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  var index = -1;
	  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ },
/* 2359 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 2360 */
[3481, 983],
/* 2361 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(2339),
	    castPath = __webpack_require__(456),
	    isIndex = __webpack_require__(315),
	    isObject = __webpack_require__(87),
	    toKey = __webpack_require__(234);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 2363 */
[3483, 2425, 989, 110],
/* 2364 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 2365 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sum` and `_.sumBy` without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {number} Returns the sum.
	 */
	function baseSum(array, iteratee) {
	  var result,
	      index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var current = iteratee(array[index]);
	    if (current !== undefined) {
	      result = result === undefined ? current : (result + current);
	    }
	  }
	  return result;
	}
	
	module.exports = baseSum;


/***/ },
/* 2366 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 2367 */
[3484, 189, 151, 36, 155],
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(151);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(1004);
	
	/**
	 * Casts `value` to an empty array if it's not an array like object.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array|Object} Returns the cast array-like object.
	 */
	function castArrayLikeObject(value) {
	  return isArrayLikeObject(value) ? value : [];
	}
	
	module.exports = castArrayLikeObject;


/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(155);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(2370);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 2372 */
1369,
/* 2373 */
[3486, 100],
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(2334),
	    baseAggregator = __webpack_require__(2340),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(36);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(111);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 2376 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(85),
	    isArrayLike = __webpack_require__(111),
	    keys = __webpack_require__(235);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(2361),
	    isIterateeCall = __webpack_require__(458),
	    toFinite = __webpack_require__(1011);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ },
/* 2379 */
[3489, 189, 2331, 317, 990, 995, 999],
/* 2380 */
[3490, 2382],
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(2432),
	    overRest = __webpack_require__(998),
	    setToString = __webpack_require__(1000);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 2382 */
[3491, 2346, 2386, 235],
/* 2383 */
[3493, 994, 235],
/* 2384 */
[3495, 997],
/* 2385 */
[3496, 189],
/* 2386 */
[3497, 977, 2447],
/* 2387 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 2388 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 2389 */
[3500, 316],
/* 2390 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 2391 */
[3501, 316],
/* 2392 */
[3502, 316],
/* 2393 */
[3503, 316],
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(189),
	    isArguments = __webpack_require__(318),
	    isArray = __webpack_require__(36);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 2395 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 2396 */
[3506, 2373],
/* 2397 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 2398 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 2399 */
[3508, 309],
/* 2400 */
[3509, 309],
/* 2401 */
[3510, 309],
/* 2402 */
[3511, 309],
/* 2403 */
[3512, 2328, 308, 449],
/* 2404 */
[3513, 314],
/* 2405 */
[3514, 314],
/* 2406 */
[3515, 314],
/* 2407 */
[3516, 314],
/* 2408 */
[3517, 2443],
/* 2409 */
[3519, 997],
/* 2410 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(991);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 2411 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 2412 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 2413 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 2414 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 2415 */
[3523, 308],
/* 2416 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 2417 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 2418 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 2419 */
[3524, 308, 449, 450],
/* 2420 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 2421 */
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(2338),
	    hasUnicode = __webpack_require__(2388),
	    unicodeToArray = __webpack_require__(2423);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2408);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 2423 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	var baseAt = __webpack_require__(2341),
	    flatRest = __webpack_require__(2381);
	
	/**
	 * Creates an array of values corresponding to `paths` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Array} Returns the picked values.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	 *
	 * _.at(object, ['a[0].b.c', 'a[1]']);
	 * // => [3, 4]
	 */
	var at = flatRest(baseAt);
	
	module.exports = at;


/***/ },
/* 2425 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(2342),
	    baseFlatten = __webpack_require__(312),
	    baseRest = __webpack_require__(454),
	    isArrayLikeObject = __webpack_require__(1004);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEvery = __webpack_require__(2335),
	    baseEvery = __webpack_require__(2343),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(36),
	    isIterateeCall = __webpack_require__(458);
	
	/**
	 * Checks if `predicate` returns truthy for **all** elements of `collection`.
	 * Iteration is stopped once `predicate` returns falsey. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * **Note:** This method returns `true` for
	 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	 * elements of empty collections.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if all elements pass the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.every([true, 1, null, 'yes'], Boolean);
	 * // => false
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.every(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.every(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.every(users, 'active');
	 * // => false
	 */
	function every(collection, predicate, guard) {
	  var func = isArray(collection) ? arrayEvery : baseEvery;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = every;


/***/ },
/* 2428 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(977),
	    baseFilter = __webpack_require__(2344),
	    baseIteratee = __webpack_require__(85),
	    isArray = __webpack_require__(36);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ },
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(2377),
	    findIndex = __webpack_require__(2430);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(981),
	    baseIteratee = __webpack_require__(85),
	    toInteger = __webpack_require__(1012);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(312),
	    map = __webpack_require__(2440);
	
	/**
	 * Creates a flattened array of values by running each element in `collection`
	 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	 * with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * function duplicate(n) {
	 *   return [n, n];
	 * }
	 *
	 * _.flatMap([1, 2], duplicate);
	 * // => [1, 1, 2, 2]
	 */
	function flatMap(collection, iteratee) {
	  return baseFlatten(map(collection, iteratee), 1);
	}
	
	module.exports = flatMap;


/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(312);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 2433 */
[3527, 2348, 992],
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(985),
	    isArrayLike = __webpack_require__(111),
	    isString = __webpack_require__(154),
	    toInteger = __webpack_require__(1012),
	    values = __webpack_require__(465);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(151),
	    baseIntersection = __webpack_require__(2349),
	    baseRest = __webpack_require__(454),
	    castArrayLikeObject = __webpack_require__(2369);
	
	/**
	 * Creates an array of unique values that are included in all given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of intersecting values.
	 * @example
	 *
	 * _.intersection([2, 1], [2, 3]);
	 * // => [2]
	 */
	var intersection = baseRest(function(arrays) {
	  var mapped = arrayMap(arrays, castArrayLikeObject);
	  return (mapped.length && mapped[0] === arrays[0])
	    ? baseIntersection(mapped)
	    : [];
	});
	
	module.exports = intersection;


/***/ },
/* 2436 */
[3532, 986, 457, 318, 36, 111, 460, 993, 463],
/* 2437 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	 * @example
	 *
	 * _.isNull(null);
	 * // => true
	 *
	 * _.isNull(void 0);
	 * // => false
	 */
	function isNull(value) {
	  return value === null;
	}
	
	module.exports = isNull;


/***/ },
/* 2438 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is `undefined`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	 * @example
	 *
	 * _.isUndefined(void 0);
	 * // => true
	 *
	 * _.isUndefined(null);
	 * // => false
	 */
	function isUndefined(value) {
	  return value === undefined;
	}
	
	module.exports = isUndefined;


/***/ },
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(452),
	    createAggregator = __webpack_require__(2374);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ },
/* 2440 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(151),
	    baseIteratee = __webpack_require__(85),
	    baseMap = __webpack_require__(988),
	    isArray = __webpack_require__(36);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ },
/* 2441 */
[3539, 452, 982, 85],
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(311),
	    baseGt = __webpack_require__(984),
	    identity = __webpack_require__(110);
	
	/**
	 * Computes the maximum value of `array`. If `array` is empty or falsey,
	 * `undefined` is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @returns {*} Returns the maximum value.
	 * @example
	 *
	 * _.max([4, 2, 8, 6]);
	 * // => 8
	 *
	 * _.max([]);
	 * // => undefined
	 */
	function max(array) {
	  return (array && array.length)
	    ? baseExtremum(array, identity, baseGt)
	    : undefined;
	}
	
	module.exports = max;


/***/ },
/* 2443 */
[3540, 450],
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	var baseExtremum = __webpack_require__(311),
	    baseIteratee = __webpack_require__(85),
	    baseLt = __webpack_require__(987);
	
	/**
	 * This method is like `_.min` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * the value is ranked. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {*} Returns the minimum value.
	 * @example
	 *
	 * var objects = [{ 'n': 1 }, { 'n': 2 }];
	 *
	 * _.minBy(objects, function(o) { return o.n; });
	 * // => { 'n': 1 }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.minBy(objects, 'n');
	 * // => { 'n': 1 }
	 */
	function minBy(array, iteratee) {
	  return (array && array.length)
	    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
	    : undefined;
	}
	
	module.exports = minBy;


/***/ },
/* 2445 */
[3541, 100],
/* 2446 */
[3542, 2359, 2360, 459, 234],
/* 2447 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 2448 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 2449 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(85),
	    baseSum = __webpack_require__(2365);
	
	/**
	 * This method is like `_.sum` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the value to be summed.
	 * The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Math
	 * @param {Array} array The array to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {number} Returns the sum.
	 * @example
	 *
	 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	 *
	 * _.sumBy(objects, function(o) { return o.n; });
	 * // => 20
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.sumBy(objects, 'n');
	 * // => 20
	 */
	function sumBy(array, iteratee) {
	  return (array && array.length)
	    ? baseSum(array, baseIteratee(iteratee, 2))
	    : 0;
	}
	
	module.exports = sumBy;


/***/ },
/* 2450 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(189),
	    copyArray = __webpack_require__(2372),
	    getTag = __webpack_require__(457),
	    isArrayLike = __webpack_require__(111),
	    isString = __webpack_require__(154),
	    iteratorToArray = __webpack_require__(2397),
	    mapToArray = __webpack_require__(995),
	    setToArray = __webpack_require__(999),
	    stringToArray = __webpack_require__(2421),
	    values = __webpack_require__(465);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var symIterator = Symbol ? Symbol.iterator : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ },
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2455);
	Mexp.prototype.formulaEval = function () {
		"use strict";
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1||arr[i].type===3){
				disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
			}
			else if(arr[i].type===13){
				disp.push({value:arr[i].show,type:1});
			}
			else if(arr[i].type===0){
				disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
			}
			else if(arr[i].type===7){
				disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
			}
			else if(arr[i].type===10){
				pop1=disp.pop();
				pop2=disp.pop();
				if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
				else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=disp.pop();
				pop2=disp.pop();
				disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
			}
			else if(arr[i].type===12){
				pop1=disp.pop();
				pop2=disp.pop();
				pop3=disp.pop();
				disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
			}
		}
		return disp[0].value;
	};
	module.exports=Mexp;

/***/ },
/* 2452 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2453);
		function inc(arr,val){
			for(var i=0;i<arr.length;i++)
				arr[i]+=val;
			return arr;
		}
		var token=['sin','cos','tan','pi','(',')','P','C',
			  'asin','acos','atan','7','8','9','int',
			  'cosh','acosh','ln','^','root','4','5','6','/','!',
			  'tanh','atanh','Mod','1','2','3','*',
			  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
		var show=['sin','cos','tan','&pi;','(',')','P','C',
			'asin','acos','atan','7','8','9','Int',
			'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
			'tanh','atanh',' Mod ','1','2','3','&times;',
			'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
		var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
			Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
			Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
			Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
			Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
		var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
		var type=[0,0,0,3,4,5,10,10,
			0,0,0,1,1,1,0,
			0,0,0,10,0,1,1,1,2,7,
			0,0,2,1,1,1,2,
			0,0,3,0,1,6,9,9,11,12,13,12,8];
		 /*
		0 : function with syntax function_name(Maths_exp)
		1 : numbers
		2 : binary operators like * / Mod left associate and same precedence
		3 : Math constant values like e,pi,Cruncher ans
		4 : opening bracket
		5 : closing bracket
		6 : decimal
		7 : function with syntax (Math_exp)function_name
		8: function with syntax function_name(Math_exp1,Math_exp2)
		9 : binary operator like +,-
		10: binary operator like P C or ^
		11: ,
		12: function with , seperated three parameters
		13: variable of Sigma function
		 */
		var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
		type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
		type_1={0:true,3:true,4:true,8:true,12:true,13:true},
		empty={},
		type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
		type6={1:true},
		newAr=[[],
				["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
				["pi","ln","Pi"],
				["sin","cos","tan","Del","int","Mod","log","pow"],
				["asin","acos","atan","cosh","root","tanh","sinh"],
				["acosh","atanh","asinh","Sigma"]];
		function match(str1,str2,i,x){
			for(var f=0;f<x;f++){
				if (str1[i+f]!==str2[f])
					return false;
			}
			return true;
		}
		Mexp.addToken=function(tokens){
			for(i=0;i<tokens.length;i++){
				x=tokens[i].token.length;
				var temp=-1;
	
				//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on
	
				if (x<newAr.length)	//match to check if token is really huge and not existing
									//if not checked it will break in next line as undefined index
					for(y=0;y<newAr[x].length;y++){
						if (tokens[i].token===newAr[x][y]){
							temp=token.indexOf(newAr[x][y]);
							break;
						}
					}
				if (temp===-1) {
					token.push(tokens[i].token);
					type.push(tokens[i].type);
					if(newAr.length<=tokens[i].token.length)
						newAr[tokens[i].token.length]=[];
					newAr[tokens[i].token.length].push(tokens[i].token);
					eva.push(tokens[i].value);
					show.push(tokens[i].show);
				}
				else {
					token[temp]=tokens[i].token;
					type[temp]=tokens[i].type;
					eva[temp]=tokens[i].value;
					show[temp]=tokens[i].show;
				}
			}
		};
		Mexp.lex=function(inp,tokens){
			'use strict';
			var str=[{type:4,value:"(",show:"(",pre:0}];
			var ptc=[];	//Parenthesis to close at the beginning is after one token
			var inpStr=inp;
			var key;
	        var pcounter=0;
			var allowed=type0;
			var bracToClose=0;
			var asterick=empty;
			var prevKey='';
			var i,x,y;
			if(typeof tokens!=="undefined")
				Mexp.addToken(tokens);
			var obj={};
			for(i=0;i<inpStr.length;i++){
				if (inpStr[i]==' ') {
					continue;
				}
				key='';
				sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
					for(y=0;y<newAr[x].length;y++){
						if (match(inpStr,newAr[x][y],i,x)){
							key=newAr[x][y];
							break sec;
						}
					}
				}
				i+=key.length-1;
				if(key===''){
					throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
				}
				var index=token.indexOf(key);
				var cToken=key;
				var cType=type[index];
				var cEv=eva[index];
				var cPre=preced[cType];
				var	cShow=show[index];
				var pre=str[str.length-1];
				for(j=ptc.length;j--;){	//loop over ptc
					if(ptc[j]===0){
						if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
							if(allowed[cType]!==true){
								throw(new Mexp.exception(key+" is not allowed after "+prevKey));
							}
							str.push({value:")",type:5,pre:0,show:")"});
							allowed=type1;
							asterick=type_3;
							inc(ptc,-1).pop();
						}
					}
				}
				if(allowed[cType]!==true){
					throw(new Mexp.exception(key+" is not allowed after "+prevKey));
				}
				if(asterick[cType]===true){
					cType=2;
					cEv=Mexp.math.mul;
					cShow="&times;";
					cPre=3;
					i=i-key.length;
			 	}
				obj={value:cEv,type:cType,pre:cPre,show:cShow};
				if(cType===0){
					allowed=type0;
					asterick=empty;
					inc(ptc,2).push(2);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===1){
					if(pre.type===1){
						pre.value+=cEv;
						inc(ptc,1);
					}
					else {
						str.push(obj);
					}
					allowed=type1;
					asterick=type_1;
				}
				else if(cType===2){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===3){//constant
					str.push(obj);
					allowed=type1;
					asterick=type_3;
				}
				else if(cType===4){
	                pcounter+=ptc.length;
	                ptc=[];
					bracToClose++;
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===5){
					if(!bracToClose){
						throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
					}
	                while(pcounter--){	//loop over ptc
	    						str.push({value:")",type:5,pre:0,show:")"});
	    			}
	                pcounter=0;
					bracToClose--;
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				else if(cType===6){
					if(pre.hasDec){
						throw(new Mexp.exception("Two decimals are not allowed in one number"));
					}
					if(pre.type!==1){
						pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
						str.push(pre);
						inc(ptc,-1);
					}
					allowed=type6;
					inc(ptc,1);
					asterick=empty;
					pre.value+=cEv;
					pre.hasDec=true;
				}
				else if(cType===7){
					allowed=type1;
					asterick=type_3;
					inc(ptc,1);
					str.push(obj);
				}
				if(cType===8){
					allowed=type0;
					asterick=empty;
					inc(ptc,4).push(4);
					str.push(obj);
					str.push({value:"(",type:4,pre:0,show:"("});
				}
				else if(cType===9){
					if(pre.type===9){
						if(pre.value===Mexp.math.add){
							pre.value=cEv;
							pre.show=cShow;
							inc(ptc,1);
						}
						else if(pre.value===Mexp.math.sub&&cShow==='-'){
							pre.value=Mexp.math.add;
							pre.show='+';
							inc(ptc,1);
						}
					}
					else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
						if(cToken==='-'){//do nothing for + token
										//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
							allowed=type0;
							asterick=empty;
							inc(ptc,2).push(2);
							str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
							str.push({value:"(",type:4,pre:0,show:"("});
						}
					}
					else{
						str.push(obj);
						inc(ptc,2);
					}
					allowed=type0;
					asterick=empty;
				}
				else if(cType===10){
					allowed=type0;
					asterick=empty;
					inc(ptc,2);
					str.push(obj);
				}
				else if(cType===11){
					allowed=type0;
					asterick=empty;
					str.push(obj);
				}
				else if(cType===12){
					allowed=type0;
					asterick=empty;
					inc(ptc,6).push(6);
					str.push(obj);
					str.push({value:"(",type:4,pre:0});
				}
				else if(cType===13){
					allowed=type1;
					asterick=type_3;
					str.push(obj);
				}
				inc(ptc,-1);
				prevKey=key;
			}
			for(var j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
	
					str.push({value:")",show:")",type:5,pre:3});
					inc(ptc,-1).pop();
				}
			}
			if (allowed[5]!==true) {
				throw(new Mexp.exception("complete the expression"));
			}
			while(bracToClose--)
				str.push({value:")",show:")",type:5,pre:3});
	
			str.push({type:5,value:")",show:")",pre:0});
	//        console.log(str);
			return new Mexp(str);
		};
	    module.exports=Mexp;


/***/ },
/* 2453 */
/***/ function(module, exports) {

		var Mexp=function(parsed){
			this.value=parsed;
	
		};
	
		Mexp.math={
			isDegree:true, //mode of calculator
			acos:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
			},
			add:function(a,b){
				return a+b;
			},
			asin:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
			},
			atan:function(x){
				return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
			},
			acosh:function(x){
				return Math.log(x+Math.sqrt(x*x-1));
			},
			asinh:function(x){
				return Math.log(x+Math.sqrt(x*x+1));
			},
			atanh:function(x){
				return Math.log((1+x)/(1-x));
			},
			C:function(n,r){
				var pro=1,other=n-r,choice=r;
				if(choice<other){
				choice=other;
				other=r;
				}
				for(var i=choice+1;i<=n;i++)
					pro*=i;
				return pro/Mexp.math.fact(other);
			},
			changeSign:function(x){
				return -x;
			},
			cos:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.cos(x);
			},
			cosh:function(x){
				return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
			},
			div:function(a,b){
			return a/b;
			},
			fact:function(n) {
			if(n%1!==0)return "NAN";
				var pro=1;
				for(var i=2;i<=n;i++)
					pro*=i;
				return pro;
			},
			inverse:function(x){
				return 1/x;
			},
			log:function(i){
				return Math.log(i)/Math.log(10);
			},
			mod:function(a,b){
			return a%b;
			},
			mul:function(a,b){
			return a*b;
			},
			P:function(n,r){var pro=1;
				 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
						pro*=i;
						return pro;
	
			},
			Pi:function(low,high,ex){
				var pro=1;
				for(var i=low;i<=high;i++){
					pro*=Number(ex.postfixEval({n:i}));
				}
				return pro;
			},
			pow10x:function(e){
				var x=1;
				while(e--){x*=10;}
				return x;
			},
			sigma:function(low,high,ex){
				var sum=0;
				for(var i=low;i<=high;i++){
					sum+=Number(ex.postfixEval({n:i}));
				}
				return sum;
			},
			sin:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.sin(x);
			},
			sinh:function(x){
				return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
			},
			sub:function(a,b){
			return a-b;
			},
			tan:function(x){
				if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
				return Math.tan(x);
			},
			tanh:function(x){
				return Mexp.sinha(x)/Mexp.cosha(x);
			},
			toRadian:function(x){
				return x*Math.PI/180;
			}
		};
		Mexp.exception=function(message){
			this.message=message;
		};
	    module.exports=Mexp;

/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	
	    var Mexp=__webpack_require__(2452);
	
		Mexp.prototype.toPostfix = function () {
			'use strict';
			var post=[],elem,popped,prep,pre,ele;
	    	var stack=[{value:"(",type:4,pre:0}];
			var arr=this.value;
			for (var i=1; i < arr.length; i++) {
				if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
					if(arr[i].type===1)
						arr[i].value=Number(arr[i].value);
					post.push(arr[i]);
				}
				else if(arr[i].type===4){
					stack.push(arr[i]);
				}
				else if(arr[i].type===5){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
				}
				else if(arr[i].type===11){
					while((popped=stack.pop()).type!==4){
						post.push(popped);
					}
					stack.push(popped);
				}
				else {
					elem=arr[i];
					pre=elem.pre;
					ele=stack[stack.length-1];
					prep=ele.pre;
					var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
					if(pre>prep)stack.push(elem);
					else {
						while(prep>=pre&&!flag||flag&&pre<prep){
							popped=stack.pop();
							ele=stack[stack.length-1];
							post.push(popped);
							prep=ele.pre;
							flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
						}
						stack.push(elem);
					}
				}
			}
			return new Mexp(post);
		};
	    module.exports=Mexp;

/***/ },
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	var Mexp=__webpack_require__(2454);
	Mexp.prototype.postfixEval = function (UserDefined) {
		'use strict';
		UserDefined=UserDefined||{};
		UserDefined.PI=Math.PI;
		UserDefined.E=Math.E;
		var stack=[],pop1,pop2,pop3;
		var disp=[];
		var temp='';
		var arr=this.value;
		var bool=(typeof UserDefined.n!=="undefined");
		for(var i=0;i<arr.length;i++){
			if(arr[i].type===1){
				stack.push({value:arr[i].value,type:1});
			}
			else if(arr[i].type===3){
				stack.push({value:UserDefined[arr[i].value],type:1});
			}
			else if(arr[i].type===0){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===7){
				if(typeof stack[stack.length-1].type==="undefined"){
					stack[stack.length-1].value.push(arr[i]);
				}
				else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
			}
			else if(arr[i].type===8){
				pop1=stack.pop();
				pop2=stack.pop();
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
			else if(arr[i].type===10){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
					pop2.value=pop2.concat(pop1);
					pop2.value.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
	            }
			}
			else if(arr[i].type===2||arr[i].type===9){
				pop1=stack.pop();
				pop2=stack.pop();
				if(typeof pop2.type==="undefined"){
	                console.log(pop2);
					pop2=pop2.concat(pop1);
					pop2.push(arr[i]);
					stack.push(pop2);
				}
				else if (typeof pop1.type==="undefined") {
					pop1.unshift(pop2);
					pop1.push(arr[i]);
					stack.push(pop1);
				}
				else{
					stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
				}
			}
			else if(arr[i].type===12){
				pop1=stack.pop();
				if (typeof pop1.type!=="undefined") {
					pop1=[pop1];
				}
				pop2=stack.pop();
				pop3=stack.pop();
				stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
			}
			else if(arr[i].type===13){
				if(bool){
					stack.push({value:UserDefined[arr[i].value],type:3});
				}
				else stack.push([arr[i]]);
			}
		}
		if (stack.length>1) {
			throw(new Mexp.exception("Uncaught Syntax error"));
		}
		return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
	};
	Mexp.eval=function(str,tokens,obj){
		if (typeof tokens==="undefined") {
			return this.lex(str).toPostfix().postfixEval();
		}
		else if (typeof obj==="undefined") {
			if (typeof tokens.length!=="undefined") 
				return this.lex(str,tokens).toPostfix().postfixEval();
			else
				return this.lex(str).toPostfix().postfixEval(tokens);
		}
		else
			return this.lex(str,tokens).toPostfix().postfixEval(obj);
	};
	module.exports=Mexp;

/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  function Provider() {
	    _classCallCheck(this, Provider);
	
	    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	  }
	
	  _createClass(Provider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        miniStore: this.props.store
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return Provider;
	}(_react.Component);
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired
	};
	Provider.childContextTypes = {
	  miniStore: _PropTypes.storeShape.isRequired
	};
	exports.default = Provider;

/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = connect;
	
	var _react = __webpack_require__(1);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _hoistNonReactStatics = __webpack_require__(231);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var defaultMapStateToProps = function defaultMapStateToProps() {
	  return {};
	};
	
	function connect(mapStateToProps) {
	  var shouldSubscribe = !!mapStateToProps;
	  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));
	
	        _this.handleChange = function () {
	          if (!_this.unsubscribe) {
	            return;
	          }
	
	          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
	          if (!(0, _shallowequal2.default)(_this.nextState, nextState)) {
	            _this.nextState = nextState;
	            _this.setState({ subscribed: nextState });
	          }
	        };
	
	        _this.store = context.miniStore;
	        _this.state = { subscribed: finnalMapStateToProps(_this.store.getState(), props) };
	        return _this;
	      }
	
	      _createClass(Connect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.trySubscribe();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.tryUnsubscribe();
	        }
	      }, {
	        key: 'trySubscribe',
	        value: function trySubscribe() {
	          if (shouldSubscribe) {
	            this.unsubscribe = this.store.subscribe(this.handleChange);
	            this.handleChange();
	          }
	        }
	      }, {
	        key: 'tryUnsubscribe',
	        value: function tryUnsubscribe() {
	          if (this.unsubscribe) {
	            this.unsubscribe();
	            this.unsubscribe = null;
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          return (0, _react.createElement)(WrappedComponent, _extends({}, this.props, this.state.subscribed, {
	            store: this.store
	          }));
	        }
	      }]);
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	    Connect.contextTypes = {
	      miniStore: _PropTypes.storeShape.isRequired
	    };
	
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 2458 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = create;
	function create(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends({}, state, partial);
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1016,
		"./af.js": 1016,
		"./ar": 1023,
		"./ar-dz": 1017,
		"./ar-dz.js": 1017,
		"./ar-kw": 1018,
		"./ar-kw.js": 1018,
		"./ar-ly": 1019,
		"./ar-ly.js": 1019,
		"./ar-ma": 1020,
		"./ar-ma.js": 1020,
		"./ar-sa": 1021,
		"./ar-sa.js": 1021,
		"./ar-tn": 1022,
		"./ar-tn.js": 1022,
		"./ar.js": 1023,
		"./az": 1024,
		"./az.js": 1024,
		"./be": 1025,
		"./be.js": 1025,
		"./bg": 1026,
		"./bg.js": 1026,
		"./bm": 1027,
		"./bm.js": 1027,
		"./bn": 1028,
		"./bn.js": 1028,
		"./bo": 1029,
		"./bo.js": 1029,
		"./br": 1030,
		"./br.js": 1030,
		"./bs": 1031,
		"./bs.js": 1031,
		"./ca": 1032,
		"./ca.js": 1032,
		"./cs": 1033,
		"./cs.js": 1033,
		"./cv": 1034,
		"./cv.js": 1034,
		"./cy": 1035,
		"./cy.js": 1035,
		"./da": 1036,
		"./da.js": 1036,
		"./de": 1039,
		"./de-at": 1037,
		"./de-at.js": 1037,
		"./de-ch": 1038,
		"./de-ch.js": 1038,
		"./de.js": 1039,
		"./dv": 1040,
		"./dv.js": 1040,
		"./el": 1041,
		"./el.js": 1041,
		"./en-au": 1042,
		"./en-au.js": 1042,
		"./en-ca": 1043,
		"./en-ca.js": 1043,
		"./en-gb": 1044,
		"./en-gb.js": 1044,
		"./en-ie": 1045,
		"./en-ie.js": 1045,
		"./en-nz": 1046,
		"./en-nz.js": 1046,
		"./eo": 1047,
		"./eo.js": 1047,
		"./es": 1050,
		"./es-do": 1048,
		"./es-do.js": 1048,
		"./es-us": 1049,
		"./es-us.js": 1049,
		"./es.js": 1050,
		"./et": 1051,
		"./et.js": 1051,
		"./eu": 1052,
		"./eu.js": 1052,
		"./fa": 1053,
		"./fa.js": 1053,
		"./fi": 1054,
		"./fi.js": 1054,
		"./fo": 1055,
		"./fo.js": 1055,
		"./fr": 1058,
		"./fr-ca": 1056,
		"./fr-ca.js": 1056,
		"./fr-ch": 1057,
		"./fr-ch.js": 1057,
		"./fr.js": 1058,
		"./fy": 1059,
		"./fy.js": 1059,
		"./gd": 1060,
		"./gd.js": 1060,
		"./gl": 1061,
		"./gl.js": 1061,
		"./gom-latn": 1062,
		"./gom-latn.js": 1062,
		"./gu": 1063,
		"./gu.js": 1063,
		"./he": 1064,
		"./he.js": 1064,
		"./hi": 1065,
		"./hi.js": 1065,
		"./hr": 1066,
		"./hr.js": 1066,
		"./hu": 1067,
		"./hu.js": 1067,
		"./hy-am": 1068,
		"./hy-am.js": 1068,
		"./id": 1069,
		"./id.js": 1069,
		"./is": 1070,
		"./is.js": 1070,
		"./it": 1071,
		"./it.js": 1071,
		"./ja": 1072,
		"./ja.js": 1072,
		"./jv": 1073,
		"./jv.js": 1073,
		"./ka": 1074,
		"./ka.js": 1074,
		"./kk": 1075,
		"./kk.js": 1075,
		"./km": 1076,
		"./km.js": 1076,
		"./kn": 1077,
		"./kn.js": 1077,
		"./ko": 1078,
		"./ko.js": 1078,
		"./ky": 1079,
		"./ky.js": 1079,
		"./lb": 1080,
		"./lb.js": 1080,
		"./lo": 1081,
		"./lo.js": 1081,
		"./lt": 1082,
		"./lt.js": 1082,
		"./lv": 1083,
		"./lv.js": 1083,
		"./me": 1084,
		"./me.js": 1084,
		"./mi": 1085,
		"./mi.js": 1085,
		"./mk": 1086,
		"./mk.js": 1086,
		"./ml": 1087,
		"./ml.js": 1087,
		"./mr": 1088,
		"./mr.js": 1088,
		"./ms": 1090,
		"./ms-my": 1089,
		"./ms-my.js": 1089,
		"./ms.js": 1090,
		"./my": 1091,
		"./my.js": 1091,
		"./nb": 1092,
		"./nb.js": 1092,
		"./ne": 1093,
		"./ne.js": 1093,
		"./nl": 1095,
		"./nl-be": 1094,
		"./nl-be.js": 1094,
		"./nl.js": 1095,
		"./nn": 1096,
		"./nn.js": 1096,
		"./pa-in": 1097,
		"./pa-in.js": 1097,
		"./pl": 1098,
		"./pl.js": 1098,
		"./pt": 1100,
		"./pt-br": 1099,
		"./pt-br.js": 1099,
		"./pt.js": 1100,
		"./ro": 1101,
		"./ro.js": 1101,
		"./ru": 1102,
		"./ru.js": 1102,
		"./sd": 1103,
		"./sd.js": 1103,
		"./se": 1104,
		"./se.js": 1104,
		"./si": 1105,
		"./si.js": 1105,
		"./sk": 1106,
		"./sk.js": 1106,
		"./sl": 1107,
		"./sl.js": 1107,
		"./sq": 1108,
		"./sq.js": 1108,
		"./sr": 1110,
		"./sr-cyrl": 1109,
		"./sr-cyrl.js": 1109,
		"./sr.js": 1110,
		"./ss": 1111,
		"./ss.js": 1111,
		"./sv": 1112,
		"./sv.js": 1112,
		"./sw": 1113,
		"./sw.js": 1113,
		"./ta": 1114,
		"./ta.js": 1114,
		"./te": 1115,
		"./te.js": 1115,
		"./tet": 1116,
		"./tet.js": 1116,
		"./th": 1117,
		"./th.js": 1117,
		"./tl-ph": 1118,
		"./tl-ph.js": 1118,
		"./tlh": 1119,
		"./tlh.js": 1119,
		"./tr": 1120,
		"./tr.js": 1120,
		"./tzl": 1121,
		"./tzl.js": 1121,
		"./tzm": 1123,
		"./tzm-latn": 1122,
		"./tzm-latn.js": 1122,
		"./tzm.js": 1123,
		"./uk": 1124,
		"./uk.js": 1124,
		"./ur": 1125,
		"./ur.js": 1125,
		"./uz": 1127,
		"./uz-latn": 1126,
		"./uz-latn.js": 1126,
		"./uz.js": 1127,
		"./vi": 1128,
		"./vi.js": 1128,
		"./x-pseudo": 1129,
		"./x-pseudo.js": 1129,
		"./yo": 1130,
		"./yo.js": 1130,
		"./zh-cn": 1131,
		"./zh-cn.js": 1131,
		"./zh-hk": 1132,
		"./zh-hk.js": 1132,
		"./zh-tw": 1133,
		"./zh-tw.js": 1133
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2459;


/***/ },
/* 2460 */
/***/ function(module, exports, __webpack_require__) {

	var cliches = [
	  'a chip off the old block',
	  'a clean slate',
	  'a dark and stormy night',
	  'a far cry',
	  'a fine kettle of fish',
	  'a loose cannon',
	  'a penny saved is a penny earned',
	  'a tough row to hoe',
	  'a word to the wise',
	  'ace in the hole',
	  'acid test',
	  'add insult to injury',
	  'against all odds',
	  'air your dirty laundry',
	  'all fun and games',
	  'all in a day\'s work',
	  'all talk, no action',
	  'all thumbs',
	  'all your eggs in one basket',
	  'all\'s fair in love and war',
	  'all\'s well that ends well',
	  'almighty dollar',
	  'American as apple pie',
	  'an axe to grind',
	  'another day, another dollar',
	  'armed to the teeth',
	  'as luck would have it',
	  'as old as time',
	  'as the crow flies',
	  'at loose ends',
	  'at my wits end',
	  'avoid like the plague',
	  'babe in the woods',
	  'back against the wall',
	  'back in the saddle',
	  'back to square one',
	  'back to the drawing board',
	  'bad to the bone',
	  'badge of honor',
	  'bald faced liar',
	  'ballpark figure',
	  'banging your head against a brick wall',
	  'baptism by fire',
	  'barking up the wrong tree',
	  'bat out of hell',
	  'be all and end all',
	  'beat a dead horse',
	  'beat around the bush',
	  'been there, done that',
	  'beggars can\'t be choosers',
	  'behind the eight ball',
	  'bend over backwards',
	  'benefit of the doubt',
	  'bent out of shape',
	  'best thing since sliced bread',
	  'bet your bottom dollar',
	  'better half',
	  'better late than never',
	  'better mousetrap',
	  'better safe than sorry',
	  'between a rock and a hard place',
	  'beyond the pale',
	  'bide your time',
	  'big as life',
	  'big cheese',
	  'big fish in a small pond',
	  'big man on campus',
	  'bigger they are the harder they fall',
	  'bird in the hand',
	  'bird\'s eye view',
	  'birds and the bees',
	  'birds of a feather flock together',
	  'bit the hand that feeds you',
	  'bite the bullet',
	  'bite the dust',
	  'bitten off more than he can chew',
	  'black as coal',
	  'black as pitch',
	  'black as the ace of spades',
	  'blast from the past',
	  'bleeding heart',
	  'blessing in disguise',
	  'blind ambition',
	  'blind as a bat',
	  'blind leading the blind',
	  'blood is thicker than water',
	  'blood sweat and tears',
	  'blow off steam',
	  'blow your own horn',
	  'blushing bride',
	  'boils down to',
	  'bolt from the blue',
	  'bone to pick',
	  'bored stiff',
	  'bored to tears',
	  'bottomless pit',
	  'boys will be boys',
	  'bright and early',
	  'brings home the bacon',
	  'broad across the beam',
	  'broken record',
	  'brought back to reality',
	  'bull by the horns',
	  'bull in a china shop',
	  'burn the midnight oil',
	  'burning question',
	  'burning the candle at both ends',
	  'burst your bubble',
	  'bury the hatchet',
	  'busy as a bee',
	  'by hook or by crook',
	  'call a spade a spade',
	  'called onto the carpet',
	  'calm before the storm',
	  'can of worms',
	  'can\'t cut the mustard',
	  'can\'t hold a candle to',
	  'case of mistaken identity',
	  'cat got your tongue',
	  'cat\'s meow',
	  'caught in the crossfire',
	  'caught red-handed',
	  'checkered past',
	  'chomping at the bit',
	  'cleanliness is next to godliness',
	  'clear as a bell',
	  'clear as mud',
	  'close to the vest',
	  'cock and bull story',
	  'cold shoulder',
	  'come hell or high water',
	  'cool as a cucumber',
	  'cool, calm, and collected',
	  'cost a king\'s ransom',
	  'count your blessings',
	  'crack of dawn',
	  'crash course',
	  'creature comforts',
	  'cross that bridge when you come to it',
	  'crushing blow',
	  'cry like a baby',
	  'cry me a river',
	  'cry over spilt milk',
	  'crystal clear',
	  'curiosity killed the cat',
	  'cut and dried',
	  'cut through the red tape',
	  'cut to the chase',
	  'cute as a bugs ear',
	  'cute as a button',
	  'cute as a puppy',
	  'cuts to the quick',
	  'dark before the dawn',
	  'day in, day out',
	  'dead as a doornail',
	  'devil is in the details',
	  'dime a dozen',
	  'divide and conquer',
	  'dog and pony show',
	  'dog days',
	  'dog eat dog',
	  'dog tired',
	  'don\'t burn your bridges',
	  'don\'t count your chickens',
	  'don\'t look a gift horse in the mouth',
	  'don\'t rock the boat',
	  'don\'t step on anyone\'s toes',
	  'don\'t take any wooden nickels',
	  'down and out',
	  'down at the heels',
	  'down in the dumps',
	  'down the hatch',
	  'down to earth',
	  'draw the line',
	  'dressed to kill',
	  'dressed to the nines',
	  'drives me up the wall',
	  'dull as dishwater',
	  'dyed in the wool',
	  'eagle eye',
	  'ear to the ground',
	  'early bird catches the worm',
	  'easier said than done',
	  'easy as pie',
	  'eat your heart out',
	  'eat your words',
	  'eleventh hour',
	  'even the playing field',
	  'every dog has its day',
	  'every fiber of my being',
	  'everything but the kitchen sink',
	  'eye for an eye',
	  'face the music',
	  'facts of life',
	  'fair weather friend',
	  'fall by the wayside',
	  'fan the flames',
	  'feast or famine',
	  'feather your nest',
	  'feathered friends',
	  'few and far between',
	  'fifteen minutes of fame',
	  'filthy vermin',
	  'fine kettle of fish',
	  'fish out of water',
	  'fishing for a compliment',
	  'fit as a fiddle',
	  'fit the bill',
	  'fit to be tied',
	  'flash in the pan',
	  'flat as a pancake',
	  'flip your lid',
	  'flog a dead horse',
	  'fly by night',
	  'fly the coop',
	  'follow your heart',
	  'for all intents and purposes',
	  'for the birds',
	  'for what it\'s worth',
	  'force of nature',
	  'force to be reckoned with',
	  'forgive and forget',
	  'fox in the henhouse',
	  'free and easy',
	  'free as a bird',
	  'fresh as a daisy',
	  'full steam ahead',
	  'fun in the sun',
	  'garbage in, garbage out',
	  'gentle as a lamb',
	  'get a kick out of',
	  'get a leg up',
	  'get down and dirty',
	  'get the lead out',
	  'get to the bottom of',
	  'get your feet wet',
	  'gets my goat',
	  'gilding the lily',
	  'give and take',
	  'go against the grain',
	  'go at it tooth and nail',
	  'go for broke',
	  'go him one better',
	  'go the extra mile',
	  'go with the flow',
	  'goes without saying',
	  'good as gold',
	  'good deed for the day',
	  'good things come to those who wait',
	  'good time was had by all',
	  'good times were had by all',
	  'greased lightning',
	  'greek to me',
	  'green thumb',
	  'green-eyed monster',
	  'grist for the mill',
	  'growing like a weed',
	  'hair of the dog',
	  'hand to mouth',
	  'happy as a clam',
	  'happy as a lark',
	  'hasn\'t a clue',
	  'have a nice day',
	  'have high hopes',
	  'have the last laugh',
	  'haven\'t got a row to hoe',
	  'head honcho',
	  'head over heels',
	  'hear a pin drop',
	  'heard it through the grapevine',
	  'heart\'s content',
	  'heavy as lead',
	  'hem and haw',
	  'high and dry',
	  'high and mighty',
	  'high as a kite',
	  'hit paydirt',
	  'hold your head up high',
	  'hold your horses',
	  'hold your own',
	  'hold your tongue',
	  'honest as the day is long',
	  'horns of a dilemma',
	  'horse of a different color',
	  'hot under the collar',
	  'hour of need',
	  'I beg to differ',
	  'icing on the cake',
	  'if the shoe fits',
	  'if the shoe were on the other foot',
	  'in a jam',
	  'in a jiffy',
	  'in a nutshell',
	  'in a pig\'s eye',
	  'in a pinch',
	  'in a word',
	  'in hot water',
	  'in the gutter',
	  'in the nick of time',
	  'in the thick of it',
	  'in your dreams',
	  'it ain\'t over till the fat lady sings',
	  'it goes without saying',
	  'it takes all kinds',
	  'it takes one to know one',
	  'it\'s a small world',
	  'it\'s only a matter of time',
	  'ivory tower',
	  'Jack of all trades',
	  'jockey for position',
	  'jog your memory',
	  'joined at the hip',
	  'judge a book by its cover',
	  'jump down your throat',
	  'jump in with both feet',
	  'jump on the bandwagon',
	  'jump the gun',
	  'jump to conclusions',
	  'just a hop, skip, and a jump',
	  'just the ticket',
	  'justice is blind',
	  'keep a stiff upper lip',
	  'keep an eye on',
	  'keep it simple, stupid',
	  'keep the home fires burning',
	  'keep up with the Joneses',
	  'keep your chin up',
	  'keep your fingers crossed',
	  'kick the bucket',
	  'kick up your heels',
	  'kick your feet up',
	  'kid in a candy store',
	  'kill two birds with one stone',
	  'kiss of death',
	  'knock it out of the park',
	  'knock on wood',
	  'knock your socks off',
	  'know him from Adam',
	  'know the ropes',
	  'know the score',
	  'knuckle down',
	  'knuckle sandwich',
	  'knuckle under',
	  'labor of love',
	  'ladder of success',
	  'land on your feet',
	  'lap of luxury',
	  'last but not least',
	  'last hurrah',
	  'last-ditch effort',
	  'law of the jungle',
	  'law of the land',
	  'lay down the law',
	  'leaps and bounds',
	  'let sleeping dogs lie',
	  'let the cat out of the bag',
	  'let the good times roll',
	  'let your hair down',
	  'let\'s talk turkey',
	  'letter perfect',
	  'lick your wounds',
	  'lies like a rug',
	  'life\'s a bitch',
	  'life\'s a grind',
	  'light at the end of the tunnel',
	  'lighter than a feather',
	  'lighter than air',
	  'like clockwork',
	  'like father like son',
	  'like taking candy from a baby',
	  'like there\'s no tomorrow',
	  'lion\'s share',
	  'live and learn',
	  'live and let live',
	  'long and short of it',
	  'long lost love',
	  'look before you leap',
	  'look down your nose',
	  'look what the cat dragged in',
	  'looking a gift horse in the mouth',
	  'looks like death warmed over',
	  'loose cannon',
	  'lose your head',
	  'lose your temper',
	  'loud as a horn',
	  'lounge lizard',
	  'loved and lost',
	  'low man on the totem pole',
	  'luck of the draw',
	  'luck of the Irish',
	  'make hay while the sun shines',
	  'make money hand over fist',
	  'make my day',
	  'make the best of a bad situation',
	  'make the best of it',
	  'make your blood boil',
	  'man of few words',
	  'man\'s best friend',
	  'mark my words',
	  'meaningful dialogue',
	  'missed the boat on that one',
	  'moment in the sun',
	  'moment of glory',
	  'moment of truth',
	  'money to burn',
	  'more power to you',
	  'more than one way to skin a cat',
	  'movers and shakers',
	  'moving experience',
	  'naked as a jaybird',
	  'naked truth',
	  'neat as a pin',
	  'needle in a haystack',
	  'needless to say',
	  'neither here nor there',
	  'never look back',
	  'never say never',
	  'nip and tuck',
	  'nip it in the bud',
	  'no guts, no glory',
	  'no love lost',
	  'no pain, no gain',
	  'no skin off my back',
	  'no stone unturned',
	  'no time like the present',
	  'no use crying over spilled milk',
	  'nose to the grindstone',
	  'not a hope in hell',
	  'not a minute\'s peace',
	  'not in my backyard',
	  'not playing with a full deck',
	  'not the end of the world',
	  'not written in stone',
	  'nothing to sneeze at',
	  'nothing ventured nothing gained',
	  'now we\'re cooking',
	  'off the top of my head',
	  'off the wagon',
	  'off the wall',
	  'old hat',
	  'older and wiser',
	  'older than dirt',
	  'older than Methuselah',
	  'on a roll',
	  'on cloud nine',
	  'on pins and needles',
	  'on the bandwagon',
	  'on the money',
	  'on the nose',
	  'on the rocks',
	  'on the spot',
	  'on the tip of my tongue',
	  'on the wagon',
	  'on thin ice',
	  'once bitten, twice shy',
	  'one bad apple doesn\'t spoil the bushel',
	  'one born every minute',
	  'one brick short',
	  'one foot in the grave',
	  'one in a million',
	  'one red cent',
	  'only game in town',
	  'open a can of worms',
	  'open and shut case',
	  'open the flood gates',
	  'opportunity doesn\'t knock twice',
	  'out of pocket',
	  'out of sight, out of mind',
	  'out of the frying pan into the fire',
	  'out of the woods',
	  'out on a limb',
	  'over a barrel',
	  'over the hump',
	  'pain and suffering',
	  'pain in the',
	  'panic button',
	  'par for the course',
	  'part and parcel',
	  'party pooper',
	  'pass the buck',
	  'patience is a virtue',
	  'pay through the nose',
	  'penny pincher',
	  'perfect storm',
	  'pig in a poke',
	  'pile it on',
	  'pillar of the community',
	  'pin your hopes on',
	  'pitter patter of little feet',
	  'plain as day',
	  'plain as the nose on your face',
	  'play by the rules',
	  'play your cards right',
	  'playing the field',
	  'playing with fire',
	  'pleased as punch',
	  'plenty of fish in the sea',
	  'point with pride',
	  'poor as a church mouse',
	  'pot calling the kettle black',
	  'pretty as a picture',
	  'pull a fast one',
	  'pull your punches',
	  'pulling your leg',
	  'pure as the driven snow',
	  'put it in a nutshell',
	  'put one over on you',
	  'put the cart before the horse',
	  'put the pedal to the metal',
	  'put your best foot forward',
	  'put your foot down',
	  'quick as a bunny',
	  'quick as a lick',
	  'quick as a wink',
	  'quick as lightning',
	  'quiet as a dormouse',
	  'rags to riches',
	  'raining buckets',
	  'raining cats and dogs',
	  'rank and file',
	  'rat race',
	  'reap what you sow',
	  'red as a beet',
	  'red herring',
	  'reinvent the wheel',
	  'rich and famous',
	  'rings a bell',
	  'ripe old age',
	  'ripped me off',
	  'rise and shine',
	  'road to hell is paved with good intentions',
	  'rob Peter to pay Paul',
	  'roll over in the grave',
	  'rub the wrong way',
	  'ruled the roost',
	  'running in circles',
	  'sad but true',
	  'sadder but wiser',
	  'salt of the earth',
	  'scared stiff',
	  'scared to death',
	  'sealed with a kiss',
	  'second to none',
	  'see eye to eye',
	  'seen the light',
	  'seize the day',
	  'set the record straight',
	  'set the world on fire',
	  'set your teeth on edge',
	  'sharp as a tack',
	  'shoot for the moon',
	  'shoot the breeze',
	  'shot in the dark',
	  'shoulder to the wheel',
	  'sick as a dog',
	  'sigh of relief',
	  'signed, sealed, and delivered',
	  'sink or swim',
	  'six of one, half a dozen of another',
	  'skating on thin ice',
	  'slept like a log',
	  'slinging mud',
	  'slippery as an eel',
	  'slow as molasses',
	  'smart as a whip',
	  'smooth as a baby\'s bottom',
	  'sneaking suspicion',
	  'snug as a bug in a rug',
	  'sow wild oats',
	  'spare the rod, spoil the child',
	  'speak of the devil',
	  'spilled the beans',
	  'spinning your wheels',
	  'spitting image of',
	  'spoke with relish',
	  'spread like wildfire',
	  'spring to life',
	  'squeaky wheel gets the grease',
	  'stands out like a sore thumb',
	  'start from scratch',
	  'stick in the mud',
	  'still waters run deep',
	  'stitch in time',
	  'stop and smell the roses',
	  'straight as an arrow',
	  'straw that broke the camel\'s back',
	  'strong as an ox',
	  'stubborn as a mule',
	  'stuff that dreams are made of',
	  'stuffed shirt',
	  'sweating blood',
	  'sweating bullets',
	  'take a load off',
	  'take one for the team',
	  'take the bait',
	  'take the bull by the horns',
	  'take the plunge',
	  'takes one to know one',
	  'takes two to tango',
	  'the more the merrier',
	  'the real deal',
	  'the real McCoy',
	  'the red carpet treatment',
	  'the same old story',
	  'there is no accounting for taste',
	  'thick as a brick',
	  'thick as thieves',
	  'thin as a rail',
	  'think outside of the box',
	  'third time\'s the charm',
	  'this day and age',
	  'this hurts me worse than it hurts you',
	  'this point in time',
	  'three sheets to the wind',
	  'through thick and thin',
	  'throw in the towel',
	  'tie one on',
	  'tighter than a drum',
	  'time and time again',
	  'time is of the essence',
	  'tip of the iceberg',
	  'tired but happy',
	  'to coin a phrase',
	  'to each his own',
	  'to make a long story short',
	  'to the best of my knowledge',
	  'toe the line',
	  'tongue in cheek',
	  'too good to be true',
	  'too hot to handle',
	  'too numerous to mention',
	  'touch with a ten foot pole',
	  'tough as nails',
	  'trial and error',
	  'trials and tribulations',
	  'tried and true',
	  'trip down memory lane',
	  'twist of fate',
	  'two cents worth',
	  'two peas in a pod',
	  'ugly as sin',
	  'under the counter',
	  'under the gun',
	  'under the same roof',
	  'under the weather',
	  'until the cows come home',
	  'unvarnished truth',
	  'up the creek',
	  'uphill battle',
	  'upper crust',
	  'upset the applecart',
	  'vain attempt',
	  'vain effort',
	  'vanquish the enemy',
	  'vested interest',
	  'waiting for the other shoe to drop',
	  'wakeup call',
	  'warm welcome',
	  'watch your p\'s and q\'s',
	  'watch your tongue',
	  'watching the clock',
	  'water under the bridge',
	  'weather the storm',
	  'weed them out',
	  'week of Sundays',
	  'went belly up',
	  'wet behind the ears',
	  'what goes around comes around',
	  'what you see is what you get',
	  'when it rains, it pours',
	  'when push comes to shove',
	  'when the cat\'s away',
	  'when the going gets tough, the tough get going',
	  'white as a sheet',
	  'whole ball of wax',
	  'whole hog',
	  'whole nine yards',
	  'wild goose chase',
	  'will wonders never cease?',
	  'wisdom of the ages',
	  'wise as an owl',
	  'wolf at the door',
	  'words fail me',
	  'work like a dog',
	  'world weary',
	  'worst nightmare',
	  'worth its weight in gold',
	  'wrong side of the bed',
	  'yanking your chain',
	  'yappy as a dog',
	  'years young',
	  'you are what you eat',
	  'you can run but you can\'t hide',
	  'you only live once',
	  'you\'re the boss ',
	  'young and foolish',
	  'young and vibrant',
	];
	
	var clicheRegex = new RegExp('\\b(' + cliches.join('|') + ')\\b', 'gi');
	var matcher = __webpack_require__(2461);
	
	module.exports = function (text) {
	  return matcher(clicheRegex, text, "clichés");
	};


/***/ },
/* 2461 */
1424,
/* 2462 */
/***/ function(module, exports) {

	(function(root) {
	  var isOn = false;
	  var scrollbarSize;
	  var scrollTop;
	
	  function getScrollbarSize() {
	    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
	
	    var doc = document.documentElement;
	    var dummyScroller = document.createElement('div');
	    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
	    doc.appendChild(dummyScroller);
	    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
	    doc.removeChild(dummyScroller);
	    return scrollbarSize;
	  }
	
	  function hasScrollbar() {
	    return document.documentElement.scrollHeight > window.innerHeight;
	  }
	
	  function on(options) {
	    if (typeof document === 'undefined' || isOn) return;
	    var doc = document.documentElement;
	    scrollTop = window.pageYOffset;
	    if (hasScrollbar()) {
	      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
	    } else {
	      doc.style.width = '100%';
	    }
	    doc.style.position = 'fixed';
	    doc.style.top = -scrollTop + 'px';
	    doc.style.overflow = 'hidden';
	    isOn = true;
	  }
	
	  function off() {
	    if (typeof document === 'undefined' || !isOn) return;
	    var doc = document.documentElement;
	    doc.style.width = '';
	    doc.style.position = '';
	    doc.style.top = '';
	    doc.style.overflow = '';
	    window.scroll(0, scrollTop);
	    isOn = false;
	  }
	
	  function toggle() {
	    if (isOn) {
	      off();
	      return;
	    }
	    on();
	  }
	
	  var noScroll = {
	    on: on,
	    off: off,
	    toggle: toggle,
	  };
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = noScroll;
	  } else {
	    root.noScroll = noScroll;
	  }
	})(this);


/***/ },
/* 2463 */
/***/ function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ },
/* 2464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(467);
	
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; }
		if (keys(obj).length !== 0) { return false; }
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(224);
	var getPolyfill = __webpack_require__(1135);
	
	module.exports = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};


/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(1138);
	var define = __webpack_require__(224);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = __webpack_require__(130).assign;
	
	var deflate   = __webpack_require__(2468);
	var inflate   = __webpack_require__(2469);
	var constants = __webpack_require__(1141);
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;


/***/ },
/* 2468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_deflate = __webpack_require__(2470);
	var utils        = __webpack_require__(130);
	var strings      = __webpack_require__(1139);
	var msg          = __webpack_require__(468);
	var ZStream      = __webpack_require__(1143);
	
	var toString = Object.prototype.toString;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_SYNC_FLUSH    = 2;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
	 * push a chunk with explicit flush (call [[Deflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	function Deflate(options) {
	  if (!(this instanceof Deflate)) return new Deflate(options);
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	
	  if (opt.dictionary) {
	    var dict;
	    // Convert data if needed
	    if (typeof opt.dictionary === 'string') {
	      // If we need to compress text, change encoding to utf8.
	      dict = strings.string2buf(opt.dictionary);
	    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
	      dict = new Uint8Array(opt.dictionary);
	    } else {
	      dict = opt.dictionary;
	    }
	
	    status = zlib_deflate.deflateSetDictionary(this.strm, dict);
	
	    if (status !== Z_OK) {
	      throw new Error(msg[status]);
	    }
	
	    this._dict_set = true;
	  }
	}
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
	 *   converted to utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the compression context.
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === Z_SYNC_FLUSH) {
	    this.onEnd(Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate algorithm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 * - dictionary
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;


/***/ },
/* 2469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var zlib_inflate = __webpack_require__(2473);
	var utils        = __webpack_require__(130);
	var strings      = __webpack_require__(1139);
	var c            = __webpack_require__(1141);
	var msg          = __webpack_require__(468);
	var ZStream      = __webpack_require__(1143);
	var GZheader     = __webpack_require__(2471);
	
	var toString = Object.prototype.toString;
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
	 * push a chunk with explicit flush (call [[Inflate#push]] with
	 * `Z_SYNC_FLUSH` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 * - `dictionary`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	function Inflate(options) {
	  if (!(this instanceof Inflate)) return new Inflate(options);
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new ZStream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new GZheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	}
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|ArrayBuffer|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
	 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
	 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function (data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var dictionary = this.options.dictionary;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	  var dict;
	
	  // Flag to properly process Z_BUF_ERROR on testing inflate call
	  // when we check that all output data was flushed.
	  var allowBufError = false;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else if (toString.call(data) === '[object ArrayBuffer]') {
	    strm.input = new Uint8Array(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status === c.Z_NEED_DICT && dictionary) {
	      // Convert data if needed
	      if (typeof dictionary === 'string') {
	        dict = strings.string2buf(dictionary);
	      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
	        dict = new Uint8Array(dictionary);
	      } else {
	        dict = dictionary;
	      }
	
	      status = zlib_inflate.inflateSetDictionary(this.strm, dict);
	
	    }
	
	    if (status === c.Z_BUF_ERROR && allowBufError === true) {
	      status = c.Z_OK;
	      allowBufError = false;
	    }
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	
	    // When no more input data, we should check that internal inflate buffers
	    // are flushed. The only way to do it when avail_out = 0 - run one more
	    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
	    // Here we set flag to process this error properly.
	    //
	    // NOTE. Deflate does not return error in this case and does not needs such
	    // logic.
	    if (strm.avail_in === 0 && strm.avail_out === 0) {
	      allowBufError = true;
	    }
	
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  // callback interim results if Z_SYNC_FLUSH.
	  if (_mode === c.Z_SYNC_FLUSH) {
	    this.onEnd(c.Z_OK);
	    strm.avail_out = 0;
	    return true;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function (chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called either after you tell inflate that the input stream is
	 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
	 * or if an error happened. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function (status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;


/***/ },
/* 2470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils   = __webpack_require__(130);
	var trees   = __webpack_require__(2475);
	var adler32 = __webpack_require__(1140);
	var crc32   = __webpack_require__(1142);
	var msg     = __webpack_require__(468);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only(s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  // zmemcpy(buf, strm->next_in, len);
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH - 1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH - 1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length - 1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH - 1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	function Config(good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	}
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
	  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	
	  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
	  //s->pending_buf = (uchf *) overlay;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
	  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
	  s.d_buf = 1 * s.lit_bufsize;
	
	  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	
	/* =========================================================================
	 * Initializes the compression dictionary from the given byte
	 * sequence without producing any compressed output.
	 */
	function deflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var s;
	  var str, n;
	  var wrap;
	  var avail;
	  var next;
	  var input;
	  var tmpDict;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	  wrap = s.wrap;
	
	  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
	  if (wrap === 1) {
	    /* adler32(strm->adler, dictionary, dictLength); */
	    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
	  }
	
	  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */
	
	  /* if dictionary would fill window, just replace the history */
	  if (dictLength >= s.w_size) {
	    if (wrap === 0) {            /* already empty otherwise */
	      /*** CLEAR_HASH(s); ***/
	      zero(s.head); // Fill with NIL (= 0);
	      s.strstart = 0;
	      s.block_start = 0;
	      s.insert = 0;
	    }
	    /* use the tail */
	    // dictionary = dictionary.slice(dictLength - s.w_size);
	    tmpDict = new utils.Buf8(s.w_size);
	    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
	    dictionary = tmpDict;
	    dictLength = s.w_size;
	  }
	  /* insert dictionary into window and hash */
	  avail = strm.avail_in;
	  next = strm.next_in;
	  input = strm.input;
	  strm.avail_in = dictLength;
	  strm.next_in = 0;
	  strm.input = dictionary;
	  fill_window(s);
	  while (s.lookahead >= MIN_MATCH) {
	    str = s.strstart;
	    n = s.lookahead - (MIN_MATCH - 1);
	    do {
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
	
	      s.prev[str & s.w_mask] = s.head[s.ins_h];
	
	      s.head[s.ins_h] = str;
	      str++;
	    } while (--n);
	    s.strstart = str;
	    s.lookahead = MIN_MATCH - 1;
	    fill_window(s);
	  }
	  s.strstart += s.lookahead;
	  s.block_start = s.strstart;
	  s.insert = s.lookahead;
	  s.lookahead = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  strm.next_in = next;
	  strm.input = input;
	  strm.avail_in = avail;
	  s.wrap = wrap;
	  return Z_OK;
	}
	
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/


/***/ },
/* 2471 */
/***/ function(module, exports) {

	'use strict';
	
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;


/***/ },
/* 2472 */
/***/ function(module, exports) {

	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
	  var s_window;               /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  s_window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = s_window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = s_window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = s_window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};


/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils         = __webpack_require__(130);
	var adler32       = __webpack_require__(1140);
	var crc32         = __webpack_require__(1142);
	var inflate_fast  = __webpack_require__(2472);
	var inflate_table = __webpack_require__(2474);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function zswap32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window, src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = zswap32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = { bits: state.lenbits };
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = { bits: state.distbits };
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
	        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	function inflateSetDictionary(strm, dictionary) {
	  var dictLength = dictionary.length;
	
	  var state;
	  var dictid;
	  var ret;
	
	  /* check state */
	  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  if (state.wrap !== 0 && state.mode !== DICT) {
	    return Z_STREAM_ERROR;
	  }
	
	  /* check for correct dictionary identifier */
	  if (state.mode === DICT) {
	    dictid = 1; /* adler32(0, null, 0)*/
	    /* dictid = adler32(dictid, dictionary, dictLength); */
	    dictid = adler32(dictid, dictionary, dictLength, 0);
	    if (dictid !== state.check) {
	      return Z_DATA_ERROR;
	    }
	  }
	  /* copy dictionary to window using updatewindow(), which will amend the
	   existing dictionary if appropriate */
	  ret = updatewindow(strm, dictionary, dictLength, dictLength);
	  if (ret) {
	    state.mode = MEM;
	    return Z_MEM_ERROR;
	  }
	  state.havedict = 1;
	  // Tracev((stderr, "inflate:   dictionary set\n"));
	  return Z_OK;
	}
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/


/***/ },
/* 2474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(130);
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	    base = extra = work;    /* dummy value--not used */
	    end = 19;
	
	  } else if (type === LENS) {
	    base = lbase;
	    base_index -= 257;
	    extra = lext;
	    extra_index -= 257;
	    end = 256;
	
	  } else {                    /* DISTS */
	    base = dbase;
	    extra = dext;
	    end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i = 0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};


/***/ },
/* 2475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	
	var utils = __webpack_require__(130);
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2 * L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	/* eslint-disable comma-spacing,array-bracket-spacing */
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* eslint-enable comma-spacing,array-bracket-spacing */
	
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES + 2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	}
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	function TreeDesc(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	}
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short(s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n * 2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n - base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length - 1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
	        tree[m * 2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n * 2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS + 1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES - 1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1 << extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length - 1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1 << extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for (; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n * 2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES + 1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n * 2 + 1]/*.Len*/ = 5;
	    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n * 2;
	  var _m2 = m * 2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n * 2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node * 2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count - 3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count - 3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count - 11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes - 1,   5);
	  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES << 1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
	    static_lenb = (s.static_len + 3 + 7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc * 2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize - 1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;


/***/ },
/* 2476 */
/***/ function(module, exports) {

	var irregulars = [
	  'awoken',
	  'been',
	  'born',
	  'beat',
	  'become',
	  'begun',
	  'bent',
	  'beset',
	  'bet',
	  'bid',
	  'bidden',
	  'bound',
	  'bitten',
	  'bled',
	  'blown',
	  'broken',
	  'bred',
	  'brought',
	  'broadcast',
	  'built',
	  'burnt',
	  'burst',
	  'bought',
	  'cast',
	  'caught',
	  'chosen',
	  'clung',
	  'come',
	  'cost',
	  'crept',
	  'cut',
	  'dealt',
	  'dug',
	  'dived',
	  'done',
	  'drawn',
	  'dreamt',
	  'driven',
	  'drunk',
	  'eaten',
	  'fallen',
	  'fed',
	  'felt',
	  'fought',
	  'found',
	  'fit',
	  'fled',
	  'flung',
	  'flown',
	  'forbidden',
	  'forgotten',
	  'foregone',
	  'forgiven',
	  'forsaken',
	  'frozen',
	  'gotten',
	  'given',
	  'gone',
	  'ground',
	  'grown',
	  'hung',
	  'heard',
	  'hidden',
	  'hit',
	  'held',
	  'hurt',
	  'kept',
	  'knelt',
	  'knit',
	  'known',
	  'laid',
	  'led',
	  'leapt',
	  'learnt',
	  'left',
	  'lent',
	  'let',
	  'lain',
	  'lighted',
	  'lost',
	  'made',
	  'meant',
	  'met',
	  'misspelt',
	  'mistaken',
	  'mown',
	  'overcome',
	  'overdone',
	  'overtaken',
	  'overthrown',
	  'paid',
	  'pled',
	  'proven',
	  'put',
	  'quit',
	  'read',
	  'rid',
	  'ridden',
	  'rung',
	  'risen',
	  'run',
	  'sawn',
	  'said',
	  'seen',
	  'sought',
	  'sold',
	  'sent',
	  'set',
	  'sewn',
	  'shaken',
	  'shaven',
	  'shorn',
	  'shed',
	  'shone',
	  'shod',
	  'shot',
	  'shown',
	  'shrunk',
	  'shut',
	  'sung',
	  'sunk',
	  'sat',
	  'slept',
	  'slain',
	  'slid',
	  'slung',
	  'slit',
	  'smitten',
	  'sown',
	  'spoken',
	  'sped',
	  'spent',
	  'spilt',
	  'spun',
	  'spit',
	  'split',
	  'spread',
	  'sprung',
	  'stood',
	  'stolen',
	  'stuck',
	  'stung',
	  'stunk',
	  'stridden',
	  'struck',
	  'strung',
	  'striven',
	  'sworn',
	  'swept',
	  'swollen',
	  'swum',
	  'swung',
	  'taken',
	  'taught',
	  'torn',
	  'told',
	  'thought',
	  'thrived',
	  'thrown',
	  'thrust',
	  'trodden',
	  'understood',
	  'upheld',
	  'upset',
	  'woken',
	  'worn',
	  'woven',
	  'wed',
	  'wept',
	  'wound',
	  'won',
	  'withheld',
	  'withstood',
	  'wrung',
	  'written'
	];
	
	var exceptions = [
	  'indeed',
	];
	
	var re = new RegExp('\\b(am|are|were|being|is|been|was|be)\\b\\s*([\\w]+ed|' + irregulars.join('|') + ')\\b', 'gi');
	var byRe; // lazly construct
	
	module.exports = function (text, options) {
	  var r = (options && options.by) ?
	          (byRe || constructByRe()) : re; // not sorry
	
	  var suggestions = [];
	  while (match = r.exec(text)) {
	    if (exceptions.indexOf(match[2].toLowerCase()) === -1) {
	      suggestions.push({
	        index: match.index,
	        offset: match[0].length
	      });
	    }
	  }
	  return suggestions;
	}
	
	// lol
	function constructByRe () {
	  return byRe = new RegExp(re.toString().slice(1, -3) + '\\s*by\\b', 'gi');
	}


/***/ },
/* 2477 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function(crypto) {
	  function pbkdf2(password, salt, iterations, keylen, digest, callback) {
	    if ('function' === typeof digest) {
	      callback = digest
	      digest = undefined
	    }
	
	    if ('function' !== typeof callback)
	      throw new Error('No callback provided to pbkdf2')
	
	    setTimeout(function() {
	      var result
	
	      try {
	        result = pbkdf2Sync(password, salt, iterations, keylen, digest)
	      } catch (e) {
	        return callback(e)
	      }
	
	      callback(undefined, result)
	    })
	  }
	
	  function pbkdf2Sync(password, salt, iterations, keylen, digest) {
	    if ('number' !== typeof iterations)
	      throw new TypeError('Iterations not a number')
	
	    if (iterations < 0)
	      throw new TypeError('Bad iterations')
	
	    if ('number' !== typeof keylen)
	      throw new TypeError('Key length not a number')
	
	    if (keylen < 0)
	      throw new TypeError('Bad key length')
	
	    digest = digest || 'sha1'
	
	    if (!Buffer.isBuffer(password)) password = new Buffer(password)
	    if (!Buffer.isBuffer(salt)) salt = new Buffer(salt)
	
	    var hLen, l = 1, r, T
	    var DK = new Buffer(keylen)
	    var block1 = new Buffer(salt.length + 4)
	    salt.copy(block1, 0, 0, salt.length)
	
	    for (var i = 1; i <= l; i++) {
	      block1.writeUInt32BE(i, salt.length)
	
	      var U = crypto.createHmac(digest, password).update(block1).digest()
	
	      if (!hLen) {
	        hLen = U.length
	        T = new Buffer(hLen)
	        l = Math.ceil(keylen / hLen)
	        r = keylen - (l - 1) * hLen
	
	        if (keylen > (Math.pow(2, 32) - 1) * hLen)
	          throw new TypeError('keylen exceeds maximum length')
	      }
	
	      U.copy(T, 0, 0, hLen)
	
	      for (var j = 1; j < iterations; j++) {
	        U = crypto.createHmac(digest, password).update(U).digest()
	
	        for (var k = 0; k < hLen; k++) {
	          T[k] ^= U[k]
	        }
	      }
	
	      var destPos = (i - 1) * hLen
	      var len = (i == l ? r : hLen)
	      T.copy(DK, destPos, 0, len)
	    }
	
	    return DK
	  }
	
	  return {
	    pbkdf2: pbkdf2,
	    pbkdf2Sync: pbkdf2Sync
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 2478 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ },
/* 2479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}
	
	/* eslint-disable no-underscore-dangle */
	function _resetWarned() {
	  warned = {};
	}
	
	deprecated._resetWarned = _resetWarned;
	/* eslint-enable no-underscore-dangle */
	
	module.exports = exports['default'];

/***/ },
/* 2480 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 2481 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(2483);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 2482 */
[3545, 1144],
/* 2483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(67);
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(301);
	var assign = __webpack_require__(25);
	
	var ReactPropTypesSecret = __webpack_require__(1144);
	var checkPropTypes = __webpack_require__(2480);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1146);
	
	var has = Object.prototype.hasOwnProperty;
	
	var defaults = {
	    allowDots: false,
	    allowPrototypes: false,
	    arrayLimit: 20,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    parameterLimit: 1000,
	    plainObjects: false,
	    strictNullHandling: false
	};
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = {};
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
	    var parts = cleanStr.split(options.delimiter, limit);
	
	    for (var i = 0; i < parts.length; ++i) {
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        var key, val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder);
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder);
	            val = options.decoder(part.slice(pos + 1), defaults.decoder);
	        }
	        if (has.call(obj, key)) {
	            obj[key] = [].concat(obj[key]).concat(val);
	        } else {
	            obj[key] = val;
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options) {
	    var leaf = val;
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]') {
	            obj = [];
	            obj = obj.concat(leaf);
	        } else {
	            obj = options.plainObjects ? Object.create(null) : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var index = parseInt(cleanRoot, 10);
	            if (
	                !isNaN(index)
	                && root !== cleanRoot
	                && String(index) === cleanRoot
	                && index >= 0
	                && (options.parseArrays && index <= options.arrayLimit)
	            ) {
	                obj = [];
	                obj[index] = leaf;
	            } else {
	                obj[cleanRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
	    if (!givenKey) {
	        return;
	    }
	
	    // Transform dot notation to bracket notation
	    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
	
	    // The regex chunks
	
	    var brackets = /(\[[^[\]]*])/;
	    var child = /(\[[^[\]]*])/g;
	
	    // Get the parent
	
	    var segment = brackets.exec(key);
	    var parent = segment ? key.slice(0, segment.index) : key;
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (parent) {
	        // If we aren't using plain objects, optionally prefix keys
	        // that would overwrite object prototype properties
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        keys.push(parent);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	        i += 1;
	        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	        keys.push(segment[1]);
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return parseObject(keys, val, options);
	};
	
	module.exports = function (str, opts) {
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
	    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
	    options.parseArrays = options.parseArrays !== false;
	    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
	    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : defaults.allowDots;
	    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
	    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
	    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? Object.create(null) : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
	    var obj = options.plainObjects ? Object.create(null) : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options);
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    return utils.compact(obj);
	};


/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(1146);
	var formats = __webpack_require__(1145);
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
	        return prefix + '[]';
	    },
	    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
	        return prefix;
	    }
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaults = {
	    delimiter: '&',
	    encode: true,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var stringify = function stringify( // eslint-disable-line func-name-matching
	    object,
	    prefix,
	    generateArrayPrefix,
	    strictNullHandling,
	    skipNulls,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    formatter,
	    encodeValuesOnly
	) {
	    var obj = object;
	    if (typeof filter === 'function') {
	        obj = filter(prefix, obj);
	    } else if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (obj === null) {
	        if (strictNullHandling) {
	            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder) : prefix;
	        }
	
	        obj = '';
	    }
	
	    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (Array.isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        if (Array.isArray(obj)) {
	            values = values.concat(stringify(
	                obj[key],
	                generateArrayPrefix(prefix, key),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        } else {
	            values = values.concat(stringify(
	                obj[key],
	                prefix + (allowDots ? '.' + key : '[' + key + ']'),
	                generateArrayPrefix,
	                strictNullHandling,
	                skipNulls,
	                encoder,
	                filter,
	                sort,
	                allowDots,
	                serializeDate,
	                formatter,
	                encodeValuesOnly
	            ));
	        }
	    }
	
	    return values;
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = opts ? utils.assign({}, opts) : {};
	
	    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
	    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
	    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
	    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
	    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
	    var sort = typeof options.sort === 'function' ? options.sort : null;
	    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
	    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
	    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
	    if (typeof options.format === 'undefined') {
	        options.format = formats['default'];
	    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
	        throw new TypeError('Unknown format option provided.');
	    }
	    var formatter = formats.formatters[options.format];
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (Array.isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    } else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (sort) {
	        objKeys.sort(sort);
	    }
	
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (skipNulls && obj[key] === null) {
	            continue;
	        }
	
	        keys = keys.concat(stringify(
	            obj[key],
	            key,
	            generateArrayPrefix,
	            strictNullHandling,
	            skipNulls,
	            encode ? encoder : null,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            formatter,
	            encodeValuesOnly
	        ));
	    }
	
	    var joined = keys.join(delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(1889);
	
	var _domAlign2 = _interopRequireDefault(_domAlign);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _isWindow = __webpack_require__(2488);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.forceAlign = function () {
	      var props = _this.props;
	      if (!props.disabled) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	        props.onAlign(source, (0, _domAlign2['default'])(source, props.target(), props.align));
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Align.prototype.componentDidMount = function componentDidMount() {
	    var props = this.props;
	    // if parent ref not attached .... use document.getElementById
	    this.forceAlign();
	    if (!props.disabled && props.monitorWindowResize) {
	      this.startMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var reAlign = false;
	    var props = this.props;
	
	    if (!props.disabled) {
	      if (prevProps.disabled || prevProps.align !== props.align) {
	        reAlign = true;
	      } else {
	        var lastTarget = prevProps.target();
	        var currentTarget = props.target();
	        if ((0, _isWindow2['default'])(lastTarget) && (0, _isWindow2['default'])(currentTarget)) {
	          reAlign = false;
	        } else if (lastTarget !== currentTarget) {
	          reAlign = true;
	        }
	      }
	    }
	
	    if (reAlign) {
	      this.forceAlign();
	    }
	
	    if (props.monitorWindowResize && !props.disabled) {
	      this.startMonitorWindowResize();
	    } else {
	      this.stopMonitorWindowResize();
	    }
	  };
	
	  Align.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stopMonitorWindowResize();
	  };
	
	  Align.prototype.startMonitorWindowResize = function startMonitorWindowResize() {
	    if (!this.resizeHandler) {
	      this.bufferMonitor = buffer(this.forceAlign, this.props.monitorBufferTime);
	      this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	    }
	  };
	
	  Align.prototype.stopMonitorWindowResize = function stopMonitorWindowResize() {
	    if (this.resizeHandler) {
	      this.bufferMonitor.clear();
	      this.resizeHandler.remove();
	      this.resizeHandler = null;
	    }
	  };
	
	  Align.prototype.render = function render() {
	    var _props = this.props,
	        childrenProps = _props.childrenProps,
	        children = _props.children;
	
	    var child = _react2['default'].Children.only(children);
	    if (childrenProps) {
	      var newProps = {};
	      for (var prop in childrenProps) {
	        if (childrenProps.hasOwnProperty(prop)) {
	          newProps[prop] = this.props[childrenProps[prop]];
	        }
	      }
	      return _react2['default'].cloneElement(child, newProps);
	    }
	    return child;
	  };
	
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  onAlign: function onAlign() {},
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ },
/* 2487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Align = __webpack_require__(2486);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 2488 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isWindow;
	function isWindow(obj) {
	  /* eslint no-eq-null: 0 */
	  /* eslint eqeqeq: 0 */
	  return obj != null && obj == obj.window;
	}
	module.exports = exports['default'];

/***/ },
/* 2489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(419);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _util = __webpack_require__(1147);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_util2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_util2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_util2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 2490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && nextChildrenPending.hasOwnProperty(child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 2491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _DateTable = __webpack_require__(471);
	
	var _DateTable2 = _interopRequireDefault(_DateTable);
	
	var _CalendarHeader = __webpack_require__(470);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _CalendarFooter = __webpack_require__(1149);
	
	var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);
	
	var _CalendarMixin = __webpack_require__(472);
	
	var _CalendarMixin2 = _interopRequireDefault(_CalendarMixin);
	
	var _CommonMixin = __webpack_require__(326);
	
	var _CommonMixin2 = _interopRequireDefault(_CommonMixin);
	
	var _DateInput = __webpack_require__(1154);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _util = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function goStartMonth() {
	  var next = this.state.value.clone();
	  next.startOf('month');
	  this.setValue(next);
	}
	
	function goEndMonth() {
	  var next = this.state.value.clone();
	  next.endOf('month');
	  this.setValue(next);
	}
	
	function goTime(direction, unit) {
	  var next = this.state.value.clone();
	  next.add(direction, unit);
	  this.setValue(next);
	}
	
	function goMonth(direction) {
	  return goTime.call(this, direction, 'months');
	}
	
	function goYear(direction) {
	  return goTime.call(this, direction, 'years');
	}
	
	function goWeek(direction) {
	  return goTime.call(this, direction, 'weeks');
	}
	
	function goDay(direction) {
	  return goTime.call(this, direction, 'days');
	}
	
	var Calendar = (0, _createReactClass2['default'])({
	  displayName: 'Calendar',
	
	  propTypes: {
	    prefixCls: _propTypes2['default'].string,
	    className: _propTypes2['default'].string,
	    style: _propTypes2['default'].object,
	    defaultValue: _propTypes2['default'].object,
	    value: _propTypes2['default'].object,
	    selectedValue: _propTypes2['default'].object,
	    mode: _propTypes2['default'].oneOf(['time', 'date', 'month', 'year', 'decade']),
	    locale: _propTypes2['default'].object,
	    showDateInput: _propTypes2['default'].bool,
	    showWeekNumber: _propTypes2['default'].bool,
	    showToday: _propTypes2['default'].bool,
	    showOk: _propTypes2['default'].bool,
	    onSelect: _propTypes2['default'].func,
	    onOk: _propTypes2['default'].func,
	    onKeyDown: _propTypes2['default'].func,
	    timePicker: _propTypes2['default'].element,
	    dateInputPlaceholder: _propTypes2['default'].any,
	    onClear: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    onPanelChange: _propTypes2['default'].func,
	    disabledDate: _propTypes2['default'].func,
	    disabledTime: _propTypes2['default'].any,
	    renderFooter: _propTypes2['default'].func,
	    renderSidebar: _propTypes2['default'].func
	  },
	
	  mixins: [_CommonMixin2['default'], _CalendarMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      showToday: true,
	      showDateInput: true,
	      timePicker: null,
	      onOk: noop,
	      onPanelChange: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      mode: this.props.mode || 'date'
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ('mode' in nextProps && this.state.mode !== nextProps.mode) {
	      this.setState({ mode: nextProps.mode });
	    }
	  },
	  onKeyDown: function onKeyDown(event) {
	    if (event.target.nodeName.toLowerCase() === 'input') {
	      return undefined;
	    }
	    var keyCode = event.keyCode;
	    // mac
	    var ctrlKey = event.ctrlKey || event.metaKey;
	    var disabledDate = this.props.disabledDate;
	    var value = this.state.value;
	
	    switch (keyCode) {
	      case _KeyCode2['default'].DOWN:
	        goWeek.call(this, 1);
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].UP:
	        goWeek.call(this, -1);
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].LEFT:
	        if (ctrlKey) {
	          goYear.call(this, -1);
	        } else {
	          goDay.call(this, -1);
	        }
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].RIGHT:
	        if (ctrlKey) {
	          goYear.call(this, 1);
	        } else {
	          goDay.call(this, 1);
	        }
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].HOME:
	        goStartMonth.call(this);
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].END:
	        goEndMonth.call(this);
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].PAGE_DOWN:
	        goMonth.call(this, 1);
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].PAGE_UP:
	        goMonth.call(this, -1);
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].ENTER:
	        if (!disabledDate || !disabledDate(value)) {
	          this.onSelect(value, {
	            source: 'keyboard'
	          });
	        }
	        event.preventDefault();
	        return 1;
	      default:
	        this.props.onKeyDown(event);
	        return 1;
	    }
	  },
	  onClear: function onClear() {
	    this.onSelect(null);
	    this.props.onClear();
	  },
	  onOk: function onOk() {
	    var selectedValue = this.state.selectedValue;
	
	    if (this.isAllowedDate(selectedValue)) {
	      this.props.onOk(selectedValue);
	    }
	  },
	  onDateInputChange: function onDateInputChange(value) {
	    this.onSelect(value, {
	      source: 'dateInput'
	    });
	  },
	  onDateTableSelect: function onDateTableSelect(value) {
	    var timePicker = this.props.timePicker;
	    var selectedValue = this.state.selectedValue;
	
	    if (!selectedValue && timePicker) {
	      var timePickerDefaultValue = timePicker.props.defaultValue;
	      if (timePickerDefaultValue) {
	        (0, _util.syncTime)(timePickerDefaultValue, value);
	      }
	    }
	    this.onSelect(value);
	  },
	  onToday: function onToday() {
	    var value = this.state.value;
	
	    var now = (0, _util.getTodayTime)(value);
	    this.onSelect(now, {
	      source: 'todayButton'
	    });
	  },
	  onPanelChange: function onPanelChange(value, mode) {
	    var props = this.props,
	        state = this.state;
	
	    if (!('mode' in props)) {
	      this.setState({ mode: mode });
	    }
	    props.onPanelChange(value || state.value, mode);
	  },
	  getRootDOMNode: function getRootDOMNode() {
	    return _reactDom2['default'].findDOMNode(this);
	  },
	  openTimePicker: function openTimePicker() {
	    this.onPanelChange(null, 'time');
	  },
	  closeTimePicker: function closeTimePicker() {
	    this.onPanelChange(null, 'date');
	  },
	  render: function render() {
	    var props = this.props,
	        state = this.state;
	    var locale = props.locale,
	        prefixCls = props.prefixCls,
	        disabledDate = props.disabledDate,
	        dateInputPlaceholder = props.dateInputPlaceholder,
	        timePicker = props.timePicker,
	        disabledTime = props.disabledTime;
	    var value = state.value,
	        selectedValue = state.selectedValue,
	        mode = state.mode;
	
	    var showTimePicker = mode === 'time';
	    var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? (0, _util.getTimeConfig)(selectedValue, disabledTime) : null;
	
	    var timePickerEle = null;
	
	    if (timePicker && showTimePicker) {
	      var timePickerProps = (0, _extends3['default'])({
	        showHour: true,
	        showSecond: true,
	        showMinute: true
	      }, timePicker.props, disabledTimeConfig, {
	        onChange: this.onDateInputChange,
	        value: selectedValue,
	        disabledTime: disabledTime
	      });
	
	      if (timePicker.props.defaultValue !== undefined) {
	        timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
	      }
	
	      timePickerEle = _react2['default'].cloneElement(timePicker, timePickerProps);
	    }
	
	    var dateInputElement = props.showDateInput ? _react2['default'].createElement(_DateInput2['default'], {
	      format: this.getFormat(),
	      key: 'date-input',
	      value: value,
	      locale: locale,
	      placeholder: dateInputPlaceholder,
	      showClear: true,
	      disabledTime: disabledTime,
	      disabledDate: disabledDate,
	      onClear: this.onClear,
	      prefixCls: prefixCls,
	      selectedValue: selectedValue,
	      onChange: this.onDateInputChange
	    }) : null;
	    var children = [props.renderSidebar(), _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-panel', key: 'panel' },
	      dateInputElement,
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-date-panel' },
	        _react2['default'].createElement(_CalendarHeader2['default'], {
	          locale: locale,
	          mode: mode,
	          value: value,
	          onValueChange: this.setValue,
	          onPanelChange: this.onPanelChange,
	          showTimePicker: showTimePicker,
	          prefixCls: prefixCls
	        }),
	        timePicker && showTimePicker ? _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-time-picker' },
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-time-picker-panel' },
	            timePickerEle
	          )
	        ) : null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(_DateTable2['default'], {
	            locale: locale,
	            value: value,
	            selectedValue: selectedValue,
	            prefixCls: prefixCls,
	            dateRender: props.dateRender,
	            onSelect: this.onDateTableSelect,
	            disabledDate: disabledDate,
	            showWeekNumber: props.showWeekNumber
	          })
	        ),
	        _react2['default'].createElement(_CalendarFooter2['default'], {
	          showOk: props.showOk,
	          renderFooter: props.renderFooter,
	          locale: locale,
	          prefixCls: prefixCls,
	          showToday: props.showToday,
	          disabledTime: disabledTime,
	          showTimePicker: showTimePicker,
	          showDateInput: props.showDateInput,
	          timePicker: timePicker,
	          selectedValue: selectedValue,
	          value: value,
	          disabledDate: disabledDate,
	          okDisabled: !this.isAllowedDate(selectedValue),
	          onOk: this.onOk,
	          onSelect: this.onSelect,
	          onToday: this.onToday,
	          onOpenTimePicker: this.openTimePicker,
	          onCloseTimePicker: this.closeTimePicker
	        })
	      )
	    )];
	
	    return this.renderRoot({
	      children: children,
	      className: props.showWeekNumber ? prefixCls + '-week-number' : ''
	    });
	  }
	});
	
	exports['default'] = Calendar;
	module.exports = exports['default'];

/***/ },
/* 2492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DateTable = __webpack_require__(471);
	
	var _DateTable2 = _interopRequireDefault(_DateTable);
	
	var _MonthTable = __webpack_require__(1157);
	
	var _MonthTable2 = _interopRequireDefault(_MonthTable);
	
	var _CalendarMixin = __webpack_require__(472);
	
	var _CalendarMixin2 = _interopRequireDefault(_CalendarMixin);
	
	var _CommonMixin = __webpack_require__(326);
	
	var _CommonMixin2 = _interopRequireDefault(_CommonMixin);
	
	var _CalendarHeader = __webpack_require__(2497);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FullCalendar = (0, _createReactClass2['default'])({
	  displayName: 'FullCalendar',
	
	  propTypes: {
	    defaultType: _propTypes2['default'].string,
	    type: _propTypes2['default'].string,
	    prefixCls: _propTypes2['default'].string,
	    locale: _propTypes2['default'].object,
	    onTypeChange: _propTypes2['default'].func,
	    fullscreen: _propTypes2['default'].bool,
	    monthCellRender: _propTypes2['default'].func,
	    dateCellRender: _propTypes2['default'].func,
	    showTypeSwitch: _propTypes2['default'].bool,
	    Select: _propTypes2['default'].func.isRequired,
	    headerComponents: _propTypes2['default'].array,
	    headerComponent: _propTypes2['default'].object, // The whole header component
	    headerRender: _propTypes2['default'].func,
	    showHeader: _propTypes2['default'].bool,
	    disabledDate: _propTypes2['default'].func
	  },
	  mixins: [_CommonMixin2['default'], _CalendarMixin2['default']],
	  getDefaultProps: function getDefaultProps() {
	    return {
	      defaultType: 'date',
	      fullscreen: false,
	      showTypeSwitch: true,
	      showHeader: true,
	      onTypeChange: function onTypeChange() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    var type = void 0;
	    if ('type' in this.props) {
	      type = this.props.type;
	    } else {
	      type = this.props.defaultType;
	    }
	    return {
	      type: type
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ('type' in nextProps) {
	      this.setState({
	        type: nextProps.type
	      });
	    }
	  },
	  onMonthSelect: function onMonthSelect(value) {
	    this.onSelect(value, {
	      target: 'month'
	    });
	  },
	  setType: function setType(type) {
	    if (!('type' in this.props)) {
	      this.setState({
	        type: type
	      });
	    }
	    this.props.onTypeChange(type);
	  },
	  render: function render() {
	    var props = this.props;
	    var locale = props.locale,
	        prefixCls = props.prefixCls,
	        fullscreen = props.fullscreen,
	        showHeader = props.showHeader,
	        headerComponent = props.headerComponent,
	        headerRender = props.headerRender,
	        disabledDate = props.disabledDate;
	    var _state = this.state,
	        value = _state.value,
	        type = _state.type;
	
	
	    var header = null;
	    if (showHeader) {
	      if (headerRender) {
	        header = headerRender(value, type, locale);
	      } else {
	        var TheHeader = headerComponent || _CalendarHeader2['default'];
	        header = _react2['default'].createElement(TheHeader, (0, _extends3['default'])({
	          key: 'calendar-header'
	        }, props, {
	          prefixCls: prefixCls + '-full',
	          type: type,
	          value: value,
	          onTypeChange: this.setType,
	          onValueChange: this.setValue
	        }));
	      }
	    }
	
	    var table = type === 'date' ? _react2['default'].createElement(_DateTable2['default'], {
	      dateRender: props.dateCellRender,
	      contentRender: props.dateCellContentRender,
	      locale: locale,
	      prefixCls: prefixCls,
	      onSelect: this.onSelect,
	      value: value,
	      disabledDate: disabledDate
	    }) : _react2['default'].createElement(_MonthTable2['default'], {
	      cellRender: props.monthCellRender,
	      contentRender: props.monthCellContentRender,
	      locale: locale,
	      onSelect: this.onMonthSelect,
	      prefixCls: prefixCls + '-month-panel',
	      value: value,
	      disabledDate: disabledDate
	    });
	
	    var children = [header, _react2['default'].createElement(
	      'div',
	      { key: 'calendar-body', className: prefixCls + '-calendar-body' },
	      table
	    )];
	
	    var className = [prefixCls + '-full'];
	
	    if (fullscreen) {
	      className.push(prefixCls + '-fullscreen');
	    }
	
	    return this.renderRoot({
	      children: children,
	      className: className.join(' ')
	    });
	  }
	});
	
	exports['default'] = FullCalendar;
	module.exports = exports['default'];

/***/ },
/* 2493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _CalendarPart = __webpack_require__(2503);
	
	var _CalendarPart2 = _interopRequireDefault(_CalendarPart);
	
	var _TodayButton = __webpack_require__(1152);
	
	var _TodayButton2 = _interopRequireDefault(_TodayButton);
	
	var _OkButton = __webpack_require__(1150);
	
	var _OkButton2 = _interopRequireDefault(_OkButton);
	
	var _TimePickerButton = __webpack_require__(1151);
	
	var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);
	
	var _CommonMixin = __webpack_require__(326);
	
	var _CommonMixin2 = _interopRequireDefault(_CommonMixin);
	
	var _util = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function isEmptyArray(arr) {
	  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
	    return !i;
	  }));
	}
	
	function isArraysEqual(a, b) {
	  if (a === b) return true;
	  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
	    return false;
	  }
	  if (a.length !== b.length) return false;
	
	  for (var i = 0; i < a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	}
	
	function getValueFromSelectedValue(selectedValue) {
	  var start = selectedValue[0],
	      end = selectedValue[1];
	
	  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
	  return [start, newEnd];
	}
	
	function normalizeAnchor(props, init) {
	  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
	  var value = props.value || init && props.defaultValue;
	  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
	  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
	}
	
	function generateOptions(length, extraOptionGen) {
	  var arr = extraOptionGen ? extraOptionGen() : [];
	  for (var value = 0; value < length; value++) {
	    if (arr.indexOf(value) === -1) {
	      arr.push(value);
	    }
	  }
	  return arr;
	}
	
	function onInputSelect(direction, value) {
	  if (!value) {
	    return;
	  }
	  var originalValue = this.state.selectedValue;
	  var selectedValue = originalValue.concat();
	  var index = direction === 'left' ? 0 : 1;
	  selectedValue[index] = value;
	  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
	    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
	  }
	  this.fireSelectValueChange(selectedValue);
	}
	
	var RangeCalendar = (0, _createReactClass2['default'])({
	  displayName: 'RangeCalendar',
	
	  propTypes: {
	    prefixCls: _propTypes2['default'].string,
	    dateInputPlaceholder: _propTypes2['default'].any,
	    defaultValue: _propTypes2['default'].any,
	    value: _propTypes2['default'].any,
	    hoverValue: _propTypes2['default'].any,
	    mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['date', 'month', 'year', 'decade'])),
	    timePicker: _propTypes2['default'].any,
	    showOk: _propTypes2['default'].bool,
	    showToday: _propTypes2['default'].bool,
	    defaultSelectedValue: _propTypes2['default'].array,
	    selectedValue: _propTypes2['default'].array,
	    onOk: _propTypes2['default'].func,
	    showClear: _propTypes2['default'].bool,
	    locale: _propTypes2['default'].object,
	    onChange: _propTypes2['default'].func,
	    onSelect: _propTypes2['default'].func,
	    onValueChange: _propTypes2['default'].func,
	    onHoverChange: _propTypes2['default'].func,
	    onPanelChange: _propTypes2['default'].func,
	    format: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	    onClear: _propTypes2['default'].func,
	    type: _propTypes2['default'].any,
	    disabledDate: _propTypes2['default'].func,
	    disabledTime: _propTypes2['default'].func
	  },
	
	  mixins: [_CommonMixin2['default']],
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      type: 'both',
	      defaultSelectedValue: [],
	      onValueChange: noop,
	      onHoverChange: noop,
	      onPanelChange: noop,
	      disabledTime: noop,
	      showToday: true
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var selectedValue = props.selectedValue || props.defaultSelectedValue;
	    var value = normalizeAnchor(props, 1);
	    return {
	      selectedValue: selectedValue,
	      prevSelectedValue: selectedValue,
	      firstSelectedValue: null,
	      hoverValue: props.hoverValue || [],
	      value: value,
	      showTimePicker: false,
	      mode: props.mode || ['date', 'date']
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    var state = this.state;
	
	    var newState = {};
	    if ('value' in nextProps) {
	      newState.value = normalizeAnchor(nextProps, 0);
	      this.setState(newState);
	    }
	    if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
	      this.setState({ hoverValue: nextProps.hoverValue });
	    }
	    if ('selectedValue' in nextProps) {
	      newState.selectedValue = nextProps.selectedValue;
	      newState.prevSelectedValue = nextProps.selectedValue;
	      this.setState(newState);
	    }
	    if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
	      this.setState({ mode: nextProps.mode });
	    }
	  },
	  onDatePanelEnter: function onDatePanelEnter() {
	    if (this.hasSelectedValue()) {
	      this.fireHoverValueChange(this.state.selectedValue.concat());
	    }
	  },
	  onDatePanelLeave: function onDatePanelLeave() {
	    if (this.hasSelectedValue()) {
	      this.fireHoverValueChange([]);
	    }
	  },
	  onSelect: function onSelect(value) {
	    var type = this.props.type;
	    var _state = this.state,
	        selectedValue = _state.selectedValue,
	        prevSelectedValue = _state.prevSelectedValue,
	        firstSelectedValue = _state.firstSelectedValue;
	
	    var nextSelectedValue = void 0;
	    if (type === 'both') {
	      if (!firstSelectedValue) {
	        (0, _util.syncTime)(prevSelectedValue[0], value);
	        nextSelectedValue = [value];
	      } else if (this.compare(firstSelectedValue, value) < 0) {
	        (0, _util.syncTime)(prevSelectedValue[1], value);
	        nextSelectedValue = [firstSelectedValue, value];
	      } else {
	        (0, _util.syncTime)(prevSelectedValue[0], value);
	        (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
	        nextSelectedValue = [value, firstSelectedValue];
	      }
	    } else if (type === 'start') {
	      (0, _util.syncTime)(prevSelectedValue[0], value);
	      var endValue = selectedValue[1];
	      nextSelectedValue = endValue && this.compare(endValue, value) > 0 ? [value, endValue] : [value];
	    } else {
	      // type === 'end'
	      var startValue = selectedValue[0];
	      if (startValue && this.compare(startValue, value) <= 0) {
	        (0, _util.syncTime)(prevSelectedValue[1], value);
	        nextSelectedValue = [startValue, value];
	      } else {
	        (0, _util.syncTime)(prevSelectedValue[0], value);
	        nextSelectedValue = [value];
	      }
	    }
	
	    this.fireSelectValueChange(nextSelectedValue);
	  },
	  onDayHover: function onDayHover(value) {
	    var hoverValue = [];
	    var _state2 = this.state,
	        selectedValue = _state2.selectedValue,
	        firstSelectedValue = _state2.firstSelectedValue;
	    var type = this.props.type;
	
	    if (type === 'start' && selectedValue[1]) {
	      hoverValue = this.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
	    } else if (type === 'end' && selectedValue[0]) {
	      hoverValue = this.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
	    } else {
	      if (!firstSelectedValue) {
	        return;
	      }
	      hoverValue = this.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
	    }
	    this.fireHoverValueChange(hoverValue);
	  },
	  onToday: function onToday() {
	    var startValue = (0, _util.getTodayTime)(this.state.value[0]);
	    var endValue = startValue.clone().add(1, 'months');
	    this.setState({ value: [startValue, endValue] });
	  },
	  onOpenTimePicker: function onOpenTimePicker() {
	    this.setState({
	      showTimePicker: true
	    });
	  },
	  onCloseTimePicker: function onCloseTimePicker() {
	    this.setState({
	      showTimePicker: false
	    });
	  },
	  onOk: function onOk() {
	    var selectedValue = this.state.selectedValue;
	
	    if (this.isAllowedDateAndTime(selectedValue)) {
	      this.props.onOk(this.state.selectedValue);
	    }
	  },
	  onStartInputSelect: function onStartInputSelect() {
	    for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
	      oargs[_key] = arguments[_key];
	    }
	
	    var args = ['left'].concat(oargs);
	    return onInputSelect.apply(this, args);
	  },
	  onEndInputSelect: function onEndInputSelect() {
	    for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      oargs[_key2] = arguments[_key2];
	    }
	
	    var args = ['right'].concat(oargs);
	    return onInputSelect.apply(this, args);
	  },
	  onStartValueChange: function onStartValueChange(leftValue) {
	    var value = [].concat(this.state.value);
	    value[0] = leftValue;
	    return this.fireValueChange(value);
	  },
	  onEndValueChange: function onEndValueChange(rightValue) {
	    var value = [].concat(this.state.value);
	    value[1] = rightValue;
	    return this.fireValueChange(value);
	  },
	  onStartPanelChange: function onStartPanelChange(value, mode) {
	    var props = this.props,
	        state = this.state;
	
	    var newMode = [mode, state.mode[1]];
	    if (!('mode' in props)) {
	      this.setState({
	        mode: newMode
	      });
	    }
	    var newValue = [value || state.value[0], state.value[1]];
	    props.onPanelChange(newValue, newMode);
	  },
	  onEndPanelChange: function onEndPanelChange(value, mode) {
	    var props = this.props,
	        state = this.state;
	
	    var newMode = [state.mode[0], mode];
	    if (!('mode' in props)) {
	      this.setState({
	        mode: newMode
	      });
	    }
	    var newValue = [state.value[0], value || state.value[1]];
	    props.onPanelChange(newValue, newMode);
	  },
	  getStartValue: function getStartValue() {
	    var value = this.state.value[0];
	    var selectedValue = this.state.selectedValue;
	    // keep selectedTime when select date
	    if (selectedValue[0] && this.props.timePicker) {
	      value = value.clone();
	      (0, _util.syncTime)(selectedValue[0], value);
	    }
	    if (this.state.showTimePicker && selectedValue[0]) {
	      return selectedValue[0];
	    }
	    return value;
	  },
	  getEndValue: function getEndValue() {
	    var _state3 = this.state,
	        value = _state3.value,
	        selectedValue = _state3.selectedValue,
	        showTimePicker = _state3.showTimePicker;
	
	    var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month');
	    // keep selectedTime when select date
	    if (selectedValue[1] && this.props.timePicker) {
	      (0, _util.syncTime)(selectedValue[1], endValue);
	    }
	    if (showTimePicker) {
	      return selectedValue[1] ? selectedValue[1] : this.getStartValue();
	    }
	    return endValue;
	  },
	
	  // get disabled hours for second picker
	  getEndDisableTime: function getEndDisableTime() {
	    var _state4 = this.state,
	        selectedValue = _state4.selectedValue,
	        value = _state4.value;
	    var disabledTime = this.props.disabledTime;
	
	    var userSettingDisabledTime = disabledTime(null, 'end') || {};
	    var startValue = selectedValue && selectedValue[0] || value[0].clone();
	    // if startTime and endTime is same day..
	    // the second time picker will not able to pick time before first time picker
	    if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
	      var hours = startValue.hour();
	      var minutes = startValue.minute();
	      var second = startValue.second();
	      var _disabledHours = userSettingDisabledTime.disabledHours,
	          _disabledMinutes = userSettingDisabledTime.disabledMinutes,
	          _disabledSeconds = userSettingDisabledTime.disabledSeconds;
	
	      _disabledHours = generateOptions(hours, _disabledHours);
	      _disabledMinutes = generateOptions(minutes, _disabledMinutes);
	      _disabledSeconds = generateOptions(second, _disabledSeconds);
	      return {
	        disabledHours: function disabledHours() {
	          return _disabledHours;
	        },
	        disabledMinutes: function disabledMinutes(hour) {
	          if (hour === hours) {
	            return _disabledMinutes;
	          }
	          return [];
	        },
	        disabledSeconds: function disabledSeconds(hour, minute) {
	          if (hour === hours && minute === minutes) {
	            return _disabledSeconds;
	          }
	          return [];
	        }
	      };
	    }
	    return userSettingDisabledTime;
	  },
	  isAllowedDateAndTime: function isAllowedDateAndTime(selectedValue) {
	    return (0, _util.isAllowedDate)(selectedValue[0], this.props.disabledDate, this.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], this.props.disabledDate, this.disabledEndTime);
	  },
	  isMonthYearPanelShow: function isMonthYearPanelShow(mode) {
	    return ['month', 'year', 'decade'].indexOf(mode) > -1;
	  },
	  hasSelectedValue: function hasSelectedValue() {
	    var selectedValue = this.state.selectedValue;
	
	    return !!selectedValue[1] && !!selectedValue[0];
	  },
	  compare: function compare(v1, v2) {
	    if (this.props.timePicker) {
	      return v1.diff(v2);
	    }
	    return v1.diff(v2, 'days');
	  },
	  fireSelectValueChange: function fireSelectValueChange(selectedValue, direct) {
	    var timePicker = this.props.timePicker;
	    var prevSelectedValue = this.state.prevSelectedValue;
	
	    if (timePicker && timePicker.props.defaultValue) {
	      var timePickerDefaultValue = timePicker.props.defaultValue;
	      if (!prevSelectedValue[0] && selectedValue[0]) {
	        (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
	      }
	      if (!prevSelectedValue[1] && selectedValue[1]) {
	        (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
	      }
	    }
	
	    if (!('selectedValue' in this.props)) {
	      this.setState({
	        selectedValue: selectedValue
	      });
	    }
	
	    // 尚未选择过时间，直接输入的话
	    if (!this.state.selectedValue[0] || !this.state.selectedValue[1]) {
	      var startValue = selectedValue[0] || (0, _moment2['default'])();
	      var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
	      this.setState({
	        selectedValue: selectedValue,
	        value: getValueFromSelectedValue([startValue, endValue])
	      });
	    }
	
	    if (selectedValue[0] && !selectedValue[1]) {
	      this.setState({ firstSelectedValue: selectedValue[0] });
	      this.fireHoverValueChange(selectedValue.concat());
	    }
	    this.props.onChange(selectedValue);
	    if (direct || selectedValue[0] && selectedValue[1]) {
	      this.setState({
	        prevSelectedValue: selectedValue,
	        firstSelectedValue: null
	      });
	      this.fireHoverValueChange([]);
	      this.props.onSelect(selectedValue);
	    }
	  },
	  fireValueChange: function fireValueChange(value) {
	    var props = this.props;
	    if (!('value' in props)) {
	      this.setState({
	        value: value
	      });
	    }
	    props.onValueChange(value);
	  },
	  fireHoverValueChange: function fireHoverValueChange(hoverValue) {
	    var props = this.props;
	    if (!('hoverValue' in props)) {
	      this.setState({ hoverValue: hoverValue });
	    }
	    props.onHoverChange(hoverValue);
	  },
	  clear: function clear() {
	    this.fireSelectValueChange([], true);
	    this.props.onClear();
	  },
	  disabledStartTime: function disabledStartTime(time) {
	    return this.props.disabledTime(time, 'start');
	  },
	  disabledEndTime: function disabledEndTime(time) {
	    return this.props.disabledTime(time, 'end');
	  },
	  disabledStartMonth: function disabledStartMonth(month) {
	    var value = this.state.value;
	
	    return month.isSameOrAfter(value[1], 'month');
	  },
	  disabledEndMonth: function disabledEndMonth(month) {
	    var value = this.state.value;
	
	    return month.isSameOrBefore(value[0], 'month');
	  },
	  render: function render() {
	    var _className, _classnames;
	
	    var props = this.props,
	        state = this.state;
	    var prefixCls = props.prefixCls,
	        dateInputPlaceholder = props.dateInputPlaceholder,
	        timePicker = props.timePicker,
	        showOk = props.showOk,
	        locale = props.locale,
	        showClear = props.showClear,
	        showToday = props.showToday,
	        type = props.type;
	    var hoverValue = state.hoverValue,
	        selectedValue = state.selectedValue,
	        mode = state.mode,
	        showTimePicker = state.showTimePicker;
	
	    var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
	    var classes = (0, _classnames3['default'])(className);
	    var newProps = {
	      selectedValue: state.selectedValue,
	      onSelect: this.onSelect,
	      onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
	    };
	
	    var placeholder1 = void 0;
	    var placeholder2 = void 0;
	
	    if (dateInputPlaceholder) {
	      if (Array.isArray(dateInputPlaceholder)) {
	        placeholder1 = dateInputPlaceholder[0];
	        placeholder2 = dateInputPlaceholder[1];
	      } else {
	        placeholder1 = placeholder2 = dateInputPlaceholder;
	      }
	    }
	    var showOkButton = showOk === true || showOk !== false && !!timePicker;
	    var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));
	
	    var startValue = this.getStartValue();
	    var endValue = this.getEndValue();
	    var todayTime = (0, _util.getTodayTime)(startValue);
	    var thisMonth = todayTime.month();
	    var thisYear = todayTime.year();
	    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
	    var nextMonthOfStart = startValue.clone().add(1, 'months');
	    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();
	    return _react2['default'].createElement(
	      'div',
	      {
	        ref: this.saveRoot,
	        className: classes,
	        style: props.style,
	        tabIndex: '0'
	      },
	      props.renderSidebar(),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-panel' },
	        showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement('a', {
	          className: prefixCls + '-clear-btn',
	          role: 'button',
	          title: locale.clear,
	          onClick: this.clear
	        }) : null,
	        _react2['default'].createElement(
	          'div',
	          {
	            className: prefixCls + '-date-panel',
	            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
	            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
	          },
	          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
	            hoverValue: hoverValue,
	            direction: 'left',
	            disabledTime: this.disabledStartTime,
	            disabledMonth: this.disabledStartMonth,
	            format: this.getFormat(),
	            value: startValue,
	            mode: mode[0],
	            placeholder: placeholder1,
	            onInputSelect: this.onStartInputSelect,
	            onValueChange: this.onStartValueChange,
	            onPanelChange: this.onStartPanelChange,
	            timePicker: timePicker,
	            showTimePicker: showTimePicker,
	            enablePrev: true,
	            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1])
	          })),
	          _react2['default'].createElement(
	            'span',
	            { className: prefixCls + '-range-middle' },
	            '~'
	          ),
	          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
	            hoverValue: hoverValue,
	            direction: 'right',
	            format: this.getFormat(),
	            timePickerDisabledTime: this.getEndDisableTime(),
	            placeholder: placeholder2,
	            value: endValue,
	            mode: mode[1],
	            onInputSelect: this.onEndInputSelect,
	            onValueChange: this.onEndValueChange,
	            onPanelChange: this.onEndPanelChange,
	            timePicker: timePicker,
	            showTimePicker: showTimePicker,
	            disabledTime: this.disabledEndTime,
	            disabledMonth: this.disabledEndMonth,
	            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
	            enableNext: true
	          }))
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: cls },
	          props.renderFooter(),
	          showToday || props.timePicker || showOkButton ? _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-footer-btn' },
	            showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
	              disabled: isTodayInView,
	              value: state.value[0],
	              onToday: this.onToday,
	              text: locale.backToToday
	            })) : null,
	            props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
	              showTimePicker: showTimePicker,
	              onOpenTimePicker: this.onOpenTimePicker,
	              onCloseTimePicker: this.onCloseTimePicker,
	              timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
	            })) : null,
	            showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
	              onOk: this.onOk,
	              okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
	            })) : null
	          ) : null
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = RangeCalendar;
	module.exports = exports['default'];

/***/ },
/* 2494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DateConstants = __webpack_require__(1153);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _util = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(one, two) {
	  return one && two && one.isSame(two, 'day');
	}
	
	function beforeCurrentMonthYear(current, today) {
	  if (current.year() < today.year()) {
	    return 1;
	  }
	  return current.year() === today.year() && current.month() < today.month();
	}
	
	function afterCurrentMonthYear(current, today) {
	  if (current.year() > today.year()) {
	    return 1;
	  }
	  return current.year() === today.year() && current.month() > today.month();
	}
	
	function getIdFromDate(date) {
	  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
	}
	
	var DateTBody = (0, _createReactClass2['default'])({
	  displayName: 'DateTBody',
	
	  propTypes: {
	    contentRender: _propTypes2['default'].func,
	    dateRender: _propTypes2['default'].func,
	    disabledDate: _propTypes2['default'].func,
	    prefixCls: _propTypes2['default'].string,
	    selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    value: _propTypes2['default'].object,
	    hoverValue: _propTypes2['default'].any,
	    showWeekNumber: _propTypes2['default'].bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hoverValue: []
	    };
	  },
	  render: function render() {
	    var props = this.props;
	    var contentRender = props.contentRender,
	        prefixCls = props.prefixCls,
	        selectedValue = props.selectedValue,
	        value = props.value,
	        showWeekNumber = props.showWeekNumber,
	        dateRender = props.dateRender,
	        disabledDate = props.disabledDate,
	        hoverValue = props.hoverValue;
	
	    var iIndex = void 0;
	    var jIndex = void 0;
	    var current = void 0;
	    var dateTable = [];
	    var today = (0, _util.getTodayTime)(value);
	    var cellClass = prefixCls + '-cell';
	    var weekNumberCellClass = prefixCls + '-week-number-cell';
	    var dateClass = prefixCls + '-date';
	    var todayClass = prefixCls + '-today';
	    var selectedClass = prefixCls + '-selected-day';
	    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
	    var selectedStartDateClass = prefixCls + '-selected-start-date';
	    var selectedEndDateClass = prefixCls + '-selected-end-date';
	    var inRangeClass = prefixCls + '-in-range-cell';
	    var lastMonthDayClass = prefixCls + '-last-month-cell';
	    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
	    var disabledClass = prefixCls + '-disabled-cell';
	    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
	    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
	    var month1 = value.clone();
	    month1.date(1);
	    var day = month1.day();
	    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
	    // calculate last month
	    var lastMonth1 = month1.clone();
	    lastMonth1.add(0 - lastMonthDiffDay, 'days');
	    var passed = 0;
	    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
	      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
	        current = lastMonth1;
	        if (passed) {
	          current = current.clone();
	          current.add(passed, 'days');
	        }
	        dateTable.push(current);
	        passed++;
	      }
	    }
	    var tableHtml = [];
	    passed = 0;
	
	    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
	      var _cx;
	
	      var isCurrentWeek = void 0;
	      var weekNumberCell = void 0;
	      var isActiveWeek = false;
	      var dateCells = [];
	      if (showWeekNumber) {
	        weekNumberCell = _react2['default'].createElement(
	          'td',
	          {
	            key: dateTable[passed].week(),
	            role: 'gridcell',
	            className: weekNumberCellClass
	          },
	          dateTable[passed].week()
	        );
	      }
	      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
	        var next = null;
	        var last = null;
	        current = dateTable[passed];
	        if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
	          next = dateTable[passed + 1];
	        }
	        if (jIndex > 0) {
	          last = dateTable[passed - 1];
	        }
	        var cls = cellClass;
	        var disabled = false;
	        var selected = false;
	
	        if (isSameDay(current, today)) {
	          cls += ' ' + todayClass;
	          isCurrentWeek = true;
	        }
	
	        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
	        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);
	
	        if (selectedValue && Array.isArray(selectedValue)) {
	          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
	          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
	            var startValue = rangeValue[0];
	            var endValue = rangeValue[1];
	            if (startValue) {
	              if (isSameDay(current, startValue)) {
	                selected = true;
	                isActiveWeek = true;
	                cls += ' ' + selectedStartDateClass;
	              }
	            }
	            if (startValue && endValue) {
	              if (isSameDay(current, endValue)) {
	                selected = true;
	                isActiveWeek = true;
	                cls += ' ' + selectedEndDateClass;
	              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
	                cls += ' ' + inRangeClass;
	              }
	            }
	          }
	        } else if (isSameDay(current, value)) {
	          // keyboard change value, highlight works
	          selected = true;
	          isActiveWeek = true;
	        }
	
	        if (isSameDay(current, selectedValue)) {
	          cls += ' ' + selectedDateClass;
	        }
	
	        if (isBeforeCurrentMonthYear) {
	          cls += ' ' + lastMonthDayClass;
	        }
	        if (isAfterCurrentMonthYear) {
	          cls += ' ' + nextMonthDayClass;
	        }
	
	        if (disabledDate) {
	          if (disabledDate(current, value)) {
	            disabled = true;
	
	            if (!last || !disabledDate(last, value)) {
	              cls += ' ' + firstDisableClass;
	            }
	
	            if (!next || !disabledDate(next, value)) {
	              cls += ' ' + lastDisableClass;
	            }
	          }
	        }
	
	        if (selected) {
	          cls += ' ' + selectedClass;
	        }
	
	        if (disabled) {
	          cls += ' ' + disabledClass;
	        }
	
	        var dateHtml = void 0;
	        if (dateRender) {
	          dateHtml = dateRender(current, value);
	        } else {
	          var content = contentRender ? contentRender(current, value) : current.date();
	          dateHtml = _react2['default'].createElement(
	            'div',
	            {
	              key: getIdFromDate(current),
	              className: dateClass,
	              'aria-selected': selected,
	              'aria-disabled': disabled
	            },
	            content
	          );
	        }
	
	        dateCells.push(_react2['default'].createElement(
	          'td',
	          {
	            key: passed,
	            onClick: disabled ? undefined : props.onSelect.bind(null, current),
	            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
	            role: 'gridcell',
	            title: (0, _util.getTitleString)(current), className: cls
	          },
	          dateHtml
	        ));
	
	        passed++;
	      }
	
	      tableHtml.push(_react2['default'].createElement(
	        'tr',
	        {
	          key: iIndex,
	          role: 'row',
	          className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
	        },
	        weekNumberCell,
	        dateCells
	      ));
	    }
	    return _react2['default'].createElement(
	      'tbody',
	      { className: prefixCls + '-tbody' },
	      tableHtml
	    );
	  }
	});
	
	exports['default'] = DateTBody;
	module.exports = exports['default'];

/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateConstants = __webpack_require__(1153);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DateTHead = function (_React$Component) {
	  (0, _inherits3['default'])(DateTHead, _React$Component);
	
	  function DateTHead() {
	    (0, _classCallCheck3['default'])(this, DateTHead);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DateTHead.prototype.render = function render() {
	    var props = this.props;
	    var value = props.value;
	    var localeData = value.localeData();
	    var prefixCls = props.prefixCls;
	    var veryShortWeekdays = [];
	    var weekDays = [];
	    var firstDayOfWeek = localeData.firstDayOfWeek();
	    var showWeekNumberEl = void 0;
	    var now = (0, _moment2['default'])();
	    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
	      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
	      now.day(index);
	      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
	      weekDays[dateColIndex] = localeData.weekdaysShort(now);
	    }
	
	    if (props.showWeekNumber) {
	      showWeekNumberEl = _react2['default'].createElement(
	        'th',
	        {
	          role: 'columnheader',
	          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
	        },
	        _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-column-header-inner' },
	          'x'
	        )
	      );
	    }
	    var weekDaysEls = weekDays.map(function (day, xindex) {
	      return _react2['default'].createElement(
	        'th',
	        {
	          key: xindex,
	          role: 'columnheader',
	          title: day,
	          className: prefixCls + '-column-header'
	        },
	        _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-column-header-inner' },
	          veryShortWeekdays[xindex]
	        )
	      );
	    });
	    return _react2['default'].createElement(
	      'thead',
	      null,
	      _react2['default'].createElement(
	        'tr',
	        { role: 'row' },
	        showWeekNumberEl,
	        weekDaysEls
	      )
	    );
	  };
	
	  return DateTHead;
	}(_react2['default'].Component);
	
	exports['default'] = DateTHead;
	module.exports = exports['default'];

/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROW = 4;
	var COL = 3;
	
	
	function goYear(direction) {
	  var next = this.state.value.clone();
	  next.add(direction, 'years');
	  this.setState({
	    value: next
	  });
	}
	
	function chooseDecade(year, event) {
	  var next = this.state.value.clone();
	  next.year(year);
	  next.month(this.state.value.month());
	  this.props.onSelect(next);
	  event.preventDefault();
	}
	
	var DecadePanel = function (_React$Component) {
	  (0, _inherits3['default'])(DecadePanel, _React$Component);
	
	  function DecadePanel(props) {
	    (0, _classCallCheck3['default'])(this, DecadePanel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.state = {
	      value: props.value || props.defaultValue
	    };
	
	    // bind methods
	    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
	    _this.nextCentury = goYear.bind(_this, 100);
	    _this.previousCentury = goYear.bind(_this, -100);
	    return _this;
	  }
	
	  DecadePanel.prototype.render = function render() {
	    var _this2 = this;
	
	    var value = this.state.value;
	    var locale = this.props.locale;
	    var currentYear = value.year();
	    var startYear = parseInt(currentYear / 100, 10) * 100;
	    var preYear = startYear - 10;
	    var endYear = startYear + 99;
	    var decades = [];
	    var index = 0;
	    var prefixCls = this.prefixCls;
	
	    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
	      decades[rowIndex] = [];
	      for (var colIndex = 0; colIndex < COL; colIndex++) {
	        var startDecade = preYear + index * 10;
	        var endDecade = preYear + index * 10 + 9;
	        decades[rowIndex][colIndex] = {
	          startDecade: startDecade,
	          endDecade: endDecade
	        };
	        index++;
	      }
	    }
	
	    var decadesEls = decades.map(function (row, decadeIndex) {
	      var tds = row.map(function (decadeData) {
	        var _classNameMap;
	
	        var dStartDecade = decadeData.startDecade;
	        var dEndDecade = decadeData.endDecade;
	        var isLast = dStartDecade < startYear;
	        var isNext = dEndDecade > endYear;
	        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
	        var content = dStartDecade + '-' + dEndDecade;
	        var clickHandler = void 0;
	        if (isLast) {
	          clickHandler = _this2.previousCentury;
	        } else if (isNext) {
	          clickHandler = _this2.nextCentury;
	        } else {
	          clickHandler = chooseDecade.bind(_this2, dStartDecade);
	        }
	        return _react2['default'].createElement(
	          'td',
	          {
	            key: dStartDecade,
	            onClick: clickHandler,
	            role: 'gridcell',
	            className: (0, _classnames2['default'])(classNameMap)
	          },
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-decade'
	            },
	            content
	          )
	        );
	      });
	      return _react2['default'].createElement(
	        'tr',
	        { key: decadeIndex, role: 'row' },
	        tds
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: this.prefixCls },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-header' },
	        _react2['default'].createElement('a', {
	          className: prefixCls + '-prev-century-btn',
	          role: 'button',
	          onClick: this.previousCentury,
	          title: locale.previousCentury
	        }),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-century' },
	          startYear,
	          '-',
	          endYear
	        ),
	        _react2['default'].createElement('a', {
	          className: prefixCls + '-next-century-btn',
	          role: 'button',
	          onClick: this.nextCentury,
	          title: locale.nextCentury
	        })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-body' },
	        _react2['default'].createElement(
	          'table',
	          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	          _react2['default'].createElement(
	            'tbody',
	            { className: prefixCls + '-tbody' },
	            decadesEls
	          )
	        )
	      )
	    );
	  };
	
	  return DecadePanel;
	}(_react2['default'].Component);
	
	exports['default'] = DecadePanel;
	
	
	DecadePanel.propTypes = {
	  locale: _propTypes2['default'].object,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  rootPrefixCls: _propTypes2['default'].string
	};
	
	DecadePanel.defaultProps = {
	  onSelect: function onSelect() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var CalendarHeader = function (_Component) {
	  (0, _inherits3['default'])(CalendarHeader, _Component);
	
	  function CalendarHeader() {
	    (0, _classCallCheck3['default'])(this, CalendarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  CalendarHeader.prototype.onYearChange = function onYearChange(year) {
	    var newValue = this.props.value.clone();
	    newValue.year(parseInt(year, 10));
	    this.props.onValueChange(newValue);
	  };
	
	  CalendarHeader.prototype.onMonthChange = function onMonthChange(month) {
	    var newValue = this.props.value.clone();
	    newValue.month(parseInt(month, 10));
	    this.props.onValueChange(newValue);
	  };
	
	  CalendarHeader.prototype.yearSelectElement = function yearSelectElement(year) {
	    var _props = this.props,
	        yearSelectOffset = _props.yearSelectOffset,
	        yearSelectTotal = _props.yearSelectTotal,
	        prefixCls = _props.prefixCls,
	        Select = _props.Select;
	
	    var start = year - yearSelectOffset;
	    var end = start + yearSelectTotal;
	
	    var options = [];
	    for (var index = start; index < end; index++) {
	      options.push(_react2['default'].createElement(
	        Select.Option,
	        { key: '' + index },
	        index
	      ));
	    }
	    return _react2['default'].createElement(
	      Select,
	      {
	        className: prefixCls + '-header-year-select',
	        onChange: this.onYearChange.bind(this),
	        dropdownStyle: { zIndex: 2000 },
	        dropdownMenuStyle: { maxHeight: 250, overflow: 'auto', fontSize: 12 },
	        optionLabelProp: 'children',
	        value: String(year),
	        showSearch: false
	      },
	      options
	    );
	  };
	
	  CalendarHeader.prototype.monthSelectElement = function monthSelectElement(month) {
	    var props = this.props;
	    var t = props.value.clone();
	    var prefixCls = props.prefixCls;
	
	    var options = [];
	    var Select = props.Select;
	
	    for (var index = 0; index < 12; index++) {
	      t.month(index);
	      options.push(_react2['default'].createElement(
	        Select.Option,
	        { key: '' + index },
	        (0, _util.getMonthName)(t)
	      ));
	    }
	
	    return _react2['default'].createElement(
	      Select,
	      {
	        className: prefixCls + '-header-month-select',
	        dropdownStyle: { zIndex: 2000 },
	        dropdownMenuStyle: { maxHeight: 250, overflow: 'auto', overflowX: 'hidden', fontSize: 12 },
	        optionLabelProp: 'children',
	        value: String(month),
	        showSearch: false,
	        onChange: this.onMonthChange.bind(this)
	      },
	      options
	    );
	  };
	
	  CalendarHeader.prototype.changeTypeToDate = function changeTypeToDate() {
	    this.props.onTypeChange('date');
	  };
	
	  CalendarHeader.prototype.changeTypeToMonth = function changeTypeToMonth() {
	    this.props.onTypeChange('month');
	  };
	
	  CalendarHeader.prototype.render = function render() {
	    var _props2 = this.props,
	        value = _props2.value,
	        locale = _props2.locale,
	        prefixCls = _props2.prefixCls,
	        type = _props2.type,
	        showTypeSwitch = _props2.showTypeSwitch,
	        headerComponents = _props2.headerComponents;
	
	    var year = value.year();
	    var month = value.month();
	    var yearSelect = this.yearSelectElement(year);
	    var monthSelect = type === 'month' ? null : this.monthSelectElement(month);
	    var switchCls = prefixCls + '-header-switcher';
	    var typeSwitcher = showTypeSwitch ? _react2['default'].createElement(
	      'span',
	      { className: switchCls },
	      type === 'date' ? _react2['default'].createElement(
	        'span',
	        { className: switchCls + '-focus' },
	        locale.month
	      ) : _react2['default'].createElement(
	        'span',
	        {
	          onClick: this.changeTypeToDate.bind(this),
	          className: switchCls + '-normal'
	        },
	        locale.month
	      ),
	      type === 'month' ? _react2['default'].createElement(
	        'span',
	        { className: switchCls + '-focus' },
	        locale.year
	      ) : _react2['default'].createElement(
	        'span',
	        {
	          onClick: this.changeTypeToMonth.bind(this),
	          className: switchCls + '-normal'
	        },
	        locale.year
	      )
	    ) : null;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-header' },
	      typeSwitcher,
	      monthSelect,
	      yearSelect,
	      headerComponents
	    );
	  };
	
	  return CalendarHeader;
	}(_react.Component);
	
	CalendarHeader.propTypes = {
	  value: _propTypes2['default'].object,
	  locale: _propTypes2['default'].object,
	  yearSelectOffset: _propTypes2['default'].number,
	  yearSelectTotal: _propTypes2['default'].number,
	  onValueChange: _propTypes2['default'].func,
	  onTypeChange: _propTypes2['default'].func,
	  Select: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  type: _propTypes2['default'].string,
	  showTypeSwitch: _propTypes2['default'].bool,
	  headerComponents: _propTypes2['default'].array
	};
	CalendarHeader.defaultProps = {
	  yearSelectOffset: 10,
	  yearSelectTotal: 20,
	  onValueChange: noop,
	  onTypeChange: noop
	};
	
	exports['default'] = CalendarHeader;
	module.exports = exports['default'];

/***/ },
/* 2498 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: 'Avui',
	  now: 'Ara',
	  backToToday: 'Tornar a avui',
	  ok: 'Acceptar',
	  clear: 'Netejar',
	  month: 'Mes',
	  year: 'Any',
	  timeSelect: 'Seleccionar hora',
	  dateSelect: 'Seleccionar data',
	  monthSelect: 'Escollir un mes',
	  yearSelect: 'Escollir un any',
	  decadeSelect: 'Escollir una dècada',
	  yearFormat: 'YYYY',
	  dateFormat: 'D/M/YYYY',
	  dayFormat: 'D',
	  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
	  monthBeforeYear: true,
	  previousMonth: 'Mes anterior (PageUp)',
	  nextMonth: 'Mes següent (PageDown)',
	  previousYear: 'Any anterior (Control + left)',
	  nextYear: 'Mes següent (Control + right)',
	  previousDecade: 'Dècada anterior',
	  nextDecade: 'Dècada següent',
	  previousCentury: 'Segle anterior',
	  nextCentury: 'Segle següent'
	};
	module.exports = exports['default'];

/***/ },
/* 2499 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: 'Aujourd\'hui',
	  now: 'Maintenant',
	  backToToday: 'Aujourd\'hui',
	  ok: 'Ok',
	  clear: 'Rétablir',
	  month: 'Mois',
	  year: 'Année',
	  timeSelect: 'Sélectionner l\'heure',
	  dateSelect: 'Sélectionner l\'heure',
	  monthSelect: 'Choisissez un mois',
	  yearSelect: 'Choisissez une année',
	  decadeSelect: 'Choisissez une décennie',
	  yearFormat: 'YYYY',
	  dateFormat: 'DD/MM/YYYY',
	  dayFormat: 'DD',
	  dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
	  monthBeforeYear: true,
	  previousMonth: 'Mois précédent (PageUp)',
	  nextMonth: 'Mois suivant (PageDown)',
	  previousYear: 'Année précédente (Ctrl + gauche)',
	  nextYear: 'Année prochaine (Ctrl + droite)',
	  previousDecade: 'Décennie précédente',
	  nextDecade: 'Décennie suivante',
	  previousCentury: 'Siècle précédent',
	  nextCentury: 'Siècle suivant'
	};
	module.exports = exports['default'];

/***/ },
/* 2500 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: 'Oggi',
	  now: 'adesso',
	  backToToday: 'Torna ad oggi',
	  ok: 'Ok',
	  clear: 'Chiaro',
	  month: 'Mese',
	  year: 'Anno',
	  timeSelect: 'Seleziona il tempo',
	  dateSelect: 'Select date',
	  monthSelect: 'Seleziona la data',
	  yearSelect: 'Scegli un anno',
	  decadeSelect: 'Scegli un decennio',
	  yearFormat: 'YYYY',
	  dateFormat: 'D/M/YYYY',
	  dayFormat: 'D',
	  dateTimeFormat: 'D/M/YYYY HH:mm:ss',
	  monthBeforeYear: true,
	  previousMonth: 'Il mese scorso (PageUp)',
	  nextMonth: 'Il prossimo mese (PageDown)',
	  previousYear: 'L\'anno scorso (Control + sinistra)',
	  nextYear: 'L\'anno prossimo (Control + destra)',
	  previousDecade: 'Ultimo decennio',
	  nextDecade: 'Prossimo decennio',
	  previousCentury: 'Secolo precedente',
	  nextCentury: 'Prossimo secolo'
	};
	module.exports = exports['default'];

/***/ },
/* 2501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _MonthTable = __webpack_require__(1157);
	
	var _MonthTable2 = _interopRequireDefault(_MonthTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function goYear(direction) {
	  var next = this.state.value.clone();
	  next.add(direction, 'year');
	  this.setAndChangeValue(next);
	}
	
	function noop() {}
	
	var MonthPanel = (0, _createReactClass2['default'])({
	  displayName: 'MonthPanel',
	
	  propTypes: {
	    onChange: _propTypes2['default'].func,
	    disabledDate: _propTypes2['default'].func,
	    onSelect: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onChange: noop,
	      onSelect: noop
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    // bind methods
	    this.nextYear = goYear.bind(this, 1);
	    this.previousYear = goYear.bind(this, -1);
	    this.prefixCls = props.rootPrefixCls + '-month-panel';
	    return {
	      value: props.value || props.defaultValue
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ('value' in nextProps) {
	      this.setState({
	        value: nextProps.value
	      });
	    }
	  },
	  setAndChangeValue: function setAndChangeValue(value) {
	    this.setValue(value);
	    this.props.onChange(value);
	  },
	  setAndSelectValue: function setAndSelectValue(value) {
	    this.setValue(value);
	    this.props.onSelect(value);
	  },
	  setValue: function setValue(value) {
	    if (!('value' in this.props)) {
	      this.setState({
	        value: value
	      });
	    }
	  },
	  render: function render() {
	    var props = this.props;
	    var value = this.state.value;
	    var cellRender = props.cellRender;
	    var contentRender = props.contentRender;
	    var locale = props.locale;
	    var year = value.year();
	    var prefixCls = this.prefixCls;
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls, style: props.style },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-header' },
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-prev-year-btn',
	            role: 'button',
	            onClick: this.previousYear,
	            title: locale.previousYear
	          }),
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-year-select',
	              role: 'button',
	              onClick: props.onYearPanelShow,
	              title: locale.yearSelect
	            },
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-year-select-content' },
	              year
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-year-select-arrow' },
	              'x'
	            )
	          ),
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-next-year-btn',
	            role: 'button',
	            onClick: this.nextYear,
	            title: locale.nextYear
	          })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(_MonthTable2['default'], {
	            disabledDate: props.disabledDate,
	            onSelect: this.setAndSelectValue,
	            locale: locale,
	            value: value,
	            cellRender: cellRender,
	            contentRender: contentRender,
	            prefixCls: prefixCls
	          })
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = MonthPanel;
	module.exports = exports['default'];

/***/ },
/* 2502 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = {
	  bottomLeft: {
	    points: ['tl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;
	module.exports = exports['default'];

/***/ },
/* 2503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CalendarHeader = __webpack_require__(470);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _DateTable = __webpack_require__(471);
	
	var _DateTable2 = _interopRequireDefault(_DateTable);
	
	var _DateInput = __webpack_require__(1154);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _index = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarPart = (0, _createReactClass2['default'])({
	  displayName: 'CalendarPart',
	
	  propTypes: {
	    prefixCls: _propTypes2['default'].string,
	    value: _propTypes2['default'].any,
	    hoverValue: _propTypes2['default'].any,
	    selectedValue: _propTypes2['default'].any,
	    direction: _propTypes2['default'].any,
	    locale: _propTypes2['default'].any,
	    showTimePicker: _propTypes2['default'].bool,
	    format: _propTypes2['default'].any,
	    placeholder: _propTypes2['default'].any,
	    disabledDate: _propTypes2['default'].any,
	    timePicker: _propTypes2['default'].any,
	    disabledTime: _propTypes2['default'].any,
	    onInputSelect: _propTypes2['default'].func,
	    timePickerDisabledTime: _propTypes2['default'].object,
	    enableNext: _propTypes2['default'].any,
	    enablePrev: _propTypes2['default'].any
	  },
	  render: function render() {
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        value = props.value,
	        hoverValue = props.hoverValue,
	        selectedValue = props.selectedValue,
	        mode = props.mode,
	        direction = props.direction,
	        locale = props.locale,
	        format = props.format,
	        placeholder = props.placeholder,
	        disabledDate = props.disabledDate,
	        timePicker = props.timePicker,
	        disabledTime = props.disabledTime,
	        timePickerDisabledTime = props.timePickerDisabledTime,
	        showTimePicker = props.showTimePicker,
	        onInputSelect = props.onInputSelect,
	        enablePrev = props.enablePrev,
	        enableNext = props.enableNext;
	
	    var shouldShowTimePicker = showTimePicker && timePicker;
	    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
	    var rangeClassName = prefixCls + '-range';
	    var newProps = {
	      locale: locale,
	      value: value,
	      prefixCls: prefixCls,
	      showTimePicker: showTimePicker
	    };
	    var index = direction === 'left' ? 0 : 1;
	    var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
	      showHour: true,
	      showMinute: true,
	      showSecond: true
	    }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
	      onChange: onInputSelect,
	      defaultOpenValue: value,
	      value: selectedValue[index]
	    }));
	    return _react2['default'].createElement(
	      'div',
	      { className: rangeClassName + '-part ' + rangeClassName + '-' + direction },
	      _react2['default'].createElement(_DateInput2['default'], {
	        format: format,
	        locale: locale,
	        prefixCls: prefixCls,
	        timePicker: timePicker,
	        disabledDate: disabledDate,
	        placeholder: placeholder,
	        disabledTime: disabledTime,
	        value: value,
	        showClear: false,
	        selectedValue: selectedValue[index],
	        onChange: onInputSelect
	      }),
	      _react2['default'].createElement(
	        'div',
	        { style: { outline: 'none' } },
	        _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
	          mode: mode,
	          enableNext: enableNext,
	          enablePrev: enablePrev,
	          onValueChange: props.onValueChange,
	          onPanelChange: props.onPanelChange,
	          disabledMonth: props.disabledMonth
	        })),
	        showTimePicker ? _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-time-picker' },
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-time-picker-panel' },
	            timePickerEle
	          )
	        ) : null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
	            hoverValue: hoverValue,
	            selectedValue: selectedValue,
	            dateRender: props.dateRender,
	            onSelect: props.onSelect,
	            onDayHover: props.onDayHover,
	            disabledDate: disabledDate,
	            showWeekNumber: props.showWeekNumber
	          }))
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = CalendarPart;
	module.exports = exports['default'];

/***/ },
/* 2504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROW = 4;
	var COL = 3;
	
	function goYear(direction) {
	  var value = this.state.value.clone();
	  value.add(direction, 'year');
	  this.setState({
	    value: value
	  });
	}
	
	function chooseYear(year) {
	  var value = this.state.value.clone();
	  value.year(year);
	  value.month(this.state.value.month());
	  this.props.onSelect(value);
	}
	
	var YearPanel = function (_React$Component) {
	  (0, _inherits3['default'])(YearPanel, _React$Component);
	
	  function YearPanel(props) {
	    (0, _classCallCheck3['default'])(this, YearPanel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.prefixCls = props.rootPrefixCls + '-year-panel';
	    _this.state = {
	      value: props.value || props.defaultValue
	    };
	    _this.nextDecade = goYear.bind(_this, 10);
	    _this.previousDecade = goYear.bind(_this, -10);
	    return _this;
	  }
	
	  YearPanel.prototype.years = function years() {
	    var value = this.state.value;
	    var currentYear = value.year();
	    var startYear = parseInt(currentYear / 10, 10) * 10;
	    var previousYear = startYear - 1;
	    var years = [];
	    var index = 0;
	    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
	      years[rowIndex] = [];
	      for (var colIndex = 0; colIndex < COL; colIndex++) {
	        var year = previousYear + index;
	        var content = String(year);
	        years[rowIndex][colIndex] = {
	          content: content,
	          year: year,
	          title: content
	        };
	        index++;
	      }
	    }
	    return years;
	  };
	
	  YearPanel.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var value = this.state.value;
	    var locale = props.locale;
	    var years = this.years();
	    var currentYear = value.year();
	    var startYear = parseInt(currentYear / 10, 10) * 10;
	    var endYear = startYear + 9;
	    var prefixCls = this.prefixCls;
	
	    var yeasEls = years.map(function (row, index) {
	      var tds = row.map(function (yearData) {
	        var _classNameMap;
	
	        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
	        var clickHandler = void 0;
	        if (yearData.year < startYear) {
	          clickHandler = _this2.previousDecade;
	        } else if (yearData.year > endYear) {
	          clickHandler = _this2.nextDecade;
	        } else {
	          clickHandler = chooseYear.bind(_this2, yearData.year);
	        }
	        return _react2['default'].createElement(
	          'td',
	          {
	            role: 'gridcell',
	            title: yearData.title,
	            key: yearData.content,
	            onClick: clickHandler,
	            className: (0, _classnames2['default'])(classNameMap)
	          },
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-year'
	            },
	            yearData.content
	          )
	        );
	      });
	      return _react2['default'].createElement(
	        'tr',
	        { key: index, role: 'row' },
	        tds
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: this.prefixCls },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-header' },
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-prev-decade-btn',
	            role: 'button',
	            onClick: this.previousDecade,
	            title: locale.previousDecade
	          }),
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-decade-select',
	              role: 'button',
	              onClick: props.onDecadePanelShow,
	              title: locale.decadeSelect
	            },
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-decade-select-content' },
	              startYear,
	              '-',
	              endYear
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-decade-select-arrow' },
	              'x'
	            )
	          ),
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-next-decade-btn',
	            role: 'button',
	            onClick: this.nextDecade,
	            title: locale.nextDecade
	          })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(
	            'table',
	            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	            _react2['default'].createElement(
	              'tbody',
	              { className: prefixCls + '-tbody' },
	              yeasEls
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return YearPanel;
	}(_react2['default'].Component);
	
	exports['default'] = YearPanel;
	
	
	YearPanel.propTypes = {
	  rootPrefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object
	};
	
	YearPanel.defaultProps = {
	  onSelect: function onSelect() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _Menus = __webpack_require__(2506);
	
	var _Menus2 = _interopRequireDefault(_Menus);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _arrayTreeFilter = __webpack_require__(1158);
	
	var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);
	
	var _arrays = __webpack_require__(1403);
	
	var _arrays2 = _interopRequireDefault(_arrays);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  }
	};
	
	var Cascader = function (_Component) {
	  _inherits(Cascader, _Component);
	
	  function Cascader(props) {
	    _classCallCheck(this, Cascader);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.setPopupVisible = function (popupVisible) {
	      if (!('popupVisible' in _this.props)) {
	        _this.setState({ popupVisible: popupVisible });
	      }
	      // sync activeValue with value when panel open
	      if (popupVisible && !_this.state.visible) {
	        _this.setState({
	          activeValue: _this.state.value
	        });
	      }
	      _this.props.onPopupVisibleChange(popupVisible);
	    };
	
	    _this.handleChange = function (options, setProps, e) {
	      if (e.type !== 'keydown' || e.keyCode === _KeyCode2['default'].ENTER) {
	        _this.props.onChange(options.map(function (o) {
	          return o.value;
	        }), options);
	        _this.setPopupVisible(setProps.visible);
	      }
	    };
	
	    _this.handlePopupVisibleChange = function (popupVisible) {
	      _this.setPopupVisible(popupVisible);
	    };
	
	    _this.handleMenuSelect = function (targetOption, menuIndex, e) {
	      // Keep focused state for keyboard support
	      var triggerNode = _this.trigger.getRootDomNode();
	      if (triggerNode && triggerNode.focus) {
	        triggerNode.focus();
	      }
	      var _this$props = _this.props,
	          changeOnSelect = _this$props.changeOnSelect,
	          loadData = _this$props.loadData,
	          expandTrigger = _this$props.expandTrigger;
	
	      if (!targetOption || targetOption.disabled) {
	        return;
	      }
	      var activeValue = _this.state.activeValue;
	
	      activeValue = activeValue.slice(0, menuIndex + 1);
	      activeValue[menuIndex] = targetOption.value;
	      var activeOptions = _this.getActiveOptions(activeValue);
	      if (targetOption.isLeaf === false && !targetOption.children && loadData) {
	        if (changeOnSelect) {
	          _this.handleChange(activeOptions, { visible: true }, e);
	        }
	        _this.setState({ activeValue: activeValue });
	        loadData(activeOptions);
	        return;
	      }
	      var newState = {};
	      if (!targetOption.children || !targetOption.children.length) {
	        _this.handleChange(activeOptions, { visible: false }, e);
	        // set value to activeValue when select leaf option
	        newState.value = activeValue;
	        // add e.type judgement to prevent `onChange` being triggered by mouseEnter
	      } else if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
	        if (expandTrigger === 'hover') {
	          _this.handleChange(activeOptions, { visible: false }, e);
	        } else {
	          _this.handleChange(activeOptions, { visible: true }, e);
	        }
	        // set value to activeValue on every select
	        newState.value = activeValue;
	      }
	      newState.activeValue = activeValue;
	      //  not change the value by keyboard
	      if ('value' in _this.props || e.type === 'keydown' && e.keyCode !== _KeyCode2['default'].ENTER) {
	        delete newState.value;
	      }
	      _this.setState(newState);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var children = _this.props.children;
	      // https://github.com/ant-design/ant-design/issues/6717
	      // Don't bind keyboard support when children specify the onKeyDown
	
	      if (children && children.props.onKeyDown) {
	        children.props.onKeyDown(e);
	        return;
	      }
	      var activeValue = [].concat(_this.state.activeValue);
	      var currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;
	      var currentOptions = _this.getCurrentLevelOptions();
	      var currentIndex = currentOptions.map(function (o) {
	        return o.value;
	      }).indexOf(activeValue[currentLevel]);
	      if (e.keyCode !== _KeyCode2['default'].DOWN && e.keyCode !== _KeyCode2['default'].UP && e.keyCode !== _KeyCode2['default'].LEFT && e.keyCode !== _KeyCode2['default'].RIGHT && e.keyCode !== _KeyCode2['default'].ENTER && e.keyCode !== _KeyCode2['default'].BACKSPACE && e.keyCode !== _KeyCode2['default'].ESC) {
	        return;
	      }
	      // Press any keys above to reopen menu
	      if (!_this.state.popupVisible && e.keyCode !== _KeyCode2['default'].BACKSPACE && e.keyCode !== _KeyCode2['default'].LEFT && e.keyCode !== _KeyCode2['default'].RIGHT && e.keyCode !== _KeyCode2['default'].ESC) {
	        _this.setPopupVisible(true);
	        return;
	      }
	      if (e.keyCode === _KeyCode2['default'].DOWN || e.keyCode === _KeyCode2['default'].UP) {
	        var nextIndex = currentIndex;
	        if (nextIndex !== -1) {
	          if (e.keyCode === _KeyCode2['default'].DOWN) {
	            nextIndex += 1;
	            nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
	          } else {
	            nextIndex -= 1;
	            nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
	          }
	        } else {
	          nextIndex = 0;
	        }
	        activeValue[currentLevel] = currentOptions[nextIndex].value;
	      } else if (e.keyCode === _KeyCode2['default'].LEFT || e.keyCode === _KeyCode2['default'].BACKSPACE) {
	        activeValue.splice(activeValue.length - 1, 1);
	      } else if (e.keyCode === _KeyCode2['default'].RIGHT) {
	        if (currentOptions[currentIndex] && currentOptions[currentIndex].children) {
	          activeValue.push(currentOptions[currentIndex].children[0].value);
	        }
	      } else if (e.keyCode === _KeyCode2['default'].ESC) {
	        _this.setPopupVisible(false);
	        return;
	      }
	      if (!activeValue || activeValue.length === 0) {
	        _this.setPopupVisible(false);
	      }
	      var activeOptions = _this.getActiveOptions(activeValue);
	      var targetOption = activeOptions[activeOptions.length - 1];
	      _this.handleMenuSelect(targetOption, activeOptions.length - 1, e);
	
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	    };
	
	    _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    };
	
	    var initialValue = [];
	    if ('value' in props) {
	      initialValue = props.value || [];
	    } else if ('defaultValue' in props) {
	      initialValue = props.defaultValue || [];
	    }
	
	    _this.state = {
	      popupVisible: props.popupVisible,
	      activeValue: initialValue,
	      value: initialValue
	    };
	    return _this;
	  }
	
	  Cascader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if ('value' in nextProps && !(0, _arrays2['default'])(this.props.value, nextProps.value)) {
	      var newValues = {
	        value: nextProps.value || [],
	        activeValue: nextProps.value || []
	      };
	      // allow activeValue diff from value
	      // https://github.com/ant-design/ant-design/issues/2767
	      if ('loadData' in nextProps) {
	        delete newValues.activeValue;
	      }
	      this.setState(newValues);
	    }
	    if ('popupVisible' in nextProps) {
	      this.setState({
	        popupVisible: nextProps.popupVisible
	      });
	    }
	  };
	
	  Cascader.prototype.getPopupDOMNode = function getPopupDOMNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Cascader.prototype.getCurrentLevelOptions = function getCurrentLevelOptions() {
	    var options = this.props.options;
	    var _state$activeValue = this.state.activeValue,
	        activeValue = _state$activeValue === undefined ? [] : _state$activeValue;
	
	    var result = (0, _arrayTreeFilter2['default'])(options, function (o, level) {
	      return o.value === activeValue[level];
	    });
	    if (result[result.length - 2]) {
	      return result[result.length - 2].children;
	    }
	    return [].concat(options).filter(function (o) {
	      return !o.disabled;
	    });
	  };
	
	  Cascader.prototype.getActiveOptions = function getActiveOptions(activeValue) {
	    return (0, _arrayTreeFilter2['default'])(this.props.options, function (o, level) {
	      return o.value === activeValue[level];
	    });
	  };
	
	  Cascader.prototype.render = function render() {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        transitionName = _props.transitionName,
	        popupClassName = _props.popupClassName,
	        options = _props.options,
	        disabled = _props.disabled,
	        builtinPlacements = _props.builtinPlacements,
	        popupPlacement = _props.popupPlacement,
	        children = _props.children,
	        restProps = _objectWithoutProperties(_props, ['prefixCls', 'transitionName', 'popupClassName', 'options', 'disabled', 'builtinPlacements', 'popupPlacement', 'children']);
	    // Did not show popup when there is no options
	
	
	    var menus = _react2['default'].createElement('div', null);
	    var emptyMenuClassName = '';
	    if (options && options.length > 0) {
	      menus = _react2['default'].createElement(_Menus2['default'], _extends({}, this.props, {
	        value: this.state.value,
	        activeValue: this.state.activeValue,
	        onSelect: this.handleMenuSelect,
	        visible: this.state.popupVisible
	      }));
	    } else {
	      emptyMenuClassName = ' ' + prefixCls + '-menus-empty';
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      _extends({
	        ref: this.saveTrigger
	      }, restProps, {
	        options: options,
	        disabled: disabled,
	        popupPlacement: popupPlacement,
	        builtinPlacements: builtinPlacements,
	        popupTransitionName: transitionName,
	        action: disabled ? [] : ['click'],
	        popupVisible: disabled ? false : this.state.popupVisible,
	        onPopupVisibleChange: this.handlePopupVisibleChange,
	        prefixCls: prefixCls + '-menus',
	        popupClassName: popupClassName + emptyMenuClassName,
	        popup: menus
	      }),
	      (0, _react.cloneElement)(children, {
	        onKeyDown: this.handleKeyDown,
	        tabIndex: disabled ? undefined : 0
	      })
	    );
	  };
	
	  return Cascader;
	}(_react.Component);
	
	Cascader.defaultProps = {
	  options: [],
	  onChange: function onChange() {},
	  onPopupVisibleChange: function onPopupVisibleChange() {},
	
	  disabled: false,
	  transitionName: '',
	  prefixCls: 'rc-cascader',
	  popupClassName: '',
	  popupPlacement: 'bottomLeft',
	  builtinPlacements: BUILT_IN_PLACEMENTS,
	  expandTrigger: 'click'
	};
	
	Cascader.propTypes = {
	  value: _propTypes2['default'].array,
	  defaultValue: _propTypes2['default'].array,
	  options: _propTypes2['default'].array.isRequired,
	  onChange: _propTypes2['default'].func,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  popupVisible: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  transitionName: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  dropdownMenuColumnStyle: _propTypes2['default'].object,
	  builtinPlacements: _propTypes2['default'].object,
	  loadData: _propTypes2['default'].func,
	  changeOnSelect: _propTypes2['default'].bool,
	  children: _propTypes2['default'].node,
	  onKeyDown: _propTypes2['default'].func,
	  expandTrigger: _propTypes2['default'].string
	};
	
	exports['default'] = Cascader;
	module.exports = exports['default'];

/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrayTreeFilter = __webpack_require__(1158);
	
	var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);
	
	var _reactDom = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menus = function (_React$Component) {
	  _inherits(Menus, _React$Component);
	
	  function Menus(props) {
	    _classCallCheck(this, Menus);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.saveMenuItem = function (index) {
	      return function (node) {
	        _this.menuItems[index] = node;
	      };
	    };
	
	    _this.menuItems = {};
	    return _this;
	  }
	
	  Menus.prototype.componentDidMount = function componentDidMount() {
	    this.scrollActiveItemToView();
	  };
	
	  Menus.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (!prevProps.visible && this.props.visible) {
	      this.scrollActiveItemToView();
	    }
	  };
	
	  Menus.prototype.getOption = function getOption(option, menuIndex) {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        expandTrigger = _props.expandTrigger;
	
	    var onSelect = this.props.onSelect.bind(this, option, menuIndex);
	    var expandProps = {
	      onClick: onSelect
	    };
	    var menuItemCls = prefixCls + '-menu-item';
	    var hasChildren = option.children && option.children.length > 0;
	    if (hasChildren || option.isLeaf === false) {
	      menuItemCls += ' ' + prefixCls + '-menu-item-expand';
	    }
	    if (expandTrigger === 'hover' && hasChildren) {
	      expandProps = {
	        onMouseEnter: this.delayOnSelect.bind(this, onSelect),
	        onMouseLeave: this.delayOnSelect.bind(this),
	        onClick: onSelect
	      };
	    }
	    if (this.isActiveOption(option, menuIndex)) {
	      menuItemCls += ' ' + prefixCls + '-menu-item-active';
	      expandProps.ref = this.saveMenuItem(menuIndex);
	    }
	    if (option.disabled) {
	      menuItemCls += ' ' + prefixCls + '-menu-item-disabled';
	    }
	    if (option.loading) {
	      menuItemCls += ' ' + prefixCls + '-menu-item-loading';
	    }
	    var title = '';
	    if (option.title) {
	      title = option.title;
	    } else if (typeof option.label === 'string') {
	      title = option.label;
	    }
	    return _react2['default'].createElement(
	      'li',
	      _extends({
	        key: option.value,
	        className: menuItemCls,
	        title: title
	      }, expandProps),
	      option.label
	    );
	  };
	
	  Menus.prototype.getActiveOptions = function getActiveOptions(values) {
	    var activeValue = values || this.props.activeValue;
	    var options = this.props.options;
	    return (0, _arrayTreeFilter2['default'])(options, function (o, level) {
	      return o.value === activeValue[level];
	    });
	  };
	
	  Menus.prototype.getShowOptions = function getShowOptions() {
	    var options = this.props.options;
	
	    var result = this.getActiveOptions().map(function (activeOption) {
	      return activeOption.children;
	    }).filter(function (activeOption) {
	      return !!activeOption;
	    });
	    result.unshift(options);
	    return result;
	  };
	
	  Menus.prototype.delayOnSelect = function delayOnSelect(onSelect) {
	    var _this2 = this;
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	    if (typeof onSelect === 'function') {
	      this.delayTimer = setTimeout(function () {
	        onSelect(args);
	        _this2.delayTimer = null;
	      }, 150);
	    }
	  };
	
	  Menus.prototype.scrollActiveItemToView = function scrollActiveItemToView() {
	    // scroll into view
	    var optionsLength = this.getShowOptions().length;
	    for (var i = 0; i < optionsLength; i++) {
	      var itemComponent = this.menuItems[i];
	      if (itemComponent) {
	        var target = (0, _reactDom.findDOMNode)(itemComponent);
	        target.parentNode.scrollTop = target.offsetTop;
	      }
	    }
	  };
	
	  Menus.prototype.isActiveOption = function isActiveOption(option, menuIndex) {
	    var _props$activeValue = this.props.activeValue,
	        activeValue = _props$activeValue === undefined ? [] : _props$activeValue;
	
	    return activeValue[menuIndex] === option.value;
	  };
	
	  Menus.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        dropdownMenuColumnStyle = _props2.dropdownMenuColumnStyle;
	
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getShowOptions().map(function (options, menuIndex) {
	        return _react2['default'].createElement(
	          'ul',
	          { className: prefixCls + '-menu', key: menuIndex, style: dropdownMenuColumnStyle },
	          options.map(function (option) {
	            return _this3.getOption(option, menuIndex);
	          })
	        );
	      })
	    );
	  };
	
	  return Menus;
	}(_react2['default'].Component);
	
	Menus.defaultProps = {
	  options: [],
	  value: [],
	  activeValue: [],
	  onSelect: function onSelect() {},
	
	  prefixCls: 'rc-cascader-menus',
	  visible: false,
	  expandTrigger: 'click'
	};
	
	Menus.propTypes = {
	  value: _propTypes2['default'].array,
	  activeValue: _propTypes2['default'].array,
	  options: _propTypes2['default'].array.isRequired,
	  prefixCls: _propTypes2['default'].string,
	  expandTrigger: _propTypes2['default'].string,
	  onSelect: _propTypes2['default'].func,
	  visible: _propTypes2['default'].bool,
	  dropdownMenuColumnStyle: _propTypes2['default'].object
	};
	
	exports['default'] = Menus;
	module.exports = exports['default'];

/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Cascader = __webpack_require__(2505);
	
	var _Cascader2 = _interopRequireDefault(_Cascader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Cascader2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 2508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRenderMixin = __webpack_require__(239);
	
	var _PureRenderMixin2 = _interopRequireDefault(_PureRenderMixin);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3['default'])(Checkbox, _React$Component);
	
	  function Checkbox(props) {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var checked = 'checked' in props ? props.checked : props.defaultChecked;
	
	    _this.state = {
	      checked: checked
	    };
	    return _this;
	  }
	
	  Checkbox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if ('checked' in nextProps) {
	      this.setState({
	        checked: nextProps.checked
	      });
	    }
	  };
	
	  Checkbox.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _PureRenderMixin2['default'].shouldComponentUpdate.apply(this, args);
	  };
	
	  Checkbox.prototype.focus = function focus() {
	    this.input.focus();
	  };
	
	  Checkbox.prototype.blur = function blur() {
	    this.input.blur();
	  };
	
	  Checkbox.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        className = _props.className,
	        style = _props.style,
	        name = _props.name,
	        type = _props.type,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        tabIndex = _props.tabIndex,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onBlur = _props.onBlur,
	        autoFocus = _props.autoFocus,
	        value = _props.value,
	        others = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'className', 'style', 'name', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);
	
	
	    var globalProps = Object.keys(others).reduce(function (prev, key) {
	      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
	        prev[key] = others[key];
	      }
	      return prev;
	    }, {});
	
	    var checked = this.state.checked;
	
	    var classString = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));
	
	    return _react2['default'].createElement(
	      'span',
	      { className: classString, style: style },
	      _react2['default'].createElement('input', (0, _extends3['default'])({
	        name: name,
	        type: type,
	        readOnly: readOnly,
	        disabled: disabled,
	        tabIndex: tabIndex,
	        className: prefixCls + '-input',
	        checked: !!checked,
	        onClick: onClick,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        onChange: this.handleChange,
	        autoFocus: autoFocus,
	        ref: this.saveInput,
	        value: value
	      }, globalProps)),
	      _react2['default'].createElement('span', { className: prefixCls + '-inner' })
	    );
	  };
	
	  return Checkbox;
	}(_react2['default'].Component);
	
	Checkbox.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  name: _propTypes2['default'].string,
	  type: _propTypes2['default'].string,
	  defaultChecked: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].bool]),
	  checked: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].bool]),
	  disabled: _propTypes2['default'].bool,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onClick: _propTypes2['default'].func,
	  tabIndex: _propTypes2['default'].string,
	  readOnly: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  value: _propTypes2['default'].any
	};
	Checkbox.defaultProps = {
	  prefixCls: 'rc-checkbox',
	  className: '',
	  style: {},
	  type: 'checkbox',
	  defaultChecked: false,
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {}
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleChange = function (e) {
	    var props = _this2.props;
	
	    if (props.disabled) {
	      return;
	    }
	    if (!('checked' in props)) {
	      _this2.setState({
	        checked: e.target.checked
	      });
	    }
	    props.onChange({
	      target: (0, _extends3['default'])({}, props, {
	        checked: e.target.checked
	      }),
	      stopPropagation: function stopPropagation() {
	        e.stopPropagation();
	      },
	      preventDefault: function preventDefault() {
	        e.preventDefault();
	      }
	    });
	  };
	
	  this.saveInput = function (node) {
	    _this2.input = node;
	  };
	};
	
	exports['default'] = Checkbox;
	module.exports = exports['default'];

/***/ },
/* 2509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Panel = __webpack_require__(2510);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _openAnimationFactory = __webpack_require__(2512);
	
	var _openAnimationFactory2 = _interopRequireDefault(_openAnimationFactory);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toArray(activeKey) {
	  var currentActiveKey = activeKey;
	  if (!Array.isArray(currentActiveKey)) {
	    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
	  }
	  return currentActiveKey;
	}
	
	var Collapse = function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    var _this$props = _this.props,
	        activeKey = _this$props.activeKey,
	        defaultActiveKey = _this$props.defaultActiveKey;
	
	    var currentActiveKey = defaultActiveKey;
	    if ('activeKey' in _this.props) {
	      currentActiveKey = activeKey;
	    }
	
	    _this.state = {
	      openAnimation: _this.props.openAnimation || (0, _openAnimationFactory2['default'])(_this.props.prefixCls),
	      activeKey: toArray(currentActiveKey)
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('activeKey' in nextProps) {
	        this.setState({
	          activeKey: toArray(nextProps.activeKey)
	        });
	      }
	      if ('openAnimation' in nextProps) {
	        this.setState({
	          openAnimation: nextProps.openAnimation
	        });
	      }
	    }
	  }, {
	    key: 'onClickItem',
	    value: function onClickItem(key) {
	      var activeKey = this.state.activeKey;
	      if (this.props.accordion) {
	        activeKey = activeKey[0] === key ? [] : [key];
	      } else {
	        activeKey = [].concat(_toConsumableArray(activeKey));
	        var index = activeKey.indexOf(key);
	        var isActive = index > -1;
	        if (isActive) {
	          // remove active state
	          activeKey.splice(index, 1);
	        } else {
	          activeKey.push(key);
	        }
	      }
	      this.setActiveKey(activeKey);
	    }
	  }, {
	    key: 'getItems',
	    value: function getItems() {
	      var _this2 = this;
	
	      var activeKey = this.state.activeKey;
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          accordion = _props.accordion,
	          destroyInactivePanel = _props.destroyInactivePanel;
	
	      var newChildren = [];
	
	      _react.Children.forEach(this.props.children, function (child, index) {
	        if (!child) return;
	        // If there is no key provide, use the panel order as default key
	        var key = child.key || String(index);
	        var _child$props = child.props,
	            header = _child$props.header,
	            headerClass = _child$props.headerClass,
	            disabled = _child$props.disabled;
	
	        var isActive = false;
	        if (accordion) {
	          isActive = activeKey[0] === key;
	        } else {
	          isActive = activeKey.indexOf(key) > -1;
	        }
	
	        var props = {
	          key: key,
	          header: header,
	          headerClass: headerClass,
	          isActive: isActive,
	          prefixCls: prefixCls,
	          destroyInactivePanel: destroyInactivePanel,
	          openAnimation: _this2.state.openAnimation,
	          children: child.props.children,
	          onItemClick: disabled ? null : function () {
	            return _this2.onClickItem(key);
	          }
	        };
	
	        newChildren.push(_react2['default'].cloneElement(child, props));
	      });
	
	      return newChildren;
	    }
	  }, {
	    key: 'setActiveKey',
	    value: function setActiveKey(activeKey) {
	      if (!('activeKey' in this.props)) {
	        this.setState({ activeKey: activeKey });
	      }
	      this.props.onChange(this.props.accordion ? activeKey[0] : activeKey);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          className = _props2.className,
	          style = _props2.style;
	
	      var collapseClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
	      return _react2['default'].createElement(
	        'div',
	        { className: collapseClassName, style: style },
	        this.getItems()
	      );
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	Collapse.propTypes = {
	  children: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  activeKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  defaultActiveKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  openAnimation: _propTypes2['default'].object,
	  onChange: _propTypes2['default'].func,
	  accordion: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool
	};
	
	Collapse.defaultProps = {
	  prefixCls: 'rc-collapse',
	  onChange: function onChange() {},
	
	  accordion: false,
	  destroyInactivePanel: false
	};
	
	Collapse.Panel = _Panel2['default'];
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PanelContent = __webpack_require__(2511);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsePanel = function (_Component) {
	  _inherits(CollapsePanel, _Component);
	
	  function CollapsePanel() {
	    _classCallCheck(this, CollapsePanel);
	
	    return _possibleConstructorReturn(this, (CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).apply(this, arguments));
	  }
	
	  _createClass(CollapsePanel, [{
	    key: 'handleItemClick',
	    value: function handleItemClick() {
	      if (this.props.onItemClick) {
	        this.props.onItemClick();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames2;
	
	      var _props = this.props,
	          className = _props.className,
	          id = _props.id,
	          style = _props.style,
	          prefixCls = _props.prefixCls,
	          header = _props.header,
	          headerClass = _props.headerClass,
	          children = _props.children,
	          isActive = _props.isActive,
	          showArrow = _props.showArrow,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          disabled = _props.disabled;
	
	      var headerCls = (0, _classnames2['default'])(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
	      var itemCls = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
	      return _react2['default'].createElement(
	        'div',
	        { className: itemCls, style: style, id: id, role: 'tablist' },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: headerCls,
	            onClick: this.handleItemClick.bind(this),
	            role: 'tab',
	            'aria-expanded': isActive
	          },
	          showArrow && _react2['default'].createElement('i', { className: 'arrow' }),
	          header
	        ),
	        _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            showProp: 'isActive',
	            exclusive: true,
	            component: '',
	            animation: this.props.openAnimation
	          },
	          _react2['default'].createElement(
	            _PanelContent2['default'],
	            {
	              prefixCls: prefixCls,
	              isActive: isActive,
	              destroyInactivePanel: destroyInactivePanel
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(_react.Component);
	
	CollapsePanel.propTypes = {
	  className: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  id: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  openAnimation: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  header: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].node]),
	  headerClass: _propTypes2['default'].string,
	  showArrow: _propTypes2['default'].bool,
	  isActive: _propTypes2['default'].bool,
	  onItemClick: _propTypes2['default'].func,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool
	};
	
	CollapsePanel.defaultProps = {
	  showArrow: true,
	  isActive: false,
	  destroyInactivePanel: false,
	  onItemClick: function onItemClick() {},
	
	  headerClass: ''
	};
	
	exports['default'] = CollapsePanel;
	module.exports = exports['default'];

/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PanelContent = function (_Component) {
	  _inherits(PanelContent, _Component);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	  }
	
	  _createClass(PanelContent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.isActive || nextProps.isActive;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      this._isActived = this._isActived || this.props.isActive;
	      if (!this._isActived) {
	        return null;
	      }
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          isActive = _props.isActive,
	          children = _props.children,
	          destroyInactivePanel = _props.destroyInactivePanel;
	
	      var contentCls = (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
	      var child = !isActive && destroyInactivePanel ? null : _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-content-box' },
	        children
	      );
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: contentCls,
	          role: 'tabpanel'
	        },
	        child
	      );
	    }
	  }]);
	
	  return PanelContent;
	}(_react.Component);
	
	PanelContent.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  isActive: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any,
	  destroyInactivePanel: _propTypes2['default'].bool
	};
	
	exports['default'] = PanelContent;
	module.exports = exports['default'];

/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cssAnimation = __webpack_require__(419);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function animate(node, show, transitionName, done) {
	  var height = void 0;
	  return (0, _cssAnimation2['default'])(node, transitionName, {
	    start: function start() {
	      if (!show) {
	        node.style.height = node.offsetHeight + 'px';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = 0;
	      }
	    },
	    active: function active() {
	      node.style.height = (show ? height : 0) + 'px';
	    },
	    end: function end() {
	      node.style.height = '';
	      done();
	    }
	  });
	}
	
	function animation(prefixCls) {
	  return {
	    enter: function enter(node, done) {
	      return animate(node, true, prefixCls + '-anim', done);
	    },
	    leave: function leave(node, done) {
	      return animate(node, false, prefixCls + '-anim', done);
	    }
	  };
	}
	
	exports['default'] = animation;
	module.exports = exports['default'];

/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _LazyRenderBox = __webpack_require__(2515);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _getScrollBarSize = __webpack_require__(2638);
	
	var _getScrollBarSize2 = _interopRequireDefault(_getScrollBarSize);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var uuid = 0;
	var openCount = 0;
	/* eslint react/no-is-mounted:0 */
	function getScroll(w, top) {
	    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	    var method = 'scroll' + (top ? 'Top' : 'Left');
	    if (typeof ret !== 'number') {
	        var d = w.document;
	        ret = d.documentElement[method];
	        if (typeof ret !== 'number') {
	            ret = d.body[method];
	        }
	    }
	    return ret;
	}
	function setTransformOrigin(node, value) {
	    var style = node.style;
	    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
	        style[prefix + 'TransformOrigin'] = value;
	    });
	    style['transformOrigin'] = value;
	}
	function offset(el) {
	    var rect = el.getBoundingClientRect();
	    var pos = {
	        left: rect.left,
	        top: rect.top
	    };
	    var doc = el.ownerDocument;
	    var w = doc.defaultView || doc.parentWindow;
	    pos.left += getScroll(w);
	    pos.top += getScroll(w, true);
	    return pos;
	}
	
	var Dialog = function (_React$Component) {
	    (0, _inherits3['default'])(Dialog, _React$Component);
	
	    function Dialog() {
	        (0, _classCallCheck3['default'])(this, Dialog);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	
	        _this.onAnimateLeave = function () {
	            var afterClose = _this.props.afterClose;
	            // need demo?
	            // https://github.com/react-component/dialog/pull/28
	
	            if (_this.wrap) {
	                _this.wrap.style.display = 'none';
	            }
	            _this.inTransition = false;
	            _this.removeScrollingEffect();
	            if (afterClose) {
	                afterClose();
	            }
	        };
	        _this.onMaskClick = function (e) {
	            // android trigger click on open (fastclick??)
	            if (Date.now() - _this.openTime < 300) {
	                return;
	            }
	            if (e.target === e.currentTarget) {
	                _this.close(e);
	            }
	        };
	        _this.onKeyDown = function (e) {
	            var props = _this.props;
	            if (props.keyboard && e.keyCode === _KeyCode2['default'].ESC) {
	                _this.close(e);
	            }
	            // keep focus inside dialog
	            if (props.visible) {
	                if (e.keyCode === _KeyCode2['default'].TAB) {
	                    var activeElement = document.activeElement;
	                    var dialogRoot = _this.wrap;
	                    if (e.shiftKey) {
	                        if (activeElement === dialogRoot) {
	                            _this.sentinel.focus();
	                        }
	                    } else if (activeElement === _this.sentinel) {
	                        dialogRoot.focus();
	                    }
	                }
	            }
	        };
	        _this.getDialogElement = function () {
	            var props = _this.props;
	            var closable = props.closable;
	            var prefixCls = props.prefixCls;
	            var dest = {};
	            if (props.width !== undefined) {
	                dest.width = props.width;
	            }
	            if (props.height !== undefined) {
	                dest.height = props.height;
	            }
	            var footer = void 0;
	            if (props.footer) {
	                footer = _react2['default'].createElement("div", { className: prefixCls + '-footer', ref: "footer" }, props.footer);
	            }
	            var header = void 0;
	            if (props.title) {
	                header = _react2['default'].createElement("div", { className: prefixCls + '-header', ref: "header" }, _react2['default'].createElement("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
	            }
	            var closer = void 0;
	            if (closable) {
	                closer = _react2['default'].createElement("button", { onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, _react2['default'].createElement("span", { className: prefixCls + '-close-x' }));
	            }
	            var style = (0, _objectAssign2['default'])({}, props.style, dest);
	            var transitionName = _this.getTransitionName();
	            var dialogElement = _react2['default'].createElement(_LazyRenderBox2['default'], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible }, _react2['default'].createElement("div", { className: prefixCls + '-content' }, closer, header, _react2['default'].createElement("div", (0, _extends3['default'])({ className: prefixCls + '-body', style: props.bodyStyle, ref: "body" }, props.bodyProps), props.children), footer), _react2['default'].createElement("div", { tabIndex: 0, ref: _this.saveRef('sentinel'), style: { width: 0, height: 0, overflow: 'hidden' } }, "sentinel"));
	            return _react2['default'].createElement(_rcAnimate2['default'], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
	        };
	        _this.getZIndexStyle = function () {
	            var style = {};
	            var props = _this.props;
	            if (props.zIndex !== undefined) {
	                style.zIndex = props.zIndex;
	            }
	            return style;
	        };
	        _this.getWrapStyle = function () {
	            return (0, _objectAssign2['default'])({}, _this.getZIndexStyle(), _this.props.wrapStyle);
	        };
	        _this.getMaskStyle = function () {
	            return (0, _objectAssign2['default'])({}, _this.getZIndexStyle(), _this.props.maskStyle);
	        };
	        _this.getMaskElement = function () {
	            var props = _this.props;
	            var maskElement = void 0;
	            if (props.mask) {
	                var maskTransition = _this.getMaskTransitionName();
	                maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], (0, _extends3['default'])({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
	                if (maskTransition) {
	                    maskElement = _react2['default'].createElement(_rcAnimate2['default'], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
	                }
	            }
	            return maskElement;
	        };
	        _this.getMaskTransitionName = function () {
	            var props = _this.props;
	            var transitionName = props.maskTransitionName;
	            var animation = props.maskAnimation;
	            if (!transitionName && animation) {
	                transitionName = props.prefixCls + '-' + animation;
	            }
	            return transitionName;
	        };
	        _this.getTransitionName = function () {
	            var props = _this.props;
	            var transitionName = props.transitionName;
	            var animation = props.animation;
	            if (!transitionName && animation) {
	                transitionName = props.prefixCls + '-' + animation;
	            }
	            return transitionName;
	        };
	        _this.setScrollbar = function () {
	            if (_this.bodyIsOverflowing && _this.scrollbarWidth !== undefined) {
	                document.body.style.paddingRight = _this.scrollbarWidth + 'px';
	            }
	        };
	        _this.addScrollingEffect = function () {
	            openCount++;
	            if (openCount !== 1) {
	                return;
	            }
	            _this.checkScrollbar();
	            _this.setScrollbar();
	            document.body.style.overflow = 'hidden';
	            // this.adjustDialog();
	        };
	        _this.removeScrollingEffect = function () {
	            openCount--;
	            if (openCount !== 0) {
	                return;
	            }
	            document.body.style.overflow = '';
	            _this.resetScrollbar();
	            // this.resetAdjustments();
	        };
	        _this.close = function (e) {
	            var onClose = _this.props.onClose;
	
	            if (onClose) {
	                onClose(e);
	            }
	        };
	        _this.checkScrollbar = function () {
	            var fullWindowWidth = window.innerWidth;
	            if (!fullWindowWidth) {
	                var documentElementRect = document.documentElement.getBoundingClientRect();
	                fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left);
	            }
	            _this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth;
	            if (_this.bodyIsOverflowing) {
	                _this.scrollbarWidth = (0, _getScrollBarSize2['default'])();
	            }
	        };
	        _this.resetScrollbar = function () {
	            document.body.style.paddingRight = '';
	        };
	        _this.adjustDialog = function () {
	            if (_this.wrap && _this.scrollbarWidth !== undefined) {
	                var modalIsOverflowing = _this.wrap.scrollHeight > document.documentElement.clientHeight;
	                _this.wrap.style.paddingLeft = (!_this.bodyIsOverflowing && modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
	                _this.wrap.style.paddingRight = (_this.bodyIsOverflowing && !modalIsOverflowing ? _this.scrollbarWidth : '') + 'px';
	            }
	        };
	        _this.resetAdjustments = function () {
	            if (_this.wrap) {
	                _this.wrap.style.paddingLeft = _this.wrap.style.paddingLeft = '';
	            }
	        };
	        _this.saveRef = function (name) {
	            return function (node) {
	                _this[name] = node;
	            };
	        };
	        return _this;
	    }
	
	    Dialog.prototype.componentWillMount = function componentWillMount() {
	        this.inTransition = false;
	        this.titleId = 'rcDialogTitle' + uuid++;
	    };
	
	    Dialog.prototype.componentDidMount = function componentDidMount() {
	        this.componentDidUpdate({});
	    };
	
	    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        var props = this.props;
	        var mousePosition = this.props.mousePosition;
	        if (props.visible) {
	            // first show
	            if (!prevProps.visible) {
	                this.openTime = Date.now();
	                this.lastOutSideFocusNode = document.activeElement;
	                this.addScrollingEffect();
	                this.wrap.focus();
	                var dialogNode = _reactDom2['default'].findDOMNode(this.dialog);
	                if (mousePosition) {
	                    var elOffset = offset(dialogNode);
	                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
	                } else {
	                    setTransformOrigin(dialogNode, '');
	                }
	            }
	        } else if (prevProps.visible) {
	            this.inTransition = true;
	            if (props.mask && this.lastOutSideFocusNode) {
	                try {
	                    this.lastOutSideFocusNode.focus();
	                } catch (e) {
	                    this.lastOutSideFocusNode = null;
	                }
	                this.lastOutSideFocusNode = null;
	            }
	        }
	    };
	
	    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.props.visible || this.inTransition) {
	            this.removeScrollingEffect();
	        }
	    };
	
	    Dialog.prototype.render = function render() {
	        var props = this.props;
	        var prefixCls = props.prefixCls,
	            maskClosable = props.maskClosable;
	
	        var style = this.getWrapStyle();
	        // clear hide display
	        // and only set display after async anim, not here for hide
	        if (props.visible) {
	            style.display = null;
	        }
	        return _react2['default'].createElement("div", null, this.getMaskElement(), _react2['default'].createElement("div", (0, _extends3['default'])({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : undefined, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
	    };
	
	    return Dialog;
	}(_react2['default'].Component);
	
	exports['default'] = Dialog;
	
	Dialog.defaultProps = {
	    className: '',
	    mask: true,
	    visible: false,
	    keyboard: true,
	    closable: true,
	    maskClosable: true,
	    destroyOnClose: false,
	    prefixCls: 'rc-dialog'
	};
	module.exports = exports['default'];

/***/ },
/* 2514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Dialog = __webpack_require__(2513);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _getContainerRenderMixin = __webpack_require__(1198);
	
	var _getContainerRenderMixin2 = _interopRequireDefault(_getContainerRenderMixin);
	
	var _Portal = __webpack_require__(1197);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var IS_REACT_16 = !!_reactDom2['default'].createPortal;
	var mixins = [];
	if (!IS_REACT_16) {
	    mixins.push((0, _getContainerRenderMixin2['default'])({
	        isVisible: function isVisible(instance) {
	            return instance.props.visible;
	        },
	
	        autoDestroy: false,
	        getContainer: function getContainer(instance) {
	            return instance.getContainer();
	        }
	    }));
	}
	;
	var DialogWrap = (0, _createReactClass2['default'])({
	    displayName: 'DialogWrap',
	    mixins: mixins,
	    getDefaultProps: function getDefaultProps() {
	        return {
	            visible: false
	        };
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(_ref) {
	        var visible = _ref.visible;
	
	        return !!(this.props.visible || visible);
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (IS_REACT_16) {
	            return;
	        }
	        if (this.props.visible) {
	            this.renderComponent({
	                afterClose: this.removeContainer,
	                onClose: function onClose() {},
	
	                visible: false
	            });
	        } else {
	            this.removeContainer();
	        }
	    },
	    saveDialog: function saveDialog(node) {
	        this._component = node;
	    },
	    getComponent: function getComponent(extra) {
	        return _react2['default'].createElement(_Dialog2['default'], (0, _extends3['default'])({ ref: this.saveDialog }, this.props, extra, { key: "dialog" }));
	    },
	    getContainer: function getContainer() {
	        if (this.props.getContainer) {
	            return this.props.getContainer();
	        }
	        var container = document.createElement('div');
	        document.body.appendChild(container);
	        return container;
	    },
	    render: function render() {
	        var visible = this.props.visible;
	
	        var portal = null;
	        if (!IS_REACT_16) {
	            return portal;
	        }
	        if (visible || this._component) {
	            portal = _react2['default'].createElement(_Portal2['default'], { getContainer: this.getContainer }, this.getComponent());
	        }
	        return portal;
	    }
	});
	exports['default'] = DialogWrap;
	module.exports = exports['default'];

/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_React$Component) {
	    (0, _inherits3['default'])(LazyRenderBox, _React$Component);
	
	    function LazyRenderBox() {
	        (0, _classCallCheck3['default'])(this, LazyRenderBox);
	        return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	    }
	
	    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !!nextProps.hiddenClassName || !!nextProps.visible;
	    };
	
	    LazyRenderBox.prototype.render = function render() {
	        var className = this.props.className;
	        if (!!this.props.hiddenClassName && !this.props.visible) {
	            className += ' ' + this.props.hiddenClassName;
	        }
	        var props = (0, _objectAssign2['default'])({}, this.props);
	        delete props.hiddenClassName;
	        delete props.visible;
	        props.className = className;
	        return _react2['default'].createElement("div", (0, _extends3['default'])({}, props));
	    };
	
	    return LazyRenderBox;
	}(_react2['default'].Component);
	
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(2518);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    if ('visible' in props) {
	      _this.state = {
	        visible: props.visible
	      };
	    } else {
	      _this.state = {
	        visible: props.defaultVisible
	      };
	    }
	    return _this;
	  }
	
	  Dropdown.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var visible = _ref.visible;
	
	    if (visible !== undefined) {
	      this.setState({
	        visible: visible
	      });
	    }
	  };
	
	  Dropdown.prototype.getMenuElement = function getMenuElement() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls;
	
	    var extraOverlayProps = {
	      prefixCls: prefixCls + '-menu',
	      onClick: this.onClick
	    };
	    if (typeof overlay.type === 'string') {
	      delete extraOverlayProps.prefixCls;
	    }
	    return _react2['default'].cloneElement(overlay, extraOverlayProps);
	  };
	
	  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        children = _props2.children,
	        transitionName = _props2.transitionName,
	        animation = _props2.animation,
	        align = _props2.align,
	        placement = _props2.placement,
	        getPopupContainer = _props2.getPopupContainer,
	        showAction = _props2.showAction,
	        hideAction = _props2.hideAction,
	        overlayClassName = _props2.overlayClassName,
	        overlayStyle = _props2.overlayStyle,
	        trigger = _props2.trigger,
	        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'children', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);
	
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      _extends({}, otherProps, {
	        prefixCls: prefixCls,
	        ref: this.saveTrigger,
	        popupClassName: overlayClassName,
	        popupStyle: overlayStyle,
	        builtinPlacements: _placements2['default'],
	        action: trigger,
	        showAction: showAction,
	        hideAction: hideAction,
	        popupPlacement: placement,
	        popupAlign: align,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        popupVisible: this.state.visible,
	        afterPopupVisibleChange: this.afterVisibleChange,
	        popup: this.getMenuElement(),
	        onPopupVisibleChange: this.onVisibleChange,
	        getPopupContainer: getPopupContainer
	      }),
	      children
	    );
	  };
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  minOverlayWidthMatchTrigger: _propTypes2['default'].bool,
	  onVisibleChange: _propTypes2['default'].func,
	  onOverlayClick: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].string,
	  overlayClassName: _propTypes2['default'].string,
	  animation: _propTypes2['default'].any,
	  align: _propTypes2['default'].object,
	  overlayStyle: _propTypes2['default'].object,
	  placement: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].node,
	  trigger: _propTypes2['default'].array,
	  showAction: _propTypes2['default'].array,
	  hideAction: _propTypes2['default'].array,
	  getPopupContainer: _propTypes2['default'].func,
	  visible: _propTypes2['default'].bool,
	  defaultVisible: _propTypes2['default'].bool
	};
	Dropdown.defaultProps = {
	  minOverlayWidthMatchTrigger: true,
	  prefixCls: 'rc-dropdown',
	  trigger: ['hover'],
	  showAction: [],
	  hideAction: [],
	  overlayClassName: '',
	  overlayStyle: {},
	  defaultVisible: false,
	  onVisibleChange: function onVisibleChange() {},
	
	  placement: 'bottomLeft'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClick = function (e) {
	    var props = _this2.props;
	    var overlayProps = props.overlay.props;
	    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
	    if (!('visible' in props)) {
	      _this2.setState({
	        visible: false
	      });
	    }
	    if (props.onOverlayClick) {
	      props.onOverlayClick(e);
	    }
	    if (overlayProps.onClick) {
	      overlayProps.onClick(e);
	    }
	  };
	
	  this.onVisibleChange = function (visible) {
	    var props = _this2.props;
	    if (!('visible' in props)) {
	      _this2.setState({
	        visible: visible
	      });
	    }
	    props.onVisibleChange(visible);
	  };
	
	  this.afterVisibleChange = function (visible) {
	    if (visible && _this2.props.minOverlayWidthMatchTrigger) {
	      var overlayNode = _this2.getPopupDomNode();
	      var rootNode = _reactDom2['default'].findDOMNode(_this2);
	      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
	        overlayNode.style.width = rootNode.offsetWidth + 'px';
	        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
	          _this2.trigger._component.alignInstance.forceAlign();
	        }
	      }
	    }
	  };
	
	  this.saveTrigger = function (node) {
	    _this2.trigger = node;
	  };
	};
	
	exports['default'] = Dropdown;
	module.exports = exports['default'];

/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dropdown = __webpack_require__(2516);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Dropdown2['default'];
	module.exports = exports['default'];

/***/ },
/* 2518 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  topCenter: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  bottomCenter: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(35);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfigStore = function () {
	    function ConfigStore() {
	        _classCallCheck(this, ConfigStore);
	
	        this._store = (0, _immutable.Map)();
	    }
	
	    ConfigStore.prototype.set = function set(key, value) {
	        this._store = this._store.set(key, value);
	    };
	
	    ConfigStore.prototype.get = function get(key) {
	        return this._store.get(key);
	    };
	
	    return ConfigStore;
	}();
	
	exports['default'] = ConfigStore;
	module.exports = exports['default'];

/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = customHTML2Content;
	
	var _draftJs = __webpack_require__(124);
	
	var _toArray = __webpack_require__(2450);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _immutable = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function compose() {
	    for (var _len = arguments.length, argument = Array(_len), _key = 0; _key < _len; _key++) {
	        argument[_key] = arguments[_key];
	    }
	
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start;
	        var result = args[start].apply(this, arguments);
	        while (i--) {
	            result = args[i].call(this, result);
	        }return result;
	    };
	}
	;
	/*
	 * Helpers
	 */
	// Prepares img meta data object based on img attributes
	var getBlockSpecForElement = function getBlockSpecForElement(imgElement) {
	    return {
	        contentType: 'image',
	        src: imgElement.getAttribute('src'),
	        width: imgElement.getAttribute('width'),
	        height: imgElement.getAttribute('height'),
	        align: imgElement.style.cssFloat
	    };
	};
	// Wraps meta data in HTML element which is 'understandable' by Draft, I used <blockquote />.
	var wrapBlockSpec = function wrapBlockSpec(blockSpec) {
	    if (blockSpec == null) {
	        return null;
	    }
	    var tempEl = document.createElement('blockquote');
	    // stringify meta data and insert it as text content of temp HTML element. We will later extract
	    // and parse it.
	    tempEl.innerText = JSON.stringify(blockSpec);
	    return tempEl;
	};
	// Replaces <img> element with our temp element
	var replaceElement = function replaceElement(oldEl, newEl) {
	    if (!(newEl instanceof HTMLElement)) {
	        return;
	    }
	    var parentNode = oldEl.parentNode;
	    return parentNode.replaceChild(newEl, oldEl);
	};
	var elementToBlockSpecElement = compose(wrapBlockSpec, getBlockSpecForElement);
	var imgReplacer = function imgReplacer(imgElement) {
	    return replaceElement(imgElement, elementToBlockSpecElement(imgElement));
	};
	// creates ContentBlock based on provided spec
	var createContentBlock = function createContentBlock(blockData, contentState) {
	    var key = blockData.key,
	        type = blockData.type,
	        text = blockData.text,
	        data = blockData.data,
	        inlineStyles = blockData.inlineStyles,
	        entityData = blockData.entityData;
	
	    var blockSpec = {
	        type: type != null ? type : 'unstyled',
	        text: text != null ? text : '',
	        key: key != null ? key : (0, _draftJs.genKey)(),
	        data: null,
	        characterList: (0, _immutable.List)([])
	    };
	    if (data) {
	        blockSpec.data = (0, _immutable.fromJS)(data);
	    }
	    if (inlineStyles || entityData) {
	        var entityKey = void 0;
	        if (entityData) {
	            var _type = entityData.type,
	                mutability = entityData.mutability,
	                _data = entityData.data;
	
	            contentState.createEntity(_type, mutability, _data);
	            entityKey = contentState.getLastCreatedEntityKey();
	        } else {
	            entityKey = null;
	        }
	        var style = (0, _immutable.OrderedSet)(inlineStyles || []);
	        var charData = _draftJs.CharacterMetadata.create({ style: style, entityKey: entityKey });
	        blockSpec.characterList = (0, _immutable.List)((0, _immutable.Repeat)(charData, text.length));
	    }
	    return new _draftJs.ContentBlock(blockSpec);
	};
	// takes HTML string and returns DraftJS ContentState
	function customHTML2Content(HTML, contentState) {
	    var tempDoc = new DOMParser().parseFromString(HTML, 'text/html');
	    // replace all <img /> with <blockquote /> elements
	    (0, _toArray2['default'])(tempDoc.querySelectorAll('img')).forEach(imgReplacer);
	    // use DraftJS converter to do initial conversion. I don't provide DOMBuilder and
	    // blockRenderMap arguments here since it should fall back to its default ones, which are fine
	
	    var _convertFromHTML = (0, _draftJs.convertFromHTML)(tempDoc.body.innerHTML),
	        contentBlocks = _convertFromHTML.contentBlocks;
	    // now replace <blockquote /> ContentBlocks with 'atomic' ones
	
	
	    contentBlocks = contentBlocks.reduce(function (contentBlocks, block) {
	        if (block.getType() !== 'blockquote') {
	            return contentBlocks.concat(block);
	        }
	        var image = JSON.parse(block.getText());
	        contentState.createEntity('IMAGE-ENTITY', 'IMMUTABLE', image);
	        var entityKey = contentState.getLastCreatedEntityKey();
	        var charData = _draftJs.CharacterMetadata.create({ entity: entityKey });
	        // const blockSpec = Object.assign({ type: 'atomic', text: ' ' }, { entityData })
	        // const atomicBlock = createContentBlock(blockSpec)
	        // const spacerBlock = createContentBlock({});
	        var fragmentArray = [new _draftJs.ContentBlock({
	            key: (0, _draftJs.genKey)(),
	            type: 'image-block',
	            text: ' ',
	            characterList: (0, _immutable.List)((0, _immutable.Repeat)(charData, charData.count()))
	        }), new _draftJs.ContentBlock({
	            key: (0, _draftJs.genKey)(),
	            type: 'unstyled',
	            text: '',
	            characterList: (0, _immutable.List)()
	        })];
	        return contentBlocks.concat(fragmentArray);
	    }, []);
	    // console.log('>> customHTML2Content contentBlocks', contentBlocks);
	    tempDoc = null;
	    return _draftJs.BlockMapBuilder.createFromArray(contentBlocks);
	}
	module.exports = exports['default'];

/***/ },
/* 2521 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.encodeContent = encodeContent;
	exports.decodeContent = decodeContent;
	exports['default'] = exportText;
	function encodeContent(text) {
	    return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br />' + '\n');
	}
	function decodeContent(text) {
	    return text.split('<br />' + '\n').join('\n');
	}
	function exportText(editorState) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { encode: false };
	
	    var content = editorState.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var encode = options.encode;
	
	    return blockMap.map(function (block) {
	        var resultText = '';
	        var lastPosition = 0;
	        var text = block.getText();
	        block.findEntityRanges(function (character) {
	            return !!character.getEntity();
	        }, function (start, end) {
	            var key = block.getEntityAt(start);
	            var entityData = content.getEntity(key).getData();
	            resultText += text.slice(lastPosition, start);
	            resultText += entityData && entityData['export'] ? entityData['export'](entityData) : text.slice(start, end);
	            lastPosition = end;
	        });
	        resultText += text.slice(lastPosition);
	        return encode ? encodeContent(resultText) : resultText;
	    }).join(encode ? '<br />\n' : '\n');
	}

/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_INLINE_STYLE = exports.DEFAULT_ELEMENT = exports.EMPTY_SET = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = GetHTML;
	
	var _draftJs = __webpack_require__(124);
	
	var _immutable = __webpack_require__(35);
	
	var _isUnitlessNumber = __webpack_require__(2523);
	
	var _isUnitlessNumber2 = _interopRequireDefault(_isUnitlessNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var EMPTY_SET = exports.EMPTY_SET = (0, _immutable.OrderedSet)();
	var DEFAULT_ELEMENT = exports.DEFAULT_ELEMENT = 'span';
	var DEFAULT_INLINE_STYLE = exports.DEFAULT_INLINE_STYLE = _draftJs.DefaultDraftInlineStyle;
	function encodeContent(text) {
	    return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br >' + '\n');
	}
	function encodeAttr(text) {
	    return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
	}
	var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;
	var NUMERIC_STRING = /^\d+$/;
	var UPPERCASE_PATTERN = /([A-Z])/g;
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
	function processStyleName(name) {
	    return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
	}
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
	function processStyleValue(name, value) {
	    var isNumeric = void 0;
	    if (typeof value === 'string') {
	        isNumeric = NUMERIC_STRING.test(value);
	    } else {
	        isNumeric = true;
	        value = String(value);
	    }
	    if (!isNumeric || value === '0' || _isUnitlessNumber2['default'][name] === true) {
	        return value;
	    } else {
	        return value + 'px';
	    }
	}
	function getStyleText(styleObject) {
	    if (!styleObject) {
	        return '';
	    }
	    return Object.keys(styleObject).map(function (name) {
	        var styleName = processStyleName(name);
	        var styleValue = processStyleValue(name, styleObject[name]);
	        return styleName + ':' + styleValue;
	    }).join(';');
	}
	function getEntityContent(contentState, entityKey, content) {
	    if (entityKey) {
	        var entity = contentState.getEntity(entityKey);
	        var entityData = entity.getData();
	        if (entityData && entityData['export']) {
	            return entityData['export'](content, entityData);
	        }
	    }
	    return content;
	}
	function GetHTML(configStore) {
	    return function exportHtml(editorState) {
	        var contentState = editorState.getCurrentContent();
	        var blockMap = contentState.getBlockMap();
	        var customStyleMap = configStore.get('customStyleMap') || {};
	        var customBlockRenderMap = configStore.get('blockRenderMap') || {};
	        var customStyleFn = configStore.get('customStyleFn');
	        var toHTMLList = configStore.get('toHTMLList');
	        _extends(customStyleMap, DEFAULT_INLINE_STYLE);
	        return blockMap.map(function (block) {
	            var resultText = '<div>';
	            var closeTag = '</div>';
	            var lastPosition = 0;
	            var text = block.getText();
	            var blockType = block.getType();
	            var blockRender = customBlockRenderMap.get(blockType);
	            if (blockRender) {
	                var element = typeof blockRender.element === 'function' ? blockRender.elementTag || 'div' : 'div';
	                resultText = '<' + (element || 'div') + ' style="' + getStyleText(customBlockRenderMap.get(blockType).style || {}) + '">';
	                closeTag = '</' + (element || 'div') + '>';
	            }
	            var charMetaList = block.getCharacterList();
	            var charEntity = null;
	            var prevCharEntity = null;
	            var ranges = [];
	            var rangeStart = 0;
	            for (var i = 0, len = text.length; i < len; i++) {
	                prevCharEntity = charEntity;
	                var meta = charMetaList.get(i);
	                charEntity = meta ? meta.getEntity() : null;
	                if (i > 0 && charEntity !== prevCharEntity) {
	                    ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
	                    rangeStart = i;
	                }
	            }
	            ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
	            ranges.map(function (_ref) {
	                var entityKey = _ref[0],
	                    stylePieces = _ref[1];
	
	                var element = DEFAULT_ELEMENT;
	                var rawContent = stylePieces.map(function (_ref2) {
	                    var text = _ref2[0];
	                    return text;
	                }).join('');
	                var content = stylePieces.map(function (_ref3) {
	                    var text = _ref3[0],
	                        styleSet = _ref3[1];
	
	                    var encodedContent = encodeContent(text);
	                    if (styleSet.size) {
	                        var inlineStyle = {};
	                        styleSet.forEach(function (item) {
	                            if (customStyleMap.hasOwnProperty(item)) {
	                                var currentStyle = customStyleMap[item];
	                                inlineStyle = _extends(inlineStyle, currentStyle);
	                            }
	                        });
	                        var customedStyle = customStyleFn(styleSet);
	                        inlineStyle = _extends(inlineStyle, customedStyle);
	                        return '<span style="' + getStyleText(inlineStyle) + '">' + encodedContent + '</span>';
	                    }
	                    return '<span>' + encodedContent + '</span>';
	                }).join('');
	                if (entityKey) {
	                    var entity = contentState.getEntity(entityKey);
	                    var entityData = entity.getData();
	                    if (entityData && entityData['export']) {
	                        resultText += entityData['export'](content, entityData);
	                    } else {
	                        var HTMLText = '';
	                        toHTMLList.forEach(function (toHTML) {
	                            var text = toHTML(rawContent, entity, contentState);
	                            if (text) {
	                                HTMLText = text;
	                            }
	                        });
	                        if (HTMLText) {
	                            resultText += HTMLText;
	                        }
	                    }
	                } else {
	                    resultText += content;
	                }
	            });
	            resultText += closeTag;
	            return resultText;
	        }).join('\n');
	    };
	}
	function getStyleRanges(text, charMetaList) {
	    var charStyle = EMPTY_SET;
	    var prevCharStyle = EMPTY_SET;
	    var ranges = [];
	    var rangeStart = 0;
	    for (var i = 0, len = text.length; i < len; i++) {
	        prevCharStyle = charStyle;
	        var meta = charMetaList.get(i);
	        charStyle = meta ? meta.getStyle() : EMPTY_SET;
	        if (i > 0 && !(0, _immutable.is)(charStyle, prevCharStyle)) {
	            ranges.push([text.slice(rangeStart, i), prevCharStyle]);
	            rangeStart = i;
	        }
	    }
	    ranges.push([text.slice(rangeStart), charStyle]);
	    return ranges;
	}

/***/ },
/* 2523 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isUnitlessNumber = {
	    animationIterationCount: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridRow: true,
	    gridColumn: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	    // SVG-related properties
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	};
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	    });
	});
	exports['default'] = isUnitlessNumber;
	module.exports = exports['default'];

/***/ },
/* 2524 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _draftJs = __webpack_require__(124);
	
	var _immutable = __webpack_require__(35);
	
	__webpack_require__(559);
	
	var _Toolbar = __webpack_require__(2527);
	
	var _ConfigStore = __webpack_require__(2519);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _getHTML = __webpack_require__(2522);
	
	var _getHTML2 = _interopRequireDefault(_getHTML);
	
	var _exportText = __webpack_require__(2521);
	
	var _exportText2 = _interopRequireDefault(_exportText);
	
	var _customHTML2Content = __webpack_require__(2520);
	
	var _customHTML2Content2 = _interopRequireDefault(_customHTML2Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasCommandModifier = _draftJs.KeyBindingUtil.hasCommandModifier;
	
	function noop() {}
	;
	var defaultPluginConfig = {};
	var focusDummyStyle = {
	    width: 0,
	    opacity: 0,
	    border: 0,
	    position: 'absolute',
	    left: 0,
	    top: 0
	};
	var toolbar = (0, _Toolbar.createToolbar)();
	var configStore = new _ConfigStore2['default']();
	
	var EditorCore = function (_React$Component) {
	    _inherits(EditorCore, _React$Component);
	
	    function EditorCore(props) {
	        _classCallCheck(this, EditorCore);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.cancelForceUpdateImmediate = function () {
	            clearImmediate(_this.forceUpdateImmediate);
	            _this.forceUpdateImmediate = null;
	        };
	        _this.handlePastedText = function (text, html) {
	            var editorState = _this.state.editorState;
	
	            if (html) {
	                var contentState = editorState.getCurrentContent();
	                var selection = editorState.getSelection();
	                var fragment = (0, _customHTML2Content2['default'])(html, contentState);
	                var pastedContent = _draftJs.Modifier.replaceWithFragment(contentState, selection, fragment);
	                var newContent = pastedContent.merge({
	                    selectionBefore: selection,
	                    selectionAfter: pastedContent.getSelectionAfter().set('hasFocus', true)
	                });
	                _this.setEditorState(_draftJs.EditorState.push(editorState, newContent, 'insert-fragment'), true);
	                return 'handled';
	            }
	            return 'not-handled';
	        };
	        _this.plugins = (0, _immutable.List)((0, _immutable.List)(props.plugins).flatten(true));
	        var editorState = void 0;
	        if (props.value !== undefined) {
	            if (props.value instanceof _draftJs.EditorState) {
	                editorState = props.value || _draftJs.EditorState.createEmpty();
	            } else {
	                editorState = _draftJs.EditorState.createEmpty();
	            }
	        } else {
	            editorState = _draftJs.EditorState.createEmpty();
	        }
	        editorState = _this.generatorDefaultValue(editorState);
	        _this.state = {
	            plugins: _this.reloadPlugins(),
	            editorState: editorState,
	            customStyleMap: {},
	            customBlockStyleMap: {},
	            compositeDecorator: null
	        };
	        if (props.value !== undefined) {
	            _this.controlledMode = true;
	            console.warn('this component is in controllred mode');
	        }
	        return _this;
	    }
	
	    EditorCore.ToEditorState = function ToEditorState(text) {
	        var createEmptyContentState = _draftJs.ContentState.createFromText((0, _exportText.decodeContent)(text) || '');
	        var editorState = _draftJs.EditorState.createWithContent(createEmptyContentState);
	        return _draftJs.EditorState.forceSelection(editorState, createEmptyContentState.getSelectionAfter());
	    };
	
	    EditorCore.prototype.Reset = function Reset() {
	        var defaultValue = this.props.defaultValue;
	
	        var contentState = defaultValue ? defaultValue.getCurrentContent() : _draftJs.ContentState.createFromText('');
	        var updatedEditorState = _draftJs.EditorState.push(this.state.editorState, contentState, 'remove-range');
	        this.setEditorState(_draftJs.EditorState.forceSelection(updatedEditorState, contentState.getSelectionBefore()));
	    };
	
	    EditorCore.prototype.SetText = function SetText(text) {
	        var createTextContentState = _draftJs.ContentState.createFromText(text || '');
	        var editorState = _draftJs.EditorState.push(this.state.editorState, createTextContentState, 'change-block-data');
	        this.setEditorState(_draftJs.EditorState.moveFocusToEnd(editorState), true);
	    };
	
	    EditorCore.prototype.getChildContext = function getChildContext() {
	        return {
	            getEditorState: this.getEditorState,
	            setEditorState: this.setEditorState
	        };
	    };
	
	    EditorCore.prototype.reloadPlugins = function reloadPlugins() {
	        var _this2 = this;
	
	        return this.plugins && this.plugins.size ? this.plugins.map(function (plugin) {
	            //　如果插件有 callbacks 方法,则认为插件已经加载。
	            if (plugin.callbacks) {
	                return plugin;
	            }
	            // 如果插件有 constructor 方法,则构造插件
	            if (plugin.hasOwnProperty('constructor')) {
	                var pluginConfig = _extends(_this2.props.pluginConfig, plugin.config || {}, defaultPluginConfig);
	                return plugin.constructor(pluginConfig);
	            }
	            // else 无效插件
	            console.warn('>> 插件: [', plugin.name, '] 无效。插件或许已经过期。');
	            return false;
	        }).filter(function (plugin) {
	            return plugin;
	        }).toArray() : [];
	    };
	
	    EditorCore.prototype.componentWillMount = function componentWillMount() {
	        var plugins = this.initPlugins().concat([toolbar]);
	        var customStyleMap = {};
	        var customBlockStyleMap = {};
	        var customBlockRenderMap = (0, _immutable.Map)(_draftJs.DefaultDraftBlockRenderMap);
	        var toHTMLList = (0, _immutable.List)([]);
	        // initialize compositeDecorator
	        var compositeDecorator = new _draftJs.CompositeDecorator(plugins.filter(function (plugin) {
	            return plugin.decorators !== undefined;
	        }).map(function (plugin) {
	            return plugin.decorators;
	        }).reduce(function (prev, curr) {
	            return prev.concat(curr);
	        }, []));
	        // initialize Toolbar
	        var toolbarPlugins = (0, _immutable.List)(plugins.filter(function (plugin) {
	            return !!plugin.component && plugin.name !== 'toolbar';
	        }));
	        // load inline styles...
	        plugins.forEach(function (plugin) {
	            var styleMap = plugin.styleMap,
	                blockStyleMap = plugin.blockStyleMap,
	                blockRenderMap = plugin.blockRenderMap,
	                toHtml = plugin.toHtml;
	
	            if (styleMap) {
	                for (var key in styleMap) {
	                    if (styleMap.hasOwnProperty(key)) {
	                        customStyleMap[key] = styleMap[key];
	                    }
	                }
	            }
	            if (blockStyleMap) {
	                for (var _key in blockStyleMap) {
	                    if (blockStyleMap.hasOwnProperty(_key)) {
	                        customBlockStyleMap[_key] = blockStyleMap[_key];
	                        customBlockRenderMap = customBlockRenderMap.set(_key, {
	                            element: null
	                        });
	                    }
	                }
	            }
	            if (toHtml) {
	                toHTMLList = toHTMLList.push(toHtml);
	            }
	            if (blockRenderMap) {
	                for (var _key2 in blockRenderMap) {
	                    if (blockRenderMap.hasOwnProperty(_key2)) {
	                        customBlockRenderMap = customBlockRenderMap.set(_key2, blockRenderMap[_key2]);
	                    }
	                }
	            }
	        });
	        configStore.set('customStyleMap', customStyleMap);
	        configStore.set('customBlockStyleMap', customBlockStyleMap);
	        configStore.set('blockRenderMap', customBlockRenderMap);
	        configStore.set('customStyleFn', this.customStyleFn.bind(this));
	        configStore.set('toHTMLList', toHTMLList);
	        this.setState({
	            toolbarPlugins: toolbarPlugins,
	            compositeDecorator: compositeDecorator
	        });
	        this.setEditorState(_draftJs.EditorState.set(this.state.editorState, { decorator: compositeDecorator }));
	    };
	
	    EditorCore.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (this.forceUpdateImmediate) {
	            this.cancelForceUpdateImmediate();
	        }
	        if (this.controlledMode) {
	            var decorators = nextProps.value.getDecorator();
	            var editorState = decorators ? nextProps.value : _draftJs.EditorState.set(nextProps.value, { decorator: this.state.compositeDecorator });
	            this.setState({
	                editorState: editorState
	            });
	        }
	    };
	
	    EditorCore.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.cancelForceUpdateImmediate();
	    };
	    //  处理　value　
	
	
	    EditorCore.prototype.generatorDefaultValue = function generatorDefaultValue(editorState) {
	        var defaultValue = this.props.defaultValue;
	
	        if (defaultValue) {
	            return defaultValue;
	        }
	        return editorState;
	    };
	
	    EditorCore.prototype.getStyleMap = function getStyleMap() {
	        return configStore.get('customStyleMap');
	    };
	
	    EditorCore.prototype.setStyleMap = function setStyleMap(customStyleMap) {
	        configStore.set('customStyleMap', customStyleMap);
	        this.render();
	    };
	
	    EditorCore.prototype.initPlugins = function initPlugins() {
	        var _this3 = this;
	
	        var enableCallbacks = ['focus', 'getEditorState', 'setEditorState', 'getStyleMap', 'setStyleMap'];
	        return this.getPlugins().map(function (plugin) {
	            enableCallbacks.forEach(function (callbackName) {
	                if (plugin.callbacks.hasOwnProperty(callbackName)) {
	                    plugin.callbacks[callbackName] = _this3[callbackName].bind(_this3);
	                }
	            });
	            return plugin;
	        });
	    };
	
	    EditorCore.prototype.focusEditor = function focusEditor(ev) {
	        this.refs.editor.focus(ev);
	        if (this.props.readOnly) {
	            this._focusDummy.focus();
	        }
	        if (this.props.onFocus) {
	            this.props.onFocus(ev);
	        }
	    };
	
	    EditorCore.prototype.focus = function focus(ev) {
	        var _this4 = this;
	
	        if (!ev || !ev.nativeEvent || !ev.nativeEvent.target) {
	            return;
	        }
	        var event = ev.nativeEvent;
	        if (document.activeElement && document.activeElement.getAttribute('contenteditable') === 'true') {
	            return;
	        }
	        if (event.target === this._editorWrapper) {
	            var editorState = this.state.editorState;
	
	            var selection = editorState.getSelection();
	            if (!selection.getHasFocus()) {
	                if (selection.isCollapsed()) {
	                    return this.setState({
	                        editorState: _draftJs.EditorState.moveFocusToEnd(editorState)
	                    }, function () {
	                        _this4.focusEditor(ev);
	                    });
	                }
	            }
	        }
	        this.focusEditor(ev);
	    };
	
	    EditorCore.prototype.getPlugins = function getPlugins() {
	        return this.state.plugins.slice();
	    };
	
	    EditorCore.prototype.getEventHandler = function getEventHandler() {
	        var _this5 = this;
	
	        var enabledEvents = ['onUpArrow', 'onDownArrow', 'handleReturn', 'onFocus', 'onBlur', 'onTab', 'handlePastedText'];
	        var eventHandler = {};
	        enabledEvents.forEach(function (event) {
	            eventHandler[event] = _this5.generatorEventHandler(event);
	        });
	        return eventHandler;
	    };
	
	    EditorCore.prototype.getEditorState = function getEditorState() {
	        var needFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (needFocus) {
	            this.refs.editor.focus();
	        }
	        return this.state.editorState;
	    };
	
	    EditorCore.prototype.setEditorState = function setEditorState(editorState) {
	        var _this6 = this;
	
	        var focusEditor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var newEditorState = editorState;
	        this.getPlugins().forEach(function (plugin) {
	            if (plugin.onChange) {
	                var updatedEditorState = plugin.onChange(newEditorState);
	                if (updatedEditorState) {
	                    newEditorState = updatedEditorState;
	                }
	            }
	        });
	        if (this.props.onChange) {
	            this.props.onChange(newEditorState);
	            // close this issue https://github.com/ant-design/ant-design/issues/5788
	            // when onChange not take any effect
	            // `<Editor />` won't rerender cause no props is changed.
	            // add an timeout here,
	            // if props.onChange not trigger componentWillReceiveProps,
	            // we will force render Editor with previous editorState,
	            if (this.controlledMode) {
	                this.forceUpdateImmediate = setImmediate(function () {
	                    return _this6.setState({
	                        editorState: new _draftJs.EditorState(_this6.state.editorState.getImmutable())
	                    });
	                });
	            }
	        }
	        if (!this.controlledMode) {
	            this.setState({ editorState: newEditorState }, focusEditor ? function () {
	                return setImmediate(function () {
	                    return _this6.refs.editor.focus();
	                });
	            } : noop);
	        }
	    };
	
	    EditorCore.prototype.handleKeyBinding = function handleKeyBinding(ev) {
	        if (this.props.onKeyDown) {
	            ev.ctrlKey = hasCommandModifier(ev);
	            var keyDownResult = this.props.onKeyDown(ev);
	            if (keyDownResult) {
	                return keyDownResult;
	            }
	            return (0, _draftJs.getDefaultKeyBinding)(ev);
	        }
	        return (0, _draftJs.getDefaultKeyBinding)(ev);
	    };
	
	    EditorCore.prototype.handleKeyCommand = function handleKeyCommand(command) {
	        if (this.props.multiLines) {
	            return this.eventHandle('handleKeyBinding', command);
	        }
	        return command === 'split-block' ? 'handled' : 'not-handled';
	    };
	
	    EditorCore.prototype.getBlockStyle = function getBlockStyle(contentBlock) {
	        var customBlockStyleMap = configStore.get('customBlockStyleMap');
	        var type = contentBlock.getType();
	        if (customBlockStyleMap.hasOwnProperty(type)) {
	            return customBlockStyleMap[type];
	        }
	    };
	
	    EditorCore.prototype.blockRendererFn = function blockRendererFn(contentBlock) {
	        var blockRenderResult = null;
	        this.getPlugins().forEach(function (plugin) {
	            if (plugin.blockRendererFn) {
	                var result = plugin.blockRendererFn(contentBlock);
	                if (result) {
	                    blockRenderResult = result;
	                }
	            }
	        });
	        return blockRenderResult;
	    };
	
	    EditorCore.prototype.eventHandle = function eventHandle(eventName) {
	        var _props;
	
	        var plugins = this.getPlugins();
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
	            args[_key3 - 1] = arguments[_key3];
	        }
	
	        for (var i = 0; i < plugins.length; i++) {
	            var plugin = plugins[i];
	            if (plugin.callbacks[eventName] && typeof plugin.callbacks[eventName] === 'function') {
	                var _plugin$callbacks;
	
	                var result = (_plugin$callbacks = plugin.callbacks)[eventName].apply(_plugin$callbacks, args);
	                if (result === true) {
	                    return 'handled';
	                }
	            }
	        }
	        return this.props.hasOwnProperty(eventName) && (_props = this.props)[eventName].apply(_props, args) === true ? 'handled' : 'not-handled';
	    };
	
	    EditorCore.prototype.generatorEventHandler = function generatorEventHandler(eventName) {
	        var _this7 = this;
	
	        return function () {
	            for (var _len2 = arguments.length, args = Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
	                args[_key4] = arguments[_key4];
	            }
	
	            return _this7.eventHandle.apply(_this7, [eventName].concat(args));
	        };
	    };
	
	    EditorCore.prototype.customStyleFn = function customStyleFn(styleSet) {
	        if (styleSet.size === 0) {
	            return {};
	        }
	        var plugins = this.getPlugins();
	        var resultStyle = {};
	        for (var i = 0; i < plugins.length; i++) {
	            if (plugins[i].customStyleFn) {
	                var styled = plugins[i].customStyleFn(styleSet);
	                if (styled) {
	                    _extends(resultStyle, styled);
	                }
	            }
	        }
	        return resultStyle;
	    };
	
	    EditorCore.prototype.render = function render() {
	        var _this8 = this;
	
	        var _props2 = this.props,
	            prefixCls = _props2.prefixCls,
	            toolbars = _props2.toolbars,
	            style = _props2.style,
	            readOnly = _props2.readOnly;
	        var _state = this.state,
	            editorState = _state.editorState,
	            toolbarPlugins = _state.toolbarPlugins;
	
	        var customStyleMap = configStore.get('customStyleMap');
	        var blockRenderMap = configStore.get('blockRenderMap');
	        var eventHandler = this.getEventHandler();
	        var Toolbar = toolbar.component;
	        return _react2['default'].createElement(
	            'div',
	            { style: style, className: prefixCls + '-editor ' + (readOnly ? 'readonly' : ''), onClick: this.focus.bind(this) },
	            _react2['default'].createElement(Toolbar, { editorState: editorState, prefixCls: prefixCls, className: prefixCls + '-toolbar', plugins: toolbarPlugins, toolbars: toolbars }),
	            _react2['default'].createElement(
	                'div',
	                { className: prefixCls + '-editor-wrapper', ref: function ref(ele) {
	                        return _this8._editorWrapper = ele;
	                    }, style: style, onClick: function onClick(ev) {
	                        return ev.preventDefault();
	                    } },
	                _react2['default'].createElement(_draftJs.Editor, _extends({}, this.props, eventHandler, { ref: 'editor', customStyleMap: customStyleMap, customStyleFn: this.customStyleFn.bind(this), editorState: editorState, handleKeyCommand: this.handleKeyCommand.bind(this), keyBindingFn: this.handleKeyBinding.bind(this), onChange: this.setEditorState.bind(this), blockStyleFn: this.getBlockStyle.bind(this), blockRenderMap: blockRenderMap, handlePastedText: this.handlePastedText, blockRendererFn: this.blockRendererFn.bind(this) })),
	                readOnly ? _react2['default'].createElement('input', { style: focusDummyStyle, ref: function ref(ele) {
	                        return _this8._focusDummy = ele;
	                    }, onBlur: eventHandler.onBlur }) : null,
	                this.props.children
	            )
	        );
	    };
	
	    return EditorCore;
	}(_react2['default'].Component);
	
	EditorCore.GetText = _exportText2['default'];
	EditorCore.GetHTML = (0, _getHTML2['default'])(configStore);
	EditorCore.defaultProps = {
	    multiLines: true,
	    plugins: [],
	    prefixCls: 'rc-editor-core',
	    pluginConfig: {},
	    toolbars: [],
	    spilitLine: 'enter'
	};
	EditorCore.childContextTypes = {
	    getEditorState: _propTypes2['default'].func,
	    setEditorState: _propTypes2['default'].func
	};
	exports['default'] = EditorCore;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(562).clearImmediate, __webpack_require__(562).setImmediate))

/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(35);
	
	var _ToolbarLine = __webpack_require__(2526);
	
	var _ToolbarLine2 = _interopRequireDefault(_ToolbarLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function noop() {}
	
	var Toolbar = function (_React$Component) {
	    _inherits(Toolbar, _React$Component);
	
	    function Toolbar(props) {
	        _classCallCheck(this, Toolbar);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var map = {};
	        props.plugins.forEach(function (plugin) {
	            map[plugin.name] = plugin;
	        });
	        _this.pluginsMap = (0, _immutable.Map)(map);
	        _this.state = {
	            editorState: props.editorState,
	            toolbars: []
	        };
	        return _this;
	    }
	
	    Toolbar.prototype.renderToolbarItem = function renderToolbarItem(pluginName, idx) {
	        var element = this.pluginsMap.get(pluginName);
	        if (element && element.component) {
	            var component = element.component;
	
	            var props = {
	                key: 'toolbar-item-' + idx,
	                onClick: component.props ? component.props.onClick : noop
	            };
	            if (_react2['default'].isValidElement(component)) {
	                return _react2['default'].cloneElement(component, props);
	            }
	            return _react2['default'].createElement(component, props);
	        }
	        return null;
	    };
	
	    Toolbar.prototype.conpomentWillReceiveProps = function conpomentWillReceiveProps(nextProps) {
	        this.render();
	    };
	
	    Toolbar.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            toolbars = _props.toolbars,
	            prefixCls = _props.prefixCls;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-toolbar' },
	            toolbars.map(function (toolbar, idx) {
	                var children = _react2['default'].Children.map(toolbar, _this2.renderToolbarItem.bind(_this2));
	                return _react2['default'].createElement(
	                    _ToolbarLine2['default'],
	                    { key: 'toolbar-' + idx },
	                    children
	                );
	            })
	        );
	    };
	
	    return Toolbar;
	}(_react2['default'].Component);
	
	exports['default'] = Toolbar;
	module.exports = exports['default'];

/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarLine = function (_React$Component) {
	    _inherits(ToolbarLine, _React$Component);
	
	    function ToolbarLine() {
	        _classCallCheck(this, ToolbarLine);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ToolbarLine.prototype.render = function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.props.children
	        );
	    };
	
	    return ToolbarLine;
	}(_react2['default'].Component);
	
	exports['default'] = ToolbarLine;
	module.exports = exports['default'];

/***/ },
/* 2527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createToolbar = createToolbar;
	
	var _Toolbar = __webpack_require__(2525);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop(args) {}
	;
	function createToolbar() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    function editorStateChange(editorState) {
	        // console.log('>> editorStateChange', editorState);
	    }
	    var callbacks = {
	        onChange: editorStateChange,
	        onUpArrow: noop,
	        onDownArrow: noop,
	        getEditorState: noop,
	        setEditorState: noop,
	        handleReturn: noop
	    };
	    return {
	        name: 'toolbar',
	        decorators: [],
	        callbacks: callbacks,
	        onChange: function onChange(editorState) {
	            return callbacks.onChange ? callbacks.onChange(editorState) : editorState;
	        },
	
	        component: _Toolbar2['default']
	    };
	}

/***/ },
/* 2528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.toEditorState = exports.GetHTML = exports.GetText = exports.EditorCore = undefined;
	
	var _EditorCore = __webpack_require__(2524);
	
	var _EditorCore2 = _interopRequireDefault(_EditorCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var GetText = _EditorCore2['default'].GetText,
	    GetHTML = _EditorCore2['default'].GetHTML;
	
	var toEditorState = _EditorCore2['default'].ToEditorState;
	var EditorCorePublic = {
	    EditorCore: _EditorCore2['default'],
	    GetText: GetText,
	    GetHTML: GetHTML,
	    toEditorState: toEditorState
	};
	exports.EditorCore = _EditorCore2['default'];
	exports.GetText = GetText;
	exports.GetHTML = GetHTML;
	exports.toEditorState = toEditorState;
	exports['default'] = EditorCorePublic;

/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _rcEditorCore = __webpack_require__(2528);
	
	var _draftJs = __webpack_require__(124);
	
	var _createMention = __webpack_require__(2537);
	
	var _createMention2 = _interopRequireDefault(_createMention);
	
	var _exportContent = __webpack_require__(473);
	
	var _exportContent2 = _interopRequireDefault(_exportContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Mention = function (_React$Component) {
	  (0, _inherits3['default'])(Mention, _React$Component);
	
	  function Mention(props) {
	    (0, _classCallCheck3['default'])(this, Mention);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onEditorChange = function (editorState) {
	      var selection = editorState.getSelection();
	      _this._decorator = editorState.getDecorator();
	      var content = editorState.getCurrentContent();
	
	      if (_this.props.onChange) {
	        _this.setState({
	          selection: selection
	        }, function () {
	          _this.props.onChange(content, (0, _exportContent2['default'])(content));
	        });
	      } else {
	        _this.setState({
	          editorState: editorState,
	          selection: selection
	        });
	      }
	    };
	
	    _this.onFocus = function (e) {
	      if (_this.props.onFocus) {
	        _this.props.onFocus(e);
	      }
	    };
	
	    _this.onBlur = function (e) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(e);
	      }
	    };
	
	    _this.reset = function () {
	      /*eslint-disable*/
	      _this._editor.Reset();
	      /*eslint-enable*/
	    };
	
	    _this.mention = (0, _createMention2['default'])({
	      prefix: _this.getPrefix(props),
	      tag: props.tag,
	      mode: props.mode,
	      mentionStyle: props.mentionStyle
	    });
	
	    _this.Suggestions = _this.mention.Suggestions;
	    _this.plugins = [_this.mention];
	
	    _this.state = {
	      suggestions: props.suggestions,
	      value: props.value && _draftJs.EditorState.createWithContent(props.value, new _draftJs.CompositeDecorator(_this.mention.decorators)),
	      selection: _draftJs.SelectionState.createEmpty()
	    };
	
	    if (typeof props.defaultValue === 'string') {
	      // eslint-disable-next-line
	      console.warn('The property `defaultValue` now allow `EditorState` only, see http://react-component.github.io/editor-mention/examples/defaultValue.html ');
	    }
	    if (props.value !== undefined) {
	      _this.controlledMode = true;
	    }
	    return _this;
	  }
	
	  Mention.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var suggestions = nextProps.suggestions;
	    var selection = this.state.selection;
	
	    var value = nextProps.value;
	    if (value && selection) {
	      value = _draftJs.EditorState.acceptSelection(_draftJs.EditorState.createWithContent(value, this._decorator), selection);
	    }
	    this.setState({
	      suggestions: suggestions,
	      value: value
	    });
	  };
	
	  Mention.prototype.getPrefix = function getPrefix() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return Array.isArray(props.prefix) ? props.prefix : [props.prefix];
	  };
	
	  Mention.prototype.render = function render() {
	    var _classnames,
	        _this2 = this;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        tag = _props.tag,
	        multiLines = _props.multiLines,
	        suggestionStyle = _props.suggestionStyle,
	        placeholder = _props.placeholder,
	        defaultValue = _props.defaultValue,
	        className = _props.className,
	        notFoundContent = _props.notFoundContent,
	        getSuggestionContainer = _props.getSuggestionContainer,
	        readOnly = _props.readOnly,
	        disabled = _props.disabled,
	        placement = _props.placement;
	    var suggestions = this.state.suggestions;
	    var Suggestions = this.Suggestions;
	
	    var editorClass = (0, _classnames3['default'])(className, (_classnames = {}, _classnames[prefixCls + '-wrapper'] = true, _classnames.readonly = readOnly, _classnames.disabled = disabled, _classnames.multilines = multiLines, _classnames));
	    var editorProps = this.controlledMode ? { value: this.state.value } : {};
	    var defaultValueState = defaultValue && _draftJs.EditorState.createWithContent(typeof defaultValue === 'string' ? _draftJs.ContentState.createFromText(defaultValue) : defaultValue, this._decorator);
	    return _react2['default'].createElement(
	      'div',
	      { className: editorClass, style: style, ref: function ref(wrapper) {
	          return _this2._wrapper = wrapper;
	        } },
	      _react2['default'].createElement(
	        _rcEditorCore.EditorCore,
	        (0, _extends3['default'])({
	          ref: function ref(editor) {
	            return _this2._editor = editor;
	          },
	          prefixCls: prefixCls,
	          style: style,
	          multiLines: multiLines,
	          plugins: this.plugins,
	          defaultValue: defaultValueState,
	          placeholder: placeholder,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onChange: this.onEditorChange
	        }, editorProps, {
	          readOnly: readOnly || disabled
	        }),
	        _react2['default'].createElement(Suggestions, {
	          mode: tag ? 'immutable' : 'mutable',
	          prefix: this.getPrefix(),
	          prefixCls: prefixCls,
	          style: suggestionStyle,
	          placement: placement,
	          notFoundContent: notFoundContent,
	          suggestions: suggestions,
	          getSuggestionContainer: getSuggestionContainer ? function () {
	            return getSuggestionContainer(_this2._wrapper);
	          } : null,
	          onSearchChange: this.props.onSearchChange,
	          onSelect: this.props.onSelect,
	          noRedup: this.props.noRedup
	        })
	      )
	    );
	  };
	
	  return Mention;
	}(_react2['default'].Component);
	
	Mention.propTypes = {
	  value: _propTypes2['default'].object,
	  suggestions: _propTypes2['default'].array,
	  prefix: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  prefixCls: _propTypes2['default'].string,
	  tag: _propTypes2['default'].element,
	  style: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  onSearchChange: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  mode: _propTypes2['default'].string,
	  multiLines: _propTypes2['default'].bool,
	  suggestionStyle: _propTypes2['default'].object,
	  placeholder: _propTypes2['default'].string,
	  defaultValue: _propTypes2['default'].object,
	  notFoundContent: _propTypes2['default'].any,
	  position: _propTypes2['default'].string,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  getSuggestionContainer: _propTypes2['default'].func,
	  noRedup: _propTypes2['default'].bool,
	  mentionStyle: _propTypes2['default'].object,
	  placement: _propTypes2['default'].string
	};
	Mention.controlledMode = false;
	
	
	Mention.defaultProps = {
	  prefixCls: 'rc-editor-mention',
	  prefix: '@',
	  mode: 'immutable',
	  suggestions: [],
	  multiLines: false,
	  className: '',
	  suggestionStyle: {},
	  notFoundContent: '无法找到',
	  position: 'absolute',
	  placement: 'bottom', // top, bottom
	  mentionStyle: {}
	};
	
	exports['default'] = Mention;
	module.exports = exports['default'];

/***/ },
/* 2530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MentionContent = function MentionContent(_ref) {
	  var children = _ref.children;
	  return _react2['default'].createElement(
	    'span',
	    { style: { backgroundColor: '#e6f3ff' } },
	    children
	  );
	};
	
	exports['default'] = MentionContent;
	module.exports = exports['default'];

/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getOffset = __webpack_require__(1163);
	
	var _getOffset2 = _interopRequireDefault(_getOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SuggestionPortal = function (_React$Component) {
	  (0, _inherits3['default'])(SuggestionPortal, _React$Component);
	
	  function SuggestionPortal() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SuggestionPortal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.matchDecorates = function (props) {
	      var callbacks = props.callbacks,
	          suggestionRegex = props.suggestionRegex,
	          decoratedText = props.decoratedText;
	
	      var matches = suggestionRegex.exec(decoratedText);
	      _this.trigger = matches[2];
	      _this.updatePortalPosition(_this.props);
	      callbacks.setEditorState(callbacks.getEditorState());
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  SuggestionPortal.prototype.componentWillMount = function componentWillMount() {
	    this.matchDecorates(this.props);
	  };
	
	  SuggestionPortal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.decoratedText !== this.props.decoratedText) {
	      this.matchDecorates(nextProps);
	    }
	    this.updatePortalPosition(nextProps);
	  };
	
	  SuggestionPortal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props = this.props,
	        offsetKey = _props.offsetKey,
	        mentionStore = _props.mentionStore;
	
	    mentionStore.inActiveSuggestion({ offsetKey: offsetKey });
	  };
	
	  SuggestionPortal.prototype.updatePortalPosition = function updatePortalPosition(props) {
	    var _this2 = this;
	
	    var offsetKey = props.offsetKey,
	        mentionStore = props.mentionStore;
	
	    mentionStore.updateSuggestion({
	      offsetKey: offsetKey,
	      trigger: this.trigger,
	      position: function position() {
	        var element = _this2.searchPortal;
	        var rect = (0, _getOffset2['default'])(element);
	        return {
	          left: rect.left,
	          top: rect.top,
	          width: element.offsetWidth,
	          height: element.offsetHeight
	        };
	      }
	    });
	  };
	
	  SuggestionPortal.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2['default'].createElement(
	      'span',
	      { ref: function ref(node) {
	          _this3.searchPortal = node;
	        }, style: this.props.style },
	      this.props.children
	    );
	  };
	
	  return SuggestionPortal;
	}(_react2['default'].Component);
	
	SuggestionPortal.propTypes = {
	  offsetKey: _propTypes2['default'].any,
	  mentionStore: _propTypes2['default'].object,
	  decoratedText: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  callbacks: _propTypes2['default'].any,
	  suggestionRegex: _propTypes2['default'].any
	};
	exports['default'] = SuggestionPortal;
	module.exports = exports['default'];

/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var SuggestionWrapper = function (_React$Component) {
	  (0, _inherits3['default'])(SuggestionWrapper, _React$Component);
	
	  function SuggestionWrapper() {
	    (0, _classCallCheck3['default'])(this, SuggestionWrapper);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SuggestionWrapper.prototype.componentDidMount = function componentDidMount() {
	    this.renderOrReady();
	  };
	
	  SuggestionWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOrReady();
	  };
	
	  SuggestionWrapper.prototype.renderOrReady = function renderOrReady() {
	    if (IS_REACT_16) {
	      this.props.renderReady();
	    } else {
	      this.renderComponent();
	    }
	  };
	
	  SuggestionWrapper.prototype.renderComponent = function renderComponent() {
	    var _props = this.props,
	        children = _props.children,
	        container = _props.container,
	        renderReady = _props.renderReady;
	
	    (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, children, container, function callback() {
	      if (renderReady) {
	        renderReady.call(this);
	      }
	    });
	  };
	
	  SuggestionWrapper.prototype.render = function render() {
	    if (IS_REACT_16) {
	      var _props2 = this.props,
	          children = _props2.children,
	          container = _props2.container;
	
	      return (0, _reactDom.createPortal)(children, container);
	    }
	    return null;
	  };
	
	  return SuggestionWrapper;
	}(_react2['default'].Component);
	
	exports['default'] = SuggestionWrapper;
	
	
	SuggestionWrapper.propTypes = {
	  children: _propTypes2['default'].any,
	  renderReady: _propTypes2['default'].func,
	  container: _propTypes2['default'].any
	};
	module.exports = exports['default'];

/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DraftOffsetKey = __webpack_require__(226);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domScrollIntoView = __webpack_require__(295);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _Nav = __webpack_require__(1161);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _SuggestionWrapper = __webpack_require__(2532);
	
	var _SuggestionWrapper2 = _interopRequireDefault(_SuggestionWrapper);
	
	var _insertMention = __webpack_require__(2538);
	
	var _insertMention2 = _interopRequireDefault(_insertMention);
	
	var _clearMention = __webpack_require__(2536);
	
	var _clearMention2 = _interopRequireDefault(_clearMention);
	
	var _getOffset = __webpack_require__(1163);
	
	var _getOffset2 = _interopRequireDefault(_getOffset);
	
	var _getMentions = __webpack_require__(1162);
	
	var _getMentions2 = _interopRequireDefault(_getMentions);
	
	var _getSearchWord2 = __webpack_require__(474);
	
	var _getSearchWord3 = _interopRequireDefault(_getSearchWord2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isNotFalse = function isNotFalse(i) {
	  return i !== false;
	};
	
	var Suggestions = function (_React$Component) {
	  (0, _inherits3['default'])(Suggestions, _React$Component);
	
	  function Suggestions() {
	    (0, _classCallCheck3['default'])(this, Suggestions);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this));
	
	    _this.onEditorStateChange = function (editorState) {
	      var offset = _this.props.store.getOffset();
	      if (offset.size === 0) {
	        _this.closeDropDown();
	        return editorState;
	      }
	      var selection = editorState.getSelection();
	
	      // 修复: 焦点移出再移入时, dropdown 会闪动一下
	      // 原因: https://github.com/facebook/draft-js/blob/67c5e69499e3b0c149ce83b004872afdf4180463/src/component/handlers/edit/editOnFocus.js#L33
	      // 此处强制 update 了一下,因此 onEditorStateChange 会 call 两次
	      if (!_this.props.callbacks.getEditorState().getSelection().getHasFocus() && selection.getHasFocus()) {
	        return editorState;
	      }
	
	      var _getSearchWord = (0, _getSearchWord3['default'])(editorState, selection),
	          word = _getSearchWord.word;
	
	      if (!word) {
	        _this.closeDropDown();
	        return editorState;
	      }
	      var selectionInsideMention = offset.map(function (_ref) {
	        var offsetKey = _ref.offsetKey;
	
	        var _decode = (0, _DraftOffsetKey.decode)(offsetKey),
	            blockKey = _decode.blockKey,
	            decoratorKey = _decode.decoratorKey,
	            leafKey = _decode.leafKey;
	
	        if (blockKey !== selection.anchorKey) {
	          return false;
	        }
	        var leaf = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);
	        if (!leaf) {
	          return false;
	        }
	        var startKey = leaf.get('start');
	        var endKey = leaf.get('end');
	        // 处理只有一个 `@` 符号时的情况
	        if (!word) {
	          return false;
	        }
	        if (startKey === endKey - 1) {
	          return selection.anchorOffset >= startKey + 1 && selection.anchorOffset <= endKey ? offsetKey : false;
	        }
	        return selection.anchorOffset > startKey + 1 && selection.anchorOffset <= endKey ? offsetKey : false;
	      });
	
	      var selectionInText = selectionInsideMention.some(isNotFalse);
	      _this.activeOffsetKey = selectionInsideMention.find(isNotFalse);
	      var trigger = _this.props.store.getTrigger(_this.activeOffsetKey);
	
	      if (!selectionInText || !selection.getHasFocus()) {
	        _this.closeDropDown();
	        return editorState;
	      }
	      var searchValue = word.substring(trigger.length, word.length);
	      if (_this.lastSearchValue !== searchValue || _this.lastTrigger !== trigger) {
	        _this.lastSearchValue = searchValue;
	        _this.lastTrigger = trigger;
	        _this.props.onSearchChange(searchValue, trigger);
	      }
	      if (!_this.state.active) {
	        // 特例处理 https://github.com/ant-design/ant-design/issues/7838
	        // 暂时没有更优雅的方法
	        if (!trigger || word.indexOf(trigger) !== -1) {
	          _this.openDropDown();
	        }
	      }
	      return editorState;
	    };
	
	    _this.onUpArrow = function (ev) {
	      ev.preventDefault();
	      if (_this.props.suggestions.length > 0) {
	        var newIndex = _this.state.focusedIndex - 1;
	        _this.setState({
	          focusedIndex: Math.max(newIndex, 0)
	        });
	      }
	    };
	
	    _this.onBlur = function (ev) {
	      ev.preventDefault();
	      _this.closeDropDown();
	    };
	
	    _this.onDownArrow = function (ev) {
	      ev.preventDefault();
	      var newIndex = _this.state.focusedIndex + 1;
	      _this.setState({
	        focusedIndex: newIndex >= _this.props.suggestions.length ? 0 : newIndex
	      });
	    };
	
	    _this.getContainer = function () {
	      var popupContainer = document.createElement('div');
	      var mountNode = void 0;
	      if (_this.props.getSuggestionContainer) {
	        mountNode = _this.props.getSuggestionContainer();
	        popupContainer.style.position = 'relative';
	      } else {
	        mountNode = document.body;
	      }
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    };
	
	    _this.handleKeyBinding = function (command) {
	      return command === 'split-block';
	    };
	
	    _this.handleReturn = function (ev) {
	      ev.preventDefault();
	      var selectedSuggestion = _this.props.suggestions[_this.state.focusedIndex];
	      if (selectedSuggestion) {
	        if (_react2['default'].isValidElement(selectedSuggestion)) {
	          _this.onMentionSelect(selectedSuggestion.props.value, selectedSuggestion.props.data);
	        } else {
	          _this.onMentionSelect(selectedSuggestion);
	        }
	        _this.lastSearchValue = null;
	        _this.lastTrigger = null;
	        return true;
	      }
	      return false;
	    };
	
	    _this.renderReady = function () {
	      var container = _this.dropdownContainer;
	      if (!container) {
	        return;
	      }
	      var active = _this.state.active;
	      var activeOffsetKey = _this.activeOffsetKey;
	
	      var offset = _this.props.store.getOffset();
	      var dropDownPosition = offset.get(activeOffsetKey);
	
	      if (active && dropDownPosition) {
	        var placement = _this.props.placement;
	        var dropDownStyle = _this.getPositionStyle(true, dropDownPosition.position());
	
	        // Check if the above space is crowded
	        var isTopCrowded = parseFloat(dropDownStyle.top) - window.scrollY - container.offsetHeight < 0;
	        // Check if the under space is crowded
	        var isBottomCrowded = (window.innerHeight || document.documentElement.clientHeight) - (parseFloat(dropDownStyle.top) - window.scrollY) - container.offsetHeight < 0;
	
	        if (placement === 'top' && !isTopCrowded) {
	          // The above space isn't crowded
	          dropDownStyle.top = (parseFloat(dropDownStyle.top) - container.offsetHeight || 0) + 'px';
	        }
	
	        if (placement === 'bottom' && isBottomCrowded && !isTopCrowded) {
	          // The above space isn't crowded and the under space is crowded.
	          dropDownStyle.top = (parseFloat(dropDownStyle.top) - container.offsetHeight || 0) + 'px';
	        }
	
	        Object.keys(dropDownStyle).forEach(function (key) {
	          container.style[key] = dropDownStyle[key];
	        });
	      }
	
	      if (!_this.focusItem) {
	        return;
	      }
	      (0, _domScrollIntoView2['default'])(_reactDom2['default'].findDOMNode(_this.focusItem), container, {
	        onlyScrollIfNeeded: true
	      });
	    };
	
	    _this.getNavigations = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          suggestions = _this$props.suggestions;
	      var focusedIndex = _this.state.focusedIndex;
	
	      return suggestions.length ? _react2['default'].Children.map(suggestions, function (element, index) {
	        var focusItem = index === focusedIndex;
	        var ref = focusItem ? function (node) {
	          _this.focusItem = node;
	        } : null;
	        var mentionClass = (0, _classnames2['default'])(prefixCls + '-dropdown-item', {
	          focus: focusItem
	        });
	        if (_react2['default'].isValidElement(element)) {
	          return _react2['default'].cloneElement(element, {
	            className: mentionClass,
	            onMouseDown: function onMouseDown() {
	              return _this.onMentionSelect(element.props.value, element.props.data);
	            },
	            ref: ref
	          });
	        }
	        return _react2['default'].createElement(
	          _Nav2['default'],
	          {
	            ref: ref,
	            className: mentionClass,
	            onMouseDown: function onMouseDown() {
	              return _this.onMentionSelect(element);
	            }
	          },
	          element
	        );
	      }, _this) : _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-dropdown-notfound ' + prefixCls + '-dropdown-item' },
	        _this.props.notFoundContent
	      );
	    };
	
	    _this.state = {
	      isActive: false,
	      focusedIndex: 0,
	      container: false
	    };
	    return _this;
	  }
	
	  Suggestions.prototype.componentDidMount = function componentDidMount() {
	    this.props.callbacks.onChange = this.onEditorStateChange;
	  };
	
	  Suggestions.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.suggestions.length !== this.props.suggestions.length) {
	      this.setState({
	        focusedIndex: 0
	      });
	    }
	  };
	
	  Suggestions.prototype.onMentionSelect = function onMentionSelect(mention, data) {
	    var editorState = this.props.callbacks.getEditorState();
	    var _props = this.props,
	        store = _props.store,
	        onSelect = _props.onSelect;
	
	    var trigger = store.getTrigger(this.activeOffsetKey);
	    if (onSelect) {
	      onSelect(mention, data || mention);
	    }
	    if (this.props.noRedup) {
	      var mentions = (0, _getMentions2['default'])(editorState.getCurrentContent(), trigger);
	      if (mentions.indexOf('' + trigger + mention) !== -1) {
	        // eslint-disable-next-line
	        console.warn('you have specified `noRedup` props but have duplicated mentions.');
	        this.closeDropDown();
	        this.props.callbacks.setEditorState((0, _clearMention2['default'])(editorState));
	        return;
	      }
	    }
	    this.props.callbacks.setEditorState((0, _insertMention2['default'])(editorState, '' + trigger + mention, data, this.props.mode), true);
	    this.closeDropDown();
	  };
	
	  Suggestions.prototype.getPositionStyle = function getPositionStyle(isActive, position) {
	    if (this.props.getSuggestionStyle) {
	      return this.props.getSuggestionStyle(isActive, position);
	    }
	    var container = this.props.getSuggestionContainer ? this.state.container : document.body;
	    var offset = (0, _getOffset2['default'])(container);
	    return position ? (0, _extends4['default'])({
	      position: 'absolute',
	      left: position.left - offset.left + 'px',
	      top: position.top - offset.top + 'px'
	    }, this.props.style) : {};
	  };
	
	  Suggestions.prototype.openDropDown = function openDropDown() {
	    this.props.callbacks.onUpArrow = this.onUpArrow;
	    this.props.callbacks.handleReturn = this.handleReturn;
	    this.props.callbacks.handleKeyBinding = this.handleKeyBinding;
	    this.props.callbacks.onDownArrow = this.onDownArrow;
	    this.props.callbacks.onBlur = this.onBlur;
	    this.setState({
	      active: true,
	      container: this.state.container || this.getContainer()
	    });
	  };
	
	  Suggestions.prototype.closeDropDown = function closeDropDown() {
	    this.props.callbacks.onUpArrow = null;
	    this.props.callbacks.handleReturn = null;
	    this.props.callbacks.handleKeyBinding = null;
	    this.props.callbacks.onDownArrow = null;
	    this.props.callbacks.onBlur = null;
	    this.setState({
	      active: false
	    });
	  };
	
	  Suggestions.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        className = _props2.className,
	        placement = _props2.placement;
	    var _state = this.state,
	        container = _state.container,
	        active = _state.active;
	
	    var cls = (0, _classnames2['default'])((0, _extends4['default'])((_extends2 = {}, _extends2[prefixCls + '-dropdown'] = true, _extends2[prefixCls + '-dropdown-placement-' + placement] = true, _extends2), className));
	    var transitionName = placement === 'top' ? 'slide-down' : 'slide-up';
	
	    var navigations = this.getNavigations();
	
	    return container ? _react2['default'].createElement(
	      _SuggestionWrapper2['default'],
	      { renderReady: this.renderReady, container: container },
	      _react2['default'].createElement(
	        _rcAnimate2['default'],
	        { transitionName: transitionName },
	        active ? _react2['default'].createElement(
	          'div',
	          { className: cls, ref: function ref(node) {
	              _this2.dropdownContainer = node;
	            } },
	          navigations
	        ) : null
	      )
	    ) : null;
	  };
	
	  return Suggestions;
	}(_react2['default'].Component);
	
	exports['default'] = Suggestions;
	
	
	Suggestions.propTypes = {
	  callbacks: _propTypes2['default'].object,
	  suggestions: _propTypes2['default'].array,
	  store: _propTypes2['default'].object,
	  onSearchChange: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  mode: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  onSelect: _propTypes2['default'].func,
	  getSuggestionContainer: _propTypes2['default'].func,
	  notFoundContent: _propTypes2['default'].any,
	  getSuggestionStyle: _propTypes2['default'].func,
	  className: _propTypes2['default'].string,
	  noRedup: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string
	};
	module.exports = exports['default'];

/***/ },
/* 2534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getMentions = exports.toEditorState = exports.toString = exports.Nav = undefined;
	
	var _draftJs = __webpack_require__(124);
	
	var _Mention = __webpack_require__(2529);
	
	var _Mention2 = _interopRequireDefault(_Mention);
	
	var _exportContent = __webpack_require__(473);
	
	var _exportContent2 = _interopRequireDefault(_exportContent);
	
	var _getMentions = __webpack_require__(1162);
	
	var _getMentions2 = _interopRequireDefault(_getMentions);
	
	var _Nav = __webpack_require__(1161);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toEditorState(text) {
	  return _draftJs.ContentState.createFromText(text);
	} // export this package's api
	
	
	_Mention2['default'].Nav = _Nav2['default'];
	_Mention2['default'].toString = _exportContent2['default'];
	_Mention2['default'].toEditorState = toEditorState;
	_Mention2['default'].getMentions = _getMentions2['default'];
	
	exports.Nav = _Nav2['default'];
	exports.toString = _exportContent2['default'];
	exports.toEditorState = toEditorState;
	exports.getMentions = _getMentions2['default'];
	exports['default'] = _Mention2['default'];

/***/ },
/* 2535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(35);
	
	var offset = (0, _immutable.Map)(); /* eslint new-cap: [2, {capIsNewExceptions: ["Map"]}] */
	
	var mentionStore = {
	  offset: (0, _immutable.Map)(),
	  getOffset: function getOffset() {
	    return offset;
	  },
	  getTrigger: function getTrigger(offsetKey) {
	    var currentOffset = offset.get(offsetKey);
	    return currentOffset && currentOffset.trigger;
	  },
	  activeSuggestion: function activeSuggestion(_ref) {
	    var offsetKey = _ref.offsetKey;
	
	    offset = offset.set(offsetKey, {
	      offsetKey: offsetKey
	    });
	  },
	  inActiveSuggestion: function inActiveSuggestion(_ref2) {
	    var offsetKey = _ref2.offsetKey;
	
	    offset = offset['delete'](offsetKey);
	  },
	  updateSuggestion: function updateSuggestion(_ref3) {
	    var offsetKey = _ref3.offsetKey,
	        position = _ref3.position,
	        trigger = _ref3.trigger;
	
	    offset = offset.set(offsetKey, {
	      offsetKey: offsetKey,
	      position: position,
	      trigger: trigger
	    });
	  }
	};
	
	exports['default'] = mentionStore;
	module.exports = exports['default'];

/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = clearMention;
	
	var _draftJs = __webpack_require__(124);
	
	var _getSearchWord = __webpack_require__(474);
	
	var _getSearchWord2 = _interopRequireDefault(_getSearchWord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function clearMention(editorState) {
	  var selection = editorState.getSelection();
	  var searchWord = (0, _getSearchWord2['default'])(editorState, selection);
	  var begin = searchWord.begin,
	      end = searchWord.end;
	
	  var replacedContent = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), selection.merge({
	    anchorOffset: begin,
	    focusOffset: end
	  }), '', null);
	
	  var InsertSpaceContent = _draftJs.Modifier.insertText(replacedContent, replacedContent.getSelectionAfter(), ' ');
	
	  var newEditorState = _draftJs.EditorState.push(editorState, InsertSpaceContent, 'insert-mention');
	  return _draftJs.EditorState.forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
	}
	module.exports = exports['default'];

/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports['default'] = createMention;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Suggestions2 = __webpack_require__(2533);
	
	var _Suggestions3 = _interopRequireDefault(_Suggestions2);
	
	var _SuggestionPortal = __webpack_require__(2531);
	
	var _SuggestionPortal2 = _interopRequireDefault(_SuggestionPortal);
	
	var _MentionContent = __webpack_require__(2530);
	
	var _MentionContent2 = _interopRequireDefault(_MentionContent);
	
	var _mentionStore = __webpack_require__(2535);
	
	var _mentionStore2 = _interopRequireDefault(_mentionStore);
	
	var _exportContent = __webpack_require__(473);
	
	var _exportContent2 = _interopRequireDefault(_exportContent);
	
	var _getRegExp = __webpack_require__(1164);
	
	var _getRegExp2 = _interopRequireDefault(_getRegExp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function findWithRegex(regex, contentBlock, callback) {
	  // Get the text from the contentBlock
	  var text = contentBlock.getText();
	  var matchArr = void 0;
	  var start = void 0; // eslint-disable-line
	  // Go through all matches in the text and return the indizes to the callback
	  while ((matchArr = regex.exec(text)) !== null) {
	    // eslint-disable-line
	    start = matchArr.index;
	    callback(start, start + matchArr[0].length);
	  }
	}
	
	function mentionContentStrategy(contentBlock, callback, contentState) {
	  contentBlock.findEntityRanges(function (character) {
	    var entityKey = character.getEntity();
	    return entityKey && contentState.getEntity(entityKey).getType() === 'mention';
	  }, callback);
	}
	
	function noop() {}
	
	var MentionContentComponent = function MentionContentComponent(props) {
	  var entityKey = props.entityKey,
	      tag = props.tag,
	      callbacks = props.callbacks;
	
	  var contentState = callbacks.getEditorState().getCurrentContent();
	  var data = contentState.getEntity(entityKey).getData();
	  return _react2['default'].createElement(tag, (0, _extends3['default'])({}, props, { data: data }));
	};
	
	function createMention() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var callbacks = {
	    onChange: noop,
	    onUpArrow: noop,
	    onDownArrow: noop,
	    getEditorState: noop,
	    setEditorState: noop,
	    handleReturn: noop,
	    onBlur: noop
	  };
	  var componentProps = {
	    callbacks: callbacks,
	    mentionStore: _mentionStore2['default']
	  };
	  var suggestionRegex = (0, _getRegExp2['default'])(config.prefix);
	
	  var tag = config.tag || _MentionContent2['default'];
	  var decorators = [{
	    strategy: function strategy(contentBlock, callback) {
	      findWithRegex(suggestionRegex, contentBlock, callback);
	    },
	    component: function component(props) {
	      return _react2['default'].createElement(_SuggestionPortal2['default'], (0, _extends3['default'])({}, props, componentProps, {
	        style: config.mentionStyle,
	        suggestionRegex: (0, _getRegExp2['default'])(config.prefix)
	      }));
	    }
	  }];
	  if (config.mode !== 'immutable') {
	    decorators.unshift({
	      strategy: mentionContentStrategy,
	      component: function component(props) {
	        return _react2['default'].createElement(MentionContentComponent, (0, _extends3['default'])({ tag: tag }, props, { callbacks: callbacks }));
	      }
	    });
	  }
	
	  return {
	    name: 'mention',
	    Suggestions: function Suggestions(props) {
	      return _react2['default'].createElement(_Suggestions3['default'], (0, _extends3['default'])({}, props, componentProps, {
	        store: _mentionStore2['default']
	      }));
	    },
	    decorators: decorators,
	    onChange: function onChange(editorState) {
	      return callbacks.onChange ? callbacks.onChange(editorState) : editorState;
	    },
	    callbacks: callbacks,
	    'export': _exportContent2['default']
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = insertMention;
	
	var _draftJs = __webpack_require__(124);
	
	var _getSearchWord = __webpack_require__(474);
	
	var _getSearchWord2 = _interopRequireDefault(_getSearchWord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function insertMention(editorState, mention, data, mode) {
	  var entityMode = mode === 'immutable' ? 'IMMUTABLE' : 'MUTABLE';
	  var selection = editorState.getSelection();
	  var contentState = editorState.getCurrentContent();
	
	  contentState.createEntity('mention', entityMode, data || mention);
	  var searchWord = (0, _getSearchWord2['default'])(editorState, selection);
	  var begin = searchWord.begin,
	      end = searchWord.end;
	
	  var replacedContent = _draftJs.Modifier.replaceText(contentState, selection.merge({
	    anchorOffset: begin,
	    focusOffset: end
	  }), mention, null, contentState.getLastCreatedEntityKey());
	
	  var InsertSpaceContent = _draftJs.Modifier.insertText(replacedContent, replacedContent.getSelectionAfter(), ' ');
	
	  var newEditorState = _draftJs.EditorState.push(editorState, InsertSpaceContent, 'insert-mention');
	  return _draftJs.EditorState.forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
	}
	module.exports = exports['default'];

/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domScrollIntoView = __webpack_require__(295);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _has = __webpack_require__(1003);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _createBaseForm = __webpack_require__(1165);
	
	var _createBaseForm2 = _interopRequireDefault(_createBaseForm);
	
	var _createForm = __webpack_require__(2541);
	
	var _utils = __webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function computedStyle(el, prop) {
	  var getComputedStyle = window.getComputedStyle;
	  var style =
	  // If we have getComputedStyle
	  getComputedStyle ?
	  // Query it
	  // TODO: From CSS-Query notes, we might need (node, null) for FF
	  getComputedStyle(el) :
	
	  // Otherwise, we are in IE and use currentStyle
	  el.currentStyle;
	  if (style) {
	    return style[
	    // Switch to camelCase for CSSOM
	    // DEV: Grabbed from jQuery
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
	    prop.replace(/-(\w)/gi, function (word, letter) {
	      return letter.toUpperCase();
	    })];
	  }
	  return undefined;
	}
	
	function getScrollableContainer(n) {
	  var node = n;
	  var nodeName = void 0;
	  /* eslint no-cond-assign:0 */
	  while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
	    var overflowY = computedStyle(node, 'overflowY');
	    // https://stackoverflow.com/a/36900407/3040605
	    if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
	      return node;
	    }
	    node = node.parentNode;
	  }
	  return nodeName === 'body' ? node.ownerDocument : node;
	}
	
	var mixin = {
	  getForm: function getForm() {
	    return (0, _extends3['default'])({}, _createForm.mixin.getForm.call(this), {
	      validateFieldsAndScroll: this.validateFieldsAndScroll
	    });
	  },
	  validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
	    var _this = this;
	
	    var _getParams = (0, _utils.getParams)(ns, opt, cb),
	        names = _getParams.names,
	        callback = _getParams.callback,
	        options = _getParams.options;
	
	    var newCb = function newCb(error, values) {
	      if (error) {
	        var validNames = _this.fieldsStore.getValidFieldsName();
	        var firstNode = void 0;
	        var firstTop = void 0;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = validNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var name = _step.value;
	
	            if ((0, _has2['default'])(error, name)) {
	              var instance = _this.getFieldInstance(name);
	              if (instance) {
	                var node = _reactDom2['default'].findDOMNode(instance);
	                var top = node.getBoundingClientRect().top;
	                if (firstTop === undefined || firstTop > top) {
	                  firstTop = top;
	                  firstNode = node;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator['return']) {
	              _iterator['return']();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        if (firstNode) {
	          var c = options.container || getScrollableContainer(firstNode);
	          (0, _domScrollIntoView2['default'])(firstNode, c, (0, _extends3['default'])({
	            onlyScrollIfNeeded: true
	          }, options.scroll));
	        }
	      }
	
	      if (typeof callback === 'function') {
	        callback(error, values);
	      }
	    };
	
	    return this.validateFields(names, options, newCb);
	  }
	};
	
	function createDOMForm(option) {
	  return (0, _createBaseForm2['default'])((0, _extends3['default'])({}, option), [mixin]);
	}
	
	exports['default'] = createDOMForm;
	module.exports = exports['default'];

/***/ },
/* 2540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports['default'] = createFieldsStore;
	
	var _set = __webpack_require__(1009);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _createFormField = __webpack_require__(1166);
	
	var _createFormField2 = _interopRequireDefault(_createFormField);
	
	var _utils = __webpack_require__(475);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function partOf(a, b) {
	  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
	}
	
	var FieldsStore = function () {
	  function FieldsStore(fields) {
	    (0, _classCallCheck3['default'])(this, FieldsStore);
	
	    _initialiseProps.call(this);
	
	    this.fields = this.flattenFields(fields);
	    this.fieldsMeta = {};
	  }
	
	  (0, _createClass3['default'])(FieldsStore, [{
	    key: 'updateFields',
	    value: function updateFields(fields) {
	      this.fields = this.flattenFields(fields);
	    }
	  }, {
	    key: 'flattenFields',
	    value: function flattenFields(fields) {
	      return (0, _utils.flattenFields)(fields, function (_, node) {
	        return (0, _createFormField.isFormField)(node);
	      }, 'You must wrap field data with `createFormField`.');
	    }
	  }, {
	    key: 'flattenRegisteredFields',
	    value: function flattenRegisteredFields(fields) {
	      var validFieldsName = this.getAllFieldsName();
	      return (0, _utils.flattenFields)(fields, function (path) {
	        return validFieldsName.indexOf(path) >= 0;
	      }, 'You cannot set field before registering it.');
	    }
	  }, {
	    key: 'setFields',
	    value: function setFields(fields) {
	      var _this = this;
	
	      var fieldsMeta = this.fieldsMeta;
	      var nowFields = (0, _extends3['default'])({}, this.fields, fields);
	      var nowValues = {};
	      Object.keys(fieldsMeta).forEach(function (f) {
	        return nowValues[f] = _this.getValueFromFields(f, nowFields);
	      });
	      Object.keys(nowValues).forEach(function (f) {
	        var value = nowValues[f];
	        var fieldMeta = _this.getFieldMeta(f);
	        if (fieldMeta && fieldMeta.normalize) {
	          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
	          if (nowValue !== value) {
	            nowFields[f] = (0, _extends3['default'])({}, nowFields[f], {
	              value: nowValue
	            });
	          }
	        }
	      });
	      this.fields = nowFields;
	    }
	  }, {
	    key: 'resetFields',
	    value: function resetFields(ns) {
	      var fields = this.fields;
	
	      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
	      return names.reduce(function (acc, name) {
	        var field = fields[name];
	        if (field && 'value' in field) {
	          acc[name] = {};
	        }
	        return acc;
	      }, {});
	    }
	  }, {
	    key: 'setFieldMeta',
	    value: function setFieldMeta(name, meta) {
	      this.fieldsMeta[name] = meta;
	    }
	  }, {
	    key: 'getFieldMeta',
	    value: function getFieldMeta(name) {
	      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
	      return this.fieldsMeta[name];
	    }
	  }, {
	    key: 'getValueFromFields',
	    value: function getValueFromFields(name, fields) {
	      var field = fields[name];
	      if (field && 'value' in field) {
	        return field.value;
	      }
	      var fieldMeta = this.getFieldMeta(name);
	      return fieldMeta && fieldMeta.initialValue;
	    }
	  }, {
	    key: 'getValidFieldsName',
	    value: function getValidFieldsName() {
	      var _this2 = this;
	
	      var fieldsMeta = this.fieldsMeta;
	
	      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
	        return !_this2.getFieldMeta(name).hidden;
	      }) : [];
	    }
	  }, {
	    key: 'getAllFieldsName',
	    value: function getAllFieldsName() {
	      var fieldsMeta = this.fieldsMeta;
	
	      return fieldsMeta ? Object.keys(fieldsMeta) : [];
	    }
	  }, {
	    key: 'getValidFieldsFullName',
	    value: function getValidFieldsFullName(maybePartialName) {
	      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
	      return this.getValidFieldsName().filter(function (fullName) {
	        return maybePartialNames.some(function (partialName) {
	          return fullName === partialName || (0, _utils.startsWith)(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
	        });
	      });
	    }
	  }, {
	    key: 'getFieldValuePropValue',
	    value: function getFieldValuePropValue(fieldMeta) {
	      var name = fieldMeta.name,
	          getValueProps = fieldMeta.getValueProps,
	          valuePropName = fieldMeta.valuePropName;
	
	      var field = this.getField(name);
	      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
	      if (getValueProps) {
	        return getValueProps(fieldValue);
	      }
	      return (0, _defineProperty3['default'])({}, valuePropName, fieldValue);
	    }
	  }, {
	    key: 'getField',
	    value: function getField(name) {
	      return (0, _extends3['default'])({}, this.fields[name], {
	        name: name
	      });
	    }
	  }, {
	    key: 'getNotCollectedFields',
	    value: function getNotCollectedFields() {
	      var _this3 = this;
	
	      return this.getValidFieldsName().filter(function (name) {
	        return !_this3.fields[name];
	      }).map(function (name) {
	        return {
	          name: name,
	          dirty: false,
	          value: _this3.getFieldMeta(name).initialValue
	        };
	      }).reduce(function (acc, field) {
	        return (0, _set2['default'])(acc, field.name, (0, _createFormField2['default'])(field));
	      }, {});
	    }
	  }, {
	    key: 'getNestedAllFields',
	    value: function getNestedAllFields() {
	      var _this4 = this;
	
	      return Object.keys(this.fields).reduce(function (acc, name) {
	        return (0, _set2['default'])(acc, name, (0, _createFormField2['default'])(_this4.fields[name]));
	      }, this.getNotCollectedFields());
	    }
	  }, {
	    key: 'getFieldMember',
	    value: function getFieldMember(name, member) {
	      return this.getField(name)[member];
	    }
	  }, {
	    key: 'getNestedFields',
	    value: function getNestedFields(names, getter) {
	      var fields = names || this.getValidFieldsName();
	      return fields.reduce(function (acc, f) {
	        return (0, _set2['default'])(acc, f, getter(f));
	      }, {});
	    }
	  }, {
	    key: 'getNestedField',
	    value: function getNestedField(name, getter) {
	      var fullNames = this.getValidFieldsFullName(name);
	      if (fullNames.length === 0 || // Not registered
	      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
	      ) {
	          return getter(name);
	        }
	      var isArrayValue = fullNames[0][name.length] === '[';
	      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
	      return fullNames.reduce(function (acc, fullName) {
	        return (0, _set2['default'])(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
	      }, isArrayValue ? [] : {});
	    }
	  }, {
	    key: 'isValidNestedFieldName',
	
	
	    // @private
	    // BG: `a` and `a.b` cannot be use in the same form
	    value: function isValidNestedFieldName(name) {
	      var names = this.getAllFieldsName();
	      return names.every(function (n) {
	        return !partOf(n, name) && !partOf(name, n);
	      });
	    }
	  }, {
	    key: 'clearField',
	    value: function clearField(name) {
	      delete this.fields[name];
	      delete this.fieldsMeta[name];
	    }
	  }]);
	  return FieldsStore;
	}();
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.setFieldsInitialValue = function (initialValues) {
	    var flattenedInitialValues = _this5.flattenRegisteredFields(initialValues);
	    var fieldsMeta = _this5.fieldsMeta;
	    Object.keys(flattenedInitialValues).forEach(function (name) {
	      if (fieldsMeta[name]) {
	        _this5.setFieldMeta(name, (0, _extends3['default'])({}, _this5.getFieldMeta(name), {
	          initialValue: flattenedInitialValues[name]
	        }));
	      }
	    });
	  };
	
	  this.getAllValues = function () {
	    var fieldsMeta = _this5.fieldsMeta,
	        fields = _this5.fields;
	
	    return Object.keys(fieldsMeta).reduce(function (acc, name) {
	      return (0, _set2['default'])(acc, name, _this5.getValueFromFields(name, fields));
	    }, {});
	  };
	
	  this.getFieldsValue = function (names) {
	    return _this5.getNestedFields(names, _this5.getFieldValue);
	  };
	
	  this.getFieldValue = function (name) {
	    var fields = _this5.fields;
	
	    return _this5.getNestedField(name, function (fullName) {
	      return _this5.getValueFromFields(fullName, fields);
	    });
	  };
	
	  this.getFieldsError = function (names) {
	    return _this5.getNestedFields(names, _this5.getFieldError);
	  };
	
	  this.getFieldError = function (name) {
	    return _this5.getNestedField(name, function (fullName) {
	      return (0, _utils.getErrorStrs)(_this5.getFieldMember(fullName, 'errors'));
	    });
	  };
	
	  this.isFieldValidating = function (name) {
	    return _this5.getFieldMember(name, 'validating');
	  };
	
	  this.isFieldsValidating = function (ns) {
	    var names = ns || _this5.getValidFieldsName();
	    return names.some(function (n) {
	      return _this5.isFieldValidating(n);
	    });
	  };
	
	  this.isFieldTouched = function (name) {
	    return _this5.getFieldMember(name, 'touched');
	  };
	
	  this.isFieldsTouched = function (ns) {
	    var names = ns || _this5.getValidFieldsName();
	    return names.some(function (n) {
	      return _this5.isFieldTouched(n);
	    });
	  };
	};
	
	function createFieldsStore(fields) {
	  return new FieldsStore(fields);
	}
	module.exports = exports['default'];

/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mixin = undefined;
	
	var _createBaseForm = __webpack_require__(1165);
	
	var _createBaseForm2 = _interopRequireDefault(_createBaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var mixin = exports.mixin = {
	  getForm: function getForm() {
	    return {
	      getFieldsValue: this.fieldsStore.getFieldsValue,
	      getFieldValue: this.fieldsStore.getFieldValue,
	      getFieldInstance: this.getFieldInstance,
	      setFieldsValue: this.setFieldsValue,
	      setFields: this.setFields,
	      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
	      getFieldDecorator: this.getFieldDecorator,
	      getFieldProps: this.getFieldProps,
	      getFieldsError: this.fieldsStore.getFieldsError,
	      getFieldError: this.fieldsStore.getFieldError,
	      isFieldValidating: this.fieldsStore.isFieldValidating,
	      isFieldsValidating: this.fieldsStore.isFieldsValidating,
	      isFieldsTouched: this.fieldsStore.isFieldsTouched,
	      isFieldTouched: this.fieldsStore.isFieldTouched,
	      isSubmitting: this.isSubmitting,
	      submit: this.submit,
	      validateFields: this.validateFields,
	      resetFields: this.resetFields
	    };
	  }
	};
	
	function createForm(options) {
	  return (0, _createBaseForm2['default'])(options, [mixin]);
	}
	
	exports['default'] = createForm;

/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// https://github.com/hammerjs/hammer.js/issues/930
	// https://github.com/JedWatson/react-hammerjs/issues/14
	// require('hammerjs') when in a browser. This is safe because Hammer is only
	// invoked in componentDidMount, which is not executed on the server.
	var Hammer = typeof window !== 'undefined' ? __webpack_require__(2259) : undefined;
	
	var privateProps = {
		children: true,
		direction: true,
		options: true,
		recognizeWith: true,
		vertical: true
	};
	
	/**
	 * Hammer Component
	 * ================
	 */
	
	var handlerToEvent = {
		action: 'tap press',
		onDoubleTap: 'doubletap',
		onPan: 'pan',
		onPanCancel: 'pancancel',
		onPanEnd: 'panend',
		onPanStart: 'panstart',
		onPinch: 'pinch',
		onPinchCancel: 'pinchcancel',
		onPinchEnd: 'pinchend',
		onPinchIn: 'pinchin',
		onPinchOut: 'pinchout',
		onPinchStart: 'pinchstart',
		onPress: 'press',
		onPressUp: 'pressup',
		onRotate: 'rotate',
		onRotateCancel: 'rotatecancel',
		onRotateEnd: 'rotateend',
		onRotateMove: 'rotatemove',
		onRotateStart: 'rotatestart',
		onSwipe: 'swipe',
		onSwipeRight: 'swiperight',
		onSwipeLeft: 'swipeleft',
		onSwipeUp: 'swipeup',
		onSwipeDown: 'swipedown',
		onTap: 'tap'
	};
	
	Object.keys(handlerToEvent).forEach(function (i) {
		privateProps[i] = true;
	});
	
	function updateHammer(hammer, props) {
		var _this = this;
	
		if (props.hasOwnProperty('vertical')) {
			console.warn('vertical is deprecated, please use `direction` instead');
		}
	
		var directionProp = props.direction;
		if (directionProp || props.hasOwnProperty('vertical')) {
			var direction = directionProp ? directionProp : props.vertical ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL';
			hammer.get('pan').set({ direction: Hammer[direction] });
			hammer.get('swipe').set({ direction: Hammer[direction] });
		}
	
		if (props.options) {
			Object.keys(props.options).forEach(function (option) {
				if (option === 'recognizers') {
					Object.keys(props.options.recognizers).forEach(function (gesture) {
						var recognizer = hammer.get(gesture);
						recognizer.set(props.options.recognizers[gesture]);
						if (props.options.recognizers[gesture].requireFailure) {
							recognizer.requireFailure(props.options.recognizers[gesture].requireFailure);
						}
					}, _this);
				} else {
					var key = option;
					var optionObj = {};
					optionObj[key] = props.options[option];
					hammer.set(optionObj);
				}
			}, this);
		}
	
		if (props.recognizeWith) {
			Object.keys(props.recognizeWith).forEach(function (gesture) {
				var recognizer = hammer.get(gesture);
				recognizer.recognizeWith(props.recognizeWith[gesture]);
			}, this);
		}
	
		Object.keys(props).forEach(function (p) {
			var e = handlerToEvent[p];
			if (e) {
				hammer.off(e);
				hammer.on(e, props[p]);
			}
		});
	}
	
	var HammerComponent = function (_React$Component) {
		(0, _inherits3['default'])(HammerComponent, _React$Component);
	
		function HammerComponent() {
			(0, _classCallCheck3['default'])(this, HammerComponent);
			return (0, _possibleConstructorReturn3['default'])(this, (HammerComponent.__proto__ || Object.getPrototypeOf(HammerComponent)).apply(this, arguments));
		}
	
		(0, _createClass3['default'])(HammerComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.hammer = new Hammer(_reactDom2['default'].findDOMNode(this));
				updateHammer(this.hammer, this.props);
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate() {
				if (this.hammer) {
					updateHammer(this.hammer, this.props);
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				if (this.hammer) {
					this.hammer.stop();
					this.hammer.destroy();
				}
				this.hammer = null;
			}
		}, {
			key: 'render',
			value: function render() {
				var props = {};
	
				Object.keys(this.props).forEach(function (i) {
					if (!privateProps[i]) {
						props[i] = this.props[i];
					}
				}, this);
	
				// Reuse the child provided
				// This makes it flexible to use whatever element is wanted (div, ul, etc)
				return _react2['default'].cloneElement(_react2['default'].Children.only(this.props.children), props);
			}
		}]);
		return HammerComponent;
	}(_react2['default'].Component);
	
	HammerComponent.displayName = 'Hammer';
	HammerComponent.propTypes = {
		className: _propTypes2['default'].string
	};
	exports['default'] = HammerComponent;
	module.exports = exports['default'];

/***/ },
/* 2543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hammer = __webpack_require__(2542);
	
	var _Hammer2 = _interopRequireDefault(_Hammer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Hammer2['default'];
	module.exports = exports['default'];

/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rmcFeedback = __webpack_require__(3238);
	
	var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputHandler = function (_Component) {
	  (0, _inherits3['default'])(InputHandler, _Component);
	
	  function InputHandler() {
	    (0, _classCallCheck3['default'])(this, InputHandler);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  InputHandler.prototype.render = function render() {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        disabled = _props.disabled,
	        onTouchStart = _props.onTouchStart,
	        onTouchEnd = _props.onTouchEnd,
	        onMouseDown = _props.onMouseDown,
	        onMouseUp = _props.onMouseUp,
	        onMouseLeave = _props.onMouseLeave,
	        otherProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'disabled', 'onTouchStart', 'onTouchEnd', 'onMouseDown', 'onMouseUp', 'onMouseLeave']);
	
	    return _react2['default'].createElement(
	      _rmcFeedback2['default'],
	      {
	        disabled: disabled,
	        onTouchStart: onTouchStart,
	        onTouchEnd: onTouchEnd,
	        onMouseDown: onMouseDown,
	        onMouseUp: onMouseUp,
	        onMouseLeave: onMouseLeave,
	        activeClassName: prefixCls + '-handler-active'
	      },
	      _react2['default'].createElement('span', otherProps)
	    );
	  };
	
	  return InputHandler;
	}(_react.Component);
	
	InputHandler.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  onTouchStart: _propTypes2['default'].func,
	  onTouchEnd: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onMouseUp: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func
	};
	
	exports['default'] = InputHandler;
	module.exports = exports['default'];

/***/ },
/* 2545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _InputHandler = __webpack_require__(2544);
	
	var _InputHandler2 = _interopRequireDefault(_InputHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function preventDefault(e) {
	  e.preventDefault();
	}
	
	function defaultParser(input) {
	  return input.replace(/[^\w\.-]+/g, '');
	}
	
	/**
	 * When click and hold on a button - the speed of auto changin the value.
	 */
	var SPEED = 200;
	
	/**
	 * When click and hold on a button - the delay before auto changin the value.
	 */
	var DELAY = 600;
	
	/**
	 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
	 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
	 */
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var InputNumber = function (_React$Component) {
	  (0, _inherits3['default'])(InputNumber, _React$Component);
	
	  function InputNumber(props) {
	    (0, _classCallCheck3['default'])(this, InputNumber);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = void 0;
	    if ('value' in props) {
	      value = props.value;
	    } else {
	      value = props.defaultValue;
	    }
	    value = _this.toNumber(value);
	
	    _this.state = {
	      inputValue: _this.toPrecisionAsStep(value),
	      value: value,
	      focused: props.autoFocus
	    };
	    return _this;
	  }
	
	  InputNumber.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate();
	  };
	
	  InputNumber.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if ('value' in nextProps) {
	      var value = this.state.focused ? nextProps.value : this.getValidValue(nextProps.value, nextProps.min, nextProps.max);
	      this.setState({
	        value: value,
	        inputValue: this.inputting ? value : this.toPrecisionAsStep(value)
	      });
	    }
	  };
	
	  InputNumber.prototype.componentWillUpdate = function componentWillUpdate() {
	    try {
	      this.start = this.input.selectionStart;
	      this.end = this.input.selectionEnd;
	    } catch (e) {
	      // Fix error in Chrome:
	      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	      // http://stackoverflow.com/q/21177489/3040605
	    }
	  };
	
	  InputNumber.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.props.focusOnUpDown && this.state.focused) {
	      var selectionRange = this.input.setSelectionRange;
	      if (selectionRange && typeof selectionRange === 'function' && this.start !== undefined && this.end !== undefined && this.start !== this.end) {
	        this.input.setSelectionRange(this.start, this.end);
	      } else {
	        this.focus();
	      }
	    }
	  };
	
	  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stop();
	  };
	
	  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
	    var val = value;
	    if (val === '') {
	      val = '';
	    } else if (!this.isNotCompleteNumber(val)) {
	      val = this.getValidValue(val);
	    } else {
	      val = this.state.value;
	    }
	    return this.toNumber(val);
	  };
	
	  InputNumber.prototype.getRatio = function getRatio(e) {
	    var ratio = 1;
	    if (e.metaKey || e.ctrlKey) {
	      ratio = 0.1;
	    } else if (e.shiftKey) {
	      ratio = 10;
	    }
	    return ratio;
	  };
	
	  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
	    // optimize for chinese input expierence
	    // https://github.com/ant-design/ant-design/issues/8196
	    return e.target.value.trim().replace(/。/g, '.');
	  };
	
	  InputNumber.prototype.getValidValue = function getValidValue(value) {
	    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.min;
	    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.max;
	
	    var val = parseFloat(value, 10);
	    // https://github.com/ant-design/ant-design/issues/7358
	    if (isNaN(val)) {
	      return value;
	    }
	    if (val < min) {
	      val = min;
	    }
	    if (val > max) {
	      val = max;
	    }
	    return val;
	  };
	
	  InputNumber.prototype.setValue = function setValue(v, callback) {
	    // trigger onChange
	    var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? undefined : parseFloat(v, 10);
	    var changed = newValue !== this.state.value || '' + newValue !== '' + this.state.inputValue; // https://github.com/ant-design/ant-design/issues/7363
	    if (!('value' in this.props)) {
	      this.setState({
	        value: newValue,
	        inputValue: this.toPrecisionAsStep(v)
	      }, callback);
	    } else {
	      // always set input value same as value
	      this.setState({
	        inputValue: this.toPrecisionAsStep(this.state.value)
	      }, callback);
	    }
	    if (changed) {
	      this.props.onChange(newValue);
	    }
	  };
	
	  InputNumber.prototype.getPrecision = function getPrecision(value) {
	    if ('precision' in this.props) {
	      return this.props.precision;
	    }
	    var valueString = value.toString();
	    if (valueString.indexOf('e-') >= 0) {
	      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
	    }
	    var precision = 0;
	    if (valueString.indexOf('.') >= 0) {
	      precision = valueString.length - valueString.indexOf('.') - 1;
	    }
	    return precision;
	  };
	
	  // step={1.0} value={1.51}
	  // press +
	  // then value should be 2.51, rather than 2.5
	  // if this.props.precision is undefined
	  // https://github.com/react-component/input-number/issues/39
	
	
	  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
	    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    if ('precision' in this.props) {
	      return this.props.precision;
	    }
	    var step = this.props.step;
	
	    var ratioPrecision = this.getPrecision(ratio);
	    var stepPrecision = this.getPrecision(step);
	    var currentValuePrecision = this.getPrecision(currentValue);
	    if (!currentValue) {
	      return ratioPrecision + stepPrecision;
	    }
	    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
	  };
	
	  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
	    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    var precision = this.getMaxPrecision(currentValue, ratio);
	    return Math.pow(10, precision);
	  };
	
	  InputNumber.prototype.focus = function focus() {
	    this.input.focus();
	  };
	
	  InputNumber.prototype.formatWrapper = function formatWrapper(num) {
	    if (this.props.formatter) {
	      return this.props.formatter(num);
	    }
	    return num;
	  };
	
	  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
	    if (this.isNotCompleteNumber(num) || num === '') {
	      return num;
	    }
	    var precision = Math.abs(this.getMaxPrecision(num));
	    if (precision === 0) {
	      return num.toString();
	    }
	    if (!isNaN(precision)) {
	      return Number(num).toFixed(precision);
	    }
	    return num.toString();
	  };
	
	  // '1.' '1x' 'xx' '' => are not complete numbers
	
	
	  InputNumber.prototype.isNotCompleteNumber = function isNotCompleteNumber(num) {
	    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
	  };
	
	  InputNumber.prototype.toNumber = function toNumber(num) {
	    if (this.isNotCompleteNumber(num)) {
	      return num;
	    }
	    if ('precision' in this.props) {
	      return Number(Number(num).toFixed(this.props.precision));
	    }
	    return Number(num);
	  };
	
	  // '1.0' '1.00'  => may be a inputing number
	
	
	  InputNumber.prototype.toNumberWhenUserInput = function toNumberWhenUserInput(num) {
	    // num.length > 16 => prevent input large number will became Infinity
	    if ((/\.\d*0$/.test(num) || num.length > 16) && this.state.focused) {
	      return num;
	    }
	    return this.toNumber(num);
	  };
	
	  InputNumber.prototype.upStep = function upStep(val, rat) {
	    var _props = this.props,
	        step = _props.step,
	        min = _props.min;
	
	    var precisionFactor = this.getPrecisionFactor(val, rat);
	    var precision = Math.abs(this.getMaxPrecision(val, rat));
	    var result = void 0;
	    if (typeof val === 'number') {
	      result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
	    } else {
	      result = min === -Infinity ? step : min;
	    }
	    return this.toNumber(result);
	  };
	
	  InputNumber.prototype.downStep = function downStep(val, rat) {
	    var _props2 = this.props,
	        step = _props2.step,
	        min = _props2.min;
	
	    var precisionFactor = this.getPrecisionFactor(val, rat);
	    var precision = Math.abs(this.getMaxPrecision(val, rat));
	    var result = void 0;
	    if (typeof val === 'number') {
	      result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
	    } else {
	      result = min === -Infinity ? -step : min;
	    }
	    return this.toNumber(result);
	  };
	
	  InputNumber.prototype.step = function step(type, e) {
	    var _this2 = this;
	
	    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var recursive = arguments[3];
	
	    this.stop();
	    if (e) {
	      e.persist();
	      e.preventDefault();
	    }
	    var props = this.props;
	    if (props.disabled) {
	      return;
	    }
	    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
	    if (this.isNotCompleteNumber(value)) {
	      return;
	    }
	    var val = this[type + 'Step'](value, ratio);
	    var outOfRange = val > props.max || val < props.min;
	    if (val > props.max) {
	      val = props.max;
	    } else if (val < props.min) {
	      val = props.min;
	    }
	    this.setValue(val);
	    this.setState({
	      focused: true
	    });
	    if (outOfRange) {
	      return;
	    }
	    this.autoStepTimer = setTimeout(function () {
	      _this2[type](e, ratio, true);
	    }, recursive ? SPEED : DELAY);
	  };
	
	  InputNumber.prototype.render = function render() {
	    var _classNames;
	
	    var props = (0, _extends3['default'])({}, this.props);
	    var prefixCls = props.prefixCls,
	        disabled = props.disabled,
	        readOnly = props.readOnly,
	        useTouch = props.useTouch;
	
	    var classes = (0, _classnames2['default'])((_classNames = {}, _classNames[prefixCls] = true, _classNames[props.className] = !!props.className, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-focused'] = this.state.focused, _classNames));
	    var upDisabledClass = '';
	    var downDisabledClass = '';
	    var value = this.state.value;
	
	    if (value || value === 0) {
	      if (!isNaN(value)) {
	        var val = Number(value);
	        if (val >= props.max) {
	          upDisabledClass = prefixCls + '-handler-up-disabled';
	        }
	        if (val <= props.min) {
	          downDisabledClass = prefixCls + '-handler-down-disabled';
	        }
	      } else {
	        upDisabledClass = prefixCls + '-handler-up-disabled';
	        downDisabledClass = prefixCls + '-handler-down-disabled';
	      }
	    }
	
	    var editable = !props.readOnly && !props.disabled;
	
	    // focus state, show input value
	    // unfocus state, show valid value
	    var inputDisplayValue = void 0;
	    if (this.state.focused) {
	      inputDisplayValue = this.state.inputValue;
	    } else {
	      inputDisplayValue = this.toPrecisionAsStep(this.state.value);
	    }
	
	    if (inputDisplayValue === undefined || inputDisplayValue === null) {
	      inputDisplayValue = '';
	    }
	
	    var upEvents = void 0;
	    var downEvents = void 0;
	    if (useTouch) {
	      upEvents = {
	        onTouchStart: editable && !upDisabledClass ? this.up : noop,
	        onTouchEnd: this.stop
	      };
	      downEvents = {
	        onTouchStart: editable && !downDisabledClass ? this.down : noop,
	        onTouchEnd: this.stop
	      };
	    } else {
	      upEvents = {
	        onMouseDown: editable && !upDisabledClass ? this.up : noop,
	        onMouseUp: this.stop,
	        onMouseLeave: this.stop
	      };
	      downEvents = {
	        onMouseDown: editable && !downDisabledClass ? this.down : noop,
	        onMouseUp: this.stop,
	        onMouseLeave: this.stop
	      };
	    }
	    var inputDisplayValueFormat = this.formatWrapper(inputDisplayValue);
	    var isUpDisabled = !!upDisabledClass || disabled || readOnly;
	    var isDownDisabled = !!downDisabledClass || disabled || readOnly;
	    // ref for test
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: classes,
	        style: props.style,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseOver: props.onMouseOver,
	        onMouseOut: props.onMouseOut
	      },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-handler-wrap' },
	        _react2['default'].createElement(
	          _InputHandler2['default'],
	          (0, _extends3['default'])({
	            ref: 'up',
	            disabled: isUpDisabled,
	            prefixCls: prefixCls,
	            unselectable: 'unselectable'
	          }, upEvents, {
	            role: 'button',
	            'aria-label': 'Increase Value',
	            'aria-disabled': !!isUpDisabled,
	            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
	          }),
	          this.props.upHandler || _react2['default'].createElement('span', {
	            unselectable: 'unselectable',
	            className: prefixCls + '-handler-up-inner',
	            onClick: preventDefault
	          })
	        ),
	        _react2['default'].createElement(
	          _InputHandler2['default'],
	          (0, _extends3['default'])({
	            ref: 'down',
	            disabled: isDownDisabled,
	            prefixCls: prefixCls,
	            unselectable: 'unselectable'
	          }, downEvents, {
	            role: 'button',
	            'aria-label': 'Decrease Value',
	            'aria-disabled': !!isDownDisabled,
	            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
	          }),
	          this.props.downHandler || _react2['default'].createElement('span', {
	            unselectable: 'unselectable',
	            className: prefixCls + '-handler-down-inner',
	            onClick: preventDefault
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        {
	          className: prefixCls + '-input-wrap',
	          role: 'spinbutton',
	          'aria-valuemin': props.min,
	          'aria-valuemax': props.max,
	          'aria-valuenow': value
	        },
	        _react2['default'].createElement('input', {
	          required: props.required,
	          type: props.type,
	          placeholder: props.placeholder,
	          onClick: props.onClick,
	          className: prefixCls + '-input',
	          tabIndex: props.tabIndex,
	          autoComplete: 'off',
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onKeyDown: editable ? this.onKeyDown : noop,
	          onKeyUp: editable ? this.onKeyUp : noop,
	          autoFocus: props.autoFocus,
	          maxLength: props.maxLength,
	          readOnly: props.readOnly,
	          disabled: props.disabled,
	          max: props.max,
	          min: props.min,
	          step: props.step,
	          name: props.name,
	          id: props.id,
	          onChange: this.onChange,
	          ref: this.saveInput,
	          value: inputDisplayValueFormat
	        })
	      )
	    );
	  };
	
	  return InputNumber;
	}(_react2['default'].Component);
	
	InputNumber.propTypes = {
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  focusOnUpDown: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  onChange: _propTypes2['default'].func,
	  onKeyDown: _propTypes2['default'].func,
	  onKeyUp: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  readOnly: _propTypes2['default'].bool,
	  max: _propTypes2['default'].number,
	  min: _propTypes2['default'].number,
	  step: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  upHandler: _propTypes2['default'].node,
	  downHandler: _propTypes2['default'].node,
	  useTouch: _propTypes2['default'].bool,
	  formatter: _propTypes2['default'].func,
	  parser: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseOver: _propTypes2['default'].func,
	  onMouseOut: _propTypes2['default'].func,
	  precision: _propTypes2['default'].number,
	  required: _propTypes2['default'].bool
	};
	InputNumber.defaultProps = {
	  focusOnUpDown: true,
	  useTouch: false,
	  prefixCls: 'rc-input-number',
	  min: -MAX_SAFE_INTEGER,
	  step: 1,
	  style: {},
	  onChange: noop,
	  onKeyDown: noop,
	  onFocus: noop,
	  onBlur: noop,
	  parser: defaultParser,
	  required: false
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onKeyDown = function (e) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (e.keyCode === 38) {
	      var ratio = _this3.getRatio(e);
	      _this3.up(e, ratio);
	      _this3.stop();
	    } else if (e.keyCode === 40) {
	      var _ratio = _this3.getRatio(e);
	      _this3.down(e, _ratio);
	      _this3.stop();
	    }
	    var onKeyDown = _this3.props.onKeyDown;
	
	    if (onKeyDown) {
	      onKeyDown.apply(undefined, [e].concat(args));
	    }
	  };
	
	  this.onKeyUp = function (e) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    _this3.stop();
	    var onKeyUp = _this3.props.onKeyUp;
	
	    if (onKeyUp) {
	      onKeyUp.apply(undefined, [e].concat(args));
	    }
	  };
	
	  this.onChange = function (e) {
	    if (_this3.state.focused) {
	      _this3.inputting = true;
	    }
	    var input = _this3.props.parser(_this3.getValueFromEvent(e));
	    _this3.setState({ inputValue: input });
	    _this3.props.onChange(_this3.toNumberWhenUserInput(input)); // valid number or invalid string
	  };
	
	  this.onFocus = function () {
	    var _props3;
	
	    _this3.setState({
	      focused: true
	    });
	    (_props3 = _this3.props).onFocus.apply(_props3, arguments);
	  };
	
	  this.onBlur = function (e) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    _this3.inputting = false;
	    _this3.setState({
	      focused: false
	    });
	    var value = _this3.getCurrentValidValue(_this3.state.inputValue);
	    e.persist(); // fix https://github.com/react-component/input-number/issues/51
	    _this3.setValue(value, function () {
	      var _props4;
	
	      (_props4 = _this3.props).onBlur.apply(_props4, [e].concat(args));
	    });
	  };
	
	  this.stop = function () {
	    if (_this3.autoStepTimer) {
	      clearTimeout(_this3.autoStepTimer);
	    }
	  };
	
	  this.down = function (e, ratio, recursive) {
	    _this3.step('down', e, ratio, recursive);
	  };
	
	  this.up = function (e, ratio, recursive) {
	    _this3.step('up', e, ratio, recursive);
	  };
	
	  this.saveInput = function (node) {
	    _this3.input = node;
	  };
	};
	
	exports['default'] = InputNumber;
	module.exports = exports['default'];

/***/ },
/* 2546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DOMWrap = (0, _createReactClass2['default'])({
	  displayName: 'DOMWrap',
	
	  propTypes: {
	    tag: _propTypes2['default'].string,
	    hiddenClassName: _propTypes2['default'].string,
	    visible: _propTypes2['default'].bool
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      tag: 'div'
	    };
	  },
	  render: function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	    if (!props.visible) {
	      props.className = props.className || '';
	      props.className += ' ' + props.hiddenClassName;
	    }
	    var Tag = props.tag;
	    delete props.tag;
	    delete props.hiddenClassName;
	    delete props.visible;
	    return _react2['default'].createElement(Tag, props);
	  }
	});
	
	exports['default'] = DOMWrap;
	module.exports = exports['default'];

/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Divider = (0, _createReactClass2['default'])({
	  displayName: 'Divider',
	
	  propTypes: {
	    className: _propTypes2['default'].string,
	    rootPrefixCls: _propTypes2['default'].string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    // To fix keyboard UX.
	    return { disabled: true };
	  },
	  render: function render() {
	    var _props = this.props,
	        _props$className = _props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        rootPrefixCls = _props.rootPrefixCls;
	
	    return _react2['default'].createElement('li', { className: className + ' ' + rootPrefixCls + '-item-divider' });
	  }
	});
	
	exports['default'] = Divider;
	module.exports = exports['default'];

/***/ },
/* 2548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _MenuMixin = __webpack_require__(1167);
	
	var _MenuMixin2 = _interopRequireDefault(_MenuMixin);
	
	var _util = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// import React from 'react';
	var Menu = (0, _createReactClass2['default'])({
	  displayName: 'Menu',
	
	  propTypes: {
	    defaultSelectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    selectedKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    defaultOpenKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    openKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    mode: _propTypes2['default'].oneOf(['horizontal', 'vertical', 'vertical-left', 'vertical-right', 'inline']),
	    getPopupContainer: _propTypes2['default'].func,
	    onClick: _propTypes2['default'].func,
	    onSelect: _propTypes2['default'].func,
	    onDeselect: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    openTransitionName: _propTypes2['default'].string,
	    openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    subMenuOpenDelay: _propTypes2['default'].number,
	    subMenuCloseDelay: _propTypes2['default'].number,
	    forceSubMenuRender: _propTypes2['default'].bool,
	    triggerSubMenuAction: _propTypes2['default'].string,
	    level: _propTypes2['default'].number,
	    selectable: _propTypes2['default'].bool,
	    multiple: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any
	  },
	
	  mixins: [_MenuMixin2['default']],
	
	  isRootMenu: true,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      selectable: true,
	      onClick: _util.noop,
	      onSelect: _util.noop,
	      onOpenChange: _util.noop,
	      onDeselect: _util.noop,
	      defaultSelectedKeys: [],
	      defaultOpenKeys: [],
	      subMenuOpenDelay: 0.1,
	      subMenuCloseDelay: 0.1,
	      triggerSubMenuAction: 'hover'
	    };
	  },
	  getInitialState: function getInitialState() {
	    var props = this.props;
	    var selectedKeys = props.defaultSelectedKeys;
	    var openKeys = props.defaultOpenKeys;
	    if ('selectedKeys' in props) {
	      selectedKeys = props.selectedKeys || [];
	    }
	    if ('openKeys' in props) {
	      openKeys = props.openKeys || [];
	    }
	    return {
	      selectedKeys: selectedKeys,
	      openKeys: openKeys
	    };
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if ('selectedKeys' in nextProps) {
	      this.setState({
	        selectedKeys: nextProps.selectedKeys || []
	      });
	    }
	    if ('openKeys' in nextProps) {
	      this.setState({
	        openKeys: nextProps.openKeys || []
	      });
	    }
	  },
	  onSelect: function onSelect(selectInfo) {
	    var props = this.props;
	    if (props.selectable) {
	      // root menu
	      var selectedKeys = this.state.selectedKeys;
	      var selectedKey = selectInfo.key;
	      if (props.multiple) {
	        selectedKeys = selectedKeys.concat([selectedKey]);
	      } else {
	        selectedKeys = [selectedKey];
	      }
	      if (!('selectedKeys' in props)) {
	        this.setState({
	          selectedKeys: selectedKeys
	        });
	      }
	      props.onSelect((0, _extends3['default'])({}, selectInfo, {
	        selectedKeys: selectedKeys
	      }));
	    }
	  },
	  onClick: function onClick(e) {
	    this.props.onClick(e);
	  },
	  onOpenChange: function onOpenChange(event) {
	    var props = this.props;
	    var openKeys = this.state.openKeys.concat();
	    var changed = false;
	    var processSingle = function processSingle(e) {
	      var oneChanged = false;
	      if (e.open) {
	        oneChanged = openKeys.indexOf(e.key) === -1;
	        if (oneChanged) {
	          openKeys.push(e.key);
	        }
	      } else {
	        var index = openKeys.indexOf(e.key);
	        oneChanged = index !== -1;
	        if (oneChanged) {
	          openKeys.splice(index, 1);
	        }
	      }
	      changed = changed || oneChanged;
	    };
	    if (Array.isArray(event)) {
	      // batch change call
	      event.forEach(processSingle);
	    } else {
	      processSingle(event);
	    }
	    if (changed) {
	      if (!('openKeys' in this.props)) {
	        this.setState({ openKeys: openKeys });
	      }
	      props.onOpenChange(openKeys);
	    }
	  },
	  onDeselect: function onDeselect(selectInfo) {
	    var props = this.props;
	    if (props.selectable) {
	      var selectedKeys = this.state.selectedKeys.concat();
	      var selectedKey = selectInfo.key;
	      var index = selectedKeys.indexOf(selectedKey);
	      if (index !== -1) {
	        selectedKeys.splice(index, 1);
	      }
	      if (!('selectedKeys' in props)) {
	        this.setState({
	          selectedKeys: selectedKeys
	        });
	      }
	      props.onDeselect((0, _extends3['default'])({}, selectInfo, {
	        selectedKeys: selectedKeys
	      }));
	    }
	  },
	  getOpenTransitionName: function getOpenTransitionName() {
	    var props = this.props;
	    var transitionName = props.openTransitionName;
	    var animationName = props.openAnimation;
	    if (!transitionName && typeof animationName === 'string') {
	      transitionName = props.prefixCls + '-open-' + animationName;
	    }
	    return transitionName;
	  },
	  isInlineMode: function isInlineMode() {
	    return this.props.mode === 'inline';
	  },
	  lastOpenSubMenu: function lastOpenSubMenu() {
	    var lastOpen = [];
	    var openKeys = this.state.openKeys;
	
	    if (openKeys.length) {
	      lastOpen = this.getFlatInstanceArray().filter(function (c) {
	        return c && openKeys.indexOf(c.props.eventKey) !== -1;
	      });
	    }
	    return lastOpen[0];
	  },
	  renderMenuItem: function renderMenuItem(c, i, subIndex) {
	    if (!c) {
	      return null;
	    }
	    var state = this.state;
	    var extraProps = {
	      openKeys: state.openKeys,
	      selectedKeys: state.selectedKeys,
	      triggerSubMenuAction: this.props.triggerSubMenuAction
	    };
	    return this.renderCommonMenuItem(c, i, subIndex, extraProps);
	  },
	  render: function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	    props.className += ' ' + props.prefixCls + '-root';
	    return this.renderRoot(props);
	  }
	});
	
	exports['default'] = Menu;
	module.exports = exports['default'];

/***/ },
/* 2549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _util = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/no-is-mounted:0 */
	
	var MenuItem = (0, _createReactClass2['default'])({
	  displayName: 'MenuItem',
	
	  propTypes: {
	    rootPrefixCls: _propTypes2['default'].string,
	    eventKey: _propTypes2['default'].string,
	    active: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any,
	    selectedKeys: _propTypes2['default'].array,
	    disabled: _propTypes2['default'].bool,
	    title: _propTypes2['default'].string,
	    onItemHover: _propTypes2['default'].func,
	    onSelect: _propTypes2['default'].func,
	    onClick: _propTypes2['default'].func,
	    onDeselect: _propTypes2['default'].func,
	    parentMenu: _propTypes2['default'].object,
	    onDestroy: _propTypes2['default'].func,
	    onMouseEnter: _propTypes2['default'].func,
	    onMouseLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onSelect: _util.noop,
	      onMouseEnter: _util.noop,
	      onMouseLeave: _util.noop
	    };
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var props = this.props;
	    if (props.onDestroy) {
	      props.onDestroy(props.eventKey);
	    }
	  },
	  onKeyDown: function onKeyDown(e) {
	    var keyCode = e.keyCode;
	    if (keyCode === _KeyCode2['default'].ENTER) {
	      this.onClick(e);
	      return true;
	    }
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    var _props = this.props,
	        eventKey = _props.eventKey,
	        onItemHover = _props.onItemHover,
	        onMouseLeave = _props.onMouseLeave;
	
	    onItemHover({
	      key: eventKey,
	      hover: false
	    });
	    onMouseLeave({
	      key: eventKey,
	      domEvent: e
	    });
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    var _props2 = this.props,
	        eventKey = _props2.eventKey,
	        onItemHover = _props2.onItemHover,
	        onMouseEnter = _props2.onMouseEnter;
	
	    onItemHover({
	      key: eventKey,
	      hover: true
	    });
	    onMouseEnter({
	      key: eventKey,
	      domEvent: e
	    });
	  },
	  onClick: function onClick(e) {
	    var _props3 = this.props,
	        eventKey = _props3.eventKey,
	        multiple = _props3.multiple,
	        onClick = _props3.onClick,
	        onSelect = _props3.onSelect,
	        onDeselect = _props3.onDeselect;
	
	    var selected = this.isSelected();
	    var info = {
	      key: eventKey,
	      keyPath: [eventKey],
	      item: this,
	      domEvent: e
	    };
	    onClick(info);
	    if (multiple) {
	      if (selected) {
	        onDeselect(info);
	      } else {
	        onSelect(info);
	      }
	    } else if (!selected) {
	      onSelect(info);
	    }
	  },
	  getPrefixCls: function getPrefixCls() {
	    return this.props.rootPrefixCls + '-item';
	  },
	  getActiveClassName: function getActiveClassName() {
	    return this.getPrefixCls() + '-active';
	  },
	  getSelectedClassName: function getSelectedClassName() {
	    return this.getPrefixCls() + '-selected';
	  },
	  getDisabledClassName: function getDisabledClassName() {
	    return this.getPrefixCls() + '-disabled';
	  },
	  isSelected: function isSelected() {
	    return this.props.selectedKeys.indexOf(this.props.eventKey) !== -1;
	  },
	  render: function render() {
	    var _classNames;
	
	    var props = this.props;
	    var selected = this.isSelected();
	    var className = (0, _classnames2['default'])(this.getPrefixCls(), props.className, (_classNames = {}, _classNames[this.getActiveClassName()] = !props.disabled && props.active, _classNames[this.getSelectedClassName()] = selected, _classNames[this.getDisabledClassName()] = props.disabled, _classNames));
	    var attrs = (0, _extends3['default'])({}, props.attribute, {
	      title: props.title,
	      className: className,
	      role: 'menuitem',
	      'aria-selected': selected,
	      'aria-disabled': props.disabled
	    });
	    var mouseEvent = {};
	    if (!props.disabled) {
	      mouseEvent = {
	        onClick: this.onClick,
	        onMouseLeave: this.onMouseLeave,
	        onMouseEnter: this.onMouseEnter
	      };
	    }
	    var style = (0, _extends3['default'])({}, props.style);
	    if (props.mode === 'inline') {
	      style.paddingLeft = props.inlineIndent * props.level;
	    }
	    return _react2['default'].createElement(
	      'li',
	      (0, _extends3['default'])({}, attrs, mouseEvent, {
	        style: style
	      }),
	      props.children
	    );
	  }
	});
	
	MenuItem.isMenuItem = 1;
	
	exports['default'] = MenuItem;
	module.exports = exports['default'];

/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MenuItemGroup = (0, _createReactClass2['default'])({
	  displayName: 'MenuItemGroup',
	
	  propTypes: {
	    renderMenuItem: _propTypes2['default'].func,
	    index: _propTypes2['default'].number,
	    className: _propTypes2['default'].string,
	    rootPrefixCls: _propTypes2['default'].string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    // To fix keyboard UX.
	    return { disabled: true };
	  },
	  renderInnerMenuItem: function renderInnerMenuItem(item, subIndex) {
	    var _props = this.props,
	        renderMenuItem = _props.renderMenuItem,
	        index = _props.index;
	
	    return renderMenuItem(item, index, subIndex);
	  },
	  render: function render() {
	    var props = this.props;
	    var _props$className = props.className,
	        className = _props$className === undefined ? '' : _props$className,
	        rootPrefixCls = props.rootPrefixCls;
	
	    var titleClassName = rootPrefixCls + '-item-group-title';
	    var listClassName = rootPrefixCls + '-item-group-list';
	    return _react2['default'].createElement(
	      'li',
	      { className: className + ' ' + rootPrefixCls + '-item-group' },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: titleClassName,
	          title: typeof props.title === 'string' ? props.title : undefined
	        },
	        props.title
	      ),
	      _react2['default'].createElement(
	        'ul',
	        { className: listClassName },
	        _react2['default'].Children.map(props.children, this.renderInnerMenuItem)
	      )
	    );
	  }
	});
	
	MenuItemGroup.isMenuItemGroup = true;
	
	exports['default'] = MenuItemGroup;
	module.exports = exports['default'];

/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _SubPopupMenu = __webpack_require__(2552);
	
	var _SubPopupMenu2 = _interopRequireDefault(_SubPopupMenu);
	
	var _placements = __webpack_require__(2553);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	var _util = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var guid = 0;
	
	var popupPlacementMap = {
	  horizontal: 'bottomLeft',
	  vertical: 'rightTop',
	  'vertical-left': 'rightTop',
	  'vertical-right': 'leftTop'
	};
	
	var SubMenu = (0, _createReactClass2['default'])({
	  displayName: 'SubMenu',
	
	  propTypes: {
	    parentMenu: _propTypes2['default'].object,
	    title: _propTypes2['default'].node,
	    children: _propTypes2['default'].any,
	    selectedKeys: _propTypes2['default'].array,
	    openKeys: _propTypes2['default'].array,
	    onClick: _propTypes2['default'].func,
	    onOpenChange: _propTypes2['default'].func,
	    rootPrefixCls: _propTypes2['default'].string,
	    eventKey: _propTypes2['default'].string,
	    multiple: _propTypes2['default'].bool,
	    active: _propTypes2['default'].bool, // TODO: remove
	    onItemHover: _propTypes2['default'].func,
	    onSelect: _propTypes2['default'].func,
	    triggerSubMenuAction: _propTypes2['default'].string,
	    onDeselect: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    onMouseEnter: _propTypes2['default'].func,
	    onMouseLeave: _propTypes2['default'].func,
	    onTitleMouseEnter: _propTypes2['default'].func,
	    onTitleMouseLeave: _propTypes2['default'].func,
	    onTitleClick: _propTypes2['default'].func
	  },
	
	  isRootMenu: false,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onMouseEnter: _util.noop,
	      onMouseLeave: _util.noop,
	      onTitleMouseEnter: _util.noop,
	      onTitleMouseLeave: _util.noop,
	      onTitleClick: _util.noop,
	      title: ''
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.isSubMenu = 1;
	    return {
	      defaultActiveFirst: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    this.componentDidUpdate();
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    var _this = this;
	
	    var _props = this.props,
	        mode = _props.mode,
	        parentMenu = _props.parentMenu;
	
	    if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.isOpen()) {
	      return;
	    }
	    this.minWidthTimeout = setTimeout(function () {
	      if (!_this.subMenuTitle || !_this.menuInstance) {
	        return;
	      }
	      var popupMenu = _reactDom2['default'].findDOMNode(_this.menuInstance);
	      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
	        return;
	      }
	      popupMenu.style.minWidth = _this.subMenuTitle.offsetWidth + 'px';
	    }, 0);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    var _props2 = this.props,
	        onDestroy = _props2.onDestroy,
	        eventKey = _props2.eventKey;
	
	    if (onDestroy) {
	      onDestroy(eventKey);
	    }
	    if (this.minWidthTimeout) {
	      clearTimeout(this.minWidthTimeout);
	    }
	    if (this.mouseenterTimeout) {
	      clearTimeout(this.mouseenterTimeout);
	    }
	  },
	  onDestroy: function onDestroy(key) {
	    this.props.onDestroy(key);
	  },
	  onKeyDown: function onKeyDown(e) {
	    var keyCode = e.keyCode;
	    var menu = this.menuInstance;
	    var isOpen = this.isOpen();
	
	    if (keyCode === _KeyCode2['default'].ENTER) {
	      this.onTitleClick(e);
	      this.setState({
	        defaultActiveFirst: true
	      });
	      return true;
	    }
	
	    if (keyCode === _KeyCode2['default'].RIGHT) {
	      if (isOpen) {
	        menu.onKeyDown(e);
	      } else {
	        this.triggerOpenChange(true);
	        this.setState({
	          defaultActiveFirst: true
	        });
	      }
	      return true;
	    }
	    if (keyCode === _KeyCode2['default'].LEFT) {
	      var handled = void 0;
	      if (isOpen) {
	        handled = menu.onKeyDown(e);
	      } else {
	        return undefined;
	      }
	      if (!handled) {
	        this.triggerOpenChange(false);
	        handled = true;
	      }
	      return handled;
	    }
	
	    if (isOpen && (keyCode === _KeyCode2['default'].UP || keyCode === _KeyCode2['default'].DOWN)) {
	      return menu.onKeyDown(e);
	    }
	  },
	  onOpenChange: function onOpenChange(e) {
	    this.props.onOpenChange(e);
	  },
	  onPopupVisibleChange: function onPopupVisibleChange(visible) {
	    this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
	  },
	  onMouseEnter: function onMouseEnter(e) {
	    var _props3 = this.props,
	        key = _props3.eventKey,
	        onMouseEnter = _props3.onMouseEnter;
	
	    this.setState({
	      defaultActiveFirst: false
	    });
	    onMouseEnter({
	      key: key,
	      domEvent: e
	    });
	  },
	  onMouseLeave: function onMouseLeave(e) {
	    var _props4 = this.props,
	        parentMenu = _props4.parentMenu,
	        eventKey = _props4.eventKey,
	        onMouseLeave = _props4.onMouseLeave;
	
	    parentMenu.subMenuInstance = this;
	    onMouseLeave({
	      key: eventKey,
	      domEvent: e
	    });
	  },
	  onTitleMouseEnter: function onTitleMouseEnter(domEvent) {
	    var _props5 = this.props,
	        key = _props5.eventKey,
	        onItemHover = _props5.onItemHover,
	        onTitleMouseEnter = _props5.onTitleMouseEnter;
	
	    onItemHover({
	      key: key,
	      hover: true
	    });
	    onTitleMouseEnter({
	      key: key,
	      domEvent: domEvent
	    });
	  },
	  onTitleMouseLeave: function onTitleMouseLeave(e) {
	    var _props6 = this.props,
	        parentMenu = _props6.parentMenu,
	        eventKey = _props6.eventKey,
	        onItemHover = _props6.onItemHover,
	        onTitleMouseLeave = _props6.onTitleMouseLeave;
	
	    parentMenu.subMenuInstance = this;
	    onItemHover({
	      key: eventKey,
	      hover: false
	    });
	    onTitleMouseLeave({
	      key: eventKey,
	      domEvent: e
	    });
	  },
	  onTitleClick: function onTitleClick(e) {
	    var props = this.props;
	
	    props.onTitleClick({
	      key: props.eventKey,
	      domEvent: e
	    });
	    if (props.triggerSubMenuAction === 'hover') {
	      return;
	    }
	    this.triggerOpenChange(!this.isOpen(), 'click');
	    this.setState({
	      defaultActiveFirst: false
	    });
	  },
	  onSubMenuClick: function onSubMenuClick(info) {
	    this.props.onClick(this.addKeyPath(info));
	  },
	  onSelect: function onSelect(info) {
	    this.props.onSelect(info);
	  },
	  onDeselect: function onDeselect(info) {
	    this.props.onDeselect(info);
	  },
	  getPrefixCls: function getPrefixCls() {
	    return this.props.rootPrefixCls + '-submenu';
	  },
	  getActiveClassName: function getActiveClassName() {
	    return this.getPrefixCls() + '-active';
	  },
	  getDisabledClassName: function getDisabledClassName() {
	    return this.getPrefixCls() + '-disabled';
	  },
	  getSelectedClassName: function getSelectedClassName() {
	    return this.getPrefixCls() + '-selected';
	  },
	  getOpenClassName: function getOpenClassName() {
	    return this.props.rootPrefixCls + '-submenu-open';
	  },
	  saveMenuInstance: function saveMenuInstance(c) {
	    this.menuInstance = c;
	  },
	  addKeyPath: function addKeyPath(info) {
	    return (0, _extends3['default'])({}, info, {
	      keyPath: (info.keyPath || []).concat(this.props.eventKey)
	    });
	  },
	  triggerOpenChange: function triggerOpenChange(open, type) {
	    var _this2 = this;
	
	    var key = this.props.eventKey;
	    var openChange = function openChange() {
	      _this2.onOpenChange({
	        key: key,
	        item: _this2,
	        trigger: type,
	        open: open
	      });
	    };
	    if (type === 'mouseenter') {
	      // make sure mouseenter happen after other menu item's mouseleave
	      this.mouseenterTimeout = setTimeout(function () {
	        openChange();
	      }, 0);
	    } else {
	      openChange();
	    }
	  },
	  isChildrenSelected: function isChildrenSelected() {
	    var ret = { find: false };
	    (0, _util.loopMenuItemRecusively)(this.props.children, this.props.selectedKeys, ret);
	    return ret.find;
	  },
	  isOpen: function isOpen() {
	    return this.props.openKeys.indexOf(this.props.eventKey) !== -1;
	  },
	  renderChildren: function renderChildren(children) {
	    var props = this.props;
	    var baseProps = {
	      mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
	      visible: this.isOpen(),
	      level: props.level + 1,
	      inlineIndent: props.inlineIndent,
	      focusable: false,
	      onClick: this.onSubMenuClick,
	      onSelect: this.onSelect,
	      onDeselect: this.onDeselect,
	      onDestroy: this.onDestroy,
	      selectedKeys: props.selectedKeys,
	      eventKey: props.eventKey + '-menu-',
	      openKeys: props.openKeys,
	      openTransitionName: props.openTransitionName,
	      openAnimation: props.openAnimation,
	      onOpenChange: this.onOpenChange,
	      subMenuOpenDelay: props.subMenuOpenDelay,
	      subMenuCloseDelay: props.subMenuCloseDelay,
	      forceSubMenuRender: props.forceSubMenuRender,
	      triggerSubMenuAction: props.triggerSubMenuAction,
	      defaultActiveFirst: this.state.defaultActiveFirst,
	      multiple: props.multiple,
	      prefixCls: props.rootPrefixCls,
	      id: this._menuId,
	      ref: this.saveMenuInstance
	    };
	    return _react2['default'].createElement(
	      _SubPopupMenu2['default'],
	      baseProps,
	      children
	    );
	  },
	  saveSubMenuTitle: function saveSubMenuTitle(subMenuTitle) {
	    this.subMenuTitle = subMenuTitle;
	  },
	  render: function render() {
	    var _classNames;
	
	    var props = this.props;
	    var isOpen = this.isOpen();
	    var prefixCls = this.getPrefixCls();
	    var isInlineMode = props.mode === 'inline';
	    var className = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + props.mode, (_classNames = {}, _classNames[props.className] = !!props.className, _classNames[this.getOpenClassName()] = isOpen, _classNames[this.getActiveClassName()] = props.active || isOpen && !isInlineMode, _classNames[this.getDisabledClassName()] = props.disabled, _classNames[this.getSelectedClassName()] = this.isChildrenSelected(), _classNames));
	
	    if (!this._menuId) {
	      if (props.eventKey) {
	        this._menuId = props.eventKey + '$Menu';
	      } else {
	        this._menuId = '$__$' + ++guid + '$Menu';
	      }
	    }
	
	    var mouseEvents = {};
	    var titleClickEvents = {};
	    var titleMouseEvents = {};
	    if (!props.disabled) {
	      mouseEvents = {
	        onMouseLeave: this.onMouseLeave,
	        onMouseEnter: this.onMouseEnter
	      };
	
	      // only works in title, not outer li
	      titleClickEvents = {
	        onClick: this.onTitleClick
	      };
	      titleMouseEvents = {
	        onMouseEnter: this.onTitleMouseEnter,
	        onMouseLeave: this.onTitleMouseLeave
	      };
	    }
	
	    var style = {};
	    if (isInlineMode) {
	      style.paddingLeft = props.inlineIndent * props.level;
	    }
	    var title = _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({
	        ref: this.saveSubMenuTitle,
	        style: style,
	        className: prefixCls + '-title'
	      }, titleMouseEvents, titleClickEvents, {
	        'aria-expanded': isOpen,
	        'aria-owns': this._menuId,
	        'aria-haspopup': 'true',
	        title: typeof props.title === 'string' ? props.title : undefined
	      }),
	      props.title,
	      _react2['default'].createElement('i', { className: prefixCls + '-arrow' })
	    );
	    var children = this.renderChildren(props.children);
	
	    var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
	      return triggerNode.parentNode;
	    };
	    var popupPlacement = popupPlacementMap[props.mode];
	    var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
	    return _react2['default'].createElement(
	      'li',
	      (0, _extends3['default'])({}, mouseEvents, { className: className, style: props.style }),
	      isInlineMode && title,
	      isInlineMode && children,
	      !isInlineMode && _react2['default'].createElement(
	        _rcTrigger2['default'],
	        {
	          prefixCls: prefixCls,
	          popupClassName: prefixCls + '-popup ' + popupClassName,
	          getPopupContainer: getPopupContainer,
	          builtinPlacements: _placements2['default'],
	          popupPlacement: popupPlacement,
	          popupVisible: isOpen,
	          popup: children,
	          action: props.disabled ? [] : [props.triggerSubMenuAction],
	          mouseEnterDelay: props.subMenuOpenDelay,
	          mouseLeaveDelay: props.subMenuCloseDelay,
	          onPopupVisibleChange: this.onPopupVisibleChange,
	          forceRender: props.forceSubMenuRender
	        },
	        title
	      )
	    );
	  }
	});
	
	SubMenu.isSubMenu = 1;
	
	exports['default'] = SubMenu;
	module.exports = exports['default'];

/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _MenuMixin = __webpack_require__(1167);
	
	var _MenuMixin2 = _interopRequireDefault(_MenuMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SubPopupMenu = (0, _createReactClass2['default'])({
	  displayName: 'SubPopupMenu',
	
	  propTypes: {
	    onSelect: _propTypes2['default'].func,
	    onClick: _propTypes2['default'].func,
	    onDeselect: _propTypes2['default'].func,
	    onOpenChange: _propTypes2['default'].func,
	    onDestroy: _propTypes2['default'].func,
	    openTransitionName: _propTypes2['default'].string,
	    openAnimation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	    openKeys: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	    visible: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any
	  },
	
	  mixins: [_MenuMixin2['default']],
	
	  onDeselect: function onDeselect(selectInfo) {
	    this.props.onDeselect(selectInfo);
	  },
	  onSelect: function onSelect(selectInfo) {
	    this.props.onSelect(selectInfo);
	  },
	  onClick: function onClick(e) {
	    this.props.onClick(e);
	  },
	  onOpenChange: function onOpenChange(e) {
	    this.props.onOpenChange(e);
	  },
	  onDestroy: function onDestroy(key) {
	    this.props.onDestroy(key);
	  },
	  getOpenTransitionName: function getOpenTransitionName() {
	    return this.props.openTransitionName;
	  },
	  renderMenuItem: function renderMenuItem(c, i, subIndex) {
	    if (!c) {
	      return null;
	    }
	    var props = this.props;
	    var extraProps = {
	      openKeys: props.openKeys,
	      selectedKeys: props.selectedKeys,
	      triggerSubMenuAction: props.triggerSubMenuAction
	    };
	    return this.renderCommonMenuItem(c, i, subIndex, extraProps);
	  },
	  render: function render() {
	    var props = (0, _extends3['default'])({}, this.props);
	
	    var haveRendered = this.haveRendered;
	    this.haveRendered = true;
	
	    this.haveOpened = this.haveOpened || props.visible || props.forceSubMenuRender;
	    if (!this.haveOpened) {
	      return null;
	    }
	
	    var transitionAppear = !(!haveRendered && props.visible && props.mode === 'inline');
	
	    props.className += ' ' + props.prefixCls + '-sub';
	    var animProps = {};
	    if (props.openTransitionName) {
	      animProps.transitionName = props.openTransitionName;
	    } else if (typeof props.openAnimation === 'object') {
	      animProps.animation = (0, _extends3['default'])({}, props.openAnimation);
	      if (!transitionAppear) {
	        delete animProps.animation.appear;
	      }
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      (0, _extends3['default'])({}, animProps, {
	        showProp: 'visible',
	        component: '',
	        transitionAppear: transitionAppear
	      }),
	      this.renderRoot(props)
	    );
	  }
	});
	
	exports['default'] = SubPopupMenu;
	module.exports = exports['default'];

/***/ },
/* 2553 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var placements = exports.placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -7]
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 7]
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0]
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0]
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Notice = function (_Component) {
	  (0, _inherits3['default'])(Notice, _Component);
	
	  function Notice() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Notice);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
	      _this.clearCloseTimer();
	      _this.props.onClose();
	    }, _this.startCloseTimer = function () {
	      if (_this.props.duration) {
	        _this.closeTimer = setTimeout(function () {
	          _this.close();
	        }, _this.props.duration * 1000);
	      }
	    }, _this.clearCloseTimer = function () {
	      if (_this.closeTimer) {
	        clearTimeout(_this.closeTimer);
	        _this.closeTimer = null;
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Notice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.startCloseTimer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearCloseTimer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _className;
	
	      var props = this.props;
	      var componentClass = props.prefixCls + '-notice';
	      var className = (_className = {}, (0, _defineProperty3['default'])(_className, '' + componentClass, 1), (0, _defineProperty3['default'])(_className, componentClass + '-closable', props.closable), (0, _defineProperty3['default'])(_className, props.className, !!props.className), _className);
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(className), style: props.style, onMouseEnter: this.clearCloseTimer,
	          onMouseLeave: this.startCloseTimer
	        },
	        _react2['default'].createElement(
	          'div',
	          { className: componentClass + '-content' },
	          props.children
	        ),
	        props.closable ? _react2['default'].createElement(
	          'a',
	          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
	          _react2['default'].createElement('span', { className: componentClass + '-close-x' })
	        ) : null
	      );
	    }
	  }]);
	  return Notice;
	}(_react.Component);
	
	Notice.propTypes = {
	  duration: _propTypes2['default'].number,
	  onClose: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	Notice.defaultProps = {
	  onEnd: function onEnd() {},
	  onClose: function onClose() {},
	
	  duration: 1.5,
	  style: {
	    right: '50%'
	  }
	};
	exports['default'] = Notice;
	module.exports = exports['default'];

/***/ },
/* 2555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _createChainedFunction = __webpack_require__(482);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Notice = __webpack_require__(2554);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var seed = 0;
	var now = Date.now();
	
	function getUuid() {
	  return 'rcNotification_' + now + '_' + seed++;
	}
	
	var Notification = function (_Component) {
	  (0, _inherits3['default'])(Notification, _Component);
	
	  function Notification() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Notification);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      notices: []
	    }, _this.add = function (notice) {
	      var key = notice.key = notice.key || getUuid();
	      _this.setState(function (previousState) {
	        var notices = previousState.notices;
	        if (!notices.filter(function (v) {
	          return v.key === key;
	        }).length) {
	          return {
	            notices: notices.concat(notice)
	          };
	        }
	      });
	    }, _this.remove = function (key) {
	      _this.setState(function (previousState) {
	        return {
	          notices: previousState.notices.filter(function (notice) {
	            return notice.key !== key;
	          })
	        };
	      });
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Notification, [{
	    key: 'getTransitionName',
	    value: function getTransitionName() {
	      var props = this.props;
	      var transitionName = props.transitionName;
	      if (!transitionName && props.animation) {
	        transitionName = props.prefixCls + '-' + props.animation;
	      }
	      return transitionName;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _className;
	
	      var props = this.props;
	      var noticeNodes = this.state.notices.map(function (notice) {
	        var onClose = (0, _createChainedFunction2['default'])(_this2.remove.bind(_this2, notice.key), notice.onClose);
	        return _react2['default'].createElement(
	          _Notice2['default'],
	          (0, _extends3['default'])({
	            prefixCls: props.prefixCls
	          }, notice, {
	            onClose: onClose
	          }),
	          notice.content
	        );
	      });
	      var className = (_className = {}, (0, _defineProperty3['default'])(_className, props.prefixCls, 1), (0, _defineProperty3['default'])(_className, props.className, !!props.className), _className);
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(className), style: props.style },
	        _react2['default'].createElement(
	          _rcAnimate2['default'],
	          { transitionName: this.getTransitionName() },
	          noticeNodes
	        )
	      );
	    }
	  }]);
	  return Notification;
	}(_react.Component);
	
	Notification.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].string,
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  style: _propTypes2['default'].object
	};
	Notification.defaultProps = {
	  prefixCls: 'rc-notification',
	  animation: 'fade',
	  style: {
	    top: 65,
	    left: '50%'
	  }
	};
	
	
	Notification.newInstance = function newNotificationInstance(properties, callback) {
	  var _ref2 = properties || {},
	      getContainer = _ref2.getContainer,
	      props = (0, _objectWithoutProperties3['default'])(_ref2, ['getContainer']);
	
	  var div = document.createElement('div');
	  if (getContainer) {
	    var root = getContainer();
	    root.appendChild(div);
	  } else {
	    document.body.appendChild(div);
	  }
	  var called = false;
	  function ref(notification) {
	    if (called) {
	      return;
	    }
	    called = true;
	    callback({
	      notice: function notice(noticeProps) {
	        notification.add(noticeProps);
	      },
	      removeNotice: function removeNotice(key) {
	        notification.remove(key);
	      },
	
	      component: notification,
	      destroy: function destroy() {
	        _reactDom2['default'].unmountComponentAtNode(div);
	        div.parentNode.removeChild(div);
	      }
	    });
	  }
	  _reactDom2['default'].render(_react2['default'].createElement(Notification, (0, _extends3['default'])({}, props, { ref: ref })), div);
	};
	
	exports['default'] = Notification;
	module.exports = exports['default'];

/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(1169);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Options = function (_React$Component) {
	  (0, _inherits3['default'])(Options, _React$Component);
	
	  function Options(props) {
	    (0, _classCallCheck3['default'])(this, Options);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));
	
	    _this.buildOptionText = function (value) {
	      return value + ' ' + _this.props.locale.items_per_page;
	    };
	
	    _this.changeSize = function (value) {
	      _this.props.changeSize(Number(value));
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        goInputText: e.target.value
	      });
	    };
	
	    _this.go = function (e) {
	      var val = _this.state.goInputText;
	      if (val === '') {
	        return;
	      }
	      val = Number(val);
	      if (isNaN(val)) {
	        val = _this.state.current;
	      }
	      if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	        _this.setState({
	          goInputText: '',
	          current: _this.props.quickGo(val)
	        });
	      }
	    };
	
	    _this.state = {
	      current: props.current,
	      goInputText: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Options, [{
	    key: 'render',
	    value: function render() {
	      var props = this.props;
	      var state = this.state;
	      var locale = props.locale;
	      var prefixCls = props.rootPrefixCls + '-options';
	      var changeSize = props.changeSize;
	      var quickGo = props.quickGo;
	      var goButton = props.goButton;
	      var buildOptionText = props.buildOptionText || this.buildOptionText;
	      var Select = props.selectComponentClass;
	      var changeSelect = null;
	      var goInput = null;
	      var gotoButton = null;
	
	      if (!(changeSize || quickGo)) {
	        return null;
	      }
	
	      if (changeSize && Select) {
	        var Option = Select.Option;
	        var pageSize = props.pageSize || props.pageSizeOptions[0];
	        var options = props.pageSizeOptions.map(function (opt, i) {
	          return _react2['default'].createElement(
	            Option,
	            { key: i, value: opt },
	            buildOptionText(opt)
	          );
	        });
	
	        changeSelect = _react2['default'].createElement(
	          Select,
	          {
	            prefixCls: props.selectPrefixCls,
	            showSearch: false,
	            className: prefixCls + '-size-changer',
	            optionLabelProp: 'children',
	            dropdownMatchSelectWidth: false,
	            value: pageSize.toString(),
	            onChange: this.changeSize,
	            getPopupContainer: function getPopupContainer(triggerNode) {
	              return triggerNode.parentNode;
	            }
	          },
	          options
	        );
	      }
	
	      if (quickGo) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'button',
	              {
	                type: 'button',
	                onClick: this.go,
	                onKeyUp: this.go
	              },
	              locale.jump_to_confirm
	            );
	          } else {
	            gotoButton = goButton;
	          }
	        }
	        goInput = _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-quick-jumper' },
	          locale.jump_to,
	          _react2['default'].createElement('input', {
	            type: 'text',
	            value: state.goInputText,
	            onChange: this.handleChange,
	            onKeyUp: this.go
	          }),
	          locale.page,
	          gotoButton
	        );
	      }
	
	      return _react2['default'].createElement(
	        'li',
	        { className: '' + prefixCls },
	        changeSelect,
	        goInput
	      );
	    }
	  }]);
	  return Options;
	}(_react2['default'].Component);
	
	Options.propTypes = {
	  changeSize: _propTypes2['default'].func,
	  quickGo: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  current: _propTypes2['default'].number,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  pageSize: _propTypes2['default'].number,
	  buildOptionText: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object
	};
	Options.defaultProps = {
	  pageSizeOptions: ['10', '20', '30', '40']
	};
	exports['default'] = Options;
	module.exports = exports['default'];

/***/ },
/* 2557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Pager = function Pager(props) {
	  var prefixCls = props.rootPrefixCls + '-item';
	  var cls = prefixCls + ' ' + prefixCls + '-' + props.page;
	
	  if (props.active) {
	    cls = cls + ' ' + prefixCls + '-active';
	  }
	
	  if (props.className) {
	    cls = cls + ' ' + props.className;
	  }
	
	  var handleClick = function handleClick() {
	    props.onClick(props.page);
	  };
	
	  var handleKeyPress = function handleKeyPress(e) {
	    props.onKeyPress(e, props.onClick, props.page);
	  };
	
	  return _react2['default'].createElement(
	    'li',
	    {
	      title: props.showTitle ? props.page : null,
	      className: cls,
	      onClick: handleClick,
	      onKeyPress: handleKeyPress,
	      tabIndex: '0'
	    },
	    props.itemRender(props.page, 'page', _react2['default'].createElement(
	      'a',
	      null,
	      props.page
	    ))
	  );
	};
	
	Pager.propTypes = {
	  page: _propTypes2['default'].number,
	  active: _propTypes2['default'].bool,
	  last: _propTypes2['default'].bool,
	  locale: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  showTitle: _propTypes2['default'].bool,
	  rootPrefixCls: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onKeyPress: _propTypes2['default'].func,
	  itemRender: _propTypes2['default'].func
	};
	
	exports['default'] = Pager;
	module.exports = exports['default'];

/***/ },
/* 2558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Pager = __webpack_require__(2557);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _Options = __webpack_require__(2556);
	
	var _Options2 = _interopRequireDefault(_Options);
	
	var _KeyCode = __webpack_require__(1169);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _zh_CN = __webpack_require__(2563);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function isInteger(value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	}
	
	function defaultItemRender(page, type, element) {
	  return element;
	}
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination(props) {
	    (0, _classCallCheck3['default'])(this, Pagination);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var hasOnChange = props.onChange !== noop;
	    var hasCurrent = 'current' in props;
	    if (hasCurrent && !hasOnChange) {
	      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
	    }
	
	    var current = props.defaultCurrent;
	    if ('current' in props) {
	      current = props.current;
	    }
	
	    var pageSize = props.defaultPageSize;
	    if ('pageSize' in props) {
	      pageSize = props.pageSize;
	    }
	
	    _this.state = {
	      current: current,
	      currentInputValue: current,
	      pageSize: pageSize
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Pagination, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('current' in nextProps) {
	        this.setState({
	          current: nextProps.current,
	          currentInputValue: nextProps.current
	        });
	      }
	
	      if ('pageSize' in nextProps) {
	        var newState = {};
	        var current = this.state.current;
	        var newCurrent = this.calculatePage(nextProps.pageSize);
	        current = current > newCurrent ? newCurrent : current;
	        if (!('current' in nextProps)) {
	          newState.current = current;
	          newState.currentInputValue = current;
	        }
	        newState.pageSize = nextProps.pageSize;
	        this.setState(newState);
	      }
	    }
	  }, {
	    key: 'getJumpPrevPage',
	    value: function getJumpPrevPage() {
	      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpNextPage',
	    value: function getJumpNextPage() {
	      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpPrevPage',
	    value: function getJumpPrevPage() {
	      return Math.max(1, this.state.current - (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'getJumpNextPage',
	    value: function getJumpNextPage() {
	      return Math.min(this.calculatePage(), this.state.current + (this.props.showLessItems ? 3 : 5));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      // When hideOnSinglePage is true and there is only 1 page, hide the pager
	      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
	        return null;
	      }
	
	      var props = this.props;
	      var locale = props.locale;
	
	      var prefixCls = props.prefixCls;
	      var allPages = this.calculatePage();
	      var pagerList = [];
	      var jumpPrev = null;
	      var jumpNext = null;
	      var firstPager = null;
	      var lastPager = null;
	      var gotoButton = null;
	
	      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
	      var pageBufferSize = props.showLessItems ? 1 : 2;
	      var _state = this.state,
	          current = _state.current,
	          pageSize = _state.pageSize;
	
	
	      var prevPage = current - 1 > 0 ? current - 1 : 0;
	      var nextPage = current + 1 < allPages ? current + 1 : allPages;
	
	      if (props.simple) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'li',
	              {
	                title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
	                className: prefixCls + '-simple-pager'
	              },
	              _react2['default'].createElement(
	                'button',
	                {
	                  type: 'button',
	                  onClick: this.handleGoTO,
	                  onKeyUp: this.handleGoTO
	                },
	                locale.jump_to_confirm
	              )
	            );
	          } else {
	            gotoButton = goButton;
	          }
	        }
	        return _react2['default'].createElement(
	          'ul',
	          { className: prefixCls + ' ' + prefixCls + '-simple ' + props.className, style: props.style },
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.prev_page : null,
	              onClick: this.prev,
	              tabIndex: '0',
	              onKeyPress: this.runIfEnterPrev,
	              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	              'aria-disabled': !this.hasPrev()
	            },
	            props.itemRender(prevPage, 'prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            _react2['default'].createElement('input', {
	              type: 'text',
	              value: this.state.currentInputValue,
	              onKeyDown: this.handleKeyDown,
	              onKeyUp: this.handleKeyUp,
	              onChange: this.handleKeyUp,
	              size: '3'
	            }),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-slash' },
	              '\uFF0F'
	            ),
	            allPages
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.next_page : null,
	              onClick: this.next,
	              tabIndex: '0',
	              onKeyPress: this.runIfEnterNext,
	              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	              'aria-disabled': !this.hasNext()
	            },
	            props.itemRender(nextPage, 'next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	          ),
	          gotoButton
	        );
	      }
	
	      if (allPages <= 5 + pageBufferSize * 2) {
	        for (var i = 1; i <= allPages; i++) {
	          var active = this.state.current === i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: i,
	            page: i,
	            active: active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	      } else {
	        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
	        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
	        jumpPrev = _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? prevItemTitle : null,
	            key: 'prev',
	            onClick: this.jumpPrev,
	            tabIndex: '0',
	            onKeyPress: this.runIfEnterJumpPrev,
	            className: prefixCls + '-jump-prev'
	          },
	          props.itemRender(this.getJumpPrevPage(), 'jump-prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        );
	        jumpNext = _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? nextItemTitle : null,
	            key: 'next',
	            tabIndex: '0',
	            onClick: this.jumpNext,
	            onKeyPress: this.runIfEnterJumpNext,
	            className: prefixCls + '-jump-next'
	          },
	          props.itemRender(this.getJumpNextPage(), 'jump-next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        );
	        lastPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          last: true,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: allPages,
	          page: allPages,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	        firstPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: 1,
	          page: 1,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	
	        var left = Math.max(1, current - pageBufferSize);
	        var right = Math.min(current + pageBufferSize, allPages);
	
	        if (current - 1 <= pageBufferSize) {
	          right = 1 + pageBufferSize * 2;
	        }
	
	        if (allPages - current <= pageBufferSize) {
	          left = allPages - pageBufferSize * 2;
	        }
	
	        for (var _i = left; _i <= right; _i++) {
	          var _active = current === _i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: props.locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: _i,
	            page: _i,
	            active: _active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	
	        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
	          pagerList[0] = _react2['default'].cloneElement(pagerList[0], {
	            className: prefixCls + '-item-after-jump-prev'
	          });
	          pagerList.unshift(jumpPrev);
	        }
	        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
	          pagerList[pagerList.length - 1] = _react2['default'].cloneElement(pagerList[pagerList.length - 1], {
	            className: prefixCls + '-item-before-jump-next'
	          });
	          pagerList.push(jumpNext);
	        }
	
	        if (left !== 1) {
	          pagerList.unshift(firstPager);
	        }
	        if (right !== allPages) {
	          pagerList.push(lastPager);
	        }
	      }
	
	      var totalText = null;
	
	      if (props.showTotal) {
	        totalText = _react2['default'].createElement(
	          'li',
	          { className: prefixCls + '-total-text' },
	          props.showTotal(props.total, [(current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
	        );
	      }
	      var prevDisabled = !this.hasPrev();
	      var nextDisabled = !this.hasNext();
	      return _react2['default'].createElement(
	        'ul',
	        {
	          className: prefixCls + ' ' + props.className,
	          style: props.style,
	          unselectable: 'unselectable'
	        },
	        totalText,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.prev_page : null,
	            onClick: this.prev,
	            tabIndex: '0',
	            onKeyPress: this.runIfEnterPrev,
	            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	            'aria-disabled': prevDisabled
	          },
	          props.itemRender(prevPage, 'prev', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        ),
	        pagerList,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.next_page : null,
	            onClick: this.next,
	            tabIndex: '0',
	            onKeyPress: this.runIfEnterNext,
	            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	            'aria-disabled': nextDisabled
	          },
	          props.itemRender(nextPage, 'next', _react2['default'].createElement('a', { className: prefixCls + '-item-link' }))
	        ),
	        _react2['default'].createElement(_Options2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          selectComponentClass: props.selectComponentClass,
	          selectPrefixCls: props.selectPrefixCls,
	          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
	          current: this.state.current,
	          pageSize: this.state.pageSize,
	          pageSizeOptions: this.props.pageSizeOptions,
	          quickGo: this.props.showQuickJumper ? this.handleChange : null,
	          goButton: goButton
	        })
	      );
	    }
	  }]);
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = {
	  current: _propTypes2['default'].number,
	  defaultCurrent: _propTypes2['default'].number,
	  total: _propTypes2['default'].number,
	  pageSize: _propTypes2['default'].number,
	  defaultPageSize: _propTypes2['default'].number,
	  onChange: _propTypes2['default'].func,
	  hideOnSinglePage: _propTypes2['default'].bool,
	  showSizeChanger: _propTypes2['default'].bool,
	  showLessItems: _propTypes2['default'].bool,
	  onShowSizeChange: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  showQuickJumper: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	  showTitle: _propTypes2['default'].bool,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  showTotal: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object,
	  style: _propTypes2['default'].object,
	  itemRender: _propTypes2['default'].func
	};
	Pagination.defaultProps = {
	  defaultCurrent: 1,
	  total: 0,
	  defaultPageSize: 10,
	  onChange: noop,
	  className: '',
	  selectPrefixCls: 'rc-select',
	  prefixCls: 'rc-pagination',
	  selectComponentClass: null,
	  hideOnSinglePage: false,
	  showQuickJumper: false,
	  showSizeChanger: false,
	  showLessItems: false,
	  showTitle: true,
	  onShowSizeChange: noop,
	  locale: _zh_CN2['default'],
	  style: {},
	  itemRender: defaultItemRender
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.calculatePage = function (p) {
	    var pageSize = p;
	    if (typeof pageSize === 'undefined') {
	      pageSize = _this2.state.pageSize;
	    }
	    return Math.floor((_this2.props.total - 1) / pageSize) + 1;
	  };
	
	  this.isValid = function (page) {
	    return isInteger(page) && page >= 1 && page !== _this2.state.current;
	  };
	
	  this.handleKeyDown = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ARROW_UP || e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      e.preventDefault();
	    }
	  };
	
	  this.handleKeyUp = function (e) {
	    var inputValue = e.target.value;
	    var currentInputValue = _this2.state.currentInputValue;
	    var value = void 0;
	
	    if (inputValue === '') {
	      value = inputValue;
	    } else if (isNaN(Number(inputValue))) {
	      value = currentInputValue;
	    } else {
	      value = Number(inputValue);
	    }
	
	    if (value !== currentInputValue) {
	      _this2.setState({
	        currentInputValue: value
	      });
	    }
	
	    if (e.keyCode === _KeyCode2['default'].ENTER) {
	      _this2.handleChange(value);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_UP) {
	      _this2.handleChange(value - 1);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      _this2.handleChange(value + 1);
	    }
	  };
	
	  this.changePageSize = function (size) {
	    var current = _this2.state.current;
	    var newCurrent = _this2.calculatePage(size);
	    current = current > newCurrent ? newCurrent : current;
	    if (typeof size === 'number') {
	      if (!('pageSize' in _this2.props)) {
	        _this2.setState({
	          pageSize: size
	        });
	      }
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: current,
	          currentInputValue: current
	        });
	      }
	    }
	    _this2.props.onShowSizeChange(current, size);
	  };
	
	  this.handleChange = function (p) {
	    var page = p;
	    if (_this2.isValid(page)) {
	      if (page > _this2.calculatePage()) {
	        page = _this2.calculatePage();
	      }
	
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: page,
	          currentInputValue: page
	        });
	      }
	
	      var pageSize = _this2.state.pageSize;
	      _this2.props.onChange(page, pageSize);
	
	      return page;
	    }
	
	    return _this2.state.current;
	  };
	
	  this.prev = function () {
	    if (_this2.hasPrev()) {
	      _this2.handleChange(_this2.state.current - 1);
	    }
	  };
	
	  this.next = function () {
	    if (_this2.hasNext()) {
	      _this2.handleChange(_this2.state.current + 1);
	    }
	  };
	
	  this.jumpPrev = function () {
	    _this2.handleChange(_this2.getJumpPrevPage());
	  };
	
	  this.jumpNext = function () {
	    _this2.handleChange(_this2.getJumpNextPage());
	  };
	
	  this.hasPrev = function () {
	    return _this2.state.current > 1;
	  };
	
	  this.hasNext = function () {
	    return _this2.state.current < _this2.calculatePage();
	  };
	
	  this.runIfEnter = function (event, callback) {
	    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      restParams[_key - 2] = arguments[_key];
	    }
	
	    if (event.key === 'Enter' || event.charCode === 13) {
	      callback.apply(undefined, restParams);
	    }
	  };
	
	  this.runIfEnterPrev = function (e) {
	    _this2.runIfEnter(e, _this2.prev);
	  };
	
	  this.runIfEnterNext = function (e) {
	    _this2.runIfEnter(e, _this2.next);
	  };
	
	  this.runIfEnterJumpPrev = function (e) {
	    _this2.runIfEnter(e, _this2.jumpPrev);
	  };
	
	  this.runIfEnterJumpNext = function (e) {
	    _this2.runIfEnter(e, _this2.jumpNext);
	  };
	
	  this.handleGoTO = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	      _this2.handleChange(_this2.state.currentInputValue);
	    }
	  };
	};
	
	exports['default'] = Pagination;
	module.exports = exports['default'];

/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(2558);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pagination)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 2560 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '/ pàgina',
	  jump_to: 'Anar a',
	  jump_to_confirm: 'Confirma',
	  page: '',
	
	  // Pagination.jsx
	  prev_page: 'Pàgina prèvia',
	  next_page: 'Pàgina següent',
	  prev_5: '5 pàgines prèvies',
	  next_5: '5 pàgines següents',
	  prev_3: '3 pàgines prèvies',
	  next_3: '3 pàgines següents'
	};
	module.exports = exports['default'];

/***/ },
/* 2561 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '/ page',
	  jump_to: 'Aller à',
	  jump_to_confirm: 'confirmer',
	  page: '',
	
	  // Pagination.jsx
	  prev_page: 'Page précédente',
	  next_page: 'Page suivante',
	  prev_5: '5 Pages précédentes',
	  next_5: '5 Pages suivantes',
	  prev_3: '3 Pages précédentes',
	  next_3: '3 Pages suivantes'
	};
	module.exports = exports['default'];

/***/ },
/* 2562 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '/ pagina',
	  jump_to: 'vai a',
	  jump_to_confirm: 'Conferma',
	  page: '',
	
	  // Pagination.jsx
	  prev_page: 'Pagina precedente',
	  next_page: 'Pagina successiva',
	  prev_5: 'Precedente 5 pagine',
	  next_5: 'Prossime 5 pagine',
	  prev_3: 'Precedente 3 pagine',
	  next_3: 'Prossime 3 pagine'
	};
	module.exports = exports['default'];

/***/ },
/* 2563 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '条/页',
	  jump_to: '跳至',
	  jump_to_confirm: '确定',
	  page: '页',
	
	  // Pagination.jsx
	  prev_page: '上一页',
	  next_page: '下一页',
	  prev_5: '向前 5 页',
	  next_5: '向后 5 页',
	  prev_3: '向前 3 页',
	  next_3: '向后 3 页'
	};
	module.exports = exports['default'];

/***/ },
/* 2564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _enhancer = __webpack_require__(1171);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _types = __webpack_require__(1172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/prop-types: 0 */
	var Circle = function (_Component) {
	  (0, _inherits3['default'])(Circle, _Component);
	
	  function Circle() {
	    (0, _classCallCheck3['default'])(this, Circle);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  Circle.prototype.getPathStyles = function getPathStyles() {
	    var _props = this.props,
	        percent = _props.percent,
	        strokeWidth = _props.strokeWidth,
	        _props$gapDegree = _props.gapDegree,
	        gapDegree = _props$gapDegree === undefined ? 0 : _props$gapDegree,
	        gapPosition = _props.gapPosition;
	
	    var radius = 50 - strokeWidth / 2;
	    var beginPositionX = 0;
	    var beginPositionY = -radius;
	    var endPositionX = 0;
	    var endPositionY = -2 * radius;
	    switch (gapPosition) {
	      case 'left':
	        beginPositionX = -radius;
	        beginPositionY = 0;
	        endPositionX = 2 * radius;
	        endPositionY = 0;
	        break;
	      case 'right':
	        beginPositionX = radius;
	        beginPositionY = 0;
	        endPositionX = -2 * radius;
	        endPositionY = 0;
	        break;
	      case 'bottom':
	        beginPositionY = radius;
	        endPositionY = 2 * radius;
	        break;
	      default:
	    }
	    var pathString = 'M 50,50 m ' + beginPositionX + ',' + beginPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + endPositionX + ',' + -endPositionY + '\n     a ' + radius + ',' + radius + ' 0 1 1 ' + -endPositionX + ',' + endPositionY;
	    var len = Math.PI * 2 * radius;
	    var trailPathStyle = {
	      strokeDasharray: len - gapDegree + 'px ' + len + 'px',
	      strokeDashoffset: '-' + gapDegree / 2 + 'px',
	      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s'
	    };
	    var strokePathStyle = {
	      strokeDasharray: percent / 100 * (len - gapDegree) + 'px ' + len + 'px',
	      strokeDashoffset: '-' + gapDegree / 2 + 'px',
	      transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line
	    };
	    return { pathString: pathString, trailPathStyle: trailPathStyle, strokePathStyle: strokePathStyle };
	  };
	
	  Circle.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        strokeWidth = _props2.strokeWidth,
	        trailWidth = _props2.trailWidth,
	        strokeColor = _props2.strokeColor,
	        percent = _props2.percent,
	        trailColor = _props2.trailColor,
	        strokeLinecap = _props2.strokeLinecap,
	        style = _props2.style,
	        className = _props2.className,
	        restProps = (0, _objectWithoutProperties3['default'])(_props2, ['prefixCls', 'strokeWidth', 'trailWidth', 'strokeColor', 'percent', 'trailColor', 'strokeLinecap', 'style', 'className']);
	
	    var _getPathStyles = this.getPathStyles(),
	        pathString = _getPathStyles.pathString,
	        trailPathStyle = _getPathStyles.trailPathStyle,
	        strokePathStyle = _getPathStyles.strokePathStyle;
	
	    delete restProps.percent;
	    delete restProps.gapDegree;
	    delete restProps.gapPosition;
	    return _react2['default'].createElement(
	      'svg',
	      (0, _extends3['default'])({
	        className: prefixCls + '-circle ' + className,
	        viewBox: '0 0 100 100',
	        style: style
	      }, restProps),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-circle-trail',
	        d: pathString,
	        stroke: trailColor,
	        strokeWidth: trailWidth || strokeWidth,
	        fillOpacity: '0',
	        style: trailPathStyle
	      }),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-circle-path',
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: strokeColor,
	        strokeWidth: this.props.percent === 0 ? 0 : strokeWidth,
	        fillOpacity: '0',
	        ref: function ref(path) {
	          _this2.path = path;
	        },
	        style: strokePathStyle
	      })
	    );
	  };
	
	  return Circle;
	}(_react.Component);
	
	Circle.propTypes = (0, _extends3['default'])({}, _types.propTypes, {
	  gapPosition: _propTypes2['default'].oneOf(['top', 'bottom', 'left', 'right'])
	});
	
	Circle.defaultProps = (0, _extends3['default'])({}, _types.defaultProps, {
	  gapPosition: 'top'
	});
	
	exports['default'] = (0, _enhancer2['default'])(Circle);
	module.exports = exports['default'];

/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _enhancer = __webpack_require__(1171);
	
	var _enhancer2 = _interopRequireDefault(_enhancer);
	
	var _types = __webpack_require__(1172);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Line = function (_Component) {
	  (0, _inherits3['default'])(Line, _Component);
	
	  function Line() {
	    (0, _classCallCheck3['default'])(this, Line);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  Line.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        className = _props.className,
	        percent = _props.percent,
	        prefixCls = _props.prefixCls,
	        strokeColor = _props.strokeColor,
	        strokeLinecap = _props.strokeLinecap,
	        strokeWidth = _props.strokeWidth,
	        style = _props.style,
	        trailColor = _props.trailColor,
	        trailWidth = _props.trailWidth,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'percent', 'prefixCls', 'strokeColor', 'strokeLinecap', 'strokeWidth', 'style', 'trailColor', 'trailWidth']);
	
	
	    delete restProps.gapPosition;
	
	    var pathStyle = {
	      strokeDasharray: '100px, 100px',
	      strokeDashoffset: 100 - percent + 'px',
	      transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear'
	    };
	
	    var center = strokeWidth / 2;
	    var right = 100 - strokeWidth / 2;
	    var pathString = 'M ' + (strokeLinecap === 'round' ? center : 0) + ',' + center + '\n           L ' + (strokeLinecap === 'round' ? right : 100) + ',' + center;
	    var viewBoxString = '0 0 100 ' + strokeWidth;
	
	    return _react2['default'].createElement(
	      'svg',
	      (0, _extends3['default'])({
	        className: prefixCls + '-line ' + className,
	        viewBox: viewBoxString,
	        preserveAspectRatio: 'none',
	        style: style
	      }, restProps),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-line-trail',
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: trailColor,
	        strokeWidth: trailWidth || strokeWidth,
	        fillOpacity: '0'
	      }),
	      _react2['default'].createElement('path', {
	        className: prefixCls + '-line-path',
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: strokeColor,
	        strokeWidth: strokeWidth,
	        fillOpacity: '0',
	        ref: function ref(path) {
	          _this2.path = path;
	        },
	        style: pathStyle
	      })
	    );
	  };
	
	  return Line;
	}(_react.Component);
	
	Line.propTypes = _types.propTypes;
	
	Line.defaultProps = _types.defaultProps;
	
	exports['default'] = (0, _enhancer2['default'])(Line);
	module.exports = exports['default'];

/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Circle = exports.Line = undefined;
	
	var _Line = __webpack_require__(2565);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Circle = __webpack_require__(2564);
	
	var _Circle2 = _interopRequireDefault(_Circle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.Line = _Line2['default'];
	exports.Circle = _Circle2['default'];
	exports['default'] = {
	  Line: _Line2['default'],
	  Circle: _Circle2['default']
	};

/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _util = __webpack_require__(2570);
	
	var _Star = __webpack_require__(2568);
	
	var _Star2 = _interopRequireDefault(_Star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function noop() {}
	
	var Rate = function (_React$Component) {
	  _inherits(Rate, _React$Component);
	
	  function Rate(props) {
	    _classCallCheck(this, Rate);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = props.value;
	    if (value === undefined) {
	      value = props.defaultValue;
	    }
	
	    _this.stars = {};
	
	    _this.state = {
	      value: value,
	      focused: false,
	      cleanedValue: null
	    };
	    return _this;
	  }
	
	  Rate.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.autoFocus && !this.props.disabled) {
	      this.focus();
	    }
	  };
	
	  Rate.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if ('value' in nextProps) {
	      var value = nextProps.value;
	      if (value === undefined) {
	        value = nextProps.defaultValue;
	      }
	      this.setState({
	        value: value
	      });
	    }
	  };
	
	  Rate.prototype.getStarDOM = function getStarDOM(index) {
	    return _reactDom2['default'].findDOMNode(this.stars[index]);
	  };
	
	  Rate.prototype.getStarValue = function getStarValue(index, x) {
	    var value = index + 1;
	    if (this.props.allowHalf) {
	      var starEle = this.getStarDOM(index);
	      var leftDis = (0, _util.getOffsetLeft)(starEle);
	      var width = starEle.clientWidth;
	      if (x - leftDis < width / 2) {
	        value -= 0.5;
	      }
	    }
	    return value;
	  };
	
	  Rate.prototype.focus = function focus() {
	    if (!this.props.disabled) {
	      this.rate.focus();
	    }
	  };
	
	  Rate.prototype.blur = function blur() {
	    if (!this.props.disabled) {
	      this.rate.focus();
	    }
	  };
	
	  Rate.prototype.changeValue = function changeValue(value) {
	    if (!('value' in this.props)) {
	      this.setState({
	        value: value
	      });
	    }
	    this.props.onChange(value);
	  };
	
	  Rate.prototype.render = function render() {
	    var _props = this.props,
	        count = _props.count,
	        allowHalf = _props.allowHalf,
	        style = _props.style,
	        prefixCls = _props.prefixCls,
	        disabled = _props.disabled,
	        className = _props.className,
	        character = _props.character,
	        tabIndex = _props.tabIndex;
	    var _state = this.state,
	        value = _state.value,
	        hoverValue = _state.hoverValue,
	        focused = _state.focused;
	
	    var stars = [];
	    var disabledClass = disabled ? prefixCls + '-disabled' : '';
	    for (var index = 0; index < count; index++) {
	      stars.push(_react2['default'].createElement(_Star2['default'], {
	        ref: this.saveRef(index),
	        index: index,
	        disabled: disabled,
	        prefixCls: prefixCls + '-star',
	        allowHalf: allowHalf,
	        value: hoverValue === undefined ? value : hoverValue,
	        onClick: this.onClick,
	        onHover: this.onHover,
	        key: index,
	        character: character,
	        focused: focused
	      }));
	    }
	    return _react2['default'].createElement(
	      'ul',
	      {
	        className: (0, _classnames2['default'])(prefixCls, disabledClass, className),
	        style: style,
	        onMouseLeave: disabled ? null : this.onMouseLeave,
	        tabIndex: disabled ? -1 : tabIndex,
	        onFocus: disabled ? null : this.onFocus,
	        onBlur: disabled ? null : this.onBlur,
	        onKeyDown: disabled ? null : this.onKeyDown,
	        ref: this.saveRate
	      },
	      stars
	    );
	  };
	
	  return Rate;
	}(_react2['default'].Component);
	
	Rate.propTypes = {
	  disabled: _propTypes2['default'].bool,
	  value: _propTypes2['default'].number,
	  defaultValue: _propTypes2['default'].number,
	  count: _propTypes2['default'].number,
	  allowHalf: _propTypes2['default'].bool,
	  allowClear: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  onChange: _propTypes2['default'].func,
	  onHoverChange: _propTypes2['default'].func,
	  className: _propTypes2['default'].string,
	  character: _propTypes2['default'].node,
	  tabIndex: _propTypes2['default'].number,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onKeyDown: _propTypes2['default'].func,
	  autoFocus: _propTypes2['default'].bool
	};
	Rate.defaultProps = {
	  defaultValue: 0,
	  count: 5,
	  allowHalf: false,
	  allowClear: true,
	  style: {},
	  prefixCls: 'rc-rate',
	  onChange: noop,
	  character: '★',
	  onHoverChange: noop,
	  tabIndex: 0
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onHover = function (event, index) {
	    var hoverValue = _this2.getStarValue(index, event.pageX);
	    var cleanedValue = _this2.state.cleanedValue;
	
	    if (hoverValue !== cleanedValue) {
	      _this2.setState({
	        hoverValue: hoverValue,
	        cleanedValue: null
	      });
	    }
	    _this2.props.onHoverChange(hoverValue);
	  };
	
	  this.onMouseLeave = function () {
	    _this2.setState({
	      hoverValue: undefined,
	      cleanedValue: null
	    });
	    _this2.props.onHoverChange(undefined);
	  };
	
	  this.onClick = function (event, index) {
	    var value = _this2.getStarValue(index, event.pageX);
	    var isReset = false;
	    if (_this2.props.allowClear) {
	      isReset = value === _this2.state.value;
	    }
	    _this2.onMouseLeave(true);
	    _this2.changeValue(isReset ? 0 : value);
	    _this2.setState({
	      cleanedValue: isReset ? value : null
	    });
	  };
	
	  this.onFocus = function () {
	    var onFocus = _this2.props.onFocus;
	
	    _this2.setState({
	      focused: true
	    });
	    if (onFocus) {
	      onFocus();
	    }
	  };
	
	  this.onBlur = function () {
	    var onBlur = _this2.props.onBlur;
	
	    _this2.setState({
	      focused: false
	    });
	    if (onBlur) {
	      onBlur();
	    }
	  };
	
	  this.onKeyDown = function (event) {
	    var keyCode = event.keyCode;
	    var _props2 = _this2.props,
	        count = _props2.count,
	        allowHalf = _props2.allowHalf,
	        onKeyDown = _props2.onKeyDown;
	    var value = _this2.state.value;
	
	    if (keyCode === _KeyCode2['default'].RIGHT && value < count) {
	      if (allowHalf) {
	        value += 0.5;
	      } else {
	        value += 1;
	      }
	      _this2.changeValue(value);
	      event.preventDefault();
	    } else if (keyCode === _KeyCode2['default'].LEFT && value > 0) {
	      if (allowHalf) {
	        value -= 0.5;
	      } else {
	        value -= 1;
	      }
	      _this2.changeValue(value);
	      event.preventDefault();
	    }
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  this.saveRef = function (index) {
	    return function (node) {
	      _this2.stars[index] = node;
	    };
	  };
	
	  this.saveRate = function (node) {
	    _this2.rate = node;
	  };
	};
	
	exports['default'] = Rate;
	module.exports = exports['default'];

/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Star = function (_React$Component) {
	  _inherits(Star, _React$Component);
	
	  function Star() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Star);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onHover = function (e) {
	      var _this$props = _this.props,
	          onHover = _this$props.onHover,
	          index = _this$props.index;
	
	      onHover(e, index);
	    }, _this.onClick = function (e) {
	      var _this$props2 = _this.props,
	          onClick = _this$props2.onClick,
	          index = _this$props2.index;
	
	      onClick(e, index);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Star.prototype.getClassName = function getClassName() {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        index = _props.index,
	        value = _props.value,
	        allowHalf = _props.allowHalf,
	        focused = _props.focused;
	
	    var starValue = index + 1;
	    var className = prefixCls;
	    if (value === 0 && index === 0 && focused) {
	      className += ' ' + prefixCls + '-focused';
	    } else if (allowHalf && value + 0.5 === starValue) {
	      className += ' ' + prefixCls + '-half ' + prefixCls + '-active';
	      if (focused) {
	        className += ' ' + prefixCls + '-focused';
	      }
	    } else {
	      className += starValue <= value ? ' ' + prefixCls + '-full' : ' ' + prefixCls + '-zero';
	      if (starValue === value && focused) {
	        className += ' ' + prefixCls + '-focused';
	      }
	    }
	    return className;
	  };
	
	  Star.prototype.render = function render() {
	    var onHover = this.onHover,
	        onClick = this.onClick;
	    var _props2 = this.props,
	        disabled = _props2.disabled,
	        prefixCls = _props2.prefixCls,
	        character = _props2.character;
	
	    return _react2['default'].createElement(
	      'li',
	      {
	        className: this.getClassName(),
	        onClick: disabled ? null : onClick,
	        onMouseMove: disabled ? null : onHover
	      },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-first' },
	        character
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-second' },
	        character
	      )
	    );
	  };
	
	  return Star;
	}(_react2['default'].Component);
	
	Star.propTypes = {
	  value: _propTypes2['default'].number,
	  index: _propTypes2['default'].number,
	  prefixCls: _propTypes2['default'].string,
	  allowHalf: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  onHover: _propTypes2['default'].func,
	  onClick: _propTypes2['default'].func,
	  character: _propTypes2['default'].node,
	  focused: _propTypes2['default'].bool
	};
	exports['default'] = Star;
	module.exports = exports['default'];

/***/ },
/* 2569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Rate = __webpack_require__(2567);
	
	var _Rate2 = _interopRequireDefault(_Rate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Rate2['default'];
	module.exports = exports['default'];

/***/ },
/* 2570 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.getOffsetLeft = getOffsetLeft;
	function getScroll(w, top) {
	  var ret = top ? w.pageYOffset : w.pageXOffset;
	  var method = top ? 'scrollTop' : 'scrollLeft';
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getClientPosition(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  box = elem.getBoundingClientRect();
	  x = box.left;
	  y = box.top;
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getOffsetLeft(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScroll(w);
	  return pos.left;
	}

/***/ },
/* 2571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _toArray = __webpack_require__(330);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _rcMenu = __webpack_require__(191);
	
	var _rcMenu2 = _interopRequireDefault(_rcMenu);
	
	var _domScrollIntoView = __webpack_require__(295);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _util = __webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3['default'])(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, DropdownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.scrollActiveItemToView = function () {
	      // scroll into view
	      var itemComponent = (0, _reactDom.findDOMNode)(_this.firstActiveItem);
	      var props = _this.props;
	
	      if (itemComponent) {
	        var scrollIntoViewOpts = {
	          onlyScrollIfNeeded: true
	        };
	        if ((!props.value || props.value.length === 0) && props.firstActiveValue) {
	          scrollIntoViewOpts.alignWithTop = true;
	        }
	
	        (0, _domScrollIntoView2['default'])(itemComponent, (0, _reactDom.findDOMNode)(_this.menuRef), scrollIntoViewOpts);
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  DropdownMenu.prototype.componentWillMount = function componentWillMount() {
	    this.lastInputValue = this.props.inputValue;
	  };
	
	  DropdownMenu.prototype.componentDidMount = function componentDidMount() {
	    this.scrollActiveItemToView();
	    this.lastVisible = this.props.visible;
	  };
	
	  DropdownMenu.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    if (!nextProps.visible) {
	      this.lastVisible = false;
	    }
	    // freeze when hide
	    return nextProps.visible;
	  };
	
	  DropdownMenu.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var props = this.props;
	    if (!prevProps.visible && props.visible) {
	      this.scrollActiveItemToView();
	    }
	    this.lastVisible = props.visible;
	    this.lastInputValue = props.inputValue;
	  };
	
	  DropdownMenu.prototype.renderMenu = function renderMenu() {
	    var _this2 = this;
	
	    var props = this.props;
	    var menuItems = props.menuItems,
	        defaultActiveFirstOption = props.defaultActiveFirstOption,
	        value = props.value,
	        prefixCls = props.prefixCls,
	        multiple = props.multiple,
	        onMenuSelect = props.onMenuSelect,
	        inputValue = props.inputValue,
	        firstActiveValue = props.firstActiveValue;
	
	    if (menuItems && menuItems.length) {
	      var menuProps = {};
	      if (multiple) {
	        menuProps.onDeselect = props.onMenuDeselect;
	        menuProps.onSelect = onMenuSelect;
	      } else {
	        menuProps.onClick = onMenuSelect;
	      }
	
	      var selectedKeys = (0, _util.getSelectKeys)(menuItems, value);
	      var activeKeyProps = {};
	
	      var clonedMenuItems = menuItems;
	      if (selectedKeys.length || firstActiveValue) {
	        if (props.visible && !this.lastVisible) {
	          activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
	        }
	        var foundFirst = false;
	        // set firstActiveItem via cloning menus
	        // for scroll into view
	        var clone = function clone(item) {
	          if (!foundFirst && selectedKeys.indexOf(item.key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
	            foundFirst = true;
	            return (0, _react.cloneElement)(item, {
	              ref: function ref(_ref) {
	                _this2.firstActiveItem = _ref;
	              }
	            });
	          }
	          return item;
	        };
	
	        clonedMenuItems = menuItems.map(function (item) {
	          if (item.type.isMenuItemGroup) {
	            var children = (0, _toArray2['default'])(item.props.children).map(clone);
	            return (0, _react.cloneElement)(item, {}, children);
	          }
	          return clone(item);
	        });
	      }
	
	      // clear activeKey when inputValue change
	      var lastValue = value && value[value.length - 1];
	      if (inputValue !== this.lastInputValue && (!lastValue || !lastValue.backfill)) {
	        activeKeyProps.activeKey = '';
	      }
	
	      return _react2['default'].createElement(
	        _rcMenu2['default'],
	        (0, _extends3['default'])({
	          ref: (0, _util.saveRef)(this, 'menuRef'),
	          style: this.props.dropdownMenuStyle,
	          defaultActiveFirst: defaultActiveFirstOption
	        }, activeKeyProps, {
	          multiple: multiple,
	          focusable: false
	        }, menuProps, {
	          selectedKeys: selectedKeys,
	          prefixCls: prefixCls + '-menu'
	        }),
	        clonedMenuItems
	      );
	    }
	    return null;
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var renderMenu = this.renderMenu();
	    return renderMenu ? _react2['default'].createElement(
	      'div',
	      {
	        style: { overflow: 'auto' },
	        onFocus: this.props.onPopupFocus,
	        onMouseDown: _util.preventDefaultEvent,
	        onScroll: this.props.onPopupScroll
	      },
	      renderMenu
	    ) : null;
	  };
	
	  return DropdownMenu;
	}(_react2['default'].Component);
	
	DropdownMenu.propTypes = {
	  defaultActiveFirstOption: _propTypes2['default'].bool,
	  value: _propTypes2['default'].any,
	  dropdownMenuStyle: _propTypes2['default'].object,
	  multiple: _propTypes2['default'].bool,
	  onPopupFocus: _propTypes2['default'].func,
	  onPopupScroll: _propTypes2['default'].func,
	  onMenuDeSelect: _propTypes2['default'].func,
	  onMenuSelect: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  menuItems: _propTypes2['default'].any,
	  inputValue: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool
	};
	exports['default'] = DropdownMenu;
	
	
	DropdownMenu.displayName = 'DropdownMenu';
	module.exports = exports['default'];

/***/ },
/* 2572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var OptGroup = function (_React$Component) {
	  (0, _inherits3['default'])(OptGroup, _React$Component);
	
	  function OptGroup() {
	    (0, _classCallCheck3['default'])(this, OptGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  return OptGroup;
	}(_react2['default'].Component);
	
	OptGroup.isSelectOptGroup = true;
	exports['default'] = OptGroup;
	module.exports = exports['default'];

/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Option = function (_React$Component) {
	  (0, _inherits3['default'])(Option, _React$Component);
	
	  function Option() {
	    (0, _classCallCheck3['default'])(this, Option);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  return Option;
	}(_react2['default'].Component);
	
	Option.propTypes = {
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])
	};
	Option.isSelectOption = true;
	exports['default'] = Option;
	module.exports = exports['default'];

/***/ },
/* 2574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _toArray = __webpack_require__(330);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _componentClasses = __webpack_require__(418);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	var _rcMenu = __webpack_require__(191);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _util = __webpack_require__(476);
	
	var _SelectTrigger = __webpack_require__(2575);
	
	var _SelectTrigger2 = _interopRequireDefault(_SelectTrigger);
	
	var _PropTypes = __webpack_require__(1173);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint func-names: 1 */
	function noop() {}
	
	function chaining() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    // eslint-disable-line
	    // eslint-disable-line
	    for (var i = 0; i < fns.length; i++) {
	      if (fns[i] && typeof fns[i] === 'function') {
	        fns[i].apply(this, args);
	      }
	    }
	  };
	}
	
	var Select = function (_React$Component) {
	  (0, _inherits3['default'])(Select, _React$Component);
	
	  function Select(props) {
	    (0, _classCallCheck3['default'])(this, Select);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = [];
	    if ('value' in props) {
	      value = (0, _util.toArray)(props.value);
	    } else {
	      value = (0, _util.toArray)(props.defaultValue);
	    }
	    value = _this.addLabelToValue(props, value);
	    value = _this.addTitleToValue(props, value);
	    var inputValue = '';
	    if (props.combobox) {
	      inputValue = value.length ? _this.getLabelFromProps(props, value[0].key) : '';
	    }
	    var open = props.open;
	    if (open === undefined) {
	      open = props.defaultOpen;
	    }
	    _this.state = {
	      value: value,
	      inputValue: inputValue,
	      open: open
	    };
	    _this.adjustOpenState();
	    return _this;
	  }
	
	  Select.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.autoFocus) {
	      this.focus();
	    }
	  };
	
	  Select.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
	    this.props = nextProps;
	    this.state = nextState;
	    this.adjustOpenState();
	  };
	
	  Select.prototype.componentDidUpdate = function componentDidUpdate() {
	    if ((0, _util.isMultipleOrTags)(this.props)) {
	      var inputNode = this.getInputDOMNode();
	      var mirrorNode = this.getInputMirrorDOMNode();
	      if (inputNode.value) {
	        inputNode.style.width = '';
	        inputNode.style.width = mirrorNode.clientWidth + 'px';
	      } else {
	        inputNode.style.width = '';
	      }
	    }
	  };
	
	  Select.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearFocusTime();
	    this.clearBlurTime();
	    this.clearAdjustTimer();
	    if (this.dropdownContainer) {
	      _reactDom2['default'].unmountComponentAtNode(this.dropdownContainer);
	      document.body.removeChild(this.dropdownContainer);
	      this.dropdownContainer = null;
	    }
	  };
	
	  // combobox ignore
	
	
	  Select.prototype.focus = function focus() {
	    if ((0, _util.isSingleMode)(this.props)) {
	      this.selectionRef.focus();
	    } else {
	      this.getInputDOMNode().focus();
	    }
	  };
	
	  Select.prototype.blur = function blur() {
	    if ((0, _util.isSingleMode)(this.props)) {
	      this.selectionRef.blur();
	    } else {
	      this.getInputDOMNode().blur();
	    }
	  };
	
	  Select.prototype.renderClear = function renderClear() {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        allowClear = _props.allowClear;
	    var _state = this.state,
	        value = _state.value,
	        inputValue = _state.inputValue;
	
	    var clear = _react2['default'].createElement('span', (0, _extends3['default'])({
	      key: 'clear',
	      onMouseDown: _util.preventDefaultEvent,
	      style: _util.UNSELECTABLE_STYLE
	    }, _util.UNSELECTABLE_ATTRIBUTE, {
	      className: prefixCls + '-selection__clear',
	      onClick: this.onClearSelection
	    }));
	    if (!allowClear) {
	      return null;
	    }
	    if ((0, _util.isCombobox)(this.props)) {
	      if (inputValue) {
	        return clear;
	      }
	      return null;
	    }
	    if (inputValue || value.length) {
	      return clear;
	    }
	    return null;
	  };
	
	  Select.prototype.render = function render() {
	    var _rootCls;
	
	    var props = this.props;
	    var multiple = (0, _util.isMultipleOrTags)(props);
	    var state = this.state;
	    var className = props.className,
	        disabled = props.disabled,
	        prefixCls = props.prefixCls;
	
	    var ctrlNode = this.renderTopControlNode();
	    var extraSelectionProps = {};
	    var open = this.state.open;
	
	    var options = this._options;
	    if (!(0, _util.isMultipleOrTagsOrCombobox)(props)) {
	      extraSelectionProps = {
	        onKeyDown: this.onKeyDown,
	        tabIndex: props.disabled ? -1 : 0
	      };
	    }
	    var rootCls = (_rootCls = {}, _rootCls[className] = !!className, _rootCls[prefixCls] = 1, _rootCls[prefixCls + '-open'] = open, _rootCls[prefixCls + '-focused'] = open || !!this._focused, _rootCls[prefixCls + '-combobox'] = (0, _util.isCombobox)(props), _rootCls[prefixCls + '-disabled'] = disabled, _rootCls[prefixCls + '-enabled'] = !disabled, _rootCls[prefixCls + '-allow-clear'] = !!props.allowClear, _rootCls);
	    return _react2['default'].createElement(
	      _SelectTrigger2['default'],
	      {
	        onPopupFocus: this.onPopupFocus,
	        onMouseEnter: this.props.onMouseEnter,
	        onMouseLeave: this.props.onMouseLeave,
	        dropdownAlign: props.dropdownAlign,
	        dropdownClassName: props.dropdownClassName,
	        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
	        defaultActiveFirstOption: props.defaultActiveFirstOption,
	        dropdownMenuStyle: props.dropdownMenuStyle,
	        transitionName: props.transitionName,
	        animation: props.animation,
	        prefixCls: props.prefixCls,
	        dropdownStyle: props.dropdownStyle,
	        combobox: props.combobox,
	        showSearch: props.showSearch,
	        options: options,
	        multiple: multiple,
	        disabled: disabled,
	        visible: open,
	        inputValue: state.inputValue,
	        value: state.value,
	        firstActiveValue: props.firstActiveValue,
	        onDropdownVisibleChange: this.onDropdownVisibleChange,
	        getPopupContainer: props.getPopupContainer,
	        onMenuSelect: this.onMenuSelect,
	        onMenuDeselect: this.onMenuDeselect,
	        onPopupScroll: props.onPopupScroll,
	        showAction: props.showAction,
	        ref: (0, _util.saveRef)(this, 'selectTriggerRef')
	      },
	      _react2['default'].createElement(
	        'div',
	        {
	          style: props.style,
	          ref: (0, _util.saveRef)(this, 'rootRef'),
	          onBlur: this.onOuterBlur,
	          onFocus: this.onOuterFocus,
	          className: (0, _classnames3['default'])(rootCls)
	        },
	        _react2['default'].createElement(
	          'div',
	          (0, _extends3['default'])({
	            ref: (0, _util.saveRef)(this, 'selectionRef'),
	            key: 'selection',
	            className: prefixCls + '-selection\n            ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'),
	            role: 'combobox',
	            'aria-autocomplete': 'list',
	            'aria-haspopup': 'true',
	            'aria-expanded': open
	          }, extraSelectionProps),
	          ctrlNode,
	          this.renderClear(),
	          multiple || !props.showArrow ? null : _react2['default'].createElement(
	            'span',
	            (0, _extends3['default'])({
	              key: 'arrow',
	              className: prefixCls + '-arrow',
	              style: _util.UNSELECTABLE_STYLE
	            }, _util.UNSELECTABLE_ATTRIBUTE, {
	              onClick: this.onArrowClick
	            }),
	            _react2['default'].createElement('b', null)
	          )
	        )
	      )
	    );
	  };
	
	  return Select;
	}(_react2['default'].Component);
	
	Select.propTypes = _PropTypes.SelectPropTypes;
	Select.defaultProps = {
	  prefixCls: 'rc-select',
	  defaultOpen: false,
	  labelInValue: false,
	  defaultActiveFirstOption: true,
	  showSearch: true,
	  allowClear: false,
	  placeholder: '',
	  onChange: noop,
	  onFocus: noop,
	  onBlur: noop,
	  onSelect: noop,
	  onSearch: noop,
	  onDeselect: noop,
	  onInputKeyDown: noop,
	  showArrow: true,
	  dropdownMatchSelectWidth: true,
	  dropdownStyle: {},
	  dropdownMenuStyle: {},
	  optionFilterProp: 'value',
	  optionLabelProp: 'value',
	  notFoundContent: 'Not Found',
	  backfill: false,
	  showAction: ['click']
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.componentWillReceiveProps = function (nextProps) {
	    if ('value' in nextProps) {
	      var value = (0, _util.toArray)(nextProps.value);
	      value = _this2.addLabelToValue(nextProps, value);
	      value = _this2.addTitleToValue(nextProps, value);
	      _this2.setState({
	        value: value
	      });
	      if (nextProps.combobox) {
	        _this2.setState({
	          inputValue: value.length ? _this2.getLabelFromProps(nextProps, value[0].key) : ''
	        });
	      }
	    }
	  };
	
	  this.onInputChange = function (event) {
	    var tokenSeparators = _this2.props.tokenSeparators;
	
	    var val = event.target.value;
	    if ((0, _util.isMultipleOrTags)(_this2.props) && tokenSeparators && (0, _util.includesSeparators)(val, tokenSeparators)) {
	      var nextValue = _this2.tokenize(val);
	      _this2.fireChange(nextValue);
	      _this2.setOpenState(false, true);
	      _this2.setInputValue('', false);
	      return;
	    }
	    _this2.setInputValue(val);
	    _this2.setState({
	      open: true
	    });
	    if ((0, _util.isCombobox)(_this2.props)) {
	      _this2.fireChange([{
	        key: val
	      }]);
	    }
	  };
	
	  this.onDropdownVisibleChange = function (open) {
	    if (open && !_this2._focused) {
	      _this2.clearBlurTime();
	      _this2.timeoutFocus();
	      _this2._focused = true;
	      _this2.updateFocusClassName();
	    }
	    _this2.setOpenState(open);
	  };
	
	  this.onKeyDown = function (event) {
	    var props = _this2.props;
	    if (props.disabled) {
	      return;
	    }
	    var keyCode = event.keyCode;
	    if (_this2.state.open && !_this2.getInputDOMNode()) {
	      _this2.onInputKeyDown(event);
	    } else if (keyCode === _KeyCode2['default'].ENTER || keyCode === _KeyCode2['default'].DOWN) {
	      _this2.setOpenState(true);
	      event.preventDefault();
	    }
	  };
	
	  this.onInputKeyDown = function (event) {
	    var props = _this2.props;
	    if (props.disabled) {
	      return;
	    }
	    var state = _this2.state;
	    var keyCode = event.keyCode;
	    if ((0, _util.isMultipleOrTags)(props) && !event.target.value && keyCode === _KeyCode2['default'].BACKSPACE) {
	      event.preventDefault();
	      var value = state.value;
	
	      if (value.length) {
	        _this2.removeSelected(value[value.length - 1].key);
	      }
	      return;
	    }
	    if (keyCode === _KeyCode2['default'].DOWN) {
	      if (!state.open) {
	        _this2.openIfHasChildren();
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	    } else if (keyCode === _KeyCode2['default'].ESC) {
	      if (state.open) {
	        _this2.setOpenState(false);
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return;
	    }
	
	    if (state.open) {
	      var menu = _this2.selectTriggerRef.getInnerMenu();
	      if (menu && menu.onKeyDown(event, _this2.handleBackfill)) {
	        event.preventDefault();
	        event.stopPropagation();
	      }
	    }
	  };
	
	  this.onMenuSelect = function (_ref) {
	    var item = _ref.item;
	
	    var value = _this2.state.value;
	    var props = _this2.props;
	    var selectedValue = (0, _util.getValuePropValue)(item);
	    var selectedLabel = _this2.getLabelFromOption(item);
	    var lastValue = value[value.length - 1];
	    var event = selectedValue;
	    if (props.labelInValue) {
	      event = {
	        key: event,
	        label: selectedLabel
	      };
	    }
	    props.onSelect(event, item);
	    var selectedTitle = item.props.title;
	    if ((0, _util.isMultipleOrTags)(props)) {
	      if ((0, _util.findIndexInValueByKey)(value, selectedValue) !== -1) {
	        return;
	      }
	      value = value.concat([{
	        key: selectedValue,
	        label: selectedLabel,
	        title: selectedTitle
	      }]);
	    } else {
	      if ((0, _util.isCombobox)(props)) {
	        _this2.skipAdjustOpen = true;
	        _this2.clearAdjustTimer();
	        _this2.skipAdjustOpenTimer = setTimeout(function () {
	          _this2.skipAdjustOpen = false;
	        }, 0);
	      }
	      if (lastValue && lastValue.key === selectedValue && !lastValue.backfill) {
	        _this2.setOpenState(false, true);
	        return;
	      }
	      value = [{
	        key: selectedValue,
	        label: selectedLabel,
	        title: selectedTitle
	      }];
	      _this2.setOpenState(false, true);
	    }
	    _this2.fireChange(value);
	    var inputValue = void 0;
	    if ((0, _util.isCombobox)(props)) {
	      inputValue = (0, _util.getPropValue)(item, props.optionLabelProp);
	    } else {
	      inputValue = '';
	    }
	    _this2.setInputValue(inputValue, false);
	  };
	
	  this.onMenuDeselect = function (_ref2) {
	    var item = _ref2.item,
	        domEvent = _ref2.domEvent;
	
	    if (domEvent.type === 'click') {
	      _this2.removeSelected((0, _util.getValuePropValue)(item));
	    }
	    _this2.setInputValue('', false);
	  };
	
	  this.onArrowClick = function (e) {
	    e.stopPropagation();
	    if (!_this2.props.disabled) {
	      _this2.setOpenState(!_this2.state.open, !_this2.state.open);
	    }
	  };
	
	  this.onPlaceholderClick = function () {
	    if (_this2.getInputDOMNode()) {
	      _this2.getInputDOMNode().focus();
	    }
	  };
	
	  this.onOuterFocus = function (e) {
	    if (_this2.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	    _this2.clearBlurTime();
	    if (!(0, _util.isMultipleOrTagsOrCombobox)(_this2.props) && e.target === _this2.getInputDOMNode()) {
	      return;
	    }
	    if (_this2._focused) {
	      return;
	    }
	    _this2._focused = true;
	    _this2.updateFocusClassName();
	    _this2.timeoutFocus();
	  };
	
	  this.onPopupFocus = function () {
	    // fix ie scrollbar, focus element again
	    _this2.maybeFocus(true, true);
	  };
	
	  this.onOuterBlur = function (e) {
	    if (_this2.props.disabled) {
	      e.preventDefault();
	      return;
	    }
	    _this2.blurTimer = setTimeout(function () {
	      _this2._focused = false;
	      _this2.updateFocusClassName();
	      var props = _this2.props;
	      var value = _this2.state.value;
	      var inputValue = _this2.state.inputValue;
	
	      if ((0, _util.isSingleMode)(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
	        var options = _this2._options || [];
	        if (options.length) {
	          var firstOption = (0, _util.findFirstMenuItem)(options);
	          if (firstOption) {
	            value = [{
	              key: firstOption.key,
	              label: _this2.getLabelFromOption(firstOption)
	            }];
	            _this2.fireChange(value);
	          }
	        }
	      } else if ((0, _util.isMultipleOrTags)(props) && inputValue) {
	        // why not use setState?
	        _this2.state.inputValue = _this2.getInputDOMNode().value = '';
	      }
	      props.onBlur(_this2.getVLForOnChange(value));
	      _this2.setOpenState(false);
	    }, 10);
	  };
	
	  this.onClearSelection = function (event) {
	    var props = _this2.props;
	    var state = _this2.state;
	    if (props.disabled) {
	      return;
	    }
	    var inputValue = state.inputValue,
	        value = state.value;
	
	    event.stopPropagation();
	    if (inputValue || value.length) {
	      if (value.length) {
	        _this2.fireChange([]);
	      }
	      _this2.setOpenState(false, true);
	      if (inputValue) {
	        _this2.setInputValue('');
	      }
	    }
	  };
	
	  this.onChoiceAnimationLeave = function () {
	    _this2.selectTriggerRef.triggerRef.forcePopupAlign();
	  };
	
	  this.getLabelBySingleValue = function (children, value) {
	    if (value === undefined) {
	      return null;
	    }
	    var label = null;
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        var maybe = _this2.getLabelBySingleValue(child.props.children, value);
	        if (maybe !== null) {
	          label = maybe;
	        }
	      } else if ((0, _util.getValuePropValue)(child) === value) {
	        label = _this2.getLabelFromOption(child);
	      }
	    });
	    return label;
	  };
	
	  this.getValueByLabel = function (children, label) {
	    if (label === undefined) {
	      return null;
	    }
	    var value = null;
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        var maybe = _this2.getValueByLabel(child.props.children, label);
	        if (maybe !== null) {
	          value = maybe;
	        }
	      } else if ((0, _util.toArray)(_this2.getLabelFromOption(child)).join('') === label) {
	        value = (0, _util.getValuePropValue)(child);
	      }
	    });
	    return value;
	  };
	
	  this.getLabelFromOption = function (child) {
	    return (0, _util.getPropValue)(child, _this2.props.optionLabelProp);
	  };
	
	  this.getLabelFromProps = function (props, value) {
	    return _this2.getLabelByValue(props.children, value);
	  };
	
	  this.getVLForOnChange = function (vls_) {
	    var vls = vls_;
	    if (vls !== undefined) {
	      if (!_this2.props.labelInValue) {
	        vls = vls.map(function (v) {
	          return v.key;
	        });
	      } else {
	        vls = vls.map(function (vl) {
	          return { key: vl.key, label: vl.label };
	        });
	      }
	      return (0, _util.isMultipleOrTags)(_this2.props) ? vls : vls[0];
	    }
	    return vls;
	  };
	
	  this.getLabelByValue = function (children, value) {
	    var label = _this2.getLabelBySingleValue(children, value);
	    if (label === null) {
	      return value;
	    }
	    return label;
	  };
	
	  this.getDropdownContainer = function () {
	    if (!_this2.dropdownContainer) {
	      _this2.dropdownContainer = document.createElement('div');
	      document.body.appendChild(_this2.dropdownContainer);
	    }
	    return _this2.dropdownContainer;
	  };
	
	  this.getPlaceholderElement = function () {
	    var props = _this2.props,
	        state = _this2.state;
	
	    var hidden = false;
	    if (state.inputValue) {
	      hidden = true;
	    }
	    if (state.value.length) {
	      hidden = true;
	    }
	    if ((0, _util.isCombobox)(props) && state.value.length === 1 && !state.value[0].key) {
	      hidden = false;
	    }
	    var placeholder = props.placeholder;
	    if (placeholder) {
	      return _react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          onMouseDown: _util.preventDefaultEvent,
	          style: (0, _extends3['default'])({
	            display: hidden ? 'none' : 'block'
	          }, _util.UNSELECTABLE_STYLE)
	        }, _util.UNSELECTABLE_ATTRIBUTE, {
	          onClick: _this2.onPlaceholderClick,
	          className: props.prefixCls + '-selection__placeholder'
	        }),
	        placeholder
	      );
	    }
	    return null;
	  };
	
	  this.getInputElement = function () {
	    var _classnames;
	
	    var props = _this2.props;
	    var inputElement = props.getInputElement ? props.getInputElement() : _react2['default'].createElement('input', { id: props.id, autoComplete: 'off' });
	    var inputCls = (0, _classnames3['default'])(inputElement.props.className, (_classnames = {}, _classnames[props.prefixCls + '-search__field'] = true, _classnames));
	    // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
	    // Add space to the end of the inputValue as the width measurement tolerance
	    return _react2['default'].createElement(
	      'div',
	      { className: props.prefixCls + '-search__field__wrap' },
	      _react2['default'].cloneElement(inputElement, {
	        ref: (0, _util.saveRef)(_this2, 'inputRef'),
	        onChange: _this2.onInputChange,
	        onKeyDown: chaining(_this2.onInputKeyDown, inputElement.props.onKeyDown, _this2.props.onInputKeyDown),
	        value: _this2.state.inputValue,
	        disabled: props.disabled,
	        className: inputCls
	      }),
	      _react2['default'].createElement(
	        'span',
	        {
	          ref: (0, _util.saveRef)(_this2, 'inputMirrorRef'),
	          className: props.prefixCls + '-search__field__mirror'
	        },
	        _this2.state.inputValue,
	        '\xA0'
	      )
	    );
	  };
	
	  this.getInputDOMNode = function () {
	    return _this2.topCtrlRef ? _this2.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this2.inputRef;
	  };
	
	  this.getInputMirrorDOMNode = function () {
	    return _this2.inputMirrorRef;
	  };
	
	  this.getPopupDOMNode = function () {
	    return _this2.selectTriggerRef.getPopupDOMNode();
	  };
	
	  this.getPopupMenuComponent = function () {
	    return _this2.selectTriggerRef.getInnerMenu();
	  };
	
	  this.setOpenState = function (open, needFocus) {
	    var props = _this2.props,
	        state = _this2.state;
	
	    if (state.open === open) {
	      _this2.maybeFocus(open, needFocus);
	      return;
	    }
	    var nextState = {
	      open: open
	    };
	    // clear search input value when open is false in singleMode.
	    if (!open && (0, _util.isSingleMode)(props) && props.showSearch) {
	      _this2.setInputValue('');
	    }
	    if (!open) {
	      _this2.maybeFocus(open, needFocus);
	    }
	    _this2.setState(nextState, function () {
	      if (open) {
	        _this2.maybeFocus(open, needFocus);
	      }
	    });
	  };
	
	  this.setInputValue = function (inputValue) {
	    var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (inputValue !== _this2.state.inputValue) {
	      _this2.setState({
	        inputValue: inputValue
	      });
	      if (fireSearch) {
	        _this2.props.onSearch(inputValue);
	      }
	    }
	  };
	
	  this.handleBackfill = function (item) {
	    if (!_this2.props.backfill || !((0, _util.isSingleMode)(_this2.props) || (0, _util.isCombobox)(_this2.props))) {
	      return;
	    }
	
	    var key = (0, _util.getValuePropValue)(item);
	    var label = _this2.getLabelFromOption(item);
	    var backfillValue = {
	      key: key,
	      label: label,
	      backfill: true
	    };
	
	    if ((0, _util.isCombobox)(_this2.props)) {
	      _this2.setInputValue(key, false);
	    }
	
	    _this2.setState({
	      value: [backfillValue]
	    });
	  };
	
	  this.filterOption = function (input, child) {
	    var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _util.defaultFilterFn;
	    var value = _this2.state.value;
	
	    var lastValue = value[value.length - 1];
	    if (!input || lastValue && lastValue.backfill) {
	      return true;
	    }
	    var filterFn = _this2.props.filterOption;
	    if ('filterOption' in _this2.props) {
	      if (_this2.props.filterOption === true) {
	        filterFn = defaultFilter;
	      }
	    } else {
	      filterFn = defaultFilter;
	    }
	
	    if (!filterFn) {
	      return true;
	    } else if (typeof filterFn === 'function') {
	      return filterFn.call(_this2, input, child);
	    } else if (child.props.disabled) {
	      return false;
	    }
	    return true;
	  };
	
	  this.timeoutFocus = function () {
	    if (_this2.focusTimer) {
	      _this2.clearFocusTime();
	    }
	    _this2.focusTimer = setTimeout(function () {
	      _this2.props.onFocus();
	    }, 10);
	  };
	
	  this.clearFocusTime = function () {
	    if (_this2.focusTimer) {
	      clearTimeout(_this2.focusTimer);
	      _this2.focusTimer = null;
	    }
	  };
	
	  this.clearBlurTime = function () {
	    if (_this2.blurTimer) {
	      clearTimeout(_this2.blurTimer);
	      _this2.blurTimer = null;
	    }
	  };
	
	  this.clearAdjustTimer = function () {
	    if (_this2.skipAdjustOpenTimer) {
	      clearTimeout(_this2.skipAdjustOpenTimer);
	      _this2.skipAdjustOpenTimer = null;
	    }
	  };
	
	  this.updateFocusClassName = function () {
	    var rootRef = _this2.rootRef,
	        props = _this2.props;
	    // avoid setState and its side effect
	
	    if (_this2._focused) {
	      (0, _componentClasses2['default'])(rootRef).add(props.prefixCls + '-focused');
	    } else {
	      (0, _componentClasses2['default'])(rootRef).remove(props.prefixCls + '-focused');
	    }
	  };
	
	  this.maybeFocus = function (open, needFocus) {
	    if (needFocus || open) {
	      var input = _this2.getInputDOMNode();
	      var _document = document,
	          activeElement = _document.activeElement;
	
	      if (input && (open || (0, _util.isMultipleOrTagsOrCombobox)(_this2.props))) {
	        if (activeElement !== input) {
	          input.focus();
	          _this2._focused = true;
	        }
	      } else {
	        if (activeElement !== _this2.selectionRef) {
	          _this2.selectionRef.focus();
	          _this2._focused = true;
	        }
	      }
	    }
	  };
	
	  this.addLabelToValue = function (props, value_) {
	    var value = value_;
	    if (props.labelInValue) {
	      value.forEach(function (v) {
	        v.label = v.label || _this2.getLabelFromProps(props, v.key);
	      });
	    } else {
	      value = value.map(function (v) {
	        return {
	          key: v,
	          label: _this2.getLabelFromProps(props, v)
	        };
	      });
	    }
	    return value;
	  };
	
	  this.addTitleToValue = function (props, values) {
	    var nextValues = values;
	    var keys = values.map(function (v) {
	      return v.key;
	    });
	    _react2['default'].Children.forEach(props.children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        nextValues = _this2.addTitleToValue(child.props, nextValues);
	      } else {
	        var value = (0, _util.getValuePropValue)(child);
	        var valueIndex = keys.indexOf(value);
	        if (valueIndex > -1) {
	          nextValues[valueIndex].title = child.props.title;
	        }
	      }
	    });
	    return nextValues;
	  };
	
	  this.removeSelected = function (selectedKey) {
	    var props = _this2.props;
	    if (props.disabled || _this2.isChildDisabled(selectedKey)) {
	      return;
	    }
	    var label = void 0;
	    var value = _this2.state.value.filter(function (singleValue) {
	      if (singleValue.key === selectedKey) {
	        label = singleValue.label;
	      }
	      return singleValue.key !== selectedKey;
	    });
	    var canMultiple = (0, _util.isMultipleOrTags)(props);
	
	    if (canMultiple) {
	      var event = selectedKey;
	      if (props.labelInValue) {
	        event = {
	          key: selectedKey,
	          label: label
	        };
	      }
	      props.onDeselect(event);
	    }
	    _this2.fireChange(value);
	  };
	
	  this.openIfHasChildren = function () {
	    var props = _this2.props;
	    if (_react2['default'].Children.count(props.children) || (0, _util.isSingleMode)(props)) {
	      _this2.setOpenState(true);
	    }
	  };
	
	  this.fireChange = function (value) {
	    var props = _this2.props;
	    if (!('value' in props)) {
	      _this2.setState({
	        value: value
	      });
	    }
	    props.onChange(_this2.getVLForOnChange(value));
	  };
	
	  this.isChildDisabled = function (key) {
	    return (0, _toArray2['default'])(_this2.props.children).some(function (child) {
	      var childValue = (0, _util.getValuePropValue)(child);
	      return childValue === key && child.props && child.props.disabled;
	    });
	  };
	
	  this.tokenize = function (string) {
	    var _props2 = _this2.props,
	        multiple = _props2.multiple,
	        tokenSeparators = _props2.tokenSeparators,
	        children = _props2.children;
	
	    var nextValue = _this2.state.value;
	    (0, _util.splitBySeparators)(string, tokenSeparators).forEach(function (label) {
	      var selectedValue = { key: label, label: label };
	      if ((0, _util.findIndexInValueByLabel)(nextValue, label) === -1) {
	        if (multiple) {
	          var value = _this2.getValueByLabel(children, label);
	          if (value) {
	            selectedValue.key = value;
	            nextValue = nextValue.concat(selectedValue);
	          }
	        } else {
	          nextValue = nextValue.concat(selectedValue);
	        }
	      }
	    });
	    return nextValue;
	  };
	
	  this.adjustOpenState = function () {
	    if (_this2.skipAdjustOpen) {
	      return;
	    }
	    var open = _this2.state.open;
	
	    var options = [];
	    // If hidden menu due to no options, then it should be calculated again
	    if (open || _this2.hiddenForNoOptions) {
	      options = _this2.renderFilterOptions();
	    }
	    _this2._options = options;
	
	    if ((0, _util.isMultipleOrTagsOrCombobox)(_this2.props) || !_this2.props.showSearch) {
	      if (open && !options.length) {
	        open = false;
	        _this2.hiddenForNoOptions = true;
	      }
	      // Keep menu open if there are options and hidden for no options before
	      if (_this2.hiddenForNoOptions && options.length) {
	        open = true;
	        _this2.hiddenForNoOptions = false;
	      }
	    }
	    _this2.state.open = open;
	  };
	
	  this.renderFilterOptions = function () {
	    var inputValue = _this2.state.inputValue;
	    var _props3 = _this2.props,
	        children = _props3.children,
	        tags = _props3.tags,
	        filterOption = _props3.filterOption,
	        notFoundContent = _props3.notFoundContent;
	
	    var menuItems = [];
	    var childrenKeys = [];
	    var options = _this2.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);
	    if (tags) {
	      // tags value must be string
	      var value = _this2.state.value || [];
	      value = value.filter(function (singleValue) {
	        return childrenKeys.indexOf(singleValue.key) === -1 && (!inputValue || String(singleValue.key).indexOf(String(inputValue)) > -1);
	      });
	      value.forEach(function (singleValue) {
	        var key = singleValue.key;
	        var menuItem = _react2['default'].createElement(
	          _rcMenu.Item,
	          {
	            style: _util.UNSELECTABLE_STYLE,
	            attribute: _util.UNSELECTABLE_ATTRIBUTE,
	            value: key,
	            key: key
	          },
	          key
	        );
	        options.push(menuItem);
	        menuItems.push(menuItem);
	      });
	      if (inputValue) {
	        var notFindInputItem = menuItems.every(function (option) {
	          // this.filterOption return true has two meaning,
	          // 1, some one exists after filtering
	          // 2, filterOption is set to false
	          // condition 2 does not mean the option has same value with inputValue
	          var filterFn = function filterFn() {
	            return (0, _util.getValuePropValue)(option) === inputValue;
	          };
	          if (filterOption !== false) {
	            return !_this2.filterOption.call(_this2, inputValue, option, filterFn);
	          }
	          return !filterFn();
	        });
	        if (notFindInputItem) {
	          options.unshift(_react2['default'].createElement(
	            _rcMenu.Item,
	            {
	              style: _util.UNSELECTABLE_STYLE,
	              attribute: _util.UNSELECTABLE_ATTRIBUTE,
	              value: inputValue,
	              key: inputValue
	            },
	            inputValue
	          ));
	        }
	      }
	    }
	
	    if (!options.length && notFoundContent) {
	      options = [_react2['default'].createElement(
	        _rcMenu.Item,
	        {
	          style: _util.UNSELECTABLE_STYLE,
	          attribute: _util.UNSELECTABLE_ATTRIBUTE,
	          disabled: true,
	          value: 'NOT_FOUND',
	          key: 'NOT_FOUND'
	        },
	        notFoundContent
	      )];
	    }
	    return options;
	  };
	
	  this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
	    var sel = [];
	    var props = _this2.props;
	    var inputValue = _this2.state.inputValue;
	
	    var tags = props.tags;
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      if (child.type.isSelectOptGroup) {
	        var innerItems = _this2.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);
	        if (innerItems.length) {
	          var label = child.props.label;
	          var key = child.key;
	          if (!key && typeof label === 'string') {
	            key = label;
	          } else if (!label && key) {
	            label = key;
	          }
	          sel.push(_react2['default'].createElement(
	            _rcMenu.ItemGroup,
	            { key: key, title: label },
	            innerItems
	          ));
	        }
	        return;
	      }
	
	      (0, _warning2['default'])(child.type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + ('instead of `' + (child.type.name || child.type.displayName || child.type) + '`.'));
	
	      var childValue = (0, _util.getValuePropValue)(child);
	
	      (0, _util.validateOptionValue)(childValue, _this2.props);
	
	      if (_this2.filterOption(inputValue, child)) {
	        var menuItem = _react2['default'].createElement(_rcMenu.Item, (0, _extends3['default'])({
	          style: _util.UNSELECTABLE_STYLE,
	          attribute: _util.UNSELECTABLE_ATTRIBUTE,
	          value: childValue,
	          key: childValue
	        }, child.props));
	        sel.push(menuItem);
	        menuItems.push(menuItem);
	      }
	      if (tags && !child.props.disabled) {
	        childrenKeys.push(childValue);
	      }
	    });
	
	    return sel;
	  };
	
	  this.renderTopControlNode = function () {
	    var _state2 = _this2.state,
	        value = _state2.value,
	        open = _state2.open,
	        inputValue = _state2.inputValue;
	
	    var props = _this2.props;
	    var choiceTransitionName = props.choiceTransitionName,
	        prefixCls = props.prefixCls,
	        maxTagTextLength = props.maxTagTextLength,
	        maxTagCount = props.maxTagCount,
	        maxTagPlaceholder = props.maxTagPlaceholder,
	        showSearch = props.showSearch;
	
	    var className = prefixCls + '-selection__rendered';
	    // search input is inside topControlNode in single, multiple & combobox. 2016/04/13
	    var innerNode = null;
	    if ((0, _util.isSingleMode)(props)) {
	      var selectedValue = null;
	      if (value.length) {
	        var showSelectedValue = false;
	        var opacity = 1;
	        if (!showSearch) {
	          showSelectedValue = true;
	        } else {
	          if (open) {
	            showSelectedValue = !inputValue;
	            if (showSelectedValue) {
	              opacity = 0.4;
	            }
	          } else {
	            showSelectedValue = true;
	          }
	        }
	        var singleValue = value[0];
	        selectedValue = _react2['default'].createElement(
	          'div',
	          {
	            key: 'value',
	            className: prefixCls + '-selection-selected-value',
	            title: singleValue.title || singleValue.label,
	            style: {
	              display: showSelectedValue ? 'block' : 'none',
	              opacity: opacity
	            }
	          },
	          value[0].label
	        );
	      }
	      if (!showSearch) {
	        innerNode = [selectedValue];
	      } else {
	        innerNode = [selectedValue, _react2['default'].createElement(
	          'div',
	          {
	            className: prefixCls + '-search ' + prefixCls + '-search--inline',
	            key: 'input',
	            style: {
	              display: open ? 'block' : 'none'
	            }
	          },
	          _this2.getInputElement()
	        )];
	      }
	    } else {
	      var selectedValueNodes = [];
	      var limitedCountValue = value;
	      var maxTagPlaceholderEl = void 0;
	      if (maxTagCount && value.length > maxTagCount) {
	        limitedCountValue = limitedCountValue.slice(0, maxTagCount);
	        var omittedValues = _this2.getVLForOnChange(value.slice(maxTagCount, value.length));
	        var content = '+ ' + (value.length - maxTagCount) + ' ...';
	        if (maxTagPlaceholder) {
	          content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
	        }
	        maxTagPlaceholderEl = _react2['default'].createElement(
	          'li',
	          (0, _extends3['default'])({
	            style: _util.UNSELECTABLE_STYLE
	          }, _util.UNSELECTABLE_ATTRIBUTE, {
	            onMouseDown: _util.preventDefaultEvent,
	            className: prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled',
	            key: 'maxTagPlaceholder',
	            title: content
	          }),
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-selection__choice__content' },
	            content
	          )
	        );
	      }
	      if ((0, _util.isMultipleOrTags)(props)) {
	        selectedValueNodes = limitedCountValue.map(function (singleValue) {
	          var content = singleValue.label;
	          var title = singleValue.title || content;
	          if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
	            content = content.slice(0, maxTagTextLength) + '...';
	          }
	          var disabled = _this2.isChildDisabled(singleValue.key);
	          var choiceClassName = disabled ? prefixCls + '-selection__choice ' + prefixCls + '-selection__choice__disabled' : prefixCls + '-selection__choice';
	          return _react2['default'].createElement(
	            'li',
	            (0, _extends3['default'])({
	              style: _util.UNSELECTABLE_STYLE
	            }, _util.UNSELECTABLE_ATTRIBUTE, {
	              onMouseDown: _util.preventDefaultEvent,
	              className: choiceClassName,
	              key: singleValue.key,
	              title: title
	            }),
	            _react2['default'].createElement(
	              'div',
	              { className: prefixCls + '-selection__choice__content' },
	              content
	            ),
	            disabled ? null : _react2['default'].createElement('span', {
	              className: prefixCls + '-selection__choice__remove',
	              onClick: _this2.removeSelected.bind(_this2, singleValue.key)
	            })
	          );
	        });
	      }
	      if (maxTagPlaceholderEl) {
	        selectedValueNodes.push(maxTagPlaceholderEl);
	      }
	      selectedValueNodes.push(_react2['default'].createElement(
	        'li',
	        {
	          className: prefixCls + '-search ' + prefixCls + '-search--inline',
	          key: '__input'
	        },
	        _this2.getInputElement()
	      ));
	
	      if ((0, _util.isMultipleOrTags)(props) && choiceTransitionName) {
	        innerNode = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            onLeave: _this2.onChoiceAnimationLeave,
	            component: 'ul',
	            transitionName: choiceTransitionName
	          },
	          selectedValueNodes
	        );
	      } else {
	        innerNode = _react2['default'].createElement(
	          'ul',
	          null,
	          selectedValueNodes
	        );
	      }
	    }
	    return _react2['default'].createElement(
	      'div',
	      { className: className, ref: (0, _util.saveRef)(_this2, 'topCtrlRef') },
	      _this2.getPlaceholderElement(),
	      innerNode
	    );
	  };
	};
	
	exports['default'] = Select;
	
	
	Select.displayName = 'Select';
	module.exports = exports['default'];

/***/ },
/* 2575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DropdownMenu = __webpack_require__(2571);
	
	var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _util = __webpack_require__(476);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_rcTrigger2['default'].displayName = 'Trigger';
	
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  }
	};
	
	var SelectTrigger = function (_React$Component) {
	  (0, _inherits3['default'])(SelectTrigger, _React$Component);
	
	  function SelectTrigger() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SelectTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownWidth: null
	    }, _this.setDropdownWidth = function () {
	      var width = _reactDom2['default'].findDOMNode(_this).offsetWidth;
	      if (width !== _this.state.dropdownWidth) {
	        _this.setState({ dropdownWidth: width });
	      }
	    }, _this.getInnerMenu = function () {
	      return _this.dropdownMenuRef && _this.dropdownMenuRef.menuRef;
	    }, _this.getPopupDOMNode = function () {
	      return _this.triggerRef.getPopupDomNode();
	    }, _this.getDropdownElement = function (newProps) {
	      var props = _this.props;
	      return _react2['default'].createElement(_DropdownMenu2['default'], (0, _extends3['default'])({
	        ref: (0, _util.saveRef)(_this, 'dropdownMenuRef')
	      }, newProps, {
	        prefixCls: _this.getDropdownPrefixCls(),
	        onMenuSelect: props.onMenuSelect,
	        onMenuDeselect: props.onMenuDeselect,
	        onPopupScroll: props.onPopupScroll,
	        value: props.value,
	        firstActiveValue: props.firstActiveValue,
	        defaultActiveFirstOption: props.defaultActiveFirstOption,
	        dropdownMenuStyle: props.dropdownMenuStyle
	      }));
	    }, _this.getDropdownTransitionName = function () {
	      var props = _this.props;
	      var transitionName = props.transitionName;
	      if (!transitionName && props.animation) {
	        transitionName = _this.getDropdownPrefixCls() + '-' + props.animation;
	      }
	      return transitionName;
	    }, _this.getDropdownPrefixCls = function () {
	      return _this.props.prefixCls + '-dropdown';
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  SelectTrigger.prototype.componentDidMount = function componentDidMount() {
	    this.setDropdownWidth();
	  };
	
	  SelectTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setDropdownWidth();
	  };
	
	  SelectTrigger.prototype.render = function render() {
	    var _popupClassName;
	
	    var _props = this.props,
	        onPopupFocus = _props.onPopupFocus,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['onPopupFocus']);
	    var multiple = props.multiple,
	        visible = props.visible,
	        inputValue = props.inputValue,
	        dropdownAlign = props.dropdownAlign,
	        disabled = props.disabled,
	        showSearch = props.showSearch,
	        dropdownClassName = props.dropdownClassName,
	        dropdownStyle = props.dropdownStyle,
	        dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
	
	    var dropdownPrefixCls = this.getDropdownPrefixCls();
	    var popupClassName = (_popupClassName = {}, _popupClassName[dropdownClassName] = !!dropdownClassName, _popupClassName[dropdownPrefixCls + '--' + (multiple ? 'multiple' : 'single')] = 1, _popupClassName);
	    var popupElement = this.getDropdownElement({
	      menuItems: props.options,
	      onPopupFocus: onPopupFocus,
	      multiple: multiple,
	      inputValue: inputValue,
	      visible: visible
	    });
	    var hideAction = void 0;
	    if (disabled) {
	      hideAction = [];
	    } else if ((0, _util.isSingleMode)(props) && !showSearch) {
	      hideAction = ['click'];
	    } else {
	      hideAction = ['blur'];
	    }
	    var popupStyle = (0, _extends3['default'])({}, dropdownStyle);
	    var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';
	    if (this.state.dropdownWidth) {
	      popupStyle[widthProp] = this.state.dropdownWidth + 'px';
	    }
	
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({}, props, {
	        showAction: disabled ? [] : this.props.showAction,
	        hideAction: hideAction,
	        ref: (0, _util.saveRef)(this, 'triggerRef'),
	        popupPlacement: 'bottomLeft',
	        builtinPlacements: BUILT_IN_PLACEMENTS,
	        prefixCls: dropdownPrefixCls,
	        popupTransitionName: this.getDropdownTransitionName(),
	        onPopupVisibleChange: props.onDropdownVisibleChange,
	        popup: popupElement,
	        popupAlign: dropdownAlign,
	        popupVisible: visible,
	        getPopupContainer: props.getPopupContainer,
	        popupClassName: (0, _classnames2['default'])(popupClassName),
	        popupStyle: popupStyle
	      }),
	      props.children
	    );
	  };
	
	  return SelectTrigger;
	}(_react2['default'].Component);
	
	SelectTrigger.propTypes = {
	  onPopupFocus: _propTypes2['default'].func,
	  onPopupScroll: _propTypes2['default'].func,
	  dropdownMatchSelectWidth: _propTypes2['default'].bool,
	  dropdownAlign: _propTypes2['default'].object,
	  visible: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  showSearch: _propTypes2['default'].bool,
	  dropdownClassName: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  inputValue: _propTypes2['default'].string,
	  filterOption: _propTypes2['default'].any,
	  options: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  showAction: _propTypes2['default'].arrayOf(_propTypes2['default'].string)
	};
	exports['default'] = SelectTrigger;
	
	
	SelectTrigger.displayName = 'SelectTrigger';
	module.exports = exports['default'];

/***/ },
/* 2576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      included = _ref.included,
	      upperBound = _ref.upperBound,
	      lowerBound = _ref.lowerBound,
	      max = _ref.max,
	      min = _ref.min;
	
	  var marksKeys = Object.keys(marks);
	  var marksCount = marksKeys.length;
	  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
	  var markWidth = unit * 0.9;
	
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var markPoint = marks[point];
	    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	    if (!markLabel) {
	      return null;
	    }
	
	    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames2['default'])((_classNames = {}, _classNames[className + '-text'] = true, _classNames[className + '-text-active'] = isActive, _classNames));
	
	    var bottomStyle = {
	      marginBottom: '-50%',
	      bottom: (point - min) / range * 100 + '%'
	    };
	
	    var leftStyle = {
	      width: markWidth + '%',
	      marginLeft: -markWidth / 2 + '%',
	      left: (point - min) / range * 100 + '%'
	    };
	
	    var style = vertical ? bottomStyle : leftStyle;
	    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: markClassName,
	        style: markStyle,
	        key: point
	      },
	      markLabel
	    );
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: className },
	    elements
	  );
	};
	
	exports['default'] = Marks;
	module.exports = exports['default'];

/***/ },
/* 2577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat);
	  if (dots) {
	    for (var i = min; i <= max; i = i + step) {
	      if (points.indexOf(i) >= 0) continue;
	      points.push(i);
	    }
	  }
	  return points;
	};
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls,
	      vertical = _ref.vertical,
	      marks = _ref.marks,
	      dots = _ref.dots,
	      step = _ref.step,
	      included = _ref.included,
	      lowerBound = _ref.lowerBound,
	      upperBound = _ref.upperBound,
	      max = _ref.max,
	      min = _ref.min,
	      dotStyle = _ref.dotStyle,
	      activeDotStyle = _ref.activeDotStyle;
	
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = Math.abs(point - min) / range * 100 + '%';
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var style = vertical ? (0, _extends3['default'])({ bottom: offset }, dotStyle) : (0, _extends3['default'])({ left: offset }, dotStyle);
	    if (isActived) {
	      style = (0, _extends3['default'])({}, style, activeDotStyle);
	    }
	
	    var pointClassName = (0, _classnames2['default'])((_classNames = {}, _classNames[prefixCls + '-dot'] = true, _classNames[prefixCls + '-dot-active'] = isActived, _classNames));
	
	    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: prefixCls + '-step' },
	    elements
	  );
	};
	
	exports['default'] = Steps;
	module.exports = exports['default'];

/***/ },
/* 2578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSliderWithTooltip;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTooltip = __webpack_require__(1187);
	
	var _rcTooltip2 = _interopRequireDefault(_rcTooltip);
	
	var _Handle = __webpack_require__(328);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function createSliderWithTooltip(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_React$Component) {
	    (0, _inherits3['default'])(ComponentWrapper, _React$Component);
	
	    function ComponentWrapper(props) {
	      (0, _classCallCheck3['default'])(this, ComponentWrapper);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	      _this.handleTooltipVisibleChange = function (index, visible) {
	        _this.setState(function (prevState) {
	          var _extends2;
	
	          return {
	            visibles: (0, _extends4['default'])({}, prevState.visibles, (_extends2 = {}, _extends2[index] = visible, _extends2))
	          };
	        });
	      };
	
	      _this.handleWithTooltip = function (_ref) {
	        var value = _ref.value,
	            dragging = _ref.dragging,
	            index = _ref.index,
	            disabled = _ref.disabled,
	            restProps = (0, _objectWithoutProperties3['default'])(_ref, ['value', 'dragging', 'index', 'disabled']);
	        var _this$props = _this.props,
	            tipFormatter = _this$props.tipFormatter,
	            tipProps = _this$props.tipProps,
	            handleStyle = _this$props.handleStyle;
	        var _tipProps$prefixCls = tipProps.prefixCls,
	            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
	            _tipProps$overlay = tipProps.overlay,
	            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
	            _tipProps$placement = tipProps.placement,
	            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
	            restTooltipProps = (0, _objectWithoutProperties3['default'])(tipProps, ['prefixCls', 'overlay', 'placement']);
	
	
	        return _react2['default'].createElement(
	          _rcTooltip2['default'],
	          (0, _extends4['default'])({}, restTooltipProps, {
	            prefixCls: prefixCls,
	            overlay: overlay,
	            placement: placement,
	            visible: !disabled && (_this.state.visibles[index] || dragging),
	            key: index
	          }),
	          _react2['default'].createElement(_Handle2['default'], (0, _extends4['default'])({}, restProps, {
	            style: (0, _extends4['default'])({}, handleStyle[0]),
	            value: value,
	            onMouseEnter: function onMouseEnter() {
	              return _this.handleTooltipVisibleChange(index, true);
	            },
	            onMouseLeave: function onMouseLeave() {
	              return _this.handleTooltipVisibleChange(index, false);
	            }
	          }))
	        );
	      };
	
	      _this.state = { visibles: {} };
	      return _this;
	    }
	
	    ComponentWrapper.prototype.render = function render() {
	      return _react2['default'].createElement(Component, (0, _extends4['default'])({}, this.props, { handle: this.handleWithTooltip }));
	    };
	
	    return ComponentWrapper;
	  }(_react2['default'].Component), _class.propTypes = {
	    tipFormatter: _propTypes2['default'].func,
	    handleStyle: _propTypes2['default'].arrayOf(_propTypes2['default'].object),
	    tipProps: _propTypes2['default'].object
	  }, _class.defaultProps = {
	    tipFormatter: function tipFormatter(value) {
	      return value;
	    },
	
	    handleStyle: [{}],
	    tipProps: {}
	  }, _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 2579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createSliderWithTooltip = exports.Handle = exports.Range = undefined;
	
	var _Slider = __webpack_require__(1176);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Range = __webpack_require__(1175);
	
	var _Range2 = _interopRequireDefault(_Range);
	
	var _Handle = __webpack_require__(328);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _createSliderWithTooltip = __webpack_require__(2578);
	
	var _createSliderWithTooltip2 = _interopRequireDefault(_createSliderWithTooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Slider2['default'].Range = _Range2['default'];
	_Slider2['default'].Handle = _Handle2['default'];
	_Slider2['default'].createSliderWithTooltip = _createSliderWithTooltip2['default'];
	exports['default'] = _Slider2['default'];
	exports.Range = _Range2['default'];
	exports.Handle = _Handle2['default'];
	exports.createSliderWithTooltip = _createSliderWithTooltip2['default'];

/***/ },
/* 2580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isString(str) {
	  return typeof str === 'string';
	}
	
	var Step = function (_React$Component) {
	  (0, _inherits3['default'])(Step, _React$Component);
	
	  function Step() {
	    (0, _classCallCheck3['default'])(this, Step);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Step.prototype.renderIconNode = function renderIconNode() {
	    var _classNames;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        progressDot = _props.progressDot,
	        stepNumber = _props.stepNumber,
	        status = _props.status,
	        title = _props.title,
	        description = _props.description,
	        icon = _props.icon,
	        iconPrefix = _props.iconPrefix;
	
	    var iconNode = void 0;
	    var iconClassName = (0, _classnames2['default'])(prefixCls + '-icon', iconPrefix + 'icon', (_classNames = {}, _classNames[iconPrefix + 'icon-' + icon] = icon && isString(icon), _classNames[iconPrefix + 'icon-check'] = !icon && status === 'finish', _classNames[iconPrefix + 'icon-cross'] = !icon && status === 'error', _classNames));
	    var iconDot = _react2['default'].createElement('span', { className: prefixCls + '-icon-dot' });
	    // `progressDot` enjoy the highest priority
	    if (progressDot) {
	      if (typeof progressDot === 'function') {
	        iconNode = _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-icon' },
	          progressDot(iconDot, { index: stepNumber - 1, status: status, title: title, description: description })
	        );
	      } else {
	        iconNode = _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-icon' },
	          iconDot
	        );
	      }
	    } else if (icon && !isString(icon)) {
	      iconNode = _react2['default'].createElement(
	        'span',
	        { className: prefixCls + '-icon' },
	        icon
	      );
	    } else if (icon || status === 'finish' || status === 'error') {
	      iconNode = _react2['default'].createElement('span', { className: iconClassName });
	    } else {
	      iconNode = _react2['default'].createElement(
	        'span',
	        { className: prefixCls + '-icon' },
	        stepNumber
	      );
	    }
	    return iconNode;
	  };
	
	  Step.prototype.render = function render() {
	    var _classNames2;
	
	    var _props2 = this.props,
	        className = _props2.className,
	        prefixCls = _props2.prefixCls,
	        style = _props2.style,
	        itemWidth = _props2.itemWidth,
	        _props2$status = _props2.status,
	        status = _props2$status === undefined ? 'wait' : _props2$status,
	        iconPrefix = _props2.iconPrefix,
	        icon = _props2.icon,
	        wrapperStyle = _props2.wrapperStyle,
	        adjustMarginRight = _props2.adjustMarginRight,
	        stepNumber = _props2.stepNumber,
	        description = _props2.description,
	        title = _props2.title,
	        progressDot = _props2.progressDot,
	        restProps = (0, _objectWithoutProperties3['default'])(_props2, ['className', 'prefixCls', 'style', 'itemWidth', 'status', 'iconPrefix', 'icon', 'wrapperStyle', 'adjustMarginRight', 'stepNumber', 'description', 'title', 'progressDot']);
	
	
	    var classString = (0, _classnames2['default'])(prefixCls + '-item', prefixCls + '-item-' + status, className, (_classNames2 = {}, _classNames2[prefixCls + '-item-custom'] = icon, _classNames2));
	    var stepItemStyle = (0, _extends3['default'])({}, style);
	    if (itemWidth) {
	      stepItemStyle.width = itemWidth;
	    }
	    if (adjustMarginRight) {
	      stepItemStyle.marginRight = adjustMarginRight;
	    }
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, restProps, {
	        className: classString,
	        style: stepItemStyle
	      }),
	      _react2['default'].createElement('div', { className: prefixCls + '-item-tail' }),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-item-icon' },
	        this.renderIconNode()
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-item-content' },
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-item-title' },
	          title
	        ),
	        description && _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-item-description' },
	          description
	        )
	      )
	    );
	  };
	
	  return Step;
	}(_react2['default'].Component);
	
	Step.propTypes = {
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  wrapperStyle: _propTypes2['default'].object,
	  itemWidth: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  status: _propTypes2['default'].string,
	  iconPrefix: _propTypes2['default'].string,
	  icon: _propTypes2['default'].node,
	  adjustMarginRight: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  stepNumber: _propTypes2['default'].string,
	  description: _propTypes2['default'].any,
	  title: _propTypes2['default'].any,
	  progressDot: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func])
	};
	exports['default'] = Step;
	module.exports = exports['default'];

/***/ },
/* 2581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(307);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _utils = __webpack_require__(2583);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/no-did-mount-set-state: 0 */
	var Steps = function (_Component) {
	  (0, _inherits3['default'])(Steps, _Component);
	
	  function Steps(props) {
	    (0, _classCallCheck3['default'])(this, Steps);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _this.calcStepOffsetWidth = function () {
	      if ((0, _utils.isFlexSupported)()) {
	        return;
	      }
	      // Just for IE9
	      var domNode = (0, _reactDom.findDOMNode)(_this);
	      if (domNode.children.length > 0) {
	        if (_this.calcTimeout) {
	          clearTimeout(_this.calcTimeout);
	        }
	        _this.calcTimeout = setTimeout(function () {
	          // +1 for fit edge bug of digit width, like 35.4px
	          var lastStepOffsetWidth = (domNode.lastChild.offsetWidth || 0) + 1;
	          // Reduce shake bug
	          if (_this.state.lastStepOffsetWidth === lastStepOffsetWidth || Math.abs(_this.state.lastStepOffsetWidth - lastStepOffsetWidth) <= 3) {
	            return;
	          }
	          _this.setState({ lastStepOffsetWidth: lastStepOffsetWidth });
	        });
	      }
	    };
	
	    _this.state = {
	      flexSupported: true,
	      lastStepOffsetWidth: 0
	    };
	    _this.calcStepOffsetWidth = (0, _lodash2['default'])(_this.calcStepOffsetWidth, 150);
	    return _this;
	  }
	
	  Steps.prototype.componentDidMount = function componentDidMount() {
	    this.calcStepOffsetWidth();
	    if (!(0, _utils.isFlexSupported)()) {
	      this.setState({
	        flexSupported: false
	      });
	    }
	  };
	
	  Steps.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.calcStepOffsetWidth();
	  };
	
	  Steps.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.calcTimeout) {
	      clearTimeout(this.calcTimeout);
	    }
	    if (this.calcStepOffsetWidth && this.calcStepOffsetWidth.cancel) {
	      this.calcStepOffsetWidth.cancel();
	    }
	  };
	
	  Steps.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        _props$style = _props.style,
	        style = _props$style === undefined ? {} : _props$style,
	        className = _props.className,
	        children = _props.children,
	        direction = _props.direction,
	        labelPlacement = _props.labelPlacement,
	        iconPrefix = _props.iconPrefix,
	        status = _props.status,
	        size = _props.size,
	        current = _props.current,
	        progressDot = _props.progressDot,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'style', 'className', 'children', 'direction', 'labelPlacement', 'iconPrefix', 'status', 'size', 'current', 'progressDot']);
	    var _state = this.state,
	        lastStepOffsetWidth = _state.lastStepOffsetWidth,
	        flexSupported = _state.flexSupported;
	
	    var filteredChildren = _react2['default'].Children.toArray(children).filter(function (c) {
	      return !!c;
	    });
	    var lastIndex = filteredChildren.length - 1;
	    var adjustedlabelPlacement = !!progressDot ? 'vertical' : labelPlacement;
	    var classString = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + direction, className, (_classNames = {}, _classNames[prefixCls + '-' + size] = size, _classNames[prefixCls + '-label-' + adjustedlabelPlacement] = direction === 'horizontal', _classNames[prefixCls + '-dot'] = !!progressDot, _classNames));
	
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({ className: classString, style: style }, restProps),
	      _react.Children.map(filteredChildren, function (child, index) {
	        if (!child) {
	          return null;
	        }
	        var childProps = (0, _extends3['default'])({
	          stepNumber: '' + (index + 1),
	          prefixCls: prefixCls,
	          iconPrefix: iconPrefix,
	          wrapperStyle: style,
	          progressDot: progressDot
	        }, child.props);
	        if (!flexSupported && direction !== 'vertical' && index !== lastIndex) {
	          childProps.itemWidth = 100 / lastIndex + '%';
	          childProps.adjustMarginRight = -Math.round(lastStepOffsetWidth / lastIndex + 1);
	        }
	        // fix tail color
	        if (status === 'error' && index === current - 1) {
	          childProps.className = prefixCls + '-next-error';
	        }
	        if (!child.props.status) {
	          if (index === current) {
	            childProps.status = status;
	          } else if (index < current) {
	            childProps.status = 'finish';
	          } else {
	            childProps.status = 'wait';
	          }
	        }
	        return (0, _react.cloneElement)(child, childProps);
	      })
	    );
	  };
	
	  return Steps;
	}(_react.Component);
	
	Steps.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  iconPrefix: _propTypes2['default'].string,
	  direction: _propTypes2['default'].string,
	  labelPlacement: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  status: _propTypes2['default'].string,
	  size: _propTypes2['default'].string,
	  progressDot: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].func]),
	  style: _propTypes2['default'].object,
	  current: _propTypes2['default'].number
	};
	Steps.defaultProps = {
	  prefixCls: 'rc-steps',
	  iconPrefix: 'rc',
	  direction: 'horizontal',
	  labelPlacement: 'horizontal',
	  current: 0,
	  status: 'process',
	  size: '',
	  progressDot: false
	};
	exports['default'] = Steps;
	module.exports = exports['default'];

/***/ },
/* 2582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Step = undefined;
	
	var _Steps = __webpack_require__(2581);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Step = __webpack_require__(2580);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Steps2['default'].Step = _Step2['default'];
	
	exports.Step = _Step2['default'];
	exports['default'] = _Steps2['default'];

/***/ },
/* 2583 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isFlexSupported = isFlexSupported;
	function isFlexSupported() {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var documentElement = window.document.documentElement;
	
	    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
	  }
	  return false;
	}

/***/ },
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var classNames = __webpack_require__(7);
	
	function noop() {}
	
	var Switch = function (_Component) {
	  (0, _inherits3['default'])(Switch, _Component);
	
	  function Switch(props) {
	    (0, _classCallCheck3['default'])(this, Switch);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var checked = false;
	    if ('checked' in props) {
	      checked = !!props.checked;
	    } else {
	      checked = !!props.defaultChecked;
	    }
	    _this.state = { checked: checked };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Switch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          autoFocus = _props.autoFocus,
	          disabled = _props.disabled;
	
	      if (autoFocus && !disabled) {
	        this.focus();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('checked' in nextProps) {
	        this.setState({
	          checked: !!nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(checked) {
	      if (this.props.disabled) {
	        return;
	      }
	      if (!('checked' in this.props)) {
	        this.setState({
	          checked: checked
	        });
	      }
	      this.props.onChange(checked);
	    }
	
	    // Handle auto focus when click switch in Chrome
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.node.focus();
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.node.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props2 = this.props,
	          className = _props2.className,
	          prefixCls = _props2.prefixCls,
	          disabled = _props2.disabled,
	          checkedChildren = _props2.checkedChildren,
	          tabIndex = _props2.tabIndex,
	          unCheckedChildren = _props2.unCheckedChildren,
	          restProps = (0, _objectWithoutProperties3['default'])(_props2, ['className', 'prefixCls', 'disabled', 'checkedChildren', 'tabIndex', 'unCheckedChildren']);
	
	      var checked = this.state.checked;
	      var switchTabIndex = disabled ? -1 : tabIndex || 0;
	      var switchClassName = classNames((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className, !!className), (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-checked', checked), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), _classNames));
	      return _react2['default'].createElement(
	        'span',
	        (0, _extends3['default'])({}, restProps, {
	          className: switchClassName,
	          tabIndex: switchTabIndex,
	          ref: this.saveNode,
	          onKeyDown: this.handleKeyDown,
	          onClick: this.toggle,
	          onMouseUp: this.handleMouseUp
	        }),
	        _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-inner' },
	          checked ? checkedChildren : unCheckedChildren
	        )
	      );
	    }
	  }]);
	  return Switch;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.toggle = function () {
	    var onClick = _this2.props.onClick;
	
	    var checked = !_this2.state.checked;
	    _this2.setChecked(checked);
	    onClick(checked);
	  };
	
	  this.handleKeyDown = function (e) {
	    if (e.keyCode === 37) {
	      // Left
	      _this2.setChecked(false);
	    } else if (e.keyCode === 39) {
	      // Right
	      _this2.setChecked(true);
	    } else if (e.keyCode === 32 || e.keyCode === 13) {
	      // Space, Enter
	      _this2.toggle();
	    }
	  };
	
	  this.handleMouseUp = function (e) {
	    if (_this2.node) {
	      _this2.node.blur();
	    }
	    if (_this2.props.onMouseUp) {
	      _this2.props.onMouseUp(e);
	    }
	  };
	
	  this.saveNode = function (node) {
	    _this2.node = node;
	  };
	};
	
	Switch.propTypes = {
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  checkedChildren: _propTypes2['default'].any,
	  unCheckedChildren: _propTypes2['default'].any,
	  onChange: _propTypes2['default'].func,
	  onMouseUp: _propTypes2['default'].func,
	  onClick: _propTypes2['default'].func,
	  tabIndex: _propTypes2['default'].number,
	  checked: _propTypes2['default'].bool,
	  defaultChecked: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool
	};
	
	Switch.defaultProps = {
	  prefixCls: 'rc-switch',
	  checkedChildren: null,
	  unCheckedChildren: null,
	  className: '',
	  defaultChecked: false,
	  onChange: noop,
	  onClick: noop
	};
	
	exports['default'] = Switch;
	module.exports = exports['default'];

/***/ },
/* 2585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2584);

/***/ },
/* 2586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports['default'] = BodyTable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(238);
	
	var _BaseTable = __webpack_require__(1179);
	
	var _BaseTable2 = _interopRequireDefault(_BaseTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function BodyTable(props, _ref) {
	  var table = _ref.table;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      scroll = _table$props.scroll;
	  var columns = props.columns,
	      fixed = props.fixed,
	      tableClassName = props.tableClassName,
	      getRowKey = props.getRowKey,
	      handleBodyScroll = props.handleBodyScroll,
	      expander = props.expander;
	  var saveRef = table.saveRef;
	  var useFixedHeader = table.props.useFixedHeader;
	
	  var bodyStyle = (0, _extends3['default'])({}, table.props.bodyStyle);
	  var innerBodyStyle = {};
	
	  if (scroll.x || fixed) {
	    bodyStyle.overflowX = bodyStyle.overflowX || 'auto';
	    // Fix weired webkit render bug
	    // https://github.com/ant-design/ant-design/issues/7783
	    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
	  }
	
	  if (scroll.y) {
	    // maxHeight will make fixed-Table scrolling not working
	    // so we only set maxHeight to body-Table here
	    if (fixed) {
	      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
	      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
	    } else {
	      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
	    }
	    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
	    useFixedHeader = true;
	
	    // Add negative margin bottom for scroll bar overflow bug
	    var scrollbarWidth = (0, _utils.measureScrollbar)();
	    if (scrollbarWidth > 0 && fixed) {
	      bodyStyle.marginBottom = '-' + scrollbarWidth + 'px';
	      bodyStyle.paddingBottom = '0px';
	    }
	  }
	
	  var baseTable = _react2['default'].createElement(_BaseTable2['default'], {
	    tableClassName: tableClassName,
	    hasHead: !useFixedHeader,
	    hasBody: true,
	    fixed: fixed,
	    columns: columns,
	    expander: expander,
	    getRowKey: getRowKey
	  });
	
	  if (fixed && columns.length) {
	    var refName = void 0;
	    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
	      refName = 'fixedColumnsBodyLeft';
	    } else if (columns[0].fixed === 'right') {
	      refName = 'fixedColumnsBodyRight';
	    }
	    delete bodyStyle.overflowX;
	    delete bodyStyle.overflowY;
	    return _react2['default'].createElement(
	      'div',
	      {
	        key: 'bodyTable',
	        className: prefixCls + '-body-outer',
	        style: (0, _extends3['default'])({}, bodyStyle)
	      },
	      _react2['default'].createElement(
	        'div',
	        {
	          className: prefixCls + '-body-inner',
	          style: innerBodyStyle,
	          ref: saveRef(refName),
	          onScroll: handleBodyScroll
	        },
	        baseTable
	      )
	    );
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    {
	      key: 'bodyTable',
	      className: prefixCls + '-body',
	      style: bodyStyle,
	      ref: saveRef('bodyTable'),
	      onScroll: handleBodyScroll
	    },
	    baseTable
	  );
	}
	
	BodyTable.propTypes = {
	  fixed: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  columns: _propTypes2['default'].array.isRequired,
	  tableClassName: _propTypes2['default'].string.isRequired,
	  handleBodyScroll: _propTypes2['default'].func.isRequired,
	  getRowKey: _propTypes2['default'].func.isRequired,
	  expander: _propTypes2['default'].object.isRequired
	};
	
	BodyTable.contextTypes = {
	  table: _propTypes2['default'].any
	};
	module.exports = exports['default'];

/***/ },
/* 2587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = ColGroup;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function ColGroup(props, _ref) {
	  var table = _ref.table;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      expandIconAsCell = _table$props.expandIconAsCell;
	  var fixed = props.fixed;
	
	
	  var cols = [];
	
	  if (expandIconAsCell && fixed !== 'right') {
	    cols.push(_react2['default'].createElement('col', {
	      className: prefixCls + '-expand-icon-col',
	      key: 'rc-table-expand-icon-col'
	    }));
	  }
	
	  var leafColumns = void 0;
	
	  if (fixed === 'left') {
	    leafColumns = table.columnManager.leftLeafColumns();
	  } else if (fixed === 'right') {
	    leafColumns = table.columnManager.rightLeafColumns();
	  } else {
	    leafColumns = table.columnManager.leafColumns();
	  }
	  cols = cols.concat(leafColumns.map(function (c) {
	    return _react2['default'].createElement('col', {
	      key: c.key || c.dataIndex,
	      style: { width: c.width, minWidth: c.width }
	    });
	  }));
	
	  return _react2['default'].createElement(
	    'colgroup',
	    null,
	    cols
	  );
	}
	
	ColGroup.propTypes = {
	  fixed: _propTypes2['default'].string
	};
	
	ColGroup.contextTypes = {
	  table: _propTypes2['default'].any
	};
	module.exports = exports['default'];

/***/ },
/* 2588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Column = function (_Component) {
	  (0, _inherits3['default'])(Column, _Component);
	
	  function Column() {
	    (0, _classCallCheck3['default'])(this, Column);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  return Column;
	}(_react.Component);
	
	Column.propTypes = {
	  className: _propTypes2['default'].string,
	  colSpan: _propTypes2['default'].number,
	  title: _propTypes2['default'].node,
	  dataIndex: _propTypes2['default'].string,
	  width: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  fixed: _propTypes2['default'].oneOf([true, 'left', 'right']),
	  render: _propTypes2['default'].func,
	  onCellClick: _propTypes2['default'].func,
	  onCell: _propTypes2['default'].func,
	  onHeaderCell: _propTypes2['default'].func
	};
	exports['default'] = Column;
	module.exports = exports['default'];

/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ColumnGroup = function (_Component) {
	  (0, _inherits3['default'])(ColumnGroup, _Component);
	
	  function ColumnGroup() {
	    (0, _classCallCheck3['default'])(this, ColumnGroup);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  return ColumnGroup;
	}(_react.Component);
	
	ColumnGroup.propTypes = {
	  title: _propTypes2['default'].node
	};
	ColumnGroup.isTableColumnGroup = true;
	exports['default'] = ColumnGroup;
	module.exports = exports['default'];

/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ColumnManager = function () {
	  function ColumnManager(columns, elements) {
	    (0, _classCallCheck3['default'])(this, ColumnManager);
	    this._cached = {};
	
	    this.columns = columns || this.normalize(elements);
	  }
	
	  ColumnManager.prototype.isAnyColumnsFixed = function isAnyColumnsFixed() {
	    var _this = this;
	
	    return this._cache('isAnyColumnsFixed', function () {
	      return _this.columns.some(function (column) {
	        return !!column.fixed;
	      });
	    });
	  };
	
	  ColumnManager.prototype.isAnyColumnsLeftFixed = function isAnyColumnsLeftFixed() {
	    var _this2 = this;
	
	    return this._cache('isAnyColumnsLeftFixed', function () {
	      return _this2.columns.some(function (column) {
	        return column.fixed === 'left' || column.fixed === true;
	      });
	    });
	  };
	
	  ColumnManager.prototype.isAnyColumnsRightFixed = function isAnyColumnsRightFixed() {
	    var _this3 = this;
	
	    return this._cache('isAnyColumnsRightFixed', function () {
	      return _this3.columns.some(function (column) {
	        return column.fixed === 'right';
	      });
	    });
	  };
	
	  ColumnManager.prototype.leftColumns = function leftColumns() {
	    var _this4 = this;
	
	    return this._cache('leftColumns', function () {
	      return _this4.groupedColumns().filter(function (column) {
	        return column.fixed === 'left' || column.fixed === true;
	      });
	    });
	  };
	
	  ColumnManager.prototype.rightColumns = function rightColumns() {
	    var _this5 = this;
	
	    return this._cache('rightColumns', function () {
	      return _this5.groupedColumns().filter(function (column) {
	        return column.fixed === 'right';
	      });
	    });
	  };
	
	  ColumnManager.prototype.leafColumns = function leafColumns() {
	    var _this6 = this;
	
	    return this._cache('leafColumns', function () {
	      return _this6._leafColumns(_this6.columns);
	    });
	  };
	
	  ColumnManager.prototype.leftLeafColumns = function leftLeafColumns() {
	    var _this7 = this;
	
	    return this._cache('leftLeafColumns', function () {
	      return _this7._leafColumns(_this7.leftColumns());
	    });
	  };
	
	  ColumnManager.prototype.rightLeafColumns = function rightLeafColumns() {
	    var _this8 = this;
	
	    return this._cache('rightLeafColumns', function () {
	      return _this8._leafColumns(_this8.rightColumns());
	    });
	  };
	
	  // add appropriate rowspan and colspan to column
	
	
	  ColumnManager.prototype.groupedColumns = function groupedColumns() {
	    var _this9 = this;
	
	    return this._cache('groupedColumns', function () {
	      var _groupColumns = function _groupColumns(columns) {
	        var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	        var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	        var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	        // track how many rows we got
	        rows[currentRow] = rows[currentRow] || [];
	        var grouped = [];
	        var setRowSpan = function setRowSpan(column) {
	          var rowSpan = rows.length - currentRow;
	          if (column && !column.children && // parent columns are supposed to be one row
	          rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
	            column.rowSpan = rowSpan;
	          }
	        };
	        columns.forEach(function (column, index) {
	          var newColumn = (0, _extends3['default'])({}, column);
	          rows[currentRow].push(newColumn);
	          parentColumn.colSpan = parentColumn.colSpan || 0;
	          if (newColumn.children && newColumn.children.length > 0) {
	            newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
	            parentColumn.colSpan = parentColumn.colSpan + newColumn.colSpan;
	          } else {
	            parentColumn.colSpan++;
	          }
	          // update rowspan to all same row columns
	          for (var i = 0; i < rows[currentRow].length - 1; ++i) {
	            setRowSpan(rows[currentRow][i]);
	          }
	          // last column, update rowspan immediately
	          if (index + 1 === columns.length) {
	            setRowSpan(newColumn);
	          }
	          grouped.push(newColumn);
	        });
	        return grouped;
	      };
	      return _groupColumns(_this9.columns);
	    });
	  };
	
	  ColumnManager.prototype.normalize = function normalize(elements) {
	    var _this10 = this;
	
	    var columns = [];
	    _react2['default'].Children.forEach(elements, function (element) {
	      if (!_react2['default'].isValidElement(element)) {
	        return;
	      }
	      var column = (0, _extends3['default'])({}, element.props);
	      if (element.key) {
	        column.key = element.key;
	      }
	      if (element.type.isTableColumnGroup) {
	        column.children = _this10.normalize(column.children);
	      }
	      columns.push(column);
	    });
	    return columns;
	  };
	
	  ColumnManager.prototype.reset = function reset(columns, elements) {
	    this.columns = columns || this.normalize(elements);
	    this._cached = {};
	  };
	
	  ColumnManager.prototype._cache = function _cache(name, fn) {
	    if (name in this._cached) {
	      return this._cached[name];
	    }
	    this._cached[name] = fn();
	    return this._cached[name];
	  };
	
	  ColumnManager.prototype._leafColumns = function _leafColumns(columns) {
	    var _this11 = this;
	
	    var leafColumns = [];
	    columns.forEach(function (column) {
	      if (!column.children) {
	        leafColumns.push(column);
	      } else {
	        leafColumns.push.apply(leafColumns, _this11._leafColumns(column.children));
	      }
	    });
	    return leafColumns;
	  };
	
	  return ColumnManager;
	}();
	
	exports['default'] = ColumnManager;
	module.exports = exports['default'];

/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ExpandIcon = function (_React$Component) {
	  (0, _inherits3['default'])(ExpandIcon, _React$Component);
	
	  function ExpandIcon() {
	    (0, _classCallCheck3['default'])(this, ExpandIcon);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  ExpandIcon.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return !(0, _shallowequal2['default'])(nextProps, this.props);
	  };
	
	  ExpandIcon.prototype.render = function render() {
	    var _props = this.props,
	        expandable = _props.expandable,
	        prefixCls = _props.prefixCls,
	        onExpand = _props.onExpand,
	        needIndentSpaced = _props.needIndentSpaced,
	        expanded = _props.expanded,
	        record = _props.record;
	
	    if (expandable) {
	      var expandClassName = expanded ? 'expanded' : 'collapsed';
	      return _react2['default'].createElement('span', {
	        className: prefixCls + '-expand-icon ' + prefixCls + '-' + expandClassName,
	        onClick: function onClick(e) {
	          return onExpand(record, e);
	        }
	      });
	    } else if (needIndentSpaced) {
	      return _react2['default'].createElement('span', { className: prefixCls + '-expand-icon ' + prefixCls + '-spaced' });
	    }
	    return null;
	  };
	
	  return ExpandIcon;
	}(_react2['default'].Component);
	
	ExpandIcon.propTypes = {
	  record: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  expandable: _propTypes2['default'].any,
	  expanded: _propTypes2['default'].bool,
	  needIndentSpaced: _propTypes2['default'].bool,
	  onExpand: _propTypes2['default'].func
	};
	exports['default'] = ExpandIcon;
	module.exports = exports['default'];

/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _miniStore = __webpack_require__(190);
	
	var _ExpandIcon = __webpack_require__(2591);
	
	var _ExpandIcon2 = _interopRequireDefault(_ExpandIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ExpandableRow = function (_React$Component) {
	  (0, _inherits3['default'])(ExpandableRow, _React$Component);
	
	  function ExpandableRow() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, ExpandableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.hasExpandIcon = function (columnIndex) {
	      var expandRowByClick = _this.props.expandRowByClick;
	
	      return !_this.expandIconAsCell && !expandRowByClick && columnIndex === _this.expandIconColumnIndex;
	    }, _this.handleExpandChange = function (record, event) {
	      var _this$props = _this.props,
	          onExpandedChange = _this$props.onExpandedChange,
	          expanded = _this$props.expanded,
	          rowKey = _this$props.rowKey;
	
	      if (_this.expandable) {
	        onExpandedChange(!expanded, record, event, rowKey);
	      }
	    }, _this.handleRowClick = function (record, index, event) {
	      var _this$props2 = _this.props,
	          expandRowByClick = _this$props2.expandRowByClick,
	          onRowClick = _this$props2.onRowClick;
	
	      if (expandRowByClick) {
	        _this.handleExpandChange(record, event);
	      }
	      if (onRowClick) {
	        onRowClick(record, index, event);
	      }
	    }, _this.renderExpandIcon = function () {
	      var _this$props3 = _this.props,
	          prefixCls = _this$props3.prefixCls,
	          expanded = _this$props3.expanded,
	          record = _this$props3.record,
	          needIndentSpaced = _this$props3.needIndentSpaced;
	
	
	      return _react2['default'].createElement(_ExpandIcon2['default'], {
	        expandable: _this.expandable,
	        prefixCls: prefixCls,
	        onExpand: _this.handleExpandChange,
	        needIndentSpaced: needIndentSpaced,
	        expanded: expanded,
	        record: record
	      });
	    }, _this.renderExpandIconCell = function (cells) {
	      if (!_this.expandIconAsCell) {
	        return;
	      }
	      var prefixCls = _this.props.prefixCls;
	
	
	      cells.push(_react2['default'].createElement(
	        'td',
	        {
	          className: prefixCls + '-expand-icon-cell',
	          key: 'rc-table-expand-icon-cell'
	        },
	        _this.renderExpandIcon()
	      ));
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  ExpandableRow.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.handleDestroy();
	  };
	
	  ExpandableRow.prototype.handleDestroy = function handleDestroy() {
	    var _props = this.props,
	        onExpandedChange = _props.onExpandedChange,
	        rowKey = _props.rowKey,
	        record = _props.record;
	
	    if (this.expandable) {
	      onExpandedChange(false, record, null, rowKey);
	    }
	  };
	
	  ExpandableRow.prototype.render = function render() {
	    var _props2 = this.props,
	        childrenColumnName = _props2.childrenColumnName,
	        expandedRowRender = _props2.expandedRowRender,
	        indentSize = _props2.indentSize,
	        record = _props2.record,
	        fixed = _props2.fixed;
	
	
	    this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
	    this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
	    var childrenData = record[childrenColumnName];
	    this.expandable = !!(childrenData || expandedRowRender);
	
	    var expandableRowProps = {
	      indentSize: indentSize,
	      onRowClick: this.handleRowClick,
	      hasExpandIcon: this.hasExpandIcon,
	      renderExpandIcon: this.renderExpandIcon,
	      renderExpandIconCell: this.renderExpandIconCell
	    };
	
	    return this.props.children(expandableRowProps);
	  };
	
	  return ExpandableRow;
	}(_react2['default'].Component);
	
	ExpandableRow.propTypes = {
	  prefixCls: _propTypes2['default'].string.isRequired,
	  rowKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]).isRequired,
	  fixed: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  record: _propTypes2['default'].object.isRequired,
	  indentSize: _propTypes2['default'].number,
	  needIndentSpaced: _propTypes2['default'].bool.isRequired,
	  expandRowByClick: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool.isRequired,
	  expandIconAsCell: _propTypes2['default'].bool,
	  expandIconColumnIndex: _propTypes2['default'].number,
	  childrenColumnName: _propTypes2['default'].string,
	  expandedRowRender: _propTypes2['default'].func,
	  onExpandedChange: _propTypes2['default'].func.isRequired,
	  onRowClick: _propTypes2['default'].func,
	  children: _propTypes2['default'].func.isRequired
	};
	exports['default'] = (0, _miniStore.connect)(function (_ref, _ref2) {
	  var expandedRowKeys = _ref.expandedRowKeys;
	  var rowKey = _ref2.rowKey;
	  return {
	    expanded: !!~expandedRowKeys.indexOf(rowKey)
	  };
	})(ExpandableRow);
	module.exports = exports['default'];

/***/ },
/* 2593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _miniStore = __webpack_require__(190);
	
	var _TableRow = __webpack_require__(1180);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _utils = __webpack_require__(238);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ExpandableTable = function (_React$Component) {
	  (0, _inherits3['default'])(ExpandableTable, _React$Component);
	
	  function ExpandableTable(props) {
	    (0, _classCallCheck3['default'])(this, ExpandableTable);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var data = props.data,
	        childrenColumnName = props.childrenColumnName,
	        defaultExpandAllRows = props.defaultExpandAllRows,
	        expandedRowKeys = props.expandedRowKeys,
	        defaultExpandedRowKeys = props.defaultExpandedRowKeys,
	        getRowKey = props.getRowKey;
	
	
	    var finnalExpandedRowKeys = [];
	    var rows = [].concat(data);
	
	    if (defaultExpandAllRows) {
	      for (var i = 0; i < rows.length; i++) {
	        var row = rows[i];
	        finnalExpandedRowKeys.push(getRowKey(row, i));
	        rows = rows.concat(row[childrenColumnName] || []);
	      }
	    } else {
	      finnalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
	    }
	
	    _this.columnManager = props.columnManager;
	    _this.store = props.store;
	
	    _this.store.setState({
	      expandedRowsHeight: {},
	      expandedRowKeys: finnalExpandedRowKeys
	    });
	    return _this;
	  }
	
	  ExpandableTable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if ('expandedRowKeys' in nextProps) {
	      this.store.setState({
	        expandedRowKeys: nextProps.expandedRowKeys
	      });
	    }
	  };
	
	  ExpandableTable.prototype.renderExpandedRow = function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        expandIconAsCell = _props.expandIconAsCell,
	        indentSize = _props.indentSize;
	
	    var colCount = void 0;
	    if (fixed === 'left') {
	      colCount = this.columnManager.leftLeafColumns().length;
	    } else if (fixed === 'right') {
	      colCount = this.columnManager.rightLeafColumns().length;
	    } else {
	      colCount = this.columnManager.leafColumns().length;
	    }
	    var columns = [{
	      key: 'extra-row',
	      render: function render() {
	        return {
	          props: {
	            colSpan: colCount
	          },
	          children: fixed !== 'right' ? _render(record, index, indent) : '&nbsp;'
	        };
	      }
	    }];
	    if (expandIconAsCell && fixed !== 'right') {
	      columns.unshift({
	        key: 'expand-icon-placeholder',
	        render: function render() {
	          return null;
	        }
	      });
	    }
	    var parentKey = ancestorKeys[ancestorKeys.length - 1];
	    var rowKey = parentKey + '-extra-row';
	    var components = {
	      body: {
	        row: 'tr',
	        cell: 'td'
	      }
	    };
	
	    return _react2['default'].createElement(_TableRow2['default'], {
	      key: rowKey,
	      columns: columns,
	      className: className,
	      rowKey: rowKey,
	      ancestorKeys: ancestorKeys,
	      prefixCls: prefixCls + '-expanded-row',
	      indentSize: indentSize,
	      indent: indent,
	      fixed: fixed,
	      components: components,
	      expandedRow: true
	    });
	  };
	
	  ExpandableTable.prototype.render = function render() {
	    var _props2 = this.props,
	        data = _props2.data,
	        childrenColumnName = _props2.childrenColumnName,
	        children = _props2.children;
	
	    var needIndentSpaced = data.some(function (record) {
	      return record[childrenColumnName];
	    });
	
	    return children({
	      props: this.props,
	      needIndentSpaced: needIndentSpaced,
	      renderRows: this.renderRows,
	      handleExpandChange: this.handleExpandChange,
	      renderExpandIndentCell: this.renderExpandIndentCell
	    });
	  };
	
	  return ExpandableTable;
	}(_react2['default'].Component);
	
	ExpandableTable.propTypes = {
	  expandIconAsCell: _propTypes2['default'].bool,
	  expandedRowKeys: _propTypes2['default'].array,
	  expandedRowClassName: _propTypes2['default'].func,
	  defaultExpandAllRows: _propTypes2['default'].bool,
	  defaultExpandedRowKeys: _propTypes2['default'].array,
	  expandIconColumnIndex: _propTypes2['default'].number,
	  expandedRowRender: _propTypes2['default'].func,
	  childrenColumnName: _propTypes2['default'].string,
	  indentSize: _propTypes2['default'].number,
	  onExpand: _propTypes2['default'].func,
	  onExpandedRowsChange: _propTypes2['default'].func,
	  columnManager: _propTypes2['default'].object.isRequired,
	  store: _propTypes2['default'].object.isRequired,
	  prefixCls: _propTypes2['default'].string.isRequired,
	  data: _propTypes2['default'].array,
	  children: _propTypes2['default'].func.isRequired
	};
	ExpandableTable.defaultProps = {
	  expandIconAsCell: false,
	  expandedRowClassName: function expandedRowClassName() {
	    return '';
	  },
	  expandIconColumnIndex: 0,
	  defaultExpandAllRows: false,
	  defaultExpandedRowKeys: [],
	  childrenColumnName: 'children',
	  indentSize: 15,
	  onExpand: function onExpand() {},
	  onExpandedRowsChange: function onExpandedRowsChange() {}
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.handleExpandChange = function (expanded, record, event, rowKey) {
	    if (event) {
	      event.preventDefault();
	      event.stopPropagation();
	    }
	
	    var _props3 = _this2.props,
	        onExpandedRowsChange = _props3.onExpandedRowsChange,
	        onExpand = _props3.onExpand;
	
	    var _store$getState = _this2.store.getState(),
	        expandedRowKeys = _store$getState.expandedRowKeys;
	
	    if (expanded) {
	      // row was expaned
	      expandedRowKeys = [].concat(expandedRowKeys, [rowKey]);
	    } else {
	      // row was collapse
	      var expandedRowIndex = expandedRowKeys.indexOf(rowKey);
	      if (expandedRowIndex !== -1) {
	        expandedRowKeys = (0, _utils.remove)(expandedRowKeys, rowKey);
	      }
	    }
	
	    if (!_this2.props.expandedRowKeys) {
	      _this2.store.setState({ expandedRowKeys: expandedRowKeys });
	    }
	
	    onExpandedRowsChange(expandedRowKeys);
	    onExpand(expanded, record);
	  };
	
	  this.renderExpandIndentCell = function (rows, fixed) {
	    var _props4 = _this2.props,
	        prefixCls = _props4.prefixCls,
	        expandIconAsCell = _props4.expandIconAsCell;
	
	    if (!expandIconAsCell || fixed === 'right') {
	      return;
	    }
	
	    var iconColumn = {
	      key: 'rc-table-expand-icon-cell',
	      className: prefixCls + '-expand-icon-th',
	      title: '',
	      rowSpan: rows.length
	    };
	
	    rows[0].unshift((0, _extends3['default'])({}, iconColumn, { column: iconColumn }));
	  };
	
	  this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
	    var _props5 = _this2.props,
	        expandedRowClassName = _props5.expandedRowClassName,
	        expandedRowRender = _props5.expandedRowRender,
	        childrenColumnName = _props5.childrenColumnName;
	
	    var childrenData = record[childrenColumnName];
	    var nextAncestorKeys = [].concat(ancestorKeys, [parentKey]);
	    var nextIndent = indent + 1;
	
	    if (expandedRowRender) {
	      rows.push(_this2.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
	    }
	
	    if (childrenData) {
	      rows.push.apply(rows, renderRows(childrenData, nextIndent, nextAncestorKeys));
	    }
	  };
	};
	
	exports['default'] = (0, _miniStore.connect)()(ExpandableTable);
	module.exports = exports['default'];

/***/ },
/* 2594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = HeadTable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(238);
	
	var _BaseTable = __webpack_require__(1179);
	
	var _BaseTable2 = _interopRequireDefault(_BaseTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function HeadTable(props, _ref) {
	  var table = _ref.table;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      scroll = _table$props.scroll,
	      showHeader = _table$props.showHeader;
	  var columns = props.columns,
	      fixed = props.fixed,
	      tableClassName = props.tableClassName,
	      handleBodyScrollLeft = props.handleBodyScrollLeft,
	      expander = props.expander;
	  var saveRef = table.saveRef;
	  var useFixedHeader = table.props.useFixedHeader;
	
	  var headStyle = {};
	
	  if (scroll.y) {
	    useFixedHeader = true;
	    // Add negative margin bottom for scroll bar overflow bug
	    var scrollbarWidth = (0, _utils.measureScrollbar)();
	    if (scrollbarWidth > 0 && !fixed) {
	      headStyle.marginBottom = '-' + scrollbarWidth + 'px';
	      headStyle.paddingBottom = '0px';
	    }
	  }
	
	  if (!useFixedHeader || !showHeader) {
	    return null;
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    {
	      key: 'headTable',
	      ref: fixed ? null : saveRef('headTable'),
	      className: prefixCls + '-header',
	      style: headStyle,
	      onScroll: handleBodyScrollLeft
	    },
	    _react2['default'].createElement(_BaseTable2['default'], {
	      tableClassName: tableClassName,
	      hasHead: true,
	      hasBody: false,
	      fixed: fixed,
	      columns: columns,
	      expander: expander
	    })
	  );
	}
	
	HeadTable.propTypes = {
	  fixed: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	  columns: _propTypes2['default'].array.isRequired,
	  tableClassName: _propTypes2['default'].string.isRequired,
	  handleBodyScrollLeft: _propTypes2['default'].func.isRequired,
	  expander: _propTypes2['default'].object.isRequired
	};
	
	HeadTable.contextTypes = {
	  table: _propTypes2['default'].any
	};
	module.exports = exports['default'];

/***/ },
/* 2595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(238);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _miniStore = __webpack_require__(190);
	
	var _lodash = __webpack_require__(2325);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ColumnManager = __webpack_require__(2590);
	
	var _ColumnManager2 = _interopRequireDefault(_ColumnManager);
	
	var _componentClasses = __webpack_require__(418);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	var _HeadTable = __webpack_require__(2594);
	
	var _HeadTable2 = _interopRequireDefault(_HeadTable);
	
	var _BodyTable = __webpack_require__(2586);
	
	var _BodyTable2 = _interopRequireDefault(_BodyTable);
	
	var _ExpandableTable = __webpack_require__(2593);
	
	var _ExpandableTable2 = _interopRequireDefault(_ExpandableTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Table = function (_React$Component) {
	  (0, _inherits3['default'])(Table, _React$Component);
	
	  function Table(props) {
	    (0, _classCallCheck3['default'])(this, Table);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.getRowKey = function (record, index) {
	      var rowKey = _this.props.rowKey;
	      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	      (0, _utils.warningOnce)(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
	      return key === undefined ? index : key;
	    };
	
	    _this.handleWindowResize = function () {
	      _this.syncFixedTableRowHeight();
	      _this.setScrollPositionClassName();
	    };
	
	    _this.syncFixedTableRowHeight = function () {
	      var tableRect = _this.tableNode.getBoundingClientRect();
	      // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
	      // see: https://github.com/ant-design/ant-design/issues/4836
	      if (tableRect.height !== undefined && tableRect.height <= 0) {
	        return;
	      }
	      var prefixCls = _this.props.prefixCls;
	
	      var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
	      var bodyRows = _this.bodyTable.querySelectorAll('.' + prefixCls + '-row') || [];
	      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
	        return row.getBoundingClientRect().height || 'auto';
	      });
	      var fixedColumnsBodyRowsHeight = [].map.call(bodyRows, function (row) {
	        return row.getBoundingClientRect().height || 'auto';
	      });
	      var state = _this.store.getState();
	      if ((0, _shallowequal2['default'])(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && (0, _shallowequal2['default'])(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
	        return;
	      }
	
	      _this.store.setState({
	        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
	        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
	      });
	    };
	
	    _this.handleBodyScrollLeft = function (e) {
	      // Fix https://github.com/ant-design/ant-design/issues/7635
	      if (e.currentTarget !== e.target) {
	        return;
	      }
	      var target = e.target;
	      var _this$props$scroll = _this.props.scroll,
	          scroll = _this$props$scroll === undefined ? {} : _this$props$scroll;
	      var headTable = _this.headTable,
	          bodyTable = _this.bodyTable;
	
	      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
	        if (target === bodyTable && headTable) {
	          headTable.scrollLeft = target.scrollLeft;
	        } else if (target === headTable && bodyTable) {
	          bodyTable.scrollLeft = target.scrollLeft;
	        }
	        _this.setScrollPositionClassName();
	      }
	      // Remember last scrollLeft for scroll direction detecting.
	      _this.lastScrollLeft = target.scrollLeft;
	    };
	
	    _this.handleBodyScrollTop = function (e) {
	      var target = e.target;
	      var _this$props$scroll2 = _this.props.scroll,
	          scroll = _this$props$scroll2 === undefined ? {} : _this$props$scroll2;
	      var headTable = _this.headTable,
	          bodyTable = _this.bodyTable,
	          fixedColumnsBodyLeft = _this.fixedColumnsBodyLeft,
	          fixedColumnsBodyRight = _this.fixedColumnsBodyRight;
	
	      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
	        var scrollTop = target.scrollTop;
	        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
	          fixedColumnsBodyLeft.scrollTop = scrollTop;
	        }
	        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
	          fixedColumnsBodyRight.scrollTop = scrollTop;
	        }
	        if (bodyTable && target !== bodyTable) {
	          bodyTable.scrollTop = scrollTop;
	        }
	      }
	      // Remember last scrollTop for scroll direction detecting.
	      _this.lastScrollTop = target.scrollTop;
	    };
	
	    _this.handleBodyScroll = function (e) {
	      _this.handleBodyScrollLeft(e);
	      _this.handleBodyScrollTop(e);
	    };
	
	    _this.saveRef = function (name) {
	      return function (node) {
	        _this[name] = node;
	      };
	    };
	
	    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
	      (0, _utils.warningOnce)(props[name] === undefined, name + ' is deprecated, please use onRow instead.');
	    });
	
	    (0, _utils.warningOnce)(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');
	
	    _this.columnManager = new _ColumnManager2['default'](props.columns, props.children);
	
	    _this.store = (0, _miniStore.create)({
	      currentHoverKey: null,
	      fixedColumnsHeadRowsHeight: [],
	      fixedColumnsBodyRowsHeight: []
	    });
	
	    _this.setScrollPosition('left');
	
	    _this.debouncedWindowResize = (0, _utils.debounce)(_this.handleWindowResize, 150);
	    return _this;
	  }
	
	  Table.prototype.getChildContext = function getChildContext() {
	    return {
	      table: {
	        props: this.props,
	        columnManager: this.columnManager,
	        saveRef: this.saveRef,
	        components: (0, _lodash2['default'])({
	          table: 'table',
	          header: {
	            wrapper: 'thead',
	            row: 'tr',
	            cell: 'th'
	          },
	          body: {
	            wrapper: 'tbody',
	            row: 'tr',
	            cell: 'td'
	          }
	        }, this.props.components)
	      }
	    };
	  };
	
	  Table.prototype.componentDidMount = function componentDidMount() {
	    if (this.columnManager.isAnyColumnsFixed()) {
	      this.handleWindowResize();
	      this.resizeEvent = (0, _addEventListener2['default'])(window, 'resize', this.debouncedWindowResize);
	    }
	  };
	
	  Table.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.columns && nextProps.columns !== this.props.columns) {
	      this.columnManager.reset(nextProps.columns);
	    } else if (nextProps.children !== this.props.children) {
	      this.columnManager.reset(null, nextProps.children);
	    }
	  };
	
	  Table.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.columnManager.isAnyColumnsFixed()) {
	      this.handleWindowResize();
	      if (!this.resizeEvent) {
	        this.resizeEvent = (0, _addEventListener2['default'])(window, 'resize', this.debouncedWindowResize);
	      }
	    }
	    // when table changes to empty, reset scrollLeft
	    if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
	      this.resetScrollX();
	    }
	  };
	
	  Table.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.resizeEvent) {
	      this.resizeEvent.remove();
	    }
	    if (this.debouncedWindowResize) {
	      this.debouncedWindowResize.cancel();
	    }
	  };
	
	  Table.prototype.setScrollPosition = function setScrollPosition(position) {
	    this.scrollPosition = position;
	    if (this.tableNode) {
	      var prefixCls = this.props.prefixCls;
	
	      if (position === 'both') {
	        (0, _componentClasses2['default'])(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-left').add(prefixCls + '-scroll-position-right');
	      } else {
	        (0, _componentClasses2['default'])(this.tableNode).remove(new RegExp('^' + prefixCls + '-scroll-position-.+$')).add(prefixCls + '-scroll-position-' + position);
	      }
	    }
	  };
	
	  Table.prototype.setScrollPositionClassName = function setScrollPositionClassName() {
	    var node = this.bodyTable;
	    var scrollToLeft = node.scrollLeft === 0;
	    var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;
	    if (scrollToLeft && scrollToRight) {
	      this.setScrollPosition('both');
	    } else if (scrollToLeft) {
	      this.setScrollPosition('left');
	    } else if (scrollToRight) {
	      this.setScrollPosition('right');
	    } else if (this.scrollPosition !== 'middle') {
	      this.setScrollPosition('middle');
	    }
	  };
	
	  Table.prototype.resetScrollX = function resetScrollX() {
	    if (this.headTable) {
	      this.headTable.scrollLeft = 0;
	    }
	    if (this.bodyTable) {
	      this.bodyTable.scrollLeft = 0;
	    }
	  };
	
	  Table.prototype.hasScrollX = function hasScrollX() {
	    var _props$scroll = this.props.scroll,
	        scroll = _props$scroll === undefined ? {} : _props$scroll;
	
	    return 'x' in scroll;
	  };
	
	  Table.prototype.renderMainTable = function renderMainTable() {
	    var _props = this.props,
	        scroll = _props.scroll,
	        prefixCls = _props.prefixCls;
	
	    var scrollable = this.columnManager.isAnyColumnsFixed() || scroll.x || scroll.y;
	
	    var table = [this.renderTable({
	      columns: this.columnManager.groupedColumns()
	    }), this.renderEmptyText(), this.renderFooter()];
	
	    return scrollable ? _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-scroll' },
	      table
	    ) : table;
	  };
	
	  Table.prototype.renderLeftFixedTable = function renderLeftFixedTable() {
	    var prefixCls = this.props.prefixCls;
	
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-fixed-left' },
	      this.renderTable({
	        columns: this.columnManager.leftColumns(),
	        fixed: 'left'
	      })
	    );
	  };
	
	  Table.prototype.renderRightFixedTable = function renderRightFixedTable() {
	    var prefixCls = this.props.prefixCls;
	
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-fixed-right' },
	      this.renderTable({
	        columns: this.columnManager.rightColumns(),
	        fixed: 'right'
	      })
	    );
	  };
	
	  Table.prototype.renderTable = function renderTable(options) {
	    var columns = options.columns,
	        fixed = options.fixed;
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        _props2$scroll = _props2.scroll,
	        scroll = _props2$scroll === undefined ? {} : _props2$scroll;
	
	    var tableClassName = scroll.x || fixed ? prefixCls + '-fixed' : '';
	
	    var headTable = _react2['default'].createElement(_HeadTable2['default'], {
	      key: 'head',
	      columns: columns,
	      fixed: fixed,
	      tableClassName: tableClassName,
	      handleBodyScrollLeft: this.handleBodyScrollLeft,
	      expander: this.expander
	    });
	
	    var bodyTable = _react2['default'].createElement(_BodyTable2['default'], {
	      key: 'body',
	      columns: columns,
	      fixed: fixed,
	      tableClassName: tableClassName,
	      getRowKey: this.getRowKey,
	      handleBodyScroll: this.handleBodyScroll,
	      expander: this.expander
	    });
	
	    return [headTable, bodyTable];
	  };
	
	  Table.prototype.renderTitle = function renderTitle() {
	    var _props3 = this.props,
	        title = _props3.title,
	        prefixCls = _props3.prefixCls;
	
	    return title ? _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-title', key: 'title' },
	      title(this.props.data)
	    ) : null;
	  };
	
	  Table.prototype.renderFooter = function renderFooter() {
	    var _props4 = this.props,
	        footer = _props4.footer,
	        prefixCls = _props4.prefixCls;
	
	    return footer ? _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-footer', key: 'footer' },
	      footer(this.props.data)
	    ) : null;
	  };
	
	  Table.prototype.renderEmptyText = function renderEmptyText() {
	    var _props5 = this.props,
	        emptyText = _props5.emptyText,
	        prefixCls = _props5.prefixCls,
	        data = _props5.data;
	
	    if (data.length) {
	      return null;
	    }
	    var emptyClassName = prefixCls + '-placeholder';
	    return _react2['default'].createElement(
	      'div',
	      { className: emptyClassName, key: 'emptyText' },
	      typeof emptyText === 'function' ? emptyText() : emptyText
	    );
	  };
	
	  Table.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var prefixCls = props.prefixCls;
	
	    var className = props.prefixCls;
	    if (props.className) {
	      className += ' ' + props.className;
	    }
	    if (props.useFixedHeader || props.scroll && props.scroll.y) {
	      className += ' ' + prefixCls + '-fixed-header';
	    }
	    if (this.scrollPosition === 'both') {
	      className += ' ' + prefixCls + '-scroll-position-left ' + prefixCls + '-scroll-position-right';
	    } else {
	      className += ' ' + prefixCls + '-scroll-position-' + this.scrollPosition;
	    }
	    var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
	    var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();
	
	    return _react2['default'].createElement(
	      _miniStore.Provider,
	      { store: this.store },
	      _react2['default'].createElement(
	        _ExpandableTable2['default'],
	        (0, _extends3['default'])({}, props, {
	          columnManager: this.columnManager,
	          getRowKey: this.getRowKey
	        }),
	        function (expander) {
	          _this2.expander = expander;
	          return _react2['default'].createElement(
	            'div',
	            {
	              ref: _this2.saveRef('tableNode'),
	              className: className,
	              style: props.style,
	              id: props.id
	            },
	            _this2.renderTitle(),
	            _react2['default'].createElement(
	              'div',
	              { className: prefixCls + '-content' },
	              _this2.renderMainTable(),
	              hasLeftFixed && _this2.renderLeftFixedTable(),
	              hasRightFixed && _this2.renderRightFixedTable()
	            )
	          );
	        }
	      )
	    );
	  };
	
	  return Table;
	}(_react2['default'].Component);
	
	Table.propTypes = (0, _extends3['default'])({
	  data: _propTypes2['default'].array,
	  useFixedHeader: _propTypes2['default'].bool,
	  columns: _propTypes2['default'].array,
	  prefixCls: _propTypes2['default'].string,
	  bodyStyle: _propTypes2['default'].object,
	  style: _propTypes2['default'].object,
	  rowKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  rowClassName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  onRow: _propTypes2['default'].func,
	  onHeaderRow: _propTypes2['default'].func,
	  onRowClick: _propTypes2['default'].func,
	  onRowDoubleClick: _propTypes2['default'].func,
	  onRowContextMenu: _propTypes2['default'].func,
	  onRowMouseEnter: _propTypes2['default'].func,
	  onRowMouseLeave: _propTypes2['default'].func,
	  showHeader: _propTypes2['default'].bool,
	  title: _propTypes2['default'].func,
	  id: _propTypes2['default'].string,
	  footer: _propTypes2['default'].func,
	  emptyText: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	  scroll: _propTypes2['default'].object,
	  rowRef: _propTypes2['default'].func,
	  getBodyWrapper: _propTypes2['default'].func,
	  children: _propTypes2['default'].node,
	  components: _propTypes2['default'].shape({
	    table: _propTypes2['default'].any,
	    header: _propTypes2['default'].shape({
	      wrapper: _propTypes2['default'].any,
	      row: _propTypes2['default'].any,
	      cell: _propTypes2['default'].any
	    }),
	    body: _propTypes2['default'].shape({
	      wrapper: _propTypes2['default'].any,
	      row: _propTypes2['default'].any,
	      cell: _propTypes2['default'].any
	    })
	  })
	}, _ExpandableTable2['default'].PropTypes);
	Table.childContextTypes = {
	  table: _propTypes2['default'].any,
	  components: _propTypes2['default'].any
	};
	Table.defaultProps = {
	  data: [],
	  useFixedHeader: false,
	  rowKey: 'key',
	  rowClassName: function rowClassName() {
	    return '';
	  },
	  onRow: function onRow() {},
	  onHeaderRow: function onHeaderRow() {},
	
	  prefixCls: 'rc-table',
	  bodyStyle: {},
	  style: {},
	  showHeader: true,
	  scroll: {},
	  rowRef: function rowRef() {
	    return null;
	  },
	  emptyText: function emptyText() {
	    return 'No Data';
	  }
	};
	exports['default'] = Table;
	module.exports = exports['default'];

/***/ },
/* 2596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(974);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TableCell = function (_React$Component) {
	  (0, _inherits3['default'])(TableCell, _React$Component);
	
	  function TableCell() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, TableCell);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (e) {
	      var _this$props = _this.props,
	          record = _this$props.record,
	          onCellClick = _this$props.column.onCellClick;
	
	      if (onCellClick) {
	        onCellClick(record, e);
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  TableCell.prototype.isInvalidRenderCellText = function isInvalidRenderCellText(text) {
	    return text && !_react2['default'].isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
	  };
	
	  TableCell.prototype.render = function render() {
	    var _props = this.props,
	        record = _props.record,
	        indentSize = _props.indentSize,
	        prefixCls = _props.prefixCls,
	        indent = _props.indent,
	        index = _props.index,
	        expandIcon = _props.expandIcon,
	        column = _props.column,
	        BodyCell = _props.component;
	    var dataIndex = column.dataIndex,
	        render = column.render,
	        _column$className = column.className,
	        className = _column$className === undefined ? '' : _column$className;
	
	    // We should return undefined if no dataIndex is specified, but in order to
	    // be compatible with object-path's behavior, we return the record object instead.
	
	    var text = void 0;
	    if (typeof dataIndex === 'number') {
	      text = (0, _lodash2['default'])(record, dataIndex);
	    } else if (!dataIndex || dataIndex.length === 0) {
	      text = record;
	    } else {
	      text = (0, _lodash2['default'])(record, dataIndex);
	    }
	    var tdProps = {};
	    var colSpan = void 0;
	    var rowSpan = void 0;
	
	    if (render) {
	      text = render(text, record, index);
	      if (this.isInvalidRenderCellText(text)) {
	        tdProps = text.props || tdProps;
	        colSpan = tdProps.colSpan;
	        rowSpan = tdProps.rowSpan;
	        text = text.children;
	      }
	    }
	
	    if (column.onCell) {
	      tdProps = (0, _extends3['default'])({}, tdProps, column.onCell(record));
	    }
	
	    // Fix https://github.com/ant-design/ant-design/issues/1202
	    if (this.isInvalidRenderCellText(text)) {
	      text = null;
	    }
	
	    var indentText = expandIcon ? _react2['default'].createElement('span', {
	      style: { paddingLeft: indentSize * indent + 'px' },
	      className: prefixCls + '-indent indent-level-' + indent
	    }) : null;
	
	    if (rowSpan === 0 || colSpan === 0) {
	      return null;
	    }
	
	    if (column.align) {
	      tdProps.style = { textAlign: column.align };
	    }
	
	    return _react2['default'].createElement(
	      BodyCell,
	      (0, _extends3['default'])({
	        className: className,
	        onClick: this.handleClick
	      }, tdProps),
	      indentText,
	      expandIcon,
	      text
	    );
	  };
	
	  return TableCell;
	}(_react2['default'].Component);
	
	TableCell.propTypes = {
	  record: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  index: _propTypes2['default'].number,
	  indent: _propTypes2['default'].number,
	  indentSize: _propTypes2['default'].number,
	  column: _propTypes2['default'].object,
	  expandIcon: _propTypes2['default'].node,
	  component: _propTypes2['default'].any
	};
	exports['default'] = TableCell;
	module.exports = exports['default'];

/***/ },
/* 2597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = TableHeader;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TableHeaderRow = __webpack_require__(2598);
	
	var _TableHeaderRow2 = _interopRequireDefault(_TableHeaderRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getHeaderRows(columns) {
	  var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var rows = arguments[2];
	
	  rows = rows || [];
	  rows[currentRow] = rows[currentRow] || [];
	
	  columns.forEach(function (column) {
	    if (column.rowSpan && rows.length < column.rowSpan) {
	      while (rows.length < column.rowSpan) {
	        rows.push([]);
	      }
	    }
	    var cell = {
	      key: column.key,
	      className: column.className || '',
	      children: column.title,
	      column: column
	    };
	    if (column.children) {
	      getHeaderRows(column.children, currentRow + 1, rows);
	    }
	    if ('colSpan' in column) {
	      cell.colSpan = column.colSpan;
	    }
	    if ('rowSpan' in column) {
	      cell.rowSpan = column.rowSpan;
	    }
	    if (cell.colSpan !== 0) {
	      rows[currentRow].push(cell);
	    }
	  });
	  return rows.filter(function (row) {
	    return row.length > 0;
	  });
	}
	
	function TableHeader(props, _ref) {
	  var table = _ref.table;
	  var components = table.components;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      showHeader = _table$props.showHeader,
	      onHeaderRow = _table$props.onHeaderRow;
	  var expander = props.expander,
	      columns = props.columns,
	      fixed = props.fixed;
	
	
	  if (!showHeader) {
	    return null;
	  }
	
	  var rows = getHeaderRows(columns);
	
	  expander.renderExpandIndentCell(rows, fixed);
	
	  var HeaderWrapper = components.header.wrapper;
	
	  return _react2['default'].createElement(
	    HeaderWrapper,
	    { className: prefixCls + '-thead' },
	    rows.map(function (row, index) {
	      return _react2['default'].createElement(_TableHeaderRow2['default'], {
	        key: index,
	        index: index,
	        fixed: fixed,
	        columns: columns,
	        rows: rows,
	        row: row,
	        components: components,
	        onHeaderRow: onHeaderRow
	      });
	    })
	  );
	}
	
	TableHeader.propTypes = {
	  fixed: _propTypes2['default'].string,
	  columns: _propTypes2['default'].array.isRequired,
	  expander: _propTypes2['default'].object.isRequired,
	  onHeaderRow: _propTypes2['default'].func
	};
	
	TableHeader.contextTypes = {
	  table: _propTypes2['default'].any
	};
	module.exports = exports['default'];

/***/ },
/* 2598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _miniStore = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TableHeaderRow(_ref) {
	  var row = _ref.row,
	      index = _ref.index,
	      height = _ref.height,
	      components = _ref.components,
	      onHeaderRow = _ref.onHeaderRow;
	
	  var HeaderRow = components.header.row;
	  var HeaderCell = components.header.cell;
	  var rowProps = onHeaderRow(row.map(function (cell) {
	    return cell.column;
	  }), index);
	  var customStyle = rowProps ? rowProps.style : {};
	  var style = (0, _extends3['default'])({ height: height }, customStyle);
	
	  return _react2['default'].createElement(
	    HeaderRow,
	    (0, _extends3['default'])({}, rowProps, { style: style }),
	    row.map(function (cell, i) {
	      var column = cell.column,
	          cellProps = (0, _objectWithoutProperties3['default'])(cell, ['column']);
	
	      var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};
	      if (column.align) {
	        cellProps.style = { textAlign: column.align };
	      }
	      return _react2['default'].createElement(HeaderCell, (0, _extends3['default'])({}, cellProps, customProps, {
	        key: column.key || column.dataIndex || i
	      }));
	    })
	  );
	}
	
	function getRowHeight(state, props) {
	  var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
	  var columns = props.columns,
	      rows = props.rows;
	
	  var headerHeight = fixedColumnsHeadRowsHeight[0];
	
	  if (headerHeight && columns) {
	    if (headerHeight === 'auto') {
	      return 'auto';
	    }
	    return headerHeight / rows.length;
	  }
	  return null;
	}
	
	exports['default'] = (0, _miniStore.connect)(function (state, props) {
	  return {
	    height: getRowHeight(state, props)
	  };
	})(TableHeaderRow);
	module.exports = exports['default'];

/***/ },
/* 2599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ColumnGroup = exports.Column = undefined;
	
	var _Table = __webpack_require__(2595);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _Column = __webpack_require__(2588);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _ColumnGroup = __webpack_require__(2589);
	
	var _ColumnGroup2 = _interopRequireDefault(_ColumnGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	_Table2['default'].Column = _Column2['default'];
	_Table2['default'].ColumnGroup = _ColumnGroup2['default'];
	
	exports['default'] = _Table2['default'];
	exports.Column = _Column2['default'];
	exports.ColumnGroup = _ColumnGroup2['default'];

/***/ },
/* 2600 */
1532,
/* 2601 */
[3337, 1181, 2602, 479, 478],
/* 2602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classnames5 = __webpack_require__(7);
	
	var _classnames6 = _interopRequireDefault(_classnames5);
	
	var _utils = __webpack_require__(156);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _addEventListener = __webpack_require__(89);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _debounce = __webpack_require__(2611);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      scrollAnimated: true,
	      onPrevClick: function onPrevClick() {},
	      onNextClick: function onNextClick() {}
	    };
	  },
	  getInitialState: function getInitialState() {
	    this.offset = 0;
	    return {
	      next: false,
	      prev: false
	    };
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    this.componentDidUpdate();
	    this.debouncedResize = (0, _debounce2['default'])(function () {
	      _this.setNextPrev();
	      _this.scrollToActiveTab();
	    }, 200);
	    this.resizeEvent = (0, _addEventListener2['default'])(window, 'resize', this.debouncedResize);
	  },
	  componentDidUpdate: function componentDidUpdate(prevProps) {
	    var props = this.props;
	    if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
	      this.setOffset(0);
	      return;
	    }
	    var nextPrev = this.setNextPrev();
	    // wait next, prev show hide
	    /* eslint react/no-did-update-set-state:0 */
	    if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
	      this.setState({}, this.scrollToActiveTab);
	    } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
	      // can not use props.activeKey
	      this.scrollToActiveTab();
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.resizeEvent) {
	      this.resizeEvent.remove();
	    }
	    if (this.debouncedResize && this.debouncedResize.cancel) {
	      this.debouncedResize.cancel();
	    }
	  },
	  setNextPrev: function setNextPrev() {
	    var navNode = this.nav;
	    var navNodeWH = this.getScrollWH(navNode);
	    var containerWH = this.getOffsetWH(this.container);
	    var navWrapNodeWH = this.getOffsetWH(this.navWrap);
	    var offset = this.offset;
	
	    var minOffset = containerWH - navNodeWH;
	    var _state = this.state,
	        next = _state.next,
	        prev = _state.prev;
	
	    if (minOffset >= 0) {
	      next = false;
	      this.setOffset(0, false);
	      offset = 0;
	    } else if (minOffset < offset) {
	      next = true;
	    } else {
	      next = false;
	      // Fix https://github.com/ant-design/ant-design/issues/8861
	      // Test with container offset which is stable
	      // and set the offset of the nav wrap node
	      var realOffset = navWrapNodeWH - navNodeWH;
	      this.setOffset(realOffset, false);
	      offset = realOffset;
	    }
	
	    if (offset < 0) {
	      prev = true;
	    } else {
	      prev = false;
	    }
	
	    this.setNext(next);
	    this.setPrev(prev);
	    return {
	      next: next,
	      prev: prev
	    };
	  },
	  getOffsetWH: function getOffsetWH(node) {
	    var tabBarPosition = this.props.tabBarPosition;
	    var prop = 'offsetWidth';
	    if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	      prop = 'offsetHeight';
	    }
	    return node[prop];
	  },
	  getScrollWH: function getScrollWH(node) {
	    var tabBarPosition = this.props.tabBarPosition;
	    var prop = 'scrollWidth';
	    if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	      prop = 'scrollHeight';
	    }
	    return node[prop];
	  },
	  getOffsetLT: function getOffsetLT(node) {
	    var tabBarPosition = this.props.tabBarPosition;
	    var prop = 'left';
	    if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	      prop = 'top';
	    }
	    return node.getBoundingClientRect()[prop];
	  },
	  setOffset: function setOffset(offset) {
	    var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    var target = Math.min(0, offset);
	    if (this.offset !== target) {
	      this.offset = target;
	      var navOffset = {};
	      var tabBarPosition = this.props.tabBarPosition;
	      var navStyle = this.nav.style;
	      var transformSupported = (0, _utils.isTransformSupported)(navStyle);
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        if (transformSupported) {
	          navOffset = {
	            value: 'translate3d(0,' + target + 'px,0)'
	          };
	        } else {
	          navOffset = {
	            name: 'top',
	            value: target + 'px'
	          };
	        }
	      } else {
	        if (transformSupported) {
	          navOffset = {
	            value: 'translate3d(' + target + 'px,0,0)'
	          };
	        } else {
	          navOffset = {
	            name: 'left',
	            value: target + 'px'
	          };
	        }
	      }
	      if (transformSupported) {
	        (0, _utils.setTransform)(navStyle, navOffset.value);
	      } else {
	        navStyle[navOffset.name] = navOffset.value;
	      }
	      if (checkNextPrev) {
	        this.setNextPrev();
	      }
	    }
	  },
	  setPrev: function setPrev(v) {
	    if (this.state.prev !== v) {
	      this.setState({
	        prev: v
	      });
	    }
	  },
	  setNext: function setNext(v) {
	    if (this.state.next !== v) {
	      this.setState({
	        next: v
	      });
	    }
	  },
	  isNextPrevShown: function isNextPrevShown(state) {
	    if (state) {
	      return state.next || state.prev;
	    }
	    return this.state.next || this.state.prev;
	  },
	  prevTransitionEnd: function prevTransitionEnd(e) {
	    if (e.propertyName !== 'opacity') {
	      return;
	    }
	    var container = this.container;
	
	    this.scrollToActiveTab({
	      target: container,
	      currentTarget: container
	    });
	  },
	  scrollToActiveTab: function scrollToActiveTab(e) {
	    var activeTab = this.activeTab,
	        navWrap = this.navWrap;
	
	    if (e && e.target !== e.currentTarget || !activeTab) {
	      return;
	    }
	
	    // when not scrollable or enter scrollable first time, don't emit scrolling
	    var needToSroll = this.isNextPrevShown() && this.lastNextPrevShown;
	    this.lastNextPrevShown = this.isNextPrevShown();
	    if (!needToSroll) {
	      return;
	    }
	
	    var activeTabWH = this.getScrollWH(activeTab);
	    var navWrapNodeWH = this.getOffsetWH(navWrap);
	    var offset = this.offset;
	
	    var wrapOffset = this.getOffsetLT(navWrap);
	    var activeTabOffset = this.getOffsetLT(activeTab);
	    if (wrapOffset > activeTabOffset) {
	      offset += wrapOffset - activeTabOffset;
	      this.setOffset(offset);
	    } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
	      offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
	      this.setOffset(offset);
	    }
	  },
	  prev: function prev(e) {
	    this.props.onPrevClick(e);
	    var navWrapNode = this.navWrap;
	    var navWrapNodeWH = this.getOffsetWH(navWrapNode);
	    var offset = this.offset;
	
	    this.setOffset(offset + navWrapNodeWH);
	  },
	  next: function next(e) {
	    this.props.onNextClick(e);
	    var navWrapNode = this.navWrap;
	    var navWrapNodeWH = this.getOffsetWH(navWrapNode);
	    var offset = this.offset;
	
	    this.setOffset(offset - navWrapNodeWH);
	  },
	  getScrollBarNode: function getScrollBarNode(content) {
	    var _classnames, _classnames2, _classnames3, _classnames4;
	
	    var _state2 = this.state,
	        next = _state2.next,
	        prev = _state2.prev;
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        scrollAnimated = _props.scrollAnimated;
	
	    var showNextPrev = prev || next;
	
	    var prevButton = _react2['default'].createElement(
	      'span',
	      {
	        onClick: prev ? this.prev : null,
	        unselectable: 'unselectable',
	        className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
	        onTransitionEnd: this.prevTransitionEnd
	      },
	      _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
	    );
	
	    var nextButton = _react2['default'].createElement(
	      'span',
	      {
	        onClick: next ? this.next : null,
	        unselectable: 'unselectable',
	        className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
	      },
	      _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
	    );
	
	    var navClassName = prefixCls + '-nav';
	    var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));
	
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
	        key: 'container',
	        ref: this.saveRef('container')
	      },
	      prevButton,
	      nextButton,
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-nav-wrap', ref: this.saveRef('navWrap') },
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-nav-scroll' },
	          _react2['default'].createElement(
	            'div',
	            { className: navClasses, ref: this.saveRef('nav') },
	            content
	          )
	        )
	      )
	    );
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 2603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _InkTabBarMixin = __webpack_require__(1181);
	
	var _InkTabBarMixin2 = _interopRequireDefault(_InkTabBarMixin);
	
	var _SwipeableTabBarMixin = __webpack_require__(2604);
	
	var _SwipeableTabBarMixin2 = _interopRequireDefault(_SwipeableTabBarMixin);
	
	var _TabBarMixin = __webpack_require__(479);
	
	var _TabBarMixin2 = _interopRequireDefault(_TabBarMixin);
	
	var _RefMixin = __webpack_require__(478);
	
	var _RefMixin2 = _interopRequireDefault(_RefMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SwipeableInkTabBar = (0, _createReactClass2['default'])({
	  displayName: 'SwipeableInkTabBar',
	
	  mixins: [_RefMixin2['default'], _TabBarMixin2['default'], _InkTabBarMixin2['default'], _SwipeableTabBarMixin2['default']],
	
	  getSwipeableTabs: function getSwipeableTabs() {
	    var _this = this;
	
	    var props = this.props;
	    var children = props.panels;
	    var activeKey = props.activeKey;
	    var rst = [];
	    var prefixCls = props.prefixCls;
	
	    var _flexWidth = 1 / props.pageSize * 100 + '%';
	    var tabStyle = {
	      WebkitFlexBasis: _flexWidth,
	      flexBasis: _flexWidth
	    };
	
	    _react2['default'].Children.forEach(children, function (child) {
	      var _classnames;
	
	      if (!child) {
	        return;
	      }
	      var key = child.key;
	      var cls = (0, _classnames3['default'])(prefixCls + '-tab', (_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-active', activeKey === key), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-disabled', child.props.disabled), _classnames));
	      var events = {};
	      if (!child.props.disabled) {
	        events = {
	          onClick: _this.onTabClick.bind(_this, key)
	        };
	      }
	      var refProps = {};
	      if (activeKey === key) {
	        refProps.ref = _this.saveRef('activeTab');
	      }
	      rst.push(_react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          role: 'tab',
	          style: tabStyle,
	          'aria-disabled': child.props.disabled ? 'true' : 'false',
	          'aria-selected': activeKey === key ? 'true' : 'false'
	        }, events, {
	          className: cls,
	          key: key
	        }, refProps),
	        child.props.tab
	      ));
	    });
	
	    return rst;
	  },
	  render: function render() {
	    var inkBarNode = this.getInkBarNode();
	    var tabs = this.getSwipeableTabs();
	    var scrollbarNode = this.getSwipeBarNode([inkBarNode, tabs]);
	    return this.getRootNode(scrollbarNode);
	  }
	});
	
	exports['default'] = SwipeableInkTabBar;
	module.exports = exports['default'];

/***/ },
/* 2604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames3 = __webpack_require__(7);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	var _rcHammerjs = __webpack_require__(2543);
	
	var _rcHammerjs2 = _interopRequireDefault(_rcHammerjs);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  getInitialState: function getInitialState() {
	    var _checkPaginationByKey = this.checkPaginationByKey(this.props.activeKey),
	        hasPrevPage = _checkPaginationByKey.hasPrevPage,
	        hasNextPage = _checkPaginationByKey.hasNextPage;
	
	    return {
	      hasPrevPage: hasPrevPage,
	      hasNextPage: hasNextPage
	    };
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      hammerOptions: {},
	      pageSize: 5, // per page show how many tabs
	      speed: 7 // swipe speed, 1 to 10, more bigger more faster
	    };
	  },
	  checkPaginationByKey: function checkPaginationByKey(activeKey) {
	    var _props = this.props,
	        panels = _props.panels,
	        pageSize = _props.pageSize;
	
	    var index = this.getIndexByKey(activeKey);
	    var centerTabCount = Math.floor(pageSize / 2);
	    // the basic rule is to make activeTab be shown in the center of TabBar viewport
	    return {
	      hasPrevPage: index - centerTabCount > 0,
	      hasNextPage: index + centerTabCount < panels.length
	    };
	  },
	
	  /**
	   * used for props.activeKey setting, not for swipe callback
	   */
	  getDeltaByKey: function getDeltaByKey(activeKey) {
	    var pageSize = this.props.pageSize;
	
	    var index = this.getIndexByKey(activeKey);
	    var centerTabCount = Math.floor(pageSize / 2);
	    var tabWidth = this.cache.tabWidth;
	
	    var delta = (index - centerTabCount) * tabWidth * -1;
	    return delta;
	  },
	  getIndexByKey: function getIndexByKey(activeKey) {
	    var panels = this.props.panels;
	
	    var length = panels.length;
	    for (var i = 0; i < length; i++) {
	      if (panels[i].key === activeKey) {
	        return i;
	      }
	    }
	    return -1;
	  },
	  checkPaginationByDelta: function checkPaginationByDelta(delta) {
	    var totalAvaliableDelta = this.cache.totalAvaliableDelta;
	
	    return {
	      hasPrevPage: delta < 0,
	      hasNextPage: -delta < totalAvaliableDelta
	    };
	  },
	  setSwipePositionByKey: function setSwipePositionByKey(activeKey) {
	    var _checkPaginationByKey2 = this.checkPaginationByKey(activeKey),
	        hasPrevPage = _checkPaginationByKey2.hasPrevPage,
	        hasNextPage = _checkPaginationByKey2.hasNextPage;
	
	    var totalAvaliableDelta = this.cache.totalAvaliableDelta;
	
	    this.setState({
	      hasPrevPage: hasPrevPage,
	      hasNextPage: hasNextPage
	    });
	    var delta = void 0;
	    if (!hasPrevPage) {
	      // the first page
	      delta = 0;
	    } else if (!hasNextPage) {
	      // the last page
	      delta = -totalAvaliableDelta;
	    } else if (hasNextPage) {
	      // the middle page
	      delta = this.getDeltaByKey(activeKey);
	    }
	    this.cache.totalDelta = delta;
	    this.setSwipePosition();
	  },
	  setSwipePosition: function setSwipePosition() {
	    var _cache = this.cache,
	        totalDelta = _cache.totalDelta,
	        vertical = _cache.vertical;
	
	    (0, _utils.setPxStyle)(this.swipeNode, totalDelta, vertical);
	  },
	  componentDidMount: function componentDidMount() {
	    var swipe = this.swipe,
	        nav = this.nav;
	    var _props2 = this.props,
	        tabBarPosition = _props2.tabBarPosition,
	        pageSize = _props2.pageSize,
	        panels = _props2.panels,
	        activeKey = _props2.activeKey;
	
	    this.swipeNode = _reactDom2['default'].findDOMNode(swipe); // dom which scroll (9999px)
	    this.realNode = _reactDom2['default'].findDOMNode(nav); // dom which visiable in screen (viewport)
	    var _isVertical = (0, _utils.isVertical)(tabBarPosition);
	    var _viewSize = (0, _utils.getStyle)(this.realNode, _isVertical ? 'height' : 'width');
	    var _tabWidth = _viewSize / pageSize;
	    this.cache = {
	      vertical: _isVertical,
	      totalAvaliableDelta: _tabWidth * panels.length - _viewSize,
	      tabWidth: _tabWidth
	    };
	    this.setSwipePositionByKey(activeKey);
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (nextProps.activeKey && nextProps.activeKey !== this.props.activeKey) {
	      this.setSwipePositionByKey(nextProps.activeKey);
	    }
	  },
	  onPan: function onPan(e) {
	    var _cache2 = this.cache,
	        vertical = _cache2.vertical,
	        totalAvaliableDelta = _cache2.totalAvaliableDelta,
	        totalDelta = _cache2.totalDelta;
	    var speed = this.props.speed;
	    // calculate touch distance
	
	    var nowDelta = vertical ? e.deltaY : e.deltaX;
	    nowDelta = nowDelta * (speed / 10);
	
	    // calculate distance dom need transform
	    var _nextDelta = nowDelta + totalDelta;
	    if (_nextDelta >= 0) {
	      _nextDelta = 0;
	    } else if (_nextDelta <= -totalAvaliableDelta) {
	      _nextDelta = -totalAvaliableDelta;
	    }
	
	    this.cache.totalDelta = _nextDelta;
	    this.setSwipePosition();
	
	    // calculate pagination display
	
	    var _checkPaginationByDel = this.checkPaginationByDelta(this.cache.totalDelta),
	        hasPrevPage = _checkPaginationByDel.hasPrevPage,
	        hasNextPage = _checkPaginationByDel.hasNextPage;
	
	    if (hasPrevPage !== this.state.hasPrevPage || hasNextPage !== this.state.hasNextPage) {
	      this.setState({
	        hasPrevPage: hasPrevPage,
	        hasNextPage: hasNextPage
	      });
	    }
	  },
	  getSwipeBarNode: function getSwipeBarNode(tabs) {
	    var _classnames2;
	
	    var _props3 = this.props,
	        prefixCls = _props3.prefixCls,
	        hammerOptions = _props3.hammerOptions,
	        tabBarPosition = _props3.tabBarPosition;
	    var _state = this.state,
	        hasPrevPage = _state.hasPrevPage,
	        hasNextPage = _state.hasNextPage;
	
	    var navClassName = prefixCls + '-nav';
	    var navClasses = (0, _classnames4['default'])((0, _defineProperty3['default'])({}, navClassName, true));
	    var events = {
	      onPan: this.onPan
	    };
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: (0, _classnames4['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nav-swipe-container', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-prevpage', hasPrevPage), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-nextpage', hasNextPage), _classnames2)),
	        key: 'container',
	        ref: this.saveRef('container')
	      },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-nav-wrap', ref: this.saveRef('navWrap') },
	        _react2['default'].createElement(
	          _rcHammerjs2['default'],
	          (0, _extends3['default'])({}, events, {
	            direction: (0, _utils.isVertical)(tabBarPosition) ? 'DIRECTION_ALL' : 'DIRECTION_HORIZONTAL',
	            options: hammerOptions
	          }),
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-nav-swipe', ref: this.saveRef('swipe') },
	            _react2['default'].createElement(
	              'div',
	              { className: navClasses, ref: this.saveRef('nav') },
	              tabs
	            )
	          )
	        )
	      )
	    );
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 2605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _TabBarMixin = __webpack_require__(479);
	
	var _TabBarMixin2 = _interopRequireDefault(_TabBarMixin);
	
	var _RefMixin = __webpack_require__(478);
	
	var _RefMixin2 = _interopRequireDefault(_RefMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabBar = (0, _createReactClass2['default'])({
	  displayName: 'TabBar',
	  mixins: [_RefMixin2['default'], _TabBarMixin2['default']],
	  render: function render() {
	    var tabs = this.getTabs();
	    return this.getRootNode(tabs);
	  }
	});
	
	exports['default'] = TabBar;
	module.exports = exports['default'];

/***/ },
/* 2606 */
[3340, 2600, 1182, 156],
/* 2607 */
[3470, 1183, 2609, 2610],
/* 2608 */
991,
/* 2609 */
[3496, 1183],
/* 2610 */
2411,
/* 2611 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(1185),
	    now = __webpack_require__(2614),
	    toNumber = __webpack_require__(2615);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 2612 */
112,
/* 2613 */
[3536, 2607, 2612],
/* 2614 */
[3541, 1184],
/* 2615 */
[3543, 1185, 2613],
/* 2616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Select = __webpack_require__(2618);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var formatOption = function formatOption(option, disabledOptions) {
	  var value = '' + option;
	  if (option < 10) {
	    value = '0' + option;
	  }
	
	  var disabled = false;
	  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
	    disabled = true;
	  }
	
	  return {
	    value: value,
	    disabled: disabled
	  };
	};
	
	var Combobox = function (_Component) {
	  (0, _inherits3['default'])(Combobox, _Component);
	
	  function Combobox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Combobox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Combobox.__proto__ || Object.getPrototypeOf(Combobox)).call.apply(_ref, [this].concat(args))), _this), _this.onItemChange = function (type, itemValue) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          defaultOpenValue = _this$props.defaultOpenValue,
	          use12Hours = _this$props.use12Hours;
	
	      var value = (_this.props.value || defaultOpenValue).clone();
	
	      if (type === 'hour') {
	        if (use12Hours) {
	          if (_this.isAM()) {
	            value.hour(+itemValue % 12);
	          } else {
	            value.hour(+itemValue % 12 + 12);
	          }
	        } else {
	          value.hour(+itemValue);
	        }
	      } else if (type === 'minute') {
	        value.minute(+itemValue);
	      } else if (type === 'ampm') {
	        var ampm = itemValue.toUpperCase();
	        if (use12Hours) {
	          if (ampm === 'PM' && value.hour() < 12) {
	            value.hour(value.hour() % 12 + 12);
	          }
	
	          if (ampm === 'AM') {
	            if (value.hour() >= 12) {
	              value.hour(value.hour() - 12);
	            }
	          }
	        }
	      } else {
	        value.second(+itemValue);
	      }
	      onChange(value);
	    }, _this.onEnterSelectPanel = function (range) {
	      _this.props.onCurrentSelectPanelChange(range);
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Combobox, [{
	    key: 'getHourSelect',
	    value: function getHourSelect(hour) {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          hourOptions = _props.hourOptions,
	          disabledHours = _props.disabledHours,
	          showHour = _props.showHour,
	          use12Hours = _props.use12Hours;
	
	      if (!showHour) {
	        return null;
	      }
	      var disabledOptions = disabledHours();
	      var hourOptionsAdj = void 0;
	      var hourAdj = void 0;
	      if (use12Hours) {
	        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
	          return h < 12 && h > 0;
	        }));
	        hourAdj = hour % 12 || 12;
	      } else {
	        hourOptionsAdj = hourOptions;
	        hourAdj = hour;
	      }
	
	      return _react2['default'].createElement(_Select2['default'], {
	        prefixCls: prefixCls,
	        options: hourOptionsAdj.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
	        type: 'hour',
	        onSelect: this.onItemChange,
	        onMouseEnter: this.onEnterSelectPanel.bind(this, 'hour')
	      });
	    }
	  }, {
	    key: 'getMinuteSelect',
	    value: function getMinuteSelect(minute) {
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          minuteOptions = _props2.minuteOptions,
	          disabledMinutes = _props2.disabledMinutes,
	          defaultOpenValue = _props2.defaultOpenValue,
	          showMinute = _props2.showMinute;
	
	      if (!showMinute) {
	        return null;
	      }
	      var value = this.props.value || defaultOpenValue;
	      var disabledOptions = disabledMinutes(value.hour());
	
	      return _react2['default'].createElement(_Select2['default'], {
	        prefixCls: prefixCls,
	        options: minuteOptions.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: minuteOptions.indexOf(minute),
	        type: 'minute',
	        onSelect: this.onItemChange,
	        onMouseEnter: this.onEnterSelectPanel.bind(this, 'minute')
	      });
	    }
	  }, {
	    key: 'getSecondSelect',
	    value: function getSecondSelect(second) {
	      var _props3 = this.props,
	          prefixCls = _props3.prefixCls,
	          secondOptions = _props3.secondOptions,
	          disabledSeconds = _props3.disabledSeconds,
	          showSecond = _props3.showSecond,
	          defaultOpenValue = _props3.defaultOpenValue;
	
	      if (!showSecond) {
	        return null;
	      }
	      var value = this.props.value || defaultOpenValue;
	      var disabledOptions = disabledSeconds(value.hour(), value.minute());
	
	      return _react2['default'].createElement(_Select2['default'], {
	        prefixCls: prefixCls,
	        options: secondOptions.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: secondOptions.indexOf(second),
	        type: 'second',
	        onSelect: this.onItemChange,
	        onMouseEnter: this.onEnterSelectPanel.bind(this, 'second')
	      });
	    }
	  }, {
	    key: 'getAMPMSelect',
	    value: function getAMPMSelect() {
	      var _props4 = this.props,
	          prefixCls = _props4.prefixCls,
	          use12Hours = _props4.use12Hours,
	          format = _props4.format;
	
	      if (!use12Hours) {
	        return null;
	      }
	
	      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
	      .map(function (c) {
	        return format.match(/\sA/) ? c.toUpperCase() : c;
	      }).map(function (c) {
	        return { value: c };
	      });
	
	      var selected = this.isAM() ? 0 : 1;
	
	      return _react2['default'].createElement(_Select2['default'], {
	        prefixCls: prefixCls,
	        options: AMPMOptions,
	        selectedIndex: selected,
	        type: 'ampm',
	        onSelect: this.onItemChange,
	        onMouseEnter: this.onEnterSelectPanel.bind(this, 'ampm')
	      });
	    }
	  }, {
	    key: 'isAM',
	    value: function isAM() {
	      var value = this.props.value || this.props.defaultOpenValue;
	      return value.hour() >= 0 && value.hour() < 12;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          prefixCls = _props5.prefixCls,
	          defaultOpenValue = _props5.defaultOpenValue;
	
	      var value = this.props.value || defaultOpenValue;
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-combobox' },
	        this.getHourSelect(value.hour()),
	        this.getMinuteSelect(value.minute()),
	        this.getSecondSelect(value.second()),
	        this.getAMPMSelect(value.hour())
	      );
	    }
	  }]);
	  return Combobox;
	}(_react.Component);
	
	Combobox.propTypes = {
	  format: _propTypes2['default'].string,
	  defaultOpenValue: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  onChange: _propTypes2['default'].func,
	  showHour: _propTypes2['default'].bool,
	  showMinute: _propTypes2['default'].bool,
	  showSecond: _propTypes2['default'].bool,
	  hourOptions: _propTypes2['default'].array,
	  minuteOptions: _propTypes2['default'].array,
	  secondOptions: _propTypes2['default'].array,
	  disabledHours: _propTypes2['default'].func,
	  disabledMinutes: _propTypes2['default'].func,
	  disabledSeconds: _propTypes2['default'].func,
	  onCurrentSelectPanelChange: _propTypes2['default'].func,
	  use12Hours: _propTypes2['default'].bool
	};
	exports['default'] = Combobox;
	module.exports = exports['default'];

/***/ },
/* 2617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Header = function (_Component) {
	  (0, _inherits3['default'])(Header, _Component);
	
	  function Header(props) {
	    (0, _classCallCheck3['default'])(this, Header);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = props.value,
	        format = props.format;
	
	    _this.state = {
	      str: value && value.format(format) || '',
	      invalid: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.focusOnOpen) {
	        // Wait one frame for the panel to be positioned before focusing
	        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
	        requestAnimationFrame(function () {
	          _this2.refs.input.focus();
	          _this2.refs.input.select();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value,
	          format = nextProps.format;
	
	      this.setState({
	        str: value && value.format(format) || '',
	        invalid: false
	      });
	    }
	  }, {
	    key: 'getClearButton',
	    value: function getClearButton() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          allowEmpty = _props.allowEmpty;
	
	      if (!allowEmpty) {
	        return null;
	      }
	      return _react2['default'].createElement('a', {
	        className: prefixCls + '-clear-btn',
	        role: 'button',
	        title: this.props.clearText,
	        onMouseDown: this.onClear
	      });
	    }
	  }, {
	    key: 'getProtoValue',
	    value: function getProtoValue() {
	      return this.props.value || this.props.defaultOpenValue;
	    }
	  }, {
	    key: 'getInput',
	    value: function getInput() {
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          placeholder = _props2.placeholder;
	      var _state = this.state,
	          invalid = _state.invalid,
	          str = _state.str;
	
	      var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
	      return _react2['default'].createElement('input', {
	        className: prefixCls + '-input  ' + invalidClass,
	        ref: 'input',
	        onKeyDown: this.onKeyDown,
	        value: str,
	        placeholder: placeholder,
	        onChange: this.onInputChange
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prefixCls = this.props.prefixCls;
	
	      return _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-input-wrap' },
	        this.getInput(),
	        this.getClearButton()
	      );
	    }
	  }]);
	  return Header;
	}(_react.Component);
	
	Header.propTypes = {
	  format: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  disabledDate: _propTypes2['default'].func,
	  placeholder: _propTypes2['default'].string,
	  clearText: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  hourOptions: _propTypes2['default'].array,
	  minuteOptions: _propTypes2['default'].array,
	  secondOptions: _propTypes2['default'].array,
	  disabledHours: _propTypes2['default'].func,
	  disabledMinutes: _propTypes2['default'].func,
	  disabledSeconds: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onClear: _propTypes2['default'].func,
	  onEsc: _propTypes2['default'].func,
	  allowEmpty: _propTypes2['default'].bool,
	  defaultOpenValue: _propTypes2['default'].object,
	  currentSelectPanel: _propTypes2['default'].string,
	  focusOnOpen: _propTypes2['default'].bool,
	  onKeyDown: _propTypes2['default'].func
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onInputChange = function (event) {
	    var str = event.target.value;
	    _this3.setState({
	      str: str
	    });
	    var _props3 = _this3.props,
	        format = _props3.format,
	        hourOptions = _props3.hourOptions,
	        minuteOptions = _props3.minuteOptions,
	        secondOptions = _props3.secondOptions,
	        disabledHours = _props3.disabledHours,
	        disabledMinutes = _props3.disabledMinutes,
	        disabledSeconds = _props3.disabledSeconds,
	        onChange = _props3.onChange,
	        allowEmpty = _props3.allowEmpty;
	
	
	    if (str) {
	      var originalValue = _this3.props.value;
	      var value = _this3.getProtoValue().clone();
	      var parsed = (0, _moment2['default'])(str, format, true);
	      if (!parsed.isValid()) {
	        _this3.setState({
	          invalid: true
	        });
	        return;
	      }
	      value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());
	
	      // if time value not allowed, response warning.
	      if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
	        _this3.setState({
	          invalid: true
	        });
	        return;
	      }
	
	      // if time value is disabled, response warning.
	      var disabledHourOptions = disabledHours();
	      var disabledMinuteOptions = disabledMinutes(value.hour());
	      var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());
	      if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
	        _this3.setState({
	          invalid: true
	        });
	        return;
	      }
	
	      if (originalValue) {
	        if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
	          // keep other fields for rc-calendar
	          var changedValue = originalValue.clone();
	          changedValue.hour(value.hour());
	          changedValue.minute(value.minute());
	          changedValue.second(value.second());
	          onChange(changedValue);
	        }
	      } else if (originalValue !== value) {
	        onChange(value);
	      }
	    } else if (allowEmpty) {
	      onChange(null);
	    } else {
	      _this3.setState({
	        invalid: true
	      });
	      return;
	    }
	
	    _this3.setState({
	      invalid: false
	    });
	  };
	
	  this.onKeyDown = function (e) {
	    var _props4 = _this3.props,
	        onEsc = _props4.onEsc,
	        onKeyDown = _props4.onKeyDown;
	
	    if (e.keyCode === 27) {
	      onEsc();
	    }
	
	    onKeyDown(e);
	  };
	
	  this.onClear = function () {
	    _this3.setState({ str: '' });
	    _this3.props.onClear();
	  };
	};
	
	exports['default'] = Header;
	module.exports = exports['default'];

/***/ },
/* 2618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames3 = __webpack_require__(7);
	
	var _classnames4 = _interopRequireDefault(_classnames3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var scrollTo = function scrollTo(element, to, duration) {
	  var requestAnimationFrame = window.requestAnimationFrame || function requestAnimationFrameTimeout() {
	    return setTimeout(arguments[0], 10);
	  };
	  // jump to target if duration zero
	  if (duration <= 0) {
	    element.scrollTop = to;
	    return;
	  }
	  var difference = to - element.scrollTop;
	  var perTick = difference / duration * 10;
	
	  requestAnimationFrame(function () {
	    element.scrollTop = element.scrollTop + perTick;
	    if (element.scrollTop === to) return;
	    scrollTo(element, to, duration - 10);
	  });
	};
	
	var Select = function (_Component) {
	  (0, _inherits3['default'])(Select, _Component);
	
	  function Select() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Select);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Select.__proto__ || Object.getPrototypeOf(Select)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false
	    }, _this.onSelect = function (value) {
	      var _this$props = _this.props,
	          onSelect = _this$props.onSelect,
	          type = _this$props.type;
	
	      onSelect(type, value);
	    }, _this.handleMouseEnter = function (e) {
	      _this.setState({ active: true });
	      _this.props.onMouseEnter(e);
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ active: false });
	    }, _this.saveList = function (node) {
	      _this.list = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Select, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // jump to selected option
	      this.scrollToSelected(0);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      // smooth scroll to selected option
	      if (prevProps.selectedIndex !== this.props.selectedIndex) {
	        this.scrollToSelected(120);
	      }
	    }
	  }, {
	    key: 'getOptions',
	    value: function getOptions() {
	      var _this2 = this;
	
	      var _props = this.props,
	          options = _props.options,
	          selectedIndex = _props.selectedIndex,
	          prefixCls = _props.prefixCls;
	
	      return options.map(function (item, index) {
	        var _classnames;
	
	        var cls = (0, _classnames4['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-select-option-selected', selectedIndex === index), (0, _defineProperty3['default'])(_classnames, prefixCls + '-select-option-disabled', item.disabled), _classnames));
	        var onclick = null;
	        if (!item.disabled) {
	          onclick = _this2.onSelect.bind(_this2, item.value);
	        }
	        return _react2['default'].createElement(
	          'li',
	          {
	            className: cls,
	            key: index,
	            onClick: onclick,
	            disabled: item.disabled
	          },
	          item.value
	        );
	      });
	    }
	  }, {
	    key: 'scrollToSelected',
	    value: function scrollToSelected(duration) {
	      // move to selected item
	      var select = _reactDom2['default'].findDOMNode(this);
	      var list = _reactDom2['default'].findDOMNode(this.list);
	      if (!list) {
	        return;
	      }
	      var index = this.props.selectedIndex;
	      if (index < 0) {
	        index = 0;
	      }
	      var topOption = list.children[index];
	      var to = topOption.offsetTop;
	      scrollTo(select, to, duration);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames2;
	
	      if (this.props.options.length === 0) {
	        return null;
	      }
	
	      var prefixCls = this.props.prefixCls;
	
	      var cls = (0, _classnames4['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-select', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-select-active', this.state.active), _classnames2));
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: cls,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave
	        },
	        _react2['default'].createElement(
	          'ul',
	          { ref: this.saveList },
	          this.getOptions()
	        )
	      );
	    }
	  }]);
	  return Select;
	}(_react.Component);
	
	Select.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  options: _propTypes2['default'].array,
	  selectedIndex: _propTypes2['default'].number,
	  type: _propTypes2['default'].string,
	  onSelect: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func
	};
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 2619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _Panel = __webpack_require__(1186);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _placements = __webpack_require__(2620);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function refFn(field, component) {
	  this[field] = component;
	}
	
	var Picker = function (_Component) {
	  (0, _inherits3['default'])(Picker, _Component);
	
	  function Picker(props) {
	    (0, _classCallCheck3['default'])(this, Picker);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Picker.__proto__ || Object.getPrototypeOf(Picker)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.saveInputRef = refFn.bind(_this, 'picker');
	    _this.savePanelRef = refFn.bind(_this, 'panelInstance');
	    var defaultOpen = props.defaultOpen,
	        defaultValue = props.defaultValue,
	        _props$open = props.open,
	        open = _props$open === undefined ? defaultOpen : _props$open,
	        _props$value = props.value,
	        value = _props$value === undefined ? defaultValue : _props$value;
	
	    _this.state = {
	      open: open,
	      value: value
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Picker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var value = nextProps.value,
	          open = nextProps.open;
	
	      if ('value' in nextProps) {
	        this.setState({
	          value: value
	        });
	      }
	      if (open !== undefined) {
	        this.setState({ open: open });
	      }
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        });
	      }
	      this.props.onChange(value);
	    }
	  }, {
	    key: 'getFormat',
	    value: function getFormat() {
	      var _props = this.props,
	          format = _props.format,
	          showHour = _props.showHour,
	          showMinute = _props.showMinute,
	          showSecond = _props.showSecond,
	          use12Hours = _props.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
	          return !!item;
	        }).join(':');
	
	        return fmtString.concat(' a');
	      }
	
	      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
	        return !!item;
	      }).join(':');
	    }
	  }, {
	    key: 'getPanelElement',
	    value: function getPanelElement() {
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          placeholder = _props2.placeholder,
	          disabledHours = _props2.disabledHours,
	          disabledMinutes = _props2.disabledMinutes,
	          disabledSeconds = _props2.disabledSeconds,
	          hideDisabledOptions = _props2.hideDisabledOptions,
	          allowEmpty = _props2.allowEmpty,
	          showHour = _props2.showHour,
	          showMinute = _props2.showMinute,
	          showSecond = _props2.showSecond,
	          defaultOpenValue = _props2.defaultOpenValue,
	          clearText = _props2.clearText,
	          addon = _props2.addon,
	          use12Hours = _props2.use12Hours,
	          focusOnOpen = _props2.focusOnOpen,
	          onKeyDown = _props2.onKeyDown,
	          hourStep = _props2.hourStep,
	          minuteStep = _props2.minuteStep,
	          secondStep = _props2.secondStep;
	
	      return _react2['default'].createElement(_Panel2['default'], {
	        clearText: clearText,
	        prefixCls: prefixCls + '-panel',
	        ref: this.savePanelRef,
	        value: this.state.value,
	        onChange: this.onPanelChange,
	        onClear: this.onPanelClear,
	        defaultOpenValue: defaultOpenValue,
	        showHour: showHour,
	        showMinute: showMinute,
	        showSecond: showSecond,
	        onEsc: this.onEsc,
	        allowEmpty: allowEmpty,
	        format: this.getFormat(),
	        placeholder: placeholder,
	        disabledHours: disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        hideDisabledOptions: hideDisabledOptions,
	        use12Hours: use12Hours,
	        hourStep: hourStep,
	        minuteStep: minuteStep,
	        secondStep: secondStep,
	        addon: addon,
	        focusOnOpen: focusOnOpen,
	        onKeyDown: onKeyDown
	      });
	    }
	  }, {
	    key: 'getPopupClassName',
	    value: function getPopupClassName() {
	      var _props3 = this.props,
	          showHour = _props3.showHour,
	          showMinute = _props3.showMinute,
	          showSecond = _props3.showSecond,
	          use12Hours = _props3.use12Hours,
	          prefixCls = _props3.prefixCls;
	
	      var popupClassName = this.props.popupClassName;
	      // Keep it for old compatibility
	      if ((!showHour || !showMinute || !showSecond) && !use12Hours) {
	        popupClassName += ' ' + prefixCls + '-panel-narrow';
	      }
	      var selectColumnCount = 0;
	      if (showHour) {
	        selectColumnCount += 1;
	      }
	      if (showMinute) {
	        selectColumnCount += 1;
	      }
	      if (showSecond) {
	        selectColumnCount += 1;
	      }
	      if (use12Hours) {
	        selectColumnCount += 1;
	      }
	      popupClassName += ' ' + prefixCls + '-panel-column-' + selectColumnCount;
	      return popupClassName;
	    }
	  }, {
	    key: 'setOpen',
	    value: function setOpen(open) {
	      var _props4 = this.props,
	          onOpen = _props4.onOpen,
	          onClose = _props4.onClose;
	
	      if (this.state.open !== open) {
	        if (!('open' in this.props)) {
	          this.setState({ open: open });
	        }
	        if (open) {
	          onOpen({ open: open });
	        } else {
	          onClose({ open: open });
	        }
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          prefixCls = _props5.prefixCls,
	          placeholder = _props5.placeholder,
	          placement = _props5.placement,
	          align = _props5.align,
	          disabled = _props5.disabled,
	          transitionName = _props5.transitionName,
	          style = _props5.style,
	          className = _props5.className,
	          getPopupContainer = _props5.getPopupContainer,
	          name = _props5.name,
	          autoComplete = _props5.autoComplete,
	          onFocus = _props5.onFocus,
	          onBlur = _props5.onBlur,
	          autoFocus = _props5.autoFocus;
	      var _state = this.state,
	          open = _state.open,
	          value = _state.value;
	
	      var popupClassName = this.getPopupClassName();
	      return _react2['default'].createElement(
	        _rcTrigger2['default'],
	        {
	          prefixCls: prefixCls + '-panel',
	          popupClassName: popupClassName,
	          popup: this.getPanelElement(),
	          popupAlign: align,
	          builtinPlacements: _placements2['default'],
	          popupPlacement: placement,
	          action: disabled ? [] : ['click'],
	          destroyPopupOnHide: true,
	          getPopupContainer: getPopupContainer,
	          popupTransitionName: transitionName,
	          popupVisible: open,
	          onPopupVisibleChange: this.onVisibleChange
	        },
	        _react2['default'].createElement(
	          'span',
	          { className: prefixCls + ' ' + className, style: style },
	          _react2['default'].createElement('input', {
	            className: prefixCls + '-input',
	            ref: this.saveInputRef,
	            type: 'text',
	            placeholder: placeholder,
	            name: name,
	            onKeyDown: this.onKeyDown,
	            disabled: disabled,
	            value: value && value.format(this.getFormat()) || '',
	            autoComplete: autoComplete,
	            onFocus: onFocus,
	            onBlur: onBlur,
	            autoFocus: autoFocus,
	            onChange: noop
	          }),
	          _react2['default'].createElement('span', { className: prefixCls + '-icon' })
	        )
	      );
	    }
	  }]);
	  return Picker;
	}(_react.Component);
	
	Picker.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  clearText: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  defaultOpenValue: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  allowEmpty: _propTypes2['default'].bool,
	  defaultValue: _propTypes2['default'].object,
	  open: _propTypes2['default'].bool,
	  defaultOpen: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  placement: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].string,
	  getPopupContainer: _propTypes2['default'].func,
	  placeholder: _propTypes2['default'].string,
	  format: _propTypes2['default'].string,
	  showHour: _propTypes2['default'].bool,
	  showMinute: _propTypes2['default'].bool,
	  showSecond: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  disabledHours: _propTypes2['default'].func,
	  disabledMinutes: _propTypes2['default'].func,
	  disabledSeconds: _propTypes2['default'].func,
	  hideDisabledOptions: _propTypes2['default'].bool,
	  onChange: _propTypes2['default'].func,
	  onOpen: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  addon: _propTypes2['default'].func,
	  name: _propTypes2['default'].string,
	  autoComplete: _propTypes2['default'].string,
	  use12Hours: _propTypes2['default'].bool,
	  hourStep: _propTypes2['default'].number,
	  minuteStep: _propTypes2['default'].number,
	  secondStep: _propTypes2['default'].number,
	  focusOnOpen: _propTypes2['default'].bool,
	  onKeyDown: _propTypes2['default'].func,
	  autoFocus: _propTypes2['default'].bool
	};
	Picker.defaultProps = {
	  clearText: 'clear',
	  prefixCls: 'rc-time-picker',
	  defaultOpen: false,
	  style: {},
	  className: '',
	  popupClassName: '',
	  align: {},
	  defaultOpenValue: (0, _moment2['default'])(),
	  allowEmpty: true,
	  showHour: true,
	  showMinute: true,
	  showSecond: true,
	  disabledHours: noop,
	  disabledMinutes: noop,
	  disabledSeconds: noop,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  onChange: noop,
	  onOpen: noop,
	  onClose: noop,
	  onFocus: noop,
	  onBlur: noop,
	  addon: noop,
	  use12Hours: false,
	  focusOnOpen: false,
	  onKeyDown: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onPanelChange = function (value) {
	    _this2.setValue(value);
	  };
	
	  this.onPanelClear = function () {
	    _this2.setValue(null);
	    _this2.setOpen(false);
	  };
	
	  this.onVisibleChange = function (open) {
	    _this2.setOpen(open);
	  };
	
	  this.onEsc = function () {
	    _this2.setOpen(false);
	    _this2.focus();
	  };
	
	  this.onKeyDown = function (e) {
	    if (e.keyCode === 40) {
	      _this2.setOpen(true);
	    }
	  };
	};
	
	exports['default'] = Picker;
	module.exports = exports['default'];

/***/ },
/* 2620 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = {
	  bottomLeft: {
	    points: ['tl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;
	module.exports = exports['default'];

/***/ },
/* 2621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(1188);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-inner', key: 'content', id: id },
	        typeof overlay === 'function' ? overlay() : overlay
	      )];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 2622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SelectPropTypes = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _strategies = __webpack_require__(481);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function nonEmptyStringType(props, propsName) {
	  var value = props[propsName];
	  if (typeof value !== 'string' || !value) {
	    return new Error(); // Just a flag, so don't need message.
	  }
	}
	
	function valueType(props, propName, componentName) {
	  var labelInValueShape = _propTypes2['default'].shape({
	    value: nonEmptyStringType,
	    label: _propTypes2['default'].node
	  });
	  if (props.labelInValue) {
	    var validate = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(labelInValueShape), labelInValueShape]);
	    var error = validate.apply(undefined, arguments);
	    if (error) {
	      return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + ('when `labelInValue` is `true`, `' + propName + '` should in ') + 'shape of `{ value: string, label?: string }`.');
	    }
	  } else if (props.treeCheckable && props.treeCheckStrictly) {
	    var _validate = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(labelInValueShape), labelInValueShape]);
	    var _error = _validate.apply(undefined, arguments);
	    if (_error) {
	      return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`, ' + 'when `treeCheckable` and `treeCheckStrictly` are `true`, ' + ('`' + propName + '` should in shape of `{ value: string, label?: string }`.'));
	    }
	  } else if (props.multiple && props[propName] === '') {
	    return new Error('Invalid prop `' + propName + '` of type `string` supplied to `' + componentName + '`, ' + 'expected `array` when `multiple` is `true`.');
	  } else {
	    var _validate2 = _propTypes2['default'].oneOfType([_propTypes2['default'].arrayOf(_propTypes2['default'].string), _propTypes2['default'].string]);
	    return _validate2.apply(undefined, arguments);
	  }
	}
	
	var SelectPropTypes = exports.SelectPropTypes = {
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  filterTreeNode: _propTypes2['default'].any,
	  showSearch: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  showArrow: _propTypes2['default'].bool,
	  allowClear: _propTypes2['default'].bool,
	  defaultOpen: _propTypes2['default'].bool,
	  open: _propTypes2['default'].bool,
	  transitionName: _propTypes2['default'].string,
	  animation: _propTypes2['default'].string,
	  choiceTransitionName: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  onDeselect: _propTypes2['default'].func,
	  onSearch: _propTypes2['default'].func,
	  searchPlaceholder: _propTypes2['default'].string,
	  placeholder: _propTypes2['default'].any,
	  inputValue: _propTypes2['default'].any,
	  value: valueType,
	  defaultValue: valueType,
	  label: _propTypes2['default'].node,
	  defaultLabel: _propTypes2['default'].any,
	  labelInValue: _propTypes2['default'].bool,
	  dropdownStyle: _propTypes2['default'].object,
	  drodownPopupAlign: _propTypes2['default'].object,
	  onDropdownVisibleChange: _propTypes2['default'].func,
	  maxTagTextLength: _propTypes2['default'].number,
	  showCheckedStrategy: _propTypes2['default'].oneOf([_strategies.SHOW_ALL, _strategies.SHOW_PARENT, _strategies.SHOW_CHILD]),
	  treeCheckStrictly: _propTypes2['default'].bool,
	  treeIcon: _propTypes2['default'].bool,
	  treeLine: _propTypes2['default'].bool,
	  treeDefaultExpandAll: _propTypes2['default'].bool,
	  treeCheckable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node]),
	  treeNodeLabelProp: _propTypes2['default'].string,
	  treeNodeFilterProp: _propTypes2['default'].string,
	  treeData: _propTypes2['default'].array,
	  treeDataSimpleMode: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	  loadData: _propTypes2['default'].func
	};

/***/ },
/* 2623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _KeyCode = __webpack_require__(72);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _util = __webpack_require__(1190);
	
	var _SelectTrigger = __webpack_require__(2624);
	
	var _SelectTrigger2 = _interopRequireDefault(_SelectTrigger);
	
	var _TreeNode2 = __webpack_require__(1189);
	
	var _TreeNode3 = _interopRequireDefault(_TreeNode2);
	
	var _strategies = __webpack_require__(481);
	
	var _PropTypes = __webpack_require__(2622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function filterFn(input, child) {
	  return String((0, _util.getPropValue)(child, (0, _util.labelCompatible)(this.props.treeNodeFilterProp))).indexOf(input) > -1;
	}
	
	function loopTreeData(data) {
	  var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var treeCheckable = arguments[2];
	
	  return data.map(function (item, index) {
	    var pos = level + '-' + index;
	    var label = item.label,
	        value = item.value,
	        disabled = item.disabled,
	        key = item.key,
	        hasOwnProperty = item.hasOwnProperty,
	        selectable = item.selectable,
	        children = item.children,
	        isLeaf = item.isLeaf,
	        otherProps = (0, _objectWithoutProperties3['default'])(item, ['label', 'value', 'disabled', 'key', 'hasOwnProperty', 'selectable', 'children', 'isLeaf']);
	
	    var props = (0, _extends3['default'])({
	      value: value,
	      title: label,
	      // value: value || String(key || label), // cause onChange callback error
	      key: key || value || pos,
	      disabled: disabled || false,
	      selectable: selectable === false ? selectable : !treeCheckable
	    }, otherProps);
	    var ret = void 0;
	    if (children && children.length) {
	      ret = _react2['default'].createElement(
	        _TreeNode3['default'],
	        props,
	        loopTreeData(children, pos, treeCheckable)
	      );
	    } else {
	      ret = _react2['default'].createElement(_TreeNode3['default'], (0, _extends3['default'])({}, props, { isLeaf: isLeaf }));
	    }
	    return ret;
	  });
	}
	
	var Select = function (_Component) {
	  (0, _inherits3['default'])(Select, _Component);
	
	  function Select(props) {
	    (0, _classCallCheck3['default'])(this, Select);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = [];
	    if ('value' in props) {
	      value = (0, _util.toArray)(props.value);
	    } else {
	      value = (0, _util.toArray)(props.defaultValue);
	    }
	    // save parsed treeData, for performance (treeData may be very big)
	    _this.renderedTreeData = _this.renderTreeData();
	    value = _this.addLabelToValue(props, value);
	    value = _this.getValue(props, value, props.inputValue ? '__strict' : true);
	    var inputValue = props.inputValue || '';
	    // if (props.combobox) {
	    //   inputValue = value.length ? String(value[0].value) : '';
	    // }
	    _this.state = {
	      value: value,
	      inputValue: inputValue,
	      open: props.open || props.defaultOpen,
	      focused: false
	    };
	    return _this;
	  }
	
	  Select.prototype.componentDidMount = function componentDidMount() {
	    var _props2 = this.props,
	        autoFocus = _props2.autoFocus,
	        disabled = _props2.disabled;
	
	    if ((0, _util.isMultipleOrTags)(this.props)) {
	      var inputNode = this.getInputDOMNode();
	      if (inputNode.value) {
	        inputNode.style.width = '';
	        inputNode.style.width = this.inputMirrorInstance.clientWidth + 'px';
	      } else {
	        inputNode.style.width = '';
	      }
	    }
	    if (autoFocus && !disabled) {
	      this.focus();
	    }
	  };
	
	  Select.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    // save parsed treeData, for performance (treeData may be very big)
	    this.renderedTreeData = this.renderTreeData(nextProps);
	    // Detecting whether the object of `onChange`'s argument  is old ref.
	    // Better to do a deep equal later.
	    this._cacheTreeNodesStates = this._cacheTreeNodesStates !== 'no' && this._savedValue && nextProps.value === this._savedValue;
	    if (this.props.treeData !== nextProps.treeData || this.props.children !== nextProps.children) {
	      // refresh this._treeNodesStates cache
	      this._treeNodesStates = (0, _util.getTreeNodesStates)(this.renderedTreeData || nextProps.children, this.state.value.map(function (item) {
	        return item.value;
	      }));
	    }
	    if ('value' in nextProps) {
	      var value = (0, _util.toArray)(nextProps.value);
	      value = this.addLabelToValue(nextProps, value);
	      value = this.getValue(nextProps, value);
	      this.setState({
	        value: value
	      });
	      // if (nextProps.combobox) {
	      //   this.setState({
	      //     inputValue: value.length ? String(value[0].key) : '',
	      //   });
	      // }
	    }
	    if (nextProps.inputValue !== this.props.inputValue) {
	      this.setState({
	        inputValue: nextProps.inputValue
	      });
	    }
	    if ('open' in nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  };
	
	  Select.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (this._savedValue && nextProps.value && nextProps.value !== this._savedValue && nextProps.value === this.props.value) {
	      this._cacheTreeNodesStates = false;
	      this.getValue(nextProps, this.addLabelToValue(nextProps, (0, _util.toArray)(nextProps.value)));
	    }
	  };
	
	  Select.prototype.componentDidUpdate = function componentDidUpdate() {
	    var state = this.state;
	    var props = this.props;
	    if (state.open && (0, _util.isMultipleOrTags)(props)) {
	      var inputNode = this.getInputDOMNode();
	      if (inputNode.value) {
	        inputNode.style.width = '';
	        inputNode.style.width = this.inputMirrorInstance.clientWidth + 'px';
	      } else {
	        inputNode.style.width = '';
	      }
	    }
	  };
	
	  Select.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    if (this.dropdownContainer) {
	      _reactDom2['default'].unmountComponentAtNode(this.dropdownContainer);
	      document.body.removeChild(this.dropdownContainer);
	      this.dropdownContainer = null;
	    }
	  };
	
	  // combobox ignore
	
	
	  Select.prototype.getLabelFromNode = function getLabelFromNode(child) {
	    return (0, _util.getPropValue)(child, this.props.treeNodeLabelProp);
	  };
	
	  Select.prototype.getLabelFromProps = function getLabelFromProps(props, value) {
	    var _this2 = this;
	
	    if (value === undefined) {
	      return null;
	    }
	    var label = null;
	    (0, _util.loopAllChildren)(this.renderedTreeData || props.children, function (item) {
	      if ((0, _util.getValuePropValue)(item) === value) {
	        label = _this2.getLabelFromNode(item);
	      }
	    });
	    if (label === null) {
	      return value;
	    }
	    return label;
	  };
	
	  Select.prototype.getDropdownContainer = function getDropdownContainer() {
	    if (!this.dropdownContainer) {
	      this.dropdownContainer = document.createElement('div');
	      document.body.appendChild(this.dropdownContainer);
	    }
	    return this.dropdownContainer;
	  };
	
	  Select.prototype.getSearchPlaceholderElement = function getSearchPlaceholderElement(hidden) {
	    var props = this.props;
	    var placeholder = void 0;
	    if ((0, _util.isMultipleOrTagsOrCombobox)(props)) {
	      placeholder = props.placeholder || props.searchPlaceholder;
	    } else {
	      placeholder = props.searchPlaceholder;
	    }
	    if (placeholder) {
	      return _react2['default'].createElement(
	        'span',
	        {
	          style: { display: hidden ? 'none' : 'block' },
	          onClick: this.onPlaceholderClick,
	          className: props.prefixCls + '-search__field__placeholder'
	        },
	        placeholder
	      );
	    }
	    return null;
	  };
	
	  Select.prototype.getInputElement = function getInputElement() {
	    var inputValue = this.state.inputValue;
	    var _props3 = this.props,
	        prefixCls = _props3.prefixCls,
	        disabled = _props3.disabled;
	
	    return _react2['default'].createElement(
	      'span',
	      { className: prefixCls + '-search__field__wrap' },
	      _react2['default'].createElement('input', {
	        ref: (0, _util.saveRef)(this, 'inputInstance'),
	        onChange: this.onInputChange,
	        onKeyDown: this.onInputKeyDown,
	        value: inputValue,
	        disabled: disabled,
	        className: prefixCls + '-search__field',
	        role: 'textbox'
	      }),
	      _react2['default'].createElement(
	        'span',
	        {
	          ref: (0, _util.saveRef)(this, 'inputMirrorInstance'),
	          className: prefixCls + '-search__field__mirror'
	        },
	        inputValue,
	        '\xA0'
	      ),
	      (0, _util.isMultipleOrTags)(this.props) ? null : this.getSearchPlaceholderElement(!!inputValue)
	    );
	  };
	
	  Select.prototype.getInputDOMNode = function getInputDOMNode() {
	    return this.inputInstance;
	  };
	
	  Select.prototype.getPopupDOMNode = function getPopupDOMNode() {
	    return this.trigger.getPopupDOMNode();
	  };
	
	  Select.prototype.getPopupComponentRefs = function getPopupComponentRefs() {
	    return this.trigger.getPopupEleRefs();
	  };
	
	  Select.prototype.getValue = function getValue(_props, val) {
	    var _this3 = this;
	
	    var init = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	    var value = val;
	    // if inputValue existing, tree is checkStrictly
	    var _strict = init === '__strict' || init && (this.state && this.state.inputValue || this.props.inputValue !== _props.inputValue);
	    if (_props.treeCheckable && (_props.treeCheckStrictly || _strict)) {
	      this.halfCheckedValues = [];
	      value = [];
	      val.forEach(function (i) {
	        if (!i.halfChecked) {
	          value.push(i);
	        } else {
	          _this3.halfCheckedValues.push(i);
	        }
	      });
	    }
	    // if (!(_props.treeCheckable && !_props.treeCheckStrictly)) {
	    if (!!!_props.treeCheckable || _props.treeCheckable && (_props.treeCheckStrictly || _strict)) {
	      return value;
	    }
	    var checkedTreeNodes = void 0;
	    if (this._cachetreeData && this._cacheTreeNodesStates && this._checkedNodes && this.state && !this.state.inputValue) {
	      this.checkedTreeNodes = checkedTreeNodes = this._checkedNodes;
	    } else {
	      /**
	       * Note: `this._treeNodesStates`'s treeNodesStates must correspond to nodes of the
	       * final tree (`processTreeNode` function from SelectTrigger.jsx produce the final tree).
	       *
	       * And, `this._treeNodesStates` from `onSelect` is previous value,
	       * so it perhaps only have a few nodes, but the newly filtered tree can have many nodes,
	       * thus, you cannot use previous _treeNodesStates.
	       */
	      // getTreeNodesStates is not effective.
	      this._treeNodesStates = (0, _util.getTreeNodesStates)(this.renderedTreeData || _props.children, value.map(function (item) {
	        return item.value;
	      }));
	      this.checkedTreeNodes = checkedTreeNodes = this._treeNodesStates.checkedNodes;
	    }
	    var mapLabVal = function mapLabVal(arr) {
	      return arr.map(function (itemObj) {
	        return {
	          value: (0, _util.getValuePropValue)(itemObj.node),
	          label: (0, _util.getPropValue)(itemObj.node, _props.treeNodeLabelProp)
	        };
	      });
	    };
	    var props = this.props;
	    var checkedValues = [];
	    if (props.showCheckedStrategy === _strategies.SHOW_ALL) {
	      checkedValues = mapLabVal(checkedTreeNodes);
	    } else if (props.showCheckedStrategy === _strategies.SHOW_PARENT) {
	      var posArr = (0, _util.filterParentPosition)(checkedTreeNodes.map(function (itemObj) {
	        return itemObj.pos;
	      }));
	      checkedValues = mapLabVal(checkedTreeNodes.filter(function (itemObj) {
	        return posArr.indexOf(itemObj.pos) !== -1;
	      }));
	    } else {
	      checkedValues = mapLabVal(checkedTreeNodes.filter(function (itemObj) {
	        return !itemObj.node.props.children;
	      }));
	    }
	    return checkedValues;
	  };
	
	  Select.prototype.getCheckedNodes = function getCheckedNodes(info, props) {
	    // TODO treeCheckable does not support tags/dynamic
	    var checkedNodes = info.checkedNodes;
	    // if inputValue existing, tree is checkStrictly
	
	    if (props.treeCheckStrictly || this.state.inputValue) {
	      return checkedNodes;
	    }
	    var checkedNodesPositions = info.checkedNodesPositions;
	    if (props.showCheckedStrategy === _strategies.SHOW_ALL) {
	      checkedNodes = checkedNodes;
	    } else if (props.showCheckedStrategy === _strategies.SHOW_PARENT) {
	      var posArr = (0, _util.filterParentPosition)(checkedNodesPositions.map(function (itemObj) {
	        return itemObj.pos;
	      }));
	      checkedNodes = checkedNodesPositions.filter(function (itemObj) {
	        return posArr.indexOf(itemObj.pos) !== -1;
	      }).map(function (itemObj) {
	        return itemObj.node;
	      });
	    } else {
	      checkedNodes = checkedNodes.filter(function (n) {
	        return !n.props.children;
	      });
	    }
	    return checkedNodes;
	  };
	
	  Select.prototype.getDeselectedValue = function getDeselectedValue(selectedValue) {
	    var checkedTreeNodes = this.checkedTreeNodes;
	    var unCheckPos = void 0;
	    checkedTreeNodes.forEach(function (itemObj) {
	      if (itemObj.node.props.value === selectedValue) {
	        unCheckPos = itemObj.pos;
	      }
	    });
	    var newVals = [];
	    var newCkTns = [];
	    checkedTreeNodes.forEach(function (itemObj) {
	      if ((0, _util.isPositionPrefix)(itemObj.pos, unCheckPos) || (0, _util.isPositionPrefix)(unCheckPos, itemObj.pos)) {
	        // Filter ancestral and children nodes when uncheck a node.
	        return;
	      }
	      newCkTns.push(itemObj);
	      newVals.push(itemObj.node.props.value);
	    });
	    this.checkedTreeNodes = this._checkedNodes = newCkTns;
	    var nv = this.state.value.filter(function (val) {
	      return newVals.indexOf(val.value) !== -1;
	    });
	    this.fireChange(nv, { triggerValue: selectedValue, clear: true });
	  };
	
	  Select.prototype.setOpenState = function setOpenState(open, needFocus) {
	    var _this4 = this;
	
	    var documentClickClose = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    this.clearDelayTimer();
	    var props = this.props;
	    // can not optimize, if children is empty
	    // if (this.state.open === open) {
	    //   return;
	    // }
	
	    if (!this.props.onDropdownVisibleChange(open, { documentClickClose: documentClickClose })) {
	      return;
	    }
	    this.setState({
	      open: open
	    }, function () {
	      if (needFocus || open) {
	        if (open || (0, _util.isMultipleOrTagsOrCombobox)(props)) {
	          var input = _this4.getInputDOMNode();
	          if (input && document.activeElement !== input) {
	            input.focus();
	          }
	        } else if (_this4.selection) {
	          _this4.selection.focus();
	        }
	      }
	    });
	  };
	
	  Select.prototype.clearSearchInput = function clearSearchInput() {
	    this.getInputDOMNode().focus();
	    if (!('inputValue' in this.props)) {
	      this.setState({ inputValue: '' });
	    }
	  };
	
	  Select.prototype.addLabelToValue = function addLabelToValue(props, value_) {
	    var _this5 = this;
	
	    var value = value_;
	    if (this.isLabelInValue()) {
	      value.forEach(function (v, i) {
	        if (Object.prototype.toString.call(value[i]) !== '[object Object]') {
	          value[i] = {
	            value: '',
	            label: ''
	          };
	          return;
	        }
	        v.label = v.label || _this5.getLabelFromProps(props, v.value);
	      });
	    } else {
	      value = value.map(function (v) {
	        return {
	          value: v,
	          label: _this5.getLabelFromProps(props, v)
	        };
	      });
	    }
	    return value;
	  };
	
	  Select.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Select.prototype.removeSelected = function removeSelected(selectedVal) {
	    var props = this.props;
	    if (props.disabled) {
	      return;
	    }
	    this._cacheTreeNodesStates = 'no';
	    if (props.treeCheckable && (props.showCheckedStrategy === _strategies.SHOW_ALL || props.showCheckedStrategy === _strategies.SHOW_PARENT) && !(props.treeCheckStrictly || this.state.inputValue)) {
	      this.getDeselectedValue(selectedVal);
	      return;
	    }
	    // click the node's `x`(in select box), likely trigger the TreeNode's `unCheck` event,
	    // cautiously, they are completely different, think about it, the tree may not render at first,
	    // but the nodes in select box are ready.
	    var label = void 0;
	    var value = this.state.value.filter(function (singleValue) {
	      if (singleValue.value === selectedVal) {
	        label = singleValue.label;
	      }
	      return singleValue.value !== selectedVal;
	    });
	    var canMultiple = (0, _util.isMultipleOrTags)(props);
	
	    if (canMultiple) {
	      var event = selectedVal;
	      if (this.isLabelInValue()) {
	        event = {
	          value: selectedVal,
	          label: label
	        };
	      }
	      props.onDeselect(event);
	    }
	    if (props.treeCheckable) {
	      if (this.checkedTreeNodes && this.checkedTreeNodes.length) {
	        this.checkedTreeNodes = this._checkedNodes = this.checkedTreeNodes.filter(function (item) {
	          return value.some(function (i) {
	            return i.value === item.node.props.value;
	          });
	        });
	      }
	    }
	    this.fireChange(value, { triggerValue: selectedVal, clear: true });
	  };
	
	  Select.prototype.openIfHasChildren = function openIfHasChildren() {
	    var props = this.props;
	    if (_react2['default'].Children.count(props.children) || (0, _util.isSingleMode)(props)) {
	      this.setOpenState(true);
	    }
	  };
	
	  Select.prototype.fireChange = function fireChange(value, extraInfo) {
	    var _this6 = this;
	
	    var props = this.props;
	    var vals = value.map(function (i) {
	      return i.value;
	    });
	    var sv = this.state.value.map(function (i) {
	      return i.value;
	    });
	    if (vals.length !== sv.length || !vals.every(function (val, index) {
	      return sv[index] === val;
	    })) {
	      var ex = { preValue: [].concat(this.state.value) };
	      if (extraInfo) {
	        (0, _objectAssign2['default'])(ex, extraInfo);
	      }
	      var labs = null;
	      var vls = value;
	      if (!this.isLabelInValue()) {
	        labs = value.map(function (i) {
	          return i.label;
	        });
	        vls = vls.map(function (v) {
	          return v.value;
	        });
	      } else if (this.halfCheckedValues && this.halfCheckedValues.length) {
	        this.halfCheckedValues.forEach(function (i) {
	          if (!vls.some(function (v) {
	            return v.value === i.value;
	          })) {
	            vls.push(i);
	          }
	        });
	      }
	      if (props.treeCheckable && ex.clear) {
	        var treeData = this.renderedTreeData || props.children;
	        ex.allCheckedNodes = (0, _util.flatToHierarchy)((0, _util.filterAllCheckedData)(vals, treeData));
	      }
	      if (props.treeCheckable && this.state.inputValue) {
	        var _vls = [].concat(this.state.value);
	        if (ex.checked) {
	          value.forEach(function (i) {
	            if (_vls.every(function (ii) {
	              return ii.value !== i.value;
	            })) {
	              _vls.push((0, _extends3['default'])({}, i));
	            }
	          });
	        } else {
	          var index = void 0;
	          var includeVal = _vls.some(function (i, ind) {
	            if (i.value === ex.triggerValue) {
	              index = ind;
	              return true;
	            }
	          });
	          if (includeVal) {
	            _vls.splice(index, 1);
	          }
	        }
	        vls = _vls;
	        if (!this.isLabelInValue()) {
	          labs = _vls.map(function (v) {
	            return v.label;
	          });
	          vls = _vls.map(function (v) {
	            return v.value;
	          });
	        }
	      }
	      this._savedValue = (0, _util.isMultipleOrTags)(props) ? vls : vls[0];
	      props.onChange(this._savedValue, labs, ex);
	      if (!('value' in props)) {
	        this._cacheTreeNodesStates = false;
	        this.setState({
	          value: this.getValue(props, (0, _util.toArray)(this._savedValue).map(function (v, i) {
	            return _this6.isLabelInValue() ? v : {
	              value: v,
	              label: labs && labs[i]
	            };
	          }))
	        });
	      }
	    }
	  };
	
	  Select.prototype.isLabelInValue = function isLabelInValue() {
	    var _props4 = this.props,
	        treeCheckable = _props4.treeCheckable,
	        treeCheckStrictly = _props4.treeCheckStrictly,
	        labelInValue = _props4.labelInValue;
	
	    if (treeCheckable && treeCheckStrictly) {
	      return true;
	    }
	    return labelInValue || false;
	  };
	
	  Select.prototype.focus = function focus() {
	    if ((0, _util.isSingleMode)(this.props)) {
	      this.selection.focus();
	    } else {
	      this.getInputDOMNode().focus();
	    }
	  };
	
	  Select.prototype.blur = function blur() {
	    if ((0, _util.isSingleMode)(this.props)) {
	      this.selection.blur();
	    } else {
	      this.getInputDOMNode().blur();
	    }
	  };
	
	  Select.prototype.renderTopControlNode = function renderTopControlNode() {
	    var _this7 = this;
	
	    var value = this.state.value;
	
	    var props = this.props;
	    var choiceTransitionName = props.choiceTransitionName,
	        prefixCls = props.prefixCls,
	        maxTagTextLength = props.maxTagTextLength;
	    // single and not combobox, input is inside dropdown
	
	    if ((0, _util.isSingleMode)(props)) {
	      var innerNode = _react2['default'].createElement(
	        'span',
	        {
	          key: 'placeholder',
	          className: prefixCls + '-selection__placeholder'
	        },
	        props.placeholder
	      );
	      if (value.length) {
	        innerNode = _react2['default'].createElement(
	          'span',
	          {
	            key: 'value',
	            title: value[0].label,
	            className: prefixCls + '-selection-selected-value'
	          },
	          value[0].label
	        );
	      }
	      return _react2['default'].createElement(
	        'span',
	        { className: prefixCls + '-selection__rendered' },
	        innerNode
	      );
	    }
	
	    var selectedValueNodes = [];
	    if ((0, _util.isMultipleOrTags)(props)) {
	      selectedValueNodes = value.map(function (singleValue) {
	        var content = singleValue.label;
	        var title = content;
	        if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
	          content = content.slice(0, maxTagTextLength) + '...';
	        }
	        return _react2['default'].createElement(
	          'li',
	          (0, _extends3['default'])({
	            style: _util.UNSELECTABLE_STYLE
	          }, _util.UNSELECTABLE_ATTRIBUTE, {
	            onMouseDown: _util.preventDefaultEvent,
	            className: prefixCls + '-selection__choice',
	            key: singleValue.value,
	            title: title
	          }),
	          _react2['default'].createElement('span', {
	            className: prefixCls + '-selection__choice__remove',
	            onClick: _this7.removeSelected.bind(_this7, singleValue.value)
	          }),
	          _react2['default'].createElement(
	            'span',
	            { className: prefixCls + '-selection__choice__content' },
	            content
	          )
	        );
	      });
	    }
	    selectedValueNodes.push(_react2['default'].createElement(
	      'li',
	      {
	        className: prefixCls + '-search ' + prefixCls + '-search--inline',
	        key: '__input'
	      },
	      this.getInputElement()
	    ));
	    var className = prefixCls + '-selection__rendered';
	    if ((0, _util.isMultipleOrTags)(props) && choiceTransitionName) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          className: className,
	          component: 'ul',
	          transitionName: choiceTransitionName,
	          onLeave: this.onChoiceAnimationLeave
	        },
	        selectedValueNodes
	      );
	    }
	    return _react2['default'].createElement(
	      'ul',
	      { className: className },
	      selectedValueNodes
	    );
	  };
	
	  Select.prototype.renderTreeData = function renderTreeData(props) {
	    var validProps = props || this.props;
	    if (validProps.treeData) {
	      if (props && props.treeData === this.props.treeData && this.renderedTreeData) {
	        // cache and use pre data.
	        this._cachetreeData = true;
	        return this.renderedTreeData;
	      }
	      this._cachetreeData = false;
	      var treeData = [].concat(validProps.treeData);
	      // process treeDataSimpleMode
	      if (validProps.treeDataSimpleMode) {
	        var simpleFormat = {
	          id: 'id',
	          pId: 'pId',
	          rootPId: null
	        };
	        if (Object.prototype.toString.call(validProps.treeDataSimpleMode) === '[object Object]') {
	          (0, _objectAssign2['default'])(simpleFormat, validProps.treeDataSimpleMode);
	        }
	        treeData = (0, _util.processSimpleTreeData)(treeData, simpleFormat);
	      }
	      return loopTreeData(treeData, undefined, this.props.treeCheckable);
	    }
	  };
	
	  Select.prototype.render = function render() {
	    var _rootCls;
	
	    var props = this.props;
	    var multiple = (0, _util.isMultipleOrTags)(props);
	    var state = this.state;
	    var className = props.className,
	        disabled = props.disabled,
	        allowClear = props.allowClear,
	        prefixCls = props.prefixCls;
	
	    var ctrlNode = this.renderTopControlNode();
	    var extraSelectionProps = {};
	    if (!(0, _util.isMultipleOrTagsOrCombobox)(props)) {
	      extraSelectionProps = {
	        onKeyDown: this.onKeyDown,
	        tabIndex: 0
	      };
	    }
	    var rootCls = (_rootCls = {}, _rootCls[className] = !!className, _rootCls[prefixCls] = 1, _rootCls[prefixCls + '-open'] = state.open, _rootCls[prefixCls + '-focused'] = state.open || state.focused, _rootCls[prefixCls + '-disabled'] = disabled, _rootCls[prefixCls + '-enabled'] = !disabled, _rootCls[prefixCls + '-allow-clear'] = !!props.allowClear, _rootCls);
	
	    var clear = _react2['default'].createElement('span', {
	      key: 'clear',
	      className: prefixCls + '-selection__clear',
	      onClick: this.onClearSelection
	    });
	    return _react2['default'].createElement(
	      _SelectTrigger2['default'],
	      (0, _extends3['default'])({}, props, {
	        treeNodes: props.children,
	        treeData: this.renderedTreeData,
	        _cachetreeData: this._cachetreeData,
	        _treeNodesStates: this._treeNodesStates,
	        halfCheckedValues: this.halfCheckedValues,
	        multiple: multiple,
	        disabled: disabled,
	        visible: state.open,
	        inputValue: state.inputValue,
	        inputElement: this.getInputElement(),
	        value: state.value,
	        onDropdownVisibleChange: this.onDropdownVisibleChange,
	        getPopupContainer: props.getPopupContainer,
	        onSelect: this.onSelect,
	        ref: (0, _util.saveRef)(this, 'trigger')
	      }),
	      _react2['default'].createElement(
	        'span',
	        {
	          style: props.style,
	          onClick: props.onClick,
	          className: (0, _classnames2['default'])(rootCls),
	          onBlur: props.onBlur,
	          onFocus: props.onFocus
	        },
	        _react2['default'].createElement(
	          'span',
	          (0, _extends3['default'])({
	            ref: (0, _util.saveRef)(this, 'selection'),
	            key: 'selection',
	            className: prefixCls + '-selection\n            ' + prefixCls + '-selection--' + (multiple ? 'multiple' : 'single'),
	            role: 'combobox',
	            'aria-autocomplete': 'list',
	            'aria-haspopup': 'true',
	            'aria-expanded': state.open
	          }, extraSelectionProps),
	          ctrlNode,
	          allowClear && this.state.value.length && this.state.value[0].value ? clear : null,
	          multiple || !props.showArrow ? null : _react2['default'].createElement(
	            'span',
	            {
	              key: 'arrow',
	              className: prefixCls + '-arrow',
	              style: { outline: 'none' }
	            },
	            _react2['default'].createElement('b', null)
	          ),
	          multiple ? this.getSearchPlaceholderElement(!!this.state.inputValue || this.state.value.length) : null
	        )
	      )
	    );
	  };
	
	  return Select;
	}(_react.Component);
	
	Select.propTypes = _PropTypes.SelectPropTypes;
	Select.defaultProps = {
	  prefixCls: 'rc-tree-select',
	  filterTreeNode: filterFn,
	  showSearch: true,
	  allowClear: false,
	  placeholder: '',
	  searchPlaceholder: '',
	  labelInValue: false,
	  onClick: noop,
	  onChange: noop,
	  onSelect: noop,
	  onDeselect: noop,
	  onSearch: noop,
	  showArrow: true,
	  dropdownMatchSelectWidth: true,
	  dropdownStyle: {},
	  onDropdownVisibleChange: function onDropdownVisibleChange() {
	    return true;
	  },
	  notFoundContent: 'Not Found',
	  showCheckedStrategy: _strategies.SHOW_CHILD,
	  // skipHandleInitValue: false, // Deprecated (use treeCheckStrictly)
	  treeCheckStrictly: false,
	  treeIcon: false,
	  treeLine: false,
	  treeDataSimpleMode: false,
	  treeDefaultExpandAll: false,
	  treeCheckable: false,
	  treeNodeFilterProp: 'value',
	  treeNodeLabelProp: 'title'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this8 = this;
	
	  this.onInputChange = function (event) {
	    var val = event.target.value;
	    var props = _this8.props;
	
	    _this8.setState({
	      inputValue: val,
	      open: true
	    });
	    if (props.treeCheckable && !val) {
	      _this8.setState({
	        value: _this8.getValue(props, [].concat(_this8.state.value), false)
	      });
	    }
	    props.onSearch(val);
	  };
	
	  this.onDropdownVisibleChange = function (open) {
	    // selection inside combobox cause click
	    if (!open && document.activeElement === _this8.getInputDOMNode()) {}
	    // return;
	
	    // this.setOpenState(open);
	    // setTimeout, then have animation. why?
	    setTimeout(function () {
	      _this8.setOpenState(open, undefined, !open);
	    }, 10);
	  };
	
	  this.onKeyDown = function (event) {
	    var props = _this8.props;
	    if (props.disabled) {
	      return;
	    }
	    var keyCode = event.keyCode;
	    if (_this8.state.open && !_this8.getInputDOMNode()) {
	      _this8.onInputKeyDown(event);
	    } else if (keyCode === _KeyCode2['default'].ENTER || keyCode === _KeyCode2['default'].DOWN) {
	      _this8.setOpenState(true);
	      event.preventDefault();
	    }
	  };
	
	  this.onInputKeyDown = function (event) {
	    var props = _this8.props;
	    if (props.disabled) {
	      return;
	    }
	    var state = _this8.state;
	    var keyCode = event.keyCode;
	    if ((0, _util.isMultipleOrTags)(props) && !event.target.value && keyCode === _KeyCode2['default'].BACKSPACE) {
	      var value = state.value.concat();
	      if (value.length) {
	        var popValue = value.pop();
	        _this8.removeSelected(_this8.isLabelInValue() ? popValue : popValue.value);
	      }
	      return;
	    }
	    if (keyCode === _KeyCode2['default'].DOWN) {
	      if (!state.open) {
	        _this8.openIfHasChildren();
	        event.preventDefault();
	        event.stopPropagation();
	        return;
	      }
	    } else if (keyCode === _KeyCode2['default'].ESC) {
	      if (state.open) {
	        _this8.setOpenState(false);
	        event.preventDefault();
	        event.stopPropagation();
	      }
	      return;
	    }
	  };
	
	  this.onSelect = function (selectedKeys, info) {
	    var item = info.node;
	    var value = _this8.state.value;
	    var props = _this8.props;
	    var selectedValue = (0, _util.getValuePropValue)(item);
	    var selectedLabel = _this8.getLabelFromNode(item);
	    var checkableSelect = props.treeCheckable && info.event === 'select';
	    var event = selectedValue;
	    if (_this8.isLabelInValue()) {
	      event = {
	        value: event,
	        label: selectedLabel
	      };
	    }
	    if (info.selected === false) {
	      _this8.onDeselect(info);
	      if (!checkableSelect) return;
	    }
	    props.onSelect(event, item, info);
	
	    var checkEvt = info.event === 'check';
	    if ((0, _util.isMultipleOrTags)(props)) {
	      _this8.clearSearchInput();
	      if (checkEvt) {
	        value = _this8.getCheckedNodes(info, props).map(function (n) {
	          return {
	            value: (0, _util.getValuePropValue)(n),
	            label: _this8.getLabelFromNode(n)
	          };
	        });
	      } else {
	        if (value.some(function (i) {
	          return i.value === selectedValue;
	        })) {
	          return;
	        }
	        value = value.concat([{
	          value: selectedValue,
	          label: selectedLabel
	        }]);
	      }
	    } else {
	      if (value.length && value[0].value === selectedValue) {
	        _this8.setOpenState(false);
	        return;
	      }
	      value = [{
	        value: selectedValue,
	        label: selectedLabel
	      }];
	      _this8.setOpenState(false);
	    }
	
	    var extraInfo = {
	      triggerValue: selectedValue,
	      triggerNode: item
	    };
	    if (checkEvt) {
	      extraInfo.checked = info.checked;
	      // if inputValue existing, tree is checkStrictly
	      extraInfo.allCheckedNodes = props.treeCheckStrictly || _this8.state.inputValue ? info.checkedNodes : (0, _util.flatToHierarchy)(info.checkedNodesPositions);
	      _this8._checkedNodes = info.checkedNodesPositions;
	      var _tree = _this8.trigger.popupEle;
	      _this8._treeNodesStates = _tree.checkKeys;
	    } else {
	      extraInfo.selected = info.selected;
	    }
	
	    _this8.fireChange(value, extraInfo);
	    if (props.inputValue === null) {
	      _this8.setState({
	        inputValue: ''
	      });
	    }
	  };
	
	  this.onDeselect = function (info) {
	    _this8.removeSelected((0, _util.getValuePropValue)(info.node));
	    if (!(0, _util.isMultipleOrTags)(_this8.props)) {
	      _this8.setOpenState(false);
	    } else {
	      _this8.clearSearchInput();
	    }
	  };
	
	  this.onPlaceholderClick = function () {
	    _this8.getInputDOMNode().focus();
	  };
	
	  this.onClearSelection = function (event) {
	    var props = _this8.props;
	    var state = _this8.state;
	    if (props.disabled) {
	      return;
	    }
	    event.stopPropagation();
	    _this8._cacheTreeNodesStates = 'no';
	    _this8._checkedNodes = [];
	    if (state.inputValue || state.value.length) {
	      _this8.setOpenState(false);
	      if (typeof props.inputValue === 'undefined') {
	        _this8.setState({
	          inputValue: ''
	        }, function () {
	          _this8.fireChange([]);
	        });
	      } else {
	        _this8.fireChange([]);
	      }
	    }
	  };
	
	  this.onChoiceAnimationLeave = function () {
	    _this8.trigger.trigger.forcePopupAlign();
	  };
	};
	
	Select.SHOW_ALL = _strategies.SHOW_ALL;
	Select.SHOW_PARENT = _strategies.SHOW_PARENT;
	Select.SHOW_CHILD = _strategies.SHOW_CHILD;
	
	exports['default'] = Select;
	module.exports = exports['default'];

/***/ },
/* 2624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcTrigger = __webpack_require__(132);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _rcTree = __webpack_require__(1192);
	
	var _rcTree2 = _interopRequireDefault(_rcTree);
	
	var _util = __webpack_require__(1190);
	
	var _toArray = __webpack_require__(330);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  }
	};
	
	var SelectTrigger = function (_Component) {
	  (0, _inherits3['default'])(SelectTrigger, _Component);
	
	  function SelectTrigger() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SelectTrigger);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      _expandedKeys: [],
	      fireOnExpand: false,
	      dropdownWidth: null
	    }, _this.onExpand = function (expandedKeys) {
	      // rerender
	      _this.setState({
	        _expandedKeys: expandedKeys,
	        fireOnExpand: true
	      }, function () {
	        // Fix https://github.com/ant-design/ant-design/issues/5689
	        if (_this.trigger && _this.trigger.forcePopupAlign) {
	          _this.trigger.forcePopupAlign();
	        }
	      });
	    }, _this.highlightTreeNode = function (treeNode) {
	      var props = _this.props;
	      var filterVal = treeNode.props[(0, _util.labelCompatible)(props.treeNodeFilterProp)];
	      if (typeof filterVal === 'string') {
	        return props.inputValue && filterVal.indexOf(props.inputValue) > -1;
	      }
	      return false;
	    }, _this.filterTreeNode = function (input, child) {
	      if (!input) {
	        return true;
	      }
	      var filterTreeNode = _this.props.filterTreeNode;
	      if (!filterTreeNode) {
	        return true;
	      }
	      if (child.props.disabled) {
	        return false;
	      }
	      return filterTreeNode.call(_this, input, child);
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  SelectTrigger.prototype.componentDidMount = function componentDidMount() {
	    this.setDropdownWidth();
	  };
	
	  SelectTrigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.inputValue && nextProps.inputValue !== this.props.inputValue) {
	      // set autoExpandParent to true
	      this.setState({
	        _expandedKeys: [],
	        fireOnExpand: false
	      });
	    }
	  };
	
	  SelectTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setDropdownWidth();
	  };
	
	  SelectTrigger.prototype.setDropdownWidth = function setDropdownWidth() {
	    var width = _reactDom2['default'].findDOMNode(this).offsetWidth;
	    if (width !== this.state.dropdownWidth) {
	      this.setState({ dropdownWidth: width });
	    }
	  };
	
	  SelectTrigger.prototype.getPopupEleRefs = function getPopupEleRefs() {
	    return this.popupEle;
	  };
	
	  SelectTrigger.prototype.getPopupDOMNode = function getPopupDOMNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  SelectTrigger.prototype.getDropdownTransitionName = function getDropdownTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = this.getDropdownPrefixCls() + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  SelectTrigger.prototype.getDropdownPrefixCls = function getDropdownPrefixCls() {
	    return this.props.prefixCls + '-dropdown';
	  };
	
	  SelectTrigger.prototype.processTreeNode = function processTreeNode(treeNodes) {
	    var _this2 = this;
	
	    var filterPoss = [];
	    this._expandedKeys = [];
	    (0, _util.loopAllChildren)(treeNodes, function (child, index, pos) {
	      if (_this2.filterTreeNode(_this2.props.inputValue, child)) {
	        filterPoss.push(pos);
	        _this2._expandedKeys.push(child.key);
	      }
	    });
	
	    // Include the filtered nodes's ancestral nodes.
	    var processedPoss = [];
	    filterPoss.forEach(function (pos) {
	      var arr = pos.split('-');
	      arr.reduce(function (pre, cur) {
	        var res = pre + '-' + cur;
	        if (processedPoss.indexOf(res) < 0) {
	          processedPoss.push(res);
	        }
	        return res;
	      });
	    });
	    var filterNodesPositions = [];
	    (0, _util.loopAllChildren)(treeNodes, function (child, index, pos) {
	      if (processedPoss.indexOf(pos) > -1) {
	        filterNodesPositions.push({ node: child, pos: pos });
	      }
	    });
	
	    var hierarchyNodes = (0, _util.flatToHierarchy)(filterNodesPositions);
	
	    var recursive = function recursive(children) {
	      return children.map(function (child) {
	        if (child.children) {
	          return _react2['default'].cloneElement(child.node, {}, recursive(child.children));
	        }
	        return child.node;
	      });
	    };
	    return recursive(hierarchyNodes);
	  };
	
	  SelectTrigger.prototype.renderTree = function renderTree(keys, halfCheckedKeys, newTreeNodes, multiple) {
	    var props = this.props;
	
	    var trProps = {
	      multiple: multiple,
	      prefixCls: props.prefixCls + '-tree',
	      showIcon: props.treeIcon,
	      showLine: props.treeLine,
	      defaultExpandAll: props.treeDefaultExpandAll,
	      defaultExpandedKeys: props.treeDefaultExpandedKeys,
	      filterTreeNode: this.highlightTreeNode
	    };
	
	    if (props.treeCheckable) {
	      trProps.selectable = false;
	      trProps.checkable = props.treeCheckable;
	      trProps.onCheck = props.onSelect;
	      trProps.checkStrictly = props.treeCheckStrictly;
	      if (props.inputValue) {
	        // enable checkStrictly when search tree.
	        trProps.checkStrictly = true;
	      } else {
	        trProps._treeNodesStates = props._treeNodesStates;
	      }
	      if (trProps.treeCheckStrictly && halfCheckedKeys.length) {
	        trProps.checkedKeys = { checked: keys, halfChecked: halfCheckedKeys };
	      } else {
	        trProps.checkedKeys = keys;
	      }
	    } else {
	      trProps.selectedKeys = keys;
	      trProps.onSelect = props.onSelect;
	    }
	
	    // expand keys
	    if (!trProps.defaultExpandAll && !trProps.defaultExpandedKeys && !props.loadData) {
	      trProps.expandedKeys = keys;
	    }
	    trProps.autoExpandParent = true;
	    trProps.onExpand = this.onExpand;
	    if (this._expandedKeys && this._expandedKeys.length) {
	      trProps.expandedKeys = this._expandedKeys;
	    }
	    if (this.state.fireOnExpand) {
	      trProps.expandedKeys = this.state._expandedKeys;
	      trProps.autoExpandParent = false;
	    }
	
	    // async loadData
	    if (props.loadData) {
	      trProps.loadData = props.loadData;
	    }
	
	    return _react2['default'].createElement(
	      _rcTree2['default'],
	      (0, _extends3['default'])({ ref: (0, _util.saveRef)(this, 'popupEle') }, trProps),
	      newTreeNodes
	    );
	  };
	
	  SelectTrigger.prototype.render = function render() {
	    var _popupClassName;
	
	    var props = this.props;
	    var multiple = props.multiple;
	    var dropdownPrefixCls = this.getDropdownPrefixCls();
	    var popupClassName = (_popupClassName = {}, _popupClassName[props.dropdownClassName] = !!props.dropdownClassName, _popupClassName[dropdownPrefixCls + '--' + (multiple ? 'multiple' : 'single')] = 1, _popupClassName);
	    var visible = props.visible;
	    var search = multiple || props.combobox || !props.showSearch ? null : _react2['default'].createElement(
	      'span',
	      { className: dropdownPrefixCls + '-search' },
	      props.inputElement
	    );
	
	    var recursive = function recursive(children) {
	      // Note: if use `React.Children.map`, the node's key will be modified.
	      return (0, _toArray2['default'])(children).map(function handler(child) {
	        // eslint-disable-line
	        if (!child) {
	          return null;
	        }
	        if (child && child.props.children) {
	          // null or String has no Prop
	          return _react2['default'].createElement(
	            _rcTree.TreeNode,
	            (0, _extends3['default'])({}, child.props, { key: child.key }),
	            recursive(child.props.children)
	          );
	        }
	        return _react2['default'].createElement(_rcTree.TreeNode, (0, _extends3['default'])({}, child.props, { key: child.key }));
	      });
	    };
	    // const s = Date.now();
	    var treeNodes = void 0;
	    if (props._cachetreeData && this.treeNodes) {
	      treeNodes = this.treeNodes;
	    } else {
	      treeNodes = recursive(props.treeData || props.treeNodes);
	      this.treeNodes = treeNodes;
	    }
	    // console.log(Date.now()-s);
	
	    if (props.inputValue) {
	      treeNodes = this.processTreeNode(treeNodes);
	    }
	
	    var keys = [];
	    var halfCheckedKeys = [];
	    (0, _util.loopAllChildren)(treeNodes, function (child) {
	      if (props.value.some(function (item) {
	        return item.value === (0, _util.getValuePropValue)(child);
	      })) {
	        keys.push(child.key);
	      }
	      if (props.halfCheckedValues && props.halfCheckedValues.some(function (item) {
	        return item.value === (0, _util.getValuePropValue)(child);
	      })) {
	        halfCheckedKeys.push(child.key);
	      }
	    });
	
	    var notFoundContent = void 0;
	    if (!treeNodes.length) {
	      if (props.notFoundContent) {
	        notFoundContent = _react2['default'].createElement(
	          'span',
	          { className: props.prefixCls + '-not-found' },
	          props.notFoundContent
	        );
	      } else if (!search) {
	        visible = false;
	      }
	    }
	    var popupElement = _react2['default'].createElement(
	      'div',
	      null,
	      search,
	      notFoundContent || this.renderTree(keys, halfCheckedKeys, treeNodes, multiple)
	    );
	
	    var popupStyle = (0, _extends3['default'])({}, props.dropdownStyle);
	    var widthProp = props.dropdownMatchSelectWidth ? 'width' : 'minWidth';
	    if (this.state.dropdownWidth) {
	      popupStyle[widthProp] = this.state.dropdownWidth + 'px';
	    }
	
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      {
	        action: props.disabled ? [] : ['click'],
	        ref: (0, _util.saveRef)(this, 'trigger'),
	        popupPlacement: 'bottomLeft',
	        builtinPlacements: BUILT_IN_PLACEMENTS,
	        popupAlign: props.dropdownPopupAlign,
	        prefixCls: dropdownPrefixCls,
	        popupTransitionName: this.getDropdownTransitionName(),
	        onPopupVisibleChange: props.onDropdownVisibleChange,
	        popup: popupElement,
	        popupVisible: visible,
	        getPopupContainer: props.getPopupContainer,
	        popupClassName: (0, _classnames2['default'])(popupClassName),
	        popupStyle: popupStyle
	      },
	      this.props.children
	    );
	  };
	
	  return SelectTrigger;
	}(_react.Component);
	
	SelectTrigger.propTypes = {
	  dropdownMatchSelectWidth: _propTypes2['default'].bool,
	  dropdownPopupAlign: _propTypes2['default'].object,
	  visible: _propTypes2['default'].bool,
	  filterTreeNode: _propTypes2['default'].any,
	  treeNodes: _propTypes2['default'].any,
	  inputValue: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  children: _propTypes2['default'].any
	};
	exports['default'] = SelectTrigger;
	module.exports = exports['default'];

/***/ },
/* 2625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SHOW_CHILD = exports.SHOW_PARENT = exports.SHOW_ALL = exports.TreeNode = undefined;
	
	var _strategies = __webpack_require__(481);
	
	Object.defineProperty(exports, 'SHOW_ALL', {
	  enumerable: true,
	  get: function get() {
	    return _strategies.SHOW_ALL;
	  }
	});
	Object.defineProperty(exports, 'SHOW_PARENT', {
	  enumerable: true,
	  get: function get() {
	    return _strategies.SHOW_PARENT;
	  }
	});
	Object.defineProperty(exports, 'SHOW_CHILD', {
	  enumerable: true,
	  get: function get() {
	    return _strategies.SHOW_CHILD;
	  }
	});
	
	var _Select = __webpack_require__(2623);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _TreeNode = __webpack_require__(1189);
	
	var _TreeNode2 = _interopRequireDefault(_TreeNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// export this package's api
	_Select2['default'].TreeNode = _TreeNode2['default'];
	
	exports['default'] = _Select2['default'];
	exports.TreeNode = _TreeNode2['default'];

/***/ },
/* 2626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _toArray = __webpack_require__(330);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _Tree = __webpack_require__(1191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultTitle = '---';
	
	var TreeNode = function (_React$Component) {
	  (0, _inherits3['default'])(TreeNode, _React$Component);
	
	  function TreeNode(props) {
	    (0, _classCallCheck3['default'])(this, TreeNode);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onCheck = function () {
	      _this.props.root.onCheck(_this);
	    };
	
	    _this.onMouseEnter = function (e) {
	      e.preventDefault();
	      _this.props.root.onMouseEnter(e, _this);
	    };
	
	    _this.onMouseLeave = function (e) {
	      e.preventDefault();
	      _this.props.root.onMouseLeave(e, _this);
	    };
	
	    _this.onContextMenu = function (e) {
	      _this.props.root.onContextMenu(e, _this);
	    };
	
	    _this.onDragStart = function (e) {
	      e.stopPropagation();
	      _this.setState({
	        dragNodeHighlight: true
	      });
	      _this.props.root.onDragStart(e, _this);
	      try {
	        // ie throw error
	        // firefox-need-it
	        e.dataTransfer.setData('text/plain', '');
	      } catch (error) {
	        // empty
	      }
	    };
	
	    _this.onDragEnter = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.props.root.onDragEnter(e, _this);
	    };
	
	    _this.onDragOver = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.props.root.onDragOver(e, _this);
	    };
	
	    _this.onDragLeave = function (e) {
	      e.stopPropagation();
	      _this.props.root.onDragLeave(e, _this);
	    };
	
	    _this.onDrop = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	      _this.setState({
	        dragNodeHighlight: false
	      });
	      _this.props.root.onDrop(e, _this);
	    };
	
	    _this.onDragEnd = function (e) {
	      e.stopPropagation();
	      _this.setState({
	        dragNodeHighlight: false
	      });
	      _this.props.root.onDragEnd(e, _this);
	    };
	
	    _this.onExpand = function () {
	      var callbackPromise = _this.props.root.onExpand(_this);
	      if (callbackPromise && typeof callbackPromise === 'object') {
	        var setLoading = function setLoading(dataLoading) {
	          _this.setState({ dataLoading: dataLoading });
	        };
	        setLoading(true);
	        callbackPromise.then(function () {
	          setLoading(false);
	        }, function () {
	          setLoading(false);
	        });
	      }
	    };
	
	    _this.saveSelectHandle = function (node) {
	      _this.selectHandle = node;
	    };
	
	    _this.state = {
	      dataLoading: false,
	      dragNodeHighlight: false
	    };
	    return _this;
	  }
	
	  TreeNode.prototype.onSelect = function onSelect() {
	    this.props.root.onSelect(this);
	  };
	
	  // keyboard event support
	  TreeNode.prototype.onKeyDown = function onKeyDown(e) {
	    e.preventDefault();
	  };
	
	  TreeNode.prototype.isSelectable = function isSelectable() {
	    var props = this.props,
	        context = this.context;
	
	    return 'selectable' in props ? props.selectable : context.rcTree.selectable;
	  };
	
	  TreeNode.prototype.renderSwitcher = function renderSwitcher(props, expandedState) {
	    var _classNames;
	
	    var prefixCls = props.prefixCls;
	    var switcherCls = (0, _classnames2['default'])(prefixCls + '-switcher', prefixCls + '-switcher_' + expandedState, (_classNames = {}, _classNames[prefixCls + '-switcher-disabled'] = props.disabled, _classNames));
	    return _react2['default'].createElement('span', { className: switcherCls, onClick: props.disabled ? null : this.onExpand });
	  };
	
	  TreeNode.prototype.renderCheckbox = function renderCheckbox(props) {
	    var _checkboxCls;
	
	    var prefixCls = props.prefixCls;
	    var checkboxCls = (_checkboxCls = {}, _checkboxCls[prefixCls + '-checkbox'] = true, _checkboxCls);
	    if (props.checked) {
	      checkboxCls[prefixCls + '-checkbox-checked'] = true;
	    } else if (props.halfChecked) {
	      checkboxCls[prefixCls + '-checkbox-indeterminate'] = true;
	    }
	    var customEle = null;
	    if (typeof props.checkable !== 'boolean') {
	      customEle = props.checkable;
	    }
	    if (props.disabled || props.disableCheckbox) {
	      checkboxCls[prefixCls + '-checkbox-disabled'] = true;
	      return _react2['default'].createElement(
	        'span',
	        { className: (0, _classnames2['default'])(checkboxCls) },
	        customEle
	      );
	    }
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: (0, _classnames2['default'])(checkboxCls),
	        onClick: this.onCheck
	      },
	      customEle
	    );
	  };
	
	  TreeNode.prototype.renderChildren = function renderChildren(props) {
	    var renderFirst = this.renderFirst;
	    this.renderFirst = 1;
	    var transitionAppear = true;
	    if (!renderFirst && props.expanded) {
	      transitionAppear = false;
	    }
	    var children = null;
	    if (props.children) {
	      children = (0, _toArray2['default'])(props.children).filter(function (item) {
	        return !!item;
	      });
	    }
	    var newChildren = children;
	    if (children && (Array.isArray(children) && children.length && children.every(function (item) {
	      return item.type && item.type.isTreeNode;
	    }) || children.type && children.type.isTreeNode)) {
	      var _classNames2;
	
	      var animProps = {};
	      if (props.openTransitionName) {
	        animProps.transitionName = props.openTransitionName;
	      } else if (typeof props.openAnimation === 'object') {
	        animProps.animation = (0, _extends3['default'])({}, props.openAnimation);
	        if (!transitionAppear) {
	          delete animProps.animation.appear;
	        }
	      }
	      var cls = (0, _classnames2['default'])(props.prefixCls + '-child-tree', (_classNames2 = {}, _classNames2[props.prefixCls + '-child-tree-open'] = props.expanded, _classNames2));
	      newChildren = _react2['default'].createElement(
	        _rcAnimate2['default'],
	        (0, _extends3['default'])({}, animProps, {
	          showProp: 'data-expanded',
	          transitionAppear: transitionAppear,
	          component: ''
	        }),
	        !props.expanded ? null : _react2['default'].createElement(
	          'ul',
	          { className: cls, 'data-expanded': props.expanded },
	          _react2['default'].Children.map(children, function (item, index) {
	            return props.root.renderTreeNode(item, index, props.pos);
	          }, props.root)
	        )
	      );
	    }
	    return newChildren;
	  };
	
	  TreeNode.prototype.render = function render() {
	    var _iconEleCls,
	        _this2 = this;
	
	    var props = this.props;
	
	    var prefixCls = props.prefixCls;
	    var expandedState = props.expanded ? 'open' : 'close';
	    var iconState = expandedState;
	
	    var canRenderSwitcher = true;
	    var content = props.title;
	    var newChildren = this.renderChildren(props);
	    if (!newChildren || newChildren === props.children) {
	      // content = newChildren;
	      newChildren = null;
	      if (!props.loadData || props.isLeaf) {
	        canRenderSwitcher = false;
	        iconState = 'docu';
	      }
	    }
	    // For performance, does't render children into dom when `!props.expanded` (move to Animate)
	    // if (!props.expanded) {
	    //   newChildren = null;
	    // }
	
	    var iconEleCls = (_iconEleCls = {}, _iconEleCls[prefixCls + '-iconEle'] = true, _iconEleCls[prefixCls + '-icon_loading'] = this.state.dataLoading, _iconEleCls[prefixCls + '-icon__' + iconState] = true, _iconEleCls);
	
	    var selectHandle = function selectHandle() {
	      var icon = props.showIcon || props.loadData && _this2.state.dataLoading ? _react2['default'].createElement('span', { className: (0, _classnames2['default'])(iconEleCls) }) : null;
	      var title = _react2['default'].createElement(
	        'span',
	        { className: prefixCls + '-title' },
	        content
	      );
	      var wrap = prefixCls + '-node-content-wrapper';
	      var domProps = {
	        className: wrap + ' ' + wrap + '-' + (iconState === expandedState ? iconState : 'normal'),
	        onMouseEnter: _this2.onMouseEnter,
	        onMouseLeave: _this2.onMouseLeave,
	        onContextMenu: _this2.onContextMenu
	      };
	      if (!props.disabled) {
	        if (props.selected || _this2.state.dragNodeHighlight) {
	          domProps.className += ' ' + prefixCls + '-node-selected';
	        }
	        domProps.onClick = function (e) {
	          if (_this2.isSelectable()) {
	            e.preventDefault();
	            _this2.onSelect();
	          } else if (props.checkable && !props.disableCheckbox) {
	            e.preventDefault();
	            // && !props.disabled is checked on line 259
	            _this2.onCheck();
	          }
	        };
	        if (props.draggable) {
	          domProps.className += ' draggable';
	          domProps.draggable = true;
	          domProps['aria-grabbed'] = true;
	          domProps.onDragStart = _this2.onDragStart;
	        }
	      }
	      return _react2['default'].createElement(
	        'span',
	        (0, _extends3['default'])({
	          ref: _this2.saveSelectHandle,
	          title: typeof content === 'string' ? content : ''
	        }, domProps),
	        icon,
	        title
	      );
	    };
	
	    var liProps = {};
	    if (props.draggable) {
	      liProps.onDragEnter = this.onDragEnter;
	      liProps.onDragOver = this.onDragOver;
	      liProps.onDragLeave = this.onDragLeave;
	      liProps.onDrop = this.onDrop;
	      liProps.onDragEnd = this.onDragEnd;
	    }
	
	    var disabledCls = '';
	    var dragOverCls = '';
	    if (props.disabled) {
	      disabledCls = prefixCls + '-treenode-disabled';
	    } else if (props.dragOver) {
	      dragOverCls = 'drag-over';
	    } else if (props.dragOverGapTop) {
	      dragOverCls = 'drag-over-gap-top';
	    } else if (props.dragOverGapBottom) {
	      dragOverCls = 'drag-over-gap-bottom';
	    }
	
	    var filterCls = props.filterTreeNode(this) ? 'filter-node' : '';
	
	    var renderNoopSwitcher = function renderNoopSwitcher() {
	      return _react2['default'].createElement('span', { className: prefixCls + '-switcher ' + prefixCls + '-switcher-noop' });
	    };
	
	    return _react2['default'].createElement(
	      'li',
	      (0, _extends3['default'])({}, liProps, {
	        className: (0, _classnames2['default'])(props.className, disabledCls, dragOverCls, filterCls)
	      }),
	      canRenderSwitcher ? this.renderSwitcher(props, expandedState) : renderNoopSwitcher(),
	      props.checkable ? this.renderCheckbox(props) : null,
	      selectHandle(),
	      newChildren
	    );
	  };
	
	  return TreeNode;
	}(_react2['default'].Component);
	
	TreeNode.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  disableCheckbox: _propTypes2['default'].bool,
	  expanded: _propTypes2['default'].bool,
	  isLeaf: _propTypes2['default'].bool,
	  root: _propTypes2['default'].object,
	  onSelect: _propTypes2['default'].func
	};
	TreeNode.contextTypes = _Tree.contextTypes;
	TreeNode.defaultProps = {
	  title: defaultTitle
	};
	
	
	TreeNode.isTreeNode = 1;
	
	exports['default'] = TreeNode;
	module.exports = exports['default'];

/***/ },
/* 2627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getOffset = getOffset;
	exports.traverseTreeNodes = traverseTreeNodes;
	exports.updateCheckState = updateCheckState;
	exports.getCheck = getCheck;
	exports.getStrictlyValue = getStrictlyValue;
	exports.isPositionPrefix = isPositionPrefix;
	
	var _react = __webpack_require__(1);
	
	function getOffset(ele) {
	  if (!ele.getClientRects().length) {
	    return { top: 0, left: 0 };
	  }
	
	  var rect = ele.getBoundingClientRect();
	  if (rect.width || rect.height) {
	    var doc = ele.ownerDocument;
	    var win = doc.defaultView;
	    var docElem = doc.documentElement;
	
	    return {
	      top: rect.top + win.pageYOffset - docElem.clientTop,
	      left: rect.left + win.pageXOffset - docElem.clientLeft
	    };
	  }
	
	  return rect;
	} /* eslint no-loop-func: 0*/
	function traverseTreeNodes(treeNodes, callback) {
	  var traverse = function traverse(subTreeNodes, level, parentsChildrenPos, parentPos) {
	    if (Array.isArray(subTreeNodes)) {
	      subTreeNodes = subTreeNodes.filter(function (item) {
	        return !!item;
	      });
	    }
	    _react.Children.forEach(subTreeNodes, function (item, index) {
	      var pos = level + '-' + index;
	      parentsChildrenPos.push(pos); // Note: side effect
	
	      var childrenPos = [];
	      if (item.props.children && item.type && item.type.isTreeNode) {
	        traverse(item.props.children, pos, childrenPos, pos);
	      }
	      callback(item, index, pos, item.key || pos, childrenPos, parentPos);
	    });
	  };
	  traverse(treeNodes, 0, []);
	}
	
	function updateCheckState(obj, checkedPosition, checkIt) {
	  var childrenLoop = function childrenLoop(parentObj) {
	    parentObj.childrenPos.forEach(function (childPos) {
	      var childObj = obj[childPos];
	      // User click don't change disabled item checked state
	      if (!childObj.disableCheckbox && !childObj.disabled) {
	        childObj.halfChecked = false;
	        childObj.checked = checkIt;
	      }
	      childrenLoop(childObj);
	    });
	  };
	
	  childrenLoop(obj[checkedPosition]);
	
	  var parentLoop = function parentLoop(childObj) {
	    if (!childObj.parentPos) return;
	    var parentObj = obj[childObj.parentPos];
	
	    var childrenCount = parentObj.childrenPos.length;
	
	    var checkedChildrenCount = 0;
	    parentObj.childrenPos.forEach(function (childPos) {
	      if (obj[childPos].disableCheckbox) {
	        childrenCount -= 1;
	        return;
	      }
	      if (obj[childPos].checked === true) checkedChildrenCount++;else if (obj[childPos].halfChecked === true) checkedChildrenCount += 0.5;
	    });
	
	    if (checkedChildrenCount === childrenCount) {
	      parentObj.checked = true;
	      parentObj.halfChecked = false;
	    } else if (checkedChildrenCount > 0) {
	      parentObj.halfChecked = true;
	      parentObj.checked = false;
	    } else {
	      parentObj.checked = false;
	      parentObj.halfChecked = false;
	    }
	    parentLoop(parentObj);
	  };
	
	  parentLoop(obj[checkedPosition]);
	}
	
	function getCheck(treeNodesStates) {
	  var halfCheckedKeys = [];
	  var checkedKeys = [];
	  var checkedNodes = [];
	  var checkedNodesPositions = [];
	  Object.keys(treeNodesStates).forEach(function (item) {
	    var itemObj = treeNodesStates[item];
	    if (itemObj.checked) {
	      checkedKeys.push(itemObj.key);
	      checkedNodes.push(itemObj.node);
	      checkedNodesPositions.push({ node: itemObj.node, pos: item });
	    } else if (itemObj.halfChecked) {
	      halfCheckedKeys.push(itemObj.key);
	    }
	  });
	  return {
	    halfCheckedKeys: halfCheckedKeys,
	    checkedKeys: checkedKeys,
	    checkedNodes: checkedNodes,
	    checkedNodesPositions: checkedNodesPositions
	  };
	}
	
	function getStrictlyValue(checkedKeys, halfChecked) {
	  if (halfChecked) {
	    return { checked: checkedKeys, halfChecked: halfChecked };
	  }
	  return checkedKeys;
	}
	
	function isPositionPrefix(smallPos, bigPos) {
	  if (bigPos.length < smallPos.length) {
	    return false;
	  }
	  // attention: "0-0-1" "0-0-10"
	  if (bigPos.length > smallPos.length && bigPos.charAt(smallPos.length) !== '-') {
	    return false;
	  }
	  return bigPos.substr(0, smallPos.length) === smallPos;
	}

/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(2487);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(53);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(2629);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(1193);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(1194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	  };
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var savePopupRef = this.savePopupRef,
	        props = this.props;
	    var align = props.align,
	        style = props.style,
	        visible = props.visible,
	        prefixCls = props.prefixCls,
	        destroyPopupOnHide = props.destroyPopupOnHide;
	
	    var className = this.getClassName(this.currentAlignClassName || props.getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	    var newStyle = (0, _extends3['default'])({}, style, this.getZIndexStyle());
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getTarget,
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            props.children
	          )
	        ) : null
	      );
	    }
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getTarget,
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          props.children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseLeave: _propTypes2['default'].func
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this2.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this2.currentAlignClassName !== currentAlignClassName) {
	      _this2.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this2.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.getTarget = function () {
	    return _this2.props.getRootDomNode();
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 2629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(1193);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 2630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _request = __webpack_require__(2635);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _uid = __webpack_require__(1195);
	
	var _uid2 = _interopRequireDefault(_uid);
	
	var _attrAccept = __webpack_require__(2633);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/no-is-mounted:0 react/sort-comp:0 */
	
	var AjaxUploader = function (_Component) {
	  (0, _inherits3['default'])(AjaxUploader, _Component);
	
	  function AjaxUploader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, AjaxUploader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uid: (0, _uid2['default'])() }, _this.reqs = {}, _this.onChange = function (e) {
	      var files = e.target.files;
	      _this.uploadFiles(files);
	      _this.reset();
	    }, _this.onClick = function () {
	      var el = _this.fileInput;
	      if (!el) {
	        return;
	      }
	      el.click();
	    }, _this.onKeyDown = function (e) {
	      if (e.key === 'Enter') {
	        _this.onClick();
	      }
	    }, _this.onFileDrop = function (e) {
	      if (e.type === 'dragover') {
	        e.preventDefault();
	        return;
	      }
	      var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
	        return (0, _attrAccept2['default'])(file, _this.props.accept);
	      });
	      _this.uploadFiles(files);
	
	      e.preventDefault();
	    }, _this.saveFileInput = function (node) {
	      _this.fileInput = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(AjaxUploader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      this.abort();
	    }
	  }, {
	    key: 'uploadFiles',
	    value: function uploadFiles(files) {
	      var _this2 = this;
	
	      var postFiles = Array.prototype.slice.call(files);
	      postFiles.forEach(function (file) {
	        file.uid = (0, _uid2['default'])();
	        _this2.upload(file, postFiles);
	      });
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file, fileList) {
	      var _this3 = this;
	
	      var props = this.props;
	
	      if (!props.beforeUpload) {
	        // always async in case use react state to keep fileList
	        return setTimeout(function () {
	          return _this3.post(file);
	        }, 0);
	      }
	
	      var before = props.beforeUpload(file, fileList);
	      if (before && before.then) {
	        before.then(function (processedFile) {
	          var processedFileType = Object.prototype.toString.call(processedFile);
	          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
	            _this3.post(processedFile);
	          } else {
	            _this3.post(file);
	          }
	        })['catch'](function (e) {
	          console && console.log(e); // eslint-disable-line
	        });
	      } else if (before !== false) {
	        setTimeout(function () {
	          return _this3.post(file);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'post',
	    value: function post(file) {
	      var _this4 = this;
	
	      if (!this._isMounted) {
	        return;
	      }
	      var props = this.props;
	      var data = props.data;
	      var onStart = props.onStart,
	          onProgress = props.onProgress;
	
	      if (typeof data === 'function') {
	        data = data(file);
	      }
	      var uid = file.uid;
	
	      var request = props.customRequest || _request2['default'];
	      this.reqs[uid] = request({
	        action: props.action,
	        filename: props.name,
	        file: file,
	        data: data,
	        headers: props.headers,
	        withCredentials: props.withCredentials,
	        onProgress: onProgress ? function (e) {
	          onProgress(e, file);
	        } : null,
	        onSuccess: function onSuccess(ret, xhr) {
	          delete _this4.reqs[uid];
	          props.onSuccess(ret, file, xhr);
	        },
	        onError: function onError(err, ret) {
	          delete _this4.reqs[uid];
	          props.onError(err, ret, file);
	        }
	      });
	      onStart(file);
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.setState({
	        uid: (0, _uid2['default'])()
	      });
	    }
	  }, {
	    key: 'abort',
	    value: function abort(file) {
	      var reqs = this.reqs;
	
	      if (file) {
	        var uid = file;
	        if (file && file.uid) {
	          uid = file.uid;
	        }
	        if (reqs[uid]) {
	          reqs[uid].abort();
	          delete reqs[uid];
	        }
	      } else {
	        Object.keys(reqs).forEach(function (uid) {
	          if (reqs[uid]) {
	            reqs[uid].abort();
	          }
	
	          delete reqs[uid];
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          Tag = _props.component,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          disabled = _props.disabled,
	          style = _props.style,
	          multiple = _props.multiple,
	          accept = _props.accept,
	          children = _props.children;
	
	      var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	      var events = disabled ? {} : {
	        onClick: this.onClick,
	        onKeyDown: this.onKeyDown,
	        onDrop: this.onFileDrop,
	        onDragOver: this.onFileDrop,
	        tabIndex: '0'
	      };
	      return _react2['default'].createElement(
	        Tag,
	        (0, _extends3['default'])({}, events, {
	          className: cls,
	          role: 'button',
	          style: style
	        }),
	        _react2['default'].createElement('input', {
	          type: 'file',
	          ref: this.saveFileInput,
	          key: this.state.uid,
	          style: { display: 'none' },
	          accept: accept,
	          multiple: multiple,
	          onChange: this.onChange
	        }),
	        children
	      );
	    }
	  }]);
	  return AjaxUploader;
	}(_react.Component);
	
	AjaxUploader.propTypes = {
	  component: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  accept: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  onStart: _propTypes2['default'].func,
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func]),
	  headers: _propTypes2['default'].object,
	  beforeUpload: _propTypes2['default'].func,
	  customRequest: _propTypes2['default'].func,
	  onProgress: _propTypes2['default'].func,
	  withCredentials: _propTypes2['default'].bool
	};
	exports['default'] = AjaxUploader;
	module.exports = exports['default'];

/***/ },
/* 2631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uid = __webpack_require__(1195);
	
	var _uid2 = _interopRequireDefault(_uid);
	
	var _warning = __webpack_require__(2636);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/sort-comp:0 */
	var IFRAME_STYLE = {
	  position: 'absolute',
	  top: 0,
	  opacity: 0,
	  filter: 'alpha(opacity=0)',
	  left: 0,
	  zIndex: 9999
	};
	
	// diferent from AjaxUpload, can only upload on at one time, serial seriously
	
	var IframeUploader = function (_Component) {
	  (0, _inherits3['default'])(IframeUploader, _Component);
	
	  function IframeUploader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, IframeUploader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uploading: false }, _this.file = {}, _this.onLoad = function () {
	      if (!_this.state.uploading) {
	        return;
	      }
	      var _this2 = _this,
	          props = _this2.props,
	          file = _this2.file;
	
	      var response = void 0;
	      try {
	        var doc = _this.getIframeDocument();
	        var script = doc.getElementsByTagName('script')[0];
	        if (script && script.parentNode === doc.body) {
	          doc.body.removeChild(script);
	        }
	        response = doc.body.innerHTML;
	        props.onSuccess(response, file);
	      } catch (err) {
	        (0, _warning2['default'])(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
	        response = 'cross-domain';
	        props.onError(err, null, file);
	      }
	      _this.endUpload();
	    }, _this.onChange = function () {
	      var target = _this.getFormInputNode();
	      // ie8/9 don't support FileList Object
	      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
	      var file = _this.file = {
	        uid: (0, _uid2['default'])(),
	        name: target.value
	      };
	      _this.startUpload();
	      var _this3 = _this,
	          props = _this3.props;
	
	      if (!props.beforeUpload) {
	        return _this.post(file);
	      }
	      var before = props.beforeUpload(file);
	      if (before && before.then) {
	        before.then(function () {
	          _this.post(file);
	        }, function () {
	          _this.endUpload();
	        });
	      } else if (before !== false) {
	        _this.post(file);
	      } else {
	        _this.endUpload();
	      }
	    }, _this.saveIframe = function (node) {
	      _this.iframe = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(IframeUploader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateIframeWH();
	      this.initIframe();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateIframeWH();
	    }
	  }, {
	    key: 'getIframeNode',
	    value: function getIframeNode() {
	      return this.iframe;
	    }
	  }, {
	    key: 'getIframeDocument',
	    value: function getIframeDocument() {
	      return this.getIframeNode().contentDocument;
	    }
	  }, {
	    key: 'getFormNode',
	    value: function getFormNode() {
	      return this.getIframeDocument().getElementById('form');
	    }
	  }, {
	    key: 'getFormInputNode',
	    value: function getFormInputNode() {
	      return this.getIframeDocument().getElementById('input');
	    }
	  }, {
	    key: 'getFormDataNode',
	    value: function getFormDataNode() {
	      return this.getIframeDocument().getElementById('data');
	    }
	  }, {
	    key: 'getFileForMultiple',
	    value: function getFileForMultiple(file) {
	      return this.props.multiple ? [file] : file;
	    }
	  }, {
	    key: 'getIframeHTML',
	    value: function getIframeHTML(domain) {
	      var domainScript = '';
	      var domainInput = '';
	      if (domain) {
	        var script = 'script';
	        domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
	        domainInput = '<input name="_documentDomain" value="' + domain + '" />';
	      }
	      return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="' + this.props.action + '" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
	    }
	  }, {
	    key: 'initIframeSrc',
	    value: function initIframeSrc() {
	      if (this.domain) {
	        this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
	      }
	    }
	  }, {
	    key: 'initIframe',
	    value: function initIframe() {
	      var iframeNode = this.getIframeNode();
	      var win = iframeNode.contentWindow;
	      var doc = void 0;
	      this.domain = this.domain || '';
	      this.initIframeSrc();
	      try {
	        doc = win.document;
	      } catch (e) {
	        this.domain = document.domain;
	        this.initIframeSrc();
	        win = iframeNode.contentWindow;
	        doc = win.document;
	      }
	      doc.open('text/html', 'replace');
	      doc.write(this.getIframeHTML(this.domain));
	      doc.close();
	      this.getFormInputNode().onchange = this.onChange;
	    }
	  }, {
	    key: 'endUpload',
	    value: function endUpload() {
	      if (this.state.uploading) {
	        this.file = {};
	        // hack avoid batch
	        this.state.uploading = false;
	        this.setState({
	          uploading: false
	        });
	        this.initIframe();
	      }
	    }
	  }, {
	    key: 'startUpload',
	    value: function startUpload() {
	      if (!this.state.uploading) {
	        this.state.uploading = true;
	        this.setState({
	          uploading: true
	        });
	      }
	    }
	  }, {
	    key: 'updateIframeWH',
	    value: function updateIframeWH() {
	      var rootNode = _reactDom2['default'].findDOMNode(this);
	      var iframeNode = this.getIframeNode();
	      iframeNode.style.height = rootNode.offsetHeight + 'px';
	      iframeNode.style.width = rootNode.offsetWidth + 'px';
	    }
	  }, {
	    key: 'abort',
	    value: function abort(file) {
	      if (file) {
	        var uid = file;
	        if (file && file.uid) {
	          uid = file.uid;
	        }
	        if (uid === this.file.uid) {
	          this.endUpload();
	        }
	      } else {
	        this.endUpload();
	      }
	    }
	  }, {
	    key: 'post',
	    value: function post(file) {
	      var formNode = this.getFormNode();
	      var dataSpan = this.getFormDataNode();
	      var data = this.props.data;
	      var onStart = this.props.onStart;
	
	      if (typeof data === 'function') {
	        data = data(file);
	      }
	      var inputs = document.createDocumentFragment();
	      for (var key in data) {
	        if (data.hasOwnProperty(key)) {
	          var input = document.createElement('input');
	          input.setAttribute('name', key);
	          input.value = data[key];
	          inputs.appendChild(input);
	        }
	      }
	      dataSpan.appendChild(inputs);
	      formNode.submit();
	      dataSpan.innerHTML = '';
	      onStart(file);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          Tag = _props.component,
	          disabled = _props.disabled,
	          className = _props.className,
	          prefixCls = _props.prefixCls,
	          children = _props.children,
	          style = _props.style;
	
	      var iframeStyle = (0, _extends3['default'])({}, IFRAME_STYLE, {
	        display: this.state.uploading || disabled ? 'none' : ''
	      });
	      var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	      return _react2['default'].createElement(
	        Tag,
	        {
	          className: cls,
	          style: (0, _extends3['default'])({ position: 'relative', zIndex: 0 }, style)
	        },
	        _react2['default'].createElement('iframe', {
	          ref: this.saveIframe,
	          onLoad: this.onLoad,
	          style: iframeStyle
	        }),
	        children
	      );
	    }
	  }]);
	  return IframeUploader;
	}(_react.Component);
	
	IframeUploader.propTypes = {
	  component: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  accept: _propTypes2['default'].string,
	  onStart: _propTypes2['default'].func,
	  multiple: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any,
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func]),
	  action: _propTypes2['default'].string,
	  name: _propTypes2['default'].string
	};
	exports['default'] = IframeUploader;
	module.exports = exports['default'];

/***/ },
/* 2632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AjaxUploader = __webpack_require__(2630);
	
	var _AjaxUploader2 = _interopRequireDefault(_AjaxUploader);
	
	var _IframeUploader = __webpack_require__(2631);
	
	var _IframeUploader2 = _interopRequireDefault(_IframeUploader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function empty() {}
	
	var Upload = function (_Component) {
	  (0, _inherits3['default'])(Upload, _Component);
	
	  function Upload() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Upload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      Component: null
	    }, _this.saveUploader = function (node) {
	      _this.uploader = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Upload, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.supportServerRender) {
	        /* eslint react/no-did-mount-set-state:0 */
	        this.setState({
	          Component: this.getComponent()
	        }, this.props.onReady);
	      }
	    }
	  }, {
	    key: 'getComponent',
	    value: function getComponent() {
	      return typeof File !== 'undefined' ? _AjaxUploader2['default'] : _IframeUploader2['default'];
	    }
	  }, {
	    key: 'abort',
	    value: function abort(file) {
	      this.uploader.abort(file);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.supportServerRender) {
	        var _ComponentUploader = this.state.Component;
	        if (_ComponentUploader) {
	          return _react2['default'].createElement(_ComponentUploader, (0, _extends3['default'])({}, this.props, { ref: this.saveUploader }));
	        }
	        return null;
	      }
	      var ComponentUploader = this.getComponent();
	      return _react2['default'].createElement(ComponentUploader, (0, _extends3['default'])({}, this.props, { ref: this.saveUploader }));
	    }
	  }]);
	  return Upload;
	}(_react.Component);
	
	Upload.propTypes = {
	  component: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  action: _propTypes2['default'].string,
	  name: _propTypes2['default'].string,
	  multipart: _propTypes2['default'].bool,
	  onError: _propTypes2['default'].func,
	  onSuccess: _propTypes2['default'].func,
	  onProgress: _propTypes2['default'].func,
	  onStart: _propTypes2['default'].func,
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func]),
	  headers: _propTypes2['default'].object,
	  accept: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  beforeUpload: _propTypes2['default'].func,
	  customRequest: _propTypes2['default'].func,
	  onReady: _propTypes2['default'].func,
	  withCredentials: _propTypes2['default'].bool,
	  supportServerRender: _propTypes2['default'].bool
	};
	Upload.defaultProps = {
	  component: 'span',
	  prefixCls: 'rc-upload',
	  data: {},
	  headers: {},
	  name: 'file',
	  multipart: false,
	  onReady: empty,
	  onStart: empty,
	  onError: empty,
	  onSuccess: empty,
	  supportServerRender: false,
	  multiple: false,
	  beforeUpload: null,
	  customRequest: null,
	  withCredentials: false
	};
	exports['default'] = Upload;
	module.exports = exports['default'];

/***/ },
/* 2633 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function endsWith(str, suffix) {
	  return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}
	
	exports['default'] = function (file, acceptedFiles) {
	  if (file && acceptedFiles) {
	    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
	    var fileName = file.name || '';
	    var mimeType = file.type || '';
	    var baseMimeType = mimeType.replace(/\/.*$/, '');
	
	    return acceptedFilesArray.some(function (type) {
	      var validType = type.trim();
	      if (validType.charAt(0) === '.') {
	        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
	      } else if (/\/\*$/.test(validType)) {
	        // This is something like a image/* mime type
	        return baseMimeType === validType.replace(/\/.*$/, '');
	      }
	      return mimeType === validType;
	    });
	  }
	  return true;
	};
	
	module.exports = exports['default'];

/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Upload = __webpack_require__(2632);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Upload2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 2635 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = upload;
	function getError(option, xhr) {
	  var msg = 'cannot post ' + option.action + ' ' + xhr.status + '\'';
	  var err = new Error(msg);
	  err.status = xhr.status;
	  err.method = 'post';
	  err.url = option.action;
	  return err;
	}
	
	function getBody(xhr) {
	  var text = xhr.responseText || xhr.response;
	  if (!text) {
	    return text;
	  }
	
	  try {
	    return JSON.parse(text);
	  } catch (e) {
	    return text;
	  }
	}
	
	// option {
	//  onProgress: (event: { percent: number }): void,
	//  onError: (event: Error, body?: Object): void,
	//  onSuccess: (body: Object): void,
	//  data: Object,
	//  filename: String,
	//  file: File,
	//  withCredentials: Boolean,
	//  action: String,
	//  headers: Object,
	// }
	function upload(option) {
	  var xhr = new XMLHttpRequest();
	
	  if (option.onProgress && xhr.upload) {
	    xhr.upload.onprogress = function progress(e) {
	      if (e.total > 0) {
	        e.percent = e.loaded / e.total * 100;
	      }
	      option.onProgress(e);
	    };
	  }
	
	  var formData = new FormData();
	
	  if (option.data) {
	    Object.keys(option.data).map(function (key) {
	      formData.append(key, option.data[key]);
	    });
	  }
	
	  formData.append(option.filename, option.file);
	
	  xhr.onerror = function error(e) {
	    option.onError(e);
	  };
	
	  xhr.onload = function onload() {
	    // allow success when 2xx status
	    // see https://github.com/react-component/upload/issues/34
	    if (xhr.status < 200 || xhr.status >= 300) {
	      return option.onError(getError(option, xhr), getBody(xhr));
	    }
	
	    option.onSuccess(getBody(xhr), xhr);
	  };
	
	  xhr.open('post', option.action, true);
	
	  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
	  if (option.withCredentials && 'withCredentials' in xhr) {
	    xhr.withCredentials = true;
	  }
	
	  var headers = option.headers || {};
	
	  // when set headers['X-Requested-With'] = null , can close default XHR header
	  // see https://github.com/react-component/upload/issues/33
	  if (headers['X-Requested-With'] !== null) {
	    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	  }
	
	  for (var h in headers) {
	    if (headers.hasOwnProperty(h) && headers[h] !== null) {
	      xhr.setRequestHeader(h, headers[h]);
	    }
	  }
	  xhr.send(formData);
	
	  return {
	    abort: function abort() {
	      xhr.abort();
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2636 */
21,
/* 2637 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = contains;
	function contains(root, n) {
	  var node = n;
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	
	  return false;
	}
	module.exports = exports['default'];

/***/ },
/* 2638 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getScrollBarSize;
	var cached = void 0;
	
	function getScrollBarSize(fresh) {
	  if (fresh || cached === undefined) {
	    var inner = document.createElement('div');
	    inner.style.width = '100%';
	    inner.style.height = '200px';
	
	    var outer = document.createElement('div');
	    var outerStyle = outer.style;
	
	    outerStyle.position = 'absolute';
	    outerStyle.top = 0;
	    outerStyle.left = 0;
	    outerStyle.pointerEvents = 'none';
	    outerStyle.visibility = 'hidden';
	    outerStyle.width = '200px';
	    outerStyle.height = '150px';
	    outerStyle.overflow = 'hidden';
	
	    outer.appendChild(inner);
	
	    document.body.appendChild(outer);
	
	    var widthContained = inner.offsetWidth;
	    outer.style.overflow = 'scroll';
	    var widthScroll = inner.offsetWidth;
	
	    if (widthContained === widthScroll) {
	      widthScroll = outer.clientWidth;
	    }
	
	    document.body.removeChild(outer);
	
	    cached = widthContained - widthScroll;
	  }
	  return cached;
	}
	module.exports = exports['default'];

/***/ },
/* 2639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetchKeys = __webpack_require__(2324);
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if (ret !== void 0) {
	        return !!ret;
	    }
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);
	
	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }
	
	    compareContext = compareContext || null;
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrays = __webpack_require__(1403);
	
	var _arrays2 = _interopRequireDefault(_arrays);
	
	var _reactAutowhatever = __webpack_require__(2647);
	
	var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);
	
	var _theme = __webpack_require__(2642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	var defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    containerProps,
	    children
	  );
	};
	
	var Autosuggest = function (_Component) {
	  _inherits(Autosuggest, _Component);
	
	  function Autosuggest(_ref2) {
	    var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
	
	    _classCallCheck(this, Autosuggest);
	
	    var _this = _possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      isFocused: false,
	      isCollapsed: !alwaysRenderSuggestions,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      valueBeforeUpDown: null
	    };
	
	    _this.justPressedUpDown = false;
	    return _this;
	  }
	
	  _createClass(Autosuggest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	
	      this.input = this.autowhatever.input;
	      this.suggestionsContainer = this.autowhatever.itemsContainer;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false) {
	          this.highlightFirstSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps)) {
	          if (nextProps.highlightFirstSuggestion) {
	            this.highlightFirstSuggestion();
	          }
	
	          if (this.state.isCollapsed && !this.justSelectedSuggestion) {
	            this.revealSuggestions();
	          }
	        } else {
	          this.resetHighlightedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var onSuggestionHighlighted = this.props.onSuggestionHighlighted;
	
	
	      if (!onSuggestionHighlighted) {
	        return;
	      }
	
	      var _state = this.state,
	          highlightedSectionIndex = _state.highlightedSectionIndex,
	          highlightedSuggestionIndex = _state.highlightedSuggestionIndex;
	
	
	      if (highlightedSectionIndex !== prevState.highlightedSectionIndex || highlightedSuggestionIndex !== prevState.highlightedSuggestionIndex) {
	        var suggestion = this.getHighlightedSuggestion();
	
	        onSuggestionHighlighted({ suggestion: suggestion });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	    }
	  }, {
	    key: 'updateHighlightedSuggestion',
	    value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof prevValue !== 'undefined') {
	          valueBeforeUpDown = prevValue;
	        }
	
	        return {
	          highlightedSectionIndex: sectionIndex,
	          highlightedSuggestionIndex: suggestionIndex,
	          valueBeforeUpDown: valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: 'resetHighlightedSuggestion',
	    value: function resetHighlightedSuggestion() {
	      var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.setState(function (state) {
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	
	        return {
	          highlightedSectionIndex: null,
	          highlightedSuggestionIndex: null,
	          valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
	        };
	      });
	    }
	  }, {
	    key: 'revealSuggestions',
	    value: function revealSuggestions() {
	      this.setState({
	        isCollapsed: false
	      });
	    }
	  }, {
	    key: 'closeSuggestions',
	    value: function closeSuggestions() {
	      this.setState({
	        highlightedSectionIndex: null,
	        highlightedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	    }
	  }, {
	    key: 'getSuggestion',
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _props = this.props,
	          suggestions = _props.suggestions,
	          multiSection = _props.multiSection,
	          getSectionSuggestions = _props.getSectionSuggestions;
	
	
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: 'getHighlightedSuggestion',
	    value: function getHighlightedSuggestion() {
	      var _state2 = this.state,
	          highlightedSectionIndex = _state2.highlightedSectionIndex,
	          highlightedSuggestionIndex = _state2.highlightedSuggestionIndex;
	
	
	      if (highlightedSuggestionIndex === null) {
	        return null;
	      }
	
	      return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
	    }
	  }, {
	    key: 'getSuggestionValueByIndex',
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	
	
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: 'getSuggestionIndices',
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: 'findSuggestionElement',
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	
	      do {
	        if (node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	
	        node = node.parentNode;
	      } while (node !== null);
	
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	      throw new Error("Couldn't find suggestion element");
	    }
	  }, {
	    key: 'maybeCallOnChange',
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _props$inputProps = this.props.inputProps,
	          value = _props$inputProps.value,
	          onChange = _props$inputProps.onChange;
	
	
	      if (newValue !== value) {
	        onChange(event, { newValue: newValue, method: method });
	      }
	    }
	  }, {
	    key: 'willRenderSuggestions',
	    value: function willRenderSuggestions(props) {
	      var suggestions = props.suggestions,
	          inputProps = props.inputProps,
	          shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	
	
	      return suggestions.length > 0 && shouldRenderSuggestions(value);
	    }
	  }, {
	    key: 'getQuery',
	    value: function getQuery() {
	      var inputProps = this.props.inputProps;
	      var value = inputProps.value;
	      var valueBeforeUpDown = this.state.valueBeforeUpDown;
	
	
	      return (valueBeforeUpDown || value).trim();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          suggestions = _props2.suggestions,
	          renderInputComponent = _props2.renderInputComponent,
	          onSuggestionsFetchRequested = _props2.onSuggestionsFetchRequested,
	          renderSuggestion = _props2.renderSuggestion,
	          inputProps = _props2.inputProps,
	          multiSection = _props2.multiSection,
	          renderSectionTitle = _props2.renderSectionTitle,
	          id = _props2.id,
	          getSectionSuggestions = _props2.getSectionSuggestions,
	          theme = _props2.theme,
	          getSuggestionValue = _props2.getSuggestionValue,
	          alwaysRenderSuggestions = _props2.alwaysRenderSuggestions;
	      var _state3 = this.state,
	          isFocused = _state3.isFocused,
	          isCollapsed = _state3.isCollapsed,
	          highlightedSectionIndex = _state3.highlightedSectionIndex,
	          highlightedSuggestionIndex = _state3.highlightedSuggestionIndex,
	          valueBeforeUpDown = _state3.valueBeforeUpDown;
	
	      var shouldRenderSuggestions = alwaysRenderSuggestions ? alwaysTrue : this.props.shouldRenderSuggestions;
	      var value = inputProps.value,
	          _onFocus = inputProps.onFocus,
	          _onKeyDown = inputProps.onKeyDown;
	
	      var willRenderSuggestions = this.willRenderSuggestions(this.props);
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	      var autowhateverInputProps = _extends({}, inputProps, {
	        onFocus: function onFocus(event) {
	          if (!_this2.justSelectedSuggestion && !_this2.justClickedOnSuggestionsContainer) {
	            var shouldRender = shouldRenderSuggestions(value);
	
	            _this2.setState({
	              isFocused: true,
	              isCollapsed: !shouldRender
	            });
	
	            _onFocus && _onFocus(event);
	
	            if (shouldRender) {
	              onSuggestionsFetchRequested({ value: value, reason: 'input-focused' });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this2.justClickedOnSuggestionsContainer) {
	            _this2.input.focus();
	            return;
	          }
	
	          _this2.blurEvent = event;
	
	          if (!_this2.justSelectedSuggestion) {
	            _this2.onBlur();
	            _this2.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          var shouldRender = shouldRenderSuggestions(value);
	
	          _this2.maybeCallOnChange(event, value, 'type');
	
	          _this2.setState({
	            highlightedSectionIndex: null,
	            highlightedSuggestionIndex: null,
	            valueBeforeUpDown: null,
	            isCollapsed: !shouldRender
	          });
	
	          if (shouldRender) {
	            onSuggestionsFetchRequested({ value: value, reason: 'input-changed' });
	          } else {
	            _this2.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          var keyCode = event.keyCode;
	
	
	          switch (keyCode) {
	            case 40: // ArrowDown
	            case 38:
	              // ArrowUp
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value)) {
	                  onSuggestionsFetchRequested({
	                    value: value,
	                    reason: 'suggestions-revealed'
	                  });
	                  _this2.revealSuggestions();
	                }
	              } else if (suggestions.length > 0) {
	                var newHighlightedSectionIndex = data.newHighlightedSectionIndex,
	                    newHighlightedItemIndex = data.newHighlightedItemIndex;
	
	
	                var newValue = void 0;
	
	                if (newHighlightedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this2.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
	                }
	
	                _this2.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
	                _this2.maybeCallOnChange(event, newValue, keyCode === 40 ? 'down' : 'up');
	              }
	
	              event.preventDefault(); // Prevents the cursor from moving
	
	              _this2.justPressedUpDown = true;
	
	              setTimeout(function () {
	                _this2.justPressedUpDown = false;
	              });
	
	              break;
	
	            // Enter
	            case 13:
	              {
	                // See #388
	                if (event.keyCode === 229) {
	                  break;
	                }
	
	                var highlightedSuggestion = _this2.getHighlightedSuggestion();
	
	                if (isOpen && !alwaysRenderSuggestions) {
	                  _this2.closeSuggestions();
	                }
	
	                if (highlightedSuggestion !== null) {
	                  var _newValue = getSuggestionValue(highlightedSuggestion);
	
	                  _this2.maybeCallOnChange(event, _newValue, 'enter');
	
	                  _this2.onSuggestionSelected(event, {
	                    suggestion: highlightedSuggestion,
	                    suggestionValue: _newValue,
	                    suggestionIndex: highlightedSuggestionIndex,
	                    sectionIndex: highlightedSectionIndex,
	                    method: 'enter'
	                  });
	
	                  _this2.justSelectedSuggestion = true;
	
	                  setTimeout(function () {
	                    _this2.justSelectedSuggestion = false;
	                  });
	                }
	
	                break;
	              }
	
	            // Escape
	            case 27:
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	
	                    _this2.maybeCallOnChange(event, _newValue2, 'escape');
	
	                    if (shouldRenderSuggestions(_newValue2)) {
	                      onSuggestionsFetchRequested({
	                        value: _newValue2,
	                        reason: 'escape-pressed'
	                      });
	                    } else {
	                      _this2.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this2.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	
	                if (willCloseSuggestions) {
	                  _this2.onSuggestionsClearRequested();
	                  _this2.closeSuggestions();
	                } else {
	                  _this2.resetHighlightedSuggestion();
	                }
	
	                break;
	              }
	          }
	
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	      var renderSuggestionData = {
	        query: this.getQuery()
	      };
	
	      return _react2.default.createElement(_reactAutowhatever2.default, {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: this.renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        highlightedSectionIndex: highlightedSectionIndex,
	        highlightedItemIndex: highlightedSuggestionIndex,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: (0, _theme.mapToAutowhateverTheme)(theme),
	        id: id,
	        ref: this.storeAutowhateverRef
	      });
	    }
	  }]);
	
	  return Autosuggest;
	}(_react.Component);
	
	Autosuggest.propTypes = {
	  suggestions: _propTypes2.default.array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
	    }
	  },
	  onSuggestionSelected: _propTypes2.default.func,
	  onSuggestionHighlighted: _propTypes2.default.func,
	  renderInputComponent: _propTypes2.default.func,
	  renderSuggestionsContainer: _propTypes2.default.func,
	  getSuggestionValue: _propTypes2.default.func.isRequired,
	  renderSuggestion: _propTypes2.default.func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps.hasOwnProperty('value')) {
	      throw new Error("'inputProps' must have 'value'.");
	    }
	
	    if (!inputProps.hasOwnProperty('onChange')) {
	      throw new Error("'inputProps' must have 'onChange'.");
	    }
	  },
	  shouldRenderSuggestions: _propTypes2.default.func,
	  alwaysRenderSuggestions: _propTypes2.default.bool,
	  multiSection: _propTypes2.default.bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
	    }
	  },
	  focusInputOnSuggestionClick: _propTypes2.default.bool,
	  highlightFirstSuggestion: _propTypes2.default.bool,
	  theme: _propTypes2.default.object,
	  id: _propTypes2.default.string
	};
	Autosuggest.defaultProps = {
	  renderSuggestionsContainer: defaultRenderSuggestionsContainer,
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  focusInputOnSuggestionClick: true,
	  highlightFirstSuggestion: false,
	  theme: _theme.defaultTheme,
	  id: '1'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onDocumentMouseDown = function (event) {
	    _this3.justClickedOnSuggestionsContainer = false;
	
	    var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
	    event.target;
	
	    while (node !== null && node !== document) {
	      if (node.getAttribute('data-suggestion-index') !== null) {
	        // Suggestion was clicked
	        return;
	      }
	
	      if (node === _this3.suggestionsContainer) {
	        // Something else inside suggestions container was clicked
	        _this3.justClickedOnSuggestionsContainer = true;
	        return;
	      }
	
	      node = node.parentNode;
	    }
	  };
	
	  this.storeAutowhateverRef = function (autowhatever) {
	    if (autowhatever !== null) {
	      _this3.autowhatever = autowhatever;
	    }
	  };
	
	  this.onSuggestionMouseEnter = function (event, _ref3) {
	    var sectionIndex = _ref3.sectionIndex,
	        itemIndex = _ref3.itemIndex;
	
	    _this3.updateHighlightedSuggestion(sectionIndex, itemIndex);
	  };
	
	  this.highlightFirstSuggestion = function () {
	    _this3.updateHighlightedSuggestion(_this3.props.multiSection ? 0 : null, 0);
	  };
	
	  this.onSuggestionMouseDown = function () {
	    _this3.justSelectedSuggestion = true;
	  };
	
	  this.onSuggestionsClearRequested = function () {
	    var onSuggestionsClearRequested = _this3.props.onSuggestionsClearRequested;
	
	
	    onSuggestionsClearRequested && onSuggestionsClearRequested();
	  };
	
	  this.onSuggestionSelected = function (event, data) {
	    var _props3 = _this3.props,
	        alwaysRenderSuggestions = _props3.alwaysRenderSuggestions,
	        onSuggestionSelected = _props3.onSuggestionSelected,
	        onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested;
	
	
	    onSuggestionSelected && onSuggestionSelected(event, data);
	
	    if (alwaysRenderSuggestions) {
	      onSuggestionsFetchRequested({
	        value: data.suggestionValue,
	        reason: 'suggestion-selected'
	      });
	    } else {
	      _this3.onSuggestionsClearRequested();
	    }
	
	    _this3.resetHighlightedSuggestion();
	  };
	
	  this.onSuggestionClick = function (event) {
	    var _props4 = _this3.props,
	        alwaysRenderSuggestions = _props4.alwaysRenderSuggestions,
	        focusInputOnSuggestionClick = _props4.focusInputOnSuggestionClick;
	
	    var _getSuggestionIndices = _this3.getSuggestionIndices(_this3.findSuggestionElement(event.target)),
	        sectionIndex = _getSuggestionIndices.sectionIndex,
	        suggestionIndex = _getSuggestionIndices.suggestionIndex;
	
	    var clickedSuggestion = _this3.getSuggestion(sectionIndex, suggestionIndex);
	    var clickedSuggestionValue = _this3.props.getSuggestionValue(clickedSuggestion);
	
	    _this3.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	    _this3.onSuggestionSelected(event, {
	      suggestion: clickedSuggestion,
	      suggestionValue: clickedSuggestionValue,
	      suggestionIndex: suggestionIndex,
	      sectionIndex: sectionIndex,
	      method: 'click'
	    });
	
	    if (!alwaysRenderSuggestions) {
	      _this3.closeSuggestions();
	    }
	
	    if (focusInputOnSuggestionClick === true) {
	      _this3.input.focus();
	    } else {
	      _this3.onBlur();
	    }
	
	    setTimeout(function () {
	      _this3.justSelectedSuggestion = false;
	    });
	  };
	
	  this.onBlur = function () {
	    var _props5 = _this3.props,
	        inputProps = _props5.inputProps,
	        shouldRenderSuggestions = _props5.shouldRenderSuggestions;
	    var value = inputProps.value,
	        onBlur = inputProps.onBlur;
	
	    var highlightedSuggestion = _this3.getHighlightedSuggestion();
	    var shouldRender = shouldRenderSuggestions(value);
	
	    _this3.setState({
	      isFocused: false,
	      highlightedSectionIndex: null,
	      highlightedSuggestionIndex: null,
	      valueBeforeUpDown: null,
	      isCollapsed: !shouldRender
	    });
	
	    onBlur && onBlur(_this3.blurEvent, { highlightedSuggestion: highlightedSuggestion });
	  };
	
	  this.resetHighlightedSuggestionOnMouseLeave = function () {
	    _this3.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
	  };
	
	  this.itemProps = function (_ref4) {
	    var sectionIndex = _ref4.sectionIndex,
	        itemIndex = _ref4.itemIndex;
	
	    return {
	      'data-section-index': sectionIndex,
	      'data-suggestion-index': itemIndex,
	      onMouseEnter: _this3.onSuggestionMouseEnter,
	      onMouseLeave: _this3.resetHighlightedSuggestionOnMouseLeave,
	      onMouseDown: _this3.onSuggestionMouseDown,
	      onTouchStart: _this3.onSuggestionMouseDown, // Because on iOS `onMouseDown` is not triggered
	      onClick: _this3.onSuggestionClick
	    };
	  };
	
	  this.renderSuggestionsContainer = function (_ref5) {
	    var containerProps = _ref5.containerProps,
	        children = _ref5.children;
	    var renderSuggestionsContainer = _this3.props.renderSuggestionsContainer;
	
	
	    return renderSuggestionsContainer({
	      containerProps: containerProps,
	      children: children,
	      query: _this3.getQuery()
	    });
	  };
	};
	
	exports.default = Autosuggest;

/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2640).default;

/***/ },
/* 2642 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var defaultTheme = exports.defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  inputOpen: 'react-autosuggest__input--open',
	  inputFocused: 'react-autosuggest__input--focused',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFirst: 'react-autosuggest__suggestion--first',
	  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionContainerFirst: 'react-autosuggest__section-container--first',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	
	var mapToAutowhateverTheme = exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	
	      case 'suggestionsContainerOpen':
	        result['itemsContainerOpen'] = theme[key];
	        break;
	
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	
	      case 'suggestionFirst':
	        result['itemFirst'] = theme[key];
	        break;
	
	      case 'suggestionHighlighted':
	        result['itemHighlighted'] = theme[key];
	        break;
	
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	
	      default:
	        result[key] = theme[key];
	    }
	  }
	
	  return result;
	};

/***/ },
/* 2643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sectionIterator = __webpack_require__(3241);
	
	var _sectionIterator2 = _interopRequireDefault(_sectionIterator);
	
	var _reactThemeable = __webpack_require__(2882);
	
	var _reactThemeable2 = _interopRequireDefault(_reactThemeable);
	
	var _SectionTitle = __webpack_require__(2646);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _ItemsList = __webpack_require__(2645);
	
	var _ItemsList2 = _interopRequireDefault(_ItemsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var emptyObject = {};
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return _react2.default.createElement('input', props);
	};
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
	  var containerProps = _ref.containerProps,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    containerProps,
	    children
	  );
	};
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  inputOpen: 'react-autowhatever__input--open',
	  inputFocused: 'react-autowhatever__input--focused',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsContainerOpen: 'react-autowhatever__items-container--open',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFirst: 'react-autowhatever__item--first',
	  itemHighlighted: 'react-autowhatever__item--highlighted',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionContainerFirst: 'react-autowhatever__section-container--first',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	
	var Autowhatever = function (_Component) {
	  _inherits(Autowhatever, _Component);
	
	  function Autowhatever(props) {
	    _classCallCheck(this, Autowhatever);
	
	    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));
	
	    _this.storeInputReference = function (input) {
	      if (input !== null) {
	        _this.input = input;
	      }
	    };
	
	    _this.storeItemsContainerReference = function (itemsContainer) {
	      if (itemsContainer !== null) {
	        _this.itemsContainer = itemsContainer;
	      }
	    };
	
	    _this.onHighlightedItemChange = function (highlightedItem) {
	      _this.highlightedItem = highlightedItem;
	    };
	
	    _this.getItemId = function (sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	
	      var id = _this.props.id;
	
	      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;
	
	      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
	    };
	
	    _this.onFocus = function (event) {
	      var inputProps = _this.props.inputProps;
	
	
	      _this.setState({
	        isInputFocused: true
	      });
	
	      inputProps.onFocus && inputProps.onFocus(event);
	    };
	
	    _this.onBlur = function (event) {
	      var inputProps = _this.props.inputProps;
	
	
	      _this.setState({
	        isInputFocused: false
	      });
	
	      inputProps.onBlur && inputProps.onBlur(event);
	    };
	
	    _this.onKeyDown = function (event) {
	      var _this$props = _this.props,
	          inputProps = _this$props.inputProps,
	          highlightedSectionIndex = _this$props.highlightedSectionIndex,
	          highlightedItemIndex = _this$props.highlightedItemIndex;
	
	
	      switch (event.key) {
	        case 'ArrowDown':
	        case 'ArrowUp':
	          {
	            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';
	
	            var _this$sectionIterator = _this.sectionIterator[nextPrev]([highlightedSectionIndex, highlightedItemIndex]),
	                _this$sectionIterator2 = _slicedToArray(_this$sectionIterator, 2),
	                newHighlightedSectionIndex = _this$sectionIterator2[0],
	                newHighlightedItemIndex = _this$sectionIterator2[1];
	
	            inputProps.onKeyDown(event, { newHighlightedSectionIndex: newHighlightedSectionIndex, newHighlightedItemIndex: newHighlightedItemIndex });
	            break;
	          }
	
	        default:
	          inputProps.onKeyDown(event, { highlightedSectionIndex: highlightedSectionIndex, highlightedItemIndex: highlightedItemIndex });
	      }
	    };
	
	    _this.highlightedItem = null;
	
	    _this.state = {
	      isInputFocused: false
	    };
	
	    _this.setSectionsItems(props);
	    _this.setSectionIterator(props);
	    _this.setTheme(props);
	    return _this;
	  }
	
	  _createClass(Autowhatever, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureHighlightedItemIsVisible();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureHighlightedItemIsVisible();
	    }
	  }, {
	    key: 'setSectionsItems',
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: 'setSectionIterator',
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator2.default)({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: 'setTheme',
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable2.default)(props.theme);
	    }
	  }, {
	    key: 'renderSections',
	    value: function renderSections() {
	      var _this2 = this;
	
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props = this.props,
	          id = _props.id,
	          items = _props.items,
	          renderItem = _props.renderItem,
	          renderItemData = _props.renderItemData,
	          renderSectionTitle = _props.renderSectionTitle,
	          highlightedSectionIndex = _props.highlightedSectionIndex,
	          highlightedItemIndex = _props.highlightedItemIndex,
	          itemProps = _props.itemProps;
	
	
	      return items.map(function (section, sectionIndex) {
	        var keyPrefix = 'react-autowhatever-' + id + '-';
	        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
	        var isFirstSection = sectionIndex === 0;
	
	        // `key` is provided by theme()
	        /* eslint-disable react/jsx-key */
	        return _react2.default.createElement(
	          'div',
	          theme(sectionKeyPrefix + 'container', 'sectionContainer', isFirstSection && 'sectionContainerFirst'),
	          _react2.default.createElement(_SectionTitle2.default, {
	            section: section,
	            renderSectionTitle: renderSectionTitle,
	            theme: theme,
	            sectionKeyPrefix: sectionKeyPrefix
	          }),
	          _react2.default.createElement(_ItemsList2.default, {
	            items: _this2.sectionsItems[sectionIndex],
	            itemProps: itemProps,
	            renderItem: renderItem,
	            renderItemData: renderItemData,
	            sectionIndex: sectionIndex,
	            highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
	            onHighlightedItemChange: _this2.onHighlightedItemChange,
	            getItemId: _this2.getItemId,
	            theme: theme,
	            keyPrefix: keyPrefix,
	            ref: _this2.storeItemsListReference
	          })
	        );
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var items = this.props.items;
	
	
	      if (items.length === 0) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props2 = this.props,
	          id = _props2.id,
	          renderItem = _props2.renderItem,
	          renderItemData = _props2.renderItemData,
	          highlightedSectionIndex = _props2.highlightedSectionIndex,
	          highlightedItemIndex = _props2.highlightedItemIndex,
	          itemProps = _props2.itemProps;
	
	
	      return _react2.default.createElement(_ItemsList2.default, {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
	        onHighlightedItemChange: this.onHighlightedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: 'react-autowhatever-' + id + '-'
	      });
	    }
	  }, {
	    key: 'ensureHighlightedItemIsVisible',
	    value: function ensureHighlightedItemIsVisible() {
	      var highlightedItem = this.highlightedItem;
	
	
	      if (!highlightedItem) {
	        return;
	      }
	
	      var itemsContainer = this.itemsContainer;
	
	      var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
	
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area
	
	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.theme;
	      var _props3 = this.props,
	          id = _props3.id,
	          multiSection = _props3.multiSection,
	          renderInputComponent = _props3.renderInputComponent,
	          renderItemsContainer = _props3.renderItemsContainer,
	          highlightedSectionIndex = _props3.highlightedSectionIndex,
	          highlightedItemIndex = _props3.highlightedItemIndex;
	      var isInputFocused = this.state.isInputFocused;
	
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
	      var containerProps = theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen');
	      var itemsContainerId = 'react-autowhatever-' + id;
	      var inputComponent = renderInputComponent(_extends({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        role: 'combobox',
	        'aria-autocomplete': 'list',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen,
	        'aria-haspopup': isOpen,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme('react-autowhatever-' + id + '-input', 'input', isOpen && 'inputOpen', isInputFocused && 'inputFocused'), this.props.inputProps, {
	        onFocus: this.onFocus,
	        onBlur: this.onBlur,
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer({
	        containerProps: _extends({
	          id: itemsContainerId
	        }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer', isOpen && 'itemsContainerOpen'), {
	          ref: this.storeItemsContainerReference
	        }),
	        children: renderedItems
	      });
	
	      return _react2.default.createElement(
	        'div',
	        containerProps,
	        inputComponent,
	        itemsContainer
	      );
	    }
	  }]);
	
	  return Autowhatever;
	}(_react.Component);
	
	Autowhatever.propTypes = {
	  id: _propTypes2.default.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _propTypes2.default.bool, // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _propTypes2.default.func, // When specified, it is used to render the input element.
	  renderItemsContainer: _propTypes2.default.func, // Renders the items container.
	  items: _propTypes2.default.array.isRequired, // Array of items or sections to render.
	  renderItem: _propTypes2.default.func, // This function renders a single item.
	  renderItemData: _propTypes2.default.object, // Arbitrary data that will be passed to renderItem()
	  renderSectionTitle: _propTypes2.default.func, // This function gets a section and renders its title.
	  getSectionItems: _propTypes2.default.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  inputProps: _propTypes2.default.object, // Arbitrary input props
	  itemProps: _propTypes2.default.oneOfType([// Arbitrary item props
	  _propTypes2.default.object, _propTypes2.default.func]),
	  highlightedSectionIndex: _propTypes2.default.number, // Section index of the highlighted item
	  highlightedItemIndex: _propTypes2.default.number, // Highlighted item index (within a section)
	  theme: _propTypes2.default.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
	  _propTypes2.default.object, _propTypes2.default.array])
	};
	Autowhatever.defaultProps = {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  highlightedSectionIndex: null,
	  highlightedItemIndex: null,
	  theme: defaultTheme
	};
	exports.default = Autowhatever;

/***/ },
/* 2644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compareObjects = __webpack_require__(483);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_Component) {
	  _inherits(Item, _Component);
	
	  function Item() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Item);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [this].concat(args))), _this), _this.storeItemReference = function (item) {
	      if (item !== null) {
	        _this.item = item;
	      }
	    }, _this.onMouseEnter = function (event) {
	      var _this$props = _this.props,
	          sectionIndex = _this$props.sectionIndex,
	          itemIndex = _this$props.itemIndex;
	
	
	      _this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _this.onMouseLeave = function (event) {
	      var _this$props2 = _this.props,
	          sectionIndex = _this$props2.sectionIndex,
	          itemIndex = _this$props2.itemIndex;
	
	
	      _this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _this.onMouseDown = function (event) {
	      var _this$props3 = _this.props,
	          sectionIndex = _this$props3.sectionIndex,
	          itemIndex = _this$props3.itemIndex;
	
	
	      _this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _this.onClick = function (event) {
	      var _this$props4 = _this.props,
	          sectionIndex = _this$props4.sectionIndex,
	          itemIndex = _this$props4.itemIndex;
	
	
	      _this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Item, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          isHighlighted = _props.isHighlighted,
	          item = _props.item,
	          renderItem = _props.renderItem,
	          renderItemData = _props.renderItemData,
	          restProps = _objectWithoutProperties(_props, ['isHighlighted', 'item', 'renderItem', 'renderItemData']);
	
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
	        renderItem(item, _extends({ isHighlighted: isHighlighted }, renderItemData))
	      );
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	Item.propTypes = {
	  sectionIndex: _propTypes2.default.number,
	  isHighlighted: _propTypes2.default.bool.isRequired,
	  itemIndex: _propTypes2.default.number.isRequired,
	  item: _propTypes2.default.any.isRequired,
	  renderItem: _propTypes2.default.func.isRequired,
	  renderItemData: _propTypes2.default.object.isRequired,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	};
	exports.default = Item;

/***/ },
/* 2645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Item = __webpack_require__(2644);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _compareObjects = __webpack_require__(483);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemsList = function (_Component) {
	  _inherits(ItemsList, _Component);
	
	  function ItemsList() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ItemsList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [this].concat(args))), _this), _this.storeHighlightedItemReference = function (highlightedItem) {
	      _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ItemsList, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          items = _props.items,
	          itemProps = _props.itemProps,
	          renderItem = _props.renderItem,
	          renderItemData = _props.renderItemData,
	          sectionIndex = _props.sectionIndex,
	          highlightedItemIndex = _props.highlightedItemIndex,
	          getItemId = _props.getItemId,
	          theme = _props.theme,
	          keyPrefix = _props.keyPrefix;
	
	      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
	      var isItemPropsFunction = typeof itemProps === 'function';
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
	        items.map(function (item, itemIndex) {
	          var isFirst = itemIndex === 0;
	          var isHighlighted = itemIndex === highlightedItemIndex;
	          var itemKey = sectionPrefix + 'item-' + itemIndex;
	          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
	          var allItemProps = _extends({
	            id: getItemId(sectionIndex, itemIndex)
	          }, theme(itemKey, 'item', isFirst && 'itemFirst', isHighlighted && 'itemHighlighted'), itemPropsObj);
	
	          if (isHighlighted) {
	            allItemProps.ref = _this2.storeHighlightedItemReference;
	          }
	
	          // `key` is provided by theme()
	          /* eslint-disable react/jsx-key */
	          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
	            sectionIndex: sectionIndex,
	            isHighlighted: isHighlighted,
	            itemIndex: itemIndex,
	            item: item,
	            renderItem: renderItem,
	            renderItemData: renderItemData
	          }));
	          /* eslint-enable react/jsx-key */
	        })
	      );
	    }
	  }]);
	
	  return ItemsList;
	}(_react.Component);
	
	ItemsList.propTypes = {
	  items: _propTypes2.default.array.isRequired,
	  itemProps: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
	  renderItem: _propTypes2.default.func.isRequired,
	  renderItemData: _propTypes2.default.object.isRequired,
	  sectionIndex: _propTypes2.default.number,
	  highlightedItemIndex: _propTypes2.default.number,
	  onHighlightedItemChange: _propTypes2.default.func.isRequired,
	  getItemId: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.func.isRequired,
	  keyPrefix: _propTypes2.default.string.isRequired
	};
	ItemsList.defaultProps = {
	  sectionIndex: null
	};
	exports.default = ItemsList;

/***/ },
/* 2646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compareObjects = __webpack_require__(483);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionTitle = function (_Component) {
	  _inherits(SectionTitle, _Component);
	
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	
	    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
	  }
	
	  _createClass(SectionTitle, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          section = _props.section,
	          renderSectionTitle = _props.renderSectionTitle,
	          theme = _props.theme,
	          sectionKeyPrefix = _props.sectionKeyPrefix;
	
	      var sectionTitle = renderSectionTitle(section);
	
	      if (!sectionTitle) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
	        sectionTitle
	      );
	    }
	  }]);
	
	  return SectionTitle;
	}(_react.Component);
	
	SectionTitle.propTypes = {
	  section: _propTypes2.default.any.isRequired,
	  renderSectionTitle: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.func.isRequired,
	  sectionKeyPrefix: _propTypes2.default.string.isRequired
	};
	exports.default = SectionTitle;

/***/ },
/* 2647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2643).default;

/***/ },
/* 2648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PanelGroup = __webpack_require__(1214);
	
	var _PanelGroup2 = _interopRequireDefault(_PanelGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Accordion = function (_React$Component) {
	  (0, _inherits3.default)(Accordion, _React$Component);
	
	  function Accordion() {
	    (0, _classCallCheck3.default)(this, Accordion);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Accordion.prototype.render = function render() {
	    return _react2.default.createElement(
	      _PanelGroup2.default,
	      (0, _extends3.default)({}, this.props, { accordion: true }),
	      this.props.children
	    );
	  };
	
	  return Accordion;
	}(_react2.default.Component);
	
	exports.default = Accordion;
	module.exports = exports['default'];

/***/ },
/* 2649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(175);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	var _CloseButton = __webpack_require__(485);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onDismiss: _propTypes2.default.func,
	  closeLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  closeLabel: 'Close alert'
	};
	
	var Alert = function (_React$Component) {
	  (0, _inherits3.default)(Alert, _React$Component);
	
	  function Alert() {
	    (0, _classCallCheck3.default)(this, Alert);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Alert.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        onDismiss = _props.onDismiss,
	        closeLabel = _props.closeLabel,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onDismiss', 'closeLabel', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var dismissable = !!onDismiss;
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dismissable')] = dismissable, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'alert',
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      dismissable && _react2.default.createElement(_CloseButton2.default, {
	        onClick: onDismiss,
	        label: closeLabel
	      }),
	      children
	    );
	  };
	
	  return Alert;
	}(_react2.default.Component);
	
	Alert.propTypes = propTypes;
	Alert.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), _StyleConfig.State.INFO, (0, _bootstrapUtils.bsClass)('alert', Alert));
	module.exports = exports['default'];

/***/ },
/* 2650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `pullRight` doesn't belong here. There's no special handling here.
	
	var propTypes = {
	  pullRight: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  pullRight: false
	};
	
	var Badge = function (_React$Component) {
	  (0, _inherits3.default)(Badge, _React$Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Badge.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Badge.prototype.render = function render() {
	    var _props = this.props,
	        pullRight = _props.pullRight,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['pullRight', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'pull-right': pullRight,
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Badge;
	}(_react2.default.Component);
	
	Badge.propTypes = propTypes;
	Badge.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('badge', Badge);
	module.exports = exports['default'];

/***/ },
/* 2651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BreadcrumbItem = __webpack_require__(1199);
	
	var _BreadcrumbItem2 = _interopRequireDefault(_BreadcrumbItem);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Breadcrumb = function (_React$Component) {
	  (0, _inherits3.default)(Breadcrumb, _React$Component);
	
	  function Breadcrumb() {
	    (0, _classCallCheck3.default)(this, Breadcrumb);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Breadcrumb.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ol', (0, _extends3.default)({}, elementProps, {
	      role: 'navigation',
	      'aria-label': 'breadcrumbs',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Breadcrumb;
	}(_react2.default.Component);
	
	Breadcrumb.Item = _BreadcrumbItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('breadcrumb', Breadcrumb);
	module.exports = exports['default'];

/***/ },
/* 2652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ButtonToolbar = function (_React$Component) {
	  (0, _inherits3.default)(ButtonToolbar, _React$Component);
	
	  function ButtonToolbar() {
	    (0, _classCallCheck3.default)(this, ButtonToolbar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ButtonToolbar.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      role: 'toolbar',
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ButtonToolbar;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('btn-toolbar', ButtonToolbar);
	module.exports = exports['default'];

/***/ },
/* 2653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CarouselCaption = __webpack_require__(2654);
	
	var _CarouselCaption2 = _interopRequireDefault(_CarouselCaption);
	
	var _CarouselItem = __webpack_require__(1200);
	
	var _CarouselItem2 = _interopRequireDefault(_CarouselItem);
	
	var _Glyphicon = __webpack_require__(487);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: `slide` should be `animate`.
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  slide: _propTypes2.default.bool,
	  indicators: _propTypes2.default.bool,
	  /**
	   * The amount of time to delay between automatically cycling an item.
	   * If `null`, carousel will not automatically cycle.
	   */
	  interval: _propTypes2.default.number,
	  controls: _propTypes2.default.bool,
	  pauseOnHover: _propTypes2.default.bool,
	  wrap: _propTypes2.default.bool,
	  /**
	   * Callback fired when the active item changes.
	   *
	   * ```js
	   * (eventKey: any) => any | (eventKey: any, event: Object) => any
	   * ```
	   *
	   * If this callback takes two or more arguments, the second argument will
	   * be a persisted event object with `direction` set to the direction of the
	   * transition.
	   */
	  onSelect: _propTypes2.default.func,
	  onSlideEnd: _propTypes2.default.func,
	  activeIndex: _propTypes2.default.number,
	  defaultActiveIndex: _propTypes2.default.number,
	  direction: _propTypes2.default.oneOf(['prev', 'next']),
	  prevIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the previous element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  prevLabel: _propTypes2.default.string,
	  nextIcon: _propTypes2.default.node,
	  /**
	   * Label shown to screen readers only, can be used to show the next element
	   * in the carousel.
	   * Set to null to deactivate.
	   */
	  nextLabel: _propTypes2.default.string
	};
	
	var defaultProps = {
	  slide: true,
	  interval: 5000,
	  pauseOnHover: true,
	  wrap: true,
	  indicators: true,
	  controls: true,
	  prevIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-left' }),
	  prevLabel: 'Previous',
	  nextIcon: _react2.default.createElement(_Glyphicon2.default, { glyph: 'chevron-right' }),
	  nextLabel: 'Next'
	};
	
	var Carousel = function (_React$Component) {
	  (0, _inherits3.default)(Carousel, _React$Component);
	
	  function Carousel(props, context) {
	    (0, _classCallCheck3.default)(this, Carousel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handlePrev = _this.handlePrev.bind(_this);
	    _this.handleNext = _this.handleNext.bind(_this);
	    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);
	
	    var defaultActiveIndex = props.defaultActiveIndex;
	
	
	    _this.state = {
	      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
	      previousActiveIndex: null,
	      direction: null
	    };
	
	    _this.isUnmounted = false;
	    return _this;
	  }
	
	  Carousel.prototype.componentDidMount = function componentDidMount() {
	    this.waitForNext();
	  };
	
	  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var activeIndex = this.getActiveIndex();
	
	    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
	      clearTimeout(this.timeout);
	
	      this.setState({
	        previousActiveIndex: activeIndex,
	        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
	      });
	    }
	
	    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
	      this.setState({
	        activeIndex: 0,
	        previousActiveIndex: null,
	        direction: null
	      });
	    }
	  };
	
	  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.timeout);
	    this.isUnmounted = true;
	  };
	
	  Carousel.prototype.getActiveIndex = function getActiveIndex() {
	    var activeIndexProp = this.props.activeIndex;
	    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
	  };
	
	  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
	    if (prevIndex === index) {
	      return null;
	    }
	
	    return prevIndex > index ? 'prev' : 'next';
	  };
	
	  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
	    var _this2 = this;
	
	    this.setState({
	      previousActiveIndex: null,
	      direction: null
	    }, function () {
	      _this2.waitForNext();
	
	      if (_this2.props.onSlideEnd) {
	        _this2.props.onSlideEnd();
	      }
	    });
	  };
	
	  Carousel.prototype.handleMouseOut = function handleMouseOut() {
	    if (this.isPaused) {
	      this.play();
	    }
	  };
	
	  Carousel.prototype.handleMouseOver = function handleMouseOver() {
	    if (this.props.pauseOnHover) {
	      this.pause();
	    }
	  };
	
	  Carousel.prototype.handleNext = function handleNext(e) {
	    var index = this.getActiveIndex() + 1;
	    var count = _ValidComponentChildren2.default.count(this.props.children);
	
	    if (index > count - 1) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = 0;
	    }
	
	    this.select(index, e, 'next');
	  };
	
	  Carousel.prototype.handlePrev = function handlePrev(e) {
	    var index = this.getActiveIndex() - 1;
	
	    if (index < 0) {
	      if (!this.props.wrap) {
	        return;
	      }
	      index = _ValidComponentChildren2.default.count(this.props.children) - 1;
	    }
	
	    this.select(index, e, 'prev');
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.pause = function pause() {
	    this.isPaused = true;
	    clearTimeout(this.timeout);
	  };
	
	  // This might be a public API.
	
	
	  Carousel.prototype.play = function play() {
	    this.isPaused = false;
	    this.waitForNext();
	  };
	
	  Carousel.prototype.select = function select(index, e, direction) {
	    clearTimeout(this.timeout);
	
	    // TODO: Is this necessary? Seems like the only risk is if the component
	    // unmounts while handleItemAnimateOutEnd fires.
	    if (this.isUnmounted) {
	      return;
	    }
	
	    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
	    direction = direction || this.getDirection(previousActiveIndex, index);
	
	    var onSelect = this.props.onSelect;
	
	
	    if (onSelect) {
	      if (onSelect.length > 1) {
	        // React SyntheticEvents are pooled, so we need to remove this event
	        // from the pool to add a custom property. To avoid unnecessarily
	        // removing objects from the pool, only do this when the listener
	        // actually wants the event.
	        if (e) {
	          e.persist();
	          e.direction = direction;
	        } else {
	          e = { direction: direction };
	        }
	
	        onSelect(index, e);
	      } else {
	        onSelect(index);
	      }
	    }
	
	    if (this.props.activeIndex == null && index !== previousActiveIndex) {
	      if (this.state.previousActiveIndex != null) {
	        // If currently animating don't activate the new index.
	        // TODO: look into queueing this canceled call and
	        // animating after the current animation has ended.
	        return;
	      }
	
	      this.setState({
	        activeIndex: index,
	        previousActiveIndex: previousActiveIndex,
	        direction: direction
	      });
	    }
	  };
	
	  Carousel.prototype.waitForNext = function waitForNext() {
	    var _props = this.props,
	        slide = _props.slide,
	        interval = _props.interval,
	        activeIndexProp = _props.activeIndex;
	
	
	    if (!this.isPaused && slide && interval && activeIndexProp == null) {
	      this.timeout = setTimeout(this.handleNext, interval);
	    }
	  };
	
	  Carousel.prototype.renderControls = function renderControls(properties) {
	    var wrap = properties.wrap,
	        children = properties.children,
	        activeIndex = properties.activeIndex,
	        prevIcon = properties.prevIcon,
	        nextIcon = properties.nextIcon,
	        bsProps = properties.bsProps,
	        prevLabel = properties.prevLabel,
	        nextLabel = properties.nextLabel;
	
	    var controlClassName = (0, _bootstrapUtils.prefix)(bsProps, 'control');
	    var count = _ValidComponentChildren2.default.count(children);
	
	    return [(wrap || activeIndex !== 0) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'prev',
	        className: (0, _classnames2.default)(controlClassName, 'left'),
	        onClick: this.handlePrev
	      },
	      prevIcon,
	      prevLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        prevLabel
	      )
	    ), (wrap || activeIndex !== count - 1) && _react2.default.createElement(
	      _SafeAnchor2.default,
	      {
	        key: 'next',
	        className: (0, _classnames2.default)(controlClassName, 'right'),
	        onClick: this.handleNext
	      },
	      nextIcon,
	      nextLabel && _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        nextLabel
	      )
	    )];
	  };
	
	  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
	    var _this3 = this;
	
	    var indicators = [];
	
	    _ValidComponentChildren2.default.forEach(children, function (child, index) {
	      indicators.push(_react2.default.createElement('li', {
	        key: index,
	        className: index === activeIndex ? 'active' : null,
	        onClick: function onClick(e) {
	          return _this3.select(index, e);
	        }
	      }),
	
	      // Force whitespace between indicator elements. Bootstrap requires
	      // this for correct spacing of elements.
	      ' ');
	    });
	
	    return _react2.default.createElement(
	      'ol',
	      { className: (0, _bootstrapUtils.prefix)(bsProps, 'indicators') },
	      indicators
	    );
	  };
	
	  Carousel.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props2 = this.props,
	        slide = _props2.slide,
	        indicators = _props2.indicators,
	        controls = _props2.controls,
	        wrap = _props2.wrap,
	        prevIcon = _props2.prevIcon,
	        prevLabel = _props2.prevLabel,
	        nextIcon = _props2.nextIcon,
	        nextLabel = _props2.nextLabel,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);
	    var _state = this.state,
	        previousActiveIndex = _state.previousActiveIndex,
	        direction = _state.direction;
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
	    'defaultActiveIndex', 'direction']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var activeIndex = this.getActiveIndex();
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      slide: slide
	    });
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut
	      }),
	      indicators && this.renderIndicators(children, activeIndex, bsProps),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        _ValidComponentChildren2.default.map(children, function (child, index) {
	          var active = index === activeIndex;
	          var previousActive = slide && index === previousActiveIndex;
	
	          return (0, _react.cloneElement)(child, {
	            active: active,
	            index: index,
	            animateOut: previousActive,
	            animateIn: active && previousActiveIndex != null && slide,
	            direction: direction,
	            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
	          });
	        })
	      ),
	      controls && this.renderControls({
	        wrap: wrap,
	        children: children,
	        activeIndex: activeIndex,
	        prevIcon: prevIcon,
	        prevLabel: prevLabel,
	        nextIcon: nextIcon,
	        nextLabel: nextLabel,
	        bsProps: bsProps
	      })
	    );
	  };
	
	  return Carousel;
	}(_react2.default.Component);
	
	Carousel.propTypes = propTypes;
	Carousel.defaultProps = defaultProps;
	
	Carousel.Caption = _CarouselCaption2.default;
	Carousel.Item = _CarouselItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel', Carousel);
	module.exports = exports['default'];

/***/ },
/* 2654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var CarouselCaption = function (_React$Component) {
	  (0, _inherits3.default)(CarouselCaption, _React$Component);
	
	  function CarouselCaption() {
	    (0, _classCallCheck3.default)(this, CarouselCaption);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  CarouselCaption.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return CarouselCaption;
	}(_react2.default.Component);
	
	CarouselCaption.propTypes = propTypes;
	CarouselCaption.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('carousel-caption', CarouselCaption);
	module.exports = exports['default'];

/***/ },
/* 2655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Checkbox inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Checkbox = function (_React$Component) {
	  (0, _inherits3.default)(Checkbox, _React$Component);
	
	  function Checkbox() {
	    (0, _classCallCheck3.default)(this, Checkbox);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Checkbox.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'checkbox',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Checkbox;
	}(_react2.default.Component);
	
	Checkbox.propTypes = propTypes;
	Checkbox.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('checkbox', Checkbox);
	module.exports = exports['default'];

/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _capitalize = __webpack_require__(1217);
	
	var _capitalize2 = _interopRequireDefault(_capitalize);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * Apply clearfix
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `visible-xs-block`
	   */
	  visibleXsBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Small devices Tablets
	   *
	   * adds class `visible-sm-block`
	   */
	  visibleSmBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `visible-md-block`
	   */
	  visibleMdBlock: _propTypes2.default.bool,
	  /**
	   * Apply clearfix
	   *
	   * on Large devices Desktops
	   *
	   * adds class `visible-lg-block`
	   */
	  visibleLgBlock: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Clearfix = function (_React$Component) {
	  (0, _inherits3.default)(Clearfix, _React$Component);
	
	  function Clearfix() {
	    (0, _classCallCheck3.default)(this, Clearfix);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Clearfix.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      var propName = 'visible' + (0, _capitalize2.default)(size) + 'Block';
	      if (elementProps[propName]) {
	        classes['visible-' + size + '-block'] = true;
	      }
	
	      delete elementProps[propName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Clearfix;
	}(_react2.default.Component);
	
	Clearfix.propTypes = propTypes;
	Clearfix.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('clearfix', Clearfix);
	module.exports = exports['default'];

/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	
	  /**
	   * The number of columns you wish to span
	   *
	   * for Extra small devices Phones (<768px)
	   *
	   * class-prefix `col-xs-`
	   */
	  xs: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Small devices Tablets (≥768px)
	   *
	   * class-prefix `col-sm-`
	   */
	  sm: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Medium devices Desktops (≥992px)
	   *
	   * class-prefix `col-md-`
	   */
	  md: _propTypes2.default.number,
	  /**
	   * The number of columns you wish to span
	   *
	   * for Large devices Desktops (≥1200px)
	   *
	   * class-prefix `col-lg-`
	   */
	  lg: _propTypes2.default.number,
	  /**
	   * Hide column
	   *
	   * on Extra small devices Phones
	   *
	   * adds class `hidden-xs`
	   */
	  xsHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Small devices Tablets
	   *
	   * adds class `hidden-sm`
	   */
	  smHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Medium devices Desktops
	   *
	   * adds class `hidden-md`
	   */
	  mdHidden: _propTypes2.default.bool,
	  /**
	   * Hide column
	   *
	   * on Large devices Desktops
	   *
	   * adds class `hidden-lg`
	   */
	  lgHidden: _propTypes2.default.bool,
	  /**
	   * Move columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-offset-`
	   */
	  xsOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-offset-`
	   */
	  smOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-offset-`
	   */
	  mdOffset: _propTypes2.default.number,
	  /**
	   * Move columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-offset-`
	   */
	  lgOffset: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-push-`
	   */
	  xsPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-push-`
	   */
	  smPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-push-`
	   */
	  mdPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the right
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-push-`
	   */
	  lgPush: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Extra small devices Phones
	   *
	   * class-prefix `col-xs-pull-`
	   */
	  xsPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Small devices Tablets
	   *
	   * class-prefix `col-sm-pull-`
	   */
	  smPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Medium devices Desktops
	   *
	   * class-prefix `col-md-pull-`
	   */
	  mdPull: _propTypes2.default.number,
	  /**
	   * Change the order of grid columns to the left
	   *
	   * for Large devices Desktops
	   *
	   * class-prefix `col-lg-pull-`
	   */
	  lgPull: _propTypes2.default.number
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Col = function (_React$Component) {
	  (0, _inherits3.default)(Col, _React$Component);
	
	  function Col() {
	    (0, _classCallCheck3.default)(this, Col);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Col.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	
	    _StyleConfig.DEVICE_SIZES.forEach(function (size) {
	      function popProp(propSuffix, modifier) {
	        var propName = '' + size + propSuffix;
	        var propValue = elementProps[propName];
	
	        if (propValue != null) {
	          classes.push((0, _bootstrapUtils.prefix)(bsProps, '' + size + modifier + '-' + propValue));
	        }
	
	        delete elementProps[propName];
	      }
	
	      popProp('', '');
	      popProp('Offset', '-offset');
	      popProp('Push', '-push');
	      popProp('Pull', '-pull');
	
	      var hiddenPropName = size + 'Hidden';
	      if (elementProps[hiddenPropName]) {
	        classes.push('hidden-' + size);
	      }
	      delete elementProps[hiddenPropName];
	    });
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Col;
	}(_react2.default.Component);
	
	Col.propTypes = propTypes;
	Col.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('col', Col);
	module.exports = exports['default'];

/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  htmlFor: _propTypes2.default.string,
	  srOnly: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  srOnly: false
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var ControlLabel = function (_React$Component) {
	  (0, _inherits3.default)(ControlLabel, _React$Component);
	
	  function ControlLabel() {
	    (0, _classCallCheck3.default)(this, ControlLabel);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ControlLabel.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        _props$htmlFor = _props.htmlFor,
	        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
	        srOnly = _props.srOnly,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['htmlFor', 'srOnly', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'sr-only': srOnly
	    });
	
	    return _react2.default.createElement('label', (0, _extends3.default)({}, elementProps, {
	      htmlFor: htmlFor,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return ControlLabel;
	}(_react2.default.Component);
	
	ControlLabel.propTypes = propTypes;
	ControlLabel.defaultProps = defaultProps;
	ControlLabel.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('control-label', ControlLabel);
	module.exports = exports['default'];

/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(331);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(334);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var DropdownButton = function (_React$Component) {
	  (0, _inherits3.default)(DropdownButton, _React$Component);
	
	  function DropdownButton() {
	    (0, _classCallCheck3.default)(this, DropdownButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  DropdownButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, {
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return DropdownButton;
	}(_react2.default.Component);
	
	DropdownButton.propTypes = propTypes;
	
	exports.default = DropdownButton;
	module.exports = exports['default'];

/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _from = __webpack_require__(753);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _keycode = __webpack_require__(446);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _RootCloseWrapper = __webpack_require__(1247);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  open: _propTypes2.default.bool,
	  pullRight: _propTypes2.default.bool,
	  onClose: _propTypes2.default.func,
	  labelledBy: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onSelect: _propTypes2.default.func,
	  rootCloseEvent: _propTypes2.default.oneOf(['click', 'mousedown'])
	};
	
	var defaultProps = {
	  bsRole: 'menu',
	  pullRight: false
	};
	
	var DropdownMenu = function (_React$Component) {
	  (0, _inherits3.default)(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    (0, _classCallCheck3.default)(this, DropdownMenu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    _this.handleRootClose = _this.handleRootClose.bind(_this);
	    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
	    return _this;
	  }
	
	  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
	    var node = _reactDom2.default.findDOMNode(this);
	    if (!node) {
	      return [];
	    }
	
	    return (0, _from2.default)(node.querySelectorAll('[tabIndex="-1"]'));
	  };
	
	  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
	    var items = this.getFocusableMenuItems();
	    var activeIndex = items.indexOf(document.activeElement);
	
	    return { items: items, activeIndex: activeIndex };
	  };
	
	  DropdownMenu.prototype.focusNext = function focusNext() {
	    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd.items,
	        activeIndex = _getItemsAndActiveInd.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
	    items[nextIndex].focus();
	  };
	
	  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
	    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
	        items = _getItemsAndActiveInd2.items,
	        activeIndex = _getItemsAndActiveInd2.activeIndex;
	
	    if (items.length === 0) {
	      return;
	    }
	
	    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
	    items[prevIndex].focus();
	  };
	
	  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
	    switch (event.keyCode) {
	      case _keycode2.default.codes.down:
	        this.focusNext();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.up:
	        this.focusPrevious();
	        event.preventDefault();
	        break;
	      case _keycode2.default.codes.esc:
	      case _keycode2.default.codes.tab:
	        this.props.onClose(event, { source: 'keydown' });
	        break;
	      default:
	    }
	  };
	
	  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
	    this.props.onClose(event, { source: 'rootClose' });
	  };
	
	  DropdownMenu.prototype.render = function render() {
	    var _extends2,
	        _this2 = this;
	
	    var _props = this.props,
	        open = _props.open,
	        pullRight = _props.pullRight,
	        labelledBy = _props.labelledBy,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        rootCloseEvent = _props.rootCloseEvent,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['onClose']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'right')] = pullRight, _extends2));
	
	    return _react2.default.createElement(
	      _RootCloseWrapper2.default,
	      {
	        disabled: !open,
	        onRootClose: this.handleRootClose,
	        event: rootCloseEvent
	      },
	      _react2.default.createElement(
	        'ul',
	        (0, _extends4.default)({}, elementProps, {
	          role: 'menu',
	          className: (0, _classnames2.default)(className, classes),
	          'aria-labelledby': labelledBy
	        }),
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            onKeyDown: (0, _createChainedFunction2.default)(child.props.onKeyDown, _this2.handleKeyDown),
	            onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	          });
	        })
	      )
	    );
	  };
	
	  return DropdownMenu;
	}(_react2.default.Component);
	
	DropdownMenu.propTypes = propTypes;
	DropdownMenu.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown-menu', DropdownMenu);
	module.exports = exports['default'];

/***/ },
/* 2661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  horizontal: _propTypes2.default.bool,
	  inline: _propTypes2.default.bool,
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  horizontal: false,
	  inline: false,
	  componentClass: 'form'
	};
	
	var Form = function (_React$Component) {
	  (0, _inherits3.default)(Form, _React$Component);
	
	  function Form() {
	    (0, _classCallCheck3.default)(this, Form);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Form.prototype.render = function render() {
	    var _props = this.props,
	        horizontal = _props.horizontal,
	        inline = _props.inline,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['horizontal', 'inline', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = [];
	    if (horizontal) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'horizontal'));
	    }
	    if (inline) {
	      classes.push((0, _bootstrapUtils.prefix)(bsProps, 'inline'));
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Form;
	}(_react2.default.Component);
	
	Form.propTypes = propTypes;
	Form.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form', Form);
	module.exports = exports['default'];

/***/ },
/* 2662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FormControlFeedback = __webpack_require__(2663);
	
	var _FormControlFeedback2 = _interopRequireDefault(_FormControlFeedback);
	
	var _FormControlStatic = __webpack_require__(2664);
	
	var _FormControlStatic2 = _interopRequireDefault(_FormControlStatic);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default,
	  /**
	   * Only relevant if `componentClass` is `'input'`.
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <FormControl inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	};
	
	var defaultProps = {
	  componentClass: 'input'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControl = function (_React$Component) {
	  (0, _inherits3.default)(FormControl, _React$Component);
	
	  function FormControl() {
	    (0, _classCallCheck3.default)(this, FormControl);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControl.prototype.render = function render() {
	    var formGroup = this.context.$bs_formGroup;
	    var controlId = formGroup && formGroup.controlId;
	
	    var _props = this.props,
	        Component = _props.componentClass,
	        type = _props.type,
	        _props$id = _props.id,
	        id = _props$id === undefined ? controlId : _props$id,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        bsSize = _props.bsSize,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;
	
	    // input[type="file"] should not have .form-control.
	    var classes = void 0;
	    if (type !== 'file') {
	      classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	    }
	
	    // If user provides a size, make sure to append it to classes as input-
	    // e.g. if bsSize is small, it will append input-sm
	    if (bsSize) {
	      var size = _StyleConfig.SIZE_MAP[bsSize] || bsSize;
	      classes[(0, _bootstrapUtils.prefix)({ bsClass: 'input' }, size)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      type: type,
	      id: id,
	      ref: inputRef,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControl;
	}(_react2.default.Component);
	
	FormControl.propTypes = propTypes;
	FormControl.defaultProps = defaultProps;
	FormControl.contextTypes = contextTypes;
	
	FormControl.Feedback = _FormControlFeedback2.default;
	FormControl.Static = _FormControlStatic2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.SMALL, _StyleConfig.Size.LARGE], FormControl));
	module.exports = exports['default'];

/***/ },
/* 2663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Glyphicon = __webpack_require__(487);
	
	var _Glyphicon2 = _interopRequireDefault(_Glyphicon);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultProps = {
	  bsRole: 'feedback'
	};
	
	var contextTypes = {
	  $bs_formGroup: _propTypes2.default.object
	};
	
	var FormControlFeedback = function (_React$Component) {
	  (0, _inherits3.default)(FormControlFeedback, _React$Component);
	
	  function FormControlFeedback() {
	    (0, _classCallCheck3.default)(this, FormControlFeedback);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
	    switch (validationState) {
	      case 'success':
	        return 'ok';
	      case 'warning':
	        return 'warning-sign';
	      case 'error':
	        return 'remove';
	      default:
	        return null;
	    }
	  };
	
	  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
	    var glyph = this.getGlyph(formGroup && formGroup.validationState);
	    if (!glyph) {
	      return null;
	    }
	
	    return _react2.default.createElement(_Glyphicon2.default, (0, _extends3.default)({}, elementProps, {
	      glyph: glyph,
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  FormControlFeedback.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (!children) {
	      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
	    }
	
	    var child = _react2.default.Children.only(children);
	    return _react2.default.cloneElement(child, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(child.props.className, className, classes)
	    }));
	  };
	
	  return FormControlFeedback;
	}(_react2.default.Component);
	
	FormControlFeedback.defaultProps = defaultProps;
	FormControlFeedback.contextTypes = contextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-feedback', FormControlFeedback);
	module.exports = exports['default'];

/***/ },
/* 2664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'p'
	};
	
	var FormControlStatic = function (_React$Component) {
	  (0, _inherits3.default)(FormControlStatic, _React$Component);
	
	  function FormControlStatic() {
	    (0, _classCallCheck3.default)(this, FormControlStatic);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormControlStatic.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return FormControlStatic;
	}(_react2.default.Component);
	
	FormControlStatic.propTypes = propTypes;
	FormControlStatic.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-control-static', FormControlStatic);
	module.exports = exports['default'];

/***/ },
/* 2665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
	   */
	  controlId: _propTypes2.default.string,
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null])
	};
	
	var childContextTypes = {
	  $bs_formGroup: _propTypes2.default.object.isRequired
	};
	
	var FormGroup = function (_React$Component) {
	  (0, _inherits3.default)(FormGroup, _React$Component);
	
	  function FormGroup() {
	    (0, _classCallCheck3.default)(this, FormGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  FormGroup.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        controlId = _props.controlId,
	        validationState = _props.validationState;
	
	
	    return {
	      $bs_formGroup: {
	        controlId: controlId,
	        validationState: validationState
	      }
	    };
	  };
	
	  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
	    var _this2 = this;
	
	    return _ValidComponentChildren2.default.some(children, function (child) {
	      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
	    });
	  };
	
	  FormGroup.prototype.render = function render() {
	    var _props2 = this.props,
	        validationState = _props2.validationState,
	        className = _props2.className,
	        children = _props2.children,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['validationState', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['controlId']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      'has-feedback': this.hasFeedback(children)
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return FormGroup;
	}(_react2.default.Component);
	
	FormGroup.propTypes = propTypes;
	FormGroup.childContextTypes = childContextTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('form-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], FormGroup));
	module.exports = exports['default'];

/***/ },
/* 2666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpBlock = function (_React$Component) {
	  (0, _inherits3.default)(HelpBlock, _React$Component);
	
	  function HelpBlock() {
	    (0, _classCallCheck3.default)(this, HelpBlock);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  HelpBlock.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return HelpBlock;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('help-block', HelpBlock);
	module.exports = exports['default'];

/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Sets image as responsive image
	   */
	  responsive: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as rounded
	   */
	  rounded: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as circle
	   */
	  circle: _propTypes2.default.bool,
	
	  /**
	   * Sets image shape as thumbnail
	   */
	  thumbnail: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  responsive: false,
	  rounded: false,
	  circle: false,
	  thumbnail: false
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image() {
	    (0, _classCallCheck3.default)(this, Image);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Image.prototype.render = function render() {
	    var _classes;
	
	    var _props = this.props,
	        responsive = _props.responsive,
	        rounded = _props.rounded,
	        circle = _props.circle,
	        thumbnail = _props.thumbnail,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (_classes = {}, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'responsive')] = responsive, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'rounded')] = rounded, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'circle')] = circle, _classes[(0, _bootstrapUtils.prefix)(bsProps, 'thumbnail')] = thumbnail, _classes);
	
	    return _react2.default.createElement('img', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.propTypes = propTypes;
	Image.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('img', Image);
	module.exports = exports['default'];

/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _InputGroupAddon = __webpack_require__(2669);
	
	var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);
	
	var _InputGroupButton = __webpack_require__(2670);
	
	var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroup = function (_React$Component) {
	  (0, _inherits3.default)(InputGroup, _React$Component);
	
	  function InputGroup() {
	    (0, _classCallCheck3.default)(this, InputGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroup.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroup;
	}(_react2.default.Component);
	
	InputGroup.Addon = _InputGroupAddon2.default;
	InputGroup.Button = _InputGroupButton2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], InputGroup));
	module.exports = exports['default'];

/***/ },
/* 2669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupAddon = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupAddon, _React$Component);
	
	  function InputGroupAddon() {
	    (0, _classCallCheck3.default)(this, InputGroupAddon);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupAddon.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupAddon;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-addon', InputGroupAddon);
	module.exports = exports['default'];

/***/ },
/* 2670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InputGroupButton = function (_React$Component) {
	  (0, _inherits3.default)(InputGroupButton, _React$Component);
	
	  function InputGroupButton() {
	    (0, _classCallCheck3.default)(this, InputGroupButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  InputGroupButton.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('span', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return InputGroupButton;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('input-group-btn', InputGroupButton);
	module.exports = exports['default'];

/***/ },
/* 2671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Jumbotron = function (_React$Component) {
	  (0, _inherits3.default)(Jumbotron, _React$Component);
	
	  function Jumbotron() {
	    (0, _classCallCheck3.default)(this, Jumbotron);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Jumbotron.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Jumbotron;
	}(_react2.default.Component);
	
	Jumbotron.propTypes = propTypes;
	Jumbotron.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('jumbotron', Jumbotron);
	module.exports = exports['default'];

/***/ },
/* 2672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(175);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Label = function (_React$Component) {
	  (0, _inherits3.default)(Label, _React$Component);
	
	  function Label() {
	    (0, _classCallCheck3.default)(this, Label);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Label.prototype.hasContent = function hasContent(children) {
	    var result = false;
	
	    _react2.default.Children.forEach(children, function (child) {
	      if (result) {
	        return;
	      }
	
	      if (child || child === 0) {
	        result = true;
	      }
	    });
	
	    return result;
	  };
	
	  Label.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	
	      // Hack for collapsing on IE8.
	      hidden: !this.hasContent(children)
	    });
	
	    return _react2.default.createElement(
	      'span',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      children
	    );
	  };
	
	  return Label;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('label', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Label));
	module.exports = exports['default'];

/***/ },
/* 2673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _ListGroupItem = __webpack_require__(1203);
	
	var _ListGroupItem2 = _interopRequireDefault(_ListGroupItem);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * You can use a custom element type for this component.
	   *
	   * If not specified, it will be treated as `'li'` if every child is a
	   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
	   */
	  componentClass: _elementType2.default
	};
	
	function getDefaultComponent(children) {
	  if (!children) {
	    // FIXME: This is the old behavior. Is this right?
	    return 'div';
	  }
	
	  if (_ValidComponentChildren2.default.some(children, function (child) {
	    return child.type !== _ListGroupItem2.default || child.props.href || child.props.onClick;
	  })) {
	    return 'div';
	  }
	
	  return 'ul';
	}
	
	var ListGroup = function (_React$Component) {
	  (0, _inherits3.default)(ListGroup, _React$Component);
	
	  function ListGroup() {
	    (0, _classCallCheck3.default)(this, ListGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ListGroup.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        _props$componentClass = _props.componentClass,
	        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children', 'componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var useListItem = Component === 'ul' && _ValidComponentChildren2.default.every(children, function (child) {
	      return child.type === _ListGroupItem2.default;
	    });
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      useListItem ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { listItem: true });
	      }) : children
	    );
	  };
	
	  return ListGroup;
	}(_react2.default.Component);
	
	ListGroup.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('list-group', ListGroup);
	module.exports = exports['default'];

/***/ },
/* 2674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Media = __webpack_require__(333);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom']),
	
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var MediaBody = function (_React$Component) {
	  (0, _inherits3.default)(MediaBody, _React$Component);
	
	  function MediaBody() {
	    (0, _classCallCheck3.default)(this, MediaBody);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaBody.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaBody;
	}(_react2.default.Component);
	
	MediaBody.propTypes = propTypes;
	MediaBody.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-body', MediaBody);
	module.exports = exports['default'];

/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'h4'
	};
	
	var MediaHeading = function (_React$Component) {
	  (0, _inherits3.default)(MediaHeading, _React$Component);
	
	  function MediaHeading() {
	    (0, _classCallCheck3.default)(this, MediaHeading);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaHeading.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaHeading;
	}(_react2.default.Component);
	
	MediaHeading.propTypes = propTypes;
	MediaHeading.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-heading', MediaHeading);
	module.exports = exports['default'];

/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(333);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaLeft = function (_React$Component) {
	  (0, _inherits3.default)(MediaLeft, _React$Component);
	
	  function MediaLeft() {
	    (0, _classCallCheck3.default)(this, MediaLeft);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaLeft.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-left-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaLeft;
	}(_react2.default.Component);
	
	MediaLeft.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-left', MediaLeft);
	module.exports = exports['default'];

/***/ },
/* 2677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaList = function (_React$Component) {
	  (0, _inherits3.default)(MediaList, _React$Component);
	
	  function MediaList() {
	    (0, _classCallCheck3.default)(this, MediaList);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaList.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('ul', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaList;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-list', MediaList);
	module.exports = exports['default'];

/***/ },
/* 2678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MediaListItem = function (_React$Component) {
	  (0, _inherits3.default)(MediaListItem, _React$Component);
	
	  function MediaListItem() {
	    (0, _classCallCheck3.default)(this, MediaListItem);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaListItem.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaListItem;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('media', MediaListItem);
	module.exports = exports['default'];

/***/ },
/* 2679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Media = __webpack_require__(333);
	
	var _Media2 = _interopRequireDefault(_Media);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Align the media to the top, middle, or bottom of the media object.
	   */
	  align: _propTypes2.default.oneOf(['top', 'middle', 'bottom'])
	};
	
	var MediaRight = function (_React$Component) {
	  (0, _inherits3.default)(MediaRight, _React$Component);
	
	  function MediaRight() {
	    (0, _classCallCheck3.default)(this, MediaRight);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  MediaRight.prototype.render = function render() {
	    var _props = this.props,
	        align = _props.align,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['align', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    if (align) {
	      // The class is e.g. `media-top`, not `media-right-top`.
	      classes[(0, _bootstrapUtils.prefix)(_Media2.default.defaultProps, align)] = true;
	    }
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return MediaRight;
	}(_react2.default.Component);
	
	MediaRight.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('media-right', MediaRight);
	module.exports = exports['default'];

/***/ },
/* 2680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _all = __webpack_require__(322);
	
	var _all2 = _interopRequireDefault(_all);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Highlight the menu item as active.
	   */
	  active: _propTypes2.default.bool,
	
	  /**
	   * Disable the menu item, making it unselectable.
	   */
	  disabled: _propTypes2.default.bool,
	
	  /**
	   * Styles the menu item as a horizontal rule, providing visual separation between
	   * groups of menu items.
	   */
	  divider: (0, _all2.default)(_propTypes2.default.bool, function (_ref) {
	    var divider = _ref.divider,
	        children = _ref.children;
	    return divider && children ? new Error('Children will not be rendered for dividers') : null;
	  }),
	
	  /**
	   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
	   */
	  eventKey: _propTypes2.default.any,
	
	  /**
	   * Styles the menu item as a header label, useful for describing a group of menu items.
	   */
	  header: _propTypes2.default.bool,
	
	  /**
	   * HTML `href` attribute corresponding to `a.href`.
	   */
	  href: _propTypes2.default.string,
	
	  /**
	   * Callback fired when the menu item is clicked.
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * Callback fired when the menu item is selected.
	   *
	   * ```js
	   * (eventKey: any, event: Object) => any
	   * ```
	   */
	  onSelect: _propTypes2.default.func
	};
	
	var defaultProps = {
	  divider: false,
	  disabled: false,
	  header: false
	};
	
	var MenuItem = function (_React$Component) {
	  (0, _inherits3.default)(MenuItem, _React$Component);
	
	  function MenuItem(props, context) {
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    var _props = this.props,
	        href = _props.href,
	        disabled = _props.disabled,
	        onSelect = _props.onSelect,
	        eventKey = _props.eventKey;
	
	
	    if (!href || disabled) {
	      event.preventDefault();
	    }
	
	    if (disabled) {
	      return;
	    }
	
	    if (onSelect) {
	      onSelect(eventKey, event);
	    }
	  };
	
	  MenuItem.prototype.render = function render() {
	    var _props2 = this.props,
	        active = _props2.active,
	        disabled = _props2.disabled,
	        divider = _props2.divider,
	        header = _props2.header,
	        onClick = _props2.onClick,
	        className = _props2.className,
	        style = _props2.style,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    if (divider) {
	      // Forcibly blank out the children; separators shouldn't render any.
	      elementProps.children = undefined;
	
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'separator',
	        className: (0, _classnames2.default)(className, 'divider'),
	        style: style
	      }));
	    }
	
	    if (header) {
	      return _react2.default.createElement('li', (0, _extends3.default)({}, elementProps, {
	        role: 'heading',
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'header')),
	        style: style
	      }));
	    }
	
	    return _react2.default.createElement(
	      'li',
	      {
	        role: 'presentation',
	        className: (0, _classnames2.default)(className, { active: active, disabled: disabled }),
	        style: style
	      },
	      _react2.default.createElement(_SafeAnchor2.default, (0, _extends3.default)({}, elementProps, {
	        role: 'menuitem',
	        tabIndex: '-1',
	        onClick: (0, _createChainedFunction2.default)(onClick, this.handleClick)
	      }))
	    );
	  };
	
	  return MenuItem;
	}(_react2.default.Component);
	
	MenuItem.propTypes = propTypes;
	MenuItem.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('dropdown', MenuItem);
	module.exports = exports['default'];

/***/ },
/* 2681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _events = __webpack_require__(1897);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _ownerDocument = __webpack_require__(182);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _scrollbarSize = __webpack_require__(909);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Modal = __webpack_require__(2765);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _isOverflowing = __webpack_require__(1250);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _Fade = __webpack_require__(332);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ModalBody = __webpack_require__(1204);
	
	var _ModalBody2 = _interopRequireDefault(_ModalBody);
	
	var _ModalDialog = __webpack_require__(2682);
	
	var _ModalDialog2 = _interopRequireDefault(_ModalDialog);
	
	var _ModalFooter = __webpack_require__(1205);
	
	var _ModalFooter2 = _interopRequireDefault(_ModalFooter);
	
	var _ModalHeader = __webpack_require__(1206);
	
	var _ModalHeader2 = _interopRequireDefault(_ModalHeader);
	
	var _ModalTitle = __webpack_require__(1207);
	
	var _ModalTitle2 = _interopRequireDefault(_ModalTitle);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _splitComponentProps2 = __webpack_require__(334);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Modal2.default.propTypes, _ModalDialog2.default.propTypes, {
	
	  /**
	   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
	   * trigger an "onHide" when clicked.
	   */
	  backdrop: _propTypes2.default.oneOf(['static', true, false]),
	
	  /**
	   * Add an optional extra class name to .modal-backdrop
	   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * Open and close the Modal with a slide and fade animation.
	   */
	  animation: _propTypes2.default.bool,
	
	  /**
	   * A Component type that provides the modal content Markup. This is a useful
	   * prop when you want to use your own styles and markup to create a custom
	   * modal component.
	   */
	  dialogComponentClass: _elementType2.default,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it
	   * opens, and replace it to the last focused element when it closes.
	   * Generally this should never be set to false as it makes the Modal less
	   * accessible to assistive technologies, like screen-readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while
	   * open. Consider leaving the default value here, as it is necessary to make
	   * the Modal work well with assistive technologies, such as screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will show itself.
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A callback fired when the header closeButton or non-static backdrop is
	   * clicked. Required if either are specified.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * @private
	   */
	  container: _Modal2.default.propTypes.container
	});
	
	var defaultProps = (0, _extends3.default)({}, _Modal2.default.defaultProps, {
	  animation: true,
	  dialogComponentClass: _ModalDialog2.default
	});
	
	var childContextTypes = {
	  $bs_modal: _propTypes2.default.shape({
	    onHide: _propTypes2.default.func
	  })
	};
	
	var Modal = function (_React$Component) {
	  (0, _inherits3.default)(Modal, _React$Component);
	
	  function Modal(props, context) {
	    (0, _classCallCheck3.default)(this, Modal);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleEntering = _this.handleEntering.bind(_this);
	    _this.handleExited = _this.handleExited.bind(_this);
	    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
	    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
	    _this.setModalRef = _this.setModalRef.bind(_this);
	
	    _this.state = {
	      style: {}
	    };
	    return _this;
	  }
	
	  Modal.prototype.getChildContext = function getChildContext() {
	    return {
	      $bs_modal: {
	        onHide: this.props.onHide
	      }
	    };
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    // Clean up the listener if we need to.
	    this.handleExited();
	  };
	
	  Modal.prototype.setModalRef = function setModalRef(ref) {
	    this._modal = ref;
	  };
	
	  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    this.props.onHide();
	  };
	
	  Modal.prototype.handleEntering = function handleEntering() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.on(window, 'resize', this.handleWindowResize);
	    this.updateStyle();
	  };
	
	  Modal.prototype.handleExited = function handleExited() {
	    // FIXME: This should work even when animation is disabled.
	    _events2.default.off(window, 'resize', this.handleWindowResize);
	  };
	
	  Modal.prototype.handleWindowResize = function handleWindowResize() {
	    this.updateStyle();
	  };
	
	  Modal.prototype.updateStyle = function updateStyle() {
	    if (!_inDOM2.default) {
	      return;
	    }
	
	    var dialogNode = this._modal.getDialogElement();
	    var dialogHeight = dialogNode.scrollHeight;
	
	    var document = (0, _ownerDocument2.default)(dialogNode);
	    var bodyIsOverflowing = (0, _isOverflowing2.default)(_reactDom2.default.findDOMNode(this.props.container || document.body));
	    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
	
	    this.setState({
	      style: {
	        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined,
	        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? (0, _scrollbarSize2.default)() : undefined
	      }
	    });
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        backdrop = _props.backdrop,
	        backdropClassName = _props.backdropClassName,
	        animation = _props.animation,
	        show = _props.show,
	        Dialog = _props.dialogComponentClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        onEntering = _props.onEntering,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Modal2.default),
	        baseModalProps = _splitComponentProps[0],
	        dialogProps = _splitComponentProps[1];
	
	    var inClassName = show && !animation && 'in';
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      (0, _extends3.default)({}, baseModalProps, {
	        ref: this.setModalRef,
	        show: show,
	        onEntering: (0, _createChainedFunction2.default)(onEntering, this.handleEntering),
	        onExited: (0, _createChainedFunction2.default)(onExited, this.handleExited),
	        backdrop: backdrop,
	        backdropClassName: (0, _classnames2.default)((0, _bootstrapUtils.prefix)(props, 'backdrop'), backdropClassName, inClassName),
	        containerClassName: (0, _bootstrapUtils.prefix)(props, 'open'),
	        transition: animation ? _Fade2.default : undefined,
	        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
	        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
	      }),
	      _react2.default.createElement(
	        Dialog,
	        (0, _extends3.default)({}, dialogProps, {
	          style: (0, _extends3.default)({}, this.state.style, style),
	          className: (0, _classnames2.default)(className, inClassName),
	          onClick: backdrop === true ? this.handleDialogClick : null
	        }),
	        children
	      )
	    );
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = propTypes;
	Modal.defaultProps = defaultProps;
	Modal.childContextTypes = childContextTypes;
	
	Modal.Body = _ModalBody2.default;
	Modal.Header = _ModalHeader2.default;
	Modal.Title = _ModalTitle2.default;
	Modal.Footer = _ModalFooter2.default;
	
	Modal.Dialog = _ModalDialog2.default;
	
	Modal.TRANSITION_DURATION = 300;
	Modal.BACKDROP_TRANSITION_DURATION = 150;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Modal));
	module.exports = exports['default'];

/***/ },
/* 2682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * A css class to apply to the Modal dialog DOM node.
	   */
	  dialogClassName: _propTypes2.default.string
	};
	
	var ModalDialog = function (_React$Component) {
	  (0, _inherits3.default)(ModalDialog, _React$Component);
	
	  function ModalDialog() {
	    (0, _classCallCheck3.default)(this, ModalDialog);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ModalDialog.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        dialogClassName = _props.dialogClassName,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['dialogClassName', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(bsProps);
	
	    var modalStyle = (0, _extends4.default)({ display: 'block' }, style);
	
	    var dialogClasses = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'dialog')] = true, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        tabIndex: '-1',
	        role: 'dialog',
	        style: modalStyle,
	        className: (0, _classnames2.default)(className, bsClassName)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _classnames2.default)(dialogClassName, dialogClasses) },
	        _react2.default.createElement(
	          'div',
	          { className: (0, _bootstrapUtils.prefix)(bsProps, 'content'), role: 'document' },
	          children
	        )
	      )
	    );
	  };
	
	  return ModalDialog;
	}(_react2.default.Component);
	
	ModalDialog.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('modal', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], ModalDialog));
	module.exports = exports['default'];

/***/ },
/* 2683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dropdown = __webpack_require__(331);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _splitComponentProps2 = __webpack_require__(334);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  title: _propTypes2.default.node.isRequired,
	  noCaret: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var NavDropdown = function (_React$Component) {
	  (0, _inherits3.default)(NavDropdown, _React$Component);
	
	  function NavDropdown() {
	    (0, _classCallCheck3.default)(this, NavDropdown);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
	    var props = _ref.props;
	
	    var _this2 = this;
	
	    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
	      return true;
	    }
	
	    if (_ValidComponentChildren2.default.some(props.children, function (child) {
	      return _this2.isActive(child, activeKey, activeHref);
	    })) {
	      return true;
	    }
	
	    return props.active;
	  };
	
	  NavDropdown.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        title = _props.title,
	        activeKey = _props.activeKey,
	        activeHref = _props.activeHref,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);
	
	
	    var active = this.isActive(this, activeKey, activeHref);
	    delete props.active; // Accessed via this.isActive().
	    delete props.eventKey; // Accessed via this.isActive().
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        toggleProps = _splitComponentProps[1];
	
	    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
	    // rather than the `<Dropdown.Toggle>`.
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        componentClass: 'li',
	        className: (0, _classnames2.default)(className, { active: active }),
	        style: style
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Toggle,
	        (0, _extends3.default)({}, toggleProps, { useAnchor: true }),
	        title
	      ),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        _ValidComponentChildren2.default.map(children, function (child) {
	          return _react2.default.cloneElement(child, {
	            active: _this3.isActive(child, activeKey, activeHref)
	          });
	        })
	      )
	    );
	  };
	
	  return NavDropdown;
	}(_react2.default.Component);
	
	NavDropdown.propTypes = propTypes;
	
	exports.default = NavDropdown;
	module.exports = exports['default'];

/***/ },
/* 2684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _uncontrollable = __webpack_require__(267);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Grid = __webpack_require__(1202);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _NavbarBrand = __webpack_require__(1210);
	
	var _NavbarBrand2 = _interopRequireDefault(_NavbarBrand);
	
	var _NavbarCollapse = __webpack_require__(2685);
	
	var _NavbarCollapse2 = _interopRequireDefault(_NavbarCollapse);
	
	var _NavbarHeader = __webpack_require__(2686);
	
	var _NavbarHeader2 = _interopRequireDefault(_NavbarHeader);
	
	var _NavbarToggle = __webpack_require__(2687);
	
	var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Create a fixed navbar along the top of the screen, that scrolls with the
	   * page
	   */
	  fixedTop: _propTypes2.default.bool,
	  /**
	   * Create a fixed navbar along the bottom of the screen, that scrolls with
	   * the page
	   */
	  fixedBottom: _propTypes2.default.bool,
	  /**
	   * Create a full-width navbar that scrolls away with the page
	   */
	  staticTop: _propTypes2.default.bool,
	  /**
	   * An alternative dark visual style for the Navbar
	   */
	  inverse: _propTypes2.default.bool,
	  /**
	   * Allow the Navbar to fluidly adjust to the page or container width, instead
	   * of at the predefined screen breakpoints
	   */
	  fluid: _propTypes2.default.bool,
	
	  /**
	   * Set a custom element for this component.
	   */
	  componentClass: _elementType2.default,
	  /**
	   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
	   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
	   * boolean value.
	   *
	   * @controllable expanded
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * A callback fired when a descendant of a child `<Nav>` is selected. Should
	   * be used to execute complex closing or other miscellaneous actions desired
	   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
	   * descendants exist. The callback is called with an eventKey, which is a
	   * prop from the selected `<Nav>` descendant, and an event.
	   *
	   * ```js
	   * function (
	   *  Any eventKey,
	   *  SyntheticEvent event?
	   * )
	   * ```
	   *
	   * For basic closing behavior after all `<Nav>` descendant onSelect events in
	   * mobile viewports, try using collapseOnSelect.
	   *
	   * Note: If you are manually closing the navbar using this `OnSelect` prop,
	   * ensure that you are setting `expanded` to false and not *toggling* between
	   * true and false.
	   */
	  onSelect: _propTypes2.default.func,
	  /**
	   * Sets `expanded` to `false` after the onSelect event of a descendant of a
	   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
	   *
	   * The onSelect callback should be used instead for more complex operations
	   * that need to be executed after the `select` event of `<Nav>` descendants.
	   */
	  collapseOnSelect: _propTypes2.default.bool,
	  /**
	   * Explicitly set the visiblity of the navbar body
	   *
	   * @controllable onToggle
	   */
	  expanded: _propTypes2.default.bool,
	
	  role: _propTypes2.default.string
	}; // TODO: Remove this pragma once we upgrade eslint-config-airbnb.
	/* eslint-disable react/no-multi-comp */
	
	var defaultProps = {
	  componentClass: 'nav',
	  fixedTop: false,
	  fixedBottom: false,
	  staticTop: false,
	  inverse: false,
	  fluid: false,
	  collapseOnSelect: false
	};
	
	var childContextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired,
	    onSelect: _propTypes2.default.func
	  })
	};
	
	var Navbar = function (_React$Component) {
	  (0, _inherits3.default)(Navbar, _React$Component);
	
	  function Navbar(props, context) {
	    (0, _classCallCheck3.default)(this, Navbar);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleCollapse = _this.handleCollapse.bind(_this);
	    return _this;
	  }
	
	  Navbar.prototype.getChildContext = function getChildContext() {
	    var _props = this.props,
	        bsClass = _props.bsClass,
	        expanded = _props.expanded,
	        onSelect = _props.onSelect,
	        collapseOnSelect = _props.collapseOnSelect;
	
	
	    return {
	      $bs_navbar: {
	        bsClass: bsClass,
	        expanded: expanded,
	        onToggle: this.handleToggle,
	        onSelect: (0, _createChainedFunction2.default)(onSelect, collapseOnSelect ? this.handleCollapse : null)
	      }
	    };
	  };
	
	  Navbar.prototype.handleCollapse = function handleCollapse() {
	    var _props2 = this.props,
	        onToggle = _props2.onToggle,
	        expanded = _props2.expanded;
	
	
	    if (expanded) {
	      onToggle(false);
	    }
	  };
	
	  Navbar.prototype.handleToggle = function handleToggle() {
	    var _props3 = this.props,
	        onToggle = _props3.onToggle,
	        expanded = _props3.expanded;
	
	
	    onToggle(!expanded);
	  };
	
	  Navbar.prototype.render = function render() {
	    var _extends2;
	
	    var _props4 = this.props,
	        Component = _props4.componentClass,
	        fixedTop = _props4.fixedTop,
	        fixedBottom = _props4.fixedBottom,
	        staticTop = _props4.staticTop,
	        inverse = _props4.inverse,
	        fluid = _props4.fluid,
	        className = _props4.className,
	        children = _props4.children,
	        props = (0, _objectWithoutProperties3.default)(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    // will result in some false positives but that seems better
	    // than false negatives. strict `undefined` check allows explicit
	    // "nulling" of the role if the user really doesn't want one
	
	
	    if (elementProps.role === undefined && Component !== 'nav') {
	      elementProps.role = 'navigation';
	    }
	
	    if (inverse) {
	      bsProps.bsStyle = _StyleConfig.Style.INVERSE;
	    }
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-top')] = fixedTop, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'static-top')] = staticTop, _extends2));
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        _Grid2.default,
	        { fluid: fluid },
	        children
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2.default.Component);
	
	Navbar.propTypes = propTypes;
	Navbar.defaultProps = defaultProps;
	Navbar.childContextTypes = childContextTypes;
	
	(0, _bootstrapUtils.bsClass)('navbar', Navbar);
	
	var UncontrollableNavbar = (0, _uncontrollable2.default)(Navbar, { expanded: 'onToggle' });
	
	function createSimpleWrapper(tag, suffix, displayName) {
	  var Wrapper = function Wrapper(_ref, _ref2) {
	    var _ref2$$bs_navbar = _ref2.$bs_navbar,
	        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;
	    var Component = _ref.componentClass,
	        className = _ref.className,
	        pullRight = _ref.pullRight,
	        pullLeft = _ref.pullLeft,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);
	    return _react2.default.createElement(Component, (0, _extends4.default)({}, props, {
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, suffix), pullRight && (0, _bootstrapUtils.prefix)(navbarProps, 'right'), pullLeft && (0, _bootstrapUtils.prefix)(navbarProps, 'left'))
	    }));
	  };
	
	  Wrapper.displayName = displayName;
	
	  Wrapper.propTypes = {
	    componentClass: _elementType2.default,
	    pullRight: _propTypes2.default.bool,
	    pullLeft: _propTypes2.default.bool
	  };
	
	  Wrapper.defaultProps = {
	    componentClass: tag,
	    pullRight: false,
	    pullLeft: false
	  };
	
	  Wrapper.contextTypes = {
	    $bs_navbar: _propTypes2.default.shape({
	      bsClass: _propTypes2.default.string
	    })
	  };
	
	  return Wrapper;
	}
	
	UncontrollableNavbar.Brand = _NavbarBrand2.default;
	UncontrollableNavbar.Header = _NavbarHeader2.default;
	UncontrollableNavbar.Toggle = _NavbarToggle2.default;
	UncontrollableNavbar.Collapse = _NavbarCollapse2.default;
	
	UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
	UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
	UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');
	
	// Set bsStyles here so they can be overridden.
	exports.default = (0, _bootstrapUtils.bsStyles)([_StyleConfig.Style.DEFAULT, _StyleConfig.Style.INVERSE], _StyleConfig.Style.DEFAULT, UncontrollableNavbar);
	module.exports = exports['default'];

/***/ },
/* 2685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(486);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool
	  })
	};
	
	var NavbarCollapse = function (_React$Component) {
	  (0, _inherits3.default)(NavbarCollapse, _React$Component);
	
	  function NavbarCollapse() {
	    (0, _classCallCheck3.default)(this, NavbarCollapse);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarCollapse.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'collapse');
	
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': navbarProps.expanded }, props),
	      _react2.default.createElement(
	        'div',
	        { className: bsClassName },
	        children
	      )
	    );
	  };
	
	  return NavbarCollapse;
	}(_react2.default.Component);
	
	NavbarCollapse.contextTypes = contextTypes;
	
	exports.default = NavbarCollapse;
	module.exports = exports['default'];

/***/ },
/* 2686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string
	  })
	};
	
	var NavbarHeader = function (_React$Component) {
	  (0, _inherits3.default)(NavbarHeader, _React$Component);
	
	  function NavbarHeader() {
	    (0, _classCallCheck3.default)(this, NavbarHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var bsClassName = (0, _bootstrapUtils.prefix)(navbarProps, 'header');
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: (0, _classnames2.default)(className, bsClassName) }));
	  };
	
	  return NavbarHeader;
	}(_react2.default.Component);
	
	NavbarHeader.contextTypes = contextTypes;
	
	exports.default = NavbarHeader;
	module.exports = exports['default'];

/***/ },
/* 2687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onClick: _propTypes2.default.func,
	  /**
	   * The toggle content, if left empty it will render the default toggle (seen above).
	   */
	  children: _propTypes2.default.node
	};
	
	var contextTypes = {
	  $bs_navbar: _propTypes2.default.shape({
	    bsClass: _propTypes2.default.string,
	    expanded: _propTypes2.default.bool,
	    onToggle: _propTypes2.default.func.isRequired
	  })
	};
	
	var NavbarToggle = function (_React$Component) {
	  (0, _inherits3.default)(NavbarToggle, _React$Component);
	
	  function NavbarToggle() {
	    (0, _classCallCheck3.default)(this, NavbarToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  NavbarToggle.prototype.render = function render() {
	    var _props = this.props,
	        onClick = _props.onClick,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onClick', 'className', 'children']);
	
	    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };
	
	    var buttonProps = (0, _extends3.default)({
	      type: 'button'
	    }, props, {
	      onClick: (0, _createChainedFunction2.default)(onClick, navbarProps.onToggle),
	      className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
	    });
	
	    if (children) {
	      return _react2.default.createElement(
	        'button',
	        buttonProps,
	        children
	      );
	    }
	
	    return _react2.default.createElement(
	      'button',
	      buttonProps,
	      _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        'Toggle navigation'
	      ),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' }),
	      _react2.default.createElement('span', { className: 'icon-bar' })
	    );
	  };
	
	  return NavbarToggle;
	}(_react2.default.Component);
	
	NavbarToggle.propTypes = propTypes;
	NavbarToggle.contextTypes = contextTypes;
	
	exports.default = NavbarToggle;
	module.exports = exports['default'];

/***/ },
/* 2688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _contains = __webpack_require__(183);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Overlay = __webpack_require__(1211);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Check if value one is inside or equal to the of value
	 *
	 * @param {string} one
	 * @param {string|array} of
	 * @returns {boolean}
	 */
	function isOneOf(one, of) {
	  if (Array.isArray(of)) {
	    return of.indexOf(one) >= 0;
	  }
	  return one === of;
	}
	
	var triggerType = _propTypes2.default.oneOf(['click', 'hover', 'focus']);
	
	var propTypes = (0, _extends3.default)({}, _Overlay2.default.propTypes, {
	
	  /**
	   * Specify which action or actions trigger Overlay visibility
	   */
	  trigger: _propTypes2.default.oneOfType([triggerType, _propTypes2.default.arrayOf(triggerType)]),
	
	  /**
	   * A millisecond delay amount to show and hide the Overlay once triggered
	   */
	  delay: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before showing the Overlay once triggered.
	   */
	  delayShow: _propTypes2.default.number,
	  /**
	   * A millisecond delay amount before hiding the Overlay once triggered.
	   */
	  delayHide: _propTypes2.default.number,
	
	  // FIXME: This should be `defaultShow`.
	  /**
	   * The initial visibility state of the Overlay. For more nuanced visibility
	   * control, consider using the Overlay component directly.
	   */
	  defaultOverlayShown: _propTypes2.default.bool,
	
	  /**
	   * An element or text to overlay next to the target.
	   */
	  overlay: _propTypes2.default.node.isRequired,
	
	  /**
	   * @private
	   */
	  onBlur: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOut: _propTypes2.default.func,
	  /**
	   * @private
	   */
	  onMouseOver: _propTypes2.default.func,
	
	  // Overridden props from `<Overlay>`.
	  /**
	   * @private
	   */
	  target: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  onHide: _propTypes2.default.oneOf([null]),
	  /**
	   * @private
	   */
	  show: _propTypes2.default.oneOf([null])
	});
	
	var defaultProps = {
	  defaultOverlayShown: false,
	  trigger: ['hover', 'focus']
	};
	
	var OverlayTrigger = function (_React$Component) {
	  (0, _inherits3.default)(OverlayTrigger, _React$Component);
	
	  function OverlayTrigger(props, context) {
	    (0, _classCallCheck3.default)(this, OverlayTrigger);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleToggle = _this.handleToggle.bind(_this);
	    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
	    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
	    _this.handleHide = _this.handleHide.bind(_this);
	
	    _this.handleMouseOver = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
	    };
	    _this.handleMouseOut = function (e) {
	      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
	    };
	
	    _this._mountNode = null;
	
	    _this.state = {
	      show: props.defaultOverlayShown
	    };
	    return _this;
	  }
	
	  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
	    this._mountNode = document.createElement('div');
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOverlay();
	  };
	
	  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    _reactDom2.default.unmountComponentAtNode(this._mountNode);
	    this._mountNode = null;
	
	    clearTimeout(this._hoverShowDelay);
	    clearTimeout(this._hoverHideDelay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
	    var _this2 = this;
	
	    if (this._hoverShowDelay != null) {
	      clearTimeout(this._hoverShowDelay);
	      this._hoverShowDelay = null;
	      return;
	    }
	
	    if (!this.state.show || this._hoverHideDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;
	
	    if (!delay) {
	      this.hide();
	      return;
	    }
	
	    this._hoverHideDelay = setTimeout(function () {
	      _this2._hoverHideDelay = null;
	      _this2.hide();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
	    var _this3 = this;
	
	    if (this._hoverHideDelay != null) {
	      clearTimeout(this._hoverHideDelay);
	      this._hoverHideDelay = null;
	      return;
	    }
	
	    if (this.state.show || this._hoverShowDelay != null) {
	      return;
	    }
	
	    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;
	
	    if (!delay) {
	      this.show();
	      return;
	    }
	
	    this._hoverShowDelay = setTimeout(function () {
	      _this3._hoverShowDelay = null;
	      _this3.show();
	    }, delay);
	  };
	
	  OverlayTrigger.prototype.handleHide = function handleHide() {
	    this.hide();
	  };
	
	  // Simple implementation of mouseEnter and mouseLeave.
	  // React's built version is broken: https://github.com/facebook/react/issues/4251
	  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
	  // moving from one child element to another.
	
	
	  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
	    var target = e.currentTarget;
	    var related = e.relatedTarget || e.nativeEvent.toElement;
	
	    if ((!related || related !== target) && !(0, _contains2.default)(target, related)) {
	      handler(e);
	    }
	  };
	
	  OverlayTrigger.prototype.handleToggle = function handleToggle() {
	    if (this.state.show) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  OverlayTrigger.prototype.hide = function hide() {
	    this.setState({ show: false });
	  };
	
	  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
	    return _react2.default.createElement(
	      _Overlay2.default,
	      (0, _extends3.default)({}, props, {
	        show: this.state.show,
	        onHide: this.handleHide,
	        target: this
	      }),
	      overlay
	    );
	  };
	
	  OverlayTrigger.prototype.show = function show() {
	    this.setState({ show: true });
	  };
	
	  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
	    _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
	  };
	
	  OverlayTrigger.prototype.render = function render() {
	    var _props = this.props,
	        trigger = _props.trigger,
	        overlay = _props.overlay,
	        children = _props.children,
	        onBlur = _props.onBlur,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onMouseOut = _props.onMouseOut,
	        onMouseOver = _props.onMouseOver,
	        props = (0, _objectWithoutProperties3.default)(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);
	
	
	    delete props.delay;
	    delete props.delayShow;
	    delete props.delayHide;
	    delete props.defaultOverlayShown;
	
	    var child = _react2.default.Children.only(children);
	    var childProps = child.props;
	    var triggerProps = {};
	
	    if (this.state.show) {
	      triggerProps['aria-describedby'] = overlay.props.id;
	    }
	
	    // FIXME: The logic here for passing through handlers on this component is
	    // inconsistent. We shouldn't be passing any of these props through.
	
	    triggerProps.onClick = (0, _createChainedFunction2.default)(childProps.onClick, onClick);
	
	    if (isOneOf('click', trigger)) {
	      triggerProps.onClick = (0, _createChainedFunction2.default)(triggerProps.onClick, this.handleToggle);
	    }
	
	    if (isOneOf('hover', trigger)) {
	       false ? (0, _warning2.default)(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
	
	      triggerProps.onMouseOver = (0, _createChainedFunction2.default)(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
	      triggerProps.onMouseOut = (0, _createChainedFunction2.default)(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
	    }
	
	    if (isOneOf('focus', trigger)) {
	      triggerProps.onFocus = (0, _createChainedFunction2.default)(childProps.onFocus, onFocus, this.handleDelayedShow);
	      triggerProps.onBlur = (0, _createChainedFunction2.default)(childProps.onBlur, onBlur, this.handleDelayedHide);
	    }
	
	    this._overlay = this.makeOverlay(overlay, props);
	
	    return (0, _react.cloneElement)(child, triggerProps);
	  };
	
	  return OverlayTrigger;
	}(_react2.default.Component);
	
	OverlayTrigger.propTypes = propTypes;
	OverlayTrigger.defaultProps = defaultProps;
	
	exports.default = OverlayTrigger;
	module.exports = exports['default'];

/***/ },
/* 2689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PageHeader = function (_React$Component) {
	  (0, _inherits3.default)(PageHeader, _React$Component);
	
	  function PageHeader() {
	    (0, _classCallCheck3.default)(this, PageHeader);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  PageHeader.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement(
	        'h1',
	        null,
	        children
	      )
	    );
	  };
	
	  return PageHeader;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('page-header', PageHeader);
	module.exports = exports['default'];

/***/ },
/* 2690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PagerItem = __webpack_require__(1212);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _deprecationWarning = __webpack_require__(2710);
	
	var _deprecationWarning2 = _interopRequireDefault(_deprecationWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _deprecationWarning2.default.wrapper(_PagerItem2.default, '`<PageItem>`', '`<Pager.Item>`');
	module.exports = exports['default'];

/***/ },
/* 2691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PagerItem = __webpack_require__(1212);
	
	var _PagerItem2 = _interopRequireDefault(_PagerItem);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  onSelect: _propTypes2.default.func
	};
	
	var Pager = function (_React$Component) {
	  (0, _inherits3.default)(Pager, _React$Component);
	
	  function Pager() {
	    (0, _classCallCheck3.default)(this, Pager);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pager.prototype.render = function render() {
	    var _props = this.props,
	        onSelect = _props.onSelect,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['onSelect', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onSelect: (0, _createChainedFunction2.default)(child.props.onSelect, onSelect)
	        });
	      })
	    );
	  };
	
	  return Pager;
	}(_react2.default.Component);
	
	Pager.propTypes = propTypes;
	
	Pager.Item = _PagerItem2.default;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pager', Pager);
	module.exports = exports['default'];

/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _PaginationButton = __webpack_require__(1213);
	
	var _PaginationButton2 = _interopRequireDefault(_PaginationButton);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  activePage: _propTypes2.default.number,
	  items: _propTypes2.default.number,
	  maxButtons: _propTypes2.default.number,
	
	  /**
	   * When `true`, will display the first and the last button page when
	   * displaying ellipsis.
	   */
	  boundaryLinks: _propTypes2.default.bool,
	
	  /**
	   * When `true`, will display the default node value ('&hellip;').
	   * Otherwise, will display provided node (when specified).
	   */
	  ellipsis: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&laquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  first: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&raquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  last: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&lsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  prev: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  /**
	   * When `true`, will display the default node value ('&rsaquo;').
	   * Otherwise, will display provided node (when specified).
	   */
	  next: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
	
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * You can use a custom element for the buttons
	   */
	  buttonComponentClass: _elementType2.default
	};
	
	var defaultProps = {
	  activePage: 1,
	  items: 1,
	  maxButtons: 0,
	  first: false,
	  last: false,
	  prev: false,
	  next: false,
	  ellipsis: true,
	  boundaryLinks: false
	};
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3.default)(Pagination, _React$Component);
	
	  function Pagination() {
	    (0, _classCallCheck3.default)(this, Pagination);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
	    var pageButtons = [];
	
	    var startPage = void 0;
	    var endPage = void 0;
	
	    if (maxButtons && maxButtons < items) {
	      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
	      endPage = startPage + maxButtons - 1;
	    } else {
	      startPage = 1;
	      endPage = items;
	    }
	
	    for (var page = startPage; page <= endPage; ++page) {
	      pageButtons.push(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: page,
	          eventKey: page,
	          active: page === activePage
	        }),
	        page
	      ));
	    }
	
	    if (ellipsis && boundaryLinks && startPage > 1) {
	      if (startPage > 2) {
	        pageButtons.unshift(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsisFirst',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      pageButtons.unshift(_react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          key: 1,
	          eventKey: 1,
	          active: false
	        }),
	        '1'
	      ));
	    }
	
	    if (ellipsis && endPage < items) {
	      if (!boundaryLinks || endPage < items - 1) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          {
	            key: 'ellipsis',
	            disabled: true,
	            componentClass: buttonProps.componentClass
	          },
	          _react2.default.createElement(
	            'span',
	            { 'aria-label': 'More' },
	            ellipsis === true ? '\u2026' : ellipsis
	          )
	        ));
	      }
	
	      if (boundaryLinks) {
	        pageButtons.push(_react2.default.createElement(
	          _PaginationButton2.default,
	          (0, _extends3.default)({}, buttonProps, {
	            key: items,
	            eventKey: items,
	            active: false
	          }),
	          items
	        ));
	      }
	    }
	
	    return pageButtons;
	  };
	
	  Pagination.prototype.render = function render() {
	    var _props = this.props,
	        activePage = _props.activePage,
	        items = _props.items,
	        maxButtons = _props.maxButtons,
	        boundaryLinks = _props.boundaryLinks,
	        ellipsis = _props.ellipsis,
	        first = _props.first,
	        last = _props.last,
	        prev = _props.prev,
	        next = _props.next,
	        onSelect = _props.onSelect,
	        buttonComponentClass = _props.buttonComponentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    var buttonProps = {
	      onSelect: onSelect,
	      componentClass: buttonComponentClass
	    };
	
	    return _react2.default.createElement(
	      'ul',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      first && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'First' },
	          first === true ? '\xAB' : first
	        )
	      ),
	      prev && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage - 1,
	          disabled: activePage === 1
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Previous' },
	          prev === true ? '\u2039' : prev
	        )
	      ),
	      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
	      next && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: activePage + 1,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Next' },
	          next === true ? '\u203A' : next
	        )
	      ),
	      last && _react2.default.createElement(
	        _PaginationButton2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          eventKey: items,
	          disabled: activePage >= items
	        }),
	        _react2.default.createElement(
	          'span',
	          { 'aria-label': 'Last' },
	          last === true ? '\xBB' : last
	        )
	      )
	    );
	  };
	
	  return Pagination;
	}(_react2.default.Component);
	
	Pagination.propTypes = propTypes;
	Pagination.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('pagination', Pagination);
	module.exports = exports['default'];

/***/ },
/* 2693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(175);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Collapse = __webpack_require__(486);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: Use uncontrollable.
	
	var propTypes = {
	  collapsible: _propTypes2.default.bool,
	  onSelect: _propTypes2.default.func,
	  header: _propTypes2.default.node,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  footer: _propTypes2.default.node,
	  defaultExpanded: _propTypes2.default.bool,
	  expanded: _propTypes2.default.bool,
	  eventKey: _propTypes2.default.any,
	  headerRole: _propTypes2.default.string,
	  panelRole: _propTypes2.default.string,
	
	  // From Collapse.
	  onEnter: _propTypes2.default.func,
	  onEntering: _propTypes2.default.func,
	  onEntered: _propTypes2.default.func,
	  onExit: _propTypes2.default.func,
	  onExiting: _propTypes2.default.func,
	  onExited: _propTypes2.default.func
	};
	
	var defaultProps = {
	  defaultExpanded: false
	};
	
	var Panel = function (_React$Component) {
	  (0, _inherits3.default)(Panel, _React$Component);
	
	  function Panel(props, context) {
	    (0, _classCallCheck3.default)(this, Panel);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.handleClickTitle = _this.handleClickTitle.bind(_this);
	
	    _this.state = {
	      expanded: _this.props.defaultExpanded
	    };
	    return _this;
	  }
	
	  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
	    // FIXME: What the heck? This API is horrible. This needs to go away!
	    e.persist();
	    e.selected = true;
	
	    if (this.props.onSelect) {
	      this.props.onSelect(this.props.eventKey, e);
	    } else {
	      e.preventDefault();
	    }
	
	    if (e.selected) {
	      this.setState({ expanded: !this.state.expanded });
	    }
	  };
	
	  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
	    return _react2.default.createElement(
	      'a',
	      {
	        role: role,
	        href: id && '#' + id,
	        onClick: this.handleClickTitle,
	        'aria-controls': id,
	        'aria-expanded': expanded,
	        'aria-selected': expanded,
	        className: expanded ? null : 'collapsed'
	      },
	      header
	    );
	  };
	
	  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
	    var children = [];
	    var bodyChildren = [];
	
	    var bodyClassName = (0, _bootstrapUtils.prefix)(bsProps, 'body');
	
	    function maybeAddBody() {
	      if (!bodyChildren.length) {
	        return;
	      }
	
	      // Derive the key from the index here, since we need to make one up.
	      children.push(_react2.default.createElement(
	        'div',
	        { key: children.length, className: bodyClassName },
	        bodyChildren
	      ));
	
	      bodyChildren = [];
	    }
	
	    // Convert to array so we can re-use keys.
	    _react2.default.Children.toArray(rawChildren).forEach(function (child) {
	      if (_react2.default.isValidElement(child) && child.props.fill) {
	        maybeAddBody();
	
	        // Remove the child's unknown `fill` prop.
	        children.push((0, _react.cloneElement)(child, { fill: undefined }));
	
	        return;
	      }
	
	      bodyChildren.push(child);
	    });
	
	    maybeAddBody();
	
	    return children;
	  };
	
	  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
	    return _react2.default.createElement(
	      _Collapse2.default,
	      (0, _extends3.default)({ 'in': expanded }, animationHooks),
	      _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          role: role,
	          className: (0, _bootstrapUtils.prefix)(bsProps, 'collapse'),
	          'aria-hidden': !expanded
	        },
	        this.renderBody(children, bsProps)
	      )
	    );
	  };
	
	  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
	    var titleClassName = (0, _bootstrapUtils.prefix)(bsProps, 'title');
	
	    if (!collapsible) {
	      if (!_react2.default.isValidElement(header)) {
	        return header;
	      }
	
	      return (0, _react.cloneElement)(header, {
	        className: (0, _classnames2.default)(header.props.className, titleClassName)
	      });
	    }
	
	    if (!_react2.default.isValidElement(header)) {
	      return _react2.default.createElement(
	        'h4',
	        { role: 'presentation', className: titleClassName },
	        this.renderAnchor(header, id, role, expanded)
	      );
	    }
	
	    return (0, _react.cloneElement)(header, {
	      className: (0, _classnames2.default)(header.props.className, titleClassName),
	      children: this.renderAnchor(header.props.children, id, role, expanded)
	    });
	  };
	
	  Panel.prototype.render = function render() {
	    var _props = this.props,
	        collapsible = _props.collapsible,
	        header = _props.header,
	        id = _props.id,
	        footer = _props.footer,
	        propsExpanded = _props.expanded,
	        headerRole = _props.headerRole,
	        panelRole = _props.panelRole,
	        className = _props.className,
	        children = _props.children,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onExited = _props.onExited,
	        props = (0, _objectWithoutProperties3.default)(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);
	
	    var _splitBsPropsAndOmit = (0, _bootstrapUtils.splitBsPropsAndOmit)(props, ['defaultExpanded', 'eventKey', 'onSelect']),
	        bsProps = _splitBsPropsAndOmit[0],
	        elementProps = _splitBsPropsAndOmit[1];
	
	    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes),
	        id: collapsible ? null : id
	      }),
	      header && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'heading') },
	        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
	      ),
	      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
	      footer && _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'footer') },
	        footer
	      )
	    );
	  };
	
	  return Panel;
	}(_react2.default.Component);
	
	Panel.propTypes = propTypes;
	Panel.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('panel', (0, _bootstrapUtils.bsStyles)([].concat((0, _values2.default)(_StyleConfig.State), [_StyleConfig.Style.DEFAULT, _StyleConfig.Style.PRIMARY]), _StyleConfig.Style.DEFAULT, Panel));
	module.exports = exports['default'];

/***/ },
/* 2694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(324);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Popover is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Popover.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Popover arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Popover arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * Title content
	   */
	  title: _propTypes2.default.node
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Popover = function (_React$Component) {
	  (0, _inherits3.default)(Popover, _React$Component);
	
	  function Popover() {
	    (0, _classCallCheck3.default)(this, Popover);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Popover.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        title = _props.title,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      display: 'block',
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: 'arrow', style: arrowStyle }),
	      title && _react2.default.createElement(
	        'h3',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'title') },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'content') },
	        children
	      )
	    );
	  };
	
	  return Popover;
	}(_react2.default.Component);
	
	Popover.propTypes = propTypes;
	Popover.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('popover', Popover);
	module.exports = exports['default'];

/***/ },
/* 2695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _values = __webpack_require__(175);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROUND_PRECISION = 1000;
	
	/**
	 * Validate that children, if any, are instances of `<ProgressBar>`.
	 */
	function onlyProgressBar(props, propName, componentName) {
	  var children = props[propName];
	  if (!children) {
	    return null;
	  }
	
	  var error = null;
	
	  _react2.default.Children.forEach(children, function (child) {
	    if (error) {
	      return;
	    }
	
	    if (child.type === ProgressBar) {
	      // eslint-disable-line no-use-before-define
	      return;
	    }
	
	    var childIdentifier = _react2.default.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
	    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
	  });
	
	  return error;
	}
	
	var propTypes = {
	  min: _propTypes2.default.number,
	  now: _propTypes2.default.number,
	  max: _propTypes2.default.number,
	  label: _propTypes2.default.node,
	  srOnly: _propTypes2.default.bool,
	  striped: _propTypes2.default.bool,
	  active: _propTypes2.default.bool,
	  children: onlyProgressBar,
	
	  /**
	   * @private
	   */
	  isChild: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  min: 0,
	  max: 100,
	  active: false,
	  isChild: false,
	  srOnly: false,
	  striped: false
	};
	
	function getPercentage(now, min, max) {
	  var percentage = (now - min) / (max - min) * 100;
	  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
	}
	
	var ProgressBar = function (_React$Component) {
	  (0, _inherits3.default)(ProgressBar, _React$Component);
	
	  function ProgressBar() {
	    (0, _classCallCheck3.default)(this, ProgressBar);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
	    var _extends2;
	
	    var min = _ref.min,
	        now = _ref.now,
	        max = _ref.max,
	        label = _ref.label,
	        srOnly = _ref.srOnly,
	        striped = _ref.striped,
	        active = _ref.active,
	        className = _ref.className,
	        style = _ref.style,
	        props = (0, _objectWithoutProperties3.default)(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {
	      active: active
	    }, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = active || striped, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'progressbar',
	        className: (0, _classnames2.default)(className, classes),
	        style: (0, _extends4.default)({ width: getPercentage(now, min, max) + '%' }, style),
	        'aria-valuenow': now,
	        'aria-valuemin': min,
	        'aria-valuemax': max
	      }),
	      srOnly ? _react2.default.createElement(
	        'span',
	        { className: 'sr-only' },
	        label
	      ) : label
	    );
	  };
	
	  ProgressBar.prototype.render = function render() {
	    var _props = this.props,
	        isChild = _props.isChild,
	        props = (0, _objectWithoutProperties3.default)(_props, ['isChild']);
	
	
	    if (isChild) {
	      return this.renderProgressBar(props);
	    }
	
	    var min = props.min,
	        now = props.now,
	        max = props.max,
	        label = props.label,
	        srOnly = props.srOnly,
	        striped = props.striped,
	        active = props.active,
	        bsClass = props.bsClass,
	        bsStyle = props.bsStyle,
	        className = props.className,
	        children = props.children,
	        wrapperProps = (0, _objectWithoutProperties3.default)(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);
	
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, wrapperProps, {
	        className: (0, _classnames2.default)(className, 'progress')
	      }),
	      children ? _ValidComponentChildren2.default.map(children, function (child) {
	        return (0, _react.cloneElement)(child, { isChild: true });
	      }) : this.renderProgressBar({
	        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
	      })
	    );
	  };
	
	  return ProgressBar;
	}(_react2.default.Component);
	
	ProgressBar.propTypes = propTypes;
	ProgressBar.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('progress-bar', (0, _bootstrapUtils.bsStyles)((0, _values2.default)(_StyleConfig.State), ProgressBar));
	module.exports = exports['default'];

/***/ },
/* 2696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  inline: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  /**
	   * Only valid if `inline` is not set.
	   */
	  validationState: _propTypes2.default.oneOf(['success', 'warning', 'error', null]),
	  /**
	   * Attaches a ref to the `<input>` element. Only functions can be used here.
	   *
	   * ```js
	   * <Radio inputRef={ref => { this.input = ref; }} />
	   * ```
	   */
	  inputRef: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/label-has-for */
	
	var defaultProps = {
	  inline: false,
	  disabled: false,
	  title: ''
	};
	
	var Radio = function (_React$Component) {
	  (0, _inherits3.default)(Radio, _React$Component);
	
	  function Radio() {
	    (0, _classCallCheck3.default)(this, Radio);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Radio.prototype.render = function render() {
	    var _props = this.props,
	        inline = _props.inline,
	        disabled = _props.disabled,
	        validationState = _props.validationState,
	        inputRef = _props.inputRef,
	        className = _props.className,
	        style = _props.style,
	        title = _props.title,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var input = _react2.default.createElement('input', (0, _extends3.default)({}, elementProps, {
	      ref: inputRef,
	      type: 'radio',
	      disabled: disabled
	    }));
	
	    if (inline) {
	      var _classes2;
	
	      var _classes = (_classes2 = {}, _classes2[(0, _bootstrapUtils.prefix)(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);
	
	      // Use a warning here instead of in propTypes to get better-looking
	      // generated documentation.
	       false ? (0, _warning2.default)(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
	
	      return _react2.default.createElement(
	        'label',
	        { className: (0, _classnames2.default)(className, _classes), style: style, title: title },
	        input,
	        children
	      );
	    }
	
	    var classes = (0, _extends3.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), {
	      disabled: disabled
	    });
	    if (validationState) {
	      classes['has-' + validationState] = true;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(className, classes), style: style },
	      _react2.default.createElement(
	        'label',
	        { title: title },
	        input,
	        children
	      )
	    );
	  };
	
	  return Radio;
	}(_react2.default.Component);
	
	Radio.propTypes = propTypes;
	Radio.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('radio', Radio);
	module.exports = exports['default'];

/***/ },
/* 2697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TODO: This should probably take a single `aspectRatio` prop.
	
	var propTypes = {
	  /**
	   * This component requires a single child element
	   */
	  children: _propTypes2.default.element.isRequired,
	  /**
	   * 16by9 aspect ratio
	   */
	  a16by9: _propTypes2.default.bool,
	  /**
	   * 4by3 aspect ratio
	   */
	  a4by3: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  a16by9: false,
	  a4by3: false
	};
	
	var ResponsiveEmbed = function (_React$Component) {
	  (0, _inherits3.default)(ResponsiveEmbed, _React$Component);
	
	  function ResponsiveEmbed() {
	    (0, _classCallCheck3.default)(this, ResponsiveEmbed);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ResponsiveEmbed.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        a16by9 = _props.a16by9,
	        a4by3 = _props.a4by3,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['a16by9', 'a4by3', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	     false ? (0, _warning2.default)(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
	     false ? (0, _warning2.default)(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '16by9')] = a16by9, _extends2[(0, _bootstrapUtils.prefix)(bsProps, '4by3')] = a4by3, _extends2));
	
	    return _react2.default.createElement(
	      'div',
	      { className: (0, _classnames2.default)(classes) },
	      (0, _react.cloneElement)(children, (0, _extends4.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, (0, _bootstrapUtils.prefix)(bsProps, 'item'))
	      }))
	    );
	  };
	
	  return ResponsiveEmbed;
	}(_react2.default.Component);
	
	ResponsiveEmbed.propTypes = propTypes;
	ResponsiveEmbed.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('embed-responsive', ResponsiveEmbed);
	module.exports = exports['default'];

/***/ },
/* 2698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  componentClass: _elementType2.default
	};
	
	var defaultProps = {
	  componentClass: 'div'
	};
	
	var Row = function (_React$Component) {
	  (0, _inherits3.default)(Row, _React$Component);
	
	  function Row() {
	    (0, _classCallCheck3.default)(this, Row);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Row.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.componentClass,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['componentClass', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(Component, (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Row;
	}(_react2.default.Component);
	
	Row.propTypes = propTypes;
	Row.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('row', Row);
	module.exports = exports['default'];

/***/ },
/* 2699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(241);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Dropdown = __webpack_require__(331);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	var _SplitToggle = __webpack_require__(2700);
	
	var _SplitToggle2 = _interopRequireDefault(_SplitToggle);
	
	var _splitComponentProps2 = __webpack_require__(334);
	
	var _splitComponentProps3 = _interopRequireDefault(_splitComponentProps2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _Dropdown2.default.propTypes, {
	
	  // Toggle props.
	  bsStyle: _propTypes2.default.string,
	  bsSize: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  /**
	   * The content of the split button.
	   */
	  title: _propTypes2.default.node.isRequired,
	  /**
	   * Accessible label for the toggle; the value of `title` if not specified.
	   */
	  toggleLabel: _propTypes2.default.string,
	
	  // Override generated docs from <Dropdown>.
	  /**
	   * @private
	   */
	  children: _propTypes2.default.node
	});
	
	var SplitButton = function (_React$Component) {
	  (0, _inherits3.default)(SplitButton, _React$Component);
	
	  function SplitButton() {
	    (0, _classCallCheck3.default)(this, SplitButton);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitButton.prototype.render = function render() {
	    var _props = this.props,
	        bsSize = _props.bsSize,
	        bsStyle = _props.bsStyle,
	        title = _props.title,
	        toggleLabel = _props.toggleLabel,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);
	
	    var _splitComponentProps = (0, _splitComponentProps3.default)(props, _Dropdown2.default.ControlledComponent),
	        dropdownProps = _splitComponentProps[0],
	        buttonProps = _splitComponentProps[1];
	
	    return _react2.default.createElement(
	      _Dropdown2.default,
	      (0, _extends3.default)({}, dropdownProps, {
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Button2.default,
	        (0, _extends3.default)({}, buttonProps, {
	          disabled: props.disabled,
	          bsSize: bsSize,
	          bsStyle: bsStyle
	        }),
	        title
	      ),
	      _react2.default.createElement(_SplitToggle2.default, {
	        'aria-label': toggleLabel || title,
	        bsSize: bsSize,
	        bsStyle: bsStyle
	      }),
	      _react2.default.createElement(
	        _Dropdown2.default.Menu,
	        null,
	        children
	      )
	    );
	  };
	
	  return SplitButton;
	}(_react2.default.Component);
	
	SplitButton.propTypes = propTypes;
	
	SplitButton.Toggle = _SplitToggle2.default;
	
	exports.default = SplitButton;
	module.exports = exports['default'];

/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropdownToggle = __webpack_require__(1201);
	
	var _DropdownToggle2 = _interopRequireDefault(_DropdownToggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SplitToggle = function (_React$Component) {
	  (0, _inherits3.default)(SplitToggle, _React$Component);
	
	  function SplitToggle() {
	    (0, _classCallCheck3.default)(this, SplitToggle);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  SplitToggle.prototype.render = function render() {
	    return _react2.default.createElement(_DropdownToggle2.default, (0, _extends3.default)({}, this.props, {
	      useAnchor: false,
	      noCaret: false
	    }));
	  };
	
	  return SplitToggle;
	}(_react2.default.Component);
	
	SplitToggle.defaultProps = _DropdownToggle2.default.defaultProps;
	
	exports.default = SplitToggle;
	module.exports = exports['default'];

/***/ },
/* 2701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TabContainer = __webpack_require__(488);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(489);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _TabPane = __webpack_require__(1215);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = (0, _extends3.default)({}, _TabPane2.default.propTypes, {
	
	  disabled: _propTypes2.default.bool,
	
	  title: _propTypes2.default.node,
	
	  /**
	   * tabClassName is used as className for the associated NavItem
	   */
	  tabClassName: _propTypes2.default.string
	});
	
	var Tab = function (_React$Component) {
	  (0, _inherits3.default)(Tab, _React$Component);
	
	  function Tab() {
	    (0, _classCallCheck3.default)(this, Tab);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tab.prototype.render = function render() {
	    var props = (0, _extends3.default)({}, this.props);
	
	    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
	    delete props.title;
	    delete props.disabled;
	    delete props.tabClassName;
	
	    return _react2.default.createElement(_TabPane2.default, props);
	  };
	
	  return Tab;
	}(_react2.default.Component);
	
	Tab.propTypes = propTypes;
	
	Tab.Container = _TabContainer2.default;
	Tab.Content = _TabContent2.default;
	Tab.Pane = _TabPane2.default;
	
	exports.default = Tab;
	module.exports = exports['default'];

/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  striped: _propTypes2.default.bool,
	  bordered: _propTypes2.default.bool,
	  condensed: _propTypes2.default.bool,
	  hover: _propTypes2.default.bool,
	  responsive: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bordered: false,
	  condensed: false,
	  hover: false,
	  responsive: false,
	  striped: false
	};
	
	var Table = function (_React$Component) {
	  (0, _inherits3.default)(Table, _React$Component);
	
	  function Table() {
	    (0, _classCallCheck3.default)(this, Table);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Table.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        striped = _props.striped,
	        bordered = _props.bordered,
	        condensed = _props.condensed,
	        hover = _props.hover,
	        responsive = _props.responsive,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'striped')] = striped, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'bordered')] = bordered, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'condensed')] = condensed, _extends2[(0, _bootstrapUtils.prefix)(bsProps, 'hover')] = hover, _extends2));
	
	    var table = _react2.default.createElement('table', (0, _extends4.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	
	    if (responsive) {
	      return _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'responsive') },
	        table
	      );
	    }
	
	    return table;
	  };
	
	  return Table;
	}(_react2.default.Component);
	
	Table.propTypes = propTypes;
	Table.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('table', Table);
	module.exports = exports['default'];

/***/ },
/* 2703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(324);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _uncontrollable = __webpack_require__(267);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _Nav = __webpack_require__(1208);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _NavItem = __webpack_require__(1209);
	
	var _NavItem2 = _interopRequireDefault(_NavItem);
	
	var _TabContainer = __webpack_require__(488);
	
	var _TabContainer2 = _interopRequireDefault(_TabContainer);
	
	var _TabContent = __webpack_require__(489);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TabContainer = _TabContainer2.default.ControlledComponent;
	
	var propTypes = {
	  /**
	   * Mark the Tab with a matching `eventKey` as active.
	   *
	   * @controllable onSelect
	   */
	  activeKey: _propTypes2.default.any,
	
	  /**
	   * Navigation style
	   */
	  bsStyle: _propTypes2.default.oneOf(['tabs', 'pills']),
	
	  animation: _propTypes2.default.bool,
	
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Callback fired when a Tab is selected.
	   *
	   * ```js
	   * function (
	   *   Any eventKey,
	   *   SyntheticEvent event?
	   * )
	   * ```
	   *
	   * @controllable activeKey
	   */
	  onSelect: _propTypes2.default.func,
	
	  /**
	   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
	   */
	  mountOnEnter: _propTypes2.default.bool,
	
	  /**
	   * Unmount tabs (remove it from the DOM) when it is no longer visible
	   */
	  unmountOnExit: _propTypes2.default.bool
	};
	
	var defaultProps = {
	  bsStyle: 'tabs',
	  animation: true,
	  mountOnEnter: false,
	  unmountOnExit: false
	};
	
	function getDefaultActiveKey(children) {
	  var defaultActiveKey = void 0;
	  _ValidComponentChildren2.default.forEach(children, function (child) {
	    if (defaultActiveKey == null) {
	      defaultActiveKey = child.props.eventKey;
	    }
	  });
	
	  return defaultActiveKey;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3.default)(Tabs, _React$Component);
	
	  function Tabs() {
	    (0, _classCallCheck3.default)(this, Tabs);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tabs.prototype.renderTab = function renderTab(child) {
	    var _child$props = child.props,
	        title = _child$props.title,
	        eventKey = _child$props.eventKey,
	        disabled = _child$props.disabled,
	        tabClassName = _child$props.tabClassName;
	
	    if (title == null) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      _NavItem2.default,
	      {
	        eventKey: eventKey,
	        disabled: disabled,
	        className: tabClassName
	      },
	      title
	    );
	  };
	
	  Tabs.prototype.render = function render() {
	    var _props = this.props,
	        id = _props.id,
	        onSelect = _props.onSelect,
	        animation = _props.animation,
	        mountOnEnter = _props.mountOnEnter,
	        unmountOnExit = _props.unmountOnExit,
	        bsClass = _props.bsClass,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        _props$activeKey = _props.activeKey,
	        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
	        props = (0, _objectWithoutProperties3.default)(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);
	
	
	    return _react2.default.createElement(
	      TabContainer,
	      {
	        id: id,
	        activeKey: activeKey,
	        onSelect: onSelect,
	        className: className,
	        style: style
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Nav2.default,
	          (0, _extends3.default)({}, props, {
	            role: 'tablist'
	          }),
	          _ValidComponentChildren2.default.map(children, this.renderTab)
	        ),
	        _react2.default.createElement(
	          _TabContent2.default,
	          {
	            bsClass: bsClass,
	            animation: animation,
	            mountOnEnter: mountOnEnter,
	            unmountOnExit: unmountOnExit
	          },
	          children
	        )
	      )
	    );
	  };
	
	  return Tabs;
	}(_react2.default.Component);
	
	Tabs.propTypes = propTypes;
	Tabs.defaultProps = defaultProps;
	
	(0, _bootstrapUtils.bsClass)('tab', Tabs);
	
	exports.default = (0, _uncontrollable2.default)(Tabs, { activeKey: 'onSelect' });
	module.exports = exports['default'];

/***/ },
/* 2704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SafeAnchor = __webpack_require__(102);
	
	var _SafeAnchor2 = _interopRequireDefault(_SafeAnchor);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * src property that is passed down to the image inside this component
	   */
	  src: _propTypes2.default.string,
	  /**
	   * alt property that is passed down to the image inside this component
	   */
	  alt: _propTypes2.default.string,
	  /**
	   * href property that is passed down to the image inside this component
	   */
	  href: _propTypes2.default.string,
	  /**
	   * onError callback that is passed down to the image inside this component
	   */
	  onError: _propTypes2.default.func,
	  /**
	   * onLoad callback that is passed down to the image inside this component
	   */
	  onLoad: _propTypes2.default.func
	}; /* eslint-disable jsx-a11y/alt-text */
	
	var Thumbnail = function (_React$Component) {
	  (0, _inherits3.default)(Thumbnail, _React$Component);
	
	  function Thumbnail() {
	    (0, _classCallCheck3.default)(this, Thumbnail);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Thumbnail.prototype.render = function render() {
	    var _props = this.props,
	        src = _props.src,
	        alt = _props.alt,
	        onError = _props.onError,
	        onLoad = _props.onLoad,
	        className = _props.className,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var Component = elementProps.href ? _SafeAnchor2.default : 'div';
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement(
	      Component,
	      (0, _extends3.default)({}, elementProps, {
	        className: (0, _classnames2.default)(className, classes)
	      }),
	      _react2.default.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
	      children && _react2.default.createElement(
	        'div',
	        { className: 'caption' },
	        children
	      )
	    );
	  };
	
	  return Thumbnail;
	}(_react2.default.Component);
	
	Thumbnail.propTypes = propTypes;
	
	exports.default = (0, _bootstrapUtils.bsClass)('thumbnail', Thumbnail);
	module.exports = exports['default'];

/***/ },
/* 2705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _uncontrollable = __webpack_require__(267);
	
	var _uncontrollable2 = _interopRequireDefault(_uncontrollable);
	
	var _createChainedFunction = __webpack_require__(47);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	var _ButtonGroup = __webpack_require__(484);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ToggleButton = __webpack_require__(1216);
	
	var _ToggleButton2 = _interopRequireDefault(_ToggleButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An HTML `<input>` name for each child button.
	   *
	   * __Required if `type` is set to `'radio'`__
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * The value, or array of values, of the active (pressed) buttons
	   *
	   * @controllable onChange
	   */
	  value: _propTypes2.default.any,
	
	  /**
	   * Callback fired when a button is pressed, depending on whether the `type`
	   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
	   * array of active values
	   *
	   * @controllable values
	   */
	  onChange: _propTypes2.default.func,
	
	  /**
	   * The input `type` of the rendered buttons, determines the toggle behavior
	   * of the buttons
	   */
	  type: _propTypes2.default.oneOf(['checkbox', 'radio']).isRequired
	};
	
	var defaultProps = {
	  type: 'radio'
	};
	
	var ToggleButtonGroup = function (_React$Component) {
	  (0, _inherits3.default)(ToggleButtonGroup, _React$Component);
	
	  function ToggleButtonGroup() {
	    (0, _classCallCheck3.default)(this, ToggleButtonGroup);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  ToggleButtonGroup.prototype.getValues = function getValues() {
	    var value = this.props.value;
	
	    return value == null ? [] : [].concat(value);
	  };
	
	  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
	    var _props = this.props,
	        type = _props.type,
	        onChange = _props.onChange;
	
	    var values = this.getValues();
	    var isActive = values.indexOf(value) !== -1;
	
	    if (type === 'radio') {
	      if (!isActive) {
	        onChange(value);
	      }
	      return;
	    }
	
	    if (isActive) {
	      onChange(values.filter(function (n) {
	        return n !== value;
	      }));
	    } else {
	      onChange([].concat(values, [value]));
	    }
	  };
	
	  ToggleButtonGroup.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props2 = this.props,
	        children = _props2.children,
	        type = _props2.type,
	        name = _props2.name,
	        props = (0, _objectWithoutProperties3.default)(_props2, ['children', 'type', 'name']);
	
	
	    var values = this.getValues();
	
	    !(type !== 'radio' || !!name) ?  false ? (0, _invariant2.default)(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : (0, _invariant2.default)(false) : void 0;
	
	    delete props.onChange;
	    delete props.value;
	
	    // the data attribute is required b/c twbs css uses it in the selector
	    return _react2.default.createElement(
	      _ButtonGroup2.default,
	      (0, _extends3.default)({}, props, { 'data-toggle': 'buttons' }),
	      _ValidComponentChildren2.default.map(children, function (child) {
	        var _child$props = child.props,
	            value = _child$props.value,
	            onChange = _child$props.onChange;
	
	        var handler = function handler() {
	          return _this2.handleToggle(value);
	        };
	
	        return _react2.default.cloneElement(child, {
	          type: type,
	          name: child.name || name,
	          checked: values.indexOf(value) !== -1,
	          onChange: (0, _createChainedFunction2.default)(onChange, handler)
	        });
	      })
	    );
	  };
	
	  return ToggleButtonGroup;
	}(_react2.default.Component);
	
	ToggleButtonGroup.propTypes = propTypes;
	ToggleButtonGroup.defaultProps = defaultProps;
	
	var UncontrolledToggleButtonGroup = (0, _uncontrollable2.default)(ToggleButtonGroup, {
	  value: 'onChange'
	});
	
	UncontrolledToggleButtonGroup.Button = _ToggleButton2.default;
	
	exports.default = UncontrolledToggleButtonGroup;
	module.exports = exports['default'];

/***/ },
/* 2706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(3);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _isRequiredForA11y = __webpack_require__(324);
	
	var _isRequiredForA11y2 = _interopRequireDefault(_isRequiredForA11y);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * An html id attribute, necessary for accessibility
	   * @type {string|number}
	   * @required
	   */
	  id: (0, _isRequiredForA11y2.default)(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
	
	  /**
	   * Sets the direction the Tooltip is positioned towards.
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	
	  /**
	   * The "top" position value for the Tooltip.
	   */
	  positionTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip.
	   */
	  positionLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	
	  /**
	   * The "top" position value for the Tooltip arrow.
	   */
	  arrowOffsetTop: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  /**
	   * The "left" position value for the Tooltip arrow.
	   */
	  arrowOffsetLeft: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	var defaultProps = {
	  placement: 'right'
	};
	
	var Tooltip = function (_React$Component) {
	  (0, _inherits3.default)(Tooltip, _React$Component);
	
	  function Tooltip() {
	    (0, _classCallCheck3.default)(this, Tooltip);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Tooltip.prototype.render = function render() {
	    var _extends2;
	
	    var _props = this.props,
	        placement = _props.placement,
	        positionTop = _props.positionTop,
	        positionLeft = _props.positionLeft,
	        arrowOffsetTop = _props.arrowOffsetTop,
	        arrowOffsetLeft = _props.arrowOffsetLeft,
	        className = _props.className,
	        style = _props.style,
	        children = _props.children,
	        props = (0, _objectWithoutProperties3.default)(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _extends4.default)({}, (0, _bootstrapUtils.getClassSet)(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));
	
	    var outerStyle = (0, _extends4.default)({
	      top: positionTop,
	      left: positionLeft
	    }, style);
	
	    var arrowStyle = {
	      top: arrowOffsetTop,
	      left: arrowOffsetLeft
	    };
	
	    return _react2.default.createElement(
	      'div',
	      (0, _extends4.default)({}, elementProps, {
	        role: 'tooltip',
	        className: (0, _classnames2.default)(className, classes),
	        style: outerStyle
	      }),
	      _react2.default.createElement('div', { className: (0, _bootstrapUtils.prefix)(bsProps, 'arrow'), style: arrowStyle }),
	      _react2.default.createElement(
	        'div',
	        { className: (0, _bootstrapUtils.prefix)(bsProps, 'inner') },
	        children
	      )
	    );
	  };
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes = propTypes;
	Tooltip.defaultProps = defaultProps;
	
	exports.default = (0, _bootstrapUtils.bsClass)('tooltip', Tooltip);
	module.exports = exports['default'];

/***/ },
/* 2707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bootstrapUtils = __webpack_require__(15);
	
	var _StyleConfig = __webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Well = function (_React$Component) {
	  (0, _inherits3.default)(Well, _React$Component);
	
	  function Well() {
	    (0, _classCallCheck3.default)(this, Well);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Well.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        props = (0, _objectWithoutProperties3.default)(_props, ['className']);
	
	    var _splitBsProps = (0, _bootstrapUtils.splitBsProps)(props),
	        bsProps = _splitBsProps[0],
	        elementProps = _splitBsProps[1];
	
	    var classes = (0, _bootstrapUtils.getClassSet)(bsProps);
	
	    return _react2.default.createElement('div', (0, _extends3.default)({}, elementProps, {
	      className: (0, _classnames2.default)(className, classes)
	    }));
	  };
	
	  return Well;
	}(_react2.default.Component);
	
	exports.default = (0, _bootstrapUtils.bsClass)('well', (0, _bootstrapUtils.bsSizes)([_StyleConfig.Size.LARGE, _StyleConfig.Size.SMALL], Well));
	module.exports = exports['default'];

/***/ },
/* 2708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.requiredRoles = requiredRoles;
	exports.exclusiveRoles = exclusiveRoles;
	
	var _createChainableTypeChecker = __webpack_require__(325);
	
	var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);
	
	var _ValidComponentChildren = __webpack_require__(68);
	
	var _ValidComponentChildren2 = _interopRequireDefault(_ValidComponentChildren);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requiredRoles() {
	  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
	    roles[_key] = arguments[_key];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var missing = void 0;
	
	    roles.every(function (role) {
	      if (!_ValidComponentChildren2.default.some(props.children, function (child) {
	        return child.props.bsRole === role;
	      })) {
	        missing = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (missing) {
	      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}
	
	function exclusiveRoles() {
	  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    roles[_key2] = arguments[_key2];
	  }
	
	  return (0, _createChainableTypeChecker2.default)(function (props, propName, component) {
	    var duplicate = void 0;
	
	    roles.every(function (role) {
	      var childrenWithRole = _ValidComponentChildren2.default.filter(props.children, function (child) {
	        return child.props.bsRole === role;
	      });
	
	      if (childrenWithRole.length > 1) {
	        duplicate = role;
	        return false;
	      }
	
	      return true;
	    });
	
	    if (duplicate) {
	      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
	    }
	
	    return null;
	  });
	}

/***/ },
/* 2709 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Copyright 2013-2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This file contains a modified version of:
	 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
	 *
	 * This source code is licensed under the BSD-style license found here:
	 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
	 * An additional grant of patent rights can be found here:
	 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
	 */
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    // eslint-disable-line guard-for-in
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      // eslint-disable-line guard-for-in
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports.default = ReactTransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 2710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(52);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function deprecationWarning(oldname, newname, link) {
	  var message = void 0;
	
	  if ((typeof oldname === 'undefined' ? 'undefined' : (0, _typeof3.default)(oldname)) === 'object') {
	    message = oldname.message;
	  } else {
	    message = oldname + ' is deprecated. Use ' + newname + ' instead.';
	
	    if (link) {
	      message += '\nYou can read more about it at ' + link;
	    }
	  }
	
	  if (warned[message]) {
	    return;
	  }
	
	   false ? (0, _warning2.default)(false, message) : void 0;
	  warned[message] = true;
	}
	
	deprecationWarning.wrapper = function (Component) {
	  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  return function (_Component) {
	    (0, _inherits3.default)(DeprecatedComponent, _Component);
	
	    function DeprecatedComponent() {
	      (0, _classCallCheck3.default)(this, DeprecatedComponent);
	      return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	    }
	
	    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
	      deprecationWarning.apply(undefined, args);
	
	      if (_Component.prototype.componentWillMount) {
	        var _Component$prototype$;
	
	        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	          methodArgs[_key2] = arguments[_key2];
	        }
	
	        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
	      }
	    };
	
	    return DeprecatedComponent;
	  }(Component);
	};
	
	exports.default = deprecationWarning;
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 2711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ValidComponentChildren = exports.createChainedFunction = exports.bootstrapUtils = undefined;
	
	var _bootstrapUtils2 = __webpack_require__(15);
	
	var _bootstrapUtils = _interopRequireWildcard(_bootstrapUtils2);
	
	var _createChainedFunction2 = __webpack_require__(47);
	
	var _createChainedFunction3 = _interopRequireDefault(_createChainedFunction2);
	
	var _ValidComponentChildren2 = __webpack_require__(68);
	
	var _ValidComponentChildren3 = _interopRequireDefault(_ValidComponentChildren2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.bootstrapUtils = _bootstrapUtils;
	exports.createChainedFunction = _createChainedFunction3.default;
	exports.ValidComponentChildren = _ValidComponentChildren3.default;

/***/ },
/* 2712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Chart = exports.defaults = exports.Scatter = exports.Bubble = exports.Polar = exports.Radar = exports.HorizontalBar = exports.Bar = exports.Line = exports.Pie = exports.Doughnut = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _chart = __webpack_require__(1812);
	
	var _chart2 = _interopRequireDefault(_chart);
	
	var _isEqual = __webpack_require__(86);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _find = __webpack_require__(2429);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _keyBy = __webpack_require__(2439);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartComponent = function (_React$Component) {
	  _inherits(ChartComponent, _React$Component);
	
	  function ChartComponent() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ChartComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleOnClick = function (event) {
	      var instance = _this.chartInstance;
	
	      var _this$props = _this.props,
	          getDatasetAtEvent = _this$props.getDatasetAtEvent,
	          getElementAtEvent = _this$props.getElementAtEvent,
	          getElementsAtEvent = _this$props.getElementsAtEvent,
	          onElementsClick = _this$props.onElementsClick;
	
	
	      getDatasetAtEvent && getDatasetAtEvent(instance.getDatasetAtEvent(event), event);
	      getElementAtEvent && getElementAtEvent(instance.getElementAtEvent(event), event);
	      getElementsAtEvent && getElementsAtEvent(instance.getElementsAtEvent(event), event);
	      onElementsClick && onElementsClick(instance.getElementsAtEvent(event), event); // Backward compatibility
	    }, _this.ref = function (element) {
	      _this.element = element;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ChartComponent.prototype.componentWillMount = function componentWillMount() {
	    this.chartInstance = undefined;
	  };
	
	  ChartComponent.prototype.componentDidMount = function componentDidMount() {
	    this.renderChart();
	  };
	
	  ChartComponent.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (this.props.redraw) {
	      this.chartInstance.destroy();
	      this.renderChart();
	      return;
	    }
	
	    this.updateChart();
	  };
	
	  ChartComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var _props = this.props,
	        redraw = _props.redraw,
	        type = _props.type,
	        options = _props.options,
	        plugins = _props.plugins,
	        legend = _props.legend,
	        height = _props.height,
	        width = _props.width;
	
	
	    if (nextProps.redraw === true) {
	      return true;
	    }
	
	    if (height !== nextProps.height || width !== nextProps.width) {
	      return true;
	    }
	
	    if (type !== nextProps.type) {
	      return true;
	    }
	
	    if (!(0, _isEqual2.default)(legend, nextProps.legend)) {
	      return true;
	    }
	
	    if (!(0, _isEqual2.default)(options, nextProps.options)) {
	      return true;
	    }
	
	    var nextData = this.transformDataProp(nextProps);
	
	    if (!(0, _isEqual2.default)(this.shadowDataProp, nextData)) {
	      return true;
	    }
	
	    return !(0, _isEqual2.default)(plugins, nextProps.plugins);
	  };
	
	  ChartComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.chartInstance.destroy();
	  };
	
	  ChartComponent.prototype.transformDataProp = function transformDataProp(props) {
	    var data = props.data;
	
	    if (typeof data == 'function') {
	      var node = this.element;
	      return data(node);
	    } else {
	      return data;
	    }
	  };
	
	  // Chart.js directly mutates the data.dataset objects by adding _meta proprerty
	  // this makes impossible to compare the current and next data changes
	  // therefore we memoize the data prop while sending a fake to Chart.js for mutation.
	  // see https://github.com/chartjs/Chart.js/blob/master/src/core/core.controller.js#L615-L617
	
	
	  ChartComponent.prototype.memoizeDataProps = function memoizeDataProps() {
	    if (!this.props.data) {
	      return;
	    }
	
	    var data = this.transformDataProp(this.props);
	
	    this.shadowDataProp = _extends({}, data, {
	      datasets: data.datasets && data.datasets.map(function (set) {
	        return _extends({}, set);
	      })
	    });
	
	    return data;
	  };
	
	  ChartComponent.prototype.updateChart = function updateChart() {
	    var _this2 = this;
	
	    var options = this.props.options;
	
	
	    var data = this.memoizeDataProps(this.props);
	
	    if (!this.chartInstance) return;
	
	    if (options) {
	      this.chartInstance.options = _chart2.default.helpers.configMerge(this.chartInstance.options, options);
	    }
	
	    // Pipe datasets to chart instance datasets enabling
	    // seamless transitions
	    var currentDatasets = this.chartInstance.config.data && this.chartInstance.config.data.datasets || [];
	    var nextDatasets = data.datasets || [];
	
	    var currentDatasetsIndexed = (0, _keyBy2.default)(currentDatasets, this.props.datasetKeyProvider);
	
	    // We can safely replace the dataset array, as long as we retain the _meta property
	    // on each dataset.
	    this.chartInstance.config.data.datasets = nextDatasets.map(function (next) {
	      var current = currentDatasetsIndexed[_this2.props.datasetKeyProvider(next)];
	      if (current && current.type === next.type) {
	        // The data array must be edited in place. As chart.js adds listeners to it.
	        current.data.splice(next.data.length);
	        next.data.forEach(function (point, pid) {
	          current.data[pid] = next.data[pid];
	        });
	
	        var _data = next.data,
	            otherProps = _objectWithoutProperties(next, ['data']);
	        // Merge properties. Notice a weakness here. If a property is removed
	        // from next, it will be retained by current and never disappears.
	        // Workaround is to set value to null or undefined in next.
	
	
	        return _extends({}, current, otherProps);
	      } else {
	        return next;
	      }
	    });
	
	    var datasets = data.datasets,
	        rest = _objectWithoutProperties(data, ['datasets']);
	
	    this.chartInstance.config.data = _extends({}, this.chartInstance.config.data, rest);
	
	    this.chartInstance.update();
	  };
	
	  ChartComponent.prototype.renderChart = function renderChart() {
	    var _props2 = this.props,
	        options = _props2.options,
	        legend = _props2.legend,
	        type = _props2.type,
	        redraw = _props2.redraw,
	        plugins = _props2.plugins;
	
	    var node = this.element;
	    var data = this.memoizeDataProps();
	
	    if (typeof legend !== 'undefined' && !(0, _isEqual2.default)(ChartComponent.defaultProps.legend, legend)) {
	      options.legend = legend;
	    }
	
	    this.chartInstance = new _chart2.default(node, {
	      type: type,
	      data: data,
	      options: options,
	      plugins: plugins
	    });
	  };
	
	  ChartComponent.prototype.render = function render() {
	    var _props3 = this.props,
	        height = _props3.height,
	        width = _props3.width,
	        onElementsClick = _props3.onElementsClick;
	
	
	    return _react2.default.createElement('canvas', {
	      ref: this.ref,
	      height: height,
	      width: width,
	      onClick: this.handleOnClick
	    });
	  };
	
	  return ChartComponent;
	}(_react2.default.Component);
	
	ChartComponent.getLabelAsKey = function (d) {
	  return d.label;
	};
	
	ChartComponent.propTypes = {
	  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]).isRequired,
	  getDatasetAtEvent: _propTypes2.default.func,
	  getElementAtEvent: _propTypes2.default.func,
	  getElementsAtEvent: _propTypes2.default.func,
	  height: _propTypes2.default.number,
	  legend: _propTypes2.default.object,
	  onElementsClick: _propTypes2.default.func,
	  options: _propTypes2.default.object,
	  plugins: _propTypes2.default.arrayOf(_propTypes2.default.object),
	  redraw: _propTypes2.default.bool,
	  type: function type(props, propName, componentName) {
	    if (!_chart2.default.controllers[props[propName]]) {
	      return new Error('Invalid chart type `' + props[propName] + '` supplied to' + ' `' + componentName + '`.');
	    }
	  },
	  width: _propTypes2.default.number,
	  datasetKeyProvider: _propTypes2.default.func
	};
	ChartComponent.defaultProps = {
	  legend: {
	    display: true,
	    position: 'bottom'
	  },
	  type: 'doughnut',
	  height: 150,
	  width: 300,
	  redraw: false,
	  options: {},
	  datasetKeyProvider: ChartComponent.getLabelAsKey
	};
	exports.default = ChartComponent;
	
	var Doughnut = exports.Doughnut = function (_React$Component2) {
	  _inherits(Doughnut, _React$Component2);
	
	  function Doughnut() {
	    _classCallCheck(this, Doughnut);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  Doughnut.prototype.render = function render() {
	    var _this4 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref) {
	        return _this4.chartInstance = _ref && _ref.chartInstance;
	      },
	      type: 'doughnut'
	    }));
	  };
	
	  return Doughnut;
	}(_react2.default.Component);
	
	var Pie = exports.Pie = function (_React$Component3) {
	  _inherits(Pie, _React$Component3);
	
	  function Pie() {
	    _classCallCheck(this, Pie);
	
	    return _possibleConstructorReturn(this, _React$Component3.apply(this, arguments));
	  }
	
	  Pie.prototype.render = function render() {
	    var _this6 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref2) {
	        return _this6.chartInstance = _ref2 && _ref2.chartInstance;
	      },
	      type: 'pie'
	    }));
	  };
	
	  return Pie;
	}(_react2.default.Component);
	
	var Line = exports.Line = function (_React$Component4) {
	  _inherits(Line, _React$Component4);
	
	  function Line() {
	    _classCallCheck(this, Line);
	
	    return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
	  }
	
	  Line.prototype.render = function render() {
	    var _this8 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref3) {
	        return _this8.chartInstance = _ref3 && _ref3.chartInstance;
	      },
	      type: 'line'
	    }));
	  };
	
	  return Line;
	}(_react2.default.Component);
	
	var Bar = exports.Bar = function (_React$Component5) {
	  _inherits(Bar, _React$Component5);
	
	  function Bar() {
	    _classCallCheck(this, Bar);
	
	    return _possibleConstructorReturn(this, _React$Component5.apply(this, arguments));
	  }
	
	  Bar.prototype.render = function render() {
	    var _this10 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref4) {
	        return _this10.chartInstance = _ref4 && _ref4.chartInstance;
	      },
	      type: 'bar'
	    }));
	  };
	
	  return Bar;
	}(_react2.default.Component);
	
	var HorizontalBar = exports.HorizontalBar = function (_React$Component6) {
	  _inherits(HorizontalBar, _React$Component6);
	
	  function HorizontalBar() {
	    _classCallCheck(this, HorizontalBar);
	
	    return _possibleConstructorReturn(this, _React$Component6.apply(this, arguments));
	  }
	
	  HorizontalBar.prototype.render = function render() {
	    var _this12 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref5) {
	        return _this12.chartInstance = _ref5 && _ref5.chartInstance;
	      },
	      type: 'horizontalBar'
	    }));
	  };
	
	  return HorizontalBar;
	}(_react2.default.Component);
	
	var Radar = exports.Radar = function (_React$Component7) {
	  _inherits(Radar, _React$Component7);
	
	  function Radar() {
	    _classCallCheck(this, Radar);
	
	    return _possibleConstructorReturn(this, _React$Component7.apply(this, arguments));
	  }
	
	  Radar.prototype.render = function render() {
	    var _this14 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref6) {
	        return _this14.chartInstance = _ref6 && _ref6.chartInstance;
	      },
	      type: 'radar'
	    }));
	  };
	
	  return Radar;
	}(_react2.default.Component);
	
	var Polar = exports.Polar = function (_React$Component8) {
	  _inherits(Polar, _React$Component8);
	
	  function Polar() {
	    _classCallCheck(this, Polar);
	
	    return _possibleConstructorReturn(this, _React$Component8.apply(this, arguments));
	  }
	
	  Polar.prototype.render = function render() {
	    var _this16 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref7) {
	        return _this16.chartInstance = _ref7 && _ref7.chartInstance;
	      },
	      type: 'polarArea'
	    }));
	  };
	
	  return Polar;
	}(_react2.default.Component);
	
	var Bubble = exports.Bubble = function (_React$Component9) {
	  _inherits(Bubble, _React$Component9);
	
	  function Bubble() {
	    _classCallCheck(this, Bubble);
	
	    return _possibleConstructorReturn(this, _React$Component9.apply(this, arguments));
	  }
	
	  Bubble.prototype.render = function render() {
	    var _this18 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref8) {
	        return _this18.chartInstance = _ref8 && _ref8.chartInstance;
	      },
	      type: 'bubble'
	    }));
	  };
	
	  return Bubble;
	}(_react2.default.Component);
	
	var Scatter = exports.Scatter = function (_React$Component10) {
	  _inherits(Scatter, _React$Component10);
	
	  function Scatter() {
	    _classCallCheck(this, Scatter);
	
	    return _possibleConstructorReturn(this, _React$Component10.apply(this, arguments));
	  }
	
	  Scatter.prototype.render = function render() {
	    var _this20 = this;
	
	    return _react2.default.createElement(ChartComponent, _extends({}, this.props, {
	      ref: function ref(_ref9) {
	        return _this20.chartInstance = _ref9 && _ref9.chartInstance;
	      },
	      type: 'scatter'
	    }));
	  };
	
	  return Scatter;
	}(_react2.default.Component);
	
	var defaults = exports.defaults = _chart2.default.defaults;
	exports.Chart = _chart2.default;

/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports.CircularProgressbar=t(require("react")):e.CircularProgressbar=t(e.React)}(this,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.i=function(e){return e},t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=7)}([function(e,t,r){"use strict";function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}Object.defineProperty(t,"__esModule",{value:!0});var s=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),u=r(6),c=n(u),l=r(4),p=n(l),f=function(e){function t(e){o(this,t);var r=a(this,(t.__proto__||Object.getPrototypeOf(t)).call(this,e));return r.state={percentage:e.initialAnimation?0:e.percentage},r}return i(t,e),s(t,[{key:"componentDidMount",value:function(){var e=this;this.props.initialAnimation&&(this.initialTimeout=setTimeout(function(){e.requestAnimationFrame=window.requestAnimationFrame(function(){e.setState({percentage:e.props.percentage})})},0))}},{key:"componentWillReceiveProps",value:function(e){this.setState({percentage:e.percentage})}},{key:"componentWillUnmount",value:function(){clearTimeout(this.initialTimeout),window.cancelAnimationFrame(this.requestAnimationFrame)}},{key:"getBackgroundPadding",value:function(){return this.props.background?null==this.props.backgroundPadding?this.props.strokeWidth:this.props.backgroundPadding:0}},{key:"getPathDescription",value:function(){var e=this.getPathRadius(),t=this.props.counterClockwise?1:0;return"\n      M 50,50\n      m 0,-"+e+"\n      a "+e+","+e+" "+t+" 1 1 0,"+2*e+"\n      a "+e+","+e+" "+t+" 1 1 0,-"+2*e+"\n    "}},{key:"getPathStyles",value:function(){var e=2*Math.PI*this.getPathRadius(),t=Math.min(Math.max(this.state.percentage,0),100),r=(100-t)/100*e;return{strokeDasharray:e+"px "+e+"px",strokeDashoffset:(this.props.counterClockwise?-r:r)+"px"}}},{key:"getPathRadius",value:function(){return 50-this.props.strokeWidth/2-this.getBackgroundPadding()}},{key:"render",value:function(){var e=this.props,t=e.percentage,r=e.textForPercentage,n=e.className,o=e.classes,a=e.styles,i=e.strokeWidth,s=this.props.classForPercentage?this.props.classForPercentage(t):"",u=this.getPathDescription(),l=r?r(t):null;return c.default.createElement("svg",{className:o.root+" "+n+" "+s,viewBox:"0 0 100 100"},this.props.background?c.default.createElement("circle",{className:o.background,style:a.background,cx:50,cy:50,r:50}):null,c.default.createElement("path",{className:o.trail,style:a.trail,d:u,strokeWidth:i,fillOpacity:0}),c.default.createElement("path",{className:o.path,d:u,strokeWidth:i,fillOpacity:0,style:Object.assign({},a.path,this.getPathStyles())}),l?c.default.createElement("text",{className:o.text,style:a.text,x:50,y:50},l):null)}}]),t}(c.default.Component);f.propTypes={percentage:p.default.number.isRequired,className:p.default.string,classes:p.default.objectOf(p.default.string),styles:p.default.objectOf(p.default.object),strokeWidth:p.default.number,background:p.default.bool,backgroundPadding:p.default.number,initialAnimation:p.default.bool,counterClockwise:p.default.bool,classForPercentage:p.default.func,textForPercentage:p.default.func},f.defaultProps={strokeWidth:8,className:"",classes:{root:"CircularProgressbar",trail:"CircularProgressbar-trail",path:"CircularProgressbar-path",text:"CircularProgressbar-text",background:"CircularProgressbar-background"},styles:{root:{},trail:{},path:{},text:{},background:{}},background:!1,backgroundPadding:null,initialAnimation:!1,counterClockwise:!1,classForPercentage:null,textForPercentage:function(e){return e+"%"}},t.default=f},function(e,t,r){"use strict";function n(e){return function(){return e}}var o=function(){};o.thatReturns=n,o.thatReturnsFalse=n(!1),o.thatReturnsTrue=n(!0),o.thatReturnsNull=n(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},e.exports=o},function(e,t,r){"use strict";function n(e,t,r,n,a,i,s,u){if(o(t),!e){var c;if(void 0===t)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[r,n,a,i,s,u],p=0;c=new Error(t.replace(/%s/g,function(){return l[p++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(e){};e.exports=n},function(e,t,r){"use strict";var n=r(1),o=r(2),a=r(5);e.exports=function(){function e(e,t,r,n,i,s){s!==a&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types")}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r}},function(e,t,r){e.exports=r(3)()},function(e,t,r){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,r){t.exports=e},function(e,t,r){e.exports=r(0)}])});

/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _fileSaver = __webpack_require__(2255);
	
	var _xlsx = __webpack_require__(268);
	
	var _xlsx2 = _interopRequireDefault(_xlsx);
	
	var _ExcelSheet = __webpack_require__(1219);
	
	var _ExcelSheet2 = _interopRequireDefault(_ExcelSheet);
	
	var _DataUtil = __webpack_require__(2715);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExcelFile = function (_React$Component) {
	    _inherits(ExcelFile, _React$Component);
	
	    function ExcelFile(props) {
	        _classCallCheck(this, ExcelFile);
	
	        var _this = _possibleConstructorReturn(this, (ExcelFile.__proto__ || Object.getPrototypeOf(ExcelFile)).call(this, props));
	
	        _initialiseProps.call(_this);
	
	        if (_this.props.hideElement) {
	            _this.download();
	        } else {
	            _this.handleDownload = _this.download.bind(_this);
	        }
	
	        _this.createSheetData = _this.createSheetData.bind(_this);
	        return _this;
	    }
	
	    _createClass(ExcelFile, [{
	        key: "createSheetData",
	        value: function createSheetData(sheet) {
	            var columns = sheet.props.children;
	            var sheetData = [_react2.default.Children.map(columns, function (column) {
	                return column.props.label;
	            })];
	            var data = typeof sheet.props.data === 'function' ? sheet.props.data() : sheet.props.data;
	
	            data.forEach(function (row) {
	                var sheetRow = [];
	
	                _react2.default.Children.forEach(columns, function (column) {
	                    var getValue = typeof column.props.value === 'function' ? column.props.value : function (row) {
	                        return row[column.props.value];
	                    };
	                    var itemValue = getValue(row);
	                    sheetRow.push(isNaN(itemValue) ? itemValue || '' : itemValue);
	                });
	
	                sheetData.push(sheetRow);
	            });
	
	            return sheetData;
	        }
	    }, {
	        key: "download",
	        value: function download() {
	            var _this2 = this;
	
	            var wb = {
	                SheetNames: _react2.default.Children.map(this.props.children, function (sheet) {
	                    return sheet.props.name;
	                }),
	                Sheets: {}
	            };
	
	            _react2.default.Children.forEach(this.props.children, function (sheet) {
	                if (typeof sheet.props.dataSet === 'undefined' || sheet.props.dataSet.length === 0) {
	                    wb.Sheets[sheet.props.name] = (0, _DataUtil.excelSheetFromAoA)(_this2.createSheetData(sheet));
	                } else {
	                    wb.Sheets[sheet.props.name] = (0, _DataUtil.excelSheetFromDataSet)(sheet.props.dataSet);
	                }
	            });
	
	            var fileExtension = this.getFileExtension();
	            var fileName = this.getFileName();
	            var wbout = _xlsx2.default.write(wb, { bookType: fileExtension, bookSST: true, type: 'binary' });
	
	            (0, _fileSaver.saveAs)(new Blob([(0, _DataUtil.strToArrBuffer)(wbout)], { type: "application/octet-stream" }), fileName);
	        }
	    }, {
	        key: "getFileName",
	        value: function getFileName() {
	            if (this.props.filename === null || typeof this.props.filename !== 'string') {
	                throw Error('Invalid file name provided');
	            }
	            return this.getFileNameWithExtension(this.props.filename, this.getFileExtension());
	        }
	    }, {
	        key: "getFileExtension",
	        value: function getFileExtension() {
	            var extension = this.props.fileExtension;
	
	            if (extension.length === 0) {
	                var slugs = this.props.filename.split('.');
	                if (slugs.length === 0) {
	                    throw Error('Invalid file name provided');
	                }
	                extension = slugs[slugs.length - 1];
	            }
	
	            if (this.fileExtensions.indexOf(extension) !== -1) {
	                return extension;
	            }
	
	            return this.defaultFileExtension;
	        }
	    }, {
	        key: "getFileNameWithExtension",
	        value: function getFileNameWithExtension(filename, extension) {
	            return filename + "." + extension;
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                hideElement = _props.hideElement,
	                element = _props.element;
	
	
	            if (hideElement) {
	                return null;
	            } else {
	                return _react2.default.createElement(
	                    "span",
	                    { onClick: this.handleDownload },
	                    element
	                );
	            }
	        }
	    }]);
	
	    return ExcelFile;
	}(_react2.default.Component);
	
	ExcelFile.props = {
	    hideElement: _propTypes2.default.bool,
	    filename: _propTypes2.default.string,
	    fileExtension: _propTypes2.default.string,
	    element: _propTypes2.default.any,
	    children: function children(props, propName, componentName) {
	        _react2.default.Children.forEach(props[propName], function (child) {
	            if (child.type !== _ExcelSheet2.default) {
	                throw new Error('<ExcelFile> can only have <ExcelSheet> as children. ');
	            }
	        });
	    }
	};
	ExcelFile.defaultProps = {
	    hideElement: false,
	    filename: "Download",
	    fileExtension: "xlsx",
	    element: _react2.default.createElement(
	        "button",
	        null,
	        "Download"
	    )
	};
	
	var _initialiseProps = function _initialiseProps() {
	    this.fileExtensions = ['xlsx', 'xls', 'csv', 'txt', 'html'];
	    this.defaultFileExtension = 'xlsx';
	};
	
	exports.default = ExcelFile;

/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.excelSheetFromDataSet = exports.excelSheetFromAoA = exports.dateToNumber = exports.strToArrBuffer = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _xlsx = __webpack_require__(268);
	
	var _xlsx2 = _interopRequireDefault(_xlsx);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var strToArrBuffer = function strToArrBuffer(s) {
	    var buf = new ArrayBuffer(s.length);
	    var view = new Uint8Array(buf);
	
	    for (var i = 0; i != s.length; ++i) {
	        view[i] = s.charCodeAt(i) & 0xFF;
	    }
	
	    return buf;
	};
	
	var dateToNumber = function dateToNumber(v, date1904) {
	    if (date1904) {
	        v += 1462;
	    }
	
	    var epoch = Date.parse(v);
	
	    return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
	};
	
	var excelSheetFromDataSet = function excelSheetFromDataSet(dataSet) {
	    /*
	    Assuming the structure of dataset
	    {
	        xSteps?: number; //How many cells to skips from left
	        ySteps?: number; //How many rows to skips from last data
	        columns: [array | string]
	        data: [array_of_array | string|boolean|number | CellObject]
	        fill, font, numFmt, alignment, and border
	    }
	     */
	    if (dataSet === undefined || dataSet.length === 0) {
	        return {};
	    }
	
	    var ws = {};
	    var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
	    var rowCount = 0;
	
	    dataSet.forEach(function (dataSetItem) {
	        var columns = dataSetItem.columns;
	        var xSteps = typeof dataSetItem.xSteps === 'number' ? dataSetItem.xSteps : 0;
	        var ySteps = typeof dataSetItem.ySteps === 'number' ? dataSetItem.ySteps : 0;
	        var data = dataSetItem.data;
	        if (dataSet === undefined || dataSet.length === 0) {
	            return;
	        }
	
	        rowCount += ySteps;
	
	        if (columns.length >= 0) {
	            columns.forEach(function (col, index) {
	                var cellRef = _xlsx2.default.utils.encode_cell({ c: xSteps + index, r: rowCount });
	                fixRange(range, 0, 0, rowCount, xSteps, ySteps);
	                getHeaderCell(col, cellRef, ws);
	            });
	
	            rowCount += 1;
	        }
	
	        for (var R = 0; R != data.length; ++R, rowCount++) {
	            for (var C = 0; C != data[R].length; ++C) {
	                var cellRef = _xlsx2.default.utils.encode_cell({ c: C + xSteps, r: rowCount });
	                fixRange(range, R, C, rowCount, xSteps, ySteps);
	                getCell(data[R][C], cellRef, ws);
	            }
	        }
	    });
	
	    if (range.s.c < 10000000) {
	        ws['!ref'] = _xlsx2.default.utils.encode_range(range);
	    }
	
	    return ws;
	};
	
	function getHeaderCell(v, cellRef, ws) {
	    var cell = {};
	    var headerCellStyle = { font: { bold: true } };
	    cell.v = v;
	    cell.t = 's';
	    cell.s = headerCellStyle;
	    ws[cellRef] = cell;
	}
	
	function getCell(v, cellRef, ws) {
	    var cell = {};
	    if (v === null) {
	        return;
	    }
	    if (typeof v === 'number') {
	        cell.v = v;
	        cell.t = 'n';
	    } else if (typeof v === 'boolean') {
	        cell.v = v;
	        cell.t = 'b';
	    } else if (v instanceof Date) {
	        cell.t = 'n';
	        cell.z = _xlsx2.default.SSF._table[14];
	        cell.v = dateToNumber(cell.v);
	    } else if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
	        cell.v = v.value;
	        cell.s = v.style;
	    } else {
	        cell.v = v;
	        cell.t = 's';
	    }
	    ws[cellRef] = cell;
	}
	
	function fixRange(range, R, C, rowCount, xSteps, ySteps) {
	    if (range.s.r > R + rowCount) {
	        range.s.r = R + rowCount;
	    }
	
	    if (range.s.c > C + xSteps) {
	        range.s.c = C + xSteps;
	    }
	
	    if (range.e.r < R + rowCount) {
	        range.e.r = R + rowCount;
	    }
	
	    if (range.e.c < C + xSteps) {
	        range.e.c = C + xSteps;
	    }
	}
	
	var excelSheetFromAoA = function excelSheetFromAoA(data) {
	    var ws = {};
	    var range = { s: { c: 10000000, r: 10000000 }, e: { c: 0, r: 0 } };
	
	    for (var R = 0; R != data.length; ++R) {
	        for (var C = 0; C != data[R].length; ++C) {
	            if (range.s.r > R) {
	                range.s.r = R;
	            }
	
	            if (range.s.c > C) {
	                range.s.c = C;
	            }
	
	            if (range.e.r < R) {
	                range.e.r = R;
	            }
	
	            if (range.e.c < C) {
	                range.e.c = C;
	            }
	
	            var cell = { v: data[R][C] };
	            if (cell.v === null) {
	                continue;
	            }
	
	            var cellRef = _xlsx2.default.utils.encode_cell({ c: C, r: R });
	            if (typeof cell.v === 'number') {
	                cell.t = 'n';
	            } else if (typeof cell.v === 'boolean') {
	                cell.t = 'b';
	            } else if (cell.v instanceof Date) {
	                cell.t = 'n';
	                cell.z = _xlsx2.default.SSF._table[14];
	                cell.v = dateToNumber(cell.v);
	            } else {
	                cell.t = 's';
	            }
	
	            ws[cellRef] = cell;
	        }
	    }
	
	    if (range.s.c < 10000000) {
	        ws['!ref'] = _xlsx2.default.utils.encode_range(range);
	    }
	
	    return ws;
	};
	
	exports.strToArrBuffer = strToArrBuffer;
	exports.dateToNumber = dateToNumber;
	exports.excelSheetFromAoA = excelSheetFromAoA;
	exports.excelSheetFromDataSet = excelSheetFromDataSet;

/***/ },
/* 2716 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(2725);


/***/ },
/* 2717 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	__webpack_require__(2726);


/***/ },
/* 2718 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronDown = function () {
	  function ChevronDown(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z'
	      })
	    );
	  }
	
	  return ChevronDown;
	}();
	
	ChevronDown.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = ChevronDown;

/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronUp = function () {
	  function ChevronUp(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z'
	      })
	    );
	  }
	
	  return ChevronUp;
	}();
	
	ChevronUp.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = ChevronUp;

/***/ },
/* 2720 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureDateRangePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(240);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _reactPortal = __webpack_require__(1259);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _consolidatedEvents = __webpack_require__(289);
	
	var _isTouchDevice = __webpack_require__(188);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _OutsideClickHandler = __webpack_require__(335);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _getResponsiveContainerStyles = __webpack_require__(1239);
	
	var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
	var _isInclusivelyAfterDay = __webpack_require__(246);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _DateRangePickerInputController = __webpack_require__(1227);
	
	var _DateRangePickerInputController2 = _interopRequireDefault(_DateRangePickerInputController);
	
	var _DayPickerRangeController = __webpack_require__(1228);
	
	var _DayPickerRangeController2 = _interopRequireDefault(_DayPickerRangeController);
	
	var _CloseButton = __webpack_require__(242);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _DateRangePickerShape = __webpack_require__(1234);
	
	var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, _DateRangePickerShape2['default']));
	
	var defaultProps = {
	  // required props for a functional interactive DateRangePicker
	  startDate: null,
	  endDate: null,
	  focusedInput: null,
	
	  // input related props
	  startDateId: _constants.START_DATE,
	  startDatePlaceholderText: 'Start Date',
	  endDateId: _constants.END_DATE,
	  endDatePlaceholderText: 'End Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDates: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	
	  // calendar presentation and interaction related props
	  renderMonth: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  initialVisibleMonth: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  renderCalendarInfo: null,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  // day presentation and interaction related props
	  renderDay: null,
	  minimumNights: 1,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {
	      return false;
	    }
	
	    return isDayHighlighted;
	  }(),
	
	  // internationalization
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DateRangePickerPhrases
	};
	
	var DateRangePicker = function (_React$Component) {
	  _inherits(DateRangePicker, _React$Component);
	
	  function DateRangePicker(props) {
	    _classCallCheck(this, DateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDateRangePickerInputFocused: false,
	      isDayPickerFocused: false,
	      showKeyboardShortcuts: false
	    };
	
	    _this.isTouchDevice = false;
	
	    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_this);
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);
	
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
	
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
	        this.responsivizePickerPosition();
	
	        if (this.props.focusedInput) {
	          this.setState({
	            isDateRangePickerInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        if (!prevProps.focusedInput && this.props.focusedInput && this.isOpened()) {
	          // The date picker just changed from being closed to being open.
	          this.responsivizePickerPosition();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onOutsideClick',
	    value: function () {
	      function onOutsideClick() {
	        var _props = this.props,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose,
	            startDate = _props.startDate,
	            endDate = _props.endDate;
	
	        if (!this.isOpened()) return;
	
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	
	        onFocusChange(null);
	        onClose({ startDate: startDate, endDate: endDate });
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: 'onDateRangePickerInputFocus',
	    value: function () {
	      function onDateRangePickerInputFocus(focusedInput) {
	        var _props2 = this.props,
	            onFocusChange = _props2.onFocusChange,
	            withPortal = _props2.withPortal,
	            withFullScreenPortal = _props2.withFullScreenPortal;
	
	
	        if (focusedInput) {
	          var moveFocusToDayPicker = withPortal || withFullScreenPortal || this.isTouchDevice;
	          if (moveFocusToDayPicker) {
	            this.onDayPickerFocus();
	          } else {
	            this.onDayPickerBlur();
	          }
	        }
	
	        onFocusChange(focusedInput);
	      }
	
	      return onDateRangePickerInputFocus;
	    }()
	  }, {
	    key: 'onDayPickerFocus',
	    value: function () {
	      function onDayPickerFocus() {
	        var _props3 = this.props,
	            focusedInput = _props3.focusedInput,
	            onFocusChange = _props3.onFocusChange;
	
	        if (!focusedInput) onFocusChange(_constants.START_DATE);
	
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: 'onDayPickerBlur',
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isDateRangePickerInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: 'setDayPickerContainerRef',
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: 'isOpened',
	    value: function () {
	      function isOpened() {
	        var focusedInput = this.props.focusedInput;
	
	        return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
	      }
	
	      return isOpened;
	    }()
	  }, {
	    key: 'responsivizePickerPosition',
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({ dayPickerContainerStyles: {} });
	
	        if (!this.isOpened()) {
	          return;
	        }
	
	        var _props4 = this.props,
	            anchorDirection = _props4.anchorDirection,
	            horizontalMargin = _props4.horizontalMargin,
	            withPortal = _props4.withPortal,
	            withFullScreenPortal = _props4.withFullScreenPortal;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
	          this.setState({
	            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: 'showKeyboardShortcutsPanel',
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'maybeRenderDayPickerWithPortal',
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _props5 = this.props,
	            withPortal = _props5.withPortal,
	            withFullScreenPortal = _props5.withFullScreenPortal;
	
	
	        if (!this.isOpened()) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal) {
	          return _react2['default'].createElement(
	            _reactPortal2['default'],
	            { isOpened: true },
	            this.renderDayPicker()
	          );
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: 'renderDayPicker',
	    value: function () {
	      function renderDayPicker() {
	        var _props6 = this.props,
	            anchorDirection = _props6.anchorDirection,
	            openDirection = _props6.openDirection,
	            isDayBlocked = _props6.isDayBlocked,
	            isDayHighlighted = _props6.isDayHighlighted,
	            isOutsideRange = _props6.isOutsideRange,
	            numberOfMonths = _props6.numberOfMonths,
	            orientation = _props6.orientation,
	            monthFormat = _props6.monthFormat,
	            renderMonth = _props6.renderMonth,
	            navPrev = _props6.navPrev,
	            navNext = _props6.navNext,
	            onPrevMonthClick = _props6.onPrevMonthClick,
	            onNextMonthClick = _props6.onNextMonthClick,
	            onDatesChange = _props6.onDatesChange,
	            onFocusChange = _props6.onFocusChange,
	            withPortal = _props6.withPortal,
	            withFullScreenPortal = _props6.withFullScreenPortal,
	            daySize = _props6.daySize,
	            enableOutsideDays = _props6.enableOutsideDays,
	            focusedInput = _props6.focusedInput,
	            startDate = _props6.startDate,
	            endDate = _props6.endDate,
	            minimumNights = _props6.minimumNights,
	            keepOpenOnDateSelect = _props6.keepOpenOnDateSelect,
	            renderDay = _props6.renderDay,
	            renderCalendarInfo = _props6.renderCalendarInfo,
	            firstDayOfWeek = _props6.firstDayOfWeek,
	            initialVisibleMonth = _props6.initialVisibleMonth,
	            hideKeyboardShortcutsPanel = _props6.hideKeyboardShortcutsPanel,
	            customCloseIcon = _props6.customCloseIcon,
	            onClose = _props6.onClose,
	            phrases = _props6.phrases,
	            isRTL = _props6.isRTL,
	            weekDayFormat = _props6.weekDayFormat,
	            styles = _props6.styles,
	            verticalHeight = _props6.verticalHeight;
	        var _state = this.state,
	            dayPickerContainerStyles = _state.dayPickerContainerStyles,
	            isDayPickerFocused = _state.isDayPickerFocused,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
	        var initialVisibleMonthThunk = initialVisibleMonth || function () {
	          return startDate || endDate || (0, _moment2['default'])();
	        };
	
	        var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton_svg));
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({ // eslint-disable-line jsx-a11y/no-static-element-interactions
	            ref: this.setDayPickerContainerRef
	          }, (0, _reactWithStyles.css)(styles.DateRangePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === _constants.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, openDirection === _constants.OPEN_DOWN && styles.DateRangePicker_picker__openDown, openDirection === _constants.OPEN_UP && styles.DateRangePicker_picker__openUp, orientation === _constants.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, (withPortal || withFullScreenPortal) && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl), {
	            style: dayPickerContainerStyles,
	            onClick: onOutsideClick
	          }),
	          _react2['default'].createElement(_DayPickerRangeController2['default'], {
	            orientation: orientation,
	            enableOutsideDays: enableOutsideDays,
	            numberOfMonths: numberOfMonths,
	            onPrevMonthClick: onPrevMonthClick,
	            onNextMonthClick: onNextMonthClick,
	            onDatesChange: onDatesChange,
	            onFocusChange: onFocusChange,
	            onClose: onClose,
	            focusedInput: focusedInput,
	            startDate: startDate,
	            endDate: endDate,
	            monthFormat: monthFormat,
	            renderMonth: renderMonth,
	            withPortal: withPortal || withFullScreenPortal,
	            daySize: daySize,
	            initialVisibleMonth: initialVisibleMonthThunk,
	            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	            navPrev: navPrev,
	            navNext: navNext,
	            minimumNights: minimumNights,
	            isOutsideRange: isOutsideRange,
	            isDayHighlighted: isDayHighlighted,
	            isDayBlocked: isDayBlocked,
	            keepOpenOnDateSelect: keepOpenOnDateSelect,
	            renderDay: renderDay,
	            renderCalendarInfo: renderCalendarInfo,
	            isFocused: isDayPickerFocused,
	            showKeyboardShortcuts: showKeyboardShortcuts,
	            onBlur: this.onDayPickerBlur,
	            phrases: phrases,
	            isRTL: isRTL,
	            firstDayOfWeek: firstDayOfWeek,
	            weekDayFormat: weekDayFormat,
	            verticalHeight: verticalHeight
	          }),
	          withFullScreenPortal && _react2['default'].createElement(
	            'button',
	            _extends({}, (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton), {
	              type: 'button',
	              onClick: this.onOutsideClick,
	              'aria-label': phrases.closeDatePicker
	            }),
	            closeIcon
	          )
	        );
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props7 = this.props,
	            startDate = _props7.startDate,
	            startDateId = _props7.startDateId,
	            startDatePlaceholderText = _props7.startDatePlaceholderText,
	            endDate = _props7.endDate,
	            endDateId = _props7.endDateId,
	            endDatePlaceholderText = _props7.endDatePlaceholderText,
	            focusedInput = _props7.focusedInput,
	            screenReaderInputMessage = _props7.screenReaderInputMessage,
	            showClearDates = _props7.showClearDates,
	            showDefaultInputIcon = _props7.showDefaultInputIcon,
	            inputIconPosition = _props7.inputIconPosition,
	            customInputIcon = _props7.customInputIcon,
	            customArrowIcon = _props7.customArrowIcon,
	            customCloseIcon = _props7.customCloseIcon,
	            disabled = _props7.disabled,
	            required = _props7.required,
	            readOnly = _props7.readOnly,
	            openDirection = _props7.openDirection,
	            phrases = _props7.phrases,
	            isOutsideRange = _props7.isOutsideRange,
	            minimumNights = _props7.minimumNights,
	            withPortal = _props7.withPortal,
	            withFullScreenPortal = _props7.withFullScreenPortal,
	            displayFormat = _props7.displayFormat,
	            reopenPickerOnClearDates = _props7.reopenPickerOnClearDates,
	            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
	            onDatesChange = _props7.onDatesChange,
	            onClose = _props7.onClose,
	            isRTL = _props7.isRTL,
	            styles = _props7.styles;
	        var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
	
	
	        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onOutsideClick : undefined;
	
	        return _react2['default'].createElement(
	          'div',
	          (0, _reactWithStyles.css)(styles.DateRangePicker),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(_DateRangePickerInputController2['default'], {
	              startDate: startDate,
	              startDateId: startDateId,
	              startDatePlaceholderText: startDatePlaceholderText,
	              isStartDateFocused: focusedInput === _constants.START_DATE,
	              endDate: endDate,
	              endDateId: endDateId,
	              endDatePlaceholderText: endDatePlaceholderText,
	              isEndDateFocused: focusedInput === _constants.END_DATE,
	              displayFormat: displayFormat,
	              showClearDates: showClearDates,
	              showCaret: !withPortal && !withFullScreenPortal,
	              showDefaultInputIcon: showDefaultInputIcon,
	              inputIconPosition: inputIconPosition,
	              customInputIcon: customInputIcon,
	              customArrowIcon: customArrowIcon,
	              customCloseIcon: customCloseIcon,
	              disabled: disabled,
	              required: required,
	              readOnly: readOnly,
	              openDirection: openDirection,
	              reopenPickerOnClearDates: reopenPickerOnClearDates,
	              keepOpenOnDateSelect: keepOpenOnDateSelect,
	              isOutsideRange: isOutsideRange,
	              minimumNights: minimumNights,
	              withFullScreenPortal: withFullScreenPortal,
	              onDatesChange: onDatesChange,
	              onFocusChange: this.onDateRangePickerInputFocus,
	              onKeyDownArrowDown: this.onDayPickerFocus,
	              onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	              onClose: onClose,
	              phrases: phrases,
	              screenReaderMessage: screenReaderInputMessage,
	              isFocused: isDateRangePickerInputFocused,
	              isRTL: isRTL
	            }),
	            this.maybeRenderDayPickerWithPortal()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePicker;
	}(_react2['default'].Component);
	
	DateRangePicker.propTypes = propTypes;
	DateRangePicker.defaultProps = defaultProps;
	
	exports.PureDateRangePicker = DateRangePicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex,
	      spacing = _ref$reactDates.spacing;
	  return {
	    DateRangePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	
	    DateRangePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	
	    DateRangePicker_picker__rtl: {
	      direction: 'rtl'
	    },
	
	    DateRangePicker_picker__directionLeft: {
	      left: 0
	    },
	
	    DateRangePicker_picker__directionRight: {
	      right: 0
	    },
	
	    DateRangePicker_picker__openDown: {
	      top: spacing.inputMarginBottom
	    },
	
	    DateRangePicker_picker__openUp: {
	      bottom: spacing.inputMarginBottom
	    },
	
	    DateRangePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%'
	    },
	
	    DateRangePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	
	    DateRangePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      padding: 15,
	      zIndex: zIndex + 2,
	
	      ':hover': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      },
	
	      ':focus': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      }
	    },
	
	    DateRangePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	})(DateRangePicker);

/***/ },
/* 2721 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _KeyboardShortcutRow = __webpack_require__(2723);
	
	var _KeyboardShortcutRow2 = _interopRequireDefault(_KeyboardShortcutRow);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CloseButton = __webpack_require__(242);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOP_LEFT = exports.TOP_LEFT = 'top-left';
	var TOP_RIGHT = exports.TOP_RIGHT = 'top-right';
	var BOTTOM_RIGHT = exports.BOTTOM_RIGHT = 'bottom-right';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  block: _propTypes2['default'].bool,
	  buttonLocation: _propTypes2['default'].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
	  showKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  openKeyboardShortcutsPanel: _propTypes2['default'].func,
	  closeKeyboardShortcutsPanel: _propTypes2['default'].func,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases))
	}));
	
	var defaultProps = {
	  block: false,
	  buttonLocation: BOTTOM_RIGHT,
	  showKeyboardShortcutsPanel: false,
	  openKeyboardShortcutsPanel: function () {
	    function openKeyboardShortcutsPanel() {}
	
	    return openKeyboardShortcutsPanel;
	  }(),
	  closeKeyboardShortcutsPanel: function () {
	    function closeKeyboardShortcutsPanel() {}
	
	    return closeKeyboardShortcutsPanel;
	  }(),
	
	  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases
	};
	
	function getKeyboardShortcuts(phrases) {
	  return [{
	    unicode: '↵',
	    label: phrases.enterKey,
	    action: phrases.selectFocusedDate
	  }, {
	    unicode: '←/→',
	    label: phrases.leftArrowRightArrow,
	    action: phrases.moveFocusByOneDay
	  }, {
	    unicode: '↑/↓',
	    label: phrases.upArrowDownArrow,
	    action: phrases.moveFocusByOneWeek
	  }, {
	    unicode: 'PgUp/PgDn',
	    label: phrases.pageUpPageDown,
	    action: phrases.moveFocusByOneMonth
	  }, {
	    unicode: 'Home/End',
	    label: phrases.homeEnd,
	    action: phrases.moveFocustoStartAndEndOfWeek
	  }, {
	    unicode: 'Esc',
	    label: phrases.escape,
	    action: phrases.returnFocusToInput
	  }, {
	    unicode: '?',
	    label: phrases.questionMark,
	    action: phrases.openThisPanel
	  }];
	}
	
	var DayPickerKeyboardShortcuts = function (_React$Component) {
	  _inherits(DayPickerKeyboardShortcuts, _React$Component);
	
	  function DayPickerKeyboardShortcuts() {
	    var _ref;
	
	    _classCallCheck(this, DayPickerKeyboardShortcuts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = DayPickerKeyboardShortcuts.__proto__ || Object.getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_ref, [this].concat(args)));
	
	    _this.keyboardShortcuts = getKeyboardShortcuts(_this.props.phrases);
	
	    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind(_this);
	    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_this);
	    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerKeyboardShortcuts, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (nextProps.phrases !== this.props.phrases) {
	          this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        this.handleFocus();
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel;
	        // Because the close button is the only focusable element inside of the panel, this
	        // amount to a very basic focus trap. The user can exit the panel by "pressing" the
	        // close button or hitting escape
	
	        switch (e.key) {
	          case 'Space':
	          case 'Escape':
	            e.stopPropagation();
	            closeKeyboardShortcutsPanel();
	            break;
	
	          // only stopPropagation here - this allows the up and down arrows continue their
	          // default behavior of scrolling the content of the Keyboard Shortcuts Panel
	          // which is needed when only a single month is shown for instance.
	          case 'ArrowUp':
	          case 'ArrowDown':
	            e.stopPropagation();
	            break;
	
	          // completely block the rest of the keys that have functionality outside of this panel
	          case 'Tab':
	          case 'Enter':
	          case 'Home':
	          case 'End':
	          case 'PageUp':
	          case 'PageDown':
	          case 'ArrowLeft':
	          case 'ArrowRight':
	            e.stopPropagation();
	            e.preventDefault();
	            break;
	
	          default:
	            break;
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onShowKeyboardShortcutsButtonClick',
	    value: function () {
	      function onShowKeyboardShortcutsButtonClick() {
	        var _this2 = this;
	
	        var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel;
	
	        // we want to return focus to this button after closing the keyboard shortcuts panel
	
	        openKeyboardShortcutsPanel(function () {
	          _this2.showKeyboardShortcutsButton.focus();
	        });
	      }
	
	      return onShowKeyboardShortcutsButtonClick;
	    }()
	  }, {
	    key: 'setShowKeyboardShortcutsButtonRef',
	    value: function () {
	      function setShowKeyboardShortcutsButtonRef(ref) {
	        this.showKeyboardShortcutsButton = ref;
	      }
	
	      return setShowKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: 'setHideKeyboardShortcutsButtonRef',
	    value: function () {
	      function setHideKeyboardShortcutsButtonRef(ref) {
	        this.hideKeyboardShortcutsButton = ref;
	      }
	
	      return setHideKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: 'handleFocus',
	    value: function () {
	      function handleFocus() {
	        if (this.hideKeyboardShortcutsButton) {
	          // automatically move focus into the dialog by moving
	          // to the only interactive element, the hide button
	          this.hideKeyboardShortcutsButton.focus();
	        }
	      }
	
	      return handleFocus;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            block = _props.block,
	            buttonLocation = _props.buttonLocation,
	            showKeyboardShortcutsPanel = _props.showKeyboardShortcutsPanel,
	            closeKeyboardShortcutsPanel = _props.closeKeyboardShortcutsPanel,
	            styles = _props.styles,
	            phrases = _props.phrases;
	
	
	        var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
	
	        var bottomRight = buttonLocation === BOTTOM_RIGHT;
	        var topRight = buttonLocation === TOP_RIGHT;
	        var topLeft = buttonLocation === TOP_LEFT;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'button',
	            _extends({
	              ref: this.setShowKeyboardShortcutsButtonRef
	            }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
	              type: 'button',
	              'aria-label': toggleButtonText,
	              onClick: this.onShowKeyboardShortcutsButtonClick,
	              onKeyDown: function () {
	                function onKeyDown(e) {
	                  if (e.key === 'Enter') {
	                    e.preventDefault();
	                  } else if (e.key === 'Space') {
	                    _this3.onShowKeyboardShortcutsButtonClick(e);
	                  }
	                }
	
	                return onKeyDown;
	              }(),
	              onMouseUp: function () {
	                function onMouseUp(e) {
	                  e.currentTarget.blur();
	                }
	
	                return onMouseUp;
	              }()
	            }),
	            _react2['default'].createElement(
	              'span',
	              (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft),
	              '?'
	            )
	          ),
	          showKeyboardShortcutsPanel && _react2['default'].createElement(
	            'div',
	            _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_panel, block && styles.DayPickerKeyboardShortcuts_panel__block), {
	              role: 'dialog',
	              'aria-labelledby': 'DayPickerKeyboardShortcuts__title',
	              'aria-describedby': 'DayPickerKeyboardShortcuts__description'
	            }),
	            _react2['default'].createElement(
	              'div',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_title), {
	                id: 'DayPickerKeyboardShortcuts__title'
	              }),
	              phrases.keyboardShortcuts
	            ),
	            _react2['default'].createElement(
	              'button',
	              _extends({
	                ref: this.setHideKeyboardShortcutsButtonRef
	              }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
	                type: 'button',
	                tabIndex: '0',
	                'aria-label': phrases.hideKeyboardShortcutsPanel,
	                onClick: closeKeyboardShortcutsPanel,
	                onKeyDown: this.onKeyDown
	              }),
	              _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_closeSvg))
	            ),
	            _react2['default'].createElement(
	              'ul',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts__list), {
	                id: 'DayPickerKeyboardShortcuts__description'
	              }),
	              this.keyboardShortcuts.map(function (_ref2) {
	                var unicode = _ref2.unicode,
	                    label = _ref2.label,
	                    action = _ref2.action;
	                return _react2['default'].createElement(_KeyboardShortcutRow2['default'], {
	                  key: label,
	                  unicode: unicode,
	                  label: label,
	                  action: action,
	                  block: block
	                });
	              })
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerKeyboardShortcuts;
	}(_react2['default'].Component);
	
	DayPickerKeyboardShortcuts.propTypes = propTypes;
	DayPickerKeyboardShortcuts.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref3) {
	  var _ref3$reactDates = _ref3.reactDates,
	      color = _ref3$reactDates.color,
	      zIndex = _ref3$reactDates.zIndex;
	  return {
	    DayPickerKeyboardShortcuts_buttonReset: {
	      background: 'none',
	      border: 0,
	      borderRadius: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      padding: 0,
	      cursor: 'pointer',
	
	      ':active': {
	        outline: 'none'
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show: {
	      width: 22,
	      position: 'absolute',
	      zIndex: zIndex + 2
	    },
	
	    DayPickerKeyboardShortcuts_show__bottomRight: {
	      borderTop: '26px solid transparent',
	      borderRight: '33px solid ' + String(color.core.primary),
	      bottom: 0,
	      right: 0,
	
	      ':hover': {
	        borderRight: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show__topRight: {
	      borderBottom: '26px solid transparent',
	      borderRight: '33px solid ' + String(color.core.primary),
	      top: 0,
	      right: 0,
	
	      ':hover': {
	        borderRight: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show__topLeft: {
	      borderBottom: '26px solid transparent',
	      borderLeft: '33px solid ' + String(color.core.primary),
	      top: 0,
	      left: 0,
	
	      ':hover': {
	        borderLeft: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_showSpan: {
	      color: color.core.white,
	      position: 'absolute'
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
	      bottom: 0,
	      right: -28
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__topRight: {
	      top: 1,
	      right: -28
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__topLeft: {
	      top: 1,
	      left: -28
	    },
	
	    DayPickerKeyboardShortcuts_panel: {
	      overflow: 'auto',
	      background: color.background,
	      border: '1px solid ' + String(color.core.border),
	      borderRadius: 2,
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      zIndex: zIndex + 2,
	      padding: 22,
	      margin: 33
	    },
	
	    DayPickerKeyboardShortcuts_title: {
	      fontSize: 16,
	      fontWeight: 'bold',
	      margin: 0
	    },
	
	    DayPickerKeyboardShortcuts_list: {
	      listStyle: 'none',
	      padding: 0
	    },
	
	    DayPickerKeyboardShortcuts_close: {
	      position: 'absolute',
	      right: 22,
	      top: 22,
	      zIndex: zIndex + 2,
	
	      ':active': {
	        outline: 'none'
	      }
	    },
	
	    DayPickerKeyboardShortcuts_closeSvg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter,
	
	      ':hover': {
	        fill: color.core.grayLight
	      },
	
	      ':focus': {
	        fill: color.core.grayLight
	      }
	    }
	  };
	})(DayPickerKeyboardShortcuts);

/***/ },
/* 2722 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _getPhrasePropTypes = __webpack_require__(73);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _LeftArrow = __webpack_require__(1230);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _RightArrow = __webpack_require__(1231);
	
	var _RightArrow2 = _interopRequireDefault(_RightArrow);
	
	var _ChevronUp = __webpack_require__(2719);
	
	var _ChevronUp2 = _interopRequireDefault(_ChevronUp);
	
	var _ChevronDown = __webpack_require__(2718);
	
	var _ChevronDown2 = _interopRequireDefault(_ChevronDown);
	
	var _ScrollableOrientationShape = __webpack_require__(193);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  orientation: _ScrollableOrientationShape2['default'],
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerNavigationPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  navPrev: null,
	  navNext: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	
	
	  // internationalization
	  phrases: _defaultPhrases.DayPickerNavigationPhrases,
	  isRTL: false
	};
	
	function DayPickerNavigation(_ref) {
	  var navPrev = _ref.navPrev,
	      navNext = _ref.navNext,
	      onPrevMonthClick = _ref.onPrevMonthClick,
	      onNextMonthClick = _ref.onNextMonthClick,
	      orientation = _ref.orientation,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      styles = _ref.styles;
	
	  var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	  var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
	  var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	
	  var navPrevIcon = navPrev;
	  var navNextIcon = navNext;
	  var isDefaultNavPrev = false;
	  var isDefaultNavNext = false;
	  if (!navPrevIcon) {
	    isDefaultNavPrev = true;
	    var Icon = isVertical ? _ChevronUp2['default'] : _LeftArrow2['default'];
	    if (isRTL && !isVertical) {
	      Icon = _RightArrow2['default'];
	    }
	    navPrevIcon = _react2['default'].createElement(Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical));
	  }
	
	  if (!navNextIcon) {
	    isDefaultNavNext = true;
	    var _Icon = isVertical ? _ChevronDown2['default'] : _RightArrow2['default'];
	    if (isRTL && !isVertical) {
	      _Icon = _LeftArrow2['default'];
	    }
	    navNextIcon = _react2['default'].createElement(_Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical));
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.DayPickerNavigation_container, isHorizontal && styles.DayPickerNavigation_container__horizontal, isVertical && styles.DayPickerNavigation_container__vertical, isVerticalScrollable && styles.DayPickerNavigation_container__verticalScrollable),
	    !isVerticalScrollable && _react2['default'].createElement(
	      'button',
	      _extends({}, _reactWithStyles.css.apply(undefined, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default].concat(_toConsumableArray(isHorizontal && [styles.DayPickerNavigation_button__horizontal, !isRTL && styles.DayPickerNavigation_leftButton__horizontal, isRTL && styles.DayPickerNavigation_rightButton__horizontal]), _toConsumableArray(isVertical && [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_prevButton__vertical, isDefaultNavPrev && styles.DayPickerNavigation_button__vertical__default]))), {
	        type: 'button',
	        'aria-label': phrases.jumpToPrevMonth,
	        onClick: onPrevMonthClick,
	        onMouseUp: function () {
	          function onMouseUp(e) {
	            e.currentTarget.blur();
	          }
	
	          return onMouseUp;
	        }()
	      }),
	      navPrevIcon
	    ),
	    _react2['default'].createElement(
	      'button',
	      _extends({}, _reactWithStyles.css.apply(undefined, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default].concat(_toConsumableArray(isHorizontal && [styles.DayPickerNavigation_button__horizontal, isRTL && styles.DayPickerNavigation_leftButton__horizontal, !isRTL && styles.DayPickerNavigation_rightButton__horizontal]), _toConsumableArray(isVertical && [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_nextButton__vertical, isDefaultNavNext && styles.DayPickerNavigation_button__vertical__default, isDefaultNavNext && styles.DayPickerNavigation_nextButton__vertical__default]), [isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollable])), {
	        type: 'button',
	        'aria-label': phrases.jumpToNextMonth,
	        onClick: onNextMonthClick,
	        onMouseUp: function () {
	          function onMouseUp(e) {
	            e.currentTarget.blur();
	          }
	
	          return onMouseUp;
	        }()
	      }),
	      navNextIcon
	    )
	  );
	}
	
	DayPickerNavigation.propTypes = propTypes;
	DayPickerNavigation.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    DayPickerNavigation_container: {
	      position: 'relative',
	      zIndex: zIndex + 2
	    },
	
	    DayPickerNavigation_container__horizontal: {},
	
	    DayPickerNavigation_container__vertical: {
	      background: color.background,
	      boxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.1)',
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      height: 52,
	      width: '100%'
	    },
	
	    DayPickerNavigation_container__verticalScrollable: {
	      position: 'relative'
	    },
	
	    DayPickerNavigation_button: {
	      cursor: 'pointer',
	      lineHeight: 0.78,
	      userSelect: 'none'
	    },
	
	    DayPickerNavigation_button__default: {
	      border: '1px solid ' + String(color.core.borderLight),
	      backgroundColor: color.background,
	      color: color.placeholderText,
	
	      ':focus': {
	        border: '1px solid ' + String(color.core.borderMedium)
	      },
	
	      ':hover': {
	        border: '1px solid ' + String(color.core.borderMedium)
	      },
	
	      ':active': {
	        background: color.backgroundDark
	      }
	    },
	
	    DayPickerNavigation_button__horizontal: {
	      borderRadius: 3,
	      padding: '6px 9px',
	      top: 18,
	      position: 'absolute'
	    },
	
	    DayPickerNavigation_leftButton__horizontal: {
	      left: 22
	    },
	
	    DayPickerNavigation_rightButton__horizontal: {
	      right: 22
	    },
	
	    DayPickerNavigation_button__vertical: {
	      display: 'inline-block',
	      position: 'relative',
	      height: '100%',
	      width: '50%'
	    },
	
	    DayPickerNavigation_button__vertical__default: {
	      padding: 5
	    },
	
	    DayPickerNavigation_nextButton__vertical__default: {
	      borderLeft: 0
	    },
	
	    DayPickerNavigation_nextButton__verticalScrollable: {
	      width: '100%'
	    },
	
	    DayPickerNavigation_svg__horizontal: {
	      height: 19,
	      width: 19,
	      fill: color.core.grayLight
	    },
	
	    DayPickerNavigation_svg__vertical: {
	      height: 42,
	      width: 42,
	      fill: color.text
	    }
	  };
	})(DayPickerNavigation);

/***/ },
/* 2723 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _reactWithStyles = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  unicode: _propTypes2['default'].string.isRequired,
	  label: _propTypes2['default'].string.isRequired,
	  action: _propTypes2['default'].string.isRequired,
	  block: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  block: false
	};
	
	function KeyboardShortcutRow(_ref) {
	  var unicode = _ref.unicode,
	      label = _ref.label,
	      action = _ref.action,
	      block = _ref.block,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    'li',
	    (0, _reactWithStyles.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block),
	    _react2['default'].createElement(
	      'div',
	      (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block),
	      _react2['default'].createElement(
	        'span',
	        _extends({}, (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_key), {
	          role: 'img',
	          'aria-label': String(label) + ',' // add comma so screen readers will pause before reading action
	        }),
	        unicode
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_action),
	      action
	    )
	  );
	}
	
	KeyboardShortcutRow.propTypes = propTypes;
	KeyboardShortcutRow.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    KeyboardShortcutRow: {
	      listStyle: 'none',
	      margin: '6px 0'
	    },
	
	    KeyboardShortcutRow__block: {
	      marginBottom: 16
	    },
	
	    KeyboardShortcutRow_keyContainer: {
	      display: 'inline-block',
	      whiteSpace: 'nowrap',
	      textAlign: 'right',
	      marginRight: 6
	    },
	
	    KeyboardShortcutRow_keyContainer__block: {
	      width: 'auto',
	      textAlign: 'left',
	      display: 'inline'
	    },
	
	    KeyboardShortcutRow_key: {
	      fontFamily: 'monospace',
	      fontSize: 12,
	      textTransform: 'uppercase',
	      background: color.core.grayLightest,
	      padding: '2px 6px'
	    },
	
	    KeyboardShortcutRow_action: {
	      display: 'inline',
	      wordBreak: 'break-word',
	      marginLeft: 8
	    }
	  };
	})(KeyboardShortcutRow);

/***/ },
/* 2724 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureSingleDatePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(57);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactWithStyles = __webpack_require__(81);
	
	var _reactPortal = __webpack_require__(1259);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _airbnbPropTypes = __webpack_require__(50);
	
	var _consolidatedEvents = __webpack_require__(289);
	
	var _isTouchDevice = __webpack_require__(188);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _SingleDatePickerShape = __webpack_require__(1237);
	
	var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);
	
	var _defaultPhrases = __webpack_require__(64);
	
	var _OutsideClickHandler = __webpack_require__(335);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _toMomentObject = __webpack_require__(195);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _toLocalizedDateString = __webpack_require__(492);
	
	var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
	var _getResponsiveContainerStyles = __webpack_require__(1239);
	
	var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
	var _SingleDatePickerInput = __webpack_require__(1232);
	
	var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);
	
	var _DayPickerSingleDateController = __webpack_require__(1229);
	
	var _DayPickerSingleDateController2 = _interopRequireDefault(_DayPickerSingleDateController);
	
	var _CloseButton = __webpack_require__(242);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _isInclusivelyAfterDay = __webpack_require__(246);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, _SingleDatePickerShape2['default']));
	
	var defaultProps = {
	  // required props for a functional interactive SingleDatePicker
	  date: null,
	  focused: false,
	
	  // input related props
	  id: 'date',
	  placeholder: 'Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customCloseIcon: null,
	
	  // calendar presentation and interaction related props
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDate: false,
	  renderCalendarInfo: null,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  // month presentation and interaction related props
	  renderMonth: null,
	
	  // day presentation and interaction related props
	  renderDay: null,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	  // internationalization props
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.SingleDatePickerPhrases
	};
	
	var SingleDatePicker = function (_React$Component) {
	  _inherits(SingleDatePicker, _React$Component);
	
	  function SingleDatePicker(props) {
	    _classCallCheck(this, SingleDatePicker);
	
	    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));
	
	    _this.isTouchDevice = false;
	
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDayPickerFocused: false,
	      isInputFocused: false,
	      showKeyboardShortcuts: false
	    };
	
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onClearFocus = _this.onClearFocus.bind(_this);
	    _this.clearDate = _this.clearDate.bind(_this);
	
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
	
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
	    return _this;
	  }
	
	  /* istanbul ignore next */
	
	
	  _createClass(SingleDatePicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
	        this.responsivizePickerPosition();
	
	        if (this.props.focused) {
	          this.setState({
	            isInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        if (!prevProps.focused && this.props.focused) {
	          this.responsivizePickerPosition();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onChange',
	    value: function () {
	      function onChange(dateString) {
	        var _props = this.props,
	            isOutsideRange = _props.isOutsideRange,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            onDateChange = _props.onDateChange,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose;
	
	        var newDate = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());
	
	        var isValid = newDate && !isOutsideRange(newDate);
	        if (isValid) {
	          onDateChange(newDate);
	          if (!keepOpenOnDateSelect) {
	            onFocusChange({ focused: false });
	            onClose({ date: newDate });
	          }
	        } else {
	          onDateChange(null);
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: 'onFocus',
	    value: function () {
	      function onFocus() {
	        var _props2 = this.props,
	            disabled = _props2.disabled,
	            onFocusChange = _props2.onFocusChange,
	            withPortal = _props2.withPortal,
	            withFullScreenPortal = _props2.withFullScreenPortal;
	
	
	        var moveFocusToDayPicker = withPortal || withFullScreenPortal || this.isTouchDevice;
	        if (moveFocusToDayPicker) {
	          this.onDayPickerFocus();
	        } else {
	          this.onDayPickerBlur();
	        }
	
	        if (!disabled) {
	          onFocusChange({ focused: true });
	        }
	      }
	
	      return onFocus;
	    }()
	  }, {
	    key: 'onClearFocus',
	    value: function () {
	      function onClearFocus() {
	        var _props3 = this.props,
	            date = _props3.date,
	            focused = _props3.focused,
	            onFocusChange = _props3.onFocusChange,
	            onClose = _props3.onClose;
	
	        if (!focused) return;
	
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: false
	        });
	
	        onFocusChange({ focused: false });
	        onClose({ date: date });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: 'onDayPickerFocus',
	    value: function () {
	      function onDayPickerFocus() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: 'onDayPickerBlur',
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: 'getDateString',
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	        return (0, _toLocalizedDateString2['default'])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: 'getDisplayFormat',
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: 'setDayPickerContainerRef',
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: 'clearDate',
	    value: function () {
	      function clearDate() {
	        var _props4 = this.props,
	            onDateChange = _props4.onDateChange,
	            reopenPickerOnClearDate = _props4.reopenPickerOnClearDate,
	            onFocusChange = _props4.onFocusChange;
	
	        onDateChange(null);
	        if (reopenPickerOnClearDate) {
	          onFocusChange({ focused: true });
	        }
	      }
	
	      return clearDate;
	    }()
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'responsivizePickerPosition',
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({ dayPickerContainerStyles: {} });
	
	        var _props5 = this.props,
	            anchorDirection = _props5.anchorDirection,
	            horizontalMargin = _props5.horizontalMargin,
	            withPortal = _props5.withPortal,
	            withFullScreenPortal = _props5.withFullScreenPortal,
	            focused = _props5.focused;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	
	        if (!focused) {
	          return;
	        }
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
	          this.setState({
	            dayPickerContainerStyles: (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin)
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: 'showKeyboardShortcutsPanel',
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'maybeRenderDayPickerWithPortal',
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _props6 = this.props,
	            focused = _props6.focused,
	            withPortal = _props6.withPortal,
	            withFullScreenPortal = _props6.withFullScreenPortal;
	
	
	        if (!focused) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal) {
	          return _react2['default'].createElement(
	            _reactPortal2['default'],
	            { isOpened: true },
	            this.renderDayPicker()
	          );
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: 'renderDayPicker',
	    value: function () {
	      function renderDayPicker() {
	        var _props7 = this.props,
	            anchorDirection = _props7.anchorDirection,
	            openDirection = _props7.openDirection,
	            onDateChange = _props7.onDateChange,
	            date = _props7.date,
	            onFocusChange = _props7.onFocusChange,
	            focused = _props7.focused,
	            enableOutsideDays = _props7.enableOutsideDays,
	            numberOfMonths = _props7.numberOfMonths,
	            orientation = _props7.orientation,
	            monthFormat = _props7.monthFormat,
	            navPrev = _props7.navPrev,
	            navNext = _props7.navNext,
	            onPrevMonthClick = _props7.onPrevMonthClick,
	            onNextMonthClick = _props7.onNextMonthClick,
	            onClose = _props7.onClose,
	            withPortal = _props7.withPortal,
	            withFullScreenPortal = _props7.withFullScreenPortal,
	            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
	            initialVisibleMonth = _props7.initialVisibleMonth,
	            renderMonth = _props7.renderMonth,
	            renderDay = _props7.renderDay,
	            renderCalendarInfo = _props7.renderCalendarInfo,
	            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
	            firstDayOfWeek = _props7.firstDayOfWeek,
	            customCloseIcon = _props7.customCloseIcon,
	            phrases = _props7.phrases,
	            daySize = _props7.daySize,
	            isRTL = _props7.isRTL,
	            isOutsideRange = _props7.isOutsideRange,
	            isDayBlocked = _props7.isDayBlocked,
	            isDayHighlighted = _props7.isDayHighlighted,
	            weekDayFormat = _props7.weekDayFormat,
	            styles = _props7.styles,
	            verticalHeight = _props7.verticalHeight;
	        var _state = this.state,
	            dayPickerContainerStyles = _state.dayPickerContainerStyles,
	            isDayPickerFocused = _state.isDayPickerFocused,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onClearFocus : undefined;
	        var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], null);
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({ // eslint-disable-line jsx-a11y/no-static-element-interactions
	            ref: this.setDayPickerContainerRef
	          }, (0, _reactWithStyles.css)(styles.SingleDatePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === _constants.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === _constants.OPEN_UP && styles.SingleDatePicker_picker__openUp, orientation === _constants.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, (withPortal || withFullScreenPortal) && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl), {
	            style: dayPickerContainerStyles,
	            onClick: onOutsideClick
	          }),
	          _react2['default'].createElement(_DayPickerSingleDateController2['default'], {
	            date: date,
	            onDateChange: onDateChange,
	            onFocusChange: onFocusChange,
	            orientation: orientation,
	            enableOutsideDays: enableOutsideDays,
	            numberOfMonths: numberOfMonths,
	            monthFormat: monthFormat,
	            withPortal: withPortal || withFullScreenPortal,
	            focused: focused,
	            keepOpenOnDateSelect: keepOpenOnDateSelect,
	            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	            initialVisibleMonth: initialVisibleMonth,
	            navPrev: navPrev,
	            navNext: navNext,
	            onPrevMonthClick: onPrevMonthClick,
	            onNextMonthClick: onNextMonthClick,
	            onClose: onClose,
	            renderMonth: renderMonth,
	            renderDay: renderDay,
	            renderCalendarInfo: renderCalendarInfo,
	            isFocused: isDayPickerFocused,
	            showKeyboardShortcuts: showKeyboardShortcuts,
	            onBlur: this.onDayPickerBlur,
	            phrases: phrases,
	            daySize: daySize,
	            isRTL: isRTL,
	            isOutsideRange: isOutsideRange,
	            isDayBlocked: isDayBlocked,
	            isDayHighlighted: isDayHighlighted,
	            firstDayOfWeek: firstDayOfWeek,
	            weekDayFormat: weekDayFormat,
	            verticalHeight: verticalHeight
	          }),
	          withFullScreenPortal && _react2['default'].createElement(
	            'button',
	            {
	              'aria-label': phrases.closeDatePicker,
	              className: 'SingleDatePicker__close',
	              type: 'button',
	              onClick: this.onClearFocus
	            },
	            _react2['default'].createElement(
	              'div',
	              { className: 'SingleDatePicker__close-icon' },
	              closeIcon
	            )
	          )
	        );
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props8 = this.props,
	            id = _props8.id,
	            placeholder = _props8.placeholder,
	            disabled = _props8.disabled,
	            focused = _props8.focused,
	            required = _props8.required,
	            readOnly = _props8.readOnly,
	            openDirection = _props8.openDirection,
	            showClearDate = _props8.showClearDate,
	            showDefaultInputIcon = _props8.showDefaultInputIcon,
	            inputIconPosition = _props8.inputIconPosition,
	            customCloseIcon = _props8.customCloseIcon,
	            customInputIcon = _props8.customInputIcon,
	            date = _props8.date,
	            phrases = _props8.phrases,
	            withPortal = _props8.withPortal,
	            withFullScreenPortal = _props8.withFullScreenPortal,
	            screenReaderInputMessage = _props8.screenReaderInputMessage,
	            isRTL = _props8.isRTL,
	            styles = _props8.styles;
	        var isInputFocused = this.state.isInputFocused;
	
	
	        var displayValue = this.getDateString(date);
	
	        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onClearFocus : undefined;
	
	        return _react2['default'].createElement(
	          'div',
	          (0, _reactWithStyles.css)(styles.SingleDatePicker),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(_SingleDatePickerInput2['default'], {
	              id: id,
	              placeholder: placeholder,
	              focused: focused,
	              isFocused: isInputFocused,
	              disabled: disabled,
	              required: required,
	              readOnly: readOnly,
	              openDirection: openDirection,
	              showCaret: !withPortal && !withFullScreenPortal,
	              onClearDate: this.clearDate,
	              showClearDate: showClearDate,
	              showDefaultInputIcon: showDefaultInputIcon,
	              inputIconPosition: inputIconPosition,
	              customCloseIcon: customCloseIcon,
	              customInputIcon: customInputIcon,
	              displayValue: displayValue,
	              onChange: this.onChange,
	              onFocus: this.onFocus,
	              onKeyDownShiftTab: this.onClearFocus,
	              onKeyDownTab: this.onClearFocus,
	              onKeyDownArrowDown: this.onDayPickerFocus,
	              onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	              screenReaderMessage: screenReaderInputMessage,
	              phrases: phrases,
	              isRTL: isRTL
	            }),
	            this.maybeRenderDayPickerWithPortal()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return SingleDatePicker;
	}(_react2['default'].Component);
	
	SingleDatePicker.propTypes = propTypes;
	SingleDatePicker.defaultProps = defaultProps;
	
	exports.PureSingleDatePicker = SingleDatePicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      spacing = _ref$reactDates.spacing,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    SingleDatePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	
	    SingleDatePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	
	    SingleDatePicker_picker__rtl: {
	      direction: 'rtl'
	    },
	
	    SingleDatePicker_picker__directionLeft: {
	      left: 0
	    },
	
	    SingleDatePicker_picker__directionRight: {
	      right: 0
	    },
	
	    SingleDatePicker_picker__openDown: {
	      top: spacing.inputMarginBottom
	    },
	
	    SingleDatePicker_picker__openUp: {
	      bottom: spacing.inputMarginBottom
	    },
	
	    SingleDatePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%'
	    },
	
	    SingleDatePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	
	    SingleDatePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      padding: 15,
	      zIndex: zIndex + 2,
	
	      ':hover': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      },
	
	      ':focus': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      }
	    },
	
	    SingleDatePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	})(SingleDatePicker);

/***/ },
/* 2725 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toMomentObject = exports.toLocalizedDateString = exports.toISODateString = exports.isSameDay = exports.isNextDay = exports.isInclusivelyBeforeDay = exports.isInclusivelyAfterDay = exports.SingleDatePickerShape = exports.SingleDatePickerInput = exports.SingleDatePicker = exports.DayPickerSingleDateController = exports.DayPickerRangeController = exports.DayPicker = exports.DateRangePickerShape = exports.DateRangePickerInputController = exports.DateRangePickerInput = exports.DateRangePicker = exports.CalendarMonthGrid = exports.CalendarMonth = exports.CalendarDay = undefined;
	
	var _CalendarDay = __webpack_require__(1221);
	
	Object.defineProperty(exports, 'CalendarDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarMonth = __webpack_require__(1223);
	
	Object.defineProperty(exports, 'CalendarMonth', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarMonth)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarMonthGrid = __webpack_require__(1224);
	
	Object.defineProperty(exports, 'CalendarMonthGrid', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarMonthGrid)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePicker = __webpack_require__(2720);
	
	Object.defineProperty(exports, 'DateRangePicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerInput = __webpack_require__(1226);
	
	Object.defineProperty(exports, 'DateRangePickerInput', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerInput)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerInputController = __webpack_require__(1227);
	
	Object.defineProperty(exports, 'DateRangePickerInputController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerInputController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerShape = __webpack_require__(1234);
	
	Object.defineProperty(exports, 'DateRangePickerShape', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerShape)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPicker = __webpack_require__(490);
	
	Object.defineProperty(exports, 'DayPicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPickerRangeController = __webpack_require__(1228);
	
	Object.defineProperty(exports, 'DayPickerRangeController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPickerRangeController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPickerSingleDateController = __webpack_require__(1229);
	
	Object.defineProperty(exports, 'DayPickerSingleDateController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPickerSingleDateController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePicker = __webpack_require__(2724);
	
	Object.defineProperty(exports, 'SingleDatePicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePickerInput = __webpack_require__(1232);
	
	Object.defineProperty(exports, 'SingleDatePickerInput', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePickerInput)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePickerShape = __webpack_require__(1237);
	
	Object.defineProperty(exports, 'SingleDatePickerShape', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePickerShape)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isInclusivelyAfterDay = __webpack_require__(246);
	
	Object.defineProperty(exports, 'isInclusivelyAfterDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isInclusivelyAfterDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isInclusivelyBeforeDay = __webpack_require__(2733);
	
	Object.defineProperty(exports, 'isInclusivelyBeforeDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isInclusivelyBeforeDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isNextDay = __webpack_require__(1241);
	
	Object.defineProperty(exports, 'isNextDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isNextDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isSameDay = __webpack_require__(194);
	
	Object.defineProperty(exports, 'isSameDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isSameDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toISODateString = __webpack_require__(336);
	
	Object.defineProperty(exports, 'toISODateString', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toISODateString)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toLocalizedDateString = __webpack_require__(492);
	
	Object.defineProperty(exports, 'toLocalizedDateString', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toLocalizedDateString)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toMomentObject = __webpack_require__(195);
	
	Object.defineProperty(exports, 'toMomentObject', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toMomentObject)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ },
/* 2726 */
/***/ function(module, exports, __webpack_require__) {

	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _registerCSSInterfaceWithDefaultTheme = __webpack_require__(2735);
	
	var _registerCSSInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerCSSInterfaceWithDefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(0, _registerCSSInterfaceWithDefaultTheme2['default'])();

/***/ },
/* 2727 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var core = {
	  white: '#fff',
	  gray: '#565a5c',
	  grayLight: '#82888a',
	  grayLighter: '#cacccd',
	  grayLightest: '#f2f2f2',
	
	  borderMedium: '#c4c4c4',
	  border: '#dbdbdb',
	  borderLight: '#e4e7e7',
	  borderLighter: '#eceeee',
	
	  primary: '#00a699',
	  primaryShade_1: '#33dacd',
	  primaryShade_2: '#66e2da',
	  primaryShade_3: '#80e8e0',
	  primaryShade_4: '#b2f1ec',
	  primary_dark: '#008489',
	
	  secondary: '#007a87',
	
	  yellow: '#ffe8bc',
	  yellow_dark: '#ffce71'
	};
	
	exports['default'] = {
	  reactDates: {
	    zIndex: 0,
	    border: {
	      input: {
	        border: 0,
	        borderTop: 0,
	        borderRight: 0,
	        borderBottom: '2px solid transparent',
	        borderLeft: 0,
	        outlineFocused: 0,
	        borderFocused: 0,
	        borderTopFocused: 0,
	        borderLeftFocused: 0,
	        borderBottomFocused: '2px solid ' + String(core.primary_dark),
	        borderRightFocused: 0
	      }
	    },
	
	    color: {
	      core: core,
	
	      disabled: core.grayLightest,
	
	      background: core.white,
	      backgroundDark: '#f2f2f2',
	      backgroundFocused: core.white,
	      text: core.gray,
	      textDisabled: core.border,
	      textFocused: '#007a87',
	      placeholderText: '#757575',
	
	      outside: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	
	      highlighted: {
	        backgroundColor: core.yellow,
	        backgroundColor_active: core.yellow_dark,
	        backgroundColor_hover: core.yellow_dark,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	
	      minimumNights: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLighter,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      },
	
	      hoveredSpan: {
	        backgroundColor: core.primaryShade_4,
	        backgroundColor_active: core.primaryShade_3,
	        backgroundColor_hover: core.primaryShade_4,
	        borderColor: core.primaryShade_3,
	        borderColor_active: core.primaryShade_3,
	        borderColor_hover: core.primaryShade_3,
	        color: core.secondary,
	        color_active: core.secondary,
	        color_hover: core.secondary
	      },
	
	      selectedSpan: {
	        backgroundColor: core.primaryShade_2,
	        backgroundColor_active: core.primaryShade_1,
	        backgroundColor_hover: core.primaryShade_1,
	        borderColor: core.primaryShade_1,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	
	      selected: {
	        backgroundColor: core.primary,
	        backgroundColor_active: core.primary,
	        backgroundColor_hover: core.primary,
	        borderColor: core.primary,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	
	      blocked_calendar: {
	        backgroundColor: core.grayLighter,
	        backgroundColor_active: core.grayLighter,
	        backgroundColor_hover: core.grayLighter,
	        borderColor: core.grayLighter,
	        borderColor_active: core.grayLighter,
	        borderColor_hover: core.grayLighter,
	        color: core.grayLight,
	        color_active: core.grayLight,
	        color_hover: core.grayLight
	      },
	
	      blocked_out_of_range: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLight,
	        borderColor_active: core.borderLight,
	        borderColor_hover: core.borderLight,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      }
	    },
	
	    spacing: {
	      captionPaddingTop: 22,
	      captionPaddingBottom: 37,
	      inputPadding: 0,
	      inputMarginBottom: 72, // spacing in between the input and the picker
	      displayTextPaddingVertical: 12,
	      displayTextPaddingHorizontal: 12
	    },
	
	    sizing: {
	      inputWidth: 130,
	      tooltipArrowWidth: 20,
	      arrowWidth: 24
	    },
	
	    font: {
	      size: 14,
	      captionSize: 18,
	      input: {
	        size: 18,
	        lineHeight: '24px',
	        styleDisabled: 'italic'
	      }
	    }
	  }
	};

/***/ },
/* 2728 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = calculateDimension;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function calculateDimension(el, axis) {
	  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!el) {
	    return 0;
	  }
	
	  var axisStart = axis === 'width' ? 'Left' : 'Top';
	  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';
	
	  // Only read styles if we need to
	  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null;
	
	  // Offset includes border and padding
	  var offsetWidth = el.offsetWidth,
	      offsetHeight = el.offsetHeight;
	
	  var size = axis === 'width' ? offsetWidth : offsetHeight;
	
	  // Get the inner size
	  if (!borderBox) {
	    size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
	  }
	
	  // Apply margin
	  if (withMargin) {
	    size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
	  }
	
	  return size;
	}

/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getActiveElement;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getActiveElement() {
	  return typeof document !== 'undefined' && document.activeElement;
	}

/***/ },
/* 2730 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarMonthWeeks;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getCalendarMonthWeeks(month, enableOutsideDays) {
	  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment2['default'].localeData().firstDayOfWeek();
	
	  if (!_moment2['default'].isMoment(month) || !month.isValid()) {
	    throw new TypeError('`month` must be a valid moment object');
	  }
	  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
	    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
	  }
	
	  // set utc offset to get correct dates in future (when timezone changes)
	  var firstOfMonth = month.clone().startOf('month').hour(12);
	  var lastOfMonth = month.clone().endOf('month').hour(12);
	
	  // calculate the exact first and last days to fill the entire matrix
	  // (considering days outside month)
	  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
	  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
	  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
	  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
	
	  var totalDays = lastDay.diff(firstDay, 'days') + 1;
	
	  var currentDay = firstDay.clone();
	  var weeksInMonth = [];
	
	  for (var i = 0; i < totalDays; i += 1) {
	    if (i % 7 === 0) {
	      weeksInMonth.push([]);
	    }
	
	    var day = null;
	    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
	      day = currentDay.clone();
	    }
	
	    weeksInMonth[weeksInMonth.length - 1].push(day);
	
	    currentDay.add(1, 'day');
	  }
	
	  return weeksInMonth;
	}

/***/ },
/* 2731 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getPhrase;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getPhrase(phrase, args) {
	  if (typeof phrase === 'string') return phrase;
	
	  if (typeof phrase === 'function') {
	    return phrase(args);
	  }
	
	  return '';
	}

/***/ },
/* 2732 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getTransformStyles;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getTransformStyles(transformValue) {
	  return {
	    transform: transformValue,
	    msTransform: transformValue,
	    MozTransform: transformValue,
	    WebkitTransform: transformValue
	  };
	}

/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyBeforeDay;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isAfterDay = __webpack_require__(244);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isAfterDay2['default'])(a, b);
	}

/***/ },
/* 2734 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTransitionEndSupported;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isTransitionEndSupported() {
	  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
	}

/***/ },
/* 2735 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = registerCSSInterfaceWithDefaultTheme;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactWithStylesInterfaceCss = __webpack_require__(2962);
	
	var _reactWithStylesInterfaceCss2 = _interopRequireDefault(_reactWithStylesInterfaceCss);
	
	var _registerInterfaceWithDefaultTheme = __webpack_require__(2736);
	
	var _registerInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerInterfaceWithDefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function registerCSSInterfaceWithDefaultTheme() {
	  (0, _registerInterfaceWithDefaultTheme2['default'])(_reactWithStylesInterfaceCss2['default']);
	}

/***/ },
/* 2736 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = registerInterfaceWithDefaultTheme;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ThemedStyleSheet = __webpack_require__(1321);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	var _DefaultTheme = __webpack_require__(2727);
	
	var _DefaultTheme2 = _interopRequireDefault(_DefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
	  _ThemedStyleSheet2['default'].registerInterface(reactWithStylesInterface);
	  _ThemedStyleSheet2['default'].registerTheme(_DefaultTheme2['default']);
	}

/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.2.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),l=__webpack_require__(2004),B=__webpack_require__(25),C=__webpack_require__(67),ba=__webpack_require__(2003),da=__webpack_require__(434),ea=__webpack_require__(946),fa=__webpack_require__(299),ia=__webpack_require__(2013),D=__webpack_require__(300);
	function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
	var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
	var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
	hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
	function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
	var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
	scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
	a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
	xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
	Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
	var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
	q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
	function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
	function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
	function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
	var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
	function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
	function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
	return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
	function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
	var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
	function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
	function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
	function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
	var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
	function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
	var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
	B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
	if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
	var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
	function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
	function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
	var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
	e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
	function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
	function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
	function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
	function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
	function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
	function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
	var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
	a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
	bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
	var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
	b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
	function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
	function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
	function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
	function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
	function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
	var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
	function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
	var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
	topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
	topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
	var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
	function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
	var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
	case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
	function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
	var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
	bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
	function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
	"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
	a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
	var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
	$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
	Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
	function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
	function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
	function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
	function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
	function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
	function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
	function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
	function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
	function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
	function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
	function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
	c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
	function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
	function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
	a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
	b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
	4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
	typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
	h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
	function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
	function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
	function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
	b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
	d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
	c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
	e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
	a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
	d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
	g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
	var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
	m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
	f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
	h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
	function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
	b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
	G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
	1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
	e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
	2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
	case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
	c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
	function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
	return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
	k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
	(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
	p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
	function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
	b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
	else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
	N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
	null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
	a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
	c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
	b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
	function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
	d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
	function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
	a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
	k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
	y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
	function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
	t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
	break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
	e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
	if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
	!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
	null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
	g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
	Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
	a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
	Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
	O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
	null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
	void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
	Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
	ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
	function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
	c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
	nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
	a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
	var sf=void 0,tf=void 0;
	if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
	a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
	tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
	function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
	function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
	function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
	function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
	function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
	function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
	function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
	stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
	function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
	function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
	function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
	var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
	topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
	function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
	lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
	""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
	C)}}
	function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
	"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
	g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
	function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
	!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
	function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
	U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
	(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
	var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
	c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
	function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
	var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
	if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
	{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
	d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
	a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
	typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
	b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
	b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
	didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
	function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
	function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
	var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
	E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
	Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ },
/* 2738 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	    "AF": "Afghanistan",
	    "AL": "Albania",
	    "DZ": "Algeria",
	    "AS": "American Samoa",
	    "AD": "Andorra",
	    "AO": "Angola",
	    "AI": "Anguilla",
	    "AG": "Antigua and Barbuda",
	    "AR": "Argentina",
	    "AM": "Armenia",
	    "AW": "Aruba",
	    "AU": "Australia",
	    "AT": "Austria",
	    "AZ": "Azerbaijan",
	    "BS": "Bahamas",
	    "BD": "Bangladesh",
	    "BB": "Barbados",
	    "BY": "Belarus",
	    "BE": "Belgium",
	    "BZ": "Belize",
	    "BJ": "Benin",
	    "BM": "Bermuda",
	    "BT": "Bhutan",
	    "BO": "Bolivia, Plurinational State of",
	    "BA": "Bosnia and Herzegovina",
	    "BW": "Botswana",
	    "BR": "Brazil",
	    "IO": "British Indian Ocean Territory",
	    "BG": "Bulgaria",
	    "BF": "Burkina Faso",
	    "BI": "Burundi",
	    "KH": "Cambodia",
	    "CM": "Cameroon",
	    "CA": "Canada",
	    "CV": "Cape Verde",
	    "KY": "Cayman Islands",
	    "CF": "Central African Republic",
	    "TD": "Chad",
	    "CL": "Chile",
	    "CN": "China",
	    "CO": "Colombia",
	    "KM": "Comoros",
	    "CG": "Congo",
	    "CD": "Democratic Republic of the Congo",
	    "CK": "Cook Islands",
	    "CR": "Costa Rica",
	    "CI": "Côte d'Ivoire",
	    "HR": "Croatia",
	    "CU": "Cuba",
	    "CW": "Curaçao",
	    "CY": "Cyprus",
	    "CZ": "Czech Republic",
	    "DK": "Denmark",
	    "DJ": "Djibouti",
	    "DM": "Dominica",
	    "DO": "Dominican Republic",
	    "EC": "Ecuador",
	    "EG": "Egypt",
	    "SV": "El Salvador",
	    "GQ": "Equatorial Guinea",
	    "ER": "Eritrea",
	    "EE": "Estonia",
	    "ET": "Ethiopia",
	    "FK": "Falkland Islands (Malvinas)",
	    "FO": "Faroe Islands",
	    "FJ": "Fiji",
	    "FI": "Finland",
	    "FR": "France",
	    "PF": "French Polynesia",
	    "GA": "Gabon",
	    "GM": "Gambia",
	    "GE": "Georgia",
	    "DE": "Germany",
	    "GH": "Ghana",
	    "GI": "Gibraltar",
	    "GR": "Greece",
	    "GL": "Greenland",
	    "GD": "Grenada",
	    "GU": "Guam",
	    "GT": "Guatemala",
	    "GG": "Guernsey",
	    "GN": "Guinea",
	    "GW": "Guinea-Bissau",
	    "HT": "Haiti",
	    "HN": "Honduras",
	    "HK": "Hong Kong",
	    "HU": "Hungary",
	    "IS": "Iceland",
	    "IN": "India",
	    "ID": "Indonesia",
	    "IR": "Iran, Islamic Republic of",
	    "IQ": "Iraq",
	    "IE": "Ireland",
	    "IM": "Isle of Man",
	    "IL": "Israel",
	    "IT": "Italy",
	    "JM": "Jamaica",
	    "JP": "Japan",
	    "JE": "Jersey",
	    "JO": "Jordan",
	    "KZ": "Kazakhstan",
	    "KE": "Kenya",
	    "KI": "Kiribati",
	    "KP": "North Korea",
	    "KR": "South Korea",
	    "KW": "Kuwait",
	    "KG": "Kyrgyzstan",
	    "LA": "Lao People's Democratic Republic",
	    "LV": "Latvia",
	    "LB": "Lebanon",
	    "LS": "Lesotho",
	    "LR": "Liberia",
	    "LY": "Libya",
	    "LI": "Liechtenstein",
	    "LT": "Lithuania",
	    "LU": "Luxembourg",
	    "MO": "Macao",
	    "MK": "Republic of Macedonia",
	    "MG": "Madagascar",
	    "MW": "Malawi",
	    "MY": "Malaysia",
	    "MV": "Maldives",
	    "ML": "Mali",
	    "MT": "Malta",
	    "MH": "Marshall Islands",
	    "MQ": "Martinique",
	    "MR": "Mauritania",
	    "MU": "Mauritius",
	    "MX": "Mexico",
	    "FM": "Micronesia, Federated States of",
	    "MD": "Republic of Moldova",
	    "MC": "Monaco",
	    "MN": "Mongolia",
	    "ME": "Montenegro",
	    "MS": "Montserrat",
	    "MA": "Morocco",
	    "MZ": "Mozambique",
	    "MM": "Myanmar",
	    "NA": "Namibia",
	    "NR": "Nauru",
	    "NP": "Nepal",
	    "NL": "Netherlands",
	    "NZ": "New Zealand",
	    "NI": "Nicaragua",
	    "NE": "Niger",
	    "NG": "Nigeria",
	    "NU": "Niue",
	    "NF": "Norfolk Island",
	    "MP": "Northern Mariana Islands",
	    "NO": "Norway",
	    "OM": "Oman",
	    "PK": "Pakistan",
	    "PW": "Palau",
	    "PS": "Palestinian Territory",
	    "PA": "Panama",
	    "PG": "Papua New Guinea",
	    "PY": "Paraguay",
	    "PE": "Peru",
	    "PH": "Philippines",
	    "PN": "Pitcairn",
	    "PL": "Poland",
	    "PT": "Portugal",
	    "PR": "Puerto Rico",
	    "QA": "Qatar",
	    "RO": "Romania",
	    "RU": "Russian",
	    "RW": "Rwanda",
	    "KN": "Saint Kitts and Nevis",
	    "WS": "Samoa",
	    "SM": "San Marino",
	    "ST": "Sao Tome and Principe",
	    "SA": "Saudi Arabia",
	    "SN": "Senegal",
	    "RS": "Serbia",
	    "SC": "Seychelles",
	    "SL": "Sierra Leone",
	    "SG": "Singapore",
	    "SX": "Sint Maarten",
	    "SK": "Slovakia",
	    "SI": "Slovenia",
	    "SB": "Solomon Islands",
	    "SO": "Somalia",
	    "ZA": "South Africa",
	    "SS": "South Sudan",
	    "ES": "Spain",
	    "LK": "Sri Lanka",
	    "SD": "Sudan",
	    "SR": "Suriname",
	    "SZ": "Swaziland",
	    "SE": "Sweden",
	    "CH": "Switzerland",
	    "SY": "Syria",
	    "TW": "Taiwan, Province of China",
	    "TJ": "Tajikistan",
	    "TZ": "Tanzania",
	    "TH": "Thailand",
	    "TG": "Togo",
	    "TK": "Tokelau",
	    "TO": "Tonga",
	    "TT": "Trinidad and Tobago",
	    "TN": "Tunisia",
	    "TR": "Turkey",
	    "TM": "Turkmenistan",
	    "TC": "Turks and Caicos Islands",
	    "TV": "Tuvalu",
	    "UG": "Uganda",
	    "UA": "Ukraine",
	    "AE": "United Arab Emirates",
	    "GB": "United Kingdom",
	    "US": "United States",
	    "UY": "Uruguay",
	    "UZ": "Uzbekistan",
	    "VU": "Vanuatu",
	    "VE": "Venezuela, Bolivarian Republic of",
	    "VN": "Viet Nam",
	    "VI": "Virgin Islands",
	    "YE": "Yemen",
	    "ZM": "Zambia",
	    "ZW": "Zimbabwe"
	};
	module.exports = exports["default"];

/***/ },
/* 2739 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(1244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var sizerStyle = {
		position: 'absolute',
		top: 0,
		left: 0,
		visibility: 'hidden',
		height: 0,
		overflow: 'scroll',
		whiteSpace: 'pre'
	};
	
	var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];
	
	var cleanInputProps = function cleanInputProps(inputProps) {
		INPUT_PROPS_BLACKLIST.forEach(function (field) {
			return delete inputProps[field];
		});
		return inputProps;
	};
	
	var copyStyles = function copyStyles(styles, node) {
		node.style.fontSize = styles.fontSize;
		node.style.fontFamily = styles.fontFamily;
		node.style.fontWeight = styles.fontWeight;
		node.style.fontStyle = styles.fontStyle;
		node.style.letterSpacing = styles.letterSpacing;
		node.style.textTransform = styles.textTransform;
	};
	
	var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
	
	var generateId = function generateId() {
		// we only need an auto-generated ID for stylesheet injection, which is only
		// used for IE. so if the browser is not IE, this should return undefined.
		return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
	};
	
	var AutosizeInput = function (_Component) {
		_inherits(AutosizeInput, _Component);
	
		function AutosizeInput(props) {
			_classCallCheck(this, AutosizeInput);
	
			var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
	
			_this.inputRef = function (el) {
				_this.input = el;
				if (typeof _this.props.inputRef === 'function') {
					_this.props.inputRef(el);
				}
			};
	
			_this.placeHolderSizerRef = function (el) {
				_this.placeHolderSizer = el;
			};
	
			_this.sizerRef = function (el) {
				_this.sizer = el;
			};
	
			_this.state = {
				inputWidth: props.minWidth,
				inputId: props.id || generateId()
			};
			return _this;
		}
	
		_createClass(AutosizeInput, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.mounted = true;
				this.copyInputStyles();
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				var id = nextProps.id;
	
				if (id !== this.props.id) {
					this.setState({ inputId: id || generateId() });
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps, prevState) {
				if (prevState.inputWidth !== this.state.inputWidth) {
					if (typeof this.props.onAutosize === 'function') {
						this.props.onAutosize(this.state.inputWidth);
					}
				}
				this.updateInputWidth();
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.mounted = false;
			}
		}, {
			key: 'copyInputStyles',
			value: function copyInputStyles() {
				if (!this.mounted || !window.getComputedStyle) {
					return;
				}
				var inputStyles = this.input && window.getComputedStyle(this.input);
				if (!inputStyles) {
					return;
				}
				copyStyles(inputStyles, this.sizer);
				if (this.placeHolderSizer) {
					copyStyles(inputStyles, this.placeHolderSizer);
				}
			}
		}, {
			key: 'updateInputWidth',
			value: function updateInputWidth() {
				if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
					return;
				}
				var newInputWidth = void 0;
				if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
					newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
				} else {
					newInputWidth = this.sizer.scrollWidth + 2;
				}
				// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
				var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
				newInputWidth += extraWidth;
				if (newInputWidth < this.props.minWidth) {
					newInputWidth = this.props.minWidth;
				}
				if (newInputWidth !== this.state.inputWidth) {
					this.setState({
						inputWidth: newInputWidth
					});
				}
			}
		}, {
			key: 'getInput',
			value: function getInput() {
				return this.input;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'blur',
			value: function blur() {
				this.input.blur();
			}
		}, {
			key: 'select',
			value: function select() {
				this.input.select();
			}
		}, {
			key: 'renderStyles',
			value: function renderStyles() {
				// this method injects styles to hide IE's clear indicator, which messes
				// with input size detection. the stylesheet is only injected when the
				// browser is IE, and can also be disabled by the `injectStyles` prop.
				var injectStyles = this.props.injectStyles;
	
				return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
					} }) : null;
			}
		}, {
			key: 'render',
			value: function render() {
				var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
					if (previousValue !== null && previousValue !== undefined) {
						return previousValue;
					}
					return currentValue;
				});
	
				var wrapperStyle = _extends({}, this.props.style);
				if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
	
				var inputStyle = _extends({
					boxSizing: 'content-box',
					width: this.state.inputWidth + 'px'
				}, this.props.inputStyle);
	
				var inputProps = _objectWithoutProperties(this.props, []);
	
				cleanInputProps(inputProps);
				inputProps.className = this.props.inputClassName;
				inputProps.id = this.state.inputId;
				inputProps.style = inputStyle;
	
				return _react2.default.createElement(
					'div',
					{ className: this.props.className, style: wrapperStyle },
					this.renderStyles(),
					_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
					_react2.default.createElement(
						'div',
						{ ref: this.sizerRef, style: sizerStyle },
						sizerValue
					),
					this.props.placeholder ? _react2.default.createElement(
						'div',
						{ ref: this.placeHolderSizerRef, style: sizerStyle },
						this.props.placeholder
					) : null
				);
			}
		}]);
	
		return AutosizeInput;
	}(_react.Component);
	
	AutosizeInput.propTypes = {
		className: _propTypes2.default.string, // className for the outer element
		defaultValue: _propTypes2.default.any, // default field value
		extraWidth: _propTypes2.default.oneOfType([// additional width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
		injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
		inputClassName: _propTypes2.default.string, // className for the input element
		inputRef: _propTypes2.default.func, // ref callback for the input element
		inputStyle: _propTypes2.default.object, // css styles for the input element
		minWidth: _propTypes2.default.oneOfType([// minimum width for input element
		_propTypes2.default.number, _propTypes2.default.string]),
		onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
		onChange: _propTypes2.default.func, // onChange handler: function(event) {}
		placeholder: _propTypes2.default.string, // placeholder text
		placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
		style: _propTypes2.default.object, // css styles for the outer element
		value: _propTypes2.default.any // field value
	};
	AutosizeInput.defaultProps = {
		minWidth: 1,
		injectStyles: true
	};
	
	exports.default = AutosizeInput;

/***/ },
/* 2741 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.ar=a())}(this,function(){"use strict";return[{locale:"ar",pluralRuleFunction:function(e,a){var r=String(e).split("."),o=Number(r[0])==e&&r[0].slice(-2);return a?"other":0==e?"zero":1==e?"one":2==e?"two":o>=3&&o<=10?"few":o>=11&&o<=99?"many":"other"},fields:{year:{displayName:"السنة",relative:{0:"السنة الحالية",1:"السنة القادمة","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-AE",parentLocale:"ar",fields:{year:{displayName:"السنة",relative:{0:"هذه السنة",1:"السنة التالية","-1":"السنة الماضية"},relativeTime:{future:{zero:"خلال {0} سنة",one:"خلال سنة واحدة",two:"خلال سنتين",few:"خلال {0} سنوات",many:"خلال {0} سنة",other:"خلال {0} سنة"},past:{zero:"قبل {0} سنة",one:"قبل سنة واحدة",two:"قبل سنتين",few:"قبل {0} سنوات",many:"قبل {0} سنة",other:"قبل {0} سنة"}}},month:{displayName:"الشهر",relative:{0:"هذا الشهر",1:"الشهر القادم","-1":"الشهر الماضي"},relativeTime:{future:{zero:"خلال {0} شهر",one:"خلال شهر واحد",two:"خلال شهرين",few:"خلال {0} أشهر",many:"خلال {0} شهرًا",other:"خلال {0} شهر"},past:{zero:"قبل {0} شهر",one:"قبل شهر واحد",two:"قبل شهرين",few:"قبل {0} أشهر",many:"قبل {0} شهرًا",other:"قبل {0} شهر"}}},day:{displayName:"يوم",relative:{0:"اليوم",1:"غدًا",2:"بعد الغد","-2":"أول أمس","-1":"أمس"},relativeTime:{future:{zero:"خلال {0} يوم",one:"خلال يوم واحد",two:"خلال يومين",few:"خلال {0} أيام",many:"خلال {0} يومًا",other:"خلال {0} يوم"},past:{zero:"قبل {0} يوم",one:"قبل يوم واحد",two:"قبل يومين",few:"قبل {0} أيام",many:"قبل {0} يومًا",other:"قبل {0} يوم"}}},hour:{displayName:"الساعات",relative:{0:"الساعة الحالية"},relativeTime:{future:{zero:"خلال {0} ساعة",one:"خلال ساعة واحدة",two:"خلال ساعتين",few:"خلال {0} ساعات",many:"خلال {0} ساعة",other:"خلال {0} ساعة"},past:{zero:"قبل {0} ساعة",one:"قبل ساعة واحدة",two:"قبل ساعتين",few:"قبل {0} ساعات",many:"قبل {0} ساعة",other:"قبل {0} ساعة"}}},minute:{displayName:"الدقائق",relative:{0:"هذه الدقيقة"},relativeTime:{future:{zero:"خلال {0} دقيقة",one:"خلال دقيقة واحدة",two:"خلال دقيقتين",few:"خلال {0} دقائق",many:"خلال {0} دقيقة",other:"خلال {0} دقيقة"},past:{zero:"قبل {0} دقيقة",one:"قبل دقيقة واحدة",two:"قبل دقيقتين",few:"قبل {0} دقائق",many:"قبل {0} دقيقة",other:"قبل {0} دقيقة"}}},second:{displayName:"الثواني",relative:{0:"الآن"},relativeTime:{future:{zero:"خلال {0} ثانية",one:"خلال ثانية واحدة",two:"خلال ثانيتين",few:"خلال {0} ثوانٍ",many:"خلال {0} ثانية",other:"خلال {0} ثانية"},past:{zero:"قبل {0} ثانية",one:"قبل ثانية واحدة",two:"قبل ثانيتين",few:"قبل {0} ثوانِ",many:"قبل {0} ثانية",other:"قبل {0} ثانية"}}}}},{locale:"ar-BH",parentLocale:"ar"},{locale:"ar-DJ",parentLocale:"ar"},{locale:"ar-DZ",parentLocale:"ar"},{locale:"ar-EG",parentLocale:"ar"},{locale:"ar-EH",parentLocale:"ar"},{locale:"ar-ER",parentLocale:"ar"},{locale:"ar-IL",parentLocale:"ar"},{locale:"ar-IQ",parentLocale:"ar"},{locale:"ar-JO",parentLocale:"ar"},{locale:"ar-KM",parentLocale:"ar"},{locale:"ar-KW",parentLocale:"ar"},{locale:"ar-LB",parentLocale:"ar"},{locale:"ar-LY",parentLocale:"ar"},{locale:"ar-MA",parentLocale:"ar"},{locale:"ar-MR",parentLocale:"ar"},{locale:"ar-OM",parentLocale:"ar"},{locale:"ar-PS",parentLocale:"ar"},{locale:"ar-QA",parentLocale:"ar"},{locale:"ar-SA",parentLocale:"ar"},{locale:"ar-SD",parentLocale:"ar"},{locale:"ar-SO",parentLocale:"ar"},{locale:"ar-SS",parentLocale:"ar"},{locale:"ar-SY",parentLocale:"ar"},{locale:"ar-TD",parentLocale:"ar"},{locale:"ar-TN",parentLocale:"ar"},{locale:"ar-YE",parentLocale:"ar"}]});


/***/ },
/* 2742 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var n=String(e).split("."),l=!n[1],o=Number(n[0])==e,t=o&&n[0].slice(-1),r=o&&n[0].slice(-2);return a?1==t&&11!=r?"one":2==t&&12!=r?"two":3==t&&13!=r?"few":"other":1==e&&l?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}}}},{locale:"en-001",parentLocale:"en"},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001"},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001"},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001"},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ },
/* 2743 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.es=a())}(this,function(){"use strict";return[{locale:"es",pluralRuleFunction:function(e,a){return a?"other":1==e?"one":"other"},fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-419",parentLocale:"es"},{locale:"es-AR",parentLocale:"es-419"},{locale:"es-BO",parentLocale:"es-419"},{locale:"es-BR",parentLocale:"es-419"},{locale:"es-BZ",parentLocale:"es-419"},{locale:"es-CL",parentLocale:"es-419"},{locale:"es-CO",parentLocale:"es-419"},{locale:"es-CR",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-CU",parentLocale:"es-419"},{locale:"es-DO",parentLocale:"es-419",fields:{year:{displayName:"Año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"Mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"Día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"anteayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"Minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"Segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-EA",parentLocale:"es"},{locale:"es-EC",parentLocale:"es-419"},{locale:"es-GQ",parentLocale:"es"},{locale:"es-GT",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-HN",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-IC",parentLocale:"es"},{locale:"es-MX",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el año próximo","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el mes próximo","-1":"el mes pasado"},relativeTime:{future:{one:"en {0} mes",other:"en {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-NI",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PA",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-PE",parentLocale:"es-419"},{locale:"es-PH",parentLocale:"es"},{locale:"es-PR",parentLocale:"es-419"},{locale:"es-PY",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antes de ayer","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-SV",parentLocale:"es-419",fields:{year:{displayName:"año",relative:{0:"este año",1:"el próximo año","-1":"el año pasado"},relativeTime:{future:{one:"dentro de {0} año",other:"dentro de {0} años"},past:{one:"hace {0} año",other:"hace {0} años"}}},month:{displayName:"mes",relative:{0:"este mes",1:"el próximo mes","-1":"el mes pasado"},relativeTime:{future:{one:"dentro de {0} mes",other:"dentro de {0} meses"},past:{one:"hace {0} mes",other:"hace {0} meses"}}},day:{displayName:"día",relative:{0:"hoy",1:"mañana",2:"pasado mañana","-2":"antier","-1":"ayer"},relativeTime:{future:{one:"dentro de {0} día",other:"dentro de {0} días"},past:{one:"hace {0} día",other:"hace {0} días"}}},hour:{displayName:"hora",relative:{0:"esta hora"},relativeTime:{future:{one:"dentro de {0} hora",other:"dentro de {0} horas"},past:{one:"hace {0} hora",other:"hace {0} horas"}}},minute:{displayName:"minuto",relative:{0:"este minuto"},relativeTime:{future:{one:"dentro de {0} minuto",other:"dentro de {0} minutos"},past:{one:"hace {0} minuto",other:"hace {0} minutos"}}},second:{displayName:"segundo",relative:{0:"ahora"},relativeTime:{future:{one:"dentro de {0} segundo",other:"dentro de {0} segundos"},past:{one:"hace {0} segundo",other:"hace {0} segundos"}}}}},{locale:"es-US",parentLocale:"es-419"},{locale:"es-UY",parentLocale:"es-419"},{locale:"es-VE",parentLocale:"es-419"}]});


/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.fr=a())}(this,function(){"use strict";return[{locale:"fr",pluralRuleFunction:function(e,a){return a?1==e?"one":"other":e>=0&&e<2?"one":"other"},fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"dans {0} an",other:"dans {0} ans"},past:{one:"il y a {0} an",other:"il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-BE",parentLocale:"fr"},{locale:"fr-BF",parentLocale:"fr"},{locale:"fr-BI",parentLocale:"fr"},{locale:"fr-BJ",parentLocale:"fr"},{locale:"fr-BL",parentLocale:"fr"},{locale:"fr-CA",parentLocale:"fr",fields:{year:{displayName:"année",relative:{0:"cette année",1:"l’année prochaine","-1":"l’année dernière"},relativeTime:{future:{one:"Dans {0} an",other:"Dans {0} ans"},past:{one:"Il y a {0} an",other:"Il y a {0} ans"}}},month:{displayName:"mois",relative:{0:"ce mois-ci",1:"le mois prochain","-1":"le mois dernier"},relativeTime:{future:{one:"dans {0} mois",other:"dans {0} mois"},past:{one:"il y a {0} mois",other:"il y a {0} mois"}}},day:{displayName:"jour",relative:{0:"aujourd’hui",1:"demain",2:"après-demain","-2":"avant-hier","-1":"hier"},relativeTime:{future:{one:"dans {0} jour",other:"dans {0} jours"},past:{one:"il y a {0} jour",other:"il y a {0} jours"}}},hour:{displayName:"heure",relative:{0:"cette heure-ci"},relativeTime:{future:{one:"dans {0} heure",other:"dans {0} heures"},past:{one:"il y a {0} heure",other:"il y a {0} heures"}}},minute:{displayName:"minute",relative:{0:"cette minute-ci"},relativeTime:{future:{one:"dans {0} minute",other:"dans {0} minutes"},past:{one:"il y a {0} minute",other:"il y a {0} minutes"}}},second:{displayName:"seconde",relative:{0:"maintenant"},relativeTime:{future:{one:"dans {0} seconde",other:"dans {0} secondes"},past:{one:"il y a {0} seconde",other:"il y a {0} secondes"}}}}},{locale:"fr-CD",parentLocale:"fr"},{locale:"fr-CF",parentLocale:"fr"},{locale:"fr-CG",parentLocale:"fr"},{locale:"fr-CH",parentLocale:"fr"},{locale:"fr-CI",parentLocale:"fr"},{locale:"fr-CM",parentLocale:"fr"},{locale:"fr-DJ",parentLocale:"fr"},{locale:"fr-DZ",parentLocale:"fr"},{locale:"fr-GA",parentLocale:"fr"},{locale:"fr-GF",parentLocale:"fr"},{locale:"fr-GN",parentLocale:"fr"},{locale:"fr-GP",parentLocale:"fr"},{locale:"fr-GQ",parentLocale:"fr"},{locale:"fr-HT",parentLocale:"fr"},{locale:"fr-KM",parentLocale:"fr"},{locale:"fr-LU",parentLocale:"fr"},{locale:"fr-MA",parentLocale:"fr"},{locale:"fr-MC",parentLocale:"fr"},{locale:"fr-MF",parentLocale:"fr"},{locale:"fr-MG",parentLocale:"fr"},{locale:"fr-ML",parentLocale:"fr"},{locale:"fr-MQ",parentLocale:"fr"},{locale:"fr-MR",parentLocale:"fr"},{locale:"fr-MU",parentLocale:"fr"},{locale:"fr-NC",parentLocale:"fr"},{locale:"fr-NE",parentLocale:"fr"},{locale:"fr-PF",parentLocale:"fr"},{locale:"fr-PM",parentLocale:"fr"},{locale:"fr-RE",parentLocale:"fr"},{locale:"fr-RW",parentLocale:"fr"},{locale:"fr-SC",parentLocale:"fr"},{locale:"fr-SN",parentLocale:"fr"},{locale:"fr-SY",parentLocale:"fr"},{locale:"fr-TD",parentLocale:"fr"},{locale:"fr-TG",parentLocale:"fr"},{locale:"fr-TN",parentLocale:"fr"},{locale:"fr-VU",parentLocale:"fr"},{locale:"fr-WF",parentLocale:"fr"},{locale:"fr-YT",parentLocale:"fr"}]});


/***/ },
/* 2745 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=o())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,o){var t=!String(e).split(".")[1];return o?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ },
/* 2746 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.zh=t())}(this,function(){"use strict";return[{locale:"zh",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒钟后"},past:{other:"{0}秒钟前"}}}}},{locale:"zh-Hans",parentLocale:"zh"},{locale:"zh-Hans-HK",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-MO",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hans-SG",parentLocale:"zh-Hans",fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0}年后"},past:{other:"{0}年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下个月","-1":"上个月"},relativeTime:{future:{other:"{0}个月后"},past:{other:"{0}个月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"后天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0}天后"},past:{other:"{0}天前"}}},hour:{displayName:"小时",relative:{0:"这一时间 / 此时"},relativeTime:{future:{other:"{0}小时后"},past:{other:"{0}小时前"}}},minute:{displayName:"分钟",relative:{0:"此刻"},relativeTime:{future:{other:"{0}分钟后"},past:{other:"{0}分钟前"}}},second:{displayName:"秒",relative:{0:"现在"},relativeTime:{future:{other:"{0}秒后"},past:{other:"{0}秒前"}}}}},{locale:"zh-Hant",pluralRuleFunction:function(e,t){return"other"},fields:{year:{displayName:"年",relative:{0:"今年",1:"明年","-1":"去年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今天",1:"明天",2:"後天","-2":"前天","-1":"昨天"},relativeTime:{future:{other:"{0} 天後"},past:{other:"{0} 天前"}}},hour:{displayName:"小時",relative:{0:"這一小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這一分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-HK",parentLocale:"zh-Hant",fields:{year:{displayName:"年",relative:{0:"今年",1:"下年","-1":"上年"},relativeTime:{future:{other:"{0} 年後"},past:{other:"{0} 年前"}}},month:{displayName:"月",relative:{0:"本月",1:"下個月","-1":"上個月"},relativeTime:{future:{other:"{0} 個月後"},past:{other:"{0} 個月前"}}},day:{displayName:"日",relative:{0:"今日",1:"明日",2:"後日","-2":"前日","-1":"昨日"},relativeTime:{future:{other:"{0} 日後"},past:{other:"{0} 日前"}}},hour:{displayName:"小時",relative:{0:"這個小時"},relativeTime:{future:{other:"{0} 小時後"},past:{other:"{0} 小時前"}}},minute:{displayName:"分鐘",relative:{0:"這分鐘"},relativeTime:{future:{other:"{0} 分鐘後"},past:{other:"{0} 分鐘前"}}},second:{displayName:"秒",relative:{0:"現在"},relativeTime:{future:{other:"{0} 秒後"},past:{other:"{0} 秒前"}}}}},{locale:"zh-Hant-MO",parentLocale:"zh-Hant-HK"}]});


/***/ },
/* 2747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _eventlistener = __webpack_require__(1989);
	
	var _lodash = __webpack_require__(307);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(2326);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _parentScroll = __webpack_require__(2750);
	
	var _parentScroll2 = _interopRequireDefault(_parentScroll);
	
	var _inViewport = __webpack_require__(2749);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.lazyLoadHandler = _this.lazyLoadHandler.bind(_this);
	
	    if (props.throttle > 0) {
	      if (props.debounce) {
	        _this.lazyLoadHandler = (0, _lodash2.default)(_this.lazyLoadHandler, props.throttle);
	      } else {
	        _this.lazyLoadHandler = (0, _lodash4.default)(_this.lazyLoadHandler, props.throttle);
	      }
	    }
	
	    _this.state = { visible: false };
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      var eventNode = this.getEventNode();
	
	      this.lazyLoadHandler();
	
	      if (this.lazyLoadHandler.flush) {
	        this.lazyLoadHandler.flush();
	      }
	
	      (0, _eventlistener.add)(window, 'resize', this.lazyLoadHandler);
	      (0, _eventlistener.add)(eventNode, 'scroll', this.lazyLoadHandler);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (!this.state.visible) {
	        this.lazyLoadHandler();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_nextProps, nextState) {
	      return nextState.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      if (this.lazyLoadHandler.cancel) {
	        this.lazyLoadHandler.cancel();
	      }
	
	      this.detachListeners();
	    }
	  }, {
	    key: 'getEventNode',
	    value: function getEventNode() {
	      return (0, _parentScroll2.default)((0, _reactDom.findDOMNode)(this));
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset() {
	      var _props = this.props,
	          offset = _props.offset,
	          offsetVertical = _props.offsetVertical,
	          offsetHorizontal = _props.offsetHorizontal,
	          offsetTop = _props.offsetTop,
	          offsetBottom = _props.offsetBottom,
	          offsetLeft = _props.offsetLeft,
	          offsetRight = _props.offsetRight,
	          threshold = _props.threshold;
	
	
	      var _offsetAll = threshold || offset;
	      var _offsetVertical = offsetVertical || _offsetAll;
	      var _offsetHorizontal = offsetHorizontal || _offsetAll;
	
	      return {
	        top: offsetTop || _offsetVertical,
	        bottom: offsetBottom || _offsetVertical,
	        left: offsetLeft || _offsetHorizontal,
	        right: offsetRight || _offsetHorizontal
	      };
	    }
	  }, {
	    key: 'lazyLoadHandler',
	    value: function lazyLoadHandler() {
	      if (!this._mounted) {
	        return;
	      }
	      var offset = this.getOffset();
	      var node = (0, _reactDom.findDOMNode)(this);
	      var eventNode = this.getEventNode();
	
	      if ((0, _inViewport2.default)(node, eventNode, offset)) {
	        var onContentVisible = this.props.onContentVisible;
	
	
	        this.setState({ visible: true }, function () {
	          if (onContentVisible) {
	            onContentVisible();
	          }
	        });
	        this.detachListeners();
	      }
	    }
	  }, {
	    key: 'detachListeners',
	    value: function detachListeners() {
	      var eventNode = this.getEventNode();
	
	      (0, _eventlistener.remove)(window, 'resize', this.lazyLoadHandler);
	      (0, _eventlistener.remove)(eventNode, 'scroll', this.lazyLoadHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          height = _props2.height,
	          width = _props2.width;
	      var visible = this.state.visible;
	
	
	      var elStyles = { height: height, width: width };
	      var elClasses = 'LazyLoad' + (visible ? ' is-visible' : '') + (className ? ' ' + className : '');
	
	      return _react2.default.createElement(this.props.elementType, {
	        className: elClasses,
	        style: elStyles
	      }, visible && _react.Children.only(children));
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	exports.default = LazyLoad;
	
	
	LazyLoad.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string,
	  debounce: _propTypes2.default.bool,
	  elementType: _propTypes2.default.string,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  offset: _propTypes2.default.number,
	  offsetBottom: _propTypes2.default.number,
	  offsetHorizontal: _propTypes2.default.number,
	  offsetLeft: _propTypes2.default.number,
	  offsetRight: _propTypes2.default.number,
	  offsetTop: _propTypes2.default.number,
	  offsetVertical: _propTypes2.default.number,
	  threshold: _propTypes2.default.number,
	  throttle: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onContentVisible: _propTypes2.default.func
	};
	
	LazyLoad.defaultProps = {
	  elementType: 'div',
	  debounce: true,
	  offset: 0,
	  offsetBottom: 0,
	  offsetHorizontal: 0,
	  offsetLeft: 0,
	  offsetRight: 0,
	  offsetTop: 0,
	  offsetVertical: 0,
	  throttle: 250
	};

/***/ },
/* 2748 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getElementPosition;
	/*
	* Finds element's position relative to the whole document,
	* rather than to the viewport as it is the case with .getBoundingClientRect().
	*/
	function getElementPosition(element) {
	  var rect = element.getBoundingClientRect();
	
	  return {
	    top: rect.top + window.pageYOffset,
	    left: rect.left + window.pageXOffset
	  };
	}

/***/ },
/* 2749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inViewport;
	
	var _getElementPosition = __webpack_require__(2748);
	
	var _getElementPosition2 = _interopRequireDefault(_getElementPosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isHidden = function isHidden(element) {
	  return element.offsetParent === null;
	};
	
	function inViewport(element, container, customOffset) {
	  if (isHidden(element)) {
	    return false;
	  }
	
	  var top = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var right = void 0;
	
	  if (typeof container === 'undefined' || container === window) {
	    top = window.pageYOffset;
	    left = window.pageXOffset;
	    bottom = top + window.innerHeight;
	    right = left + window.innerWidth;
	  } else {
	    var containerPosition = (0, _getElementPosition2.default)(container);
	
	    top = containerPosition.top;
	    left = containerPosition.left;
	    bottom = top + container.offsetHeight;
	    right = left + container.offsetWidth;
	  }
	
	  var elementPosition = (0, _getElementPosition2.default)(element);
	
	  return top <= elementPosition.top + element.offsetHeight + customOffset.top && bottom >= elementPosition.top - customOffset.bottom && left <= elementPosition.left + element.offsetWidth + customOffset.left && right >= elementPosition.left - customOffset.right;
	}

/***/ },
/* 2750 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var style = function style(element, prop) {
	  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
	};
	
	var overflow = function overflow(element) {
	  return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
	};
	
	var scrollParent = function scrollParent(element) {
	  if (!(element instanceof HTMLElement)) {
	    return window;
	  }
	
	  var parent = element;
	
	  while (parent) {
	    if (parent === document.body || parent === document.documentElement) {
	      break;
	    }
	
	    if (!parent.parentNode) {
	      break;
	    }
	
	    if (/(scroll|auto)/.test(overflow(parent))) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return window;
	};
	
	exports.default = scrollParent;

/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2753);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
	var isBrowser = typeof window !== 'undefined';
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (isBrowser) {
	        if (!this.props.container) {
	          this.container = document.createElement('div');
	          document.body.appendChild(this.container);
	        } else {
	          this.container = this.props.container;
	        }
	        this.renderLayer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unmountComponentAtNode(this.container);
	      }
	      if (!this.props.container) {
	        document.body.removeChild(this.container);
	      }
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (useCreatePortal) {
	        return _reactDom2.default.createPortal(this.props.children, this.container);
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node, // eslint-disable-line
	  container: _propTypes2.default.object // eslint-disable-line
	};
	
	exports.default = Portal;

/***/ },
/* 2752 */
[3545, 2754],
/* 2753 */
[3546, 2752],
/* 2754 */
1144,
/* 2755 */
/***/ function(module, exports) {

	var messages = {
	  invalidPredicate: '`predicate` must be a function',
	  invalidPropValidator: '`propValidator` must be a function',
	  requiredCore: 'is marked as required',
	  invalidTypeCore: 'Invalid input type',
	  predicateFailureCore: 'Failed to succeed with predicate',
	  anonymousMessage: '<<anonymous>>',
	  baseInvalidMessage: 'Invalid ',
	};
	
	function constructPropValidatorVariations(propValidator) {
	  if (typeof propValidator !== 'function') {
	    throw new Error(messages.invalidPropValidator);
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false, null);
	  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
	
	  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
	    if (typeof predicate !== 'function') {
	      throw new Error(messages.invalidPredicate);
	    }
	    var basePropValidator = propValidator.bind(null, false, predicate);
	    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
	    return basePropValidator;
	  };
	
	  return requiredPropValidator;
	}
	
	function createInvalidRequiredErrorMessage(propName, componentName, value) {
	  return new Error(
	    'The prop `' + propName + '` ' + messages.requiredCore +
	    ' in `' + componentName + '`, but its value is `' + value + '`.'
	  );
	}
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(
	    isRequired, // Bound parameter to indicate with the propType is required
	    predicate, // Bound parameter to allow user to add dynamic validation
	    props,
	    propName,
	    componentName,
	    location,
	    propFullName
	  ) {
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    var isPropValueUndefined = typeof propValue === 'undefined';
	    var isPropValueNull = propValue === null;
	
	    if (isRequired) {
	      componentName = componentName ||  messages.anonymousMessage;
	      propFullName = propFullName || propName;
	      if (isPropValueUndefined) {
	        return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
	      } else if (isPropValueNull) {
	        return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
	      }
	    }
	
	    if (isPropValueUndefined || isPropValueNull) {
	      return null;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (! validator(propValue)) {
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    if (predicate && ! predicate(propValue)) {
	      var predicateName = predicate.name || messages.anonymousMessage;
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
	        predicateName + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  return constructPropValidatorVariations(propValidator);
	
	}
	
	module.exports = {
	  constructPropValidatorVariations: constructPropValidatorVariations,
	  createMomentChecker: createMomentChecker,
	  messages: messages,
	};


/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(8);
	
	function isValidMoment(testMoment) {
	  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
	    return false;
	  }
	
	  /* istanbul ignore else  */
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  /* istanbul ignore next */
	  return !isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	};


/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(495);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(339);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(497);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(498);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(237);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(496);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	    style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    onRest: _propTypes2['default'].func
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  },
	
	  wasAnimating: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyle: null,
	  // after checking for unreadPropStyle != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(destStyle) {
	    var dirty = false;
	    var _state = this.state;
	    var currentStyle = _state.currentStyle;
	    var currentVelocity = _state.currentVelocity;
	    var lastIdealStyle = _state.lastIdealStyle;
	    var lastIdealVelocity = _state.lastIdealVelocity;
	
	    for (var key in destStyle) {
	      if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	        continue;
	      }
	
	      var styleValue = destStyle[key];
	      if (typeof styleValue === 'number') {
	        if (!dirty) {
	          dirty = true;
	          currentStyle = _extends({}, currentStyle);
	          currentVelocity = _extends({}, currentVelocity);
	          lastIdealStyle = _extends({}, lastIdealStyle);
	          lastIdealVelocity = _extends({}, lastIdealVelocity);
	        }
	
	        currentStyle[key] = styleValue;
	        currentVelocity[key] = 0;
	        lastIdealStyle[key] = styleValue;
	        lastIdealVelocity[key] = 0;
	      }
	    }
	
	    if (dirty) {
	      this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // check if we need to animate in the first place
	      var propsStyle = _this.props.style;
	      if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	        if (_this.wasAnimating && _this.props.onRest) {
	          _this.props.onRest();
	        }
	
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.wasAnimating = false;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      _this.wasAnimating = true;
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyle = {};
	      var newLastIdealVelocity = {};
	      var newCurrentStyle = {};
	      var newCurrentVelocity = {};
	
	      for (var key in propsStyle) {
	        if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	          continue;
	        }
	
	        var styleValue = propsStyle[key];
	        if (typeof styleValue === 'number') {
	          newCurrentStyle[key] = styleValue;
	          newCurrentVelocity[key] = 0;
	          newLastIdealStyle[key] = styleValue;
	          newLastIdealVelocity[key] = 0;
	        } else {
	          var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	          var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	          for (var i = 0; i < framesToCatchUp; i++) {
	            var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            newLastIdealStyleValue = _stepper[0];
	            newLastIdealVelocityValue = _stepper[1];
	          }
	
	          var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	          var nextIdealX = _stepper2[0];
	          var nextIdealV = _stepper2[1];
	
	          newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	          newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	          newLastIdealStyle[key] = newLastIdealStyleValue;
	          newLastIdealVelocity[key] = newLastIdealVelocityValue;
	        }
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyle: newCurrentStyle,
	        currentVelocity: newCurrentVelocity,
	        lastIdealStyle: newLastIdealStyle,
	        lastIdealVelocity: newLastIdealVelocity
	      });
	
	      _this.unreadPropStyle = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = Motion;
	module.exports = exports['default'];

/***/ },
/* 2758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(495);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(339);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(497);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(498);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(237);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(496);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = _createReactClass2['default']({
	  propTypes: {
	    // TOOD: warn against putting a config in here
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	    styles: _propTypes2['default'].func.isRequired,
	    children: _propTypes2['default'].func.isRequired
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  },
	
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _state = this.state;
	    var currentStyles = _state.currentStyles;
	    var currentVelocities = _state.currentVelocities;
	    var lastIdealStyles = _state.lastIdealStyles;
	    var lastIdealVelocities = _state.lastIdealVelocities;
	
	    var someDirty = false;
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i];
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            someDirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	        }
	      }
	    }
	
	    if (someDirty) {
	      this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	    }
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var newLastIdealStyles = [];
	      var newLastIdealVelocities = [];
	      var newCurrentStyles = [];
	      var newCurrentVelocities = [];
	
	      for (var i = 0; i < destStyles.length; i++) {
	        var destStyle = destStyles[i];
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in destStyle) {
	          if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	            continue;
	          }
	
	          var styleValue = destStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _mapToZero = __webpack_require__(495);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(339);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(497);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(2760);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(498);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(237);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(496);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = _createReactClass2['default']({
	  propTypes: {
	    defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	    })),
	    styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	      key: _propTypes2['default'].string.isRequired,
	      data: _propTypes2['default'].any,
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	    }))]).isRequired,
	    children: _propTypes2['default'].func.isRequired,
	    willEnter: _propTypes2['default'].func,
	    willLeave: _propTypes2['default'].func,
	    didLeave: _propTypes2['default'].func
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    };
	  },
	
	  getInitialState: function getInitialState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync[0];
	    var currentStyles = _mergeAndSync[1];
	    var currentVelocities = _mergeAndSync[2];
	    var lastIdealStyles = _mergeAndSync[3];
	    var lastIdealVelocities = _mergeAndSync[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  },
	
	  unmounting: false,
	  animationID: null,
	  prevTime: 0,
	  accumulatedTime: 0,
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	  unreadPropStyles: null,
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	  clearUnreadPropStyle: function clearUnreadPropStyle(unreadPropStyles) {
	    var _mergeAndSync2 = mergeAndSync(this.props.willEnter, this.props.willLeave, this.props.didLeave, this.state.mergedPropsStyles, unreadPropStyles, this.state.currentStyles, this.state.currentVelocities, this.state.lastIdealStyles, this.state.lastIdealVelocities);
	
	    var mergedPropsStyles = _mergeAndSync2[0];
	    var currentStyles = _mergeAndSync2[1];
	    var currentVelocities = _mergeAndSync2[2];
	    var lastIdealStyles = _mergeAndSync2[3];
	    var lastIdealVelocities = _mergeAndSync2[4];
	
	    for (var i = 0; i < unreadPropStyles.length; i++) {
	      var unreadPropStyle = unreadPropStyles[i].style;
	      var dirty = false;
	
	      for (var key in unreadPropStyle) {
	        if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	          continue;
	        }
	
	        var styleValue = unreadPropStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyles[i] = _extends({}, currentStyles[i]);
	            currentVelocities[i] = _extends({}, currentVelocities[i]);
	            lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	            lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            mergedPropsStyles[i] = {
	              key: mergedPropsStyles[i].key,
	              data: mergedPropsStyles[i].data,
	              style: _extends({}, mergedPropsStyles[i].style)
	            };
	          }
	          currentStyles[i][key] = styleValue;
	          currentVelocities[i][key] = 0;
	          lastIdealStyles[i][key] = styleValue;
	          lastIdealVelocities[i][key] = 0;
	          mergedPropsStyles[i].style[key] = styleValue;
	        }
	      }
	    }
	
	    // unlike the other 2 components, we can't detect staleness and optionally
	    // opt out of setState here. each style object's data might contain new
	    // stuff we're not/cannot compare
	    this.setState({
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      mergedPropsStyles: mergedPropsStyles,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities
	    });
	  },
	
	  startAnimationIfNecessary: function startAnimationIfNecessary() {
	    var _this = this;
	
	    if (this.unmounting) {
	      return;
	    }
	
	    // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	    // call cb? No, otherwise accidental parent rerender causes cb trigger
	    this.animationID = _raf2['default'](function (timestamp) {
	      // https://github.com/chenglou/react-motion/pull/420
	      // > if execution passes the conditional if (this.unmounting), then
	      // executes async defaultRaf and after that component unmounts and after
	      // that the callback of defaultRaf is called, then setState will be called
	      // on unmounted component.
	      if (_this.unmounting) {
	        return;
	      }
	
	      var propStyles = _this.props.styles;
	      var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	      // check if we need to animate in the first place
	      if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.accumulatedTime = 0;
	        return;
	      }
	
	      var currentTime = timestamp || _performanceNow2['default']();
	      var timeDelta = currentTime - _this.prevTime;
	      _this.prevTime = currentTime;
	      _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	      // more than 10 frames? prolly switched browser tab. Restart
	      if (_this.accumulatedTime > msPerFrame * 10) {
	        _this.accumulatedTime = 0;
	      }
	
	      if (_this.accumulatedTime === 0) {
	        // no need to cancel animationID here; shouldn't have any in flight
	        _this.animationID = null;
	        _this.startAnimationIfNecessary();
	        return;
	      }
	
	      var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	      var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	      var _mergeAndSync3 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var newMergedPropsStyles = _mergeAndSync3[0];
	      var newCurrentStyles = _mergeAndSync3[1];
	      var newCurrentVelocities = _mergeAndSync3[2];
	      var newLastIdealStyles = _mergeAndSync3[3];
	      var newLastIdealVelocities = _mergeAndSync3[4];
	
	      for (var i = 0; i < newMergedPropsStyles.length; i++) {
	        var newMergedPropsStyle = newMergedPropsStyles[i].style;
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	
	        for (var key in newMergedPropsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = newMergedPropsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = newLastIdealStyles[i][key];
	            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	            for (var j = 0; j < framesToCatchUp; j++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        newLastIdealStyles[i] = newLastIdealStyle;
	        newLastIdealVelocities[i] = newLastIdealVelocity;
	        newCurrentStyles[i] = newCurrentStyle;
	        newCurrentVelocities[i] = newCurrentVelocity;
	      }
	
	      _this.animationID = null;
	      // the amount we're looped over above
	      _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	      _this.setState({
	        currentStyles: newCurrentStyles,
	        currentVelocities: newCurrentVelocities,
	        lastIdealStyles: newLastIdealStyles,
	        lastIdealVelocities: newLastIdealVelocities,
	        mergedPropsStyles: newMergedPropsStyles
	      });
	
	      _this.unreadPropStyles = null;
	
	      _this.startAnimationIfNecessary();
	    });
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  },
	
	  componentWillReceiveProps: function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  },
	
	  render: function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  }
	});
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

/***/ },
/* 2760 */
/***/ function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ },
/* 2761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(2757);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(2758);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(2759);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(2763);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(1245);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(339);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(2762);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ },
/* 2762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 2763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(1245);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ },
/* 2764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(323);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _getContainer = __webpack_require__(340);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(197);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
	 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
	 * The children of `<Portal/>` component will be appended to the `container` specified.
	 */
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Portal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
	      if (!_this._overlayTarget) {
	        _this._overlayTarget = document.createElement('div');
	        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
	        _this._portalContainerNode.appendChild(_this._overlayTarget);
	      }
	    }, _this._unmountOverlayTarget = function () {
	      if (_this._overlayTarget) {
	        _this._portalContainerNode.removeChild(_this._overlayTarget);
	        _this._overlayTarget = null;
	      }
	      _this._portalContainerNode = null;
	    }, _this._renderOverlay = function () {
	      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);
	
	      // Save reference for future access.
	      if (overlay !== null) {
	        _this._mountOverlayTarget();
	
	        var initialRender = !_this._overlayInstance;
	
	        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
	          if (initialRender && _this.props.onRendered) {
	            _this.props.onRendered();
	          }
	        });
	      } else {
	        // Unrender if the component is null for transitions to null
	        _this._unrenderOverlay();
	        _this._unmountOverlayTarget();
	      }
	    }, _this._unrenderOverlay = function () {
	      if (_this._overlayTarget) {
	        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
	        _this._overlayInstance = null;
	      }
	    }, _this.getMountNode = function () {
	      return _this._overlayTarget;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Portal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._renderOverlay();
	  };
	
	  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this._overlayTarget && nextProps.container !== this.props.container) {
	      this._portalContainerNode.removeChild(this._overlayTarget);
	      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
	      this._portalContainerNode.appendChild(this._overlayTarget);
	    }
	  };
	
	  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	    this._unrenderOverlay();
	    this._unmountOverlayTarget();
	  };
	
	  Portal.prototype.render = function render() {
	    return null;
	  };
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.displayName = 'Portal';
	Portal.propTypes = {
	  /**
	   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
	   * appended to it.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  onRendered: _propTypes2.default.func
	};
	exports.default = Portal;
	module.exports = exports['default'];

/***/ },
/* 2765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _activeElement = __webpack_require__(903);
	
	var _activeElement2 = _interopRequireDefault(_activeElement);
	
	var _contains = __webpack_require__(183);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _inDOM = __webpack_require__(123);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(323);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _deprecated = __webpack_require__(2479);
	
	var _deprecated2 = _interopRequireDefault(_deprecated);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ModalManager = __webpack_require__(2766);
	
	var _ModalManager2 = _interopRequireDefault(_ModalManager);
	
	var _Portal = __webpack_require__(1246);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _RefHolder = __webpack_require__(2769);
	
	var _RefHolder2 = _interopRequireDefault(_RefHolder);
	
	var _addEventListener = __webpack_require__(1249);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _addFocusListener = __webpack_require__(2770);
	
	var _addFocusListener2 = _interopRequireDefault(_addFocusListener);
	
	var _getContainer = __webpack_require__(340);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(197);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */
	
	var modalManager = new _ModalManager2.default();
	
	/**
	 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
	 * The Modal component renders its `children` node in front of a backdrop component.
	 *
	 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
	 *
	 * - Manages dialog stacking when one-at-a-time just isn't enough.
	 * - Creates a backdrop, for disabling interaction below the modal.
	 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
	 * - It disables scrolling of the page content while open.
	 * - Adds the appropriate ARIA roles are automatically.
	 * - Easily pluggable animations via a `<Transition/>` component.
	 *
	 * Note that, in the same way the backdrop element prevents users from clicking or interacting
	 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
	 * interact with page content while the Modal is open. To do this, we use a common technique of applying
	 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
	 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
	 * React hierarchy (such as the default: document.body).
	 */
	
	var Modal = function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Modal.prototype.omitProps = function omitProps(props, propTypes) {
	
	    var keys = Object.keys(props);
	    var newProps = {};
	    keys.map(function (prop) {
	      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
	        newProps[prop] = props[prop];
	      }
	    });
	
	    return newProps;
	  };
	
	  Modal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        container = _props.container,
	        children = _props.children,
	        Transition = _props.transition,
	        backdrop = _props.backdrop,
	        dialogTransitionTimeout = _props.dialogTransitionTimeout,
	        className = _props.className,
	        style = _props.style,
	        onExit = _props.onExit,
	        onExiting = _props.onExiting,
	        onEnter = _props.onEnter,
	        onEntering = _props.onEntering,
	        onEntered = _props.onEntered;
	
	
	    var dialog = _react2.default.Children.only(children);
	    var filteredProps = this.omitProps(this.props, Modal.propTypes);
	
	    var mountModal = show || Transition && !this.state.exited;
	    if (!mountModal) {
	      return null;
	    }
	
	    var _dialog$props = dialog.props,
	        role = _dialog$props.role,
	        tabIndex = _dialog$props.tabIndex;
	
	
	    if (role === undefined || tabIndex === undefined) {
	      dialog = (0, _react.cloneElement)(dialog, {
	        role: role === undefined ? 'document' : role,
	        tabIndex: tabIndex == null ? '-1' : tabIndex
	      });
	    }
	
	    if (Transition) {
	      dialog = _react2.default.createElement(
	        Transition,
	        {
	          transitionAppear: true,
	          unmountOnExit: true,
	          'in': show,
	          timeout: dialogTransitionTimeout,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.handleHidden,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        dialog
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      {
	        ref: this.setMountNode,
	        container: container,
	        onRendered: this.onPortalRendered
	      },
	      _react2.default.createElement(
	        'div',
	        _extends({
	          ref: this.setModalNodeRef,
	          role: role || 'dialog'
	        }, filteredProps, {
	          style: style,
	          className: className
	        }),
	        backdrop && this.renderBackdrop(),
	        _react2.default.createElement(
	          _RefHolder2.default,
	          { ref: this.setDialogRef },
	          dialog
	        )
	      )
	    );
	  };
	
	  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    if (!this.props.show && nextProps.show) {
	      this.checkForFocus();
	    }
	  };
	
	  Modal.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    if (this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var transition = this.props.transition;
	
	
	    if (prevProps.show && !this.props.show && !transition) {
	      // Otherwise handleHidden will call this.
	      this.onHide();
	    } else if (!prevProps.show && this.props.show) {
	      this.onShow();
	    }
	  };
	
	  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props2 = this.props,
	        show = _props2.show,
	        transition = _props2.transition;
	
	
	    this._isMounted = false;
	
	    if (show || transition && !this.state.exited) {
	      this.onHide();
	    }
	  };
	
	  Modal.prototype.autoFocus = function autoFocus() {
	    if (!this.props.autoFocus) {
	      return;
	    }
	
	    var dialogElement = this.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      this.lastFocus = currentActiveElement;
	
	      if (!dialogElement.hasAttribute('tabIndex')) {
	        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');
	
	        dialogElement.setAttribute('tabIndex', -1);
	      }
	
	      dialogElement.focus();
	    }
	  };
	
	  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
	    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
	    if (this.lastFocus && this.lastFocus.focus) {
	      this.lastFocus.focus();
	      this.lastFocus = null;
	    }
	  };
	
	  Modal.prototype.getDialogElement = function getDialogElement() {
	    return _reactDom2.default.findDOMNode(this.dialog);
	  };
	
	  Modal.prototype.isTopModal = function isTopModal() {
	    return this.props.manager.isTopModal(this);
	  };
	
	  return Modal;
	}(_react2.default.Component);
	
	Modal.propTypes = _extends({}, _Portal2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Modal
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
	   *
	   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
	   * page content can be placed behind a virtual backdrop as well as a visual one.
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * A callback fired when the Modal is opening.
	   */
	  onShow: _propTypes2.default.func,
	
	  /**
	   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
	   *
	   * The `onHide` callback only signals intent from the Modal,
	   * you must actually set the `show` prop to `false` for the Modal to close.
	   */
	  onHide: _propTypes2.default.func,
	
	  /**
	   * Include a backdrop component.
	   */
	  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),
	
	  /**
	   * A function that returns a backdrop component. Useful for custom
	   * backdrop rendering.
	   *
	   * ```js
	   *  renderBackdrop={props => <MyBackdrop {...props} />}
	   * ```
	   */
	  renderBackdrop: _propTypes2.default.func,
	
	  /**
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   */
	  onEscapeKeyDown: _propTypes2.default.func,
	
	  /**
	   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
	   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
	   * @deprecated
	   */
	  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),
	
	  /**
	   * A callback fired when the backdrop, if specified, is clicked.
	   */
	  onBackdropClick: _propTypes2.default.func,
	
	  /**
	   * A style object for the backdrop component.
	   */
	  backdropStyle: _propTypes2.default.object,
	
	  /**
	   * A css class or classes for the backdrop component.
	   */
	  backdropClassName: _propTypes2.default.string,
	
	  /**
	   * A css class or set of classes applied to the modal container when the modal is open,
	   * and removed when it is closed.
	   */
	  containerClassName: _propTypes2.default.string,
	
	  /**
	   * Close the modal when escape key is pressed
	   */
	  keyboard: _propTypes2.default.bool,
	
	  /**
	   * A `<Transition/>` component to use for the dialog and backdrop components.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * The `timeout` of the dialog transition if specified. This number is used to ensure that
	   * transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  dialogTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * The `timeout` of the backdrop transition if specified. This number is used to
	   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
	   *
	   * See the Transition `timeout` prop for more infomation.
	   */
	  backdropTransitionTimeout: _propTypes2.default.number,
	
	  /**
	   * When `true` The modal will automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes. This also
	   * works correctly with any Modal children that have the `autoFocus` prop.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  autoFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will prevent focus from leaving the Modal while open.
	   *
	   * Generally this should never be set to `false` as it makes the Modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  enforceFocus: _propTypes2.default.bool,
	
	  /**
	   * When `true` The modal will restore focus to previously focused element once
	   * modal is hidden
	   */
	  restoreFocus: _propTypes2.default.bool,
	
	  /**
	   * Callback fired before the Modal transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Modal transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Modal begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Modal finishes transitioning out
	   */
	  onExited: _propTypes2.default.func,
	
	  /**
	   * A ModalManager instance used to track and manage the state of open
	   * Modals. Useful when customizing how modals interact within a container
	   */
	  manager: _propTypes2.default.object.isRequired
	});
	Modal.defaultProps = {
	  show: false,
	  backdrop: true,
	  keyboard: true,
	  autoFocus: true,
	  enforceFocus: true,
	  restoreFocus: true,
	  onHide: function onHide() {},
	  manager: modalManager,
	  renderBackdrop: function renderBackdrop(props) {
	    return _react2.default.createElement('div', props);
	  }
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.state = { exited: !this.props.show };
	
	  this.renderBackdrop = function () {
	    var _props3 = _this2.props,
	        backdropStyle = _props3.backdropStyle,
	        backdropClassName = _props3.backdropClassName,
	        renderBackdrop = _props3.renderBackdrop,
	        Transition = _props3.transition,
	        backdropTransitionTimeout = _props3.backdropTransitionTimeout;
	
	
	    var backdropRef = function backdropRef(ref) {
	      return _this2.backdrop = ref;
	    };
	
	    var backdrop = renderBackdrop({
	      ref: backdropRef,
	      style: backdropStyle,
	      className: backdropClassName,
	      onClick: _this2.handleBackdropClick
	    });
	
	    if (Transition) {
	      backdrop = _react2.default.createElement(
	        Transition,
	        { transitionAppear: true,
	          'in': _this2.props.show,
	          timeout: backdropTransitionTimeout
	        },
	        backdrop
	      );
	    }
	
	    return backdrop;
	  };
	
	  this.onPortalRendered = function () {
	    _this2.autoFocus();
	
	    if (_this2.props.onShow) {
	      _this2.props.onShow();
	    }
	  };
	
	  this.onShow = function () {
	    var doc = (0, _ownerDocument2.default)(_this2);
	    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);
	
	    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);
	
	    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);
	
	    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);
	
	    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
	  };
	
	  this.onHide = function () {
	    _this2.props.manager.remove(_this2);
	
	    _this2._onDocumentKeydownListener.remove();
	
	    _this2._onDocumentKeyupListener.remove();
	
	    _this2._onFocusinListener.remove();
	
	    if (_this2.props.restoreFocus) {
	      _this2.restoreLastFocus();
	    }
	  };
	
	  this.setMountNode = function (ref) {
	    _this2.mountNode = ref ? ref.getMountNode() : ref;
	  };
	
	  this.setModalNodeRef = function (ref) {
	    _this2.modalNode = ref;
	  };
	
	  this.setDialogRef = function (ref) {
	    _this2.dialog = ref;
	  };
	
	  this.handleHidden = function () {
	    _this2.setState({ exited: true });
	    _this2.onHide();
	
	    if (_this2.props.onExited) {
	      var _props4;
	
	      (_props4 = _this2.props).onExited.apply(_props4, arguments);
	    }
	  };
	
	  this.handleBackdropClick = function (e) {
	    if (e.target !== e.currentTarget) {
	      return;
	    }
	
	    if (_this2.props.onBackdropClick) {
	      _this2.props.onBackdropClick(e);
	    }
	
	    if (_this2.props.backdrop === true) {
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyDown = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyDown) {
	        _this2.props.onEscapeKeyDown(e);
	      }
	
	      _this2.props.onHide();
	    }
	  };
	
	  this.handleDocumentKeyUp = function (e) {
	    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
	      if (_this2.props.onEscapeKeyUp) {
	        _this2.props.onEscapeKeyUp(e);
	      }
	    }
	  };
	
	  this.checkForFocus = function () {
	    if (_inDOM2.default) {
	      _this2.lastFocus = (0, _activeElement2.default)();
	    }
	  };
	
	  this.enforceFocus = function () {
	    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
	      return;
	    }
	
	    var dialogElement = _this2.getDialogElement();
	    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));
	
	    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
	      dialogElement.focus();
	    }
	  };
	};
	
	Modal.Manager = _ModalManager2.default;
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ },
/* 2766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class = __webpack_require__(1894);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _style = __webpack_require__(294);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _scrollbarSize = __webpack_require__(909);
	
	var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);
	
	var _isOverflowing = __webpack_require__(1250);
	
	var _isOverflowing2 = _interopRequireDefault(_isOverflowing);
	
	var _manageAriaHidden = __webpack_require__(2772);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function findIndexOf(arr, cb) {
	  var idx = -1;
	  arr.some(function (d, i) {
	    if (cb(d, i)) {
	      idx = i;
	      return true;
	    }
	  });
	  return idx;
	}
	
	function findContainer(data, modal) {
	  return findIndexOf(data, function (d) {
	    return d.modals.indexOf(modal) !== -1;
	  });
	}
	
	function setContainerStyle(state, container) {
	  var style = { overflow: 'hidden' };
	
	  // we are only interested in the actual `style` here
	  // becasue we will override it
	  state.style = {
	    overflow: container.style.overflow,
	    paddingRight: container.style.paddingRight
	  };
	
	  if (state.overflowing) {
	    // use computed style, here to get the real padding
	    // to add our scrollbar width
	    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
	  }
	
	  (0, _style2.default)(container, style);
	}
	
	function removeContainerStyle(_ref, container) {
	  var style = _ref.style;
	
	
	  Object.keys(style).forEach(function (key) {
	    return container.style[key] = style[key];
	  });
	}
	/**
	 * Proper state managment for containers and the modals in those containers.
	 *
	 * @internal Used by the Modal to ensure proper styling of containers.
	 */
	
	var ModalManager = function ModalManager() {
	  var _this = this;
	
	  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
	      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
	      _ref2$handleContainer = _ref2.handleContainerOverflow,
	      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;
	
	  _classCallCheck(this, ModalManager);
	
	  this.add = function (modal, container, className) {
	    var modalIdx = _this.modals.indexOf(modal);
	    var containerIdx = _this.containers.indexOf(container);
	
	    if (modalIdx !== -1) {
	      return modalIdx;
	    }
	
	    modalIdx = _this.modals.length;
	    _this.modals.push(modal);
	
	    if (_this.hideSiblingNodes) {
	      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
	    }
	
	    if (containerIdx !== -1) {
	      _this.data[containerIdx].modals.push(modal);
	      return modalIdx;
	    }
	
	    var data = {
	      modals: [modal],
	      //right now only the first modal of a container will have its classes applied
	      classes: className ? className.split(/\s+/) : [],
	
	      overflowing: (0, _isOverflowing2.default)(container)
	    };
	
	    if (_this.handleContainerOverflow) {
	      setContainerStyle(data, container);
	    }
	
	    data.classes.forEach(_class2.default.addClass.bind(null, container));
	
	    _this.containers.push(container);
	    _this.data.push(data);
	
	    return modalIdx;
	  };
	
	  this.remove = function (modal) {
	    var modalIdx = _this.modals.indexOf(modal);
	
	    if (modalIdx === -1) {
	      return;
	    }
	
	    var containerIdx = findContainer(_this.data, modal);
	    var data = _this.data[containerIdx];
	    var container = _this.containers[containerIdx];
	
	    data.modals.splice(data.modals.indexOf(modal), 1);
	
	    _this.modals.splice(modalIdx, 1);
	
	    // if that was the last modal in a container,
	    // clean up the container
	    if (data.modals.length === 0) {
	      data.classes.forEach(_class2.default.removeClass.bind(null, container));
	
	      if (_this.handleContainerOverflow) {
	        removeContainerStyle(data, container);
	      }
	
	      if (_this.hideSiblingNodes) {
	        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
	      }
	      _this.containers.splice(containerIdx, 1);
	      _this.data.splice(containerIdx, 1);
	    } else if (_this.hideSiblingNodes) {
	      //otherwise make sure the next top modal is visible to a SR
	      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
	    }
	  };
	
	  this.isTopModal = function (modal) {
	    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
	  };
	
	  this.hideSiblingNodes = hideSiblingNodes;
	  this.handleContainerOverflow = handleContainerOverflow;
	  this.modals = [];
	  this.containers = [];
	  this.data = [];
	};
	
	exports.default = ModalManager;
	module.exports = exports['default'];

/***/ },
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _elementType = __webpack_require__(30);
	
	var _elementType2 = _interopRequireDefault(_elementType);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Portal = __webpack_require__(1246);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _Position = __webpack_require__(2768);
	
	var _Position2 = _interopRequireDefault(_Position);
	
	var _RootCloseWrapper = __webpack_require__(1247);
	
	var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
	 */
	var Overlay = function (_React$Component) {
	  _inherits(Overlay, _React$Component);
	
	  function Overlay(props, context) {
	    _classCallCheck(this, Overlay);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleHidden = function () {
	      _this.setState({ exited: true });
	
	      if (_this.props.onExited) {
	        var _this$props;
	
	        (_this$props = _this.props).onExited.apply(_this$props, arguments);
	      }
	    };
	
	    _this.state = { exited: !props.show };
	    _this.onHiddenListener = _this.handleHidden.bind(_this);
	    return _this;
	  }
	
	  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.show) {
	      this.setState({ exited: false });
	    } else if (!nextProps.transition) {
	      // Otherwise let handleHidden take care of marking exited.
	      this.setState({ exited: true });
	    }
	  };
	
	  Overlay.prototype.render = function render() {
	    var _props = this.props,
	        container = _props.container,
	        containerPadding = _props.containerPadding,
	        target = _props.target,
	        placement = _props.placement,
	        shouldUpdatePosition = _props.shouldUpdatePosition,
	        rootClose = _props.rootClose,
	        children = _props.children,
	        Transition = _props.transition,
	        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);
	
	    // Don't un-render the overlay while it's transitioning out.
	
	
	    var mountOverlay = props.show || Transition && !this.state.exited;
	    if (!mountOverlay) {
	      // Don't bother showing anything if we don't have to.
	      return null;
	    }
	
	    var child = children;
	
	    // Position is be inner-most because it adds inline styles into the child,
	    // which the other wrappers don't forward correctly.
	    child = _react2.default.createElement(
	      _Position2.default,
	      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
	      child
	    );
	
	    if (Transition) {
	      var onExit = props.onExit,
	          onExiting = props.onExiting,
	          onEnter = props.onEnter,
	          onEntering = props.onEntering,
	          onEntered = props.onEntered;
	
	      // This animates the child node by injecting props, so it must precede
	      // anything that adds a wrapping div.
	
	      child = _react2.default.createElement(
	        Transition,
	        {
	          'in': props.show,
	          transitionAppear: true,
	          onExit: onExit,
	          onExiting: onExiting,
	          onExited: this.onHiddenListener,
	          onEnter: onEnter,
	          onEntering: onEntering,
	          onEntered: onEntered
	        },
	        child
	      );
	    }
	
	    // This goes after everything else because it adds a wrapping div.
	    if (rootClose) {
	      child = _react2.default.createElement(
	        _RootCloseWrapper2.default,
	        { onRootClose: props.onHide },
	        child
	      );
	    }
	
	    return _react2.default.createElement(
	      _Portal2.default,
	      { container: container },
	      child
	    );
	  };
	
	  return Overlay;
	}(_react2.default.Component);
	
	Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {
	
	  /**
	   * Set the visibility of the Overlay
	   */
	  show: _propTypes2.default.bool,
	
	  /**
	   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
	   */
	  rootClose: _propTypes2.default.bool,
	
	  /**
	   * A Callback fired by the Overlay when it wishes to be hidden.
	   *
	   * __required__ when `rootClose` is `true`.
	   *
	   * @type func
	   */
	  onHide: function onHide(props) {
	    var propType = _propTypes2.default.func;
	    if (props.rootClose) {
	      propType = propType.isRequired;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return propType.apply(undefined, [props].concat(args));
	  },
	
	
	  /**
	   * A `<Transition/>` component used to animate the overlay changes visibility.
	   */
	  transition: _elementType2.default,
	
	  /**
	   * Callback fired before the Overlay transitions in
	   */
	  onEnter: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition in
	   */
	  onEntering: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning in
	   */
	  onEntered: _propTypes2.default.func,
	
	  /**
	   * Callback fired right before the Overlay transitions out
	   */
	  onExit: _propTypes2.default.func,
	
	  /**
	   * Callback fired as the Overlay begins to transition out
	   */
	  onExiting: _propTypes2.default.func,
	
	  /**
	   * Callback fired after the Overlay finishes transitioning out
	   */
	  onExited: _propTypes2.default.func
	});
	
	exports.default = Overlay;
	module.exports = exports['default'];

/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _componentOrElement = __webpack_require__(323);
	
	var _componentOrElement2 = _interopRequireDefault(_componentOrElement);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _calculatePosition = __webpack_require__(2771);
	
	var _calculatePosition2 = _interopRequireDefault(_calculatePosition);
	
	var _getContainer = __webpack_require__(340);
	
	var _getContainer2 = _interopRequireDefault(_getContainer);
	
	var _ownerDocument = __webpack_require__(197);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The Position component calculates the coordinates for its child, to position
	 * it relative to a `target` component or node. Useful for creating callouts
	 * and tooltips, the Position component injects a `style` props with `left` and
	 * `top` values for positioning your component.
	 *
	 * It also injects "arrow" `left`, and `top` values for styling callout arrows
	 * for giving your components a sense of directionality.
	 */
	var Position = function (_React$Component) {
	  _inherits(Position, _React$Component);
	
	  function Position(props, context) {
	    _classCallCheck(this, Position);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.getTarget = function () {
	      var target = _this.props.target;
	
	      var targetElement = typeof target === 'function' ? target() : target;
	      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
	    };
	
	    _this.maybeUpdatePosition = function (placementChanged) {
	      var target = _this.getTarget();
	
	      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
	        return;
	      }
	
	      _this.updatePosition(target);
	    };
	
	    _this.state = {
	      positionLeft: 0,
	      positionTop: 0,
	      arrowOffsetLeft: null,
	      arrowOffsetTop: null
	    };
	
	    _this._needsFlush = false;
	    _this._lastTarget = null;
	    return _this;
	  }
	
	  Position.prototype.componentDidMount = function componentDidMount() {
	    this.updatePosition(this.getTarget());
	  };
	
	  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
	    this._needsFlush = true;
	  };
	
	  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this._needsFlush) {
	      this._needsFlush = false;
	      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
	    }
	  };
	
	  Position.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        className = _props.className,
	        props = _objectWithoutProperties(_props, ['children', 'className']);
	
	    var _state = this.state,
	        positionLeft = _state.positionLeft,
	        positionTop = _state.positionTop,
	        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);
	
	    // These should not be forwarded to the child.
	
	
	    delete props.target;
	    delete props.container;
	    delete props.containerPadding;
	    delete props.shouldUpdatePosition;
	
	    var child = _react2.default.Children.only(children);
	    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
	      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
	      // and `props.style`.
	      positionLeft: positionLeft,
	      positionTop: positionTop,
	      className: (0, _classnames2.default)(className, child.props.className),
	      style: _extends({}, child.props.style, {
	        left: positionLeft,
	        top: positionTop
	      })
	    }));
	  };
	
	  Position.prototype.updatePosition = function updatePosition(target) {
	    this._lastTarget = target;
	
	    if (!target) {
	      this.setState({
	        positionLeft: 0,
	        positionTop: 0,
	        arrowOffsetLeft: null,
	        arrowOffsetTop: null
	      });
	
	      return;
	    }
	
	    var overlay = _reactDom2.default.findDOMNode(this);
	    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);
	
	    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
	  };
	
	  return Position;
	}(_react2.default.Component);
	
	Position.propTypes = {
	  /**
	   * A node, element, or function that returns either. The child will be
	   * be positioned next to the `target` specified.
	   */
	  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	
	  /**
	   * "offsetParent" of the component
	   */
	  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
	  /**
	   * Minimum spacing in pixels between container border and component border
	   */
	  containerPadding: _propTypes2.default.number,
	  /**
	   * How to position the component relative to the target
	   */
	  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
	  /**
	   * Whether the position should be changed on each update
	   */
	  shouldUpdatePosition: _propTypes2.default.bool
	};
	
	Position.displayName = 'Position';
	
	Position.defaultProps = {
	  containerPadding: 0,
	  placement: 'right',
	  shouldUpdatePosition: false
	};
	
	exports.default = Position;
	module.exports = exports['default'];

/***/ },
/* 2769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  children: _propTypes2.default.node
	};
	
	/**
	 * Internal helper component to allow attaching a non-conflicting ref to a
	 * child element that may not accept refs.
	 */
	
	var RefHolder = function (_React$Component) {
	  _inherits(RefHolder, _React$Component);
	
	  function RefHolder() {
	    _classCallCheck(this, RefHolder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  RefHolder.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return RefHolder;
	}(_react2.default.Component);
	
	RefHolder.propTypes = propTypes;
	
	exports.default = RefHolder;
	module.exports = exports['default'];

/***/ },
/* 2770 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = addFocusListener;
	/**
	 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
	 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
	 *
	 * We only allow one Listener at a time to avoid stack overflows
	 */
	function addFocusListener(handler) {
	  var useFocusin = !document.addEventListener;
	  var remove = void 0;
	
	  if (useFocusin) {
	    document.attachEvent('onfocusin', handler);
	    remove = function remove() {
	      return document.detachEvent('onfocusin', handler);
	    };
	  } else {
	    document.addEventListener('focus', handler, true);
	    remove = function remove() {
	      return document.removeEventListener('focus', handler, true);
	    };
	  }
	
	  return { remove: remove };
	}
	module.exports = exports['default'];

/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = calculatePosition;
	
	var _offset = __webpack_require__(905);
	
	var _offset2 = _interopRequireDefault(_offset);
	
	var _position = __webpack_require__(1900);
	
	var _position2 = _interopRequireDefault(_position);
	
	var _scrollTop = __webpack_require__(906);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _ownerDocument = __webpack_require__(197);
	
	var _ownerDocument2 = _interopRequireDefault(_ownerDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getContainerDimensions(containerNode) {
	  var width = void 0,
	      height = void 0,
	      scroll = void 0;
	
	  if (containerNode.tagName === 'BODY') {
	    width = window.innerWidth;
	    height = window.innerHeight;
	
	    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
	  } else {
	    var _getOffset = (0, _offset2.default)(containerNode);
	
	    width = _getOffset.width;
	    height = _getOffset.height;
	
	    scroll = (0, _scrollTop2.default)(containerNode);
	  }
	
	  return { width: width, height: height, scroll: scroll };
	}
	
	function getTopDelta(top, overlayHeight, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerScroll = containerDimensions.scroll;
	  var containerHeight = containerDimensions.height;
	
	  var topEdgeOffset = top - padding - containerScroll;
	  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;
	
	  if (topEdgeOffset < 0) {
	    return -topEdgeOffset;
	  } else if (bottomEdgeOffset > containerHeight) {
	    return containerHeight - bottomEdgeOffset;
	  } else {
	    return 0;
	  }
	}
	
	function getLeftDelta(left, overlayWidth, container, padding) {
	  var containerDimensions = getContainerDimensions(container);
	  var containerWidth = containerDimensions.width;
	
	  var leftEdgeOffset = left - padding;
	  var rightEdgeOffset = left + padding + overlayWidth;
	
	  if (leftEdgeOffset < 0) {
	    return -leftEdgeOffset;
	  } else if (rightEdgeOffset > containerWidth) {
	    return containerWidth - rightEdgeOffset;
	  }
	
	  return 0;
	}
	
	function calculatePosition(placement, overlayNode, target, container, padding) {
	  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);
	
	  var _getOffset2 = (0, _offset2.default)(overlayNode),
	      overlayHeight = _getOffset2.height,
	      overlayWidth = _getOffset2.width;
	
	  var positionLeft = void 0,
	      positionTop = void 0,
	      arrowOffsetLeft = void 0,
	      arrowOffsetTop = void 0;
	
	  if (placement === 'left' || placement === 'right') {
	    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;
	
	    if (placement === 'left') {
	      positionLeft = childOffset.left - overlayWidth;
	    } else {
	      positionLeft = childOffset.left + childOffset.width;
	    }
	
	    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);
	
	    positionTop += topDelta;
	    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
	    arrowOffsetLeft = void 0;
	  } else if (placement === 'top' || placement === 'bottom') {
	    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;
	
	    if (placement === 'top') {
	      positionTop = childOffset.top - overlayHeight;
	    } else {
	      positionTop = childOffset.top + childOffset.height;
	    }
	
	    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);
	
	    positionLeft += leftDelta;
	    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
	    arrowOffsetTop = void 0;
	  } else {
	    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
	  }
	
	  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
	}
	module.exports = exports['default'];

/***/ },
/* 2772 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.ariaHidden = ariaHidden;
	exports.hideSiblings = hideSiblings;
	exports.showSiblings = showSiblings;
	
	var BLACKLIST = ['template', 'script', 'style'];
	
	var isHidable = function isHidable(_ref) {
	  var nodeType = _ref.nodeType,
	      tagName = _ref.tagName;
	  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
	};
	
	var siblings = function siblings(container, mount, cb) {
	  mount = [].concat(mount);
	
	  [].forEach.call(container.children, function (node) {
	    if (mount.indexOf(node) === -1 && isHidable(node)) {
	      cb(node);
	    }
	  });
	};
	
	function ariaHidden(show, node) {
	  if (!node) {
	    return;
	  }
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function hideSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(true, node);
	  });
	}
	
	function showSiblings(container, mountNode) {
	  siblings(container, mountNode, function (node) {
	    return ariaHidden(false, node);
	  });
	}

/***/ },
/* 2773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountrySelectNative = (_temp2 = _class = function (_Component) {
		_inherits(CountrySelectNative, _Component);
	
		function CountrySelectNative() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, CountrySelectNative);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelectNative.__proto__ || Object.getPrototypeOf(CountrySelectNative)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event) {
				var onChange = _this.props.onChange;
	
				onChange(event.target.value);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		// storeSelectRef = (ref) => this.select = ref
		// ref={ this.storeSelectRef }
	
		_createClass(CountrySelectNative, [{
			key: 'render',
			value: function render() {
				var _props = this.props,
				    name = _props.name,
				    value = _props.value,
				    options = _props.options,
				    disabled = _props.disabled,
				    tabIndex = _props.tabIndex,
				    className = _props.className,
				    SelectArrow = _props.selectArrowComponent;
	
	
				var selectedOption = options.filter(function (option) {
					return option.value === value;
				})[0] || options[0];
				var SelectedCountryFlag = selectedOption.icon;
	
				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)(className, 'react-phone-number-input__country--native') },
					_react2.default.createElement(SelectedCountryFlag, null),
					_react2.default.createElement(
						'select',
						{
							name: name,
							value: value,
							onChange: this.onChange,
							disabled: disabled,
							tabIndex: tabIndex,
							className: 'react-phone-number-input__country-select' },
						options.map(function (_ref2) {
							var value = _ref2.value,
							    label = _ref2.label;
							return _react2.default.createElement(
								'option',
								{ key: value || '-', value: value },
								label
							);
						})
					),
					_react2.default.createElement(SelectArrow, null)
				);
			}
	
			// toggle()
			// {
			// 	this.select.click()
			// }
	
		}]);
	
		return CountrySelectNative;
	}(_react.Component), _class.propTypes = {
		selectArrowComponent: _propTypes2.default.func.isRequired
	}, _class.defaultProps = {
		selectArrowComponent: function selectArrowComponent() {
			return _react2.default.createElement('div', { className: 'react-phone-number-input__country-select-arrow' });
		} }, _temp2);
	exports.default = CountrySelectNative;
	//# sourceMappingURL=CountrySelectNative.js.map

/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	// Could have been `import { Select } from 'react-responsive-ui'`
	// but in that case Webpack bundles the whole `react-responsive-ui` package.
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Select = __webpack_require__(2837);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CountrySelectReactResponsiveUI = (_temp2 = _class = function (_Component) {
		_inherits(CountrySelectReactResponsiveUI, _Component);
	
		function CountrySelectReactResponsiveUI() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, CountrySelectReactResponsiveUI);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountrySelectReactResponsiveUI.__proto__ || Object.getPrototypeOf(CountrySelectReactResponsiveUI)).call.apply(_ref, [this].concat(args))), _this), _this.onTabOut = function (event) {
				var focusPhoneInputField = _this.props.focusPhoneInputField;
	
	
				event.preventDefault();
	
				// Focus the phone number input upon country selection
				// (do it in a timeout because the `<input/>`
				//  is hidden while selecting a country)
				setTimeout(focusPhoneInputField, 0);
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(CountrySelectReactResponsiveUI, [{
			key: 'render',
	
	
			// storeSelectRef = (ref) => this.select = ref
			// ref={ this.storeSelectRef }
	
			// toggle()
			// {
			// 	this.select.toggle()
			// }
			value: function render() {
				var _props = this.props,
				    name = _props.name,
				    value = _props.value,
				    onChange = _props.onChange,
				    options = _props.options,
				    disabled = _props.disabled,
				    tabIndex = _props.tabIndex,
				    className = _props.className,
				    hidePhoneInputField = _props.hidePhoneInputField,
				    ariaLabel = _props.ariaLabel,
				    closeAriaLabel = _props.closeAriaLabel,
				    saveOnIcons = _props.saveOnIcons,
				    nativeExpanded = _props.nativeExpanded,
				    maxItems = _props.maxItems,
				    inputClassName = _props.inputClassName,
				    toggleClassName = _props.toggleClassName;
	
	
				return _react2.default.createElement(_Select2.default, {
					name: name,
					value: value,
					onChange: onChange,
					options: options,
					disabled: disabled,
					tabIndex: tabIndex,
					className: (0, _classnames2.default)(className, {
						'react-phone-number-input__country--native-expanded': nativeExpanded
					}),
					onToggle: hidePhoneInputField,
					onTabOut: this.onTabOut,
					ariaLabel: ariaLabel,
					closeAriaLabel: closeAriaLabel,
					saveOnIcons: saveOnIcons,
					nativeExpanded: nativeExpanded,
					maxItems: maxItems,
					inputClassName: inputClassName,
					toggleClassName: toggleClassName,
					focusUponSelection: false,
					concise: true,
					autocomplete: true,
					autocompleteShowAll: true });
			}
	
			// Focuses phone number `<input/>` field
			// on tab out of the country `<select/>`.
	
		}]);
	
		return CountrySelectReactResponsiveUI;
	}(_react.Component), _class.defaultProps = {
		// Whether to use native country `<select/>` when it's expanded.
		// Deprecated. Use `<PhoneInputNative/>` instead.
		nativeExpanded: false,
	
		// If set to `false`, then country flags will be shown
		// for all countries when country `<select/>` is expanded.
		// By default shows flag only for currently selected country.
		// (is `true` by default to save user's traffic
		//  because all flags are about 3 MegaBytes)
		saveOnIcons: true }, _temp2);
	exports.default = CountrySelectReactResponsiveUI;
	//# sourceMappingURL=CountrySelectReactResponsiveUI.js.map

/***/ },
/* 2775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Default country flag icon.
	// `<img/>` is wrapped in a `<div/>` to prevent SVGs from exploding in size.
	// https://github.com/catamphetamine/react-phone-number-input/issues/111
	var FlagComponent = function FlagComponent(_ref) {
		var country = _ref.country,
		    flags = _ref.flags,
		    flagsPath = _ref.flagsPath,
		    className = _ref.className;
	
		if (flags && flags[country]) {
			return _react2.default.cloneElement(flags[country](), {
				className: (0, _classnames2.default)('react-phone-number-input__icon', className)
			});
		}
	
		return _react2.default.createElement(
			'div',
			{ className: (0, _classnames2.default)('react-phone-number-input__icon', className) },
			_react2.default.createElement('img', {
				alt: country,
				className: 'react-phone-number-input__icon-image',
				src: '' + flagsPath + country.toLowerCase() + '.svg' })
		);
	};
	
	FlagComponent.propTypes = {
		// The country to be selected by default.
		// Two-letter country code ("ISO 3166-1 alpha-2").
		country: _propTypes2.default.string.isRequired,
	
		// Country flag icon components.
		// By default flag icons are inserted as `<img/>`s
		// with their `src` pointed to `flag-icon-css` github repo.
		// There might be cases (e.g. an offline application)
		// where having a large (3 megabyte) `<svg/>` flags
		// bundle is more appropriate.
		// `import flags from 'react-phone-number-input/flags'`.
		flags: _propTypes2.default.objectOf(_propTypes2.default.func),
	
		// A base URL path for national flag SVG icons.
		// By default it uses the ones from `flag-icon-css` github repo.
		flagsPath: _propTypes2.default.string.isRequired
	};
	
	exports.default = FlagComponent;
	//# sourceMappingURL=Flag.js.map

/***/ },
/* 2776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class;
	
	// Both these functions are exported from `react-phone-number-input`.
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(494);
	
	var _parsePhoneNumberCharacters = __webpack_require__(1255);
	
	var _parsePhoneNumberCharacters2 = _interopRequireDefault(_parsePhoneNumberCharacters);
	
	var _formatPhoneNumber = __webpack_require__(1254);
	
	var _formatPhoneNumber2 = _interopRequireDefault(_formatPhoneNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * `InputBasic`'s caret is not as "smart" as the default `inputComponent`'s
	 * but still works good enough. When erasing or inserting digits in the middle
	 * of a phone number the caret usually jumps to the end: this is the expected
	 * behaviour and it's the workaround for the [Samsung Galaxy smart caret positioning bug](https://github.com/catamphetamine/react-phone-number-input/issues/75).
	 */
	var InputBasic = (0, _reactLifecyclesCompat.polyfill)(_class = function (_PureComponent) {
		_inherits(InputBasic, _PureComponent);
	
		function InputBasic() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, InputBasic);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputBasic.__proto__ || Object.getPrototypeOf(InputBasic)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.onChange = function (event) {
				var onChange = _this.props.onChange;
				var value = _this.state.value;
	
	
				var newValue = (0, _parsePhoneNumberCharacters2.default)(event.target.value);
	
				// By default, if a value is something like `"(123)"`
				// then Backspace would only erase the rightmost brace
				// becoming something like `"(123"`
				// which would give the same `"123"` value
				// which would then be formatted back to `"(123)"`
				// and so a user wouldn't be able to erase the phone number.
				// Working around this issue with this simple hack.
				if (newValue === value) {
					if (_this.format(newValue).indexOf(event.target.value) === 0) {
						// Trim the last digit (or plus sign).
						newValue = newValue.slice(0, -1);
					}
				}
	
				// Prevents React from resetting the `<input/>` caret position.
				// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
				// https://github.com/facebook/react/issues/955
				_this.setState({ value: newValue }, function () {
					return onChange(newValue);
				});
			}, _this.storeInput = function (ref) {
				return _this.input = ref;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(InputBasic, [{
			key: 'format',
			value: function format(value) {
				var _props = this.props,
				    country = _props.country,
				    metadata = _props.metadata;
	
	
				return (0, _formatPhoneNumber2.default)(value, country, metadata).text;
			}
		}, {
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _props2 = this.props,
				    onChange = _props2.onChange,
				    country = _props2.country,
				    metadata = _props2.metadata,
				    rest = _objectWithoutProperties(_props2, ['onChange', 'country', 'metadata']);
	
				// Prevents React from resetting the `<input/>` caret position.
				// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
				// https://github.com/facebook/react/issues/955
	
	
				var value = this.state.value;
	
	
				return _react2.default.createElement('input', _extends({}, rest, {
					ref: this.storeInput,
					value: this.format(value),
					onChange: this.onChange }));
			}
		}], [{
			key: 'getDerivedStateFromProps',
	
			// Prevents React from resetting the `<input/>` caret position.
			// https://github.com/reactjs/react-redux/issues/525#issuecomment-254852039
			// https://github.com/facebook/react/issues/955
			value: function getDerivedStateFromProps(_ref2) {
				var value = _ref2.value;
	
				return { value: value };
			}
		}]);
	
		return InputBasic;
	}(_react.PureComponent)) || _class;
	
	exports.default = InputBasic;
	//# sourceMappingURL=InputBasic.js.map

/***/ },
/* 2777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _inputFormat = __webpack_require__(954);
	
	var _parsePhoneNumberCharacters = __webpack_require__(1255);
	
	var _formatPhoneNumber = __webpack_require__(1254);
	
	var _formatPhoneNumber2 = _interopRequireDefault(_formatPhoneNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Both these functions are exported from `react-phone-number-input`.
	
	
	/**
	 * This input uses `input-format` library
	 * for "smart" caret positioning.
	 */
	var InputSmart = function (_Component) {
		_inherits(InputSmart, _Component);
	
		function InputSmart() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, InputSmart);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputSmart.__proto__ || Object.getPrototypeOf(InputSmart)).call.apply(_ref, [this].concat(args))), _this), _this.storeInput = function (ref) {
				return _this.input = ref;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(InputSmart, [{
			key: 'focus',
			value: function focus() {
				this.input.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    country = _props.country,
				    metadata = _props.metadata,
				    rest = _objectWithoutProperties(_props, ['country', 'metadata']);
	
				return _react2.default.createElement(_inputFormat.ReactInput, _extends({}, rest, {
					ref: this.storeInput,
					parse: _parsePhoneNumberCharacters.parsePhoneNumberCharacter,
					format: function format(value) {
						return (0, _formatPhoneNumber2.default)(value, country, metadata);
					} }));
			}
		}]);
	
		return InputSmart;
	}(_react.Component);
	
	exports.default = InputSmart;
	//# sourceMappingURL=InputSmart.js.map

/***/ },
/* 2778 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = InternationalIcon;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function InternationalIcon() {
		return _react2.default.createElement(
			"svg",
			{ version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink",
				viewBox: "0 0 356.926 356.926" },
			_react2.default.createElement(
				"g",
				null,
				_react2.default.createElement(
					"g",
					null,
					_react2.default.createElement("path", { d: "M211.89,213.669c0-10.475-8.521-18.997-18.996-18.997c-0.401,0-0.799,0.017-1.193,0.041v2.406\r c0.396-0.028,0.79-0.061,1.193-0.061c9.158,0,16.608,7.452,16.608,16.611s-7.45,16.61-16.608,16.61\r c-0.269,0-0.53-0.027-0.795-0.041v0.897v1.509v4.723H186.2v3.182h13.388v-3.182h-5.104v-4.774\r C204.218,231.781,211.89,223.607,211.89,213.669z" }),
					_react2.default.createElement(
						"g",
						null,
						_react2.default.createElement("polygon", { points: "260.072,79.408 260.398,82.045 256.447,82.882 255.913,88.517 260.677,88.517 266.998,87.913 270.251,84.021\r 266.788,82.678 264.883,80.488 262.024,75.858 260.677,69.329 255.286,70.409 253.799,72.721 253.799,75.312 256.378,77.084\r " }),
						_react2.default.createElement("polygon", { points: "255.495,81.569 255.773,78.037 252.637,76.683 248.233,77.706 244.945,82.94 244.945,86.344 248.768,86.344\r " }),
						_react2.default.createElement("path", { d: "M164.852,96.598l-0.976,2.498h-4.7v2.428h1.121c0,0,0.07,0.511,0.168,1.191l2.876-0.238l1.783-1.121l0.465-2.248\r l2.335-0.204l0.912-1.888l-2.138-0.442L164.852,96.598z" }),
						_react2.default.createElement("polygon", { points: "152.739,101.001 152.565,103.366 155.976,103.081 156.324,100.705 154.279,99.096 \t\t\t" }),
						_react2.default.createElement("path", { d: "M356.868,176.633c-0.047-5.223-0.313-10.398-0.802-15.505c-1.662-17.01-5.717-33.311-11.828-48.589\r c-0.441-1.127-0.859-2.283-1.336-3.41c-8.121-19.183-19.531-36.646-33.474-51.721c-0.906-0.987-1.835-1.952-2.765-2.916\r c-2.649-2.736-5.333-5.415-8.156-7.971C266.788,17.631,224.642,0,178.463,0C131.896,0,89.447,17.957,57.635,47.271\r c-7.413,6.832-14.221,14.303-20.408,22.285C13.919,99.717,0,137.49,0,178.463c0,98.398,80.059,178.463,178.463,178.463\r c69.225,0,129.316-39.643,158.897-97.399c6.32-12.327,11.247-25.491,14.569-39.294c0.837-3.486,1.58-7.018,2.208-10.585\r c1.801-10.137,2.788-20.56,2.788-31.196C356.902,177.859,356.868,177.249,356.868,176.633z M323.278,105.306l1.022-1.162\r c1.359,2.637,2.649,5.304,3.846,8.028l-1.708-0.07l-3.172,0.436v-7.233H323.278z M297.484,74.156l0.023-7.971\r c2.812,2.975,5.508,6.036,8.087,9.214l-3.207,4.781l-11.247-0.111l-0.696-2.341L297.484,74.156z M82.214,54.364v-0.302h3.567\r l0.325-1.226h5.838v2.55l-1.691,2.236h-8.052v-3.259H82.214z M87.925,62.323c0,0,3.578-0.61,3.892-0.61c0.296,0,0,3.573,0,3.573\r l-8.081,0.511l-1.534-1.847L87.925,62.323z M334.642,133.156h-13.06l-7.971-5.92l-8.365,0.808v5.112h-2.648l-2.848-2.033\r l-14.512-3.671v-9.4l-18.38,1.423l-5.705,3.062h-7.285l-3.59-0.36l-8.854,4.926v9.254l-18.097,13.065l1.5,5.583h3.677\r l-0.964,5.315l-2.58,0.953l-0.133,13.884l15.633,17.823h6.819l0.407-1.081h12.246l3.531-3.265h6.948l3.812,3.811l10.328,1.069\r l-1.359,13.757l11.503,20.28l-6.064,11.572l0.406,5.438l4.775,4.752v13.095l6.251,8.412v10.897h5.391\r c-30.046,36.913-75.823,60.534-127.026,60.534c-90.312,0-163.783-73.454-163.783-163.777c0-22.732,4.665-44.401,13.077-64.089\r v-5.106l5.855-7.11c2.033-3.846,4.212-7.582,6.542-11.235l0.25,2.974l-6.791,8.261c-2.108,3.985-4.084,8.052-5.855,12.217v9.312\r l6.791,3.276v12.955l6.535,11.136l5.316,0.808l0.68-3.817l-6.245-9.661l-1.237-9.388h3.677l1.557,9.673l9.051,13.193l-2.33,4.27\r l5.734,8.795l14.291,3.532v-2.306l5.711,0.808l-0.534,4.078l4.484,0.825l6.948,1.888l9.8,11.171l12.507,0.941l1.237,10.207\r l-8.58,5.984l-0.39,9.115l-1.237,5.588l12.386,15.5l0.947,5.32c0,0,4.49,1.209,5.048,1.209c0.535,0,10.062,7.227,10.062,7.227\r v28.024l3.393,0.964l-2.294,12.92l5.71,7.634l-1.068,12.827l7.563,13.269l9.696,8.47l9.731,0.197l0.952-3.148l-7.163-6.029\r l0.418-2.986l1.272-3.684l0.273-3.741l-4.839-0.14l-2.44-3.066l4.021-3.881l0.546-2.916l-4.496-1.29l0.261-2.719l6.402-0.976\r l9.73-4.672l3.265-6.006l10.196-13.06l-2.312-10.213l3.131-5.438l9.399,0.278l6.327-5.02l2.051-19.693l7.04-8.877l1.237-5.704\r l-6.39-2.045l-4.224-6.942l-14.419-0.145l-11.444-4.351l-0.534-8.162l-3.811-6.675l-10.335-0.145l-5.995-9.382l-5.298-2.585\r l-0.273,2.858l-9.672,0.569l-3.532-4.926l-10.079-2.045l-8.302,9.603l-13.065-2.23l-0.953-14.727l-9.527-1.632l3.805-7.221\r l-1.092-4.148l-12.531,8.371l-7.877-0.964l-2.817-6.158l1.737-6.355l4.339-8.005l9.998-5.072h19.322l-0.064,5.891l6.948,3.235\r l-0.558-10.062l5.007-5.037l10.103-6.64l0.703-4.659l10.068-10.486l10.707-5.937l-0.941-0.773l7.256-6.826l2.655,0.703\r l1.214,1.522l2.76-3.062l0.68-0.296l-3.021-0.43l-3.084-0.987v-2.963l1.632-1.33h3.579l1.655,0.726l1.418,2.858l1.737-0.267\r v-0.244l0.5,0.163l5.02-0.772l0.714-2.463l2.852,0.726v2.667l-2.666,1.818h0.018l0.377,2.928l9.115,2.794c0,0,0,0.035,0.023,0.11\r l2.079-0.18l0.146-3.939l-7.209-3.282l-0.396-1.894l5.972-2.033l0.273-5.722l-6.245-3.805l-0.412-9.667l-8.581,4.218h-3.143\r l0.837-7.355l-11.688-2.748l-4.816,3.654v11.119l-8.673,2.754l-3.486,7.244l-3.758,0.604v-9.277l-8.162-1.133l-4.096-2.667\r l-1.639-6.007l14.611-8.54l7.14-2.179l0.72,4.804l3.991-0.215l0.308-2.411l4.166-0.599l0.07-0.842l-1.784-0.738l-0.407-2.544\r l5.118-0.43l3.091-3.213l0.18-0.238l0.035,0.012l0.941-0.976l10.753-1.354l4.746,4.032l-12.467,6.64l15.871,3.747l2.045-5.31\r h6.948l2.44-4.625l-4.903-1.226v-5.856l-15.359-6.803l-10.62,1.226l-6.001,3.125l0.407,7.628l-6.257-0.953l-0.964-4.212\r l6.007-5.449l-10.898-0.535l-3.125,0.953l-1.359,3.677l4.084,0.686l-0.813,4.084l-6.936,0.406l-1.092,2.725L118.987,52.4\r c0,0-0.273-5.711-0.703-5.711c-0.389,0,7.901-0.145,7.901-0.145l5.995-5.85l-3.271-1.632l-4.339,4.223l-7.222-0.406l-4.403-6.019\r h-9.254L94.03,44.07h8.848l0.796,2.597l-2.307,2.172l9.807,0.279l1.487,3.532l-11.032-0.407l-0.546-2.725l-6.925-1.499\r l-3.689-2.033l-8.255,0.069c27.043-19.699,60.284-31.358,96.226-31.358c41.403,0,79.263,15.476,108.124,40.915l-1.929,3.474\r l-7.564,2.962l-3.194,3.462l0.743,4.02l3.893,0.546l2.358,5.867l6.704-2.713l1.127,7.86h-2.045l-5.519-0.819l-6.111,1.022\r l-5.926,8.377l-8.458,1.319l-1.221,7.25l3.579,0.842l-1.046,4.665l-8.412-1.69l-7.703,1.69l-1.639,4.293l1.325,9.01l4.531,2.115\r l7.61-0.046l5.123-0.465l1.58-4.078l8.018-10.422l5.264,1.081l5.193-4.7l0.976,3.678l12.78,8.621l-1.557,2.108l-5.763-0.308\r l2.23,3.137l3.556,0.79l4.159-1.737l-0.093-5.002l1.859-0.923l-1.487-1.575l-8.528-4.758l-2.254-6.314h7.099l2.243,2.248\r l6.134,5.257l0.244,6.367l6.332,6.733l2.348-9.231l4.392-2.394l0.802,7.552l4.287,4.7l8.54-0.139\r c1.661,4.247,3.148,8.563,4.427,12.978L334.642,133.156z M97.324,81.092l4.27-2.044l3.881,0.929l-1.324,5.211l-4.183,1.319\r L97.324,81.092z M120.073,93.35v3.37h-9.783l-3.689-1.028l0.918-2.341l4.7-1.94h6.437v1.94H120.073z M124.582,98.05v3.259\r l-2.463,1.58l-3.044,0.575c0,0,0-4.903,0-5.415H124.582z M121.822,96.72v-3.893l3.363,3.067L121.822,96.72z M123.355,104.568\r v3.178l-2.347,2.347h-5.211l0.813-3.573l2.463-0.215l0.5-1.226L123.355,104.568z M110.39,98.05h5.408l-6.948,9.696l-2.852-1.534\r l0.616-4.084L110.39,98.05z M132.529,103.464v3.166h-5.211l-1.417-2.062v-2.951h0.406L132.529,103.464z M127.748,99.096\r l1.475-1.557l2.498,1.557l-1.999,1.656L127.748,99.096z M337.291,141.428l0.511-0.61c0.232,0.93,0.441,1.859,0.662,2.789\r L337.291,141.428z" }),
						_react2.default.createElement("path", { d: "M27.734,109.268v5.106c1.771-4.177,3.747-8.231,5.855-12.223L27.734,109.268z" })
					)
				)
			)
		);
	}
	//# sourceMappingURL=InternationalIcon.js.map

/***/ },
/* 2779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PhoneInput = __webpack_require__(1251);
	
	var _PhoneInput2 = _interopRequireDefault(_PhoneInput);
	
	var _CountrySelectNative = __webpack_require__(2773);
	
	var _CountrySelectNative2 = _interopRequireDefault(_CountrySelectNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneInputNative = (_temp2 = _class = function (_Component) {
		_inherits(PhoneInputNative, _Component);
	
		function PhoneInputNative() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhoneInputNative);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNative.__proto__ || Object.getPrototypeOf(PhoneInputNative)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _this.getInputClassName = function (_ref2) {
				var disabled = _ref2.disabled,
				    invalid = _ref2.invalid;
	
				return (0, _classnames2.default)(
				// Will be removed in version 2.x
				'react-phone-number-input__phone--native', {
					'react-phone-number-input__phone--disabled': disabled,
					'react-phone-number-input__phone--invalid': invalid
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PhoneInputNative, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_PhoneInput2.default, _extends({}, this.props, {
					ref: this.storeInputRef,
					getInputClassName: this.getInputClassName,
					countrySelectComponent: _CountrySelectNative2.default,
					countrySelectProperties: countrySelectProperties }));
			}
		}, {
			key: 'focus',
	
	
			// Proxy `.focus()` method.
			value: function focus() {
				return this.input.focus();
			}
		}]);
	
		return PhoneInputNative;
	}(_react.Component), _class.propTypes = {
		// Replaces the default country select arrow.
		countrySelectArrowComponent: _propTypes2.default.func
	}, _temp2);
	exports.default = PhoneInputNative;
	
	
	var countrySelectProperties = {
		countrySelectArrowComponent: 'selectArrowComponent'
	};
	//# sourceMappingURL=PhoneInputNative.js.map

/***/ },
/* 2780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _metadata = __webpack_require__(960);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _PhoneInputNative = __webpack_require__(2779);
	
	var _PhoneInputNative2 = _interopRequireDefault(_PhoneInputNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneInputNativeDefaultMetadata = function (_Component) {
		_inherits(PhoneInputNativeDefaultMetadata, _Component);
	
		function PhoneInputNativeDefaultMetadata() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhoneInputNativeDefaultMetadata);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputNativeDefaultMetadata.__proto__ || Object.getPrototypeOf(PhoneInputNativeDefaultMetadata)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PhoneInputNativeDefaultMetadata, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_PhoneInputNative2.default, _extends({}, this.props, {
					ref: this.storeInputRef,
					metadata: _metadata2.default }));
			}
	
			// Proxy `.focus()` method.
	
		}, {
			key: 'focus',
			value: function focus() {
				return this.input.focus();
			}
		}]);
	
		return PhoneInputNativeDefaultMetadata;
	}(_react.Component);
	
	exports.default = PhoneInputNativeDefaultMetadata;
	//# sourceMappingURL=PhoneInputNativeDefaultMetadata.js.map

/***/ },
/* 2781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PhoneInput = __webpack_require__(1251);
	
	var _PhoneInput2 = _interopRequireDefault(_PhoneInput);
	
	var _CountrySelectReactResponsiveUI = __webpack_require__(2774);
	
	var _CountrySelectReactResponsiveUI2 = _interopRequireDefault(_CountrySelectReactResponsiveUI);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PhoneInputReactResponsiveUI = (_temp2 = _class = function (_Component) {
		_inherits(PhoneInputReactResponsiveUI, _Component);
	
		function PhoneInputReactResponsiveUI() {
			var _ref;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, PhoneInputReactResponsiveUI);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInputReactResponsiveUI.__proto__ || Object.getPrototypeOf(PhoneInputReactResponsiveUI)).call.apply(_ref, [this].concat(args))), _this), _this.storeInputRef = function (ref) {
				return _this.input = ref;
			}, _this.getInputClassName = function (_ref2) {
				var disabled = _ref2.disabled,
				    invalid = _ref2.invalid;
	
				return (0, _classnames2.default)('rrui__input', 'rrui__input-element', 'rrui__input-field', {
					'rrui__input-field--invalid': invalid,
					'rrui__input-field--disabled': disabled
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		_createClass(PhoneInputReactResponsiveUI, [{
			key: 'render',
			value: function render() {
				return _react2.default.createElement(_PhoneInput2.default, _extends({}, this.props, {
					ref: this.storeInputRef,
					getInputClassName: this.getInputClassName,
					countrySelectComponent: _CountrySelectReactResponsiveUI2.default,
					countrySelectProperties: countrySelectProperties,
					countrySelectHidesPhoneInputField: true }));
			}
		}, {
			key: 'focus',
	
	
			// Proxy `.focus()` method.
			value: function focus() {
				return this.input.focus();
			}
		}]);
	
		return PhoneInputReactResponsiveUI;
	}(_react.Component), _class.propTypes = {
		// `<input/>` CSS class.
		// Both for the phone number `<input/>` and
		// the country select autocomplete `<input/>`.
		inputClassName: _propTypes2.default.string,
	
		// If set to `false`, then country flags will be shown
		// for all countries when country `<select/>` is expanded.
		// By default shows flag only for currently selected country.
		saveOnIcons: _propTypes2.default.bool,
	
		// Whether to use native country `<select/>` when it's expanded.
		// Deprecated. Will be removed in some future major version.
		// Use `<PhoneInputNative/>` instead.
		nativeCountrySelect: _propTypes2.default.bool,
	
		// `aria-label` for the `<Select/>`'s toggle `<button/>`.
		countrySelectAriaLabel: _propTypes2.default.string,
	
		// `aria-label` for the `<Select/>`'s "Close" button
		// (which is an "x" visible in fullscreen mode).
		// (not yet implemented but is likely to be).
		countrySelectCloseAriaLabel: _propTypes2.default.string,
	
		// Defines the height (in items) of the expanded country `<select/>`.
		countrySelectMaxItems: _propTypes2.default.number,
	
		// Country `<select/>` toggle `<button/>` CSS class.
		// Deprecated. Will be removed in some future major version.
		countrySelectToggleClassName: _propTypes2.default.string
	}, _temp2);
	exports.default = PhoneInputReactResponsiveUI;
	
	
	var countrySelectProperties = {
		inputClassName: 'inputClassName',
		saveOnIcons: 'saveOnIcons',
		nativeCountrySelect: 'nativeExpanded',
		countrySelectAriaLabel: 'ariaLabel',
		countrySelectCloseAriaLabel: 'closeAriaLabel',
		countrySelectMaxItems: 'maxItems',
		countrySelectToggleClassName: 'toggleClassName'
	};
	//# sourceMappingURL=PhoneInputReactResponsiveUI.js.map

/***/ },
/* 2782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPreSelectedCountry = getPreSelectedCountry;
	exports.getCountrySelectOptions = getCountrySelectOptions;
	exports.parsePhoneNumber = parsePhoneNumber;
	exports.generateNationalNumberDigits = generateNationalNumberDigits;
	exports.migrateParsedInputForNewCountry = migrateParsedInputForNewCountry;
	exports.e164 = e164;
	exports.getCountryForParsedInput = getCountryForParsedInput;
	exports.get_country_from_possibly_incomplete_international_phone_number = get_country_from_possibly_incomplete_international_phone_number;
	exports.compare_strings = compare_strings;
	exports.has_international_option = has_international_option;
	exports.strip_country_calling_code = strip_country_calling_code;
	exports.get_national_significant_number_part = get_national_significant_number_part;
	exports.could_number_belong_to_country = could_number_belong_to_country;
	
	var _custom = __webpack_require__(972);
	
	var _countries2 = __webpack_require__(1253);
	
	var _countries3 = _interopRequireDefault(_countries2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Decides which country should be pre-selected
	 * when the phone number input component is first mounted.
	 * @param  {object} parsedNumber - A parsed number object: `{ country, phone }`. Can be an empty object.
	 * @param  {string?} country - Pre-defined country (two-letter code).
	 * @param  {string[]} countries - A list of countries available.
	 * @param  {boolean} includeInternationalOption - Whether "International" country option is available.
	 * @param  {object} metadata - `libphonenumber-js` metadata
	 * @return {string?}
	 */
	function getPreSelectedCountry(parsed_number, country, countries, includeInternationalOption, metadata) {
		// If can get country from E.164 phone number
		// then it overrides the `country` passed (or not passed).
		if (parsed_number.country) {
			// `country` will be left `undefined` in case of non-detection.
			country = parsed_number.country;
		}
	
		// Only pre-select a country if it's in the available `countries` list.
		if (countries.indexOf(country) < 0) {
			country = undefined;
		}
	
		// If there will be no "International" option
		// then some `country` must be selected.
		// It will still be the wrong country though.
		// But still country `<select/>` can't be left in a broken state.
		if (!country && !has_international_option(countries, includeInternationalOption)) {
			country = countries[0];
		}
	
		return country;
	}
	
	/**
	 * Generates a sorted list of country `<select/>` options.
	 * @param  {string[]} countries - A list of two-letter ("ISO 3166-1 alpha-2") country codes.
	 * @param  {object?} labels - Custom country labels. E.g. `{ RU: 'Россия', US: 'США', ... }`.
	 * @param  {boolean} includeInternationalOption - Whether should include "International" option at the top of the list.
	 * @return {object[]} A list of objects having shape `{ value : string, label : string }`.
	 */
	function getCountrySelectOptions(_countries, country_names, includeInternationalOption) {
		// Generates a `<Select/>` option for each country.
		var country_select_options = _countries.map(function (country) {
			return {
				value: country,
				label: country_names && country_names[country] || _countries3.default[country]
			};
		});
	
		// Sort the list of countries alphabetically.
		//
		// This is only done when custom `countries` are supplied.
		//
		// If no custom `countries` are supplied
		// then this means the default list of `countries`
		// is used which is already sorted by country name alphabetically.
		//
		if (_countries !== _countries2.countries || country_names) {
			country_select_options.sort(function (a, b) {
				return compare_strings(a.label, b.label);
			});
		}
	
		// Add the "International" option to the country list (if suitable)
		if (has_international_option(_countries, includeInternationalOption)) {
			country_select_options.unshift({
				label: country_names && country_names.ZZ || _countries3.default.ZZ
			});
		}
	
		return country_select_options;
	}
	
	/**
	 * Parses a E.164 phone number to an object having shape `{ country : string, phone : string }`.
	 * @param {string} value = E.164 phone number.
	 * @param  {object} metadata - `libphonenumber-js` metadata
	 * @example
	 * parsePhoneNumber('+78005553535')
	 * // returns `{ country: 'RU', phone: '8005553535' }`
	 */
	function parsePhoneNumber(value, metadata) {
		return (0, _custom.parseNumber)(value || '', metadata);
	}
	
	/**
	 * Generates national number digits for a parsed phone.
	 * May prepend national prefix.
	 * @param  {object} parsedPhone - Object having shape `{ country : string, phone : string }`.
	 * @param  {object} metadata - `libphonenumber-js` metadata
	 * @return {string}
	 * @example
	 * getNationalNumberDigits({ country: 'RU', phone: '8005553535' })
	 * // returns '88005553535'
	 */
	function generateNationalNumberDigits(parsed_phone, metadata) {
		return (0, _custom.formatNumber)(parsed_phone, 'National', metadata).replace(/\D/g, '');
	}
	
	/**
	 * Migrates `<input/>` parsed `value` for the newly selected `country`.
	 * @param {string?} value - The `value` parsed from phone number `<input/>` (it's the `parsed_input` state property, not the `value` property).
	 * @param {string?} previousCountry - Previously selected country.
	 * @param {string?} newCountry - Newly selected country. Can't be same as previously selected country.
	 * @param {object} metadata - `libphonenumber-js` metadata.
	 * @return {string}
	 */
	function migrateParsedInputForNewCountry(value, previous_country, new_country, metadata) {
		// If `parsed_input` is empty
		// then no need to migrate anything.
		if (!value) {
			return value;
		}
	
		// If switching to some country.
		// (from "International" or another country)
		// If switching from "International" then `value` starts with a `+`.
		// Otherwise it may or may not start with a `+`.
		if (new_country) {
			// If the phone number was entered in international format
			// then migrate it to the newly selected country.
			// The phone number may be incomplete.
			// The phone number entered not necessarily starts with
			// the previously selected country phone prefix.
			if (value[0] === '+') {
				// If the international phone number already contains
				// any country calling code then trim the country calling code part.
				// (that could also be the newly selected country phone code prefix as well)
				// `value` doesn't neccessarily belong to `previous_country`.
				// (e.g. if a user enters an international number
				//  not belonging to any of the reduced `countries` list)
				value = strip_country_calling_code(value, previous_country, metadata);
	
				// Prepend country calling code prefix
				// for the newly selected country.
				return '+' + (0, _custom.getCountryCallingCode)(new_country, metadata) + value;
			}
		}
		// If switching to "International" from a country.
		else {
				// If the phone number was entered in national format.
				if (value[0] !== '+') {
					// Format the national phone number as an international one.
					// The phone number entered not necessarily even starts with
					// the previously selected country phone prefix.
					// Even if the phone number belongs to whole another country
					// it will still be parsed into some national phone number.
					var partial_national_significant_number = get_national_significant_number_part(value, previous_country, metadata);
					return (0, _custom.formatNumber)(partial_national_significant_number, previous_country, 'E.164', metadata);
				}
			}
	
		return value;
	}
	
	/**
	 * Converts phone number digits to a (possibly incomplete) E.164 phone number.
	 * @param  {string?} number - A possibly incomplete phone number digits string. Can be a possibly incomplete E.164 phone number.
	 * @param  {string?} country
	 * @param  {[object} metadata - `libphonenumber-js` metadata.
	 * @return {string?}
	 */
	function e164(number, country, metadata) {
		if (!number) {
			return;
		}
	
		// If the phone number is being input in international format.
		if (number[0] === '+') {
			// If it's just the `+` sign then return nothing.
			if (number === '+') {
				return;
			}
	
			// If there are any digits then the `value` is returned as is.
			return number;
		}
	
		// For non-international phone numbers
		// an accompanying country code is required.
		if (!country) {
			return;
		}
	
		var partial_national_significant_number = get_national_significant_number_part(number, country, metadata);
	
		if (!partial_national_significant_number) {
			return;
		}
	
		return (0, _custom.formatNumber)(partial_national_significant_number, country, 'E.164', metadata);
	}
	
	// If the phone number being input is an international one
	// then tries to derive the country from the phone number.
	// (regardless of whether there's any country currently selected)
	/**
	 * @param {string} parsedInput - A possibly incomplete E.164 phone number.
	 * @param {string?} country - Currently selected country.
	 * @param {string[]} countries - A list of available countries.
	 * @param {boolean} includeInternationalOption - Whether "International" country option is available.
	 * @param  {[object} metadata - `libphonenumber-js` metadata.
	 * @return {string?}
	 */
	function getCountryForParsedInput(parsed_input, country, countries, includeInternationalOption, metadata) {
		if (parsed_input === '+') {
			// Don't change the currently selected country yet.
			return country;
		}
	
		var derived_country = get_country_from_possibly_incomplete_international_phone_number(parsed_input, metadata);
	
		// If a phone number is being input in international form
		// and the country can already be derived from it,
		// then select that country.
		if (derived_country && countries.indexOf(derived_country) >= 0) {
			return derived_country;
		}
		// If "International" country option has not been disabled
		// and the international phone number entered doesn't correspond
		// to the currently selected country then reset the currently selected country.
		else if (country && has_international_option(countries, includeInternationalOption) && !could_number_belong_to_country(parsed_input, country, metadata)) {
				return undefined;
			}
	
		// Don't change the currently selected country.
		return country;
	}
	
	/**
	 * Determines the country for a given (possibly incomplete) E.164 phone number.
	 * @param  {string} number - A possibly incomplete E.164 phone number.
	 * @param  {object} metadata - `libphonenumber-js` metadata.
	 * @return {string?}
	 */
	function get_country_from_possibly_incomplete_international_phone_number(number, metadata) {
		var formatter = new _custom.AsYouType(null, metadata);
		formatter.input(number);
		// `001` is a special "non-geograpical entity" code
		// in Google's `libphonenumber` library.
		if (formatter.country === '001') {
			return;
		}
		return formatter.country;
	}
	
	/**
	 * Compares two strings.
	 * A helper for `Array.sort()`.
	 */
	function compare_strings(a, b) {
		// Use `String.localeCompare` if it's available.
		// https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare
		// Which means everyone except IE <= 10 and Safari <= 10.
		if (String.prototype.localeCompare) {
			return a.localeCompare(b);
		}
		return a < b ? -1 : a > b ? 1 : 0;
	}
	
	/**
	 * Whether should add the "International" option to country `<select/>`.
	 */
	function has_international_option(_countries, includeInternationalOption) {
		// If this behaviour is explicitly set, then do as it says.
		if (includeInternationalOption !== undefined) {
			return includeInternationalOption;
		}
	
		// If the list of `countries` has been overridden
		// then only show "International" option
		// if no countries have been left out.
		// The reasoning is that if some countries were left out
		// and a user selects "International" option
		// then he can input a phone number for a non-included country
		// and perhaps that's what a developer didn't encourage
		// when he was reducing the set of selectable countries.
		return _countries.length >= _countries2.countries.length;
	}
	
	/**
	 * Strips `+${countryCallingCode}` prefix from an E.164 phone number.
	 * @param {string} number - (possibly incomplete) E.164 phone number.
	 * @param {string?} country - A possible country for this phone number.
	 * @param {object} metadata - `libphonenumber-js` metadata.
	 * @return {string}
	 */
	function strip_country_calling_code(number, country, metadata) {
		// Just an optimization, so that it
		// doesn't have to iterate through all country calling codes.
		if (country) {
			var country_calling_prefix = '+' + (0, _custom.getCountryCallingCode)(country, metadata);
	
			// If `country` fits the actual `number`.
			if (number.length < country_calling_prefix.length) {
				if (country_calling_prefix.indexOf(number) === 0) {
					return '';
				}
			} else {
				if (number.indexOf(country_calling_prefix) === 0) {
					return number.slice(country_calling_prefix.length);
				}
			}
		}
	
		// If `country` doesn't fit the actual `number`.
		// Try all available country calling codes.
		for (var _iterator = Object.keys(metadata.country_calling_codes), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
			var _ref;
	
			if (_isArray) {
				if (_i >= _iterator.length) break;
				_ref = _iterator[_i++];
			} else {
				_i = _iterator.next();
				if (_i.done) break;
				_ref = _i.value;
			}
	
			var country_calling_code = _ref;
	
			if (number.indexOf(country_calling_code) === '+'.length) {
				return number.slice('+'.length + country_calling_code.length);
			}
		}
	
		return '';
	}
	
	/**
	 * Parses a partially entered national phone number digits
	 * (or a partially entered E.164 international phone number)
	 * and returns the national significant number part.
	 * National significant number returned doesn't come with a national prefix.
	 * @param {string} number - National number digits. Or possibly incomplete E.164 phone number.
	 * @param {string?} country
	 * @param {object} metadata - `libphonenumber-js` metadata.
	 */
	function get_national_significant_number_part(number, country, metadata) {
		// Create "as you type" formatter.
		var formatter = new _custom.AsYouType(country, metadata);
	
		// Input partial national phone number.
		formatter.input(number);
	
		// Return the parsed partial national phone number.
		return formatter.getNationalNumber();
	}
	
	/**
	 * Checks if a partially entered E.164 phone number could belong to a country.
	 * @param  {string} number
	 * @param  {string} country
	 * @return {boolean}
	 */
	function could_number_belong_to_country(number, country, metadata) {
		var country_calling_code = (0, _custom.getCountryCallingCode)(country, metadata);
	
		var i = 0;
		while (i + 1 < number.length && i < country_calling_code.length) {
			if (number[i + 1] !== country_calling_code[i]) {
				return false;
			}
			i++;
		}
	
		return true;
	}
	//# sourceMappingURL=input-control.js.map

/***/ },
/* 2783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict'
	
	exports = module.exports = __webpack_require__(1252).default
	
	exports.PhoneInputNative = __webpack_require__(2780).default
	
	exports['default'] = __webpack_require__(1252).default

/***/ },
/* 2784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _placeholders = __webpack_require__(2788);
	
	var placeholders = _interopRequireWildcard(_placeholders);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactPlaceholder = (_temp2 = _class = function (_React$Component) {
	  _inherits(ReactPlaceholder, _React$Component);
	
	  function ReactPlaceholder() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ReactPlaceholder);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlaceholder.__proto__ || Object.getPrototypeOf(ReactPlaceholder)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      ready: _this.props.ready
	    }, _this.getFiller = function () {
	      var _this$props = _this.props,
	          firstLaunchOnly = _this$props.firstLaunchOnly,
	          children = _this$props.children,
	          ready = _this$props.ready,
	          className = _this$props.className,
	          type = _this$props.type,
	          customPlaceholder = _this$props.customPlaceholder,
	          showLoadingAnimation = _this$props.showLoadingAnimation,
	          rest = _objectWithoutProperties(_this$props, ['firstLaunchOnly', 'children', 'ready', 'className', 'type', 'customPlaceholder', 'showLoadingAnimation']);
	
	      var classes = showLoadingAnimation ? ['show-loading-animation', className].filter(function (c) {
	        return c;
	      }).join(' ') : className;
	
	      if (customPlaceholder && _react2.default.isValidElement(customPlaceholder)) {
	        var mergedCustomClasses = [customPlaceholder.props.className, classes].filter(function (c) {
	          return c;
	        }).join(' ');
	        return _react2.default.cloneElement(customPlaceholder, { className: mergedCustomClasses });
	      } else if (customPlaceholder) {
	        return customPlaceholder;
	      }
	
	      var Placeholder = placeholders[type];
	
	      return _react2.default.createElement(Placeholder, _extends({}, rest, { className: classes }));
	    }, _this.setNotReady = function () {
	      var delay = _this.props.delay;
	
	
	      if (delay > 0) {
	        _this.timeout = setTimeout(function () {
	          _this.setState({ ready: false });
	        }, delay);
	      } else {
	        _this.setState({ ready: false });
	      }
	    }, _this.setReady = function () {
	      if (_this.timeout) {
	        clearTimeout(_this.timeout);
	      }
	
	      if (!_this.state.ready) {
	        _this.setState({ ready: true });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ReactPlaceholder, [{
	    key: 'render',
	    value: function render() {
	      return this.state.ready ? this.props.children : this.getFiller();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!this.props.firstLaunchOnly && this.state.ready && !nextProps.ready) {
	        this.setNotReady();
	      } else if (nextProps.ready) {
	        this.setReady();
	      }
	    }
	  }]);
	
	  return ReactPlaceholder;
	}(_react2.default.Component), _class.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element]).isRequired,
	  delay: _propTypes2.default.number,
	  ready: _propTypes2.default.bool.isRequired,
	  firstLaunchOnly: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['text', 'media', 'textRow', 'rect', 'round']),
	  rows: _propTypes2.default.number,
	  color: _propTypes2.default.string,
	  showLoadingAnimation: _propTypes2.default.bool,
	  customPlaceholder: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.element])
	}, _class.defaultProps = {
	  delay: 0,
	  type: 'text',
	  color: '#CDCDCD'
	}, _temp2);
	exports.default = ReactPlaceholder;

/***/ },
/* 2785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _ReactPlaceholder = __webpack_require__(2784);
	
	var _ReactPlaceholder2 = _interopRequireDefault(_ReactPlaceholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ReactPlaceholder2.default;

/***/ },
/* 2786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextBlock = __webpack_require__(1257);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _RoundShape = __webpack_require__(1256);
	
	var _RoundShape2 = _interopRequireDefault(_RoundShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MediaBlock = (_temp = _class = function (_React$Component) {
	  _inherits(MediaBlock, _React$Component);
	
	  function MediaBlock() {
	    _classCallCheck(this, MediaBlock);
	
	    return _possibleConstructorReturn(this, (MediaBlock.__proto__ || Object.getPrototypeOf(MediaBlock)).apply(this, arguments));
	  }
	
	  _createClass(MediaBlock, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          color = _props.color,
	          rows = _props.rows;
	
	
	      var classes = ['media-block', className].filter(function (c) {
	        return c;
	      }).join(' ');
	
	      return _react2.default.createElement(
	        'div',
	        { className: classes, style: _extends({}, style, { display: 'flex' }) },
	        _react2.default.createElement(_RoundShape2.default, {
	          color: color,
	          style: { minHeight: 55, width: 55, minWidth: 55, marginRight: 10 }
	        }),
	        _react2.default.createElement(_TextBlock2.default, { color: color, rows: rows })
	      );
	    }
	  }]);
	
	  return MediaBlock;
	}(_react2.default.Component), _class.propTypes = {
	  rows: _propTypes2.default.number.isRequired,
	  color: _propTypes2.default.string.isRequired,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string
	}, _temp);
	exports.default = MediaBlock;

/***/ },
/* 2787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RectShape = (_temp = _class = function (_React$Component) {
	  _inherits(RectShape, _React$Component);
	
	  function RectShape() {
	    _classCallCheck(this, RectShape);
	
	    return _possibleConstructorReturn(this, (RectShape.__proto__ || Object.getPrototypeOf(RectShape)).apply(this, arguments));
	  }
	
	  _createClass(RectShape, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          color = _props.color;
	
	
	      var defaultStyle = {
	        backgroundColor: color,
	        width: '100%',
	        height: '100%',
	        marginRight: 10
	      };
	
	      var classes = ['rect-shape', className].filter(function (c) {
	        return c;
	      }).join(' ');
	
	      return _react2.default.createElement('div', { className: classes, style: _extends({}, defaultStyle, style) });
	    }
	  }]);
	
	  return RectShape;
	}(_react2.default.Component), _class.propTypes = {
	  color: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  style: _propTypes2.default.object
	}, _temp);
	exports.default = RectShape;

/***/ },
/* 2788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.media = exports.text = exports.rect = exports.round = exports.textRow = exports.MediaBlock = exports.TextBlock = exports.RectShape = exports.RoundShape = exports.TextRow = undefined;
	
	var _TextRow2 = __webpack_require__(1258);
	
	var _TextRow3 = _interopRequireDefault(_TextRow2);
	
	var _RoundShape2 = __webpack_require__(1256);
	
	var _RoundShape3 = _interopRequireDefault(_RoundShape2);
	
	var _RectShape2 = __webpack_require__(2787);
	
	var _RectShape3 = _interopRequireDefault(_RectShape2);
	
	var _TextBlock2 = __webpack_require__(1257);
	
	var _TextBlock3 = _interopRequireDefault(_TextBlock2);
	
	var _MediaBlock2 = __webpack_require__(2786);
	
	var _MediaBlock3 = _interopRequireDefault(_MediaBlock2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.TextRow = _TextRow3.default;
	// import Card from 'Card';
	
	exports.RoundShape = _RoundShape3.default;
	exports.RectShape = _RectShape3.default;
	exports.TextBlock = _TextBlock3.default;
	exports.MediaBlock = _MediaBlock3.default;
	var textRow = exports.textRow = _TextRow3.default;
	var round = exports.round = _RoundShape3.default;
	var rect = exports.rect = _RectShape3.default;
	var text = exports.text = _TextBlock3.default;
	var media = exports.media = _MediaBlock3.default;

/***/ },
/* 2789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createControlClass = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _redux = __webpack_require__(56);
	
	var _identity = __webpack_require__(199);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _shallowEqual = __webpack_require__(201);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _merge = __webpack_require__(2812);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _omit = __webpack_require__(200);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _debounce = __webpack_require__(2803);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _getValue2 = __webpack_require__(253);
	
	var _getValue3 = _interopRequireDefault(_getValue2);
	
	var _getValidity = __webpack_require__(507);
	
	var _getValidity2 = _interopRequireDefault(_getValidity);
	
	var _invertValidity = __webpack_require__(508);
	
	var _invertValidity2 = _interopRequireDefault(_invertValidity);
	
	var _getModel = __webpack_require__(252);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _persistEventWithCallback = __webpack_require__(2815);
	
	var _persistEventWithCallback2 = _interopRequireDefault(_persistEventWithCallback);
	
	var _actions = __webpack_require__(198);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _controlPropsMap = __webpack_require__(342);
	
	var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);
	
	var _validityKeys = __webpack_require__(2793);
	
	var _validityKeys2 = _interopRequireDefault(_validityKeys);
	
	var _batchActions = __webpack_require__(341);
	
	var _resolveModel = __webpack_require__(347);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	var _isNative = __webpack_require__(2811);
	
	var _isNative2 = _interopRequireDefault(_isNative);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _containsEvent = __webpack_require__(1265);
	
	var _containsEvent2 = _interopRequireDefault(_containsEvent);
	
	var _controlStripDefaultsComponent = __webpack_require__(2790);
	
	var _controlStripDefaultsComponent2 = _interopRequireDefault(_controlStripDefaultsComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var disallowedProps = ['changeAction', 'getFieldFromState', 'store'];
	
	function mergeOrSetErrors(model, errors, options) {
	  return _actions2.default.setErrors(model, errors, _extends({
	    merge: (0, _isPlainObject.isObjectLike)(errors)
	  }, options));
	}
	
	var propTypes = {
	  model: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	  modelValue: _propTypes2.default.any,
	  viewValue: _propTypes2.default.any,
	  defaultValue: _propTypes2.default.any,
	  control: _propTypes2.default.any,
	  onLoad: _propTypes2.default.func,
	  onSubmit: _propTypes2.default.func,
	  fieldValue: _propTypes2.default.object,
	  mapProps: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  changeAction: _propTypes2.default.func,
	  updateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  validateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  validators: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  asyncValidateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  asyncValidators: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  errors: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  controlProps: _propTypes2.default.object,
	  component: _propTypes2.default.any,
	  dispatch: _propTypes2.default.func,
	  parser: _propTypes2.default.func,
	  formatter: _propTypes2.default.func,
	  ignore: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  dynamic: _propTypes2.default.bool,
	  store: _propTypes2.default.shape({
	    subscribe: _propTypes2.default.func,
	    dispatch: _propTypes2.default.func,
	    getState: _propTypes2.default.func
	  }),
	  getRef: _propTypes2.default.func,
	  withField: _propTypes2.default.bool,
	  debounce: _propTypes2.default.number,
	  persist: _propTypes2.default.bool,
	  getValue: _propTypes2.default.func,
	  isToggle: _propTypes2.default.bool,
	  updateOnEnter: _propTypes2.default.bool,
	
	  // HTML5 attributes
	  formNoValidate: _propTypes2.default.bool
	};
	
	var htmlAttributes = ['formNoValidate'];
	var disallowedPropTypeKeys = Object.keys(propTypes).filter(function (key) {
	  return htmlAttributes.indexOf(key) === -1;
	});
	
	function createControlClass(s) {
	  var emptyControlProps = {};
	  var emptyMapProps = {};
	
	  var Control = function (_Component) {
	    _inherits(Control, _Component);
	
	    function Control(props) {
	      _classCallCheck(this, Control);
	
	      var _this = _possibleConstructorReturn(this, (Control.__proto__ || Object.getPrototypeOf(Control)).call(this, props));
	
	      _this.getChangeAction = _this.getChangeAction.bind(_this);
	      _this.getValidateAction = _this.getValidateAction.bind(_this);
	
	      _this.handleKeyPress = _this.handleKeyPress.bind(_this);
	      _this.createEventHandler = _this.createEventHandler.bind(_this);
	      _this.handleFocus = _this.createEventHandler('focus').bind(_this);
	      _this.handleBlur = _this.createEventHandler('blur').bind(_this);
	      _this.handleUpdate = _this.createEventHandler('change').bind(_this);
	      _this.forceHandleUpdate = _this.createEventHandler('change', true).bind(_this);
	      _this.handleChange = _this.handleChange.bind(_this);
	      _this.handleLoad = _this.handleLoad.bind(_this);
	      _this.getMappedProps = _this.getMappedProps.bind(_this);
	      _this.attachNode = _this.attachNode.bind(_this);
	
	      if (props.debounce) {
	        _this.handleUpdate = (0, _debounce2.default)(_this.handleUpdate, props.debounce);
	      }
	
	      _this.willValidate = false;
	
	      _this.state = {
	        viewValue: _this.format(props.modelValue)
	      };
	      return _this;
	    }
	
	    _createClass(Control, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.attachNode();
	        this.handleLoad();
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(_ref) {
	        var modelValue = _ref.modelValue;
	
	        if (modelValue !== this.props.modelValue) {
	          this.setViewValue(modelValue);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return !(0, _shallowEqual2.default)(this.props, nextProps, {
	          deepKeys: ['controlProps'],
	          omitKeys: ['mapProps']
	        }) || !(0, _shallowEqual2.default)(this.state.viewValue, nextState.viewValue);
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.handleIntents();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var _props = this.props,
	            model = _props.model,
	            fieldValue = _props.fieldValue,
	            dispatch = _props.dispatch,
	            _props$validators = _props.validators,
	            validators = _props$validators === undefined ? {} : _props$validators,
	            _props$errors = _props.errors,
	            errors = _props$errors === undefined ? {} : _props$errors,
	            persist = _props.persist;
	
	
	        if (!persist && fieldValue && !fieldValue.valid) {
	          var keys = Object.keys(validators).concat(Object.keys(errors), this.willValidate ? _validityKeys2.default : []);
	
	          dispatch(_actions2.default.resetValidity(model, keys));
	        }
	
	        // flush debounced model changes
	        if (this.handleUpdate.flush) {
	          this.handleUpdate.flush();
	        }
	      }
	    }, {
	      key: 'getMappedProps',
	      value: function getMappedProps() {
	        var props = this.props;
	        var mapProps = props.mapProps;
	        var viewValue = this.state.viewValue;
	
	        var originalProps = _extends({}, props, props.controlProps, {
	          onFocus: this.handleFocus,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onKeyPress: this.handleKeyPress,
	          viewValue: viewValue
	        });
	
	        if ((0, _isPlainObject2.default)(mapProps)) {
	          return (0, _mapValues2.default)(mapProps, function (value, key) {
	            if (typeof value === 'function' && key !== 'component') {
	              return value(originalProps);
	            }
	
	            return value;
	          });
	        } else if (typeof mapProps === 'function') {
	          return mapProps(originalProps);
	        }
	
	        return emptyMapProps;
	      }
	    }, {
	      key: 'getChangeAction',
	      value: function getChangeAction(event) {
	        return this.props.changeAction(this.props.model, this.getValue(event), {
	          currentValue: this.props.modelValue,
	          external: false
	        });
	      }
	    }, {
	      key: 'getValidateAction',
	      value: function getValidateAction(value, eventName) {
	        var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	        var _props2 = this.props,
	            validators = _props2.validators,
	            errors = _props2.errors,
	            model = _props2.model,
	            modelValue = _props2.modelValue,
	            updateOn = _props2.updateOn,
	            fieldValue = _props2.fieldValue;
	
	
	        if (!validators && !errors && !this.willValidate) return false;
	
	        var nodeErrors = this.getNodeErrors();
	
	        // If it is not a change event, use the model value.
	        var valueToValidate = forceUpdate || (0, _containsEvent2.default)(updateOn, eventName) ? value : modelValue;
	
	        if (validators || errors) {
	          var fieldValidity = (0, _getValidity2.default)(validators, valueToValidate);
	          var fieldErrors = (0, _merge2.default)((0, _getValidity2.default)(errors, valueToValidate), nodeErrors);
	
	          var mergedErrors = validators ? (0, _merge2.default)((0, _invertValidity2.default)(fieldValidity), fieldErrors) : fieldErrors;
	
	          if (!fieldValue || !(0, _shallowEqual2.default)(mergedErrors, fieldValue.errors)) {
	            return mergeOrSetErrors(model, mergedErrors);
	          }
	        } else if (nodeErrors && Object.keys(nodeErrors).length) {
	          return mergeOrSetErrors(model, nodeErrors);
	        }
	
	        return false;
	      }
	    }, {
	      key: 'getAsyncValidateAction',
	      value: function getAsyncValidateAction(value, eventName) {
	        var _this2 = this;
	
	        var _props3 = this.props,
	            asyncValidators = _props3.asyncValidators,
	            fieldValue = _props3.fieldValue,
	            model = _props3.model,
	            modelValue = _props3.modelValue,
	            updateOn = _props3.updateOn,
	            _props3$validateOn = _props3.validateOn,
	            validateOn = _props3$validateOn === undefined ? updateOn : _props3$validateOn,
	            asyncValidateOn = _props3.asyncValidateOn,
	            dispatch = _props3.dispatch,
	            getValue = _props3.getValue;
	
	        // If there are no async validators,
	        // do not run async validation
	
	        if (!asyncValidators) return false;
	
	        // If it is not a change event, use the model value.
	        var valueToValidate = (0, _containsEvent2.default)(updateOn, eventName) ? value : modelValue;
	
	        // If any sync validity is invalid,
	        // do not run async validation
	        // unless sync and async validation occur simultaneously
	        if (validateOn !== asyncValidateOn) {
	          var asyncValidatorKeys = Object.keys(asyncValidators);
	          var syncValid = Object.keys(fieldValue.validity).every(function (key) {
	            // If validity is based on async validator, skip
	            if (!!~asyncValidatorKeys.indexOf(key)) return true;
	
	            return fieldValue.validity[key];
	          });
	
	          if (!syncValid) return false;
	        }
	
	        dispatch(_actions2.default.setValidating(model, true));
	
	        (0, _mapValues2.default)(asyncValidators, function (validator, key) {
	          var outerDone = function outerDone(valid) {
	            var validity = _icepick2.default.merge(fieldValue.validity, _defineProperty({}, key, valid));
	
	            dispatch(_actions2.default.setValidity(model, validity));
	          };
	
	          validator(getValue(valueToValidate, _this2.props), outerDone);
	        });
	
	        return valueToValidate;
	      }
	    }, {
	      key: 'getNodeErrors',
	      value: function getNodeErrors() {
	        var node = this.node,
	            _props4 = this.props,
	            fieldValue = _props4.fieldValue,
	            formNoValidate = _props4.formNoValidate;
	
	
	        if (formNoValidate || !node || node && !node.willValidate) {
	          this.willValidate = false;
	          return null;
	        }
	
	        this.willValidate = true;
	
	        var nodeErrors = {};
	
	        _validityKeys2.default.forEach(function (key) {
	          var errorValidity = node.validity[key];
	
	          // If the key is invalid or they key was
	          // previously invalid and is now valid,
	          // set its validity
	          if (errorValidity || fieldValue && fieldValue.errors[key]) {
	            nodeErrors[key] = errorValidity;
	          }
	        });
	
	        return nodeErrors;
	      }
	    }, {
	      key: 'setViewValue',
	      value: function setViewValue(viewValue) {
	        if (!this.props.isToggle) {
	          if (this.props.formatter) {
	            var parsedValue = this.parse(viewValue);
	            this.setState({ viewValue: this.format(parsedValue) });
	          } else {
	            this.setState({ viewValue: this.parse(viewValue) });
	          }
	        }
	      }
	    }, {
	      key: 'getValue',
	      value: function getValue(event) {
	        return this.props.getValue(event, this.props);
	      }
	    }, {
	      key: 'handleIntents',
	      value: function handleIntents() {
	        var _this3 = this;
	
	        var _props5 = this.props,
	            model = _props5.model,
	            modelValue = _props5.modelValue,
	            fieldValue = _props5.fieldValue,
	            intents = _props5.fieldValue.intents,
	            controlProps = _props5.controlProps,
	            dispatch = _props5.dispatch,
	            updateOn = _props5.updateOn,
	            _props5$validateOn = _props5.validateOn,
	            validateOn = _props5$validateOn === undefined ? updateOn : _props5$validateOn;
	
	
	        if (!intents.length) return;
	
	        intents.forEach(function (intent) {
	          switch (intent.type) {
	            case _actionTypes2.default.FOCUS:
	              {
	                if (_isNative2.default) return;
	
	                var focused = fieldValue.focus;
	
	                if (focused && _this3.node.focus && (!_this3.props.isToggle || typeof intent.value === 'undefined' || intent.value === controlProps.value)) {
	                  _this3.node.focus();
	
	                  dispatch(_actions2.default.clearIntents(model, intent));
	                }
	
	                return;
	              }
	            case 'validate':
	              if ((0, _containsEvent2.default)(validateOn, 'change')) {
	                _this3.validate({ clearIntents: intent });
	              }
	              return;
	            case 'reset':
	              _this3.setViewValue(modelValue);
	              if (_this3.handleUpdate.cancel) {
	                _this3.handleUpdate.cancel();
	              }
	              dispatch(_actions2.default.clearIntents(model, intent));
	              if ((0, _containsEvent2.default)(validateOn, 'change')) {
	                _this3.validate({});
	              }
	              return;
	
	            case 'load':
	              if (!(0, _shallowEqual2.default)(modelValue, fieldValue.value)) {
	                dispatch(_actions2.default.load(model, fieldValue.value, { clearIntents: intent }));
	              }
	              return;
	
	            default:
	              return;
	          }
	        });
	      }
	    }, {
	      key: 'parse',
	      value: function parse(value) {
	        return this.props.parser ? this.props.parser(value) : value;
	      }
	    }, {
	      key: 'format',
	      value: function format(value) {
	        return this.props.formatter ? this.props.formatter(value) : value;
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(event) {
	        if (event && event.persist) event.persist();
	
	        this.setViewValue(this.getValue(event));
	        this.handleUpdate(event);
	      }
	    }, {
	      key: 'handleKeyPress',
	      value: function handleKeyPress(event) {
	        var _props6 = this.props,
	            onKeyPress = _props6.controlProps.onKeyPress,
	            updateOnEnter = _props6.updateOnEnter;
	
	
	        if (onKeyPress) onKeyPress(event);
	
	        if (updateOnEnter && event.key === 'Enter') {
	          this.forceHandleUpdate(event);
	        }
	      }
	    }, {
	      key: 'handleLoad',
	      value: function handleLoad() {
	        var _props7 = this.props,
	            model = _props7.model,
	            modelValue = _props7.modelValue,
	            fieldValue = _props7.fieldValue,
	            controlProps = _props7.controlProps,
	            onLoad = _props7.onLoad,
	            dispatch = _props7.dispatch,
	            changeAction = _props7.changeAction,
	            parser = _props7.parser;
	
	        var defaultValue = undefined;
	
	        if (controlProps.hasOwnProperty('defaultValue')) {
	          defaultValue = controlProps.defaultValue;
	        } else if (controlProps.hasOwnProperty('defaultChecked')) {
	          defaultValue = controlProps.defaultChecked;
	        } else if (this.props.hasOwnProperty('defaultValue')) {
	          defaultValue = this.props.defaultValue;
	        }
	
	        var loadActions = [this.getValidateAction(defaultValue)];
	
	        if (typeof defaultValue !== 'undefined') {
	          loadActions.push(changeAction(model, defaultValue));
	        } else {
	          if (parser) {
	            var parsedValue = parser(modelValue);
	
	            if (parsedValue !== modelValue) {
	              loadActions.push(changeAction(model, parsedValue));
	            }
	          }
	        }
	
	        (0, _batchActions.dispatchBatchIfNeeded)(model, loadActions, dispatch);
	
	        if (onLoad) onLoad(modelValue, fieldValue, this.node);
	      }
	    }, {
	      key: 'createEventHandler',
	      value: function createEventHandler(eventName) {
	        var _this4 = this;
	
	        var forceUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	        var eventAction = {
	          focus: _actions2.default.silentFocus,
	          blur: _actions2.default.blur
	        }[eventName];
	
	        var dispatchBatchActions = function dispatchBatchActions(persistedEvent) {
	          var _props8 = _this4.props,
	              dispatch = _props8.dispatch,
	              model = _props8.model,
	              updateOn = _props8.updateOn,
	              _props8$validateOn = _props8.validateOn,
	              validateOn = _props8$validateOn === undefined ? updateOn : _props8$validateOn,
	              asyncValidateOn = _props8.asyncValidateOn;
	
	
	          var eventActions = [eventAction && eventAction(model), (forceUpdate || (0, _containsEvent2.default)(validateOn, eventName)) && _this4.getValidateAction(persistedEvent, eventName, forceUpdate), (forceUpdate || (0, _containsEvent2.default)(asyncValidateOn, eventName)) && _this4.getAsyncValidateAction(persistedEvent, eventName), (forceUpdate || (0, _containsEvent2.default)(updateOn, eventName)) && _this4.getChangeAction(persistedEvent)];
	
	          (0, _batchActions.dispatchBatchIfNeeded)(model, eventActions, dispatch);
	
	          return persistedEvent;
	        };
	
	        return function (event) {
	          var _props9 = _this4.props,
	              controlProps = _props9.controlProps,
	              parser = _props9.parser,
	              ignore = _props9.ignore,
	              withField = _props9.withField,
	              fieldValue = _props9.fieldValue;
	
	
	          var controlEventHandler = {
	            focus: controlProps.onFocus,
	            blur: controlProps.onBlur,
	            change: controlProps.onChange
	          }[eventName];
	
	          if ((0, _containsEvent2.default)(ignore, eventName)) {
	            return controlEventHandler ? controlEventHandler(event) : event;
	          }
	
	          if (_this4.props.isToggle) {
	            return (0, _redux.compose)(dispatchBatchActions, (0, _persistEventWithCallback2.default)(controlEventHandler || _identity2.default))(event);
	          }
	
	          return (0, _redux.compose)(dispatchBatchActions, parser, function (e) {
	            return _this4.getValue(e);
	          }, (0, _persistEventWithCallback2.default)(controlEventHandler || _identity2.default))(event, withField ? fieldValue : undefined);
	        };
	      }
	    }, {
	      key: 'attachNode',
	      value: function attachNode() {
	        var node = s.findDOMNode && s.findDOMNode(this);
	
	        if (node) {
	          this.node = node;
	          this.willValidate = node.willValidate;
	        }
	      }
	    }, {
	      key: 'validate',
	      value: function validate(options) {
	        var _props10 = this.props,
	            model = _props10.model,
	            modelValue = _props10.modelValue,
	            fieldValue = _props10.fieldValue,
	            validators = _props10.validators,
	            errorValidators = _props10.errors,
	            dispatch = _props10.dispatch;
	
	
	        if (!validators && !errorValidators && !this.willValidate || !fieldValue) {
	          return;
	        }
	
	        var fieldValidity = (0, _getValidity2.default)(validators, modelValue);
	        var fieldErrors = (0, _getValidity2.default)(errorValidators, modelValue);
	        var nodeErrors = this.getNodeErrors();
	
	        var errors = validators ? (0, _merge2.default)((0, _invertValidity2.default)(fieldValidity), fieldErrors) : fieldErrors;
	
	        if (this.willValidate) {
	          errors = (0, _merge2.default)(errors, nodeErrors);
	        }
	
	        if (!(0, _shallowEqual2.default)(errors, fieldValue.errors)) {
	          dispatch(mergeOrSetErrors(model, errors, options));
	        } else if (options.clearIntents) {
	          dispatch(_actions2.default.clearIntents(model, options.clearIntents));
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props11 = this.props,
	            controlProps = _props11.controlProps,
	            component = _props11.component,
	            control = _props11.control,
	            getRef = _props11.getRef,
	            fieldValue = _props11.fieldValue;
	
	
	        var mappedProps = (0, _omit2.default)(this.getMappedProps(), disallowedProps);
	
	        if (getRef) {
	          mappedProps.getRef = getRef;
	        }
	
	        if (controlProps.withFieldValue) {
	          mappedProps.fieldValue = fieldValue;
	        }
	
	        // If there is an existing control, clone it
	        if (control) {
	          return (0, _react.cloneElement)(control, _extends({}, mappedProps, {
	            defaultValue: undefined,
	            defaultChecked: undefined
	          }), controlProps.children);
	        }
	        return (0, _react.createElement)(_controlStripDefaultsComponent2.default, _extends({
	          component: component
	        }, controlProps, mappedProps));
	      }
	    }]);
	
	    return Control;
	  }(_react.Component);
	
	  Control.displayName = 'Control';
	
	   false ? Control.propTypes = propTypes : void 0;
	
	  Control.defaultProps = {
	    changeAction: s.actions.change,
	    updateOn: 'change',
	    asyncValidateOn: 'blur',
	    parser: _identity2.default,
	    controlProps: emptyControlProps,
	    ignore: [],
	    dynamic: false,
	    component: 'input',
	    withField: true,
	    persist: false,
	    getValue: _getValue3.default,
	    isToggle: false,
	    updateOnEnter: true
	  };
	
	  function mapStateToProps(state, props) {
	    var model = props.model,
	        controlProps = props.controlProps;
	
	
	    var finalControlProps = _extends({}, controlProps, (0, _omit2.default)(props, disallowedPropTypeKeys));
	
	    var modelString = (0, _getModel2.default)(model, state);
	    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
	    var modelValue = s.get(state, modelString);
	
	    return {
	      model: modelString,
	      modelValue: modelValue,
	      fieldValue: fieldValue,
	      controlProps: finalControlProps
	    };
	  }
	
	  var ConnectedControl = (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps, null, null, {
	    areOwnPropsEqual: function areOwnPropsEqual(nextOwnProps, ownProps) {
	      return (0, _shallowEqual2.default)(nextOwnProps, ownProps, {
	        omitKeys: ['mapProps']
	      });
	    },
	    areStatePropsEqual: function areStatePropsEqual(nextStateProps, stateProps) {
	      return (0, _shallowEqual2.default)(nextStateProps, stateProps, {
	        deepKeys: ['controlProps']
	      });
	    }
	  })(Control));
	
	  /* eslint-disable react/prop-types */
	  /* eslint-disable react/no-multi-comp */
	
	  var DefaultConnectedControl = function (_React$Component) {
	    _inherits(DefaultConnectedControl, _React$Component);
	
	    function DefaultConnectedControl() {
	      _classCallCheck(this, DefaultConnectedControl);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControl.__proto__ || Object.getPrototypeOf(DefaultConnectedControl)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControl, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	        return !(0, _shallowEqual2.default)(this.context, nextContext) || !(0, _shallowEqual2.default)(this.props, nextProps, {
	          deepKeys: ['controlProps'],
	          omitKeys: ['mapProps']
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({}, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.default, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControl;
	  }(_react2.default.Component);
	
	  // Copy the context types so that we can properly implement shouldComponentUpdate
	
	
	  DefaultConnectedControl.contextTypes = ConnectedControl.contextTypes;
	
	  DefaultConnectedControl.custom = ConnectedControl;
	
	  var DefaultConnectedControlInput = function (_DefaultConnectedCont) {
	    _inherits(DefaultConnectedControlInput, _DefaultConnectedCont);
	
	    function DefaultConnectedControlInput() {
	      _classCallCheck(this, DefaultConnectedControlInput);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlInput.__proto__ || Object.getPrototypeOf(DefaultConnectedControlInput)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlInput, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'input'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.default, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlInput;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.input = DefaultConnectedControlInput;
	
	  var DefaultConnectedControlText = function (_DefaultConnectedCont2) {
	    _inherits(DefaultConnectedControlText, _DefaultConnectedCont2);
	
	    function DefaultConnectedControlText() {
	      _classCallCheck(this, DefaultConnectedControlText);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlText.__proto__ || Object.getPrototypeOf(DefaultConnectedControlText)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlText, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'input'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.text, {
	            type: this.props.type || 'text'
	          }, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlText;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.text = DefaultConnectedControlText;
	
	  var DefaultConnectedControlPassword = function (_DefaultConnectedCont3) {
	    _inherits(DefaultConnectedControlPassword, _DefaultConnectedCont3);
	
	    function DefaultConnectedControlPassword() {
	      _classCallCheck(this, DefaultConnectedControlPassword);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlPassword.__proto__ || Object.getPrototypeOf(DefaultConnectedControlPassword)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlPassword, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'input'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.text, {
	            type: this.props.type || 'password'
	          }, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlPassword;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.password = DefaultConnectedControlPassword;
	
	  var DefaultConnectedControlTextArea = function (_DefaultConnectedCont4) {
	    _inherits(DefaultConnectedControlTextArea, _DefaultConnectedCont4);
	
	    function DefaultConnectedControlTextArea() {
	      _classCallCheck(this, DefaultConnectedControlTextArea);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlTextArea.__proto__ || Object.getPrototypeOf(DefaultConnectedControlTextArea)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlTextArea, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'textarea',
	          updateOnEnter: false
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.textarea, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlTextArea;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.textarea = DefaultConnectedControlTextArea;
	
	  var DefaultConnectedControlRadio = function (_DefaultConnectedCont5) {
	    _inherits(DefaultConnectedControlRadio, _DefaultConnectedCont5);
	
	    function DefaultConnectedControlRadio() {
	      _classCallCheck(this, DefaultConnectedControlRadio);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlRadio.__proto__ || Object.getPrototypeOf(DefaultConnectedControlRadio)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlRadio, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'input',
	          type: 'radio',
	          isToggle: true
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.radio, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlRadio;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.radio = DefaultConnectedControlRadio;
	
	  var DefaultConnectedControlCheckbox = function (_DefaultConnectedCont6) {
	    _inherits(DefaultConnectedControlCheckbox, _DefaultConnectedCont6);
	
	    function DefaultConnectedControlCheckbox() {
	      _classCallCheck(this, DefaultConnectedControlCheckbox);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlCheckbox.__proto__ || Object.getPrototypeOf(DefaultConnectedControlCheckbox)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlCheckbox, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'input',
	          type: 'checkbox',
	          isToggle: true
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.checkbox, this.props.mapProps),
	          getValue: _getValue2.getCheckboxValue,
	          changeAction: this.props.changeAction || s.actions.checkWithValue
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlCheckbox;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.checkbox = DefaultConnectedControlCheckbox;
	
	  var DefaultConnectedControlFile = function (_DefaultConnectedCont7) {
	    _inherits(DefaultConnectedControlFile, _DefaultConnectedCont7);
	
	    function DefaultConnectedControlFile() {
	      _classCallCheck(this, DefaultConnectedControlFile);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlFile.__proto__ || Object.getPrototypeOf(DefaultConnectedControlFile)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlFile, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'input',
	          type: 'file'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.file, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlFile;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.file = DefaultConnectedControlFile;
	
	  var DefaultConnectedControlSelect = function (_DefaultConnectedCont8) {
	    _inherits(DefaultConnectedControlSelect, _DefaultConnectedCont8);
	
	    function DefaultConnectedControlSelect() {
	      _classCallCheck(this, DefaultConnectedControlSelect);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlSelect.__proto__ || Object.getPrototypeOf(DefaultConnectedControlSelect)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlSelect, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'select'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.select, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlSelect;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.select = DefaultConnectedControlSelect;
	
	  var DefaultConnectedControlButton = function (_DefaultConnectedCont9) {
	    _inherits(DefaultConnectedControlButton, _DefaultConnectedCont9);
	
	    function DefaultConnectedControlButton() {
	      _classCallCheck(this, DefaultConnectedControlButton);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlButton.__proto__ || Object.getPrototypeOf(DefaultConnectedControlButton)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlButton, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'button'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.button, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlButton;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.button = DefaultConnectedControlButton;
	
	  var DefaultConnectedControlReset = function (_DefaultConnectedCont10) {
	    _inherits(DefaultConnectedControlReset, _DefaultConnectedCont10);
	
	    function DefaultConnectedControlReset() {
	      _classCallCheck(this, DefaultConnectedControlReset);
	
	      return _possibleConstructorReturn(this, (DefaultConnectedControlReset.__proto__ || Object.getPrototypeOf(DefaultConnectedControlReset)).apply(this, arguments));
	    }
	
	    _createClass(DefaultConnectedControlReset, [{
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ConnectedControl, _extends({
	          component: 'button',
	          type: 'reset'
	        }, this.props, {
	          mapProps: _extends({}, _controlPropsMap2.default.reset, this.props.mapProps)
	        }));
	      }
	    }]);
	
	    return DefaultConnectedControlReset;
	  }(DefaultConnectedControl);
	
	  DefaultConnectedControl.reset = DefaultConnectedControlReset;
	
	  return DefaultConnectedControl;
	}
	
	exports.createControlClass = createControlClass;
	exports.default = createControlClass;

/***/ },
/* 2790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Prevents the defaultValue/defaultChecked fields from rendering with value/checked
	var ComponentWrapper = function (_Component) {
	  _inherits(ComponentWrapper, _Component);
	
	  function ComponentWrapper() {
	    _classCallCheck(this, ComponentWrapper);
	
	    return _possibleConstructorReturn(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).apply(this, arguments));
	  }
	
	  _createClass(ComponentWrapper, [{
	    key: 'render',
	    value: function render() {
	      /* eslint-disable no-unused-vars */
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          defaultChecked = _props.defaultChecked,
	          component = _props.component,
	          getRef = _props.getRef,
	          otherProps = _objectWithoutProperties(_props, ['defaultValue', 'defaultChecked', 'component', 'getRef']);
	      /* eslint-enable */
	
	      if (getRef) {
	        otherProps.ref = getRef;
	      }
	      var WrappedComponent = component;
	      return _react2.default.createElement(WrappedComponent, otherProps);
	    }
	  }]);
	
	  return ComponentWrapper;
	}(_react.Component);
	
	 false ? ComponentWrapper.propTypes = {
	  component: _propTypes2.default.any,
	  defaultValue: _propTypes2.default.any,
	  defaultChecked: _propTypes2.default.any,
	  getRef: _propTypes2.default.func
	} : void 0;
	exports.default = ComponentWrapper;

/***/ },
/* 2791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFieldClass = exports.controlPropsMap = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _get2 = __webpack_require__(45);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _identity = __webpack_require__(199);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _omit = __webpack_require__(200);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _pick = __webpack_require__(2816);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _reactRedux = __webpack_require__(40);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _actions = __webpack_require__(198);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _controlComponent = __webpack_require__(501);
	
	var _controlComponent2 = _interopRequireDefault(_controlComponent);
	
	var _controlPropsMap2 = __webpack_require__(342);
	
	var _controlPropsMap3 = _interopRequireDefault(_controlPropsMap2);
	
	var _deepCompareChildren = __webpack_require__(1266);
	
	var _deepCompareChildren2 = _interopRequireDefault(_deepCompareChildren);
	
	var _shallowCompareWithoutChildren = __webpack_require__(2817);
	
	var _shallowCompareWithoutChildren2 = _interopRequireDefault(_shallowCompareWithoutChildren);
	
	var _getModel = __webpack_require__(252);
	
	var _getModel2 = _interopRequireDefault(_getModel);
	
	var _getFieldFromState = __webpack_require__(250);
	
	var _getFieldFromState2 = _interopRequireDefault(_getFieldFromState);
	
	var _resolveModel = __webpack_require__(347);
	
	var _resolveModel2 = _interopRequireDefault(_resolveModel);
	
	var _getValue = __webpack_require__(253);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var fieldPropTypes = {
	  model: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	  parser: _propTypes2.default.func,
	  formatter: _propTypes2.default.func,
	  updateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  changeAction: _propTypes2.default.func,
	  validators: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  asyncValidators: _propTypes2.default.object,
	  validateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  asyncValidateOn: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string), _propTypes2.default.string]),
	  errors: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  mapProps: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]),
	  componentMap: _propTypes2.default.object,
	  dynamic: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func,
	  getRef: _propTypes2.default.func,
	
	  // Calculated props
	  fieldValue: _propTypes2.default.object,
	  store: _propTypes2.default.shape({
	    subscribe: _propTypes2.default.func,
	    dispatch: _propTypes2.default.func,
	    getState: _propTypes2.default.func
	  }),
	  storeSubscription: _propTypes2.default.any
	};
	
	function getControlType(control, props, options) {
	  var _controlPropsMap = options.controlPropsMap;
	
	
	  var controlDisplayNames = Object.keys(_controlPropsMap).filter(function (controlKey) {
	    var propsMap = _controlPropsMap[controlKey];
	
	    if ((0, _isPlainObject2.default)(propsMap) && propsMap.component) {
	      return control.type === propsMap.component;
	    }
	
	    return false;
	  });
	
	  if (controlDisplayNames.length) return controlDisplayNames[0];
	
	  try {
	    var controlDisplayName = control.constructor.displayName || control.type.displayName || control.type.name || control.type;
	
	    if (controlDisplayName === 'input') {
	      controlDisplayName = _controlPropsMap[control.props.type] ? control.props.type : 'text';
	    }
	
	    return _controlPropsMap[controlDisplayName] ? controlDisplayName : null;
	  } catch (error) {
	    return undefined;
	  }
	}
	
	var defaultStrategy = {
	  Control: _controlComponent2.default,
	  controlPropTypes: fieldPropTypes,
	  getFieldFromState: _getFieldFromState2.default,
	  actions: _actions2.default
	};
	
	function createFieldClass() {
	  var customControlPropsMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultStrategy;
	
	  // Use the fieldPropTypes if no controlProptypes have been defined to
	  // maintain backwards compatibiltiy.
	  var controlPropTypes = s.controlPropTypes || fieldPropTypes;
	
	  function mapStateToProps(state, props) {
	    var model = props.model;
	
	
	    var modelString = (0, _getModel2.default)(model, state);
	    var fieldValue = s.getFieldFromState(state, modelString) || _initialFieldState2.default;
	
	    return {
	      model: modelString,
	      fieldValue: fieldValue
	    };
	  }
	
	  var options = {
	    controlPropsMap: _extends({}, _controlPropsMap3.default, customControlPropsMap)
	  };
	
	  // TODO: refactor
	  var defaultControlPropsMap = {
	    checkbox: {
	      changeAction: s.actions.checkWithValue,
	      getValue: _getValue.getCheckboxValue,
	      isToggle: true
	    },
	    radio: {
	      isToggle: true
	    }
	  };
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field() {
	      _classCallCheck(this, Field);
	
	      return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        var dynamic = this.props.dynamic;
	
	
	        if (dynamic) {
	          return (0, _deepCompareChildren2.default)(this, nextProps, nextState);
	        }
	
	        return (0, _shallowCompareWithoutChildren2.default)(this, nextProps);
	      }
	    }, {
	      key: 'createControlComponent',
	      value: function createControlComponent(control) {
	        var props = this.props;
	
	
	        if (!control || !control.props || control instanceof _controlComponent2.default) {
	          return control;
	        }
	
	        var controlType = getControlType(control, props, options);
	        var _props$mapProps = props.mapProps,
	            mapProps = _props$mapProps === undefined ? options.controlPropsMap[controlType] : _props$mapProps;
	
	
	        var controlProps = (0, _pick2.default)(props, Object.keys(controlPropTypes));
	
	        if (!mapProps) {
	          return _react2.default.cloneElement(control, null, this.mapChildrenToControl(control.props.children));
	        }
	
	        return _react2.default.createElement(s.Control, _extends({}, controlProps, {
	          control: control,
	          controlProps: control.props,
	          component: control.type,
	          mapProps: mapProps
	        }, defaultControlPropsMap[controlType] || {}));
	      }
	    }, {
	      key: 'mapChildrenToControl',
	      value: function mapChildrenToControl(children) {
	        var _this2 = this;
	
	        if (_react2.default.Children.count(children) > 1) {
	          return _react2.default.Children.map(children, function (child) {
	            return _this2.createControlComponent(child);
	          });
	        }
	
	        return this.createControlComponent(children);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            children = _props.children,
	            fieldValue = _props.fieldValue;
	
	
	        var allowedProps = (0, _omit2.default)(this.props, Object.keys(controlPropTypes));
	        var renderableChildren = typeof children === 'function' ? children(fieldValue) : children;
	
	        if (!component) {
	          (0, _invariant2.default)(_react2.default.Children.count(renderableChildren) === 1, 'Empty wrapper components for <Field> are only possible' + 'when there is a single child. Please check the children' + ('passed into <Field model="' + this.props.model + '">.'));
	
	          return this.createControlComponent(renderableChildren);
	        }
	
	        return _react2.default.createElement(component, allowedProps, this.mapChildrenToControl(renderableChildren));
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  if (false) {
	    process.env.NODE_ENV !== "production" ? Field.propTypes = fieldPropTypes : void 0;
	  }
	
	  Field.defaultProps = {
	    updateOn: 'change',
	    asyncValidateOn: 'blur',
	    parser: _identity2.default,
	    formatter: _identity2.default,
	    changeAction: _actions2.default.change,
	    dynamic: true,
	    component: 'div'
	  };
	
	  return (0, _resolveModel2.default)((0, _reactRedux.connect)(mapStateToProps)(Field));
	}
	
	exports.controlPropsMap = _controlPropsMap3.default;
	exports.createFieldClass = createFieldClass;
	exports.default = createFieldClass(_controlPropsMap3.default);

/***/ },
/* 2792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _formComponent = __webpack_require__(502);
	
	var _formComponent2 = _interopRequireDefault(_formComponent);
	
	var _formsReducer = __webpack_require__(505);
	
	var _formsReducer2 = _interopRequireDefault(_formsReducer);
	
	var _redux = __webpack_require__(56);
	
	var _omit = __webpack_require__(200);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LocalForm = function (_React$Component) {
	  _inherits(LocalForm, _React$Component);
	
	  function LocalForm(props) {
	    _classCallCheck(this, LocalForm);
	
	    var _this = _possibleConstructorReturn(this, (LocalForm.__proto__ || Object.getPrototypeOf(LocalForm)).call(this, props));
	
	    _this.store = props.store || (0, _redux.createStore)((0, _formsReducer2.default)(_defineProperty({}, props.model, props.initialState)));
	
	    _this.dispatch = function (action) {
	      if (typeof action === 'function') {
	        return action(_this.store.dispatch, _this.store.getState);
	      }
	
	      return _this.store.dispatch(action);
	    };
	    return _this;
	  }
	
	  _createClass(LocalForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.getDispatch) {
	        this.props.getDispatch(this.dispatch);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var allowedProps = (0, _omit2.default)(this.props, ['store', 'initialState']);
	
	      return _react2.default.createElement(_formComponent2.default, _extends({ store: this.store }, allowedProps));
	    }
	  }]);
	
	  return LocalForm;
	}(_react2.default.Component);
	
	LocalForm.displayName = 'LocalForm';
	
	 false ? LocalForm.propTypes = {
	  store: _propTypes2.default.shape({
	    subscribe: _propTypes2.default.func,
	    dispatch: _propTypes2.default.func,
	    getState: _propTypes2.default.func
	  }),
	
	  // provided props
	  initialState: _propTypes2.default.any,
	  model: _propTypes2.default.string.isRequired,
	  getDispatch: _propTypes2.default.func
	} : void 0;
	
	LocalForm.defaultProps = {
	  initialState: {},
	  model: 'local'
	};
	
	exports.default = LocalForm;

/***/ },
/* 2793 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var validityKeys = ['badInput', 'customError', 'patternMismatch', 'rangeOverflow', 'rangeUnderflow', 'stepMismatch', 'tooLong', 'tooShort', 'typeMismatch', 'valueMissing'];
	
	exports.default = validityKeys;

/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isRetouched = exports.isTouched = exports.isPending = exports.isValid = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = formSelector;
	
	var _isValid = __webpack_require__(247);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isPending = __webpack_require__(2795);
	
	var _isPending2 = _interopRequireDefault(_isPending);
	
	var _isTouched = __webpack_require__(2798);
	
	var _isTouched2 = _interopRequireDefault(_isTouched);
	
	var _isRetouched = __webpack_require__(2797);
	
	var _isRetouched2 = _interopRequireDefault(_isRetouched);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function formSelector(formState) {
	  return _extends({}, formState, {
	    get valid() {
	      return (0, _isValid2.default)(formState);
	    },
	    get pending() {
	      return (0, _isPending2.default)(formState);
	    },
	    get touched() {
	      return (0, _isTouched2.default)(formState);
	    },
	    get retouched() {
	      return (0, _isRetouched2.default)(formState);
	    }
	  });
	}
	
	exports.isValid = _isValid2.default;
	exports.isPending = _isPending2.default;
	exports.isTouched = _isTouched2.default;
	exports.isRetouched = _isRetouched2.default;

/***/ },
/* 2795 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPending;
	function isPending(formState) {
	  if (!formState) return false;
	
	  // Field is pending
	  if (!formState.$form) {
	    return formState.pending;
	  }
	
	  // Any field in form is pending
	  return Object.keys(formState).some(function (key) {
	    return isPending(formState[key]);
	  });
	}

/***/ },
/* 2796 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPristine;
	function isPristine(formState) {
	  if (!formState) return false;
	
	  // Form is pristine
	  if (!formState.$form) {
	    return formState.pristine;
	  }
	
	  // Every field in form is pristine
	  return Object.keys(formState).every(function (key) {
	    if (key === '$form') return true;
	
	    return isPristine(formState[key]);
	  });
	}

/***/ },
/* 2797 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isRetouched;
	function isRetouched(formState) {
	  if (!formState) return false;
	
	  // Field is pending
	  if (!formState.$form) {
	    return formState.retouched;
	  }
	
	  // Any field in form is pending
	  return Object.keys(formState).some(function (key) {
	    return isRetouched(formState[key]);
	  });
	}

/***/ },
/* 2798 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isTouched;
	function isTouched(formState) {
	  if (!formState) return false;
	
	  // Field is touched
	  if (!formState.$form) {
	    return formState.touched;
	  }
	
	  // Any field in form is touched
	  return Object.keys(formState).some(function (key) {
	    return isTouched(formState[key]);
	  });
	}

/***/ },
/* 2799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.track = exports.getFormStateKey = exports.getForm = exports.getField = exports.form = exports.batched = exports.modeled = exports.createFieldClass = exports.Fieldset = exports.Errors = exports.Form = exports.Control = exports.Field = exports.controls = exports.actionTypes = exports.actions = exports.initialFieldState = exports.createForms = exports.combineForms = exports.modelReducer = exports.formReducer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _modelReducer = __webpack_require__(344);
	
	var _formReducer = __webpack_require__(248);
	
	var _formReducer2 = _interopRequireDefault(_formReducer);
	
	var _modeledEnhancer = __webpack_require__(504);
	
	var _modelActions = __webpack_require__(1260);
	
	var _controlPropsMap = __webpack_require__(342);
	
	var _controlPropsMap2 = _interopRequireDefault(_controlPropsMap);
	
	var _formsReducer = __webpack_require__(505);
	
	var _errorsComponent = __webpack_require__(1261);
	
	var _controlComponent = __webpack_require__(501);
	
	var _formComponent = __webpack_require__(502);
	
	var _fieldActions = __webpack_require__(500);
	
	var _track = __webpack_require__(255);
	
	var _fieldsetComponent = __webpack_require__(1262);
	
	var _fieldsetComponent2 = _interopRequireDefault(_fieldsetComponent);
	
	var _batchActions = __webpack_require__(341);
	
	var _batchActions2 = _interopRequireDefault(_batchActions);
	
	var _getValue = __webpack_require__(253);
	
	var _getValue2 = _interopRequireDefault(_getValue);
	
	var _getFromImmutableState = __webpack_require__(2808);
	
	var _getFromImmutableState2 = _interopRequireDefault(_getFromImmutableState);
	
	var _getForm = __webpack_require__(251);
	
	var _getForm2 = _interopRequireDefault(_getForm);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _findKeyImmutable = __webpack_require__(2804);
	
	var _findKeyImmutable2 = _interopRequireDefault(_findKeyImmutable);
	
	var _immutable = __webpack_require__(35);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactDom = __webpack_require__(14);
	
	var _index = __webpack_require__(1263);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function immutableSet(state, path, value) {
	  try {
	    return state.setIn(path, value);
	  } catch (error) {
	    throw new Error('Unable to set path \'' + path.join('.') + '\' in state. Please make sure that state is an Immutable instance.');
	  }
	}
	
	function immutableKeys(state) {
	  if (_immutable2.default.Map.isMap(state)) {
	    return state.keySeq();
	  }
	  return Object.keys(state);
	}
	
	var baseStrategy = {
	  get: _getFromImmutableState2.default,
	  set: immutableSet,
	  getValue: _getValue2.default,
	  keys: immutableKeys,
	  splice: function splice(list) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return list.splice.apply(list, args);
	  },
	  merge: function merge(map) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    return map.merge.apply(map, args);
	  },
	  remove: function remove(map) {
	    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	      args[_key3 - 1] = arguments[_key3];
	    }
	
	    return map.remove.apply(map, args);
	  },
	  push: function push(list) {
	    for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	      args[_key4 - 1] = arguments[_key4];
	    }
	
	    return list.push.apply(list, args);
	  },
	  length: function length(list) {
	    return list.size;
	  },
	  object: new _immutable2.default.Map(),
	  array: new _immutable2.default.List(),
	  isObject: function isObject(state) {
	    return (0, _isPlainObject2.default)(state) || _immutable2.default.Map.isMap(state);
	  }
	};
	
	function immutableGetForm(state, modelString) {
	  return (0, _getForm2.default)(state, modelString, baseStrategy);
	}
	
	function immutableGetFormStateKey(state, model) {
	  return (0, _getForm.getFormStateKey)(state, model, baseStrategy);
	}
	
	function immutableGetFieldFromState(state, modelString) {
	  return (0, _index.getField)(state, modelString, { getForm: immutableGetForm });
	}
	
	var immutableStrategy = _extends({}, baseStrategy, {
	  getForm: immutableGetForm,
	  getFieldFromState: immutableGetFieldFromState,
	  findKey: _findKeyImmutable2.default
	});
	
	function transformAction(action) {
	  if (action.value && action.value.toJS) {
	    return _extends({}, action, {
	      value: action.value.toJS()
	    });
	  }
	
	  if (action.actions) {
	    return _extends({}, action, {
	      actions: action.actions.map(transformAction)
	    });
	  }
	
	  return action;
	}
	
	function immutableFormReducer(model) {
	  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new _immutable2.default.Map();
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var _initialState = initialState && initialState.toJS ? initialState.toJS() : initialState;
	
	  return (0, _formReducer2.default)(model, _initialState, _extends({}, options, {
	    transformAction: transformAction
	  }));
	}
	
	var immutableModelActions = (0, _modelActions.createModelActions)(immutableStrategy);
	var immutableFieldActions = (0, _fieldActions.createFieldActions)(immutableStrategy);
	
	var immutableActions = _extends({}, immutableModelActions, immutableFieldActions, {
	  batch: _batchActions2.default
	});
	
	var immutableModelReducer = (0, _modelReducer.createModeler)(immutableStrategy);
	var immutableModelReducerEnhancer = (0, _modeledEnhancer.createModelReducerEnhancer)(immutableModelReducer);
	var ImmutableControl = (0, _controlComponent.createControlClass)({
	  get: _getFromImmutableState2.default,
	  getFieldFromState: immutableGetFieldFromState,
	  actions: immutableModelActions,
	  findDOMNode: _reactDom.findDOMNode
	});
	var ImmutableField = (0, _index.createFieldClass)(_controlPropsMap2.default, {
	  Control: ImmutableControl,
	  getter: _getFromImmutableState2.default,
	  getFieldFromState: immutableGetFieldFromState,
	  changeAction: immutableModelActions.change,
	  actions: immutableModelActions
	});
	var ImmutableErrors = (0, _errorsComponent.createErrorsClass)(immutableStrategy);
	var ImmutableForm = (0, _formComponent.createFormClass)(_extends({}, immutableStrategy, {
	  actions: immutableActions
	}));
	
	var immutableFormCombiner = (0, _formsReducer.createFormCombiner)({
	  modelReducer: immutableModelReducer,
	  formReducer: immutableFormReducer,
	  modeled: immutableModelReducerEnhancer,
	  toJS: function toJS(val) {
	    return val && val.toJS ? val.toJS() : val;
	  }
	});
	
	var immutableCombineForms = immutableFormCombiner.combineForms;
	var immutableCreateForms = immutableFormCombiner.createForms;
	
	var immutableTrack = (0, _track.createTrack)(immutableStrategy);
	
	exports.formReducer = immutableFormReducer;
	exports.modelReducer = immutableModelReducer;
	exports.combineForms = immutableCombineForms;
	exports.createForms = immutableCreateForms;
	exports.initialFieldState = _index.initialFieldState;
	exports.actions = immutableActions;
	exports.actionTypes = _index.actionTypes;
	exports.controls = _controlPropsMap2.default;
	exports.Field = ImmutableField;
	exports.Control = ImmutableControl;
	exports.Form = ImmutableForm;
	exports.Errors = ImmutableErrors;
	exports.Fieldset = _fieldsetComponent2.default;
	exports.createFieldClass = _index.createFieldClass;
	exports.modeled = immutableModelReducerEnhancer;
	exports.batched = _index.batched;
	exports.form = _index.form;
	exports.getField = immutableGetFieldFromState;
	exports.getForm = immutableGetForm;
	exports.getFormStateKey = immutableGetFormStateKey;
	exports.track = immutableTrack;

/***/ },
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createFormActionsReducer = createFormActionsReducer;
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _updateField = __webpack_require__(2819);
	
	var _updateField2 = _interopRequireDefault(_updateField);
	
	var _updateParentForms = __webpack_require__(2820);
	
	var _updateParentForms2 = _interopRequireDefault(_updateParentForms);
	
	var _updateSubFields = __webpack_require__(2821);
	
	var _updateSubFields2 = _interopRequireDefault(_updateSubFields);
	
	var _getFieldForm = __webpack_require__(2806);
	
	var _getFieldForm2 = _interopRequireDefault(_getFieldForm);
	
	var _isPristine = __webpack_require__(2796);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _map = __webpack_require__(1269);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _inverse = __webpack_require__(2809);
	
	var _inverse2 = _interopRequireDefault(_inverse);
	
	var _mergeValidity = __webpack_require__(1270);
	
	var _mergeValidity2 = _interopRequireDefault(_mergeValidity);
	
	var _isValid = __webpack_require__(247);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _isValidityValid = __webpack_require__(1268);
	
	var _isValidityValid2 = _interopRequireDefault(_isValidityValid);
	
	var _isValidityInvalid = __webpack_require__(509);
	
	var _isValidityInvalid2 = _interopRequireDefault(_isValidityInvalid);
	
	var _fieldActions = __webpack_require__(500);
	
	var _fieldActions2 = _interopRequireDefault(_fieldActions);
	
	var _toPath = __webpack_require__(254);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _createField = __webpack_require__(345);
	
	var _assocIn = __webpack_require__(249);
	
	var _assocIn2 = _interopRequireDefault(_assocIn);
	
	var _getFormValue = __webpack_require__(1267);
	
	var _getFormValue2 = _interopRequireDefault(_getFormValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var resetFieldState = function resetFieldState(field, customInitialFieldState) {
	  if (!(0, _isPlainObject2.default)(field)) return field;
	
	  var intents = [{ type: 'reset' }];
	  var resetValue = (0, _createField.getMeta)(field, 'initialValue');
	  var loadedValue = (0, _createField.getMeta)(field, 'loadedValue');
	
	  if (loadedValue && resetValue !== loadedValue) {
	    intents.push({ type: 'load' });
	    resetValue = loadedValue;
	  }
	  return (0, _createField.fieldOrForm)((0, _createField.getMeta)(field, 'model'), resetValue, _extends({}, customInitialFieldState, { intents: intents }));
	};
	
	var setInitialFieldState = function setInitialFieldState(customInitialFieldState) {
	  return function (field) {
	    if (!(0, _isPlainObject2.default)(field)) return field;
	
	    if (field.$form) {
	      // eslint-disable-next-line arrow-body-style
	      return (0, _mapValues2.default)(field, function (fieldState, key) {
	        return key === '$form' ? (0, _createField.updateFieldState)(customInitialFieldState, {
	          value: field.value,
	          model: field.model
	        }) : resetFieldState(fieldState, customInitialFieldState);
	      });
	    }
	
	    return (0, _createField.updateFieldState)(customInitialFieldState, {
	      value: field.value,
	      model: field.model
	    });
	  };
	};
	
	var addIntent = function addIntent(intents, newIntent) {
	  if (!intents) return [newIntent];
	  if (intents.some(function (intent) {
	    return intent.type === newIntent.type;
	  })) return intents;
	
	  return intents.concat(newIntent);
	};
	
	var clearIntents = function clearIntents(intents, oldIntent) {
	  if (!intents || typeof oldIntent === 'undefined') return [];
	  return intents.filter(function (intent) {
	    return intent.type !== oldIntent.type;
	  });
	};
	
	var defaultOptions = {
	  initialFieldState: _initialFieldState2.default
	};
	
	function createFormActionsReducer(options) {
	  var formOptions = options ? _extends({}, defaultOptions, options, {
	    initialFieldState: _extends({}, defaultOptions.initialFieldState, options.initialFieldState)
	  }) : defaultOptions;
	
	  var customInitialFieldState = formOptions.initialFieldState;
	
	  return function formActionsReducer(state, action, localPath) {
	    var _getFieldAndForm = (0, _updateField.getFieldAndForm)(state, localPath),
	        _getFieldAndForm2 = _slicedToArray(_getFieldAndForm, 1),
	        field = _getFieldAndForm2[0];
	
	    var fieldState = field && field.$form ? field.$form : field;
	
	    var intents = fieldState.intents;
	
	
	    var fieldUpdates = {};
	    var subFieldUpdates = {};
	    var parentFormUpdates = void 0;
	
	    switch (action.type) {
	      case _actionTypes2.default.FOCUS:
	        {
	          fieldUpdates = {
	            focus: true,
	            intents: action.silent ? intents : addIntent(intents, action)
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.BLUR:
	      case _actionTypes2.default.SET_TOUCHED:
	        {
	          var fieldForm = (0, _getFieldForm2.default)(state, localPath).$form;
	
	          fieldUpdates = {
	            focus: action.type === _actionTypes2.default.BLUR ? false : field.focus,
	            touched: true,
	            retouched: fieldForm ? !!(fieldForm.submitted || fieldForm.submitFailed) : false
	          };
	
	          parentFormUpdates = {
	            touched: true,
	            retouched: fieldUpdates.retouched
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_UNTOUCHED:
	        {
	          fieldUpdates = {
	            focus: false,
	            touched: false
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_PRISTINE:
	      case _actionTypes2.default.SET_DIRTY:
	        {
	          var pristine = action.type === _actionTypes2.default.SET_PRISTINE;
	
	          fieldUpdates = {
	            pristine: pristine
	          };
	
	          subFieldUpdates = {
	            pristine: pristine
	          };
	
	          parentFormUpdates = function parentFormUpdates(form) {
	            return { pristine: (0, _isPristine2.default)(form) };
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_VALIDATING:
	        {
	          fieldUpdates = {
	            validating: action.validating,
	            validated: !action.validating
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_VALIDITY:
	      case _actionTypes2.default.SET_ERRORS:
	        {
	          var _fieldUpdates;
	
	          var isErrors = action.type === _actionTypes2.default.SET_ERRORS;
	          var validity = void 0;
	          if (isErrors) {
	            validity = action.merge ? (0, _mergeValidity2.default)(fieldState.errors, action.errors) : action.errors;
	          } else {
	            validity = action.merge ? (0, _mergeValidity2.default)(fieldState.validity, action.validity) : action.validity;
	          }
	
	          var inverseValidity = (0, _isPlainObject2.default)(validity) ? (0, _mapValues2.default)(validity, _inverse2.default) : !validity;
	
	          // If the field is a form, its validity is
	          // also based on whether its fields are all valid.
	          var areFieldsValid = field && field.$form ? (0, _isValid.fieldsValid)(field, { async: false }) : true;
	
	          fieldUpdates = (_fieldUpdates = {}, _defineProperty(_fieldUpdates, isErrors ? 'errors' : 'validity', validity), _defineProperty(_fieldUpdates, isErrors ? 'validity' : 'errors', inverseValidity), _defineProperty(_fieldUpdates, 'validating', false), _defineProperty(_fieldUpdates, 'validated', true), _defineProperty(_fieldUpdates, 'valid', areFieldsValid && (isErrors ? !(0, _isValidityInvalid2.default)(validity) : (0, _isValidityValid2.default)(validity))), _fieldUpdates);
	
	          if (action.async) {
	            var actionValidity = isErrors ? action.errors : action.validity;
	
	            fieldUpdates.asyncKeys = (0, _isPlainObject2.default)(actionValidity) || Array.isArray(actionValidity) ? Object.keys(actionValidity) : true;
	          }
	
	          parentFormUpdates = function parentFormUpdates(form) {
	            return { valid: (0, _isValid2.default)(form) };
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_FIELDS_VALIDITY:
	        {
	          return (0, _map2.default)(action.fieldsValidity, function (fieldValidity, subField) {
	            return _fieldActions2.default.setValidity(subField, fieldValidity, action.options);
	          }).reduce(function (accState, subAction) {
	            return formActionsReducer(accState, subAction, localPath.concat((0, _toPath2.default)(subAction.model)));
	          }, state);
	        }
	
	      case _actionTypes2.default.RESET_VALIDITY:
	        {
	          var _validity = _extends({}, fieldState.validity);
	          var errors = _extends({}, fieldState.errors);
	          var valid = void 0;
	
	          if (action.omitKeys) {
	            action.omitKeys.forEach(function (key) {
	              delete _validity[key];
	              delete errors[key];
	            });
	            valid = (0, _isValidityValid2.default)(_validity);
	          } else {
	            _validity = customInitialFieldState.validity;
	            errors = customInitialFieldState.errors;
	            valid = customInitialFieldState.valid;
	          }
	
	          fieldUpdates = {
	            valid: valid,
	            validity: _validity,
	            errors: errors
	          };
	
	          subFieldUpdates = {
	            valid: customInitialFieldState.valid,
	            validity: customInitialFieldState.validity,
	            errors: customInitialFieldState.errors
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_PENDING:
	        {
	          fieldUpdates = {
	            pending: action.pending,
	            submitted: false,
	            submitFailed: false,
	            retouched: false
	          };
	
	          subFieldUpdates = {
	            pending: action.pending,
	            submitted: false,
	            submitFailed: false,
	            retouched: false
	          };
	
	          parentFormUpdates = { pending: action.pending };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_SUBMITTED:
	        {
	          var submitted = !!action.submitted;
	
	          fieldUpdates = {
	            pending: false,
	            submitted: submitted,
	            submitFailed: submitted ? false : fieldState && fieldState.submitFailed,
	            touched: true,
	            retouched: false
	          };
	
	          subFieldUpdates = {
	            submitted: submitted,
	            submitFailed: submitted ? false : fieldUpdates.submitFailed,
	            retouched: false
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.SET_SUBMIT_FAILED:
	        {
	          fieldUpdates = {
	            pending: false,
	            submitted: fieldState.submitted && !action.submitFailed,
	            submitFailed: !!action.submitFailed,
	            touched: true,
	            retouched: false
	          };
	
	          subFieldUpdates = {
	            pending: false,
	            submitted: !action.submitFailed,
	            submitFailed: !!action.submitFailed,
	            touched: true,
	            retouched: false
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.RESET:
	        {
	          return localPath.length ? (0, _assocIn2.default)(state, localPath, resetFieldState(field, customInitialFieldState)) : resetFieldState(field, customInitialFieldState);
	        }
	
	      case _actionTypes2.default.SET_INITIAL:
	        {
	          var setCustomInitialFieldState = setInitialFieldState(customInitialFieldState);
	
	          return (0, _updateField2.default)(state, localPath, setCustomInitialFieldState, setCustomInitialFieldState);
	        }
	
	      case _actionTypes2.default.ADD_INTENT:
	        {
	          fieldUpdates = {
	            intents: addIntent(intents, action.intent)
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.CLEAR_INTENTS:
	        {
	          fieldUpdates = {
	            intents: clearIntents(intents, action.intent)
	          };
	
	          break;
	        }
	
	      case _actionTypes2.default.CHANGE:
	        {
	          return (0, _updateParentForms2.default)(state, localPath, function (parentForm) {
	            var formModelValue = (0, _getFormValue2.default)(parentForm);
	
	            if (!parentForm.$form) {
	              return _extends({}, customInitialFieldState, {
	                value: formModelValue,
	                initialValue: formModelValue
	              });
	            }
	
	            // If the form is invalid (due to async validity)
	            // but its fields are valid and the value has changed,
	            // the form should be "valid" again.
	            if ((!parentForm.$form.validity || typeof parentForm.$form.validity === 'boolean' || !Object.keys(parentForm.$form.validity).length) && !parentForm.$form.valid && (0, _isValid2.default)(parentForm, { async: false })) {
	              return {
	                value: formModelValue,
	                validity: true,
	                errors: false,
	                valid: true
	              };
	            }
	
	            return {
	              value: formModelValue
	            };
	          });
	        }
	
	      default:
	        return state;
	    }
	
	    if (action.clearIntents) {
	      fieldUpdates.intents = clearIntents(intents, action.clearIntents);
	    }
	
	    var updatedField = (0, _updateField2.default)(state, localPath, fieldUpdates);
	    var updatedSubFields = Object.keys(subFieldUpdates).length ? (0, _updateSubFields2.default)(updatedField, localPath, subFieldUpdates) : updatedField;
	    var updatedParentForms = parentFormUpdates ? (0, _updateParentForms2.default)(updatedSubFields, localPath, parentFormUpdates) : updatedSubFields;
	
	    return updatedParentForms;
	  };
	}
	
	exports.default = createFormActionsReducer();

/***/ },
/* 2801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = changeActionReducer;
	
	var _actionTypes = __webpack_require__(113);
	
	var _actionTypes2 = _interopRequireDefault(_actionTypes);
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _shallowEqual = __webpack_require__(201);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _formReducer = __webpack_require__(248);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	var _assocIn = __webpack_require__(249);
	
	var _assocIn2 = _interopRequireDefault(_assocIn);
	
	var _getFormValue = __webpack_require__(1267);
	
	var _getFormValue2 = _interopRequireDefault(_getFormValue);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateFieldValue(field, action) {
	  var parentModel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
	  var value = action.value,
	      removeKeys = action.removeKeys,
	      silent = action.silent,
	      load = action.load,
	      model = action.model,
	      external = action.external;
	
	
	  var fieldState = field && field.$form ? field.$form : field;
	
	  var changedFieldProps = {
	    validated: false,
	    retouched: fieldState.submitted ? true : fieldState.retouched,
	    // If change originated from Control component (not externally),
	    // then there is no need to remind Control to validate itself.
	    intents: external ? [{ type: 'validate' }] : [],
	    pristine: silent ? fieldState.pristine : false,
	    value: value,
	    loadedValue: load ? value : fieldState.loadedValue
	  };
	
	  if ((0, _shallowEqual2.default)(field.value, value)) {
	    return _icepick2.default.merge(field, changedFieldProps);
	  }
	
	  if (removeKeys) {
	    (0, _invariant2.default)(field && field.$form, 'Unable to remove keys. ' + 'Field for "%s" in store is not an array/object.', model);
	
	    var valueIsArray = Array.isArray(field.$form.value);
	    var removeKeysArray = Array.isArray(removeKeys) ? removeKeys : [removeKeys];
	
	    var result = void 0;
	
	    if (valueIsArray) {
	      result = [];
	
	      Object.keys(field).forEach(function (key) {
	        if (!!~removeKeysArray.indexOf(+key) || key === '$form') return;
	
	        result[key] = _extends({}, field[key]);
	      });
	
	      var finalResult = _extends({}, result.filter(function (f) {
	        return f;
	      }).map(function (subField, index) {
	        return _extends({}, subField, {
	          model: model + '.' + index
	        });
	      }));
	
	      finalResult.$form = field.$form;
	
	      return finalResult;
	    }
	
	    result = _extends({}, field);
	
	    Object.keys(field).forEach(function (key) {
	      if (!!~removeKeysArray.indexOf(key)) {
	        delete result['' + key];
	      }
	    });
	
	    return result;
	  }
	
	  if (!Array.isArray(value) && !(0, _isPlainObject2.default)(value)) {
	    return _icepick2.default.merge(field, _icepick2.default.set(changedFieldProps, 'value', value));
	  }
	
	  var updatedField = (0, _mapValues2.default)(value, function (subValue, index) {
	    // TODO: refactor
	    var subField = field[index] || (0, _formReducer.createInitialState)('' + (parentModel ? parentModel + '.' : '') + model + '.' + index, subValue);
	
	    if (Object.hasOwnProperty.call(subField, '$form')) {
	      return updateFieldValue(subField, {
	        model: index,
	        value: subValue,
	        external: external,
	        silent: silent,
	        load: load
	      }, parentModel ? parentModel + '.' + model : model);
	    }
	
	    if ((0, _shallowEqual2.default)(subValue, subField.value)) {
	      return subField;
	    }
	
	    return _icepick2.default.merge(subField, _icepick2.default.assign(changedFieldProps, {
	      value: subValue,
	      loadedValue: load ? subValue : subField.loadedValue
	    }));
	  });
	
	  var dirtyFormState = _icepick2.default.merge(field.$form || _initialFieldState2.default, _icepick2.default.set(changedFieldProps, 'retouched', field.submitted || field.$form && field.$form.retouched));
	
	  return _icepick2.default.set(updatedField, '$form', dirtyFormState);
	}
	
	function changeActionReducer(state, action, localPath) {
	  if (action.type !== _actionTypes2.default.CHANGE) return state;
	
	  var field = (0, _get2.default)(state, localPath, (0, _formReducer.createInitialState)(action.model, action.value));
	
	  var updatedField = updateFieldValue(field, action);
	
	  if (!localPath.length) return updatedField;
	
	  var updatedState = (0, _assocIn2.default)(state, localPath, updatedField, function (form) {
	    if (!form.$form) return form;
	
	    var formValue = (0, _getFormValue2.default)(form);
	
	    var formUpdates = _extends({}, form.$form, {
	      value: formValue
	    });
	
	    if (action.silent) {
	      formUpdates.loadedValue = formValue;
	    } else {
	      formUpdates.pristine = false;
	    }
	
	    return _extends({}, form, {
	      $form: formUpdates
	    });
	  });
	
	  return updatedState;
	}

/***/ },
/* 2802 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (state, action) {
	    return reducers.reduceRight(function (prevState, reducer) {
	      return reducer(prevState, action);
	    }, state);
	  };
	}

/***/ },
/* 2803 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	function debounce(func, delay) {
	  var timeout = void 0;
	  var laterFunc = void 0;
	
	  var createLaterFunc = function createLaterFunc(args) {
	    return function () {
	      timeout = null;
	      func.apply(null, args);
	
	      // Only run the deferred function once
	      laterFunc = undefined;
	    };
	  };
	
	  var debouncedFunc = function debouncedFunc() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    clearTimeout(timeout);
	    laterFunc = createLaterFunc(args);
	    timeout = setTimeout(laterFunc, delay);
	  };
	
	  debouncedFunc.flush = function () {
	    clearTimeout(timeout);
	    if (laterFunc) laterFunc();
	  };
	
	  debouncedFunc.cancel = function () {
	    clearTimeout(timeout);
	    laterFunc = undefined;
	  };
	
	  return debouncedFunc;
	}

/***/ },
/* 2804 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findKey;
	function findKey(object, predicate) {
	  return object.findKey(predicate);
	}

/***/ },
/* 2805 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findKey;
	function findKey(object, predicate) {
	  var resultKey = void 0;
	
	  Object.keys(object).some(function (key) {
	    var isKey = predicate(object[key], key, object);
	
	    if (isKey) {
	      resultKey = key;
	      return true;
	    }
	
	    return false;
	  });
	
	  return resultKey;
	}

/***/ },
/* 2806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getFieldForm;
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getFieldForm(state, path) {
	  var formPath = path.slice(0, -1);
	
	  if (!formPath.length) return state;
	
	  var form = (0, _get2.default)(state, formPath);
	
	  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', formPath.join('.'));
	
	  return form;
	}

/***/ },
/* 2807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getField;
	
	var _isPlainObject = __webpack_require__(54);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _initialFieldState = __webpack_require__(134);
	
	var _initialFieldState2 = _interopRequireDefault(_initialFieldState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getField(state, path) {
	  if (false) {
	    if (!(0, _isPlainObject2.default)(state)) {
	      throw new Error('Could not retrieve field \'' + path + '\' ' + 'from an invalid/empty form state.');
	    }
	  }
	
	  var result = (0, _get2.default)(state, path, _initialFieldState2.default);
	
	  if ('$form' in result) return result.$form;
	
	  return result;
	}

/***/ },
/* 2808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = immutableGetFromState;
	
	var _toPath = __webpack_require__(254);
	
	var _toPath2 = _interopRequireDefault(_toPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function immutableGetFromState(state, modelString) {
	  var path = (0, _toPath2.default)(modelString);
	
	  return path.reduce(function (subState, subPath) {
	    if (!subState || typeof subState === 'string') return subState;
	
	    // Current subState is immutable
	    if ((typeof subState === 'undefined' ? 'undefined' : _typeof(subState)) === 'object' && 'get' in subState) {
	      return subState.get(subPath);
	    }
	
	    // Current subState is a plain object/array
	    return subState[subPath];
	  }, state);
	}

/***/ },
/* 2809 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inverse;
	function inverse(value) {
	  return !value;
	}

/***/ },
/* 2810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = invertValidators;
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _invertValidity = __webpack_require__(508);
	
	var _invertValidity2 = _interopRequireDefault(_invertValidity);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function invertValidators(validators) {
	  if (typeof validators === 'function') {
	    return function (val) {
	      return (0, _invertValidity2.default)(validators(val));
	    };
	  }
	
	  return (0, _mapValues2.default)(validators, invertValidators);
	}

/***/ },
/* 2811 */
1356,
/* 2812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeDeep;
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mergeDeep(target, source) {
	  return _icepick2.default.merge(target, source);
	}

/***/ },
/* 2813 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = partition;
	function partition(collection, predicate) {
	  var result = [[], []];
	
	  collection.forEach(function (item, index) {
	    if (predicate(item, index, collection)) {
	      result[0].push(item);
	    } else {
	      result[1].push(item);
	    }
	  });
	
	  return result;
	}

/***/ },
/* 2814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pathStartsWith;
	exports.pathDifference = pathDifference;
	
	var _lodash = __webpack_require__(975);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function pathStartsWith(pathString, subPathString) {
	  if (pathString === subPathString) return true;
	
	  var path = (0, _lodash2.default)(pathString);
	  var subPath = (0, _lodash2.default)(subPathString);
	
	  var startsWithSubPath = subPath.every(function (segment, index) {
	    return path[index] === segment;
	  });
	
	  return startsWithSubPath;
	}
	
	function pathDifference(pathString, subPathString) {
	  if (pathString === subPathString) return [];
	
	  var path = (0, _lodash2.default)(pathString);
	  var subPath = (0, _lodash2.default)(subPathString);
	
	  var difference = path.reduce(function (acc, segment, index) {
	    if (segment === subPath[index]) return acc;
	
	    acc.push(segment);
	
	    return acc;
	  }, []);
	
	  return difference;
	}

/***/ },
/* 2815 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = persistEventWithCallback;
	function persistEventWithCallback(callback) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (event && event.persist) {
	      event.persist();
	    }
	
	    callback.apply(undefined, [event].concat(args));
	    return event;
	  };
	}

/***/ },
/* 2816 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = pick;
	function pick(object, props) {
	  var result = {};
	
	  for (var i = 0; i < props.length; i++) {
	    var prop = props[i];
	    result[prop] = object[prop];
	  }
	
	  return result;
	}

/***/ },
/* 2817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = shallowCompareWithoutChildren;
	
	var _react = __webpack_require__(1);
	
	var _shallowEqual = __webpack_require__(201);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowCompareWithoutChildren(instance, nextProps) {
	  return !(0, _shallowEqual2.default)(instance.props, nextProps, { omitKeys: ['children'] }) || _react.Children.count(instance.props.children) !== _react.Children.count(nextProps.children);
	}

/***/ },
/* 2818 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toArray;
	function toArray(object) {
	  var result = [];
	  Object.keys(object).forEach(function (key) {
	    if (object.hasOwnProperty(key)) {
	      result.push(object[key]);
	    }
	  });
	  return result;
	}

/***/ },
/* 2819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.getFieldAndForm = getFieldAndForm;
	exports.default = updateField;
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _mapValues = __webpack_require__(90);
	
	var _mapValues2 = _interopRequireDefault(_mapValues);
	
	var _formReducer = __webpack_require__(248);
	
	var _createField = __webpack_require__(345);
	
	var _assocIn = __webpack_require__(249);
	
	var _assocIn2 = _interopRequireDefault(_assocIn);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function tempInitialState(path) {
	  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (path.length === 1) return _defineProperty({}, path[0], initialValue);
	
	  return _defineProperty({}, path[0], tempInitialState(path.slice(1), initialValue));
	}
	
	function getFieldAndForm(formState, modelPath) {
	  var field = (0, _get2.default)(formState, modelPath);
	  var form = formState;
	
	  (0, _invariant2.default)(form, 'Could not find form for "%s" in the store.', modelPath);
	
	  if (!field) {
	    var initialValue = (0, _get2.default)(formState.$form.initialValue, modelPath);
	
	    form = _icepick2.default.merge((0, _formReducer.createInitialState)(formState.$form.model, tempInitialState(modelPath, initialValue)), formState);
	
	    field = (0, _get2.default)(form, modelPath);
	  }
	
	  return [field, form];
	}
	
	function updateField(state, path, newState, newSubState, updater) {
	  var _getFieldAndForm = getFieldAndForm(state, path),
	      _getFieldAndForm2 = _slicedToArray(_getFieldAndForm, 2),
	      field = _getFieldAndForm2[0],
	      fullState = _getFieldAndForm2[1];
	
	  if (!field) return state;
	
	  var isForm = field.hasOwnProperty('$form');
	  var fieldPath = isForm ? [].concat(_toConsumableArray(path), ['$form']) : path;
	
	  var fieldState = isForm ? field.$form : field;
	
	  var updatedFieldState = typeof newState === 'function' ? newState(fieldState) : newState;
	
	  if (isForm && newSubState) {
	    var formState = (0, _mapValues2.default)(field, function (subState, key) {
	      if (key === '$form') {
	        return (0, _createField.updateFieldState)(fieldState, updatedFieldState);
	      }
	
	      var updatedSubState = typeof newSubState === 'function' ? newSubState(subState, updatedFieldState) : newSubState;
	
	      return (0, _createField.updateFieldState)(subState, updatedSubState);
	    });
	
	    if (!path.length) return formState;
	
	    return (0, _assocIn2.default)(fullState, path, formState, updater);
	  }
	
	  return (0, _assocIn2.default)(fullState, fieldPath, (0, _createField.updateFieldState)(fieldState, updatedFieldState), updater);
	}

/***/ },
/* 2820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateParentForms;
	
	var _icepick = __webpack_require__(126);
	
	var _icepick2 = _interopRequireDefault(_icepick);
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _assocIn = __webpack_require__(249);
	
	var _assocIn2 = _interopRequireDefault(_assocIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// import { updateFieldState } from './create-field';
	
	function updateParentForms(state, localPath, updater) {
	  var parentLocalPath = localPath.slice(0, -1);
	
	  var value = parentLocalPath.length ? (0, _get2.default)(state, parentLocalPath) : state;
	
	  if (!value) return state;
	
	  var form = value.$form;
	
	  var updatedValue = typeof updater === 'function' ? updater(value) : updater;
	
	  // const updatedForm = updateFieldState(form, updatedValue);
	
	  var newState = (0, _assocIn2.default)(state, [].concat(_toConsumableArray(parentLocalPath), ['$form']), _icepick2.default.merge(form, updatedValue));
	
	  if (!parentLocalPath.length) return newState;
	
	  return updateParentForms(newState, parentLocalPath, updater);
	}

/***/ },
/* 2821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = updateSubFields;
	
	var _get = __webpack_require__(45);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _assocIn = __webpack_require__(249);
	
	var _assocIn2 = _interopRequireDefault(_assocIn);
	
	var _createField = __webpack_require__(345);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function updateSubField(subField, newSubState) {
	  // Form
	  if (subField && subField.$form) {
	    // intermediate value - not mutated outside function
	    var result = {};
	
	    Object.keys(subField).forEach(function (key) {
	      if (key === '$form') {
	        result.$form = (0, _createField.updateFieldState)(subField.$form, newSubState);
	      } else {
	        result[key] = updateSubField(subField[key], newSubState);
	      }
	    });
	
	    return result;
	  }
	
	  // Field
	  return (0, _createField.updateFieldState)(subField, newSubState);
	}
	
	function updateSubFields(state, localPath, newState) {
	  var field = (0, _get2.default)(state, localPath);
	
	  // only forms can have fields -
	  // skip if field is not a form
	  if (!field || !field.$form) return state;
	
	  // intermediate value - not mutated outside function
	  var updatedField = {};
	
	  Object.keys(field).forEach(function (key) {
	    if (key === '$form') {
	      updatedField.$form = field.$form;
	    } else {
	      updatedField[key] = updateSubField(field[key], newState);
	    }
	  });
	
	  if (!localPath.length) return updatedField;
	
	  return (0, _assocIn2.default)(state, localPath, updatedField);
	}

/***/ },
/* 2822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(1273);
	
	var _warning = __webpack_require__(511);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 2823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(1271);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(2830);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(2824);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(2825);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(2826);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(2827);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 2824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(56);
	
	var _wrapMapToProps = __webpack_require__(1272);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 2825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(1272);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 2826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(1274);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 2827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(2828);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 2828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(511);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 2829 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 2830 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 2831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _resizeDetectorStyles = __webpack_require__(2832);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResizeDetector = function (_Component) {
	  _inherits(ResizeDetector, _Component);
	
	  function ResizeDetector() {
	    _classCallCheck(this, ResizeDetector);
	
	    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this));
	
	    _this.state = {
	      expandChildHeight: 0,
	      expandChildWidth: 0,
	      expandScrollLeft: 0,
	      expandScrollTop: 0,
	      shrinkScrollTop: 0,
	      shrinkScrollLeft: 0,
	      lastWidth: 0,
	      lastHeight: 0
	    };
	
	    _this.reset = _this.reset.bind(_this);
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  _createClass(ResizeDetector, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.forceUpdate();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _containerSize = this.containerSize(),
	          _containerSize2 = _slicedToArray(_containerSize, 2),
	          width = _containerSize2[0],
	          height = _containerSize2[1];
	
	      this.reset(width, height);
	      this.props.onResize(width, height);
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props !== nextProps || this.state !== nextState;
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.expand.scrollLeft = this.expand.scrollWidth;
	      this.expand.scrollTop = this.expand.scrollHeight;
	
	      this.shrink.scrollLeft = this.shrink.scrollWidth;
	      this.shrink.scrollTop = this.shrink.scrollHeight;
	    }
	  }, {
	    key: 'containerSize',
	    value: function containerSize() {
	      return [this.props.handleWidth && this.container.parentElement.offsetWidth, this.props.handleHeight && this.container.parentElement.offsetHeight];
	    }
	  }, {
	    key: 'reset',
	    value: function reset(containerWidth, containerHeight) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      var parent = this.container.parentElement;
	
	      var position = 'static';
	      if (parent.currentStyle) {
	        position = parent.currentStyle.position;
	      } else if (window.getComputedStyle) {
	        position = window.getComputedStyle(parent).position;
	      }
	      if (position === 'static') {
	        parent.style.position = 'relative';
	      }
	
	      this.setState({
	        expandChildHeight: this.expand.offsetHeight + 10,
	        expandChildWidth: this.expand.offsetWidth + 10,
	        lastWidth: containerWidth,
	        lastHeight: containerHeight
	      });
	    }
	  }, {
	    key: 'handleScroll',
	    value: function handleScroll(e) {
	      if (typeof window === 'undefined') {
	        return;
	      }
	
	      e.preventDefault();
	      e.stopPropagation();
	
	      var state = this.state;
	
	      var _containerSize3 = this.containerSize(),
	          _containerSize4 = _slicedToArray(_containerSize3, 2),
	          width = _containerSize4[0],
	          height = _containerSize4[1];
	
	      if (width !== state.lastWidth || height !== state.lastHeight) {
	        this.props.onResize(width, height);
	      }
	
	      this.reset(width, height);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var state = this.state;
	
	
	      var expandStyle = _extends({}, _resizeDetectorStyles.expandChildStyle, {
	        width: state.expandChildWidth,
	        height: state.expandChildHeight
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: _resizeDetectorStyles.parentStyle, ref: function ref(e) {
	            _this2.container = e;
	          } },
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.expand = e;
	            } },
	          _react2.default.createElement('div', { style: expandStyle })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _resizeDetectorStyles.parentStyle, onScroll: this.handleScroll, ref: function ref(e) {
	              _this2.shrink = e;
	            } },
	          _react2.default.createElement('div', { style: _resizeDetectorStyles.shrinkChildStyle })
	        )
	      );
	    }
	  }]);
	
	  return ResizeDetector;
	}(_react.Component);
	
	exports.default = ResizeDetector;
	
	
	ResizeDetector.propTypes = {
	  handleWidth: _propTypes2.default.bool,
	  handleHeight: _propTypes2.default.bool,
	  onResize: _propTypes2.default.func
	};
	
	ResizeDetector.defaultProps = {
	  handleWidth: false,
	  handleHeight: false,
	  onResize: function onResize(e) {
	    return e;
	  }
	};

/***/ },
/* 2832 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var parentStyle = exports.parentStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  right: 0,
	  bottom: 0,
	  overflow: 'hidden',
	  zIndex: -1,
	  visibility: 'hidden'
	};
	
	var shrinkChildStyle = exports.shrinkChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '200%',
	  height: '200%'
	};
	
	var expandChildStyle = exports.expandChildStyle = {
	  position: 'absolute',
	  left: 0,
	  top: 0,
	  width: '100%',
	  height: '100%'
	};

/***/ },
/* 2833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ResizeDetector = __webpack_require__(2831);
	
	var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _ResizeDetector2.default;

/***/ },
/* 2834 */
[3545, 2836],
/* 2835 */
[3546, 2834],
/* 2836 */
1144,
/* 2837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _scrollIntoViewIfNeeded = __webpack_require__(3240);
	
	var _scrollIntoViewIfNeeded2 = _interopRequireDefault(_scrollIntoViewIfNeeded);
	
	var _dom = __webpack_require__(2838);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// Possible enhancements:
	//
	//  * If the menu is close to a screen edge,
	//    automatically reposition it so that it fits on the screen
	//  * Maybe show menu immediately above the toggler
	//    (like in Material design), not below it.
	//
	// https://material.google.com/components/menus.html
	
	var Empty_value_option_value = '';
	
	var value_prop_type = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.bool]);
	
	var Select = function (_PureComponent) {
		_inherits(Select, _PureComponent);
	
		function Select(props) {
			_classCallCheck(this, Select);
	
			// Shouldn't memory leak because
			// the set of options is assumed to be constant.
			var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));
	
			_initialiseProps.call(_this);
	
			_this.options = {};
	
			var _this$props = _this.props,
			    value = _this$props.value,
			    autocomplete = _this$props.autocomplete,
			    options = _this$props.options,
			    children = _this$props.children,
			    menu = _this$props.menu,
			    toggler = _this$props.toggler,
			    onChange = _this$props.onChange;
	
	
			if (autocomplete) {
				if (!options) {
					throw new Error('"options" property is required for an "autocomplete" select');
				}
	
				_this.state.matching_options = _this.get_matching_options(options, value);
			}
	
			if (children && !menu) {
				_react2.default.Children.forEach(children, function (element) {
					if (!element.props.value) {
						throw new Error('You must specify "value" prop on each child of <Select/>');
					}
	
					if (!element.props.label) {
						throw new Error('You must specify "label" prop on each child of <Select/>');
					}
				});
			}
	
			if (menu && !toggler) {
				throw new Error('Supply a "toggler" component when enabling "menu" in <Select/>');
			}
	
			if (!menu && !onChange) {
				throw new Error('"onChange" property must be specified for a non-menu <Select/>');
			}
			return _this;
		}
	
		// Client side rendering, javascript is enabled
	
	
		_createClass(Select, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _props = this.props,
				    fallback = _props.fallback,
				    nativeExpanded = _props.nativeExpanded;
	
	
				document.addEventListener('click', this.document_clicked);
	
				if (fallback) {
					this.setState({ javascript: true });
				}
	
				if (nativeExpanded) {
					this.resize_native_expanded_select();
					window.addEventListener('resize', this.resize_native_expanded_select);
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(previous_props, previous_state) {
				var _props2 = this.props,
				    nativeExpanded = _props2.nativeExpanded,
				    value = _props2.value;
				var _state = this.state,
				    expanded = _state.expanded,
				    height = _state.height;
	
	
				if (expanded !== previous_state.expanded) {
					if (expanded && this.should_animate()) {
						if (height === undefined) {
							this.calculate_height();
						}
					}
				}
	
				// If the `value` changed then resize the native expanded `<select/>`
				if (nativeExpanded && value !== previous_props.value) {
					this.resize_native_expanded_select();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var nativeExpanded = this.props.nativeExpanded;
	
	
				document.removeEventListener('click', this.document_clicked);
	
				if (nativeExpanded) {
					window.removeEventListener('resize', this.resize_native_expanded_select);
				}
	
				clearTimeout(this.toggle_timeout);
				clearTimeout(this.scroll_into_view_timeout);
				clearTimeout(this.restore_focus_on_collapse_timeout);
	
				this.toggle_timeout = undefined;
				this.scroll_into_view_timeout = undefined;
				this.restore_focus_on_collapse_timeout = undefined;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var _props3 = this.props,
				    id = _props3.id,
				    upward = _props3.upward,
				    concise = _props3.concise,
				    compact = _props3.compact,
				    scroll = _props3.scroll,
				    children = _props3.children,
				    menu = _props3.menu,
				    toggler = _props3.toggler,
				    alignment = _props3.alignment,
				    autocomplete = _props3.autocomplete,
				    saveOnIcons = _props3.saveOnIcons,
				    fallback = _props3.fallback,
				    native = _props3.native,
				    nativeExpanded = _props3.nativeExpanded,
				    disabled = _props3.disabled,
				    required = _props3.required,
				    placeholder = _props3.placeholder,
				    label = _props3.label,
				    value = _props3.value,
				    error = _props3.error,
				    closeButton = _props3.closeButton,
				    closeAriaLabel = _props3.closeAriaLabel,
				    style = _props3.style,
				    className = _props3.className;
				var _state2 = this.state,
				    expanded = _state2.expanded,
				    list_height = _state2.list_height;
	
	
				var options = this.get_options();
	
				var list_style = void 0;
	
				// Makes the options list scrollable (only when not in `autocomplete` mode).
				if (this.is_scrollable() && list_height !== undefined) {
					list_style = { maxHeight: list_height + 'px' };
				}
	
				var overflow = scroll && options && this.overflown();
	
				var list_items = void 0;
	
				// If a list of options is supplied as an array of `{ value, label }`,
				// then transform those elements to <buttons/>
				if (options) {
					list_items = options.map(function (_ref, index) {
						var value = _ref.value,
						    label = _ref.label,
						    icon = _ref.icon;
	
						return _this2.render_list_item({ index: index, value: value, label: label, icon: !saveOnIcons && icon, overflow: overflow });
					});
				}
				// Else, if a list of options is supplied as a set of child React elements,
				// then render those elements.
				else {
						list_items = _react2.default.Children.map(children, function (element, index) {
							if (!element) {
								return;
							}
	
							return _this2.render_list_item({ index: index, element: element });
						});
					}
	
				var wrapper_style = { textAlign: alignment };
	
				var selected = this.get_selected_option();
	
				var show_options_list = !native && !nativeExpanded && list_items.length > 0;
				var show_label = label && (this.get_selected_option() || placeholder);
	
				return _react2.default.createElement(
					'div',
					{
						ref: function ref(_ref3) {
							return _this2.select = _ref3;
						},
						onKeyDown: this.on_key_down_in_container,
						onBlur: this.on_blur,
						style: style ? _extends({}, wrapper_style, style) : wrapper_style,
						className: (0, _classnames2.default)('rrui__select', {
							'rrui__rich': fallback,
							'rrui__select--menu': menu,
							'rrui__select--upward': upward,
							'rrui__select--expanded': expanded,
							'rrui__select--collapsed': !expanded,
							'rrui__select--disabled': disabled,
							'rrui__select--compact': compact || concise && !autocomplete
						}, className) },
					_react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)({
								'rrui__input': !toggler
							}) },
						!menu && !native && this.render_selected_item(show_label),
						show_label && _react2.default.createElement(
							'label',
							{
								htmlFor: id,
								className: (0, _classnames2.default)('rrui__input-label', {
									'rrui__input-label--required': required && value_is_empty(value),
									'rrui__input-label--invalid': this.should_indicate_invalid()
								}) },
							label
						),
						menu && this.render_toggler(),
						show_options_list && _react2.default.createElement(
							'ul',
							{
								ref: function ref(_ref2) {
									return _this2.list = _ref2;
								},
								style: list_style,
								className: (0, _classnames2.default)('rrui__expandable', 'rrui__expandable--overlay', 'rrui__select__options', 'rrui__shadow', {
									'rrui__select__options--autocomplete': autocomplete,
									'rrui__select__options--menu': menu,
									'rrui__expandable--expanded': expanded,
									'rrui__select__options--expanded': expanded,
									'rrui__expandable--left-aligned': alignment === 'left',
									'rrui__expandable--right-aligned': alignment === 'right',
									'rrui__select__options--left-aligned': !children && alignment === 'left',
									'rrui__select__options--right-aligned': !children && alignment === 'right',
									// CSS selector performance optimization
									'rrui__select__options--upward': upward,
									'rrui__select__options--downward': !upward
								}) },
							list_items
						),
						show_options_list && expanded && closeButton && _react2.default.createElement(
							'button',
							{
								type: 'button',
								onClick: this.toggle,
								'aria-label': closeAriaLabel,
								className: (0, _classnames2.default)('rrui__button-reset', 'rrui__select__close', {
									'rrui__select__close--autocomplete': autocomplete
								}) },
							closeButton
						),
						(native || fallback && !this.state.javascript) && this.render_static()
					),
					this.should_indicate_invalid() && _react2.default.createElement(
						'div',
						{ className: 'rrui__input-error' },
						error
					)
				);
			}
		}, {
			key: 'render_list_item',
			value: function render_list_item(_ref4) // , first, last
			{
				var _this3 = this;
	
				var index = _ref4.index,
				    element = _ref4.element,
				    value = _ref4.value,
				    label = _ref4.label,
				    icon = _ref4.icon,
				    overflow = _ref4.overflow;
				var _props4 = this.props,
				    disabled = _props4.disabled,
				    menu = _props4.menu,
				    scrollbarPadding = _props4.scrollbarPadding;
				var _state3 = this.state,
				    focused_option_value = _state3.focused_option_value,
				    expanded = _state3.expanded;
	
				// If a list of options is supplied as a set of child React elements,
				// then extract values from their props.
	
				if (element) {
					value = element.props.value;
				}
	
				var is_focused = !menu && value === focused_option_value;
	
				var item_style = void 0;
	
				// on overflow the vertical scrollbar will take up space
				// reducing padding-right and the only way to fix that
				// is to add additional padding-right
				//
				// a hack to restore padding-right taken up by a vertical scrollbar
				if (overflow && scrollbarPadding) {
					item_style = { marginRight: (0, _dom.getScrollbarWidth)() + 'px' };
				}
	
				var button = void 0;
	
				// If a list of options is supplied as a set of child React elements,
				// then enhance those elements with extra props.
				if (element) {
					var extra_props = {
						style: item_style ? _extends({}, item_style, element.props.style) : element.props.style,
						className: (0, _classnames2.default)('rrui__button-reset', 'rrui__select__option', {
							'rrui__select__option--focused': is_focused
						}, element.props.className)
					};
	
					var onClick = element.props.onClick;
	
					extra_props.onClick = function (event) {
						if (menu) {
							_this3.toggle();
						} else {
							_this3.item_clicked(value, event);
						}
	
						if (onClick) {
							onClick(event);
						}
					};
	
					button = _react2.default.cloneElement(element, extra_props);
				}
				// Else, if a list of options is supplied as an array of `{ value, label }`,
				// then transform those options to <buttons/>
				else {
						if (icon) {
							icon = render_icon(icon);
						}
	
						button = _react2.default.createElement(
							'button',
							{
								type: 'button',
								onClick: function onClick(event) {
									return _this3.item_clicked(value, event);
								},
								disabled: disabled,
								tabIndex: '-1',
								'aria-label': label,
								className: (0, _classnames2.default)('rrui__button-reset', 'rrui__select__option', {
									'rrui__select__option--focused': is_focused,
									// CSS selector performance optimization
									'rrui__select__option--disabled': disabled
								}),
								style: item_style },
							icon && _react2.default.cloneElement(icon, {
								className: (0, _classnames2.default)(icon.props.className, 'rrui__select__option-icon')
							}),
							label
						);
					}
	
				return _react2.default.createElement(
					'li',
					{
						key: get_option_key(value),
						ref: function ref(_ref5) {
							return _this3.options[get_option_key(value)] = _ref5;
						},
						className: (0, _classnames2.default)('rrui__expandable__content', 'rrui__select__options-list-item', {
							'rrui__select__separator-option': element && element.type === Select.Separator,
							'rrui__expandable__content--expanded': expanded,
							// CSS selector performance optimization
							'rrui__select__options-list-item--expanded': expanded
						}) },
					button
				);
			}
	
			// Renders the selected option
			// and possibly a transparent native `<select/>` above it
			// so that the native `<select/>` expands upon click
			// on the selected option
			// (in case of `nativeExpanded` setting).
	
		}, {
			key: 'render_selected_item',
			value: function render_selected_item(label_is_shown) {
				var _props5 = this.props,
				    nativeExpanded = _props5.nativeExpanded,
				    toggler = _props5.toggler;
	
	
				if (toggler) {
					return this.render_toggler();
				}
	
				var selected = this.render_selected_item_only(label_is_shown);
	
				if (nativeExpanded) {
					return _react2.default.createElement(
						'div',
						{ style: native_expanded_select_container_style },
						this.render_static(),
						selected
					);
				}
	
				return selected;
			}
		}, {
			key: 'render_selected_item_only',
			value: function render_selected_item_only(label_is_shown) {
				var _this4 = this;
	
				var _props6 = this.props,
				    children = _props6.children,
				    value = _props6.value,
				    placeholder = _props6.placeholder,
				    label = _props6.label,
				    disabled = _props6.disabled,
				    required = _props6.required,
				    autocomplete = _props6.autocomplete,
				    concise = _props6.concise,
				    nativeExpanded = _props6.nativeExpanded,
				    tabIndex = _props6.tabIndex,
				    onFocus = _props6.onFocus,
				    title = _props6.title,
				    ariaLabel = _props6.ariaLabel,
				    inputClassName = _props6.inputClassName,
				    toggleClassName = _props6.toggleClassName;
				var _state4 = this.state,
				    expanded = _state4.expanded,
				    autocomplete_width = _state4.autocomplete_width,
				    autocomplete_input_value = _state4.autocomplete_input_value;
	
	
				var selected = this.get_selected_option();
				var selected_label = this.get_selected_option_label();
	
				var selected_text = selected ? selected_label : placeholder || label;
	
				var selected_style_classes = {
					'rrui__input-element': true
				};
	
				if (autocomplete && expanded) {
					// style = { ...style, width: autocomplete_width + 'px' }
	
					return _react2.default.createElement('input', {
						type: 'text',
						ref: function ref(_ref6) {
							return _this4.autocomplete = _ref6;
						},
						placeholder: selected_text,
						value: autocomplete_input_value,
						onChange: this.on_autocomplete_input_change,
						onKeyDown: this.on_key_down,
						onFocus: onFocus,
						tabIndex: tabIndex,
						title: title,
						className: (0, _classnames2.default)(selected_style_classes, 'rrui__input-field', 'rrui__select__autocomplete', inputClassName,
						// CSS selector performance optimization
						// (should it even be optimized).
						{
							'rrui__input-field--disabled': disabled
						}) });
				}
	
				var show_selected_as_an_icon = concise && selected && selected.icon;
	
				return _react2.default.createElement(
					'button',
					{
						ref: function ref(_ref7) {
							return _this4.selected = _ref7;
						},
						type: 'button',
						disabled: disabled,
						onClick: this.toggle,
						onKeyDown: this.on_key_down,
						onFocus: onFocus,
						tabIndex: nativeExpanded ? -1 : tabIndex,
						title: title,
						'aria-label': ariaLabel,
						className: (0, _classnames2.default)(selected_style_classes, 'rrui__button-reset', 'rrui__select__button', toggleClassName, {
							'rrui__select__button--empty': !selected_label,
							'rrui__select__button--invalid': this.should_indicate_invalid(),
							'rrui__input-element--invalid': this.should_indicate_invalid(),
							// CSS selector performance optimization
							// (should it even be optimized).
							'rrui__select__button--disabled': disabled
						}) },
					_react2.default.createElement(
						'div',
						{ className: 'rrui__select__selected-content' },
						_react2.default.createElement(
							'div',
							{
								className: (0, _classnames2.default)('rrui__select__selected-label', {
									'rrui__select__selected-label--required': !label_is_shown && required && value_is_empty(value)
								}) },
							show_selected_as_an_icon ? _react2.default.cloneElement(render_icon(selected.icon), { title: selected_label }) : selected_text
						),
						_react2.default.createElement('div', {
							className: (0, _classnames2.default)('rrui__select__arrow', {
								// CSS selector performance optimization
								'rrui__select__arrow--expanded': expanded,
								'rrui__select__arrow--disabled': disabled
							}) })
					)
				);
			}
		}, {
			key: 'render_toggler',
			value: function render_toggler() {
				var _this5 = this;
	
				var toggler = this.props.toggler;
	
	
				return _react2.default.createElement(
					'div',
					{ className: 'rrui__select__toggler' },
					_react2.default.cloneElement(toggler, {
						ref: function ref(_ref8) {
							return _this5.selected = _ref8;
						},
						onClick: this.toggle,
						onKeyDown: this.on_key_down
					})
				);
			}
	
			// supports disabled javascript
	
		}, {
			key: 'render_static',
			value: function render_static() {
				var _this6 = this;
	
				var _props7 = this.props,
				    id = _props7.id,
				    name = _props7.name,
				    value = _props7.value,
				    label = _props7.label,
				    disabled = _props7.disabled,
				    options = _props7.options,
				    menu = _props7.menu,
				    toggler = _props7.toggler,
				    fallback = _props7.fallback,
				    native = _props7.native,
				    nativeExpanded = _props7.nativeExpanded,
				    tabIndex = _props7.tabIndex,
				    children = _props7.children;
	
	
				if (menu) {
					return _react2.default.createElement(
						'div',
						{
							className: (0, _classnames2.default)({
								'rrui__rich__fallback': fallback
							}) },
						toggler
					);
				}
	
				return _react2.default.createElement(
					'select',
					{
						ref: function ref(_ref9) {
							return _this6.native = _ref9;
						},
						id: id,
						name: name,
						value: value_is_empty(value) ? Empty_value_option_value : value,
						disabled: disabled,
						onChange: this.native_select_on_change,
						tabIndex: native || nativeExpanded ? tabIndex : undefined,
						className: (0, _classnames2.default)('rrui__input', 'rrui__select__native', {
							'rrui__select__native-expanded': nativeExpanded,
							'rrui__rich__fallback': fallback
						}) },
					options ? this.render_native_select_options(options, value_is_empty(value)) : _react2.default.Children.map(children, function (child) {
						if (!child) {
							return;
						}
	
						return _react2.default.createElement(
							'option',
							{
								className: 'rrui__select__native-option',
								key: child.props.value,
								value: child.props.value },
							child.props.label
						);
					})
				);
			}
		}, {
			key: 'render_native_select_options',
			value: function render_native_select_options(options, empty_option_is_selected) {
				var placeholder = this.props.placeholder;
	
	
				var empty_option_present = false;
	
				var rendered_options = options.map(function (option) {
					var value = option.value,
					    label = option.label;
	
	
					if (value_is_empty(value)) {
						empty_option_present = true;
						value = Empty_value_option_value;
					}
	
					return _react2.default.createElement(
						'option',
						{
							className: 'rrui__select__native-option',
							key: get_option_key(value),
							value: value },
						label
					);
				});
	
				if (empty_option_is_selected && !empty_option_present) {
					rendered_options.unshift(_react2.default.createElement(
						'option',
						{
							className: 'rrui__select__native-option',
							key: get_option_key(undefined),
							value: '' },
						placeholder
					));
				}
	
				return rendered_options;
			}
	
			// Whether should indicate that the input value is invalid
	
		}, {
			key: 'should_indicate_invalid',
			value: function should_indicate_invalid() {
				var _props8 = this.props,
				    indicateInvalid = _props8.indicateInvalid,
				    error = _props8.error;
	
	
				return indicateInvalid && error;
			}
		}, {
			key: 'get_selected_option',
			value: function get_selected_option() {
				var value = this.props.value;
	
	
				return this.get_option(value);
			}
		}, {
			key: 'get_option',
			value: function get_option(value) {
				var _props9 = this.props,
				    options = _props9.options,
				    children = _props9.children;
	
	
				if (options) {
					return options.filter(function (x) {
						return x.value === value;
					})[0];
				}
	
				var option = void 0;
	
				_react2.default.Children.forEach(children, function (child) {
					if (child.props.value === value) {
						option = child;
					}
				});
	
				return option;
			}
		}, {
			key: 'get_option_index',
			value: function get_option_index(option) {
				var _props10 = this.props,
				    options = _props10.options,
				    children = _props10.children;
	
	
				if (options) {
					return options.indexOf(option);
				}
	
				var option_index = void 0;
	
				_react2.default.Children.forEach(children, function (child, index) {
					if (child.props.value === option.value) {
						option_index = index;
					}
				});
	
				return option_index;
			}
		}, {
			key: 'get_selected_option_label',
			value: function get_selected_option_label() {
				var options = this.props.options;
	
	
				var selected = this.get_selected_option();
	
				if (!selected) {
					return;
				}
	
				if (options) {
					return selected.label;
				}
	
				return selected.props.label;
			}
		}, {
			key: 'overflown',
			value: function overflown() {
				var _props11 = this.props,
				    options = _props11.options,
				    maxItems = _props11.maxItems;
	
	
				return options.length > maxItems;
			}
		}, {
			key: 'scrollable_list_height',
			value: function scrollable_list_height(height, vertical_padding) {
				var maxItems = this.props.maxItems;
	
				// (Adding vertical padding so that it shows these `maxItems` options fully)
	
				return (height - 2 * vertical_padding) * (maxItems / this.get_options().length) + vertical_padding;
			}
		}, {
			key: 'should_animate',
			value: function should_animate() {
				return true;
	
				// return this.props.options.length >= this.props.transition_item_count_min
			}
		}, {
			key: 'focus',
			value: function focus() {
				if (this.autocomplete) {
					_focus(this.autocomplete);
				} else {
					_focus(this.selected);
				}
			}
	
			// Would have used `onBlur={...}` event handler here
			// with `if (container.contains(event.relatedTarget))` condition,
			// but it doesn't work in IE in React.
			// https://github.com/facebook/react/issues/3751
			//
			// Therefore, using the hacky `document.onClick` handlers
			// and this `onKeyDown` Tab handler
			// until `event.relatedTarget` support is consistent in React.
			//
	
	
			// This handler is a workaround for `redux-form`
	
		}, {
			key: 'get_options',
			value: function get_options() {
				var _props12 = this.props,
				    autocomplete = _props12.autocomplete,
				    autocompleteShowAll = _props12.autocompleteShowAll,
				    maxItems = _props12.maxItems,
				    options = _props12.options;
				var matching_options = this.state.matching_options;
	
	
				if (!autocomplete) {
					return options;
				}
	
				if (autocompleteShowAll) {
					return matching_options;
				}
	
				return matching_options.slice(0, maxItems);
			}
	
			// Get the previous option (relative to the currently focused option)
	
		}, {
			key: 'previous_focusable_option',
			value: function previous_focusable_option() {
				var options = this.get_options();
				var focused_option_value = this.state.focused_option_value;
	
	
				var i = 0;
				while (i < options.length) {
					if (options[i].value === focused_option_value) {
						if (i - 1 >= 0) {
							return options[i - 1];
						}
					}
					i++;
				}
			}
	
			// Get the next option (relative to the currently focused option)
	
		}, {
			key: 'next_focusable_option',
			value: function next_focusable_option() {
				var options = this.get_options();
				var focused_option_value = this.state.focused_option_value;
	
	
				var i = 0;
				while (i < options.length) {
					if (options[i].value === focused_option_value) {
						if (i + 1 < options.length) {
							return options[i + 1];
						}
					}
					i++;
				}
			}
	
			// Scrolls to an option having the value
	
		}, {
			key: 'scroll_to',
			value: function scroll_to(value) {
				var vertical_padding = this.state.vertical_padding;
	
	
				var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)]);
				var list = _reactDom2.default.findDOMNode(this.list);
	
				// If this option isn't even shown
				// (e.g. autocomplete)
				// then don't scroll to it because there's nothing to scroll to.
				if (!option_element) {
					return;
				}
	
				var offset_top = option_element.offsetTop;
	
				var is_first_option = list.firstChild === option_element;
	
				// If it's the first one - then scroll to list top
				if (is_first_option) {
					offset_top -= vertical_padding;
				}
	
				list.scrollTop = offset_top;
			}
	
			// Fully shows an option having the `value` (scrolls to it if neccessary)
	
		}, {
			key: 'show_option',
			value: function show_option(value, gravity) {
				var vertical_padding = this.state.vertical_padding;
	
	
				var option_element = _reactDom2.default.findDOMNode(this.options[get_option_key(value)]);
				var list = _reactDom2.default.findDOMNode(this.list);
	
				var is_first_option = list.firstChild === option_element;
				var is_last_option = list.lastChild === option_element;
	
				switch (gravity) {
					case 'top':
						var top_line = option_element.offsetTop;
	
						if (is_first_option) {
							top_line -= vertical_padding;
						}
	
						if (top_line < list.scrollTop) {
							list.scrollTop = top_line;
						}
	
						return;
	
					case 'bottom':
						var bottom_line = option_element.offsetTop + option_element.offsetHeight;
	
						if (is_last_option) {
							bottom_line += vertical_padding;
						}
	
						if (bottom_line > list.scrollTop + list.offsetHeight) {
							list.scrollTop = bottom_line - list.offsetHeight;
						}
	
						return;
				}
			}
	
			// Calculates height of the expanded item list
	
		}, {
			key: 'calculate_height',
			value: function calculate_height() {
				var options = this.props.options;
	
	
				var list_dom_node = _reactDom2.default.findDOMNode(this.list);
				// const border = parseInt(window.getComputedStyle(list_dom_node).borderTopWidth)
				var height = list_dom_node.scrollHeight;
				var vertical_padding = parseInt(window.getComputedStyle(list_dom_node).paddingTop);
	
				// For things like "accordeon".
				//
				// const images = list_dom_node.querySelectorAll('img')
				//
				// if (images.length > 0)
				// {
				// 	return this.preload_images(list_dom_node, images)
				// }
	
				var state = { height: height, vertical_padding: vertical_padding
	
					// If it's a regular `<select/>` with `<option/>`s
					// then calculate its height.
				};if (this.is_scrollable() && options && this.overflown()) {
					state.list_height = this.scrollable_list_height(height, vertical_padding);
				}
	
				this.setState(state);
			}
		}, {
			key: 'is_scrollable',
			value: function is_scrollable() {
				var _props13 = this.props,
				    menu = _props13.menu,
				    autocomplete = _props13.autocomplete,
				    autocompleteShowAll = _props13.autocompleteShowAll,
				    scroll = _props13.scroll;
	
	
				return !menu && (autocomplete && autocompleteShowAll || !autocomplete) && scroll;
			}
	
			// This turned out not to work for `autocomplete`
			// because not all options are ever shown.
			// get_widest_label_width()
			// {
			// 	// <ul/> -> <li/> -> <button/>
			// 	const label = ReactDOM.findDOMNode(this.list).firstChild.firstChild
			//
			// 	const style = getComputedStyle(label)
			//
			// 	const width = parseFloat(style.width)
			// 	const side_padding = parseFloat(style.paddingLeft)
			//
			// 	return width - 2 * side_padding
			// }
	
		}, {
			key: 'get_matching_options',
			value: function get_matching_options(options, value) {
				// If the autocomplete value is `undefined` or empty
				if (!value) {
					return options;
				}
	
				value = value.toLowerCase();
	
				return options.filter(function (_ref10) {
					var label = _ref10.label,
					    verbose = _ref10.verbose;
	
					return (verbose || label).toLowerCase().indexOf(value) >= 0;
				});
			}
		}]);
	
		return Select;
	}(_react.PureComponent);
	
	Select.propTypes = {
		// A list of selectable options
		options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
			// Option value (may be `undefined`)
			value: value_prop_type,
			// Option label (may be `undefined`)
			label: _propTypes2.default.string,
			// Option icon
			icon: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
		})),
	
		// HTML form input `name` attribute
		name: _propTypes2.default.string,
	
		// Label which is placed above the select
		label: _propTypes2.default.string,
	
		// Placeholder (like "Choose")
		placeholder: _propTypes2.default.string,
	
		// Whether to use native `<select/>`
		native: _propTypes2.default.bool.isRequired,
	
		// Whether to use native `<select/>` when expanded
		nativeExpanded: _propTypes2.default.bool.isRequired,
	
		// Show icon only for selected item,
		// and only if `concise` is `true`.
		saveOnIcons: _propTypes2.default.bool,
	
		// Disables this control
		disabled: _propTypes2.default.bool,
	
		// Set to `true` to mark the field as required
		required: _propTypes2.default.bool.isRequired,
	
		// Selected option value
		value: value_prop_type,
	
		// Is called when an option is selected
		onChange: _propTypes2.default.func,
	
		// Is called when the select is focused
		onFocus: _propTypes2.default.func,
	
		// Is called when the select is blurred.
		// This `onBlur` interceptor is a workaround for `redux-form`,
		// so that it gets the parsed `value` in its `onBlur` handler,
		// not the formatted text.
		onBlur: _propTypes2.default.func,
	
		// (exotic use case)
		// Falls back to a plain HTML input
		// when javascript is disabled (e.g. Tor)
		fallback: _propTypes2.default.bool.isRequired,
	
		// Component CSS class
		className: _propTypes2.default.string,
	
		// Autocomplete `<input/>` CSS class
		inputClassName: _propTypes2.default.string,
	
		// `<button/>` toggler CSS class
		toggleClassName: _propTypes2.default.string,
	
		// CSS style object
		style: _propTypes2.default.object,
	
		// If this flag is set to `true`,
		// and `icon` is specified for a selected option,
		// then the selected option will be displayed
		// as icon only, without the label.
		concise: _propTypes2.default.bool,
	
		// If this flag is set to `true`,
		// then it makes `<Select/>` not stretch itself
		// to 100% width by making it `inline-block`.
		// Is set to `true` when `concise` is `true`
		// because it makes sense.
		compact: _propTypes2.default.bool,
	
		// HTML `tabindex` attribute
		tabIndex: _propTypes2.default.number,
	
		// If set to `true`, autocompletion is available
		// upon expanding the options list.
		autocomplete: _propTypes2.default.bool,
	
		// If set to `true`, autocomple will show all
		// matching options instead of just `maxItems`.
		autocompleteShowAll: _propTypes2.default.bool,
	
		// Options list alignment ("left", "right")
		alignment: _propTypes2.default.oneOf(['left', 'right']),
	
		// If `menu` flag is set to `true`
		// then it's gonna be a dropdown menu
		// with `children` elements inside
		// and therefore `onChange` won't be called
		// on menu item click.
		menu: _propTypes2.default.bool,
	
		// If `menu` flag is set to `true`
		// then `toggler` is the dropdown menu button.
		// E.g. `toggler={<DropDownMenuButton/>}`.
		// `toggler` must accept `onClick` and `onKeyDown` properties.
		toggler: _propTypes2.default.element,
	
		// If `scroll` is `false`, then options list
		// is not limited in height.
		// Is `true` by default (scrollable).
		scroll: _propTypes2.default.bool.isRequired,
	
		// If this flag is set to `true`,
		// then the dropdown expands itself upward.
		// (as opposed to the default downward)
		upward: _propTypes2.default.bool,
	
		// Maximum items fitting the options list height (scrollable).
		// In case of `autocomplete` that's the maximum number of matched items shown.
		// Is `6` by default.
		maxItems: _propTypes2.default.number.isRequired,
	
		// Is `true` by default (only when the list of options is scrollable)
		scrollbarPadding: _propTypes2.default.bool,
	
		focusUponSelection: _propTypes2.default.bool.isRequired,
	
		// When the `<Select/>` is expanded
		// the options list may not fit on the screen.
		// If `scrollIntoView` is `true` (which is the default)
		// then the browser will automatically scroll
		// so that the expanded options list fits on the screen.
		scrollIntoView: _propTypes2.default.bool.isRequired,
	
		// If `scrollIntoView` is `true` (which is the default)
		// then this is gonna be the delay after which it scrolls into view.
		expandAnimationDuration: _propTypes2.default.number.isRequired,
	
		onTabOut: _propTypes2.default.func,
	
		onToggle: _propTypes2.default.func,
	
		// `aria-label` for the `<Select/>`'s `<button/>`
		ariaLabel: _propTypes2.default.string.isRequired,
	
		// `aria-label` for the "Close" button
		// (which is an "x" visible in fullscreen mode).
		closeAriaLabel: _propTypes2.default.string.isRequired,
	
		// The "x" button that closes the `<Select/>`
		// in fullscreen mode on mobile devices.
		closeButton: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.oneOf([false])]).isRequired
	
		// transition_item_count_min : PropTypes.number,
		// transition_duration_min : PropTypes.number,
		// transition_duration_max : PropTypes.number
	};
	Select.defaultProps = {
		alignment: 'left',
		scroll: true,
		maxItems: 6,
		scrollbarPadding: true,
		focusUponSelection: true,
		fallback: false,
		native: false,
		nativeExpanded: false,
		scrollIntoView: true,
		expandAnimationDuration: 150,
	
		// Set to `true` to mark the field as required
		required: false,
	
		// `aria-label` for the `<Select/>`'s `<button/>`
		ariaLabel: 'Select country',
	
		// `aria-label` for the "Close" button
		// (which is an "x" visible in fullscreen mode).
		closeAriaLabel: 'Close',
	
		// The "x" button that closes the `<Select/>`
		// in fullscreen mode on mobile devices.
		closeButton: _react2.default.createElement(
			'svg',
			{ viewBox: '0 0 22 21', className: 'rrui__select__close-icon' },
			_react2.default.createElement(
				'g',
				{ stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round' },
				_react2.default.createElement(
					'g',
					{ className: 'rrui__select__close-icon-path', transform: 'translate(-1367.000000, -40.000000)', strokeWidth: '1' },
					_react2.default.createElement(
						'g',
						{ transform: 'translate(1368.000000, 41.000000)' },
						_react2.default.createElement('path', { d: 'M0.807611845,0.307611845 L19.1923882,18.6923882' }),
						_react2.default.createElement('path', { d: 'M0.807611845,0.307611845 L19.1923882,18.6923882', transform: 'translate(10.000000, 9.500000) scale(-1, 1) translate(-10.000000, -9.500000) ' })
					)
				)
			)
		)
	
		// transition_item_count_min : 1,
		// transition_duration_min : 60, // milliseconds
		// transition_duration_max : 100 // milliseconds
	};
	
	var _initialiseProps = function _initialiseProps() {
		var _this7 = this;
	
		this.state = {
			// Is initialized during the first `componentDidUpdate()` call
			vertical_padding: 0
		};
	
		this.native_select_on_change = function (event) {
			var _props14 = _this7.props,
			    onChange = _props14.onChange,
			    previous_value = _props14.value;
	
	
			var value = event.target.value;
	
			// Convert back from an empty string to `undefined`
			if (value === Empty_value_option_value) {
				// `null` is not accounted for, use `undefined` instead.
				value = undefined;
			}
	
			// Call `onChange` only if `value` did actually change
			if (value !== previous_value) {
				onChange(value);
			}
		};
	
		this.resize_native_expanded_select = function () {
			// For some strange reason 1px on the right side of the `<select/>`
			// still falls through to the underlying selected option label.
			_reactDom2.default.findDOMNode(_this7.native).style.width = _reactDom2.default.findDOMNode(_this7.selected).offsetWidth + 1 + 'px';
		};
	
		this.toggle = function (event) {
			var toggle_options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
			if (event) {
				// Don't navigate away when clicking links
				event.preventDefault();
	
				// Not discarding the click event because
				// other expanded selects may be listening to it.
				// // Discard the click event so that it won't reach `document` click listener
				// event.stopPropagation() // doesn't work
				// event.nativeEvent.stopImmediatePropagation()
			}
	
			var _props15 = _this7.props,
			    menu = _props15.menu,
			    toggler = _props15.toggler,
			    disabled = _props15.disabled,
			    autocomplete = _props15.autocomplete,
			    options = _props15.options,
			    value = _props15.value,
			    focusUponSelection = _props15.focusUponSelection,
			    onToggle = _props15.onToggle,
			    nativeExpanded = _props15.nativeExpanded,
			    scrollIntoView = _props15.scrollIntoView,
			    expandAnimationDuration = _props15.expandAnimationDuration;
	
	
			if (nativeExpanded) {
				return;
			}
	
			if (disabled) {
				return;
			}
	
			if (!menu && options.length === 0) {
				return;
			}
	
			clearTimeout(_this7.toggle_timeout);
			clearTimeout(_this7.scroll_into_view_timeout);
			clearTimeout(_this7.restore_focus_on_collapse_timeout);
	
			_this7.toggle_timeout = undefined;
			_this7.scroll_into_view_timeout = undefined;
			_this7.restore_focus_on_collapse_timeout = undefined;
	
			var expanded = _this7.state.expanded;
	
	
			if (!expanded && autocomplete) {
				_this7.setState({
					// The input value can't be `undefined`
					// because in that case React would complain
					// about it being an "uncontrolled input"
					autocomplete_input_value: '',
					matching_options: options
				});
	
				// if (!this.state.autocomplete_width)
				// {
				// 	this.setState({ autocomplete_width: this.get_widest_label_width() })
				// }
			}
	
			// Deferring expanding the select upon click
			// because `document.onClick(event)` should fire first,
			// otherwise `event.target` in that handler will be detached
			// from the document and so `this.document_clicked()` handler will
			// immediately toggle the select back to collapsed state.
			_this7.toggle_timeout = setTimeout(function () {
				_this7.toggle_timeout = undefined;
	
				_this7.setState({
					expanded: !expanded
				}, function () {
					var is_now_expanded = _this7.state.expanded;
	
					if (!toggle_options.dont_focus_after_toggle) {
						// If it's autocomplete, then focus <input/> field
						// upon toggling the select component.
						if (autocomplete) {
							if (is_now_expanded) {
								// Focus the input after the select is expanded
								_focus(_this7.autocomplete);
							} else if (focusUponSelection) {
								// Focus the toggler after the select is collapsed
								_focus(_this7.selected);
							}
						} else {
							// For some reason Firefox loses focus
							// upon select expansion via a click,
							// so this extra `.focus()` works around that issue.
							_focus(_this7.selected);
						}
					}
	
					_this7.scroll_into_view_timeout = setTimeout(function () {
						_this7.scroll_into_view_timeout = undefined;
	
						var is_still_expanded = _this7.state.expanded;
	
						// For some reason in IE 11 "scroll into view" scrolls
						// to the top of the page, therefore turn it off for IE.
						if (is_still_expanded && _this7.list && scrollIntoView && !is_internet_explorer()) {
							var element = _reactDom2.default.findDOMNode(_this7.list);
	
							// https://developer.mozilla.org/ru/docs/Web/API/Element/scrollIntoViewIfNeeded
							if (element.scrollIntoViewIfNeeded) {
								element.scrollIntoViewIfNeeded(false);
							} else {
								// https://github.com/stipsan/scroll-into-view-if-needed
								(0, _scrollIntoViewIfNeeded2.default)(element, false, { duration: 800 });
							}
						}
					}, expandAnimationDuration * 1.1);
				});
	
				if (!expanded && options) {
					// Focus either the selected option
					// or the first option in the list.
	
					var focused_option_value = value || options[0].value;
	
					_this7.setState({ focused_option_value: focused_option_value });
	
					// Scroll down to the focused option
					_this7.scroll_to(focused_option_value);
				}
	
				if (onToggle) {
					onToggle(!expanded);
				}
	
				if (toggle_options.callback) {
					toggle_options.callback();
				}
			}, 0);
		};
	
		this.item_clicked = function (value, event) {
			if (event) {
				event.preventDefault();
			}
	
			var _props16 = _this7.props,
			    onChange = _props16.onChange,
			    previous_value = _props16.value;
	
	
			_this7.toggle(undefined, {
				callback: function callback() {
					// Call `onChange` only if `value` did actually change
					if (value !== previous_value) {
						onChange(value);
					}
				}
			});
		};
	
		this.document_clicked = function (event) {
			var autocomplete = _reactDom2.default.findDOMNode(_this7.autocomplete);
			var selected_option = _reactDom2.default.findDOMNode(_this7.selected);
			var options_list = _reactDom2.default.findDOMNode(_this7.list);
	
			// Don't close the select if its expander button has been clicked,
			// or if autocomplete has been clicked,
			// or if an option was selected from the list.
			if (options_list && options_list.contains(event.target) || autocomplete && autocomplete.contains(event.target) || selected_option && selected_option.contains(event.target)) {
				return;
			}
	
			_this7.setState({ expanded: false });
	
			var onToggle = _this7.props.onToggle;
	
	
			if (onToggle) {
				onToggle(false);
			}
		};
	
		this.on_key_down_in_container = function (event) {
			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}
	
			var expanded = _this7.state.expanded;
	
	
			switch (event.keyCode) {
				// Toggle on Tab out
				case 9:
					if (expanded) {
						_this7.toggle(undefined, { dont_focus_after_toggle: true });
	
						var onTabOut = _this7.props.onTabOut;
	
	
						if (onTabOut) {
							onTabOut(event);
						}
					}
					return;
			}
		};
	
		this.on_key_down = function (event) {
			var onKeyDown = _this7.props.onKeyDown;
	
	
			if (onKeyDown) {
				onKeyDown(event);
			}
	
			if ((0, _dom.submitFormOnCtrlEnter)(event, _this7.autocomplete || _this7.selected)) {
				return;
			}
	
			if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
				return;
			}
	
			var _props17 = _this7.props,
			    options = _props17.options,
			    value = _props17.value,
			    autocomplete = _props17.autocomplete;
			var _state5 = _this7.state,
			    expanded = _state5.expanded,
			    focused_option_value = _state5.focused_option_value;
	
			// Maybe add support for `children` arrow navigation in future
	
			if (options) {
				switch (event.keyCode) {
					// Select the previous option (if present) on up arrow
					case 38:
						event.preventDefault();
	
						var previous = _this7.previous_focusable_option();
	
						if (previous) {
							_this7.show_option(previous.value, 'top');
							return _this7.setState({ focused_option_value: previous.value });
						}
	
						return;
	
					// Select the next option (if present) on down arrow
					case 40:
						event.preventDefault();
	
						var next = _this7.next_focusable_option();
	
						if (next) {
							_this7.show_option(next.value, 'bottom');
							return _this7.setState({ focused_option_value: next.value });
						}
	
						return;
	
					// Collapse on Escape
					//
					// Maybe add this kind of support for "Escape" key in some future:
					//  hiding the item list, cancelling current item selection process
					//  and restoring the selection present before the item list was toggled.
					//
					case 27:
						// Collapse the list if it's expanded
						if (_this7.state.expanded) {
							_this7.toggle();
	
							// Restore focus when the list is collapsed
							_this7.restore_focus_on_collapse_timeout = setTimeout(function () {
								_this7.restore_focus_on_collapse_timeout = undefined;
								_focus(_this7.selected);
							}, 0);
						}
	
						return;
	
					// on Enter
					case 13:
						// Choose the focused item on Enter
						if (expanded) {
							event.preventDefault();
	
							// If an item is focused
							// (which may not be the case
							//  when autocomplete is matching no items)
							// (still for non-autocomplete select
							//  it is valid to have a default option)
							if (_this7.get_options() && _this7.get_options().length > 0) {
								// Choose the focused item
								_this7.item_clicked(focused_option_value);
							}
						}
						// Else it should have just submitted the form on Enter,
						// but it wouldn't because the select element activator is a <button/>
						// therefore hitting Enter while being focused on it just pushes that button.
						// So submit the enclosing form manually.
						else {
								if ((0, _dom.submitContainingForm)(_reactDom2.default.findDOMNode(_this7.select))) {
									event.preventDefault();
								}
							}
	
						return;
	
					// on Spacebar
					case 32:
						// Choose the focused item on Enter
						if (expanded) {
							// only if it it's an `options` select
							// and also if it's not an autocomplete
							if (_this7.get_options() && !autocomplete) {
								event.preventDefault();
	
								// `focused_option_value` could be non-existent
								// in case of `autocomplete`, but since
								// we're explicitly not handling autocomplete here
								// it is valid to select any options including the default ones.
								_this7.item_clicked(focused_option_value);
							}
						}
						// Otherwise, the spacebar keydown event on a `<button/>`
						// will trigger `onClick` and `.toggle()` will be called.
	
						return;
				}
			}
		};
	
		this.on_blur = function (event) {
			var _props18 = _this7.props,
			    onBlur = _props18.onBlur,
			    value = _props18.value;
	
			// If clicked on a select option then don't trigger "blur" event
	
			if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) {
				return;
			}
	
			// This `onBlur` interceptor is a workaround for `redux-form`,
			// so that it gets the right (parsed, not the formatted one)
			// `event.target.value` in its `onBlur` handler.
			if (onBlur) {
				var _event = _extends({}, event, {
					target: _extends({}, event.target, {
						value: value
					})
	
					// For `redux-form` event detection.
					// https://github.com/erikras/redux-form/blob/v5/src/events/isEvent.js
				});_event.stopPropagation = event.stopPropagation;
				_event.preventDefault = event.preventDefault;
	
				onBlur(_event);
			}
		};
	
		this.on_autocomplete_input_change = function (event) {
			var options = _this7.props.options;
	
			var input = event.target.value;
			var matching_options = _this7.get_matching_options(options, input);
	
			_this7.setState({
				autocomplete_input_value: input,
				matching_options: matching_options,
				focused_option_value: matching_options.length > 0 ? matching_options[0].value : undefined
			});
		};
	};
	
	exports.default = Select;
	
	
	Select.Separator = function (props) {
		return _react2.default.createElement('div', { className: 'rrui__select__separator' });
	};
	
	var native_expanded_select_container_style = {
		display: 'inline-block'
	
		// There can be an `undefined` value,
		// so just `{ value }` won't do here.
	};function get_option_key(value) {
		return value_is_empty(value) ? '@@rrui/select/undefined' : value;
	}
	
	function value_is_empty(value) {
		return value === null || value === undefined;
	}
	
	// Detects Internet Explorer.
	// https://stackoverflow.com/questions/19999388/check-if-user-is-using-ie-with-jquery
	function is_internet_explorer() {
		return window.navigator.userAgent.indexOf('MSIE ') > 0 || window.navigator.userAgent.indexOf('Trident/') > 0;
	}
	
	/**
	 * Focuses on a React component (if any).
	 * @param  {?object} component
	 */
	function _focus(component) {
		if (!component) {
			return;
		}
	
		if (typeof component.focus === 'function') {
			return component.focus();
		}
	
		var node = _reactDom2.default.findDOMNode(component);
		if (node) {
			return node.focus();
		}
	}
	
	function render_icon(icon) {
		return typeof icon === 'function' ? icon() : icon;
	}
	//# sourceMappingURL=Select.js.map

/***/ },
/* 2838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.submitFormOnCtrlEnter = submitFormOnCtrlEnter;
	exports.submitContainingForm = submitContainingForm;
	exports.getScrollbarWidth = getScrollbarWidth;
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Submits the form on `Ctrl` + `Enter` (or `Cmd` + `Enter`).
	function submitFormOnCtrlEnter(event, component) {
		if ((event.ctrlKey || event.metaKey) && event.keyCode === 13) {
			if (submitContainingForm(_reactDom2.default.findDOMNode(component))) {
				event.preventDefault();
				return true;
			}
		}
	}
	
	function submitContainingForm(node) {
		while (node.parentElement) {
			node = node.parentElement;
			if (node instanceof HTMLFormElement) {
				// Won't use `node.submit()` because it bypasses `onSubmit`.
				// Will click the submit button instead.
				var submit = node.querySelector('button[type=submit]');
				if (submit) {
					submit.click();
					return true;
				}
			}
		}
	}
	
	function getScrollbarWidth() {
		// // `window.innerWidth` has a bug:
		// // it's decreases as the page scale is increased.
		// // Therefore not using it.
		// // (Full width) - (Width minus scrollbar)
		// return document.body.clientWidth - window.innerWidth
	
		return 17;
	}
	//# sourceMappingURL=dom.js.map

/***/ },
/* 2839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(230);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(512);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 2840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(21);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(949);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(512);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(1281);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(1277);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(1276);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 2843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(1282);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(1283);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(1284);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(1285);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(349);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(1287);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 2849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRouter = __webpack_require__(1286);
	
	var _reducer = __webpack_require__(1280);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ConnectedRouter = function (_Component) {
	  _inherits(ConnectedRouter, _Component);
	
	  function ConnectedRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ConnectedRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
	      _this.store.dispatch({
	        type: _reducer.LOCATION_CHANGE,
	        payload: location
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
	    var _props = this.props,
	        propsStore = _props.store,
	        history = _props.history;
	
	    this.store = propsStore || this.context.store;
	
	    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
	    this.handleLocationChange(history.location);
	  };
	
	  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
	  };
	
	  ConnectedRouter.prototype.render = function render() {
	    return _react2.default.createElement(_reactRouter.Router, this.props);
	  };
	
	  return ConnectedRouter;
	}(_react.Component);
	
	ConnectedRouter.propTypes = {
	  store: _propTypes2.default.object,
	  history: _propTypes2.default.object,
	  children: _propTypes2.default.node
	};
	ConnectedRouter.contextTypes = {
	  store: _propTypes2.default.object
	};
	exports.default = ConnectedRouter;

/***/ },
/* 2850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerMiddleware;
	
	var _actions = __webpack_require__(1278);
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, args);
	      };
	    };
	  };
	}

/***/ },
/* 2851 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 2852 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(2851)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 2853 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(2855).enable();
	  window.Promise = __webpack_require__(2854);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(2858);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(25);


/***/ },
/* 2854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(1288);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 2855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(1288);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 2856 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(2857);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2857 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2858 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 2859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Async = __webpack_require__(1290);
	
	var _Async2 = _interopRequireDefault(_Async);
	
	var _Creatable = __webpack_require__(1291);
	
	var _Creatable2 = _interopRequireDefault(_Creatable);
	
	var _Select = __webpack_require__(350);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AsyncCreatableSelect = function (_React$Component) {
		_inherits(AsyncCreatableSelect, _React$Component);
	
		function AsyncCreatableSelect() {
			_classCallCheck(this, AsyncCreatableSelect);
	
			return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
		}
	
		_createClass(AsyncCreatableSelect, [{
			key: 'focus',
			value: function focus() {
				this.select.focus();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				return _react2.default.createElement(
					_Async2.default,
					this.props,
					function (_ref) {
						var ref = _ref.ref,
						    asyncProps = _objectWithoutProperties(_ref, ['ref']);
	
						var asyncRef = ref;
						return _react2.default.createElement(
							_Creatable2.default,
							asyncProps,
							function (_ref2) {
								var ref = _ref2.ref,
								    creatableProps = _objectWithoutProperties(_ref2, ['ref']);
	
								var creatableRef = ref;
								return _this2.props.children(_extends({}, creatableProps, {
									ref: function ref(select) {
										creatableRef(select);
										asyncRef(select);
										_this2.select = select;
									}
								}));
							}
						);
					}
				);
			}
		}]);
	
		return AsyncCreatableSelect;
	}(_react2.default.Component);
	
	var defaultChildren = function defaultChildren(props) {
		return _react2.default.createElement(_Select2.default, props);
	};
	
	AsyncCreatableSelect.propTypes = {
		children: _propTypes2.default.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	};
	
	AsyncCreatableSelect.defaultProps = {
		children: defaultChildren
	};
	
	exports.default = AsyncCreatableSelect;

/***/ },
/* 2860 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	};

/***/ },
/* 2861 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var trim = function trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	};
	
	exports.default = trim;

/***/ },
/* 2862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(1990);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(95);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ },
/* 2863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.NextArrow = exports.PrevArrow = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _helpers = __webpack_require__(517);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PrevArrow = exports.PrevArrow = function (_React$Component) {
	  _inherits(PrevArrow, _React$Component);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  PrevArrow.prototype.render = function render() {
	    var prevClasses = { 'slick-arrow': true, 'slick-prev': true };
	    var prevHandler = this.clickHandler.bind(this, { message: 'previous' });
	
	    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	      prevClasses['slick-disabled'] = true;
	      prevHandler = null;
	    }
	
	    var prevArrowProps = {
	      key: '0',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(prevClasses),
	      style: { display: 'block' },
	      onClick: prevHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var prevArrow = void 0;
	
	    if (this.props.prevArrow) {
	      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
	    } else {
	      prevArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '0', type: 'button' }, prevArrowProps),
	        ' Previous'
	      );
	    }
	
	    return prevArrow;
	  };
	
	  return PrevArrow;
	}(_react2.default.Component);
	
	var NextArrow = exports.NextArrow = function (_React$Component2) {
	  _inherits(NextArrow, _React$Component2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	  }
	
	  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
	    if (e) {
	      e.preventDefault();
	    }
	    this.props.clickHandler(options, e);
	  };
	
	  NextArrow.prototype.render = function render() {
	    var nextClasses = { 'slick-arrow': true, 'slick-next': true };
	    var nextHandler = this.clickHandler.bind(this, { message: 'next' });
	
	    if (!_helpers2.default.canGoNext(this.props)) {
	      nextClasses['slick-disabled'] = true;
	      nextHandler = null;
	    }
	
	    var nextArrowProps = {
	      key: '1',
	      'data-role': 'none',
	      className: (0, _classnames2.default)(nextClasses),
	      style: { display: 'block' },
	      onClick: nextHandler
	    };
	    var customProps = {
	      currentSlide: this.props.currentSlide,
	      slideCount: this.props.slideCount
	    };
	    var nextArrow = void 0;
	
	    if (this.props.nextArrow) {
	      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
	    } else {
	      nextArrow = _react2.default.createElement(
	        'button',
	        _extends({ key: '1', type: 'button' }, nextArrowProps),
	        ' Next'
	      );
	    }
	
	    return nextArrow;
	  };
	
	  return NextArrow;
	}(_react2.default.Component);

/***/ },
/* 2864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Dots = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	  dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  return dots;
	};
	
	var Dots = exports.Dots = function (_React$Component) {
	  _inherits(Dots, _React$Component);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Dots.prototype.clickHandler = function clickHandler(options, e) {
	    // In Autoplay the focus stays on clicked button even after transition
	    // to next slide. That only goes away by click somewhere outside
	    e.preventDefault();
	    this.props.clickHandler(options);
	  };
	
	  Dots.prototype.render = function render() {
	    var _this2 = this;
	
	    var dotCount = getDotCount({
	      slideCount: this.props.slideCount,
	      slidesToScroll: this.props.slidesToScroll
	    });
	
	    // Apply join & split to Array to pre-fill it for IE8
	    //
	    // Credit: http://stackoverflow.com/a/13735425/1849458
	    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
	
	      var leftBound = i * _this2.props.slidesToScroll;
	      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
	      var className = (0, _classnames2.default)({
	        'slick-active': _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
	      });
	
	      var dotOptions = {
	        message: 'dots',
	        index: i,
	        slidesToScroll: _this2.props.slidesToScroll,
	        currentSlide: _this2.props.currentSlide
	      };
	
	      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
	
	      return _react2.default.createElement(
	        'li',
	        { key: i, className: className },
	        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
	      );
	    });
	
	    return _react2.default.createElement(
	      'ul',
	      { className: this.props.dotsClass, style: { display: 'block' } },
	      dots
	    );
	  };
	
	  return Dots;
	}(_react2.default.Component);

/***/ },
/* 2865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2869);

/***/ },
/* 2866 */
/***/ function(module, exports) {

	"use strict";
	
	var initialState = {
	    animating: false,
	    dragging: false,
	    autoPlayTimer: null,
	    currentDirection: 0,
	    currentLeft: null,
	    currentSlide: 0,
	    direction: 1,
	    listWidth: null,
	    listHeight: null,
	    scrolling: false,
	    // loadIndex: 0,
	    slideCount: null,
	    slideWidth: null,
	    slideHeight: null,
	    swiping: false,
	    // sliding: false,
	    // slideOffset: 0,
	    swipeLeft: null,
	    touchObject: {
	        startX: 0,
	        startY: 0,
	        curX: 0,
	        curY: 0
	    },
	
	    lazyLoadedList: [],
	
	    // added for react
	    initialized: false,
	    edgeDragged: false,
	    swiped: false, // used by swipeEvent. differentites between touch and swipe.
	    trackStyle: {},
	    trackWidth: 0
	
	    // Removed
	    // transformsEnabled: false,
	    // $nextArrow: null,
	    // $prevArrow: null,
	    // $dots: null,
	    // $list: null,
	    // $slideTrack: null,
	    // $slides: null,
	};
	
	module.exports = initialState;

/***/ },
/* 2867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.InnerSlider = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _eventHandlers = __webpack_require__(2868);
	
	var _eventHandlers2 = _interopRequireDefault(_eventHandlers);
	
	var _helpers = __webpack_require__(517);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _initialState = __webpack_require__(2866);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	var _defaultProps = __webpack_require__(1297);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _track = __webpack_require__(2870);
	
	var _dots = __webpack_require__(2864);
	
	var _arrows = __webpack_require__(2863);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InnerSlider = exports.InnerSlider = (0, _createReactClass2.default)({
	  displayName: 'InnerSlider',
	
	  mixins: [_helpers2.default, _eventHandlers2.default],
	  list: null,
	  track: null,
	  listRefHandler: function listRefHandler(ref) {
	    this.list = ref;
	  },
	  trackRefHandler: function trackRefHandler(ref) {
	    this.track = ref;
	  },
	  getInitialState: function getInitialState() {
	    return _extends({}, _initialState2.default, {
	      currentSlide: this.props.initialSlide
	    });
	  },
	  getDefaultProps: function getDefaultProps() {
	    return _defaultProps2.default;
	  },
	  componentWillMount: function componentWillMount() {
	    if (this.props.init) {
	      this.props.init();
	    }
	    this.setState({
	      mounted: true
	    });
	    var lazyLoadedList = [];
	    for (var i = 0; i < _react2.default.Children.count(this.props.children); i++) {
	      if (i >= this.state.currentSlide && i < this.state.currentSlide + this.props.slidesToShow) {
	        lazyLoadedList.push(i);
	      }
	    }
	
	    if (this.props.lazyLoad && this.state.lazyLoadedList.length === 0) {
	      this.setState({
	        lazyLoadedList: lazyLoadedList
	      });
	    }
	  },
	  componentDidMount: function componentDidMount() {
	    // Hack for autoplay -- Inspect Later
	    this.initialize(this.props);
	    this.adaptHeight();
	
	    // To support server-side rendering
	    if (!window) {
	      return;
	    }
	    if (window.addEventListener) {
	      window.addEventListener('resize', this.onWindowResized);
	    } else {
	      window.attachEvent('onresize', this.onWindowResized);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this.animationEndCallback) {
	      clearTimeout(this.animationEndCallback);
	    }
	    if (window.addEventListener) {
	      window.removeEventListener('resize', this.onWindowResized);
	    } else {
	      window.detachEvent('onresize', this.onWindowResized);
	    }
	    if (this.state.autoPlayTimer) {
	      clearInterval(this.state.autoPlayTimer);
	    }
	  },
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	    if (this.props.slickGoTo != nextProps.slickGoTo) {
	      if (false) {
	        console.warn('react-slick deprecation warning: slickGoTo prop is deprecated and it will be removed in next release. Use slickGoTo method instead');
	      }
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.slickGoTo,
	        currentSlide: this.state.currentSlide
	      });
	    } else if (this.state.currentSlide >= nextProps.children.length) {
	      this.update(nextProps);
	      this.changeSlide({
	        message: 'index',
	        index: nextProps.children.length - nextProps.slidesToShow,
	        currentSlide: this.state.currentSlide
	      });
	    } else {
	      this.update(nextProps);
	    }
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    this.adaptHeight();
	  },
	  onWindowResized: function onWindowResized() {
	    this.update(this.props);
	    // animating state should be cleared while resizing, otherwise autoplay stops working
	    this.setState({
	      animating: false
	    });
	    clearTimeout(this.animationEndCallback);
	    delete this.animationEndCallback;
	  },
	  slickPrev: function slickPrev() {
	    this.changeSlide({ message: 'previous' });
	  },
	  slickNext: function slickNext() {
	    this.changeSlide({ message: 'next' });
	  },
	  slickGoTo: function slickGoTo(slide) {
	    slide = Number(slide);
	    !isNaN(slide) && this.changeSlide({
	      message: 'index',
	      index: slide,
	      currentSlide: this.state.currentSlide
	    });
	  },
	  render: function render() {
	    var className = (0, _classnames2.default)('slick-initialized', 'slick-slider', this.props.className, {
	      'slick-vertical': this.props.vertical
	    });
	
	    var trackProps = {
	      fade: this.props.fade,
	      cssEase: this.props.cssEase,
	      speed: this.props.speed,
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      focusOnSelect: this.props.focusOnSelect ? this.selectHandler : null,
	      currentSlide: this.state.currentSlide,
	      lazyLoad: this.props.lazyLoad,
	      lazyLoadedList: this.state.lazyLoadedList,
	      rtl: this.props.rtl,
	      slideWidth: this.state.slideWidth,
	      slidesToShow: this.props.slidesToShow,
	      slidesToScroll: this.props.slidesToScroll,
	      slideCount: this.state.slideCount,
	      trackStyle: this.state.trackStyle,
	      variableWidth: this.props.variableWidth
	    };
	
	    var dots;
	
	    if (this.props.dots === true && this.state.slideCount >= this.props.slidesToShow) {
	      var dotProps = {
	        dotsClass: this.props.dotsClass,
	        slideCount: this.state.slideCount,
	        slidesToShow: this.props.slidesToShow,
	        currentSlide: this.state.currentSlide,
	        slidesToScroll: this.props.slidesToScroll,
	        clickHandler: this.changeSlide,
	        children: this.props.children,
	        customPaging: this.props.customPaging
	      };
	
	      dots = _react2.default.createElement(_dots.Dots, dotProps);
	    }
	
	    var prevArrow, nextArrow;
	
	    var arrowProps = {
	      infinite: this.props.infinite,
	      centerMode: this.props.centerMode,
	      currentSlide: this.state.currentSlide,
	      slideCount: this.state.slideCount,
	      slidesToShow: this.props.slidesToShow,
	      prevArrow: this.props.prevArrow,
	      nextArrow: this.props.nextArrow,
	      clickHandler: this.changeSlide
	    };
	
	    if (this.props.arrows) {
	      prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
	      nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
	    }
	
	    var verticalHeightStyle = null;
	
	    if (this.props.vertical) {
	      verticalHeightStyle = {
	        height: this.state.listHeight
	      };
	    }
	
	    var centerPaddingStyle = null;
	
	    if (this.props.vertical === false) {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: '0px ' + this.props.centerPadding
	        };
	      }
	    } else {
	      if (this.props.centerMode === true) {
	        centerPaddingStyle = {
	          padding: this.props.centerPadding + ' 0px'
	        };
	      }
	    }
	
	    var listStyle = (0, _objectAssign2.default)({}, verticalHeightStyle, centerPaddingStyle);
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: this.onInnerSliderEnter,
	        onMouseLeave: this.onInnerSliderLeave,
	        onMouseOver: this.onInnerSliderOver
	      },
	      prevArrow,
	      _react2.default.createElement(
	        'div',
	        {
	          ref: this.listRefHandler,
	          className: 'slick-list',
	          style: listStyle,
	          onMouseDown: this.swipeStart,
	          onMouseMove: this.state.dragging ? this.swipeMove : null,
	          onMouseUp: this.swipeEnd,
	          onMouseLeave: this.state.dragging ? this.swipeEnd : null,
	          onTouchStart: this.swipeStart,
	          onTouchMove: this.state.dragging ? this.swipeMove : null,
	          onTouchEnd: this.swipeEnd,
	          onTouchCancel: this.state.dragging ? this.swipeEnd : null,
	          onKeyDown: this.props.accessibility ? this.keyHandler : null },
	        _react2.default.createElement(
	          _track.Track,
	          _extends({ ref: this.trackRefHandler }, trackProps),
	          this.props.children
	        )
	      ),
	      nextArrow,
	      dots
	    );
	  }
	});

/***/ },
/* 2868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackHelper = __webpack_require__(1298);
	
	var _helpers = __webpack_require__(517);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _reactDom = __webpack_require__(14);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EventHandlers = {
	  // Event handler for previous and next
	  changeSlide: function changeSlide(options) {
	    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	    var _props = this.props,
	        slidesToScroll = _props.slidesToScroll,
	        slidesToShow = _props.slidesToShow;
	    var _state = this.state,
	        slideCount = _state.slideCount,
	        currentSlide = _state.currentSlide;
	
	    unevenOffset = slideCount % slidesToScroll !== 0;
	    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	    if (options.message === 'previous') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	      targetSlide = currentSlide - slideOffset;
	      if (this.props.lazyLoad) {
	        previousInt = currentSlide - slideOffset;
	        targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	      }
	    } else if (options.message === 'next') {
	      slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	      targetSlide = currentSlide + slideOffset;
	      if (this.props.lazyLoad) {
	        targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	      }
	    } else if (options.message === 'dots' || options.message === 'children') {
	      // Click on dots
	      targetSlide = options.index * options.slidesToScroll;
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    } else if (options.message === 'index') {
	      targetSlide = Number(options.index);
	      if (targetSlide === options.currentSlide) {
	        return;
	      }
	    }
	
	    this.slideHandler(targetSlide);
	  },
	
	  // Accessiblity handler for previous and next
	  keyHandler: function keyHandler(e) {
	    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	    if (!e.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	      if (e.keyCode === 37 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'next' : 'previous'
	        });
	      } else if (e.keyCode === 39 && this.props.accessibility === true) {
	        this.changeSlide({
	          message: this.props.rtl === true ? 'previous' : 'next'
	        });
	      }
	    }
	  },
	  // Focus on selecting a slide (click handler on track)
	  selectHandler: function selectHandler(options) {
	    this.changeSlide(options);
	  },
	  swipeStart: function swipeStart(e) {
	    var touches, posX, posY;
	
	    if (this.props.swipe === false || 'ontouchend' in document && this.props.swipe === false) {
	      return;
	    } else if (this.props.draggable === false && e.type.indexOf('mouse') !== -1) {
	      return;
	    }
	    posX = e.touches !== undefined ? e.touches[0].pageX : e.clientX;
	    posY = e.touches !== undefined ? e.touches[0].pageY : e.clientY;
	    this.setState({
	      dragging: true,
	      touchObject: {
	        startX: posX,
	        startY: posY,
	        curX: posX,
	        curY: posY
	      }
	    });
	  },
	  swipeMove: function swipeMove(e) {
	    if (!this.state.dragging) {
	      e.preventDefault();
	      return;
	    }
	    if (this.state.scrolling) {
	      return;
	    }
	    if (this.state.animating) {
	      e.preventDefault();
	      return;
	    }
	    if (this.props.vertical && this.props.swipeToSlide && this.props.verticalSwiping) {
	      e.preventDefault();
	    }
	    var swipeLeft;
	    var curLeft, positionOffset;
	    var touchObject = this.state.touchObject;
	
	    curLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	      slideIndex: this.state.currentSlide,
	      trackRef: this.track
	    }, this.props, this.state));
	    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	    if (!this.props.verticalSwiping && !this.state.swiping && verticalSwipeLength > 4) {
	      this.setState({
	        scrolling: true
	      });
	      return;
	    }
	
	    if (this.props.verticalSwiping) {
	      touchObject.swipeLength = verticalSwipeLength;
	    }
	
	    positionOffset = (this.props.rtl === false ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	
	    if (this.props.verticalSwiping) {
	      positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	    }
	
	    var currentSlide = this.state.currentSlide;
	    var dotCount = Math.ceil(this.state.slideCount / this.props.slidesToScroll);
	    var swipeDirection = this.swipeDirection(this.state.touchObject);
	    var touchSwipeLength = touchObject.swipeLength;
	
	    if (this.props.infinite === false) {
	      if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left') {
	        touchSwipeLength = touchObject.swipeLength * this.props.edgeFriction;
	
	        if (this.state.edgeDragged === false && this.props.edgeEvent) {
	          this.props.edgeEvent(swipeDirection);
	          this.setState({ edgeDragged: true });
	        }
	      }
	    }
	
	    if (this.state.swiped === false && this.props.swipeEvent) {
	      this.props.swipeEvent(swipeDirection);
	      this.setState({ swiped: true });
	    }
	
	    if (!this.props.vertical) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft + touchSwipeLength * (this.state.listHeight / this.state.listWidth) * positionOffset;
	    }
	
	    if (this.props.verticalSwiping) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    }
	
	    this.setState({
	      touchObject: touchObject,
	      swipeLeft: swipeLeft,
	      trackStyle: (0, _trackHelper.getTrackCSS)((0, _objectAssign2.default)({ left: swipeLeft }, this.props, this.state))
	    });
	
	    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	      return;
	    }
	    if (touchObject.swipeLength > 4) {
	      this.setState({
	        swiping: true
	      });
	      e.preventDefault();
	    }
	  },
	  getNavigableIndexes: function getNavigableIndexes() {
	    var max = void 0;
	    var breakPoint = 0;
	    var counter = 0;
	    var indexes = [];
	
	    if (!this.props.infinite) {
	      max = this.state.slideCount;
	    } else {
	      breakPoint = this.props.slidesToShow * -1;
	      counter = this.props.slidesToShow * -1;
	      max = this.state.slideCount * 2;
	    }
	
	    while (breakPoint < max) {
	      indexes.push(breakPoint);
	      breakPoint = counter + this.props.slidesToScroll;
	
	      counter += this.props.slidesToScroll <= this.props.slidesToShow ? this.props.slidesToScroll : this.props.slidesToShow;
	    }
	
	    return indexes;
	  },
	  checkNavigable: function checkNavigable(index) {
	    var navigables = this.getNavigableIndexes();
	    var prevNavigable = 0;
	
	    if (index > navigables[navigables.length - 1]) {
	      index = navigables[navigables.length - 1];
	    } else {
	      for (var n in navigables) {
	        if (index < navigables[n]) {
	          index = prevNavigable;
	          break;
	        }
	
	        prevNavigable = navigables[n];
	      }
	    }
	
	    return index;
	  },
	  getSlideCount: function getSlideCount() {
	    var _this = this;
	
	    var centerOffset = this.props.centerMode ? this.state.slideWidth * Math.floor(this.props.slidesToShow / 2) : 0;
	
	    if (this.props.swipeToSlide) {
	      var swipedSlide = void 0;
	
	      var slickList = _reactDom2.default.findDOMNode(this.list);
	
	      var slides = slickList.querySelectorAll('.slick-slide');
	
	      Array.from(slides).every(function (slide) {
	        if (!_this.props.vertical) {
	          if (slide.offsetLeft - centerOffset + _this.getWidth(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        } else {
	          if (slide.offsetTop + _this.getHeight(slide) / 2 > _this.state.swipeLeft * -1) {
	            swipedSlide = slide;
	            return false;
	          }
	        }
	
	        return true;
	      });
	
	      var slidesTraversed = Math.abs(swipedSlide.dataset.index - this.state.currentSlide) || 1;
	
	      return slidesTraversed;
	    } else {
	      return this.props.slidesToScroll;
	    }
	  },
	
	  swipeEnd: function swipeEnd(e) {
	    if (!this.state.dragging) {
	      if (this.props.swipe) {
	        e.preventDefault();
	      }
	      return;
	    }
	    var touchObject = this.state.touchObject;
	    var minSwipe = this.state.listWidth / this.props.touchThreshold;
	    var swipeDirection = this.swipeDirection(touchObject);
	
	    if (this.props.verticalSwiping) {
	      minSwipe = this.state.listHeight / this.props.touchThreshold;
	    }
	
	    var wasScrolling = this.state.scrolling;
	    // reset the state of touch related state variables.
	    this.setState({
	      dragging: false,
	      edgeDragged: false,
	      scrolling: false,
	      swiping: false,
	      swiped: false,
	      swipeLeft: null,
	      touchObject: {}
	    });
	    if (wasScrolling) {
	      return;
	    }
	
	    // Fix for #13
	    if (!touchObject.swipeLength) {
	      return;
	    }
	    if (touchObject.swipeLength > minSwipe) {
	      e.preventDefault();
	
	      var slideCount = void 0,
	          newSlide = void 0;
	
	      switch (swipeDirection) {
	
	        case 'left':
	        case 'down':
	          newSlide = this.state.currentSlide + this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 0;
	          break;
	
	        case 'right':
	        case 'up':
	          newSlide = this.state.currentSlide - this.getSlideCount();
	          slideCount = this.props.swipeToSlide ? this.checkNavigable(newSlide) : newSlide;
	          this.state.currentDirection = 1;
	          break;
	
	        default:
	          slideCount = this.state.currentSlide;
	
	      }
	
	      this.slideHandler(slideCount);
	    } else {
	      // Adjust the track back to it's original position.
	      var currentLeft = (0, _trackHelper.getTrackLeft)((0, _objectAssign2.default)({
	        slideIndex: this.state.currentSlide,
	        trackRef: this.track
	      }, this.props, this.state));
	
	      this.setState({
	        trackStyle: (0, _trackHelper.getTrackAnimateCSS)((0, _objectAssign2.default)({ left: currentLeft }, this.props, this.state))
	      });
	    }
	  },
	  onInnerSliderEnter: function onInnerSliderEnter(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderOver: function onInnerSliderOver(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.pause();
	    }
	  },
	  onInnerSliderLeave: function onInnerSliderLeave(e) {
	    if (this.props.autoplay && this.props.pauseOnHover) {
	      this.autoPlay();
	    }
	  }
	};
	
	exports.default = EventHandlers;

/***/ },
/* 2869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _innerSlider = __webpack_require__(2867);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _json2mq = __webpack_require__(2305);
	
	var _json2mq2 = _interopRequireDefault(_json2mq);
	
	var _defaultProps = __webpack_require__(1297);
	
	var _defaultProps2 = _interopRequireDefault(_defaultProps);
	
	var _canUseDom = __webpack_require__(1810);
	
	var _canUseDom2 = _interopRequireDefault(_canUseDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var enquire = _canUseDom2.default && __webpack_require__(933);
	
	var Slider = function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    _classCallCheck(this, Slider);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    _this.innerSliderRefHandler = _this.innerSliderRefHandler.bind(_this);
	    return _this;
	  }
	
	  Slider.prototype.innerSliderRefHandler = function innerSliderRefHandler(ref) {
	    this.innerSlider = ref;
	  };
	
	  Slider.prototype.media = function media(query, handler) {
	    enquire.register(query, handler);
	    this._responsiveMediaHandlers.push({ query: query, handler: handler });
	  };
	
	  Slider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    if (this.props.responsive) {
	      var breakpoints = this.props.responsive.map(function (breakpt) {
	        return breakpt.breakpoint;
	      });
	      breakpoints.sort(function (x, y) {
	        return x - y;
	      });
	
	      breakpoints.forEach(function (breakpoint, index) {
	        var bQuery;
	        if (index === 0) {
	          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
	        } else {
	          bQuery = (0, _json2mq2.default)({ minWidth: breakpoints[index - 1], maxWidth: breakpoint });
	        }
	        _canUseDom2.default && _this2.media(bQuery, function () {
	          _this2.setState({ breakpoint: breakpoint });
	        });
	      });
	
	      // Register media query for full screen. Need to support resize from small to large
	      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });
	
	      _canUseDom2.default && this.media(query, function () {
	        _this2.setState({ breakpoint: null });
	      });
	    }
	  };
	
	  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._responsiveMediaHandlers.forEach(function (obj) {
	      enquire.unregister(obj.query, obj.handler);
	    });
	  };
	
	  Slider.prototype.slickPrev = function slickPrev() {
	    this.innerSlider.slickPrev();
	  };
	
	  Slider.prototype.slickNext = function slickNext() {
	    this.innerSlider.slickNext();
	  };
	
	  Slider.prototype.slickGoTo = function slickGoTo(slide) {
	    this.innerSlider.slickGoTo(slide);
	  };
	
	  Slider.prototype.render = function render() {
	    var _this3 = this;
	
	    var settings;
	    var newProps;
	    if (this.state.breakpoint) {
	      newProps = this.props.responsive.filter(function (resp) {
	        return resp.breakpoint === _this3.state.breakpoint;
	      });
	      settings = newProps[0].settings === 'unslick' ? 'unslick' : (0, _objectAssign2.default)({}, this.props, newProps[0].settings);
	    } else {
	      settings = (0, _objectAssign2.default)({}, _defaultProps2.default, this.props);
	    }
	
	    var children = this.props.children;
	    if (!Array.isArray(children)) {
	      children = [children];
	    }
	
	    // Children may contain false or null, so we should filter them
	    children = children.filter(function (child) {
	      return !!child;
	    });
	
	    if (settings === 'unslick') {
	      // if 'unslick' responsive breakpoint setting used, just return the <Slider> tag nested HTML
	      return _react2.default.createElement(
	        'div',
	        { className: this.props.className + ' unslicked' },
	        children
	      );
	    } else {
	      return _react2.default.createElement(
	        _innerSlider.InnerSlider,
	        _extends({ ref: this.innerSliderRefHandler }, settings),
	        children
	      );
	    }
	  };
	
	  return Slider;
	}(_react2.default.Component);
	
	exports.default = Slider;

/***/ },
/* 2870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Track = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(25);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	  slickCloned = index < 0 || index >= spec.slideCount;
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	  return (0, _classnames2.default)({
	    'slick-slide': true,
	    'slick-active': slickActive,
	    'slick-center': slickCenter,
	    'slick-cloned': slickCloned
	  });
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = 'relative';
	    style.left = -spec.index * spec.slideWidth;
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	    style.WebkitTransition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  // key could be a zero
	  return child.key === null || child.key === undefined ? fallbackKey : child.key;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	  var count = _react2.default.Children.count(spec.children);
	
	  _react2.default.Children.forEach(spec.children, function (elem, index) {
	    var child = void 0;
	    var childOnClickOptions = {
	      message: 'children',
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    };
	
	    if (!spec.lazyLoad | (spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0)) {
	      child = elem;
	    } else {
	      child = _react2.default.createElement('div', null);
	    }
	    var childStyle = getSlideStyle((0, _objectAssign2.default)({}, spec, { index: index }));
	    var slideClass = child.props.className || '';
	
	    var onClick = function onClick(e) {
	      child.props && child.props.onClick && child.props.onClick(e);
	      if (spec.focusOnSelect) {
	        spec.focusOnSelect(childOnClickOptions);
	      }
	    };
	
	    slides.push(_react2.default.cloneElement(child, {
	      key: 'original' + getKey(child, index),
	      'data-index': index,
	      className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: index }, spec)), slideClass),
	      tabIndex: '-1',
	      style: (0, _objectAssign2.default)({ outline: 'none' }, child.props.style || {}, childStyle),
	      onClick: onClick
	    }));
	
	    // variableWidth doesn't wrap properly.
	    if (spec.infinite && spec.fade === false) {
	      var infiniteCount = spec.variableWidth ? spec.slidesToShow + 1 : spec.slidesToShow;
	
	      if (index >= count - infiniteCount) {
	        key = -(count - index);
	        preCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'precloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	
	      if (index < infiniteCount) {
	        key = count + index;
	        postCloneSlides.push(_react2.default.cloneElement(child, {
	          key: 'postcloned' + getKey(child, key),
	          'data-index': key,
	          className: (0, _classnames2.default)(getSlideClasses((0, _objectAssign2.default)({ index: key }, spec)), slideClass),
	          style: (0, _objectAssign2.default)({}, child.props.style || {}, childStyle),
	          onClick: onClick
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track = exports.Track = function (_React$Component) {
	  _inherits(Track, _React$Component);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Track.prototype.render = function render() {
	    var slides = renderSlides.call(this, this.props);
	    return _react2.default.createElement(
	      'div',
	      { className: 'slick-track', style: this.props.trackStyle },
	      slides
	    );
	  };
	
	  return Track;
	}(_react2.default.Component);

/***/ },
/* 2871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TransitionGroup = __webpack_require__(2903);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AnimateGroupChild = __webpack_require__(2872);
	
	var _AnimateGroupChild2 = _interopRequireDefault(_AnimateGroupChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AnimateGroup = (_temp = _class = function (_Component) {
	  _inherits(AnimateGroup, _Component);
	
	  function AnimateGroup() {
	    _classCallCheck(this, AnimateGroup);
	
	    return _possibleConstructorReturn(this, (AnimateGroup.__proto__ || Object.getPrototypeOf(AnimateGroup)).apply(this, arguments));
	  }
	
	  _createClass(AnimateGroup, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          component = _props.component,
	          children = _props.children,
	          appear = _props.appear,
	          enter = _props.enter,
	          leave = _props.leave;
	
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        { component: component },
	        _react.Children.map(children, function (child, index) {
	          return _react2.default.createElement(
	            _AnimateGroupChild2.default,
	            {
	              appearOptions: appear,
	              enterOptions: enter,
	              leaveOptions: leave,
	              key: 'child-' + index
	            },
	            child
	          );
	        })
	      );
	    }
	  }]);
	
	  return AnimateGroup;
	}(_react.Component), _class.propTypes = {
	  appear: _propTypes2.default.object,
	  enter: _propTypes2.default.object,
	  leave: _propTypes2.default.object,
	
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  component: _propTypes2.default.any
	}, _class.defaultProps = {
	  component: 'span'
	}, _temp);
	exports.default = AnimateGroup;

/***/ },
/* 2872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNumber2 = __webpack_require__(462);
	
	var _isNumber3 = _interopRequireDefault(_isNumber2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp2;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(1310);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Animate = __webpack_require__(1299);
	
	var _Animate2 = _interopRequireDefault(_Animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var steps = options.steps,
	      duration = options.duration;
	
	
	  if (steps && steps.length) {
	    return steps.reduce(function (result, entry) {
	      return result + ((0, _isNumber3.default)(entry.duration) && entry.duration > 0 ? entry.duration : 0);
	    }, 0);
	  }
	
	  if ((0, _isNumber3.default)(duration)) {
	    return duration;
	  }
	
	  return 0;
	};
	
	var AnimateGroupChild = (_temp2 = _class = function (_Component) {
	  _inherits(AnimateGroupChild, _Component);
	
	  function AnimateGroupChild() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AnimateGroupChild);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimateGroupChild.__proto__ || Object.getPrototypeOf(AnimateGroupChild)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _this.handleEnter = function (node, isAppearing) {
	      var _this$props = _this.props,
	          appearOptions = _this$props.appearOptions,
	          enterOptions = _this$props.enterOptions;
	
	
	      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
	    }, _this.handleExit = function () {
	      _this.handleStyleActive(_this.props.leaveOptions);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AnimateGroupChild, [{
	    key: 'handleStyleActive',
	    value: function handleStyleActive(style) {
	      if (style) {
	        var onAnimationEnd = style.onAnimationEnd ? function () {
	          style.onAnimationEnd();
	        } : null;
	
	        this.setState(_extends({}, style, {
	          onAnimationEnd: onAnimationEnd,
	          isActive: true
	        }));
	      }
	    }
	  }, {
	    key: 'parseTimeout',
	    value: function parseTimeout() {
	      var _props = this.props,
	          appearOptions = _props.appearOptions,
	          enterOptions = _props.enterOptions,
	          leaveOptions = _props.leaveOptions;
	
	
	      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          appearOptions = _props2.appearOptions,
	          enterOptions = _props2.enterOptions,
	          leaveOptions = _props2.leaveOptions,
	          props = _objectWithoutProperties(_props2, ['children', 'appearOptions', 'enterOptions', 'leaveOptions']);
	
	      return _react2.default.createElement(
	        _Transition2.default,
	        _extends({}, props, {
	          onEnter: this.handleEnter,
	          onExit: this.handleExit,
	          timeout: this.parseTimeout()
	        }),
	        function (transitionState) {
	          return _react2.default.createElement(
	            _Animate2.default,
	            _this2.state,
	            _react.Children.only(children)
	          );
	        }
	      );
	    }
	  }]);
	
	  return AnimateGroupChild;
	}(_react.Component), _class.propTypes = {
	  appearOptions: _propTypes2.default.object,
	  enterOptions: _propTypes2.default.object,
	  leaveOptions: _propTypes2.default.object,
	  children: _propTypes2.default.element
	}, _temp2);
	exports.default = AnimateGroupChild;

/***/ },
/* 2873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = createAnimateManager;
	
	var _setRafTimeout = __webpack_require__(2876);
	
	var _setRafTimeout2 = _interopRequireDefault(_setRafTimeout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function createAnimateManager() {
	  var currStyle = {};
	  var handleChange = function handleChange() {
	    return null;
	  };
	  var shouldStop = false;
	
	  var setStyle = function setStyle(_style) {
	    if (shouldStop) {
	      return;
	    }
	
	    if (Array.isArray(_style)) {
	      if (!_style.length) {
	        return;
	      }
	
	      var styles = _style;
	
	      var _styles = _toArray(styles),
	          curr = _styles[0],
	          restStyles = _styles.slice(1);
	
	      if (typeof curr === 'number') {
	        (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles), curr);
	
	        return;
	      }
	
	      setStyle(curr);
	      (0, _setRafTimeout2.default)(setStyle.bind(null, restStyles));
	      return;
	    }
	
	    if ((typeof _style === 'undefined' ? 'undefined' : _typeof(_style)) === 'object') {
	      currStyle = _style;
	      handleChange(currStyle);
	    }
	
	    if (typeof _style === 'function') {
	      _style();
	    }
	  };
	
	  return {
	    stop: function stop() {
	      shouldStop = true;
	    },
	    start: function start(style) {
	      shouldStop = false;
	      setStyle(style);
	    },
	    subscribe: function subscribe(_handleChange) {
	      handleChange = _handleChange;
	
	      return function () {
	        handleChange = function handleChange() {
	          return null;
	        };
	      };
	    }
	  };
	}

/***/ },
/* 2874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shallowEqual = undefined;
	
	var _isPlainObject2 = __webpack_require__(88);
	
	var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);
	
	var _isEqual2 = __webpack_require__(86);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    var keyA = keysA[i];
	
	    if (objA[keyA] === objB[keyA]) {
	      continue;
	    }
	
	    // special diff with Array or Object
	    if ((0, _isArray3.default)(objA[keyA])) {
	      if (!(0, _isArray3.default)(objB[keyA]) || objA[keyA].length !== objB[keyA].length) {
	        return false;
	      } else if (!(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if ((0, _isPlainObject3.default)(objA[keyA])) {
	      if (!(0, _isPlainObject3.default)(objB[keyA]) || !(0, _isEqual3.default)(objA[keyA], objB[keyA])) {
	        return false;
	      }
	    } else if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	
	function shouldComponentUpdate(nextProps, nextState) {
	  return shallowCompare(this, nextProps, nextState);
	}
	/* eslint-disable no-param-reassign */
	function pureRenderDecorator(component) {
	  component.prototype.shouldComponentUpdate = shouldComponentUpdate;
	}
	exports.shallowEqual = shallowEqual;
	exports.default = pureRenderDecorator;

/***/ },
/* 2875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _filter2 = __webpack_require__(2428);
	
	var _filter3 = _interopRequireDefault(_filter2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _raf = __webpack_require__(237);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _util = __webpack_require__(351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alpha = function alpha(begin, end, k) {
	  return begin + (end - begin) * k;
	};
	var needContinue = function needContinue(_ref) {
	  var from = _ref.from,
	      to = _ref.to;
	  return from !== to;
	};
	
	/*
	 * @description: cal new from value and velocity in each stepper
	 * @return: { [styleProperty]: { from, to, velocity } }
	 */
	var calStepperVals = function calStepperVals(easing, preVals, steps) {
	  var nextStepVals = (0, _util.mapObject)(function (key, val) {
	    if (needContinue(val)) {
	      var _easing = easing(val.from, val.to, val.velocity),
	          _easing2 = _slicedToArray(_easing, 2),
	          newX = _easing2[0],
	          newV = _easing2[1];
	
	      return _extends({}, val, {
	        from: newX,
	        velocity: newV
	      });
	    }
	
	    return val;
	  }, preVals);
	
	  if (steps < 1) {
	    return (0, _util.mapObject)(function (key, val) {
	      if (needContinue(val)) {
	        return _extends({}, val, {
	          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
	          from: alpha(val.from, nextStepVals[key].from, steps)
	        });
	      }
	
	      return val;
	    }, preVals);
	  }
	
	  return calStepperVals(easing, nextStepVals, steps - 1);
	};
	
	// configure update function
	
	exports.default = function (from, to, easing, duration, render) {
	  var interKeys = (0, _util.getIntersectionKeys)(from, to);
	  var timingStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, [from[key], to[key]]));
	  }, {});
	
	  var stepperStyle = interKeys.reduce(function (res, key) {
	    return _extends({}, res, _defineProperty({}, key, {
	      from: from[key],
	      velocity: 0,
	      to: to[key]
	    }));
	  }, {});
	  var cafId = -1;
	  var preTime = void 0;
	  var beginTime = void 0;
	  var update = function update() {
	    return null;
	  };
	
	  var getCurrStyle = function getCurrStyle() {
	    return (0, _util.mapObject)(function (key, val) {
	      return val.from;
	    }, stepperStyle);
	  };
	  var shouldStopAnimation = function shouldStopAnimation() {
	    return !(0, _filter3.default)(stepperStyle, needContinue).length;
	  };
	
	  // stepper timing function like spring
	  var stepperUpdate = function stepperUpdate(now) {
	    if (!preTime) {
	      preTime = now;
	    }
	    var deltaTime = now - preTime;
	    var steps = deltaTime / easing.dt;
	
	    stepperStyle = calStepperVals(easing, stepperStyle, steps);
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, getCurrStyle(stepperStyle)));
	
	    preTime = now;
	
	    if (!shouldStopAnimation()) {
	      cafId = (0, _raf2.default)(update);
	    }
	  };
	
	  // t => val timing function like cubic-bezier
	  var timingUpdate = function timingUpdate(now) {
	    if (!beginTime) {
	      beginTime = now;
	    }
	
	    var t = (now - beginTime) / duration;
	    var currStyle = (0, _util.mapObject)(function (key, val) {
	      return alpha.apply(undefined, _toConsumableArray(val).concat([easing(t)]));
	    }, timingStyle);
	
	    // get union set and add compatible prefix
	    render(_extends({}, from, to, currStyle));
	
	    if (t < 1) {
	      cafId = (0, _raf2.default)(update);
	    } else {
	      var finalStyle = (0, _util.mapObject)(function (key, val) {
	        return alpha.apply(undefined, _toConsumableArray(val).concat([easing(1)]));
	      }, timingStyle);
	
	      render(_extends({}, from, to, finalStyle));
	    }
	  };
	
	  update = easing.isStepper ? stepperUpdate : timingUpdate;
	
	  // return start animation method
	  return function () {
	    (0, _raf2.default)(update);
	
	    // return stop animation method
	    return function () {
	      (0, _raf.cancel)(cafId);
	    };
	  };
	};

/***/ },
/* 2876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRafTimeout;
	
	var _raf = __webpack_require__(237);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function setRafTimeout(callback) {
	  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var currTime = -1;
	
	  var shouldUpdate = function shouldUpdate(now) {
	    if (currTime < 0) {
	      currTime = now;
	    }
	
	    if (now - currTime > timeout) {
	      callback(now);
	      currTime = -1;
	    } else {
	      (0, _raf2.default)(shouldUpdate);
	    }
	  };
	
	  (0, _raf2.default)(shouldUpdate);
	}

/***/ },
/* 2877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(1301);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(352);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      elementRef = props.elementRef,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      onBlur = props.onBlur,
	      onReady = props.onReady,
	      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onChange', 'onFocus', 'onBlur', 'onReady']);
	
	  return options;
	};
	
	var Element = function Element(type) {
	  var _class, _temp;
	
	  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.handleRef = function (ref) {
	        _this._ref = ref;
	      };
	
	      _this._element = null;
	
	      var options = _extractOptions(_this.props);
	      // We keep track of the extracted options on this._options to avoid re-rendering.
	      // (We would unnecessarily re-render if we were tracking them with state.)
	      _this._options = options;
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.context.addElementsLoadListener(function (elements) {
	        var element = elements.create(type, _this2._options);
	        _this2._element = element;
	
	        _this2._setupEventListeners(element);
	
	        element.mount(_this2._ref);
	        if (hocOptions.sourceType) {
	          _this2.context.registerElement(hocOptions.sourceType, element);
	        }
	      });
	    };
	
	    _class.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var options = _extractOptions(nextProps);
	      if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	        this._options = options;
	        if (this._element) {
	          this._element.update(options);
	        }
	      }
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this._element) {
	        var element = this._element;
	        element.destroy();
	        this.context.unregisterElement(element);
	      }
	    };
	
	    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
	      var _this3 = this;
	
	      element.on('ready', function () {
	        if (_this3.props.elementRef) {
	          if (window.console && window.console.warn) {
	            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
	          }
	          _this3.props.elementRef(_this3._element);
	        }
	        _this3.props.onReady(_this3._element);
	      });
	
	      element.on('change', function (change) {
	        _this3.props.onChange(change);
	      });
	
	      element.on('blur', function () {
	        var _props;
	
	        return (_props = _this3.props).onBlur.apply(_props, arguments);
	      });
	      element.on('focus', function () {
	        var _props2;
	
	        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
	      });
	    };
	
	    _class.prototype.render = function render() {
	      return _react2.default.createElement('div', {
	        id: this.props.id,
	        className: this.props.className,
	        ref: this.handleRef
	      });
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.propTypes = {
	    id: _propTypes2.default.string,
	    className: _propTypes2.default.string,
	    elementRef: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onReady: _propTypes2.default.func
	  }, _class.defaultProps = {
	    id: undefined,
	    className: undefined,
	    elementRef: undefined,
	    onChange: noop,
	    onBlur: noop,
	    onFocus: noop,
	    onReady: noop
	  }, _class.contextTypes = _Elements.elementContextTypes, _temp;
	};
	
	exports.default = Element;

/***/ },
/* 2878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(1301);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Elements = __webpack_require__(352);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var noop = function noop() {};
	
	var _extractOptions = function _extractOptions(props) {
	  var id = props.id,
	      className = props.className,
	      elementRef = props.elementRef,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onReady = props.onReady,
	      paymentRequest = props.paymentRequest,
	      options = _objectWithoutProperties(props, ['id', 'className', 'elementRef', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);
	
	  return options;
	};
	
	var PaymentRequestButtonElement = function (_React$Component) {
	  _inherits(PaymentRequestButtonElement, _React$Component);
	
	  function PaymentRequestButtonElement(props, context) {
	    _classCallCheck(this, PaymentRequestButtonElement);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.handleRef = function (ref) {
	      _this._ref = ref;
	    };
	
	    var options = _extractOptions(props);
	    // We keep track of the extracted options on this._options to avoid re-rendering.
	    // (We would unnecessarily re-render if we were tracking them with state.)
	    _this._options = options;
	    return _this;
	  }
	
	  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.context.addElementsLoadListener(function (elements) {
	      _this2._element = elements.create('paymentRequestButton', _extends({
	        paymentRequest: _this2.props.paymentRequest
	      }, _this2._options));
	      _this2._element.on('ready', function () {
	        if (_this2.props.elementRef) {
	          if (window.console && window.console.warn) {
	            console.warn("'elementRef()' is deprecated and will be removed in a future version of react-stripe-elements. Please use 'onReady()' instead.");
	          }
	          _this2.props.elementRef(_this2._element);
	        }
	        _this2.props.onReady(_this2._element);
	      });
	      _this2._element.on('focus', function () {
	        var _props;
	
	        return (_props = _this2.props).onFocus.apply(_props, arguments);
	      });
	      _this2._element.on('click', function () {
	        var _props2;
	
	        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
	      });
	      _this2._element.on('blur', function () {
	        var _props3;
	
	        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
	      });
	      _this2._element.mount(_this2._ref);
	    });
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.paymentRequest !== nextProps.paymentRequest) {
	      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
	    }
	    var options = _extractOptions(nextProps);
	    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
	      this._options = options;
	      this._element.update(options);
	    }
	  };
	
	  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._element.destroy();
	  };
	
	  PaymentRequestButtonElement.prototype.render = function render() {
	    return _react2.default.createElement('div', {
	      id: this.props.id,
	      className: this.props.className,
	      ref: this.handleRef
	    });
	  };
	
	  return PaymentRequestButtonElement;
	}(_react2.default.Component);
	
	PaymentRequestButtonElement.propTypes = {
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  elementRef: _propTypes2.default.func,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  paymentRequest: _propTypes2.default.shape({
	    canMakePayment: _propTypes2.default.func.isRequired,
	    on: _propTypes2.default.func.isRequired,
	    show: _propTypes2.default.func.isRequired
	  }).isRequired
	};
	PaymentRequestButtonElement.defaultProps = {
	  id: undefined,
	  className: undefined,
	  elementRef: undefined,
	  onBlur: noop,
	  onClick: noop,
	  onFocus: noop,
	  onReady: noop
	};
	PaymentRequestButtonElement.contextTypes = _Elements.elementContextTypes;
	exports.default = PaymentRequestButtonElement;

/***/ },
/* 2879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Elements = __webpack_require__(352);
	
	var _Provider = __webpack_require__(518);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
	// not sure if we need to do the same.
	var inject = function inject(WrappedComponent) {
	  var _class, _temp;
	
	  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _componentOptions$wit = componentOptions.withRef,
	      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;
	
	
	  return _temp = _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class(props, context) {
	      _classCallCheck(this, _class);
	
	      if (!context || !context.getRegisteredElements) {
	        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
	      }
	
	      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	      _this.findElement = function (specifiedType) {
	        var allElements = _this.context.getRegisteredElements();
	        var matchingElements = specifiedType === 'auto' ? allElements : allElements.filter(function (_ref) {
	          var type = _ref.type;
	          return type === specifiedType;
	        });
	
	        if (matchingElements.length === 1) {
	          return matchingElements[0].element;
	        } else if (matchingElements.length > 1) {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        } else {
	          return null;
	        }
	      };
	
	      _this.requireElement = function (specifiedType) {
	        var element = _this.findElement(specifiedType);
	        if (element) {
	          return element;
	        } else {
	          throw new Error('You did not specify the type of Source or Token to create.\n        We could not infer which Element you want to use for this operation.');
	        }
	      };
	
	      _this.wrappedCreateToken = function (stripe) {
	        return function () {
	          var typeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	          if (typeOrOptions && (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) === 'object') {
	            var type = typeOrOptions.type,
	                rest = _objectWithoutProperties(typeOrOptions, ['type']);
	
	            var specifiedType = typeof type === 'string' ? type : 'auto';
	            var element = _this.requireElement(specifiedType);
	            return stripe.createToken(element, rest);
	          } else if (typeof typeOrOptions === 'string') {
	            return stripe.createToken(typeOrOptions, options);
	          } else {
	            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof typeOrOptions === 'undefined' ? 'undefined' : _typeof(typeOrOptions)) + '.');
	          }
	        };
	      };
	
	      _this.wrappedCreateSource = function (stripe) {
	        return function () {
	          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
	            var type = options.type,
	                rest = _objectWithoutProperties(options, ['type']); // eslint-disable-line no-unused-vars
	
	
	            var specifiedType = typeof type === 'string' ? type : 'auto';
	            var element = _this.findElement(specifiedType);
	            if (element) {
	              return stripe.createSource(element, rest);
	            } else if (specifiedType !== 'auto') {
	              return stripe.createSource(options);
	            } else {
	              throw new Error('You did not specify the type of Source to create.\n          We also could not find any Elements in the current context.');
	            }
	          } else {
	            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
	          }
	        };
	      };
	
	      if (_this.context.tag === 'sync') {
	        _this.state = {
	          stripe: _this.stripeProps(_this.context.stripe)
	        };
	      } else {
	        _this.state = {
	          stripe: null
	        };
	      }
	      return _this;
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      if (this.context.tag === 'async') {
	        this.context.addStripeLoadListener(function (stripe) {
	          _this2.setState({
	            stripe: _this2.stripeProps(stripe)
	          });
	        });
	      } else {
	        // when 'sync', it's already set in the constructor.
	      }
	    };
	
	    _class.prototype.getWrappedInstance = function getWrappedInstance() {
	      if (!withRef) {
	        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
	      }
	      return this.wrappedInstance;
	    };
	
	    _class.prototype.stripeProps = function stripeProps(stripe) {
	      return _extends({}, stripe, {
	        // These are the only functions that take elements.
	        createToken: this.wrappedCreateToken(stripe),
	        createSource: this.wrappedCreateSource(stripe)
	      });
	    };
	    // Finds the element by the specified type. Throws if multiple Elements match.
	
	    // Require that exactly one Element is found.
	
	
	    // createToken has a bit of an unusual method signature for legacy reasons
	    // -- we're allowed to pass in the token type OR the element as the first parameter,
	    // so we need to check if we're passing in a string as the first parameter and
	    // just pass through the options if that's the case.
	
	
	    _class.prototype.render = function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
	        stripe: this.state.stripe,
	        ref: withRef ? function (c) {
	          _this3.wrappedInstance = c;
	        } : null
	      }));
	    };
	
	    return _class;
	  }(_react2.default.Component), _class.contextTypes = _extends({}, _Provider.providerContextTypes, _Elements.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
	};
	
	exports.default = inject;

/***/ },
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var DetectPassiveEvents = __webpack_require__(1883).default;
	
	function getInitialState() {
	  return {
	    x: null,
	    y: null,
	    swiping: false,
	    start: 0
	  };
	}
	
	function getMovingPosition(e) {
	  return 'changedTouches' in e ? { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY } : { x: e.clientX, y: e.clientY };
	}
	function getPosition(e) {
	  return 'touches' in e ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
	}
	
	function rotateByAngle(pos, angle) {
	  if (angle === 0) {
	    return pos;
	  }
	
	  var x = pos.x,
	      y = pos.y;
	
	
	  var angleInRadians = Math.PI / 180 * angle;
	  var rotatedX = x * Math.cos(angleInRadians) + y * Math.sin(angleInRadians);
	  var rotatedY = y * Math.cos(angleInRadians) - x * Math.sin(angleInRadians);
	  return { x: rotatedX, y: rotatedY };
	}
	
	function calculatePos(e, state) {
	  var _rotateByAngle = rotateByAngle(getMovingPosition(e), state.rotationAngle),
	      x = _rotateByAngle.x,
	      y = _rotateByAngle.y;
	
	  var deltaX = state.x - x;
	  var deltaY = state.y - y;
	
	  var absX = Math.abs(deltaX);
	  var absY = Math.abs(deltaY);
	
	  var time = Date.now() - state.start;
	  var velocity = Math.sqrt(absX * absX + absY * absY) / time;
	
	  return { deltaX: deltaX, deltaY: deltaY, absX: absX, absY: absY, velocity: velocity };
	}
	
	var Swipeable = function (_React$Component) {
	  _inherits(Swipeable, _React$Component);
	
	  function Swipeable(props, context) {
	    _classCallCheck(this, Swipeable);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.swipeable = getInitialState();
	
	    _this.eventStart = _this.eventStart.bind(_this);
	    _this.eventMove = _this.eventMove.bind(_this);
	    _this.eventEnd = _this.eventEnd.bind(_this);
	    _this.mouseDown = _this.mouseDown.bind(_this);
	    _this.mouseMove = _this.mouseMove.bind(_this);
	    _this.mouseUp = _this.mouseUp.bind(_this);
	    _this.cleanupMouseListeners = _this.cleanupMouseListeners.bind(_this);
	    _this.setupMouseListeners = _this.setupMouseListeners.bind(_this);
	    _this.elementRef = _this.elementRef.bind(_this);
	    _this.setupTouchmoveEvent = _this.setupTouchmoveEvent.bind(_this);
	    _this.cleanupTouchmoveEvent = _this.cleanupTouchmoveEvent.bind(_this);
	
	    _this.hasPassiveSupport = DetectPassiveEvents.hasSupport;
	    return _this;
	  }
	
	  Swipeable.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.preventDefaultTouchmoveEvent) {
	      this.setupTouchmoveEvent();
	    }
	  };
	
	  Swipeable.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (prevProps.disabled !== this.props.disabled) {
	      this.cleanupMouseListeners();
	
	      this.swipeable = getInitialState();
	    }
	
	    if (prevProps.preventDefaultTouchmoveEvent && !this.props.preventDefaultTouchmoveEvent) {
	      this.cleanupTouchmoveEvent();
	    } else if (!prevProps.preventDefaultTouchmoveEvent && this.props.preventDefaultTouchmoveEvent) {
	      this.setupTouchmoveEvent();
	    }
	  };
	
	  Swipeable.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.cleanupMouseListeners();
	  };
	
	  Swipeable.prototype.setupTouchmoveEvent = function setupTouchmoveEvent() {
	    if (this.element && this.hasPassiveSupport) {
	      this.element.addEventListener('touchmove', this.eventMove, { passive: false });
	    }
	  };
	
	  Swipeable.prototype.setupMouseListeners = function setupMouseListeners() {
	    document.addEventListener('mousemove', this.mouseMove);
	    document.addEventListener('mouseup', this.mouseUp);
	  };
	
	  Swipeable.prototype.cleanupTouchmoveEvent = function cleanupTouchmoveEvent() {
	    if (this.element && this.hasPassiveSupport) {
	      this.element.removeEventListener('touchmove', this.eventMove, { passive: false });
	    }
	  };
	
	  Swipeable.prototype.cleanupMouseListeners = function cleanupMouseListeners() {
	    document.removeEventListener('mousemove', this.mouseMove);
	    document.removeEventListener('mouseup', this.mouseUp);
	  };
	
	  Swipeable.prototype.mouseDown = function mouseDown(e) {
	    if (!this.props.trackMouse || e.type !== 'mousedown') {
	      return;
	    }
	
	    if (typeof this.props.onMouseDown === 'function') this.props.onMouseDown(e);
	
	    this.setupMouseListeners();
	
	    this.eventStart(e);
	  };
	
	  Swipeable.prototype.mouseMove = function mouseMove(e) {
	    this.eventMove(e);
	  };
	
	  Swipeable.prototype.mouseUp = function mouseUp(e) {
	    this.cleanupMouseListeners();
	    this.eventEnd(e);
	  };
	
	  Swipeable.prototype.eventStart = function eventStart(e) {
	    if (e.touches && e.touches.length > 1) return;
	
	    var rotationAngle = this.props.rotationAngle;
	
	    var _rotateByAngle2 = rotateByAngle(getPosition(e), rotationAngle),
	        x = _rotateByAngle2.x,
	        y = _rotateByAngle2.y;
	
	    if (this.props.stopPropagation) e.stopPropagation();
	
	    this.swipeable = { start: Date.now(), x: x, y: y, swiping: false, rotationAngle: rotationAngle };
	  };
	
	  Swipeable.prototype.eventMove = function eventMove(e) {
	    var _props = this.props,
	        stopPropagation = _props.stopPropagation,
	        delta = _props.delta,
	        onSwiping = _props.onSwiping,
	        onSwiped = _props.onSwiped,
	        onSwipingLeft = _props.onSwipingLeft,
	        onSwipedLeft = _props.onSwipedLeft,
	        onSwipingRight = _props.onSwipingRight,
	        onSwipedRight = _props.onSwipedRight,
	        onSwipingUp = _props.onSwipingUp,
	        onSwipedUp = _props.onSwipedUp,
	        onSwipingDown = _props.onSwipingDown,
	        onSwipedDown = _props.onSwipedDown,
	        preventDefaultTouchmoveEvent = _props.preventDefaultTouchmoveEvent;
	
	
	    if (!this.swipeable.x || !this.swipeable.y || e.touches && e.touches.length > 1) {
	      return;
	    }
	
	    var pos = calculatePos(e, this.swipeable);
	
	    if (pos.absX < delta && pos.absY < delta && !this.swipeable.swiping) return;
	
	    if (stopPropagation) e.stopPropagation();
	
	    if (onSwiping) {
	      onSwiping(e, pos.deltaX, pos.deltaY, pos.absX, pos.absY, pos.velocity);
	    }
	
	    var cancelablePageSwipe = false;
	    if (onSwiping || onSwiped) {
	      cancelablePageSwipe = true;
	    }
	
	    if (pos.absX > pos.absY) {
	      if (pos.deltaX > 0) {
	        if (onSwipingLeft || onSwipedLeft) {
	          onSwipingLeft && onSwipingLeft(e, pos.absX);
	          cancelablePageSwipe = true;
	        }
	      } else if (onSwipingRight || onSwipedRight) {
	        onSwipingRight && onSwipingRight(e, pos.absX);
	        cancelablePageSwipe = true;
	      }
	    } else if (pos.deltaY > 0) {
	      if (onSwipingUp || onSwipedUp) {
	        onSwipingUp && onSwipingUp(e, pos.absY);
	        cancelablePageSwipe = true;
	      }
	    } else if (onSwipingDown || onSwipedDown) {
	      onSwipingDown && onSwipingDown(e, pos.absY);
	      cancelablePageSwipe = true;
	    }
	
	    this.swipeable.swiping = true;
	
	    if (cancelablePageSwipe && preventDefaultTouchmoveEvent) e.preventDefault();
	  };
	
	  Swipeable.prototype.eventEnd = function eventEnd(e) {
	    var _props2 = this.props,
	        stopPropagation = _props2.stopPropagation,
	        flickThreshold = _props2.flickThreshold,
	        onSwiped = _props2.onSwiped,
	        onSwipedLeft = _props2.onSwipedLeft,
	        onSwipedRight = _props2.onSwipedRight,
	        onSwipedUp = _props2.onSwipedUp,
	        onSwipedDown = _props2.onSwipedDown,
	        onTap = _props2.onTap;
	
	
	    if (this.swipeable.swiping) {
	      var pos = calculatePos(e, this.swipeable);
	
	      if (stopPropagation) e.stopPropagation();
	
	      var isFlick = pos.velocity > flickThreshold;
	
	      onSwiped && onSwiped(e, pos.deltaX, pos.deltaY, isFlick, pos.velocity);
	
	      if (pos.absX > pos.absY) {
	        if (pos.deltaX > 0) {
	          onSwipedLeft && onSwipedLeft(e, pos.deltaX, isFlick);
	        } else {
	          onSwipedRight && onSwipedRight(e, pos.deltaX, isFlick);
	        }
	      } else if (pos.deltaY > 0) {
	        onSwipedUp && onSwipedUp(e, pos.deltaY, isFlick);
	      } else {
	        onSwipedDown && onSwipedDown(e, pos.deltaY, isFlick);
	      }
	    } else {
	      onTap && onTap(e);
	    }
	
	    this.swipeable = getInitialState();
	  };
	
	  Swipeable.prototype.elementRef = function elementRef(element) {
	    this.element = element;
	    this.props.innerRef && this.props.innerRef(element);
	  };
	
	  Swipeable.prototype.render = function render() {
	    var newProps = _extends({}, this.props);
	    if (!this.props.disabled) {
	      newProps.onTouchStart = this.eventStart;
	
	      if (!this.props.preventDefaultTouchmoveEvent || !this.hasPassiveSupport) {
	        newProps.onTouchMove = this.eventMove;
	      }
	
	      newProps.onTouchEnd = this.eventEnd;
	      newProps.onMouseDown = this.mouseDown;
	    }
	
	    newProps.ref = this.elementRef;
	
	    delete newProps.onSwiped;
	    delete newProps.onSwiping;
	    delete newProps.onSwipingUp;
	    delete newProps.onSwipingRight;
	    delete newProps.onSwipingDown;
	    delete newProps.onSwipingLeft;
	    delete newProps.onSwipedUp;
	    delete newProps.onSwipedRight;
	    delete newProps.onSwipedDown;
	    delete newProps.onSwipedLeft;
	    delete newProps.onTap;
	    delete newProps.flickThreshold;
	    delete newProps.delta;
	    delete newProps.preventDefaultTouchmoveEvent;
	    delete newProps.stopPropagation;
	    delete newProps.nodeName;
	    delete newProps.children;
	    delete newProps.trackMouse;
	    delete newProps.disabled;
	    delete newProps.innerRef;
	    delete newProps.rotationAngle;
	
	    return React.createElement(this.props.nodeName, newProps, this.props.children);
	  };
	
	  return Swipeable;
	}(React.Component);
	
	Swipeable.propTypes = {
	  onSwiped: PropTypes.func,
	  onSwiping: PropTypes.func,
	  onSwipingUp: PropTypes.func,
	  onSwipingRight: PropTypes.func,
	  onSwipingDown: PropTypes.func,
	  onSwipingLeft: PropTypes.func,
	  onSwipedUp: PropTypes.func,
	  onSwipedRight: PropTypes.func,
	  onSwipedDown: PropTypes.func,
	  onSwipedLeft: PropTypes.func,
	  onTap: PropTypes.func,
	  flickThreshold: PropTypes.number,
	  delta: PropTypes.number,
	  preventDefaultTouchmoveEvent: PropTypes.bool,
	  stopPropagation: PropTypes.bool,
	  nodeName: PropTypes.string,
	  trackMouse: PropTypes.bool,
	  disabled: PropTypes.bool,
	  innerRef: PropTypes.func,
	  children: PropTypes.node,
	  rotationAngle: PropTypes.number
	};
	
	Swipeable.defaultProps = {
	  flickThreshold: 0.6,
	  delta: 10,
	  preventDefaultTouchmoveEvent: false,
	  stopPropagation: false,
	  nodeName: 'div',
	  disabled: false,
	  rotationAngle: 0
	};
	
	module.exports = Swipeable;

/***/ },
/* 2881 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module, exports, __webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(module, exports, require('react'), require('prop-types'));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(mod, mod.exports, global.React, global.propTypes);
	    global.ReactTagsInput = mod.exports;
	  }
	})(this, function (module, exports, _react, _propTypes) {
	  'use strict';
	
	  Object.defineProperty(exports, "__esModule", {
	    value: true
	  });
	
	  var _react2 = _interopRequireDefault(_react);
	
	  var _propTypes2 = _interopRequireDefault(_propTypes);
	
	  function _interopRequireDefault(obj) {
	    return obj && obj.__esModule ? obj : {
	      default: obj
	    };
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  var _createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }
	
	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();
	
	  function _possibleConstructorReturn(self, call) {
	    if (!self) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return call && (typeof call === "object" || typeof call === "function") ? call : self;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	  }
	
	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  function _objectWithoutProperties(obj, keys) {
	    var target = {};
	
	    for (var i in obj) {
	      if (keys.indexOf(i) >= 0) continue;
	      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	      target[i] = obj[i];
	    }
	
	    return target;
	  }
	
	  function uniq(arr) {
	    var out = [];
	
	    for (var i = 0; i < arr.length; i++) {
	      if (out.indexOf(arr[i]) === -1) {
	        out.push(arr[i]);
	      }
	    }
	
	    return out;
	  }
	
	  /* istanbul ignore next */
	  function getClipboardData(e) {
	    if (window.clipboardData) {
	      return window.clipboardData.getData('Text');
	    }
	
	    if (e.clipboardData) {
	      return e.clipboardData.getData('text/plain');
	    }
	
	    return '';
	  }
	
	  function defaultRenderTag(props) {
	    var tag = props.tag,
	        key = props.key,
	        disabled = props.disabled,
	        onRemove = props.onRemove,
	        classNameRemove = props.classNameRemove,
	        getTagDisplayValue = props.getTagDisplayValue,
	        other = _objectWithoutProperties(props, ['tag', 'key', 'disabled', 'onRemove', 'classNameRemove', 'getTagDisplayValue']);
	
	    return _react2.default.createElement(
	      'span',
	      _extends({ key: key }, other),
	      getTagDisplayValue(tag),
	      !disabled && _react2.default.createElement('a', { className: classNameRemove, onClick: function onClick(e) {
	          return onRemove(key);
	        } })
	    );
	  }
	
	  function defaultRenderInput(_ref) {
	    var addTag = _ref.addTag,
	        props = _objectWithoutProperties(_ref, ['addTag']);
	
	    var onChange = props.onChange,
	        value = props.value,
	        other = _objectWithoutProperties(props, ['onChange', 'value']);
	
	    return _react2.default.createElement('input', _extends({ type: 'text', onChange: onChange, value: value }, other));
	  }
	
	  function defaultRenderLayout(tagComponents, inputComponent) {
	    return _react2.default.createElement(
	      'span',
	      null,
	      tagComponents,
	      inputComponent
	    );
	  }
	
	  function defaultPasteSplit(data) {
	    return data.split(' ').map(function (d) {
	      return d.trim();
	    });
	  }
	
	  var defaultInputProps = {
	    className: 'react-tagsinput-input',
	    placeholder: 'Add a tag'
	  };
	
	  var TagsInput = function (_React$Component) {
	    _inherits(TagsInput, _React$Component);
	
	    /* istanbul ignore next */
	    function TagsInput() {
	      _classCallCheck(this, TagsInput);
	
	      var _this = _possibleConstructorReturn(this, (TagsInput.__proto__ || Object.getPrototypeOf(TagsInput)).call(this));
	
	      _this.state = { tag: '', isFocused: false };
	      _this.focus = _this.focus.bind(_this);
	      _this.blur = _this.blur.bind(_this);
	      return _this;
	    }
	
	    _createClass(TagsInput, [{
	      key: '_getTagDisplayValue',
	      value: function _getTagDisplayValue(tag) {
	        var tagDisplayProp = this.props.tagDisplayProp;
	
	
	        if (tagDisplayProp) {
	          return tag[tagDisplayProp];
	        }
	
	        return tag;
	      }
	    }, {
	      key: '_makeTag',
	      value: function _makeTag(tag) {
	        var tagDisplayProp = this.props.tagDisplayProp;
	
	
	        if (tagDisplayProp) {
	          return _defineProperty({}, tagDisplayProp, tag);
	        }
	
	        return tag;
	      }
	    }, {
	      key: '_removeTag',
	      value: function _removeTag(index) {
	        var value = this.props.value.concat([]);
	        if (index > -1 && index < value.length) {
	          var changed = value.splice(index, 1);
	          this.props.onChange(value, changed, [index]);
	        }
	      }
	    }, {
	      key: '_clearInput',
	      value: function _clearInput() {
	        if (this.hasControlledInput()) {
	          this.props.onChangeInput('');
	        } else {
	          this.setState({ tag: '' });
	        }
	      }
	    }, {
	      key: '_tag',
	      value: function _tag() {
	        if (this.hasControlledInput()) {
	          return this.props.inputValue;
	        }
	
	        return this.state.tag;
	      }
	    }, {
	      key: '_addTags',
	      value: function _addTags(tags) {
	        var _this2 = this;
	
	        var _props = this.props,
	            validationRegex = _props.validationRegex,
	            onChange = _props.onChange,
	            onValidationReject = _props.onValidationReject,
	            onlyUnique = _props.onlyUnique,
	            maxTags = _props.maxTags,
	            value = _props.value;
	
	
	        if (onlyUnique) {
	          tags = uniq(tags);
	          tags = tags.filter(function (tag) {
	            return value.every(function (currentTag) {
	              return _this2._getTagDisplayValue(currentTag) !== _this2._getTagDisplayValue(tag);
	            });
	          });
	        }
	
	        var rejectedTags = tags.filter(function (tag) {
	          return !validationRegex.test(_this2._getTagDisplayValue(tag));
	        });
	        tags = tags.filter(function (tag) {
	          return validationRegex.test(_this2._getTagDisplayValue(tag));
	        });
	        tags = tags.filter(function (tag) {
	          var tagDisplayValue = _this2._getTagDisplayValue(tag);
	          if (typeof tagDisplayValue.trim === 'function') {
	            return tagDisplayValue.trim().length > 0;
	          } else {
	            return tagDisplayValue;
	          }
	        });
	
	        if (maxTags >= 0) {
	          var remainingLimit = Math.max(maxTags - value.length, 0);
	          tags = tags.slice(0, remainingLimit);
	        }
	
	        if (onValidationReject && rejectedTags.length > 0) {
	          onValidationReject(rejectedTags);
	        }
	
	        if (tags.length > 0) {
	          var newValue = value.concat(tags);
	          var indexes = [];
	          for (var i = 0; i < tags.length; i++) {
	            indexes.push(value.length + i);
	          }
	          onChange(newValue, tags, indexes);
	          this._clearInput();
	          return true;
	        }
	
	        if (rejectedTags.length > 0) {
	          return false;
	        }
	
	        this._clearInput();
	        return false;
	      }
	    }, {
	      key: '_shouldPreventDefaultEventOnAdd',
	      value: function _shouldPreventDefaultEventOnAdd(added, empty, keyCode) {
	        if (added) {
	          return true;
	        }
	
	        if (keyCode === 13) {
	          return this.props.preventSubmit || !this.props.preventSubmit && !empty;
	        }
	
	        return false;
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (this.input && typeof this.input.focus === 'function') {
	          this.input.focus();
	        }
	
	        this.handleOnFocus();
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        if (this.input && typeof this.input.blur === 'function') {
	          this.input.blur();
	        }
	
	        this.handleOnBlur();
	      }
	    }, {
	      key: 'accept',
	      value: function accept() {
	        var tag = this._tag();
	
	        if (tag !== '') {
	          tag = this._makeTag(tag);
	          return this._addTags([tag]);
	        }
	
	        return false;
	      }
	    }, {
	      key: 'addTag',
	      value: function addTag(tag) {
	        return this._addTags([tag]);
	      }
	    }, {
	      key: 'clearInput',
	      value: function clearInput() {
	        this._clearInput();
	      }
	    }, {
	      key: 'handlePaste',
	      value: function handlePaste(e) {
	        var _this3 = this;
	
	        var _props2 = this.props,
	            addOnPaste = _props2.addOnPaste,
	            pasteSplit = _props2.pasteSplit;
	
	
	        if (!addOnPaste) {
	          return;
	        }
	
	        e.preventDefault();
	
	        var data = getClipboardData(e);
	        var tags = pasteSplit(data).map(function (tag) {
	          return _this3._makeTag(tag);
	        });
	
	        this._addTags(tags);
	      }
	    }, {
	      key: 'handleKeyDown',
	      value: function handleKeyDown(e) {
	        if (e.defaultPrevented) {
	          return;
	        }
	
	        var _props3 = this.props,
	            value = _props3.value,
	            removeKeys = _props3.removeKeys,
	            addKeys = _props3.addKeys;
	
	        var tag = this._tag();
	        var empty = tag === '';
	        var keyCode = e.keyCode;
	        var key = e.key;
	        var add = addKeys.indexOf(keyCode) !== -1 || addKeys.indexOf(key) !== -1;
	        var remove = removeKeys.indexOf(keyCode) !== -1 || removeKeys.indexOf(key) !== -1;
	
	        if (add) {
	          var added = this.accept();
	          if (this._shouldPreventDefaultEventOnAdd(added, empty, keyCode)) {
	            e.preventDefault();
	          }
	        }
	
	        if (remove && value.length > 0 && empty) {
	          e.preventDefault();
	          this._removeTag(value.length - 1);
	        }
	      }
	    }, {
	      key: 'handleClick',
	      value: function handleClick(e) {
	        if (e.target === this.div) {
	          this.focus();
	        }
	      }
	    }, {
	      key: 'handleChange',
	      value: function handleChange(e) {
	        var onChangeInput = this.props.onChangeInput;
	        var onChange = this.props.inputProps.onChange;
	
	        var tag = e.target.value;
	
	        if (onChange) {
	          onChange(e);
	        }
	
	        if (this.hasControlledInput()) {
	          onChangeInput(tag);
	        } else {
	          this.setState({ tag: tag });
	        }
	      }
	    }, {
	      key: 'handleOnFocus',
	      value: function handleOnFocus(e) {
	        var onFocus = this.props.inputProps.onFocus;
	
	
	        if (onFocus) {
	          onFocus(e);
	        }
	
	        this.setState({ isFocused: true });
	      }
	    }, {
	      key: 'handleOnBlur',
	      value: function handleOnBlur(e) {
	        var onBlur = this.props.inputProps.onBlur;
	
	
	        this.setState({ isFocused: false });
	
	        if (e == null) {
	          return;
	        }
	
	        if (onBlur) {
	          onBlur(e);
	        }
	
	        if (this.props.addOnBlur) {
	          var tag = this._makeTag(e.target.value);
	          this._addTags([tag]);
	        }
	      }
	    }, {
	      key: 'handleRemove',
	      value: function handleRemove(tag) {
	        this._removeTag(tag);
	      }
	    }, {
	      key: 'inputProps',
	      value: function inputProps() {
	        var _props$inputProps = this.props.inputProps,
	            onChange = _props$inputProps.onChange,
	            onFocus = _props$inputProps.onFocus,
	            onBlur = _props$inputProps.onBlur,
	            otherInputProps = _objectWithoutProperties(_props$inputProps, ['onChange', 'onFocus', 'onBlur']);
	
	        var props = _extends({}, defaultInputProps, otherInputProps);
	
	        if (this.props.disabled) {
	          props.disabled = true;
	        }
	
	        return props;
	      }
	    }, {
	      key: 'inputValue',
	      value: function inputValue(props) {
	        return props.currentValue || props.inputValue || '';
	      }
	    }, {
	      key: 'hasControlledInput',
	      value: function hasControlledInput() {
	        var _props4 = this.props,
	            inputValue = _props4.inputValue,
	            onChangeInput = _props4.onChangeInput;
	
	
	        return typeof onChangeInput === 'function' && typeof inputValue === 'string';
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        if (this.hasControlledInput()) {
	          return;
	        }
	
	        this.setState({
	          tag: this.inputValue(this.props)
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        /* istanbul ignore next */
	        if (this.hasControlledInput()) {
	          return;
	        }
	
	        if (!this.inputValue(nextProps)) {
	          return;
	        }
	
	        this.setState({
	          tag: this.inputValue(nextProps)
	        });
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props5 = this.props,
	            value = _props5.value,
	            onChange = _props5.onChange,
	            tagProps = _props5.tagProps,
	            renderLayout = _props5.renderLayout,
	            renderTag = _props5.renderTag,
	            renderInput = _props5.renderInput,
	            addKeys = _props5.addKeys,
	            removeKeys = _props5.removeKeys,
	            className = _props5.className,
	            focusedClassName = _props5.focusedClassName,
	            addOnBlur = _props5.addOnBlur,
	            addOnPaste = _props5.addOnPaste,
	            inputProps = _props5.inputProps,
	            pasteSplit = _props5.pasteSplit,
	            onlyUnique = _props5.onlyUnique,
	            maxTags = _props5.maxTags,
	            validationRegex = _props5.validationRegex,
	            disabled = _props5.disabled,
	            tagDisplayProp = _props5.tagDisplayProp,
	            inputValue = _props5.inputValue,
	            onChangeInput = _props5.onChangeInput,
	            other = _objectWithoutProperties(_props5, ['value', 'onChange', 'tagProps', 'renderLayout', 'renderTag', 'renderInput', 'addKeys', 'removeKeys', 'className', 'focusedClassName', 'addOnBlur', 'addOnPaste', 'inputProps', 'pasteSplit', 'onlyUnique', 'maxTags', 'validationRegex', 'disabled', 'tagDisplayProp', 'inputValue', 'onChangeInput']);
	
	        var isFocused = this.state.isFocused;
	
	
	        if (isFocused) {
	          className += ' ' + focusedClassName;
	        }
	
	        var tagComponents = value.map(function (tag, index) {
	          return renderTag(_extends({
	            key: index,
	            tag: tag,
	            onRemove: _this4.handleRemove.bind(_this4),
	            disabled: disabled,
	            getTagDisplayValue: _this4._getTagDisplayValue.bind(_this4)
	          }, tagProps));
	        });
	
	        var inputComponent = renderInput(_extends({
	          ref: function ref(r) {
	            _this4.input = r;
	          },
	          value: this._tag(),
	          onPaste: this.handlePaste.bind(this),
	          onKeyDown: this.handleKeyDown.bind(this),
	          onChange: this.handleChange.bind(this),
	          onFocus: this.handleOnFocus.bind(this),
	          onBlur: this.handleOnBlur.bind(this),
	          addTag: this.addTag.bind(this)
	        }, this.inputProps()));
	
	        return _react2.default.createElement(
	          'div',
	          { ref: function ref(r) {
	              _this4.div = r;
	            }, onClick: this.handleClick.bind(this), className: className },
	          renderLayout(tagComponents, inputComponent)
	        );
	      }
	    }]);
	
	    return TagsInput;
	  }(_react2.default.Component);
	
	  TagsInput.defaultProps = {
	    className: 'react-tagsinput',
	    focusedClassName: 'react-tagsinput--focused',
	    addKeys: [9, 13],
	    addOnBlur: false,
	    addOnPaste: false,
	    inputProps: {},
	    removeKeys: [8],
	    renderInput: defaultRenderInput,
	    renderTag: defaultRenderTag,
	    renderLayout: defaultRenderLayout,
	    pasteSplit: defaultPasteSplit,
	    tagProps: { className: 'react-tagsinput-tag', classNameRemove: 'react-tagsinput-remove' },
	    onlyUnique: false,
	    maxTags: -1,
	    validationRegex: /.*/,
	    disabled: false,
	    tagDisplayProp: null,
	    preventSubmit: true
	  };
	  exports.default = TagsInput;
	  module.exports = exports['default'];
	});
	


/***/ },
/* 2882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _objectAssign = __webpack_require__(2883);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var truthy = function truthy(x) {
	  return x;
	};
	
	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];
	
	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }
	
	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);
	
	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 2883 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 2884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Base2 = __webpack_require__(1302);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _debounce = __webpack_require__(1303);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Debouncer = function (_Base) {
	  _inherits(Debouncer, _Base);
	
	  function Debouncer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Debouncer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Debouncer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this._wrapHandler = function (fn) {
	      return (0, _debounce2.default)(fn, _this.time);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Debouncer;
	}(_Base3.default);
	
	exports.default = Debouncer;

/***/ },
/* 2885 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Base2 = __webpack_require__(1302);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	var _throttle = __webpack_require__(2886);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Throttler = function (_Base) {
	  _inherits(Throttler, _Base);
	
	  function Throttler() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Throttler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Throttler)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this._wrapHandler = function (fn) {
	      return (0, _throttle2.default)(fn, _this.time);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Throttler;
	}(_Base3.default);
	
	exports.default = Throttler;

/***/ },
/* 2886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = throttle;
	
	var _lodash = __webpack_require__(129);
	
	var _debounce = __webpack_require__(1303);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if ((0, _lodash.isObject)(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return (0, _debounce2.default)(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}

/***/ },
/* 2887 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(354);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Debouncer = __webpack_require__(2884);
	
	var _Debouncer2 = _interopRequireDefault(_Debouncer);
	
	var _Base2 = __webpack_require__(1304);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Debounce = function (_Base) {
	  _inherits(Debounce, _Base);
	
	  function Debounce(props) {
	    _classCallCheck(this, Debounce);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Debounce).call(this, props));
	
	    _this._throttler = new _Debouncer2.default(_this.el, _this.handlersToWrap, props.time);
	    return _this;
	  }
	
	  return Debounce;
	}(_Base3.default);
	
	Debounce.defaultProps = {
	  handler: '',
	  handlers: [],
	  time: 400
	};
	exports.default = Debounce;

/***/ },
/* 2888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(354);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Throttler = __webpack_require__(2885);
	
	var _Throttler2 = _interopRequireDefault(_Throttler);
	
	var _Base2 = __webpack_require__(1304);
	
	var _Base3 = _interopRequireDefault(_Base2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Throttle = function (_Base) {
	  _inherits(Throttle, _Base);
	
	  function Throttle(props) {
	    _classCallCheck(this, Throttle);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Throttle).call(this, props));
	
	    _this._throttler = new _Throttler2.default(props.children, _this.handlersToWrap, props.time);
	    return _this;
	  }
	
	  return Throttle;
	}(_Base3.default);
	
	Throttle.defaultProps = {
	  handler: '',
	  handlers: [],
	  time: 100
	};
	exports.default = Throttle;

/***/ },
/* 2889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Throttle = exports.Debounce = undefined;
	
	var _Debounce = __webpack_require__(2887);
	
	var _Debounce2 = _interopRequireDefault(_Debounce);
	
	var _Throttle = __webpack_require__(2888);
	
	var _Throttle2 = _interopRequireDefault(_Throttle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Debounce = _Debounce2.default;
	exports.Throttle = _Throttle2.default;

/***/ },
/* 2890 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 2891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(353);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 2892 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(25);
	
	var ReactBaseClasses = __webpack_require__(1305);
	var ReactChildren = __webpack_require__(2893);
	var ReactDOMFactories = __webpack_require__(2894);
	var ReactElement = __webpack_require__(202);
	var ReactPropTypes = __webpack_require__(2895);
	var ReactVersion = __webpack_require__(2896);
	
	var createReactClass = __webpack_require__(2897);
	var onlyChild = __webpack_require__(2900);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 2893 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2891);
	var ReactElement = __webpack_require__(202);
	
	var emptyFunction = __webpack_require__(67);
	var traverseAllChildren = __webpack_require__(2901);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 2894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(202);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 2895 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(202),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(2481);
	
	module.exports = factory(isValidElement);

/***/ },
/* 2896 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 2897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(1305),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(202),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(1308);
	var factory = __webpack_require__(896);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 2898 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 2899 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 2900 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(353);
	
	var ReactElement = __webpack_require__(202);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 2901 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(353);
	
	var ReactCurrentOwner = __webpack_require__(1306);
	var REACT_ELEMENT_TYPE = __webpack_require__(1307);
	
	var getIteratorFn = __webpack_require__(2898);
	var invariant = __webpack_require__(18);
	var KeyEscapeUtils = __webpack_require__(2890);
	var warning = __webpack_require__(301);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 2902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(355);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _addClass = __webpack_require__(2904);
	
	var _addClass2 = _interopRequireDefault(_addClass);
	
	var _removeClass = __webpack_require__(2906);
	
	var _removeClass2 = _interopRequireDefault(_removeClass);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Transition = __webpack_require__(1310);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _PropTypes = __webpack_require__(1311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass2.default)(node, c);
	  });
	};
	
	var propTypes = _extends({}, _Transition2.default.propTypes, {
	
	  /**
	   * The animation classNames applied to the component as it enters, exits or has finished the transition.
	   * A single name can be provided and it will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	});
	
	/**
	 * A `Transition` component using CSS transitions and animations.
	 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` stages of the transition. The first class is applied and then a
	 * second "active" class in order to activate the css animation. After the animation,
	 * matching `done` class names are applied to persist the animation state.
	 *
	 * When the `in` prop is toggled to `true` the Component will get
	 * the `example-enter` CSS class and the `example-enter-active` CSS class
	 * added in the next tick. This is a convention based on the `classNames` prop.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 */
	
	var CSSTransition = function (_React$Component) {
	  _inherits(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CSSTransition);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node);
	      }
	    }, _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node);
	      }
	    }, _this.onEntered = function (node, appearing) {
	      var _this$getClassNames3 = _this.getClassNames('enter'),
	          doneClassName = _this$getClassNames3.doneClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node);
	      }
	    }, _this.onExit = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          className = _this$getClassNames4.className;
	
	      _this.removeClasses(node, 'appear');
	      _this.removeClasses(node, 'enter');
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    }, _this.onExiting = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames5.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    }, _this.onExited = function (node) {
	      var _this$getClassNames6 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames6.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    }, _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	
	
	      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
	
	      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
	
	      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
	
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
	    var _getClassNames = this.getClassNames(type),
	        className = _getClassNames.className,
	        activeClassName = _getClassNames.activeClassName,
	        doneClassName = _getClassNames.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    /* eslint-disable no-unused-expressions */
	    node && node.scrollTop;
	    /* eslint-enable no-unused-expressions */
	    addClass(node, className);
	  };
	
	  CSSTransition.prototype.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	
	    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react2.default.Component);
	
	CSSTransition.propTypes =  false ? propTypes : {};
	
	exports.default = CSSTransition;
	module.exports = exports['default'];

/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(355);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChildMapping = __webpack_require__(2909);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var propTypes = {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes2.default.any,
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   */
	  children: _propTypes2.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes2.default.bool,
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes2.default.bool,
	  /**
	    * A convenience prop that enables or disables exit animations
	    * for all children. Note that specifying this will override any defaults set
	    * on individual children Transitions.
	    */
	  exit: _propTypes2.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes2.default.func
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	/**
	 * The `<TransitionGroup>` component manages a set of `<Transition>` components
	 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
	 * state machine for managing the mounting and unmounting of components over
	 * time.
	 *
	 * Consider the example below using the `Fade` CSS transition from before.
	 * As items are removed or added to the TodoList the `in` prop is toggled
	 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
	 * component in a `<TransitionGroup>`, not just css.
	 *
	 * ## Example
	 *
	 * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
	 *
	 * Note that `<TransitionGroup>`  does not define any animation behavior!
	 * Exactly _how_ a list item animates is up to the individual `<Transition>`
	 * components. This means you can mix and match animations across different
	 * list items.
	 */
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    // Initial children should all be entering, dependent on appear
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
	        return (0, _react.cloneElement)(child, {
	          onExited: _this.handleExited.bind(_this, child),
	          in: true,
	          appear: _this.getProp(child, 'appear'),
	          enter: _this.getProp(child, 'enter'),
	          exit: _this.getProp(child, 'exit')
	        });
	      })
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: { isMounting: !this.appeared }
	    };
	  };
	  // use child config unless explictly set by the Group
	
	
	  TransitionGroup.prototype.getProp = function getProp(child, prop) {
	    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;
	
	    return props[prop] != null ? props[prop] : child.props[prop];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    var prevChildMapping = this.state.children;
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	
	    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
	
	    Object.keys(children).forEach(function (key) {
	      var child = children[key];
	
	      if (!(0, _react.isValidElement)(child)) return;
	
	      var hasPrev = key in prevChildMapping;
	      var hasNext = key in nextChildMapping;
	
	      var prevChild = prevChildMapping[key];
	      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;
	
	      // item is new (entering)
	      if (hasNext && (!hasPrev || isLeaving)) {
	        // console.log('entering', key)
	        children[key] = (0, _react.cloneElement)(child, {
	          onExited: _this2.handleExited.bind(_this2, child),
	          in: true,
	          exit: _this2.getProp(child, 'exit', nextProps),
	          enter: _this2.getProp(child, 'enter', nextProps)
	        });
	      }
	      // item is old (exiting)
	      else if (!hasNext && hasPrev && !isLeaving) {
	          // console.log('leaving', key)
	          children[key] = (0, _react.cloneElement)(child, { in: false });
	        }
	        // item hasn't changed transition states
	        // copy over the last transition props;
	        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	            // console.log('unchanged', key)
	            children[key] = (0, _react.cloneElement)(child, {
	              onExited: _this2.handleExited.bind(_this2, child),
	              in: prevChild.props.in,
	              exit: _this2.getProp(child, 'exit', nextProps),
	              enter: _this2.getProp(child, 'enter', nextProps)
	            });
	          }
	    });
	
	    this.setState({ children: children });
	  };
	
	  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    this.setState(function (state) {
	      var children = _extends({}, state.children);
	
	      delete children[child.key];
	      return { children: children };
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _props = this.props,
	        Component = _props.component,
	        childFactory = _props.childFactory,
	        props = _objectWithoutProperties(_props, ['component', 'childFactory']);
	
	    var children = values(this.state.children).map(childFactory);
	
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes2.default.object.isRequired
	};
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 2904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addClass;
	
	var _hasClass = __webpack_require__(2905);
	
	var _hasClass2 = _interopRequireDefault(_hasClass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	module.exports = exports['default'];

/***/ },
/* 2905 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasClass;
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	module.exports = exports["default"];

/***/ },
/* 2906 */
/***/ function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ },
/* 2907 */
[3545, 2908],
/* 2908 */
1144,
/* 2909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = Object.create(null);
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 2910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ScaleUtils = exports.AxisUtils = exports.FlexibleHeightXYPlot = exports.FlexibleWidthXYPlot = exports.FlexibleXYPlot = exports.makeWidthFlexible = exports.makeVisFlexible = exports.makeHeightFlexible = exports.Sunburst = exports.Sankey = exports.ParallelCoordinates = exports.RadarChart = exports.RadialChart = exports.Treemap = exports.ContinuousSizeLegend = exports.ContinuousColorLegend = exports.SearchableDiscreteColorLegend = exports.DiscreteColorLegend = exports.Voronoi = exports.HorizontalGridLines = exports.VerticalGridLines = exports.GradientDefs = exports.GridLines = exports.CircularGridLines = exports.YAxis = exports.XAxis = exports.DecorativeAxis = exports.XYPlot = exports.Crosshair = exports.Borders = exports.Hint = exports.LineMarkSeriesCanvas = exports.LineMarkSeries = exports.ArcSeries = exports.AreaSeries = exports.CustomSVGSeries = exports.ContourSeries = exports.HeatmapSeries = exports.WhiskerSeries = exports.MarkSeriesCanvas = exports.MarkSeries = exports.RectSeriesCanvas = exports.RectSeries = exports.PolygonSeries = exports.LabelSeries = exports.HorizontalRectSeriesCanvas = exports.HorizontalRectSeries = exports.VerticalRectSeriesCanvas = exports.VerticalRectSeries = exports.VerticalBarSeriesCanvas = exports.VerticalBarSeries = exports.HorizontalBarSeriesCanvas = exports.HorizontalBarSeries = exports.LineSeriesCanvas = exports.LineSeries = exports.AbstractSeries = undefined;
	
	var _makeVisFlexible = __webpack_require__(2915);
	
	Object.defineProperty(exports, 'makeHeightFlexible', {
	  enumerable: true,
	  get: function get() {
	    return _makeVisFlexible.makeHeightFlexible;
	  }
	});
	Object.defineProperty(exports, 'makeVisFlexible', {
	  enumerable: true,
	  get: function get() {
	    return _makeVisFlexible.makeVisFlexible;
	  }
	});
	Object.defineProperty(exports, 'makeWidthFlexible', {
	  enumerable: true,
	  get: function get() {
	    return _makeVisFlexible.makeWidthFlexible;
	  }
	});
	Object.defineProperty(exports, 'FlexibleXYPlot', {
	  enumerable: true,
	  get: function get() {
	    return _makeVisFlexible.FlexibleXYPlot;
	  }
	});
	Object.defineProperty(exports, 'FlexibleWidthXYPlot', {
	  enumerable: true,
	  get: function get() {
	    return _makeVisFlexible.FlexibleWidthXYPlot;
	  }
	});
	Object.defineProperty(exports, 'FlexibleHeightXYPlot', {
	  enumerable: true,
	  get: function get() {
	    return _makeVisFlexible.FlexibleHeightXYPlot;
	  }
	});
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _lineSeries = __webpack_require__(522);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _lineSeriesCanvas = __webpack_require__(1317);
	
	var _lineSeriesCanvas2 = _interopRequireDefault(_lineSeriesCanvas);
	
	var _horizontalBarSeries = __webpack_require__(2935);
	
	var _horizontalBarSeries2 = _interopRequireDefault(_horizontalBarSeries);
	
	var _horizontalBarSeriesCanvas = __webpack_require__(2934);
	
	var _horizontalBarSeriesCanvas2 = _interopRequireDefault(_horizontalBarSeriesCanvas);
	
	var _verticalBarSeries = __webpack_require__(2940);
	
	var _verticalBarSeries2 = _interopRequireDefault(_verticalBarSeries);
	
	var _verticalBarSeriesCanvas = __webpack_require__(2939);
	
	var _verticalBarSeriesCanvas2 = _interopRequireDefault(_verticalBarSeriesCanvas);
	
	var _verticalRectSeries = __webpack_require__(1319);
	
	var _verticalRectSeries2 = _interopRequireDefault(_verticalRectSeries);
	
	var _verticalRectSeriesCanvas = __webpack_require__(2941);
	
	var _verticalRectSeriesCanvas2 = _interopRequireDefault(_verticalRectSeriesCanvas);
	
	var _horizontalRectSeries = __webpack_require__(2937);
	
	var _horizontalRectSeries2 = _interopRequireDefault(_horizontalRectSeries);
	
	var _horizontalRectSeriesCanvas = __webpack_require__(2936);
	
	var _horizontalRectSeriesCanvas2 = _interopRequireDefault(_horizontalRectSeriesCanvas);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _polygonSeries = __webpack_require__(524);
	
	var _polygonSeries2 = _interopRequireDefault(_polygonSeries);
	
	var _rectSeries = __webpack_require__(526);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	var _rectSeriesCanvas = __webpack_require__(525);
	
	var _rectSeriesCanvas2 = _interopRequireDefault(_rectSeriesCanvas);
	
	var _markSeries = __webpack_require__(523);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	var _markSeriesCanvas = __webpack_require__(1318);
	
	var _markSeriesCanvas2 = _interopRequireDefault(_markSeriesCanvas);
	
	var _whiskerSeries = __webpack_require__(2942);
	
	var _whiskerSeries2 = _interopRequireDefault(_whiskerSeries);
	
	var _heatmapSeries = __webpack_require__(2933);
	
	var _heatmapSeries2 = _interopRequireDefault(_heatmapSeries);
	
	var _contourSeries = __webpack_require__(2931);
	
	var _contourSeries2 = _interopRequireDefault(_contourSeries);
	
	var _customSvgSeries = __webpack_require__(2932);
	
	var _customSvgSeries2 = _interopRequireDefault(_customSvgSeries);
	
	var _areaSeries = __webpack_require__(2929);
	
	var _areaSeries2 = _interopRequireDefault(_areaSeries);
	
	var _arcSeries = __webpack_require__(521);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _lineMarkSeries = __webpack_require__(1316);
	
	var _lineMarkSeries2 = _interopRequireDefault(_lineMarkSeries);
	
	var _lineMarkSeriesCanvas = __webpack_require__(2938);
	
	var _lineMarkSeriesCanvas2 = _interopRequireDefault(_lineMarkSeriesCanvas);
	
	var _hint = __webpack_require__(2927);
	
	var _hint2 = _interopRequireDefault(_hint);
	
	var _borders = __webpack_require__(2923);
	
	var _borders2 = _interopRequireDefault(_borders);
	
	var _crosshair = __webpack_require__(2925);
	
	var _crosshair2 = _interopRequireDefault(_crosshair);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _decorativeAxis = __webpack_require__(519);
	
	var _decorativeAxis2 = _interopRequireDefault(_decorativeAxis);
	
	var _xAxis = __webpack_require__(2921);
	
	var _xAxis2 = _interopRequireDefault(_xAxis);
	
	var _yAxis = __webpack_require__(2922);
	
	var _yAxis2 = _interopRequireDefault(_yAxis);
	
	var _circularGridLines = __webpack_require__(2924);
	
	var _circularGridLines2 = _interopRequireDefault(_circularGridLines);
	
	var _gridLines = __webpack_require__(520);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	var _gradientDefs = __webpack_require__(2926);
	
	var _gradientDefs2 = _interopRequireDefault(_gradientDefs);
	
	var _verticalGridLines = __webpack_require__(2943);
	
	var _verticalGridLines2 = _interopRequireDefault(_verticalGridLines);
	
	var _horizontalGridLines = __webpack_require__(2928);
	
	var _horizontalGridLines2 = _interopRequireDefault(_horizontalGridLines);
	
	var _voronoi = __webpack_require__(1320);
	
	var _voronoi2 = _interopRequireDefault(_voronoi);
	
	var _discreteColorLegend = __webpack_require__(1312);
	
	var _discreteColorLegend2 = _interopRequireDefault(_discreteColorLegend);
	
	var _searchableDiscreteColorLegend = __webpack_require__(2914);
	
	var _searchableDiscreteColorLegend2 = _interopRequireDefault(_searchableDiscreteColorLegend);
	
	var _continuousColorLegend = __webpack_require__(2911);
	
	var _continuousColorLegend2 = _interopRequireDefault(_continuousColorLegend);
	
	var _continuousSizeLegend = __webpack_require__(2912);
	
	var _continuousSizeLegend2 = _interopRequireDefault(_continuousSizeLegend);
	
	var _treemap = __webpack_require__(2949);
	
	var _treemap2 = _interopRequireDefault(_treemap);
	
	var _radialChart = __webpack_require__(2945);
	
	var _radialChart2 = _interopRequireDefault(_radialChart);
	
	var _radarChart = __webpack_require__(2944);
	
	var _radarChart2 = _interopRequireDefault(_radarChart);
	
	var _parallelCoordinates = __webpack_require__(2916);
	
	var _parallelCoordinates2 = _interopRequireDefault(_parallelCoordinates);
	
	var _sankey = __webpack_require__(2946);
	
	var _sankey2 = _interopRequireDefault(_sankey);
	
	var _sunburst = __webpack_require__(2948);
	
	var _sunburst2 = _interopRequireDefault(_sunburst);
	
	var _axisUtils = __webpack_require__(80);
	
	var _axisUtils2 = _interopRequireDefault(_axisUtils);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _scalesUtils2 = _interopRequireDefault(_scalesUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AbstractSeries = _abstractSeries2.default; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.LineSeries = _lineSeries2.default;
	exports.LineSeriesCanvas = _lineSeriesCanvas2.default;
	exports.HorizontalBarSeries = _horizontalBarSeries2.default;
	exports.HorizontalBarSeriesCanvas = _horizontalBarSeriesCanvas2.default;
	exports.VerticalBarSeries = _verticalBarSeries2.default;
	exports.VerticalBarSeriesCanvas = _verticalBarSeriesCanvas2.default;
	exports.VerticalRectSeries = _verticalRectSeries2.default;
	exports.VerticalRectSeriesCanvas = _verticalRectSeriesCanvas2.default;
	exports.HorizontalRectSeries = _horizontalRectSeries2.default;
	exports.HorizontalRectSeriesCanvas = _horizontalRectSeriesCanvas2.default;
	exports.LabelSeries = _labelSeries2.default;
	exports.PolygonSeries = _polygonSeries2.default;
	exports.RectSeries = _rectSeries2.default;
	exports.RectSeriesCanvas = _rectSeriesCanvas2.default;
	exports.MarkSeries = _markSeries2.default;
	exports.MarkSeriesCanvas = _markSeriesCanvas2.default;
	exports.WhiskerSeries = _whiskerSeries2.default;
	exports.HeatmapSeries = _heatmapSeries2.default;
	exports.ContourSeries = _contourSeries2.default;
	exports.CustomSVGSeries = _customSvgSeries2.default;
	exports.AreaSeries = _areaSeries2.default;
	exports.ArcSeries = _arcSeries2.default;
	exports.LineMarkSeries = _lineMarkSeries2.default;
	exports.LineMarkSeriesCanvas = _lineMarkSeriesCanvas2.default;
	exports.Hint = _hint2.default;
	exports.Borders = _borders2.default;
	exports.Crosshair = _crosshair2.default;
	exports.XYPlot = _xyPlot2.default;
	exports.DecorativeAxis = _decorativeAxis2.default;
	exports.XAxis = _xAxis2.default;
	exports.YAxis = _yAxis2.default;
	exports.CircularGridLines = _circularGridLines2.default;
	exports.GridLines = _gridLines2.default;
	exports.GradientDefs = _gradientDefs2.default;
	exports.VerticalGridLines = _verticalGridLines2.default;
	exports.HorizontalGridLines = _horizontalGridLines2.default;
	exports.Voronoi = _voronoi2.default;
	exports.DiscreteColorLegend = _discreteColorLegend2.default;
	exports.SearchableDiscreteColorLegend = _searchableDiscreteColorLegend2.default;
	exports.ContinuousColorLegend = _continuousColorLegend2.default;
	exports.ContinuousSizeLegend = _continuousSizeLegend2.default;
	exports.Treemap = _treemap2.default;
	exports.RadialChart = _radialChart2.default;
	exports.RadarChart = _radarChart2.default;
	exports.ParallelCoordinates = _parallelCoordinates2.default;
	exports.Sankey = _sankey2.default;
	exports.Sunburst = _sunburst2.default;
	exports.AxisUtils = _axisUtils2.default;
	exports.ScaleUtils = _scalesUtils2.default;

/***/ },
/* 2911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  height: _propTypes2.default.number,
	  endColor: _propTypes2.default.string,
	  endTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  midColor: _propTypes2.default.string,
	  midTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	  startColor: _propTypes2.default.string,
	  startTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  width: _propTypes2.default.number
	}; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var defaultProps = {
	  className: '',
	  startColor: _theme.CONTINUOUS_COLOR_RANGE[0],
	  endColor: _theme.CONTINUOUS_COLOR_RANGE[1]
	};
	
	function ContinuousColorLegend(_ref) {
	  var startColor = _ref.startColor,
	      midColor = _ref.midColor,
	      endColor = _ref.endColor,
	      startTitle = _ref.startTitle,
	      midTitle = _ref.midTitle,
	      endTitle = _ref.endTitle,
	      height = _ref.height,
	      width = _ref.width,
	      className = _ref.className;
	
	  var colors = [startColor];
	  if (midColor) {
	    colors.push(midColor);
	  }
	  colors.push(endColor);
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-continuous-color-legend ' + className, style: { width: width, height: height } },
	    _react2.default.createElement('div', {
	      className: 'rv-gradient',
	      style: { background: 'linear-gradient(to right, ' + colors.join(',') + ')' } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-legend-titles' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__left' },
	        startTitle
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__right' },
	        endTitle
	      ),
	      midTitle ? _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__center' },
	        midTitle
	      ) : null
	    )
	  );
	}
	
	ContinuousColorLegend.displayName = 'ContinuousColorLegend';
	ContinuousColorLegend.propTypes = propTypes;
	ContinuousColorLegend.defaultProps = defaultProps;
	
	exports.default = ContinuousColorLegend;

/***/ },
/* 2912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var propTypes = {
	  className: _propTypes2.default.string,
	  circlesTotal: _propTypes2.default.number,
	  endSize: _propTypes2.default.number,
	  endTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  height: _propTypes2.default.number,
	  startSize: _propTypes2.default.number,
	  startTitle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	  width: _propTypes2.default.number
	};
	
	var defaultProps = {
	  circlesTotal: 10,
	  className: '',
	  endSize: 20,
	  startSize: 2
	};
	
	function ContinuousSizeLegend(_ref) {
	  var startTitle = _ref.startTitle,
	      endTitle = _ref.endTitle,
	      startSize = _ref.startSize,
	      endSize = _ref.endSize,
	      circlesTotal = _ref.circlesTotal,
	      height = _ref.height,
	      width = _ref.width,
	      className = _ref.className;
	
	  var circles = [];
	  var step = (endSize - startSize) / (circlesTotal - 1);
	
	  for (var i = 0; i < circlesTotal; i++) {
	    var size = step * i + startSize;
	    circles.push(_react2.default.createElement('div', { key: i, className: 'rv-bubble', style: {
	        width: size,
	        height: size,
	        borderRadius: size / 2
	      } }));
	    // Add the separator in order to justify the content (otherwise the tags
	    // will be stacked together without any margins around).
	    circles.push(' ');
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-continuous-size-legend ' + className, style: { width: width, height: height } },
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-bubbles', style: { height: endSize } },
	      circles,
	      _react2.default.createElement('div', { className: 'rv-spacer' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-legend-titles' },
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__left' },
	        startTitle
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'rv-legend-titles__right' },
	        endTitle
	      )
	    )
	  );
	}
	
	ContinuousSizeLegend.displayName = 'ContinuousSizeLegend';
	ContinuousSizeLegend.propTypes = propTypes;
	ContinuousSizeLegend.defaultProps = defaultProps;
	
	exports.default = ContinuousSizeLegend;

/***/ },
/* 2913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	function DiscreteColorLegendItem(_ref) {
	  var color = _ref.color,
	      disabled = _ref.disabled,
	      onClick = _ref.onClick,
	      orientation = _ref.orientation,
	      onMouseEnter = _ref.onMouseEnter,
	      onMouseLeave = _ref.onMouseLeave,
	      title = _ref.title;
	
	  var className = 'rv-discrete-color-legend-item ' + orientation;
	  if (disabled) {
	    className += ' disabled';
	  }
	  if (onClick) {
	    className += ' clickable';
	  }
	  return _react2.default.createElement(
	    'div',
	    { className: className, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
	    _react2.default.createElement('span', {
	      className: 'rv-discrete-color-legend-item__color',
	      style: disabled ? null : { background: color } }),
	    _react2.default.createElement(
	      'span',
	      { className: 'rv-discrete-color-legend-item__title' },
	      title
	    )
	  );
	}
	
	DiscreteColorLegendItem.propTypes = {
	  color: _propTypes2.default.string.isRequired,
	  disabled: _propTypes2.default.bool,
	  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
	  onClick: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  orientation: _propTypes2.default.oneOf(['vertical', 'horizontal']).isRequired
	};
	DiscreteColorLegendItem.defaultProps = {
	  disabled: false
	};
	DiscreteColorLegendItem.displayName = 'DiscreteColorLegendItem';
	
	exports.default = DiscreteColorLegendItem;

/***/ },
/* 2914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _discreteColorLegend = __webpack_require__(1312);
	
	var _discreteColorLegend2 = _interopRequireDefault(_discreteColorLegend);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = _extends({}, _discreteColorLegend2.default.propTypes, {
	  searchText: _propTypes2.default.string,
	  onSearchChange: _propTypes2.default.func,
	  searchPlaceholder: _propTypes2.default.string,
	  searchFn: _propTypes2.default.func
	});
	
	var defaultProps = {
	  className: '',
	  searchText: '',
	  searchFn: function searchFn(items, s) {
	    return items.filter(function (item) {
	      return String(item.title || item).toLowerCase().indexOf(s) !== -1;
	    });
	  }
	};
	
	function SearchableDiscreteColorLegend(props) {
	  var className = props.className,
	      colors = props.colors,
	      height = props.height,
	      items = props.items,
	      onItemClick = props.onItemClick,
	      onSearchChange = props.onSearchChange,
	      orientation = props.orientation,
	      searchFn = props.searchFn,
	      searchPlaceholder = props.searchPlaceholder,
	      searchText = props.searchText,
	      width = props.width;
	
	  var onChange = onSearchChange ? function (_ref) {
	    var value = _ref.target.value;
	    return onSearchChange(value);
	  } : null;
	  var filteredItems = searchFn(items, searchText);
	  return _react2.default.createElement(
	    'div',
	    { className: 'rv-search-wrapper ' + className, style: { width: width, height: height } },
	    _react2.default.createElement(
	      'form',
	      { className: 'rv-search-wrapper__form' },
	      _react2.default.createElement('input', {
	        type: 'search',
	        placeholder: searchPlaceholder,
	        className: 'rv-search-wrapper__form__input',
	        value: searchText,
	        onChange: onChange })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'rv-search-wrapper__contents' },
	      _react2.default.createElement(_discreteColorLegend2.default, {
	        colors: colors,
	        items: filteredItems,
	        onItemClick: onItemClick,
	        orientation: orientation
	      })
	    )
	  );
	}
	
	SearchableDiscreteColorLegend.propTypes = propTypes;
	SearchableDiscreteColorLegend.defaultProps = defaultProps;
	SearchableDiscreteColorLegend.displayName = 'SearchableDiscreteColorLegend';
	
	exports.default = SearchableDiscreteColorLegend;

/***/ },
/* 2915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FlexibleXYPlot = exports.FlexibleHeightXYPlot = exports.FlexibleWidthXYPlot = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.makeHeightFlexible = makeHeightFlexible;
	exports.makeVisFlexible = makeVisFlexible;
	exports.makeWidthFlexible = makeWidthFlexible;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _window = __webpack_require__(2258);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _reactUtils = __webpack_require__(203);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var CONTAINER_REF = 'container';
	
	// As a performance enhancement, we want to only listen once
	var resizeSubscribers = [];
	var DEBOUNCE_DURATION = 100;
	var timeoutId = null;
	
	/**
	 * Calls each subscriber, debounced to the
	 */
	function debounceEmitResize() {
	  _window2.default.clearTimeout(timeoutId);
	  timeoutId = _window2.default.setTimeout(emitResize, DEBOUNCE_DURATION);
	}
	
	/**
	 * Calls each subscriber once syncronously.
	 */
	function emitResize() {
	  resizeSubscribers.forEach(function (cb) {
	    return cb();
	  });
	}
	
	/**
	 * Add the given callback to the list of subscribers to be caled when the
	 * window resizes. Returns a function that, when called, removes the given
	 * callback from the list of subscribers. This function is also resposible for
	 * adding and removing the resize listener on `window`.
	 *
	 * @param {Function} cb - Subscriber callback function
	 * @returns {Function} Unsubscribe function
	 */
	function subscribeToDebouncedResize(cb) {
	  resizeSubscribers.push(cb);
	
	  // if we go from zero to one Flexible components instances, add the listener
	  if (resizeSubscribers.length === 1) {
	    _window2.default.addEventListener('resize', debounceEmitResize);
	  }
	  return function unsubscribe() {
	    removeSubscriber(cb);
	
	    // if we have no Flexible components, remove the listener
	    if (resizeSubscribers.length === 0) {
	      _window2.default.clearTimeout(timeoutId);
	      _window2.default.removeEventListener('resize', debounceEmitResize);
	    }
	  };
	}
	
	/**
	 * Helper for removing the given callback from the list of subscribers.
	 *
	 * @param {Function} cb - Subscriber callback function
	 */
	function removeSubscriber(cb) {
	  var index = resizeSubscribers.indexOf(cb);
	  if (index > -1) {
	    resizeSubscribers.splice(index, 1);
	  }
	}
	
	/**
	 * Helper for getting a display name for the child component
	 * @param {*} Component React class for the child component.
	 * @returns {String} The child components name
	 */
	function getDisplayName(Component) {
	  return Component.displayName || Component.name || 'Component';
	}
	
	/**
	 * Add the ability to stretch the visualization on window resize.
	 * @param {*} Component React class for the child component.
	 * @returns {*} Flexible component.
	 */
	
	function makeFlexible(Component, isWidthFlexible, isHeightFlexible) {
	
	  var ResultClass = function (_React$Component) {
	    _inherits(ResultClass, _React$Component);
	
	    _createClass(ResultClass, null, [{
	      key: 'propTypes',
	      get: function get() {
	        var _Component$propTypes = Component.propTypes,
	            height = _Component$propTypes.height,
	            width = _Component$propTypes.width,
	            otherPropTypes = _objectWithoutProperties(_Component$propTypes, ['height', 'width']); // eslint-disable-line no-unused-vars
	
	
	        return otherPropTypes;
	      }
	    }]);
	
	    function ResultClass(props) {
	      _classCallCheck(this, ResultClass);
	
	      var _this = _possibleConstructorReturn(this, (ResultClass.__proto__ || Object.getPrototypeOf(ResultClass)).call(this, props));
	
	      _this.state = {
	        height: 0,
	        width: 0
	      };
	      _this._onResize = _this._onResize.bind(_this);
	      return _this;
	    }
	
	    /**
	     * Get the width of the container and assign the width.
	     * @private
	     */
	
	
	    _createClass(ResultClass, [{
	      key: '_onResize',
	      value: function _onResize() {
	        var containerElement = (0, _reactUtils.getDOMNode)(this.refs[CONTAINER_REF]);
	        var offsetHeight = containerElement.offsetHeight,
	            offsetWidth = containerElement.offsetWidth;
	
	
	        var newHeight = this.state.height === offsetHeight ? {} : { height: offsetHeight };
	
	        var newWidth = this.state.width === offsetWidth ? {} : { width: offsetWidth };
	
	        this.setState(_extends({}, newHeight, newWidth));
	      }
	    }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this._onResize();
	        this.cancelSubscription = subscribeToDebouncedResize(this._onResize);
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps() {
	        this._onResize();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.cancelSubscription();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _state = this.state,
	            height = _state.height,
	            width = _state.width;
	
	        var props = _extends({}, this.props, { animation: height === 0 && width === 0 ? null : this.props.animation });
	
	        var updatedDimensions = _extends({}, isHeightFlexible ? { height: height } : {}, isWidthFlexible ? { width: width } : {});
	
	        return _react2.default.createElement(
	          'div',
	          {
	            ref: CONTAINER_REF,
	            style: { width: '100%', height: '100%' } },
	          _react2.default.createElement(Component, _extends({}, updatedDimensions, props))
	        );
	      }
	    }]);
	
	    return ResultClass;
	  }(_react2.default.Component);
	
	  ResultClass.displayName = 'Flexible' + getDisplayName(Component);
	
	  return ResultClass;
	}
	
	function makeHeightFlexible(component) {
	  return makeFlexible(component, false, true);
	}
	
	function makeVisFlexible(component) {
	  return makeFlexible(component, true, true);
	}
	
	function makeWidthFlexible(component) {
	  return makeFlexible(component, true, false);
	}
	
	var FlexibleWidthXYPlot = exports.FlexibleWidthXYPlot = makeWidthFlexible(_xyPlot2.default);
	var FlexibleHeightXYPlot = exports.FlexibleHeightXYPlot = makeHeightFlexible(_xyPlot2.default);
	var FlexibleXYPlot = exports.FlexibleXYPlot = makeVisFlexible(_xyPlot2.default);

/***/ },
/* 2916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Scale = __webpack_require__(180);
	
	var _d3Format = __webpack_require__(223);
	
	var _animation = __webpack_require__(38);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _theme = __webpack_require__(48);
	
	var _chartUtils = __webpack_require__(162);
	
	var _lineSeries = __webpack_require__(522);
	
	var _lineSeries2 = _interopRequireDefault(_lineSeries);
	
	var _lineMarkSeries = __webpack_require__(1316);
	
	var _lineMarkSeries2 = _interopRequireDefault(_lineMarkSeries);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _decorativeAxis = __webpack_require__(519);
	
	var _decorativeAxis2 = _interopRequireDefault(_decorativeAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-parallel-coordinates-chart';
	var DEFAULT_FORMAT = (0, _d3Format.format)('.2r');
	/**
	 * Generate axes for each of the domains
	 * @param {Object} props
	 - props.animation {Boolean}
	 - props.domains {Array} array of object specifying the way each axis is to be plotted
	 - props.style {object} style object for the whole chart
	 - props.tickFormat {Function} formatting function for axes
	 * @return {Array} the plotted axis components
	 */
	function getAxes(props) {
	  var animation = props.animation,
	      domains = props.domains,
	      style = props.style,
	      tickFormat = props.tickFormat;
	
	  return domains.map(function (domain, index) {
	    var sortedDomain = domain.domain;
	
	    var domainTickFormat = function domainTickFormat(t) {
	      return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
	    };
	
	    return _react2.default.createElement(_decorativeAxis2.default, {
	      animation: animation,
	      key: index + '-axis',
	      axisStart: { x: domain.name, y: 0 },
	      axisEnd: { x: domain.name, y: 1 },
	      axisDomain: sortedDomain,
	      numberOfTicks: 5,
	      tickValue: domainTickFormat,
	      style: style.axes
	    });
	  });
	}
	
	/**
	 * Generate labels for the ends of the axes
	 * @param {Object} props
	 - props.domains {Array} array of object specifying the way each axis is to be plotted
	 - props.style {object} style object for just the labels
	 * @return {Array} the prepped data for the labelSeries
	 */
	function getLabels(props) {
	  var domains = props.domains,
	      style = props.style;
	
	  return domains.map(function (domain, index) {
	    return {
	      x: domain.name,
	      y: 1.1,
	      label: domain.name,
	      style: style
	    };
	  });
	}
	
	/**
	 * Generate the actual lines to be plotted
	 * @param {Object} props
	 - props.animation {Boolean}
	 - props.data {Array} array of object specifying what values are to be plotted
	 - props.domains {Array} array of object specifying the way each axis is to be plotted
	 - props.style {object} style object for the whole chart
	 - props.showMarks {Bool} whether or not to use the line mark series
	 * @return {Array} the plotted axis components
	 */
	function getLines(props) {
	  var animation = props.animation,
	      colorRange = props.colorRange,
	      domains = props.domains,
	      data = props.data,
	      style = props.style,
	      showMarks = props.showMarks;
	
	  var scales = domains.reduce(function (acc, _ref) {
	    var domain = _ref.domain,
	        name = _ref.name;
	
	    acc[name] = (0, _d3Scale.scaleLinear)().domain(domain).range([0, 1]);
	    return acc;
	  }, {});
	
	  return data.map(function (row, rowIndex) {
	    var mappedData = domains.map(function (domain, index) {
	      var getValue = domain.getValue,
	          name = domain.name;
	
	      return {
	        x: name,
	        y: scales[name](getValue ? getValue(row) : row[name])
	      };
	    });
	    var lineProps = {
	      animation: animation,
	      className: predefinedClassName + '-line',
	      key: rowIndex + '-polygon',
	      data: mappedData,
	      color: row.color || colorRange[rowIndex % colorRange.length],
	      style: style.lines
	    };
	    return showMarks ? _react2.default.createElement(_lineMarkSeries2.default, lineProps) : _react2.default.createElement(_lineSeries2.default, lineProps);
	  });
	}
	
	var ParallelCoordinates = function (_Component) {
	  _inherits(ParallelCoordinates, _Component);
	
	  function ParallelCoordinates() {
	    _classCallCheck(this, ParallelCoordinates);
	
	    return _possibleConstructorReturn(this, (ParallelCoordinates.__proto__ || Object.getPrototypeOf(ParallelCoordinates)).apply(this, arguments));
	  }
	
	  _createClass(ParallelCoordinates, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          colorRange = _props.colorRange,
	          data = _props.data,
	          domains = _props.domains,
	          height = _props.height,
	          hideInnerMostValues = _props.hideInnerMostValues,
	          margin = _props.margin,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          showMarks = _props.showMarks,
	          style = _props.style,
	          tickFormat = _props.tickFormat,
	          width = _props.width;
	
	
	      var axes = getAxes({
	        domains: domains,
	        animation: animation,
	        hideInnerMostValues: hideInnerMostValues,
	        style: style,
	        tickFormat: tickFormat
	      });
	
	      var lines = getLines({
	        animation: animation,
	        colorRange: colorRange,
	        domains: domains,
	        data: data,
	        showMarks: showMarks,
	        style: style
	      });
	      var labelSeries = _react2.default.createElement(_labelSeries2.default, {
	        animation: true,
	        key: className,
	        className: predefinedClassName + '-label',
	        data: getLabels({ domains: domains, style: style.labels }) });
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          width: width,
	          margin: margin,
	          dontCheckIfEmpty: true,
	          className: className + ' ' + predefinedClassName,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          xType: 'ordinal',
	          yDomain: [0, 1] },
	        children,
	        axes.concat(lines).concat(labelSeries)
	      );
	    }
	  }]);
	
	  return ParallelCoordinates;
	}(_react.Component);
	
	ParallelCoordinates.displayName = 'ParallelCoordinates';
	ParallelCoordinates.propTypes = {
	  animation: _animation.AnimationPropType,
	  className: _propTypes2.default.string,
	  colorType: _propTypes2.default.string,
	  colorRange: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  domains: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    domain: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	    tickFormat: _propTypes2.default.func
	  })).isRequired,
	  height: _propTypes2.default.number.isRequired,
	  margin: _chartUtils.MarginPropType,
	  style: _propTypes2.default.shape({
	    axes: _propTypes2.default.object,
	    labels: _propTypes2.default.object,
	    lines: _propTypes2.default.object
	  }),
	  showMarks: _propTypes2.default.bool,
	  tickFormat: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired
	};
	ParallelCoordinates.defaultProps = {
	  className: '',
	  colorType: 'category',
	  colorRange: _theme.DISCRETE_COLOR_RANGE,
	  style: {
	    axes: {
	      line: {},
	      ticks: {},
	      text: {}
	    },
	    labels: {
	      fontSize: 10,
	      textAnchor: 'middle'
	    },
	    lines: {
	      strokeWidth: 1,
	      strokeOpacity: 1
	    }
	  },
	  tickFormat: DEFAULT_FORMAT
	};
	
	exports.default = ParallelCoordinates;

/***/ },
/* 2917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  height: _propTypes2.default.number.isRequired,
	  style: _propTypes2.default.object,
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
	  width: _propTypes2.default.number.isRequired
	};
	
	var defaultProps = {
	  style: {}
	};
	
	function AxisLine(_ref) {
	  var orientation = _ref.orientation,
	      width = _ref.width,
	      height = _ref.height,
	      style = _ref.style;
	
	  var lineProps = void 0;
	  if (orientation === LEFT) {
	    lineProps = {
	      x1: width,
	      x2: width,
	      y1: 0,
	      y2: height
	    };
	  } else if (orientation === RIGHT) {
	    lineProps = {
	      x1: 0,
	      x2: 0,
	      y1: 0,
	      y2: height
	    };
	  } else if (orientation === TOP) {
	    lineProps = {
	      x1: 0,
	      x2: width,
	      y1: height,
	      y2: height
	    };
	  } else {
	    lineProps = {
	      x1: 0,
	      x2: width,
	      y1: 0,
	      y2: 0
	    };
	  }
	  return _react2.default.createElement('line', _extends({}, lineProps, { className: 'rv-xy-plot__axis__line', style: style }));
	}
	
	AxisLine.defaultProps = defaultProps;
	AxisLine.displayName = 'AxisLine';
	AxisLine.propTypes = propTypes;
	
	exports.default = AxisLine;

/***/ },
/* 2918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(80);
	
	var _scalesUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = {
	  height: _propTypes2.default.number.isRequired,
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
	  style: _propTypes2.default.object,
	  width: _propTypes2.default.number.isRequired
	};
	
	var defaultProps = {
	  style: {}
	};
	
	function _getTickFormatFn(scale, tickTotal, tickFormat) {
	  return !tickFormat ? scale.tickFormat ? scale.tickFormat(tickTotal) : function (v) {
	    return v;
	  } : tickFormat;
	}
	
	var AxisTicks = function (_React$Component) {
	  _inherits(AxisTicks, _React$Component);
	
	  function AxisTicks() {
	    _classCallCheck(this, AxisTicks);
	
	    return _possibleConstructorReturn(this, (AxisTicks.__proto__ || Object.getPrototypeOf(AxisTicks)).apply(this, arguments));
	  }
	
	  _createClass(AxisTicks, [{
	    key: '_isAxisVertical',
	
	
	    /**
	     * Gets if the axis is vertical.
	     * @returns {boolean} True if vertical.
	     * @private
	     */
	    value: function _isAxisVertical() {
	      var orientation = this.props.orientation;
	
	      return orientation === LEFT || orientation === RIGHT;
	    }
	
	    /**
	     * Check if axis ticks should be mirrored (for the right and top positions.
	     * @returns {boolean} True if mirrored.
	     * @private
	     */
	
	  }, {
	    key: '_areTicksWrapped',
	    value: function _areTicksWrapped() {
	      var orientation = this.props.orientation;
	
	      return orientation === LEFT || orientation === TOP;
	    }
	  }, {
	    key: '_getTickContainerPropsGetterFn',
	    value: function _getTickContainerPropsGetterFn() {
	      if (this._isAxisVertical()) {
	        return function (pos) {
	          return { transform: 'translate(0, ' + pos + ')' };
	        };
	      }
	      return function (pos) {
	        return { transform: 'translate(' + pos + ', 0)' };
	      };
	    }
	
	    /**
	     * Get the props of the tick line.
	     * @returns {Object} Props.
	     * @private
	     */
	
	  }, {
	    key: '_getTickLineProps',
	    value: function _getTickLineProps() {
	      var _ref;
	
	      var _props = this.props,
	          tickSize = _props.tickSize,
	          _props$tickSizeOuter = _props.tickSizeOuter,
	          tickSizeOuter = _props$tickSizeOuter === undefined ? tickSize : _props$tickSizeOuter,
	          _props$tickSizeInner = _props.tickSizeInner,
	          tickSizeInner = _props$tickSizeInner === undefined ? tickSize : _props$tickSizeInner;
	
	      var isVertical = this._isAxisVertical();
	      var tickXAttr = isVertical ? 'y' : 'x';
	      var tickYAttr = isVertical ? 'x' : 'y';
	      var wrap = this._areTicksWrapped() ? -1 : 1;
	      return _ref = {}, _defineProperty(_ref, tickXAttr + '1', 0), _defineProperty(_ref, tickXAttr + '2', 0), _defineProperty(_ref, tickYAttr + '1', -wrap * tickSizeInner), _defineProperty(_ref, tickYAttr + '2', wrap * tickSizeOuter), _ref;
	    }
	
	    /**
	     * Get attributes for the label of the tick.
	     * @returns {Object} Object with properties.
	     * @private
	     */
	
	  }, {
	    key: '_getTickLabelProps',
	    value: function _getTickLabelProps() {
	      var _props2 = this.props,
	          orientation = _props2.orientation,
	          tickLabelAngle = _props2.tickLabelAngle,
	          tickSize = _props2.tickSize,
	          _props2$tickSizeOuter = _props2.tickSizeOuter,
	          tickSizeOuter = _props2$tickSizeOuter === undefined ? tickSize : _props2$tickSizeOuter,
	          _props2$tickPadding = _props2.tickPadding,
	          tickPadding = _props2$tickPadding === undefined ? tickSize : _props2$tickPadding;
	
	      // Assign the text orientation inside the label of the tick mark.
	
	      var textAnchor = void 0;
	      if (orientation === LEFT || orientation === BOTTOM && tickLabelAngle) {
	        textAnchor = 'end';
	      } else if (orientation === RIGHT || orientation === TOP && tickLabelAngle) {
	        textAnchor = 'start';
	      } else {
	        textAnchor = 'middle';
	      }
	
	      // The label's position is translated to the given padding and then the
	      // label is rotated to the given angle.
	      var isVertical = this._isAxisVertical();
	      var wrap = this._areTicksWrapped() ? -1 : 1;
	
	      var labelOffset = wrap * (tickSizeOuter + tickPadding);
	      var transform = (isVertical ? 'translate(' + labelOffset + ', 0)' : 'translate(0, ' + labelOffset + ')') + (tickLabelAngle ? ' rotate(' + tickLabelAngle + ')' : '');
	
	      // Set the vertical offset of the label according to the position of
	      // the axis.
	      var dy = orientation === TOP || tickLabelAngle ? '0' : orientation === BOTTOM ? '0.72em' : '0.32em';
	
	      return {
	        textAnchor: textAnchor,
	        dy: dy,
	        transform: transform
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          attr = _props3.attr,
	          orientation = _props3.orientation,
	          width = _props3.width,
	          height = _props3.height,
	          style = _props3.style,
	          tickFormat = _props3.tickFormat,
	          tickTotal = _props3.tickTotal,
	          tickValues = _props3.tickValues;
	
	
	      var x = orientation === LEFT ? width : 0;
	      var y = orientation === TOP ? height : 0;
	
	      var scale = (0, _scalesUtils.getAttributeScale)(this.props, attr);
	
	      var values = (0, _axisUtils.getTickValues)(scale, tickTotal, tickValues);
	      var tickFormatFn = _getTickFormatFn(scale, tickTotal, tickFormat);
	
	      var translateFn = this._getTickContainerPropsGetterFn();
	      var pathProps = this._getTickLineProps();
	      var textProps = this._getTickLabelProps();
	
	      var ticks = values.map(function (v, i) {
	        var pos = scale(v);
	        var text = tickFormatFn(v, i);
	
	        return _react2.default.createElement(
	          'g',
	          _extends({ key: i }, translateFn(pos, 0), {
	            className: 'rv-xy-plot__axis__tick',
	            style: style }),
	          _react2.default.createElement('line', _extends({}, pathProps, {
	            className: 'rv-xy-plot__axis__tick__line',
	            style: _extends({}, style, style.line)
	          })),
	          _react2.default.createElement(
	            'text',
	            _extends({}, textProps, {
	              className: 'rv-xy-plot__axis__tick__text',
	              style: _extends({}, style, style.text)
	            }),
	            text
	          )
	        );
	      });
	
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + x + ', ' + y + ')',
	          className: 'rv-xy-plot__axis__ticks' },
	        ticks
	      );
	    }
	  }]);
	
	  return AxisTicks;
	}(_react2.default.Component);
	
	AxisTicks.defaultProps = defaultProps;
	AxisTicks.displayName = 'AxisTicks';
	AxisTicks.propTypes = propTypes;
	AxisTicks.requiresSVG = true;
	
	exports.default = AxisTicks;

/***/ },
/* 2919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	// Assuming that 16px = 1em
	var ADJUSTMENT_FOR_TEXT_SIZE = 16;
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT,
	    TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	/**
	 * Compute transformations, keyed by orientation
	 * @param {number} width - width of axis
	 * @param {number} height - height of axis
	 * @returns {Object} Object of transformations, keyed by orientation
	 */
	
	var transformation = function transformation(width, height) {
	  var _ref;
	
	  return _ref = {}, _defineProperty(_ref, LEFT, {
	    x: ADJUSTMENT_FOR_TEXT_SIZE,
	    y: 0,
	    rotation: -90,
	    textAnchor: 'end'
	  }), _defineProperty(_ref, RIGHT, {
	    x: ADJUSTMENT_FOR_TEXT_SIZE * -0.5,
	    y: height,
	    rotation: -90,
	    textAnchor: 'start'
	  }), _defineProperty(_ref, TOP, {
	    x: 0,
	    y: ADJUSTMENT_FOR_TEXT_SIZE,
	    rotation: 0,
	    textAnchor: 'start'
	  }), _defineProperty(_ref, BOTTOM, {
	    x: width,
	    y: -6,
	    rotation: 0,
	    textAnchor: 'end'
	  }), _ref;
	};
	
	var propTypes = {
	  width: _propTypes2.default.number.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT, TOP, BOTTOM]).isRequired,
	  style: _propTypes2.default.object,
	  title: _propTypes2.default.string.isRequired
	};
	
	function AxisTitle(_ref2) {
	  var orientation = _ref2.orientation,
	      width = _ref2.width,
	      height = _ref2.height,
	      style = _ref2.style,
	      title = _ref2.title;
	
	  var outerGroupTranslateX = orientation === LEFT ? width : 0;
	  var outerGroupTranslateY = orientation === TOP ? height : 0;
	  var outerGroupTransform = 'translate(' + outerGroupTranslateX + ', ' + outerGroupTranslateY + ')';
	  var _transformation$orien = transformation(width, height)[orientation],
	      x = _transformation$orien.x,
	      y = _transformation$orien.y,
	      rotation = _transformation$orien.rotation,
	      textAnchor = _transformation$orien.textAnchor;
	
	  var innerGroupTransform = 'translate(' + x + ', ' + y + ') rotate(' + rotation + ')';
	
	  return _react2.default.createElement(
	    'g',
	    { transform: outerGroupTransform, className: 'rv-xy-plot__axis__title' },
	    _react2.default.createElement(
	      'g',
	      { style: _extends({ textAnchor: textAnchor }, style), transform: innerGroupTransform },
	      _react2.default.createElement(
	        'text',
	        { style: style },
	        title
	      )
	    )
	  );
	}
	
	AxisTitle.displayName = 'AxisTitle';
	AxisTitle.propTypes = propTypes;
	
	exports.default = AxisTitle;

/***/ },
/* 2920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	exports.default = decorativeAxisTick;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axisUtils = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Generate the actual polygons to be plotted
	 * @param {Object} props
	 - props.animation {Boolean}
	 - props.axisDomain {Array} a pair of values specifying the domain of the axis
	 - props.numberOfTicks{Number} the number of ticks on the axis
	 - props.axisStart {Object} a object specify in cartesian space the start of the axis
	 example: {x: 0, y: 0}
	 - props.axisEnd {Object} a object specify in cartesian space the start of the axis
	 - props.tickValue {Func} a formatting function for the tick values
	 - props.tickSize {Number} a pixel size of the axis
	 - props.style {Object} The style object for the axis
	 * @return {Component} the plotted axis
	 */
	function decorativeAxisTick(props) {
	  var axisDomain = props.axisDomain,
	      numberOfTicks = props.numberOfTicks,
	      axisStart = props.axisStart,
	      axisEnd = props.axisEnd,
	      tickValue = props.tickValue,
	      tickSize = props.tickSize,
	      style = props.style;
	
	  var _generatePoints = (0, _axisUtils.generatePoints)({ axisStart: axisStart, axisEnd: axisEnd, numberOfTicks: numberOfTicks, axisDomain: axisDomain }),
	      points = _generatePoints.points;
	  // add a quarter rotation to make ticks orthogonal to axis
	
	
	  var tickAngle = (0, _axisUtils.getAxisAngle)(axisStart, axisEnd) + Math.PI / 2;
	  return points.map(function (point, index) {
	    var tickProps = _extends({
	      x1: 0,
	      y1: 0,
	      x2: tickSize * Math.cos(tickAngle),
	      y2: tickSize * Math.sin(tickAngle)
	    }, style.ticks);
	
	    var textProps = _extends({
	      x: tickSize * Math.cos(tickAngle),
	      y: tickSize * Math.sin(tickAngle),
	      textAnchor: 'start'
	    }, style.text);
	    return _react2.default.createElement(
	      'g',
	      { key: index, transform: 'translate(' + point.x + ', ' + point.y + ')', className: 'rv-xy-plot__axis__tick' },
	      _react2.default.createElement('line', _extends({}, tickProps, { className: 'rv-xy-plot__axis__tick__line' })),
	      _react2.default.createElement(
	        'text',
	        _extends({}, textProps, { className: 'rv-xy-plot__axis__tick__text' }),
	        tickValue(point.text)
	      )
	    );
	  });
	}

/***/ },
/* 2921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(80);
	
	var _axis = __webpack_require__(1313);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TOP = _axisUtils.ORIENTATION.TOP,
	    BOTTOM = _axisUtils.ORIENTATION.BOTTOM;
	
	
	var propTypes = _extends({}, _axis2.default.propTypes, {
	  orientation: _propTypes2.default.oneOf([TOP, BOTTOM])
	});
	
	var defaultProps = {
	  orientation: BOTTOM,
	  attr: 'x',
	  attrAxis: 'y'
	};
	
	function XAxis(props) {
	  return _react2.default.createElement(_axis2.default, props);
	}
	
	XAxis.displayName = 'XAxis';
	XAxis.propTypes = propTypes;
	XAxis.defaultProps = defaultProps;
	XAxis.requiresSVG = true;
	
	exports.default = XAxis;

/***/ },
/* 2922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(80);
	
	var _axis = __webpack_require__(1313);
	
	var _axis2 = _interopRequireDefault(_axis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LEFT = _axisUtils.ORIENTATION.LEFT,
	    RIGHT = _axisUtils.ORIENTATION.RIGHT;
	
	
	var propTypes = _extends({}, _axis2.default.propTypes, {
	  orientation: _propTypes2.default.oneOf([LEFT, RIGHT])
	});
	
	var defaultProps = {
	  orientation: LEFT,
	  attr: 'y',
	  attrAxis: 'x'
	};
	
	function YAxis(props) {
	  return _react2.default.createElement(_axis2.default, props);
	}
	
	YAxis.displayName = 'YAxis';
	YAxis.propTypes = propTypes;
	YAxis.defaultProps = defaultProps;
	YAxis.requiresSVG = true;
	
	exports.default = YAxis;

/***/ },
/* 2923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var propTypes = {
	  style: _propTypes2.default.shape({
	    bottom: _propTypes2.default.object,
	    left: _propTypes2.default.object,
	    right: _propTypes2.default.object,
	    top: _propTypes2.default.object
	  }),
	  // supplied by xyplot
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	
	var CLASSES = {
	  bottom: 'rv-xy-plot__borders-bottom',
	  container: 'rv-xy-plot__borders',
	  left: 'rv-xy-plot__borders-left',
	  right: 'rv-xy-plot__borders-right',
	  top: 'rv-xy-plot__borders-top'
	};
	
	var Borders = function (_PureComponent) {
	  _inherits(Borders, _PureComponent);
	
	  function Borders() {
	    _classCallCheck(this, Borders);
	
	    return _possibleConstructorReturn(this, (Borders.__proto__ || Object.getPrototypeOf(Borders)).apply(this, arguments));
	  }
	
	  _createClass(Borders, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          marginTop = _props.marginTop,
	          marginBottom = _props.marginBottom,
	          marginLeft = _props.marginLeft,
	          marginRight = _props.marginRight,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          style = _props.style,
	          className = _props.className;
	
	      var height = innerHeight + marginTop + marginBottom;
	      var width = innerWidth + marginLeft + marginRight;
	      return _react2.default.createElement(
	        'g',
	        { className: CLASSES.container + ' ' + className },
	        _react2.default.createElement('rect', {
	          className: CLASSES.bottom + ' ' + className + '-bottom',
	          style: _extends({}, style.all, style.bottom),
	          x: 0,
	          y: height - marginBottom,
	          width: width,
	          height: marginBottom }),
	        _react2.default.createElement('rect', {
	          className: CLASSES.left + ' ' + className + '-left',
	          style: _extends({}, style.all, style.left),
	          x: 0,
	          y: 0,
	          width: marginLeft,
	          height: height }),
	        _react2.default.createElement('rect', {
	          className: CLASSES.right + ' ' + className + '-right',
	          style: _extends({}, style.all, style.right),
	          x: width - marginRight,
	          y: 0,
	          width: marginRight,
	          height: height }),
	        _react2.default.createElement('rect', {
	          className: CLASSES.top + ' ' + className + '-top',
	          style: _extends({}, style.all, style.top),
	          x: 0,
	          y: 0,
	          width: width,
	          height: marginTop })
	      );
	    }
	  }]);
	
	  return Borders;
	}(_react.PureComponent);
	
	Borders.displayName = 'Borders';
	Borders.defaultProps = {
	  className: '',
	  style: {
	    all: {},
	    bottom: {},
	    left: {},
	    right: {},
	    top: {}
	  }
	};
	Borders.propTypes = propTypes;
	Borders.requiresSVG = true;
	
	exports.default = Borders;

/***/ },
/* 2924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _axisUtils = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var animatedProps = ['xRange', 'yRange', 'xDomain', 'yDomain', 'width', 'height', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'tickTotal'];
	
	var CircularGridLines = function (_PureComponent) {
	  _inherits(CircularGridLines, _PureComponent);
	
	  function CircularGridLines() {
	    _classCallCheck(this, CircularGridLines);
	
	    return _possibleConstructorReturn(this, (CircularGridLines.__proto__ || Object.getPrototypeOf(CircularGridLines)).apply(this, arguments));
	  }
	
	  _createClass(CircularGridLines, [{
	    key: '_getDefaultProps',
	    value: function _getDefaultProps() {
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          innerHeight = _props.innerHeight,
	          marginTop = _props.marginTop,
	          marginLeft = _props.marginLeft;
	
	      return {
	        left: marginLeft,
	        top: marginTop,
	        width: innerWidth,
	        height: innerHeight,
	        style: {},
	        tickTotal: (0, _axisUtils.getTicksTotalFromSize)(Math.min(innerWidth, innerHeight))
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          animation = _props2.animation,
	          centerX = _props2.centerX,
	          centerY = _props2.centerY;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: animatedProps }),
	          _react2.default.createElement(CircularGridLines, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var props = _extends({}, this._getDefaultProps(), this.props);
	
	      var tickTotal = props.tickTotal,
	          tickValues = props.tickValues,
	          marginLeft = props.marginLeft,
	          marginTop = props.marginTop,
	          rRange = props.rRange,
	          style = props.style;
	
	
	      var xScale = (0, _scalesUtils.getAttributeScale)(props, 'x');
	      var yScale = (0, _scalesUtils.getAttributeScale)(props, 'y');
	      var values = (0, _axisUtils.getTickValues)(xScale, tickTotal, tickValues);
	      return _react2.default.createElement(
	        'g',
	        {
	          transform: 'translate(' + (xScale(centerX) + marginLeft) + ',' + (yScale(centerY) + marginTop) + ')',
	          className: 'rv-xy-plot__circular-grid-lines' },
	        values.reduce(function (res, value, index) {
	          var radius = xScale(value);
	          if (rRange && (radius < rRange[0] || radius > rRange[1])) {
	            return res;
	          }
	          return res.concat([_react2.default.createElement('circle', _extends({ cx: 0, cy: 0, r: radius }, {
	            key: index,
	            className: 'rv-xy-plot__circular-grid-lines__line',
	            style: style }))]);
	        }, [])
	      );
	    }
	  }]);
	
	  return CircularGridLines;
	}(_react.PureComponent);
	
	CircularGridLines.displayName = 'CircularGridLines';
	CircularGridLines.propTypes = {
	  centerX: _propTypes2.default.number,
	  centerY: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  top: _propTypes2.default.number,
	  left: _propTypes2.default.number,
	  rRange: _propTypes2.default.arrayOf(_propTypes2.default.number),
	
	  style: _propTypes2.default.object,
	
	  tickValues: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  tickTotal: _propTypes2.default.number,
	
	  animation: _animation.AnimationPropType,
	  // generally supplied by xyplot
	  marginTop: _propTypes2.default.number,
	  marginBottom: _propTypes2.default.number,
	  marginLeft: _propTypes2.default.number,
	  marginRight: _propTypes2.default.number,
	  innerWidth: _propTypes2.default.number,
	  innerHeight: _propTypes2.default.number
	};
	CircularGridLines.defaultProps = {
	  centerX: 0,
	  centerY: 0
	};
	CircularGridLines.requiresSVG = true;
	
	exports.default = CircularGridLines;

/***/ },
/* 2925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scalesUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Format title by detault.
	 * @param {Array} values List of values.
	 * @returns {*} Formatted value or undefined.
	 */
	function defaultTitleFormat(values) {
	  var value = getFirstNonEmptyValue(values);
	  if (value) {
	    return {
	      title: 'x',
	      value: value.x
	    };
	  }
	}
	
	/**
	 * Format items by default.
	 * @param {Array} values Array of values.
	 * @returns {*} Formatted list of items.
	 */
	function defaultItemsFormat(values) {
	  return values.map(function (v, i) {
	    if (v) {
	      return { value: v.y, title: i };
	    }
	  });
	}
	
	/**
	 * Get the first non-empty item from an array.
	 * @param {Array} values Array of values.
	 * @returns {*} First non-empty value or undefined.
	 */
	function getFirstNonEmptyValue(values) {
	  return (values || []).find(function (v) {
	    return Boolean(v);
	  });
	}
	
	var Crosshair = function (_PureComponent) {
	  _inherits(Crosshair, _PureComponent);
	
	  function Crosshair() {
	    _classCallCheck(this, Crosshair);
	
	    return _possibleConstructorReturn(this, (Crosshair.__proto__ || Object.getPrototypeOf(Crosshair)).apply(this, arguments));
	  }
	
	  _createClass(Crosshair, [{
	    key: '_renderCrosshairTitle',
	
	
	    /**
	     * Render crosshair title.
	     * @returns {*} Container with the crosshair title.
	     * @private
	     */
	    value: function _renderCrosshairTitle() {
	      var _props = this.props,
	          values = _props.values,
	          titleFormat = _props.titleFormat,
	          style = _props.style;
	
	      var titleItem = titleFormat(values);
	      if (!titleItem) {
	        return null;
	      }
	      return _react2.default.createElement(
	        'div',
	        { className: 'rv-crosshair__title', key: 'title', style: style.title },
	        _react2.default.createElement(
	          'span',
	          { className: 'rv-crosshair__title__title' },
	          titleItem.title
	        ),
	        ': ',
	        _react2.default.createElement(
	          'span',
	          { className: 'rv-crosshair__title__value' },
	          titleItem.value
	        )
	      );
	    }
	
	    /**
	     * Render crosshair items (title + value for each series).
	     * @returns {*} Array of React classes with the crosshair values.
	     * @private
	     */
	
	  }, {
	    key: '_renderCrosshairItems',
	    value: function _renderCrosshairItems() {
	      var _props2 = this.props,
	          values = _props2.values,
	          itemsFormat = _props2.itemsFormat;
	
	      var items = itemsFormat(values);
	      if (!items) {
	        return null;
	      }
	      return items.filter(function (i) {
	        return i;
	      }).map(function renderValue(item, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'rv-crosshair__item', key: 'item' + i },
	          _react2.default.createElement(
	            'span',
	            { className: 'rv-crosshair__item__title' },
	            item.title
	          ),
	          ': ',
	          _react2.default.createElement(
	            'span',
	            { className: 'rv-crosshair__item__value' },
	            item.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          values = _props3.values,
	          marginTop = _props3.marginTop,
	          marginLeft = _props3.marginLeft,
	          innerWidth = _props3.innerWidth,
	          innerHeight = _props3.innerHeight,
	          style = _props3.style;
	
	      var value = getFirstNonEmptyValue(values);
	      if (!value) {
	        return null;
	      }
	      var x = (0, _scalesUtils.getAttributeFunctor)(this.props, 'x');
	      var innerLeft = x(value);
	
	      var _props$orientation = this.props.orientation,
	          orientation = _props$orientation === undefined ? innerLeft > innerWidth / 2 ? 'left' : 'right' : _props$orientation;
	
	      var left = marginLeft + innerLeft;
	      var top = marginTop;
	      var innerClassName = 'rv-crosshair__inner rv-crosshair__inner--' + orientation;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-crosshair',
	          style: { left: left + 'px', top: top + 'px' } },
	        _react2.default.createElement('div', {
	          className: 'rv-crosshair__line',
	          style: _extends({ height: innerHeight + 'px' }, style.line) }),
	        _react2.default.createElement(
	          'div',
	          { className: innerClassName },
	          children ? children : _react2.default.createElement(
	            'div',
	            { className: 'rv-crosshair__inner__content', style: style.box },
	            _react2.default.createElement(
	              'div',
	              null,
	              this._renderCrosshairTitle(),
	              this._renderCrosshairItems()
	            )
	          )
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        values: _propTypes2.default.array,
	        series: _propTypes2.default.object,
	        innerWidth: _propTypes2.default.number,
	        innerHeight: _propTypes2.default.number,
	        marginLeft: _propTypes2.default.number,
	        marginTop: _propTypes2.default.number,
	        orientation: _propTypes2.default.oneOf(['left', 'right']),
	        itemsFormat: _propTypes2.default.func,
	        titleFormat: _propTypes2.default.func,
	        style: _propTypes2.default.shape({
	          line: _propTypes2.default.object,
	          title: _propTypes2.default.object,
	          box: _propTypes2.default.object
	        })
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        titleFormat: defaultTitleFormat,
	        itemsFormat: defaultItemsFormat,
	        style: {
	          line: {},
	          title: {},
	          box: {}
	        }
	      };
	    }
	  }]);
	
	  return Crosshair;
	}(_react.PureComponent);
	
	Crosshair.displayName = 'Crosshair';
	
	exports.default = Crosshair;

/***/ },
/* 2926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-gradient-defs';
	
	var GradientDefs = function (_PureComponent) {
	  _inherits(GradientDefs, _PureComponent);
	
	  function GradientDefs() {
	    _classCallCheck(this, GradientDefs);
	
	    return _possibleConstructorReturn(this, (GradientDefs.__proto__ || Object.getPrototypeOf(GradientDefs)).apply(this, arguments));
	  }
	
	  _createClass(GradientDefs, [{
	    key: 'render',
	    value: function render() {
	      var className = this.props.className;
	
	      return _react2.default.createElement(
	        'defs',
	        { className: predefinedClassName + ' ' + className },
	        this.props.children
	      );
	    }
	  }]);
	
	  return GradientDefs;
	}(_react.PureComponent);
	
	GradientDefs.displayName = 'GradientDefs';
	GradientDefs.requiresSVG = true;
	GradientDefs.propTypes = {
	  className: _propTypes2.default.string
	};
	GradientDefs.defaultProps = {
	  className: ''
	};
	
	exports.default = GradientDefs;

/***/ },
/* 2927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _scalesUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/*
	 * Hint provides two options for placement of hint:
	 * a) around a data point in one of four quadrants (imagine the point bisected
	 *    by two axes -vertical, horizontal- creating 4 quadrants around a data
	 *    point).
	 * b) **New** pin to an edge of chart/plot area and position along that edge
	 *    using data point's other dimension value.
	 *
	 * To support these two options, deprecate one Hint props (orientation) with two
	 * new Hint align prop object (horizontal, vertical) with following values:
	 *
	 *   horizontal: auto, left, right, leftEdge, rightEdge
	 *   vertical: auto, bottom, top, bottomEdge, topEdge
	 *
	 * Thus, the following ALIGN constants are the values for horizontal
	 * and vertical
	 */
	var ALIGN = {
	  AUTO: 'auto',
	  LEFT: 'left',
	  RIGHT: 'right',
	  LEFT_EDGE: 'leftEdge',
	  RIGHT_EDGE: 'rightEdge',
	  BOTTOM: 'bottom',
	  TOP: 'top',
	  BOTTOM_EDGE: 'bottomEdge',
	  TOP_EDGE: 'topEdge'
	};
	
	/**
	 * For backwards support, retain the ORIENTATION prop constants
	 */
	var ORIENTATION = {
	  BOTTOM_LEFT: 'bottomleft',
	  BOTTOM_RIGHT: 'bottomright',
	  TOP_LEFT: 'topleft',
	  TOP_RIGHT: 'topright'
	};
	
	/**
	 * Default format function for the value.
	 * @param {Object} value Value.
	 * @returns {Array} title-value pairs.
	 */
	function defaultFormat(value) {
	  return Object.keys(value).map(function getProp(key) {
	    return { title: key, value: value[key] };
	  });
	}
	
	var Hint = function (_PureComponent) {
	  _inherits(Hint, _PureComponent);
	
	  function Hint() {
	    _classCallCheck(this, Hint);
	
	    return _possibleConstructorReturn(this, (Hint.__proto__ || Object.getPrototypeOf(Hint)).apply(this, arguments));
	  }
	
	  _createClass(Hint, [{
	    key: '_getCSSRight',
	
	
	    /**
	     * Get the right coordinate of the hint.
	     * When x undefined or null, edge case, pin right.
	     * @param {number} x X.
	     * @returns {{right: *}} Mixin.
	     * @private
	     */
	    value: function _getCSSRight(x) {
	      if (x === undefined || x === null) {
	        return {
	          right: 0
	        };
	      }
	
	      var _props = this.props,
	          innerWidth = _props.innerWidth,
	          marginRight = _props.marginRight;
	
	      return {
	        right: marginRight + innerWidth - x
	      };
	    }
	
	    /**
	     * Get the left coordinate of the hint.
	     * When x undefined or null, edge case, pin left.
	     * @param {number} x X.
	     * @returns {{left: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSLeft',
	    value: function _getCSSLeft(x) {
	      if (x === undefined || x === null) {
	        return {
	          left: 0
	        };
	      }
	
	      var marginLeft = this.props.marginLeft;
	
	      return {
	        left: marginLeft + x
	      };
	    }
	
	    /**
	     * Get the bottom coordinate of the hint.
	     * When y undefined or null, edge case, pin bottom.
	     * @param {number} y Y.
	     * @returns {{bottom: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSBottom',
	    value: function _getCSSBottom(y) {
	      if (y === undefined || y === null) {
	        return {
	          bottom: 0
	        };
	      }
	
	      var _props2 = this.props,
	          innerHeight = _props2.innerHeight,
	          marginBottom = _props2.marginBottom;
	
	      return {
	        bottom: marginBottom + innerHeight - y
	      };
	    }
	
	    /**
	     * Get the top coordinate of the hint.
	     * When y undefined or null, edge case, pin top.
	     * @param {number} y Y.
	     * @returns {{top: *}} Mixin.
	     * @private
	     */
	
	  }, {
	    key: '_getCSSTop',
	    value: function _getCSSTop(y) {
	      if (y === undefined || y === null) {
	        return {
	          top: 0
	        };
	      }
	
	      var marginTop = this.props.marginTop;
	
	      return {
	        top: marginTop + y
	      };
	    }
	  }, {
	    key: '_mapOrientationToAlign',
	    value: function _mapOrientationToAlign(orientation) {
	      // TODO: print warning that this feature is deprecated and support will be
	      // removed in next major release.
	      switch (orientation) {
	        case ORIENTATION.BOTTOM_LEFT:
	          return {
	            horizontal: ALIGN.LEFT,
	            vertical: ALIGN.BOTTOM
	          };
	        case ORIENTATION.BOTTOM_RIGHT:
	          return {
	            horizontal: ALIGN.RIGHT,
	            vertical: ALIGN.BOTTOM
	          };
	        case ORIENTATION.TOP_LEFT:
	          return {
	            horizontal: ALIGN.LEFT,
	            vertical: ALIGN.TOP
	          };
	        case ORIENTATION.TOP_RIGHT:
	          return {
	            horizontal: ALIGN.RIGHT,
	            vertical: ALIGN.TOP
	          };
	        default:
	          // fall back to horizontalAlign, verticalAlign that are either
	          // provided or defaulted to AUTO.  So, don't change things
	          break;
	      }
	    }
	
	    /**
	     * Obtain align object with horizontal and vertical settings
	     * but convert any AUTO values to the non-auto ALIGN depending on the
	     * values of x and y.
	     * @param {number} x X value.
	     * @param {number} y Y value.
	     * @returns {Object} Align object w/ horizontal, vertical prop strings.
	     * @private
	     */
	
	  }, {
	    key: '_getAlign',
	    value: function _getAlign(x, y) {
	      var _props3 = this.props,
	          innerWidth = _props3.innerWidth,
	          innerHeight = _props3.innerHeight,
	          orientation = _props3.orientation,
	          _props3$align = _props3.align,
	          horizontal = _props3$align.horizontal,
	          vertical = _props3$align.vertical;
	
	      var align = orientation ? this._mapOrientationToAlign(orientation) : { horizontal: horizontal, vertical: vertical };
	      if (horizontal === ALIGN.AUTO) {
	        align.horizontal = x > innerWidth / 2 ? ALIGN.LEFT : ALIGN.RIGHT;
	      }
	      if (vertical === ALIGN.AUTO) {
	        align.vertical = y > innerHeight / 2 ? ALIGN.TOP : ALIGN.BOTTOM;
	      }
	      return align;
	    }
	
	    /**
	     * Get a CSS mixin for a proper positioning of the element.
	     * @param {Object} align object with horizontal and vertical prop strings.
	     * @param {number} x X position.
	     * @param {number} y Y position.
	     * @returns {Object} Object, that may contain `left` or `right, `top` or
	     * `bottom` properties.
	     * @private
	     */
	
	  }, {
	    key: '_getAlignStyle',
	    value: function _getAlignStyle(align, x, y) {
	      return _extends({}, this._getXCSS(align.horizontal, x), this._getYCSS(align.vertical, y));
	    }
	  }, {
	    key: '_getYCSS',
	    value: function _getYCSS(verticalAlign, y) {
	      // obtain yCSS
	      switch (verticalAlign) {
	        case ALIGN.TOP_EDGE:
	          // this pins x to top edge
	          return this._getCSSTop(null);
	        case ALIGN.BOTTOM_EDGE:
	          // this pins x to bottom edge
	          return this._getCSSBottom(null);
	        case ALIGN.BOTTOM:
	          // this places hint text to the bottom of center, so set its top edge
	          return this._getCSSTop(y);
	        case ALIGN.TOP:
	        default:
	          // this places hint text to the top of center, so set its bottom edge
	          // default case should not be possible but if it happens set to BOTTOM
	          return this._getCSSBottom(y);
	      }
	    }
	  }, {
	    key: '_getXCSS',
	    value: function _getXCSS(horizontal, x) {
	      // obtain xCSS
	      switch (horizontal) {
	        case ALIGN.LEFT_EDGE:
	          // this pins x to left edge
	          return this._getCSSLeft(null);
	        case ALIGN.RIGHT_EDGE:
	          // this pins x to left edge
	          return this._getCSSRight(null);
	        case ALIGN.LEFT:
	          // this places hint text to the left of center, so set its right edge
	          return this._getCSSRight(x);
	        case ALIGN.RIGHT:
	        default:
	          // this places hint text to the right of center, so set its left edge
	          // default case should not be possible but if it happens set to RIGHT
	          return this._getCSSLeft(x);
	      }
	    }
	
	    /**
	     * Get the class names from align values.
	     * @param {Object} align object with horizontal and vertical prop strings.
	     * @returns {string} Class names.
	     * @private
	     */
	
	  }, {
	    key: '_getAlignClassNames',
	    value: function _getAlignClassNames(align) {
	      var orientation = this.props.orientation;
	
	      var orientationClass = orientation ? 'rv-hint--orientation-' + orientation : '';
	      return orientationClass + ' rv-hint--horizontalAlign-' + align.horizontal + '\n     rv-hint--verticalAlign-' + align.vertical;
	    }
	
	    /**
	     * Get the position for the hint and the appropriate class name.
	     * @returns {{style: Object, className: string}} Style and className for the
	     * hint.
	     * @private
	     */
	
	  }, {
	    key: '_getPositionInfo',
	    value: function _getPositionInfo() {
	      var _props4 = this.props,
	          value = _props4.value,
	          getAlignStyle = _props4.getAlignStyle;
	
	
	      var x = (0, _scalesUtils.getAttributeFunctor)(this.props, 'x')(value);
	      var y = (0, _scalesUtils.getAttributeFunctor)(this.props, 'y')(value);
	
	      var align = this._getAlign(x, y);
	
	      return {
	        position: getAlignStyle ? getAlignStyle(align, x, y) : this._getAlignStyle(align, x, y),
	        className: this._getAlignClassNames(align)
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          value = _props5.value,
	          format = _props5.format,
	          children = _props5.children,
	          style = _props5.style;
	
	      var _getPositionInfo2 = this._getPositionInfo(),
	          position = _getPositionInfo2.position,
	          className = _getPositionInfo2.className;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-hint ' + className,
	          style: _extends({}, style, position, {
	            position: 'absolute'
	          }) },
	        children ? children : _react2.default.createElement(
	          'div',
	          { className: 'rv-hint__content', style: style.content },
	          format(value).map(function (formattedProp, i) {
	            return _react2.default.createElement(
	              'div',
	              { key: 'rv-hint' + i, style: style.row },
	              _react2.default.createElement(
	                'span',
	                { className: 'rv-hint__title', style: style.title },
	                formattedProp.title
	              ),
	              ': ',
	              _react2.default.createElement(
	                'span',
	                { className: 'rv-hint__value', style: style.value },
	                formattedProp.value
	              )
	            );
	          })
	        )
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    get: function get() {
	      return {
	        marginTop: _propTypes2.default.number,
	        marginLeft: _propTypes2.default.number,
	        innerWidth: _propTypes2.default.number,
	        innerHeight: _propTypes2.default.number,
	        scales: _propTypes2.default.object,
	        value: _propTypes2.default.object,
	        format: _propTypes2.default.func,
	        style: _propTypes2.default.object,
	        align: _propTypes2.default.shape({
	          horizontal: _propTypes2.default.oneOf([ALIGN.AUTO, ALIGN.LEFT, ALIGN.RIGHT, ALIGN.LEFT_EDGE, ALIGN.RIGHT_EDGE]),
	          vertical: _propTypes2.default.oneOf([ALIGN.AUTO, ALIGN.BOTTOM, ALIGN.TOP, ALIGN.BOTTOM_EDGE, ALIGN.TOP_EDGE])
	        }),
	        getAlignStyle: _propTypes2.default.func,
	        orientation: _propTypes2.default.oneOf([ORIENTATION.BOTTOM_LEFT, ORIENTATION.BOTTOM_RIGHT, ORIENTATION.TOP_LEFT, ORIENTATION.TOP_RIGHT])
	      };
	    }
	  }, {
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        format: defaultFormat,
	        align: {
	          horizontal: ALIGN.AUTO,
	          vertical: ALIGN.AUTO
	        },
	        style: {}
	      };
	    }
	  }]);
	
	  return Hint;
	}(_react.PureComponent);
	
	Hint.displayName = 'Hint';
	Hint.ORIENTATION = ORIENTATION;
	Hint.ALIGN = ALIGN;
	
	exports.default = Hint;

/***/ },
/* 2928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axisUtils = __webpack_require__(80);
	
	var _gridLines = __webpack_require__(520);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HORIZONTAL = _axisUtils.DIRECTION.HORIZONTAL;
	
	
	var propTypes = _extends({}, _gridLines2.default.propTypes, {
	  direction: _propTypes2.default.oneOf([HORIZONTAL])
	});
	
	var defaultProps = {
	  direction: HORIZONTAL,
	  attr: 'y'
	};
	
	function HorizontalGridLines(props) {
	  return _react2.default.createElement(_gridLines2.default, props);
	}
	
	HorizontalGridLines.displayName = 'HorizontalGridLines';
	HorizontalGridLines.propTypes = propTypes;
	HorizontalGridLines.defaultProps = defaultProps;
	HorizontalGridLines.requiresSVG = true;
	
	exports.default = HorizontalGridLines;

/***/ },
/* 2929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(107);
	
	var d3Shape = _interopRequireWildcard(_d3Shape);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _theme = __webpack_require__(48);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _reactUtils = __webpack_require__(203);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--line';
	
	var AreaSeries = function (_AbstractSeries) {
	  _inherits(AreaSeries, _AbstractSeries);
	
	  function AreaSeries() {
	    _classCallCheck(this, AreaSeries);
	
	    return _possibleConstructorReturn(this, (AreaSeries.__proto__ || Object.getPrototypeOf(AreaSeries)).apply(this, arguments));
	  }
	
	  _createClass(AreaSeries, [{
	    key: '_renderArea',
	    value: function _renderArea(data, x, y0, y, curve, getNull) {
	      var area = d3Shape.area();
	      if (curve !== null) {
	        if (typeof curve === 'string' && d3Shape[curve]) {
	          area = area.curve(d3Shape[curve]);
	        } else if (typeof curve === 'function') {
	          area = area.curve(curve);
	        }
	      }
	      area = area.defined(getNull);
	      area = area.x(x).y0(y0).y1(y);
	      return area(data);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          curve = _props.curve,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (this.props.nullAccessor) {
	        (0, _reactUtils.warning)('nullAccessor has been renamed to getNull', true);
	      }
	
	      if (!data) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(AreaSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var y0 = this._getAttr0Functor('y');
	      var stroke = this._getAttributeValue('stroke') || this._getAttributeValue('color');
	      var fill = this._getAttributeValue('fill') || this._getAttributeValue('color');
	      var newOpacity = this._getAttributeValue('opacity');
	      var opacity = Number.isFinite(newOpacity) ? newOpacity : _theme.DEFAULT_OPACITY;
	      var getNull = this.props.nullAccessor || this.props.getNull;
	      var d = this._renderArea(data, x, y0, y, curve, getNull);
	
	      return _react2.default.createElement('path', {
	        d: d,
	        className: predefinedClassName + ' ' + className,
	        transform: 'translate(' + marginLeft + ',' + marginTop + ')',
	        onMouseOver: this._seriesMouseOverHandler,
	        onMouseOut: this._seriesMouseOutHandler,
	        onClick: this._seriesClickHandler,
	        onContextMenu: this._seriesRightClickHandler,
	        style: _extends({
	          opacity: opacity,
	          stroke: stroke,
	          fill: fill
	        }, style)
	      });
	    }
	  }]);
	
	  return AreaSeries;
	}(_abstractSeries2.default);
	
	AreaSeries.displayName = 'AreaSeries';
	AreaSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  getNull: _propTypes2.default.func
	});
	AreaSeries.defaultProps = {
	  getNull: function getNull() {
	    return true;
	  }
	};
	
	exports.default = AreaSeries;

/***/ },
/* 2930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Interpolate = __webpack_require__(291);
	
	var _animation = __webpack_require__(38);
	
	var _seriesUtils = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_DRAWS = 30;
	
	/**
	 * Draw loop draws each of the layers until it should draw more
	 * @param {CanvasContext} ctx - the context where the drawing will take place
	 * @param {Number} height - height of the canvas
	 * @param {Number} width - width of the canvas
	 * @param {Array} layers - the layer objects to render
	 */
	function engageDrawLoop(ctx, height, width, layers) {
	  var drawIteration = 0;
	  // using setInterval because request animation frame goes too fast
	  var drawCycle = setInterval(function () {
	    if (!ctx) {
	      clearInterval(drawCycle);
	      return;
	    }
	    drawLayers(ctx, height, width, layers, drawIteration);
	    if (drawIteration > MAX_DRAWS) {
	      clearInterval(drawCycle);
	    }
	    drawIteration += 1;
	  }, 1);
	}
	
	/**
	 * Loops across each of the layers to be drawn and draws them
	 * @param {CanvasContext} ctx - the context where the drawing will take place
	 * @param {Number} height - height of the canvas
	 * @param {Number} width - width of the canvas
	 * @param {Array} layers - the layer objects to render
	 * @param {Number} drawIteration - width of the canvas
	 */
	function drawLayers(ctx, height, width, layers, drawIteration) {
	  ctx.clearRect(0, 0, width, height);
	  layers.forEach(function (layer) {
	    var interpolator = layer.interpolator,
	        newProps = layer.newProps,
	        animation = layer.animation;
	    // return an empty object if dont need to be animating
	
	    var interpolatedProps = animation ? interpolator ? interpolator(drawIteration / MAX_DRAWS) : interpolator : function () {
	      return {};
	    };
	    layer.renderLayer(_extends({}, newProps, interpolatedProps), ctx);
	  });
	}
	
	/**
	 * Build an array of layer of objects the contain the method for drawing each series
	 * as well as an interpolar (specifically a d3-interpolate interpolator)
	 * @param {Object} newChildren the new children to be rendered.
	 * @param {Object} oldChildren the old children to be rendered.
	 * @returns {Array} Object for rendering
	 */
	function buildLayers(newChildren, oldChildren) {
	  return newChildren.map(function (child, index) {
	    var oldProps = oldChildren[index] ? oldChildren[index].props : {};
	    var newProps = child.props;
	
	    var oldAnimatedProps = (0, _animation.extractAnimatedPropValues)(_extends({}, oldProps, {
	      animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS
	    }));
	    var newAnimatedProps = newProps ? (0, _animation.extractAnimatedPropValues)(_extends({}, newProps, {
	      animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS
	    })) : null;
	    var interpolator = (0, _d3Interpolate.interpolate)(oldAnimatedProps, newAnimatedProps);
	
	    return {
	      renderLayer: child.type.renderLayer,
	      newProps: child.props,
	      animation: child.props.animation,
	      interpolator: interpolator
	    };
	  });
	}
	
	var CanvasWrapper = function (_Component) {
	  _inherits(CanvasWrapper, _Component);
	
	  function CanvasWrapper() {
	    _classCallCheck(this, CanvasWrapper);
	
	    return _possibleConstructorReturn(this, (CanvasWrapper.__proto__ || Object.getPrototypeOf(CanvasWrapper)).apply(this, arguments));
	  }
	
	  _createClass(CanvasWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var ctx = this.refs.canvas.getContext('2d');
	      if (!ctx) {
	        return;
	      }
	      var pixelRatio = this.props.pixelRatio;
	
	      if (!ctx) {
	        return;
	      }
	      ctx.scale(pixelRatio, pixelRatio);
	
	      this.drawChildren(this.props, null, ctx);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(nextProps) {
	      this.drawChildren(nextProps, this.props, this.refs.canvas.getContext('2d'));
	    }
	
	    /**
	     * Check that we can and should be animating, then kick off animations as apporpriate
	     * @param {Object} newProps the new props to be interpolated to
	     * @param {Object} oldProps the old props to be interpolated against
	     * @param {DomRef} ctx the canvas context to be drawn on.
	     * @returns {Array} Object for rendering
	     */
	
	  }, {
	    key: 'drawChildren',
	    value: function drawChildren(newProps, oldProps, ctx) {
	      var children = newProps.children,
	          innerHeight = newProps.innerHeight,
	          innerWidth = newProps.innerWidth,
	          marginBottom = newProps.marginBottom,
	          marginLeft = newProps.marginLeft,
	          marginRight = newProps.marginRight,
	          marginTop = newProps.marginTop;
	
	      if (!ctx) {
	        return;
	      }
	
	      var childrenShouldAnimate = children.find(function (child) {
	        return child.props.animation;
	      });
	
	      var height = innerHeight + marginTop + marginBottom;
	      var width = innerWidth + marginLeft + marginRight;
	      var layers = buildLayers(newProps.children, oldProps ? oldProps.children : []);
	      // if we don't need to be animating, dont! cut short
	      if (!childrenShouldAnimate) {
	        drawLayers(ctx, height, width, layers);
	        return;
	      }
	
	      engageDrawLoop(ctx, height, width, layers);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          innerHeight = _props.innerHeight,
	          innerWidth = _props.innerWidth,
	          marginBottom = _props.marginBottom,
	          marginLeft = _props.marginLeft,
	          marginRight = _props.marginRight,
	          marginTop = _props.marginTop,
	          pixelRatio = _props.pixelRatio;
	
	
	      var height = innerHeight + marginTop + marginBottom;
	      var width = innerWidth + marginLeft + marginRight;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { left: 0, top: 0 }, className: 'rv-xy-canvas' },
	        _react2.default.createElement('canvas', {
	          className: 'rv-xy-canvas-element',
	          height: height * pixelRatio,
	          width: width * pixelRatio,
	          style: {
	            height: height + 'px',
	            width: width + 'px'
	          },
	          ref: 'canvas' })
	      );
	    }
	  }], [{
	    key: 'defaultProps',
	    get: function get() {
	      return {
	        pixelRatio: window && window.devicePixelRatio || 1
	      };
	    }
	  }]);
	
	  return CanvasWrapper;
	}(_react.Component);
	
	CanvasWrapper.displayName = 'CanvasWrapper';
	CanvasWrapper.propTypes = {
	  marginBottom: _propTypes2.default.number.isRequired,
	  marginLeft: _propTypes2.default.number.isRequired,
	  marginRight: _propTypes2.default.number.isRequired,
	  marginTop: _propTypes2.default.number.isRequired,
	  innerHeight: _propTypes2.default.number.isRequired,
	  innerWidth: _propTypes2.default.number.isRequired,
	  pixelRatio: _propTypes2.default.number.isRequired
	};
	
	exports.default = CanvasWrapper;

/***/ },
/* 2931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Contour = __webpack_require__(1876);
	
	var _d3Geo = __webpack_require__(1877);
	
	var _d3Scale = __webpack_require__(180);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _theme = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--contour';
	
	function getDomain(data) {
	  return data.reduce(function (acc, row) {
	    return {
	      min: Math.min(acc.min, row.value),
	      max: Math.max(acc.max, row.value)
	    };
	  }, { min: Infinity, max: -Infinity });
	}
	
	var ContourSeries = function (_AbstractSeries) {
	  _inherits(ContourSeries, _AbstractSeries);
	
	  function ContourSeries() {
	    _classCallCheck(this, ContourSeries);
	
	    return _possibleConstructorReturn(this, (ContourSeries.__proto__ || Object.getPrototypeOf(ContourSeries)).apply(this, arguments));
	  }
	
	  _createClass(ContourSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          bandwidth = _props.bandwidth,
	          className = _props.className,
	          colorRange = _props.colorRange,
	          data = _props.data,
	          innerHeight = _props.innerHeight,
	          innerWidth = _props.innerWidth,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (!data || !innerWidth || !innerHeight) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(ContourSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	
	      var contouredData = (0, _d3Contour.contourDensity)().x(function (d) {
	        return x(d);
	      }).y(function (d) {
	        return y(d);
	      }).size([innerWidth, innerHeight]).bandwidth(bandwidth)(data);
	
	      var geo = (0, _d3Geo.geoPath)();
	
	      var _getDomain = getDomain(contouredData),
	          min = _getDomain.min,
	          max = _getDomain.max;
	
	      var colorScale = (0, _d3Scale.scaleLinear)().domain([min, max]).range(colorRange || _theme.CONTINUOUS_COLOR_RANGE);
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        contouredData.map(function (polygon, index) {
	          return _react2.default.createElement('path', {
	            className: 'rv-xy-plot__series--contour-line',
	            key: 'rv-xy-plot__series--contour-line-' + index,
	            d: geo(polygon),
	            style: _extends({
	              fill: colorScale(polygon.value)
	            }, style)
	          });
	        })
	      );
	    }
	  }]);
	
	  return ContourSeries;
	}(_abstractSeries2.default);
	
	ContourSeries.propTypes = {
	  animation: _propTypes2.default.bool,
	  bandwidth: _propTypes2.default.number,
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired
	  })).isRequired,
	  marginLeft: _propTypes2.default.number,
	  marginTop: _propTypes2.default.number,
	  style: _propTypes2.default.object
	};
	
	ContourSeries.defaultProps = {
	  bandwidth: 40,
	  style: {}
	};
	
	exports.default = ContourSeries;

/***/ },
/* 2932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--custom-svg-wrapper';
	
	var DEFAULT_STYLE = {
	  stroke: 'blue',
	  fill: 'blue'
	};
	
	function predefinedComponents(type) {
	  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	  var style = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_STYLE;
	
	  switch (type) {
	    case 'diamond':
	      return _react2.default.createElement('polygon', {
	        style: style,
	        points: '0 0 ' + size / 2 + ' ' + size / 2 + ' 0 ' + size + ' ' + -size / 2 + ' ' + size / 2 + ' 0 0' });
	    case 'star':
	      var starPoints = [].concat(_toConsumableArray(new Array(5))).map(function (c, index) {
	        var angle = index / 5 * Math.PI * 2;
	        var innerAngle = angle + Math.PI / 10;
	        var outerAngle = angle - Math.PI / 10;
	        // ratio of inner polygon to outer polgyon
	        var innerRadius = size / 2.61;
	        return '\n        ' + Math.cos(outerAngle) * size + ' ' + Math.sin(outerAngle) * size + '\n        ' + Math.cos(innerAngle) * innerRadius + ' ' + Math.sin(innerAngle) * innerRadius + '\n      ';
	      }).join(' ');
	      return _react2.default.createElement('polygon', {
	        points: starPoints,
	        x: '0', y: '0', height: size, width: size, style: style });
	    case 'square':
	      return _react2.default.createElement('rect', { x: '' + -size / 2, y: '' + -size / 2, height: size, width: size, style: style });
	    default:
	    case 'circle':
	      return _react2.default.createElement('circle', { cx: '0', cy: '0', r: size / 2, style: style });
	  }
	}
	
	function getInnerComponent(_ref) {
	  var customComponent = _ref.customComponent,
	      defaultType = _ref.defaultType,
	      positionInPixels = _ref.positionInPixels,
	      positionFunctions = _ref.positionFunctions,
	      style = _ref.style;
	  var size = customComponent.size;
	
	  var aggStyle = _extends({}, style, customComponent.style || {});
	  var innerComponent = customComponent.customComponent;
	  if (!innerComponent && typeof defaultType === 'string') {
	    return predefinedComponents(defaultType, size, aggStyle);
	  }
	  // if default component is a function
	  if (!innerComponent) {
	    return defaultType(customComponent, positionInPixels, aggStyle);
	  }
	  if (typeof innerComponent === 'string') {
	    return predefinedComponents(innerComponent || defaultType, size, aggStyle);
	  }
	  // if inner component is a function
	  return innerComponent(customComponent, positionInPixels, aggStyle);
	}
	
	var CustomSVGSeries = function (_AbstractSeries) {
	  _inherits(CustomSVGSeries, _AbstractSeries);
	
	  function CustomSVGSeries() {
	    _classCallCheck(this, CustomSVGSeries);
	
	    return _possibleConstructorReturn(this, (CustomSVGSeries.__proto__ || Object.getPrototypeOf(CustomSVGSeries)).apply(this, arguments));
	  }
	
	  _createClass(CustomSVGSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          customComponent = _props.customComponent,
	          data = _props.data,
	          innerHeight = _props.innerHeight,
	          innerWidth = _props.innerWidth,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	
	      if (!data || !innerWidth || !innerHeight) {
	        return null;
	      }
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(CustomSVGSeries, _extends({}, this.props, { animation: false }))
	        );
	      }
	
	      var x = this._getAttributeFunctor('x');
	      var y = this._getAttributeFunctor('y');
	      var contents = data.map(function (seriesComponent, index) {
	        var positionInPixels = {
	          x: x({ x: seriesComponent.x }),
	          y: y({ y: seriesComponent.y })
	        };
	        var innerComponent = getInnerComponent({
	          customComponent: seriesComponent,
	          positionInPixels: positionInPixels,
	          defaultType: customComponent,
	          positionFunctions: { x: x, y: y },
	          style: style
	        });
	        return _react2.default.createElement(
	          'g',
	          {
	            className: 'rv-xy-plot__series--custom-svg',
	            key: 'rv-xy-plot__series--custom-svg-' + index,
	            transform: 'translate(' + positionInPixels.x + ',' + positionInPixels.y + ')'
	          },
	          innerComponent
	        );
	      });
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        contents
	      );
	    }
	  }]);
	
	  return CustomSVGSeries;
	}(_abstractSeries2.default);
	
	CustomSVGSeries.propTypes = {
	  animation: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  customComponent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    x: _propTypes2.default.number.isRequired,
	    y: _propTypes2.default.number.isRequired
	  })).isRequired,
	  marginLeft: _propTypes2.default.number,
	  marginTop: _propTypes2.default.number,
	  style: _propTypes2.default.object
	};
	
	CustomSVGSeries.defaultProps = {
	  animation: false,
	  customComponent: 'circle',
	  style: {}
	};
	
	exports.default = CustomSVGSeries;

/***/ },
/* 2933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--heatmap';
	
	var HeatmapSeries = function (_AbstractSeries) {
	  _inherits(HeatmapSeries, _AbstractSeries);
	
	  function HeatmapSeries() {
	    _classCallCheck(this, HeatmapSeries);
	
	    return _possibleConstructorReturn(this, (HeatmapSeries.__proto__ || Object.getPrototypeOf(HeatmapSeries)).apply(this, arguments));
	  }
	
	  _createClass(HeatmapSeries, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          style = _props.style;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(HeatmapSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var xFunctor = this._getAttributeFunctor('x');
	      var yFunctor = this._getAttributeFunctor('y');
	      var opacityFunctor = this._getAttributeFunctor('opacity');
	      var fillFunctor = this._getAttributeFunctor('fill') || this._getAttributeFunctor('color');
	      var strokeFunctor = this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color');
	      var xDistance = this._getScaleDistance('x');
	      var yDistance = this._getScaleDistance('y');
	      return _react2.default.createElement(
	        'g',
	        {
	          className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(function (d, i) {
	          var attrs = {
	            style: _extends({
	              stroke: strokeFunctor && strokeFunctor(d),
	              fill: fillFunctor && fillFunctor(d),
	              opacity: opacityFunctor && opacityFunctor(d)
	            }, style),
	            x: xFunctor(d) - xDistance / 2,
	            y: yFunctor(d) - yDistance / 2,
	            width: xDistance,
	            height: yDistance,
	            key: i,
	            onClick: function onClick(e) {
	              return _this2._valueClickHandler(d, e);
	            },
	            onContextMenu: function onContextMenu(e) {
	              return _this2._valueRightClickHandler(d, e);
	            },
	            onMouseOver: function onMouseOver(e) {
	              return _this2._valueMouseOverHandler(d, e);
	            },
	            onMouseOut: function onMouseOut(e) {
	              return _this2._valueMouseOutHandler(d, e);
	            }
	          };
	          return _react2.default.createElement('rect', attrs);
	        })
	      );
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x' || attr === 'y';
	      return { isDomainAdjustmentNeeded: isDomainAdjustmentNeeded };
	    }
	  }]);
	
	  return HeatmapSeries;
	}(_abstractSeries2.default);
	
	HeatmapSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	HeatmapSeries.displayName = 'HeatmapSeries';
	
	exports.default = HeatmapSeries;

/***/ },
/* 2934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeriesCanvas = __webpack_require__(1314);
	
	var _barSeriesCanvas2 = _interopRequireDefault(_barSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);
	
	  function HorizontalBarSeriesCanvas() {
	    _classCallCheck(this, HorizontalBarSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _barSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalBarSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
	HorizontalBarSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalBarSeriesCanvas;

/***/ },
/* 2935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeries = __webpack_require__(1315);
	
	var _barSeries2 = _interopRequireDefault(_barSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeries = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeries, _AbstractSeries);
	
	  function HorizontalBarSeries() {
	    _classCallCheck(this, HorizontalBarSeries);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeries.__proto__ || Object.getPrototypeOf(HorizontalBarSeries)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_barSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'y';
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return HorizontalBarSeries;
	}(_abstractSeries2.default);
	
	HorizontalBarSeries.displayName = 'HorizontalBarSeries';
	
	exports.default = HorizontalBarSeries;

/***/ },
/* 2936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeriesCanvas = __webpack_require__(525);
	
	var _rectSeriesCanvas2 = _interopRequireDefault(_rectSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);
	
	  function HorizontalRectSeriesCanvas() {
	    _classCallCheck(this, HorizontalRectSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = false;
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _rectSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalRectSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
	HorizontalRectSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalRectSeriesCanvas;

/***/ },
/* 2937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeries = __webpack_require__(526);
	
	var _rectSeries2 = _interopRequireDefault(_rectSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeries = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeries, _AbstractSeries);
	
	  function HorizontalRectSeries() {
	    _classCallCheck(this, HorizontalRectSeries);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeries.__proto__ || Object.getPrototypeOf(HorizontalRectSeries)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_rectSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'y',
	        valuePosAttr: 'x',
	        lineSizeAttr: 'height',
	        valueSizeAttr: 'width'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = false;
	      var zeroBaseValue = attr === 'x';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return HorizontalRectSeries;
	}(_abstractSeries2.default);
	
	HorizontalRectSeries.displayName = 'HorizontalRectSeries';
	
	exports.default = HorizontalRectSeries;

/***/ },
/* 2938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _markSeriesCanvas = __webpack_require__(1318);
	
	var _markSeriesCanvas2 = _interopRequireDefault(_markSeriesCanvas);
	
	var _lineSeriesCanvas = __webpack_require__(1317);
	
	var _lineSeriesCanvas2 = _interopRequireDefault(_lineSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var LineMarkSeriesCanvas = function (_AbstractSeries) {
	  _inherits(LineMarkSeriesCanvas, _AbstractSeries);
	
	  function LineMarkSeriesCanvas() {
	    _classCallCheck(this, LineMarkSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (LineMarkSeriesCanvas.__proto__ || Object.getPrototypeOf(LineMarkSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(LineMarkSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _lineSeriesCanvas2.default.renderLayer(props, ctx);
	      _markSeriesCanvas2.default.renderLayer(props, ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return LineMarkSeriesCanvas;
	}(_abstractSeries2.default);
	
	LineMarkSeriesCanvas.displayName = 'LineMarkSeriesCanvas';
	LineMarkSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = LineMarkSeriesCanvas;

/***/ },
/* 2939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeriesCanvas = __webpack_require__(1314);
	
	var _barSeriesCanvas2 = _interopRequireDefault(_barSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalBarSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalBarSeriesCanvas, _AbstractSeries);
	
	  function HorizontalBarSeriesCanvas() {
	    _classCallCheck(this, HorizontalBarSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalBarSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalBarSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalBarSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _barSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalBarSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalBarSeriesCanvas.displayName = 'HorizontalBarSeriesCanvas';
	HorizontalBarSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalBarSeriesCanvas;

/***/ },
/* 2940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _barSeries = __webpack_require__(1315);
	
	var _barSeries2 = _interopRequireDefault(_barSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var VerticalBarSeries = function (_AbstractSeries) {
	  _inherits(VerticalBarSeries, _AbstractSeries);
	
	  function VerticalBarSeries() {
	    _classCallCheck(this, VerticalBarSeries);
	
	    return _possibleConstructorReturn(this, (VerticalBarSeries.__proto__ || Object.getPrototypeOf(VerticalBarSeries)).apply(this, arguments));
	  }
	
	  _createClass(VerticalBarSeries, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_barSeries2.default, _extends({}, this.props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }));
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = attr === 'x';
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }]);
	
	  return VerticalBarSeries;
	}(_abstractSeries2.default);
	
	VerticalBarSeries.displayName = 'VerticalBarSeries';
	
	exports.default = VerticalBarSeries;

/***/ },
/* 2941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	var _rectSeriesCanvas = __webpack_require__(525);
	
	var _rectSeriesCanvas2 = _interopRequireDefault(_rectSeriesCanvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var HorizontalRectSeriesCanvas = function (_AbstractSeries) {
	  _inherits(HorizontalRectSeriesCanvas, _AbstractSeries);
	
	  function HorizontalRectSeriesCanvas() {
	    _classCallCheck(this, HorizontalRectSeriesCanvas);
	
	    return _possibleConstructorReturn(this, (HorizontalRectSeriesCanvas.__proto__ || Object.getPrototypeOf(HorizontalRectSeriesCanvas)).apply(this, arguments));
	  }
	
	  _createClass(HorizontalRectSeriesCanvas, [{
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }], [{
	    key: 'getParentConfig',
	    value: function getParentConfig(attr) {
	      var isDomainAdjustmentNeeded = false;
	      var zeroBaseValue = attr === 'y';
	      return {
	        isDomainAdjustmentNeeded: isDomainAdjustmentNeeded,
	        zeroBaseValue: zeroBaseValue
	      };
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer(props, ctx) {
	      _rectSeriesCanvas2.default.renderLayer(_extends({}, props, {
	        linePosAttr: 'x',
	        valuePosAttr: 'y',
	        lineSizeAttr: 'width',
	        valueSizeAttr: 'height'
	      }), ctx);
	    }
	  }, {
	    key: 'requiresSVG',
	    get: function get() {
	      return false;
	    }
	  }, {
	    key: 'isCanvas',
	    get: function get() {
	      return true;
	    }
	  }]);
	
	  return HorizontalRectSeriesCanvas;
	}(_abstractSeries2.default);
	
	HorizontalRectSeriesCanvas.displayName = 'HorizontalRectSeriesCanvas';
	HorizontalRectSeriesCanvas.propTypes = _extends({}, _abstractSeries2.default.propTypes);
	
	exports.default = HorizontalRectSeriesCanvas;

/***/ },
/* 2942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _theme = __webpack_require__(48);
	
	var _abstractSeries = __webpack_require__(27);
	
	var _abstractSeries2 = _interopRequireDefault(_abstractSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-xy-plot__series rv-xy-plot__series--whisker';
	var DEFAULT_STROKE_WIDTH = 1;
	var DEFAULT_CROSS_BAR_WIDTH = 6;
	
	/**
	 * Render whisker lines for a data point.
	 * @param {Object} whiskerMarkProps All the properties of the whisker mark.
	 * @private
	 */
	var renderWhiskerMark = function renderWhiskerMark(whiskerMarkProps) {
	  return function (d, i) {
	    var crossBarWidth = whiskerMarkProps.crossBarWidth,
	        opacityFunctor = whiskerMarkProps.opacityFunctor,
	        sizeFunctor = whiskerMarkProps.sizeFunctor,
	        strokeFunctor = whiskerMarkProps.strokeFunctor,
	        strokeWidth = whiskerMarkProps.strokeWidth,
	        style = whiskerMarkProps.style,
	        valueClickHandler = whiskerMarkProps.valueClickHandler,
	        valueMouseOutHandler = whiskerMarkProps.valueMouseOutHandler,
	        valueMouseOverHandler = whiskerMarkProps.valueMouseOverHandler,
	        valueRightClickHandler = whiskerMarkProps.valueRightClickHandler,
	        xFunctor = whiskerMarkProps.xFunctor,
	        yFunctor = whiskerMarkProps.yFunctor;
	
	
	    var r = sizeFunctor ? sizeFunctor(d) : 0;
	    var cx = xFunctor(d);
	    var cy = yFunctor(d);
	    var positiveXVariance = xFunctor({ x: d.x + d.xVariance / 2 });
	    var negativeXVariance = xFunctor({ x: d.x - d.xVariance / 2 });
	    var positiveYVariance = yFunctor({ y: d.y + d.yVariance / 2 });
	    var negativeYVariance = yFunctor({ y: d.y - d.yVariance / 2 });
	    /**
	     * Determine whether on not we should draw whiskers in each direction.
	     * We need to see an actual variance value, and also have that value extend past the
	     * radius "buffer" region in which we won't be drawing (if any).
	     */
	    var hasXWhiskers = positiveXVariance && cx + r < positiveXVariance;
	    var hasYWhiskers = positiveYVariance && cy - r > positiveYVariance;
	    if (!hasXWhiskers && !hasYWhiskers) {
	      return null;
	    }
	
	    var styleAttr = _extends({
	      opacity: opacityFunctor ? opacityFunctor(d) : _theme.DEFAULT_OPACITY,
	      stroke: strokeFunctor && strokeFunctor(d),
	      strokeWidth: strokeWidth || DEFAULT_STROKE_WIDTH
	    }, style);
	    var crossBarExtension = crossBarWidth / 2;
	
	    var rightLineAttrs = {
	      x1: cx + r,
	      y1: cy,
	      x2: positiveXVariance,
	      y2: cy,
	      style: styleAttr
	    };
	    var leftLineAttrs = {
	      x1: cx - r,
	      y1: cy,
	      x2: negativeXVariance,
	      y2: cy,
	      style: styleAttr
	    };
	    var rightCrossBarAttrs = {
	      x1: positiveXVariance,
	      y1: cy - crossBarExtension,
	      x2: positiveXVariance,
	      y2: cy + crossBarExtension,
	      style: styleAttr
	    };
	    var leftCrossBarAttrs = {
	      x1: negativeXVariance,
	      y1: cy - crossBarExtension,
	      x2: negativeXVariance,
	      y2: cy + crossBarExtension,
	      style: styleAttr
	    };
	
	    var upperLineAttrs = {
	      x1: cx,
	      y1: cy - r,
	      x2: cx,
	      y2: positiveYVariance,
	      style: styleAttr
	    };
	    var lowerLineAttrs = {
	      x1: cx,
	      y1: cy + r,
	      x2: cx,
	      y2: negativeYVariance,
	      style: styleAttr
	    };
	    var upperCrossBarAttrs = {
	      x1: cx - crossBarExtension,
	      y1: positiveYVariance,
	      x2: cx + crossBarExtension,
	      y2: positiveYVariance,
	      style: styleAttr
	    };
	    var lowerCrossBarAttrs = {
	      x1: cx - crossBarExtension,
	      y1: negativeYVariance,
	      x2: cx + crossBarExtension,
	      y2: negativeYVariance,
	      style: styleAttr
	    };
	
	    return _react2.default.createElement(
	      'g',
	      { className: 'mark-whiskers', key: i,
	        onClick: function onClick(e) {
	          return valueClickHandler(d, e);
	        },
	        onContextMenu: function onContextMenu(e) {
	          return valueRightClickHandler(d, e);
	        },
	        onMouseOver: function onMouseOver(e) {
	          return valueMouseOverHandler(d, e);
	        },
	        onMouseOut: function onMouseOut(e) {
	          return valueMouseOutHandler(d, e);
	        }
	      },
	      hasXWhiskers ? _react2.default.createElement(
	        'g',
	        { className: 'x-whiskers' },
	        _react2.default.createElement('line', rightLineAttrs),
	        _react2.default.createElement('line', leftLineAttrs),
	        _react2.default.createElement('line', rightCrossBarAttrs),
	        _react2.default.createElement('line', leftCrossBarAttrs)
	      ) : null,
	      hasYWhiskers ? _react2.default.createElement(
	        'g',
	        { className: 'y-whiskers' },
	        _react2.default.createElement('line', upperLineAttrs),
	        _react2.default.createElement('line', lowerLineAttrs),
	        _react2.default.createElement('line', upperCrossBarAttrs),
	        _react2.default.createElement('line', lowerCrossBarAttrs)
	      ) : null
	    );
	  };
	};
	
	var WhiskerSeries = function (_AbstractSeries) {
	  _inherits(WhiskerSeries, _AbstractSeries);
	
	  function WhiskerSeries() {
	    _classCallCheck(this, WhiskerSeries);
	
	    return _possibleConstructorReturn(this, (WhiskerSeries.__proto__ || Object.getPrototypeOf(WhiskerSeries)).apply(this, arguments));
	  }
	
	  _createClass(WhiskerSeries, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          crossBarWidth = _props.crossBarWidth,
	          data = _props.data,
	          marginLeft = _props.marginLeft,
	          marginTop = _props.marginTop,
	          strokeWidth = _props.strokeWidth,
	          style = _props.style;
	
	      if (!data) {
	        return null;
	      }
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(WhiskerSeries, _extends({}, this.props, { animation: null }))
	        );
	      }
	
	      var whiskerMarkProps = {
	        crossBarWidth: crossBarWidth,
	        opacityFunctor: this._getAttributeFunctor('opacity'),
	        sizeFunctor: this._getAttributeFunctor('size'),
	        strokeFunctor: this._getAttributeFunctor('stroke') || this._getAttributeFunctor('color'),
	        strokeWidth: strokeWidth,
	        style: style,
	        xFunctor: this._getAttributeFunctor('x'),
	        yFunctor: this._getAttributeFunctor('y'),
	        valueClickHandler: this._valueClickHandler,
	        valueRightClickHandler: this._valueRightClickHandler,
	        valueMouseOverHandler: this._valueMouseOverHandler,
	        valueMouseOutHandler: this._valueMouseOutHandler
	      };
	
	      return _react2.default.createElement(
	        'g',
	        { className: predefinedClassName + ' ' + className,
	          ref: 'container',
	          transform: 'translate(' + marginLeft + ',' + marginTop + ')' },
	        data.map(renderWhiskerMark(whiskerMarkProps))
	      );
	    }
	  }]);
	
	  return WhiskerSeries;
	}(_abstractSeries2.default);
	
	WhiskerSeries.displayName = 'WhiskerSeries';
	WhiskerSeries.propTypes = _extends({}, _abstractSeries2.default.propTypes, {
	  strokeWidth: _propTypes2.default.number
	});
	WhiskerSeries.defaultProps = {
	  crossBarWidth: DEFAULT_CROSS_BAR_WIDTH,
	  size: 0,
	  strokeWidth: DEFAULT_STROKE_WIDTH
	};
	exports.default = WhiskerSeries;

/***/ },
/* 2943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gridLines = __webpack_require__(520);
	
	var _gridLines2 = _interopRequireDefault(_gridLines);
	
	var _axisUtils = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VERTICAL = _axisUtils.DIRECTION.VERTICAL;
	
	
	var propTypes = _extends({}, _gridLines2.default.propTypes, {
	  direction: _propTypes2.default.oneOf([VERTICAL])
	});
	
	var defaultProps = {
	  direction: VERTICAL,
	  attr: 'x'
	};
	
	function VerticalGridLines(props) {
	  return _react2.default.createElement(_gridLines2.default, props);
	}
	
	VerticalGridLines.displayName = 'VerticalGridLines';
	VerticalGridLines.propTypes = propTypes;
	VerticalGridLines.defaultProps = defaultProps;
	VerticalGridLines.requiresSVG = true;
	
	exports.default = VerticalGridLines;

/***/ },
/* 2944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Scale = __webpack_require__(180);
	
	var _d3Format = __webpack_require__(223);
	
	var _animation = __webpack_require__(38);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _theme = __webpack_require__(48);
	
	var _chartUtils = __webpack_require__(162);
	
	var _polygonSeries = __webpack_require__(524);
	
	var _polygonSeries2 = _interopRequireDefault(_polygonSeries);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _decorativeAxis = __webpack_require__(519);
	
	var _decorativeAxis2 = _interopRequireDefault(_decorativeAxis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-radar-chart';
	var DEFAULT_FORMAT = (0, _d3Format.format)('.2r');
	/**
	 * Generate axes for each of the domains
	 * @param {Object} props
	 - props.animation {Boolean}
	 - props.domains {Array} array of object specifying the way each axis is to be plotted
	 - props.style {object} style object for the whole chart
	 - props.tickFormat {Function} formatting function for axes
	 - props.startingAngle {number} the initial angle offset
	 * @return {Array} the plotted axis components
	 */
	function getAxes(props) {
	  var animation = props.animation,
	      domains = props.domains,
	      startingAngle = props.startingAngle,
	      style = props.style,
	      tickFormat = props.tickFormat,
	      hideInnerMostValues = props.hideInnerMostValues;
	
	  return domains.map(function (domain, index) {
	    var angle = index / domains.length * Math.PI * 2 + startingAngle;
	    var sortedDomain = domain.domain;
	
	    var domainTickFormat = function domainTickFormat(t) {
	      if (hideInnerMostValues && t === sortedDomain[0]) {
	        return '';
	      }
	      return domain.tickFormat ? domain.tickFormat(t) : tickFormat(t);
	    };
	
	    return _react2.default.createElement(_decorativeAxis2.default, {
	      animation: animation,
	      key: index + '-axis',
	      axisStart: { x: 0, y: 0 },
	      axisEnd: { x: Math.cos(angle), y: Math.sin(angle) },
	      axisDomain: sortedDomain,
	      numberOfTicks: 5,
	      tickValue: domainTickFormat,
	      style: style.axes
	    });
	  });
	}
	
	/**
	 * Generate labels for the ends of the axes
	 * @param {Object} props
	 - props.domains {Array} array of object specifying the way each axis is to be plotted
	  - props.startingAngle {number} the initial angle offset
	 - props.style {object} style object for just the labels
	 * @return {Array} the prepped data for the labelSeries
	 */
	function getLabels(props) {
	  var domains = props.domains,
	      startingAngle = props.startingAngle,
	      style = props.style;
	
	  return domains.map(function (_ref, index) {
	    var name = _ref.name;
	
	    var angle = index / domains.length * Math.PI * 2 + startingAngle;
	    var radius = 1.2;
	    return {
	      x: radius * Math.cos(angle),
	      y: radius * Math.sin(angle),
	      label: name,
	      style: style
	    };
	  });
	}
	
	/**
	 * Generate the actual polygons to be plotted
	 * @param {Object} props
	 - props.animation {Boolean}
	 - props.data {Array} array of object specifying what values are to be plotted
	 - props.domains {Array} array of object specifying the way each axis is to be plotted
	 - props.startingAngle {number} the initial angle offset
	 - props.style {object} style object for the whole chart
	 * @return {Array} the plotted axis components
	 */
	function getPolygons(props) {
	  var animation = props.animation,
	      colorRange = props.colorRange,
	      domains = props.domains,
	      data = props.data,
	      style = props.style,
	      startingAngle = props.startingAngle;
	
	  var scales = domains.reduce(function (acc, _ref2) {
	    var domain = _ref2.domain,
	        name = _ref2.name;
	
	    acc[name] = (0, _d3Scale.scaleLinear)().domain(domain).range([0, 1]);
	    return acc;
	  }, {});
	
	  return data.map(function (row, rowIndex) {
	    var mappedData = domains.map(function (_ref3, index) {
	      var name = _ref3.name,
	          getValue = _ref3.getValue;
	
	      var dataPoint = getValue ? getValue(row) : row[name];
	      // error handling if point doesn't exist
	      var angle = index / domains.length * Math.PI * 2 + startingAngle;
	      // dont let the radius become negative
	      var radius = Math.max(scales[name](dataPoint), 0);
	      return { x: radius * Math.cos(angle), y: radius * Math.sin(angle) };
	    });
	
	    return _react2.default.createElement(_polygonSeries2.default, {
	      animation: animation,
	      className: predefinedClassName + '-polygon',
	      key: rowIndex + '-polygon',
	      data: mappedData,
	      style: _extends({
	        stroke: row.color || row.stroke || colorRange[rowIndex % colorRange.length],
	        fill: row.color || row.fill || colorRange[rowIndex % colorRange.length]
	      }, style.polygons)
	    });
	  });
	}
	
	var RadarChart = function (_Component) {
	  _inherits(RadarChart, _Component);
	
	  function RadarChart() {
	    _classCallCheck(this, RadarChart);
	
	    return _possibleConstructorReturn(this, (RadarChart.__proto__ || Object.getPrototypeOf(RadarChart)).apply(this, arguments));
	  }
	
	  _createClass(RadarChart, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          colorRange = _props.colorRange,
	          data = _props.data,
	          domains = _props.domains,
	          height = _props.height,
	          hideInnerMostValues = _props.hideInnerMostValues,
	          margin = _props.margin,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          startingAngle = _props.startingAngle,
	          style = _props.style,
	          tickFormat = _props.tickFormat,
	          width = _props.width;
	
	
	      var axes = getAxes({
	        domains: domains,
	        animation: animation,
	        hideInnerMostValues: hideInnerMostValues,
	        startingAngle: startingAngle,
	        style: style,
	        tickFormat: tickFormat
	      });
	
	      var polygons = getPolygons({
	        animation: animation,
	        colorRange: colorRange,
	        domains: domains,
	        data: data,
	        startingAngle: startingAngle,
	        style: style
	      });
	      var labelSeries = _react2.default.createElement(_labelSeries2.default, {
	        animation: animation,
	        key: className,
	        className: predefinedClassName + '-label',
	        data: getLabels({ domains: domains, style: style.labels, startingAngle: startingAngle }) });
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          width: width,
	          margin: margin,
	          dontCheckIfEmpty: true,
	          className: className + ' ' + predefinedClassName,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          xDomain: [-1, 1],
	          yDomain: [-1, 1] },
	        children,
	        axes.concat(polygons).concat(labelSeries)
	      );
	    }
	  }]);
	
	  return RadarChart;
	}(_react.Component);
	
	RadarChart.displayName = 'RadarChart';
	RadarChart.propTypes = {
	  animation: _animation.AnimationPropType,
	  className: _propTypes2.default.string,
	  colorType: _propTypes2.default.string,
	  colorRange: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  domains: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    domain: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
	    tickFormat: _propTypes2.default.func
	  })).isRequired,
	  height: _propTypes2.default.number.isRequired,
	  hideInnerMostValues: _propTypes2.default.bool,
	  margin: _chartUtils.MarginPropType,
	  startingAngle: _propTypes2.default.number,
	  style: _propTypes2.default.shape({
	    axes: _propTypes2.default.object,
	    labels: _propTypes2.default.object,
	    polygons: _propTypes2.default.object
	  }),
	  tickFormat: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired
	};
	RadarChart.defaultProps = {
	  className: '',
	  colorType: 'category',
	  colorRange: _theme.DISCRETE_COLOR_RANGE,
	  hideInnerMostValues: true,
	  startingAngle: Math.PI / 2,
	  style: {
	    axes: {
	      line: {},
	      ticks: {},
	      text: {}
	    },
	    labels: {
	      fontSize: 10,
	      textAnchor: 'middle'
	    },
	    polygons: {
	      strokeWidth: 0.5,
	      strokeOpacity: 1,
	      fillOpacity: 0.1
	    }
	  },
	  tickFormat: DEFAULT_FORMAT
	};
	
	exports.default = RadarChart;

/***/ },
/* 2945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Shape = __webpack_require__(107);
	
	var _animation = __webpack_require__(38);
	
	var _arcSeries = __webpack_require__(521);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _theme = __webpack_require__(48);
	
	var _chartUtils = __webpack_require__(162);
	
	var _seriesUtils = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-radial-chart';
	
	var DEFAULT_RADIUS_MARGIN = 15;
	
	/**
	 * Create the list of wedges to render.
	 * @param {Object} props
	   props.data {Object} - tree structured data (each node has a name anc an array of children)
	 * @returns {Array} Array of nodes.
	 */
	function getWedgesToRender(_ref) {
	  var data = _ref.data,
	      getAngle = _ref.getAngle;
	
	  var pie = (0, _d3Shape.pie)().sort(null).value(getAngle);
	  var pieData = pie(data).reverse();
	  return pieData.map(function (row, index) {
	    return _extends({}, row.data, {
	      angle0: row.startAngle,
	      angle: row.endAngle,
	      radius0: row.data.innerRadius || 0,
	      radius: row.data.radius || 1,
	      color: row.data.color || index
	    });
	  });
	}
	
	function generateLabels(mappedData, accessors) {
	  var getLabel = accessors.getLabel,
	      getSubLabel = accessors.getSubLabel;
	
	  return mappedData.reduce(function (res, row) {
	    var angle = row.angle,
	        angle0 = row.angle0,
	        radius = row.radius;
	
	    var centeredAngle = (angle + angle0) / 2;
	
	    // unfortunate, but true fact: d3 starts its radians at 12 oclock rather than 3
	    // and move clockwise rather than counter clockwise. why why why!
	    var updatedAngle = -1 * centeredAngle + Math.PI / 2;
	    var newLabels = [];
	    if (getLabel(row)) {
	      newLabels.push({
	        angle: updatedAngle,
	        radius: radius * 1.1,
	        label: getLabel(row),
	        style: { fontSize: '12px' }
	      });
	    }
	
	    if (getSubLabel(row)) {
	      newLabels.push({
	        angle: updatedAngle,
	        radius: radius * 1.1,
	        label: getSubLabel(row),
	        yOffset: 12,
	        style: { fontSize: '10px' }
	      });
	    }
	    return res.concat(newLabels);
	  }, []);
	  // could add force direction here to make sure the labels dont overlap
	}
	
	/**
	 * Get the max radius so the chart can extend to the margin.
	 * @param  {Number} width - container width
	 * @param  {Number} height - container height
	 * @return {Number} radius
	 */
	function getMaxRadius(width, height) {
	  return Math.min(width, height) / 2 - DEFAULT_RADIUS_MARGIN;
	}
	
	var RadialChart = function (_Component) {
	  _inherits(RadialChart, _Component);
	
	  function RadialChart() {
	    _classCallCheck(this, RadialChart);
	
	    return _possibleConstructorReturn(this, (RadialChart.__proto__ || Object.getPrototypeOf(RadialChart)).apply(this, arguments));
	  }
	
	  _createClass(RadialChart, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          data = _props.data,
	          height = _props.height,
	          hideRootNode = _props.hideRootNode,
	          width = _props.width,
	          colorType = _props.colorType,
	          radius = _props.radius,
	          innerRadius = _props.innerRadius,
	          showLabels = _props.showLabels,
	          margin = _props.margin,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          labelsAboveChildren = _props.labelsAboveChildren,
	          getAngle = _props.getAngle,
	          getLabel = _props.getLabel,
	          getSubLabel = _props.getSubLabel;
	
	      var mappedData = getWedgesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width, getAngle: getAngle });
	      var radialDomain = (0, _seriesUtils.getRadialDomain)(mappedData);
	      var arcProps = _extends({
	        colorType: colorType
	      }, this.props, {
	        animation: animation,
	        radiusDomain: [0, radialDomain],
	        data: mappedData,
	        radiusNoFallBack: true,
	        arcClassName: 'rv-radial-chart__series--pie__slice'
	      });
	      if (radius) {
	        arcProps.radiusDomain = [0, 1];
	        arcProps.radiusRange = [innerRadius || 0, radius];
	        arcProps.radiusType = 'linear';
	      }
	      var maxRadius = radius ? radius : getMaxRadius(width, height);
	      var defaultMargin = (0, _chartUtils.getRadialLayoutMargin)(width, height, maxRadius);
	
	      var labels = generateLabels(mappedData, {
	        getLabel: getLabel,
	        getSubLabel: getSubLabel
	      });
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          width: width,
	          margin: _extends({}, margin, defaultMargin),
	          className: className + ' ' + predefinedClassName,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          xDomain: [-radialDomain, radialDomain],
	          yDomain: [-radialDomain, radialDomain] },
	        _react2.default.createElement(_arcSeries2.default, _extends({}, arcProps, { getAngle: function getAngle(d) {
	            return d.angle;
	          } })),
	        showLabels && !labelsAboveChildren && _react2.default.createElement(_labelSeries2.default, { data: labels }),
	        children,
	        showLabels && labelsAboveChildren && _react2.default.createElement(_labelSeries2.default, { data: labels })
	      );
	    }
	  }]);
	
	  return RadialChart;
	}(_react.Component);
	
	RadialChart.displayName = 'RadialChart';
	RadialChart.propTypes = {
	  animation: _animation.AnimationPropType,
	  className: _propTypes2.default.string,
	  colorType: _propTypes2.default.string,
	  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    angle: _propTypes2.default.number,
	    className: _propTypes2.default.string,
	    label: _propTypes2.default.string,
	    radius: _propTypes2.default.number,
	    style: _propTypes2.default.object
	  })).isRequired,
	  getAngle: _propTypes2.default.func,
	  getAngle0: _propTypes2.default.func,
	  getRadius: _propTypes2.default.func,
	  getRadius0: _propTypes2.default.func,
	  getLabel: _propTypes2.default.func,
	  height: _propTypes2.default.number.isRequired,
	  labelsAboveChildren: _propTypes2.default.bool,
	  margin: _chartUtils.MarginPropType,
	  onValueClick: _propTypes2.default.func,
	  onValueMouseOver: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired,
	  showLabels: _propTypes2.default.bool,
	  subLabel: _propTypes2.default.func
	};
	RadialChart.defaultProps = {
	  className: '',
	  colorType: 'category',
	  colorRange: _theme.DISCRETE_COLOR_RANGE,
	  getAngle: function getAngle(d) {
	    return d.angle;
	  },
	  getAngle0: function getAngle0(d) {
	    return d.angle0;
	  },
	  getRadius: function getRadius(d) {
	    return d.radius;
	  },
	  getRadius0: function getRadius0(d) {
	    return d.radius0;
	  },
	  getLabel: function getLabel(d) {
	    return d.label;
	  },
	  getSubLabel: function getSubLabel(d) {
	    return d.subLabel;
	  }
	};
	
	exports.default = RadialChart;

/***/ },
/* 2946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Sankey = __webpack_require__(1879);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _chartUtils = __webpack_require__(162);
	
	var _verticalRectSeries = __webpack_require__(1319);
	
	var _verticalRectSeries2 = _interopRequireDefault(_verticalRectSeries);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _voronoi = __webpack_require__(1320);
	
	var _voronoi2 = _interopRequireDefault(_voronoi);
	
	var _theme = __webpack_require__(48);
	
	var _sankeyLink = __webpack_require__(2947);
	
	var _sankeyLink2 = _interopRequireDefault(_sankeyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NOOP = function NOOP(f) {
	  return f;
	};
	
	var ALIGNMENTS = {
	  justify: _d3Sankey.sankeyJustify,
	  center: _d3Sankey.sankeyCenter,
	  left: _d3Sankey.sankeyLeft,
	  right: _d3Sankey.sankeyRight
	};
	
	var DEFAULT_MARGINS = {
	  top: 20,
	  left: 20,
	  right: 20,
	  bottom: 20
	};
	
	var Sankey = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey() {
	    _classCallCheck(this, Sankey);
	
	    return _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).apply(this, arguments));
	  }
	
	  _createClass(Sankey, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          align = _props.align,
	          animation = _props.animation,
	          children = _props.children,
	          className = _props.className,
	          hasVoronoi = _props.hasVoronoi,
	          height = _props.height,
	          hideLabels = _props.hideLabels,
	          layout = _props.layout,
	          links = _props.links,
	          linkOpacity = _props.linkOpacity,
	          margin = _props.margin,
	          nodePadding = _props.nodePadding,
	          nodes = _props.nodes,
	          nodeWidth = _props.nodeWidth,
	          onValueClick = _props.onValueClick,
	          onValueMouseOver = _props.onValueMouseOver,
	          onValueMouseOut = _props.onValueMouseOut,
	          onLinkClick = _props.onLinkClick,
	          onLinkMouseOver = _props.onLinkMouseOver,
	          onLinkMouseOut = _props.onLinkMouseOut,
	          style = _props.style,
	          width = _props.width;
	
	      var nodesCopy = [].concat(_toConsumableArray(new Array(nodes.length))).map(function (e, i) {
	        return _extends({}, nodes[i]);
	      });
	      var linksCopy = [].concat(_toConsumableArray(new Array(links.length))).map(function (e, i) {
	        return _extends({}, links[i]);
	      });
	
	      var _getInnerDimensions = (0, _chartUtils.getInnerDimensions)({
	        margin: margin, height: height, width: width
	      }, DEFAULT_MARGINS),
	          marginLeft = _getInnerDimensions.marginLeft,
	          marginTop = _getInnerDimensions.marginTop,
	          marginRight = _getInnerDimensions.marginRight,
	          marginBottom = _getInnerDimensions.marginBottom;
	
	      var sankeyInstance = (0, _d3Sankey.sankey)().extent([[marginLeft, marginTop], [width - marginRight, height - marginBottom - marginTop]]).nodeWidth(nodeWidth).nodePadding(nodePadding).nodes(nodesCopy).links(linksCopy).nodeAlign(ALIGNMENTS[align]).iterations(layout);
	      sankeyInstance(nodesCopy);
	
	      var nWidth = sankeyInstance.nodeWidth();
	      var path = (0, _d3Sankey.sankeyLinkHorizontal)();
	
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        _extends({}, this.props, {
	          yType: 'literal',
	          className: 'rv-sankey ' + className }),
	        linksCopy.map(function (link, i) {
	          return _react2.default.createElement(_sankeyLink2.default, {
	            style: style.links,
	            data: path(link),
	            opacity: link.opacity || linkOpacity,
	            color: link.color,
	            onLinkClick: onLinkClick,
	            onLinkMouseOver: onLinkMouseOver,
	            onLinkMouseOut: onLinkMouseOut,
	            strokeWidth: Math.max(link.width, 1),
	            node: link,
	            nWidth: nWidth,
	            key: 'link-' + i });
	        }),
	        _react2.default.createElement(_verticalRectSeries2.default, {
	          animation: animation,
	          className: className + ' rv-sankey__node',
	          data: nodesCopy.map(function (node) {
	            return _extends({}, node, {
	              y: node.y1 - marginTop,
	              y0: node.y0 - marginTop,
	              x: node.x1,
	              x0: node.x0,
	              color: node.color || _theme.DISCRETE_COLOR_RANGE[0],
	              sourceLinks: null,
	              targetLinks: null
	            });
	          }),
	          style: style.rects,
	          onValueClick: onValueClick,
	          onValueMouseOver: onValueMouseOver,
	          onValueMouseOut: onValueMouseOut,
	          colorType: 'literal' }),
	        !hideLabels && _react2.default.createElement(_labelSeries2.default, {
	          animation: animation,
	          className: className,
	          data: nodesCopy.map(function (node) {
	            return {
	              x: node.x0 + (node.x0 < width / 2 ? nWidth + 10 : -10),
	              y: node.y0 + (node.y1 - node.y0) / 2 - marginTop,
	              label: node.name,
	              style: style.labels
	            };
	          })
	        }),
	        hasVoronoi && _react2.default.createElement(_voronoi2.default, {
	          className: 'rv-sankey__voronoi',
	          extent: [[-marginLeft, -marginTop], [width + marginRight, height + marginBottom]],
	          nodes: nodesCopy,
	          onClick: onValueClick,
	          onHover: onValueMouseOver,
	          onBlur: onValueMouseOut,
	          x: function x(d) {
	            return d.x0 + (d.x1 - d.x0) / 2;
	          },
	          y: function y(d) {
	            return d.y0 + (d.y1 - d.y0) / 2;
	          }
	        }),
	        children
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component);
	
	Sankey.defaultProps = {
	  align: 'justify',
	  className: '',
	  hasVoronoi: false,
	  hideLabels: false,
	  layout: 50,
	  margin: DEFAULT_MARGINS,
	  nodePadding: 10,
	  nodeWidth: 10,
	  onValueMouseOver: NOOP,
	  onValueClick: NOOP,
	  onValueMouseOut: NOOP,
	  onLinkClick: NOOP,
	  onLinkMouseOver: NOOP,
	  onLinkMouseOut: NOOP,
	  style: {
	    links: {},
	    rects: {},
	    labels: {}
	  }
	};
	Sankey.propTypes = {
	  align: _propTypes2.default.oneOf(['justify', 'left', 'right', 'center']),
	  className: _propTypes2.default.string,
	  hasVoronoi: _propTypes2.default.bool,
	  height: _propTypes2.default.number.isRequired,
	  hideLabels: _propTypes2.default.bool,
	  layout: _propTypes2.default.number,
	  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    source: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]).isRequired,
	    target: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]).isRequired
	  })).isRequired,
	  margin: _chartUtils.MarginPropType,
	  nodePadding: _propTypes2.default.number,
	  nodes: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	  nodeWidth: _propTypes2.default.number,
	  onValueMouseOver: _propTypes2.default.func,
	  onValueClick: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  onLinkClick: _propTypes2.default.func,
	  onLinkMouseOver: _propTypes2.default.func,
	  onLinkMouseOut: _propTypes2.default.func,
	  style: _propTypes2.default.shape({
	    links: _propTypes2.default.object,
	    rects: _propTypes2.default.object,
	    labels: _propTypes2.default.object
	  }),
	  width: _propTypes2.default.number.isRequired
	};
	exports.default = Sankey;

/***/ },
/* 2947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _theme = __webpack_require__(48);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _seriesUtils = __webpack_require__(49);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var DEFAULT_LINK_COLOR = _theme.DISCRETE_COLOR_RANGE[1];
	var DEFAULT_LINK_OPACITY = 0.7;
	
	var SankeyLink = function (_PureComponent) {
	  _inherits(SankeyLink, _PureComponent);
	
	  function SankeyLink() {
	    _classCallCheck(this, SankeyLink);
	
	    return _possibleConstructorReturn(this, (SankeyLink.__proto__ || Object.getPrototypeOf(SankeyLink)).apply(this, arguments));
	  }
	
	  _createClass(SankeyLink, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          data = _props.data,
	          node = _props.node,
	          opacity = _props.opacity,
	          color = _props.color,
	          strokeWidth = _props.strokeWidth,
	          style = _props.style,
	          onLinkClick = _props.onLinkClick,
	          onLinkMouseOver = _props.onLinkMouseOver,
	          onLinkMouseOut = _props.onLinkMouseOut;
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: _seriesUtils.ANIMATED_SERIES_PROPS }),
	          _react2.default.createElement(SankeyLink, _extends({}, this.props, { animation: null }))
	        );
	      }
	      return _react2.default.createElement('path', _extends({
	        d: data
	      }, style, {
	        className: 'rv-sankey__link',
	        opacity: Number.isFinite(opacity) ? opacity : DEFAULT_LINK_OPACITY,
	        stroke: color || DEFAULT_LINK_COLOR,
	        onClick: function onClick(e) {
	          return onLinkClick(node, e);
	        },
	        onMouseOver: function onMouseOver(e) {
	          return onLinkMouseOver(node, e);
	        },
	        onMouseOut: function onMouseOut(e) {
	          return onLinkMouseOut(node, e);
	        },
	        strokeWidth: strokeWidth,
	        fill: 'none' }));
	    }
	  }]);
	
	  return SankeyLink;
	}(_react.PureComponent);
	
	SankeyLink.displayName = 'SankeyLink';
	SankeyLink.requiresSVG = true;
	exports.default = SankeyLink;

/***/ },
/* 2948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Hierarchy = __webpack_require__(898);
	
	var _d3Scale = __webpack_require__(180);
	
	var _animation = __webpack_require__(38);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	var _arcSeries = __webpack_require__(521);
	
	var _arcSeries2 = _interopRequireDefault(_arcSeries);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _seriesUtils = __webpack_require__(49);
	
	var _chartUtils = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var predefinedClassName = 'rv-sunburst';
	
	var LISTENERS_TO_OVERWRITE = ['onValueMouseOver', 'onValueMouseOut', 'onValueClick', 'onValueRightClick', 'onSeriesMouseOver', 'onSeriesMouseOut', 'onSeriesClick', 'onSeriesRightClick'];
	
	/**
	 * Create the list of nodes to render.
	 * @param {Object} props
	   props.data {Object} - tree structured data (each node has a name anc an array of children)
	   props.height {number} - the height of the graphic to be rendered
	   props.hideRootNode {boolean} - whether or not to hide the root node
	   props.width {number} - the width of the graphic to be rendered
	   props.getSize {function} - accessor for the size
	 * @returns {Array} Array of nodes.
	 */
	function getNodesToRender(_ref) {
	  var data = _ref.data,
	      height = _ref.height,
	      hideRootNode = _ref.hideRootNode,
	      width = _ref.width,
	      getSize = _ref.getSize;
	
	  var partitionFunction = (0, _d3Hierarchy.partition)();
	  var structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(getSize);
	  var radius = Math.min(width, height) / 2 - 10;
	  var x = (0, _d3Scale.scaleLinear)().range([0, 2 * Math.PI]);
	  var y = (0, _d3Scale.scaleSqrt)().range([0, radius]);
	
	  return partitionFunction(structuredInput).descendants().reduce(function (res, cell, index) {
	    if (hideRootNode && index === 0) {
	      return res;
	    }
	
	    return res.concat([_extends({
	      angle0: Math.max(0, Math.min(2 * Math.PI, x(cell.x0))),
	      angle: Math.max(0, Math.min(2 * Math.PI, x(cell.x1))),
	      radius0: Math.max(0, y(cell.y0)),
	      radius: Math.max(0, y(cell.y1)),
	      depth: cell.depth,
	      parent: cell.parent
	    }, cell.data)]);
	  }, []);
	}
	
	/**
	 * Convert arc nodes into label rows.
	 * Important to use mappedData rather than regular data, bc it is already unrolled
	 * @param {Array} mappedData - Array of nodes.
	 * @param {Object} accessors - object of accessors
	 * @returns {Array} array of node for rendering as labels
	 */
	function buildLabels(mappedData, accessors) {
	  var getAngle = accessors.getAngle,
	      getAngle0 = accessors.getAngle0,
	      getLabel = accessors.getLabel,
	      getRadius0 = accessors.getRadius0;
	
	
	  return mappedData.filter(getLabel).map(function (row) {
	    var truedAngle = -1 * getAngle(row) + Math.PI / 2;
	    var truedAngle0 = -1 * getAngle0(row) + Math.PI / 2;
	    var angle = (truedAngle0 + truedAngle) / 2;
	    var rotateLabels = !row.dontRotateLabel;
	    var rotAngle = -angle / (2 * Math.PI) * 360;
	
	    return _extends({}, row, {
	      children: null,
	      angle: null,
	      radius: null,
	      x: getRadius0(row) * Math.cos(angle),
	      y: getRadius0(row) * Math.sin(angle),
	      style: _extends({
	        textAnchor: rotAngle > 90 ? 'end' : 'start'
	      }, row.labelStyle),
	      rotation: rotateLabels ? rotAngle > 90 ? rotAngle + 180 : rotAngle === 90 ? 90 : rotAngle : null
	    });
	  });
	}
	
	var NOOP = function NOOP() {};
	
	var Sunburst = function (_React$Component) {
	  _inherits(Sunburst, _React$Component);
	
	  function Sunburst() {
	    _classCallCheck(this, Sunburst);
	
	    return _possibleConstructorReturn(this, (Sunburst.__proto__ || Object.getPrototypeOf(Sunburst)).apply(this, arguments));
	  }
	
	  _createClass(Sunburst, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          getAngle = _props.getAngle,
	          getAngle0 = _props.getAngle0,
	          animation = _props.animation,
	          className = _props.className,
	          children = _props.children,
	          data = _props.data,
	          height = _props.height,
	          hideRootNode = _props.hideRootNode,
	          getLabel = _props.getLabel,
	          width = _props.width,
	          getSize = _props.getSize,
	          colorType = _props.colorType;
	
	      var mappedData = getNodesToRender({ data: data, height: height, hideRootNode: hideRootNode, width: width, getSize: getSize });
	      var radialDomain = (0, _seriesUtils.getRadialDomain)(mappedData);
	      var margin = (0, _chartUtils.getRadialLayoutMargin)(width, height, radialDomain);
	
	      var labelData = buildLabels(mappedData, {
	        getAngle: getAngle,
	        getAngle0: getAngle0,
	        getLabel: getLabel,
	        getRadius0: function getRadius0(d) {
	          return d.radius0;
	        }
	      });
	
	      var hofBuilder = function hofBuilder(f) {
	        return function (e, i) {
	          return f ? f(mappedData[e.index], i) : NOOP;
	        };
	      };
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        {
	          height: height,
	          hasTreeStructure: true,
	          width: width,
	          className: predefinedClassName + ' ' + className,
	          margin: margin,
	          xDomain: [-radialDomain, radialDomain],
	          yDomain: [-radialDomain, radialDomain] },
	        _react2.default.createElement(_arcSeries2.default, _extends({
	          colorType: colorType
	        }, this.props, {
	          animation: animation,
	          radiusDomain: [0, radialDomain],
	          // need to present a stripped down version for interpolation
	          data: animation ? mappedData.map(function (row, index) {
	            return _extends({}, row, { parent: null, children: null, index: index });
	          }) : mappedData,
	          _data: animation ? mappedData : null,
	          arcClassName: predefinedClassName + '__series--radial__arc'
	        }, LISTENERS_TO_OVERWRITE.reduce(function (acc, propName) {
	          var prop = _this2.props[propName];
	          acc[propName] = animation ? hofBuilder(prop) : prop;
	          return acc;
	        }, {}))),
	        labelData.length > 0 && _react2.default.createElement(_labelSeries2.default, { data: labelData, getLabel: getLabel }),
	        children
	      );
	    }
	  }]);
	
	  return Sunburst;
	}(_react2.default.Component);
	
	Sunburst.displayName = 'Sunburst';
	Sunburst.propTypes = {
	  animation: _animation.AnimationPropType,
	  getAngle: _propTypes2.default.func,
	  getAngle0: _propTypes2.default.func,
	  className: _propTypes2.default.string,
	  colorType: _propTypes2.default.string,
	  data: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  hideRootNode: _propTypes2.default.bool,
	  getLabel: _propTypes2.default.func,
	  onValueClick: _propTypes2.default.func,
	  onValueMouseOver: _propTypes2.default.func,
	  onValueMouseOut: _propTypes2.default.func,
	  getSize: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired
	};
	Sunburst.defaultProps = {
	  getAngle: function getAngle(d) {
	    return d.angle;
	  },
	  getAngle0: function getAngle0(d) {
	    return d.angle0;
	  },
	  className: '',
	  colorType: 'literal',
	  getColor: function getColor(d) {
	    return d.color;
	  },
	  hideRootNode: false,
	  getLabel: function getLabel(d) {
	    return d.label;
	  },
	  getSize: function getSize(d) {
	    return d.size;
	  }
	};
	
	exports.default = Sunburst;

/***/ },
/* 2949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _d3Hierarchy = __webpack_require__(898);
	
	var _theme = __webpack_require__(48);
	
	var _animation = __webpack_require__(38);
	
	var _scalesUtils = __webpack_require__(60);
	
	var _chartUtils = __webpack_require__(162);
	
	var _treemapDom = __webpack_require__(2950);
	
	var _treemapDom2 = _interopRequireDefault(_treemapDom);
	
	var _treemapSvg = __webpack_require__(2952);
	
	var _treemapSvg2 = _interopRequireDefault(_treemapSvg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TREEMAP_TILE_MODES = {
	  squarify: _d3Hierarchy.treemapSquarify,
	  resquarify: _d3Hierarchy.treemapResquarify,
	  slice: _d3Hierarchy.treemapSlice,
	  dice: _d3Hierarchy.treemapDice,
	  slicedice: _d3Hierarchy.treemapSliceDice,
	  binary: _d3Hierarchy.treemapBinary
	};
	
	var TREEMAP_LAYOUT_MODES = ['circlePack', 'partition', 'partition-pivot'];
	
	var NOOP = function NOOP(d) {
	  return d;
	};
	
	var ATTRIBUTES = ['opacity', 'color'];
	
	var DEFAULT_MARGINS = {
	  left: 40,
	  right: 10,
	  top: 10,
	  bottom: 40
	};
	
	/**
	 * Get the map of scale functions from the given props.
	 * @param {Object} props Props for the component.
	 * @returns {Object} Map of scale functions.
	 * @private
	 */
	function _getScaleFns(props) {
	  var data = props.data;
	
	  var allData = data.children || [];
	
	  // Adding _allData property to the object to reuse the existing
	  // getAttributeFunctor function.
	  var compatibleProps = _extends({}, props, (0, _scalesUtils.getMissingScaleProps)(props, allData, ATTRIBUTES), {
	    _allData: allData
	  });
	  return {
	    opacity: (0, _scalesUtils.getAttributeFunctor)(compatibleProps, 'opacity'),
	    color: (0, _scalesUtils.getAttributeFunctor)(compatibleProps, 'color')
	  };
	}
	
	var Treemap = function (_React$Component) {
	  _inherits(Treemap, _React$Component);
	
	  function Treemap(props) {
	    _classCallCheck(this, Treemap);
	
	    var _this = _possibleConstructorReturn(this, (Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call(this, props));
	
	    _this.state = _extends({
	      scales: _getScaleFns(props)
	    }, (0, _chartUtils.getInnerDimensions)(props, props.margin));
	    return _this;
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState(_extends({
	        scales: _getScaleFns(props)
	      }, (0, _chartUtils.getInnerDimensions)(props, props.margin)));
	    }
	
	    /**
	     * Create the list of nodes to render.
	     * @returns {Array} Array of nodes.
	     * @private
	     */
	
	  }, {
	    key: '_getNodesToRender',
	    value: function _getNodesToRender() {
	      var _state = this.state,
	          innerWidth = _state.innerWidth,
	          innerHeight = _state.innerHeight;
	      var _props = this.props,
	          data = _props.data,
	          mode = _props.mode,
	          padding = _props.padding,
	          sortFunction = _props.sortFunction,
	          getSize = _props.getSize;
	
	      if (!data) {
	        return [];
	      }
	
	      if (mode === 'partition' || mode === 'partition-pivot') {
	        var partitionFunction = (0, _d3Hierarchy.partition)().size(mode === 'partition-pivot' ? [innerHeight, innerWidth] : [innerWidth, innerHeight]).padding(padding);
	        var _structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(getSize).sort(function (a, b) {
	          return sortFunction(a, b, getSize);
	        });
	        var mappedNodes = partitionFunction(_structuredInput).descendants();
	        if (mode === 'partition-pivot') {
	          return mappedNodes.map(function (node) {
	            return _extends({}, node, {
	              x0: node.y0,
	              x1: node.y1,
	              y0: node.x0,
	              y1: node.x1
	            });
	          });
	        }
	        return mappedNodes;
	      }
	      if (mode === 'circlePack') {
	        var packingFunction = (0, _d3Hierarchy.pack)().size([innerWidth, innerHeight]).padding(padding);
	        var _structuredInput2 = (0, _d3Hierarchy.hierarchy)(data).sum(getSize).sort(function (a, b) {
	          return sortFunction(a, b, getSize);
	        });
	        return packingFunction(_structuredInput2).descendants();
	      }
	
	      var tileFn = TREEMAP_TILE_MODES[mode];
	      var treemapingFunction = (0, _d3Hierarchy.treemap)(tileFn).tile(tileFn).size([innerWidth, innerHeight]).padding(padding);
	      var structuredInput = (0, _d3Hierarchy.hierarchy)(data).sum(getSize).sort(function (a, b) {
	        return sortFunction(a, b, getSize);
	      });
	      return treemapingFunction(structuredInput).descendants();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var renderMode = this.props.renderMode;
	      var scales = this.state.scales;
	
	      var nodes = this._getNodesToRender();
	      var TreemapElement = renderMode === 'SVG' ? _treemapSvg2.default : _treemapDom2.default;
	      return _react2.default.createElement(TreemapElement, _extends({}, this.props, { nodes: nodes, scales: scales }));
	    }
	  }]);
	
	  return Treemap;
	}(_react2.default.Component);
	
	Treemap.displayName = 'Treemap';
	Treemap.propTypes = {
	  animation: _animation.AnimationPropType,
	  className: _propTypes2.default.string,
	  data: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.number.isRequired,
	  hideRootNode: _propTypes2.default.bool,
	  margin: _chartUtils.MarginPropType,
	  mode: _propTypes2.default.oneOf(Object.keys(TREEMAP_TILE_MODES).concat(TREEMAP_LAYOUT_MODES)),
	  onLeafClick: _propTypes2.default.func,
	  onLeafMouseOver: _propTypes2.default.func,
	  onLeafMouseOut: _propTypes2.default.func,
	  useCirclePacking: _propTypes2.default.bool,
	  padding: _propTypes2.default.number.isRequired,
	  sortFunction: _propTypes2.default.func,
	  width: _propTypes2.default.number.isRequired,
	  getSize: _propTypes2.default.func,
	  getColor: _propTypes2.default.func
	};
	
	Treemap.defaultProps = {
	  className: '',
	  colorRange: _theme.CONTINUOUS_COLOR_RANGE,
	  _colorValue: _theme.DEFAULT_COLOR,
	  data: {
	    children: []
	  },
	  hideRootNode: false,
	  margin: DEFAULT_MARGINS,
	  mode: 'squarify',
	  onLeafClick: NOOP,
	  onLeafMouseOver: NOOP,
	  onLeafMouseOut: NOOP,
	  opacityType: _theme.OPACITY_TYPE,
	  _opacityValue: _theme.DEFAULT_OPACITY,
	  padding: 1,
	  sortFunction: function sortFunction(a, b, accessor) {
	    if (!accessor) {
	      return 0;
	    }
	    return accessor(a) - accessor(b);
	  },
	  getSize: function getSize(d) {
	    return d.size;
	  },
	  getColor: function getColor(d) {
	    return d.color;
	  },
	  getLabel: function getLabel(d) {
	    return d.title;
	  }
	};
	exports.default = Treemap;

/***/ },
/* 2950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _treemapLeaf = __webpack_require__(2951);
	
	var _treemapLeaf2 = _interopRequireDefault(_treemapLeaf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	
	var TreemapDOM = function (_React$Component) {
	  _inherits(TreemapDOM, _React$Component);
	
	  function TreemapDOM() {
	    _classCallCheck(this, TreemapDOM);
	
	    return _possibleConstructorReturn(this, (TreemapDOM.__proto__ || Object.getPrototypeOf(TreemapDOM)).apply(this, arguments));
	  }
	
	  _createClass(TreemapDOM, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          animation = _props.animation,
	          className = _props.className,
	          height = _props.height,
	          hideRootNode = _props.hideRootNode,
	          getLabel = _props.getLabel,
	          mode = _props.mode,
	          nodes = _props.nodes,
	          width = _props.width,
	          scales = _props.scales,
	          style = _props.style;
	
	      var useCirclePacking = mode === 'circlePack';
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
	          style: { height: height, width: width } },
	        nodes.map(function (node, index) {
	          // throw out the rootest node
	          if (hideRootNode && !index) {
	            return null;
	          }
	
	          var nodeProps = _extends({
	            animation: animation,
	            node: node,
	            getLabel: getLabel
	          }, _this2.props, {
	            x0: useCirclePacking ? node.x : node.x0,
	            x1: useCirclePacking ? node.x : node.x1,
	            y0: useCirclePacking ? node.y : node.y0,
	            y1: useCirclePacking ? node.y : node.y1,
	            r: useCirclePacking ? node.r : 1,
	            scales: scales,
	            style: style
	          });
	          return _react2.default.createElement(_treemapLeaf2.default, _extends({}, nodeProps, { key: 'leaf-' + index }));
	        })
	      );
	    }
	  }]);
	
	  return TreemapDOM;
	}(_react2.default.Component);
	
	TreemapDOM.displayName = 'TreemapDOM';
	exports.default = TreemapDOM;

/***/ },
/* 2951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _animation = __webpack_require__(38);
	
	var _animation2 = _interopRequireDefault(_animation);
	
	var _scalesUtils = __webpack_require__(60);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var ANIMATED_PROPS = ['colorRange', 'colorDomain', 'color', 'opacityRange', 'opacityDomain', 'opacity', 'x0', 'x1', 'y0', 'y1', 'r'];
	
	var TreemapLeaf = function (_React$Component) {
	  _inherits(TreemapLeaf, _React$Component);
	
	  function TreemapLeaf() {
	    _classCallCheck(this, TreemapLeaf);
	
	    return _possibleConstructorReturn(this, (TreemapLeaf.__proto__ || Object.getPrototypeOf(TreemapLeaf)).apply(this, arguments));
	  }
	
	  _createClass(TreemapLeaf, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          animation = _props.animation,
	          getLabel = _props.getLabel,
	          mode = _props.mode,
	          node = _props.node,
	          onLeafClick = _props.onLeafClick,
	          onLeafMouseOver = _props.onLeafMouseOver,
	          onLeafMouseOut = _props.onLeafMouseOut,
	          r = _props.r,
	          scales = _props.scales,
	          x0 = _props.x0,
	          x1 = _props.x1,
	          y0 = _props.y0,
	          y1 = _props.y1,
	          style = _props.style;
	
	
	      if (animation) {
	        return _react2.default.createElement(
	          _animation2.default,
	          _extends({}, this.props, { animatedProps: ANIMATED_PROPS }),
	          _react2.default.createElement(TreemapLeaf, _extends({}, this.props, { animation: null }))
	        );
	      }
	      var useCirclePacking = mode === 'circlePack';
	      var background = scales.color(node);
	      var opacity = scales.opacity(node);
	      var color = (0, _scalesUtils.getFontColorFromBackground)(background);
	      var data = node.data;
	
	      var title = getLabel(data);
	      var leafStyle = _extends({
	        top: useCirclePacking ? y0 - r : y0,
	        left: useCirclePacking ? x0 - r : x0,
	        width: useCirclePacking ? r * 2 : x1 - x0,
	        height: useCirclePacking ? r * 2 : y1 - y0,
	        background: background,
	        opacity: opacity,
	        color: color
	      }, style, node.data.style);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'rv-treemap__leaf ' + (useCirclePacking ? 'rv-treemap__leaf--circle' : ''),
	          onMouseEnter: function onMouseEnter(event) {
	            return onLeafMouseOver(node, event);
	          },
	          onMouseLeave: function onMouseLeave(event) {
	            return onLeafMouseOut(node, event);
	          },
	          onClick: function onClick(event) {
	            return onLeafClick(node, event);
	          },
	          style: leafStyle },
	        _react2.default.createElement(
	          'div',
	          { className: 'rv-treemap__leaf__content' },
	          title
	        )
	      );
	    }
	  }]);
	
	  return TreemapLeaf;
	}(_react2.default.Component);
	
	TreemapLeaf.propTypes = {
	  animation: _animation.AnimationPropType,
	  height: _propTypes2.default.number.isRequired,
	  mode: _propTypes2.default.string,
	  node: _propTypes2.default.object.isRequired,
	  onLeafClick: _propTypes2.default.func,
	  onLeafMouseOver: _propTypes2.default.func,
	  onLeafMouseOut: _propTypes2.default.func,
	  scales: _propTypes2.default.object.isRequired,
	  width: _propTypes2.default.number.isRequired,
	  r: _propTypes2.default.number.isRequired,
	  x0: _propTypes2.default.number.isRequired,
	  x1: _propTypes2.default.number.isRequired,
	  y0: _propTypes2.default.number.isRequired,
	  y1: _propTypes2.default.number.isRequired
	};
	exports.default = TreemapLeaf;

/***/ },
/* 2952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _xyPlot = __webpack_require__(135);
	
	var _xyPlot2 = _interopRequireDefault(_xyPlot);
	
	var _polygonSeries = __webpack_require__(524);
	
	var _polygonSeries2 = _interopRequireDefault(_polygonSeries);
	
	var _markSeries = __webpack_require__(523);
	
	var _markSeries2 = _interopRequireDefault(_markSeries);
	
	var _labelSeries = __webpack_require__(161);
	
	var _labelSeries2 = _interopRequireDefault(_labelSeries);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	var MARGIN_ADJUST = 1.2;
	
	var TreemapSVG = function (_React$Component) {
	  _inherits(TreemapSVG, _React$Component);
	
	  function TreemapSVG() {
	    _classCallCheck(this, TreemapSVG);
	
	    return _possibleConstructorReturn(this, (TreemapSVG.__proto__ || Object.getPrototypeOf(TreemapSVG)).apply(this, arguments));
	  }
	
	  _createClass(TreemapSVG, [{
	    key: 'getCircularNodes',
	    value: function getCircularNodes() {
	      var _props = this.props,
	          animation = _props.animation,
	          hideRootNode = _props.hideRootNode,
	          nodes = _props.nodes,
	          onLeafMouseOver = _props.onLeafMouseOver,
	          onLeafMouseOut = _props.onLeafMouseOut,
	          onLeafClick = _props.onLeafClick,
	          scales = _props.scales,
	          style = _props.style;
	
	      var _nodes$reduce = nodes.reduce(function (acc, node, index) {
	        if (!index && hideRootNode) {
	          return acc;
	        }
	        var x = node.x,
	            y = node.y,
	            r = node.r;
	
	        return {
	          maxY: Math.max(y + r, acc.maxY),
	          minY: Math.min(y - r, acc.minY),
	          maxX: Math.max(x + MARGIN_ADJUST * r, acc.maxX),
	          minX: Math.min(x - MARGIN_ADJUST * r, acc.minX),
	          rows: acc.rows.concat([{
	            x: x,
	            y: y,
	            size: r,
	            color: scales.color(node)
	          }])
	        };
	      }, {
	        rows: [],
	        maxY: -Infinity,
	        minY: Infinity,
	        maxX: -Infinity,
	        minX: Infinity
	      }),
	          rows = _nodes$reduce.rows,
	          minY = _nodes$reduce.minY,
	          maxY = _nodes$reduce.maxY,
	          minX = _nodes$reduce.minX,
	          maxX = _nodes$reduce.maxX;
	
	      return {
	        updatedNodes: _react2.default.createElement(_markSeries2.default, {
	          animation: animation,
	          className: 'rv-treemap__leaf rv-treemap__leaf--circle',
	          onSeriesMouseEnter: onLeafMouseOver,
	          onSeriesMouseLeave: onLeafMouseOut,
	          onSeriesClick: onLeafClick,
	          data: rows,
	          colorType: 'literal',
	          getColor: function getColor(d) {
	            return d.color;
	          },
	          sizeType: 'literal',
	          getSize: function getSize(d) {
	            return d.size;
	          },
	          style: style }),
	        minY: minY,
	        maxY: maxY,
	        minX: minX,
	        maxX: maxX
	      };
	    }
	  }, {
	    key: 'getNonCircularNodes',
	    value: function getNonCircularNodes() {
	      var _props2 = this.props,
	          animation = _props2.animation,
	          hideRootNode = _props2.hideRootNode,
	          nodes = _props2.nodes,
	          onLeafMouseOver = _props2.onLeafMouseOver,
	          onLeafMouseOut = _props2.onLeafMouseOut,
	          onLeafClick = _props2.onLeafClick,
	          scales = _props2.scales,
	          style = _props2.style;
	      var color = scales.color;
	
	      return nodes.reduce(function (acc, node, index) {
	        if (!index && hideRootNode) {
	          return acc;
	        }
	        var x0 = node.x0,
	            x1 = node.x1,
	            y1 = node.y1,
	            y0 = node.y0;
	
	        var x = x0;
	        var y = y0;
	        var nodeHeight = y1 - y0;
	        var nodeWidth = x1 - x0;
	
	        acc.maxY = Math.max(y + nodeHeight, acc.maxY);
	        acc.minY = Math.min(y, acc.minY);
	        acc.maxX = Math.max(x + nodeWidth, acc.maxX);
	        acc.minX = Math.min(x, acc.minX);
	
	        var data = [{ x: x, y: y }, { x: x, y: y + nodeHeight }, { x: x + nodeWidth, y: y + nodeHeight }, { x: x + nodeWidth, y: y }];
	
	        acc.updatedNodes = acc.updatedNodes.concat([_react2.default.createElement(_polygonSeries2.default, {
	          animation: animation,
	          className: 'rv-treemap__leaf',
	          key: index,
	          color: color(node),
	          type: 'literal',
	          onSeriesMouseEnter: onLeafMouseOver,
	          onSeriesMouseLeave: onLeafMouseOut,
	          onSeriesClick: onLeafClick,
	          data: data,
	          style: _extends({}, style, node.style)
	        })]);
	        return acc;
	      }, {
	        updatedNodes: [],
	        maxY: -Infinity,
	        minY: Infinity,
	        maxX: -Infinity,
	        minX: Infinity
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          className = _props3.className,
	          height = _props3.height,
	          mode = _props3.mode,
	          nodes = _props3.nodes,
	          width = _props3.width;
	
	      var useCirclePacking = mode === 'circlePack';
	
	      var _ref = useCirclePacking ? this.getCircularNodes() : this.getNonCircularNodes(),
	          minY = _ref.minY,
	          maxY = _ref.maxY,
	          minX = _ref.minX,
	          maxX = _ref.maxX,
	          updatedNodes = _ref.updatedNodes;
	
	      var labels = nodes.reduce(function (acc, node) {
	        if (!node.data.title) {
	          return acc;
	        }
	        return acc.concat(_extends({}, node.data, {
	          x: node.x0 || node.x,
	          y: node.y0 || node.y,
	          label: '' + node.data.title
	        }));
	      }, []);
	
	      return _react2.default.createElement(
	        _xyPlot2.default,
	        _extends({
	          className: 'rv-treemap ' + (useCirclePacking ? 'rv-treemap-circle-packed' : '') + ' ' + className,
	          width: width,
	          height: height,
	          yDomain: [maxY, minY],
	          xDomain: [minX, maxX],
	          colorType: 'literal',
	          hasTreeStructure: true
	        }, this.props),
	        updatedNodes,
	        _react2.default.createElement(_labelSeries2.default, { data: labels })
	      );
	    }
	  }]);
	
	  return TreemapSVG;
	}(_react2.default.Component);
	
	TreemapSVG.displayName = 'TreemapSVG';
	
	exports.default = TreemapSVG;

/***/ },
/* 2953 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUniquePropertyValues = getUniquePropertyValues;
	exports.addValueToArray = addValueToArray;
	// Copyright (c) 2016 - 2017 Uber Technologies, Inc.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the "Software"), to deal
	// in the Software without restriction, including without limitation the rights
	// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	// copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	// THE SOFTWARE.
	
	/**
	 * Get unique property values from an array.
	 * @param {Array} arr Array of data.
	 * @param {string} propertyName Prop name.
	 * @returns {Array} Array of unique values.
	 */
	function getUniquePropertyValues(arr, accessor) {
	  var setOfValues = new Set(arr.map(accessor));
	  return Array.from(setOfValues);
	}
	
	/**
	 * Add zero to the domain.
	 * @param {Array} arr Add zero to the domain.
	 * @param {Number} value Add zero to domain.
	 * @returns {Array} Adjusted domain.
	 */
	function addValueToArray(arr, value) {
	  var result = [].concat(arr);
	  if (result[0] > value) {
	    result[0] = value;
	  }
	  if (result[result.length - 1] < value) {
	    result[result.length - 1] = value;
	  }
	  return result;
	}

/***/ },
/* 2954 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * WindowSizeListener
	 * React component for listening to window resize events
	 */
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var PropTypes = __webpack_require__(2);
	var debounce = __webpack_require__(2955);
	
	var WindowSizeListener = (function (_React$Component) {
	  _inherits(WindowSizeListener, _React$Component);
	
	  function WindowSizeListener(props) {
	    _classCallCheck(this, WindowSizeListener);
	
	    _get(Object.getPrototypeOf(WindowSizeListener.prototype), 'constructor', this).call(this, props);
	    this.displayName = 'WindowSizeListener';
	    this._listeners = [];
	    this.DEBOUNCE_TIME = 100;
	    this.onResize = this.onResize.bind(this);
	  }
	
	  _createClass(WindowSizeListener, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return nextProps.onResize !== this.props.onResize;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Defer creating _debouncedResize until it's mounted
	      // This allows users to change DEBOUNCE_TIME if they want
	      // If there's no listeners, we need to attach the window listener
	      if (!this._listeners.length) {
	        this._debouncedResize = debounce(this.onResize, this.DEBOUNCE_TIME);
	        window.addEventListener('resize', this._debouncedResize, false);
	      }
	      this._listeners.push(this.props.onResize);
	      this._debouncedResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var idx = this._listeners.indexOf(this.props.onResize);
	      this._listeners.splice(idx, 1);
	      if (!this._listeners.length) {
	        window.removeEventListener('resize', this._debouncedResize, false);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.onResize !== this.props.onResize) {
	        var idx = this._listeners.indexOf(this.props.onResize);
	        this._listeners.splice(idx, 1, nextProps.onResize);
	      }
	    }
	
	    /**
	     * Resize handler
	     * Gets the window size and calls eacg listener
	     * @private
	     */
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	      var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	
	      this._listeners.forEach(function (listener) {
	        listener({ windowWidth: windowWidth, windowHeight: windowHeight });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }, {
	    key: 'DEBOUNCE_TIME',
	    get: function get() {
	      return this._DEBOUNCE_TIME;
	    },
	    set: function set(value) {
	      this._DEBOUNCE_TIME = value;
	    }
	  }]);
	
	  return WindowSizeListener;
	})(React.Component);
	
	WindowSizeListener.propTypes = {
	  onResize: PropTypes.func.isRequired
	};
	
	module.exports = WindowSizeListener;

/***/ },
/* 2955 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(973);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeNow = getNative(Date, 'now');
	
	/**
	 * Gets the number of milliseconds that have elapsed since the Unix epoch
	 * (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @category Date
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => logs the number of milliseconds it took for the deferred function to be invoked
	 */
	var now = nativeNow || function() {
	  return new Date().getTime();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed invocations. Provide an options object to indicate that `func`
	 * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	 * Subsequent calls to the debounced function return the result of the last
	 * `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options] The options object.
	 * @param {boolean} [options.leading=false] Specify invoking on the leading
	 *  edge of the timeout.
	 * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	 *  delayed before it is invoked.
	 * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	 *  edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // avoid costly calculations while the window size is in flux
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	 * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // ensure `batchLog` is invoked once after 1 second of debounced calls
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', _.debounce(batchLog, 250, {
	 *   'maxWait': 1000
	 * }));
	 *
	 * // cancel a debounced call
	 * var todoChanges = _.debounce(batchLog, 1000);
	 * Object.observe(models.todo, todoChanges);
	 *
	 * Object.observe(models, function(changes) {
	 *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	 *     todoChanges.cancel();
	 *   }
	 * }, ['delete']);
	 *
	 * // ...at some point `models.todo` is changed
	 * models.todo.completed = true;
	 *
	 * // ...before 1 second has passed `models.todo` is deleted
	 * // which cancels the debounced `todoChanges` call
	 * delete models.todo;
	 */
	function debounce(func, wait, options) {
	  var args,
	      maxTimeoutId,
	      result,
	      stamp,
	      thisArg,
	      timeoutId,
	      trailingCall,
	      lastCalled = 0,
	      maxWait = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = wait < 0 ? 0 : (+wait || 0);
	  if (options === true) {
	    var leading = true;
	    trailing = false;
	  } else if (isObject(options)) {
	    leading = !!options.leading;
	    maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function cancel() {
	    if (timeoutId) {
	      clearTimeout(timeoutId);
	    }
	    if (maxTimeoutId) {
	      clearTimeout(maxTimeoutId);
	    }
	    lastCalled = 0;
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	  }
	
	  function complete(isCalled, id) {
	    if (id) {
	      clearTimeout(id);
	    }
	    maxTimeoutId = timeoutId = trailingCall = undefined;
	    if (isCalled) {
	      lastCalled = now();
	      result = func.apply(thisArg, args);
	      if (!timeoutId && !maxTimeoutId) {
	        args = thisArg = undefined;
	      }
	    }
	  }
	
	  function delayed() {
	    var remaining = wait - (now() - stamp);
	    if (remaining <= 0 || remaining > wait) {
	      complete(trailingCall, maxTimeoutId);
	    } else {
	      timeoutId = setTimeout(delayed, remaining);
	    }
	  }
	
	  function maxDelayed() {
	    complete(trailing, timeoutId);
	  }
	
	  function debounced() {
	    args = arguments;
	    stamp = now();
	    thisArg = this;
	    trailingCall = trailing && (timeoutId || !leading);
	
	    if (maxWait === false) {
	      var leadingCall = leading && !timeoutId;
	    } else {
	      if (!maxTimeoutId && !leading) {
	        lastCalled = stamp;
	      }
	      var remaining = maxWait - (stamp - lastCalled),
	          isCalled = remaining <= 0 || remaining > maxWait;
	
	      if (isCalled) {
	        if (maxTimeoutId) {
	          maxTimeoutId = clearTimeout(maxTimeoutId);
	        }
	        lastCalled = stamp;
	        result = func.apply(thisArg, args);
	      }
	      else if (!maxTimeoutId) {
	        maxTimeoutId = setTimeout(maxDelayed, remaining);
	      }
	    }
	    if (isCalled && timeoutId) {
	      timeoutId = clearTimeout(timeoutId);
	    }
	    else if (!timeoutId && wait !== maxWait) {
	      timeoutId = setTimeout(delayed, wait);
	    }
	    if (leadingCall) {
	      isCalled = true;
	      result = func.apply(thisArg, args);
	    }
	    if (isCalled && !timeoutId && !maxTimeoutId) {
	      args = thisArg = undefined;
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = debounce;


/***/ },
/* 2956 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANNEL = exports.CHANNEL = '__direction__';
	
	var DIRECTIONS = exports.DIRECTIONS = {
	  LTR: 'ltr',
	  RTL: 'rtl'
	};

/***/ },
/* 2957 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].shape({
	  getState: _propTypes2['default'].func,
	  setState: _propTypes2['default'].func,
	  subscribe: _propTypes2['default'].func
	});

/***/ },
/* 2958 */
/***/ function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arrayFlatten = __webpack_require__(2963);
	
	var _globalCache = __webpack_require__(947);
	
	var _globalCache2 = _interopRequireDefault(_globalCache);
	
	var _constants = __webpack_require__(2959);
	
	var _getClassName = __webpack_require__(2960);
	
	var _getClassName2 = _interopRequireDefault(_getClassName);
	
	var _separateStyles2 = __webpack_require__(2961);
	
	var _separateStyles3 = _interopRequireDefault(_separateStyles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Function required as part of the react-with-styles interface. Parses the styles provided by
	 * react-with-styles to produce class names based on the style name and optionally the namespace if
	 * available.
	 *
	 * stylesObject {Object} The styles object passed to withStyles.
	 *
	 * Return an object mapping style names to class names.
	 */
	function create(stylesObject) {
	  var stylesToClasses = {};
	  var styleNames = Object.keys(stylesObject);
	  var sharedState = _globalCache2['default'].get(_constants.GLOBAL_CACHE_KEY) || {};
	  var _sharedState$namespac = sharedState.namespace,
	      namespace = _sharedState$namespac === undefined ? '' : _sharedState$namespac;
	
	  styleNames.forEach(function (styleName) {
	    var className = (0, _getClassName2['default'])(namespace, styleName);
	    stylesToClasses[styleName] = className;
	  });
	  return stylesToClasses;
	}
	
	/**
	 * Process styles to be consumed by a component.
	 *
	 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
	 * representing inline styles, or arrays thereof.
	 *
	 * Return an object with optional className and style properties to be spread on a component.
	 */
	function resolve(stylesArray) {
	  var flattenedStyles = (0, _arrayFlatten.from)(stylesArray);
	
	  var _separateStyles = (0, _separateStyles3['default'])(flattenedStyles),
	      classNames = _separateStyles.classNames,
	      hasInlineStyles = _separateStyles.hasInlineStyles,
	      inlineStyles = _separateStyles.inlineStyles;
	
	  var specificClassNames = classNames.map(function (name, index) {
	    return String(name) + ' ' + String(name) + '_' + String(index + 1);
	  });
	  var className = specificClassNames.join(' ');
	
	  var result = { className: className };
	  if (hasInlineStyles) result.style = inlineStyles;
	  return result;
	}
	
	exports['default'] = { create: create, resolve: resolve };

/***/ },
/* 2959 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
	var MAX_SPECIFICITY = 20;
	
	exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
	exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

/***/ },
/* 2960 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getClassName;
	/**
	 * Construct a class name.
	 *
	 * namespace {String} Used to construct unique class names.
	 * styleName {String} Name identifying the specific style.
	 *
	 * Return the class name.
	 */
	function getClassName(namespace, styleName) {
	  var namespaceSegment = namespace.length > 0 ? String(namespace) + '__' : '';
	  return '' + namespaceSegment + String(styleName);
	}

/***/ },
/* 2961 */
/***/ function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This function takes an array of styles and separates them into styles that
	// are handled by Aphrodite and inline styles.
	function separateStyles(stylesArray) {
	  var classNames = [];
	
	  // Since determining if an Object is empty requires collecting all of its
	  // keys, and we want the best performance in this code because we are in the
	  // render path, we are going to do a little bookkeeping ourselves.
	  var hasInlineStyles = false;
	  var inlineStyles = {};
	
	  // This is run on potentially every node in the tree when rendering, where
	  // performance is critical. Normally we would prefer using `forEach`, but
	  // old-fashioned for loops are faster so that's what we have chosen here.
	  for (var i = 0; i < stylesArray.length; i++) {
	    // eslint-disable-line no-plusplus
	    var style = stylesArray[i];
	
	    // If this  style is falsy, we just want to disregard it. This allows for
	    // syntax like:
	    //
	    //   css(isFoo && styles.foo)
	    if (style) {
	      if (typeof style === 'string') {
	        classNames.push(style);
	      } else {
	        Object.assign(inlineStyles, style);
	        hasInlineStyles = true;
	      }
	    }
	  }
	
	  return {
	    classNames: classNames,
	    hasInlineStyles: hasInlineStyles,
	    inlineStyles: inlineStyles
	  };
	}
	
	exports['default'] = separateStyles;

/***/ },
/* 2962 */
/***/ function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(2958).default;


/***/ },
/* 2963 */
/***/ function(module, exports) {

	'use strict'
	
	/**
	 * Expose `arrayFlatten`.
	 */
	module.exports = flatten
	module.exports.from = flattenFrom
	module.exports.depth = flattenDepth
	module.exports.fromDepth = flattenFromDepth
	
	/**
	 * Flatten an array.
	 *
	 * @param  {Array} array
	 * @return {Array}
	 */
	function flatten (array) {
	  if (!Array.isArray(array)) {
	    throw new TypeError('Expected value to be an array')
	  }
	
	  return flattenFrom(array)
	}
	
	/**
	 * Flatten an array-like structure.
	 *
	 * @param  {Array} array
	 * @return {Array}
	 */
	function flattenFrom (array) {
	  return flattenDown(array, [])
	}
	
	/**
	 * Flatten an array-like structure with depth.
	 *
	 * @param  {Array}  array
	 * @param  {number} depth
	 * @return {Array}
	 */
	function flattenDepth (array, depth) {
	  if (!Array.isArray(array)) {
	    throw new TypeError('Expected value to be an array')
	  }
	
	  return flattenFromDepth(array, depth)
	}
	
	/**
	 * Flatten an array-like structure with depth.
	 *
	 * @param  {Array}  array
	 * @param  {number} depth
	 * @return {Array}
	 */
	function flattenFromDepth (array, depth) {
	  if (typeof depth !== 'number') {
	    throw new TypeError('Expected the depth to be a number')
	  }
	
	  return flattenDownDepth(array, [], depth)
	}
	
	/**
	 * Flatten an array indefinitely.
	 *
	 * @param  {Array} array
	 * @param  {Array} result
	 * @return {Array}
	 */
	function flattenDown (array, result) {
	  for (var i = 0; i < array.length; i++) {
	    var value = array[i]
	
	    if (Array.isArray(value)) {
	      flattenDown(value, result)
	    } else {
	      result.push(value)
	    }
	  }
	
	  return result
	}
	
	/**
	 * Flatten an array with depth.
	 *
	 * @param  {Array}  array
	 * @param  {Array}  result
	 * @param  {number} depth
	 * @return {Array}
	 */
	function flattenDownDepth (array, result, depth) {
	  depth--
	
	  for (var i = 0; i < array.length; i++) {
	    var value = array[i]
	
	    if (depth > -1 && Array.isArray(value)) {
	      flattenDownDepth(value, result, depth)
	    } else {
	      result.push(value)
	    }
	  }
	
	  return result
	}


/***/ },
/* 2964 */
/***/ function(module, exports, __webpack_require__) {

	!function(a,t){ true?module.exports=t(__webpack_require__(1)):"function"==typeof define&&define.amd?define(["react"],t):"object"==typeof exports?exports["react-world-flags"]=t(require("react")):a["react-world-flags"]=t(a.react)}(this,function(a){return function(a){var t={};function i(l){if(t[l])return t[l].exports;var e=t[l]={i:l,l:!1,exports:{}};return a[l].call(e.exports,e,e.exports,i),e.l=!0,e.exports}return i.m=a,i.c=t,i.d=function(a,t,l){i.o(a,t)||Object.defineProperty(a,t,{configurable:!1,enumerable:!0,get:l})},i.r=function(a){Object.defineProperty(a,"__esModule",{value:!0})},i.n=function(a){var t=a&&a.__esModule?function(){return a.default}:function(){return a};return i.d(t,"a",t),t},i.o=function(a,t){return Object.prototype.hasOwnProperty.call(a,t)},i.p="",i(i.s=259)}([function(a){a.exports=[{name:{common:"Aruba",official:"Aruba",native:{nld:{official:"Aruba",common:"Aruba"},pap:{official:"Aruba",common:"Aruba"}}},tld:[".aw"],cca2:"AW",ccn3:"533",cca3:"ABW",cioc:"ARU",independent:!1,status:"officially-assigned",currency:["AWG"],callingCode:["297"],capital:["Oranjestad"],altSpellings:["AW"],region:"Americas",subregion:"Caribbean",languages:{nld:"Dutch",pap:"Papiamento"},translations:{deu:{official:"Aruba",common:"Aruba"},fra:{official:"Aruba",common:"Aruba"},hrv:{official:"Aruba",common:"Aruba"},ita:{official:"Aruba",common:"Aruba"},jpn:{official:"アルバ",common:"アルバ"},nld:{official:"Aruba",common:"Aruba"},por:{official:"Aruba",common:"Aruba"},rus:{official:"Аруба",common:"Аруба"},slk:{official:"Aruba",common:"Aruba"},spa:{official:"Aruba",common:"Aruba"},fin:{official:"Aruba",common:"Aruba"},est:{official:"Aruba",common:"Aruba"},zho:{official:"阿鲁巴",common:"阿鲁巴"}},latlng:[12.5,-69.96666666],demonym:"Aruban",landlocked:!1,borders:[],area:180,flag:"🇦🇼"},{name:{common:"Afghanistan",official:"Islamic Republic of Afghanistan",native:{prs:{official:"جمهوری اسلامی افغانستان",common:"افغانستان"},pus:{official:"د افغانستان اسلامي جمهوریت",common:"افغانستان"},tuk:{official:"Owganystan Yslam Respublikasy",common:"Owganystan"}}},tld:[".af"],cca2:"AF",ccn3:"004",cca3:"AFG",cioc:"AFG",independent:!0,status:"officially-assigned",currency:["AFN"],callingCode:["93"],capital:["Kabul"],altSpellings:["AF","Afġānistān"],region:"Asia",subregion:"Southern Asia",languages:{prs:"Dari",pus:"Pashto",tuk:"Turkmen"},translations:{cym:{official:"Gweriniaeth Islamaidd Affganistan",common:"Affganistan"},deu:{official:"Islamische Republik Afghanistan",common:"Afghanistan"},fra:{official:"République islamique d'Afghanistan",common:"Afghanistan"},hrv:{official:"Islamska Republika Afganistan",common:"Afganistan"},ita:{official:"Repubblica islamica dell'Afghanistan",common:"Afghanistan"},jpn:{official:"アフガニスタン·イスラム共和国",common:"アフガニスタン"},nld:{official:"Islamitische Republiek Afghanistan",common:"Afghanistan"},por:{official:"República Islâmica do Afeganistão",common:"Afeganistão"},rus:{official:"Исламская Республика Афганистан",common:"Афганистан"},slk:{official:"Afgánsky islamský štát",common:"Afganistan"},spa:{official:"República Islámica de Afganistán",common:"Afganistán"},fin:{official:"Afganistanin islamilainen tasavalta",common:"Afganistan"},est:{official:"Afganistani Islamivabariik",common:"Afganistan"},zho:{official:"阿富汗伊斯兰共和国",common:"阿富汗"}},latlng:[33,65],demonym:"Afghan",landlocked:!0,borders:["IRN","PAK","TKM","UZB","TJK","CHN"],area:652230,flag:"🇦🇫"},{name:{common:"Angola",official:"Republic of Angola",native:{por:{official:"República de Angola",common:"Angola"}}},tld:[".ao"],cca2:"AO",ccn3:"024",cca3:"AGO",cioc:"ANG",independent:!0,status:"officially-assigned",currency:["AOA"],callingCode:["244"],capital:["Luanda"],altSpellings:["AO","República de Angola","ʁɛpublika de an'ɡɔla"],region:"Africa",subregion:"Middle Africa",languages:{por:"Portuguese"},translations:{cym:{official:"Gweriniaeth Angola",common:"Angola"},deu:{official:"Republik Angola",common:"Angola"},fra:{official:"République d'Angola",common:"Angola"},hrv:{official:"Republika Angola",common:"Angola"},ita:{official:"Repubblica dell'Angola",common:"Angola"},jpn:{official:"アンゴラ共和国",common:"アンゴラ"},nld:{official:"Republiek Angola",common:"Angola"},por:{official:"República de Angola",common:"Angola"},rus:{official:"Республика Ангола",common:"Ангола"},slk:{official:"Angolská republika",common:"Angola"},spa:{official:"República de Angola",common:"Angola"},fin:{official:"Angolan tasavalta",common:"Angola"},est:{official:"Angola Vabariik",common:"Angola"},zho:{official:"安哥拉共和国",common:"安哥拉"}},latlng:[-12.5,18.5],demonym:"Angolan",landlocked:!1,borders:["COG","COD","ZMB","NAM"],area:1246700,flag:"🇦🇴"},{name:{common:"Anguilla",official:"Anguilla",native:{eng:{official:"Anguilla",common:"Anguilla"}}},tld:[".ai"],cca2:"AI",ccn3:"660",cca3:"AIA",cioc:"",independent:!1,status:"officially-assigned",currency:["XCD"],callingCode:["1264"],capital:["The Valley"],altSpellings:["AI"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Anguilla",common:"Anguilla"},fra:{official:"Anguilla",common:"Anguilla"},hrv:{official:"Anguilla",common:"Angvila"},ita:{official:"Anguilla",common:"Anguilla"},jpn:{official:"アングィラ",common:"アンギラ"},nld:{official:"Anguilla",common:"Anguilla"},por:{official:"Anguilla",common:"Anguilla"},rus:{official:"Ангилья",common:"Ангилья"},slk:{official:"Anguilla",common:"Anguilla"},spa:{official:"Anguila",common:"Anguilla"},fin:{official:"Anguilla",common:"Anguilla"},est:{official:"Anguilla",common:"Anguilla"},zho:{official:"安圭拉",common:"安圭拉"}},latlng:[18.25,-63.16666666],demonym:"Anguillian",landlocked:!1,borders:[],area:91,flag:"🇦🇮"},{name:{common:"Åland Islands",official:"Åland Islands",native:{swe:{official:"Landskapet Åland",common:"Åland"}}},tld:[".ax"],cca2:"AX",ccn3:"248",cca3:"ALA",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["358"],capital:["Mariehamn"],altSpellings:["AX","Aaland","Aland","Ahvenanmaa"],region:"Europe",subregion:"Northern Europe",languages:{swe:"Swedish"},translations:{deu:{official:"Åland-Inseln",common:"Åland"},fra:{official:"Ahvenanmaa",common:"Ahvenanmaa"},hrv:{official:"Aland Islands",common:"Ålandski otoci"},ita:{official:"Isole Åland",common:"Isole Aland"},jpn:{official:"オーランド諸島",common:"オーランド諸島"},nld:{official:"Åland eilanden",common:"Ålandeilanden"},por:{official:"Ilhas Åland",common:"Alândia"},rus:{official:"Аландские острова",common:"Аландские острова"},slk:{official:"Alandské ostrovy",common:"Alandy"},spa:{official:"Islas Åland",common:"Alandia"},fin:{official:"Ahvenanmaan maakunta",common:"Ahvenanmaa"},est:{official:"Ahvenamaa maakond",common:"Ahvenamaa"},zho:{official:"奥兰群岛",common:"奥兰群岛"}},latlng:[60.116667,19.9],demonym:"Ålandish",landlocked:!1,borders:[],area:1580,flag:"🇦🇽"},{name:{common:"Albania",official:"Republic of Albania",native:{sqi:{official:"Republika e Shqipërisë",common:"Shqipëria"}}},tld:[".al"],cca2:"AL",ccn3:"008",cca3:"ALB",cioc:"ALB",independent:!0,status:"officially-assigned",currency:["ALL"],callingCode:["355"],capital:["Tirana"],altSpellings:["AL","Shqipëri","Shqipëria","Shqipnia"],region:"Europe",subregion:"Southern Europe",languages:{sqi:"Albanian"},translations:{cym:{official:"Gweriniaeth Albania",common:"Albania"},deu:{official:"Republik Albanien",common:"Albanien"},fra:{official:"République d'Albanie",common:"Albanie"},hrv:{official:"Republika Albanija",common:"Albanija"},ita:{official:"Repubblica d'Albania",common:"Albania"},jpn:{official:"アルバニア共和国",common:"アルバニア"},nld:{official:"Republiek Albanië",common:"Albanië"},por:{official:"República da Albânia",common:"Albânia"},rus:{official:"Республика Албания",common:"Албания"},slk:{official:"Albánska republika",common:"Albánsko"},spa:{official:"República de Albania",common:"Albania"},fin:{official:"Albanian tasavalta",common:"Albania"},est:{official:"Albaania Vabariik",common:"Albaania"},zho:{official:"阿尔巴尼亚共和国",common:"阿尔巴尼亚"}},latlng:[41,20],demonym:"Albanian",landlocked:!1,borders:["MNE","GRC","MKD","UNK"],area:28748,flag:"🇦🇱"},{name:{common:"Andorra",official:"Principality of Andorra",native:{cat:{official:"Principat d'Andorra",common:"Andorra"}}},tld:[".ad"],cca2:"AD",ccn3:"020",cca3:"AND",cioc:"AND",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["376"],capital:["Andorra la Vella"],altSpellings:["AD","Principality of Andorra","Principat d'Andorra"],region:"Europe",subregion:"Southern Europe",languages:{cat:"Catalan"},translations:{cym:{official:"Tywysogaeth Andorra",common:"Andorra"},deu:{official:"Fürstentum Andorra",common:"Andorra"},fra:{official:"Principauté d'Andorre",common:"Andorre"},hrv:{official:"Kneževina Andora",common:"Andora"},ita:{official:"Principato di Andorra",common:"Andorra"},jpn:{official:"アンドラ公国",common:"アンドラ"},nld:{official:"Prinsdom Andorra",common:"Andorra"},por:{official:"Principado de Andorra",common:"Andorra"},rus:{official:"Княжество Андорра",common:"Андорра"},slk:{official:"Andorrské kniežatstvo",common:"Andorra"},spa:{official:"Principado de Andorra",common:"Andorra"},fin:{official:"Andorran ruhtinaskunta",common:"Andorra"},est:{official:"Andorra Vürstiriik",common:"Andorra"},zho:{official:"安道尔公国",common:"安道尔"}},latlng:[42.5,1.5],demonym:"Andorran",landlocked:!0,borders:["FRA","ESP"],area:468,flag:"🇦🇩"},{name:{common:"United Arab Emirates",official:"United Arab Emirates",native:{ara:{official:"الإمارات العربية المتحدة",common:"دولة الإمارات العربية المتحدة"}}},tld:[".ae","امارات."],cca2:"AE",ccn3:"784",cca3:"ARE",cioc:"UAE",independent:!0,status:"officially-assigned",currency:["AED"],callingCode:["971"],capital:["Abu Dhabi"],altSpellings:["AE","UAE","Emirates"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Vereinigte Arabische Emirate",common:"Vereinigte Arabische Emirate"},fra:{official:"Émirats arabes unis",common:"Émirats arabes unis"},hrv:{official:"Ujedinjeni Arapski Emirati",common:"Ujedinjeni Arapski Emirati"},ita:{official:"Emirati Arabi Uniti",common:"Emirati Arabi Uniti"},jpn:{official:"アラブ首長国連邦",common:"アラブ首長国連邦"},nld:{official:"Verenigde Arabische Emiraten",common:"Verenigde Arabische Emiraten"},por:{official:"Emirados Árabes Unidos",common:"Emirados Árabes Unidos"},rus:{official:"Объединенные Арабские Эмираты",common:"Объединённые Арабские Эмираты"},slk:{official:"Spojené arabské emiráty",common:"Spojené arabské emiráty"},spa:{official:"Emiratos Árabes Unidos",common:"Emiratos Árabes Unidos"},fin:{official:"Yhdistyneet arabiemiirikunnat",common:"Arabiemiraatit"},est:{official:"Araabia Ühendemiraadid",common:"Araabia Ühendemiraadid"},zho:{official:"阿拉伯联合酋长国",common:"阿拉伯联合酋长国"}},latlng:[24,54],demonym:"Emirati",landlocked:!1,borders:["OMN","SAU"],area:83600,flag:"🇦🇪"},{name:{common:"Argentina",official:"Argentine Republic",native:{grn:{official:"Argentine Republic",common:"Argentina"},spa:{official:"República Argentina",common:"Argentina"}}},tld:[".ar"],cca2:"AR",ccn3:"032",cca3:"ARG",cioc:"ARG",independent:!0,status:"officially-assigned",currency:["ARS"],callingCode:["54"],capital:["Buenos Aires"],altSpellings:["AR","Argentine Republic","República Argentina"],region:"Americas",subregion:"South America",languages:{grn:"Guaraní",spa:"Spanish"},translations:{cym:{official:"Gweriniaeth yr Ariannin",common:"Ariannin"},deu:{official:"Argentinische Republik",common:"Argentinien"},fra:{official:"République argentine",common:"Argentine"},hrv:{official:"Argentinski Republika",common:"Argentina"},ita:{official:"Repubblica Argentina",common:"Argentina"},jpn:{official:"アルゼンチン共和国",common:"アルゼンチン"},nld:{official:"Argentijnse Republiek",common:"Argentinië"},por:{official:"República Argentina",common:"Argentina"},rus:{official:"Аргентинская Республика",common:"Аргентина"},slk:{official:"Argentínska republika",common:"Argentína"},spa:{official:"República Argentina",common:"Argentina"},fin:{official:"Argentiinan tasavalta",common:"Argentiina"},est:{official:"Argentina Vabariik",common:"Argentina"},zho:{official:"阿根廷共和国",common:"阿根廷"}},latlng:[-34,-64],demonym:"Argentine",landlocked:!1,borders:["BOL","BRA","CHL","PRY","URY"],area:2780400,flag:"🇦🇷"},{name:{common:"Armenia",official:"Republic of Armenia",native:{hye:{official:"Հայաստանի Հանրապետություն",common:"Հայաստան"}}},tld:[".am"],cca2:"AM",ccn3:"051",cca3:"ARM",cioc:"ARM",independent:!0,status:"officially-assigned",currency:["AMD"],callingCode:["374"],capital:["Yerevan"],altSpellings:["AM","Hayastan","Republic of Armenia","Հայաստանի Հանրապետություն"],region:"Asia",subregion:"Western Asia",languages:{hye:"Armenian"},translations:{cym:{official:"Gweriniaeth Armenia",common:"Armenia"},deu:{official:"Republik Armenien",common:"Armenien"},fra:{official:"République d'Arménie",common:"Arménie"},hrv:{official:"Republika Armenija",common:"Armenija"},ita:{official:"Repubblica di Armenia",common:"Armenia"},jpn:{official:"アルメニア共和国",common:"アルメニア"},nld:{official:"Republiek Armenië",common:"Armenië"},por:{official:"República da Arménia",common:"Arménia"},rus:{official:"Республика Армения",common:"Армения"},slk:{official:"Arménska republika",common:"Arménsko"},spa:{official:"República de Armenia",common:"Armenia"},fin:{official:"Armenian tasavalta",common:"Armenia"},est:{official:"Armeenia Vabariik",common:"Armeenia"},zho:{official:"亚美尼亚共和国",common:"亚美尼亚"}},latlng:[40,45],demonym:"Armenian",landlocked:!0,borders:["AZE","GEO","IRN","TUR"],area:29743,flag:"🇦🇲"},{name:{common:"American Samoa",official:"American Samoa",native:{eng:{official:"American Samoa",common:"American Samoa"},smo:{official:"Sāmoa Amelika",common:"Sāmoa Amelika"}}},tld:[".as"],cca2:"AS",ccn3:"016",cca3:"ASM",cioc:"ASA",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1684"],capital:["Pago Pago"],altSpellings:["AS","Amerika Sāmoa","Amelika Sāmoa","Sāmoa Amelika"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",smo:"Samoan"},translations:{deu:{official:"Amerikanisch-Samoa",common:"Amerikanisch-Samoa"},fra:{official:"Samoa américaines",common:"Samoa américaines"},hrv:{official:"američka Samoa",common:"Američka Samoa"},ita:{official:"Samoa americane",common:"Samoa Americane"},jpn:{official:"米サモア",common:"アメリカ領サモア"},nld:{official:"Amerikaans Samoa",common:"Amerikaans Samoa"},por:{official:"Samoa americana",common:"Samoa Americana"},rus:{official:"американское Самоа",common:"Американское Самоа"},slk:{official:"Americká Samoa",common:"Americká Samoa"},spa:{official:"Samoa Americana",common:"Samoa Americana"},fin:{official:"Amerikan Samoa",common:"Amerikan Samoa"},est:{official:"Ameerika Samoa",common:"Ameerika Samoa"},zho:{official:"美属萨摩亚",common:"美属萨摩亚"}},latlng:[-14.33333333,-170],demonym:"American Samoan",landlocked:!1,borders:[],area:199,flag:"🇦🇸"},{name:{common:"Antarctica",official:"Antarctica",native:{}},tld:[".aq"],cca2:"AQ",ccn3:"010",cca3:"ATA",cioc:"",independent:!1,status:"officially-assigned",currency:[],callingCode:[],capital:[""],altSpellings:["AQ"],region:"Antarctic",subregion:"",languages:{},translations:{cym:{official:"Yr Antarctig",common:"Yr Antarctig"},deu:{official:"Antarktika",common:"Antarktis"},fra:{official:"Antarctique",common:"Antarctique"},hrv:{official:"Antarktika",common:"Antarktika"},ita:{official:"Antartide",common:"Antartide"},jpn:{official:"南極大陸",common:"南極"},nld:{official:"Antarctica",common:"Antarctica"},por:{official:"Antártica",common:"Antártida"},rus:{official:"Антарктида",common:"Антарктида"},slk:{official:"Antarktída",common:"Antarktída"},spa:{official:"Antártida",common:"Antártida"},fin:{official:"Etelämanner",common:"Etelämanner"},est:{official:"Antarktika",common:"Antarktika"},zho:{official:"南极洲",common:"南极洲"}},latlng:[-90,0],demonym:"Antarctican",landlocked:!1,borders:[],area:14e6,flag:"🇦🇶"},{name:{common:"French Southern and Antarctic Lands",official:"Territory of the French Southern and Antarctic Lands",native:{fra:{official:"Territoire des Terres australes et antarctiques françaises",common:"Terres australes et antarctiques françaises"}}},tld:[".tf"],cca2:"TF",ccn3:"260",cca3:"ATF",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:[],capital:["Port-aux-Français"],altSpellings:["TF","French Southern Territories"],region:"Antarctic",subregion:"",languages:{fra:"French"},translations:{deu:{official:"Gebiet der Französisch Süd-und Antarktisgebiete",common:"Französische Süd-und Antarktisgebiete"},fra:{official:"Territoire des Terres australes et antarctiques françaises",common:"Terres australes et antarctiques françaises"},hrv:{official:"Teritoriju Francuski južni i antarktički teritoriji",common:"Francuski južni i antarktički teritoriji"},ita:{official:"Territorio della australi e antartiche francesi Terre",common:"Territori Francesi del Sud"},jpn:{official:"フランス領南方·南極地域の領土",common:"フランス領南方・南極地域"},nld:{official:"Grondgebied van de Franse Zuidelijke en Antarctische gebieden",common:"Franse Gebieden in de zuidelijke Indische Oceaan"},por:{official:"Território do Sul e Antártica Francesa",common:"Terras Austrais e Antárticas Francesas"},rus:{official:"Территория Французские Южные и Антарктические земли",common:"Французские Южные и Антарктические территории"},slk:{official:"Francúzske južné a antarktické územia",common:"Francúzske juŽné a antarktické územia"},spa:{official:"Territorio del Francés Tierras australes y antárticas",common:"Tierras Australes y Antárticas Francesas"},fin:{official:"Ranskan eteläiset ja antarktiset alueet",common:"Ranskan eteläiset ja antarktiset alueet"},est:{official:"Prantsuse Lõunaalad",common:"Prantsuse Lõunaalad"},zho:{official:"法国南部和南极土地",common:"法国南部和南极土地"}},latlng:[-49.25,69.167],demonym:"French",landlocked:!1,borders:[],area:7747,flag:"🇹🇫"},{name:{common:"Antigua and Barbuda",official:"Antigua and Barbuda",native:{eng:{official:"Antigua and Barbuda",common:"Antigua and Barbuda"}}},tld:[".ag"],cca2:"AG",ccn3:"028",cca3:"ATG",cioc:"ANT",independent:!0,status:"officially-assigned",currency:["XCD"],callingCode:["1268"],capital:["Saint John's"],altSpellings:["AG"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{cym:{official:"Antigwa a Barbiwda",common:"Antigwa a Barbiwda"},deu:{official:"Antigua und Barbuda",common:"Antigua und Barbuda"},fra:{official:"Antigua -et-Barbuda",common:"Antigua-et-Barbuda"},hrv:{official:"Antigva i Barbuda",common:"Antigva i Barbuda"},ita:{official:"Antigua e Barbuda",common:"Antigua e Barbuda"},jpn:{official:"アンチグアバーブーダ",common:"アンティグア・バーブーダ"},nld:{official:"Antigua en Barbuda",common:"Antigua en Barbuda"},por:{official:"Antigua e Barbuda",common:"Antígua e Barbuda"},rus:{official:"Антигуа и Барбуда",common:"Антигуа и Барбуда"},slk:{official:"Antigua a Barbuda",common:"Antigua a Barbuda"},spa:{official:"Antigua y Barbuda",common:"Antigua y Barbuda"},fin:{official:"Antigua ja Barbuda",common:"Antigua ja Barbuda"},est:{official:"Antigua ja Barbuda",common:"Antigua ja Barbuda"},zho:{official:"安提瓜和巴布达",common:"安提瓜和巴布达"}},latlng:[17.05,-61.8],demonym:"Antiguan, Barbudan",landlocked:!1,borders:[],area:442,flag:"🇦🇬"},{name:{common:"Australia",official:"Commonwealth of Australia",native:{eng:{official:"Commonwealth of Australia",common:"Australia"}}},tld:[".au"],cca2:"AU",ccn3:"036",cca3:"AUS",cioc:"AUS",independent:!0,status:"officially-assigned",currency:["AUD"],callingCode:["61"],capital:["Canberra"],altSpellings:["AU"],region:"Oceania",subregion:"Australia and New Zealand",languages:{eng:"English"},translations:{cym:{official:"Cymanwlad Awstralia",common:"Awstralia"},deu:{official:"Commonwealth Australien",common:"Australien"},fra:{official:"Australie",common:"Australie"},hrv:{official:"Commonwealth of Australia",common:"Australija"},ita:{official:"Commonwealth dell'Australia",common:"Australia"},jpn:{official:"オーストラリア連邦",common:"オーストラリア"},nld:{official:"Gemenebest van Australië",common:"Australië"},por:{official:"Comunidade da Austrália",common:"Austrália"},rus:{official:"Содружество Австралии",common:"Австралия"},slk:{official:"Austrálsky zväz",common:"Austrália"},spa:{official:"Mancomunidad de Australia",common:"Australia"},fin:{official:"Australian liittovaltio",common:"Australia"},est:{official:"Austraalia Ühendus",common:"Austraalia"},zho:{official:"澳大利亚联邦",common:"澳大利亚"}},latlng:[-27,133],demonym:"Australian",landlocked:!1,borders:[],area:7692024,flag:"🇦🇺"},{name:{common:"Austria",official:"Republic of Austria",native:{bar:{official:"Republik Österreich",common:"Österreich"}}},tld:[".at"],cca2:"AT",ccn3:"040",cca3:"AUT",cioc:"AUT",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["43"],capital:["Vienna"],altSpellings:["AT","Osterreich","Oesterreich"],region:"Europe",subregion:"Western Europe",languages:{bar:"Austro-Bavarian German"},translations:{cym:{official:"Gweriniaeth Awstria",common:"Awstria"},deu:{official:"Republik Österreich",common:"Österreich"},fra:{official:"République d'Autriche",common:"Autriche"},hrv:{official:"Republika Austrija",common:"Austrija"},ita:{official:"Repubblica d'Austria",common:"Austria"},jpn:{official:"オーストリア共和国",common:"オーストリア"},nld:{official:"Republiek Oostenrijk",common:"Oostenrijk"},por:{official:"República da Áustria",common:"Áustria"},rus:{official:"Австрийская Республика",common:"Австрия"},slk:{official:"Rakúska republika",common:"Rakúsko"},spa:{official:"República de Austria",common:"Austria"},fin:{official:"Itävallan tasavalta",common:"Itävalta"},est:{official:"Austria Vabariik",common:"Austria"},zho:{official:"奥地利共和国",common:"奥地利"}},latlng:[47.33333333,13.33333333],demonym:"Austrian",landlocked:!0,borders:["CZE","DEU","HUN","ITA","LIE","SVK","SVN","CHE"],area:83871,flag:"🇦🇹"},{name:{common:"Azerbaijan",official:"Republic of Azerbaijan",native:{aze:{official:"Azərbaycan Respublikası",common:"Azərbaycan"},rus:{official:"Азербайджанская Республика",common:"Азербайджан"}}},tld:[".az"],cca2:"AZ",ccn3:"031",cca3:"AZE",cioc:"AZE",independent:!0,status:"officially-assigned",currency:["AZN"],callingCode:["994"],capital:["Baku"],altSpellings:["AZ","Republic of Azerbaijan","Azərbaycan Respublikası"],region:"Asia",subregion:"Western Asia",languages:{aze:"Azerbaijani",rus:"Russian"},translations:{cym:{official:"Gweriniaeth Aserbaijan",common:"Aserbaijan"},deu:{official:"Republik Aserbaidschan",common:"Aserbaidschan"},fra:{official:"République d'Azerbaïdjan",common:"Azerbaïdjan"},hrv:{official:"Republika Azerbajdžan",common:"Azerbajdžan"},ita:{official:"Repubblica dell'Azerbaigian",common:"Azerbaijan"},jpn:{official:"アゼルバイジャン共和国",common:"アゼルバイジャン"},nld:{official:"Republiek Azerbeidzjan",common:"Azerbeidzjan"},por:{official:"República do Azerbaijão",common:"Azerbeijão"},rus:{official:"Азербайджанская Республика",common:"Азербайджан"},slk:{official:"Azerbajǆanská republika",common:"AzerbajǇan"},spa:{official:"República de Azerbaiyán",common:"Azerbaiyán"},fin:{official:"Azerbaidzanin tasavalta",common:"Azerbaidzan"},est:{official:"Aserbaidžaani Vabariik",common:"Aserbaidžaan"},zho:{official:"阿塞拜疆共和国",common:"阿塞拜疆"}},latlng:[40.5,47.5],demonym:"Azerbaijani",landlocked:!0,borders:["ARM","GEO","IRN","RUS","TUR"],area:86600,flag:"🇦🇿"},{name:{common:"Burundi",official:"Republic of Burundi",native:{fra:{official:"République du Burundi",common:"Burundi"},run:{official:"Republika y'Uburundi ",common:"Uburundi"}}},tld:[".bi"],cca2:"BI",ccn3:"108",cca3:"BDI",cioc:"BDI",independent:!0,status:"officially-assigned",currency:["BIF"],callingCode:["257"],capital:["Bujumbura"],altSpellings:["BI","Republic of Burundi","Republika y'Uburundi","République du Burundi"],region:"Africa",subregion:"Eastern Africa",languages:{fra:"French",run:"Kirundi"},translations:{cym:{official:"Gweriniaeth Bwrwndi",common:"Bwrwndi"},deu:{official:"Republik Burundi",common:"Burundi"},fra:{official:"République du Burundi",common:"Burundi"},hrv:{official:"Burundi",common:"Burundi"},ita:{official:"Repubblica del Burundi",common:"Burundi"},jpn:{official:"ブルンジ共和国",common:"ブルンジ"},nld:{official:"Republiek Burundi",common:"Burundi"},por:{official:"República do Burundi",common:"Burundi"},rus:{official:"Республика Бурунди",common:"Бурунди"},slk:{official:"Burundská republika",common:"Burundi"},spa:{official:"República de Burundi",common:"Burundi"},fin:{official:"Burundin tasavalta",common:"Burundi"},est:{official:"Burundi Vabariik",common:"Burundi"},zho:{official:"布隆迪共和国",common:"布隆迪"}},latlng:[-3.5,30],demonym:"Burundian",landlocked:!0,borders:["COD","RWA","TZA"],area:27834,flag:"🇧🇮"},{name:{common:"Belgium",official:"Kingdom of Belgium",native:{deu:{official:"Königreich Belgien",common:"Belgien"},fra:{official:"Royaume de Belgique",common:"Belgique"},nld:{official:"Koninkrijk België",common:"België"}}},tld:[".be"],cca2:"BE",ccn3:"056",cca3:"BEL",cioc:"BEL",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["32"],capital:["Brussels"],altSpellings:["BE","België","Belgie","Belgien","Belgique","Kingdom of Belgium","Koninkrijk België","Royaume de Belgique","Königreich Belgien"],region:"Europe",subregion:"Western Europe",languages:{deu:"German",fra:"French",nld:"Dutch"},translations:{cym:{official:"Teyrnas Gwlad Belg",common:"Gwlad Belg"},deu:{official:"Königreich Belgien",common:"Belgien"},fra:{official:"Royaume de Belgique",common:"Belgique"},hrv:{official:"Kraljevina Belgija",common:"Belgija"},ita:{official:"Regno del Belgio",common:"Belgio"},jpn:{official:"ベルギー王国",common:"ベルギー"},nld:{official:"Koninkrijk België",common:"België"},por:{official:"Reino da Bélgica",common:"Bélgica"},rus:{official:"Королевство Бельгия",common:"Бельгия"},slk:{official:"Belgické kráľovstvo",common:"Belgicko"},spa:{official:"Reino de Bélgica",common:"Bélgica"},fin:{official:"Belgian kuningaskunta",common:"Belgia"},est:{official:"Belgia Kuningriik",common:"Belgia"},zho:{official:"比利时王国",common:"比利时"}},latlng:[50.83333333,4],demonym:"Belgian",landlocked:!1,borders:["FRA","DEU","LUX","NLD"],area:30528,flag:"🇧🇪"},{name:{common:"Benin",official:"Republic of Benin",native:{fra:{official:"République du Bénin",common:"Bénin"}}},tld:[".bj"],cca2:"BJ",ccn3:"204",cca3:"BEN",cioc:"BEN",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["229"],capital:["Porto-Novo"],altSpellings:["BJ","Republic of Benin","République du Bénin"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{cym:{official:"Gweriniaeth Benin",common:"Benin"},deu:{official:"Republik Benin",common:"Benin"},fra:{official:"République du Bénin",common:"Bénin"},hrv:{official:"Republika Benin",common:"Benin"},ita:{official:"Repubblica del Benin",common:"Benin"},jpn:{official:"ベナン共和国",common:"ベナン"},nld:{official:"Republiek Benin",common:"Benin"},por:{official:"República do Benin",common:"Benin"},rus:{official:"Республика Бенин",common:"Бенин"},slk:{official:"Beninská republika",common:"Benin"},spa:{official:"República de Benin",common:"Benín"},fin:{official:"Beninin tasavalta",common:"Benin"},est:{official:"Benini Vabariik",common:"Benin"},zho:{official:"贝宁共和国",common:"贝宁"}},latlng:[9.5,2.25],demonym:"Beninese",landlocked:!1,borders:["BFA","NER","NGA","TGO"],area:112622,flag:"🇧🇯"},{name:{common:"Burkina Faso",official:"Burkina Faso",native:{fra:{official:"République du Burkina",common:"Burkina Faso"}}},tld:[".bf"],cca2:"BF",ccn3:"854",cca3:"BFA",cioc:"BUR",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["226"],capital:["Ouagadougou"],altSpellings:["BF"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{cym:{official:"Bwrcina Ffaso",common:"Bwrcina Ffaso"},deu:{official:"Burkina Faso",common:"Burkina Faso"},fra:{official:"République du Burkina",common:"Burkina Faso"},hrv:{official:"Burkina Faso",common:"Burkina Faso"},ita:{official:"Burkina Faso",common:"Burkina Faso"},jpn:{official:"ブルキナファソ",common:"ブルキナファソ"},nld:{official:"Burkina Faso",common:"Burkina Faso"},por:{official:"Burkina Faso",common:"Burkina Faso"},rus:{official:"Буркина -Фасо",common:"Буркина-Фасо"},slk:{official:"Burkina Faso",common:"Burkina Faso"},spa:{official:"Burkina Faso",common:"Burkina Faso"},fin:{official:"Burkina Faso",common:"Burkina Faso"},est:{official:"Burkina Faso",common:"Burkina Faso"},zho:{official:"布基纳法索",common:"布基纳法索"}},latlng:[13,-2],demonym:"Burkinabe",landlocked:!0,borders:["BEN","CIV","GHA","MLI","NER","TGO"],area:272967,flag:"🇧🇫"},{name:{common:"Bangladesh",official:"People's Republic of Bangladesh",native:{ben:{official:"বাংলাদেশ গণপ্রজাতন্ত্রী",common:"বাংলাদেশ"}}},tld:[".bd"],cca2:"BD",ccn3:"050",cca3:"BGD",cioc:"BAN",independent:!0,status:"officially-assigned",currency:["BDT"],callingCode:["880"],capital:["Dhaka"],altSpellings:["BD","People's Republic of Bangladesh","Gônôprôjatôntri Bangladesh"],region:"Asia",subregion:"Southern Asia",languages:{ben:"Bengali"},translations:{cym:{official:"Gweriniaeth Pobl Bangladesh",common:"Bangladesh"},deu:{official:"Volksrepublik Bangladesch",common:"Bangladesch"},fra:{official:"La République populaire du Bangladesh",common:"Bangladesh"},hrv:{official:"Narodna Republika Bangladeš",common:"Bangladeš"},ita:{official:"Repubblica popolare del Bangladesh",common:"Bangladesh"},jpn:{official:"バングラデシュ人民共和国",common:"バングラデシュ"},nld:{official:"Volksrepubliek Bangladesh",common:"Bangladesh"},por:{official:"República Popular do Bangladesh",common:"Bangladesh"},rus:{official:"Народная Республика Бангладеш",common:"Бангладеш"},slk:{official:"Bangladéšska ľudová republika",common:"Bangladéš"},spa:{official:"República Popular de Bangladesh",common:"Bangladesh"},fin:{official:"Bangladeshin kansantasavalta",common:"Bangladesh"},est:{official:"Bangladeshi Rahvavabariik",common:"Bangladesh"},zho:{official:"孟加拉人民共和国",common:"孟加拉国"}},latlng:[24,90],demonym:"Bangladeshi",landlocked:!1,borders:["MMR","IND"],area:147570,flag:"🇧🇩"},{name:{common:"Bulgaria",official:"Republic of Bulgaria",native:{bul:{official:"Република България",common:"България"}}},tld:[".bg"],cca2:"BG",ccn3:"100",cca3:"BGR",cioc:"BUL",independent:!0,status:"officially-assigned",currency:["BGN"],callingCode:["359"],capital:["Sofia"],altSpellings:["BG","Republic of Bulgaria","Република България"],region:"Europe",subregion:"Eastern Europe",languages:{bul:"Bulgarian"},translations:{cym:{official:"Gweriniaeth Bwlgaria",common:"Bwlgaria"},deu:{official:"Republik Bulgarien",common:"Bulgarien"},fra:{official:"République de Bulgarie",common:"Bulgarie"},hrv:{official:"Republika Bugarska",common:"Bugarska"},ita:{official:"Repubblica di Bulgaria",common:"Bulgaria"},jpn:{official:"ブルガリア共和国",common:"ブルガリア"},nld:{official:"Republiek Bulgarije",common:"Bulgarije"},por:{official:"República da Bulgária",common:"Bulgária"},rus:{official:"Республика Болгария",common:"Болгария"},slk:{official:"Bulharská republika",common:"Bulharsko"},spa:{official:"República de Bulgaria",common:"Bulgaria"},fin:{official:"Bulgarian tasavalta",common:"Bulgaria"},est:{official:"Bulgaaria Vabariik",common:"Bulgaaria"},zho:{official:"保加利亚共和国",common:"保加利亚"}},latlng:[43,25],demonym:"Bulgarian",landlocked:!1,borders:["GRC","MKD","ROU","SRB","TUR"],area:110879,flag:"🇧🇬"},{name:{common:"Bahrain",official:"Kingdom of Bahrain",native:{ara:{official:"مملكة البحرين",common:"‏البحرين"}}},tld:[".bh"],cca2:"BH",ccn3:"048",cca3:"BHR",cioc:"BRN",independent:!0,status:"officially-assigned",currency:["BHD"],callingCode:["973"],capital:["Manama"],altSpellings:["BH","Kingdom of Bahrain","Mamlakat al-Baḥrayn"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{cym:{official:"Teyrnas Bahrein",common:"Bahrain"},deu:{official:"Königreich Bahrain",common:"Bahrain"},fra:{official:"Royaume de Bahreïn",common:"Bahreïn"},hrv:{official:"Kraljevina Bahrein",common:"Bahrein"},ita:{official:"Regno del Bahrain",common:"Bahrein"},jpn:{official:"バーレーン王国",common:"バーレーン"},nld:{official:"Koninkrijk Bahrein",common:"Bahrein"},por:{official:"Reino do Bahrein",common:"Bahrein"},rus:{official:"Королевство Бахрейн",common:"Бахрейн"},slk:{official:"Bahrajnské kráľovstvo",common:"Bahrajn"},spa:{official:"Reino de Bahrein",common:"Bahrein"},fin:{official:"Bahrainin kuningaskunta",common:"Bahrain"},est:{official:"Bahreini Kuningriik",common:"Bahrein"},zho:{official:"巴林王国",common:"巴林"}},latlng:[26,50.55],demonym:"Bahraini",landlocked:!1,borders:[],area:765,flag:"🇧🇭"},{name:{common:"Bahamas",official:"Commonwealth of the Bahamas",native:{eng:{official:"Commonwealth of the Bahamas",common:"Bahamas"}}},tld:[".bs"],cca2:"BS",ccn3:"044",cca3:"BHS",cioc:"BAH",independent:!0,status:"officially-assigned",currency:["BSD"],callingCode:["1242"],capital:["Nassau"],altSpellings:["BS","Commonwealth of the Bahamas"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{cym:{official:"Cymanwlad y Bahamas",common:"Bahamas"},deu:{official:"Commonwealth der Bahamas",common:"Bahamas"},fra:{official:"Commonwealth des Bahamas",common:"Bahamas"},hrv:{official:"Zajednica Bahama",common:"Bahami"},ita:{official:"Commonwealth delle Bahamas",common:"Bahamas"},jpn:{official:"バハマ",common:"バハマ"},nld:{official:"Gemenebest van de Bahama's",common:"Bahama’s"},por:{official:"Comunidade das Bahamas",common:"Bahamas"},rus:{official:"Содружество Багамских Островов",common:"Багамские Острова"},slk:{official:"Bahamské spoločenstvo",common:"Bahamy"},spa:{official:"Commonwealth de las Bahamas",common:"Bahamas"},fin:{official:"Bahaman liittovaltio",common:"Bahamasaaret"},est:{official:"Bahama Ühendus",common:"Bahama"},zho:{official:"巴哈马联邦",common:"巴哈马"}},latlng:[24.25,-76],demonym:"Bahamian",landlocked:!1,borders:[],area:13943,flag:"🇧🇸"},{name:{common:"Bosnia and Herzegovina",official:"Bosnia and Herzegovina",native:{bos:{official:"Bosna i Hercegovina",common:"Bosna i Hercegovina"},hrv:{official:"Bosna i Hercegovina",common:"Bosna i Hercegovina"},srp:{official:"Боснa и Херцеговина",common:"Боснa и Херцеговина"}}},tld:[".ba"],cca2:"BA",ccn3:"070",cca3:"BIH",cioc:"BIH",independent:!0,status:"officially-assigned",currency:["BAM"],callingCode:["387"],capital:["Sarajevo"],altSpellings:["BA","Bosnia-Herzegovina","Босна и Херцеговина"],region:"Europe",subregion:"Southern Europe",languages:{bos:"Bosnian",hrv:"Croatian",srp:"Serbian"},translations:{cym:{official:"Bosnia a Hercegovina",common:"Bosnia a Hercegovina"},deu:{official:"Bosnien und Herzegowina",common:"Bosnien und Herzegowina"},fra:{official:"Bosnie-et-Herzégovine",common:"Bosnie-Herzégovine"},hrv:{official:"Bosna i Hercegovina",common:"Bosna i Hercegovina"},ita:{official:"Bosnia-Erzegovina",common:"Bosnia ed Erzegovina"},jpn:{official:"ボスニア·ヘルツェゴビナ",common:"ボスニア・ヘルツェゴビナ"},nld:{official:"Bosnië-Herzegovina",common:"Bosnië en Herzegovina"},por:{official:"Bósnia e Herzegovina",common:"Bósnia e Herzegovina"},rus:{official:"Босния и Герцеговина",common:"Босния и Герцеговина"},slk:{official:"Republika Bosny a Hercegoviny",common:"Bosna a Hercegovina"},spa:{official:"Bosnia y Herzegovina",common:"Bosnia y Herzegovina"},fin:{official:"Bosnia ja Hertsegovina",common:"Bosnia ja Hertsegovina"},est:{official:"Bosnia ja Hertsegoviina",common:"Bosnia ja Hertsegoviina"},zho:{official:"波斯尼亚和黑塞哥维那",common:"波斯尼亚和黑塞哥维那"}},latlng:[44,18],demonym:"Bosnian, Herzegovinian",landlocked:!1,borders:["HRV","MNE","SRB"],area:51209,flag:"🇧🇦"},{name:{common:"Saint Barthélemy",official:"Collectivity of Saint Barthélemy",native:{fra:{official:"Collectivité de Saint-Barthélemy",common:"Saint-Barthélemy"}}},tld:[".bl"],cca2:"BL",ccn3:"652",cca3:"BLM",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["590"],capital:["Gustavia"],altSpellings:["BL","St. Barthelemy","Collectivity of Saint Barthélemy","Collectivité de Saint-Barthélemy"],region:"Americas",subregion:"Caribbean",languages:{fra:"French"},translations:{deu:{official:"Gebietskörperschaft Saint -Barthélemy",common:"Saint-Barthélemy"},fra:{official:"Collectivité de Saint-Barthélemy",common:"Saint-Barthélemy"},hrv:{official:"Kolektivnost sv Barthélemy",common:"Saint Barthélemy"},ita:{official:"Collettività di Saint Barthélemy",common:"Antille Francesi"},jpn:{official:"サン·バルテルミー島の集合体",common:"サン・バルテルミー"},nld:{official:"Gemeenschap Saint Barthélemy",common:"Saint Barthélemy"},por:{official:"Coletividade de Saint Barthélemy",common:"São Bartolomeu"},rus:{official:"Коллективность Санкт -Бартельми",common:"Сен-Бартелеми"},slk:{official:"Svätý Bartolomej",common:"Svätý Bartolomej"},spa:{official:"Colectividad de San Barthélemy",common:"San Bartolomé"},fin:{official:"Saint-Barthélemyn yhteisö",common:"Saint-Barthélemy"},est:{official:"Saint-Barthélemy territoriaalühendus",common:"Saint-Barthélemy"},zho:{official:"圣巴泰勒米集体",common:"圣巴泰勒米"}},latlng:[18.5,-63.41666666],demonym:"Saint Barthélemy Islander",landlocked:!1,borders:[],area:21,flag:"🇧🇱"},{name:{common:"Saint Helena, Ascension and Tristan da Cunha",official:"Saint Helena, Ascension and Tristan da Cunha",native:{eng:{official:"Saint Helena, Ascension and Tristan da Cunha",common:"Saint Helena, Ascension and Tristan da Cunha"}}},tld:[".sh",".ac"],cca2:"SH",ccn3:"654",cca3:"SHN",cioc:"",independent:!1,status:"officially-assigned",currency:["SHP","GBP"],callingCode:["290","247"],capital:["Jamestown"],altSpellings:["Saint Helena","St. Helena, Ascension and Tristan da Cunha"],region:"Africa",subregion:"Western Africa",languages:{eng:"English"},translations:{deu:{official:"Sankt Helena, Ascension und Tristan da Cunha",common:"St. Helena, Ascension und Tristan da Cunha"},fra:{official:"Sainte-Hélène, Ascension et Tristan da Cunha",common:"Sainte-Hélène, Ascension et Tristan da Cunha"},hrv:{official:"Sveta Helena",common:"Sveta Helena"},ita:{official:"Sant'Elena, Ascensione e Tristan da Cunha",common:"Sant'Elena, Ascensione e Tristan da Cunha"},jpn:{official:"セントヘレナ・アセンションおよびトリスタンダクーニャ",common:"セントヘレナ・アセンションおよびトリスタンダクーニャ"},nld:{official:"Sint-Helena, Ascension en Tristan da Cunha",common:"Sint-Helena, Ascension en Tristan da Cunha"},por:{official:"Santa Helena, Ascensão e Tristão da Cunha",common:"Santa Helena, Ascensão e Tristão da Cunha"},rus:{official:"Острова Святой Елены, Вознесения и Тристан-да-Кунья",common:"Острова Святой Елены, Вознесения и Тристан-да-Кунья"},slk:{official:"Svätá Helena (zámorské územie)",common:"Svätá Helena (zámorské územie)"},spa:{official:"Santa Elena, Ascensión y Tristán de Acuña",common:"Santa Elena, Ascensión y Tristán de Acuña"},fin:{official:"Saint Helena, Ascension ja Tristan da Cunha",common:"Saint Helena, Ascension ja Tristan da Cunha"},est:{official:"Saint Helena, Ascension ja Tristan da Cunha",common:"Saint Helena, Ascension ja Tristan da Cunha"},zho:{official:"圣赫勒拿、阿森松和特里斯坦-达库尼亚",common:"圣赫勒拿、阿森松和特里斯坦-达库尼亚"}},latlng:[-15.95,-5.72],demonym:"Saint Helenian",landlocked:!1,borders:[],area:394,flag:"🇸🇭"},{name:{common:"Belarus",official:"Republic of Belarus",native:{bel:{official:"Рэспубліка Беларусь",common:"Белару́сь"},rus:{official:"Республика Беларусь",common:"Беларусь"}}},tld:[".by"],cca2:"BY",ccn3:"112",cca3:"BLR",cioc:"BLR",independent:!0,status:"officially-assigned",currency:["BYN"],callingCode:["375"],capital:["Minsk"],altSpellings:["BY","Bielaruś","Republic of Belarus","Белоруссия","Республика Белоруссия"],region:"Europe",subregion:"Eastern Europe",languages:{bel:"Belarusian",rus:"Russian"},translations:{cym:{official:"Gweriniaeth Belarws",common:"Belarws"},deu:{official:"Republik Belarus",common:"Weißrussland"},fra:{official:"République de Biélorussie",common:"Biélorussie"},hrv:{official:"Republika Bjelorusija",common:"Bjelorusija"},ita:{official:"Repubblica di Belarus",common:"Bielorussia"},jpn:{official:"ベラルーシ共和国",common:"ベラルーシ"},nld:{official:"Republiek Belarus",common:"Wit-Rusland"},por:{official:"República da Bielorrússia",common:"Bielorússia"},rus:{official:"Республика Беларусь",common:"Беларусь"},slk:{official:"Bieloruská republika",common:"Bielorusko"},spa:{official:"República de Belarús",common:"Bielorrusia"},fin:{official:"Valko-Venäjän tasavalta",common:"Valko-Venäjä"},est:{official:"Valgevene Vabariik",common:"Valgevene"},zho:{official:"白俄罗斯共和国",common:"白俄罗斯"}},latlng:[53,28],demonym:"Belarusian",landlocked:!0,borders:["LVA","LTU","POL","RUS","UKR"],area:207600,flag:"🇧🇾"},{name:{common:"Belize",official:"Belize",native:{bjz:{official:"Belize",common:"Belize"},eng:{official:"Belize",common:"Belize"},spa:{official:"Belice",common:"Belice"}}},tld:[".bz"],cca2:"BZ",ccn3:"084",cca3:"BLZ",cioc:"BIZ",independent:!0,status:"officially-assigned",currency:["BZD"],callingCode:["501"],capital:["Belmopan"],altSpellings:["BZ"],region:"Americas",subregion:"Central America",languages:{bjz:"Belizean Creole",eng:"English",spa:"Spanish"},translations:{cym:{official:"Belîs",common:"Belîs"},deu:{official:"Belize",common:"Belize"},fra:{official:"Belize",common:"Belize"},hrv:{official:"Belize",common:"Belize"},ita:{official:"Belize",common:"Belize"},jpn:{official:"ベリーズ",common:"ベリーズ"},nld:{official:"Belize",common:"Belize"},por:{official:"Belize",common:"Belize"},rus:{official:"Белиз",common:"Белиз"},slk:{official:"Belize",common:"Belize"},spa:{official:"Belice",common:"Belice"},fin:{official:"Belize",common:"Belize"},est:{official:"Belize",common:"Belize"},zho:{official:"伯利兹",common:"伯利兹"}},latlng:[17.25,-88.75],demonym:"Belizean",landlocked:!1,borders:["GTM","MEX"],area:22966,flag:"🇧🇿"},{name:{common:"Bermuda",official:"Bermuda",native:{eng:{official:"Bermuda",common:"Bermuda"}}},tld:[".bm"],cca2:"BM",ccn3:"060",cca3:"BMU",cioc:"BER",independent:!1,status:"officially-assigned",currency:["BMD"],callingCode:["1441"],capital:["Hamilton"],altSpellings:["BM","The Islands of Bermuda","The Bermudas","Somers Isles"],region:"Americas",subregion:"Northern America",languages:{eng:"English"},translations:{cym:{official:"Bermiwda",common:"Bermiwda"},deu:{official:"Bermuda",common:"Bermuda"},fra:{official:"Bermudes",common:"Bermudes"},hrv:{official:"Bermuda",common:"Bermudi"},ita:{official:"Bermuda",common:"Bermuda"},jpn:{official:"バミューダ",common:"バミューダ"},nld:{official:"Bermuda",common:"Bermuda"},por:{official:"Bermudas",common:"Bermudas"},rus:{official:"Бермудские острова",common:"Бермудские Острова"},slk:{official:"Bermudy",common:"Bermudy"},spa:{official:"Bermuda",common:"Bermudas"},fin:{official:"Bermuda",common:"Bermuda"},est:{official:"Bermuda",common:"Bermuda"},zho:{official:"百慕大",common:"百慕大"}},latlng:[32.33333333,-64.75],demonym:"Bermudian",landlocked:!1,borders:[],area:54,flag:"🇧🇲"},{name:{common:"Bolivia",official:"Plurinational State of Bolivia",native:{aym:{official:"Wuliwya Suyu",common:"Wuliwya"},grn:{official:"Tetã Volívia",common:"Volívia"},que:{official:"Buliwya Mamallaqta",common:"Buliwya"},spa:{official:"Estado Plurinacional de Bolivia",common:"Bolivia"}}},tld:[".bo"],cca2:"BO",ccn3:"068",cca3:"BOL",cioc:"BOL",independent:!0,status:"officially-assigned",currency:["BOB","BOV"],callingCode:["591"],capital:["Sucre"],altSpellings:["BO","Buliwya","Wuliwya","Bolivia, Plurinational State of","Plurinational State of Bolivia","Estado Plurinacional de Bolivia","Buliwya Mamallaqta","Wuliwya Suyu","Tetã Volívia"],region:"Americas",subregion:"South America",languages:{aym:"Aymara",grn:"Guaraní",que:"Quechua",spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Bolifia",common:"Bolifia"},deu:{official:"Multinationaler Staat von Bolivien",common:"Bolivien"},fra:{official:"État plurinational de Bolivie",common:"Bolivie"},hrv:{official:"Plurinational State of Bolivia",common:"Bolivija"},ita:{official:"Stato Plurinazionale della Bolivia",common:"Bolivia"},jpn:{official:"ボリビアの多民族国",common:"ボリビア多民族国"},nld:{official:"Plurinationale Staat van Bolivia",common:"Bolivia"},por:{official:"Estado Plurinacional da Bolívia",common:"Bolívia"},rus:{official:"Многонациональное Государство Боливия",common:"Боливия"},slk:{official:"Bolívijská republika",common:"Bolívia"},spa:{official:"Estado Plurinacional de Bolivia",common:"Bolivia"},fin:{official:"Bolivian monikansainen valtio",common:"Bolivia"},est:{official:"Boliivia Paljurahvuseline Riik",common:"Boliivia"},zho:{official:"多民族玻利维亚国",common:"玻利维亚"}},latlng:[-17,-65],demonym:"Bolivian",landlocked:!0,borders:["ARG","BRA","CHL","PRY","PER"],area:1098581,flag:"🇧🇴"},{name:{common:"Caribbean Netherlands",official:"Bonaire, Sint Eustatius and Saba",native:{nld:{official:"Bonaire, Sint Eustatius en Saba",common:"Caribisch Nederland"},pap:{official:"Boneiru, Sint Eustatius y Saba",common:"Boneiru, Sint Eustatius y Saba"}}},tld:[".bq",".nl"],cca2:"BQ",ccn3:"535",cca3:"BES",cioc:"",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["599"],capital:[],altSpellings:["BES islands"],region:"Americas",subregion:"Caribbean",languages:{eng:"English",nld:"Dutch",pap:"Papiamento"},translations:{deu:{official:"Besonderen Gemeinden der Niederlande",common:"Karibische Niederlande"},fra:{official:"Bonaire, Saint-Eustache et Saba",common:"Pays-Bas caribéens"},hrv:{official:"Bonaire, Sint Eustatius i Saba",common:"Bonaire, Sint Eustatius i Saba"},ita:{official:"Bonaire, Sint Eustatius e Saba",common:"Paesi Bassi caraibici"},jpn:{official:"ボネール、シント・ユースタティウスおよびサバ",common:"ボネール、シント・ユースタティウスおよびサバ"},nld:{official:"Bonaire, Sint Eustatius en Saba",common:"Caribisch Nederland"},por:{official:"Bonaire, Saba e Santo Eustáquio",common:"Países Baixos Caribenhos"},rus:{official:"Бонэйр, Синт-Эстатиус и Саба",common:"Карибские Нидерланды"},slk:{official:"Bonaire, Sint Eustatius a Saba",common:"Bonaire, Sint Eustatius a Saba"},spa:{official:"Bonaire, San Eustaquio y Saba",common:"Caribe Neerlandés"},fin:{official:"Bonaire, Sint Eustatius ja Saba",common:"Bonaire, Sint Eustatius ja Saba"},est:{official:"Bonaire, Sint Eustatius ja Saba",common:"Bonaire, Sint Eustatius ja Saba"},zho:{official:"荷蘭加勒比區",common:"荷蘭加勒比區"}},latlng:[12.18,-68.25],demonym:"Dutch",landlocked:!1,borders:[],area:328,flag:""},{name:{common:"Brazil",official:"Federative Republic of Brazil",native:{por:{official:"República Federativa do Brasil",common:"Brasil"}}},tld:[".br"],cca2:"BR",ccn3:"076",cca3:"BRA",cioc:"BRA",independent:!0,status:"officially-assigned",currency:["BRL"],callingCode:["55"],capital:["Brasília"],altSpellings:["BR","Brasil","Federative Republic of Brazil","República Federativa do Brasil"],region:"Americas",subregion:"South America",languages:{por:"Portuguese"},translations:{cym:{official:"Gweriniaeth Ffederal Brasil",common:"Brasil"},deu:{official:"Föderative Republik Brasilien",common:"Brasilien"},fra:{official:"République fédérative du Brésil",common:"Brésil"},hrv:{official:"Savezne Republike Brazil",common:"Brazil"},ita:{official:"Repubblica federativa del Brasile",common:"Brasile"},jpn:{official:"ブラジル連邦共和国",common:"ブラジル"},nld:{official:"Federale Republiek Brazilië",common:"Brazilië"},por:{official:"República Federativa do Brasil",common:"Brasil"},rus:{official:"Федеративная Республика Бразилия",common:"Бразилия"},slk:{official:"Brazílska federatívna republika",common:"Brazília"},spa:{official:"República Federativa del Brasil",common:"Brasil"},fin:{official:"Brasilian liittotasavalta",common:"Brasilia"},est:{official:"Brasiilia Liitvabariik",common:"Brasiilia"},zho:{official:"巴西联邦共和国",common:"巴西"}},latlng:[-10,-55],demonym:"Brazilian",landlocked:!1,borders:["ARG","BOL","COL","GUF","GUY","PRY","PER","SUR","URY","VEN"],area:8515767,flag:"🇧🇷"},{name:{common:"Barbados",official:"Barbados",native:{eng:{official:"Barbados",common:"Barbados"}}},tld:[".bb"],cca2:"BB",ccn3:"052",cca3:"BRB",cioc:"BAR",independent:!0,status:"officially-assigned",currency:["BBD"],callingCode:["1246"],capital:["Bridgetown"],altSpellings:["BB"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{cym:{official:"Barbados",common:"Barbados"},deu:{official:"Barbados",common:"Barbados"},fra:{official:"Barbade",common:"Barbade"},hrv:{official:"Barbados",common:"Barbados"},ita:{official:"Barbados",common:"Barbados"},jpn:{official:"バルバドス",common:"バルバドス"},nld:{official:"Barbados",common:"Barbados"},por:{official:"Barbados",common:"Barbados"},rus:{official:"Барбадос",common:"Барбадос"},slk:{official:"Barbados",common:"Barbados"},spa:{official:"Barbados",common:"Barbados"},fin:{official:"Barbados",common:"Barbados"},est:{official:"Barbados",common:"Barbados"},zho:{official:"巴巴多斯",common:"巴巴多斯"}},latlng:[13.16666666,-59.53333333],demonym:"Barbadian",landlocked:!1,borders:[],area:430,flag:"🇧🇧"},{name:{common:"Brunei",official:"Nation of Brunei, Abode of Peace",native:{msa:{official:"Nation of Brunei, Abode Damai",common:"Negara Brunei Darussalam"}}},tld:[".bn"],cca2:"BN",ccn3:"096",cca3:"BRN",cioc:"BRU",independent:!0,status:"officially-assigned",currency:["BND"],callingCode:["673"],capital:["Bandar Seri Begawan"],altSpellings:["BN","Brunei Darussalam","Nation of Brunei","the Abode of Peace"],region:"Asia",subregion:"South-Eastern Asia",languages:{msa:"Malay"},translations:{cym:{official:"Teyrnas Brwnei",common:"Brunei"},deu:{official:"Nation von Brunei, Wohnung des Friedens",common:"Brunei"},fra:{official:"État de Brunei Darussalam",common:"Brunei"},hrv:{official:"Nacija od Bruneja, Kuću Mira",common:"Brunej"},ita:{official:"Nazione di Brunei, Dimora della Pace",common:"Brunei"},jpn:{official:"ブルネイ、平和の精舎の国家",common:"ブルネイ・ダルサラーム"},nld:{official:"Natie van Brunei, de verblijfplaats van de Vrede",common:"Brunei"},por:{official:"Nação do Brunei, Morada da Paz",common:"Brunei"},rus:{official:"Нация Бруней, обитель мира",common:"Бруней"},slk:{official:"Brunejský sultanât",common:"Brunej"},spa:{official:"Nación de Brunei, Morada de la Paz",common:"Brunei"},fin:{official:"Brunei Darussalamin valtio",common:"Brunei"},est:{official:"Brunei Darussalami Riik",common:"Brunei"},zho:{official:"文莱和平之国",common:"文莱"}},latlng:[4.5,114.66666666],demonym:"Bruneian",landlocked:!1,borders:["MYS"],area:5765,flag:"🇧🇳"},{name:{common:"Bhutan",official:"Kingdom of Bhutan",native:{dzo:{official:"འབྲུག་རྒྱལ་ཁབ་",common:"འབྲུག་ཡུལ་"}}},tld:[".bt"],cca2:"BT",ccn3:"064",cca3:"BTN",cioc:"BHU",independent:!0,status:"officially-assigned",currency:["BTN","INR"],callingCode:["975"],capital:["Thimphu"],altSpellings:["BT","Kingdom of Bhutan"],region:"Asia",subregion:"Southern Asia",languages:{dzo:"Dzongkha"},translations:{cym:{official:"Teyrnas Bhwtan",common:"Bhwtan"},deu:{official:"Königreich Bhutan",common:"Bhutan"},fra:{official:"Royaume du Bhoutan",common:"Bhoutan"},hrv:{official:"Kraljevina Butan",common:"Butan"},ita:{official:"Regno del Bhutan",common:"Bhutan"},jpn:{official:"ブータン王国",common:"ブータン"},nld:{official:"Koninkrijk Bhutan",common:"Bhutan"},por:{official:"Reino do Butão",common:"Butão"},rus:{official:"Королевство Бутан",common:"Бутан"},slk:{official:"Bhutánske krâľovstvo",common:"Bhután"},spa:{official:"Reino de Bután",common:"Bután"},fin:{official:"Bhutanin kuningaskunta",common:"Bhutan"},est:{official:"Bhutani Kuningriik",common:"Bhutan"},zho:{official:"不丹王国",common:"不丹"}},latlng:[27.5,90.5],demonym:"Bhutanese",landlocked:!0,borders:["CHN","IND"],area:38394,flag:"🇧🇹"},{name:{common:"Bouvet Island",official:"Bouvet Island",native:{nor:{official:"Bouvetøya",common:"Bouvetøya"}}},tld:[".bv"],cca2:"BV",ccn3:"074",cca3:"BVT",cioc:"",independent:!1,status:"officially-assigned",currency:["NOK"],callingCode:[],capital:[""],altSpellings:["BV","Bouvetøya","Bouvet-øya"],region:"Antarctic",subregion:"",languages:{nor:"Norwegian"},translations:{deu:{official:"Bouvet-Insel",common:"Bouvetinsel"},fra:{official:"Île Bouvet",common:"Île Bouvet"},hrv:{official:"Bouvet Island",common:"Otok Bouvet"},ita:{official:"Isola Bouvet",common:"Isola Bouvet"},jpn:{official:"ブーヴェ島",common:"ブーベ島"},nld:{official:"Bouvet Island",common:"Bouveteiland"},por:{official:"Ilha Bouvet",common:"Ilha Bouvet"},rus:{official:"Остров Буве",common:"Остров Буве"},slk:{official:"Bouvetov ostrov",common:"Bouvetov ostrov"},spa:{official:"Isla Bouvet",common:"Isla Bouvet"},fin:{official:"Bouvet'nsaari",common:"Bouvet'nsaari"},est:{official:"Bouvet’ saar",common:"Bouvet’ saar"},zho:{official:"布维岛",common:"布维岛"}},latlng:[-54.43333333,3.4],demonym:"",landlocked:!1,borders:[],area:49,flag:"🇧🇻"},{name:{common:"Botswana",official:"Republic of Botswana",native:{eng:{official:"Republic of Botswana",common:"Botswana"},tsn:{official:"Lefatshe la Botswana",common:"Botswana"}}},tld:[".bw"],cca2:"BW",ccn3:"072",cca3:"BWA",cioc:"BOT",independent:!0,status:"officially-assigned",currency:["BWP"],callingCode:["267"],capital:["Gaborone"],altSpellings:["BW","Republic of Botswana","Lefatshe la Botswana"],region:"Africa",subregion:"Southern Africa",languages:{eng:"English",tsn:"Tswana"},translations:{deu:{official:"Republik Botsuana",common:"Botswana"},fra:{official:"République du Botswana",common:"Botswana"},hrv:{official:"Republika Bocvana",common:"Bocvana"},ita:{official:"Repubblica del Botswana",common:"Botswana"},jpn:{official:"ボツワナ共和国",common:"ボツワナ"},nld:{official:"Republiek Botswana",common:"Botswana"},por:{official:"República do Botswana",common:"Botswana"},rus:{official:"Республика Ботсвана",common:"Ботсвана"},slk:{official:"Botswanská republika",common:"Botswana"},spa:{official:"República de Botswana",common:"Botswana"},fin:{official:"Botswanan tasavalta",common:"Botswana"},est:{official:"Botswana Vabariik",common:"Botswana"},zho:{official:"博茨瓦纳共和国",common:"博茨瓦纳"}},latlng:[-22,24],demonym:"Motswana",landlocked:!0,borders:["NAM","ZAF","ZMB","ZWE"],area:582e3,flag:"🇧🇼"},{name:{common:"Central African Republic",official:"Central African Republic",native:{fra:{official:"République centrafricaine",common:"République centrafricaine"},sag:{official:"Ködörösêse tî Bêafrîka",common:"Bêafrîka"}}},tld:[".cf"],cca2:"CF",ccn3:"140",cca3:"CAF",cioc:"CAF",independent:!0,status:"officially-assigned",currency:["XAF"],callingCode:["236"],capital:["Bangui"],altSpellings:["CF","Central African Republic","République centrafricaine"],region:"Africa",subregion:"Middle Africa",languages:{fra:"French",sag:"Sango"},translations:{cym:{official:"Gweriniaeth Canolbarth Affrica",common:"Gweriniaeth Canolbarth Affrica"},deu:{official:"Zentralafrikanische Republik",common:"Zentralafrikanische Republik"},fra:{official:"République centrafricaine",common:"République centrafricaine"},hrv:{official:"Centralna Afrička Republika",common:"Srednjoafrička Republika"},ita:{official:"Repubblica Centrafricana",common:"Repubblica Centrafricana"},jpn:{official:"中央アフリカ共和国",common:"中央アフリカ共和国"},nld:{official:"Centraal-Afrikaanse Republiek",common:"Centraal-Afrikaanse Republiek"},por:{official:"República Centro-Africano",common:"República Centro-Africana"},rus:{official:"Центрально-Африканская Республика",common:"Центральноафриканская Республика"},slk:{official:"Stredoafrická republika",common:"Stredoafrická republika"},spa:{official:"República Centroafricana",common:"República Centroafricana"},fin:{official:"Keski-Afrikan tasavalta",common:"Keski-Afrikan tasavalta"},est:{official:"Kesk-Aafrika Vabariik",common:"Kesk-Aafrika Vabariik"},zho:{official:"中非共和国",common:"中非共和国"}},latlng:[7,21],demonym:"Central African",landlocked:!0,borders:["CMR","TCD","COD","COG","SSD","SDN"],area:622984,flag:"🇨🇫"},{name:{common:"Canada",official:"Canada",native:{eng:{official:"Canada",common:"Canada"},fra:{official:"Canada",common:"Canada"}}},tld:[".ca"],cca2:"CA",ccn3:"124",cca3:"CAN",cioc:"CAN",independent:!0,status:"officially-assigned",currency:["CAD"],callingCode:["1"],capital:["Ottawa"],altSpellings:["CA"],region:"Americas",subregion:"Northern America",languages:{eng:"English",fra:"French"},translations:{cym:{official:"Canada",common:"Canada"},deu:{official:"Kanada",common:"Kanada"},fra:{official:"Canada",common:"Canada"},hrv:{official:"Kanada",common:"Kanada"},ita:{official:"Canada",common:"Canada"},jpn:{official:"カナダ",common:"カナダ"},nld:{official:"Canada",common:"Canada"},por:{official:"Canadá",common:"Canadá"},rus:{official:"Канада",common:"Канада"},slk:{official:"Kanada",common:"Kanada"},spa:{official:"Canadá",common:"Canadá"},fin:{official:"Kanada",common:"Kanada"},est:{official:"Kanada",common:"Kanada"},zho:{official:"加拿大",common:"加拿大"}},latlng:[60,-95],demonym:"Canadian",landlocked:!1,borders:["USA"],area:9984670,flag:"🇨🇦"},{name:{common:"Cocos (Keeling) Islands",official:"Territory of the Cocos (Keeling) Islands",native:{eng:{official:"Territory of the Cocos (Keeling) Islands",common:"Cocos (Keeling) Islands"}}},tld:[".cc"],cca2:"CC",ccn3:"166",cca3:"CCK",cioc:"",independent:!1,status:"officially-assigned",currency:["AUD"],callingCode:["61"],capital:["West Island"],altSpellings:["CC","Keeling Islands","Cocos Islands"],region:"Oceania",subregion:"Australia and New Zealand",languages:{eng:"English"},translations:{cym:{official:"Tiriogaeth yr Ynysoedd Cocos (Keeling)",common:"Ynysoedd Cocos"},deu:{official:"Gebiet der Cocos (Keeling) Islands",common:"Kokosinseln"},fra:{official:"Territoire des îles Cocos (Keeling)",common:"Îles Cocos"},hrv:{official:"Teritoriju Kokosovi (Keeling) Islands",common:"Kokosovi Otoci"},ita:{official:"Territorio della (Keeling) Isole Cocos",common:"Isole Cocos e Keeling"},jpn:{official:"ココス諸島の領土",common:"ココス（キーリング）諸島"},nld:{official:"Grondgebied van de Eilanden Cocos (Keeling )",common:"Cocoseilanden"},por:{official:"Território dos Cocos (Keeling)",common:"Ilhas Cocos (Keeling)"},rus:{official:"Территория Кокосовые (Килинг) острова",common:"Кокосовые острова"},slk:{official:"Kokosové ostrovy",common:"Kokosové ostrovy"},spa:{official:"Territorio de los (Keeling) Islas Cocos",common:"Islas Cocos o Islas Keeling"},fin:{official:"Kookossaaret",common:"Kookossaaret"},est:{official:"Kookossaarte ala",common:"Kookossaared"},zho:{official:"科科斯",common:"科科斯"}},latlng:[-12.5,96.83333333],demonym:"Cocos Islander",landlocked:!1,borders:[],area:14,flag:"🇨🇨"},{name:{common:"Switzerland",official:"Swiss Confederation",native:{fra:{official:"Confédération suisse",common:"Suisse"},gsw:{official:"Schweizerische Eidgenossenschaft",common:"Schweiz"},ita:{official:"Confederazione Svizzera",common:"Svizzera"},roh:{official:"Confederaziun svizra",common:"Svizra"}}},tld:[".ch"],cca2:"CH",ccn3:"756",cca3:"CHE",cioc:"SUI",independent:!0,status:"officially-assigned",currency:["CHE","CHF","CHW"],callingCode:["41"],capital:["Bern"],altSpellings:["CH","Swiss Confederation","Schweiz","Suisse","Svizzera","Svizra"],region:"Europe",subregion:"Western Europe",languages:{fra:"French",gsw:"Swiss German",ita:"Italian",roh:"Romansh"},translations:{deu:{official:"Schweizerische Eidgenossenschaft",common:"Schweiz"},fra:{official:"Confédération suisse",common:"Suisse"},hrv:{official:"švicarska Konfederacija",common:"Švicarska"},ita:{official:"Confederazione svizzera",common:"Svizzera"},jpn:{official:"スイス連邦",common:"スイス"},nld:{official:"Zwitserse Confederatie",common:"Zwitserland"},por:{official:"Confederação Suíça",common:"Suíça"},rus:{official:"Швейцарская Конфедерация",common:"Швейцария"},slk:{official:"Švajčiarska konfederácia",common:"Švajčiarsko"},spa:{official:"Confederación Suiza",common:"Suiza"},fin:{official:"Sveitsin valaliitto",common:"Sveitsi"},est:{official:"Šveitsi Konföderatsioon",common:"Šveits"},zho:{official:"瑞士联邦",common:"瑞士"}},latlng:[47,8],demonym:"Swiss",landlocked:!0,borders:["AUT","FRA","ITA","LIE","DEU"],area:41284,flag:"🇨🇭"},{name:{common:"Chile",official:"Republic of Chile",native:{spa:{official:"República de Chile",common:"Chile"}}},tld:[".cl"],cca2:"CL",ccn3:"152",cca3:"CHL",cioc:"CHI",independent:!0,status:"officially-assigned",currency:["CLF","CLP"],callingCode:["56"],capital:["Santiago"],altSpellings:["CL","Republic of Chile","República de Chile"],region:"Americas",subregion:"South America",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Chile",common:"Chile"},deu:{official:"Republik Chile",common:"Chile"},fra:{official:"République du Chili",common:"Chili"},hrv:{official:"Republika Čile",common:"Čile"},ita:{official:"Repubblica del Cile",common:"Cile"},jpn:{official:"チリ共和国",common:"チリ"},nld:{official:"Republiek Chili",common:"Chili"},por:{official:"República do Chile",common:"Chile"},rus:{official:"Республика Чили",common:"Чили"},slk:{official:"Čílska republika",common:"Čile"},spa:{official:"República de Chile",common:"Chile"},fin:{official:"Chilen tasavalta",common:"Chile"},est:{official:"Tšiili Vabariik",common:"Tšiili"},zho:{official:"智利共和国",common:"智利"}},latlng:[-30,-71],demonym:"Chilean",landlocked:!1,borders:["ARG","BOL","PER"],area:756102,flag:"🇨🇱"},{name:{common:"China",official:"People's Republic of China",native:{zho:{official:"中华人民共和国",common:"中国"}}},tld:[".cn",".中国",".中國",".公司",".网络"],cca2:"CN",ccn3:"156",cca3:"CHN",cioc:"CHN",independent:!0,status:"officially-assigned",currency:["CNY"],callingCode:["86"],capital:["Beijing"],altSpellings:["CN","Zhōngguó","Zhongguo","Zhonghua","People's Republic of China","中华人民共和国","Zhōnghuá Rénmín Gònghéguó"],region:"Asia",subregion:"Eastern Asia",languages:{zho:"Chinese"},translations:{cym:{official:"Gweriniaeth Pobl Tsieina",common:"Tsieina"},deu:{official:"Volksrepublik China",common:"China"},fra:{official:"République populaire de Chine",common:"Chine"},hrv:{official:"Narodna Republika Kina",common:"Kina"},ita:{official:"Repubblica popolare cinese",common:"Cina"},jpn:{official:"中華人民共和国",common:"中国"},nld:{official:"Volksrepubliek China",common:"China"},por:{official:"República Popular da China",common:"China"},rus:{official:"Народная Республика Китай",common:"Китай"},slk:{official:"Čínska ľudová republika",common:"Čína"},spa:{official:"República Popular de China",common:"China"},fin:{official:"Kiinan kansantasavalta",common:"Kiina"},est:{official:"Hiina Rahvavabariik",common:"Hiina"}},latlng:[35,105],demonym:"Chinese",landlocked:!1,borders:["AFG","BTN","MMR","HKG","IND","KAZ","NPL","PRK","KGZ","LAO","MAC","MNG","PAK","RUS","TJK","VNM"],area:9706961,flag:"🇨🇳"},{name:{common:"Ivory Coast",official:"Republic of Côte d'Ivoire",native:{fra:{official:"République de Côte d'Ivoire",common:"Côte d'Ivoire"}}},tld:[".ci"],cca2:"CI",ccn3:"384",cca3:"CIV",cioc:"CIV",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["225"],capital:["Yamoussoukro"],altSpellings:["CI","Côte d'Ivoire","Ivory Coast","Republic of Côte d'Ivoire","République de Côte d'Ivoire"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{deu:{official:"Republik Côte d'Ivoire",common:"Elfenbeinküste"},fra:{official:"République de Côte d' Ivoire",common:"Côte d'Ivoire"},hrv:{official:"Republika Côte d'Ivoire",common:"Obala Bjelokosti"},ita:{official:"Repubblica della Costa d'Avorio",common:"Costa d'Avorio"},jpn:{official:"コートジボワール共和国",common:"コートジボワール"},nld:{official:"Republiek Ivoorkust",common:"Ivoorkust"},por:{official:"República da Côte d'Ivoire",common:"Costa do Marfim"},rus:{official:"Республика Кот-д'Ивуаре",common:"Кот-д’Ивуар"},slk:{official:"Republika Pobrežie Slonoviny",common:"Pobržie Slonoviny"},spa:{official:"República de Côte d'Ivoire",common:"Costa de Marfil"},fin:{official:"Norsunluurannikon tasavalta",common:"Norsunluurannikko"},est:{official:"Côte d’Ivoire’i Vabariik",common:"Elevandiluurannik"},zho:{official:"科特迪瓦共和国",common:"科特迪瓦"}},latlng:[8,-5],demonym:"Ivorian",landlocked:!1,borders:["BFA","GHA","GIN","LBR","MLI"],area:322463,flag:"🇨🇮"},{name:{common:"Cameroon",official:"Republic of Cameroon",native:{eng:{official:"Republic of Cameroon",common:"Cameroon"},fra:{official:"République du Cameroun",common:"Cameroun"}}},tld:[".cm"],cca2:"CM",ccn3:"120",cca3:"CMR",cioc:"CMR",independent:!0,status:"officially-assigned",currency:["XAF"],callingCode:["237"],capital:["Yaoundé"],altSpellings:["CM","Republic of Cameroon","République du Cameroun"],region:"Africa",subregion:"Middle Africa",languages:{eng:"English",fra:"French"},translations:{cym:{official:"Gweriniaeth Camerŵn",common:"Camerŵn"},deu:{official:"Republik Kamerun",common:"Kamerun"},fra:{official:"République du Cameroun",common:"Cameroun"},hrv:{official:"Republika Kamerun",common:"Kamerun"},ita:{official:"Repubblica del Camerun",common:"Camerun"},jpn:{official:"カメルーン共和国",common:"カメルーン"},nld:{official:"Republiek Kameroen",common:"Kameroen"},por:{official:"República dos Camarões",common:"Camarões"},rus:{official:"Республика Камерун",common:"Камерун"},slk:{official:"Kamerunská republika",common:"Kamerun"},spa:{official:"República de Camerún",common:"Camerún"},fin:{official:"Kamerunin tasavalta",common:"Kamerun"},est:{official:"Kameruni Vabariik",common:"Kamerun"},zho:{official:"喀麦隆共和国",common:"喀麦隆"}},latlng:[6,12],demonym:"Cameroonian",landlocked:!1,borders:["CAF","TCD","COG","GNQ","GAB","NGA"],area:475442,flag:"🇨🇲"},{name:{common:"DR Congo",official:"Democratic Republic of the Congo",native:{fra:{official:"République démocratique du Congo",common:"RD Congo"},kon:{official:"Repubilika ya Kongo Demokratiki",common:"Repubilika ya Kongo Demokratiki"},lin:{official:"Republiki ya Kongó Demokratiki",common:"Republiki ya Kongó Demokratiki"},lua:{official:"Ditunga dia Kongu wa Mungalaata",common:"Ditunga dia Kongu wa Mungalaata"},swa:{official:"Jamhuri ya Kidemokrasia ya Kongo",common:"Jamhuri ya Kidemokrasia ya Kongo"}}},tld:[".cd"],cca2:"CD",ccn3:"180",cca3:"COD",cioc:"COD",independent:!0,status:"officially-assigned",currency:["CDF"],callingCode:["243"],capital:["Kinshasa"],altSpellings:["CD","DR Congo","Congo-Kinshasa","Congo, the Democratic Republic of the","DRC"],region:"Africa",subregion:"Middle Africa",languages:{fra:"French",kon:"Kikongo",lin:"Lingala",lua:"Tshiluba",swa:"Swahili"},translations:{cym:{official:"Gweriniaeth Ddemocrataidd Congo",common:"Gweriniaeth Ddemocrataidd Congo"},deu:{official:"Demokratische Republik Kongo",common:"Kongo (Dem. Rep.)"},fra:{official:"République démocratique du Congo",common:"Congo (Rép. dém.)"},hrv:{official:"Demokratska Republika Kongo",common:"Kongo, Demokratska Republika"},ita:{official:"Repubblica Democratica del Congo",common:"Congo (Rep. Dem.)"},jpn:{official:"コンゴ民主共和国",common:"コンゴ民主共和国"},nld:{official:"Democratische Republiek Congo",common:"Congo (DRC)"},por:{official:"República Democrática do Congo",common:"República Democrática do Congo"},rus:{official:"Демократическая Республика Конго",common:"Демократическая Республика Конго"},slk:{official:"Konžská demokratická republika",common:"Kongo"},spa:{official:"República Democrática del Congo",common:"Congo (Rep. Dem.)"},fin:{official:"Kongon demokraattinen tasavalta",common:"Kongon demokraattinen tasavalta"},est:{official:"Kongo Demokraatlik Vabariik",common:"Kongo DV"},zho:{official:"刚果民主共和国",common:"民主刚果"}},latlng:[0,25],demonym:"Congolese",landlocked:!1,borders:["AGO","BDI","CAF","COG","RWA","SSD","TZA","UGA","ZMB"],area:2344858,flag:"🇨🇩"},{name:{common:"Republic of the Congo",official:"Republic of the Congo",native:{fra:{official:"République du Congo",common:"République du Congo"},kon:{official:"Repubilika ya Kongo",common:"Repubilika ya Kongo"},lin:{official:"Republíki ya Kongó",common:"Republíki ya Kongó"}}},tld:[".cg"],cca2:"CG",ccn3:"178",cca3:"COG",cioc:"CGO",independent:!0,status:"officially-assigned",currency:["XAF"],callingCode:["242"],capital:["Brazzaville"],altSpellings:["CG","Congo","Congo-Brazzaville"],region:"Africa",subregion:"Middle Africa",languages:{fra:"French",kon:"Kikongo",lin:"Lingala"},translations:{cym:{official:"Gweriniaeth y Congo",common:"Gweriniaeth y Congo"},deu:{official:"Republik Kongo",common:"Kongo"},fra:{official:"République du Congo",common:"Congo"},hrv:{official:"Republika Kongo",common:"Kongo"},ita:{official:"Repubblica del Congo",common:"Congo"},jpn:{official:"コンゴ共和国",common:"コンゴ共和国"},nld:{official:"Republiek Congo",common:"Congo"},por:{official:"República do Congo",common:"Congo"},rus:{official:"Республика Конго",common:"Республика Конго"},slk:{official:"Konžská republika",common:"Kongo"},spa:{official:"República del Congo",common:"Congo"},fin:{official:"Kongon tasavalta",common:"Kongo-Brazzaville"},est:{official:"Kongo Vabariik",common:"Kongo Vabariik"},zho:{official:"刚果共和国",common:"刚果"}},latlng:[-1,15],demonym:"Congolese",landlocked:!1,borders:["AGO","CMR","CAF","COD","GAB"],area:342e3,flag:"🇨🇬"},{name:{common:"Cook Islands",official:"Cook Islands",native:{eng:{official:"Cook Islands",common:"Cook Islands"},rar:{official:"Kūki 'Āirani",common:"Kūki 'Āirani"}}},tld:[".ck"],cca2:"CK",ccn3:"184",cca3:"COK",cioc:"COK",independent:!1,status:"officially-assigned",currency:["NZD","CKD"],callingCode:["682"],capital:["Avarua"],altSpellings:["CK","Kūki 'Āirani"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",rar:"Cook Islands Māori"},translations:{cym:{official:"Ynysoedd Cook",common:"Ynysoedd Cook"},deu:{official:"Cook-Inseln",common:"Cookinseln"},fra:{official:"Îles Cook",common:"Îles Cook"},hrv:{official:"Cook Islands",common:"Cookovo Otočje"},ita:{official:"Isole Cook",common:"Isole Cook"},jpn:{official:"クック諸島",common:"クック諸島"},nld:{official:"Cook eilanden",common:"Cookeilanden"},por:{official:"Ilhas Cook",common:"Ilhas Cook"},rus:{official:"острова Кука",common:"Острова Кука"},slk:{official:"Cookove ostrovy",common:"Cookove ostrovy"},spa:{official:"Islas Cook",common:"Islas Cook"},fin:{official:"Cookinsaaret",common:"Cookinsaaret"},est:{official:"Cooki saared",common:"Cooki saared"},zho:{official:"库克群岛",common:"库克群岛"}},latlng:[-21.23333333,-159.76666666],demonym:"Cook Islander",landlocked:!1,borders:[],area:236,flag:"🇨🇰"},{name:{common:"Colombia",official:"Republic of Colombia",native:{spa:{official:"República de Colombia",common:"Colombia"}}},tld:[".co"],cca2:"CO",ccn3:"170",cca3:"COL",cioc:"COL",independent:!0,status:"officially-assigned",currency:["COP"],callingCode:["57"],capital:["Bogotá"],altSpellings:["CO","Republic of Colombia","República de Colombia"],region:"Americas",subregion:"South America",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Colombia",common:"Colombia"},deu:{official:"Republik Kolumbien",common:"Kolumbien"},fra:{official:"République de Colombie",common:"Colombie"},hrv:{official:"Republika Kolumbija",common:"Kolumbija"},ita:{official:"Repubblica di Colombia",common:"Colombia"},jpn:{official:"コロンビア共和国",common:"コロンビア"},nld:{official:"Republiek Colombia",common:"Colombia"},por:{official:"República da Colômbia",common:"Colômbia"},rus:{official:"Республика Колумбия",common:"Колумбия"},slk:{official:"Kolumbijská republika",common:"Kolumbia"},spa:{official:"República de Colombia",common:"Colombia"},fin:{official:"Kolumbian tasavalta",common:"Kolumbia"},est:{official:"Colombia Vabariik",common:"Colombia"},zho:{official:"哥伦比亚共和国",common:"哥伦比亚"}},latlng:[4,-72],demonym:"Colombian",landlocked:!1,borders:["BRA","ECU","PAN","PER","VEN"],area:1141748,flag:"🇨🇴"},{name:{common:"Comoros",official:"Union of the Comoros",native:{ara:{official:"الاتحاد القمري",common:"القمر‎"},fra:{official:"Union des Comores",common:"Comores"},zdj:{official:"Udzima wa Komori",common:"Komori"}}},tld:[".km"],cca2:"KM",ccn3:"174",cca3:"COM",cioc:"COM",independent:!0,status:"officially-assigned",currency:["KMF"],callingCode:["269"],capital:["Moroni"],altSpellings:["KM","Union of the Comoros","Union des Comores","Udzima wa Komori","al-Ittiḥād al-Qumurī"],region:"Africa",subregion:"Eastern Africa",languages:{ara:"Arabic",fra:"French",zdj:"Comorian"},translations:{cym:{official:"Undeb y Comoros",common:"Y Comoros"},deu:{official:"Union der Komoren",common:"Union der Komoren"},fra:{official:"Union des Comores",common:"Comores"},hrv:{official:"Savez Komori",common:"Komori"},ita:{official:"Unione delle Comore",common:"Comore"},jpn:{official:"コモロ連合",common:"コモロ"},nld:{official:"Unie van de Comoren",common:"Comoren"},por:{official:"União das Comores",common:"Comores"},rus:{official:"Союз Коморских Островов",common:"Коморы"},slk:{official:"Komorská únia",common:"Komory"},spa:{official:"Unión de las Comoras",common:"Comoras"},fin:{official:"Komorien liitto",common:"Komorit"},est:{official:"Komoori Liit",common:"Komoorid"},zho:{official:"科摩罗联盟",common:"科摩罗"}},latlng:[-12.16666666,44.25],demonym:"Comoran",landlocked:!1,borders:[],area:1862,flag:"🇰🇲"},{name:{common:"Cape Verde",official:"Republic of Cabo Verde",native:{por:{official:"República de Cabo Verde",common:"Cabo Verde"}}},tld:[".cv"],cca2:"CV",ccn3:"132",cca3:"CPV",cioc:"CPV",independent:!0,status:"officially-assigned",currency:["CVE"],callingCode:["238"],capital:["Praia"],altSpellings:["CV","Republic of Cabo Verde","República de Cabo Verde"],region:"Africa",subregion:"Western Africa",languages:{por:"Portuguese"},translations:{cym:{official:"Gweriniaeth Cabo Verde",common:"Penrhyn Verde"},deu:{official:"Republik Cabo Verde",common:"Kap Verde"},fra:{official:"République du Cap-Vert",common:"Îles du Cap-Vert"},hrv:{official:"Republika Cabo Verde",common:"Zelenortska Republika"},ita:{official:"Repubblica di Capo Verde",common:"Capo Verde"},jpn:{official:"カーボベルデ共和国",common:"カーボベルデ"},nld:{official:"Republiek van Cabo Verde",common:"Kaapverdië"},por:{official:"República de Cabo Verde",common:"Cabo Verde"},rus:{official:"Республика Кабо -Верде",common:"Кабо-Верде"},slk:{official:"Kapverdská republika",common:"Kapverdy"},spa:{official:"República de Cabo Verde",common:"Cabo Verde"},fin:{official:"Kap Verden tasavalta",common:"Kap Verde"},est:{official:"Cabo Verde Vabariik",common:"Roheneemesaared"},zho:{official:"佛得角共和国",common:"佛得角"}},latlng:[16,-24],demonym:"Cape Verdian",landlocked:!1,borders:[],area:4033,flag:"🇨🇻"},{name:{common:"Costa Rica",official:"Republic of Costa Rica",native:{spa:{official:"República de Costa Rica",common:"Costa Rica"}}},tld:[".cr"],cca2:"CR",ccn3:"188",cca3:"CRI",cioc:"CRC",independent:!0,status:"officially-assigned",currency:["CRC"],callingCode:["506"],capital:["San José"],altSpellings:["CR","Republic of Costa Rica","República de Costa Rica"],region:"Americas",subregion:"Central America",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Costa Rica",common:"Costa Rica"},deu:{official:"Republik Costa Rica",common:"Costa Rica"},fra:{official:"République du Costa Rica",common:"Costa Rica"},hrv:{official:"Republika Kostarika",common:"Kostarika"},ita:{official:"Repubblica di Costa Rica",common:"Costa Rica"},jpn:{official:"コスタリカ共和国",common:"コスタリカ"},nld:{official:"Republiek Costa Rica",common:"Costa Rica"},por:{official:"República da Costa Rica",common:"Costa Rica"},rus:{official:"Республика Коста-Рика",common:"Коста-Рика"},slk:{official:"Kostarická republika",common:"Kostarika"},spa:{official:"República de Costa Rica",common:"Costa Rica"},fin:{official:"Costa Rican tasavalta",common:"Costa Rica"},est:{official:"Costa Rica Vabariik",common:"Costa Rica"},zho:{official:"哥斯达黎加共和国",common:"哥斯达黎加"}},latlng:[10,-84],demonym:"Costa Rican",landlocked:!1,borders:["NIC","PAN"],area:51100,flag:"🇨🇷"},{name:{common:"Cuba",official:"Republic of Cuba",native:{spa:{official:"República de Cuba",common:"Cuba"}}},tld:[".cu"],cca2:"CU",ccn3:"192",cca3:"CUB",cioc:"CUB",independent:!0,status:"officially-assigned",currency:["CUC","CUP"],callingCode:["53"],capital:["Havana"],altSpellings:["CU","Republic of Cuba","República de Cuba"],region:"Americas",subregion:"Caribbean",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Ciwba",common:"Ciwba"},deu:{official:"Republik Kuba",common:"Kuba"},fra:{official:"République de Cuba",common:"Cuba"},hrv:{official:"Republika Kuba",common:"Kuba"},ita:{official:"Repubblica di Cuba",common:"Cuba"},jpn:{official:"キューバ共和国",common:"キューバ"},nld:{official:"Republiek Cuba",common:"Cuba"},por:{official:"República de Cuba",common:"Cuba"},rus:{official:"Республика Куба",common:"Куба"},slk:{official:"Kubánska republika",common:"Kuba"},spa:{official:"República de Cuba",common:"Cuba"},fin:{official:"Kuuban tasavalta",common:"Kuuba"},est:{official:"Kuuba Vabariik",common:"Kuuba"},zho:{official:"古巴共和国",common:"古巴"}},latlng:[21.5,-80],demonym:"Cuban",landlocked:!1,borders:[],area:109884,flag:"🇨🇺"},{name:{common:"Curaçao",official:"Country of Curaçao",native:{eng:{official:"Country of Curaçao",common:"Curaçao"},nld:{official:"Land Curaçao",common:"Curaçao"},pap:{official:"Pais Kòrsou",common:"Pais Kòrsou"}}},tld:[".cw"],cca2:"CW",ccn3:"531",cca3:"CUW",cioc:"",independent:!1,status:"officially-assigned",currency:["ANG"],callingCode:["5999"],capital:["Willemstad"],altSpellings:["CW","Curacao","Kòrsou","Country of Curaçao","Land Curaçao","Pais Kòrsou"],region:"Americas",subregion:"Caribbean",languages:{eng:"English",nld:"Dutch",pap:"Papiamento"},translations:{deu:{official:"Land Curaçao",common:"Curaçao"},fra:{official:"Curaçao",common:"Curaçao"},nld:{official:"Land Curaçao",common:"Curaçao"},por:{official:"País de Curaçao",common:"ilha da Curação"},rus:{official:"Страна Кюрасао",common:"Кюрасао"},slk:{official:"Curacao",common:"Curacao"},spa:{official:"País de Curazao",common:"Curazao"},fin:{official:"Curaçao",common:"Curaçao"},est:{official:"Curaçao",common:"Curaçao"},zho:{official:"库拉索",common:"库拉索"}},latlng:[12.116667,-68.933333],demonym:"Dutch",landlocked:!1,borders:[],area:444,flag:"🇨🇼"},{name:{common:"Christmas Island",official:"Territory of Christmas Island",native:{eng:{official:"Territory of Christmas Island",common:"Christmas Island"}}},tld:[".cx"],cca2:"CX",ccn3:"162",cca3:"CXR",cioc:"",independent:!1,status:"officially-assigned",currency:["AUD"],callingCode:["61"],capital:["Flying Fish Cove"],altSpellings:["CX","Territory of Christmas Island"],region:"Oceania",subregion:"Australia and New Zealand",languages:{eng:"English"},translations:{cym:{official:"Tiriogaeth yr Ynys y Nadolig",common:"Ynys y Nadolig"},deu:{official:"Gebiet der Weihnachtsinsel",common:"Weihnachtsinsel"},fra:{official:"Territoire de l'île Christmas",common:"Île Christmas"},hrv:{official:"Teritorij Božićni otok",common:"Božićni otok"},ita:{official:"Territorio di Christmas Island",common:"Isola di Natale"},jpn:{official:"クリスマス島の領土",common:"クリスマス島"},nld:{official:"Grondgebied van Christmas Island",common:"Christmaseiland"},por:{official:"Território da Ilha Christmas",common:"Ilha do Natal"},rus:{official:"Территория острова Рождества",common:"Остров Рождества"},slk:{official:"Teritórium Vianočného ostrova",common:"Vianočnú ostrov"},spa:{official:"Territorio de la Isla de Navidad",common:"Isla de Navidad"},fin:{official:"Joulusaaren alue",common:"Joulusaari"},est:{official:"Jõulusaare ala",common:"Jõulusaar"},zho:{official:"圣诞岛",common:"圣诞岛"}},latlng:[-10.5,105.66666666],demonym:"Christmas Islander",landlocked:!1,borders:[],area:135,flag:"🇨🇽"},{name:{common:"Cayman Islands",official:"Cayman Islands",native:{eng:{official:"Cayman Islands",common:"Cayman Islands"}}},tld:[".ky"],cca2:"KY",ccn3:"136",cca3:"CYM",cioc:"CAY",independent:!1,status:"officially-assigned",currency:["KYD"],callingCode:["1345"],capital:["George Town"],altSpellings:["KY"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{cym:{official:"Ynysoedd Cayman",common:"Ynysoedd Cayman"},deu:{official:"Cayman-Inseln",common:"Kaimaninseln"},fra:{official:"Îles Caïmans",common:"Îles Caïmans"},hrv:{official:"Kajmanski otoci",common:"Kajmanski otoci"},ita:{official:"Isole Cayman",common:"Isole Cayman"},jpn:{official:"ケイマン諸島",common:"ケイマン諸島"},nld:{official:"Caymaneilanden",common:"Caymaneilanden"},por:{official:"Ilhas Cayman",common:"Ilhas Caimão"},rus:{official:"Каймановы острова",common:"Каймановы острова"},slk:{official:"Kajmanie ostrovy",common:"Kajmanie ostrovy"},spa:{official:"Islas Caimán",common:"Islas Caimán"},fin:{official:"Caymansaaret",common:"Caymansaaret"},est:{official:"Kaimanisaared",common:"Kaimanisaared"},zho:{official:"开曼群岛",common:"开曼群岛"}},latlng:[19.5,-80.5],demonym:"Caymanian",landlocked:!1,borders:[],area:264,flag:"🇰🇾"},{name:{common:"Cyprus",official:"Republic of Cyprus",native:{ell:{official:"Δημοκρατία της Κύπρος",common:"Κύπρος"},tur:{official:"Kıbrıs Cumhuriyeti",common:"Kıbrıs"}}},tld:[".cy"],cca2:"CY",ccn3:"196",cca3:"CYP",cioc:"CYP",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["357"],capital:["Nicosia"],altSpellings:["CY","Kýpros","Kıbrıs","Republic of Cyprus","Κυπριακή Δημοκρατία","Kıbrıs Cumhuriyeti"],region:"Europe",subregion:"Eastern Europe",languages:{ell:"Greek",tur:"Turkish"},translations:{cym:{official:"Gweriniaeth Cyprus",common:"Cyprus"},deu:{official:"Republik Zypern",common:"Zypern"},fra:{official:"République de Chypre",common:"Chypre"},hrv:{official:"Republika Cipar",common:"Cipar"},ita:{official:"Repubblica di Cipro",common:"Cipro"},jpn:{official:"キプロス共和国",common:"キプロス"},nld:{official:"Republiek Cyprus",common:"Cyprus"},por:{official:"República de Chipre",common:"Chipre"},rus:{official:"Республика Кипр",common:"Кипр"},slk:{official:"Cyperská republika",common:"Cyprus"},spa:{official:"República de Chipre",common:"Chipre"},fin:{official:"Kyproksen tasavalta",common:"Kypros"},est:{official:"Küprose Vabariik",common:"Küpros"},zho:{official:"塞浦路斯共和国",common:"塞浦路斯"}},latlng:[35,33],demonym:"Cypriot",landlocked:!1,borders:[],area:9251,flag:"🇨🇾"},{name:{common:"Czechia",official:"Czech Republic",native:{ces:{official:"česká republika",common:"Česko"},slk:{official:"Česká republika",common:"Česko"}}},tld:[".cz"],cca2:"CZ",ccn3:"203",cca3:"CZE",cioc:"CZE",independent:!0,status:"officially-assigned",currency:["CZK"],callingCode:["420"],capital:["Prague"],altSpellings:["CZ","Česká republika","Česko"],region:"Europe",subregion:"Eastern Europe",languages:{ces:"Czech",slk:"Slovak"},translations:{cym:{official:"Y Weriniaeth Tsiec",common:"Y Weriniaeth Tsiec"},deu:{official:"Tschechische Republik",common:"Tschechien"},fra:{official:"République tchèque",common:"Tchéquie"},hrv:{official:"Češka",common:"Češka"},ita:{official:"Repubblica Ceca",common:"Cechia"},jpn:{official:"チェコ共和国",common:"チェコ"},nld:{official:"Tsjechische Republiek",common:"Tsjechië"},por:{official:"República Checa",common:"Chéquia"},rus:{official:"Чешская Республика",common:"Чехия"},slk:{official:"Česká republika",common:"Česko"},spa:{official:"República Checa",common:"Chequia"},fin:{official:"Tšekin tasavalta",common:"Tšekki"},est:{official:"Tšehhi Vabariik",common:"Tšehhi"},zho:{official:"捷克共和国",common:"捷克"}},latlng:[49.75,15.5],demonym:"Czech",landlocked:!0,borders:["AUT","DEU","POL","SVK"],area:78865,flag:"🇨🇿"},{name:{common:"Germany",official:"Federal Republic of Germany",native:{deu:{official:"Bundesrepublik Deutschland",common:"Deutschland"}}},tld:[".de"],cca2:"DE",ccn3:"276",cca3:"DEU",cioc:"GER",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["49"],capital:["Berlin"],altSpellings:["DE","Federal Republic of Germany","Bundesrepublik Deutschland"],region:"Europe",subregion:"Western Europe",languages:{deu:"German"},translations:{deu:{official:"Bundesrepublik Deutschland",common:"Deutschland"},fra:{official:"République fédérale d'Allemagne",common:"Allemagne"},hrv:{official:"Njemačka Federativna Republika",common:"Njemačka"},ita:{official:"Repubblica federale di Germania",common:"Germania"},jpn:{official:"ドイツ連邦共和国",common:"ドイツ"},nld:{official:"Bondsrepubliek Duitsland",common:"Duitsland"},por:{official:"República Federal da Alemanha",common:"Alemanha"},rus:{official:"Федеративная Республика Германия",common:"Германия"},slk:{official:"Nemecká spolková republika",common:"Nemecko"},spa:{official:"República Federal de Alemania",common:"Alemania"},fin:{official:"Saksan liittotasavalta",common:"Saksa"},est:{official:"Saksamaa Liitvabariik",common:"Saksamaa"},zho:{official:"德意志联邦共和国",common:"德国"}},latlng:[51,9],demonym:"German",landlocked:!1,borders:["AUT","BEL","CZE","DNK","FRA","LUX","NLD","POL","CHE"],area:357114,flag:"🇩🇪"},{name:{common:"Djibouti",official:"Republic of Djibouti",native:{ara:{official:"جمهورية جيبوتي",common:"جيبوتي‎"},fra:{official:"République de Djibouti",common:"Djibouti"}}},tld:[".dj"],cca2:"DJ",ccn3:"262",cca3:"DJI",cioc:"DJI",independent:!0,status:"officially-assigned",currency:["DJF"],callingCode:["253"],capital:["Djibouti"],altSpellings:["DJ","Jabuuti","Gabuuti","Republic of Djibouti","République de Djibouti","Gabuutih Ummuuno","Jamhuuriyadda Jabuuti"],region:"Africa",subregion:"Eastern Africa",languages:{ara:"Arabic",fra:"French"},translations:{cym:{official:"Gweriniaeth Jibwti",common:"Jibwti"},deu:{official:"Republik Dschibuti",common:"Dschibuti"},fra:{official:"République de Djibouti",common:"Djibouti"},hrv:{official:"Republika Džibuti",common:"Džibuti"},ita:{official:"Repubblica di Gibuti",common:"Gibuti"},jpn:{official:"ジブチ共和国",common:"ジブチ"},nld:{official:"Republiek Djibouti",common:"Djibouti"},por:{official:"República do Djibouti",common:"Djibouti"},rus:{official:"Республика Джибути",common:"Джибути"},slk:{official:"ǅibutská republika",common:"ǅibutsko"},spa:{official:"República de Djibouti",common:"Djibouti"},fin:{official:"Dijiboutin tasavalta",common:"Dijibouti"},est:{official:"Djibouti Vabariik",common:"Djibouti"},zho:{official:"吉布提共和国",common:"吉布提"}},latlng:[11.5,43],demonym:"Djibouti",landlocked:!1,borders:["ERI","ETH","SOM"],area:23200,flag:"🇩🇯"},{name:{common:"Dominica",official:"Commonwealth of Dominica",native:{eng:{official:"Commonwealth of Dominica",common:"Dominica"}}},tld:[".dm"],cca2:"DM",ccn3:"212",cca3:"DMA",cioc:"DMA",independent:!0,status:"officially-assigned",currency:["XCD"],callingCode:["1767"],capital:["Roseau"],altSpellings:["DM","Dominique","Wai‘tu kubuli","Commonwealth of Dominica"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{cym:{official:"Cymanwlad Dominica",common:"Dominica"},deu:{official:"Commonwealth von Dominica",common:"Dominica"},fra:{official:"Commonwealth de la Dominique",common:"Dominique"},hrv:{official:"Zajednica Dominika",common:"Dominika"},ita:{official:"Commonwealth di Dominica",common:"Dominica"},jpn:{official:"ドミニカ国",common:"ドミニカ国"},nld:{official:"Gemenebest Dominica",common:"Dominica"},por:{official:"Comunidade da Dominica",common:"Dominica"},rus:{official:"Содружество Доминики",common:"Доминика"},slk:{official:"Dominické spoločenstvo",common:"Dominika"},spa:{official:"Mancomunidad de Dominica",common:"Dominica"},fin:{official:"Dominican liittovaltio",common:"Dominica"},est:{official:"Dominica Ühendus",common:"Dominica"},zho:{official:"多米尼加共和国",common:"多米尼加"}},latlng:[15.41666666,-61.33333333],demonym:"Dominican",landlocked:!1,borders:[],area:751,flag:"🇩🇲"},{name:{common:"Denmark",official:"Kingdom of Denmark",native:{dan:{official:"Kongeriget Danmark",common:"Danmark"}}},tld:[".dk"],cca2:"DK",ccn3:"208",cca3:"DNK",cioc:"DEN",independent:!0,status:"officially-assigned",currency:["DKK"],callingCode:["45"],capital:["Copenhagen"],altSpellings:["DK","Danmark","Kingdom of Denmark","Kongeriget Danmark"],region:"Europe",subregion:"Northern Europe",languages:{dan:"Danish"},translations:{cym:{official:"Teyrnas Denmarc",common:"Denmarc"},deu:{official:"Königreich Dänemark",common:"Dänemark"},fra:{official:"Royaume du Danemark",common:"Danemark"},hrv:{official:"Kraljevina Danska",common:"Danska"},ita:{official:"Regno di Danimarca",common:"Danimarca"},jpn:{official:"デンマーク王国",common:"デンマーク"},nld:{official:"Koninkrijk Denemarken",common:"Denemarken"},por:{official:"Reino da Dinamarca",common:"Dinamarca"},rus:{official:"Королевство Дания",common:"Дания"},slk:{official:"Dánske kráľovstvo",common:"Dánsko"},spa:{official:"Reino de Dinamarca",common:"Dinamarca"},fin:{official:"Tanskan kuningaskunta",common:"Tanska"},est:{official:"Taani Kuningriik",common:"Taani"},zho:{official:"丹麦王国",common:"丹麦"}},latlng:[56,10],demonym:"Danish",landlocked:!1,borders:["DEU"],area:43094,flag:"🇩🇰"},{name:{common:"Dominican Republic",official:"Dominican Republic",native:{spa:{official:"República Dominicana",common:"República Dominicana"}}},tld:[".do"],cca2:"DO",ccn3:"214",cca3:"DOM",cioc:"DOM",independent:!0,status:"officially-assigned",currency:["DOP"],callingCode:["1809","1829","1849"],capital:["Santo Domingo"],altSpellings:["DO"],region:"Americas",subregion:"Caribbean",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Dominica",common:"Gweriniaeth Dominica"},deu:{official:"Dominikanische Republik",common:"Dominikanische Republik"},fra:{official:"République Dominicaine",common:"République dominicaine"},hrv:{official:"Dominikanska Republika",common:"Dominikanska Republika"},ita:{official:"Repubblica Dominicana",common:"Repubblica Dominicana"},jpn:{official:"ドミニカ共和国",common:"ドミニカ共和国"},nld:{official:"Dominicaanse Republiek",common:"Dominicaanse Republiek"},por:{official:"República Dominicana",common:"República Dominicana"},rus:{official:"Доминиканская Республика",common:"Доминиканская Республика"},slk:{official:"Dominikánska republika",common:"Dominikánska republika"},spa:{official:"República Dominicana",common:"República Dominicana"},fin:{official:"Dominikaaninen tasavalta",common:"Dominikaaninen tasavalta"},est:{official:"Dominikaani Vabariik",common:"Dominikaani Vabariik"},zho:{official:"多明尼加共和国",common:"多明尼加"}},latlng:[19,-70.66666666],demonym:"Dominican",landlocked:!1,borders:["HTI"],area:48671,flag:"🇩🇴"},{name:{common:"Algeria",official:"People's Democratic Republic of Algeria",native:{ara:{official:"الجمهورية الديمقراطية الشعبية الجزائرية",common:"الجزائر"}}},tld:[".dz","الجزائر."],cca2:"DZ",ccn3:"012",cca3:"DZA",cioc:"ALG",independent:!0,status:"officially-assigned",currency:["DZD"],callingCode:["213"],capital:["Algiers"],altSpellings:["DZ","Dzayer","Algérie"],region:"Africa",subregion:"Northern Africa",languages:{ara:"Arabic"},translations:{cym:{official:"Gweriniaeth Ddemocrataidd Pobl Algeria",common:"Algeria"},deu:{official:"Demokratische Volksrepublik Algerien",common:"Algerien"},fra:{official:"République démocratique et populaire d'Algérie",common:"Algérie"},hrv:{official:"Narodna Demokratska Republika Alžir",common:"Alžir"},ita:{official:"Repubblica popolare democratica di Algeria",common:"Algeria"},jpn:{official:"アルジェリア人民民主共和国",common:"アルジェリア"},nld:{official:"Democratische Volksrepubliek Algerije",common:"Algerije"},por:{official:"República Argelina Democrática e Popular",common:"Argélia"},rus:{official:"Народно-Демократическая Республика Алжир",common:"Алжир"},slk:{official:"Alžírska demokratická ľudová republika",common:"Alžírsko"},spa:{official:"República Argelina Democrática y Popular",common:"Argelia"},fin:{official:"Algerian demokraattinen kansantasavalta",common:"Algeria"},est:{official:"Alžeeria Demokraatlik Rahvavabariik",common:"Alžeeria"},zho:{official:"阿尔及利亚人民民主共和国",common:"阿尔及利亚"}},latlng:[28,3],demonym:"Algerian",landlocked:!1,borders:["TUN","LBY","NER","ESH","MRT","MLI","MAR"],area:2381741,flag:"🇩🇿"},{name:{common:"Ecuador",official:"Republic of Ecuador",native:{spa:{official:"República del Ecuador",common:"Ecuador"}}},tld:[".ec"],cca2:"EC",ccn3:"218",cca3:"ECU",cioc:"ECU",independent:!0,status:"officially-assigned",currency:["USD"],callingCode:["593"],capital:["Quito"],altSpellings:["EC","Republic of Ecuador","República del Ecuador"],region:"Americas",subregion:"South America",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Ecwador",common:"Ecwador"},deu:{official:"Republik Ecuador",common:"Ecuador"},fra:{official:"République de l'Équateur",common:"Équateur"},hrv:{official:"Republika Ekvador",common:"Ekvador"},ita:{official:"Repubblica dell'Ecuador",common:"Ecuador"},jpn:{official:"エクアドル共和国",common:"エクアドル"},nld:{official:"Republiek Ecuador",common:"Ecuador"},por:{official:"República do Equador",common:"Equador"},rus:{official:"Республика Эквадор",common:"Эквадор"},slk:{official:"Ekvádorská republika",common:"Ekvádor"},spa:{official:"República del Ecuador",common:"Ecuador"},fin:{official:"Ecuadorin tasavalta",common:"Ecuador"},est:{official:"Ecuadori Vabariik",common:"Ecuador"},zho:{official:"厄瓜多尔共和国",common:"厄瓜多尔"}},latlng:[-2,-77.5],demonym:"Ecuadorean",landlocked:!1,borders:["COL","PER"],area:276841,flag:"🇪🇨"},{name:{common:"Egypt",official:"Arab Republic of Egypt",native:{ara:{official:"جمهورية مصر العربية",common:"مصر"}}},tld:[".eg",".مصر"],cca2:"EG",ccn3:"818",cca3:"EGY",cioc:"EGY",independent:!0,status:"officially-assigned",currency:["EGP"],callingCode:["20"],capital:["Cairo"],altSpellings:["EG","Arab Republic of Egypt"],region:"Africa",subregion:"Northern Africa",languages:{ara:"Arabic"},translations:{cym:{official:"Gweriniaeth Arabaidd yr Aifft",common:"Yr Aifft"},deu:{official:"Arabische Republik Ägypten",common:"Ägypten"},fra:{official:"République arabe d'Égypte",common:"Égypte"},hrv:{official:"Arapska Republika Egipat",common:"Egipat"},ita:{official:"Repubblica araba d'Egitto",common:"Egitto"},jpn:{official:"エジプト·アラブ共和国",common:"エジプト"},nld:{official:"Arabische Republiek Egypte",common:"Egypte"},por:{official:"República Árabe do Egipto",common:"Egito"},rus:{official:"Арабская Республика Египет",common:"Египет"},slk:{official:"Egyptská arabská republika",common:"Egypt"},spa:{official:"República Árabe de Egipto",common:"Egipto"},fin:{official:"Egyptin arabitasavalta",common:"Egypti"},est:{official:"Egiptuse Araabia Vabariik",common:"Egiptus"},zho:{official:"阿拉伯埃及共和国",common:"埃及"}},latlng:[27,30],demonym:"Egyptian",landlocked:!1,borders:["ISR","LBY","PSE","SDN"],area:1002450,flag:"🇪🇬"},{name:{common:"Eritrea",official:"State of Eritrea",native:{ara:{official:"دولة إرتريا",common:"إرتريا‎"},eng:{official:"State of Eritrea",common:"Eritrea"},tir:{official:"ሃገረ ኤርትራ",common:"ኤርትራ"}}},tld:[".er"],cca2:"ER",ccn3:"232",cca3:"ERI",cioc:"ERI",independent:!0,status:"officially-assigned",currency:["ERN"],callingCode:["291"],capital:["Asmara"],altSpellings:["ER","State of Eritrea","ሃገረ ኤርትራ","Dawlat Iritriyá","ʾErtrā","Iritriyā"],region:"Africa",subregion:"Eastern Africa",languages:{ara:"Arabic",eng:"English",tir:"Tigrinya"},translations:{cym:{official:"Gwladwriaeth Eritrea",common:"Eritrea"},deu:{official:"Staat Eritrea",common:"Eritrea"},fra:{official:"État d'Érythrée",common:"Érythrée"},hrv:{official:"Država Eritreji",common:"Eritreja"},ita:{official:"Stato di Eritrea",common:"Eritrea"},jpn:{official:"エリトリア国",common:"エリトリア"},nld:{official:"Staat Eritrea",common:"Eritrea"},por:{official:"Estado da Eritreia",common:"Eritreia"},rus:{official:"Государство Эритрея",common:"Эритрея"},slk:{official:"Eritrejský štát",common:"Eritrea"},spa:{official:"Estado de Eritrea",common:"Eritrea"},fin:{official:"Eritrean valtio",common:"Eritrea"},est:{official:"Eritrea Riik",common:"Eritrea"},zho:{official:"厄立特里亚",common:"厄立特里亚"}},latlng:[15,39],demonym:"Eritrean",landlocked:!1,borders:["DJI","ETH","SDN"],area:117600,flag:"🇪🇷"},{name:{common:"Western Sahara",official:"Sahrawi Arab Democratic Republic",native:{ber:{official:"Sahrawi Arab Democratic Republic",common:"Western Sahara"},mey:{official:"الجمهورية العربية الصحراوية الديمقراطية",common:"الصحراء الغربية"},spa:{official:"República Árabe Saharaui Democrática",common:"Sahara Occidental"}}},tld:[".eh"],cca2:"EH",ccn3:"732",cca3:"ESH",cioc:"",independent:!1,status:"officially-assigned",currency:["MAD","DZD","MRO"],callingCode:["212"],capital:["El Aaiún"],altSpellings:["EH","Taneẓroft Tutrimt"],region:"Africa",subregion:"Northern Africa",languages:{ber:"Berber",mey:"Hassaniya",spa:"Spanish"},translations:{deu:{official:"Demokratische Arabische Republik Sahara",common:"Westsahara"},fra:{official:"République arabe sahraouie démocratique",common:"Sahara Occidental"},hrv:{official:"Sahrawi Arab Demokratska Republika",common:"Zapadna Sahara"},ita:{official:"Repubblica Araba Saharawi Democratica",common:"Sahara Occidentale"},jpn:{official:"サハラアラブ民主共和国",common:"西サハラ"},nld:{official:"Sahrawi Arabische Democratische Republiek",common:"Westelijke Sahara"},por:{official:"República Árabe Saharaui Democrática",common:"Saara Ocidental"},rus:{official:"Sahrawi Арабская Демократическая Республика",common:"Западная Сахара"},slk:{official:"Západná Sahara",common:"Západná Sahara"},spa:{official:"República Árabe Saharaui Democrática",common:"Sahara Occidental"},fin:{official:"Länsi-Sahara",common:"Länsi-Sahara"},est:{official:"Lääne-Sahara",common:"Lääne-Sahara"},zho:{official:"阿拉伯撒哈拉民主共和国",common:"西撒哈拉"}},latlng:[24.5,-13],demonym:"Sahrawi",landlocked:!1,borders:["DZA","MRT","MAR"],area:266e3,flag:"🇪🇭"},{name:{common:"Spain",official:"Kingdom of Spain",native:{spa:{official:"Reino de España",common:"España"}}},tld:[".es"],cca2:"ES",ccn3:"724",cca3:"ESP",cioc:"ESP",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["34"],capital:["Madrid"],altSpellings:["ES","Kingdom of Spain","Reino de España"],region:"Europe",subregion:"Southern Europe",languages:{spa:"Spanish"},translations:{deu:{official:"Königreich Spanien",common:"Spanien"},fra:{official:"Royaume d'Espagne",common:"Espagne"},hrv:{official:"Kraljevina Španjolska",common:"Španjolska"},ita:{official:"Regno di Spagna",common:"Spagna"},jpn:{official:"スペイン王国",common:"スペイン"},nld:{official:"Koninkrijk Spanje",common:"Spanje"},por:{official:"Reino de Espanha",common:"Espanha"},rus:{official:"Королевство Испания",common:"Испания"},slk:{official:"Španielske kráľovstvo",common:"Španielsko"},spa:{official:"Reino de España",common:"España"},fin:{official:"Espanjan kuningaskunta",common:"Espanja"},est:{official:"Hispaania Kuningriik",common:"Hispaania"},zho:{official:"西班牙王国",common:"西班牙"}},latlng:[40,-4],demonym:"Spanish",landlocked:!1,borders:["AND","FRA","GIB","PRT","MAR"],area:505992,flag:"🇪🇸"},{name:{common:"Estonia",official:"Republic of Estonia",native:{est:{official:"Eesti Vabariik",common:"Eesti"}}},tld:[".ee"],cca2:"EE",ccn3:"233",cca3:"EST",cioc:"EST",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["372"],capital:["Tallinn"],altSpellings:["EE","Eesti","Republic of Estonia","Eesti Vabariik"],region:"Europe",subregion:"Northern Europe",languages:{est:"Estonian"},translations:{cym:{official:"Gweriniaeth Estonia",common:"Estonia"},deu:{official:"Republik Estland",common:"Estland"},fra:{official:"République d'Estonie",common:"Estonie"},hrv:{official:"Republika Estonija",common:"Estonija"},ita:{official:"Repubblica di Estonia",common:"Estonia"},jpn:{official:"エストニア共和国",common:"エストニア"},nld:{official:"Republiek Estland",common:"Estland"},por:{official:"República da Estónia",common:"Estónia"},rus:{official:"Эстонская Республика",common:"Эстония"},slk:{official:"Estónska republika",common:"Estónsko"},spa:{official:"República de Estonia",common:"Estonia"},fin:{official:"Viron tasavalta",common:"Viro"},est:{official:"Eesti Vabariik",common:"Eesti"},zho:{official:"爱沙尼亚共和国",common:"爱沙尼亚"}},latlng:[59,26],demonym:"Estonian",landlocked:!1,borders:["LVA","RUS"],area:45227,flag:"🇪🇪"},{name:{common:"Ethiopia",official:"Federal Democratic Republic of Ethiopia",native:{amh:{official:"የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ",common:"ኢትዮጵያ"}}},tld:[".et"],cca2:"ET",ccn3:"231",cca3:"ETH",cioc:"ETH",independent:!0,status:"officially-assigned",currency:["ETB"],callingCode:["251"],capital:["Addis Ababa"],altSpellings:["ET","ʾĪtyōṗṗyā","Federal Democratic Republic of Ethiopia","የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ"],region:"Africa",subregion:"Eastern Africa",languages:{amh:"Amharic"},translations:{cym:{official:"Gweriniaeth Ddemocrataidd Ffederal Ethiopia",common:"Ethiopia"},deu:{official:"Demokratische Bundesrepublik Äthiopien",common:"Äthiopien"},fra:{official:"République fédérale démocratique d'Éthiopie",common:"Éthiopie"},hrv:{official:"Savezna Demokratska Republika Etiopija",common:"Etiopija"},ita:{official:"Repubblica federale democratica di Etiopia",common:"Etiopia"},jpn:{official:"エチオピア連邦民主共和国",common:"エチオピア"},nld:{official:"Federale Democratische Republiek Ethiopië",common:"Ethiopië"},por:{official:"República Federal Democrática da Etiópia",common:"Etiópia"},rus:{official:"Федеративная Демократическая Республика Эфиопия",common:"Эфиопия"},slk:{official:"Etiópska federatívna demokratická republika",common:"Etiópia"},spa:{official:"República Democrática Federal de Etiopía",common:"Etiopía"},fin:{official:"Etiopian demokraattinen liittotasavalta",common:"Etiopia"},est:{official:"Etioopia Demokraatlik Liitvabariik",common:"Etioopia"},zho:{official:"埃塞俄比亚联邦民主共和国",common:"埃塞俄比亚"}},latlng:[8,38],demonym:"Ethiopian",landlocked:!0,borders:["DJI","ERI","KEN","SOM","SSD","SDN"],area:1104300,flag:"🇪🇹"},{name:{common:"Finland",official:"Republic of Finland",native:{fin:{official:"Suomen tasavalta",common:"Suomi"},swe:{official:"Republiken Finland",common:"Finland"}}},tld:[".fi"],cca2:"FI",ccn3:"246",cca3:"FIN",cioc:"FIN",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["358"],capital:["Helsinki"],altSpellings:["FI","Suomi","Republic of Finland","Suomen tasavalta","Republiken Finland"],region:"Europe",subregion:"Northern Europe",languages:{fin:"Finnish",swe:"Swedish"},translations:{deu:{official:"Republik Finnland",common:"Finnland"},fra:{official:"République de Finlande",common:"Finlande"},hrv:{official:"Republika Finska",common:"Finska"},ita:{official:"Repubblica di Finlandia",common:"Finlandia"},jpn:{official:"フィンランド共和国",common:"フィンランド"},nld:{official:"Republiek Finland",common:"Finland"},por:{official:"República da Finlândia",common:"Finlândia"},rus:{official:"Финляндская Республика",common:"Финляндия"},slk:{official:"Fínska republika",common:"Fínsko"},spa:{official:"República de Finlandia",common:"Finlandia"},fin:{official:"Suomen tasavalta",common:"Suomi"},est:{official:"Soome Vabariik",common:"Soome"},zho:{official:"芬兰共和国",common:"芬兰"}},latlng:[64,26],demonym:"Finnish",landlocked:!1,borders:["NOR","SWE","RUS"],area:338424,flag:"🇫🇮"},{name:{common:"Fiji",official:"Republic of Fiji",native:{eng:{official:"Republic of Fiji",common:"Fiji"},fij:{official:"Matanitu Tugalala o Viti",common:"Viti"},hif:{official:"रिपब्लिक ऑफ फीजी",common:"फिजी"}}},tld:[".fj"],cca2:"FJ",ccn3:"242",cca3:"FJI",cioc:"FIJ",independent:!0,status:"officially-assigned",currency:["FJD"],callingCode:["679"],capital:["Suva"],altSpellings:["FJ","Viti","Republic of Fiji","Matanitu ko Viti","Fijī Gaṇarājya"],region:"Oceania",subregion:"Melanesia",languages:{eng:"English",fij:"Fijian",hif:"Fiji Hindi"},translations:{deu:{official:"Republik Fidschi",common:"Fidschi"},fra:{official:"République des Fidji",common:"Fidji"},hrv:{official:"Republika Fidži",common:"Fiđi"},ita:{official:"Repubblica di Figi",common:"Figi"},jpn:{official:"フィジー共和国",common:"フィジー"},nld:{official:"Republiek Fiji",common:"Fiji"},por:{official:"República de Fiji",common:"Fiji"},rus:{official:"Республика Фиджи",common:"Фиджи"},slk:{official:"Fiǆijská republika",common:"Fiǆi"},spa:{official:"República de Fiji",common:"Fiyi"},fin:{official:"Fidžin tasavalta",common:"Fidži"},est:{official:"Fidži Vabariik",common:"Fidži"},zho:{official:"斐济共和国",common:"斐济"}},latlng:[-18,175],demonym:"Fijian",landlocked:!1,borders:[],area:18272,flag:"🇫🇯"},{name:{common:"Falkland Islands",official:"Falkland Islands",native:{eng:{official:"Falkland Islands",common:"Falkland Islands"}}},tld:[".fk"],cca2:"FK",ccn3:"238",cca3:"FLK",cioc:"",independent:!1,status:"officially-assigned",currency:["FKP"],callingCode:["500"],capital:["Stanley"],altSpellings:["FK","Islas Malvinas","Falkland Islands (Malvinas)"],region:"Americas",subregion:"South America",languages:{eng:"English"},translations:{deu:{official:"Falkland-Inseln",common:"Falklandinseln"},fra:{official:"Îles Malouines",common:"Îles Malouines"},hrv:{official:"Falklandski otoci",common:"Falklandski Otoci"},ita:{official:"Isole Falkland",common:"Isole Falkland o Isole Malvine"},jpn:{official:"フォークランド",common:"フォークランド（マルビナス）諸島"},nld:{official:"Falkland eilanden",common:"Falklandeilanden"},por:{official:"Ilhas Malvinas",common:"Ilhas Malvinas"},rus:{official:"Фолклендские острова",common:"Фолклендские острова"},slk:{official:"Falklandské ostrovy",common:"Falklandy"},spa:{official:"islas Malvinas",common:"Islas Malvinas"},fin:{official:"Falkandinsaaret",common:"Falkandinsaaret"},est:{official:"Falklandi saared",common:"Falklandi saared"},zho:{official:"福克兰群岛",common:"福克兰群岛"}},latlng:[-51.75,-59],demonym:"Falkland Islander",landlocked:!1,borders:[],area:12173,flag:"🇫🇰"},{name:{common:"France",official:"French Republic",native:{fra:{official:"République française",common:"France"}}},tld:[".fr"],cca2:"FR",ccn3:"250",cca3:"FRA",cioc:"FRA",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["33"],capital:["Paris"],altSpellings:["FR","French Republic","République française"],region:"Europe",subregion:"Western Europe",languages:{fra:"French"},translations:{deu:{official:"Französische Republik",common:"Frankreich"},fra:{official:"République française",common:"France"},hrv:{official:"Francuska Republika",common:"Francuska"},ita:{official:"Repubblica francese",common:"Francia"},jpn:{official:"フランス共和国",common:"フランス"},nld:{official:"Franse Republiek",common:"Frankrijk"},por:{official:"República Francesa",common:"França"},rus:{official:"Французская Республика",common:"Франция"},slk:{official:"Francúzska republika",common:"Francúzsko"},spa:{official:"República francés",common:"Francia"},fin:{official:"Ranskan tasavalta",common:"Ranska"},est:{official:"Prantsuse Vabariik",common:"Prantsusmaa"},zho:{official:"法兰西共和国",common:"法国"}},latlng:[46,2],demonym:"French",landlocked:!1,borders:["AND","BEL","DEU","ITA","LUX","MCO","ESP","CHE"],area:551695,flag:"🇫🇷"},{name:{common:"Faroe Islands",official:"Faroe Islands",native:{dan:{official:"Færøerne",common:"Færøerne"},fao:{official:"Føroyar",common:"Føroyar"}}},tld:[".fo"],cca2:"FO",ccn3:"234",cca3:"FRO",cioc:"",independent:!1,status:"officially-assigned",currency:["DKK"],callingCode:["298"],capital:["Tórshavn"],altSpellings:["FO","Føroyar","Færøerne"],region:"Europe",subregion:"Northern Europe",languages:{dan:"Danish",fao:"Faroese"},translations:{deu:{official:"Färöer",common:"Färöer-Inseln"},fra:{official:"Îles Féroé",common:"Îles Féroé"},hrv:{official:"Farski Otoci",common:"Farski Otoci"},ita:{official:"Isole Faroe",common:"Isole Far Oer"},jpn:{official:"フェロー諸島",common:"フェロー諸島"},nld:{official:"Faeröer",common:"Faeröer"},por:{official:"Ilhas Faroe",common:"Ilhas Faroé"},rus:{official:"Фарерские острова",common:"Фарерские острова"},slk:{official:"Faerské ostrovy",common:"Faerské ostrovy"},spa:{official:"Islas Feroe",common:"Islas Faroe"},fin:{official:"Färsaaret",common:"Färsaaret"},est:{official:"Fääri saared",common:"Fääri saared"},zho:{official:"法罗群岛",common:"法罗群岛"}},latlng:[62,-7],demonym:"Faroese",landlocked:!1,borders:[],area:1393,flag:"🇫🇴"},{name:{common:"Micronesia",official:"Federated States of Micronesia",native:{eng:{official:"Federated States of Micronesia",common:"Micronesia"}}},tld:[".fm"],cca2:"FM",ccn3:"583",cca3:"FSM",cioc:"FSM",independent:!0,status:"officially-assigned",currency:["USD"],callingCode:["691"],capital:["Palikir"],altSpellings:["FM","Federated States of Micronesia","Micronesia, Federated States of"],region:"Oceania",subregion:"Micronesia",languages:{eng:"English"},translations:{deu:{official:"Föderierte Staaten von Mikronesien",common:"Mikronesien"},fra:{official:"États fédérés de Micronésie",common:"Micronésie"},hrv:{official:"Savezne Države Mikronezije",common:"Mikronezija"},ita:{official:"Stati federati di Micronesia",common:"Micronesia"},jpn:{official:"ミクロネシア連邦",common:"ミクロネシア連邦"},nld:{official:"Federale Staten van Micronesia",common:"Micronesië"},por:{official:"Estados Federados da Micronésia",common:"Micronésia"},rus:{official:"Федеративные Штаты Микронезии",common:"Федеративные Штаты Микронезии"},slk:{official:"Mikron/u00e9zske federatívne štáty",common:"Mikronézia"},spa:{official:"Estados Federados de Micronesia",common:"Micronesia"},fin:{official:"Mikronesian liittovaltio",common:"Mikronesia"},est:{official:"Mikroneesia Liiduriigid",common:"Mikroneesia"},zho:{official:"密克罗尼西亚联邦",common:"密克罗尼西亚"}},latlng:[6.91666666,158.25],demonym:"Micronesian",landlocked:!1,borders:[],area:702,flag:"🇫🇲"},{name:{common:"Gabon",official:"Gabonese Republic",native:{fra:{official:"République gabonaise",common:"Gabon"}}},tld:[".ga"],cca2:"GA",ccn3:"266",cca3:"GAB",cioc:"GAB",independent:!0,status:"officially-assigned",currency:["XAF"],callingCode:["241"],capital:["Libreville"],altSpellings:["GA","Gabonese Republic","République Gabonaise"],region:"Africa",subregion:"Middle Africa",languages:{fra:"French"},translations:{deu:{official:"Gabunische Republik",common:"Gabun"},fra:{official:"République gabonaise",common:"Gabon"},hrv:{official:"Gabon Republika",common:"Gabon"},ita:{official:"Repubblica gabonese",common:"Gabon"},jpn:{official:"ガボン共和国",common:"ガボン"},nld:{official:"Republiek Gabon",common:"Gabon"},por:{official:"República do Gabão",common:"Gabão"},rus:{official:"Габона Республика",common:"Габон"},slk:{official:"Gabonská republika",common:"Gabon"},spa:{official:"República de Gabón",common:"Gabón"},fin:{official:"Gabonin tasavalta",common:"Gabon"},est:{official:"Gaboni Vabariik",common:"Gabon"},zho:{official:"加蓬共和国",common:"加蓬"}},latlng:[-1,11.75],demonym:"Gabonese",landlocked:!1,borders:["CMR","COG","GNQ"],area:267668,flag:"🇬🇦"},{name:{common:"United Kingdom",official:"United Kingdom of Great Britain and Northern Ireland",native:{eng:{official:"United Kingdom of Great Britain and Northern Ireland",common:"United Kingdom"}}},tld:[".uk"],cca2:"GB",ccn3:"826",cca3:"GBR",cioc:"GBR",independent:!0,status:"officially-assigned",currency:["GBP"],callingCode:["44"],capital:["London"],altSpellings:["GB","UK","Great Britain"],region:"Europe",subregion:"Northern Europe",languages:{eng:"English"},translations:{deu:{official:"Vereinigtes Königreich Großbritannien und Nordirland",common:"Vereinigtes Königreich"},fra:{official:"Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",common:"Royaume-Uni"},hrv:{official:"Ujedinjeno Kraljevstvo Velike Britanije i Sjeverne Irske",common:"Ujedinjeno Kraljevstvo"},ita:{official:"Regno Unito di Gran Bretagna e Irlanda del Nord",common:"Regno Unito"},jpn:{official:"グレート·ブリテンおよび北アイルランド連合王国",common:"イギリス"},nld:{official:"Verenigd Koninkrijk van Groot-Brittannië en Noord-Ierland",common:"Verenigd Koninkrijk"},por:{official:"Reino Unido da Grã-Bretanha e Irlanda do Norte",common:"Reino Unido"},rus:{official:"Соединенное Королевство Великобритании и Северной Ирландии",common:"Великобритания"},slk:{official:"Spojené kráľovstvo Veľkej Británie a SevernéhoÌrska",common:"Veľká Británia (Spojené kráľovstvo)"},spa:{official:"Reino Unido de Gran Bretaña e Irlanda del Norte",common:"Reino Unido"},fin:{official:"Ison-Britannian ja Pohjois-Irlannin yhdistynyt kuningaskunta",common:"Yhdistynyt kuningaskunta"},est:{official:"Suurbritannia ja Põhja-Iiri Ühendkuningriik",common:"Suurbritannia"},zho:{official:"大不列颠及北爱尔兰联合王国",common:"英国"}},latlng:[54,-2],demonym:"British",landlocked:!1,borders:["IRL"],area:242900,flag:"🇬🇧"},{name:{common:"Georgia",official:"Georgia",native:{kat:{official:"საქართველო",common:"საქართველო"}}},tld:[".ge"],cca2:"GE",ccn3:"268",cca3:"GEO",cioc:"GEO",independent:!0,status:"officially-assigned",currency:["GEL"],callingCode:["995"],capital:["Tbilisi"],altSpellings:["GE","Sakartvelo"],region:"Asia",subregion:"Western Asia",languages:{kat:"Georgian"},translations:{deu:{official:"Georgia",common:"Georgien"},fra:{official:"République de Géorgie",common:"Géorgie"},hrv:{official:"Gruzija",common:"Gruzija"},ita:{official:"Georgia",common:"Georgia"},jpn:{official:"グルジア",common:"グルジア"},nld:{official:"Georgia",common:"Georgië"},por:{official:"Georgia",common:"Geórgia"},rus:{official:"Грузия",common:"Грузия"},slk:{official:"Gruzínsko",common:"Gruzínsko"},spa:{official:"Georgia",common:"Georgia"},fin:{official:"Georgia",common:"Georgia"},est:{official:"Gruusia",common:"Gruusia"},zho:{official:"格鲁吉亚",common:"格鲁吉亚"}},latlng:[42,43.5],demonym:"Georgian",landlocked:!1,borders:["ARM","AZE","RUS","TUR"],area:69700,flag:"🇬🇪"},{name:{common:"Guernsey",official:"Bailiwick of Guernsey",native:{eng:{official:"Bailiwick of Guernsey",common:"Guernsey"},fra:{official:"Bailliage de Guernesey",common:"Guernesey"},nfr:{official:"Dgèrnésiais",common:"Dgèrnésiais"}}},tld:[".gg"],cca2:"GG",ccn3:"831",cca3:"GGY",cioc:"",independent:!1,status:"officially-assigned",currency:["GBP"],callingCode:["44"],capital:["St. Peter Port"],altSpellings:["GG","Bailiwick of Guernsey","Bailliage de Guernesey"],region:"Europe",subregion:"Northern Europe",languages:{eng:"English",fra:"French",nfr:"Guernésiais"},translations:{deu:{official:"Guernsey",common:"Guernsey"},fra:{official:"Bailliage de Guernesey",common:"Guernesey"},hrv:{official:"Struka Guernsey",common:"Guernsey"},ita:{official:"Baliato di Guernsey",common:"Guernsey"},jpn:{official:"ガーンジーの得意分野",common:"ガーンジー"},nld:{official:"Baljuwschap Guernsey",common:"Guernsey"},por:{official:"Bailiado de Guernsey",common:"Guernsey"},rus:{official:"Коронное владение Гернси",common:"Гернси"},slk:{official:"Guernsey",common:"Guernsey"},spa:{official:"Bailía de Guernsey",common:"Guernsey"},fin:{official:"Guernsey",common:"Guernsey"},est:{official:"Guernsey foogtkond",common:"Guernsey"},zho:{official:"根西岛",common:"根西岛"}},latlng:[49.46666666,-2.58333333],demonym:"Channel Islander",landlocked:!1,borders:[],area:78,flag:"🇬🇬"},{name:{common:"Ghana",official:"Republic of Ghana",native:{eng:{official:"Republic of Ghana",common:"Ghana"}}},tld:[".gh"],cca2:"GH",ccn3:"288",cca3:"GHA",cioc:"GHA",independent:!0,status:"officially-assigned",currency:["GHS"],callingCode:["233"],capital:["Accra"],altSpellings:["GH"],region:"Africa",subregion:"Western Africa",languages:{eng:"English"},translations:{deu:{official:"Republik Ghana",common:"Ghana"},fra:{official:"République du Ghana",common:"Ghana"},hrv:{official:"Republika Gana",common:"Gana"},ita:{official:"Repubblica del Ghana",common:"Ghana"},jpn:{official:"ガーナ共和国",common:"ガーナ"},nld:{official:"Republiek Ghana",common:"Ghana"},por:{official:"República do Gana",common:"Gana"},rus:{official:"Республика Гана",common:"Гана"},slk:{official:"Ghansk/u00e1 republika",common:"Ghana"},spa:{official:"República de Ghana",common:"Ghana"},fin:{official:"Ghanan tasavalta",common:"Ghana"},est:{official:"Ghana Vabariik",common:"Ghana"},zho:{official:"加纳共和国",common:"加纳"}},latlng:[8,-2],demonym:"Ghanaian",landlocked:!1,borders:["BFA","CIV","TGO"],area:238533,flag:"🇬🇭"},{name:{common:"Gibraltar",official:"Gibraltar",native:{eng:{official:"Gibraltar",common:"Gibraltar"}}},tld:[".gi"],cca2:"GI",ccn3:"292",cca3:"GIB",cioc:"",independent:!1,status:"officially-assigned",currency:["GIP"],callingCode:["350"],capital:["Gibraltar"],altSpellings:["GI"],region:"Europe",subregion:"Southern Europe",languages:{eng:"English"},translations:{deu:{official:"Gibraltar",common:"Gibraltar"},fra:{official:"Gibraltar",common:"Gibraltar"},hrv:{official:"Gibraltar",common:"Gibraltar"},ita:{official:"Gibilterra",common:"Gibilterra"},jpn:{official:"ジブラルタル",common:"ジブラルタル"},nld:{official:"Gibraltar",common:"Gibraltar"},por:{official:"Gibraltar",common:"Gibraltar"},rus:{official:"Гибралтар",common:"Гибралтар"},slk:{official:"Gibraltár",common:"Gibraltár"},spa:{official:"Gibraltar",common:"Gibraltar"},fin:{official:"Gibraltar",common:"Gibraltar"},est:{official:"Gibraltar",common:"Gibraltar"},zho:{official:"直布罗陀",common:"直布罗陀"}},latlng:[36.13333333,-5.35],demonym:"Gibraltar",landlocked:!1,borders:["ESP"],area:6,flag:"🇬🇮"},{name:{common:"Guinea",official:"Republic of Guinea",native:{fra:{official:"République de Guinée",common:"Guinée"}}},tld:[".gn"],cca2:"GN",ccn3:"324",cca3:"GIN",cioc:"GUI",independent:!0,status:"officially-assigned",currency:["GNF"],callingCode:["224"],capital:["Conakry"],altSpellings:["GN","Republic of Guinea","République de Guinée"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{deu:{official:"Republik Guinea",common:"Guinea"},fra:{official:"République de Guinée",common:"Guinée"},hrv:{official:"Republika Gvineja",common:"Gvineja"},ita:{official:"Repubblica di Guinea",common:"Guinea"},jpn:{official:"ギニア共和国",common:"ギニア"},nld:{official:"Republiek Guinee",common:"Guinee"},por:{official:"República da Guiné",common:"Guiné"},rus:{official:"Республика Гвинея",common:"Гвинея"},slk:{official:"Guinejská republika",common:"Guinea"},spa:{official:"República de Guinea",common:"Guinea"},fin:{official:"Guinean tasavalta",common:"Guinea"},est:{official:"Guinea Vabariik",common:"Guinea"},zho:{official:"几内亚共和国",common:"几内亚"}},latlng:[11,-10],demonym:"Guinean",landlocked:!1,borders:["CIV","GNB","LBR","MLI","SEN","SLE"],area:245857,flag:"🇬🇳"},{name:{common:"Guadeloupe",official:"Guadeloupe",native:{fra:{official:"Guadeloupe",common:"Guadeloupe"}}},tld:[".gp"],cca2:"GP",ccn3:"312",cca3:"GLP",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["590"],capital:["Basse-Terre"],altSpellings:["GP","Gwadloup"],region:"Americas",subregion:"Caribbean",languages:{fra:"French"},translations:{deu:{official:"Guadeloupe",common:"Guadeloupe"},fra:{official:"Guadeloupe",common:"Guadeloupe"},hrv:{official:"Gvadalupa",common:"Gvadalupa"},ita:{official:"Guadeloupe",common:"Guadeloupa"},jpn:{official:"グアドループ島",common:"グアドループ"},nld:{official:"Guadeloupe",common:"Guadeloupe"},por:{official:"Guadalupe",common:"Guadalupe"},rus:{official:"Гваделупа",common:"Гваделупа"},slk:{official:"Guadeloupe",common:"Guadeloupe"},spa:{official:"Guadalupe",common:"Guadalupe"},fin:{official:"Guadeloupen departmentti",common:"Guadeloupe"},est:{official:"Guadeloupe’i ja sõltkondade departemang",common:"Guadeloupe"},zho:{official:"瓜德罗普岛",common:"瓜德罗普岛"}},latlng:[16.25,-61.583333],demonym:"Guadeloupian",landlocked:!1,borders:[],area:1628,flag:"🇬🇵"},{name:{common:"Gambia",official:"Republic of the Gambia",native:{eng:{official:"Republic of the Gambia",common:"Gambia"}}},tld:[".gm"],cca2:"GM",ccn3:"270",cca3:"GMB",cioc:"GAM",independent:!0,status:"officially-assigned",currency:["GMD"],callingCode:["220"],capital:["Banjul"],altSpellings:["GM","Republic of the Gambia"],region:"Africa",subregion:"Western Africa",languages:{eng:"English"},translations:{deu:{official:"Republik Gambia",common:"Gambia"},fra:{official:"République de Gambie",common:"Gambie"},hrv:{official:"Republika Gambija",common:"Gambija"},ita:{official:"Repubblica del Gambia",common:"Gambia"},jpn:{official:"ガンビア共和国",common:"ガンビア"},nld:{official:"Republiek Gambia",common:"Gambia"},por:{official:"República da Gâmbia",common:"Gâmbia"},rus:{official:"Республика Гамбия",common:"Гамбия"},slk:{official:"Gambijsk/u00e1 republika",common:"Gambia"},spa:{official:"República de Gambia",common:"Gambia"},fin:{official:"Gambian tasavalta",common:"Gambia"},est:{official:"Gambia Vabariik",common:"Gambia"},zho:{official:"冈比亚共和国",common:"冈比亚"}},latlng:[13.46666666,-16.56666666],demonym:"Gambian",landlocked:!1,borders:["SEN"],area:10689,flag:"🇬🇲"},{name:{common:"Guinea-Bissau",official:"Republic of Guinea-Bissau",native:{por:{official:"República da Guiné-Bissau",common:"Guiné-Bissau"},pov:{official:"República da Guiné-Bissau",common:"Guiné-Bissau"}}},tld:[".gw"],cca2:"GW",ccn3:"624",cca3:"GNB",cioc:"GBS",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["245"],capital:["Bissau"],altSpellings:["GW","Republic of Guinea-Bissau","República da Guiné-Bissau"],region:"Africa",subregion:"Western Africa",languages:{por:"Portuguese",pov:"Upper Guinea Creole"},translations:{deu:{official:"Republik Guinea-Bissau",common:"Guinea-Bissau"},fra:{official:"République de Guinée-Bissau",common:"Guinée-Bissau"},hrv:{official:"Republika Gvineja Bisau",common:"Gvineja Bisau"},ita:{official:"Repubblica di Guinea-Bissau",common:"Guinea-Bissau"},jpn:{official:"ギニアビサウ共和国",common:"ギニアビサウ"},nld:{official:"Republiek Guinee-Bissau",common:"Guinee-Bissau"},por:{official:"República da Guiné-Bissau",common:"Guiné-Bissau"},rus:{official:"Республика Гвинея -Бисау",common:"Гвинея-Бисау"},slk:{official:"Guinejsko-bissauská republika",common:"Guinea-Bissau"},spa:{official:"República de Guinea-Bissau",common:"Guinea-Bisáu"},fin:{official:"Guinea-Bissaun tasavalta",common:"Guinea-Bissau"},est:{official:"Guinea-Bissau Vabariik",common:"Guinea-Bissau"},zho:{official:"几内亚比绍共和国",common:"几内亚比绍"}},latlng:[12,-15],demonym:"Guinea-Bissauan",landlocked:!1,borders:["GIN","SEN"],area:36125,flag:"🇬🇼"},{name:{common:"Equatorial Guinea",official:"Republic of Equatorial Guinea",native:{fra:{official:"République de la Guinée Équatoriale",common:"Guinée équatoriale"},por:{official:"República da Guiné Equatorial",common:"Guiné Equatorial"},spa:{official:"República de Guinea Ecuatorial",common:"Guinea Ecuatorial"}}},tld:[".gq"],cca2:"GQ",ccn3:"226",cca3:"GNQ",cioc:"GEQ",independent:!0,status:"officially-assigned",currency:["XAF"],callingCode:["240"],capital:["Malabo"],altSpellings:["GQ","Republic of Equatorial Guinea","República de Guinea Ecuatorial","République de Guinée équatoriale","República da Guiné Equatorial"],region:"Africa",subregion:"Middle Africa",languages:{fra:"French",por:"Portuguese",spa:"Spanish"},translations:{cym:{official:"Gweriniaeth Gini Gyhydeddol",common:"Gini Gyhydeddol"},deu:{official:"Republik Äquatorialguinea",common:"Äquatorialguinea"},fra:{official:"République de Guinée équatoriale",common:"Guinée équatoriale"},hrv:{official:"Republika Ekvatorska Gvineja",common:"Ekvatorijalna Gvineja"},ita:{official:"Repubblica della Guinea Equatoriale",common:"Guinea Equatoriale"},jpn:{official:"赤道ギニア共和国",common:"赤道ギニア"},nld:{official:"Republiek Equatoriaal-Guinea",common:"Equatoriaal-Guinea"},por:{official:"República da Guiné Equatorial",common:"Guiné Equatorial"},rus:{official:"Республика Экваториальная Гвинея",common:"Экваториальная Гвинея"},slk:{official:"Republika rovníkovej Guiney",common:"Rovníková Guinea"},spa:{official:"República de Guinea Ecuatorial",common:"Guinea Ecuatorial"},fin:{official:"Päiväntasaajan Guinean tasavalta",common:"Päiväntasaajan Guinea"},est:{official:"Ekvatoriaal-Guinea Vabariik",common:"Ekvatoriaal-Guinea"},zho:{official:"赤道几内亚共和国",common:"赤道几内亚"}},latlng:[2,10],demonym:"Equatorial Guinean",landlocked:!1,borders:["CMR","GAB"],area:28051,flag:"🇬🇶"},{name:{common:"Greece",official:"Hellenic Republic",native:{ell:{official:"Ελληνική Δημοκρατία",common:"Ελλάδα"}}},tld:[".gr"],cca2:"GR",ccn3:"300",cca3:"GRC",cioc:"GRE",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["30"],capital:["Athens"],altSpellings:["GR","Elláda","Hellenic Republic","Ελληνική Δημοκρατία"],region:"Europe",subregion:"Southern Europe",languages:{ell:"Greek"},translations:{deu:{official:"Hellenische Republik",common:"Griechenland"},fra:{official:"République hellénique",common:"Grèce"},hrv:{official:"Helenska Republika",common:"Grčka"},ita:{official:"Repubblica ellenica",common:"Grecia"},jpn:{official:"ギリシャ共和国",common:"ギリシャ"},nld:{official:"Helleense Republiek",common:"Griekenland"},por:{official:"República Helénica",common:"Grécia"},rus:{official:"Греческая Республика",common:"Греция"},slk:{official:"Grécka republika",common:"Greécko"},spa:{official:"República Helénica",common:"Grecia"},fin:{official:"Helleenien tasavalta",common:"Kreikka"},est:{official:"Kreeka Vabariik",common:"Kreeka"},zho:{official:"希腊共和国",common:"希腊"}},latlng:[39,22],demonym:"Greek",landlocked:!1,borders:["ALB","BGR","TUR","MKD"],area:131990,flag:"🇬🇷"},{name:{common:"Grenada",official:"Grenada",native:{eng:{official:"Grenada",common:"Grenada"}}},tld:[".gd"],cca2:"GD",ccn3:"308",cca3:"GRD",cioc:"GRN",independent:!0,status:"officially-assigned",currency:["XCD"],callingCode:["1473"],capital:["St. George's"],altSpellings:["GD"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Grenada",common:"Grenada"},fra:{official:"Grenade",common:"Grenade"},hrv:{official:"Grenada",common:"Grenada"},ita:{official:"Grenada",common:"Grenada"},jpn:{official:"グレナダ",common:"グレナダ"},nld:{official:"Grenada",common:"Grenada"},por:{official:"Grenada",common:"Granada"},rus:{official:"Гренада",common:"Гренада"},slk:{official:"Grenada",common:"Grenada"},spa:{official:"Granada",common:"Grenada"},fin:{official:"Grenada",common:"Grenada"},est:{official:"Grenada",common:"Grenada"},zho:{official:"格林纳达",common:"格林纳达"}},latlng:[12.11666666,-61.66666666],demonym:"Grenadian",landlocked:!1,borders:[],area:344,flag:"🇬🇩"},{name:{common:"Greenland",official:"Greenland",native:{kal:{official:"Kalaallit Nunaat",common:"Kalaallit Nunaat"}}},tld:[".gl"],cca2:"GL",ccn3:"304",cca3:"GRL",cioc:"",independent:!1,status:"officially-assigned",currency:["DKK"],callingCode:["299"],capital:["Nuuk"],altSpellings:["GL","Grønland"],region:"Americas",subregion:"Northern America",languages:{kal:"Greenlandic"},translations:{deu:{official:"Grönland",common:"Grönland"},fra:{official:"Groenland",common:"Groenland"},hrv:{official:"Grenland",common:"Grenland"},ita:{official:"Groenlandia",common:"Groenlandia"},jpn:{official:"グリーンランド",common:"グリーンランド"},nld:{official:"Groenland",common:"Groenland"},por:{official:"Groenlândia",common:"Gronelândia"},rus:{official:"Гренландия",common:"Гренландия"},slk:{official:"Grónsko",common:"Grónsko"},spa:{official:"Groenlandia",common:"Groenlandia"},fin:{official:"Groönlanti",common:"Groönlanti"},est:{official:"Gröönimaa",common:"Gröönimaa"},zho:{official:"格陵兰",common:"格陵兰"}},latlng:[72,-40],demonym:"Greenlandic",landlocked:!1,borders:[],area:2166086,flag:"🇬🇱"},{name:{common:"Guatemala",official:"Republic of Guatemala",native:{spa:{official:"República de Guatemala",common:"Guatemala"}}},tld:[".gt"],cca2:"GT",ccn3:"320",cca3:"GTM",cioc:"GUA",independent:!0,status:"officially-assigned",currency:["GTQ"],callingCode:["502"],capital:["Guatemala City"],altSpellings:["GT"],region:"Americas",subregion:"Central America",languages:{spa:"Spanish"},translations:{deu:{official:"Republik Guatemala",common:"Guatemala"},fra:{official:"République du Guatemala",common:"Guatemala"},hrv:{official:"Republika Gvatemala",common:"Gvatemala"},ita:{official:"Repubblica del Guatemala",common:"Guatemala"},jpn:{official:"グアテマラ共和国",common:"グアテマラ"},nld:{official:"Republiek Guatemala",common:"Guatemala"},por:{official:"República da Guatemala",common:"Guatemala"},rus:{official:"Республика Гватемала",common:"Гватемала"},slk:{official:"Guatemalská republika",common:"Guatemala"},spa:{official:"República de Guatemala",common:"Guatemala"},fin:{official:"Guatemalan tasavalta",common:"Guatemala"},est:{official:"Guatemala Vabariik",common:"Guatemala"},zho:{official:"危地马拉共和国",common:"危地马拉"}},latlng:[15.5,-90.25],demonym:"Guatemalan",landlocked:!1,borders:["BLZ","SLV","HND","MEX"],area:108889,flag:"🇬🇹"},{name:{common:"French Guiana",official:"Guiana",native:{fra:{official:"Guyane",common:"Guyane française"}}},tld:[".gf"],cca2:"GF",ccn3:"254",cca3:"GUF",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["594"],capital:["Cayenne"],altSpellings:["GF","Guiana","Guyane"],region:"Americas",subregion:"South America",languages:{fra:"French"},translations:{deu:{official:"Guayana",common:"Französisch Guyana"},fra:{official:"Guyane",common:"Guyane"},hrv:{official:"Gijana",common:"Francuska Gvajana"},ita:{official:"Guiana",common:"Guyana francese"},jpn:{official:"ギアナ",common:"フランス領ギアナ"},nld:{official:"Guyana",common:"Frans-Guyana"},por:{official:"Guiana",common:"Guiana Francesa"},rus:{official:"Гвиана",common:"Французская Гвиана"},slk:{official:"Francúzska Guyana",common:"Guyana"},spa:{official:"Guayana",common:"Guayana Francesa"},fin:{official:"Ranskan Guayana",common:"Ranskan Guayana"},est:{official:"Guajaana departemang",common:"Prantsuse Guajaana"},zho:{official:"法属圭亚那",common:"法属圭亚那"}},latlng:[4,-53],demonym:"Guianan",landlocked:!1,borders:["BRA","SUR"],area:83534,flag:"🇬🇫"},{name:{common:"Guam",official:"Guam",native:{cha:{official:"Guåhån",common:"Guåhån"},eng:{official:"Guam",common:"Guam"},spa:{official:"Guam",common:"Guam"}}},tld:[".gu"],cca2:"GU",ccn3:"316",cca3:"GUM",cioc:"GUM",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1671"],capital:["Hagåtña"],altSpellings:["GU","Guåhån"],region:"Oceania",subregion:"Micronesia",languages:{cha:"Chamorro",eng:"English",spa:"Spanish"},translations:{deu:{official:"Guam",common:"Guam"},fra:{official:"Guam",common:"Guam"},hrv:{official:"Guam",common:"Guam"},ita:{official:"Guam",common:"Guam"},jpn:{official:"グアム",common:"グアム"},nld:{official:"Guam",common:"Guam"},por:{official:"Guam",common:"Guam"},rus:{official:"Гуам",common:"Гуам"},slk:{official:"Guam",common:"Guam"},spa:{official:"Guam",common:"Guam"},fin:{official:"Guam",common:"Guam"},est:{official:"Guami ala",common:"Guam"},zho:{official:"关岛",common:"关岛"}},latlng:[13.46666666,144.78333333],demonym:"Guamanian",landlocked:!1,borders:[],area:549,flag:"🇬🇺"},{name:{common:"Guyana",official:"Co-operative Republic of Guyana",native:{eng:{official:"Co-operative Republic of Guyana",common:"Guyana"}}},tld:[".gy"],cca2:"GY",ccn3:"328",cca3:"GUY",cioc:"GUY",independent:!0,status:"officially-assigned",currency:["GYD"],callingCode:["592"],capital:["Georgetown"],altSpellings:["GY","Co-operative Republic of Guyana"],region:"Americas",subregion:"South America",languages:{eng:"English"},translations:{deu:{official:"Kooperative Republik Guyana",common:"Guyana"},fra:{official:"République coopérative de Guyana",common:"Guyana"},hrv:{official:"Zadruga Republika Gvajana",common:"Gvajana"},ita:{official:"Co -operative Republic of Guyana",common:"Guyana"},jpn:{official:"ガイアナの協同共和国",common:"ガイアナ"},nld:{official:"Coöperatieve Republiek Guyana",common:"Guyana"},por:{official:"Co -operative República da Guiana",common:"Guiana"},rus:{official:"Кооперативная Республика Гайана",common:"Гайана"},slk:{official:"Guyanská kooperatívna republika",common:"Guyana"},spa:{official:"República Cooperativa de Guyana",common:"Guyana"},fin:{official:"Guayanan osuustoiminnallinen tasavalta",common:"Guayana"},est:{official:"Guyana Vabariik",common:"Guyana"},zho:{official:"圭亚那共和国",common:"圭亚那"}},latlng:[5,-59],demonym:"Guyanese",landlocked:!1,borders:["BRA","SUR","VEN"],area:214969,flag:"🇬🇾"},{name:{common:"Hong Kong",official:"Hong Kong Special Administrative Region of the People's Republic of China",native:{eng:{official:"Hong Kong Special Administrative Region of the People's Republic of China",common:"Hong Kong"},zho:{official:"中华人民共和国香港特别行政区",common:"香港"}}},tld:[".hk",".香港"],cca2:"HK",ccn3:"344",cca3:"HKG",cioc:"HKG",independent:!1,status:"officially-assigned",currency:["HKD"],callingCode:["852"],capital:["City of Victoria"],altSpellings:["HK"],region:"Asia",subregion:"Eastern Asia",languages:{eng:"English",zho:"Chinese"},translations:{deu:{official:"Sonderverwaltungszone der Volksrepublik China",common:"Hongkong"},fra:{official:"Région administrative spéciale de Hong Kong de la République populaire de Chine",common:"Hong Kong"},hrv:{official:"Hong Kong Posebnog upravnog područjaNarodne Republike Kine",common:"Hong Kong"},ita:{official:"Hong Kong Regione amministrativa speciale della Repubblica Popolare Cinese",common:"Hong Kong"},jpn:{official:"中華人民共和国香港特別行政区",common:"香港"},nld:{official:"Hong Kong Speciale Administratieve Regio van de Volksrepubliek China",common:"Hongkong"},por:{official:"Hong Kong Região Administrativa Especial da República Popular da China",common:"Hong Kong"},rus:{official:"Hong Kong Специальный административный район Китайской Народной Республики Китая",common:"Гонконг"},slk:{official:"Špeciálna administratívna oblasťČínskej ľudovej republiky Hongkong",common:"Hongkong"},spa:{official:"Hong Kong Región Administrativa Especial de la República Popular China",common:"Hong Kong"},fin:{official:"Hong Kongin erityishallintoalue",common:"Hongkong"},est:{official:"Hongkongi erihalduspiirkond",common:"Hongkong"}},latlng:[22.267,114.188],demonym:"Hong Konger",landlocked:!1,borders:["CHN"],area:1104,flag:"🇭🇰"},{name:{common:"Heard Island and McDonald Islands",official:"Heard Island and McDonald Islands",native:{eng:{official:"Heard Island and McDonald Islands",common:"Heard Island and McDonald Islands"}}},tld:[".hm",".aq"],cca2:"HM",ccn3:"334",cca3:"HMD",cioc:"",independent:!1,status:"officially-assigned",currency:["AUD"],callingCode:[],capital:[""],altSpellings:["HM","Heard Island and McDonald Islands"],region:"Antarctic",subregion:"",languages:{eng:"English"},translations:{deu:{official:"Heard und McDonaldinseln",common:"Heard und die McDonaldinseln"},fra:{official:"Des îles Heard et McDonald",common:"Îles Heard-et-MacDonald"},hrv:{official:"Otok Heard i otočje McDonald",common:"Otok Heard i otočje McDonald"},ita:{official:"Isole Heard e McDonald",common:"Isole Heard e McDonald"},jpn:{official:"ハード島とマクドナルド諸島",common:"ハード島とマクドナルド諸島"},nld:{official:"Heard en McDonaldeilanden",common:"Heard-en McDonaldeilanden"},por:{official:"Ilha Heard e Ilhas McDonald",common:"Ilha Heard e Ilhas McDonald"},rus:{official:"Остров Херд и острова Макдональд",common:"Остров Херд и острова Макдональд"},slk:{official:"Teritórium Heardovho ostrova a Macdonaldových ostrovov",common:"Heardov ostrov"},spa:{official:"Islas Heard y McDonald",common:"Islas Heard y McDonald"},fin:{official:"Heard ja McDonaldinsaaret",common:"Heard ja McDonaldinsaaret"},est:{official:"Heardi ja McDonaldi saarte ala",common:"Heard ja McDonald"},zho:{official:"赫德岛和麦当劳群岛",common:"赫德岛和麦当劳群岛"}},latlng:[-53.1,72.51666666],demonym:"Heard and McDonald Islander",landlocked:!1,borders:[],area:412,flag:"🇭🇲"},{name:{common:"Honduras",official:"Republic of Honduras",native:{spa:{official:"República de Honduras",common:"Honduras"}}},tld:[".hn"],cca2:"HN",ccn3:"340",cca3:"HND",cioc:"HON",independent:!0,status:"officially-assigned",currency:["HNL"],callingCode:["504"],capital:["Tegucigalpa"],altSpellings:["HN","Republic of Honduras","República de Honduras"],region:"Americas",subregion:"Central America",languages:{spa:"Spanish"},translations:{deu:{official:"Republik Honduras",common:"Honduras"},fra:{official:"République du Honduras",common:"Honduras"},hrv:{official:"Republika Honduras",common:"Honduras"},ita:{official:"Repubblica di Honduras",common:"Honduras"},jpn:{official:"ホンジュラス共和国",common:"ホンジュラス"},nld:{official:"Republiek Honduras",common:"Honduras"},por:{official:"República de Honduras",common:"Honduras"},rus:{official:"Республика Гондурас",common:"Гондурас"},slk:{official:"Honduraská republika",common:"Honduras"},spa:{official:"República de Honduras",common:"Honduras"},fin:{official:"Hondurasin tasavalta",common:"Honduras"},est:{official:"Hondurase Vabariik",common:"Honduras"},zho:{official:"洪都拉斯共和国",common:"洪都拉斯"}},latlng:[15,-86.5],demonym:"Honduran",landlocked:!1,borders:["GTM","SLV","NIC"],area:112492,flag:"🇭🇳"},{name:{common:"Croatia",official:"Republic of Croatia",native:{hrv:{official:"Republika Hrvatska",common:"Hrvatska"}}},tld:[".hr"],cca2:"HR",ccn3:"191",cca3:"HRV",cioc:"CRO",independent:!0,status:"officially-assigned",currency:["HRK"],callingCode:["385"],capital:["Zagreb"],altSpellings:["HR","Hrvatska","Republic of Croatia","Republika Hrvatska"],region:"Europe",subregion:"Southern Europe",languages:{hrv:"Croatian"},translations:{cym:{official:"Gweriniaeth Croatia",common:"Croatia"},deu:{official:"Republik Kroatien",common:"Kroatien"},fra:{official:"République de Croatie",common:"Croatie"},hrv:{official:"Republika Hrvatska",common:"Hrvatska"},ita:{official:"Repubblica di Croazia",common:"Croazia"},jpn:{official:"クロアチア共和国",common:"クロアチア"},nld:{official:"Republiek Kroatië",common:"Kroatië"},por:{official:"República da Croácia",common:"Croácia"},rus:{official:"Республика Хорватия",common:"Хорватия"},slk:{official:"Chorvátska republika",common:"Chorvátsko"},spa:{official:"República de Croacia",common:"Croacia"},fin:{official:"Kroatian tasavalta",common:"Kroatia"},est:{official:"Horvaatia Vabariik",common:"Horvaatia"},zho:{official:"克罗地亚共和国",common:"克罗地亚"}},latlng:[45.16666666,15.5],demonym:"Croatian",landlocked:!1,borders:["BIH","HUN","MNE","SRB","SVN"],area:56594,flag:"🇭🇷"},{name:{common:"Haiti",official:"Republic of Haiti",native:{fra:{official:"République d'Haïti",common:"Haïti"},hat:{official:"Repiblik Ayiti",common:"Ayiti"}}},tld:[".ht"],cca2:"HT",ccn3:"332",cca3:"HTI",cioc:"HAI",independent:!0,status:"officially-assigned",currency:["HTG","USD"],callingCode:["509"],capital:["Port-au-Prince"],altSpellings:["HT","Republic of Haiti","République d'Haïti","Repiblik Ayiti"],region:"Americas",subregion:"Caribbean",languages:{fra:"French",hat:"Haitian Creole"},translations:{deu:{official:"Republik Haiti",common:"Haiti"},fra:{official:"République d'Haïti",common:"Haïti"},hrv:{official:"Republika Haiti",common:"Haiti"},ita:{official:"Repubblica di Haiti",common:"Haiti"},jpn:{official:"ハイチ共和国",common:"ハイチ"},nld:{official:"Republiek Haïti",common:"Haïti"},por:{official:"República do Haiti",common:"Haiti"},rus:{official:"Республика Гаити",common:"Гаити"},slk:{official:"Haitská republika",common:"Haiti"},spa:{official:"República de Haití",common:"Haiti"},fin:{official:"Haitin tasavalta",common:"Haiti"},est:{official:"Haiti Vabariik",common:"Haiti"},zho:{official:"海地共和国",common:"海地"}},latlng:[19,-72.41666666],demonym:"Haitian",landlocked:!1,borders:["DOM"],area:27750,flag:"🇭🇹"},{name:{common:"Hungary",official:"Hungary",native:{hun:{official:"Magyarország",common:"Magyarország"}}},tld:[".hu"],cca2:"HU",ccn3:"348",cca3:"HUN",cioc:"HUN",independent:!0,status:"officially-assigned",currency:["HUF"],callingCode:["36"],capital:["Budapest"],altSpellings:["HU"],region:"Europe",subregion:"Eastern Europe",languages:{hun:"Hungarian"},translations:{deu:{official:"Ungarn",common:"Ungarn"},fra:{official:"Hongrie",common:"Hongrie"},hrv:{official:"Madžarska",common:"Mađarska"},ita:{official:"Ungheria",common:"Ungheria"},jpn:{official:"ハンガリー",common:"ハンガリー"},nld:{official:"Hongarije",common:"Hongarije"},por:{official:"Hungria",common:"Hungria"},rus:{official:"Венгрия",common:"Венгрия"},slk:{official:"Maďarsko",common:"Maďarsko"},spa:{official:"Hungría",common:"Hungría"},fin:{official:"Unkari",common:"Unkari"},est:{official:"Ungari",common:"Ungari"},zho:{official:"匈牙利",common:"匈牙利"}},latlng:[47,20],demonym:"Hungarian",landlocked:!0,borders:["AUT","HRV","ROU","SRB","SVK","SVN","UKR"],area:93028,flag:"🇭🇺"},{name:{common:"Indonesia",official:"Republic of Indonesia",native:{ind:{official:"Republik Indonesia",common:"Indonesia"}}},tld:[".id"],cca2:"ID",ccn3:"360",cca3:"IDN",cioc:"INA",independent:!0,status:"officially-assigned",currency:["IDR"],callingCode:["62"],capital:["Jakarta"],altSpellings:["ID","Republic of Indonesia","Republik Indonesia"],region:"Asia",subregion:"South-Eastern Asia",languages:{ind:"Indonesian"},translations:{deu:{official:"Republik Indonesien",common:"Indonesien"},fra:{official:"République d'Indonésie",common:"Indonésie"},hrv:{official:"Republika Indonezija",common:"Indonezija"},ita:{official:"Repubblica di Indonesia",common:"Indonesia"},jpn:{official:"インドネシア共和国",common:"インドネシア"},nld:{official:"Republiek Indonesië",common:"Indonesië"},por:{official:"República da Indonésia",common:"Indonésia"},rus:{official:"Республика Индонезия",common:"Индонезия"},slk:{official:"Indonézska republika",common:"Indonézia"},spa:{official:"República de Indonesia",common:"Indonesia"},fin:{official:"Indonesian tasavalta",common:"Indonesia"},est:{official:"Indoneesia Vabariik",common:"Indoneesia"},zho:{official:"印度尼西亚共和国",common:"印度尼西亚"}},latlng:[-5,120],demonym:"Indonesian",landlocked:!1,borders:["TLS","MYS","PNG"],area:1904569,flag:"🇮🇩"},{name:{common:"Isle of Man",official:"Isle of Man",native:{eng:{official:"Isle of Man",common:"Isle of Man"},glv:{official:"Ellan Vannin or Mannin",common:"Mannin"}}},tld:[".im"],cca2:"IM",ccn3:"833",cca3:"IMN",cioc:"",independent:!1,status:"officially-assigned",currency:["GBP"],callingCode:["44"],capital:["Douglas"],altSpellings:["IM","Ellan Vannin","Mann","Mannin"],region:"Europe",subregion:"Northern Europe",languages:{eng:"English",glv:"Manx"},translations:{deu:{official:"Isle of Man",common:"Insel Man"},fra:{official:"Isle of Man",common:"Île de Man"},hrv:{official:"Mana ostrvo",common:"Otok Man"},ita:{official:"Isola di Man",common:"Isola di Man"},jpn:{official:"マン島",common:"マン島"},nld:{official:"Isle of Man",common:"Isle of Man"},por:{official:"Isle of Man",common:"Ilha de Man"},rus:{official:"Остров Мэн",common:"Остров Мэн"},slk:{official:"Ostrov Man",common:"Man"},spa:{official:"Isla de Man",common:"Isla de Man"},fin:{official:"Mansaari",common:"Mansaari"},est:{official:"Mani saar",common:"Mani saar"},zho:{official:"马恩岛",common:"马恩岛"}},latlng:[54.25,-4.5],demonym:"Manx",landlocked:!1,borders:[],area:572,flag:"🇮🇲"},{name:{common:"India",official:"Republic of India",native:{eng:{official:"Republic of India",common:"India"},hin:{official:"भारत गणराज्य",common:"भारत"},tam:{official:"இந்தியக் குடியரசு",common:"இந்தியா"}}},tld:[".in"],cca2:"IN",ccn3:"356",cca3:"IND",cioc:"IND",independent:!0,status:"officially-assigned",currency:["INR"],callingCode:["91"],capital:["New Delhi"],altSpellings:["IN","Bhārat","Republic of India","Bharat Ganrajya","இந்தியா"],region:"Asia",subregion:"Southern Asia",languages:{eng:"English",hin:"Hindi",tam:"Tamil"},translations:{deu:{official:"Republik Indien",common:"Indien"},fra:{official:"République de l'Inde",common:"Inde"},hrv:{official:"Republika Indija",common:"Indija"},ita:{official:"Repubblica dell'India",common:"India"},jpn:{official:"インド共和国",common:"インド"},nld:{official:"Republiek India",common:"India"},por:{official:"República da Índia",common:"Índia"},rus:{official:"Республика Индия",common:"Индия"},slk:{official:"Indická republika",common:"India"},spa:{official:"República de la India",common:"India"},fin:{official:"Intian tasavalta",common:"Intia"},est:{official:"India Vabariik",common:"India"},zho:{official:"印度共和国",common:"印度"}},latlng:[20,77],demonym:"Indian",landlocked:!1,borders:["BGD","BTN","MMR","CHN","NPL","PAK"],area:3287590,flag:"🇮🇳"},{name:{common:"British Indian Ocean Territory",official:"British Indian Ocean Territory",native:{eng:{official:"British Indian Ocean Territory",common:"British Indian Ocean Territory"}}},tld:[".io"],cca2:"IO",ccn3:"086",cca3:"IOT",cioc:"",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["246"],capital:["Diego Garcia"],altSpellings:["IO"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English"},translations:{cym:{official:"Tiriogaeth Brydeinig Cefnfor India",common:"Tiriogaeth Brydeinig Cefnfor India"},deu:{official:"Britisch-Indischer Ozean",common:"Britisches Territorium im Indischen Ozean"},fra:{official:"Territoire britannique de l' océan Indien",common:"Territoire britannique de l'océan Indien"},hrv:{official:"British Indian Ocean Territory",common:"Britanski Indijskooceanski teritorij"},ita:{official:"Territorio britannico dell'Oceano Indiano",common:"Territorio britannico dell'oceano indiano"},jpn:{official:"イギリス領インド洋地域",common:"イギリス領インド洋地域"},nld:{official:"Brits Indische Oceaan Territorium",common:"Britse Gebieden in de Indische Oceaan"},por:{official:"British Indian Ocean Territory",common:"Território Britânico do Oceano Índico"},rus:{official:"Британская территория Индийского океана",common:"Британская территория в Индийском океане"},slk:{official:"Britské indickooceánske územie",common:"Britské indickooceánske územie"},spa:{official:"Territorio Británico del Océano Índico",common:"Territorio Británico del Océano Índico"},fin:{official:"Brittiläinen Intian valtameren alue",common:"Brittiläinen Intian valtameren alue"},est:{official:"Briti India ookeani ala",common:"Briti India ookeani ala"},zho:{official:"英属印度洋领地",common:"英属印度洋领地"}},latlng:[-6,71.5],demonym:"Indian",landlocked:!1,borders:[],area:60,flag:"🇮🇴"},{name:{common:"Ireland",official:"Republic of Ireland",native:{eng:{official:"Republic of Ireland",common:"Ireland"},gle:{official:"Poblacht na hÉireann",common:"Éire"}}},tld:[".ie"],cca2:"IE",ccn3:"372",cca3:"IRL",cioc:"IRL",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["353"],capital:["Dublin"],altSpellings:["IE","Éire","Republic of Ireland","Poblacht na hÉireann"],region:"Europe",subregion:"Northern Europe",languages:{eng:"English",gle:"Irish"},translations:{deu:{official:"Republik Irland",common:"Irland"},fra:{official:"République d'Irlande",common:"Irlande"},hrv:{official:"Republika Irska",common:"Irska"},ita:{official:"Repubblica d'Irlanda",common:"Irlanda"},jpn:{official:"アイルランド共和国",common:"アイルランド"},nld:{official:"Republic of Ireland",common:"Ierland"},por:{official:"República da Irlanda",common:"Irlanda"},rus:{official:"Ирландия",common:"Ирландия"},slk:{official:"Írska republika",common:"Írsko"},spa:{official:"República de Irlanda",common:"Irlanda"},fin:{official:"Irlannin tasavalta",common:"Irlanti"},est:{official:"Iirimaa",common:"Iirimaa"},zho:{official:"爱尔兰共和国",common:"爱尔兰"}},latlng:[53,-8],demonym:"Irish",landlocked:!1,borders:["GBR"],area:70273,flag:"🇮🇪"},{name:{common:"Iran",official:"Islamic Republic of Iran",native:{fas:{official:"جمهوری اسلامی ایران",common:"ایران"}}},tld:[".ir","ایران."],cca2:"IR",ccn3:"364",cca3:"IRN",cioc:"IRI",independent:!0,status:"officially-assigned",currency:["IRR"],callingCode:["98"],capital:["Tehran"],altSpellings:["IR","Islamic Republic of Iran","Iran, Islamic Republic of","Jomhuri-ye Eslāmi-ye Irān"],region:"Asia",subregion:"Southern Asia",languages:{fas:"Persian"},translations:{deu:{official:"Islamische Republik Iran",common:"Iran"},fra:{official:"République islamique d'Iran",common:"Iran"},hrv:{official:"Islamska Republika Iran",common:"Iran"},ita:{official:"Repubblica islamica dell'Iran",common:"Iran"},jpn:{official:"イラン·イスラム共和国",common:"イラン・イスラム共和国"},nld:{official:"Islamitische Republiek Iran",common:"Iran"},por:{official:"República Islâmica do Irã",common:"Irão"},rus:{official:"Исламская Республика Иран",common:"Иран"},slk:{official:"Iránska islamská republika",common:"Irán"},spa:{official:"República Islámica de Irán",common:"Iran"},fin:{official:"Iranin islamilainen tasavalta",common:"Iran"},est:{official:"Iraani Islamivabariik",common:"Iraan"},zho:{official:"伊朗伊斯兰共和国",common:"伊朗"}},latlng:[32,53],demonym:"Iranian",landlocked:!1,borders:["AFG","ARM","AZE","IRQ","PAK","TUR","TKM"],area:1648195,flag:"🇮🇷"},{name:{common:"Iraq",official:"Republic of Iraq",native:{ara:{official:"جمهورية العراق",common:"العراق"},arc:{official:"ܩܘܼܛܢܵܐ ܐܝܼܪܲܩ",common:"ܩܘܼܛܢܵܐ"},ckb:{official:"کۆماری عێراق",common:"کۆماری"}}},tld:[".iq"],cca2:"IQ",ccn3:"368",cca3:"IRQ",cioc:"IRQ",independent:!0,status:"officially-assigned",currency:["IQD"],callingCode:["964"],capital:["Baghdad"],altSpellings:["IQ","Republic of Iraq","Jumhūriyyat al-‘Irāq"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic",arc:"Aramaic",ckb:"Sorani"},translations:{deu:{official:"Republik Irak",common:"Irak"},fra:{official:"République d'Irak",common:"Irak"},hrv:{official:"Republika Irak",common:"Irak"},ita:{official:"Repubblica dell'Iraq",common:"Iraq"},jpn:{official:"イラク共和国",common:"イラク"},nld:{official:"Republiek Irak",common:"Irak"},por:{official:"República do Iraque",common:"Iraque"},rus:{official:"Республика Ирак",common:"Ирак"},slk:{official:"Iracká republika",common:"Irak"},spa:{official:"República de Irak",common:"Irak"},fin:{official:"Irakin tasavalta",common:"Irak"},est:{official:"Iraagi Vabariik",common:"Iraak"},zho:{official:"伊拉克共和国",common:"伊拉克"}},latlng:[33,44],demonym:"Iraqi",landlocked:!1,borders:["IRN","JOR","KWT","SAU","SYR","TUR"],area:438317,flag:"🇮🇶"},{name:{common:"Iceland",official:"Iceland",native:{isl:{official:"Ísland",common:"Ísland"}}},tld:[".is"],cca2:"IS",ccn3:"352",cca3:"ISL",cioc:"ISL",independent:!0,status:"officially-assigned",currency:["ISK"],callingCode:["354"],capital:["Reykjavik"],altSpellings:["IS","Island","Republic of Iceland","Lýðveldið Ísland"],region:"Europe",subregion:"Northern Europe",languages:{isl:"Icelandic"},translations:{deu:{official:"Island",common:"Island"},fra:{official:"République d'Islande",common:"Islande"},hrv:{official:"Island",common:"Island"},ita:{official:"Islanda",common:"Islanda"},jpn:{official:"アイスランド",common:"アイスランド"},nld:{official:"IJsland",common:"IJsland"},por:{official:"Islândia",common:"Islândia"},rus:{official:"Исландия",common:"Исландия"},slk:{official:"Islandská republika",common:"Island"},spa:{official:"Islandia",common:"Islandia"},fin:{official:"Islanti",common:"Islanti"},est:{official:"Islandi Vabariik",common:"Island"},zho:{official:"冰岛",common:"冰岛"}},latlng:[65,-18],demonym:"Icelander",landlocked:!1,borders:[],area:103e3,flag:"🇮🇸"},{name:{common:"Israel",official:"State of Israel",native:{ara:{official:"دولة إسرائيل",common:"إسرائيل"},heb:{official:"מדינת ישראל",common:"ישראל"}}},tld:[".il"],cca2:"IL",ccn3:"376",cca3:"ISR",cioc:"ISR",independent:!0,status:"officially-assigned",currency:["ILS"],callingCode:["972"],capital:["Jerusalem"],altSpellings:["IL","State of Israel","Medīnat Yisrā'el"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic",heb:"Hebrew"},translations:{deu:{official:"Staat Israel",common:"Israel"},fra:{official:"État d'Israël",common:"Israël"},hrv:{official:"Država Izrael",common:"Izrael"},ita:{official:"Stato di Israele",common:"Israele"},jpn:{official:"イスラエル国",common:"イスラエル"},nld:{official:"Staat Israël",common:"Israël"},por:{official:"Estado de Israel",common:"Israel"},rus:{official:"Государство Израиль",common:"Израиль"},slk:{official:"Izraelský štát",common:"Izrael"},spa:{official:"Estado de Israel",common:"Israel"},fin:{official:"Israelin valtio",common:"Israel"},est:{official:"Iisraeli Riik",common:"Iisrael"},zho:{official:"以色列国",common:"以色列"}},latlng:[31.47,35.13],demonym:"Israeli",landlocked:!1,borders:["EGY","JOR","LBN","PSE","SYR"],area:20770,flag:"🇮🇱"},{name:{common:"Italy",official:"Italian Republic",native:{ita:{official:"Repubblica italiana",common:"Italia"}}},tld:[".it"],cca2:"IT",ccn3:"380",cca3:"ITA",cioc:"ITA",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["39"],capital:["Rome"],altSpellings:["IT","Italian Republic","Repubblica italiana"],region:"Europe",subregion:"Southern Europe",languages:{ita:"Italian"},translations:{deu:{official:"Italienische Republik",common:"Italien"},fra:{official:"République italienne",common:"Italie"},hrv:{official:"talijanska Republika",common:"Italija"},ita:{official:"Repubblica italiana",common:"Italia"},jpn:{official:"イタリア共和国",common:"イタリア"},nld:{official:"Italiaanse Republiek",common:"Italië"},por:{official:"República Italiana",common:"Itália"},rus:{official:"итальянская Республика",common:"Италия"},slk:{official:"Talianska republika",common:"Taliansko"},spa:{official:"República Italiana",common:"Italia"},fin:{official:"Italian tasavalta",common:"Italia"},est:{official:"Itaalia Vabariik",common:"Itaalia"},zho:{official:"意大利共和国",common:"意大利"}},latlng:[42.83333333,12.83333333],demonym:"Italian",landlocked:!1,borders:["AUT","FRA","SMR","SVN","CHE","VAT"],area:301336,flag:"🇮🇹"},{name:{common:"Jamaica",official:"Jamaica",native:{eng:{official:"Jamaica",common:"Jamaica"},jam:{official:"Jamaica",common:"Jamaica"}}},tld:[".jm"],cca2:"JM",ccn3:"388",cca3:"JAM",cioc:"JAM",independent:!0,status:"officially-assigned",currency:["JMD"],callingCode:["1876"],capital:["Kingston"],altSpellings:["JM"],region:"Americas",subregion:"Caribbean",languages:{eng:"English",jam:"Jamaican Patois"},translations:{deu:{official:"Jamaika",common:"Jamaika"},fra:{official:"Jamaïque",common:"Jamaïque"},hrv:{official:"Jamajka",common:"Jamajka"},ita:{official:"Giamaica",common:"Giamaica"},jpn:{official:"ジャマイカ",common:"ジャマイカ"},nld:{official:"Jamaica",common:"Jamaica"},por:{official:"Jamaica",common:"Jamaica"},rus:{official:"Ямайка",common:"Ямайка"},slk:{official:"Jamajka",common:"Jamajka"},spa:{official:"Jamaica",common:"Jamaica"},fin:{official:"Jamaika",common:"Jamaika"},est:{official:"Jamaica",common:"Jamaica"},zho:{official:"牙买加",common:"牙买加"}},latlng:[18.25,-77.5],demonym:"Jamaican",landlocked:!1,borders:[],area:10991,flag:"🇯🇲"},{name:{common:"Jersey",official:"Bailiwick of Jersey",native:{eng:{official:"Bailiwick of Jersey",common:"Jersey"},fra:{official:"Bailliage de Jersey",common:"Jersey"},nrf:{official:"Bailliage dé Jèrri",common:"Jèrri"}}},tld:[".je"],cca2:"JE",ccn3:"832",cca3:"JEY",cioc:"",independent:!1,status:"officially-assigned",currency:["GBP"],callingCode:["44"],capital:["Saint Helier"],altSpellings:["JE","Bailiwick of Jersey","Bailliage de Jersey","Bailliage dé Jèrri"],region:"Europe",subregion:"Northern Europe",languages:{eng:"English",fra:"French",nrf:"Jèrriais"},translations:{deu:{official:"Vogtei Jersey",common:"Jersey"},fra:{official:"Bailliage de Jersey",common:"Jersey"},hrv:{official:"Struka od Jersey",common:"Jersey"},ita:{official:"Baliato di Jersey",common:"Isola di Jersey"},jpn:{official:"ジャージの得意分野",common:"ジャージー"},nld:{official:"Baljuwschap Jersey",common:"Jersey"},por:{official:"Bailiado de Jersey",common:"Jersey"},rus:{official:"Коронное владение Джерси",common:"Джерси"},slk:{official:"Bailiwick Jersey",common:"Jersey"},spa:{official:"Bailía de Jersey",common:"Jersey"},fin:{official:"Jersey",common:"Jersey"},est:{official:"Jersey foogtkond",common:"Jersey"},zho:{official:"泽西岛",common:"泽西岛"}},latlng:[49.25,-2.16666666],demonym:"Channel Islander",landlocked:!1,borders:[],area:116,flag:"🇯🇪"},{name:{common:"Jordan",official:"Hashemite Kingdom of Jordan",native:{ara:{official:"المملكة الأردنية الهاشمية",common:"الأردن"}}},tld:[".jo","الاردن."],cca2:"JO",ccn3:"400",cca3:"JOR",cioc:"JOR",independent:!0,status:"officially-assigned",currency:["JOD"],callingCode:["962"],capital:["Amman"],altSpellings:["JO","Hashemite Kingdom of Jordan","al-Mamlakah al-Urdunīyah al-Hāshimīyah"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Haschemitisches Königreich Jordanien",common:"Jordanien"},fra:{official:"Royaume hachémite de Jordanie",common:"Jordanie"},hrv:{official:"Hašemitske Kraljevine Jordan",common:"Jordan"},ita:{official:"Regno hascemita di Giordania",common:"Giordania"},jpn:{official:"ヨルダン·ハシミテ王国",common:"ヨルダン"},nld:{official:"Hasjemitisch Koninkrijk Jordanië",common:"Jordanië"},por:{official:"Reino Hachemita da Jordânia",common:"Jordânia"},rus:{official:"Иорданского Хашимитского Королевства",common:"Иордания"},slk:{official:"Jordánske hášimovské kráľovstvo",common:"Jordánsko"},spa:{official:"Reino Hachemita de Jordania",common:"Jordania"},fin:{official:"Jordanian hašemiittinen kunigaskunta",common:"Jordania"},est:{official:"Jordaania Hašimiidi Kuningriik",common:"Jordaania"},zho:{official:"约旦哈希姆王国",common:"约旦"}},latlng:[31,36],demonym:"Jordanian",landlocked:!1,borders:["IRQ","ISR","PSE","SAU","SYR"],area:89342,flag:"🇯🇴"},{name:{common:"Japan",official:"Japan",native:{jpn:{official:"日本",common:"日本"}}},tld:[".jp",".みんな"],cca2:"JP",ccn3:"392",cca3:"JPN",cioc:"JPN",independent:!0,status:"officially-assigned",currency:["JPY"],callingCode:["81"],capital:["Tokyo"],altSpellings:["JP","Nippon","Nihon"],region:"Asia",subregion:"Eastern Asia",languages:{jpn:"Japanese"},translations:{deu:{official:"Japan",common:"Japan"},fra:{official:"Japon",common:"Japon"},hrv:{official:"Japan",common:"Japan"},ita:{official:"Giappone",common:"Giappone"},jpn:{official:"日本",common:"日本"},nld:{official:"Japan",common:"Japan"},por:{official:"Japão",common:"Japão"},rus:{official:"Япония",common:"Япония"},slk:{official:"Japonsko",common:"Japonsko"},spa:{official:"Japón",common:"Japón"},fin:{official:"Japani",common:"Japani"},est:{official:"Jaapan",common:"Jaapan"},zho:{official:"日本国",common:"日本"}},latlng:[36,138],demonym:"Japanese",landlocked:!1,borders:[],area:377930,flag:"🇯🇵"},{name:{common:"Kazakhstan",official:"Republic of Kazakhstan",native:{kaz:{official:"Қазақстан Республикасы",common:"Қазақстан"},rus:{official:"Республика Казахстан",common:"Казахстан"}}},tld:[".kz",".қаз"],cca2:"KZ",ccn3:"398",cca3:"KAZ",cioc:"KAZ",independent:!0,status:"officially-assigned",currency:["KZT"],callingCode:["76","77"],capital:["Astana"],altSpellings:["KZ","Qazaqstan","Казахстан","Republic of Kazakhstan","Қазақстан Республикасы","Qazaqstan Respublïkası","Республика Казахстан","Respublika Kazakhstan"],region:"Asia",subregion:"Central Asia",languages:{kaz:"Kazakh",rus:"Russian"},translations:{deu:{official:"Republik Kasachstan",common:"Kasachstan"},fra:{official:"République du Kazakhstan",common:"Kazakhstan"},hrv:{official:"Republika Kazahstan",common:"Kazahstan"},ita:{official:"Repubblica del Kazakhstan",common:"Kazakistan"},jpn:{official:"カザフスタン共和国",common:"カザフスタン"},nld:{official:"Republiek Kazachstan",common:"Kazachstan"},por:{official:"República do Cazaquistão",common:"Cazaquistão"},rus:{official:"Республика Казахстан",common:"Казахстан"},slk:{official:"Kazašská republika",common:"Kazachstan"},spa:{official:"República de Kazajstán",common:"Kazajistán"},fin:{official:"Kazakstanin tasavalta",common:"Kazakstan"},est:{official:"Kasahstani Vabariik",common:"Kasahstan"},zho:{official:"哈萨克斯坦共和国",common:"哈萨克斯坦"}},latlng:[48,68],demonym:"Kazakhstani",landlocked:!0,borders:["CHN","KGZ","RUS","TKM","UZB"],area:2724900,flag:"🇰🇿"},{name:{common:"Kenya",official:"Republic of Kenya",native:{eng:{official:"Republic of Kenya",common:"Kenya"},swa:{official:"Republic of Kenya",common:"Kenya"}}},tld:[".ke"],cca2:"KE",ccn3:"404",cca3:"KEN",cioc:"KEN",independent:!0,status:"officially-assigned",currency:["KES"],callingCode:["254"],capital:["Nairobi"],altSpellings:["KE","Republic of Kenya","Jamhuri ya Kenya"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English",swa:"Swahili"},translations:{deu:{official:"Republik Kenia",common:"Kenia"},fra:{official:"République du Kenya",common:"Kenya"},hrv:{official:"Republika Kenija",common:"Kenija"},ita:{official:"Repubblica del Kenya",common:"Kenya"},jpn:{official:"ケニア共和国",common:"ケニア"},nld:{official:"Republiek Kenia",common:"Kenia"},por:{official:"República do Quénia",common:"Quénia"},rus:{official:"Республика Кения",common:"Кения"},slk:{official:"Kenská republika",common:"Keňa"},spa:{official:"República de Kenya",common:"Kenia"},fin:{official:"Kenian tasavalta",common:"Kenia"},est:{official:"Keenia Vabariik",common:"Keenia"},zho:{official:"肯尼亚共和国",common:"肯尼亚"}},latlng:[1,38],demonym:"Kenyan",landlocked:!1,borders:["ETH","SOM","SSD","TZA","UGA"],area:580367,flag:"🇰🇪"},{name:{common:"Kyrgyzstan",official:"Kyrgyz Republic",native:{kir:{official:"Кыргыз Республикасы",common:"Кыргызстан"},rus:{official:"Кыргызская Республика",common:"Киргизия"}}},tld:[".kg"],cca2:"KG",ccn3:"417",cca3:"KGZ",cioc:"KGZ",independent:!0,status:"officially-assigned",currency:["KGS"],callingCode:["996"],capital:["Bishkek"],altSpellings:["KG","Киргизия","Kyrgyz Republic","Кыргыз Республикасы","Kyrgyz Respublikasy"],region:"Asia",subregion:"Central Asia",languages:{kir:"Kyrgyz",rus:"Russian"},translations:{deu:{official:"Kirgisische Republik",common:"Kirgisistan"},fra:{official:"République kirghize",common:"Kirghizistan"},hrv:{official:"Kirgistanu",common:"Kirgistan"},ita:{official:"Kirghizistan",common:"Kirghizistan"},jpn:{official:"キルギス共和国",common:"キルギス"},nld:{official:"Kirgizische Republiek",common:"Kirgizië"},por:{official:"República do Quirguistão",common:"Quirguistão"},rus:{official:"Кыргызская Республика",common:"Киргизия"},slk:{official:"Kirgizská republika",common:"Kirgizsko"},spa:{official:"República Kirguisa",common:"Kirguizistán"},fin:{official:"Kirgisian tasavalta",common:"Kirgisia"},est:{official:"Kirgiisi Vabariik",common:"Kõrgõzstan"},zho:{official:"吉尔吉斯斯坦共和国",common:"吉尔吉斯斯坦"}},latlng:[41,75],demonym:"Kirghiz",landlocked:!0,borders:["CHN","KAZ","TJK","UZB"],area:199951,flag:"🇰🇬"},{name:{common:"Cambodia",official:"Kingdom of Cambodia",native:{khm:{official:"ព្រះរាជាណាចក្រកម្ពុជា",common:"Kâmpŭchéa"}}},tld:[".kh"],cca2:"KH",ccn3:"116",cca3:"KHM",cioc:"CAM",independent:!0,status:"officially-assigned",currency:["KHR"],callingCode:["855"],capital:["Phnom Penh"],altSpellings:["KH","Kingdom of Cambodia"],region:"Asia",subregion:"South-Eastern Asia",languages:{khm:"Khmer"},translations:{cym:{official:"Teyrnas Cambodia",common:"Cambodia"},deu:{official:"Königreich Kambodscha",common:"Kambodscha"},fra:{official:"Royaume du Cambodge",common:"Cambodge"},hrv:{official:"Kraljevina Kambodža",common:"Kambodža"},ita:{official:"Regno di Cambogia",common:"Cambogia"},jpn:{official:"カンボジア王国",common:"カンボジア"},nld:{official:"Koninkrijk Cambodja",common:"Cambodja"},por:{official:"Reino do Camboja",common:"Camboja"},rus:{official:"Королевство Камбоджа",common:"Камбоджа"},slk:{official:"Kamboǆské kráľovstvo",common:"Kamboǆa"},spa:{official:"Reino de Camboya",common:"Camboya"},fin:{official:"Kambodžan kuningaskunta",common:"Kambodža"},est:{official:"Kambodža Kuningriik",common:"Kambodža"},zho:{official:"柬埔寨王国",common:"柬埔寨"}},latlng:[13,105],demonym:"Cambodian",landlocked:!1,borders:["LAO","THA","VNM"],area:181035,flag:"🇰🇭"},{name:{common:"Kiribati",official:"Independent and Sovereign Republic of Kiribati",native:{eng:{official:"Independent and Sovereign Republic of Kiribati",common:"Kiribati"},gil:{official:"Ribaberiki Kiribati",common:"Kiribati"}}},tld:[".ki"],cca2:"KI",ccn3:"296",cca3:"KIR",cioc:"KIR",independent:!0,status:"officially-assigned",currency:["AUD"],callingCode:["686"],capital:["South Tarawa"],altSpellings:["KI","Republic of Kiribati","Ribaberiki Kiribati"],region:"Oceania",subregion:"Micronesia",languages:{eng:"English",gil:"Gilbertese"},translations:{deu:{official:"Unabhängige und souveräne Republik Kiribati",common:"Kiribati"},fra:{official:"République de Kiribati",common:"Kiribati"},hrv:{official:"Samostalne i suverene Republike Kiribati",common:"Kiribati"},ita:{official:"Repubblica indipendente e sovrano di Kiribati",common:"Kiribati"},jpn:{official:"キリバスの独立と主権共和国",common:"キリバス"},nld:{official:"Onafhankelijke en soevereine republiek Kiribati",common:"Kiribati"},por:{official:"Independente e soberano República de Kiribati",common:"Kiribati"},rus:{official:"Независимой и суверенной Республики Кирибати",common:"Кирибати"},slk:{official:"Kiribatská republika",common:"Kiribati"},spa:{official:"República Independiente y Soberano de Kiribati",common:"Kiribati"},fin:{official:"Kiribatin tasavalta",common:"Kiribati"},est:{official:"Kiribati Vabariik",common:"Kiribati"},zho:{official:"基里巴斯共和国",common:"基里巴斯"}},latlng:[1.41666666,173],demonym:"I-Kiribati",landlocked:!1,borders:[],area:811,flag:"🇰🇮"},{name:{common:"Saint Kitts and Nevis",official:"Federation of Saint Christopher and Nevisa",native:{eng:{official:"Federation of Saint Christopher and Nevisa",common:"Saint Kitts and Nevis"}}},tld:[".kn"],cca2:"KN",ccn3:"659",cca3:"KNA",cioc:"SKN",independent:!0,status:"officially-assigned",currency:["XCD"],callingCode:["1869"],capital:["Basseterre"],altSpellings:["KN","Federation of Saint Christopher and Nevis"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Föderation von Saint Kitts und Nevisa",common:"Saint Christopher und Nevis"},fra:{official:"Fédération de Saint -Christophe-et Nevisa",common:"Saint-Christophe-et-Niévès"},hrv:{official:"Federacija Sv.Kristofora i Nevisa",common:"Sveti Kristof i Nevis"},ita:{official:"Federazione di Saint Christopher e Nevisa",common:"Saint Kitts e Nevis"},jpn:{official:"セントクリストファーNevisa連盟",common:"セントクリストファー・ネイビス"},nld:{official:"Federatie van Saint Kitts en Nevisa",common:"Saint Kitts en Nevis"},por:{official:"Federação de São Cristóvão e Nevisa",common:"São Cristóvão e Nevis"},rus:{official:"Федерация Сент-Кристофер и Nevisa",common:"Сент-Китс и Невис"},slk:{official:"Feder໡cia Svätého Krištofa a Nevisu",common:"Svätý Krištof a Nevis"},spa:{official:"Federación de San Cristóbal y Nevisa",common:"San Cristóbal y Nieves"},fin:{official:"Saint Christopherin ja Nevisin federaatio",common:"Saint Kitts ja Nevis"},est:{official:"Saint Kittsi ja Nevise Föderatsioon",common:"Saint Kitts ja Nevis"},zho:{official:"圣克里斯托弗和尼维斯联邦",common:"圣基茨和尼维斯"}},latlng:[17.33333333,-62.75],demonym:"Kittitian or Nevisian",landlocked:!1,borders:[],area:261,flag:"🇰🇳"},{name:{common:"South Korea",official:"Republic of Korea",native:{kor:{official:"한국",common:"대한민국"}}},tld:[".kr",".한국"],cca2:"KR",ccn3:"410",cca3:"KOR",cioc:"KOR",independent:!0,status:"officially-assigned",currency:["KRW"],callingCode:["82"],capital:["Seoul"],altSpellings:["KR","Korea, Republic of","Republic of Korea"],region:"Asia",subregion:"Eastern Asia",languages:{kor:"Korean"},translations:{deu:{official:"Republik Korea",common:"Südkorea"},fra:{official:"République de Corée",common:"Corée du Sud"},hrv:{official:"Republika Koreja",common:"Južna Koreja"},ita:{official:"Repubblica di Corea",common:"Corea del Sud"},jpn:{official:"大韓民国",common:"大韓民国"},nld:{official:"Republiek Korea",common:"Zuid-Korea"},por:{official:"República da Coreia",common:"Coreia do Sul"},rus:{official:"Республика Корея",common:"Южная Корея"},slk:{official:"Kórejská republika",common:"Južná Kórea"},spa:{official:"República de Corea",common:"Corea del Sur"},fin:{official:"Korean tasavalta",common:"Etelä-Korea"},est:{official:"Korea Vabariik",common:"Lõuna-Korea"},zho:{official:"大韩民国",common:"韩国"}},latlng:[37,127.5],demonym:"South Korean",landlocked:!1,borders:["PRK"],area:100210,flag:"🇰🇷"},{name:{common:"Kosovo",official:"Republic of Kosovo",native:{sqi:{official:"Republika e Kosovës",common:"Kosova"},srp:{official:"Република Косово",common:"Косово"}}},tld:[],cca2:"XK",ccn3:"",cca3:"UNK",cioc:"KOS",independent:null,status:"user-assigned",currency:["EUR"],callingCode:["383"],capital:["Pristina"],altSpellings:["XK","Република Косово"],region:"Europe",subregion:"Eastern Europe",languages:{sqi:"Albanian",srp:"Serbian"},translations:{deu:{official:"Republik Kosovo",common:"Kosovo"},fra:{official:"République du Kosovo",common:"Kosovo"},hrv:{official:"Republika Kosovo",common:"Kosovo"},ita:{official:"Repubblica del Kosovo",common:"Kosovo"},nld:{official:"Republiek Kosovo",common:"Kosovo"},por:{official:"República do Kosovo",common:"Kosovo"},rus:{official:"Республика Косово",common:"Республика Косово"},slk:{official:"Republika Kosovo",common:"Kosovo"},spa:{official:"República de Kosovo",common:"Kosovo"},fin:{official:"Kosovon tasavalta",common:"Kosovo"},est:{official:"Kosovo Vabariik",common:"Kosovo"},zho:{official:"科索沃共和国",common:"科索沃"}},latlng:[42.666667,21.166667],demonym:"Kosovar",landlocked:!0,borders:["ALB","MKD","MNE","SRB"],area:10908,flag:"🇽🇰"},{name:{common:"Kuwait",official:"State of Kuwait",native:{ara:{official:"دولة الكويت",common:"الكويت"}}},tld:[".kw"],cca2:"KW",ccn3:"414",cca3:"KWT",cioc:"KUW",independent:!0,status:"officially-assigned",currency:["KWD"],callingCode:["965"],capital:["Kuwait City"],altSpellings:["KW","State of Kuwait","Dawlat al-Kuwait"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Staat Kuwait",common:"Kuwait"},fra:{official:"État du Koweït",common:"Koweït"},hrv:{official:"Država Kuvajt",common:"Kuvajt"},ita:{official:"Stato del Kuwait",common:"Kuwait"},jpn:{official:"クウェート国",common:"クウェート"},nld:{official:"Staat Koeweit",common:"Koeweit"},por:{official:"Estado do Kuwait",common:"Kuwait"},rus:{official:"Государство Кувейт",common:"Кувейт"},slk:{official:"Kuvajtský štát",common:"Kuvajt"},spa:{official:"Estado de Kuwait",common:"Kuwait"},fin:{official:"Kuwaitin valtio",common:"Kuwait"},est:{official:"Kuveidi Riik",common:"Kuveit"},zho:{official:"科威特国",common:"科威特"}},latlng:[29.5,45.75],demonym:"Kuwaiti",landlocked:!1,borders:["IRQ","SAU"],area:17818,flag:"🇰🇼"},{name:{common:"Laos",official:"Lao People's Democratic Republic",native:{lao:{official:"ສາທາລະນະ ຊາທິປະໄຕ ຄົນລາວ ຂອງ",common:"ສປປລາວ"}}},tld:[".la"],cca2:"LA",ccn3:"418",cca3:"LAO",cioc:"LAO",independent:!0,status:"officially-assigned",currency:["LAK"],callingCode:["856"],capital:["Vientiane"],altSpellings:["LA","Lao","Lao People's Democratic Republic","Sathalanalat Paxathipatai Paxaxon Lao"],region:"Asia",subregion:"South-Eastern Asia",languages:{lao:"Lao"},translations:{deu:{official:"Laos, Demokratische Volksrepublik",common:"Laos"},fra:{official:"République démocratique populaire lao",common:"Laos"},hrv:{official:"Narodna Demokratska Republika",common:"Laos"},ita:{official:"Repubblica democratica popolare del Laos",common:"Laos"},jpn:{official:"ラオス人民民主共和国",common:"ラオス人民民主共和国"},nld:{official:"Lao Democratische Volksrepubliek",common:"Laos"},por:{official:"Laos, República Democrática",common:"Laos"},rus:{official:"Лаосская Народно-Демократическая Республика",common:"Лаос"},slk:{official:"Laoská ľudovodemokratická republika",common:"Laos"},spa:{official:"República Democrática Popular Lao",common:"Laos"},fin:{official:"Laosin demokraattinen kansantasavalta",common:"Laos"},est:{official:"Laose Demokraatlik Rahvavabariik",common:"Laos"},zho:{official:"老挝人民民主共和国",common:"老挝"}},latlng:[18,105],demonym:"Laotian",landlocked:!0,borders:["MMR","KHM","CHN","THA","VNM"],area:236800,flag:"🇱🇦"},{name:{common:"Lebanon",official:"Lebanese Republic",native:{ara:{official:"الجمهورية اللبنانية",common:"لبنان"},fra:{official:"République libanaise",common:"Liban"}}},tld:[".lb"],cca2:"LB",ccn3:"422",cca3:"LBN",cioc:"LIB",independent:!0,status:"officially-assigned",currency:["LBP"],callingCode:["961"],capital:["Beirut"],altSpellings:["LB","Lebanese Republic","Al-Jumhūrīyah Al-Libnānīyah"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic",fra:"French"},translations:{deu:{official:"Libanesische Republik",common:"Libanon"},fra:{official:"République libanaise",common:"Liban"},hrv:{official:"Libanonska Republika",common:"Libanon"},ita:{official:"Repubblica libanese",common:"Libano"},jpn:{official:"レバノン共和国",common:"レバノン"},nld:{official:"Libanese Republiek",common:"Libanon"},por:{official:"República Libanesa",common:"Líbano"},rus:{official:"Ливанская Республика",common:"Ливан"},slk:{official:"Libanonská republika",common:"Libanon"},spa:{official:"República Libanesa",common:"Líbano"},fin:{official:"Libanonin tasavalta",common:"Libanon"},est:{official:"Liibanoni Vabariik",common:"Liibanon"},zho:{official:"黎巴嫩共和国",common:"黎巴嫩"}},latlng:[33.83333333,35.83333333],demonym:"Lebanese",landlocked:!1,borders:["ISR","SYR"],area:10452,flag:"🇱🇧"},{name:{common:"Liberia",official:"Republic of Liberia",native:{eng:{official:"Republic of Liberia",common:"Liberia"}}},tld:[".lr"],cca2:"LR",ccn3:"430",cca3:"LBR",cioc:"LBR",independent:!0,status:"officially-assigned",currency:["LRD"],callingCode:["231"],capital:["Monrovia"],altSpellings:["LR","Republic of Liberia"],region:"Africa",subregion:"Western Africa",languages:{eng:"English"},translations:{deu:{official:"Republik Liberia",common:"Liberia"},fra:{official:"République du Libéria",common:"Liberia"},hrv:{official:"Republika Liberija",common:"Liberija"},ita:{official:"Repubblica di Liberia",common:"Liberia"},jpn:{official:"リベリア共和国",common:"リベリア"},nld:{official:"Republiek Liberia",common:"Liberia"},por:{official:"República da Libéria",common:"Libéria"},rus:{official:"Республика Либерия",common:"Либерия"},slk:{official:"Libérijská republika",common:"Libéria"},spa:{official:"República de Liberia",common:"Liberia"},fin:{official:"Liberian tasavalta",common:"Liberia"},est:{official:"Libeeria Vabariik",common:"Libeeria"},zho:{official:"利比里亚共和国",common:"利比里亚"}},latlng:[6.5,-9.5],demonym:"Liberian",landlocked:!1,borders:["GIN","CIV","SLE"],area:111369,flag:"🇱🇷"},{name:{common:"Libya",official:"State of Libya",native:{ara:{official:"الدولة ليبيا",common:"‏ليبيا"}}},tld:[".ly"],cca2:"LY",ccn3:"434",cca3:"LBY",cioc:"LBA",independent:!0,status:"officially-assigned",currency:["LYD"],callingCode:["218"],capital:["Tripoli"],altSpellings:["LY","State of Libya","Dawlat Libya"],region:"Africa",subregion:"Northern Africa",languages:{ara:"Arabic"},translations:{deu:{official:"Staat Libyen",common:"Libyen"},fra:{official:"Grande République arabe libyenne populaire et socialiste",common:"Libye"},hrv:{official:"Država Libiji",common:"Libija"},ita:{official:"Stato della Libia",common:"Libia"},jpn:{official:"リビアの国家",common:"リビア"},nld:{official:"Staat van Libië",common:"Libië"},por:{official:"Estado da Líbia",common:"Líbia"},rus:{official:"Государство Ливии",common:"Ливия"},slk:{official:"Líbya",common:"Líbya"},spa:{official:"Estado de Libia",common:"Libia"},fin:{official:"Libyan valtio",common:"Libya"},est:{official:"Liibüa",common:"Liibüa"},zho:{official:"利比亚国",common:"利比亚"}},latlng:[25,17],demonym:"Libyan",landlocked:!1,borders:["DZA","TCD","EGY","NER","SDN","TUN"],area:1759540,flag:"🇱🇾"},{name:{common:"Saint Lucia",official:"Saint Lucia",native:{eng:{official:"Saint Lucia",common:"Saint Lucia"}}},tld:[".lc"],cca2:"LC",ccn3:"662",cca3:"LCA",cioc:"LCA",independent:!0,status:"officially-assigned",currency:["XCD"],callingCode:["1758"],capital:["Castries"],altSpellings:["LC"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"St. Lucia",common:"Saint Lucia"},fra:{official:"Sainte-Lucie",common:"Sainte-Lucie"},hrv:{official:"Sveta Lucija",common:"Sveta Lucija"},ita:{official:"Santa Lucia",common:"Santa Lucia"},jpn:{official:"セントルシア",common:"セントルシア"},nld:{official:"Saint Lucia",common:"Saint Lucia"},por:{official:"Santa Lúcia",common:"Santa Lúcia"},rus:{official:"Сент-Люсия",common:"Сент-Люсия"},slk:{official:"Svätá Lucia",common:"Svätá Lucia"},spa:{official:"Santa Lucía",common:"Santa Lucía"},fin:{official:"Saint Lucia",common:"Saint Lucia"},est:{official:"Saint Lucia",common:"Saint Lucia"},zho:{official:"圣卢西亚",common:"圣卢西亚"}},latlng:[13.88333333,-60.96666666],demonym:"Saint Lucian",landlocked:!1,borders:[],area:616,flag:"🇱🇨"},{name:{common:"Liechtenstein",official:"Principality of Liechtenstein",native:{deu:{official:"Fürstentum Liechtenstein",common:"Liechtenstein"}}},tld:[".li"],cca2:"LI",ccn3:"438",cca3:"LIE",cioc:"LIE",independent:!0,status:"officially-assigned",currency:["CHF"],callingCode:["423"],capital:["Vaduz"],altSpellings:["LI","Principality of Liechtenstein","Fürstentum Liechtenstein"],region:"Europe",subregion:"Western Europe",languages:{deu:"German"},translations:{deu:{official:"Fürstentum Liechtenstein",common:"Liechtenstein"},fra:{official:"Principauté du Liechtenstein",common:"Liechtenstein"},hrv:{official:"Kneževina Lihtenštajn",common:"Lihtenštajn"},ita:{official:"Principato del Liechtenstein",common:"Liechtenstein"},jpn:{official:"リヒテンシュタイン公国",common:"リヒテンシュタイン"},nld:{official:"Vorstendom Liechtenstein",common:"Liechtenstein"},por:{official:"Principado de Liechtenstein",common:"Liechtenstein"},rus:{official:"Княжество Лихтенштейн",common:"Лихтенштейн"},slk:{official:"Lichtenštajnské kniežatstvo",common:"Lichtenštajnsko"},spa:{official:"Principado de Liechtenstein",common:"Liechtenstein"},fin:{official:"Liechensteinin ruhtinaskunta",common:"Liechenstein"},est:{official:"Liechtensteini Vürstiriik",common:"Liechtenstein"},zho:{official:"列支敦士登公国",common:"列支敦士登"}},latlng:[47.26666666,9.53333333],demonym:"Liechtensteiner",landlocked:!0,borders:["AUT","CHE"],area:160,flag:"🇱🇮"},{name:{common:"Sri Lanka",official:"Democratic Socialist Republic of Sri Lanka",native:{sin:{official:"ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජය",common:"ශ්‍රී ලංකාව"},tam:{official:"இலங்கை சனநாயக சோசலிசக் குடியரசு",common:"இலங்கை"}}},tld:[".lk",".இலங்கை",".ලංකා"],cca2:"LK",ccn3:"144",cca3:"LKA",cioc:"SRI",independent:!0,status:"officially-assigned",currency:["LKR"],callingCode:["94"],capital:["Colombo"],altSpellings:["LK","ilaṅkai","Democratic Socialist Republic of Sri Lanka"],region:"Asia",subregion:"Southern Asia",languages:{sin:"Sinhala",tam:"Tamil"},translations:{deu:{official:"Demokratische Sozialistische Republik Sri Lanka",common:"Sri Lanka"},fra:{official:"République démocratique socialiste du Sri Lanka",common:"Sri Lanka"},hrv:{official:"Demokratska Socijalističke Republike Šri Lanke",common:"Šri Lanka"},ita:{official:"Repubblica democratica socialista dello Sri Lanka",common:"Sri Lanka"},jpn:{official:"スリランカ民主社会主義共和国",common:"スリランカ"},nld:{official:"Democratische Socialistische Republiek Sri Lanka",common:"Sri Lanka"},por:{official:"República Democrática Socialista do Sri Lanka",common:"Sri Lanka"},rus:{official:"Демократическая Социалистическая Республика Шри-Ланка",common:"Шри-Ланка"},slk:{official:"Srílanská demokratická socialistická republika",common:"Srí Lanka"},spa:{official:"República Democrática Socialista de Sri Lanka",common:"Sri Lanka"},fin:{official:"Sri Lankan demokraattinen sosialistinen tasavalta",common:"Sri Lanka"},est:{official:"Sri Lanka Demokraatlik Sotsialistlik Vabariik",common:"Sri Lanka"},zho:{official:"斯里兰卡民主社会主义共和国",common:"斯里兰卡"}},latlng:[7,81],demonym:"Sri Lankan",landlocked:!1,borders:["IND"],area:65610,flag:"🇱🇰"},{name:{common:"Lesotho",official:"Kingdom of Lesotho",native:{eng:{official:"Kingdom of Lesotho",common:"Lesotho"},sot:{official:"Kingdom of Lesotho",common:"Lesotho"}}},tld:[".ls"],cca2:"LS",ccn3:"426",cca3:"LSO",cioc:"LES",independent:!0,status:"officially-assigned",currency:["LSL","ZAR"],callingCode:["266"],capital:["Maseru"],altSpellings:["LS","Kingdom of Lesotho","Muso oa Lesotho"],region:"Africa",subregion:"Southern Africa",languages:{eng:"English",sot:"Sotho"},translations:{deu:{official:"Königreich Lesotho",common:"Lesotho"},fra:{official:"Royaume du Lesotho",common:"Lesotho"},hrv:{official:"Kraljevina Lesoto",common:"Lesoto"},ita:{official:"Regno del Lesotho",common:"Lesotho"},jpn:{official:"レソト王国",common:"レソト"},nld:{official:"Koninkrijk Lesotho",common:"Lesotho"},por:{official:"Reino do Lesoto",common:"Lesoto"},rus:{official:"Королевство Лесото",common:"Лесото"},slk:{official:"Lesothské kráľovstvo",common:"Lesotho"},spa:{official:"Reino de Lesotho",common:"Lesotho"},fin:{official:"Lesothon kuningaskunta",common:"Lesotho"},est:{official:"Lesotho Kuningriik",common:"Lesotho"},zho:{official:"莱索托王国",common:"莱索托"}},latlng:[-29.5,28.5],demonym:"Mosotho",landlocked:!0,borders:["ZAF"],area:30355,flag:"🇱🇸"},{name:{common:"Lithuania",official:"Republic of Lithuania",native:{lit:{official:"Lietuvos Respublikos",common:"Lietuva"}}},tld:[".lt"],cca2:"LT",ccn3:"440",cca3:"LTU",cioc:"LTU",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["370"],capital:["Vilnius"],altSpellings:["LT","Republic of Lithuania","Lietuvos Respublika"],region:"Europe",subregion:"Northern Europe",languages:{lit:"Lithuanian"},translations:{deu:{official:"Republik Litauen",common:"Litauen"},fra:{official:"République de Lituanie",common:"Lituanie"},hrv:{official:"Republika Litva",common:"Litva"},ita:{official:"Repubblica di Lituania",common:"Lituania"},jpn:{official:"リトアニア共和国",common:"リトアニア"},nld:{official:"Republiek Litouwen",common:"Litouwen"},por:{official:"República da Lituânia",common:"Lituânia"},rus:{official:"Литовская Республика",common:"Литва"},slk:{official:"Litovská republika",common:"Litva"},spa:{official:"República de Lituania",common:"Lituania"},fin:{official:"Liettuan tasavalta",common:"Liettua"},est:{official:"Leedu Vabariik",common:"Leedu"},zho:{official:"立陶宛共和国",common:"立陶宛"}},latlng:[56,24],demonym:"Lithuanian",landlocked:!1,borders:["BLR","LVA","POL","RUS"],area:65300,flag:"🇱🇹"},{name:{common:"Luxembourg",official:"Grand Duchy of Luxembourg",native:{deu:{official:"Großherzogtum Luxemburg",common:"Luxemburg"},fra:{official:"Grand-Duché de Luxembourg",common:"Luxembourg"},ltz:{official:"Groussherzogtum Lëtzebuerg",common:"Lëtzebuerg"}}},tld:[".lu"],cca2:"LU",ccn3:"442",cca3:"LUX",cioc:"LUX",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["352"],capital:["Luxembourg"],altSpellings:["LU","Grand Duchy of Luxembourg","Grand-Duché de Luxembourg","Großherzogtum Luxemburg","Groussherzogtum Lëtzebuerg"],region:"Europe",subregion:"Western Europe",languages:{deu:"German",fra:"French",ltz:"Luxembourgish"},translations:{deu:{official:"Großherzogtum Luxemburg,",common:"Luxemburg"},fra:{official:"Grand-Duché de Luxembourg",common:"Luxembourg"},hrv:{official:"Veliko Vojvodstvo Luksemburg",common:"Luksemburg"},ita:{official:"Granducato di Lussemburgo",common:"Lussemburgo"},jpn:{official:"ルクセンブルク大公国",common:"ルクセンブルク"},nld:{official:"Groothertogdom Luxemburg",common:"Luxemburg"},por:{official:"Grão-Ducado do Luxemburgo",common:"Luxemburgo"},rus:{official:"Великое Герцогство Люксембург",common:"Люксембург"},slk:{official:"Luxemburské veľkovojvodstvo",common:"Luxembursko"},spa:{official:"Gran Ducado de Luxemburgo",common:"Luxemburgo"},fin:{official:"Luxemburgin suurherttuakunta",common:"Luxemburg"},est:{official:"Luksemburgi Suurhertsogiriik",common:"Luksemburg"},zho:{official:"卢森堡大公国",common:"卢森堡"}},latlng:[49.75,6.16666666],demonym:"Luxembourger",landlocked:!0,borders:["BEL","FRA","DEU"],area:2586,flag:"🇱🇺"},{name:{common:"Latvia",official:"Republic of Latvia",native:{lav:{official:"Latvijas Republikas",common:"Latvija"}}},tld:[".lv"],cca2:"LV",ccn3:"428",cca3:"LVA",cioc:"LAT",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["371"],capital:["Riga"],altSpellings:["LV","Republic of Latvia","Latvijas Republika"],region:"Europe",subregion:"Northern Europe",languages:{lav:"Latvian"},translations:{deu:{official:"Republik Lettland",common:"Lettland"},fra:{official:"République de Lettonie",common:"Lettonie"},hrv:{official:"Republika Latvija",common:"Latvija"},ita:{official:"Repubblica di Lettonia",common:"Lettonia"},jpn:{official:"ラトビア共和国",common:"ラトビア"},nld:{official:"Republiek Letland",common:"Letland"},por:{official:"República da Letónia",common:"Letónia"},rus:{official:"Латвийская Республика",common:"Латвия"},slk:{official:"Lotyšská republika",common:"Lotyšsko"},spa:{official:"República de Letonia",common:"Letonia"},fin:{official:"Latvian tasavalta",common:"Latvia"},est:{official:"Läti Vabariik",common:"Läti"},zho:{official:"拉脱维亚共和国",common:"拉脱维亚"}},latlng:[57,25],demonym:"Latvian",landlocked:!1,borders:["BLR","EST","LTU","RUS"],area:64559,flag:"🇱🇻"},{name:{common:"Macau",official:"Macao Special Administrative Region of the People's Republic of China",native:{por:{official:"Região Administrativa Especial de Macau da República Popular da China",common:"Macau"},zho:{official:"中华人民共和国澳门特别行政区",common:"澳门"}}},tld:[".mo"],cca2:"MO",ccn3:"446",cca3:"MAC",cioc:"",independent:!1,status:"officially-assigned",currency:["MOP"],callingCode:["853"],capital:[""],altSpellings:["MO","澳门","Macao","Macao Special Administrative Region of the People's Republic of China","中華人民共和國澳門特別行政區","Região Administrativa Especial de Macau da República Popular da China"],region:"Asia",subregion:"Eastern Asia",languages:{por:"Portuguese",zho:"Chinese"},translations:{deu:{official:"Sonderverwaltungsregion Macau der Volksrepublik China",common:"Macao"},fra:{official:"Région administrative spéciale de Macao de la République populaire de Chine",common:"Macao"},hrv:{official:"Makao Posebnog upravnog područjaNarodne Republike Kine",common:"Makao"},ita:{official:"Macao Regione amministrativa speciale della Repubblica Popolare Cinese",common:"Macao"},jpn:{official:"中華人民共和国マカオ特別行政区",common:"マカオ"},nld:{official:"Speciale Administratieve Regio Macau van de Volksrepubliek China",common:"Macao"},por:{official:"Macau Região Administrativa Especial da República Popular da China",common:"Macau"},rus:{official:"Специальный административный район Макао Китайской Народной Республики Китай",common:"Макао"},slk:{official:"Macao, Špeciàlna administratívna oblasŦ",common:"Macao"},spa:{official:"Macao, Región Administrativa Especial de la República Popular China",common:"Macao"},fin:{official:"Macaon Kiinan kansantasavallan erityishallintoalue",common:"Macao"},est:{official:"Macau erihalduspiirkond",common:"Macau"}},latlng:[22.16666666,113.55],demonym:"Chinese",landlocked:!1,borders:["CHN"],area:30,flag:"🇲🇴"},{name:{common:"Saint Martin",official:"Saint Martin",native:{fra:{official:"Saint-Martin",common:"Saint-Martin"}}},tld:[".fr",".gp"],cca2:"MF",ccn3:"663",cca3:"MAF",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["590"],capital:["Marigot"],altSpellings:["MF","Collectivity of Saint Martin","Collectivité de Saint-Martin","Saint Martin (French part)"],region:"Americas",subregion:"Caribbean",languages:{fra:"French"},translations:{deu:{official:"St. Martin",common:"Saint Martin"},fra:{official:"Saint-Martin",common:"Saint-Martin"},hrv:{official:"Saint Martin",common:"Sveti Martin"},ita:{official:"saint Martin",common:"Saint Martin"},jpn:{official:"サンマルタン島",common:"サン・マルタン（フランス領）"},nld:{official:"Saint Martin",common:"Saint-Martin"},por:{official:"saint Martin",common:"São Martinho"},rus:{official:"Сен-Мартен",common:"Сен-Мартен"},slk:{official:"Saint-Martin",common:"Saint-Martin"},spa:{official:"Saint Martin",common:"Saint Martin"},fin:{official:"Saint-Martin",common:"Saint-Martin"},est:{official:"Saint-Martini ühendus",common:"Saint-Martin"},zho:{official:"圣马丁",common:"圣马丁"}},latlng:[18.08333333,-63.95],demonym:"Saint Martin Islander",landlocked:!1,borders:["SXM"],area:53,flag:"🇲🇫"},{name:{common:"Morocco",official:"Kingdom of Morocco",native:{ara:{official:"المملكة المغربية",common:"المغرب"},ber:{official:"ⵜⴰⴳⵍⴷⵉⵜ ⵏ ⵍⵎⵖⵔⵉⴱ",common:"ⵍⵎⴰⵖⵔⵉⴱ"}}},tld:[".ma","المغرب."],cca2:"MA",ccn3:"504",cca3:"MAR",cioc:"MAR",independent:!0,status:"officially-assigned",currency:["MAD"],callingCode:["212"],capital:["Rabat"],altSpellings:["MA","Kingdom of Morocco","Al-Mamlakah al-Maġribiyah"],region:"Africa",subregion:"Northern Africa",languages:{ara:"Arabic",ber:"Berber"},translations:{deu:{official:"Königreich Marokko",common:"Marokko"},fra:{official:"Royaume du Maroc",common:"Maroc"},hrv:{official:"Kraljevina Maroko",common:"Maroko"},ita:{official:"Regno del Marocco",common:"Marocco"},jpn:{official:"モロッコ王国",common:"モロッコ"},nld:{official:"Koninkrijk Marokko",common:"Marokko"},por:{official:"Reino de Marrocos",common:"Marrocos"},rus:{official:"Королевство Марокко",common:"Марокко"},slk:{official:"Marocké kniežatstvo",common:"Maroko"},spa:{official:"Reino de Marruecos",common:"Marruecos"},fin:{official:"Marokon kuningaskunta",common:"Marokko"},est:{official:"Maroko Kuningriik",common:"Maroko"},zho:{official:"摩洛哥王国",common:"摩洛哥"}},latlng:[32,-5],demonym:"Moroccan",landlocked:!1,borders:["DZA","ESH","ESP"],area:446550,flag:"🇲🇦"},{name:{common:"Monaco",official:"Principality of Monaco",native:{fra:{official:"Principauté de Monaco",common:"Monaco"}}},tld:[".mc"],cca2:"MC",ccn3:"492",cca3:"MCO",cioc:"MON",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["377"],capital:["Monaco"],altSpellings:["MC","Principality of Monaco","Principauté de Monaco"],region:"Europe",subregion:"Western Europe",languages:{fra:"French"},translations:{deu:{official:"Fürstentum Monaco",common:"Monaco"},fra:{official:"Principauté de Monaco",common:"Monaco"},hrv:{official:"Kneževina Monako",common:"Monako"},ita:{official:"Principato di Monaco",common:"Principato di Monaco"},jpn:{official:"モナコ公国",common:"モナコ"},nld:{official:"Vorstendom Monaco",common:"Monaco"},por:{official:"Principado do Mónaco",common:"Mónaco"},rus:{official:"Княжество Монако",common:"Монако"},slk:{official:"Monacké kniežatstvo",common:"Monako"},spa:{official:"Principado de Mónaco",common:"Mónaco"},fin:{official:"Monacon ruhtinaskunta",common:"Monaco"},est:{official:"Monaco Vürstiriik",common:"Monaco"},zho:{official:"摩纳哥公国",common:"摩纳哥"}},latlng:[43.73333333,7.4],demonym:"Monegasque",landlocked:!1,borders:["FRA"],area:2.02,flag:"🇲🇨"},{name:{common:"Moldova",official:"Republic of Moldova",native:{ron:{official:"Republica Moldova",common:"Moldova"}}},tld:[".md"],cca2:"MD",ccn3:"498",cca3:"MDA",cioc:"MDA",independent:!0,status:"officially-assigned",currency:["MDL"],callingCode:["373"],capital:["Chișinău"],altSpellings:["MD","Moldova, Republic of","Republic of Moldova","Republica Moldova"],region:"Europe",subregion:"Eastern Europe",languages:{ron:"Moldavian"},translations:{deu:{official:"Republik Moldau",common:"Moldawie"},fra:{official:"République de Moldavie",common:"Moldavie"},hrv:{official:"Moldavija",common:"Moldova"},ita:{official:"Repubblica di Moldova",common:"Moldavia"},jpn:{official:"モルドバ共和国",common:"モルドバ共和国"},nld:{official:"Republiek Moldavië",common:"Moldavië"},por:{official:"República da Moldávia",common:"Moldávia"},rus:{official:"Молдова",common:"Молдавия"},slk:{official:"Moldavská republika",common:"Moldavsko"},spa:{official:"República de Moldova",common:"Moldavia"},fin:{official:"Moldovan tasavalta",common:"Moldova"},est:{official:"Moldova Vabariik",common:"Moldova"},zho:{official:"摩尔多瓦共和国",common:"摩尔多瓦"}},latlng:[47,29],demonym:"Moldovan",landlocked:!0,borders:["ROU","UKR"],area:33846,flag:"🇲🇩"},{name:{common:"Madagascar",official:"Republic of Madagascar",native:{fra:{official:"République de Madagascar",common:"Madagascar"},mlg:{official:"Repoblikan'i Madagasikara",common:"Madagasikara"}}},tld:[".mg"],cca2:"MG",ccn3:"450",cca3:"MDG",cioc:"MAD",independent:!0,status:"officially-assigned",currency:["MGA"],callingCode:["261"],capital:["Antananarivo"],altSpellings:["MG","Republic of Madagascar","Repoblikan'i Madagasikara","République de Madagascar"],region:"Africa",subregion:"Eastern Africa",languages:{fra:"French",mlg:"Malagasy"},translations:{deu:{official:"Republik Madagaskar",common:"Madagaskar"},fra:{official:"République de Madagascar",common:"Madagascar"},hrv:{official:"Republika Madagaskar",common:"Madagaskar"},ita:{official:"Repubblica del Madagascar",common:"Madagascar"},jpn:{official:"マダガスカル共和国",common:"マダガスカル"},nld:{official:"Republiek Madagaskar",common:"Madagaskar"},por:{official:"República de Madagáscar",common:"Madagáscar"},rus:{official:"Республика Мадагаскар",common:"Мадагаскар"},slk:{official:"Madagaskarská republika",common:"Madagaskar"},spa:{official:"República de Madagascar",common:"Madagascar"},fin:{official:"Madagaskarin tasavalta",common:"Madagaskar"},est:{official:"Madagaskari Vabariik",common:"Madagaskar"},zho:{official:"马达加斯加共和国",common:"马达加斯加"}},latlng:[-20,47],demonym:"Malagasy",landlocked:!1,borders:[],area:587041,flag:"🇲🇬"},{name:{common:"Maldives",official:"Republic of the Maldives",native:{div:{official:"ދިވެހިރާއްޖޭގެ ޖުމްހޫރިއްޔާ",common:"ދިވެހިރާއްޖޭގެ"}}},tld:[".mv"],cca2:"MV",ccn3:"462",cca3:"MDV",cioc:"MDV",independent:!0,status:"officially-assigned",currency:["MVR"],callingCode:["960"],capital:["Malé"],altSpellings:["MV","Maldive Islands","Republic of the Maldives","Dhivehi Raajjeyge Jumhooriyya"],region:"Asia",subregion:"Southern Asia",languages:{div:"Maldivian"},translations:{deu:{official:"Republik Malediven",common:"Malediven"},fra:{official:"République des Maldives",common:"Maldives"},hrv:{official:"Republika Maldivi",common:"Maldivi"},ita:{official:"Repubblica delle Maldive",common:"Maldive"},jpn:{official:"モルディブ共和国",common:"モルディブ"},nld:{official:"Republiek van de Malediven",common:"Maldiven"},por:{official:"República das Maldivas",common:"Maldivas"},spa:{official:"República de las Maldivas",common:"Maldivas"},rus:{official:"Республика Мальдивы",common:"Мальдивы"},slk:{official:"Maldivská republika",common:"Maldivy"},fin:{official:"Malediivien tasavalta",common:"Malediivit"},est:{official:"Maldiivi Vabariik",common:"Maldiivid"},zho:{official:"马尔代夫共和国",common:"马尔代夫"}},latlng:[3.25,73],demonym:"Maldivan",landlocked:!1,borders:[],area:300,flag:"🇲🇻"},{name:{common:"Mexico",official:"United Mexican States",native:{spa:{official:"Estados Unidos Mexicanos",common:"México"}}},tld:[".mx"],cca2:"MX",ccn3:"484",cca3:"MEX",cioc:"MEX",independent:!0,status:"officially-assigned",currency:["MXN"],callingCode:["52"],capital:["Mexico City"],altSpellings:["MX","Mexicanos","United Mexican States","Estados Unidos Mexicanos"],region:"Americas",subregion:"Northern America",languages:{spa:"Spanish"},translations:{deu:{official:"Vereinigte Mexikanische Staaten",common:"Mexiko"},fra:{official:"États-Unis du Mexique",common:"Mexique"},hrv:{official:"Sjedinjene Meksičke Države",common:"Meksiko"},ita:{official:"Stati Uniti del Messico",common:"Messico"},jpn:{official:"メキシコ合衆国",common:"メキシコ"},nld:{official:"Verenigde Mexicaanse Staten",common:"Mexico"},por:{official:"Estados Unidos Mexicanos",common:"México"},rus:{official:"Мексиканские Соединённые Штаты",common:"Мексика"},slk:{official:"Spojené štášy mexické",common:"Mexiko"},spa:{official:"Estados Unidos Mexicanos",common:"México"},fin:{official:"Meksikon yhdysvallat",common:"Meksiko"},est:{official:"Mehhiko Ühendriigid",common:"Mehhiko"},zho:{official:"墨西哥合众国",common:"墨西哥"}},latlng:[23,-102],demonym:"Mexican",landlocked:!1,borders:["BLZ","GTM","USA"],area:1964375,flag:"🇲🇽"},{name:{common:"Marshall Islands",official:"Republic of the Marshall Islands",native:{eng:{official:"Republic of the Marshall Islands",common:"Marshall Islands"},mah:{official:"Republic of the Marshall Islands",common:"M̧ajeļ"}}},tld:[".mh"],cca2:"MH",ccn3:"584",cca3:"MHL",cioc:"MHL",independent:!0,status:"officially-assigned",currency:["USD"],callingCode:["692"],capital:["Majuro"],altSpellings:["MH","Republic of the Marshall Islands","Aolepān Aorōkin M̧ajeļ"],region:"Oceania",subregion:"Micronesia",languages:{eng:"English",mah:"Marshallese"},translations:{deu:{official:"Republik der Marshall-Inseln",common:"Marshallinseln"},fra:{official:"République des Îles Marshall",common:"Îles Marshall"},hrv:{official:"Republika Maršalovi Otoci",common:"Maršalovi Otoci"},ita:{official:"Repubblica delle Isole Marshall",common:"Isole Marshall"},jpn:{official:"マーシャル諸島共和国",common:"マーシャル諸島"},nld:{official:"Republiek van de Marshall-eilanden",common:"Marshalleilanden"},por:{official:"República das Ilhas Marshall",common:"Ilhas Marshall"},rus:{official:"Республика Маршалловы острова",common:"Маршалловы Острова"},slk:{official:"Republika Marshallových ostrovov",common:"Marshallove ostrovy"},spa:{official:"República de las Islas Marshall",common:"Islas Marshall"},fin:{official:"Marshallinsaarten tasavalta",common:"Marshallinsaaret"},est:{official:"Marshalli Saarte Vabariik",common:"Marshalli Saared"},zho:{official:"马绍尔群岛共和国",common:"马绍尔群岛"}},latlng:[9,168],demonym:"Marshallese",landlocked:!1,borders:[],area:181,flag:"🇲🇭"},{name:{common:"Macedonia",official:"Republic of Macedonia",native:{mkd:{official:"Република Македонија",common:"Македонија"}}},tld:[".mk"],cca2:"MK",ccn3:"807",cca3:"MKD",cioc:"MKD",independent:!0,status:"officially-assigned",currency:["MKD"],callingCode:["389"],capital:["Skopje"],altSpellings:["MK","Macedonia, the Former Yugoslav Republic of","Republic of Macedonia","Република Македонија"],region:"Europe",subregion:"Southern Europe",languages:{mkd:"Macedonian"},translations:{deu:{official:"Republik Mazedonien",common:"Mazedonien"},fra:{official:"République de Macédoine",common:"Macédoine"},hrv:{official:"Republika Makedonija",common:"Makedonija"},ita:{official:"Repubblica di Macedonia",common:"Macedonia"},jpn:{official:"マケドニア共和国",common:"マケドニア旧ユーゴスラビア共和国"},nld:{official:"Republic of Macedonia",common:"Macedonië"},por:{official:"República da Macedónia",common:"Macedónia"},rus:{official:"Республика Македония",common:"Республика Македония"},slk:{official:"Macedónska republika",common:"Macedónsko"},spa:{official:"República de Macedonia",common:"Macedonia"},fin:{official:"Makedonian tasavalta",common:"Makedonia"},est:{official:"Makedoonia Vabariik",common:"Makedoonia"},zho:{official:"马其顿共和国",common:"马其顿"}},latlng:[41.83333333,22],demonym:"Macedonian",landlocked:!0,borders:["ALB","BGR","GRC","UNK","SRB"],area:25713,flag:"🇲🇰"},{name:{common:"Mali",official:"Republic of Mali",native:{fra:{official:"République du Mali",common:"Mali"}}},tld:[".ml"],cca2:"ML",ccn3:"466",cca3:"MLI",cioc:"MLI",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["223"],capital:["Bamako"],altSpellings:["ML","Republic of Mali","République du Mali"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{deu:{official:"Republik Mali",common:"Mali"},fra:{official:"République du Mali",common:"Mali"},hrv:{official:"Republika Mali",common:"Mali"},ita:{official:"Repubblica del Mali",common:"Mali"},jpn:{official:"マリ共和国",common:"マリ"},nld:{official:"Republiek Mali",common:"Mali"},por:{official:"República do Mali",common:"Mali"},rus:{official:"Республика Мали",common:"Мали"},slk:{official:"Malijská republika",common:"Mali"},spa:{official:"República de Malí",common:"Mali"},fin:{official:"Malin tasavalta",common:"Mali"},est:{official:"Mali Vabariik",common:"Mali"},zho:{official:"马里共和国",common:"马里"}},latlng:[17,-4],demonym:"Malian",landlocked:!0,borders:["DZA","BFA","GIN","CIV","MRT","NER","SEN"],area:1240192,flag:"🇲🇱"},{name:{common:"Malta",official:"Republic of Malta",native:{eng:{official:"Republic of Malta",common:"Malta"},mlt:{official:"Repubblika ta ' Malta",common:"Malta"}}},tld:[".mt"],cca2:"MT",ccn3:"470",cca3:"MLT",cioc:"MLT",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["356"],capital:["Valletta"],altSpellings:["MT","Republic of Malta","Repubblika ta' Malta"],region:"Europe",subregion:"Southern Europe",languages:{eng:"English",mlt:"Maltese"},translations:{deu:{official:"Republik Malta",common:"Malta"},fra:{official:"République de Malte",common:"Malte"},hrv:{official:"Republika Malta",common:"Malta"},ita:{official:"Repubblica di Malta",common:"Malta"},jpn:{official:"マルタ共和国",common:"マルタ"},nld:{official:"Republiek Malta",common:"Malta"},por:{official:"República de Malta",common:"Malta"},rus:{official:"Республика Мальта",common:"Мальта"},slk:{official:"Maltská republika",common:"Malta"},spa:{official:"República de Malta",common:"Malta"},fin:{official:"Maltan tasavalta",common:"Malta"},est:{official:"Malta Vabariik",common:"Malta"},zho:{official:"马耳他共和国",common:"马耳他"}},latlng:[35.83333333,14.58333333],demonym:"Maltese",landlocked:!1,borders:[],area:316,flag:"🇲🇹"},{name:{common:"Myanmar",official:"Republic of the Union of Myanmar",native:{mya:{official:"ပြည်ထောင်စု သမ္မတ မြန်မာနိုင်ငံတော်",common:"မြန်မာ"}}},tld:[".mm"],cca2:"MM",ccn3:"104",cca3:"MMR",cioc:"MYA",independent:!0,status:"officially-assigned",currency:["MMK"],callingCode:["95"],capital:["Naypyidaw"],altSpellings:["MM","Burma","Republic of the Union of Myanmar","Pyidaunzu Thanmăda Myăma Nainngandaw"],region:"Asia",subregion:"South-Eastern Asia",languages:{mya:"Burmese"},translations:{deu:{official:"Republik der Union von Myanmar",common:"Myanmar"},fra:{official:"République de l'Union du Myanmar",common:"Birmanie"},hrv:{official:"Republika Unije Mijanmar",common:"Mijanmar"},ita:{official:"Repubblica dell'Unione di Myanmar",common:"Birmania"},jpn:{official:"ミャンマー連邦共和国",common:"ミャンマー"},nld:{official:"Republiek van de Unie van Myanmar",common:"Myanmar"},por:{official:"República da União de Myanmar",common:"Myanmar"},rus:{official:"Республика Союза Мьянма",common:"Мьянма"},slk:{official:"Mjanmarská zväzová republika",common:"Mjanmarsko"},spa:{official:"República de la Unión de Myanmar",common:"Myanmar"},fin:{official:"Myanmarin liiton tasavalta",common:"Myanmar"},est:{official:"Myanmari Liidu Vabariik",common:"Myanmar"},zho:{official:"缅甸联邦共和国",common:"缅甸"}},latlng:[22,98],demonym:"Bamar",landlocked:!1,borders:["BGD","CHN","IND","LAO","THA"],area:676578,flag:"🇲🇲"},{name:{common:"Montenegro",official:"Montenegro",native:{srp:{official:"Црна Гора",common:"Црна Гора"}}},tld:[".me"],cca2:"ME",ccn3:"499",cca3:"MNE",cioc:"MNE",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["382"],capital:["Podgorica"],altSpellings:["ME","Crna Gora"],region:"Europe",subregion:"Southern Europe",languages:{srp:"Montenegrin"},translations:{deu:{official:"Montenegro",common:"Montenegro"},fra:{official:"Monténégro",common:"Monténégro"},hrv:{official:"Crna Gora",common:"Crna Gora"},ita:{official:"Montenegro",common:"Montenegro"},jpn:{official:"モンテネグロ",common:"モンテネグロ"},nld:{official:"Montenegro",common:"Montenegro"},por:{official:"Montenegro",common:"Montenegro"},rus:{official:"Черногория",common:"Черногория"},slk:{official:"Čierna Hora",common:"Čierna Hora"},spa:{official:"Montenegro",common:"Montenegro"},fin:{official:"Montenegro",common:"Montenegro"},est:{official:"Montenegro",common:"Montenegro"},zho:{official:"黑山",common:"黑山"}},latlng:[42.5,19.3],demonym:"Montenegrin",landlocked:!1,borders:["ALB","BIH","HRV","UNK","SRB"],area:13812,flag:"🇲🇪"},{name:{common:"Mongolia",official:"Mongolia",native:{mon:{official:"Монгол улс",common:"Монгол улс"}}},tld:[".mn"],cca2:"MN",ccn3:"496",cca3:"MNG",cioc:"MGL",independent:!0,status:"officially-assigned",currency:["MNT"],callingCode:["976"],capital:["Ulan Bator"],altSpellings:["MN"],region:"Asia",subregion:"Eastern Asia",languages:{mon:"Mongolian"},translations:{deu:{official:"Mongolei",common:"Mongolei"},fra:{official:"Mongolie",common:"Mongolie"},hrv:{official:"Mongolija",common:"Mongolija"},ita:{official:"Mongolia",common:"Mongolia"},jpn:{official:"モンゴル",common:"モンゴル"},nld:{official:"Mongolië",common:"Mongolië"},por:{official:"Mongólia",common:"Mongólia"},rus:{official:"Монголия",common:"Монголия"},slk:{official:"Mongolsko",common:"Mongolsko"},spa:{official:"Mongolia",common:"Mongolia"},fin:{official:"Mongolian tasavalta",common:"Mongolia"},est:{official:"Mongoolia",common:"Mongoolia"},zho:{official:"蒙古",common:"蒙古"}},latlng:[46,105],demonym:"Mongolian",landlocked:!0,borders:["CHN","RUS"],area:1564110,flag:"🇲🇳"},{name:{common:"Northern Mariana Islands",official:"Commonwealth of the Northern Mariana Islands",native:{cal:{official:"Commonwealth of the Northern Mariana Islands",common:"Northern Mariana Islands"},cha:{official:"Sankattan Siha Na Islas Mariånas",common:"Na Islas Mariånas"},eng:{official:"Commonwealth of the Northern Mariana Islands",common:"Northern Mariana Islands"}}},tld:[".mp"],cca2:"MP",ccn3:"580",cca3:"MNP",cioc:"",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1670"],capital:["Saipan"],altSpellings:["MP","Commonwealth of the Northern Mariana Islands","Sankattan Siha Na Islas Mariånas"],region:"Oceania",subregion:"Micronesia",languages:{cal:"Carolinian",cha:"Chamorro",eng:"English"},translations:{deu:{official:"Commonwealth der Nördlichen Marianen",common:"Nördliche Marianen"},fra:{official:"Commonwealth des îles Mariannes du Nord",common:"Îles Mariannes du Nord"},hrv:{official:"Zajednica je Sjeverni Marijanski otoci",common:"Sjevernomarijanski otoci"},ita:{official:"Commonwealth delle Isole Marianne Settentrionali",common:"Isole Marianne Settentrionali"},jpn:{official:"北マリアナ諸島",common:"北マリアナ諸島"},nld:{official:"Commonwealth van de Noordelijke Marianen",common:"Noordelijke Marianeneilanden"},por:{official:"Comunidade das Ilhas Marianas do Norte",common:"Marianas Setentrionais"},rus:{official:"Содружество Северных Марианских островов",common:"Северные Марианские острова"},slk:{official:"Spoločenstvo ostrovov Severné Mariány",common:"Severné Mariány"},spa:{official:"Mancomunidad de las Islas Marianas del Norte",common:"Islas Marianas del Norte"},fin:{official:"Pohjois-Mariaanit",common:"Pohjois-Mariaanit"},est:{official:"Põhja-Mariaani Ühendus",common:"Põhja-Mariaanid"},zho:{official:"北马里亚纳群岛",common:"北马里亚纳群岛"}},latlng:[15.2,145.75],demonym:"American",landlocked:!1,borders:[],area:464,flag:"🇲🇵"},{name:{common:"Mozambique",official:"Republic of Mozambique",native:{por:{official:"República de Moçambique",common:"Moçambique"}}},tld:[".mz"],cca2:"MZ",ccn3:"508",cca3:"MOZ",cioc:"MOZ",independent:!0,status:"officially-assigned",currency:["MZN"],callingCode:["258"],capital:["Maputo"],altSpellings:["MZ","Republic of Mozambique","República de Moçambique"],region:"Africa",subregion:"Eastern Africa",languages:{por:"Portuguese"},translations:{deu:{official:"Republik Mosambik",common:"Mosambik"},fra:{official:"République du Mozambique",common:"Mozambique"},hrv:{official:"Republika Mozambiku",common:"Mozambik"},ita:{official:"Repubblica del Mozambico",common:"Mozambico"},jpn:{official:"モザンビーク共和国",common:"モザンビーク"},nld:{official:"Republiek Mozambique",common:"Mozambique"},por:{official:"República de Moçambique",common:"Moçambique"},rus:{official:"Республика Мозамбик",common:"Мозамбик"},slk:{official:"Mozambická republika",common:"Mozambik"},spa:{official:"República de Mozambique",common:"Mozambique"},fin:{official:"Mosambikin tasavalta",common:"Mosambik"},est:{official:"Mosambiigi Vabariik",common:"Mosambiik"},zho:{official:"莫桑比克共和国",common:"莫桑比克"}},latlng:[-18.25,35],demonym:"Mozambican",landlocked:!1,borders:["MWI","ZAF","SWZ","TZA","ZMB","ZWE"],area:801590,flag:"🇲🇿"},{name:{common:"Mauritania",official:"Islamic Republic of Mauritania",native:{ara:{official:"الجمهورية الإسلامية الموريتانية",common:"موريتانيا"}}},tld:[".mr"],cca2:"MR",ccn3:"478",cca3:"MRT",cioc:"MTN",independent:!0,status:"officially-assigned",currency:["MRO"],callingCode:["222"],capital:["Nouakchott"],altSpellings:["MR","Islamic Republic of Mauritania","al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah"],region:"Africa",subregion:"Western Africa",languages:{ara:"Arabic"},translations:{deu:{official:"Islamische Republik Mauretanien",common:"Mauretanien"},fra:{official:"République islamique de Mauritanie",common:"Mauritanie"},hrv:{official:"Islamska Republika Mauritanija",common:"Mauritanija"},ita:{official:"Repubblica islamica di Mauritania",common:"Mauritania"},jpn:{official:"モーリタニア·イスラム共和国",common:"モーリタニア"},nld:{official:"Islamitische Republiek Mauritanië",common:"Mauritanië"},por:{official:"República Islâmica da Mauritânia",common:"Mauritânia"},rus:{official:"Исламская Республика Мавритания",common:"Мавритания"},slk:{official:"Mauritánska islamská republika",common:"Mauritánia"},spa:{official:"República Islámica de Mauritania",common:"Mauritania"},fin:{official:"Mauritanian islamilainen tasavalta",common:"Mauritania"},est:{official:"Mauritaania Islamivabariik",common:"Mauritaania"},zho:{official:"毛里塔尼亚伊斯兰共和国",common:"毛里塔尼亚"}},latlng:[20,-12],demonym:"Mauritanian",landlocked:!1,borders:["DZA","MLI","SEN","ESH"],area:1030700,flag:"🇲🇷"},{name:{common:"Montserrat",official:"Montserrat",native:{eng:{official:"Montserrat",common:"Montserrat"}}},tld:[".ms"],cca2:"MS",ccn3:"500",cca3:"MSR",cioc:"",independent:!1,status:"officially-assigned",currency:["XCD"],callingCode:["1664"],capital:["Plymouth"],altSpellings:["MS"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Montserrat",common:"Montserrat"},fra:{official:"Montserrat",common:"Montserrat"},hrv:{official:"Montserrat",common:"Montserrat"},ita:{official:"Montserrat",common:"Montserrat"},jpn:{official:"モントセラト",common:"モントセラト"},nld:{official:"Montserrat",common:"Montserrat"},por:{official:"Montserrat",common:"Montserrat"},rus:{official:"Монтсеррат",common:"Монтсеррат"},slk:{official:"Montserrat",common:"Montserrat"},spa:{official:"Montserrat",common:"Montserrat"},fin:{official:"Montserrat",common:"Montserrat"},est:{official:"Montserrat",common:"Montserrat"},zho:{official:"蒙特塞拉特",common:"蒙特塞拉特"}},latlng:[16.75,-62.2],demonym:"Montserratian",landlocked:!1,borders:[],area:102,flag:"🇲🇸"},{name:{common:"Martinique",official:"Martinique",native:{fra:{official:"Martinique",common:"Martinique"}}},tld:[".mq"],cca2:"MQ",ccn3:"474",cca3:"MTQ",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["596"],capital:["Fort-de-France"],altSpellings:["MQ"],region:"Americas",subregion:"Caribbean",languages:{fra:"French"},translations:{deu:{official:"Martinique",common:"Martinique"},fra:{official:"Martinique",common:"Martinique"},hrv:{official:"Martinique",common:"Martinique"},ita:{official:"Martinique",common:"Martinica"},jpn:{official:"マルティニーク島",common:"マルティニーク"},nld:{official:"Martinique",common:"Martinique"},por:{official:"Martinique",common:"Martinica"},rus:{official:"Мартиника",common:"Мартиника"},spa:{official:"Martinica",common:"Martinica"},slk:{official:"Martinique",common:"Martinique"},fin:{official:"Martinique",common:"Martinique"},est:{official:"Martinique’i departemang",common:"Martinique"},zho:{official:"马提尼克",common:"马提尼克"}},latlng:[14.666667,-61],demonym:"French",landlocked:!1,borders:[],area:1128,flag:"🇲🇶"},{name:{common:"Mauritius",official:"Republic of Mauritius",native:{eng:{official:"Republic of Mauritius",common:"Mauritius"},fra:{official:"République de Maurice",common:"Maurice"},mfe:{official:"Republik Moris",common:"Moris"}}},tld:[".mu"],cca2:"MU",ccn3:"480",cca3:"MUS",cioc:"MRI",independent:!0,status:"officially-assigned",currency:["MUR"],callingCode:["230"],capital:["Port Louis"],altSpellings:["MU","Republic of Mauritius","République de Maurice"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English",fra:"French",mfe:"Mauritian Creole"},translations:{deu:{official:"Republik Mauritius",common:"Mauritius"},fra:{official:"République de Maurice",common:"Île Maurice"},hrv:{official:"Republika Mauricijus",common:"Mauricijus"},ita:{official:"Repubblica di Mauritius",common:"Mauritius"},jpn:{official:"モーリシャス共和国",common:"モーリシャス"},nld:{official:"Republiek Mauritius",common:"Mauritius"},por:{official:"República das Maurícias",common:"Maurício"},rus:{official:"Республика Маврикий",common:"Маврикий"},slk:{official:"Maurícijská republika",common:"Maurícius"},spa:{official:"República de Mauricio",common:"Mauricio"},fin:{official:"Mauritiuksen tasavalta",common:"Mauritius"},est:{official:"Mauritiuse Vabariik",common:"Mauritius"},zho:{official:"毛里求斯共和国",common:"毛里求斯"}},latlng:[-20.28333333,57.55],demonym:"Mauritian",landlocked:!1,borders:[],area:2040,flag:"🇲🇺"},{name:{common:"Malawi",official:"Republic of Malawi",native:{eng:{official:"Republic of Malawi",common:"Malawi"},nya:{official:"Chalo cha Malawi, Dziko la Malaŵi",common:"Malaŵi"}}},tld:[".mw"],cca2:"MW",ccn3:"454",cca3:"MWI",cioc:"MAW",independent:!0,status:"officially-assigned",currency:["MWK"],callingCode:["265"],capital:["Lilongwe"],altSpellings:["MW","Republic of Malawi"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English",nya:"Chewa"},translations:{deu:{official:"Republik Malawi",common:"Malawi"},fra:{official:"République du Malawi",common:"Malawi"},hrv:{official:"Republika Malavi",common:"Malavi"},ita:{official:"Repubblica del Malawi",common:"Malawi"},jpn:{official:"マラウイ共和国",common:"マラウイ"},nld:{official:"Republiek Malawi",common:"Malawi"},por:{official:"República do Malawi",common:"Malawi"},rus:{official:"Республика Малави",common:"Малави"},slk:{official:"Malawijská republika",common:"Malawi"},spa:{official:"República de Malawi",common:"Malawi"},fin:{official:"Malawin tasavalta",common:"Malawi"},est:{official:"Malawi Vabariik",common:"Malawi"},zho:{official:"马拉维共和国",common:"马拉维"}},latlng:[-13.5,34],demonym:"Malawian",landlocked:!0,borders:["MOZ","TZA","ZMB"],area:118484,flag:"🇲🇼"},{name:{common:"Malaysia",official:"Malaysia",native:{eng:{official:"Malaysia",common:"Malaysia"},msa:{official:"مليسيا",common:"مليسيا"}}},tld:[".my"],cca2:"MY",ccn3:"458",cca3:"MYS",cioc:"MAS",independent:!0,status:"officially-assigned",currency:["MYR"],callingCode:["60"],capital:["Kuala Lumpur"],altSpellings:["MY"],region:"Asia",subregion:"South-Eastern Asia",languages:{eng:"English",msa:"Malay"},translations:{deu:{official:"Malaysia",common:"Malaysia"},fra:{official:"Fédération de Malaisie",common:"Malaisie"},hrv:{official:"Malezija",common:"Malezija"},ita:{official:"Malaysia",common:"Malesia"},jpn:{official:"マレーシア",common:"マレーシア"},nld:{official:"Maleisië",common:"Maleisië"},por:{official:"Malásia",common:"Malásia"},rus:{official:"Малайзия",common:"Малайзия"},slk:{official:"Malajzia",common:"Malajzia"},spa:{official:"Malasia",common:"Malasia"},fin:{official:"Malesia",common:"Malesia"},est:{official:"Malaisia",common:"Malaisia"},zho:{official:"马来西亚",common:"马来西亚"}},latlng:[2.5,112.5],demonym:"Malaysian",landlocked:!1,borders:["BRN","IDN","THA"],area:330803,flag:"🇲🇾"},{name:{common:"Mayotte",official:"Department of Mayotte",native:{fra:{official:"Département de Mayotte",common:"Mayotte"}}},tld:[".yt"],cca2:"YT",ccn3:"175",cca3:"MYT",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["262"],capital:["Mamoudzou"],altSpellings:["YT","Department of Mayotte","Département de Mayotte"],region:"Africa",subregion:"Eastern Africa",languages:{fra:"French"},translations:{deu:{official:"Übersee-Département Mayotte",common:"Mayotte"},fra:{official:"Département de Mayotte",common:"Mayotte"},hrv:{official:"Odjel Mayotte",common:"Mayotte"},ita:{official:"Dipartimento di Mayotte",common:"Mayotte"},jpn:{official:"マヨット科",common:"マヨット"},nld:{official:"Afdeling Mayotte",common:"Mayotte"},por:{official:"Departamento de Mayotte",common:"Mayotte"},rus:{official:"Департамент Майотта",common:"Майотта"},slk:{official:"Department Mayotte",common:"Mayotte"},spa:{official:"Departamento de Mayotte",common:"Mayotte"},fin:{official:"Mayotte",common:"Mayotte"},est:{official:"Mayotte",common:"Mayotte"},zho:{official:"马约特",common:"马约特"}},latlng:[-12.83333333,45.16666666],demonym:"Mahoran",landlocked:!1,borders:[],area:374,flag:"🇾🇹"},{name:{common:"Namibia",official:"Republic of Namibia",native:{afr:{official:"Republiek van Namibië",common:"Namibië"},deu:{official:"Republik Namibia",common:"Namibia"},eng:{official:"Republic of Namibia",common:"Namibia"},her:{official:"Republic of Namibia",common:"Namibia"},hgm:{official:"Republic of Namibia",common:"Namibia"},kwn:{official:"Republic of Namibia",common:"Namibia"},loz:{official:"Republic of Namibia",common:"Namibia"},ndo:{official:"Republic of Namibia",common:"Namibia"},tsn:{official:"Lefatshe la Namibia",common:"Namibia"}}},tld:[".na"],cca2:"NA",ccn3:"516",cca3:"NAM",cioc:"NAM",independent:!0,status:"officially-assigned",currency:["NAD","ZAR"],callingCode:["264"],capital:["Windhoek"],altSpellings:["NA","Namibië","Republic of Namibia"],region:"Africa",subregion:"Southern Africa",languages:{afr:"Afrikaans",deu:"German",eng:"English",her:"Herero",hgm:"Khoekhoe",kwn:"Kwangali",loz:"Lozi",ndo:"Ndonga",tsn:"Tswana"},translations:{deu:{official:"Republik Namibia",common:"Namibia"},fra:{official:"République de Namibie",common:"Namibie"},hrv:{official:"Republika Namibija",common:"Namibija"},ita:{official:"Repubblica di Namibia",common:"Namibia"},jpn:{official:"ナミビア共和国",common:"ナミビア"},nld:{official:"Republiek Namibië",common:"Namibië"},por:{official:"República da Namíbia",common:"Namíbia"},rus:{official:"Республика Намибия",common:"Намибия"},slk:{official:"Namíbijská republika",common:"Namíbia"},spa:{official:"República de Namibia",common:"Namibia"},fin:{official:"Namibian tasavalta",common:"Namibia"},est:{official:"Namiibia Vabariik",common:"Namiibia"},zho:{official:"纳米比亚共和国",common:"纳米比亚"}},latlng:[-22,17],demonym:"Namibian",landlocked:!1,borders:["AGO","BWA","ZAF","ZMB"],area:825615,flag:"🇳🇦"},{name:{common:"New Caledonia",official:"New Caledonia",native:{fra:{official:"Nouvelle-Calédonie",common:"Nouvelle-Calédonie"}}},tld:[".nc"],cca2:"NC",ccn3:"540",cca3:"NCL",cioc:"",independent:!1,status:"officially-assigned",currency:["XPF"],callingCode:["687"],capital:["Nouméa"],altSpellings:["NC"],region:"Oceania",subregion:"Melanesia",languages:{fra:"French"},translations:{deu:{official:"Neukaledonien",common:"Neukaledonien"},fra:{official:"Nouvelle-Calédonie",common:"Nouvelle-Calédonie"},hrv:{official:"Nova Kaledonija",common:"Nova Kaledonija"},ita:{official:"Nuova Caledonia",common:"Nuova Caledonia"},jpn:{official:"ニューカレドニア",common:"ニューカレドニア"},nld:{official:"nieuw -Caledonië",common:"Nieuw-Caledonië"},por:{official:"New Caledonia",common:"Nova Caledónia"},rus:{official:"Новая Каледония",common:"Новая Каледония"},slk:{official:"Nová Kaledónia",common:"Nová Kaledónia"},spa:{official:"nueva Caledonia",common:"Nueva Caledonia"},fin:{official:"Uusi-Kaledonia",common:"Uusi-Kaledonia"},est:{official:"Uus-Kaledoonia",common:"Uus-Kaledoonia"},zho:{official:"新喀里多尼亚",common:"新喀里多尼亚"}},latlng:[-21.5,165.5],demonym:"New Caledonian",landlocked:!1,borders:[],area:18575,flag:"🇳🇨"},{name:{common:"Niger",official:"Republic of Niger",native:{fra:{official:"République du Niger",common:"Niger"}}},tld:[".ne"],cca2:"NE",ccn3:"562",cca3:"NER",cioc:"NIG",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["227"],capital:["Niamey"],altSpellings:["NE","Nijar"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{deu:{official:"Republik Niger",common:"Niger"},fra:{official:"République du Niger",common:"Niger"},hrv:{official:"Republika Niger",common:"Niger"},ita:{official:"Repubblica del Niger",common:"Niger"},jpn:{official:"ニジェール共和国",common:"ニジェール"},nld:{official:"Republiek Niger",common:"Niger"},por:{official:"República do Níger",common:"Níger"},rus:{official:"Республика Нигер",common:"Нигер"},slk:{official:"Nigérská republika",common:"Niger"},spa:{official:"República de Níger",common:"Níger"},fin:{official:"Nigerin tasavalta",common:"Niger"},est:{official:"Nigeri Vabariik",common:"Niger"},zho:{official:"尼日尔共和国",common:"尼日尔"}},latlng:[16,8],demonym:"Nigerien",landlocked:!0,borders:["DZA","BEN","BFA","TCD","LBY","MLI","NGA"],area:1267e3,flag:"🇳🇪"},{name:{common:"Norfolk Island",official:"Territory of Norfolk Island",native:{eng:{official:"Territory of Norfolk Island",common:"Norfolk Island"},pih:{official:"Teratri of Norf'k Ailen",common:"Norf'k Ailen"}}},tld:[".nf"],cca2:"NF",ccn3:"574",cca3:"NFK",cioc:"",independent:!1,status:"officially-assigned",currency:["AUD"],callingCode:["672"],capital:["Kingston"],altSpellings:["NF","Territory of Norfolk Island","Teratri of Norf'k Ailen"],region:"Oceania",subregion:"Australia and New Zealand",languages:{eng:"English",pih:"Norfuk"},translations:{deu:{official:"Gebiet der Norfolk-Insel",common:"Norfolkinsel"},fra:{official:"Territoire de l'île Norfolk",common:"Île Norfolk"},hrv:{official:"Teritorij Norfolk Island",common:"Otok Norfolk"},ita:{official:"Territorio di Norfolk Island",common:"Isola Norfolk"},jpn:{official:"ノーフォーク島の領土",common:"ノーフォーク島"},nld:{official:"Grondgebied van Norfolk Island",common:"Norfolkeiland"},por:{official:"Território da Ilha Norfolk",common:"Ilha Norfolk"},rus:{official:"Территория острова Норфолк",common:"Норфолк"},slk:{official:"Teritórium ostrova Norfolk",common:"Norfolk"},spa:{official:"Territorio de la Isla Norfolk",common:"Isla de Norfolk"},fin:{official:"Norfolkinsaaren territorio",common:"Norfolkinsaari"},est:{official:"Norfolki saare ala",common:"Norfolk"},zho:{official:"诺福克岛",common:"诺福克岛"}},latlng:[-29.03333333,167.95],demonym:"Norfolk Islander",landlocked:!1,borders:[],area:36,flag:"🇳🇫"},{name:{common:"Nigeria",official:"Federal Republic of Nigeria",native:{eng:{official:"Federal Republic of Nigeria",common:"Nigeria"}}},tld:[".ng"],cca2:"NG",ccn3:"566",cca3:"NGA",cioc:"NGR",independent:!0,status:"officially-assigned",currency:["NGN"],callingCode:["234"],capital:["Abuja"],altSpellings:["NG","Nijeriya","Naíjíríà","Federal Republic of Nigeria"],region:"Africa",subregion:"Western Africa",languages:{eng:"English"},translations:{deu:{official:"Bundesrepublik Nigeria",common:"Nigeria"},fra:{official:"République fédérale du Nigeria",common:"Nigéria"},hrv:{official:"Savezna Republika Nigerija",common:"Nigerija"},ita:{official:"Repubblica federale di Nigeria",common:"Nigeria"},jpn:{official:"ナイジェリア連邦共和国",common:"ナイジェリア"},nld:{official:"Federale Republiek Nigeria",common:"Nigeria"},por:{official:"República Federal da Nigéria",common:"Nigéria"},rus:{official:"Федеративная Республика Нигерия",common:"Нигерия"},slk:{official:"Nigérijská federatívna republika",common:"Nigéria"},spa:{official:"República Federal de Nigeria",common:"Nigeria"},fin:{official:"Nigerian liittotasavalta",common:"Nigeria"},est:{official:"Nigeeria Liitvabariik",common:"Nigeeria"},zho:{official:"尼日利亚联邦共和国",common:"尼日利亚"}},latlng:[10,8],demonym:"Nigerian",landlocked:!1,borders:["BEN","CMR","TCD","NER"],area:923768,flag:"🇳🇬"},{name:{common:"Nicaragua",official:"Republic of Nicaragua",native:{spa:{official:"República de Nicaragua",common:"Nicaragua"}}},tld:[".ni"],cca2:"NI",ccn3:"558",cca3:"NIC",cioc:"NCA",independent:!0,status:"officially-assigned",currency:["NIO"],callingCode:["505"],capital:["Managua"],altSpellings:["NI","Republic of Nicaragua","República de Nicaragua"],region:"Americas",subregion:"Central America",languages:{spa:"Spanish"},translations:{deu:{official:"Republik Nicaragua",common:"Nicaragua"},fra:{official:"République du Nicaragua",common:"Nicaragua"},hrv:{official:"Republika Nikaragva",common:"Nikaragva"},ita:{official:"Repubblica del Nicaragua",common:"Nicaragua"},jpn:{official:"ニカラグア共和国",common:"ニカラグア"},nld:{official:"Republiek Nicaragua",common:"Nicaragua"},por:{official:"República da Nicarágua",common:"Nicarágua"},rus:{official:"Республика Никарагуа",common:"Никарагуа"},slk:{official:"Nikaragujská republika",common:"Nikaragua"},spa:{official:"República de Nicaragua",common:"Nicaragua"},fin:{official:"Nicaraguan tasavalta",common:"Nicaragua"},est:{official:"Nicaragua Vabariik",common:"Nicaragua"},zho:{official:"尼加拉瓜共和国",common:"尼加拉瓜"}},latlng:[13,-85],demonym:"Nicaraguan",landlocked:!1,borders:["CRI","HND"],area:130373,flag:"🇳🇮"},{name:{common:"Niue",official:"Niue",native:{eng:{official:"Niue",common:"Niue"},niu:{official:"Niuē",common:"Niuē"}}},tld:[".nu"],cca2:"NU",ccn3:"570",cca3:"NIU",cioc:"",independent:!1,status:"officially-assigned",currency:["NZD"],callingCode:["683"],capital:["Alofi"],altSpellings:["NU"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",niu:"Niuean"},translations:{deu:{official:"Niue",common:"Niue"},fra:{official:"Niue",common:"Niue"},hrv:{official:"Niue",common:"Niue"},ita:{official:"Niue",common:"Niue"},jpn:{official:"ニウエ",common:"ニウエ"},nld:{official:"Niue",common:"Niue"},por:{official:"Niue",common:"Niue"},rus:{official:"Ниуэ",common:"Ниуэ"},slk:{official:"Niue",common:"Niue"},spa:{official:"Niue",common:"Niue"},fin:{official:"Niue",common:"Niue"},est:{official:"Niue",common:"Niue"},zho:{official:"纽埃",common:"纽埃"}},latlng:[-19.03333333,-169.86666666],demonym:"Niuean",landlocked:!1,borders:[],area:260,flag:"🇳🇺"},{name:{common:"Netherlands",official:"Netherlands",native:{nld:{official:"Nederland",common:"Nederland"}}},tld:[".nl"],cca2:"NL",ccn3:"528",cca3:"NLD",cioc:"NED",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["31"],capital:["Amsterdam"],altSpellings:["NL","Holland","Nederland","The Netherlands"],region:"Europe",subregion:"Western Europe",languages:{nld:"Dutch"},translations:{deu:{official:"Niederlande",common:"Niederlande"},fra:{official:"Pays-Bas",common:"Pays-Bas"},hrv:{official:"Holandija",common:"Nizozemska"},ita:{official:"Paesi Bassi",common:"Paesi Bassi"},jpn:{official:"オランダ",common:"オランダ"},nld:{official:"Nederland",common:"Nederland"},por:{official:"Holanda",common:"Holanda"},rus:{official:"Нидерланды",common:"Нидерланды"},slk:{official:"Holandské kráľovstvo",common:"Holansko"},spa:{official:"Países Bajos",common:"Países Bajos"},fin:{official:"Alankomaat",common:"Alankomaat"},est:{official:"Madalmaade Kuningriik",common:"Holland"},zho:{official:"荷兰",common:"荷兰"}},latlng:[52.5,5.75],demonym:"Dutch",landlocked:!1,borders:["BEL","DEU"],area:41850,flag:"🇳🇱"},{name:{common:"Norway",official:"Kingdom of Norway",native:{nno:{official:"Kongeriket Noreg",common:"Noreg"},nob:{official:"Kongeriket Norge",common:"Norge"},smi:{official:"Norgga gonagasriika",common:"Norgga"}}},tld:[".no"],cca2:"NO",ccn3:"578",cca3:"NOR",cioc:"NOR",independent:!0,status:"officially-assigned",currency:["NOK"],callingCode:["47"],capital:["Oslo"],altSpellings:["NO","Norge","Noreg","Kingdom of Norway","Kongeriket Norge","Kongeriket Noreg"],region:"Europe",subregion:"Northern Europe",languages:{nno:"Norwegian Nynorsk",nob:"Norwegian Bokmål",smi:"Sami"},translations:{deu:{official:"Königreich Norwegen",common:"Norwegen"},fra:{official:"Royaume de Norvège",common:"Norvège"},hrv:{official:"Kraljevina Norveška",common:"Norveška"},ita:{official:"Regno di Norvegia",common:"Norvegia"},jpn:{official:"ノルウェー王国",common:"ノルウェー"},nld:{official:"Koninkrijk Noorwegen",common:"Noorwegen"},por:{official:"Reino da Noruega",common:"Noruega"},rus:{official:"Королевство Норвегия",common:"Норвегия"},slk:{official:"Nórske kráľovstvo",common:"Nórsko"},spa:{official:"Reino de Noruega",common:"Noruega"},fin:{official:"Norjan kuningaskunta",common:"Norja"},est:{official:"Norra Kuningriik",common:"Norra"},zho:{official:"挪威王国",common:"挪威"}},latlng:[62,10],demonym:"Norwegian",landlocked:!1,borders:["FIN","SWE","RUS"],area:323802,flag:"🇳🇴"},{name:{common:"Nepal",official:"Federal Democratic Republic of Nepal",native:{nep:{official:"नेपाल संघीय लोकतान्त्रिक गणतन्त्र",common:"नेपाल"}}},tld:[".np"],cca2:"NP",ccn3:"524",cca3:"NPL",cioc:"NEP",independent:!0,status:"officially-assigned",currency:["NPR"],callingCode:["977"],capital:["Kathmandu"],altSpellings:["NP","Federal Democratic Republic of Nepal","Loktāntrik Ganatantra Nepāl"],region:"Asia",subregion:"Southern Asia",languages:{nep:"Nepali"},translations:{deu:{official:"Demokratischen Bundesrepublik Nepal",common:"Népal"},fra:{official:"République du Népal",common:"Népal"},hrv:{official:"Savezna Demokratska Republika Nepal",common:"Nepal"},ita:{official:"Repubblica federale democratica del Nepal",common:"Nepal"},jpn:{official:"ネパール連邦民主共和国",common:"ネパール"},nld:{official:"Federale Democratische Republiek Nepal",common:"Nepal"},por:{official:"República Democrática Federal do Nepal",common:"Nepal"},rus:{official:"Федеративная Демократическая Республика Непал",common:"Непал"},slk:{official:"Nepálska federatívna demokratická republika",common:"Nepál"},spa:{official:"República Democrática Federal de Nepal",common:"Nepal"},fin:{official:"Nepalin demokraattinen liittotasavalta",common:"Nepal"},est:{official:"Nepali Demokraatlik Liitvabariik",common:"Nepal"},zho:{official:"尼泊尔联邦民主共和国",common:"尼泊尔"}},latlng:[28,84],demonym:"Nepalese",landlocked:!0,borders:["CHN","IND"],area:147181,flag:"🇳🇵"},{name:{common:"Nauru",official:"Republic of Nauru",native:{eng:{official:"Republic of Nauru",common:"Nauru"},nau:{official:"Republic of Nauru",common:"Nauru"}}},tld:[".nr"],cca2:"NR",ccn3:"520",cca3:"NRU",cioc:"NRU",independent:!0,status:"officially-assigned",currency:["AUD"],callingCode:["674"],capital:["Yaren"],altSpellings:["NR","Naoero","Pleasant Island","Republic of Nauru","Ripublik Naoero"],region:"Oceania",subregion:"Micronesia",languages:{eng:"English",nau:"Nauru"},translations:{deu:{official:"Republik Nauru",common:"Nauru"},fra:{official:"République de Nauru",common:"Nauru"},hrv:{official:"Republika Nauru",common:"Nauru"},ita:{official:"Repubblica di Nauru",common:"Nauru"},jpn:{official:"ナウル共和国",common:"ナウル"},nld:{official:"Republiek Nauru",common:"Nauru"},por:{official:"República de Nauru",common:"Nauru"},rus:{official:"Республика Науру",common:"Науру"},slk:{official:"Naurská republika",common:"Nauru"},spa:{official:"República de Nauru",common:"Nauru"},fin:{official:"Naurun tasavalta",common:"Nauru"},est:{official:"Nauru Vabariik",common:"Nauru"},zho:{official:"瑙鲁共和国",common:"瑙鲁"}},latlng:[-.53333333,166.91666666],demonym:"Nauruan",landlocked:!1,borders:[],area:21,flag:"🇳🇷"},{name:{common:"New Zealand",official:"New Zealand",native:{eng:{official:"New Zealand",common:"New Zealand"},mri:{official:"Aotearoa",common:"Aotearoa"},nzs:{official:"New Zealand",common:"New Zealand"}}},tld:[".nz"],cca2:"NZ",ccn3:"554",cca3:"NZL",cioc:"NZL",independent:!0,status:"officially-assigned",currency:["NZD"],callingCode:["64"],capital:["Wellington"],altSpellings:["NZ","Aotearoa"],region:"Oceania",subregion:"Australia and New Zealand",languages:{eng:"English",mri:"Māori",nzs:"New Zealand Sign Language"},translations:{deu:{official:"Neuseeland",common:"Neuseeland"},fra:{official:"Nouvelle-Zélande",common:"Nouvelle-Zélande"},hrv:{official:"Novi Zeland",common:"Novi Zeland"},ita:{official:"Nuova Zelanda",common:"Nuova Zelanda"},jpn:{official:"ニュージーランド",common:"ニュージーランド"},nld:{official:"Nieuw Zeeland",common:"Nieuw-Zeeland"},por:{official:"nova Zelândia",common:"Nova Zelândia"},rus:{official:"Новая Зеландия",common:"Новая Зеландия"},slk:{official:"Nový Zéland",common:"Nový Zéland"},spa:{official:"nueva Zelanda",common:"Nueva Zelanda"},fin:{official:"Uusi-Seelanti",common:"Uusi-Seelanti"},est:{official:"Uus-Meremaa",common:"Uus-Meremaa"},zho:{official:"新西兰",common:"新西兰"}},latlng:[-41,174],demonym:"New Zealander",landlocked:!1,borders:[],area:270467,flag:"🇳🇿"},{name:{common:"Oman",official:"Sultanate of Oman",native:{ara:{official:"سلطنة عمان",common:"عمان"}}},tld:[".om"],cca2:"OM",ccn3:"512",cca3:"OMN",cioc:"OMA",independent:!0,status:"officially-assigned",currency:["OMR"],callingCode:["968"],capital:["Muscat"],altSpellings:["OM","Sultanate of Oman","Salṭanat ʻUmān"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Sultanat Oman",common:"Oman"},fra:{official:"Sultanat d'Oman",common:"Oman"},hrv:{official:"Sultanat Oman",common:"Oman"},ita:{official:"Sultanato dell'Oman",common:"oman"},jpn:{official:"オマーン·スルタン国",common:"オマーン"},nld:{official:"Sultanaat van Oman",common:"Oman"},por:{official:"Sultanato de Omã",common:"Omã"},rus:{official:"Султанат Оман",common:"Оман"},slk:{official:"Ománsky sultanát",common:"Omán"},spa:{official:"Sultanato de Omán",common:"Omán"},fin:{official:"Omanin sulttaanikunta",common:"Oman"},est:{official:"Omaani Sultaniriik",common:"Omaan"},zho:{official:"阿曼苏丹国",common:"阿曼"}},latlng:[21,57],demonym:"Omani",landlocked:!1,borders:["SAU","ARE","YEM"],area:309500,flag:"🇴🇲"},{name:{common:"Pakistan",official:"Islamic Republic of Pakistan",native:{eng:{official:"Islamic Republic of Pakistan",common:"Pakistan"},urd:{official:"اسلامی جمہوریۂ پاكستان",common:"پاكستان"}}},tld:[".pk"],cca2:"PK",ccn3:"586",cca3:"PAK",cioc:"PAK",independent:!0,status:"officially-assigned",currency:["PKR"],callingCode:["92"],capital:["Islamabad"],altSpellings:["PK","Pākistān","Islamic Republic of Pakistan","Islāmī Jumhūriya'eh Pākistān"],region:"Asia",subregion:"Southern Asia",languages:{eng:"English",urd:"Urdu"},translations:{deu:{official:"Islamische Republik Pakistan",common:"Pakistan"},fra:{official:"République islamique du Pakistan",common:"Pakistan"},hrv:{official:"Islamska Republika Pakistan",common:"Pakistan"},ita:{official:"Repubblica islamica del Pakistan",common:"Pakistan"},jpn:{official:"パキスタン",common:"パキスタン"},nld:{official:"Islamitische Republiek Pakistan",common:"Pakistan"},por:{official:"República Islâmica do Paquistão",common:"Paquistão"},rus:{official:"Исламская Республика Пакистан",common:"Пакистан"},slk:{official:"Pakistanská islamská republika",common:"Pakistan"},spa:{official:"República Islámica de Pakistán",common:"Pakistán"},fin:{official:"Pakistanin islamilainen tasavalta",common:"Pakistan"},est:{official:"Pakistani Islamivabariik",common:"Pakistan"},zho:{official:"巴基斯坦伊斯兰共和国",common:"巴基斯坦"}},latlng:[30,70],demonym:"Pakistani",landlocked:!1,borders:["AFG","CHN","IND","IRN"],area:881912,flag:"🇵🇰"},{name:{common:"Panama",official:"Republic of Panama",native:{spa:{official:"República de Panamá",common:"Panamá"}}},tld:[".pa"],cca2:"PA",ccn3:"591",cca3:"PAN",cioc:"PAN",independent:!0,status:"officially-assigned",currency:["PAB","USD"],callingCode:["507"],capital:["Panama City"],altSpellings:["PA","Republic of Panama","República de Panamá"],region:"Americas",subregion:"Central America",languages:{spa:"Spanish"},translations:{deu:{official:"Republik Panama",common:"Panama"},fra:{official:"République du Panama",common:"Panama"},hrv:{official:"Republika Panama",common:"Panama"},ita:{official:"Repubblica di Panama",common:"Panama"},jpn:{official:"パナマ共和国",common:"パナマ"},nld:{official:"Republiek Panama",common:"Panama"},por:{official:"República do Panamá",common:"Panamá"},rus:{official:"Республика Панама",common:"Панама"},slk:{official:"Panamská republika",common:"Panama"},spa:{official:"República de Panamá",common:"Panamá"},fin:{official:"Panaman tasavalta",common:"Panama"},est:{official:"Panama Vabariik",common:"Panama"},zho:{official:"巴拿马共和国",common:"巴拿马"}},latlng:[9,-80],demonym:"Panamanian",landlocked:!1,borders:["COL","CRI"],area:75417,flag:"🇵🇦"},{name:{common:"Pitcairn Islands",official:"Pitcairn Group of Islands",native:{eng:{official:"Pitcairn Group of Islands",common:"Pitcairn Islands"}}},tld:[".pn"],cca2:"PN",ccn3:"612",cca3:"PCN",cioc:"",independent:!1,status:"officially-assigned",currency:["NZD"],callingCode:["64"],capital:["Adamstown"],altSpellings:["PN","Pitcairn","Pitcairn Henderson Ducie and Oeno Islands"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English"},translations:{deu:{official:"Pitcairn Inselgruppe",common:"Pitcairn"},fra:{official:"Groupe d'îles Pitcairn",common:"Îles Pitcairn"},hrv:{official:"Pitcairn skupine otoka",common:"Pitcairnovo otočje"},ita:{official:"Pitcairn gruppo di isole",common:"Isole Pitcairn"},jpn:{official:"島のピトケアングループ",common:"ピトケアン"},nld:{official:"Pitcairn groep eilanden",common:"Pitcairneilanden"},por:{official:"Pitcairn grupo de ilhas",common:"Ilhas Pitcairn"},rus:{official:"Питкэрн группа островов",common:"Острова Питкэрн"},slk:{official:"Pitcairnove ostrovy",common:"Pitcairnove ostrovy"},spa:{official:"Grupo de Islas Pitcairn",common:"Islas Pitcairn"},fin:{official:"Pitcairn",common:"Pitcairn"},est:{official:"Pitcairni, Hendersoni, Ducie ja Oeno saar",common:"Pitcairn"},zho:{official:"皮特凯恩群岛",common:"皮特凯恩群岛"}},latlng:[-25.06666666,-130.1],demonym:"Pitcairn Islander",landlocked:!1,borders:[],area:47,flag:"🇵🇳"},{name:{common:"Peru",official:"Republic of Peru",native:{aym:{official:"Piruw Suyu",common:"Piruw"},que:{official:"Piruw Ripuwlika",common:"Piruw"},spa:{official:"República del Perú",common:"Perú"}}},tld:[".pe"],cca2:"PE",ccn3:"604",cca3:"PER",cioc:"PER",independent:!0,status:"officially-assigned",currency:["PEN"],callingCode:["51"],capital:["Lima"],altSpellings:["PE","Republic of Peru","República del Perú"],region:"Americas",subregion:"South America",languages:{aym:"Aymara",que:"Quechua",spa:"Spanish"},translations:{deu:{official:"Republik Peru",common:"Peru"},fra:{official:"République du Pérou",common:"Pérou"},hrv:{official:"Republika Peru",common:"Peru"},ita:{official:"Repubblica del Perù",common:"Perù"},jpn:{official:"ペルー共和国",common:"ペルー"},nld:{official:"Republiek Peru",common:"Peru"},por:{official:"República do Peru",common:"Perú"},rus:{official:"Республика Перу",common:"Перу"},slk:{official:"Peruánska republika",common:"Peru"},spa:{official:"República de Perú",common:"Perú"},fin:{official:"Perun tasavalta",common:"Peru"},est:{official:"Peruu Vabariik",common:"Peruu"},zho:{official:"秘鲁共和国",common:"秘鲁"}},latlng:[-10,-76],demonym:"Peruvian",landlocked:!1,borders:["BOL","BRA","CHL","COL","ECU"],area:1285216,flag:"🇵🇪"},{name:{common:"Philippines",official:"Republic of the Philippines",native:{eng:{official:"Republic of the Philippines",common:"Philippines"},fil:{official:"Republic of the Philippines",common:"Pilipinas"}}},tld:[".ph"],cca2:"PH",ccn3:"608",cca3:"PHL",cioc:"PHI",independent:!0,status:"officially-assigned",currency:["PHP"],callingCode:["63"],capital:["Manila"],altSpellings:["PH","Republic of the Philippines","Repúblika ng Pilipinas"],region:"Asia",subregion:"South-Eastern Asia",languages:{eng:"English",fil:"Filipino"},translations:{deu:{official:"Republik der Philippinen",common:"Philippinen"},fra:{official:"République des Philippines",common:"Philippines"},hrv:{official:"Republika Filipini",common:"Filipini"},ita:{official:"Repubblica delle Filippine",common:"Filippine"},jpn:{official:"フィリピン共和国",common:"フィリピン"},nld:{official:"Republiek der Filipijnen",common:"Filipijnen"},por:{official:"República das Filipinas",common:"Filipinas"},rus:{official:"Республика Филиппины",common:"Филиппины"},slk:{official:"Filipínska republika",common:"Filipíny"},spa:{official:"República de las Filipinas",common:"Filipinas"},fin:{official:"Filippiinien tasavalta",common:"Filippiinit"},est:{official:"Filipiini Vabariik",common:"Filipiinid"},zho:{official:"菲律宾共和国",common:"菲律宾"}},latlng:[13,122],demonym:"Filipino",landlocked:!1,borders:[],area:342353,flag:"🇵🇭"},{name:{common:"Palau",official:"Republic of Palau",native:{eng:{official:"Republic of Palau",common:"Palau"},pau:{official:"Beluu er a Belau",common:"Belau"}}},tld:[".pw"],cca2:"PW",ccn3:"585",cca3:"PLW",cioc:"PLW",independent:!0,status:"officially-assigned",currency:["USD"],callingCode:["680"],capital:["Ngerulmud"],altSpellings:["PW","Republic of Palau","Beluu er a Belau"],region:"Oceania",subregion:"Micronesia",languages:{eng:"English",pau:"Palauan"},translations:{deu:{official:"Palau",common:"Palau"},fra:{official:"République des Palaos (Palau)",common:"Palaos (Palau)"},hrv:{official:"Republika Palau",common:"Palau"},ita:{official:"Repubblica di Palau",common:"Palau"},jpn:{official:"パラオ共和国",common:"パラオ"},nld:{official:"Republiek van Palau",common:"Palau"},por:{official:"República de Palau",common:"Palau"},rus:{official:"Республика Палау",common:"Палау"},slk:{official:"Palauská republika",common:"Palau"},spa:{official:"República de Palau",common:"Palau"},fin:{official:"Palaun tasavalta",common:"Palau"},est:{official:"Belau Vabariik",common:"Belau"},zho:{official:"帕劳共和国",common:"帕劳"}},latlng:[7.5,134.5],demonym:"Palauan",landlocked:!1,borders:[],area:459,flag:"🇵🇼"},{name:{common:"Papua New Guinea",official:"Independent State of Papua New Guinea",native:{eng:{official:"Independent State of Papua New Guinea",common:"Papua New Guinea"},hmo:{official:"Independen Stet bilong Papua Niugini",common:"Papua Niu Gini"},tpi:{official:"Independen Stet bilong Papua Niugini",common:"Papua Niugini"}}},tld:[".pg"],cca2:"PG",ccn3:"598",cca3:"PNG",cioc:"PNG",independent:!0,status:"officially-assigned",currency:["PGK"],callingCode:["675"],capital:["Port Moresby"],altSpellings:["PG","Independent State of Papua New Guinea","Independen Stet bilong Papua Niugini"],region:"Oceania",subregion:"Melanesia",languages:{eng:"English",hmo:"Hiri Motu",tpi:"Tok Pisin"},translations:{deu:{official:"Unabhängige Staat Papua-Neuguinea",common:"Papua-Neuguinea"},fra:{official:"État indépendant de Papouasie-Nouvelle-Guinée",common:"Papouasie-Nouvelle-Guinée"},hrv:{official:"Nezavisna Država Papui Novoj Gvineji",common:"Papua Nova Gvineja"},ita:{official:"Stato indipendente di Papua Nuova Guinea",common:"Papua Nuova Guinea"},jpn:{official:"パプアニューギニア独立国",common:"パプアニューギニア"},nld:{official:"Onafhankelijke Staat Papoea -Nieuw-Guinea",common:"Papoea-Nieuw-Guinea"},por:{official:"Estado Independente da Papua Nova Guiné",common:"Papua Nova Guiné"},rus:{official:"Независимое Государство Папуа-Новой Гвинеи",common:"Папуа — Новая Гвинея"},slk:{official:"Nezávislý štát Papua-Nová Guinea",common:"Papua-Nová Guinea"},spa:{official:"Estado Independiente de Papúa Nueva Guinea",common:"Papúa Nueva Guinea"},fin:{official:"Papua-Uuden-Guinean Itsenäinen valtio",common:"Papua-Uusi-Guinea"},est:{official:"Paapua Uus-Guinea Iseseisvusriik",common:"Paapua Uus-Guinea"},zho:{official:"巴布亚新几内亚",common:"巴布亚新几内亚"}},latlng:[-6,147],demonym:"Papua New Guinean",landlocked:!1,borders:["IDN"],area:462840,flag:"🇵🇬"},{name:{common:"Poland",official:"Republic of Poland",native:{pol:{official:"Rzeczpospolita Polska",common:"Polska"}}},tld:[".pl"],cca2:"PL",ccn3:"616",cca3:"POL",cioc:"POL",independent:!0,status:"officially-assigned",currency:["PLN"],callingCode:["48"],capital:["Warsaw"],altSpellings:["PL","Republic of Poland","Rzeczpospolita Polska"],region:"Europe",subregion:"Eastern Europe",languages:{pol:"Polish"},translations:{deu:{official:"Republik Polen",common:"Polen"},fra:{official:"République de Pologne",common:"Pologne"},hrv:{official:"Republika Poljska",common:"Poljska"},ita:{official:"Repubblica di Polonia",common:"Polonia"},jpn:{official:"ポーランド共和国",common:"ポーランド"},nld:{official:"Republiek Polen",common:"Polen"},por:{official:"República da Polónia",common:"Polónia"},rus:{official:"Республика Польша",common:"Польша"},slk:{official:"Poľská republika",common:"Poľsko"},spa:{official:"República de Polonia",common:"Polonia"},fin:{official:"Puolan tasavalta",common:"Puola"},est:{official:"Poola Vabariik",common:"Poola"},zho:{official:"波兰共和国",common:"波兰"}},latlng:[52,20],demonym:"Polish",landlocked:!1,borders:["BLR","CZE","DEU","LTU","RUS","SVK","UKR"],area:312679,flag:"🇵🇱"},{name:{common:"Puerto Rico",official:"Commonwealth of Puerto Rico",native:{eng:{official:"Commonwealth of Puerto Rico",common:"Puerto Rico"},spa:{official:"Estado Libre Asociado de Puerto Rico",common:"Puerto Rico"}}},tld:[".pr"],cca2:"PR",ccn3:"630",cca3:"PRI",cioc:"PUR",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1787","1939"],capital:["San Juan"],altSpellings:["PR","Commonwealth of Puerto Rico","Estado Libre Asociado de Puerto Rico"],region:"Americas",subregion:"Caribbean",languages:{eng:"English",spa:"Spanish"},translations:{deu:{official:"Commonwealth von Puerto Rico",common:"Puerto Rico"},fra:{official:"Porto Rico",common:"Porto Rico"},hrv:{official:"Zajednica Puerto Rico",common:"Portoriko"},ita:{official:"Commonwealth di Porto Rico",common:"Porto Rico"},jpn:{official:"プエルトリコのコモンウェルス",common:"プエルトリコ"},nld:{official:"Gemenebest van Puerto Rico",common:"Puerto Rico"},por:{official:"Commonwealth of Puerto Rico",common:"Porto Rico"},rus:{official:"Содружество Пуэрто-Рико",common:"Пуэрто-Рико"},slk:{official:"Portorické spoločenstvo",common:"Portoriko"},spa:{official:"Asociado de Puerto Rico",common:"Puerto Rico"},fin:{official:"Puerto Rico",common:"Puerto Rico"},est:{official:"Puerto Rico Ühendus",common:"Puerto Rico"},zho:{official:"波多黎各联邦",common:"波多黎各"}},latlng:[18.25,-66.5],demonym:"Puerto Rican",landlocked:!1,borders:[],area:8870,flag:"🇵🇷"},{name:{common:"North Korea",official:"Democratic People's Republic of Korea",native:{kor:{official:"조선 민주주의 인민 공화국",common:"북한"}}},tld:[".kp"],cca2:"KP",ccn3:"408",cca3:"PRK",cioc:"PRK",independent:!0,status:"officially-assigned",currency:["KPW"],callingCode:["850"],capital:["Pyongyang"],altSpellings:["KP","Democratic People's Republic of Korea","조선민주주의인민공화국","Chosŏn Minjujuŭi Inmin Konghwaguk","Korea, Democratic People's Republic of"],region:"Asia",subregion:"Eastern Asia",languages:{kor:"Korean"},translations:{deu:{official:"Demokratische Volksrepublik Korea",common:"Nordkorea"},fra:{official:"République populaire démocratique de Corée",common:"Corée du Nord"},hrv:{official:"Demokratska Narodna Republika Koreja",common:"Sjeverna Koreja"},ita:{official:"Repubblica democratica popolare di Corea",common:"Corea del Nord"},jpn:{official:"朝鮮民主主義人民共和国",common:"朝鮮民主主義人民共和国"},nld:{official:"Democratische Volksrepubliek Korea",common:"Noord-Korea"},por:{official:"República Popular Democrática da Coreia",common:"Coreia do Norte"},rus:{official:"Корейская Народно-Демократическая Республика Корея",common:"Северная Корея"},slk:{official:"Kórejská ľudovodemokratická republika",common:"Kórejská ľudovodemokratická republika (KĽR, Severná Kórea)"},spa:{official:"República Popular Democrática de Corea",common:"Corea del Norte"},fin:{official:"Korean demokraattinen kansantasavalta",common:"Pohjois-Korea"},est:{official:"Korea Rahvademokraatlik Vabariik",common:"Põhja-Korea"},zho:{official:"朝鲜人民民主共和国",common:"朝鲜"}},latlng:[40,127],demonym:"North Korean",landlocked:!1,borders:["CHN","KOR","RUS"],area:120538,flag:"🇰🇵"},{name:{common:"Portugal",official:"Portuguese Republic",native:{por:{official:"República português",common:"Portugal"}}},tld:[".pt"],cca2:"PT",ccn3:"620",cca3:"PRT",cioc:"POR",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["351"],capital:["Lisbon"],altSpellings:["PT","Portuguesa","Portuguese Republic","República Portuguesa"],region:"Europe",subregion:"Southern Europe",languages:{por:"Portuguese"},translations:{deu:{official:"Portugiesische Republik",common:"Portugal"},fra:{official:"République portugaise",common:"Portugal"},hrv:{official:"Portugalska Republika",common:"Portugal"},ita:{official:"Repubblica portoghese",common:"Portogallo"},jpn:{official:"ポルトガル共和国",common:"ポルトガル"},nld:{official:"Portugese Republiek",common:"Portugal"},por:{official:"República português",common:"Portugal"},rus:{official:"Португальская Республика",common:"Португалия"},slk:{official:"Portugalská republika",common:"Portugalsko"},spa:{official:"República Portuguesa",common:"Portugal"},fin:{official:"Portugalin tasavalta",common:"Portugali"},est:{official:"Portugali Vabariik",common:"Portugal"},zho:{official:"葡萄牙共和国",common:"葡萄牙"}},latlng:[39.5,-8],demonym:"Portuguese",landlocked:!1,borders:["ESP"],area:92090,flag:"🇵🇹"},{name:{common:"Paraguay",official:"Republic of Paraguay",native:{grn:{official:"Tetã Paraguái",common:"Paraguái"},spa:{official:"República de Paraguay",common:"Paraguay"}}},tld:[".py"],cca2:"PY",ccn3:"600",cca3:"PRY",cioc:"PAR",independent:!0,status:"officially-assigned",currency:["PYG"],callingCode:["595"],capital:["Asunción"],altSpellings:["PY","Republic of Paraguay","República del Paraguay","Tetã Paraguái"],region:"Americas",subregion:"South America",languages:{grn:"Guaraní",spa:"Spanish"},translations:{deu:{official:"Republik Paraguay",common:"Paraguay"},fra:{official:"République du Paraguay",common:"Paraguay"},hrv:{official:"Republika Paragvaj",common:"Paragvaj"},ita:{official:"Repubblica del Paraguay",common:"Paraguay"},jpn:{official:"パラグアイ共和国",common:"パラグアイ"},nld:{official:"Republiek Paraguay",common:"Paraguay"},por:{official:"República do Paraguai",common:"Paraguai"},rus:{official:"Республика Парагвай",common:"Парагвай"},slk:{official:"Paraguajská republika",common:"Paraguaj"},spa:{official:"República de Paraguay",common:"Paraguay"},fin:{official:"Paraguayn tasavalta",common:"Paraguay"},est:{official:"Paraguay Vabariik",common:"Paraguay"},zho:{official:"巴拉圭共和国",common:"巴拉圭"}},latlng:[-23,-58],demonym:"Paraguayan",landlocked:!0,borders:["ARG","BOL","BRA"],area:406752,flag:"🇵🇾"},{name:{common:"Palestine",official:"State of Palestine",native:{ara:{official:"دولة فلسطين",common:"فلسطين"}}},tld:[".ps","فلسطين."],cca2:"PS",ccn3:"275",cca3:"PSE",cioc:"PLE",independent:!1,status:"officially-assigned",currency:["ILS"],callingCode:["970"],capital:["Ramallah"],altSpellings:["PS","Palestine, State of","State of Palestine","Dawlat Filasṭin"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Staat Palästina",common:"Palästina"},fra:{official:"État de Palestine",common:"Palestine"},hrv:{official:"State of Palestine",common:"Palestina"},ita:{official:"Stato di Palestina",common:"Palestina"},jpn:{official:"パレスチナ自治政府",common:"パレスチナ"},nld:{official:"Staat Palestina",common:"Palestijnse gebieden"},por:{official:"Estado da Palestina",common:"Palestina"},rus:{official:"Государство Палестина",common:"Палестина"},slk:{official:"Palestínsky štát",common:"Palestína"},spa:{official:"Estado de Palestina",common:"Palestina"},fin:{official:"Palestiinan valtio",common:"Palestiina"},est:{official:"Palestiina Riik",common:"Palestiina"},zho:{official:"巴勒斯坦国",common:"巴勒斯坦"}},latlng:[31.9,35.2],demonym:"Palestinian",landlocked:!1,borders:["ISR","EGY","JOR"],area:6220,flag:"🇵🇸"},{name:{common:"French Polynesia",official:"French Polynesia",native:{fra:{official:"Polynésie française",common:"Polynésie française"}}},tld:[".pf"],cca2:"PF",ccn3:"258",cca3:"PYF",cioc:"",independent:!1,status:"officially-assigned",currency:["XPF"],callingCode:["689"],capital:["Papeetē"],altSpellings:["PF","Polynésie française","French Polynesia","Pōrīnetia Farāni"],region:"Oceania",subregion:"Polynesia",languages:{fra:"French"},translations:{deu:{official:"Französisch-Polynesien",common:"Französisch-Polynesien"},fra:{official:"Polynésie française",common:"Polynésie française"},hrv:{official:"Francuska Polinezija",common:"Francuska Polinezija"},ita:{official:"Polinesia Francese",common:"Polinesia Francese"},jpn:{official:"フランス領ポリネシア",common:"フランス領ポリネシア"},nld:{official:"Frans-Polynesië",common:"Frans-Polynesië"},por:{official:"Polinésia Francesa",common:"Polinésia Francesa"},rus:{official:"Французская Полинезия",common:"Французская Полинезия"},slk:{official:"Francúzska Polynézia",common:"Francúzska Polynézia"},spa:{official:"Polinesia francés",common:"Polinesia Francesa"},fin:{official:"Ranskan Polynesia",common:"Ranskan Polynesia"},est:{official:"Prantsuse Polüneesia",common:"Prantsuse Polüneesia"},zho:{official:"法属波利尼西亚",common:"法属波利尼西亚"}},latlng:[-15,-140],demonym:"French Polynesian",landlocked:!1,borders:[],area:4167,flag:"🇵🇫"},{name:{common:"Qatar",official:"State of Qatar",native:{ara:{official:"دولة قطر",common:"قطر"}}},tld:[".qa","قطر."],cca2:"QA",ccn3:"634",cca3:"QAT",cioc:"QAT",independent:!0,status:"officially-assigned",currency:["QAR"],callingCode:["974"],capital:["Doha"],altSpellings:["QA","State of Qatar","Dawlat Qaṭar"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Staat Katar",common:"Katar"},fra:{official:"État du Qatar",common:"Qatar"},hrv:{official:"Država Katar",common:"Katar"},ita:{official:"Stato del Qatar",common:"Qatar"},jpn:{official:"カタール国",common:"カタール"},nld:{official:"Staat Qatar",common:"Qatar"},por:{official:"Estado do Qatar",common:"Catar"},rus:{official:"Государство Катар",common:"Катар"},slk:{official:"Katarský štát",common:"Katar"},spa:{official:"Estado de Qatar",common:"Catar"},fin:{official:"Qatarin valtio",common:"Qatar"},est:{official:"Katari Riik",common:"Katar"},zho:{official:"卡塔尔国",common:"卡塔尔"}},latlng:[25.5,51.25],demonym:"Qatari",landlocked:!1,borders:["SAU"],area:11586,flag:"🇶🇦"},{name:{common:"Réunion",official:"Réunion Island",native:{fra:{official:"Ile de la Réunion",common:"La Réunion"}}},tld:[".re"],cca2:"RE",ccn3:"638",cca3:"REU",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["262"],capital:["Saint-Denis"],altSpellings:["RE","Reunion"],region:"Africa",subregion:"Eastern Africa",languages:{fra:"French"},translations:{deu:{official:"Réunion",common:"Réunion"},fra:{official:"Ile de la Réunion",common:"Réunion"},hrv:{official:"Réunion Island",common:"Réunion"},ita:{official:"Réunion",common:"Riunione"},jpn:{official:"レユニオン島",common:"レユニオン"},nld:{official:"Réunion",common:"Réunion"},por:{official:"Ilha da Reunião",common:"Reunião"},rus:{official:"Реюньон",common:"Реюньон"},slk:{official:"Réunionský zámorský departmán",common:"Réunion"},spa:{official:"Isla de la Reunión",common:"Reunión"},fin:{official:"Réunion",common:"Réunion"},est:{official:"Réunioni departemang",common:"Réunion"},zho:{official:"留尼旺岛",common:"留尼旺岛"}},latlng:[-21.15,55.5],demonym:"French",landlocked:!1,borders:[],area:2511,flag:"🇷🇪"},{name:{common:"Romania",official:"Romania",native:{ron:{official:"România",common:"România"}}},tld:[".ro"],cca2:"RO",ccn3:"642",cca3:"ROU",cioc:"ROU",independent:!0,status:"officially-assigned",currency:["RON"],callingCode:["40"],capital:["Bucharest"],altSpellings:["RO","Rumania","Roumania","România"],region:"Europe",subregion:"Eastern Europe",languages:{ron:"Romanian"},translations:{deu:{official:"Rumänien",common:"Rumänien"},fra:{official:"Roumanie",common:"Roumanie"},hrv:{official:"Rumunija",common:"Rumunjska"},ita:{official:"Romania",common:"Romania"},jpn:{official:"ルーマニア",common:"ルーマニア"},nld:{official:"Roemenië",common:"Roemenië"},por:{official:"Romênia",common:"Roménia"},rus:{official:"Румыния",common:"Румыния"},slk:{official:"Rumunsko",common:"Rumunsko"},spa:{official:"Rumania",common:"Rumania"},fin:{official:"Romania",common:"Romania"},est:{official:"Rumeenia",common:"Rumeenia"},zho:{official:"罗马尼亚",common:"罗马尼亚"}},latlng:[46,25],demonym:"Romanian",landlocked:!1,borders:["BGR","HUN","MDA","SRB","UKR"],area:238391,flag:"🇷🇴"},{name:{common:"Russia",official:"Russian Federation",native:{rus:{official:"Российская Федерация",common:"Россия"}}},tld:[".ru",".su",".рф"],cca2:"RU",ccn3:"643",cca3:"RUS",cioc:"RUS",independent:!0,status:"officially-assigned",currency:["RUB"],callingCode:["7"],capital:["Moscow"],altSpellings:["RU","Russian Federation","Российская Федерация"],region:"Europe",subregion:"Eastern Europe",languages:{rus:"Russian"},translations:{deu:{official:"Russische Föderation",common:"Russland"},fra:{official:"Fédération de Russie",common:"Russie"},hrv:{official:"Ruska Federacija",common:"Rusija"},ita:{official:"Federazione russa",common:"Russia"},jpn:{official:"ロシア連邦",common:"ロシア連邦"},nld:{official:"Russische Federatie",common:"Rusland"},por:{official:"Federação Russa",common:"Rússia"},rus:{official:"Российская Федерация",common:"Россия"},slk:{official:"Ruská federácia",common:"Rusko"},spa:{official:"Federación de Rusia",common:"Rusia"},fin:{official:"Venäjän federaatio",common:"Venäjä"},est:{official:"Venemaa Föderatsioon",common:"Venemaa"},zho:{official:"俄罗斯联邦",common:"俄罗斯"}},latlng:[60,100],demonym:"Russian",landlocked:!1,borders:["AZE","BLR","CHN","EST","FIN","GEO","KAZ","PRK","LVA","LTU","MNG","NOR","POL","UKR"],area:17098242,flag:"🇷🇺"},{name:{common:"Rwanda",official:"Republic of Rwanda",native:{eng:{official:"Republic of Rwanda",common:"Rwanda"},fra:{official:"République rwandaise",common:"Rwanda"},kin:{official:"Repubulika y'u Rwanda",common:"Rwanda"}}},tld:[".rw"],cca2:"RW",ccn3:"646",cca3:"RWA",cioc:"RWA",independent:!0,status:"officially-assigned",currency:["RWF"],callingCode:["250"],capital:["Kigali"],altSpellings:["RW","Republic of Rwanda","Repubulika y'u Rwanda","République du Rwanda"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English",fra:"French",kin:"Kinyarwanda"},translations:{deu:{official:"Republik Ruanda",common:"Ruanda"},fra:{official:"République rwandaise",common:"Rwanda"},hrv:{official:"Republika Ruandi",common:"Ruanda"},ita:{official:"Repubblica del Ruanda",common:"Ruanda"},jpn:{official:"ルワンダ共和国",common:"ルワンダ"},nld:{official:"Republiek Rwanda",common:"Rwanda"},por:{official:"República do Ruanda",common:"Ruanda"},rus:{official:"Республика Руанда",common:"Руанда"},slk:{official:"Rwandská republika",common:"Rwanda"},spa:{official:"República de Rwanda",common:"Ruanda"},fin:{official:"Ruandan tasavalta",common:"Ruanda"},est:{official:"Rwanda Vabariik",common:"Rwanda"},zho:{official:"卢旺达共和国",common:"卢旺达"}},latlng:[-2,30],demonym:"Rwandan",landlocked:!0,borders:["BDI","COD","TZA","UGA"],area:26338,flag:"🇷🇼"},{name:{common:"Saudi Arabia",official:"Kingdom of Saudi Arabia",native:{ara:{official:"المملكة العربية السعودية",common:"العربية السعودية"}}},tld:[".sa",".السعودية"],cca2:"SA",ccn3:"682",cca3:"SAU",cioc:"KSA",independent:!0,status:"officially-assigned",currency:["SAR"],callingCode:["966"],capital:["Riyadh"],altSpellings:["Saudi","SA","Kingdom of Saudi Arabia","Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Königreich Saudi-Arabien",common:"Saudi-Arabien"},fra:{official:"Royaume d'Arabie Saoudite",common:"Arabie Saoudite"},hrv:{official:"Kraljevina Saudijska Arabija",common:"Saudijska Arabija"},ita:{official:"Arabia Saudita",common:"Arabia Saudita"},jpn:{official:"サウジアラビア王国",common:"サウジアラビア"},nld:{official:"Koninkrijk van Saoedi-Arabië",common:"Saoedi-Arabië"},por:{official:"Reino da Arábia Saudita",common:"Arábia Saudita"},rus:{official:"Королевство Саудовская Аравия",common:"Саудовская Аравия"},slk:{official:"Saudskoarabské kráľovstvo",common:"Saudská Arábia"},spa:{official:"Reino de Arabia Saudita",common:"Arabia Saudí"},fin:{official:"Saudi-Arabian kuningaskunta",common:"Saudi-Arabia"},est:{official:"Saudi Araabia Kuningriik",common:"Saudi Araabia"},zho:{official:"沙特阿拉伯王国",common:"沙特阿拉伯"}},latlng:[25,45],demonym:"Saudi Arabian",landlocked:!1,borders:["IRQ","JOR","KWT","OMN","QAT","ARE","YEM"],area:2149690,flag:"🇸🇦"},{name:{common:"Sudan",official:"Republic of the Sudan",native:{ara:{official:"جمهورية السودان",common:"السودان"},eng:{official:"Republic of the Sudan",common:"Sudan"}}},tld:[".sd"],cca2:"SD",ccn3:"729",cca3:"SDN",cioc:"SUD",independent:!0,status:"officially-assigned",currency:["SDG"],callingCode:["249"],capital:["Khartoum"],altSpellings:["SD","Republic of the Sudan","Jumhūrīyat as-Sūdān"],region:"Africa",subregion:"Northern Africa",languages:{ara:"Arabic",eng:"English"},translations:{deu:{official:"Republik Sudan",common:"Sudan"},fra:{official:"République du Soudan",common:"Soudan"},hrv:{official:"Republika Sudan",common:"Sudan"},ita:{official:"Repubblica del Sudan",common:"Sudan"},jpn:{official:"スーダン共和国",common:"スーダン"},nld:{official:"Republiek Soedan",common:"Soedan"},por:{official:"República do Sudão",common:"Sudão"},rus:{official:"Республика Судан",common:"Судан"},slk:{official:"Sudánska republika",common:"Sudán"},spa:{official:"República de Sudán",common:"Sudán"},fin:{official:"Sudanin tasavalta",common:"Sudan"},est:{official:"Sudaani Vabariik",common:"Sudaan"},zho:{official:"苏丹共和国",common:"苏丹"}},latlng:[15,30],demonym:"Sudanese",landlocked:!1,borders:["CAF","TCD","EGY","ERI","ETH","LBY","SSD"],area:1886068,flag:"🇸🇩"},{name:{common:"Senegal",official:"Republic of Senegal",native:{fra:{official:"République du Sénégal",common:"Sénégal"}}},tld:[".sn"],cca2:"SN",ccn3:"686",cca3:"SEN",cioc:"SEN",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["221"],capital:["Dakar"],altSpellings:["SN","Republic of Senegal","République du Sénégal"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{deu:{official:"Republik Senegal",common:"Senegal"},fra:{official:"République du Sénégal",common:"Sénégal"},hrv:{official:"Republika Senegal",common:"Senegal"},ita:{official:"Repubblica del Senegal",common:"Senegal"},jpn:{official:"セネガル共和国",common:"セネガル"},nld:{official:"Republiek Senegal",common:"Senegal"},por:{official:"República do Senegal",common:"Senegal"},rus:{official:"Республика Сенегал",common:"Сенегал"},slk:{official:"Senegalská republika",common:"Senegal"},spa:{official:"República de Senegal",common:"Senegal"},fin:{official:"Senegalin tasavalta",common:"Senegal"},est:{official:"Senegali Vabariik",common:"Senegal"},zho:{official:"塞内加尔共和国",common:"塞内加尔"}},latlng:[14,-14],demonym:"Senegalese",landlocked:!1,borders:["GMB","GIN","GNB","MLI","MRT"],area:196722,flag:"🇸🇳"},{name:{common:"Singapore",official:"Republic of Singapore",native:{zho:{official:"新加坡共和国",common:"新加坡"},eng:{official:"Republic of Singapore",common:"Singapore"},msa:{official:"Republik Singapura",common:"Singapura"},tam:{official:"சிங்கப்பூர் குடியரசு",common:"சிங்கப்பூர்"}}},tld:[".sg",".新加坡",".சிங்கப்பூர்"],cca2:"SG",ccn3:"702",cca3:"SGP",cioc:"SIN",independent:!0,status:"officially-assigned",currency:["SGD"],callingCode:["65"],capital:["Singapore"],altSpellings:["SG","Singapura","Republik Singapura","新加坡共和国"],region:"Asia",subregion:"South-Eastern Asia",languages:{zho:"Chinese",eng:"English",msa:"Malay",tam:"Tamil"},translations:{deu:{official:"Republik Singapur",common:"Singapur"},fra:{official:"République de Singapour",common:"Singapour"},hrv:{official:"Republika Singapur",common:"Singapur"},ita:{official:"Repubblica di Singapore",common:"Singapore"},jpn:{official:"シンガポール共和国",common:"シンガポール"},nld:{official:"Republiek Singapore",common:"Singapore"},por:{official:"República de Singapura",common:"Singapura"},rus:{official:"Республика Сингапур",common:"Сингапур"},slk:{official:"Singapurská republika",common:"Singapur"},spa:{official:"República de Singapur",common:"Singapur"},fin:{official:"Singaporen tasavalta",common:"Singapore"},est:{official:"Singapuri Vabariik",common:"Singapur"}},latlng:[1.36666666,103.8],demonym:"Singaporean",landlocked:!1,borders:[],area:710,flag:"🇸🇬"},{name:{common:"South Georgia",official:"South Georgia and the South Sandwich Islands",native:{eng:{official:"South Georgia and the South Sandwich Islands",common:"South Georgia"}}},tld:[".gs"],cca2:"GS",ccn3:"239",cca3:"SGS",cioc:"",independent:!1,status:"officially-assigned",currency:["GBP"],callingCode:["500"],capital:["King Edward Point"],altSpellings:["GS","South Georgia and the South Sandwich Islands"],region:"Antarctic",subregion:"",languages:{eng:"English"},translations:{deu:{official:"Südgeorgien und die Südlichen Sandwichinseln",common:"Südgeorgien und die Südlichen Sandwichinseln"},fra:{official:"Géorgie du Sud et les îles Sandwich du Sud",common:"Géorgie du Sud-et-les Îles Sandwich du Sud"},hrv:{official:"Južna Džordžija i Otoci Južni Sendvič",common:"Južna Georgija i otočje Južni Sandwich"},ita:{official:"Georgia del Sud e isole Sandwich del Sud",common:"Georgia del Sud e Isole Sandwich Meridionali"},jpn:{official:"サウスジョージア·サウスサンドウィッチ諸島",common:"サウスジョージア・サウスサンドウィッチ諸島"},nld:{official:"Zuid-Georgië en de Zuidelijke Sandwich-eilanden",common:"Zuid-Georgia en Zuidelijke Sandwicheilanden"},por:{official:"Geórgia do Sul e Sandwich do Sul",common:"Ilhas Geórgia do Sul e Sandwich do Sul"},rus:{official:"Южная Георгия и Южные Сандвичевы острова",common:"Южная Георгия и Южные Сандвичевы острова"},slk:{official:"Južná Georgia a Južné Sandwichove ostrovy",common:"Južná Georgia a Južné Sandwichove ostrovy"},spa:{official:"Georgia del Sur y las Islas Sandwich del Sur",common:"Islas Georgias del Sur y Sandwich del Sur"},fin:{official:"Etelä-Georgia ja Eteläiset Sandwichsaaret",common:"Etelä-Georgia ja Eteläiset Sandwichsaaret"},est:{official:"Lõuna-Georgia ja Lõuna-Sandwichi saared",common:"Lõuna-Georgia ja Lõuna-Sandwichi saared"},zho:{official:"南乔治亚岛和南桑威奇群岛",common:"南乔治亚"}},latlng:[-54.5,-37],demonym:"South Georgian South Sandwich Islander",landlocked:!1,borders:[],area:3903,flag:"🇬🇸"},{name:{common:"Svalbard and Jan Mayen",official:"Svalbard og Jan Mayen",native:{nor:{official:"Svalbard og Jan Mayen",common:"Svalbard og Jan Mayen"}}},tld:[".sj"],cca2:"SJ",ccn3:"744",cca3:"SJM",cioc:"",independent:!1,status:"officially-assigned",currency:["NOK"],callingCode:["4779"],capital:["Longyearbyen"],altSpellings:["SJ","Svalbard and Jan Mayen Islands"],region:"Europe",subregion:"Northern Europe",languages:{nor:"Norwegian"},translations:{deu:{official:"Inselgruppe Spitzbergen",common:"Spitzbergen"},fra:{official:"Jan Mayen Svalbard",common:"Svalbard et Jan Mayen"},hrv:{official:"Svalbard og Jan Mayen",common:"Svalbard i Jan Mayen"},ita:{official:"Svalbard og Jan Mayen",common:"Svalbard e Jan Mayen"},jpn:{official:"スバールバル諸島OGヤンマイエン",common:"スヴァールバル諸島およびヤンマイエン島"},nld:{official:"Svalbard og Jan Mayen",common:"Svalbard en Jan Mayen"},por:{official:"Svalbard og Jan Mayen",common:"Ilhas Svalbard e Jan Mayen"},rus:{official:"Свальбарда ог Ян-Майен",common:"Шпицберген и Ян-Майен"},slk:{official:"Svalbard a Jan Mayen",common:"Svalbard a Jan Mayen"},spa:{official:"Svalbard og Jan Mayen",common:"Islas Svalbard y Jan Mayen"},fin:{official:"Huippuvuoret",common:"Huippuvuoret"},est:{official:"Svalbard",common:"Svalbard"},zho:{official:"斯瓦尔巴特",common:"斯瓦尔巴特"}},latlng:[78,20],demonym:"Norwegian",landlocked:!1,borders:[],area:-1,flag:"🇸🇯"},{name:{common:"Solomon Islands",official:"Solomon Islands",native:{eng:{official:"Solomon Islands",common:"Solomon Islands"}}},tld:[".sb"],cca2:"SB",ccn3:"090",cca3:"SLB",cioc:"SOL",independent:!0,status:"officially-assigned",currency:["SBD"],callingCode:["677"],capital:["Honiara"],altSpellings:["SB"],region:"Oceania",subregion:"Melanesia",languages:{eng:"English"},translations:{deu:{official:"Salomon-Inseln",common:"Salomonen"},fra:{official:"Îles Salomon",common:"Îles Salomon"},hrv:{official:"Solomonski Otoci",common:"Solomonski Otoci"},ita:{official:"Isole Salomone",common:"Isole Salomone"},jpn:{official:"ソロモン諸島",common:"ソロモン諸島"},nld:{official:"Solomon eilanden",common:"Salomonseilanden"},por:{official:"Ilhas Salomão",common:"Ilhas Salomão"},rus:{official:"Соломоновы острова",common:"Соломоновы Острова"},slk:{official:"Salomonove ostrovy",common:"Salomonove ostrovy"},spa:{official:"islas Salomón",common:"Islas Salomón"},fin:{official:"Salomonsaaret",common:"Salomonsaaret"},est:{official:"Saalomoni Saared",common:"Saalomoni Saared"},zho:{official:"所罗门群岛",common:"所罗门群岛"}},latlng:[-8,159],demonym:"Solomon Islander",landlocked:!1,borders:[],area:28896,flag:"🇸🇧"},{name:{common:"Sierra Leone",official:"Republic of Sierra Leone",native:{eng:{official:"Republic of Sierra Leone",common:"Sierra Leone"}}},tld:[".sl"],cca2:"SL",ccn3:"694",cca3:"SLE",cioc:"SLE",independent:!0,status:"officially-assigned",currency:["SLL"],callingCode:["232"],capital:["Freetown"],altSpellings:["SL","Republic of Sierra Leone"],region:"Africa",subregion:"Western Africa",languages:{eng:"English"},translations:{deu:{official:"Republik Sierra Leone",common:"Sierra Leone"},fra:{official:"République de Sierra Leone",common:"Sierra Leone"},hrv:{official:"Republika Sijera Leone",common:"Sijera Leone"},ita:{official:"Repubblica della Sierra Leone",common:"Sierra Leone"},jpn:{official:"シエラレオネ共和国",common:"シエラレオネ"},nld:{official:"Republiek Sierra Leone",common:"Sierra Leone"},por:{official:"República da Serra Leoa",common:"Serra Leoa"},rus:{official:"Республика Сьерра-Леоне",common:"Сьерра-Леоне"},slk:{official:"Sierraleonská republika",common:"Sierra Leone"},spa:{official:"República de Sierra Leona",common:"Sierra Leone"},fin:{official:"Sierra Leonen tasavalta",common:"Sierra Leone"},est:{official:"Sierra Leone Vabariik",common:"Sierra Leone"},zho:{official:"塞拉利昂共和国",common:"塞拉利昂"}},latlng:[8.5,-11.5],demonym:"Sierra Leonean",landlocked:!1,borders:["GIN","LBR"],area:71740,flag:"🇸🇱"},{name:{common:"El Salvador",official:"Republic of El Salvador",native:{spa:{official:"República de El Salvador",common:"El Salvador"}}},tld:[".sv"],cca2:"SV",ccn3:"222",cca3:"SLV",cioc:"ESA",independent:!0,status:"officially-assigned",currency:["SVC","USD"],callingCode:["503"],capital:["San Salvador"],altSpellings:["SV","Republic of El Salvador","República de El Salvador"],region:"Americas",subregion:"Central America",languages:{spa:"Spanish"},translations:{cym:{official:"Gweriniaeth El Salfador",common:"El Salfador"},deu:{official:"Republik El Salvador",common:"El Salvador"},fra:{official:"République du Salvador",common:"Salvador"},hrv:{official:"Republika El Salvador",common:"Salvador"},ita:{official:"Repubblica di El Salvador",common:"El Salvador"},jpn:{official:"エルサルバドル共和国",common:"エルサルバドル"},nld:{official:"Republiek El Salvador",common:"El Salvador"},por:{official:"República de El Salvador",common:"El Salvador"},rus:{official:"Республика Эль-Сальвадор",common:"Сальвадор"},slk:{official:"Salvádorská republika",common:"Salvádor"},spa:{official:"República de El Salvador",common:"El Salvador"},fin:{official:"El Salvadorin tasavalta",common:"El Salvador"},est:{official:"El Salvadori Vabariik",common:"El Salvador"},zho:{official:"萨尔瓦多共和国",common:"萨尔瓦多"}},latlng:[13.83333333,-88.91666666],demonym:"Salvadoran",landlocked:!1,borders:["GTM","HND"],area:21041,flag:"🇸🇻"},{name:{common:"San Marino",official:"Most Serene Republic of San Marino",native:{ita:{official:"Serenissima Repubblica di San Marino",common:"San Marino"}}},tld:[".sm"],cca2:"SM",ccn3:"674",cca3:"SMR",cioc:"SMR",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["378"],capital:["City of San Marino"],altSpellings:["SM","Republic of San Marino","Repubblica di San Marino"],region:"Europe",subregion:"Southern Europe",languages:{ita:"Italian"},translations:{deu:{official:"Republik San Marino",common:"San Marino"},fra:{official:"République de Saint-Marin",common:"Saint-Marin"},hrv:{official:"Većina Serene Republika San Marino",common:"San Marino"},ita:{official:"Serenissima Repubblica di San Marino",common:"San Marino"},jpn:{official:"サンマリノのほとんどセリーヌ共和国",common:"サンマリノ"},nld:{official:"Meest Serene Republiek San Marino",common:"San Marino"},por:{official:"Sereníssima República de San Marino",common:"San Marino"},rus:{official:"Большинство Serene Республика Сан-Марино",common:"Сан-Марино"},slk:{official:"Sanmarínska republika",common:"San Maríno"},spa:{official:"Serenísima República de San Marino",common:"San Marino"},fin:{official:"San Marinon seesteinen tasavalta",common:"San Marino"},est:{official:"San Marino Vabariik",common:"San Marino"},zho:{official:"圣马力诺共和国",common:"圣马力诺"}},latlng:[43.76666666,12.41666666],demonym:"Sammarinese",landlocked:!0,borders:["ITA"],area:61,flag:"🇸🇲"},{name:{common:"Somalia",official:"Federal Republic of Somalia",native:{ara:{official:"جمهورية الصومال‎‎",common:"الصومال‎‎"},som:{official:"Jamhuuriyadda Federaalka Soomaaliya",common:"Soomaaliya"}}},tld:[".so"],cca2:"SO",ccn3:"706",cca3:"SOM",cioc:"SOM",independent:!0,status:"officially-assigned",currency:["SOS"],callingCode:["252"],capital:["Mogadishu"],altSpellings:["SO","aṣ-Ṣūmāl","Federal Republic of Somalia","Jamhuuriyadda Federaalka Soomaaliya","Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya"],region:"Africa",subregion:"Eastern Africa",languages:{ara:"Arabic",som:"Somali"},translations:{deu:{official:"Bundesrepublik Somalia",common:"Somalia"},fra:{official:"République fédérale de Somalie",common:"Somalie"},hrv:{official:"Savezna Republika Somaliji",common:"Somalija"},ita:{official:"Repubblica federale di Somalia",common:"Somalia"},jpn:{official:"ソマリア連邦共和国",common:"ソマリア"},nld:{official:"Federale Republiek Somalië",common:"Somalië"},por:{official:"República Federal da Somália",common:"Somália"},rus:{official:"Федеративная Республика Сомали",common:"Сомали"},slk:{official:"Somálska federatívna republika",common:"Somálsko"},spa:{official:"República Federal de Somalia",common:"Somalia"},fin:{official:"Somalian liittotasavalta",common:"Somalia"},est:{official:"Somaalia Liitvabariik",common:"Somaalia"},zho:{official:"索马里共和国",common:"索马里"}},latlng:[10,49],demonym:"Somali",landlocked:!1,borders:["DJI","ETH","KEN"],area:637657,flag:"🇸🇴"},{name:{common:"Saint Pierre and Miquelon",official:"Saint Pierre and Miquelon",native:{fra:{official:"Collectivité territoriale de Saint-Pierre-et-Miquelon",common:"Saint-Pierre-et-Miquelon"}}},tld:[".pm"],cca2:"PM",ccn3:"666",cca3:"SPM",cioc:"",independent:!1,status:"officially-assigned",currency:["EUR"],callingCode:["508"],capital:["Saint-Pierre"],altSpellings:["PM","Collectivité territoriale de Saint-Pierre-et-Miquelon"],region:"Americas",subregion:"Northern America",languages:{fra:"French"},translations:{deu:{official:"St. Pierre und Miquelon",common:"Saint-Pierre und Miquelon"},fra:{official:"Saint-Pierre-et-Miquelon",common:"Saint-Pierre-et-Miquelon"},hrv:{official:"Saint Pierre i Miquelon",common:"Sveti Petar i Mikelon"},ita:{official:"Saint Pierre e Miquelon",common:"Saint-Pierre e Miquelon"},jpn:{official:"サンピエール島·ミクロン島",common:"サンピエール島・ミクロン島"},nld:{official:"Saint-Pierre en Miquelon",common:"Saint Pierre en Miquelon"},por:{official:"Saint Pierre e Miquelon",common:"Saint-Pierre e Miquelon"},rus:{official:"Сен-Пьер и Микелон",common:"Сен-Пьер и Микелон"},slk:{official:"Ostrovy Saint Pierre a Miquelon",common:"Saint Pierre a Miquelon"},spa:{official:"San Pedro y Miquelón",common:"San Pedro y Miquelón"},fin:{official:"Saint-Pierre ja Miquelon",common:"Saint-Pierre ja Miquelon"},est:{official:"Saint-Pierre’i ja Miqueloni territoriaalühendus",common:"Saint-Pierre ja Miquelon"},zho:{official:"圣皮埃尔和密克隆",common:"圣皮埃尔和密克隆"}},latlng:[46.83333333,-56.33333333],demonym:"French",landlocked:!1,borders:[],area:242,flag:"🇵🇲"},{name:{common:"Serbia",official:"Republic of Serbia",native:{srp:{official:"Република Србија",common:"Србија"}}},tld:[".rs",".срб"],cca2:"RS",ccn3:"688",cca3:"SRB",cioc:"SRB",independent:!0,status:"officially-assigned",currency:["RSD"],callingCode:["381"],capital:["Belgrade"],altSpellings:["RS","Srbija","Republic of Serbia","Република Србија","Republika Srbija"],region:"Europe",subregion:"Southern Europe",languages:{srp:"Serbian"},translations:{deu:{official:"Republik Serbien",common:"Serbien"},fra:{official:"République de Serbie",common:"Serbie"},hrv:{official:"Republika Srbija",common:"Srbija"},ita:{official:"Repubblica di Serbia",common:"Serbia"},jpn:{official:"セルビア共和国",common:"セルビア"},nld:{official:"Republiek Servië",common:"Servië"},por:{official:"República da Sérvia",common:"Sérvia"},rus:{official:"Республика Сербия",common:"Сербия"},slk:{official:"Srbská republika",common:"Srbsko"},spa:{official:"República de Serbia",common:"Serbia"},fin:{official:"Serbian tasavalta",common:"Serbia"},est:{official:"Serbia Vabariik",common:"Serbia"},zho:{official:"塞尔维亚共和国",common:"塞尔维亚"}},latlng:[44,21],demonym:"Serbian",landlocked:!0,borders:["BIH","BGR","HRV","HUN","UNK","MKD","MNE","ROU"],area:88361,flag:"🇷🇸"},{name:{common:"South Sudan",official:"Republic of South Sudan",native:{eng:{official:"Republic of South Sudan",common:"South Sudan"}}},tld:[".ss"],cca2:"SS",ccn3:"728",cca3:"SSD",cioc:"",independent:!0,status:"officially-assigned",currency:["SSP"],callingCode:["211"],capital:["Juba"],altSpellings:["SS"],region:"Africa",subregion:"Middle Africa",languages:{eng:"English"},translations:{deu:{official:"Republik Südsudan",common:"Südsudan"},fra:{official:"République du Soudan du Sud",common:"Soudan du Sud"},hrv:{official:"Republika Južni Sudan",common:"Južni Sudan"},ita:{official:"Repubblica del Sudan del Sud",common:"Sudan del sud"},jpn:{official:"南スーダン共和国",common:"南スーダン"},nld:{official:"Republiek Zuid-Soedan",common:"Zuid-Soedan"},por:{official:"República do Sudão do Sul",common:"Sudão do Sul"},rus:{official:"Республика Южный Судан",common:"Южный Судан"},slk:{official:"Juhosudánska republika",common:"Južný Sudán"},spa:{official:"República de Sudán del Sur",common:"Sudán del Sur"},fin:{official:"Etelä-Sudanin tasavalta",common:"Etelä-Sudan"},est:{official:"Lõuna-Sudaani Vabariik",common:"Lõuna-Sudaan"},zho:{official:"南苏丹共和国",common:"南苏丹"}},latlng:[7,30],demonym:"South Sudanese",landlocked:!0,borders:["CAF","COD","ETH","KEN","SDN","UGA"],area:619745,flag:"🇸🇸"},{name:{common:"São Tomé and Príncipe",official:"Democratic Republic of São Tomé and Príncipe",native:{por:{official:"República Democrática do São Tomé e Príncipe",common:"São Tomé e Príncipe"}}},tld:[".st"],cca2:"ST",ccn3:"678",cca3:"STP",cioc:"STP",independent:!0,status:"officially-assigned",currency:["STD"],callingCode:["239"],capital:["São Tomé"],altSpellings:["ST","Democratic Republic of São Tomé and Príncipe","Sao Tome and Principe","República Democrática de São Tomé e Príncipe"],region:"Africa",subregion:"Middle Africa",languages:{por:"Portuguese"},translations:{deu:{official:"Demokratische Republik São Tomé und Príncipe",common:"São Tomé und Príncipe"},fra:{official:"République démocratique de São Tomé et Príncipe",common:"São Tomé et Príncipe"},hrv:{official:"Demokratska Republika São Tome i Principe",common:"Sveti Toma i Princip"},ita:{official:"Repubblica democratica di São Tomé e Príncipe",common:"São Tomé e Príncipe"},jpn:{official:"サントメ·プリンシペ民主共和国",common:"サントメ・プリンシペ"},nld:{official:"Democratische Republiek Sao Tomé en Principe",common:"Sao Tomé en Principe"},por:{official:"República Democrática de São Tomé e Príncipe",common:"São Tomé e Príncipe"},spa:{official:"República Democrática de Santo Tomé y Príncipe",common:"Santo Tomé y Príncipe"},rus:{official:"Демократическая Республика Сан-Томе и Принсипи",common:"Сан-Томе и Принсипи"},slk:{official:"Demokratická republika Svätého Tomáša A princovho ostrova",common:"Svätý Tomáš a Princov ostrov"},fin:{official:"São Tomé ja Príncipen demokraattinen tasavalta",common:"São Téme ja Príncipe"},est:{official:"São Tomé ja Príncipe Demokraatlik Vabariik",common:"São Tomé ja Príncipe"},zho:{official:"圣多美和普林西比民主共和国",common:"圣多美和普林西比"}},latlng:[1,7],demonym:"Sao Tomean",landlocked:!1,borders:[],area:964,flag:"🇸🇹"},{name:{common:"Suriname",official:"Republic of Suriname",native:{nld:{official:"Republiek Suriname",common:"Suriname"}}},tld:[".sr"],cca2:"SR",ccn3:"740",cca3:"SUR",cioc:"SUR",independent:!0,status:"officially-assigned",currency:["SRD"],callingCode:["597"],capital:["Paramaribo"],altSpellings:["SR","Sarnam","Sranangron","Republic of Suriname","Republiek Suriname"],region:"Americas",subregion:"South America",languages:{nld:"Dutch"},translations:{deu:{official:"Republik Suriname",common:"Suriname"},fra:{official:"République du Suriname",common:"Surinam"},hrv:{official:"Republika Surinam",common:"Surinam"},ita:{official:"Repubblica del Suriname",common:"Suriname"},jpn:{official:"スリナム共和国",common:"スリナム"},nld:{official:"Republiek Suriname",common:"Suriname"},por:{official:"República do Suriname",common:"Suriname"},rus:{official:"Республика Суринам",common:"Суринам"},slk:{official:"Surinamská republika",common:"Surinam"},spa:{official:"República de Suriname",common:"Surinam"},fin:{official:"Surinamen tasavalta",common:"Suriname"},est:{official:"Suriname Vabariik",common:"Suriname"},zho:{official:"苏里南共和国",common:"苏里南"}},latlng:[4,-56],demonym:"Surinamer",landlocked:!1,borders:["BRA","GUF","GUY"],area:163820,flag:"🇸🇷"},{name:{common:"Slovakia",official:"Slovak Republic",native:{slk:{official:"Slovenská republika",common:"Slovensko"}}},tld:[".sk"],cca2:"SK",ccn3:"703",cca3:"SVK",cioc:"SVK",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["421"],capital:["Bratislava"],altSpellings:["SK","Slovak Republic","Slovenská republika"],region:"Europe",subregion:"Central Europe",languages:{slk:"Slovak"},translations:{deu:{official:"Slowakische Republik",common:"Slowakei"},fra:{official:"République slovaque",common:"Slovaquie"},hrv:{official:"slovačka",common:"Slovačka"},ita:{official:"Repubblica slovacca",common:"Slovacchia"},jpn:{official:"スロバキア共和国",common:"スロバキア"},nld:{official:"Slowaakse Republiek",common:"Slowakije"},por:{official:"República Eslovaca",common:"Eslováquia"},rus:{official:"Словацкая Республика",common:"Словакия"},slk:{official:"Slovenská republika",common:"Slovensko"},spa:{official:"República Eslovaca",common:"República Eslovaca"},fin:{official:"Slovakian tasavalta",common:"Slovakia"},est:{official:"Slovaki Vabariik",common:"Slovakkia"},zho:{official:"斯洛伐克共和国",common:"斯洛伐克"}},latlng:[48.66666666,19.5],demonym:"Slovak",landlocked:!0,borders:["AUT","CZE","HUN","POL","UKR"],area:49037,flag:"🇸🇰"},{name:{common:"Slovenia",official:"Republic of Slovenia",native:{slv:{official:"Republika Slovenija",common:"Slovenija"}}},tld:[".si"],cca2:"SI",ccn3:"705",cca3:"SVN",cioc:"SLO",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["386"],capital:["Ljubljana"],altSpellings:["SI","Republic of Slovenia","Republika Slovenija"],region:"Europe",subregion:"Southern Europe",languages:{slv:"Slovene"},translations:{deu:{official:"Republik Slowenien",common:"Slowenien"},fra:{official:"République de Slovénie",common:"Slovénie"},hrv:{official:"Republika Slovenija",common:"Slovenija"},ita:{official:"Repubblica di Slovenia",common:"Slovenia"},jpn:{official:"スロベニア共和国",common:"スロベニア"},nld:{official:"Republiek Slovenië",common:"Slovenië"},por:{official:"República da Eslovénia",common:"Eslovénia"},rus:{official:"Республика Словения",common:"Словения"},slk:{official:"Slovinská republika",common:"Slovinsko"},spa:{official:"República de Eslovenia",common:"Eslovenia"},fin:{official:"Slovenian tasavalta",common:"Slovenia"},est:{official:"Sloveenia Vabariik",common:"Sloveenia"},zho:{official:"斯洛文尼亚共和国",common:"斯洛文尼亚"}},latlng:[46.11666666,14.81666666],demonym:"Slovene",landlocked:!1,borders:["AUT","HRV","ITA","HUN"],area:20273,flag:"🇸🇮"},{name:{common:"Sweden",official:"Kingdom of Sweden",native:{swe:{official:"Konungariket Sverige",common:"Sverige"}}},tld:[".se"],cca2:"SE",ccn3:"752",cca3:"SWE",cioc:"SWE",independent:!0,status:"officially-assigned",currency:["SEK"],callingCode:["46"],capital:["Stockholm"],altSpellings:["SE","Kingdom of Sweden","Konungariket Sverige"],region:"Europe",subregion:"Northern Europe",languages:{swe:"Swedish"},translations:{deu:{official:"Königreich Schweden",common:"Schweden"},fra:{official:"Royaume de Suède",common:"Suède"},hrv:{official:"Kraljevina Švedska",common:"Švedska"},ita:{official:"Regno di Svezia",common:"Svezia"},jpn:{official:"スウェーデン王国",common:"スウェーデン"},nld:{official:"Koninkrijk Zweden",common:"Zweden"},por:{official:"Reino da Suécia",common:"Suécia"},rus:{official:"Королевство Швеция",common:"Швеция"},slk:{official:"Švédske kráľovstvo",common:"Švédsko"},spa:{official:"Reino de Suecia",common:"Suecia"},fin:{official:"Ruotsin kuningaskunta",common:"Ruotsi"},est:{official:"Rootsi Kuningriik",common:"Rootsi"},zho:{official:"瑞典王国",common:"瑞典"}},latlng:[62,15],demonym:"Swedish",landlocked:!1,borders:["FIN","NOR"],area:450295,flag:"🇸🇪"},{name:{common:"Swaziland",official:"Kingdom of Swaziland",native:{eng:{official:"Kingdom of Swaziland",common:"Swaziland"},ssw:{official:"Kingdom of Swaziland",common:"Swaziland"}}},tld:[".sz"],cca2:"SZ",ccn3:"748",cca3:"SWZ",cioc:"SWZ",independent:!0,status:"officially-assigned",currency:["SZL"],callingCode:["268"],capital:["Lobamba"],altSpellings:["SZ","weSwatini","Swatini","Ngwane","Kingdom of Swaziland","Umbuso waseSwatini"],region:"Africa",subregion:"Southern Africa",languages:{eng:"English",ssw:"Swazi"},translations:{deu:{official:"Königreich Swasiland",common:"Swasiland"},fra:{official:"Royaume du Swaziland",common:"Swaziland"},hrv:{official:"Kraljevina Svazi",common:"Svazi"},ita:{official:"Regno dello Swaziland",common:"Swaziland"},jpn:{official:"スワジランド王国",common:"スワジランド"},nld:{official:"Koninkrijk Swaziland",common:"Swaziland"},por:{official:"Reino da Suazilândia",common:"Suazilândia"},rus:{official:"Королевство Свазиленд",common:"Свазиленд"},slk:{official:"Svazijské kráľovstvo",common:"Svazijsko"},spa:{official:"Reino de Swazilandia",common:"Suazilandia"},fin:{official:"Swazimaan kuningaskunta",common:"Swazimaa"},est:{official:"Svaasimaa Kuningriik",common:"Svaasimaa"},zho:{official:"斯威士兰王国",common:"斯威士兰"}},latlng:[-26.5,31.5],demonym:"Swazi",landlocked:!0,borders:["MOZ","ZAF"],area:17364,flag:"🇸🇿"},{name:{common:"Sint Maarten",official:"Sint Maarten",native:{eng:{official:"Sint Maarten",common:"Sint Maarten"},fra:{official:"Saint-Martin",common:"Saint-Martin"},nld:{official:"Sint Maarten",common:"Sint Maarten"}}},tld:[".sx"],cca2:"SX",ccn3:"534",cca3:"SXM",cioc:"",independent:!1,status:"officially-assigned",currency:["ANG"],callingCode:["1721"],capital:["Philipsburg"],altSpellings:["SX","Sint Maarten (Dutch part)"],region:"Americas",subregion:"Caribbean",languages:{eng:"English",fra:"French",nld:"Dutch"},translations:{deu:{official:"Sint Maarten",common:"Sint Maarten"},fra:{official:"Sint Maarten",common:"Saint-Martin"},ita:{official:"Sint Maarten",common:"Sint Maarten"},jpn:{official:"シントマールテン島",common:"シント・マールテン"},nld:{official:"Sint Maarten",common:"Sint Maarten"},por:{official:"Sint Maarten",common:"São Martinho"},rus:{official:"Синт-Маартен",common:"Синт-Мартен"},slk:{official:"Sint Maarten",common:"Sint Maarten"},spa:{official:"Sint Maarten",common:"Sint Maarten"},fin:{official:"Sint Maarten",common:"Sint Maarten"},est:{official:"Sint Maarten",common:"Sint Maarten"},zho:{official:"圣马丁岛",common:"圣马丁岛"}},latlng:[18.033333,-63.05],demonym:"St. Maartener",landlocked:!1,borders:["MAF"],area:34,flag:"🇸🇽"},{name:{common:"Seychelles",official:"Republic of Seychelles",native:{crs:{official:"Repiblik Sesel",common:"Sesel"},eng:{official:"Republic of Seychelles",common:"Seychelles"},fra:{official:"République des Seychelles",common:"Seychelles"}}},tld:[".sc"],cca2:"SC",ccn3:"690",cca3:"SYC",cioc:"SEY",independent:!0,status:"officially-assigned",currency:["SCR"],callingCode:["248"],capital:["Victoria"],altSpellings:["SC","Republic of Seychelles","Repiblik Sesel","République des Seychelles"],region:"Africa",subregion:"Eastern Africa",languages:{crs:"Seychellois Creole",eng:"English",fra:"French"},translations:{deu:{official:"Republik der Seychellen",common:"Seychellen"},fra:{official:"République des Seychelles",common:"Seychelles"},hrv:{official:"Republika Sejšeli",common:"Sejšeli"},ita:{official:"Repubblica delle Seychelles",common:"Seychelles"},jpn:{official:"セイシェル共和国",common:"セーシェル"},nld:{official:"Republiek der Seychellen",common:"Seychellen"},por:{official:"República das Seychelles",common:"Seicheles"},rus:{official:"Республика Сейшельские Острова",common:"Сейшельские Острова"},slk:{official:"Seychelská republika",common:"Seychely"},spa:{official:"República de las Seychelles",common:"Seychelles"},fin:{official:"Seychellien tasavalta",common:"Seychellit"},est:{official:"Seišelli Vabariik",common:"Seišellid"},zho:{official:"塞舌尔共和国",common:"塞舌尔"}},latlng:[-4.58333333,55.66666666],demonym:"Seychellois",landlocked:!1,borders:[],area:452,flag:"🇸🇨"},{name:{common:"Syria",official:"Syrian Arab Republic",native:{ara:{official:"الجمهورية العربية السورية",common:"سوريا"}}},tld:[".sy","سوريا."],cca2:"SY",ccn3:"760",cca3:"SYR",cioc:"SYR",independent:!0,status:"officially-assigned",currency:["SYP"],callingCode:["963"],capital:["Damascus"],altSpellings:["SY","Syrian Arab Republic","Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Arabische Republik Syrien",common:"Syrien"},fra:{official:"République arabe syrienne",common:"Syrie"},hrv:{official:"Sirijska Arapska Republika",common:"Sirija"},ita:{official:"Repubblica araba siriana",common:"Siria"},jpn:{official:"シリアアラブ共和国",common:"シリア・アラブ共和国"},nld:{official:"Syrische Arabische Republiek",common:"Syrië"},por:{official:"República Árabe Síria",common:"Síria"},rus:{official:"Сирийская Арабская Республика",common:"Сирия"},slk:{official:"Sýrska arabská republika",common:"Sýria"},spa:{official:"República Árabe Siria",common:"Siria"},fin:{official:"Syyrian arabitasavalta",common:"Syyria"},est:{official:"Süüria Araabia Vabariik",common:"Süüria"},zho:{official:"叙利亚阿拉伯共和国",common:"叙利亚"}},latlng:[35,38],demonym:"Syrian",landlocked:!1,borders:["IRQ","ISR","JOR","LBN","TUR"],area:185180,flag:"🇸🇾"},{name:{common:"Turks and Caicos Islands",official:"Turks and Caicos Islands",native:{eng:{official:"Turks and Caicos Islands",common:"Turks and Caicos Islands"}}},tld:[".tc"],cca2:"TC",ccn3:"796",cca3:"TCA",cioc:"",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1649"],capital:["Cockburn Town"],altSpellings:["TC"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Turks und Caicos Inseln",common:"Turks-und Caicosinseln"},fra:{official:"Îles Turques et Caïques",common:"Îles Turques-et-Caïques"},hrv:{official:"Otoci Turks i Caicos",common:"Otoci Turks i Caicos"},ita:{official:"Turks e Caicos",common:"Isole Turks e Caicos"},jpn:{official:"タークス·カイコス諸島",common:"タークス・カイコス諸島"},nld:{official:"Turks-en Caicoseilanden",common:"Turks-en Caicoseilanden"},por:{official:"Ilhas Turks e Caicos",common:"Ilhas Turks e Caicos"},rus:{official:"Теркс и Кайкос острова",common:"Теркс и Кайкос"},slk:{official:"Ostrovy Turks a Caicos",common:"Turks a Caicos"},spa:{official:"Islas Turcas y Caicos",common:"Islas Turks y Caicos"},fin:{official:"Turks-ja Caicossaaret",common:"Turks-ja Caicossaaret"},est:{official:"Turksi ja Caicose saared",common:"Turks ja Caicos"},zho:{official:"特克斯和凯科斯群岛",common:"特克斯和凯科斯群岛"}},latlng:[21.75,-71.58333333],demonym:"Turks and Caicos Islander",landlocked:!1,borders:[],area:948,flag:"🇹🇨"},{name:{common:"Chad",official:"Republic of Chad",native:{ara:{official:"جمهورية تشاد",common:"تشاد‎"},fra:{official:"République du Tchad",common:"Tchad"}}},tld:[".td"],cca2:"TD",ccn3:"148",cca3:"TCD",cioc:"CHA",independent:!0,status:"officially-assigned",currency:["XAF"],callingCode:["235"],capital:["N'Djamena"],altSpellings:["TD","Tchad","Republic of Chad","République du Tchad"],region:"Africa",subregion:"Middle Africa",languages:{ara:"Arabic",fra:"French"},translations:{cym:{official:"Gweriniaeth Tsiad",common:"Tsiad"},deu:{official:"Republik Tschad",common:"Tschad"},fra:{official:"République du Tchad",common:"Tchad"},hrv:{official:"Čadu",common:"Čad"},ita:{official:"Repubblica del Ciad",common:"Ciad"},jpn:{official:"チャド共和国",common:"チャド"},nld:{official:"Republiek Tsjaad",common:"Tsjaad"},por:{official:"República do Chade",common:"Chade"},rus:{official:"Республика Чад",common:"Чад"},slk:{official:"Čadská republika",common:"Čad"},spa:{official:"República de Chad",common:"Chad"},fin:{official:"Tšadin tasavalta",common:"Tšad"},est:{official:"Tšaadi Vabariik",common:"Tšaad"},zho:{official:"乍得共和国",common:"乍得"}},latlng:[15,19],demonym:"Chadian",landlocked:!0,borders:["CMR","CAF","LBY","NER","NGA","SDN"],area:1284e3,flag:"🇹🇩"},{name:{common:"Togo",official:"Togolese Republic",native:{fra:{official:"République togolaise",common:"Togo"}}},tld:[".tg"],cca2:"TG",ccn3:"768",cca3:"TGO",cioc:"TOG",independent:!0,status:"officially-assigned",currency:["XOF"],callingCode:["228"],capital:["Lomé"],altSpellings:["TG","Togolese","Togolese Republic","République Togolaise"],region:"Africa",subregion:"Western Africa",languages:{fra:"French"},translations:{deu:{official:"Republik Togo",common:"Togo"},fra:{official:"République togolaise",common:"Togo"},hrv:{official:"Togolese Republika",common:"Togo"},ita:{official:"Repubblica del Togo",common:"Togo"},jpn:{official:"トーゴ共和国",common:"トーゴ"},nld:{official:"Republiek Togo",common:"Togo"},por:{official:"República do Togo",common:"Togo"},rus:{official:"Того Республика",common:"Того"},slk:{official:"Togská republika",common:"Togo"},spa:{official:"República de Togo",common:"Togo"},fin:{official:"Togon tasavalta",common:"Togo"},est:{official:"Togo Vabariik",common:"Togo"},zho:{official:"多哥共和国",common:"多哥"}},latlng:[8,1.16666666],demonym:"Togolese",landlocked:!1,borders:["BEN","BFA","GHA"],area:56785,flag:"🇹🇬"},{name:{common:"Thailand",official:"Kingdom of Thailand",native:{tha:{official:"ราชอาณาจักรไทย",common:"ประเทศไทย"}}},tld:[".th",".ไทย"],cca2:"TH",ccn3:"764",cca3:"THA",cioc:"THA",independent:!0,status:"officially-assigned",currency:["THB"],callingCode:["66"],capital:["Bangkok"],altSpellings:["TH","Prathet","Thai","Kingdom of Thailand","ราชอาณาจักรไทย","Ratcha Anachak Thai"],region:"Asia",subregion:"South-Eastern Asia",languages:{tha:"Thai"},translations:{deu:{official:"Königreich Thailand",common:"Thailand"},fra:{official:"Royaume de Thaïlande",common:"Thaïlande"},hrv:{official:"Kraljevina Tajland",common:"Tajland"},ita:{official:"Regno di Thailandia",common:"Tailandia"},jpn:{official:"タイ王国",common:"タイ"},nld:{official:"Koninkrijk Thailand",common:"Thailand"},por:{official:"Reino da Tailândia",common:"Tailândia"},rus:{official:"Королевство Таиланд",common:"Таиланд"},slk:{official:"Thajské kráľovstvo",common:"Thajsko"},spa:{official:"Reino de Tailandia",common:"Tailandia"},fin:{official:"Thaimaan kuningaskunta",common:"Thaimaa"},est:{official:"Tai Kuningriik",common:"Tai"},zho:{official:"泰王国",common:"泰国"}},latlng:[15,100],demonym:"Thai",landlocked:!1,borders:["MMR","KHM","LAO","MYS"],area:513120,flag:"🇹🇭"},{name:{common:"Tajikistan",official:"Republic of Tajikistan",native:{rus:{official:"Республика Таджикистан",common:"Таджикистан"},tgk:{official:"Ҷумҳурии Тоҷикистон",common:"Тоҷикистон"}}},tld:[".tj"],cca2:"TJ",ccn3:"762",cca3:"TJK",cioc:"TJK",independent:!0,status:"officially-assigned",currency:["TJS"],callingCode:["992"],capital:["Dushanbe"],altSpellings:["TJ","Toçikiston","Republic of Tajikistan","Ҷумҳурии Тоҷикистон","Çumhuriyi Toçikiston"],region:"Asia",subregion:"Central Asia",languages:{rus:"Russian",tgk:"Tajik"},translations:{deu:{official:"Republik Tadschikistan",common:"Tadschikistan"},fra:{official:"République du Tadjikistan",common:"Tadjikistan"},hrv:{official:"Republika Tadžikistan",common:"Tađikistan"},ita:{official:"Repubblica del Tajikistan",common:"Tagikistan"},jpn:{official:"タジキスタン共和国",common:"タジキスタン"},nld:{official:"Tadzjikistan",common:"Tadzjikistan"},por:{official:"República do Tajiquistão",common:"Tajiquistão"},rus:{official:"Республика Таджикистан",common:"Таджикистан"},slk:{official:"Taǆická republika",common:"Taǆikistan"},spa:{official:"República de Tayikistán",common:"Tayikistán"},fin:{official:"Tadžikistanin tasavalta",common:"Tadžikistan"},est:{official:"Tadžikistani Vabariik",common:"Tadžikistan"},zho:{official:"塔吉克斯坦共和国",common:"塔吉克斯坦"}},latlng:[39,71],demonym:"Tadzhik",landlocked:!0,borders:["AFG","CHN","KGZ","UZB"],area:143100,flag:"🇹🇯"},{name:{common:"Tokelau",official:"Tokelau",native:{eng:{official:"Tokelau",common:"Tokelau"},smo:{official:"Tokelau",common:"Tokelau"},tkl:{official:"Tokelau",common:"Tokelau"}}},tld:[".tk"],cca2:"TK",ccn3:"772",cca3:"TKL",cioc:"",independent:!1,status:"officially-assigned",currency:["NZD"],callingCode:["690"],capital:["Fakaofo"],altSpellings:["TK"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",smo:"Samoan",tkl:"Tokelauan"},translations:{deu:{official:"Tokelau",common:"Tokelau"},fra:{official:"Îles Tokelau",common:"Tokelau"},hrv:{official:"Tokelau",common:"Tokelau"},ita:{official:"Tokelau",common:"Isole Tokelau"},jpn:{official:"トケラウ諸島",common:"トケラウ"},nld:{official:"Tokelau",common:"Tokelau"},por:{official:"Tokelau",common:"Tokelau"},rus:{official:"Токелау",common:"Токелау"},slk:{official:"Tokelauské ostrovy",common:"Tokelau"},spa:{official:"Tokelau",common:"Islas Tokelau"},fin:{official:"Tokelau",common:"Tokelau"},est:{official:"Tokelau",common:"Tokelau"},zho:{official:"托克劳",common:"托克劳"}},latlng:[-9,-172],demonym:"Tokelauan",landlocked:!1,borders:[],area:12,flag:"🇹🇰"},{name:{common:"Turkmenistan",official:"Turkmenistan",native:{rus:{official:"Туркменистан",common:"Туркмения"},tuk:{official:"Türkmenistan",common:"Türkmenistan"}}},tld:[".tm"],cca2:"TM",ccn3:"795",cca3:"TKM",cioc:"TKM",independent:!0,status:"officially-assigned",currency:["TMT"],callingCode:["993"],capital:["Ashgabat"],altSpellings:["TM"],region:"Asia",subregion:"Central Asia",languages:{rus:"Russian",tuk:"Turkmen"},translations:{deu:{official:"Turkmenistan",common:"Turkmenistan"},fra:{official:"Turkménistan",common:"Turkménistan"},hrv:{official:"Turkmenistan",common:"Turkmenistan"},ita:{official:"Turkmenistan",common:"Turkmenistan"},jpn:{official:"トルクメニスタン",common:"トルクメニスタン"},nld:{official:"Turkmenistan",common:"Turkmenistan"},por:{official:"Turcomenistão",common:"Turquemenistão"},rus:{official:"Туркменистан",common:"Туркмения"},slk:{official:"Turkménsko",common:"Turkménsko"},spa:{official:"Turkmenistán",common:"Turkmenistán"},fin:{official:"Turkmenistan",common:"Turkmenistan"},est:{official:"Türkmenistan",common:"Türkmenistan"},zho:{official:"土库曼斯坦",common:"土库曼斯坦"}},latlng:[40,60],demonym:"Turkmen",landlocked:!0,borders:["AFG","IRN","KAZ","UZB"],area:488100,flag:"🇹🇲"},{name:{common:"Timor-Leste",official:"Democratic Republic of Timor-Leste",native:{por:{official:"República Democrática de Timor-Leste",common:"Timor-Leste"},tet:{official:"Repúblika Demokrátika Timór-Leste",common:"Timór-Leste"}}},tld:[".tl"],cca2:"TL",ccn3:"626",cca3:"TLS",cioc:"TLS",independent:!0,status:"officially-assigned",currency:["USD"],callingCode:["670"],capital:["Dili"],altSpellings:["TL","East Timor","Democratic Republic of Timor-Leste","República Democrática de Timor-Leste","Repúblika Demokrátika Timór-Leste","Timór Lorosa'e","Timor Lorosae"],region:"Asia",subregion:"South-Eastern Asia",languages:{por:"Portuguese",tet:"Tetum"},translations:{deu:{official:"Demokratische Republik Timor-Leste",common:"Timor-Leste"},fra:{official:"République démocratique du Timor oriental",common:"Timor oriental"},hrv:{official:"Demokratska Republika Timor-Leste",common:"Istočni Timor"},ita:{official:"Repubblica Democratica di Timor Est",common:"Timor Est"},jpn:{official:"東ティモール民主共和国",common:"東ティモール"},nld:{official:"Democratische Republiek Oost-Timor",common:"Oost-Timor"},por:{official:"República Democrática de Timor-Leste",common:"Timor-Leste"},rus:{official:"Демократическая Республика Тимор -Лешти",common:"Восточный Тимор"},slk:{official:"Východotimorská demokratická republika",common:"Východný Timor"},spa:{official:"República Democrática de Timor-Leste",common:"Timor Oriental"},fin:{official:"Itä-Timorin demokraattinen tasavalta",common:"Itä-Timor"},est:{official:"Timor-Leste Demokraatlik Vabariik",common:"Ida-Timor"},zho:{official:"东帝汶民主共和国",common:"东帝汶"}},latlng:[-8.83333333,125.91666666],demonym:"East Timorese",landlocked:!1,borders:["IDN"],area:14874,flag:"🇹🇱"},{name:{common:"Tonga",official:"Kingdom of Tonga",native:{eng:{official:"Kingdom of Tonga",common:"Tonga"},ton:{official:"Kingdom of Tonga",common:"Tonga"}}},tld:[".to"],cca2:"TO",ccn3:"776",cca3:"TON",cioc:"TGA",independent:!0,status:"officially-assigned",currency:["TOP"],callingCode:["676"],capital:["Nuku'alofa"],altSpellings:["TO"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",ton:"Tongan"},translations:{deu:{official:"Königreich Tonga",common:"Tonga"},fra:{official:"Royaume des Tonga",common:"Tonga"},hrv:{official:"Kraljevina Tonga",common:"Tonga"},ita:{official:"Regno di Tonga",common:"Tonga"},jpn:{official:"トンガ王国",common:"トンガ"},nld:{official:"Koninkrijk Tonga",common:"Tonga"},por:{official:"Reino de Tonga",common:"Tonga"},rus:{official:"Королевство Тонга",common:"Тонга"},slk:{official:"Tongské kráľovstvo",common:"Tonga"},spa:{official:"Reino de Tonga",common:"Tonga"},fin:{official:"Tongan kuningaskunta",common:"Tonga"},est:{official:"Tonga Kuningriik",common:"Tonga"},zho:{official:"汤加王国",common:"汤加"}},latlng:[-20,-175],demonym:"Tongan",landlocked:!1,borders:[],area:747,flag:"🇹🇴"},{name:{common:"Trinidad and Tobago",official:"Republic of Trinidad and Tobago",native:{eng:{official:"Republic of Trinidad and Tobago",common:"Trinidad and Tobago"}}},tld:[".tt"],cca2:"TT",ccn3:"780",cca3:"TTO",cioc:"TTO",independent:!0,status:"officially-assigned",currency:["TTD"],callingCode:["1868"],capital:["Port of Spain"],altSpellings:["TT","Republic of Trinidad and Tobago"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Republik Trinidad und Tobago",common:"Trinidad und Tobago"},fra:{official:"République de Trinité-et-Tobago",common:"Trinité-et-Tobago"},hrv:{official:"Republika Trinidad i Tobago",common:"Trinidad i Tobago"},ita:{official:"Repubblica di Trinidad e Tobago",common:"Trinidad e Tobago"},jpn:{official:"トリニダード·トバゴ共和国",common:"トリニダード・トバゴ"},nld:{official:"Republiek Trinidad en Tobago",common:"Trinidad en Tobago"},por:{official:"República de Trinidad e Tobago",common:"Trinidade e Tobago"},rus:{official:"Республика Тринидад и Тобаго",common:"Тринидад и Тобаго"},slk:{official:"Republika Trinidad a Tobaga",common:"Trinidad a Tobago"},spa:{official:"República de Trinidad y Tobago",common:"Trinidad y Tobago"},fin:{official:"Trinidadin ja Tobagon tasavalta",common:"Trinidad ja Tobago"},est:{official:"Trinidadi ja Tobago Vabariik",common:"Trinidad ja Tobago"},zho:{official:"特立尼达和多巴哥共和国",common:"特立尼达和多巴哥"}},latlng:[11,-61],demonym:"Trinidadian",landlocked:!1,borders:[],area:5130,flag:"🇹🇹"},{name:{common:"Tunisia",official:"Tunisian Republic",native:{ara:{official:"الجمهورية التونسية",common:"تونس"}}},tld:[".tn"],cca2:"TN",ccn3:"788",cca3:"TUN",cioc:"TUN",independent:!0,status:"officially-assigned",currency:["TND"],callingCode:["216"],capital:["Tunis"],altSpellings:["TN","Republic of Tunisia","al-Jumhūriyyah at-Tūnisiyyah"],region:"Africa",subregion:"Northern Africa",languages:{ara:"Arabic"},translations:{deu:{official:"Tunesische Republik",common:"Tunesien"},fra:{official:"République tunisienne",common:"Tunisie"},hrv:{official:"Tuniski Republika",common:"Tunis"},ita:{official:"Repubblica tunisina",common:"Tunisia"},jpn:{official:"チュニジア共和国",common:"チュニジア"},nld:{official:"Republiek Tunesië",common:"Tunesië"},por:{official:"República da Tunísia",common:"Tunísia"},rus:{official:"Тунисской Республики",common:"Тунис"},slk:{official:"Tuniská republika",common:"Tunisko"},spa:{official:"República de Túnez",common:"Túnez"},fin:{official:"Tunisian tasavalta",common:"Tunisia"},est:{official:"Tuneesia Vabariik",common:"Tuneesia"},zho:{official:"突尼斯共和国",common:"突尼斯"}},latlng:[34,9],demonym:"Tunisian",landlocked:!1,borders:["DZA","LBY"],area:163610,flag:"🇹🇳"},{name:{common:"Turkey",official:"Republic of Turkey",native:{tur:{official:"Türkiye Cumhuriyeti",common:"Türkiye"}}},tld:[".tr"],cca2:"TR",ccn3:"792",cca3:"TUR",cioc:"TUR",independent:!0,status:"officially-assigned",currency:["TRY"],callingCode:["90"],capital:["Ankara"],altSpellings:["TR","Turkiye","Republic of Turkey","Türkiye Cumhuriyeti"],region:"Asia",subregion:"Western Asia",languages:{tur:"Turkish"},translations:{deu:{official:"Republik Türkei",common:"Türkei"},fra:{official:"République de Turquie",common:"Turquie"},hrv:{official:"Republika Turska",common:"Turska"},ita:{official:"Repubblica di Turchia",common:"Turchia"},jpn:{official:"トルコ共和国",common:"トルコ"},nld:{official:"Republiek Turkije",common:"Turkije"},por:{official:"República da Turquia",common:"Turquia"},rus:{official:"Республика Турции",common:"Турция"},slk:{official:"Turecká republika",common:"Turecko"},spa:{official:"República de Turquía",common:"Turquía"},fin:{official:"Turkin tasavalta",common:"Turkki"},est:{official:"Türgi Vabariik",common:"Türgi"},zho:{official:"土耳其共和国",common:"土耳其"}},latlng:[39,35],demonym:"Turkish",landlocked:!1,borders:["ARM","AZE","BGR","GEO","GRC","IRN","IRQ","SYR"],area:783562,flag:"🇹🇷"},{name:{common:"Tuvalu",official:"Tuvalu",native:{eng:{official:"Tuvalu",common:"Tuvalu"},tvl:{official:"Tuvalu",common:"Tuvalu"}}},tld:[".tv"],cca2:"TV",ccn3:"798",cca3:"TUV",cioc:"TUV",independent:!0,status:"officially-assigned",currency:["AUD"],callingCode:["688"],capital:["Funafuti"],altSpellings:["TV"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",tvl:"Tuvaluan"},translations:{deu:{official:"Tuvalu",common:"Tuvalu"},fra:{official:"Tuvalu",common:"Tuvalu"},hrv:{official:"Tuvalu",common:"Tuvalu"},ita:{official:"Tuvalu",common:"Tuvalu"},jpn:{official:"ツバル",common:"ツバル"},nld:{official:"Tuvalu",common:"Tuvalu"},por:{official:"Tuvalu",common:"Tuvalu"},rus:{official:"Тувалу",common:"Тувалу"},slk:{official:"Tuvalu",common:"Tuvalu"},spa:{official:"Tuvalu",common:"Tuvalu"},fin:{official:"Tuvalu",common:"Tuvalu"},est:{official:"Tuvalu",common:"Tuvalu"},zho:{official:"图瓦卢",common:"图瓦卢"}},latlng:[-8,178],demonym:"Tuvaluan",landlocked:!1,borders:[],area:26,flag:"🇹🇻"},{name:{common:"Taiwan",official:"Republic of China (Taiwan)",native:{zho:{official:"中華民國",common:"台灣"}}},tld:[".tw",".台灣",".台湾"],cca2:"TW",ccn3:"158",cca3:"TWN",cioc:"TPE",independent:!1,status:"officially-assigned",currency:["TWD"],callingCode:["886"],capital:["Taipei"],altSpellings:["TW","Táiwān","Republic of China","中華民國","Zhōnghuá Mínguó","Chinese Taipei"],region:"Asia",subregion:"Eastern Asia",languages:{zho:"Chinese"},translations:{deu:{official:"Republik China (Taiwan)",common:"Taiwan"},fra:{official:"République de Chine (Taïwan)",common:"Taïwan"},hrv:{official:"Republika Kina",common:"Tajvan"},ita:{official:"Repubblica cinese (Taiwan)",common:"Taiwan"},jpn:{official:"中華民国",common:"台湾"},nld:{official:"Republiek China (Taiwan)",common:"Taiwan"},por:{official:"República da China",common:"Ilha Formosa"},rus:{official:"Китайская Республика",common:"Тайвань"},slk:{official:"Čínska republika",common:"Taiwan"},spa:{official:"República de China en Taiwán",common:"Taiwán"},fin:{official:"Kiinan tasavalta",common:"Taiwan"},est:{official:"Taiwani",common:"Taiwan"}},latlng:[23.5,121],demonym:"Taiwanese",landlocked:!1,borders:[],area:36193,flag:"🇹🇼"},{name:{common:"Tanzania",official:"United Republic of Tanzania",native:{eng:{official:"United Republic of Tanzania",common:"Tanzania"},swa:{official:"Jamhuri ya Muungano wa Tanzania",common:"Tanzania"}}},tld:[".tz"],cca2:"TZ",ccn3:"834",cca3:"TZA",cioc:"TAN",independent:!0,status:"officially-assigned",currency:["TZS"],callingCode:["255"],capital:["Dodoma"],altSpellings:["TZ","Tanzania, United Republic of","United Republic of Tanzania","Jamhuri ya Muungano wa Tanzania"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English",swa:"Swahili"},translations:{deu:{official:"Vereinigte Republik Tansania",common:"Tansania"},fra:{official:"République -Unie de Tanzanie",common:"Tanzanie"},hrv:{official:"Ujedinjena Republika Tanzanija",common:"Tanzanija"},ita:{official:"Repubblica Unita di Tanzania",common:"Tanzania"},jpn:{official:"タンザニア連合共和国",common:"タンザニア"},nld:{official:"Verenigde Republiek Tanzania",common:"Tanzania"},por:{official:"República Unida da Tanzânia",common:"Tanzânia"},rus:{official:"Объединенная Республика Танзания",common:"Танзания"},slk:{official:"Tanzánijská zjednotená republika",common:"Tanzánia"},spa:{official:"República Unida de Tanzania",common:"Tanzania"},fin:{official:"Tansanian yhdistynyt tasavalta",common:"Tansania"},est:{official:"Tansaania Ühendvabariik",common:"Tansaania"},zho:{official:"坦桑尼亚联合共和国",common:"坦桑尼亚"}},latlng:[-6,35],demonym:"Tanzanian",landlocked:!1,borders:["BDI","COD","KEN","MWI","MOZ","RWA","UGA","ZMB"],area:945087,flag:"🇹🇿"},{name:{common:"Uganda",official:"Republic of Uganda",native:{eng:{official:"Republic of Uganda",common:"Uganda"},swa:{official:"Republic of Uganda",common:"Uganda"}}},tld:[".ug"],cca2:"UG",ccn3:"800",cca3:"UGA",cioc:"UGA",independent:!0,status:"officially-assigned",currency:["UGX"],callingCode:["256"],capital:["Kampala"],altSpellings:["UG","Republic of Uganda","Jamhuri ya Uganda"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English",swa:"Swahili"},translations:{deu:{official:"Republik Uganda",common:"Uganda"},fra:{official:"République de l'Ouganda",common:"Ouganda"},hrv:{official:"Republika Uganda",common:"Uganda"},ita:{official:"Repubblica di Uganda",common:"Uganda"},jpn:{official:"ウガンダ共和国",common:"ウガンダ"},nld:{official:"Republiek Uganda",common:"Oeganda"},por:{official:"República do Uganda",common:"Uganda"},rus:{official:"Республика Уганда",common:"Уганда"},slk:{official:"Ugandská republika",common:"Uganda"},spa:{official:"República de Uganda",common:"Uganda"},fin:{official:"Ugandan tasavalta",common:"Uganda"},est:{official:"Uganda Vabariik",common:"Uganda"},zho:{official:"乌干达共和国",common:"乌干达"}},latlng:[1,32],demonym:"Ugandan",landlocked:!0,borders:["COD","KEN","RWA","SSD","TZA"],area:241550,flag:"🇺🇬"},{name:{common:"Ukraine",official:"Ukraine",native:{ukr:{official:"Україна",common:"Україна"}}},tld:[".ua",".укр"],cca2:"UA",ccn3:"804",cca3:"UKR",cioc:"UKR",independent:!0,status:"officially-assigned",currency:["UAH"],callingCode:["380"],capital:["Kyiv"],altSpellings:["UA","Ukrayina"],region:"Europe",subregion:"Eastern Europe",languages:{ukr:"Ukrainian"},translations:{deu:{official:"Ukraine",common:"Ukraine"},fra:{official:"Ukraine",common:"Ukraine"},hrv:{official:"Ukrajina",common:"Ukrajina"},ita:{official:"Ucraina",common:"Ucraina"},jpn:{official:"ウクライナ",common:"ウクライナ"},nld:{official:"Oekraïne",common:"Oekraïne"},por:{official:"Ucrânia",common:"Ucrânia"},rus:{official:"Украина",common:"Украина"},slk:{official:"Ukrajina",common:"Ukrajina"},spa:{official:"Ucrania",common:"Ucrania"},fin:{official:"Ukraina",common:"Ukraina"},est:{official:"Ukraina",common:"Ukraina"},zho:{official:"乌克兰",common:"乌克兰"}},latlng:[49,32],demonym:"Ukrainian",landlocked:!1,borders:["BLR","HUN","MDA","POL","ROU","RUS","SVK"],area:603500,flag:"🇺🇦"},{name:{common:"United States Minor Outlying Islands",official:"United States Minor Outlying Islands",native:{eng:{official:"United States Minor Outlying Islands",common:"United States Minor Outlying Islands"}}},tld:[".us"],cca2:"UM",ccn3:"581",cca3:"UMI",cioc:"",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:[],capital:[""],altSpellings:["UM"],region:"Americas",subregion:"Northern America",languages:{eng:"English"},translations:{deu:{official:"USA, kleinere ausgelagerte Inseln",common:"Kleinere Inselbesitzungen der Vereinigten Staaten"},fra:{official:"Îles mineures éloignées des États-Unis",common:"Îles mineures éloignées des États-Unis"},hrv:{official:"Mali udaljeni otoci SAD-a",common:"Mali udaljeni otoci SAD-a"},ita:{official:"Stati Uniti Isole Minori",common:"Isole minori esterne degli Stati Uniti d'America"},jpn:{official:"アメリカ合衆国外諸島",common:"合衆国領有小離島"},nld:{official:"Kleine afgelegen eilanden van de Verenigde Staten",common:"Kleine afgelegen eilanden van de Verenigde Staten"},por:{official:"Estados Unidos Ilhas Menores Distantes",common:"Ilhas Menores Distantes dos Estados Unidos"},rus:{official:"Внешние малые острова США",common:"Внешние малые острова США"},slk:{official:"Menšie odľahlé ostrovy Spjoených štátov",common:"Menšie odľahlé ostrovy USA"},spa:{official:"Estados Unidos Islas menores alejadas de",common:"Islas Ultramarinas Menores de Estados Unidos"},fin:{official:"Yhdysvaltain asumattomat saaret",common:"Yhdysvaltain asumattomat saaret"},est:{official:"Ühendriikide väikesed hajasaared",common:"Ühendriikide hajasaared"},zho:{official:"美国本土外小岛屿",common:"美国本土外小岛屿"}},latlng:[19.3,166.633333],demonym:"American",landlocked:!1,borders:[],area:34.2,flag:"🇺🇲"},{name:{common:"Uruguay",official:"Oriental Republic of Uruguay",native:{spa:{official:"República Oriental del Uruguay",common:"Uruguay"}}},tld:[".uy"],cca2:"UY",ccn3:"858",cca3:"URY",cioc:"URU",independent:!0,status:"officially-assigned",currency:["UYI","UYU"],callingCode:["598"],capital:["Montevideo"],altSpellings:["UY","Oriental Republic of Uruguay","República Oriental del Uruguay"],region:"Americas",subregion:"South America",languages:{spa:"Spanish"},translations:{deu:{official:"Republik Östlich des Uruguay",common:"Uruguay"},fra:{official:"République orientale de l'Uruguay",common:"Uruguay"},hrv:{official:"Orijentalna Republika Urugvaj",common:"Urugvaj"},ita:{official:"Repubblica Orientale dell'Uruguay",common:"Uruguay"},jpn:{official:"ウルグアイ東方共和国",common:"ウルグアイ"},nld:{official:"Oosterse Republiek Uruguay",common:"Uruguay"},por:{official:"República Oriental do Uruguai",common:"Uruguai"},rus:{official:"Восточной Республики Уругвай",common:"Уругвай"},slk:{official:"Uruguajská východná republika",common:"Uruguaj"},spa:{official:"República Oriental del Uruguay",common:"Uruguay"},fin:{official:"Uruguayn itäinen tasavalta",common:"Uruguay"},est:{official:"Uruguay Idavabariik",common:"Uruguay"},zho:{official:"乌拉圭东岸共和国",common:"乌拉圭"}},latlng:[-33,-56],demonym:"Uruguayan",landlocked:!1,borders:["ARG","BRA"],area:181034,flag:"🇺🇾"},{name:{common:"United States",official:"United States of America",native:{eng:{official:"United States of America",common:"United States"}}},tld:[".us"],cca2:"US",ccn3:"840",cca3:"USA",cioc:"USA",independent:!0,status:"officially-assigned",currency:["USD","USN","USS"],callingCode:["1"],capital:["Washington D.C."],altSpellings:["US","USA","United States of America"],region:"Americas",subregion:"Northern America",languages:{eng:"English"},translations:{deu:{official:"Vereinigte Staaten von Amerika",common:"Vereinigte Staaten von Amerika"},fra:{official:"Les états-unis d'Amérique",common:"États-Unis"},hrv:{official:"Sjedinjene Države Amerike",common:"Sjedinjene Američke Države"},ita:{official:"Stati Uniti d'America",common:"Stati Uniti d'America"},jpn:{official:"アメリカ合衆国",common:"アメリカ合衆国"},nld:{official:"Verenigde Staten van Amerika",common:"Verenigde Staten"},por:{official:"Estados Unidos da América",common:"Estados Unidos"},rus:{official:"Соединенные Штаты Америки",common:"Соединённые Штаты Америки"},slk:{official:"Spojené štáty Americké",common:"Spojené štáty americké"},spa:{official:"Estados Unidos de América",common:"Estados Unidos"},fin:{official:"Amerikan yhdysvallat",common:"Yhdysvallat"},est:{official:"Ameerika Ühendriigid",common:"Ameerika Ühendriigid"},zho:{official:"美利坚合众国",common:"美国"}},latlng:[38,-97],demonym:"American",landlocked:!1,borders:["CAN","MEX"],area:9372610,flag:"🇺🇸"},{name:{common:"Uzbekistan",official:"Republic of Uzbekistan",native:{rus:{official:"Республика Узбекистан",common:"Узбекистан"},uzb:{official:"O'zbekiston Respublikasi",common:"O‘zbekiston"}}},tld:[".uz"],cca2:"UZ",ccn3:"860",cca3:"UZB",cioc:"UZB",independent:!0,status:"officially-assigned",currency:["UZS"],callingCode:["998"],capital:["Tashkent"],altSpellings:["UZ","Republic of Uzbekistan","O‘zbekiston Respublikasi","Ўзбекистон Республикаси"],region:"Asia",subregion:"Central Asia",languages:{rus:"Russian",uzb:"Uzbek"},translations:{deu:{official:"Republik Usbekistan",common:"Usbekistan"},fra:{official:"République d'Ouzbékistan",common:"Ouzbékistan"},hrv:{official:"Republika Uzbekistan",common:"Uzbekistan"},ita:{official:"Repubblica di Uzbekistan",common:"Uzbekistan"},jpn:{official:"ウズベキスタン共和国",common:"ウズベキスタン"},nld:{official:"Republiek Oezbekistan",common:"Oezbekistan"},por:{official:"República do Usbequistão",common:"Uzbequistão"},rus:{official:"Республика Узбекистан",common:"Узбекистан"},slk:{official:"Uzbecká republika",common:"Uzbekistan"},spa:{official:"República de Uzbekistán",common:"Uzbekistán"},fin:{official:"Uzbekistanin tasavalta",common:"Uzbekistan"},est:{official:"Usbekistani Vabariik",common:"Usbekistan"},zho:{official:"乌兹别克斯坦共和国",common:"乌兹别克斯坦"}},latlng:[41,64],demonym:"Uzbekistani",landlocked:!0,borders:["AFG","KAZ","KGZ","TJK","TKM"],area:447400,flag:"🇺🇿"},{name:{common:"Vatican City",official:"Vatican City State",native:{ita:{official:"Stato della Città del Vaticano",common:"Vaticano"},lat:{official:"Status Civitatis Vaticanæ",common:"Vaticanæ"}}},tld:[".va"],cca2:"VA",ccn3:"336",cca3:"VAT",cioc:"",independent:!0,status:"officially-assigned",currency:["EUR"],callingCode:["3906698","379"],capital:["Vatican City"],altSpellings:["VA","Holy See (Vatican City State)","Vatican City State","Stato della Città del Vaticano"],region:"Europe",subregion:"Southern Europe",languages:{ita:"Italian",lat:"Latin"},translations:{deu:{official:"Staat Vatikanstadt",common:"Vatikanstadt"},fra:{official:"Cité du Vatican",common:"Cité du Vatican"},hrv:{official:"Vatikan",common:"Vatikan"},ita:{official:"Città del Vaticano",common:"Città del Vaticano"},jpn:{official:"バチカン市国の状態",common:"バチカン市国"},nld:{official:"Vaticaanstad",common:"Vaticaanstad"},por:{official:"Cidade do Vaticano",common:"Cidade do Vaticano"},rus:{official:"Город-государство Ватикан",common:"Ватикан"},slk:{official:"Svätá stolica (Vatikánsky mestský štát",common:"Vatikán"},spa:{official:"Ciudad del Vaticano",common:"Ciudad del Vaticano"},fin:{official:"Vatikaanin kaupunkivaltio",common:"Vatikaani"},est:{official:"Vatikani Linnriik",common:"Vatikan"},zho:{official:"梵蒂冈城国",common:"梵蒂冈"}},latlng:[41.9,12.45],demonym:"Italian",landlocked:!0,borders:["ITA"],area:.44,flag:"🇻🇦"},{name:{common:"Saint Vincent and the Grenadines",official:"Saint Vincent and the Grenadines",native:{eng:{official:"Saint Vincent and the Grenadines",common:"Saint Vincent and the Grenadines"}}},tld:[".vc"],cca2:"VC",ccn3:"670",cca3:"VCT",cioc:"VIN",independent:!0,status:"officially-assigned",currency:["XCD"],callingCode:["1784"],capital:["Kingstown"],altSpellings:["VC"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"St. Vincent und die Grenadinen",common:"Saint Vincent und die Grenadinen"},fra:{official:"Saint-Vincent-et-les Grenadines",common:"Saint-Vincent-et-les-Grenadines"},hrv:{official:"Sveti Vincent i Grenadini",common:"Sveti Vincent i Grenadini"},ita:{official:"Saint Vincent e Grenadine",common:"Saint Vincent e Grenadine"},jpn:{official:"セントビンセントおよびグレナディーン諸島",common:"セントビンセントおよびグレナディーン諸島"},nld:{official:"Saint Vincent en de Grenadines",common:"Saint Vincent en de Grenadines"},por:{official:"São Vicente e Granadinas",common:"São Vincente e Granadinas"},rus:{official:"Сент-Винсент и Гренадины",common:"Сент-Винсент и Гренадины"},slk:{official:"Svätý Vincent a Grenadíny",common:"Svätý Vincent a Grenadíny"},spa:{official:"San Vicente y las Granadinas",common:"San Vicente y Granadinas"},fin:{official:"Saint Vincent ja Grenadiinit",common:"Saint Vincent ja Grenadiinit"},est:{official:"Saint Vincent ja Grenadiinid",common:"Saint Vincent"},zho:{official:"圣文森特和格林纳丁斯",common:"圣文森特和格林纳丁斯"}},latlng:[13.25,-61.2],demonym:"Saint Vincentian",landlocked:!1,borders:[],area:389,flag:"🇻🇨"},{name:{common:"Venezuela",official:"Bolivarian Republic of Venezuela",native:{spa:{official:"República Bolivariana de Venezuela",common:"Venezuela"}}},tld:[".ve"],cca2:"VE",ccn3:"862",cca3:"VEN",cioc:"VEN",independent:!0,status:"officially-assigned",currency:["VEF"],callingCode:["58"],capital:["Caracas"],altSpellings:["VE","Bolivarian Republic of Venezuela","Venezuela, Bolivarian Republic of","República Bolivariana de Venezuela"],region:"Americas",subregion:"South America",languages:{spa:"Spanish"},translations:{deu:{official:"Bolivarische Republik Venezuela",common:"Venezuela"},fra:{official:"République bolivarienne du Venezuela",common:"Venezuela"},hrv:{official:"BOLIVARIJANSKA Republika Venezuela",common:"Venezuela"},ita:{official:"Repubblica Bolivariana del Venezuela",common:"Venezuela"},jpn:{official:"ベネズエラ·ボリバル共和国",common:"ベネズエラ・ボリバル共和国"},nld:{official:"Bolivariaanse Republiek Venezuela",common:"Venezuela"},por:{official:"República Bolivariana da Venezuela",common:"Venezuela"},rus:{official:"Боливарианская Республика Венесуэла",common:"Венесуэла"},slk:{official:"Venezuelská bolívarovská republika",common:"Venezuela"},spa:{official:"República Bolivariana de Venezuela",common:"Venezuela"},fin:{official:"Venezuelan bolivariaainen tasavalta",common:"Venezuela"},est:{official:"Venezuela Bolívari Vabariik",common:"Venezuela"},zho:{official:"委内瑞拉玻利瓦尔共和国",common:"委内瑞拉"}},latlng:[8,-66],demonym:"Venezuelan",landlocked:!1,borders:["BRA","COL","GUY"],area:916445,flag:"🇻🇪"},{name:{common:"British Virgin Islands",official:"Virgin Islands",native:{eng:{official:"Virgin Islands",common:"British Virgin Islands"}}},tld:[".vg"],cca2:"VG",ccn3:"092",cca3:"VGB",cioc:"IVB",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1284"],capital:["Road Town"],altSpellings:["VG","Virgin Islands, British"],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Jungferninseln",common:"Britische Jungferninseln"},fra:{official:"îles Vierges",common:"Îles Vierges britanniques"},hrv:{official:"Djevičanski Otoci",common:"Britanski Djevičanski Otoci"},ita:{official:"Isole Vergini",common:"Isole Vergini Britanniche"},jpn:{official:"バージン諸島",common:"イギリス領ヴァージン諸島"},nld:{official:"Maagdeneilanden",common:"Britse Maagdeneilanden"},por:{official:"Ilhas Virgens",common:"Ilhas Virgens"},rus:{official:"Виргинские острова",common:"Британские Виргинские острова"},slk:{official:"Panenské ostrovy",common:"Panenské ostrovy"},spa:{official:"Islas Vírgenes",common:"Islas Vírgenes del Reino Unido"},fin:{official:"Brittiläiset Neitsytsaaret",common:"Neitsytsaaret"},est:{official:"Neitsisaared",common:"Briti Neitsisaared"},zho:{official:"英属维尔京群岛",common:"英属维尔京群岛"}},latlng:[18.431383,-64.62305],demonym:"Virgin Islander",landlocked:!1,borders:[],area:151,flag:"🇻🇬"},{name:{common:"United States Virgin Islands",official:"Virgin Islands of the United States",native:{eng:{official:"Virgin Islands of the United States",common:"United States Virgin Islands"}}},tld:[".vi"],cca2:"VI",ccn3:"850",cca3:"VIR",cioc:"ISV",independent:!1,status:"officially-assigned",currency:["USD"],callingCode:["1340"],capital:["Charlotte Amalie"],altSpellings:["VI","Virgin Islands, U.S."],region:"Americas",subregion:"Caribbean",languages:{eng:"English"},translations:{deu:{official:"Jungferninseln der Vereinigten Staaten",common:"Amerikanische Jungferninseln"},fra:{official:"Îles Vierges des États-Unis",common:"Îles Vierges des États-Unis"},hrv:{official:"Djevičanski Otoci SAD",common:"Američki Djevičanski Otoci"},ita:{official:"Isole Vergini degli Stati Uniti",common:"Isole Vergini americane"},jpn:{official:"米国のバージン諸島",common:"アメリカ領ヴァージン諸島"},nld:{official:"Maagdeneilanden van de Verenigde Staten",common:"Amerikaanse Maagdeneilanden"},por:{official:"Ilhas Virgens dos Estados Unidos",common:"Ilhas Virgens dos Estados Unidos"},rus:{official:"Виргинские острова Соединенных Штатов",common:"Виргинские Острова"},slk:{official:"Americké Panenské ostrovy",common:"Americké Panenské ostrovy"},spa:{official:"Islas Vírgenes de los Estados Unidos",common:"Islas Vírgenes de los Estados Unidos"},fin:{official:"Yhdysvaltain Neitsytsaaret",common:"Neitsytsaaret"},est:{official:"Ühendriikide Neitsisaared",common:"Neitsisaared, USA"},zho:{official:"美属维尔京群岛",common:"美属维尔京群岛"}},latlng:[18.35,-64.933333],demonym:"Virgin Islander",landlocked:!1,borders:[],area:347,flag:"🇻🇮"},{name:{common:"Vietnam",official:"Socialist Republic of Vietnam",native:{vie:{official:"Cộng hòa xã hội chủ nghĩa Việt Nam",common:"Việt Nam"}}},tld:[".vn"],cca2:"VN",ccn3:"704",cca3:"VNM",cioc:"VIE",independent:!0,status:"officially-assigned",currency:["VND"],callingCode:["84"],capital:["Hanoi"],altSpellings:["VN","Socialist Republic of Vietnam","Cộng hòa Xã hội chủ nghĩa Việt Nam","Viet Nam"],region:"Asia",subregion:"South-Eastern Asia",languages:{vie:"Vietnamese"},translations:{deu:{official:"Sozialistische Republik Vietnam",common:"Vietnam"},fra:{official:"République socialiste du Viêt Nam",common:"Viêt Nam"},hrv:{official:"Socijalistička Republika Vijetnam",common:"Vijetnam"},ita:{official:"Repubblica socialista del Vietnam",common:"Vietnam"},jpn:{official:"ベトナム社会主義共和国",common:"ベトナム"},nld:{official:"Socialistische Republiek Vietnam",common:"Vietnam"},por:{official:"República Socialista do Vietname",common:"Vietname"},rus:{official:"Социалистическая Республика Вьетнам",common:"Вьетнам"},slk:{official:"Vietnamská socialistická republika",common:"Vietnam"},spa:{official:"República Socialista de Vietnam",common:"Vietnam"},fin:{official:"Vietnamin sosialistinen tasavalta",common:"Vietnam"},est:{official:"Vietnami Sotsialistlik Vabariik",common:"Vietnam"},zho:{official:"越南社会主义共和国",common:"越南"}},latlng:[16.16666666,107.83333333],demonym:"Vietnamese",landlocked:!1,borders:["KHM","CHN","LAO"],area:331212,flag:"🇻🇳"},{name:{common:"Vanuatu",official:"Republic of Vanuatu",native:{bis:{official:"Ripablik blong Vanuatu",common:"Vanuatu"},eng:{official:"Republic of Vanuatu",common:"Vanuatu"},fra:{official:"République de Vanuatu",common:"Vanuatu"}}},tld:[".vu"],cca2:"VU",ccn3:"548",cca3:"VUT",cioc:"VAN",independent:!0,status:"officially-assigned",currency:["VUV"],callingCode:["678"],capital:["Port Vila"],altSpellings:["VU","Republic of Vanuatu","Ripablik blong Vanuatu","République de Vanuatu"],region:"Oceania",subregion:"Melanesia",languages:{bis:"Bislama",eng:"English",fra:"French"},translations:{deu:{official:"Vanuatu",common:"Vanuatu"},fra:{official:"République de Vanuatu",common:"Vanuatu"},hrv:{official:"Republika Vanuatu",common:"Vanuatu"},ita:{official:"Repubblica di Vanuatu",common:"Vanuatu"},jpn:{official:"バヌアツ共和国",common:"バヌアツ"},nld:{official:"Republiek Vanuatu",common:"Vanuatu"},por:{official:"República de Vanuatu",common:"Vanuatu"},rus:{official:"Республика Вануату",common:"Вануату"},slk:{official:"Vanuatská republika",common:"Vanuatu"},spa:{official:"República de Vanuatu",common:"Vanuatu"},fin:{official:"Vanuatun tasavalta",common:"Vanuatu"},est:{official:"Vanuatu Vabariik",common:"Vanuatu"},zho:{official:"瓦努阿图共和国",common:"瓦努阿图"}},latlng:[-16,167],demonym:"Ni-Vanuatu",landlocked:!1,borders:[],area:12189,flag:"🇻🇺"},{name:{common:"Wallis and Futuna",official:"Territory of the Wallis and Futuna Islands",native:{fra:{official:"Territoire des îles Wallis et Futuna",common:"Wallis et Futuna"}}},tld:[".wf"],cca2:"WF",ccn3:"876",cca3:"WLF",cioc:"",independent:!1,status:"officially-assigned",currency:["XPF"],callingCode:["681"],capital:["Mata-Utu"],altSpellings:["WF","Territory of the Wallis and Futuna Islands","Territoire des îles Wallis et Futuna"],region:"Oceania",subregion:"Polynesia",languages:{fra:"French"},translations:{deu:{official:"Gebiet der Wallis und Futuna",common:"Wallis und Futuna"},fra:{official:"Territoire des îles Wallis et Futuna",common:"Wallis-et-Futuna"},hrv:{official:"Teritoriju Wallis i Futuna",common:"Wallis i Fortuna"},ita:{official:"Territorio delle Isole Wallis e Futuna",common:"Wallis e Futuna"},jpn:{official:"ウォリス·フツナ諸島の領土",common:"ウォリス・フツナ"},nld:{official:"Grondgebied van de Wallis en Futuna",common:"Wallis en Futuna"},por:{official:"Território das Ilhas Wallis e Futuna",common:"Wallis e Futuna"},rus:{official:"Территория Уоллис и Футуна острова",common:"Уоллис и Футуна"},slk:{official:"Teritórium ostrovov Wallis a Futuna",common:"Wallis a Futuna"},spa:{official:"Territorio de las Islas Wallis y Futuna",common:"Wallis y Futuna"},fin:{official:"Wallisin ja Futunan yhteisö",common:"Wallis ja Futuna"},est:{official:"Wallise ja Futuna ala",common:"Wallis ja Futuna"},zho:{official:"瓦利斯和富图纳群岛",common:"瓦利斯和富图纳群岛"}},latlng:[-13.3,-176.2],demonym:"Wallis and Futuna Islander",landlocked:!1,borders:[],area:142,flag:"🇼🇫"},{name:{common:"Samoa",official:"Independent State of Samoa",native:{eng:{official:"Independent State of Samoa",common:"Samoa"},smo:{official:"Malo Saʻoloto Tutoʻatasi o Sāmoa",common:"Sāmoa"}}},tld:[".ws"],cca2:"WS",ccn3:"882",cca3:"WSM",cioc:"SAM",independent:!0,status:"officially-assigned",currency:["WST"],callingCode:["685"],capital:["Apia"],altSpellings:["WS","Independent State of Samoa","Malo Saʻoloto Tutoʻatasi o Sāmoa"],region:"Oceania",subregion:"Polynesia",languages:{eng:"English",smo:"Samoan"},translations:{deu:{official:"Unabhängige Staat Samoa",common:"Samoa"},fra:{official:"Samoa",common:"Samoa"},hrv:{official:"Nezavisna Država Samoa",common:"Samoa"},ita:{official:"Stato indipendente di Samoa",common:"Samoa"},jpn:{official:"サモア独立国",common:"サモア"},nld:{official:"Onafhankelijke Staat Samoa",common:"Samoa"},por:{official:"Estado Independente de Samoa",common:"Samoa"},rus:{official:"Независимое Государство Самоа",common:"Самоа"},slk:{official:"Nezávislý štátSamoa",common:"Samoa"},spa:{official:"Estado Independiente de Samoa",common:"Samoa"},fin:{official:"Samoan itsenäinen valtio",common:"Samoa"},est:{official:"Samoa Iseseisvusriik",common:"Samoa"},zho:{official:"萨摩亚独立国",common:"萨摩亚"}},latlng:[-13.58333333,-172.33333333],demonym:"Samoan",landlocked:!1,borders:[],area:2842,flag:"🇼🇸"},{name:{common:"Yemen",official:"Republic of Yemen",native:{ara:{official:"الجمهورية اليمنية",common:"اليَمَن"}}},tld:[".ye"],cca2:"YE",ccn3:"887",cca3:"YEM",cioc:"YEM",independent:!0,status:"officially-assigned",currency:["YER"],callingCode:["967"],capital:["Sana'a"],altSpellings:["YE","Yemeni Republic","al-Jumhūriyyah al-Yamaniyyah"],region:"Asia",subregion:"Western Asia",languages:{ara:"Arabic"},translations:{deu:{official:"Republik Jemen",common:"Jemen"},fra:{official:"République du Yémen",common:"Yémen"},hrv:{official:"Republika Jemen",common:"Jemen"},ita:{official:"Repubblica dello Yemen",common:"Yemen"},jpn:{official:"イエメン共和国",common:"イエメン"},nld:{official:"Republiek Jemen",common:"Jemen"},por:{official:"República do Iêmen",common:"Iémen"},rus:{official:"Йеменская Республика",common:"Йемен"},slk:{official:"Jemenská republika",common:"Jemen"},spa:{official:"República de Yemen",common:"Yemen"},fin:{official:"Jemenin tasavalta",common:"Jemen"},est:{official:"Jeemeni Vabariik",common:"Jeemen"},zho:{official:"也门共和国",common:"也门"}},latlng:[15,48],demonym:"Yemeni",landlocked:!1,borders:["OMN","SAU"],area:527968,flag:"🇾🇪"},{name:{common:"South Africa",official:"Republic of South Africa",native:{afr:{official:"Republiek van Suid-Afrika",common:"South Africa"},eng:{official:"Republic of South Africa",common:"South Africa"},nbl:{official:"IRiphabliki yeSewula Afrika",common:"Sewula Afrika"},nso:{official:"Rephaboliki ya Afrika-Borwa ",common:"Afrika-Borwa"},sot:{official:"Rephaboliki ya Afrika Borwa",common:"Afrika Borwa"},ssw:{official:"IRiphabhulikhi yeNingizimu Afrika",common:"Ningizimu Afrika"},tsn:{official:"Rephaboliki ya Aforika Borwa",common:"Aforika Borwa"},tso:{official:"Riphabliki ra Afrika Dzonga",common:"Afrika Dzonga"},ven:{official:"Riphabuḽiki ya Afurika Tshipembe",common:"Afurika Tshipembe"},xho:{official:"IRiphabliki yaseMzantsi Afrika",common:"Mzantsi Afrika"},zul:{official:"IRiphabliki yaseNingizimu Afrika",common:"Ningizimu Afrika"}}},tld:[".za"],cca2:"ZA",ccn3:"710",cca3:"ZAF",cioc:"RSA",independent:!0,status:"officially-assigned",currency:["ZAR"],callingCode:["27"],capital:["Pretoria","Bloemfontein","Cape Town"],altSpellings:["ZA","RSA","Suid-Afrika","Republic of South Africa"],region:"Africa",subregion:"Southern Africa",languages:{afr:"Afrikaans",eng:"English",nbl:"Southern Ndebele",nso:"Northern Sotho",sot:"Southern Sotho",ssw:"Swazi",tsn:"Tswana",tso:"Tsonga",ven:"Venda",xho:"Xhosa",zul:"Zulu"},translations:{deu:{official:"Republik Südafrika",common:"Republik Südafrika"},fra:{official:"République d'Afrique du Sud",common:"Afrique du Sud"},hrv:{official:"Južnoafrička Republika",common:"Južnoafrička Republika"},ita:{official:"Repubblica del Sud Africa",common:"Sud Africa"},jpn:{official:"南アフリカ共和国",common:"南アフリカ"},nld:{official:"Zuid -Afrika",common:"Zuid-Afrika"},por:{official:"República da África do Sul",common:"África do Sul"},rus:{official:"Южно-Африканская Республика",common:"Южно-Африканская Республика"},slk:{official:"Juhoafrická republika",common:"Juhoafrická republika"},spa:{official:"República de Sudáfrica",common:"República de Sudáfrica"},fin:{official:"Etelä-Afrikan tasavalta",common:"Etelä-Afrikka"},est:{official:"Lõuna-Aafrika Vabariik",common:"Lõuna-Aafrika Vabariik"},zho:{official:"南非共和国",common:"南非"}},latlng:[-29,24],demonym:"South African",landlocked:!1,borders:["BWA","LSO","MOZ","NAM","SWZ","ZWE"],area:1221037,flag:"🇿🇦"},{name:{common:"Zambia",official:"Republic of Zambia",native:{eng:{official:"Republic of Zambia",common:"Zambia"}}},tld:[".zm"],cca2:"ZM",ccn3:"894",cca3:"ZMB",cioc:"ZAM",independent:!0,status:"officially-assigned",currency:["ZMW"],callingCode:["260"],capital:["Lusaka"],altSpellings:["ZM","Republic of Zambia"],region:"Africa",subregion:"Eastern Africa",languages:{eng:"English"},translations:{deu:{official:"Republik Sambia",common:"Sambia"},fra:{official:"République de Zambie",common:"Zambie"},hrv:{official:"Republika Zambija",common:"Zambija"},ita:{official:"Repubblica di Zambia",common:"Zambia"},jpn:{official:"ザンビア共和国",common:"ザンビア"},nld:{official:"Republiek Zambia",common:"Zambia"},por:{official:"República da Zâmbia",common:"Zâmbia"},rus:{official:"Республика Замбия",common:"Замбия"},slk:{official:"Zambijská republika",common:"Zambia"},spa:{official:"República de Zambia",common:"Zambia"},fin:{official:"Sambian tasavalta",common:"Sambia"},est:{official:"Sambia Vabariik",common:"Sambia"},zho:{official:"赞比亚共和国",common:"赞比亚"}},latlng:[-15,30],demonym:"Zambian",landlocked:!0,borders:["AGO","BWA","COD","MWI","MOZ","NAM","TZA","ZWE"],area:752612,flag:"🇿🇲"},{name:{common:"Zimbabwe",official:"Republic of Zimbabwe",native:{bwg:{official:"Republic of Zimbabwe",common:"Zimbabwe"},eng:{official:"Republic of Zimbabwe",common:"Zimbabwe"},kck:{official:"Republic of Zimbabwe",common:"Zimbabwe"},khi:{official:"Republic of Zimbabwe",common:"Zimbabwe"},ndc:{official:"Republic of Zimbabwe",common:"Zimbabwe"},nde:{official:"Republic of Zimbabwe",common:"Zimbabwe"},nya:{official:"Republic of Zimbabwe",common:"Zimbabwe"},sna:{official:"Republic of Zimbabwe",common:"Zimbabwe"},sot:{official:"Republic of Zimbabwe",common:"Zimbabwe"},toi:{official:"Republic of Zimbabwe",common:"Zimbabwe"},tsn:{official:"Republic of Zimbabwe",common:"Zimbabwe"},tso:{official:"Republic of Zimbabwe",common:"Zimbabwe"},ven:{official:"Republic of Zimbabwe",common:"Zimbabwe"},xho:{official:"Republic of Zimbabwe",common:"Zimbabwe"},zib:{official:"Republic of Zimbabwe",common:"Zimbabwe"}}},tld:[".zw"],cca2:"ZW",ccn3:"716",cca3:"ZWE",cioc:"ZIM",independent:!0,status:"officially-assigned",currency:["ZWL"],callingCode:["263"],capital:["Harare"],altSpellings:["ZW","Republic of Zimbabwe"],region:"Africa",subregion:"Eastern Africa",languages:{bwg:"Chibarwe",eng:"English",kck:"Kalanga",khi:"Khoisan",ndc:"Ndau",nde:"Northern Ndebele",nya:"Chewa",sna:"Shona",sot:"Sotho",toi:"Tonga",tsn:"Tswana",tso:"Tsonga",ven:"Venda",xho:"Xhosa",zib:"Zimbabwean Sign Language"},translations:{deu:{official:"Republik Simbabwe",common:"Simbabwe"},fra:{official:"République du Zimbabwe",common:"Zimbabwe"},hrv:{official:"Republika Zimbabve",common:"Zimbabve"},ita:{official:"Repubblica dello Zimbabwe",common:"Zimbabwe"},jpn:{official:"ジンバブエ共和国",common:"ジンバブエ"},nld:{official:"Republiek Zimbabwe",common:"Zimbabwe"},por:{official:"República do Zimbabwe",common:"Zimbabwe"},rus:{official:"Республика Зимбабве",common:"Зимбабве"},slk:{official:"Zimbabwianska republika",common:"Zimbabwe"},spa:{official:"República de Zimbabue",common:"Zimbabue"},fin:{official:"Zimbabwen tasavalta",common:"Zimbabwe"},est:{official:"Zimbabwe Vabariik",common:"Zimbabwe"},zho:{official:"津巴布韦共和国",common:"津巴布韦"}},latlng:[-20,30],demonym:"Zimbabwean",landlocked:!0,borders:["BWA","MOZ","ZAF","ZMB"],area:390757,flag:"🇿🇼"}]},function(a,t,i){a.exports=i(0)},function(a,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getAlphaTwoCode=void 0;var l,e=i(1),o=(l=e)&&l.__esModule?l:{default:l};t.getAlphaTwoCode=function(a){var t=String(a).toUpperCase(),i=o.default.find(function(a){return a.cca2===t||a.ccn3===t||a.cca3==t});return i&&i.cca2}},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600' viewBox='0 0 252 126'%3E %3Crect fill='%23319208' width='252' height='126'/%3E %3Crect y='18' fill='%23FFD200' width='252' height='90'/%3E %3Crect y='36' fill='%23DE2010' width='252' height='54'/%3E %3Crect y='54' width='252' height='18'/%3E %3Cpath d='M4.583,0l84,63l-84,63H0V0H4.583z'/%3E %3Cpath fill='%23FFF' d='M0,0l84,63L0,126'/%3E %3Cpolygon fill='%23DE2010' points='46.161,66.045 64.434,53.111 43.405,50.056 34,31 24.595,50.056 3.566,53.111 21.839,66.045 17.836,85.248 34,76 50.164,85.248 '/%3E %3Cpath fill='%23FFC618' d='M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292'/%3E %3Cg fill='none' stroke='%23000' stroke-width='0.2117'%3E %3Cpath d='M28.635,55.109c1.976,4.305,2.47,4.588,7.411,6.282c4.94,1.694,18.898,3.3,20.274,3.458c-0.9-0.9-16.621-12.545-19.85-14.875c-3.229-2.329-4.129-3.388-4.129-3.388s-2.911-5.24-3.917-6.776c-1.006-1.535-2.858-3.705-5.293-3.705s-3.917,1.429-4.623,3.97c-0.388,0.106-2.47,1.376-2.4,2.682c0.6-0.071,4.376-1.129,5.682,3.141c1.306,4.27,1.376,11.257,0.035,14.716c-1.341,3.459-3.423,6.07-3.423,9.105c0,0.423,0.282,1.27,0.988,1.27c0.247,1.341,2.223,10.904,2.223,10.904h28.161l4.473-17.292'/%3E %3Cpath d='M19.39,70.99c0,0,5.999-0.353,7.623-0.353c1.623,0,16.734,0.019,25.165,1.968'/%3E %3Cpath d='M21.508,70.871c0,0-0.601-0.728-0.213-2.175 c0.388-1.447,4.623-5.188,4.623-10.481'/%3E %3Cpath d='M25.142,70.637c0,0-0.494-2.364,4.905-4.376 c1.518-0.459,5.858-2.894,5.999-4.87'/%3E %3Cpath d='M29.473,66.485c0,0,13.243,0.058,23.724,2.175'/%3E %3Cpath d='M32.793,64.905c0,0,4.551,0.156,5.292-0.056c0.741-0.212,2.053-0.762,2.575-2.313'/%3E %3Cpath d='M35.49,64.959c0,0,2.434-1.265,2.911-2.911'/%3E %3Cpath d='M28.141,81.894c0,0-1.041-7.216-1.253-11.257l2.717,2.594l2.875-2.514l2.472,2.638l2.858-2.425l2.471,2.778l2.83-2.407l2.252,2.618l2.822-2.041l3.355,3.189'/%3E %3Cpath d='M50.951,77.345c-10.081-1.444-23.57-1.35-23.57-1.35'/%3E %3Cpath d='M22.694,51.052c0,0,8.2-3.918,9.647-4.465'/%3E %3C/g%3E %3Cg transform='matrix(0.211738,0,0,0.211738,16,36)' fill='none' stroke='%23000' %3E %3Cpolyline points='52.487,177.086 65.505,188.938 77.267,177.176 89.163,189.442 102.009,178.084 113.836,190.514 127.175,179.501 138.072,192.229 151.342,182.084 165.289,194.403'/%3E %3Ccircle cx='89.425' cy='154.584' r='5.167'/%3E %3Ccircle cx='111.237' cy='156.047' r='5.167'/%3E %3Ccircle cx='30.05' cy='16.5' r='4'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='2100' height='1400'%3E %3Crect width='2100' height='1400' fill='%23198a00'/%3E %3Crect x='1850' y='500' width='250' height='900' fill='%23ef7d00'/%3E %3Crect x='1600' y='500' width='250' height='900' fill='%23000'/%3E %3Crect x='1350' y='500' width='250' height='900' fill='%23de2010'/%3E %3Cg fill='%23ef7d00' stroke='%23000' stroke-width='2.25' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='M 1916.4245,168.3344 C 1916.4245,168.3344 2002.4265,134.6285 2010.7593,127.6785 C 2014.5489,131.8483 1976.2829,174.2418 1902.0276,189.87871 C 1969.4633,175.2842 2027.0511,129.4158 2038.7957,130.8058 C 2042.2056,131.5008 2041.4461,175.6316 1886.8731,213.85517 C 1993.7101,188.14097 2055.8431,140.8829 2055.0855,146.0952 C 2055.8431,147.1376 2044.4782,183.27622 1950.9008,211.42263 C 1977.0424,205.86205 2047.8881,166.2494 2047.1305,173.8943 C 2049.4031,177.0216 1978.5575,260.41781 1850.5039,233.31502 C 1952.7956,257.63859 2019.0941,198.91314 2028.5661,199.95564 C 2030.4609,200.30309 2009.6221,251.38355 1880.8128,254.51107 C 1942.568,248.60433 1924.7593,254.16286 1924.7593,254.16286 C 1924.7593,254.16286 1888.3881,280.22426 1844.4417,262.50402 C 1878.918,271.19178 1882.7056,271.53828 1883.4633,274.31751 C 1881.1906,277.79154 1852.7764,283.00526 1825.4995,269.45208 C 1847.4718,277.79154 1867.1733,279.18294 1867.5512,282.31046 C 1867.1733,283.35177 1853.1561,290.64992 1840.654,285.43798 C 1828.1518,280.22426 1712.9782,215.24513 1712.9782,215.24513 L 1909.227,165.902 z'/%3E %3Cpath d='M 1685.7126,344.10525 C 1668.4556,344.10525 1667.9794,358.19028 1667.9794,358.19028 C 1667.9794,358.19028 1666.5551,359.20736 1667.5052,366.03421 C 1670.3541,361.38542 1671.7804,359.93337 1671.7804,359.93337 C 1673.6808,360.22451 1681.5962,362.40249 1694.104,353.39936 C 1682.7032,364.28942 1689.5134,368.35602 1689.5134,368.35602 C 1689.5134,368.35602 1686.8216,376.92419 1695.5285,378.66728 C 1692.8383,375.18109 1694.4214,372.13156 1694.4214,372.13156 C 1694.4214,372.13156 1706.6118,370.97066 1705.8204,357.32052 C 1706.2964,369.66245 1713.5789,372.71197 1713.5789,372.71197 C 1713.5789,372.71197 1713.5789,379.53704 1721.4943,380.11924 C 1717.2212,376.63305 1718.1694,371.26002 1718.1694,371.26002 C 1718.1694,371.26002 1728.4613,364.43494 1719.7526,352.81725 C 1724.9778,350.05699 1729.2529,342.36216 1729.2529,342.36216 C 1729.2529,342.36216 1722.1291,339.60198 1718.8042,337.28017 C 1717.2192,334.22886 1718.6456,317.52919 1718.6456,317.52919 L 1714.3704,295.89129 L 1702.1781,329.58356 C 1702.6522,324.79085 1702.9697,344.10525 1685.7126,344.10525 z'/%3E %3Cpath d='M 1770.9438,295.51356 C 1771.3216,295.86186 1783.8256,308.72015 1795.9482,308.02364 C 1800.4933,304.54953 1786.4761,296.90496 1786.4761,295.16705 C 1791.401,299.33759 1812.238,315.66829 1825.4995,309.76147 C 1830.8022,302.81171 1816.0275,303.85472 1799.7358,285.08968 C 1811.1007,292.03953 1839.5168,307.32884 1852.7764,301.42209 C 1858.4607,295.86186 1823.225,278.48634 1811.4804,264.93494 L 1781.1734,250.68874 L 1739.8773,281.61565 z'/%3E %3Cpath d='M 1724.3449,189.87853 C 1724.3449,189.87853 1738.3622,182.23388 1794.433,186.05621 C 1800.4952,186.75101 1832.6971,175.9792 1842.9266,172.8518 C 1859.2164,170.0719 1911.1199,159.6472 1925.1389,149.9175 C 1934.9888,148.8752 1922.4847,166.597 1909.9846,170.7667 C 1896.7229,176.32663 1848.6091,191.61602 1831.5597,189.53109 C 1852.0189,189.87871 1840.654,205.16792 1806.5555,197.87072 C 1822.8472,206.21035 1816.785,207.6003 1816.785,207.6003 C 1816.785,207.6003 1787.993,208.99025 1780.4158,203.083 C 1799.7377,209.68531 1791.7807,212.11761 1791.7807,212.11761 C 1791.7807,212.11761 1772.0811,213.855 1762.9868,210.03267 C 1777.0041,213.855 1769.8065,216.28754 1769.8065,216.28754 C 1769.8065,216.28754 1758.4416,218.02494 1748.9696,214.89759 C 1739.4994,211.77024 1725.1025,189.87853 1724.3449,189.87853 z'/%3E %3Cpath d='M 1746.8274,302.71636 L 1748.8865,336.69798 C 1748.8865,336.69798 1747.7776,338.44108 1746.8274,339.45816 C 1745.8771,340.47353 1720.5441,335.82644 1724.0276,353.54318 C 1724.0276,360.80493 1724.1863,362.69184 1729.5703,366.75845 C 1728.144,361.96582 1728.6201,358.62694 1728.6201,358.62694 C 1728.6201,358.62694 1735.7439,362.54802 1742.711,351.80187 C 1737.9617,362.40249 1741.2846,366.17804 1742.3936,366.46909 C 1743.5025,368.35772 1740.495,376.92419 1749.9935,376.77866 C 1746.3532,373.58352 1748.0949,368.93642 1748.0949,368.93642 C 1748.0949,368.93642 1758.0695,367.48617 1754.5859,350.93033 C 1758.2281,347.58966 1759.6525,350.78479 1759.6525,350.78479 C 1759.6525,350.78479 1760.7596,360.65939 1769.4684,358.62694 C 1773.428,360.65939 1768.8356,366.03242 1768.8356,366.03242 C 1768.8356,366.03242 1775.1678,366.17804 1777.0683,361.23981 C 1778.9688,356.30336 1781.1847,347.44413 1770.7341,343.81411 C 1769.4684,340.32971 1774.8524,340.03856 1774.8524,340.03856 C 1774.8524,340.03856 1781.502,342.07101 1783.4006,345.12063 C 1785.3011,348.17015 1784.6682,337.13456 1776.4354,335.97196 C 1766.3022,335.68091 1765.6694,333.79399 1765.6694,333.35902 C 1765.6694,332.92244 1763.9276,308.67167 1763.1361,301.70098 z'/%3E %3Cpath d='M 1782.0688,331.67486 C 1782.1934,330.11719 1764.7834,308.61621 1769.2001,305.83699 C 1773.6149,306.67035 1780.8559,316.44969 1786.7216,313.27539 C 1784.9439,309.46353 1779.7036,311.61029 1773.7529,301.85179 C 1767.8041,290.81969 1766.9351,274.25865 1746.0981,256.19352 C 1759.5883,275.31034 1790.1901,286.5157 1791.4861,280.9416 C 1792.782,275.3675 1764.5397,254.28933 1765.9868,249.20906 C 1771.6031,259.64161 1799.9606,282.88746 1820.8542,280.96244 C 1822.2862,276.48689 1803.7445,267.45433 1798.9726,259.01961 C 1785.626,250.79616 1749.9084,222.55764 1749.1925,216.00857 C 1736.1954,198.622 1728.0817,193.36226 1724.3034,191.35975 C 1722.8431,189.78217 1722.4767,188.27399 1722.1914,187.31517 C 1714.123,169.8692 1724.8097,164.2041 1731.0646,163.3664 C 1736.2124,162.8417 1737.7067,163.5485 1741.4113,161.9032 C 1737.0247,160.3293 1732.6401,158.8574 1728.2554,157.2835 C 1733.9738,161.1307 1748.5805,157.7436 1745.4143,168.8249 C 1751.8184,166.5901 1765.4446,151.7209 1729.9707,148.3652 C 1718.4264,136.218 1670.9623,129.237 1659.0818,182.2531 C 1660.0301,182.99639 1660.5269,183.60716 1663.5458,185.67499 C 1648.5575,179.01161 1608.1248,173.8732 1593.554,171.7138 C 1554.1905,161.297 1513.3099,136.1939 1509.3802,139.2811 C 1504.1242,141.4208 1533.1636,166.2005 1531.6542,166.749 C 1506.4747,153.2833 1483.4723,143.7431 1462.0688,135.0617 C 1447.0114,129.8992 1431.9299,117.8797 1430.2669,120.1662 C 1424.7253,130.6954 1454.4075,157.1623 1459.9287,160.2757 C 1465.4516,163.2539 1508.8759,181.72909 1508.2356,181.95975 C 1442.8304,154.731 1431.8645,149.7947 1428.5824,146.6553 C 1422.8177,145.4644 1408.775,128.074 1404.8615,129.1923 C 1402.719,131.1229 1407.0161,158.6011 1438.2263,170.9357 C 1443.3134,174.3363 1505.1266,194.67481 1504.5213,196.26941 C 1504.3701,196.66789 1433.7231,169.5256 1430.9789,168.5552 C 1417.358,163.6563 1400.6447,146.4846 1397.5201,148.4156 C 1394.5379,150.1678 1405.2248,168.754 1418.9884,174.5834 C 1426.2027,177.50343 1453.8752,190.0745 1478.8069,198.07552 C 1480.3981,198.60329 1433.9924,181.93483 1411.6811,173.3834 C 1401.5649,168.2337 1396.801,161.8148 1395.2601,163.1959 C 1392.9808,164.5768 1398.9425,192.03295 1470.6403,207.52545 C 1472.5293,208.26287 1495.8781,202.45215 1494.7241,203.22283 C 1494.4354,203.41556 1471.5384,207.98755 1469.309,207.83131 C 1467.3249,207.55335 1454.781,209.19336 1454.5541,209.78959 C 1453.7962,211.64683 1459.0989,221.47779 1496.1182,219.42766 C 1500.8508,219.16671 1526.5335,210.84928 1524.3758,212.63847 C 1523.2969,213.53358 1489.403,223.63519 1486.8217,223.83447 C 1484.5797,224.12502 1472.6728,225.26704 1472.2326,226.42862 C 1471.695,228.01284 1481.0459,235.00963 1500.9262,236.13064 C 1518.5282,236.98833 1551.9751,226.26591 1551.3042,226.96106 C 1550.6331,227.65612 1519.0604,237.5792 1518.2342,238.18393 C 1517.0918,238.77651 1505.5304,239.35172 1505.1246,240.16612 C 1504.1825,242.19168 1521.802,257.30424 1573.911,241.1763 C 1568.6762,247.66176 1543.4181,252.09749 1543.4544,253.26528 C 1543.3373,254.11259 1549.0191,259.14779 1557.8497,260.94983 C 1562.2647,261.85081 1568.3098,261.66709 1573.8316,260.86664 C 1583.7496,259.04555 1594.202,255.44675 1607.4824,244.18943 C 1609.0694,247.7224 1574.3077,263.85722 1575.9399,265.39586 C 1583.4775,271.80689 1608.5159,264.56939 1610.1556,263.72905 C 1611.7972,262.88693 1658.3714,238.79904 1658.2108,236.01114 C 1658.9344,239.58392 1598.1654,269.86969 1598.8209,271.11208 C 1602.7219,276.82124 1623.4814,270.81226 1624.4731,270.28731 C 1625.4631,269.76397 1650.9661,257.1275 1651.665,256.75496 C 1652.3622,256.38243 1621.6924,273.21904 1624.4241,275.78162 C 1623.1036,286.71498 1672.3226,268.23581 1676.1801,265.93476 C 1678.1089,264.78423 1652.5359,276.24772 1652.4679,281.69356 C 1660.7027,294.46357 1687.0709,290.41253 1691.1381,287.60379 C 1693.1727,286.19862 1688.7446,297.09029 1690.1709,296.10094 C 1690.6678,295.89648 1695.9063,290.21495 1697.9201,286.10327 C 1697.2777,289.67094 1694.3874,295.29174 1692.7004,301.74087 C 1691.0116,308.18993 1690.5279,315.46723 1688.2101,323.19855 C 1687.6791,326.59459 1704.4583,316.5589 1702.0213,292.56797 C 1703.4571,305.04684 1696.7224,328.38106 1698.4848,329.59393 C 1702.01,332.01968 1711.7559,317.97275 1712.7401,308.47409 C 1715.6343,313.2719 1721.7078,323.28692 1726.9331,325.59137 C 1726.3645,318.33312 1727.0332,318.66586 1724.6813,311.53229 C 1726.0376,302.06144 1726.2266,288.9536 1726.5552,274.15293 C 1740.7539,299.1002 1746.4174,309.63499 1742.4503,328.73974 C 1746.6724,330.35457 1753.4165,315.40489 1752.8725,307.70996 C 1758.2943,329.09143 1781.6966,332.29695 1782.0688,331.67486 z'/%3E %3Cpath d='M 1545.5749,173.2876 C 1545.5749,173.2876 1535.9106,179.9848 1523.8842,179.591 C 1526.8908,190.62165 1551.8029,182.15172 1551.8029,182.15172 C 1551.8029,182.15172 1539.7764,194.36428 1531.1861,196.33396 C 1536.3403,200.27349 1558.0311,198.89477 1561.6827,196.925 C 1565.3326,194.95515 1571.7762,187.27308 1571.7762,187.27308 C 1571.7762,187.27308 1549.4406,210.91026 1546.2193,210.71344 C 1545.7897,213.47107 1569.6284,212.48614 1574.5684,208.34971 C 1579.5066,204.21311 1591.9634,198.10691 1591.9634,198.10691 C 1591.9634,198.10691 1559.3195,218.98639 1557.8157,218.98639 C 1570.0573,221.94117 1594.5402,215.44075 1610.2179,206.57684 C 1587.0233,220.75926 1584.8773,223.31981 1573.0646,228.04728 C 1583.5889,230.2142 1588.9559,236.71462 1624.6073,222.53196 C 1645.0097,213.66823 1656.6051,197.51588 1656.6051,197.51588 C 1643.9348,213.07718 1623.9613,226.27561 1601.8435,239.27551 C 1600.5532,241.63891 1625.4649,251.28999 1657.2493,220.95624'/%3E %3Cpath d='M 1718.2413,239.07802 C 1718.2413,239.07802 1720.3891,248.33581 1728.9789,255.42769 C 1737.5707,262.51788 1738.2149,269.41228 1738.2149,269.41228'/%3E %3Cpath d='M 1713.9473,178.80314 C 1713.9473,178.80314 1716.9529,187.07601 1725.758,192.39452 C 1734.7786,197.71286 1748.3103,214.45591 1749.3833,217.41051 C 1750.4223,220.98661 1755.6098,246.76077 1755.1811,249.51746'/%3E %3Cpath d='M 1659.1838,191.60649 C 1659.8279,194.75808 1646.5116,210.71344 1664.7661,229.42617 C 1648.2288,247.94073 1648.2307,250.30583 1648.2307,250.30583 C 1648.2307,250.30583 1657.4646,255.03262 1674.0019,242.0322 C 1701.2751,272.76153 1692.1866,286.82411 1692.1866,286.82411'/%3E %3Cpath d='M 1690.0141,265.13074 C 1690.0141,265.13074 1687.5016,261.82996 1691.9807,249.5036 C 1696.0139,253.96009 1700.4987,254.91133 1702.4653,256.71508 C 1704.4299,258.51881 1725.0232,261.25304 1726.3323,273.87565'/%3E %3Cpath d='M 1714.2231,149.4322 C 1714.2231,148.5049 1710.0765,140.3439 1694.6066,150.5451 C 1702.8979,151.0086 1711.0872,155.3674 1714.2231,149.4322 z'/%3E %3Cpath d='M 1861.8688,186.75118 C 1862.6263,187.09854 1908.0897,196.13332 1923.2443,191.61602 C 1903.9224,215.24513 1865.2786,199.26067 1865.2786,199.26067 C 1884.2207,204.47295 1884.9802,204.12559 1891.0404,208.99025 C 1892.9352,213.50756 1856.1863,211.42263 1844.0619,205.16792 C 1877.7808,214.89759 1878.5384,214.20262 1879.6755,218.02494 C 1881.1926,223.23722 1824.3623,216.63491 1819.4373,209.68531 C 1834.5918,220.45741 1842.9266,222.54242 1851.2614,227.40708 C 1841.0319,231.57703 1822.0896,235.74603 1787.2336,213.16019 C 1833.0748,251.38355 1874.371,248.95092 1880.8128,255.90068 C 1864.9008,277.44503 1803.1456,243.04417 1774.7314,225.66951 C 1746.3173,208.29527 1836.8644,267.71596 1845.2011,266.67286 C 1841.0319,272.5796 1811.1026,267.36766 1809.2077,264.58844'/%3E %3Cpath d='M 1873.6134,226.71211 C 1868.3106,227.40708 1852.3986,227.40708 1850.126,227.05955'/%3E %3Cpath d='M 1532.2598,166.9845 C 1532.2598,166.9845 1566.8363,183.72743 1581.4391,182.54561 C 1577.574,185.89418 1571.7744,187.27308 1571.7744,187.27308 C 1575.4261,188.65197 1585.5196,193.57642 1600.7685,190.42467 C 1597.1169,193.77324 1592.3922,197.51604 1592.3922,197.51604 C 1592.3922,197.51604 1605.4932,202.04636 1620.3114,194.95515 C 1615.8021,200.07642 1613.2234,203.81922 1613.2234,203.81922 L 1623.5324,204.41009'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 9 6'%3E %3CclipPath id='Z'%3E %3Cpath d='M0,0 4.5,3 0,6' id='X'/%3E %3C/clipPath%3E %3CclipPath id='A'%3E %3Cpath d='M0,0H9V6H0z'/%3E %3C/clipPath%3E %3Cg clip-path='url(%23A)'%3E %3Cpath d='M0,0V6H9V0z' fill='%23002395'/%3E %3Cpath d='M0,0V3H9V0z' fill='%23de3831'/%3E %3Cg stroke-width='2' stroke='%23fff'%3E %3Cpath d='M0,0 4.5,3 0,6M4.5,3H9' id='W'/%3E %3Cuse xlink:href='%23X' stroke='%23ffb612' clip-path='url(%23Z)'/%3E %3C/g%3E %3Cuse xlink:href='%23W' fill='none' stroke='%23007a4d' stroke-width='1.2'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect width='450' height='300'/%3E %3Crect fill='%23FFF' width='450' height='200'/%3E %3Crect fill='%23CE1126' width='450' height='100'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2880' height='1440'%3E %3Cdefs%3E %3Cpath id='s' d='M0,0 0.309017,0.951057 -0.5,0.363271H0.5L-0.309017,0.951057z'/%3E %3C/defs%3E %3Crect width='2880' height='1440' fill='%23ce1126'/%3E %3Crect width='1440' height='720' fill='%23002b7f'/%3E %3Cg fill='%23fff'%3E %3Cuse xlink:href='%23s' transform='translate(720,30) scale(160)'/%3E %3Cuse xlink:href='%23s' transform='translate(500,210) scale(160)'/%3E %3Cuse xlink:href='%23s' transform='translate(945,180) scale(150)'/%3E %3Cuse xlink:href='%23s' transform='translate(830,364.894348) scale(100)'/%3E %3Cuse xlink:href='%23s' transform='translate(720,499.788697) scale(200)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='840' height='600'%3E %3Ctitle%3EFlag of Kosovo%3C/title%3E %3Cdefs%3E %3Cpath id='star' d='M0,-36 21.160269,29.124612 -34.238034,-11.124612H34.238034L-21.160269,29.124612z' fill='%23fff'/%3E %3C/defs%3E %3Crect width='840' height='600' fill='%23244aa5'/%3E %3Cpath fill='%23d0a650' transform='translate(229,151) scale(0.38,0.35)' d='m271.3,381.7c0,0 4.1,-3 5.6,-3.4c1.5,-0.4 6.8,-2.2 6.8,-2.2c0,0 3.4,-1.9 5.2,-1.9c1.9,0 5.6,2.2 6.8,4.1c1.1,1.9 7.1,5.2 7.1,5.2c0,0 4.1,1.5 4.9,0c0.8,-1.5 2.6,-2.6 4.5,-2.6c1.9,0 2.2,-1.9 2.2,-3.4c0,-1.5 0.8,-3.4 2.2,-5.2c1.5,-1.9 4.5,-3 4.5,-3c0,0 4.1,-1.9 4.5,-4.5c0.4,-2.6 4.5,-4.5 6.8,-4.9c2.2,-0.4 0,-1.5 6,-0.8c6,0.8 6.8,-1.5 7.1,-3.4c0.4,-1.9 0,-3.8 3.8,-3.4c3.8,0.4 5.6,0.4 5.6,-1.9c0,-2.2 3.4,-3.4 -2.6,-5.2c-6,-1.9 -5.6,-0.4 -6,-3.4c-0.4,-3 0,-2.6 -4.1,-3c-4.1,-0.4 -1.9,-2.6 -2.2,-4.9c-0.4,-2.2 -1.5,-3.4 -2.2,-4.9c-0.8,-1.5 -3,-1.5 -3,-3.7c0,-2.2 -0.4,-3.4 -2.6,-3.4c-2.2,0 -3,0 -3,-2.2c0,-2.2 0.4,-4.1 2.6,-4.1c2.2,0 3.4,-1.9 3,-4.1c-0.4,-2.2 -0.4,-7.1 -0.4,-7.1l3,-3.8c0,0 9,-7.9 9.8,-9.4c0.8,-1.5 3.8,-2.6 5.2,0.4c1.5,3 2.2,3.8 3.4,5.2c1.1,1.5 4.5,0.4 5.2,-1.1c0.8,-1.5 1.1,-7 3.1,-10c2,-2.9 3.4,-4.4 3.9,-6.8c0.5,-2.4 1.5,-4.4 3.9,-4.4c2.4,0 3.9,-3.4 3.9,-5.4c0,-2 1,-3.9 3.9,-4.4c2.9,-0.5 4.4,-2.4 5.4,0.5c1,2.9 2,2.9 3.9,3.9c2,1 4.9,2.4 6.3,1c1.5,-1.5 2.2,-3.9 4.4,-2.4c2.1,1.5 3.6,0 4.1,-2.9c0.5,-2.9 1,-6.8 1,-6.8c0,0 0.5,-2 3.9,-2c3.4,0 1,-2.4 2.9,-3.9c2,-1.5 2,-2.9 4.4,-2c2.4,1 6.3,-1.2 4.4,-3.6c-2,-2.4 -6.3,-6.3 -3.9,-9.3c2.4,-2.9 3.4,-7.8 1,-8.3c-2.4,-0.5 -5.9,0.5 -6.3,-2.4c-0.5,-2.9 -1.5,-4.9 1.5,-5.4c2.9,-0.5 7.8,-0.5 9.3,-2c1.5,-1.5 6.3,-2.4 6.3,-6.8c0,-4.4 1.5,-4.9 2,-7.3c0.5,-2.4 0.5,-7.5 -1.5,-9.9c-2,-2.4 -4.9,-5.9 -5.4,-7.3c-0.5,-1.5 -2.4,-3.9 -5.4,-4.9c-2.9,-1 -5.4,-1.5 -5.4,-3.9c0,-2.4 2,0.5 2,-5.9c0,-6.3 -3.9,-7.3 -3.9,-7.3l-5.9,-3.9c0,0 -10.4,-3 -13.2,-3c-2.8,0 -6,-3.2 -2.8,-5.2c3.2,-2 4,-5.6 2.8,-8.4c-1.2,-2.8 -2,-4.8 -6.4,-6c-4.4,-1.2 -5.6,-2.4 -3.6,-5.2c2,-2.8 2.4,-4.8 4.8,-2.8c2.4,2 6.4,2.8 9.6,1.2c3.2,-1.6 4.4,-2.8 6,-1.2c1.6,1.6 3.6,3.2 6,0.8c2.4,-2.4 6.8,-2.8 8.8,-1.6c2,1.2 6.8,0.8 8.4,0c1.6,-0.8 4.8,-3.6 4.8,-5.2c0,-1.6 2,-4.4 4,-5.6c2,-1.2 4.4,-5.2 6.4,-5.2c2,0 2.8,-2.4 2.8,-4c0,-1.6 1.6,-4.8 2,-6c0.4,-1.2 4.4,-2.9 7.2,-0.4c2.8,2.4 6.4,3.2 6.4,3.2c0,0 4,0.8 6,0c2,-0.8 4.8,-1.6 7.6,0.4c2.8,2 6.8,2 6.8,2c0,0 0.8,-3.2 0.8,-4.8c0,-1.6 0.8,-4.4 -0.8,-5.6c-1.6,-1.2 -3.6,-2.8 -0.4,-5.2c3.2,-2.4 3.2,-2 6.4,-2c3.2,0 5.2,0.4 7.6,0.4c2.4,0 6.4,2.4 6.4,4.8c0,2.4 1.6,4 3.6,5.2c2,1.2 4.4,2.4 3.6,4.4c-0.8,2 -0.8,3.6 1.6,3.2c2.4,-0.4 3.2,1.2 3.2,3.2c0,2 0.8,3.2 3.2,4c2.4,0.8 3.6,2.4 3.6,4.4c0,2 -0.4,3.2 0.4,5.2c0.8,2 3.2,5.2 3.2,5.2c0,0 4.4,5.6 -1.2,2.8c-5.6,-2.8 -6.8,-4 -8.8,-3.6c-2,0.4 -3.2,1.6 -3.2,1.6c0,0 -2.8,0.8 -4.8,0.8c-2,0 -4,4.4 -0.8,5.2c3.2,0.8 4.4,1.6 4.4,4.4c0,2.8 -1.2,2 -2.8,4c-1.6,2 -2.8,0.8 -5.6,0.8c-2.8,0 -3.6,2.4 -3.6,4.8c0,2.4 1.2,2 2.4,4c1.2,2 3.2,2.4 5.2,0.4c2,-2 3.6,-3.2 4.8,0.4c1.2,3.6 2.8,3.6 5.2,3.6c2.4,0 3.2,0 5.2,-1.2c2,-1.2 4.4,0 4.8,3.2c0.4,3.2 2.4,3.6 4.4,4.8c2,1.2 3.2,2 3.6,4c0.4,2 1.6,2.8 3.6,1.6c2,-1.2 5.2,-2 6.4,-0.4c1.2,1.6 3.2,4.8 3.2,4.8l0.4,4l7.6,2.8c0,0 0.8,2 0.8,3.6c0,1.6 1.2,2.4 3.2,2c2,-0.4 5.6,0 5.6,0c0,0 2.8,-1.2 2.8,-3.6c0,-2.4 1.2,-3.2 3.2,-3.2c2,0 6.4,1.6 7.6,-0.8c1.2,-2.4 4.8,-3.2 7.6,-2c2.8,1.2 10,4.4 10,4.4c0,0 -0.8,0.4 1.6,4.4c2.4,4 6.8,4 6.8,4c0,0 0.4,3.6 1.2,5.2c0.8,1.6 4.4,2.4 6.4,0.8c2,-1.6 4.8,-3.6 7.2,-3.6c2.4,0 4,0 4,-1.6c0,-1.6 -2.4,-2.8 -2.4,-5.2c0,-2.4 2.4,-2.4 2.8,-4.8c0.4,-2.4 2.8,0 4.4,1.2c1.6,1.2 3.6,3.2 3.6,4.8c0,1.6 3.2,7.2 5.2,8c2,0.8 7.2,1.2 8.8,-0.8c1.6,-2 5.6,-2.8 5.2,2c-0.4,4.8 -1.2,5.2 1.6,6.8c2.8,1.6 3.2,7.2 0.8,8.8c-2.4,1.6 -3.2,2 -3.2,4.8c0,2.8 -0.8,6 1.2,7.6c2,1.6 3.2,2.8 3.2,4.4c0,1.6 2.4,8.8 2.4,8.8c0,0 1.2,7.2 0.8,8.8c-0.4,1.6 -1.2,4.4 2.4,4c3.6,-0.4 4.4,-0.4 4.4,2.8c0,3.2 1.2,4.4 -0.8,5.6c-2,1.2 -3.2,5.2 -1.2,6c2,0.8 3.6,2 4,3.6c0.4,1.6 3.6,4.4 5.6,2.8c2,-1.6 2.4,-2.4 4,-2.8c1.6,-0.4 2.8,-1.6 1.2,-3.6c-1.6,-2 -2,-4 -0.4,-5.2c1.6,-1.2 2.4,-5.2 2.4,-5.2c0,0 2.4,-3.6 5.2,0c2.8,3.6 3.2,2.4 5.2,2.4c2,0 2.8,2 2.8,4c0,2 4,1.6 4,4.8c0,3.2 0.8,10.8 0.8,10.8c0,0 0,4.4 2.4,6c2.4,1.6 2,2 0.8,4c-1.2,2 -0.8,5.2 -0.8,6.8c0,1.6 0.8,2.4 -1.2,4c-2,1.6 -2.8,3.6 -1.6,6c1.2,2.4 0.8,4 4,6.8c3.2,2.8 2.8,4 2.8,6c0,2 3.2,4.8 3.2,6.8c0,2 2.4,4.4 4.4,4.8c2,0.4 4.4,4 4.4,6c0,2 0.4,7.2 0.4,7.2c0,0 -0.4,1.2 2,1.2c2.4,0 4,2.8 4.8,-0.4c0.8,-3.2 3.2,-3.6 4.8,-4.4c1.6,-0.8 4.8,-2.4 6.4,-1.2c1.6,1.2 3.6,1.2 5.2,1.2c1.6,0 9.2,0.4 9.2,0.4c0,0 2,-0.4 3.2,2.8c1.2,3.2 4.8,6.8 2.8,8.4c-2,1.6 -2,4.8 0.4,4.8c2.4,0 4.8,0 4.8,2c0,2 0.4,3.6 2.4,2.4c2,-1.2 3.2,-1.6 4,0c0.8,1.6 2.4,1.6 4.4,2.8c2,1.2 2.8,0.4 4,-1.2c1.2,-1.6 6,-3.2 6,-3.2c0,0 6.4,-1.6 8.8,-0.8c2.4,0.8 5.6,2.4 5.6,2.4c0,0 1.6,4 0.8,6.4c-0.8,2.4 -1.6,2 -0.8,5.6c0.8,3.6 -0.8,4 -2.4,3.6c-1.6,-0.4 -3.2,-0.4 -3.2,2.8c0,3.2 -1.6,4 -1.6,6.8c0,2.8 0,2.4 -1.6,3.6c-1.6,1.2 -2,3.2 0.4,3.6c2.4,0.4 1.6,3.2 1.6,4.8c0,1.6 -0.4,5.2 -0.4,5.2c0,0 0.4,2 -2.4,2c-2.8,0 -5.2,-0.4 -5.6,1.6c-0.4,2 -3.6,5.2 -0.8,7.2c2.8,2 2,3.2 0.4,4c-1.6,0.8 -2.8,4.8 0.4,6c3.2,1.2 2.8,2.4 0.8,4c-2,1.6 -6,2.8 -6,5.2c0,2.4 -0.8,2.4 -3.2,2.8c-2.4,0.4 -3.6,3.6 -0.8,7.6c2.8,4 3.6,3.2 5.6,3.2c2,0 2,-3.2 2,-3.2c0,0 6.8,0.4 8.8,0.4c2,0 4.8,0 6.4,-1.2c1.6,-1.2 6,-3.2 6,0.4c0,3.6 0.8,3.2 2.8,4.8c2,1.6 2.4,0.4 4,2.8c1.6,2.4 2,0.4 3.2,-2.4c1.2,-2.8 3.6,-5.6 5.6,-2.4c2,3.2 2,2.4 4.4,2.4c2.4,0 3.2,1.2 3.2,3.2c0,2 2.4,2 5.2,1.6c2.8,-0.4 3.2,1.6 4.4,3.6c1.2,2 1.6,1.6 3.2,1.6c1.6,0 3.2,0 4.4,-1.6c1.2,-1.6 2.8,-3.6 4.4,-1.2c1.6,2.4 4.8,2 5.6,-0.8c0.8,-2.8 4.4,-5.2 6.4,-2c2,3.2 3.6,3.2 5.6,3.6c2,0.4 4.8,0.4 6,2.4c1.2,2 5.2,5.2 2.4,7.6c-2.8,2.4 -6,5.6 -3.6,6.4c2.4,0.8 4,1.6 5.6,3.6c1.6,2 6.8,2.8 9.2,3.2c2.4,0.4 4.4,0.8 7.2,-1.6c2.8,-2.4 5.6,-2.4 5.2,0.8c-0.4,3.2 1.2,6.8 1.2,6.8c0,0 2,5.2 2,7.2c0,2 -0.4,2.4 3.2,4.8c3.6,2.4 3.2,4 6,1.6c2.8,-2.4 3.6,-3.6 3.6,-5.6c0,-2 0,-6.4 0,-6.4c0,0 4,-0.8 5.6,-2c1.6,-1.2 8,-4.8 9.6,-3.2c1.6,1.6 3.6,1.2 5.2,0.4c1.6,-0.8 4.8,-0.8 6.4,-0.8c1.6,0 4.4,0.4 7.6,-2.4c3.2,-2.8 3.2,-2 5.2,0c2,2 2,4.4 0.8,6c-1.2,1.6 0,5.2 2.8,5.2c2.8,0 3.6,1.6 3.6,3.6c0,2 0.4,4.8 0.8,6.4c0.4,1.6 0.4,2.4 4.8,3.6c4.4,1.2 3.6,4 4.4,6c0.8,2 0.8,3.6 -1.6,3.6c-2.4,0 -3.2,1.2 -3.6,3.2c-0.4,2 -4,2.8 -4,2.8l-3.6,-0.8c0,0 -2.4,0 -3.6,1.6c-1.2,1.6 -3.6,4.8 -2,7.6c1.6,2.8 1.6,4.4 0,5.6c-1.6,1.2 -2.4,7.2 -4,6c-1.6,-1.2 -3.6,0.4 -5.2,1.2c-1.6,0.8 -1.2,6.4 2,8.4c3.2,2 4,4.8 4,4.8l3.6,6c0,0 -1.2,1.2 -2,3.2c-0.8,2 -3.2,6 -0.8,6.8c2.4,0.8 1.2,5.2 -1.2,5.2c-2.4,0 -5.2,-1.2 -5.6,2c-0.4,3.2 -1.6,2.4 -4,2c-2.4,-0.4 -8.4,-2 -10,1.2c-1.6,3.2 -2,4.4 -4.8,4c-2.8,-0.4 -1.6,4.8 -0.8,6.8c0.8,2 3.6,4.8 3.6,4.8c0,0 2.4,2 2.4,6c0,4 -1.6,3.6 -3.2,0.8c-1.6,-2.8 -4.8,-2.4 -5.2,0.8c-0.4,3.2 -0.8,8 -3.6,8c-2.8,0 -4,0.8 -5.2,2.4c-1.2,1.6 -3.2,4.4 -3.2,6c0,1.6 -0.4,3.2 -2.4,3.6c-2,0.4 -2.4,4.8 -2.4,4.8c0,0 -4.8,0.8 -5.2,2.8c-0.4,2 0.4,5.2 -3.6,5.6c-4,0.4 -6.4,3.2 -7.6,5.2c-1.2,2 -1.6,3.6 0,5.6c1.6,2 2.8,8.4 4.8,9.6c2,1.2 3.6,1.6 3.2,4.8c-0.4,3.2 -2.8,5.6 0.4,5.6c3.2,0 5.2,0.8 4,3.6c-1.2,2.8 -1.2,3.2 -3.6,4.4c-2.4,1.2 -3.6,1.2 -3.6,4.4c0,3.2 0.8,3.2 -1.2,4.4c-2,1.2 -2,2.8 -2,5.2c0,2.4 -0.8,1.6 -3.2,4.4c-2.4,2.8 -5.6,2.8 -7.6,2c-2,-0.8 -2.4,-0.8 -2.8,-3.2c-0.4,-2.4 -4,-2.4 -6,-2c-2,0.4 -4.8,2.8 -4.8,2.8c0,0 -3.6,2.4 -2,4.4c1.6,2 0.8,5.2 -2,4.8c-2.8,-0.4 -9.2,3.2 -11.2,-0.4c-2,-3.6 -7.6,-6 -8.4,-1.2c-0.8,4.8 2.4,4.4 2,9.2c-0.4,4.8 -1.2,4.8 -2.8,6.4c-1.6,1.6 -1.6,2.8 -2,4.8c-0.4,2 -0.8,6.4 2,8c2.8,1.6 4,6 4,8.4c0,2.4 0,4.8 2.8,4.8c2.8,0 5.2,-0.4 5.6,-3.2c0.4,-2.8 6,-4.4 6.4,1.2c0.4,5.6 0.4,8.4 2.4,10.8c2,2.4 3.6,5.6 5.2,6.8c1.6,1.2 4.3,11.4 4.3,11.4c-3.9,0.9 -4.9,6.4 -7.4,7.5c-1.4,0.6 -2.9,0.1 -4.2,1.1c-1,0.8 -1,2.3 -2.4,3c-2.9,1.4 -2.4,-3.5 -5.9,-1.7c-3.2,1.6 -3.5,5.6 -8.1,3.9c-2.4,-0.9 -3.9,-11.1 -4.6,-13.5c-0.4,-1.4 -2.9,-5.6 -3.7,-6.9c-2.7,-4.4 -8.1,0 -9.8,-1.3c-2.7,-2 -1.5,-5.4 -5.6,-5.8c-8.3,-0.6 -2.4,5.5 -5.9,6.9c-6.7,2.6 -6.7,-6.8 -11.7,-2.5c-1.9,1.6 3,2.6 1.8,5.4c-1,2.3 -5.9,5.8 -5.6,8.5c0.4,3.7 4.1,4.8 5.2,7.9c3,8.2 -2,13.9 -9.5,7.5c-4.2,-3.6 -5,-10.3 -11.5,-9.8c-1.5,0.1 -2,1.8 -3.5,2c-1.5,0.1 -2.7,-1.5 -4.3,-1c-2.4,0.9 -0.3,2.7 -0.8,4.2c0,0 -3.2,2.9 -3.7,3.7c-1.8,2.6 -1.2,4.9 -3.8,7c-2.2,1.8 -3.9,0.7 -6.3,3.5c-2.5,2.9 -2.7,7.2 -5.9,10c-1.6,1.4 -2.7,-4.2 -4.7,-0.5c-0.3,0.5 -0.6,1 -0.8,1.5c-0.5,1.1 -0.6,1.6 -0.1,2.8c4.2,8.8 -4.6,12.1 -7.3,18.3c-1.2,2.6 2.1,5 0.8,7c-0.9,1.5 -4.8,5.6 -5.1,6.5c-0.3,0.9 -0.7,2.9 -1.4,3.6c-0.7,0.8 -3.1,0.4 -3.3,1.6c-0.2,1.4 2.5,2.5 3.2,3.4c0.9,1.1 -0.4,2.6 -0.1,2.9c4.5,4.9 1.8,3.4 4.1,7.7c0.3,0.6 1.7,-0.5 2.2,1.1c0.5,1.5 -1.1,1.4 -0.5,3.1c0.1,0.5 3.3,5 3.3,5.1c0.2,1.5 -6.1,4.6 -7.5,4.6c-3.8,0.1 3.3,-8.5 -2.9,-8.5c-2.7,0 -2.9,6.7 -3.6,7.4c-0.3,0.3 -2.8,-0 -3.4,-0c-4,-0 -6.6,5.4 -8.2,5.9c-1,0.4 -3.2,-0.6 -4.9,-0.3c-1.6,0.3 -3.5,2 -5,2c-1,0 -1.5,-0.7 -2.3,-1.2c-1.8,-1.1 -5.1,-1.6 -7.1,-2.3c-1.1,-0.4 -3.2,1.5 -3.9,1c-1.3,-0.9 0.9,-3.4 -2.1,-5.2c-0.4,-0.2 -2.6,-6 -2.5,-6.3c1,-3.8 2.1,-7.9 1.6,-11.9c-0.6,-4.1 -6.5,-7.6 -8.1,-10.9c-1.2,-2.5 -2.3,-9.1 -4.6,-10.8c-2.5,-1.8 -4.8,-5.3 -6.1,-8c-0.4,-0.8 0.8,-2.2 -0.1,-3.6c-1,-1.5 -2.9,-2.1 -3.4,-4.1c-0.4,-1.6 -0,-6.8 -1.7,-7.9c-1.9,-1.2 -14.1,-2.8 -17.1,-3.1c-1.6,-0.1 -2.8,-0.1 -4,-1.4c-0.5,-0.5 -1.3,-2.6 -1.7,-2.6c-1.2,-0.1 -2.6,0.6 -3.8,0.7c-0.9,0.1 -2.4,-0.6 -3.2,0c-3.9,2.9 -4.9,6.6 -8.6,9.7c-3.8,3.1 -8,3 -11.8,6.6c-2.4,2.3 -4,7.8 -6.4,10.4c-1,1.1 -2.6,-0 -3,0.5c-2,2.7 -4.8,4.3 -6.8,6.8c-0.4,0.5 -0.3,1.5 -0.8,1.9l-4.3,1.2c-1.1,0.2 -3.2,-0.1 -4.1,0.2c-2,0.7 -1.9,3 -8.7,4.5c-0.5,0.1 -1.4,0.6 -1.8,0.9c-0.8,0.6 -1.4,1.5 -2.2,2.1c-0.5,0.4 -2,-0.3 -2.9,-0.2c-1.7,0.3 -2.7,1.9 -4.3,2.1c-3.6,0.5 -9.4,-1.8 -12.2,-0.6c-1.7,0.7 -6.4,6.4 -8.1,7c-1.1,0.4 -1.9,-0.1 -3.1,-0.6c-0.6,0.8 -2,7 -2.5,8.4c-0,0.1 -7.7,7.1 -8.3,7.9c-1,1.2 -1.4,2.5 -2.6,3.8c-0.8,0.9 -2.1,1.7 -3.4,1.7c-1.6,0 -4,-1.3 -5.5,-1.6c-2.9,-0.5 -11.6,-0.9 -14.2,-0.3c-2.7,0.6 -1.9,9 -8.6,9.8c-3.9,0.5 -7.5,1.3 -11.5,1.7c-0.4,0 -2.8,-1.8 -5.2,-1.1c-0.9,0.3 -3.8,3.5 -3.8,4.5l-0,1.8c-0,0.3 0.8,1.4 0.7,1.5c-1.5,1.9 -4.9,4.9 -6,7.1c-0.3,0.6 -0.7,1.3 -1.2,1.7c-0.9,0.7 -5.5,2.6 -5.9,3.5c-1.1,3 3.2,5.8 2.8,7c-1.2,3.9 -6,7.6 -7.5,11.2c-0.6,1.5 1.6,6.5 1.5,8.2c-0.5,4.7 -2,10.7 -1.8,15.3c0,0.9 0.6,5.6 0.9,6.1c0.5,0.9 1.6,1.4 2.3,2.2c0.7,0.8 6,12 6.2,13.2c1,8.3 -10.1,5.4 -3.7,13.7c1,1.3 1.8,2.7 2.9,3.8c1.4,1.5 9.6,8 9.7,8.7c0.2,1.2 -6.6,2.4 -7.8,3.7c-3.2,3.4 -5.9,9.7 -9,13.2c-1.9,2.2 -3.6,-0.2 -6.1,4.9c-0.9,1.9 -0,6.2 -1.1,7.4c-1.6,1.8 -2.9,-0.6 -4.5,0.2c-0.7,0.3 -1.1,2.5 -1.8,3.1c-1.8,1.7 -17.8,10.9 -19.3,10.1c-0.8,-0.4 -1.7,-3.3 -1.8,-4.2c-0.2,-1 -1.2,-3.2 -2,-3.9c-4.1,-3.8 -10.4,-4.5 -14.4,0.1c-1,1.2 -1.1,3 -2.4,4.2c-2.2,2 -4.7,3.8 -6.8,5.8c-0.4,0.4 -1.6,1.9 -2.1,1.8c-1.6,-0.2 -5.5,-5 -6.5,-6.3c-1.8,-2.3 -7,-7.8 -7.5,-10.4c0,-8.9 -6.4,-18.2 -9.1,-26.9l4,0.1c4.5,-3.3 3.2,-11.4 11.3,-8.2c1,-1.5 0.9,-3.1 2.8,-4.2c0.7,-0.4 2,-0.8 2.4,-1.5c2.7,-4.5 5.9,-21.7 3.1,-26.1c-2.5,-4 -5.1,-3.8 -7.1,-10.4c-0.6,-1.8 0.5,-3.9 -0,-5.9c-0.4,-1.6 -3.1,-11.1 -3.5,-11.8c-0.5,-0.8 -2.2,-1.8 -2.3,-2.3c-0.1,-0.8 -0.7,-11.1 -0.4,-11.9c-2.7,-8 -11.8,-13.1 -12.3,-14c-1.1,-1.9 -2.2,-4.4 -3.4,-6.5c-1.4,-2.5 -1.4,-3.8 -2.2,-6.2c-0.3,-1.1 -1.8,-2 -1.9,-3.2c-0.2,-2.1 5.3,-6.5 5.1,-10.2c-0.1,-1.2 -3.5,-4.8 -2.8,-6.8c0.7,-2.1 4.2,-6.8 4.1,-9.1c-0.2,-3.1 -5.5,-9.8 -6.2,-13.1c-0.3,-1.6 2.1,-2.9 1.5,-4c-0.7,-1.4 -6.3,-6.9 -7.2,-8.5c-0.7,-1.2 2.1,-2.8 0.1,-5c-1.8,-2 -0.3,-1.3 -0.8,-3c-0.6,-1.9 -2.6,-3.6 -3.4,-5.6c-0.7,-1.7 -5.5,-20.5 -5.4,-21.6c-0.8,-1.3 -2.2,-2.4 -2.9,-3.7c-0.7,-1.3 -1,-3.8 -1.6,-4.8c-0.1,-0.1 -5.4,-1.8 -6.4,-3.5c-0.8,-1.4 -1,-6 -2.4,-8.3c-0.7,-1.1 -1.8,-0.9 -2.6,-1.7c-0.7,-0.6 -0.6,-1.7 -1.1,-2.4c-1.6,-2.4 -4.8,-0.2 -7,-9c-2.9,-2.2 -5.6,-4.1 -8.1,-6.8c-0.5,-0.5 -0.8,-1.1 -1.4,-1.4c-2,-0.9 -5,-1.2 -6.7,-2.8c-1,0 -6.3,-0.2 -6.9,-0.6c-0.6,-0.4 -1.2,-2.9 -1.6,-3c-2.8,-0.6 -7.4,-0.3 -9.8,-2.5c-1.9,-1.8 -2.3,-10.5 -5.7,-9.3c-0.4,-0.2 -0.9,-0.4 -1.4,-0.3c-2.2,-3.1 -9.8,-3.5 -12.9,-5.5c-0.9,-0.6 -3.8,-0.1 -3.8,-1c0.7,-1.7 0.5,-3.1 0.6,-4.8c-1.7,-1.8 -2.8,-3.9 -4,-5.2c-2.9,-0.7 -1.8,-1 -3.6,-2.2c-5,-0.4 -5.5,0.5 -8.7,3.7c-0.8,0.8 -2.4,1 -3.4,1.6c-1.7,1 -2.2,4.3 -4.6,2.8c-0.8,-0.5 -1.3,-1.3 -1.9,-1.9c-1.4,-1.3 -2.2,-0.6 -2.9,-3c-4.1,-2.4 -15.4,5.9 -18.1,0.1c-1.9,-1.1 -3.3,0.3 -4.9,-1.5c-0.8,-0.9 2.2,-10.9 -6,-15c1.9,-1.6 3.9,-2.7 5.7,-4.2c0.5,-1.1 -0.1,-2.8 -0.1,-3.9c-0,-1.7 1,-5 0.7,-6.2c-0.3,-1.2 -1.5,-2.2 -1.9,-3.6c-0.5,-1.4 0.1,-3.2 -0.6,-4.7c-0.5,-0.4 -2,-1.4 -2.6,-1.4c-2.1,-1.9 -4.4,-3.1 -6.1,-5.4c-0.4,-0.5 -0.7,-1.4 -1.2,-1.8c-1.5,-1.2 -6.4,-2.8 -6.2,-5.3c0.1,-0.8 1.1,-0.9 1.4,-1.7c0.3,-1 0.1,-2.3 0.8,-3.2c2.3,-3.4 7.4,-1.9 6.6,-8.2c-0.4,-2.8 -2.2,-5.2 -2.7,-8.2c-0.9,-0.7 -1,-1.9 -1.8,-2.6c-5,-0.5 -4.3,-6.1 -6.1,-7.4c-5.3,-3.9 -9.4,-1.5 -3.5,-9.2c0.8,-2.5 -5.1,-6.5 -6.3,-7.9c-2.1,-2.2 -1.1,-6.8 -1.9,-9.2c-0.4,-1.2 -3.9,-3.3 -5,-5c-0.3,-0.5 -1.2,-3.1 -1.7,-3.4l0.1,-0.8c1.1,-0.9 0.5,-2.7 0.2,-3.9c-0.7,-0.7 -2.2,-0.5 -2.7,-1c-4.8,-4.7 -10.6,-6.8 -16.9,-9.5c-1.7,-0.7 -1.2,-2.2 -2.6,-2.9c-1.2,-0.6 -9.7,-4.7 -10.3,-4.5c-1,-0.3 -1.7,-4.4 -2.4,-5.7c-0.6,-1.2 -3,-3.4 -3,-3.5c0.2,-3.8 -2,-4.3 -4.7,-6.3c0.2,-0.5 -0.3,-1.7 -0.3,-2.3c-0,-0.5 1.8,-7.1 2.1,-8c0.5,-1.4 2.2,-2.7 1.9,-4.3c-0.4,-2.5 -0.7,-6.4 -1.5,-8.6c-2.7,-7.8 -5.9,-6.8 -4.2,-17c0.4,-2.1 -0.3,-3.3 1.2,-5.2c-0.2,-0.1 0.7,-1.1 0.8,-1.3c0.9,-0.9 3.4,-2.4 3.9,-3.1c1.5,-2.2 2.4,-7.2 4.3,-8.8c1.4,-1.2 5.4,-3.5 6.1,-4.5c0.6,-0.8 1.5,-3.3 1,-4.3c-1.4,-0.9 -2.8,-0.5 -4.2,-0.7c-0.5,-0.1 -2.3,-1.5 -3.7,-1.8c-0.4,-0.5 -1.1,-1.1 -1.1,-1.8l-0.6,-0.6c-1.6,-0.2 -3.4,-1.3 -4.8,-1.8c-1.8,-0.8 -4.3,-0.9 -6,-2c-3.2,-2 -6.8,-7.5 -9.9,-8.3c-4.2,-1 -6.9,0.4 -10.9,0.6c-2.6,0.2 -2.6,-1.5 -4.7,-2.2c-2.8,-0.9 -0.7,1.6 -7.1,-0.6c-0.8,-0.7 0.4,-3.1 0.5,-4c-1,-0.3 -2.2,0.3 -3.4,-0c-5.3,-1.4 -3.3,-6.6 -4.7,-10c-0.6,-0.8 -2.8,-0.6 -3.8,-0.7c-0.3,-0.1 -0.4,-0.6 -0.3,-0.8l0.5,-0.4c0.9,-1.5 -2.3,-5.3 -2.2,-5.8c0.2,-1.2 6.7,-2.3 7.6,-2.4c0.3,-0.9 -0.6,-1.7 -0.7,-2.6c-0.2,-2 1,-4.6 1.6,-6.4l-0.2,-0.6c-1.8,-1.1 -2.4,-2.7 -4,-4c0.1,-0.9 1.2,-1.5 1.4,-2.4c3.1,-9.3 7.9,-1.9 12.1,-10.5c0.4,-0.8 1.6,-2.9 2,-4.3l0.8,-0.2c0.8,0.2 1.9,0.9 2.7,0.6c0.6,-0.9 1.9,-1.2 2.9,-1.5l1.5,0.4c7.8,-1.8 6,-4.9 10.5,-8.4c1.2,-0.9 4.7,-1.3 6.3,-1.9c1.7,0.8 4.1,3.7 7.3,5c2.3,1 10.2,2.8 11.5,3.6c1.7,1 2,3.4 3.5,4.3c4.5,2.6 1.9,-1.8 6.2,-0.9c4.4,1 8,4.9 12.1,6.8c0.7,0.3 2.4,-0.1 3.2,-0.3c1.3,-0.3 8.3,-1.7 9,-1.4c0.8,0.3 2,1.1 2.8,1.3c1,0.2 1.8,-2.1 2.5,-2c3,0.5 3.1,1.8 7.1,1.4c0.2,-0 2.1,-12.2 4,-12.8c1.1,-0.3 4.1,2.9 5,3.1c1.5,0.4 -0.1,-2.5 -0.2,-2.7c-0.4,-1 -2.5,-8.5 -2.4,-9.2c0.1,-0.4 2,0.6 2.9,0.3c2.2,-0.8 5.2,-1.4 6.8,-3.3c0.2,-0.2 3.6,-5.5 3.7,-5.7c0.2,-0.9 -0.9,-3 -0.4,-3.7c0.5,-0.6 2.4,-1.4 3.3,-2.4c1.3,-1.4 1.5,-3.8 3.3,-4.8c7.1,-0.7 9.6,-6.7 16,-7.5c0.4,-0 1.8,-0.3 2.1,-0.2l1.3,2.3c0.4,0.6 4.7,3.4 5.4,3.2c0.6,-0.1 0.9,-1.2 1.5,-1.4c1.3,0.2 4.9,-2.2 5.3,-3.4c0.1,-0.2 -0.8,-1.4 -0.4,-2.2c0.3,-0.6 4.8,-4.2 5.5,-4.6c1.6,-0 3.3,-0.4 4.8,0.2c0.9,0.4 1,1.9 2,2.1c1.1,0.1 3.1,-0.4 3.9,-0.2c0.9,0.2 1.3,-1.8 2.4,-1.9z'/%3E %3Cg id='h'%3E %3Cuse xlink:href='%23star' x='461.835' y='121.826'/%3E %3Cuse xlink:href='%23star' x='544.233' y='136.356'/%3E %3Cuse xlink:href='%23star' x='622.857' y='164.972'/%3E %3C/g%3E %3Cuse xlink:href='%23h' x='-840' transform='scale(-1,1)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 150 100'%3E %3Cpath fill='%23ED2939' d='M0,0H150V100H0z'/%3E %3Cpath fill='%23FFF' d='M0,0H40V40H0z'/%3E %3Cpath fill='%23002395' d='M0,0H20V40H0z'/%3E %3Cpath fill='none' stroke='%23FFF' d='M0,40H60V0'/%3E %3Cpath fill='%23FFF' d='M105,46 93,34H117zM101,50 89,38V62zM105,54 93,66H117zM109,50 121,38V62z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='360' viewBox='0 0 950 570'%3E %3Crect width='950' height='285' fill='%23d21034'/%3E %3Crect y='285' width='950' height='285' fill='%23009543'/%3E %3Cpath d='M 0,0 L 552.8133,285 L 0,570 z' fill='%23000'/%3E %3Crect y='234' width='950' height='102' fill='%23000'/%3E %3Cpath d='M 0,40.502 L 474.251,284.9995 L 0,529.497 z' fill='%23fdce12'/%3E %3Crect y='270' width='950' height='30' fill='%23fdce12'/%3E %3Cpath d='M 0,74.25473 L 408.78173,285 L 0,495.745 z' fill='%23000'/%3E %3Cpath d='M 115.481,339.524 C 115.481,339.524 115.481,360.119 115.481,372 C 143.734,372 199.181,350.35 199.181,280.644 C 199.181,210.938 140.037,198 122.346,198 C 104.656,198 50,210.674 50,267.706 C 50,324.738 103.6,330.019 114.161,330.019 C 124.722,330.019 164.328,320.513 159.84,277.739 C 159.84,289.885 146.11,315.497 117.329,315.497 C 88.549,315.497 70.595,294.109 70.595,272.987 C 70.595,251.863 88.021,223.611 118.385,223.611 C 148.749,223.611 170.928,250.542 170.928,277.739 C 170.928,304.935 149.542,339.524 115.481,339.524 z' fill='%23fdce12'/%3E %3Cg id='frond' fill='%23fdce12'%3E %3Cpath d='M 90.728,297.245 L 92.411,298.334 C 92.411,298.334 105.778,267.838 141.72,246.154 C 137.165,248.629 113.105,260.61 90.728,297.245 z' stroke='%23fdce12'/%3E %3Cpath d='M 94.193,291.997 C 94.193,291.997 90.035,283.482 93.698,279.72 C 97.362,275.957 95.679,289.72 95.679,289.72 L 97.263,287.443 C 97.263,287.443 94.787,277.046 97.56,274.868 C 100.332,272.69 98.946,284.868 98.946,284.868 L 100.629,282.69 C 100.629,282.69 98.847,272.591 101.52,270.709 C 104.194,268.828 102.511,280.215 102.511,280.215 L 104.491,277.937 C 104.491,277.937 103.006,268.333 106.273,266.056 C 109.541,263.778 106.669,275.165 106.669,275.165 L 108.847,272.789 C 108.847,272.789 107.857,263.976 110.63,261.996 C 113.402,260.016 111.026,270.313 111.026,270.313 L 113.006,268.234 C 113.006,268.234 112.412,260.016 115.085,258.135 C 117.759,256.253 115.283,265.957 115.283,265.957 L 117.363,263.976 C 117.363,263.976 116.868,255.758 120.234,254.174 C 123.6,252.59 119.64,261.897 119.64,261.897 L 121.917,259.917 C 121.917,259.917 122.61,250.313 125.482,249.421 C 128.353,248.53 124.195,257.937 124.195,257.937 L 126.274,256.253 C 126.274,256.253 127.363,248.035 130.531,247.045 C 133.7,246.055 128.551,254.57 128.551,254.57 L 130.63,252.986 C 130.63,252.986 132.908,244.768 135.878,243.877 C 138.849,242.986 132.809,251.6 132.809,251.6 L 134.789,250.214 C 134.789,250.214 138.056,242.787 140.73,242.292 C 143.403,241.797 137.759,248.431 137.759,248.431 L 140.235,246.946 C 140.235,246.946 144.492,239.223 145.978,241.599 C 147.463,243.976 140.037,247.441 140.037,247.441 L 137.561,248.827 C 137.561,248.827 146.572,244.57 147.661,246.748 C 148.75,248.926 135.284,250.313 135.284,250.313 L 133.106,251.798 C 133.106,251.798 142.116,249.322 141.027,251.6 C 139.938,253.877 131.027,253.382 131.027,253.382 L 128.947,254.867 C 128.947,254.867 137.957,252.689 136.769,254.768 C 135.581,256.847 126.769,256.649 126.769,256.649 L 124.591,258.432 C 124.591,258.432 133.403,256.154 132.116,258.828 C 130.828,261.501 120.828,261.402 120.828,261.402 L 118.353,263.679 C 118.353,263.679 127.66,260.511 126.868,262.986 C 126.076,265.462 115.481,266.749 115.481,266.749 L 113.105,269.125 C 113.105,269.125 123.105,265.759 120.135,268.828 C 117.165,271.898 109.937,272.69 109.937,272.69 L 107.065,276.155 C 107.065,276.155 116.967,270.214 115.58,273.581 C 114.194,276.947 104.491,279.225 104.491,279.225 L 102.511,281.601 C 102.511,281.601 111.422,276.452 110.531,279.324 C 109.64,282.195 100.134,285.264 100.134,285.264 L 98.55,287.443 C 98.55,287.443 109.045,281.205 108.154,284.373 C 107.263,287.542 97.263,289.819 97.263,289.819 L 95.976,291.799 C 95.976,291.799 105.679,286.255 105.778,288.928 C 105.877,291.601 94.391,294.275 94.391,294.275 L 94.193,291.997 z'/%3E %3C/g%3E %3Cuse xlink:href='%23frond' transform='translate(238.5) scale(-1,1)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-15 -10 30 20'%3E %3Crect fill='%23DA251d' x='-20' y='-15' width='40' height='30'/%3E %3Cg id='g' transform='translate(0,-6)'%3E %3Cpolyline id='g1' fill='%23FF0' points='0,0 0,6 4,6' transform='rotate(18)'/%3E %3Cuse xlink:href='%23g1' transform='scale(-1,1)'/%3E %3C/g%3E %3Cg id='g2' transform='rotate(72)'%3E %3Cuse xlink:href='%23g' /%3E %3Cuse xlink:href='%23g' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23g2' transform='scale(-1,1)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 17.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Capa_1' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='1275.59px' height='850.394px' viewBox='1488.189 992.126 1275.59 850.394' enable-background='new 1488.189 992.126 1275.59 850.394' xml:space='preserve'%3E %3Crect id='rect3' x='1488.189' y='992.126' fill='%23FFFFFF' width='1275.59' height='850.394'/%3E %3Cpath id='path5' fill='%23369443' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1885.935,1567.623 c0,0-1.033-6.99,12.242-12.116c13.275-5.126,14.307-24.232,11.652-36.97c0,0-6.932,12.116-15.339,16.155 c0,0-13.717,7.146-14.345,20.795c0,0-0.109,4.99-1.142,8.873c-0.565,2.126-6.637-17.087,4.867-31.377 c11.872-14.748,15.192-26.717,5.752-50.017c0,0-0.885,14.135-10.177,22.213c-9.292,8.077-10.474,8.699-10.325,27.96 c0,0,0.148,6.679-3.392,8.854c0,0-7.227-10.563-9.145-17.553c-1.917-6.99-2.802-9.941,5.457-18.019c0,0,26.461-17.1,7.375-54.522 c0,0-0.59,12.893-9.735,20.504c-9.145,7.611-8.407,12.737-8.85,25.941c-0.443,13.203-1.328,12.271-2.36,14.135 c0,0-16.814-30.911-3.835-47.377s20.207-19.883,5.9-50.483c0,0,0.635,15.689-10.818,23.456c-11.453,7.767-8.798,25.941-8.798,25.941 s0.737,6.835-1.622,11.805c0,0-16.202-31.601-0.737-48.62c13.127-14.446,14.012-24.543,6.932-45.047c0,0-0.885,9.476-8.112,14.601 c-7.227,5.126-12.979,10.252-11.652,29.979c0,0,0.59,13.825-1.18,17.708c0,0-6.785-12.582-8.702-20.815 c-1.917-8.233-2.655-13.048,2.36-21.281c5.015-8.233,24.927-31.844,1.18-65.861c0,0-0.737,11.029-6.785,20.97 c-6.047,9.941-3.245,21.747-1.917,30.756s-3.097,17.708-3.097,17.708s-10.325-18.951-8.112-40.697 c2.212-21.747-6.637-39.61-26.697-52.503c0,0-14.602,33.863,5.31,51.105c0,0,16.962,16.776,21.239,37.125 c0,0-12.832-1.243-24.484-23.921c-11.652-22.679-35.841-19.106-37.464-19.261c0,0,3.983,35.105,41.151,45.047 c0,0,23.747,4.039,28.172,21.436c0,0,3.982,11.961,5.605,18.329c0,0-7.522-2.951-14.455-13.203 c-6.932-10.252-6.047-11.495-29.499-13.825c0,0-9.44-1.088-14.455-7.767c0,0,9.882,37.125,35.251,36.814 c0,0,23.157-2.485,36.136,27.96c0,0-2.507-1.553-5.9-3.884c-3.392-2.33-11.947-6.679-28.909-4.66 c-16.962,2.019-21.682-0.777-25.959-2.175c0,0,17.109,31.377,41.299,22.057c24.189-9.32,35.872,24.665,36.136,25.319 c0,0-3.245-2.486-7.522-6.68c-4.277-4.194-13.157-9.366-29.942-4.039c0,0-12.094,4.66-24.337,0.932c0,0,11.8,22.834,39.381,18.951 c27.581-3.884,34.514,20.349,34.514,20.349s-3.687-2.175-6.195-4.194c-2.507-2.019-11.8-7.301-31.711-1.398 c-19.912,5.903-27.139-0.932-27.139-0.932s11.062,20.193,32.301,22.523c0,0,11.8-0.155,16.814-2.019 c5.015-1.864,18.289-4.815,27.434,8.388c0,0-2.507,0.466-6.342-1.243c0,0-14.159-5.126-24.927,3.883c0,0-9.587,9.786-23.157,7.922 c0,0,17.552,17.087,45.428,2.641c0,0,9.44-6.835,16.372-1.553C1869.858,1578.031,1885.935,1567.623,1885.935,1567.623z'/%3E %3Cpath id='path7' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2041.1,1146.669 c0,0-3.238-28.908,19.863-31.688c24.091-2.9,35.989,2.175,35.989,2.175l10.816,21.229l-3.737,14.291l-14.946,6.835 c0,0,2.557-21.954-17.568-22.411c-5.099-0.116-8.096,1.906-16.161,0.626C2047.245,1136.438,2042.907,1145.351,2041.1,1146.669z'/%3E %3Cpath id='path9' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2203.639,1218.226 c-3.442,4.453-17.208,6.006-17.208,6.006s14.159,10.873,20.256,26.407c6.097,15.533-164.113,0.103-164.113,0.103 s7.375-5.281,12.39-15.223c0,0-7.522,2.796-15.044-4.66c0,0,5.605,1.864,12.979-9.32c0,0,10.915-13.98,18.584-17.708 c0,0-3.54,2.175-12.094-2.485c0,0,14.75-1.864,20.059-27.028c0,0,0.885-5.592,6.49-13.669c5.605-8.078,4.425,1.553,14.75-10.874 c0,0,4.72-8.802,0.59-14.187c-4.13-5.385-8.555-3.417-17.208-8.595c-8.653-5.178-12.488-8.078-9.538-16.051 c2.95-7.974,10.62-6.731,11.701-6.731c1.082,0,1.672-6.938,11.112-11.702c9.44-4.764,34.514-2.693,38.25-0.621 c3.737,2.071,18.879,6.524,27.729,28.892c8.85,22.368-2.36,30.756,21.731,64.515c0,0-9.636,2.071-15.831,0.207 C2169.224,1185.502,2181.711,1207.663,2203.639,1218.226z'/%3E %3Cpath id='path11' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2098.328,1123.835 c-19.617-0.932-12.094-19.624-12.094-19.624'/%3E %3Cpath id='path13' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2132.399,1126.398 c0,0-3.466-1.631-6.398-5.514c-4.115-5.449-13.292-8.077-18.233-2.951c0,0-5.015,5.592-9.44,5.903c0,0,5.015,1.553,8.481,4.738 c3.466,3.184,7.08,5.514,12.242,4.815c5.162-0.699,5.974-3.417,8.407-5.048C2129.892,1126.708,2132.399,1126.398,2132.399,1126.398z '/%3E %3Cpath id='path15' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.981,1405.765c0,0,18.29,14.912,33.629,0 c0,0,6.195,7.456,18.584,5.281c12.39-2.175,14.455-8.699,15.635-12.427c0,0,10.718,6.253,19.764,1.314 c9.047-4.939,9.047-12.394,9.047-12.394s15.733,3.101,23.796-7.562c8.063-10.663,3.147-21.226-1.18-22.469 c0,0,17.01,4.456,21.633-10.148c3.933-12.427-4.917-18.847-4.917-18.847s35.841-0.172,50.542-11.391c0,0,12.193-7.663,4.917-15.74 c0,0,32.252-5.178,40.315-18.019c0,0,3.54-3.521,2.36-9.734c0,0-0.197-3.521-3.737-3.728c0,0,36.78-5.681,47.395-17.812 c0,0,5.113-5.592,2.557-13.048c0,0-0.541-1.968-1.426-3.288c0,0,33.481-7.068,50-21.98c0,0,9.536-8.496,4.62-19.887 c0,0,55.951-15.322,42.972-39.968c0,0,26.156-8.492,17.896-32.102c0,0,21.633-10.977,12.193-28.374 c-9.034-16.65-36.775,2.899-69.624,11.988c0,0-88.884,27.985-132.656,35.432l-124.372,185.167l-72.568,27.96L2259.981,1405.765z'/%3E %3Cpath id='path17' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2259.097,1269.382c0,0,11.657-8.751,32.449,1.553 c0,0,7,4.82,12.507-0.461c4.601-4.413,5.032-12.549-1.297-17.247c-15.487-11.495-21.24-45.979,2.36-60.269 c0,0,34.219-20.297,159.696-52.229c0,0,10.513-2.915,16.118-1.517c6.172,1.539,10.423,6.835,11.295,11.366 c0,0,5.615,15.956-13.262,25.086c0,0-8.522,3.9-17.306,6.421c0,0,9.648-2.086,13.766,7.456c3.933,9.113-1.77,18.433-19.469,24.439 c0,0-4.787,1.863-11.603,3.521c0,0,15.143,4.349,7.866,16.569c0,0-6.49,12.841-29.401,15.119c0,0,17.109,1.864,5.015,18.122 c0,0-5.31,8.906-22.026,12.22c0,0,12.685,0.414,6.293,11.805c-6.391,11.391-21.432,17.812-36.232,18.847 c0,0-8.016,0.414-13.621-0.829c0,0,14.061,7.042,5.801,18.847c0,0-6.096,8.388-21.337,7.974c0,0,3.956,13.183-7.227,18.174 c-8.702,3.883-15.929-2.33-15.929-2.33s2.95,14.135-9.735,19.106c0,0-6.342,3.262-15.782,0c0,0-7.227,16.155-32.891,4.815 C2239.479,1364.602,2259.097,1269.382,2259.097,1269.382z'/%3E %3Cpath id='path19' fill='%23F6E200' stroke='%23010002' stroke-width='3' d='M2193.461,1317.07'/%3E %3Cpath id='path21' fill='none' stroke='%23010002' stroke-width='3' d='M2654.383,1121.815c0,0-40.315,23.342-165.869,46.684'/%3E %3Cpath id='path23' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1934.384,1534.589c0,0-14.946,25.682-33.039,26.096 c0,0-31.122-3.788-39.922,4.349c-6.136,5.675-12.39,10.356-14.946,24.854s4.916,17.605,6.686,18.226c0,0,1.377,10.356,11.603,7.663 c0,0,0.59,10.77,18.683,5.592c18.093-5.178,25.566-3.521,29.106-21.54c3.54-18.019,6.808-17.724,10.03-19.883 c4.327-2.9,12.455-5.64,18.486-9.113c5.418-3.12,26.156-13.67,33.235-14.498c7.08-0.828,5.506-24.646,5.506-24.646h-18.289 l-8.85-13.048L1934.384,1534.589z'/%3E %3Cpath id='path25' fill='none' stroke='%23010002' stroke-width='3' d='M2636.487,1153.918c0,0-109.115,35.594-159.93,39.968'/%3E %3Cpath id='path27' fill='none' stroke='%23010002' stroke-width='3' d='M2593.515,1193.886c0,0-64.011,20.094-138.971,32.774'/%3E %3Cpath id='path29' fill='none' stroke='%23010002' stroke-width='3' d='M2538.894,1235.753c0,0-72.322,17.372-106.849,20.255'/%3E %3Cpath id='path31' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2490.368,1269.9 c0,0-61.173,12.758-76.672,14.292'/%3E %3Cpolygon id='polygon33' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2421.511,1362.939 2424.574,1460.005 2424.574,1460.005 2407.435,1450.062 2407.435,1450.062 2378.901,1573.241 2367.128,1564.783 2394.904,1446.772 2394.904,1446.772 2375.536,1447.128 2375.536,1447.128 '/%3E %3Cpath id='path35' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2451.43,1301.381 c0,0-44.642,6.783-62.409,6.42'/%3E %3Cpath id='path37' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2395.972,1328.513 c0,0-18.05-0.848-26.724-2.288'/%3E %3Cpath id='path39' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2379.255,1357.509 c0,0-15.34-4.142-24.386-9.941'/%3E %3Cpath id='path41' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2356.64,1387.54 c0,0-11.8-4.556-17.503-16.983'/%3E %3Cpath id='path43' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2327.829,1398.62 c0,0-9.145-8.181-9.735-17.294'/%3E %3Cpolygon id='polygon45' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2532.37,1406.102 2491.805,1493.32 2491.805,1493.32 2481.104,1476.067 2481.104,1476.067 2395.461,1577.264 2386.188,1566.883 2471.506,1466.967 2471.506,1466.967 2454.247,1457.705 2454.247,1457.705 '/%3E %3Cpath id='path47' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2293.61,1405.765 c0,0,3.424-2.953,1.082-15.792'/%3E %3Cpolygon id='polygon49' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' points='2495.369,1342.078 2474.473,1436.672 2474.473,1436.672 2460.361,1422.396 2460.361,1422.396 2383.71,1569.785 2371.898,1562.89 2449.065,1415.802 2449.065,1415.802 2430.27,1410.867 2430.27,1410.867 '/%3E %3Cpath id='path51' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2298.035,1371.126 c0,0,1.77-3.676,1.18-9.475'/%3E %3Cpath id='path53' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1991.986,1405.766c0,0-18.289,14.912-33.629,0 c0,0-6.195,7.456-18.584,5.281s-14.455-8.699-15.635-12.427c0,0-10.718,6.253-19.764,1.314c-9.047-4.939-9.047-12.395-9.047-12.395 s-15.733,3.101-23.796-7.562c-8.063-10.663-3.147-21.226,1.18-22.469c0,0-17.01,4.456-21.633-10.148 c-3.933-12.427,4.917-18.847,4.917-18.847s-35.841-0.172-50.542-11.391c0,0-12.193-7.663-4.916-15.74 c0,0-32.252-5.178-40.315-18.019c0,0-3.54-3.521-2.36-9.734c0,0,0.197-3.521,3.736-3.728c0,0-36.78-5.681-47.395-17.812 c0,0-5.113-5.592-2.557-13.048c0,0,0.541-1.968,1.426-3.288c0,0-33.481-7.068-50.001-21.98c0,0-9.536-8.496-4.62-19.887 c0,0-55.952-15.322-42.972-39.968c0,0-26.156-8.492-17.896-32.102c0,0-21.633-10.977-12.193-28.374 c9.034-16.65,36.776,2.899,69.624,11.988c0,0,88.884,27.985,132.656,35.432l124.372,185.167l72.568,27.96L1991.986,1405.766z'/%3E %3Cpath id='path55' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2362.54,1187.263 c0,0-20.649,8.285-27.532,19.676c-6.883,11.391-2.35,22.462,0,28.814c1.181,3.192,15.733,31.248-1.377,51.545'/%3E %3Cpath id='path57' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1992.871,1269.383c0,0-11.657-8.751-32.449,1.553 c0,0-7,4.82-12.506-0.461c-4.601-4.413-5.033-12.549,1.297-17.247c15.487-11.495,21.239-45.979-2.36-60.269 c0,0-34.219-20.297-159.696-52.229c0,0-10.513-2.915-16.118-1.517c-6.172,1.539-10.423,6.835-11.295,11.366 c0,0-5.615,15.956,13.262,25.086c0,0,8.522,3.9,17.306,6.421c0,0-9.648-2.086-13.766,7.456c-3.933,9.113,1.77,18.433,19.469,24.439 c0,0,4.787,1.863,11.603,3.521c0,0-15.143,4.349-7.866,16.569c0,0,6.49,12.841,29.401,15.119c0,0-17.109,1.864-5.015,18.122 c0,0,5.31,8.906,22.026,12.22c0,0-12.685,0.414-6.293,11.805c6.391,11.391,21.432,17.812,36.233,18.847 c0,0,8.016,0.414,13.621-0.828c0,0-14.061,7.042-5.801,18.847c0,0,6.096,8.388,21.338,7.974c0,0-3.956,13.184,7.227,18.174 c8.702,3.883,15.929-2.33,15.929-2.33s-2.95,14.135,9.735,19.106c0,0,6.342,3.262,15.782,0c0,0,7.227,16.155,32.891,4.815 C2012.488,1364.602,1992.871,1269.383,1992.871,1269.383z'/%3E %3Cpath id='path59' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2362.245,1309.355 c0,0-0.098-0.104-7.375-2.382'/%3E %3Cpath id='path61' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2405.805,1279.531 c0,0-12.308,2.478-24.386,2.589'/%3E %3Cpath id='path63' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2422.816,1249.189 c0,0-14.455,1.45-28.024,1.243'/%3E %3Cpath id='path65' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2444.35,1217.501 c0,0-20.846,4.142-32.056,4.349'/%3E %3Cpath id='path67' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2461.656,1182.085 c0,0-25.709,7.338-44.839,9.941'/%3E %3Cpath id='path69' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2374.339,1207.145 c0,0,18.486,17.19-3.737,33.138c0,0,9.243,14.498-9.243,29.617'/%3E %3Cpath id='path71' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M1994.394,1416.2c0,0-3.766,20.218-33.627,45.666 c0,0-23.04,20.324-22.45,43.727c0.601,23.832-4.13,26.51-13.176,34.588c0,0,18.683,1.45,27.729-10.977 c0,0-0.393,20.711-3.147,22.575c0,0,5.859,0.374,14.356-8.906c0,0,5.113-5.385,9.833-7.456c0,0-5.506,14.291-1.18,27.546 c0,0,1.377-5.178,8.653-7.456c0,0,13.176-2.693,18.29-21.747c0,0,3.343-12.634,23.992-23.818c0,0,23.402-8.827,22.813-20.361 S1994.394,1416.2,1994.394,1416.2z'/%3E %3Cpath id='path73' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2366.276,1277.046 c0,0,2.753,27.646-31.072,27.648c0,0,6.49,24.647-26.156,23.819c0,0-3.737,19.675-27.336,15.74'/%3E %3Cpath id='path75' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2317.618,1534.589c0,0,14.946,25.682,33.039,26.096 c0,0,31.122-3.788,39.922,4.349c6.136,5.675,12.39,10.356,14.946,24.854c2.557,14.498-4.917,17.604-6.687,18.226 c0,0-1.377,10.356-11.603,7.663c0,0-0.59,10.77-18.683,5.592s-25.566-3.521-29.106-21.54c-3.54-18.019-6.808-17.724-10.03-19.883 c-4.327-2.9-12.455-5.64-18.486-9.113c-5.418-3.12-26.156-13.669-33.235-14.498c-7.08-0.828-5.507-24.646-5.507-24.646h18.289 l8.85-13.048L2317.618,1534.589z'/%3E %3Cpath id='path77' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2257.608,1416.2c0,0,3.766,20.218,33.627,45.666 c0,0,23.04,20.324,22.45,43.727c-0.601,23.832,4.13,26.51,13.176,34.588c0,0-18.683,1.45-27.729-10.977 c0,0,0.393,20.711,3.147,22.575c0,0-5.86,0.374-14.356-8.906c0,0-5.113-5.385-9.833-7.456c0,0,5.506,14.291,1.18,27.546 c0,0-1.377-5.178-8.653-7.456c0,0-13.176-2.692-18.29-21.747c0,0-3.343-12.634-23.992-23.818c0,0-23.403-8.827-22.813-20.361 C2206.112,1478.047,2257.608,1416.2,2257.608,1416.2z'/%3E %3Cpath id='path79' fill='none' stroke='%23010002' stroke-width='3' d='M2333.695,1560.685c0,0,5.352,1.191,16.962,0'/%3E %3Cpath id='path81' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2383.303,1575.183 c0,0,16.323-2.485,15.536,32.931'/%3E %3Cpath id='path83' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2373.47,1583.26 c0,0,14.75-1.864,13.766,32.517'/%3E %3Cpath id='path85' fill='none' stroke='%23010002' stroke-width='3' d='M2231.088,1500.416c0,0,7.08,1.45,11.997,7.042 c4.916,5.592,14.356,4.556,14.356,4.556s-5.113-4.142-6.883-14.498s-7.473-13.462-7.473-13.462'/%3E %3Cpath id='path87' fill='none' stroke='%23010002' stroke-width='3' d='M2259.974,1474.247c0,0,7.08,1.45,11.996,7.042 c4.916,5.592,14.356,4.556,14.356,4.556s-5.113-4.142-6.883-14.498s-7.473-13.462-7.473-13.462'/%3E %3Cpath id='path89' fill='none' stroke='%23010002' stroke-width='3' d='M2264.842,1514.447c0,0,6.182,1.266,10.474,6.149 c4.293,4.882,12.535,3.978,12.535,3.978s-4.465-3.617-6.01-12.658c-1.545-9.042-6.525-11.754-6.525-11.754'/%3E %3Cpath id='path91' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2149.136,1676.875 c0,0,5.361,23.657,23.993,21.747c0,0,13.176-1.243,12.193-23.197c0,0,19.469,10.356,22.616-15.326c0,0,17.699,4.142,17.503-19.883 c0,0,16.52,2.9,14.553-18.433c0,0,17.896,4.763,17.896-15.326c0,0,41.888-6.947-45.428-86.573l-77.877,46.393L2149.136,1676.875z'/%3E %3Cpath id='path93' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2140.483,1570.709c0,0,12.979,11.516,22.222-5.675 c0,0,12.586-0.621,14.553-10.148c0,0,10.227-1.036,12.193-10.77c0,0,13.963-1.45,13.57-13.255c0,0,25.385-1.96,0.008-30.7 c-25.377-28.741-68.446,47.684-68.446,47.684L2140.483,1570.709z'/%3E %3Cpath id='path95' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2185.322,1675.425 c0,0-1.967-41.63-38.047-101.278'/%3E %3Cpath id='path97' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2207.938,1660.099 c0,0,5.605-24.025-45.232-95.064c0,0,5.9-16.983-12.193-27.857'/%3E %3Cpath id='path99' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2225.44,1640.216 c0,0,1.573-25.993-48.181-85.33c0,0,4.395-15.326-13.634-27.546'/%3E %3Cpath id='path101' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2239.993,1621.783 c0,0-1.868-26.303-50.542-77.667c0,0,2.435-15.74-15.007-25.475'/%3E %3Cpath id='path103' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2257.889,1606.457 c0,0-3.54-30.031-54.868-75.596c0,0,1.77-11.805-15.34-23.818'/%3E %3Cpath id='path105' fill='%23F4C53D' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2102.865,1676.875 c0,0-5.361,23.657-23.992,21.747c0,0-13.176-1.243-12.193-23.197c0,0-19.469,10.356-22.616-15.326c0,0-17.699,4.142-17.503-19.883 c0,0-16.52,2.9-14.553-18.433c0,0-17.896,4.764-17.896-15.326c0,0-41.888-6.947,45.428-86.573l77.877,46.393L2102.865,1676.875z'/%3E %3Cpath id='path107' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2111.519,1570.709c0,0-12.979,11.516-22.223-5.674 c0,0-12.586-0.621-14.552-10.148c0,0-10.227-1.036-12.193-10.77c0,0-13.963-1.45-13.57-13.255c0,0-25.385-1.96-0.008-30.7 c25.377-28.741,68.446,47.683,68.446,47.683L2111.519,1570.709z'/%3E %3Cpath id='path109' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2066.68,1675.425 c0,0,1.966-41.63,38.047-101.278'/%3E %3Cpath id='path111' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2044.064,1660.099 c0,0-5.605-24.025,45.232-95.064c0,0-5.9-16.983,12.193-27.856'/%3E %3Cpath id='path113' fill='%23F4C53D' stroke='%23010002' stroke-width='3' d='M2126.001,1563.585c12.582,0,26.839,78.599,23.139,125.953 c-1.344,17.198-10.557,31.245-23.139,31.245s-21.795-14.047-23.139-31.245C2099.162,1642.184,2113.419,1563.585,2126.001,1563.585' /%3E %3Cpath id='path115' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2026.561,1640.216 c0,0-1.573-25.993,48.182-85.33c0,0-4.395-15.326,13.634-27.546'/%3E %3Cpath id='path117' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2012.008,1621.783 c0,0,1.868-26.303,50.542-77.667c0,0-2.435-15.74,15.007-25.475'/%3E %3Cellipse id='ellipse119' fill='%23F4C53D' stroke='%23010002' stroke-width='3' cx='2126.001' cy='1562.963' rx='17.41' ry='25.785'/%3E %3Cpath id='path121' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1994.112,1606.457 c0,0,3.54-30.031,54.868-75.596c0,0-1.77-11.805,15.34-23.818'/%3E %3Cpath id='path123' fill='%23FFFFFF' stroke='%23010002' stroke-width='3' d='M2126.001,1557.331c0,0,147.66-65.433,148.029-216.805 h-296.058C1978.341,1491.898,2126.001,1557.331,2126.001,1557.331z'/%3E %3Cline id='line125' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2046.293' y1='1340.525' x2='2069.067' y2='1340.525'/%3E %3Cline id='line127' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2000.746' y1='1340.525' x2='2023.52' y2='1340.525'/%3E %3Cline id='line129' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' x1='2091.841' y1='1340.525' x2='2114.614' y2='1340.525'/%3E %3Cpath id='path131' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2000.746,1340.525v96.719c0,0,11.31,22.432,22.774,36.5 v-133.219L2000.746,1340.525L2000.746,1340.525z'/%3E %3Cpath id='path133' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2046.293,1340.525v159.435 c0,0,14.242,13.965,22.774,20.697v-180.132H2046.293z'/%3E %3Cpath id='path135' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2091.841,1340.525v197.076 c0,0,16.248,10.494,22.774,13.937v-211.013H2091.841z'/%3E %3Cline id='line137' fill='none' stroke='%23010002' stroke-width='3' x1='2000.746' y1='1340.525' x2='2023.52' y2='1340.525'/%3E %3Cline id='line139' fill='none' stroke='%23010002' stroke-width='3' x1='2046.293' y1='1340.525' x2='2069.067' y2='1340.525'/%3E %3Cline id='line141' fill='none' stroke='%23010002' stroke-width='3' x1='2091.841' y1='1340.525' x2='2114.614' y2='1340.525'/%3E %3Cpath id='path143' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2251.256,1340.525v96.719c0,0-11.31,22.432-22.773,36.5 v-133.219H2251.256z'/%3E %3Cpath id='path145' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2205.708,1340.525v159.435 c0,0-14.242,13.965-22.774,20.697v-180.132H2205.708z'/%3E %3Cpath id='path147' fill='%23A60032' stroke='%23010002' stroke-width='3' d='M2160.161,1340.525v197.076 c0,0-16.248,10.494-22.774,13.937v-211.013H2160.161z'/%3E %3Cline id='line149' fill='none' x1='2281.978' y1='1703.708' x2='2268.261' y2='1720.484'/%3E %3Cline id='line151' fill='none' x1='2251.256' y1='1701.845' x2='2289.057' y2='1736.793'/%3E %3Cpath id='path153' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2364.725,1614.728l-5.742,23.475 l0,0l15.719,15.659l0,0l-22.216,93.839l-19.76-26.542l-29.279,13.665l22.216-93.839l0,0l20.597-5.743l0,0l5.348-23.433 C2351.608,1611.809,2357.838,1609.369,2364.725,1614.728z'/%3E %3Cpath id='path155' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2369.988,1599.248l-11.315,21.11 l0,0l11.335,19.41l0,0l-44.521,84.586l-12.564-31.023l-31.64,5.219l44.521-84.586l0,0l21.306,0.067l0,0l10.924-21.177 C2358.035,1592.854,2365.982,1592.837,2369.988,1599.248z'/%3E %3Cpath id='path157' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2371.898,1605.387l-30.096,38.235 l0,0l6.898,21.598l0,0l-61.447,71.871l-5.615-33.205l-31.943-2.411l61.447-71.871l0,0l20.746,5.113l0,0l31.924-40.59 C2363.811,1594.128,2372.373,1598.38,2371.898,1605.387z'/%3E %3Cpath id='path159' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1900.98,1512.014'/%3E %3Cpath id='path161' fill='none' stroke='%23010002' stroke-width='3' d='M1597.585,1121.816c0,0,40.315,23.342,165.869,46.684'/%3E %3Cpath id='path163' fill='none' stroke='%23010002' stroke-width='3' d='M1615.481,1153.918c0,0,109.115,35.594,159.93,39.968'/%3E %3Cpath id='path165' fill='none' stroke='%23010002' stroke-width='3' d='M1658.453,1193.886c0,0,64.011,20.094,138.971,32.774'/%3E %3Cpath id='path167' fill='none' stroke='%23010002' stroke-width='3' d='M1713.073,1235.753c0,0,72.322,17.371,106.849,20.255'/%3E %3Cpath id='path169' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1761.599,1269.901 c0,0,61.173,12.758,76.672,14.292'/%3E %3Cpath id='path171' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1800.538,1301.382 c0,0,44.642,6.783,62.409,6.42'/%3E %3Cpath id='path173' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1855.996,1328.513 c0,0,18.05-0.848,26.724-2.288'/%3E %3Cpath id='path175' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1872.712,1357.509 c0,0,15.34-4.142,24.386-9.941'/%3E %3Cpath id='path177' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1895.328,1387.54 c0,0,11.8-4.556,17.503-16.983'/%3E %3Cpath id='path179' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1924.139,1398.621 c0,0,9.145-8.181,9.735-17.294'/%3E %3Cpath id='path181' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1958.358,1405.766 c0,0-3.424-2.953-1.082-15.792'/%3E %3Cpath id='path183' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1953.933,1371.126 c0,0-1.77-3.676-1.18-9.475'/%3E %3Cpath id='path185' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1889.428,1187.263 c0,0,20.649,8.284,27.532,19.675c6.883,11.391,2.35,22.462,0,28.814c-1.181,3.192-15.733,31.248,1.377,51.545'/%3E %3Cpath id='path187' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1889.723,1309.355 c0,0,0.098-0.104,7.375-2.382'/%3E %3Cpath id='path189' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1846.163,1279.531 c0,0,12.308,2.478,24.386,2.589'/%3E %3Cpath id='path191' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1829.152,1249.189 c0,0,14.455,1.45,28.024,1.243'/%3E %3Cpath id='path193' fill='%23369443' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1882.877,1610.513 c0,0-0.442-12.581,15.486-13.513l46.901,65.237c0,0-1.77,4.194-23.008,3.728c0,0-2.249-0.015-3.429,2.47 C1917.015,1672.25,1882.877,1610.513,1882.877,1610.513z'/%3E %3Cpath id='path195' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1807.618,1217.501 c0,0,20.846,4.142,32.056,4.349'/%3E %3Cpath id='path197' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1790.312,1182.085 c0,0,25.709,7.338,44.839,9.941'/%3E %3Cpath id='path199' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1877.629,1207.146 c0,0-18.486,17.19,3.736,33.138c0,0-9.243,14.498,9.243,29.617'/%3E %3Cpath id='path201' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1885.692,1277.047 c0,0-2.753,27.646,31.072,27.648c0,0-6.49,24.647,26.156,23.819c0,0,3.736,19.676,27.336,15.74'/%3E %3Cpath id='path203' fill='none' stroke='%23010002' stroke-width='3' d='M1918.258,1560.685c0,0-5.352,1.191-16.962,0'/%3E %3Cpath id='path205' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1868.651,1575.183 c0,0-16.323-2.485-15.536,32.931'/%3E %3Cpath id='path207' fill='none' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1878.484,1583.26 c0,0-14.75-1.864-13.766,32.516'/%3E %3Cpath id='path209' fill='none' stroke='%23010002' stroke-width='3' d='M2020.914,1500.415c0,0-7.08,1.45-11.996,7.042 s-14.356,4.556-14.356,4.556s5.113-4.142,6.883-14.498s7.473-13.462,7.473-13.462'/%3E %3Cpath id='path211' fill='none' stroke='%23010002' stroke-width='3' d='M1992.028,1474.247c0,0-7.08,1.45-11.996,7.042 c-4.916,5.592-14.356,4.556-14.356,4.556s5.113-4.142,6.883-14.498s7.473-13.462,7.473-13.462'/%3E %3Cpath id='path213' fill='none' stroke='%23010002' stroke-width='3' d='M1987.16,1514.446c0,0-6.182,1.266-10.474,6.148 c-4.293,4.883-12.535,3.978-12.535,3.978s4.465-3.617,6.01-12.659c1.545-9.042,6.525-11.754,6.525-11.754'/%3E %3Cpath id='path215' fill='%23162667' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2274.03,1230.549 c0,0-72.456,37.901-148.029-3.107c-75.573,41.008-148.029,3.107-148.029,3.107v109.976h296.058L2274.03,1230.549L2274.03,1230.549z' /%3E %3Cpath id='path217' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M1609.306,1515.748 c7.175-2.929,12.342-5.756,12.32-13.412c-0.005-1.825-1.019-5.863-3.055-12.114l-48.177-147.24 c-2.853-8.747-5.01-13.947-6.01-15.863c-2.166-4.147-6.417-5.835-12.143-8.22h5.93h49.361h5.941 c-6.652,3.143-12.716,5.639-12.659,12.691c0.022,2.693,0.779,6.49,2.341,11.393l36.907,115.541l36.871-115.541 c1.562-4.903,2.369-8.7,2.343-11.393c-0.071-7.248-6.386-9.86-12.591-12.691h5.872h47.565h5.906 c-5.426,2.174-9.848,3.878-12.12,8.22c-1.002,1.916-3.157,7.116-6.009,15.863l-48.177,147.24c-2.038,6.25-2.775,10.357-3.056,12.258 c0,0-2.217,9.312,12.32,13.267L1609.306,1515.748L1609.306,1515.748z'/%3E %3Cpath id='path219' fill='%230081C6' stroke='%23010002' stroke-width='3' stroke-miterlimit='10' d='M2635.986,1500.605v-166.709 c0-2.884-0.476-5.095-1.425-6.634c-0.951-1.537-5.09-5.969-10.995-8.364h5.906h43.363h5.906c-5.906,1.955-10.046,6.706-10.995,8.292 c-0.951,1.586-1.425,3.821-1.425,6.706v166.709c0,2.981,0.491,5.264,1.476,6.85c0.983,1.586,5.039,5.458,10.944,8.292h-5.906 h-43.363h-5.906c5.906-2.687,10.044-6.825,10.995-8.364C2635.51,1505.847,2635.986,1503.586,2635.986,1500.605z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Cdefs%3E %3ClinearGradient id='grad' gradientUnits='userSpaceOnUse' x1='103.083' y1='111.276' x2='92.5511' y2='107.764' gradientTransform='matrix(0.99614143,0,0,2.2525522,703.84172,-75.047171)'%3E %3Cstop stop-color='%23f00' offset='0'/%3E %3Cstop stop-color='%23ff0' offset='1'/%3E %3C/linearGradient%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m776.26,144.068,250.401-0.92914-0.4646,222.992s8.8267,33.9134-104.992,85.4802c40.8818-4.18106,85.4802-47.8503,85.4802-47.8503s18.1181-23.2281,26.9449-10.2204c8.8267,13.0077,17.1889,19.5117,23.6928,24.622,6.504,5.11021,11.614,19.0472,1.8582,29.2676s-25.0866,11.6142-29.2676-0.92915c-6.504,3.25205-46.4568,51.5669-128.22,53.8897-83.1573-1.39373-128.685-54.3542-128.685-54.3542s-11.1496,17.6537-26.9448,3.71663c-15.3307-18.1182-3.71653-29.7324-3.71653-29.7324s13.0078-7.43296,16.7244-12.5433c6.03938-6.96852,7.89764-16.2598,18.1181-16.2598,12.0787,0.92916,16.7244,10.685,16.7244,10.685s41.811,44.134,86.8739,49.7086c-101.736-48.783-105.453-78.98-104.988-86.413l0.46458-221.133z'/%3E %3Cpath fill='%23006129' stroke='%23000' stroke-width='1.8873' d='m782.299,150.107,238.787-1.39371,0,214.63c0.4645,27.874-46.4566,56.2125-119.858,92.4486-75.7244-39.0236-119.394-62.7163-119.858-92.9131l0.92912-212.771z'/%3E %3Cg id='lamp' fill='%23f7c600' stroke='%23000' stroke-width='0.9437'%3E %3Cpath fill='none' stroke='%23f7c600' stroke-width='1.8873' d='m814.794,181.829,14.095-20.7013,14.1636,20.7446'/%3E %3Cpath d='m831.719,174.09c0.00053,1.54631-1.25288,2.80012-2.79923,2.80012s-2.79977-1.25381-2.79924-2.80012c-0.00053-1.54631,1.25289-2.80013,2.79924-2.80013s2.79976,1.25382,2.79923,2.80013z'/%3E %3Cpath d='m817.444,197.119,21.8516,0.0622s0.34262-2.83593-2.28248-4.55956c11.4454-1.57386,8.47204-11.6694,18.0575-12.2416,1.85988,0.28611-5.00735,4.29202-5.00735,4.29202s-5.77927,4.07838-3.14748,6.15185c2.08942,1.64618,3.00441-1.00133,3.29056-3.00428,0.28613-2.00296,9.29933-3.29055,8.01175-9.01315-2.14601-4.72127-14.7359,3.14727-14.7359,3.14727l-8.98216-0.0498c-0.56005-1.00812-3.03547-5.05072-5.59189-5.06944-3.03289,0.11067-5.16923,5.11927-5.16923,5.11927h-13.0191-7.29642s-0.69652,5.21257,9.60433,6.21405c2.31918,3.02889,4.11696,3.87515,6.13307,4.65921-1.34408,1.12015-1.72246,2.47524-1.71681,4.29203z'/%3E %3Cpath d='m819.017,192.684,18.2006-0.062'/%3E %3Cpath d='m810.681,181.953s1.45607,8.51263,8.17643,10.5287'/%3E %3Cpath fill='url(%23grad)' d='m809.561,181.841c0.67203-3.24812,1.90411-3.80827,3.24818-7.95248,0.22402-4.03218-3.24818-3.58421-2.24012-6.1603,1.79209-2.80015,0.89605-5.48827-2.46413-7.61639,0.67204,3.69624-4.36823,7.16842-4.36823,10.1925,0,3.02421,2.57614,2.35218,2.24012,6.94451,0.22402,2.68797-0.67203,2.01609-0.89604,4.59218h4.48022z'/%3E %3Cpath d='m831.495,161.657c0.00049,1.42254-1.15262,2.576-2.57522,2.576-1.42259,0-2.5757-1.15346-2.57521-2.576-0.00049-1.42254,1.15262-2.576,2.57521-2.576,1.4226,0,2.57571,1.15346,2.57522,2.576z'/%3E %3C/g%3E %3Cuse xlink:href='%23lamp' x='-0.77220062' y='41.304015'/%3E %3Cuse xlink:href='%23lamp' x='-1.0892006' y='82.013015'/%3E %3Cuse xlink:href='%23lamp' x='25.626799' y='126.09901'/%3E %3Cuse xlink:href='%23lamp' x='-4.5742006' y='162.16301'/%3E %3Cuse xlink:href='%23lamp' x='-3.7822006' y='204.77301'/%3E %3Cuse xlink:href='%23lamp' x='146.2798' y='0.67201485'/%3E %3Cuse xlink:href='%23lamp' x='144.9358' y='41.218015'/%3E %3Cuse xlink:href='%23lamp' x='143.1438' y='82.661015'/%3E %3Cuse xlink:href='%23lamp' x='145.1598' y='123.43101'/%3E %3Cuse xlink:href='%23lamp' x='144.7118' y='164.20101'/%3E %3Cuse xlink:href='%23lamp' x='144.9358' y='205.19501'/%3E %3Cg fill='%23ffc6b5' stroke='%23000' stroke-width='0.9437'%3E %3Cpath fill='%23f7c600' d='m915.843,406.315s5.70236,13.1472,12.1968,5.06884c6.49443-8.07841,4.11854-11.5633,4.11854-11.5633l-14.573-7.92002-4.27677,9.02885,2.53442,5.3856z'/%3E %3Cpath d='m928.357,404.572s0.95029,0.15854,1.74235-1.26706c0.79206-1.42559-1.74235-2.05942-2.85118-3.64339l-1.26721,2.53457,2.37604,2.37588z'/%3E %3Cpath d='m895.409,401.087-12.8305,6.96957s-6.33605,1.26706-6.8112,0c-0.47529-1.2672,0.15839-2.37603,3.48472-2.53441,3.32648-0.15839,12.3553-8.39532,12.3553-8.39532l3.80163,3.96016z'/%3E %3Cpath d='m895.568,173.149s0.31677,3.00961,0.47515,4.59362c0.15838,1.584-2.53442,4.91039-2.6928,4.752s-1.42559,0.15839-1.26721,1.10884c0.15838,0.95044,2.05927,1.26722,2.05927,1.26722s-0.79206,3.32639,0,3.48477c0.79191,0.1584-2.05927,4.27696,0,5.38568,2.05912,1.10872,5.54398,2.53433,7.12796,2.21755,1.58397-0.31678,0,6.17762,0,6.17762l-4.43516,9.504,24.3936-2.53432-5.06884-8.07851s-2.37588-1.584-1.74235-6.17762c0.63368-4.59361-0.31677-25.344-0.31677-25.344l-17.424-2.37606-1.10883,6.01923z'/%3E %3Cpath d='m891.132,209.264s-7.92002,3.64329-7.60326,13.4641c-2.05912,9.50401-3.16795,19.008-3.16795,19.008s-9.34561,10.6127-12.1968,14.4144c-2.85118,3.80165-7.12811,11.5632-8.71208,13.6224-1.58398,2.05929-7.76158,8.87057-7.6032,11.4049,0.1584,2.53427-1.4256,13.7809,4.752,15.048,1.58399,0.63353,6.65283-12.9889,6.65283-12.9889s0.31676-5.86068-1.4256-6.96953c-1.74235-1.10882,3.80163-4.9105,3.80163-4.9105s10.6128-7.76162,12.9889-9.66239c2.37603-1.90078,8.87046-9.18722,8.87046-9.18722l3.6431-43.2433z'/%3E %3Cpath fill='%23fff' d='m900.161,201.82s2.05927,5.54406,6.65281,4.59362c4.59369-0.95045,9.97929-5.22716,9.97929-5.22716s4.27678-0.1584,4.91046,0.47516c0.63353,0.63356,11.5631,11.2463,11.2464,14.5728-0.31677,3.32651-5.06884,2.37595-6.8112,4.59362-1.74235,2.21767-4.59369,7.76162-3.80162,11.8801,0.79206,4.11845,3.16794,9.50413,2.85118,11.5633-0.31677,2.05917-2.05912,2.69273-2.05912,3.80155,0,1.10885,1.42559,3.00974,1.42559,5.0689,0,2.05917-1.90089,5.06867-1.58397,7.12794,0.31676,2.05929,0.47514,8.0784,0.47514,8.0784l-0.47514,27.8785s1.58397,0.95029,1.74235,2.53442c0.15838,1.58397,10.7712,47.6785,10.7712,47.6785s-0.47514,1.42559-1.58397,1.26721c-1.10883-0.15839,4.27677,7.12795,4.43516,9.18722,0.15838,2.05928,5.54413,18.2162,5.3856,20.4337-0.15838,2.2175-0.9503,7.12796-1.42559,7.28634-0.47515,0.15838,3.48486,10.1377,2.85118,11.7216-0.63353,1.58397-7.12796,1.42559-7.12796,1.42559l-1.74235-0.31676s0.15838,2.05927-1.10883,2.21765-10.6128-0.4753-10.6128-0.4753-2.6928,4.11839-4.27677,3.96001c-1.58413-0.15838-3.64325-3.00956-4.11855-2.53427-0.47514,0.47515,1.42574,3.1678,0.95045,3.95986-0.47515,0.79206-8.55355,2.53457-10.1377-1.26706-1.58397-3.80162,0.95045-2.85133,0.4753-3.64324-0.4753-0.79206-4.11839-2.85118-5.22722-2.21765-1.10882,0.63352,2.85119,1.58397,2.6928,3.16809-0.15838,1.58398-3.48486,3.95986-4.75207,3.95986s-4.27677-5.86075-8.71193-5.22707c-4.43531,0.63353-7.28649,1.74236-7.28649,1.74236s-5.22722,2.2175-7.44487,1.74236c-2.2175-0.47515-3.16795-2.21766-3.16795-3.16795,0-0.95045,1.58397-5.06884,1.42559-6.33605s-1.42559-2.53442-1.42559-4.4353c0-1.90074,3.64325-8.39517,3.64325-8.39517l-0.15839-29.1457s-3.32648-0.00015-3.48486-2.05927,5.06884-46.0945,5.86075-48.9457c0.79206-2.85118,2.85133-12.9888,2.85133-12.9888s-2.37603,1.10882-2.53442,0c-0.15838-1.10883,7.12796-26.2944,7.12796-26.2944s1.26721-12.5137,1.26721-15.8401c0-3.32639-0.63353-7.92001-0.63353-7.92001s-6.50318-2.75297-6.65296-6.96956c-0.59473-6.70875,6.17766-10.4546,6.96973-12.6721,0.79191-2.21755,3.16794-8.87033,3.16794-8.87033s3.48487-6.01923,9.18723-6.96968z'/%3E %3Cpath fill='%23f7c600' d='m897.785,402.988s-15.3648,8.07855-17.5824,8.71208c-2.21765,0.63353-3.64324-2.6928-1.42559-3.32648,2.21765-0.63353,5.70236-0.95045,5.70236-0.95045s-5.22721-4.11839-5.06883-4.27677c0.15853-0.15838,7.12811-2.69265,7.28649-2.69265s2.21765,4.11824,3.64324,3.80148c1.4256-0.31677,5.54399-3.48471,5.54399-3.48471s2.21765,2.53441,1.90074,2.2175z'/%3E %3Cpath d='m919.432,407.423c1.45277,1.87357,2.02077,5.1232,5.34725,3.22246,3.32633-1.90074-1.70401-5.42879-1.70401-5.42879l-3.64324,2.20633z'/%3E %3Cpath d='m925.505,407.106s1.58398,1.26721,3.00957-0.15838-2.85133-4.43516-2.85133-4.43516l-2.05913,2.37604,1.90089,2.2175z'/%3E %3Cpath d='m932.317,216.96c0.15838,0,5.22722,15.6817,5.86074,19.6417,0.63368,3.95995,2.6928,19.8,1.90089,22.0176-0.79206,2.21767-8.87046,12.8304-9.82091,15.5232-0.95044,2.69283-6.65281,12.989-6.65281,12.989s-1.42559,10.1377-2.05927,10.6128c-0.63353,0.47529,1.63531,2.96351,1.42575,3.80162-0.31435,0.9429-4.59369,5.3856-6.49443,4.91046-1.90089-0.4753-4.91046-2.69295-5.06884-4.75207s0.15838-8.87047,1.58397-10.6128c1.4256-1.74236,8.87047-19.3249,9.34562-20.4337,0.47514-1.10884,6.81119-14.8896,6.96957-17.2656,0.15853-2.37605-1.97095-7.87036-4.2111-9.88644-4.98549-14.6729-3.02662-23.5215,7.22082-26.5457z'/%3E %3Cpath fill='%239c5100' d='m895.092,172.199s3.48487,0.47506,5.38561-0.63366c1.90089-1.10873,4.11854-1.58389,5.70251,0.63366,1.58398,2.21756,2.6928,2.05917,2.6928,2.05917s-2.37603,5.86073,0,6.49439c2.37604,0.63367,3.48471,0.63356,3.64325,1.42561,0.15838,0.79206-2.05927,2.53434-1.42574,3.32639,0.63368,0.79206,1.7425,1.74251,1.90088,2.37607,0.15839,0.63356-1.42559,3.32627-0.95044,3.95995,0.4753,0.63366,1.90089,3.16811,2.85118,3.16811,0.95045,0,0.31692,3.96005,3.1681,3.00961s2.6928-3.48489,2.6928-3.48489,3.00957-0.47516,3.80163-3.16801c0.79191-2.69283,2.6928-3.32639,2.6928-3.32639s3.80163-2.05917-1.26721-5.22716c0-22.1761-14.5728-19.8001-14.5728-19.8001s-1.74251-3.96017-4.59369-3.48489-3.00956,3.80179-5.06884,3.48489c-2.05912-0.31688-2.53426-1.74238-2.6928-1.58399-0.15838,0.15839-1.90073,3.32627-1.90073,4.11834,0,0.79204-5.54399-1.10885-5.06884,3.00961,0.47515,4.11845,3.16795,3.96005,3.00956,3.64327z'/%3E %3Cg fill='none'%3E %3Cpath d='m920.753,207.997s-14.0977,9.02885-13.7809,12.1968'/%3E %3Cpath d='m923.921,209.581s-3.16795,3.48477-3.32633,3.48477'/%3E %3Cpath d='m928.198,213.383s-6.96972,5.70244-5.86089,9.34561'/%3E %3Cpath d='m895.251,207.205s-2.05912,4.27673-1.58398,5.70234c0.4753,1.42561,3.96001,6.81128,4.43531,10.1377,0.47515,3.32639,0,5.70246,0,5.70246'/%3E %3Cpath d='m891.608,215.125s0.63353,5.06889,1.58398,6.01922c0.95044,0.95034,3.48486,5.22717,3.80162,6.96956'/%3E %3Cpath d='m890.341,236.192s4.1184,2.05939,7.92002-5.86073'/%3E %3Cpath d='m904.438,224.788c-0.15839,0-3.00957,7.76162,2.05927,10.6128,5.06883,2.85121,8.87046,2.53433,11.088,1.74238,2.21766-0.79194,4.59369-2.21756,4.59369-2.21756'/%3E %3Cpath d='m902.221,234.292s0.31677,10.4546,15.6817,20.7505'/%3E %3Cpath d='m902.854,244.112s-0.15838,9.18712,5.8609,13.3056'/%3E %3Cpath d='m899.686,233.341s-4.59369,13.6223-8.23678,15.048'/%3E %3Cpath d='m898.261,243.32s-0.15838,9.8209-1.42559,13.3057'/%3E %3Cpath d='m895.568,259.002s3.16795,3.96007,6.65281,3.64329c3.48471-0.31678,4.91031-4.43533,7.28634-3.80167,2.37604,0.63367,4.59369,2.53456,10.1377,2.05929'/%3E %3Cpath d='m911.725,265.021s0,8.07839,1.42559,8.87045,0.79206,8.2368,0.79206,8.2368'/%3E %3Cpath d='m892.4,261.22s-0.15838,7.60335-1.10882,10.2961c-0.9503,2.69273-2.85119,7.28645-2.53427,11.2464'/%3E %3Cpath d='m882.737,287.197c0.79191-0.31676,3.48486-2.69265,3.48486-2.69265'/%3E %3Cpath d='m887.648,286.247s-6.81134,29.1458-4.91045,46.5698'/%3E %3Cpath d='m889.232,287.673s-3.48487,21.8593-1.90089,25.9777'/%3E %3Cpath d='m887.489,287.039c0.15838,0,13.3056,0.95029,13.3056,0.95029'/%3E %3Cpath d='m902.696,286.247s3.64324,1.90089,8.71208,1.58397'/%3E %3Cpath d='m901.112,296.86s-0.63368,37.3826-1.58398,45.6194'/%3E %3Cpath d='m920.595,305.413s4.11839,32.7889,6.49443,35.7985'/%3E %3Cpath d='m912.675,309.532s2.53442,28.9873,3.96001,31.5217'/%3E %3Cpath d='m876.718,351.191s4.9103-1.58413,9.34546-6.33605c5.06899,6.81119,12.8305,0.31692,12.8305,0.31692s12.0384,8.23678,17.4242-0.95045c8.23678,5.3856,12.3552-0.79206,12.3552-0.79206s3.00972,4.59354,5.22722,4.11839'/%3E %3Cpath d='m920.753,350.716s6.17767,28.9874,15.3649,37.2242'/%3E %3Cpath d='m888.915,347.706s0.79191,24.2354,2.21751,41.3424'/%3E %3Cpath d='m887.806,375.11s-0.79207,15.84-1.74251,16.9489'/%3E %3Cpath d='m878.46,393.642s1.74236,6.81134,10.4544,0.4753c8.71193-6.3362,8.87032,2.37603,9.18723,3.32633,0.31677,0.95029,1.74236,7.76163,5.06869,2.05927'/%3E %3Cpath d='m910.141,390.158s-1.42559,14.0974,11.088,3.80147c12.5137-10.2959,14.5728-0.15823,14.8896,3.00972'/%3E %3Cpath d='m910.299,166.813s-1.10882,6.96954,6.33605,6.336c-0.95044,3.80167,1.90074,5.0689,1.90074,5.0689'/%3E %3Cpath d='m924.08,182.495c0.15853,0,3.32648,2.05916-0.15838,4.59361'/%3E %3Cpath d='m913.309,188.039s1.58382,1.90089,3.32633,1.42573c1.74236-0.47518,4.59354,1.74239,4.59354,1.74239s2.37603,0.79194,2.6928,0.31678'/%3E %3Cpath d='m903.646,194.058s5.38561,2.05927,8.87047-6.4944'/%3E %3Cpath d='m893.667,185.029,3.1681,0.1584'/%3E %3Cpath d='m858.523,284.924,0.24792,6.94179'/%3E %3Cpath d='m852.013,284.409s4.45059,7.44321,4.0787,11.4099'/%3E %3Cpath stroke-linejoin='round' d='m894.142,188.197,2.85118,0-2.53441,1.10883'/%3E %3Cpath stroke-linejoin='round' d='m911.665,299.962s3.32769-0.34968,3.2229,5.20608c2.12495-6.90163,6.44581-7.0656,6.44581-7.0656'/%3E %3Cpath stroke-width='1.6986' stroke-linejoin='round' d='m898.102,179.327c0.47515,0,2.2175-0.63368,2.53442-0.15839,0.31676,0.47528-1.90089,0.79206-2.53442,0.15839z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='1.8873'%3E %3Cpath fill='%23f7c600' d='m900.299,458.579c66.8976-1.85832,110.102-50.1732,109.638-50.6378-0.4645-0.46458,8.8268-13.4724,16.2599-11.6142,7.4331,1.85832,18.1181,23.6929,31.1259,28.3385,6.5038,10.2204-1.8583,19.5118-4.6457,21.3701-2.7874,1.85831-15.3307,6.96852-17.189-0.46458-1.8581-7.43309-5.5747-6.03935-5.5747-6.03935s-59.4645,58.0707-128.22,55.748c-71.0786,0.46458-129.614-55.748-129.614-55.748l-5.11024,5.57477s-5.57479,6.03937-8.36219,5.57479c-2.78738-0.46458-14.8661-8.3621-15.7952-16.2598-0.92914-7.89767,7.43306-13.0079,7.43306-13.0079s20.4409-15.7954,22.7637-24.1575c4.64566-4.64561,13.4724,3.25189,13.4724,3.25189s53.8897,61.7873,113.819,58.0709z'/%3E %3Cpath d='m748.855,422.646s5.52789-1.4742,7.55478,0.82921c2.0269,2.30327,15.9387,15.9388,15.9387,15.9388'/%3E %3Cpath d='m761.477,429.095-5.52789,4.14587s13.9119,2.76361,10.7794,11.8849'/%3E %3Cpath d='m1052.34,422.185s-2.7641-1.47421-7.0941,1.7505c-4.3303,3.22456-15.294,15.4781-15.294,15.4781'/%3E %3Cpath d='m1039.9,428.727,5.9885,4.60653s-12.5298,0.8292-9.7659,12.7142'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m819.664,437.396c-0.36233,1.05196-1.32124-0.0286-2.1167,0.18281-2.09463,0.0787-3.83438,1.44493-5.62783,2.37754-6.13592,3.57703-12.2718,7.15406-18.4078,10.7311-0.61916-0.20373-0.47224-0.70419-0.32125-1.20622,1.63543-7.66322,3.3341-15.3134,4.92489-22.9858,0.26406-1.34229,0.68917-3.00961-0.60666-3.98662-0.55081-0.37618,0.30172-1.13938,0.65524-0.44562,3.13656,2.23685,6.27311,4.47369,9.40967,6.71054-0.30176,0.88447-0.8363,0.2643-1.3719-0.0946-1.30246-1.25352-2.87297-0.0955-2.83433,1.48783-1.11932,5.05195-2.21088,10.1101-3.31857,15.1646,4.16553-2.47603,8.37867-4.87373,12.5066-7.41174,1.47316-0.65547,2.56043-2.63086,1.02815-3.85506-0.58172-0.34251-1.5433-1.27927-0.58447-1.42187,2.22165,1.58438,4.44331,3.16877,6.66496,4.75315z'/%3E %3Cpath d='m826.275,469.382c-0.16777,0.5721-0.46619,0.69814-0.92215,0.2864-3.69141-2.01877-7.38282-4.03754-11.0742-6.05631,0.16777-0.5721,0.4662-0.69816,0.92216-0.28641,0.99931,0.68068,2.63447,0.93833,3.36348-0.25422,1.46548-2.35102,2.70085-4.83909,4.05889-7.25394,1.8462-3.41959,3.76974-6.79894,5.55943-10.2479,0.85611-1.22152-0.0994-2.72784-1.29719-3.25104-0.40497-0.21691-1.00172-0.37764-0.48962-0.86318,0.2462-0.30433,0.77152,0.34421,1.12983,0.42258,3.53863,1.93522,7.07727,3.87043,10.6159,5.80565-0.16777,0.5721-0.46619,0.69816-0.92215,0.28642-1.001-0.67935-2.64214-0.9398-3.37996,0.24523-1.46544,2.35104-2.70083,4.83909-4.05887,7.25394-1.84621,3.41958-3.76975,6.79893-5.55945,10.2479-0.85548,1.23068,0.0966,2.74667,1.31365,3.26002,0.24676,0.13495,0.49352,0.26991,0.74028,0.40486z'/%3E %3Cpath d='m868.884,459.388c-1.00242,2.8143-2.00484,5.62861-3.00726,8.44291-1.2319-0.13004-0.41252-1.7076-0.79582-2.53896-0.43991-3.80009-3.2427-7.34798-7.06085-8.16085-2.91908-0.79536-6.00002,0.70778-7.71381,3.08201-2.59075,3.5364-4.16561,7.85282-4.38703,12.2348-0.14778,2.49015,0.99504,5.04624,3.16882,6.35708,1.72432,1.13596,3.81745,1.593,5.86414,1.53554,0.72218-2.12904,1.58542-4.21491,2.1873-6.38101,0.24699-1.40888-1.20996-2.26005-2.37507-2.58291-0.18191-0.40867,0.26984-0.91183,0.74426-0.47135,3.67913,1.31047,7.35827,2.62093,11.0374,3.9314-0.13183,1.3581-1.66681-0.10859-2.51672,0.4334-1.35963,0.5218-1.47634,2.15677-1.99174,3.33918-0.44831,1.25866-0.89663,2.51732-1.34495,3.77598-4.94585,0.34999-10.0434-0.69666-14.3476-3.186-4.18483-2.6372-7.01502-7.72851-6.19175-12.7222,0.63731-4.27402,3.30111-8.27732,7.24184-10.1654,3.61966-1.92325,8.03709-1.91584,11.7955-0.3912,2.05559,0.69257,3.82986,1.96318,5.42017,3.40994,0.96375,1.30024,2.82894,1.30279,3.61967-0.17512,0.21785,0.0776,0.43569,0.15518,0.65354,0.23277'/%3E %3Cpath d='m886.836,488.201c-0.0223,0.44877-0.0724,0.85974-0.60997,0.60926-4.21257-0.63812-8.42515-1.27625-12.6377-1.91437,0.0223-0.44877,0.0724-0.85976,0.60998-0.60927,1.09552,0.22381,2.56416,0.20525,3.09269-0.97692,0.53524-1.68791,0.64169-3.47598,0.94965-5.21478,0.72349-4.8563,1.49549-9.70591,2.18624-14.5667,0.26829-1.04778-0.0904-2.23279-1.17512-2.63961-0.6141-0.29133-1.2988-0.33485-1.95936-0.44497,0.0223-0.44877,0.0724-0.85976,0.60997-0.60928,4.21257,0.63813,8.42515,1.27626,12.6377,1.91439-0.0223,0.44877-0.0724,0.85974-0.60998,0.60927-1.1016-0.2267-2.56339-0.19692-3.11123,0.97411-0.53526,1.68791-0.64169,3.47598-0.94966,5.21477-0.72349,4.85631-1.49546,9.70593-2.18623,14.5668-0.26553,1.04485,0.0941,2.25417,1.18531,2.64856,0.61993,0.28179,1.3048,0.32904,1.96771,0.43882z'/%3E %3Cpath d='m920.954,479.914c-0.16674,2.98737-0.33347,5.97475-0.50021,8.96212-7.51522,0.38345-15.0304,0.7669-22.5457,1.15035-0.13786-0.54875,0.009-0.84067,0.60604-0.72557,1.13326,0.0288,2.59279-0.4515,2.73734-1.75192,0.10037-2.22701-0.15016-4.45454-0.22473-6.68127-0.2431-4.44122-0.41871-8.88702-0.70892-13.325,0.12388-1.32148-1.06672-2.30103-2.32047-2.26067-0.39826-0.20163-1.47506,0.4153-1.36759-0.31092-0.18148-0.58815,0.63507-0.2751,0.98049-0.38746,4.18034-0.2133,8.36067-0.42659,12.541-0.63988,0.13785,0.54874-0.009,0.84069-0.60604,0.7256-1.15864-0.006-2.66506,0.27574-2.98562,1.58332-0.18294,1.92668,0.086,3.86449,0.13757,5.79531,0.25424,4.62527,0.43398,9.2557,0.73973,13.8774-0.0938,1.20984,0.87722,2.28029,2.13026,2.04705,1.83023-0.0915,3.69956-0.0136,5.48649-0.47334,2.50745-0.66714,3.8741-3.15018,4.56089-5.46973,0.44973-0.62711,0.0775-2.19165,1.07054-2.10165,0.0896-0.005,0.17929-0.009,0.26893-0.0137'/%3E %3Cpath d='m938.531,458.219c-0.59756,0.0106-0.3343,0.77285-0.48591,1.17286-0.99799,7.4764-1.94375,14.9603-2.97613,22.4318-0.251,1.6554-0.66406,3.58785-2.29741,4.42578-0.60243,0.21391-0.072,1.16167,0.48021,0.63456,2.50975-0.75292,5.01949-1.50585,7.52924-2.25877-0.0947-1.26854-1.54038-0.11599-2.3501-0.33901-1.7273-0.002-1.98401-2.09956-1.7436-3.41099,0.10417-0.88542,0.20833-1.77083,0.3125-2.65625,2.875-0.86458,5.75-1.72917,8.625-2.59375,1.10069,1.38573,2.31391,2.69066,3.30954,4.15271,0.74791,1.41036-1.0692,2.05489-2.12457,2.3273-0.49289,0.0522-0.0627,1.08444,0.38688,0.6048,3.77813-1.13243,7.55627-2.26487,11.3344-3.39731-0.0343-1.28248-1.67666-0.0806-2.36866-0.93623-2.12162-1.59417-3.64389-3.81223-5.39981-5.7751-4.07719-4.79409-8.15438-9.58846-12.2316-14.3824zm-0.0625,8.96875c2.04167,2.4375,4.08333,4.875,6.125,7.3125-2.44792,0.72917-4.89583,1.45833-7.34375,2.1875,0.40625-3.16667,0.8125-6.33333,1.21875-9.5z'/%3E %3Cpath d='m977.1,441.379c1.08619,2.02027,2.17237,4.04053,3.25856,6.0608-1.01376,0.87074-1.54101-1.14943-2.46007-1.45809-1.50628-1.26767-3.77854-1.50742-5.45644-0.43192-0.68677,0.35724-1.36507,0.73053-2.04797,1.09509,3.2768,6.06782,6.50863,12.1606,9.81456,18.2122,0.51183,1.5521,2.41826,1.84313,3.64829,0.96814,0.47558-0.34475,0.90639-0.54064,1.05915,0.18819-1.66296,0.96412-3.48109,1.88159-5.20372,2.82777-2.16967,1.16651-4.33934,2.33303-6.50901,3.49954-0.51117-0.52976-0.16902-0.80293,0.40615-1.00604,1.54289-0.57239,2.13516-2.44512,1.10289-3.76223-3.20609-6.02574-6.4605-12.0261-9.68551-18.042-1.79599,0.99462-4.0898,1.89186-4.54312,4.13133-0.51017,1.40933,0.23983,3.13506,0.2408,4.33405-0.55321,0.57388-0.6986-0.20859-0.9546-0.62321-0.92819-1.7264-1.85638-3.4528-2.78457-5.1792,6.70487-3.60483,13.4097-7.20967,20.1146-10.8145z'/%3E %3Cpath d='m992.351,432.337c2.0776,2.75429,4.1552,5.50857,6.2328,8.26286,1.44515-0.91843,2.65215-2.55983,2.21865-4.35293,0.1665-1.40062-1.83649-2.98786-1.14842-3.96993,0.45322-0.28145,0.72022,0.76715,1.09532,1.04351,2.3726,3.14543,4.7453,6.29085,7.1179,9.43628-0.9284,1.05716-1.6006-1.09804-2.5836-1.33091-1.3865-0.98572-3.3326-1.47708-4.8196-0.39701-1.11024,0.35461-1.05845,0.97758-0.303,1.6619,1.6701,2.15612,3.2205,4.41037,5.003,6.47497,1.091,1.05878,2.448-0.0476,3.3717-0.78331,2.3881-1.6263,4.4849-4.16522,4.362-7.21105,0.1567-1.32908-0.6787-2.81295-0.6701-3.93483,0.5356-0.7123,0.6849,0.39371,0.9923,0.75562,1.122,2.02645,2.244,4.0529,3.366,6.07935-5.8479,4.41112-11.6957,8.82225-17.5436,13.2334-0.76181-0.53919-0.0123-0.85701,0.46753-1.22935,1.63799-1.01232,1.11749-3.07847-0.0879-4.21329-3.74799-4.93642-7.43003-9.92457-11.2263-14.8233-0.97162-1.31754-2.7643-0.62395-3.74511,0.2947-0.40617,0.57713-1.04343-0.5784-0.27209-0.66375,5.51431-4.15951,11.0286-8.31901,16.5429-12.4785,1.5093,2.00085,3.0185,4.0017,4.5278,6.00255-1.0492,1.06371-1.9782-1.30665-3.1748-1.43095-2.17343-1.13109-4.75777-0.21919-6.55386,1.2098-1.07368,0.76459-2.11384,1.57485-3.16929,2.36419'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 180 120'%3E %3Cdefs%3E %3Cg id='s' transform='translate(0,-36)'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-5V0H3z' fill='%23fff' transform='rotate(18,0,-5)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3C/defs%3E %3Cpath d='M0,0H180V120H0z' fill='%23cf142b'/%3E %3Cpath d='M0,0H180V80H0z' fill='%2300247d'/%3E %3Cpath d='M0,0H180V40H0z' fill='%23ffcc00'/%3E %3Cg transform='translate(90,84)'%3E %3Cg id='s4'%3E %3Cg id='s2'%3E %3Cuse xlink:href='%23s' transform='rotate(10)'/%3E %3Cuse xlink:href='%23s' transform='rotate(30)'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='rotate(40)'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' transform='rotate(-80)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 72 48'%3E %3Crect width='72' height='48' fill='%23009e60'/%3E %3Crect width='54' height='48' fill='%23fcd116'/%3E %3Crect width='18' height='48' fill='%230072c6'/%3E %3Cg fill='%23009e60'%3E %3Cpath d='m32,34 4,8 4,-8 -4,-8z'/%3E %3Cpath d='m27,24 4,8 4,-8 -4,-8z'/%3E %3Cpath d='m37,24 4,8 4,-8 -4,-8z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='500' viewBox='0 0 2500 2500'%3E %3Ctitle%3EFlag of Vatican City%3C/title%3E %3Crect width='2500' height='2500' fill='%23fff'/%3E %3Crect width='1250' height='2500' fill='%23ffe000'/%3E %3Cg id='coa' stroke='%23000' stroke-width='3.205' stroke-linejoin='round'%3E %3Cg id='tiara' fill='%23ce9d09' stroke-linecap='round'%3E %3Cg id='band'%3E %3Cpath fill='%23fff' d='m1781.07 990.292l16.1062 3.84122 25.6631 4.16908 11.7604 1.2926-2.0767 49.9158s-2.8084 33.1782-7.6882 48.9616c-3.6176 11.701-15.781 33.1806-15.781 33.1806l-7.6882 11.7346-45.3199-39.2502s7.7255-10.947 10.5207-16.995c3.5074-7.5891 7.6882-23.8739 7.6882-23.8739l4.451-25.897 2.4279-32.776zm-56.9911 151.477l41.2735 36.0131s-8.3454 7.4281-13.3532 9.7114c-9.8241 4.4794-20.7674 7.5168-31.5621 7.2836-7.7283-0.167-15.3195-2.9727-22.3505-6.1856-15.7215-7.1841-33.0314-14.7311-43.1678-28.7322-3.5868-4.9543-5.0026-11.5703-4.8894-17.6856 0.1281-6.9328 6.2807-19.8312 6.2807-19.8312s2.3909 8.636 5.1333 12.0223c4.513 5.5725 11.1176 9.3021 17.5966 12.3749 4.8475 2.2989 10.1441 4.0219 15.4999 4.336 6.9511 0.4078 14.1627-0.6737 20.6367-3.2371 3.3392-1.3222 8.9021-6.0696 8.9021-6.0696z'/%3E %3Cpath fill='%23fff' d='m1658.65 877.67s3.2943 6.60021 4.297 10.1276c1.7151 6.03329 2.9083 12.326 2.8613 18.5981-0.047 6.28734-1.4684 12.5389-3.1474 18.5982-2.5161 9.0802-6.3199 17.7833-10.3005 26.3235-2.5243 5.41581-6.054 10.3236-8.5837 15.7369-4.0792 8.72864-6.9937 17.956-10.5867 26.8957-2.9986 7.46093-6.8645 14.6102-9.156 22.3178-3.0437 10.2378-4.5617 20.8914-6.0086 31.4738-1.2447 9.103-2.2289 18.2805-2.289 27.468-0.071 10.8993 0.257 21.9099 2.289 32.6182 2.0132 10.6096 4.9766 21.2042 9.7283 30.9015 3.8299 7.8163 8.9314 15.1035 14.8784 21.4595 4.9155 5.2533 10.7063 9.7565 16.8814 13.4478 5.6111 3.3542 11.951 5.3107 18.0259 7.7254 8.392 3.3358 25.4328 9.3354 25.4328 9.3354s-23.527-11.5926-31.7275-21.3526c-6.7839-8.0741-10.5208-18.6192-12.8756-28.8986-2.7273-11.9056-2.3831-24.473-1.1445-36.6239 1.3326-13.0719 5.1794-25.8174 9.156-38.3408 4.1968-13.2172 10.0958-25.835 15.4508-38.6268 3.8591-9.2188 8.276-18.2009 12.0172-27.4681 4.4171-10.9412 8.7643-21.9345 12.3034-33.1905 2.1584-6.86471 4.8495-13.7214 5.4303-20.894 0.6311-7.79253-0.3834-15.7424-2.1702-23.3535-2.5031-10.6626-5.5983-21.6488-11.8358-30.6517-3.7541-5.41848-8.8987-10.1529-14.7694-13.1509-5.7326-2.92745-12.5435-5.40098-18.8584-4.1538-2.1092 0.41656-5.2985 3.6779-5.2985 3.6779z'/%3E %3Cpath fill='%23fff' d='m1711.59 945.594s4.4543-17.9908 5.2084-27.1872c0.6452-7.8667 0.2242-15.8223-0.6069-23.6716-0.9248-8.73396-1.4686-17.7937-4.8557-25.897-3.5136-8.40592-9.0243-16.1296-15.5787-22.4577-6.46-6.23687-14.2939-11.3052-22.6599-14.5671-8.8012-3.43152-18.4915-4.27873-27.9203-4.8557-8.0878-0.49492-16.2402 0.19161-24.2785 1.21393-4.6447 0.59072-9.3229 1.33124-13.7578 2.8325-4.1142 1.39268-11.7346 5.66498-11.7346 5.66498l29.9434 48.9616s9.3726-5.51792 14.5671-6.8789c5.494-1.43944 11.3253-1.54575 16.995-1.21393 5.757 0.33691 11.7257 0.89368 16.9949 3.23714 6.7067 2.98278 12.4901 7.98381 17.5468 13.3041 6.1021 6.41995 11.5485 13.7867 14.9589 21.9611 3.1668 7.59027 3.5823 16.072 4.7213 24.2172 0.2473 1.76811 0.4565 5.33646 0.4565 5.33646z'/%3E %3Cpath d='m1717.05 906.676s-5.3336-16.5594-10.3697-23.474c-5.8495-8.03107-13.3653-15.3911-22.2554-19.8275-9.4283-4.70495-30.9939-6.21691-30.9939-6.21691l11.4135 21.1281-19.9659-0.48705-10.4269-17.4343-19.2319 8.7057-9.5679-15.6448 20.4311-9.47347-9.4144-15.1852 20.4231-1.9427 8.8924 14.7s15.8737 0.0481 23.5878 1.66764c5.2383 1.09979 10.3852 2.90955 15.1204 5.40504 4.5315 2.38821 8.6981 5.52167 12.4464 9.01294 4.5081 4.199 8.7319 8.8641 11.8742 14.1632 3.0537 5.14968 6.5418 16.7274 6.5418 16.7274z'/%3E %3Cpath d='m1581.65 845.092l31.8993 46.5923m-17.9701-54.7363l-15.0315 8.78851-14.3063 10.8728 30.9015 47.2106 13.734-10.5866 14.1198-8.18363z'/%3E %3Cpath d='m1653.79 1035.87l17.8828-36.9101 19.1392 7.6135 7.7552-19.059-19.026-8.86935 9.8713-21.3164-14.0201-6.29475-10.5867 20.4578-19.1933-8.02412-8.4281 19.9631 18.6084 7.80376-17.1675 36.6241z'/%3E %3Cpath d='m1796.92 1024.83l18.2088-0.4047v21.0414l17.5333 0.8317-2.9826 21.3575-16.3572-1.0293s-2.6981 12.5748-5.1215 18.4951c-2.5132 6.1396-9.6623 17.3995-9.6623 17.3995l-19.4228-4.8557s7.0265-11.0483 9.7114-16.995c2.4047-5.3259 5.665-16.5903 5.665-16.5903l-19.9387-2.5165 3.4705-20.1921 18.0868 1.2625z'/%3E %3C/g%3E %3Cuse xlink:href='%23band' transform='matrix(-1,0,0,1,3717.75,0)'/%3E %3Cpath fill='%23fff' d='m1756.66 735.602l-27.4199 29.4458 16.8814 50.9303 9.6654 35.7948-27.723 25.8264 50.7288 71.0499-17.3653 19.8177c-1.8179 2.32887-2.4559 5.66203-2.1441 8.59991 0.2858 2.69342 1.5814 5.46434 3.5766 7.29618 4.5597 4.18658 11.3282 5.13314 17.3106 6.72397 21.0652 5.60173 42.9277 8.10234 64.6643 9.72824 4.6678 0.3492 14.0426 0 14.0426 0s9.3574 0.3505 14.0426 0c21.7366-1.62587 43.5991-4.12651 64.6643-9.72824 5.9824-1.59083 12.7509-2.53739 17.3106-6.72397 1.9952-1.83184 3.2908-4.60276 3.5766-7.29618 0.3118-2.93788-0.3262-6.27104-2.1441-8.59991l-16.3019-35.876 51.819-55.5208-19.7758-17.8337-0.4354-43.2583 16.8814-50.9303-25.4118-25.7241-22.9434-61.258s-4.8005-17.0806-8.8699-24.8929c-2.433-4.67074-5.832-8.79081-9.156-12.8757-3.9828-4.89437-8.0012-9.86994-12.8757-13.8771-4.4164-3.63059-9.5357-6.34555-14.5924-9.01295-5.4329-2.86583-10.8919-5.95625-16.8444-7.47197-6.1395-1.56334-18.9437-1.54098-18.9437-1.54098s-12.7871-0.026-18.9437 1.54098c-5.9526 1.51506-11.4115 4.60614-16.8444 7.47197-5.0567 2.6674-10.176 5.38236-14.5924 9.01295-4.8745 4.00714-8.8929 8.98271-12.8757 13.8771-3.324 4.08485-6.723 8.20492-9.156 12.8757-4.0694 7.81233-8.8699 24.8929-8.8699 24.8929z'/%3E %3Cpath d='m1963.27 933.128s-3.1773-2.84544-4.9603-3.99962c-3.7472-2.4257-7.7685-4.47267-11.9369-6.06964-5.6064-2.14787-11.5532-3.28842-17.3997-4.65339-6.6974-1.56366-13.4146-3.13944-20.2321-4.04642-7.9733-1.06074-16.0331-1.53775-24.0762-1.61857-8.6068-0.0865-25.7932 1.21392-25.7932 1.21392s-17.1689-1.30099-25.7932-1.21392c-8.0431 0.0812-16.1029 0.55783-24.0762 1.61857-6.8175 0.90698-13.5347 2.48276-20.2321 4.04642-5.8465 1.36497-11.7933 2.50552-17.3997 4.65339-4.1684 1.59697-8.1897 3.64394-11.9369 6.06964-1.783 1.15418-4.9603 3.99962-4.9603 3.99962m218.711-42.6925s-5.1828-5.26865-8.6021-5.91895c-2.2098-0.42027-4.7416 0.21473-6.5754 1.51741-2.372 1.68499-3.9554 4.56016-4.6534 7.38473-0.6248 2.52827-0.3529 5.36837 0.6069 7.78937 0.8132 2.05124 2.0996 4.33782 4.1476 5.15919 4.8004 1.92528 15.3837-2.02435 15.3837-2.02435zm5.1557-3.59224c5.8013 0.17064 7.9138 3.10789 9.4541 6.47428m-243.23-2.882l-0.3074 13.9074s10.5833 3.94958 15.3837 2.02435c2.048-0.82135 3.3344-3.10795 4.1476-5.15919 0.9598-2.421 1.2317-5.2611 0.6069-7.78937-0.698-2.82457-2.2814-5.69974-4.6534-7.38473-1.8338-1.30268-4.3681-1.95069-6.5754-1.51741-3.4449 0.67621-8.602 5.91895-8.602 5.91895zm-5.1558-3.59224c-5.8013 0.17064-7.9138 3.10789-9.4541 6.47428m198.167 1.34599l-8.4468-0.94606m-130.044 0.94606l8.4468-0.94606m75.9916 0.81471c-2.8651-0.42255-7.6006-4.2094-7.6006-4.2094m-22.7856 4.2094c2.8651-0.42255 7.6006-4.2094 7.6006-4.2094m140.936-19.3466s-4.2156 3.34715-7.2851 3.85745l-1.211 0.6445s-1.9472 5.72805-3.6621 8.17385c-1.7189 2.45145-6.4648 6.25-6.4648 6.25s-4.787-4.14415-7.7442-4.9512c-1.9395-0.52925-4.1634-0.54345-6.0253 0.21485-1.9759 0.8047-3.5479 2.53495-4.7364 4.30665-1.4037 2.09245-2.7058 4.58275-2.5879 7.0996 0.1411 3.01385 3.877 8.1836 3.877 8.1836l-2.5781 4.51175-3.6621 2.373c-6.3145-1.9131-12.631-3.93545-18.9454-7.53905-1.7321-1.88775-3.3581-4.30185-4.5214-9.0332 0 0 4.5436-2.69345 5.5957-4.95115 1.1824-2.5374 1.6683-6.00595 0.2148-8.39845-1.6161-2.66045-5.2762-4.0421-8.3887-4.0918-2.2801-0.0364-4.6888 1.14055-6.25 2.80275-1.6788 1.7875-2.9748 4.46475-2.5781 6.88475 0.4042 2.4662 4.7363 5.81055 4.7363 5.81055s-1.8003 4.55785-3.8379 5.4297c-6.0115 2.57205-9.9784 4.0405-15.2441 4.8535-5.2104 0.80445-11.0723 1.4648-16.2988-0.0195-3.376-0.95875-6.845-2.7304-8.9649-5.5273-0.6311-0.83265-0.8593-3.00785-0.8593-3.00785s6.4664-1.67915 9.0429-3.6621c2.5589-1.9694 5.2823-4.56845 5.8106-7.7539 0.531-3.20115-1.1709-6.58965-3.0176-9.2578-1.8303-2.6446-4.582-4.73805-7.5293-6.0254-1.3298-0.5809-4.3066-0.64455-4.3066-0.64455s-0.6294 0.5709-0.9375 0.8594c-1.2438 1.59805-2.9535 2.8626-4.7657 3.8086-0.032 0.0185-0.076 0.0508-0.1074 0.0684-0.044 0.0245-0.1285 0.0438-0.1758 0.0684-0.3793 0.18905-0.7491 0.41-1.1328 0.5664-0.1998 0.0815-0.51 0.0933-0.7422 0.15625-1.269 0.42885-2.4707 0.78125-2.4707 0.78125s3.8635 1.19585 4.9512 2.7344c0.6719 0.95035 0.9629 2.10935 1.084 3.31055 0.1485 0.7129 0.2344 1.43385 0.2051 2.1289-0.047 1.10925-0.3223 2.23315-0.7032 3.33005-0.3486 1.27815-0.8392 2.5073-1.6699 3.4961-0.4512 0.53715-1.0035 0.98495-1.5918 1.38675-0.028 0.0227-0.049 0.0558-0.078 0.0781-0.03 0.0231-0.086 0.0362-0.1172 0.0586-1.0379 0.67075-2.2093 1.1684-3.3789 1.49415-1.3714 0.3819-4.186 0.0793-4.2871 0.0684 0.1034 0.0002 5.51-0.01 7.666-1.5625 0.067-0.0431 0.1299-0.092 0.1953-0.1367 1.5102-1.205 2.5998-2.97625 3.2617-4.88285 0.2091-0.7666 0.415-1.54335 0.4883-2.31445 0.096-1.01385 0.1157-2.0935 0.01-3.1445-0.3302-1.5845-1.0609-3.1235-2.2168-4.1504-2.4174-2.1477-9.3244-2.40865-9.4141-2.4121-0.1069 0.004-6.99 0.2671-9.4043 2.4121-1.1559 1.0269-1.8866 2.5659-2.2168 4.1504-0.1059 1.051-0.087 2.13065 0.01 3.1445 0.073 0.7711 0.2792 1.54785 0.4883 2.31445 0.6619 1.9066 1.7515 3.67785 3.2617 4.88285 0.065 0.0447 0.1286 0.0936 0.1953 0.1367 2.1559 1.5529 7.5623 1.5627 7.666 1.5625-0.1011 0.0109-2.9156 0.31355-4.2871-0.0684-1.1696-0.32575-2.341-0.8234-3.3789-1.49415-0.031-0.0224-0.087-0.0355-0.1172-0.0586-0.029-0.0223-0.05-0.0554-0.078-0.0781-0.5883-0.4018-1.1406-0.8496-1.5918-1.38675-0.8306-0.9888-1.3213-2.21795-1.6699-3.4961-0.3809-1.0969-0.6563-2.2208-0.7031-3.33005-0.029-0.69505 0.057-1.416 0.205-2.1289 0.1211-1.2012 0.4219-2.3602 1.0938-3.31055 1.0878-1.53855 4.9414-2.7344 4.9414-2.7344s-1.2009-0.352-2.4707-0.78125c-0.2299-0.0625-0.5344-0.0755-0.7324-0.15625-0.3891-0.15855-0.7679-0.38405-1.1524-0.57615-0.042-0.0218-0.1172-0.0368-0.1562-0.0586-0.026-0.0145-0.062-0.0435-0.088-0.0586-1.8212-0.94695-3.5456-2.2132-4.7949-3.81835-0.3082-0.2885-0.9375-0.8594-0.9375-0.8594s-2.967 0.0637-4.2969 0.64455c-2.9473 1.28735-5.7088 3.3808-7.5391 6.0254-1.8467 2.66815-3.5486 6.05665-3.0176 9.2578 0.5283 3.18545 3.2615 5.7845 5.8204 7.7539 2.5765 1.98295 9.0332 3.6621 9.0332 3.6621s-0.2283 2.1752-0.8594 3.00785c-2.1199 2.7969-5.5889 4.56855-8.9649 5.5273-5.2265 1.48435-11.0884 0.824-16.2988 0.0195-5.2657-0.813-9.2326-2.28145-15.2441-4.8535-2.0376-0.87185-3.8379-5.4297-3.8379-5.4297s4.3321-3.34435 4.7363-5.81055c0.3967-2.42-0.8993-5.09725-2.5781-6.88475-1.5612-1.6622-3.9602-2.83915-6.2403-2.80275-3.1125 0.0497-6.7823 1.43135-8.3984 4.0918-1.4535 2.3925-0.9675 5.86105 0.2149 8.39845 1.0521 2.2577 5.5957 4.95115 5.5957 4.95115-1.1633 4.73135-2.7894 7.14545-4.5215 9.0332-6.3144 3.6036-12.6308 5.62595-18.9453 7.53905l-3.6524-2.373-2.5879-4.51175s3.7359-5.16975 3.877-8.1836c0.1179-2.51685-1.1842-5.00715-2.5879-7.0996-1.1885-1.7717-2.7604-3.50195-4.7363-4.30665-1.8619-0.7583-4.0859-0.7441-6.0254-0.21485-2.9572 0.80705-7.7442 4.9512-7.7442 4.9512s-4.7459-3.79855-6.4648-6.25c-1.7149-2.4458-3.6524-8.17385-3.6524-8.17385l-1.2109-0.6445c-3.0703-0.50455-7.2949-3.85745-7.2949-3.85745l-4.4434 0.9375s-4.1014 2.19525-4.1504 4.1504c-0.067 2.70015 3.7256 3.9183 5.4395 6.00585 1.4706 1.7913 2.8406 3.6673 4.1406 5.58595 1.225 1.80785 2.8428 3.47495 3.4375 5.57615 0.6494 2.29425-0.9739 4.97205 0 7.14845 1.2278 2.74365 3.7734 5.4157 6.7188 6.01565 2.6155 0.53275 7.5879-2.57815 7.5879-2.57815l-0.1465 19.8828 10.3027 9.30665 9.7266 20.3125-3.8575 5.1465 1.1426 10c7.4813-9.58415 20.5018-13.7912 32.1875-17.1484 15.7316-4.5196 44.5698-4.8416 58.0078-4.7168 4.4794 0.0416 7.2559 0.13675 7.2559 0.13675s44.2954-1.44185 65.2539 4.58005c11.6856 3.3576 24.7062 7.5643 32.1875 17.1484l1.1426-10-3.8574-5.1465 9.7265-20.3125 10.3028-9.30665-0.1465-19.8828s4.9724 3.1109 7.5879 2.57815c2.9454-0.59995 5.4909-3.272 6.7187-6.01565 0.9739-2.1764-0.6494-4.8542 0-7.14845 0.5947-2.1012 2.2125-3.7683 3.4375-5.57615 1.3-1.91865 2.6798-3.79465 4.1504-5.58595 1.7139-2.08755 5.4967-3.3057 5.4297-6.00585-0.049-1.95515-4.1504-4.1504-4.1504-4.1504l-4.4434-0.9375zm-148.33-2.6074c1.0489 0.98195 3.1026 2.8469 4.7949 3.81835 0.08 0.0418 0.1633 0.0768 0.2441 0.1172 0.5048 0.26415 1.2018 0.50155 1.8848 0.7324 2.913 0.7925 7.9353 0.26675 8.0469 0.2539h0.01 0.02c0.1114 0.0128 5.1327 0.53605 8.0468-0.2539 0.6767-0.22865 1.3711-0.46095 1.875-0.72265 0.094-0.047 0.1896-0.0878 0.2832-0.1367 1.692-0.9767 3.7202-2.82985 4.7657-3.8086 0.5223-0.6711 0.9659-1.39145 1.2988-2.1582 1.1552-2.6608 1.1017-6.11155-0.2051-8.7012-1.5377-3.0469-5.1755-4.49675-8.0859-6.2793-2.5063-1.53495-7.9125-3.72505-7.9981-3.75975-0.1 0.0405-5.4757 2.22685-7.9785 3.75975-2.9104 1.78255-6.558 3.2324-8.0957 6.2793-1.3068 2.58965-1.3603 6.0404-0.2051 8.7012 0.3329 0.76675 0.7765 1.4871 1.2989 2.1582z'/%3E %3Cpath d='m1980.77 829.789s-10.8864-5.06097-16.5904-6.87893c-10.4126-3.31869-21.2354-5.21582-31.9667-7.28356-12.4669-2.40215-25.2596-3.0515-37.6221-5.94324-3.8919-0.91037-7.5305-2.76907-11.445-3.57657-5.4002-1.11395-11.0611-2.8737-16.4523-1.71675-2.9678 0.6369-7.8193 4.578-7.8193 4.578s-4.8672-3.93997-7.8193-4.578c-5.3894-1.16479-11.0521 0.6028-16.4523 1.71675-3.9145 0.8075-7.5531 2.6662-11.445 3.57657-12.3625 2.89174-25.1552 3.54109-37.6221 5.94324-10.7313 2.06774-21.5541 3.96487-31.9667 7.28356-5.704 1.81796-16.5904 6.87893-16.5904 6.87893m197.457-45.1211s5.3501-2.82415 7.2852-5.05855c1.2834-1.48195 2.5069-3.2978 2.6367-5.25395 0.1511-2.277-0.6209-4.853-2.2266-6.4746-1.5608-1.57635-4.061-2.21855-6.2793-2.22655-1.8556-0.006-3.842 0.6124-5.2539 1.8164-1.63 1.39005-2.7809 3.5372-3.0371 5.66405-0.2186 1.81445 0.5096 3.6987 1.3672 5.3125 1.3002 2.44695 5.5078 6.2207 5.5078 6.2207zm-151.123 0s4.2076-3.77375 5.5078-6.2207c0.8576-1.6138 1.5858-3.49805 1.3672-5.3125-0.2562-2.12685-1.4071-4.274-3.0371-5.66405-1.4119-1.204-3.3983-1.8224-5.2539-1.8164-2.2183 0.008-4.7088 0.6502-6.2696 2.22655-1.6057 1.6216-2.3776 4.1976-2.2265 6.4746 0.1298 1.95615 1.3435 3.772 2.6269 5.25395 1.9351 2.2344 7.2852 5.05855 7.2852 5.05855zm-41.0742 18.0078l-11.9336 15.5762s-0.084 4.10895 0.8105 5.86915c1.2312 2.4238 5.8594 5.66405 5.8594 5.66405l0.8496 21.3868-11.3086 19.5996-0.9863 0.20505 7.2949 3.85745c0.342 0.0562 0.6808 0.11165 0.9863 0.0879 4.3781-0.34225 7.0688-5.2579 10.8789-7.44145 4.8491-2.779 10.0115-4.98805 15.1661-7.1484 7.1244-2.9859 14.3588-5.7335 21.7382-8.0176 9.3031-2.87955 18.6911-5.75975 28.3301-7.14845 7.298-1.0514 14.7122-1.54535 22.0996-1.4453 2.4625 0.0333 4.9209 0.12695 7.3731 0.29295 6.5689 0.44475 19.3704 3.40415 19.4726 3.42775 0.086-0.0198 12.9093-2.9827 19.4824-3.42775 9.8085-0.66405 19.7421-0.2495 29.4727 1.15235 9.639 1.3887 19.027 4.2689 28.3301 7.14845 7.3794 2.2841 14.6139 5.0317 21.7383 8.0176 5.1546 2.16035 10.3169 4.3694 15.166 7.1484 3.8101 2.18355 6.5008 7.0992 10.8789 7.44145 0.3085 0.024 0.6505-0.0304 0.9961-0.0879l7.2851-3.85745-0.9863-0.20505-11.3086-19.5996 0.8496-21.3868s4.638-3.24025 5.8692-5.66405c0.8943-1.7602 0.8007-5.86915 0.8007-5.86915l-11.9335-15.5762c-0.0001 0-6.0157 6.00765-9.9122 7.28515-2.0507 0.67235-4.4136 0.6401-6.4746 0-2.501-0.7768-4.4344-2.81105-6.4746-4.45315-4.6088-3.70965-9.2257-7.54105-12.9492-12.1386-2.1328-2.6335-5.2637-8.7012-5.2637-8.7012s-12.9078 10.1416-20.6347 12.1387c-7.5767 1.95835-15.96 1.6057-23.4668-0.6055-1.8839-0.5549-5.0293-3.0664-5.0293-3.0664-8.8263-5.6214-17.652-8.69745-26.4258-7.85155-8.7738-0.8459-17.5995 2.23015-26.4258 7.85155 0 0-3.1552 2.5115-5.0391 3.0664-7.5068 2.2112-15.89 2.56385-23.4667 0.6055-7.727-1.99715-20.6348-12.1387-20.6348-12.1387s-3.1309 6.0677-5.2637 8.7012c-3.7235 4.5976-8.3404 8.429-12.9492 12.1386-2.0402 1.6421-3.9736 3.67635-6.4746 4.45315-2.061 0.6401-4.4239 0.67235-6.4746 0-3.8965-1.2775-9.9121-7.28515-9.9121-7.28515z'/%3E %3Cpath d='m1985.89 796.364s0.4479-5.70292-0.1618-8.45505c-0.5584-2.5204-1.694-4.94002-3.136-7.08123-1.5129-2.2464-5.6473-5.84156-5.6473-5.84156m-1.4343 27.6901c-0.0001 0 3.3941 0.1231 4.8535-0.6055 2.6029-1.2996 6.0742-6.2695 6.0742-6.2695s6.6614 4.60745 10.3125 4.04295c1.8007-0.2784 3.2946-1.88475 4.248-3.4375 1.0106-1.6457 1.6515-3.78155 1.2207-5.66405-0.3431-1.49915-1.6576-2.6497-2.832-3.6426-2.2813-1.92865-6.3955-1.66185-7.8906-4.24805-1.1818-2.04435-0.4569-4.8105 0.1953-7.08005 1.3607-4.7357 4.7512-8.64825 7.4902-12.7442 1.7395-2.60125 5.2931-4.38305 5.6641-7.49025 0.2006-1.67945-2.0215-4.6582-2.0215-4.6582s-5.2216-0.11815-7.6855 0.61525c-4.0775 1.21385-8.3071 2.99495-11.2012 6.11325-2.4056 2.5919-3.1206 6.36555-4.3848 9.668-0.9609 2.50985-2.4219 7.68555-2.4219 7.68555s-6.0411-0.013-8.7011 1.21095c-3.5158 1.6175-7.1107 4.1574-8.7012 7.6855-1.2473 2.7667-1.0733 6.27265 0 9.11135 1.0815 2.86035 3.4928 5.23565 6.0742 6.875 2.8465 1.80775 9.7071 2.83205 9.7071 2.83205zm-234.71-27.69s-4.1344 3.59516-5.6473 5.84156c-1.442 2.14121-2.5776 4.56083-3.136 7.08123-0.6097 2.75213-0.1618 8.45505-0.1618 8.45505m-16.9364-45.4847s-2.2221 2.97875-2.0215 4.6582c0.371 3.1072 3.9246 4.889 5.6641 7.49025 2.739 4.0959 6.1295 8.00845 7.4902 12.7442 0.6522 2.26955 1.3771 5.0357 0.1953 7.08005-1.4951 2.5862-5.6093 2.3194-7.8906 4.24805-1.1744 0.9929-2.4889 2.14345-2.832 3.6426-0.4308 1.8825 0.2101 4.01835 1.2207 5.66405 0.9534 1.55275 2.4473 3.1591 4.248 3.4375 3.6511 0.5645 10.3125-4.04295 10.3125-4.04295s3.4713 4.9699 6.0743 6.2695c1.4594 0.7286 4.8535 0.6055 4.8535 0.6055s6.8703-1.0243 9.7168-2.83205c2.5814-1.63935 4.9829-4.01465 6.0644-6.875 1.0733-2.8387 1.2473-6.34465 0-9.11135-1.5905-3.5281-5.1854-6.068-8.7012-7.6855-2.66-1.22395-8.7011-1.21095-8.7011-1.21095s-1.461-5.1757-2.4219-7.68555c-1.2642-3.30245-1.9792-7.0761-4.3848-9.668-2.8941-3.1183-7.1236-4.8994-11.2011-6.11325-2.4639-0.7334-7.6856-0.61525-7.6856-0.61525zm135.626 14.3174l8.3246-2.43757 8.3246 2.43757m-14.4926 20.0821s-6.481-5.90993-7.6882-9.91375c-0.5271-1.74815-0.45-3.84915 0.4046-5.46267 1.1684-2.20587 5.8673-4.65339 5.8673-4.65339s-7.0852-3.44282-8.9021-6.67661c-1.0288-1.83119-1.1579-4.24509-0.607-6.27195 0.8741-3.21533 3.2994-5.96975 5.8673-8.09287 3.185-2.63316 11.2261-5.26034 11.2261-5.26034s8.0266 2.61995 11.2261 5.26034c2.5698 2.12081 4.9932 4.87754 5.8673 8.09287 0.5509 2.02686 0.4218 4.44076-0.607 6.27195-1.8169 3.23379-8.9021 6.67661-8.9021 6.67661s4.6989 2.44752 5.8673 4.65339c0.8546 1.61352 0.9317 3.71452 0.4046 5.46267-1.2072 4.00382-7.6882 9.91375-7.6882 9.91375l-6.168 0.40463zm22.6719-26.8875s13.4369 5.72681 17.9891 11.1064c1.2701 1.50095 2.3519 3.50054 2.2255 5.46267-0.4485 6.96199-10.3184 18.2089-10.3184 18.2089l-19.9282-8.28243h-12.9438l-19.9282 8.28243s-9.8699-11.2469-10.3184-18.2089c-0.1264-1.96213 0.9554-3.96172 2.2255-5.46267 4.5522-5.37958 17.9891-11.1064 17.9891-11.1064'/%3E %3Cpath d='m1844.36 669.248l8.0562-6.20056 6.5065 0.13988-6.6557-0.14309s-3.591-2.44764-4.578-4.29188c-0.958-1.79023-1.4152-4.02072-1.0015-6.00863 0.5525-2.65484 2.0852-5.45855 4.4277-6.82475 2.2371-1.30479 7.7551-0.47145 7.7551-0.47145s5.5027-0.84166 7.7551 0.47145c2.3428 1.36572 3.8752 4.16991 4.4277 6.82475 0.4137 1.98791-0.043 4.2184-1.0015 6.00863-0.987 1.84424-4.578 4.29188-4.578 4.29188l-6.6557 0.14309 6.5065-0.13988 8.0562 6.20056m52.5845 5.06845l-2.6798 4.65503m32.6326-20.0046l-7.5149 0.98202m8.513 8.80375l-11.5169 0.60428m-1.4979-13.7479c1.4677 0.93659 4.1545 2.86005 4.5946 4.63497 0.7761 3.12938-0.6743 7.07048-3.1391 9.14891-2.3885 2.01406-9.252 1.50107-9.252 1.50107m-181.69 33.5875s11.2946-2.8202 16.9546-4.17785c8.0811-1.93833 16.0993-4.19579 24.2786-5.665 9.2622-1.66374 18.6201-2.88431 28.0067-3.55413 11.7104-0.83564 35.2159-0.57225 35.2159-0.57225s23.488-0.26449 35.2159 0.57225c9.3866 0.66969 18.7445 1.89039 28.0067 3.55413 8.1793 1.46921 16.1975 3.72667 24.2786 5.665 5.66 1.35765 16.9546 4.17785 16.9546 4.17785m-171.551-30.1651l2.6798 4.65503m-32.6326-20.0046l7.5149 0.98202m-8.513 8.80375l11.5169 0.60428m-6.4754 16.0764s12.5425-3.18763 18.8753-4.50628c6.9234-1.44166 13.8728-2.81916 20.8871-3.71964 8.0675-1.03566 16.1997-1.55541 24.3248-1.92859 9.6296-0.44228 28.917-0.36651 28.917-0.36651s19.2699-0.0764 28.917 0.36651c8.1252 0.37308 16.2573 0.89293 24.3248 1.92859 7.0143 0.90048 13.9637 2.27798 20.8871 3.71964 6.3328 1.31865 18.8753 4.50628 18.8753 4.50628m-170.239-14.5393s-6.8635 0.51299-9.252-1.50107c-2.4648-2.07843-3.9152-6.01953-3.1391-9.14891 0.6108-2.46349 5.5498-5.21314 5.5498-5.21314m63.1382 74.0024c-11.9767 0.7232-24.0098 1.474-35.8108 3.6418-12.2927 2.25809-24.4854 5.39728-36.2155 9.71141-11.113 4.08716-22.8689 22.6434-32.0955 15.2222-1.983-1.59501 0.7525-5.08407 1.7168-7.43927 1.8655-4.55651 4.429-8.93224 7.7254-12.5895 2.4138-2.67809 7.9759-3.02712 8.5837-6.58089 0.4416-2.58142-3.4743-4.09285-4.2918-6.58088-1.0439-3.17647-1.5387-6.81352-0.5723-10.0144 1.2405-4.10872 6.5254-6.17981 7.7254-10.3005 1.043-3.58184-2.5475-7.83256-0.8584-11.1589 2.133-4.20065 11.3369-2.77746 12.0173-7.43927 0.3317-2.27285-3.8251-2.9802-4.578-5.15025-0.5324-1.53446 0.3091-3.24011 0.2861-4.86414-0.031-2.20169 0.392-4.60137-0.5723-6.58088-0.857-1.7593-3.702-2.13985-4.2918-4.00576-0.5582-1.76572-0.1716-4.13356 1.1445-5.43639 1.0368-1.02642 3.6319 0.44281 4.2918-0.85837 1.3318-2.62589-2.5388-5.31434-3.7196-8.01151-1.4064-3.21256-3.2072-6.31351-4.0057-9.72827-0.6313-2.69961-2.9585-6.88614-0.5723-8.29764 2.7325-1.61631 5.4768 3.23869 8.0115 5.15025 3.3453 2.52289 7.1094 4.81707 9.4422 8.29764 1.6831 2.51135 0.7428 6.50932 2.9483 8.57708 2.6468 2.48143 7.7583 0.49134 10.4996 2.86794 2.3561 2.04271 4.4414 5.55009 3.7196 8.58376-0.6897 2.89871-7.5314 2.81792-6.867 5.72252 0.7892 3.45006 6.8133 3.17917 10.3005 2.57514 2.033-0.35214 3.4624-2.24683 5.1503-3.43351 1.3108-0.92157 2.389-2.23216 3.8627-2.86127 1.6908-0.72182 5.4363-0.9299 5.4363-0.9299l-2.1459-0.50072s-3.1717-2.52782-3.505-4.36342c-0.3139-1.72858 0.4369-3.73179 1.6452-5.00719 1.3551-1.43043 3.5376-2.16034 5.5079-2.14594 1.6471 0.0118 3.4459 0.66342 4.578 1.85981 1.1609 1.22684 1.8244 3.11308 1.6452 4.7926-0.1565 1.46787-1.1275 2.87998-2.289 3.79116-1.2578 0.98685-4.578 1.43063-4.578 1.43063l2.289 0.64379 6.1517 8.4407 26.5387-1.45409s3.2734-3.3392 2.6302-5.1592c-0.6891-1.94976-2.503-2.66777-5.665-2.52901-8.5812 0.37659-10.3395-6.82843-10.015-12.0381 0.27-4.33353 5.4839-7.27436 9.5092-8.90214 3.8768-1.56776 10.7873 3.59271 12.5439-0.20233 1.5397-3.32652-5.8181-5.02096-6.9801-8.49749-0.5029-1.50446-0.5077-3.33604 0.2023-4.75454 1.8128-3.62158 5.7132-6.02963 9.408-7.68822 1.5569-0.69888 5.0552-0.80928 5.0552-0.80928s3.4821 0.10463 5.0552 0.80928c3.6961 1.65563 7.5952 4.06664 9.408 7.68822 0.71 1.4185 0.7052 3.25008 0.2023 4.75454-1.162 3.47653-8.5198 5.17097-6.9801 8.49749 1.7566 3.79504 8.6671-1.36543 12.5439 0.20233 4.0253 1.62778 9.2392 4.56861 9.5092 8.90214 0.3245 5.20968-1.4338 12.4147-10.015 12.0381-3.162-0.13876-4.9759 0.57925-5.665 2.52901-0.6432 1.82 2.6302 5.1592 2.6302 5.1592l26.5387 1.45409 6.1517-8.4407 2.289-0.64379s-3.3202-0.44378-4.578-1.43063c-1.1615-0.91118-2.1325-2.32329-2.289-3.79116-0.1792-1.67952 0.4843-3.56576 1.6452-4.7926 1.1321-1.19639 2.9309-1.84798 4.578-1.85981 1.9703-0.0144 4.1528 0.71551 5.5079 2.14594 1.2083 1.2754 1.9591 3.27861 1.6452 5.00719-0.3333 1.8356-3.505 4.36342-3.505 4.36342l-2.1459 0.50072s3.7455 0.20808 5.4363 0.9299c1.4737 0.62911 2.5519 1.9397 3.8627 2.86127 1.6879 1.18668 3.1173 3.08137 5.1503 3.43351 3.4872 0.60403 9.5113 0.87492 10.3005-2.57514 0.6644-2.9046-6.1773-2.82381-6.867-5.72252-0.7218-3.03367 1.3635-6.54105 3.7196-8.58376 2.7413-2.3766 7.8528-0.38651 10.4996-2.86794 2.2055-2.06776 1.2652-6.06573 2.9483-8.57708 2.3328-3.48057 6.0969-5.77475 9.4422-8.29764 2.5347-1.91156 5.279-6.76656 8.0115-5.15025 2.3862 1.4115 0.059 5.59803-0.5723 8.29764-0.7985 3.41476-2.5993 6.51571-4.0057 9.72827-1.1808 2.69717-5.0514 5.38562-3.7196 8.01151 0.6599 1.30118 3.255-0.16805 4.2918 0.85837 1.3161 1.30283 1.7027 3.67067 1.1445 5.43639-0.5898 1.86591-3.4348 2.24646-4.2918 4.00576-0.9643 1.97951-0.5415 4.37919-0.5723 6.58088-0.023 1.62403 0.8185 3.32968 0.2861 4.86414-0.7529 2.17005-4.9097 2.8774-4.578 5.15025 0.6804 4.66181 9.8843 3.23862 12.0173 7.43927 1.6891 3.32633-1.9014 7.57705-0.8584 11.1589 1.2 4.12072 6.4849 6.19181 7.7254 10.3005 0.9664 3.20087 0.4716 6.83792-0.5723 10.0144-0.8175 2.48803-4.7334 3.99946-4.2918 6.58088 0.6078 3.55377 6.1699 3.9028 8.5837 6.58089 3.2964 3.65727 5.8599 8.033 7.7254 12.5895 0.9643 2.3552 3.6998 5.84426 1.7168 7.43927-9.2266 7.42112-20.9825-11.1351-32.0955-15.2222-11.7301-4.31413-23.9228-7.45332-36.2155-9.71141-11.801-2.1678-23.8341-2.91831-35.8108-3.6418-6.9678-0.42091-20.9375-0.40462-20.9375-0.40462s-13.9523-0.0172-20.9375 0.40462z'/%3E %3Cpath d='m1869.06 595.401l-10.1836 0.11745-10.1836-0.11745m16.9312-33.8799c2.6422-5.60081-1.9753-9.7497-6.7476-13.8571-4.7723 4.10743-9.3897 8.25632-6.7475 13.8571m14.0661 46.73c3.8943 0.2869 8.6316 4.26757 11.5881 1.71675 1.336-1.1526 0.6752-3.66318 0-5.29332-1.5743-3.80071-8.4131-4.62493-8.7268-8.72683-0.2706-3.53784 5.1908-5.2117 6.2948-8.58376 0.5489-1.67687 0.6808-3.66554 0-5.29332-2.7515-6.57773-14.4931-6.95114-16.5271-13.6805-0.9011-2.98148 5.9324-6.49335 6.7999-6.86893 4.3393-1.87871 9.7036 2.65867 13.9877 0.7993 2.899-1.25827 6.1252-4.1237 6.0696-7.28357-0.06-3.43827-3.7256-6.31645-6.8789-7.68821-6.1079-2.65702-16.2205 5.9042-19.9783 0.40464-3.4586-5.06171 8.643-11.0806 7.0297-16.995-0.7665-2.81003-6.9773-5.26035-6.9773-5.26035s-6.2021 2.43824-6.9773 5.26035c-1.6239 5.91151 10.4883 11.9333 7.0297 16.995-3.7578 5.49956-13.8704-3.06166-19.9783-0.40464-3.1533 1.37176-6.8184 4.24994-6.8789 7.68821-0.056 3.15987 3.1706 6.0253 6.0696 7.28357 4.2841 1.85937 9.6484-2.67801 13.9877-0.7993 0.8674 0.37558 7.701 3.88745 6.7999 6.86893-2.034 6.7294-13.7756 7.10281-16.5271 13.6805-0.6809 1.62778-0.5489 3.61645 0 5.29332 1.1039 3.37206 6.5654 5.04592 6.2948 8.58376-0.3137 4.1019-7.1525 4.92612-8.7268 8.72683-0.6753 1.63014-1.336 4.14072 0 5.29332 2.9565 2.55082 7.6937-1.42985 11.588-1.71675 2.433-0.17924 7.3187 0 7.3187 0s4.8683-0.18054 7.3186 0z'/%3E %3Cpath fill='none' d='m1953.74 953.499s-7.1544-3.01914-10.8036-4.34009c-6.5977-2.3883-13.2592-4.63213-20.0298-6.47428-6.5995-1.79562-13.2329-3.68914-20.0298-4.45107-14.5762-1.63399-44.0021-0.20232-44.0021-0.20232s-29.4085-1.43357-44.0021 0.20232c-6.7969 0.76191-13.4303 2.65545-20.0298 4.45107-6.7706 1.84215-13.4321 4.08598-20.0298 6.47428-3.6492 1.32095-10.8036 4.34009-10.8036 4.34009m201.899-222.5s-11.9524-4.75619-18.0259-6.86702c-5.1003-1.77255-10.2059-3.58154-15.4508-4.86412-6.3972-1.56438-12.932-2.53824-19.4565-3.43352-9.3932-1.28887-18.8433-2.20847-28.307-2.78448-8.5842-0.52248-25.7932-0.60697-25.7932-0.60697s-17.1915 0.0836-25.7932 0.60697c-9.4637 0.57579-18.9138 1.49561-28.307 2.78448-6.5245 0.89528-13.0593 1.86914-19.4565 3.43352-5.2449 1.28258-10.3505 3.09157-15.4508 4.86412-6.0735 2.11083-18.0259 6.86702-18.0259 6.86702m-14.1568 120.41s17.5596-5.91847 26.4055-8.671c9.1286-2.84052 18.1733-6.06275 27.5157-8.09285 11.184-2.43029 22.6108-3.62932 33.9899-4.85571 11.0585-1.19184 33.2791-2.42786 33.2791-2.42786s22.2032 1.23478 33.2791 2.42786c11.3792 1.22574 22.8059 2.42542 33.9899 4.85571 9.3424 2.0301 18.3871 5.25233 27.5157 8.09285 8.8459 2.75253 26.4055 8.671 26.4055 8.671'/%3E %3C/g%3E %3Cg id='silverkey' fill='%23ccc'%3E %3Cg id='keybase'%3E %3Cpath d='m1533.28 904.042l101.171 86.7132s-5.1334 11.2137-7.279 16.9889c-1.9789 5.3266-3.8171 10.7271-5.1455 16.252-1.9584 8.145-4.1351 24.7886-4.1351 24.7886l-117.942-108.035c1.6729-24.6894 15.5662-33.4882 33.3308-36.7078z'/%3E %3Cpath d='m1518.99 958.197l-24.2832 27.1672 15.1647 14.5924-23.4623 22.89-15.1647-15.1647-25.5145 27.2017-0.2368 33.7431 58.0835 45.4939 20.0288-14.8785-1.1445-32.3322 15.4508 8.5838 15.4508-9.4422 0.8583 29.1849-12.5895-9.1561-13.734 18.0259-1.4306 32.0461 43.7772 38.9131 53.0494-47.0794-4.0084-14.1122-2.3054-12.678-1.2464-25.1286 1.9803-27.4395z'/%3E %3Cpath d='m1494.71 985.364l-0.6211 29.9932 15.6428-15.2612z'/%3E %3Cpath fill='none' d='m1571.935 1140.425l-1.8207 34.26245m-18.6096 -139.675l0.6445 31.7845m-14.8106 -17.3405l0.8297 25.8846m-14.425 -36.3405l0.5416 28.9249m-21.4347 15.2245l0.3115 30.6476m24.7368 -9.675l44.0639 36.8974 45.0552 -39.54m-171.018 -66.875l57.579 49.1932 18.8843 -16.8814 -14.8785 -12.5895 16.5953 -15.7369 12.8756 11.1589 14.5924 -14.8785 18.8843 18.312 -17.1507 13.4474 16.0062 14.5929 -15.1647 14.0202'/%3E %3Cpath d='m1901.35 1229.35l48.6021 44.5794 10.7633 31.4287-62.6421-6.6732-35.6637-35.2765-37.9692-35.1752-164.039-142.138s3.4783-13.1014 5.635-19.5218c3.124-9.3004 6.8664-18.3846 10.5645-27.472 0.9279-2.2802 2.9156-6.7855 2.9156-6.7855l183.014 162.24z'/%3E %3Cpath d='m1942.67 1236.04c27.0945 37.8682 72.6912 73.6383 86.5365 90.8418 13.8452 17.2034 22.7646 33.5407 2.5831 55.5383-20.1814 21.9976-43.064 9.5153-61.1352-2.5832-18.0712-12.0984-49.6026-51.3029-94.7165-81.3701z'/%3E %3Cpath d='m1926.7 1299.75l-35.1694-15.8738m40.928-38.2875c2.4231 7.9655 0.5742 16.7742 3.624 24.4159 3.0153 7.5554 14.0225 19.9737 14.0225 19.9737s-6.9976 0.9775-10.2616 2.2451c-4.731 1.8372-11.9561 2.7096-13.172 7.6371-1.0633 4.3091 4.0612 8.0262 7.0898 11.2707 2.9045 3.1116 6.6447 5.3721 10.3159 7.5262 6.1364 3.6005 12.391 7.6535 19.393 8.9161 8.7653 1.5806 25.1291-10.7555 26.6468-1.9791 0.6311 3.6495-7.3892 1.3125-10.7131 2.9459-7.7584 3.8123-11.6492 12.1174-4.8208 17.8939 4.3853 3.7097 11.2751 2.3464 16.9994 2.8209 5.4887 0.455 11.7572-2.745 16.5227 0.016 5.6107 3.2507 12.6678 11.1061 9.6914 16.867-3.0627 5.9283-14.4837 5.7692-19.9267 1.9095-4.0245-2.8539-2.947-9.4733-3.5417-14.371-0.1769-1.4578 0-2.937 0-4.4055'/%3E %3Ccircle cx='2154.6649' cy='1480.1466' r='129.6871'/%3E %3Cpath fill='%23fff' d='m2106.13 1485.65c-22.3554 0-40.4781 18.1226-40.4781 40.478 0 22.3555 18.1227 40.4781 40.4781 40.4781s40.4781-18.1226 40.4781-40.4781l14.0261-0.6088c0 22.3554 18.1227 40.4781 40.4781 40.4781s40.4781-18.1227 40.4781-40.4781-18.1227-40.4781-40.4781-40.4781l0.6088-7.9375c22.3555 0 40.4781-18.1227 40.4781-40.4781s-18.1226-40.4781-40.4781-40.4781c-22.3554 0-40.4781 18.1227-40.4781 40.4781l-14.026-1.2177c0-22.3555-18.1227-40.4781-40.4781-40.4781-22.3555 0-40.4781 18.1226-40.4781 40.4781 0 22.3554 18.1226 40.4781 40.4781 40.4781z'/%3E %3Ccircle cx='2154.6667' cy='1446.0519' r='14.61264'/%3E %3Ccircle cx='2189.3667' cy='1480.1479' r='14.61264'/%3E %3Ccircle cx='2155.2767' cy='1511.1999' r='14.61264'/%3E %3Ccircle cx='2119.3467' cy='1480.1479' r='14.61264'/%3E %3Cpath fill='%23fff' d='m2152.23 1558.42c-5.3378 10.9567-12.6202 15.941-21.919 21.919 13.2474 5.754 29.4005 4.6966 43.838 0-9.2987-4.6497-16.0413-11.9958-21.919-21.919zm-76.5786-80.2317c-10.9566-5.3378-15.9409-12.6203-21.919-21.919-5.7539 13.2473-4.6965 29.4005 0 43.838 4.6498-9.2988 11.9959-16.0414 21.919-21.919zm159.246 3.6531c10.9567-5.3378 15.941-12.6203 21.919-21.919 5.754 13.2473 4.6966 29.4005 0 43.838-4.6497-9.2988-11.9958-16.0414-21.919-21.919zm-78.4052-80.8406c-5.3378-10.9566-12.6203-15.9409-21.919-21.919 13.2473-5.7539 29.4005-4.6965 43.838 0-9.2988 4.6498-16.0414 11.9959-21.919 21.919z'/%3E %3C/g%3E %3Cg fill='%23ce9d09'%3E %3Cg id='keydeco'%3E %3Cpath d='m1533.48 903.819s0.7031-5.06124 0.0001-7.43925c-1.1438-3.86881-3.5741-7.46776-6.5809-10.1575-2.5433-2.27495-5.8071-3.92372-9.1561-4.57801-3.6147-0.70621-7.4637-0.11504-11.0158 0.85837-2.4196 0.6631-6.7534 3.32254-6.7534 3.32254l-14.8491 6.11961-5.5107 17.6674s-3.1741 5.5789-3.9314 8.65611c-0.8104 3.29294-1.4088 6.87107-0.5723 10.1574 0.9826 3.86017 3.2315 7.61137 6.2948 10.1574 2.8332 2.35479 6.6269 3.72901 10.3005 4.00577 2.8265 0.21295 8.2977-1.85982 8.2977-1.85982 1.5802-18.6113 9.856-32.8133 33.4766-36.9102z'/%3E %3Cpath d='m1500.27 885.645l-38.7531-17.0196-3.1474 3.00431 21.1189 38.2016s5.9243-8.73821 9.3535-12.7364c3.5106-4.09311 11.4281-11.4499 11.4281-11.4499z'/%3E %3Ccircle cy='865.26332' cx='1457.292' r='15.951473'/%3E %3Cpath d='m1566.19 932.256c3.3899 27.9522 7.3216 55.9043 16.0248 83.8565l31.0688 28.459c-6.625-29.2317-18.4423-58.4633-18.3681-87.695z'/%3E %3Cpath d='m1613.05 972.415l-85.4875-6.36886 27.2007 24.9158 78.0675 3.37974 1.1469-3.98967z'/%3E %3Cpath d='m1718.36 1066.92c-22.4447 8.4602-31.4178 22.3089-37.8571 37.1712-6.3529 0.5589-12.3057 0.6177-14.4104-4.1336 5.3477-34.6998 30.2103-45.5513 35.7531-47.747 14.9497-2.8246 12.1788 8.8497 16.5144 14.7094z'/%3E %3Cpath d='m1745.88 1092.82c-22.4446 8.4601-31.4177 22.3089-37.857 37.1711-6.3529 0.5589-12.3057 0.6177-14.4104-4.1336 5.3477-34.6998 30.2103-45.5512 35.753-47.747 14.9498-2.8246 12.1789 8.8497 16.5144 14.7095z'/%3E %3Cpath d='m2058.66 1354.69c-7.33655 -0.2015 -15.0781 1.5039 -15.0781 1.5039 0.3035 8.02055 -2.9456 16.58265 -11.7969 26.2305 -7.63945 8.32695 -15.6662 11.70345 -23.67185 12.041l-0.01 0.01s-2.8398 17.65195 2.5879 23.25195c6.3562 6.5581 27.11915 3.87695 27.11915 3.87695l1.7676 -1.1325a129.6875 129.6875 0 0 1 31.91405 -39.7949l0.332 -1.2595s3.0386 -16.5234 -2.1484 -21.5c-2.35045 -2.27015 -6.6137 -3.0726 -11.01565 0z'/%3E %3Ccircle cy='1375.4239' cx='2254.5167' r='17.656865'/%3E %3Ccircle cy='1580.0009' cx='2260.6067' r='17.656865'/%3E %3Ccircle cy='1591.5699' cx='2062.1167' r='17.656865'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='goldkey' fill='%23ce9d09' transform='matrix(-1,0,0,1,3718.256,0)'%3E %3Cuse xlink:href='%23keybase'/%3E %3Cuse xlink:href='%23keydeco' fill='%23ccc'/%3E %3C/g%3E %3Cg id='cord'%3E %3Cg fill='%23fa0204'%3E %3Cpath id='piece1' d='m1869.19 1175.78c0 5.3802-4.4998 7.4585-13.2427 7.4585s-12.7861-2.5349-12.7861-7.9152c0-5.3802 4.0432-6.6974 12.7861-6.6974s13.2427 1.7739 13.2427 7.1541z'/%3E %3Cuse xlink:href='%23piece1' x='6.39127' y='14.309'/%3E %3Cpath d='m1877.34 1208.69c-1.772 5.0801-6.7053 5.5604-14.9604 2.681-8.255-2.8795-11.2378-6.6047-9.4658-11.6847 1.772-5.0801 6.0234-4.9922 14.2785-2.1127 8.2551 2.8794 11.9197 6.0364 10.1477 11.1164z'/%3E %3Cpath id='piece2' d='m1877.51 1222.51c-1.065 5.2737-5.8872 6.4202-14.4571 4.6895s-12.0312-5.0159-10.9662-10.2897c1.065-5.2737 5.289-5.7645 13.8588-4.0338 8.5699 1.7306 12.6295 4.3602 11.5645 9.634z'/%3E %3Cuse xlink:href='%23piece2' x='3.95963' y='16.1422'/%3E %3Cpath d='m1921.73 1216.2c-2.5904-0.6912-2.3033-5.3033-1.583-7.8857 1.107-3.9686 8.3538-9.11 8.3538-9.11s1.7671 5.5627 0.9501 8.1851c-1.1615 3.7283-3.948 9.8173-7.7209 8.8106z'/%3E %3Cpath d='m1912.29 1224.42c-2.8216-0.6217-3.1818-5.5227-2.444-8.3162 1.142-4.3238 9.6454-9.3253 9.6454-9.3253s1.4762 6.0417 0.5196 8.831c-1.2669 3.6937-3.9075 9.6508-7.721 8.8105z'/%3E %3Cpath d='m1901.52 1240.01c-4.2916-1.1384-3.8048-8.7623-2.6592-13.0521 0.946-3.5426 3.7155-9.1195 7.2774-8.2489 4.1673 1.0185 4.1144 8.3214 3.1027 12.4905-0.9208 3.7948-3.9464 9.8117-7.7209 8.8105z'/%3E %3Cpath d='m1888.73 1252.19c-4.2142-0.9262-6.0068-7.6384-5.1637-11.8701 0.8851-4.4419 5.3598-10.4103 9.7819-9.4309 4.4624 0.9884 6.0053 8.3528 4.9293 12.7949-1.0033 4.1426-5.3845 9.4211-9.5475 8.5061z'/%3E %3Cpath d='m1886.51 1259.58c-1.0768 5.087-7.5039 6.86-11.4614 5.5691-4.1541-1.355-9.5785-7.1863-8.4416-12.5236 1.1474-5.3859 8.1788-6.8138 12.3239-5.2257 3.8656 1.4809 8.6428 7.1552 7.5791 12.1802z'/%3E %3Cpath d='m1801.47 1210.29s5.1379 2.5312 7.3489 4.7921c2.321 2.3733 5.1107 3.3218 3.709 6.9229-1.4145 3.6339-5.8427 2.3881-8.1269-0.1558-2.1302-2.3723-2.931-11.5592-2.931-11.5592z'/%3E %3Cpath d='m1826.84 1219.06c5.2115 1.0469 5.1081 7.1209 2.4435 10.8465-2.7971 3.9106-10.8836 8.9923-16.3493 7.8872-5.5156-1.1152-4.8437-7.7572-1.7951-11.658 2.843-3.6377 10.5528-8.1097 15.7009-7.0757z'/%3E %3Cpath id='piece3' d='m1844.26 1230.55c4.8531 2.1688 3.4146 8.0709 0 11.1182-3.5896 3.1987-12.5967 6.3749-17.6849 4.0932-5.1345-2.3024-3.0165-8.6334 0.8162-11.767 3.5744-2.9224 12.0797-5.5868 16.8737-3.4444z'/%3E %3Cuse xlink:href='%23piece3' x='13.9976' y='10.6607'/%3E %3Cpath d='m1862.97 1250.68c4.7874 0.7544 6.069 7.4153 4.5846 11.6962-1.5593 4.494-7.4731 10.6689-12.4956 9.8697-5.0684-0.8064-5.9818-8.1322-4.2007-12.6343 1.6611-4.1985 7.3836-9.6772 12.1127-8.932z'/%3E %3Cpath d='m1875.1 1265.33c3.9649 2.3077 3.0331 9.5902 0.4105 13.5334-2.7541 4.1391-9.845 8.622-14.0023 6.1932-4.1951-2.451-2.7353-10.302 0.2157-14.3787 2.7522-3.8018 9.4605-7.6274 13.3771-5.3479z'/%3E %3Cpath d='m1789.02 1225.44c4.2435-0.3761 7.1824 5.9652 7.1269 10.5849-0.059 4.8498-3.317 12.4028-7.771 12.7899-4.4945 0.3906-7.3089-6.7007-7.0653-11.611 0.2273-4.5791 3.5185-11.3927 7.7102-11.7644z'/%3E %3Cpath d='m1802.91 1237.65c4.1568 0.9325 5.0275 7.8673 3.5694 12.2512-1.5316 4.6021-6.9326 10.8061-11.2933 9.82-4.4004-0.9952-4.9243-8.6065-3.1985-13.21 1.6094-4.293 6.8172-9.7825 10.9234-8.8615z'/%3E %3Cpath d='m1815.79 1246.24c4.9212 1.1581 5.952 9.7707 4.2258 15.2152-1.8133 5.7155-8.2076 13.4205-13.3701 12.1958-5.2096-1.2359-5.8298-10.6887-3.7868-16.4059 1.9054-5.3317 8.071-12.1493 12.9322-11.0055z'/%3E %3Cpath d='m1826.22 1256.8c5.0144-0.6444 9.0048 7.0573 9.301 12.7613 0.3098 5.9882-2.9706 15.4482-8.2344 16.115-5.3117 0.6727-9.2128-7.9599-9.3081-14.0304-0.089-5.6613 3.2892-14.2102 8.2424-14.8467z'/%3E %3Cpath id='piece4' d='m1838.59 1265.66c4.5564-0.5341 8.1822 5.85 8.4514 10.578 0.2815 4.9637-2.6993 12.8053-7.4822 13.358-4.8266 0.5576-8.3713-6.5981-8.4579-11.63-0.081-4.6927 2.9887-11.779 7.4895-12.3067z'/%3E %3Cuse xlink:href='%23piece4' x='12.7879' y='10.3504'/%3E %3Cpath id='piece5' d='m1929.28 1250.88c-3.2434 2.8459-9.7124 0.3125-12.6215-2.8742-3.0537-3.345-5.2098-10.4862-1.8005-13.4679 3.4404-3.009 10.2869 0.1121 13.2276 3.611 2.7423 3.263 4.3982 9.9199 1.1944 12.7311z'/%3E %3Cuse xlink:href='%23piece5' x='-6.99906' y='12.7922'/%3E %3Cuse xlink:href='%23piece5' x='-19.4791' y='23.4522'/%3E %3Cpath d='m1905.19 1281.18c-1.1383 4.1621-7.9325 5.6128-12.1161 4.5566-4.3915-1.1087-10.1258-5.8797-8.9239-10.2466 1.2128-4.4066 8.646-5.5749 13.0279-4.2756 4.0865 1.2117 9.1366 5.8543 8.0121 9.9656z'/%3E %3Cpath d='m1887.18 1278.19c3.6414 2.5388 2.7856 10.5507 0.377 14.8888-2.5295 4.5537-9.0418 9.4855-12.86 6.8135-3.8529-2.6965-2.5122-11.3338 0.1981-15.8188 2.5276-4.1825 8.6887-8.3913 12.2858-5.8835z'/%3E %3Cpath d='m1869.62 1287.55c3.9649 2.3077 3.0332 9.5902 0.4105 13.5334-2.7541 4.1392-9.8449 8.622-14.0022 6.1932-4.1952-2.451-2.7354-10.302 0.2157-14.3787 2.7522-3.8017 9.4604-7.6273 13.3771-5.3479z'/%3E %3Cpath id='piece6' d='m1831.34 1312.91c-3.3916 3.2346-0.7555 11.2719 2.7733 15.2819 3.7054 4.2091 11.7943 8.1045 15.3483 4.7027 3.5863-3.4329 0.2927-12.0241-3.5934-16.1312-3.6241-3.83-11.1791-7.0483-14.5293-3.8532z'/%3E %3Cuse xlink:href='%23piece6' x='-7.31929' y='13.7806'/%3E %3Cpath id='piece7' d='m1820.83 1339.55c-4.3482 1.7486-4.8759 10.1907-3.083 15.2224 1.8833 5.282 7.9545 11.896 12.5156 10.0521 4.6026-1.8607 4.7247-11.0608 2.6358-16.315-1.9481-4.8998-7.7742-10.687-12.0694-8.9598z'/%3E %3Cuse xlink:href='%23piece7' x='-10.5477' y='14.8521'/%3E %3Cpath id='piece8' d='m1802.66 1371.04c-4.5705 1.0369-6.4304 9.2885-5.4581 14.5409 1.0218 5.5138 5.9673 13.0069 10.763 11.9097 4.8395-1.1073 6.4191-10.1716 5.1899-15.6905-1.1464-5.1468-5.981-11.7847-10.4958-10.7605z'/%3E %3Cuse xlink:href='%23piece8' x='-10.1211' y='15.9316'/%3E %3Cpath id='piece9' d='m1784.06 1403.3c-4.6836 0.1712-8.0416 7.9347-8.0603 13.2763-0.019 5.6077 3.4514 13.888 8.3674 13.6993 4.9609-0.1905 8.1942-8.8046 8.0099-14.4558-0.1719-5.2701-3.6915-12.6895-8.3179-12.5204z'/%3E %3Cuse xlink:href='%23piece9' x='-10.3299' y='19.16'/%3E %3Cuse xlink:href='%23piece9' x='-22.3899' y='37.02'/%3E %3Cuse xlink:href='%23piece9' x='-34.87' y='52.31'/%3E %3Cuse xlink:href='%23piece9' x='-47.79' y='66.51'/%3E %3Cuse xlink:href='%23piece9' x='-61.99' y='78.14'/%3E %3Cuse xlink:href='%23piece9' x='-75.5599' y='90.62'/%3E %3Cpath d='m1692.79 1500.17l-5.2618 20.5953s2.9353 7.3347 5.9995 7.026c5.4811-0.552 6.9648-9.0469 8.0099-14.4557 0.9476-8.4237-8.7476-13.1656-8.7476-13.1656z'/%3E %3Cpath d='m2017.21 1513.25c1.6097 6.1241 15.2598 11.3138 15.2598 11.3138l-6.6509-27.7579c-5.7168 0.154-9.4945 12.4363-8.6089 16.4441z'/%3E %3Cpath d='m2016.01 1490.95c-4.3589-1.7217-10.549 4.0428-12.7088 8.9283-2.2663 5.1293-2.4091 14.1062 2.1699 15.9053 4.6206 1.8154 11.0377-4.7785 13.1357-10.0289 1.9564-4.8966 1.7085-13.1047-2.5973-14.8056z'/%3E %3Cpath id='piece10' d='m2000.82 1478.67c-4.6803-0.2433-8.7113 7.193-9.202 12.5121-0.5142 5.584 2.2105 14.1386 7.124 14.3851 4.9583 0.2487 8.9402-8.046 9.2562-13.6913 0.2944-5.2647-2.5557-12.9661-7.1789-13.2065z'/%3E %3Cuse xlink:href='%23piece10' x='-13.4001' y='-13.7001'/%3E %3Cuse xlink:href='%23piece10' x='-25.88' y='-29.23'/%3E %3Cuse xlink:href='%23piece10' x='-38.66' y='-42.32'/%3E %3Cuse xlink:href='%23piece10' x='-49.01' y='-60.28'/%3E %3Cuse xlink:href='%23piece10' x='-60.2801' y='-76.41'/%3E %3Cuse xlink:href='%23piece10' x='-70.63' y='-93.46'/%3E %3Cuse xlink:href='%23piece10' x='-79.76' y='-113.25'/%3E %3Cuse xlink:href='%23piece10' x='-89.81' y='-131.21'/%3E %3Cuse xlink:href='%23piece10' x='-98.03' y='-152.52'/%3E %3Cpath d='m1883.85 1304.56s-1.6473 26.6763 8.0374 28.389c6.0386 1.0678 10.7782-14.9091 10.7782-14.9091z'/%3E %3Cpath id='piece11' d='m1862.02 1610.75c-2.8778 3.699 0.9139 11.2601 4.9952 14.7063 4.2852 3.6171 12.8598 6.2779 15.8737 2.3895 3.0412-3.9239-1.4825-11.936-5.9313-15.4255-4.149-3.2541-12.0958-5.3239-14.9385-1.6701z'/%3E %3Cuse xlink:href='%23piece11' x='18.3' y='-2.15'/%3E %3Cuse xlink:href='%23piece11' x='36.81' y='-5.81'/%3E %3Cpath id='piece12' d='m1916.18 1603.8c-2.2897 4.0891 2.5943 10.9952 7.1468 13.7895 4.7797 2.9327 13.6566 4.2758 16.0525-0.021 2.4176-4.336-3.2579-11.578-8.1802-14.3601-4.5906-2.5942-12.7581-3.4473-15.02 0.592z'/%3E %3Cuse xlink:href='%23piece12' x='20.0199' y='-3.21989'/%3E %3Cpath id='piece13' d='m1953.48 1595.43c-1.9026 4.283 3.5981 10.7088 8.389 13.071 5.03 2.4789 13.993 2.9969 15.982-1.5028 2.0071-4.5407-4.3126-11.2279-9.4707-13.5437-4.8105-2.1594-13.0218-2.255-14.9012 1.9759z'/%3E %3Cuse xlink:href='%23piece13' x='18.94' y='-5.58998'/%3E %3Cpath id='piece14' d='m1991.26 1583.89c-1.6462 4.3879 4.2246 10.4775 9.1467 12.5525 5.1677 2.1773 14.1457 2.1649 15.8653-2.4445 1.7353-4.6513-4.9685-10.9534-10.2545-12.9604-4.9296-1.8714-13.1322-1.4816-14.7584 2.8528z'/%3E %3Cuse xlink:href='%23piece14' x='19.16' y='-6.23998'/%3E %3Cuse xlink:href='%23piece14' x='37.67' y='-13.9899'/%3E %3Cuse xlink:href='%23piece14' x='57.48' y='-22.17'/%3E %3Cuse xlink:href='%23piece14' x='77.5' y='-28.6299'/%3E %3Cuse xlink:href='%23piece14' x='79.87' y='-44.34'/%3E %3Cpath d='m2066.71 1534.88s13.5498 1.9917 14.7891-2.8749c1.6456-6.4625-15.4209-12.7452-15.4209-12.7452z'/%3E %3Cpath id='piece15' d='m1701.62 1575.59c-3.9861 2.4647-3.066 10.8731-0.4409 15.5252 2.7567 4.8833 9.8673 10.3646 14.0469 7.7697 4.2177-2.6186 2.7685-11.7047-0.186-16.5255-2.7555-4.4957-9.4834-9.2042-13.421-6.7695z'/%3E %3Cuse xlink:href='%23piece15' x='18.94' y='7.75003'/%3E %3Cuse xlink:href='%23piece15' x='37.03' y='10.55'/%3E %3Cuse xlink:href='%23piece15' x='56.83' y='15.5001'/%3E %3Cuse xlink:href='%23piece15' x='74.7' y='18.08'/%3E %3Cuse xlink:href='%23piece15' x='92.35' y='21.74'/%3E %3Cuse xlink:href='%23piece15' x='110.43' y='26.69'/%3E %3Cuse xlink:href='%23piece15' x='128.3' y='29.92'/%3E %3Cuse xlink:href='%23piece15' x='146.6' y='32.72'/%3E %3Cpath d='m1648.16 1517.51c-4.1667-2.1454-10.8978 2.9772-13.5312 7.6245-2.7637 4.8794-3.7956 13.7979 0.5824 16.042 4.4179 2.2645 11.457-3.6607 14.0652-8.6773 2.4321-4.6785 2.9991-12.8708-1.1168-14.9901z'/%3E %3Cpath d='m1642.01 1534.4c-4.4151-1.5719-10.4047 4.4008-12.3964 9.3572-2.0898 5.2037-1.9258 14.1803 2.7119 15.8218 4.6799 1.6566 10.868-5.1526 12.7855-10.4717 1.7879-4.9605 1.2598-13.1554-3.1015-14.7082z'/%3E %3Cpath d='m1647.74 1549.94c-4.5395-1.1649-9.9626 5.3264-11.4964 10.4431-1.6092 5.3718-0.6317 14.2965 4.1358 15.5106 4.8109 1.2252 10.3558-6.1173 11.7829-11.5884 1.3306-5.1022 0.061-13.2154-4.4229-14.3661z'/%3E %3Cpath d='m1662.37 1556.31c-4.499-1.3127-10.1315 4.9978-11.8319 10.0615-1.784 5.3163-1.0989 14.2682 3.6263 15.6376 4.7683 1.3819 10.5504-5.7753 12.1556-11.1967 1.4968-5.056 0.4935-13.2064-3.9506-14.5032z'/%3E %3Cpath id='piece16' d='m1671.91 1558.81c-4.5474 1.1337-6.2318 9.4229-5.1483 14.6535 1.1385 5.4908 6.242 12.8773 11.0134 11.6786 4.8148-1.2097 6.2017-10.3055 4.8557-15.7971-1.2554-5.1213-6.2297-11.6551-10.7217-10.5354z'/%3E %3Cuse xlink:href='%23piece16' x='16.79' y='6.23999'/%3E %3Cuse xlink:href='%23piece6' x='8.61071' y='-11.1894'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='6.47'/%3E %3Cuse xlink:href='%23piece6' x='4.91148' y='26.6794'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='47.8699'/%3E %3Cuse xlink:href='%23piece6' x='5.57' y='68.5699'/%3E %3Cuse xlink:href='%23piece6' x='2.22005' y='87.7499'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='109.06'/%3E %3Cuse xlink:href='%23piece6' x='2.22004' y='126.41'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='143.46'/%3E %3Cuse xlink:href='%23piece6' x='4.66' y='163.86'/%3E %3Cuse xlink:href='%23piece6' x='3.44006' y='183.95'/%3E %3Cuse xlink:href='%23piece6' x='3.74' y='203.13'/%3E %3Cuse xlink:href='%23piece6' x='4.35006' y='223.52'/%3E %3Cuse xlink:href='%23piece6' x='4.35006' y='243.31'/%3E %3Cuse xlink:href='%23piece6' x='3.74' y='263.1'/%3E %3Cuse xlink:href='%23piece6' x='2.52' y='283.19'/%3E %3Cuse xlink:href='%23piece6' x='2.52' y='305.11'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='327.94'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='349.25'/%3E %3Cuse xlink:href='%23piece6' x='1.92002' y='369.04'/%3E %3Cuse xlink:href='%23piece6' x='1.31006' y='391.27'/%3E %3Cpath id='piece17' d='m1882.24 1303.18c2.4423 3.7068-1.3196 10.8321-5.1636 13.9699-4.036 3.2931-11.9117 5.4626-14.4688 1.5665-2.5804-3.9315 1.8636-11.4583 6.0421-14.6207 3.8968-2.949 11.1785-4.577 13.5912-0.9154z'/%3E %3Cuse xlink:href='%23piece17' x='2.74003' y='16.13'/%3E %3Cuse xlink:href='%23piece17' x='2.43002' y='34.1'/%3E %3Cuse xlink:href='%23piece17' x='2.13' y='52.36'/%3E %3Cuse xlink:href='%23piece17' x='1.82003' y='69.11'/%3E %3Cuse xlink:href='%23piece17' x='2.74002' y='87.07'/%3E %3Cuse xlink:href='%23piece17' x='1.52002' y='104.42'/%3E %3Cpath d='m1883.25 1426.06c2.6959 3.8337-1.4565 11.2029-5.6994 14.448-4.4549 3.4059-13.148 5.6497-15.9706 1.6202-2.8482-4.0661 2.0571-11.8504 6.6693-15.1211 4.3012-3.05 12.3386-4.7336 15.0017-0.9467z'/%3E %3Cpath id='piece18' d='m1882.09 1443.58c3.3915 3.2345 0.7554 11.2718-2.7734 15.2819-3.7054 4.209-11.7943 8.1044-15.3482 4.7026-3.5863-3.4328-0.2928-12.0241 3.5933-16.1312 3.6241-3.83 11.1791-7.0482 14.5293-3.8532z'/%3E %3Cuse xlink:href='%23piece18' x='.610044' y='20.4001'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='40.4901'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='62.11'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='82.2'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='102.6'/%3E %3Cuse xlink:href='%23piece18' x='.610044' y='122.99'/%3E %3Cuse xlink:href='%23piece18' x='.610045' y='143.69'/%3E %3Cuse xlink:href='%23piece18' x='-.299955' y='164.4'/%3E %3Cuse xlink:href='%23piece18' x='.920001' y='183.27'/%3E %3Cuse xlink:href='%23piece18' x='.92' y='203.06'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='224.37'/%3E %3Cuse xlink:href='%23piece18' x='.310021' y='245.37'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fa0204' d='m1849.64 1848.26c19.9021 5.5241 31.7591 5.236 48.2193 0.4305l-17.4364-27.9844'/%3E %3Cpath fill='%23ce9d09' d='m1888.31 1776.16-31.7083-8.1414s0.3666-35.1832 20.3893-32.1154c16.6195 2.5464 11.9853 40.3409 11.319 40.2568z'/%3E %3Ccircle fill='%23ce9d09' cx='1872.8856' cy='1722.9711' r='12.9159'/%3E %3Cpath fill='%23fa0204' d='m1885.37 1791.86c7.0484 17.8642 11.3696 33.2411 4.7358 53.3857m7.5972 3.4126c-10.2262-8.2551-36.5822-5.8322-47.9812-0.3475-4.4526 0-16.4454-83.2401 25.7219-81.1827 38.7211 1.8892 24.9493 81.9145 22.2593 81.5302z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fa0204' d='m1815.2 1866.34c19.2918 12.2385 37.2498 11.1397 54.2468 0.4305l-40.2546-41.9766'/%3E %3Ccircle fill='%23ce9d09' cx='1843.3956' cy='1738.2551' r='12.9159'/%3E %3Cpath fill='%23ce9d09' d='m1859.33 1780.02-32.7202-0.6458s-4.2451-26.6125 16.1449-27.7691c16.9243-0.96 17.2516 28.3629 16.5753 28.4149z'/%3E %3Cpath fill='%23fa0204' d='m1843.61 1860.74c-6.2615-13.9097-6.9109-31.0263-5.1664-49.5109m-9.4716 50.372c-7.6816-13.1828-9.1065-30.0153-3.0137-51.233m43.4039 56.6355c-4.9263-6.1908-40.2274-8.8289-54.0959-0.3918-5.02 0-18.5411-93.8481 28.9999-91.5285 43.6557 2.13 28.1288 92.3536 25.096 91.9203z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='250'%3E %3Crect width='500' height='250' fill='%231eb53a'/%3E %3Crect width='500' height='125' fill='%230099b5'/%3E %3Crect width='500' height='90' y='80' fill='%23ce1126'/%3E %3Crect width='500' height='80' y='85' fill='%23fff'/%3E %3Ccircle cx='70' cy='40' r='30' fill='%23fff'/%3E %3Ccircle cx='80' cy='40' r='30' fill='%230099b5'/%3E %3Cg fill='%23fff' transform='translate(136,64)'%3E %3Cg id='s3'%3E %3Cg id='s'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath id='o' d='M0,-6V0H3' transform='rotate(18,0,-6)'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='-24'/%3E %3Cuse xlink:href='%23s' y='-48'/%3E %3C/g%3E %3Cuse xlink:href='%23s3' x='24'/%3E %3Cuse xlink:href='%23s3' x='48'/%3E %3Cuse xlink:href='%23s' x='-48'/%3E %3Cuse xlink:href='%23s' x='-24'/%3E %3Cuse xlink:href='%23s' x='-24' y='-24'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='900' height='600' viewBox='-5 -5 27 18'%3E %3Ctitle%3EFlag of Uruguay%3C/title%3E %3Crect x='-5' y='-5' width='27' height='18' fill='%23fff'/%3E %3Cg fill='%230038a8'%3E %3Crect x='5' y='-3' width='17' height='2'/%3E %3Crect x='5' y='1' width='17' height='2'/%3E %3Crect x='-5' y='5' width='27' height='2'/%3E %3Crect x='-5' y='9' width='27' height='2'/%3E %3C/g%3E %3Cg transform='scale(0.11)' fill='%23fcd116' stroke='%23000' stroke-width='0.6' stroke-miterlimit='20'%3E %3Cg id='u'%3E %3Cg id='t'%3E %3Cg id='s'%3E %3Cg transform='rotate(22.5)'%3E %3Cpath d='M 1.5,9 6,12 C -2,25 7,27 0,33 3,26 -3,28 -3,16' stroke-linecap='square'/%3E %3Cpath d='M 0,11 C -2,24 4.5,28 0,33' fill='none'/%3E %3C/g%3E %3Cpath d='M 0,0 h 6 l -6,33 l -6,-33 h 6 v 33'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23u' transform='rotate(180)'/%3E %3Ccircle r='11'/%3E %3C/g%3E %3Cg transform='scale(0.011)'%3E %3Cg id='right'%3E %3Cpath d='M 81,-44 c -7,8 -11,-6 -36,-6 -25,0 -29,15 -33,12 -4,-3 21,-21 29,-22 8,-1 31,7 40,16 M 52,-35 c 7,6 1,19 -6,19 -7,0 -20,-12 -14,-20'/%3E %3Cpath d=' M 19,-26 c 1,-12 11,-14 27,-14 16,0 23,12 29,15 -7,0 -13,-10 -29,-10 -16,0 -16,0 -27,10 M 22,-23 c 4,-6 9,6 20,6 11,0 17,-3 24,-8 7,-5 -10,12 -21,12 -11,0 -26,-6 -23,-10'/%3E %3Cpath d='M 56,-17 c 13,-7 5,-17 0,-19 2,2 10,12 0,19 M 0,43 c 6,0 8,-2 16,-2 8,0 27,11 38,7 -23,9 -14,3 -54,3 h -5 M 58,57 c -4,-7 -3,-5 -11,-16 8,6 10,9 11,16 M 0,67 C 25,67 21,62 54,48 30,51 25,59 0,59 h -5 M 0,30 c 7,0 9,-5 17,-5 8,0 19,3 24,7 1,1 -3,-8 -11,-9 C 22,22 25,9 16,7 c 0,4 3,3 4,9 0,5 -9,5 -11,0 2,8 -4,8 -9,8'/%3E %3C/g%3E %3Cuse xlink:href='%23right' transform='scale(-1,1)'/%3E %3Cpath d='M 0,76 c -5,0 -18,3 0,3 18,0 5,-3 0,-3'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1235' height='650' viewBox='0 0 7410 3900'%3E %3Crect width='7410' height='3900' fill='%23b22234'/%3E %3Cpath d='M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0' stroke='%23fff' stroke-width='300'/%3E %3Crect width='2964' height='2100' fill='%233c3b6e'/%3E %3Cg fill='%23fff'%3E %3Cg id='s18'%3E %3Cg id='s9'%3E %3Cg id='s5'%3E %3Cg id='s4'%3E %3Cpath id='s' d='M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z'/%3E %3Cuse xlink:href='%23s' y='420'/%3E %3Cuse xlink:href='%23s' y='840'/%3E %3Cuse xlink:href='%23s' y='1260'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='1680'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' x='247' y='210'/%3E %3C/g%3E %3Cuse xlink:href='%23s9' x='494'/%3E %3C/g%3E %3Cuse xlink:href='%23s18' x='988'/%3E %3Cuse xlink:href='%23s9' x='1976'/%3E %3Cuse xlink:href='%23s5' x='2470'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1235' height='650' viewBox='0 0 7410 3900'%3E %3Crect width='7410' height='3900' fill='%23b22234'/%3E %3Cpath d='M0,450H7410m0,600H0m0,600H7410m0,600H0m0,600H7410m0,600H0' stroke='%23fff' stroke-width='300'/%3E %3Crect width='2964' height='2100' fill='%233c3b6e'/%3E %3Cg fill='%23fff'%3E %3Cg id='s18'%3E %3Cg id='s9'%3E %3Cg id='s5'%3E %3Cg id='s4'%3E %3Cpath id='s' d='M247,90 317.534230,307.082039 132.873218,172.917961H361.126782L176.465770,307.082039z'/%3E %3Cuse xlink:href='%23s' y='420'/%3E %3Cuse xlink:href='%23s' y='840'/%3E %3Cuse xlink:href='%23s' y='1260'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='1680'/%3E %3C/g%3E %3Cuse xlink:href='%23s4' x='247' y='210'/%3E %3C/g%3E %3Cuse xlink:href='%23s9' x='494'/%3E %3C/g%3E %3Cuse xlink:href='%23s18' x='988'/%3E %3Cuse xlink:href='%23s9' x='1976'/%3E %3Cuse xlink:href='%23s5' x='2470'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600'/%3E %3Crect y='100' width='900' height='100' fill='%23fcdc04'/%3E %3Crect y='200' width='900' height='100' fill='%23d90000'/%3E %3Crect y='400' width='900' height='100' fill='%23fcdc04'/%3E %3Crect y='500' width='900' height='100' fill='%23d90000'/%3E %3Ccircle cx='450' cy='300' r='93.5' fill='%23fff'/%3E %3Cg stroke='%23000'%3E %3Cpath d='M 433.52031,228.39062 L 427.45593,217.22033 C 429.79607,214.8802 433.73312,213.07128 440.0095,213.07128 C 440.0095,213.49691 439.37106,225.30563 439.37106,225.30563 z' fill='%23d90000'/%3E %3Cpath d='M 439.37106,225.41204 L 440.22231,213.07128 C 440.22231,213.07128 452.77588,212.32724 459.5843,220.51813 C 459.6907,220.41173 452.88229,230.09231 452.88229,230.09231 z' fill='%23fcdc04'/%3E %3Cpath d='M 453.0951,229.98591 L 459.26508,220.41173 C 463.41413,224.7736 465.11583,227.85858 465.75427,232.53967 C 465.86068,232.64608 455.96728,234.98622 455.96728,234.87981 C 455.96728,234.7734 453.20151,230.09231 453.0951,229.98591 z' fill='%23d90000'/%3E %3Cpath d='M 436.60529,388.07318 C 436.60529,388.07318 448.2012,374.77476 470.75458,377.64774 C 467.35037,372.1154 456.3929,372.75384 456.3929,372.75384 C 456.3929,372.75384 452.9887,346.90266 455.64806,345.62578 C 458.30741,344.3489 469.5841,345.73219 469.5841,345.73219 C 471.07299,345.73219 473.62675,341.68954 471.60583,339.13659 C 469.5841,336.58282 463.62694,326.79583 466.07349,324.88051 C 468.52085,322.966 481.81845,325.94457 481.81845,325.94457 L 444.26496,277.85924 C 444.26496,277.85924 440.43513,259.77414 448.09479,251.0504 C 457.35057,243.39073 456.3929,235.09262 456.07368,235.19903 C 454.7968,226.79451 442.03123,220.73014 433.4139,228.49702 C 428.30718,234.667 431.71139,239.34808 431.71139,239.34808 C 431.71139,239.34808 418.30738,242.9651 417.77534,245.30524 C 417.24331,247.64619 432.88186,244.88043 432.88186,244.88043 L 431.39217,255.62508 C 431.39217,255.62508 400.96631,283.28436 424.26453,307.22103 C 424.47735,307.11462 425.00938,306.15696 425.00938,306.15696 C 425.00938,306.15696 433.20108,316.26399 441.8176,318.49772 C 449.9029,326.79583 449.15886,325.51895 449.15886,325.51895 C 449.15886,325.51895 450.75415,338.60455 449.26527,341.1575 C 447.24354,340.51906 426.60548,339.77503 423.51969,340.94469 C 420.75392,341.79595 410.11567,341.26391 412.77503,358.60498 C 414.79595,353.92389 416.60487,349.77483 416.60487,349.77483 C 416.60487,349.77483 416.28565,356.05121 418.83941,358.28576 C 418.41378,351.68935 421.28595,347.22188 421.28595,347.22188 C 421.28595,347.22188 421.81799,354.45592 423.41328,355.51918 C 425.00938,356.58325 425.00938,343.81686 433.83953,344.88093 C 442.66886,345.945 449.05246,345.62578 449.05246,345.62578 C 449.05246,345.62578 452.03104,370.6257 451.07337,372.96665 C 444.68977,371.47696 429.47766,373.60509 428.52,377.43493 C 437.45573,376.90289 441.6056,377.96615 441.6056,377.96615 C 441.6056,377.96615 434.37156,384.34975 436.60529,388.07318 z'/%3E %3Cpath d='M 440.19145,251.66041 C 440.19145,251.66041 418.05232,276.06251 427.60376,294.73569 C 428.11224,292.13157 427.89049,290.49566 428.20971,290.60207 C 427.67768,290.28285 430.95517,292.8488 430.7058,292.34925 C 430.77566,290.99927 429.70753,288.10598 429.70753,288.10598 C 430.7058,288.35534 431.70489,288.60552 432.70317,288.85488 C 432.12077,287.77295 431.53756,286.69182 430.95517,285.60988 C 432.37014,285.7764 433.78429,285.9421 435.19926,286.10861 C 435.19926,286.10861 433.70144,282.1147 434.20098,282.1147 C 434.69972,282.1147 437.69535,282.36407 437.69535,282.36407 C 431.39948,271.06545 437.33877,261.68215 440.19145,251.66041 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Cpath d='M 447.88198,230.73075 C 447.88198,230.73075 449.05246,239.13527 444.47777,241.58182 C 443.73293,242.11385 440.86075,243.07151 441.28638,244.77402 C 441.81841,247.11416 443.09448,246.68853 444.9034,246.2629 C 449.69008,245.41165 455.22243,235.19903 447.88198,230.73075 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Ccircle cx='438' cy='238' r='1.8' fill='%23fff' stroke='none'/%3E %3Cpath d='M 432.56264,244.98602 C 431.39217,245.94368 425.2222,252.32728 431.28576,254.66742 C 437.56295,252.96491 435.86044,251.79525 437.24373,250.41196 C 437.27947,247.53979 434.12301,246.79494 432.56264,244.98602 z' fill='%23d90000'/%3E %3Cpath d='M 445.96666,305.30652 C 445.64744,306.68981 444.26496,311.79571 446.17947,315.73195 C 451.499,313.49822 453.94555,314.13585 455.75446,315.30633 C 451.39341,311.79571 449.6909,310.30602 445.96666,305.30652 z' fill='%239ca69c' stroke='%239ca69c'/%3E %3Cpath d='M 455.11602,329.45519 L 455.43524,341.37032 C 455.43524,341.37032 459.5843,342.11517 461.49881,341.37032 C 463.41413,340.62547 461.3924,333.07221 455.11602,329.45519 z' fill='%23fff' stroke='%23fff'/%3E %3Cpath d='M 485.22266,330.94488 C 485.22266,330.94488 477.56299,312.43415 457.98819,307.75307 C 438.4134,303.07198 440.96635,282.22111 442.56245,280.94423 C 443.41371,279.13531 444.05215,276.36954 449.69008,279.02971 C 455.32883,281.68907 481.28642,294.77387 485.00985,295.41231 C 488.73327,296.05075 485.54188,331.37051 485.22266,330.94488 z' fill='%239ca69c'/%3E %3Cpath d='M 466.60552,307.64666 C 466.2863,307.85947 492.77592,323.2844 484.79703,336.58282 C 492.35111,331.58251 489.90375,322.85959 489.90375,322.85959 C 489.90375,322.85959 496.07372,338.92377 481.07361,346.79626 C 482.66971,348.17954 483.73378,347.85951 483.73378,347.85951 L 481.18001,350.41328 C 481.18001,350.41328 480.00954,352.32779 490.11656,347.43388 C 487.34999,349.66843 487.13798,351.26372 487.13798,351.26372 C 487.13798,351.26372 487.88202,353.39185 494.47843,347.6467 C 489.1589,353.39185 487.98843,356.37043 487.98843,356.26403 C 502.3501,354.98715 533.62722,308.2851 478.09503,294.45465 C 481.07442,297.54044 480.64798,297.11482 480.64798,297.11482 z' fill='%23d90000'/%3E %3Cpath d='M 467.776,303.07198 C 471.39302,305.62493 472.66909,306.47618 473.09472,307.75307 C 469.79692,307.00903 466.81834,307.22103 466.81834,307.22103 C 466.81834,307.22103 459.6907,300.41262 458.41382,299.88058 C 457.45616,299.88058 451.92463,296.36997 451.92463,296.36997 C 449.15886,294.98668 446.60591,285.4125 456.81853,288.17827 C 467.34956,293.17776 468.83926,293.6042 468.83926,293.6042 C 473.02405,294.91601 477.20803,296.22864 481.39283,297.54044 C 483.80444,300.23554 486.21525,302.93064 488.62687,305.62574 C 488.62687,305.62574 475.75489,299.24214 474.15879,299.13574 C 477.6694,302.00791 479.69113,305.94415 479.69113,305.94415 C 475.61274,304.77367 472.0672,303.71042 467.776,303.07198 z' fill='%23fff'/%3E %3Cpath d='M 417.66893,245.94368 C 417.66893,245.94368 430.00969,242.9651 431.49858,243.39073' stroke='%23fff'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'%3E %3Crect width='1200' height='800' fill='%23005BBB'/%3E %3Crect width='1200' height='400' y='400' fill='%23FFD500'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 72 48'%3E %3Cpath d='M0,48V0H72z' fill='%231eb53a'/%3E %3Cpath d='M0,48H72V0z' fill='%2300a3dd'/%3E %3Cpath d='M0,48 72,0' stroke='%23fcd116' stroke-width='19'/%3E %3Cpath d='M0,48 72,0' stroke='%23000' stroke-width='13'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg%3E %3Csvg width='900' height='600' viewBox='-60 -40 240 160' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Crect x='-60' y='-40' width='100%25' height='100%25' fill='%23fe0000'/%3E %3Crect x='-60' y='-40' width='50%25' height='50%25' fill='%23000095'/%3E %3Cpath id='four_rays' d='M 8,0 L 0,30 L -8,0 L 0,-30 M 0,8 L 30,0 L 0,-8 L -30,0' fill='%23fff'/%3E %3Cuse xlink:href='%23four_rays' transform='rotate(30)'/%3E %3Cuse xlink:href='%23four_rays' transform='rotate(60)'/%3E %3Ccircle r='17' fill='%23000095'/%3E %3Ccircle r='15' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM0,300V400H300V0H600z'/%3E %3C/clipPath%3E %3Cpath id='star' fill='%23ffce00' d='M0,-50.0808 29.4368,40.5162 -47.6297,-15.4758H47.6297L-29.4368,40.5172z'/%3E %3Cuse id='rats' xlink:href='%23star' transform='rotate(36)'/%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%235b97b1'/%3E %3Cuse xlink:href='%23star' x='645.3396' y='540.9936'/%3E %3Cuse xlink:href='%23rats' x='788.0256' y='504.516'/%3E %3Cuse xlink:href='%23rats' x='788.0256' y='382.5324'/%3E %3Cuse xlink:href='%23rats' x='914.0304' y='473.6844'/%3E %3Cuse xlink:href='%23rats' x='914.0304' y='208.2708'/%3E %3Cuse xlink:href='%23star' x='996.4416' y='390.0456'/%3E %3Cuse xlink:href='%23rats' x='1019.928' y='172.0776'/%3E %3Cuse xlink:href='%23star' x='1102.836' y='321.5544'/%3E %3Cuse xlink:href='%23star' x='1102.836' y='87.486'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='480' viewBox='0 0 30 18'%3E %3Crect fill='%23CE1126' width='30' height='18'/%3E %3Cpolygon fill='%23FFF' points='0,0 20.824734,18 30,18 9.175266,0'/%3E %3Cpolygon points='1.52921,0 22.353945,18 28.470789,18 7.646055,0'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800'%3E %3Crect width='1200' height='800' fill='%23E30A17'/%3E %3Ccircle cx='425' cy='400' r='200' style='fill:%23ffffff'/%3E %3Ccircle cx='475' cy='400' r='160' style='fill:%23E30A17'/%3E %3Cpolygon style='fill:%23ffffff' points='583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='960' height='480' viewBox='0 0 96 48'%3E %3Cg fill='%23C10000'%3E %3Crect width='96' height='48'/%3E %3Crect width='40' fill='%23fff' height='24'/%3E %3Crect x='17' y='3' width='6' height='18'/%3E %3Crect x='11' y='9' width='18' height='6'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800' viewBox='-60 -40 120 80'%3E %3Cg fill='%23E70013'%3E %3Crect x='-60' y='-40' width='120' height='80'/%3E %3Ccircle fill='%23FFF' r='20'/%3E %3Ccircle r='15'/%3E %3Ccircle fill='%23FFF' cx='4' r='12'/%3E %3Cpath transform='translate(4)scale(9)rotate(-90)' d='M0,-1 L0.58779,0.80902 L-0.95106,-0.30902 L0.95106,-0.30902 L-0.58779,0.80902z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect fill='%2328ae66' height='600' width='900'/%3E %3Cg fill='%23fff'%3E %3Cpath id='crescent' d='m446.821,66.5425c26.5998,11.4204,45.2364,37.851,45.2364,68.6278,0,41.2242-33.4308,74.6551-74.6545,74.6551-18.4554,0-35.3454-6.70442-48.3768-17.805,8.06162,3.4572,16.8702,5.5458,26.1504,5.9508,41.1846,1.7982,76.0418-30.1422,77.8398-71.3268,1.04399-23.9112-9.28683-45.6876-26.1954-60.1017z'/%3E %3Cpath id='star' d='m375.616,121.42,8.4582-26.0328-22.1448,16.089,27.3726,0-22.1448-16.089z'/%3E %3Cuse xlink:href='%23star' y='-38.400051' height='600'/%3E %3Cuse xlink:href='%23star' x='37.936928' y='-18.722051'/%3E %3Cuse xlink:href='%23star' x='-37.936072' y='18.721949'/%3E %3Cuse xlink:href='%23star' y='38.399949' height='600'/%3E %3C/g%3E %3Cg id='carpets' fill='%23383739'%3E %3Crect fill='%23ca3745' width='162' height='600' x='107.998'/%3E %3Cg id='ornm5'%3E %3Cg id='ornm'%3E %3Cpath d='m107.998-39.6189v5.87932l9.11017,8.52746-3.07221,2.86017,6.51492,6.03814-2.86017,2.59534v-3.76059h-5.56153v4.50212l12.553,11.7585h6.35594l0.68864-4.13136h-3.65475l3.97238-3.70763,9.95763,9.0572-9.95763,9.11017-3.97238-3.70763h3.65475l-0.68864-4.18432h-6.35594l-12.553,11.7586v4.50212h5.56153v-3.76059l2.86017,2.59534-6.51492,6.03814,3.07221,2.91305-9.11017,8.47458v5.87932l15.413-14.3539-3.07204-2.91305,6.46187-6.03814-5.56153-5.19068,3.7078-3.38983,7.09729,6.5678,15.5722-14.3008-15.5722-14.3008-7.09729,6.62076-3.7078-3.4428,5.56153-5.19068-6.46187-6.03814,3.07204-2.86017-15.413-14.4068zm0,28.5488v22.1398l3.60169-3.65466v-4.29019h3.81356l3.07186-3.125-3.07186-3.07203h-3.81356v-4.34322l-3.60169-3.65466zm26.2712,7.83898-0.52983,3.01907,0.52983,3.07203,3.28373-3.07203-3.28373-3.01907z'/%3E %3Cpath fill='%23faae29' d='m107.998-38.9833v4.66102l9.74576,9.11017-3.0722,2.86017,6.51491,6.03814-3.91949,3.65466v-4.39619h-4.71407v3.91949l12.3412,11.4936h5.72034l0.58254-3.2839h-4.23729l5.08475-4.76695,10.5932,9.6928-10.5932,9.6928-5.08475-4.71398h4.23729l-0.584-3.33686h-5.72034l-12.3412,11.4936v3.91949h4.71407v-4.39619l3.91949,3.65466-6.51491,6.03814,3.0722,2.91305-9.74576,9.05729v4.66102l14.7774-13.7183-3.07203-2.91305,6.46187-6.03814-5.56153-5.19068,4.34339-4.02542,7.09729,6.62076,14.8836-13.7182-14.8836-13.7182-7.09729,6.62076-4.34339-4.02542,5.56153-5.19068-6.46187-6.03814,3.07203-2.86017-14.7774-13.7712zm0,28.5488v20.8686l3.17796-3.17797v-4.60798h4.07831l2.6483-2.64831-2.6483-2.64831h-4.07831v-4.60805l-3.17796-3.17797zm26.5888,8.05085-0.37068,2.17161,0.37068,2.17161,2.33051-2.17161-2.33051-2.17161z'/%3E %3C/g%3E %3Cuse xlink:href='%23ornm' y='109.20679'/%3E %3Cuse xlink:href='%23ornm' y='222.0051'/%3E %3Cuse xlink:href='%23ornm' y='334.80173'/%3E %3Cuse xlink:href='%23ornm' y='447.59835'/%3E %3C/g%3E %3Cuse xlink:href='%23ornm5' transform='matrix(-1,0,0,1,377.99597,0)'/%3E %3Cpath id='branch' fill='%23faae29' d='m121.14,530.824c0.7992,3.4074,3.5082,5.979,4.1538,9.51299,1.2924-3.6846,2.484-6.77342,1.5942-10.8042-0.6366-2.883-3.06181-4.9392-3.3426-7.902-2.64421,2.37721-3.2136,5.74921-2.4054,9.19321zm-0.67021,14.2764c2.24281,3.075,5.36041,5.4336,8.8032,7.0062-0.678-2.6934,0.594-4.7214,2.0058-6.85978,1.701-2.574,2.5302-5.1024,1.1436-8.06637-0.6462,1.5408-1.5144,2.8206-2.5332,4.1382-1.5066,2.05559-2.4972,3.8832-2.7294,6.51962-1.7424-1.2912-2.508-3.2196-3.4398-5.0856-1.4202-2.673-3.7122-4.9074-6.34498-6.3684,0.6996,2.9982,1.2384,6.16859,3.0948,8.71617zm12.5784,9.16557c-0.47939,1.7076-0.8928,3.4008-0.8004,5.1858-1.482-1.5966-3.45-2.7984-5.2056-4.08479-2.391-1.93381-5.178-3.2976-7.1328-5.76,0.2916,3.62399,1.8426,6.57842,4.7874,8.78337,3.1128,2.32981,6.86699,3.58261,9.93303,6.02879-0.459-3.2958,0.7518-5.9364,1.7844-8.96577,0.86041-2.89499,0.0276-5.83439-1.93559-8.0406,0.0294,2.4456-0.74221,4.5456-1.43041,6.85317zm6.98578,11.133c0.64501,2.5002,2.4366,4.53419,3.66001,6.76441-3.29881-1.023-6.20938-2.8122-9.1914-4.4958-3.55201-1.9338-7.40882-3.165-10.6242-5.7186,1.6002,5.9244,5.5662,9.35877,11.3682,11.1102,3.9672,1.1982,7.31038,0.6006,12.1242,2.5458-0.552-3.2586-1.5246-6.77582-3.0654-9.71401-1.1958-2.12519-2.5218-4.22099-3.2604-6.5616-1.0698,1.9224-1.5762,3.8784-1.011,6.06962zm12.1386,9.0654c1.13581,1.94579,2.63521,3.5832,4.4946,4.875-4.68299,0.29819-8.45156-2.6694-13.017-2.7984-2.81999-0.0792-5.4972,0.7962-8.37301,0.5334,3.4128,2.3028,6.98578,4.3134,11.1408,4.85099,5.4012,0.69841,10.3824-0.66059,16.341-0.129-2.7846-1.96499-4.1778-4.5954-5.9136-7.42377-2.2602-3.5322-4.3932-6.0498-8.78938-6.61799,1.76459,1.9836,2.79179,4.4406,4.11659,6.70982zm16.6314,7.77299c-8.25002,1.4022-16.1556,3.2172-24.5814,3.3006,9.43139,3.288,18.318,3.8826,27.672,0.4878,5.055-1.8348,8.931-2.817,12.7488-2.5434,5.5794,0.4008,12.36,2.6022,19.8642,10.5168l2.9496-2.36041c-10.7554-9.58314-24.8278-11.753-38.6527-9.40237z'/%3E %3Cuse xlink:href='%23branch' transform='matrix(-1,0,0,1,378.03633,0)'/%3E %3Cg id='carp1'%3E %3Cpath d='m128.266,70.3392-12.981-7.96019,0-19.1352,12.981-7.96019,0-10.125,12.267-7.3872,9.80042,0,18.6474-10.4886,40.0332,0,18.648,10.4886,9.80042,0,12.267,7.3872,0,10.125,12.981,7.96019-0.0006,19.1352-12.9804,7.96019,0,10.125-12.267,7.3872-9.80042,0-18.648,10.4886-40.0332,0-18.6474-10.4886-9.80042,0-12.267-7.3872z'/%3E %3Cpath fill='%2328ae66' d='m169.068,7.73279-18.644,10.4873-9.74578,0-11.9704,7.20336,0,10.1165-12.9767,7.94494,0,18.644,12.9767,7.94494,0,10.1695,11.9174,7.20336,9.79875,0,18.644,10.4873,39.8305,0,18.644-10.4873,9.79874,0,11.9704-7.20336,0-10.1695,12.9767-7.94494,0-18.644-12.9767-7.94494,0-10.1165-11.9704-7.20336-9.79874,0-18.644-10.4873-39.8305,0zm1.11229,3.86653,37.6589,0,18.644,10.4873,9.74578,0,9.05717,5.45551,0,10.1165,13.0296,7.94494,0,14.4068-13.0296,7.94494,0,10.1165-9.05717,5.45551-9.74578,0-18.644,10.4873-37.6589,0-18.644-10.4873-9.74578,0-9.11014-5.45551,0-10.1165-12.9767-7.94494,0-14.4068,12.9767-7.94494,0-10.1165,9.11014-5.45551,9.74578,0,18.644-10.4873z'/%3E %3Cpath fill='%23faae29' d='m188.783,53.0252,0-41.0085-18.5058,0-18.6486,10.4886-9.72181,0-8.79479,5.2962,0,10.1004-12.9804,7.95959,0,6.73559,69.0807-0.00066,0,41.0095,18.5058,0,18.648-10.4886,9.72241,0,8.79419-5.2962,0-10.0998,12.981-7.96019,0-6.73559z'/%3E %3Cpath fill='%23fff' d='m120.131,53.0254-0.0006,6.73559,12.981,7.96019,0,10.0998,8.79419,5.2962,9.72241,0,18.648,10.4886,18.5064,0,0-41.0095,69.0807,0.000661,0-6.73559-12.981-7.95959,0-10.1004-8.79419-5.2962-9.72241,0-18.648-10.4886-18.5058,0,0,41.0085z'/%3E %3Cg id='carp1h'%3E %3Cg id='carp1q'%3E %3Cpath d='m148.448,26.2804-3.1956-2.9784-3.1662,1.9524,3.201,2.9844-4.11,2.5464,8.96877,0,7.72921,7.29062,2.47261-2.6112-7.515-7.08902,0-4.812z'/%3E %3Cpath d='m163.573,24.9719-3.1956-2.9784-3.1662,1.9524,3.201,2.9844-4.11,2.5464,8.96877,0,7.72922,7.29062,2.47259-2.6112-7.51499-7.08902,0-4.812z'/%3E %3Cpath d='m147.339,34.8358-3.1956-2.9784-3.1656,1.9524,3.2004,2.9844-4.1094,2.5464,8.96877,0,7.72861,7.29062,2.4726-2.6112-7.51499-7.08902,0-4.812z'/%3E %3Cpath d='m188.997,11.5889-8.09309,0-4.23481,4.0812-8.25542,0-6.1002,3.1662,1.4226,3.4662,5.44021-2.8572,2.38259,0,8.34119,9.6468,9.09717-5.5398z'/%3E %3Cpath fill='%23ca3745' d='m145.199,23.8378,2.8716,2.6766-2.406,1.4904-2.8758-2.6808,2.4102-1.4862zm7.20541,0.495,0,4.227,7.3374,6.92158-1.884,1.9896-7.54141-7.11418-7.63559,0,9.72361-6.02398z'/%3E %3Cpath fill='%23ca3745' d='m160.324,22.5293,2.8716,2.6766-2.406,1.4904-2.8752-2.6808,2.4096-1.4862zm7.2054,0.495,0,4.227,7.33741,6.92158-1.88399,1.9896-7.54142-7.11358-7.63559,0,9.72362-6.02458z'/%3E %3Cpath fill='%23ca3745' d='m144.091,32.3932,2.871,2.6766-2.406,1.4904-2.8752-2.6808,2.4102-1.4862zm7.2048,0.495,0,4.227,7.33741,6.92158-1.88341,1.9896-7.54142-7.11358-7.63618,0,9.72361-6.02458z'/%3E %3Cpath fill='%23ca3745' d='m188.783,12.0166-7.70603,0-4.23481,4.0812-8.32377,0-5.6604,2.9376,1.095,2.6688,5.1168-2.6868,2.68501,0,8.232,9.52081,8.79623-5.3562z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp1q' transform='matrix(1,0,0,-1,0,105.62254)'/%3E %3Cpath d='m143.054,39.7108-3.8586-1.4418-0.0924,0.0642-4.98241,3.4572,0,0.929397-7.98,10.0914,7.98,10.0914,0,0.929998,5.07481,3.5208,3.8586-1.4418-2.355-1.5594,0-2.967,0.93599-1.1196,4.18141,0,0-14.9088-4.18141,0-0.93599-1.1196,0-2.967z'/%3E %3Cpath fill='%23ca3745' d='m134.549,42.0137,4.7064-3.2652,2.862,1.0692-1.8468,1.2228,0,3.3522,1.164,1.392,3.9528,0,0,14.0532-3.9528,0-1.164,1.392,0,3.3522,1.8468,1.2228-2.862,1.0692-4.7064-3.2652,0.0006-0.855-7.86302-9.94258,7.86302-9.94318z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp1h' transform='matrix(-1,0,0,1,377.99368,0)'/%3E %3Cpath d='m136.203,61.2822-2.1726-1.8798v-0.906l-4.6608-5.685,4.66141-5.6856v-0.9054l2.17259-1.8798,3.90241,3.1734-2.25241-0.0174,3.32821,3.378,7.60502,0,5.9808-4.677,0-12.3342,14.9586,0,17.3724-10.6608,0-2.796-2.6568-1.7706-0.8418,0-2.8932,1.9362-0.4482,1.4442-2.2632-3.09,4.3986-3.6954,0.7032,0,4.9638-3.642,1.8714,0,4.9632,3.642,0.70381,0,4.3986,3.6954-2.2632,3.09-0.44821-1.4442-2.8932-1.9362-0.8418,0-2.65679,1.7706,0,2.796,17.3724,10.6608,14.9586,0,0,12.3342,5.9808,4.677,7.60502,0,3.3282-3.378-2.2524,0.0174,3.9024-3.1734,2.1726,1.8798,0,0.9054,4.6614,5.6856-4.6614,5.685,0,0.906-2.1726,1.8798-3.9024-3.1734,2.2524,0.0174-3.3282-3.3786-7.60502,0-5.9808,4.6776,0,12.3342-14.9586,0-17.3724,10.6608,0,2.796,2.65679,1.7706,0.8418,0,2.8932-1.9362,0.44821-1.4442,2.2632,3.0894-4.3986,3.696-0.70381,0-4.9632,3.642-1.8714,0-4.9638-3.642-0.7032,0-4.3992-3.696,2.2638-3.0894,0.4482,1.4442,2.8926,1.9362,0.8418,0,2.6574-1.7706,0-2.796-17.3724-10.6608-14.9586,0,0-12.3342-5.98141-4.6776-7.60441,0-3.32821,3.3786,2.25241-0.0174z'/%3E %3Cpath fill='%23faae29' d='m189.211,87.3189,1.9014,1.45379-1.9014,1.4538,0-2.9076zm-6.0438,2.6442,0.0702,0,4.9638,3.6426,0.5796,0,0-2.8416-2.604-1.9914,2.6046-1.9914,0-5.3376-18.5892-11.4078-13.7418,0,0-11.4624-7.09502-5.5488-10.7016,0-2.6898,3.0414-2.68979-3.0414-3.17581,0.0006,4.35961,5.3172,0,0.863402,1.72679,1.5,2.7744-2.16-1.62839,0.0126,0-0.54,3.62879-3.699,7.974,0,6.26223,4.8972,0,12.1146,14.6514,0,17.679,10.8492,0,3.264-2.95559,1.9698-1.1022,0-3.1266-2.0928-0.24061-0.776398-1.5246,2.0808,3.9732,3.3372,0.6174,0zm-47.2008-39.7602,2.11801,2.394-4.2366,0,2.11859-2.394zm52.8156-34.8072-1.9002,1.4538,1.9002,1.4532,0-2.907zm51.1272,37.6296,2.118,2.394,2.118-2.394-4.236,0zm-45.1542-37.3668-4.9638-3.642-0.5796,0,0,2.8404,2.6052,1.9926-2.6058,1.9926,0,5.3364,18.5892,11.4078,13.7418,0,0,11.4624,7.09502,5.5488,10.6998,0,2.69039-3.0408,2.69041,3.0402,3.1764,0-4.3596-5.3172,0-0.863402-1.7268-1.5-2.77441,2.16,1.62841-0.0132,0,0.5406-3.62881,3.6984-7.974,0-6.26162-4.8972,0-12.114-14.652,0-17.679-10.8492,0-3.2646,2.9556-1.9692,1.1022,0,3.1266,2.0928,0.2406,0.776399,1.5246-2.0808-3.9732-3.3378-0.6876,0z'/%3E %3Cpath fill='%23fff' d='m188.782,90.2262-1.9002-1.4532,1.9002-1.4532,0,2.9064zm-50.6976-37.2006-2.118,2.394-2.11801-2.394,4.23601,0zm56.7408,36.9378-0.0702,0-4.9638,3.6426-0.5796,0,0-0.744005,0-2.0964,2.6052-1.9926-2.6058-1.9926,0-5.3364,18.5892-11.4078,13.7418,0,0-11.4624,7.09503-5.5488,10.7004,0,2.6898,3.0414,2.6898-3.0414,3.177,0.000599-4.3596,5.3172,0,0.863402-1.7268,1.5-2.7744-2.16,1.6284,0.0126,0-0.54-3.6288-3.699-7.974,0-6.26163,4.8972,0,12.1146-14.652,0-17.679,10.8492,0,3.264,2.9556,1.9698,1.1022,0,3.1266-2.0928,0.2406-0.776399,1.5246,2.0808-3.9732,3.3372-0.6174,0zm47.202-39.7602-2.11799,2.394,4.2366,0-2.11861-2.394zm-58.7886-34.5444,4.96381-3.642,0.5802,0,0,2.8404-2.6058,1.9926,2.6058,1.9926,0.0006,5.3364-18.5898,11.4078-13.7412,0,0,11.4624-7.09562,5.5488-10.7028,0-2.6898-3.0408-2.6904,3.0402-3.174,0,4.3602-5.3172,0-0.863401,1.7268-1.5,2.7738,2.16-1.6284-0.0132,0,0.5406,3.6294,3.6984,7.9734,0,6.26223-4.8972,0-12.114,14.6514,0,17.6796-10.8492,0-3.2646-2.9556-1.9692-1.1028,0-3.1266,2.0928-0.2406,0.776399-1.524-2.0808,3.9732-3.3378,0.687,0zm5.97241,2.6448,1.9014-1.4538-1.9014-1.4538,0,2.9076z'/%3E %3Cpath fill='%2328ae66' d='m188.783,53.0252,0-28.3449-18.4686,11.334-13.4346,0,0,11.2428-6.82801,5.34,39.1602-0.00066,0,28.3453,18.4674-11.3334,13.4346,0,0-11.2428,6.82801-5.34z'/%3E %3Cpath fill='%23ca3745' d='m150.051,53.0254,6.82861,5.34,0,11.2428,13.434,0,18.4692,11.334,0-28.3459,39.159,0.000661-6.82801-5.34,0-11.2428-13.4346,0-18.4674-11.3334,0,28.3443z'/%3E %3Cpath d='m169.118,39.0635-3.195-2.9784-3.16621,1.9518,3.201,2.9844-4.11,2.5464,8.96877,0,7.72922,7.29122,2.4726-2.6118-7.515-7.08902,0-4.8114z'/%3E %3Cpath d='m208.873,66.5593,3.1956,2.9784,3.1656-1.9524-3.2004-2.9844,4.11-2.5458-8.96937,0-7.72861-7.29123-2.4726,2.6112,7.51499,7.08962,0,4.8114z'/%3E %3Cpath d='m169.118,66.5593-3.1956,2.9784-3.16561-1.9524,3.2004-2.9844-4.1094-2.5458,8.96877,0,7.72861-7.29123,2.47261,2.6112-7.515,7.08962,0,4.8114z'/%3E %3Cpath d='m208.873,39.0635,3.1956-2.9784,3.1656,1.9518-3.2004,2.9844,4.11,2.5464-8.96937,0-7.72861,7.29122-2.4726-2.6118,7.51499-7.08902,0-4.8114z'/%3E %3Cpath fill='%23ca3745' d='m212.122,69.0018-2.871-2.6766,2.406-1.4904,2.8752,2.6808-2.4102,1.4862zm-7.2048-0.495,0-4.2264-7.33741-6.92158,1.884-1.9902,7.54142,7.11418,7.63559,0-9.72362,6.02398zm-39.0468-31.8865,2.8716,2.6766-2.40659,1.491-2.87521-2.6808,2.4102-1.4868zm7.20541,0.4956,0,4.2264,7.33741,6.92158-1.884,1.9902-7.54142-7.11418-7.63559,0,9.72362-6.02398z'/%3E %3Cpath fill='%2328ae66' d='m212.122,36.6203-2.871,2.6766,2.406,1.491,2.8752-2.6808-2.4102-1.4868zm-7.2048,0.4956,0,4.2264-7.33741,6.92158,1.884,1.9902,7.54142-7.11418,7.63559,0-9.72362-6.02398zm-39.0468,31.8859,2.871-2.6766-2.40599-1.4904-2.87521,2.6808,2.4102,1.4862zm7.20481-0.495,0-4.2264,7.33741-6.92158-1.8834-1.9902-7.54142,7.11418-7.63619,0,9.72362,6.02398z'/%3E %3Cpath d='M208.856,52.8119,188.997,66.047,169.138,52.8119,188.997,39.5759z'/%3E %3Cpath fill='%23fff' d='m188.783,40.2328-18.5514,12.3642,37.5318,0-18.5514-12.3642,0,25.1568,18.552-12.3642-37.533,0,18.552,12.3642z'/%3E %3Cpath d='m194.308,57.3629,0,3.639-10.6206,0,0-3.639-6.87359,0,0-9.10318,6.87359,0,0-3.639,10.6206,0,0,3.639,6.87299,0,0,9.10318z'/%3E %3Cpath fill='%23ca3745' d='m184.116,45.0484,0,3.639-6.87299,0,0,3.9096,11.5404,0,0-7.54862-4.6674,0zm5.0964,7.54862,11.5404,0,0-3.9096-6.87299,0,0-3.639-4.6674,0,0,7.54862zm-11.9694,0.4284,0,3.9096,6.873,0,0,3.639,4.6674,0,0-7.54862-11.5404,0zm11.9694,7.54862,4.6674,0,0-3.639,6.873,0,0-3.9096-11.5404,0,0,7.54862z'/%3E %3C/g%3E %3Cg id='carp2'%3E %3Cpath d='m222.877,203.61,0-5.8302,15.9882,0,0-5.8302,15.9882,0,0-52.6812-15.9882,0,0-5.8302-15.9882,0,0-5.8302-15.9882,0,0-5.8302-35.7822,0,0,5.8302-15.9882,0,0,5.8302-15.9888,0,0,5.8302-15.9882,0,0,52.6812,15.9882,0,0,5.8302,15.9888,0,0,5.8302,15.9882,0,0,5.83019,35.7822,0,0-5.83019z'/%3E %3Cpath fill='%23ca3745' d='m171.558,122.193v5.8261h-15.9963v5.82644h-15.9956v5.8261h-15.9959v51.8539h15.9959v5.82712h15.9956v5.82543h15.9963v5.82542h34.9034v-5.82542h15.9966v-5.82543h15.9966v-5.82712h15.9949v-51.8539h-15.9949v-5.8261h-15.9966v-5.82644h-15.9966v-5.8261h-34.9034zm4.23729,4.23729h26.4288v5.8261h15.9966v5.82644h15.9966v5.8261h15.9949v43.3793h-15.9949v5.82712h-15.9966v5.82542h-15.9966v5.82542h-26.4288v-5.82542h-15.9963v-5.82542h-15.9956v-5.82712h-15.9959v-43.3793h15.9959v-5.8261h15.9956v-5.82644h15.9963v-5.8261z'/%3E %3Cpath fill='%23ca3745' d='m160.209,198.519,0-5.8308-15.9882,0,0-5.8296-15.9888,0,0-42.5004,15.9888,0,0-5.8302,15.9882,0,0-5.8302,15.9882,0,0-5.8296,25.6008,0,0,5.8296,15.9888,0,0,5.8302,15.9876,0,0,5.8302,15.9888,0,0,42.5004-15.9888,0,0,5.8296-15.9876,0,0,5.8308-15.9888,0,0,5.8296-25.6008,0,0-5.8296z'/%3E %3Cpath d='m163.921,137.014-4.1412-3.1302,0,6.0108-3.9654,2.52-0.0102-3.7626-3.8034,3.4164-3.8034-3.4164-0.0102,3.7626-4.3944-2.7924,0,5.5728-3.5514,2.571-0.01-3.417-4.2192,3.0558-4.2192-3.0558-0.01,3.417-3.97981-2.8812,0,16.8816-4.662,0,0,7.6842,4.662,0,0,16.8816,3.97981-2.8818,0.01,3.4176,4.2192-3.0558,4.2186,3.0558,0.0102-3.4176,3.5514,2.571,0,5.5734,4.3944-2.7924,0.0102,3.7626,3.8034-3.4164,3.8034,3.4164,0.0102-3.7626,3.9654,2.5194,0,6.0114,4.1412-3.1302,0.009,4.1982,4.0584-3.6294,4.059,3.6294,0.009-4.1982,3.7128,2.8062,0,6.411,5.5512-5.0598,0,5.946,7.6776-4.9362,7.6782,4.9362,0-5.946,5.5512,5.0598,0-6.411,3.7122-2.8062,0.009,4.1982,4.059-3.6294,4.059,3.6294,0.009-4.1982,4.14001,3.1302,0-6.0114,3.9666-2.5194,0.01,3.7626,3.804-3.4164,3.8034,3.4164,0.01-3.7626,4.395,2.7924,0-5.5734,3.5514-2.571,0.01,3.4176,4.2186-3.0558,4.2192,3.0558,0.01-3.4176,3.9798,2.8812,0-16.881,4.662,0,0-7.6842-4.662,0,0-16.8816-3.9798,2.8812-0.01-3.417-4.2192,3.0558-4.2192-3.0558-0.009,3.417-3.5514-2.571,0-5.5728-4.395,2.7924-0.01-3.7626-3.8034,3.4164-3.804-3.4164-0.01,3.7626-3.9666-2.5206,0-6.0102-4.14001,3.1296-0.009-4.1982-4.059,3.63-4.059-3.63-0.009,4.1988-3.7122-2.8074,0-6.4098-5.5512,5.0598,0-5.946-7.6782,4.9362-7.6776-4.9362,0,5.946-5.5512-5.0598,0,6.4104-3.7128,2.8068-0.009-4.1988-4.059,3.63-4.0584-3.63z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='m132.21,148.604,0.01-3.4176,3.7926,2.7474,0.1278-0.093,3.6648-2.6544,0.01,3.4176,3.978-2.8794,0,39.768-3.978-2.8794-0.01,3.4176-3.7926-2.7474-3.7926,2.7474-0.01-3.4176-3.97801,2.8794,0-16.4706-4.662,0,0-6.8268,4.662,0,0-16.4706z'/%3E %3Cpath d='m164.356,133.772,3.6324,3.2484,3.6324-3.2484,0.009,4.1022,4.1388-3.129,0,61.7274-4.1388-3.129-0.009,4.1022-3.6324-3.2484-3.6324,3.2484-0.008-4.1022-4.1388,3.129,0-61.7274,4.1388,3.129z'/%3E %3Cpath d='m213.64,133.772-3.6324,3.2484-3.6324-3.2484-0.009,4.1022-4.1382-3.129,0,61.7274,4.1382-3.129,0.009,4.1022,3.6324-3.2484,3.6324,3.2484,0.009-4.1022,4.13881,3.129,0-61.7274-4.13881,3.129z'/%3E %3Cpath d='m245.786,148.604-0.01-3.4176-3.7926,2.7474-0.1284-0.093-3.6648-2.6544-0.01,3.4176-3.9774-2.8794,0,39.768,3.9774-2.8794,0.01,3.4176,3.7932-2.7474,3.7926,2.7474,0.01-3.4176,3.9774,2.8794,0-16.4706,4.662,0,0-6.8268-4.662,0,0-16.4706z'/%3E %3C/g%3E %3Cg fill='%23faae29'%3E %3Cpath d='m148.623,139.611,3.3774,3.0342,3.3774-3.0342,0.01,3.5832,4.3926-2.7918,0,50.4126-4.3926-2.7912-0.01,3.5826-3.3774-3.0336-3.3774,3.0336-0.01-3.5826-4.3926,2.7912,0-50.4126,4.3926,2.7918z'/%3E %3Cpath d='m181.748,133.827-5.5512-5.0598,0,73.6824,5.5512-5.0598,0,6.1314,7.2486-4.6602,0.0006,0,0.0006,0,7.2486,4.6602,0-6.1314,5.5512,5.0598,0-73.6824-5.5512,5.0598,0-6.1314-7.2486,4.6602-0.0006,0-0.0006,0-7.2486-4.6602z'/%3E %3Cpath d='m229.373,139.611-3.3774,3.0342-3.378-3.0342-0.009,3.5832-4.3932-2.7918,0,50.4126,4.3932-2.7912,0.009,3.5826,3.378-3.0336,3.3774,3.0336,0.01-3.5826,4.3926,2.7912,0-50.4126-4.3926,2.7918z'/%3E %3C/g%3E %3Cg id='carp2h'%3E %3Cg id='carp2q'%3E %3Cpath d='m134.288,158.366c0.4854,0.4896,1.0656,0.7374,1.7244,0.7374,0.6582,0,1.2384-0.2478,1.7244-0.7374,1.5186-1.53,1.5696-4.2972,1.5546-6.28859,0,0-1.7556,1.85521-2.0724,2.19-0.2208-0.38159-1.2066-2.08379-1.2066-2.08379s-0.9858,1.7022-1.2072,2.08379c-0.3168-0.33479-2.0724-2.19-2.0724-2.19-0.015,1.9914,0.0366,4.7586,1.5552,6.28859z'/%3E %3Cpath d='m150.966,154.08-1.2792-1.278,0-2.54639-2.9376,2.7228,5.2512,5.2512,5.2512-5.2512-2.9376-2.7228,0,2.54639-1.2786,1.278,0-4.5114,2.265-1.94459-3.3-2.8338-3.3,2.8338,2.2656,1.94459z'/%3E %3Cpath d='m166.953,149.02-1.2786-1.2786,0-2.5464-2.9376,2.7228,5.2512,5.2512,5.2512-5.2512-2.93761-2.7228,0,2.5464-1.2792,1.2786,0-4.512,2.26561-1.9446-3.3-2.8332-3.3,2.8332,2.265,1.9446z'/%3E %3Cpath fill='%23fff' d='m136.013,153.039c0.2622,0.4524,1.12319,1.9398,1.12319,1.9398s1.2132-1.2828,1.7088-1.8054c-0.0594,2.2488-0.5532,4.0254-1.41179,4.89-0.4026,0.4056-0.8802,0.6114-1.4202,0.6114-0.5406,0-1.01821-0.2058-1.4202-0.6108-0.85861-0.8652-1.35241-2.6418-1.41181-4.8906,0.495,0.5232,1.70821,1.8054,1.70821,1.8054,0.37439-0.6468,0.7494-1.2936,1.1238-1.9398z'/%3E %3Cpath fill='%23fff' d='m168.595,144.312,0,5.7432,2.136-2.1354,0-1.7424,1.8912,1.7532-4.6332,4.63319-4.6338-4.63319,1.8912-1.7532,0,1.7424,2.136,2.1354,0-5.7432-2.0358-1.7478,2.6424-2.2686,2.6418,2.2686z'/%3E %3Cpath fill='%23ca3745' d='m152.607,149.372,0,5.7432,2.136-2.136,0-1.7418,1.89119,1.7526-4.6338,4.6338-4.6332-4.6338,1.89121-1.7526,0,1.7418,2.13599,2.136,0-5.7432-2.0358-1.7478,2.6418-2.2686,2.6424,2.2686z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp2q' transform='matrix(-1,0,0,1,377.9958,0)'/%3E %3Cpath d='m195.282,150.937-1.7202-2.3772,4.4112-4.0722-4.11301-3.37919,0,2.39399-1.72019,1.4718,0-4.34219,3.88559-2.86381-7.02902-5.181-7.02902,5.181,3.88621,2.86381,0,4.34219-1.72021-1.4718,0-2.39399-4.1136,3.37919,4.4118,4.0722-1.7202,2.3772z'/%3E %3Cpath fill='%23ca3745' d='m183.552,150.509,1.4508-2.0058-4.32901-3.996,3.03181-2.49119,0,1.68419,2.5776,2.2056,0-5.49-3.5922-2.6472,6.3066-4.64819,6.30661,4.64819-3.5916,2.6472,0,5.49,2.577-2.2056,0-1.68419,3.0324,2.49119-4.329,3.996,1.4514,2.0058z'/%3E %3Cpath d='m185.785,137.769,3.21181,2.367,3.21239-2.367-3.21239-2.3676-0.1272,0.0942z'/%3E %3Cpath fill='%2328ae66' d='m188.997,135.934c0.2124,0.156,2.1144,1.55819,2.49,1.83479-0.3756,0.2766-2.2776,1.6788-2.49,1.83481-0.2118-0.15601-2.1144-1.55821-2.4894-1.83481,0.375-0.2766,2.2776-1.67879,2.4894-1.83479z'/%3E %3C/g%3E %3Cuse xlink:href='%23carp2h' transform='matrix(1,0,0,-1,0,331.21644)'/%3E %3Cpath d='m245.902,163.15-7.0374,0,0-2.805-21.5106,0-14.9742-9.83579-0.0636,0-26.7012,0-14.9736,9.83579-21.5112,0,0,2.805-7.0374,0,0,4.9176,7.0374,0,0,2.805,21.5112,0,14.9736,9.8364,26.7648,0,14.9742-9.8364,21.5106,0,0-2.805,7.0374,0z'/%3E %3Cpath fill='%23ca3745' d='m175.742,150.953-14.9894,9.79873-21.1864,0,0,2.8072-7.04449,0,0,4.07839,7.04449,0,0,2.8072,21.1864,0,14.9894,9.8517,26.5359,0,14.9364-9.8517,21.2393,0,0-2.8072,7.04449,0,0-4.07839-7.04449,0,0-2.8072-21.2393,0-14.9364-9.79873zm0.31779,1.43008,25.8475,0,13.7182,9.00424,0,1.37712,15.3072,0,0,5.72034-15.3072,0,0,1.37712-13.7182,8.95127-25.8475,0-13.6652-8.95127,0-1.37712-15.3602,0,0-5.72034,15.3602,0,0-1.37712z'/%3E %3Cpath fill='%23ca3745' d='m201.799,152.826,13.3788,8.7834,0,1.5588,15.3318,0,0,4.8804-15.3318,0,0,1.5594-13.3788,8.7834-25.6044,0-13.3788-8.7834,0-1.5594-15.3318,0,0-4.8804,15.3318,0,0-1.5588,13.3788-8.7834z'/%3E %3Cg%3E %3Cpath d='m169.551,170.598,5.793,4.3488,3.8106-2.8614-2.2152-1.6632-1.5954,1.1982-1.362-1.0224,21.8154-16.3788-4.4304,0zm12.645,6.40077,4.4304,0,21.816-16.3788-5.79241-4.3482-3.81119,2.86079,2.21519,1.66261,1.596-1.1982,1.362,1.023zm9.17098,0,4.4298,0-21.8148-16.3788,1.362-1.023,1.5954,1.1982,2.2152-1.66261-3.8106-2.86079-5.793,4.3482zm12.645-6.40077-1.362,1.0224-1.596-1.1982-2.21519,1.6632,3.81119,2.8614,5.7924-4.3488-21.816-16.3788-4.4304,0z'/%3E %3Cpath d='m165.164,165.609,3.8934,2.586,3.89341-2.586-3.89341-2.586z'/%3E %3Cpath d='m185.104,165.609,3.8934,2.586,3.8934-2.586-3.8934-2.586z'/%3E %3Cpath d='m212.832,165.609-3.8934,2.586-3.8934-2.586,3.8934-2.586z'/%3E %3Cpath fill='%23faae29' d='m207.729,170.598-5.0784,3.81299-3.0978-2.32559,1.5018-1.1274,1.596,1.1982,2.0754-1.5582-21.2448-15.9498,3.003,0zm-13.2162,5.97179-3.0024,0-21.2448-15.9498,5.079-3.813,3.0966,2.32559-1.5012,1.12681-1.5954-1.1982-2.076,1.5588zm-8.0286,0-3.003,0,21.2448-15.9498-2.0754-1.5588-1.596,1.1982-1.5018-1.12681,3.0978-2.32559,5.0784,3.813zm5.0262-21.9216,3.0024,0-21.2442,15.9498,2.076,1.5582,1.5954-1.1982,1.5012,1.1274-3.0966,2.32559-5.07901-3.81299z'/%3E %3Cpath fill='%2328ae66' d='m169.057,163.538,3.1188,2.0712-3.1188,2.0712-3.1188-2.0712z'/%3E %3Cpath fill='%2328ae66' d='m188.998,163.538,3.1188,2.0712-3.1188,2.0712-3.1182-2.0712z'/%3E %3Cpath fill='%2328ae66' d='m208.939,163.538-3.1188,2.0712,3.1188,2.0712,3.1182-2.0712z'/%3E %3C/g%3E %3C/g%3E %3Cg id='carp3'%3E %3Cg%3E %3Cpath d='m120.514,274.151-1.5276,2.1606,2.7384,2.094-2.739,2.0946,1.5276,2.1606,3.1818,0.3696,3.081-2.3808,7.68181,4.8798,0-4.0524-4.8348-3.0714,4.8348-3.0708,0-4.0524-7.68181,4.8798-3.081-2.3802z'/%3E %3Cpath d='m120.514,260.073-1.5276,2.16119,2.7384,2.094-2.739,2.094,1.5276,2.1612,3.1818,0.369,3.081-2.3808,7.68181,4.8804,0-4.053-4.8348-3.0708,4.8348-3.07139,0-4.0524-7.68181,4.87979-3.081-2.38019z'/%3E %3Cpath d='m120.514,296.739-1.5276-2.1606,2.7384-2.094-2.739-2.0946,1.5276-2.1606,3.1818-0.369,3.081,2.3802,7.68181-4.8798,0,4.0524-4.8348,3.0714,4.8348,3.0708,0,4.0524-7.68181-4.8798-3.081,2.3808z'/%3E %3Cpath d='m257.482,274.151,1.5276,2.1606-2.7384,2.094,2.7384,2.0946-1.5276,2.1606-3.1812,0.3696-3.081-2.3808-7.6824,4.8798,0-4.0524,4.8354-3.0714-4.8354-3.0708,0-4.0524,7.6824,4.8798,3.081-2.3802z'/%3E %3Cpath d='m257.482,260.073,1.5276,2.16119-2.7384,2.094,2.7384,2.094-1.5276,2.1612-3.1812,0.369-3.081-2.3808-7.6824,4.8804,0-4.053,4.8354-3.0708-4.8354-3.07139,0-4.0524,7.6824,4.87979,3.081-2.38019z'/%3E %3Cpath d='m257.482,296.739,1.5276-2.1606-2.7384-2.094,2.7384-2.0946-1.5276-2.1606-3.1812-0.369-3.081,2.3802-7.6824-4.8798,0,4.0524,4.8354,3.0714-4.8354,3.0708,0,4.0524,7.6824-4.8798,3.081,2.3808z'/%3E %3Cpath d='m226.727,235.73,0,5.856,4.25941,0,0,2.5878,4.1844,0,0-4.7124h-3.73201v-3.7314h-4.7118z'/%3E %3Cpath d='m239.283,244.965,0,5.8554,4.25521,0,0,2.5884,4.1886,0,0-4.7124h-3.73141v-3.7314h-4.7124z'/%3E %3Cpath d='m151.269,235.73,0,5.856-4.2606,0,0,2.5878-4.18321,0,0-4.7124h3.73141v-3.7314h4.7124z'/%3E %3Cpath d='m226.727,321.083,0-5.856,4.25941,0,0-2.58779,4.1844,0,0,4.7118h-3.73201v3.73199h-4.7118z'/%3E %3Cpath d='m151.269,321.083,0-5.856-4.2606,0,0-2.58779-4.18321,0,0,4.7118h3.73141v3.73199h4.7124z'/%3E %3Cpath d='m239.283,311.848,0-5.85539,4.25521,0,0-2.5884,4.1886,0,0,4.7118h-3.73141v3.73199h-4.7124z'/%3E %3Cpath d='m138.714,244.965,0,5.8554-4.2564,0,0,2.5884-4.18741,0,0-4.7124h3.73141v-3.7314h4.7124z'/%3E %3Cpath d='m138.714,311.848,0-5.85539-4.2564,0,0-2.5884-4.18741,0,0,4.7118h3.73141v3.73199h4.7124z'/%3E %3Cpath d='m204.753,235.594c-0.27181-0.264-3.2508-3.156-3.2508-3.156l-3.19321,2.95861s2.502,2.42819,2.7834,2.70179l-3.5928,3.4878h5.33401l1.9194-1.8636,1.9194,1.8636h5.3334l-3.5928-3.4878c0.2814-0.2736,2.7828-2.70179,2.7828-2.70179l-3.1926-2.95861c-1.08481,1.05061-2.1672,2.10361-3.2502,3.156z'/%3E %3Cpath d='m188.998,235.594c-0.2712-0.264-3.2502-3.156-3.2502-3.156l-3.1932,2.95861s2.5014,2.42819,2.7834,2.70179l-3.5928,3.4878h5.3334l1.9194-1.8636,1.9194,1.8636h5.3334l-3.5922-3.4878c0.2814-0.2736,2.7828-2.70179,2.7828-2.70179l-3.1926-2.95861c-1.0848,1.05061-2.1672,2.10361-3.2508,3.156z'/%3E %3Cpath d='m173.244,235.594c0.2718-0.264,3.25079-3.156,3.25079-3.156l3.19321,2.95861s-2.502,2.42819-2.7834,2.70179l3.5928,3.4878h-5.33401l-1.91939-1.8636-1.91941,1.8636h-5.33339l3.59279-3.4878c-0.28139-0.2736-2.7834-2.70179-2.7834-2.70179l3.1932-2.95861c1.08481,1.05061,2.1672,2.10361,3.25021,3.156z'/%3E %3Cpath d='m204.753,321.219c-0.27181,0.2634-3.2508,3.1554-3.2508,3.1554l-3.19321-2.9586s2.502-2.4276,2.7834-2.7012l-3.5928-3.4878h5.33401l1.9194,1.8636,1.9194-1.8636h5.3334l-3.5928,3.4878c0.2814,0.2736,2.7828,2.7012,2.7828,2.7012l-3.1926,2.9586c-1.08481-1.0506-2.1672-2.1036-3.2502-3.1554z'/%3E %3Cpath d='m188.998,321.219c-0.2712,0.2634-3.2502,3.1554-3.2502,3.1554l-3.1932-2.9586s2.5014-2.4276,2.7834-2.7012l-3.5928-3.4878h5.3334l1.9194,1.8636,1.9194-1.8636h5.3334l-3.5922,3.4878c0.2814,0.2736,2.7828,2.7012,2.7828,2.7012l-3.1926,2.9586c-1.0848-1.0506-2.1672-2.1036-3.2508-3.1554z'/%3E %3Cpath d='m173.244,321.219c0.2718,0.2634,3.25079,3.1554,3.25079,3.1554l3.19321-2.9586s-2.502-2.4276-2.7834-2.7012l3.5928-3.4878h-5.33401l-1.91939,1.8636-1.91941-1.8636h-5.33339l3.59279,3.4878c-0.28139,0.2736-2.7834,2.7012-2.7834,2.7012l3.1932,2.9586c1.08481-1.0506,2.1672-2.1036,3.25021-3.1554z'/%3E %3C/g%3E %3Cg fill='%2328ae66'%3E %3Cpath d='m134.029,281.713,0,3.0366-7.27801-4.623-3.1806,2.4582-2.8182-0.327-1.1784-1.6674,2.856-2.184-2.856-2.184,1.179-1.6674,2.8176-0.327,3.1806,2.4576,7.27801-4.623,0,3.0366-5.2062,3.3072z'/%3E %3Cpath d='m134.029,267.635,0,3.0372-7.27801-4.623-3.1806,2.4576-2.8182-0.327-1.1784-1.6674,2.856-2.184-2.856-2.1834,1.179-1.66739,2.8176-0.3276,3.1806,2.45759,7.27801-4.62239,0,3.0366-5.2062,3.30659z'/%3E %3Cpath d='m134.029,289.178,0-3.0366-7.27801,4.623-3.1806-2.4582-2.8182,0.327-1.1784,1.6674,2.856,2.184-2.856,2.184,1.179,1.6674,2.8176,0.327,3.1806-2.4576,7.27801,4.623,0-3.0366-5.2062-3.3072z'/%3E %3Cpath d='m243.967,281.713,0,3.0366,7.278-4.623,3.18,2.4582,2.8182-0.327,1.1784-1.6674-2.856-2.184,2.856-2.184-1.1784-1.6674-2.8182-0.327-3.18,2.4576-7.278-4.623,0,3.0366,5.2056,3.3072z'/%3E %3Cpath d='m243.967,267.635,0,3.0372,7.278-4.623,3.18,2.4576,2.8182-0.327,1.1784-1.6674-2.856-2.184,2.856-2.1834-1.1784-1.66739-2.8182-0.3276-3.18,2.45759-7.278-4.62239,0,3.0366,5.2056,3.30659z'/%3E %3Cpath d='m243.967,289.178,0-3.0366,7.278,4.623,3.18-2.4582,2.8182,0.327,1.1784,1.6674-2.856,2.184,2.856,2.184-1.1784,1.6674-2.8182,0.327-3.18-2.4576-7.278,4.623,0-3.0366,5.2056-3.3072z'/%3E %3Cpath d='m231.011,236.159v3.732h3.73141v3.855h-3.32641v-2.5878h-4.26v-4.9992h3.855z'/%3E %3Cpath d='m243.566,245.393v3.7314h3.7314v3.8556h-3.327v-2.5878h-4.2594v-4.9992h3.855z'/%3E %3Cpath d='m146.985,236.159v3.732h-3.7314v3.855h3.327v-2.5878h4.2594v-4.9992h-3.855z'/%3E %3Cpath d='m231.011,320.653v-3.7314h3.73141v-3.855h-3.32641v2.58781h-4.26v4.99859h3.855z'/%3E %3Cpath d='m146.985,320.653v-3.7314h-3.732v-3.855h3.327v2.58781h4.26v4.99859h-3.855z'/%3E %3Cpath d='m243.566,311.419v-3.7314h3.7314v-3.855h-3.327v2.5878h-4.2594v4.9986h3.855z'/%3E %3Cpath d='m134.43,245.393v3.7314h-3.7314v3.8556h3.327v-2.5878h4.2594v-4.9992h-3.855z'/%3E %3Cpath d='m134.431,311.419v-3.7314h-3.732v-3.855h3.327v2.5878h4.26v4.9986h-3.855z'/%3E %3Cpath d='m201.496,233.029c0.26579,0.258,3.25739,3.162,3.25739,3.162s2.99101-2.904,3.25681-3.162c0.25199,0.2328,2.28539,2.1168,2.5638,2.3748-0.288,0.279-2.7762,2.6946-2.7762,2.6946l3.15119,3.0594h-4.1022l-2.0934-2.0328-2.094,2.0328h-4.1022l3.15121-3.0594s-2.48821-2.4156-2.77621-2.6946c0.2784-0.258,2.3118-2.142,2.56381-2.3748z'/%3E %3Cpath d='m185.741,233.029c0.2658,0.258,3.2568,3.162,3.2568,3.162s2.991-2.904,3.2574-3.162c0.252,0.2328,2.28481,2.1168,2.5632,2.3748-0.2874,0.279-2.7756,2.6946-2.7756,2.6946l3.1512,3.0594h-4.1028l-2.0934-2.0328-2.0934,2.0328h-4.1028l3.1512-3.0594s-2.4882-2.4156-2.7756-2.6946c0.2784-0.258,2.3118-2.142,2.5638-2.3748z'/%3E %3Cpath d='m176.502,233.029c-0.2664,0.258-3.2574,3.162-3.2574,3.162s-2.991-2.904-3.25681-3.162c-0.25199,0.2328-2.28539,2.1168-2.56379,2.3748,0.28799,0.279,2.7762,2.6946,2.7762,2.6946l-3.1512,3.0594h4.1022l2.0934-2.0328,2.094,2.0328h4.1022l-3.1512-3.0594s2.4882-2.4156,2.7762-2.6946c-0.2784-0.258-2.3118-2.142-2.5638-2.3748z'/%3E %3Cpath d='m201.496,323.784c0.26579-0.2586,3.25739-3.1626,3.25739-3.1626s2.99101,2.904,3.25681,3.1626c0.25199-0.2334,2.28539-2.1174,2.5638-2.3748-0.288-0.27959-2.7762-2.69459-2.7762-2.69459l3.15119-3.0594h-4.1022l-2.0934,2.03219-2.094-2.03219h-4.1022l3.15121,3.0594s-2.48821,2.415-2.77621,2.69459c0.2784,0.2574,2.3118,2.1414,2.56381,2.3748z'/%3E %3Cpath d='m185.741,323.784c0.2658-0.2586,3.2568-3.1626,3.2568-3.1626s2.991,2.904,3.2574,3.1626c0.252-0.2334,2.28481-2.1174,2.5632-2.3748-0.2874-0.27959-2.7756-2.69459-2.7756-2.69459l3.1512-3.0594h-4.1028l-2.0934,2.03219-2.0934-2.03219h-4.1028l3.1512,3.0594s-2.4882,2.415-2.7756,2.69459c0.2784,0.2574,2.3118,2.1414,2.5638,2.3748z'/%3E %3Cpath d='m176.502,323.784c-0.2664-0.2586-3.2574-3.1626-3.2574-3.1626s-2.991,2.904-3.25681,3.1626c-0.25199-0.2334-2.28539-2.1174-2.56379-2.3748,0.28799-0.27959,2.7762-2.69459,2.7762-2.69459l-3.1512-3.0594h4.1022l2.0934,2.03219,2.094-2.03219h4.1022l-3.1512,3.0594s2.4882,2.415,2.7762,2.69459c-0.2784,0.2574-2.3118,2.1414-2.5638,2.3748z'/%3E %3C/g%3E %3Cpath d='m146.58,306.421,0,9.234,84.8358,0,0-9.234,12.5508,0,0-56.0292-12.5508,0,0-9.234-84.8358,0,0,9.234-12.5508,0,0,56.0292z'/%3E %3Cpath fill='%23ca3745' d='m147.034,241.578v9.21695h-12.5529v55.1898h12.5529v9.21695h83.9509v-9.21695h12.554v-55.1903h-12.5542v-9.21695h-83.9509zm5.40254,3.54915h73.1467v8.89831l3.01864,2.22542h11.3881v44.3322h-11.4407l-2.9661,2.17119v8.95085h-73.1465v-8.89831l-3.01915-2.22373h-11.4407v-44.3322h11.3878l3.07203-2.22542v-8.89831z'/%3E %3Cpath fill='%23ca3745' d='m152.86,245.551v8.15763l11.017-8.15763h-11.017zm61.228,0,11.017,8.15763v-8.15763h-11.017zm-75.6348,11.1237v7.62712l10.3814-7.62712h-10.3806zm90.6788,0,10.4339,7.67966v-7.67966h-10.4339zm10.4339,35.7508-10.4339,7.7339h10.4339v-7.7339zm-101.113,0.0525v7.68135h10.3814l-10.3814-7.68135zm14.4068,10.6474v8.10339h10.9639l-10.9639-8.10339zm72.2449,0-10.9627,8.10339h10.9627v-8.10339z'/%3E %3Cpath fill='%2328ae66' d='m213.377,245.559c0.1128,0.0828,26.0154,19.2144,26.1876,19.3416v27.0102c-0.1722,0.1278-26.0748,19.2588-26.1876,19.3422h-48.7596c-0.11221-0.0834-26.0148-19.2144-26.187-19.3422v-27.0102c0.1722-0.1272,26.0748-19.2588,26.187-19.3416h48.7596z'/%3E %3Cpath d='m144.667,295.021-3.0108-3.4944,2.8266-3.2802-2.8266-3.2802,2.8266-3.2796-2.8266-3.2802,2.8266-3.2802-2.8266-3.2802,2.826-3.2802-2.826-3.2802,3.0108-3.4938,88.6614,0,3.0108,3.4938-2.8266,3.2802,2.8266,3.2802-2.8266,3.2802,2.8266,3.2802-2.8266,3.2802,2.8266,3.2796-2.8266,3.2802,2.8266,3.2802-3.0108,3.4944zm60.9456-45.2364-3.4944-3.0108-3.2808,2.8266-3.2796-2.8266-3.2802,2.8266-3.2802-2.8266-3.2802,2.8266-3.2802-2.8266-3.2796,2.8266-3.2802-2.8266-3.4944,3.0108,0,57.243,3.4944,3.0114,3.2802-2.8266,3.2796,2.826,3.2802-2.8266,3.2802,2.8266,3.2802-2.8266,3.2802,2.8266,3.2796-2.826,3.2808,2.8266,3.4944-3.0114z'/%3E %3Cg fill='%23faae29'%3E %3Cpath d='m198.623,249.981-3.0654-2.6418-3.066,2.6418,0,56.85,3.066,2.6412,3.0654-2.6412z'/%3E %3Cpath d='m185.503,249.981-3.066-2.6418-3.0654,2.6418,0,56.85,3.0654,2.6412,3.066-2.6412z'/%3E %3Cpath d='m144.863,294.593-2.6412-3.066,2.6412-3.066,88.269,0,2.6412,3.066-2.6412,3.066z'/%3E %3Cpath d='m233.132,275.34,2.6418,3.066-2.6418,3.0654-88.2678,0-2.6418-3.0654,2.6418-3.066z'/%3E %3Cpath d='m233.132,268.352,2.6412-3.066-2.6412-3.0654-88.269,0-2.6412,3.0654,2.6412,3.066z'/%3E %3C/g%3E %3Cg fill='%23ca3745'%3E %3Cpath d='m205.184,249.981-3.0654-2.6418-3.066,2.6418,0,56.85,3.066,2.6412,3.06462-2.64063z'/%3E %3Cpath d='m178.943,249.981-3.066-2.6418-3.066,2.6418,0,56.85,3.066,2.6412,3.066-2.6412z'/%3E %3Cpath d='m144.864,288.032-2.6418-3.066,2.6418-3.066,88.2678,0,2.6418,3.066-2.6418,3.066z'/%3E %3Cpath d='m144.864,274.912-2.6418-3.066,2.6418-3.066,88.2678,0,2.6418,3.066-2.6418,3.066z'/%3E %3Cpath d='m192.064,306.831-3.066,2.6412-3.066-2.6412,0-56.85,3.066-2.6418,3.066,2.6418z'/%3E %3C/g%3E %3Cpath d='m218.631,251.09-59.4804,0v4.7238h-7.60141v45.1848h7.60141v4.7232h59.6946v-4.7232h7.60141v-45.1848h-7.60141v-4.7238h-0.2142z'/%3E %3Cpath fill='%23ca3745' d='m159.587,251.535v4.71525h-7.62712v44.3322h7.62712v4.71356h6.25017l-12.4471-10.4339v-32.8932l12.4471-10.4339h-6.25017zm52.5963,0,12.3932,10.4339v32.8932l-12.3932,10.4339h6.24915v-4.71356h7.57458v-44.3322h-7.57458v-4.71525h-6.24915z'/%3E %3Cg fill='%2328ae66'%3E %3Cpath d='m166.525,251.535c-0.1176,0.099-12.5613,10.5202-12.7119,10.6462v32.4681c0.1506,0.12661,12.5943,10.5472,12.7119,10.6462h44.9681c0.11813-0.099,12.5083-10.5202,12.6589-10.6462v-32.4681c-0.15068-0.12594-12.5407-10.5472-12.6589-10.6462zm0.63559,1.80085,43.6441,0,11.5466,9.69279,0,30.7732-11.5466,9.63983-43.6441,0-11.4936-9.63983,0-30.7732z'/%3E %3Cpath d='m178.72,294.289,1.9536,0.8442,0.3594,2.2818-2.4594,2.16359,3.5724,3.4542-3.4374,0-2.4576-2.36579-2.4582,2.36579-3.4374,0,3.573-3.4542-2.46-2.16359,0.36-2.2818,1.953-0.8442,2.4696,1.9746,0.1338-0.10681z'/%3E %3Cpath d='m191.468,294.289,1.953,0.8442,0.36,2.2818-2.4594,2.16359,3.5724,3.4542-3.4374,0-2.4582-2.36579-2.4576,2.36579-3.438,0,3.573-3.4542-2.4594-2.16359,0.36-2.2818,1.953-0.8442,2.469,1.9746,0.1338-0.10681z'/%3E %3Cpath d='m199.277,294.289-1.953,0.8442-0.36,2.2818,2.4594,2.16359-3.5724,3.4542,3.4374,0,2.45821-2.36579,2.45759,2.36579,3.43741,0-3.57241-3.4542,2.4594-2.16359-0.36-2.2818-1.95299-0.8442-2.469,1.9746-0.1344-0.10681z'/%3E %3Cpath d='m178.72,262.523,1.9536-0.8442,0.3594-2.2812-2.4594-2.1636,3.5724-3.4542-3.4374,0-2.4576,2.3652-2.4582-2.3652-3.4374,0,3.573,3.4542-2.46,2.163,0.36,2.2818,1.953,0.8442,2.4696-1.974,0.1338,0.1068z'/%3E %3Cpath d='m191.468,262.523,1.953-0.8442,0.36-2.2812-2.4594-2.1636,3.5724-3.4542-3.4374,0-2.4582,2.3652-2.4576-2.3652-3.438,0,3.573,3.4542-2.4594,2.163,0.36,2.2818,1.953,0.8442,2.469-1.974,0.1338,0.1068z'/%3E %3Cpath d='m199.277,262.523-1.953-0.8442-0.36-2.2812,2.4594-2.1636-3.5724-3.4542,3.4374,0,2.45821,2.3652,2.45759-2.3652,3.43741,0-3.57241,3.4542,2.4594,2.163-0.36,2.2818-1.95299,0.8442-2.469-1.974-0.1344,0.1068z'/%3E %3Cpath d='m221.901,266.167-1.95,1.6146,1.95,1.614,0,2.6766-2.9988-2.4714s-2.0166,1.827-2.1522,1.95c-0.1728-0.0216-2.1156-0.2658-2.3076-0.2898-0.0858-0.1578-0.6924-1.2762-0.813-1.5,0.201-0.2004,1.986-1.9794,1.986-1.9794s-1.785-1.7796-1.986-1.98c0.1206-0.2238,0.7272-1.3428,0.813-1.5,0.192-0.024,2.1348-0.2688,2.3076-0.2904,0.1356,0.123,2.1522,1.9506,2.1522,1.9506l2.9988-2.4708v2.676z'/%3E %3Cpath d='m221.901,276.792-1.95,1.6146,1.95,1.6134,0,2.67719-2.9988-2.47139s-2.0166,1.827-2.1522,1.94999c-0.1728-0.0216-2.1156-0.26639-2.3076-0.28979-0.0858-0.15781-0.6924-1.27681-0.813-1.5,0.201-0.20041,1.986-1.9794,1.986-1.9794s-1.785-1.7802-1.986-1.9806c0.1206-0.2232,0.7272-1.3422,0.813-1.50001,0.192-0.0234,2.1348-0.26819,2.3076-0.28979,0.1356,0.12299,2.1522,1.95,2.1522,1.95l2.9988-2.47021v2.67601z'/%3E %3Cpath d='m221.901,290.646-1.95-1.61461,1.95-1.614,0-2.6766-2.9988,2.4714s-2.0166-1.8276-2.1522-1.9506c-0.1728,0.0216-2.1156,0.2664-2.3076,0.2898-0.0858,0.15781-0.6924,1.27681-0.813,1.5,0.201,0.20101,1.986,1.98,1.986,1.98s-1.785,1.7796-1.986,1.98c0.1206,0.2232,0.7272,1.3422,0.813,1.5,0.192,0.024,2.1348,0.26821,2.3076,0.2898,0.1356-0.12299,2.1522-1.94999,2.1522-1.94999l2.9988,2.47079v-2.67599z'/%3E %3Cpath d='m156.097,266.167,1.9494,1.6146-1.9494,1.614,0,2.6766,2.9988-2.4714s2.0166,1.827,2.1522,1.95c0.1722-0.0216,2.1156-0.2658,2.3076-0.2898,0.0858-0.1578,0.6918-1.2762,0.813-1.5-0.20099-0.2004-1.986-1.9794-1.986-1.9794s1.78501-1.7796,1.986-1.98c-0.1212-0.2238-0.7272-1.3428-0.813-1.5-0.192-0.024-2.1354-0.2688-2.3076-0.2904-0.1356,0.123-2.1522,1.9506-2.1522,1.9506l-2.9988-2.4708v2.676z'/%3E %3Cpath d='m156.097,276.792,1.9494,1.6146-1.9494,1.6134,0,2.67719,2.9988-2.47139s2.0166,1.827,2.1522,1.94999c0.1722-0.0216,2.1156-0.26639,2.3076-0.28979,0.0858-0.15781,0.6918-1.27681,0.813-1.5-0.20099-0.20041-1.986-1.9794-1.986-1.9794s1.78501-1.7802,1.986-1.9806c-0.1212-0.2232-0.7272-1.3422-0.813-1.50001-0.192-0.0234-2.1354-0.26819-2.3076-0.28979-0.1356,0.12299-2.1522,1.95-2.1522,1.95l-2.9988-2.47021v2.67601z'/%3E %3Cpath d='m156.097,290.646,1.9494-1.61461-1.9494-1.614,0-2.6766,2.9988,2.4714s2.0166-1.8276,2.1522-1.9506c0.1722,0.0216,2.1156,0.2664,2.3076,0.2898,0.0858,0.15781,0.6918,1.27681,0.813,1.5-0.20099,0.20101-1.986,1.98-1.986,1.98s1.78501,1.7796,1.986,1.98c-0.1212,0.2232-0.7272,1.3422-0.813,1.5-0.192,0.024-2.1354,0.26821-2.3076,0.2898-0.1356-0.12299-2.1522-1.94999-2.1522-1.94999l-2.9988,2.47079v-2.67599z'/%3E %3C/g%3E %3Cpath fill='%23ca3745' d='m167.32,253.761c-0.11581,0.097-10.6021,8.87607-11.0699,9.26907,0.94518,0.78343,1.85946,1.60292,2.8072,2.38348,0.23983-0.21695,2.0656-1.85424,2.0656-1.85424l2.70127,0.37076,1.05932,1.95975s-1.64758,1.64878-1.90678,1.90678c0.2592,0.2574,1.90678,1.90678,1.90678,1.90678l-1.05932,1.95974-2.70127,0.3178s-1.82568-1.58364-2.06568-1.80085l-2.9661,2.48941v0.84746c0.99787,0.82593,1.96469,1.66435,2.9661,2.4894,0.23999-0.21659,2.06568-1.80084,2.06568-1.80084l2.70127,0.31779,1.05932,1.95975s-1.64758,1.64878-1.90678,1.90678c0.2592,0.25741,1.90678,1.90678,1.90678,1.90678l-1.05932,2.01271-2.70127,0.3178s-1.82568-1.63661-2.06568-1.85382l-2.9661,2.48941v0.90042l2.9661,2.48941c0.23999-0.21659,2.06568-1.85381,2.06568-1.85381l2.70127,0.37076,1.05932,1.95975s-1.64758,1.64878-1.90678,1.90678c0.2592,0.258,1.90678,1.90678,1.90678,1.90678l-1.05932,1.95974-2.70127,0.37076s-1.82568-1.63661-2.06568-1.85381c-0.94385,0.77731-1.86544,1.55378-2.80721,2.33051,0.46785,0.39298,10.9541,9.17158,11.0699,9.26907h2.43644l3.54873-3.4428-2.27754-2.01271,0.42373-2.75424,2.38347-1.00635,2.43644,1.90678,2.38348-1.90678,2.38347,1.00635,0.4767,2.75424-2.33051,2.01271,3.44279,3.2839,3.4428-3.2839-2.33051-2.01271,0.42373-2.75424,2.43644-1.00635,2.38348,1.90678,2.43644-1.90678,2.38347,1.00635,0.42373,2.75424-2.27754,2.01271,3.38983,3.33687,3.4428-3.33687-2.27755-2.01271,0.42373-2.75424,2.43644-1.00635,2.38348,1.90678,2.38347-1.90678,2.43644,1.00635,0.42373,2.75424-2.27754,2.01271,3.54873,3.4428h2.38347c0.11577-0.0975,10.6015-8.87609,11.0699-9.26907-0.94351-0.77702-1.86222-1.55149-2.8072-2.33051-0.24,0.2172-2.01271,1.85381-2.01271,1.85381l-2.70128-0.37076-1.11228-1.95974s1.64818-1.64878,1.90678-1.90678c-0.2586-0.258-1.90678-1.90678-1.90678-1.90678l1.11228-1.95975,2.70128-0.37076s1.77271,1.63722,2.01271,1.85381l2.9661-2.48941v-0.90042l-2.9661-2.48941c-0.24,0.21721-2.01271,1.85382-2.01271,1.85382l-2.70128-0.3178-1.11228-2.01271s1.64818-1.64937,1.90678-1.90678c-0.2586-0.258-1.90678-1.90678-1.90678-1.90678l1.11228-1.95975,2.70128-0.31779s1.77271,1.58425,2.01271,1.80084c0.99454-0.81922,1.97379-1.62008,2.9661-2.43644v-0.95339l-2.9661-2.43644c-0.24,0.21721-2.01271,1.80085-2.01271,1.80085l-2.70128-0.3178-1.11228-1.95974s1.64818-1.64938,1.90678-1.90678c-0.2586-0.258-1.90678-1.90678-1.90678-1.90678l1.11228-1.95975,2.70128-0.37076s1.77271,1.63722,2.01271,1.85381c0.94925-0.78198,1.91118-1.54834,2.86017-2.33051-0.36468-0.30586-11.0065-9.22464-11.1229-9.32203h-2.38347l-3.54873,3.4428,2.27754,2.01271-0.42373,2.75424-2.43644,1.05932-2.38347-1.90678-2.38348,1.90678-2.43644-1.05932-0.42373-2.75424,2.27755-2.01271-3.38983-3.2839-3.4428,3.2839,2.27754,2.01271-0.42373,2.75424-2.38347,1.05932-2.43644-1.90678-2.38348,1.90678-2.43644-1.05932-0.42373-2.75424,2.33051-2.01271-3.4428-3.2839-3.44279,3.2839,2.33051,2.01271-0.4767,2.75424-2.38347,1.05932-2.38348-1.90678-2.43644,1.90678-2.38347-1.05932-0.42373-2.75424,2.27754-2.01271-3.6017-3.4428zm-11.2288,23.5698,0,2.17161,1.27119-1.11229z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m176.271,301.271-1.85424,1.74745h3.65424l-1.8-1.74745z'/%3E %3Cpath d='m188.983,301.271-1.8,1.74745h3.65423l-1.85423-1.74745z'/%3E %3Cpath d='m201.747,301.271-1.85254,1.74745h3.70678l-1.85424-1.74745z'/%3E %3Cpath d='m174.364,253.761,1.90678,1.8,1.85424-1.8h-3.76102z'/%3E %3Cpath d='m187.129,253.761,1.85424,1.8,1.90678-1.8h-3.76102z'/%3E %3Cpath d='m199.895,253.761,1.85254,1.8,1.85424-1.8h-3.70678z'/%3E %3Cpath d='m221.875,266.737-1.27119,1.05932,1.27119,1.00678v-2.0661z'/%3E %3Cpath d='m221.875,277.33-1.27119,1.05932,1.27119,1.05932v-2.11864z'/%3E %3Cpath d='m221.875,287.976-1.27119,1.05932,1.27119,1.05932v-2.11864z'/%3E %3Cpath d='m156.091,266.685v2.17119l1.27119-1.05932-1.27119-1.11187z'/%3E %3Cpath d='m156.091,277.33v2.17118l1.27119-1.11186-1.27119-1.05932z'/%3E %3Cpath d='m156.091,287.924v2.17118l1.27119-1.05932-1.27119-1.11186z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m199.901,274.857,0-3.7914-3.837,0,0-4.1562-14.1318,0,0,4.1562-3.837,0,0,3.7914-5.2992,0,0,7.098,5.2992,0,0,3.7908,3.837,0,0,4.1568,14.1318,0,0-4.1568,3.837,0,0-3.7908,5.2986,0,0-7.098z'/%3E %3Cpath fill='%23faae29' d='m188.783,267.338,0,4.2846-6.0744,3.453,0,3.1164-9.4842,0,0-2.9064,5.2986,0,0-3.7908,3.837,0,0-4.1568z'/%3E %3Cpath fill='%23faae29' d='m189.212,289.475,0-4.2846,6.0738-3.4536,0-3.1158,9.4848,0,0,2.9058-5.2986,0,0,3.7914-3.837,0,0,4.1568z'/%3E %3Cpath fill='%23fff' d='m195.286,278.192,0-3.1164-6.0738-3.453,0-4.2846,6.423,0,0,4.1568,3.837,0,0,3.7908,5.2986,0,0,2.9064z'/%3E %3Cpath fill='%23fff' d='m173.225,278.621,9.4842,0,0,3.1158,6.0744,3.4536,0,4.2846-6.423,0,0-4.1568-3.837,0,0-3.7914-5.2986,0z'/%3E %3Cpath fill='%23ca3745' d='m183.138,278.621,0,2.8884,5.6454,3.21,0-6.0984z'/%3E %3Cpath fill='%2328ae66' d='m188.783,272.094-5.6454,3.2094,0,2.8884,5.6454,0z'/%3E %3Cpath fill='%23ca3745' d='m194.858,278.192,0-2.8884-5.6454-3.2094,0,6.0978z'/%3E %3Cpath fill='%2328ae66' d='m189.212,284.719,5.6454-3.21,0-2.8884-5.6454,0z'/%3E %3C/g%3E %3C/g%3E %3Cg id='carp4'%3E %3Cpath d='m137.647,353.73,0,11.7168-11.1654,0,0,10.6272-11.3166,0,0,30.2586,11.3166,0,0,10.6272,11.1654,0,0,11.7168,40.5978,0,7.1394,4.29-3.4308,2.061-14.4762,0-1.2486-1.4082,13.119,0-3.696-3.7218-18.7662,0,8.5026,8.8518,17.598,0,6.0114-3.612,6.0114,3.612,17.5992,0,8.50201-8.8518-18.7656,0-3.6966,3.7218,13.1196,0-1.2492,1.4082-14.4768,0-3.4308-2.061,7.14-4.29,40.5978,0,0-11.7168,11.1654,0,0-10.6272,11.316,0,0-30.2586-11.316,0,0-10.6272-11.1654,0,0-11.7168-40.5978,0-7.14-4.2894,3.4308-2.0616,14.4768,0,1.2492,1.4082-13.1196,0,3.6966,3.7218,18.7656,0-8.50201-8.8518-17.5992,0-6.0114,3.612-6.0114-3.612-17.598,0-8.5026,8.8518,18.7662,0,3.696-3.7218-13.119,0,1.2486-1.4082,14.4762,0,3.4308,2.0616-7.1394,4.2894z'/%3E %3Cpath fill='%23ca3745' d='m199.629,428.23,40.3071,0,0-11.7055,11.1229,0,0-10.6462,11.3347,0,0-29.3963-11.3347,0,0-10.5932-11.1229,0,0-11.7055-40.3071,0-16.7373-10.1165-17.32,0-7.68009,7.99788,17.5848,0,2.86017-2.86017-13.0826,0,2.01272-2.27754,14.8305,0,18.9619,11.4407,34.6398,0,0,11.7055,11.1758,0,0,10.6462,11.3348,0,0,20.9746-11.3348,0,0,10.6462-11.1758,0,0,11.7055-34.6398,0-18.9619,11.3877-14.8305,0-2.01272-2.22458,13.0826,0-2.86017-2.86017-17.5848,0,7.68009,7.99788,17.32,0zm-22.7224-4.18432-34.6398,0,0-11.7055-11.1229,0,0-10.6462-11.3348,0,0-20.9746,11.3348,0,0-10.6462,11.1229,0,0-11.7055,34.6398,0,19.0149-11.4407,14.7776,0,2.01271,2.27754-13.0297,0,2.86017,2.86017,17.5847,0-7.68008-7.99788-17.32,0-16.7373,10.1165-40.3071,0,0,11.7055-11.1758,0,0,10.5932-11.3348,0,0,29.3963,11.3348,0,0,10.6462,11.1758,0,0,11.7055,40.3071,0,16.7373,10.1165,17.32,0,7.68008-7.99788-17.5847,0-2.86017,2.86017,13.0297,0-2.01271,2.22458-14.7776,0z'/%3E %3Cpath fill='%23faae29' d='m188.983,351.59-11.9703,7.20339-34.322,0,0,11.7055-11.1229,0,0,10.6462-11.3348,0,0,20.1271,11.3348,0,0,10.6462,11.1229,0,0,11.7055,34.322,0,11.9703,7.15042,11.9703-7.15042,34.322,0,0-11.7055,11.1758,0,0-10.6462,11.3348,0,0-20.1271-11.3348,0,0-10.6462-11.1758,0,0-11.7055-34.322,0zm0,2.9661,11.2818,6.77966,32.5212,0,0,11.7055,11.1758,0,0,10.5932,11.2818,0,0,15.0953-11.2818,0,0,10.6462-11.1758,0,0,11.7055-32.5212,0-11.2818,6.77966-11.2288-6.77966-32.5212,0,0-11.7055-11.1758,0,0-10.6462-11.3347,0,0-15.0953,11.3347,0,0-10.5932,11.1758,0,0-11.7055,32.5212,0z'/%3E %3Cpath fill='%2328ae66' d='m232.342,408.954,0,11.7168-32.2002,0-11.1444,6.69599-11.1444-6.69599-32.1996,0,0-11.7168-11.166,0,0-10.6278-11.316,0,0-14.2458,11.316,0,0-10.6278,11.166,0,0-11.7162,32.1402,0,0.0594,0,11.1444-6.696,11.1444,6.696,32.2002,0,0,11.7162,11.1654,0,0,10.6278,11.316,0,0,14.2458-11.316,0,0,10.6278z'/%3E %3Cg%3E %3Cpath d='m149.869,404.849,0,11.34,17.7,0-17.7-11.7396z'/%3E %3Cpath d='m149.869,377.558,0-11.3406,17.7,0-17.7,11.7396z'/%3E %3Cpath d='m228.127,404.849,0,11.34-17.7,0,17.7-11.7396z'/%3E %3Cpath d='m228.127,377.558,0-11.3406-17.7,0,17.7,11.7396z'/%3E %3Cpath fill='%23ca3745' d='m150.298,405.248,15.8496,10.5126-15.8496,0z'/%3E %3Cpath fill='%23ca3745' d='m150.298,377.159c0.6162-0.4092,14.7696-9.79679,15.8496-10.5126h-15.8496v10.5126z'/%3E %3Cpath fill='%23ca3745' d='m227.698,405.248c-0.6168,0.4092-14.7702,9.7962-15.8496,10.5126h15.8496v-10.5126z'/%3E %3Cpath fill='%23ca3745' d='m227.698,377.159c-0.6168-0.4086-14.7702-9.79619-15.8496-10.5126h15.8496v10.5126z'/%3E %3C/g%3E %3Cg id='carp4y'%3E %3Cpath d='m172.445,388.094,0-5.7912-1.9752,0-9.4764-5.925-0.1134,0.0714-9.3624,5.8536-1.9752,0,0,5.7912-4.455,0,0,6.2196,4.455,0,0,5.7906,1.9752,0,9.4758,5.925,9.4764-5.925,1.9752,0,0-5.7906,6.7818,0,0-6.2196z'/%3E %3Cpath fill='%23ca3745' d='m160.994,376.884,8.6682,5.4192-17.3352,0,8.667-5.4192zm8.667,23.2206-8.667,5.4192-8.6664-5.4192,17.3334,0z'/%3E %3Cpath fill='%23ca3745' d='m167.562,388.523,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cg fill='%23faae29'%3E %3Cpath d='m172.017,394.313,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m160.78,394.313,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m178.799,388.523,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m156.325,388.523,0,5.3628-10.809,0,0-5.3628z'/%3E %3Cpath d='m172.017,382.732,0,5.3622-10.809,0,0-5.3622z'/%3E %3Cpath d='m160.78,382.732,0,5.3622-10.809,0,0-5.3622z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m153.349,389.714,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m157.804,383.923,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m169.04,383.923,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m164.585,389.714,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m175.822,389.714,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m169.04,395.505,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m157.804,395.505,0,2.9796-4.8552,0,0-2.9796z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m152.891,390.171-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m157.346,384.38-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m168.583,384.38-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m164.128,390.171-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m175.365,390.171-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m168.583,395.962-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m157.346,395.962-3.9408,0,0,2.0652,3.9408,0z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23carp4y' transform='matrix(-1,0,0,1,377.99506,0)'/%3E %3Cg id='carp4r'%3E %3Cpath d='m200.449,378.42,0,5.7906-1.9752,0-9.4764,5.925-0.1134-0.0708-9.3624-5.8542-1.9752,0,0-5.7906-5.6184,0,0-6.2196,5.6184,0,0-5.79059,1.9752,0,9.4758-5.9256,9.4764,5.9256,1.9752,0,0,5.79059,5.6184,0,0,6.2196z'/%3E %3Cpath fill='%23faae29' d='m188.998,389.63,8.6676-5.4198-17.3346,0,8.667,5.4198zm8.667-23.2206-8.667-5.4198-8.6664,5.4198,17.3334,0z'/%3E %3Cg fill='%23ca3745'%3E %3Cpath d='m200.021,372.2,0-5.36219-10.809,0,0,5.36219z'/%3E %3Cpath d='m188.784,372.2,0-5.36219-10.809,0,0,5.36219z'/%3E %3Cpath d='m205.639,377.991,0-5.3628-10.809,0,0,5.3628z'/%3E %3Cpath d='m194.402,377.991,0-5.3628-10.809,0,0,5.3628z'/%3E %3Cpath d='m183.165,377.991,0-5.3628-10.8084,0,0,5.3628z'/%3E %3Cpath d='m200.021,383.782,0-5.3628-10.809,0,0,5.3628z'/%3E %3Cpath d='m188.784,383.782,0-5.3628-10.809,0,0,5.3628z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m185.807,368.029,0,2.97959-4.8552,0,0-2.97959z'/%3E %3Cpath d='m197.044,368.029,0,2.97959-4.8552,0,0-2.97959z'/%3E %3Cpath d='m180.188,373.82,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m191.426,373.82,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m202.663,373.82,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m185.807,379.611,0,2.9796-4.8552,0,0-2.9796z'/%3E %3Cpath d='m197.044,379.611,0,2.9796-4.8552,0,0-2.9796z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m185.35,368.486-3.9408,0,0,2.06519,3.9408,0z'/%3E %3Cpath d='m196.587,368.486-3.9408,0,0,2.06519,3.9408,0z'/%3E %3Cpath d='m179.731,374.277-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m190.969,374.277-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m202.205,374.277-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m185.35,380.068-3.9408,0,0,2.0652,3.9408,0z'/%3E %3Cpath d='m196.587,380.068-3.9408,0,0,2.0652,3.9408,0z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23carp4r' y='31.788122'/%3E %3C/g%3E %3Cg id='carp5'%3E %3Cpath d='m127.676,479.354,42.0516-22.6314,0.054,0,38.4852,0,42.0516,22.6314,0,37.29-42.0516,22.6308-38.5392,0-42.0516-22.6308z'/%3E %3Cpath fill='%2328ae66' d='m169.863,457.151-41.7376,22.4576v36.7576l41.7376,22.4576h38.2932l41.739-22.4576v-36.7576l-41.739-22.4576h-38.2932zm0.74067,3.01865h36.8118l39.5136,21.239v33.2102l-39.5136,21.239h-36.834l-39.5122-21.239v-33.2102z'/%3E %3Cpath fill='%23faae29' d='m189.212,497.784,0,37.6402,18.0954,0,39.183-21.087,0-16.1244-57.7068-0.00002,0-37.6398-18.0948,0-39.1836,21.0864,0,16.1244z'/%3E %3Cpath fill='%23fff' d='m188.783,497.784,0,37.6402-18.0948,0-39.1836-21.087,0-16.1244,57.7068-0.00002,0-37.6398,18.0954,0,39.183,21.0864,0,16.1244z'/%3E %3Cpath d='m192.514,533.317,0-10.8792-3.5172,2.2314-3.5178-2.2314,0,10.8792-10.9416,0,7.383-5.4144,0-7.7226-11.2596-7.1442-7.8678,0,0-30.0726,7.8678,0,11.2596-7.14419,0-7.7226-7.383-5.4144,0.6546,0,10.287,0,0,10.8798,3.5178-2.232,3.5172,2.232,0-10.8798,10.9422,0-7.3836,5.4144,0,7.7226,11.2596,7.14419,7.86781,0,0,30.0726-7.86781,0-11.2596,7.1442,0,7.7226,7.3836,5.4144z'/%3E %3Cpath fill='%23faae29' d='m192.956,463.135v11.2288l-3.76102-2.38305v3.17797l17.2136,10.9627h5.6678v11.6542h2.70169v-14.4067h-7.57457l-11.5458-7.31017v-8.15763l6.51356-4.7661h-9.21525zm-29.7144,35.0644v14.4068h7.52119l11.6,7.36102v8.15762l-6.51526,4.76611h9.21695v-11.2288l3.70678,2.38475v-3.28475l-17.2136-10.8576h-5.61491v-11.7051h-2.70119z'/%3E %3Cpath fill='%23fff' d='m175.847,463.135,6.51526,4.7661v8.15763l-11.6,7.31017h-7.52119v14.4068h2.70119v-11.6542h5.61491l17.2136-10.9102v-3.23051l-3.70678,2.38305v-11.2286h-9.21695zm36.2288,35.0644v11.7051h-5.6678l-17.2136,10.8576v3.28475l3.76102-2.38475v11.2288h9.21525l-6.51356-4.76611v-8.15762l11.5458-7.36102h7.57457v-14.4068h-2.70169z'/%3E %3Cpath fill='%23ca3745' d='m166.352,509.458,5.3376,0,17.3076,10.9806,17.307-10.9806,5.3382,0,0-22.9164-5.2758,0-0.0624,0-17.307-10.9806-17.3076,10.9806-5.3376,0z'/%3E %3Cpath d='m200.977,503.445,3.6954,0,0-1.7484-2.7798,0,0-3.1782,5.9412,0,0,8.1054-5.6958,0,0.0006,5.5296-11.7246,0,0-7.9452,5.16,0,0,3.1782-1.9986,0,0,1.5888,5.4018,0,0-3.0378-21.9612-13.383-3.6954,0,0,1.7478,2.7804,0,0,3.1782-5.9418,0,0-8.1048,5.6958,0,0-5.5296,0.2142,0,11.5098,0,0,7.9452-5.16,0,0-3.1782,1.9986,0,0-1.5888-5.4012,0,0,3.0378zm-1.9998-13.383,0-3.0378-5.4018,0,0,1.5888,1.9986,0,0,3.1782-5.16,0,0-7.9452,11.7246,0,0,5.5296,5.6952,0,0,8.1048-5.9412,0,0-3.1782,2.7804,0,0-1.7478-3.696,0-21.9606,13.383,0,3.0372,5.4012,0,0-1.5888-1.9986,0,0-3.1782,5.16,0,0,7.9458-11.724,0,0-5.5302-5.6958,0,0-8.1048,5.9418,0,0,3.1782-2.7804,0,0,1.7484,3.6954,0z'/%3E %3Cpath fill='%23fff' d='m199.406,505.697,0,3.7068-6.2592,0,0-2.4456,1.9992,0,0-2.3214-4.3032,0,0,7.0878,10.8672,0,0-5.5296,5.6958,0,0-7.2474-5.0844,0,0,2.3208,2.7798,0,0,2.6052-4.2438,0-22.2696-13.5708,0-3.7068,6.2592,0,0,2.4456-1.9986,0,0,2.3214,4.3026,0,0-7.0884-10.8672,0,0,5.5296-5.6952,0,0,7.248,5.0838,0,0-2.3214-2.7798,0,0-2.6052,4.2438,0zm1.4514-13.5714,4.2444,0,0,2.6052-2.7804,0,0,2.3214,5.0844,0,0-7.248-5.6952,0,0-5.5296-10.8672,0,0,7.0884,4.3026,0,0-2.3214-1.9986,0,0-2.4456,6.2586,0,0,3.7068-22.2696,13.5708-4.2438,0,0-2.6052,2.7798,0,0-2.3214-5.0838,0,0,7.248,5.6952,0,0,5.5296,10.8672,0,0-7.0884-4.3026,0,0,2.3214,1.9986,0,0,2.4456-6.2592,0,0-3.7068z'/%3E %3Cg%3E %3Cpath d='m238.042,499.884,0,11.7618-5.0052,0,0-4.1538-5.0454,0,0,4.1538-5.0052,0,0-11.7618,5.0052,0,0,4.1538,5.0454,0,0-4.1538z'/%3E %3Cpath d='m220.132,515.499,0,11.7618-5.0052,0,0-4.1538-5.0454,0,0,4.1538-5.0052,0,0-11.7618,5.0052,0,0,4.1544,5.0454,0,0-4.1544z'/%3E %3Cpath d='m238.042,496.113,0-11.7618-5.0052,0,0,4.15379-5.0454,0,0-4.15379-5.0052,0,0,11.7618,5.0052,0,0-4.1538,5.0454,0,0,4.1538z'/%3E %3Cpath d='m139.953,499.884,0,11.7618,5.0052,0,0-4.1538,5.04541,0,0,4.1538,5.00519,0,0-11.7618-5.00519,0,0,4.1538-5.04541,0,0-4.1538z'/%3E %3Cpath d='m139.953,496.113,0-11.7618,5.0052,0,0,4.15379,5.04541,0,0-4.15379,5.00519,0,0,11.7618-5.00519,0,0-4.1538-5.04541,0,0,4.1538z'/%3E %3Cpath d='m220.132,480.499,0-11.7618-5.0052,0,0,4.1538-5.0454,0,0-4.1538-5.0052,0,0,11.7618,5.0052,0,0-4.1538,5.0454,0,0,4.1538z'/%3E %3Cpath d='m157.864,515.499,0,11.7618,5.00521,0,0-4.1538,5.04539,0,0,4.1538,5.0052,0,0-11.7618-5.0052,0,0,4.1544-5.04539,0,0-4.1544z'/%3E %3Cpath d='m157.864,480.499,0-11.7618,5.00521,0,0,4.1538,5.04539,0,0-4.1538,5.0052,0,0,11.7618-5.0052,0,0-4.1538-5.04539,0,0,4.1538z'/%3E %3Cpath d='m223.118,472.256,0,8.93219,16.5972,0z'/%3E %3Cpath d='m154.877,523.742,0-8.9322-16.5972,0z'/%3E %3Cpath d='m154.877,472.256,0,8.93219-16.5972,0z'/%3E %3Cpath d='m223.118,523.742,0-8.9322,16.5972,0z'/%3E %3C/g%3E %3Cg fill='%23ca3745'%3E %3Cpath d='m233.465,507.064,0,4.1538,4.1484,0,0-10.9044-4.1484,0,0,4.1538-5.9028,0,0-4.1538-4.1478,0,0,10.9044,4.1478,0,0-4.1538z'/%3E %3Cpath d='m215.555,522.678,0,4.1538,4.1478,0,0-10.9044-4.1478,0,0,4.1538-5.90281,0,0-4.1538-4.1478,0,0,10.9044,4.1478,0,0-4.1538z'/%3E %3Cpath d='m233.465,488.934,0-4.1538,4.1484,0,0,10.9044-4.1484,0,0-4.1544-5.9028,0,0,4.1544-4.1478,0,0-10.9044,4.1478,0,0,4.1538z'/%3E %3Cpath d='m144.53,507.064,0,4.1538-4.1478,0,0-10.9044,4.1478,0,0,4.1538,5.9028,0,0-4.1538,4.1478,0,0,10.9044-4.1478,0,0-4.1538z'/%3E %3Cpath d='m144.53,488.934,0-4.1538-4.1478,0,0,10.9044,4.1478,0,0-4.1544,5.9028,0,0,4.1544,4.1478,0,0-10.9044-4.1478,0,0,4.1538z'/%3E %3Cpath d='m215.555,473.32,0-4.1544,4.1478,0,0,10.905-4.1478,0,0-4.15439-5.90281,0,0,4.15439-4.1478,0,0-10.905,4.1478,0,0,4.1544z'/%3E %3Cpath d='m162.44,522.678,0,4.1538-4.1478,0,0-10.9044,4.1478,0,0,4.1538,5.9028,0,0-4.1538,4.1484,0,0,10.9044-4.1484,0,0-4.1538z'/%3E %3Cpath d='m162.44,473.32,0-4.1544-4.1478,0,0,10.905,4.1478,0,0-4.15439,5.9028,0,0,4.15439,4.1484,0,0-10.905-4.1484,0,0,4.1544z'/%3E %3C/g%3E %3Cpath fill='%23faae29' d='m223.57,472.986v7.78644h14.461l-14.461-7.78644zm-83.58,42.2678,14.4597,7.78644v-7.78644h-14.4605z'/%3E %3Cpath fill='%23fff' d='m154.449,472.986-14.4597,7.78644h14.4597v-7.78644zm69.1203,42.2678v7.78644l14.461-7.78644h-14.461z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450' viewBox='-3 -6 24 12'%3E %3Cpath d='M21,6V-6H-3V6z' fill='%23dc241f'/%3E %3Cpath d='M-3,-6V6L9,0z' fill='%23ffc726'/%3E %3Cpath d='M-3,-6V6L5,0z'/%3E %3C!-- -arctan(0.5) v --%3E %3Cg transform='rotate(-26.565051)'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-2.1V0H1z' fill='%23fff' transform='rotate(18,0,-2.1)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1800' height='900'%3E %3Cdefs%3E %3Cg id='star'%3E %3Cg id='arm' transform='translate(0,-0.324925)'%3E %3Cpath d='M1,0H0V0.5z'/%3E %3Cpath d='M1,0H0V-0.5z' transform='rotate(-36,1,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23arm' transform='rotate(72)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(144)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(216)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(288)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='1800' height='900' fill='%2300247d'/%3E %3Cg fill='%23fed100'%3E %3Cpath d='M329.37609,777.2654C311.44173,777.11556 497.99952,677.83404 654.14523,550.66563C858.78891,383.99945 1299.541,117.15633 1429.1161,73.7954c13.5433,-4.53215 -27.7761,23.07308 -33.14,32.01541c-138.3415,163.74043 -27.925,472.72379 144.9726,628.04829c51.99,39.7632 49.3274,41.85082 145.7074,45.7463v9l-1357.28001,-11.34z'/%3E %3Cpath d='m318.12503,795.3246c0,0 -13.16343,9.4029 -13.12495,16.4061c0.043,7.7725 14.76557,18.0468 14.76557,18.0468l1338.74505,14.7656 24.6093,-16.4062 -34.453,-21.328 -1330.54197,-11.4843z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse xlink:href='%23star' transform='translate(342.9565,112.5812) scale(45)'/%3E %3Cuse xlink:href='%23star' transform='translate(521.20459,267.53) scale(37.5)'/%3E %3Cuse xlink:href='%23star' transform='translate(135,321.8075) scale(45)'/%3E %3Cuse xlink:href='%23star' transform=' translate(342.9565,652.5812) scale(52.5)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600' viewBox='0 0 1400 700'%3E %3Crect width='1400' fill='%23060' height='700'/%3E %3Crect width='1400' fill='%23fff' height='500'/%3E %3Crect width='1400' fill='%23c00' height='200'/%3E %3Cg fill='%23f8c300'%3E %3Cpath d='M 672.0,340.7 a 12.5,12.5 0,0,1 23.3,5.9 v 50 h 9.4 v -50 a 12.5,12.5 0,0,1 23.3,-5.9 a 29.5,29.5 0,1,0 -56,0'/%3E %3Cpath d='M 678.7,327.65 a 20,20 0,0,1 21.3,9.55 a 20,20 0,0,1 21.3,-9.55 a 21.5,21.5 0,0,0 -42.6,0' fill='%23fff'/%3E %3Cpath id='w' d='M 695.3,376.627 a 38,38 0 0 1 -63.845,24.316 a 39.5,39.5 0 0 1 -59.734,17.467 c 3.6496,36.426 58.252,28.989 62.32,-6.4288 17.154,30.115 54.873,21.49 65.91,-15.4 z'/%3E %3Cuse xlink:href='%23w' transform='translate(700,0) scale(-1,1) translate(-700,0)'/%3E %3Cpath id='r' d='M 658.84,441.31 c -7.6181,16.446 -22.845,19.271 -36.164,5.9953 0,0 5.3539,-3.7831 11.086,-4.826 -1.0748,-4.5744 1.1291,-10.902 4.2354,-14.324 3.2575,2.2264 7.8036,6.6886 8.9598,11.874 8.0291,-1.0394 11.883,1.2815 11.883,1.2815 z'/%3E %3Cuse xlink:href='%23r' transform='rotate(9.37, 700,804)'/%3E %3Cuse xlink:href='%23r' transform='rotate(18.74, 700,804)'/%3E %3Cpath d='M 603,478 a 340,340 0 0 1 194,0' fill='none' stroke-width='16' stroke='%23f8c300'/%3E %3Cg transform='translate(700,380)'%3E %3Cg transform='translate(0,-140)'%3E %3Cpolygon id='s' points='0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571' transform='scale(0.000048669)'/%3E %3C/g%3E %3Cg id='h'%3E %3Cuse xlink:href='%23s' transform='rotate(-30) translate(0,-140) rotate(30)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-60) translate(0,-140) rotate(60)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-90) translate(0,-140) rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23ED1C24' width='900' height='600'/%3E %3Crect fill='%23fff' y='100' width='900' height='400'/%3E %3Crect fill='%23241D4F' y='200' width='900' height='200'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='809' height='500'%3E %3Crect width='809' height='500' fill='%23006a4e'/%3E %3Crect y='100' width='809' height='100' fill='%23ffce00'/%3E %3Crect y='300' width='809' height='100' fill='%23ffce00'/%3E %3Crect width='300' height='300' fill='%23d21034'/%3E %3Cg transform='translate(150,150)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-95 V 0 H 50' transform='rotate(18 0,-95)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='600' height='400'%3E %3Cdefs%3E %3Cpath id='s' transform='scale(21)' fill='%23fff' d='M0,-1 L0.58779,0.80902 L-0.95106,-0.30902 L0.95106,-0.30902 L-0.58779,0.80902z'/%3E %3C/defs%3E %3Crect fill='%23002395' height='400' width='600' /%3E %3Crect fill='%23fff' height='164' width='244' /%3E %3Crect fill='%23002395' height='160' width='80' /%3E %3Crect fill='%23ED2939' height='160' width='80' x='160'/%3E %3Cpath fill='%23fff' d='M355,183 l12.875,20.5 h36.625 v71.5 l-27.5,-43 -37,59 h18 l19,-34 39,70 39,-70 19,34 h18 l-37,-59 -27.5,43 v-39.5 h16.5 l12.25,-19.5 h-28.75 v-12.5 h36.625 l12.875,-20.5 h-122z M398,270.5h-40v14h40z M474,270.5h-40v14h40z'/%3E %3Cuse xlink:href='%23s' x='416' y='362'/%3E %3Cuse xlink:href='%23s' x='371' y='328'/%3E %3Cuse xlink:href='%23s' x='461' y='328'/%3E %3Cuse xlink:href='%23s' x='333' y='227'/%3E %3Cuse xlink:href='%23s' x='499' y='227'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%23C60C30' width='450' height='300'/%3E %3Crect fill='%23FECB00' width='300' height='300'/%3E %3Crect fill='%23002664' width='150' height='300'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m1008.94,170.989v85.1747c0,69.9277-27.4673,133.94-108.953,172.848-81.488-38.909-108.956-102.921-108.956-172.849v-85.1747h217.907z'/%3E %3Cpath fill='%23fdc300' d='m1001.61,179.669v79.444c0,65.2229-25.6193,124.928-101.623,161.218-76.0036-36.2906-101.623-95.9956-101.623-161.219v-79.444h203.246z'/%3E %3Cg fill='%23ff9e3d' stroke='%23000' stroke-width='0.2604'%3E %3Cpath d='m852.667,214.487c-1.47074-1.10339-3.06648-1.77759-5.27051-1.83885,0.48747-5.39443-3.43312-7.72372-6.25377-8.7046-2.8165-0.98088-3.79977-2.08427-4.28724-4.29105-0.49163-2.20678-1.96238-3.55518-4.53722-4.29063-2.57484-0.73587-4.78303-3.31017-5.76214-4.53648-0.9791-1.22589-1.34991-0.98088-2.0832,1.10339-0.73746,2.08427-3.67894,6.00738-0.98327,6.13031-1.95822,1.59341-3.06231,3.43267-1.83739,5.88446-1.34992,1.10339-2.32902,2.69722-0.49164,3.31017,1.84156,0.61294,2.32903,1.10338,2.45402,1.59383-1.65407,0-2.08321,3.31016,1.83738,4.04562-0.85828,0.1225-1.22492,2.81972,0.37081,2.81972-2.20819,0-4.04974,3.31058-6.86624,3.31058-2.82065,0-4.2914,0.61253-4.41222,1.83885-0.12499,1.22589-1.59574,2.6968-2.32902,3.31016,2.0832,0.24501,3.42895,0,4.53305-0.85837,1.1041-0.85838,2.94148-1.10339,4.17057-0.12251,1.22493,0.98088,3.79977,1.47091,5.02469,1.22589-2.69567,1.83926-4.65804,4.29105-4.90386,6.62034-0.24582,2.3297-1.83739,5.0265-3.67894,5.76237-1.83739,0.73545-4.28723,2.69722-5.14551,5.0265,2.32902,5.76196,5.63298,7.18536,8.94527,8.70419,5.88714,2.69764,9.56191,4.65898,12.0159,7.3562,2.44985,2.69722,3.43312,0.73546,7.1079,5.39402,3.67893,4.65899,7.11205,13.4861,10.7868,14.9574,3.67893,1.47091,8.33698,0.49044,11.0326-4.16854,2.69983-4.65857,4.41639-51.7364-9.43692-59.583z'/%3E %3Cpath fill='%23ff927f' d='m858.921,194.871c-3.43312,3.6781-7.84951,7.3562-7.11206,13.9765,0.73746,6.62033,1.47074,17.4092-4.65804,21.0869-6.12879,3.6781-9.07027,12.9956-1.71656,18.3897,7.35371,5.39486,7.59952,12.0152,8.82445,18.1451,1.22909,6.12989,4.41639,11.0335,9.32025,6.86535,4.8997,0.73545,7.59953-1.2259,7.59953-5.14901,0-3.92312,0.24582-6.12989,3.92059-7.35621,3.67894-1.22589,4.65805-2.4522,6.37461-5.76195,1.71656-3.31017,2.69566-4.78149,1.71656-6.74326-0.97911-1.96135-1.34992-6.00697-0.61247-8.94961,0.73746-2.94224-0.9791-4.53607-1.96237-6.37491-0.97911-1.83884-1.34575-3.43267-0.85828-5.88488,0.49163-2.4522-0.73329-4.04562-2.44985-5.27193-1.71656-1.22589-2.45402-2.45179-2.08321-4.41355,0.36665-1.96135-1.22909-3.18725-3.06647-4.65857-1.83739-1.47132-3.1873-3.43267-3.1873-6.3749,0-2.94265-5.63715-9.80841-10.0494-11.5248z'/%3E %3Cpath fill='%23ff9ee1' d='m860.267,274.928c8.21199-2.08428,7.4787-15.57,6.25378-21.2094-1.22909-5.63987-4.3789-13.7174-1.96238-20.1064,3.43312-9.07212-4.17058-17.6542-2.2082-21.0869,1.96238-3.43309,1.71656-5.27193,1.47075-6.37532-0.24166-1.10339-2.08321-1.96135-2.20403,0.36793-0.125,2.32929-0.73746,3.18725-2.2082,4.65857s-1.1041,4.65857,0,8.21416c1.1041,3.55518,3.43312,8.95003-0.24582,16.0604-3.67477,7.11078-2.16236,10.2793-0.73329,13.6086,2.20403,5.14901,7.47871,23.0487,1.83739,25.8684z'/%3E %3Cpath d='m823.49,198.059c0.92077,0,2.69983-0.36835,2.69983,0.85796'/%3E %3Cpath d='m821.652,203.943c1.1041-0.79712,3.06648,0.12251,5.02469-1.04214'/%3E %3Cpath d='m823.615,208.847c1.47074,0,3.43312-0.0613,5.2705-1.53258'/%3E %3Cpath d='m825.452,212.893c1.34992,0,3.86226-0.85796,4.47473-2.63555'/%3E %3Cpath d='m825.823,215.713c2.63317-0.12251,6.12879,0.85838,6.61626-0.0613'/%3E %3Cpath d='m825.944,224.417c1.83739-1.71633,6.19128-2.88097,7.17039-4.65856'/%3E %3Cpath d='m830.602,197.078c3.06231,0.9813,1.79573,2.87556,3.30813,4.04603,2.69983,2.08428,0.24582,4.41356,2.45402,5.02651,2.20403,0.61294,2.16653,0.98546,1.59156,3.43267-0.67495,2.88139,2.08321,3.00348,1.1041,4.904'/%3E %3Cpath d='m847.397,212.648c-1.22492,0-4.84136,0.12251-6.3746,3.37142'/%3E %3Cpath d='m821.223,248.018c1.41241,0.24543,2.11653-0.55753,2.51234-1.3484,0.42914-0.85838,0.61247-1.47133,1.89989-1.53258,1.28742-0.0617,3.24979-0.42919,3.67893-1.41007,0.42914-0.98047,1.96238-0.0613,3.2498-2.63597,1.28742-2.57429,2.1457-5.63945,5.57466-6.74284'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.2604'%3E %3Cg fill='%2300a728'%3E %3Cpath d='m918.475,301.589c1.38741,2.01594-0.05,4.19521,2.30402,5.06692,2.75816,1.02089,0.34998,4.64857,3.60394,5.92697,2.88316,1.13422,0.0208,4.60231,3.13731,6.15989,2.78732,1.39465-0.46664,4.64898,3.25396,6.50866,3.71644,1.85926-0.69995,6.04322,2.09154,7.67039,2.78733,1.62716-0.92911,5.81112,2.32485,7.43829,3.25397,1.62674-1.39574,4.88107,1.6249,7.20577,3.02065,2.32429-0.69579,5.81071,2.32486,7.9029,3.02064,2.09219-1.85405,4.88566,1.16243,7.90332,2.32485,2.32428-0.83745,4.60064,0.92911,8.1354,1.16242,2.32429-1.16243,11.6222-7.67036,10.6922-2.32486,3.95186-11.3868,7.43829-14.6408,6.27615-3.25396,2.32428-13.7116,5.57861-19.0613,0.46502-5.34133,5.11359-15.8032,1.85926-19.0572-0.46502-3.25396,1.16214-12.3159-2.32429-14.6408-6.27615-6.50793,0.93004-8.83279-8.36792-7.67036-10.6922,1.76656-3.53476-1.39575-5.81112,0.92911-8.1354,3.01648-3.01766-1.85822-5.81113,1.16243-7.90332,3.02064-2.09219-0.69579-5.57861,2.32485-7.9029,3.02065-2.3247-1.62906-5.57903,1.6249-7.20577,3.25397-1.62717-0.46247-5.81113,2.32486-7.43829,2.79149-1.62717-1.6249-5.81113,2.09153-7.67039,3.72061-1.85968,0.46664-5.11401,3.25397-6.50866,3.11647-1.55758,0.25415-5.02567,3.1373-6.15989,3.25397-1.2784,0.84578-4.90608,3.60395-5.92697,2.39151-0.88546,0.86661-3.12057,2.37485-5.16317,6.9204,2.72263,28.3441,4.67648,37.156,0.0962z'/%3E %3Cpath d='m887.544,302.239c-2.55817,2.5568,0.46664,4.41647-2.09153,7.43787-2.55818,3.02224-0.23332,4.64899-2.32486,7.43829-2.09154,2.78931,0.92911,4.18438-1.39575,7.20578-2.32069,3.02182,0.46664,4.8815-2.09153,7.43829-2.55401,2.5568,0.46663,4.8815-2.09154,7.67081-2.55401,2.7893,0.46664,4.64856-2.09154,7.20536-2.55401,2.55721,0.46664,5.34652-2.09153,7.90289-2.55401,2.55722,0.46663,5.81113-2.32486,8.83337-2.78733,3.0214,0.46664,5.34568-1.85822,7.67038-2.32485,2.32428-0.23332,4.64857-1.85822,6.27573-1.62906,1.62717-1.85821,3.89395-1.16242,4.8815'/%3E %3Cpath d='m892.423,303.169c-2.32069,3.02182,1.16242,4.41647-0.92911,6.97327-2.09154,2.55721,0.92911,3.48684-0.69579,6.50866s1.16242,3.71893-0.92911,6.74075c-2.09154,3.02182,1.16243,5.34611-1.16243,8.36792-2.32486,3.02182,1.16243,4.64857-0.92911,7.67081-2.09154,3.0214,0.92911,4.64856-0.92911,6.97326-1.86238,2.32429,1.39158,4.64857-0.92911,7.43788-2.32485,2.78972,0.92911,4.88149-0.93327,7.43829-1.85822,2.55679,0.69995,5.3461-0.92911,7.43787-1.6249,2.09219,1.16243,5.11401-1.16243,7.90331-2.32485,2.78931,0.46664,4.64899-0.92911,6.50866-1.39574,1.85926-2.49568,4.59065-1.16243,5.34611'/%3E %3Cpath d='m899.86,305.958c-1.15826,4.85983,1.62907,9.18004,0,13.2298-1.62489,4.0502,1.16243,5.67028,0.23332,8.91003-0.92911,3.24016,1.16243,5.67028-0.23332,9.18004-1.39158,3.51018,1.86239,6.2099,0,10.8001-1.85821,4.59023,1.19993,5.73279,0,10.2601-1.39158,5.26568,2.32486,8.05499,0,11.7743-2.32068,3.71894,2.09571,4.64898,0.23332,8.83253-1.85821,4.18437,1.16243,5.81112-0.23332,9.9955'/%3E %3Cpath d='m912.18,302.239c2.55818,2.5568-0.46663,4.41647,2.09154,7.43787,2.55817,3.02224,0.23332,4.64899,2.32486,7.43829,2.09153,2.78931-0.92911,4.18438,1.39574,7.20578,2.32069,3.02182-0.46664,4.8815,2.09154,7.43829,2.55401,2.5568-0.46664,4.8815,2.09154,7.67081,2.554,2.7893-0.46664,4.64856,2.09153,7.20536,2.55401,2.55721-0.46664,5.34652,2.09154,7.90289,2.55401,2.55722-0.46664,5.81113,2.32485,8.83337,2.78733,3.0214-0.46663,5.34568,1.85822,7.67038,2.32486,2.32428,0.23332,4.64857,1.85822,6.27573,1.62907,1.62717,1.86239,3.89395,1.16243,4.8815'/%3E %3Cpath d='m907.301,303.169c2.32069,3.02182-1.16243,4.41647,0.92911,6.97327,2.09153,2.55721-0.92911,3.48684,0.69579,6.50866,1.62906,3.02182-1.16243,3.71893,0.92911,6.74075,2.09153,3.02182-1.16243,5.34611,1.16242,8.36792,2.32486,3.02182-1.16242,4.64857,0.92911,7.67081,2.09154,3.0214-0.92911,4.64856,0.92911,6.97326,1.86239,2.32429-1.39158,4.64857,0.93328,7.43788,2.32069,2.78972-0.93328,4.88149,0.92911,7.43829,1.85822,2.55679-0.69996,5.3461,0.92911,7.43787,1.6249,2.09219-1.16243,5.11401,1.16242,7.90331,2.32486,2.78931-0.46663,4.64899,0.92911,6.50866,1.39575,1.85926,2.49985,4.59065,1.16243,5.34611'/%3E %3C/g%3E %3Cg fill='%23fcc300'%3E %3Cpath d='m884.115,313.745c0.004,1.0438-0.0208,2.08344-0.98744,3.37058-2.09154,2.78931,0.92911,4.18438-1.39575,7.20578-2.32069,3.02182,0.46664,4.8815-2.09153,7.43829-2.55401,2.5568,0.46663,4.8815-2.09154,7.67081-2.55401,2.7893,0.46664,4.64856-2.09154,7.20536-2.55401,2.55721,0.46664,5.34652-2.09153,7.90289-2.55401,2.55722,0.46663,5.81113-2.32486,8.83337-2.78733,3.0214,0.46664,5.34568-1.85822,7.67038-2.32485,2.32428-0.23332,4.64857-1.85822,6.27573,2.78733-2.09177,2.78733-5.34568,4.87887-6.97285,2.09153-1.62758-0.69579-3.95186,0.46664-5.114,1.16242-1.16215,0.23331-6.04364,2.32485-8.36793,2.09154-2.3247,0.23332-6.97326,2.09154-8.60043,1.85822-1.62716,0.46247-6.50824,2.78733-8.13541,2.32485-1.62716,0-5.57861,1.85821-7.6708,1.86239-2.09177,0-5.3461,1.86239-7.90289,1.85822-2.5568,0.0833-4.87817,1.39158-6.97327,0.58329-0.92963,0.58329-7.67039-0.87078-3.83561z'/%3E %3Cpath d='m890.798,316.651c-1.6249,3.02182,1.16242,3.71893-0.92911,6.74075-2.09154,3.02182,1.16243,5.34611-1.16243,8.36792-2.32486,3.02182,1.16243,4.64857-0.92911,7.67081-2.09154,3.0214,0.92911,4.64856-0.92911,6.97326-1.86238,2.32429,1.39158,4.64857-0.92911,7.43788-2.32485,2.78972,0.92911,4.88149-0.93327,7.43829-1.85822,2.55679,0.69995,5.3461-0.92911,7.43787-1.6249,2.09219,1.16243,5.11401-1.16243,7.90331-2.32485,2.78931,0.46664,4.64899-0.92911,6.50866,2.7915-0.93004,1.74573-4.76523,2.7915-5.57861,1.04576-0.81379-0.34998-6.15989,1.27492-7.55455,1.62906-1.39465-1.04577-5.69695,0.46663-7.55454,2.55818-3.13766,0.34998-5.22985,1.85822-7.67039,1.51241-2.44095-0.57496-5.57403,0.5833-7.20578,1.97488-2.7893-0.87495-5.3036,0.57913-7.32203,2.09154-2.90556-0.40414-5.29818,1.04577-7.20578,2.20819-2.90556-0.23332-5.81112,0.69995-7.32203,0.92911-1.51091,2.43735-8.01916-0.46663-9.06504z'/%3E %3Cpath d='m899.86,319.188c-1.62489,4.0502,1.16243,5.67028,0.23332,8.91003-0.92911,3.24016,1.16243,5.67028-0.23332,9.18004-1.39158,3.51018,1.86239,6.2099,0,10.8001-1.85821,4.59023,1.19993,5.73279,0,10.2601-1.39158,5.26568,2.32486,8.05499,0,11.7743-2.32068,3.71894,2.66234,4.95025,0.23332,8.83253-1.16242,1.85967,0.11666,6.62491,1.97488,0.93004,1.86238-5.69487-1.39158-6.39198,0.23332-8.71668,1.62906-2.3247-0.57913-8.48418,0.11666-11.7385,0.69996-3.25433-1.6249-7.6708-0.11666-11.1572,1.51241-3.48642-2.32486-7.20536-0.81245-10.2276,1.51241-3.02141-0.69579-6.74076,0.69579-9.1813,1.39575-2.44054-1.04577-5.69487-0.46247-7.08952,0.57913-1.39466-0.5833-6.547-1.86239-2.57638z'/%3E %3C/g%3E %3Cpath fill='%23ef072d' d='m917.292,304.331c0-26.2659-3.71644-35.3309-17.4323-35.3309-13.7116,0-17.4281,9.06504-17.4281,35.3309h34.8603z'/%3E %3Cpath fill='%23000' d='m882.432,304.331c0-26.2659,3.71644-35.3309,17.4281-35.3309-6.27461,0-10.1077,4.88066-11.1535,8.13499-1.04577,3.25433-0.46664,3.02182,0.92911,1.74342,1.39575-1.27839,0.69579,1.51091-0.46247,3.02182-1.16243,1.51091-2.32486,5.81113-0.69996,4.41647,1.62907-1.39465,2.90399,0.23252,1.16243,2.67306-1.74156,2.44053-3.25397,8.1354-1.51241,6.15989,1.74573-1.97593,2.09154,1.2784,1.04994,2.90556-1.04994,1.62717-0.93328,3.0214,0,2.32428,0.92911-0.69711,0.81245,2.67305-0.11666,3.95145h-6.62459z'/%3E %3Cpath fill='%23000' d='m914.622,302.82c0-20.571-2.55401-26.7309-7.66619-28.8227-2.89566-1.18631-2.97898-0.92963-1.59574,0.92963,1.38325,1.85926,1.17076,4.53272-0.10832,2.67305-1.27492-1.85926-1.6999-2.20803-2.2332-1.39424-0.5333,0.81337,1.48741,4.64857,2.97898,8.13541,1.19993,2.80431,0.42498,4.18354-1.38324,1.39423-1.80823-2.7893-1.80823-0.26251-0.22082,2.09219,2.03737,3.02182,1.97487,12.2031,1.97487,16.0383l8.25366-1.04589z'/%3E %3Cpath fill='%23ef072d' d='m899.86,308.166c5.46217,0,11.441-0.97338,15.4574-2.53304,4.76637-1.85051,5.02052-3.47643,3.37062-5.55236-1.16243-1.46133-3.7206-0.5842-6.15795,0.4871-2.44151,1.07131-9.18276,1.75342-12.67,1.75342-3.48311,0-10.2244-0.68211-12.6659-1.75342-2.43734-1.0713-4.99552-1.94843-6.15795-0.4871-1.64989,2.07593-1.39574,3.70185,3.37063,5.55236,4.01225,1.55966,9.99521,2.53304,15.4532,2.53304z'/%3E %3C/g%3E %3Cg fill='%23b95a1e' stroke='%23000' stroke-width='0.2976'%3E %3Cg%3E %3Cpath d='m952.855,273.393s3.57764,6.17649,6.20159,10.6787c2.62361,4.5016,4.74983,5.52721,6.64995,4.19194,1.89978-1.33586,0.28699-5.00496-1.23506-6.74599-1.52239-1.74163-9.89229-9.91172-9.89229-9.91172l-1.72419,1.78709z'/%3E %3Cpath d='m952.005,273.868s1.41757,7.08152,2.46606,12.2491c1.04835,5.16688,2.72803,6.88205,4.94181,6.29214,2.21365-0.59058,1.85465-4.61693,0.97094-6.79384-0.88385-2.1776-6.18786-12.8251-6.18786-12.8251l-2.19095,1.07774z'/%3E %3Cpath d='m950.499,274.091s-0.008,7.23757,0,12.5221c0.008,5.28383,1.31323,7.32945,3.59492,7.23723,2.28169-0.0929,2.72346-4.11011,2.28772-6.43309-0.43573-2.32368-3.52721-13.9007-3.52721-13.9007l-2.35543,0.57443z'/%3E %3Cpath d='m948.148,273.393s-3.57764,6.17649-6.20159,10.6787c-2.62361,4.5016-4.74983,5.52721-6.64995,4.19194-1.89978-1.33586-0.28699-5.00496,1.23506-6.74599,1.52239-1.74163,9.89229-9.91172,9.89229-9.91172l1.72419,1.78709z'/%3E %3Cpath d='m948.999,273.868s-1.41757,7.08152-2.46606,12.2491c-1.04835,5.16688-2.72803,6.88205-4.94181,6.29214-2.21365-0.59058-1.85465-4.61693-0.97094-6.79384,0.88385-2.1776,6.18786-12.8251,6.18786-12.8251l2.19095,1.07774z'/%3E %3Cpath d='m950.504,274.091s0.008,7.23757,0,12.5221c-0.008,5.28383-1.31323,7.32945-3.59492,7.23723-2.28169-0.0929-2.72346-4.11011-2.28772-6.43309,0.43573-2.32368,3.52721-13.9007,3.52721-13.9007l2.35543,0.57443z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m954.464,218.4s5.82657-6.18876,16.0232-12.3775c10.196-6.18874,17.5728-10.9492,18.936-9.90202,0,1.23779-8.73994,7.42652-16.023,12.3775-7.28309,4.95099-16.023,12.3775-16.023,12.3775l-2.91328-2.4755z'/%3E %3Cpath d='m955.14,223.351s5.75948-3.63469,16.8043-8.66425c10.8719-4.46556,26.219-3.71326,26.219-2.4755-1.45611,1.23774-14.566,1.23774-23.306,4.95099-8.34258,3.54434-16.804,8.66426-16.804,8.66426l-2.91328-2.4755z'/%3E %3Cpath d='m955.202,231.877s5.07089-2.45,16.8043-6.18876c11.6522-3.71325,27.1218-1.23775,27.1218,0-1.45611,1.23774-14.0127,0.48543-22.7526,2.47551-9.04357,1.93924-18.2601,6.18875-18.2601,6.18875l-2.91328-2.4755z'/%3E %3Cpath d='m955.756,240.535s5.84408-4.95866,18.2916-6.18876c12.5245-1.23774,22.7214,6.18876,22.7214,7.42648-1.4561,1.23778-13.1099-5.44762-21.8498-4.49146-9.25941,0.95395-16.2499,5.72924-16.2499,5.72924l-2.91328-2.4755z'/%3E %3Cpath d='m952.855,213.304s9.38996-6.18876,9.38996-11.1398c0-4.951-4.13967-9.90199-5.31344-12.3775,2.34754,0,7.66089,7.42649,7.66089,12.3775,0,5.41052-8.82413,13.6152-8.82413,13.6152l-2.91328-2.4755z'/%3E %3Cpath d='m952.855,213.304s-1.17377-3.71325-1.17377-11.1398c0-8.66428,5.17991-14.175,7.04243-16.0908,0.48494,1.91582-4.6949,8.66427-4.6949,16.0908,0,5.41053,1.73952,13.6152,1.73952,13.6152l-2.91328-2.4755z'/%3E %3Cpath d='m946.539,218.4s-5.82657-6.18876-16.0232-12.3775c-10.196-6.18874-17.5728-10.9492-18.936-9.90202,0,1.23779,8.73994,7.42652,16.023,12.3775,7.28309,4.95099,16.023,12.3775,16.023,12.3775l2.91328-2.4755z'/%3E %3Cpath d='m945.863,223.351s-5.75948-3.63469-16.8043-8.66425c-10.8719-4.46556-26.219-3.71326-26.219-2.4755,1.45611,1.23774,14.566,1.23774,23.306,4.95099,8.34258,3.54434,16.804,8.66426,16.804,8.66426l2.91328-2.4755z'/%3E %3Cpath d='m945.801,231.877s-5.07089-2.45-16.8043-6.18876c-11.6522-3.71325-27.1218-1.23775-27.1218,0,1.45611,1.23774,14.0127,0.48543,22.7526,2.47551,9.04357,1.93924,18.2601,6.18875,18.2601,6.18875l2.91328-2.4755z'/%3E %3Cpath d='m945.247,240.535s-5.84408-4.95866-18.2916-6.18876c-12.5245-1.23774-22.7214,6.18876-22.7214,7.42648,1.4561,1.23778,13.1099-5.44762,21.8498-4.49146,9.25941,0.95395,16.2499,5.72924,16.2499,5.72924l2.91328-2.4755z'/%3E %3Cpath d='m948.148,213.304s-9.38996-6.18876-9.38996-11.1398c0-4.951,4.13967-9.90199,5.31344-12.3775-2.34754,0-7.66089,7.42649-7.66089,12.3775,0,5.41052,8.82413,13.6152,8.82413,13.6152l2.91328-2.4755z'/%3E %3Cpath d='m948.148,213.304s1.17377-3.71325,1.17377-11.1398c0-8.66428-5.17991-14.175-7.04243-16.0908-0.48494,1.91582,4.6949,8.66427,4.6949,16.0908,0,5.41053-1.73952,13.6152-1.73952,13.6152l2.91328-2.4755z'/%3E %3C/g%3E %3Cg stroke='%23fdc301' stroke-width='0.7501'%3E %3Cpath d='m981.025,302.422c-3.64812-8.54578-4.69495-23.5172-4.69495-25.9927,0-6.97118,2.18284-40.8779,2.34748-54.461,0.16463-13.5831-8.21614-21.0417-16.4324-21.0417-7.04243,0-11.7374,4.95102-11.7374,12.3775h3.52125c0-4.951,3.52125-8.66425,8.2162-8.66425,7.04244,0,12.4548,5.85035,12.9112,17.3285,0.50384,13.2662-1.41221,47.7134-1.17377,56.9365,0.23844,9.22374,3.39431,17.4468,7.04243,23.5172z'/%3E %3Cpath d='m919.979,302.422c3.64812-8.54578,4.69495-23.5172,4.69495-25.9927,0-6.97118-2.18284-40.8779-2.34748-54.461-0.16463-13.5831,8.21614-21.0417,16.4324-21.0417,7.04243,0,11.7374,4.95102,11.7374,12.3775h-3.52125c0-4.951-3.52125-8.66425-8.2162-8.66425-7.04244,0-12.4548,5.85035-12.9112,17.3285-0.50384,13.2662,1.41221,47.7134,1.17377,56.9365-0.23844,9.22374-3.39431,17.4468-7.04243,23.5172z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m950.507,273.954c6.56043-0.0974,7.28391-2.47542,7.28391-2.47542s1.45666-4.95099,0.72837-6.18884c-0.72841-1.23772-8.01228-1.23772-8.01228-1.23772v9.90198z'/%3E %3Cpath d='m950.507,269.003c7.04244,0,8.21621-2.47542,8.21621-2.47542s2.34728-4.95099,1.1737-6.18884c-1.17377-1.23772-9.38991-1.23772-9.38991-1.23772v9.90198z'/%3E %3Cpath d='m950.507,264.052c5.86873,0,9.38998-2.47549,9.38998-2.47549s2.34728-4.95099,1.1737-6.18884c-1.17377-1.23772-10.5637-1.23765-10.5637-1.23765v9.90198z'/%3E %3Cpath d='m950.507,257.863c10.5716-0.0974,10.5637-3.17937,10.5637-3.17937s2.34728-4.95099,1.17371-6.18885c-1.17377-1.23771-11.7374-0.53376-11.7374-0.53376v9.90198z'/%3E %3Cpath d='m950.507,252.912c10.5716-0.0974,11.7374-2.47542,11.7374-2.47542s2.34728-4.95099,1.17371-6.18884c-1.17378-1.23772-12.9111-1.23772-12.9111-1.23772v9.90198z'/%3E %3Cpath d='m950.507,246.724c10.5716-0.0974,12.9112-2.47549,12.9112-2.47549s2.34728-4.95099,1.17371-6.18877c-1.17377-1.23772-14.0849-1.23772-14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.507,240.535c10.5716-0.0974,14.0849-2.47549,14.0849-2.47549s1.17357-4.95099,0-6.18877c-1.17377-1.23772-14.0849-1.23772-14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.507,234.346c10.5716-0.0974,14.0849-2.47549,14.0849-2.47549s0-4.95099-1.17371-6.18877c-1.17377-1.23772-12.9112-1.23772-12.9112-1.23772v9.90198z'/%3E %3Cpath d='m950.507,228.157c10.5716-0.0974,12.9111-2.47549,12.9111-2.47549s0-4.95099-1.17371-6.18877c-1.17377-1.23772-11.7374-1.23772-11.7374-1.23772v9.90198z'/%3E %3Cpath d='m950.507,212.631c8.22416,0.01,11.7773,7.15331,11.7573,7.00764l-2.36742,2.32976c-1.25778,1.23778-9.38991,1.23778-9.28894,1.23143l-0.10097-10.5688z'/%3E %3Cpath d='m950.496,273.954c-6.56043-0.0974-7.28391-2.47542-7.28391-2.47542s-1.45666-4.95099-0.72837-6.18884c0.72841-1.23772,8.01228-1.23772,8.01228-1.23772v9.90198z'/%3E %3Cpath d='m950.496,269.003c-7.04244,0-8.21621-2.47542-8.21621-2.47542s-2.34728-4.95099-1.1737-6.18884c1.17377-1.23772,9.38991-1.23772,9.38991-1.23772v9.90198z'/%3E %3Cpath d='m950.496,264.052c-5.86873,0-9.38998-2.47549-9.38998-2.47549s-2.34728-4.95099-1.1737-6.18884c1.17377-1.23772,10.5637-1.23765,10.5637-1.23765v9.90198z'/%3E %3Cpath d='m950.496,257.863c-10.5716-0.0974-10.5637-3.17937-10.5637-3.17937s-2.34728-4.95099-1.17371-6.18885c1.17377-1.23771,11.7374-0.53376,11.7374-0.53376v9.90198z'/%3E %3Cpath d='m950.496,252.912c-10.5716-0.0974-11.7374-2.47542-11.7374-2.47542s-2.34728-4.95099-1.17371-6.18884c1.17378-1.23772,12.9111-1.23772,12.9111-1.23772v9.90198z'/%3E %3Cpath d='m950.496,246.724c-10.5716-0.0974-12.9112-2.47549-12.9112-2.47549s-2.34728-4.95099-1.17371-6.18877c1.17377-1.23772,14.0849-1.23772,14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.496,240.535c-10.5716-0.0974-14.0849-2.47549-14.0849-2.47549s-1.17357-4.95099,0-6.18877c1.17377-1.23772,14.0849-1.23772,14.0849-1.23772v9.90198z'/%3E %3Cpath d='m950.496,234.346c-10.5716-0.0974-14.0849-2.47549-14.0849-2.47549s0-4.95099,1.17371-6.18877c1.17377-1.23772,12.9112-1.23772,12.9112-1.23772v9.90198z'/%3E %3Cpath d='m950.496,228.157c-10.5716-0.0974-12.9111-2.47549-12.9111-2.47549s0-4.95099,1.17371-6.18877c1.17377-1.23772,11.7374-1.23772,11.7374-1.23772v9.90198z'/%3E %3Cpath d='m950.496,212.631c-8.22416,0.01-11.7773,7.15331-11.7573,7.00764l2.36742,2.32976c1.25778,1.23778,9.38991,1.23778,9.28894,1.23143l0.10097-10.5688z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 600 400'%3E %3Crect width='600' height='400' fill='%233e5eb9'/%3E %3Crect width='600' height='250' y='75' fill='%23ffd900'/%3E %3Crect width='600' height='200' y='100' fill='%23b10c0c'/%3E %3Cg fill='%23ffd900' stroke='%23000' stroke-width='1.008'%3E %3Cg id='e'%3E %3Cpath fill='%23fff' d='m492.85 154.28-24.285 8.571 24.285 8.571 24.285-8.571-24.285-8.571z'/%3E %3Crect width='357.13' height='5.714' x='122.85' y='160' rx='3.106' ry='2.857'/%3E %3Cpath d='m471.44 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3Cpath d='m468.58 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3Cpath d='m465.72 165.71c1.427 0 2.859-1.429 2.859-2.857 0-1.428-1.431-2.857-2.858-2.857'/%3E %3C/g%3E %3Cuse xlink:href='%23e' x='-23.27' y='17.15'/%3E %3Crect stroke-width='1.08' width='485.7' height='8.571' x='59.812' y='195.72' rx='4.224' ry='4.286'/%3E %3C/g%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='1.008' d='m442.85 200c-28.571 28.569-66.668 85.711-142.86 85.711-66.668 0-114.28-57.142-142.86-85.711 28.571-28.574 76.188-85.716 142.86-85.716 76.188 0 114.28 57.142 142.86 85.716z'/%3E %3Cpath fill='%23000' d='m290.02 144.1c7.601 8.549 1.254 11.996 9.3 12.557 8.485 0.623 3.675 9.034 10.812 9.326 4.99 0.218-0.498 20.151 4.305 26.729 4.893 6.857 8.991 2.009 9.077 6.963 0.085 5.124-13.317 4.607-13.552 20.39-0.393 9.096-11.31 9.678-11.831 15.531-0.648 5.505 21.507 8.595 21.211 13.523-0.304 4.913-23.922 4.144-24.95 9.747-0.527 5.033 32.446 9.158 35.098 23.713-4.92 1.609-18.919 3.124-29.499 3.132-66.657 0.048-114.28-57.147-142.85-85.716 28.571-28.574 76.188-85.716 142.86-85.716 0 0-19.789 18.082-9.971 29.815z'/%3E %3Cg stroke='%23FFF'%3E %3Cg id='c' stroke-width='6.927'%3E %3Cg id='b'%3E %3Cpath id='a' stroke-width='6.927' d='M213.933 192.377V169.52M227.783 169.52v22.857M241.643 169.52v22.857'/%3E %3Cuse xlink:href='%23a' y='38.1'/%3E %3C/g%3E %3Cuse xlink:href='%23b' x='41.56'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000'%3E %3Cuse xlink:href='%23c' x='104.76'/%3E %3C/g%3E %3Cg fill='%23a70000'%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='0.855' d='m511.35 196.6c-4.328 7.496 3.321-2.493 21.985 10.056 3.459 2.331 6.481 8.489 6.481 12.759-0.878-0.587-1.53-1.894-2.497-2.743-1.354 1.357 1.293 7.577 1.68 10.517-2.918-1.633-2.637-2.406-3.606-4.413 0.193 2.426-0.501 9.107 0.66 11.68-2.3-0.657-2.147-2.508-3.348-2.88 0.817 2.912-0.712 6.081-0.306 9.355-1.344-1.33-2.776-2.372-3.4-2.909-0.105 1.559-2.585 5.656-2.641 7.13-1.14-0.689-1.45-1.763-1.64-2.486-1.417 1.781-6.454 8.358-6.777 10.364-3.881-3.428-13.823-11.775-15.117-16.206-1.144 2.515-2.8 3.364-6.073 5.2-1.293-7.022-6.13-14.915-3.543-20.934-1.833 1.087-3.342 2.174-5.174 3.511 1.736-10.17 10.587-22.095 23.319-28.001z'/%3E %3Cpath d='m495.21 233.72c1.797-3.592 3.452-4.731 4.613-7.044 2.051-4.065 2.344-7.299 4.131-6.825 1.787 0.474 1.785 2.139-0.53 6.136-2.315 3.997-3.416 4.851-8.214 7.733z'/%3E %3Cpath d='m507.36 242.28c-0.231-2.735 0.562-3.877 0.418-5.638-0.247-3.099-1.514-5.226 0.134-5.377 1.648-0.151 2.418 0.906 2.423 4.029 0.005 3.123-0.478 3.943-2.974 6.987z'/%3E %3Cpath d='m516.58 247.64c-0.72-3.818-0.181-5.511-0.642-7.971-0.802-4.328-2.389-7.177-0.862-7.573 1.527-0.396 2.449 1.004 3.027 5.393 0.578 4.389 0.273 5.595-1.523 10.151z'/%3E %3Cpath d='m526.17 220.89c-2.252-1.709-3.566-1.824-5.018-2.922-2.558-1.927-3.852-3.99-4.675-2.966-0.823 1.024-0.239 2.144 2.442 3.922 2.68 1.778 3.588 1.918 7.252 1.966z'/%3E %3Cpath d='m524.58 233.56c-1.187-2.465-2.436-3.09-3.204-4.676-1.357-2.787-1.359-5.198-2.831-4.58-1.472 0.618-1.59 1.88-0.016 4.578 1.574 2.697 2.398 3.186 6.051 4.678z'/%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='1.067' d='m80.783 203.82c-0.242-2.183 0.225-2.444-1.118-4.09 1.955 0.818 2.029 2.992 4.406 1.449 0.873-0.452 1.254-0.466 0.193-2.891 2.479 0.115 10.596 2.899 11.896 2.963 3.413 0.157 9.644-3.586 13.969 1.016 4.151 4.196 2.765 8.551 2.765 14.362-1.668-0.799-0.864-1.193-2.634-3.271 1.327 5.079-0.071 14.237-0.071 19.624-0.681-1.299-0.581-0.735-1.247-2.08-1.77 4.917-3.891 5.929-3.891 11.74-0.639-2.279-0.022-1.797-0.733-2.996-1.72 3.733-13.26 6.923-8.813 10.686-4.014-2.353-5.774-2.106-7.594-4.223-0.784 0.506-1.407 1.464-2.136 2.777-7.057-3.247-4.534-10.25-10.062-14.928-0.957 1.961-0.521 1.677-1.555 4.869-1.119-4.434-1.425-7.251-2.684-10.511-1.086 1.807-0.989 1.114-2.961 3.845-0.816-5.401-2.144-6.676-1.619-10.25-2.096 1.479-0.724 0.88-2.819 2.7 1.985-13.84 10.558-24.067 16.71-20.792z'/%3E %3Cpath d='m72.101 226.41c1.818-4.456 3.457-5.855 4.632-8.724 2.075-5.042 2.413-9.073 4.156-8.458 1.743 0.615 1.715 2.691-0.617 7.645-2.332 4.955-3.423 6.005-8.171 9.536z'/%3E %3Cpath d='m78.985 237.56c0.729-3.995 1.879-5.45 2.352-8.023 0.839-4.524 0.371-7.893 1.991-7.715 1.62 0.177 1.986 1.885 0.908 6.385-1.078 4.501-1.822 5.566-5.252 9.353z'/%3E %3Cpath d='m87.219 245.31c0.205-3.873 1.113-5.385 1.249-7.88 0.246-4.388-0.599-7.529 0.946-7.547 1.545-0.018 2.095 1.56 1.622 5.953-0.473 4.393-1.045 5.489-3.817 9.474z'/%3E %3Cpath d='m104.9 219.98c-3.381-3.368-5.425-3.997-7.606-6.163-3.842-3.804-5.698-7.376-7.066-6.11s-0.545 3.164 3.5 6.784c4.045 3.62 5.452 4.148 11.172 5.489z'/%3E %3Cpath d='m102.84 233c-2.202-3.382-3.818-4.258-5.24-6.434-2.507-3.824-3.369-7.11-4.79-6.296-1.422 0.814-1.104 2.531 1.613 6.238 2.717 3.706 3.81 4.388 8.417 6.493z'/%3E %3Cpath fill='%233d5da7' stroke='%23000' stroke-width='0.826' d='m253.8 129.5c-3.958 7.655 6.93-2.546 23.998 10.269 3.163 2.381 7.697 11.787 7.697 16.147-3.634-0.773-10.069-4.36-10.069-4.36s7.552 7.564 7.552 16.284c-2.668-1.668-4.003-1.418-4.89-3.466 0 2.823 2.373 4.622 2.373 8.982-1.926-1.537-3.557-2.561-5.186-3.46 2.517 4.36-4.587 12.818-1.032 15.641-6.218-0.899-12.58-4.872-15.097-9.232-1.334 0.899-1.479 2.311-1.531 3.816 0.196 0.163-9.465-7.171-8.577-9.988-1.296 1.818-1.478 2.817-1.774 4.866-3.549-3.5-6.802-7-7.986-11.525-1.577 2.049-1.676 2.049-3.253 4.098-1.183-7.171-1.183-6.915 1.183-13.061-1.676 1.11-3.056 2.22-4.732 3.586 1.587-10.385 9.682-22.563 21.325-28.594z'/%3E %3Cpath d='m244.04 166.9c0.633-5.275 2.012-7.262 2.424-10.659 0.735-5.974-0.137-10.341 1.98-10.23 2.117 0.11 2.727 2.314 1.68 8.276-1.046 5.961-1.929 7.409-6.084 12.614z'/%3E %3Cpath d='m255.09 176.56c-0.429-4.45 0.393-6.345 0.12-9.212-0.47-5.044-2.028-8.461-0.183-8.775 1.845-0.314 2.778 1.378 2.977 6.471 0.199 5.093-0.294 6.45-2.915 11.516z'/%3E %3Cpath d='m272.34 184.44c-1.876-3.851-3.488-4.999-4.699-7.478-2.139-4.356-2.586-7.913-4.236-7.269-1.65 0.645-1.559 2.485 0.824 6.749 2.383 4.264 3.46 5.134 8.111 7.998z'/%3E %3Cpath d='m278.31 149.95c-4.778-2.515-7.232-2.547-10.311-4.163-5.422-2.834-8.578-6.035-9.698-4.273-1.121 1.762 0.375 3.514 5.965 6.09 5.59 2.576 7.307 2.698 14.045 2.346z'/%3E %3Cpath d='m280.06 164.36c-3.479-2.894-5.536-3.32-7.78-5.182-3.953-3.267-5.92-6.476-7.241-5.175-1.32 1.301-0.438 3.019 3.711 6.097 4.149 3.078 5.568 3.46 11.31 4.26z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 180 120'%3E %3Crect width='180' height='120' fill='%23000'/%3E %3Crect width='180' height='80' fill='%23fff'/%3E %3Crect width='180' height='40' fill='%23ce1126'/%3E %3Cg id='s' fill='%23007a3d'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M54,47v13h8' transform='rotate(18,54,47)' id='o'/%3E %3Cuse xlink:href='%23o' x='-108' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72,54,60)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72,54,60)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144,54,60)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' x='72'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' width='675' height='450'%3E %3Cdefs%3E %3Cmarker markerWidth='691.235' markerHeight='1592.9' orient='auto'%3E %3Cg transform='translate(139.04186,-931.37552)'%3E %3Cg transform='matrix(0.3358457,0,0,0.3358462,22.073663,254.82087)'%3E %3Cpath d='m-1508.834 4385.729 0 0 0 0 0 0' fill='%23000'/%3E %3Cg transform='matrix(2.9999964,0,0,2.9994449,-746.32978,-2781.9855)'%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342' fill='%23ff0'/%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342-0.012 0z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m375.446 838.791c-11.615-1.163-24.989-3.92-35.313 1.894-6.921-4.079-16.558-3.83-24.763-3.031-4.456 0.797-9.697 0.797-14.354 1.558l-0.73 0.103c-8.449 0.561-16.113-1.936-23.455-5.217 2.331 13.234 4.919 26.797 6.191 40.652 2.77 20.52-9.709 37.748-4.59 58.019 3.056 9.727 13.751 15.382 23.54 16.503 9.478 0.559 19.285 2.112 28.057 4.017 1.668 0.347 3.646 1.121 4.797 1.619 2.417 1.011 4.188 2.496 5.74 4.085 5.296-5.516 13.057-7.05 20.715-7.859 13.8-1.613 30.814-0.736 39.263-13.239l0-0.707c4.59-6.915 3.981-17.464 1.991-25.299-0.134-2.733-0.864-5.144-1.26-7.749-8.431-22.268-1.211-47.311 2.417-69.756-4.432 2.423-9.375 3.567-14.305 4.779-3.932 0.524-8.315 0.286-12.296 0.072l-1.65-0.444M392.795 902.697 392.795 902.697' fill='%23dc171d'/%3E %3Cpath d='m392.795 902.697c-0.055 1.466 0.737 2.618 1.023 3.974 1.613 9.734 3.172 22.627-6.848 28.666-11.085 7.049-25.622 4.03-38.448 7.761-2.563 0.712-6.093 3.069-7.895 4.736-1.157-0.761-2.319-1.93-3.811-2.617-10.555-5.613-24.276-3.732-36.189-6.764-5.984-1.893-12.223-6.555-13.739-12.68-3.896-16.07 5.436-29.767 4.334-45.709-0.712-12.175-2.758-23.862-5.57-35.276 9.314 4.34 20.094 5.064 30.565 2.983 7.755-1.084 16.783-1.108 24.051 2.173 4.005-1.723 8.693-2.496 13.009-2.971 8.206 0.798 17.026 2.283 25.476 2.222 5.643-0.293 10.769-1.924 15.675-4.097-2.91 18.865-8.498 38.625-1.637 57.599' fill='%2362afe1'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049' fill='%23fff'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049 0.006-0.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074' fill='%23fff'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074-0.006 0z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809' fill='%23fff'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M311.937 914.432l0.03 7.609 4.797 0-0.024-7.609-4.803 0M370.862 924.836l-0.061-13.087-10.446-0.012 0.049 13.099 10.458 0M363.18 914.481l0.055 7.585 4.791 0-0.043-7.585-4.803 0M370.783 903.506l-0.061-13.101-10.458 0 0.037 13.101 10.489 0-0.006 0zM363.101 893.163l0.03 7.597 4.791 0-0.006-7.597-4.815 0M319.534 903.458l-0.073-13.076-10.464-0.013 0.049 13.082 10.489 0 0 0.007zM311.851 893.115l0.024 7.585 4.803 0.012-0.036-7.597-4.791 0M338.502 903.481l-0.049-13.076-10.47-0.012 0.043 13.087 10.476 0M330.826 893.127l0.024 7.585 4.797 0.024-0.03-7.609-4.791 0M353.124 903.506l-0.073-13.101-10.464-0.012 0.049 13.087 10.489 0.025M345.435 893.14l0.037 7.609 4.797 0-0.024-7.609-4.809 0' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024' fill='%23fff'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024 0.006 0zM325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M329.018 929.675l-0.103-21.342M352.143 929.687l-0.103-21.329M366.79 886.626l-17.081-12.474-19.193-0.024-16.947 12.449 53.222 0.049M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m331.994 863.799 0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m336.371 865.686 0.024 3.792 7.414 0-0.024-3.792-7.414 0M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742' fill='%23fff'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186c0 0 1.065 1.37 0.018 2.94l0.578 1.09-2.131 0 0.578-1.035c0 0-1.09-1.82 0.049-2.995l-0.657-1.186M331.313 900.335l2.21 0-0.639 1.186c0 0 1.065 1.334 0.006 2.94l0.572 1.09-2.124 0 0.572-1.035c0 0-1.065-1.82 0.055-2.995l-0.651-1.186M336.225 900.335l2.204 0-0.657 1.186c0 0 1.077 1.37 0.018 2.94l0.578 1.114-2.112-0.024 0.566-1.035c0 0-1.077-1.808 0.043-2.995l-0.645-1.186 0.006 0zM341.771 900.346l2.222 0-0.651 1.199c0 0 1.065 1.346 0.006 2.922l0.597 1.108-2.143 0 0.572-1.035c0 0-1.065-1.832 0.073-2.995l-0.67-1.199-0.006 0zM346.701 900.346l2.204 0-0.651 1.199c0 0 1.071 1.346 0.012 2.916l0.584 1.114-2.124 0 0.554-1.035c0 0-1.071-1.82 0.085-2.995l-0.664-1.199M351.602 900.359l2.204-0.012-0.651 1.199c0 0 1.09 1.346 0.03 2.922l0.554 1.108-2.131 0 0.572-1.035c0 0-1.065-1.82 0.073-2.995l-0.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' fill='%23f9d90f'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407' fill='%23f9d90f'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407l0 0.012z' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' fill='%237e7e7e'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198' fill='%23f9d90f'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198zM294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406' fill='%23ff0'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406l0 0.012z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' fill='%237e7e7e'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101' fill='%23f9d90f'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101l0 0.005zM387.036 978.575 372.615 975.416' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m333.072 977.041c-0.323 0.207-0.761 0.262-1.266 0.237l-2.277-0.116 0.195-2.842 2.258 0.121c0.444 0.03 0.797 0.116 1.017 0.25 0.457 0.237 0.657 0.676 0.615 1.284-0.03 0.524-0.213 0.865-0.548 1.065m-3.823 4.475 0.225-3.464 2.654 0.183c0.858 0.067 1.497-0.158 1.93-0.597 0.45-0.426 0.682-0.986 0.712-1.619 0.055-0.737-0.134-1.34-0.572-1.784-0.42-0.426-1.017-0.651-1.765-0.724l-3.792-0.237-0.524 8.156 1.126 0.074M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03c0.402 0.037 0.718 0.085 0.95 0.195 0.426 0.201 0.627 0.603 0.627 1.187 0 0.548-0.158 0.914-0.469 1.133-0.298 0.2-0.73 0.292-1.248 0.292l-2.666-0.03 0.024-2.806m-0.043 7.226 0.024-3.482 2.605 0.037c0.463 0 0.804 0.036 1.041 0.152 0.384 0.177 0.572 0.548 0.59 1.059l0.067 1.37c0.018 0.329 0.024 0.53 0.043 0.664 0.037 0.097 0.055 0.201 0.103 0.275l1.4 0-0.024-0.177c-0.158-0.085-0.286-0.249-0.341-0.499-0.049-0.158-0.073-0.396-0.085-0.694l-0.024-1.09c-0.018-0.493-0.103-0.833-0.292-1.023-0.164-0.219-0.39-0.408-0.737-0.524 0.39-0.206 0.682-0.444 0.895-0.737 0.201-0.323 0.304-0.73 0.304-1.229 0-0.937-0.383-1.577-1.163-1.924-0.42-0.189-0.956-0.287-1.589-0.298l-3.914-0.037-0.03 8.181 1.126 0M346.135 980.206c-0.499-0.608-0.767-1.369-0.828-2.27-0.055-1.133 0.164-1.997 0.682-2.582 0.524-0.633 1.199-0.937 2.082-0.986 0.889-0.049 1.619 0.237 2.161 0.797 0.554 0.548 0.87 1.309 0.925 2.259 0.03 0.913-0.128 1.722-0.548 2.434-0.414 0.725-1.102 1.133-2.118 1.157-1.059 0.055-1.851-0.194-2.356-0.81m-1.339-5.15c-0.524 0.81-0.737 1.747-0.682 2.88 0.079 1.223 0.457 2.234 1.169 2.995 0.791 0.761 1.838 1.144 3.129 1.071 1.382-0.061 2.423-0.584 3.129-1.546 0.572-0.87 0.846-1.882 0.785-3.129-0.079-1.114-0.402-2.021-1.004-2.697-0.761-0.907-1.875-1.308-3.385-1.247-1.424 0.091-2.471 0.614-3.147 1.673M383.238 963.29c0.785-0.134 1.467-0.097 2.088 0.116 0.913 0.286 1.528 0.962 1.911 1.997l-1.126 0.158c-0.243-0.559-0.59-0.943-1.059-1.157-0.457-0.2-1.029-0.25-1.686-0.152-0.767 0.116-1.382 0.499-1.814 1.114-0.426 0.657-0.554 1.534-0.365 2.653 0.158 0.926 0.499 1.711 1.059 2.234 0.517 0.536 1.278 0.724 2.271 0.584 0.743-0.122 1.339-0.419 1.759-0.931 0.438-0.486 0.566-1.224 0.42-2.173l-2.624 0.402-0.134-0.901 3.652-0.561 0.712 4.328-0.724 0.11-0.45-0.998c-0.304 0.451-0.609 0.798-0.877 0.998-0.45 0.354-1.059 0.579-1.82 0.688-0.986 0.152-1.887-0.025-2.703-0.548-0.895-0.664-1.473-1.65-1.692-3.019-0.237-1.345-0.024-2.496 0.597-3.403 0.59-0.876 1.449-1.387 2.605-1.552M391.498 962.656l2.618-0.95c0.359-0.133 0.67-0.177 0.937-0.145 0.481 0.036 0.834 0.322 1.035 0.894 0.189 0.487 0.189 0.913-0.024 1.212-0.225 0.31-0.578 0.536-1.09 0.724l-2.459 0.883-1.017-2.618m2.618 6.764-1.278-3.281 2.435-0.877c0.457-0.146 0.773-0.225 1.011-0.2 0.432 0.054 0.761 0.317 0.98 0.815l0.554 1.249c0.122 0.31 0.219 0.499 0.298 0.584 0.037 0.11 0.116 0.177 0.177 0.249l1.321-0.486-0.073-0.177c-0.195 0-0.383-0.11-0.524-0.323-0.103-0.152-0.201-0.371-0.341-0.626l-0.432-1.023c-0.195-0.444-0.396-0.718-0.627-0.883-0.231-0.128-0.524-0.213-0.87-0.237 0.268-0.311 0.463-0.622 0.536-0.987 0.079-0.371 0.043-0.785-0.134-1.247-0.335-0.87-0.95-1.345-1.814-1.406-0.457-0.036-0.98 0.061-1.583 0.273l-3.677 1.309 2.971 7.694 1.077-0.396M403.691 965.366l-4.669-6.812 5.126-3.269 0.566 0.822-4.2 2.684 1.437 2.082 3.878-2.496 0.53 0.797-3.878 2.496 1.583 2.295 4.273-2.734 0.566 0.804-5.217 3.33M407.776 953.325l1.339-1.473c0.621-0.657 1.278-0.956 1.997-0.87 0.718 0.061 1.449 0.438 2.228 1.12 0.213 0.164 0.402 0.377 0.597 0.615 0.341 0.444 0.542 0.835 0.67 1.224 0.11 0.488 0.085 0.932-0.085 1.358-0.103 0.212-0.286 0.462-0.56 0.761l-1.345 1.461-4.839-4.206m7.074 3.207c0.95-1.046 1.157-2.173 0.603-3.445-0.323-0.688-0.816-1.358-1.497-1.942-0.858-0.761-1.753-1.151-2.697-1.223-1.047-0.08-1.936 0.298-2.709 1.144l-2.283 2.447 6.294 5.491 2.283-2.459M419.725 950.171l-7.244-4.255 0.59-0.937 7.256 4.231-0.597 0.973M422.568 945.229l-7.822-3.13 2.307-5.503 0.95 0.365-1.881 4.535 2.356 0.926 1.759-4.177 0.901 0.372-1.741 4.17 2.636 1.071 1.93-4.589 0.95 0.359-2.35 5.601M426.16 935.623l-8.23-1.82 0.274-1.272 7.603-2.569-6.678-1.473 0.244-0.998 8.23 1.771-0.262 1.236-7.615 2.624 6.678 1.443-0.237 1.059M425.508 925.171l0.103-1.035c0.475 0.013 0.877-0.061 1.181-0.225 0.597-0.323 0.944-0.937 1.035-1.845 0.037-0.425 0.018-0.797-0.079-1.151-0.177-0.681-0.56-1.059-1.175-1.12-0.457-0.049-0.785 0.061-1.023 0.311-0.213 0.286-0.438 0.699-0.609 1.284l-0.377 1.077c-0.243 0.706-0.469 1.193-0.712 1.466-0.39 0.512-0.937 0.688-1.637 0.64-0.749-0.079-1.357-0.377-1.79-0.95-0.444-0.524-0.627-1.272-0.517-2.198 0.073-0.846 0.353-1.558 0.852-2.13 0.463-0.524 1.181-0.774 2.1-0.676l-0.085 1.035c-0.45 0-0.81 0.079-1.071 0.262-0.475 0.262-0.737 0.816-0.816 1.625-0.067 0.67 0.024 1.12 0.28 1.462 0.256 0.286 0.578 0.468 0.956 0.499 0.402 0.037 0.718-0.091 0.937-0.401 0.158-0.214 0.347-0.676 0.603-1.425l0.371-1.132c0.183-0.524 0.402-0.925 0.657-1.211 0.457-0.475 1.053-0.676 1.802-0.62 0.913 0.097 1.564 0.475 1.899 1.169 0.329 0.7 0.457 1.473 0.377 2.35-0.103 0.992-0.426 1.771-1.023 2.295-0.597 0.535-1.339 0.718-2.24 0.645M254.898 924.672l0.189 1.022c-0.457 0.091-0.822 0.275-1.09 0.512-0.481 0.45-0.645 1.126-0.481 2.045 0.073 0.389 0.213 0.772 0.39 1.077 0.365 0.621 0.84 0.87 1.443 0.772 0.444-0.079 0.737-0.249 0.877-0.566 0.134-0.311 0.231-0.786 0.262-1.394l0.055-1.151c0.037-0.712 0.116-1.272 0.274-1.583 0.25-0.56 0.718-0.907 1.418-1.022 0.749-0.135 1.406 0.036 1.972 0.462 0.572 0.396 0.95 1.084 1.09 1.997 0.177 0.835 0.097 1.583-0.231 2.258-0.317 0.658-0.925 1.059-1.857 1.23l-0.183-1.034c0.432-0.158 0.755-0.311 0.968-0.524 0.365-0.408 0.475-0.998 0.335-1.808-0.11-0.658-0.335-1.084-0.676-1.297-0.335-0.25-0.67-0.348-1.035-0.286-0.408 0.061-0.676 0.286-0.804 0.651-0.079 0.243-0.14 0.748-0.195 1.522l-0.055 1.193c-0.03 0.56-0.116 1.023-0.304 1.34-0.298 0.584-0.804 0.943-1.54 1.059-0.931 0.158-1.65-0.055-2.161-0.651-0.524-0.584-0.846-1.284-1.01-2.155-0.183-1.035-0.049-1.838 0.365-2.483 0.42-0.664 1.084-1.047 1.984-1.175M254.381 935.465l8.047-2.423 1.875 5.667-0.98 0.31-1.534-4.657-2.447 0.737 1.418 4.303-0.937 0.298-1.406-4.315-2.727 0.815 1.558 4.76-0.962 0.275-1.905-5.771M257.948 945.289l7.402-3.926 0.791 1.381-5.089 5.381 7.433-1.272 0.767 1.37-7.384 3.902-0.524-0.908 4.359-2.294c0.158-0.092 0.402-0.226 0.755-0.414 0.347-0.158 0.737-0.372 1.126-0.573l-7.402 1.26-0.542-0.962 5.053-5.363-0.243 0.122c-0.158 0.091-0.432 0.225-0.804 0.438-0.365 0.226-0.639 0.365-0.816 0.438l-4.346 2.331-0.536-0.925M271.742 956.192c-0.371-0.085-0.737-0.298-1.096-0.67l-1.564-1.613 2.106-1.93 1.577 1.608c0.304 0.298 0.499 0.59 0.603 0.84 0.146 0.48 0 0.919-0.444 1.333-0.402 0.371-0.804 0.524-1.181 0.432m-5.947 0.749 2.581-2.368 1.832 1.857c0.59 0.603 1.193 0.877 1.826 0.865 0.645-0.037 1.199-0.275 1.686-0.737 0.548-0.487 0.81-1.059 0.81-1.673-0.006-0.597-0.28-1.157-0.785-1.68l-2.63-2.685-6.124 5.625 0.791 0.797M273.178 963.515l4.438-6.958 5.247 3.19-0.548 0.828-4.31-2.581-1.333 2.106 3.963 2.404-0.511 0.798-3.969-2.392-1.51 2.355 4.365 2.624-0.524 0.822-5.308-3.196M286.315 962.169l2.666 0.847c0.377 0.115 0.651 0.261 0.834 0.426 0.341 0.323 0.432 0.785 0.231 1.345-0.164 0.487-0.414 0.804-0.804 0.938-0.347 0.06-0.785 0.06-1.297-0.098l-2.514-0.803 0.883-2.655m-2.301 6.836 1.108-3.318 2.484 0.81c0.444 0.116 0.767 0.275 0.925 0.438 0.304 0.274 0.396 0.682 0.244 1.188l-0.371 1.32c-0.085 0.323-0.128 0.536-0.164 0.633 0 0.104 0 0.214 0.018 0.286l1.309 0.426 0.079-0.189c-0.14-0.11-0.219-0.31-0.213-0.559 0.03-0.153 0.073-0.396 0.158-0.676l0.317-1.059c0.128-0.463 0.177-0.81 0.061-1.059-0.097-0.262-0.262-0.5-0.536-0.724 0.414-0.074 0.773-0.201 1.077-0.427 0.286-0.25 0.53-0.597 0.676-1.083 0.298-0.883 0.134-1.62-0.524-2.18-0.329-0.292-0.797-0.542-1.412-0.773l-3.725-1.15-2.605 7.761 1.09 0.335M295.318 827.761 295.318 827.761' fill='%23012a87'/%3E %3Cpath d='m295.318 827.761c0.962-2.32 9.874-8.645 39.117-5.875 0 0 4.943 3.019 7.847 2.63 1.656-0.214-0.974 0.103-3.135-1.693-2.204-1.795-2.672-5.478 2.362-5.381 5.01 0.128 23.765 1.187 24.118 2.873 0.329 1.704-9.916 2.417-13.727 2.319-3.829-0.103-3.385 1.833 0.426 1.687 11.907-0.426 24.903-4.621 38.63 5.089 1.637 1.18-4.139 1.369-8.608-0.53 0 0-12.108 0.628-17.343-0.231 0 0-4.024 3.274-9.265 2.952 0.682 1.698-1.936 8.035-18.414 3.268-2.721 0.835-12.637 2.496-11.554-0.45-2.611 0-7.189 0.84-7.871-0.646-0.657-1.46 8.06-3.671 9.588-5.253 0 0-18.439 0.177-21.933-1.096 0 0-10.878 2.441-10.239 0.323' fill='%23bc715f'/%3E %3Cpath d='m301.229 853.583c0.396-0.535 0.554-1.497 1.394-1.473 1.826 0.486 3.068 3.828 5.314 1.661 0.797-0.177 1.102 0.908 1.759 1.035 0.42 1.857 1.911-0.377 3.025-0.25 2.38-1.059 5.326-1.309 8.145-0.785 0.085 1.82-1.339 3.829-3.129 4.864 0.037 1.833 1.698 3.008 1.668 4.852-0.286 0.688-0.049 1.771-1.09 1.997-1.321-0.237-2.624-0.377-3.719-1.114-0.134-0.134-0.243-0.396-0.524-0.31-0.134 0.615 0.828 1.224 1.205 1.851-0.664 1.132-1.765 0.097-2.691 0.11-0.274 0.651-0.012 1.473-0.682 1.893-1.169-0.036-1.406-1.308-2.124-1.942-0.737 0.797 0.517 1.272 0.694 1.905-0.45 2.398-0.39 4.742-2.788 6.313l-1.607 0.798c-0.438-1.205-0.164-3.032-0.457-4.292-0.95 1.546-1.692 2.898-3.086 4.206-1.631-0.536-2.581-2.459-2.94-4.054-0.682-1.857-0.292-4.079 1.175-5.424-0.499-0.974-2.21-0.749-2.453-2.136-2.563-1.669-3.981 2.922-5.637 0.535-0.536-2.227 0.103-4.998 1.717-6.66-0.359-0.912-1.552-0.675-2.258-1.199-1.613-1.37-3.939-2.818-3.823-5.291 4.413-1.667 9.691-0.444 12.899 2.91' fill='%23008830'/%3E %3Cpath d='m303.518 853.334c-0.103 2.02 1.364 0.547 2.453 1.771-0.852-0.335-1.473 1.473-2.307 0.438l-0.524 0.5c0.304 0.693 0.895 0.785 0.28 1.546-0.913 0.347-1.096-0.797-1.522-1.248-0.073-0.2 0.14-0.578-0.195-0.712-0.517 0.438-1.059 0.597-1.771 0.524-0.195-0.39-0.572-0.901-0.189-1.199 0.7-0.944 1.784 0.34 2.313-0.323 0.085-0.584-0.426-1.297 0.237-1.699 0.457 0.079 1.041-0.17 1.23 0.402M308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99c0.055 0.39-0.201 0.937 0.31 1.212 0.664-0.36 1.37-0.086 1.753 0.572-0.006 0.352 0.103 0.815-0.359 0.986l-1.035-0.194c0.073-0.201-0.256-0.329-0.384-0.524-0.457-0.14-0.724 0.231-1.065 0.456 0.256 0.39 0.846 0.603 0.706 1.102-0.609 0.608-0.907-0.524-1.577-0.238-0.457-0.176 0.164-1.126-0.554-1.412-0.852 0-0.286 1.399-1.376 0.852-0.39-0.439-0.773-1.029-0.353-1.522 0.457-0.305 1.23-0.226 1.619 0.17 0.664-0.736 0.73-3.579 2.319-1.461M302.179 857.924c0.444 0.64-0.097 1.51 0.469 2.222 0.889-1.661 1.747 0.359 2.806 0.201 0.323 0.396 0.11 0.944 0.17 1.394-1.309 0.347-2.885 0.761-4.042-0.286l-0.323 0.371c0.688 0.64 1.339 1.364 0.791 2.435-0.98 0.213-2.496 0.237-2.989-0.773-0.256-0.833 0.597-1.436-0.304-2.106-0.651 0.81-0.621 1.894-1.978 1.157-0.84-0.463-1.09-1.418-0.67-2.222 0.877-1.382 2.411 0.043 3.36-0.633 0.134-1.187-0.304-2.222 0.785-2.879 0.931-0.165 1.364 0.535 1.93 1.119' fill='%23f9d90f'/%3E %3Cpath d='m305.892 858.648c-0.438 2.021-1.96-0.103-2.672-0.189 0.95-1.686 1.546 0.548 2.672 0.189M310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846c-1.059 0.298-0.895-1.023-1.418-1.541l0.408-0.371c0.384 0.463 0.676 1.297 1.011 1.912' fill='%23fff'/%3E %3Cpath d='m309.197 860.444c0.304 0.7-0.688 1.261 0.158 1.771 0.268-0.225 0.597-0.536 0.737-0.664 0.724 0.214 1.564 0.342 2.07 1.059 0.542 1.486-0.962 1.449-1.814 1.863l-0.846-0.036c0.201-0.414-0.365-0.59-0.505-0.876-0.39-0.097-0.712 0.024-0.931 0.352 0.189 0.944 1.339 1.68 0.152 2.52-1.004-0.066-2.563 0.323-2.471-1.065-0.377-0.785 1.023-1.997-0.475-2.045-0.493 1.059-1.035 2.081-2.319 1.077l0.158-1.51c1.23 0.036 2.685 0.249 3.238-1.126 0.353-0.998-0.615-1.918 0.25-2.709 1.254-0.286 1.96 0.554 2.599 1.387' fill='%23f9d90f'/%3E %3Cpath d='m308.296 862.714c0.317 0.749-0.536 0.798-0.937 1.169-0.542 0.043-0.919-0.17-1.248-0.536-0.243-0.907 0.432-0.998 0.95-1.357 0.603-0.25 0.852 0.45 1.236 0.724' fill='%23000'/%3E %3Cpath d='m307.56 863.201c-0.134 0.177-0.323 0.122-0.524 0.17l-0.189-0.906c0.402 0.036 0.925 0.164 0.712 0.736' fill='%23fff'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/marker%3E %3C/defs%3E %3Cpath d='M0 0 298.571 225.241 675 225.241 675 0z' fill='%23dc171d'/%3E %3Cpath d='M0 0 299.005 225.746 0 450z' style='fill:%23fff;stroke:%23fff'/%3E %3Cpath d='M0 450 298.571 225.241 675 225.241 675 450z' fill='%23012a87'/%3E %3Cg transform='matrix(1.0075359,0,0,1.0073522,-229.18917,-679.02099)'%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342' fill='%23ff0'/%3E %3Cpath d='m377.175 843.108 0.091-3.458c0 0-1.857-2.958 0.298-6.136 0 0-4.578-2.422-3.512-6.215 0 0-4.139-1.059-3.835-5.613 0 0-4.468-0.31-4.931-4.114 0 0-4.468 0.736-6.434-2.971 0 0-4.359 0.852-5.588-2.204 0 0-4.237 1.468-6.751-2.124 0 0-4.474 1.808-6.349-1.583-1.851 3.379-6.325 1.583-6.325 1.583-2.484 3.579-6.751 2.094-6.751 2.094-1.187 3.068-5.533 2.198-5.533 2.198-1.96 3.708-6.422 2.971-6.422 2.971-0.438 3.793-4.9 4.103-4.9 4.103 0.353 4.566-3.78 5.601-3.78 5.601 1.09 3.792-3.482 6.208-3.482 6.208 2.21 3.196 0.371 6.131 0.371 6.131l-0.103 3.189 73.949 0.342-0.012 0z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m375.446 838.791c-11.615-1.163-24.989-3.92-35.313 1.894-6.921-4.079-16.558-3.83-24.763-3.031-4.456 0.797-9.697 0.797-14.354 1.558l-0.73 0.103c-8.449 0.561-16.113-1.936-23.455-5.217 2.331 13.234 4.919 26.797 6.191 40.652 2.77 20.52-9.709 37.748-4.59 58.019 3.056 9.727 13.751 15.382 23.54 16.503 9.478 0.559 19.285 2.112 28.057 4.017 1.668 0.347 3.646 1.121 4.797 1.619 2.417 1.011 4.188 2.496 5.74 4.085 5.296-5.516 13.057-7.05 20.715-7.859 13.8-1.613 30.814-0.736 39.263-13.239l0-0.707c4.59-6.915 3.981-17.464 1.991-25.299-0.134-2.733-0.864-5.144-1.26-7.749-8.431-22.268-1.211-47.311 2.417-69.756-4.432 2.423-9.375 3.567-14.305 4.779-3.932 0.524-8.315 0.286-12.296 0.072l-1.65-0.444M392.795 902.697 392.795 902.697' fill='%23dc171d'/%3E %3Cpath d='m392.795 902.697c-0.055 1.466 0.737 2.618 1.023 3.974 1.613 9.734 3.172 22.627-6.848 28.666-11.085 7.049-25.622 4.03-38.448 7.761-2.563 0.712-6.093 3.069-7.895 4.736-1.157-0.761-2.319-1.93-3.811-2.617-10.555-5.613-24.276-3.732-36.189-6.764-5.984-1.893-12.223-6.555-13.739-12.68-3.896-16.07 5.436-29.767 4.334-45.709-0.712-12.175-2.758-23.862-5.57-35.276 9.314 4.34 20.094 5.064 30.565 2.983 7.755-1.084 16.783-1.108 24.051 2.173 4.005-1.723 8.693-2.496 13.009-2.971 8.206 0.798 17.026 2.283 25.476 2.222 5.643-0.293 10.769-1.924 15.675-4.097-2.91 18.865-8.498 38.625-1.637 57.599' fill='%2362afe1'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049' fill='%23fff'/%3E %3Cpath d='m376.042 906.458-0.091-17.739 2.185 0-27.113-17.513-0.049-9.101 2.618 0-13.557-9.709-13.49 9.703 2.611 0 0.049 9.094-26.967 17.49 2.155 0.012 0.091 17.727 71.551 0.049 0.006-0.013z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074' fill='%23fff'/%3E %3Cpath d='m384.376 929.761 0.006 5.551-87.347-0.097-0.036-5.527 87.384 0.074-0.006 0z' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809' fill='%23fff'/%3E %3Cpath d='m302.836 929.426-0.073-18.786 3.537-0.007-0.195 19.005 0.213-18.852-5.095-0.146 0-4.03 78.064 0.086 0.037 3.993-4.815 0 0.091 19.023-0.17-19.023 3.585 0 0.079 18.809M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M319.619 924.8l-0.055-13.1-10.482 0 0.061 13.087 10.476 0.013M311.937 914.432l0.03 7.609 4.797 0-0.024-7.609-4.803 0M370.862 924.836l-0.061-13.087-10.446-0.012 0.049 13.099 10.458 0M363.18 914.481l0.055 7.585 4.791 0-0.043-7.585-4.803 0M370.783 903.506l-0.061-13.101-10.458 0 0.037 13.101 10.489 0-0.006 0zM363.101 893.163l0.03 7.597 4.791 0-0.006-7.597-4.815 0M319.534 903.458l-0.073-13.076-10.464-0.013 0.049 13.082 10.489 0 0 0.007zM311.851 893.115l0.024 7.585 4.803 0.012-0.036-7.597-4.791 0M338.502 903.481l-0.049-13.076-10.47-0.012 0.043 13.087 10.476 0M330.826 893.127l0.024 7.585 4.797 0.024-0.03-7.609-4.791 0M353.124 903.506l-0.073-13.101-10.464-0.012 0.049 13.087 10.489 0.025M345.435 893.14l0.037 7.609 4.797 0-0.024-7.609-4.809 0' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024' fill='%23fff'/%3E %3Cpath d='m355.717 899.488 0.116 30.199-30.333-0.049-0.11-30.174 30.321 0.024 0.006 0zM325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M325.207 908.108l30.54 0.024M329.018 929.675l-0.103-21.342M352.143 929.687l-0.103-21.329M366.79 886.626l-17.081-12.474-19.193-0.024-16.947 12.449 53.222 0.049M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012M331.994 863.799l0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m331.994 863.799 0.03 7.609 16.144 0.012-0.03-7.609-16.144-0.012' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m336.371 865.686 0.024 3.792 7.414 0-0.024-3.792-7.414 0M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325M340.036 855.142l8.979 6.348-17.891-0.024 8.912-6.325' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742' fill='%23fff'/%3E %3Cpath d='m376.341 850.838c2.551-0.061 3.208 10.507 3.214 15.742 2.191 0.615 7.049 3.671 9.198 6.434l-24.642-0.036c2.118-2.727 6.94-5.795 9.113-6.409 0-5.242 0.536-15.803 3.117-15.742M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186M326.808 900.335l2.21 0-0.645 1.186c0 0 1.065 1.37 0.018 2.94l0.578 1.09-2.131 0 0.578-1.035c0 0-1.09-1.82 0.049-2.995l-0.657-1.186M331.313 900.335l2.21 0-0.639 1.186c0 0 1.065 1.334 0.006 2.94l0.572 1.09-2.124 0 0.572-1.035c0 0-1.065-1.82 0.055-2.995l-0.651-1.186M336.225 900.335l2.204 0-0.657 1.186c0 0 1.077 1.37 0.018 2.94l0.578 1.114-2.112-0.024 0.566-1.035c0 0-1.077-1.808 0.043-2.995l-0.645-1.186 0.006 0zM341.771 900.346l2.222 0-0.651 1.199c0 0 1.065 1.346 0.006 2.922l0.597 1.108-2.143 0 0.572-1.035c0 0-1.065-1.832 0.073-2.995l-0.67-1.199-0.006 0zM346.701 900.346l2.204 0-0.651 1.199c0 0 1.071 1.346 0.012 2.916l0.584 1.114-2.124 0 0.554-1.035c0 0-1.071-1.82 0.085-2.995l-0.664-1.199M351.602 900.359l2.204-0.012-0.651 1.199c0 0 1.09 1.346 0.03 2.922l0.554 1.108-2.131 0 0.572-1.035c0 0-1.065-1.82 0.073-2.995l-0.651-1.187' style='fill:none;stroke-width:1.16422367;stroke:%23000'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' fill='%23f9d90f'/%3E %3Cpath d='m340.699 968.397c11.359 0.037 25.329-2.283 31.873-5.667l14.372-1.273 0.286 17.538c-12.175 6.714-40.286 8.156-46.471 8.108-6.191 0.049-34.649-1.418-46.879-8.156l0.158-17.55 14.403 1.297c6.544 3.367 20.94 5.704 32.287 5.704l-0.03 0' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407' fill='%23f9d90f'/%3E %3Cpath d='m256.883 893.589 12.662 4.03-3.829 20.503-11.986 1.862c0 0-2.021-10.781 3.153-26.407l0 0.012z' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' fill='%237e7e7e'/%3E %3Cpath d='m265.709 917.896-11.98 2.088 7.579-10.781 4.401 8.693' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198' fill='%23f9d90f'/%3E %3Cpath d='m249.31 908.358 12.205 0.882c0.274 10.343 1.528 49.813 48.656 51.956l-1.467 14.36c-57.367 0.596-61.726-48.413-59.394-67.198zM294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141M294.107 978.496l14.384-3.141' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406' fill='%23ff0'/%3E %3Cpath d='m423.518 893.735-12.613 3.993 3.999 20.472 12.01 1.929c0 0 1.93-10.774-3.397-26.406l0 0.012z' style='fill:%23f9d90f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' fill='%237e7e7e'/%3E %3Cpath d='m414.904 917.987 12.01 2.155-7.682-10.786-4.328 8.631' style='fill:%23f9b60f;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101' fill='%23f9d90f'/%3E %3Cpath d='m431.23 908.522-12.223 0.835c-0.177 10.33-1.077 49.818-48.206 51.912l1.601 14.348c57.355 0.663 61.3-48.322 58.828-67.101l0 0.005zM387.036 978.575 372.615 975.416' style='fill:none;stroke-width:0.27124387;stroke:%23000'/%3E %3Cpath d='m333.072 977.041c-0.323 0.207-0.761 0.262-1.266 0.237l-2.277-0.116 0.195-2.842 2.258 0.121c0.444 0.03 0.797 0.116 1.017 0.25 0.457 0.237 0.657 0.676 0.615 1.284-0.03 0.524-0.213 0.865-0.548 1.065m-3.823 4.475 0.225-3.464 2.654 0.183c0.858 0.067 1.497-0.158 1.93-0.597 0.45-0.426 0.682-0.986 0.712-1.619 0.055-0.737-0.134-1.34-0.572-1.784-0.42-0.426-1.017-0.651-1.765-0.724l-3.792-0.237-0.524 8.156 1.126 0.074M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03M337.497 974.691l2.776 0.03c0.402 0.037 0.718 0.085 0.95 0.195 0.426 0.201 0.627 0.603 0.627 1.187 0 0.548-0.158 0.914-0.469 1.133-0.298 0.2-0.73 0.292-1.248 0.292l-2.666-0.03 0.024-2.806m-0.043 7.226 0.024-3.482 2.605 0.037c0.463 0 0.804 0.036 1.041 0.152 0.384 0.177 0.572 0.548 0.59 1.059l0.067 1.37c0.018 0.329 0.024 0.53 0.043 0.664 0.037 0.097 0.055 0.201 0.103 0.275l1.4 0-0.024-0.177c-0.158-0.085-0.286-0.249-0.341-0.499-0.049-0.158-0.073-0.396-0.085-0.694l-0.024-1.09c-0.018-0.493-0.103-0.833-0.292-1.023-0.164-0.219-0.39-0.408-0.737-0.524 0.39-0.206 0.682-0.444 0.895-0.737 0.201-0.323 0.304-0.73 0.304-1.229 0-0.937-0.383-1.577-1.163-1.924-0.42-0.189-0.956-0.287-1.589-0.298l-3.914-0.037-0.03 8.181 1.126 0M346.135 980.206c-0.499-0.608-0.767-1.369-0.828-2.27-0.055-1.133 0.164-1.997 0.682-2.582 0.524-0.633 1.199-0.937 2.082-0.986 0.889-0.049 1.619 0.237 2.161 0.797 0.554 0.548 0.87 1.309 0.925 2.259 0.03 0.913-0.128 1.722-0.548 2.434-0.414 0.725-1.102 1.133-2.118 1.157-1.059 0.055-1.851-0.194-2.356-0.81m-1.339-5.15c-0.524 0.81-0.737 1.747-0.682 2.88 0.079 1.223 0.457 2.234 1.169 2.995 0.791 0.761 1.838 1.144 3.129 1.071 1.382-0.061 2.423-0.584 3.129-1.546 0.572-0.87 0.846-1.882 0.785-3.129-0.079-1.114-0.402-2.021-1.004-2.697-0.761-0.907-1.875-1.308-3.385-1.247-1.424 0.091-2.471 0.614-3.147 1.673M383.238 963.29c0.785-0.134 1.467-0.097 2.088 0.116 0.913 0.286 1.528 0.962 1.911 1.997l-1.126 0.158c-0.243-0.559-0.59-0.943-1.059-1.157-0.457-0.2-1.029-0.25-1.686-0.152-0.767 0.116-1.382 0.499-1.814 1.114-0.426 0.657-0.554 1.534-0.365 2.653 0.158 0.926 0.499 1.711 1.059 2.234 0.517 0.536 1.278 0.724 2.271 0.584 0.743-0.122 1.339-0.419 1.759-0.931 0.438-0.486 0.566-1.224 0.42-2.173l-2.624 0.402-0.134-0.901 3.652-0.561 0.712 4.328-0.724 0.11-0.45-0.998c-0.304 0.451-0.609 0.798-0.877 0.998-0.45 0.354-1.059 0.579-1.82 0.688-0.986 0.152-1.887-0.025-2.703-0.548-0.895-0.664-1.473-1.65-1.692-3.019-0.237-1.345-0.024-2.496 0.597-3.403 0.59-0.876 1.449-1.387 2.605-1.552M391.498 962.656l2.618-0.95c0.359-0.133 0.67-0.177 0.937-0.145 0.481 0.036 0.834 0.322 1.035 0.894 0.189 0.487 0.189 0.913-0.024 1.212-0.225 0.31-0.578 0.536-1.09 0.724l-2.459 0.883-1.017-2.618m2.618 6.764-1.278-3.281 2.435-0.877c0.457-0.146 0.773-0.225 1.011-0.2 0.432 0.054 0.761 0.317 0.98 0.815l0.554 1.249c0.122 0.31 0.219 0.499 0.298 0.584 0.037 0.11 0.116 0.177 0.177 0.249l1.321-0.486-0.073-0.177c-0.195 0-0.383-0.11-0.524-0.323-0.103-0.152-0.201-0.371-0.341-0.626l-0.432-1.023c-0.195-0.444-0.396-0.718-0.627-0.883-0.231-0.128-0.524-0.213-0.87-0.237 0.268-0.311 0.463-0.622 0.536-0.987 0.079-0.371 0.043-0.785-0.134-1.247-0.335-0.87-0.95-1.345-1.814-1.406-0.457-0.036-0.98 0.061-1.583 0.273l-3.677 1.309 2.971 7.694 1.077-0.396M403.691 965.366l-4.669-6.812 5.126-3.269 0.566 0.822-4.2 2.684 1.437 2.082 3.878-2.496 0.53 0.797-3.878 2.496 1.583 2.295 4.273-2.734 0.566 0.804-5.217 3.33M407.776 953.325l1.339-1.473c0.621-0.657 1.278-0.956 1.997-0.87 0.718 0.061 1.449 0.438 2.228 1.12 0.213 0.164 0.402 0.377 0.597 0.615 0.341 0.444 0.542 0.835 0.67 1.224 0.11 0.488 0.085 0.932-0.085 1.358-0.103 0.212-0.286 0.462-0.56 0.761l-1.345 1.461-4.839-4.206m7.074 3.207c0.95-1.046 1.157-2.173 0.603-3.445-0.323-0.688-0.816-1.358-1.497-1.942-0.858-0.761-1.753-1.151-2.697-1.223-1.047-0.08-1.936 0.298-2.709 1.144l-2.283 2.447 6.294 5.491 2.283-2.459M419.725 950.171l-7.244-4.255 0.59-0.937 7.256 4.231-0.597 0.973M422.568 945.229l-7.822-3.13 2.307-5.503 0.95 0.365-1.881 4.535 2.356 0.926 1.759-4.177 0.901 0.372-1.741 4.17 2.636 1.071 1.93-4.589 0.95 0.359-2.35 5.601M426.16 935.623l-8.23-1.82 0.274-1.272 7.603-2.569-6.678-1.473 0.244-0.998 8.23 1.771-0.262 1.236-7.615 2.624 6.678 1.443-0.237 1.059M425.508 925.171l0.103-1.035c0.475 0.013 0.877-0.061 1.181-0.225 0.597-0.323 0.944-0.937 1.035-1.845 0.037-0.425 0.018-0.797-0.079-1.151-0.177-0.681-0.56-1.059-1.175-1.12-0.457-0.049-0.785 0.061-1.023 0.311-0.213 0.286-0.438 0.699-0.609 1.284l-0.377 1.077c-0.243 0.706-0.469 1.193-0.712 1.466-0.39 0.512-0.937 0.688-1.637 0.64-0.749-0.079-1.357-0.377-1.79-0.95-0.444-0.524-0.627-1.272-0.517-2.198 0.073-0.846 0.353-1.558 0.852-2.13 0.463-0.524 1.181-0.774 2.1-0.676l-0.085 1.035c-0.45 0-0.81 0.079-1.071 0.262-0.475 0.262-0.737 0.816-0.816 1.625-0.067 0.67 0.024 1.12 0.28 1.462 0.256 0.286 0.578 0.468 0.956 0.499 0.402 0.037 0.718-0.091 0.937-0.401 0.158-0.214 0.347-0.676 0.603-1.425l0.371-1.132c0.183-0.524 0.402-0.925 0.657-1.211 0.457-0.475 1.053-0.676 1.802-0.62 0.913 0.097 1.564 0.475 1.899 1.169 0.329 0.7 0.457 1.473 0.377 2.35-0.103 0.992-0.426 1.771-1.023 2.295-0.597 0.535-1.339 0.718-2.24 0.645M254.898 924.672l0.189 1.022c-0.457 0.091-0.822 0.275-1.09 0.512-0.481 0.45-0.645 1.126-0.481 2.045 0.073 0.389 0.213 0.772 0.39 1.077 0.365 0.621 0.84 0.87 1.443 0.772 0.444-0.079 0.737-0.249 0.877-0.566 0.134-0.311 0.231-0.786 0.262-1.394l0.055-1.151c0.037-0.712 0.116-1.272 0.274-1.583 0.25-0.56 0.718-0.907 1.418-1.022 0.749-0.135 1.406 0.036 1.972 0.462 0.572 0.396 0.95 1.084 1.09 1.997 0.177 0.835 0.097 1.583-0.231 2.258-0.317 0.658-0.925 1.059-1.857 1.23l-0.183-1.034c0.432-0.158 0.755-0.311 0.968-0.524 0.365-0.408 0.475-0.998 0.335-1.808-0.11-0.658-0.335-1.084-0.676-1.297-0.335-0.25-0.67-0.348-1.035-0.286-0.408 0.061-0.676 0.286-0.804 0.651-0.079 0.243-0.14 0.748-0.195 1.522l-0.055 1.193c-0.03 0.56-0.116 1.023-0.304 1.34-0.298 0.584-0.804 0.943-1.54 1.059-0.931 0.158-1.65-0.055-2.161-0.651-0.524-0.584-0.846-1.284-1.01-2.155-0.183-1.035-0.049-1.838 0.365-2.483 0.42-0.664 1.084-1.047 1.984-1.175M254.381 935.465l8.047-2.423 1.875 5.667-0.98 0.31-1.534-4.657-2.447 0.737 1.418 4.303-0.937 0.298-1.406-4.315-2.727 0.815 1.558 4.76-0.962 0.275-1.905-5.771M257.948 945.289l7.402-3.926 0.791 1.381-5.089 5.381 7.433-1.272 0.767 1.37-7.384 3.902-0.524-0.908 4.359-2.294c0.158-0.092 0.402-0.226 0.755-0.414 0.347-0.158 0.737-0.372 1.126-0.573l-7.402 1.26-0.542-0.962 5.053-5.363-0.243 0.122c-0.158 0.091-0.432 0.225-0.804 0.438-0.365 0.226-0.639 0.365-0.816 0.438l-4.346 2.331-0.536-0.925M271.742 956.192c-0.371-0.085-0.737-0.298-1.096-0.67l-1.564-1.613 2.106-1.93 1.577 1.608c0.304 0.298 0.499 0.59 0.603 0.84 0.146 0.48 0 0.919-0.444 1.333-0.402 0.371-0.804 0.524-1.181 0.432m-5.947 0.749 2.581-2.368 1.832 1.857c0.59 0.603 1.193 0.877 1.826 0.865 0.645-0.037 1.199-0.275 1.686-0.737 0.548-0.487 0.81-1.059 0.81-1.673-0.006-0.597-0.28-1.157-0.785-1.68l-2.63-2.685-6.124 5.625 0.791 0.797M273.178 963.515l4.438-6.958 5.247 3.19-0.548 0.828-4.31-2.581-1.333 2.106 3.963 2.404-0.511 0.798-3.969-2.392-1.51 2.355 4.365 2.624-0.524 0.822-5.308-3.196M286.315 962.169l2.666 0.847c0.377 0.115 0.651 0.261 0.834 0.426 0.341 0.323 0.432 0.785 0.231 1.345-0.164 0.487-0.414 0.804-0.804 0.938-0.347 0.06-0.785 0.06-1.297-0.098l-2.514-0.803 0.883-2.655m-2.301 6.836 1.108-3.318 2.484 0.81c0.444 0.116 0.767 0.275 0.925 0.438 0.304 0.274 0.396 0.682 0.244 1.188l-0.371 1.32c-0.085 0.323-0.128 0.536-0.164 0.633 0 0.104 0 0.214 0.018 0.286l1.309 0.426 0.079-0.189c-0.14-0.11-0.219-0.31-0.213-0.559 0.03-0.153 0.073-0.396 0.158-0.676l0.317-1.059c0.128-0.463 0.177-0.81 0.061-1.059-0.097-0.262-0.262-0.5-0.536-0.724 0.414-0.074 0.773-0.201 1.077-0.427 0.286-0.25 0.53-0.597 0.676-1.083 0.298-0.883 0.134-1.62-0.524-2.18-0.329-0.292-0.797-0.542-1.412-0.773l-3.725-1.15-2.605 7.761 1.09 0.335M295.318 827.761 295.318 827.761' fill='%23012a87'/%3E %3Cpath d='m295.318 827.761c0.962-2.32 9.874-8.645 39.117-5.875 0 0 4.943 3.019 7.847 2.63 1.656-0.214-0.974 0.103-3.135-1.693-2.204-1.795-2.672-5.478 2.362-5.381 5.01 0.128 23.765 1.187 24.118 2.873 0.329 1.704-9.916 2.417-13.727 2.319-3.829-0.103-3.385 1.833 0.426 1.687 11.907-0.426 24.903-4.621 38.63 5.089 1.637 1.18-4.139 1.369-8.608-0.53 0 0-12.108 0.628-17.343-0.231 0 0-4.024 3.274-9.265 2.952 0.682 1.698-1.936 8.035-18.414 3.268-2.721 0.835-12.637 2.496-11.554-0.45-2.611 0-7.189 0.84-7.871-0.646-0.657-1.46 8.06-3.671 9.588-5.253 0 0-18.439 0.177-21.933-1.096 0 0-10.878 2.441-10.239 0.323' fill='%23bc715f'/%3E %3Cpath d='m301.229 853.583c0.396-0.535 0.554-1.497 1.394-1.473 1.826 0.486 3.068 3.828 5.314 1.661 0.797-0.177 1.102 0.908 1.759 1.035 0.42 1.857 1.911-0.377 3.025-0.25 2.38-1.059 5.326-1.309 8.145-0.785 0.085 1.82-1.339 3.829-3.129 4.864 0.037 1.833 1.698 3.008 1.668 4.852-0.286 0.688-0.049 1.771-1.09 1.997-1.321-0.237-2.624-0.377-3.719-1.114-0.134-0.134-0.243-0.396-0.524-0.31-0.134 0.615 0.828 1.224 1.205 1.851-0.664 1.132-1.765 0.097-2.691 0.11-0.274 0.651-0.012 1.473-0.682 1.893-1.169-0.036-1.406-1.308-2.124-1.942-0.737 0.797 0.517 1.272 0.694 1.905-0.45 2.398-0.39 4.742-2.788 6.313l-1.607 0.798c-0.438-1.205-0.164-3.032-0.457-4.292-0.95 1.546-1.692 2.898-3.086 4.206-1.631-0.536-2.581-2.459-2.94-4.054-0.682-1.857-0.292-4.079 1.175-5.424-0.499-0.974-2.21-0.749-2.453-2.136-2.563-1.669-3.981 2.922-5.637 0.535-0.536-2.227 0.103-4.998 1.717-6.66-0.359-0.912-1.552-0.675-2.258-1.199-1.613-1.37-3.939-2.818-3.823-5.291 4.413-1.667 9.691-0.444 12.899 2.91' fill='%23008830'/%3E %3Cpath d='m303.518 853.334c-0.103 2.02 1.364 0.547 2.453 1.771-0.852-0.335-1.473 1.473-2.307 0.438l-0.524 0.5c0.304 0.693 0.895 0.785 0.28 1.546-0.913 0.347-1.096-0.797-1.522-1.248-0.073-0.2 0.14-0.578-0.195-0.712-0.517 0.438-1.059 0.597-1.771 0.524-0.195-0.39-0.572-0.901-0.189-1.199 0.7-0.944 1.784 0.34 2.313-0.323 0.085-0.584-0.426-1.297 0.237-1.699 0.457 0.079 1.041-0.17 1.23 0.402M308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99 308.978 854.99c0.055 0.39-0.201 0.937 0.31 1.212 0.664-0.36 1.37-0.086 1.753 0.572-0.006 0.352 0.103 0.815-0.359 0.986l-1.035-0.194c0.073-0.201-0.256-0.329-0.384-0.524-0.457-0.14-0.724 0.231-1.065 0.456 0.256 0.39 0.846 0.603 0.706 1.102-0.609 0.608-0.907-0.524-1.577-0.238-0.457-0.176 0.164-1.126-0.554-1.412-0.852 0-0.286 1.399-1.376 0.852-0.39-0.439-0.773-1.029-0.353-1.522 0.457-0.305 1.23-0.226 1.619 0.17 0.664-0.736 0.73-3.579 2.319-1.461M302.179 857.924c0.444 0.64-0.097 1.51 0.469 2.222 0.889-1.661 1.747 0.359 2.806 0.201 0.323 0.396 0.11 0.944 0.17 1.394-1.309 0.347-2.885 0.761-4.042-0.286l-0.323 0.371c0.688 0.64 1.339 1.364 0.791 2.435-0.98 0.213-2.496 0.237-2.989-0.773-0.256-0.833 0.597-1.436-0.304-2.106-0.651 0.81-0.621 1.894-1.978 1.157-0.84-0.463-1.09-1.418-0.67-2.222 0.877-1.382 2.411 0.043 3.36-0.633 0.134-1.187-0.304-2.222 0.785-2.879 0.931-0.165 1.364 0.535 1.93 1.119' fill='%23f9d90f'/%3E %3Cpath d='m305.892 858.648c-0.438 2.021-1.96-0.103-2.672-0.189 0.95-1.686 1.546 0.548 2.672 0.189M310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846 310.634 860.846c-1.059 0.298-0.895-1.023-1.418-1.541l0.408-0.371c0.384 0.463 0.676 1.297 1.011 1.912' fill='%23fff'/%3E %3Cpath d='m309.197 860.444c0.304 0.7-0.688 1.261 0.158 1.771 0.268-0.225 0.597-0.536 0.737-0.664 0.724 0.214 1.564 0.342 2.07 1.059 0.542 1.486-0.962 1.449-1.814 1.863l-0.846-0.036c0.201-0.414-0.365-0.59-0.505-0.876-0.39-0.097-0.712 0.024-0.931 0.352 0.189 0.944 1.339 1.68 0.152 2.52-1.004-0.066-2.563 0.323-2.471-1.065-0.377-0.785 1.023-1.997-0.475-2.045-0.493 1.059-1.035 2.081-2.319 1.077l0.158-1.51c1.23 0.036 2.685 0.249 3.238-1.126 0.353-0.998-0.615-1.918 0.25-2.709 1.254-0.286 1.96 0.554 2.599 1.387' fill='%23f9d90f'/%3E %3Cpath d='m308.296 862.714c0.317 0.749-0.536 0.798-0.937 1.169-0.542 0.043-0.919-0.17-1.248-0.536-0.243-0.907 0.432-0.998 0.95-1.357 0.603-0.25 0.852 0.45 1.236 0.724' fill='%23000'/%3E %3Cpath d='m307.56 863.201c-0.134 0.177-0.323 0.122-0.524 0.17l-0.189-0.906c0.402 0.036 0.925 0.164 0.712 0.736' fill='%23fff'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1064' height='600'%3E %3Ctitle%3EFlag of El Salvador%3C/title%3E %3Crect height='600' width='1064' fill='%230f47af'/%3E %3Crect height='200' width='1064' y='200' fill='%23fff'/%3E %3Cg transform='translate(16.12698,0)'%3E %3Cg%3E %3Cg fill-rule='evenodd' stroke='%23000' stroke-width='0.304' fill='%23fff'%3E %3Cpath d='m515.01,353.35c1.5188,0,3.1669,0,10.11-1.6925,6.9428-1.6491,12.67-5.8572,14.015-6.4651,1.3451-0.60692,3.2972-0.43425,3.2972-0.43425-0.73822-0.78061-2.864-2.7337-5.8572-2.7337-3.0377,0-1.8228,0-4.3828,1.0846-2.56,1.0422-7.8971,4.2949-16.921,4.2949h-0.17266c-9.0251,0-14.665-3.2527-17.225-4.2949-2.56-1.0846-1.3886-1.0846-4.3828-1.0846-3.0377,0-5.12,1.9531-5.9006,2.7337,0,0,1.9955-0.17267,3.3406,0.43425,1.3451,0.60794,7.072,4.816,14.015,6.4651,6.8973,1.6925,8.5898,1.6925,10.065,1.6925z'/%3E %3Cpath d='m488.37,347.44c0.73718-0.43321-0.1737-1.6481-0.1737-1.6481l2.7337-0.60794c-1.3451-0.60692-3.3406-0.43425-3.3406-0.43425-0.5211,0.43425-0.43425,0.95534-0.5211,1.3451-0.0434,0.39082-0.0434,0.99877,0.26055,1.3017,0.25952,0.26055,1.0412,0.0434,1.0412,0.0434z'/%3E %3Cpath d='m490.92,345.19-2.7337,0.60794s0.91088,1.2149,0.1737,1.6481l4.816-0.91088s-0.73719-0.5211-2.256-1.3451z'/%3E %3Cpath d='m541.69,347.44c-0.73719-0.43321,0.13027-1.6481,0.13027-1.6481l-2.6903-0.60794c1.3451-0.60692,3.2972-0.43425,3.2972-0.43425,0.56349,0.43425,0.47664,0.95534,0.56349,1.3451,0.0434,0.39082,0.0434,0.99877-0.25951,1.3017-0.30294,0.26055-1.0412,0.0434-1.0412,0.0434z'/%3E %3Cpath d='m539.13,345.19,2.6903,0.60794s-0.86746,1.2149-0.13027,1.6481l-4.816-0.91088s0.73718-0.5211,2.256-1.3451z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m511.97,343.31-1.2188,3.0312,0.5625,0.21875c0.9109,0.39087,1.8168,0.18523,2.25-0.8125,0.39086-1.0422-0.13254-1.8088-1-2.1562l-0.59375-0.28125zm0.25,0.625,0.0937,0.0312c0.69376,0.303,1.1154,0.79993,0.8125,1.625-0.3474,0.78061-1.0372,0.80398-1.6875,0.5l-0.125-0.0312,0.90625-2.125z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='69.829,129.54,71.13,126.65,71.466,126.78,70.165,129.67,70.165,129.67'/%3E %3Cpath d='m516.34,345.28c-0.63438,0.0162-1.2381,0.44315-1.5312,1.0938-0.39086,0.8685-0.0115,1.7967,0.8125,2.1875,0.8241,0.34739,1.7977-0.0266,2.1875-0.9375,0.34737-0.824-0.0197-1.8269-0.84375-2.2188-0.20602-0.0869-0.41354-0.13041-0.625-0.125zm-0.0312,0.5c0.14642-0.001,0.31702,0.0286,0.46875,0.0937,0.65028,0.2595,0.82305,0.95559,0.5625,1.5625-0.2605,0.60797-0.96673,0.9168-1.5312,0.65625-0.52007-0.2605-0.80397-0.91113-0.5-1.5625,0.19538-0.4552,0.56075-0.74598,1-0.75z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' d='m503.81,347.36c-0.0434-0.21609-0.12924-0.38979-0.34637-0.47664-0.21609-0.0869-0.56348,0-0.65033,0.26055-0.0869,0.25951,0.0868,0.47767,0.21712,0.60691l0.21712,0.1737c0.34637,0.30397,0.56349,0.65137,0.34637,1.1714-0.21713,0.56452-0.78061,0.78165-1.3017,0.60795-0.43425-0.1737-0.69479-0.69376-0.56452-1.2149l0.39082,0.0868c-0.13027,0.30397,0.0434,0.65034,0.34637,0.78061,0.30397,0.13027,0.65137-0.0869,0.78164-0.38979,0.12924-0.34739-0.0868-0.56452-0.30397-0.78164l-0.17267-0.1737c-0.26055-0.26055-0.47664-0.56452-0.30397-0.99773,0.1737-0.47767,0.69479-0.65137,1.128-0.47767,0.34636,0.13027,0.52109,0.39082,0.56348,0.73821l-0.34739,0.0858z'/%3E %3Cpath fill-rule='evenodd' d='m506.2,347.53-0.52109,1.8228c-0.13028,0.5211-0.13028,1.0422,0.43424,1.2149,0.60692,0.17473,0.86746-0.25952,1.0412-0.78061l0.52006-1.8662,0.34637,0.13027-0.56349,1.9531c-0.1737,0.69376-0.73718,1.128-1.432,0.91088-0.69376-0.17266-0.95431-0.82403-0.73718-1.5188l0.56348-1.9965,0.34843,0.13028z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M82.754,133.95,80.992,131.06,80.53,133.36,80.194,133.32,80.824,130.05,80.824,130.05,82.544,132.9,83.006,130.64,83.342,130.68z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M83.552,133.87,83.929,130.76,84.265,130.8,83.887,133.95,83.887,133.95z'/%3E %3Cpath d='m530.31,348.88c-0.91089-0.0435-1.6441,0.68286-1.6875,1.5938-0.0434,0.99879,0.65162,1.7378,1.5625,1.7812,0.86846,0.0434,1.6441-0.62623,1.6875-1.625,0.0434-0.91086-0.694-1.75-1.5625-1.75zm-0.0625,0.46875c0.69377,0.0435,1.1372,0.63092,1.0938,1.2812,0,0.69483-0.54934,1.1562-1.1562,1.1562-0.60796-0.0434-1.0938-0.59863-1.0938-1.25,0.0434-0.6503,0.50592-1.1875,1.1562-1.1875z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M90.979,134.04,88.545,131.77,88.713,134.12,88.335,134.12,88.084,130.85,88.084,130.85,90.518,133.11,90.35,130.8,90.728,130.76z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M92.952,133.57,92.364,130.47,92.742,130.43,93.287,133.15,93.287,133.15,94.169,132.99,94.253,133.36z'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M94.63,133.24,93.917,130.17,94.295,130.09,95.008,133.15,95.008,133.15z'/%3E %3Cpath d='m540,347.72c-0.1356,0.007-0.26512,0.0299-0.40625,0.0625l-0.34375,0.125,0.875,3.125,0.6875-0.15625c0.52109-0.1737,0.95495-0.56738,0.78125-1.2188-0.0869-0.34739-0.42167-0.63715-0.8125-0.59375,0.1737-0.1737,0.19965-0.50163,0.15625-0.71875-0.16282-0.5211-0.53069-0.64739-0.9375-0.625zm0.0625,0.40625c0.20733-0.0346,0.4023,0.0493,0.5,0.375,0.13028,0.39082-0.13456,0.50795-0.4375,0.59375l-0.0937,0.0312-0.3125-0.9375h0.125c0.076-0.0326,0.14964-0.051,0.21875-0.0625zm0.5,1.3125c0.254-0.0285,0.52858,0.0181,0.59375,0.34375,0.13027,0.39082-0.16478,0.57045-0.46875,0.65625l-0.28125,0.0937-0.25-1,0.1875-0.0312c0.0757-0.0217,0.13409-0.053,0.21875-0.0625z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M98.869,130.01,98.995,130.34,97.861,130.72,98.239,131.85,99.414,131.43,99.54,131.81,98.029,132.32,96.98,129.34,96.98,129.34,98.533,128.79,98.617,129.12,97.442,129.54,97.735,130.38z'/%3E %3Cpath d='m544.75,346.19c-0.30397-0.0434-0.55195,0.026-0.8125,0.15625l-0.4375,0.1875,1.2188,3.0312,0.34375-0.125-0.46875-1.3125,0.125-0.0312,1.3438,0.90625,0.46875-0.15625-1.4688-0.96875c0.38977-0.21712,0.51745-0.69075,0.34375-1.125-0.0869-0.26055-0.35228-0.5191-0.65625-0.5625zm-0.0937,0.40625c0.16814,0.0163,0.31889,0.12662,0.40625,0.34375,0.17267,0.43321-0.18489,0.65097-0.53125,0.78125l-0.0625,0.0312-0.40625-1,0.0937-0.0312c0.15198-0.0651,0.33186-0.14128,0.5-0.125z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M100.8,127.87,102.44,127.15,102.6,127.45,101.93,127.74,103.11,130.3,103.11,130.3,102.77,130.47,101.6,127.91,100.97,128.2z'/%3E %3Cpath d='m548.34,344.19,0.21875,3.7188,0.40625-0.21875-0.0625-0.84375,1.2812-0.65625,0.6875,0.5625,0.34375-0.21875-2.875-2.3438zm0.4375,0.875,1,0.8125-0.90625,0.46875-0.0937-1.2812z' transform='translate(-16.12698,0)'/%3E %3Cpath d='m551.44,342.88c-0.31836,0.0182-0.65974,0.11748-0.96875,0.3125l-0.5625,0.3125,1.7188,2.8125,0.5-0.28125c0.86746-0.5201,1.252-1.3894,0.6875-2.3438-0.35219-0.59644-0.8444-0.84287-1.375-0.8125zm0.15625,0.5c0.30384,0.0271,0.60492,0.19339,0.84375,0.5625,0.43326,0.73715,0.0264,1.2967-0.625,1.6875l-0.0625,0.0312-1.1875-1.9375,0.0937-0.0937c0.3252-0.1737,0.63366-0.27714,0.9375-0.25z' transform='translate(-16.12698,0)'/%3E %3C/g%3E %3Cg id='g3' stroke='%23000' stroke-miterlimit='2.61310005'%3E %3Cg fill-rule='evenodd' stroke-width='0.13017058' fill='%23e60000'%3E %3Cpath d='m485.07,355.17c0.5211,0,0.91089-0.39082,0.91089-0.91192,0-0.47767-0.38979-0.86746-0.91089-0.86746-0.47663,0-0.91088,0.38979-0.91088,0.86746,0,0.5211,0.43425,0.91192,0.91088,0.91192z'/%3E %3Cpath d='m479.95,361.5c0.52006,0,0.91088-0.38979,0.91088-0.91089,0-0.47767-0.38979-0.91192-0.91088-0.91192-0.47767,0-0.91088,0.43425-0.91088,0.91192,0,0.5211,0.43424,0.91089,0.91088,0.91089z'/%3E %3Cpath d='m468.06,341.63c0.47664,0,0.91089-0.43425,0.91089-0.91089,0-0.52109-0.43425-0.91192-0.91089-0.91192-0.52006,0-0.91088,0.39083-0.91088,0.91192,0,0.47664,0.38979,0.91089,0.91088,0.91089z'/%3E %3Cpath d='m460.68,345.32c0.52007,0,0.99774-0.43424,0.99774-0.99876,0-0.52007-0.47767-0.99774-0.99774-0.99774-0.56452,0-0.99773,0.47767-0.99773,0.99774,0,0.56452,0.43321,0.99876,0.99773,0.99876z'/%3E %3Cpath d='m459.34,323.02c0.5211,0,0.99774-0.43322,0.99774-0.99774,0-0.52109-0.47664-0.99773-0.99774-0.99773-0.56348,0-0.99773,0.47664-0.99773,0.99773,0,0.56556,0.43321,0.99774,0.99773,0.99774z'/%3E %3Cpath d='m453.13,324.84c0.56452,0,0.99773-0.43425,0.99773-0.99774,0-0.56452-0.43321-0.99773-0.99773-0.99773-0.52006,0-0.99774,0.43321-0.99774,0.99773,0,0.56349,0.47664,0.99774,0.99774,0.99774z'/%3E %3Cpath d='m456.3,304.97c0.56452,0,0.99773-0.47767,0.99773-0.99774,0-0.56452-0.43321-0.99876-0.99773-0.99876-0.56349,0-0.99774,0.43424-0.99774,0.99876,0,0.5211,0.43425,0.99774,0.99774,0.99774z'/%3E %3Cpath d='m450.75,286.7c0.52006,0,0.99773-0.43425,0.99773-0.95431,0-0.56349-0.47663-0.99774-0.99773-0.99774-0.56452,0-0.99773,0.43322-0.99773,0.99774,0,0.52109,0.43321,0.95431,0.99773,0.95431z'/%3E %3Cpath d='m457.82,288.52c0.56349,0,0.99773-0.43321,0.99773-0.99774,0-0.52006-0.43424-0.99773-0.99773-0.99773-0.56452,0-0.99773,0.47767-0.99773,0.99773-0.001,0.56349,0.43321,0.99774,0.99773,0.99774z'/%3E %3Cpath d='m464.76,273.3c0.52109,0,0.99773-0.43424,0.99773-0.99773,0-0.52109-0.47664-0.95431-0.99773-0.95431-0.56349,0-0.99774,0.43322-0.99774,0.95431,0.001,0.56349,0.43425,0.99773,0.99774,0.99773z'/%3E %3Cpath d='m459.47,269.09c0.56452,0,0.99773-0.43424,0.99773-0.99773,0-0.52006-0.43321-0.99773-0.99773-0.99773-0.56349,0-0.99774,0.47664-0.99774,0.99773-0.001,0.56349,0.43322,0.99773,0.99774,0.99773z'/%3E %3Cpath d='m470.01,258.85c0.56348,0,0.99773-0.43322,0.99773-0.99774s-0.43425-0.99773-0.99773-0.99773c-0.56452,0-0.99774,0.43321-0.99774,0.99773-0.001,0.56452,0.43322,0.99774,0.99774,0.99774z'/%3E %3Cpath d='m448.49,305.1c0.56349,0,0.99774-0.43424,0.99774-0.95431,0-0.52109-0.43321-0.95534-0.99774-0.95534-0.52109,0-0.9543,0.43425-0.9543,0.95534,0,0.52007,0.43321,0.95431,0.9543,0.95431z'/%3E %3C/g%3E %3Cg stroke-width='0.26034117' fill='none'%3E %3Cpath d='m485.93,358.9s-0.73718-3.1669-0.60794-3.9041l0.78164-0.60794'/%3E %3Cpath d='m484.72,360.11s-2.8205,0.13027-3.7314,0.43425c0,0,0,0.1737-0.30294,0.78164'/%3E %3Cpath d='m467.28,345.8s-0.1737-3.7748,0.60795-4.0788c0,0,0.73718-0.30294,1.1714-0.91089'/%3E %3Cpath d='m464.41,344.58s-2.1257-0.30501-2.7337,0c0,0-0.13028,0.60691-0.60795,0.78061'/%3E %3Cpath d='m460.34,322.45-0.73719,0.43425c-0.78061,0.30294-2.256,3.9475-2.256,3.9475s-2.4297-1.8228-3.4709-1.9965h-1.0846'/%3E %3Cpath d='m447.97,304.66s0.60794,0.60794,1.2149,0.30397c0,0,2.9942,1.9531,3.1669,2.7337,0,0,3.1679-3.1669,3.7748-2.864,0,0,0.30294,0.43425,0.91088-0.17369'/%3E %3Cpath d='m451.31,286.14s0.30397,0.43321,0.86746,0.73718c0,0,1.3886,1.9955,1.3886,3.4709,0,0,2.56-2.256,3.2972-2.0823,0,0,0.91088,0.30294,1.5178,0'/%3E %3Cpath d='m458.69,268.83s0.60692,0.73718,1.0412,0.13027c0,0,1.8218,2.256,0.73719,3.9485,0,0,2.56-0.60691,3.3406-0.1737,0,0,0.30294,1.0412,1.2149,0.43425'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke-width='0.26034117' fill='%231f601a'%3E %3Cpath d='m532.79,378.34s-3.9041-0.30294-4.512-0.30294c-0.60794,0-1.9531-2.6913-2.56-3.1669-0.60795-0.43425-10.848-5.424-17.486-6.4651-6.6388-1.0412-16.834-4.9897-18.961-6.0309-11.021-5.2937-23.343-15.099-26.077-19.135-2.864-4.208-5.9006-14.015-7.2457-19.264-0.60795-2.4308-3.9051-12.366-3.9051-19.135,0-7.8526,0.91088-14.318,2.1257-19.438,1.1714-5.12,9.9794-20.131,15.359-26.814,0,0-12.105,18.743-14.188,25.903-2.0823,7.376-2.6903,16.357-2.56,21.477,0.13028,4.2091,3.6446,19.612,8.7646,30.936,4.0788,9.0685,7.6365,10.153,14.015,15.229,2.9942,2.3873,8.7211,6.1611,13.537,8.5919,4.816,2.3863,15.056,5.4229,17.789,5.8572,2.6903,0.47768,16.401,4.512,18.223,5.424,1.8249,0.91088,6.4672,4.9897,7.682,6.3338z'/%3E %3Cpath d='m464.11,343.41c0.30397-1.3886,0.43321-2.4297,0.91088-2.864,0.43322-0.47767,1.9531-2.3005,2.256-3.4709,0.30397-1.2148,0-2.1257,0-2.7337,0-0.60795,0.43321-2.6903,0.43321-2.6903s-0.73718-2.56-1.3451-3.0377c-0.60691-0.43425-2.1257-2.561-2.4297-3.1669,0,0,0.17266,1.2149-0.30397,1.8228-0.43425,0.60691-0.60692,2.1257-0.60692,2.9942,0,0.91089,0.30294,3.0377,0,4.0778-0.30397,1.1714-0.73718,2.1268-0.43424,3.4709,0.26158,1.0856,1.5199,5.5976,1.5199,5.5976z'/%3E %3Cpath d='m463.63,341.89s-3.4274-4.3818-3.4274-6.2046c0-1.7794-0.30294-2.864-0.60691-3.2972-0.30398-0.43321-2.256-2.7337-0.47664-5.5532,0.78061-1.2149,0.91088-1.128,1.3451-2.4308,0.60691-1.6491,1.8228-1.6491,1.9955-3.2961,0,0,0.43424,1.952,0.56452,3.6001,0.17266,1.6491-0.13028,2.257-0.26055,3.1669-0.1737,0.91192,0.43321,1.9531,0.43321,3.2972,0,1.3886-0.17266,1.9097-0.17266,2.7337-0.002,0.43528-0.56659,6.1622,0.60587,7.9839z'/%3E %3Cpath d='m502.25,365.41s-2.9074-0.30397-3.992-0.47767c-0.78061-0.0869-2.56-0.52006-3.5577-0.91088-0.86746-0.30398-2.56-1.2159-4.0344-2.7771-2.7771-2.9508-2.5166-4.5131-2.9942-4.6433-0.99773-0.17266,1.5612-0.43321,2.7771-0.25951,1.1714,0.13027,2.8205,0.99773,3.9051,2.0389,1.128,1.0422,2.864,2.2136,3.4709,2.6479,0.60691,0.47664,1.0412,0.65033,1.6915,1.5188,0.65137,0.86746,0.60794,1.432,2.7337,2.8629z'/%3E %3Cpath d='m506.24,367.53s-7.2891-3.2538-8.0274-3.8617c-0.78061-0.56452-1.9955-1.736-2.7771-2.56-0.73718-0.82507-3.8183-2.3873-4.3383-3.384-0.34636-0.6948-2.256-3.3406-3.384-5.424-0.56452-1.0846,4.8594,0.3474,4.8594,0.3474,4.4262,1.7794,2.4297,0.52109,4.8594,2.3439,1.4754,1.128,2.4731,2.0823,2.864,2.9074,0.56349,1.3017,1.2149,3.5567,1.8662,4.7292,0.60691,1.1704,1.7773,2.6882,4.0778,4.9018z'/%3E %3Cpath d='m510.19,368.45s-6.0309-1.5622-8.7646-5.2937c-1.9531-2.56-1.9531-1.7783-2.7771-2.6468-0.99773-1.0846-2.56-2.256-3.8607-4.4686,0.12924,0.21712-1.736-5.9006-1.6491-6.6388,0.0434-0.43322,2.2994,0.30397,4.1212,1.0846,1.5622,0.65137,2.4731,1.9096,3.8183,2.7347,1.6057,1.0412,1.8228,3.6435,2.56,4.8594,1.0412,1.7784,1.1714,2.6903,1.1714,3.5567-0.0434,1.3451,0.73718,1.7794,1.1714,2.9074,0.52213,1.3441,2.1268,1.128,4.2091,3.9051z'/%3E %3Cpath d='m500.56,366.45s-5.12-2.256-5.8582-2.4297c-0.78061-0.13028-1.0846-0.60795-2.1257-0.91192-0.86746-0.21712-1.6491-0.86746-3.7748-0.43321-0.91088,0.21609-4.6423,1.0412-5.5542,0.60691-0.91088-0.47767,1.3451,2.561,2.3863,3.1669,1.0846,0.60794,2.864,0.91191,4.3828,0.73822,1.5178-0.13028,3.6011,0,4.3818,0,0.73719,0,1.1714,0.17369,2.256-0.13028,1.0422-0.30294,1.3451-0.78061,3.9062-0.60691z'/%3E %3Cpath d='m504.03,366.45s-5.7279-1.432-6.6822-1.432c-0.95431,0-3.688,0.1737-4.816,0.39082-1.0846,0.1737-4.512-0.1737-5.5108,0.3474-1.0412,0.47664-5.5966,1.128-6.8115,0.82403-1.2149-0.26054,2.4297,3.2538,3.8617,3.6446,4.6423,1.3017,3.2538,1.128,6.248,0.3474,1.8228-0.47767,4.4262-0.60794,5.3371-0.73822,0.91088-0.1737,0.73718-0.69479,1.9531-1.2148,1.2138-0.52007,3.2527-1.8218,6.4206-2.1692z'/%3E %3Cpath d='m508.71,368.84s-5.7269-2.3873-10.197-1.1725c-3.08,0.86849-2.9942,0.73822-4.208,0.95534-1.432,0.21712-2.6468-0.5211-4.9897,0.43321-1.1714,0.47767-6.1611,2.5176-7.5497,2.4308-1.2583-0.0868,3.992,3.3406,5.424,3.1235,4.5989-0.65137,8.9382,0.91089,11.064,0.0434,1.9086-0.73822,3.0377-1.2583,3.992-1.5623,0.9543-0.34739,1.4754-1.2148,2.0823-1.6491,0.60691-0.47664,0.99773-1.6481,4.3818-2.6024z'/%3E %3Cpath d='m478.13,355.69s-3.2972-3.6435-3.9485-4.1212c-0.60691-0.47767-2.1692-1.6057-2.9942-2.3439-0.69376-0.60691-1.3886-1.952-3.5143-2.4731-0.91088-0.21712-3.1235-0.65137-3.7738-1.432-0.60794-0.82507,0.12924,2.9074,0.82404,3.9041,0.69479,0.99877,2.1702,2.0399,3.6011,2.561,1.432,0.52007,3.2538,1.5623,3.9051,1.9086,0.69376,0.30397,1.0412,0.65137,2.1257,0.82507,1.0846,0.21712,1.5622-0.0868,3.7748,1.1714z'/%3E %3Cpath d='m481.25,357.21s-5.5976-3.9475-6.4651-4.3818c-0.86746-0.39083-2.4731-0.95431-3.5143-1.3017-1.0846-0.30397-3.9051-2.3439-5.0331-2.3439s-3.2538-0.0869-4.2081-0.82403c-0.99773-0.78165-0.13027,2.7337,0.95431,3.7314,3.6012,3.2093,1.128,2.256,4.1212,2.864,1.8228,0.38978,4.2525,1.3886,5.12,1.6481,0.91089,0.26055,0.99774-0.30293,2.2994-0.21608,1.3027,0.0434,3.7325-0.21713,6.7256,0.82403z'/%3E %3Cpath d='m482.59,358.25s-2.2994-1.5199-6.8549-2.3005c-3.1235-0.56452-2.9942-0.6948-4.1646-0.99773-1.3886-0.43425-1.6925-0.43425-4.2525-0.56452-1.2583-0.0868-6.2046,1.5188-7.376,0.82506-1.0846-0.60794,1.2149,1.5178,2.6034,2.0389,1.9955,0.73822,1.736,2.0399,3.9051,2.7337,2.2994,0.73822,4.7292,1.6491,6.0743,1.3896,1.0412-0.21712,1.8228-0.6948,3.2972-0.82507,1.431-0.17473,3.9475-2.257,6.768-2.2994z'/%3E %3Cpath d='m483.07,357.08s1.128-5.4663,0.1737-6.768c-0.47664-0.60794-1.0846-1.4754-1.2149-2.865-0.13027-1.3451-1.0412-3.6001-1.6491-4.3383-0.60691-0.78061-1.8228-4.2515-1.5188-5.1189,0,0-3.1669,3.1235-2.9942,5.1189,0.13027,1.9531,0.13027,1.4764,0,2.3873-0.1737,0.91089,0.73718,3.9041,1.3451,4.816,0.60691,0.91089,0.30397,3.6435,0.91088,4.2081,0.60898,0.60794,4.2112,3.0377,4.9473,2.56z'/%3E %3Cpath d='m482.59,358.25c0.34739,0.17267-1.9086-1.736-2.9942-2.2136-1.0412-0.43425-5.2502-1.6491-5.5542-2.6903-0.30294-1.0856-3.7748-4.6857-3.9041-5.5976-0.13028-0.69376-0.78165-2.1257-0.60795-2.864,0.13028-0.73718,0.43425-2.56,0.91089-3.6011,0.43321-1.0846,1.4754-3.6001,2.56-4.0778,0,0,0.86746,2.864,1.1714,3.9051,0.30397,1.0846,0.60691,2.2994,1.0846,2.864,0.43321,0.60795,1.952,3.4698,2.0823,4.5555,0.1737,1.0412,0.91089,4.512,1.0846,5.2492,0.1313,0.73822,2.9518,3.8193,4.1667,4.4707z'/%3E %3Cpath d='m464.11,343.41c0.13027,0.78165-2.256-0.78061-3.4709-0.78061s-4.816,0.47664-5.7269-0.43424c-0.91088-0.91192-2.256-2.56-2.7337-2.864-0.43425-0.30398-2.0834-3.0377-2.56-4.512-0.43424-1.5188-3.6011-4.2525-4.0354-4.5555,0,0,4.3394-0.86849,7.072,0.91089,2.6903,1.8228,2.864,1.3886,3.4709,1.6491,0.60691,0.30397,5.2502,4.2515,5.5542,5.7269,0.30397,1.5188,2.257,4.0788,2.4297,4.8594z'/%3E %3Cpath d='m464.11,343.41s-3.9051-2.7337-4.816-2.6034c-0.91088,0.1737-5.1634-2.9942-5.4229-4.9463-0.1737-1.0412-2.2126-2.5166-2.56-3.1669-1.0846-1.8228-1.6925-5.8572-3.1669-6.9417,0,0,4.0778,1.0412,5.12,1.2148,1.9531,0.30397,3.6011,0.60691,4.3394,2.256,0.78061,1.6491,1.3886,3.0376,1.9955,3.1669,0.60691,0.1737,1.4754,2.257,1.7794,4.3818,0.30191,2.0834,2.7316,6.6388,2.7316,6.6388z'/%3E %3Cpath d='m456.73,322.89c0.65034,1.0412,0.60691-6.0319,0.86746-6.7691,0.30294-0.73822,1.0846-2.257,1.6915-2.864,0.60794-0.60795,0.60794-2.6903,0.91088-3.2972,0.26055-0.60795,0.13027-4.6857-0.30294-5.7269,0,0-1.2149,0.91089-1.8228,1.6481-0.60691,0.73822-1.6491,1.0422-1.952,1.9531-0.30398,0.91192-0.91089,0.91192-1.3451,1.8228-0.47664,0.91192-0.91089,2.3863-0.60691,3.6011,0.30397,1.2149,0.13027,1.6491,0.13027,2.7337,0,1.0401,1.5188,5.5532,2.4297,6.8983z'/%3E %3Cpath d='m456.86,323.49s-0.30398-1.9531,0.47663-2.6903c0.73719-0.78165,1.4754-0.78165,1.7794-1.2149,0.30294-0.47767,0.17267-1.0422,0.47664-1.6491,0.30397-0.60795,0.95431-1.6057,1.0412-2.1268,0.30397-1.6491,1.2148-3.4709,0.43424-5.2492,0,0-1.6491,0.56349-2.0823,0.86746-0.47767,0.30397-1.8228,1.5188-1.9531,2.7337-0.17266,1.3451-0.30294,1.5188-0.78061,2.257-0.43321,0.73719-1.0412,2.9942-0.30294,4.3818,0.78061,1.3462,0.91089,2.6903,0.91089,2.6903z'/%3E %3Cpath d='m452.48,300.46s-0.30397-4.3818,0.91089-5.7279c1.2148-1.3451,1.5188-3.9041,4.2091-5.2937,0,0-0.13028,1.0846,0,1.8228,0.17369,0.73718,0.47663,2.864,0,3.6011-0.43425,0.78061-1.9531,2.1257-1.9531,2.7337,0,0.60794-1.0412,2.1257-1.7783,2.4297-0.78165,0.26055-1.3886,0.43425-1.3886,0.43425z'/%3E %3Cpath d='m452.48,302.84s0-3.1235,0.91089-4.0344c0.91088-0.91088,1.3886-1.3886,1.8228-1.9531,0.43321-0.60691,0.91088-2.1257,1.952-2.7337,1.0412-0.60691,2.864-2.1257,3.0377-2.6903,0,0,0.43321,3.7314-0.60691,5.7279-1.0846,1.952-1.0846,2.9942-2.256,3.4274-1.2149,0.47767-1.3886,0.78165-1.8218,1.0846-0.47767,0.30397-1.2148,0.73821-1.8228,0.73821-0.60898,0-1.2159,0.43322-1.2159,0.43322z'/%3E %3Cpath d='m455.95,323.36c0.1737,0.8685,0.78061-1.9531-2.3863-1.9531s-5.7279-1.2149-6.8115-2.2994c-1.0412-1.0412-1.6491-1.7794-2.0834-2.257-0.47664-0.43321-1.6491-2.256-1.8218-3.1669-0.13027-0.86849-1.0412-4.2091-0.91088-4.816,0,0,1.6925,0.30294,2.4297,0.91089,0.73718,0.60794,2.1257,0.60794,2.864,1.0846,0.73718,0.43424,1.3451,1.6491,1.8228,2.0834,0.43321,0.47767,1.7783,0.47767,2.3863,1.3451,0.60691,0.91088,1.6481,2.864,1.8218,3.7748,0.13027,0.91088,1.2148,1.8218,1.9531,2.256,0.73615,0.4787,0.60588,2.2581,0.73615,3.0376z'/%3E %3Cpath d='m455.65,322.15s-2.0823-2.56-3.1669-2.56c-1.0412,0-3.7314-2.7347-3.9051-3.9051-0.13027-1.2149-1.0412-3.4709-1.6491-3.9475-0.60691-0.43425-1.6481-1.4754-1.5178-3.2972,0.17266-1.8228,0.17266-4.816,0.17266-4.816s0.60795,1.8228,1.4754,2.256c0.91088,0.43425,2.56,1.0422,2.864,1.6501,0.30294,0.60691,1.5188,0.60691,1.9955,2.4297,0.43321,1.7794,0.43321,1.6491,0.73719,2.256,0.30397,0.60795,1.0412,1.3462,1.3451,2.561,0.30397,1.2118,1.9531,4.3352,1.6491,7.3729z'/%3E %3Cpath d='m452.53,305.53c-0.0858,0.82403,1.2149-1.6057-1.6491-2.4742-2.9074-0.86746-4.9028-2.6903-5.5532-3.9475-0.65137-1.2149-0.99773-2.0823-1.3017-2.6034-0.25952-0.56349-0.86746-2.5166-0.73719-3.384,0.0869-0.86746,0.21712-4.1222,0.5211-4.6433,0,0,1.432,0.73822,1.9086,1.4754,0.5211,0.78061,1.7794,1.1714,2.3429,1.7794,0.52109,0.60691,0.73718,1.8652,1.0412,2.4297,0.30397,0.52007,1.5188,0.91089,1.8228,1.8662,0.30397,0.99773,0.69479,3.08,0.56452,3.9475-0.0869,0.86746,0.60691,1.9531,1.1714,2.6044,0.56349,0.60691-0.0879,2.2116-0.13131,2.9498z'/%3E %3Cpath d='m452.57,304.32s-1.2149-2.9084-2.1692-3.1669c-0.95431-0.30397-2.5166-2.7771-2.6034-3.9051-0.12924-1.3017-0.30294-3.4709-0.73718-4.0344-0.43322-0.56452-1.2149-2.4297-0.60692-4.0354,0.65034-1.6057,1.6491-3.7314,1.6491-3.7314s0.86746,1.3451,1.3451,2.1702c0.78061,1.5623,1.5622,1.6915,1.6925,2.2994,0.0869,0.65034,1.0412,1.0412,1.3886,2.2994,0.47767,1.6925-0.0434,1.6057,0.0434,2.256,0.13028,0.60692,0.60692,1.5188,0.52007,2.6903-0.0445,1.1694,0.60691,4.51-0.52213,7.1578z'/%3E %3Cpath d='m454.91,286.14c0.13028-0.43321,1.0412-0.91088,2.1257-1.2149,1.0412-0.30294,2.6903-2.6903,3.4274-3.2972,0.69376-0.65137,1.0846-1.6057,1.9955-2.1257,0.91088-0.5211,1.4754-2.3873,1.7794-4.2091,0,0-2.56,0.60691-3.2972,0.73719-0.73718,0.17369-2.256,1.0846-2.864,1.8218-0.60691,0.73822-1.2148,1.9531-1.8228,2.256-0.60691,0.30397-1.3451,2.1268-1.3451,3.3406,0.001,1.1725,0.001,2.6913,0.001,2.6913z'/%3E %3Cpath d='m454.78,284.79s-0.17266-1.7794-0.17266-2.56c0-0.91088-0.56452-3.3406,0.73718-5.2937,0.91088-1.3451,4.2525-3.9051,5.12-4.0354,0,0,0.60692,2.3863,0.47664,3.1235-0.17266,0.78061-0.95431,3.7748-1.6491,4.0778-0.69376,0.30501-2.4297,3.9062-4.512,4.6878z'/%3E %3Cpath d='m454,286.14c-0.38979,0.65034-0.12924-2.256-1.0412-2.9942-0.91089-0.78061-1.0412-1.8218-1.0412-3.0377,0-1.2149,0.26055-2.0823,0.43321-2.8629,0.13028-0.73822,2.4297-3.9051,2.257-4.816,0,0,1.3017,2.9508,1.6481,3.7748,0.47767,1.0412-0.30294,2.1257-0.12924,2.9942,0.12924,0.91088,0.86746,2.56,0.30294,3.4709-0.47664,0.78061-1.8218,2.4297-2.4297,3.4709z'/%3E %3Cpath d='m461.98,270.61s0.1737-0.43321,1.5188-0.43321,3.2972-0.13131,3.9051-0.73925c0.60691-0.60691,1.6491-1.3886,2.256-1.6925,0.60691-0.25951,1.6491-1.6481,1.8228-2.256,0.12924-0.60692,1.2149-1.7794,1.6491-1.7794,0,0-1.6491-0.1737-3.4709,0.30397-1.7783,0.43321-4.3383,1.3451-4.9463,2.56-0.60898,1.1725-2.7347,4.0364-2.7347,4.0364z'/%3E %3Cpath d='m462.46,270.3c0.34739,1.0412,2.864-1.0412,3.4274-1.7783,0.60795-0.78165,1.5199-1.9531,1.5199-1.9531s1.432-1.7349,1.8228-2.4297c0.91088-1.6491,0.69376-4.6423,0.30294-4.3818-0.47664,0.30398-2.1257,1.2149-2.56,1.3886-0.47767,0.13027-1.3451,0.43321-1.6491,1.1714-0.30398,0.78061-0.60795,1.8218-1.0846,2.2994-0.43321,0.43321-3.1669,1.952-1.7794,5.6835z'/%3E %3Cpath d='m461.55,270.3s2.0834-1.4754,2.864-2.256c0.91089-0.86746,0.43322-2.0823,0.91089-2.6903,0.38978-0.56452,1.4754-1.9531,1.1714-2.864-0.30294-0.91089-0.86746-3.4709-0.86746-3.4709s-1.0846,1.0412-1.8218,1.8228c-0.78061,0.73718-0.91088,1.3451-1.2148,2.256-0.30294,0.91089-0.91089,1.5188-1.2149,2.256-0.30397,0.73718,0,2.256,0.17266,3.1669,0.13028,0.91089,0,1.7794,0,1.7794z'/%3E %3C/g%3E %3Cg stroke-width='0.13017058' fill='none'%3E %3Cpath d='m494.83,365.23s-9.936-0.13027-10.848-1.3451'/%3E %3Cpath d='m500.56,366.45s-6.4651,1.7794-9.936,1.3451c-3.4709-0.43321-5.12,0.30397-5.9016,0.30397-0.73719,0-4.512-1.5188-4.512-1.5188'/%3E %3Cpath d='m507.19,368.84s-4.9897,0.91089-6.0309,1.2149c-1.0412,0.30294-6.1611,2.256-7.68,2.256-1.2149,0-4.1657-0.13027-4.9897,0-1.4754,0.30398-5.424,0-6.3338-0.43321'/%3E %3Cpath d='m488.37,356.95s3.7748,2.257,4.3818,2.9942c0.56349,0.78164,3.9051,3.4709,4.512,3.4709'/%3E %3Cpath d='m488.37,352.26s6.4651,5.5976,7.5063,6.3348c1.0846,0.78164,7.4194,6.9428,8.1576,7.8536'/%3E %3Cpath d='m493.61,349.87s5.12,4.0778,5.7279,5.7269c0.60691,1.6491,2.1257,3.6012,2.1257,3.6012s2.1257,4.208,2.864,4.816c0.73719,0.60691,2.256,2.2126,4.0788,3.3406'/%3E %3Cpath d='m464.41,346.1s5.3805,4.5555,6.8549,5.424'/%3E %3Cpath d='m462.16,348.96s5.424,3.7738,7.8102,4.6847c2.4297,0.86849,4.3818,1.6491,9.632,2.3873'/%3E %3Cpath d='m481.73,358.16s-6.0309-0.30397-7.072,0c-1.0412,0.30294-5.7279-0.78164-6.9428-1.0856-1.2149-0.26055-6.0309-1.1714-6.6378-1.3451'/%3E %3Cpath d='m472.53,337.81s-0.30294,3.2972,0.17369,4.6857c0.43425,1.3451,2.56,5.2492,2.3863,6.1611-0.13027,0.91088,1.2149,4.9887,2.4297,5.7269'/%3E %3Cpath d='m478.73,338.42s-1.0846,3.2972-0.60691,4.3828c0.43321,1.0412,1.1714,2.9942,1.1714,4.2081,0,1.2138,0.78061,2.9942,1.0846,3.7738,0.30397,0.73822-0.1737,3.2972,0.60691,4.0354,0.73718,0.78061,1.6491,2.1257,1.6491,2.1257'/%3E %3Cpath d='m446.49,330.74,0,0s4.816,1.8228,5.424,2.9942c0.56452,1.2159,1.4754,1.5199,1.9531,2.1268'/%3E %3Cpath d='m464.24,326.23s1.2149,4.816,0.91089,6.0309c-0.30397,1.1725-0.30397,3.6012-0.30397,4.512,0,0.91192-1.3451,4.512-1.2149,5.12'/%3E %3Cpath d='m462.29,322.15s-0.43424,2.864-0.60691,4.0778c-0.13027,1.1725,0,3.1669-0.30397,3.9051-0.30397,0.73719-0.73822,4.816,0,6.6378'/%3E %3Cpath d='m449.06,326.23s3.9051,3.2972,4.816,4.2091c0.91088,0.91089,4.9463,5.2492,5.12,6.3338,0.13027,1.0422,2.9942,4.3394,3.9051,5.12'/%3E %3Cpath d='m442.42,309.35s3.9051,3.9051,4.2091,4.816c0.30294,0.91192,1.9531,2.3863,2.7337,2.864'/%3E %3Cpath d='m460.77,311s-1.4754,2.257-1.4754,2.9942c0,0.78164-0.60691,2.7347-1.2149,3.4709-0.38979,0.5211-1.6491,2.7337-1.5188,4.0778'/%3E %3Cpath d='m459.6,304.66s-0.60691,2.1268-0.91088,3.6011c-0.30397,1.5188-1.0846,3.0377-1.3451,3.9475-0.30398,0.91192-1.5188,5.2502-1.0846,7.9839'/%3E %3Cpath d='m445.89,304.53s0.43425,2.0833,1.4754,3.1669c1.0846,1.0422,2.7337,2.561,2.864,3.4274,0.1737,0.91088,1.5188,5.4229,3.0377,6.9428,1.5188,1.5188,1.6491,3.0377,1.6491,3.0377'/%3E %3Cpath d='m444.37,289.18s0.43322,2.56,0.73719,3.2972c0.30397,0.73822,1.5188,4.0788,2.7337,5.12'/%3E %3Cpath d='m457.34,289.91s-0.78061,2.0823-0.91089,2.9942c-0.1737,0.91088-1.0846,1.9531-1.2148,2.4297-0.1737,0.43321-0.73719,1.952-0.73719,1.952'/%3E %3Cpath d='m460.03,291.99c-0.13028,0.91088-1.8228,3.6446-1.9531,4.0788-0.1737,0.47664-1.0412,2.56-1.952,3.1669-0.91088,0.60691-3.6011,2.56-3.4709,3.3406'/%3E %3Cpath d='m448.27,286.14s-0.13027,3.2972,0.47664,4.512c0.60794,1.2148,1.3451,3.0377,1.6491,3.9485,0.30397,0.86746,0.30397,2.3863,0.43321,3.4274,0.1737,1.0846,0.60795,3.0376,1.2149,3.7738'/%3E %3Cpath d='m463.81,275.9s-2.1702,2.4731-3.1679,3.4709c-0.99773,0.99774-4.816,5.12-4.9897,5.8572'/%3E %3Cpath d='m460.21,273.64s-2.1257,4.6423-2.6034,5.3805c-0.43425,0.78061-0.86746,1.9955-0.86746,1.9955'/%3E %3Cpath d='m454.78,273.47s0.13027,3.6446,0,4.5554c-0.17266,0.86746-0.17266,2.3863,0,2.864,0.13027,0.43321-0.47664,3.7314-0.60691,4.512'/%3E %3Cpath d='m472.22,264.14s-4.816,2.864-5.5542,3.6011'/%3E %3Cpath transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' d='M42.888,45.28,39.699,49.938,38.985,51.281' stroke-width='0.1259'/%3E %3Cpath d='m465.63,259.93s-1.0846,2.56-1.2149,3.6011c-0.1737,1.0846-1.6491,4.3828-2.256,5.5976'/%3E %3Cpath d='m469.23,257.98s-0.47767,1.0412,1.3451,0.73822' stroke-width='0.26034117'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23g3' transform='matrix(-1,0,0,1,1030.0497,0)'/%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m514.57,366.14s0.73718-1.8218,2.256-0.1737c0,0,1.8218,4.2525,0.43321,4.3818-1.3451,0.17474-2.6903,0.43425-2.8205-0.30293-0.17267-0.73719,0.13131-3.9051,0.13131-3.9051z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m516.52,365.54s0.47663-6.4651,1.3451-6.7691c0.91088-0.30397,3.6435-1.8228,5.2926-0.47767,1.6491,1.3886,0.13027,8.0708-0.47664,8.6787-0.56452,0.60691-1.4754,2.4731-4.9463,2.0389l-0.47767-1.6481s1.8228-0.1737,3.0377-0.78165c1.2149-0.60794,1.6057-1.1714,1.5188-1.7794-0.1737-0.91089-0.0869-4.2515-0.99773-4.5555-0.91192-0.30397-2.3439-0.73718-2.3439-0.73718s-1.3451,5.0321-1.6481,6.4641l-0.30397-0.43321z'/%3E %3Cpath d='m514.44,370.05s-6.2046,3.6011-3.0377,9.0251l-2.1257-1.3451s-1.1714,2.1268-0.13027,3.3406c0,0-4.2081-3.7748-0.91088-8.2879,3.3406-4.5554,6.0308-4.2515,6.0308-4.2515l0.1737,1.5188z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m514.44,367.06s-2.7337-1.8228-6.6388-0.78165c0,0-1.736-5.5966-1.0846-7.376,0.30293-0.82403,0.91088-0.91088,0.91088-0.91088s-1.9531-1.1725-1.3451,4.0778c0.60691,5.2937,1.6481,6.7691,1.6481,6.7691s5.12,0.30294,6.3348-0.30397l0.17473-1.4744z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m514.44,367.06s-5.4239-9.0685-6.8115-9.0685c0,0-1.5622-0.21712,1.952-0.60795,1.2148-0.13027,3.1669,0,4.0788,1.6925,0.91089,1.6491,1.6481,5.5532,1.952,6.1611,0,0-1.0412,0.30398-1.1714,1.8228z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m514.44,367.06s-3.6446-1.6925-4.0788-2.1268c-0.47664-0.43425-1.2149-5.5532-0.78061-5.2502,0,0-1.4754-1.6915-1.952-1.6915-0.30397,0-1.3451,0.78061-1.0412,2.56,0.30293,1.8228,0.73718,4.5554,1.2148,5.7269-0.001,0,2.8629-1.1704,6.6378,0.78165z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%23011322'/%3E %3Cpath d='m517.74,370.05s1.9531,1.2149,1.9531,3.4709,0.91089,6.3348,2.7337,7.2457c0,0,0.43321-1.6925,1.0412-1.9965,0,0,1.8228,2.1268,2.3873,2.1268,0,0-1.0422-1.9531-1.0422-2.864,0-0.91192-0.91089-4.3818-1.8228-5.2502-0.86746-0.91088-2.6903-3.0377-5.2492-3.7748v1.0422h-0.001z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%2300209f'/%3E %3Cpath d='m518.48,359.51-1.6481,6.4641,0.43322,1.3896s0.60794-0.1737,0.91088-0.91192c0.30397-0.78061,1.2159-6.3348,1.6925-6.5085l-1.3886-0.43321z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='%23011322'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m514.35,369.31s-2.9508,0.91192-4.0778,3.2103c0,0-0.39082-1.4754,3.9909-3.6011l0.0868,0.39082z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m517.83,369.31s2.0389,0.82507,2.56,2.0399c0,0-1.9531-1.3017-2.56-1.5188v-0.52z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m514.35,367.58s-4.5989,0.73822-5.5976,0.52109c0,0,1.3886,0.30398,5.6845-0.0868l-0.0869-0.43424z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m521.82,364.8s0.5211,2.3005,0.86849,2.1702c0.38979-0.1737,1.1714-3.8617,1.2149-5.5966,0.0869-1.6936-0.73822-2.0834-1.432-1.9965-0.65137,0.0434-1.0422,1.5622-0.95534,2.256,0.0434,0.65034,0.21712,2.7771,0.30397,3.1669z'/%3E %3Cpath fill-rule='evenodd' fill='%23011d33' d='m516.83,365.97s1.8652,4.1657,0.43321,4.3818c-1.3886,0.21816,0.60795,0.17474-0.34739-2.6903-0.38979-1.0846-0.99774-2.4297-1.3017-2.4297,0.001,0.001,1.0856,0.39186,1.2159,0.73822z'/%3E %3Cpath d='m514.57,366.14s0.73718-1.8218,2.256-0.1737c0,0,1.8218,4.2525,0.43321,4.3818-1.3451,0.17474-2.6903,0.43425-2.8205-0.30293-0.17267-0.73719,0.13131-3.9051,0.13131-3.9051z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='none'/%3E %3Cpath d='m516.52,365.54s0.47663-6.4651,1.3451-6.7691c0.91088-0.30397,3.6435-1.8228,5.2926-0.47767,1.6491,1.3886,0.13027,8.0708-0.47664,8.6787-0.56452,0.60691-1.4754,2.4731-4.9463,2.0389l-0.47767-1.6481s1.8228-0.1737,3.0377-0.78165c1.2149-0.60794,1.6057-1.1714,1.5188-1.7794-0.1737-0.91089-0.0869-4.2515-0.99773-4.5555-0.91192-0.30397-2.3439-0.73718-2.3439-0.73718s-1.3451,5.0321-1.6481,6.4641l-0.30397-0.43321z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='none'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m509.84,255.9c-0.39082-0.95431-0.47663-7.376-0.39082-8.3737,0.13028-1.736,3.1235-10.24,3.7314-11.238,0.65137-0.99773,0.47767-1.2149,0.73719-1.8228l0.86745-1.1714c0.65137,1.0846,1.128,2.7771,1.2583,4.1222,0,0-0.56349,4.0788-1.0412,5.9016-0.43321,1.8218-1.6057,4.3383-1.8228,4.8594-0.56349,1.2583-0.52007,2.4297-0.17267,2.5166l-3.1669,5.2058z'/%3E %3Cpath fill-rule='evenodd' fill='%23fff' d='m515.01,247.35,0.47767,0.52006c1.3451-1.432,1.431-4.4252,1.431-4.4252l-0.86746-6.0309s-0.56349,4.0788-1.0412,5.9016c-0.43321,1.8218-1.6057,4.3383-1.8228,4.8594-0.86746,2.1702-0.21609,2.4297-0.17266,2.5166l1.9955-3.3416z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m515.48,247.87c1.3451-1.432,1.431-4.4252,1.431-4.4252s0.95534,4.9028,0.43425,5.945c-0.52007,1.0412-0.52007,0.73718-0.43425,1.2583l-1.431-2.7782z'/%3E %3Cpath d='m516.91,250.65c-0.0858-0.52109-0.0858-0.21712,0.43425-1.2583,0.52109-1.0412-0.43425-5.945-0.43425-5.945l-0.86746-6.0309c-0.13027-1.3451-0.60691-3.0377-1.2583-4.1222l-0.86746,1.1714c-0.25951,0.60692-0.0858,0.82404-0.73719,1.8228-0.60691,0.99773-3.6011,9.5017-3.7314,11.238-0.0858,0.99773,0,7.4194,0.39082,8.3737' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.26034117' fill='none'/%3E %3Cg%3E %3Cpath d='m515.01,234.11s-0.0869-0.95431-0.1737-1.3017c-0.0434-0.17369,0.52007,0.86746,0.99774,0.73719,0.86746,0.26055,1.8228,1.432,2.0834,1.736-0.39083,0.56349-1.3017,1.6491-1.9531,1.432-0.56349-0.1737-0.43321-0.99773-0.60794-1.5188-0.0869-0.25951-0.38979-0.60691-0.34637-1.0846z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m515.05,233.33c0.0434,0.0434,0.30294,0.3474,0.34739,0.39082,0.21609,0.13028,0.43322,0,0.69376,0.1737,0.65034,0.43321,0.86746,0.82404,1.5623,1.5188' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m515.66,233.99c0.82403,0.38979,1.2583,1.0412,1.8228,1.7349,0,0,0.0434-0.0868,0-0.0868' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m514.09,233.42s0.86746-0.43321,1.1714-0.60691c0.17369-0.0868-0.65034,0.78061-0.34637,1.1714,0.0434,0.91088-0.69376,2.2126-0.95431,2.56-0.65033-0.1737-1.3017-0.1737-1.8218-1.1714-0.21713-0.3474,0.38978-0.73822,0.78061-1.0846,0.21609-0.17473,0.69376-0.73822,1.1704-0.86849z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m514.87,233.16c-0.0434,0.0868-0.25952,0.38979-0.25952,0.52006-0.0434,0.21713,0.13028,0.39083,0.0869,0.69376-0.1737,0.73719-0.47767,1.0846-0.86746,1.9955' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m514.44,233.99c-0.0869,0.91088-0.52109,1.5178-0.99773,2.2994,0-0.0434,0.13027,0,0.13027,0' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m515.44,232.81c0.60691-0.73718,1.6915-1.3886,2.2126-0.9543,0.0434,0.0434,0.47664,0.30294,0.60691,0.56348,0.26055,0.30398,0.21712,0.43425,0.0869,0.78165-0.38979,0.78061-1.432,0.38978-2.0823,0.0434-0.13027-0.0868-0.52006-0.43425-0.73718-0.3474-0.3474,0.13028-0.21713,0.13028-0.3474,0.13028,0.12924,0.0868,0.26055,0.0434,0.3474,0.0868,0.60691,0.17266,1.0412,0.52006,1.7783,0.86746,0.5211,0.21609,1.4754-0.47767,1.432-0.95431,0-0.56452-0.91088-1.5623-1.3451-1.5623-0.99773,0-1.7794,0.60692-2.4731,1.3886,0.1737-0.13027,0.38979,0.13027,0.5211-0.0434z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m514.87,232.81c-0.56349-0.73718-1.6491-1.3886-2.1692-0.9543-0.0434,0.0434-0.47767,0.30294-0.60691,0.56348-0.26055,0.26055-0.26055,0.43425-0.0869,0.78165,0.3474,0.78061,1.432,0.38978,2.0389,0.0434,0.1737-0.0868,0.56452-0.43425,0.78061-0.3474,0.3474,0.13028,0.21713,0.13028,0.3474,0.13028-0.13027,0.0868-0.26055,0.0434-0.39082,0.0868-0.56349,0.17266-0.99773,0.52006-1.7783,0.86746-0.52007,0.21609-1.432-0.47767-1.432-0.95431,0.0434-0.60795,0.9543-1.5623,1.3886-1.5623,0.99773,0,1.7794,0.60692,2.4297,1.3886-0.1313-0.13027-0.34739,0.13027-0.52109-0.0434z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m515.09,232.38c-0.26055-0.0868-0.56349,0.17267-0.65033,0.34637-0.0869,0.21712,0.0868,0.56348,0.34636,0.60691,0.3474,0.13027,0.82403,0.0434,0.91088-0.34637,0.0869-0.34739-0.30294-0.43424-0.60691-0.60691z' fill-rule='evenodd' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath fill-rule='evenodd' fill='%23FC0' d='m515.05,226.35s0.39082,2.3439,1.5622,4.0354-1.432,1.4754-1.6057,2.0823c0,0-0.78061-1.6915-1.6057-2.1257,0,0,1.3017-2.0389,1.6491-3.9485v-0.0434z'/%3E %3Cpath d='m515.05,226.35c0,0 0.39082,2.3439 1.5622,4.0354 0,0 -1.432,1.4754 -1.6057,2.0823 0,0 -0.78061,-1.6915 -1.6057,-2.1257 0,0 1.3017,-2.0389 1.6491,-3.9485' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m515.01,228.82c0,0 0.30294,1.0412 0.65034,1.736 0,0 -0.56349,0.43425 -0.65034,0.69376 0,0 -0.30294,-0.69376 -0.60691,-0.86746 -10e-4,0 0.56349,-0.91088 0.60691,-1.5622z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill-rule='evenodd' fill='%23fff' d='m515.01,344.54c-0.0869,0-0.21712-0.17473-0.34636-0.21815-0.39082-0.25952-1.128-0.25952-1.3017-0.47664-1.0412-1.1714-0.34739-3.4274,0.0858-4.816,0.86746-2.6034,0.99773-4.9897,1.5622-7.4628h0.0434c0.56348,2.4731,0.69376,4.8594,1.5188,7.4628,0.47663,1.3886,1.1714,3.6446,0.13027,4.816-0.21712,0.21712-0.91088,0.21712-1.3017,0.47664-0.1313,0.0434-0.26054,0.21815-0.39082,0.21815z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m515.01,331.48c0.56452,2.4731,0.73719,4.9897,1.5623,7.5931,0.43321,1.3017,1.0846,3.384,0.30397,4.5555v-0.0434c0.38979,0,0.73718-0.13027,1.0846-0.26055,0.13027-0.0434,0.25951-0.0869,0.30294-0.21712,0.13027-0.21609,0.30397-0.38979,0.47767-0.52006,0.26055-0.1737,0.56452-0.0434,0.82507-0.21713,0.0869-0.0868,0.13027-0.17369,0.1737-0.17369,0.52006-0.26055,1.0412-0.56452,1.2583-1.128,0.13027-0.39082,0.1737-0.82507,0.0869-1.2593-0.0434-0.30294-0.1737-0.52006-0.26055-0.78061-0.1737-0.39082-0.3474-0.78164-0.5211-1.1714-0.17369-0.39082-0.43424-0.73822-0.60691-1.129-0.0868-0.21609-0.1737-0.38979-0.30397-0.56349-0.0869-0.17369-0.21712-0.34739-0.30397-0.52109-0.0868-0.1737-0.30397-0.30397-0.43425-0.47767-0.1737-0.1737-0.21712-0.1737-0.3474-0.30294-0.0434-0.0434-0.25951-0.0869-0.21609-0.1737-0.0868,0-0.21712-0.0868-0.26054-0.13027-0.3474-0.73822-0.65137-1.128-0.99774-1.8662-0.17369-0.30397-0.21712-0.86746-0.21712-1.2149h-1.6057v0.002z'/%3E %3Cpath fill-rule='evenodd' fill='%2300209f' d='m515.01,331.48c-0.52006,2.4731-0.69376,4.9897-1.5622,7.5931-0.39082,1.3017-1.0412,3.384-0.26055,4.5555l-0.0434-0.0434h0.0434c-0.38979,0-0.73718-0.13027-1.128-0.26055-0.0868-0.0434-0.21712-0.0869-0.30397-0.21712-0.12924-0.21609-0.25951-0.38979-0.47664-0.52006-0.21712-0.1737-0.52006-0.0434-0.78061-0.21713-0.0869-0.0868-0.13027-0.17369-0.21609-0.17369-0.52109-0.26055-0.99773-0.56452-1.2148-1.128-0.13028-0.39082-0.1737-0.82507-0.0869-1.2593,0.0434-0.30294,0.17266-0.52006,0.26055-0.78061,0.17369-0.39082,0.34636-0.78164,0.52006-1.1714,0.1737-0.39082,0.38979-0.73822,0.60691-1.129,0.0869-0.21609,0.1737-0.38979,0.30397-0.56349,0.0868-0.17369,0.17267-0.34739,0.30294-0.52109,0.0869-0.1737,0.30397-0.30397,0.43425-0.47767,0.1737-0.1737,0.21712-0.1737,0.34636-0.30294,0.0434-0.0434,0.26055-0.0869,0.21712-0.1737,0.0868,0,0.21609-0.0868,0.21609-0.13027,0.39083-0.73822,0.6948-1.128,1.0412-1.8662,0.1737-0.30397,0.21712-0.86746,0.21712-1.2149h1.5633v0.002z'/%3E %3Cg id='g1' stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m514.27,331.57s-0.99773,4.0778-1.5622,5.12c-0.60691,1.0412-2.9508,2.9508-1.432,5.9006' stroke='%23011322'/%3E %3Cpath d='m514.35,331.57s-0.95431,4.1212-1.5622,5.1624c-0.60795,1.0856-2.9074,3.0377-1.3451,5.9885' stroke='%23011d33'/%3E %3Cpath d='m514.48,331.57s-0.99774,4.1646-1.6057,5.2492c-0.56349,1.0422-2.864,3.08-1.2583,6.0319' stroke='%23022743'/%3E %3Cpath d='m514.57,331.57s-0.95431,4.2515-1.5623,5.2926c-0.60691,1.0422-2.864,3.1235-1.2583,6.1611' stroke='%23033054'/%3E %3Cpath d='m514.7,331.57s-0.99773,4.2949-1.6057,5.3795c-0.60691,1.0422-2.8195,3.1669-1.1714,6.2046' stroke='%23053a65'/%3E %3Cpath d='m514.18,331.57s-0.9543,3.9475-1.6057,5.0766c-0.60692,1.0846-2.9508,2.9942-1.3886,5.9006' stroke='%23011d33'/%3E %3Cpath d='m514.05,331.61s-0.91088,3.7738-1.6046,5.0331c-0.60795,1.0412-2.9508,2.9508-1.3886,5.8572' stroke='%23022743'/%3E %3Cpath d='m513.96,331.61s-0.91088,3.6446-1.6481,4.9897c-0.56452,1.0412-2.9508,2.9508-1.3886,5.9006' stroke='%23033054'/%3E %3Cpath d='m513.83,331.61s-0.82403,3.5567-1.6491,4.9463c-0.56349,1.0846-2.9064,2.9508-1.3875,5.9006' stroke='%23053a65'/%3E %3Cpath d='m513.75,331.65s-0.82403,3.383-1.6491,4.9028c-0.60691,1.0412-2.9508,2.9508-1.3886,5.8572' stroke='%2300209f'/%3E %3Cpath d='m514.79,331.57s-0.95431,4.3818-1.5622,5.4229c-0.60692,1.0422-2.7771,3.2538-1.1714,6.3348' stroke='%2300209f'/%3E %3C/g%3E %3Cuse xlink:href='%23g1' transform='matrix(-1,0,0,1,1030.0498,0)'/%3E %3Cpath d='m518.65,335.17c0.13028,0.1737,0.3474,0.30397,0.43425,0.47767,0.0869,0.1737,0.21712,0.3474,0.30397,0.5211,0.13027,0.1737,0.21712,0.3474,0.30397,0.56348,0.17267,0.39083,0.43322,0.73822,0.60691,1.129,0.1737,0.38978,0.3474,0.78061,0.5211,1.1714,0.0869,0.26055,0.21712,0.47767,0.26055,0.78061,0.0868,0.43424,0.0434,0.86849-0.0869,1.2593-0.21712,0.56349-0.73822,0.86746-1.2583,1.128-0.0434,0-0.0869,0.0869-0.1737,0.1737-0.26055,0.1737-0.56452,0.0434-0.82507,0.21712-0.1737,0.13028-0.3474,0.30397-0.47767,0.52006-0.0434,0.13028-0.17267,0.1737-0.30294,0.21713-0.3474,0.13027-0.69479,0.26054-1.0846,0.26054v0.0434-0.0434c-0.0434,0.0869-0.13028,0.1737-0.1737,0.26055-0.21712,0.21713-0.91088,0.21713-1.3017,0.47664-0.13027,0.0434-0.26054,0.21816-0.39082,0.21816-0.0869,0-0.21712-0.17474-0.34636-0.21816-0.39082-0.25951-1.128-0.25951-1.3017-0.47664-0.0869-0.0869-0.13027-0.1737-0.1737-0.26055v0.0434l-0.0434-0.0434h0.0434c-0.38978,0-0.73718-0.13027-1.128-0.26054-0.0868-0.0434-0.21713-0.0868-0.30398-0.21713-0.12924-0.21609-0.25951-0.38978-0.47663-0.52006-0.21713-0.1737-0.52006-0.0434-0.78061-0.21712-0.0869-0.0868-0.13028-0.1737-0.21609-0.1737-0.5211-0.26055-0.99774-0.56452-1.2149-1.128-0.13027-0.39082-0.1737-0.82507-0.0869-1.2593,0.0434-0.30294,0.17267-0.52006,0.26055-0.78061,0.1737-0.39082,0.34636-0.78165,0.52006-1.1714,0.1737-0.39083,0.38979-0.73822,0.60691-1.129,0.0869-0.21608,0.1737-0.38978,0.30398-0.56348,0.0868-0.1737,0.17266-0.3474,0.30293-0.5211,0.0868-0.1737,0.30398-0.30397,0.43425-0.47767' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.17359523' fill='none'/%3E %3C/g%3E %3Cg id='g2'%3E %3Cg fill-rule='evenodd'%3E %3Cpath fill='%23fff' d='m487.37,293.56c-1.4754-3.688-3.0377-11.238-2.9508-12.973,0.30294-7.1154,0.21713-9.2412,0.86746-16.53l7.3326,8.3737c-0.1737,2.8205-0.21713,3.688,0,5.4663,0.0869,0.65137,0.47767,3.8617,0.99773,5.12l-6.247,10.543z'/%3E %3Cpath fill='%2300209f' d='m493.61,283.01c-0.52006-1.2583-0.91088-4.4686-0.99773-5.12-0.21712-1.7783-0.1737-2.6468,0-5.4663l4.512,4.9897-3.5143,5.5966z'/%3E %3Cpath fill='%2300209f' d='m474.96,289.91c-0.13027-1.6491-0.26055-3.4709-0.26055-4.2949,0.0434-5.12-0.56349-7.9839,0-13.407,0.43425-4.2515,1.4754-9.8491,1.2583-14.448-0.0869-1.3017,0.17267-2.6034,0.21713-3.8617l9.1119,10.153c-0.65034,7.2891-0.56452,9.4149-0.86746,16.53-0.0869,1.7349,1.4754,9.2846,2.9508,12.973l-1.9086,3.2103-10.502-6.8549z'/%3E %3Cpath fill='%2300209f' d='m481.34,303.67c-0.60691-0.99774-1.128-3.8617-1.2583-4.4252-0.30294-1.5188-0.30294-2.3873-0.21609-4.9897l5.0331,3.2972-3.5588,6.1177z'/%3E %3Cpath fill='%2300209f' d='m466.97,327.7c-0.56452-0.34637-1.5188-1.3451-1.8228-2.2126-0.60795-1.736-0.47767-1.6925-0.91089-3.6012-0.25951-1.0846-0.25951-2.2994-0.52109-3.4274-0.21609-1.128-1.8218-4.7292-1.8652-6.2046-0.17267-4.7281-1.736-7.9395-1.3451-13.103,0.26054-3.992,1.1714-9.4149,0.73718-13.581-0.13027-1.128,0.0434-2.4307,0.0868-3.5577l10.24,6.6822c-0.39082,6.8549-0.21713,8.7645-0.21713,15.402-0.0434,1.6057,1.3886,8.1132,3.1235,11.021l-7.5052,12.582z'/%3E %3Cpath fill='%2300209f' d='m483.98,331.48c1.9096,1.736,5.424,2.6468,5.9885,3.0377,1.2583,0.91088,3.1235,2.256,6.2914,2.4297,2.3429,0.1737,3.384-0.43321,5.7703-0.73718,2.7337-0.3474-0.34739,0.0868,2.2994-0.47767,1.3451-0.3474,1.3451-0.56453,3.1669-0.99774,1.3451-0.30397,2.6903-0.65137,3.5143-1.7794,0.30397-0.43425,0.56452-0.78061,0.60794-1.4754h1.8218c0.1737,0.52006-0.3474,1.5188-0.52006,1.8662-0.13028,0.1737-0.3474,0.47663-0.47664,0.65033-0.26055,0.56452-0.21712,0.43425-0.6948,0.8685-0.12924,0.0869-0.69376,0.56348-0.86745,0.65033-0.34637,0.26055-0.69377,0.60795-1.0846,0.65137-1.7794,0.30397-2.5166,0.69376-4.2091,1.1714-1.6057,0.47768-0.73718,0.39083-1.952,0.6948-0.60691,0.12924-1.8228,0.60691-2.4297,0.69376-1.0846,0.1737-1.2583,0.3474-2.3863,0.60794-2.9074,0.65034-5.7269,0.47664-8.5908,0.30398-1.1714-0.0868-4.0354-0.6948-5.0331-1.3896-1.7794-1.2583-5.6845-1.7349-7.4194-2.9498-0.25952-0.17473-1.3451-0.69479-1.5612-0.91192-1.6925-1.3886-3.0377-1.7794-4.816-2.9074h12.581z'/%3E %3Cpath fill='%2300209f' d='m497.74,331.48,13.885,0c-0.0434,0.6948-0.30397,1.0412-0.60794,1.4754-0.82404,1.128-2.1692,1.4754-3.5143,1.7794-1.432,0.34637-2.9074-0.43424-4.4252-0.43424-3.6456-1.128-4.0788-2.257-5.3371-2.8205z'/%3E %3Cpath fill='%23fff' d='m497.74,331.48c1.2583,0.65137,1.8662,1.736,5.3371,2.8205,1.3451,0,2.8205,0.60794,4.0788,0.56452-1.5188,0.34739-1.5623,0.56348-2.8205,0.86746-2.6468,0.56452,0.43321,0.13027-2.2994,0.47767-2.3863,0.30397-3.4274,0.91088-5.7703,0.73718-3.1669-0.1737-5.0331-1.5188-6.2914-2.4297-0.56452-0.39082-4.0788-1.3017-5.9885-3.0377h13.754z'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.17359523' stroke-miterlimit='2.61310005'%3E %3Cg%3E %3Cpath d='m476.65,259.71s1.6925,14.969,7.5063,14.406' stroke='%23022743'/%3E %3Cpath d='m484.16,274.03c-2.9074,0.13027-4.816-3.5577-5.9006-7.0286-1.128-3.5577-1.6057-7.2891-1.6057-7.3326' stroke='%23022847'/%3E %3Cpath d='m484.16,273.99c-2.9074-0.0868-4.816-3.8172-5.8137-7.072-1.1714-3.4274-1.6925-7.2457-1.6925-7.2891' stroke='%23032b4c'/%3E %3Cpath d='m484.2,273.95c-2.9074-0.25951-4.8594-4.0778-5.8137-7.1154-1.128-3.3406-1.6925-7.1589-1.736-7.2457' stroke='%23032d4f'/%3E %3Cpath d='m484.2,273.9c-2.9074-0.47664-4.8594-4.3818-5.7703-7.1589-1.128-3.2538-1.736-7.1154-1.7794-7.2457' stroke='%23032f53'/%3E %3Cpath d='m484.24,273.82c-2.9508-0.60692-4.9028-4.5989-5.7269-7.1589-1.128-3.1669-1.8228-7.072-1.8662-7.2023' stroke='%23043258'/%3E %3Cpath d='m484.24,273.77c-2.9074-0.82403-4.9028-4.8594-5.6845-7.2023-1.128-3.08-1.8652-6.9852-1.8652-7.1589' stroke='%2304345b'/%3E %3Cpath d='m484.29,273.73c-2.9508-0.99774-4.9463-5.12-5.6845-7.2891-1.0846-2.9074-1.9086-6.8983-1.9086-7.072' stroke='%2304365e'/%3E %3Cpath d='m484.29,273.69c-2.9508-1.2148-4.9463-5.3805-5.5976-7.3326-1.128-2.8205-1.952-6.8115-1.9955-7.072' stroke='%23043862'/%3E %3Cpath d='m484.29,273.6c-2.9074-1.3451-4.9463-5.64-5.5542-7.3326-1.128-2.7337-1.9955-6.7691-2.0389-7.0286' stroke='%23053b67'/%3E %3Cpath d='m484.33,273.55c-2.9508-1.5188-4.9897-5.9006-5.5542-7.376-1.0846-2.6468-2.0389-6.6822-2.0823-6.9852' stroke='%23053d6a'/%3E %3Cpath d='m484.33,273.51c-2.9508-1.736-4.9897-6.1611-5.4674-7.4194-1.128-2.56-2.1257-6.6388-2.1692-6.9417' stroke='%23053f6e'/%3E %3Cpath d='m484.37,273.47c-2.9508-1.9086-5.0331-6.4206-5.4674-7.5063-1.0846-2.3863-2.1257-6.552-2.2126-6.8983' stroke='%23064172'/%3E %3Cpath d='m476.69,259.02c0.0868,0.38978,1.1714,4.5554,2.256,6.8549,0.39082,0.82403,2.4731,5.4239,5.4239,7.5063' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m476.87,256.33s4.8594,11.889,7.9395,10.544' stroke='%23022743'/%3E %3Cpath d='m484.81,266.87c-1.3451,0.56349-3.3406-1.8228-4.9463-4.5989-1.736-3.0377-2.9942-5.9885-2.9942-5.9885' stroke='%23022a49'/%3E %3Cpath d='m484.81,266.83c-1.1714,0.52006-3.2537-1.7794-4.9028-4.6423-1.7794-3.1669-3.0376-5.944-3.0376-5.944' stroke='%23032d4f'/%3E %3Cpath d='m484.81,266.79c-0.99773,0.43321-3.1669-1.736-4.8594-4.6857-1.8662-3.3406-3.0377-5.9006-3.0377-5.9006' stroke='%23033054'/%3E %3Cpath d='m484.81,266.79c-0.82403,0.34739-3.1235-1.736-4.7726-4.7726-1.952-3.4709-3.1235-5.8572-3.1235-5.8572' stroke='%23043359'/%3E %3Cpath d='m484.85,266.74c-0.69376,0.30397-3.08-1.6925-4.7726-4.816-1.9955-3.6446-3.1235-5.8572-3.1235-5.8572' stroke='%23043760'/%3E %3Cpath d='m484.85,266.74c-0.52006,0.21712-2.9942-1.6925-4.7292-4.9028-2.0389-3.7748-3.1669-5.8148-3.1669-5.8148' stroke='%23053a65'/%3E %3Cpath d='m484.85,266.7c-0.34636,0.17369-2.9074-1.6491-4.6857-4.9463-2.1257-3.9485-3.1669-5.7713-3.1669-5.7713' stroke='%23053d6a'/%3E %3Cpath d='m484.85,266.7c-0.17267,0.0434-2.8205-1.6491-4.6423-4.9897-2.1692-4.1222-3.2114-5.7703-3.2114-5.7703' stroke='%23064171'/%3E %3Cpath d='m477,255.9s1.0412,1.432,3.2538,5.7269c1.8228,3.4274,4.5989,5.0331,4.5989,5.0331' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M492.88,278.72 496.65,278.02' stroke='%2300209f'/%3E %3Cpath d='M492.62,274.86 496.7,277.07' stroke='%2300209f'/%3E %3Cpath d='M492.53,275.03 496.7,277.07' stroke='%23064171'/%3E %3Cpath d='M492.53,275.2 496.74,277.11' stroke='%23053e6c'/%3E %3Cpath d='M492.53,275.42 496.74,277.16' stroke='%23053b67'/%3E %3Cpath d='M492.57,275.59 496.78,277.2' stroke='%23043862'/%3E %3Cpath d='M492.57,275.77 496.83,277.2' stroke='%2304355c'/%3E %3Cpath d='M492.57,275.94 496.87,277.24' stroke='%23043258'/%3E %3Cpath d='M492.57,276.11 496.91,277.29' stroke='%23032f53'/%3E %3Cpath d='M492.57,276.33 496.96,277.33' stroke='%23032c4d'/%3E %3Cpath d='M492.57,276.51 497,277.37' stroke='%23022a49'/%3E %3Cpath d='M492.83,278.54 496.7,277.98' stroke='%23064171'/%3E %3Cpath d='M492.83,278.33 496.74,277.89' stroke='%23053e6c'/%3E %3Cpath d='M492.79,278.11 496.78,277.85' stroke='%23053b67'/%3E %3Cpath d='M492.79,277.94 496.83,277.81' stroke='%23043862'/%3E %3Cpath d='M492.75,277.72H496.87' stroke='%2304355c'/%3E %3Cpath d='M492.75,277.5 496.91,277.68' stroke='%23043258'/%3E %3Cpath d='M492.75,277.33 496.96,277.59' stroke='%23032f53'/%3E %3Cpath d='M492.7,277.11 497.04,277.55' stroke='%23032c4d'/%3E %3Cpath d='M492.7,276.9 497.09,277.5' stroke='%23022a49'/%3E %3Cpath d='M492.66,276.72 497.13,277.42' stroke='%23022743'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m474.96,277.81s0.21712,3.1669,0.91088,4.512c0.99774,1.8662,3.9051,4.7302,7.2457,6.8125' stroke='%23022743'/%3E %3Cpath d='m483.2,289.13c-2.1692-1.3886-4.1212-3.1235-5.4663-4.6423-0.73822-0.78061-1.3451-1.6057-1.736-2.256-0.69376-1.3886-0.99774-4.512-0.99774-4.512' stroke='%23022847'/%3E %3Cpath d='m483.29,289.13c-2.1692-1.3886-4.1222-3.2537-5.424-4.7292-0.73719-0.78061-1.3451-1.5622-1.6915-2.2994-0.78061-1.3886-1.1714-4.4686-1.1714-4.4686' stroke='%23032b4c'/%3E %3Cpath d='m483.33,289.13c-2.1257-1.432-4.0778-3.384-5.3371-4.7726-0.69376-0.78061-1.3017-1.6057-1.6915-2.3429-0.82507-1.4754-1.3017-4.4686-1.3017-4.4686' stroke='%23032d4f'/%3E %3Cpath d='m483.42,289.09c-2.1257-1.432-4.0778-3.4274-5.3371-4.816-0.65033-0.73719-1.2148-1.5623-1.6491-2.3429-0.86746-1.5188-1.432-4.4686-1.432-4.4686' stroke='%23032f53'/%3E %3Cpath d='m483.5,289.09c-2.1257-1.432-4.0354-3.5577-5.2937-4.9028-0.60691-0.69376-1.2149-1.5188-1.6491-2.3429-0.91088-1.5622-1.5188-4.4686-1.5188-4.4686' stroke='%23043258'/%3E %3Cpath d='m483.59,289.09c-2.1257-1.4754-4.0354-3.688-5.2502-4.9897-0.60691-0.69376-1.1714-1.5178-1.6491-2.3429-0.95431-1.6491-1.6491-4.4686-1.6491-4.4686' stroke='%2304345b'/%3E %3Cpath d='m483.63,289.09c-2.0389-1.5188-3.992-3.8183-5.1634-5.0766-0.56452-0.65034-1.1714-1.4744-1.6491-2.3429-0.99773-1.6925-1.7794-4.4696-1.7794-4.4696' stroke='%2304365e'/%3E %3Cpath d='m483.72,289.05c-2.0399-1.4754-3.992-3.8617-5.12-5.12-0.56349-0.60795-1.128-1.4754-1.6491-2.3429-1.0412-1.736-1.9086-4.4696-1.9086-4.4696' stroke='%23043862'/%3E %3Cpath d='m483.81,289.05c-2.0399-1.5188-3.992-3.992-5.0766-5.2068-0.52006-0.56452-1.128-1.432-1.6491-2.3429-1.0846-1.8228-1.9955-4.4696-1.9955-4.4696' stroke='%23053b67'/%3E %3Cpath d='m483.85,289.05c-1.9965-1.5188-3.9051-4.1222-4.9897-5.2937-0.52007-0.56452-1.0846-1.432-1.6491-2.3429-1.0846-1.8652-2.1257-4.4686-2.1257-4.4686' stroke='%23053d6a'/%3E %3Cpath d='m483.94,289.05c-1.9955-1.5622-3.9051-4.2091-4.9463-5.3371-0.47664-0.56452-1.0846-1.432-1.6491-2.3863-1.128-1.9086-2.256-4.4686-2.256-4.4686' stroke='%23053f6e'/%3E %3Cpath d='m484.03,289c-1.9955-1.5622-3.9051-4.2949-4.9029-5.3805-0.47767-0.52006-1.0412-1.432-1.6057-2.3863-1.2149-1.9965-2.4297-4.4686-2.4297-4.4686' stroke='%23064172'/%3E %3Cpath d='m475.09,276.68s2.8205,5.3371,4.1657,6.8549c0.95431,1.0412,2.864,3.9051,4.8594,5.4674' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m475.17,289.91c3.08,2.0389,3.8617,2.56,10.239,6.6378l1.9531-2.9942s-0.73718-1.7783-1.0412-2.6034' stroke='%23011d33'/%3E %3Cpath d='m475.22,289.87c2.9508,1.9965,3.9475,2.6468,10.195,6.5509l0.0869-0.0858c0-0.0434,1.7349-2.9074,1.7349-2.9074s-0.0868-0.34636-0.30293-0.78061c-0.21713-0.56349-0.47768-1.2149-0.60795-1.6915' stroke='%23011e34'/%3E %3Cpath d='m475.22,289.87c2.864,1.9096,4.1222,2.7337,10.195,6.4651l0.0869-0.13027c0-0.0868,1.6481-2.9074,1.6481-2.9074s-0.0868-0.30293-0.25951-0.73718c-0.21712-0.52006-0.43425-1.1714-0.56452-1.6046' stroke='%23022037'/%3E %3Cpath d='m475.22,289.87c2.7771,1.8218,4.2949,2.7771,10.195,6.3348l0.0869-0.13028c0-0.0868,1.5612-2.864,1.5178-2.864,0,0-0.0434-0.30398-0.21609-0.6948-0.1737-0.52006-0.39082-1.128-0.52109-1.5612' stroke='%23022139'/%3E %3Cpath d='m475.22,289.83c2.6903,1.7784,4.4686,2.864,10.195,6.248l0.0869-0.13027c0-0.13027,1.432-2.864,1.432-2.864s0-0.26055-0.1737-0.65137c-0.21713-0.52006-0.39083-1.0412-0.47767-1.4744' stroke='%2302223b'/%3E %3Cpath d='m475.26,289.83c2.56,1.6925,4.5989,2.9508,10.152,6.1177,0.0434,0,0.0869-0.13027,0.0869-0.13027,0-0.1737,1.3451-2.8205,1.3451-2.864-0.0434,0,0-0.21713-0.1737-0.60691-0.1737-0.47664-0.30398-0.95431-0.39082-1.3886' stroke='%2302233d'/%3E %3Cpath d='m475.26,289.78c2.4731,1.6491,4.7726,3.0377,10.197,6.0309,0,0,0.0434-0.13028,0.0869-0.13028,0-0.21609,1.2149-2.8205,1.1714-2.8205,0,0,0.0434-0.21713-0.0869-0.60691-0.1737-0.43322-0.30398-0.86746-0.3474-1.3017' stroke='%23022540'/%3E %3Cpath d='m475.26,289.78c2.3863,1.6057,4.9463,3.08,10.197,5.9006l0.0869-0.13027c0-0.21609,1.0846-2.7771,1.0846-2.8205,0,0,0.0869-0.17369-0.0868-0.52006-0.1737-0.47664-0.26055-0.82403-0.30398-1.2583' stroke='%23022541'/%3E %3Cpath d='m475.26,289.78c2.2994,1.5188,5.12,3.1669,10.197,5.8137,0-0.0434,0.0869-0.17266,0.0869-0.17266,0-0.26055,0.99774-2.7771,0.95431-2.8205,0,0,0.13028-0.13027,0-0.47663-0.1737-0.43425-0.21712-0.78061-0.26055-1.1714' stroke='%23022743'/%3E %3Cpath d='m475.3,289.74c2.1692,1.4754,5.2502,3.2538,10.153,5.7279,0-0.0434,0.0869-0.13027,0.0869-0.1737,0-0.30397,0.86746-2.7771,0.86746-2.7771s0.13028-0.13027,0-0.47663c-0.1737-0.39082-0.1737-0.69376-0.1737-1.0846' stroke='%23022847'/%3E %3Cpath d='m475.3,289.74c2.0823,1.3886,5.3805,3.3406,10.153,5.5976,0.0434-0.0434,0.0869-0.13027,0.0869-0.1737,0-0.34636,0.78061-2.7337,0.73719-2.7771,0,0,0.21712-0.12924,0.0869-0.43321-0.1737-0.39082-0.13028-0.60691-0.13028-0.99774' stroke='%23022a49'/%3E %3Cpath d='m475.3,289.74c1.9955,1.3017,5.5532,3.384,10.153,5.4674,0.0434-0.0434,0.0869-0.13028,0.13028-0.1737-0.0434-0.3474,0.65033-2.7337,0.60691-2.7337,0-0.0434,0.21712-0.13027,0.0869-0.43321-0.13027-0.3474-0.0869-0.5211-0.0869-0.91089' stroke='%23032a4a'/%3E %3Cpath d='m475.35,289.7c1.8652,1.2583,5.6835,3.4709,10.11,5.3805,0.0434-0.0434,0.0869-0.12924,0.13028-0.17266,0-0.39083,0.52006-2.6903,0.47664-2.7337,0,0,0.25951-0.0869,0.17266-0.34636-0.17266-0.3474-0.0868-0.47767-0.0434-0.86746' stroke='%23032b4c'/%3E %3Cpath d='m475.35,289.7c1.7783,1.1714,5.8572,3.5577,10.11,5.2502,0.0434,0,0.13028-0.13028,0.13028-0.1737,0-0.43321,0.43321-2.6903,0.38979-2.7337,0,0,0.30294-0.0434,0.17266-0.30294-0.12924-0.34739,0-0.39082,0.0434-0.78061' stroke='%23032d4f'/%3E %3Cpath d='m475.35,289.7c1.6915,1.0846,6.0309,3.6011,10.153,5.1634,0-0.0434,0.0869-0.1737,0.0869-0.21713,0-0.43321,0.34636-2.6468,0.30294-2.6903h-0.0434s0.34637-0.0434,0.26055-0.30397c-0.13027-0.30294,0-0.30294,0.0858-0.69376' stroke='%23032e50'/%3E %3Cpath d='m475.35,289.65c1.6046,1.0846,6.2046,3.688,10.153,5.0766,0.0434-0.0434,0.0869-0.17266,0.0869-0.21609,0-0.47663,0.21609-2.6468,0.17266-2.6903l0.26055-0.26054c-0.13027-0.25952,0.0434-0.25952,0.17267-0.60692' stroke='%23032f53'/%3E %3Cpath d='m475.39,289.65c1.4754,0.99774,6.3338,3.7748,10.11,4.9463,0.0434-0.0434,0.0869-0.1737,0.0869-0.21712,0-0.52007,0.12924-2.6468,0.0858-2.6903,0,0,0.39083,0.0434,0.30398-0.17267-0.13028-0.30397,0.0868-0.21712,0.17266-0.56349' stroke='%23033156'/%3E %3Cpath d='m475.39,289.61c1.3886,0.95431,6.5075,3.8617,10.11,4.8594,0.0434-0.0434,0.0869-0.1737,0.12924-0.21713,0-0.56348-0.0434-2.6034-0.0858-2.6468,0,0,0.43322,0.0434,0.34637-0.17267-0.0868-0.26055,0.13027-0.13027,0.25951-0.47664' stroke='%23043258'/%3E %3Cpath d='m475.39,289.61c1.3017,0.86746,6.6812,3.9051,10.11,4.7292,0.0434-0.0434,0.0869-0.1737,0.12924-0.21712,0-0.56349-0.12924-2.6034-0.17267-2.6468,0,0,0.43322,0.0858,0.38979-0.13027-0.13027-0.21712,0.13028-0.0434,0.30294-0.38979' stroke='%23043359'/%3E %3Cpath d='m475.39,289.61c1.2148,0.78061,6.8115,3.992,10.11,4.5989,0.0434-0.0434,0.12924-0.12924,0.12924-0.21609,0-0.60795-0.21712-2.56-0.30397-2.6468,0,0,0.52109,0.13028,0.43424-0.0869-0.0869-0.21712,0.21713,0.0434,0.38979-0.30294' stroke='%2304355c'/%3E %3Cpath d='m475.43,289.57c1.0846,0.73718,6.9417,4.0788,10.066,4.5554,0.0434-0.0858,0.12924-0.17267,0.12924-0.25952,0-0.65033-0.34636-2.56-0.38979-2.6034,0,0,0.52006,0.0869,0.43321-0.0434-0.0434-0.21712,0.26055,0.0868,0.43425-0.25952' stroke='%2304365e'/%3E %3Cpath d='m475.43,289.57c0.99773,0.65033,7.1154,4.1657,10.066,4.4262,0.0869-0.0869,0.12924-0.1737,0.12924-0.26055,0-0.65033-0.43321-2.5166-0.52006-2.6034,0,0,0.56348,0.13027,0.52006,0-0.0858-0.17267,0.30397,0.13027,0.47767-0.17267' stroke='%23043760'/%3E %3Cpath d='m475.43,289.57c0.91088,0.56452,7.2891,4.208,10.11,4.2959,0.0434-0.0868,0.0858-0.17369,0.12924-0.26054-0.0434-0.69376-0.56348-2.5166-0.65033-2.6034,0,0,0.60691,0.17369,0.52109,0.0434-0.0434-0.17266,0.34637,0.21712,0.56349-0.0858' stroke='%23043862'/%3E %3Cpath d='m475.48,289.52c0.78164,0.5211,7.4194,4.2959,10.066,4.2091,0.0434-0.0434,0.0858-0.1737,0.12924-0.26055,0-0.73718-0.69376-2.5166-0.73718-2.56h-0.0434s0.65137,0.17266,0.60795,0.0434c-0.0434-0.13027,0.34636,0.30294,0.60691,0' stroke='%23053a65'/%3E %3Cpath d='m475.48,289.52c0.69479,0.47767,7.5931,4.3828,10.066,4.0788,0.0434-0.0434,0.12924-0.1737,0.12924-0.26055,0-0.78061-0.78061-2.4731-0.86746-2.56,0,0,0.65137,0.21609,0.60692,0.13028-0.0434-0.13028,0.43424,0.34636,0.69479,0.0434' stroke='%23053b67'/%3E %3Cpath d='m475.48,289.52c0.60691,0.39082,7.7668,4.4262,10.066,3.9485,0.0434-0.0434,0.12924-0.1737,0.12924-0.25951,0-0.78164-0.86746-2.4731-0.9543-2.5166v-0.0434s0.69376,0.26055,0.65033,0.1737c-0.0434-0.13027,0.43425,0.43321,0.6948,0.13027' stroke='%23053c68'/%3E %3Cpath d='m475.48,289.48c0.52109,0.34739,7.9405,4.5131,10.066,3.9051,0.0858-0.0869,0.12924-0.21609,0.12924-0.30293,0-0.82404-0.99773-2.4297-1.0846-2.5166,0,0,0.73719,0.26055,0.69376,0.1737-0.0434-0.0868,0.47664,0.52006,0.78061,0.21712' stroke='%23053e6c'/%3E %3Cpath d='m475.52,289.48c0.39082,0.26054,8.0708,4.5999,10.023,3.7748,0.0858-0.0869,0.12924-0.21712,0.17267-0.30397-0.0434-0.86746-1.128-2.4297-1.2149-2.5166,0,0,0.73719,0.30398,0.73719,0.21713-0.0434-0.0434,0.52006,0.60691,0.82403,0.30397' stroke='%23053f6e'/%3E %3Cpath d='m475.52,289.48c0.30397,0.17369,8.2011,4.6423,10.023,3.6446,0.0858-0.0869,0.12924-0.21713,0.17267-0.30398,0-0.86746-1.2583-2.4297-1.3451-2.4731,0,0,0.82403,0.30397,0.78061,0.26054,0-0.0869,0.56348,0.60691,0.91088,0.3474' stroke='%23053f6f'/%3E %3Cpath d='m475.52,289.43c0.21712,0.13028,8.3748,4.7292,10.023,3.5577,0.0858-0.0868,0.12924-0.1737,0.17267-0.30397,0-0.91088-1.3451-2.3863-1.432-2.4731,0,0,0.82403,0.3474,0.82403,0.30397-0.0434-0.0434,0.60691,0.69376,0.91089,0.43425' stroke='%23064171'/%3E %3Cpath d='m475.52,289.43c0.13027,0.0434,8.5474,4.816,10.066,3.4274,0.0434-0.0868,0.12924-0.1737,0.12924-0.30397,0-0.95431-1.432-2.3863-1.5622-2.4731l0.86745,0.34636s0.65034,0.78061,0.99774,0.5211' stroke='%23064374'/%3E %3Cpath d='m475.57,289.39s9.7189,5.4674,10.153,3.0377c0-0.99774-1.6491-2.4297-1.6491-2.4297l0.91088,0.34637s0.65034,0.86745,1.0412,0.60794' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m474.44,315.12-7.5497,12.582c-0.56452-0.34637-1.5188-1.3451-1.8228-2.2126-0.56452-1.736-0.47767-1.736-0.91089-3.6012-0.21608-1.0846-0.25951-2.2994-0.47663-3.4274-0.26055-1.128-1.8662-4.7292-1.9096-6.2046' stroke='%23011d33'/%3E %3Cpath d='m461.77,312.26c0.0434,1.4754,1.6491,4.9897,1.9096,6.1177,0.21712,1.129,0.26055,2.3439,0.47663,3.4274,0.43322,1.8662,0.34637,1.8228,0.95431,3.5577,0.26055,0.86746,1.2583,1.8662,1.7794,2.2126,0.0434,0,7.5063-12.452,7.5497-12.452' stroke='%23011d33'/%3E %3Cpath d='m461.77,312.26c0.0434,1.433,1.6491,4.9463,1.8662,6.0743,0.26055,1.129,0.30398,2.3005,0.56349,3.384,0.43321,1.8228,0.30294,1.8228,0.91088,3.5577,0.30398,0.82404,1.2583,1.8228,1.7794,2.1702,0.0434,0,7.4628-12.28,7.5497-12.322' stroke='%23011e34'/%3E %3Cpath d='m461.77,312.26c0.0434,1.433,1.6057,4.9028,1.8662,6.0308,0.26055,1.0856,0.30398,2.257,0.56349,3.3406,0.43321,1.8228,0.30294,1.7794,0.91088,3.5143,0.30398,0.82507,1.2583,1.7794,1.7794,2.1268,0.0868,0.0434,7.4628-12.106,7.5497-12.149' stroke='%23011e34'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3896,1.6057,4.8594,1.8662,5.944,0.26055,1.129,0.30398,2.257,0.56349,3.3406,0.43321,1.7794,0.34636,1.7794,0.91088,3.4709,0.30398,0.82404,1.2583,1.7794,1.7794,2.1268,0.13027,0.0434,7.4194-11.976,7.5497-12.018' stroke='%23011f36'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3896,1.6057,4.816,1.8662,5.9016,0.26055,1.0846,0.30398,2.256,0.56349,3.2961,0.43321,1.7794,0.34636,1.736,0.95431,3.4274,0.30294,0.82507,1.2148,1.7794,1.7794,2.1268,0.0868,0.0434,7.3326-11.846,7.5063-11.888' stroke='%23011f36'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3896,1.5622,4.7292,1.8662,5.8148,0.26055,1.0846,0.30398,2.256,0.56349,3.2961,0.43321,1.736,0.34636,1.736,0.95431,3.384,0.30294,0.82507,1.2148,1.7794,1.7794,2.1268,0.13027,0.0434,7.3326-11.715,7.5063-11.758' stroke='%23022037'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3462,1.5622,4.6857,1.8662,5.7713,0.26055,1.0846,0.30398,2.2126,0.56349,3.2538,0.43321,1.7349,0.38979,1.7349,0.95431,3.3396,0.30294,0.82507,1.2148,1.7794,1.7794,2.0834,0.17266,0.0868,7.2891-11.498,7.5063-11.584' stroke='%23022037'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3462,1.5622,4.6423,1.8662,5.7279,0.26055,1.0412,0.30398,2.1692,0.56349,3.2103,0.43321,1.6925,0.38979,1.6925,0.99773,3.3396,0.30294,0.78165,1.2149,1.6925,1.736,2.0399,0.17266,0.0434,7.2891-11.368,7.5063-11.454' stroke='%23022139'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3027,1.5622,4.5989,1.8662,5.6411,0.26055,1.0846,0.30398,2.1692,0.56349,3.2103,0.43321,1.6925,0.38979,1.6925,0.99773,3.2961,0.30294,0.78164,1.2149,1.6925,1.736,2.0399,0.21608,0.0434,7.2457-11.238,7.5063-11.323' stroke='%23022139'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3027,1.5188,4.5554,1.8662,5.5976,0.26055,1.0412,0.30398,2.1257,0.60691,3.1669,0.43322,1.6915,0.34637,1.6481,0.95431,3.2538,0.30294,0.78061,1.2149,1.6925,1.736,2.0389,0.25951,0.0434,7.2023-11.107,7.5063-11.193' stroke='%23022139'/%3E %3Cpath d='m461.77,312.26c0.0434,1.3027,1.5188,4.4696,1.8662,5.5542,0.26055,0.99773,0.30398,2.1257,0.60691,3.08,0.43322,1.6925,0.38979,1.6925,0.95431,3.2537,0.30294,0.78061,1.2149,1.6915,1.736,1.9955,0.25951,0.0869,7.2023-10.934,7.5063-11.02' stroke='%2302223b'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2593,1.5188,4.4262,1.8662,5.4674,0.26055,1.0412,0.30398,2.1268,0.60691,3.08,0.43322,1.6925,0.38979,1.6925,0.99774,3.2103,0.30294,0.78061,1.1714,1.6491,1.6925,1.9965,0.30293,0.0858,7.1589-10.761,7.5063-10.89' stroke='%2302223b'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2593,1.5188,4.3828,1.8662,5.4239,0.26055,0.99774,0.30398,2.0834,0.60691,3.0377,0.43322,1.6491,0.38979,1.6491,0.99774,3.2103,0.30294,0.73719,1.1714,1.6057,1.736,1.9531,0.30294,0.0868,7.072-10.631,7.4628-10.76' stroke='%2302233d'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2159,1.4754,4.3394,1.8662,5.3805,0.26055,0.99773,0.30398,2.0399,0.60691,2.9942,0.43322,1.6491,0.43322,1.6491,0.99774,3.1669,0.30294,0.73719,1.2148,1.6057,1.736,1.9531,0.30294,0.0858,7.072-10.5,7.4628-10.63' stroke='%2302233d'/%3E %3Cpath d='m461.77,312.26c0.0434,1.2159,1.4754,4.2949,1.8662,5.2937,0.26055,0.99773,0.3474,2.0399,0.60691,2.9942,0.43322,1.6057,0.43322,1.6057,0.99774,3.1235,0.34636,0.73718,1.2148,1.6057,1.736,1.9096,0.34636,0.13027,7.0286-10.327,7.4628-10.456' stroke='%2302233e'/%3E %3Cpath d='m461.77,312.26c0.0434,1.1725,1.4754,4.2091,1.8662,5.2502,0.26055,0.99774,0.3474,1.9965,0.60691,2.9508,0.43322,1.6057,0.43322,1.6057,1.0412,3.08,0.30294,0.73822,1.1714,1.6057,1.6925,1.9096,0.38979,0.13028,7.0286-10.197,7.4628-10.326' stroke='%2302233e'/%3E %3Cpath d='m461.77,312.21c0.0434,1.2159,1.4754,4.2091,1.8228,5.2502,0.30397,0.95431,0.39082,1.9965,0.65033,2.9074,0.43322,1.5623,0.43322,1.6057,1.0412,3.0377,0.30294,0.73822,1.1714,1.5623,1.6925,1.9096,0.38979,0.13028,6.9852-10.023,7.4628-10.195' stroke='%23022540'/%3E %3Cpath d='m461.77,312.21c0.0434,1.2159,1.432,4.1657,1.8228,5.1634,0.30397,0.95431,0.39082,1.9965,0.65033,2.9074,0.47664,1.5623,0.47664,1.5623,1.0412,3.0377,0.30294,0.6948,1.1714,1.5188,1.6925,1.8228,0.43321,0.13028,6.9417-9.8491,7.4628-10.022' stroke='%23022540'/%3E %3Cpath d='m461.77,312.21c0.0434,1.1725,1.432,4.1222,1.8228,5.12,0.26055,0.9543,0.39082,1.9531,0.69376,2.864,0.43321,1.5188,0.43321,1.5622,1.0412,2.9942,0.30294,0.69479,1.128,1.5188,1.6491,1.8228,0.47664,0.13027,6.9417-9.7188,7.4628-9.8915' stroke='%23022540'/%3E %3Cpath d='m461.77,312.21c0.0434,1.1725,1.432,4.0354,1.8228,5.0766,0.26055,0.91089,0.39082,1.9096,0.69376,2.8205,0.43321,1.5188,0.43321,1.5188,1.0412,2.9508,0.30294,0.6948,1.1714,1.5188,1.6491,1.8228,0.47664,0.13027,6.8983-9.5886,7.4628-9.7612' stroke='%23022541'/%3E %3Cpath d='m461.77,312.21c0.0434,1.129,1.432,3.992,1.8228,4.9897,0.26055,0.95534,0.39082,1.9096,0.69376,2.8205,0.43321,1.4754,0.47664,1.5188,1.0412,2.9084,0.30294,0.69377,1.1714,1.5178,1.6925,1.8218,0.47664,0.13028,6.8549-9.4583,7.4194-9.631' stroke='%23022541'/%3E %3Cpath d='m461.77,312.21c0.0434,1.129,1.3886,3.9485,1.8228,4.9463,0.26055,0.91191,0.39082,1.8662,0.69376,2.7771,0.43321,1.4754,0.47664,1.4754,1.0412,2.865,0.34636,0.69376,1.1714,1.4754,1.6925,1.7783,0.52007,0.1737,6.8115-9.2412,7.4194-9.4573' stroke='%23022743'/%3E %3Cpath d='m461.77,312.21c0.0434,1.129,1.3886,3.9051,1.8228,4.9028,0.26055,0.8685,0.39082,1.8662,0.69376,2.7347,0.43321,1.432,0.47664,1.4744,1.0846,2.8629,0.30294,0.65137,1.128,1.433,1.6491,1.736,0.52007,0.1737,6.768-9.1119,7.4194-9.327' stroke='%23022743'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0856,1.3886,3.8617,1.8228,4.816,0.26055,0.91192,0.39082,1.8662,0.69376,2.7347,0.43321,1.432,0.47664,1.4754,1.0846,2.8205,0.30294,0.65033,1.128,1.432,1.6491,1.736,0.56349,0.17266,6.768-8.9827,7.4194-9.1978' stroke='%23022845'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0856,1.3886,3.7748,1.8228,4.7726,0.26055,0.86849,0.39082,1.8228,0.69376,2.6913,0.43321,1.3886,0.52109,1.432,1.0846,2.7771,0.34636,0.65034,1.128,1.432,1.6491,1.736,0.60692,0.17266,6.7246-8.8524,7.4194-9.0685' stroke='%23022845'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0422,1.3451,3.7314,1.8228,4.7292,0.26055,0.8685,0.39082,1.7794,0.69376,2.6479,0.47664,1.3886,0.52109,1.432,1.0846,2.7337,0.34636,0.65034,1.128,1.432,1.6491,1.6925,0.60692,0.21712,6.6812-8.6787,7.4194-8.8948' stroke='%23022847'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0422,1.3451,3.688,1.8228,4.6423,0.26055,0.8685,0.39082,1.7794,0.73718,2.6479,0.43322,1.3451,0.47767,1.3886,1.0846,2.6903,0.30293,0.65137,1.128,1.3886,1.6057,1.6925,0.65034,0.21713,6.6812-8.5484,7.4194-8.808' stroke='%23022847'/%3E %3Cpath d='m461.77,312.21c0.0434,1.0422,1.3451,3.6446,1.8228,4.5989,0.26055,0.86849,0.39082,1.736,0.73718,2.561,0.43322,1.3886,0.52007,1.432,1.0846,2.6903,0.30293,0.65034,1.128,1.3886,1.6057,1.6925,0.69377,0.1737,6.6378-8.3748,7.4194-8.6777' stroke='%23022847'/%3E %3Cpath d='m461.77,312.21c0.0434,0.99877,1.3451,3.6012,1.8228,4.5555,0.26055,0.82506,0.39082,1.736,0.73718,2.5176,0.43322,1.3451,0.52007,1.432,1.0846,2.6903,0.34636,0.60795,1.128,1.3451,1.6491,1.6491,0.65034,0.17369,6.5943-8.2445,7.376-8.5474' stroke='%23022a49'/%3E %3Cpath d='m461.77,312.21c0.0434,0.99877,1.3017,3.5143,1.8228,4.4696,0.26055,0.82403,0.39082,1.7349,0.73718,2.5166,0.43322,1.3451,0.52007,1.3886,1.0846,2.6468,0.34636,0.60794,1.128,1.3451,1.6491,1.6057,0.69376,0.21712,6.5509-8.0708,7.376-8.3737' stroke='%23022a49'/%3E %3Cpath d='m461.77,312.21c0.0434,0.95534,1.3017,3.4709,1.8228,4.4262,0.26055,0.82403,0.43321,1.6915,0.73718,2.4731,0.43322,1.3017,0.52007,1.3886,1.128,2.6034,0.30397,0.60795,1.0846,1.3451,1.6057,1.6057,0.73718,0.21713,6.5075-7.9405,7.376-8.2434' stroke='%23032a4a'/%3E %3Cpath d='m461.77,312.21c0.0434,0.95534,1.3017,3.4274,1.7794,4.3828,0.30398,0.78061,0.47664,1.6481,0.78061,2.4297,0.43322,1.3017,0.56349,1.3451,1.128,2.56,0.3474,0.60795,1.0846,1.3027,1.6057,1.6057,0.73718,0.21712,6.5075-7.8102,7.376-8.1132' stroke='%23032a4a'/%3E %3Cpath d='m461.81,312.21c0,0.95534,1.2149,3.384,1.736,4.2949,0.30398,0.82507,0.47664,1.6501,0.78061,2.4307,0.43322,1.2583,0.56349,1.3451,1.128,2.5166,0.3474,0.60794,1.128,1.3017,1.6057,1.5622,0.78061,0.26055,6.4641-7.5931,7.376-7.9395' stroke='%23032b4c'/%3E %3Cpath d='m461.81,312.21c0,0.91192,1.2149,3.3406,1.736,4.2525,0.30398,0.78061,0.47664,1.6057,0.78061,2.3863,0.47767,1.2583,0.56349,1.3451,1.1714,2.5166,0.30397,0.56452,1.0846,1.2593,1.5622,1.5199,0.82403,0.25951,6.4206-7.4639,7.376-7.8102' stroke='%23032b4c'/%3E %3Cpath d='m461.81,312.21c0,0.91192,1.2149,3.2538,1.736,4.1657,0.30398,0.78061,0.47664,1.6491,0.78061,2.3863,0.47767,1.2583,0.56349,1.3017,1.1714,2.4742,0.30397,0.56348,1.0846,1.2583,1.5622,1.5178,0.82403,0.26055,6.4206-7.3326,7.376-7.6789' stroke='%23032c4d'/%3E %3Cpath d='m461.81,312.21c0,0.8685,1.2149,3.2103,1.736,4.1222,0.30398,0.78061,0.47664,1.6057,0.82404,2.3429,0.43424,1.2148,0.56348,1.3017,1.128,2.4307,0.34739,0.56349,1.0846,1.2583,1.5622,1.5188,0.86746,0.26055,6.3772-7.2033,7.376-7.5497' stroke='%23032c4d'/%3E %3Cpath d='m461.81,312.21c0,0.8685,1.1714,3.1669,1.736,4.0788,0.30398,0.73718,0.47664,1.5622,0.82404,2.2994,0.43424,1.2159,0.56348,1.2593,1.128,2.3873,0.34739,0.56349,1.0846,1.2149,1.6057,1.4754,0.86746,0.30294,6.3348-7.0296,7.3326-7.376' stroke='%23032c4d'/%3E %3Cpath d='m461.81,312.21c0,0.8685,1.1714,3.1235,1.736,3.992,0.30398,0.78061,0.47664,1.5622,0.82404,2.2994,0.43424,1.1725,0.56348,1.2593,1.1714,2.3439,0.30397,0.56348,1.0412,1.2148,1.5622,1.4754,0.86746,0.26055,6.2914-6.8559,7.3326-7.2457' stroke='%23032d4f'/%3E %3Cpath d='m461.81,312.21c0,0.82507,1.1714,3.08,1.736,3.9485,0.30398,0.73719,0.47664,1.5188,0.82404,2.256,0.43424,1.1725,0.60691,1.2148,1.1714,2.3439,0.3474,0.52109,1.0412,1.1714,1.5622,1.432,0.91089,0.26054,6.248-6.7257,7.3326-7.1154' stroke='%23032d4f'/%3E %3Cpath d='m461.81,312.21c0,0.82507,1.1714,2.9942,1.736,3.9051,0.30398,0.73718,0.47664,1.4754,0.82404,2.2126,0.43424,1.129,0.60691,1.2159,1.1714,2.3005,0.3474,0.5211,1.0846,1.1714,1.5622,1.432,0.95431,0.26055,6.248-6.5954,7.3326-6.9852' stroke='%23032e50'/%3E %3Cpath d='m461.81,312.21c0,0.78165,1.128,2.9508,1.736,3.8183,0.30398,0.73719,0.47664,1.5188,0.82404,2.2126,0.43424,1.129,0.60691,1.2159,1.1714,2.257,0.3474,0.52109,1.0846,1.1714,1.5622,1.3886,0.95431,0.30398,6.2046-6.4217,7.3326-6.8115' stroke='%23032e50'/%3E %3Cpath d='m461.81,312.21c0,0.78165,1.128,2.9084,1.736,3.7748,0.30398,0.69479,0.47664,1.4754,0.82404,2.1702,0.43424,1.0846,0.60691,1.1714,1.2148,2.2126,0.3474,0.5211,1.0412,1.128,1.5188,1.3886,0.99774,0.30397,6.2046-6.2914,7.3326-6.6812' stroke='%23032f53'/%3E %3Cpath d='m461.81,312.21c0,0.73822,1.128,2.865,1.736,3.7314,0.30398,0.6948,0.47664,1.432,0.82404,2.1268,0.47664,1.0846,0.65033,1.1714,1.2148,2.1692,0.3474,0.5211,1.0412,1.128,1.5188,1.3886,1.0412,0.30397,6.1611-6.1177,7.3326-6.5509' stroke='%23032f53'/%3E %3Cpath d='m461.81,312.21c0,0.73822,1.128,2.8216,1.736,3.6446,0.30398,0.69376,0.47664,1.432,0.82404,2.1268,0.47664,1.0412,0.65033,1.128,1.2148,2.1692,0.3474,0.47767,1.0412,1.0856,1.5623,1.3451,0.99773,0.30397,6.0743-5.9874,7.2891-6.4206' stroke='%23033054'/%3E %3Cpath d='m461.81,312.21c0,0.73822,1.0846,2.7347,1.736,3.6012,0.30398,0.69376,0.47664,1.3886,0.86746,2.0834,0.43322,1.0412,0.60691,1.128,1.1714,2.1257,0.3474,0.47767,1.0412,1.0856,1.5623,1.3017,1.0412,0.3474,6.0743-5.8137,7.2891-6.2469' stroke='%23033054'/%3E %3Cpath d='m461.81,312.21c0,0.6948,1.0846,2.6913,1.736,3.5577,0.26055,0.65137,0.52007,1.3451,0.86746,1.9965,0.43322,1.0412,0.65034,1.1714,1.2149,2.1257,0.3474,0.47767,1.0412,1.0422,1.5188,1.3027,1.0846,0.34637,6.0309-5.6845,7.2891-6.1177' stroke='%23033054'/%3E %3Cpath d='m461.81,312.21c0,0.6948,1.0846,2.6479,1.6925,3.4709,0.30397,0.65137,0.56349,1.3886,0.91088,1.9965,0.43322,1.0412,0.65034,1.128,1.2149,2.0834,0.3474,0.47664,1.0412,1.0412,1.5188,1.3017,1.0846,0.34636,5.9885-5.5542,7.2891-5.9874' stroke='%23033156'/%3E %3Cpath d='m461.81,312.21c0,0.65137,1.0846,2.6044,1.6925,3.4274,0.30397,0.65137,0.56349,1.3451,0.91088,1.9531,0.43322,0.99774,0.65034,1.128,1.2149,2.0389,0.3474,0.47768,1.0412,1.0422,1.5188,1.3027,1.128,0.30398,5.9885-5.3805,7.2891-5.8572' stroke='%23033156'/%3E %3Cpath d='m461.81,312.21c0,0.65137,1.0412,2.561,1.6925,3.384,0.30397,0.60795,0.56349,1.3017,0.91088,1.9096,0.43322,0.99774,0.65034,1.0846,1.2583,2.0399,0.3474,0.47664,0.99774,0.99773,1.4754,1.2149,1.1714,0.34739,5.945-5.2068,7.2891-5.6835' stroke='%23043258'/%3E %3Cpath d='m461.81,312.21c0,0.65137,1.0412,2.4742,1.6925,3.2972,0.30397,0.65137,0.56349,1.3017,0.91088,1.9097,0.43322,0.9543,0.69376,1.0846,1.2583,1.9965,0.3474,0.47663,0.99774,0.99773,1.4754,1.2148,1.1714,0.3474,5.945-5.0766,7.2891-5.5532' stroke='%23043258'/%3E %3Cpath d='m461.81,312.17c0,0.65137,1.0412,2.4742,1.6925,3.2972,0.30397,0.60794,0.56349,1.2593,0.91088,1.8662,0.47664,0.9543,0.69376,1.0846,1.2583,1.9531,0.3474,0.47767,0.99774,0.95431,1.4754,1.2149,1.2148,0.3474,5.9016-4.9463,7.2891-5.4229' stroke='%23043359'/%3E %3Cpath d='m461.81,312.17c0,0.65137,1.0412,2.4307,1.6925,3.2537,0.30397,0.60795,0.56349,1.2159,0.91088,1.8228,0.47664,0.91191,0.69376,1.0412,1.2583,1.9096,0.39083,0.47663,0.99774,0.95431,1.5188,1.1714,1.2149,0.39082,5.8137-4.7726,7.2457-5.2492' stroke='%23043359'/%3E %3Cpath d='m461.81,312.17c0,0.60794,0.99773,2.3873,1.6925,3.1669,0.30397,0.60794,0.56349,1.2593,0.95431,1.8228,0.43321,0.91191,0.69376,1.0412,1.2583,1.8662,0.3474,0.47767,0.99773,0.95431,1.4754,1.1714,1.2149,0.39082,5.8137-4.5989,7.2457-5.1189' stroke='%2304345b'/%3E %3Cpath d='m461.81,312.17c0,0.60794,0.99773,2.3005,1.6925,3.1235,0.30397,0.56452,0.56349,1.2149,0.95431,1.7794,0.43321,0.86849,0.69376,0.99876,1.2583,1.8228,0.3474,0.47767,0.99773,0.95534,1.4754,1.1714,1.2583,0.39082,5.7714-4.4686,7.2457-4.9887' stroke='%2304345b'/%3E %3Cpath d='m461.81,312.17c0,0.60794,0.99773,2.257,1.6925,3.08,0.30397,0.56452,0.56349,1.1725,0.95431,1.736,0.43321,0.86849,0.69376,0.99877,1.2583,1.8228,0.3474,0.43425,0.99773,0.91192,1.4754,1.128,1.3017,0.39082,5.7714-4.3383,7.2457-4.8584' stroke='%2304345b'/%3E %3Cpath d='m461.81,312.17c0,0.56452,0.95431,2.2136,1.6925,2.9942,0.30397,0.56452,0.56349,1.1725,0.95431,1.736,0.43321,0.82507,0.69376,0.95535,1.2583,1.7794,0.39082,0.43425,0.99773,0.86849,1.4754,1.0856,1.3017,0.43321,5.7279-4.1657,7.2457-4.6857' stroke='%2304355c'/%3E %3Cpath d='m461.81,312.17c0,0.56452,0.95431,2.1702,1.6925,2.9508,0.30397,0.56348,0.56349,1.128,0.95431,1.6915,0.43321,0.82507,0.73718,0.95534,1.3017,1.736,0.3474,0.43425,0.95431,0.8685,1.432,1.0846,1.3451,0.43425,5.6845-4.0344,7.2457-4.5544' stroke='%2304355c'/%3E %3Cpath d='m461.81,312.17c0,0.52109,0.95431,2.1268,1.6925,2.9084,0.30397,0.52006,0.56349,1.0846,0.95431,1.6491,0.43321,0.82403,0.73718,0.95431,1.3017,1.6915,0.3474,0.43425,0.95431,0.8685,1.432,1.0856,1.3886,0.43321,5.6845-3.9051,7.2457-4.4252' stroke='%2304365e'/%3E %3Cpath d='m461.81,312.17c0,0.52109,0.95431,2.0399,1.6925,2.8216,0.30397,0.52006,0.56349,1.128,0.95431,1.6491,0.47663,0.78061,0.73718,0.91088,1.3017,1.6481,0.39083,0.43424,0.99774,0.86849,1.432,1.0856,1.3886,0.39083,5.6411-3.7314,7.2457-4.2949' stroke='%2304365e'/%3E %3Cpath d='m461.81,312.17c0,0.52109,0.91089,1.9965,1.6925,2.7781,0.30397,0.52006,0.56349,1.0846,0.95431,1.6046,0.47663,0.78164,0.78061,0.91191,1.3017,1.6491,0.39083,0.39082,0.99774,0.82507,1.4754,0.99877,1.3886,0.43321,5.5542-3.5577,7.2023-4.1212' stroke='%23043760'/%3E %3Cpath d='m461.81,312.17c0,0.47767,0.91089,1.9531,1.6925,2.7347,0.30397,0.47663,0.56349,1.0412,0.95431,1.5622,0.47663,0.73719,0.78061,0.86746,1.3451,1.6057,0.3474,0.38979,0.95431,0.78061,1.432,0.99773,1.432,0.43425,5.5542-3.4274,7.2023-3.9909' stroke='%23043760'/%3E %3Cpath d='m461.81,312.17c0,0.47767,0.91089,1.9096,1.6491,2.6479,0.3474,0.52006,0.65034,1.0412,1.0412,1.5622,0.43425,0.73719,0.73822,0.86746,1.3017,1.5622,0.3474,0.38979,0.95431,0.78061,1.432,0.99774,1.432,0.43424,5.5108-3.2972,7.2023-3.9041' stroke='%23043862'/%3E %3Cpath d='m461.81,312.17c0,0.43424,0.91089,1.8662,1.6491,2.6044,0.3474,0.47664,0.65034,0.99774,1.0412,1.4754,0.43425,0.73718,0.73822,0.91088,1.3017,1.5622,0.39082,0.38979,0.95431,0.78061,1.432,0.99773,1.4754,0.43425,5.5108-3.1669,7.2023-3.7738' stroke='%23043862'/%3E %3Cpath d='m461.81,312.17c0,0.43424,0.86746,1.7794,1.6491,2.5176,0.3474,0.52007,0.65034,0.99774,1.0412,1.4754,0.43425,0.73718,0.78165,0.86746,1.3451,1.5188,0.3474,0.39082,0.91089,0.78061,1.3886,0.95431,1.5188,0.47767,5.4674-2.9508,7.2023-3.6001' stroke='%23043862'/%3E %3Cpath d='m461.81,312.17c0,0.43424,0.86746,1.736,1.6491,2.4742,0.3474,0.47767,0.65034,0.99773,1.0412,1.432,0.43425,0.69376,0.78165,0.86746,1.3451,1.5188,0.3474,0.34739,0.91089,0.73718,1.3886,0.91088,1.5188,0.47767,5.4239-2.8205,7.2023-3.4698' stroke='%23043963'/%3E %3Cpath d='m461.81,312.17c0,0.39082,0.86746,1.6925,1.6491,2.4307,0.3474,0.43425,0.65034,0.95431,1.0412,1.3886,0.43425,0.69479,0.78165,0.82403,1.3451,1.4754,0.38979,0.3474,0.95431,0.6948,1.3886,0.91089,1.5622,0.47767,5.4239-2.6903,7.2023-3.3396' stroke='%23043963'/%3E %3Cpath d='m461.81,312.17c0,0.39082,0.86746,1.6491,1.6491,2.3439,0.3474,0.47768,0.65034,0.95431,1.0412,1.3886,0.47767,0.65034,0.82507,0.82507,1.3451,1.432,0.38979,0.3474,0.95431,0.69479,1.3886,0.91088,1.6057,0.47767,5.3805-2.56,7.2023-3.2093' stroke='%23053a65'/%3E %3Cpath d='m461.81,312.17c0,0.34739,0.82404,1.6057,1.6491,2.3005,0.3474,0.43425,0.65034,0.91088,1.0412,1.3451,0.47767,0.65137,0.82507,0.82507,1.3886,1.3886,0.34636,0.34739,0.91088,0.69479,1.3886,0.86849,1.6057,0.52006,5.2937-2.3873,7.1589-3.0377' stroke='%23053a65'/%3E %3Cpath d='m461.81,312.17c0,0.34739,0.82404,1.5199,1.6491,2.257,0.3474,0.43424,0.65034,0.86745,1.0412,1.3017,0.47767,0.60795,0.82507,0.78061,1.3886,1.3451,0.38979,0.3474,0.91088,0.6948,1.3886,0.86849,1.6057,0.47664,5.2937-2.2136,7.1589-2.9074' stroke='%23053b67'/%3E %3Cpath d='m461.81,312.17c0,0.34739,0.82404,1.4764,1.6491,2.1702,0.3474,0.43424,0.65034,0.86746,1.0846,1.3017,0.43424,0.60795,0.78164,0.78165,1.3451,1.3451,0.38979,0.30398,0.91088,0.65137,1.3886,0.82507,1.6491,0.47664,5.2502-2.0834,7.1589-2.7771' stroke='%23053b67'/%3E %3Cpath d='m461.81,312.17c0,0.30397,0.82404,1.433,1.6491,2.1268,0.3474,0.39082,0.65034,0.86746,1.0846,1.2583,0.43424,0.56452,0.82507,0.73822,1.3451,1.3017,0.38979,0.30397,0.91088,0.60794,1.3886,0.78164,1.6925,0.5211,5.2502-1.9096,7.1589-2.6034' stroke='%23053c68'/%3E %3Cpath d='m461.81,312.17c0,0.30397,0.78061,1.3896,1.6491,2.0834,0.3474,0.39082,0.65034,0.82507,1.0846,1.2148,0.43424,0.56452,0.82507,0.73822,1.3886,1.2593,0.34637,0.30294,0.91089,0.60691,1.3451,0.78061,1.6925,0.52109,5.2068-1.7794,7.1589-2.4731' stroke='%23053c68'/%3E %3Cpath d='m461.81,312.17c0,0.26055,0.78061,1.3462,1.6491,1.9965,0.30398,0.39082,0.65034,0.82507,1.0846,1.2148,0.43424,0.5211,0.82507,0.6948,1.3886,1.2159,0.38979,0.30294,0.91089,0.60692,1.3451,0.78061,1.736,0.5211,5.1634-1.6491,7.1589-2.3429' stroke='%23053c68'/%3E %3Cpath d='m461.81,312.17c0,0.26055,0.78061,1.2593,1.6491,1.9531,0.30398,0.39082,0.65034,0.78165,1.0846,1.1714,0.43424,0.5211,0.86849,0.6948,1.3886,1.1725,0.38979,0.30294,0.91089,0.60691,1.3451,0.78061,1.7794,0.5211,5.1634-1.4754,7.1589-2.2126' stroke='%23053d6a'/%3E %3Cpath d='m461.81,312.17c0,0.21712,0.78061,1.2159,1.6491,1.9096,0.30398,0.3474,0.65034,0.73822,1.0846,1.128,0.47767,0.47767,0.86849,0.69479,1.3886,1.129,0.38979,0.30397,0.91089,0.60691,1.3451,0.73718,1.7794,0.56452,5.12-1.3017,7.1589-2.0389' stroke='%23053d6a'/%3E %3Cpath d='m461.81,312.17c0,0.21712,0.73719,1.1725,1.6491,1.8228,0.30398,0.39082,0.65034,0.73822,1.0846,1.129,0.47767,0.47664,0.86849,0.65034,1.432,1.128,0.38978,0.25951,0.86746,0.52006,1.3451,0.69376,1.7794,0.56452,5.0766-1.1714,7.1154-1.9086' stroke='%23053e6c'/%3E %3Cpath d='m461.81,312.17c0,0.21712,0.73719,1.129,1.6057,1.7794,0.3474,0.3474,0.73718,0.6948,1.128,1.0856,0.47767,0.43321,0.86849,0.65034,1.432,1.0846,0.38978,0.26055,0.86746,0.5211,1.3451,0.69376,1.8228,0.56452,5.0331-1.0412,7.1154-1.7783' stroke='%23053e6c'/%3E %3Cpath d='m461.81,312.17c0,0.1737,0.73719,1.0856,1.6057,1.736,0.3474,0.30397,0.73718,0.69479,1.128,1.0422,0.47767,0.43321,0.91088,0.60691,1.432,1.0412,0.38978,0.26055,0.86746,0.52006,1.3451,0.69479,1.8228,0.56349,4.9897-0.91191,7.1154-1.6491' stroke='%23053f6e'/%3E %3Cpath d='m461.81,312.17c0,0.1737,0.73719,0.99876,1.6057,1.6491,0.3474,0.3474,0.73718,0.69479,1.1714,1.0422,0.43425,0.38979,0.86746,0.60691,1.432,0.99774,0.34636,0.26054,0.86746,0.52109,1.3017,0.65033,1.8662,0.56452,4.9897-0.69376,7.1154-1.4744' stroke='%23053f6e'/%3E %3Cpath d='m461.81,312.17c0,0.13027,0.69376,0.95534,1.6057,1.6057,0.3474,0.30397,0.73718,0.65137,1.1714,0.95534,0.43425,0.43321,0.86746,0.65033,1.432,0.99773,0.38979,0.26055,0.86746,0.47767,1.3017,0.65137,1.9096,0.56349,4.9463-0.56452,7.1154-1.3451' stroke='%23053f6f'/%3E %3Cpath d='m461.81,312.17c0,0.13027,0.69376,0.91192,1.6057,1.5622,0.3474,0.30397,0.73718,0.60795,1.1714,0.91192,0.43425,0.39082,0.86746,0.60691,1.432,0.99773,0.38979,0.21713,0.86746,0.43425,1.3017,0.60795,1.9096,0.56348,4.9028-0.43425,7.1154-1.2149' stroke='%23053f6f'/%3E %3Cpath d='m461.81,312.17c0,0.13027,0.69376,0.86849,1.6057,1.4764,0.3474,0.30293,0.73718,0.60691,1.1714,0.91088,0.43425,0.39082,0.91089,0.60691,1.432,0.95431,0.38979,0.21712,0.86746,0.43424,1.3017,0.60794,1.9531,0.56452,4.9028-0.30397,7.1154-1.0846' stroke='%23053f6f'/%3E %3Cpath d='m461.81,312.17c0,0.0869,0.65034,0.78164,1.6057,1.433,0.3474,0.25952,0.73718,0.56349,1.1714,0.86746,0.47767,0.39082,0.91089,0.56452,1.4754,0.91088,0.38978,0.21713,0.82403,0.43425,1.2583,0.56452,1.9955,0.60692,4.8594-0.13027,7.1154-0.91088' stroke='%23064171'/%3E %3Cpath d='m461.81,312.17c0,0.0869,0.65034,0.73822,1.6057,1.3896,0.3474,0.25951,0.73718,0.56348,1.1714,0.82403,0.47767,0.3474,0.91089,0.56452,1.4754,0.86746,0.38978,0.21712,0.82403,0.43425,1.3017,0.56452,1.952,0.60795,4.816,0,7.072-0.78061' stroke='%23064171'/%3E %3Cpath d='m461.81,312.17c0,0.0434,0.65034,0.69479,1.6057,1.3027,0.3474,0.25951,0.73718,0.56348,1.1714,0.82403,0.47767,0.3474,0.95431,0.56452,1.4754,0.82507,0.38978,0.21609,0.86746,0.38979,1.3017,0.56349,1.9955,0.60794,4.7726,0.1737,7.072-0.65034' stroke='%23064172'/%3E %3Cpath d='m461.81,312.13c0,0.0869,0.65034,0.6948,1.6057,1.3027,0.3474,0.26055,0.73718,0.52006,1.1714,0.78061,0.47767,0.30397,0.95431,0.5211,1.4754,0.82507,0.43321,0.17267,0.86746,0.34636,1.3017,0.52006,2.0389,0.60795,4.7292,0.30398,7.072-0.52006' stroke='%23064172'/%3E %3Cpath d='m461.81,312.13c0,0.0869,0.60691,0.65137,1.6057,1.2593,0.3474,0.21712,0.73718,0.47664,1.1714,0.73718,0.47767,0.30398,0.95431,0.5211,1.5188,0.78165,0.38979,0.1737,0.82404,0.34636,1.2583,0.47663,2.0389,0.65137,4.7292,0.47768,7.072-0.34636' stroke='%23064374'/%3E %3Cpath d='m461.81,312.13c0,0.0434,0.60691,0.56452,1.6057,1.1725,0.3474,0.26055,0.73718,0.47664,1.2149,0.73718,0.43424,0.26055,0.91088,0.47767,1.4754,0.73822,0.38979,0.1737,0.82404,0.3474,1.2583,0.47664,2.0823,0.65137,4.6857,0.60795,7.072-0.21609' stroke='%23064374'/%3E %3Cpath d='m461.81,312.13c0,0.0434,0.60691,0.5211,1.6057,1.129,0.3474,0.21713,0.73718,0.43425,1.2149,0.69376,0.43424,0.26055,0.9543,0.47768,1.4754,0.6948,0.38979,0.1737,0.82404,0.3474,1.2583,0.47767,2.1257,0.60691,4.6423,0.73719,7.072-0.0869' stroke='%2300209f'/%3E %3Cpath d='m461.81,312.13s6.4651,5.0766,12.626,2.9084' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m461.55,292.17s1.2583,8.1132,1.736,9.2846c0.43321,1.0422,2.9942,5.6845,6.8983,6.7691' stroke='%23022743'/%3E %3Cpath d='m461.55,292.17s1.3451,8.0274,1.8662,9.1988c0.43425,1.0412,2.8205,5.4663,6.8115,6.8115' stroke='%23022a49'/%3E %3Cpath d='m461.59,292.13s1.3886,7.9839,1.9096,9.1988c0.43425,1.0412,2.6903,5.2058,6.7246,6.8549' stroke='%23032b4c'/%3E %3Cpath d='m461.59,292.13s1.4754,7.9405,1.9965,9.1119c0.47664,1.0412,2.5166,4.9887,6.6378,6.8983' stroke='%23032e50'/%3E %3Cpath d='m461.64,292.13s1.5188,7.8526,2.0399,9.0251c0.52006,1.0846,2.3863,4.7716,6.5943,6.9418' stroke='%23033054'/%3E %3Cpath d='m461.64,292.13s1.6057,7.8092,2.1702,8.9817c0.47664,1.0846,2.2126,4.4686,6.4641,6.9852' stroke='%23043359'/%3E %3Cpath d='m461.64,292.08s1.6925,7.7668,2.257,8.9382c0.52006,1.0846,2.0389,4.2525,6.3772,7.0286' stroke='%2304355c'/%3E %3Cpath d='m461.68,292.08s1.7349,7.7234,2.2994,8.8948c0.52006,1.0846,1.9086,3.992,6.2904,7.072' stroke='%23043760'/%3E %3Cpath d='m461.68,292.08s1.8218,7.6365,2.3863,8.808c0.56348,1.0846,1.7794,3.7748,6.248,7.1154' stroke='%23053a65'/%3E %3Cpath d='m461.72,292.04s1.8652,7.6365,2.4731,8.7646c0.56349,1.128,1.5622,3.5153,6.1177,7.2023' stroke='%23053c68'/%3E %3Cpath d='m461.72,292.04s1.9955,7.5497,2.56,8.7211c0.56349,1.0846,1.432,3.2538,6.0309,7.2023' stroke='%23053f6e'/%3E %3Cpath d='m461.77,292.04s2.0399,7.5063,2.6034,8.6343c0.60691,1.128,1.3017,3.0377,5.9874,7.2457' stroke='%23064172'/%3E %3Cpath d='m461.77,291.99s2.1268,7.4628,2.6903,8.5908c0.60691,1.128,1.1714,2.8205,5.9006,7.3326' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m462.07,287.18s1.0412,11.455,9.1978,14.622' stroke='%23022743'/%3E %3Cpath d='m462.07,287.18c0.0434,0.0434,0.47664,3.688,2.1257,7.2457,1.3017,2.7337,3.4709,5.8572,7.072,7.3326' stroke='%23022a49'/%3E %3Cpath d='m462.11,287.18c0,0.0434,0.52007,3.7748,2.1692,7.2023,1.2149,2.5166,3.384,5.7713,6.9852,7.376' stroke='%23032b4c'/%3E %3Cpath d='m462.11,287.18c0.0434,0.0868,0.65034,3.9051,2.256,7.1154,1.1714,2.3429,3.2972,5.7279,6.8983,7.4194' stroke='%23032e50'/%3E %3Cpath d='m462.16,287.18c0,0.0868,0.73718,3.992,2.3429,7.072,1.0412,2.1692,3.1669,5.6411,6.7691,7.4194' stroke='%23033054'/%3E %3Cpath d='m462.16,287.18c0.0434,0.13027,0.86746,4.0788,2.4297,6.9852,0.95431,1.9965,3.1235,5.5976,6.6822,7.5063' stroke='%23043359'/%3E %3Cpath d='m462.2,287.18c0,0.13027,0.95431,4.1657,2.4731,6.9417,0.91088,1.7794,3.0377,5.5108,6.5954,7.5063' stroke='%2304355c'/%3E %3Cpath d='m462.2,287.14c0.0434,0.21713,1.0846,4.3394,2.56,6.9428,0.82403,1.5612,2.9508,5.4229,6.5085,7.5052' stroke='%23043760'/%3E %3Cpath d='m462.2,287.14c0.0869,0.21713,1.2149,4.4252,2.6468,6.8559,0.78061,1.432,2.864,5.3805,6.4217,7.5486' stroke='%23053a65'/%3E %3Cpath d='m462.25,287.14c0.0434,0.26055,1.3017,4.512,2.6903,6.8125,0.69376,1.2149,2.7771,5.2937,6.3348,7.5921' stroke='%23053c68'/%3E %3Cpath d='m462.25,287.14c0.0858,0.26055,1.432,4.5999,2.8205,6.7256,0.60691,1.0412,2.6468,5.2502,6.2046,7.6355' stroke='%23053f6e'/%3E %3Cpath d='m462.29,287.14c0.0434,0.30398,1.5188,4.7302,2.864,6.6822,0.52006,0.82403,2.56,5.1634,6.1177,7.6355' stroke='%23064172'/%3E %3Cpath d='m462.29,287.14c0.0858,0.30398,1.6491,4.816,2.9508,6.5954,0.47664,0.65034,2.4731,5.12,6.0309,7.7224' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m462.16,284.01s2.3863,9.1988,9.0251,11.455' stroke='%23022743'/%3E %3Cpath d='m462.16,284.01s0.91088,3.2537,3.08,6.4217c1.432,2.1258,3.5143,4.2081,5.944,5.0331' stroke='%23022847'/%3E %3Cpath d='m462.16,283.97s0.95431,3.2103,3.1235,6.3772c1.5188,2.1692,3.6446,4.3383,5.9006,5.12' stroke='%23032a4a'/%3E %3Cpath d='m462.16,283.93s0.99773,3.1669,3.2103,6.3338c1.5623,2.2126,3.7314,4.4686,5.8137,5.1634' stroke='%23032c4d'/%3E %3Cpath d='m462.2,283.88s0.99774,3.1235,3.2538,6.3338c1.6057,2.2126,3.8617,4.5554,5.7279,5.2068' stroke='%23032f53'/%3E %3Cpath d='m462.2,283.88s1.0412,3.0376,3.3406,6.248c1.6491,2.256,3.9485,4.6857,5.6845,5.2502' stroke='%23033156'/%3E %3Cpath d='m462.2,283.84s1.0846,3.0377,3.384,6.2046c1.736,2.3429,4.1222,4.816,5.6411,5.3371' stroke='%23043359'/%3E %3Cpath d='m462.2,283.79s1.128,2.9942,3.4709,6.1611c1.7794,2.3863,4.2091,4.9463,5.5542,5.4239' stroke='%2304355c'/%3E %3Cpath d='m462.25,283.79s1.0846,2.9074,3.5143,6.1177c1.8228,2.3863,4.3394,5.0331,5.4674,5.424' stroke='%23043760'/%3E %3Cpath d='m462.25,283.75s1.128,2.864,3.6011,6.0743c1.8652,2.4297,4.4252,5.2068,5.3805,5.5108' stroke='%23043963'/%3E %3Cpath d='m462.25,283.71s1.1714,2.8205,3.6446,6.0308c1.9086,2.4731,4.5989,5.3371,5.3371,5.5976' stroke='%23053b67'/%3E %3Cpath d='m462.25,283.66s1.2148,2.7771,3.7314,6.0309c1.9531,2.5166,4.6857,5.424,5.2502,5.5976' stroke='%23053e6c'/%3E %3Cpath d='m462.29,283.66s1.2149,2.6903,3.7748,5.944c1.9955,2.56,4.816,5.5542,5.1634,5.6845' stroke='%23053f6f'/%3E %3Cpath d='m462.29,283.62s1.2583,2.6468,3.8617,5.9006c2.0389,2.6034,4.9028,5.6845,5.12,5.7713' stroke='%23064172'/%3E %3Cpath d='m462.29,283.58s1.3017,2.6034,3.9051,5.8572c2.1257,2.6468,5.0766,5.8148,5.0766,5.8148' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M479.9,296.55 484.46,297.38' stroke='%2300209f'/%3E %3Cpath d='M480.38,300.02 484.46,298.29' stroke='%2300209f'/%3E %3Cpath d='M479.86,296.68 484.42,297.38' stroke='%23064171'/%3E %3Cpath d='M479.86,296.85 484.46,297.42' stroke='%23053e6c'/%3E %3Cpath d='M479.9,297.03 484.5,297.42' stroke='%23053b67'/%3E %3Cpath d='M479.9,297.2 484.55,297.46' stroke='%23043862'/%3E %3Cpath d='M479.9,297.38 484.59,297.46' stroke='%2304355c'/%3E %3Cpath d='M479.95,297.55 484.63,297.51' stroke='%23043258'/%3E %3Cpath d='M479.95,297.68 484.68,297.51' stroke='%23032f53'/%3E %3Cpath d='M479.95,297.85 484.72,297.55' stroke='%23032c4d'/%3E %3Cpath d='M479.99,298.03 484.76,297.55' stroke='%23022a49'/%3E %3Cpath d='M480.34,299.81 484.5,298.2' stroke='%23064171'/%3E %3Cpath d='M480.29,299.63 484.55,298.11' stroke='%23053e6c'/%3E %3Cpath d='M480.29,299.46 484.59,298.07' stroke='%23053b67'/%3E %3Cpath d='M480.25,299.28 484.63,297.98' stroke='%23043862'/%3E %3Cpath d='M480.21,299.11 484.68,297.94' stroke='%2304355c'/%3E %3Cpath d='M480.21,298.94 484.72,297.85' stroke='%23043258'/%3E %3Cpath d='M480.16,298.72 484.76,297.81' stroke='%23032f53'/%3E %3Cpath d='M480.12,298.55 484.81,297.72' stroke='%23032c4d'/%3E %3Cpath d='M480.12,298.37 484.85,297.68' stroke='%23022a49'/%3E %3Cpath d='M480.08,298.2 484.89,297.59' stroke='%23022743'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m484.24,331.57s-2.4297,0.13027-2.6468,0.21712c-0.26055,0.0434-9.8926-0.1737-9.8926-0.1737' stroke='%23032b4c'/%3E %3Cpath d='m484.29,331.61s-2.3863,0.21713-2.7337,0.30398c-0.39082,0.0424-9.7623-0.26055-9.7623-0.26055' stroke='%23032e50'/%3E %3Cpath d='m484.29,331.65s-2.2994,0.30294-2.7771,0.38979c-0.52109,0.0879-9.632-0.34637-9.632-0.34637' stroke='%23033054'/%3E %3Cpath d='m484.33,331.7s-2.256,0.34637-2.864,0.47768c-0.65034,0.12924-9.5452-0.43425-9.5452-0.43425' stroke='%23043359'/%3E %3Cpath d='m484.33,331.7s-2.1692,0.47768-2.9508,0.60692c-0.73719,0.17369-9.3715-0.52007-9.3715-0.52007' stroke='%2304355c'/%3E %3Cpath d='m484.33,331.74s-2.0834,0.52006-2.9942,0.69376c-0.86746,0.21712-9.2412-0.60691-9.2412-0.60691' stroke='%23043760'/%3E %3Cpath d='m484.37,331.78s-2.0389,0.60691-3.08,0.82404c-0.99773,0.1737-9.1119-0.73719-9.1119-0.73719' stroke='%23053a65'/%3E %3Cpath d='m484.37,331.83s-1.9955,0.69376-3.1235,0.91088c-1.128,0.21713-9.0251-0.78164-9.0251-0.78164' stroke='%23053c68'/%3E %3Cpath d='m484.42,331.87s-1.952,0.73719-3.2103,0.99774c-1.2583,0.26054-8.8948-0.8685-8.8948-0.8685' stroke='%23053f6e'/%3E %3Cpath d='m484.42,331.91s-1.8662,0.82403-3.2538,1.0846c-1.3886,0.30397-8.7645-0.95534-8.7645-0.95534' stroke='%23064172'/%3E %3Cpath d='m472.48,332.09s7.1154,1.3451,8.6343,1.0412c1.5188-0.30397,3.3406-1.1725,3.3406-1.1725' stroke='%2300209f'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m486.06,337.07s4.5554,0.6948,4.7292,0.65137c0.0858,0,2.6468-0.1737,2.7337-0.1737,0.0434,0,2.2126-0.52109,2.2126-0.52109' stroke='%23022a49' stroke-width='0.17359523'/%3E %3Cpath d='m485.8,336.99s4.6857,0.73822,5.0331,0.65137c0.17267-0.0434,2.5166-0.1737,2.6468-0.1737,0.13027,0,2.0823-0.47767,2.0823-0.47767' stroke='%23032d4f' stroke-width='0.17359523'/%3E %3Cpath d='m485.54,336.86s4.816,0.82507,5.2937,0.69479c0.25951-0.0434,2.3863-0.1737,2.6034-0.1737,0.1737,0,1.9096-0.43424,1.9096-0.43424' stroke='%23033054' stroke-width='0.17359523'/%3E %3Cpath d='m485.28,336.73s4.9028,0.8685,5.5966,0.73822c0.34739-0.0434,2.257-0.17369,2.5166-0.17369,0.21712-0.0434,1.736-0.3474,1.736-0.3474' stroke='%23043359' stroke-width='0.17359523'/%3E %3Cpath d='m485.02,336.64s5.0331,0.91088,5.8572,0.73718c0.43424-0.0868,2.1702-0.17369,2.4731-0.21712,0.30398,0,1.5623-0.26055,1.5623-0.26055' stroke='%23043760' stroke-width='0.17359523'/%3E %3Cpath d='m484.76,336.51s5.1634,0.99773,6.1611,0.78061c0.5211-0.0869,1.9965-0.1737,2.3863-0.21713,0.3474,0,1.3886-0.21712,1.3886-0.21712' stroke='%23053a65' stroke-width='0.17359523'/%3E %3Cpath d='m484.5,336.38s5.2502,1.0846,6.4206,0.86746c0.65034-0.13027,1.9096-0.21712,2.3429-0.26055,0.43424-0.0434,1.2148-0.1737,1.2148-0.1737' stroke='%23053d6a' stroke-width='0.17359523'/%3E %3Cpath d='m484.24,336.29s5.3805,1.128,6.7246,0.86746c0.69479-0.1737,1.736-0.26055,2.256-0.26055,0.47767-0.0434,1.0846-0.0869,1.0846-0.0869' stroke='%23064171' stroke-width='0.17359523'/%3E %3Cpath transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' stroke='%23022743' d='M59.296,119.6,63.577,120.19,66.304,120.06,68.612,119.47' stroke-width='0.1679'/%3E %3Cpath d='m483.98,336.16s5.5108,1.2148,7.0286,0.91088c1.4754-0.30397,3.08-0.30397,3.08-0.30397' stroke='%2300209f' stroke-width='0.17359523'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m505.76,336.81s2.864-1.0412,4.2949-1.5612c2.6903-0.99876,2.9942-3.688,2.9942-3.688' stroke='%2300209f'/%3E %3Cpath d='m505.46,335.95s1.736-0.69376,3.1669-1.2148c3.8183-1.432,3.384-3.2538,3.384-3.2538' stroke='%2300209f'/%3E %3Cpath d='m505.2,336.12s2.256-0.86746,3.4274-1.3017c0.60794-0.21713,1.3886-0.56452,1.7794-0.82507,0.52007-0.30397,1.1714-0.91088,1.3451-1.2149,0.3474-0.52109,0.3474-1.2583,0.3474-1.2583' stroke='%23053e6c'/%3E %3Cpath d='m504.94,336.34s2.8205-1.0846,3.688-1.3886c0.43424-0.1737,1.4754-0.60794,1.736-0.78164,0.39082-0.26055,1.3017-0.99774,1.432-1.2149,0.26055-0.43425,0.43321-1.432,0.43321-1.432' stroke='%23043862'/%3E %3Cpath d='m504.68,336.51s3.384-1.2583,3.9485-1.4764c0.30397-0.0858,1.5188-0.60691,1.6925-0.69376,0.26055-0.1737,1.432-1.128,1.5188-1.2583,0.1737-0.26055,0.47768-1.5623,0.47768-1.5623' stroke='%23043258'/%3E %3Cpath d='m504.42,336.73s3.9051-1.4744,4.208-1.5622c0.13028-0.0869,1.6057-0.60691,1.6925-0.69376,0.13027-0.0434,1.5188-1.1714,1.5622-1.2583,0.0868-0.13027,0.56453-1.6491,0.56453-1.6491' stroke='%23032c4d'/%3E %3Cpath d='m505.46,336.86s3.4709-1.3017,4.6423-1.736c0.82404-0.30294,1.6925-1.0412,2.0823-1.5612,0.56452-0.82507,0.78164-1.9965,0.78164-1.9965' stroke='%23053e6c'/%3E %3Cpath d='m505.11,336.86s4.1657-1.5188,5.0331-1.8662c0.60794-0.21609,1.6925-1.0846,1.9531-1.4744,0.43321-0.60794,0.73719-1.9531,0.73719-1.9531' stroke='%23043862'/%3E %3Cpath d='m504.81,336.9s4.816-1.8228,5.3805-1.9955c0.43425-0.1737,1.6925-1.1725,1.8662-1.432,0.30397-0.43425,0.69376-1.9096,0.69376-1.9096' stroke='%23043258'/%3E %3Cpath d='m504.5,336.9s5.4239-2.0389,5.7279-2.1257c0.21608-0.0869,1.6481-1.2148,1.7783-1.3451,0.13027-0.21712,0.65033-1.8662,0.65033-1.8662' stroke='%23032c4d'/%3E %3Cpath transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' stroke='%23022743' d='M76.543,119.3,82.461,117.12,84.055,115.91,84.643,114.14'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m511.27,331.57s-2.5166,0.13027-2.7771,0.21712c-0.26054,0.0434-10.283-0.1737-10.283-0.1737' stroke='%23032b4c'/%3E %3Cpath d='m511.32,331.61s-2.4731,0.21713-2.864,0.30398c-0.39082,0.0424-10.153-0.26055-10.153-0.26055' stroke='%23032e50'/%3E %3Cpath d='m511.32,331.65s-2.3863,0.30294-2.9074,0.38979c-0.52109,0.0879-10.023-0.34637-10.023-0.34637' stroke='%23033054'/%3E %3Cpath d='m511.32,331.7s-2.2994,0.34637-2.9508,0.47768c-0.65137,0.12924-9.8926-0.43425-9.8926-0.43425' stroke='%23043359'/%3E %3Cpath d='m511.36,331.7s-2.257,0.47768-3.0377,0.60692c-0.78061,0.17369-9.7623-0.52007-9.7623-0.52007' stroke='%2304355c'/%3E %3Cpath d='m511.36,331.74s-2.1692,0.52006-3.08,0.69376c-0.91088,0.21712-9.6754-0.60691-9.6754-0.60691' stroke='%23043760'/%3E %3Cpath d='m511.4,331.78s-2.1257,0.60691-3.1669,0.82404c-1.0846,0.1737-9.5452-0.73719-9.5452-0.73719' stroke='%23053a65'/%3E %3Cpath d='m511.4,331.83s-2.0389,0.69376-3.2538,0.91088c-1.1714,0.21713-9.3714-0.78164-9.3714-0.78164' stroke='%23053c68'/%3E %3Cpath d='m511.45,331.87s-2.0389,0.73719-3.3406,0.99774c-1.3017,0.26054-9.2412-0.8685-9.2412-0.8685' stroke='%23053f6e'/%3E %3Cpath d='m511.45,331.91s-1.9531,0.82403-3.384,1.0846c-1.432,0.30397-9.1119-0.95534-9.1119-0.95534' stroke='%23064172'/%3E %3Cpath d='m498.99,332.09s7.4628,1.3451,9.0251,1.0412c1.5622-0.30397,3.4709-1.1725,3.4709-1.1725' stroke='%2300209f'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m474.96,289.91c-0.13027-1.2583-0.1737-2.5166-0.1737-3.2103,0.0434-5.1634-0.65034-9.0685-0.0869-14.491,0.43425-4.2515,1.4754-9.8491,1.2583-14.448-0.0869-1.3017,0.17267-2.6034,0.21713-3.8617l20.957,23.517'/%3E %3Cpath d='m466.97,327.7c-0.56452-0.34637-1.5188-1.3451-1.8228-2.2126-0.60795-1.736-0.47767-1.6925-0.91089-3.6012-0.25951-1.0846-0.25951-2.2994-0.52109-3.4274-0.21609-1.128-1.8218-4.7292-1.8652-6.2046-0.17267-4.7281-1.736-7.9395-1.3451-13.103,0.26054-3.992,1.1714-9.4149,0.73718-13.581-0.13027-1.128,0.0434-2.4307,0.0868-3.5577l23.56,15.576'/%3E %3Cpath d='m513.44,331.48c0.1737,0.52006-0.3474,1.5188-0.52006,1.8662-0.13028,0.1737-0.3474,0.47663-0.47664,0.65033-0.26055,0.56452-0.21712,0.43425-0.6948,0.8685-0.12924,0.0869-0.69376,0.56348-0.86745,0.65033-0.34637,0.26055-0.69377,0.60795-1.0846,0.65137-1.7794,0.30397-2.5166,0.69376-4.2091,1.1714-1.6057,0.47768-0.73718,0.39083-1.952,0.6948-0.60691,0.12924-1.8228,0.60691-2.4297,0.69376-1.0846,0.1737-1.2583,0.3474-2.3863,0.60794-2.9074,0.65034-5.7269,0.47664-8.5908,0.30398-1.1714-0.0868-4.0354-0.6948-5.0331-1.3896-1.7794-1.2583-5.6845-1.7349-7.4194-2.9498-0.25952-0.17473-1.3451-0.69479-1.5612-0.91192-1.6925-1.3886-3.0377-1.7794-4.816-2.9074'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-miterlimit='2.61310005'%3E %3Cg%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='58.457,80.488,58.457,80.488,35.334,65.381,34.915,66.01,57.911,81.286' stroke-width='0.1259' fill='%23FC0'/%3E %3Cpath d='m461.16,280.89c-0.1737-0.91088,0.0868-2.1268,0.73718-2.257,0.0434,0,0.52006-0.17266,0.82404-0.0858,0.39082,0,0.47663,0.12924,0.65033,0.43321,0.34636,0.82404-0.65033,1.3451-1.3451,1.6057-0.1737,0.0434-0.65034,0.13027-0.73718,0.34636-0.13028,0.3474-0.0434,0.21713-0.13028,0.3474,0.13028-0.0434,0.1737-0.1737,0.30294-0.26055,0.5211-0.30294,1.0412-0.38979,1.7794-0.73718,0.56452-0.25952,0.65137-1.3886,0.26055-1.7349-0.43322-0.3474-1.7784-0.30397-2.0823,0.0434-0.65034,0.73719-0.69376,1.736-0.56349,2.7337,0-0.21712,0.3474-0.1737,0.30398-0.43425z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m460.77,281.32c-0.91088-0.0434-2.0834,0.3474-2.1257,0.99773,0,0.0869-0.0869,0.60795,0,0.86746,0.0434,0.39082,0.17267,0.47767,0.52007,0.56452,0.86745,0.25952,1.2583-0.78061,1.3886-1.5188,0.0434-0.1737,0.0434-0.65033,0.26055-0.78061,0.34636-0.1737,0.25951-0.0868,0.34636-0.1737-0.0434,0.13028-0.1737,0.21713-0.21712,0.30398-0.21609,0.56348-0.25952,1.128-0.52006,1.9086-0.1737,0.56349-1.3017,0.78061-1.6491,0.43425-0.43424-0.3474-0.56348-1.6925-0.26054-2.0399,0.65137-0.73718,1.6491-0.91088,2.6468-0.91088-0.17266,0.0434-0.12924,0.39082-0.38979,0.3474z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m460.6,280.93c-0.26054,0.13027-0.26054,0.47767-0.13027,0.69479,0.0869,0.21609,0.47664,0.25951,0.65034,0.17267,0.34636-0.21609,0.56452-0.60692,0.34636-0.95431-0.21506-0.30398-0.56245-0.0434-0.86643,0.0868z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m455.56,277.76c0,0 2.5166,0.99773 4.5554,1.0412 0,0 0.0869,1.7794 0.52007,2.2994 0,0 -1.8218,-0.34637 -2.6468,0.0868 10e-4,0 -1.0836,-2.4731 -2.4287,-3.4274z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m457.6,279.02c0,0 0.99773,0.43425 1.8218,0.43425 0,0 0.0434,0.69376 0.21713,0.91088 0,0 -0.73719,-0.13027 -1.0412,0.0434 0,-10e-4 -0.43425,-0.99773 -0.99773,-1.3886z' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m460.77,282.88s0.47664-0.82403,0.60691-1.128c0.0858-0.17266-0.0434,0.99774,0.38979,1.128,0.56349,0.73719,0.69376,2.256,0.69376,2.6468-0.65033,0.21609-1.2148,0.60691-2.2126,0.13027-0.34636-0.21712-0.0869-0.86746,0.0434-1.3886,0.0879-0.26158,0.17473-0.99877,0.4787-1.3886z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m461.25,282.23c0,0.12924,0.0868,0.65034,0.0434,0.56349,0-0.21609,0.25951,0.21712,0.30294,0.30397,0.3474,0.65034,0.47767,1.128,0.60794,2.3863' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m461.46,283.32c0.21713,0.99774,0.39083,0.95431,0.39083,2.3439l0.0868-0.0868' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m461.42,284.23c0.17266,0.69376,0.12924,1.0412,0.17266,1.3886-0.0434,0-0.25951,0.17267-0.30293,0.17267' stroke-width='0.13017058' fill='none'/%3E %3C/g%3E %3Cg%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='70.375,61.185,70.375,61.185,49.728,38.23,49.309,38.733,69.745,61.772' stroke-width='0.1259' fill='%23fc0'/%3E %3Cpath d='m476.61,253.08c0.0434-0.95431,0.56452-2.0834,1.2149-2.0399,0.0434,0,0.56452-0.0434,0.82403,0.0868,0.39083,0.0868,0.43425,0.26055,0.52007,0.60795,0.17369,0.86746-0.91089,1.128-1.6481,1.2148-0.1737,0-0.69376-0.0434-0.82404,0.1737-0.21712,0.30397-0.0869,0.21609-0.21712,0.30397,0.13027,0,0.26055-0.13027,0.3474-0.17369,0.60691-0.17267,1.128-0.17267,1.952-0.30294,0.56452-0.0868,0.91088-1.2149,0.60794-1.6057-0.30397-0.43425-1.6057-0.73719-1.9965-0.47664-0.82403,0.56349-1.0846,1.5188-1.1714,2.56,0.0445-0.21919,0.3474-0.13234,0.39082-0.34843z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m476.13,253.38c-0.91088-0.25952-2.1257-0.13028-2.3429,0.47767,0,0.0434-0.21609,0.56348-0.17267,0.82403-0.0434,0.38979,0.0434,0.52006,0.38979,0.69376,0.73719,0.43425,1.3886-0.47664,1.6925-1.1714,0.0869-0.1737,0.21712-0.60691,0.43321-0.69376,0.3474-0.0858,0.26055,0,0.3474-0.0858-0.0434,0.12924-0.17267,0.17267-0.25952,0.25952-0.34739,0.52006-0.52109,0.99773-0.9543,1.7349-0.30398,0.47767-1.432,0.47767-1.736,0.0434-0.30294-0.47664-0.0869-1.7783,0.25952-2.0389,0.78164-0.60794,1.8228-0.56452,2.7771-0.26055-0.1737-0.0424-0.21713,0.30501-0.43425,0.21713z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m476.04,252.95c-0.30398,0.0434-0.3474,0.43322-0.30398,0.65034,0.0434,0.21712,0.38979,0.38979,0.60691,0.30397,0.3474-0.13027,0.69376-0.43321,0.56349-0.82403-0.12924-0.3474-0.56349-0.1737-0.86642-0.13028z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m471.92,248.69c0,0 2.1702,1.5622 4.1222,2.0834 0,0 -0.30398,1.7794 0,2.3429 0,0 -1.736,-0.73718 -2.6034,-0.52109 0,0 -0.43424,-2.6468 -1.5188,-3.9051z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23fc0'/%3E %3Cpath d='m473.57,250.43c0,0 0.86746,0.60691 1.6491,0.82404 0,0 -0.13028,0.69376 0,0.91088 0,0 -0.69376,-0.26055 -1.0412,-0.1737 0,0.001 -0.1737,-1.0846 -0.60795,-1.5612z' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m475.74,254.9s0.65034-0.69376,0.86746-0.9543c0.13028-0.1737-0.30294,0.9543,0.0869,1.2148,0.38979,0.82404,0.13028,2.2994,0.0434,2.7337-0.69376,0.0434-1.3017,0.25951-2.1257-0.43425-0.30398-0.26055,0.0858-0.82403,0.34636-1.3017,0.13027-0.25952,0.39082-0.95431,0.78164-1.2583z' fill-rule='evenodd' stroke-width='0.13017058' fill='%23FC0'/%3E %3Cpath d='m476.35,254.42c0,0.0868-0.0434,0.43321-0.0434,0.52006,0.0434,0.26055,0.25951,0.3474,0.30294,0.65137,0.13027,0.73718-0.0434,1.2149-0.0868,2.1692' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m476.26,255.29c0.21609,0.91088,0.0434,1.6491-0.0868,2.5166-0.0434,0,0.0868,0,0.0868-0.0434' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m476.13,256.81c-0.12924,0.34636-0.12924,0.56348-0.17266,0.9543-0.0434-0.0434-0.21713,0.13028-0.26055,0.0869' stroke-width='0.13017058' fill='none'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23g2' transform='matrix(-1,0,0,1,1030.0498,0)'/%3E %3C/g%3E %3Cg%3E %3Cpath d='M87.035,32.69,38.397,114.06,135.71,114.06,135.71,114.06z' fill='%23fc0' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.41960001' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M87.035,37.978,43.14,111.42,130.97,111.42,130.97,111.42z' fill='%23fff' stroke='%23fff' stroke-miterlimit='2.61310005' stroke-width='0.1259' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M56.148,89.594,56.148,89.594,43.14,111.42,130.97,111.42,117.92,89.594z' fill='%23007e93' stroke='%23007e93' stroke-miterlimit='2.61310005' stroke-width='0.2518' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cg stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m507.11,266.09c2.1268-1.9096,4.7292-2.6903,7.7668-2.7337h0.21712c2.9508,0.0434,5.945,0.73718,7.8526,2.7337' stroke='%23086aad'/%3E %3Cpath d='m507.06,266.18c2.0823-1.9531,4.7726-2.6903,7.8102-2.7337h0.21712c3.0366,0,6.0309,0.73719,7.9395,2.7771' stroke='%230863aa'/%3E %3Cpath d='m507.02,266.31c2.0823-2.0389,4.816-2.7771,7.8971-2.8205h0.21713c3.0366,0.0434,6.0743,0.78061,7.9829,2.864' stroke='%23095fa8'/%3E %3Cpath d='m506.93,266.4c2.0834-2.0389,4.9028-2.8205,7.9839-2.8205h0.26055c3.08,0,6.1177,0.78061,8.0263,2.9508' stroke='%230a58a5'/%3E %3Cpath d='m506.89,266.48c2.0399-2.0823,4.9463-2.8205,8.0708-2.864h0.21712c3.1669,0.0434,6.2035,0.82404,8.1132,3.0377' stroke='%230a52a2'/%3E %3Cpath d='m506.81,266.57c2.0389-2.1257,4.9897-2.864,8.1566-2.864h0.26055c3.2103,0.0434,6.2469,0.82404,8.2,3.08' stroke='%230b4d9f'/%3E %3Cpath d='m506.76,266.7c2.0389-2.1692,5.0331-2.9508,8.2434-2.9508h0.21713c3.2972,0.0434,6.2904,0.86746,8.2869,3.1669' stroke='%230c479d'/%3E %3Cpath d='m506.2,267.61c2.3863-2.5166,5.3371-3.2538,8.8514-3.2538h0.21609c3.8617,0.0434,7.1599,1.3451,9.0685,4.0354' stroke='%23270a7f'/%3E %3Cpath d='m506.24,267.48c2.3429-2.4297,5.2937-3.1669,8.808-3.2103h0.21609c3.7748,0.0434,7.0296,1.3017,8.9827,3.9486' stroke='%23241183'/%3E %3Cpath d='m506.33,267.39c2.2994-2.4297,5.2068-3.1669,8.6777-3.1669h0.21713c3.7314,0.0434,6.9852,1.2148,8.9382,3.8617' stroke='%23221786'/%3E %3Cpath d='m506.37,267.31c2.256-2.3863,5.2068-3.1235,8.5908-3.1669h0.21712c3.688,0.0434,6.8983,1.1714,8.8948,3.7748' stroke='%231f1f8a'/%3E %3Cpath d='m506.46,267.18c2.1692-2.2994,5.12-3.08,8.504-3.08h0.1737c3.6446,0,6.8549,1.0412,8.8514,3.6446' stroke='%231a258d'/%3E %3Cpath d='m506.5,267.09c2.1257-2.3005,5.12-3.0377,8.4171-3.08h0.21713c3.5577,0.0434,6.768,0.99773,8.7211,3.5577' stroke='%23172d91'/%3E %3Cpath d='m506.54,267c2.0823-2.257,5.0766-3.0377,8.3303-3.0377h0.21712c3.5143,0,6.6812,0.91088,8.6777,3.4274' stroke='%23143393'/%3E %3Cpath d='m506.63,266.87c2.0389-2.2136,5.0331-2.9508,8.2434-2.9942h0.1737c3.4709,0,6.6378,0.86746,8.6343,3.384' stroke='%23113b97'/%3E %3Cpath d='m510.01,261.15c1.4754-1.0412,3.0377-1.3451,4.9897-1.3451,1.8662,0,3.5143,0.30397,4.9463,1.2583' stroke='%23ff0a00'/%3E %3Cpath d='m509.97,261.23c1.4754-1.0412,3.08-1.3451,5.0331-1.3451,1.8662,0,3.5577,0.30294,4.9897,1.2583' stroke='%23F10'/%3E %3Cpath d='m509.93,261.32c1.5188-1.0412,3.1235-1.3886,5.0766-1.3886,1.8662,0,3.6012,0.34636,5.0766,1.3017' stroke='%23ff1500'/%3E %3Cpath d='m509.89,261.45c1.5188-1.0846,3.1235-1.432,5.12-1.432,1.9086,0,3.6446,0.34636,5.12,1.3017' stroke='%23ff1a00'/%3E %3Cpath d='m509.84,261.54c1.5188-1.0846,3.1669-1.431,5.1634-1.431,1.9086,0,3.688,0.34637,5.1634,1.3017' stroke='%23ff2000'/%3E %3Cpath d='m509.8,261.62c1.5188-1.0846,3.2103-1.4754,5.2068-1.4754,1.9086,0,3.7314,0.39082,5.2068,1.3886' stroke='%23ff2700'/%3E %3Cpath d='m509.75,261.71c1.5188-1.0846,3.2103-1.4754,5.2502-1.4754,1.9086,0,3.7748,0.39082,5.2502,1.3886' stroke='%23ff2f00'/%3E %3Cpath d='m509.71,261.8c1.5188-1.128,3.2538-1.4754,5.2937-1.4754,1.952,0,3.8183,0.39082,5.3371,1.3886' stroke='%23F30'/%3E %3Cpath d='m509.67,261.88c1.5188-1.128,3.2972-1.5188,5.3371-1.5188,1.952,0,3.8617,0.43424,5.3805,1.432' stroke='%23ff3c00'/%3E %3Cpath d='m509.62,261.97c1.5622-1.128,3.3406-1.5188,5.3805-1.5188,1.952,0,3.9051,0.43424,5.424,1.432' stroke='%23ff4100'/%3E %3Cpath d='m509.58,262.06c1.5622-1.128,3.3406-1.5188,5.4239-1.5188,1.9955,0,3.9485,0.43425,5.4674,1.432' stroke='%23ff4600'/%3E %3Cpath d='m508.41,264.01c1.6915-1.3017,4.3818-1.9531,6.6378-1.9531,2.3863,0,4.9897,0.65034,6.6812,1.9965' stroke='%23fff500'/%3E %3Cpath d='m508.5,263.88c1.6481-1.3017,4.2949-1.9096,6.5509-1.9096,2.3429,0,4.9028,0.60691,6.5944,1.9965' stroke='%23ffeb00'/%3E %3Cpath d='m508.54,263.79c1.6925-1.3017,4.2515-1.9096,6.5075-1.9096,2.2994,0,4.8594,0.60691,6.5509,1.9531' stroke='%23ffe000'/%3E %3Cpath d='m508.63,263.66c1.6491-1.2583,4.1657-1.8652,6.4217-1.8652,2.2994,0,4.816,0.60691,6.4641,1.9086' stroke='%23ffd600'/%3E %3Cpath d='m508.67,263.58c1.6491-1.2583,4.1222-1.8652,6.3783-1.8652,2.256,0,4.7302,0.60691,6.4206,1.8652' stroke='%23ffcf00'/%3E %3Cpath d='m508.76,263.45c1.6491-1.2583,4.0788-1.8228,6.2914-1.8228,2.256,0,4.6868,0.56452,6.3338,1.8662' stroke='%23ffc400'/%3E %3Cpath d='m508.8,263.36c1.6491-1.2583,4.0354-1.8228,6.248-1.8228s4.5999,0.56452,6.2469,1.8228' stroke='%23ffba00'/%3E %3Cpath d='m508.89,263.23c1.6057-1.2149,3.9485-1.7783,6.1611-1.7783s4.5565,0.56348,6.2035,1.7783' stroke='%23ffb000'/%3E %3Cpath d='m508.93,263.14c1.6491-1.2583,3.9051-1.7794,6.1177-1.7794,2.1692,0,4.5131,0.56349,6.1177,1.7794' stroke='%23ffa600'/%3E %3Cpath d='m509.02,263.01c1.6057-1.2148,3.8183-1.736,6.0309-1.736,2.1257,0,4.4262,0.5211,6.0308,1.736' stroke='%23ff9c00'/%3E %3Cpath d='m509.06,262.93c1.6057-1.2148,3.8183-1.736,5.9874-1.736,2.1257,0,4.3828,0.5211,5.9885,1.6925' stroke='%23ff9100'/%3E %3Cpath d='m509.15,262.79c1.6057-1.1714,3.7314-1.6925,5.9016-1.6925,2.0823,0,4.3394,0.52006,5.9016,1.6491' stroke='%23ff8700'/%3E %3Cpath d='m509.19,262.71c1.6057-1.2149,3.688-1.6925,5.8572-1.6925,2.0823,0,4.2525,0.52006,5.8582,1.6491' stroke='%23ff7d00'/%3E %3Cpath d='m509.28,262.58c1.5612-1.1714,3.6011-1.6481,5.7703-1.6481,2.0389,0,4.2091,0.52006,5.7713,1.6046' stroke='%23ff7500'/%3E %3Cpath d='m509.32,262.49c1.6046-1.1714,3.5577-1.6481,5.7269-1.6481,2.0389,0,4.1222,0.47663,5.6845,1.5622' stroke='%23ff6b00'/%3E %3Cpath d='m509.41,262.36c1.5612-1.1714,3.5143-1.6057,5.64-1.6057,1.9955,0,4.0788,0.47664,5.6411,1.5623' stroke='%23ff6100'/%3E %3Cpath d='m509.45,262.27c1.6057-1.1714,3.4709-1.6057,5.5976-1.6057,1.952,0,4.0354,0.47664,5.5542,1.5188' stroke='%23ff5700'/%3E %3Cpath d='m508.19,264.23c1.7783-1.3886,4.512-2.0389,6.8549-2.0389,2.4297,0,5.0766,0.69376,6.8115,2.0823' stroke='%23ebf605'/%3E %3Cpath d='m508.15,264.36c1.8652-1.4754,4.512-2.0823,6.8983-2.0823,2.4297,0,5.1634,0.69376,6.8983,2.1257' stroke='%23d6ec09'/%3E %3Cpath d='m508.06,264.49c1.952-1.5623,4.512-2.1692,6.9852-2.1692,2.4731,0,5.2068,0.73719,6.9417,2.1692' stroke='%23c2e30e'/%3E %3Cpath d='m507.98,264.62c2.0823-1.6491,4.5554-2.2126,7.072-2.2126,2.4731,0,5.2502,0.73719,6.9852,2.2126' stroke='%23add912'/%3E %3Cpath d='m507.93,264.75c2.1257-1.6915,4.5565-2.256,7.072-2.256,2.56,0,5.3371,0.73718,7.1154,2.2126' stroke='%2399cf16'/%3E %3Cpath d='m507.85,264.88c2.256-1.7794,4.5565-2.3439,7.1589-2.3439,2.6034,0,5.4239,0.78061,7.1589,2.3005' stroke='%2385c61a'/%3E %3Cpath d='m507.8,265.01c2.2994-1.8652,4.5565-2.3863,7.2023-2.3863,2.6034,0,5.4674,0.78061,7.2457,2.3005' stroke='%2370bc1f'/%3E %3Cpath d='m507.71,265.14c2.4297-1.952,4.5999-2.4731,7.2891-2.4731,2.6468,0,5.5108,0.82404,7.2891,2.3863' stroke='%235cb323'/%3E %3Cpath d='m507.63,265.22c2.5166-1.9965,4.5989-2.4731,7.376-2.4731,2.6468,0,5.5542,0.82404,7.376,2.3863' stroke='%2347a928'/%3E %3Cpath d='m507.24,265.92c2.2126-1.952,4.7726-2.6468,7.8102-2.6468,2.864,0,5.8582,0.73822,7.7668,2.6034' stroke='%230d74a4'/%3E %3Cpath d='m507.28,265.87c2.256-1.9955,4.7292-2.6903,7.7668-2.6903,2.864,0,5.8148,0.78061,7.7234,2.6034' stroke='%23127a97'/%3E %3Cpath d='m507.33,265.79c2.2994-1.9955,4.7292-2.6468,7.7234-2.6468,2.8205,0,5.8148,0.78061,7.68,2.56' stroke='%2317808b'/%3E %3Cpath d='m507.37,265.7c2.3429-1.9955,4.6857-2.6034,7.68-2.6034,2.7771,0,5.7713,0.78061,7.5931,2.5166' stroke='%231a847d'/%3E %3Cpath d='m507.41,265.66c2.3863-2.0389,4.6857-2.6468,7.5931-2.6468,2.8205,0,5.7714,0.82403,7.5921,2.5166' stroke='%231e8a6d'/%3E %3Cpath d='m507.46,265.57c2.4297-2.0389,4.6423-2.6034,7.5497-2.6034,2.7771,0,5.7279,0.82404,7.5497,2.5166' stroke='%23238f5e'/%3E %3Cpath d='m507.5,265.53c2.4731-2.0823,4.6423-2.6034,7.5063-2.6034,2.7337,0,5.6845,0.82403,7.5063,2.4731' stroke='%232b944e'/%3E %3Cpath d='m507.54,265.44c2.5166-2.0833,4.5989-2.56,7.4628-2.56,2.6903,0,5.6845,0.82403,7.4628,2.4297' stroke='%232f9b3e'/%3E %3Cpath d='m519.91,260.97c-1.432-0.95431-3.08-1.2583-4.9028-1.2583-1.9531,0-3.4709,0.3474-4.9463,1.3451' stroke='%23F00'/%3E %3Cpath d='m524.46,268.57c-1.9955-2.8205-5.3795-4.1657-9.3715-4.1657-3.6011,0-6.5075,0.78061-8.9817,3.2972' stroke='%232a007c'/%3E %3Cpath d='m522.86,265.92c-1.9086-1.8652-4.9018-2.6034-7.8092-2.6034-3.08,0-5.6835,0.73822-7.8526,2.6903' stroke='%230671b0'/%3E %3Cpath d='m523.6,267.09c-2.0399-2.4731-5.1634-3.2538-8.5908-3.2538-3.2103,0-6.2914,0.73719-8.3303,2.9508' stroke='%230c419a'/%3E %3Cpath d='m521.82,264.18c-1.736-1.3886-4.3818-2.0399-6.768-2.0399-2.2994,0-5.0766,0.65033-6.768,1.952' stroke='%23FF0'/%3E %3Cpath d='m520.51,262.06c-1.5188-0.99773-3.5143-1.4754-5.5108-1.4754-2.0823,0-3.9051,0.43321-5.4674,1.6057' stroke='%23ff4d00'/%3E %3Cpath d='m522.42,265.22c-1.7794-1.5622-4.7292-2.4297-7.4194-2.4297-2.8205,0-4.8594,0.47664-7.4194,2.56' stroke='%2333a02c'/%3E %3C/g%3E %3Cg stroke-width='0.17359523' stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m505.81,268.13c2.8205-1.3886,5.7714-2.256,9.1978-2.256,3.2538,0,6.7246,1.2149,9.4583,2.6903l9.632,16.097c0,10.543-8.5908,19.264-19.09,19.264-10.543,0-19.047-8.504-19.134-19.177l9.936-16.618z' stroke='%23fef2ec'/%3E %3Cpath d='m515.01,266.09c3.2103,0,6.6378,1.2583,9.328,2.6903,0.0434,0,9.5017,15.837,9.5017,15.88,0,10.369-8.4606,19.003-18.83,19.003-10.413,0-18.786-8.3737-18.873-18.917,0-0.0434,9.7623-16.358,9.8057-16.358,2.7761-1.3875,5.6835-2.2994,9.0675-2.2994z' stroke='%23fef2ea'/%3E %3Cpath d='m514.96,266.61c3.1669,0,6.5075,1.1714,9.1119,2.6034,0.0868,0.0434,9.2412,15.315,9.2412,15.446,0,10.109-8.2445,18.526-18.353,18.526-10.066,0-18.266-8.2-18.31-18.439,0-0.13027,9.4149-15.88,9.5017-15.923,2.7337-1.3451,5.5532-2.2126,8.808-2.2126z' stroke='%23fef0e6'/%3E %3Cpath d='m514.96,267.13c3.0811,0,6.3338,1.128,8.8514,2.5166,0.1737,0.0869,9.0251,14.839,9.0251,15.056,0,9.8057-8.0274,17.963-17.876,17.963-9.8057,0-17.746-7.9405-17.833-17.92,0-0.21712,9.1119-15.36,9.2846-15.489,2.6479-1.3027,5.3805-2.1268,8.5485-2.1268z' stroke='%23feede3'/%3E %3Cpath d='m514.96,267.87c2.9508,0,6.0743,1.0846,8.504,2.4297,0.26055,0.1737,8.5919,14.058,8.5919,14.406,0,9.3715-7.681,17.182-17.096,17.182-9.3715,0-17.008-7.5931-17.051-17.138,0-0.3474,8.5474-14.665,8.8514-14.795,2.5166-1.2593,5.2058-2.0834,8.2-2.0834z' stroke='%23fee8dc'/%3E %3Cpath d='m514.96,268.39c2.864,0,5.9016,1.0412,8.2434,2.3429,0.3474,0.21609,8.3313,13.537,8.3313,13.971,0,9.1119-7.4628,16.704-16.575,16.704-9.1119,0-16.488-7.4184-16.53-16.661,0-0.43424,8.2-14.145,8.5908-14.362,2.4287-1.2138,5.0321-1.9955,7.9395-1.9955z' stroke='%23fee6d5'/%3E %3Cpath d='m514.96,269.13c2.7337,0,5.6411,1.0412,7.8537,2.256,0.47663,0.26055,7.9395,12.755,7.9395,13.32,0,8.7211-7.072,15.923-15.793,15.923-8.6777,0-15.75-7.0286-15.793-15.837,0-0.60795,7.7224-13.45,8.2-13.754,2.3429-1.1714,4.816-1.9086,7.5931-1.9086z' stroke='%23fee3cf'/%3E %3Cpath d='m514.96,269.65c2.6903,0,5.4239,0.95431,7.6355,2.1692,0.5211,0.30397,7.681,12.235,7.681,12.887,0,8.4172-6.8994,15.402-15.316,15.402-8.4172,0-15.229-6.8125-15.272-15.315,0-0.6948,7.376-12.974,7.8971-13.277,2.2984-1.1714,4.6847-1.8662,7.375-1.8662z' stroke='%23fee0cc'/%3E %3Cpath d='m514.96,270.17c2.6034,0,5.2502,0.91088,7.376,2.0823,0.56452,0.34637,7.4194,11.758,7.4194,12.496,0,8.1132-6.6388,14.882-14.795,14.882-8.1132,0-14.709-6.5943-14.752-14.839,0-0.78164,7.0286-12.496,7.6365-12.843,2.1681-1.0846,4.512-1.7783,7.1154-1.7783z' stroke='%23fedec6'/%3E %3Cpath d='m514.96,273.47c2.0389,0,4.0788,0.69479,5.7279,1.6057,1.0412,0.60691,5.7269,8.4171,5.7269,9.7188,0,6.2904-5.12,11.498-11.455,11.498-6.2914,0-11.411-5.12-11.455-11.498,0-1.3017,4.816-9.328,5.9016-9.936,1.6915-0.86746,3.5143-1.3886,5.5532-1.3886z' stroke='%23fdcdaa'/%3E %3Cpath d='m514.96,273.69c1.9955,0,3.992,0.69376,5.5976,1.6057,1.0846,0.65034,5.5966,8.1566,5.5966,9.5017,0,6.1611-5.0321,11.238-11.194,11.238-6.1611,0-11.194-4.9897-11.194-11.194,0-1.3886,4.6423-9.1119,5.7703-9.7623,1.6491-0.86746,3.4285-1.3886,5.424-1.3886z' stroke='%23fdcdaa'/%3E %3Cpath d='m514.96,274.94c1.7794,0,3.5577,0.60691,4.9897,1.432,1.2593,0.73719,4.9463,6.8549,4.9463,8.4172,0,5.4663-4.4686,9.9784-9.936,9.9784s-9.8926-4.4252-9.936-9.936c0-1.6057,3.8183-7.896,5.12-8.6343,1.432-0.77958,3.0366-1.2572,4.816-1.2572z' stroke='%23fdc59e'/%3E %3Cpath d='m514.96,275.2c1.736,0,3.4709,0.56349,4.8594,1.3886,1.3027,0.78061,4.816,6.5943,4.816,8.201,0,5.3371-4.3383,9.7188-9.6754,9.7188s-9.6754-4.2959-9.6754-9.6754c0-1.6491,3.6446-7.6365,4.9897-8.4172,1.3886-0.73925,2.9498-1.2159,4.6857-1.2159z' stroke='%23fdc59e'/%3E %3Cpath d='m515.01,266.35c3.1669,0,6.5509,1.2149,9.1988,2.6468,0.0434,0.0434,9.3704,15.576,9.3704,15.663,0,10.24-8.3737,18.786-18.569,18.786-10.24,0-18.57-8.3303-18.614-18.699,0-0.0868,9.5886-16.097,9.632-16.141,2.7771-1.3886,5.6411-2.256,8.9817-2.256z' stroke='%23fef0e9'/%3E %3Cpath d='m514.96,266.87c3.1245,0,6.4206,1.1714,8.9817,2.56,0.13028,0.0868,9.1543,15.099,9.1543,15.273,0,9.9349-8.1576,18.223-18.137,18.223-9.936,0-18.006-8.0698-18.093-18.179,0-0.1737,9.2846-15.619,9.4149-15.706,2.6913-1.3462,5.4674-2.1702,8.6787-2.1702z' stroke='%23feede3'/%3E %3Cpath d='m514.96,267.39c3.0377,0,6.248,1.128,8.7211,2.4731,0.21712,0.13028,8.8948,14.578,8.8948,14.839,0,9.6754-7.9405,17.703-17.616,17.703-9.6754,0-17.486-7.8536-17.573-17.659,0-0.26054,8.8948-15.143,9.1119-15.273,2.6458-1.3017,5.3361-2.0823,8.4606-2.0823z' stroke='%23feebdf'/%3E %3Cpath d='m514.96,267.61c2.9942,0,6.1611,1.128,8.6343,2.4731,0.21712,0.13027,8.7211,14.318,8.7211,14.622,0,9.5452-7.8102,17.442-17.355,17.442-9.5017,0-17.225-7.7234-17.312-17.399,0-0.30397,8.7211-14.882,8.9817-15.056,2.56-1.2583,5.2492-2.0823,8.3303-2.0823z' stroke='%23feebdd'/%3E %3Cpath d='m514.96,268.13c2.9074,0,5.9885,1.0846,8.3737,2.3863,0.30397,0.1737,8.4616,13.798,8.4616,14.188,0,9.2412-7.5497,16.921-16.835,16.921-9.2412,0-16.747-7.4628-16.791-16.878,0-0.39082,8.3737-14.406,8.7211-14.578,2.4731-1.2593,5.1189-2.0399,8.0698-2.0399z' stroke='%23fee8d9'/%3E %3Cpath d='m514.96,268.65c2.8205,0,5.8148,1.0412,8.1132,2.2994,0.39082,0.21712,8.2011,13.277,8.2011,13.754,0,8.9817-7.3326,16.444-16.314,16.444-8.9382,0-16.227-7.2891-16.314-16.358,0-0.5211,8.0708-13.971,8.4606-14.188,2.4297-1.2149,4.9897-1.952,7.8537-1.952z' stroke='%23fee6d3'/%3E %3Cpath d='m514.96,268.91c2.7771,0,5.7279,0.99773,7.9829,2.256,0.43424,0.26055,8.0708,13.016,8.0708,13.537,0,8.8514-7.2023,16.183-16.054,16.183-8.808,0-15.967-7.1589-16.054-16.096,0-0.56452,7.8971-13.711,8.3303-13.971,2.3863-1.1714,4.9028-1.9086,7.7234-1.9086z' stroke='%23fee3d2'/%3E %3Cpath d='m514.96,269.39c2.7337,0,5.5108,0.99774,7.7234,2.2136,0.52006,0.30294,7.8526,12.495,7.8526,13.103,0,8.5908-7.0286,15.663-15.576,15.663s-15.489-6.9417-15.533-15.576c0-0.65137,7.5497-13.233,8.0708-13.494,2.2984-1.1714,4.7281-1.9096,7.4618-1.9096z' stroke='%23fee0cc'/%3E %3Cpath d='m514.96,269.91c2.6468,0,5.3371,0.95431,7.5063,2.1257,0.52006,0.3474,7.5497,12.018,7.5497,12.713,0,8.2434-6.7691,15.099-15.056,15.099-8.2434,0-14.969-6.6812-15.013-15.056,0-0.73822,7.2023-12.757,7.7658-13.06,2.2136-1.127,4.5999-1.8218,7.2468-1.8218z' stroke='%23fedec8'/%3E %3Cpath d='m514.96,270.43c2.56,0,5.1634,0.91089,7.2457,2.0389,0.60795,0.39082,7.2891,11.498,7.2891,12.279,0,7.9829-6.552,14.622-14.535,14.622-7.9839,0-14.448-6.5085-14.491-14.578,0-0.82404,6.8549-12.235,7.5063-12.626,2.1247-1.0836,4.4252-1.7349,6.9852-1.7349z' stroke='%23fddbc5'/%3E %3Cpath d='m514.96,270.65c2.5166,0,5.0766,0.91088,7.1154,2.0389,0.65137,0.39082,7.1589,11.238,7.1589,12.063,0,7.8526-6.4206,14.361-14.274,14.361-7.8537,0-14.232-6.3782-14.274-14.318,0-0.86746,6.7246-12.019,7.4194-12.409,2.0813-1.0422,4.3383-1.736,6.8549-1.736z' stroke='%23fddbc2'/%3E %3Cpath d='m514.96,270.91c2.4731,0,4.9897,0.86746,6.9852,1.9965,0.6948,0.43321,7.0296,10.977,7.0296,11.846,0,7.7224-6.2914,14.101-14.015,14.101-7.7234,0-13.97-6.248-14.014-14.057,0-0.91088,6.5509-11.759,7.2457-12.192,2.0823-1.0422,4.2949-1.6936,6.768-1.6936z' stroke='%23fdd9bf'/%3E %3Cpath d='m514.96,271.17c2.4297,0,4.9028,0.86746,6.8549,1.9531,0.73822,0.43321,6.8994,10.717,6.8994,11.628,0,7.5931-6.1611,13.84-13.754,13.84-7.5497,0-13.711-6.1177-13.754-13.797,0-0.95431,6.3783-11.498,7.1154-11.932,2.0389-1.0422,4.2091-1.6925,6.6388-1.6925z' stroke='%23fdd9bf'/%3E %3Cpath d='m514.96,271.43c2.3863,0,4.817,0.82403,6.7246,1.9086,0.78164,0.47768,6.7691,10.457,6.7691,11.411,0,7.4194-6.0743,13.581-13.494,13.581-7.4194,0-13.45-6.0309-13.494-13.537,0-0.99773,6.2046-11.281,6.9852-11.715,1.9955-1.0412,4.1222-1.6481,6.5085-1.6481z' stroke='%23fdd6bc'/%3E %3Cpath d='m514.96,271.69c2.3429,0,4.7302,0.82404,6.5943,1.8662,0.82507,0.47664,6.6388,10.197,6.6388,11.194,0,7.2891-5.944,13.32-13.233,13.32-7.2891,0-13.19-5.9006-13.233-13.277,0-1.0412,5.9874-11.021,6.8559-11.498,1.951-0.99773,4.0344-1.6057,6.3772-1.6057z' stroke='%23fdd6b9'/%3E %3Cpath d='m514.96,271.95c2.2994,0,4.6433,0.78061,6.5075,1.8228,0.82507,0.52006,6.5085,9.936,6.5085,10.977,0,7.1589-5.8572,13.103-13.016,13.103-7.1589,0-12.929-5.8137-12.973-13.059,0-1.0846,5.8137-10.804,6.6812-11.281,1.952-0.99773,3.992-1.5622,6.2914-1.5622z' stroke='%23fdd4b8'/%3E %3Cpath d='m514.96,272.17c2.256,0,4.5565,0.82404,6.3772,1.8218,0.86849,0.5211,6.3782,9.6754,6.3782,10.761,0,7.0286-5.7269,12.842-12.755,12.842-7.0286,0-12.712-5.6845-12.712-12.799,0-1.128,5.64-10.544,6.5509-11.064,1.9086-0.95431,3.9051-1.5623,6.1611-1.5623z' stroke='%23fdd4b6'/%3E %3Cpath d='m514.96,272.43c2.2126,0,4.4696,0.78061,6.248,1.7783,0.91088,0.5211,6.247,9.4149,6.247,10.544,0,6.8983-5.64,12.582-12.495,12.582-6.8549,0-12.453-5.5966-12.496-12.538,0-1.128,5.5108-10.283,6.4651-10.848,1.8218-0.90985,3.8183-1.5178,6.0309-1.5178z' stroke='%23fdd2b2'/%3E %3Cpath d='m514.96,272.69c2.1692,0,4.3828,0.73718,6.1177,1.736,0.95431,0.56349,6.1177,9.1543,6.1177,10.37,0,6.7246-5.5108,12.279-12.235,12.279-6.7246,0-12.192-5.4674-12.235-12.279,0-1.1714,5.3371-10.066,6.3348-10.587,1.7784-0.95431,3.7314-1.5188,5.9006-1.5188z' stroke='%23fdd1b0'/%3E %3Cpath d='m514.96,272.95c2.1257,0,4.2525,0.73718,5.9885,1.6925,0.99774,0.56349,5.9874,8.8948,5.9874,10.153,0,6.5944-5.3805,12.018-11.976,12.018-6.5954,0-11.931-5.3371-11.975-12.018,0-1.2148,5.1634-9.8057,6.2046-10.37,1.7349-0.91192,3.6446-1.4754,5.7703-1.4754z' stroke='%23fdd0b0'/%3E %3Cpath d='m514.96,273.21c2.0823,0,4.1657,0.69377,5.8582,1.6481,1.0412,0.60795,5.8572,8.6777,5.8572,9.936,0,6.4206-5.2502,11.758-11.715,11.758-6.4651,0-11.672-5.2068-11.714-11.758,0-1.2583,4.9897-9.5452,6.0309-10.153,1.7349-0.91088,3.6011-1.431,5.6835-1.431z' stroke='%23fdd0ad'/%3E %3Cpath d='m514.96,273.95c1.952,0,3.9051,0.65137,5.5108,1.5622,1.0846,0.65034,5.424,7.896,5.424,9.2846,0,6.0309-4.9028,11.021-10.935,11.021-6.0309,0-10.934-4.9028-10.934-10.977,0-1.432,4.4686-8.8948,5.64-9.5452,1.6057-0.82507,3.3406-1.3451,5.2937-1.3451z' stroke='%23fdcaa6'/%3E %3Cpath d='m514.96,274.21c1.9096,0,3.8183,0.65033,5.3805,1.5188,1.128,0.69479,5.2937,7.6365,5.2937,9.0685,0,5.9006-4.7726,10.76-10.674,10.76-5.9006,0-10.673-4.7726-10.717-10.717,0-1.4754,4.3394-8.6343,5.5108-9.328,1.6046-0.8261,3.2961-1.3027,5.2058-1.3027z' stroke='%23fdcaa4'/%3E %3Cpath d='m514.96,274.47c1.8662,0,3.7314,0.60691,5.2502,1.4754,1.1714,0.69376,5.2068,7.376,5.2068,8.8514,0,5.7703-4.6857,10.499-10.457,10.499-5.7703,0-10.413-4.6857-10.456-10.457,0-1.5188,4.1646-8.3737,5.3805-9.0685,1.5612-0.823,3.2093-1.3007,5.0755-1.3007z' stroke='%23fdc8a4'/%3E %3Cpath d='m514.96,274.73c1.8228,0,3.6446,0.60691,5.12,1.431,1.2149,0.73822,5.0766,7.1154,5.0766,8.6353,0,5.64-4.5989,10.239-10.197,10.239-5.5966,0-10.153-4.5554-10.197-10.197,0-1.5622,3.992-8.1566,5.2502-8.8514,1.5188-0.77958,3.1235-1.2572,4.9463-1.2572z' stroke='%23fdc8a1'/%3E %3Cpath d='m514.96,275.46c1.6925,0,3.384,0.56349,4.7302,1.3451,1.3451,0.78061,4.6847,6.3338,4.6847,7.9839,0,5.2068-4.2081,9.4583-9.4149,9.4583s-9.4149-4.2081-9.4149-9.4149c0-1.6925,3.4709-7.4194,4.816-8.2,1.3875-0.73925,2.9064-1.1725,4.5989-1.1725z' stroke='%23fdc39b'/%3E %3Cpath d='m514.96,275.72c1.6491,0,3.2972,0.5211,4.5999,1.3017,1.3886,0.82403,4.5554,6.0743,4.5554,7.8102,0,5.0331-4.1222,9.1988-9.1554,9.1988-5.0766,0-9.1543-4.1222-9.1543-9.1988,0-1.7349,3.2972-7.1589,4.6857-7.9829,1.3441-0.69479,2.8195-1.129,4.4686-1.129z' stroke='%23fdc398'/%3E %3Cpath d='m514.96,275.98c1.6057,0,3.2103,0.52006,4.5131,1.2583,1.3886,0.82404,4.3818,5.8137,4.3818,7.5921,0,4.9028-3.992,8.9382-8.8948,8.9382s-8.8948-3.9909-8.8948-8.9382c0-1.7783,3.08-6.9417,4.5565-7.7668,1.3007-0.69273,2.7326-1.0836,4.3383-1.0836z' stroke='%23fdc097'/%3E %3Cpath d='m514.96,276.25c1.5622,0,3.1245,0.47664,4.3828,1.2149,1.432,0.86745,4.2515,5.5976,4.2515,7.376,0,4.7726-3.8607,8.6777-8.6343,8.6777-4.7726,0-8.6343-3.8617-8.6777-8.6777,0-1.8218,2.9508-6.6812,4.4686-7.5063,1.2583-0.69376,2.6468-1.0846,4.2091-1.0846z' stroke='%23fdc095'/%3E %3Cpath d='m514.96,276.46c1.5188,0,2.9942,0.52006,4.2525,1.2149,1.4754,0.86746,4.1212,5.3371,4.1212,7.1589,0,4.6423-3.7304,8.4182-8.3737,8.4182-4.6423,0-8.3737-3.7748-8.4172-8.4182,0-1.8652,2.7771-6.4206,4.2949-7.2891,1.2583-0.65033,2.6034-1.0846,4.1222-1.0846z' stroke='%23fdbe92'/%3E %3Cpath d='m514.96,276.72c1.4754,0,2.9074,0.47664,4.1222,1.1714,1.4754,0.91089,3.9909,5.0766,3.9909,6.9417,0,4.4686-3.6435,8.1576-8.1132,8.1576-4.512,0-8.1566-3.6446-8.1566-8.1576,0-1.9086,2.6034-6.2046,4.1646-7.072,1.2149-0.65137,2.5166-1.0412,3.992-1.0412z' stroke='%23fdbe90'/%3E %3Cpath d='m514.96,276.98c1.432,0,2.8205,0.43425,3.992,1.128,1.5188,0.91089,3.9041,4.816,3.9041,6.7246,0,4.3394-3.5567,7.8971-7.896,7.8971-4.3383,0-7.8971-3.5143-7.8971-7.8971,0-1.952,2.4297-5.944,4.0354-6.8549,1.1714-0.60691,2.4297-0.99774,3.8617-0.99774z' stroke='%23fdbb8f'/%3E %3Cpath d='m514.96,277.24c1.3886,0,2.7337,0.43321,3.8617,1.0846,1.5622,0.95431,3.7738,4.5555,3.7738,6.5075,0,4.2091-3.4264,7.6365-7.6355,7.6365-4.2081,0-7.6365-3.384-7.6365-7.6365,0-1.9955,2.256-5.6835,3.9051-6.6378,1.0846-0.60691,2.3429-0.95431,3.7314-0.95431z' stroke='%23fdbb8d'/%3E %3Cpath d='m514.96,277.5c1.3451,0,2.6468,0.38979,3.7314,1.0412,1.6057,0.95431,3.6446,4.2949,3.6446,6.2904,0,4.0788-3.2972,7.4194-7.376,7.4194s-7.376-3.3406-7.376-7.4194c0-2.0389,2.0823-5.4663,3.7748-6.4206,1.0412-0.56452,2.256-0.91088,3.6012-0.91088z' stroke='%23fdb98a'/%3E %3Cpath d='m514.96,277.76c1.3017,0,2.56,0.38979,3.6011,0.99773,1.6491,0.99773,3.5143,4.0354,3.5143,6.0743,0,3.9486-3.2103,7.1589-7.1154,7.1589-3.9485,0-7.1154-3.2103-7.1154-7.1589,0-2.0823,1.9096-5.2068,3.6011-6.1611,1.0412-0.60794,2.2126-0.91088,3.5143-0.91088z' stroke='%23fdb98a'/%3E %3Cpath d='m514.96,277.98c1.2583,0,2.4731,0.39082,3.5143,0.99773,1.6491,0.99773,3.3406,3.7748,3.3406,5.8572,0,3.8183-3.08,6.8994-6.8549,6.8994-3.8183,0-6.8549-3.08-6.8983-6.8994,0-2.1257,1.7794-4.9897,3.5143-5.944,0.99773-0.56349,2.1257-0.91088,3.384-0.91088z' stroke='%23fcb687'/%3E %3Cpath d='m514.96,278.24c1.2148,0,2.3863,0.34739,3.384,0.9543,1.6925,1.0412,3.2103,3.5143,3.2103,5.64,0,3.688-2.9508,6.6388-6.5943,6.6388s-6.6378-2.9508-6.6378-6.6388c0-2.1692,1.6057-4.7292,3.384-5.7269,0.95431-0.56348,2.0389-0.86745,3.2538-0.86745z' stroke='%23fcb685'/%3E %3Cpath d='m514.96,278.5c1.1714,0,2.2994,0.34637,3.2537,0.91089,1.736,1.0412,3.08,3.2537,3.08,5.4229,0,3.5143-2.8205,6.3782-6.3338,6.3782s-6.3772-2.864-6.3772-6.3348c0-2.256,1.4309-4.512,3.2537-5.5532,0.91089-0.52006,1.952-0.82404,3.1235-0.82404z' stroke='%23fcb485'/%3E %3Cpath d='m514.96,290.95c3.3406,0,6.0743-2.7337,6.0743-6.0743,0-3.384-2.7347-6.1177-6.0743-6.1177-3.384,0-6.1177,2.7337-6.1177,6.1177,0,3.3406,2.7337,6.0743,6.1177,6.0743z' stroke='%23fcb482'/%3E %3C/g%3E %3Cpath d='m515.01,291c3.3406,0,6.0743-2.7337,6.0743-6.1177,0-3.3406-2.7347-6.0743-6.0743-6.0743-3.384,0-6.1177,2.7337-6.1177,6.0743,0,3.384,2.7337,6.1177,6.1177,6.1177z' fill-rule='evenodd' stroke='%23fff' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23fff'/%3E %3Cg stroke='%23000'%3E %3Cg stroke-width='0.13' fill='none'%3E %3Cpath d='M516.31,278.89 517,275.64'/%3E %3Cpath d='M515.66,278.81 516,275.51'/%3E %3Cpath d='M515.01,278.76 515.01,275.46'/%3E %3Cpath d='M514.4,278.81 514.05,275.51'/%3E %3Cpath d='M513.75,278.89 513.05,275.64'/%3E %3Cpath d='M513.14,279.07 512.1,275.9'/%3E %3Cpath d='M512.53,279.28 511.19,276.25'/%3E %3Cpath d='M511.97,279.54 510.28,276.68'/%3E %3Cpath d='M511.4,279.89 509.45,277.24'/%3E %3Cpath d='M510.93,280.32 508.67,277.85'/%3E %3Cpath d='M510.45,280.76 507.98,278.54'/%3E %3Cpath d='M510.06,281.28 507.37,279.33'/%3E %3Cpath d='M509.67,281.8 506.81,280.15'/%3E %3Cpath d='M509.41,282.36 506.37,281.02'/%3E %3Cpath d='M509.15,282.97 506.02,281.93'/%3E %3Cpath d='M508.97,283.58 505.76,282.88'/%3E %3Cpath d='M508.89,284.23 505.59,283.88'/%3E %3Cpath d='M508.84,284.88 505.55,284.88'/%3E %3Cpath d='M508.89,285.49 505.59,285.83'/%3E %3Cpath d='M508.97,286.14 505.72,286.83'/%3E %3Cpath d='M509.15,286.74 505.98,287.79'/%3E %3Cpath d='M509.37,287.35 506.33,288.7'/%3E %3Cpath d='M509.67,287.92 506.15,290.09'/%3E %3Cpath d='M510.01,288.48 502.81,293.6'/%3E %3Cpath d='M510.41,288.96 502.73,295.77'/%3E %3Cpath d='M510.84,289.43 504.5,296.51'/%3E %3Cpath d='M511.36,289.83 506.54,296.29'/%3E %3Cpath d='M511.88,290.22 506.85,298.94'/%3E %3Cpath d='M512.45,290.48 509.67,296.81'/%3E %3Cpath d='M513.05,290.74 510.23,299.46'/%3E %3Cpath d='M513.66,290.91 512.45,296.77'/%3E %3Cpath d='M514.31,291 513.44,300.02'/%3E %3Cpath d='M515.57,291 515.92,294.29'/%3E %3Cpath d='M516.22,290.91 518.17,299.41'/%3E %3Cpath d='M516.83,290.74 518.48,295.77'/%3E %3Cpath d='M517.43,290.52 521.3,298.89'/%3E %3Cpath d='M518.04,290.22 522.16,297.33'/%3E %3Cpath d='M518.56,289.87 524.51,297.68'/%3E %3Cpath d='M519.08,289.48 524.29,295.51'/%3E %3Cpath d='M519.52,289.05 527.24,296.07'/%3E %3Cpath d='M519.91,288.52 524.12,291.56'/%3E %3Cpath d='M520.3,288 523.16,289.65'/%3E %3Cpath d='M520.56,287.44 523.6,288.78'/%3E %3Cpath d='M520.82,286.83 523.94,287.87'/%3E %3Cpath d='M520.99,286.22 524.2,286.92'/%3E %3Cpath d='M521.08,285.57 524.38,285.92'/%3E %3Cpath d='M521.12,284.92 524.42,284.92'/%3E %3Cpath d='M521.08,284.31 524.38,283.97'/%3E %3Cpath d='M520.99,283.66 524.25,282.97'/%3E %3Cpath d='M520.82,283.06 523.99,282.02'/%3E %3Cpath d='M520.6,282.45 523.64,281.1'/%3E %3Cpath d='M520.34,281.84 523.21,280.19'/%3E %3Cpath d='M519.99,281.32 522.64,279.37'/%3E %3Cpath d='M519.56,280.8 522.03,278.59'/%3E %3Cpath d='M519.13,280.37 521.34,277.89'/%3E %3Cpath d='M518.61,279.93 520.56,277.29'/%3E %3Cpath d='M518.09,279.59 519.73,276.72'/%3E %3Cpath d='M517.52,279.33 518.87,276.29'/%3E %3Cpath d='M516.91,279.07 517.96,275.94'/%3E %3Cpath d='M515.01,270.99 515.01,268.43'/%3E %3Cpath d='M512.14,271.3 511.62,268.78'/%3E %3Cpath d='M509.37,272.17 508.32,269.87'/%3E %3Cpath d='M506.85,273.64 505.33,271.56'/%3E %3Cpath d='M504.68,275.55 502.77,273.86'/%3E %3Cpath d='M502.99,277.94 500.73,276.64'/%3E %3Cpath d='M501.77,280.58 499.34,279.76'/%3E %3Cpath d='M501.16,283.4 498.6,283.14'/%3E %3Cpath d='M501.16,286.31 498.6,286.57'/%3E %3Cpath d='M501.77,289.18 499.3,289.96'/%3E %3Cpath d='M527.02,291.87 529.24,293.17'/%3E %3Cpath d='M528.19,289.22 530.62,290'/%3E %3Cpath d='M528.8,286.4 531.36,286.66'/%3E %3Cpath d='M528.8,283.49 531.36,283.23'/%3E %3Cpath d='M528.19,280.63 530.67,279.85'/%3E %3Cpath d='M527.02,277.98 529.24,276.68'/%3E %3Cpath d='M525.33,275.64 527.24,273.9'/%3E %3Cpath d='M523.21,273.69 524.68,271.6'/%3E %3Cpath d='M520.69,272.21 521.73,269.87'/%3E %3Cpath d='M517.91,271.3 518.43,268.83'/%3E %3C/g%3E %3Cpath d='m518.56,287.74s-0.86746-0.47767-1.3886-0.47767c-0.52006,0-2.8205-0.13028-3.7314,0.13027-0.52006,0.1737-0.95431,0.60691-0.95431,0.60691s0.60691,0.60795,1.8218,0.73822c1.2583,0.0858,2.0389,0,2.6903-0.21712,0.73822-0.21713,1.5622-0.78061,1.5622-0.78061z' fill-rule='evenodd' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23e60000'/%3E %3Cpath d='m512.66,286.83s0.0868-1.6925,1.2583-3.8183c0,0-0.38979,0.60691-0.60691,1.128,0,0-0.65137,0.3474-1.0422-0.13027-0.38979-0.38979-0.17267-0.56349,0.13027-1.1714,0.25951-0.47767,0.21609-0.95431,0.56349-1.2583,0.30294-0.30397,0.56348-0.34739,1.3886-0.34739,0.82507,0,1.3451,0.0868,2.0389,1.0412,0.60691,0.82404,0.95431,1.6057,1.2583,2.0389,0.69376,1.0846,0.69376,2.3863,0.69376,2.3863l0.21713,1.0412s-0.86746-0.47767-1.3886-0.47767c-0.52006,0-2.8205-0.13028-3.7314,0.13027-0.52006,0.1737-0.9543,0.60691-0.9543,0.60691s-0.34637-0.77854,0.17473-1.1694z' fill-rule='evenodd' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23e60000'/%3E %3Cpath d='m512.66,286.83s0.65137-0.39082,2.864-0.3474c2.56,0.0434,2.6458,0.21713,2.8195,0.39082' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='none'/%3E %3Cpath d='m514.87,296.38,0-8.9817s0.30397-0.26055,0.99773,0v8.8948s0.21712,6.8115-0.52109,6.768c-0.86746,0.001-0.47664-1.5612-0.47664-6.6812z' fill-rule='evenodd' stroke-miterlimit='2.61310005' stroke-width='0.13017058' fill='%23FC0'/%3E %3C/g%3E %3Cg fill='%23e60000'%3E %3Cpath d='m505.59,288.83,0.1737,0.3474-1.7349,0.73718,0.25951,0.60691-0.25951,0.0869c-0.1737-0.39082-0.30397-0.52006-0.73822-0.43321l-0.12924-0.26055,2.4287-1.0846z' fill-rule='evenodd'/%3E %3Cpath d='m503.72,288.09c-0.13028-0.0868-0.26055-0.25951-0.30398-0.47664-0.0869-0.43424,0.0868-0.91088,0.65137-1.0412,0.25952-0.0868,0.91089-0.0868,1.128,0.73718,0.0868,0.3474,0.0434,0.78061-0.52109,0.99773l-0.0858-0.34739c0.30294-0.0858,0.38979-0.34637,0.30294-0.65034-0.0869-0.34636-0.38979-0.47664-0.73719-0.38979-0.34739,0.0868-0.47663,0.38979-0.43321,0.69376,0.0434,0.1737,0.17267,0.34637,0.39082,0.43322l0.0434,0.26054-1.4754,0.13028-0.30294-1.3451,0.34637-0.0434,0.26055,1.0846,0.73615-0.0434z' fill-rule='evenodd'/%3E %3Cpath d='m503.03,283.23c-0.43425,0-0.60692,0.30397-0.60692,0.60794-0.0434,0.25951,0,0.65034,0.38979,0.69376,0.26055,0,0.3474-0.1737,0.39082-0.30397l0.25952-0.78061c0.0868-0.34636,0.34636-0.56349,0.73718-0.52006,0.65034,0.0434,0.78061,0.65033,0.73719,1.128-0.0434,0.47768-0.21712,0.6948-0.30294,0.78061-0.26055,0.21713-0.47767,0.26055-0.73822,0.21713l0.0434-0.34637c0.47767,0.0434,0.65137-0.34739,0.69479-0.69479,0.0434-0.25951,0-0.69376-0.39082-0.73719-0.30397-0.0434-0.39082,0.0868-0.52006,0.5211l-0.1737,0.56349c-0.0868,0.1737-0.21713,0.56348-0.69376,0.52006-0.43322-0.0434-0.82404-0.34636-0.78061-0.99773,0.0868-0.95431,0.65033-0.99774,0.95431-0.99774v0.35z' fill-rule='evenodd'/%3E %3Cpath d='M75.327,65.759,76.082,66.01,76.543,64.625,76.837,64.751,76.375,66.094,77.215,66.388,77.719,64.877,78.012,64.961,78.012,64.961,77.425,66.808,74.907,66.01,75.495,64.164,75.83,64.29z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m520.81,277.53c-0.19515,0.0487-0.40098,0.18964-0.53125,0.40625l-0.59375,1.0312,2.2812,1.4375,0.21875-0.28125-1-0.625,0.4375-0.71875c0.30294-0.52109,0.0964-0.94016-0.25-1.1562-0.17371-0.10856-0.36735-0.14247-0.5625-0.0937zm0.15625,0.40625c0.0589,0.009,0.12236,0.0503,0.1875,0.0937,0.2605,0.17369,0.26745,0.39674,0.0937,0.65625l-0.34375,0.5625-0.75-0.4375,0.40625-0.625c0.0977-0.16282,0.22945-0.27646,0.40625-0.25z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M80.11,62.024,79.901,62.275,78.222,60.681,77.593,61.311,77.383,61.101,77.383,61.101,78.852,59.548,79.104,59.758,78.474,60.429z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M80.992,61.269,79.439,59.17,79.691,58.96,81.286,61.059,81.286,61.059z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='M80.95,58.499,81.327,59.212,82.628,58.541,82.754,58.834,81.496,59.506,81.873,60.261,83.3,59.548,83.426,59.8,83.426,59.8,81.705,60.723,80.488,58.373,82.208,57.492,82.334,57.786z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m513.75,274.77-0.3474-1.5612c0-0.0868-0.0434-0.39082-0.13027-0.65136l-0.25951,2.3863-0.3474,0.0869-1.2583-2.0823c0.0434,0.26054,0.13027,0.60691,0.1737,0.65033l0.34636,1.6057-0.34636,0.0434-0.60795-2.6468,0.5211-0.0869,1.2583,2.0834,0.26055-2.4297,0.52006-0.13028,0.56348,2.6903-0.34636,0.0424z' fill-rule='evenodd'/%3E %3Cpath d='m530.78,272-0.125,2.7188,1.1562,0.0312c0.60691,0.0434,0.96875-0.2845,0.96875-0.71875,0.0434-0.47664-0.29505-0.6007-0.46875-0.6875,0.30392-0.12924,0.375-0.3888,0.375-0.5625,0.0434-0.38978-0.19869-0.7066-0.71875-0.75l-1.2-0.03zm0.40625,0.375,0.59375,0.0625c0.39082,0,0.53125,0.11446,0.53125,0.375-0.0434,0.304-0.2151,0.38715-0.5625,0.34375h-0.625l0.0625-0.78125zm-0.0625,1.125,0.65625,0.0625c0.26055,0,0.5625,0.0911,0.5625,0.4375,0,0.26055-0.2151,0.4375-0.5625,0.4375l-0.6875-0.0625,0.0312-0.875z' transform='translate(-16.12698,0)'/%3E %3Cpath d='m533.8125,272.25 -0.71875,2.65625 0.34375,0.0937 0.28125,-1.125 0.875,0.25c0.4343,0.12924 0.38715,0.37662 0.34375,0.59375 -0.0434,0.0858 -0.1684,0.48255 -0.125,0.65625l0.4375,0.125 0,-0.0312c-0.0868,-0.0869 -0.0747,-0.1388 -0.0312,-0.3125l0.0625,-0.46875c0.13027,-0.3474 0.005,-0.4767 -0.125,-0.5625 0.1737,-0.0879 0.44445,-0.14146 0.53125,-0.53125 0.1737,-0.56349 -0.222,-0.80723 -0.65625,-0.9375L533.8125,272.25zm0.34375,0.46875L534.9375,273c0.1737,0.0434 0.44278,0.11022 0.3125,0.5 -0.0869,0.34745 -0.3332,0.32465 -0.59375,0.28125l-0.75,-0.21875 0.25,-0.84375z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M92.742,58.289,92.322,58.96,93.581,59.716,93.413,59.967,92.154,59.254,91.734,60.009,93.077,60.807,92.952,61.059,92.952,61.059,91.273,60.093,92.574,57.827,94.253,58.792,94.085,59.086z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m540.31,275.81-2.0625,1.7188,0.6875,0.875c0.607,0.65036,1.3359,0.35854,1.8125-0.0312,0.60795-0.4777,0.75892-1.1865,0.28125-1.75l-0.71875-0.8125zm-0.0312,0.59375,0.40625,0.5c0.30397,0.34736,0.25892,0.72303-0.21875,1.1562-0.47659,0.3908-0.91478,0.37865-1.2188,0.0312l-0.40625-0.46875,1.4375-1.2188z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M97.735,63.157,96.98,63.534,97.651,64.793,97.357,64.961,96.729,63.661,95.932,64.038,96.645,65.465,96.351,65.591,96.351,65.591,95.47,63.87,97.819,62.695,98.701,64.416,98.407,64.542z' fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cpath d='m525.11,283.71-0.0434-0.3474,1.8662-0.25951-0.0868-0.60692,0.26055-0.0434c0.13027,0.43321,0.17369,0.56349,0.60691,0.60691l0.0434,0.25951-2.6468,0.39083z' fill-rule='evenodd'/%3E %3Cpath d='m542.09,284.53c-0.12924,0-0.36446-0.0106-0.625,0.25-0.17373,0.21712-0.21875,0.48358-0.21875,0.65625-0.0434,0.60794,0.39042,0.90625,0.78125,0.90625,0.21608,0.0434,0.5138-0.0286,0.6875-0.375,0.0434,0.13027,0.18385,0.34475,0.53125,0.34375,0.34637,0.0434,0.71875-0.17433,0.71875-0.78125,0.0434-0.60794-0.38456-0.84375-0.6875-0.84375-0.26055,0-0.44435,0.11549-0.53125,0.375-0.0869-0.30294-0.30885-0.48785-0.65625-0.53125zm0,0.4375c0.21712,0,0.44965,0.18489,0.40625,0.53125,0,0.26055-0.12239,0.46875-0.46875,0.46875-0.39085,0-0.4375-0.31413-0.4375-0.53125,0-0.38974,0.28391-0.46875,0.5-0.46875zm1.1875,0.125c0.1737,0,0.38715,0.0901,0.34375,0.4375,0,0.34641-0.21348,0.4375-0.34375,0.4375-0.21713-0.0434-0.40625-0.23945-0.40625-0.5,0-0.21609,0.18912-0.375,0.40625-0.375z' transform='translate(-16.12698,0)'/%3E %3Cpath d='m526.76,286.92c0.86746,0.21609,0.78061,0.86746,0.73719,1.128-0.12924,0.43321-0.52006,0.73822-0.99773,0.60794-0.43425-0.0868-0.56349-0.43424-0.69376-0.91088l-0.0869-0.30397c-0.0869-0.38979-0.26055-0.52007-0.39082-0.56349l-0.3474,1.432-0.30397-0.0868,0.43424-1.7794c0.56349,0.1737,0.78165,0.47767,0.91089,0.86746l0.0868,0.39082c0.0869,0.30294,0.1737,0.56349,0.5211,0.60691,0.1737,0.0868,0.47767,0,0.56452-0.38978,0.13028-0.47767-0.30397-0.60795-0.47767-0.65137l0.0434-0.3474z' fill-rule='evenodd'/%3E %3Cpath d='m524.12,289.52,0.17267-0.34636,1.6925,0.82403,0.26055-0.56452,0.26055,0.0868c-0.1737,0.43425-0.21712,0.60795,0.13027,0.86746l-0.0868,0.26055-2.4297-1.128z' fill-rule='evenodd'/%3E %3C/g%3E %3Cpath d='M87.035,37.978,43.14,111.42,130.97,111.42,130.97,111.42z' stroke='%23000' stroke-miterlimit='2.61310005' stroke-width='0.2938' fill='none' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)'/%3E %3Cg%3E %3Cg stroke-miterlimit='2.61310005' fill='none'%3E %3Cpath d='m517.43,319.37c1.1714,0.30397,2.6034,0.47767,4.0344,0.0868,1.9531-0.47767,3.7748-1.6057,6.0743-1.3886,1.6491,0.17267,3.9051,1.6057,6.6388,1.6057,2.6903,0,3.6011-0.95534,5.944-1.433,1.6491-0.34636,2.4742-0.17267,4.2525,0.21712,2.0389,0.39082,3.08,1.5623,6.5075,1.3027' stroke='%23000' stroke-width='0.13017058'/%3E %3Cpath d='m482.42,322.63c1.5178-1.1725,4.2081-1.6491,6.248-1.1725,2.6903,0.56452,3.8607,1.2583,6.7246,1.2148,2.1268-0.0424,3.9485-1.4744,6.1177-1.4744,3.6011,0,3.7314,0.73719,6.8983,1.3451,0.82404,0.17267,1.8662,0.17267,2.6903,0,1.1714-0.21712,2.2136-0.60794,3.1669-1.0856,0.99774-0.52007,3.5143-0.43322,4.7726-0.30294,2.256,0.21609,3.1669,1.0846,3.6446,1.2148,1.2149,0.30294,2.6034,0.47768,4.0344,0.0869,1.9531-0.56452,3.7738-1.8228,6.1177-1.5622,1.6491,0.1737,3.9041,1.7783,6.5954,1.7783,2.6903,0,3.6435-1.0846,5.944-1.6046,1.6925-0.39082,2.5166-0.1737,4.2949,0.21712,1.9965,0.47664,3.08,1.7783,6.5085,1.4744' stroke='%23fff' stroke-width='0.47725767'/%3E %3Cpath d='m477.3,320.07c1.5188-0.99773,4.2091-1.432,6.248-1.0412,2.6903,0.5211,3.8617,1.1714,6.7246,1.128,2.1257-0.0434,3.9485-1.3451,6.1177-1.3451,3.6011,0,3.7314,0.69479,6.8983,1.2149,0.82506,0.13027,1.8662,0.13027,2.6903,0,1.1714-0.17267,2.2126-0.56349,3.1669-0.99774,0.9543-0.43424,3.5143-0.34739,4.7726-0.26054,2.256,0.21712,3.1669,0.95534,3.6446,1.0856,1.2149,0.25952,2.6034,0.43321,4.0344,0.0858,1.9531-0.52006,3.7748-1.6057,6.1177-1.3886,1.6491,0.1737,3.9051,1.6057,6.5954,1.5623,2.6903,0,3.6446-0.95431,5.944-1.432,1.6925-0.3474,2.5166-0.13028,4.2949,0.21712,1.9965,0.43425,3.08,1.6057,6.5085,1.3017' stroke='%23fff' stroke-width='0.34708709'/%3E %3Cpath d='m472.61,327.49c1.5188-1.2583,4.2091-1.7783,6.2914-1.3017,2.6468,0.65137,3.8183,1.432,6.6822,1.3886,2.1257-0.0434,3.9909-1.6481,6.1177-1.6481,3.6446,0,3.7304,0.82404,6.8983,1.5188,0.82404,0.17267,1.8662,0.17267,2.7337,0,1.1714-0.26054,2.1692-0.69479,3.1235-1.2593,0.99773-0.52006,3.5143-0.43321,4.816-0.30294,2.2126,0.25951,3.1235,1.1714,3.6012,1.3451,1.2148,0.30294,2.6034,0.52006,4.0778,0.0868,1.9531-0.65137,3.7748-1.9965,6.0743-1.736,1.6491,0.21609,3.9051,1.9955,6.6388,1.9955,2.6468,0,3.6011-1.2148,5.9006-1.8218,1.6925-0.43425,2.5166-0.1737,4.2949,0.26054,2.0399,0.52007,3.08,1.9955,6.5085,1.6481' stroke='%23fff' stroke-width='0.60742819'/%3E %3Cpath d='m473.83,323.23c1.5623-1.0412,4.2525-1.432,6.2914-1.0412,2.6903,0.52006,3.8617,1.128,6.7256,1.0846,0.95431,0,1.8228-0.26054,2.7337-0.56452' stroke='%23fff' stroke-width='0.34708709'/%3E %3Cpath d='m487.58,318.81c0.43321-0.13027,1.6915-0.73719,3.5143-0.73719,3.6446,0,1.3451,0.0434,4.512,0.60692,0.82403,0.13027,3.1235,0.17369,3.7748-0.47767' stroke='%23000' stroke-width='0.3037658'/%3E %3Cpath d='m531.15,328.49c1.1714-0.21712,2.1702-0.56452,3.1669-0.99877,0.95431-0.43321,3.4709-0.38978,4.7726-0.25951,2.257,0.21712,3.1235,0.95431,3.6446,1.0412,1.2148,0.30397,2.6034,0.47767,4.0344,0.0869,1.9531-0.47767,3.7748-1.6057,6.1177-1.3886,1.6491,0.1737,3.9051,1.6057,6.5954,1.6057' stroke='%23000' stroke-width='0.3037658'/%3E %3Cpath d='m536.74,318.46c2.6913,0,3.6012-0.95431,5.945-1.432,1.6491-0.34636,2.4731-0.13027,4.2515,0.21713,2.0389,0.39082,3.08,1.6057,6.5075,1.3017' stroke='%23fff' stroke-width='0.34708709'/%3E %3Cpath d='m472.74,327.75c1.5622-0.99773,4.2515-1.432,6.2914-1.0412,2.6903,0.5211,3.8617,1.1714,6.7246,1.128,2.1257-0.0434,3.9486-1.3451,6.1177-1.3451,3.6012,0,3.7314,0.6948,6.8983,1.2149,0.82403,0.13027,1.8662,0.13027,2.6903,0,1.1714-0.1737,2.1692-0.56349,3.1669-0.99774,0.95431-0.43424,3.4709-0.34739,4.7726-0.21712,2.256,0.1737,3.1235,0.91192,3.6435,1.0412' stroke='%23000' stroke-width='0.13017058'/%3E %3Cpath d='m478.47,324.45c1.5612-1.0412,4.2515-1.432,6.2904-1.0412,2.6903,0.52109,3.8617,1.128,6.6822,1.0846,2.1692-0.0434,3.9909-1.3451,6.1177-1.3017,3.6446,0,3.7748,0.65137,6.9418,1.2149,0.82403,0.13028,1.8652,0.13028,2.6903,0,1.1714-0.21609,2.1692-0.56349,3.1669-0.99773,0.9543-0.43425,3.4709-0.39082,4.7726-0.26055,2.2126,0.21712,3.1235,0.95534,3.6446,1.0422,1.1714,0.30294,2.6034,0.47664,4.0354,0.0869,1.952-0.47767,3.7738-1.6067,6.1177-1.3886,1.7783,0.17266,4.0344,1.6046,6.5943,1.6046,2.6913,0,3.6446-0.95431,5.944-1.432,1.6491-0.3474,2.4742-0.17266,4.2959,0.21712,1.9955,0.39083,3.08,1.5623,6.4641,1.2583' stroke='%23000' stroke-width='0.60742819'/%3E %3C/g%3E %3Cg fill-rule='evenodd' stroke='%23000' stroke-width='0.26' fill='%23fc0'%3E %3Cpath d='m479.69,311.82c0.43321,0.0868,1.4754-0.73822,1.7794-0.95534,0.43321-0.26055,0.65033-0.91088,0.99773-1.2583,0.34636-0.39082,1.3886-0.86746,1.8652-1.1714,2.0823-1.3017,3.0377-2.0399,4.4686-3.9485,1.9531-2.6903,4.2525-4.9028,7.1154-6.5075,0.91088-0.52109,2.2994-0.3474,3.2972,0.0858,0.30294,0.13027,0.69376,0.47767,1.0412,0.73718,1.2148,0.95431,2.864,1.6491,4.8594,2.257,1.9086,0.56349,2.3429,1.8218,3.8617,3.1669,0.73718,0.65033,1.5622,1.2149,2.4731,1.6481,0.0869,0.0434,0.30294,0.39082,0.38979,0.43424,0.86746,0.65137,1.8228,1.1725,2.56,1.8228,1.3886,1.2583,2.6903,2.5176,3.9909,3.8617,0.21713,0.21609,0.30397,0.65033,0.5211,0.82403,0.99773,0.95431,1.9531,1.9531,3.1669,2.5166,1.2148,0.60794,2.2994,1.3896,3.4274,2.0834-11.542,0.43424-22.171-0.30398-33.755,0.0434-0.30397,0.0434-0.39082,0-2.1268,0-0.86745-0.0434-1.3886,0.0434-2.256,0.0434-3.5143-0.0434-6.8549-0.0434-10.977-0.0868l3.3003-5.5966z'/%3E %3Cpath d='m525.03,317.12c-0.95431-0.60794-1.9096-1.2583-2.9508-1.7794-1.2149-0.56349-2.1702-1.5623-3.1669-2.5166-0.21712-0.1737-0.30397-0.60794-0.5211-0.82403-1.3017-1.3451-2.6034-2.6044-3.9909-3.8617-0.73718-0.65034-1.6925-1.1714-2.56-1.8228-0.0869-0.0434-0.30293-0.39082-0.38978-0.43424-0.91089-0.43321-1.736-0.99774-2.4731-1.6481-0.99773-0.91192-1.5188-1.736-2.3429-2.3873l0.0434-0.0434c0.47767-0.3474,0.99773-0.69376,1.5622-0.95431,0.73719-0.43321,1.9086-0.30294,2.7337,0.0868,0.26055,0.0869,0.60794,0.3474,0.86746,0.56349,0.99773,0.82507,2.3863,1.3886,4.0354,1.9096,1.6057,0.47767,1.9965,1.5188,3.2538,2.6034,0.60794,0.56452,1.2583,1.0422,2.0399,1.3896,0.0434,0.0434,0.21609,0.30294,0.30294,0.38979,0.73822,0.52109,1.5188,0.95534,2.1702,1.5188,1.128,1.0422,2.2136,2.0834,3.2972,3.2103,0.1737,0.1737,0.21712,0.5211,0.43425,0.6948,0.82403,0.78061,1.6481,1.6057,2.6468,2.0823,0.99774,0.47767,1.8652,1.129,2.8205,1.6925-2.6034,0.13027-5.1634,0.13027-7.7234,0.13027h-0.0889z'/%3E %3Cpath d='m514.74,303.06c0.34637,0.0868,0.73719,0.21712,1.128,0.3474,1.6057,0.47767,1.9965,1.5188,3.2538,2.6034,0.60794,0.56452,1.2583,1.0422,2.0399,1.3896,0.0434,0.0434,0.21609,0.30294,0.30294,0.38979,0.73822,0.52109,1.5188,0.95534,2.1702,1.5188,1.128,1.0422,2.2136,2.0834,3.2972,3.2103,0.1737,0.1737,0.21713,0.52109,0.43425,0.69479,0.82403,0.78061,1.6481,1.6057,2.6468,2.0823,0.86746,0.39082,1.6057,0.95534,2.3863,1.433,2.1268,0,4.2515-0.0434,6.4651-0.13027-0.86849-0.5211-1.6491-1.129-2.6034-1.5623-0.91192-0.43424-1.6057-1.1725-2.3873-1.9096-0.17369-0.13027-0.21712-0.43424-0.38978-0.60794-0.99877-1.0412-1.9965-1.952-3.0377-2.9074-0.56349-0.52109-1.2583-0.91088-1.9086-1.3886-0.0868-0.0434-0.26055-0.30397-0.30397-0.3474-0.6948-0.34636-1.3017-0.73718-1.8662-1.2583-1.128-0.99773-1.4754-1.9531-2.9508-2.3863-1.4754-0.43424-2.7337-0.99876-3.6435-1.6925-0.26055-0.21712-0.56452-0.47767-0.78165-0.56452-0.78164-0.34739-1.8228-0.47767-2.5166-0.0868-0.60691,0.34843-1.2148,0.73925-1.7349,1.1725z'/%3E %3Cpath d='m525.33,305.53c0.30397,0.34636,0.60794,0.69376,1.0412,1.0846,0.56452,0.5211,1.1714,0.91192,1.8662,1.2583,0.0434,0.0434,0.21712,0.30397,0.30397,0.3474,0.65034,0.47767,1.3451,0.86746,1.9086,1.3886,1.0422,0.95535,2.0399,1.8662,3.0377,2.9074,0.17266,0.1737,0.21609,0.47767,0.38978,0.60794,0.78165,0.73719,1.4754,1.4754,2.3873,1.9096,0.60691,0.30294,1.128,0.65034,1.6925,0.99774h-0.0434c2.5166,0,5.0321,0,7.5931-0.0869-0.69479-0.43425-1.3027-0.91089-2.0834-1.2583-0.73718-0.39082-1.3017-0.99774-1.9531-1.5623-0.12924-0.13027-0.17267-0.34739-0.30398-0.52109-0.82403-0.82404-1.6046-1.5623-2.4297-2.3429-0.47664-0.43424-1.0412-0.73821-1.5622-1.129-0.0868-0.0434-0.21713-0.21609-0.26055-0.25951-0.56349-0.26055-1.0412-0.60795-1.5188-0.99877-0.91088-0.82403-1.1714-1.6057-2.3429-1.9531-1.2159-0.38979-2.257-0.78061-2.9942-1.3886-0.21712-0.17266-0.43424-0.34636-0.60794-0.43321-0.65034-0.26055-1.4754-0.39082-2.0399-0.0868-0.78061,0.43321-1.432,0.91088-2.0823,1.4754v0.0434h0.002z'/%3E %3Cpath d='m544.99,315.6c-0.47767-0.3474-0.99773-0.65034-1.5622-0.91089-0.73719-0.39082-1.3017-0.99773-1.9531-1.5622-0.12924-0.13027-0.17266-0.3474-0.30397-0.5211-0.82403-0.82403-1.6046-1.5622-2.4297-2.3429-0.47664-0.43425-1.0412-0.73822-1.5623-1.129-0.0869-0.0434-0.21712-0.21609-0.26054-0.25951-0.56349-0.26055-1.0412-0.60795-1.5188-0.99877-0.78061-0.69376-1.0846-1.3451-1.8652-1.7794l0.0424,0.0434c0.39083-0.30294,0.82507-0.60692,1.2593-0.82404,0.52006-0.30397,1.2149-0.1737,1.7783,0.0434,0.13028,0.0434,0.3474,0.26054,0.5211,0.39082,0.65137,0.47664,1.4754,0.86746,2.561,1.1714,0.99773,0.30294,1.2149,0.95431,1.9955,1.6491,0.39082,0.3474,0.82506,0.65034,1.3017,0.86746,0.0434,0.0434,0.13028,0.21713,0.21712,0.26055,0.43425,0.30397,0.95431,0.56452,1.3451,0.95534,0.69479,0.65034,1.3886,1.3017,2.0833,1.9955,0.13028,0.13027,0.13028,0.3474,0.26055,0.43425,0.5211,0.47767,1.0412,0.99773,1.6491,1.3017,0.65033,0.3474,1.2148,0.73822,1.8218,1.0846-1.8218,0.0868-3.6001,0.0868-5.3795,0.0868v0.0434h-0.001z'/%3E %3C/g%3E %3Cg stroke='%2300633b' stroke-width='0.13' fill='none'%3E %3Cpath d='m494.83,298.72c0.56349-0.0869,0.30294-0.21609,0.82403,0.13027'/%3E %3Cpath d='m493.79,299.41c0.60691-0.0869,0.82404-0.47767,1.2583,0.0434'/%3E %3Cpath d='m493.22,299.81c0.26055,0,0.43425-0.30397,1.2583,0.17267'/%3E %3Cpath d='m492.62,300.5c0.5211-0.13027,0.82403-0.0868,1.3451,0.0869'/%3E %3Cpath d='m491.92,301.02c0.60691-0.1737,0.86745,0.26055,1.5188,0.13027'/%3E %3Cpath d='m491.18,301.76c0.38979,0,0.5211-0.13028,0.86746,0,0.43321,0.13027,0.34636,0.0434,0.78061,0.0868'/%3E %3Cpath d='m490.36,302.54c0.43424,0,0.56348-0.0869,0.9543-0.0434,0.52007,0.0868,0.39083,0.13028,0.91089,0.0434'/%3E %3Cpath d='m489.88,303.19c0.86746-0.0868,1.128-0.0434,1.7349,0.1737'/%3E %3Cpath d='m488.71,304.79c0.73719-0.21712,1.0846-0.21712,1.736,0.0434'/%3E %3Cpath d='m476.65,317.2c2.3863-0.39082,5.2068,0.0434,7.5931-0.30397'/%3E %3Cpath d='m489.06,304.01c0.60691-0.21712,0.47664-0.13027,1.0846-0.0868,0.60795,0.0868,0.86746,0.1737,1.0412,0.0868'/%3E %3Cpath d='m488.1,305.4c0.60691-0.30397,1.3451-0.13027,1.9531,0.0434'/%3E %3Cpath d='m489.67,306.05c-0.65034-0.1737-1.3451-0.0434-2.0389,0'/%3E %3Cpath d='m489.15,306.75c-0.6948-0.21712-1.432-0.30397-2.1268-0.0868'/%3E %3Cpath d='m486.06,307.27c0.86746,0,1.6925-0.21712,2.56,0.0868'/%3E %3Cpath d='m485.33,307.96c0.91088-0.30397,1.8228-0.0434,2.7771,0.0434'/%3E %3Cpath d='m484.46,308.48c0.95431-0.0434,1.8652-0.0434,2.8205-0.0868,0.13027,0,0.43424-0.13028,0.60691,0.0868'/%3E %3Cpath d='m487.58,309c-1.432,0.30397-2.864,0.0869-4.2959,0.13027'/%3E %3Cpath d='m486.8,309.74c-0.47768,0.0434-1.2149,0.21712-1.8662,0.1737-0.13028-0.0434-0.25952-0.13028-0.38979-0.13028-0.73718-0.0434-1.4754-0.0434-2.1692,0.21713'/%3E %3Cpath d='m482.07,310.52c0.30398-0.1737,0.65034-0.21712,0.95431-0.13027,0.91089,0.13027,1.7783,0,2.6468,0.21609,0.21712,0.0868,0.43424,0.21712,0.69376,0.21712'/%3E %3Cpath d='m481.55,310.87c0.65033,0,1.3017-0.0868,1.952,0.0434,0.82403,0.21712,1.6057,0.39082,2.4731,0.43424h-0.0869'/%3E %3Cpath d='m480.94,311.35c0.69376,0,1.3451,0.13028,2.0399,0.26055,0.91088,0.1737,1.8218-0.0868,2.6903,0.1737'/%3E %3Cpath d='m480.12,311.78c0.91088,0.38979,1.8662,0.0434,2.8205,0.21712,0.91089,0.17267,1.736,0.12924,2.6034,0.30294'/%3E %3Cpath d='m479.51,312.47c1.3886,0.0434,2.7771,0,4.2091,0.26055,0.38978,0.0868,0.99773,0.26055,1.5188,0.1737'/%3E %3Cpath d='m479.04,313.08c1.3451,0.26054,2.7337,0.0434,4.0778,0.39082,0.60794,0.13027,1.2583,0.25951,1.9096,0.25951h-0.0868'/%3E %3Cpath d='m478.47,314.12c0.12924-0.0434,0.30294-0.13027,0.43321-0.13027,1.0846,0,2.1257,0.1737,3.2538,0.0434,0.86746-0.0434,1.8218-0.13027,2.6903,0.1737h-0.0868'/%3E %3Cpath d='m477.99,314.82c2.1692-0.21713,4.3828,0.0868,6.552,0'/%3E %3Cpath d='m477.6,315.47c2.2994,0.26055,4.5989,0.0434,6.8549,0.21713'/%3E %3Cpath d='m477.26,316.16c0.99773,0.21712,1.9965-0.0868,2.9942,0.13027,0.73719,0.13028,1.3886,0.25952,2.1268,0.13028,0.65033-0.1737,1.2583,0.0434,1.8652-0.0434'/%3E %3Cpath d='m493.53,306.88h0.21713'/%3E %3Cpath d='m493.31,307.14c0.0868,0.0434,0.21712-0.13028,0.26055,0.0434'/%3E %3Cpath d='m493.05,307.49h0.47663'/%3E %3Cpath d='m492.83,307.79h0.60691'/%3E %3Cpath d='m492.44,308.18c0.3474,0.0434,0.65137,0.0869,0.99773,0.0869h-0.0869'/%3E %3Cpath d='m492.1,308.7c0.38979-0.13027,0.82404,0,1.2149-0.13027h-0.0869'/%3E %3Cpath d='m491.58,309.31h1.6491-0.0858'/%3E %3Cpath d='m491.31,309.7c0.60692,0,1.1714-0.0869,1.736,0.0434h-0.0434'/%3E %3Cpath d='m490.97,310.26c0.65033-0.0869,1.3451,0,2.0399,0.0868'/%3E %3Cpath d='m490.58,310.87c0.43321-0.0434,0.78061,0.21712,1.2149,0.30397,0.34739,0.0869,0.65033,0,0.9543-0.0434'/%3E %3Cpath d='m490.45,311.35c0.65034,0.21713,1.3451,0.26055,1.9955,0.30398'/%3E %3Cpath d='m490.06,311.87c0.56349-0.0434,1.0846,0.0868,1.6491,0.25951,0.25951,0.0869,0.52006,0.0434,0.73718,0.0434h-0.0434'/%3E %3Cpath d='m489.32,312.69c0.6948-0.30397,1.5188-0.0869,2.256,0.13028,0.26055,0.0869,0.52109-0.0434,0.82403-0.0434h-0.0869'/%3E %3Cpath d='m489.23,313.21c0.82507-0.26055,1.6925-0.26055,2.4742,0.0869,0.12924,0.0434,0.30293,0,0.43321,0'/%3E %3Cpath d='m488.71,313.82c1.0846,0.21712,2.2126-0.12924,3.2972,0.1737'/%3E %3Cpath d='m488.41,314.3c0.86746,0.3474,1.8228,0,2.7771,0.26055,0.30294,0.0869,0.60691,0.0869,0.91088-0.0434'/%3E %3Cpath d='m487.8,314.95c0.39082-0.13027,0.78164-0.21712,1.1714-0.13027,1.0412,0.26055,1.9955,0.1737,2.9508,0.30397'/%3E %3Cpath d='m487.32,315.64c0.21712-0.0434,0.43424,0.13028,0.60691,0.0869,1.3451-0.21712,2.6903,0,3.992-0.0869'/%3E %3Cpath d='m486.98,316.16c1.0412,0.38979,2.1257,0,3.2538,0.30397,0.43425,0.13027,0.99773,0.1737,1.4754,0'/%3E %3Cpath d='m486.59,316.9c1.6057,0.0434,3.1235-0.0434,4.9897,0.1737'/%3E %3Cpath d='m495.7,307.7c0.1737-0.0434,0.30397,0.13028,0.47767,0.0869'/%3E %3Cpath d='m495.48,308.18c0.21712-0.0434,0.39082-0.13027,0.60794-0.0868'/%3E %3Cpath d='m495.31,308.61c0.30294,0.0434,0.56349-0.0434,0.86746,0.0869'/%3E %3Cpath d='m495.09,309.22c0.34636,0,0.73718,0,1.0846,0.0868'/%3E %3Cpath d='m494.79,309.83c0.47664-0.13028,0.91089,0.0434,1.3886-0.0868'/%3E %3Cpath d='m494.74,310.26c0.43322,0.1737,0.86746,0.0434,1.3451,0.0868v-0.0868'/%3E %3Cpath d='m494.48,310.95c0.43321-0.0434,0.82403-0.0869,1.2148,0.0868,0.13028,0.0434,0.30398,0,0.47767-0.0868'/%3E %3Cpath d='m494.44,311.56c0.56349-0.21713,1.128,0.13027,1.736,0'/%3E %3Cpath d='m494.18,312.3c0.65137-0.0434,1.2583,0.0869,1.9096,0'/%3E %3Cpath d='m493.96,312.86c0.25951-0.0869,0.56349-0.26055,0.82403-0.13027,0.38979,0.1737,0.86746,0.0868,1.3017,0.13027'/%3E %3Cpath d='m493.83,313.52c0.73718-0.26055,1.5188,0.1737,2.256-0.21712'/%3E %3Cpath d='m493.74,314.21c0.34636-0.0868,0.69376-0.0868,1.0846,0.0434,0.38979,0.0869,0.86746,0.0434,1.3451-0.0434'/%3E %3Cpath d='m493.53,314.86c0.86746-0.1737,1.7794,0,2.6903-0.0434l-0.0434,0.0434'/%3E %3Cpath d='m493.01,315.47c1.128-0.0869,2.2994-0.21712,3.4274-0.21712'/%3E %3Cpath d='m493.14,316.16c1.2583-0.21713,2.56-0.13028,3.8617-0.1737'/%3E %3Cpath d='m492.92,316.86c1.2583,0.1737,1.5188-0.0868,2.7771-0.12924,0.21713,0,1.3017-0.21815,1.5188-0.26054,0.1737-0.0434,0.56349,0,0.73822,0'/%3E %3Cpath d='m492.92,317.2c1.9096-0.1737,3.8607,0.1737,5.8137-0.30397'/%3E %3Cpath d='m484.63,316.99h1.5178'/%3E %3Cpath d='m492.01,317.2c0.1737,0.0869,0.38979-0.0868,0.52007,0.0869'/%3E %3Cpath d='m499.26,317.07c1.5612-0.1737,3.1669,0.30397,4.7292,0'/%3E %3Cpath d='m498.47,316.55c0.99773-0.30294,1.9096-0.0858,2.864,0.0879,0.0869,0,0.0869,0.21609,0.1737,0.25951,0.86746,0.13028,1.6925,0,2.56-0.0434'/%3E %3Cpath d='m492.92,316.47h-0.99773'/%3E %3Cpath d='m486.72,316.25c-0.69376,0.0434-1.3886,0.0434-2.0823,0.13027'/%3E %3Cpath d='m499.78,301.63h0.30398'/%3E %3Cpath d='m499.91,302.06c0.13027,0.0434,0.25951,0,0.38979-0.0434'/%3E %3Cpath d='m499.99,302.76c0.0434-0.0434,0.0434-0.13027,0.0868-0.13027,0.12924-0.0434,0.30294-0.0434,0.43321-0.0434'/%3E %3Cpath d='m500.17,303.19c0.21712-0.13027,0.47767-0.0434,0.73718-0.0434'/%3E %3Cpath d='m500.99,303.58c-0.26055-0.0434-0.47767,0.0434-0.69479,0.13027'/%3E %3Cpath d='m500.6,304.32c0.21609-0.13028,0.43425-0.1737,0.69376-0.13028'/%3E %3Cpath d='m501.6,304.71h-0.99773'/%3E %3Cpath d='m500.9,305.23c0.3474,0,0.69376,0.0868,0.95431-0.13028'/%3E %3Cpath d='m502.12,305.84c-0.39082,0-0.73719,0-1.0846,0.0858'/%3E %3Cpath d='m501.29,306.57c0.38979,0.0434,0.78061-0.0434,1.1714-0.21713'/%3E %3Cpath d='m502.55,306.75c-0.34636,0.1737-0.73718,0.21713-1.128,0.30398'/%3E %3Cpath d='m501.64,307.7c0.47767-0.25951,1.0412-0.0434,1.5188-0.21609'/%3E %3Cpath d='m503.29,308.09c-0.38979,0-0.78061-0.0868-1.1714,0.0434-0.13028,0.0434-0.21713,0.13027-0.39082,0.13027'/%3E %3Cpath d='m502.03,309.22c0.30397-0.13027,0.60691-0.34636,0.95431-0.30294,0.0434-0.21712,0.26055,0,0.34636-0.13027,0.0868-0.0434,0.26055,0,0.43425,0'/%3E %3Cpath d='m503.98,309.44c-0.56349-0.0434-1.1714,0.0868-1.7349,0.17369'/%3E %3Cpath d='m502.42,310.35c0.65034-0.26054,1.3017-0.26054,1.9955-0.34739'/%3E %3Cpath d='m502.47,311.17c0.73821-0.17369,1.5188-0.13027,2.2126-0.43424'/%3E %3Cpath d='m505.2,311.26c-0.82403,0.13028-1.6491,0-2.4297,0.39083'/%3E %3Cpath d='m502.94,312.39c0.13028,0.0434,0.21713,0.13027,0.3474,0.0868,0.78164-0.30397,1.5622-0.56349,2.3429-0.47664'/%3E %3Cpath d='m505.85,312.56c-0.78061,0.43425-1.6925,0.26055-2.56,0.30397-0.0858,0-0.17266,0.0868-0.30294,0.13028'/%3E %3Cpath d='m503.29,313.52c0.95431-0.13027,1.8662-0.1737,2.8205-0.30397'/%3E %3Cpath d='m506.72,313.82c-0.78061,0.13027-1.5188-0.0434-2.256,0.13027-0.34637,0.0434-0.65137,0.1737-0.99774,0.26055'/%3E %3Cpath d='m503.59,314.82c0.13028,0,0.30294,0.0434,0.38979-0.0434,0.95431-0.56452,2.0389-0.39082,3.08-0.43424'/%3E %3Cpath d='m507.37,314.95c-0.86746,0-1.7794-0.21712-2.6468,0.0868-0.30294,0.12924-0.60691,0.30294-0.95431,0.30294'/%3E %3Cpath d='m504.07,315.99c0.47664-0.0868,0.91089-0.30397,1.3451-0.39082,0.99774-0.13028,1.9955-0.0434,2.9942-0.0434'/%3E %3Cpath d='m508.41,316.08c-0.56452-0.13028-1.1714-0.1737-1.6925,0-0.86746,0.21712-1.6491,0.43321-2.5166,0.47664'/%3E %3Cpath d='m504.68,316.99c0.69479-0.0869,1.3451-0.30294,2.0399-0.47767,0.56349-0.12924,1.128-0.0424,1.6925-0.0424'/%3E %3Cpath d='m504.72,317.38c1.0412-0.1737,2.0834,0,3.1235-0.3474,0.3474-0.13027,0.73822,0.0869,1.128,0.0434'/%3E %3Cpath d='m508.97,316.68c1.736,0.12924,3.4709-0.21712,5.1634,0.17266'/%3E %3Cpath d='m509.32,317.2c0.21609,0.0434,0.38979-0.13027,0.52006-0.13027,1.432,0,2.864,0.0434,4.2949,0.13027'/%3E %3Cpath d='m513.62,313.52h0.21712'/%3E %3Cpath d='m513.7,313.99c0.17369,0.0868,0.34636-0.21712,0.52006,0'/%3E %3Cpath d='m513.83,314.51h0.91088'/%3E %3Cpath d='m514.09,315.25c0.30398-0.34636,0.73719,0,1.0412-0.21609'/%3E %3Cpath d='m514.31,315.95c0.39082-0.34739,0.95431,0.0434,1.3451-0.30397'/%3E %3Cpath d='m514.4,316.47c0.56348-0.1737,1.1714,0.0424,1.7349-0.30397'/%3E %3Cpath d='m514.61,316.99c0.86746-0.38979,1.8652,0.1737,2.6903-0.43425'/%3E %3Cpath d='m514.7,317.42c1.0846-0.3474,2.2126,0,3.2972-0.0434'/%3E %3Cpath d='m518.69,317.38c1.9096-0.0868,3.8617-0.13027,5.7703,0'/%3E %3Cpath d='m517.87,316.68c1.6925,0.17266,4.2515,0,6.3783,0.17266'/%3E %3Cpath d='m508.5,303.62c0.12924,0,1.3017-0.21712,1.3886-0.21712'/%3E %3Cpath d='m508.89,303.93c0.34739,0.0434,1.1714,0.0434,1.4754-0.21712'/%3E %3Cpath d='m509.45,304.49c0-0.0434,0.99773-0.21609,1.0412-0.21609,0.13027-0.0434,0.30397,0,0.47664-0.0434'/%3E %3Cpath d='m509.89,304.79c0.17266-0.13027,1.5622-0.0434,1.8218-0.0868'/%3E %3Cpath d='m512.05,305.1c-0.26054,0-1.3886,0.0434-1.5622,0.1737'/%3E %3Cpath d='m511.45,305.88c0.1737-0.12924,0.99774-0.25951,1.3017-0.25951'/%3E %3Cpath d='m513.4,306.1c-0.34739,0-1.0846,0.0868-1.4754,0.0868'/%3E %3Cpath d='m512.66,306.75c0.38979-0.0434,1.0846-0.13027,1.3017-0.30397'/%3E %3Cpath d='m514.66,307.09c-0.39082,0-0.91088,0.0434-1.432,0.0868'/%3E %3Cpath d='m513.88,307.7c0.47664,0,1.1714,0,1.5188-0.13027'/%3E %3Cpath d='m515.92,307.87c-0.30398,0.1737-0.91089,0.21713-1.3017,0.30397'/%3E %3Cpath d='m515.26,308.79c0.39082-0.26055,1.0846-0.0868,1.5622-0.26055'/%3E %3Cpath d='m517.35,309.09c-0.47664,0-0.95431-0.0434-1.3017,0.0434-0.13027,0.0434-0.1737,0.13028-0.39082,0.13028'/%3E %3Cpath d='m518.91,310.26c-0.6948-0.0434-1.2583,0.0868-1.8662,0.1737'/%3E %3Cpath d='m517.65,311.09c0.60691-0.26054,1.3451-0.21712,2.0399-0.34739'/%3E %3Cpath d='m519.17,312.91c0.13028,0.0434,0.78061-0.0869,0.91089-0.13028,1.0422-0.13027,1.2148-0.34739,2.1702-0.26055'/%3E %3Cpath d='m522.82,312.95c-1.2593,0.21712-1.736,0.26055-2.6913,0.3474-0.13027,0-0.43321,0.0868-0.52006,0.13027'/%3E %3Cpath d='m520.17,313.82c0.95534-0.17266,2.3439-0.12924,3.2972-0.25951'/%3E %3Cpath d='m524.51,314.08c-0.78061,0.13027-1.6915,0-2.4297,0.1737-0.3474,0.0434-0.99774,0.0869-1.3451,0.1737'/%3E %3Cpath d='m521.64,315.03c0.13027,0,0.30397,0,0.39082-0.0434,0.78165-0.5211,2.0399-0.43425,3.1669-0.43425'/%3E %3Cpath d='m525.9,315.08c-1.0856,0-1.5199,0.0434-2.3439,0.12924-0.30397,0.0434-0.73719,0.21712-1.128,0.21712'/%3E %3Cpath d='m523.34,315.99c0.99773-0.1737,2.9074-0.39082,1.7794-0.30397,1.0412-0.0869,1.2148-0.0869,2.3429-0.0869'/%3E %3Cpath d='m527.76,316.03c-0.69376-0.0869-1.432-0.0869-1.9086,0.0434-0.43425,0.13027-0.30397,0.26055-1.7794,0.30397'/%3E %3Cpath d='m524.68,316.68c0.69479-0.0868,0.78164-0.0434,1.432-0.21712,0.52109-0.13028,1.2159-0.0869,1.8662-0.0869'/%3E %3Cpath d='m525.03,316.94c1.0846-0.13027,1.2148-0.0869,2.3439-0.0434,0.30294,0,0.56349,0,0.95431-0.0434'/%3E %3Cpath d='m508.15,303.19c0.26054-0.13027,0.43424-0.21712,0.91088-0.17369-0.13027-0.1737,0.21712,0,0.30397-0.0868,0-0.0869,0.25952-0.0434,0.43321-0.0434'/%3E %3Cpath d='m507.63,302.67c0.25952-0.13027,0.52007-0.13027,0.95431-0.0869-0.13027-0.21712,0.25952,0,0.30294-0.13027,0.0434-0.0434,0.30397,0,0.47767,0'/%3E %3Cpath d='m516.26,309.96c0.30397-0.13027,0.26055-0.21712,0.69376-0.13027-0.12924-0.21713,0.47767,0,0.5211-0.13028,0.0434-0.0869,0.52109-0.0434,0.69376-0.0434'/%3E %3Cpath d='m518.09,311.69c0.69377-0.1737,1.5623-0.1737,2.1692-0.47767'/%3E %3Cpath d='m521.3,312c-0.82403,0.12924-2.0389,0.0424-2.6903,0.38979'/%3E %3Cpath d='m508.71,301.93c-0.78061-0.0434-0.91089,0.21713-1.4754,0.21713'/%3E %3Cpath d='m517.26,304.1c0.13027,0,0.99773-0.1737,1.128-0.1737'/%3E %3Cpath d='m517.61,304.45c0.52007-0.12924,0.91089,0,1.2149-0.21609'/%3E %3Cpath d='m518.04,304.88c0-0.0434,0.82403-0.13028,0.86746-0.13028,0.13027-0.0434,0.30397-0.0434,0.43425-0.0434'/%3E %3Cpath d='m518.48,305.27c0.1737-0.13027,1.3027-0.0868,1.5623-0.13027'/%3E %3Cpath d='m520.34,305.53c-0.26055-0.0434-1.3017,0.13027-1.4754,0.21712'/%3E %3Cpath d='m519.43,306.23c0.1737-0.13027,1.3017-0.26055,1.5623-0.21712'/%3E %3Cpath d='m521.6,306.44c-0.3474,0-1.3017,0.0868-1.6491,0.13028'/%3E %3Cpath d='m520.51,307.01c0.3474,0,1.432-0.0868,1.6057-0.26055'/%3E %3Cpath d='m522.73,307.35c-0.3474,0-0.95535,0.0434-1.433,0.0869'/%3E %3Cpath d='m521.73,307.92c0.43425,0,1.3886,0,1.6925-0.1737'/%3E %3Cpath d='m523.9,308.05c-0.26055,0.1737-1.0846,0.26055-1.432,0.3474'/%3E %3Cpath d='m523.25,308.87c0.3474-0.21712,1.0412-0.0869,1.4754-0.21712'/%3E %3Cpath d='m525.2,309.18c-0.39082,0-0.86849-0.0434-1.1714,0.0434-0.13027,0.0434-0.1737,0.13028-0.3474,0.0868'/%3E %3Cpath d='m526.63,310.26c-0.60794-0.0434-1.128,0.0868-1.6925,0.1737'/%3E %3Cpath d='m525.5,311.04c0.56349-0.26055,1.2583-0.26055,1.9086-0.3474'/%3E %3Cpath d='m527.02,312.73c0.1737,0.0434,0.60691-0.13028,0.69376-0.13028,0.99877-0.13027,1.129-0.34739,2.0399-0.30397'/%3E %3Cpath d='m530.23,312.73c-1.129,0.21712-1.5622,0.26055-2.4308,0.30397-0.13027,0-0.43321,0.0868-0.52006,0.13027'/%3E %3Cpath d='m527.8,313.52c0.8685-0.13027,2.1702-0.13027,3.0377-0.21712'/%3E %3Cpath d='m531.8,313.78c-0.6948,0.0868-1.5188,0-2.2136,0.13027-0.30398,0.0869-0.95431,0.0869-1.2583,0.1737'/%3E %3Cpath d='m529.19,314.64c0.13027,0,0.26055,0,0.34739-0.0434,0.6948-0.47767,1.8662-0.39082,2.9508-0.39082'/%3E %3Cpath d='m533.1,314.69c-0.99774,0-1.432,0.0434-2.1702,0.13028-0.47768,0.0434-1.0412,0.21712-1.1714,0.21712'/%3E %3Cpath d='m530.49,315.51c0.91192-0.1737,2.9084-0.3474,1.8662-0.26055,0.95534-0.0868,1.129-0.0868,2.1702-0.0868'/%3E %3Cpath d='m534.79,315.6c-0.65137-0.0868-1.2583-0.13028-1.736,0-0.3474,0.0869-0.47767,0.26055-1.9096,0.30397'/%3E %3Cpath d='m531.67,316.21c0.65033-0.0869,1.0412-0.0869,1.6057-0.21712,0.47664-0.13027,1.128-0.0868,1.736-0.0868'/%3E %3Cpath d='m532.32,316.55c0.91192-0.12924,1.0422-0.21609,2.1268-0.17267,0.30397,0,0.52006-0.0434,0.86745-0.0869'/%3E %3Cpath d='m516.74,303.75c0.25951-0.13028,0.17267-0.21713,0.56349-0.1737,0.30397-0.0868,0.52109,0.0434,0.56452-0.0868,0-0.0434,0.25951-0.0434,0.38979-0.0434'/%3E %3Cpath d='m516.13,303.41c0.26054-0.13028,0.30397-0.26055,0.69479-0.21713,0.38979-0.0434,0.56349,0,0.60691-0.13027,0.0434-0.0434,0.26055,0,0.43425,0'/%3E %3Cpath d='m524.33,309.96c0.26055-0.13027,0.13028-0.1737,0.5211-0.13027-0.0868-0.1737,0.43424,0,0.47767-0.0868,0.0434-0.0869,0.47767-0.0434,0.65033-0.0434'/%3E %3Cpath d='m525.9,311.56c0.65033-0.1737,1.432-0.1737,1.9955-0.39083'/%3E %3Cpath d='m528.85,311.87c-0.73821,0.13027-1.6925-0.0434-2.257,0.25951'/%3E %3Cpath d='m517.3,302.58c-0.73718-0.0434-1.3451,0.30294-1.7783,0.60691'/%3E %3Cpath d='m526.2,306.4c0.0869,0,1.129-0.1737,1.1725-0.1737'/%3E %3Cpath d='m526.55,306.66c0.39082-0.0869,0.95431-0.0434,1.1714-0.21713'/%3E %3Cpath d='m526.94,306.96c-0.0434,0,0.82404-0.13028,0.86746-0.13028,0.0869-0.0434,0.21713,0,0.3474,0'/%3E %3Cpath d='m527.28,307.27c0.12924-0.0869,1.2149-0.0869,1.3886-0.13027'/%3E %3Cpath d='m528.93,307.44c-0.21712-0.0434-1.0422,0.0868-1.1725,0.17266'/%3E %3Cpath d='m528.37,307.96c0.13028-0.0869,0.82404-0.1737,1.0412-0.1737'/%3E %3Cpath d='m529.84,308.14c-0.21713,0-0.99774,0.0868-1.2583,0.0868'/%3E %3Cpath d='m529.06,308.57c0.25951,0,1.0412-0.0869,1.2148-0.21713'/%3E %3Cpath d='m530.75,308.83c-0.30397,0-0.78061,0.0434-1.128,0.0434'/%3E %3Cpath d='m529.97,309.26c0.3474,0,1.0412,0,1.3017-0.13028'/%3E %3Cpath d='m531.67,309.39c-0.21713,0.13028-0.8685,0.1737-1.129,0.21712'/%3E %3Cpath d='m530.93,310c0.26055-0.1737,1.0422-0.0434,1.3451-0.13028'/%3E %3Cpath d='m532.66,310.22c-0.3474,0-0.69376-0.0434-0.95431,0.0434-0.0869,0.0434-0.1737,0.0434-0.30397,0.0434'/%3E %3Cpath d='m533.75,311.09c-0.47664-0.0434-1.0846,0.13028-1.4754,0.1737'/%3E %3Cpath d='m532.75,311.61c0.39082-0.1737,1.0846-0.13027,1.5622-0.21712'/%3E %3Cpath d='m533.83,312.91c0.0869,0.0434,0.65137-0.0434,0.73822-0.0434,0.73718-0.0869,0.86746-0.26055,1.5622-0.21712'/%3E %3Cpath d='m536.53,312.99c-0.8685,0.13027-1.2159,0.17369-1.9097,0.21712-0.0869,0-0.39082,0.0434-0.47767,0.0434'/%3E %3Cpath d='m534.49,313.56c0.69376-0.13028,1.8228-0.0868,2.5166-0.1737'/%3E %3Cpath d='m537.7,313.78c-0.52109,0.0868-1.1714,0-1.6925,0.0868-0.43425,0.0868-1.0422,0.13027-1.0856,0.13027'/%3E %3Cpath d='m535.48,314.47c0.0869,0,0.6948-0.1737,0.73822-0.1737,0.86746-0.0869,1.1714-0.1737,1.9965-0.21712'/%3E %3Cpath d='m538.69,314.47c-0.78061,0-1.0846,0.0434-1.6491,0.0868-0.39082,0.0434-1.0412,0.26055-1.128,0.26055'/%3E %3Cpath d='m536.57,315.16c0.56349-0.12924,2.256-0.30294,1.5622-0.25951,0.73719-0.0434,0.86746-0.0434,1.6481-0.0868'/%3E %3Cpath d='m540,315.16c-0.47664-0.0424-0.95431-0.0858-1.3451,0-0.21712,0.0868-0.47664,0.1737-1.5622,0.26055'/%3E %3Cpath d='m537.52,315.64c0.52007-0.0869,0.86746-0.0434,1.3017-0.1737,0.39082-0.13027,0.91088-0.0434,1.3451-0.0869'/%3E %3Cpath d='m537.96,315.9c0.69376-0.0869,0.95431-0.1737,1.7783-0.13027,0.21713,0,0.39083,0,0.6948-0.0434'/%3E %3Cpath d='m525.98,306.1c0.21712-0.0869,0.30397-0.21713,0.60795-0.1737,0.21712-0.0434,0.39082,0.0434,0.39082-0.0434,0.0434-0.0424,0.21712-0.0424,0.3474-0.0424'/%3E %3Cpath d='m525.63,305.79c0.21712-0.0868,0.26055-0.1737,0.56348-0.1737,0.30398,0,0.43425,0,0.47768-0.0434,0-0.0868,0.21712-0.0434,0.30397-0.0434'/%3E %3Cpath d='m531.8,310.82c0.21712-0.0869,0.26055-0.13028,0.60691-0.0869-0.13027-0.13028,0.30397,0,0.3474-0.0858,0-0.0445,0.3474,0,0.47767,0'/%3E %3Cpath d='m533.18,312.08c0.47664-0.12924,1.0846-0.12924,1.5188-0.34637'/%3E %3Cpath d='m535.44,312.3c-0.56349,0.0869-1.3886-0.0434-1.8662,0.21712'/%3E %3Cpath d='m526.55,305.18c-0.56452-0.0434-0.69376,0.1737-1.0412,0.43425'/%3E %3Cpath d='m534.31,306.75c0.0869,0,0.99773-0.13027,1.0846-0.13027'/%3E %3Cpath d='m534.62,307.05c0.34637-0.0868,0.91089-0.0868,1.0846-0.21713'/%3E %3Cpath d='m534.96,307.31,0.82507-0.13028c0.0869-0.0434,0.21712,0,0.30397,0'/%3E %3Cpath d='m535.35,307.74c0.13027-0.0868,1.0422-0.25952,1.2159-0.25952'/%3E %3Cpath d='m536.83,307.74c-0.21712-0.0434-1.0846,0.13027-1.2148,0.21712'/%3E %3Cpath d='m536.09,308.27c0.0869-0.0869,0.95431-0.21712,1.1714-0.17369'/%3E %3Cpath d='m537.7,308.4c-0.26054,0-0.95534,0.0434-1.3017,0.13027'/%3E %3Cpath d='m536.83,308.79c0.26055,0,1.0856-0.0868,1.2149-0.21712'/%3E %3Cpath d='m538.52,309c-0.25952,0-0.91089,0.0869-1.2583,0.13027'/%3E %3Cpath d='m537.78,309.44c0.30294,0,0.99774,0,1.2149-0.13028'/%3E %3Cpath d='m539.35,309.52c-0.21713,0.13027-0.95535,0.13027-1.2149,0.21712'/%3E %3Cpath d='m538.69,310.13c0.21712-0.1737,0.91191-0.0868,1.2148-0.1737'/%3E %3Cpath d='m540.26,310.31c-0.30397,0-0.60691,0-0.86746,0.0434-0.0434,0.0434-0.26055,0.0434-0.3474,0.0434'/%3E %3Cpath d='m541.26,311.09c-0.43425-0.0434-0.95535,0.13028-1.3462,0.1737'/%3E %3Cpath d='m540.26,311.65c0.39082-0.1737,1.0856-0.1737,1.5622-0.26055'/%3E %3Cpath d='m541.34,312.82c0.0858,0,0.60691-0.0868,0.69376-0.0868,0.69479-0.0869,0.82403-0.21713,1.432-0.1737'/%3E %3Cpath d='m543.81,312.86c-0.78164,0.13028-1.128,0.1737-1.736,0.21713-0.0869,0-0.39082,0-0.43425,0.0434'/%3E %3Cpath d='m541.91,313.47c0.65137-0.0869,1.736-0.1737,2.3429-0.21713'/%3E %3Cpath d='m544.94,313.6c-0.52006,0.0434-1.128,0-1.6057,0.0868-0.39082,0.0858-0.95431,0.0858-0.99773,0.12924'/%3E %3Cpath d='m542.86,314.21c0.0869,0,0.65137-0.13027,0.6948-0.13027,0.78164-0.0868,1.0846-0.1737,1.8662-0.21712'/%3E %3Cpath d='m545.85,314.21c-0.73821,0.0434-0.99876,0.0434-1.5188,0.0869-0.39083,0.0434-0.95535,0.26055-1.0856,0.26055'/%3E %3Cpath d='m543.86,314.86c0.56453-0.0868,2.1258-0.30397,1.4754-0.21712,0.65034-0.0869,0.78061-0.0869,1.5188-0.0869'/%3E %3Cpath d='m547.07,314.86c-0.47767-0.0434-0.95534-0.0868-1.2583,0-0.21712,0.0869-0.43425,0.1737-1.432,0.21713'/%3E %3Cpath d='m544.77,315.29c0.43425-0.0434,0.78164-0.0434,1.2149-0.17266,0.34739-0.0869,0.78164-0.0434,1.2159-0.0434'/%3E %3Cpath d='m545.12,315.55c0.69479-0.0868,0.91088-0.13027,1.6925-0.13027,0.21713,0,0.3474,0,0.60795-0.0434'/%3E %3Cpath d='m534.14,306.49c0.1737-0.0869,0.21713-0.1737,0.5211-0.13028,0.21712-0.0434,0.3474,0,0.39082-0.0434,0-0.0434,0.1737-0.0434,0.30294-0.0434'/%3E %3Cpath d='m533.79,306.23c0.21712-0.0869,0.21712-0.1737,0.52109-0.13027,0.26055-0.0434,0.39082,0,0.43425-0.0869,0-0.0434,0.17266-0.0434,0.30397-0.0434'/%3E %3Cpath d='m539.48,310.87c0.1737-0.0868,0.25951-0.0868,0.52006-0.0868-0.0869-0.12924,0.30397,0,0.3474-0.0434,0.0434-0.0434,0.3474-0.0434,0.43425-0.0434'/%3E %3Cpath d='m540.69,312c0.43321-0.0869,1.0846-0.0869,1.4754-0.26055'/%3E %3Cpath d='m542.86,312.21c-0.56349,0.0868-1.432-0.0434-1.8652,0.1737'/%3E %3Cpath d='m534.66,305.66c-0.5211-0.0434-0.6948,0.1737-0.99877,0.38979'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg fill='%23fc0'%3E %3Cpath d='M491.53,373.25l0.75,5.56c-1.47-0.48-2.82,0.38-3.47,1.6-1.04,2.08-0.12,3.65,1.88,4.65l2.69,1.38,5-9.72-2-1-2,3.9h-0.04l-0.43-5.15-2.38-1.22zm0.75,7.34c0.32,0.03,0.67,0.17,1.03,0.35l0.25,0.12-1.4,2.66-0.25-0.13c-0.91-0.47-1.52-1.04-1-2.12,0.35-0.68,0.83-0.92,1.37-0.88z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='39.783,154.09,42.594,155.98,44.188,153.63,41.251,151.66,42.258,150.15,46.958,153.34,41.083,162.07,36.383,158.92,37.391,157.45,40.328,159.38,40.328,159.38,41.629,157.45,38.775,155.56'/%3E %3Cpath d='M480.84,365.62l-2.65,3.07-0.85-0.69c-1.73-1.52-3.48-1.45-5,0.28-1.6,1.91-1.01,3.58,0.82,5.1l2.28,1.96,7.06-8.28-1.66-1.44zm-5.53,3.54c0.38,0.03,0.8,0.29,1.25,0.68l0.35,0.25-1.97,2.29-0.32-0.26c-0.82-0.69-1.29-1.34-0.46-2.34,0.41-0.48,0.77-0.66,1.15-0.62z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' d='m451.31,368.27-1.4754-1.6491,4.512-4.1212c0.99774-0.86849,2.3429-2.257,1.0846-3.6446-1.2583-1.3886-2.7771-0.21712-3.7738,0.6948l-4.5131,4.0778-1.4754-1.6057,4.816-4.3818c1.9965-1.7794,4.2525-2.257,6.2914-0.0434,2.0389,2.256,1.3451,4.512-0.65034,6.2914l-4.816,4.3818z'/%3E %3Cpath d='M463.44,347.66c-0.62-0.05-1.27,0.1-1.94,0.56-0.95,0.69-1.69,1.93-1.12,3.19-0.79-0.35-1.67-0.11-2.32,0.37-1.78,1.22-1.74,2.73-0.53,4.47l1.56,2.25,9-6.16-1.97-2.84c-0.73-1.06-1.65-1.76-2.68-1.84zm-0.03,2.34c0.65-0.06,1.13,0.47,1.59,1.12l0.28,0.35-2.31,1.56-0.19-0.25c-0.56-0.82-1.15-1.79-0.06-2.53,0.26-0.17,0.47-0.23,0.69-0.25zm-3.19,3.16c0.4-0.01,0.74,0.26,1.06,0.75l0.16,0.21-2.13,1.47-0.15-0.21c-0.48-0.7-0.62-1.35,0.25-1.91,0.31-0.23,0.57-0.31,0.81-0.31z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='16.87,122.62,18.422,121.78,20.898,126.31,11.625,131.35,10.575,129.46,18.296,125.31,18.296,125.31'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='16.702,117.84,16.702,117.84,17.542,119.81,7.889,124.05,7.05,122.08'/%3E %3Cpath fill-rule='evenodd' d='m431.09,327.83c-0.52006,0.78165-0.60691,1.8228-0.34636,2.7337,0.69376,1.9965,2.8205,2.561,4.6423,1.9965,1.736-0.56452,3.08-2.3429,2.4297-4.2949-0.25951-0.91088-1.0412-1.6491-1.8652-2.0399l2.3863-0.78061c0.65034,0.69376,1.1714,1.3886,1.432,2.256,0.99773,3.0377-0.78061,6.0743-3.6446,7.0296-2.9508,0.9543-6.248-0.3474-7.2891-3.5143-0.26055-0.86746-0.30397-1.736-0.17266-2.6034l2.4276-0.78268z'/%3E %3Cpath d='M452.44,313.25l-10.25,6.22,0.31,1.69,11.78,2.37-0.44-2.28-2.4-0.53-0.72-3.88,2.16-1.28-0.44-2.31zm-3.32,4.53l0.47,2.63-4.12-0.5v-0.07l3.65-2.06z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M446.69,292.88c-2.82,0.01-5.04,1.97-5.28,5.06l-0.25,3.12,10.84,0.88,0.25-3.13c0.26-3.21-1.92-5.64-5-5.9-0.19-0.02-0.37-0.04-0.56-0.03zm-0.41,2.5c0.24-0.02,0.49-0.03,0.75,0,1.95,0.13,3.22,1.21,3,3.68v0.32l-6.53-0.54,0.03-0.31c0.15-2.01,1.09-3.04,2.75-3.15z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='8.183,68.444,7.512,71.76,10.323,72.347,11.037,68.906,12.757,69.242,11.625,74.823,1.301,72.641,2.434,67.102,4.196,67.479,3.483,70.92,3.483,70.92,5.749,71.382,6.462,68.067'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='12.589,55.393,11.331,58.583,13.974,59.59,15.275,56.316,16.954,56.946,14.897,62.233,5.036,58.415,7.134,53.127,8.813,53.757,7.512,57.072,7.512,57.072,9.652,57.911,10.911,54.722'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='18.926,48.973,20.521,49.77,18.171,54.386,8.771,49.56,9.736,47.672,17.542,51.659,17.542,51.659'/%3E %3Cpath fill-rule='evenodd' d='m446.19,249.87c-0.6948,0.0434-1.3017,0.25952-1.736,0.82404-0.43424,0.60691-0.43424,1.432,0.13028,1.8662,1.4744,1.0846,3.5577-2.9942,6.5075-0.78164,1.736,1.3017,2.1257,3.3406,0.73719,5.2068-0.91089,1.2583-2.2994,1.6491-3.7748,1.5178l-0.21712-1.952c0.86746,0.25951,1.9096,0.0858,2.4731-0.6948,0.56349-0.69376,0.30397-1.6057-0.38979-2.0823-0.91088-0.69376-1.7794,0-2.6034,0.52006-1.3017,0.82403-2.5166,1.2583-3.8617,0.26055-1.4754-1.0846-1.8228-3.08-0.69376-4.5989,0.60691-0.82404,1.8228-1.6491,2.8205-1.7794l0.60795,1.6936z'/%3E %3Cpath d='M467.19,240.31l-1.22,1.22,4.97,10.97,1.62-1.69-1-2.25,2.72-2.81,2.28,0.94,1.63-1.69-11-4.69zm1.72,3.1l3.47,1.59-1.69,1.78-1.81-3.34,0.03-0.03z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='40.328,24.549,41.461,25.934,37.432,29.208,30.802,20.982,32.481,19.64,37.978,26.438,37.978,26.438'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='42.888,12.337,44.86,11.121,47.042,22.535,45.993,23.207,36.635,16.324,38.565,15.065,44.608,19.682,44.608,19.682,44.65,19.64'/%3E %3Cpath d='M495.25,221l-1.56,0.75,0.56,12.03,2.13-0.97-0.1-2.53,3.56-1.59,1.75,1.75,2.16-0.97-8.5-8.47zm0.44,3.56l2.69,2.78-2.26,1-0.43-3.72v-0.06z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M507.41,217.22c-0.56,0-1.16,0.1-1.75,0.28l-3,0.88,3.06,10.43,2.97-0.84c3.12-0.91,4.65-3.83,3.78-6.78-0.71-2.44-2.65-3.99-5.06-3.97zm-0.07,2.28c1.36,0.05,2.27,0.84,2.72,2.41,0.57,1.86-0.02,3.4-2.4,4.09l-0.32,0.12-1.81-6.28,0.31-0.12c0.56-0.15,1.05-0.24,1.5-0.22z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M520.5,214.06c-0.2,0.01-0.42,0.04-0.62,0.06-3.26,0.44-5.19,3.37-4.76,6.41,0.39,3.08,3.03,5.37,6.29,4.94,3.29-0.44,5.2-3.33,4.81-6.41-0.37-2.85-2.71-5.09-5.72-5zm-0.25,2.44c1.73-0.22,3.19,1.21,3.41,2.81,0.17,1.48-0.87,3.52-2.57,3.78-1.69,0.22-3.25-1.52-3.47-3-0.17-1.6,0.85-3.37,2.63-3.59z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M529.53,213.56l-0.12,10.91h2.21l0.04-4.38h0.03l2.69,4.44,2.68,0.03-3.15-4.62c1.52-0.22,2.34-1.61,2.34-3,0.04-2.35-1.51-3.3-3.72-3.35l-3-0.03zm2.25,1.94h0.31c1.04,0,1.86,0.25,1.82,1.47,0,1.21-0.78,1.53-1.91,1.53h-0.25l0.03-3z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='110.2,9.064,106.88,8.225,106.21,10.995,109.65,11.876,109.19,13.597,103.69,12.212,106.26,1.972,111.75,3.357,111.33,5.12,107.89,4.238,107.89,4.238,107.35,6.504,110.62,7.302'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='119.98,13.849,122.62,7.26,124.59,8.057,120.61,18.045,119.18,17.457,116.54,8.477,116.49,8.477,113.85,15.107,111.88,14.352,115.91,4.28,115.91,4.28,117.33,4.826,119.94,13.849'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='132.52,22.661,131.56,24.172,127.19,21.444,132.82,12.505,134.62,13.639,129.96,21.066,129.96,21.066'/%3E %3Cpath d='M588.72,233.25l-10.5,5.91,1.81,1.46,2.16-1.21,3.03,2.53-0.75,2.34,1.84,1.47,3.75-11.41-1.34-1.09zm-1.63,3.16l-1.25,3.62-1.9-1.53,3.15-2.09z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M605.06,250.31l-11.62,2.97,1.34,1.88,2.44-0.57,2.28,3.16-1.34,2.09,1.4,1.91,6.53-10.06-1.03-1.38zm-2.34,2.63l-2.16,3.18-1.44-2,3.6-1.18z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='159.26,58.289,158.29,56.358,163.75,52.624,163.75,52.624,163.75,52.624,156.65,53.379,156.32,52.75,161.19,47.588,161.19,47.546,154.89,49.645,153.93,47.714,164.42,44.482,165.13,45.826,160.14,51.365,167.48,50.567,168.19,51.952'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='166.1,64.206,165,60.975,162.32,61.898,163.45,65.255,161.73,65.843,159.93,60.429,169.92,57.072,171.76,62.443,170.04,63.031,168.91,59.674,168.91,59.674,166.73,60.429,167.82,63.619'/%3E %3Cpath d='M619.81,282.16l-10.62,2.25,0.43,2.15,4.29-0.9h0.06l-3.75,3.65,0.59,2.6,3.81-4.07c0.57,1.44,2.07,1.9,3.41,1.6,2.3-0.48,2.92-2.16,2.44-4.38l-0.66-2.9zm-1.34,2.62l0.06,0.28c0.22,1.04,0.15,1.91-1.06,2.13-1.17,0.26-1.63-0.45-1.85-1.53l-0.06-0.25,2.91-0.63z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='164.5,80.027,164.5,80.027,164.25,77.928,174.74,76.711,174.99,78.81'/%3E %3Cpath fill-rule='evenodd' d='m603.56,306.83c0.73822-0.60794,1.128-1.5622,1.128-2.5166-0.0434-2.1268-1.952-3.2982-3.8172-3.2538-1.8228,0-3.6446,1.3017-3.6012,3.383,0,0.91192,0.47767,1.8662,1.1714,2.4742l-2.5166,0.0434c-0.39082-0.82507-0.69376-1.6491-0.69376-2.56-0.0445-3.2103,2.56-5.5976,5.5532-5.6411,3.1235-0.0434,5.8572,2.1692,5.944,5.5108,0,0.86746-0.21713,1.7783-0.60795,2.5166l-2.56,0.0434z'/%3E %3Cpath d='M611.66,308.88l-0.25,2.31,2.15,1.19-0.47,3.9-2.43,0.56-0.25,2.35,11.62-2.85,0.22-1.75-10.59-5.71zm3.65,4.46l3.41,1.57v0.03l-3.72,0.84,0.31-2.44z' transform='translate(-16.12698,0)'/%3E %3Cpath fill-rule='evenodd' d='m595.92,340.16c0.91088-0.34739,1.6491-1.0412,1.9965-1.9096,0.78061-1.9955-0.5211-3.8172-2.257-4.512-1.6925-0.65034-3.8607-0.17267-4.6423,1.736-0.3474,0.91192-0.25952,1.9531,0.1737,2.7771l-2.3863-0.91089c-0.0434-0.91088,0-1.7794,0.34636-2.6468,1.1725-2.9508,4.512-4.2081,7.2902-3.08,2.9074,1.128,4.5989,4.2515,3.383,7.3326-0.34636,0.82507-0.86746,1.5623-1.5188,2.1268l-2.3852-0.91296z'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='158.33,129.17,159.93,126.19,157.41,124.8,155.73,127.95,154.18,127.07,156.86,122.08,166.14,127.11,163.45,132.1,161.86,131.22,163.58,128.12,163.58,128.12,161.52,127.03,159.89,130.01'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='151.24,137.48,156.99,141.63,155.73,143.39,147.04,137.02,147.93,135.8,157.28,135.46,157.32,135.46,151.53,131.22,152.79,129.5,161.52,135.88,161.52,135.88,160.64,137.14,151.28,137.43'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='150.57,146.37,152.12,144.78,153.38,146,148.85,150.74,147.59,149.52,149.1,147.92,142.76,141.84,142.76,141.84,144.23,140.29'/%3E %3Cpath d='M585.53,363.41l-1.72,1.37,2.81,3.41v0.03l-4.93-1.6-2.07,1.69,5.41,1.47c-1,1.17-0.75,2.73,0.16,3.81,1.47,1.78,3.31,1.53,5,0.1l2.28-1.91-6.94-8.37zm2.09,6.12l1.91,2.31-0.22,0.16c-0.82,0.69-1.56,1.01-2.34,0.09-0.78-0.95-0.37-1.68,0.5-2.37l0.15-0.19z' transform='translate(-16.12698,0)'/%3E %3Cpath d='M578.72,369.06l-2,1.25,0.44,2.44-3.35,2.06-1.93-1.47-2,1.25,9.59,7.22,1.44-0.9-2.19-11.85zm-1.25,5.72l0.97,3.63h-0.06l-3-2.32,2.09-1.31z' transform='translate(-16.12698,0)'/%3E %3Cpolygon fill-rule='evenodd' transform='matrix(1.0339204,0,0,1.0339204,425.01778,213.54926)' points='118.72,160.39,117.96,158.79,122.62,156.57,127.15,166.14,125.22,167.02,121.49,159.13,121.49,159.13'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2800' height='1400'%3E %3Crect width='2800' height='1400' fill='%2312ad2b'/%3E %3Crect y='400' width='2800' height='600' fill='%23ffce00'/%3E %3Cpath d='M 0,0 V 1400 L 700,700' fill='%23d21034'/%3E %3Cg id='star' transform='translate(1400,700)' fill='%23000'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-200 v 200 h 100' transform='rotate(18 0,-200)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' x='700'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500' viewBox='0 0 20 10'%3E %3Crect fill='%23078930' width='20' height='10'/%3E %3Crect fill='%23FFF' width='20' height='7'/%3E %3Crect width='20' height='3'/%3E %3Crect fill='%23DA121A' y='3.5' width='20' height='3'/%3E %3Cpolygon fill='%230F47AF' points='0,0 8.660254,5 0,10'/%3E %3Cpolygon fill='%23FCDD09' points='-513674,0 415571,301930 -158734,-488533 -158734,488533 415571,-301930' transform='translate(2.88675,5) scale(0.000003114816)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23377e3f' /%3E %3Crect y='120' width='900' height='360' fill='%23fff' /%3E %3Crect y='180' width='900' height='240' fill='%23b40a2d' /%3E %3Cpath d='M 450,191.459 520.534,408.541 335.873,274.377 564.127,274.377 379.466,408.541 z' fill='%23ecc81d' /%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 81 54'%3E %3Crect fill='%234189DD' width='81' height='54'/%3E %3Cg transform='translate(40.5 27) scale(13)'%3E %3Cg id='t'%3E %3Cpolygon id='w' fill='%23FFF' points='0,0 0,1 .5,1' transform='translate(0 -1) rotate(18)'/%3E %3Cuse xlink:href='%23w' transform='scale(-1 1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(144)'/%3E %3Cuse xlink:href='%23t' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='300' height='600' fill='%2300853f'/%3E %3Crect x='300' width='300' height='600' fill='%23fdef42'/%3E %3Crect x='600' width='300' height='600' fill='%23e31b23'/%3E %3Cg transform='translate(450,300)' fill='%2300853f'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-100 v 100 h 50 z' transform='rotate(18 0,-100)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='800' height='600'%3E %3Crect fill='%235eb6e4' width='800' height='600'/%3E %3Crect fill='%23fff' width='800' height='300'/%3E %3Cg id='coa'%3E %3Cg id='crown' fill='none' stroke='%23000' stroke-width='0.933'%3E %3Cg fill='%23fff'%3E %3Ccircle cx='459.439' cy='171.232' r='4.044'/%3E %3Ccircle cx='461.689' cy='157.024' r='5.081'/%3E %3Ccircle cx='376.388' cy='141.721' r='3.909'/%3E %3Ccircle cx='338.47' cy='157.024' r='5.081'/%3E %3Ccircle cx='361.666' cy='143.366' r='4.218'/%3E %3Ccircle cx='340.72' cy='171.232' r='4.044'/%3E %3Ccircle cx='346.87' cy='147.119' r='4.885'/%3E %3Ccircle cx='423.77' cy='141.721' r='3.909'/%3E %3Ccircle cx='438.492' cy='143.366' r='4.218'/%3E %3Ccircle cx='453.288' cy='147.119' r='4.886'/%3E %3C/g%3E %3Cg stroke-width='1.09'%3E %3Ccircle cx='459.439' cy='171.231' r='4.458'/%3E %3Ccircle cx='461.69' cy='157.025' r='5.602'/%3E %3Ccircle cx='376.389' cy='141.721' r='4.31'/%3E %3Ccircle cx='338.47' cy='157.025' r='5.602'/%3E %3Ccircle cx='361.666' cy='143.367' r='4.65'/%3E %3Ccircle cx='340.718' cy='171.231' r='4.458'/%3E %3Ccircle cx='346.871' cy='147.119' r='5.386'/%3E %3Ccircle cx='423.769' cy='141.721' r='4.309'/%3E %3Ccircle cx='438.492' cy='143.365' r='4.65'/%3E %3Ccircle cx='453.287' cy='147.119' r='5.387'/%3E %3C/g%3E %3Cg fill='%23000' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m392.488 132.016c-13.4834 15.5386-37.154 7.94825-47.9528 13.9984-18.7842 10.523 1.64882 35.4862 5.49625 40.2579l20.4697-5.3427c-7.51535-6.013-22.5874-16.2266-18.0484-24.525 4.65236-8.50925 29.3711 0.12401 40.1806-18.0396 2.27362-3.82028 0.53149-7.12735-0.14528-6.349z'/%3E %3Cpath fill='%23f1bf31' d='m392.488 132.481c-13.4834 15.5422-36.3898 8.0941-47.1862 14.1449-18.7848 10.5242 2.4313 34.8756 6.27875 39.649l17.6817-5.3445c-7.5183-6.013-21.7996-16.536-17.2606-24.835 4.65118-8.50865 29.8222-0.0307 40.6317-18.1949 2.27362-3.82028 0.5315-6.19725-0.14528-5.4195z'/%3E %3Cpath stroke-width='0.633' d='m393.711 133.678c-14.6026 19.7168-36.5226 9.7636-45.9432 17.455-10.6418 8.69055 4.8626 25.7953 12.3431 32.5624l1.16943-0.42933c-6.0691-5.75375-24.0579-22.8396-12.6278-32.0652 8.2193-6.63605 31.3311 2.02086 45.1075-17.0546z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m357.83 171.306c-0.35847 0.67855-0.89469 1.84901-1.25611 3.33189-6.24155-7.43505-10.917-15.14-5.99825-21.5044 4.47816-5.79565 15.453-3.17304 26.8778-7.187 5.2329-1.55197 10.3689-4.31575 14.7431-9.4943-0.42048 1.13386-0.85512 2.5063-1.33761 3.87992-11.5955 14.7638-34.7527 7.689-39.1671 15.7612-2.60433 4.7628 1.09487 10.2584 6.13819 15.2126z'/%3E %3Cpath stroke='none' d='m352.11 169.98c1.30334-0.37618 1.96831-1.09843 2.6935-1.94174 0.29528 0.35729 0.60118 0.7128 0.91772 1.06713-0.49901 0.66142-1.06949 1.31044-1.9252 1.75925-1.03465 0.54272-2.16792 0.68091-3.22914 0.68091-0.3555-0.47658-0.70157-0.95965-1.03701-1.44567 0.86103 0.0862 1.82717 0.098 2.58012-0.11988zm-2.8115-5.7715c1.13504-0.17835 1.5939-0.29292 2.49272-0.8002 0.1559 0.34311 0.32893 0.68681 0.51791 1.03051-0.75826 0.44055-1.37775 0.70453-2.42775 0.91949-1.0559 0.21792-2.15138 0.15355-3.12284-0.008-0.20787-0.44527-0.40098-0.89055-0.57519-1.33523 0.94842 0.18307 2.17441 0.34134 3.11516 0.1937zm1.5385-4.8125c-2.07343-0.19843-4.08544-1.28327-5.4951-2.82756 0.0998-0.41339 0.2309-0.82146 0.39271-1.22067 0.81142 1.01456 2.57009 2.76909 5.1862 2.99705-0.0549 0.34842-0.0821 0.69862-0.0838 1.05118zm1.806-4.554c-1.48229-0.86398-2.70473-2.22815-3.45709-3.77185 0.27519-0.19607 0.56338-0.37796 0.86693-0.54567 0.5498 1.16693 1.58327 2.74134 3.38917 3.64311-0.28937 0.20787-0.5557 0.43228-0.79901 0.67441zm3.9835-6.1505c0.24567 1.40728 0.99035 2.59665 2.14547 3.45118-0.38268 0.0803-0.75472 0.16595-1.11614 0.25748-1.02401-0.95019-1.69134-2.17677-1.9311-3.58051 0.29586-0.0455 0.59645-0.088 0.90177-0.12815zm7.098-0.6195c0.36909 1.04586 1.11201 1.96772 2.09173 2.70709 0.10925 0.0815 0.16477 0.18366 0.18189 0.28642l-1.10669 0.13937c-0.99922-0.84803-1.74567-1.89095-2.10296-3.06437l0.93603-0.0685zm6.9235-0.688c0.67145 1.03229 1.58976 1.90276 2.68464 2.55237-0.42638 0.085-0.85275 0.16653-1.27795 0.24271-0.97855-0.72638-1.7941-1.62874-2.39646-2.66398 0.32893-0.0413 0.65905-0.0845 0.98976-0.1311zm6.187-1.259c0.89527 0.86634 2.02972 1.50827 3.24153 1.92048-0.42992 0.16417-0.86338 0.3183-1.29862 0.46417-1.11733-0.51082-2.14016-1.21712-2.9504-2.11712 0.33662-0.0845 0.67205-0.17363 1.00748-0.26752zm6.2295-2.395c0.83031 0.6 1.92106 0.99626 2.89783 1.2378-0.33071 0.23149-0.66614 0.45118-1.00512 0.66378-0.99685-0.31595-2.01791-0.78603-2.79744-1.45807 0.30237-0.14233 0.60414-0.29055 0.90473-0.44351zm4.592-2.906c0.65964 0.33071 1.42913 0.56456 2.18149 0.72638-0.23799 0.26339-0.48071 0.51733-0.72697 0.76477-0.79016-0.20551-1.57854-0.4937-2.25295-0.89469 0.26752-0.19252 0.53386-0.39153 0.79842-0.59645z'/%3E %3Cpath fill='none' stroke-width='0.604' d='m393.76 134.456c0.0437 0.95374-0.22618 1.77579-1.125 3.28878-10.8118 18.1636-36.2918 9.84035-40.9435 18.3508-4.47225 8.17915 9.6425 18.5168 17.2376 24.5716-1.33288 0.4813-2.73839 0.90295-4.21654 1.26023l-1.32697 0.71811-1.96654 0.62067c-6.0691-5.7555-24.0414-22.6854-12.613-31.9087 8.22225-6.63605 31.1776 2.17382 44.954-16.9016z'/%3E %3Cpath d='m407.522 132.016c13.4852 15.5386 37.1558 7.94825 47.9522 13.9984 18.7848 10.523-1.64823 35.4862-5.4933 40.2579l-20.4726-5.3427c7.5183-6.013 22.588-16.2266 18.0514-24.525-4.65296-8.50925-29.3734 0.12401-40.1835-18.0396-2.27303-3.82028-0.52854-7.12735 0.14587-6.349z'/%3E %3Cpath fill='%23f1bf31' d='m407.671 132.481c13.4834 15.5422 36.3898 8.0941 47.1862 14.1449 18.7842 10.5242-2.4313 34.8756-6.27875 39.649l-17.6823-5.3445c7.5189-6.013 21.7996-16.536 17.2624-24.835-4.65237-8.50865-29.824-0.0307-40.6329-18.1949-2.27363-3.82028-0.5315-6.19725 0.14527-5.4195z'/%3E %3Cpath stroke-width='0.633' d='m438.879 183.266c6.0697-5.75375 24.0585-22.8396 12.6284-32.0652-8.2205-6.63605-31.3317 2.02086-45.1081-17.0546l0.0496-0.46832c14.602 19.7168 36.5226 9.7636 45.9432 17.455 10.6258 8.6752-4.95 25.7374-12.46 32.5282z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m442.329 171.306c0.35787 0.67855 0.89409 1.84901 1.25551 3.33189 6.24155-7.43505 10.9176-15.14 5.9988-21.5044-4.47815-5.79625-15.4548-3.17245-26.8796-7.1876-5.2329-1.55197-10.3683-4.31575-14.742-9.4937 0.42048 1.13268 0.85335 2.50394 1.33642 3.87638 11.5931 14.7685 34.7575 7.69195 39.1701 15.7648 2.60315 4.7628-1.09548 10.2584-6.13935 15.2126z'/%3E %3Cpath stroke='none' d='m448.048 170.6c-1.50177-0.37264-2.24764-1.0311-3.23268-1.9252-0.29587 0.34134-0.60118 0.6815-0.91536 1.01988 0.68918 0.66437 1.39725 1.31575 2.46202 1.78996 0.92007 0.40807 1.88917 0.56457 2.81398 0.61063 0.34547-0.45177 0.68327-0.90768 1.01279-1.36831-0.73642 0.0454-1.51004 0.0296-2.14075-0.12697zm2.8125-6.3925c-1.13563-0.17835-1.59331-0.29292-2.49213-0.8002-0.1559 0.34311-0.32952 0.68681-0.51791 1.03051 0.75768 0.43996 1.37598 0.70453 2.42657 0.91949 1.0565 0.21792 2.15197 0.15355 3.12284-0.008 0.20846-0.44527 0.40217-0.89055 0.57579-1.33523-0.94901 0.18307-2.175 0.34134-3.11516 0.1937zm-1.538-4.8125c2.07401-0.19902 4.08425-1.28445 5.4939-2.82756-0.0992-0.41339-0.23091-0.82028-0.39272-1.22008-0.81023 1.01456-2.5689 2.76791-5.18445 2.99587 0.0543 0.34842 0.0815 0.69921 0.0833 1.05177zm-1.8045-4.554c1.48051-0.86339 2.70236-2.22815 3.45472-3.77126-0.2746-0.19666-0.56338-0.37855-0.86693-0.54626-0.5498 1.16693-1.58327 2.74075-3.38799 3.64252 0.28996 0.20787 0.5563 0.43287 0.80019 0.675zm-3.986-6.1505c-0.24626 1.40728-0.99095 2.59606-2.14489 3.45059 0.38268 0.0803 0.75414 0.16594 1.11555 0.25748 1.02343-0.9502 1.69134-2.17678 1.93052-3.57993-0.29587-0.0455-0.59587-0.088-0.90118-0.12815zm-7.098-0.6195c-0.3691 1.04586-1.11083 1.96772-2.09233 2.70709-0.10866 0.0815-0.16476 0.18307-0.1813 0.28582l1.10788 0.13996c0.99862-0.84803 1.74508-1.89094 2.10236-3.06437l-0.93661-0.0685zm-6.9225-0.688c-0.67146 1.0317-1.59036 1.90217-2.68642 2.55178 0.42697 0.085 0.85334 0.16712 1.27913 0.2433 0.97737-0.72638 1.79351-1.62874 2.39528-2.66398-0.32835-0.0408-0.65788-0.0844-0.988-0.1311zm-6.188-1.259c-0.89528 0.86634-2.02914 1.50827-3.24036 1.91989 0.42933 0.16417 0.86339 0.31771 1.29744 0.46417 1.11851-0.51082 2.14016-1.21712 2.9504-2.11653-0.33603-0.0845-0.67205-0.17363-1.00748-0.26752zm-6.2285-2.3945c-0.82973 0.59941-1.92048 0.99567-2.89784 1.23721 0.3313 0.23149 0.66733 0.45 1.00571 0.66319 0.99568-0.31595 2.01615-0.78544 2.79627-1.45689-0.30296-0.14174-0.60414-0.29055-0.90414-0.44351zm-4.5935-2.9065c-0.65906 0.3313-1.42855 0.56457-2.17973 0.72638 0.2374 0.26339 0.48012 0.51674 0.72579 0.76418 0.79016-0.20551 1.57737-0.4937 2.25237-0.8941-0.26752-0.19311-0.53386-0.39153-0.79843-0.59645z'/%3E %3Cpath fill='none' stroke-width='0.604' d='m406.399 134.456c-0.0437 0.95374 0.22677 1.77579 1.12795 3.28878 10.8088 18.1636 36.2894 9.84035 40.9424 18.3508 4.47048 8.17915-9.6437 18.5168-17.2394 24.5716 1.33288 0.4813 2.73839 0.90295 4.21713 1.26023l1.32638 0.71811 1.96654 0.62067c6.0691-5.7555 24.0414-22.6854 12.6136-31.9087-8.22225-6.63605-31.1782 2.17382-44.9546-16.9016z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23000' d='m400.079 166.698h-6.84155s0.81023-6.52205-0.10571-10.9406c-0.74114-3.57284-3.59174-7.67365-3.59174-10.6807 0-3.00591 3.25571-11.4526 3.25571-11.4526h7.28326 7.28445s3.0998 8.44665 3.0998 11.4526c0 3.00709-2.69587 7.1079-3.43701 10.6807-0.91535 4.41851-0.1057 10.9406-0.1057 10.9406h-6.84155z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m400.079 166.698h-6.84155s1.05295-6.5114 0.20374-10.9406c-0.69154-3.60414-3.1252-6.401-3.44646-10.0571-0.4565-5.1579 4.04232-12.0762 4.04232-12.0762h6.04195 6.0425s4.34351 6.9183 3.88819 12.0762c-0.32126 3.6561-2.60138 6.45295-3.29291 10.0571-0.84862 4.42913 0.20374 10.9406 0.20374 10.9406h-6.84155z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m389.977 144.402c0.43051-0.14646 0.88583-0.24862 1.31811-0.24862 1.50118 0 2.09528 0.98031 2.09528 0.98031s3.93189-0.91004 6.68919-0.91004c2.75729 0 6.69036 0.91004 6.69036 0.91004s0.59409-0.98031 2.09468-0.98031c0.38091 0 0.77953 0.0791 1.1628 0.19902 0.0254 0.45826 0.0224 0.90944-0.0159 1.34823-0.32185 3.65846-2.60374 6.45294-3.29292 10.0571-0.42047 2.18918-0.37677 4.88623-0.22382 7.0553l-6.41515 3.0502-6.41515-3.05079c0.15296-2.16909 0.19784-4.86555-0.22204-7.05475-0.69154-3.60413-3.12461-6.39865-3.44823-10.0571-0.0372-0.42283-0.0414-0.85689-0.0171-1.29862z'/%3E %3Cpath fill='%23000' stroke='none' d='m407.092 146.815c-0.29882 0.94311-0.77835 2.45256-1.1941 3.975-0.41516 1.52185-0.7683 3.05374-0.81555 4.04468-0.19074 3.8693 0.47244 8.0699 1.24194 11.863h-0.27875c-1.08661-3.31772-2.34508-8.42835-2.29665-11.8695 0.0272-2.09468 1.35237-6.15235 2.03091-8.0935 0.97795-2.80335 0.77657-4.69665 0.0868-6.57345-0.69095-1.88563-1.87028-3.75413-2.83819-6.4949-0.006-0.0177-0.004-0.0319 0.002-0.0425h1.29744c0.99035 2.69646 2.10354 4.58209 2.76614 6.49135 0.67264 1.9376 0.88465 3.89528-0.002 6.6998zm-13.2495 19.883c0.77303-3.82619 1.41732-7.97245 1.24252-11.863-0.0437-0.98859-0.39685-2.52048-0.81614-4.04468-0.41516-1.52422-0.89646-3.03367-1.1941-3.97441-0.88878-2.8063-0.18071-6.13291 0.74587-8.7508 0.80374-2.26949 1.77165-4.01398 2.01614-4.44095h1.34705c-0.41279 0.67737-4.64291 7.8266-2.79626 13.1114 0.67677 1.94115 2.00079 5.99825 2.03032 8.09115 0.0466 3.43701-1.21595 8.5571-2.29902 11.8712h-0.27638z'/%3E %3Cpath d='m400.079 166.698h-6.84155s1.05295-6.5114 0.20374-10.9406c-0.69154-3.60414-3.1252-6.401-3.44646-10.0571-0.4565-5.1579 4.04232-12.0762 4.04232-12.0762h6.04195 6.0425s4.34351 6.9183 3.88819 12.0762c-0.32126 3.6561-2.60138 6.45295-3.29291 10.0571-0.84862 4.42913 0.20374 10.9406 0.20374 10.9406h-6.84155z'/%3E %3Cellipse fill='%23fff' stroke-width='0.915' cx='400' cy='140.644' rx='3.409' ry='2.507'/%3E %3Cellipse stroke-width='1.029' cx='400' cy='140.492' rx='3.835' ry='2.735'/%3E %3Ccircle fill='%23fff' stroke-width='0.915' cx='400' cy='148.23' r='3.683'/%3E %3Ccircle stroke-width='1.029' cx='400' cy='148.23' r='4.143'/%3E %3C/g%3E %3Cg%3E %3Cpath stroke-width='0.904' d='m360.414 204.281s-1.05709-1.06536-1.37835-1.93524c-0.25512-0.68503-0.27815-1.85433-0.27815-1.85433l-3.78779-6.0691 8.5075-8.08935 16.1764-4.64055 20.3953-1.45748h0.0313l20.3982 1.45748 16.174 4.64055 8.5063 8.08935-3.78662 6.0691s-0.0231 1.16929-0.27815 1.85433c-0.32243 0.86988-1.37894 1.93524-1.37894 1.93524l-18.9714-6.4122-20.6634-0.9254-20.6924 0.9254-18.9738 6.4122z'/%3E %3Cpath fill='%23f1bf31' d='m360.873 203.597s-0.75768-0.94725-1.04646-1.65532c-0.41752-1.02342-0.36318-2.81338-0.36318-2.81338l-4.49351-4.70493 8.5069-8.08935 16.1746-4.64055 20.429-1.45748 20.4266 1.45748 16.177 4.64055 8.50395 8.08935-4.49056 4.70493s0.052 1.78996-0.36555 2.81338c-0.28642 0.70807-1.04645 1.65532-1.04645 1.65532l-18.5144-5.72715-20.6906-0.92775-20.6924 0.92775-18.515 5.72715z'/%3E %3Cpath fill='%23000' d='M358.832,207.288A41.168,12.777 0 1,1 441.168,207.288A41.168,10.824 0 1,1 358.832,207.288z'/%3E %3Cpath fill='%23f1bf31' d='M360.208,207.288A39.792,12.312 0 1,1 439.792,207.288A39.792,10.523 0 1,1 360.208,207.288z'/%3E %3Cellipse fill='%23d99f31' cx='400' cy='208.415' rx='36.785' ry='9.395'/%3E %3Cpath stroke-width='1.09' d='m436.52 209.676c-6.8864 2.94626-20.4319 4.52717-36.4707 4.52717-16.0394-0.001-29.5842-1.5809-36.4701-4.52717'/%3E %3Cpath stroke-width='1.01' d='m435.909 206.262c-7.0565 2.68819-20.2819 4.03287-35.8589 4.0311-15.5776 0-28.8018-1.34409-35.8577-4.03169'/%3E %3Cpath d='m432.459 203.885c-7.4947 2.17441-19.092 3.40335-32.4088 3.40216-13.317 0-24.9124-1.22834-32.4071-3.40216'/%3E %3Cpath d='m427.478 202.07c-7.2313 1.42677-16.78 2.21279-27.4282 2.21279s-20.1962-0.78602-27.4276-2.21279'/%3E %3Cpath d='m419.092 200.318c-5.65925 0.62421-12.1181 0.9561-19.0424 0.9561-6.92365 0-13.3825-0.33188-19.0418-0.9561'/%3E %3Cellipse cx='400' cy='208.415' rx='36.475' ry='9.093'/%3E %3Cpath fill='%23000' stroke-linejoin='round' d='m354.757 192.762c-3.61122-4.80295-6.8309-8.07285-14.6486-10.8342 1.07303-0.86398 2.97107-1.64882 4.7941-2.09705 2.9752-0.73288 6.01535-0.33484 7.97065 0.68918-1.55257-5.55476 1.42854-11.0941 1.42854-11.0941s4.81772-0.27579 9.6992 3.64606c0.15945-6.72695 2.13189-9.92065 2.13189-9.92065s5.07045 0.24331 10.2573 5.39645c0.988-6.9579 4.74213-10.7344 4.74213-10.7344s6.22915 1.95118 9.79015 8.52345c2.37283-9.52265 9.1559-13.2532 9.1559-13.2532s6.78545 3.73051 9.1571 13.2532c3.5622-6.57225 9.79195-8.52345 9.79195-8.52345s3.73051 3.64016 4.74213 10.7344c5.1868-5.15315 10.2567-5.39645 10.2567-5.39645s1.97303 3.1937 2.13307 9.92065c4.88091-3.92185 10.1782-2.4626 10.1782-2.4626s2.50157 4.35591 0.94842 9.91065c1.95414-1.02401 4.99607-1.42205 7.97125-0.68918 1.82244 0.44823 3.72048 1.23307 4.7941 2.09705-7.0016 2.54115-11.1916 6.0313-14.804 10.8342-3.37855-6.9018-21.4548-14.4927-45.1689-14.4927-23.7112 0-41.9434 7.59094-45.3213 14.4927z'/%3E %3Cpath fill='%23f1bf31' stroke-linejoin='round' d='m354.757 191.986c-3.08799-4.84016-7.5455-8.3823-12.1695-10.1722 1.07363-0.86338 2.95867-1.1935 4.95591-1.33287 2.34213-0.16182 4.29154 0.16594 5.9451 0.95079-1.55315-5.55175 0.9691-11.2305 0.9691-11.2305s4.96654 0.0189 9.84805 3.94075c0.16004-6.72695 2.29252-10.0636 2.29252-10.0636s4.75512 0.52913 9.94135 5.68465c1.11319-6.9455 4.74862-10.8656 4.74862-10.8656s6.22855 1.93288 9.78955 8.50275c2.37343-9.5203 9.0006-12.923 9.0006-12.923s6.6301 3.40276 9.00355 12.923c3.56044-6.56989 9.78955-8.50275 9.78955-8.50275s3.75178 3.51083 4.74863 10.8656c5.1868-5.1555 9.94135-5.68465 9.94135-5.68465s2.13189 3.33661 2.29252 10.0636c4.8815-3.92185 10.4664-2.85709 10.4664-2.85709s1.90394 4.59508 0.35138 10.1468c1.65236-0.78485 3.60177-1.1126 5.94215-0.95079 1.99724 0.13937 3.88465 0.46949 4.95768 1.33287-4.62343 1.78996-9.0815 5.3321-12.1689 10.1722-3.37855-6.9018-21.61-13.8596-45.3242-13.8596-23.7112 0-41.9434 6.9579-45.3213 13.8596z'/%3E %3Cpath fill='%23000' d='m352.995 194.157c0-8.75375 20.9002-16.1852 47.0534-16.1852 26.1555 0 46.2815 7.7303 46.2815 15.4104 0 1.84016-1.62579 3.42343-3.77067 4.76929 0.20729-0.57696 0.31122-1.16693 0.31122-1.76279 0-7.6801-16.6666-13.9051-42.822-13.9051-26.1532 0-42.8197 6.225-42.8197 13.9051 0 0.59586 0.10571 1.18582 0.31181 1.76279-2.14548-1.34586-4.54548-2.15551-4.54548-3.99449z'/%3E %3Cpath fill='%23f1bf31' stroke-width='0.904' d='m354.222 193.382c0-6.64195 19.6748-14.9451 45.828-14.9451 26.1538 0 45.8286 8.30315 45.8286 14.9451 0 1.84016-2.04744 2.02441-2.23229 1.45807-2.19803-6.73405-17.4425-12.6679-43.5963-12.6679-26.1532 0-41.3976 5.93385-43.5963 12.6679-0.18484 0.56634-2.2317 0.38208-2.2317-1.45807z'/%3E %3Cpath fill='%23000' stroke-width='0.45' stroke-linejoin='round' d='m399.577 172.094c0.15177-2.3504 0.46299-7.5685 0.46299-7.5685 0.007-0.052 0.0732-0.82796 0.0791-0.77422 0 0 0.29292 5.98995 0.43406 8.3386 0.14114 2.3439 0.28878 6.01475 0.28878 6.01475 0 0.0207-0.0165 0.0396-0.0396 0.0396l-1.50296 0.008c-0.0212 0-0.0395-0.0189-0.0395-0.0396 0 0 0.16595-3.675 0.31713-6.0189zm38.4561 13.549c0.40866-0.81201 0.91713-1.84311 1.2874-2.65453 0.75296-1.65532 2.10946-4.30453 2.10946-4.30453 0.0189-0.0502-0.0437-0.0785-0.0709-0.0336 0 0-1.69842 2.40118-2.65335 3.8935-0.50374 0.78957-1.18523 1.79055-1.72145 2.56713zm-12.8116-4.64353c0.22795-0.51083 1.29508-2.88957 2.12362-4.41556 0.98681-1.81417 2.76969-4.51181 2.76969-4.51181 0.0289-0.0454 0.0898-0.01 0.0667 0.0378 0 0-1.27914 2.73012-2.01378 4.51181-0.7187 1.73977-1.71378 4.51182-1.71378 4.51182l-0.65965 0.009zm-11.599-2.087c0.28169-1.11968 0.85748-3.3685 1.31575-4.95059 0.64429-2.21752 1.03819-3.45709 1.78996-5.63975 0.0165-0.0514 0.0856-0.0325 0.075 0.0189-0.42402 2.25472-0.6502 3.52972-1.03642 5.79095-0.27402 1.6122-0.63839 3.91358-0.80138 4.94941zm-39.3096 2.24384l-0.57106 0.004c-0.0378-0.0271-1.03169-2.79862-1.75039-4.53891-0.73524-1.78103-2.01437-4.51115-2.01437-4.51115-0.0224-0.0485 0.0378-0.0839 0.0667-0.0378 0 0 1.78346 2.69764 2.76968 4.51181 0.82914 1.52422 1.89567 3.90414 2.12363 4.41497zm10.8817-2.07498c-0.16418-1.03642-0.52973-3.33721-0.80315-4.94884-0.38445-2.26065-0.6124-3.53565-1.03583-5.79097-0.009-0.0532 0.0579-0.0703 0.075-0.0207 0.75118 2.18268 1.14567 3.42402 1.78878 5.64155 0.45945 1.5815 1.03465 3.8315 1.31752 4.9506zm-23.1862 6.6231c-0.41339-0.82086-0.93779-1.88386-1.31693-2.71595-0.75591-1.65532-2.10945-4.30454-2.10945-4.30454-0.0206-0.0502 0.0431-0.0785 0.0679-0.0336 0 0 1.69902 2.40118 2.65394 3.89351 0.51614 0.80728 1.21831 1.83779 1.76044 2.62146z'/%3E %3C/g%3E %3Cg stroke-width='0.777' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath fill='%23d99f31' stroke-width='0.719' d='m361.605 197.422c-0.33662-1.9063-1.98485-3.44056-3.25571-3.21674-1.26851 0.22264-3.07264 2.12244-2.73603 4.02638 0.33425 1.90571 2.71713 3.29056 3.988 3.0691 1.26909-0.22441 2.33976-1.97481 2.00374-3.87874z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m359.49 195.078c0.35315 0.41752 0.56693 0.95787 0.56693 1.54783 0 1.32343-1.07126 2.39469-2.39351 2.39469-0.43819 0-0.84802-0.11811-1.20058-0.32244-0.065-0.17008-0.11516-0.34666-0.14705-0.52855-0.29114-1.65118 0.97146-3.1435 2.06989-3.3372 0.0809-0.0142 0.16003-0.0206 0.24035-0.0206 0.29646 0 0.58996 0.0945 0.86397 0.26634z'/%3E %3Cpath d='m360.903 197.466c-0.29055-1.64882-1.41792-2.82815-2.51634-2.63504-1.10079 0.19311-2.36103 1.68779-2.07225 3.33661 0.29292 1.64823 2.05571 2.84823 3.15414 2.65512 1.10019-0.19252 1.72559-1.70846 1.43445-3.35669z'/%3E %3Cpath fill='%23d99f31' d='m375.4 192.846l-0.59764-3.58347-2.413-1.21653s-2.59311 0.70393-4.20886 1.27855c-1.67362 0.59409-4.21063 1.73149-4.21063 1.73149l-0.60236 1.05295 0.75413 4.05296 1.35118 1.20236 9.0201-2.70531 0.90709-1.813z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m365.464 195.441l7.226-2.2865 0.45-0.7485-0.6245-3.7525-0.26-0.257-8.0245 2.944 0.611 3.4025z'/%3E %3Cpath stroke-width='1.09' d='m365.464 195.441l7.226-2.2865 0.45-0.7485-0.475-3.001m2.55548 3.44149l-2.08047-0.442'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m385.724 189.003c-0.0721-0.82618 0.54035-1.55729 1.36713-1.62756 0.82795-0.0726 1.55728 0.5374 1.62932 1.36653 0.0732 0.82618-0.53976 1.55492-1.36594 1.62756-0.82855 0.0726-1.55729-0.54035-1.63052-1.36653zm-3.48189 3.32244c-0.072-0.82618 0.54035-1.55551 1.36653-1.62815 0.82855-0.0726 1.55729 0.53977 1.62993 1.36654 0.0726 0.82618-0.53977 1.55728-1.36595 1.62992-0.82855 0.0703-1.55728-0.54036-1.63051-1.36831zm-3.55394-2.66811c-0.0732-0.82677 0.53976-1.55551 1.36594-1.62756 0.82619-0.0732 1.40552 0.53977 1.47816 1.36595 0.0726 0.82854-0.38799 1.55728-1.21654 1.62992-0.82618 0.0703-1.55552-0.53977-1.62756-1.36831zm3.03071-3.32244c-0.072-0.82618 0.54035-1.55492 1.36653-1.62756 0.82677-0.0726 1.55729 0.54035 1.62756 1.36653 0.0732 0.82618-0.53976 1.5567-1.36594 1.62756-0.82618 0.0726-1.55492-0.53976-1.62815-1.36653z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m385.814 189.398c0.19725-0.52559 0.68149-0.92008 1.27736-0.97145 0.68977-0.0597 1.31044 0.35315 1.54075 0.97205-0.19724 0.52618-0.68149 0.9183-1.27736 0.97027-0.68977 0.0608-1.30984-0.35374-1.54075-0.97087zm-4.00512-2.66752c0.23032 0.6183 0.8504 1.03111 1.53839 0.97087 0.59645-0.0526 1.08071-0.44646 1.27736-0.97205-0.22972-0.61654-0.85098-1.03051-1.53897-0.97028-0.59528 0.052-1.07953 0.44587-1.27677 0.97146zm-3.03189 3.32126c0.23032 0.6189 0.85099 1.03229 1.54075 0.97382 0.58406-0.0514 0.98681-0.43229 1.14626-0.94429-0.18838-0.63307-0.71102-1.06181-1.40964-0.99981-0.59587 0.052-1.08012 0.44528-1.27737 0.97028zm3.55571 2.66693c0.22855 0.61772 0.84922 1.03287 1.5378 0.97264 0.59823-0.052 1.08248-0.44645 1.27854-0.97264-0.2309-0.61653-0.85098-1.02992-1.54016-0.96968-0.59468 0.0526-1.07894 0.44586-1.27618 0.96968z'/%3E %3Cpath stroke-width='0.933' d='m385.724 189.003c-0.0721-0.82618 0.54035-1.55729 1.36713-1.62756 0.82795-0.0726 1.55728 0.5374 1.62932 1.36653 0.0732 0.82618-0.53976 1.55492-1.36594 1.62756-0.82855 0.0726-1.55729-0.54035-1.63052-1.36653zm-3.48189 3.32244c-0.072-0.82618 0.54035-1.55551 1.36653-1.62815 0.82855-0.0726 1.55729 0.53977 1.62993 1.36654 0.0726 0.82618-0.53977 1.55728-1.36595 1.62992-0.82855 0.0703-1.55728-0.54036-1.63051-1.36831zm-3.55394-2.66811c-0.0732-0.82677 0.53976-1.55551 1.36594-1.62756 0.82619-0.0732 1.40552 0.53977 1.47816 1.36595 0.0726 0.82854-0.38799 1.55728-1.21654 1.62992-0.82618 0.0703-1.55552-0.53977-1.62756-1.36831zm3.03071-3.32244c-0.072-0.82618 0.54035-1.55492 1.36653-1.62756 0.82677-0.0726 1.55729 0.54035 1.62756 1.36653 0.0732 0.82618-0.53976 1.5567-1.36594 1.62756-0.82618 0.0726-1.55492-0.53976-1.62815-1.36653z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m392.853 190.393v-3.8935l2.2695-2.113h9.918l2.2695 2.113 0.002 3.8915-2.2715 1.9645h-9.918z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m405.238 184.846l-0.798 0.814v3.717l-0.633 0.625-7.51-0.054-0.623-0.6235v-3.569l-0.6725-0.9095z'/%3E %3Cpath d='m392.853 190.393v-3.8935l2.2695-2.113h9.918l2.2695 2.113 0.002 3.8915-2.2715 1.9645h-9.918z'/%3E %3Cpath stroke-width='1.09' d='m393.463 190.23l2.21103-0.85099m10.9926 0.91122l-2.22639-0.91358m-9.0502 2.72835l0.90118-2.10355m8.4195 2.10355l-0.90118-2.10355m0.63071-4.34114v3.71634l-0.63071 0.6248-7.5118-0.0537-0.62362-0.62303v-3.71634'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m414.374 189.003c0.0732-0.82618-0.53918-1.55729-1.36595-1.62756-0.82795-0.0726-1.55728 0.5374-1.62932 1.36653-0.0709 0.82618 0.53976 1.55492 1.36831 1.62756 0.82618 0.0726 1.55491-0.54035 1.62697-1.36653zm3.48307 3.32244c0.072-0.82618-0.54035-1.55551-1.36712-1.62815-0.82618-0.0726-1.55728 0.53977-1.62933 1.36654-0.0709 0.82618 0.53976 1.55728 1.36831 1.62992 0.82618 0.0703 1.55492-0.54036 1.62815-1.36831zm3.55394-2.66811c0.0732-0.82677-0.53976-1.55551-1.36594-1.62756-0.82618-0.0732-1.40552 0.53977-1.47874 1.36595-0.072 0.82854 0.39035 1.55728 1.21712 1.62992 0.82618 0.0703 1.55552-0.53977 1.62756-1.36831zm-3.02893-3.32244c0.0703-0.82618-0.53977-1.55492-1.3689-1.62756-0.82619-0.0726-1.55492 0.54035-1.62697 1.36653-0.0732 0.82618 0.53976 1.5567 1.36594 1.62756 0.82618 0.0726 1.55492-0.53976 1.62992-1.36653z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m414.285 189.398c-0.19666-0.52618-0.68149-0.92008-1.27736-0.97145-0.68918-0.0597-1.30926 0.35315-1.54016 0.97145 0.19783 0.52618 0.68208 0.9189 1.27795 0.97087 0.68977 0.0608 1.31044-0.35374 1.53957-0.97087zm1.18937-2.66811c0.19725 0.52559 0.6809 0.9189 1.27854 0.97145 0.688 0.0602 1.30807-0.35256 1.53839-0.97086-0.19666-0.525-0.6809-0.91949-1.27855-0.97146-0.68799-0.0602-1.30806 0.35374-1.53838 0.97087zm3.16122 3.3502c0.15827 0.5126 0.56162 0.89409 1.14862 0.94547 0.68859 0.0585 1.30866-0.35492 1.5378-0.97441-0.19725-0.525-0.68149-0.91771-1.27736-0.96968-0.69803-0.062-1.21949 0.36614-1.40906 0.99862zm-3.68622 2.63917c0.19666 0.52559 0.68149 0.92008 1.27796 0.97205 0.68917 0.0602 1.30925-0.35374 1.54016-0.96968-0.19666-0.52618-0.6815-0.92008-1.27796-0.97264-0.6874-0.0602-1.30866 0.35315-1.54016 0.97027z'/%3E %3Cpath stroke-width='0.933' d='m414.374 189.003c0.0732-0.82618-0.53918-1.55729-1.36595-1.62756-0.82795-0.0726-1.55728 0.5374-1.62932 1.36653-0.0709 0.82618 0.53976 1.55492 1.36831 1.62756 0.82618 0.0726 1.55491-0.54035 1.62697-1.36653zm3.48307 3.32244c0.072-0.82618-0.54035-1.55551-1.36712-1.62815-0.82618-0.0726-1.55728 0.53977-1.62933 1.36654-0.0709 0.82618 0.53976 1.55728 1.36831 1.62992 0.82618 0.0703 1.55492-0.54036 1.62815-1.36831zm3.55394-2.66811c0.0732-0.82677-0.53976-1.55551-1.36594-1.62756-0.82618-0.0732-1.40552 0.53977-1.47874 1.36595-0.072 0.82854 0.39035 1.55728 1.21712 1.62992 0.82618 0.0703 1.55552-0.53977 1.62756-1.36831zm-3.02893-3.32244c0.0703-0.82618-0.53977-1.55492-1.3689-1.62756-0.82619-0.0726-1.55492 0.54035-1.62697 1.36653-0.0732 0.82618 0.53976 1.5567 1.36594 1.62756 0.82618 0.0726 1.55492-0.53976 1.62992-1.36653z'/%3E %3Cpath fill='%23d99f31' d='m424.7 192.846l0.59823-3.58347 2.4124-1.21653s2.59311 0.70393 4.20886 1.27855c1.67303 0.59409 4.21063 1.73149 4.21063 1.73149l0.60237 1.05295-0.75355 4.05296-1.35176 1.20236-9.02011-2.70531-0.90708-1.813z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m434.635 195.441l-7.2235-2.2865-0.453-0.7485 0.627-3.7525 0.257-0.257 8.0275 2.944-0.6125 3.4025z'/%3E %3Cpath stroke-width='1.09' d='m434.635 195.441l-7.2235-2.2865-0.453-0.7485 0.476-3.001m-1.88401 4.9525l1.8605-1.2025'/%3E %3Cpath fill='%23d99f31' stroke-width='0.719' d='m438.405 197.422c0.33662-1.9063 1.98544-3.44056 3.25335-3.21674 1.27087 0.22264 3.07559 2.12244 2.74134 4.02638-0.33661 1.90571-2.72008 3.29056-3.99095 3.0691-1.2685-0.22441-2.33976-1.97481-2.00374-3.87874z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m439.953 196.626c0-0.58996 0.21378-1.13032 0.56811-1.54784 0.27342-0.17185 0.56752-0.26634 0.86338-0.26634 0.0786 0 0.15945 0.007 0.23859 0.0207 1.10019 0.1937 2.36043 1.68603 2.06988 3.33721-0.0319 0.18248-0.0821 0.36023-0.14704 0.53031-0.35256 0.20374-0.76182 0.32067-1.19883 0.32067-1.32224 0-2.39409-1.07126-2.39409-2.39468z'/%3E %3Cpath d='m439.106 197.466c0.29055-1.64882 1.4185-2.82815 2.51693-2.63504 1.10019 0.19311 2.36279 1.68779 2.07224 3.33661-0.29114 1.64823-2.05394 2.84823-3.15413 2.65512-1.10079-0.19252-1.72559-1.70846-1.43504-3.35669z'/%3E %3Cpath stroke-width='0.833' d='m424.278 192.878l0.65197-3.89292 2.56181-1.27086s2.77677 0.75591 4.50827 1.37067c1.78937 0.63485 4.50768 1.8437 4.50768 1.8437l0.64547 1.12736-0.80551 4.35178-1.44921 1.28918-9.6614-2.89843-0.959-1.921zm-31.9069-6.5321l2.39646-2.24233h10.6246l2.39586 2.24233 0.004 4.21063-2.39999 2.08228h-10.6246l-2.39646-2.08228v-4.21063zm-16.5502 6.5321l-0.65197-3.89292-2.56241-1.27086s-2.77618 0.75591-4.50768 1.37067c-1.78996 0.63485-4.50768 1.8437-4.50768 1.8437l-0.64311 1.12736 0.80315 4.35178 1.44922 1.28918 9.6614-2.89843 0.95905-1.92048z'/%3E %3C/g%3E %3Cg stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath fill='%23d99f31' stroke-width='0.952' d='m408.129 95.8505c1.77579 0 3.07146 1.58445 3.07146 3.36378 0 1.77992-1.29567 3.52382-3.07146 3.52382-2.3191 0-5.6864-2.74311-5.57245-0.56043l0.0561 1.10433 1.2313 10.1451c3.02244 0.6809-10.5544 0.6809-7.53305 0l1.23543-10.1906 0.0537-1.05886c0.11044-2.18091-3.34016 0.56043-5.57065 0.56043-1.77756 0-3.07087-1.7439-3.07087-3.52382 0-1.77933 1.29331-3.36378 3.07087-3.36378 1.7504 0 3.68327 1.63052 4.92284 0.863975 1.95-1.20236-0.39685-3.90768-0.39685-5.7307 0-1.7752 1.74449-3.22441 3.52382-3.22441 1.77756 0 3.52382 1.44922 3.52382 3.22441 0 1.82303-2.36279 4.44922-0.39507 5.7307 1.17401 0.766535 3.10925-0.863975 4.92106-0.863975z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m397.49 91.5085c-0.20846-0.24803-0.36201-0.52323-0.4624-0.81142 0.37854-1.31811 1.66063-2.36988 3.05315-2.36988 0.61004 0 1.19823 0.20315 1.7002 0.540945-0.1063 0.360235-0.91712 0.434645-1.68307 1.07716-1.09843 0.91949-1.68779 2.65984-2.60787 1.56319zm0.5055 5.0955c0.14173 0.198425 0.2185 0.410435 0.2185 0.6313 0 1.09902-1.8998 1.98957-4.24429 1.98957-1.96359 0-3.61536-0.626575-4.09843-1.47638 0.56929-0.881695 1.59567-1.47342 2.69056-1.47342 1.63642 0 3.87461 1.3937 5.03325 0.679135 0.16948-0.10453 0.30059-0.22205 0.40039-0.350195zm3.2675 0.168c0-0.51319 0.2433-0.99331 0.66555-1.40256-0.10512 0.625985 0.0212 1.18288 0.6372 1.58504 1.09666 0.714565 3.33662-0.679135 5.0309-0.679135 1.07776 0 2.08937 0.573425 2.66516 1.4315-0.65079 1.04055-2.35689 1.78228-4.35768 1.78228-2.5624 0-4.64114-1.21654-4.64114-2.71712z'/%3E %3Cpath d='m407.596 96.2765c1.65886 0 3.15768 1.35532 3.15768 3.01594 0 1.65946-1.49882 3.01536-3.15768 3.01536s-5.7372-2.90256-5.6392-0.68976l0.0537 1.18169 0.69744 9.78365c2.82401 0.63544-8.0829 0.63544-5.2612 0l0.70157-9.8268 0.0502-1.13859c0.0974-2.21102-4.10434 0.68977-5.63505 0.68977-1.65886 0-3.15827-1.35591-3.15827-3.01536 0-1.66063 1.49941-3.01594 3.15827-3.01594 1.63405 0 3.87402 1.39075 5.0327 0.678545 1.82126-1.12323-0.68327-3.77067-0.68327-5.47145 0-1.65827 1.5059-3.1559 3.16653-3.1559 1.66122 0 3.16654 1.49764 3.16654 3.1559 0 1.70079-2.51634 4.27382-0.67914 5.47145 1.09488 0.712205 3.33721-0.678545 5.02916-0.678545z'/%3E %3Ccircle fill='%23f1f1f2' stroke-width='1.703' cx='400' cy='116.288' r='7.901'/%3E %3Cpath fill='%23000' stroke='none' d='m401.46 121.283c0.52973-0.6626 1.11496-1.50355 1.35827-2.28839 0.17894-0.57283 0.77422-0.30354 0.64548 0.18484-0.22618 0.85335-0.74528 1.74626-1.25374 2.4502zm-8.69537-4.65354c0.137-0.11575 0.29232-0.26103 0.47716-0.40866 0.18307-0.14764 0.39862-0.30531 0.65433-0.4506 0.33425-0.2244 0.10158-0.7435-0.30531-0.54626-0.42815 0.20847-0.78071 0.42697-1.0128 0.58347zm-0.0502 1.17166l0.41161 0.73464c0.57697-0.61004 1.54252-1.49882 1.69607-1.64232 0.35669-0.33839-0.10571-0.72874-0.41103-0.51083-0.35078 0.25099-0.85925 0.63544-1.2189 0.96733-0.19783 0.18248-0.36673 0.34429-0.47775 0.45118zm0.59764 1.76279l0.51319 0.59763c1.21299-0.94311 2.29075-2.08642 2.46496-2.27362 0.34252-0.37146-0.0543-0.87638-0.46063-0.5067-0.19311 0.20374-1.76693 1.60335-2.5063 2.17382l-0.0112 0.009zm10.7829 1.33288c0.38209-0.43229 0.79724-1.03642 0.93425-1.73563 0.0502-0.24744 0.22677-0.36555 0.40335-0.32835 0.17007 0.0372 0.29468 0.21378 0.25511 0.45059-0.13936 0.84272-0.57992 1.55906-0.99271 2.04036zm-6.05668 0.77172c1.10728-1.26614 1.91457-2.34803 2.64331-3.56457 0.10984-0.18307 0.30944-0.22854 0.45649-0.15591 0.15591 0.0744 0.22855 0.26162 0.12225 0.47953-0.4565 0.93485-1.07303 1.90394-1.6187 2.59311-0.54626 0.69154-0.95138 1.16516-0.95138 1.16516zm-2.24082-1.37469c0.74079-0.68533 1.58901-1.55227 2.05828-2.12777 0.27815-0.34074 0.88229-0.0768 0.5374 0.43406-0.44232 0.65374-1.12559 1.45984-1.75866 2.04272z'/%3E %3Cpath fill='%23d99f31' d='m406.135 133.626h-6.0573l-6.03305-0.002c-1.02402 1.72913-4.2567 2.90256-6.90235 1.52185-1.87855-0.98209-2.263-3.21201-2.263-3.21201s5.0622 0.18484 5.08935-4.2939c0-4.53898 2.60729-7.50415 6.3555-7.0553 1.63583 0.19488 2.74253 1.01988 3.75355 1.93878 1.01338-0.9189 2.12421-1.74626 3.76299-1.93878 3.74705-0.44469 6.349 2.51634 6.349 7.0199 0 4.51654 5.0888 4.33346 5.0888 4.33346s-0.38386 2.22579-2.26299 3.20788c-2.65571 1.38484-5.9073 0.19724-6.8805-1.52008z'/%3E %3Cpath fill='%23d99f31' stroke='none' d='m406.139 133.624h-0.41752c-1.12146 1.03996-2.88426 2.09468-5.64155 2.70532-2.75965-0.61063-4.52008-1.66536-5.64095-2.70532h-0.39449s-4.24016 3.0065-7.2136 0.75177c-1.09843-0.83091-1.33051-1.97717-1.33051-1.97717s5.0888-0.27756 5.0888-4.79409c0-4.50355 2.44429-6.401 5.73305-6.401 1.43681 0 2.74429 0.70984 3.75768 1.62992 1.01102-0.92008 2.32146-1.62992 3.75827-1.62992 3.28878 0 5.7325 1.89744 5.7325 6.401 0 4.51654 5.087 4.79409 5.087 4.79409s-0.23268 1.14626-1.32874 1.97717c-2.97579 2.25473-7.18995-0.75177-7.18995-0.75177z'/%3E %3Cpath stroke='%23f1bf31' stroke-width='0.904' d='m391.164 125.035c-0.26515 0.63957 0.15591 2.86358 0.15591 2.86358s0.1376 2.01969-1.45099 3.5563c-1.10905 1.07363-3.64606 1.54134-3.64606 1.54134m22.7788-7.9612c0.26634 0.63957-0.15532 2.86359-0.15532 2.86359s-0.137 2.01968 1.44922 3.5563c1.10846 1.07362 3.64606 1.54134 3.64606 1.54134'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m399.982 135.868c-6.29585-1.43032-7.112-5.32975-6.9372-5.28605 0.41279 0.10157 1.86673 2.94567 7.03405 4.38307 5.1685-1.4374 6.6195-4.2815 7.03525-4.38307 0.17421-0.0437-0.64193 3.85571-6.9372 5.28605h-0.19488zm-7.7355-11.121c0-1.52421 2.52638-2.80157 5.93445-3.15177 0.70335 0.29586 1.34528 0.73582 1.89922 1.23838 0.55157-0.50138 1.19173-0.94134 1.89331-1.23662 3.39921 0.35256 5.9179 1.62815 5.9179 3.15 0 3.61063-4.1256 5.3569-7.82365 5.3551-3.69804 0-7.82125-1.74449-7.82125-5.3551z'/%3E %3Cpath d='m406.139 133.624h-0.41752c-1.12146 1.03996-2.88426 2.09468-5.64155 2.70532-2.75965-0.61063-4.52008-1.66536-5.64095-2.70532h-0.39449s-4.24016 3.0065-7.2136 0.75177c-1.09843-0.83091-1.33051-1.97717-1.33051-1.97717s5.0888-0.27756 5.0888-4.79409c0-4.50355 2.44429-6.401 5.73305-6.401 1.43681 0 2.74429 0.70984 3.75768 1.62992 1.01102-0.92008 2.32146-1.62992 3.75827-1.62992 3.28878 0 5.7325 1.89744 5.7325 6.401 0 4.51654 5.087 4.79409 5.087 4.79409s-0.23268 1.14626-1.32874 1.97717c-2.97579 2.25473-7.18995-0.75177-7.18995-0.75177z'/%3E %3Cpath fill='%23000' d='m407.625 130.618s-0.75177 5.0516-7.5455 6.5551c-6.7955-1.50355-7.54725-6.5551-7.54725-6.5551s0.75177 4.20827 7.54725 5.7118c6.7937-1.50355 7.5455-5.7118 7.5455-5.7118z'/%3E %3C/g%3E %3C/g%3E %3Cg id='shield' stroke-width='0.933' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath fill='%23a0cfeb' d='m398.792 227.491c13.5414-0.23681 71.818-10.0081 71.818 70.925 0 77.3055-70.5605 108.048-70.5605 108.048s-70.563-29.7809-70.563-113.912c0-75.068 69.3055-65.06 69.3055-65.06z'/%3E %3Cpath fill='%2394bb79' d='m421.681 348.386c4.12972-2.30492 8.889-3.6189 13.953-3.6189 8.237 0 15.6608 3.47422 20.8902 9.03605-20.5866 37.0152-56.4735 52.66-56.4735 52.66s-34.9589-14.7555-55.6635-52.8325c5.2199-5.4614 12.577-8.8636 20.7284-8.8636 5.67935 0 10.9718 1.65059 15.4252 4.49941 5.23465-5.62915 12.7046-9.1488 20.9976-9.1488 7.8508 0 14.964 3.1565 20.1426 8.2683z'/%3E %3Cpath fill='%23658d5c' d='m433.967 345.161c3.55453 0.41102 9.77305 3.75827 12.7796 8.2695-2.33563 3.86043-6.82265 9.9939-9.3 13.3742-5.49565-8.06695-16.8821-18.8676-16.0931-18.0874 0.11397 0.11043 0.59174-0.27756 0.73051-0.35492 1.09606-0.61181 2.1189-1.16634 3.12165-1.63937 2.01851-0.78839 4.14745-1.35472 6.3573-1.6689 0.75768-0.0248 1.55315 0.008 2.40414 0.10689zm-24.18 50.7695c-4.49587 2.37401-7.9943 3.89587-9.7382 4.63051-1.74626-0.73464-5.2453-2.25649-9.7382-4.63051-8.7077-7.0512-26.641-23.5075-39.267-47.4296 4.07185-2.27894 8.76435-3.57874 13.7616-3.57874 0.40925 0 2.10531 0.4937 3.34724 1.07716 7.93585 3.72874 17.7561 14.4348 14.1378 16.4823-2.6563 1.49883-10.255-0.96141-10.6542 1.97835-0.14941 1.11319 14.0964 8.9386 22.1918 15.8303 6.63605 5.6492 17.0014 14.7957 15.959 15.6402zm17.297-7.0315c-9.0632-8.89665-29.4466-26.9964-46.503-39.6762 4.72678-5.0622 11.2654-8.4077 18.5829-9.0071l0.38445 0.0514c9.84215 1.41024 18.7577 11.9634 15.1388 14.0108-2.65571 1.49941-10.2555-0.96142-10.6536 1.97894-0.1311 0.98032 10.1924 7.22125 16.2366 12.4181 5.93445 5.10175 9.81495 8.76735 14.2164 13.5762-2.48917 2.40649-4.97362 4.62047-7.40255 6.64785z'/%3E %3Cpath fill='%23000' d='m422.071 347.943c1.88563 1.77933 2.70768 3.26161 2.71418 3.27224 0.1807 0.30059-0.0213 0.99213-0.5628 0.48544 0 0-0.75-0.71457-2.95275-2.86063-2.96457-2.89252-8.09351-6.5492-12.339-7.2632-0.40749-0.0685-0.58406-0.26989-0.53387-0.56516 0.0473-0.29646 0.30532-0.57697 0.71221-0.51083 0.0768 0.0124 6.3449 1.1941 12.962 7.44215zm-34.8745 5.5545c0.19488 0.1748 0.24685 0.41575 0.13878 0.59409-0.11397 0.18662-0.35492 0.22796-0.55866 0.0809-3.58583-2.54764-5.33565-3.61477-7.41435-4.91871-0.16359-0.10393-0.27224-0.27638-0.14941-0.45886 0.0809-0.12224 0.24921-0.20137 0.40866-0.24744 0.32599-0.0933 0.81851-0.10984 1.13386 0.0874 2.10591 1.32225 3.51969 2.4626 6.44115 4.8626z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.244' d='m421.681 348.386c4.12972-2.30492 8.889-4.08366 13.953-4.08366 8.2766 0 15.7329 3.63543 20.9664 9.36554m-112.312-0.225c5.22695-5.6823 12.6236-9.2947 20.8276-9.2947 5.67935 0 10.9718 2.2695 15.4252 5.1183 5.23465-5.62915 12.7046-9.76715 20.9976-9.76715 7.8508 0 14.964 3.77481 20.1426 8.8866'/%3E %3Cpath fill='none' stroke='%234c819a' stroke-width='0.777' d='m367.911 230.52h66.967m-75.9135 3.71221h84.1205m-90.2515 3.71279h95.794m-100.444 3.71457h104.632m-108.329 3.71221h111.648m-114.663 3.7122h117.374m-119.856 3.7128h122.102m-124.169 3.7122h126.052m-127.756 3.7128h129.332m-130.752 3.71398h132.079m-133.248 3.71043h134.356m-135.301 3.7128h136.22m-50.2455 3.71279h51.0055m-137.726 0h51.354m51.9835 3.71162h35.002m-138.918 0h35.4443m74.937 3.71516h29.0174m-139.824 0h29.234m87.8725 3.7122h23.08m-140.456 0h22.9943m100.604 3.7128h17.1172m-140.856 0h17.0947m111.114 3.70984h12.7996m-141.032 0h13.0288m119.299 3.7128h8.77205m-141.027 0h8.4815'/%3E %3Cg id='tower1' fill='none'%3E %3Cpath fill='%23000' d='m356.655 300.398l-0.0165-7.225 7.7485-3.024 7.7495 2.093 0.0165 8.156z'/%3E %3Cpath fill='%23fff' d='m373.237 333.224l3.39449 13.9482c-3.52559-1.54666-7.4185-2.40591-11.5158-2.40591l-0.72873-57.564 3.09862 0.89055v6.05255l3.87461 0.99685v-5.9947l5.27125 1.3872v9.84155l-3.39449 5.0374v27.8102z'/%3E %3Cpath fill='%23bdbfc1' d='m364.387 332.147v-28.6636-6.07735-10.2024l-0.001-0.0005-3.09922 1.3559v5.96515l-3.87461 1.54489v-5.98995l-5.2695 2.23642v9.5321l3.78721 4.54252 0.0892 27.3933-3.87638 14.0817c3.69331-1.87736 7.84605-2.97933 12.2445-3.08917v-0.0921-12.5368z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='m364.249 332.04l-8.2305 1.7439m-1.73985 8.66869l10.0483-2.12244 10.8644 1.16752m-11.2246-5.22463l-8.8677 1.8065m17.6528-24.6833l-8.364-1.73564-8.48325 2.58897m16.8472 3.09805l-8.364-1.59686-8.48325 2.45019m0-7.85847l8.48325-2.7431 8.364 1.76694m-16.8472 12.7258l8.48325-2.26299 8.364 1.48819m-16.7705 4.66358l8.4065-2.07638 8.44075 1.38072m-16.8472 4.60156l8.4065-1.89153 8.5199 1.27087m-3.0963-24.4116v3.83682m-3.09981-0.58288v3.91359m3.09981 0.82795v3.91654m-7.90395-4.2815v3.91358m0 4.10965v3.913m-3.7193 1.3624v3.60472m0-19.4197v3.60414m3.7193-9.1069v3.91594m2.4961-10.9818l12.2274 2.97697m-12.2274-2.97697l-12.2598 4.44686'/%3E %3Cpath stroke='%23000' stroke-width='1.244' d='m364.387 344.776v-57.5725'/%3E %3Cpath fill='%23000' d='m370.586 334.677l-3.72283-0.51319 0.004-11.7809c0-1.44981 0.88051-2.33622 1.67362-2.33622 1.40611 0 2.04508 1.58445 2.04508 2.95689z'/%3E %3Cpath stroke='%23000' d='m373.237 333.225l3.39449 13.9482c-3.52559-1.54666-7.4185-2.40591-11.5158-2.40591-4.6689 0-9.07735 1.11674-12.972 3.09744l3.87402-14.0794-0.0892-27.3933-3.78485-4.54311v-9.5321l5.2689-2.2376v5.9882l3.87461-1.5437v-5.96515l3.09981-1.35531 3.09862 0.89055v6.05255l3.87461 0.99685v-5.9947l5.27125 1.3872v9.84155l-3.39449 5.0374v27.8102zm3.10037 13.42c-3.40926-1.40964-7.30215-2.18622-11.2205-2.18622-4.47224 0-8.8636 1.01162-12.6466 2.82166l3.84745-13.4132-0.0791-27.4778c0-0.0224-0.0561-0.17894-0.0703-0.19666l-3.71457-4.4563v-9.21435l4.64882-1.9748v5.52105c0 0.25275 0.18898 0.3815 0.42579 0.28642l3.87461-1.54252c0.0803-0.0313 0.19429-0.19961 0.19429-0.28701v-5.7638l2.81162-1.22953 2.76614 0.79606v5.8175c0 0.10985 0.12461 0.27225 0.23209 0.29882l3.87461 0.99863c0.21791 0.0561 0.38858-0.0762 0.38858-0.29882v-5.5937l4.6506 1.22303v9.50905l-3.34075 4.9565c-0.0106 0.0147-0.0537 0.15768-0.0537 0.1748v27.8102l3.41102 13.4208zm1.21476 0.45532c0.075 0.30886-0.7559 0.0201-1.04645-0.10866-3.48603-1.53012-7.3376-2.37874-11.3888-2.37874-4.6193 0-8.97995 1.10374-12.8333 3.06201-0.29941 0.15177-1.14862 0.42992-1.05885 0.1063l4.48228-14.038-0.0868-27.2392-3.71457-4.45808c-0.0148-0.0172-0.0709-0.1748-0.0709-0.19783v-9.5321c0-0.0833 0.11043-0.25099 0.18661-0.28406l5.2701-2.23878c0.23859-0.10157 0.4317 0.0272 0.4317 0.28465v5.5311l3.25394-1.29508v-5.7561c0-0.0803 0.11161-0.25099 0.18661-0.28229l3.09981-1.35531c0.0206-0.0106 0.18662-0.0213 0.20965-0.0147l3.09803 0.89055c0.10217 0.0295 0.22441 0.19134 0.22441 0.29705v5.8116l3.25335 0.83858v-5.5931c0-0.22677 0.17244-0.35728 0.39035-0.30118l5.2695 1.38721c0.10807 0.0265 0.23091 0.18897 0.23091 0.29881v9.84155c0 0.0165-0.0413 0.16004-0.052 0.17245l-3.34075 4.96004v27.6774l4.00512 13.914zm-13.1485-43.577l8.364 1.89094m-8.364-1.89094l-8.475 2.8689'/%3E %3C/g%3E %3Cg id='tower2' fill='none'%3E %3Cpath fill='%23000' d='m391.526 294.975l-0.0165-7.3835 7.7485-2.7885 7.7495 2.4025 0.0165 7.7695z'/%3E %3Cpath fill='%23fff' d='m408.108 328.109l3.39508 13.7888c-3.10394-1.15217-6.4618-1.77992-9.96435-1.77992-0.81295 0-1.61799 0.0338-2.41378 0.1001l0.1343-58.4401 3.09744 1.04646v6.0508l3.87461 1.07539v-5.91555l5.27184 1.69429v9.81085l-3.39508 4.83544v27.7335z'/%3E %3Cpath fill='%23bdbfc1' d='m399.259 340.19v-5.3197-8.22345-28.5874-6.07735-10.2042h-0.0005l-3.09803 1.20236v6.0443l-3.87638 1.38485v-5.98585l-5.2701 2.07992v9.64075l3.7872 4.63642 0.0898 27.58-3.877 15.702c3.64252-2.14489 7.8018-3.50611 12.2451-3.85512v-0.0183z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='m398.802 330.83l-8.5754 1.64646m19.4823 3.86989l-10.502-1.31989-10.3568 1.97008m4.22485-21.0118v3.75768m3.7193 3.39918v3.91536m0-28.1692v3.91417m-3.7193 1.4327v3.75768m3.7193-1.00867v3.91359m7.90455-3.31536v3.913m-3.09981-8.65571v3.91358m3.09981-7.09016v3.83681m-13.8284 20.8854l8.40475-1.81417 8.5193 1.58209m-17.0014-7.64056l8.4821-2.10767 8.3634 1.79765m-16.8455-3.58112l8.4821-2.29488 8.3634 1.90808m-16.8455-3.56518l8.4821-2.43306 8.3634 2.04745m-16.8455-3.58171l8.4821-2.54113 8.3634 2.15257m0.0791 15.8575l-8.4425-1.69075-8.40475 1.9996m8.3887 6.16672l-8.3699 1.71496m20.6138-32.8205l-12.2439-3.55926-12.2445 4.16339m20.6244 4.21654l-8.3634-2.25561-8.4762 2.67549'/%3E %3Cpath stroke='%23000' stroke-width='1.244' d='m399.259 340.19v-58.412'/%3E %3Cpath fill='%23000' d='m405.457 329.407l-3.72225-0.58996 0.004-11.7803c0-1.44981 0.88051-2.25768 1.67539-2.25768 1.40374 0 2.04272 1.58208 2.04278 2.26858z'/%3E %3Cpath stroke='%23000' d='m411.218 341.411c-2.98347-1.03819-6.3431-1.60334-9.67975-1.60334-5.09765 0-10.0418 1.31693-14.2046 3.62716l3.85571-15.0012-0.0786-27.6538c0-0.0231-0.0561-0.17657-0.0709-0.19547l-3.714-4.55v-9.31889l4.64941-1.83957v5.53345c0 0.24685 0.18248 0.37559 0.41456 0.29232l3.87461-1.38898c0.0898-0.0313 0.20552-0.19724 0.20552-0.29055v-5.8305l2.79685-1.08602 2.78031 0.93897v5.8305c0 0.10748 0.12225 0.26929 0.22618 0.29882l3.87461 1.0754c0.21969 0.0602 0.39449-0.0709 0.39449-0.29882v-5.49215l4.65119 1.49705v9.4866l-3.33898 4.75512c-0.008 0.0147-0.0561 0.16181-0.0561 0.17834v27.7335l3.41989 13.301zm1.2065 0.41103c0.072 0.29705-0.74351 0.007-1.02992-0.0998-3.0691-1.1374-6.3892-1.75866-9.8563-1.75866-5.2429 0-10.1534 1.42205-14.3664 3.90178-0.29469 0.17421-1.16044 0.4565-1.07776 0.12224l4.48524-15.6656-0.0898-27.4306-3.71456-4.55138c-0.0147-0.0165-0.0703-0.17244-0.0703-0.19488v-9.64075c0-0.0868 0.11398-0.25512 0.19725-0.28819l5.2677-2.08287c0.23622-0.0933 0.42342 0.0354 0.42342 0.28878v5.54765l3.25571-1.16457v-5.8264c0-0.0892 0.11457-0.25689 0.19902-0.28819l3.09862-1.20237c0.0218-0.008 0.18898-0.0106 0.21083-0.004l3.09863 1.04646c0.0909 0.0313 0.20905 0.19547 0.20905 0.29232v5.8181l3.2563 0.90118v-5.50865c0-0.23622 0.17835-0.36732 0.40512-0.29468l5.27125 1.69606c0.0957 0.0313 0.21378 0.19547 0.21378 0.29528v9.81085c0 0.0183-0.0461 0.16417-0.0561 0.17775l-3.33603 4.75512v27.5982l4.00512 13.7498zm-4.316-13.713l3.39508 13.7888c-3.10394-1.15217-6.4618-1.77992-9.96435-1.77992-5.3008 0-10.265 1.4374-14.524 3.94547l3.87461-15.7028-0.0898-27.58-3.78485-4.63642v-9.64075l5.2701-2.08051v5.9882l3.87461-1.38898v-6.0443l3.09981-1.2 3.09744 1.04646v6.0508l3.87461 1.07539v-5.91555l5.27185 1.69429v9.81085l-3.39508 4.83544v27.7335z'/%3E %3C/g%3E %3Cg id='tower3' fill='none'%3E %3Cpath fill='%23000' d='m426.396 300.554l-0.0145-8.156 7.7485-2.1695 7.7485 2.5555 0.017 7.77z'/%3E %3Cpath fill='%23fff' d='m442.979 333.534l3.39449 13.3134c-3.31772-1.34114-6.94075-2.08052-10.7404-2.08052-0.54709 0-1.09059 0.0154-1.63011 0.0456l0.12658-57.6096 3.09804 1.0441v6.05315l3.87461 1.30748v-5.91735l5.27125 1.77342v9.688l-3.39449 4.80473v27.5776z'/%3E %3Cpath fill='%23bdbfc1' d='m434.13 332.147v-28.6636-6.07735-10.203l-3.09804 0.96791v6.04431l-3.87637 1.15393v-5.98759l-5.27011 1.69606v9.763l3.78544 4.85197 0.0915 27.5492-3.87697 15.0302c3.67027-2.00847 7.8248-3.238 12.2445-3.46594v-0.12225-12.5368z'/%3E %3Cpath stroke='%23000' stroke-width='1.09' d='m423.572 342.002l10.5065-1.62992 10.6954 1.40788m-11.0922-5.55648l-8.8512 1.35768m6.8209-33.4247v3.91417m-3.72107 1.27739v3.76004m0 12.1317v3.76004m3.72107-8.64745v3.91359m0-12.0136v3.91417m7.90215-3.08386v3.91418m-3.0998-8.73308v3.91359m3.0998-7.01398v3.83799m-13.8278 20.4201l8.40415-1.42618 8.5199 1.58209m-17.0014-11.9976l8.4815-1.82894 8.36635 1.98545m0 3.96791l-8.36635-1.87501-8.4815 1.72146m16.8478-7.76574l-8.36635-2.12423-8.4815 1.96831m16.8478-3.812l-8.36635-2.2317-8.4815 2.07578m16.8614-3.70627l-8.3634-2.43307-8.475 2.17146m-3.78545-4.85256l12.2604-3.43996 12.228 3.74941m-12.228 30.89l-8.38585 1.35768m-0.0349-7.87975l8.40415-1.61338 8.4425 1.76694'/%3E %3Cpath stroke='%23000' stroke-width='1.244' d='m434.13 344.806v-57.603'/%3E %3Cpath fill='%23000' d='m440.329 334.909l-3.72343-0.58937 0.002-11.7809c0-1.45157 0.88229-2.25945 1.67599-2.25945 1.40551 0 2.04508 1.58445 2.04501 2.27066z'/%3E %3Cpath stroke='%23000' d='m446.079 346.338c-3.19784-1.21476-6.82085-1.87913-10.4439-1.87913-4.78406 0-9.4518 1.15866-13.4274 3.20964l3.85335-14.3492-0.0791-27.6254c0-0.0224-0.052-0.17421-0.0667-0.19075l-3.71811-4.76693v-9.4329l4.64882-1.49527v5.5624c0 0.23268 0.17421 0.36319 0.39862 0.29705l3.87461-1.15689c0.0992-0.0283 0.22145-0.19016 0.22145-0.29646v-5.81635l2.78681-0.86988 2.79036 0.94311v5.82815c0 0.0974 0.1187 0.26339 0.20965 0.29468l3.87697 1.30807c0.22854 0.0768 0.40925-0.0514 0.40925-0.29468v-5.48505l4.65059 1.56496v9.36615l-3.33898 4.72382c-0.008 0.0147-0.0555 0.16181-0.0555 0.17834v27.5776l3.40926 12.805zm-3.1-12.804l3.39449 13.3134c-3.31772-1.34114-6.94075-2.08052-10.7404-2.08052-4.9813 0-9.66555 1.27087-13.7474 3.50493l3.87402-15.0307-0.0886-27.5468-3.78543-4.85434v-9.7624l5.2695-1.69606v5.9876l3.87461-1.15453v-6.0437l3.0998-0.96792 3.09804 1.0441v6.05315l3.87461 1.30748v-5.91735l5.27125 1.77342v9.688l-3.39449 4.80473v27.5776zm4.31369 13.2353c0.0774 0.30355-0.74527 0.0165-1.03582-0.10157-3.28052-1.32461-6.86635-2.05512-10.6222-2.05512-4.92934 0-9.5634 1.25787-13.5998 3.46713-0.29764 0.16181-0.99922-0.17658-0.91359-0.50433l4.32874-14.3728-0.0868-27.4028-3.72107-4.76752c-0.0147-0.0165-0.0667-0.17008-0.0667-0.19133v-9.76475c0-0.0992 0.12106-0.26339 0.21614-0.29469l5.2677-1.6943c0.22854-0.0744 0.40748 0.0561 0.40748 0.29528v5.57245l3.25335-0.97205v-5.81105c0-0.10217 0.11988-0.26634 0.21791-0.29764l3.09981-0.96673c0.0165-0.006 0.17244-0.005 0.19134 0.002l3.09744 1.04468c0.0939 0.0307 0.20965 0.19725 0.20965 0.2941v5.82875l3.25571 1.09842v-5.48385c0-0.24094 0.18071-0.37145 0.40925-0.29468l5.27185 1.77342c0.0909 0.0307 0.20965 0.19666 0.20965 0.29469v9.68565c0 0.0165-0.0454 0.16417-0.0561 0.17835l-3.33661 4.72382v27.443l4.00276 13.2738z'/%3E %3C/g%3E %3Cg id='feather' fill='%23000' stroke='%23000'%3E %3Cpath d='m369.418 268.702c-0.28288-2.57008-1.2815-6.72875-4.71556-6.1996 0.17481 4.46811 5.8612 21.2906-0.63779 22.4528l-0.21733-0.23268c0.085-7.6382-7.5496-15.9744-6.0632-22.627 0.98032-4.37717 4.29213-6.7447 8.70355-6.7447 8.04566 0 9.15885 9.99805 3.27934 13.503l-0.34902-0.15177z'/%3E %3Cpath fill='%23fff' d='m369.854 267.53c-0.65433-2.86949-2.23228-6.61065-5.8447-5.97105l-0.23681 0.31122c0.16595 4.80472 6.18955 19.4179 0.4565 21.9986-0.15355-8.3675-7.6949-13.7976-5.75965-21.6414 0.5374-2.17382 2.70531-4.87559 4.81535-5.6681 0.98977-0.37382 2.11772-0.68386 3.18898-0.66319 7.25845 0.14941 9.14175 7.67185 3.38032 11.6338z'/%3E %3Cpath stroke='none' d='m359.574 264.713c0.62067-1.69842 2.65335-3.42048 4.46575-3.63543 0.37677-0.046 0.67973 0.29232 0.82914 0.71161l-0.17303-0.004c-0.20788 0-0.41103 0.0271-0.61477 0.0744 0.0106 0.31004 0.036 0.63366 0.0744 0.96614-0.85039 0.0531-2.32559 0.39508-3.82972 2.23819-0.69567 0.85512-1.06536 0.50433-0.75177-0.35078z'/%3E %3Cpath stroke-width='1.09' d='m359.997 265.232l4.24902-1.73563m-3.92717 3.26811l4.20119-1.81359m-3.8628 3.43288l4.19941-1.97894m-3.39213 3.52205l3.78544-1.95532m-2.51634 3.38563l2.94862-1.67598m-0.82264 2.69941l1.29095-0.71693'/%3E %3Cpath stroke='none' d='m369.137 259.592c-2.22756-3.28288-7.8319-1.43681-9.27695 0.6437-0.10335 0.15177-0.47303-0.075-0.68091-0.15827-0.0278-0.0106-0.0532-0.0242-0.0774-0.0389 0.38858-0.64488 0.87225-1.29626 1.425-1.88327 2.71418-1.73386 7.4362-2.08287 9.3372 0.98208 0.14705 0.23859 0.0414 0.47776-0.13524 0.58524-0.17598 0.10807-0.43582 0.0998-0.59173-0.13051z'/%3E %3C/g%3E %3Cuse xlink:href='%23feather' x='35.338' y='-5.423'/%3E %3Cuse xlink:href='%23feather' x='70.673'/%3E %3Cg stroke='%23000'%3E %3Cpath fill='%23000' d='m446.259 240.532c3.26398 2.15315 14.8104 8.6439 16.5189 45.6354 3.33071 72.0965-58.0165 114.162-58.0165 114.162s77.6215-33.0508 77.6215-114.226l0.0001-0.00026c0-34.1728-13.5668-71.191-40.4758-71.191l-14.7915 0.0465-21.4842 10.0512c-1.125-1.56969-3.27166-2.59134-5.3504-2.59134-2.07579 0-4.2254 1.02165-5.3504 2.59134l-21.4837-10.0512-15.2554-0.0465c-26.9108 0-40.4776 37.0182-40.4776 71.191l0.00005 0.00027c0 81.1752 77.621 114.226 77.621 114.226s-61.3472-42.066-58.0165-114.162c1.70905-36.9916 13.2555-43.4823 16.5195-45.6354l18.1308 6.04764 22.914-13.4114c1.4947 1.59862 3.04017 2.73498 5.4006 2.73248 2.35866 0 3.68149-0.92834 5.39646-2.73248l22.7604 13.5668z'/%3E %3Cpath fill='%23d99f31' d='m431.453 214.144l-31.1716 13.5443-31.171-13.5443-10.9189 0.76801c-26.9108 0-40.4776 37.0182-40.4776 71.191v0.00024c0 81.1752 77.621 114.226 77.621 114.226s-62.1214-42.066-58.793-114.162c1.70905-36.9916 13.5667-44.4124 16.8307-46.5656l19.9756 5.55915 26.9332-15.9212 26.9314 15.9212 19.5115-5.55915c3.26398 2.15315 15.1216 9.574 16.8307 46.5656 3.33012 72.0965-58.7935 114.162-58.7935 114.162s77.6215-33.0508 77.6215-114.226l-0.00005-0.00024c0-34.1728-13.5668-71.191-40.4758-71.191z'/%3E %3Cpath fill='%23000' stroke='none' d='m437.336 228.911c-3.71634 0.4376-6.31831 2.92973-6.4506 6.73525-0.0709 2.03918 0.90118 5.06635 2.30256 6.34725l-0.83683 0.91596c-1.65472-1.5142-2.86772-4.88743-2.78209-7.31105 0.1494-4.26675 3.14587-7.24017 7.61575-7.7634zm-74.5104-1.076c4.47048 0.52324 7.46695 3.49666 7.61635 7.7634 0.085 2.42363-1.12795 5.79685-2.78209 7.31105l-0.83683-0.91595c1.40138-1.28091 2.37284-4.30808 2.30197-6.34725-0.13288-3.80552-2.73426-6.29765-6.4512-6.73525zm-8.73434 7.44655c-5.39825 3.48602-10.2922 10.0972-13.0346 16.9258-0.15177 0.35728-0.38445 0.46358-0.62067 0.37795-0.21201-0.0768-0.30118-0.38209-0.20374-0.68327 2.58543-7.17755 7.43505-13.6642 13.5336-18.186l0.3254 1.56555zm7.1995-12.852c-13.2136 0-23.0197 9.30415-29.6392 26.4685-0.15118 0.32008-0.45473 0.56456-0.78307 0.44882-0.26103-0.0939-0.29055-0.46595-0.17244-0.80197 6.62185-17.4892 16.7256-27.1996 30.5947-27.1996 6.0372 0 11.2276 1.48701 15.6703 4.75157l0.24271 1.60985c-4.45866-3.62776-9.737-5.27715-15.913-5.27715zm0 3.564c-11.5294 0-20.5176 9.7193-26.1821 24.0189-0.16181 0.34252-0.39449 0.52323-0.71044 0.39449-0.24508-0.0998-0.27165-0.46713-0.14704-0.77008 5.37755-14.4614 14.8146-24.727 27.0396-24.727 6.1323 0 11.387 1.94173 15.8114 6.19785l-0.2067 1.37953c-4.33465-4.45335-9.52975-6.4937-15.6048-6.4937zm13.2195 12.5915c-2.30079-6.8699-6.0567-9.51435-13.3778-9.51435-9.65495 0-17.6032 8.77265-22.8561 22.0382-0.12874 0.30295-0.35315 0.4813-0.64134 0.38386-0.24922-0.085-0.28878-0.42756-0.17658-0.73701 5.1136-13.4794 13.317-23.0805 23.674-23.0805 7.68605 0 11.7904 3.16063 14.015 9.84865l-0.6372 1.06122zm51.0465 0.093l-0.67028-0.95729c2.20099-6.8002 6.29115-10.0222 14.0026-10.0453 12.427 0.0579 21.9674 14.0586 26.928 32.3327 0.0998 0.35906 0.0331 0.74764-0.28878 0.81142-0.31535 0.0602-0.56693-0.17834-0.65787-0.51909-4.97304-18.0348-14.4372-31.1699-25.9046-31.2296-7.3813 0.0207-11.1166 2.69055-13.409 9.6071zm43.388 21.7645c0.10453 0.41161 0.0667 0.75827-0.29646 0.84744-0.29468 0.075-0.56279-0.14764-0.66023-0.58524-4.7693-20.384-14.9746-34.3636-29.1804-34.3636-6.11105 0-11.3238 1.52185-15.6396 5.964l-0.19784-1.42972c4.42796-4.27205 9.6933-5.6947 15.8374-5.6947 15.1234 0 25.6424 14.935 30.137 35.2618zm3.8275 0.535c0.075 0.38622-0.0555 0.74941-0.3874 0.80374-0.31654 0.0514-0.57343-0.22028-0.64843-0.59233-4.693-22.305-15.788-38.723-33.151-38.723-6.10455 0-11.3286 2.09764-15.7258 5.7555l0.16654-1.60748c4.42205-3.40453 9.5764-5.3114 15.5592-5.3114 18.2924 0 29.687 17.3061 34.184 39.6726zm-31.651-28.224c9.512 1.1628 18.0579 12.3042 21.6726 26.9858 0.0856 0.37382-0.002 0.74351-0.31949 0.82855-0.30945 0.085-0.58347-0.11457-0.71634-0.5941-4.11319-15.8274-12.2634-24.675-20.7614-25.7569l0.12461-1.46338z'/%3E %3Cpath fill='none' d='m419.351 240.512c-0.73229-0.86634-2.92914-3.98859-2.92914-10.2703m-0.29409 8.36515c-0.68386-0.91594-2.32441-3.61004-2.32441-8.36515m-0.86103 6.4825c-0.58169-0.89174-1.75925-3.11398-1.75925-6.4825m-1.35059 4.64469c-0.39981-0.79784-1.11614-2.52402-1.11614-4.64469m-27.5044 10.2703c0.73229-0.86634 2.92913-3.98859 2.92913-10.2703m0.2941 8.36515c0.68386-0.91594 2.32441-3.61004 2.32441-8.36515m0.86516 6.4801c0.58051-0.89351 1.75512-3.11457 1.75512-6.4801m1.34941 4.64528c0.3998-0.79784 1.11732-2.52461 1.11732-4.64528'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='400.282' cy='229.24' r='6.199'/%3E %3Cpath fill='none' d='m394.135 227.779c0.66023-2.80335 3.14114-4.88977 6.14585-4.88977 2.62677 0 4.87913 1.59449 5.84705 3.86811m0.33012 4.06182c-0.70157 2.74252-3.21437 4.76929-6.17715 4.76929-2.70295 0-5.012-1.69075-5.92795-4.07185m7.562 1.62815c-0.50197 0.21142-1.05472 0.32776-1.63405 0.32776-2.28189 0-4.1439-1.80886-4.22953-4.07185m7.87325 1.99547c-0.46241 0.77835-1.16634 1.39784-2.00965 1.74863m-1.19173-1.89863c-0.14115 0.0313-0.29056 0.0479-0.44233 0.0479-1.06299 0-1.93937-0.80905-2.04508-1.84547m-2.11181-1.24134c0.12461-0.55453 0.36792-0.88878 0.46949-1.04469'/%3E %3Cpath fill='none' d='m394.135 227.779c0-2.91733 2.55827-5.35865 6.14585-5.35865 2.73838 0 5.84705 1.9246 5.84705 4.33701m0.33012 4.06181c0 2.69469-3.21437 5.07875-6.17715 5.07875-2.70295 0-5.92795-1.96476-5.92795-4.3813'/%3E %3Cpath fill='%23000' d='m423.345 242.22c3.26575 4.3311 8.30965 7.07125 13.9654 7.07125 7.39785 0 13.0294-4.59686 13.0294-11.9451-0.1683-3.89292-2.79685-8.7018-9.01595-8.7018-4.04055 0-7.4705 3.89528-7.4705 7.93585 0 2.23405 0.42815 3.58346 1.80059 5.2636-5.53585-1.77933-9.19845-4.72973-9.19845-11.0108 0-6.44055 4.27087-11.0546 11.2683-11.6356 23.3852-1.94351 37.6748 24.0148 40.428 59.8935 3.92422 51.177-23.6782 91.9745-65.637 115.271-5.8571 3.25099-10.4498 5.8512-12.4394 6.69215l-0.0265 6.36555c15.975-6.1063 34.4959-17.8914 46.0465-28.4416 21.9922-20.0906 42.9732-54.0775 39.7902-99.852-2.01142-28.9063-11.0126-48.293-22.0624-57.8705-18.8924-16.3807-44.6516-9.838-44.6516 9.57755 0 4.23957 1.66713 8.2246 4.17343 11.387zm-46.592 0c-3.26634 4.3311-8.30965 7.07125-13.9672 7.07125-7.39605 0-13.0276-4.59686-13.0276-11.9451 0.1683-3.89292 2.79685-8.7018 9.01595-8.7018 4.03996 0 7.4705 3.89528 7.4705 7.93585 0 2.23405-0.42815 3.58346-1.80059 5.2636 5.53525-1.77933 9.19845-4.72973 9.19845-11.0108 0-6.44055-4.27087-11.0546-11.2683-11.6356-23.3852-1.94351-37.6742 24.0148-40.428 59.8935-3.92422 51.177 23.6782 91.9745 65.637 115.271 5.8571 3.25099 10.4498 5.8512 12.4394 6.69215l0.0265 6.36555c-15.975-6.1063-34.4959-17.8914-46.0465-28.4416-21.9922-20.0906-42.9732-54.0775-39.7902-99.852 2.01142-28.9063 11.0126-48.293 22.0624-57.8705 18.8924-16.3807 44.6516-9.838 44.6516 9.57755 0 4.23957-1.66595 8.2246-4.17342 11.387z'/%3E %3Cpath fill='%23f1bf31' d='m400.048 406.956c-15.975-6.1069-34.4959-18.6685-46.0465-29.2181-21.9922-20.0906-41.5784-53.303-38.3953-99.078 2.01201-28.9046 10.5496-47.2069 21.5976-56.785 18.8929-16.3778 43.2579-8.92205 43.2579 8.95925 0 9.83975-7.98545 17.8382-17.8311 17.8382-5.96105 0-12.2546-4.83662-11.6315-12.101 0.1683-3.89115 3.37618-6.9951 7.30865-6.9951 4.04055 0 7.31635 3.27401 7.31635 7.31635 0 2.23228-1.46339 4.38543-3.03898 5.72895 6.22265-0.22205 11.677-5.5063 11.677-11.7874 0-6.44055-4.89154-11.8288-11.889-12.4098-23.3852-1.94351-38.4974 24.6313-41.0468 60.668-3.62481 51.2045 24.297 92.5955 66.2555 115.89 5.88365 3.26575 10.4935 5.25475 12.466 6.08325 1.97421-0.82855 6.5823-2.81752 12.466-6.08325 41.9587-23.2943 69.8805-64.6855 66.2555-115.89-2.54941-36.0366-17.6616-62.6115-41.0468-60.668-6.99745 0.5811-11.8866 5.9693-11.8866 12.4098 0 6.2811 5.45195 11.5654 11.677 11.7874-1.57618-1.34351-3.04193-3.49666-3.04193-5.72895 0-4.04233 3.27638-7.31635 7.31695-7.31635 3.93248 0 7.1427 3.10394 7.31105 6.9951 0.62244 7.26435-5.67285 12.101-11.6338 12.101-9.84565 0-17.8294-7.99845-17.8294-17.8382 0-17.8813 24.3638-25.337 43.2561-8.95925 11.0504 9.57815 19.588 27.8806 21.5976 56.785 3.18307 45.7748-16.4032 78.9875-38.3953 99.078-11.5506 10.5496-30.0714 23.1112-46.0465 29.2181z'/%3E %3C/g%3E %3C/g%3E %3Cg id='laurel' fill='%23000' stroke='%23000' stroke-width='0.933' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath d='m302.443 357.768s-3.28465-1.32638-4.73859-2.05335c-2.5252-1.2626-8.21575-8.26535-14.5736-11.9551-9.75885-5.6622-19.2041-4.20236-27.8327-7.90865 1.93288 9.03605 8.02085 17.198 18.101 21.5209 8.28071 3.55217 21.6414 0.49843 23.0947 0.6189 1.45394 0.12284 6.0691 1.90394 6.0691 1.90394l-0.11988-2.12657z'/%3E %3Cpath d='m267.223 369.044l0.0874-0.26398c5.338-0.72638 10.3382-1.93642 15.5309-3.25335 11.5046-2.91496 16.8945-0.54803 26.2176 5.8329 0.58346 0.3998 1.275 0.9567 1.9435 1.20827 1.51122 0.57107 2.4815 0.17244 3.94075 0.17244l0.13347 0.0266 2.18563 1.70906c0.16653 0.13051 0.0667 0.24449-0.0909 0.27815-1.90393 0.39212-4.50413 0.38622-6.49664 0.20551-3.00651-0.27402-9.1943 6.8516-18.0018 6.8516-11.1603 0-18.4937-4.93938-25.4498-12.7672z'/%3E %3Cpath fill='%23658d5c' d='m316.303 374.316c-1.74213 0.062-3.59882 0.062-5.3179 0.35079-5.1325 0.86397-10.2136 6.4553-18.0183 6.67975-10.3854 0.29881-16.9429-4.59272-24.0414-11.5736 10.3276-1.55256 18.3106-7.51595 28.9666-4.16279 5.4632 1.71908 11.8848 8.5996 17.0138 7.61399l1.39724 1.09193z'/%3E %3Cpath stroke-width='0.45' d='m309.878 372.946s-9.11045 1.49705-14.785 1.51181c-9.16535 0.0206-23.1928-3.79961-23.1928-3.79961s13.986 4.2313 23.1928 4.41792c5.6622 0.11456 14.785-1.2 14.785-1.2v-0.93012z'/%3E %3Cpath fill='none' stroke-width='0.777' d='m284.538 262.675c0.075-0.28701 0.0189-0.63366-0.16004-1.063-0.18248-0.44468-0.46476-0.91771-0.76358-1.42027-0.31181-0.52559-0.64193-1.07776-0.90296-1.65296-0.26397-0.58523-0.46712-1.2124-0.50905-1.86673l1.41614-0.40512c0.10158 0.7937 0.57933 1.81299 1.1191 2.61437 0.2681 0.39862 0.53976 0.72697 0.77066 0.93425 0.11575 0.1057 0.20966 0.17066 0.27078 0.19664 0.033 0.0165 0.42667 0.44704 0.42667 0.44704l-1.17136 2.61615c-0.0871 0.19549-0.60383 0.0124-0.49635-0.40037z'/%3E %3Cpath stroke-width='0.777' d='m338.065 388.946c-0.046-1.89981 0.33012-1.19173 2.37697-0.35728 0.43642 0.17657 0.11457 0.60413-0.25925 0.83681-1.22303 0.76417-2.30256 2.38346-2.82166 2.02027-1.40787-0.98445-0.52145-1.01929 0.70394-2.4998z'/%3E %3Cpath d='m289.158 254.936c-6.0254 15.3189-8.05985 42.4441-5.9752 54.761 6.4069 37.8674 37.5957 73.3685 66.1455 79.1055 24.8309 4.99075 39.9668 16.1162 49.852 27.9821 6.4612 7.7551 9.91065 11.2766 19.1876 26.7201 3.39035 5.6439-2.40886 6.78545-4.80059 2.1059-6.52795-12.7654-10.0453-18.4382-19.04-28.4728-9.65905-10.7764-23.8672-20.4514-47.0575-25.0802-27.6544-5.5205-60.049-41.0841-66.4565-78.9495-2.08524-12.3189-0.26162-41.7296 6.06259-57.275l2.08229-0.89705'/%3E %3Cpath d='m330.29 387.334c-4.30217 0.47185-7.2112 6.7175-11.5276 10.6476-7.94825 7.23425-20.6846 7.9565-28.8054 3.1252-0.34015-0.20374-0.5126-0.6567-0.12815-0.74527 10.0966-2.29017 11.4136-16.0689 32.4608-14.713 2.46674 0.15945 3.50905 0.66438 5.98585 0.66438l2.01437 1.02106z'/%3E %3Cpath d='m314.307 323.269l0.13937 0.0679c0.1063 6.15474 4.77343 14.5488 5.91735 21.3183 0.98681 5.8299-0.43583 10.7032-2.66989 16.1344-0.55866 1.35354-1.86909 4.07421-1.92047 5.4071-0.0478 1.24134 0.73051 2.38996 1.38897 3.41752 0.23032 0.36141 1.62343 2.19035 1.47992 2.54527-5.5766-4.82894-2.29606-1.6813-4.61693-6.13345-1.19645-2.29606-2.62264-4.38071-3.80846-6.6933-6.26045-12.2114-6.3762-26.064 4.09016-36.0638z'/%3E %3Cpath d='m354.556 389.97c-2.73898-0.88464-5.52755-1.97598-7.0305-4.77934-2.5252-4.70551-1.98485-8.50864-4.57441-13.3777-4.91221-9.2374-14.3699-10.2319-19.1433-18.7949-0.96792 7.87975-2.02441 19.6524 10.2425 28.0718 4.3187 2.96279 10.9051 3.6437 12.4914 4.83366 1.58858 1.18996 2.5435 2.89016 2.5435 2.89016l5.47085 1.1563z'/%3E %3Cpath fill='%23658d5c' d='m349.244 388.53c-0.90118-0.95905-1.9122-1.9246-2.98169-2.69882-2.50336-1.81063-7.9246-1.9813-12.0177-4.9813-5.71596-4.19232-8.67875-8.0888-10.2668-14.997-0.96378-4.18996-0.22264-7.53955-0.0254-11.0232 5.149 7.47875 14.0941 8.1827 18.88 17.1296 2.90905 5.43605 2.52283 13.7038 8.48385 17.009l-2.07225-0.43819z'/%3E %3Cpath stroke-width='0.777' d='m300.355 347.397s-0.34075 0.41043-0.82027 1.77756c-0.21378 0.61417 1.13326 2.46437 1.02342 1.82244-0.27402-1.56969 0.49842-2.67402 0.49842-2.67402l-0.70157-0.92598z'/%3E %3Cpath fill='%23658d5c' d='m302.443 357.768s-3.28465-0.70748-4.73859-1.43209c-2.5252-1.26436-8.1142-8.59604-14.5736-12.2652-9.26045-5.25885-17.3268-4.16043-26.4378-6.8244 2.58544 9.72285 7.52716 15.5392 16.7061 19.66 8.2199 3.68977 21.6414 0.49902 23.0947 0.6189 1.45394 0.12284 6.0691 2.05985 6.0691 2.05985l-0.11988-1.81713z'/%3E %3Cpath fill='%23466343' d='m315.478 368.908c-0.4063-2.89252-3.6939-7.0559-5.07045-9.74825-2.01555-3.94783-3.52914-8.2559-3.97972-12.6827-0.97146-9.53625 1.21653-14.6817 7.4929-21.7488 0.0461 2.07166 0.32421 2.79863 0.9496 4.725 2.62618 8.09175 6.30355 14.7798 5.1118 23.5772-0.5876 4.33111-4.12382 10.4976-4.28563 13.1445-0.0827 1.37067 0.69095 2.97993 1.37422 4.13445l-1.59272-1.40138z'/%3E %3Cpath d='m291.921 343.116c-6.73585-11.1974-22.5342-6.17895-32.8872-15.5805-5.0244-4.56319-7.2691-11.4319-8.27185-17.9646-0.29941-1.94528-1.12973-9.6567-0.67677-11.1538 0.0827-0.27815 0.36319-0.34488 0.57933-0.13288 3.43228 3.35552 6.87285 5.52285 10.8466 8.214 9.4388 6.3886 13.3134 12.385 18.1778 22.3476 6.37085 13.0453 12.1447 5.61025 12.2321 14.2701z'/%3E %3Cpath stroke-width='0.45' d='m312.93 328.102s-2.13839 11.2022-1.81477 18.4069c0.33248 7.36065 3.59646 18.5498 3.59646 18.5498h-0.62126s-3.38386-11.1827-3.5935-18.5498c-0.20788-7.2384 2.43307-18.4069 2.43307-18.4069z'/%3E %3Cpath fill='%23658d5c' d='m281.964 336.012c-3.62862-1.15123-7.78551-1.85014-12.2024-2.91413-4.13977-0.99685-7.52065-3.25807-10.6766-6.10215-4.8998-4.4185-6.5197-10.3424-7.4746-16.6978-0.53563-3.56339-0.68091-7.01635-0.44233-10.6222 0.39449 0.69508 0.89469 1.38248 1.54843 1.85138 3.21437 2.30315 6.564 3.91004 9.78365 6.23565 2.81338 2.03268 4.81122 3.37382 7.1185 5.97345 2.91673 3.29114 5.35215 6.84745 7.40375 10.7327 1.61752 3.06615 3.00413 6.66085 5.0953 9.4429z'/%3E %3Cpath fill='%23a48253' d='m282.118 333.911c1.08366 1.44508 5.4567 3.32245 7.04705 3.52559l1.54665 3.85808v-0.00005c-2.27178-2.65837-5.26653-4.17895-8.74741-5.28332z'/%3E %3Ccircle fill='%23d99f31' cx='271.96' cy='304.79' r='4.417'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m272.469 300.875c-0.22364 0.52367-0.35938 1.12912-0.35938 1.78125 0 1.94764 1.15049 3.53125 2.5625 3.53125 0.3918 0 0.76155-0.12675 1.09375-0.34375 0.0919-0.33421 0.14063-0.68228 0.14063-1.04688 0-2.01267-1.49482-3.67002-3.4375-3.92187z'/%3E %3Ccircle fill='none' stroke-width='1.244' cx='271.96' cy='304.79' r='4.719'/%3E %3Cpath d='m285.013 302.83s2.06162-7.676 4.00276-12.4264c4.59036-11.2458 12.5516-11.6687 16.6086-20.5742 2.32264 6.0124 4.17756 13.7427 0.11988 22.4132-4.68366 10.0164-16.6689 15.8941-16.6689 15.8941l-4.06241-5.3067z'/%3E %3Cpath fill='%23466343' d='m305.587 271.848c5.9823 16.3305-1.91634 28.0884-16.4197 36.1966l-3.82027-5.2801c2.49331-10.4876 4.28327-15.6514 12.2958-23.1036 3.16832-2.94626 5.9445-3.90296 7.9441-7.813z'/%3E %3Cpath fill='%23a48253' d='m288.712 255.666c-5.97105 15.6951-7.7362 41.9398-5.6805 54.084 6.424 37.9571 37.5272 73.589 66.2345 79.357 24.7559 4.9748 39.5563 16.1244 49.7504 27.6461 4.76103 5.38405 8.60255 10.6412 11.7644 15.5912 2.72008 4.25846 5.0498 8.9055 7.3376 12.5823 0.36969 0.5935-2.71949 1.87086-3.04606 1.3435-2.4189-3.91004-4.64233-8.84055-7.42855-13.3565-3.17067-5.1372-8.61675-10.3925-13.353-15.9838-10.0784-11.8996-23.4998-20.8424-46.7604-25.4846-27.5032-5.48975-59.512-40.6193-65.9025-78.39-2.07638-12.2705-0.54626-40.7498 4.92106-55.7845l2.16319-1.60454z'/%3E %3Cpath d='m285.719 329.932c-1.23366-1.18169-3.00886-2.30905-4.1941-3.54035-11.0274-11.4449-8.1313-31.4374 3.96319-41.2022 0.41162-0.33013 0.72284-0.17481 0.78071 0.31122 0.48603 4.02814 1.1126 7.81889 2.72835 12.2563 3.68977 10.1344 4.29154 15.9466 0.93839 24.5752-2.04508 5.25945 0.006 9.89825 0.006 9.89825l-4.22245-2.29843z'/%3E %3Cpath stroke-width='0.623' d='m324.604 379.212c-7.0553-2.41241-14.3433-1.76516-20.2104-7.85495-6.77125-7.024-8.237-17.8896-6.4677-24.1642 0.0868-0.30473 0.32362-0.55453 0.51437-0.31949 1.50355 1.84134 2.30079 3.16654 4.27737 4.62343 7.0677 5.21455 15.7447 7.826 18.7405 15.7908 0.59823 1.58445 0.79607 3.24508 1.35355 4.84193 1.90866 5.47145 5.03975 7.1244 9.5746 10.1114l-7.7823-3.02894z'/%3E %3Cpath fill='%23658d5c' d='m330.117 382.116c-6.6012-5.59785-18.4966-3.5876-25.5804-11.1809-5.2016-5.5748-7.3943-14.3664-6.10455-21.9904 6.287 5.60195 13.5974 7.14035 19.3158 13.4298 6.72935 7.40435 0.99921 12.3726 13.6683 19.5774l-1.29922 0.16418z'/%3E %3Cpath d='m294.865 341.944l0.0189-0.17185c1.64055-1.95414 0.50256-7.82365-0.0354-10.1764-0.92776-4.05532-1.04233-7.54135-0.36733-11.671 0.77894-4.76929 3.39036-9.0756 6.06735-13.024 1.19351-1.75866 5.07045-7.2573 5.47265-9.24865 0.0331-0.17008 0.21378-0.15767 0.28878 0.006 1.47815 3.22323 2.25059 7.14745 2.84705 10.6317 0.83268 4.87914 1.0937 9.3136-0.60059 14.8618-1.51535 4.96654-3.55276 8.1809-6.67325 11.5216-1.32047 1.41201-4.42677 4.52422-4.8815 6.2061-0.0827 0.30709-0.61004 2.54587-0.4937 4.18347l-1.64291-3.1187z'/%3E %3Cpath stroke-width='0.948' d='m283.939 277.75s0.20965 0.0313 1.09429-0.56221c0.88405-0.59173 1.95531-1.61102 2.41063-2.88425 0.45414-1.27087 3.64193-11.8618 7.89865-18.417 4.97244-7.65945 10.1362-11.0935 16.3984-16.7144 0.98386 6.0691 1.12737 15.9608-4.00335 23.8984-4.69843 7.26735-16.6122 12.4435-17.9929 12.9832-1.3813 0.53976-3.74823 0.93898-5.10825 2.74489-0.77008 1.01929-1.2998 3.0065-1.2998 3.0065l0.60236-4.05532z'/%3E %3Cpath d='m282.442 278.762s-0.51733-0.0248-1.18583-0.96733c-0.66614-0.94547-1.33642-2.40236-1.33642-3.9 0-3.16594 3.00237-12.642 1.513-19.816-2.84233-13.6914-7.1445-19.1811-7.8065-24.2616-0.26398-2.02677-11.4449 13.8301-8.04565 28.5449 1.68543 7.2927 10.1616 15.4441 11.351 16.5154 1.18996 1.07126 2.81338 2.46023 3.58996 4.60098 0.7996 2.20748 0.62953 4.71909 0.62953 4.71909l1.29094-5.43545z'/%3E %3Cpath d='m289.004 255.212c0.80374-1.96063 2.13248-4.28327 3.36201-5.31085 3.02244-2.5252 11.4904-8.81455 14.3823-13.399 6.4382-10.2071 5.139-22.7788 4.46634-24.968-5.58305 4.85433-10.6784 8.0563-16.3701 16.092-4.96831 7.0134-6.05435 20.7296-6.4364 23.3298-0.41929 2.8376-1.67953 5.9049-1.67953 5.9049l2.2754-1.64882z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.948' d='m283.998 279.97l0.22441-1.97244c1.53189-0.58582 2.89488-2.11181 3.51319-3.59055 2.66811-6.38446 4.2939-12.8746 8.04155-18.7712 4.86496-7.65355 10.076-10.6311 15.3354-14.8352 0.24508 6.76419 1.43681 13.8897-3.94902 22.7546-3.06083 5.0327-11.9805 10.0199-17.5323 12.2102-2.48327 0.98032-4.26024 1.77698-5.63325 4.20473z'/%3E %3Cpath d='m261.115 266.482c8.51105 7.0884 10.9382 10.4026 13.4416 21.3679 0.2935 1.28445 1.92284 6.83445 2.26831 7.5183 0.81968 1.63169 2.51575 2.40413 3.56043 3.74291 0.11398 0.14765 0.39685 3.03603 0.44055 3.41634 0.0266 0.22973-0.15 0.22382-0.28051 0.10571-1.3246-1.21063-2.02027-3.1063-3.56516-4.24016-1.32874-0.97559-5.8181-1.93346-7.7551-2.73248-4.94587-2.04094-8.9805-5.85945-11.8453-10.3317-3.7813-5.90255-4.20886-13.94-3.29941-20.7054 0.20965-1.55315 0.41929-3.42342 0.96969-4.89567 0.0768-0.20315 0.19724-0.1559 0.30059 0.006 2.01673 3.14174 3.31181 4.70493 5.76435 6.74825z'/%3E %3Cpath fill='%23658d5c' d='m279.992 299.389l0.23504 2.0061c-4.04055-5.46735-5.39235-3.85157-10.9778-6.16475-4.8626-2.01142-8.80985-5.7638-11.6356-10.1575-4.2189-6.56105-4.14035-16.2697-2.35866-23.6676 2.26535 4.46575 11.129 8.9451 14.5305 14.5199 2.18799 3.58524 3.54566 7.84605 4.63169 11.8848 0.54212 2.01969 1.15453 6.09155 1.98957 7.76105 0.62244 1.24784 2.50807 2.91556 3.58524 3.81792z'/%3E %3Cpath fill='%23658d5c' d='m295.366 342.052c1.50768-2.30197 0.18661-8.1366-0.29469-10.7776-0.7435-4.08662-0.79724-7.61575-0.13051-11.7402 1.0878-6.74115 5.35455-11.2571 9.12345-16.7203 0.74292-1.07776 1.48406-2.16791 2.06752-3.34252 4.33111 12.192 5.54585 24.6455-3.89291 34.8856-1.42441 1.54548-4.8502 4.52481-5.3758 6.4016-0.28229 1.00512-0.37973 2.07224-0.45886 3.11043l-1.03819-1.81712z'/%3E %3Cpath fill='%23a48253' d='m331.315 385.465s-0.53386 0.84921-3.04016 0.84921l1.24289 1.2192c0.25017-0.0784 0.50714-0.14533 0.77146-0.19993 2.39586-0.4937 3.13346-0.42107 4.69252 0.18306'/%3E %3Cpath fill='%23466343' d='m328.275 386.314c-2.5063 0-10.3441-1.30157-16.6146 0.33662-9.4553 2.47086-13.3588 11.3156-20.4662 14.459 10.797 4.64941 18.6992 3.50492 27.6838-3.68091 3.62005-2.89435 5.92197-8.41799 10.6398-9.89557z'/%3E %3Cpath fill='none' d='m405.404 431.001s0.0992-1.37835 1.68957-1.93052c1.37244-0.47776 2.08288 0.61417 2.08288 0.61417'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m340.475 388.878s-0.84922 0.49488-1.10019 0.7187c-0.57934 0.51909-1.34174 0.90118-1.57796 1.3252l-0.92244-0.0856c0.57343-0.47717 1.17933-1.29331 1.50532-1.69016 0.19134-0.23032 0.004-1.10669 0.004-1.10669l2.09114 0.83858z'/%3E %3Cpath fill='%23658d5c' stroke='none' d='m287.558 255.574c1.69665-4.80414 1.65768-10.1492 2.60787-15.1382 2.00197-10.5166 4.98957-13.9358 12.587-20.9705 2.42067-2.24055 4.89981-3.87047 7.5325-5.86005 0.42638 3.0254 0.62481 5.56475 0.31772 8.60255-1.49469 14.86-7.82365 18.3674-18.4352 27.4554-2.05807 1.76044-2.58898 4.22717-4.60985 5.91085z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m287.961 254.318c0.27697-0.40453 0.54271-0.63839 0.68622-0.57048 0.11457 0.0543 0.12992 0.28878 0.0614 0.61772-0.33308 0.43111-0.70513 0.83918-1.1504 1.21004 0.14646-0.41516 0.27992-0.83445 0.40276-1.25729z'/%3E %3Cpath fill='none' d='m287.558 255.574c1.69665-4.80414 1.65768-10.1492 2.60787-15.1382 2.00197-10.5166 4.98957-13.9358 12.587-20.9705 2.42067-2.24055 4.89981-3.87047 7.5325-5.86005 0.42638 3.0254 0.62481 5.56475 0.31772 8.60255-1.49469 14.86-7.82365 18.3674-18.4352 27.4554-2.05807 1.76044-2.58898 4.22717-4.60985 5.91085z'/%3E %3Cpath stroke='none' d='m288.224 256.116s0.38208-1.16457 0.95728-2.65158c0.5752-1.48642 0.42757 0.39862 0.42757 0.39862l-0.33839 1.61989-1.04645 0.63307z'/%3E %3Cpath fill='%23658d5c' stroke='none' d='m282.056 278.96l-0.77658 2.49331c-0.43582-3.24449-1.80236-4.69016-4.13976-6.8061-10.1805-9.21025-14.5305-20.0504-10.2596-32.7248 1.49527-4.43032 2.93445-6.874 6.08385-10.33 1.98897 3.40807 2.95275 5.44665 4.3311 9.1447 3.49252 9.38445 4.88563 14.69 3.50079 25.4392-0.49016 3.79724-2.31083 8.42125 0.20965 11.7974 0.27579 0.36732 0.61004 0.79724 1.05059 0.98622z'/%3E %3Cpath fill='none' d='m282.056 278.96l-0.77658 2.49331c-0.43582-3.24449-1.80236-4.69016-4.13976-6.8061-10.1805-9.21025-14.5305-20.0504-10.2596-32.7248 1.49527-4.43032 2.93445-6.874 6.08385-10.33 1.98897 3.40807 2.95275 5.44665 4.3311 9.1447 3.49252 9.38445 4.88563 14.69 3.50079 25.4392-0.49016 3.79724-2.31083 8.42125 0.20965 11.7974 0.27579 0.36732 0.61004 0.79724 1.05059 0.98622z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m281.765 284.471s0.24567-2.46437-0.13642-3.96319c-0.18898-0.74586-0.68326-1.84607-0.68326-1.84607s1.2248 0.62303 1.50531 0.5687c0.28051-0.052-0.68563 5.24055-0.68563 5.24055z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m285.922 260.331c-0.58701 0.23917-2.39173-2.30433-2.61142-4.02579-0.20729-1.63642-0.87874-0.95315-0.79961 0.34666 0.14765 2.41712 3.0378 5.0061 2.63741 6.5427 0.5439-1.32048 0.80079-2.2754 0.77362-2.86359z'/%3E %3Cpath fill='none' stroke-width='0.777' d='m285.922 260.331c-0.58701 0.23917-2.39173-2.30433-2.61142-4.02579-0.20729-1.63642-0.87874-0.95315-0.79961 0.34666 0.14765 2.41712 2.72835 4.56614 2.32796 6.1004'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='281.443' cy='253.512' r='4.416'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m281.706 253.088c-1.19646-0.83918-1.72146-2.15492-1.17107-2.94213 0.54981-0.78484 1.96595-0.74291 3.16418 0.0957 1.19764 0.83858 1.72086 2.15492 1.17106 2.93976-0.5498 0.78662-1.96594 0.7435-3.16417-0.0933z'/%3E %3Ccircle fill='none' stroke-width='1.315' cx='281.402' cy='253.639' r='4.607'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='303.963' cy='344.419' r='4.572'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m303.43 343.97c-0.97559-1.34291-1.00866-2.98169-0.0744-3.65846 0.93425-0.67855 2.48149-0.14114 3.45709 1.20236 0.97323 1.34173 1.00866 2.97933 0.0744 3.65906-0.93425 0.67854-2.48091 0.14114-3.45709-1.20296z'/%3E %3Ccircle fill='none' stroke-width='1.4' cx='303.963' cy='344.419' r='4.805'/%3E %3Cpath fill='none' d='m406.8 432.551s0.0502-1.39134 1.69016-1.77756c1.49527-0.35079 2.08228 0.92539 2.08228 0.92539m7.22835 15.6142c-2.98818 0.61713-4.81535-3.13287-3.78957-4.05531 0.67087-0.60177 2.32323-0.47303 3.53563 0.1187 2.16792 1.05708 1.58623 3.6626 0.25394 3.93661z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m417.799 447.313c-2.48149 0.6313-4.43091-2.70118-3.7872-3.43583 0.5935-0.67737 1.8496-0.71221 3.0626-0.12343 2.16791 1.05945 2.04271 3.225 0.7246 3.55926z'/%3E %3Cpath fill='none' d='m417.799 447.313c-2.48149 0.6313-4.43091-2.70118-3.7872-3.43583 0.5935-0.67737 1.8496-0.71221 3.0626-0.12343 2.16791 1.05945 2.04271 3.225 0.7246 3.55926z'/%3E %3Cpath stroke-width='0.45' d='m287.438 256.177c3.1435-9.15885 4.89567-15.5976 10.1008-24.5445 3.54035-6.08385 10.4834-14.6941 10.4834-14.6941s-6.5386 8.83465-9.9307 14.9598c-4.79469 8.66045-5.8701 12.3874-9.69685 23.4579l-0.9567 0.82087z'/%3E %3Cpath stroke-width='0.45' d='m272.549 235.821s-1.14803 14.387 0.66023 23.2943c1.62579 8.00195 7.27325 19.6317 7.27325 19.6317s0.31595 0.23445-1.3187-4.07599c-1.67953-4.42677-3.82027-9.32305-5.18029-15.5811-1.93052-8.88426-1.43446-23.2689-1.43446-23.2689z'/%3E %3Cpath stroke-width='0.45' d='m259.099 273.201s1.90394 4.97953 3.53622 7.95475c4.48052 8.17205 8.3256 12.4476 15.9726 17.7732l0.22441-0.6874c-7.37305-5.23465-10.8402-9.414-15.5788-17.0858-1.83721-2.97756-4.15453-7.95475-4.15453-7.95475z'/%3E %3Cpath stroke-width='0.45' d='m286.481 276.543s9.1565-8.45435 13.8384-15.0656c4.13799-5.84645 9.10275-16.21 9.10275-16.21s-4.53426 10.4918-8.55 16.3736c-4.51004 6.60355-13.1516 14.902-13.1516 14.902h-1.23957z'/%3E %3Cpath stroke-width='0.45' d='m295.454 342.794c1.74212-4.19646 4.36241-9.975 6.3183-16.6317 2.45433-8.35275 3.91122-12.4228 4.19232-21.9278-0.14114 9.49075-1.15275 12.7718-3.1624 20.6776-1.71083 6.7299-4.05295 12.6366-5.7951 16.8307l-1.55315 1.05118z'/%3E %3Cpath stroke-width='0.45' d='m290.24 300.668s6.89705-6.0313 9.97915-11.4296c4.06063-7.11615 4.7439-12.828 4.7439-12.828s-0.0661 5.7431-4.12559 12.8581c-3.08091 5.4006-10.3234 12.2882-10.3234 12.2882l-0.27402-0.88878z'/%3E %3Cpath stroke-width='0.45' d='m282.38 334.885s-5.9504-3.77008-9.2126-6.5191c-12.6573-10.6618-20.5866-25.0323-20.5866-25.0323s7.24665 15.1736 20.1212 25.653c3.42224 2.78445 9.67795 6.67325 9.67795 6.67325v-0.77481z'/%3E %3Cpath fill='none' d='m283.201 336.413s-1.13977-0.48661-0.54626-1.57205'/%3E %3Cpath stroke-width='0.45' d='m328.64 379.995c-5.58545-3.51083-13.4445-8.74135-20.527-16.0164-2.42481-2.49212-5.91495-6.6691-5.91495-6.6691s2.8317 4.42028 5.14075 6.8244c6.3142 6.57165 14.987 12.7382 20.5724 16.2496l0.72874-0.38858z'/%3E %3Cpath stroke-width='0.45' d='m347.968 386.704s-10.5059-7.5366-15.2315-14.1142c-2.57126-3.57579-3.81909-5.78505-5.55885-9.8321 2.08878 4.05532 3.50493 6.25395 6.33485 9.8321 4.73209 5.98525 14.4555 13.184 14.4555 13.184v0.93012z'/%3E %3Cpath stroke-width='0.45' d='m295.95 400.21c15.4476-2.14725 21.4565-11.1726 34.614-13.2224-1.38662 0.0726-1.13327-0.47126-2.39351-0.20551-11.6026 2.44783-18.6974 11.2246-32.2205 13.428z'/%3E %3Ccircle fill='%23d99f31' stroke='none' cx='314.799' cy='382.209' r='4.572'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m319.287 381.34c-0.0402 0.14823-0.0998 0.29173-0.17775 0.42756-0.67087 1.16102-2.5063 1.35354-4.09902 0.43405-1.59449-0.92007-2.34449-2.60551-1.67303-3.76653 0.19074-0.33071 0.47716-0.58287 0.825-0.75295 0.20846-0.0289 0.42047-0.0443 0.6372-0.0443 2.22697 0 4.0813 1.5939 4.4876 3.70216z'/%3E %3Ccircle fill='none' stroke-width='1.399' cx='314.799' cy='382.209' r='4.805'/%3E %3Cpath fill='%23a48253' stroke='none' d='m330.798 384.331s0.42933 0.24331 0.6933 0.54213c0.26576 0.29941 0.36379 0.6561 0.18071 0.88405 0 0 0.10571 0.2622 0.44823 0.51083 0.45886 0.33425 1.063 0.30768 1.72972 0.41161 0.84922 0.137 1.44509 0.25335 2.04686 0.42992 0.60472 0.17657 1.36239 0.49016 1.36239 0.49016l-3.42579-1.7067-3.03543-1.56201z'/%3E %3Cpath stroke-width='0.45' d='m297.758 357.549s-8.52695-2.23583-19.4214-6.3012c-10.8951-4.06772-18.2368-10.872-18.2368-10.872s7.34175 6.18365 18.2368 10.2508c10.8945 4.06772 19.4214 5.99235 19.4214 5.99235v0.93012z'/%3E %3Ccircle fill='%23d99f31' stroke-width='1.244' cx='334.687' cy='394.974' r='4.882'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m338.153 397.954c-1.46103 0.55394-3.39153-0.39626-4.47638-2.27598-1.17107-2.02678-0.91418-4.36654 0.57283-5.22695l0.0638-0.0349c0.12283-0.009 0.24626-0.0154 0.37145-0.0154 2.52461 0 4.57205 2.04685 4.57205 4.57441 0 1.1374-0.41574 2.17795-1.10374 2.97874z'/%3E %3Ccircle fill='none' cx='334.683' cy='394.974' r='4.572'/%3E %3Cpath fill='%23a48253' stroke='none' d='m289.595 332.55s0.5191 1.58859 0.92422 2.57657c0.30059 0.73347 0.83622 1.85197 0.83622 1.85197s-1.11851 0.23918-1.11851 0.11457c0-0.1252-0.87225-4.52422-0.87225-4.52422l0.23032-0.0189z'/%3E %3Cpath fill='%23658d5c' stroke='none' d='m289.006 333.474c-1.65118-2.52874-5.162-5.34215-7.14685-7.40375-3.41339-3.54449-5.5317-7.6063-6.31005-12.4914-1.83779-11.5464 1.52008-19.3116 9.9455-27.117 0.53209 8.1 5.1638 14.8152 6.1441 22.904 1.40551 11.6026-5.97755 13.7894-0.84922 25.1445l-1.78346-1.03642z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m287.887 331.17s0.0986 0.50079 0.2374 1.12086c0.32894 0.39803 0.62657 0.79429 0.88051 1.18229l1.4622 0.8498-0.7813-2.66693-1.79882-0.48602z'/%3E %3Cpath fill='none' d='m289.006 333.474c-1.65118-2.52874-5.162-5.34215-7.14685-7.40375-3.41339-3.54449-5.5317-7.6063-6.31005-12.4914-1.83779-11.5464 1.52008-19.3116 9.9455-27.117 0.53209 8.1 5.1638 14.8152 6.1441 22.904 1.40551 11.6026-5.97755 13.7894-0.84922 25.1445'/%3E %3Cpath stroke-width='0.45' d='m288.996 331.076c-3.35552-5.04745-4.01162-7.5142-5.4301-12.7158-2.66811-9.7689-2.68465-21.6325-0.17421-25.966-2.51044 4.33346-3.02717 16.1368-0.60001 25.9748 1.36654 5.5435 2.45374 8.43605 5.56475 13.5414l0.63957-0.83445z'/%3E %3Cpath fill='none' d='m288.588 332.886c-0.81968-0.95729 0.22855-2.52933 1.17107-1.14213'/%3E %3C/g%3E %3Cg id='oak' fill='%23000' stroke='%23000' stroke-width='0.933' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='0.777' d='m514.668 257.68c-0.013-0.0437 0.0135-0.23032 0.039-0.26752 0 0 0.297-0.43405 0.6-1.14626 0.30705-0.7246 0.61415-1.72146 0.6313-2.83464l1.65885 0.34133c-1.3825 4.93878-1.4386 6.6892-1.4386 6.6892-0.013 0.41575-0.48365 0.47953-0.6065 0.0833l-0.88405-2.86535z'/%3E %3Cpath d='m519.124 275.312c1.32345-0.86811 1.7675-3.11044 1.8502-4.56142 0.14765-2.60374-2.02205-4.90866-2.13425-7.32105-0.0709-1.54725 1.26615-1.7067 1.5195-2.91319 0.2244-1.07776-3.96145-4.85611-2.8317-7.83365 0.80785-2.12835 2.50395-1.08189 3.15175-3.30768 0.6827-2.35689-1.435-5.7248 1.2874-7.30925 1.32225-0.77008 3.264 0.35078 3.8392-1.7126 0.5858-2.09941 0.11985-6.2705 3.1435-6.56515 4.0116-0.39272 4.6317 7.8195 5.3693 8.39645 0.76595 0.6 1.79175-0.5002 2.88425-0.0667 2.94625 1.17343-0.20785 6.60885-1.22125 8.42185 7.47285 0.30532 0.63955 4.95237-0.50845 7.0181 0.3177 0.75414 2.2299 1.03407 2.5435 2.1821 0.2055 0.7559-0.36145 1.42028-0.88465 1.88326-1.67365 1.47816-4.1711 2.03269-5.9882 3.22855l-0.24925 0.17894c-0.062 0.68268 1.8313 2.68228-0.72045 3.52972-4.76515 1.58623-7.7988 2.62618-9.63605 7.43921-0.4943 1.29153-0.66675 5.25529-0.75825 4.84843l-0.65615-5.53585z'/%3E %3Cpath fill='%23658d5c' d='m519.848 279.074l-0.82795-3.63779c0.2238-0.12107 0.41455-0.30177 0.59765-0.47599 0.96965-0.93189 1.43265-3.50905 1.50765-4.80236 0.16185-2.80926-1.87735-4.42028-1.9789-6.75651-0.052-1.2124 1.2939-1.64645 1.5112-2.79448 0.27635-1.46162-3.7559-4.99548-2.6988-7.75926 0.7187-1.87263 2.4602-0.90531 3.16415-3.34488 0.6124-2.12598-1.2248-5.91735 1.07305-7.19055 1.3878-0.76595 3.38445 0.46535 4.0553-1.99311 0.50845-1.85847 0.11635-5.0309 2.7431-5.2943 3.57105-0.35728 4.1067 6.81435 5.03505 7.5266 1.02995 0.78897 1.84785-0.23504 2.8382 0.15177 1.4929 0.58287 1.125 2.64272 0.78895 3.83032-0.38855 1.38071-1.0612 2.51929-1.63225 3.80197-0.11165 0.25571-0.114 0.49606 0.1872 0.61063 0.9384 0.35492 1.73975 0.20492 2.06575 1.43621 0.4423 1.67186-2.126 3.49843-2.6947 4.82363-0.4429 1.0317 1.29155 1.29331 1.51715 2.65985 0.32185 1.92874-6.15175 4.09016-6.64785 4.99547-0.0579 1.26437 1.62165 2.57244-0.4193 3.25571-5.1266 1.71733-10.2449 4.94587-10.1846 10.9571z'/%3E %3Cpath stroke-width='0.45' d='m519.398 275.86s6.52795-11.6226 8.41535-19.8744c1.30395-5.7118 1.87915-14.9581 1.87915-14.9581s-0.2829 9.2132-1.4138 14.9398c-1.7232 8.7059-8.4697 20.987-8.4697 20.987l-0.411-1.09429z'/%3E %3Cpath stroke-width='0.777' d='m519.608 286.898c-0.008-0.0478 0.048-0.23032 0.0809-0.26575 0 0 1.275-1.34114 2.0327-2.19863 0.29525-0.33248 0.4795-0.73523 0.58995-1.06299 0.1057-0.31772 0.1388-0.5504 0.1388-0.5504 0.0295-0.20551 0.20785-0.31771 0.4051-0.25098l2.1697 0.71634c0.29705 0.0974 0.336 0.36732 0.0809 0.54803-0.014 0.008-1.66775 1.17933-2.26535 1.8939-1.3205 1.57382-1.66715 2.16909-2.19865 3.79311-0.1246 0.37559-0.5362 0.34665-0.6-0.046l-0.43405-2.57658z'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m520.348 289.424c0.54565-1.67008 0.91535-2.29902 2.25475-3.89587 0.6313-0.75177 2.32555-1.94941 2.32555-1.94941l-2.17025-0.71634s-0.14115 1.02519-0.80315 1.77756c-0.76005 0.85925-2.04095 2.20689-2.04095 2.20689l0.43405 2.57716z'/%3E %3Cpath d='m511.694 247.35s2.726 5.43365 5.07225 13.7888c4.8378 17.2506 5.46495 39.649 3.3803 51.9685-6.4075 37.8674-40.6624 73.2755-68.315 78.796-23.1928 4.62815-36.8734 14.5134-46.5945 25.236-7.5579 8.73485-10.4794 13.9424-17.3333 27.9054-2.10945 4.29803-9.01535 5.14135-6.04605-0.90945 5.37345-9.49075 10.477-18.2569 18.3484-27.5882 10.2336-11.5654 24.9366-22.9098 49.7652-27.8994 28.549-5.7366 61.442-41.0841 67.85-78.9495 2.08405-12.3189 1.44215-39.1695-5.5193-56.443l-0.60825-5.9049'/%3E %3Cpath stroke-width='0.846' d='m497.255 240.334s-8.04805-0.30532-4.17756-6.401c-3.68327-1.81063-8.1242-5.0935-3.37205-7.80295-0.21319-0.92363-3.02244-1.81063-2.81103-3.98859 0.12284-1.25197 1.7067-1.8248 1.8437-2.36279-0.52323-0.98622-4.19587-5.7012-2.92323-7.10905 1.95355-2.15965 6.17481 0.44173 8.09706 1.60098 0.47834-0.2935 1.18642-0.88878 1.66181-1.20472 2.80512-1.85847 2.99173 2.63681 3.75945 4.07362 0.35315 0.65847 2.56712-1.125 4.06182-0.33425 2.58485 1.36654 1.4433 4.70315 2.09295 6.9555 0.6472-0.0703 1.57795-0.59764 2.22575-0.64134 4.19-0.28051 1.9205 7.0949 1.74155 9.414 6.66085-0.96082 1.5372 5.8736 1.9063 11.7437 0.10215 1.62166-0.4004 5.20335-1.6506 3.82678-3.9425-4.34174-14.8996-3.15414-12.4559-7.7699z'/%3E %3Cpath stroke-width='0.977' d='m496.324 264.527c-1.44154-0.11634-4.56851-0.55866-5.18505-1.9252-0.97382-2.16792 1.55905-2.9126 1.43445-3.07678-0.88642-1.17992-4.99488-1.93523-5.0179-3.58819-0.0165-1.16043 1.92284-1.99075 1.57973-3.04783-0.46949-1.44685-3.23682-3.64843-2.16378-5.2571 1.30039-1.94528 4.03465 0.6685 5.35275 0.65197 0.62716-0.008 1.51417-1.39725 2.71594-1.41851 1.76929-0.029 2.84705 3.41339 3.51556 3.32008 0.73937-0.10157 1.19173-1.11732 1.91872-1.33464 2.21695-0.66733 2.85 1.72972 3.37205 3.29055 1.0317 3.08563 2.1443-0.57697 3.812 0.14941 4.21475 1.83957 2.47915 10.0931 3.70215 11.084 0.73645 0.59528 2.11715 0.52087 2.6593 1.36181 1.1545 1.7941-0.42935 5.4189 0.45885 8.664 0.35965 1.3128 4.4557 5.1248 4.4557 5.1248s0.636 3.81792 0.5315 3.6189c-1.8455-3.55098-2.24645-4.3937-5.55-6.9183-3.1748-2.4248-7.9996-0.50197-9.1128-1.77283-1.2378-1.41614 0.1931-2.70827-0.45-3.32835-0.2457-0.23504-3.97265 0.15118-4.5331 0.0951-2.64922-0.26575-5.0805-2.67638-3.49607-5.6929z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.977' d='m518.514 278.198l0.42755 2.37697c-6.7955-9.72105-12.3414-5.85945-13.7988-7.4392-1.10905-1.20237 0.30475-2.06811-0.6-3.01063-0.9573-0.99863-6.66911 1.11496-8.36576-3.32008-0.35315-0.92244 0.90708-2.44607 0.26988-2.57067-1.44508-0.28288-3.39272-0.24272-4.38485-1.55079-0.41338-0.54626-0.7689-1.2939-0.22854-1.88386 0.28051-0.30473 0.61063-0.56398 0.84449-0.91063 0.88288-1.3128-4.48642-2.32559-4.50295-4.27973-0.0106-1.11968 1.46161-1.52421 0.92185-2.90256-0.47126-1.20649-2.10118-3.20374-1.2691-4.51654 1.00925-1.58976 3.27225 0.41162 4.53308 0.55689 0.6189 0.0709 1.66949-1.3872 2.69114-1.41614 1.62579-0.0479 2.3191 2.97284 3.56221 2.85059 1.2124-0.11988 2.5896-2.00551 3.91655-0.36732 0.9242 1.14212 0.90295 4.47697 3.0685 3.51083 0.51735-0.23032 1.2874-0.86162 1.86675-0.61004 3.46535 1.49882 2.5807 7.0677 3.4423 10.0305 0.463 1.59035 2.11595 1.23957 2.7077 2.22342 0.2864 0.47776 0.5256 1.03051 0.57285 1.59036 0.042 0.48012-0.0325 0.95374-0.0974 1.42677-0.2681 1.92047-0.0874 3.64606 0.401 5.52755 0.3856 1.49882 2.4933 4.27677 4.02165 4.68425z'/%3E %3Cpath d='m520.088 307.84l0.34015-0.27992c1.19825-0.0213 2.0268-2.49804 2.3876-3.44527 1.5012-3.93426-1.19585-10.4622 3.34725-10.4416 0.2321-1.62757 0.56515-5.625 2.0451-6.69036 1.0736-0.77362 2.12595 0.19961 3.15175-0.1057 0.76005-1.53189 1.12145-4.43918 3.30355-4.84784 0.69155-0.12874 2.1431 0.99449 2.38405 0.87225 0.5953-0.29882 1.3016-3.41811 3.04785-3.88937 1.07715-0.29055 2.0929 0.82205 2.48505 0.57106 0.63955-0.40925 1.25845-1.07775 1.78995-1.64468 2.27775-2.43307 5.1177-2.475 5.04155 0.77067-0.027 1.1563-0.76655 2.78858-1.17935 3.84331-0.1417 0.35728 1.4321 1.1061 1.67125 1.56555 0.80555 1.53425-2.02615 3.35551-2.6598 4.56378 0.0435 0.20373 1.4994 0.49428 1.7167 0.79901 1.88565 2.63741-3.57105 5.52755-4.95175 7.14865-0.5439 0.63779 1.3246 2.0563 1.06535 3.16063-1.0441 4.42854-7.86495 2.79863-9.375 3.48602-0.525 0.24095-0.68505 2.61201-1.12915 3.21437-1.92045 2.59548-9.5262-0.57519-11.2536 1.05059-1.5738 1.48229-2.09705 4.00926-3.09805 5.8116-0.2161 0.39213-0.63365 0.27166-0.5982-0.1376l0.4677-5.3752z'/%3E %3Cpath fill='%23658d5c' d='m520.538 308.03c1.4079-0.0685 2.28605-2.63268 2.7112-3.74764 0.55455-1.45335 0.802-2.90256 0.8581-4.45158 0.0851-2.25059-1.5242-6.20434 1.97005-5.6687 0 0 0.73705-5.2754 2.24825-6.49194 0.98505-0.79134 2.7437-0.34252 3.1689-0.6567 1.0075-0.74291 0.61715-3.95965 2.79035-4.37067 0.84155-0.16004 2.351 0.67264 2.99235 0.35315 0.8037-0.4004 1.0919-2.81398 2.6303-3.22441 0.962-0.25571 2.2364 0.78248 2.8636 0.39036 1.3246-0.82677 2.33325-3.44292 4.2065-2.91733 2.11415 0.59174 1.3683 3.80138 0.8309 5.11595-0.38445 0.94075 0.68505 1.2815 1.06475 1.97244 0.71045 1.29744-1.6506 3.35906-1.94525 4.50354-0.11225 0.4252 0.9283 0.9443 1.18935 1.22303 1.57205 1.67953-2.4768 4.64882-3.56455 5.57716-0.32425 0.27578-1.02815 0.82795-1.06715 1.27086-0.0832 0.94193 0.9319 1.62933 0.6703 2.77796-0.8888 3.89882-6.316 2.74901-8.44845 3.46122-0.85985 0.28582-0.98445 2.03209-1.51595 2.76142-1.7061 2.34212-9.18605 0.0791-11.1933 1.9122-1.2 1.09607-2.16795 2.9817-2.82995 4.45808l0.3697-4.24843z'/%3E %3Cpath stroke-width='0.45' d='m521.658 307.028c0.2362-0.0661 9.06675-7.0949 14.0268-12.4831 4.0618-4.41201 9.4577-12.121 9.4577-12.121s-5.3315 7.86085-9.3018 12.4305c-5.0203 5.77855-13.9447 13.5024-14.1809 13.5691-0.2368 0.0661-0.23915-1.32933 0-1.39548z'/%3E %3Cpath d='m523.694 284.444c-2.07815-1.20827-1.7693-7.67365 1.27085-10.6075 2.5559-2.4691 9.7063 4.8 7.487 7.8065-1.22715 1.66359-6.5675 4.07421-8.7579 2.80099z'/%3E %3Cpath d='m532.498 280.529c-1.28565 1.05708-4.27145-0.32362-5.7868-1.83898-1.38895-1.39134-2.23285-3.51968-1.4014-4.50177 1.6376-1.94351 6.2014-4.73386 8.3941-2.8943 2.1821 1.82953-0.0415 8.27835-1.2059 9.23505z'/%3E %3Cpath fill='%23a48253' d='m532.078 281.366c-1.16695 1.58031-6.2622 3.61713-8.1496 2.52047-1.6423-0.95492-1.6234-6.8374 1.35825-9.71695 1.88095-1.81476 8.8925 4.35178 6.79135 7.19645z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m533.248 271.806c1.8189 1.52657 0.0584 7.45455-1.0488 8.3634-0.9402 0.77481-3.6124-0.25925-5.1614-1.80768-1.4073-1.41024-2.07815-3.3809-1.5319-4.02815 1.68365-1.99606 5.9238-4.05354 7.74215-2.52756z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m531.891 271.844c-0.52735 0.5568-0.875 1.50977-0.875 2.59375 0 1.68392 0.8431 3.05749 1.89065 3.10937 0.14395-0.45772 0.27745-0.94121 0.375-1.4375 0.1685-0.85662 0.2537-1.73033 0.1875-2.4375-0.0662-0.70716-0.28955-1.21091-0.57815-1.45312-0.005-0.005-0.01-0.0111-0.0155-0.0156-0.2463-0.20005-0.57355-0.31783-0.96875-0.35938-0.005-0.0005-0.011 0.00049-0.0155 0z'/%3E %3Cpath stroke-width='0.863' d='m493.752 286.796c-0.58111-1.79174-3.34311-3.02717-3.63308-5.18445-0.1311-0.98032 0.94252-2.64744 0.85276-2.938-0.47717-1.55728-3.07441-3.56516-1.7439-5.50215 1.71732-2.50216 4.16279 0.0809 6.19845 0.67264 0.33366-0.12697 0.44586-1.24606 1.24134-1.45748 3.11634-0.82854 5.8299 4.23367 6.64845 4.54075 2.41655 0.91595 4.3122-3.35964 5.6262 5.98405 1.03405-0.24743 2.4396-0.50256 3.0632 0.56044 2.5701 4.40374 1.0695 13.8927 6.2055 16.4422l0.16655 0.33661c-0.0703 0.37323-0.2368 3.17836-0.99035 2.26359-1.29805-1.57382-2.3197-3.8126-4.5803-4.20886-2.38585-0.41752-12.8032 3.35138-13.0831-1.38071-0.0331-0.55866 0.72284-1.3252 0.47304-1.86733-0.59529-1.30334-6.85336-0.84685-7.51006-4.34528-0.25689-1.37244 0.70807-2.62264 1.06535-3.91594z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.863' d='m517.578 301.936c-3.8309-5.9445-5.5441-3.70216-11.3616-3.26398-1.32695 0.0992-5.8016 0.28642-5.72245-1.95414 0.023-0.63779 0.5067-0.80551 0.10985-1.57382-0.84511-1.64468-6.08803-1.3435-6.87698-4.38898-0.40866-1.57618 0.45709-3.70039 0.23681-4.29449-0.7311-1.97834-3.98622-3.82854-3.0189-6.41989 0.12874-0.34429 0.31949-0.66202 0.38209-1.0317 0.19488-1.1439-2.14311-3.76418-1.10256-5.45255 1.20886-1.96359 3.31949-0.4128 4.92697 0.31536 1.15039 0.52205 0.85925-0.49607 1.61988-0.74705 1.32815-0.44055 2.98347 0.82854 3.87229 1.67953 0.4984 0.47953 2.074 2.35925 2.475 2.54586 0.93835 0.43583 2.53285-0.0602 3.62125 0.32185 0.97735 0.34488 1.63995 4.44921 1.7876 5.49565l0.18895 0.13111c0.89055-0.19312 2.20275-0.18485 2.73665 0.68326 2.4289 3.96142 1.2354 13.4191 6.44645 16.2904l-0.3213 1.66359z'/%3E %3Cpath stroke-width='0.45' d='m517.278 301.663s-6.9183-11.4426-12.89-17.4284c-3.80965-3.81615-10.6412-8.82875-10.6412-8.82875s6.89587 5.2305 10.6412 9.26045c5.44845 5.8612 11.4951 16.9966 11.4951 16.9966h1.3949z'/%3E %3Cpath d='m509.884 319.282c0.30885 0.14704 0.96675 0.0325 1.37835 0.14291 3.0484 0.83268-1.314 9.67206-1.5614 11.6126-0.0644 0.51733 0.2675 2.18918 0.235 2.30079l-0.66495 3.76241c-0.1181 0.39035 0.0726-3.74351-0.52735-4.77343-1.0624-1.82717-4.4138-0.84095-6.13525-1.1067-2.84648-0.43819-0.6254-2.87126-1.86085-3.36555-2.04095-0.81614-6.2994 0.34902-6.8061-2.68878-0.18898-1.13386 0.55866-2.34685 0.48189-3.31595-1.46339-1.69429-5.22225-2.07224-4.7876-5.04745 0.14941-1.03169 1.65413-2.12657 1.61338-2.79508-0.052-0.80964-3.15-3.0815-2.41122-4.73563 0.45296-1.01102 1.32697-1.01516 1.40965-1.60512 0.0874-0.61063-2.51162-4.51181-0.32599-5.56655 2.62264-1.26496 4.78878 1.6937 6.67795 1.8313 0.9567 0.0703 1.80237-1.49527 3.24922-1.17342 1.52657 0.34074 1.69667 2.38583 2.39232 3.52146 0.67445 0.0248 1.33705-0.69744 2.08645-0.77422 3.19725-0.33484 2.70295 4.7876 3.5256 6.5504 0.0998 0.21437 1.0612-0.36732 1.45745-0.21142 0.6685 0.25926 0.91595 1.00453 1.0128 1.65709 0.2811 1.91811-0.7429 3.96968-0.43935 5.7803z'/%3E %3Cpath d='m530.144 326.956c0.6006 6.0378-7.58505 0.0909-12.0862 2.48976-1.3429 0.71339-4.48465 3.1187-4.2561 2.54115l1.13325-2.85296c0.37385-0.31594 1.58035-0.32008 2.00435-0.51319 0.9756-0.44409 2.31025-1.98838 3.2055-3.66437 1.2396-2.32323 0.3945-4.94941 1.14805-6.6567 1.1545-2.61024 2.961-0.21023 3.73935-0.77421 1.44095-1.04469 1.68425-6.32245 5.20395-6.37675 0.92715-0.0147 0.90885 0.16417 1.5508 0.47362 0.7323-1.06713 0.9691-2.37933 2.39175-2.82343 1.02755-0.32185 1.7291 0.59351 2.6787 0.58465 0.68095-0.53327 3.3201-4.95532 5.4827-4.43623 2.4319 0.58288 0.96615 4.90808 0.7831 6.4925 0.2681 0.29469 0.60415 0.28819 1.0299 0.85748 1.67365 2.23996-0.949 4.6317-1.8502 6.3951 0.23685 0.52914 0.9136 0.49784 1.06125 1.17048 0.6 2.73484-4.5945 3.07146-5.1301 3.80256 0 0.25276 0.3998 0.54508 0.3549 1.1185-0.26395 3.34902-8.025 2.45434-8.4449 2.17206z'/%3E %3Cpath d='m477.587 346.87c0.15355-1.14449-2.24055-2.88012-1.23543-4.45217 0.81554-1.27441 2.67815-0.61595 3.42756-1.27205 0.64606-2.02677-0.42697-4.75926 2.38642-5.3888 1.42795-0.31712 2.21279 1.12972 2.67579 2.23052 0.17421 0.40866 0.80787 2.93563 1.05295 3.02303 0.52736 0.18898 1.92461-0.80964 2.62441-0.71044 1.90571 0.27461 0.40276 3.84095 0.98209 4.84843 0.40689 0.70808 1.42205 0.14941 2.07047 0.37205 1.92224 0.66024 0.42933 3.85926 0.42933 5.2258 0 0.83682 1.38484 1.09193 1.49941 2.5122 0.20138 2.54587-1.95 2.82167-3.17304 4.46634-0.17007 0.23033-0.21141 0.34252-0.0183 0.57698 2.1071 2.56889 0.91359 3.82087-1.4185 5.51695-2.74665 1.99489-6.9762 3.26575-5.42305 7.5307 0 0-1.38897 2.85059-1.53838 1.90217-0.22028-1.39548 0.45649-2.81989 0.0703-4.3376-0.41339-1.61929-5.3634-3.74764-5.56065-5.4939-0.14115-1.2313 1.2874-1.41614 1.3996-2.52461 0.12933-1.26024-4.2939-2.42363-3.77657-4.92107 0.27992-1.35 1.71909-1.74626 2.34803-2.83642-0.10157-1.06063-5.03505-4.82894-0.70334-5.8116 0.54567-0.12461 1.41319-0.11634 1.8809-0.4565z'/%3E %3Cpath fill='%23658d5c' d='m481.75 372.916c0.1683-1.22953 0.31771-2.89075 0.004-4.09666-0.45236-1.74449-4.29626-3.93898-4.46634-5.4508-0.10985-0.96319 0.6254-1.21476 0.77893-2.4189 0.20788-1.62283-3.78898-2.66161-3.31594-4.89567 0.28819-1.36831 1.99783-2.02205 1.83543-3.23681-0.0892-0.67677-2.11358-2.34863-1.68189-4.08662 0.35079-1.40551 1.875-0.84508 2.75906-1.55256 0.97027-0.77303-1.90158-3.1311-0.98563-4.54961 0.72638-1.12677 2.71358-0.63306 3.27638-1.43031 0.58346-0.82441-0.46713-4.26674 2.3002-4.90867 2.18917-0.50669 2.63504 4.19174 3.56339 4.875 0.87815 0.64843 1.27677-0.5126 2.65099-0.32598 1.35413 0.18484 0.31004 3.49252 0.84566 4.48937 0.57874 1.0813 1.49883 0.22205 2.43544 0.5563 1.51122 0.53977 0.0206 3.74587 0.0206 4.86083 0 1.16457 1.2313 1.1628 1.34114 2.54115 0.17893 2.24054-1.95178 2.80748-3.07914 4.18819-0.31181 0.37972-0.33898 0.73287 0.007 1.10492 2.02855 2.18563 0.59764 3.49842-1.3748 4.92283-3.06437 2.21516-6.66495 3.43996-5.12185 7.90215l-1.79233 1.51181z'/%3E %3Cpath d='m531.058 337.065c1.5242-0.39213 3.61715-1.87854 5.08935-0.70335 2.79035 2.22933-2.0699 6.13345-2.96695 8.22225-0.017 0.76181 1.5526 1.02107 1.4504 2.55532-0.17835 2.69764-3.77185 2.12244-5.462 3.08563-0.13345 0.48602 0.6183 0.90708 0.6183 1.3872 0 3.81851-5.76555 2.37697-7.9642 3.09154-0.6998 0.22618 0.47955 2.24823-2.02085 3.1937-1.07955 0.4063-2.6244-0.0213-3.7187-0.21437-1.3264-0.23445-2.67815-0.50847-4.03405-0.43406-0.55865 0.0313-1.1315 0.17835-1.69255 0.12933-0.24035-0.0213-0.41275-0.1376-0.32185-0.40925l6.3-18.5852c0.13465-0.39862 2.87185 0.6378 3.4819 0.6378 0.67855 0 1.3453-1.42441 1.8189-1.8567 1.6441-1.50118 2.4378 0.6313 3.81025 0.63957 1.0004 0.004 3.81615-5.589 5.612-0.73937z'/%3E %3Cpath stroke-width='0.777' d='m499.83 340.094c-0.049-0.78544-1.62933 1.60453-1.62933 1.60453s1.12323 1.1067 1.88745 1.76279c0.9425 0.81201 2.5228 1.95355 2.5228 1.95355l0.1518-1.17697s-2.79276-1.95177-2.93272-4.1439z'/%3E %3Cpath d='m498.153 332.518c0.42815 0.6059 0.16004 1.42441-0.13288 2.03209-0.32126 0.67086-0.51023 1.07185-0.94901 1.65531-1.43681 1.90394-4.62756 3.60414-6.0685 2.61615-1.3122-0.89941-3.99508-8.7809-1.89567-10.1386 1.99666-1.29213 7.17755 1.1876 9.04605 3.83504z'/%3E %3Cpath d='m490.57 336.029c0.62303-0.94311 1.53307-1.65945 2.42185-2.33622 1.26378-0.96733 4.47992-2.67815 5.9002-1.30748 1.86262 1.79941 2.75967 7.23955 0.59586 9.12875-2.85059 2.49212-7.464-0.37737-9.26045-2.84409-0.6183-0.84862-0.17008-1.86496 0.34252-2.64095z'/%3E %3Cpath fill='%23a48253' d='m493.292 334.184c1.94764-1.44685 4.16044-2.25059 4.99725-1.37008 2.24647 2.3693 2.35927 6.90355 0.7996 8.22815-1.57145 1.33346-5.224 1.22716-8.3758-2.75493-0.66496-0.84094 0.6124-2.64153 2.57894-4.10315z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m497.646 332.256c1.05237 1.93523-4.68839 7.33345-6.60295 6.0549-1.32874-0.88465-3.13937-7.67835-1.83544-8.85415 1.84193-1.663 7.5242 1.11732 8.4384 2.79921z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m490.641 329.5c-0.47064 0.0306-0.83673 0.15553-1.0625 0.35937-0.0285 0.0258-0.067 0.11921-0.10937 0.23438 0.78185 0.38655 2.17713 0.73662 3.60937 1.375 2.04575 0.91048 3.46033 2.10899 4.0625 1.76562 0.0958-0.33218 0.10073-0.59098 0.0312-0.71875-0.14553-0.26775-0.62961-0.74254-1.28125-1.1875-0.65163-0.44495-1.46835-0.8852-2.3125-1.21875-0.84414-0.33355-1.71393-0.56172-2.4375-0.60937-0.18089-0.0119-0.34311-0.0102-0.5 0z'/%3E %3Cpath fill='%23466343' d='m512.038 356.94c2.87125-0.13878 5.61675 1.13622 7.35235 0.50905 2.58485-0.93012 1.0069-2.94212 2.25295-3.05433 1.24605-0.11456 7.53305 0.34666 7.5266-2.78209 0-0.60236-0.5067-0.8374-0.2805-1.51594 0.22615-0.67913 4.9565-0.45059 5.1266-2.97756 0.10745-1.61102-1.36005-1.62933-1.13385-2.60551 0.22615-0.9756 5.2925-5.76851 2.7679-7.75275-1.7386-1.36654-4.5868 1.01929-4.85495 0.32184-0.35075-0.90944-0.4293-1.67007-1.58205-1.77755-1.66715-0.15355-2.67405 2.4998-3.76185 2.4998-1.09015 0-1.5862-1.09016-2.7035-0.99036-1.46165 0.12874-1.6819 2.36103-2.928 2.36103-1.24545 0-3.18895-0.69154-3.18895-0.69154l-6.2994 18.5846s1.03995-0.0974 1.7067-0.12874z'/%3E %3Cpath fill='none' stroke-width='0.623' d='m515.124 349.614s5.91555-2.24055 9.39095-4.26674c3.32245-1.93701 7.99785-5.71655 7.99785-5.71655m-17.3888 9.98325s5.91555-1.92932 9.39095-3.95551c3.32245-1.93937 7.99785-6.02775 7.99785-6.02775'/%3E %3Cpath stroke-width='0.777' d='m477.297 379.028s2.34213-0.56752 3.28111-0.56752c0.93779 0 1.49232 0.45472 1.49232 0.45472l1.06536-1.95767s-3.18544 0.37795-4.12973 0.29291l-1.70905 1.77756z'/%3E %3Cpath fill='none' d='m463.168 400.047c-1.86024-2.26949 4.31102-8.15435 6.6071-6.489 1.64468 1.1941 3.7122 6.3142 2.07461 7.8425-1.82776 1.7002-7.20295 0.45236-8.6817-1.35354z'/%3E %3Cpath stroke-width='0.777' d='m460.324 392.568l-0.68563-0.0472c-1.20414-1.50177-1.64233-1.56142-3.40689-2.04331-0.56102-0.15355-0.63956-0.74528-0.0337-0.90709l2.13484-0.56043c0.33839-0.088 1.2437 0.72047 1.50059 0.91122 0.40748 0.30295 2.47914 0.74705 1.71969 1.48051l-1.22895 1.16635z'/%3E %3Cpath fill='none' d='m459.855 391.228c0.87165-1.31221 6.28465-1.62402 9.44115 1.15807 1.94114 1.71378 0.37972 4.13031-1.46162 5.68935-1.82303 1.54489-4.58267 2.81988-5.71654 1.82894-3.21615-2.81339-3.31182-7.09845-2.263-8.6764z'/%3E %3Cpath fill='%23658d5c' d='m513.108 333.132s2.61675-2.72422 4.7256-3.78485c4.0925-2.06161 10.7433 1.25611 11.7313-0.61063 0.50435-0.95079-0.2569-1.64646 0.37795-1.8998 0.63365-0.25335 7.89035 1.18582 8.17855-2.09528 0.0543-0.59114-0.7553-0.88996-0.1264-1.52185 0.63075-0.63071 5.2134-0.93779 4.75455-3.10394-0.1447-0.6933-1.1421-0.88878-0.8864-1.58208 0.25335-0.69567 3.6874-3.95965 2.22165-5.96105-0.42755-0.58406-1.5071-0.46949-1.4268-1.18347 0.2557-2.21752 1.0016-5.64565-0.8303-5.8246-1.9683-0.19075-4.2685 3.81201-5.0368 3.96615-0.95375 0.19075-1.52185-0.74941-2.475-0.4441-1.5827 0.50611-1.83545 2.85059-2.47085 2.85059-0.6331 0-0.58525-0.65433-1.60335-0.63366-3.1081 0.065-3.3691 5.0516-4.9246 6.27695-0.88645 0.69744-1.40965-0.24271-2.2837-0.062-2.1537 0.44174-1.5183 5.82755-2.65985 7.54135-1.1427 1.7126-3.61295 3.73878-4.11965 3.99449-0.50905 0.25335-1.50535 0.25099-1.50535 0.25099l-1.64055 3.82677z'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m455.154 389.994s1.97244 0.6626 3.28051 0.73346c0.87992 0.0478 2.2565-0.12637 2.2565-0.12637s-0.54095 0.11398-1.125-0.29942c-0.19075-0.13523-1.54252-1.33287-1.54252-1.33287l-2.86949 1.02519z'/%3E %3Cpath fill='%23a48253' d='m460.398 391.64c1.45335-1.64705 5.66045-1.47048 8.7455 1.25019 1.53189 1.35118 0.51909 3.3815-1.30158 4.98899-1.83366 1.61752-4.16339 2.5187-4.95236 1.83071-3.0815-2.69469-3.55867-6.8616-2.49154-8.06991z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m463.517 399.896c-0.69095-0.78897 0.41338-3.20787 1.88327-4.53248 1.30216-1.1752 3.42224-1.97835 3.88051-1.48643 1.79882 1.93111 3.64016 5.36695 2.21221 7.06951-1.43327 1.70905-6.4187 0.72874-7.976-1.05059z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m469.062 394.484c-0.0464 0.006-0.0943 0.0215-0.14063 0.0312-1.49232 0.31772-2.33885 2.27882-1.89062 4.39063 0.2006 0.94383 0.62976 1.76231 1.17187 2.34375 0.002 0.002 0.0133-0.002 0.0156 0 1.29582 0.1 2.43774-0.15348 2.85938-0.65625 0.52391-0.62469 0.48832-1.6812 0.0156-2.90625-0.43676-1.13192-1.24009-2.30607-2.03125-3.20313z'/%3E %3Cpath fill='%23a48253' stroke-width='0.777' d='m515.848 260.454s0.052-1.77107 1.4492-6.7624c0.24275-0.86988 0.90295-1.35177 0.90295-1.35177l-2.6061-0.35728s0.6644 0.6313 0.6526 1.45512c-0.033 2.33031-1.28505 4.15098-1.28505 4.15098l0.8864 2.86536z'/%3E %3Cpath fill='%23658d5c' stroke-width='0.846' d='m512.958 255.114s-1.6943-4.95237-3.14175-6.75885c-1.53185-1.91693-2.63265-2.3191-5.41475-3.20788-2.4608-0.7872-6.30416-1.42027-6.46596-3.34901-0.16358-1.92874 0.0626-1.56378-0.63897-1.74863-2.25886-0.5935-5.0829-1.34055-4.54311-3.57756 0.53976-2.23819 1.37244-2.58661 0.40512-3.0561-1.42855-0.68918-5.18505-2.87599-4.73623-4.78997 0.44646-1.91634 2.11772-1.94173 1.41378-3.11693-0.5061-0.84035-2.31732-1.76279-2.17205-3.29468 0.10039-1.04469 1.42264-1.38307 1.38307-2.31319-0.0395-0.93189-3.58996-5.064-1.50118-6.78955 1.90394-1.57145 5.26595 1.2378 6.1252 1.59271 0.86162 0.35492 1.85197-1.4681 3.11221-1.1687 1.61988 0.38623 1.70492 2.81103 2.18209 3.67088 0.87401 1.56732 2.66223-0.47185 4.06123 0.27992 2.3321 1.25433 1.5201 5.56655 2.1496 6.43879 0.6266 0.87166 2.3498-0.52145 3.57285 0.15119 1.90215 1.05059 0.2746 7.34645 0.3986 8.37995 0.12465 1.03701 1.5077 0.14586 2.2967 0.76063 2.10115 1.63583-0.4565 6.6-0.052 10.7882 0.1394 1.44744 0.48605 3.69568 0.48605 3.69568l1.0795 7.41319z'/%3E %3Cpath d='m496.894 399.126c0.66082 1.13504 1.86083 1.91811 2.41653 3.08504 0.78544 1.64055 0.0502 3.30768-1.93051 3.18543-0.85748-0.0526-1.64646-0.71456-2.46851-0.7813-0.66496-0.0514-2.56653 2.49154-4.41024 2.40886-2.51279-0.11043-3.71043-3.17657-5.2429-4.74449-1.22067-0.25748-2.11772 1.54075-3.47362 1.29567-2.78622-0.50256-2.65158-4.92461-3.613-6.87225-0.76771-0.57106-1.92874 0.63721-3.47362-0.45531-2.3876-1.68544-1.1374-6.98445-3.69804-8.46675-2.25472-1.3063-7.02345-0.44055-6.60885-0.65788l2.65807-1.3813c0.16595-0.0874 0.67441 0.15591 0.84036 0.18898 4.3565 0.86752 10.187 0.15354 14.6528 0.15354 2.14075 0 1.79646 1.72973 2.14075 2.08288l0.17244 0.0265c2.22342 0.15413 4.87736-0.008 6.77305 1.39311 2.29429 1.70315 0.12283 3.225 0.11457 3.60709l0.10334 0.0496 0.48544 0.16417 1.49764 0.43996c1.16043 0.37205 2.46023 0.88642 3.23858 1.875 1.13445 1.44095-0.13878 2.11359-0.17421 3.40335z'/%3E %3Cpath fill='%23466343' d='m467.191 386.192c0.96142 0.60827 13.7864 0.20374 15.5084 0.20374 1.86201 0 1.25374 1.47165 1.88918 2.02618 0.77244 0.35079 9.57995 0.0585 7.5744 3.38682-0.23032 0.38209-0.53209 0.72697-0.72638 1.12736l0.0449 0.36969c0.89941 0.74527 4.02224 0.80374 5.3817 2.5559 0.81023 1.04645-1.33642 2.72598-0.41693 3.38858 1.76516 1.26851 5.7118 6.9142-1.45158 5.2193-1.72323-0.40866-3.76358 4.39607-7.5118 0.0963-0.45472-0.52323-1.51122-2.04803-1.94586-2.34862-1.04646-0.72284-2.37874 0.95728-3.6626 0.74764-2.36044-0.38859-2.50748-4.52835-3.35729-6.26455-1.17106-0.81792-2.15079 0.1559-3.54803-0.83091-3.16831-2.23583 0.71456-9.9077-9.5368-8.7614l1.75866-0.91594z'/%3E %3Cpath stroke-width='0.45' d='m466.256 386.406s9.65435 1.95531 15.2008 4.7504c5.09055 2.56653 11.9197 8.46319 11.9197 8.46319s-6.6567-6.26635-11.7644-8.92795c-5.2866-2.75315-14.5819-4.59508-14.5819-4.59508l-0.77422 0.30946z'/%3E %3Cpath d='m491.113 376.212c2.50394 2.31909-1.28268 10.0447-4.1256 9.56105-4.53012-0.77185-7.0181-5.8884-6.16475-8.0687 0.91181-2.33563 7.58505-3.99685 10.2904-1.49232z'/%3E %3Cpath fill='none' d='m486.598 384.988c-1.28031-0.91831-0.78839-4.16929 0.34488-6.13345 1.03819-1.79882 2.51457-2.92795 3.6437-2.57481 3.2126 1.00276 6.33305 5.22816 5.1307 7.80235-1.1811 2.53701-7.8443 1.81713-9.1193 0.90591z'/%3E %3Cpath fill='%23a48253' d='m490.902 376.44c2.3002 2.12953-1.35177 9.14585-3.86161 8.7183-4.31752-0.73523-5.87245-5.1809-5.3492-7.0116 0.53799-1.89153 6.6567-4.07185 9.21085-1.7067z'/%3E %3Cpath d='m505.924 381.749c-0.411 0.5439-1.275 1.55492-2.1762 1.54665-3.84331-0.0366-3.5752-3.31772-5.5937-5.49745-0.67677-0.16417-1.17697 0.63307-2.49981 0.33189-1.73386-0.39685-1.83956-4.81476-4.43681-5.7177-1.3128-0.45531-4.9689-0.47421-6.9992 1.43209l3.63308-2.82756c3.51141 1.37834 6.67559-6.09625 10.6972-5.10355 1.14212 0.28169 1.17933 1.02756 2.50039 0.91122 2.93565-0.25984 5.92145-2.18622 9.45475-1.01988 2.1142 0.69803-0.63305 3.52972 2.0398 3.2061 1.7191-0.20964 4.2809-0.20138 4.7917 1.93524 0.28055 1.17283-0.3242 1.70433-0.19545 2.55354 0.34665 0.27047 6.79845 2.51457 3.38445 4.24193 0.54035 1.51654 3.13345 2.5317 1.761 4.38957-1.2874 1.74626-4.0299-0.19075-4.79055 0.5315-0.31295 0.30118-0.30055 1.13622-0.57635 1.4811-1.138 1.41319-4.1327-1.45807-5.4112-1.72854-1.2685 4.31102-3.5693 2.28012-5.58305-0.66614z'/%3E %3Cpath fill='%23658d5c' d='m491.454 372.425c2.66634 0.75118 2.73898 4.86437 4.27559 5.2488 1.53603 0.38386 1.49646-0.42579 2.45847-0.20374 0.88878 0.20374 1.78583 5.3882 6.08326 4.85256 1.0943-0.13701 1.64295-1.30039 1.64295-1.30039s1.57145 2.57716 3.2238 2.80925c2.37815 0.33425 1.69725-1.8059 2.3008-1.87677 0.96615-0.11162 2.7425 1.9376 4.5183 1.9376 1.0004 0 0.8575-1.7067 1.91395-1.7067 1.0571 0 3.14355 1.00689 4.00335-0.23091 1.12325-1.61516-1.4929-3.50905-1.68365-4.08602-0.1931-0.5752 0.7435-0.59174 0.6455-1.14803-0.3638-2.05335-3.69805-2.3817-3.98685-3.1063-0.28815-0.72224 0.46535-1.46811 0.1831-2.59311-0.47715-1.91457-3.1937-1.9813-4.42265-1.70906-2.84645 0.63367-0.26575-2.40236-2.2943-3.25747-3.4925-1.47284-8.57305 1.31634-9.8705 0.77008-0.87226-0.36733-1.20474-0.47599-1.95001-0.6065-3.14587-0.54626-6.04605 4.04292-8.03325 5.0002l0.99212 1.2065z'/%3E %3Cpath stroke-width='0.45' d='m490.467 370.994s9.64847-0.59409 15.3107 1.37658c4.89805 1.70433 11.3634 6.9118 11.3634 6.9118s-6.96615-5.1242-12.1482-6.62955c-5.57482-1.61752-14.8666-0.73111-14.8666-0.73111l0.34075-0.92775z'/%3E %3Cpath stroke-width='0.45' d='m481.945 371.67s1.84547-12.28 1.68602-20.172c-0.0957-4.74449-1.00098-12.1228-1.00098-12.1228s1.26909 7.6488 1.46634 12.5888c0.29232 7.3376-1.37717 18.7754-1.37717 18.7754l-0.77421 0.93071z'/%3E %3Cpath d='m472.62 371.22c0.17657 0.525 1.9624 1.04233 1.8 3.0313-0.19488 2.43721-3.86811 1.68838-5.5766 2.83405-0.64607 0.43583 0.76535 2.52875 0.0248 3.52146-1.32697 1.77107-5.83465 0.71457-6.1624 1.15394-0.60472 0.81024 1.46929 3.04016-0.71634 4.26969-3.03838 1.70846-9.4518-0.99331-12.9106 2.07165-0.20374 0.18307-1.54901 1.69429-1.60098 1.70906-1.97717 0.52086-7.22185 1.60275-6.60885 1.34527 3.07677-1.2998 8.025-2.56653 8.99235-4.68189 0.82677-1.80236 0.20137-5.2057 0.53976-7.15335 0.50256-2.91083 2.64095-1.73976 3.34489-2.66398 0.56929-0.74705-0.48958-4.80413 1.81063-6.71635 1.61575-1.34114 3.34961-0.41987 4.82539-1.48287 1.54252-1.10847-0.78897-4.81477 2.25886-5.8695 1.83189-0.63307 3.73583 1.41201 4.15099 1.32225 1.13976-0.24449 2.47441-3.67737 4.78583-3.21556 2.30256 0.45827 1.275 3.4943 1.17697 4.89981 3.85984 0.47953 1.77106 3.34961-0.13465 5.625z'/%3E %3Cpath fill='%23658d5c' d='m441.417 390.864s8.2075-3.42993 8.87775-5.1514c1.03228-2.63918-0.0933-6.63605 1.3435-7.59095 0.93662-0.62481 1.875-0.31181 2.48977-1.2 0.61594-0.88878-0.18307-5.1951 2.03445-6.93485 1.38897-1.08839 2.64094-0.1128 4.33346-1.30217 1.82303-1.28563-0.48012-4.45984 2.3067-5.50395 1.64055-0.61476 3.28937 1.39311 4.10728 1.17933 1.57146-0.40925 2.40178-3.53622 4.7067-3.20197 1.85374 0.26811 0.94665 2.15552 0.82854 3.94075-0.0685 1.02579 1.54016 0.54981 2.01851 1.98721 0.35078 1.04645-1.08012 3.29468-2.03741 4.13209-0.54626 0.47716 1.66359 1.31575 1.53071 2.80216-0.1931 2.13662-4.31515 2.28603-5.27184 2.62855-1.23544 0.44055-0.12107 2.28661-0.95965 3.36201-1.34114 1.71909-4.77934 0.65197-5.39235 1.47224-0.56044 0.74941 0.68563 2.67993-0.89233 3.86398-1.63996 1.22953-8.01495 0.45059-9.049 0.83268-3.07264 1.1315-5.5748 2.31083-5.5748 2.31083l-5.39999 2.37343z'/%3E %3Cpath stroke-width='0.45' d='m450.209 386.042s8.97225-6.45295 13.5608-12.2232c2.53051-3.18307 5.8736-8.0185 5.8736-8.0185s-3.23681 5.0138-5.7201 8.32795c-4.52835 6.0437-13.5662 12.9496-13.5662 12.9496l-0.14823-1.03583z'/%3E %3Cpath stroke-width='0.45' d='m517.264 328.63c3.4488-1.86437 9.71105-5.09115 14.8252-9.7565 3.43995-3.13937 7.9252-8.93445 7.9252-8.93445s-4.45395 6.0939-7.9252 9.3992c-5.2199 4.97126-11.8412 8.51105-15.2906 10.3754l0.46535-1.08366z'/%3E %3Cpath fill='%23466343' d='m509.938 333.264l-0.79135 2.63268c0-3.63603-0.1435-5.3675-4.4492-5.139-0.66735 0.0331-1.35415 0.10748-2.01675 0.004-2.188-0.34252-0.50195-1.65708-1.19765-2.65807-0.85155-1.22067-6.6112-0.12401-7.0819-3.01063-0.18071-1.11673 1.06417-2.44606 0.15118-3.32245-1.38248-1.32401-4.82599-2.47205-4.45808-4.8998 0.15355-0.99863 1.49114-1.72323 1.29803-2.65335-0.25807-1.23957-2.73307-3.39508-2.12835-4.75689 0.4813-1.08603 1.36418-0.73523 1.44744-1.76043 0.0951-1.14449-1.90807-4.00099-0.12283-4.8691 2.35453-1.14449 3.94902 1.09016 5.9693 1.25433 1.17165 0.0951 1.96653-1.30039 3.18957-1.02756 1.58209 0.35078 1.59214 2.89783 2.60969 3.41929 0.3738 0.18898 1.49465-0.76004 2.02205-0.82027 2.83405-0.3254 2.1909 5.17205 3.1559 6.45945 0.35075 0.46535 1.0984 0.002 1.6051 0.16004 1.77345 0.55216-0.1264 6.5628 0.60475 7.36655 0.2486 0.27402 1.1498 0.12047 1.54425 0.23032 1.48055 0.41574 0.44645 4.23779 0.202 5.17675-0.5504 2.10768-2.45435 6.24745-1.55315 8.214z'/%3E %3Cpath stroke-width='0.45' d='m509.828 332.84s-2.74665-10.9352-6.64605-16.8118c-3.22856-4.86674-10.3028-10.8674-10.3028-10.8674s6.76715 6.04605 9.83742 10.8674c3.76415 5.90905 6.33305 16.8118 6.33305 16.8118h0.77835z'/%3E %3Cpath stroke-width='0.45' d='m515.794 275.694s-6.4925-10.546-12.0738-16.0311c-4.55554-4.48111-12.9827-9.9933-12.9827-9.9933s8.0309 5.6705 12.362 10.1658c5.2943 5.4933 11.455 15.8586 11.455 15.8586h1.23955z'/%3E %3Cpath fill='%23a48253' d='m512.964 250.457c1.0819 2.70827 2.6327 6.89585 3.66435 10.8059 4.8402 18.336 5.2866 39.5244 3.2144 51.7665-6.3809 37.7061-40.6642 72.7855-68.103 78.263-23.2966 4.6506-37.0666 14.7455-46.8461 25.5348-4.63642 5.1136-8.3386 10.2148-11.204 15.0774-2.84233 4.81949-4.7067 8.9516-7.22955 13.1038-0.0295 0.0147-0.0744 0.0336-0.14114 0.0561-0.17008 0.0608-0.39686 0.11397-0.65788 0.16417-0.55453 0.10394-1.25669 0.18484-1.92283 0.21201-0.67914 0.029-1.2815 0.002-1.64469-0.0874l-0.0868-0.0231c0.35492-0.54981 0.70807-1.08544 1.05472-1.65473 2.40591-3.96555 4.49705-7.8313 7.24785-12.4246 2.74252-4.57618 5.9864-9.4057 10.4008-14.3953 10.1758-11.5028 24.6378-22.6294 49.3536-27.5964 28.7722-5.7827 61.6275-41.4632 68.062-79.4835 2.0947-12.3809 2.04925-33.7606-5.8181-56.926l0.6561-2.39232z'/%3E %3Cpath stroke-width='0.45' d='m511.844 248.246c-2.38585-6.0815-4.06535-9.424-7.5201-14.9676-4.46281-7.1616-13.5278-16.8809-13.5278-16.8809s8.57715 9.75885 12.7967 16.8514c4.464 7.50415 6.50905 12.1216 9.07145 20.4685l-0.82025-5.47145z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m513.234 254.084s-0.36555-0.90945-0.55455-1.50768c-0.39445-1.23957-0.7122-3.26162-0.7122-3.26162s0.5882 1.41615 0.98035 2.34863c0.34425 0.82205 0.89465 2.45197 0.89465 2.45197l-0.60825-0.0313z'/%3E %3Cpath d='m514.378 317.002c-1.77755-1.47638-6.6508-5.9693-6.6508-8.26595 0-2.73602 2.55475-2.26535 3.1689-2.66575-0.10985-1.10847-3.85805-3.84567-2.35455-6.3124 0.9904-1.62756 3.24335-1.17107 4.0778-1.83484 0.63775-1.74449-1.83725-6.27051 0.14705-8.72481 1.17575-1.45393 2.0852-0.36791 2.6374-0.50019 0.1104-0.76477 0.0874-1.5437 0.1742-2.30906 0.15-1.35354 0.64015-2.69764 2.21395-2.77795 2.20275-0.11457 3.6998 2.71299 4.74865 4.26614 0.23385-0.13464 1.38245-0.29645 1.6252-0.41693 2.71005-1.3252 1.72735 7.0819 1.80415 8.37815 0.6313-0.0213 1.91275-0.37382 2.4732-0.046 2.90255 1.71261-2.86535 10.7179-3.4795 12.8363-0.25575 0.88051 3.04545 0.17244 0.5102 3.37146-1.47815 1.86674-3.36375 3.51909-4.99545 5.25119l-6.1004-0.24922z'/%3E %3Cpath fill='%23658d5c' d='m515.298 323.974c1.10255-2.90493 0.71045-5.7366-1.4805-7.32285-2.34625-1.69902-5.475-5.7325-5.47085-8.0687 0.007-2.76142 2.75075-1.07953 2.87775-2.38524 0.0957-0.97441-3.6065-3.89587-2.28665-6.0425 0.85985-1.39547 3.15005-1.23366 3.72935-1.93346 0.9638-1.16457-1.42615-6.3307 0.46535-8.7366 1.03995-1.32284 1.8461 0.0833 2.5394-0.40512 0.67085-0.4754-0.40515-4.42441 2.14075-4.53898 2.45255-0.10984 4.2561 4.00335 4.6488 3.87638 0.7931-0.25512 1.73565-1.08366 2.62855-0.23622 0.8699 0.82441 0.59825 7.8443 0.59825 7.8443s1.6671-0.16181 2.20095 0.16594c2.21695 1.36418-1.76515 9.3331-2.8866 11.5176-0.9567 1.86437 1.84605 2.09882 0.40925 4.01339-2.36455 3.15414-7.09015 6.939-7.8378 11.5796'/%3E %3Cpath stroke-width='0.45' d='m518.028 321.924s1.7752-11.4201 2.2671-17.446c0.4028-4.94115-0.69565-13.0742-0.69565-13.0742s0.63365 7.82365 0.2309 12.7654c-0.4919 6.02365-3.1376 20.3563-3.1376 20.3563l1.33525-2.60138z'/%3E %3Cpath d='m492.06 364.365c0.9939-2.55413-1.93347-10.0435 0.27578-11.3551 1.26261-0.75177 2.05985 0.66024 3.28938-0.55039 1.57145-1.55315-0.88701-7.40195 1.98661-9.25216 1.66949-1.07362 2.99175 0.47362 4.59925-0.98444 1.0671-0.97146 1.11435-4.88563 3.82675-5.5642 1.8024-0.45059 2.63035 0.77657 4.2272 0.99685 1.3535 0.18425 5.9486-6.2191 8.8051-4.68898 2.9923 1.60512 0.3431 5.00255-0.25925 7.27794-0.3154 1.18996 2.23225 1.02166 1.9931 3.01418-0.21735 1.82126-2.3002 3.64666-2.302 4.4126 0 0.81437 2.10535 1.36831 2.19035 2.89252 0.16775 2.96279-4.60745 3.37973-6.212 4.64056-0.8415 0.66023 1.0831 2.78858-0.1045 4.74862-1.25845 2.08229-6.61715 0.62067-7.5077 1.06712-0.7246 0.36555-0.017 3.89529-0.9201 5.14666-1.4675 2.03563-8.46496 0.12519-11.0563 0.54862-3.4689 0.5687-4.98543 1.27913-7.16695 3.87047l4.33524-6.22085z'/%3E %3Cpath fill='%23658d5c' d='m487.657 368.456s2.73426-1.41614 3.71929-2.99587c0.9691-1.55965 1.09429-2.11949 1.0565-4.58445-0.0231-1.49705-1.32697-6.64845 0.14114-7.4687 1.2065-0.67264 1.875 0.64606 3.37854-0.77422 1.83307-1.73149-0.85571-7.7238 1.75453-9.34195 1.57382-0.97559 2.99532 0.75 4.81477-0.87815 1.24135-1.11023 1.02935-4.84606 3.47365-5.4579 1.5319-0.38445 2.7508 0.80965 4.2 1.00453 1.77165 0.23859 5.80985-5.6516 8.34035-4.27323 1.10905 0.60473 1.4374 1.45335 1.23365 2.67048-0.2197 1.31161-0.9632 2.47086-1.24725 3.75177-0.36555 1.65059 1.86615 1.50532 1.6648 3.24745-0.189 1.65413-2.1514 3.24094-2.1514 4.31457 0 1.17519 1.7693 1.93878 1.88385 3.38445 0.21555 2.74016-5.51515 2.79449-5.97815 4.29744-0.45885 1.48937 0.6561 2.60611-0.42755 4.36241-1.17105 1.89449-5.20335 0.2185-6.77895 0.86161-1.31515 0.53386-0.5191 3.50493-1.31635 4.69548-2.201 3.28228-12.8504-1.32756-17.2252 4.68602l-0.53622-1.50177z'/%3E %3Cpath stroke-width='0.45' d='m487.976 368.836s11.3226-9.63605 17.5347-16.7746c4.78405-5.4933 11.2458-14.9162 11.2458-14.9162s-6.0319 9.5386-10.6252 15.072c-5.6114 6.75885-15.9916 15.8652-15.9916 15.8652l-2.16378 0.75354z'/%3E %3Cpath fill='%23a48253' stroke='none' d='m486.963 369.091l1.85611-0.5374s-0.68091 0.79902-0.95492 1.04645c-0.23269 0.20729-0.84272 0.77776-0.84272 0.77776l-0.0585-1.28681z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m486.87 384.764c-0.91772-0.65846-0.68091-3.67087 0.47716-5.67875 1.05059-1.8189 2.67875-2.70118 3.35375-2.38583 2.4809 1.16457 5.5872 5.0622 4.59625 7.18585-0.98386 2.10768-7.2124 1.74626-8.42714 0.87874z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m491.359 377.719c-0.27752 0.11743-0.53145 0.27483-0.73437 0.5-1.02107 1.13386-0.54262 3.2262 1.0625 4.67187 0.81629 0.73435 1.76736 1.15884 2.64062 1.25 0.003-0.002 0.0122 0.002 0.0156 0 0.22095-0.15174 0.37483-0.31663 0.45313-0.48437 0.34923-0.74843-0.0269-2.09591-0.9375-3.40625-0.67849-0.9763-1.6093-1.90396-2.5-2.53125z'/%3E %3Cpath d='m516.644 254.586c-2.35455-0.8126-3.9638-5.16615-2.98405-9.02775 0.97205-3.82323 10.7309-2.26594 9.6803 2.28779-0.8303 3.5941-4.69845 7.42915-6.69625 6.73995z'/%3E %3Cpath d='m523.074 246.464c-0.34725 2.29252-3.3673 2.54823-4.76515 2.26299-1.487-0.29882-4.29215-1.87854-3.9638-3.77657 0.6957-4.02815 3.94725-7.13385 5.8636-6.8309 2.0953 0.33189 3.42405 4.65295 2.86535 8.3445z'/%3E %3Cpath fill='%23a48253' d='m516.848 253.845c-1.98305-0.30709-3.53385-4.39961-2.58485-8.1325 0.8888-3.50315 9.23325-1.288 8.475 1.99489-0.82795 3.58995-3.95255 6.43639-5.89015 6.13759z'/%3E %3Cpath fill='%23d99f31' stroke-width='1.09' d='m520.134 238.734c1.62815 0.25689 3.3555 3.92598 2.7886 7.65945-0.27165 1.80355-3.08505 1.70433-4.52245 1.41378-1.54845-0.31418-4.15455-1.35-3.9071-2.77796 0.6874-3.98267 4.14215-6.53444 5.64095-6.29529z'/%3E %3Cpath fill='%23f1bf31' stroke='none' d='m519.859 239.266c-0.0739 0.006-0.1556 0.0246-0.25 0.0468 0.10145 0.65378 0.5141 1.61433 0.7031 2.71875 0.251 1.46339 0.21925 3.85023 1.2344 3.67188 0.62925-0.11081 0.8995-0.61025 0.9062-1.57813-0.0004-0.005 0-0.0104 0-0.0156-0.0844-0.96678-0.30585-1.87923-0.60935-2.64062-0.5278-1.32405-1.34795-2.13229-1.79685-2.20313-0.0485-0.008-0.11365-0.006-0.1875 0z'/%3E %3Cpath fill='none' d='m382.268 446.704c-0.77008-1.13445 0.99212-4.61634 4.68189-4.19646 1.61752 0.18484 0.83504 2.52638-1.17284 3.92835-1.40787 0.98032-2.73838 1.40315-3.50905 0.26811z'/%3E %3Cpath fill='%23a48253' d='m382.268 446.704c-0.77008-1.13445 0.35079-3.57166 4.06358-3.72934 1.33288-0.0585 1.45335 2.05926-0.55453 3.46123-1.40787 0.98031-2.73838 1.40314-3.50905 0.2681z'/%3E %3Cpath fill='none' d='m394.916 431s-0.0998-1.37894-1.69016-1.93052c-1.37067-0.47834-2.23819 0.61418-2.23819 0.61418m2.37756 3.17716s-0.0502-1.39134-1.68838-1.77756c-1.49469-0.35079-2.08465 0.92599-2.08465 0.92599'/%3E %3C/g%3E %3Cg id='motto' fill='%23000'%3E %3Cpath fill='%23fff' d='m401.704 427.164c7.68955-0.0904 13.4716-0.82146 20.0468-2.11949-1.55138 5.27305-4.65296 15.3042 7.7445 15.3042 9.02125 0 18.5976-5.4254 27.897-0.65374 20.3108 10.4168 35.6463 2.97756 48.0443-10.9695 0 0-9.16657 1.95768-18.5977 1.54901 0 0 7.06535-6.02125 7.74865-13.9488-6.1996 4.64882-12.3998 5.32795-18.6012 5.32795-6.19605 0-10.1598-3.74409-18.2764-5.0244 0.45708-2.80512 0.94724-5.6622 1.67834-9.6012 0.79666-4.30039-0.38858-7.79055-6.6443-8.5258-13.614-1.59803-26.8004 6.2551-50.892 6.63305-24.2563-0.37795-40.8821-8.2311-54.4985-6.63305-6.2557 0.73524-7.44095 4.2254-6.6437 8.5258 0.73051 3.93898 1.22067 6.79605 1.67481 9.6012-8.1136 1.28032-12.078 5.0244-18.2734 5.0244-6.20435 0-12.4016-0.67913-18.6018-5.32795 0.68327 7.92755 7.7492 13.9488 7.7492 13.9488-9.4305 0.40866-18.5982-1.54901-18.5982-1.54901 12.3998 13.947 27.734 21.3862 48.0449 10.9695 9.2994-4.77166 18.8758 0.65374 27.897 0.65374 12.3974 0 9.29585-10.0311 7.7451-15.3042 7.03585 1.38898 14.824 2.15374 23.3534 2.15374l0.003-0.0342z'/%3E %3Cpath d='m337.705 427.301c-0.90118 0.41693-1.36417-0.1624-0.34843-0.6815 0.72048-0.36968 3.83032-1.72381 6.07916-2.16555 0.0874-0.0165 0.17008 0.0437 0.18248 0.13288l0.0815 0.6c0.0124 0.0768-0.0502 0.16004-0.12637 0.17244-2.11595 0.37618-5.1124 1.59036-5.8683 1.94174zm0.519 2.946c-0.90118 0.41693-1.36594-0.16181-0.34843-0.6809 0.71812-0.36792 3.98622-1.97481 6.23681-2.41713 0.0626-0.0124 0.15235 0.0372 0.1748 0.0974l0.22618 0.59823c0.0354 0.0974-0.0165 0.18838-0.11811 0.20729-2.11772 0.37382-5.41715 1.84606-6.17125 2.19508zm32.3145 5.392c-3.86398-0.4004-8.42715-1.57146-13.272-2.24646-6.13345-0.85512-11.4668-0.5374-17.8518 2.3563-0.35138 0.16004-0.53799 0.17657-0.675 0.18071-0.11811 0.004-0.29882-0.0272-0.33602-0.20552-0.0295-0.137 0.0644-0.26515 0.1494-0.34901 0.0974-0.0969 0.24272-0.18603 0.41929-0.27756 5.9427-3.0378 12.1606-3.58347 18.4004-2.73426 4.83603 0.65788 9.4435 1.67067 13.2992 2.06989 2.1691 0.22441 4.64646-0.14114 5.462-1.44744 0.21437-0.34075 0.82914 0.39685 0.62776 0.71634-1.23366 1.97657-4.11792 2.15551-6.22325 1.93701zm-33.6075-11.0435c-0.16181 0.0626-0.31772 0.10217-0.43405 0.10393-0.0974 0-0.25276-0.0248-0.30296-0.17066-0.0461-0.13465 0.0419-0.25276 0.10748-0.32186 0.0797-0.0803 0.20197-0.16003 0.34902-0.22795 2.33799-1.07539 2.94449-1.26437 6.3685-2.17618 0.28818-0.0768 0.50256 0.0939 0.55217 0.31358 0.0473 0.21615-0.0667 0.46536-0.35493 0.53327-2.67224 0.63603-3.97441 1.05059-6.28525 1.94587zm-0.527-2.999c-0.15236 0.0602-0.29527 0.0957-0.40925 0.0915-0.10748-0.004-0.23917-0.0455-0.28819-0.17422-0.0484-0.12283 0.01-0.24331 0.0762-0.32184 0.0732-0.0856 0.17894-0.16596 0.31949-0.22855 2.35926-1.03996 3.30178-1.37657 6.5888-1.9996 0.27579-0.0537 0.5002 0.098 0.57697 0.29527 0.085 0.21733-0.0231 0.46654-0.32185 0.52323-3.20964 0.60768-4.34587 0.94193-6.54215 1.81418zm34.1425 9.0065c-2.6374-0.27225-5.6392-0.86161-8.8199-1.38071-0.33012-0.0543-0.45709-0.34075-0.41752-0.57933 0.0396-0.23918 0.24921-0.46949 0.57933-0.41575 3.16004 0.51496 6.1441 1.10256 8.762 1.37421 1.07716 0.11044 2.06811-0.0408 2.92973-0.37736 0.31122-0.12283 0.56456 0.0579 0.65197 0.28465 0.0892 0.22618 0.0265 0.52913-0.28465 0.65138-1.01279 0.39921-2.16555 0.57106-3.40098 0.44291zm-13.876 5.25c-5.2636-0.82027-11.7544 0.0685-16.7811 2.57244-0.22027 0.10984-0.41929 0.14764-0.5687 0.1624-0.12224 0.01-0.30531 0.006-0.38445-0.13524-0.0437-0.0791-0.0331-0.16181-0.008-0.22205 0.0248-0.0608 0.0667-0.11811 0.11811-0.1683 0.0998-0.10335 0.26221-0.21614 0.47599-0.32776 7.4079-3.59055 13.0642-3.35138 17.4703-2.85118 4.72323 0.53386 8.8677 1.55905 13.3878 1.8998 0.39271 0.0289 0.50019 0.38209 0.60236 0.6874 0.0933 0.28229 0.26516 0.79961-1.14862 0.64784-4.47402-0.47363-8.5689-1.54843-13.1634-2.26536zm13.833-2.9805c-5.00195-0.5191-11.6398-2.22579-18.0042-2.50807-0.32775-0.0148-0.53504-0.23504-0.53681-0.48602-0.002-0.26162 0.21083-0.47126 0.54508-0.4565 6.3874 0.28406 13.102 1.80591 18.1228 2.325 1.85374 0.19311 3.88052-0.17422 4.85434-1.04645 0.29232-0.26339 1.04645 0.7246 0.76653 0.9744-1.29212 1.15808-3.74173 1.40552-5.74785 1.19764zm-31.7325 0.1075c-0.90118 0.41752-1.36417-0.16181-0.34901-0.6809 0.82205-0.42166 5.34215-2.55768 7.75335-2.71772 0.33189-0.0231 0.5746 0.18071 0.64547 0.41516 0.0774 0.25984-0.0685 0.53149-0.42579 0.5563-2.16732 0.1435-6.75825 2.02618-7.624 2.42716z'/%3E %3Cpath d='m462.392 427.301c0.90118 0.41693 1.36594-0.1624 0.34901-0.6815-0.72106-0.36968-3.82913-1.72381-6.07795-2.16555-0.0892-0.0165-0.17243 0.0437-0.18425 0.13288l-0.0815 0.6c-0.01 0.0768 0.0502 0.16004 0.12637 0.17244 2.11595 0.37618 5.1124 1.59036 5.8683 1.94174zm-0.5185 2.946c0.90118 0.41693 1.36417-0.16181 0.34901-0.6809-0.7187-0.36792-3.98917-1.97481-6.2374-2.41713-0.062-0.0124-0.15177 0.0372-0.1748 0.0974l-0.22559 0.59823c-0.0378 0.0974 0.0142 0.18838 0.11811 0.20729 2.11595 0.37382 5.41715 1.84606 6.17065 2.19508zm-32.3145 5.392c3.86339-0.4004 8.42715-1.57146 13.272-2.24646 6.1311-0.85512 11.4674-0.5374 17.8518 2.3563 0.35079 0.16004 0.5374 0.17657 0.675 0.18071 0.11811 0.004 0.29882-0.0272 0.33661-0.20552 0.029-0.137-0.065-0.26515-0.14941-0.34901-0.098-0.0969-0.2433-0.18603-0.42224-0.27756-5.94035-3.0378-12.1606-3.58347-18.398-2.73426-4.8378 0.65788-9.4435 1.67067-13.2992 2.06989-2.1691 0.22441-4.64646-0.14114-5.462-1.44744-0.21437-0.34075-0.82913 0.39685-0.62775 0.71634 1.23366 1.97657 4.11791 2.15551 6.22325 1.93701zm33.608-11.0435c0.16181 0.0626 0.31771 0.10217 0.43405 0.10393 0.0974 0 0.25276-0.0248 0.30296-0.17066 0.046-0.13465-0.0414-0.25276-0.10748-0.32186-0.0791-0.0803-0.20138-0.16003-0.34902-0.22795-2.338-1.07539-2.9439-1.26437-6.3685-2.17618-0.29055-0.0768-0.50433 0.0939-0.55217 0.31358-0.0472 0.21615 0.0667 0.46536 0.35493 0.53327 2.67224 0.63603 3.97382 1.05059 6.28525 1.94587zm0.5265-2.999c0.15177 0.0602 0.29527 0.0957 0.40925 0.0915 0.10807-0.004 0.23917-0.0455 0.28819-0.17422 0.0484-0.12283-0.01-0.24331-0.0762-0.32184-0.0709-0.0856-0.18071-0.16596-0.31949-0.22855-2.35926-1.03996-3.30178-1.37657-6.5888-1.9996-0.27579-0.0537-0.5002 0.098-0.57697 0.29527-0.085 0.21733 0.0224 0.46654 0.32008 0.52323 3.21378 0.60768 4.34941 0.94193 6.5439 1.81418zm-34.1425 9.0065c2.6374-0.27225 5.6392-0.86161 8.8199-1.38071 0.33248-0.0543 0.45531-0.34075 0.41752-0.57933-0.0396-0.23918-0.24921-0.46949-0.57933-0.41575-3.16004 0.51496-6.1435 1.10256-8.762 1.37421-1.07776 0.11044-2.06811-0.0408-2.92973-0.37736-0.31122-0.12283-0.56456 0.0579-0.65138 0.28465-0.0898 0.22618-0.0271 0.52913 0.28406 0.65138 1.01279 0.39921 2.16555 0.57106 3.40098 0.44291zm13.876 5.25c5.2636-0.82027 11.7561 0.0685 16.7811 2.57244 0.22027 0.10984 0.41929 0.14764 0.5687 0.1624 0.12224 0.01 0.30531 0.006 0.38445-0.13524 0.0431-0.0791 0.0331-0.16181 0.008-0.22205-0.0248-0.0608-0.0667-0.11811-0.11634-0.1683-0.10157-0.10335-0.26398-0.21614-0.47776-0.32776-7.40845-3.59055-13.0642-3.35138-17.4703-2.85118-4.72323 0.53386-8.8677 1.55905-13.3854 1.8998-0.39448 0.0289-0.50256 0.38209-0.60472 0.6874-0.0933 0.28229-0.26516 0.79961 1.14862 0.64784 4.47402-0.47363 8.5689-1.54843 13.1634-2.26536zm-13.8335-2.9805c5.00255-0.5191 11.6404-2.22579 18.0042-2.50807 0.32775-0.0148 0.53563-0.23504 0.5374-0.48602 0.003-0.26162-0.21319-0.47126-0.54567-0.4565-6.38445 0.28406-13.102 1.80591-18.1222 2.325-1.85374 0.19311-3.88052-0.17422-4.85434-1.04645-0.29232-0.26339-1.04409 0.7246-0.76594 0.9744 1.29153 1.15808 3.74173 1.40552 5.74665 1.19764zm31.733 0.1075c0.90118 0.41752 1.36594-0.16181 0.34901-0.6809-0.82441-0.42166-5.3427-2.55768-7.7551-2.71772-0.32834-0.0231-0.57342 0.18071-0.6437 0.41516-0.0774 0.25984 0.0679 0.53149 0.4252 0.5563 2.16792 0.1435 6.75885 2.02618 7.6246 2.42716z'/%3E %3Cg stroke='%23000' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='0.933' d='m400.04 427.329c-10.3441 0-17.1048-1.5815-26.3462-3.25335-21.515-3.89292-26.1928-0.93425-26.1928 2.78858 0 1.19351 1.10492 1.54666 1.90157 1.1876 0.40749-0.18484 0.74351-0.86988 0.74351-0.86988-0.75768-0.008-1.25433-0.30945-1.09429-1.24783 0.45945-2.71772 6.04665-3.95552 24.642-0.92776 9.2705 1.50709 16.0104 2.788 26.3546 2.788l-0.008-0.46536zm0.0165 0c10.3447 0 17.1053-1.5815 26.3468-3.25335 21.515-3.89292 26.1928-0.93425 26.1928 2.78858 0 1.19351-1.10492 1.54666-1.90157 1.1876-0.40749-0.18484-0.74351-0.86988-0.74351-0.86988 0.75768-0.008 1.25433-0.30945 1.09429-1.24783-0.45945-2.71772-6.04665-3.95552-24.642-0.92776-9.2705 1.50709-16.0104 2.788-26.3552 2.788l0.008-0.46536z'/%3E %3Cpath d='m342.374 416.79c-3.40866 0.54626-6.53565 1.71083-9.7311 2.96516-8.70825 3.4193-18.6992 2.89607-26.4378-2.60787 0.53976 3.91122 2.25472 7.31695 4.7628 10.3046 0.61299 0.72697 2.49212 2.5872 2.49212 2.5872 0.313 0.3254 0.25689 0.53327-0.1872 0.54567-5.92795 0.25335-11.3114 0.17658-17.1402-0.91122 13.7616 15.134 27.5858 18.9006 46.4304 9.7441 9.90235-4.80886 18.15 0.62067 28.0394 0.62067 10.4894 0 9.5014-6.86635 7.19235-14.6238l1.25846 0.13583c1.6878 4.76634 4.33937 16.523-8.4508 15.5722-9.85865-0.73111-17.7508-5.75435-27.6838-1.01575-15.2941 7.29624-26.3462 7.19234-39.6538-2.68229-2.71358-2.0126-7.08605-5.6309-8.951-8.39055-0.45236-0.67027 0.004-1.07126 0.68386-0.86161 5.0516 1.56791 12.7004 1.57205 16.5939 1.46988-3.15236-3.17067-6.69865-9.05495-6.5451-13.2762 0.0206-0.54626 0.27992-0.64961 0.74351-0.4128 7.20885 3.73524 9.9142 5.2364 18.3212 5.2364 4.95 0 15.0638-5.59134 18.0744-5.0126l0.18838 0.61299z'/%3E %3Cpath stroke-width='0.933' d='m457.723 416.79c3.40748 0.54626 6.53445 1.71083 9.7317 2.96516 8.70825 3.4193 18.6998 2.89607 26.4378-2.60787-0.53977 3.91122-2.25709 7.31695-4.76516 10.3046-0.61063 0.72697-2.48918 2.5872-2.48918 2.5872-0.31358 0.3254-0.25806 0.53327 0.18662 0.54567 5.9256 0.25335 11.3114 0.17658 17.1402-0.91122-13.764 15.134-27.5859 18.9006-46.4327 9.7441-9.9-4.80886-18.1476 0.62067-28.0364 0.62067-10.49 0-9.50195-6.86635-7.1929-14.6238l-1.25611 0.13583c-1.69015 4.76634-4.34173 16.523 8.44901 15.5722 9.85809-0.73111 17.7502-5.75435 27.6833-1.01575 15.2941 7.29624 26.3462 7.19234 39.6538-2.68229 2.71359-2.0126 7.08605-5.6309 8.9504-8.39055 0.45535-0.67027-0.006-1.07126-0.68265-0.86161-5.05215 1.56791-12.701 1.57205-16.5939 1.46988 3.14941-3.17067 6.69805-9.05495 6.5445-13.2762-0.0206-0.54626-0.28051-0.64961-0.7435-0.4128-7.20885 3.73524-9.9142 5.2364-18.3212 5.2364-4.95237 0-15.0638-5.59134-18.0744-5.0126l-0.18898 0.61299z'/%3E %3Cpath d='m399.473 405.15c-11.8264 0.0856-21.8008-2.06752-30.1246-3.94489-6.9-1.55669-14.935-3.33661-22.0092-2.39586-5.15315 0.68976-7.2567 2.96516-6.3762 8.16025 1.09607 6.4571 2.05926 12.9685 3.23268 19.405 0.67677 3.71457 2.65571 4.21299 6.14645 3.59587 5.0262-0.88878 21.147-4.49292 24.7683 0.0856 3.4754 4.39134 0.0886 7.5579-4.74921 7.6388-0.67677 0.01-0.45827-0.46122-0.23032-0.46122 4.62815 0 7.88565-2.67815 4.89567-6.78485-3.14941-4.32756-18.2315-1.15512-24.3732 0.27992-3.9059 0.91181-6.50315 0.40925-7.22185-4.38544-0.99035-6.60885-1.59862-11.1496-3.6939-19.6955-3.54213-14.4455 22.2378-7.75335 29.6646-6.02775 10.1244 2.3504 18.577 3.86162 30.584 4.22126 12.0307-0.35964 20.4827-1.87086 30.6071-4.22126 7.425-1.72559 33.2067-8.4177 29.667 6.02775-2.09705 8.54585-2.7059 13.0866-3.69626 19.6955-0.71811 4.79469-3.31594 5.29725-7.22125 4.38544-6.14235-1.43504-21.2238-4.60749-24.3738-0.27992-2.98996 4.10669 0.26752 6.78485 4.89626 6.78485 0.22796 0 0.44587 0.47126-0.2309 0.46122-4.83544-0.0809-8.22461-3.24745-4.74863-7.6388 3.62067-4.57855 19.7416-0.97441 24.7683-0.0856 3.49016 0.61712 5.4691 0.1187 6.14585-3.59587 1.17107-6.4364 2.13662-12.9478 3.23327-19.405 0.88051-5.1951-1.22303-7.4705-6.37915-8.16025-7.07365-0.94075-15.1069 0.83917-22.0063 2.39586-8.3238 1.87737-18.2988 4.03052-30.1258 3.94489h-1.04882z'/%3E %3C/g%3E %3Cg id='text'%3E %3Cpath d='m361.531 417.226c-1.61929-0.13878-4.2254-0.28406-4.2254-0.28406l-0.94488-12.8817 3.13111 0.37323 0.65019 10.0518c0.31772 0.0189 1.72323 0.11221 2.65985 0.21437 1.06477 0.11575 2.78445 0.38622 2.78445 0.38622l0.19666 2.58721s-2.62559-0.30827-4.25198-0.44705z'/%3E %3Cpath d='m368.29 417.947l-0.7055-12.4225 3.154 0.484 0.7055 12.422z'/%3E %3Cpath d='m377.81 412.179l1.07126 0.18307c1.59626 0.27224 1.71909-0.27815 1.70846-0.94902-0.0165-0.81023-0.39271-1.30807-2.0061-1.58386l-0.81969-0.13996 0.046 2.48977zm0.11397 4.9376l1.49233 0.25512c1.73858 0.29527 2.16142-0.0265 2.14488-0.89823-0.0189-0.99922-0.62067-1.59922-2.49744-1.9187l-1.19232-0.20375 0.0526 2.76556zm1.83366 2.76555l-4.99843-0.85334-0.22618-12.271 4.49528 0.76653c3.08563 0.525 4.75099 1.87855 4.7941 4.20886 0.0165 0.97559-0.53386 1.62284-1.13563 1.97185 0.86811 0.48425 2.10118 1.59272 2.13248 3.21851 0.0414 2.28012-1.34351 3.59173-5.0616 2.95866z'/%3E %3Cpath d='m391.53 421.566c-1.67126-0.15767-4.33937-0.52972-4.33937-0.52972l-0.12224-6.1825-0.12106-6.2067 7.12265 0.73937 0.0224 1.22066 0.0248 1.23958-3.98268-0.41339 0.0502 2.54823 4.18583 0.43347 0.046 2.30491-4.18583-0.43346 0.049 2.62027c0.3183 0.049 1.75039 0.26929 2.7124 0.35492 1.08189 0.0974 2.8565 0.13465 2.8565 0.13465l0.0478 2.4626s-2.69882-0.13465-4.36654-0.29292z'/%3E %3Cpath d='m401.918 415.228c1.663-0.029 2.39173-0.73701 2.37106-1.8691-0.0213-1.18937-0.53622-1.68779-2.04331-1.66063l-1.39488 0.023 0.0614 3.52323 1.00571-0.0165zm6.962 6.4175c-2.4567-0.0809-3.77894-1.31221-5.0746-2.76556l-1.37067-1.53602c-0.19488 0.0165-0.40512 0.0201-0.61654 0.0242l-0.81201 0.0147 0.0732 4.32934-3.07973 0.0514-0.21378-12.3868 4.7817-0.0827c2.74488-0.0485 4.76929 1.18287 4.8189 3.93839 0.0231 1.34291-0.59351 2.53523-1.84961 3.30945l1.18937 1.2437c0.66851 0.6933 1.41614 1.15453 2.72658 1.47047l-0.57284 2.38937z'/%3E %3Cpath d='m408.991 411.684l-0.015-2.45 10.9515-1.5115 0.0145 2.452-3.904 0.538 0.0585 9.887-3.1435 0.4325-0.0585-9.886z'/%3E %3Cpath d='m426.623 409.195c-0.37559 1.34586-0.77422 2.68464-1.17933 4.02342 0.85925-0.0868 1.76043-0.24035 2.58661-0.48779-0.37145-1.19587-0.73642-2.38937-1.07775-3.59764l-0.32953 0.062zm3.35079 8.99645l-1.21654-3.32422c-0.64547 0.23681-1.34114 0.37618-2.04094 0.4819-0.70571 0.1057-1.41614 0.17834-2.09055 0.28228l-1.32933 3.81437-3.18485 0.59587 3.84981-10.6246-1.34823 0.25334-0.0248-2.44783c2.84705-0.46536 5.60845-0.98445 8.364-1.57028l0.11161 2.43189-1.35945 0.25512 3.54804 9.2374-3.27874 0.61477z'/%3E %3Cpath d='m438.3 417.4c-2.02264 0.0355-3.09213-0.31359-4.01339-0.80551l0.86161-2.29607c1.14744 0.38386 1.81595 0.5439 3.15768 0.52087 1.47638-0.0272 2.19863-0.49016 2.20926-1.16044 0.008-0.44882-0.33425-0.7624-0.91772-1.04645-0.58405-0.28465-1.3624-0.5191-2.14134-0.82264-1.56083-0.60827-3.16594-1.50295-3.12874-3.63957 0.0437-2.42539 2.75138-3.6626 4.9252-3.7004 1.95414-0.0349 3.0502 0.36555 4.00099 0.76654l-0.79075 2.22579c-0.96142-0.26162-1.92697-0.48603-3.1624-0.463-1.22067 0.0206-1.93288 0.65375-1.94115 1.1067-0.007 0.35138 0.33603 0.6313 0.93838 0.91535 0.59174 0.27875 1.38485 0.53799 2.17559 0.86988 1.58681 0.66319 3.21674 1.62816 3.18131 3.63426-0.0502 2.75905-2.81989 3.85158-5.35456 3.89468z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%230072C6' width='450' height='300'/%3E %3Crect fill='%23FFF' width='450' height='200'/%3E %3Crect fill='%231EB53A' width='450' height='100'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 9 6'%3E %3Ctitle%3EFlag of Slovakia%3C/title%3E %3Crect width='9' height='6' fill='%23ee1c25'/%3E %3Crect width='9' height='4' fill='%230b4ea2'/%3E %3Crect width='9' height='2' fill='%23fff'/%3E %3Cg%3E %3Cpath fill='%23fff' d='M3.16255,4.635c-0.53781-0.25905-1.3071-0.77323-1.3071-1.79033,0-1.01711,0.04863-1.47967,0.04863-1.47967h1.25847,1.2585s0.04864,0.46256,0.04864,1.47967c0,1.0171-0.76929,1.53128-1.30714,1.79033z'/%3E %3Cpath fill='%23ee1c25' d='M3.16255,4.5c-0.4934-0.23766-1.19917-0.70938-1.19917-1.64251,0-0.933128,0.044612-1.35749,0.044612-1.35749h1.15456,1.15459s0.044626,0.424365,0.044626,1.35749c0,0.933128-0.705776,1.40485-1.19921,1.64251z'/%3E %3Cpath fill='%23fff' d='m3.26808,2.61284c0.133599,0.00216,0.394255,0.00739,0.626352-0.070273,0,0-0.00613,0.083055-0.00613,0.179805,0,0.096773,0.00613,0.179822,0.00613,0.179822-0.21289-0.07125-0.4758-0.07273-0.62635-0.07082v0.515391h-0.211033v-0.515391c-0.150545-0.00191-0.41345-0.0004252-0.626352,0.070815,0,0,0.00613-0.083049,0.00613-0.179822,0-0.09675-0.00613-0.179805-0.00613-0.179805,0.2321,0.077665,0.492753,0.072432,0.626352,0.070273v-0.323676c-0.121766-0.00108-0.297234,0.00473-0.49563,0.071126,0,0,0.00613-0.083055,0.00613-0.179822,0-0.096756-0.00613-0.179811-0.00613-0.179811,0.198103,0.066283,0.373356,0.072192,0.495088,0.071137-0.00626-0.20498-0.06597-0.46332-0.06597-0.46332s0.12289,0.00959,0.172016,0.00959c0.049178,0,0.172031-0.00959,0.172031-0.00959s-0.059695,0.258346-0.065964,0.463301c0.121741,0.00106,0.296989-0.00485,0.495086-0.071137,0,0-0.00613,0.083055-0.00613,0.179811,0,0.096767,0.00613,0.179822,0.00613,0.179822-0.198388-0.066392-0.373863-0.072207-0.495627-0.071126v0.323676z'/%3E %3Cpath fill='%230b4ea2' d='m3.1625,3.29094c-0.24847,0-0.381562,0.344688-0.381562,0.344688s-0.073834-0.163438-0.276562-0.163438c-0.137161,0-0.238243,0.12201-0.3025,0.235,0.24954,0.39705,0.64768,0.64207,0.96062,0.79281,0.31299-0.15075,0.71139-0.39571,0.96094-0.79281-0.064256-0.11299-0.165339-0.235-0.3025-0.235-0.202734,0-0.276875,0.163438-0.276875,0.163438s-0.133073-0.344688-0.381562-0.344688z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='1100' height='800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' height='600' width='1200' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 12 6'%3E %3Ctitle%3EFlag of Slovenia%3C/title%3E %3Crect width='12' fill='%23ed1c24' height='6'/%3E %3Crect width='12' fill='%23005da4' height='4'/%3E %3Crect width='12' fill='%23fff' height='2'/%3E %3Cg transform='translate(2.2238 1) scale(.12937)'%3E %3Csvg width='12' viewBox='-120 -190.223125 240 309.188274' height='15.459'%3E%3C!-- R0 = 15*sqrt(349) %7E 280.223125 Py= 15*sqrt(285)-90 %7E 163.229145242 --%3E %3Cpath d='m110.26-19.478l9.74-143.75a280.22 280.22 0 0 0 -240 0l9.74 143.75a155.61 155.61 0 0 0 110.26 138.45 155.61 155.61 0 0 0 110.26 -138.45' fill='%23005da4'/%3E %3C!-- 30*sqrt(81/4+1) , 30*sqrt(19)-30 --%3E %3Cpath d='m-90 0a138.29 138.29 0 0 0 90 100.77 138.29 138.29 0 0 0 90 -100.77l-45-60-18 24-27-54-27 54-18-24-45 60' fill='%23fff'/%3E %3Cg id='wave' fill='%23005da4' transform='scale(5) translate(0 5.1962)'%3E %3Cpath d='m-17.196-2.1962a6 6 0 0 0 8.1962 2.1962 6 6 0 0 1 6 0 6 6 0 0 0 6 0 6 6 0 0 1 6 0 6 6 0 0 0 8.1962 -2.1962v1.732a6 6 0 0 1 -8.1962 2.1962 6 6 0 0 0 -6 0 6 6 0 0 1 -6 0 6 6 0 0 0 -6 0 6 6 0 0 1 -8.1962 -2.1962z'/%3E %3C/g%3E %3Cuse xlink:href='%23wave' transform='translate(0 17.321)'/%3E %3Cg id='s' transform='translate(0,-120) scale(2.25)'%3E %3Cpath stroke-width='.2' d='m0-5l1 3.2679 3.3301-0.7679-2.3301 2.5 2.3301 2.5-3.3301-0.7679-1 3.2679-1-3.2679-3.3301 0.7679 2.3301-2.5-2.3301-2.5 3.3301 0.7679z' fill='%23fd0'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='translate(-33.75,-45)'/%3E %3Cuse xlink:href='%23s' transform='translate(33.75,-45)'/%3E %3Cpath d='m-111.58-167.05l9.96 146.99a146.95 146.95 0 0 0 101.62 129.95 146.95 146.95 0 0 0 101.62 -129.95l9.96-146.99a280.22 280.22 0 0 0 8.42 3.82l-9.74 143.75a155.61 155.61 0 0 1 -110.26 138.45 155.61 155.61 0 0 1 -110.26 -138.45l-9.74-143.75a280.22 280.22 0 0 0 8.42 -3.82' fill='%23ed1c24'/%3E %3C/svg%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30' width='1200' height='600'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='4320' height='2880'%3E %3Crect fill='%23ed2939' width='4320' height='1440'/%3E %3Crect fill='%23fff' y='1440' width='4320' height='1440'/%3E %3Cpath fill='%23fff' d='M 1481.678,720 A 541.5,541.5 0 1 1 398.67798,720 A 541.5,541.5 0 1 1 1481.678,720 z'/%3E %3Cpath fill='%23ed2939' d='M 1651.835,720 A 511.73499,511.73499 0 1 1 628.36499,720 A 511.73499,511.73499 0 1 1 1651.835,720 z'/%3E %3Cpath fill='%23fff' id='star' d='M 1007.1951,733.06439 L 933.63466,676.63425 L 860.09279,733.09117 L 888.40587,642.09687 L 814.61147,586.0053 L 905.6704,586.1981 L 933.6049,495.07467 L 961.56934,586.18798 L 1052.6282,585.96246 L 978.8522,642.0808 L 1007.1951,733.06439 z'/%3E %3Cuse xlink:href='%23star' transform='translate(577.18853,0)'/%3E %3Cuse xlink:href='%23star' transform='translate(288.88853,-214.21117)'/%3E %3Cuse xlink:href='%23star' transform='translate(107.99953,342.74883)'/%3E %3Cuse xlink:href='%23star' transform='translate(469.18853,342.74883)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1600' height='1000' viewBox='0 0 16 10'%3E %3Crect width='16' height='10' fill='%23006aa7'/%3E %3Crect width='2' height='10' x='5' fill='%23fecc00'/%3E %3Crect width='16' height='2' y='4' fill='%23fecc00'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='300' viewBox='0 0 12 6'%3E %3Crect width='12' height='6'/%3E %3Crect fill='%23FFF' width='12' height='4'/%3E %3Crect fill='%23D21034' width='12' height='2'/%3E %3Cpolygon fill='%23007229' points='0,0 4,3 0,6'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='450'%3E %3Cpath d='M0,450H900V0H0z' fill='%23d62828'/%3E %3Cpath d='M0,450V0H600z' fill='%23fcd856'/%3E %3Cpath d='M0,450V0H300z' fill='%23003f87'/%3E %3Cpath d='M0,450H900V150z' fill='%23fff'/%3E %3Cpath d='M0,450H900V300z' fill='%23007a3d'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='800' height='400'%3E %3Cpath d='M0,400V0H800z' fill='%230051ba'/%3E %3Cpath d='M0,400H800V0z' fill='%23215b33'/%3E %3Cpath d='M0,400 800,0' stroke='%23fcd116' stroke-width='36'/%3E %3Cg transform='translate(140,120)'%3E %3Cg id='s' fill='%23fff'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath id='o' d='M0,-40V0H20z' transform='rotate(18,0,-40)'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/g%3E %3Cg id='s2' transform='rotate(40.6)'%3E %3Cuse id='s1' xlink:href='%23s' x='-104' transform='rotate(-40.6,-104,0)'/%3E %3Cuse xlink:href='%23s1' x='208'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg width='750' xmlns='http://www.w3.org/2000/svg' version='1.0' height='500'%3E %3Crect width='750' fill='%23006c35' height='500'/%3E %3Cpath fill-rule='evenodd' d='m323.28 118.09c-0.3878-0.0115-0.96797 0.20495-1.7812 0.6875-1.8284 1.2256-5.4516 5.0006-5.5625 9.3438-0.11087 2.4503-0.57338 2.4407 1.0312 4 1.1591 1.6712 2.3168 1.5069 4.6562 0.28125 1.3436-0.98979 1.7974-1.6212 2.25-3.2812 0.55738-2.7839-2.9295 1.3172-3.375-1.7812-0.77915-2.8766 1.4468-4.0598 3.5625-6.8438 0.0485-1.3111 0.0719-2.381-0.78125-2.4062zm34.062 0.1875c-0.65345 0.088-1.4528 0.92515-2.5625 2.9375-0.79526 2.1076-4.2255 5.2972-1.75 11.875 2.0249 4.1708 2.8567 10.949 1.9375 18.5-1.403 2.1459-1.723 2.8854-3.5625 5.0312-2.5843 2.7789-5.3833 2.0684-7.5312 1.0312-2.0068-1.3526-3.5838-2.0469-4.5-6.3438 0.16531-6.8489 0.56436-18.059-0.6875-20.438-1.8455-3.684-4.8873-2.3628-6.1875-1.25-6.2472 5.712-9.3329 15.357-11.219 23.031-1.7326 5.593-3.5788 3.9755-4.875 1.7188-3.1558-2.9573-3.3775-26.083-7.1875-22.281-6.1021 17.44 3.5018 36.545 10.156 34.688 4.8008 1.9876 7.847-7.1505 9.8125-17.156 1.3446-2.8081 2.3721-3.1309 3.0625-1.6875-0.17741 13.306 0.95406 16.274 4.375 20.312 7.6311 5.8874 13.943 0.7459 14.438 0.25 0.49491-0.4949 5.9375-5.9375 5.9375-5.9375 1.3224-1.391 3.0698-1.4756 4.9375-0.25 1.8153 1.65 1.5822 4.4922 5.4688 6.4688 3.2708 1.3083 10.255 0.31819 11.875-2.5 2.1802-3.7364 2.7088-5.0203 3.7188-6.4375 1.5562-2.0713 4.2188-1.1542 4.2188-0.5-0.24796 1.1551-1.8124 2.2946-0.75 4.375 1.8506 1.3879 2.2804 0.49593 3.375 0.1875 3.8715-1.8506 6.7812-10.25 6.7812-10.25 0.17134-3.1327-1.611-2.8951-2.75-2.25-1.4857 0.90815-1.5768 1.2168-3.0625 2.125-1.8929 0.28122-5.5597 1.5299-7.375-1.2812-1.8536-3.3796-1.8641-8.0912-3.2812-11.5 0-0.24795-2.4765-5.3599-0.1875-5.6875 1.1551 0.21469 3.6392 0.85659 4.0312-1.2188 1.2116-2.0229-2.6142-7.7615-5.2188-10.656-2.2608-2.4815-5.3824-2.784-8.4062-0.25-2.1177 1.9483-1.8035 4.1242-2.2188 6.1875-0.53925 2.3697-0.43618 5.3048 1.9688 8.4375 2.1136 4.1678 5.9535 9.5151 4.6875 17.062 0 0-2.2313 3.5917-6.1562 3.125-1.6359-0.35681-4.3016-1.0648-5.7188-11.531-1.0724-7.9224 0.26872-19.022-3.0938-24.219-0.75911-1.9611-1.4109-3.8654-2.5-3.7188zm-10.78 0.84c-1.0171 0.0888-2.1438 1.2735-3.0625 3.5625-0.78821 1.7407-1.751 10.844-1.5938 10.844-0.62896 2.7093 2.8308 3.8574 4.4062 0.375 2.3616-6.3843 2.373-9.1042 2.5312-11.812-0.3679-2.0627-1.2641-3.0576-2.2812-2.9688zm39.812 0.71875c-1.0447 0.0947-1.8768 0.70635-2.1875 2.25-0.41629 3.6296-0.20355 5.6032 0.40625 8.625 0.46769 2.0149 3.4004 5.3884 4.8438 7.3438 6.896 9.2694 13.531 18.583 19.938 28.219 1.0072 7.155 1.7452 14.154 2.2188 21.125 1.0382 15.284 1.3537 34.31 0.40625 50.406 2.8636 0.1129 7.4518-4.6239 9.0625-11.562 1.0472-9.5976-0.37299-29.18-0.46875-34.844-0.0675-2.3514-0.21224-5.157-0.375-8.0938 7.4527 12.179 14.683 25.082 21.781 39.25 2.5874-1.2297 2.0139-15.798 0.5-17.844-5.6807-12.227-13.529-24.296-16.031-28.938-0.90311-1.6763-3.9793-6.3547-7.625-11.75-0.67122-7.6985-1.4006-14.219-1.875-16.188-1.1722-8.1381 3.3447 0.91775 2.7188-3.8125-1.4656-8.127-5.9513-13.65-11.25-21.094-1.7085-2.4211-1.6747-2.9149-4.3125 0.59375-1.5766 3.5768-1.5553 6.5526-1.0938 9.3438-0.69381-1.0083-1.5514-2.2039-2.7812-3.6875-4.576-3.9259-4.8583-4.1405-8.6562-7.3438-1.1976-0.84982-3.4776-2.1579-5.2188-2zm118 1.2188c-0.50876-0.0791-1.0631 0.17099-1.6875 1.0938-1.1934 1.0462-2.4768 2.9408-2.4375 5.375 0.29027 4.2888 1.0535 8.68 1.3438 12.969 0.10229 0.57392 0.2102 1.1448 0.3125 1.7188-0.46081-0.58803-0.86314-1.0469-1.0938-1.2812-8.3598-8.7822 3.841-1.4353-1.5938-8.2188-4.5962-5.0467-5.941-6.6526-9.875-9.6875-1.9726-1.275-3.1644-3.7112-3.8125 0.4375-0.25802 3.6447-0.52618 7.8653-0.28125 10.938-0.0141 1.7074 1.7542 4.9216 3.2812 6.8125 5.5768 6.8517 11.273 14.142 17 21.75 1.2052 15.516 1.5266 29.739 2.75 45.281-0.17335 6.6473-2.218 15.476-4.1562 16.312 0 0-2.9599 1.7004-4.9375-0.1875-1.4383-0.57755-7.1875-9.5938-7.1875-9.5938-2.9432-2.6982-4.9055-1.9272-7 0-5.7755 5.5769-8.3876 16.023-12.312 23.219-1.012 1.6056-3.8623 2.9724-7.0312-0.125-8.0484-10.996-3.3419-26.648-4.3438-22.625-7.1685 8.0786-3.9938 21.465-2.375 24.344 2.3636 4.7282 4.2758 7.7553 8.875 10.094 4.189 3.0833 7.4508 1.159 9.25-1 4.2152-4.3684 4.2714-15.54 6.25-17.75 1.3879-4.06 4.8662-3.3617 6.5625-1.5625 1.644 2.3636 3.585 3.9014 6 5.1875 3.9319 3.4683 8.6246 4.0984 13.25 0.9375 3.1609-1.773 5.2119-4.0772 7.0625-8.625 1.9856-5.3106 1.0038-33.142 0.5625-48.625 2.9696 4.1831 5.9006 8.4568 8.8125 12.781 1.2782 13.591 1.8582 26.976 1.4375 39.812-0.30139 2.5521 8.9062-7.6196 8.8438-12.438-0.0415-4.2158 0.008-8.0366 0-11.594 4.466 7.1306 8.789 14.38 12.875 21.719 2.532-1.3416 1.6641-15.678 0.0625-17.656-4.2781-7.1786-9.7567-14.936-14-20.938-0.83864-7.5749-1.9805-16.512-2.5-19.25-0.8094-4.2696-1.6201-10.683-2.8438-15.75-0.33567-1.9786-1.3488-8.2985-1.0312-8.9062 0.49893-1.4141 2.3842 0.0452 3.3125-1.5938 1.3899-1.5149-4.8179-17.598-7.9688-22.188-1.1329-2.0572-3.1818-1.3453-5.7188 2-2.3526 2.2013-1.4918 7.2234-0.59375 12 2.3327 12.174 4.4149 24.572 6.0625 36.938-3.0501-4.5343-6.7725-10.021-10.438-15.312-0.0985-0.51026-0.46875-2.3803-0.46875-2.4062-0.00002-0.21873-0.50509-9.959-0.9375-12.281-0.0756-0.94243-0.30028-1.2137 0.6875-1.0938 1.0473 0.88094 1.1896 0.92846 1.8438 1.2188 1.0573 0.19352 1.9818-1.594 1.3438-3.25-3.2708-6.0325-6.5418-12.092-9.8125-18.125-0.3936-0.38756-0.83499-0.79588-1.3438-0.875zm-304.53 0.3125c-1.8123-0.0518-3.8118 1.0716-3.0312 3.25-0.45458 1.1873 3.5475 5.2009 4.25 7.4062 0.62996 1.5704-0.62483 6.6271 0.6875 7.0938 1.2065 0.52312 2.868-3.5005 3.5-7.2188 0.34975-2.037 0.0851-9.0082-4.6562-10.438-0.24291-0.0549-0.4911-0.0863-0.75-0.0937zm346.91 0.04c-0.41312 0.041-0.91624 0.70862-1.6875 2.3438-1.8546 3.0379-2.4928 8.4774-1.75 13.281 4.4652 30.203 7.7834 59.449 8.4688 86.219-0.38402 2.541-0.49612 3.8926-1.6875 7.0938-2.6358 3.3786-5.5427 7.6142-8.2812 9.6562-2.7376 2.0411-8.5638 3.9871-10.469 5.5-6.0436 3.4935-6.074 7.5111-1.1875 7.6562 8.4213-0.97769 18.386-1.6686 25.25-12.031 1.8365-2.9038 3.999-10.776 4.0938-15.594 0.64204-28.247-0.36143-55.866-4.5938-76.281-0.27113-1.9887-1.1492-6.5596-0.8125-7.1562 0.54529-1.398 3.3005 0.13992 4.2812-1.4688 1.4394-1.4696-7.1254-12.436-10.125-17.125-0.59928-1.1776-0.96885-2.1465-1.5-2.0938zm-88.312 0.46875c-0.34774 0.06-0.86114 0.58925-1.8125 1.8438-2.3525 7.6916-3.1793 13.973-2.2812 18.75 6.0426 31.534 12.234 60.263 11.25 90.281 2.8656 0.0191 6.1786-6.5553 7.5938-13.062 0.7751-8.9636-0.51716-14.419-0.75-19.688-0.23181-5.2685-5.9639-48.014-7.125-52-1.401-7.5374 5.5735-0.99148 4.8125-5.375-2.411-5.5265-8.4287-13.574-10.312-18.375-0.70808-1.2858-0.79543-2.475-1.375-2.375zm-215.03 0.59375c-0.7426 0.12864-1.4592 0.74056-1.7188 1.75-0.16329 0.66121 0.28622 1.7611-0.3125 2.0938-0.3437 0.34673-1.6482 0.11368-1.5938-1.7188 0-0.58359-0.42846-1.1926-0.6875-1.5625-0.26005-0.17034-0.43554-0.21875-0.90625-0.21875-0.57352 0.0232-0.56052 0.17445-0.875 0.65625-0.14 0.49-0.32 0.97-0.32 1.53-0.0716 0.65214-0.33273 0.873-0.8125 0.96875-0.53623 0-0.40932 0.0584-0.84375-0.21875-0.25803-0.28222-0.5625-0.3932-0.5625-0.875 0-0.49892-0.13107-1.2954-0.28125-1.625-0.22778-0.30036-0.58775-0.45667-1-0.5625-2.2467 0.008-2.4103 2.5898-2.2812 3.5625-0.16832 0.18344-0.25163 4.7592 2.8125 6.0312 4.1134 1.9614 11.827 1.1322 11.5-5.5 0.00001-0.58662-0.12904-2.5565-0.1875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm55.188 0.0625c-1.4216 0.0725-2.6766 0.47991-3.75 1.0312-2.7265 2.6106-3.3657 6.7957-1.2188 9.4062 2.0895 0.98677 4.1742 3.0899 2.7812 4.25-5.9087 6.3111-21.287 16.857-22.062 18.781-0.006 0.0157-0.0279 0.0481-0.0312 0.0625-0.002 0.0138 0.00015 0.05 0 0.0625 0.00047 0.006-0.001 0.0256 0 0.0312 0.005 0.0159 0.0214 0.0496 0.0312 0.0625 0.004 0.004 0.0268 0.0276 0.0312 0.0312 0.005 0.003 0.0257-0.003 0.0312 0 0.006 0.003 0.0245 0.029 0.0312 0.0312 0.007 0.002 0.0233-0.002 0.0312 0 0.002 0.002 0.0286 0.029 0.0312 0.0312 0.78147 0.52416 10.404 0.51176 11.469 0.0312 0.008-0.004 0.0248-0.0271 0.0312-0.0312 0.003-0.002 0.0286 0.002 0.0312 0 0.002-0.002-0.002-0.0291 0-0.0312 3.307-1.2186 19-19.156 19-19.156-0.81342-0.69647-1.5626-1.2098-2.375-1.9062-0.87086-0.75393-0.78317-1.4951 0-2.25 3.8866-2.2618 2.655-7.2382 0.625-9.5-1.6828-0.75445-3.2659-1.01-4.6875-0.9375zm144.25 0.0625c-0.41312 0.041-0.91624 0.67737-1.6875 2.3125-1.8546 3.0379-3.1149 8.3282-2.9688 13.281 4.0176 27.814 5.2493 52.154 7.875 79.969 0.21369 2.6902-0.18067 6.598-1.9688 8.1562-6.6141 6.9064-16.151 15.424-26.531 19.344-1.1168 1.2539 2.7768 6.5988 7.8125 6.5938 8.4213-0.9777 15.823-5.7042 22.688-18.156 1.8355-2.9039 5.0615-9.1196 5.1562-13.938 0.64205-28.247-1.4239-50.209-5.6562-70.625-0.27114-1.9886-0.0867-4.3408 0.25-4.9375 0.54529-0.65112 2.3943 0.0149 3.375-1.5938 1.4393-1.4696-3.8441-13.655-6.8438-18.344-0.59928-1.1776-0.96885-2.1152-1.5-2.0625zm-223.47 0.85c-1.1623 0.1359-2.2557 1.0822-2.7812 2.3438-0.19454 4.4611-0.2207 8.9199 0.28125 13.031 2.029 7.2108 2.6715 13.553 3.6562 20.938 0.27314 9.8909-5.7117 4.2786-5.4375-0.625 1.3819-6.3692 1.0089-16.396-0.21875-18.938-0.97367-2.541-2.1011-3.1683-4.4688-2.75-1.8798-0.1149-6.7361 5.1765-8.0938 13.938 0.00001-0.00001-1.1311 4.4965-1.625 8.5-0.66423 4.5246-3.6616 7.7288-5.75-0.625-1.8052-6.0718-2.9147-21.032-5.9375-17.531-0.86582 11.681-1.8939 32.235 8.0312 34.344 12.005 1.1541 5.3735-20.294 9.7188-24.188 0.82147-1.9242 2.3438-1.9584 2.4688 0.46875v18.219c-0.10986 5.9226 3.7877 7.6826 6.8125 8.9062 3.1478-0.24292 5.235-0.15687 6.4688 2.9062 0.49188 10.502 1.0081 21.03 1.5 31.531 0 0 7.2773 2.0912 7.625-17.719 0.34876-11.632-2.3163-21.393-0.75-23.656 0.0554-2.2235 2.9055-2.3335 4.875-1.25 3.1377 2.2134 4.5298 4.9374 9.4062 3.8438 7.4204-2.0441 11.89-5.6459 12-11.344-0.43342-5.4146-1.0598-10.835-3.4062-16.25 0.32759-0.98475-1.4203-3.5465-1.0938-4.5312 1.3335 2.0884 3.3509 1.9151 3.8125 0-1.263-4.1618-3.2292-8.1494-6.4062-9.875-2.6257-2.3132-6.4679-1.824-7.875 3-0.65214 5.5588 2.0146 12.147 6.0625 17.531 0.85977 2.1036 2.0624 5.6022 1.5312 8.75-2.154 1.2287-4.2896 0.7175-6.0938-1.1875 0.00001-0.00001-5.9062-4.4215-5.9062-5.4062 1.5673-10.035 0.33759-11.184-0.53125-13.969-0.60677-3.8443-2.4286-5.0618-3.9062-7.6875-1.4776-1.5663-3.482-1.5663-4.4375 0-2.6106 4.5256-1.3858 14.242 0.5 18.594 1.3627 4.0025 3.4525 6.5 2.4688 6.5-0.81038 2.2618-2.5002 1.7356-3.7188-0.875-1.7397-5.3955-2.0938-13.437-2.0938-17.062-0.52212-4.4944-1.1042-14.095-4.0625-16.531-0.78934-1.0751-1.721-1.4494-2.625-1.3438zm42.156 0.0625c-0.59574 0.0753-1.2543 0.41445-2.0312 0.59375-2.5521 0.8124-4.9414 3.0187-4.1875 7.3125 3.0168 18.332 4.9832 32.323 8 50.656 0.46368 2.1469-1.336 4.9768-3.6562 4.6875-3.9451-2.669-4.9242-8.0746-11.656-7.8438-4.8734 0.0585-10.431 5.3615-11.125 10.469-0.81239 4.059-1.1017 8.4601 0 12 3.425 4.1184 7.5277 3.6793 11.125 2.75 2.9583-1.2176 5.3923-4.133 6.4375-3.4375 0.003 0.003 0.0286-0.004 0.0312 0 0.003 0.004-0.003 0.027 0 0.0312 0.64509 1.1276-0.0608 10.663-13.938 18.031-8.5281 3.8292-15.316 4.7441-18.969-2.2188-2.2628-4.3513 0.16462-20.924-5.4062-17.094-16.475 42.467 38.598 48.395 44.75 1.75 0.39844-1.3159 1.6121-2.6362 2.4688-2.3125 0.3759 0.16008 0.71998 0.67052 0.84375 1.625-1.2771 42.235-42.606 45.13-49.625 31.844-1.7397-3.1317-2.2631-10.103-2.4375-14.281-0.31817-2.5275-0.95237-3.9854-1.6875-4.5625-1.6745-1.2582-3.9247 2.023-4.4062 7.7188-0.69647 4.5831-0.5 5.8413-0.5 10.25 2.2044 33.359 55.388 19.026 64.031-8.5312 4.2787-14.246-0.0871-24.993 1.3438-26.312 0.0124-0.0104 0.0493-0.0222 0.0625-0.0312 0.0136-0.008 0.048-0.0242 0.0625-0.0312 0.0149-0.006 0.0467-0.0262 0.0625-0.0312 0.0487-0.013 0.13046-0.0305 0.1875-0.0312 5.2796 5.6868 12.688 0.72253 14.312-1.25 0.69648-0.98677 2.4387-1.6198 3.6562-0.34375 4.1184 2.9603 11.337 1.5649 12.844-3.6562 0.87085-5.1052 1.6069-10.361 1.7812-15.812-2.6827 0.83292-4.8475 1.4566-5.7188 2.375-0.20749 0.22659-0.36097 0.47794-0.40625 0.75-0.23283 1.5089-0.45467 3.0224-0.6875 4.5312-0.0249 0.12473-0.065 0.23996-0.125 0.34375-0.11434 0.18521-0.30336 0.35601-0.5 0.46875-0.94842 0.51783-2.6022 0.22171-2.6875-1.1562-1.276-5.8017-6.5276-6.5563-9.7188 2.4375-2.1469 1.7397-6.0616 2.0793-6.4688-0.53125 0.52213-6.0335-1.9089-6.8434-6.7812-4-1.5664-11.951-3.1202-23.361-4.6875-35.312 2.031-0.0585 3.8934 1.414 5.75-0.90625-2.0092-6.2487-6.2607-18.963-8.6562-20.156-0.0188-0.009-0.0439-0.024-0.0625-0.0312-0.10876-0.1305-0.23745-0.25071-0.34375-0.34375-0.0442-0.0375-0.1123-0.0933-0.15625-0.125-0.0439-0.0305-0.11251-0.0687-0.15625-0.0937-0.0962-0.0528-0.21644-0.0958-0.3125-0.125-0.2184-0.0619-0.43059-0.091-0.65625-0.0625zm164.34 0.0937c-2.1076-0.0625-4.4397 1.2657-3.5312 3.9062-0.52916 1.4403 4.5283 6.326 5.3438 9 1.4676 4.1084-1.1208 8.0273 0.40625 8.5938 1.4051 0.63399 3.36-4.2415 4.0938-8.75 0.84767-3.6447-1.7525-11.114-5.4375-12.656-0.28247-0.0665-0.57391-0.0848-0.875-0.0937zm-128.03 4.5c0.95979-0.0978 2.1195 0.78407 2.6875 2.0312 0.60588 1.3303 0.30199 2.6014-0.6875 2.8438-0.98948 0.24236-2.2691-0.63842-2.875-1.9688-0.60586-1.3303-0.30199-2.6326 0.6875-2.875 0.0618-0.0152 0.12351-0.0247 0.1875-0.0312zm237.5 6.1562c-1.9215-0.0673-4.0156 1.3916-3.1875 4.25-0.4818 1.5593 4.1009 6.8552 4.8438 9.75 0.66826 2.0602-1.017 8.6997 0.375 9.3125 1.2811 0.6864 3.0818-4.5873 3.75-9.4688 0.37092-2.672-1.6093-12.049-4.9688-13.719-0.25753-0.0719-0.538-0.11538-0.8125-0.125zm-131.31 3.25c0.17575 0.78356 0.3514 1.5724 0.46875 2.375 0.39382 1.7317 0.73331 3.4518 1.0938 5.1562-1.5169-2.0887-2.7725-3.7763-3.3125-4.375-3.4323-4.079 0.0773-2.6786 1.75-3.1562zm30.25 14.875c-0.7426 0.12864-1.4592 0.7718-1.7188 1.7812-0.16329 0.6612 0.31746 1.7299-0.28125 2.0625-0.3437 0.34673-1.6794 0.14492-1.625-1.6875-0.00001-0.5836-0.42846-1.2238-0.6875-1.5938-0.26003-0.17035-0.43554-0.21875-0.90625-0.21875-0.57353 0.0232-0.56053 0.17446-0.875 0.65625-0.13304 0.49087-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.87299-0.78125 0.96875-0.53622 0-0.44058 0.0584-0.875-0.21875-0.25804-0.28221-0.5625-0.39321-0.5625-0.875 0.00001-0.49893-0.13107-1.2954-0.28125-1.625-0.2278-0.30037-0.58776-0.42541-1-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16834 0.18344-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 11.858 1.101 11.531-5.5312 0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.41981-0.9777-1.1949-1.3474-1.9375-1.2188zm-138.12 1.375c-0.5072-0.0517-1.1721 0.13451-1.9375 0.59375-3.6376 1.9675-5.0461 7.8039-2.7812 11.219 2.1157 3.0077 5.4607 1.9062 5.9062 1.9062 3.564 0.4455 5.6875-6.6875 5.6875-6.6875-0.00001 0 0.10732-2.0056-4.125 1.7812-1.781 0.33363-2.0232-0.3096-2.4688-1.3125-0.37093-1.8556-0.29122-3.7371 0.5625-5.5938 0.39436-1.1131 0.002-1.8201-0.84375-1.9062zm195.25 0.90625c-2.0194-0.0982-4.1688 1.2095-4.7188 3.9688 0.008 1.6278 0.73488 2.5224 0.59375 4-0.21065 0.84465-1.0809 1.4001-3.1562 0.40625 0.32455-0.29835-1.3438-2.6562-1.3438-2.6562-1.6188-0.98576-3.7804 0.0535-5.1875 0.96875-0.7741 1.4071-1.3467 3.8189-0.46875 6.2812 2.3233 4.2928 10.293 11.618 14.094 11.688 0.0706-3.8705 0.4466-9.0175 0.65625-12.219 0.0897-1.2085 0.37315-2.5404 1.5312-2.8438 1.1571-0.30238 3.1653 1.1642 3.1875-0.0937-0.21066-2.4624-0.70279-6.096-2.0938-7.8125-0.71249-1.0557-1.8821-1.6286-3.0938-1.6875zm-161.62 13.469c-0.0537 0.0197-0.10688 0.0656-0.15625 0.0937-0.0242 0.0147-0.0693 0.0449-0.0937 0.0625-0.40219 0.30193-0.87679 0.99874-1.9375 1.75-1.7891 2.035-2.1098 3.4521-2 7.5312 0.10179 0.43147 3.3965 9.5919 6.1875 16.031 1.8818 6.6927 3.6228 14.356 2.3438 21.594-4.4057 9.5684-13.263 18.15-21.812 22.812-4.3557 1.395-8.1174 0.91994-9.125-0.0312-0.008-0.008-0.024-0.0236-0.0312-0.0312-2.5014-1.6818-2.5588-4.6756-2.4062-5.1875-0.00005-0.003 0.00017-0.0277 0-0.0312 0.006-0.006 0.0255-0.0258 0.0312-0.0312 7.2138-5.0246 15.454-9.0914 21.906-22.656 1.905-5.1838 2.4866-8.2964 0.59375-16.312-0.73791-2.9868-1.6494-5.4446-3.6875-7.5625 0.005-0.006 0.0259-0.0257 0.0312-0.0312 1.228-0.58751 4.4141 1.7597 4.9062 0.28125-0.75393-3.8271-3.3461-8.965-6.2812-11.594-2.5702-2.3344-5.3662-2.6046-7.7188-0.46875-2.6499 1.4746-3.2135 6.7707-1.9375 11.406 1.4172 3.4895 5.2433 4.1017 7.9688 11.125-0.00005 0.007-0.00024 0.0289 0 0.0312 0.0568 0.44036 0.93536 5.2424-0.4375 7.1875-1.1141 3.4742-15.424 14.759-16.438 15.438-0.0112 0.0112-0.0829 0.0519-0.0937 0.0625-0.006 0.006-0.0259 0.026-0.0312 0.0312-0.003 0.002-0.0246 0.0245-0.0312 0.0312-0.003 0.003-0.0284 0.028-0.0312 0.0312-0.003 0-0.0278 0.00017-0.0312 0-0.002-0.00007-0.0241-0.00011-0.0312 0-0.006-0.005-0.0257-0.0254-0.0312-0.0312 0.00024-0.003-0.00007-0.0284 0-0.0312-0.006-0.0108-0.0256-0.0512-0.0312-0.0625-0.0431-0.28175 0.0326-0.99908 0-2.1562-0.094-2.1144 0.78114-6.8979 0.71875-7.7188 0.00003-0.003-0.00009-0.0281 0-0.0312-0.006-0.006-0.0254-0.0257-0.0312-0.0312 0.00004-0.003-0.00016-0.0278 0-0.0312-0.007 0.00014-0.0302 0.00009-0.0312 0-4.7302 3.0541-6.2924 12.416-7.1562 15.188-11.975 8.2741-25.574 14.43-33.406 22.812-4.0791 6.3702 28.104-7.3147 31.844-8.9688 0.0321 0.0241 0.0641 0.063 0.0937 0.0937 0.71089 0.78237 0.77161 3.5103 2.9062 5.9688 3.3453 4.5317 10.456 7.3224 17.375 5.5938 11.603-4.194 18.288-12.102 25.094-20.875 0.97266-1.4151 2.4972-2.5301 3.9062-1.4375 4.6768 10.47 18.161 17.92 35.594 18.688 4.0338-4.9056 2.1046-7.3177 0.46875-8.3438-0.50391-0.33487-8.6698-3.5184-9.9375-6.6875-0.79829-2.9492 1.1426-5.5648 5.0312-7.5312 11.193-1.3537 22.196-2.8573 32.844-6.2812 0.10784-3.5772 2.2149-8.9267 3.625-11.25 0.97909-1.612 1.6086-1.7716 1.8438-2 0.008-0.008 0.0246-0.023 0.0312-0.0312 0.003-0.004 0.0284-0.0269 0.0312-0.0312 0.006-0.005 0.0256-0.0257 0.0312-0.0312 0.00002-0.0107 0.00042-0.0514 0-0.0625 0.006-0.0708-0.00049-0.19272-0.0312-0.3125l-1.8125-1.0625-35.719-0.15625c-0.44124-0.16987-0.76931-0.34037-0.96875-0.5-0.0152-0.0127-0.0489-0.0499-0.0625-0.0625-0.006-0.006-0.0253-0.025-0.0312-0.0312-0.006-0.006-0.0261-0.0251-0.0312-0.0312-0.005-0.0109-0.0263-0.0516-0.0312-0.0625-0.003-0.003-0.0277-0.0279-0.0312-0.0312 0.00006-0.003-0.00029-0.0279 0-0.0312-0.003-0.003-0.0276-0.0279-0.0312-0.0312 0.00002-0.003-0.00018-0.0279 0-0.0312 0.00001-0.003-0.00013-0.0279 0-0.0312 0-0.003-0.00008-0.0279 0-0.0312-0.00033-0.005 0.00012-0.0265 0-0.0312 0.00013-0.002 0.00009-0.0246 0-0.0312-0.00005-0.003 0.0001-0.0279 0-0.0312-0.00006-0.003 0.00014-0.0279 0-0.0312-0.00007-0.003 0.00019-0.0279 0-0.0312 0.006-0.006 0.0254-0.0256 0.0312-0.0312 0.008-0.0165 0.0204-0.0462 0.0312-0.0625 0.17439-0.23501 0.59702-0.45652 1.125-0.65625 8.5292-1.1621 23.682-3.646 24.688-18.219-0.15724-7.5908-3.2482-12.561-12.562-13.938-6.8439 0.52918-11.725 7.1491-10.938 14.438-0.32757 1.9624 0.66406 5.8136-1.3438 6.25-13.128 1.1994-27.457 9.4251-27.938 15.312-0.003-0.00052-0.0285 0.00014-0.0312 0-0.005 0.006-0.0258 0.0256-0.0312 0.0312-0.0101 0.005-0.046 0.0231-0.0625 0.0312-0.0109-0.00015-0.0515 0.0004-0.0625 0-0.0211 0.007-0.0722 0.0257-0.0937 0.0312-0.006 0.00054-0.0232-0.00011-0.0312 0-0.0178-0.00028-0.0507 0-0.0625 0-0.006-0.00019-0.0232-0.0002-0.0312 0-0.0132 0.00033-0.0516 0.00053-0.0625 0-0.0339-0.007-0.0956-0.0238-0.125-0.0312-0.85384-0.23714-1.9538-1.6462-1.7812-3.625-0.49994-10.177-3.8122-21.693-9-30.562-1.8513-1.8508-2.6579-2.6008-3.1875-2.6875-0.0171-0.002-0.0459 0.0008-0.0625 0-0.0218-0.00009-0.0656 0.00025-0.0937 0-0.005 0.00014-0.0264-0.0004-0.0312 0-0.003-0.00009-0.0283 0.00025-0.0312 0-0.004 0.001-0.0274-0.001-0.0312 0zm34.188 5.375c-0.7426 0.12864-1.4592 0.74055-1.7188 1.75-0.16327 0.66121 0.31746 1.7611-0.28125 2.0938-0.34371 0.34673-1.6794 0.14493-1.625-1.6875 0-0.58359-0.42846-1.2238-0.6875-1.5938-0.26004-0.17034-0.40429-0.21875-0.875-0.21875-0.57352 0.0232-0.59178 0.17445-0.90625 0.65625-0.13306 0.49085-0.3125 0.97487-0.3125 1.5312-0.0716 0.65214-0.30147 0.873-0.78125 0.96875-0.53623 0-0.40933 0.0584-0.84375-0.21875-0.25803-0.28222-0.59375-0.3932-0.59375-0.875-0.00001-0.49893-0.0998-1.2954-0.25-1.625-0.22779-0.30036-0.61901-0.42542-1.0312-0.53125-2.2467 0.008-2.379 2.5586-2.25 3.5312-0.16833 0.18345-0.28288 4.7905 2.7812 6.0625 4.1134 1.9614 13.916 0.80665 11.531-5.5312-0.00001-0.58662-0.16029-2.5565-0.21875-3.0938-0.4198-0.9777-1.1949-1.3474-1.9375-1.2188zm137.97 5.6562c-0.1034-0.0186-0.22236-0.0114-0.34375 0.0312 0 0-19.059 13.559-19.531 14.031-1.8899 1.6802-0.94442 7.5886 0 6.9062 1.3658 0.52513 20.554-12.478 20.188-14 0.83627 0.0491 1.2385-6.6892-0.3125-6.9688zm-119.96 2.01c0.77787-0.0825 1.7982 0.18143 2.7812 0.75 1.4228 0.82293 2.2998 2.0657 2.1875 2.9688-0.004 0.0245 0.005 0.0698 0 0.0937-0.006 0.0238-0.0554 0.0705-0.0625 0.0937-0.008 0.023-0.0221 0.0713-0.0312 0.0937-0.006 0.0148-0.0241 0.048-0.0312 0.0625-0.007 0.0144-0.0231 0.0484-0.0312 0.0625-0.0466 0.0763-0.12358 0.15638-0.1875 0.21875-0.68395 0.63877-2.2626 0.54784-3.75-0.3125-1.4098-0.81544-2.281-2.068-2.1875-2.9688 0.003-0.0246 0.0267-0.0696 0.0312-0.0937 0.0236-0.11178 0.0679-0.21374 0.125-0.3125 0.0204-0.0353 0.0384-0.0926 0.0625-0.125 0.005-0.006 0.0261-0.025 0.0312-0.0312 0.042-0.049 0.10547-0.11459 0.15625-0.15625 0.22671-0.17829 0.54802-0.30575 0.90625-0.34375zm-166.91 3.4375c-9.8758 0.18043-24.338 12.945-24.719 20.031 10.421-5.0044 20.657-9.8212 31.25-15-1.7095-2.5521-0.10363-4.8518-6.5312-5.0312zm32 4.4375c0.96809 0.0109 1.9891 0.48893 2.5312 1.8438 0.48784 1.2428 0.0231 2.5424-0.5625 3.1875-0.003 0.005 0.003 0.0263 0 0.0312-0.009 0.0144-0.0215 0.049-0.0312 0.0625-0.4145 0.53404-1.8697 0.3125-2.9062 0.3125-1.2539-0.0554-1.8721-0.26122-2.625-1.2812-0.35982-1.1339 0.73594-2.2481 1.2188-3.0938 0.005-0.008 0.0263-0.0234 0.0312-0.0312 0.0524-0.0788 0.13801-0.17326 0.21875-0.25 0.375-0.34347 1.0235-0.66453 1.7188-0.75 0.13519-0.0166 0.26795-0.0328 0.40625-0.0312zm251.16 3.93c-1.756 0.21654-3.4252 1.877-2.6562 4.5312-0.4818 1.5593 2.3822 7.0115 3.125 9.9062 0.66827 2.0602-0.86071 7.8872 0.53125 8.5 1.2811 0.68641 4.6502-3.4593 4.5312-8.6562 0.37092-2.672-0.95304-12.517-4.3125-14.188-0.38629-0.10791-0.81353-0.14372-1.2188-0.0937zm-213.31 9.625c-1.552 0.10848-2.9369 0.93803-2.3125 3.125-0.0937 1.5865 4.3851 3.5156 4.6562 7.1875 0.64004 1.5139-0.9575 6.362 0.375 6.8125 1.2236 0.50396 2.9215-3.3513 3.5625-6.9375 0.35479-1.9645-1.5367-8.8358-4.75-10.062-0.49313-0.10609-1.0139-0.16116-1.5312-0.125zm63.844 8.7188c0.11777-0.008 0.22161 0.00072 0.34375 0 0.0205-0.00013 0.0419-0.00009 0.0625 0 3.9793 1.0815 9.8454 1.1936 14.938 1.7188 4.1477 0.26307 6.1971 3.5103 2.3125 4.875-3.8322 1.3124-7.5141 2.3374-7.5312 7.875 0.50376 2.7431 0.39705 4.1826-0.0312 4.8438-0.0335 0.0496-0.0878 0.11552-0.125 0.15625-0.005 0.006-0.0258 0.0258-0.0312 0.0312-0.006 0.005-0.0256 0.0261-0.0312 0.0312-0.006 0.005-0.0255 0.0265-0.0312 0.0312l-0.0312 0.0312c-0.011 0.005-0.0514 0.0259-0.0625 0.0312-0.0557 0.0346-0.12681 0.0715-0.1875 0.0937-0.0536 0.0182-0.1305 0.0217-0.1875 0.0312-0.91095 0.1336-2.234-0.73511-3.2188-1.25-2.3626-1.6964-8.9931-5.8056-9.9375-14.625-0.13438-1.9902 1.3554-3.7064 3.75-3.875zm-155.94 6.7812c-0.24858 0.008-0.74605 0.75061-1.4062 1.5938-5.8753 9.3597-6.3978 23.331-3.1562 27.5 1.7226 1.9695 4.5628 2.8356 6.6562 2.2188 3.6911-1.6006 5.3134-9.077 4.4375-11.812-1.2317-1.9282-2.2078-2.2337-3.4375-0.59375-2.5974 5.2735-3.6784 1.666-3.9062-1.2812-0.39814-5.589 0.14322-10.736 0.75-14.812 0.32304-2.089 0.31108-2.8203 0.0625-2.8125zm200.16 12.29c-0.43689-0.0234-0.90278 0.0449-1.375 0.28125-0.0927 0-4.2058 2.7815-5.5312 4.7188-0.80837 0.61485-0.71671 1.1493-0.46875 2.2188 0.62996 1.4484 1.7401 0.99386 3 0.3125 1.6722-0.2278 2.4808 0.8672 2.3438 2.875-0.77208 2.5037 0.34374 3.4365 0.34375 3.5938 0 0.15724 1.6101 1.5392 3.5 0.4375 3.9894-1.523 6.4755-3.0042 12.062-4.2188 1.4666-0.0292 1.3818-3.9536-0.9375-4.0938-3.0258 0.1522-5.8179 0.30676-8.8438 2.6875-1.8617 0.43039-2.1805-0.70275-2.5938-1.7188-0.47272-2.5208 1.0645-4.2976 0.75-6.1875 0.0839 0.0831-0.93932-0.83604-2.25-0.90625zm128.16 4.7812c-0.74222 0.0232-1.5238 0.12602-2.6562 0.21875-1.2246 0.26006-1.6522 0.79656-1.875 2.2812 0.0877 2.2517 1.4649 2.1402 2.875 3.0312 0.81645 1.0392 1.3476 1.98-0.0625 3.6875-1.3365 1.2246-2.2885 1.9004-3.625 3.125-0.631 1.0765-1.024 2.7299 0.90625 3.25 3.564 1.0019 11.812-4.3569 11.812-4.4688 1.3365-1.0019 0.89313-2.9062 0.78125-2.9062-0.77912-0.89102-2.5374-0.35586-3.7188-0.5-0.56244 0-2.4092-0.27339-1.5312-1.9062 0.73278-1.016 1.0031-1.6232 1.5-2.875 0.55638-1.2246 0.0673-2.0505-1.9375-2.7188-1.021-0.18546-1.7265-0.24193-2.4688-0.21875zm-53.54 108.4c-0.008 0.004-0.0234 0.0258-0.0312 0.0312-5.9277 1.521-5.7433 7.6749-1.9375 10.375-62.594 0-158.65-1.0625-179.25-1.0625-11.525 0-47.987-1.375-48.688-1.375 7.8196 11.437 19.147 13.766 33.969 14 27.802 0 156.62-0.34375 193.28-0.34375-2.6062 4.6275 0.23645 12.074 2.2812 13.438 0.0434 0.0279 0.11369 0.0715 0.15625 0.0937 0.0763 0.038 0.17693 0.0749 0.25 0.0937 0.0242 0.006 0.07-0.003 0.0937 0 2.4271 0.5725 3.4951-1.1846 4.3125-2.4688 3.9372 0.34703 26.097 0.66757 28.125-0.0312 0.007-0.003 0.0245-0.0284 0.0312-0.0312 1.3718 2.0189 2.7332 3.9264 5.3438 3.5938 4.569-0.97972 8.1674-1.477 8.2812-10.75 0 0-0.46704-15.802-10.844-14.812-2.4553 0.37092-9.3438 1.0625-9.3438 1.0625-7.9718-0.94847-13.819-1.0454-22.781-1.375 0.82723-1.0502 2.2878-5.3034 0.5-6.8438-0.46622-0.38767-1.1617-0.60352-2.125-0.53125-0.007 0.0005-0.0244-0.00008-0.0312 0-0.0136-0.00068-0.0492 0.002-0.0625 0-0.007-0.002-0.0248-0.0293-0.0312-0.0312-0.0257-0.009-0.0692-0.0161-0.0937-0.0312-0.0486-0.033-0.11173-0.10294-0.15625-0.15625-0.011-0.0139-0.0517-0.0475-0.0625-0.0625-0.45322-0.65987-0.70068-2.2777-1-2.6875-0.004-0.004-0.0277-0.0271-0.0312-0.0312-0.004-0.003-0.0276-0.0282-0.0312-0.0312-0.0109-0.007-0.0514-0.0277-0.0625-0.0312-0.004-0.00036-0.0275-0.00006-0.0312 0-0.004 0.00091-0.0274-0.001-0.0312 0zm4.25 22.594c0.0109-0.005 0.0202 0.005 0.0312 0 9.1319 0.44551 17.712 0.0857 26.844 0.53125 1.4473 1.2303 0.72345 4.0484-0.21875 4.5625-0.0422 0.0211-0.11339 0.051-0.15625 0.0625-0.0344 0.008-0.0905-0.001-0.125 0-0.0345-0.0007-0.0905 0.008-0.125 0-2.9694-0.0746-4.6869-0.14417-7.6562-0.21875-0.005-0.14772-0.0215-0.30707-0.0625-0.4375-0.70371-2.0856-5.8008-1.9461-7-0.3125-0.0166 0.0235-0.0475 0.0696-0.0625 0.0937-0.0192 0.0325-0.0463 0.0915-0.0625 0.125-0.0193 0.0422-0.0482 0.11238-0.0625 0.15625-0.0187 0.0619-0.0229 0.15372-0.0312 0.21875-0.008 0.0748-0.0379 0.17113-0.0312 0.25-4.0086 0.4818-7.6164-0.13309-11.625-0.28125-1.1761-1.4641-1.0388-4.1134 0.34375-4.75z' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1080' height='720' viewBox='0 0 1080 720'%3E %3Crect width='1080' height='720' fill='%2320603D'/%3E %3Crect width='1080' height='540' fill='%23FAD201'/%3E %3Crect width='1080' height='360' fill='%2300A1DE'/%3E %3Cg transform='translate(886.5,188.1)'%3E %3Cg id='h'%3E %3Cpath id='q' fill='%23E5BE01' d='M 116.10000,0.00000 L 35.69202,4.69894 112.14399,30.04889 33.25966,13.77660 100.54555,58.05000 28.56072,21.91541 82.09510,82.09510 21.91541,28.56072 58.05000,100.54555 13.77660,33.25966 30.04889,112.14399 4.69894,35.69202 0.00000,116.10000 -1,-1 z'/%3E %3Cuse xlink:href='%23q' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3Ccircle r='34.3' fill='%23E5BE01' stroke='%2300A1DE' stroke-width='3.4'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9 6' width='900' height='600'%3E%3Crect fill='%23fff' width='9' height='3'/%3E%3Crect fill='%23d52b1e' y='3' width='9' height='3'/%3E%3Crect fill='%230039a6' y='2' width='9' height='2'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1350' height='900'%3E %3Crect width='1350' height='900' fill='%23fff'/%3E %3Crect width='1350' height='600' fill='%230c4076'/%3E %3Crect width='1350' height='300' fill='%23c6363c'/%3E %3Cg%3E %3Cg transform='matrix(1,0,0,1.0043716,0,-0.32788075)'%3E %3Cpath fill='%2321231e' d='m473.38,259.35zm1.0098,0.0337zm-93.132,5.2436c-2.30984-0.2547,3.48357-0.77423,4.85921-0.74476,29.2392-1.8271,58.4803-3.65646,87.7454-5.02418,0.006,2.14822-3.95456,0.6738-5.64195,1.28281-29.1557,1.44472-58.2914,3.26022-87.4244,5.10075l0.24884-0.33104,0.21312-0.28351-0.00025-0.00007zm-0.98838,0.21166zm6.5343,31.051c-2.1781-10.3503-4.3562-20.7007-6.5343-31.051,2.24726-0.16069,1.38028,4.47146,2.35289,6.27247,1.72326,8.18896,3.44653,16.3779,5.16979,24.5669-0.40297,0.52555-0.43759,0.86795-0.98838,0.21166zm0.50852,0.40289zm94.846-4.0806c0.0433,2.29366-4.10686,0.52718-5.7799,1.1954-29.69,0.92479-59.374,2.03894-89.0665,2.88458,0.19988-2.2311,4.5146-0.57519,6.41431-1.2042,29.4799-0.8776,58.953-1.98321,88.4321-2.87578zm-0.031,0zm94.368,3.466c2.17326,1.02636-3.85742,0.3909-5.13524,0.45206-29.7469-0.88096-59.4862-1.99829-89.2324-2.90039,0.261-2.20443,4.35614-0.33324,6.22483-0.82645,29.5516,0.92252,59.0972,2.03005,88.6514,2.87146l-0.3246,0.25718-0.18392,0.14571-0.00004,0.00043zm0.98838,0.21167zm6.5343-31.051c-2.1781,10.3503-4.3562,20.7007-6.5343,31.051-2.11816-0.77417,0.53953-4.65151,0.37613-6.6958,1.72326-8.18896,3.44653-16.3779,5.16979-24.5669,0.52516-0.60989,0.63576-0.32596,0.98838,0.21167zm-0.46196-0.61456zm-93.659-4.8395c0.85119-0.69952,3.25454-0.4022,5.6201-0.28896,29.3609,1.44451,58.7011,3.27626,88.0386,5.12823-0.33902,2.1985-4.37641,0.19693-6.27673,0.62314-28.9574-1.80781-57.9166-3.61747-86.8995-4.97079l-0.28992-0.29572-0.19233-0.19618-0.0002,0.00028zm0.48224,0.49189zm0.52164-0.70235zm-1.0098,0.0337zm-7.7662,0.33554c-0.26642-2.10699,3.13572-0.64702,4.5454-1.14803,1.46862,0.29926,4.03852-0.80448,4.72484,0.78781-1.24999,1.64015-1.01458-2.07321-0.69234,0.279-2.85184-0.1798-5.72414,0.0233-8.5779,0.0812zm0.0358,0zm-8.2687,0.15754c1.0121-0.99117-2.1605,0.38747-0.12416-1.2868,2.79684-0.11403,5.59664,0.039,8.39288,0.1126,0.0956,2.04592-3.17785,0.47514-4.63511,0.8877-1.04538-0.12573-3.39414,0.14117-3.7721-0.0661-0.18937-1.11976,0.32819-1.11472,0.13849,0.35262zm-0.001-1.0198zm-0.50493,0.49309z'/%3E %3Cpath fill='%2321231e' d='m595.05,245.94c0.0372-1.74531-1.12336,2.50426-2.61752,3.49924-3.30087,4.72366-5.97194,9.84635-8.52802,14.9999-1.91597-0.9918,1.28773-3.68708,1.60194-5.38187,2.55225-4.85337,5.37293-9.59783,8.85245-13.8509,0.23038,0.24454,0.46077,0.48908,0.69115,0.73362zm-19.257-3.8894c1.11489-2.15622,0.74235,3.64582,1.68789,4.68067,1.01782,4.15895,6.01522,4.8658,9.30486,2.99685,2.75858-1.1619,5.26098-2.84052,7.66234-4.60855,1.10343,2.00092-3.51171,3.10344-4.95573,4.43176-3.68943,2.32758-9.93234,3.71048-12.3254-1.08238-1.13466-2.10183-1.51617-4.50635-1.7094-6.85988l0.27578,0.36288,0.0596,0.0785,0.00003,0.00016zm0.33662-0.95972zm-2.3217,0.50873c-1.86165-1.06886,1.12616-0.83085,2.00025-0.60675,0.84953,0.6349-0.32476,1.29458-1.08013,0.87102-0.28529-0.10725-2.05396,0.15027-0.92012-0.26427zm-0.8499-0.55322zm-25.304-5.2652c-1.11228-1.84231,2.27293,3.41439,2.86485,4.85914,2.77981,4.639,7.31564,10.8912,13.5437,8.97385,3.98056-1.52616,6.61543-5.14297,8.89543-8.56764,1.75148,1.36422-1.99329,3.85915-2.86027,5.44615-3.18666,4.14828-9.57046,6.29638-13.8855,2.5393-4.38568-3.38206-7.03834-8.43233-9.44151-13.3037l0.45497,0.0273,0.42837,0.0257v-0.00006zm-0.85469-0.54601zm-28.404-0.52196c-0.9862-1.97825,2.03968,3.3787,2.5155,4.7294,2.43356,4.82873,7.244,10.8718,13.3708,8.52925,5.67603-2.37174,9.24016-7.79817,12.5177-12.7367,1.73769,1.46427-2.17742,4.15712-2.93552,5.96811-3.59358,4.70113-9.60295,10.4227-15.9662,7.48462-5.40233-2.82024-8.04852-8.77773-10.364-14.0999l0.45106,0.0655,0.41079,0.0596-0.0001,0.00014zm-0.78784-0.63739zm-33.758,0.67227c2.08897-0.5,2.52174,3.56913,4.3558,4.98183,3.49185,5.14994,10.3852,8.68657,16.3777,5.63581,5.33949-2.39297,9.39208-6.83258,13.024-11.29,1.56541,1.64519-2.6179,3.87631-3.56828,5.58578-4.92733,5.29594-12.9451,10.3756-20.1567,6.41828-4.51465-2.44149-7.70441-6.88804-10.0326-11.3317zm0.0645,0.24895zm0.94659-2.3343zm-1.0122,0zm-0.97763,0.3644c1.20423-0.49907,0.15925-0.84589,1.53075-0.65462-0.68554,0.7487,0.0961,1.26538,0.1567-0.17391,1.74497,1.19636-1.11609,1.56779-1.68745,0.82853zm0.38079,0.27301zm0.32587-1.1173zm-0.5479-0.26819zm-0.97525,1.1906c-0.16788-1.11305,0.0537-1.03062,0.9747-1.19,0.75087,1.27677-0.24,1.04137-0.9747,1.19zm0.18144,0zm-0.6231-0.45821c-2.47651-0.75314,1.95467-1.21263,0.4078,0.45179-0.35682-0.13032-1.64228-0.10653-0.4078-0.45179zm-0.90005-0.46423zm-0.19338,0.38004zm0.90005,0.46423zm-0.97883-0.36441c-2.16759-0.42351,0.61642,1.34548-0.52538-0.28424,0.9365-0.53696,1.75305,1.18652,0.35001,1.0037-1.59127,0.40291-1.09639-2.14183,0.17537-0.71946zm-0.71026-0.46542zm-0.302,2.552zm1.0122,0zm-33.684-0.16117c-1.52923-1.61612,2.78602,2.5088,3.5859,3.71858,4.69831,5.08626,12.0826,10.5385,19.2279,7.06916,4.5087-2.27149,7.49211-6.60018,9.922-10.8754,1.84456,1.34183-1.92238,4.18942-2.67985,5.9483-3.75595,5.44876-11.095,9.05955-17.4479,5.87542-5.52407-2.4388-9.72564-7.00847-13.4698-11.6108l0.45106-0.0655,0.41078-0.0596-0.00009-0.00009zm-0.93585-0.38725zm-28.302,1.5274c-1.38497-1.70396,2.49951,2.80557,3.14895,4.13944,3.45105,4.44999,8.6491,10.35,14.9307,8.07341,5.39524-2.60704,7.94324-8.55017,10.2228-13.7403,1.93604,1.19867-1.46661,4.57244-1.98583,6.51653-2.57583,5.01954-7.95743,10.6591-14.1249,8.22888-5.92753-2.41297-9.67595-8.02348-13.0751-13.165l0.45497-0.0273,0.42836-0.0257,0.0001,0.00001zm-0.91199-0.44016zm-25.7,6.5448c0.26845-2.42295,2.48706,3.01062,3.72633,3.64645,2.90521,3.86884,8.7862,6.35487,12.8763,2.70906,4.22689-3.29104,6.76664-8.1916,9.09722-12.9004,1.91177,1.29626-1.73644,4.49387-2.30264,6.43896-2.93895,4.87791-7.97076,10.977-14.4031,8.85164-4.20281-1.58182-7.02251-5.36233-9.41826-8.97893l0.39927,0.21982,0.0245,0.0135,0.00039-0.00014zm0.002-1.0198zm-2.077,0.79616c-2.21632-0.32364,0.86972-0.99964,1.81233-0.79438,1.10472,0.97881-0.44028,1.14503-1.309,1.0668-0.35662-0.0624-1.37114,0.51995-0.50333-0.27242zm-1.0075-0.077zm-17.892,3.6741c-1.66824-0.0297,3.14066,1.52771,4.4072,2.92192,3.41176,2.18178,9.44342,4.50078,11.9023-0.15689,1.05898-1.97376,1.39688-4.23344,1.58274-6.43893,2.19242,0.32355,0.0526,4.33402-0.24416,5.98073-1.43759,4.63417-7.192,5.11424-10.877,2.97475-2.6748-1.17937-5.11411-2.82219-7.46235-4.54787,0.23045-0.24454,0.46079-0.4892,0.69126-0.73371zm10.885,18.497c-0.17763,2.44645-1.89403-2.6447-2.60701-3.55988-2.60833-5.00483-5.47769-9.91068-9.05895-14.2899,1.67772-1.37425,2.76531,2.68796,4.04782,3.74505,3.09639,4.55843,5.64713,9.45624,8.09207,14.3861l-0.39189-0.23272-0.082-0.0487-0.00003,0.00004zm0.043,1.0174zm101.31-5.9736c-0.18613,2.39053-4.82344,0.59472-6.77936,1.37442-31.5046,1.65513-63.0113,3.28334-94.5322,4.5991,0.35876-2.32098,5.10517-0.60957,7.21342-1.32617,31.3754-1.35332,62.7371-3.00314,94.0982-4.64735zm-0.0525,0zm101.33,4.9549c-0.21954,2.38729-4.8924,0.12992-6.82256,0.72972-31.5125-1.35806-63.0114-3.00913-94.5093-4.66704,0.56932-2.27695,5.12619-0.12692,7.28702-0.63649,31.3277,1.64549,62.7732,3.26971,94.0449,4.57381zm0,1.0198zm0.001,0zm0.45242-0.28262z'/%3E %3Cpath d='m583.45,264.21c3.2719-6.6002,6.7086-13.075,11.297-18.682-11.747,8.7421-17.928,7.4228-18.788-3.9591-0.69592-0.24775-1.6377-0.24775-2.5784-0.24775-8.9635,13.98-17.683,12.042-26.156-5.8148-11.543,18.351-21.448,18.022-29.225-1.1137-13.313,16.726-24.528,16.772-33.646,0.35359l-0.001-2.0854c0.50732,0.2261,0.16233,0.29826-1.0338,0.13229l-0.19337-0.38004c-0.35573,0.071-0.6828,0.13349-0.98242,0.18881-0.29961-0.0553-0.62789-0.11785-0.98241-0.18881l-0.19338,0.38004c-1.1973,0.16597-1.5422,0.0937-1.0349-0.13229v2.0866c-9.1174,16.417-20.333,16.372-33.646-0.35478-7.7769,19.135-17.683,19.465-29.226,1.1137-8.4717,17.857-17.192,19.794-26.155,5.8148-0.94064-0.001-1.8825,0-2.5796,0.24775-0.85827,11.382-7.0392,12.701-18.786,3.9591,4.5874,5.6068,8.0252,12.082,11.297,18.682,33.848-1.4131,67.579-3.181,101.31-4.9561,33.728,1.7751,67.457,3.543,101.31,4.9561h0.001z' fill='%23edb92e'/%3E %3Cpolygon points='504.63,277.31,482.13,288.56,459.63,277.31,482.13,266.06' transform='matrix(1.0106622,0,0,1.0182434,-5.1283744,-6.1909008)' fill='%23EDB92E'/%3E %3Cg%3E %3Cpath fill='%23edb92e' d='m473.89,259.19-0.006,0.17559c-17.488,0.78174-48.477,2.522-93.121,5.3662l6.5343,31.051c29.651-0.83704,64.257-2.1383,94.845-3.0632,30.588,0.92484,65.195,2.2261,94.846,3.0632l6.5343-31.051c-44.64-2.86-75.63-4.6-93.12-5.38l-0.006-0.17679c1.7667-0.34755-0.97524-0.40769-8.2532-0.15633-7.278-0.25257-10.018-0.19122-8.2508,0.15633h-0.001z'/%3E %3Cpath fill='%23edb92e' d='m597.33,236.74-3.6837-0.61936c-7.075,17.39-13.417,17.812-14.611,1.27,1.5816-0.56885,0.95733-3.335,2.7491-2.2285,0.93943,0.57848,2.1308-1.0692,1.3536-1.9772-2.0054-1.4817-3.7876-1.252-5.5411,0.39808-0.82484-2.641-2.8506-3.8725-5.3752-2.7601-1.0898,0.48106-0.71621,2.4582,0.3784,2.3452,1.7679-0.18401,1.0576,1.6657,1.6079,2.902-12.548,16.482-18.963,14.52-17.4-7.1245-2.9878-0.61936-6.4662-1.2375-9.577-2.3512-11.548,23.346-19.765,24.349-26.418,3.3987,1.4253-1.068,1.0194-3.7511,3.1024-2.8888,1.1734,0.48587,2.1594-1.5995,1.1102-2.4895-2.4316-2.0613-5.0708-1.365-6.8387,1.2844-1.4193-2.8539-3.9488-3.8834-6.619-2.1491-1.1531,0.74804-0.43809,2.9429,0.78665,2.611,2.3528-0.63621,1.2964,2.4738,3.0762,3.5406-5.1007,19.695-30.867,21.02-26.65-8.1311-2.3647,0.0794-4.5014,0.15995-6.6298,0.23933-2.1296-0.0795-4.2663-0.15995-6.6322-0.23933,4.2173,29.151-21.55,27.826-26.649,8.1311,1.7786-1.0668,0.72218-4.1756,3.075-3.5406,1.2247,0.33193,1.9409-1.8629,0.78782-2.611-2.6715-1.7342-5.1997-0.70476-6.619,2.1491-1.769-2.6494-4.4083-3.3458-6.8387-1.2844-1.0504,0.88996-0.0645,2.9754,1.1101,2.4895,2.0818-0.86229,1.676,1.8208,3.1012,2.8888-6.6525,20.95-14.869,19.947-26.416-3.3987-3.1108,1.1136-6.5904,1.7318-9.5782,2.3512,1.5626,21.644-4.8512,23.607-17.4,7.1245,0.5503-1.2363-0.15875-3.086,1.6079-2.902,1.0946,0.11304,1.4694-1.8653,0.3796-2.3452-2.5259-1.1137-4.5504,0.11906-5.3752,2.7601-1.7535-1.65-3.5369-1.8785-5.5423-0.39808-0.77709,0.908,0.41542,2.5556,1.3536,1.9772,1.7929-1.1064,1.1674,1.6597,2.7491,2.2285-1.1925,16.542-7.5358,16.12-14.61-1.27l-3.6837,0.61936c-0.1134,4.0866,1.3059,8.4342,3.8067,11.63,10.608,13.554,18.499,10.479,18.788-4.7012,13.89,16.392,24.394,14.319,26.278-2.9705,11.685,21.809,30.433,11.372,30.821-1.8557,5.146,19.226,33.665,19.091,35.489-3.0066,1.8228,22.096,30.34,22.232,35.487,3.0066,0.38795,13.227,19.136,23.665,30.821,1.8557,1.8836,17.289,12.388,19.363,26.278,2.9705,0.28769,15.18,8.178,18.255,18.788,4.7012,2.4996-3.1942,3.9201-7.543,3.8067-11.63h-0.002z'/%3E %3Cpath fill='%2321231e' d='m593.72,235.62c4.42035,0.0529,4.09659,2.47992-0.16711,1.00541-0.24039-0.55867-0.74483-0.76636,0.16711-1.00541zm-0.55148,0.30909zm-14.312,0.98376c1.16449,0.80019,0.75643,3.84363,1.44574,6.24637,0.44281,2.39292,1.81934,7.19081,5.10289,5.32393,3.94972-3.12497,5.7706-8.0871,7.76379-12.5545,1.99124,1.0586-1.31141,4.28763-1.69505,6.15516-1.90284,3.11051-4.05796,8.35163-8.46091,7.75936-4.07546-2.50461-3.88959-8.1876-4.49068-12.4138l0.25373-0.39259,0.0805-0.12454v0.00057zm-0.33422,0.51714zm3.5166-2.6999c-0.23535,1.18205-1.37813,0.21489-1.45473,1.61274-0.0853,1.41247-2.39737,1.81681-1.40024,0.36786,0.74771-1.00213,1.07014-3.22892,2.85497-1.9806zm0.79018-1.1317c1.39325-2.16743,1.4084,2.38339-0.43779,2.18026-1.68696-0.0134-0.0348-0.99845,0.42268-1.59091,0.19229-0.13451-0.11764-0.8219,0.0151-0.58935zm0.59923-0.8226zm-6.323,0.96212c0.83333-0.13234,0.38212-1.6633,2.72043-1.97821,1.17208-0.2798,4.42981,0.43022,3.00334,1.83897-1.41394-1.3028-3.66527-1.07437-4.89654,0.35919l-0.45173-0.12018-0.3755-0.0999v0.00013zm0.82723,0.22008zm-5.5173-2.6663c-1.10113-1.94135,3.00183-1.62888,3.93323-0.56399,1.47105,0.51458,2.0684,4.23919,0.51457,2.35959-0.66798-1.83311-2.68078-2.72664-4.4478-1.7956zm0.12296,1.3722c0.49138,2.55158-2.61806-0.5429-1.21772-1.70331,0.92324-1.27327,1.10805,0.4049,0.76102,1.16989,0.0389,0.22812,0.18514,0.56135,0.4567,0.53342zm2.0615,3.7186c-1.13998-0.33671-1.03714-0.339-1.21378-1.9976,0.0869-0.91014-1.56601-0.90876-0.65384-1.73452,2.00859-0.11834,1.68723,2.44935,1.86762,3.73212zm0.0609-0.51833zm-17.964-6.4173c1.04706-2.14916,0.19517,4.21701,0.38105,5.54021,0.26715,3.80995-0.2516,8.9339,3.30869,11.3438,4.47689,0.55328,7.55438-3.97647,10.3697-6.8032,0.86954-1.79634,5.2322-5.59717,2.69668-1.66852-3.4853,3.86519-7.02787,9.44546-12.7512,9.6081-4.65413-1.61747-4.34631-7.71439-4.62884-11.7784,0.20662-1.36132-0.39676-7.09256,0.62388-6.24209zm0.20293-0.99821zm-9.2261-1.6248c-1.97345-1.45633,2.81352,0.35091,3.88548,0.49541,1.58037,0.68088,4.56327,0.35935,5.24746,1.58708-0.86854,1.12176-3.59656-0.52247-5.17107-0.52308-0.75062-0.32725-5.48367-1.02535-3.96187-1.55941zm-0.90483-0.45459zm-26.267,3.2171c1.43621,0.48473,1.67472,3.74145,2.86863,5.95494,1.73695,3.82972,4.34092,9.73853,9.4897,8.7066,6.46687-2.86337,9.49052-9.96879,12.8395-15.7643,2.04472-4.36295,1.87416,0.23332,0.0233,2.12412-3.32088,5.54051-6.48027,12.5373-13.0484,14.7154-5.8784,0.76848-8.68815-5.79593-10.5951-10.2536-0.46518-1.7455-1.84757-3.70414-1.57769-5.48321zm-0.17906,0.56404zm3.7757-3.5153c-0.28562,1.11307-1.89302,0.73119-1.97294,2.40994-0.26968,1.76224-2.3634,1.04814-1.04793-0.1732,0.53218-1.28237,1.24182-3.1327,3.02087-2.23674zm0.59208-1.6284c1.53383-2.08556,1.80574,2.6853-0.15308,2.65302-1.59974,0.0775-0.13414-1.01715,0.33222-1.57458,0.135-0.35201,0.1353-0.8206-0.17914-1.07844zm-6.9652,1.1233c0.59863-0.2418,0.55796-2.35872,3.02125-2.99938,1.38406-0.60916,4.46706,0.0855,4.29584,1.45571-0.85556,0.72177-2.39721-1.38554-3.78255-0.54881-1.58898,0.12001-2.08177,2.39643-3.53454,2.09248zm0.87259,0.0553zm-6.7659-2.0048c-1.51989-1.62577,2.34198-2.01658,3.42371-1.63211,1.34497,0.33514,4.31386,2.68693,2.54009,3.5459-1.04631-2.17041-3.7058-3.65923-5.9638-1.91379zm0.38198,1.6909c0.89366,2.27048-2.41443,0.24126-1.73476-1.16446-0.13078-1.62648,1.89793-1.29375,1.034-0.0613-0.11278,0.44842,0.0985,1.32368,0.70076,1.22572zm3.6969,4.1612c-1.09755,0.41176-1.66777-0.25075-2.20698-2.07939,0.0966-1.47169-1.62615-0.81171-1.49028-2.08174,2.75889-0.77621,2.22201,2.95428,3.69726,4.16113zm-0.23039-0.56645zm-26.893-7.1846c0.70054-2.21881-0.0356,4.12807,0.0428,5.55076-0.31094,6.59403,2.67729,15.2506,10.3023,15.8513,7.93822,0.47477,14.0898-6.72709,15.799-13.9082,2.11226,0.9697-1.03572,4.79975-1.7058,6.62573-3.65534,6.67077-13.2265,11.3076-19.8765,6.06713-5.97109-4.98168-6.0368-13.6799-5.07894-20.7688l0.31038,0.34953,0.2065,0.23255,0.00019-0.00003zm-0.0335-1.0174zm-6.6322,1.2568c-0.43299-1.96683,2.45398-0.70454,3.63958-1.1474,1.06516-0.15604,4.19908-0.27263,2.58682,0.9304-2.07561,0.0679-4.15097,0.14508-6.2264,0.217zm0.0382,0zm-6.1511-0.8214c-2.37288-0.0858,1.53868-0.67901,2.51035-0.33436,1.19816,0.38358,4.00588-0.72539,3.60257,1.1474-2.20983-0.0798-4.41966-0.15955-6.62978-0.231l0.31037-0.34954,0.20649-0.23254v0.00004zm-1.0003,0.14672zm-26.408,7.62c1.32812,0.61093,1.58193,3.93667,3.11235,6.05203,3.29761,6.35393,12.302,11.0914,18.6298,6.12001,5.61917-4.8039,5.55221-13.054,4.66592-19.7922,2.31595,0.081,1.01905,4.8802,1.4448,6.89443,0.13978,6.85334-3.40948,15.3774-11.1777,15.9536-8.44274,0.57476-15.0885-7.0012-16.9056-14.6615l0.17611-0.433,0.0543-0.13345,0.00002-0.00003zm-0.23038,0.56645zm3.6957-4.1612c0.17186,1.35151-1.60823,0.56743-1.49135,2.08506,0.0702,1.23372-1.98714,3.35454-1.74869,1.34333,1.12205-1.20159,0.7023-4.22121,3.24004-3.42839zm0.38317-1.6909c1.257-2.26578,2.12993,2.43562,0.18168,2.64947-1.5772,0.28534-0.26066-0.99056,0.13109-1.60207,0.0893-0.36811,0.0276-0.8267-0.31277-1.0474zm-6.7647,2.0048c0.56002-0.31749,0.25863-2.41144,2.61658-3.36142,1.29405-0.77958,4.4397-0.48861,4.44325,0.89445-0.75592,0.82473-2.55305-1.06666-3.82015-0.0612-1.55975,0.32466-1.76128,2.64329-3.23968,2.52821zm0.87139-0.0553zm-6.9652-1.1233c-1.60139-1.48335,2.21402-2.38904,3.44381-2.01373,1.29245,0.26808,4.46434,2.19182,2.65,3.19183-1.19948-2.20484-4.20839-3.10711-6.09381-1.1781zm0.59207,1.6284c1.17474,2.13851-2.36964,0.5493-1.86635-0.93336-0.33757-1.59676,1.71914-1.52398,1.01696-0.19253-0.0575,0.45817,0.26762,1.30226,0.84939,1.12589zm3.7745,3.5153c-1.12885,0.24263-1.39578-0.15952-2.12358-1.84607-0.0726-1.27557-2.18026-0.53676-1.43-1.7523,2.27211-0.7746,2.52113,2.39996,3.55358,3.59837zm-0.17905-0.56404zm-26.549-2.5099c-0.20613-2.40415,2.31228,3.55091,3.08216,4.61773,3.02653,4.83326,5.94433,11.0441,11.8558,12.7077,5.32028,0.005,7.46122-6.07353,9.2715-10.1591,0.18743-2.16352,3.16509-6.73035,1.88717-2.18019-2.02789,5.03619-3.99282,11.9749-9.99368,13.3448-6.13222-0.0317-9.50612-6.3623-12.5266-10.8386-1.51372-2.51789-2.88962-5.11547-4.1982-7.745l0.4331,0.17588,0.18881,0.0767-0.00006,0.00012zm-0.33901-0.95972zm-8.905,2.7938c-2.44392-0.25038,2.49295-1.10568,3.52018-1.31458,1.796-0.0615,4.29113-1.68992,5.54045-1.0382-0.22903,1.46978-3.54391,1.31649-5.0188,1.96674-0.80026-0.0462-5.11995,1.56276-4.04183,0.38604zm-1.0075,0.0746zm-17.359,6.8792c1.62514-0.26637,2.7218,2.82629,4.52032,4.36682,2.64721,2.61004,5.60126,6.6892,9.75499,6.09987,3.67356-2.52608,3.03684-7.87318,3.3113-11.8113-0.22927-1.58273-0.29613-8.21137,0.86711-4.2096,0.0282,5.38671,0.95481,11.7155-2.62549,16.224-3.98436,2.8873-8.25184-1.74594-10.9447-4.40679-1.64525-1.98437-3.90449-3.92324-4.88351-6.26307zm0.0609,0.51834zm2.0603-3.7186c0.0573,1.1083-1.30725,1.27342-0.95683,2.74358-0.0238,1.5391-1.66221,0.42631-0.94422-0.64333-0.01-1.14564,0.53696-2.34128,1.90105-2.10025zm0.12535-1.3722c0.78758-2.41774,2.29117,1.77206,0.51715,2.2416-1.53929,0.46951-0.16203-1.02224-0.1798-1.7495-0.0267-0.20498-0.14395-0.40762-0.33735-0.4921zm-5.5173,2.6663c0.51763-0.48894-0.29603-2.04707,1.76661-3.36862,1.00522-0.93845,4.80223-1.15124,3.75059,0.70239-1.95742-1.12537-4.29065,0.37605-4.68992,2.44632l-0.45173,0.12018-0.3755,0.0999-0.00005-0.00016zm0.82723-0.22008zm-5.6414-0.21768c-1.86926-1.14879,1.8532-2.10338,2.91983-1.76082,1.25511-0.0716,3.58554,2.13489,1.58641,1.92408-1.23885-1.35616-3.52774-1.08766-4.50624-0.16326zm-0.76636-0.66627zm1.473,1.8761c1.44185,2.18869-2.71479,0.50151-1.81331-1.1762,0.56143-1.47218,1.03191,0.29238,1.25545,0.99342,0.13426,0.14069,0.36212,0.31005,0.55786,0.18278zm3.5166,2.6999c-1.01377,0.43418-1.39273,0.35279-2.16799-1.34341-0.0205-1.11221-1.69813-0.36509-1.15854-1.46471,2.08909-1.07409,2.00031,2.07091,3.32653,2.80812zm-0.33423-0.51714zm-14.696-0.28743c0.12316-2.41599,1.94674,3.46092,2.756,4.55326,1.75343,2.89042,3.345,7.20687,7.08959,7.78886,3.70041-1.83945,3.45901-7.02126,4.0898-10.5885,1.42518-3.13202,0.95656,2.87974,0.45967,4.22111-0.48788,3.05305-2.05363,8.6329-6.19197,7.0685-4.64909-2.95496-6.5632-8.55575-8.75457-13.3517l0.40777,0.22853,0.14372,0.0805-0.00001-0.00056zm-0.16713-1.0054zm-3.6837,0.61938c4.197-1.39605,4.67574,1.00496,0.16713,1.00539-0.45609-0.44178-0.9044-0.47541-0.16713-1.00539zm-0.42138,0.48826zm4.7091,11.329c-1.96327,1.27455-2.90857-3.47938-3.76133-5.00663-0.27102-1.81139-2.18384-6.03476,0.0623-6.29353-0.0867,4.03391,1.22986,8.10515,3.69903,11.3002zm18.774-4.7168c-0.57942,0.10382,0.61202,3.22996-0.34136,5.53456-0.41833,4.36839-3.7059,10.0567-8.85811,8.34339-4.3935-1.40679-7.54471-5.06691-10.3699-8.53102,1.93398-1.14164,3.2716,3.40997,5.27529,4.26152,2.70567,2.83653,8.32834,5.52335,10.9866,1.20459,1.98402-3.09737,2.28728-6.90811,2.41702-10.4918,0.29468-0.10875,0.596-0.21234,0.89052-0.32122zm-0.89051,0.32112zm27.229-3.2027c-0.73331-0.12534,0.33883,3.13873-0.82706,5.27183-0.93273,5.15528-5.2038,10.8982-11.0872,9.49409-6.34385-1.49385-11.0351-6.51575-15.1934-11.2231,1.9628-1.14876,3.54231,3.4401,5.56848,4.39539,3.94613,3.58897,9.94985,8.1238,15.3223,4.74722,3.75514-2.95948,4.69246-8.01621,5.26898-12.499,0.31596-0.0615,0.63199-0.12502,0.94794-0.18638zm-0.94779,0.18641zm31.812-1.9327c-0.84669-0.52848,0.50928,3.5402-1.15529,5.51589-2.98148,8.14953-13.6758,12.3997-21.1058,7.4451-4.19781-2.47528-7.19615-6.51667-9.4933-10.7315,2.12416-0.79947,2.70082,3.92604,4.59525,5.10187,4.29725,5.96091,13.1602,9.09795,19.5534,4.5251,3.8924-2.57725,6.47361-7.05924,6.61303-11.7403,0.32679-0.0368,0.66793-0.0804,0.99272-0.11622zm35.504-2.9164c-0.90424-0.77737,0.36918,3.46903-1.06527,5.39795-2.69462,9.73313-14.4084,14.6829-23.5415,10.9869-5.84185-2.07991-10.3483-7.2207-11.8736-13.2039,2.22138-0.25699,1.89244,4.47389,3.82698,5.8678,6.19346,9.31131,21.6996,10.2443,28.2285,0.82498,2.06414-2.87919,3.11581-6.36922,3.41754-9.8737,0.33495-0.00018,0.6729,0.00023,1.00738-0.00005zm35.489,3.0331c-0.75342-0.71764-0.24281,3.50227-2.09139,5.16766-5.62112,10.4033-21.738,12.7611-29.632,3.70293-2.92746-3.22499-4.41496-7.52579-4.77259-11.8196,2.22471,0.10134,0.9645,4.60047,2.50861,6.29088,3.52246,9.7114,16.4886,12.9971,24.8557,7.55166,4.05827-2.38237,6.94259-6.49016,8.13852-11.0105,0.32986,0.0401,0.66388,0.0764,0.99316,0.11699zm30.819,1.816c-0.54989-0.32762-1.23663,3.57341-3.19459,5.19045-4.33233,6.41781-13.3332,10.4515-20.511,6.22031-4.74301-2.60335-7.96751-7.77589-8.12305-13.1954,2.14039,0.16506,0.89799,4.47479,2.60736,6.06324,3.34776,7.34735,13.4726,10.3682,20.0217,5.34536,3.58161-2.45008,6.20248-6.03662,8.252-9.8099,0.30976,0.0572,0.63915,0.12986,0.94761,0.18596zm-0.9478-0.18641zm27.229,3.2027c-0.51158-0.28961-1.64251,2.90211-3.68846,4.219-4.35725,4.22474-10.7264,9.59-17.1234,6.58686-4.65967-2.81898-5.84285-8.70313-6.4746-13.7112,2.19962-0.0282,0.99442,4.31765,2.23232,6.0091,1.02326,4.61216,5.46691,9.11091,10.4901,7.2379,5.63925-1.82898,9.86418-6.32847,13.6737-10.6627,0.28963,0.10251,0.60132,0.21884,0.89039,0.321zm-0.8905-0.32112zm18.774,4.7168c1.60676,1.56163-2.43073,3.74637-3.43954,5.31196-3.05784,3.26303-9.19855,6.30987-12.5548,1.79695-2.38869-3.29927-2.75905-7.5404-2.90203-11.4853,2.23841,0.24724,0.59693,4.65726,1.78659,6.54217,0.48279,3.71764,4.00989,7.78983,8.01076,5.766,3.77153-1.58309,6.58208-4.82473,9.09901-7.9318zm4.2042-10.805c0.70765-2.33588,0.5336,3.82891-0.20641,5.02472-0.74717,2.03623-1.76648,5.65421-3.569,6.11975-0.33663-1.58141,2.34622-3.86732,2.48751-6.03075,0.86539-1.03182,0.32423-6.14787,1.2879-5.11372zm0-1.0198zm-0.002,0zm0,1.0198z'/%3E %3Cpath fill='%23edb92e' d='m482.14,262.87c-33.9831-0.007-67.9688,1.70838-101.771,5.21779-7.82824-0.16357-1.90797-8.28401,3.26332-6.28889,66.8828-6.63062,134.465-6.58824,201.306,0.49558,7.55519,3.0911-1.5647,8.07021-5.92354,5.29755-32.186-3.177-64.531-4.729-96.874-4.723z'/%3E %3Cpath fill='%230c4076' d='m482.14,105.07c9.4827,0,17.169,7.7439,17.169,17.298,0,9.5527-7.6862,17.298-17.169,17.298-9.4815,0-17.168-7.7439-17.168-17.298,0-9.5538,7.6862-17.298,17.168-17.298z'/%3E %3Cpath fill='%23edb92e' d='m485.26,84.894c1.6783-0.0457,3.026-1.4312,3.026-3.1329,0-1.7042-1.3501-3.0908-3.0308-3.1341-0.009-1.7234-1.3978-3.1173-3.1108-3.1173-1.7118,0-3.1012,1.3951-3.1108,3.1185-1.6795,0.0433-3.0308,1.4287-3.0308,3.1329,0,1.7017,1.3489,3.0872,3.0272,3.1329v6.4246h-5.491c-0.009-1.7222-1.399-3.1161-3.1108-3.1161-1.6903,0-3.0678,1.3614-3.1108,3.0547-1.7094,0.0084-3.0941,1.4083-3.0941,3.1329,0,1.7258,1.3847,3.1257,3.0953,3.1341,0.0429,1.6933,1.4181,3.0547,3.1096,3.0547,1.6664,0,3.0284-1.3229,3.1072-2.9826h5.4934v21.372h6.2311v-21.372h5.4934c0.0787,1.6597,1.4408,2.9826,3.1072,2.9826,1.6915,0,3.0678-1.3614,3.1096-3.0547,1.7106-0.0081,3.0953-1.4083,3.0953-3.1341,0-1.7246-1.3847-3.1245-3.0941-3.1329-0.0429-1.6933-1.4205-3.0547-3.1108-3.0547-1.7118,0-3.1,1.3939-3.1108,3.1161h-5.4898v-6.425z'/%3E %3Cpath fill='%2321231e' d='m487.78,81.761c0.7837-0.16044,1.26563,0.07068,0.9022,0.89596-0.36456,1.53642-1.82464,2.72958-3.40929,2.74556-0.057-0.611939-0.15181-1.17534,0.60993-1.1148,1.10578-0.301495,1.91536-1.38304,1.89716-2.52672zm-3.0308-3.1317c0.94669,0.142646,0.96875-0.121972,0.63462-0.505077,1.86638,0.0622,3.45234,1.7768,3.40875,3.63665-0.62011,0.04608-1.17173,0.114767-1.0901-0.64583-0.26241-1.10836-1.31638-1.96858-2.45928-1.97958-0.16476-0.168414-0.32874-0.33922-0.49399-0.50616zm0.49299,0.50632zm-3.0976-3.1161c-0.15909-0.783964,0.0692-1.27979,0.89887-0.90556,1.56416,0.378377,2.73567,1.90441,2.71793,3.51051-0.62448,0.05264-1.17312,0.115346-1.0972-0.64824-0.27748-1.12544-1.35782-1.97534-2.5196-1.95671zm-3.0976,3.1173c0.12042-0.948408-0.14006-0.974066-0.5156-0.626595,0.0207-1.88802,1.72006-3.55425,3.61309-3.51044,0.0464,0.624875,0.11389,1.17794-0.65056,1.10266-1.12525,0.273241-1.96806,1.37202-1.95393,2.52794-0.16431,0.16882-0.3288,0.337559-0.493,0.50643zm0.49299-0.50632zm-3.0308,3.1305c-0.78465,0.161986-1.26782-0.07359-0.8998-0.89838,0.36214-1.53828,1.82736-2.72821,3.41157-2.74311,0.0566,0.611558,0.15234,1.1762-0.60994,1.11361-1.10807,0.299629-1.91986,1.383-1.90183,2.52788zm3.0272,3.1329c-0.94799-0.146838-0.96823,0.117145-0.63463,0.502677-1.86421-0.06475-3.44748-1.77758-3.40496-3.63548,0.61924-0.04556,1.17156-0.115451,1.09,0.64462,0.26095,1.10785,1.31461,1.96545,2.45536,1.97954,0.16487,0.169199,0.32874,0.341051,0.49423,0.50864zm-0.493-0.50872zm-0.51926,6.9333v-6.4246c0.97884-0.256192,1.16489,0.280405,1.0122,1.15574v5.26886c-0.49465,0.584918-0.51113,0.593664-1.0122,0zm1.0122,0zm-5.9971-0.50992h5.491c0.2532,0.978382-0.27444,1.17592-1.15574,1.0198h-4.33526c-0.58405-0.495349-0.58531-0.515742,0-1.0198zm0,1.0198zm-3.1108-3.1161c-0.1592-0.784278,0.0694-1.27929,0.89886-0.90555,1.56364,0.379439,2.73513,1.90307,2.71793,3.50933-0.62169,0.0511-1.17449,0.117609-1.096-0.64583-0.27902-1.12697-1.35618-1.9759-2.52079-1.95795zm-3.1084,3.0547c0.13909-0.945162-0.11803-0.979858-0.50187-0.638544,0.0575-1.86092,1.74409-3.47743,3.60955-3.43597,0.0411,0.615795,0.1215,1.17909-0.63983,1.09906-1.11138,0.268071-1.95515,1.33656-1.96564,2.47866-0.16721,0.165544-0.33599,0.331495-0.50221,0.49679zm0.50255-0.4967zm-3.0929,3.1197c-0.7906,0.164948-1.26656-0.07936-0.8985-0.90559,0.37152-1.56023,1.87604-2.75524,3.48427-2.73718,0.048,0.621654,0.12201,1.17986-0.64318,1.10518-1.12895,0.281464-1.95963,1.37925-1.94259,2.53759zm3.0941,3.1209c-0.94977-0.123293-0.96313,0.143905-0.62286,0.519376-1.8946-0.02318-3.52935-1.7531-3.48356-3.6402,0.62877-0.05113,1.16988-0.107573,1.0936,0.65544,0.26665,1.12322,1.35153,1.9838,2.5092,1.9691,0.16795,0.165007,0.33525,0.333295,0.50362,0.49628zm-0.50256-0.49669zm3.1072,3.0547c0.15625,0.77861-0.0637,1.28014-0.89168,0.9064-1.54161-0.37051-2.70955-1.85496-2.72223-3.43818,0.61539-0.06206,1.16954-0.145841,1.1051,0.61574,0.29471,1.10535,1.3627,1.93396,2.50881,1.91604zm3.1072-2.9826c-0.1444,0.937675,0.11335,0.983985,0.49733,0.649243-0.10199,1.82837-1.76834,3.3931-3.60434,3.35319-0.0373-0.60859-0.12676-1.18124,0.63266-1.09638,1.09284-0.262224,1.93395-1.29665,1.96944-2.41973,0.1682-0.162147,0.33731-0.323942,0.50491-0.48632zm-0.50493,0.48586zm5.9983,0.53398h-5.4934c-0.2532-0.978382,0.27444-1.17592,1.15574-1.0198h4.33766c0.58018,0.496093,0.58837,0.517498,0,1.0198zm0-1.0198zm-0.50613,21.882v-21.372c0.97884-0.256192,1.16489,0.280405,1.0122,1.15574v20.2163c-0.49465,0.5849-0.51114,0.59368-1.0122,0zm0.50613,0.50992zm6.2311,0h-6.2311c-0.2532-0.97838,0.27444-1.17592,1.15574-1.0198h5.07536c0.58015,0.49611,0.58841,0.51743,0,1.0198zm0.50613-0.50992zm0-21.372v21.372c-0.97884,0.25619-1.16489-0.28041-1.0122-1.15574v-20.2163c0.49465-0.584928,0.51113-0.593674,1.0122,0zm-1.0122,0zm5.9995,0.50993h-5.4934c-0.2532-0.978382,0.27444-1.17592,1.15574-1.0198h4.33766c0.61835,0.487793,0.5559,0.501114,0,1.0198zm0-1.0198zm3.1072,2.9826c0.15008,0.76847-0.0521,1.2802-0.87857,0.9113-1.51829-0.36347-2.6837-1.80117-2.73348-3.36023,0.6053-0.06892,1.16477-0.17869,1.1171,0.57962,0.30795,1.0835,1.36621,1.88568,2.49495,1.86931zm3.1072-3.0547c-0.13912,0.945169,0.11808,0.979856,0.50183,0.638532-0.0561,1.86123-1.74247,3.47778-3.60811,3.43622-0.0415-0.61709-0.12087-1.17873,0.64102-1.09812,1.11124-0.268671,1.95323-1.33677,1.96299-2.47871,0.16702-0.166085,0.33719-0.331264,0.50227-0.49792zm-0.50255,0.49669zm3.0941-3.1209c0.7902-0.164836,1.26715,0.07919,0.8986,0.90559-0.37074,1.56126-1.87663,2.75658-3.48547,2.73837-0.0481-0.621389-0.12176-1.18018,0.64318-1.10556,1.12929-0.280684,1.96194-1.38008,1.94369-2.5384zm-3.0929-3.1197c0.94976,0.123278,0.96313-0.143824,0.62287-0.519394,1.89385,0.02362,3.52751,1.75279,3.48256,3.63904-0.62841,0.05103-1.17033,0.107695-1.0935-0.65544-0.26712-1.12206-1.35102-1.983-2.50801-1.9675-0.16811-0.165235-0.33515-0.333059-0.50392-0.49671zm0.50255,0.49669zm-3.1084-3.0547c-0.15563-0.777035,0.0626-1.2813,0.89049-0.90677,1.54197,0.37019,2.71156,1.85469,2.72482,3.43835-0.61464,0.06147-1.16922,0.146536-1.1051-0.61456-0.29518-1.10572-1.36093-1.93435-2.51021-1.91702zm-3.1108,3.1161c0.14266-0.954848-0.11272-0.975006-0.50238-0.628993,0.0227-1.88704,1.72124-3.55084,3.61337-3.50689,0.0464,0.624866,0.11389,1.17795-0.65056,1.10265-1.12497,0.2722-1.96838,1.37138-1.95434,2.52674-0.16864,0.168848-0.33771,0.337562-0.50609,0.50649zm0.50612-0.50632zm-5.9959-0.51353h5.4898c0.2532,0.978382-0.27444,1.17592-1.15574,1.0198h-4.33406c-0.58016-0.496109-0.58839-0.517424,0-1.0198zm0,1.0198zm0.50613-6.9345v6.4246c-0.97884,0.256192-1.16489-0.280405-1.0122-1.15574v-5.26886c0.49033-0.605226,0.50188-0.57543,1.0122,0zm-1.0122,0zm0.50613,0zm-0.50613,0z'/%3E %3Cpath fill='%2321231e' d='m499.82,122.37c-0.69799,0.0953-1.26389,0.0552-1.03216-0.80265-0.22012-5.9866-3.92922-11.6752-9.3245-14.2818-2.26582-1.12113-4.79136-1.70106-7.31839-1.70339-0.0929-0.70294-0.0585-1.2752,0.80262-0.99859,6.27187,0.21967,12.2044,4.12271,14.9662,9.745,1.2599,2.48109,1.89891,5.26157,1.90625,8.04138zm-17.675,17.808c-0.0929-0.69814-0.0585-1.27217,0.80264-1.04009,5.94126-0.22531,11.546-3.95665,14.1223-9.30217,1.14747-2.30975,1.73451-4.88799,1.73794-7.46535,0.70284-0.0953,1.2667-0.0552,0.99133,0.80263-0.2145,6.31771-4.09317,12.3356-9.76365,15.1316-2.43547,1.2353-5.16184,1.86656-7.89053,1.87335zm-17.674-17.808c0.69799-0.0953,1.26389-0.0552,1.03216,0.80265,0.22011,5.98653,3.92925,11.6754,9.32449,14.2818,2.26539,1.1212,4.79059,1.70082,7.3172,1.7034,0.0929,0.70294,0.0585,1.2752-0.80262,0.99859-6.27155-0.22-12.2034-4.12305-14.965-9.74499-1.25988-2.48111-1.89892-5.26156-1.90623-8.04141zm17.674-17.808c0.0929,0.69814,0.0585,1.27217-0.80264,1.04009-5.94128,0.22551-11.5449,3.95672-14.1214,9.30198-1.14737,2.30979-1.73419,4.88818-1.73758,7.46552-0.70284,0.0953-1.2667,0.0552-0.99133-0.80263,0.21505-6.31699,4.09124-12.3381,9.76368-15.1316,2.43504-1.23535,5.16098-1.86632,7.8893-1.87334z'/%3E %3Cpath fill='%23edb92e' d='m498.96,118.85c0.23158,1.1353,0.35454,2.3103,0.35454,3.5141,0,0.83103-0.0598,1.6488-0.1731,2.4498-5.6438-0.19723-11.302-0.33072-16.995-0.33072-5.6927,0-11.351,0.13349-16.996,0.33072-0.11341-0.80096-0.17309-1.6188-0.17309-2.4498,0-1.2038,0.12294-2.3788,0.35572-3.5141,5.5841-0.19122,11.183-0.32352,16.813-0.32352,5.6307,0,11.229,0.13229,16.813,0.32352z'/%3E %3Cpath fill='%2321231e' d='m499.82,122.37c-0.30016-0.11009-1.05994,0.2422-1.0132-0.21647-0.012-1.07272-0.12562-2.1443-0.3404-3.19544,0.3157,0.0479,0.99981-0.45709,1.03377,0.0144,0.21552,1.11861,0.32033,2.25957,0.31983,3.39747zm-0.69711,2.9585c-0.0724-0.25491,0.24475-1.31059-0.1847-0.83167-0.39168,0.47095-0.26548-0.004-0.22795-0.33256,0.0594-0.59642,0.0994-1.19536,0.094-1.795,0.28975,0.0998,0.9868-0.2046,1.0112,0.1588-0.005,0.79061-0.0671,1.58084-0.1743,2.364-0.17275,0.14538-0.34548,0.29151-0.51825,0.43643zm0.51806-0.43656c0.25818,0.58161-0.90359,0.56404-0.2426,0.20444,0.0809-0.0682,0.16174-0.13629,0.2426-0.20444zm-17.495,0.10704c0.10952-0.32649-0.26762-1.13963,0.28822-1.0198,5.57628,0.003,11.1517,0.13392,16.7243,0.3298-0.12101,0.32181,0.22776,1.14717-0.32375,1.00752-5.56069-0.19529-11.1249-0.31587-16.6888-0.31752zm-17.496-0.10704c0.23517-0.1171,1.32876,0.0112,0.7799-0.33004-0.66416-0.39181,0.28148-0.22674,0.5924-0.28124,5.37257-0.18235,10.7478-0.3,16.1237-0.2991-0.10952,0.32649,0.26762,1.13963-0.28822,1.0198-5.56468,0.005-11.1287,0.13001-16.6897,0.3272-0.17266-0.14555-0.3455-0.29103-0.51805-0.43662zm0.51806,0.43656c-0.52863,0.35657-0.70757-0.79582-0.24251-0.20444,0.0808,0.0682,0.16189,0.1363,0.24251,0.20444zm-0.697-2.958c0.29086,0.0979,0.9733-0.19896,1.0132,0.1516,0.00058,0.74494,0.067,1.4886,0.1627,2.2269-0.29951-0.0569-0.94304,0.34042-1.0212-0.01-0.1002-0.78519-0.15576-1.57744-0.1547-2.36882zm0.84513-4.0229c0.0944,0.25471-0.16695,1.31112,0.25346,0.83115,0.43002-0.49592,0.13517,0.23189,0.12471,0.50856-0.13999,0.88698-0.21006,1.78514-0.2098,2.68311-0.30327-0.11123-1.08197,0.25027-1.0112-0.23331,0.0188-1.13611,0.1345-2.2712,0.3649-3.38427,0.15887-0.13489,0.32125-0.27123,0.47793-0.40524zm-0.47867,0.40529c-0.0561-0.61333,0.8337-0.4371,0.0937-0.0794l-0.055,0.0466-0.0387,0.0328-0.00002,0.00007zm17.309-0.73001c-0.10952,0.32649,0.26762,1.13963-0.28822,1.0198-5.50414,0.006-11.0076,0.12846-16.5083,0.3192,0.0989-0.32935-0.30517-1.12878,0.25455-1.02735,5.51183-0.18637,11.0276-0.31402,16.5419-0.31165zm17.309,0.73121c-0.23255,0.1366-1.31671,0.0555-0.77108,0.39103,0.60716,0.38732-0.42201,0.14068-0.69717,0.18785-5.27821-0.17646-10.559-0.2857-15.8404-0.28723,0.10952-0.32649-0.26762-1.13963,0.28822-1.0198,5.51534,0.004,11.0298,0.13282,16.5417,0.3221,0.15944,0.13509,0.31982,0.27225,0.47868,0.40605zm-0.47868-0.40649c0.59538-0.15831,0.56814,0.75232,0.0942,0.08l-0.0549-0.0466-0.0393-0.0334-0.00001,0.00003z'/%3E %3Cpath fill='%23edb92e' d='m468.82,133.18c-3.6348-2.2574-4.2698,1.2363-4.1779,4.7493,0.34618,13.234,2.8649,25.827-0.67444,42.031-1.4157,6.4847-3.6969,10.132-1.4742,11.382,5.67,3.187,8.2687,6.1022,7.3687,7.6705,1.676,3.2183,5.8563,2.5965,12.278,1.5646,6.4221,1.0319,10.604,1.6536,12.281-1.5646-0.90125-1.5683,1.6986-4.4835,7.3675-7.6705,2.2238-1.2496-0.0573-4.8972-1.4742-11.382-3.5381-16.205-1.0194-28.797-0.67445-42.031,0.0919-3.5129-0.54194-7.0066-4.1767-4.7493-7.1562,4.445-19.404,4.4955-26.643,0z'/%3E %3Cpath fill='%2321231e' d='m465.15,137.91c-1.13492,0.39435-1.10489-0.45711-1.0059-1.31084,0.0741-1.72415,0.3321-4.27811,2.42455-4.63622,0.90579-0.0879,1.76607,0.31743,2.51989,0.77692-0.31968,1.37213-1.14114,0.3878-2.02702,0.24591-1.57427-0.12729-1.75392,1.89596-1.87295,3.04179-0.0473,0.62629-0.0522,1.2548-0.0386,1.88244zm-0.68518,42.154c-1.49056,0.14927-0.72608-1.14459-0.61519-2.03882,2.10769-10.3489,1.55599-20.9734,0.74386-31.4296-0.19569-2.88366-0.37622-5.76922-0.4525-8.6589,1.42763-0.51187,0.96307,0.96944,1.07474,1.86102,0.53321,11.1562,1.9787,22.3804,0.41763,33.5213-0.28791,2.26452-0.68891,4.51405-1.16854,6.74505zm-1.7225,10.828c-0.24418,1.40216-1.28074,0.5448-1.5363-0.35237-0.4797-2.41277,0.7936-4.72699,1.32894-7.03154,0.35009-1.21112,0.674-2.43034,0.94207-3.66242,1.4748-0.1483,0.7406,1.11274,0.56702,1.98677-0.57116,2.69693-1.88817,5.2662-1.95201,8.04692,0.0398,0.42209,0.26201,0.81769,0.65028,1.01264zm7.5704,7.8786c-1.231,0.98022-0.69309-0.14898-0.89308-0.98728-1.3885-2.62471-4.14433-4.13428-6.57813-5.66227-1.22736-0.39213,0.16316-1.82665,0.85206-0.67925,2.50362,1.59179,5.31919,3.21134,6.66951,5.97232,0.42825,0.39574-0.0547,2.48146-0.0524,1.35794l0.00002-0.001,0.002-0.00011zm-0.89528,0.47385zm12.806,0.82501c0.15434,1.33728-0.52616,1.05384-1.66398,1.26951-3.06792,0.36834-6.4309,1.22195-9.34575-0.21141-0.77385-0.42499-1.39203-1.10269-1.79624-1.88338,0.96526-1.01893,1.19535,0.27865,1.9505,0.77812,2.41126,1.46815,5.38593,0.73772,8.0211,0.46119,0.94624-0.12091,1.8887-0.32408,2.83437-0.41403zm-0.15995,0zm11.923-0.80697c1.11314-1.06205,1.03627,0.22511,0.30156,0.86126-2.01817,2.29356-5.41733,1.84354-8.13508,1.55829-1.36808-0.16802-2.72863-0.39057-4.08966-0.60701-0.23186-1.43768,1.01579-0.8303,1.90275-0.7301,2.83865,0.32523,5.93404,1.15437,8.64506-0.12199,0.66223-0.0395,1.44916-2.01211,1.37428-0.9598l0.001-0.00065zm0.87617-0.50993zm6.6835-7.8605c1.05382,0.97535-0.26305,1.2773-1.00509,1.76909-2.14025,1.42973-4.62336,2.84185-5.72381,5.27844,0.35122,0.74069-0.92909,1.90267-1.04158,0.73193-0.12417-2.19348,1.92805-3.68489,3.43095-4.96056,1.36651-1.05589,2.83668-1.97197,4.33953-2.8189zm-1.7225-10.828c1.25686-0.74767,1.13395,0.66286,1.40021,1.51294,0.59706,2.81863,2.00978,5.50848,1.97749,8.42816,0.016,0.64513-0.95328,2.32826-1.39999,1.3469-0.57038-0.64574,0.79586-1.16624,0.40587-2.05358-0.46751-3.14524-1.79308-6.1065-2.38358-9.23442zm-0.68517-42.154c1.45659-0.43718,0.91058,1.02714,0.94531,1.92363-0.51843,11.0491-1.96313,22.1616-0.44623,33.1977,0.28854,2.28752,0.68857,4.56018,1.17538,6.81363-1.30055,0.76997-1.13178-0.75155-1.36418-1.62023-2.12616-10.4371-1.58231-21.153-0.76265-31.6992,0.19683-2.86901,0.37555-5.74114,0.45237-8.61557zm-3.4068-4.3019c-0.98595-0.83683-0.0366-1.26962,0.81291-1.50932,1.61678-0.68258,3.1457,0.75905,3.33512,2.32222,0.26503,1.15057,0.29609,2.33957,0.2692,3.51535-1.44837,0.43519-0.9023-1.01329-1.0486-1.90866-0.12606-1.14-0.27977-3.12038-1.83262-3.04839-0.55515,0.0743-1.06387,0.34429-1.53601,0.6288zm-27.173,0c0.34904-1.48258,1.34021-0.27401,2.19942,0.0405,6.28023,2.87072,13.6596,3.05873,20.2142,1.02284,1.47551-0.48427,2.90628-1.11632,4.22966-1.9316,1.06356,0.9042-0.12844,1.26861-0.90841,1.67168-6.56178,3.12782-14.3442,3.37712-21.2439,1.24644-1.56848-0.51089-3.085-1.18501-4.49102-2.04984z'/%3E %3C/g%3E %3Cg id='g3987'%3E %3Cpath d='m363.03,212.12c-1.8968-4.1431-0.36646-9.9267,0.25306-11.235,0.31394-0.66267-0.61595-2.1179-1.0194-2.6879-12.907-18.281-13.128-19.903-4.2305-26.753,8.0288-6.1804,26.161-12.19,39.133-16.235,2.7013-2.0625,4.4203-4.8671,6.8757-7.1762-24.928,1.7932-51.946,11.919-65.572,23.754-7.2004,6.2538,1.5554,18.889,12.28,38.106,6.631,4.7842,9.7418,7.0102,12.28,2.2273h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m362.83,200.67c1.42356,0.15756,0.52025,1.20436,0.37718,2.06975-0.70703,2.98973-0.96545,6.28561,0.28622,9.1714-1.1655,1.08438-1.29206-0.62648-1.55226-1.47223-0.67614-3.22372-0.28088-6.70903,0.88886-9.76892zm-0.97525-2.1732c0.70327-0.97529,1.15582-0.30292,1.49075,0.4833,0.32245,0.64097,0.69801,1.4101,0.3959,2.1275-0.66451-0.17858-1.01351-0.44623-1.04137-1.12077-0.21462-0.53043-0.52197-1.02367-0.84528-1.49003zm-4.1254-27.454c1.39475,0.99442-0.63226,1.5257-1.23665,2.27869-2.20407,1.75225-4.72794,4.22169-3.98144,7.32816,1.16243,4.64361,4.24326,8.48251,6.79954,12.4352,1.10994,1.61543,2.23755,3.21862,3.36696,4.82047-1.05118,1.37902-1.51846-0.72115-2.22185-1.39503-3.13688-4.6999-6.7813-9.22107-8.68013-14.6042-1.05887-2.78929,0.0851-5.89819,2.28684-7.77894,1.14088-1.12044,2.40535-2.10506,3.66673-3.08435zm39.134-16.236c1.49486,1.18373-0.90984,1.141-1.7053,1.57016-11.095,3.59176-22.3191,7.13826-32.5998,12.7354-1.45801,0.82839-2.88099,1.72344-4.21543,2.74078-1.3627-0.95927,0.51206-1.47439,1.19767-2.0926,8.34889-5.23365,17.7559-8.43325,27.0105-11.6573,3.47549-1.16871,6.96825-2.28528,10.4686-3.37703l-0.15637,0.0806,0.0002-0.00005zm0.61116,0.81299zm6.6059-7.074c-0.28058-2.02239,0.76279,0.33335-0.56111,0.73125-2.00817,2.11887-3.69971,4.56319-6.04488,6.34278-1.29837-0.89917,0.35048-1.40197,0.91329-2.14217,1.87535-1.84134,3.39174-4.01461,5.31183-5.81336,0.12697,0.29381,0.25383,0.58789,0.38087,0.8815zm-0.0717-1.0174c2.15314-0.95468,0.72445,1.46557,0.14867,0.34418l-0.0774-0.17913-0.0713-0.16505zm-65.206,24.648c-1.48319-0.94729,0.65089-1.62413,1.28245-2.3688,10.3237-7.9504,22.541-13.0547,34.926-16.8412,9.4408-2.81216,19.1685-4.70981,28.9973-5.43829,0.62827,1.65229-1.50406,0.92587-2.45502,1.22836-16.8376,1.68551-33.427,6.37331-48.5195,14.0549-5.03877,2.63385-9.91383,5.64711-14.2312,9.36501zm12.244,37.306c-0.68468,1.76551-1.21177-0.41899-1.73445-1.11723-4.35334-7.95055-9.3681-15.6093-12.6266-24.1044-1.39982-3.78852-2.34836-8.65096,0.59198-11.9784,0.57356-1.52973,2.24856-0.12289,0.8083,0.61154-2.76449,3.11772-1.68286,7.64838-0.39609,11.1688,3.30928,8.49618,8.33567,16.1681,12.694,24.1403,0.0487,0.15342,1.08434,1.80514,0.66286,1.27929zm-0.5897,0.82742zm12.574,1.3037c0.024,1.32186,0.66803,0.75402-0.45426,2.13529-1.34413,1.98531-4.08001,1.80097-5.92365,0.67096-2.19807-1.15762-4.17624-2.67559-6.19647-4.10946,0.5393-1.63338,1.64041,0.16,2.52037,0.55775,2.1717,1.37773,4.32157,3.41814,7.03874,3.38062,1.5537-0.13946,1.96382-1.87755,3.01527-2.63516zm-0.44643,0.26939zm0.44764,0.75045zm0.45957-0.7228z'/%3E %3Cpath d='m359.11,213.58c-0.56223-1.6452-0.96689-3.2315-1.245-4.7192-0.54312-2.7096-0.31036-5.5166,0.59089-8.1516-2.9747-4.2093-6.3123-8.783-8.7211-13.328-1.7201-3.2448-3.0487-6.8575-2.0376-10.558,1.0791-3.9471,4.4943-6.6362,7.58-9.0115,3.6957-2.8455,8.6244-5.3374,13.613-7.466,11.172-4.6338,20.054-6.902,26.563-7.1077l-4.1314,3.8353c-12.112,3.917-26.406,9.0836-33.283,14.379-8.8978,6.8503-8.677,8.4715,4.2305,26.753,0.40227,0.57005,1.3334,2.0253,1.0194,2.6879-0.61954,1.3085-1.7619,7.341,0.13608,11.483-1.1149,2.101-2.73,1.003-4.3164,1.2038h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m357.37,208.96c1.2023-0.69963,1.12019,0.49762,1.32007,1.34677,0.24836,1.04899,0.54912,2.08555,0.8988,3.10523-0.76918,0.50853-1.16351,0.2382-1.26044-0.60011-0.39409-1.26052-0.7216-2.57907-0.95843-3.85189zm0.99077-0.20204zm-0.31634-7.7547c1.07875-1.17627,0.92008,0.1568,0.55133,0.9891-0.5813,2.19952-0.68318,4.53204-0.23487,6.76558-1.18468,0.67074-1.15285-0.50747-1.22367-1.38305-0.2147-2.30362,0.0908-4.64736,0.8412-6.83345,0.022,0.15393,0.0436,0.30834,0.066,0.46182zm0.82366-0.59171zm-9.5794-12.791c0.87844-0.90594,1.20031,0.0102,1.58643,0.78533,2.37674,4.18619,5.21998,8.07918,7.99299,12.0061-0.76071,1.02097-1.20066,0.13008-1.66879-0.60132-2.79759-3.95397-5.6275-7.90822-7.91063-12.1901zm-2.0782-10.933c1.19103-0.0396,0.89352,0.75122,0.71496,1.58149-0.38383,3.12158,0.81923,6.16426,2.25582,8.87076-0.86221,0.88672-1.20217,0.0339-1.52554-0.77211-1.44023-2.97236-2.36859-6.40777-1.44524-9.68014zm7.7602-9.282c1.04219,0.73396,0.1623,1.2091-0.5491,1.71257-2.62612,2.07397-5.31561,4.49701-6.23705,7.83888-1.34898,0.0592-0.81101-0.96892-0.44048-1.76549,1.48584-3.31153,4.42601-5.62575,7.22663-7.78596zm13.728-7.5322c0.86212,1.00293-0.16382,1.20712-0.97566,1.53465-4.24032,1.8885-8.42973,3.99034-12.138,6.80855-1.20061-0.83657,0.13148-1.337,0.84993-1.87494,3.8184-2.62363,8.01992-4.64186,12.2638-6.46826zm-0.005,0.002zm27.103-6.2634c-1.32888-1.56835,0.38817,0.51823-1.09294,0.16827-8.90508,0.63181-17.4107,3.71142-25.6208,7.03566-0.93202-1.10118,0.43228-1.24443,1.24723-1.60797,8.04752-3.15859,16.3998-6.06219,25.1084-6.47978,0.11936,0.29455,0.23884,0.58968,0.35812,0.88382zm-0.35812-0.88394c1.5886-0.4526,1.23185,0.53836,0.29854,0.73698-0.0995-0.24565-0.19913-0.49141-0.29854-0.73698zm-4.4584,3.9688c1.37713-1.2784,2.75427-2.5568,4.1314-3.8352,1.30947,0.7455-0.0897,1.3791-0.70925,2.04492-0.98514,0.86997-1.89227,1.84536-2.92557,2.65024-0.16551-0.28666-0.33114-0.57328-0.49658-0.85996zm0.68518,0.75045zm-33.318,14.409c-1.16761-0.81385,0.0644-1.29942,0.78427-1.8184,7.12743-4.63247,15.1817-7.56198,23.1289-10.45,2.95523-1.04203,5.92686-2.03714,8.90863-3.00047,0.86,1.19955-0.59485,1.20791-1.43331,1.5379-9.45346,3.17549-18.9894,6.39075-27.7122,11.298-1.26795,0.74422-2.50888,1.53904-3.67633,2.43295zm4.3355,26.053c-0.86038,1.19922-1.28983-0.13273-1.82828-0.83539-3.13738-4.63737-6.64997-9.1252-8.79676-14.3368-1.05651-2.43423-0.88904-5.45191,0.96363-7.46369,1.34883-1.63675,3.05246-2.92691,4.71285-4.22796,1.20226,0.83586-0.14084,1.3296-0.80867,1.92874-2.14845,1.75876-4.83828,3.94108-4.49715,7.04186,0.56256,3.79833,2.95381,6.98065,4.92826,10.1686,1.72495,2.60911,3.52573,5.16774,5.32612,7.72468zm1.0636,3.2014c-0.56401-0.21279-1.03822-0.37412-1.01019-1.03526-0.21232-0.56538-0.53662-1.08054-0.8774-1.5762,0.65569-0.8454,1.12171-0.43367,1.43715,0.38461,0.3408,0.66701,0.76607,1.47382,0.45044,2.22685zm0.12653,11.505c-1.11933-0.67925-0.96005,0.251-1.38585-1.30006-0.94363-3.46102-0.80777-7.25066,0.34752-10.6422,1.21691,0.1593,0.71641,0.97351,0.50498,1.79796-0.68562,3.24798-0.67101,6.74308,0.54164,9.84824l-0.005,0.15849-0.004,0.13762,0.00024-0.00001zm0.0131-0.45459zm-4.776,0.908c0.26019,1.86013-0.57906-0.0795,0.4378-0.026,1.19079,0.0553,2.86135,0.5552,3.43228-0.90926,1.14187,0.21124,0.81018,0.97549,0.0919,1.50812-1.10419,0.96509-2.60756,0.34063-3.8986,0.44289-0.0212-0.33857-0.0422-0.67715-0.0634-1.01571zm0.001,1.0198c-0.42824-1.41674,0.94189-0.86456,0,0.00004v-0.00004zm0.47867-0.67589z'/%3E %3Cpath d='m468.14,132.2c0.11221-2.3151-0.0442-1.9242-0.39034,1.6476-0.37242-0.71558-0.86185-1.0439-1.4539-1.0319-1.0469,0.0193-1.6783,1.6152-1.781,5.2195,0.0621,0.92964,0.12534,1.8485,0.1874,2.7601-33.058-0.73482-52.66,4.2838-57.715,13.922-4.16,7.9303,2.9126,21.062,13.584,36.055,1.2904,1.8136,1.2486,1.6597,0.001,3.1546-1.8049,2.1624-3.7494,5.8232-2.2883,9.0391-6.4662,3.5671-14.161,4.433-20.874,1.4853-1.1137-2.9609-3.5321-4.3704-5.4874-5.7126-0.39749-0.27421-1.8359-0.98016-1.9792-1.4408-3.5274-11.349-7.0679-21.843-10.107-31.615-9.5364-30.687,75.242-33.501,88.304-33.483z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m467.31,134.09c1.78922-0.69149-0.88161,0.0861,0.0912-1.71891,0.11624-0.70232-0.008-2.45417,1.09065-1.92664,0.61594,0.77038-0.0119,2.57428-0.83988,1.52908-0.17738-1.41058,0.15052-0.73252,0.95353-0.99088-0.30201,0.92883,0.003,2.34017-0.57547,2.96563-0.23997,0.0471-0.48008,0.0951-0.71999,0.14172zm0.95137-0.18761c0.62386,2.81545-1.74498,0.41371-0.25607,0.0505l0.23176-0.0457,0.0243-0.005v0.00001zm-1.9481-0.57127c-0.33159-0.92098,0.163-1.28221,0.9003-0.8023,0.53025,0.30634,1.50929,1.23464,0.36564,1.41762-0.43274,0.36162-0.61766-0.78747-1.26594-0.61532zm0.001,0zm-1.2868,4.6759c-1.59652,0.63722-0.83712-1.19048-0.86956-2.0725,0.19329-1.36235,0.44029-3.43642,2.13625-3.6227,0.34854,0.91201-0.30936,1.02823-0.6552,1.68545-0.50861,1.23034-0.55567,2.8571-0.61149,4.00975zm-1.0099,0.0673zm0.68161,3.2351c0.38211-1.77344-0.7502,0.25215-0.55308-1.32871,0.11783-0.71544-0.64162-2.19889,0.57712-1.95302,0.64412,0.0236,0.23469,1.25249,0.42678,1.79432,0.0483,0.62931,0.1998,1.07886-0.45082,1.48741zm0.51566-0.54361zm-57.772,14.195c-1.86266-0.46323,0.378-2.12761,0.86845-3.02956,5.18364-5.62506,12.9448-7.71189,20.174-9.27169,11.9207-2.31708,24.1285-2.58551,36.2357-2.36731,0.41142,1.89623-2.20773,0.63942-3.31242,0.96537-13.4237-0.0294-27.1038,0.34789-40.0449,4.26795-5.32664,1.76686-11.0737,4.29553-13.9208,9.43524zm13.547,35.52c-1.22964,1.46994-1.76114-1.2884-2.62336-1.97242-5.11337-7.60866-10.47-15.4342-12.6328-24.4736-0.68217-3.1575-0.71402-6.62271,0.81401-9.55049,1.76843,0.39278-0.18674,2.01309-0.0326,3.18495-0.96835,6.39456,2.12764,12.4933,4.98499,18.0048,2.81555,5.14825,6.0987,10.024,9.48974,14.8067zm-0.0226,3.7799c-1.32461-0.5223-0.21852-1.06931,0.055-1.83515-0.33195-0.79846-1.36343-1.50712-0.0317-1.94443,0.82765,0.88602,1.57023,2.33956,0.39055,3.28672-0.13713,0.16493-0.2763,0.32936-0.41383,0.49286zm-2.4328,9.1582c-0.6025-1.16764-1.05894-0.0375-1.21971-2.13953-0.27472-2.83653,1.12935-5.53909,2.87813-7.6753,1.43804,0.5689,0.02,1.38617-0.35214,2.21288-1.26845,2.01708-2.12979,4.64715-1.08902,6.9429-0.0724,0.21968-0.14482,0.4394-0.21726,0.65905zm0.21725-0.65905zm-21.806,1.8773c1.03469-1.00344,1.51403-0.12119,3.17285,0.25857,5.97698,1.74862,12.544,0.62035,17.9317-2.3719,1.2997,1.44846-1.5994,1.64158-2.47586,2.30461-5.82807,2.37542-12.8178,2.76708-18.5201-0.0771l-0.10857-0.11469v0.0005zm0.27097,0.28623zm-5.571-5.7583c0.48791-1.61741,1.63056,0.0509,2.48986,0.48444,1.62997,1.1713,3.06161,2.71455,3.75556,4.62682-1.16154,0.96689-1.19164-0.5885-1.78935-1.26638-1.11252-1.65828-2.83339-2.74872-4.45607-3.84488zm-2.1761-1.709c0.74103-0.54134,1.13851-0.23993,1.72171,0.25433,0.78596,0.31685,1.37931,0.81649,0.42272,1.43475-0.73516-0.50465-1.74522-0.83607-2.14443-1.68908zm-10.107-31.615c1.54988-0.99531,1.2512,1.54937,1.82477,2.43551,3.04711,9.63598,6.25243,19.2214,9.24676,28.8742-1.62736,0.9971-1.28004-1.78915-1.90937-2.7125-3.00054-9.54952-6.18339-19.0408-9.16216-28.5972zm88.281-33.661c2.3149,0.15457-0.977,0.80657-1.86393,0.55722-18.4851,0.47121-37.046,2.06528-55.0758,6.31884-8.90951,2.29073-18.1093,5.02306-25.3401,10.948-3.71026,3.03372-6.31519,7.74526-5.64734,12.6401,0.11025,1.0209,1.21713,3.65707-0.40502,2.96632-1.49202-4.68998-0.48681-10.0683,2.82553-13.7496,5.03077-5.87525,12.4878-8.88952,19.6414-11.3272,16.135-5.13516,33.0891-7.02945,49.9148-8.22361,5.47898-0.3435,10.9664-0.59165,16.4568-0.61421-0.16875,0.16139-0.33781,0.32399-0.5063,0.48422zm1.0099,0.0505zm-0.50494-0.0253zm0.50494,0.0253z'/%3E %3Cpath d='m404.99,190.16c3.5166,0,6.3672,2.8719,6.3672,6.4149,0,3.5442-2.8506,6.4161-6.3672,6.4161s-6.3672-2.8719-6.3672-6.4161c0-3.5418,2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m411.87,196.57h-1.0122c0.0268-2.1992-1.2955-4.3408-3.2747-5.3-0.7998-0.39875-1.6926-0.6056-2.5861-0.60484v-1.0198c2.3326-0.0201,4.6106,1.2606,5.8244,3.2491,0.68656,1.0953,1.0469,2.3841,1.0487,3.6755zm-6.8733,6.9261v-1.0198c2.1697,0.0263,4.2691-1.2876,5.2254-3.2297,0.41942-0.82526,0.63601-1.751,0.63558-2.6764h1.0122c0.0201,2.3519-1.2532,4.6604-3.2586,5.8909-1.0772,0.67558-2.3441,1.0335-3.6146,1.035zm-6.8733-6.9261h1.0122c-0.0261,2.1859,1.2785,4.3173,3.24,5.2834,0.80828,0.41087,1.7145,0.62309,2.6208,0.62256v1.0198c-2.3327,0.0203-4.6104-1.2609-5.8244-3.2491-0.68595-1.0969-1.0479-2.3837-1.0487-3.6766zm6.8733-6.9248v1.0198c-2.1696-0.0263-4.2694,1.2871-5.2253,3.2295-0.42014,0.82468-0.63576,1.7502-0.63548,2.6751h-1.0123c-0.0199-2.3517,1.2544-4.6585,3.2586-5.8897,1.0772-0.67543,2.3438-1.0337,3.6144-1.0348z' fill='%2321231e'/%3E %3Cpath d='m350.75,203.61c3.2648,0,5.9124,2.6663,5.9124,5.9567,0,3.2905-2.6476,5.9567-5.9124,5.9567-3.266,0-5.9136-2.6675-5.9136-5.9567,0-3.2904,2.6476-5.9567,5.9136-5.9567z' fill='%23FFF'/%3E %3Cpath d='m357.17,209.56h-1.0123c0.0211-1.9413-1.0892-3.8374-2.7925-4.7689-0.79387-0.44551-1.704-0.67765-2.6137-0.67802v-1.0198c2.1783-0.0185,4.305,1.1779,5.439,3.0342,0.64073,1.0226,0.97738,2.227,0.97941,3.4326zm-6.4185,6.4667v-1.0198c1.9894,0.0233,3.9151-1.1732,4.8045-2.9476,0.39671-0.76908,0.6015-1.6344,0.60191-2.4993h1.0123c0.017,2.1835-1.1563,4.3288-3.0136,5.4802-1.0116,0.64519-2.207,0.98366-3.4051,0.9865zm-6.4197-6.4667h1.0122c-0.0235,2.0052,1.1667,3.9592,2.9594,4.8576,0.75367,0.38754,1.6007,0.58937,2.4479,0.58935v1.0198c-2.1785,0.0176-4.307-1.1773-5.4402-3.0354-0.64027-1.0226-0.97781-2.226-0.9794-3.4314zm6.4197-6.4666v1.0198c-2.0017-0.0231-3.9402,1.1876-4.8218,2.9804-0.38703,0.76044-0.58493,1.614-0.58557,2.4666h-1.0122c-0.0172-2.1958,1.17-4.3522,3.0441-5.5,1.0063-0.6311,2.189-0.9647,3.3755-0.9668z' fill='%2321231e'/%3E %3Cpath d='m345.1,192.72c3.2648,0,5.9124,2.6675,5.9124,5.9579,0,3.2892-2.6476,5.9567-5.9124,5.9567-3.266,0-5.9124-2.6675-5.9124-5.9567,0-3.2904,2.6464-5.9579,5.9124-5.9579z' fill='%23FFF'/%3E %3Cpath d='m351.52,198.68h-1.0122c0.0231-2.0049-1.1654-3.9602-2.9587-4.858-0.75282-0.38946-1.6006-0.5893-2.4475-0.58995v-1.0198c2.1781-0.0175,4.306,1.178,5.439,3.0355,0.64069,1.0225,0.97733,2.2269,0.97941,3.4323zm-6.4185,6.4666v-1.0198c1.9379,0.0221,3.8165-1.1107,4.733-2.8126,0.44347-0.80194,0.67273-1.7184,0.67336-2.634h1.0122c0.0172,2.1959-1.1707,4.3518-3.0442,5.5-1.0058,0.63018-2.1882,0.96517-3.3744,0.9665zm-6.4185-6.4666h1.0122c-0.0231,2.0047,1.1661,3.9591,2.9584,4.8576,0.75365,0.38756,1.6007,0.58928,2.4479,0.58926v1.0198c-2.1658,0.0173-4.2832-1.1633-5.4194-3.0048-0.65505-1.0284-0.99618-2.2447-0.99919-3.4619zm6.4185-6.4678v1.0198c-1.9374-0.0214-3.8178,1.1096-4.7326,2.8131-0.44377,0.80211-0.67337,1.719-0.67389,2.635h-1.0122c-0.0178-2.1961,1.1701-4.3519,3.0429-5.5012,1.0069-0.62976,2.1891-0.96488,3.3758-0.9667z' fill='%2321231e'/%3E %3Cpath d='m339.79,181.71c3.266,0,5.9124,2.6663,5.9124,5.9567,0,3.2892-2.6464,5.9567-5.9124,5.9567-3.2648,0-5.9124-2.6675-5.9124-5.9567,0-3.2904,2.6476-5.9567,5.9124-5.9567z' fill='%23FFF'/%3E %3Cpath d='m346.21,187.66h-1.0122c0.0228-1.9924-1.1502-3.9362-2.926-4.8407-0.76117-0.3995-1.6212-0.60553-2.4802-0.60622v-1.0198c2.1658-0.0179,4.2819,1.1635,5.4194,3.0035,0.65427,1.0292,0.99676,2.2452,0.9991,3.4632zm-6.4185,6.4666v-1.0198c1.9251,0.0212,3.7943-1.0949,4.7149-2.7811,0.45597-0.80894,0.69064-1.738,0.69158-2.6657h1.0123c0.0177,2.1834-1.1568,4.3274-3.0123,5.4802-1.0122,0.64387-2.2079,0.98423-3.4065,0.98639zm-6.4185-6.4666h1.0122c-0.0234,1.9928,1.1514,3.9348,2.926,4.8405,0.76108,0.3998,1.6211,0.60565,2.4802,0.60632v1.0198c-2.1782,0.0176-4.306-1.1779-5.439-3.0355-0.64073-1.0221-0.97729-2.2262-0.97941-3.4312zm6.4185-6.4666v1.0198c-1.9893-0.0231-3.9153,1.1731-4.8045,2.9477-0.3967,0.76908-0.6015,1.6344-0.60191,2.4993h-1.0122c-0.017-2.1834,1.156-4.3291,3.0135-5.4802,1.0117-0.64531,2.2071-0.98358,3.4052-0.98661z' fill='%2321231e'/%3E %3Cpath d='m444.27,202.15c3.4164-0.2321,2.5712,5.8942,1.8968,7.2592-0.87976,1.7823-1.6974,1.8388-2.8076,0.19121-0.85111-1.2628-2.5044-7.2183,0.91079-7.4504z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m446.62,209.63c-0.30161-0.15154-0.60321-0.30307-0.90482-0.45461,0.32656-0.77695,0.44318-1.62371,0.5251-2.45701,0.0679-1.03225,0.0606-2.11221-0.35043-3.07951-0.19955-0.45937-0.58101-0.87475-1.09433-0.95955-0.16156-0.0318-0.32629-0.0332-0.49039-0.0267-0.0231-0.33913-0.0461-0.67827-0.0692-1.0174,0.64466-0.0417,1.32067,0.11979,1.81599,0.55022,0.71308,0.60455,1.01659,1.54516,1.14739,2.44254,0.17923,1.32162,0.0624,2.67294-0.23469,3.96901-0.0862,0.35263-0.19014,0.70613-0.34462,1.033zm-3.6778,0.25015c0.27853-0.19082,0.55705-0.38164,0.83558-0.57246,0.2538,0.35319,0.50892,0.74436,0.9085,0.94518,0.25421,0.0959,0.44699-0.17186,0.5897-0.3406,0.17308-0.22862,0.31193-0.4809,0.4392-0.73722,0.30161,0.15154,0.60321,0.30307,0.90482,0.45461-0.31398,0.61004-0.68124,1.27588-1.33747,1.56761-0.52064,0.23116-1.12429,0.022-1.52306-0.34818-0.32098-0.27759-0.57944-0.62201-0.81727-0.96894zm1.294-8.2454c0.0231,0.33913,0.0461,0.67827,0.0692,1.0174-0.48692,0.0234-0.9811,0.25675-1.22149,0.69647-0.38433,0.66622-0.39805,1.46923-0.35548,2.21706,0.0926,1.15609,0.37193,2.3023,0.84369,3.36273,0.0606,0.13046,0.12695,0.25835,0.2052,0.37915-0.27853,0.19082-0.55706,0.38164-0.83559,0.57246-0.47444-0.76732-0.73635-1.64438-0.95202-2.51408-0.26571-1.16486-0.4178-2.39325-0.15483-3.57254,0.16743-0.75999,0.60358-1.50114,1.31564-1.86138,0.33415-0.1797,0.70999-0.26328,1.08568-0.29727z'/%3E %3Cpath d='m444.49,205.46c8.0312-0.54719,6.0449,13.845,4.4584,17.055-2.0687,4.1864-3.9917,4.3163-6.5999,0.44859-1.9994-2.9645-5.8885-16.956,2.1427-17.503h-0.001z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m449.4,222.74c-0.30161-0.15153-0.60322-0.30307-0.90483-0.4546,0.74791-1.72339,1.03509-3.60618,1.2504-5.46019,0.23335-2.54016,0.24236-5.18025-0.6136-7.61411-0.46974-1.31387-1.37623-2.58315-2.75224-3.03292-0.59726-0.19743-1.2306-0.24222-1.856-0.2119-0.0231-0.33913-0.0461-0.67827-0.0692-1.0174,1.35332-0.0906,2.77186,0.24733,3.81009,1.15352,1.49563,1.29486,2.12758,3.28702,2.41834,5.18459,0.43059,3.03506,0.16517,6.14152-0.51005,9.12118-0.19969,0.79415-0.41955,1.59102-0.77291,2.33183zm-7.4702,0.50752c0.27853-0.19082,0.55706-0.38164,0.83559-0.57246,0.67074,0.9427,1.36994,1.97502,2.45424,2.47268,0.74199,0.33284,1.50122-0.18849,1.95562-0.752,0.54315-0.63228,0.94534-1.3694,1.31988-2.10992,0.30161,0.15154,0.60322,0.30307,0.90483,0.45461-0.64026,1.23192-1.34501,2.5687-2.60498,3.26388-0.93463,0.52379-2.09875,0.20308-2.87539-0.45849-0.79601-0.63679-1.41858-1.46167-1.98979-2.2983zm2.5605-17.28v-1.0198c0.0116,0.33957,0.0231,0.67913,0.0347,1.0187-1.23882,0.0741-2.49527,0.61211-3.20976,1.66191-1.03555,1.48152-1.20141,3.37076-1.17078,5.12842,0.10122,2.88879,0.77476,5.74883,1.85677,8.42441,0.22242,0.5134,0.45875,1.02338,0.76398,1.49369-0.27853,0.19082-0.55706,0.38164-0.83559,0.57246-1.04087-1.68758-1.61094-3.61562-2.10159-5.52256-0.61689-2.6495-0.98739-5.43944-0.42598-8.13192,0.34448-1.62122,1.22924-3.23758,2.75168-4.0132,0.7053-0.3877,1.50525-0.55834,2.30134-0.63062,0.0119,0.33926,0.0223,0.68045,0.0352,1.01851zm-0.001-1.0198c0.002,0.33762,0.002,0.68218,0,1.0198-0.0115-0.33953-0.0231-0.67907-0.0346-1.0186l0.0346-0.001v-0.0002z'/%3E %3Cpath d='m379.74,210.81c3.2624-1.0463,3.8914,5.1065,3.5596,6.5941-0.43331,1.9423-1.214,2.1924-2.6822,0.85989-1.1245-1.021-4.1397-6.4077-0.87737-7.454z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m383.79,217.51c-0.32866-0.0746-0.65733-0.14913-0.98599-0.22369,0.12602-0.77108,0.0528-1.56012-0.0473-2.33013-0.15456-1.00636-0.39736-2.03197-0.9565-2.89688-0.30175-0.46828-0.79376-0.89378-1.38363-0.86076-0.17969,0.00023-0.35529,0.0438-0.52759,0.0913-0.10187-0.32391-0.20373-0.64783-0.3056-0.97174,0.60869-0.19296,1.29481-0.20088,1.8739,0.0909,0.83394,0.40217,1.35394,1.23387,1.69496,2.06408,0.50341,1.26674,0.71555,2.63783,0.72734,3.99666-0.003,0.34785-0.0202,0.70064-0.0896,1.04023zm-3.5142,1.1269c0.22601-0.25255,0.45201-0.50511,0.67802-0.75766,0.33584,0.28523,0.68155,0.61963,1.13013,0.7018,0.2564,0.01,0.37116-0.2798,0.46724-0.47194,0.11468-0.26389,0.18777-0.54312,0.253-0.82262,0.32866,0.0746,0.65733,0.14913,0.98599,0.2237-0.16018,0.66929-0.36215,1.40425-0.93089,1.8453-0.44441,0.34122-1.06896,0.29242-1.54086,0.0356-0.38521-0.19337-0.72338-0.46831-1.04263-0.75422zm-0.69115-8.3187c0.10186,0.32391,0.20372,0.64783,0.30558,0.97174-0.47588,0.14153-0.90398,0.49865-1.02829,0.99303-0.20904,0.76333-0.018,1.5671,0.21544,2.30219,0.36836,1.07375,0.90236,2.09715,1.60125,2.99317,0.0858,0.10569,0.17547,0.20856,0.27563,0.30096-0.22601,0.25256-0.45202,0.50511-0.67803,0.75767-0.6458-0.63791-1.1107-1.4329-1.52782-2.23231-0.52485-1.05588-0.95622-2.19746-0.98579-3.38898-0.0235-0.7869,0.22593-1.62137,0.83662-2.14833,0.28284-0.25398,0.62847-0.42508,0.98541-0.54914z'/%3E %3Cpath d='m380.74,213.97c7.6695-2.4594,9.1449,11.994,8.3642,15.491-1.0194,4.564-2.8553,5.1522-6.3039,2.0216-2.6428-2.3993-9.7298-15.055-2.0603-17.513z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m389.6,229.58c-0.32866-0.0746-0.65733-0.14914-0.98599-0.22371,0.31737-1.85218,0.1538-3.75034-0.0781-5.60321-0.37356-2.52128-0.98909-5.0872-2.39792-7.24637-0.7874-1.20127-2.03417-2.24906-3.53028-2.28947-0.58135-0.0303-1.156,0.0835-1.71155,0.24584-0.10186-0.32391-0.20372-0.64783-0.30558-0.97174,1.29164-0.41303,2.75045-0.42728,3.9746,0.20669,1.77365,0.90752,2.86112,2.71149,3.59063,4.50048,1.12427,2.83271,1.59293,5.89621,1.644,8.93308-0.008,0.81845-0.0291,1.6466-0.19983,2.44841zm-7.1359,2.2886c0.22601-0.25256,0.45201-0.50511,0.67802-0.75767,0.87245,0.75551,1.7967,1.58823,2.96515,1.81354,0.80236,0.14253,1.41589-0.54436,1.72296-1.20243,0.37841-0.7442,0.59648-1.5564,0.78373-2.36628,0.32866,0.0746,0.65733,0.14913,0.98599,0.22369-0.33,1.35114-0.69877,2.81913-1.75804,3.79632-0.7808,0.7334-1.99001,0.70407-2.90163,0.24455-0.92528-0.42385-1.72244-1.08112-2.47618-1.75172zm-1.8741-18.378c0.10186,0.32391,0.20373,0.64783,0.30559,0.97174-1.20337,0.37121-2.30362,1.2186-2.74088,2.42942-0.66111,1.77411-0.3208,3.72972,0.17398,5.50171,0.80978,2.70115,2.11456,5.25236,3.77687,7.52746,0.31667,0.42015,0.65113,0.82989,1.03621,1.18969-0.22601,0.25256-0.45202,0.50511-0.67803,0.75767-1.4072-1.39217-2.4208-3.12469-3.34601-4.85968-1.22714-2.4267-2.24623-5.0488-2.33777-7.79649-0.05-1.66005,0.43149-3.43961,1.7249-4.55908,0.59328-0.54519,1.32974-0.89937,2.08514-1.16244zm0.15279,0.48587c-0.11532-0.36672-0.20041-0.63731-0.0351-0.11154,0.0117,0.0372,0.0234,0.0744,0.0351,0.11154z'/%3E %3Cpath d='m464.2,137.77c-17.233-1.5683-34.854,0.19483-52.298,7.1714-14.703,5.881-13.262,23.054,4.6662,46.89-1.6222,3.0199-2.545,6.7745-2.6906,11.109,1.8968-0.10464,3.2266-0.0553,4.9001-0.0974-1.2987-2.8876,0.15518-6.4246,1.7965-8.9165,1.0708-1.6272,1.2892-1.341-0.001-3.1545-10.672-14.993-17.744-28.125-13.584-36.055,5.0553-9.6368,24.656-14.657,57.715-13.922-0.0598-0.87914-0.12176-1.7667-0.18144-2.6627-0.10506-0.12027-0.21128-0.23934-0.3235-0.3608l0.001-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m412.09,145.42c-1.04336-1.30994,0.9551-1.30418,1.78982-1.78213,15.987-6.06128,33.3877-7.96408,50.3674-6.37006,0.34816,1.65821-1.47115,0.71786-2.43862,0.8246-16.8546-1.28577-34.008,0.9908-49.7186,7.32759zm4.9252,46.659c-1.20248-0.55236-0.94617,0.16653-1.94556-1.42318-5.66899-7.87904-11.011-16.3721-13.12-25.9686-1.20264-5.51591-0.65525-11.9584,3.5169-16.144,1.72886-1.82505,3.93894-3.12333,6.25084-4.07103,1.05098,1.31839-0.98555,1.30823-1.74559,1.94787-4.4098,2.19629-7.37133,6.84314-7.5199,11.7652-0.34791,7.50434,2.87125,14.6082,6.39593,21.0481,2.4068,4.28844,5.18136,8.35969,8.12549,12.295,0.0139,0.18347,0.0277,0.36809,0.0418,0.55047zm-0.0417-0.55081zm-3.1215,10.908c0.36453,1.80662-0.87004,0.27162-0.41866-0.69497,0.24164-3.50874,1.02239-7.02981,2.69137-10.1482,1.56088,0.29803,0.21996,1.46501,0.005,2.38442-1.14301,2.85149-1.63947,5.92488-1.74565,8.98424-0.17729-0.17513-0.35548-0.3507-0.53216-0.52553zm0.0549,1.0174zm4.4119-0.39566c1.6471-0.99757,0.3349,0.82805-0.74008,0.31625-1.22423,0.005-2.4491,0.005-3.6718,0.075-0.56759-1.50448,1.1407-0.96178,2.05913-1.0854,0.93344-0.011,1.86708-0.004,2.8004-0.025-0.14921,0.23969-0.29845,0.47955-0.44765,0.71915zm0.92154-0.42093zm0.91438-8.9874c1.44754,0.40226,0.22985,1.34137-0.10253,2.18481-1.04182,2.05598-1.7849,4.58019-0.81143,6.8026-1.19989,1.0853-1.3161-0.7093-1.43751-1.596-0.20852-2.65071,0.94298-5.21475,2.35147-7.39141zm0.009-2.5761c0.79738-1.12577,1.32451,0.0128,1.7035,0.80577,0.38563,0.89781-0.45124,1.63435-0.871,2.33292-1.24092-0.36067-0.50881-1.04206-0.0573-1.76067,0.011-0.51379-0.56431-0.94789-0.77522-1.37802zm-13.621-36.591c1.57643,0.28689,0.19988,1.50284,0.12778,2.47764-1.25455,5.38267,0.98655,10.7888,3.22151,15.5971,3.09196,6.32508,7.03774,12.1833,11.0928,17.9218-1.00015,1.32727-1.46913-0.5773-2.1302-1.26445-5.00628-7.32598-10.0948-14.8455-12.6955-23.4163-1.02793-3.6728-1.44131-7.81409,0.38355-11.3157zm57.658-13.649c1.96395-0.31701-0.0284,0.91165-0.98447,0.44944-12.9923-0.14576-26.1598,0.18278-38.8245,3.36134-5.86593,1.6128-12.1202,3.81373-15.9863,8.78466-0.27977,0.95984-1.69397,2.1558-1.67657,0.73396,3.17075-5.39764,9.29845-8.01308,15.011-9.8308,12.1424-3.53977,24.9092-4.05648,37.4806-4.11067,1.83231,0.004,3.6643,0.034,5.49623,0.0687-0.17196,0.18098-0.34397,0.3632-0.5159,0.54335zm1.0099-0.0697zm-1.066-2.291c0.72087-1.05033,1.01076-0.33807,0.94754,0.54848-0.0683,0.54488,0.32509,1.49092-0.0634,1.75593-0.98646,0.41821-0.87461-0.4241-0.90548-1.10353,0.006-0.36836-0.17551-1.54002-0.0334-1.33267l0.0547,0.13225,0.00002-0.00046zm0.75919-0.67349zm-1.0612-0.38485c0.67131,1.06842,0.66951,0.24649,0.82672,0.12332,0.54589,0.32368-0.36651,0.80653-0.57539,0.87948-0.22153-0.15199-0.38547-0.53559-0.25133-1.0028zm-0.0119,0.70835zm0.72935,0.012zm-0.31276-0.86831z'/%3E %3Cpath d='m380.59,142.66c3.3913,0,6.1404,2.7685,6.1404,6.1852s-2.7491,6.1864-6.1404,6.1864-6.1404-2.7697-6.1404-6.1864,2.7491-6.1852,6.1404-6.1852z' fill='%23FFF'/%3E %3Cpath d='m387.24,148.84h-1.0122c0.0251-2.1141-1.2455-4.1741-3.1496-5.0944-0.76834-0.3831-1.6262-0.58087-2.4844-0.58054v-1.0198c2.2555-0.0199,4.4585,1.2189,5.6317,3.1418,0.6669,1.0576,1.0115,2.3049,1.0146,3.553zm-6.6465,6.6964v-1.0198c2.0858,0.0245,4.1056-1.2375,5.0235-3.106,0.40447-0.79203,0.60971-1.6817,0.61058-2.5702h1.0122c0.0194,2.2741-1.212,4.5064-3.152,5.6948-1.0402,0.65606-2.266,0.99894-3.4943,1.0012zm-6.6465-6.6964h1.0122c-0.0245,2.1018,1.23,4.1512,3.1171,5.0788,0.77603,0.395,1.6468,0.59682,2.5169,0.59744v1.0198c-2.2558,0.0197-4.459-1.2194-5.6317-3.1429-0.66692-1.0576-1.0115-2.305-1.0145-3.5531zm6.6465-6.6952v1.0198c-2.0856-0.0248-4.1053,1.2367-5.0234,3.1048-0.40444,0.79204-0.60979,1.6817-0.61058,2.5702h-1.0123c-0.0193-2.2614,1.198-4.4816,3.1202-5.6744,1.0485-0.66743,2.2842-1.0193,3.5261-1.0205z' fill='%2321231e'/%3E %3Cpath d='m392.62,138.7c3.3913,0,6.1404,2.7685,6.1404,6.1852,0,3.4179-2.7491,6.1864-6.1404,6.1864-3.3901,0-6.1392-2.7685-6.1392-6.1864,0-3.4155,2.7479-6.1852,6.1392-6.1852z' fill='%23FFF'/%3E %3Cpath d='m399.27,144.88h-1.0122c0.025-2.114-1.2455-4.1741-3.1497-5.0944-0.76834-0.38311-1.6262-0.58087-2.4844-0.58055v-1.0198c2.2555-0.0199,4.4585,1.2189,5.6317,3.1418,0.66711,1.0576,1.0112,2.3052,1.0146,3.553zm-6.6465,6.6964v-1.0198c2.0734,0.0246,4.0812-1.2217,5.0069-3.072,0.41479-0.80073,0.62638-1.7031,0.62719-2.6041h1.0122c0.0194,2.2745-1.2121,4.5067-3.152,5.696-1.042,0.65377-2.2651,0.99888-3.4944,0.99997zm-6.6453-6.6964h1.0122c-0.0246,2.0891,1.2138,4.1261,3.0821,5.062,0.78498,0.40473,1.6679,0.61451,2.5508,0.61423v1.0198c-2.2681,0.0199-4.4828-1.2334-5.6508-3.1743-0.65291-1.0518-0.99149-2.2857-0.99423-3.5217zm6.6453-6.6952v1.0198c-2.0728-0.0245-4.0795,1.2217-5.0056,3.0709-0.414,0.80107-0.62737,1.7028-0.62748,2.604h-1.0122c-0.0198-2.2866,1.2259-4.53,3.1829-5.7145,1.0344-0.64203,2.2463-0.97796,3.4624-0.98032z' fill='%2321231e'/%3E %3Cpath d='m394.22,143.97c0.60521,0.819,1.2176,1.6368,1.8383,2.4558-9.7012,5.3614-13.717,11.016-12.77,16.702,0.16115,0.97655,3.1108,11.382,9.7,31.549,4.5026,3.1329,7.8593,5.9375,10.07,8.4125-0.24829,0.28142,0.71025,1.1594,0.42376,1.3999,0.67325,3.08-2.7753,2.4534-5.0899,1.6933-1.1149-2.9609-4.5157-6.1022-6.4698-7.4456-0.3987-0.273-1.8371-0.98017-1.9803-1.4396-3.5262-11.349-7.0679-21.843-10.106-31.615-3.0523-9.8196,3.5608-16.781,14.384-21.713z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m396.31,146.88c-0.46317-1.34873-0.47128-0.23017-0.81769-0.36561-0.56249-0.73998-1.11647-1.48641-1.67-2.2331,0.60172-0.75812,1.05871-0.54555,1.43721,0.23477,0.35809,0.59059,1.003,1.11475,1.18097,1.74341-0.0436,0.20675-0.0865,0.41421-0.13049,0.62053zm0.15877-0.75526zm-12.674,16.928c-0.94051,0.44849-1.20646-0.0648-1.12333-0.95391-0.27841-4.5549,2.70284-8.51783,6.02737-11.3043,2.18519-1.86347,4.61743-3.41493,7.12371-4.8076,0.89236,0.86221,0.0308,1.21196-0.75548,1.6024-4.20189,2.52357-8.53144,5.56333-10.6069,10.1697-0.71753,1.65731-0.96734,3.50993-0.66541,5.29371zm0-0.001zm9.4887,31.214c-0.49234,1.28659-0.94547,0.47165-1.11057-0.4705-3.23056-10.0412-6.5261-20.07-9.3057-30.2476-0.18514-0.68966,1.39257-0.66357,1.10773,0.25376,2.87281,10.3296,6.20287,20.5254,9.50072,30.7253-0.064-0.087-0.12823-0.17399-0.19218-0.26102zm-0.57535,0.83945zm10.736,8.3308c-0.92459-1.31863-0.53594,0.42959-1.17499-0.4558-2.85031-3.00488-6.18141-5.50215-9.5615-7.87495,0.36815-1.18876,1.06595-0.57783,1.74721-0.013,3.19239,2.30615,6.33442,4.73723,8.98649,7.66544,0.001,0.22592,0.00042,0.45365,0.003,0.67829zm-0.002-0.6783zm0.54194,1.6308c-0.90704,0.63423-0.9602-0.45432-0.94207,0.023-0.23936-0.50368-0.79914-1.09613-0.3533-1.65109,0.35874,0.55996,0.80686,0.47143,0.91891,0.59029,0.28064,0.43809,0.70747,1.09443,0.20612,1.53827,0.0567-0.16678,0.11442-0.33401,0.17034-0.50046zm-0.98837,0.21888zm-5.0684,1.7643c1.28046-0.14508,0.25929-0.95467,1.41961-0.42706,1.12396,0.22863,2.56916,0.75398,3.54985-0.0779,0.3807-0.64222-0.2252-1.56074,0.90694-1.43804,0.48398,0.17131,0.27721,1.35035,0.0356,1.83862-1.00389,1.55105-3.15763,1.05167-4.65899,0.68763-0.44247-0.14866-0.96335-0.17063-1.25298-0.58325zm0.31633,0.30427zm-6.5976-7.5093c0.338-1.12303,0.97809-0.71236,1.60371-0.0672,2.28817,1.90119,4.47775,4.11732,5.62273,6.91148-0.83276,0.61651-1.14813,0.13108-1.42231-0.66758-1.41392-2.46748-3.51963-4.51859-5.80413-6.17671zm0.5682-0.84185zm-2.7467-0.8659c0.50158-0.0722,0.95215-0.58858,1.29051-0.0318,0.46241,0.33565,0.97786,0.58735,1.4564,0.8975-0.30269,0.63756-0.63897,1.06703-1.22589,0.45225-0.55203-0.35826-1.25765-0.67338-1.52102-1.31797zm-10.106-31.615c1.05842-0.74384,1.1912,0.28412,1.4161,1.13987,3.16545,10.0734,6.52782,20.0839,9.65423,30.1697-0.99848,0.69277-1.18655-0.16467-1.3777-1.01979-3.15627-10.1203-6.53911-20.1694-9.69263-30.2898zm15.272-22.17c-1.47708,0.64,0.42424,0.72306-0.94732,1.1179-4.99999,2.41732-10.1205,5.56177-12.7524,10.6495-1.6062,3.10018-1.66877,6.81301-0.60738,10.0968-0.99911,0.69667-1.19429-0.16983-1.32103-1.03742-1.1159-4.32163,0.0576-9.06005,2.92522-12.4568,3.17629-3.87011,7.60076-6.45558,12.0887-8.5299,0.20436,0.0533,0.41157,0.10691,0.61424,0.15996zm-0.61476-0.15996z'/%3E %3Cpath d='m355.95,216.87-0.36766,1.9796c-2.8243,0.66024-5.2403,0.82502-7.2457,0.49428,3.3555-3.2989,5.8539-4,7.6134-2.4738z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m355.08,218.76c0.12255-0.65987,0.24511-1.31973,0.36766-1.9796,0.33105,0.0625,0.66211,0.12508,0.99316,0.18762-0.12255,0.65987-0.24511,1.31973-0.36766,1.9796-0.12733,0.1343-0.25466,0.26859-0.38199,0.40289-0.20372-0.19684-0.40745-0.39367-0.61117-0.59051zm0.99316,0.18762c-0.0434,0.10312-0.004,0.28587-0.10074,0.33758-0.0686-0.002-0.36702,0.12829-0.22499,0.006,0.10858-0.11452,0.21716-0.22903,0.32573-0.34356zm-8.0956,0.036c0.23555,0.24293,0.47111,0.48587,0.70666,0.7288-0.0907-0.28903-0.18144-0.57807-0.27216-0.8671,2.08792,0.33347,4.22058,0.0982,6.27884-0.3182,0.25758-0.0545,0.51497-0.10998,0.77112-0.1709,0.0764,0.33113,0.15279,0.66227,0.22919,0.9934-2.21533,0.51104-4.50821,0.83-6.78159,0.58982-0.22067-0.0245-0.44088-0.0533-0.6599-0.0898-0.0906-0.28793-0.18211-0.58172-0.27216-0.866zm0.27216,0.86711c-0.32946-0.0545-0.65893-0.10904-0.98839-0.16356,0.23874-0.23452,0.47749-0.46903,0.71623-0.70355,0.0907,0.28904,0.18144,0.57807,0.27216,0.86711zm8.1911-2.8827c-0.33105-0.0625-0.66211-0.12508-0.99316-0.18762,0.0557,0.15995,0.11141,0.3199,0.16711,0.47985-0.53408-0.48034-1.27209-0.72173-1.98637-0.62876-1.02241,0.11916-1.94132,0.64771-2.77105,1.22751-0.77854,0.55099-1.49199,1.18803-2.17317,1.85406-0.23555-0.24293-0.47111-0.48587-0.70666-0.7288,1.10809-1.07676,2.2984-2.10564,3.69122-2.79672,0.97137-0.4805,2.10757-0.76431,3.17831-0.47263,0.52811,0.1415,1.01424,0.41687,1.42665,0.77354,0.0557,0.15966,0.11161,0.32088,0.16712,0.47957zm-0.16712-0.47987c0.0652,0.0918,0.25945,0.13834,0.20588,0.27165-0.0203,0.15706-0.0438,0.27245-0.0926,0.0537-0.0378-0.10845-0.0755-0.21695-0.11333-0.32537zm-0.32946,0.38605c0.16553,0.0312,0.33105,0.0625,0.49658,0.0937-0.16553-0.0312-0.33105-0.0625-0.49658-0.0937zm0.32946-0.38605c0.0652,0.0918,0.25945,0.13834,0.20588,0.27165-0.0203,0.15706-0.0438,0.27245-0.0926,0.0537-0.0378-0.10845-0.0755-0.21695-0.11333-0.32537z'/%3E %3Cpath d='m355.64,212.34c1.7702,0.39447,1.9338,0.69514,2.7061,0.82983,0.99196,0.17198,2.3587,0.10222,3.2994-0.72881,3.8377-2.3187,3.9201,1.8581,2.4292,4.9862-1.0815,2.2658-0.52642,4.8262,0.50494,6.7661,1.22,2.291,0.96091,3.3398,0.0978,3.9591-0.59684,0.39327-1.1662,0.76248-1.6771,1.0908-1.0337,1.2291-1.8192,1.0174-1.9648-0.5905-3.8318-1.5887-5.1007-5.2916-6.2478-8.5508-1.6771-4.7661-7.771-5.893,0.8511-7.7619h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m358.43,212.66c-0.0573,0.33433-0.11459,0.66867-0.17189,1.003-0.83298-0.16819-1.58347-0.60973-2.42336-0.7629-0.43209,0.0334-0.24735-0.32366-0.19014-0.5999,0.023-0.33847,0.1135-0.57442,0.47196-0.37935,0.77788,0.14806,1.48579,0.52045,2.24471,0.72435,0.0229,0.005,0.0478,0.008,0.0687,0.0148zm2.9532-0.66387c0.17348,0.29104,0.34697,0.58208,0.52045,0.87312,0.098-0.0575-0.38965,0.31729-0.56329,0.38864-0.93682,0.50096-2.0484,0.57892-3.08216,0.40496,0.0573-0.33433,0.11459-0.66867,0.17189-1.003,1.01471,0.16821,2.16048,0.0489,2.95311-0.66372zm-0.0728,0.0542zm3.2182,5.5899c-0.30368-0.14671-0.60979-0.29728-0.91197-0.44159,0.5659-1.25436,1.00368-2.65747,0.78293-4.04443-0.0541-0.49157-0.45518-0.99183-0.99667-0.87602-0.54204,0.0588-1.03487,0.32097-1.49932,0.59098-0.17348-0.29104-0.34697-0.58208-0.52045-0.87312,0.88121-0.52053,2.01311-1.03814,3.0133-0.53685,0.9601,0.52409,1.13146,1.75176,1.06889,2.74348-0.078,1.19311-0.43268,2.35849-0.93671,3.43755zm0.4942,6.3043c-0.29683,0.16035-0.59367,0.32071-0.8905,0.48106-1.13998-2.12356-1.599-4.77475-0.59915-7.04066,0.079-0.39332,0.47209,0.0819,0.70482,0.11366,0.43126,0.0617,0.1832,0.35671,0.0907,0.62411-0.69887,1.91816-0.23371,4.0672,0.69414,5.82183zm-0.0704,4.6266c-0.19219-0.27003-0.36915-0.62091-0.57057-0.84188,0.61594-0.37636,0.59476-1.1931,0.39281-1.79874-0.15296-0.52547-0.38867-1.02208-0.64245-1.50541,0.29683-0.16035,0.59367-0.32071,0.8905-0.48106,0.54671,1.07359,1.14269,2.31566,0.77194,3.5406-0.14886,0.44458-0.46054,0.82004-0.84223,1.08649zm0.0167-0.0121-0.0167,0.0121,0.0167-0.0121zm-1.5852,1.0054c-0.25704-0.21968-0.51409-0.43937-0.77113-0.65905,0.57048-0.42832,1.19879-0.78017,1.78591-1.1876,0.18462,0.28463,0.36925,0.56925,0.55387,0.85388-0.55947,0.3658-1.11882,0.73198-1.6816,1.0927,0.0372-0.0332,0.0771-0.0669,0.11295-0.0999zm-0.77113-0.65905zm-1.7714,0.21046c0.12812-0.31429,0.25624-0.62859,0.38436-0.94288,0.19469,0.23468,0.3668,0.47259,0.36176,0.78894,0.0525,0.18491,0.077,0.45078,0.2545,0.55263,0.32564-0.0883,0.55112-0.36978,0.7697-0.6099,0.25704,0.21969,0.51409,0.43937,0.77113,0.65906-0.46314,0.5596-1.18883,1.19461-1.96482,0.88435-0.65645-0.30978-0.8261-1.10122-0.88891-1.7582,0.10419,0.14188,0.20764,0.28474,0.31228,0.426zm0.38436-0.94288c0.34683-0.0736,0.40528,0.69265,0.16623,0.22709-0.0554-0.0757-0.11079-0.15146-0.16623-0.22709zm-6.9163-7.9086c0.31752-0.11385,0.63504-0.22771,0.95256-0.34156,0.8562,2.42863,1.74108,5.00098,3.68136,6.79737,0.66669,0.61476,1.44546,1.10485,2.28235,1.4528-0.12812,0.3143-0.25624,0.62859-0.38436,0.94289-2.09891-0.84036-3.73569-2.56214-4.76474-4.54526-0.73596-1.37025-1.25192-2.84299-1.76717-4.30624zm1.3274-8.4426v1.0198c0.19309-0.0163-0.49502,0.1162-0.65056,0.15877-1.06961,0.28921-2.21215,0.49616-3.13651,1.13914-0.41538,0.24431-0.0997,0.71614,0.10943,0.98563,1.00354,1.25595,2.19131,2.3929,2.90143,3.85839,0.15182,0.30516,0.28276,0.61974,0.40152,0.93915-0.31752,0.11385-0.63505,0.2277-0.95257,0.34155-0.58288-1.70225-1.88325-2.98994-3.01374-4.33665-0.47866-0.566-0.92888-1.4098-0.48393-2.12045,0.54413-0.82478,1.57369-1.10175,2.46095-1.40202,0.77748-0.23065,1.5675-0.43374,2.36398-0.58331zm-0.10624,0.012zm0.10743,1.0078c-0.002-0.33761-0.002-0.68219,0-1.0198,0.24109,0.0779-0.018,0.55756,0.0242,0.79516-0.008,0.0749-0.0161,0.14976-0.0242,0.22464zm0-1.0198z'/%3E %3Cpath d='m357.15,212.5c3.3364,1.1978,3.7088-0.66627,5.9601-0.57126-0.88692,5.1413-1.7846,7.8016-7.1097,5.0427-2.9389-1.5238-6.7014,0.70594-7.4164,2.3596-0.26142,0.60372-1.9708-0.65065-2.5951-2.0253-2.6154-5.7571,6.6883-6.4113,11.161-4.8058z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m363.61,212.02c-0.33184-0.0585-0.66369-0.11706-0.99553-0.17559,0.15876,0.19884,0.31753,0.39768,0.47629,0.59652-1.23807-0.0936-2.23158,0.83253-3.43391,0.94246-0.9083,0.11462-1.82174-0.098-2.67424-0.4001,0.113-0.31991,0.226-0.63981,0.339-0.95972,0.98732,0.36821,2.12142,0.55493,3.11464,0.10029,0.8497-0.381,1.74296-0.77266,2.69748-0.70029,0.15874,0.19876,0.31763,0.39794,0.47627,0.59643zm-0.47627-0.59652c0.20064,0.0591,0.6937-0.11768,0.54024,0.2271-0.009,0.37475-0.10557,0.4087-0.29526,0.0797-0.0817-0.10225-0.16328-0.20457-0.24498-0.30678zm-7.3627,6.0048c0.15438-0.30226,0.30877-0.60453,0.46315-0.90679,1.10067,0.54188,2.28134,1.12318,3.5417,1.03522,0.9055-0.0699,1.51566-0.86588,1.82836-1.64939,0.539-1.29488,0.76019-2.69105,1.01031-4.06312,0.33184,0.0585,0.66369,0.11706,0.99553,0.17559-0.30675,1.64407-0.55338,3.34667-1.34797,4.84107-0.48797,0.95036-1.44554,1.68842-2.53843,1.71973-1.39844,0.0703-2.73054-0.54319-3.95265-1.15231zm-6.7217,2.1094c-0.30877-0.1355-0.61754-0.271-0.92631-0.4065,0.57033-1.18306,1.71591-1.96833,2.86955-2.52075,1.62736-0.75094,3.61343-0.93963,5.24151-0.089-0.15439,0.30226-0.30877,0.60453-0.46316,0.90679-1.54678-0.80112-3.43522-0.44713-4.89266,0.38402-0.72067,0.42315-1.44868,0.96066-1.82893,1.72544zm-3.5178-2.0168c0.30639-0.14111,0.61277-0.28221,0.91916-0.42332,0.38573,0.77141,0.99288,1.4741,1.7757,1.85553,0.26023,0.005-0.35243,0.19076,0.048,0.24382,0.25847,0.11342,0.51693,0.22684,0.7754,0.34026-0.21215,0.52028-0.88963,0.55672-1.32379,0.30751-0.95894-0.49445-1.72749-1.36337-2.19449-2.3238zm11.79-5.4973c-0.113,0.31991-0.226,0.63981-0.339,0.95972-2.0899-0.70375-4.34568-0.8657-6.52971-0.61576-1.30468,0.18625-2.68847,0.50339-3.68513,1.42102-0.70825,0.62513-0.87698,1.66975-0.59356,2.54242,0.0635,0.2654,0.17579,0.51396,0.27632,0.76657-0.30638,0.14111-0.61277,0.28222-0.91915,0.42333-0.49177-1.07325-0.71984-2.36523-0.19187-3.46925,0.62597-1.30017,2.0114-1.99991,3.34322-2.36876,2.34774-0.61853,4.84073-0.55717,7.20639-0.0673,0.48442,0.11078,0.96422,0.24189,1.43249,0.40802zm-0.1695,0.47986c0.0655-0.18535,0.25009-0.70803,0.0872-0.24676-0.029,0.0823-0.0581,0.16451-0.0872,0.24676z'/%3E %3Cpath d='m458.84,124.49c3.3758,0,6.1117,2.7577,6.1117,6.1588s-2.736,6.1588-6.1117,6.1588c-3.3758,0-6.1129-2.7577-6.1129-6.1588s2.7372-6.1588,6.1129-6.1588z' fill='%23FFF'/%3E %3Cpath d='m465.46,130.64h-1.0122c0.0268-2.145-1.2906-4.233-3.2434-5.1234-0.73535-0.34813-1.549-0.52507-2.3621-0.52502v-1.0198c2.2466-0.0199,4.4402,1.2148,5.6083,3.1303,0.6611,1.0538,1.0078,2.2958,1.0094,3.538zm-6.6178,6.6687v-1.0198c2.0753,0.0255,4.0847-1.2311,4.9976-3.09,0.4023-0.78858,0.60822-1.6738,0.60794-2.5585h1.0122c0.0196,2.2644-1.2066,4.4872-3.1374,5.6718-1.0369,0.65097-2.2568,0.99575-3.4803,0.99647zm-6.619-6.6687h1.0123c-0.0257,2.1043,1.2399,4.1545,3.1347,5.0708,0.76421,0.38169,1.6181,0.57823,2.4719,0.57769v1.0198c-2.2596,0.0203-4.4642-1.2292-5.6292-3.1614-0.64831-1.0478-0.98821-2.2761-0.98969-3.5069zm6.619-6.6687v1.0198c-2.0884-0.0258-4.109,1.2475-5.0157,3.1237-0.39123,0.78009-0.59131,1.6528-0.59092,2.5249h-1.0122c-0.0196-2.2647,1.207-4.4878,3.1386-5.6719,1.0368-0.65131,2.257-0.99519,3.4802-0.99655z' fill='%2321231e'/%3E %3Cpath d='m446.31,124.49c3.3758,0,6.1129,2.7577,6.1129,6.1588s-2.7371,6.1588-6.1129,6.1588-6.1129-2.7577-6.1129-6.1588,2.7372-6.1588,6.1129-6.1588z' fill='%23FFF'/%3E %3Cpath d='m452.93,130.64h-1.0123c0.0256-2.1043-1.2399-4.1545-3.1348-5.0708-0.76422-0.38166-1.6181-0.57822-2.4719-0.57767v-1.0198c2.2595-0.0202,4.4642,1.2294,5.6292,3.1616,0.64837,1.0478,0.9881,2.2763,0.98978,3.5068zm-6.619,6.6687v-1.0198c2.0884,0.0258,4.109-1.2473,5.0157-3.1236,0.39127-0.78008,0.59125-1.6528,0.59102-2.5249h1.0122c0.0196,2.2647-1.207,4.4877-3.1386,5.6719-1.0369,0.65096-2.2568,0.99574-3.4803,0.99646zm-6.619-6.6687h1.0122c-0.0257,2.1043,1.2399,4.1545,3.1347,5.0708,0.76421,0.3817,1.6181,0.57823,2.4719,0.57769v1.0198c-2.2596,0.0203-4.4642-1.2292-5.6292-3.1614-0.64829-1.0478-0.98821-2.2761-0.98967-3.5069zm6.619-6.6687v1.0198c-2.0884-0.0258-4.109,1.2475-5.0157,3.1237-0.39134,0.78007-0.59113,1.6528-0.59092,2.5249h-1.0123c-0.0196-2.2647,1.207-4.4878,3.1386-5.6719,1.0368-0.65131,2.257-0.99519,3.4802-0.99655z' fill='%2321231e'/%3E %3Cpath d='m433.79,125.48c3.3758,0,6.1129,2.7565,6.1129,6.1588,0,3.4011-2.7371,6.1588-6.1129,6.1588s-6.1117-2.7577-6.1117-6.1588c0-3.4023,2.736-6.1588,6.1117-6.1588z' fill='%23FFF'/%3E %3Cpath d='m440.41,131.63h-1.0122c0.0252-2.0913-1.2232-4.1314-3.1012-5.0537-0.77243-0.39332-1.6391-0.59534-2.5054-0.59489v-1.0198c2.2464-0.0197,4.4396,1.2142,5.6089,3.1287,0.66087,1.0544,1.0087,2.2967,1.0099,3.5397zm-6.619,6.6687v-1.0198c2.0884,0.0258,4.109-1.2473,5.0157-3.1236,0.39129-0.78008,0.59116-1.6528,0.59102-2.5249h1.0122c0.0196,2.2647-1.207,4.4877-3.1386,5.6718-1.0369,0.6511-2.2568,0.99554-3.4803,0.99645zm-6.6178-6.6687h1.0122c-0.0268,2.145,1.2906,4.233,3.2434,5.1234,0.73525,0.34844,1.549,0.52522,2.3621,0.52522v1.0198c-2.2594,0.0202-4.4645-1.2292-5.6285-3.162-0.64779-1.0481-0.98772-2.2758-0.98927-3.5065zm6.6178-6.6687v1.0198c-2.0878-0.0257-4.1087,1.2464-5.0146,3.1229-0.39147,0.78011-0.59081,1.6534-0.59092,2.5256h-1.0122c-0.021-2.3339,1.2845-4.6238,3.3155-5.7782,0.99565-0.58449,2.1488-0.88846,3.3022-0.89015z' fill='%2321231e'/%3E %3Cpath d='m422.25,127.7c3.3758,0,6.1117,2.7565,6.1117,6.1576,0,3.4023-2.736,6.16-6.1117,6.16-3.3758,0-6.1129-2.7577-6.1129-6.16,0-3.4011,2.7372-6.1576,6.1129-6.1576z' fill='%23FFF'/%3E %3Cpath d='m428.87,133.86h-1.0122c0.0257-2.1036-1.239-4.1538-3.1335-5.0696-0.76418-0.3818-1.6181-0.57832-2.4719-0.57778v-1.0198c2.259-0.0201,4.4641,1.2283,5.6285,3.1607,0.64775,1.0481,0.98783,2.2757,0.98918,3.5065zm-6.6178,6.6699v-1.0198c2.0882,0.0263,4.1077-1.2483,5.0145-3.1237,0.39127-0.78049,0.59099-1.6536,0.59093-2.5261h1.0122c0.0194,2.2646-1.2057,4.4873-3.1365,5.6726-1.0372,0.65118-2.2573,0.99615-3.4811,0.99701zm-6.619-6.6699h1.0123c-0.0229,2.0136,1.1298,3.9791,2.895,4.9467,0.82444,0.46083,1.7672,0.70494,2.7117,0.70307v1.0198c-2.2466,0.0198-4.4402-1.2149-5.6089-3.1299-0.66171-1.0539-1.0081-2.2972-1.01-3.5397zm6.619-6.6675v1.0198c-2.1008-0.026-4.1325,1.2627-5.0326,3.1559-0.37974,0.77176-0.57462,1.6316-0.57411,2.4913h-1.0122c-0.0213-2.3215,1.271-4.5986,3.2842-5.7582,1.0036-0.59625,2.1685-0.90741,3.3348-0.90896z' fill='%2321231e'/%3E %3Cpath d='m346.3,159.43c3.3913,0,6.1404,2.7685,6.1404,6.1864,0,3.4167-2.7491,6.1852-6.1404,6.1852-3.3901,0-6.1404-2.7685-6.1404-6.1852,0-3.4179,2.7491-6.1864,6.1404-6.1864z' fill='%23FFF'/%3E %3Cpath d='m352.94,165.62h-1.0122c0.0244-2.1014-1.2294-4.1512-3.1163-5.0784-0.77649-0.39497-1.6473-0.59804-2.518-0.59788v-1.0198c2.2555-0.0198,4.4585,1.2188,5.6317,3.1418,0.6663,1.0588,1.0115,2.3057,1.0147,3.5543zm-6.6465,6.6952v-1.0198c2.0856,0.0248,4.1053-1.2367,5.0234-3.1048,0.4044-0.79205,0.60982-1.6817,0.61068-2.5702h1.0122c0.0193,2.2614-1.198,4.4816-3.1202,5.6744-1.0485,0.66744-2.2842,1.0193-3.5262,1.0205zm-6.6465-6.6952h1.0122c-0.0247,2.1013,1.2301,4.1496,3.1162,5.0772,0.77675,0.39411,1.6473,0.5981,2.518,0.59778v1.0198c-2.2427,0.0192-4.434-1.2046-5.6115-3.11-0.68017-1.0637-1.0316-2.325-1.0349-3.5848zm6.6465-6.6964v1.0198c-2.0734-0.0247-4.0812,1.2217-5.007,3.072-0.41479,0.80074-0.62652,1.7031-0.62727,2.6041h-1.0122c-0.0194-2.2745,1.2121-4.5067,3.152-5.696,1.042-0.65378,2.2652-0.99887,3.4945-0.99997z' fill='%2321231e'/%3E %3Cpath d='m356.82,152.75c3.3901,0,6.1392,2.7685,6.1392,6.1864,0,3.4167-2.7479,6.1852-6.1392,6.1852s-6.1404-2.7685-6.1404-6.1852,2.7491-6.1864,6.1404-6.1864z' fill='%23FFF'/%3E %3Cpath d='m363.47,158.94h-1.0122c0.0243-2.0891-1.2142-4.126-3.0823-5.062-0.78499-0.40473-1.6679-0.61451-2.5508-0.61423v-1.0198c2.2681-0.0199,4.4825,1.2338,5.6509,3.1744,0.65292,1.0518,0.99144,2.286,0.99443,3.5217zm-6.6453,6.6952v-1.0198c2.0849,0.025,4.1041-1.2363,5.022-3.1037,0.40405-0.79264,0.61091-1.6822,0.61094-2.5713h1.0122c0.0196,2.2609-1.1971,4.4804-3.118,5.674-1.049,0.66754-2.2847,1.0196-3.5272,1.0208zm-6.6465-6.6952h1.0122c-0.0248,2.114,1.2456,4.1741,3.1498,5.0944,0.76834,0.3831,1.6262,0.58086,2.4844,0.58054v1.0198c-2.2555,0.0199-4.4585-1.2189-5.6317-3.1418-0.66705-1.0576-1.0113-2.3052-1.0147-3.553zm6.6465-6.6964v1.0198c-2.0858-0.0245-4.1056,1.2375-5.0235,3.106-0.40439,0.79206-0.60982,1.6817-0.61068,2.5702h-1.0122c-0.0195-2.2741,1.2119-4.5063,3.1518-5.6948,1.0403-0.65613,2.2661-0.99889,3.4946-1.0012z' fill='%2321231e'/%3E %3Cpath d='m368.79,147.09c3.3913,0,6.1404,2.7685,6.1404,6.1864,0,3.4167-2.7479,6.1852-6.1404,6.1852-3.3901,0-6.1392-2.7685-6.1392-6.1852,0-3.4179,2.7479-6.1864,6.1392-6.1864z' fill='%23FFF'/%3E %3Cpath d='m375.43,153.28h-1.0122c0.0254-2.1145-1.2453-4.1749-3.1496-5.0957-0.76834-0.38311-1.6262-0.58086-2.4844-0.58054v-1.0198c2.2555-0.02,4.4585,1.2188,5.6317,3.1417,0.66602,1.0589,1.012,2.3052,1.0146,3.5543zm-6.6465,6.6952v-1.0198c2.0854,0.0253,4.1049-1.2362,5.0232-3.1038,0.40414-0.79262,0.61077-1.6822,0.61074-2.5713h1.0122c0.02,2.2736-1.2111,4.5051-3.15,5.6939-1.0428,0.65391-2.266,1.0001-3.4961,1.001zm-6.6453-6.6952h1.0122c-0.0244,2.0887,1.2143,4.125,3.0821,5.0608,0.78499,0.40471,1.6679,0.6145,2.5508,0.61422v1.0198c-2.2682,0.0198-4.4825-1.2336-5.6513-3.1741-0.65256-1.0513-0.99118-2.2851-0.99378-3.5207zm6.6453-6.6964v1.0198c-2.0727-0.0248-4.0801,1.2214-5.0056,3.0709-0.41428,0.80141-0.62746,1.7036-0.62739,2.6052h-1.0122c-0.0198-2.2739,1.2111-4.5056,3.1497-5.6956,1.0424-0.6538,2.2657-0.99959,3.4954-1.0004z' fill='%2321231e'/%3E %3Cpath d='m338.16,169.49c3.3913,0,6.1404,2.7685,6.1404,6.1864,0,3.4155-2.7491,6.1852-6.1404,6.1852-3.3901,0-6.1392-2.7685-6.1392-6.1852,0-3.4179,2.7479-6.1864,6.1392-6.1864z' fill='%23FFF'/%3E %3Cpath d='m344.8,175.68h-1.0122c0.0254-2.1145-1.2453-4.1749-3.1496-5.0956-0.7683-0.38323-1.6262-0.58096-2.4844-0.58064v-1.0198c2.2555-0.0198,4.4585,1.2188,5.6317,3.1418,0.66587,1.0589,1.0122,2.3051,1.0146,3.5543zm-6.6465,6.6952v-1.0198c2.0733,0.0242,4.081-1.2219,5.007-3.072,0.41458-0.80038,0.62624-1.7023,0.62709-2.603h1.0122c0.0193,2.2739-1.2126,4.5058-3.1523,5.6941-1.0404,0.65545-2.2656,0.9986-3.494,1.0007zm-6.6453-6.6952h1.0122c-0.024,2.0887,1.2144,4.125,3.0823,5.0608,0.78498,0.40474,1.6679,0.61452,2.5508,0.61424v1.0198c-2.2682,0.0198-4.4825-1.2336-5.6513-3.1741-0.65285-1.0513-0.99076-2.2856-0.99397-3.5207zm6.6453-6.6964v1.0198c-2.0726-0.0248-4.0801,1.2214-5.0055,3.0709-0.4143,0.80141-0.62741,1.7036-0.6275,2.6052h-1.0122c-0.0197-2.2739,1.2113-4.5056,3.1498-5.6956,1.0424-0.65379,2.2656-0.99959,3.4954-1.0004z' fill='%2321231e'/%3E %3Cpolygon points='409.61,280.14,431.38,267.54,454.53,277.39,432.76,290' transform='matrix(1.0106622,0,0,1.0182434,-5.1283744,-6.1909008)' fill='%23edb92e'/%3E %3Cpath d='m431.11,266.67-22.003,12.832-0.50613-0.88274,22.003-12.832,0.45122-0.0277,0.0549,0.9104zm-0.50613-0.88274,0.21845-0.12748,0.23277,0.0997-0.45122,0.0277zm23.447,10.945-23.392-10.035,0.39631-0.93807,23.392,10.035,0.0549,0.91041-0.45122,0.0277zm0.39631-0.93807,0.93108,0.39928-0.87617,0.51114-0.0549-0.91042zm-22.456,12.861,22.005-12.833,0.50613,0.88276-22.005,12.833-0.45122,0.0277-0.0549-0.91041zm0.50613,0.88274-0.21845,0.12749-0.23277-0.0997,0.45122-0.0277zm-23.445-10.947,23.39,10.036-0.39631,0.93807-23.39-10.036-0.0549-0.9104,0.45122-0.0277zm-0.39631,0.93807-0.93108-0.39929,0.87617-0.51112,0.0549,0.91041z' fill='%2321231e'/%3E %3Cpath d='m431.13,270.65c5.6414-0.34757,10.401,2.4426,10.631,6.2309,0.22918,3.7896-4.1576,7.1425-9.7979,7.4901-5.6402,0.34757-10.4-2.4426-10.63-6.2309-0.23038-3.7896,4.1564-7.1426,9.7967-7.4901z' fill='%23c6363c'/%3E %3Cpath fill='%2321231e' d='m442.26,276.85c-0.33663,0.0208-0.67327,0.0417-1.0099,0.0625-0.11067-1.89705-1.53793-3.4232-3.12645-4.30807-2.10372-1.18449-4.57799-1.58605-6.96851-1.44518-0.0207-0.33913-0.0414-0.67827-0.0621-1.0174,3.07128-0.17538,6.32587,0.47814,8.77602,2.42641,1.31073,1.04785,2.29378,2.57629,2.39094,4.28174zm-10.272,8.0301c-0.0207-0.33913-0.0414-0.67827-0.0621-1.0174,2.80968-0.18622,5.70025-1.12047,7.72544-3.14926,0.98778-0.99786,1.69112-2.36835,1.59874-3.80088,0.33663-0.0208,0.67327-0.0417,1.0099-0.0625,0.13581,2.09365-1.08228,4.03638-2.67826,5.2969-2.13781,1.7186-4.88606,2.55648-7.59372,2.73314zm-11.166-6.7084c0.33663-0.0208,0.67327-0.0417,1.0099-0.0625,0.10885,1.87832,1.51266,3.39564,3.08095,4.28273,2.11303,1.20326,4.60549,1.61284,7.01283,1.47053,0.0207,0.33913,0.0414,0.67827,0.0621,1.0174-3.07097,0.17544-6.32499-0.47816-8.77482-2.4263-1.31073-1.04797-2.29368-2.57596-2.39096-4.28186zm10.271-8.0301c0.0207,0.33913,0.0414,0.67827,0.0621,1.0174-2.80965,0.18633-5.70028,1.12043-7.72544,3.14926-0.98713,0.99808-1.69176,2.36831-1.59765,3.80088-0.33663,0.0208-0.67327,0.0417-1.0099,0.0625-0.13845-2.1119,1.10221-4.06761,2.71756-5.32951,2.13291-1.69663,4.86151-2.52476,7.55333-2.70053z'/%3E %3Cpath d='m382.38,269.85,23.776,9.074-19.628,13.224c-5.0875-1.7042-9.1222-19.12-4.1481-22.298z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m405.98,279.4c-7.92533-3.02467-15.8507-6.04933-23.776-9.074,0.21782-0.26484,0.14943-1.16498,0.62885-0.84918,7.83508,2.99022,15.6702,5.98045,23.5053,8.97067-0.005,0.39978,0.34169,1.07978-0.33034,0.94938l-0.0278,0.003v-0.00007zm0.35811-0.9525c0.26314,0.17753,1.29242,0.26716,0.61641,0.55245-0.49084,0.50826-0.61013,0.21203-0.59614-0.37276-0.007-0.0599-0.0135-0.11979-0.0203-0.17969zm-20.088,13.277c6.54267-4.408,13.0853-8.816,19.628-13.224,0.0872,0.33228,0.85434,0.79979,0.32071,1.00858-6.46256,4.35402-12.9251,8.70805-19.3877,13.0621-0.61722,0.2997-0.46235-0.41329-0.55505-0.80157l-0.006-0.045v-0.00005zm0.56104,0.84666zm-4.2496-23.198c-0.004,0.29311-0.6705,1.09603-0.0698,0.92318,0.31022-0.008-0.56365,0.46333-0.62724,0.74742-1.18154,1.73471-1.2569,3.94105-1.23285,5.97116,0.18317,3.87287,1.11376,7.74339,2.88697,11.2008,0.76536,1.35775,1.6644,2.83575,3.17209,3.4485-0.2038,0.26517-0.11085,1.19131-0.58598,0.85213-1.77498-0.82109-2.84185-2.60054-3.70808-4.27432-1.72776-3.57007-2.65433-7.52524-2.78049-11.4855-0.0138-2.24138,0.16911-4.69031,1.59518-6.52481,0.37405-0.38327,0.75895-0.90636,1.35022-0.85854zm-0.45002,0.0458c0.38906-0.2638,0.54986,0.0593,0,0.0001v-0.0001zm0.27096,0.43055zm-0.27096-0.43055c0.38906-0.2638,0.54986,0.0593,0,0.0001v-0.0001z'/%3E %3Cpath d='m382.83,274.26c5.6211-0.57727,10.49,2.0168,10.872,5.792,0.38198,3.7775-3.8676,7.3061-9.4887,7.8834-3.6551,0.37522-5.9279-2.8455-6.323-6.2598-0.39631-3.4131,1.0851-7.0199,4.9395-7.4156z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='m394.21,280c-0.33503,0.0345-0.67007,0.0689-1.0051,0.10342-0.17586-1.7771-1.51447-3.19884-3.02146-4.02596-2.20459-1.22507-4.81264-1.55539-7.29699-1.31142-0.0342-0.33753-0.0684-0.67507-0.10266-1.0126,2.9357-0.29116,6.05547,0.17931,8.54542,1.83879,1.50488,0.99988,2.70248,2.56777,2.88079,4.40777zm-9.9399,8.4414c-0.0342-0.33753-0.0684-0.67507-0.10266-1.0126,2.7073-0.29286,5.44855-1.2804,7.39222-3.24752,1.05366-1.06606,1.80559-2.54703,1.64535-4.07781,0.33503-0.0345,0.67007-0.069,1.0051-0.10343,0.20782,1.95861-0.7883,3.85349-2.19493,5.15775-2.08965,1.96179-4.9297,2.98545-7.74508,3.28361zm-6.8769-6.7072c0.33503-0.0393,0.67007-0.0786,1.0051-0.11787,0.2382,1.99128,1.13519,4.04604,2.87126,5.16322,0.85371,0.54547,1.89545,0.75564,2.89796,0.64942,0.0342,0.33753,0.0684,0.67507,0.10266,1.0126-1.72233,0.20632-3.50238-0.46201-4.67819-1.73392-1.2798-1.33877-1.9801-3.15349-2.19879-4.97345zm5.3907-7.9808c0.0342,0.33753,0.0684,0.67507,0.10266,1.0126-1.47758,0.12303-2.88612,0.95404-3.63048,2.24907-0.82226,1.37006-1.03441,3.03311-0.85802,4.60134-0.33503,0.0393-0.67007,0.0786-1.0051,0.11786-0.25733-2.22809,0.22844-4.68178,1.83687-6.3303,0.93315-0.96599,2.2273-1.52055,3.55407-1.65057z'/%3E %3Cpath d='m457.46,280.42c1.7631,0,3.1931,1.4396,3.1931,3.2171,0,1.7763-1.43,3.2159-3.1931,3.2159s-3.1919-1.4396-3.1919-3.2159c0-1.7775,1.4288-3.2171,3.1919-3.2171z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m461.16,283.63h-1.0123c0.0181-1.09046-0.69927-2.14339-1.72005-2.52663-0.30697-0.11995-0.63691-0.18095-0.96643-0.17986v-1.0198c1.19461-0.008,2.36388,0.61312,3.03596,1.59879,0.4323,0.61988,0.66297,1.37555,0.66282,2.1275zm-3.6993,3.7258v-1.0198c1.08922,0.0176,2.13175-0.71222,2.50723-1.7314,0.11948-0.30978,0.18006-0.64204,0.17885-0.974h1.0122c0.008,1.20516-0.60989,2.39095-1.60619,3.07013-0.60913,0.42684-1.35303,0.65539-2.09209,0.65507zm-3.6981-3.7258h1.0122c-0.0175,1.08935,0.69781,2.14269,1.71845,2.52507,0.30696,0.12009,0.63677,0.18138,0.96634,0.18013v1.0198c-1.20864,0.008-2.39157-0.62805-3.05911-1.63399-0.41654-0.61261-0.6398-1.35519-0.63788-2.09101zm3.6981-3.727v1.0198c-1.05127-0.0158-2.06174,0.66157-2.46506,1.62937-0.14608,0.33885-0.22176,0.70781-0.22002,1.07683h-1.0122c-0.009-1.25103,0.6586-2.48078,1.71868-3.14701,0.58536-0.37856,1.28594-0.58026,1.9786-0.57899z'/%3E %3Cpath d='m408.71,283.14c1.7631,0,3.1931,1.4396,3.1931,3.2171,0,1.7763-1.43,3.2159-3.1931,3.2159s-3.192-1.4396-3.192-3.2159c0-1.7775,1.4289-3.2171,3.192-3.2171z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m412.41,286.36h-1.0122c0.0179-1.08318-0.68922-2.13028-1.70025-2.51886-0.31243-0.12523-0.64944-0.18869-0.98594-0.18764v-1.0198c1.19461-0.008,2.36389,0.61312,3.03598,1.59879,0.4319,0.61971,0.66406,1.3764,0.66241,2.12751zm-3.6993,3.7258v-1.0198c1.0892,0.0175,2.13187-0.71223,2.50743-1.73139,0.11941-0.3098,0.18022-0.64203,0.17895-0.974h1.0123c0.008,1.20519-0.61017,2.3909-1.6064,3.07013-0.6093,0.42682-1.35243,0.65532-2.09228,0.65506zm-3.6981-3.7258h1.0122c-0.0175,1.08938,0.69787,2.14268,1.71846,2.52517,0.30695,0.12008,0.63676,0.18137,0.96632,0.18012v1.0198c-1.20864,0.008-2.39157-0.62806-3.0591-1.634-0.41655-0.61267-0.63978-1.35499-0.63788-2.09109zm3.6981-3.727v1.0198c-1.05123-0.0158-2.06183,0.66146-2.4649,1.6294-0.14597,0.33886-0.22142,0.70784-0.21978,1.0768h-1.0122c-0.009-1.25103,0.65862-2.48078,1.71869-3.14702,0.58502-0.37855,1.28701-0.58036,1.97819-0.57898z'/%3E %3Cpath d='m406.99,268.29c1.7631,0,3.1932,1.4408,3.1932,3.2171s-1.4301,3.2171-3.1932,3.2171-3.1919-1.4408-3.1919-3.2171,1.4288-3.2171,3.1919-3.2171z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m410.69,271.51h-1.0122c0.0179-1.08332-0.69016-2.12948-1.70043-2.51885-0.31243-0.12524-0.64944-0.1887-0.98594-0.18765v-1.0198c1.20917-0.009,2.39166,0.62887,3.05963,1.63473,0.41748,0.6126,0.6395,1.35442,0.63894,2.09157zm-3.6993,3.727v-1.0198c1.0827,0.0179,2.11836-0.70368,2.50012-1.71275,0.12455-0.3153,0.18728-0.65475,0.18626-0.99365h1.0122c0.009,1.23666-0.6436,2.45208-1.68333,3.12296-0.59298,0.39474-1.30674,0.60343-2.01525,0.60324zm-3.6981-3.727h1.0122c-0.0176,1.0896,0.6978,2.14343,1.71846,2.52627,0.30694,0.12009,0.63675,0.18138,0.96632,0.18002v1.0198c-1.20191,0.008-2.37831-0.62102-3.04707-1.61798-0.42429-0.61488-0.65142-1.36632-0.64991-2.10811zm3.6981-3.727v1.0198c-1.05122-0.0162-2.06044,0.66185-2.46444,1.62869-0.14655,0.339-0.22206,0.70843-0.22063,1.07771h-1.0122c-0.009-1.24347,0.65093-2.46525,1.69983-3.13444,0.58928-0.38716,1.29679-0.5919,1.99744-0.59176z'/%3E %3Cpath d='m457.34,266.19c1.7631,0,3.1919,1.4396,3.1919,3.2159,0,1.7775-1.4288,3.2171-3.1919,3.2171-1.7643,0-3.1931-1.4396-3.1931-3.2171,0-1.7763,1.4288-3.2159,3.1931-3.2159z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m461.04,269.41h-1.0122c0.0172-1.08218-0.6883-2.12923-1.69903-2.51716-0.31248-0.12516-0.64929-0.18912-0.98586-0.18784v-1.0198c1.20863-0.008,2.39161,0.62791,3.0591,1.63391,0.41648,0.61253,0.63997,1.35543,0.63799,2.09089zm-3.6981,3.727v-1.0198c1.08186,0.017,2.11895-0.70238,2.49843-1.71274,0.12498-0.3152,0.18744-0.65474,0.18636-0.99365h1.0122c0.009,1.25091-0.65864,2.48081-1.71868,3.14701-0.58518,0.37868-1.28643,0.58004-1.97831,0.57918zm-3.6993-3.727h1.0122c-0.0175,1.08258,0.68778,2.13033,1.69902,2.51845,0.31278,0.12551,0.65012,0.18906,0.98705,0.18774v1.0198c-1.24816,0.009-2.46903-0.6708-3.12342-1.73255-0.37702-0.59165-0.57599-1.29737-0.57485-1.99344zm3.6993-3.7258v1.0198c-1.08189-0.0173-2.11911,0.70165-2.49962,1.71153-0.12448,0.31535-0.1877,0.6546-0.18646,0.99356h-1.0122c-0.009-1.25083,0.65876-2.48113,1.71998-3.1458,0.58499-0.37962,1.28642-0.57995,1.9783-0.57909z'/%3E %3Cpath d='m370.93,237.39c2.4172-0.74323,6.1953,4.6362,7.0941,4.5436,1.1889-3.0764-1.2367-10.433-5.5328-16.257-2.9186-0.9585-3.18-2.8479-3.7828-7.2303-0.18026-1.3109-2.6798-0.4077-2.7252,1.8232-0.0502,2.3909-0.23397,3.715,0.29722,5.7559,0.20891,0.80457,0.0931,1.5755-0.79858,2.3103,4.5504,1.8148,5.6677,4.0397,5.448,9.056v-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m377.56,241.75c0.26209,0.14036,0.80292,0.24169,0.89702,0.40557-0.23235,0.26071-0.56516,0.38209-0.87915,0.17624-1.06507-0.64691-1.84858-1.65372-2.78534-2.46238-0.94744-0.82377-1.9237-1.78182-3.19981-2.02916-0.41056,0.0666-0.62759,0.003-0.65881-0.45942-0.25221-0.40882-0.0547-0.60401,0.38943-0.56315,1.42116-0.006,2.59108,0.96733,3.62734,1.83171,1.04307,0.86959,1.92264,1.92621,3.01159,2.73931,0.22645-0.006-0.37045,0.27574-0.40227,0.36128zm0.94302,0.37042c-0.0441,0.45372-0.69245,0.35098-0.0982,0.075,0.0325-0.0246,0.0657-0.0506,0.0982-0.075zm-6.1607-15.958c0.13039-0.27971,0.18037-0.80509,0.35966-0.93541,0.49825,0.39446,0.77476,1.01077,1.15765,1.51333,2.14008,3.26704,3.87434,6.86033,4.69345,10.6961,0.28898,1.53595,0.48598,3.17848-0.0499,4.68395-0.28143-0.15422-0.76481-0.21439-0.92454-0.42528,0.50327-1.61222,0.15408-3.33745-0.21807-4.94017-1.02264-3.89207-2.90913-7.52648-5.26788-10.7729,0.0832,0.0601,0.16636,0.12042,0.24963,0.1804zm0.31275-0.96933zm-4.4406-6.6759c0.31858-0.003,0.77513-0.18889,1.01068-0.0822,0.26904,1.67922,0.3599,3.44117,1.11691,4.99251,0.45096,0.9115,1.36887,1.47318,2.31259,1.7655-0.13579,0.29008-0.1697,0.78459-0.36744,0.95035-1.34597-0.40363-2.55153-1.35732-3.05546-2.69513-0.6256-1.56618-0.76645-3.2788-1.01728-4.93107zm-1.7177,1.7643c-0.31372-0.0475-0.798,0.0631-1.00905-0.0795,0.017-1.39355,1.11889-2.86235,2.58871-2.86772,0.57584,0.00062,1.08578,0.47196,1.14048,1.04356-0.32214,0.007-0.76131,0.18005-1.0134,0.0878-0.15203-0.25955-0.56034-0.0324-0.7592,0.07-0.5973,0.36383-0.93941,1.05893-0.94754,1.74588zm0.28052,5.6164c-0.31537,0.0407-0.74808,0.27974-0.99287,0.20122-0.53294-1.90312-0.34218-3.89189-0.29896-5.83924,0.31484,0.0475,0.7958-0.0632,1.01064,0.0796-0.039,1.85607-0.23431,3.74484,0.28119,5.55845zm-1.1018,1.9651c-0.12262,0.25672-0.27938,0.82022-0.38124,0.89046,0.0288-0.30018-0.27826-0.72297,0.01-0.92779,0.48487-0.39873,0.69041-1.07281,0.4946-1.6711,0.31544-0.0408,0.74794-0.27971,0.99296-0.20124,0.30371,1.02423-0.14039,2.1486-0.98413,2.77716-0.0435-0.28829-0.0916-0.5834-0.1322-0.86749zm-0.37243,0.94768c-0.192-0.15772-1.03527-0.21343-0.62116-0.46607,0.30602-0.29652,0.59638-0.55196,0.55794,0.0555,0.0211,0.13686,0.0421,0.27371,0.0632,0.41057zm5.1281,8.5821c0.27513-0.00092,0.87397,0.002,0.95432-0.001-0.28124-0.0787-0.86629,0.12878-0.94886-0.1372,0.0631-2.00607,0.0366-4.22375-1.24695-5.88733-0.97906-1.24796-2.44795-1.97098-3.88646-2.55622,0.15364-0.28108,0.21803-0.77206,0.42591-0.92555,1.98211,0.78546,4.01539,1.95641,4.94472,3.97255,0.81406,1.72655,0.83776,3.68723,0.769,5.55797-0.33722-0.008-0.67447-0.0151-1.01168-0.0229zm1.0122-0.001c-0.33507,0.002-0.67713,0.002-1.0122,0,0.20068-0.35461,0.41304-0.63106,0.72959-0.21048,0.0942,0.0702,0.18862,0.14039,0.28261,0.21048zm-1.0122,0c-0.26067-0.39086,0.62528-0.67794,0.18666-0.25387-0.0622,0.0846-0.12444,0.16925-0.18666,0.25387z'/%3E %3Cpath d='m368.78,218.51c-0.4166,1.009-0.54312,1.8352-0.64339,3.3674-0.0764,1.1678,0.34975,2.261,1.0922,3.2291,0.74486,0.97294,1.8108,1.8292,3.0081,2.5244,0.74128,0.43176,1.5924,1.6248,2.2656,2.9814,0.66966,1.3494,1.1603,2.8719,1.1877,3.9543,0.0955,3.5803,0.78904,6.7084,2.4172,7.3253,1.0648,0.40409,1.4909,0.34155,2.3158,0.14913-0.23278-0.64342-0.14444-1.549-0.71861-2.4462-0.73889-1.157-1.3871-2.4859-1.4456-3.6488-0.0513-0.9044-0.47509-1.5081-0.12533-3.2905,0.2256-1.1546,0.97285-1.5911,0.84035-2.6554-0.25665-2.0625-1.8741-6.0205-4.2484-6.0205-2.3408-0.001-3.4343-0.25376-4.6459-3.3698-0.41183-1.0595-0.95018-1.5695-1.2999-2.0998z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m368.64,221.91c-0.31387-0.0605-0.79436,0.0255-1.0063-0.12453,0.0721-1.17881,0.20225-2.37746,0.6765-3.47175,0.27776,0.15941,0.75873,0.2339,0.91212,0.44528-0.42283,0.99528-0.51742,2.08478-0.58232,3.151zm0.98718,2.884c-0.2745,0.16402-0.57757,0.54874-0.83455,0.57738-0.76601-0.99981-1.25497-2.2557-1.16193-3.52853,0.31385,0.0605,0.79438-0.0255,1.00629,0.12453-0.0593,1.03021,0.37247,2.02514,0.99019,2.82662zm2.8613,2.3945c-0.19235,0.25726-0.32829,0.72829-0.55547,0.85355-1.17184-0.69024-2.27125-1.54208-3.10542-2.62521,0.27488-0.16432,0.57682-0.54816,0.83511-0.57782,0.76307,0.97142,1.76464,1.73071,2.82578,2.34948zm2.465,3.1954c-0.301,0.10713-0.67245,0.42532-0.93032,0.40325-0.53228-0.99456-1.09534-2.0543-2.0404-2.71558,0.19217-0.25696,0.32865-0.72889,0.55522-0.8531,1.11132,0.75938,1.8077,1.99851,2.4155,3.16543zm1.2402,4.1684c-0.31785-0.0313-0.78635,0.0991-1.01237-0.0308-0.0906-1.294-0.57654-2.52365-1.13213-3.68267,0.30075-0.10701,0.67296-0.42556,0.92996-0.40306,0.61334,1.28887,1.14693,2.67762,1.21454,4.11651zm2.0902,6.8624c-0.14745,0.28351-0.20638,0.77408-0.40841,0.9299-1.28978-0.56771-1.81751-2.01949-2.15443-3.28652-0.36551-1.46353-0.49324-2.975-0.5372-4.47923,0.31736,0.0313,0.78732-0.0992,1.01167,0.0308,0.0891,1.95776,0.2125,3.99724,1.09023,5.78518,0.23204,0.41789,0.53816,0.83882,0.99814,1.01986zm1.6628,0.79978c0.27897-0.0745,0.77978-0.34153,0.92305-0.29826-0.183,0.26794-0.23347,0.71533-0.63926,0.68796-0.76925,0.19721-1.57943,0.067-2.30314-0.2351,0.14833-0.28575,0.20463-0.7696,0.40972-0.93319,0.621,0.27607,1.32146,0.31212,1.96941,0.11089-0.11902,0.22024-0.24471,0.45822-0.35978,0.6677zm0.95019-0.34877c0.18998,0.36363,0.27439,0.66998-0.25093,0.64548-0.26579,0.12832,0.25104-0.55934,0.25093-0.64548zm-1.6186-1.9964c0.28301-0.18409,0.56829-0.36696,0.8499-0.55181,0.52679,0.753,0.54377,1.69119,0.7685,2.54786-0.31057,0.072-0.71713,0.34651-0.96899,0.29459-0.23493-0.75788-0.19056-1.61082-0.64941-2.29064zm-1.5256-3.8954c0.33524-0.0164,0.68133-0.0443,1.0099-0.0537,0.0979,1.24116,0.72159,2.36064,1.3652,3.39843-0.28739,0.13932-0.6224,0.49646-0.88062,0.50239-0.72643-1.16633-1.40527-2.46395-1.49448-3.84712zm1.0099-0.0577zm-1.1268-3.3602c0.30372,0.10049,0.79101,0.0774,0.98235,0.25355-0.21311,0.90723-0.0934,1.83837,0.10502,2.735,0.20515,0.47018-0.2601,0.39021-0.5909,0.40758-0.36983,0.12713-0.42503-0.0871-0.433-0.40268-0.23732-0.98394-0.28293-2.0022-0.0635-2.99345zm0.8356-2.4931c0.31775-0.00051,0.77659-0.17773,1.00824-0.0704,0.17264,1.02972-0.66109,1.8089-0.85014,2.76078-0.3028-0.10031-0.79279-0.0778-0.98102-0.25327,0.10842-0.78367,0.71741-1.38796,0.83027-2.16263,0.009-0.0914,0.003-0.18371-0.007-0.27448zm-3.747-5.5743c0.0386-0.31831-0.077-0.79934,0.0573-1.01675,1.5371,0.0496,2.64688,1.34392,3.3533,2.58399,0.66979,1.19937,1.14755,2.51679,1.33891,3.87964-0.31932,0.00069-0.77347,0.17737-1.01052,0.0707-0.28832-1.70092-0.94753-3.39695-2.11469-4.69006-0.42901-0.44134-0.98606-0.82862-1.62426-0.8275zm-5.1162-3.6946c0.31323-0.12402,0.62896-0.24634,0.94063-0.37142,0.45338,1.08833,0.95664,2.39625,2.16179,2.82989,0.64725,0.2156,1.33927,0.21035,2.01376,0.2156-0.0387,0.32019,0.0771,0.79558-0.0573,1.01954-1.26991,0.024-2.70267-0.11714-3.60218-1.12683-0.68023-0.72469-1.09564-1.65333-1.45666-2.56678zm-0.36287-2.089c-0.25321-0.12659-0.80745-0.29895-0.87641-0.39754,0.31207,0.0455,0.78258-0.25529,0.95403,0.0956,0.48606,0.6221,0.95367,1.27274,1.2266,2.02066-0.30991,0.0795-0.70508,0.36187-0.96295,0.3176-0.26692-0.73292-0.78471-1.32383-1.22838-1.95118,0.29501-0.0283,0.59546-0.0575,0.88711-0.0851zm-0.93349-0.39205c0.1478-0.20504,0.24757-0.91237,0.4272-0.7846,0.0632,0.23353,0.71622,0.74911,0.23261,0.72115-0.21994,0.0212-0.43987,0.0423-0.65981,0.0635zm0.46673,0.19602zm-0.46673-0.19602c0.1478-0.20504,0.24757-0.91237,0.4272-0.7846,0.0632,0.23353,0.71622,0.74911,0.23261,0.72115-0.21994,0.0212-0.43987,0.0423-0.65981,0.0635z'/%3E %3Cpath d='m359.96,227.08c0.63505-0.49068,1.405-0.85268,2.1284-1.1353,1.2307-0.48106,2.5438-0.55442,3.8115-0.17078,5.6128,1.6969,8.0706,11.668,1.9207,14.064-1.2116,0.14793-2.3289-0.9477-3.4164-3.3542-1.282-3.1846-2.6452-5.3951-4.1063-6.7469-0.89527-1.1293-0.9251-2.0854-0.33901-2.6566h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m361.91,225.47c0.12176,0.3167,0.24351,0.6334,0.36527,0.9501-0.70426,0.27714-1.39959,0.60173-2.0031,1.0641-0.20532-0.26939-0.41063-0.53879-0.61595-0.80818,0.67821-0.52265,1.4608-0.89446,2.25378-1.20602zm4.1397-0.184c-0.0971,0.32552-0.19417,0.65103-0.29125,0.97655-1.13423-0.35172-2.38265-0.2786-3.4832,0.1581-0.12176-0.3167-0.24351-0.6334-0.36527-0.9501,1.30901-0.51874,2.79085-0.59987,4.13972-0.18455zm1.8359,15.058c-0.0406-0.33753-0.0812-0.67507-0.12176-1.0126-0.27912,0.0731,0.32263-0.1496,0.42032-0.21483,1.28691-0.64473,2.20863-1.89602,2.53428-3.28843,0.5175-2.18864-0.0319-4.53642-1.18526-6.43468-0.86302-1.41886-2.16437-2.63523-3.77467-3.13132,0.0971-0.32552,0.19417-0.65103,0.29126-0.97655,2.10301,0.64724,3.74417,2.32874,4.72897,4.25335,1.09263,2.15078,1.52576,4.73659,0.76649,7.06537-0.5164,1.60524-1.74506,2.96313-3.30771,3.60527-0.11609,0.0495-0.22599,0.11317-0.35192,0.13442zm0.12175-0.0312zm-4.0681-3.638c0.29957-0.13883,0.67835-0.24362,0.93025-0.40294,0.48068,1.01549,0.99617,2.09065,1.9142,2.78406,0.28213,0.19944,0.63188,0.32218,0.9799,0.276,0.0406,0.33753,0.0812,0.67507,0.12176,1.0126-1.10232,0.14821-2.06973-0.61202-2.68473-1.45314-0.51458-0.68031-0.91078-1.44159-1.26138-2.21658zm0.008,0.0205zm-4.0407-6.641c0.26341-0.21167,0.52682-0.42333,0.79023-0.635-0.0727-0.0891,0.28225,0.26418,0.37842,0.36804,1.73197,1.85476,2.8468,4.17989,3.80192,6.50513-0.31275,0.12748-0.6255,0.25496-0.93825,0.38244-0.90593-2.20666-1.9542-4.41896-3.59421-6.18282-0.13897-0.15308-0.29604-0.28822-0.43811-0.43779zm0.0525,0.0577zm0.004-3.5418v1.0198c0.20409-0.0789,0.45687-0.23205,0.21115,0.0337-0.28853,0.60098,0.12132,1.25386,0.47283,1.73176,0.0754,0.1823-0.33688,0.30624-0.45012,0.46597-0.18978,0.22169-0.36403,0.27647-0.48643-0.028-0.54972-0.7571-0.91423-1.83414-0.39662-2.70104,0.13722-0.27018,0.35858-0.44484,0.64919-0.52219zm-0.35213,0.14431c0.15654-0.23834,0.52864-0.13897,0.0926-0.038-0.0309,0.0127-0.0618,0.0253-0.0926,0.038zm0.35333,0.87553c-0.002-0.3376-0.002-0.6822,0-1.0198,0.10266,0.30467,0.20532,0.60934,0.30798,0.91401-0.10265,0.0352-0.20538,0.0706-0.30798,0.10579zm0.30798-0.10583z'/%3E %3Cpath d='m362.79,227.74c5.3919-2.1046,9.361,8.2261,4.3224,10.189-2.7049,1.0535-2.9628-2.3307-3.488-4.2117-0.70906-2.5412-6.0126-3.9555-0.83439-5.9772z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m367.29,238.4c-0.12176-0.3167-0.24352-0.6334-0.36528-0.9501,0.80213-0.30555,1.45265-0.96865,1.72956-1.78236,0.45034-1.24488,0.27685-2.63116-0.15073-3.85757-0.47186-1.3165-1.29028-2.56906-2.49712-3.31567-0.85572-0.54839-1.96311-0.68449-2.9171-0.32222-0.21016,0.12628-0.18226-0.24425-0.27585-0.36127-0.0705-0.18325-0.1409-0.3665-0.21135-0.54975,0.81907-0.30917,1.72653-0.40947,2.58209-0.19813,1.38175,0.32533,2.51736,1.31614,3.29788,2.47105,1.03923,1.55084,1.60959,3.46088,1.40049,5.33058-0.13452,1.11832-0.63687,2.22769-1.54018,2.92966-0.31434,0.25883-0.68117,0.44282-1.05241,0.60578zm-4.1576-4.5484c0.32469-0.0922,0.64937-0.1844,0.97406-0.2766,0.32491,1.14092,0.44301,2.36788,1.0537,3.40711,0.23166,0.40197,0.67705,0.70193,1.15487,0.623,0.20986-0.0195,0.41239-0.0828,0.60948-0.15499,0.12176,0.3167,0.24352,0.6334,0.36528,0.9501-0.7368,0.30031-1.64789,0.35671-2.312-0.14566-0.81603-0.60018-1.14-1.62058-1.3959-2.55678-0.1642-0.61185-0.28246-1.23538-0.44949-1.84618zm-0.53-6.5905c0.12176,0.3167,0.24351,0.63339,0.36527,0.95009-0.64587,0.27802-1.35401,0.53203-1.82278,1.08119-0.24964,0.31741,0.056,0.68495,0.25812,0.93453,0.87445,0.98927,2.05105,1.76392,2.58528,3.01493,0.0718,0.17543,0.20317,0.3994-0.0877,0.39157-0.25592,0.0727-0.51184,0.14535-0.76776,0.21802-0.29339-0.9026-1.06393-1.52159-1.71806-2.1642-0.5687-0.55769-1.24725-1.141-1.36893-1.97346-0.0841-0.67969,0.38877-1.27104,0.92435-1.62776,0.50179-0.34913,1.06816-0.59932,1.63219-0.82491z'/%3E %3Cpath d='m363.35,229.27c2.6285-1.0247,6.2382,5.1365,2.9484,6.5364-2.2215,0.94529-3.9774-0.29825-4.69-2.1552-0.71384-1.8569-0.10266-3.6621,1.7416-4.3812z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='m366.5,236.28c-0.1313-0.31269-0.26261-0.62537-0.39391-0.93806,0.4619-0.18696,0.83652-0.58784,0.94358-1.08039,0.18305-0.82587-0.0877-1.67761-0.46061-2.41185-0.44427-0.82683-1.07323-1.60437-1.93395-2.01785-0.34714-0.15605-0.75398-0.22259-1.11746-0.0818-0.12175-0.3167-0.24351-0.63339-0.36526-0.95009,0.58487-0.22259,1.24847-0.17661,1.81733,0.0725,0.93312,0.40124,1.66633,1.1664,2.20737,2.01057,0.56679,0.89648,0.96076,1.946,0.91848,3.01887-0.0238,0.7333-0.33146,1.46905-0.90312,1.94201-0.21094,0.18373-0.46067,0.32053-0.71245,0.43612zm-5.3585-2.4402c0.31434-0.12267,0.62868-0.24534,0.94302-0.36801,0.34832,0.91971,1.04747,1.77357,2.02048,2.05413,0.66131,0.19552,1.37644,0.0841,2.00099-0.18386,0.1313,0.31269,0.26261,0.62537,0.39391,0.93806-0.96407,0.41965-2.10391,0.51065-3.08043,0.0792-1.08141-0.4596-1.86585-1.4412-2.27797-2.51956zm2.0305-5.0403c0.12176,0.3167,0.24352,0.6334,0.36528,0.9501-0.75169,0.27785-1.39916,0.8883-1.6076,1.67637-0.19143,0.67408-0.0933,1.39972,0.15485,2.04574-0.31434,0.12267-0.62868,0.24535-0.94302,0.36802-0.42354-1.07932-0.46895-2.35666,0.10012-3.39298,0.40854-0.76792,1.12591-1.33794,1.93037-1.64725zm0.18264,0.47505c-0.0609-0.15835-0.12176-0.3167-0.18264-0.47505,0.0609,0.15835,0.12176,0.3167,0.18264,0.47505z'/%3E %3Cpath d='m400.08,179.66c3.5166,0,6.3672,2.8719,6.3672,6.4149,0,3.5418-2.8505,6.4149-6.3672,6.4149-3.5166,0-6.3672-2.8719-6.3672-6.4149s2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m406.95,186.07h-1.0122c0.0269-2.1992-1.2954-4.3408-3.2746-5.3-0.79979-0.39878-1.6927-0.60543-2.5861-0.60475v-1.0198c2.3326-0.02,4.6106,1.2607,5.8244,3.2492,0.68633,1.0953,1.0473,2.3839,1.0486,3.6754zm-6.8733,6.9248v-1.0198c2.1696,0.0263,4.2693-1.2872,5.2253-3.2296,0.42015-0.82468,0.63578-1.7502,0.63549-2.6752h1.0122c0.0199,2.3517-1.2544,4.6585-3.2586,5.8897-1.0772,0.67562-2.3441,1.0334-3.6144,1.0349zm-6.8733-6.9248h1.0122c-0.0268,2.1992,1.2955,4.3408,3.2747,5.3,0.79978,0.39881,1.6927,0.60521,2.5861,0.60475v1.0198c-2.3326,0.02-4.6106-1.2607-5.8244-3.2492-0.68639-1.0953-1.0472-2.3839-1.0487-3.6753zm6.8733-6.9249v1.0198c-2.1692-0.0264-4.2688,1.2868-5.2248,3.2285-0.42042,0.82499-0.6362,1.7507-0.6361,2.6761h-1.0122c-0.0196-2.3515,1.2531-4.6597,3.2586-5.8897,1.0773-0.67541,2.3438-1.0338,3.6145-1.0348z' fill='%2321231e'/%3E %3Cpath d='m395.43,169c3.5166,0,6.3672,2.8719,6.3672,6.4161,0,3.543-2.8505,6.4149-6.3672,6.4149-3.5166,0-6.3672-2.8719-6.3672-6.4149,0-3.5442,2.8505-6.4161,6.3672-6.4161z' fill='%23FFF'/%3E %3Cpath d='m402.31,175.42h-1.0123c0.0262-2.1859-1.2784-4.3173-3.2399-5.2834-0.80826-0.41092-1.7145-0.62294-2.6208-0.62248v-1.0198c2.3327-0.0202,4.6104,1.261,5.8244,3.2492,0.68585,1.0969,1.048,2.3836,1.0486,3.6765zm-6.8733,6.9249v-1.0198c2.1692,0.0263,4.2688-1.2868,5.2248-3.2285,0.42041-0.82501,0.63643-1.7507,0.63599-2.6761h1.0123c0.0196,2.3515-1.2531,4.6597-3.2586,5.8897-1.0772,0.67541-2.3438,1.0337-3.6144,1.0348zm-6.8733-6.9249h1.0122c-0.0267,2.1992,1.2956,4.3408,3.2748,5.3,0.79978,0.39879,1.6927,0.60526,2.5861,0.60464v1.0198c-2.3326,0.0201-4.6106-1.2606-5.8244-3.2491-0.68647-1.0953-1.047-2.384-1.0488-3.6753zm6.8733-6.9261v1.0198c-2.1697-0.0263-4.2691,1.2876-5.2253,3.2297-0.41957,0.82525-0.636,1.751-0.63569,2.6764h-1.0122c-0.0201-2.3519,1.2532-4.6604,3.2586-5.8909,1.0773-0.6756,2.3441-1.0335,3.6146-1.035z' fill='%2321231e'/%3E %3Cpath d='m410.68,131.46c3.3913,0,6.1404,2.7685,6.1404,6.1852s-2.7491,6.1864-6.1404,6.1864c-3.3901,0-6.1404-2.7697-6.1404-6.1864s2.7491-6.1852,6.1404-6.1852z' fill='%23FFF'/%3E %3Cpath d='m417.32,137.65h-1.0122c0.0249-2.1141-1.2455-4.1742-3.1497-5.0944-0.76829-0.38324-1.6262-0.58096-2.4844-0.58064v-1.0198c2.2555-0.0199,4.4585,1.2189,5.6317,3.1418,0.66698,1.0577,1.0114,2.305,1.0146,3.5531zm-6.6465,6.6964v-1.0198c2.0858,0.0245,4.1056-1.2375,5.0234-3.106,0.40443-0.79205,0.60972-1.6817,0.61067-2.5702h1.0122c0.0194,2.2741-1.212,4.5064-3.152,5.6948-1.0403,0.65607-2.266,0.99891-3.4944,1.0012zm-6.6465-6.6964h1.0122c-0.0247,2.102,1.2305,4.1506,3.1171,5.0787,0.77624,0.39428,1.6468,0.59699,2.5169,0.59745v1.0198c-2.2429,0.019-4.4344-1.2054-5.6115-3.1112-0.68009-1.0637-1.0318-2.3249-1.0348-3.5848zm6.6465-6.6952v1.0198c-2.0856-0.0248-4.1053,1.2367-5.0235,3.1048-0.40442,0.79205-0.60978,1.6817-0.61057,2.5702h-1.0122c-0.0193-2.2614,1.198-4.4816,3.1202-5.6744,1.0485-0.6675,2.2842-1.0192,3.5261-1.0205z' fill='%2321231e'/%3E %3Cpath d='m400.36,136.18c3.5166,0,6.3672,2.8719,6.3672,6.4149,0,3.5442-2.8505,6.4161-6.3672,6.4161-3.5166,0-6.3672-2.8719-6.3672-6.4161,0-3.543,2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m407.23,142.59h-1.0123c0.0268-2.1992-1.2955-4.3408-3.2747-5.3-0.79978-0.39882-1.6927-0.60543-2.5861-0.60474v-1.0198c2.3326-0.02,4.6106,1.2607,5.8244,3.2492,0.68638,1.0953,1.0472,2.3839,1.0487,3.6753zm-6.8733,6.9261v-1.0198c2.1564,0.0259,4.2443-1.271,5.2076-3.1947,0.43102-0.83399,0.65397-1.7727,0.65332-2.7111h1.0122c0.0201,2.3519-1.2532,4.6604-3.2586,5.8909-1.0772,0.67547-2.3439,1.0336-3.6145,1.0348zm-6.8733-6.9261h1.0122c-0.0261,2.1859,1.2785,4.3173,3.24,5.2834,0.80829,0.41083,1.7145,0.62315,2.6208,0.62259v1.0198c-2.3327,0.0202-4.6104-1.261-5.8244-3.2492-0.68596-1.0969-1.0479-2.3837-1.0487-3.6766zm6.8733-6.9249v1.0198c-2.1692-0.0263-4.2688,1.2869-5.2248,3.2286-0.42046,0.82498-0.63626,1.7507-0.6359,2.6761h-1.0122c-0.0196-2.3515,1.2531-4.6597,3.2586-5.8897,1.0772-0.67545,2.344-1.0336,3.6143-1.0349z' fill='%2321231e'/%3E %3Cpath d='m392.77,145.25c3.5166,0,6.3672,2.8719,6.3672,6.4161,0,3.543-2.8505,6.4149-6.3672,6.4149-3.5166,0-6.3672-2.8719-6.3672-6.4149,0-3.5442,2.8505-6.4161,6.3672-6.4161z' fill='%23FFF'/%3E %3Cpath d='m399.64,151.66h-1.0122c0.0263-2.1859-1.2783-4.3173-3.2398-5.2834-0.80826-0.41092-1.7145-0.62294-2.6208-0.62248v-1.0198c2.3327-0.0202,4.6104,1.261,5.8244,3.2492,0.68578,1.0969,1.0482,2.3835,1.0484,3.6764zm-6.8733,6.9249v-1.0198c2.1692,0.0263,4.2688-1.2868,5.2248-3.2285,0.42052-0.82496,0.63592-1.7507,0.63568-2.6761h1.0122c0.0196,2.3515-1.2531,4.6597-3.2586,5.8897-1.0771,0.6754-2.3441,1.0337-3.6141,1.0348zm-6.8733-6.9249h1.0122c-0.0265,2.1857,1.2786,4.3162,3.2397,5.2822,0.80826,0.41089,1.7145,0.62292,2.6208,0.62246v1.0198c-2.3326,0.0201-4.6106-1.2606-5.8244-3.2491-0.68617-1.0953-1.0476-2.3838-1.0484-3.6753zm6.8733-6.9261v1.0198c-2.1697-0.0263-4.2691,1.2876-5.2254,3.2297-0.4195,0.82525-0.636,1.751-0.63557,2.6764h-1.0122c-0.0201-2.3519,1.2532-4.6604,3.2586-5.8909,1.0772-0.67557,2.3441-1.0335,3.6145-1.035z' fill='%2321231e'/%3E %3Cpath d='m391.54,156.66c3.5178,0,6.3672,2.8719,6.3672,6.4149s-2.8494,6.4149-6.3672,6.4149c-3.5166,0-6.3672-2.8719-6.3672-6.4149s2.8505-6.4149,6.3672-6.4149z' fill='%23FFF'/%3E %3Cpath d='m398.41,163.08h-1.0122c0.0261-2.186-1.2787-4.316-3.2396-5.2828-0.80866-0.40993-1.7148-0.62273-2.6212-0.62192v-1.0198c2.3462-0.0205,4.6365,1.2759,5.8458,3.283,0.67214,1.0883,1.026,2.3634,1.0273,3.6415zm-6.8733,6.9248v-1.0198c2.1825,0.0271,4.2942-1.303,5.2424-3.2635,0.40884-0.81623,0.61864-1.7288,0.6183-2.6412h1.0122c0.0214,2.4236-1.3346,4.8012-3.4437,5.9998-1.0344,0.60654-2.2316,0.92283-3.4293,0.92471zm-6.8733-6.9248h1.0122c-0.027,2.1992,1.2954,4.3408,3.2746,5.3,0.79978,0.39884,1.6927,0.60539,2.5861,0.60485v1.0198c-2.3326,0.0201-4.6106-1.2606-5.8244-3.2491-0.68648-1.0953-1.0471-2.3841-1.0486-3.6756zm6.8733-6.9249v1.0198c-2.1692-0.0262-4.2688,1.2869-5.2248,3.2286-0.42041,0.82499-0.6363,1.7507-0.636,2.6761h-1.0122c-0.0196-2.3515,1.2531-4.6597,3.2586-5.8897,1.0772-0.67563,2.3442-1.0333,3.6144-1.0349z' fill='%2321231e'/%3E %3Cpath d='m474.41,198.02c-2.7013-5.0307-5.5662-8.2478-8.5958-9.6501,4.1756-13.155,5.158-30.146,2.7025-51.096-0.24828-3.1305-1.0206-4.4787-2.2131-4.457-1.0457,0.0193-1.6783,1.6164-1.781,5.2207,0.75919,11.525,1.6927,21.606,1.1698,30.165-0.46792,7.6428-2.262,13.996-4.2376,21.155-0.27335,0.99339,0.43093,1.7751,3.8688,3.7126,2.5366,1.4432,4.1338,3.2171,4.6662,5.0728,0.73531-0.29585,1.2068-0.20686,1.4718-0.12989,2.5474,0.73843,3.6229,0.53758,2.9484,0.006v0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m465.33,188.22c1.37942,0.84479,0.31363-0.67394,1.28681-0.01,3.76061,2.12291,6.20398,5.87985,8.2353,9.57188-0.87222,0.8986-1.20795,0.009-1.59666-0.78278-1.90541-3.21156-4.20476-6.4853-7.65567-8.16132-0.0899-0.20605-0.17985-0.41211-0.26978-0.61816zm0.26978,0.61816zm2.4101-51.518c1.12748-0.4471,1.13948,0.34547,1.15895,1.25699,1.56937,14.5214,1.94753,29.383-1.20325,43.7277-0.46846,2.09789-1.02767,4.17533-1.67337,6.22559-1.22934-0.0134-0.86137-0.85442-0.54607-1.67675,3.91271-13.5333,4.09303-27.8283,3.03051-41.7787-0.20758-2.58945-0.4685-5.17452-0.76677-7.75483zm0.001,0.0193zm-1.701-4.0072c-0.19093-0.76289,0.0524-1.3177,0.82729-0.83763,1.59379,0.95796,1.67718,3.09014,1.87987,4.74411-1.07379,0.41608-1.13182-0.33938-1.1566-1.21707-0.2164-0.91076-0.35969-2.57892-1.55056-2.68941zm-1.2856,4.6771c-1.02215,0.36256-1.15101-0.22633-0.95725-1.09606,0.17758-1.51285,0.17263-3.41719,1.52306-4.40726,0.74295-0.58735,0.86282,0.30832,0.66959,0.8287-0.93085,0.468-0.90426,1.78623-1.0958,2.68657-0.0792,0.61762-0.12483,1.52458-0.1396,1.98805zm-1.0099,0.0673zm2.1797,30.162c-1.23365,0.30441-1.0192-0.66798-0.93435-1.54611,0.33379-9.55667-0.66155-19.0888-1.24515-28.6163,1.18603-0.46038,1.09872,0.53314,1.10948,1.41694,0.59843,9.56475,1.58916,19.1546,1.07002,28.7455zm-4.2555,21.259c-1.20299,0.0323-0.90558-0.78215-0.60808-1.59939,1.80387-6.45388,3.4768-13.0046,3.85379-19.7224,1.18731-0.28827,1.04352,0.59868,0.90828,1.46297-0.53653,6.77042-2.339,13.3422-4.15399,19.8588zm3.63,3.1329c-0.24124,1.05666-0.83274,0.86412-1.51798,0.29819-1.20654-0.82645-2.99228-1.55125-3.15939-3.20158-0.25332-0.78259,1.25767-0.45275,1.03026,0.1456,0.7578,1.33978,2.39775,1.94414,3.64711,2.75779zm-0.001-0.001zm4.2317,5.0451c0.76811,1.01675-0.15908,1.11383-0.44816,0.17286-0.78609-1.94114-2.51229-3.31112-4.27885-4.32922,0.24923-1.06711,0.87973-0.82762,1.54569-0.23741,1.69903,1.14774,3.26431,2.70946,3.85486,4.72449-0.22453-0.11019-0.44896-0.22075-0.67354-0.33072zm0.37481,0.94527zm1.4241-1.092c-0.1866,0.38056-0.063,1.16407-0.65363,0.92297-0.38135-0.0622-0.88968,0.42057-0.92103-0.21472-0.56454-0.65372,0.2405-0.75974,0.7515-0.80105,0.27489-0.0146,0.56629,0.009,0.82316,0.0928zm3.3149,0.4955c-1.51257,0.4011-0.52734-0.77183,0.10738-0.0661,0.42231,0.92313-0.85888,1.21724-1.52311,1.0199-0.73933-0.0857-1.46417-0.26529-2.17849-0.4701-0.004-1.10162,0.6533-0.97421,1.46593-0.67914,0.44159,0.11125,1.13843,0.17931,1.46606,0.15529-0.5855,1.01666,0.28797,0.0872,0.66223,0.0402zm-1.0122,0c-0.62826-1.45559,1.18286-0.70396,0.44969-0.22091-0.14989,0.0736-0.29981,0.14726-0.44969,0.22091zm0,0.001c1.32674-0.19986,0.81027,0.29768,0.0276,0.11036l-0.0277-0.11036h0.00008z'/%3E %3Cpath d='m458.4,214.56c1.5649-0.98617,1.8717-0.724,2.3742-1.371,0.64699-0.83223,0.65534-2.1984,0.45242-3.5081-0.81888-5.2844,2.3349-4.5472,5.8825-2.2105,1.7738,1.169,3.5584,3.8822,5.0828,5.2989,1.5244,1.4155,2.7885,1.537,3.1681,2.0962,0.0477,2.0277,0.0573,3.7799,0.0429,4.5725v0.005c0.0144,0.79255,0.006,2.5424-0.0429,4.5701-0.38079,0.55924-1.6449,0.6795-3.1681,2.0962-1.5244,1.4167-3.3089,4.1299-5.0828,5.2977-3.5477,2.338-6.7014,3.074-5.8825-2.2105,0.20172-1.3097,0.19457-2.6759-0.45242-3.5081-0.50254-0.64703-0.80932-0.38484-2.3742-1.371-1.0158-0.63861-1.7774-1.4083-2.2847-2.243-0.50733-0.83583-0.23158-1.7354-0.23158-2.635,0-0.90078-0.27575-1.8004,0.23158-2.635,0.50732-0.83583,1.2689-1.6055,2.2847-2.2441z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m460.37,212.87c1.18548,0.4309,0.46548,1.22528-0.4026,1.44027-0.6942,0.31908-1.65135,1.05561-1.78302-0.22459,0.66418-0.51447,1.57497-0.64672,2.18562-1.21568zm0.34975-3.1161c1.66152-0.73563,1.08592,1.7692,0.95562,2.68595-0.0351,0.98508-0.96484,1.26062-1.22021,0.30612,0.51981-0.90828,0.39262-2.00011,0.26459-2.99207zm6.6596-2.7144c-0.61882,1.79782-2.14069-0.59072-3.31288-0.6057-1.39327-0.84731-2.81313,0.3906-2.46901,1.87803,0.2261,0.819,0.11931,1.74565-0.89471,1.3245-0.19934-1.45513-0.34213-3.47111,1.1983-4.25573,1.69634-0.62165,3.39551,0.43359,4.83575,1.25051,0.21658,0.13231,0.4306,0.26879,0.64255,0.40839zm5.1484,5.3506c-0.82452,1.59132-1.76893-0.63023-2.49459-1.23321-0.97957-1.16938-1.9563-2.37274-3.20769-3.2659,0.56227-1.72221,1.84758,0.36927,2.55418,0.95362,1.06744,1.16575,2.00633,2.448,3.1481,3.54549zm3.3304,2.4582c-0.45016-0.0764-1.03489,0.0857-1.05868,0.19811-0.97156-0.59172-2.08123-1.01326-2.87434-1.84878,0.46757-1.55931,1.54561,0.21739,2.43408,0.43537,0.52208,0.33623,1.34803,0.52532,1.49894,1.2153zm-0.0871-0.2754zm0.1313,4.8599c-1.77224,0.45486-0.73294-1.92075-1.02182-2.90777-0.10721-0.8674-0.19677-2.18358,0.97764-1.56964,0.0459,1.49166,0.0538,2.98517,0.0442,4.47741zm-1.0122,0,0-0.009,0,0.009zm0,0.005c0.61973-0.017,1.16401,0.007,0.21039,0.007l-0.21039-0.007zm0,0.009,0-0.009,0,0.009zm0.87976,4.8491c-0.31266-0.45475-1.05634-0.38426-0.91328-0.5872,0.0278-1.42039,0.0482-2.84116,0.0327-4.26184,1.78729-0.4773,0.74646,1.9645,1.00579,2.95611-0.0438,0.62465,0.0375,1.2872-0.12524,1.89293zm0.0883-0.2766zm-3.3304,2.4582c-1.48587-0.92203,0.64603-1.70404,1.41636-2.18072,0.50399-0.58439,1.71861-0.60868,1.70096,0.13594-0.94962,0.81892-2.25536,1.07838-3.11732,2.04478zm-5.1484,5.3494c-1.28484-1.09729,0.90131-1.68589,1.37139-2.62008,1.04112-1.14956,1.96247-2.40877,3.09184-3.47714,1.47565,0.92104-0.71621,1.83092-1.14645,2.76787-1.00718,1.19959-2.01918,2.429-3.31678,3.32935zm-6.6596-2.7144c1.64003-0.23117,0.57413,1.54398,0.95186,2.46346,0.14768,1.32209,1.71251,1.25194,2.60838,0.76886,0.91055-0.22035,1.89696-1.17195,2.60546-1.23969,1.14022,0.93503-0.73692,1.3325-1.35285,1.8044-1.17626,0.57406-2.69901,1.1741-3.92225,0.41687-1.29396-0.97662-1.06914-2.80368-0.8906-4.2139zm-0.35095-3.1161c1.18529-1.52884,1.58413,1.17265,1.46784,2.07599,0.3484,0.93518-0.6327,1.65645-1.08304,0.80316,0.0992-0.96143,0.20333-2.04223-0.3848-2.87915zm-2.243-1.2532c0.39022-1.50965,1.66912-0.0909,2.55469,0.17623,1.0376,0.44049-0.50984,1.51892-0.89647,0.66417-0.58922-0.209-1.13368-0.50317-1.65822-0.8404zm0.53478-0.8635zm-2.983-1.5454c1.10418-1.22212,1.55272,0.87724,2.54429,1.24768,0.94022,0.26665-0.27871,1.72968-0.78634,0.68092-0.69202-0.53357-1.30443-1.17918-1.75795-1.9286zm-0.30678-2.9008c1.72116-0.47493,0.52001,1.53663,1.167,2.3694-1.08874,1.22529-1.3942-0.64701-1.21833-1.51358,0.0189-0.28515,0.0447-0.57,0.0513-0.85582zm0.30678-2.9008c1.41825,0.36586,0.31098,1.86905,0.70775,2.90066-1.52096,0.46478-1.09415-1.53064-0.93707-2.41927,0.0567-0.16888,0.13332-0.33123,0.22932-0.48139zm2.4471-2.4101c1.1864,0.99833-0.58124,1.42646-1.06794,2.22844-0.18885,0.82728-1.18406,0.73197-1.27267,0.0103,0.59561-0.91308,1.42096-1.66108,2.34061-2.23872zm0.53715,0.8635z'/%3E %3Cpath d='m475.52,220.24-0.1313,0.88877c-3.7518,0.47384-6.8494,1.9856-9.5543,4.356,1.7893-2.6675,5.6283-4.6531,9.6856-5.2448z' fill='%2321231e'/%3E %3Cpath d='m475.52,218.64-0.1313-0.88877c-3.7518-0.47504-6.8494-1.9856-9.5543-4.356,1.7893,2.6663,5.6283,4.6518,9.6856,5.2448z' fill='%2321231e'/%3E %3Cpath d='m461.16,207.28c1.1412,0.46904,2.3838,0.97174,3.4366,1.994,1.5996,1.5526,0.56342,4.1299-1.5041,6.6242-0.65176,0.78653-0.96689,2.1768-0.96212,3.561,0.005,1.3842,0.33185,2.7625,0.96212,3.5238,2.0663,2.4943,3.1036,5.0716,1.5041,6.6242-1.0516,1.0223-2.2943,1.5226-3.4355,1.9928-0.10982-0.60133-0.0979-1.3903,0.0585-2.4017,0.20293-1.3097,0.19577-2.6759-0.45121-3.5081-0.50374-0.64703-0.80933-0.38485-2.3754-1.3698-1.0146-0.63982-1.7762-1.4095-2.2847-2.2442-0.50732-0.83463-0.23159-1.7342-0.23159-2.635,0-0.90079-0.27693-1.8004,0.23159-2.635,0.50851-0.83584,1.2701-1.6055,2.2847-2.2442,1.5661-0.98617,1.8717-0.72398,2.3754-1.371,0.64697-0.83224,0.65414-2.1984,0.45121-3.5081-0.15637-1.0114-0.16831-1.8016-0.0585-2.4029h-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m464.95,208.9c-0.23397,0.24454-0.46793,0.48908-0.7019,0.73362-0.91295-0.89844-2.10691-1.41622-3.27672-1.8897,0.12733-0.31429,0.25465-0.62858,0.38198-0.94287,1.29138,0.51733,2.59275,1.10862,3.59664,2.09895zm-1.467,7.3169c-0.25837-0.21773-0.51881-0.4345-0.7759-0.65283,0.9859-1.23087,1.98239-2.60024,2.15917-4.21287,0.0559-0.62706-0.14991-1.28456-0.61894-1.71738,0.23396-0.24454,0.46793-0.48907,0.70189-0.73361,0.98976,0.90738,1.13073,2.40311,0.71294,3.62054-0.43276,1.37583-1.27552,2.59395-2.17916,3.69615zm-0.84394,3.2339c-0.3374,0.00067-0.6748,0.001-1.0122,0.002,0.0161-1.34951,0.22439-2.79638,1.0809-3.88792,0.25864,0.21728,0.51727,0.43455,0.77591,0.65183-0.68638,0.90697-0.82812,2.13163-0.84461,3.23409zm0.84394,3.199c-0.25863,0.21728-0.51727,0.43456-0.7759,0.65184-0.84391-1.08251-1.05407-2.51246-1.0802-3.8482,0.3374-0.00067,0.6748-0.001,1.0122-0.002,0.0222,1.09578,0.1677,2.29982,0.8439,3.19836zm1.467,7.3169c-0.23397-0.24454-0.46793-0.48908-0.7019-0.73362,0.84296-0.77049,0.70835-2.05256,0.29983-3.00919-0.4335-1.07432-1.10998-2.03049-1.84016-2.92228,0.25864-0.21728,0.51727-0.43456,0.77591-0.65184,1.14221,1.41733,2.26777,3.03194,2.39743,4.90445,0.0505,0.89239-0.27714,1.79488-0.93111,2.41248zm-4.2842,1.7186c0.33185-0.0617,0.6637-0.12347,0.99555-0.1852-0.12951-0.14538-0.893-0.32577-0.53127-0.44424,1.11746-0.45229,2.24687-0.96625,3.1179-1.8228,0.23396,0.24454,0.46793,0.48908,0.70189,0.73362-1.00301,0.98942-2.30518,1.58051-3.59541,2.09746-0.22948-0.12626-0.45952-0.25267-0.68866-0.37884zm0.68877,0.37885c-0.31438,0.13297-0.70547,0.40623-0.64606-0.14447-0.17173-0.48675,0.42527,0.094,0.63662,0.13928l0.009,0.005zm-0.63267-2.9513c0.33343,0.0521,0.66687,0.10422,1.0003,0.15633-0.10837,0.73614-0.18489,1.49174-0.0599,2.2309-0.33185,0.0617-0.66369,0.12347-0.99554,0.1852-0.14582-0.85155-0.0683-1.72425,0.0551-2.57243zm-0.34855-3.1161c0.265-0.20926,0.53-0.41853,0.795-0.62779,0.82549,1.11333,0.7398,2.59874,0.5537,3.9001-0.33343-0.0521-0.66687-0.10423-1.0003-0.15634,0.13479-1.02312,0.27025-2.22191-0.3484-3.11597zm-2.2465-1.252c0.1782-0.28754,0.36052-0.57738,0.53617-0.8635,0.63697,0.4534,1.39858,0.66928,2.06695,1.05851,0.15701,0.14805,0.62886,0.40966,0.26499,0.56657-0.23708,0.0814-0.5187,0.6382-0.72247,0.37271-0.48577-0.37574-1.12606-0.49084-1.63927-0.83365-0.17157-0.0954-0.34011-0.19737-0.50637-0.30064zm0.001,0c-0.37599-0.23571-0.56675-0.3574-0.0797-0.0503-0.0554-0.007,0.11159,0.0504,0.0797,0.0503zm-2.4483-2.4101c0.28699-0.17769,0.57628-0.3541,0.86185-0.53258,0.52134,0.85548,1.27934,1.54762,2.1224,2.0789-0.17905,0.28784-0.35811,0.57568-0.53716,0.86352-0.97569-0.61387-1.84565-1.42091-2.44709-2.40984zm0,0.001c0.18231,0.29745,0.43538,0.71543,0.10978,0.18031-0.0366-0.0601-0.0734-0.12015-0.10978-0.18031zm-0.30678-2.902h1.0122c0.0213,0.78443-0.27018,1.64568,0.1542,2.3695-0.28728,0.17719-0.57456,0.35439-0.86184,0.53158-0.56554-0.87544-0.33583-1.92989-0.30456-2.90108zm0.30678-2.9008c0.28699,0.17769,0.57628,0.3541,0.86185,0.53259-0.42471,0.72279-0.1369,1.58398-0.1564,2.3678h-1.0123c-0.0267-0.97393-0.26122-2.02696,0.30685-2.90039zm2.4471-2.4101c0.17819,0.28754,0.36052,0.57738,0.53616,0.8635-0.84229,0.53142-1.59938,1.2224-2.1207,2.0772-0.28728-0.17719-0.57457-0.35439-0.86185-0.53158,0.59819-0.98949,1.47812-1.8011,2.44639-2.40912zm2.2465-1.2532c0.26501,0.20926,0.53001,0.41851,0.79502,0.62777-0.53026,0.73148-1.50814,0.8111-2.21065,1.30913-0.337,0.37957-0.4591-0.13021-0.64487-0.38502-0.38137-0.32095,0.0717-0.45225,0.33787-0.61056,0.50767-0.33849,1.14231-0.44951,1.62105-0.82394,0.0359-0.0367,0.0688-0.0802,0.10158-0.11738zm0.34856-3.1161c0.33343-0.0521,0.66687-0.10423,1.0003-0.15634,0.18585,1.30135,0.27187,2.78679-0.5538,3.90002-0.26501-0.20926-0.53001-0.41851-0.79502-0.62777,0.62008-0.89094,0.48426-2.09996,0.34852-3.11591zm0.44167-1.9711v-1.0198c0.16015,0.2853,0.60612,0.48864,0.46078,0.85993-0.0663,0.65848-0.001,1.3227,0.097,1.9746-0.33343,0.0521-0.66687,0.10423-1.0003,0.15635-0.12519-0.84945-0.20104-1.72114-0.0558-2.5732,0.16614,0.2004,0.33198,0.4033,0.49832,0.60212zm0-1.0198c0.39362-0.0362,0.76271-0.052,0.52816,0.43586,0.0319,0.45434-0.41609-0.39493-0.52816-0.43586zm-0.001,0c0.002,0.33761,0.002,0.6822,0,1.0198-0.39382-0.0281,0.002-0.58526-0.0323-0.8538,0.0108-0.0553,0.0215-0.11066,0.0323-0.166z'/%3E %3Cpath d='m361,226.26,0.67683-0.29225c-1.5399-2.1515-1.8729-4.2081-1.2832-6.2658-1.3119,1.6356-0.99195,4.2117,0.6064,6.558z' fill='%2321231e'/%3E %3Cpath d='m410.74,199.91c1.3286,1.6861,1.1686,2.0902,1.8896,2.5737,0.94064,0.62418,2.2167,0.4065,3.4008-0.0458,4.8583-1.8593,4.8607,2.0048,3.4486,6.4282-0.68399,2.1455-2.7562,4.4714-3.6802,6.2959-0.90841,1.7871-0.71265,3.1257-1.1197,3.5827-1.7619,0.29225-3.2755,0.50632-3.9643,0.5857h-0.005c-0.67444,0.10822-2.1749,0.30186-3.907,0.48826-0.56701-0.3235-1.0051-1.5935-2.6118-2.9874-1.6127-1.4011-4.4024-2.9176-5.9028-4.6302-3.0439-3.4732-4.6626-6.8106,0.12413-6.694,1.1913,0.03,2.3826-0.18761,2.9162-1.0439,0.42256-0.66868,0.10505-0.97174,0.51568-2.9285,0.26857-1.2832,0.73889-2.3067,1.3429-3.0427,0.61355-0.74924,1.5088-0.58449,2.3337-0.73843,0.832-0.15635,1.5888-0.64703,2.508-0.18159,0.91794,0.46542,1.8454,1.2375,2.7109,2.3367v0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m412.91,202.06c-0.24397,0.18063-0.37488,0.97042-0.69325,0.75341-0.74601-0.60238-1.01722-1.58368-1.64479-2.29142-0.49912-0.36791,0.24652-0.58241,0.48483-0.86046,0.27808-0.0362,0.47403,0.54673,0.70133,0.77338,0.41463,0.51253,0.609,1.23976,1.15188,1.62509zm-0.55627,0.85147zm3.4999-0.94769c0.0129,0.33317,0.61853,0.941,0.12056,1.0389-1.15017,0.41363-2.54114,0.62103-3.62049-0.0918,0.24401-0.20341,0.36771-0.91928,0.69348-0.76968,0.8852,0.4442,1.93388,0.13883,2.80645-0.17742zm4.1087,7.0608c-0.27846-0.20085-1.13945-0.1-0.87927-0.57982,0.44637-1.60236,0.97215-3.322,0.545-4.98364-0.20269-0.84819-1.16333-1.11748-1.92675-0.95466-0.5118,0.0748-1.00769,0.22892-1.49094,0.40999-0.0167-0.34186-0.63635-0.96369-0.0946-1.04624,1.22774-0.44544,2.83069-0.74718,3.87145,0.25951,1.05887,1.16649,0.86851,2.89202,0.63092,4.32717-0.15433,0.87043-0.39348,1.7267-0.65582,2.56769zm-3.7112,6.3716c-0.23863-0.2412-1.10928-0.28485-0.77209-0.70704,1.11509-2.02556,2.75191-3.76811,3.52122-5.97728,0.26167,0.19475,1.0899,0.10332,0.88931,0.53157-0.83347,2.25699-2.51729,4.05207-3.63844,6.15275zm-1.4873,3.8533c-0.14463-0.27326,0.043-1.23142-0.40949-0.87007-0.0587-0.0215,0.14704-0.47317,0.13547-0.65649,0.15822-0.9634,0.40816-1.92105,0.86134-2.79097,0.23368,0.23827,1.06604,0.27588,0.79417,0.68279-0.50679,0.97344-0.55063,2.08914-0.87104,3.11875-0.0882,0.25488-0.26442,0.41606-0.51045,0.51599zm0.29365-0.16236zm-4.3403,0.75525c0.0679-0.31318-0.12865-1.01507,0.0812-1.0318,1.27135-0.1567,2.53703-0.35681,3.80093-0.5645-0.0517,0.32745,0.41118,1.02396-0.069,1.04428-1.26745,0.20074-2.54054,0.4137-3.81311,0.55202zm0.0573-0.004zm0.0179-0.004c-0.0351-0.22048-0.21657-1.36105-0.11601-0.72919,0.0649,0.7025,0.0261-0.75971,0.04-0.0737,0.00052,0.12039,0.00056,1.17223-0.004,0.60028-0.0189-0.67681,0.0299-0.0119,0.08,0.20258zm-0.15997-1.0054zm-4.0765,1.4348c0.0582-0.30702,0.80093-0.92604,0.22504-0.94402,0.28877-0.0526,0.82698-0.0946,1.21336-0.14584,0.88077-0.10435,1.76146-0.21124,2.63837-0.3446-0.0528,0.31974,0.39183,1.00278-0.0512,1.03824-1.2594,0.17036-2.52702,0.35811-3.7906,0.44554-0.0779-0.0169-0.15835-0.0312-0.23492-0.0493zm0.3032,0.0625zm-2.9962-3.1076c0.27647-0.15025,0.50802-0.96512,0.81549-0.635,0.92597,0.77437,1.54684,1.82062,2.30491,2.73926,0.0645,0.21682-0.31467,0.81028-0.48621,0.90274-0.7937-0.63758-1.19778-1.63066-1.93374-2.33194-0.22-0.23813-0.45677-0.46318-0.70045-0.67506zm-5.9518-4.6795c0.31316-0.13758,0.65896-0.92358,0.94131-0.47393,1.67851,1.72083,3.851,2.83163,5.67176,4.38135-0.28972,0.17711-0.52723,1.00206-0.8624,0.60054-1.88991-1.53492-4.10283-2.68578-5.75067-4.50796zm0.51687-7.5394c-0.12017,0.29644,0.21583,1.06366-0.23506,1.01698-0.75382,0.0303-1.71917,0.01-2.19908,0.69702-0.31024,0.90853,0.29283,1.81479,0.7219,2.58186,0.5652,0.91854,1.24977,1.75641,1.95448,2.5703-0.313,0.13758-0.66963,0.93729-0.94226,0.46202-1.16407-1.41458-2.43432-2.89957-2.81184-4.74226-0.22253-1.02177,0.44518-2.08212,1.45321-2.34232,0.66023-0.22308,1.36726-0.25246,2.05865-0.2436zm2.4769-0.80938c0.18354,0.24797,1.00944,0.37544,0.74466,0.70281-0.75275,0.97935-2.09419,1.15226-3.24807,1.12222,0.11031-0.30563-0.20022-1.04455,0.2339-1.0164,0.79431-0.0158,1.78108-0.0864,2.26951-0.80863zm-0.002,0.004zm0.45003-2.7625c0.2604,0.16521,1.03933-0.009,0.95268,0.38346-0.237,0.85561-0.09,1.77567-0.3822,2.61382-0.10564,0.56234-0.51912,0.0335-0.8114-0.10579-0.39753-0.12206,0.0758-0.49866-0.0276-0.79832,0.0341-0.7034,0.11746-1.40833,0.2685-2.09317zm1.4468-3.2628c0.15803,0.26335,0.8816,0.46813,0.68669,0.76725-0.59907,0.78932-0.93905,1.74347-1.14492,2.70437-0.28648-0.16869-1.12467,0.0173-0.9335-0.45942,0.2548-1.08115,0.68667-2.14872,1.39173-3.0122zm0.78067,0.64944c0.16497-0.20348,0.81454-0.99221,0.33957-0.41395-0.11321,0.13793-0.22624,0.27626-0.33957,0.41395zm1.8502-1.5634c-0.0496,0.30061,0.39118,0.9468,0.0277,1.0267-0.63371,0.11579-1.4194-0.0223-1.8776,0.5326-0.16725-0.27482-0.98167-0.50774-0.62657-0.81773,0.64951-0.68314,1.62931-0.62437,2.47646-0.74157zm0.18621,1.0006c-0.33784,0.0648-1.13052,0.21117-0.35025,0.0656,0.11659-0.0218,0.23442-0.0442,0.35025-0.0656zm2.6417-1.1365c-0.23096,0.23038-0.25387,1.01596-0.63861,0.83101-0.6847-0.21078-1.33798,0.20096-2.003,0.3047,0.0421-0.34578-0.45251-1.03858,0.0818-1.06337,0.82662-0.26273,1.74599-0.53268,2.5598-0.0723zm2.9902,2.7914c-0.29128,0.0991-1.20265-0.24285-0.92046,0.26421-0.11243-0.0773-0.46086-0.54968-0.69132-0.75841-0.53678-0.55001-1.14633-1.03627-1.8321-1.3877,0.22774-0.22529,0.26564-1.04856,0.64219-0.80941,1.06654,0.59994,2.00868,1.44992,2.71544,2.4411,0.0285,0.0832,0.0591,0.16804,0.0863,0.25021zm-0.10982-0.3163zm-0.90243,0.31751c0.19535,0.0299,1.14307-0.0649,0.88023,0.0462-0.33506,0.0266-0.8473,0.55557-0.88023-0.0462zm0.10982,0.31629z'/%3E %3Cpath d='m410.05,219.43c-0.26381-0.007-0.52762-0.0205-0.79261-0.0325-1.368-3.8364-3.5011-6.9321-6.3063-9.5358,2.8159,1.5731,5.5614,5.4155,7.0989,9.5695v-0.001z' fill='%2321231e'/%3E %3Cpath d='m411.43,219.24c0.2471-0.0806,0.493-0.15995,0.74009-0.24173-0.50255-3.9892,0.0668-7.5358,1.5363-10.88-1.9612,2.3752-2.7598,6.8058-2.2764,11.122z' fill='%2321231e'/%3E %3Cpath d='m418.3,201.97c-0.18025,1.4227-0.36527,2.9537-1.0719,4.3187-1.0636,2.0541-3.6838,1.2628-6.483-0.69874-0.88094-0.61817-2.231-0.76129-3.4772-0.5412-1.2426,0.21888-2.3826,0.79135-2.8792,1.6128-1.596,2.6386-3.5118,4.1203-5.3096,2.6134-1.1913-1.0006-1.997-2.291-2.7515-3.4769,0.48226-0.21046,1.1651-0.31509,2.0902-0.29223,1.1913,0.03,2.3826-0.18763,2.9162-1.0439,0.42257-0.66869,0.10743-0.97174,0.51687-2.9236,0.26978-1.2868,0.7377-2.3079,1.3417-3.0475,0.61355-0.74925,1.51-0.57968,2.3349-0.73482,0.832-0.15515,1.5876-0.65063,2.5068-0.18402,0.91796,0.46423,1.8454,1.2375,2.7121,2.3368,1.3274,1.6861,1.1627,2.0902,1.8896,2.5773,0.93944,0.62055,2.2167,0.39927,3.3996-0.0493,0.91555-0.34637,1.6628-0.49189,2.2644-0.46663z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m417.68,206.53c-0.29922-0.15715-0.59845-0.3143-0.89767-0.47145,0.6633-1.28163,0.83985-2.73595,1.0196-4.14793,0.33423,0.0433,0.66847,0.0866,1.0027,0.12989-0.18866,1.532-0.40514,3.1016-1.12463,4.48949zm-7.2207-0.51594c0.19258-0.27902,0.38516-0.55803,0.57774-0.83705,1.25164,0.83937,2.60689,1.71855,4.15302,1.81369,0.66099,0.0478,1.31723-0.32463,1.59229-0.93176,0.29922,0.15715,0.59844,0.31429,0.89766,0.47144-0.47243,1.01081-1.60685,1.59428-2.70362,1.47137-1.66848-0.15206-3.16284-1.06611-4.51709-1.98769zm-3.1012-0.45821c-0.0581-0.33433-0.11618-0.66867-0.17427-1.003,1.29746-0.21817,2.73491-0.13409,3.85317,0.6235-0.19258,0.27901-0.38517,0.55803-0.57775,0.83704-0.89849-0.59834-2.0682-0.62496-3.10115-0.45754zm-2.5342,1.3758c-0.28808-0.17639-0.57615-0.35278-0.86423-0.52917,0.69644-1.09634,1.99496-1.62213,3.22441-1.8493,0.0581,0.33433,0.11619,0.66867,0.17428,1.003-0.94266,0.18411-1.97848,0.5427-2.53446,1.37547zm-6.0652,2.7396c0.21545-0.26099,0.43259-0.52136,0.64698-0.78273,0.58856,0.56876,1.53489,0.63305,2.20431,0.16793,1.02139-0.63421,1.72462-1.65158,2.34964-2.65408,0.28808,0.17639,0.57615,0.35278,0.86423,0.52917-0.83361,1.33278-1.83193,2.73567-3.35905,3.31092-0.93474,0.34301-1.97096,0.073-2.70611-0.57121zm-2.6285-4.3356c0.13369,0.31188,0.26739,0.62377,0.40108,0.93565,0.11301-0.16186,0.14095-0.9534,0.32512-0.58493,0.73125,1.15247,1.49378,2.31707,2.54916,3.20262-0.21565,0.26057-0.43131,0.52115-0.64696,0.78172-1.18683-0.98926-2.03653-2.29925-2.8544-3.59225,0.0754-0.24725,0.15023-0.49723,0.226-0.74281zm-0.22561,0.74323c-0.18165-0.27654-0.50138-0.59532,0.0242-0.6555,0.41309-0.25953-0.0212,0.43281-0.0174,0.63303l-0.007,0.0225zm2.5294-1.0764c-0.008,0.33881-0.0189,0.68026-0.0253,1.0174-0.63084-0.004-1.28549,0.005-1.8775,0.2491-0.13369-0.31189-0.26739-0.62377-0.40108-0.93566,0.72339-0.30768,1.52925-0.34583,2.30388-0.33084zm2.4769-0.80938c0.28417,0.1793,0.57306,0.37581,0.85429,0.5444-0.69101,1.08914-2.1016,1.3097-3.29212,1.28292-0.15204-0.17541-0.003-0.63449-0.0419-0.91654,0.10335-0.22498,0.60998-0.0404,0.87627-0.13611,0.58976-0.0712,1.26579-0.24012,1.60351-0.77467zm-0.002,0.004zm0.45122-2.7589c0.32946,0.0705,0.65893,0.14111,0.98839,0.21166-0.21582,0.82764-0.18155,1.69066-0.33127,2.52579-0.0856,0.19462-0.16587,0.73703-0.43361,0.45013-0.17343-0.20586-0.79501-0.29128-0.58292-0.59775,0.17433-0.70735,0.10248-1.4581,0.27815-2.17072,0.0249-0.14013,0.0515-0.27993,0.0813-0.41911zm1.4456-3.2664c0.25997,0.2156,0.52198,0.43556,0.78067,0.64843-0.65641,0.8122-1.02266,1.81766-1.2384,2.82932-0.32946-0.0706-0.65892-0.14112-0.98838-0.21168,0.24593-1.17138,0.68553-2.32944,1.44611-3.26607zm0,0.001c0.21824-0.26945,0.49703-0.6088,0.11782-0.14439-0.0392,0.0479-0.0788,0.0971-0.11782,0.14439zm2.6333-0.91281c0.0618,0.33322,0.12174,0.67276,0.18483,1.002-0.67743,0.16128-1.53366-0.0397-2.0374,0.5552-0.26023-0.21647-0.52045-0.43295-0.78068-0.64942,0.57001-0.74616,1.56372-0.81835,2.4259-0.8766,0.069-0.008,0.14082-0.0192,0.20735-0.0312zm-0.001,0.001c0.26018-0.0505,0.88871-0.16683,0.28779-0.0542-0.0957,0.018-0.19284,0.0366-0.28779,0.0542zm2.8267-0.1395c-0.15165,0.30279-0.30233,0.61158-0.4546,0.9106-0.71655-0.37205-1.47128,0.11643-2.1868,0.2303-0.0613-0.33433-0.12255-0.66867-0.18383-1.003,0.86297-0.21089,1.78692-0.61836,2.66145-0.2126,0.053,0.0198,0.11985,0.0562,0.16378,0.0747zm-0.4536,0.9116zm3.3352,1.5646c-0.26421,0.21086-0.52842,0.42173-0.79263,0.63259-0.69838-0.88185-1.53326-1.68239-2.5426-2.1972,0.1512-0.30387,0.3024-0.60774,0.4536-0.91161,1.14022,0.58158,2.09409,1.47778,2.88163,2.47622zm1.7702,2.4678c-0.18654,0.282-0.36841,0.5759-0.55787,0.85047-0.80086-0.52293-1.05735-1.50744-1.64963-2.2158-0.15148-0.24327-0.54422-0.50523-0.10355-0.67099,0.25246-0.14624,0.55112-0.65397,0.72903-0.1864,0.52032,0.62516,0.86482,1.3703,1.34041,2.02306,0.0687,0.0746,0.16964,0.15088,0.24161,0.19966zm-0.55387,0.85147zm3.4987-0.95249c0.11846,0.31734,0.23783,0.63979,0.35571,0.9539-1.21176,0.4649-2.69544,0.7558-3.85444-0.002,0.18463-0.28383,0.36925-0.56765,0.55388-0.85148,0.89598,0.55803,2.02948,0.23128,2.94485-0.10052zm2.9437,0.0758c-0.33423-0.0433-0.66847-0.0866-1.0027-0.12989,0.0972,0.20229,0.7442,0.65588,0.23029,0.57463-0.62553,0.0316-1.2324,0.21419-1.81533,0.43324-0.11857-0.3183-0.23715-0.63659-0.35572-0.95489,0.78646-0.29188,1.61683-0.52939,2.4636-0.4953,0.15964,0.18991,0.32179,0.38656,0.47986,0.57221zm-0.47988-0.57367c0.38134-0.0329,0.68946-0.004,0.49546,0.44986,0.0285,0.33294-0.39165-0.39821-0.49546-0.44986z'/%3E %3Cpath d='m391.76,221.18c0.7747-0.94167,1.0827-0.73241,1.2247-1.3241,0.17906-0.76489-0.27097-1.9627-0.8535-3.104-2.3313-4.5701,0.14922-4.1852,3.5118-2.3825,0.85231,0.45702,1.8419,1.2676,2.8243,2.1034,0.99077,0.84306,1.9744,1.7258,2.798,2.3175,1.6664,1.199,2.6954,1.2351,3.1812,1.7198,0.74009,1.8569,1.3489,3.4636,1.6055,4.1864,0.001,0.004,0.001,0.004,0.006,0.007,0.28409,0.724,0.88214,2.3283,1.541,4.178-0.10623,0.51594-1.0648,0.65906-1.781,1.9784-0.70428,1.3001-1.2582,3.6584-2.12,4.795-1.2641,1.6657-2.4196,2.6578-3.3197,2.4943-0.89766-0.16357-1.5375-1.4769-1.7774-4.3813-0.0942-1.1281-0.7389-2.3223-1.4826-3.0295-0.58014-0.55203-0.70906-0.31992-2.1439-1.1281-0.92751-0.52195-1.7165-1.1654-2.3456-1.8653-0.6267-0.69754-0.72338-1.4781-1.0146-2.2478-0.29246-0.77331-0.77829-1.5334-0.70309-2.267,0.0752-0.74323,0.35214-1.4456,0.84991-2.0505h-0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m392.49,219.74c0.28133,0.12416,0.8275,0.0884,0.96719,0.29825-0.15479,0.70139-0.94618,0.9065-1.31118,1.46767-0.17614-0.25239-0.80983-0.46425-0.70059-0.74193,0.27235-0.38486,0.70741-0.61745,1.0218-0.9462,0.0101-0.019,0.0159-0.0732,0.0228-0.0778zm0.98361,0.23332zm-1.7953-2.9874c0.30015-0.0631,0.74635-0.57298,0.95494-0.35598,0.48643,1.03377,1.05133,2.16867,0.8392,3.34313-0.27944-0.13815-0.87427-0.0668-0.96761-0.32841,0.0404-0.9418-0.43872-1.83404-0.82653-2.65874zm4.1994-3.0656c-0.2126,0.22548-0.28614,0.89956-0.58683,0.84089-1.02754-0.50067-2.08671-1.12826-3.25991-1.13122-0.5011,0.0626-0.27304,0.73047-0.20735,1.05646,0.17301,0.63994,0.46031,1.24112,0.75501,1.83245-0.30027,0.0618-0.74952,0.57775-0.9559,0.35345-0.48004-1.04496-1.10756-2.19399-0.83337-3.37812,0.27012-0.89238,1.35475-1.02433,2.12987-0.79979,1.04326,0.24602,2.01584,0.72977,2.95848,1.22588zm2.9126,2.1636c-0.25272,0.17674-0.4667,0.81006-0.74365,0.70113-0.84302-0.70288-1.68089-1.42989-2.6446-1.9651,0.20285-0.23395,0.29095-0.84818,0.56339-0.85149,1.02466,0.58467,1.92532,1.35997,2.82486,2.11546zm2.7658,2.2922c-0.23128,0.20552-0.39805,0.80236-0.66839,0.77092-0.95822-0.70978-1.84063-1.5142-2.7497-2.2843,0.25351-0.17532,0.46795-0.81707,0.74605-0.69873,0.88222,0.74694,1.73674,1.53097,2.67204,2.21211zm3.3567,1.9447c-0.22825,0.18088-0.9522,0.2076-0.86876,0.48541,0.0603,0.0925-0.39979-0.23938-0.57078-0.26449-0.88458-0.3426-1.73739-0.77492-2.50438-1.3362,0.23967-0.19529,0.40056-0.85549,0.69008-0.75658,0.85744,0.66039,1.90314,0.97393,2.84924,1.46779,0.16382,0.10319,0.31627,0.22826,0.4046,0.40407zm-0.11341-0.17197zm1.7297,4.3873c-0.30118,0.0541-0.76773,0.34544-0.97677,0.2736-0.50043-1.37906-1.03622-2.74504-1.57706-4.10869,0.30528-0.0335,0.79706-0.50449,0.98508-0.26284,0.53714,1.35947,1.07523,2.72586,1.56875,4.09793zm-0.004-0.0108,0.004,0.0108-0.004-0.0108zm0-0.008c-0.22454,0.17624-0.96326,0.20967-0.86431,0.47575-0.0422,0.11117,0.68547,0.3659,0.16972-0.003-0.52399-0.5278-0.0328-0.0348,0.20517,0.2057-0.0406-0.0383-0.75545-0.7608-0.3122-0.31452,0.49983,0.50312,0.19615,0.1994-0.11724-0.11713-0.0892-0.003,0.22502,0.56773-0.0626-0.065,0.0916,0.33835,0.68336-0.15283,0.98346-0.16029,0.0717,0.36871-0.26803-0.61221,0.0255,0.15182-0.091-0.0747-0.75161-0.75474-0.323-0.31928,0.49937,0.50266,0.19792,0.20118-0.11625-0.11612-0.18613-0.18948,0.71666,0.72101,0.31219,0.31452-0.4512-0.37456-0.29295-0.3625-0.0606-0.26647,0.0279,0.0432,0.11202,0.14907,0.16008,0.2143zm-0.16711-0.22007zm1.7332,4.6891c-0.2838,0.023-0.91937-0.3575-0.98204-0.0809,0.007,0.29086-0.22059-0.57063-0.31347-0.75405-0.39507-1.08947-0.79126-2.17869-1.21116-3.25883,0.30532-0.0615,0.73611-0.41099,0.96813-0.30423,0.52531,1.38785,1.06182,2.77886,1.52427,4.18552,0.004,0.0706,0.0107,0.14266,0.0143,0.21253zm-0.0191-0.27541zm-1.8132,2.3945c-0.21871-0.21538-0.89598-0.30085-0.82584-0.59806,0.37214-0.72614,1.08153-1.24513,1.66753-1.72832,0.27443,0.13178,0.90639,0.0419,0.96446,0.30781-0.29642,0.73011-1.17051,0.9636-1.5642,1.6324-0.0897,0.12261-0.17019,0.25333-0.24195,0.38617zm-2.1618,4.8599c-0.19055-0.2453-0.81405-0.42773-0.73655-0.71195,0.91094-1.43176,1.22037-3.14411,2.0104-4.63622,0.22085,0.21656,0.89165,0.29848,0.82909,0.59985-0.76942,1.55021-1.09549,3.31933-2.10294,4.74832zm-3.8115,2.6867c0.12059-0.293,0.0218-0.87143,0.27226-0.995,0.90041-0.11174,1.51453-0.90543,2.10168-1.52391,0.25932-0.18889,0.4545-0.794,0.73313-0.70889,0.15212,0.2384,0.87782,0.40246,0.58272,0.69882-0.83284,1.01651-1.72876,2.18504-3.0654,2.5221-0.20524,0.04-0.41915,0.0414-0.62439,0.007zm-2.1916-4.8395c0.30806,0.0278,0.80611-0.17097,1.01323-0.0228,0.146,1.22554,0.21287,2.5657,0.95397,3.60276,0.3136,0.2145,0.49893,0.34043,0.31467,0.75279,0.0306,0.45324-0.18907,0.61941-0.56594,0.33625-1.05508-0.65385-1.30908-1.99416-1.52843-3.12429-0.0871-0.51045-0.14468-1.03447-0.1875-1.54476zm-1.3262-2.7024c0.25869-0.16674,0.50793-0.75867,0.77242-0.66501,0.85628,0.88239,1.4416,2.05136,1.5617,3.28055-0.30699-0.0399-0.84904,0.20298-1.0165-0.005-0.12776-0.98-0.61454-1.92001-1.31762-2.61074zm-2.0436-1.0535c0.21708-0.22082,0.30577-0.89448,0.60425-0.8282,0.67819,0.44626,1.55121,0.54936,2.13428,1.14114-0.26318,0.16368-0.50886,0.77732-0.78302,0.66033-0.55044-0.39456-1.24947-0.52374-1.8191-0.8975-0.0455-0.0251-0.0908-0.051-0.13641-0.0758zm-2.4733-1.9687c0.26688-0.16019,0.54914-0.66282,0.80693-0.62061,0.62264,0.67787,1.35882,1.24893,2.1605,1.6999-0.21027,0.22721-0.308,0.85607-0.58729,0.83697-0.88434-0.51255-1.69817-1.15413-2.38014-1.91626zm-1.1125-2.4077c0.30529-0.0524,0.7519-0.41561,0.974-0.285,0.25105,0.68551,0.3756,1.45386,0.8875,2.0094-0.26921,0.14694-0.56396,0.70878-0.81765,0.6038-0.58265-0.65519-0.76136-1.52845-1.04385-2.3282zm-0.73293-2.5003c0.30959,0.0686,0.77289,0.011,1.0011,0.14644,0.012,0.71882,0.44597,1.33094,0.6771,1.9907-0.30639,0.0627-0.73196,0.38788-0.9692,0.29831-0.31136-0.78256-0.79643-1.56406-0.709-2.43545zm1.0051,0.10344c-0.0117,0.12107-0.009,0.0881,0-0.0001v0.0001zm0.34737-1.5923c0.0348-0.22519-0.0703-1.08132,0.0533-0.90541,0.0686,0.30922,0.50709,0.65514,0.1819,0.92234-0.32641,0.46302-0.52798,1.01183-0.5808,1.5757-0.29724-0.0896-0.84806,0.0276-0.9971-0.18282,0.0924-0.81934,0.42795-1.60935,0.9546-2.2439,0.12881,0.27745,0.26192,0.55939,0.38807,0.83409zm0-1.0198c0.3027,0.0363,0.90786-0.0703,1.03542,0.0487-0.22458,0.15569-0.51983,0.86931-0.69963,0.6715-0.11193-0.24008-0.22389-0.48018-0.33579-0.72024zm-0.001,0c0.002,0.33762,0.002,0.68219,0,1.0198-0.0402-0.3095-0.63716-0.8192-0.16122-0.94312,0.0537-0.0255,0.10755-0.0512,0.16122-0.0767zm0,1.0198c-0.3027-0.0363-0.90786,0.0703-1.03542-0.0487,0.22458-0.1557,0.51981-0.86933,0.69961-0.67152,0.11193,0.24008,0.2239,0.48019,0.33581,0.72026z'/%3E %3Cpath d='m406.51,226.13c0.0692,0.32111,0.14802,0.63621,0.22203,0.94408-1.4456,0.33916-2.6428,0.93446-3.6408,1.7523-0.99554,0.81781-1.7941,1.8677-2.4256,3.1281,0.22083-1.3951,0.91437-2.6434,1.9338-3.6452,1.017-1.0018,2.3659-1.7643,3.9094-2.1792h0.001z' fill='%2321231e'/%3E %3Cpath d='m405.92,224.45c-0.13966-0.31028-0.28528-0.62178-0.43212-0.93206-1.6091-0.1335-3.1645-0.54479-4.6864-1.205-1.5088-0.65545-2.9854-1.555-4.4465-2.6711,1.1579,1.2977,2.6643,2.4017,4.3188,3.2279,1.6688,0.83463,3.4904,1.3854,5.2451,1.5803h0.001z' fill='%2321231e'/%3E %3Cpath d='m391.36,213.8c0.99315,0.3656,1.6592,0.82141,2.8016,1.7667,0.8702,0.72038,1.3441,1.7607,1.5136,2.9477,0.1707,1.193,0.0394,2.5448-0.29365,3.8846-0.20532,0.83104,0.0466,2.2478,0.53597,3.644,0.48702,1.3878,1.2176,2.7613,1.9565,3.5009,2.4435,2.4498,4.16,5.0391,3.4772,6.6422-0.44644,1.0499-0.78426,1.3217-1.4838,1.798-0.29127-0.59891-0.98599-1.1353-1.2212-2.1527-0.30319-1.3121-0.79142-2.6711-1.5661-3.4865-0.59923-0.63861-0.73173-1.3518-2.2203-2.279-0.96332-0.60252-1.7822-0.34396-2.4375-1.1497-1.2689-1.5598-2.9329-5.3758-1.3059-7.1173,1.6031-1.7186,2.1773-2.6891,0.82366-5.6488-0.46077-1.0066-0.44883-1.7402-0.58133-2.35h0.001z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m394.49,215.17c-0.21407,0.26218-0.42813,0.52435-0.6422,0.78653-0.80723-0.66904-1.65056-1.33454-2.65363-1.6815,0.11539-0.3191,0.23078-0.63821,0.34617-0.95731,1.11177,0.38658,2.05715,1.10508,2.94966,1.85228zm1.6926,3.2688c-0.32083,0.009-0.76671,0.1862-1.00891,0.0886-0.14163-0.96862-0.55292-1.94-1.32619-2.57071,0.21407-0.26218,0.42815-0.52435,0.64222-0.78653,0.98402,0.80224,1.52551,2.03093,1.69288,3.26867zm-0.30319,4.0794c-0.32676-0.0824-0.65608-0.16273-0.98123-0.24635,0.29564-1.20127,0.4502-2.45565,0.2842-3.68853,0.32031-0.009,0.76774-0.18636,1.00813-0.0885,0.17673,1.34368,0.008,2.71937-0.3111,4.02335zm-0.98123-0.24535zm1.5029,3.5971c-0.31239,0.0717-0.71632,0.33438-0.9711,0.28588-0.40111-1.24084-0.78726-2.5728-0.53207-3.88298,0.3013,0.11368,0.77898,0.11781,0.96922,0.30046-0.15496,1.11339,0.19468,2.24803,0.53395,3.29664zm1.8371,3.3097c-0.251,0.20134-0.50263,0.61362-0.75323,0.68126-0.95793-1.03296-1.55934-2.34094-2.03658-3.65182,0.31296-0.0719,0.71516-0.33396,0.97197-0.28618,0.43288,1.16358,0.96219,2.34054,1.81784,3.25674zm3.5847,7.2039c-0.2798-0.16146-0.74805-0.24235-0.90911-0.45459,0.29765-1.00391-0.27839-2.00581-0.76942-2.84823-0.73359-1.16628-1.65365-2.20293-2.62072-3.17947,0.25114-0.20148,0.50239-0.61335,0.75347-0.68147,1.42833,1.48021,2.87153,3.07397,3.55094,5.0531,0.21361,0.68053,0.27723,1.4422-0.005,2.11066zm-2.4017,1.8208c0.24998-0.15067,0.77764-0.32849,0.85275-0.46206-0.17282-0.10248-0.92324-0.10313-0.50175-0.30867,0.54056-0.32788,0.89796-0.871,1.1216-1.451,0.2778,0.16066,0.75209,0.24398,0.90607,0.45337-0.30852,0.82153-0.89057,1.51833-1.64328,1.96839-0.24407-0.067-0.49631-0.13119-0.73539-0.20003zm0.73651,0.19843c-0.304,0.26592-0.58375,0.44091-0.6783-0.0787-0.17813-0.27341,0.53099,0.0955,0.6783,0.0787zm-1.997-2.4594c0.31966-0.0368,0.74883-0.2519,0.99938-0.17611,0.1762,0.77532,0.81944,1.30291,1.16862,1.98951-0.30286,0.11669-0.65592,0.38863-0.92761,0.40889-0.45863-0.71775-1.0714-1.35431-1.24039-2.22229zm-1.4408-3.252c0.24313-0.234,0.49692-0.46786,0.73332-0.70194,0.93988,1.02701,1.37248,2.39681,1.694,3.72328-0.31913,0.0366-0.74989,0.25216-0.99856,0.17592-0.28252-1.13026-0.63323-2.31327-1.42876-3.19726zm0.002,0.002zm-2.1212-2.1984c0.17746-0.28864,0.35492-0.57727,0.53238-0.86591,0.8976,0.51465,1.58879,1.2988,2.14746,2.1566,0.35957,0.2389-0.11178,0.42372-0.27507,0.63345-0.23075,0.40392-0.4482,0.1515-0.62625-0.14371-0.45506-0.722-1.03652-1.34754-1.77852-1.78043zm-2.5629-1.2592c0.26077-0.21481,0.52357-0.43393,0.78306-0.64602,0.52708,0.61941,1.45102,0.49546,2.10078,0.9183,0.44158,0.12015-0.10378,0.49565-0.17274,0.7461-0.0972,0.42685-0.38637,0.0546-0.64048,0.004-0.74267-0.2301-1.57594-0.34998-2.07062-1.0224zm-1.2832-7.7896c0.24501,0.23229,0.49456,0.46639,0.7367,0.69754-0.78746,0.91302-0.5644,2.24165-0.26581,3.30747,0.34344,1.12644,0.8673,2.20882,1.59564,3.13754-0.26103,0.21567-0.52205,0.43135-0.78308,0.64702-1.16116-1.53103-1.98643-3.38585-2.09247-5.32053-0.031-0.88403,0.19471-1.81118,0.80902-2.46904zm0.73293-5.0872c0.30494-0.10041,0.68406-0.39894,0.94217-0.37425,0.60463,1.32173,1.14491,2.9178,0.45043,4.31316-0.33561,0.7003-0.86556,1.28041-1.38752,1.84584-0.2459-0.23251-0.49181-0.46503-0.73771-0.69754,0.74656-0.78917,1.60691-1.74126,1.42623-2.91811-0.0888-0.75941-0.38401-1.47755-0.6936-2.1691zm-0.12176-3.0728v1.0198c0.15777-0.0986,0.45813-0.78045,0.52039-0.48716,0.10771,0.71767,0.19169,1.4538,0.5164,2.1141-0.305,0.10044-0.68395,0.39889-0.94225,0.37429-0.36196-0.75338-0.45947-1.58784-0.58869-2.40237,0.16456-0.20581,0.3304-0.41495,0.49415-0.61866zm-0.49418,0.61936c-0.0777-0.33881-0.28153-0.77932,0.25992-0.61936,0.50804-0.0803-0.1818,0.41613-0.25821,0.61722l-0.002,0.002zm0.49537,0.40048c-0.002-0.33762-0.002-0.68218,0-1.0198,0.37144,0.0353-0.0172,0.60105,0.0272,0.86464-0.009,0.0517-0.0181,0.10368-0.0272,0.15516zm0-1.0198z'/%3E %3Cpath d='m434.07,226.22c-1.2772,1.1016-1.5996,0.88394-1.9565,1.549-0.45243,0.84546-0.24114,2.1287,0.14801,3.3337,1.5375,4.7529-1.3608,4.3356-4.8416,2.5172-1.7321-0.9044-3.7542-3.2171-5.3251-4.3788-1.5781-1.1594-2.6858-1.1509-3.1179-1.6308-0.44166-1.8773-0.79619-3.525-0.93825-4.2778-0.005,0-0.005,0-0.005-0.005-0.1707-0.74925-0.51925-2.4306-0.89051-4.4077,0.21727-0.58931,1.3047-0.8611,2.3731-2.4594,1.0851-1.6176,2.1654-4.6362,3.5692-6.1058,2.8768-3.0126,5.7655-4.3067,5.9255,1.4793,0.0394,1.4023,0.28649,2.8202,1.0373,3.5863,0.58849,0.60253,0.83199,0.29224,2.4709,1.1016,1.0684,0.52675,1.9218,1.2159,2.5342,2.0036,0.61476,0.78894,0.48823,1.7294,0.62431,2.6302,0.13489,0.89718,0.53358,1.7643,0.17786,2.6434-0.35095,0.86952-0.94541,1.6981-1.7858,2.4209z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m432.56,228.01c-0.21644-0.22408-0.97072-0.29971-0.8046-0.63027,0.46165-0.69995,1.36136-0.897,1.9273-1.49703,0.1747,0.0402,0.7713,0.61247,0.6116,0.81388-0.48851,0.4725-1.13288,0.73938-1.6449,1.16959-0.0345,0.0449-0.0638,0.0957-0.0894,0.14383zm0.1838,2.93443c-0.33227,0.00031-0.9584,0.56977-1.03602,0.077-0.32309-1.12016-0.58671-2.40102-0.0382-3.4949,0.24803,0.25102,1.05919,0.29369,0.78918,0.72928-0.23962,0.88974,0.0263,1.8348,0.28504,2.68865zm-5.5555,3.1269c0.24165-0.24517,0.28559-1.10467,0.71099-0.77888,1.13285,0.52543,2.33755,1.1862,3.62501,1.05346,0.76711-0.14137,0.69169-1.10697,0.60297-1.69373-0.0724-0.47388-0.20065-0.93692-0.34532-1.39327,0.34025-0.003,0.98225-0.58685,1.04234-0.0514,0.32177,1.14858,0.691,2.56657-0.12185,3.59798-0.8989,0.93185-2.33305,0.57869-3.41127,0.2031-0.72481-0.25554-1.4211-0.58465-2.10287-0.9373zm-5.3907-4.4197c0.26003-0.17377,0.42626-0.98288,0.75303-0.70375,1.74761,1.34876,3.17059,3.11429,5.10306,4.2189-0.23912,0.24038-0.28903,1.10763-0.70289,0.7734-1.92433-1.1596-3.38257-2.9405-5.1532-4.28855zm0.59685-0.82262zm-3.9082-1.1016c0.26244-0.1656,1.17065-0.0366,0.86662-0.46062,0.73918,0.44436,1.62727,0.6149,2.35231,1.10499,0.25157,0.21081,0.94401,0.38366,0.48689,0.7365-0.21883,0.38572-0.43928,0.6877-0.79916,0.26491-0.79662-0.58135-1.80788-0.73668-2.6245-1.26805-0.14029-0.0923-0.21429-0.22902-0.28216-0.37773zm0.11698,0.2249zm-0.56342-4.1107c0.0787-0.26349-0.19298-1.27637,0.21154-0.84304,0.46913,0.25186,0.33646,0.85901,0.50123,1.29527,0.2255,1.06889,0.4678,2.13423,0.7171,3.19784-0.33234-0.0259-0.99951,0.48933-1.03989-0.008-0.31467-1.34784-0.62072-2.69817-0.88631-4.05662,0.16526,0.1381,0.33189,0.27729,0.49633,0.41473zm0-1.0198c0.4861-0.31319,0.67983,0.76229,0.23216,0.19396-0.0774-0.0646-0.15476-0.12933-0.23216-0.19396zm-0.49777,0.61937c0.30405,0.004,0.86176-0.35157,0.99909-0.11226,0.0652-0.22127-0.52878-0.72969-0.50213-0.37008-0.10507,0.20625,0.22862,1.07027-0.19387,0.80248-0.20495,0.11412-0.3659-0.722-0.30309-0.32014zm0.98599-0.22851zm-1.8574-4.4702c0.31322,0.0111,1.01675,0.6374,0.97039,0.0818,0.27867,1.46619,0.56297,2.93164,0.887,4.38855-0.31111-0.0213-0.90421,0.4058-1.02059,0.0746-0.30315-1.44239-0.62341-2.88895-0.85419-4.34139,0.006-0.0678,0.0109-0.13606,0.0174-0.20353zm-0.0226,0.2718zm2.4507-2.8395c0.20609,0.26438,1.04392,0.41354,0.69115,0.78091-0.55086,0.84242-1.38863,1.41441-2.12727,2.06951-0.25773,0.12076-0.67551-0.23175-0.99198-0.28247,0.38418-0.82403,1.33734-1.14799,1.8758-1.8542,0.19948-0.22549,0.38712-0.46276,0.5523-0.71375zm3.6241-6.1744c0.15942,0.29697,0.93069,0.57142,0.56734,0.88679-1.43417,1.75785-2.12146,3.97171-3.35343,5.85766-0.2067-0.26421-1.0188-0.40371-0.70731-0.77407,1.20605-1.96154,1.93093-4.2399,3.4934-5.97038zm6.7945,1.8184c-0.33024-0.0935-1.09781,0.2836-1.02222-0.24659-0.0803-1.03767-0.11441-2.21694-0.84094-3.03549-0.70057-0.5555-1.60289,0.0247-2.22779,0.42809-0.72328,0.50196-1.36698,1.10876-1.97522,1.74279-0.16338-0.30185-0.97343-0.5943-0.53606-0.90488,1.1013-1.07253,2.31084-2.26274,3.89393-2.50799,1.10944-0.15537,2.01919,0.76231,2.29791,1.76482,0.29893,0.8856,0.37838,1.83332,0.41039,2.75925zm0.89288,3.2435c-0.28165,0.12682-0.58434,0.90341-0.85031,0.57127-0.85362-1.05574-0.99985-2.47684-1.05248-3.78615,0.32246,0.0941,1.07918-0.27646,1.0199,0.22617,0.0737,1.0233,0.16768,2.18778,0.88289,2.98871zm-0.001-0.001zm2.3337,1.003c-0.22846,0.23854-0.25424,1.05637-0.65059,0.81564-0.76383-0.45399-1.77956-0.41441-2.40271-1.10312,0.29443-0.14982,0.57233-0.88469,0.8773-0.57266,0.64487,0.31892,1.38549,0.42718,2.02164,0.7843,0.0515,0.0252,0.10282,0.0509,0.15436,0.0758zm2.7097,2.1455c-0.28964,0.10157-0.64343,0.77036-0.8917,0.50921-0.61038-0.74185-1.40445-1.31634-2.2621-1.74052,0.22896-0.23657,0.25716-1.07342,0.65534-0.80701,0.9572,0.50177,1.83518,1.1861,2.49846,2.03832zm-0.795,0.63019c0.34331,0.43956,0.48598,0.62538,0.0564,0.0727l-0.0423-0.0544-0.0141-0.0181v-0.0002zm1.522,2.2393c-0.29934-0.0581-0.95498,0.3566-1.02219-0.008-0.0999-0.75118-0.004-1.59448-0.49591-2.23115,0.30288-0.11022,0.69598-0.84849,0.9263-0.44629,0.53827,0.79406,0.48139,1.77881,0.5918,2.68576zm0.14562,2.9116c-0.2672-0.22063-1.07545-0.17895-0.86165-0.62774,0.12424-0.72591-0.1915-1.42207-0.2844-2.1321,0.3101,0.0434,0.92138-0.32852,1.0253-0.001,0.18687,0.90359,0.50215,1.86147,0.12075,2.76088zm-1.9254,2.6158c-0.12344-0.29822-0.82486-0.63757-0.50974-0.9043,0.64003-0.58162,1.17481-1.2905,1.4993-2.0956,0.24179,0.20589,1.02697,0.18913,0.86066,0.56286-0.41537,0.942-1.07231,1.77177-1.85022,2.43704z'/%3E %3Cpath d='m417.9,222.59c-0.0238-0.28503-0.0501-0.57487-0.068-0.86711,3.2063-0.87794,5.6927-2.7252,7.722-5.4348-1.1412,2.8948-4.2078,5.2832-7.654,6.3019z' fill='%2321231e'/%3E %3Cpath d='m418.22,224.11c0.099,0.27661,0.19338,0.55323,0.29127,0.82502,3.359,0.0637,6.3719,1.1774,9.1902,3.1437-2.0579-2.3416-5.8216-3.8304-9.4815-3.9688z' fill='%2321231e'/%3E %3Cpath d='m432.69,233.31c-1.0851-0.33555-2.2716-0.68792-3.3638-1.531-1.664-1.2868-1.1806-3.7799,0.24828-6.3536,0.45838-0.82503,0.5121-2.2093,0.27455-3.5659-0.23874-1.3638-0.77232-2.6999-1.4897-3.3866-2.3456-2.2622-3.7804-4.7565-2.5891-6.5857,0.79621-1.2207,1.8813-1.9326,2.8744-2.6037,0.21129,0.62899,0.35095,1.4696,0.3796,2.5544,0.0369,1.4023,0.28171,2.819,1.0325,3.5863,0.5885,0.60252,0.832,0.29224,2.471,1.1016,1.0684,0.52676,1.9218,1.2159,2.5342,2.0036,0.61476,0.78893,0.48823,1.7294,0.62431,2.6302,0.13489,0.89718,0.53357,1.7643,0.17786,2.6434-0.35095,0.86833-0.94541,1.6982-1.7858,2.4209-1.2773,1.1016-1.5996,0.88395-1.9565,1.549-0.45241,0.84547-0.23994,2.1275,0.148,3.3338,0.29605,0.91522,0.43094,1.6416,0.42019,2.2033z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m429.01,232.18c0.20532-0.26939,0.41063-0.53879,0.61595-0.80818,0.93553,0.73203,2.08053,1.11021,3.20363,1.4477-0.0987,0.32472-0.19736,0.64943-0.29604,0.97415-1.2409-0.36968-2.49375-0.80487-3.52354-1.61367zm0.11459-7.0066c0.29445,0.16596,0.58889,0.33193,0.88334,0.49789-0.7068,1.32956-1.41031,2.82253-1.18372,4.36784,0.0893,0.52422,0.37634,1.0117,0.802,1.33272-0.20532,0.26939-0.41063,0.53879-0.61595,0.80818-1.14153-0.83836-1.43459-2.39124-1.15401-3.71248,0.21295-1.1647,0.70435-2.26272,1.26834-3.29415zm0.21844-3.2279c0.33185-0.0593,0.6637-0.11866,0.99555-0.17799,0.20434,1.29181,0.28026,2.70511-0.3315,3.90376-0.29444-0.16596-0.58888-0.33192-0.88332-0.49788,0.48223-0.99083,0.37705-2.17248,0.21927-3.22789zm-1.3417-3.1076c0.23218-0.24566,0.46961-0.4914,0.6985-0.73702,0.96183,0.97886,1.38745,2.34915,1.6392,3.66669-0.33185,0.0593-0.6637,0.11866-0.99555,0.17799-0.21578-1.10597-0.5481-2.2714-1.34215-3.10766zm0.001,0.001zm-2.6631-7.2351c0.28144,0.18597,0.56508,0.37606,0.84513,0.55945-0.69658,1.06305-0.20719,2.40278,0.39728,3.3849,0.57699,0.94919,1.32509,1.78163,2.11876,2.5538-0.23317,0.24534-0.46634,0.49067-0.69951,0.73601-1.35972-1.3493-2.72208-2.89508-3.11244-4.8276-0.15434-0.82427-0.0134-1.70207,0.45078-2.40656zm3.7757-2.4871c-0.31911,0.10904-0.63823,0.21809-0.95734,0.32713,0.15875,0.12448,0.94272,0.16614,0.61981,0.354-0.97607,0.64832-1.95191,1.36417-2.59293,2.36581-0.28171-0.18681-0.56342-0.37362-0.84513-0.56043,0.74418-1.16599,1.8775-1.99673,3.0154-2.7464,0.25325,0.0866,0.50763,0.17319,0.76019,0.25989zm-0.76038-0.25977c0.2901-0.19203,0.64494-0.57503,0.67411,0.002,0.26652,0.48965-0.41622,0.0246-0.65805,0.003l-0.0161-0.005zm1.1662,2.9645c-0.3201-0.0284-0.78164,0.0946-1.01223-0.0296-0.0307-0.79126-0.10132-1.59152-0.35017-2.34777,0.31911-0.10904,0.63823-0.21808,0.95734-0.32712,0.28982,0.87026,0.37667,1.79298,0.40506,2.70452zm0.88811,3.2423c-0.24033,0.23813-0.48066,0.47625-0.72099,0.71438-0.97042-1.05018-1.1226-2.56464-1.1773-3.93025,0.31974,0.0284,0.78237-0.0946,1.01168,0.0297,0.061,1.08937,0.13232,2.32763,0.88661,3.18622zm2.3325,1.0018c-0.14802,0.30467-0.29603,0.60934-0.44405,0.91401-0.67326-0.38481-1.44944-0.50906-2.14615-0.8299-0.20524-0.14515-0.66006-0.36508-0.26335-0.56932,0.22784-0.11238,0.43951-0.71235,0.67783-0.37476,0.57822,0.30124,1.25298,0.38429,1.83311,0.69718,0.11531,0.0514,0.23037,0.10772,0.34261,0.16279zm2.7097,2.1455c-0.26474,0.2092-0.53156,0.4227-0.795,0.6292-0.62264-0.7984-1.45507-1.41409-2.3588-1.8603,0.14802-0.30467,0.29603-0.60934,0.44405-0.91401,1.04079,0.51035,1.99771,1.2313,2.70975,2.14511zm-0.795,0.6302c0.16876,0.21502,0.58031,0.74654,0.18804,0.24174-0.0626-0.0806-0.12563-0.16107-0.18804-0.24174zm1.522,2.2393c-0.33311,0.0511-0.66883,0.1-1.0003,0.15253-0.13457-0.79847,0.006-1.70925-0.5177-2.3919,0.265-0.21006,0.53001-0.42013,0.79501-0.63019,0.66449,0.81116,0.60987,1.89051,0.72299,2.86956zm0.14563,2.9116c-0.31195-0.12828-0.62391-0.25656-0.93586-0.38484,0.2931-0.78464-0.1159-1.59254-0.2102-2.375,0.33343-0.0505,0.66687-0.10103,1.0003-0.15154,0.16888,0.95493,0.55157,1.96245,0.14576,2.91138zm-1.9254,2.6158c-0.21885-0.25817-0.43769-0.51634-0.65654-0.77451,0.70519-0.60578,1.29614-1.3595,1.646-2.2252,0.31195,0.12828,0.62391,0.25656,0.93586,0.38484-0.40873,1.01505-1.09956,1.90865-1.92532,2.61487zm-1.83954,1.40349c-0.29683-0.16115-0.59366-0.32231-0.89049-0.48346,0.38408-0.77784,1.31785-0.96635,1.90032-1.54895,0.26874-0.34011,0.45373,0.30836,0.68149,0.45445,0.35297,0.24979-0.24906,0.42287-0.39951,0.61546-0.38454,0.35592-0.95916,0.48474-1.2665,0.91738l-0.025,0.0458-0.00031-0.00068zm0.18381,2.93444c-0.32071,0.10503-0.64141,0.21006-0.96212,0.31509-0.36408-1.18952-0.69504-2.55747-0.1123-3.73302,0.29683,0.16115,0.59366,0.32231,0.89049,0.48346-0.41814,0.92618-0.0848,2.01268,0.18393,2.93447zm-0.2089,2.84789c0.0987-0.32472,0.19736-0.64944,0.29604-0.97416-0.19966,0.0593-0.69415,0.70347-0.65514,0.28985-0.0346-0.63234-0.19992-1.24828-0.3921-1.8488,0.32071-0.10503,0.64141-0.21005,0.96212-0.31508,0.24306,0.76677,0.45124,1.5601,0.4441,2.3703-0.21837,0.15925-0.43651,0.31887-0.65502,0.47789zm0.65415-0.47746c-0.04,0.29134,0.14228,0.89035-0.33512,0.57621-0.6123-0.0593,0.0625-0.33321,0.27094-0.52934l0.0454-0.0331,0.0188-0.0137h-0.00003zm-0.50613-0.009c-0.1571,0.51694-0.15944,0.52465-0.00099,0.003l0.00099-0.003zm0.50613,0.009c-0.04,0.29134,0.14228,0.89035-0.33512,0.57621-0.6123-0.0593,0.0625-0.33321,0.27094-0.52934l0.0454-0.0331,0.0188-0.0137h-0.00003z'/%3E %3Cpath d='m410.55,216.45c4.0263-0.19844,7.9142,3.3241,8.486,7.6344,0.57059,4.3103-2.2441,7.6561-6.1034,7.7018-3.8592,0.0458-7.4451-3.1136-8.1828-7.2736-0.73769-4.16,1.7738-7.8641,5.8002-8.0626z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m419.54,224.02c-0.33423,0.0449-0.66847,0.0898-1.0027,0.13469-0.44684-3.33325-3.04532-6.34863-6.36491-7.06366-0.52305-0.11266-1.06064-0.14834-1.59477-0.12925-0.0167-0.33913-0.0335-0.67827-0.0502-1.0174,2.84853-0.13664,5.56954,1.45774,7.22179,3.71617,0.94636,1.27423,1.57836,2.78669,1.79079,4.35945zm-6.5988,8.279c-0.004-0.33993-0.008-0.67987-0.0119-1.0198,1.94,0.007,3.8405-1.06386,4.8037-2.75413,0.77465-1.30397,1.0047-2.87948,0.8041-4.37035,0.33423-0.0449,0.66847-0.0898,1.0027-0.13469,0.3311,2.32994-0.35679,4.86789-2.1105,6.49534-1.1973,1.14435-2.83895,1.76949-4.4881,1.78363zm-8.6865-7.6933c0.33185-0.0601,0.66369-0.12027,0.99554-0.1804,0.5471,3.18398,3.04202,6.03864,6.24593,6.71192,0.47069,0.0987,0.95217,0.14532,1.43306,0.14211,0.004,0.33993,0.008,0.67987,0.0119,1.0198-2.97493,0.0397-5.77433-1.73817-7.32978-4.21974-0.67401-1.05443-1.13604-2.24198-1.35665-3.47369zm6.2729-8.6615c0.0167,0.33913,0.0335,0.67827,0.0502,1.0174-1.85997,0.0623-3.64749,1.12179-4.56416,2.74648-0.83308,1.40656-1.04794,3.12139-0.76293,4.71719-0.33184,0.0601-0.66369,0.12026-0.99553,0.18039-0.4451-2.40202,0.18774-5.06723,1.9642-6.80214,1.13709-1.13685,2.7094-1.78745,4.30822-1.85932z'/%3E %3Cpath d='m410.89,218.57c2.9448-0.12868,5.7691,2.4221,6.2024,5.5743,0.43451,3.1522-1.5864,5.6476-4.4584,5.6958-2.8338,0.0505-5.5208-2.3379-6.0389-5.377-0.53358-3.1064,1.3513-5.7643,4.2949-5.893z' fill='%23edb92e'/%3E %3Cpath fill='%2321231e' d='m417.59,224.07c-0.33423,0.0465-0.66847,0.093-1.0027,0.13951-0.3324-2.42571-2.25924-4.61465-4.6935-5.06915-0.32551-0.0542-0.65611-0.0783-0.98599-0.0656-0.0143-0.33913-0.0287-0.67827-0.043-1.0174,2.18262-0.0947,4.26262,1.15323,5.48803,2.91352,0.65001,0.91611,1.08065,1.98876,1.23716,3.09912zm-4.9514,6.2754c-0.006-0.33993-0.0111-0.67987-0.0167-1.0198,1.38842,0.001,2.74788-0.77403,3.42043-1.99431,0.5429-0.93532,0.69249-2.06021,0.54471-3.12185,0.33423-0.0465,0.66847-0.093,1.0027-0.13951,0.24751,1.69717-0.2104,3.53873-1.43021,4.78086-0.91218,0.95088-2.20941,1.47701-3.52093,1.49461zm-6.545-5.8003c0.33185-0.0577,0.6637-0.11546,0.99555-0.17319,0.39616,2.33713,2.26013,4.42614,4.61844,4.87745,0.30145,0.0545,0.60799,0.0812,0.91436,0.076,0.006,0.33993,0.0111,0.67987,0.0167,1.0198-2.22591,0.0361-4.31658-1.29421-5.49659-3.1368-0.52526-0.80399-0.88537-1.7192-1.04846-2.66323zm4.77115-6.48829c0.0143,0.33913,0.0287,0.67827,0.043,1.0174-1.33132,0.0373-2.61855,0.78481-3.27694,1.94818-0.58896,1.00022-0.73722,2.21582-0.54185,3.34925-0.33185,0.0577-0.66369,0.11545-0.99554,0.17318-0.32228-1.78013,0.13702-3.74986,1.44067-5.04699,0.87378-0.88694,2.09051-1.39512,3.33066-1.44102z'/%3E %3Cpath d='m411.22,220.72c1.8419-0.0685,3.6026,1.5141,3.8879,3.4889,0.28529,1.9748-0.98599,3.5682-2.7885,3.6067-1.8037,0.0372-3.5011-1.4636-3.8222-3.4059-0.32111-1.9435,0.88215-3.6188,2.7228-3.6885v-0.001z' fill='%230c4076'/%3E %3Cpath fill='%2321231e' d='m415.6,224.13c-0.33343,0.0489-0.66687,0.0978-1.0003,0.14671-0.20859-1.43809-1.34732-2.73763-2.79308-3.01145-0.18955-0.0356-0.38282-0.0448-0.57536-0.042-0.0127-0.33913-0.0255-0.67827-0.0382-1.0174,1.45037-0.055,2.83064,0.78136,3.63156,1.96118,0.40188,0.58471,0.67498,1.2604,0.77538,1.96296zm-3.2779,4.19c-0.007-0.33993-0.0143-0.67987-0.0215-1.0198,0.8606,0.00054,1.68749-0.52569,2.05363-1.30401,0.26296-0.52871,0.32952-1.13922,0.24539-1.7197,0.33343-0.0489,0.66687-0.0978,1.0003-0.14674,0.18873,1.2052-0.18737,2.52525-1.11494,3.34642-0.58808,0.53562-1.37102,0.82599-2.16288,0.84383zm-4.3319-3.8316c0.33265-0.0561,0.66529-0.11224,0.99794-0.16836,0.22866,1.42227,1.37181,2.70161,2.81388,2.94366,0.1644,0.0285,0.33158,0.0387,0.4983,0.0357,0.007,0.33993,0.0144,0.67987,0.0216,1.0198-1.47341,0.0312-2.8678-0.83845-3.64552-2.06357-0.34693-0.53398-0.58073-1.14137-0.6862-1.7672zm2.7157-3.7727h1.0122c-0.16234,0.16958-0.32469,0.33915-0.48703,0.50873-0.83079,0.0143-1.62304,0.51903-1.9876,1.26563-0.28878,0.55882-0.35704,1.21324-0.2554,1.82923-0.33264,0.0561-0.66529,0.11225-0.99793,0.16838-0.21057-1.20911,0.13596-2.54549,1.05047-3.39361,0.57465-0.55007,1.35937-0.86115,2.15166-0.88754-0.16171,0.16968-0.32668,0.3397-0.48637,0.50918zm1.0122,0v0.49069c-0.16234,0.006-0.32469,0.0121-0.48703,0.0181,0.16233-0.1696,0.32477-0.33916,0.48703-0.50879zm0-0.001c-0.33507,0.002-0.67713,0.002-1.0122,0,0.16234-0.16957,0.32468-0.33915,0.48702-0.50872,0.17503,0.16956,0.35029,0.33922,0.52518,0.50872zm-1.0122,0v-0.49068c0.16234-0.006,0.32468-0.0121,0.48702-0.0181-0.16233,0.1696-0.32476,0.33915-0.48702,0.50878z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m482.14,182.98c3.7685,0,6.822,3.0764,6.822,6.8731,0,3.7968-3.0535,6.8732-6.822,6.8732-3.7673,0-6.822-3.0764-6.822-6.8732,0-3.7956,3.0547-6.8731,6.822-6.8731z' fill='%23FFF'/%3E %3Cpath d='m489.47,189.85h-1.0122c0.0279-2.3407-1.3595-4.6239-3.4526-5.6729-0.88056-0.45505-1.8722-0.69026-2.8629-0.68985v-1.0198c2.501-0.0218,4.943,1.3598,6.2325,3.4992,0.71532,1.1614,1.0948,2.5201,1.0952,3.8834zm-7.3281,7.3831v-1.0198c2.323,0.0279,4.5733-1.3682,5.6113-3.4409,0.46533-0.89843,0.70433-1.9109,0.70411-2.922h1.0122c0.0234,2.5978-1.4383,5.1464-3.7072,6.4175-1.0946,0.63293-2.3573,0.96382-3.6205,0.96528zm-7.3281-7.3831h1.0122c-0.0268,2.3405,1.3593,4.6252,3.454,5.6726,0.87994,0.45554,1.8713,0.69068,2.8616,0.69019v1.0198c-2.4871,0.0217-4.9154-1.3449-6.2102-3.4642-0.731-1.1677-1.116-2.5423-1.1177-3.9184zm7.3281-7.3831v1.0198c-2.3367-0.0273-4.5998,1.3859-5.6293,3.4784-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71991,2.4984-1.1014,3.8526-1.103z' fill='%2321231e'/%3E %3Cpath d='m482.14,171.07c3.7685,0,6.822,3.0776,6.822,6.8731,0,3.7968-3.0535,6.8732-6.822,6.8732-3.7673,0-6.822-3.0764-6.822-6.8732,0-3.7956,3.0547-6.8731,6.822-6.8731z' fill='%23FFF'/%3E %3Cpath d='m489.47,177.94h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.86217-0.43085-1.8258-0.65232-2.7891-0.65277v-1.0198c2.4873-0.0212,4.9167,1.3441,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3831v-1.0198c2.323,0.0279,4.5733-1.368,5.6113-3.4408,0.46534-0.89842,0.70433-1.9109,0.70411-2.922h1.0122c0.0234,2.5978-1.4383,5.1464-3.7072,6.4175-1.0946,0.63293-2.3572,0.96371-3.6205,0.96519zm-7.3281-7.3831h1.0122c-0.0268,2.3405,1.3593,4.6252,3.454,5.6726,0.87994,0.45558,1.8712,0.69084,2.8616,0.6903v1.0198c-2.4871,0.0218-4.9154-1.3447-6.2102-3.4641-0.73103-1.1678-1.116-2.5422-1.1177-3.9186zm7.3281-7.3831v1.0198c-2.3367-0.0273-4.5998,1.3859-5.6293,3.4784-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71976,2.4982-1.1017,3.8526-1.103z' fill='%2321231e'/%3E %3Cpath d='m482.14,159.61c3.7685,0,6.822,3.0776,6.822,6.8732s-3.0535,6.8731-6.822,6.8731c-3.7673,0-6.822-3.0776-6.822-6.8731,0-3.7956,3.0547-6.8732,6.822-6.8732z' fill='%23FFF'/%3E %3Cpath d='m489.47,166.49h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.8622-0.43079-1.8258-0.65248-2.7891-0.65287v-1.0198c2.4872-0.0211,4.9167,1.3442,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3831v-1.0198c2.3229,0.0267,4.5746-1.3678,5.6111-3.4422,0.46571-0.89789,0.70461-1.91,0.7043-2.9208h1.0122c0.0215,2.5073-1.3364,4.9677-3.474,6.2798-1.1492,0.71924-2.499,1.1017-3.8537,1.103zm-7.3281-7.3831h1.0122c-0.0281,2.3687,1.3947,4.6769,3.5273,5.7098,0.86177,0.43137,1.8252,0.6527,2.7883,0.65312v1.0198c-2.5015,0.0216-4.9429-1.3608-6.2325-3.5004-0.71673-1.1606-1.0934-2.5196-1.0953-3.8823zm7.3281-7.3831v1.0198c-2.3367-0.0272-4.5998,1.386-5.6293,3.4785-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71998,2.4986-1.1013,3.8526-1.1031z' fill='%2321231e'/%3E %3Cpath d='m482.14,127.08c3.7685,0,6.822,3.0776,6.822,6.8731,0,3.7968-3.0535,6.8744-6.822,6.8744-3.7673,0-6.822-3.0776-6.822-6.8744,0-3.7956,3.0547-6.8731,6.822-6.8731z' fill='%23FFF'/%3E %3Cpath d='m489.47,133.95h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.86217-0.43085-1.8258-0.6523-2.7891-0.65276v-1.0198c2.4873-0.0212,4.9168,1.3441,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3843v-1.0198c2.3228,0.0272,4.5728-1.3687,5.6107-3.4413,0.4656-0.89881,0.70527-1.9113,0.70469-2.9229h1.0122c0.0236,2.5845-1.4229,5.1189-3.6708,6.3984-1.1035,0.64565-2.3797,0.98346-3.6568,0.98567zm-7.3281-7.3843h1.0122c-0.0273,2.3546,1.3765,4.6517,3.4903,5.692,0.87087,0.44417,1.8485,0.67153,2.8254,0.67208v1.0198c-2.4732,0.021-4.8893-1.3292-6.1878-3.4303-0.7467-1.1744-1.1379-2.5639-1.1401-3.9537zm7.3281-7.3831v1.0198c-2.3367-0.0271-4.5998,1.3859-5.6293,3.4785-0.45424,0.88884-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71996,2.4986-1.1013,3.8526-1.1031z' fill='%2321231e'/%3E %3Cpath d='m482.14,137.16c3.7685,0,6.822,3.0764,6.822,6.8719,0,3.7968-3.0535,6.8743-6.822,6.8743-3.7673,0-6.822-3.0776-6.822-6.8743,0-3.7956,3.0547-6.8719,6.822-6.8719z' fill='%23FFF'/%3E %3Cpath d='m489.47,144.03h-1.0122c0.0283-2.3546-1.3775-4.6491-3.4895-5.6909-0.87167-0.44187-1.849-0.67136-2.826-0.67081v-1.0198c2.5647-0.0233,5.0658,1.4324,6.3285,3.6617,0.65615,1.1223,0.99754,2.4212,0.99923,3.7199zm-7.3281,7.3843v-1.0198c2.3228,0.027,4.5728-1.3686,5.6107-3.4413,0.46559-0.89882,0.70527-1.9113,0.70469-2.923h1.0122c0.0236,2.5845-1.4229,5.1189-3.6708,6.3984-1.1035,0.64578-2.3799,0.98315-3.6568,0.98567zm-7.3281-7.3843h1.0122c-0.0273,2.3545,1.3765,4.6517,3.4903,5.692,0.87087,0.44419,1.8485,0.67155,2.8254,0.6721v1.0198c-2.4875,0.0215-4.9157-1.3454-6.2102-3.4654-0.73184-1.1671-1.1157-2.5427-1.1177-3.9185zm7.3281-7.3819v1.0198c-2.3643-0.0284-4.6529,1.4195-5.666,3.5512-0.43071,0.86977-0.64884,1.8407-0.64952,2.8104h-1.0122c-0.021-2.5072,1.3361-4.9682,3.4752-6.2786,1.1475-0.71967,2.499-1.1022,3.8526-1.1029z' fill='%2321231e'/%3E %3Cpath d='m482.14,148.16c3.7685,0,6.822,3.0776,6.822,6.8732,0,3.7968-3.0535,6.8744-6.822,6.8744-3.7673,0-6.822-3.0776-6.822-6.8744,0-3.7956,3.0547-6.8732,6.822-6.8732z' fill='%23FFF'/%3E %3Cpath d='m489.47,155.03h-1.0122c0.0283-2.3684-1.3939-4.6771-3.5264-5.7102-0.86219-0.43078-1.8258-0.65246-2.7891-0.65286v-1.0198c2.4873-0.0211,4.9167,1.3443,6.2102,3.4654,0.73156,1.1663,1.1164,2.542,1.1176,3.9174zm-7.3281,7.3843v-1.0198c2.3228,0.0272,4.5728-1.3686,5.6107-3.4412,0.46559-0.89882,0.70528-1.9113,0.70469-2.923h1.0122c0.0236,2.5845-1.4229,5.1189-3.6708,6.3984-1.1035,0.64568-2.3797,0.98331-3.6568,0.98556zm-7.3281-7.3843h1.0122c-0.0273,2.3545,1.3765,4.6517,3.4903,5.692,0.87087,0.44418,1.8485,0.67154,2.8254,0.67209v1.0198c-2.4732,0.021-4.8893-1.3292-6.1878-3.4303-0.7467-1.1744-1.1379-2.5638-1.1401-3.9537zm7.3281-7.3831v1.0198c-2.3367-0.0272-4.5998,1.386-5.6293,3.4785-0.45425,0.88883-0.68579,1.8872-0.68622,2.8845h-1.0122c-0.0207-2.5072,1.3361-4.969,3.4752-6.2798,1.1483-0.71984,2.4984-1.1016,3.8526-1.1031z' fill='%2321231e'/%3E %3Cpath d='m486.99,195.51c0.97764,1.5779,0.7186,1.8858,1.3596,2.3933,0.82602,0.65184,2.1821,0.65905,3.482,0.45581,5.2451-0.82502,4.5134,2.3512,2.194,5.9267-1.1591,1.7871-3.8521,3.5851-5.2582,5.1209-1.405,1.5358-1.5256,2.8094-2.0806,3.193-2.0126,0.0481-3.7506,0.0577-4.5384,0.0433h-0.004c-0.78784,0.0145-2.5247,0.006-4.5372-0.0433-0.55387-0.38364-0.67445-1.6572-2.0806-3.193-1.405-1.5358-4.0992-3.3338-5.2582-5.1209-2.3194-3.5743-3.0499-6.7517,2.194-5.9267,1.2999,0.20324,2.6572,0.19603,3.482-0.45581,0.64221-0.50753,0.38317-0.8154,1.3608-2.3933,0.63504-1.0222,1.3978-1.7895,2.2274-2.3019,0.82841-0.51113,1.7213-0.2321,2.6154-0.2321,0.89288,0,1.7858-0.27903,2.6154,0.2321,0.82841,0.51233,1.5924,1.2796,2.2274,2.3019h-0.001z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m488.66,197.51c-0.25615,0.15897-0.44919,0.92333-0.74608,0.69824-0.65656-0.60854-0.74168-1.57756-1.26883-2.28148-0.15902-0.27227,0.63977-0.59748,0.80908-0.61857,0.45224,0.63894,0.65581,1.41476,1.0613,2.07114,0.0433,0.0485,0.0981,0.0913,0.14453,0.13067zm-0.62311,0.80096zm3.716-0.44858c-0.0558,0.33175,0.41491,1.05164-0.0991,1.0452-1.21583,0.15079-2.59273,0.18537-3.6168-0.5954,0.25751-0.18209,0.43785-0.87062,0.74611-0.71456,0.88584,0.52005,1.99912,0.396,2.96976,0.26476zm2.6954,6.7096c-0.21622-0.26844-1.07505-0.39896-0.69711-0.79492,0.70951-1.19866,1.5394-2.4757,1.52441-3.91707-0.0389-0.91203-1.10254-1.12267-1.83547-1.1138-0.51326-0.009-1.02498,0.0479-1.53179,0.1243,0.0541-0.33898-0.42619-1.07584,0.12276-1.04642,1.27965-0.15434,2.85152-0.26411,3.79853,0.78665,0.87125,1.13445,0.34647,2.66298-0.18185,3.82782-0.34211,0.74152-0.75819,1.44834-1.19948,2.13344zm-5.3108,5.187c-0.16591-0.29815-0.99767-0.57565-0.55041-0.89343,1.61803-1.6703,3.66422-2.92823,5.01365-4.85162,0.19868,0.2549,1.01451,0.38827,0.72338,0.73963-1.4251,1.9598-3.53609,3.26125-5.18662,5.00542zm-2.4399,3.3566c-0.10771-0.29507,0.21889-1.20241-0.29074-0.93087,0.50374-0.68185,0.77128-1.59705,1.32109-2.28885,0.23372-0.22157,0.48022-0.86891,0.76989-0.73127,0.20661,0.28514,0.90994,0.53926,0.40696,0.86298-0.74768,0.80428-1.05837,1.88644-1.67992,2.76849-0.13161,0.17624-0.31467,0.27581-0.52728,0.31952zm0.27456-0.089zm-4.8249,0.13349c0.10055-0.28918-0.20356-0.98805,0.15315-1.01795,1.45767,0.0103,2.91549-0.009,4.37276-0.0419-0.0978,0.32293,0.27588,1.09427-0.23494,1.02427-1.42216,0.0315-2.90195,0.0483-4.29097,0.0355zm0-1.0198,0.009,0-0.009,0zm-0.004,0c0.007,0.18828,0.007,1.16276-0.001,0.8795,0.004-0.28959-0.0174-0.60511,0.001-0.8795zm-0.009,0,0.009,0-0.009,0zm-4.8142,0.88636c0.0843-0.3026,0.8781-0.8476,0.30604-0.92598,1.47155,0.0306,3.01038,0.055,4.50811,0.0385-0.0884,0.30082,0.21533,0.9817-0.142,1.0218-1.48709-0.003-2.98334,0.0204-4.46428-0.0676-0.0688-0.0217-0.14003-0.0465-0.20787-0.0667zm0.27456,0.089zm-2.4399-3.3566c0.30676-0.14124,0.64671-0.95061,0.92422-0.48554,0.76613,0.82111,1.18399,1.87226,1.73172,2.83174,0.13732,0.27929-0.38,0.61826-0.49076,0.92116-0.74417-0.62803-0.90451-1.67486-1.49742-2.42455-0.202-0.29619-0.42878-0.57771-0.66776-0.84281zm-5.3108-5.187c0.32541-0.0881,0.77284-0.80664,0.9913-0.34844,1.42087,1.87707,3.46791,3.13397,5.06192,4.84514-0.30593,0.14039-0.63056,0.92742-0.91939,0.50443-1.67299-1.70367-3.7674-3.00839-5.13383-5.00113zm2.6954-6.7096c-0.15404,0.30995,0.0839,1.14701-0.43308,0.96888-0.93251-0.0906-2.04935-0.26333-2.82315,0.38614-0.57249,0.74686-0.13118,1.7557,0.16273,2.53089,0.33971,0.79388,0.77931,1.54033,1.2459,2.26536-0.32919,0.0907-0.79828,0.8345-0.99812,0.32127-0.83305-1.39557-1.77588-2.91632-1.67857-4.60387,0.0601-1.17015,1.20221-1.92008,2.29113-1.97038,0.74402-0.0788,1.49657-0.008,2.23316,0.10171zm3.0929-0.35239c0.1059,0.30815,0.86791,0.71576,0.42386,0.94287-1.09222,0.67724-2.45109,0.59195-3.67181,0.4161,0.15196-0.29508-0.0755-1.10323,0.39034-0.973,0.94572,0.1025,2.04228,0.19971,2.85761-0.38597zm1.2438-2.2634c0.18953,0.2426,0.95573,0.35211,0.77227,0.67971-0.55743,0.74242-0.6248,1.80136-1.3933,2.38449-0.11005-0.30814-0.79916-0.66343-0.47621-0.93426,0.40004-0.64504,0.5978-1.40991,1.0419-2.03915-0.003-0.0363,0.0489-0.0572,0.0553-0.0908zm0,0.001zm2.3922-2.4666c0.0736,0.30734,0.68895,0.74034,0.38432,0.9599-0.78607,0.52398-1.42415,1.24707-1.9194,2.0468-0.20586-0.25504-1.04171-0.37039-0.72927-0.74069,0.58948-0.89805,1.34584-1.70025,2.26435-2.26601zm2.8792-0.30789c-0.0984,0.2987,0.21121,1.0188-0.1814,1.0148-0.72121-0.008-1.50828-0.23454-2.1701,0.1617-0.0682-0.31396-0.76119-0.79623-0.33071-0.97771,0.83689-0.43928,1.78824-0.21551,2.68221-0.19879zm2.8804,0.30789c-0.25196,0.19932-0.33583,1.00378-0.7033,0.7769-0.69761-0.28442-1.4529-0.0518-2.1771-0.066,0.0917-0.30031-0.19041-0.9697,0.1528-1.0218,0.91804-0.055,1.90647-0.22518,2.7276,0.3109zm-0.001,0zm1.9636,3.246c-0.0506-0.23628,0.12393-1.35018-0.13505-0.77382-0.17984,0.47884-0.35543,0.62304-0.58228,0.10153-0.47851-0.67149-1.07144-1.2704-1.775-1.7055,0.24322-0.20381,0.35042-0.9986,0.6947-0.76242,0.91004,0.60319,1.65268,1.43526,2.2261,2.3594-0.14275,0.26028-0.28608,0.52048-0.42847,0.78081zm0.42855-0.78052c0.0946,0.28795,0.8281,0.93128,0.13387,0.78052-0.68178,0.15413-0.52984-0.1851-0.22479-0.61493,0.0303-0.0552,0.0606-0.11039,0.0909-0.16559zm-0.42974-0.23933c-0.0817,0.24202,0.16861,1.06094-0.12235,0.95113-0.60517-0.13251,0.031-0.61965,0.12235-0.95117v0.00004zm-0.42854,0.77932c-0.0942-0.28758-0.82715-0.9306-0.13267-0.77932,0.7181-0.16191,0.47158,0.24659,0.18938,0.67619l-0.0338,0.0615-0.0229,0.0417z'/%3E %3Cpath d='m481.35,212.77-0.88335-0.13228c-0.4703-3.7799-1.9696-6.9008-4.3236-9.6272,2.6476,1.8028,4.6184,5.6705,5.2069,9.7595z' fill='%2321231E'/%3E %3Cpath d='m494.21,198.3c-0.46674,1.1485-0.96451,2.4017-1.9792,3.4624-1.5422,1.6104-4.0991,0.56644-6.5749-1.5166-0.78067-0.65544-2.1606-0.97293-3.5345-0.96812-1.3739,0.005-2.7419,0.33313-3.4975,0.96812-2.4757,2.083-5.0326,3.1269-6.5749,1.5166-1.0146-1.0595-1.5112-2.3127-1.9768-3.4624,0.59565-0.11064,1.3799-0.0974,2.3826,0.0602,1.2999,0.20324,2.656,0.19604,3.482-0.45461,0.6422-0.50752,0.38317-0.81659,1.3608-2.3933,0.63385-1.0235,1.3978-1.7907,2.2274-2.3031,0.82842-0.51113,1.7213-0.23211,2.6142-0.23211,0.89408,0,1.787-0.27902,2.6166,0.23211,0.82842,0.51233,1.5924,1.2796,2.2274,2.3031,0.97763,1.5767,0.7186,1.8858,1.3596,2.3933,0.82603,0.65184,2.1821,0.65785,3.482,0.45461,1.0039-0.15755,1.7894-0.17078,2.385-0.0602z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m492.6,202.12c-0.24272-0.23572-0.48544-0.47144-0.72816-0.70716,0.89443-0.92371,1.4057-2.12571,1.8755-3.30234,0.31195,0.12908,0.62391,0.25817,0.93586,0.38725-0.51484,1.29723-1.09758,2.60754-2.0832,3.62225zm-7.2624-1.4793c0.21612-0.26031,0.43126-0.5227,0.64799-0.78173,1.21827,0.98952,2.57463,1.99566,4.18032,2.17533,0.62461,0.0603,1.27764-0.15353,1.70578-0.62149,0.24272,0.23572,0.48544,0.47145,0.72816,0.70717-0.8946,0.99207-2.38639,1.14062-3.59543,0.71645-1.36868-0.43825-2.57589-1.28662-3.66682-2.19573zm0.64699-0.78173c0.12688,0.10511,0.78556,0.66149,0.394,0.33152-0.13121-0.11046-0.26335-0.22126-0.394-0.33152zm-3.8568-0.0673c-0.00067-0.33993-0.001-0.67987-0.002-1.0198,1.34122,0.0153,2.77978,0.22898,3.85919,1.0873-0.21566,0.26057-0.43132,0.52115-0.64698,0.78172-0.89742-0.68763-2.1137-0.8346-3.21021-0.84922zm-3.174,0.84908c-0.21556-0.26031-0.43555-0.5227-0.64837-0.78173,1.06989-0.84737,2.49249-1.06051,3.81995-1.0866,0.00067,0.33993,0.001,0.67987,0.002,1.0198-1.09219,0.0222-2.28424,0.17005-3.17358,0.84853zm-7.2636,1.4793c0.24272-0.23572,0.48543-0.47144,0.72815-0.70716,0.7601,0.84571,2.03884,0.71397,2.98696,0.29974,1.06835-0.43757,2.01682-1.11851,2.89915-1.85379,0.21646,0.26057,0.43291,0.52115,0.64937,0.78172-1.40405,1.14524-3.0026,2.28522-4.86854,2.41562-0.88872,0.053-1.78673-0.28378-2.39509-0.93613zm-1.7046-4.3175c0.0613,0.33433,0.12256,0.66867,0.18384,1.003,0.14437-0.13228,0.3231-0.89658,0.4409-0.53564,0.44753,1.1243,0.95574,2.26119,1.8083,3.14235-0.24271,0.23572-0.48543,0.47143-0.72814,0.70715-0.98561-1.01425-1.56863-2.32575-2.08065-3.62358,0.12504-0.23065,0.25173-0.46478,0.37575-0.69328zm-0.37601,0.69394c-0.13032-0.31513-0.40447-0.70914,0.14535-0.65127,0.48146-0.17084-0.0961,0.42816-0.13805,0.63779l-0.007,0.0135zm2.9281-0.63621c-0.0517,0.33593-0.10345,0.67187-0.15518,1.0078-0.73023-0.10759-1.47997-0.18718-2.2133-0.0617-0.0613-0.33433-0.12255-0.66867-0.18382-1.003,0.84479-0.14626,1.71066-0.0664,2.5523,0.0569zm3.0929-0.35117c0.20749,0.26739,0.41664,0.53422,0.6231,0.80196-1.10247,0.82644-2.5788,0.74267-3.87107,0.5554,0.0517-0.33593,0.10345-0.67187,0.15518-1.0078,1.01556,0.1359,2.21137,0.2702,3.09279-0.34956zm0.6231,0.80096c-0.27731,0.22077-0.64203,0.50621-0.15598,0.12305,0.0519-0.0409,0.10435-0.0828,0.15598-0.12305zm0.62073-3.0632c0.28569,0.1796,0.57138,0.35919,0.85707,0.53879-0.45692,0.64745-0.66583,1.42351-1.0635,2.09936-0.15895,0.18968-0.42817,0.62268-0.58392,0.20634-0.0853-0.23862-0.63963-0.5133-0.30649-0.7161,0.3606-0.53969,0.50729-1.20084,0.86915-1.74697,0.073-0.12869,0.15007-0.25621,0.22769-0.38142zm2.3922-2.4678c0.17587,0.28944,0.35173,0.57888,0.5276,0.86832-0.85161,0.5282-1.5374,1.29132-2.0627,2.1385-0.28569-0.1796-0.57139-0.35919-0.85708-0.53879,0.6068-0.98113,1.40569-1.85965,2.39218-2.46803zm2.878-0.30788v1.0198c-0.77796,0.0191-1.63382-0.26801-2.3503,0.1566-0.17587-0.28944-0.35174-0.57889-0.52761-0.86833,0.86671-0.56924,1.91321-0.33519,2.87791-0.30807zm2.8816,0.30788c-0.17581,0.28915-0.35573,0.5806-0.529,0.86832-0.71717-0.4257-1.57377-0.1383-2.3526-0.1574v-1.0198c0.96839-0.0267,2.01134-0.26182,2.8816,0.30888zm-0.001,0zm2.3922,2.4678c-0.2854,0.18009-0.57308,0.35892-0.85707,0.53979-0.52534-0.84757-1.2118-1.61177-2.0641-2.1397,0.17667-0.28944,0.35333-0.57889,0.53-0.86833,0.98402,0.61061,1.78689,1.48688,2.39117,2.46824zm1.2426,2.2622c-0.20817,0.26672-0.4153,0.53557-0.62411,0.80097-0.72497-0.54059-0.8041-1.51683-1.29693-2.22588-0.37681-0.33877,0.12667-0.46407,0.38325-0.65083,0.30128-0.36229,0.4322,0.0289,0.57764,0.29202,0.34919,0.5263,0.46491,1.18027,0.84321,1.68194,0.0357,0.0352,0.0824,0.0724,0.11694,0.10178zm-0.62311,0.80097c-0.38375-0.30215-0.38144-0.30219,0.0002,0h-0.0002zm3.716-0.44979c0.0517,0.33593,0.10345,0.67187,0.15518,1.0078-1.29202,0.18685-2.77058,0.27305-3.87105-0.5569,0.2077-0.26699,0.4154-0.53398,0.6231-0.80097,0.88238,0.62374,2.08239,0.48551,3.09277,0.35007zm2.9305,0.6374c-0.31195-0.12908-0.6239-0.25817-0.93585-0.38725,0.034,0.20575,0.61155,0.79167,0.1709,0.66413-0.66988-0.0769-1.34701-0.006-2.0107,0.0927-0.0517-0.33593-0.10345-0.67187-0.15518-1.0078,0.84312-0.12503,1.70875-0.20318,2.5546-0.0577,0.12536,0.232,0.25114,0.46382,0.37623,0.69592zm-0.37602-0.69514c0.33558,0.0592,0.81149,0.0418,0.46653,0.4727-0.11688,0.50521-0.30575-0.30438-0.45872-0.45829l-0.008-0.0144h-0.00001zm-0.0919,0.50151c0.48893,0.20233,0.50833,0.21035,0.008,0.003l-0.008-0.003zm0.0919-0.50151c0.33558,0.0592,0.81149,0.0418,0.46653,0.4727-0.11688,0.50521-0.30575-0.30438-0.45872-0.45829l-0.008-0.0144h-0.00001z'/%3E %3Cpath d='m482.14,211.65c4.2698,0,7.7316,3.4877,7.7316,7.7896s-3.4617,7.7896-7.7316,7.7896c-4.2698,0-7.7304-3.4877-7.7304-7.7896s3.4605-7.7896,7.7304-7.7896z' fill='%23EDB92E'/%3E %3Cpath d='m482.94,212.77,0.88214-0.13228c0.47032-3.7799,1.9696-6.9008,4.3236-9.6272-2.6476,1.8028-4.6184,5.6705-5.2057,9.7595z' fill='%2321231e'/%3E %3C/g%3E %3Cuse xlink:href='%23g3987' transform='matrix(-1,0,0,1,964.28557,0)'/%3E %3Cg%3E %3Cpath stroke='%2321231e' stroke-width='1.01444578' fill='%23edb92e' d='m576.93,293.58c2.0018,0.30308,3.0618,1.5683,2.9914,2.8611,0.0692,1.294-0.99197,2.5592-2.9962,2.8623-0.45479,0.12386-0.96331,0.21647-1.5291,0.26578-60.788,5.2363-125.72,5.2375-186.51,0-0.56461-0.0493-1.0731-0.14192-1.5291-0.26578-2.0042-0.30307-3.0654-1.5683-2.995-2.8623-0.0692-1.2929,0.98957-2.558,2.9902-2.8611,0.456-0.12508,0.96689-0.21647,1.5339-0.26578,60.789-5.2375,125.72-5.2351,186.51,0,0.5682,0.0493,1.0779,0.1407,1.5339,0.26578z'/%3E %3Cpath fill='%2321231e' d='m412.13,298.41c-0.76635-0.0252-0.76295-1.36398,0-1.3888,0.59174,0.0185,2.72417-0.21214,3.92052-0.24171,6.46351-0.38192,12.9315-0.71027,19.4001-0.97481,0.66075,2.11101-2.21204,0.97043-3.42686,1.35993-3.69659,0.16703-7.39259,0.34756-11.0873,0.55187,4.85318,0.26466,9.70802,0.49891,14.5643,0.6996,0.56067,2.14616-2.08298,0.81013-3.24918,1.07593-6.71085-0.29953-13.4193-0.65489-20.1234-1.07903,0.071-0.52587-0.042,0.0465,0.002-0.003zm0.0429-0.69634zm46.617-2.629c0.61492,2.12525-2.23274,0.9246-3.45596,1.2879-6.61392,0.1571-13.2266,0.36881-19.8367,0.6428-0.6608-2.11204,2.21374-0.97075,3.42929-1.35009,6.61919-0.25294,13.2407-0.44599,19.8634-0.58061zm23.348-0.22608c0.57186,2.13774-2.24892,0.87788-3.47971,1.21605-6.61542,0.0172-13.2308,0.0871-19.8449,0.21995-0.61477-2.12735,2.23458-0.92079,3.45841-1.2767,6.62081-0.11139,13.2475-0.15944,19.8662-0.1593zm23.348,0.26096c0.52671,2.14846-2.26785,0.83068-3.50493,1.14298-6.61431-0.11788-13.2296-0.18116-19.845-0.18568-0.57113-2.13727,2.25278-0.87765,3.48329-1.20421,6.62225,0.0251,13.2484,0.10837,19.8666,0.24691zm23.342,0.73843c0.48183,2.15877-2.28534,0.78424-3.52851,1.07207-6.612-0.25751-13.2263-0.45441-19.8417-0.59847-0.5264-2.14956,2.27087-0.8295,3.50843-1.13091,6.62237,0.16071,13.2432,0.38148,19.8618,0.65731zm23.322,1.2087c0.35453-0.15541,0.96012,0.97474,0.2053,1.248-2.37546,0.22975-5.54571,0.34822-8.22215,0.517-5.10136,0.28017-10.2045,0.52748-15.3092,0.7403-0.66089-2.11121,2.21192-0.97192,3.42675-1.36234,3.35945-0.15015,6.7182-0.31554,10.0763-0.49406-4.51675-0.24334-9.0351-0.45662-13.5544-0.6466-0.48421-2.16106,2.28693-0.78348,3.53075-1.06106,6.61801,0.29462,13.2371,0.65235,19.8466,1.05876zm-0.0394,0.64342,0,0.005,0-0.005zm-116.61,0.70476c0.77874-0.004,0.72839,1.28362-0.0507,1.2102,0.0171-0.40094,0.033-0.81666,0.0507-1.2102zm93.325,1.1569c-0.77816,0.0714-0.83268-1.21321-0.052-1.2093,0.0175,0.39961,0.0337,0.82021,0.052,1.2093z'/%3E %3Cpath fill='%2321231e' d='m482.37,265.18-22.74,11.455-0.45122-0.91161,22.74-11.455,0.45122,0,0,0.91162zm-0.45122-0.91162,0.22561-0.11305,0.22561,0.11305-0.45122,0zm22.74,12.367-22.74-11.455,0.45122-0.91161,22.74,11.455,0,0.9116-0.45122,0zm0.45122-0.9116,0.90483,0.45581-0.90483,0.45579,0-0.9116zm-23.191,11.455,22.74-11.455,0.45122,0.9116-22.74,11.455-0.45122,0,0-0.9116zm0.45122,0.9116-0.22561,0.11306-0.22561-0.11306,0.45122,0zm-22.74-12.367,22.74,11.455-0.45122,0.91161-22.74-11.455,0-0.91161,0.45122,0zm-0.45122,0.91161-0.90483-0.4558,0.90483-0.45581,0,0.91161z'/%3E %3Cpath fill='%230c4076' d='m482.14,269.15c5.651,0,10.234,3.0776,10.234,6.8731,0,3.7968-4.5826,6.8732-10.234,6.8732-5.651,0-10.232-3.0764-10.232-6.8732,0-3.7956,4.5814-6.8731,10.232-6.8731z'/%3E %3Cpath fill='%2321231e' d='m492.88,276.02c-0.39628-0.0793-1.17356,0.25337-1.03186-0.39271-0.24304-2.32505-2.2509-3.98603-4.26585-4.87326-1.70676-0.75518-3.58053-1.09433-5.44189-1.097,0.0937-0.37485-0.27829-1.22325,0.39061-1.01333,3.30274,0.0929,6.81132,1.17694,8.999,3.77776,0.82543,1.0137,1.35162,2.28029,1.34999,3.59854zm-10.74,7.3831c0.0937-0.37769-0.2783-1.21482,0.39063-1.02516,3.0039-0.0957,6.21119-1.04138,8.21473-3.40259,0.67794-0.82943,1.12681-1.87277,1.12204-2.95492,0.3818,0.083,1.20536-0.25848,0.9966,0.39207-0.20774,2.64588-2.36513,4.65985-4.65817,5.7063-1.88842,0.88551-3.98756,1.27866-6.06583,1.2843zm-10.738-7.383c0.3963,0.0793,1.17364-0.25338,1.03196,0.39272,0.24272,2.32492,2.24909,3.98639,4.26455,4.87326,1.70657,0.75523,3.58061,1.09493,5.44189,1.09708-0.0937,0.37485,0.27829,1.22325-0.39061,1.01333-3.30197-0.0929-6.81187-1.176-8.9978-3.77777-0.82651-1.0125-1.35102-2.28116-1.34999-3.59862zm10.738-7.3831c-0.0937,0.37769,0.2783,1.21482-0.39063,1.02516-3.00445,0.096-6.21089,1.04228-8.21472,3.40401-0.67678,0.82938-1.12575,1.87215-1.12075,2.9537-0.38182-0.083-1.20544,0.25849-0.9967-0.39207,0.20749-2.64549,2.36531-4.65854,4.65687-5.7063,1.88889-0.88546,3.98744-1.27799,6.06593-1.2845z'/%3E %3Cpath fill='%23edb92e' d='m482.14,211.65c4.2698,0,7.7316,3.4877,7.7316,7.7896s-3.4617,7.7896-7.7316,7.7896c-4.2698,0-7.7304-3.4877-7.7304-7.7896s3.4605-7.7896,7.7304-7.7896z'/%3E %3Cpath fill='%2321231e' d='m490.38,219.44h-1.0122c0.0307-2.69177-1.57395-5.31759-3.9895-6.50853-0.99731-0.50844-2.11693-0.7707-3.23575-0.77059v-1.0198c2.81193-0.0235,5.55681,1.53018,7.00575,3.93604,0.80721,1.3033,1.23003,2.83302,1.2317,4.36288zm-8.2377,8.2995v-1.0198c2.67198,0.0311,5.25994-1.58427,6.43849-3.97654,0.51969-1.01768,0.78651-2.16077,0.78666-3.30268h1.0122c0.0246,2.88919-1.58246,5.72366-4.08819,7.16713-1.24769,0.74343-2.70009,1.12957-4.14916,1.13189zm-8.2365-8.2995h1.0122c-0.0306,2.69123,1.57245,5.31792,3.9881,6.50852,0.99733,0.50841,2.1169,0.77088,3.23575,0.77069v1.0198c-2.7959,0.0234-5.52584-1.51249-6.98009-3.89619-0.82215-1.31137-1.25537-2.8581-1.25596-4.40282zm8.2365-8.2995v1.0198c-2.67154-0.031-5.26015,1.58361-6.4373,3.97655-0.51966,1.01769-0.78668,2.16073-0.78676,3.30267h-1.0122c-0.0226-2.81828,1.5022-5.58529,3.90657-7.05886,1.28957-0.81079,2.80889-1.23901,4.32969-1.24016z'/%3E %3Cpath fill='%23edb92e' d='m482.14,213.71c3.1394,0,5.6844,2.564,5.6844,5.727,0,3.1642-2.545,5.7282-5.6844,5.7282s-5.6844-2.564-5.6844-5.7282c0-3.163,2.545-5.727,5.6844-5.727z'/%3E %3Cpath fill='%2321231e' d='m488.33,219.44h-1.0122c0.0218-1.92029-1.11622-3.7938-2.83474-4.65272-0.72087-0.37292-1.53276-0.56331-2.34366-0.56438v-1.0198c2.1012-0.0172,4.15313,1.13629,5.24634,2.92784,0.61775,0.98617,0.94199,2.14687,0.94426,3.30906zm-6.1905,6.2381v-1.0198c1.92848,0.0226,3.79638-1.15118,4.63189-2.88577,0.36284-0.72015,0.54493-1.52712,0.5464-2.33253h1.0122c0.0171,2.1066-1.11514,4.17601-2.9065,5.28725-0.97643,0.62082-2.12812,0.94861-3.28399,0.95085zm-6.191-6.238h1.0122c-0.0219,1.93247,1.13043,3.81729,2.86595,4.67005,0.71323,0.36208,1.51319,0.54728,2.31245,0.54824v1.0198c-2.1012,0.0172-4.15313-1.1363-5.24635-2.92784-0.61861-0.98609-0.94151-2.14797-0.94425-3.31025zm6.1905-6.237v1.0198c-1.90551-0.022-3.75153,1.12283-4.60183,2.82398-0.3815,0.73585-0.57526,1.56512-0.57658,2.39312h-1.0122c-0.0171-2.11828,1.12933-4.19725,2.93611-5.30517,0.97057-0.60782,2.11016-0.92984,3.2545-0.93173z'/%3E %3Cpath fill='%230c4076' d='m482.14,215.83c1.9768,0,3.5787,1.614,3.5787,3.6055,0,1.9916-1.6019,3.6055-3.5787,3.6055-1.9756,0-3.5787-1.6152-3.5787-3.6055,0-1.9916,1.6031-3.6055,3.5787-3.6055z'/%3E %3Cpath fill='%2321231e' d='m486.23,219.44h-1.0122c0.0152-1.20121-0.74035-2.36698-1.84623-2.83826-0.38477-0.17115-0.80603-0.25661-1.22677-0.25739v-1.0198c1.32693-0.009,2.62637,0.68445,3.36603,1.78466,0.46821,0.68106,0.7171,1.50568,0.71917,2.33079zm-4.0848,4.1155v-1.0198c1.192,0.015,2.34008-0.74418,2.80758-1.83821,0.17704-0.39396,0.26457-0.82622,0.26552-1.25764h1.0123c0.009,1.37354-0.71855,2.72385-1.8782,3.46221-0.65203,0.42623-1.42897,0.65167-2.2072,0.65344zm-4.0848-4.1155h1.0122c-0.0146,1.20131,0.74109,2.36751,1.84753,2.83826,0.38426,0.17134,0.80529,0.25636,1.22558,0.25739v1.0198c-1.31942,0.009-2.61173-0.67689-3.35297-1.76686-0.47733-0.68414-0.72964-1.5167-0.73234-2.34859zm4.0848-4.1155v1.0198c-1.19976-0.0146-2.35452,0.75442-2.81713,1.85915-0.17019,0.38848-0.25504,0.81275-0.25584,1.2365h-1.0122c-0.008-1.33117,0.67321-2.64034,1.77278-3.39196,0.6743-0.46988,1.49103-0.72228,2.31239-0.72349z'/%3E %3Cpath d='m482.156,256.301c-43.811,0.21546-67.7872,2.12298-101.625,5.28937-2.02242,0.18925-3.08656,0.89329-3.5,1.21345-0.92466,0.71605-1.32296,1.91247-1.21875,2.98694,0.0927,0.9557,1.12251,3.15638,4.90625,2.76914,23.5771-2.41292,63.7284-5.42575,101.344-5.19603,33.7227,0.20595,66.8395,1.65152,100.875,5.13381,3.00818,0.30777,4.78549-0.35776,5.40625-2.30244,0.53807-1.68562-0.43231-3.14247-1.90625-3.85813-1.9886-0.96554-4.65184-0.94268-8.40625-1.27568-31.1675-2.76438-67.3206-4.90087-95.875-4.76043zm0.125,1.08898c28.7518-0.19006,65.1972,1.71859,95.75,4.63599,3.75206,0.35827,7.1273,0.62131,8,1.21344,1.03365,0.70134,1.84661,1.33975,1.3125,2.76915-0.33591,0.89898-1.0415,1.80792-4.28125,1.46235-33.2559-3.54733-67.801-4.9481-100.906-5.1338-38.2581-0.21459-77.4416,2.5462-101,5.1338-3.78374,0.41561-4.15102-1.0562-4.3125-1.80461-0.20339-0.94266,0.11832-1.5515,1.09375-2.27132,0.44591-0.32906,0.76009-0.57567,2.78125-0.77785,30.6681-3.06777,57.7222-4.93733,101.562-5.22715z' fill='%2321231e'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m314.58,301.17,0,271.32,0,0.004c0.00099,48.555,18.82,92.636,49.174,124.58s72.248,51.749,118.39,51.749h0.00599c46.145-0.00099,88.036-19.805,118.39-51.747,30.356-31.943,49.174-76.026,49.175-124.58v-271.31c-111.71-0.0105-223.43,0.0152-335.14-0.00099z' fill='%23C6363C'/%3E %3Cpath fill='%23FFF' d='m313.39,300c0.1913,94.2424-0.38257,188.499,0.28683,282.732,2.19028,42.5696,19.7274,84.2695,49.2088,115.138,3.18197-4.31506-7.18653-9.19381-9.0302-14.0508-27.6221-34.671-40.243-79.6868-38.107-123.694v-257.765h332.78c-0.19204,93.4137,0.384,186.842-0.2878,280.247-2.85479,67.338-47.2018,131.996-111.115,155.153-17.5416,6.56314-36.2692,9.84193-54.9891,9.8786,1.1411,5.43872,12.1996,0.63827,17.2225,1.4299,63.8825-6.28011,119.605-53.7793,140.576-113.741,11.2656-28.9559,11.5662-60.3486,10.9518-90.9522v-244.376c-112.499,0.00002-224.998,0.00005-337.497,0.00007z'/%3E %3Cg%3E %3Cg stroke='%2321231e' stroke-width='0.99388075' fill='%23FFF'%3E %3Cpath d='m483.67,734.79c1.4555-0.23969,3.9126,0.0669,5.7692-1.3934,2.47-1.9421,1.4907-9.7869,1.2678-14.751-1.1353-25.354-2.1733-68.034-3.4634-127.97-2.1123-0.28786-3.6499-0.13982-5.0949,0.0787-1.4438-0.21853-2.9814-0.36657-5.0937-0.0787-1.2901,59.939-2.3281,102.62-3.4646,127.97-0.22167,4.964-1.2022,12.809,1.269,14.751,1.8566,1.4604,4.3137,1.1526,5.7692,1.3934h3.0412z'/%3E %3Cpath d='m499.55,734.06c-1.4719-0.10574-3.8903,0.42296-5.8724-0.86238-2.6354-1.7095-2.8524-9.7329-3.0799-14.696-1.1623-25.353-3.508-67.829-7.6458-127.64,2.0771-0.47819,3.6229-0.46996,5.0808-0.38419,0.22753-0.0564,0.45858-0.10927,0.69315-0.16096,9.527,59.168,13.124,101.14,19.648,126.46,0.90075,3.4953,2.8348,12.254-0.17592,15.099-1.717,1.6225-4.1918,1.5403-5.6191,1.9104l-3.0283,0.27611v-0.001z'/%3E %3Cpath d='m518.2,731.39c-1.4754,0.0271-3.8364,0.77426-5.9264-0.32662-2.7796-1.4639-2.6671-9.4721-3.9056-14.28-6.5246-25.321-10.122-67.309-19.653-126.5,2.0255-0.66617,3.5643-0.79777,5.0245-0.84475l0.20641-0.0681c15.15,57.536,19.692,98.095,31.451,123.15,1.0884,3.4718,4.0522,12.691,1.2186,15.903-1.5646,1.7729-4.0358,1.9139-5.4244,2.4132l-2.9908,0.54985z'/%3E %3Cpath d='m536.98,726.08c-1.4649,0.17387-3.9349,1.5391-6.1234,0.65089-2.911-1.1808-3.3661-9.747-5.4608-14.209-11.813-25.169-16.342-65.982-31.66-123.94,1.9504-0.86239,3.4693-1.1455,4.9178-1.337,1.3277-0.60976,1.0755-0.92347,3.1854-1.2325,17.797,57.241,23.578,97.056,40.366,121.76,2.7104,3.9876,4.6937,11.975,2.8559,14.525-1.3816,1.9186-3.827,2.304-5.1594,2.9384l-2.9228,0.8424h0.001z'/%3E %3Cpath d='m464.75,734.06c1.4719-0.10574,3.8904,0.42296,5.8725-0.86238,2.6366-1.7095,2.8524-9.7329,3.0799-14.696,1.1635-25.353,3.508-67.829,7.6458-127.64-2.0771-0.47819-3.6218-0.46996-5.0808-0.38419-0.22753-0.0564-0.45741-0.10927-0.69315-0.16096-9.527,59.168-13.124,101.14-19.648,126.46-0.89958,3.4953-2.8336,12.254,0.17593,15.099,1.7182,1.6225,4.1918,1.5403,5.6203,1.9104l3.0283,0.27611-0.001-0.001z'/%3E %3Cpath d='m446.09,731.39c1.4743,0.0271,3.8364,0.77426,5.9264-0.32662,2.7785-1.4639,2.6659-9.4721,3.9044-14.28,6.5246-25.321,10.122-67.309,19.655-126.5-2.0255-0.66617-3.5655-0.79777-5.0257-0.84475l-0.20524-0.0681c-15.151,57.536-19.693,98.095-31.451,123.15-1.0884,3.4718-4.0534,12.691-1.2186,15.903,1.5634,1.7729,4.0358,1.9139,5.4244,2.4132l2.9908,0.54985z'/%3E %3Cpath d='m427.31,726.08c1.4649,0.17387,3.9349,1.5391,6.1234,0.65089,2.911-1.1808,3.3661-9.747,5.462-14.209,11.812-25.169,16.341-65.982,31.659-123.94-1.9504-0.86239-3.4693-1.1455-4.9178-1.337-1.3277-0.60976-1.0755-0.92347-3.1854-1.2325-17.797,57.241-23.578,97.056-40.366,121.76-2.7093,3.9876-4.6937,11.975-2.8559,14.525,1.3816,1.9186,3.827,2.304,5.1594,2.9384l2.9227,0.8424h-0.00099z'/%3E %3Cpath d='m527.05,682.84c-1.3406,0.0811-3.3602,0.89879-5.4643-0.10457-2.7984-1.3347-4.6257-9.0667-6.1258-13.873-11.915-23.54-22.791-65.347-40.632-123.45,1.7276-0.72844,3.108-0.91407,4.4322-1.0128,1.1752-0.51695,2.4536-0.98809,4.3782-1.162,19.215,57.497,27.843,99.074,46.623,121.97,3.101,3.7796,5.4068,12.025,3.9314,14.414-1.1072,1.7976-3.3368,2.0267-4.5143,2.5672l-2.6295,0.64855h0.00099z'/%3E %3Cpath d='m511.85,685.82c-1.3441-0.0271-3.4494,0.62739-5.4268-0.54046-2.6319-1.5521-3.5619-9.3945-4.5014-14.299-4.8016-25.052-13.658-67.097-26.244-126.12,1.8038-0.58628,3.1995-0.6603,4.5284-0.65442,1.2292-0.42063,2.5556-0.78719,4.492-0.80716,14.871,58.657,18.311,102.58,32.376,125.13,2.5627,4.1086,3.9982,12.402,2.2566,14.663-1.3101,1.7001-3.5561,1.7506-4.7899,2.1947l-2.6917,0.4359z'/%3E %3Cpath d='m496.38,687.58c-1.3347-0.13394-3.5045,0.34894-5.34-0.97048-2.4407-1.7565-2.4642-9.6354-2.8348-14.592-1.8977-25.321-5.876-67.88-11.614-127.64,1.8625-0.43942,3.2605-0.403,4.5823-0.28902,1.2726-0.32076,2.6342-0.58041,4.5636-0.4453,8.0551,59.573,12.736,102.71,17.833,127.14,1.0169,4.8723,2.5521,12.664,0.55829,14.776-1.4989,1.5873-3.7402,1.458-5.0186,1.8023l-2.7304,0.21854z'/%3E %3Cpath d='m437.24,682.84c1.3406,0.0811,3.3602,0.89879,5.4643-0.10457,2.7984-1.3347,4.6257-9.0667,6.1258-13.873,11.915-23.54,22.791-65.347,40.632-123.45-1.7276-0.72844-3.108-0.91407-4.4322-1.0128-1.174-0.51695-2.4536-0.98809-4.3782-1.162-19.215,57.497-27.843,99.074-46.623,121.97-3.0998,3.7796-5.4068,12.025-3.9314,14.414,1.1072,1.7976,3.3368,2.0267,4.5143,2.5672l2.6295,0.64855h-0.00099z'/%3E %3Cpath d='m452.44,685.82c1.3429-0.0271,3.4482,0.62739,5.4268-0.54046,2.6319-1.5521,3.5608-9.3945,4.5002-14.299,4.8016-25.052,13.659-67.097,26.245-126.12-1.805-0.58628-3.1995-0.6603-4.5296-0.65442-1.228-0.42063-2.5545-0.78719-4.4908-0.80716-14.871,58.657-18.311,102.58-32.378,125.13-2.5627,4.1086-3.9982,12.402-2.2554,14.663,1.3101,1.7001,3.5549,1.7506,4.7887,2.1947l2.6929,0.4359z'/%3E %3Cpath d='m467.92,687.58c1.3347-0.13394,3.5045,0.34894,5.34-0.97048,2.4407-1.7565,2.4642-9.6354,2.836-14.592,1.8977-25.321,5.876-67.88,11.614-127.64-1.8636-0.43942-3.2605-0.403-4.5823-0.28902-1.2726-0.32076-2.6342-0.58041-4.5647-0.4453-8.054,59.573-12.735,102.71-17.832,127.14-1.0169,4.8723-2.5533,12.664-0.55945,14.776,1.5001,1.5873,3.7402,1.458,5.0198,1.8023l2.7304,0.21854h-0.00099z'/%3E %3Cpath d='m483.52,688.09c1.3124-0.23967,3.5279,0.0682,5.2028-1.3923,2.2284-1.9421,1.3441-9.7881,1.1435-14.752-1.0239-25.356-1.9598-68.036-3.1233-127.98-1.9059-0.28784-3.2922-0.13981-4.5952,0.0787-1.303-0.21736-2.6882-0.36656-4.594-0.0787-1.1635,59.942-2.0994,102.62-3.1233,127.98-0.20055,4.964-1.0849,12.81,1.1424,14.752,1.676,1.4604,3.8915,1.1526,5.2039,1.3923h2.7433z'/%3E %3Cpath d='m516.54,647.97c-1.0274,0.0811-2.5744,0.89997-4.1859-0.1034-2.1428-1.3358-3.542-9.0667-4.6914-13.873-9.1259-23.54-17.457-65.347-31.123-123.45,1.3241-0.72726,2.3809-0.91289,3.3942-1.0128,0.90075-0.51696,1.8801-0.98692,3.3543-1.162,14.718,57.497,21.327,99.074,35.711,121.97,2.375,3.7797,4.1413,12.025,3.0119,14.415-0.84914,1.7964-2.5568,2.0267-3.4576,2.566l-2.015,0.64971h0.00099z'/%3E %3Cpath d='m504.9,650.96c-1.0298-0.0271-2.6413,0.62623-4.1566-0.54046-2.0161-1.552-2.728-9.3945-3.4482-14.299-3.6769-25.054-10.461-67.099-20.101-126.12,1.3828-0.58628,2.4512-0.6603,3.4681-0.65442,0.94179-0.42062,1.9575-0.78719,3.4411-0.80716,11.391,58.657,14.025,102.58,24.799,125.13,1.9634,4.1086,3.0623,12.402,1.7288,14.663-1.004,1.7001-2.7234,1.7506-3.6687,2.1947l-2.0619,0.43589z'/%3E %3Cpath d='m493.05,652.72c-1.0216-0.13511-2.6835,0.34896-4.0897-0.97164-1.8695-1.7553-1.8871-9.6354-2.1721-14.592-1.452-25.32-4.5002-67.88-8.8949-127.64,1.4274-0.43824,2.4982-0.40182,3.5103-0.28902,0.97464-0.32076,2.0185-0.57924,3.4963-0.44412,6.1692,59.573,9.7546,102.71,13.659,127.14,0.77877,4.8723,1.9551,12.664,0.42808,14.776-1.1482,1.5873-2.8653,1.4581-3.8446,1.8011l-2.0912,0.21971h-0.00099z'/%3E %3Cpath d='m447.75,647.97c1.0274,0.0811,2.5744,0.89997,4.1859-0.1034,2.1428-1.3358,3.542-9.0667,4.6914-13.873,9.1259-23.54,17.457-65.347,31.123-123.45-1.3241-0.72726-2.3809-0.91289-3.3942-1.0128-0.90075-0.51696-1.8789-0.98692-3.3543-1.162-14.718,57.497-21.327,99.074-35.711,121.97-2.375,3.7797-4.1413,12.025-3.0119,14.415,0.84914,1.7964,2.5568,2.0267,3.4576,2.566l2.015,0.64971h-0.00099z'/%3E %3Cpath d='m459.39,650.96c1.0286-0.0271,2.6413,0.62623,4.1566-0.54046,2.015-1.552,2.728-9.3945,3.447-14.299,3.678-25.054,10.462-67.099,20.101-126.12-1.3816-0.58628-2.4501-0.6603-3.4681-0.65442-0.94062-0.42062-1.9575-0.78719-3.44-0.80716-11.391,58.657-14.025,102.58-24.8,125.13-1.9622,4.1086-3.0623,12.402-1.7276,14.663,1.0028,1.7001,2.7234,1.7506,3.6675,2.1947l2.063,0.43589z'/%3E %3Cpath d='m471.25,652.72c1.0227-0.13511,2.6846,0.34896,4.0897-0.97164,1.8707-1.7553,1.8883-9.6354,2.1721-14.592,1.4532-25.32,4.5002-67.88,8.8949-127.64-1.4274-0.43824-2.497-0.40182-3.5103-0.28902-0.97464-0.32076-2.0173-0.57924-3.4951-0.44412-6.1704,59.573-9.7558,102.71-13.66,127.14-0.77877,4.8723-1.9551,12.664-0.42692,14.776,1.1482,1.5873,2.8641,1.4581,3.8434,1.8011l2.0924,0.21971z'/%3E %3Cpath d='m483.2,653.23c1.0063-0.23967,2.7034,0.0681,3.9865-1.3923,1.7065-1.9421,1.0298-9.7869,0.87611-14.751-0.78463-25.357-1.5024-68.037-2.3938-127.98-1.459-0.28785-2.5216-0.13981-3.5197,0.0787-0.99809-0.21852-2.0595-0.36656-3.5186-0.0787-0.89136,59.942-1.6091,102.62-2.3938,127.98-0.15364,4.964-0.83038,12.809,0.87612,14.751,1.2831,1.4604,2.9802,1.1526,3.9865,1.3923h2.1006z'/%3E %3Cpath d='m474.88,559.13c-0.0786,4.2484-0.13019,9.015-0.16185,13.914l-0.047,0.0154-10.59,2.2006c-0.0234,4.8312,11.917,55.429,18.064,55.429,6.1539,0,18.088-50.631,18.064-55.462l-10.588-2.1677-0.0481-0.0153c-0.0329-4.8993-0.0833-9.6659-0.16185-13.914-2.2249,1.847-4.6808,5.0709-7.2658,7.9823-2.5861-2.9114-5.0386-6.1353-7.2635-7.9823h-0.002z'/%3E %3C/g%3E %3Cg%3E %3Cg id='g3464'%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m412.13,584.52c-3.2019,0.13746-7.1298,1.9703-18.607,11.936-5.0092,10.24-10.058,20.537-17.019,29.416-2.3762,1.5708-4.2387,2.6658-6.1223,3.2886-1.9645,0.64854-16.435,0.17036-16.788-0.43589-4.5026-4.0898-11.384-1.1749-9.0872,3.1382-1.7839,1.6942,2.144,7.8883,5.3013,5.3188,2.8981-2.3592,12.985-0.13158,16.346-1.3523-1.2714,3.0312-10.384,5.0051-16.755,5.468-5.822,0.2479-5.435,6.0637-3.0342,10.524,2.7269,1.7412,0.48791-0.45703,1.4778,0.81539,2.6061,3.869,8.1818,3.3661,8.3683-0.41591,0.19469-3.916,13.787-9.0115,15.825-12.016-2.4923,5.9438-8.2393,11.489-11.094,17.31-3.0646,3.0818-4.9283,3.6974-0.96525,9.9115,4.3982-0.50287,4.6562-1.6719,7.3631,0.89057,6.012-0.65794,6.9843-2.445,6.0108-7.2104-1.0298-5.0333,3.1772-14.139,4.5765-16.711,1.2913-2.3733,1.6068-4.8382,2.8618-6.3245,2.1803-2.5824,12.571-7.7508,15.232-6.3315,4.8966,2.6118,8.6345,1.0316,9.2514-3.7174-1.5775-1.2231-0.39407-7.9682-3.7824-8.2537-2.7703-0.2338-4.4123,0.62035-6.9573,2.7023-4.0112,3.2792-6.0695,5.025-7.3901,4.6608-3.1268-0.86121,5.6649-5.1802,13.66-15.683,11.081-14.553,11.841-21.948,11.327-26.928l0.00099-0.00099z' fill='%23EDB92E'/%3E %3Cuse xlink:href='%23path1214' transform='matrix(-1,0,0,1,801.63351,0)'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m345.18,634.54c-4.0123-2.3522-6.3181-2.2593-7.8745-0.50873-0.85501,0.96225-1.9481,0.4641-1.3089-1.0468,2.6682-6.3139,6.9233-7.0999,10.741-4.1403,1.0696,0.99044,1.9282,1.8422,2.7879,2.6917-0.64038,0.94815-3.8282,2.277-4.3454,3.0042z' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m402.64,628.89c4.2586-2.9008,8.2498-3.4683,10.436-1.8387,1.2022,0.89528,2.3903,0.25262,1.3324-1.236-4.417-6.2199-9.5939-6.536-13.5-3.0289-1.0603,1.1491-1.9035,2.1301-2.7456,3.1088,1.337,1.4663,4.2914,3.1194,4.4768,2.9948z' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m369.09,664.55c0.12901-0.25729-0.97815-5.4398-2.7116-7.0588-1.3488,1.0809-2.8629,2.0349-4.2868,3.5224-4.2598,4.4517-4.241,11.011,2.4137,16.728,1.6432,1.4122,2.3926-0.0764,1.7288-1.7001-1.1353-2.7763,0.24395-6.3186,2.8559-11.492z' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m352.47,650.93c-3.956,1.6437-5.3212,3.7268-5.177,6.4631,0.0786,1.505-0.90895,2.0655-1.4672,0.31605-4.8368-11.243,0.18062-13.347,7.43-12.938,0.41636,1.9586-0.61457,6.0872-0.78698,6.1588h0.001z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m383.95,621.26c0.3374,0.20443,0.6748,0.40886,1.0122,0.61329-0.3244,0.50656-0.34001,1.1771-0.0602,1.70646,0.4121,0.80365,1.17014,1.35457,1.92862,1.80651-0.19821,0.3415-0.39642,0.683-0.59463,1.0245-0.95832-0.56597-1.88564-1.29077-2.39267-2.30615-0.39948-0.78123-0.43536-1.74297-0.0555-2.53875,0.0473-0.10524,0.10465-0.20602,0.16216-0.30586zm6.5058,0.81656c-0.24786,0.30665-0.49573,0.6133-0.74359,0.91995-0.81429-0.64465-1.60347-1.33429-2.5099-1.84933-0.39091-0.20626-0.8601-0.4293-1.30322-0.2542-0.42602,0.19069-0.69677,0.59875-0.93815,0.98008-0.3374-0.20404-0.6748-0.40808-1.0122-0.61212,0.39642-0.6551,0.93046-1.30294,1.69088-1.53077,0.69094-0.21537,1.42902,0.00076,2.0456,0.3324,0.95154,0.51593,1.77912,1.2239,2.62229,1.8952,0.0494,0.0389,0.099,0.0835,0.14829,0.11879z'/%3E %3Cpath fill='%2321231e' d='m387.33,617.58c0.3374,0.20443,0.6748,0.40887,1.0122,0.6133-0.32411,0.50693-0.33904,1.17676-0.0601,1.70661,0.41244,0.80334,1.16992,1.35483,1.92808,1.80733-0.19821,0.3411-0.39642,0.6822-0.59463,1.0233-0.95852-0.56475-1.88467-1.28976-2.39268-2.30383-0.39611-0.77618-0.43762-1.73031-0.0636-2.52292,0.05-0.11127,0.10711-0.22041,0.17073-0.32379zm6.5058,0.81656c-0.24786,0.30704-0.49572,0.61407-0.74358,0.92111-0.81287-0.64683-1.60458-1.33345-2.5099-1.8505-0.39147-0.20529-0.85995-0.4288-1.30331-0.25327-0.4266,0.18942-0.69751,0.59861-0.93807,0.98033-0.3374-0.20443-0.6748-0.40887-1.0122-0.6133,0.3933-0.64965,0.92118-1.29208,1.67269-1.52411,0.70153-0.22678,1.45512-0.005,2.0807,0.33511,0.96699,0.5283,1.80731,1.2511,2.66548,1.9347,0.0293,0.0226,0.059,0.0507,0.0882,0.0699z'/%3E %3Cpath fill='%2321231e' d='m390.88,612.83c0.35303,0.18211,0.70607,0.36422,1.0591,0.54633-0.4265,0.80663-0.40479,1.80508-0.002,2.6161,0.45277,0.94343,1.25296,1.66552,2.09913,2.25504-0.22402,0.32897-0.44803,0.65795-0.67205,0.98692-1.14831-0.79271-2.20783-1.83054-2.68436-3.17096-0.38433-1.04823-0.31033-2.24642,0.2-3.23343zm7.145,1.1032c-0.27367,0.28902-0.54733,0.57805-0.821,0.86707-0.89004-0.83429-1.74809-1.71752-2.7606-2.40633-0.38725-0.23925-0.84397-0.51655-1.3161-0.38752-0.51241,0.19724-0.80796,0.70377-1.07237,1.15504-0.061,0.14719-0.12686,0.27895-0.27847,0.13391-0.29917-0.15432-0.59833-0.30865-0.8975-0.46297,0.39201-0.74961,0.88739-1.5244,1.68435-1.88791,0.63621-0.28989,1.37902-0.17431,1.98468,0.1361,0.96794,0.49186,1.7618,1.2521,2.55437,1.98031,0.30895,0.28724,0.61952,0.58946,0.92264,0.8723z'/%3E %3Cpath fill='%2321231e' d='m394.82,607.72c0.3581,0.17428,0.7162,0.34855,1.0743,0.52283-0.4936,0.9997-0.43902,2.21783,0.0679,3.20131,0.48703,0.98869,1.29989,1.77423,2.17694,2.42177-0.23418,0.32427-0.46836,0.64855-0.70254,0.97282-1.2606-0.92605-2.39716-2.14156-2.86574-3.66498-0.35306-1.13018-0.27296-2.38932,0.24913-3.45375zm7.552,1.2666c-0.28305,0.28158-0.56609,0.56317-0.84914,0.84475-0.95102-0.9464-1.86116-1.95016-2.95441-2.73751-0.40338-0.26228-0.88515-0.57213-1.38628-0.42766-0.53587,0.22046-0.83891,0.75983-1.11382,1.23929-0.082,0.0872-0.1013,0.33917-0.21727,0.31813-0.34367-0.16708-0.68735-0.33415-1.03102-0.50122,0.4081-0.82193,0.91008-1.68634,1.76458-2.10654,0.66373-0.32396,1.45422-0.19818,2.08445,0.14388,1.03064,0.55043,1.85771,1.39744,2.68784,2.20391,0.3412,0.33631,0.67943,0.6905,1.01507,1.02297z'/%3E %3Cpath fill='%2321231e' d='m399.15,602.61c0.33387,0.21109,0.66773,0.42218,1.0016,0.63327-0.47378,0.72384-0.62251,1.64944-0.36688,2.47931,0.37412,1.25297,1.27919,2.25861,2.2239,3.12472,0.1479,0.13461,0.29967,0.26478,0.45242,0.39384-0.25255,0.3043-0.50511,0.60861-0.75766,0.91291-1.21965-1.02962-2.3743-2.2367-2.94617-3.75499-0.38495-1.02829-0.38643-2.2076,0.0818-3.20945,0.088-0.19975,0.1969-0.39971,0.31103-0.57961zm7.525,1.4299c-0.28969,0.26905-0.57939,0.53811-0.86908,0.80716-0.87256-0.92719-1.71627-1.89687-2.7299-2.67519-0.41247-0.294-0.92379-0.62869-1.45131-0.4578-0.60689,0.24764-0.99162,0.82048-1.35128,1.33991-0.0699,0.20983-0.19153,0.18383-0.33631,0.052-0.26276-0.16594-0.52553-0.33187-0.7883-0.49781,0.49754-0.76789,1.06777-1.56896,1.92948-1.95195,0.71916-0.33396,1.56783-0.16199,2.22047,0.24359,1.02913,0.62365,1.84574,1.52697,2.67427,2.38571,0.2357,0.24954,0.46771,0.50499,0.70196,0.75435z'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m462.62,580.6-9.4895-5.3752c-3.9924,2.8668-6.9456,13.516-0.12315,22.215,8.5032,10.843,11.947,18.704,14.025,27.481,6.1891-7.9294,8.3178-16.27,4.3876-24.406-5.3024-10.976-8.753-17.165-8.7999-19.915z' fill='%23FFF'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m470.37,573.01-9.4895-5.3752c-3.9924,2.8679-12.335,13.179-5.5136,21.877,8.5032,10.843,17.338,19.044,19.415,27.819,6.1903-7.9282,8.8233-16.271,4.8943-24.407-5.3024-10.975-9.2585-17.164-9.3066-19.913z' fill='%23FFF'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m449.43,569.16-9.4895-5.3752c-3.9924,2.8668-6.9456,13.515-0.12315,22.214,8.5043,10.844,11.947,18.706,14.025,27.482,6.1903-7.9294,8.319-16.271,4.3888-24.407-5.3036-10.975-8.753-17.164-8.8011-19.913z' fill='%23FFF'/%3E %3Cpath d='m405.49,468.99c0.18179,8.6778-1.3558,66.559-1.8402,74.738-0.48321,8.1444-4.0921,13.695-7.9378,16.877-3.5268-4.8488-5.632-11.392-6.134-19.156-0.25451-3.9582,0.47382-58.733,0.77759-69.991,6.4812-17.161,11.29-17.811,15.134-2.4685z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m404.14,543.76c-1.71385,0.35612-0.65866-1.76311-0.86398-2.77246,0.80624-23.2651,1.45647-46.5386,1.72476-69.8165-0.45774-1.11048,0.48063-3.37179,0.98854-1.55775-0.14541,21.3149-0.82314,42.6232-1.45118,63.9284-0.11718,3.40644-0.22042,6.81502-0.39814,10.2183zm-8.8351,17.141c1.19201-0.71951-0.38875-0.72748,1.28027-1.75743,4.12388-4.02511,6.25829-9.7519,6.56258-15.4419,1.71842-0.3589,0.65513,1.74111,0.71012,2.73536-0.80615,5.55881-3.46906,10.9457-7.83516,14.5557-0.23921-0.0307-0.4788-0.0609-0.71781-0.0917zm0.71778,0.0916zm-6.9468-19.508c1.61235-0.56846,0.88306,1.53273,1.22074,2.48472,0.66676,5.78243,2.36629,11.5855,5.81041,16.3466-1.11271,1.37933-1.62561-0.97142-2.29533-1.71086-3.00554-5.18815-4.34436-11.1834-4.73582-17.1205zm0.80928-70.199c1.63934-0.0179,0.69619,1.53574,0.89839,2.78445-0.37555,22.1585-0.76737,44.3199-0.7433,66.482,0.15753,1.87534-1.66343,0.53588-1.00619-0.82738,0.0296-22.7602,0.37564-45.5202,0.81936-68.2759l0.0317-0.16332,0.00004,0.00011zm-0.0317,0.16331zm16.128-2.4661c-1.60133,0.62436-1.10848-1.41608-1.68493-2.46449-0.96888-2.75913-1.68286-6.07452-4.23682-7.82059-2.19049-0.75026-3.66401,1.73845-4.73245,3.24856-1.88502,3.03716-3.23129,6.36639-4.51312,9.6917-1.80255-0.20645,0.009-2.0384,0.15064-3.08955,1.65247-3.68467,3.13667-7.78405,6.38705-10.3763,1.85652-1.50747,4.33692-0.12192,5.27887,1.74935,1.69251,2.75877,2.56024,5.95076,3.35076,9.06136zm-0.0153-0.11044z'/%3E %3Cpath d='m367.87,454.83-2.456,79.583c-0.77525,7.06,8.4175,49.073,13.442,57.361,12.436-5.3176,15.062-33.821,12.721-61.594-2.3398-27.775,0.39173-51.76,2.2882-56.751,0.16537-6.2822-0.8902-12.835-0.95235-19.378-7.9179,0.47349-17.125,0.30431-25.043,0.77896z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m364.91,534.4c0.81863-26.5277,1.63727-53.0553,2.4559-79.583,2.00906-0.18992,0.46287,2.96295,0.86084,4.28783-0.7758,25.1215-1.54947,50.243-2.32661,75.3645-0.33003-0.023-0.66013-0.0465-0.99013-0.0693zm0.99222,0.0305zm12.751,56.888c0.71842,2.27904-1.44719-1.0928-1.57931-2.05384-4.50783-11.7892-7.16035-24.193-9.73103-36.5212-1.07185-6.07705-2.51239-12.182-2.43058-18.3819,1.89867-0.10345,0.50712,2.7447,1.12252,3.99929,1.77987,14.1235,5.05062,28.0354,8.93429,41.7182,1.21964,3.88287,2.3376,7.85254,4.30355,11.4391-0.20641-0.0662-0.41312-0.13375-0.61944-0.19958zm0.38939,0.91642zm12.031-62.01c1.93699-0.45988,0.80991,2.71145,1.29055,3.94258,0.83056,14.4316,0.94984,29.207-2.93253,43.2484-1.78479,5.78999-4.54688,12.1486-10.3891,14.8192-1.04447-1.57962,2.04223-1.66927,2.71858-2.91727,5.78612-5.6445,7.45667-14.0154,8.76412-21.6833,1.79248-12.3778,1.54492-24.9734,0.54839-37.4095zm2.2871-56.806c2.04742-0.29514-0.19317,2.50286,0.0752,3.6844-2.58042,15.6214-2.62798,31.5632-1.78443,47.3381,0.11353,1.90151,0.25629,3.80109,0.41208,5.69957-1.93503,0.46199-0.81088-2.70098-1.29263-3.92954-0.98689-16.2253-0.967-32.6247,1.58228-48.7127,0.22985-1.30314,0.61102-3.10937,1.00755-4.07975zm0.99223,0.0259zm-1.4192-18.894c0.0296-2.28165,0.77742,1.03598,0.5323,1.93507,0.23314,5.65586,1.02818,11.2892,0.88609,16.9585-1.75242,0.39268-0.67625-1.92271-0.99542-2.96314-0.14784-5.48368-0.89866-10.9348-0.9498-16.4228,0.17564,0.16405,0.35109,0.32849,0.52683,0.49232zm-0.0586-0.99397zm-24.517,1.2912c-2.36485-0.29954,1.60977-0.80775,2.50872-0.66251,7.3336-0.29875,14.6796-0.20342,22.0085-0.6292,0.44083,1.91066-2.56017,0.75067-3.74954,1.17357-7.07633,0.26342-14.1634,0.18751-21.2344,0.5998,0.15546-0.16045,0.31147-0.3214,0.46673-0.48166zm-0.99224-0.0305zm0.49612,0.0153zm-0.49612-0.0153z'/%3E %3Cpath d='m353.13,467.85,1.6889,79.603c-0.4058,7.094,10.96,48.541,16.409,56.542,12.613-9.7893,10.075-49.808,8.1419-61.917-3.8516-24.13-3.1972-52.079-1.8684-56.621-0.16068-6.2822-0.32136-13.805-0.72364-20.334-7.8827,0.9082-15.764,1.8188-23.647,2.727h-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m354.32,547.47c-0.56297-26.5343-1.12593-53.0687-1.6889-79.603,2.00539-0.29152,0.61507,2.96023,1.08562,4.27026,0.53168,25.1168,1.0682,50.2336,1.59686,75.3503-0.33118-0.006-0.66244-0.012-0.99358-0.0176zm0.99457-0.0212zm15.608,56.159c1.15861,2.07973-1.51036-0.96724-1.60246-2.02495-5.18426-11.7058-8.51903-24.1327-11.7547-36.4899-1.3327-5.82587-3.02426-11.6605-3.24412-17.6619,1.892-0.20216,0.64851,2.72254,1.33118,3.94472,2.51654,14.0296,6.51833,27.7686,11.1216,41.2455,1.41213,3.78013,2.727,7.65191,4.86263,11.0993-0.23799-0.0375-0.47647-0.0754-0.71421-0.1127zm0.60753,0.78719zm7.3479-62.232c1.9043-0.59003,0.97768,2.67526,1.51917,3.86328,1.4132,14.2565,1.8245,28.8288-1.06518,42.9333-1.30923,5.62379-3.19524,11.6222-7.80198,15.4355-1.41041-1.30428,1.64154-2.17497,2.00776-3.57635,4.87138-7.28239,5.81354-16.3273,6.58413-24.8434,0.71832-11.2677,0.33616-22.632-1.2439-33.8123zm-1.8742-56.687c1.94636-0.44579,0.15803,2.24252,0.47305,3.35864-1.12551,15.622-0.33781,31.3508,1.48978,46.8907,0.26241,2.09803,0.56406,4.19093,0.89191,6.27969-1.90271,0.61335-0.99483-2.64649-1.56973-3.82081-2.09636-16.2323-2.93319-32.6846-1.84335-49.0276,0.0798-1.11352,0.35908-3.11068,0.55834-3.6807zm0.99223-0.0259zm-1.1635-19.826c-0.0796-2.29566,0.84339,1.05589,0.57932,1.97031,0.30283,5.94802,0.43128,11.9029,0.5844,17.8562-1.75924,0.47646-0.75202-1.96077-1.06874-3.00182-0.1478-5.76502-0.29743-11.5317-0.6476-17.2887,0.18423,0.15457,0.36832,0.30978,0.55262,0.46402zm-0.11259-0.98926zm-23.591,3.7197c-0.51665-1.88658,2.30987-0.87153,3.4679-1.39793,6.70754-0.77384,13.4151-1.54773,20.1228-2.32037,0.55755,1.86267-2.44011,0.90186-3.58188,1.41447-6.66926,0.76756-13.3406,1.54352-20.0088,2.30383zm0.0563-0.004zm-0.0575-0.99279zm-0.49729,0.50873z'/%3E %3Cpath d='m342.19,486.7,20.911-0.53341c-1.7769,8.6837-0.35537,35.655,3.2523,56.214,3.3825,19.277,8.1067,69.272-11.96,81.276-12.444-26.379-2.9696-52.014-9.2409-74.92-4.8931-24.344-5.8584-44.679-2.9626-62.037z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m363.12,486.66c-6.97033,0.1778-13.9407,0.35561-20.911,0.53341-0.30523-1.99644,2.92892-0.63108,4.22927-1.1025,5.55198-0.14162,11.104-0.28325,16.6559-0.42487,0.38447,0.50933,0.77009,0.55158,0.0258,0.99396zm-0.0258-0.99396zm3.7543,56.626c-1.88735,0.64392-1.03402-2.6025-1.63027-3.76077-2.28541-15.5683-3.79333-31.334-3.20988-47.0818,0.11408-1.80357,0.26476-3.61005,0.61221-5.38579,1.90658,0.0541,0.15456,2.63041,0.48978,3.90162-0.81994,14.5147,0.54772,29.0659,2.36724,43.4587,0.40141,2.96427,0.85739,5.92114,1.37092,8.86805zm-12.898,81.575c0.66675-0.58066,1.02837-1.42759,2.81464-2.58491,6.99114-6.3467,9.39655-16.0369,10.8489-25.022,2.41798-17.323,1.16529-34.964-1.47212-52.1868-0.79575-2.82581,1.5201-1.46036,1.11584,0.68072,2.60708,17.5245,3.82027,35.484,1.12579,53.0738-1.61856,9.10777-4.38879,18.923-11.8715,24.9867-0.84073,0.36386-1.59524,1.64739-2.56157,1.05245zm0.70371,0.21501zm-9.9822-75.249c1.87337-0.82976,1.2189,2.49765,1.86502,3.61044,3.4866,18.2687-0.59609,37.0847,3.21072,55.3308,1.05605,5.40405,2.76594,10.6798,5.10149,15.6671-1.67248,1.09555-1.71694-2.34818-2.53482-3.38259-5.90264-14.449-5.48479-30.3331-5.24645-45.6485,0.0662-8.56863-0.13178-17.2581-2.39596-25.5772zm0.007,0.0329zm-2.4958-62.666c0.52105,0.89337,0.37259,1.82583,0.008,3.85362-2.59897,19.5352-0.36107,39.3608,3.45403,58.5818-1.87455,0.6877-1.10342-2.60188-1.73806-3.75129-3.53728-19.153-5.37153-38.9316-2.20163-58.2697,0.15884-0.13707,0.31887-0.2783,0.47745-0.41442zm-0.47736,0.41473zm0.49026,0.0823zm-0.49026-0.0823z'/%3E %3Cpath d='m422.15,454.38c-0.0809,8.6802-3.3708,66.485-4.1026,74.644-0.72951,8.1244-4.5037,13.556-8.4445,16.614-3.379-4.9592-5.2849-11.567-5.5499-19.342-0.13605-3.9641,2.2519-58.69,2.8958-69.933,6.9972-16.946,11.824-17.441,15.201-1.9832z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m418.54,529.07c-1.72461,0.30331-0.60256-1.78409-0.7795-2.79954,1.51005-23.2276,2.86479-46.4682,3.83949-69.7248-0.42383-1.12436,0.58065-3.35908,1.03331-1.52764-0.79659,21.4402-2.12636,42.8577-3.41101,64.2733-0.2119,3.26056-0.41166,6.52235-0.68229,9.77868zm-9.35,16.85c1.21509-0.68421-0.36502-0.7381,1.33484-1.71726,4.24395-3.89206,6.55024-9.5486,7.02531-15.2225,1.72876-0.30613,0.60131,1.76086,0.6275,2.75637-0.97552,5.52685-3.79679,10.8292-8.27325,14.2962-0.23813-0.0376-0.47626-0.0752-0.7144-0.11279zm0.71426,0.11279zm-6.3498-19.718c1.61058-0.5757,0.8439,1.40467,1.12603,2.31063,0.47319,5.87365,1.99135,11.8079,5.33047,16.7332-1.15605,1.34758-1.59229-1.0221-2.24363-1.78056-2.84636-5.27882-4.00374-11.3198-4.21287-17.2633zm2.9333-70.14c1.63948,0.0328,0.64813,1.55613,0.81516,2.81033-1.05006,22.0661-2.10061,44.1352-2.75386,66.217,0.39111,1.8536-1.70277,1.101-0.98745-0.43796,0.71164-22.8184,1.75818-45.6262,2.88887-68.4273l0.0375-0.16215-0.00022,0.0001zm-0.0375,0.16214zm16.195-1.9503c-1.62102,0.57626-1.06395-1.45097-1.60993-2.51733-0.88232-2.7906-1.49978-6.1236-3.99749-7.95182-2.16445-0.81919-3.71636,1.61886-4.82862,3.09566-1.97519,2.97645-3.42279,6.2598-4.804,9.54253-1.79564-0.26178,0.0735-2.03861,0.2452-3.08518,1.76437-3.62849,3.36988-7.67881,6.69854-10.1652,1.90387-1.44912,4.33641,0.0201,5.22123,1.9171,1.60904,2.80991,2.37687,6.03053,3.07507,9.16422zm-0.0117-0.11162zm-0.48555,0.10692zm0.48555-0.10692z'/%3E %3Cpath d='m384.99,407.23c-0.5571,18.646-0.87495,59.108-0.75883,62.547,0.26506,7.7755,3.3309,17.672,6.7087,22.631,3.9408-3.0583,7.7162-8.4898,8.4457-16.615,0.59933-6.6793,0.81044-39.483,0.9113-55.923-4.2176-2.7164-8.5665-6.1095-12.081-9.7211,0.00099,0-3.0963-2.754-3.2253-2.9184z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m384.72,469.76c-1.48975,0.52089-0.89658-1.15349-1.01508-2.05419,0.0574-20.1655,0.26249-40.3325,0.78135-60.4918,1.53759-0.42444,0.82376,1.27089,0.93132,2.19553-0.45506,20.0321-0.71212,40.0705-0.70221,60.1078l0.003,0.17785,0.001,0.0649v-0.0001zm5.9088,22.254c1.29664,1.25687-0.57324,0.70369-0.75063-0.33603-3.53445-6.27545-5.44449-13.4101-6.07893-20.5597-0.71021-1.16298,1.03408-2.11083,0.95302-0.64735,0.52224,7.05722,2.38273,14.0898,5.76213,20.3256,0.099,0.5449,1.6207,1.74384,0.11441,1.21746zm0.60753,0.78719zm7.647-17.054c1.52428-0.33232,0.77449,1.23311,0.73443,2.13358-0.88163,5.75328-3.73253,11.3215-8.38136,14.9201-1.2766-0.88515,0.38237-1.40236,0.94719-2.13796,4.04679-3.88512,6.23119-9.38701,6.69974-14.9158zm1.1377-55.46c0.80713-1.77856,0.84932,0.51215,0.75577,1.35163-0.15877,17.334-0.12873,34.6753-0.76171,52.0003-0.21775,0.82469,0.41826,2.70521-1.02706,2.11787-0.1464-1.13858,0.13454-2.68706,0.11561-3.98715,0.53297-17.2957,0.55051-34.6023,0.68879-51.9044,0.0762,0.14053,0.15268,0.28144,0.2286,0.42172zm0.53717-0.83654zm-12.35-9.801c-0.17292,1.94343,0.31849-0.77072,1.14502,0.94347,3.40696,3.33934,7.20354,6.26692,11.2051,8.85755-0.41487,1.51781-1.46824,0.0937-2.28019-0.31899-3.72537-2.55548-7.26501-5.40212-10.4253-8.6361,0.11846-0.28197,0.23691-0.56397,0.35538-0.84593zm-0.35538,0.84594c-1.9091-0.94949,1.08709-1.38701,0.0109-0.026l-0.0109,0.026h0.00001zm-2.3738-3.251c-1.66535,0.33113-0.23535-0.80333,0.28624,0.0422,0.9153,0.83063,1.837,1.65424,2.75962,2.47669-0.52857,1.95078-0.0906-1.14204-0.68026,0.72724-1.08373-0.98462-2.20191-1.93403-3.25229-2.95393,0.2954-0.0972,0.59189-0.19589,0.88669-0.29216zm-0.99223-0.0305c-0.65842-2.06006,1.39594-0.6334,0.37986-0.12531-0.12642,0.0417-0.25364,0.0838-0.37986,0.12531z'/%3E %3Cpath d='m399.93,419.25c-0.37063,20.09-0.15364,51.736-0.0656,54.309,0.26506,7.7755,2.1721,14.383,5.5499,19.344,3.9408-3.0594,8.1032-8.6849,8.8316-16.809,0.44802-5.0016,1.8378-26.451,1.968-42.913-5.3013-1.6707-11.99-10.366-16.284-13.93z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m400.36,473.54c-1.19409,0.42497-1.04663-0.57638-1.01972-1.43338-0.1602-17.6221-0.18616-35.2471,0.0941-52.8681,1.41171-0.42667,0.91428,0.98812,0.96266,1.87646-0.23766,17.4732-0.23582,34.9516-0.037,52.425zm4.75,18.966c1.27037,1.14312-0.43159,0.82266-0.67314-0.19733-3.47169-5.58987-4.84017-12.2288-5.06922-18.7362,1.33215-0.48183,0.9822,0.83468,1.08199,1.70591,0.41505,6.07757,1.92314,12.2425,5.3746,17.3404-0.23806-0.0376-0.47628-0.0752-0.71423-0.11279zm0.60753,0.78719zm8.0328-17.248c1.43245-0.32405,0.85026,1.03779,0.76147,1.91655-0.91062,5.95456-4.02168,11.6106-8.79427,15.331-1.09483-0.7482-0.0439-1.21887,0.59028-1.79769,4.35362-3.94445,6.95217-9.62536,7.44252-15.4499zm2.314-42.394c0.23031-1.71572,0.8856-0.14636,0.63409,0.76744-0.21891,13.9205-0.89827,27.8346-1.95795,41.7158-1.38241,0.31385-0.876-0.95007-0.84685-1.82761,0.9721-13.691,1.66652-27.4076,1.82287-41.1338,0.11578,0.15925,0.23335,0.31966,0.34784,0.4781zm0.29791-0.94932zm-15.935-13.446c-1.77514,0.28386-0.0863-0.8728,0.46943,0.16942,4.61331,4.15065,8.40067,9.31817,13.7915,12.5374,0.57094,0.53137,2.18439,0.41,1.4428,1.47734-0.5395,0.3768-1.6561-0.55953-2.34356-0.84489-5.47895-3.43244-9.3369-8.77293-14.1741-12.9657,0.27131-0.12453,0.54268-0.2491,0.81395-0.37361zm-0.99457-0.0188c-0.62236-1.71397,1.61225-0.30973,0.11042-0.0506l-0.11039,0.0507-0.00003-0.00004z'/%3E %3Cpath d='M387.08,405.55,372.84,385.03c-2.8782,10.123-6.3873,82.767-2.2683,88.725,0.26506,7.7755,3.0717,14.355,6.4507,19.314,3.9408-3.0583,9.8226-8.5556,8.1231-16.78-1.6983-8.2243,0.20642-62.257,1.9317-70.731h-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m373.25,384.74c4.74533,6.84267,9.49067,13.6853,14.236,20.528-1.23793,1.40211-1.73608-1.30781-2.59732-1.99952-4.15166-5.98661-8.30333-11.9732-12.455-17.9598-0.31629-0.72206,0.4176-0.37672,0.81631-0.56865zm-0.88549,0.14804zm-1.2948,88.845c-1.41023,0.68686-1.25026-0.6789-1.70724-1.95697-1.38194-8.25519-1.11057-16.6786-1.14526-25.02,0.27662-18.2687,1.03438-36.5541,2.97102-54.7282,0.29855-2.39311,0.57868-4.79903,1.17622-7.13993,1.77733,0.0213,0.24972,1.97173,0.38831,3.03802-1.89467,13.5977-2.47527,27.3396-3.09584,41.0429-0.4057,12.953-0.90673,25.9532,0.13657,38.8879,0.22173,1.99153,0.40847,4.04624,1.27622,5.87621zm-0.088-0.2667zm5.7387,19.204c1.31526,1.7146-1.0333,0.0201-1.16792-0.97211-3.30459-5.3831-5.27264-11.6082-5.47528-17.9321,1.6411-0.5292,0.82738,1.58063,1.17799,2.5341,0.63269,5.89973,2.84132,11.5905,6.17944,16.4828-0.23802-0.0376-0.47635-0.0752-0.71423-0.11277zm0.60754,0.78719zm7.3326-17.072c1.60814-0.8107,1.07596,1.603,1.27818,2.56354,0.16364,6.02897-4.03133,11.0766-8.61081,14.509-1.36895-0.98451,0.68305-1.53544,1.25915-2.32645,4.26571-3.59862,7.41057-9.00915,6.07348-14.746zm2.4184-70.334c0.0774-2.1924,0.70238,0.76659,0.17558,1.60837-1.45117,14.2668-1.809,28.6212-2.16547,42.9497-0.0519,8.37837-0.4192,16.8015,0.47528,25.1464-0.64307,1.70542-1.37882-0.64958-1.20547-1.70405-0.75223-12.6483-0.22681-25.3324,0.14176-37.9863,0.45437-10.0433,0.69197-20.1267,2.0025-30.1035,0.0289-0.92954,0.20061-0.26562,0.57582,0.0893zm0-0.99631zm-0.00099,0zm0,0.99631z'/%3E %3Cpath d='m357.88,451.24c-0.64507,11.241-1.1013,18.85-0.96642,22.814,0.26623,7.7767,2.1721,14.383,5.5499,19.344,3.942-3.0583,8.9606-8.4746,8.4457-16.615-1.9903-31.459,1.4473-61.093,5.4526-89.577-3.3778-2.4802-9.072-5.1531-12.451-7.6333-6.7556,38.356-9.0087,62.162-6.032,71.669l0.001-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m357.41,474.03c-1.72219,0.59221-0.78856-1.6364-1.00994-2.58023,0.14338-6.75569,0.61822-13.4985,0.98412-20.2445,1.81866-0.35886,0.57861,2.01069,0.81986,3.05856-0.32961,6.58271-0.87576,13.1761-0.79404,19.7661zm4.75,18.968c1.332,1.73328-1.05676,0.007-1.15245-0.99528-3.11942-5.42882-4.37108-11.7336-4.5899-17.9371,1.663-0.54382,0.81741,1.6136,1.14806,2.5683,0.49613,5.78534,2.01967,11.6244,5.30845,16.4769-0.23793-0.0376-0.47661-0.0752-0.71416-0.11285zm0.60754,0.78719zm7.6458-16.977c1.70269-0.5888,0.84215,1.71247,0.95761,2.68455-0.44138,5.79902-4.08301,10.8563-8.60353,14.2928-1.39535-0.99177,0.71229-1.5481,1.2608-2.36626,4.09875-3.6817,6.83912-9.00247,6.38512-14.6111zm5.6555-89.207c1.23202-1.93087,0.5407,1.42081,0.42808,2.22282-4.0439,28.7575-6.97573,57.8602-5.09122,86.9204-1.81031,0.5635-0.79279-2.07508-1.1746-3.12109-1.54927-28.9422,1.56764-57.8753,5.63951-86.4934,0.0659,0.15713,0.1324,0.31414,0.19823,0.47129zm0.58642-0.80364zm-12.255-7.1446c-2.12638-0.56005,0.99663-0.35876,1.51297,0.66734,3.53049,2.24218,7.33398,4.04126,10.7421,6.47724-0.66438,1.70951-1.98801-0.5613-3.05176-0.8236-3.30979-2.03274-6.82086-3.74167-9.98563-6.0061,0.26076-0.10496,0.52155-0.20991,0.78229-0.31488zm-0.97816-0.17388zm-5.8947,71.403c1.42301,1.68365-1.04697-0.28412-0.63216-1.49683-1.58139-9.29493-0.51905-18.7791,0.32665-28.0961,1.50177-14.0139,3.77622-27.9311,6.20028-41.8108,1.90997-0.105,0.26029,2.28288,0.41292,3.40858-2.96216,17.7164-5.99229,35.4992-6.70532,53.4777-0.0721,4.91978-0.13596,9.94715,1.22312,14.7205-0.27498-0.0676-0.55135-0.13599-0.82549-0.20303zm0.70371,0.70494zm0.00099-0.00099zm-0.70372-0.70493z'/%3E %3Cpath d='m343.64,471.82,3.861,14.631c0.26624,7.7755,5.0667,14.196,8.4457,19.156,3.9408-3.0583,7.5203-8.088,6.5152-16.18-5.7786-46.464-3.7132-77.204,6.0331-115.07-22.039,15.045-32.255,46.787-24.855,97.459z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m347.02,486.58c-1.287-4.877-2.574-9.754-3.861-14.631,1.8344-0.77091,1.27593,2.56671,2.00392,3.6955,0.94028,3.59788,1.91529,7.18878,2.83411,10.791-0.32568,0.0482-0.65136,0.0963-0.97703,0.14452zm0.96173-0.25377zm7.661,18.889c1.25652,1.86148-1.17654-0.33182-1.42735-1.25243-3.60681-5.19902-7.00418-10.996-7.21068-17.4919,1.82478-0.43279,0.76603,2.32075,1.41681,3.42488,1.20795,5.76299,4.64844,10.673,7.93549,15.4323-0.23807-0.0376-0.47631-0.0751-0.71427-0.11285zm0.60754,0.78719zm5.7188-16.512c1.85769-0.57723,0.89893,2.38935,1.14009,3.53411-0.13236,5.09343-2.79131,9.94798-6.85875,12.978-1.42058-1.25292,1.50699-2.0088,1.99666-3.23329,3.23254-3.56331,4.37813-8.58695,3.722-13.2788zm6.806-114.72c-0.54335-2.06344,0.48386,1.56134-0.53289,2.61743-5.99313,23.4948-9.08311,47.7688-8.41463,72.0295,0.29454,13.3615,1.4882,26.6878,3.12666,39.9469-1.92021,0.51603-0.90803-2.71705-1.47357-3.93299-3.31167-27.6444-4.07621-55.802,0.5948-83.3409,1.53097-9.37392,3.57643-18.6579,5.93836-27.8557,0.25377,0.17857,0.50748,0.35727,0.76127,0.53577zm-0.56061-0.82242zm-24.094,97.744c-1.87847,0.87576-0.91535-2.50374-1.48933-3.57837-2.59649-20.4977-3.22566-41.8008,2.87305-61.7674,3.92434-12.8003,11.4836-24.8229,22.7101-32.3978,1.35763,1.42122-1.80203,1.99252-2.51812,3.1143-12.5025,9.86505-19.225,25.2741-21.946,40.6361-3.22233,17.814-2.14545,36.2559,0.37029,53.9932zm-0.96174,0.25379zm0.48088-0.12689zm-0.48088,0.12689z'/%3E %3Cpath d='m344.77,486.22-20.223-6.7169c-2.5768,20.221,1.384,45.621,6.8295,79.114,4.6762,28.76,2.2178,51.522-1.357,66.121,21.575-2.9549,30.695-30.772,19.88-83.093-2.8312-13.695-5.6766-31.201-5.1289-55.426z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m324.71,479.03c6.741,2.23897,13.482,4.47793,20.223,6.7169-0.43447,2.01589-3.13982-0.48826-4.57928-0.47273-5.31856-1.76652-10.6371-3.53303-15.9557-5.29955-0.60268-0.66233-0.24906-0.54457,0.31197-0.94462zm-0.64859,0.40887zm7.8123,79.098c-1.96,0.56489-1.02565-2.88922-1.67773-4.13965-3.28668-21.2478-7.19169-42.5808-6.90576-64.1614,0.078-3.60875,0.32265-7.21485,0.7712-10.7969,2.01706-0.0282,0.20098,2.92936,0.55707,4.25722-1.4386,20.2282,1.95115,40.3758,4.92437,60.3167,0.75956,4.84412,1.54511,9.68427,2.33085,14.5241zm-1.9141,65.708c-0.26727,2.37297-0.26261-2.11025,0.36154-3.03264,4.29729-20.5445,3.88975-41.8606,0.57227-62.5151,1.93765-0.59279,1.01474,2.78542,1.61127,4.00867,2.88294,20.6066,2.8552,41.8374-1.99599,62.1508-0.18301-0.20382-0.36618-0.40895-0.54909-0.6118zm0.13371,0.98692zm19.326-83.485c1.96409-0.6315,1.12258,2.96846,1.84538,4.2091,3.17457,17.4663,5.41916,35.5796,1.96528,53.1799-1.96997,9.49145-6.58948,19.5002-15.7635,23.8977-2.32011,1.12692-4.82657,1.82144-7.37322,2.19811-0.54316-1.94591,2.81397-1.00428,3.96915-1.91303,9.15173-2.7497,14.8116-11.5847,17.1804-20.3887,4.19957-15.3596,2.86903-31.5666,0.69365-47.1418-0.71705-4.70187-1.56487-9.3817-2.51717-14.0413zm-4.7981-55.055c0.92323-2.26426,0.5734,2.348,0.59714,3.2846-0.20867,17.3141,1.57067,34.6347,5.17404,51.568-1.87732,0.69596-1.11619-2.61462-1.76866-3.75852-3.36792-16.9618-4.77261-34.2946-4.34275-51.5782l0.17234,0.24527,0.16779,0.23879,0.0001,0.00003zm0.31197-0.94462z'/%3E %3Cpath fill='%2321231e' d='m343.56,584.05c0.43123,0.005,1.62794-0.11881,0.94951,0.4901-0.38016,0.31128-0.97813-0.006-0.94951-0.4901zm-4.302-40.199c1.48585-0.84811,1.31913,0.81891,1.57689,1.82825,2.49011,12.6365,4.3117,25.5022,3.90582,38.4121-1.67317,0.47895-1.07006-1.16462-1.13013-2.21607,0.13562-12.7915-1.79675-25.5264-4.35258-38.0243zm-5.4127-50.215c1.63623-0.54273,1.12916,1.08652,1.20609,2.13411,0.21569,16.0736,2.09295,32.1085,5.36643,47.8418-1.51011,0.85935-1.31962-0.87115-1.58885-1.88835-3.17123-15.8248-4.89985-31.9521-4.98367-48.0876zm1.1811-0.008c-0.43405,0.0143-1.62176,0.18679-0.96862-0.4515,0.37229-0.32526,0.979-0.04,0.96862,0.4515z'/%3E %3Cpath d='m343.96,367.25,13.271,2.2323c-0.64976,2.848-4.0205,20.313-4.6304,23.295-4.9635,24.275-8.2358,52.876-4.4838,84.249,1.3922,11.641,3.861,21.161,7.4804,28.518-14.559-1.6531-23.89-15.872-22.683-40.67-2.5298-28.961-1.4191-51.991,3.2699-69.313,1.3734-5.0744,5.7904-24.209,7.776-28.31z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m357.15,369.98c-4.42367-0.7441-8.84733-1.4882-13.271-2.2323,0.08-2.02073,2.99714-0.0612,4.36466-0.27566,3.02351,0.50858,6.04702,1.01716,9.07053,1.52574,0.4469,0.57749,0.53108,0.60955-0.16419,0.98222zm0.16419-0.98222zm-4.2258,23.886c-1.88321,0.0192-0.21892-2.31964-0.32202-3.48733,1.32255-6.67341,2.58093-13.3601,3.98126-20.0178,1.86715,0.009,0.20222,2.27974,0.29804,3.43885-1.3428,6.68404-2.62469,13.3803-3.95728,20.0662zm-4.4768,84.09c-1.92518,0.51031-0.90768-2.71769-1.43164-3.9511-2.76466-26.8258-0.50165-53.9836,4.93477-80.3383,1.99512,0.10356,0.0106,2.83869,0.18964,4.15738-5.12619,26.3368-6.91987,53.4411-3.69277,80.132zm6.9304,29.072c0.29848-0.87932-1.26355-0.68482-1.61069-2.9432-3.49165-8.26152-5.2206-17.1449-6.30722-26.0111,1.92327-0.51118,0.91334,2.7202,1.52813,3.93187,1.25974,8.34007,3.18366,16.6863,6.89176,24.3082-0.16729,0.23796-0.33481,0.47665-0.50198,0.71422zm0.50198-0.71435zm-23.624-40.407c1.99626-0.56431,0.46705,2.54062,0.89521,3.68146-0.0124,10.4198,1.68763,21.768,8.95256,29.7569,3.45926,3.76298,8.30996,6.15558,13.3862,6.69414,0.0505,2.02623-2.88354,0.18586-4.14959,0.17742-8.95488-2.50847-14.8323-10.9129-17.1062-19.5517-1.90632-6.71921-2.29916-13.8636-1.97822-20.7583zm0.98989-0.0869zm2.2953-69.4c1.95662,0.22625-0.11151,2.77202,0.00015,4.11266-4.72508,21.4106-4.07356,43.5687-2.29555,65.2876-1.95198,0.44921-0.81385-2.78363-1.3252-4.02984-1.5462-21.7712-1.91586-44.0889,3.6206-65.3704zm8.3378-28.671c0.29395,0.99468,0.0426,1.583-0.63828,3.37653-2.62777,8.41341-4.51181,17.033-6.74012,25.5555-1.92186-0.16319,0.0499-2.5841-0.0471-3.82483,2.19417-8.29981,3.84391-16.793,6.89652-24.8334,0.1759-0.0916,0.35319-0.18219,0.52896-0.27385zm-0.52896,0.27375zm0.44686,0.21737zm-0.44686-0.21737z'/%3E %3Cpath d='m335.92,370.39,6.5152,7.4407c-1.8496,1.3218,1.2878,7.0259-0.40112,18.103-1.0896,6.2892-4.831,13.704-5.605,21.729-2.5662,26.596-2.5756,59.898,5.4162,81.186-14.559-1.6531-19.556-14.853-20.028-39.678-0.38938-20.523-0.45624-44.72,4.6926-72.661,1.045-6.5301,4.1824-11.737,9.4098-16.12z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m342.06,378.16c-2.17173-2.4802-4.34347-4.9604-6.5152-7.4406,1.26424-1.50311,2.22486,1.63777,3.34658,2.31444,1.22226,1.59996,3.0032,3.02571,3.88445,4.73201,0.0537,0.7229-0.22935,0.40139-0.71583,0.39415zm0.74593-0.6556zm-0.28501,18.515c-1.95798,0.11409-0.26083-2.43951-0.58879-3.62704,0.50281-4.48473-0.44055-8.94113-0.57248-13.4024-0.2257-1.33576,1.6214-1.99502,1.12718-0.46057-0.43333,3.16268,0.67112,6.36176,0.54449,9.56011,0.0711,2.65176-0.11385,5.30785-0.5104,7.92989zm0.002-0.009zm-5.6015,21.702c-1.95682,0.12872-0.32586-2.63437-0.42339-3.86079,1.17329-6.13907,3.86635-11.8661,5.04442-18.0007,1.84504-0.0915,0.30233,2.15523,0.285,3.24274-1.71064,6.1831-4.29935,12.1747-4.90603,18.6187zm4.865,81.632c0.23672-0.91311-1.0969-0.66652-1.30245-2.86455-5.25253-16.459-6.11731-33.9298-6.0602-51.0904,0.0958-9.27407,0.62513-18.5418,1.50754-27.7736,1.94733-0.12684,0.36058,2.65518,0.64464,3.91595-1.64879,20.7949-2.0119,41.9069,1.75349,62.5032,0.95143,4.97084,2.21566,9.89143,3.97783,14.6398-0.17362,0.22302-0.34721,0.44695-0.52085,0.66957zm0.52074-0.66969zm-20.989-39.493c1.92675-0.34815,0.65767,2.62574,1.11176,3.84661,0.51186,9.18038,1.17222,18.8701,5.94046,26.9769,2.80026,4.80724,8.02703,7.87553,13.529,8.34999,0.14386,1.8901-2.40239,0.37098-3.55005,0.33291-6.85443-1.61993-11.597-7.70361-13.6182-14.1757-2.71123-8.13772-3.18369-16.8206-3.41291-25.3307zm4.6996-72.749c1.96403-0.1178,0.21185,2.38482,0.38002,3.55125-3.99152,22.8195-4.63305,46.0658-4.08515,69.1786-1.91435,0.36569-0.65313-2.56459-1.06065-3.75941-0.46355-23.0649,0.51447-46.2939,4.76578-68.9704zm0.98051,0.15744zm9.2925-16.526c-0.64823,0.79847-0.24654,1.17795-1.8883,2.36621-3.92598,3.74965-6.60742,8.77998-7.40419,14.1599-1.82778,0.12394-0.36212-2.10623-0.32606-3.17694,1.41619-5.2933,4.72515-9.94133,8.92656-13.4033,0.23064,0.0181,0.46148,0.0359,0.69199,0.0541zm-0.69198-0.054z'/%3E %3Cpath d='m372.29,389.97-13.435-1.5673c-2.4688,12.704-4.3571,21.686-4.8146,26.212-0.8984,8.8764,1.7921,17.014,4.8673,23.075,4.9541-2.9866,7.2552-9.5108,9.3394-18.659,2.0912-9.1866,2.6119-19.201,4.044-29.061h-0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m358.91,387.91c4.47833,0.52243,8.95667,1.04487,13.435,1.5673,0.0903,0.86246-0.2522,1.17814-1.0834,0.87629-4.15551-0.48477-8.31103-0.96955-12.4665-1.45432-0.44106-0.53525-0.5489-0.61345,0.11494-0.98927zm-0.54537,0.39946zm-3.8329,26.358c-0.78772,0.0741-1.19567-0.16882-0.88897-0.97423,1.0176-7.23257,2.60891-14.3685,3.9712-21.5407,0.25134-1.28073,0.50095-2.56179,0.75071-3.84283,0.86696-0.0244,1.15292,0.34269,0.78931,1.14735-1.49125,7.87942-3.22819,15.7168-4.43184,23.6477-0.0732,0.51966-0.13508,1.04109-0.19041,1.56273zm4.1179,22.598c0.66366,0.67489,0.39211,1.1689-0.28442,0.45821-3.58421-7.11012-5.63845-15.1696-4.82139-23.1573,0.82342-0.087,1.18743,0.19833,0.90799,1.02572-0.56196,7.57636,1.48045,15.1541,4.8967,21.8743-0.23287-0.067-0.46647-0.13402-0.69888-0.20091zm0.51136,0.85298zm8.5993-19.196c0.77534,0.0333,1.18726,0.2943,0.77173,1.07386-1.24553,5.07681-2.52515,10.3434-5.62498,14.6545-1.02107,1.37274-2.27703,2.58191-3.74608,3.46714-0.58299-0.62039-0.52432-1.0654,0.27882-1.38037,3.60211-2.67742,5.28987-7.0583,6.59522-11.1939,0.67026-2.18095,1.21655-4.39778,1.72529-6.62124zm4.5284-28.453c-0.22392-0.9538,0.27863-1.17808,0.46115-0.21194-1.39786,9.61954-1.8818,19.3815-4.02075,28.8854-0.77799-0.0317-1.18569-0.29782-0.77877-1.07974,1.98265-9.28195,2.47122-18.789,3.84695-28.1636,0.1638,0.18994,0.32763,0.37992,0.49142,0.56983zm0-0.99632c0.97134-0.25122,0.4479,1.10661-0.00003,0h0.00003zm-0.00099,0c0.0459,0.61947-0.072,1.48655-0.0199,0.34339,0.007-0.11373,0.0134-0.23129,0.0199-0.34339zm0,0.99632z'/%3E %3Cpath d='m407.15,418.58-11.924,0.12454c-0.40815,10.961-0.70371,18.379-0.50902,22.241,0.38235,7.5758,2.2718,13.994,5.5065,18.795,3.6218-3.0195,7.0488-8.3488,7.5895-16.274,0.54303-7.9576-0.58876-16.429-0.66265-24.887z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m395.23,418.2c3.97467-0.0415,7.94933-0.083,11.924-0.12455,0.0131,0.54896,0.18621,1.25485-0.61739,1.00286-3.76587,0.0393-7.53174,0.0787-11.2976,0.118-0.53911-0.49003-0.61346-0.51779-0.009-0.99631zm-0.49142,0.47935c-0.17773-0.77125,0.92706-0.49913,0.043-0.0423l-0.043,0.042-0.00001,0.0003zm0.48321,22.235c-0.49996,0.009-1.22701,0.26355-1.01498-0.50662-0.1343-6.27878,0.22641-12.5548,0.42379-18.8288,0.0359-0.96652,0.0728-1.933,0.10806-2.89955,0.54858,0.0119,1.25906-0.12638,0.96916,0.6636-0.22131,6.88903-0.61472,13.7785-0.51985,20.6731,0.008,0.29931,0.0215,0.60043,0.0338,0.89826zm4.6926,18.437c0.35881,0.42363,0.97485,0.99123,0.0156,0.67716-0.43836-0.31033-0.65933-0.95709-0.98767-1.41301-3.10422-5.33833-4.3954-11.5376-4.71281-17.6514,0.54754-0.036,1.24257-0.23618,1.02787,0.57601,0.39834,6.26108,1.86186,12.6384,5.38652,17.9157-0.24314-0.0348-0.48646-0.0698-0.7295-0.10452zm0.63568,0.76604c-0.30118,0.79957-1.14352-0.387-0.28659-0.0411,0.0955,0.0137,0.19106,0.0274,0.28659,0.0411zm6.7756-16.691c0.54824,0.0291,1.26602-0.0878,0.94226,0.69263-0.49428,6.02097-3.00849,12.0697-7.71776,15.9981-0.34919-0.41496-0.93309-0.84246-0.17315-1.16784,4.38079-3.91265,6.58343-9.75566,6.94865-15.5229zm-0.16185-24.355c-0.0108-0.55475-0.13605-1.37926,0.43772-0.55717,0.13553,1.0846,0.0554,2.26886,0.13215,3.3913,0.25151,7.19262,1.05653,14.3876,0.5834,21.5885-0.54809-0.0291-1.26286,0.0881-0.9536-0.69333,0.43855-8.08368-0.6445-16.1435-0.70123-24.2228,0.16697,0.16436,0.33582,0.32963,0.50156,0.49341zm-0.009-0.99632c0.78401-0.23538,0.5439,0.94178,0.0556,0.054l-0.0553-0.0543-0.00031,0.00029z'/%3E %3Cpath d='m419.99,424.24-11.913,0.54164c-0.027,10.969-0.0645,18.392,0.26389,22.246,0.64507,7.557,2.7574,13.906,6.1563,18.59,3.5162-3.144,6.7544-8.5897,7.0195-16.528,0.26623-7.9717-1.16-16.398-1.5282-24.849h0.00099z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m408.06,424.28c3.971-0.18054,7.942-0.36109,11.913-0.54163,0.0344,0.55041,0.23019,1.24822-0.58486,1.02259-3.76118,0.171-7.52236,0.34201-11.2835,0.51301-0.52616-0.39141-0.59479-0.57759-0.0446-0.99397zm-0.47501,0.4958c-0.20325-0.76784,0.91097-0.52755,0.0389-0.0409l-0.0391,0.0408,0.00019,0.00004zm1.2561,22.205c-0.49991,0.0268-1.21772,0.30807-1.03239-0.47092-0.35557-6.42039-0.20913-12.8552-0.23119-19.2823,0.002-0.81709,0.003-1.63417,0.005-2.45126,0.55138-0.009,1.25736-0.17137,0.99333,0.6321,0.0201,6.83181-0.12717,13.6695,0.1889,20.4964,0.0219,0.35892,0.0464,0.71768,0.0765,1.07601zm5.3306,18.262c0.37652,0.41272,1.00896,0.95706,0.035,0.67527-0.4502-0.30527-0.69641-0.94834-1.04598-1.39782-3.27682-5.22336-4.78115-11.3636-5.30955-17.4543,0.5483-0.0569,1.23548-0.27984,1.04787,0.54283,0.61577,6.24189,2.29975,12.563,6.00552,17.7128-0.24416-0.0263-0.4893-0.0525-0.73285-0.0787zm0.6615,0.74253c-0.27435,0.81283-1.15875-0.34955-0.28554-0.0307,0.0952,0.0102,0.19041,0.0204,0.28554,0.0307zm6.1926-16.916c0.55129,0.008,1.26253-0.13166,0.96368,0.66236-0.28305,6.03357-2.58665,12.1657-7.1562,16.2539-0.36394-0.40217-0.96312-0.80968-0.21268-1.16102,4.24172-4.06136,6.23987-9.98007,6.4052-15.7552zm-1.0321-25.331c-0.007,0.5584-0.12044,1.38469,0.43526,0.5407,0.15651,0.20432,0.0726,1.05805,0.14175,1.51302,0.43877,7.77172,1.68591,15.5086,1.4474,23.3101-0.55109-0.008-1.25907,0.13179-0.97629-0.6628,0.15571-8.09334-1.20756-16.11-1.54415-24.1817,0.1653-0.17309,0.33098-0.34633,0.49603-0.51931zm-0.49612,0.51931c-0.28021-0.80038,0.95565-0.57673,0.0609-0.0637l-0.0609,0.0637h-0.00008zm0.49729,0.47701c-0.00097-0.32293-0.006-1.52192,0.0101-0.54635-0.0154,0.16502,0.0446,0.42036-0.0101,0.54635z'/%3E %3Cpath d='m395,412.42-11.895-0.84475c-1.2937,10.893-2.1897,18.263-2.3082,22.127-0.23339,7.5816,1.1306,14.133,3.9666,19.18,3.8552-2.714,7.7021-7.7485,8.882-15.603,1.1857-7.8883,0.74359-16.423,1.3546-24.86z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m383.14,411.08c3.965,0.28158,7.93,0.56317,11.895,0.84475-0.0287,0.5529,0.0845,1.26949-0.7018,0.94913-3.75453-0.26664-7.50907-0.53328-11.2636-0.79992-0.47754-0.45038-0.52486-0.64309,0.0704-0.99396zm-0.52896,0.43823c-0.11159-0.78896,0.96648-0.41794,0.0415-0.0344l-0.0415,0.0344,0.00001-0.00003zm-1.3183,22.201c-0.58106,0.0167-1.22605,0.0857-0.96654-0.67979,0.40011-6.44802,1.29024-12.8529,2.01667-19.2693,0.0894-0.75058,0.17947-1.50106,0.26783-2.25176,0.63452,0.0158,1.23429,0.0589,0.90249,0.83589-0.77174,6.78725-1.71204,13.5612-2.17649,20.379-0.0181,0.32845-0.0345,0.65761-0.044,0.98603zm3.1843,18.757c0.3282,0.45535,0.8936,1.06989-0.0449,0.67517-0.4091-0.35894-0.58412-1.02149-0.87577-1.51052-2.65183-5.56705-3.43601-11.8413-3.25571-17.9525,0.61403-0.03,1.23412-0.0656,0.97583,0.73074-0.10203,6.24918,0.84481,12.697,3.91925,18.2204-0.23937-0.0544-0.48025-0.10907-0.71869-0.16326zm0.57236,0.81538c-0.36703,0.77744-1.11146-0.48541-0.27807-0.0632,0.0927,0.0211,0.18538,0.0421,0.27807,0.0632zm8.1044-16.084c0.6345,0.0354,1.23228,0.0975,0.86633,0.86201-0.99351,5.92598-3.9859,11.7093-8.9707,15.2224-0.31561-0.44273-0.8652-0.91629-0.0768-1.17778,4.68123-3.54393,7.35158-9.18927,8.18115-14.9066zm1.8109-24.289c0.0323-0.56004-0.0246-1.38897,0.48366-0.5145,0.0257,1.29706-0.15195,2.66917-0.17171,3.99691-0.29787,6.98689-0.11395,14.0179-1.1398,20.9544-0.63337-0.0352-1.23062-0.0973-0.88007-0.86412,1.07182-7.99175,0.65347-16.0802,1.24818-24.1061,0.15324,0.1778,0.30653,0.35562,0.45974,0.53341zm0.0704-0.99397c0.80649-0.16894,0.45973,0.98647,0.0464,0.0539l-0.0465-0.0539,0.00004,0.00005z'/%3E %3Cpath d='m383.86,399.58-13.046-5.4186c-2.2249,8.8235-5.2309,37.867,0.11142,50.133,4.3466-2.9537,8.726-8.4934,10.188-17.225,1.4672-8.7695,1.907-18.098,2.7456-27.489z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m371,393.7c4.34867,1.8062,8.69733,3.6124,13.046,5.4186-0.14774,0.85697-0.56565,1.06129-1.28225,0.54403-4.04792-1.68129-8.09584-3.36257-12.1438-5.04386-0.432-0.577-0.211-0.678,0.38-0.919zm-0.67204,0.3372c-0.007-1.00429,1.18279-0.16392,0-0.00001v0.00001zm0.31431,49.843c0.61609,0.62128,0.5669,1.10299-0.21604,0.51007-2.16521-5.34031-2.6369-11.1729-2.90831-16.8744-0.30702-9.56175,0.36616-19.1514,1.84211-28.6003,0.26687-1.63635,0.57208-3.26766,0.96806-4.87812,0.79296,0.0452,1.17196,0.34066,0.75531,1.11732-1.57735,7.60498-2.2529,15.3722-2.56906,23.1234-0.19981,7.36173-0.12625,14.8305,1.59801,22.0292,0.33814,1.28853,0.74541,2.55895,1.26434,3.7867-0.24481-0.0713-0.48961-0.14259-0.73442-0.21388zm0.55829,0.82477c-0.67973,0.78289-1.00265-0.69375-0.005-0.001l0.005,0.001zm9.4191-17.72c0.8405-0.0381,1.17469,0.28637,0.81096,1.09209-1.23375,6.52177-4.6618,12.8398-10.2301,16.6278-0.59294-0.57478-0.60907-1.03113,0.18955-1.35871,5.18282-3.88722,8.20643-10.0637,9.22959-16.3612zm3.0459-26.948c0.12132-0.86649,0.70906-1.09636,0.65637-0.0903-0.81216,9.07534-1.22937,18.2019-2.72183,27.2024-0.83754,0.0371-1.1724-0.28301-0.82897-1.09184,1.37819-8.7845,1.79271-17.6774,2.58943-26.5242,0.10168,0.16799,0.20327,0.33613,0.305,0.50403zm0.38-0.91877zm-0.19,0.45938zm0.19-0.45938z'/%3E %3Cpath id='path1214' d='m387.75,701.16c7.9625,6.3832,15.249-8.2173,8.1865-27.512-5.225-14.277-30.765-8.7354-16.54,10.47,0.67439,0.91055,1.6244,0.48759,1.4895-0.55102-0.80809-3.9383,1.703-6.227,5.5769-5.5009,10.577,1.9809,10.91,22.069-0.59347,17.5-2.0994-0.13629-0.22049,3.9101,1.8789,5.5937h0.00099z' stroke='%2321231E' stroke-width='0.99388075' fill='%23EDB92E'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m400.05,639.16-0.006,0.12923c-1.038,3.3496-4.906,7.5382-7.9179,10.679-4.6668,4.8688-3.5631,12.245-0.33308,16.164,3.5232,4.2755,5.096,9.0914,5.8032,12.833,0.52778,2.3063,1.4731,7.4712,0.78464,15.508-0.33896,3.9559-2.7292,5.9932-4.9682,7.7661-1.1377,0.90233,0.48321,3.0524,4.2445,5.878,0.41167,0.309,1.5435,1.0844,2.083,3.0442,0.20759,0.47114,1.9528,0.47114,2.1616,0,0.53951-1.9597,1.6713-2.7352,2.0842-3.0442,3.7602-2.8256,5.381-4.9757,4.2434-5.878-2.239-1.7729-4.6292-3.8102-4.9682-7.7661-0.68847-8.0352,0.25802-13.201,0.78581-15.508,0.70722-3.742,2.28-8.5568,5.8032-12.833,3.23-3.9206,4.3337-11.297-0.3331-16.164-3.0119-3.1405-6.8799-7.329-7.9179-10.679l-0.006-0.12923c-0.0516-0.6509-0.41167-0.97752-0.77174-0.97752-0.36005,0-0.72012,0.32662-0.77173,0.97752z' fill='%23EDB92E'/%3E %3Cpath d='m395.06,685.47,11.51,0c1.9809,0,3.6018,1.592,3.6018,3.5376v0.00099c0,1.9456-1.6209,3.5376-3.6018,3.5376h-11.51c-1.9809,0-3.6018-1.592-3.6018-3.5376v-0.00099c0-1.9456,1.6209-3.5376,3.6018-3.5376z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m406.57,685.97h-11.51v-0.9963h11.51v0.9963zm4.0991,3.0395h-0.99457c0.0277-1.51992-1.25651-2.88558-2.7578-3.02022-0.35387,0.0683-0.39264-0.13955-0.34709-0.44542,0.0521-0.20646-0.15184-0.67649,0.20995-0.56435,1.84255,0.0636,3.53491,1.51513,3.82718,3.34384,0.0412,0.22637,0.059,0.45643,0.0623,0.68615zm-0.99457,0.00099c0.32922-0.002,0.66536-0.002,0.99457,0h-0.99457zm-3.1045,4.0358v-0.99631c1.53615,0.0334,2.98088-1.22992,3.09244-2.77343-0.0963-0.3766,0.27827-0.24927,0.52363-0.26653,0.25584,0.00001,0.61285-0.0878,0.47064,0.2917-0.10618,1.86025-1.67035,3.47611-3.5096,3.70223-0.19126,0.0265-0.38459,0.039-0.57711,0.0423zm-11.51-0.99631h11.51v0.99631h-11.51v-0.99631zm-4.0991-3.0395h0.99458c-0.0279,1.52,1.2564,2.88573,2.75772,3.02051,0.35387-0.0683,0.39264,0.13955,0.34709,0.44542-0.0521,0.20646,0.15184,0.67649-0.20995,0.56434-1.84267-0.0634-3.53486-1.51514-3.82724-3.34384-0.0411-0.22648-0.0592-0.4564-0.0622-0.68643zm0.99458-0.00099c-0.32922,0.002-0.66536,0.002-0.99458,0h0.99458zm3.1045-4.0358v0.9963c-1.53605-0.0337-2.98089,1.22961-3.09241,2.77303,0.0963,0.3766-0.27827,0.24927-0.52363,0.26653-0.25584-0.00001-0.61285,0.0878-0.47064-0.2917,0.1064-1.87487,1.69537-3.50055,3.55179-3.70738,0.17734-0.0238,0.35606-0.0341,0.53489-0.0368z'/%3E %3Cpath d='m417.13,579.19,0.38352-10.914c-4.3806-2.2276-15.174,0.0599-19.732,10.136-5.6825,12.56-11.058,19.246-17.873,25.141,9.8777,1.8446,18.248-0.11044,23.641-7.3561,7.2764-9.7752,11.167-15.697,13.58-17.007z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m418.01,568.3c-0.12784,3.638-0.25568,7.276-0.38352,10.914-0.85651,0.16264-1.1901-0.16196-0.95784-1.01382,0.11638-3.3118,0.23275-6.62359,0.34913-9.93538,0.48555-0.22024,0.73793-0.72982,0.99223,0.0352zm-0.27093-0.46174zm-19.504,10.786c-0.85771-0.17842-1.03836-0.60188-0.47956-1.29299,2.99556-6.01824,9.41158-10.3771,16.2118-10.3215,1.29323,0.0308,2.60389,0.25292,3.77224,0.82878-0.22124,0.76064-0.57191,1.05112-1.27138,0.55337-3.66825-1.01468-7.61163,0.088-10.8336,1.92752-3.26881,1.89645-5.85352,4.8668-7.39946,8.30479zm-18.234,24.446c-0.10448,0.9136-0.2351,1.15935-0.41636,0.1116,5.65286-4.78786,10.3048-10.6892,13.8527-17.1809,1.41237-2.53659,2.69433-5.14411,3.89252-7.78809,0.85414,0.17672,1.04057,0.60291,0.49778,1.30155-3.68976,8.06074-8.37567,15.813-14.8661,21.9375-0.88519,0.85383-1.79891,1.67762-2.72716,2.48427-0.0778-0.28865-0.15561-0.5773-0.23341-0.86595zm-0.18296,0.97751c-0.96744-0.0394-1.15507-0.29001-0.27513-0.82982,0.13712,0.0751,0.18094,0.60096,0.27513,0.82982zm23.334-8.1421c0.7877,0.35314,0.89926,0.80653,0.20099,1.35695-3.25206,4.10818-8.22457,6.66814-13.4051,7.23646-3.37229,0.4227-6.79777,0.16475-10.1297-0.45158-0.0144-0.81919,0.28858-1.18034,1.0931-0.81774,5.73953,0.95924,12.018,0.66309,17.0682-2.5066,2.0149-1.25388,3.75755-2.91667,5.17255-4.81749zm13.483-16.727c0.76239-0.13505,1.31994,0.15786,0.44151,0.63474-2.29717,1.79822-3.90832,4.29292-5.68731,6.57043-2.49148,3.3636-4.93734,6.7608-7.43973,10.1164-0.79622-0.35383-0.88945-0.81079-0.21361-1.38057,3.52704-4.66464,6.78442-9.54018,10.5503-14.0197,0.77975-0.86906,1.58477-1.75425,2.60805-2.34079-0.0864,0.13983-0.17287,0.27964-0.25921,0.41949zm0.99224,0.0352z'/%3E %3Cpath d='m425.16,580.63-11.789-4.9651c-4.8333,9.8527-8.1232,16.512-9.493,20.127-2.687,7.0905-3.4212,13.768-2.178,19.535,4.7864-1.2184,10.314-4.6326,14.051-11.652,3.752-7.0471,6.0625-15.277,9.4098-23.046z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m413.56,575.2c3.92967,1.65503,7.85933,3.31007,11.789,4.9651-0.18283,0.65106-0.42077,1.16706-1.09322,0.61801-3.6935-1.55557-7.38699-3.11113-11.0805-4.6667-0.30293-0.58749-0.30668-0.77884,0.3847-0.91641zm-0.63803,0.2385zm-8.5829,20.523c-0.65139-0.16016-1.1851-0.37811-0.6509-1.06334,2.60013-6.17747,5.68348-12.136,8.59993-18.167,0.31566-0.33569,0.36532-1.45066,0.89247-1.16541,0.86427,0.13505,0.49247,0.69146,0.18475,1.22602-2.94824,6.09459-6.06299,12.1164-8.70471,18.3534-0.11064,0.27073-0.21777,0.54288-0.32154,0.81632zm-2.7644,18.876c0.20009,0.63589,0.39626,1.2664-0.36358,0.58745-1.41298-6.63433-0.17046-13.5516,2.1994-19.8159,0.59064,0.17216,1.20602,0.33307,0.68494,1.01042-2.13791,5.90256-3.2358,12.3815-1.91306,18.5964-0.20258-0.12608-0.40508-0.25239-0.6077-0.37833zm0.24395,0.96578c-0.76089,0.42729-0.7316-0.83736-0.0365-0.0227l0.0365,0.0227zm13.49-12.368c0.61579,0.24343,1.13268,0.51628,0.51488,1.12674-2.97573,5.36071-7.99242,9.72827-14.005,11.2414-0.23097-0.61638-0.37864-1.17301,0.47016-1.16441,5.69398-1.66802,10.3036-6.0119,13.02-11.2038zm9.6561-22.354c0.22011-0.6172,0.44037-1.25401,0.64859-0.26082-3.30104,7.62909-5.5349,15.7098-9.42736,23.0821-0.60517-0.24327-1.13588-0.50951-0.53247-1.12555,3.66152-7.1776,5.85368-14.9729,9.04735-22.3513,0.088,0.21853,0.17593,0.43706,0.26389,0.65559zm0.3847-0.91641c0.84675,0.1252,0.0898,1.08836,0.0127,0.0316l-0.0127-0.0316z'/%3E %3Cpath d='m428.55,580.62-12.643-1.9315c-2.2847,10.735-3.8528,17.998-4.3008,21.839-0.8773,7.5323,0.0375,14.187,2.6495,19.478,4.3442-2.3522,8.8726-7.0165,10.786-14.736,1.9211-7.752,2.1557-16.298,3.508-24.649h0.001z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m415.98,578.2c4.21433,0.64383,8.42867,1.28767,12.643,1.9315-0.0302,0.65001-0.10849,1.23457-0.88263,0.87265-3.97016-0.60653-7.94033-1.21306-11.9105-1.81959-0.42368-0.5606-0.53524-0.60279,0.15012-0.98456zm-0.56062,0.3889c-0.028-0.80167,0.99371-0.31802,0.0278-0.0193l-0.0279,0.0193h0.00004zm-3.3215,22c-0.58909-0.0296-1.23109-0.0211-0.90451-0.76662,0.9691-6.42675,2.46105-12.7596,3.77656-19.121,0.14959-0.70419,0.29944-1.40832,0.44955-2.1124,0.64731,0.0672,1.22245,0.18113,0.81671,0.93151-1.37958,6.65787-2.93204,13.2862-3.99864,20.0042-0.0497,0.35435-0.098,0.70913-0.13967,1.06436zm1.92,18.982c0.34945,0.56801,0.68018,1.12047-0.20993,0.65912-2.98802-6.09014-3.46779-13.1024-2.69723-19.756,0.61512,0.0226,1.24217,0.0357,0.91014,0.81186-0.63282,6.24583-0.12115,12.7982,2.67849,18.5024-0.22716-0.0725-0.45431-0.14494-0.68147-0.21736zm0.47149,0.87648c-0.61128,0.5996-0.92456-0.6168-0.0637-0.0203l0.0637,0.0203h0.00001zm10.068-15.294c0.64544,0.0894,1.21716,0.22256,0.7765,0.95654-1.57887,5.93019-5.37912,11.3969-10.8442,14.3372-0.36225-0.53601-0.65369-1.03898,0.16385-1.23808,5.12194-3.01539,8.53162-8.34822,9.90389-14.0556zm3.99-25.028c-0.1063,0.78708,0.0492,1.09119,0.47594,0.66955-1.32938,8.17581-1.52967,16.5281-3.5018,24.5979-0.64409-0.0891-1.21564-0.22219-0.79099-0.96018,1.80279-7.85537,2.0269-15.9528,3.3267-23.889,0.16333-0.1394,0.32713-0.27899,0.49015-0.41826zm-0.49025,0.41827zm0.49142,0.57805c-0.0498-0.39684,0.065-1.5339,0.0401-0.52852-0.0134,0.1761-0.0267,0.35282-0.0401,0.52852z'/%3E %3Cpath d='m430.43,563.41,7.5391-0.0634c4.4017,2.1877,9.0216,12.222,3.6827,21.906-6.6547,12.071-8.7928,20.385-9.4379,29.382-7.3796-6.8309-10.818-14.723-8.2428-23.384,3.474-11.687,6.853-25.118,6.4589-27.84z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m437.97,563.85c-2.51303,0.0211-5.02607,0.0423-7.5391,0.0634-0.26476-0.96741,0.27196-1.14719,1.13537-1.00593,2.20465,0.0175,4.42542-0.10964,6.61992-0.00098-0.0722,0.31439-0.14351,0.62966-0.21619,0.94351zm-0.009-0.9963zm4.1226,22.645c-0.94563-0.24295-0.88161-0.77978-0.36288-1.47165,2.84748-5.78449,2.42144-13.272-1.70109-18.3478-0.64527-0.74756-1.38934-1.42962-2.27416-1.88218,0.20066-0.90364,0.70484-0.97121,1.33471-0.35013,3.29923,2.54727,4.92911,6.73545,5.36539,10.7792,0.41028,3.88691-0.47598,7.86088-2.36197,11.2725zm-10.21,29.506c1.02003-0.98391,0.24148-0.35685-0.14184-0.62884,0.49299-7.69611,2.59633-15.2332,5.85693-22.2068,1.11403-2.43045,2.33597-4.81021,3.62422-7.1526,0.97129,0.24427,0.86372,0.80228,0.32234,1.48644-4.22195,7.75017-7.5717,16.1264-8.52658,24.9592-0.12693,1.06815-0.22484,2.13965-0.30254,3.21246-0.2774,0.11001-0.55574,0.22027-0.83253,0.33011zm0.83272-0.33014c0.0876,1.03279-0.18537,1.15289-0.82967,0.33295,0.2632-0.11332,0.55506-0.2218,0.82967-0.33295zm-9.2151-23.561c0.93546,0.0433,1.04166,0.52586,0.68091,1.2979-1.32444,5.07036-0.21027,10.57,2.57538,14.9575,1.57506,2.5754,3.59359,4.85439,5.7993,6.90544-0.4518,0.82442-0.94132,0.71204-1.44303-0.00061-4.41702-4.25594-8.05021-9.81655-8.43617-16.0891-0.16691-2.38277,0.14828-4.78435,0.82361-7.07116zm6.9304-28.196c-0.12533,0.99771,0.11604,0.91724,0.50612,0.54045,0.0499,2.84725-0.72678,5.63387-1.28277,8.4078-1.49442,6.57166-3.29484,13.0699-5.20161,19.5326-1.00203-0.031-1.01305-0.59909-0.62812-1.38184,2.20115-7.65206,4.38794-15.3301,5.82399-23.1691,0.16499-1.11043,0.37884-2.23338,0.29473-3.35994,0.16268-0.18978,0.32444-0.38116,0.48766-0.56998zm-0.48673,0.56983zm0.49142-0.0717zm-0.49142,0.0717z'/%3E %3Cpath d='m433.79,558.16-12.055-4.2802c-4.261,10.115-7.1638,16.951-8.3249,20.639-2.2765,7.2327-2.6284,13.941-1.0556,19.629,4.709-1.4921,10.675-4.5751,14.004-11.796,3.3414-7.2515,4.5342-16.245,7.4312-24.192z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m421.9,553.41c4.01833,1.42673,8.03667,2.85347,12.055,4.2802-0.1474,0.65506-0.3519,1.19011-1.05275,0.68205-3.77845-1.34156-7.55689-2.68312-11.3353-4.02468-0.33547-0.5687-0.34757-0.76101,0.33308-0.93757zm-0.62396,0.27493zm-7.3936,20.983c-0.65568-0.12304-1.20594-0.30837-0.71114-1.02108,2.23986-6.31718,4.9793-12.4417,7.54401-18.6305,0.29617-0.35475,0.28387-1.46736,0.82445-1.21924,0.86915,0.0866,0.53396,0.66227,0.2559,1.21472-2.59363,6.2532-5.35693,12.4435-7.63874,18.8203-0.0949,0.27746-0.18447,0.5567-0.27448,0.83576zm-1.6795,19.005c0.23744,0.62322,0.46784,1.2379-0.3284,0.60743-1.79205-6.54273-0.94696-13.5209,1.06068-19.9111,0.59969,0.13775,1.22098,0.26413,0.7424,0.96928-1.79906,6.01522-2.52158,12.5469-0.84599,18.6762-0.20957-0.11396-0.41912-0.22797-0.62869-0.3419zm0.30026,0.94932c-0.73159,0.47002-0.78175-0.78993-0.0416-0.0226l0.0416,0.0226zm13.402-12.48c0.63007,0.20882,1.15836,0.45411,0.57586,1.09736-2.29931,4.70921-6.44552,8.38082-11.263,10.3783-0.88826,0.37797-1.79516,0.71153-2.71502,1.00416-0.26859-0.60348-0.44471-1.15211,0.40814-1.18433,4.92487-1.6299,9.41438-4.86525,12.0147-9.41446,0.35598-0.61131,0.67942-1.24043,0.97933-1.88101zm7.7162-23.514c0.18524-0.62803,0.36953-1.27534,0.63333-0.29842-2.90442,7.94644-3.94709,16.4902-7.44642,24.2312-0.61546-0.20945-1.16231-0.4445-0.59932-1.09383,3.22987-7.54946,4.29606-15.7881,7.11215-23.4781,0.10009,0.21305,0.20017,0.4261,0.30026,0.63915zm0.33308-0.93757c0.85014,0.0733,0.15384,1.08086,0.0161,0.0343l-0.0161-0.0343zm-0.16654,0.46879zm0.16654-0.46879c0.85014,0.0733,0.15384,1.08086,0.0161,0.0343l-0.0161-0.0343z'/%3E %3Cpath d='m425.6,549.74-2.6448-16.405c-2.7691-0.75076-6.4483,5.7288-10.048,9.5096-0.83037,0.87178-1.7839,1.6919-2.5087,2.7669-1.5142,2.2441-2.7374,4.9193-3.4165,7.9552-3.0119,13.456-7.4007,20.454-12.874,27.615,10.045-0.20796,17.844-3.829,21.652-12.023,5.1371-11.055,7.7432-17.645,9.8402-19.419z' fill='%23FFF'/%3E %3Cpath fill='%2321231e' d='m423.44,533.25c0.8816,5.46833,1.7632,10.9367,2.6448,16.405-0.94522,0.43546-1.16692-0.13255-1.16844-1.00592-0.81895-5.07976-1.63791-10.1595-2.45686-15.2393,0.44652-0.31001,0.56913-0.89049,0.9805-0.1598zm-0.36006-0.40064zm-9.8191,10.333c-0.76003-0.44442-0.77958-0.89688-0.0715-1.39257,2.45497-2.70303,4.34814-5.94719,7.24132-8.22868,0.75531-0.54075,1.70872-0.96178,2.64947-0.71207-0.004,0.95561-0.51742,0.94808-1.28814,1.07574-2.19189,1.15965-3.57251,3.34069-5.13322,5.1913-1.09547,1.38513-2.183,2.78337-3.39792,4.06628zm-2.4559,2.7023c-0.50569-0.28947-1.08795-0.5856-0.44784-1.07158,0.65636-0.83775,1.4496-1.55243,2.1857-2.317,0.89788,0.4865,0.62143,1.00089-0.0923,1.50764-0.59197,0.58607-1.17813,1.18923-1.64554,1.88094zm-3.3438,7.7861c-0.90108,0.0145-1.11221-0.41846-0.72936-1.19374,0.67915-2.54043,1.77819-4.96929,3.24977-7.14924,0.73049,0.30746,0.9517,0.70402,0.35259,1.2856-1.3462,2.16848-2.31558,4.56744-2.873,7.05738zm-13.369,27.007c0.29327,1.21976-0.41372,0.86819-0.24053,0.007,4.23797-5.43792,7.80901-11.4461,10.0342-17.9938,1.06365-3.02062,1.90327-6.11634,2.60681-9.23932,1.04024-0.0502,1.0313,0.55942,0.70402,1.36924-1.81063,7.87087-4.8124,15.5309-9.4485,22.1808-1.03538,1.52683-2.1327,3.0106-3.25142,4.47711-0.13484-0.2669-0.26994-0.53479-0.40462-0.80108zm0.0211,0.9963c-1.14662,0.35616-1.01101-0.45229-0.35143-0.69584,0.11714,0.23192,0.23429,0.46406,0.35143,0.69584zm21.191-12.731c0.96099,0.17313,0.94335,0.71055,0.41243,1.39936-2.48405,4.90545-7.17729,8.46545-12.4201,9.97466-2.97255,0.90615-6.08324,1.28774-9.18339,1.35712-0.2914-0.98444,0.27522-1.14101,1.13891-1.03731,5.95791-0.25802,12.212-1.99125,16.452-6.40668,1.49565-1.53613,2.69474-3.34747,3.60011-5.28715zm9.8003-19.129c0.86691-0.36415,1.25156,0.0424,0.45624,0.64501-2.03286,2.56201-3.2153,5.66443-4.63509,8.58228-1.57529,3.43984-3.12517,6.89132-4.72072,10.3219-0.97983-0.17529-0.92926-0.72662-0.42692-1.44283,2.51137-5.29629,4.70365-10.7515,7.50941-15.9033,0.56158-0.95451,1.15028-1.92255,1.98714-2.6637-0.0567,0.15355-0.11342,0.30708-0.17006,0.46063zm0.9805-0.1598z'/%3E %3C/g%3E %3Cuse xlink:href='%23g3464' transform='matrix(-1,0,0,1,964.29686,0)'/%3E %3Cpath stroke='%2321231E' d='m536.38,414.88c1.5869-0.32898,3.2089-0.78836,4.8568-1.3676-7.6306-4.7877-13.959-10.575-21.484-22.122-7.7068-11.828,3.379-32.951,7.9238-44.156,9.4966-7.0412,18.449-17.379,21.29-31.012,1.1259-7.3349-19.09-4.6832-32.997,1.8857-16.996,8.0293-19.31,5.804-25.369,7.1634-2.1545,10.42,2.3562,11.303,6.6934,10.79-9.3652,15.028-13.273,29.986-15.141,51.497-1.8684-21.512-5.7786-36.469-15.144-51.497,4.3384,0.51226,8.8492-0.37009,6.6934-10.79-6.0589-1.3582-8.3718,0.86707-25.369-7.1634-13.906-6.5689-34.123-9.2206-32.997-1.8857,2.8418,13.632,11.793,23.97,21.29,31.012,4.5448,11.205,15.631,32.329,7.9238,44.156-7.5238,11.547-13.853,17.335-21.484,22.122,1.649,0.57922,3.2699,1.0386,4.858,1.3676-1.1541,1.5755-11.049,4.6632-12.209,3.8419-7.5743-5.3622-14.956-17.956-21.396-25.265-18.245-20.712-27.347-36.702-24.13-49.597,4.5847-13.887,20.93-29.475-0.72365-26.783-21.653,2.694-39.601,32.426-45.366,68.197-2.1381,13.274-3.3778,24.385-4.8251,33.478,11.819-4.2202,17.054-8.4334,20.199-13.622-1.4133,4.9346-2.4735,9.6189-3.1843,14.088,9.669-1.7142,16.683-6.4643,19.195-15.137,1.0169-3.5118,2.2683-6.4314,3.5666-8.8552,2.9697,1.0574,6.8225,0.99632,11.508-0.15509,1.7792,4.2508,15.098,19.102,22.256,30.014,8.0821,12.322,20.229,21.742,24.231,22.255,2.0032,0.2573,2.619-4.192,2.1733-10.324,21.125,0.15038,42.235,0.27493,62.935-0.42884,20.7,0.70377,41.811,0.57922,62.936,0.42884-0.44686,6.1318,0.16772,10.581,2.1709,10.324,4.0018-0.51343,16.149-9.9326,24.23-22.255,7.1579-10.914,20.478-25.764,22.256-30.014,4.6855,1.1502,8.5395,1.2125,11.508,0.15509,1.2995,2.4238,2.5498,5.3434,3.5678,8.8552,2.5111,8.6731,9.5259,13.423,19.194,15.137-0.70958-4.4705-1.7698-9.1548-3.1831-14.088,3.1432,5.1884,8.3788,9.4016,20.198,13.622-1.4473-9.0926-2.687-20.204-4.8251-33.478-5.7634-35.771-23.713-65.503-45.366-68.197-21.652-2.6917-5.3083,12.896-0.72365,26.783,3.2171,12.896-5.8842,28.885-24.13,49.597-6.4389,7.3091-13.821,19.903-21.395,25.265-1.1599,0.82126-11.056-2.2664-12.209-3.8419z' fill='%23FFF'/%3E %3Cg id='g3535'%3E %3Cpath d='m440.58,356.77c-2.0361,1.7812-8.7565,1.807-17.956,2.3968-14.818,0.52048-23.397-3.9536-25.301-13.446,5.5605,6.6288,12.191,9.908,19.725,8.041,10.164-2.5178,15.978-4.3248,18.296-3.876,1.5622,0.55455,3.8434,3.3802,5.2356,6.8838z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m422.64,359.67c-0.0273-0.58009-0.23047-1.24829,0.6016-1.03502,4.67788-0.33997,9.39458-0.35355,14.0308-1.12115,1.03375-0.2215,2.13164-0.43964,2.97904-1.11254,0.37616,0.39942,0.94293,0.85764,0.14661,1.11499-2.18055,1.14814-4.71786,1.2352-7.12013,1.49473-3.54135,0.28687-7.09326,0.42529-10.6379,0.65899zm0.0141,0zm-24.952-14.263c-0.56121,0.45063-1.0128,0.83016-0.0887,0.31755,0.45214-0.14605,0.29284,0.94778,0.53965,1.29466,1.00292,3.73849,3.67839,6.92055,7.10533,8.68778,4.892,2.5633,10.5517,3.04355,15.9864,3.00204,0.44337,0.12859,1.48464-0.37739,1.37365,0.33955,0.30085,0.84346-0.54281,0.60994-1.09574,0.65-5.67852,0.0734-11.5915-0.42855-16.7065-3.09806-3.53249-1.82683-6.33576-5.04428-7.48797-8.86826-0.20114-0.62553-0.35523-1.26471-0.49298-1.90694,0.28895-0.13944,0.57789-0.27889,0.86684-0.41832zm19.225,7.8789c0.22252,0.61301,0.37496,1.18286-0.48321,1.13025-4.38554,0.96699-9.0772-0.00014-12.8395-2.4129-2.5435-1.58301-4.74001-3.66906-6.66265-5.95461,0.45125-0.47366,0.89502-0.85483,1.24486-0.0754,3.2846,3.77899,7.61218,7.02752,12.7021,7.68374,2.01383,0.26843,4.06922,0.11596,6.03842-0.37109zm18.581-3.8619c-0.27733,0.4901-0.0961,1.18318-0.76627,0.90483-2.70273,0.0427-5.3147,0.87142-7.93035,1.47233-3.21657,0.81141-6.42457,1.65669-9.64551,2.45085-0.22518-0.6147-0.37119-1.18172,0.4841-1.14558,4.85797-1.16853,9.65581-2.6043,14.5667-3.54142,1.08234-0.16647,2.20417-0.35966,3.29131-0.14101zm-0.0715-0.02zm5.469,7.7473c-0.38996-0.61127-0.76465-0.80492-0.82432-0.27668-0.98748-2.32098-2.27285-4.66029-4.32193-6.20572-0.72541-0.17389-0.52263-0.64035-0.272-1.18607,0.42937-0.008,0.96207,0.46176,1.35291,0.75766,1.92475,1.70341,3.23074,3.99779,4.20021,6.35146-0.045,0.18645-0.09,0.37289-0.13487,0.55935zm0.13487-0.55925z'/%3E %3Cpath fill='%2321231e' d='m419.53,321.15c0.0285,0.52557,0.0571,1.05113,0.0856,1.5767-0.67235,0.0698-1.10731-0.83629-0.6294-1.3158,0.13673-0.15479,0.34096-0.25225,0.5438-0.2609zm15.272,3.9136c-0.17906,0.49463-0.35811,0.98927-0.53717,1.4839-3.55135-1.26207-7.04724-2.75595-10.7548-3.50922-1.28024-0.25102-2.58933-0.37974-3.89402-0.30978-0.0285-0.52557-0.0571-1.05113-0.0856-1.5767,3.81105-0.19325,7.48236,1.08986,11.0194,2.35068,1.41747,0.51515,2.84268,1.05023,4.25225,1.56112zm8.862,2.5907c0.079,0.52047,0.15794,1.04093,0.23691,1.5614-1.40392,0.12062-2.77133-0.3558-4.10636-0.72626-1.86949-0.56838-3.69689-1.26265-5.52859-1.9402,0.17905-0.49503,0.35811-0.99007,0.53716-1.4851,2.58371,0.94085,5.15251,1.98728,7.85926,2.52241,0.32877,0.0516,0.67405,0.10794,1.00162,0.0677zm0.23691,1.5603c-0.079-0.5201-0.15794-1.0402-0.23691-1.5603,0.66274-0.13796,1.18375,0.72645,0.7527,1.2483-0.11976,0.1689-0.31465,0.28344-0.51579,0.312z'/%3E %3Cpath fill='%2321231e' d='m467.17,336.71c0.0641-0.3893,0.12823-0.7786,0.19235-1.1679,0.39436,0.0471,0.6238,0.53792,0.41891,0.8745-0.11546,0.21606-0.37499,0.33177-0.61126,0.2934zm-9.8613-2.0725c0.10595-0.38067,0.21189-0.76133,0.31784-1.142,3.19473,0.89958,6.46264,1.50481,9.73465,2.044-0.0641,0.38967-0.12823,0.77933-0.19235,1.169-3.31334-0.54742-6.6281-1.16265-9.86014-2.071zm0.31784-1.142c-0.10595,0.38067-0.21189,0.76133-0.31784,1.142-0.39521-0.0936-0.57137-0.63001-0.3057-0.9384,0.14394-0.18633,0.39866-0.266,0.62354-0.2036z'/%3E %3Cpath fill='%2321231e' d='m431.54,331.89c-0.25646,0.4594-0.51292,0.9188-0.76938,1.3782-2.69042-1.51685-4.60582-4.05281-6.15901-6.66166-0.77438-1.29594-1.47166-2.63547-2.19168-3.9618,0.46053-0.25221,0.92107-0.50442,1.3816-0.75663,1.61047,2.9562,3.13524,6.06042,5.60431,8.41373,0.64695,0.60848,1.35976,1.15551,2.13416,1.58816zm7.6071-5.1637c0.46327,0.24869,0.92653,0.49737,1.3898,0.74606-1.16299,2.13225-2.61165,4.22461-4.70078,5.53966-1.30033,0.82202-2.98239,1.146-4.4382,0.55101-0.16958-0.1155-0.62489-0.16931-0.58498-0.37149,0.24234-0.43411,0.48469-0.86823,0.72703-1.30234,0.95683,0.57698,2.18441,0.49252,3.14013-0.0398,1.67797-0.9045,2.86874-2.47511,3.86011-4.06209,0.21319-0.34616,0.41717-0.70774,0.60689-1.06103z'/%3E %3Cpath d='m429.59,330.91-2.1897-2.1935c-1.0673-1.3511-0.45037-3.1511,1.8531-5.401,1.6842,0.73078,3.0318,1.2936,4.3806,1.8563-0.8984,3.0371-2.2472,4.951-4.044,5.7382z' fill='%2321231E'/%3E %3Cpath fill='%2321231e' d='m423.26,412.95c-0.14626,0.35505-0.24183,0.81814-0.41866,1.108-0.57236-0.19639-0.42176-1.13588,0.18451-1.1397,0.0795-0.006,0.15841,0.01,0.23415,0.0317zm23.873-3.5282c0.2764,0.28158,0.5528,0.56317,0.8292,0.84475-2.85707,2.84941-6.58205,4.82734-10.5699,5.49061-4.88263,0.83922-9.89508-0.0671-14.522-1.68701,0.13019-0.37283,0.26037-0.74567,0.39056-1.1185,4.68367,1.63937,9.79909,2.54266,14.716,1.48476,3.46366-0.72617,6.65273-2.52628,9.15618-5.01461zm2.8887-2.8668c0.27835,0.27963,0.55671,0.55926,0.83506,0.83889-0.96197,0.96073-1.92656,1.91879-2.8947,2.8733-0.2764-0.28158-0.5528-0.56317-0.8292-0.84475,0.96706-0.95155,1.92952-1.90871,2.88884-2.86744zm0.83506,0.83889c-0.25475-0.28649-0.63177-0.57453-0.81286-0.86009,0.40509-0.41091,1.15702,0.0709,0.9593,0.6106-0.024,0.094-0.0866,0.18622-0.14644,0.24949z'/%3E %3Cpath fill='%2321231e' d='m452.17,401.28c-0.39057-0.054-0.78113-0.10809-1.1717-0.16213,0.0436-0.53322,0.83399-0.69908,1.0881-0.22861,0.0724,0.11603,0.0999,0.25808,0.0836,0.39074zm-5.5077,15.927c0.0993,0.38223,0.1986,0.76447,0.2979,1.1467-0.22949-0.2714-0.45897-0.54281-0.68846-0.81421,2.1706-4.82111,3.73699-9.91979,4.53806-15.1493,0.0677-0.42378,0.12999-0.84837,0.18851-1.2735,0.39057,0.0537,0.78113,0.10731,1.1717,0.16096-0.723,5.40394-2.20168,10.7012-4.36564,15.7049-0.14846,0.34779-0.30111,0.69377-0.45362,1.0398-0.22948-0.27179-0.459-0.5436-0.68845-0.81538zm-0.39056,0.33249c0.36007,0.16057,0.72013,0.32114,1.0802,0.48171-0.19148,0.5156-1.02971,0.4317-1.1155-0.11099-0.0305-0.12292-0.0131-0.25697,0.0353-0.37072zm15.249-9.5355c0.32331,0.22637,0.64663,0.45273,0.96994,0.6791-2.54489,3.65798-6.34481,6.27398-10.4232,7.96355-1.65717,0.69626-3.37055,1.25322-5.10879,1.70823-0.0993-0.38183-0.1986-0.76367-0.2979-1.1455,4.51592-1.18306,8.96566-3.11061,12.3941-6.35246,0.91515-0.86442,1.74453-1.82203,2.46593-2.85292zm0.96994,0.6791c-0.32331-0.22637-0.64663-0.45273-0.96994-0.6791,0.28211-0.45356,1.06267-0.24183,1.0723,0.2933,0.0141,0.13507-0.0313,0.27913-0.10236,0.3858z'/%3E %3Cpath fill='%2321231e' d='m461.29,400.2c-0.39253,0.036-0.78507,0.0721-1.1776,0.10809-0.075-0.51468,0.6223-0.86148,0.98669-0.4895,0.10908,0.0976,0.17309,0.24157,0.19091,0.38141zm4.4345,15.717c0.2377,0.31527,0.47539,0.63053,0.71309,0.9458-0.28256-0.0664-0.6154-0.0533-0.86632-0.16986-3.16287-4.55487-4.76589-10.0244-5.3675-15.493-0.0342-0.29713-0.0608-0.59504-0.09-0.89268,0.39213-0.036,0.78427-0.0721,1.1764-0.1081,0.48767,5.31571,1.89369,10.6551,4.82017,15.1704,0.14707,0.22933,0.30162,0.45365,0.45627,0.6779-0.28021-0.0426-0.56427-0.0924-0.84208-0.13041zm-0.12901,0.81303c0.32331-0.22636,0.64663-0.45273,0.96994-0.67909,0.32855,0.42034-0.13511,1.0829-0.64221,0.9094-0.13278-0.0343-0.24765-0.1221-0.32773-0.23031zm7.6716-12.607c0.38233,0.0963,0.76467,0.19268,1.147,0.28902-1.18931,4.82941-3.90362,9.33979-7.8789,12.376-0.21878,0.14767-0.34955-0.36525-0.53094-0.4983-0.22006-0.22652-0.37225-0.44396,0.005-0.59046,3.66134-2.87774,6.15479-7.08123,7.25807-11.5762zm1.147,0.28902c-0.38233-0.0963-0.76467-0.19268-1.147-0.28902,0.0972-0.51237,0.87342-0.60948,1.0944-0.1374,0.0709,0.12881,0.0876,0.28665,0.0526,0.42642z'/%3E %3Cpath d='m405.91,317.77c-16.619,1.7976-15.826,12.669-0.28969,28.043,2.9732,2.9408,3.9935,2.8468,4.6281-0.21149,1.1083-5.3434,7.0195-8.5004,10.123-4.4282,2.1123,2.7716,1.6396,4.3577,8.6768,3.3743,8.889,7.4583,16.126,12.704,4.4944,12.267-5.1171-0.19268-9.0603,2.7916-15.727,2.5307,1.9727,3.829,2.3258,4.2731,3.3907,4.5962,6.4624,1.2806,13.273-2.7622,19.793-1.5579,14.285,2.6365-22.887-38.633-22.427-40.263,1.174-4.1533-8.9359-11.599-12.662-4.3507z' fill='%23EDB92E'/%3E %3Cpath fill='%2321231e' d='m405.97,345.46c-0.63842,1.23846-1.27787,0.0892-1.91709-0.52305-4.06663-4.27995-8.13541-8.87724-10.1508-14.5212-1.1218-3.0258-0.99896-6.83757,1.46938-9.18069,2.77156-2.70665,6.77306-3.5028,10.486-3.95871,0.53366,1.22553-0.65232,1.07905-1.52255,1.20687-3.40595,0.58035-7.26877,1.591-9.22908,4.69776-1.82025,3.10463-0.54232,6.89545,0.99759,9.83683,2.50394,4.69709,6.13668,8.69183,9.86662,12.4421zm3.7918,0.041c1.23655-0.12254,0.92878,0.82322,0.56684,1.62489-0.28918,1.17365-1.70243,1.7251-2.68499,0.99349-0.89226-0.5157-1.63792-1.2395-2.37267-1.95269,0.55407-1.04825,1.10522-0.37822,1.7018,0.23146,0.58531,0.40202,1.31295,1.31586,2.08187,0.93978,0.44179-0.50144,0.55299-1.2107,0.70715-1.83693zm11.005-4.6291c-0.75468,1.07541-1.20296-0.00003-1.94225-0.47584-3.5993-1.99006-7.50785,1.82142-8.08913,5.3069-1.31167,0.1289-0.85329-0.91549-0.51723-1.72594,1.17018-3.03612,4.3719-5.79472,7.79263-5.0023,1.11274,0.27266,2.06762,0.99623,2.75598,1.89718zm8.6005,3.2944c-0.82267,0.89493-0.0252,0.97017-1.46798,1.02783-2.21283,0.22861-5.04601,0.49479-6.47456-1.61862-0.50493-0.68439-0.92609-1.42725-1.44846-2.09945,0.69489-0.96748,1.16417-0.22624,1.57914,0.52367,0.65553,1.25247,1.78838,2.37111,3.30418,2.31447,1.46855,0.17818,2.95855-0.25747,4.39679-0.17925l0.11089,0.0319v-0.00053zm-0.38822-0.11162zm4.5448,13.258c-0.34897-1.27616,0.76789-0.9646,1.63618-0.97489,1.28717-0.097,2.86319,0.0614,3.84925-0.91064,0.20392-1.25764-1.04063-2.20561-1.76368-3.09182-2.65565-2.67061-5.65203-4.96766-8.51636-7.40475,0.51648-1.251,1.22922-0.25488,1.9089,0.29814,3.00325,2.6111,6.33222,4.94884,8.76519,8.13647,0.82652,0.97172,0.98958,2.75446-0.38337,3.32004-1.69558,0.77967-3.67556,0.64217-5.49611,0.62745zm-15.267,1.8058c-1.26553,1.02862-0.71244-0.55103,0.32489-0.25534,4.5533,0.1561,8.72597-1.992,13.1823-2.48968,0.60694,0.0875,2.06733-0.52022,1.77559,0.52242,0.045,0.80826-1.24315,0.22869-1.81842,0.47958-4.28029,0.5466-8.30229,2.52486-12.6773,2.48265-0.75732-0.0816-1.74598,0.32429-0.787-0.73963zm-0.88198,0.45587zm3.9279,3.8795c0.14012,1.19996-0.74295,1.0063-1.3745,0.34552-1.13416-1.21113-1.75717-2.79039-2.55319-4.22498,0.87587-0.8579,1.19019,0.0408,1.54816,0.82243,0.69323,1.07028,1.09315,2.63424,2.42777,3.06983l-0.0481-0.0129-0.00014,0.0001zm-0.19234,0.97752zm19.98-2.5366c0.14648,1.24134-0.79379,0.8877-1.64837,0.79915-6.19169-0.37987-12.1258,2.92894-18.3311,1.73774-0.13055-1.23859,0.79702-0.87957,1.64931-0.78062,6.1938,0.42949,12.1214-2.8804,18.3302-1.75627zm-22.996-39.908c0.98693,0.0432,1.27813,0.60032,1.75926,1.40227,7.27335,9.72399,15.3131,18.9153,21.6824,29.2886,1.39706,2.52315,3.07779,5.10839,3.22757,8.0682-0.002,1.35357-1.21991,2.3099-2.52299,2.25146-1.00449,0.32781-1.85368-0.6834-0.8633-1.073,0.95267,0.22652,2.43681,0.0511,2.39409-1.22302-0.26409-3.04056-2.06253-5.66739-3.54391-8.25018-6.25106-9.98787-14.003-18.9055-21.058-28.3121-0.43061-0.67161-1.06533-1.31019-1.07506-2.15226zm-12.131-3.7209c0.0655-1.28053-0.8678-0.46737,0.0663-1.63521,1.48274-2.35243,4.66815-2.93463,7.12799-1.90927,2.71248,1.07726,5.37582,3.23423,5.96725,6.22126,0.35878,0.95321-0.38673,1.75447-1.00312,0.90271,0.20347-2.25335-1.71126-4.0398-3.40767-5.22378-2.10555-1.46958-5.4093-2.15379-7.35133-0.0535-0.58934,0.47493-0.73943,1.33321-1.39938,1.69782zm0.38938-0.2667zm-0.44216-0.22794zm0.44216,0.22794z'/%3E %3Cpath fill='%2321231e' d='m406.86,317.22c-0.3753,0.13159-0.7506,0.26317-1.1259,0.39476-0.17851-0.43638,0.29851-0.93006,0.7403-0.76399,0.17805,0.0518,0.32614,0.20293,0.3856,0.36923zm7.7021,10.54c-0.25685,0.30312-0.5137,0.60625-0.77055,0.90937-3.08094-2.60039-5.77748-5.75381-7.42321-9.46194-0.2336-0.52173-0.44427-1.05359-0.63427-1.59271,0.3753-0.13159,0.7506-0.26317,1.1259-0.39476,1.24266,3.56448,3.53748,6.68147,6.26598,9.25597,0.46609,0.44197,0.94703,0.86783,1.43615,1.28407zm-0.77173,0.90937c0.25685-0.30312,0.51371-0.60625,0.77056-0.90937,0.37451,0.28535,0.21422,0.95523-0.25099,1.0357-0.17963,0.0433-0.38124-0.004-0.51957-0.12633z'/%3E %3Cpath fill='%2321231E' d='M0.9,0c0,0.435087-0.402944,0.787795-0.9,0.787795s-0.9-0.352708-0.9-0.787795,0.402944-0.787795,0.9-0.787795,0.9,0.352708,0.9,0.787795z' transform='matrix(0.21421557,-1.5108362,1.7589027,0.18400288,404.14272,325.54714)'/%3E %3Cpath fill='%2321231e' d='m358.42,362.56c0.59848-0.47408,1.32908,0.54254,0.68909,0.9577-0.2288-0.31701-0.46287-0.64749-0.68909-0.9577zm-22.681,56.14c1.4717-10.1107,5.01436-19.785,8.4826-29.3523,3.39442-8.52846,6.67439-17.308,12.1596-24.7515,0.46369-1.32127,3.24108-2.73322,2.29845-0.72275-4.4893,4.65989-6.90728,10.8555-9.60853,16.6373-4.91065,11.7007-9.33647,23.7082-11.8608,36.1707-0.44764,1.12949,0.43639,2.66011-1.47141,2.01857zm5.5534,80.362c-5.78817-16.1576-6.83157-33.5392-6.97465-50.5614-0.005-9.94896,0.50423-19.8954,1.42091-29.801,2.25205-0.31461,0.53146,2.66866,0.83998,3.98686-1.5874,21.011-1.8961,42.3628,2.19921,63.1223,0.91312,4.35582,2.07003,8.6669,3.62293,12.8406-0.36938,0.13762-0.73927,0.27475-1.10838,0.41263zm1.1083-0.41357c0.29883,0.70162-0.87351,1.13458-1.10671,0.4112,0.36677-0.13601,0.74642-0.27861,1.10671-0.4112z'/%3E %3C/g%3E %3Cuse xlink:href='%23g3535' transform='matrix(-1,0,0,1,964.29721,0)'/%3E %3Cpath fill='%2321231e' d='m473.11,398.36c-0.36744,0.11209-0.52136,0.43768-0.44596,0.85825,0.0973,1.60258,0.28372,3.19635,0.57726,4.77505,0.34717,1.90631,0.90455,3.77303,1.5507,5.59752,0.98844,2.63176,2.23941,5.16545,3.78762,7.51421,0.91989,1.44912,1.97455,2.83011,3.0336,4.16342,0.21397,0.1901,0.66535,0.19982,0.9308,0.0943,0.53343-0.50658,0.96464-1.16542,1.43447-1.75001,0.8386-1.14048,1.64362-2.30402,2.37938-3.51363,1.45154-2.46533,2.70401-5.05723,3.58456-7.78303,0.72447-2.30922,1.28335-4.68061,1.51478-7.09371,0.11002-0.79391,0.16989-1.59466,0.17871-2.39607-0.0771-0.36516-0.53212-0.59669-0.868-0.403-0.45167,0.20685-0.28061,0.87479-0.35091,1.36115-0.14413,1.84356-0.41895,3.67485-0.8363,5.47723-0.4357,1.85547-1.06395,3.66139-1.78454,5.42373-0.8197,1.97667-1.86651,3.85-2.99053,5.66804-0.84597,1.26376-1.71137,2.51941-2.66568,3.70394-1.03407-1.34203-2.03442-2.71246-2.92593-4.15546-1.35733-2.14179-2.45671-4.44313-3.34951-6.81404-0.77262-2.14584-1.33938-4.36412-1.69086-6.61655-0.18969-1.24583-0.24314-2.53645-0.3812-3.76944-0.12621-0.24497-0.35273-0.38005-0.68246-0.3419z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m549.18,422.03,0,108.56,0,0.004c-0.00099,19.413-7.5285,37.038-19.669,49.809-12.143,12.772-28.899,20.691-47.357,20.691h-0.006c-18.457-0.00099-35.214-7.9188-47.354-20.69-12.143-12.771-19.67-30.397-19.671-49.811v-108.56h134.06z' fill='%23C6363C'/%3E %3Cuse xlink:href='%23path1563' transform='matrix(-1,0,0,1,964.29715,-90.088376)'/%3E %3Cpath stroke='%2321231E' stroke-width='0.99388075' d='m549.18,488.62,0,27.978-53.063,0,0,82.947c-4.5061,1.0104-9.1776,1.5462-13.964,1.5462h-0.005c-4.7852,0-9.4555-0.53458-13.96-1.5462v-82.947h-53.064v-27.978h53.064v-66.588h27.929v66.588h53.063z' fill='%23FFF'/%3E %3Cuse xlink:href='%23path1563' y='-90.088376'/%3E %3Cpath id='path1563' d='m459.14,567.32,0-39.331c-8.5595-2.3028-29.402-10.619-30.486,7.6134-0.50198,8.4276,10.44,13.987,13.39,6.5418,1.3969-3.5223-0.12432-6.0178-2.1827-6.8226-2.2226-0.86943-4.4263,0.92935-3.8376,3.6105-8.8597-4.6373,7.9156-14.483,15.49-1.6684,2.2061,3.7315-3.7226,7.6216-3.7308,10.388-0.007,2.7681,5.8255,6.912,3.7308,10.394-7.6693,12.754-24.351,2.969-15.49-1.6684-0.58876,2.6811,1.6162,4.4799,3.8376,3.6105,2.0572-0.8048,3.5784-3.3003,2.1827-6.8238-2.9509-7.4442-13.892-1.8845-13.39,6.543,1.0837,18.231,21.926,9.915,30.486,7.6122z' stroke='%2321231E' stroke-width='0.99388075' fill='%23FFF'/%3E %3Cuse xlink:href='%23path1563' transform='matrix(-1,0,0,1,964.29715,0)'/%3E %3Cpath fill='%2321231e' d='m414,420.86c0.0769,37.9499-0.15407,75.9048,0.11608,113.851,1.19869,27.857,19.6711,54.508,46.2142,63.7703,22.4262,8.31951,49.0036,2.58773,66.3765-13.74,16.202-14.5213,24.6562-36.6878,23.5841-58.2366,0.00002-35.2156,0.00004-70.4311,0.00005-105.647-45.43,0.00093-90.8621-0.002-136.291,0.001zm2.2653,2.3625h131.79c-0.0773,37.1217,0.15498,74.2486-0.11689,111.367-1.12767,26.6642-18.7148,52.2587-44.0242,61.4104-21.5923,8.2881-47.349,3.04215-64.3154-12.5677-16.0185-14.0851-24.4149-35.7432-23.3346-56.9243,0.00035-34.4285,0.0007-68.857,0.001-103.285z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' x='0' y='0' fill='%23002B7F'/%3E %3Crect width='1' height='2' x='1' y='0' fill='%23FCD116'/%3E %3Crect width='1' height='2' x='2' y='0' fill='%23CE1126'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1400' height='550' viewBox='0 0 75 18' preserveAspectRatio='none'%3E %3Crect width='75' height='18' fill='%238d1b3d'/%3E %3Cpath d='M22,18H0V0H22l6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1 -6,1 6,1z' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='330'%3E %3Crect width='600' height='330' fill='%230038a8'/%3E %3Crect width='600' height='220' fill='%23fff'/%3E %3Crect width='600' height='110' fill='%23d52b1e'/%3E %3Cg%3E %3Cg fill='none' stroke='%23000'%3E %3Ccircle stroke-width='1.07585' cx='300' cy='165' r='42.2'/%3E %3Ccircle stroke-width='0.47815' cx='300' cy='165' r='34.67'/%3E %3Ccircle stroke-width='0.43816' cx='300' cy='165' r='26.56'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m277.53,181.28-4.8927,2.9054-1.4963-2.5198c-0.27744-0.46724-0.44945-0.84813-0.51601-1.1427-0.0666-0.29453-0.0363-0.58185,0.0908-0.86197,0.12709-0.28011,0.34638-0.51266,0.65787-0.69763,0.27145-0.16118,0.53998-0.24239,0.80558-0.24363,0.26562-0.001,0.51973,0.0631,0.76232,0.19286,0.15451,0.0828,0.32407,0.22138,0.50868,0.41571-0.0469-0.21589-0.0648-0.38284-0.0536-0.50084,0.007-0.0794,0.0448-0.21092,0.1133-0.39456,0.0685-0.18363,0.12781-0.31439,0.17786-0.39227l0.98439-1.5732,1.0147,1.7088-1.0156,1.6955c-0.13279,0.2173-0.20433,0.38317-0.21461,0.49762-0.0109,0.15394,0.0246,0.29989,0.10651,0.43783l0.0793,0.1335,1.9858-1.1792zm-3.812,0.20962-0.37853-0.63744c-0.041-0.069-0.14247-0.18926-0.30456-0.36086-0.0795-0.0882-0.17921-0.13961-0.29919-0.15414-0.11997-0.0145-0.23336,0.01-0.34016,0.0734-0.15797,0.0938-0.2495,0.21587-0.2746,0.3662s0.0443,0.36344,0.20811,0.63933l0.39438,0.66415z'/%3E %3Cpath d='m269.11,177.71-1.4871-4.4713,1.1528-0.38341,0.93096,2.7992,0.85817-0.28541-0.86358-2.5966,1.1013-0.36626,0.86358,2.5966,1.0644-0.35401-0.9579-2.8802,1.2228-0.40668,1.514,4.5524z'/%3E %3Cpath d='m267.16,171.06-0.3323-2.9038c-0.0724-0.63243,0.0238-1.1233,0.28857-1.4727,0.26476-0.34935,0.67479-0.5558,1.2301-0.61935,0.57074-0.0653,1.0364,0.0553,1.3971,0.36169,0.36064,0.30644,0.58127,0.81187,0.66188,1.5163l0.10944,0.95637,2.0978-0.24007,0.2008,1.7546zm2.2094-2.0304-0.049-0.42806c-0.0385-0.33678-0.1241-0.56661-0.25667-0.68948-0.13256-0.12287-0.29011-0.17386-0.47265-0.15298-0.17739,0.0203-0.32102,0.0967-0.43089,0.22903-0.10986,0.13238-0.14612,0.36183-0.10876,0.68833l0.0569,0.49746z'/%3E %3Cpath d='m266.98,160.38,0.18811-1.7443,3.3729,0.36373c0.33446,0.0361,0.64465,0.12223,0.93056,0.25847,0.28592,0.13625,0.52815,0.32764,0.72669,0.57418s0.32966,0.49688,0.39335,0.75099c0.0894,0.3532,0.10849,0.76778,0.0572,1.2437-0.0297,0.27528-0.0814,0.57357-0.15507,0.89486-0.0737,0.32129-0.17957,0.58511-0.31764,0.79144-0.13807,0.20634-0.32237,0.38882-0.55289,0.54745-0.23053,0.15863-0.46131,0.25932-0.69235,0.30207-0.37184,0.0692-0.69669,0.0888-0.97455,0.0589l-3.3729-0.36374,0.18811-1.7443,3.4539,0.37248c0.30873,0.0333,0.55915-0.0262,0.75126-0.1786,0.19211-0.15236,0.30454-0.38033,0.33727-0.68392,0.0325-0.301-0.0276-0.54628-0.18026-0.73582-0.15263-0.18954-0.38589-0.30123-0.69977-0.33508z'/%3E %3Cpath d='m267.74,156.21,1.0861-3.1072c0.18101-0.51785,0.44822-0.87058,0.80162-1.0582,0.3534-0.18759,0.71941-0.21522,1.098-0.0829,0.31756,0.111,0.55534,0.30514,0.71335,0.5824,0.10535,0.18485,0.15759,0.41967,0.15673,0.70444,0.22773-0.3535,0.48638-0.58175,0.77594-0.68476,0.28956-0.103,0.60534-0.0947,0.94732,0.0248,0.27847,0.0973,0.50623,0.2496,0.68326,0.45675,0.17704,0.20718,0.29101,0.44575,0.34192,0.71573,0.0319,0.16742,0.0171,0.39799-0.0444,0.6917-0.0818,0.39082-0.14402,0.6473-0.18672,0.76943l-1.0016,2.8653zm2.6922-0.93805,0.25231-0.72183c0.0905-0.25893,0.1089-0.45466,0.0552-0.58721-0.0537-0.13253-0.16486-0.22826-0.33341-0.28718-0.15633-0.0546-0.29619-0.0466-0.41956,0.024s-0.22903,0.23176-0.31698,0.48335l-0.25615,0.73282zm2.1105,0.73772,0.29586-0.84641c0.0999-0.2858,0.11965-0.50504,0.0593-0.65773-0.0604-0.15268-0.17608-0.25891-0.34708-0.31868-0.15877-0.0555-0.30668-0.0421-0.44373,0.0402s-0.25637,0.2688-0.35798,0.55948l-0.29458,0.84275z'/%3E %3Cpath d='m270.43,149.37,0.90849-1.5054,3.6722,2.2161,1.4179-2.3495,1.1997,0.72398-2.3264,3.855z'/%3E %3Cpath d='m273.87,144.16,1.1282-1.3537,4.3712,3.643-1.1282,1.3537z'/%3E %3Cpath d='m281.52,141.22,1.4723-0.65101c0.20313,0.39522,0.31475,0.77525,0.33485,1.1401,0.0201,0.36486-0.0469,0.71073-0.20101,1.0376-0.15411,0.32689-0.42448,0.65645-0.81111,0.98868-0.46907,0.40307-0.91088,0.66415-1.3254,0.78324-0.41455,0.1191-0.87733,0.0997-1.3884-0.0583-0.51102-0.15794-0.99673-0.50481-1.4571-1.0406-0.61387-0.71439-0.89577-1.4266-0.84571-2.1366,0.0501-0.71001,0.42249-1.3635,1.1172-1.9605,0.54365-0.46714,1.0654-0.72446,1.5654-0.77195,0.49996-0.0475,1.0211,0.0915,1.5635,0.41697l-0.95243,1.2739c-0.1542-0.0961-0.28002-0.15514-0.37744-0.1772-0.16227-0.038-0.32099-0.038-0.47616-0.00025-0.15516,0.0378-0.29947,0.11405-0.43293,0.22872-0.30224,0.25972-0.42927,0.5804-0.38109,0.96205,0.0335,0.28513,0.21632,0.62101,0.54856,1.0076,0.41149,0.47888,0.76617,0.74473,1.064,0.79755,0.29785,0.0528,0.57828-0.0338,0.84127-0.25975,0.25514-0.21924,0.38641-0.45657,0.39382-0.71199,0.007-0.25542-0.0767-0.54483-0.25221-0.86823z'/%3E %3Cpath d='m287.58,139.04-1.7674,0.94226,0.19872,0.95853-1.5858,0.84547-0.78977-6.0274,1.692-0.90208,4.5643,4.0151-1.6235,0.86556zm-0.90425-0.91228-1.5172-1.5092,0.41089,2.099z'/%3E %3Cpath d='m292.05,132.3,2.5741-0.44458c0.50743-0.0876,0.92922-0.0896,1.2654-0.006,0.33614,0.0838,0.62845,0.23678,0.87693,0.45908,0.24847,0.22232,0.44811,0.49639,0.59892,0.82222,0.15081,0.32584,0.25924,0.68,0.32531,1.0625,0.10349,0.59923,0.11554,1.0757,0.0362,1.4295-0.0794,0.35377-0.22095,0.66314-0.42465,0.92809-0.20371,0.26496-0.43815,0.45841-0.70331,0.58036-0.36233,0.16762-0.69776,0.27807-1.0063,0.33136l-2.5741,0.44458zm1.952,0.97061,0.52914,3.0637,0.42456-0.0733c0.36208-0.0625,0.61269-0.14717,0.75181-0.25392s0.23474-0.26769,0.28687-0.48283c0.0521-0.21514,0.0394-0.54711-0.0381-0.99589-0.10262-0.59413-0.26976-0.98411-0.50142-1.1699-0.23167-0.18582-0.5719-0.23998-1.0207-0.16247z'/%3E %3Cpath d='m299.36,131.32,4.7078,0.2013-0.0519,1.2138-2.9472-0.12602-0.0386,0.90356,2.734,0.11691-0.0496,1.1595-2.734-0.11691-0.0479,1.1207,3.0326,0.12967-0.055,1.2875-4.7932-0.20495z'/%3E %3Cpath d='m306.21,131.86,1.7079,0.41801-1.0197,4.1661,2.6655,0.6524-0.33312,1.361-4.3734-1.0704z'/%3E %3Cpath d='m315.34,134.89,2.516,1.4873c0.54797,0.32393,0.88136,0.69687,1.0002,1.1188,0.1188,0.42194,0.036,0.87348-0.24843,1.3546-0.29234,0.49452-0.6695,0.7931-1.1315,0.89575-0.46199,0.10265-0.99815-0.0264-1.6085-0.38723l-0.82865-0.48985-1.0745,1.8177-1.5203-0.89873zm0.2858,2.9871,0.37089,0.21925c0.2918,0.1725,0.52669,0.24297,0.70467,0.21141,0.17798-0.0316,0.31371-0.12642,0.40721-0.28458,0.0909-0.1537,0.11665-0.3143,0.0774-0.4818-0.0393-0.16749-0.20035-0.33486-0.48325-0.5021l-0.43103-0.2548z'/%3E %3Cpath d='m320.56,144.51-1.4666-1.364-0.8415,0.50015-1.316-1.2239,5.4413-2.7102,1.4041,1.3058-2.3091,5.6233-1.3472-1.253zm0.56794-1.1521,0.93263-1.9261-1.8507,1.0723z'/%3E %3Cpath d='m321.81,147.14,4.692-3.2194,1.658,2.4164c0.30744,0.44807,0.504,0.81689,0.5897,1.1064,0.0857,0.28955,0.0743,0.57824-0.0342,0.86607-0.10849,0.28783-0.31209,0.53423-0.6108,0.73919-0.26032,0.17861-0.52295,0.27722-0.78791,0.29583-0.26497,0.0186-0.52274-0.0289-0.77331-0.14255-0.1596-0.0725-0.33786-0.19969-0.5348-0.38152,0.061,0.21236,0.0897,0.37777,0.0863,0.49625-0.002,0.0797-0.0309,0.2134-0.0872,0.40113-0.0564,0.18773-0.10695,0.32208-0.1518,0.40308l-0.87931,1.6342-1.1244-1.6387,0.90241-1.7584c0.11829-0.22552,0.17882-0.39572,0.18159-0.5106,0.00081-0.15433-0.0442-0.29763-0.13493-0.42992l-0.0878-0.12802-1.9043,1.3066zm3.7901-0.45867,0.41944,0.61131c0.0454,0.0661,0.15455,0.17952,0.32753,0.34014,0.0851,0.0828,0.18796,0.12758,0.30863,0.13423,0.12067,0.007,0.23221-0.0252,0.33464-0.0954,0.15148-0.10394,0.23483-0.23174,0.25004-0.38339,0.0152-0.15165-0.068-0.35976-0.24951-0.62434l-0.437-0.63691z'/%3E %3Cpath d='m327.36,155.2-0.74229-1.8602-0.97457,0.0922-0.66605-1.6692,6.0777-0.12252,0.71065,1.7809-4.4924,4.0953-0.68188-1.7088zm1.0062-0.7985,1.6668-1.3421-2.1315,0.1777z'/%3E %3Cpath d='m329.85,160.62,1.1708-0.17519,0.40208,2.6871-2.3992,0.359c-0.42757-0.46194-0.73428-0.88112-0.92012-1.2576-0.18585-0.37645-0.31936-0.83594-0.40054-1.3785-0.0999-0.66794-0.0675-1.2294,0.0973-1.6845,0.16477-0.45507,0.45504-0.8321,0.8708-1.1311,0.41575-0.299,0.91538-0.49216,1.4989-0.57947,0.6142-0.0919,1.1674-0.0452,1.6596,0.14023,0.49216,0.18539,0.89253,0.50487,1.2011,0.95844,0.23876,0.35413,0.40638,0.85365,0.50289,1.4986,0.093,0.62188,0.10634,1.0954,0.0399,1.4207-0.0665,0.32522-0.20284,0.60727-0.40911,0.84615-0.20629,0.23888-0.48347,0.43668-0.83156,0.59343l-0.55043-1.6327c0.20207-0.10089,0.34706-0.24229,0.43497-0.4242,0.0879-0.18192,0.1127-0.40083,0.0744-0.65675-0.0571-0.38132-0.23497-0.6654-0.53373-0.85225-0.29877-0.18686-0.73477-0.2374-1.308-0.15162-0.60908,0.0911-1.027,0.27076-1.2538,0.53886-0.22676,0.26811-0.30951,0.60689-0.24824,1.0164,0.0291,0.1945,0.085,0.37583,0.16774,0.54399,0.0827,0.16815,0.20894,0.35597,0.37866,0.56344l0.52975-0.0793z'/%3E %3Cpath d='m333.57,168.88-0.15576,1.7475-3.379-0.30119c-0.33507-0.0299-0.6468-0.11026-0.93519-0.24118-0.28839-0.13093-0.53412-0.3178-0.7372-0.56061-0.20307-0.24283-0.3388-0.49069-0.40719-0.74358-0.096-0.35149-0.1227-0.76564-0.0802-1.2425,0.0246-0.27579,0.0707-0.57499,0.13846-0.89759,0.0677-0.3226,0.16869-0.58833,0.30292-0.79719,0.13422-0.20886,0.31511-0.39472,0.54265-0.55759,0.22755-0.16288,0.45643-0.26782,0.68664-0.31485,0.37049-0.0761,0.69492-0.10173,0.97328-0.0769l3.379,0.30119-0.15576,1.7475-3.4602-0.30842c-0.30929-0.0276-0.55857,0.0366-0.74782,0.19248-0.18926,0.15589-0.29744,0.38591-0.32455,0.69005-0.0269,0.30156,0.0378,0.54568,0.19387,0.73236,0.15612,0.18667,0.39141,0.29402,0.70586,0.32206z'/%3E %3Cpath d='m327.28,174.9,0.62561-1.9026-0.80624-0.5552,0.56134-1.7072,4.7375,3.8091-0.59893,1.8215-6.0736,0.2543,0.57468-1.7478zm1.284,0.034,2.1396,0.0416-1.748-1.2326z'/%3E %3Cpath d='m330.6,179.56-1.0037,1.6746-2.2386-0.002,1.0574,1.9732-0.9977,1.6647-1.6992-3.5978-2.0442-1.2252,0.90591-1.5115,2.0442,1.2252z'/%3E %3C/g%3E %3Cg fill='%23009b3a' stroke='%23000' stroke-width='0.1'%3E %3Cpath d='m305.58,145.3s16.052,6.9159,13.249,21.207-11.74,14.195-15.244,15.775c-3.5043,1.5793-5.9218,3.8396-7.3046,3.5235-1.3827-0.31613-3.2104-1.3832-3.2104-1.3832s-0.14627,2.3471,2.6684,2.7742,6.5145-3.7042,8.2916-4.1636c1.7771-0.45933,12.688-1.6436,15.343-16.185,3.0983-15.522-13.693-21.092-13.792-21.548z'/%3E %3Cpath d='m313.68,148.34a2.2037,0.52177,75.104,0,1,-1.0572,0.0811,2.2037,0.52177,75.104,1,1,1.0572,-0.0811z'/%3E %3Cpath d='m313.13,148.49a2.2707,0.50636,63.335,1,1,-0.95726,0.34968,2.2707,0.50636,63.335,0,1,0.95726,-0.34968z'/%3E %3Cpath d='m311.52,149.55a2.1502,0.53476,17.053,0,1,-0.10032,1.0864,2.1502,0.53476,17.053,0,1,0.10032,-1.0864z'/%3E %3Cpath d='m311.76,148.96a2.2609,0.50857,34.225,1,1,-0.46166,0.91557,2.2609,0.50857,34.225,1,1,0.46166,-0.91557z'/%3E %3Cpath d='m312.44,148.68a2.299,0.50014,46.194,1,1,-0.6989,0.71633,2.299,0.50014,46.194,0,1,0.6989,-0.71633z'/%3E %3Cpath d='m313.56,150.7c0.009,0.01-0.61928,0.34913-0.76157,0.39979-0.14231,0.0506-0.3352-0.18953-0.74445,0.0205-0.40924,0.21003-0.69016,0.59314-0.7795,0.81798-0.0893,0.22483,0.11595,0.31904,0.61058,0.0786,0.49463-0.24042,0.62481-0.62134,0.8633-0.77059,0.23847-0.14922,0.6385-0.36885,0.86618-0.44991,0.0986-0.21524,0.41874-0.67667,0.58423-0.94149,0.16549-0.2648,0.81483-0.70186,1.0512-1.2107,0.20634-0.42091,0.12886-0.77938-0.14731-0.6296-0.27617,0.14979-0.63323,0.57288-0.79951,0.87657-0.16629,0.30371-0.0235,0.69038-0.2082,0.97494-0.14547,0.2062-0.49727,0.83331-0.53495,0.83386z'/%3E %3Cpath d='m318.53,152.34a3.3048,0.7416,88.415,1,1,-1.491,-0.357,3.3048,0.7416,88.415,1,1,1.491,0.357z'/%3E %3Cpath d='m317.7,152.31a3.4427,0.71192,77.49,1,1,-1.4415,0.0724,3.4427,0.71192,77.49,1,1,1.4415,-0.0724z'/%3E %3Cpath d='m315.13,153.11a3.2071,0.7642,34.91,1,1,-0.4987,1.511,3.2071,0.7642,34.91,1,1,0.4987,-1.511z'/%3E %3Cpath d='m315.65,152.38a3.4298,0.71459,50.904,0,1,-0.94257,1.1046,3.4298,0.71459,50.904,1,1,0.94257,-1.1046z'/%3E %3Cpath d='m316.69,152.28a3.5036,0.69953,61.837,1,1,-1.2051,0.71311,3.5036,0.69953,61.837,1,1,1.2051,-0.71311z'/%3E %3Cpath d='m317.57,155.67c0.01,0.0178-0.97325,0.22286-1.1871,0.23175-0.21385,0.009-0.40144-0.42144-1.0378-0.30379-0.63631,0.11765-1.1522,0.54061-1.3504,0.82262-0.19818,0.28203,0.0549,0.50882,0.81953,0.38586,0.76463-0.12297,1.0711-0.61026,1.4508-0.71727,0.37968-0.107,1.0064-0.24252,1.3486-0.25671,0.20777-0.26415,0.80398-0.78171,1.1209-1.0869,0.31688-0.30518,1.3609-0.64054,1.8567-1.2634,0.42514-0.51046,0.43655-1.0585,0.005-0.9676-0.43208,0.0909-1.0667,0.53707-1.3975,0.89759-0.33087,0.36054-0.26112,0.97825-0.6112,1.3031-0.26974,0.23022-0.96462,0.97091-1.017,0.95483z'/%3E %3Cpath d='m321.14,159a0.73839,3.3192,8.7402,1,1,-1.3929,-0.63898,0.73839,3.3192,8.7402,1,1,1.3929,0.63898z'/%3E %3Cpath d='m320.35,158.8a3.4648,0.70737,87.95,1,1,-1.422,-0.20538,3.4648,0.70737,87.95,1,1,1.422,0.20538z'/%3E %3Cpath d='m317.69,159.1a3.2231,0.76041,46.026,1,1,-0.76003,1.3966,3.2231,0.76041,46.026,1,1,0.76003,-1.3966z'/%3E %3Cpath d='m318.33,158.48a3.4552,0.70935,61.791,1,1,-1.1206,0.90994,3.4552,0.70935,61.791,1,1,1.1206,-0.90994z'/%3E %3Cpath d='m319.35,158.58a3.5309,0.69413,72.543,1,1,-1.3065,0.47282,3.5309,0.69413,72.543,1,1,1.3065,-0.47282z'/%3E %3Cpath d='m319.61,162.09c0.006,0.0195-0.99148,0.0332-1.2021,0.00066-0.21062-0.0323-0.31635-0.49335-0.95952-0.49937-0.64317-0.006-1.2237,0.3126-1.4683,0.55307-0.24457,0.24047-0.0381,0.51308,0.73143,0.5385,0.76954,0.0255,1.157-0.39697,1.5474-0.42973,0.39042-0.0327,1.0274-0.0462,1.3644,0.005,0.25074-0.22097,0.92685-0.61761,1.2916-0.85817,0.36477-0.24055,1.4457-0.37122,2.0427-0.8912,0.50763-0.42249,0.61765-0.9616,0.17894-0.95479-0.43872,0.007-1.1395,0.32554-1.5279,0.61807-0.38843,0.29252-0.43169,0.916-0.83247,1.1696-0.30518,0.17556-1.118,0.77363-1.1663,0.74768'/%3E %3Cpath d='m321.34,166.42a0.73814,3.3203,31.311,0,1,-1.0129,-1.1684,0.73814,3.3203,31.311,0,1,1.0129,1.1684'/%3E %3Cpath d='m320.69,165.91a0.70283,3.4872,20.618,0,1,-1.2076,-0.77836,0.70283,3.4872,20.618,0,1,1.2076,0.77836'/%3E %3Cpath d='m318.17,165.09a3.2755,0.74824,69.934,0,1,-1.2303,0.98083,3.2755,0.74824,69.934,0,1,1.2303,-0.98083'/%3E %3Cpath d='m318.99,164.78a3.5112,0.69802,85.137,0,1,-1.3677,0.38052,3.5112,0.69802,85.137,1,1,1.3677,-0.38052'/%3E %3Cpath d='m319.88,165.3a0.68491,3.5784,5.5508,1,1,-1.3664,-0.10172,0.68491,3.5784,5.5508,1,1,1.3664,0.10172'/%3E %3Cpath d='m318.75,168.66c-0.002,0.0206-0.91045-0.37916-1.0886-0.4962-0.17812-0.11705-0.0948-0.58827-0.67475-0.85977-0.57992-0.2715-1.2292-0.21605-1.544-0.0942-0.31478,0.12187-0.23372,0.46002,0.45307,0.80175,0.68677,0.34174,1.2015,0.11022,1.5677,0.24126,0.36615,0.13105,0.94806,0.38192,1.2331,0.5692,0.31278-0.10125,1.0789-0.18952,1.5025-0.26178,0.42362-0.0722,1.4529,0.25346,2.1953,0.0181,0.62359-0.18191,0.93252-0.63634,0.53272-0.8114-0.39982-0.17507-1.158-0.16922-1.6232-0.0586-0.46522,0.11067-0.74646,0.67093-1.2077,0.74038-0.34444,0.0366-1.3125,0.25518-1.3461,0.21116'/%3E %3Cpath d='m319.34,173.95a0.86442,3.782,48.457,1,1,-0.73094,-1.6561,0.86442,3.782,48.457,1,1,0.73094,1.6561'/%3E %3Cpath d='m318.79,173.16a0.82109,3.9816,37.466,1,1,-1.0735,-1.296,0.82109,3.9816,37.466,1,1,1.0735,1.296'/%3E %3Cpath d='m316.29,171.34a3.8093,0.85822,86.522,1,1,-1.6766,0.63757,3.8093,0.85822,86.522,1,1,1.6766,-0.63757'/%3E %3Cpath d='m317.29,171.29a0.80649,4.0537,11.633,0,1,-1.6306,-0.0747,0.80649,4.0537,11.633,1,1,1.6306,0.0747'/%3E %3Cpath d='m318.1,172.18a0.79539,4.1102,22.119,1,1,-1.4706,-0.60655,0.79539,4.1102,22.119,1,1,1.4706,0.60655'/%3E %3Cpath d='m315.75,175.49c-0.009,0.022-0.87758-0.74786-1.0352-0.94149-0.15759-0.19362,0.089-0.68363-0.46017-1.1931-0.54912-0.50946-1.282-0.68314-1.6686-0.66249-0.38655,0.0207-0.40846,0.42323,0.23521,1.0489,0.64368,0.62564,1.2864,0.5563,1.6464,0.8334,0.35997,0.2771,0.91807,0.76453,1.1702,1.0743,0.37758,0.001,1.2499,0.18108,1.7399,0.25458,0.49005,0.0735,1.516,0.80535,2.4105,0.81412,0.74621,0.0248,1.2356-0.36504,0.85306-0.7029-0.38257-0.33788-1.219-0.60568-1.7675-0.6518-0.54847-0.0462-1.0422,0.47055-1.5728,0.38034-0.39119-0.0842-1.5286-0.19313-1.5511-0.25388'/%3E %3Cpath d='m314.17,180.54a0.96734,4.1698,79.752,1,1,0.19909,-1.9977,0.96734,4.1698,79.752,1,1,-0.19909,1.9977'/%3E %3Cpath d='m314.09,179.47a0.92321,4.3692,68.504,0,1,-0.32819,-1.8534,0.92321,4.3692,68.504,0,1,0.32819,1.8534'/%3E %3Cpath d='m312.66,176.29a0.96428,4.1831,26.238,0,1,-1.9665,-0.36332,0.96428,4.1831,26.238,1,1,1.9665,0.36332'/%3E %3Cpath d='m313.66,176.83a0.90974,4.4339,41.823,0,1,-1.533,-1.0142,0.90974,4.4339,41.823,0,1,1.533,1.0142'/%3E %3Cpath d='m313.95,178.15a0.89742,4.4948,52.671,1,1,-1.0881,-1.4274,0.89742,4.4948,52.671,0,1,1.0881,1.4274'/%3E %3Cpath d='m309.87,179.93c-0.0207,0.0157-0.43852-1.2188-0.48489-1.4941-0.0464-0.27531,0.45926-0.59874,0.20755-1.4008-0.25172-0.8021-0.86427-1.3912-1.2486-1.5951-0.38437-0.20393-0.6254,0.16627-0.34588,1.1336,0.27952,0.96728,0.9377,1.273,1.1338,1.7448,0.19607,0.47173,0.4685,1.2581,0.54266,1.6986,0.36367,0.2197,1.1074,0.89507,1.5403,1.2484,0.43283,0.35332,1.0233,1.6427,1.8819,2.1684,0.70667,0.45515,1.392,0.36743,1.2073-0.17513-0.18469-0.54259-0.84572-1.281-1.3499-1.6421-0.50418-0.36109-1.2629-0.15524-1.7257-0.54789-0.33158-0.3063-1.3698-1.0677-1.3584-1.1386'/%3E %3Cpath d='m307.4,184.24a1.2121,4.2194,89.068,0,1,0.007,-2.4245,1.2121,4.2194,89.068,0,1,-0.007,2.4245'/%3E %3Cpath d='m306.84,180.45a1.1714,4.3658,37.587,0,1,-1.7986,-1.5041,1.1714,4.3658,37.587,1,1,1.7986,1.5041'/%3E %3Cpath d='m307.43,182.38a1.1973,4.2713,66.472,0,1,-0.8567,-2.2386,1.1973,4.2713,66.472,0,1,0.8567,2.2386'/%3E %3Cpath d='m308.58,145.66a2.6209,0.53282,41.126,0,1,-0.99489,0.54201,2.6209,0.53282,41.126,1,1,0.99489,-0.54201'/%3E %3Cpath d='m307.29,146.75a2.6543,0.52611,8.1634,0,1,0.202,1.0896,2.6543,0.52611,8.1634,1,1,-0.202,-1.0896'/%3E %3Cpath d='m307.81,146.06a2.776,0.50303,26.817,1,1,-0.52645,0.86106,2.776,0.50303,26.817,0,1,0.52645,-0.86106'/%3E %3Cpath d='m288.79,180.13s3.5359,0.75834,6.6097,1.8755c3.0739,1.1172,7.7443,4.9517,8.9996,5.1689,1.4081,0.0641,3.3608-0.41654,4.1019-2.4496-2.1685,0.57838-3.4689,1.457-5.539,0.31964-0.73141-0.27703-3.1265-2.4578-5.752-3.625s-7.9208-2.4978-7.9208-2.4978l-0.49937,1.2083'/%3E %3Cpath d='m292.56,148.16c-0.0127-0.0303,4.0701-2.1474,4.0701-2.1474l-4.4882,1.1477-0.52144,0.78964,0.93955,0.21005'/%3E %3Cpath d='m296.42,149.15c-1.5758-0.28645-3.9992-0.81633-5.5421-0.9399,1.0665-1.1813,2.536-3.1789,3.4417-4.4051-0.59804,1.1695-1.5368,2.7117-1.9073,3.8312,1.0862,0.5863,2.7936,1.0454,4.0078,1.5138'/%3E %3Cpath d='m291.83,148.41c-0.0177-0.0279,3.6168-2.8004,3.6168-2.8004l-4.2006,1.8792-0.37387,0.86847,0.95766,0.0527'/%3E %3Cpath d='m295.69,149.11c-1.5867-0.30167-4.0287-0.85794-5.5794-0.99119,1.0478-1.2168,2.4844-3.2756,3.3699-4.5394-0.57788,1.2063-1.4906,2.7965-1.8411,3.952,1.1012,0.60975,2.8232,1.0903,4.0506,1.5786'/%3E %3Cpath d='m291.23,148.64c-0.01-0.0311,4.2591-1.7838,4.2591-1.7838l-4.5864,0.75479-0.59212,0.73968,0.91942,0.28937'/%3E %3Cpath d='m295.21,149.15c-1.6049-0.13379-4.0856-0.43321-5.635-0.39973,0.89323-1.351,2.0721-3.6004,2.7993-4.9815-0.42971,1.2892-1.1454,3.0051-1.3563,4.2178,1.1608,0.49985,2.9206,0.80072,4.192,1.1634'/%3E %3Cpath d='m290.79,148.66c-0.0233-0.0237,2.8854-3.5159,2.8854-3.5159l-3.6561,2.7338-0.16967,0.93251,0.9404-0.1504'/%3E %3Cpath d='m295.19,149.38c-1.7196-0.0327-4.3869-0.18429-6.0307-0.0383,0.81363-1.5376,1.8405-4.0759,2.4746-5.6347-0.32708,1.4374-0.91528,3.3608-1.0174,4.6992,1.2844,0.46358,3.1854,0.66769,4.5735,0.97377'/%3E %3Cpath d='m290.21,149.49c-0.0223-0.0308,3.5039-3.3619,3.5039-3.3619l-4.2398,2.3458-0.29039,1.0048,1.0262,0.0113'/%3E %3Cpath d='m294.42,149.49c-1.848,0.007-4.6936-0.0933-6.4968,0.10867,1.1962-1.7142,2.8298-4.536,3.8367-6.269-0.65065,1.5916-1.6836,3.725-2.0711,5.2021,1.2892,0.47854,3.2974,0.65581,4.7312,0.95826'/%3E %3Cpath d='m289.03,149.74c-0.0176-0.0333,4.476-3.7911,4.476-3.7911l-5.0591,2.6902-0.52142,1.1141,1.1046-0.0132'/%3E %3Cpath d='m293.75,149.6c-1.83,0.26391-4.6638,0.56204-6.4216,1.0097,0.93966-1.8374,2.154-4.8155,2.9034-6.6449-0.41668,1.6421-1.1346,3.8655-1.3069,5.3593,1.346,0.28713,3.3611,0.18057,4.8251,0.27594'/%3E %3Cpath d='m288.43,150.49c-0.0259-0.0268,3.4487-4.7769,3.4487-4.7769l-4.3038,3.8915-0.23064,1.1922,1.0858-0.3068'/%3E %3Cpath d='m292.74,150.17c-1.8426,0.17159-4.6899,0.32693-6.4707,0.68564,1.0418-1.7872,2.4221-4.6995,3.2735-6.4883-0.50848,1.6185-1.3505,3.8022-1.6066,5.2848,1.3282,0.35426,3.347,0.34906,4.8038,0.51778'/%3E %3Cpath d='m287.81,150.99c-0.0179-0.0338,4.3902-3.7991,4.3902-3.7991l-4.981,2.6844-0.50347,1.1213,1.0943-0.007'/%3E %3Cpath d='m292.2,150.36c-1.837,0.38744-4.6873,0.87846-6.4421,1.442,0.85827-1.8764,1.9372-4.8962,2.6036-6.7515-0.33926,1.6475-0.95401,3.8889-1.0536,5.3732,1.3752,0.18936,3.4073-0.0559,4.8922-0.0637'/%3E %3Cpath d='m287.08,151.19c-0.03-0.0213,2.8045-5.2073,2.8045-5.2073l-3.7959,4.5028-0.0628,1.1897,1.0542-0.48522'/%3E %3Cpath d='m292.2,150.66c-1.9709,0.51269-5.0424,1.1852-6.9015,1.891,0.71391-2.1333,1.5308-5.5533,2.0364-7.6546-0.17164,1.855-0.57348,4.3854-0.5018,6.0476,1.534,0.1517,3.7366-0.21064,5.367-0.28402'/%3E %3Cpath d='m286.53,152.39c-0.0298-0.0303,3.5334-5.2185,3.5334-5.2185l-4.5179,4.2179-0.1906,1.3165,1.1751-0.31589'/%3E %3Cpath d='m291.42,151.25c-1.9374,0.61271-4.9624,1.4426-6.7795,2.2401,0.61082-2.1464,1.264-5.5698,1.669-7.6734-0.0842,1.8422-0.36592,4.3642-0.21696,6.0029,1.5335,0.0673,3.7084-0.40931,5.3275-0.56959'/%3E %3Cpath d='m285.82,153.16c-0.0343-0.0242,2.6855-5.7607,2.6855-5.7607l-3.8184,4.9613,0.0173,1.3246,1.1156-0.52521'/%3E %3Cpath d='m290.68,152.04c-1.9847,0.45234-5.0722,1.0322-6.9539,1.6786,0.80306-2.0896,1.7642-5.4488,2.3585-7.5126-0.25108,1.8295-0.76055,4.3205-0.76099,5.9662,1.5208,0.19251,3.7297-0.10474,5.3564-0.13211'/%3E %3Cpath d='m285.18,153.71c-0.0238-0.0354,4.3881-4.5082,4.3881-4.5082l-5.173,3.338-0.42128,1.2662,1.2062-0.0961'/%3E %3Cpath d='m289.8,152.82c-1.966,0.26388-5.0168,0.54834-6.8942,1.02,0.91275-2.0472,2.058-5.3709,2.7652-7.4125-0.3577,1.8371-1.0084,4.3219-1.1101,5.9967,1.4734,0.34649,3.6488,0.26266,5.239,0.39584'/%3E %3Cpath d='m284.31,153.26c-0.0323-0.0271,2.9857-5.6409,2.9857-5.6409l-4.0499,4.7466-0.0631,1.3441,1.1273-0.44976'/%3E %3Cpath d='m290.04,152.15c-2.1381,0.87557-5.4778,2.0958-7.4812,3.1751,0.65695-2.5384,1.3495-6.5596,1.7791-9.0308-0.077,2.141-0.36647,5.0863-0.18727,6.9715,1.6973-0.0533,4.0995-0.7916,5.8893-1.1159'/%3E %3Cpath d='m283.9,154.97c-0.0346-0.0302,3.5737-6.4733,3.5737-6.4733l-4.7176,5.4774-0.13032,1.5296,1.2742-0.53369'/%3E %3Cpath d='m289.22,152.95c-2.0951,0.9847-5.3742,2.3775-7.3258,3.5553,0.5427-2.5381,1.0549-6.539,1.3737-8.998,0.0186,2.1135-0.13932,5.0315,0.1235,6.8784,1.6918-0.14952,4.0566-1.014,5.8286-1.4358'/%3E %3Cpath d='m283.17,155.95c-0.0392-0.0225,2.6078-6.9665,2.6078-6.9665l-3.9029,6.222,0.099,1.5082,1.1961-0.76364'/%3E %3Cpath d='m288.3,153.53c-2.0902,1.0013-5.3626,2.4201-7.3079,3.6131,0.5268-2.5408,1.0138-6.543,1.317-9.0029,0.0321,2.1119-0.10721,5.0291,0.1676,6.8726,1.6919-0.16336,4.0527-1.0468,5.8233-1.4828'/%3E %3Cpath d='m282.58,156.78c-0.0319-0.0338,4.0345-6.1433,4.0345-6.1433l-5.0869,5.0282-0.24792,1.5233,1.3003-0.40818'/%3E %3Cpath d='m288.11,153.21c-1.8636,1.4877-4.8118,3.6746-6.4923,5.3092-0.003-2.5647-0.34635-6.5176-0.55367-8.9482,0.46762,2.0126,0.93175,4.8392,1.5844,6.5336,1.642-0.58507,3.7979-2.0286,5.4615-2.8945'/%3E %3Cpath d='m282.78,157.07c-0.0447-0.006,0.46739-7.3613,0.46739-7.3613l-1.9438,7.1568,0.54238,1.3482,0.934-1.1436'/%3E %3Cpath d='m287.58,153.89c-1.869,1.4782-4.8251,3.6499-6.5118,5.2759,0.008-2.5657-0.3191-6.522-0.51623-8.9546,0.45907,2.0159,0.91126,4.8461,1.5566,6.5446,1.6438-0.57637,3.8048-2.0088,5.4714-2.866'/%3E %3Cpath d='m282.31,158.32c-0.0416-0.0175,1.8801-7.1926,1.8801-7.1926l-3.2533,6.6145,0.2567,1.4768,1.1165-0.89863'/%3E %3Cpath d='m287.37,154.06c-1.7662,1.74-4.5782,4.3217-6.1396,6.1914-0.27684-2.6316-1.0544-6.6488-1.5284-9.1194,0.6982,2.0118,1.4798,4.8594,2.3351,6.5234,1.6338-0.78834,3.7067-2.5165,5.3328-3.5955'/%3E %3Cpath d='m282.32,159.24c-0.0462-0.007,0.35192-7.6498,0.35192-7.6498l-1.8789,7.4327,0.58349,1.4029,0.94347-1.1858'/%3E %3Cpath d='m286.81,155.33c-1.8902,1.5628-4.8841,3.862-6.5822,5.5756-0.0591-2.665-0.50061-6.7694-0.76796-9.2932,0.52674,2.0871,1.0678,5.0201,1.7784,6.7748,1.6814-0.62281,3.8742-2.1423,5.5718-3.0572'/%3E %3Cpath d='m281.76,160.11c-0.0403-0.0248,2.6632-7.1952,2.6632-7.1952l-3.9937,6.3751,0.10446,1.5793,1.226-0.75915'/%3E %3Cpath d='m286.78,155.36c-1.6729,1.7696-4.3365,4.3957-5.8152,6.2962-0.2642-2.6676-1.004-6.7388-1.4549-9.2426,0.66316,2.038,1.406,4.9231,2.2178,6.6079,1.5481-0.80419,3.5117-2.5626,5.0523-3.6616'/%3E %3Cpath d='m281.86,160.48c-0.0468-0.00066-0.31503-7.607-0.31503-7.607l-1.2318,7.5764,0.70623,1.3169,0.84065-1.2864'/%3E %3Cpath d='m285.96,155.93c-1.6186,1.7855-4.2014,4.4366-5.6223,6.3515-0.34233-2.6683-1.2009-6.7377-1.7249-9.2404,0.72226,2.0346,1.549,4.9167,2.4093,6.5966,1.5223-0.81796,3.4317-2.5947,4.9379-3.7076'/%3E %3Cpath d='m281.43,161.24c-0.0429-0.0127,0.84948-7.7276,0.84948-7.7276l-2.2658,7.3094,0.45158,1.5011,0.96479-1.0828'/%3E %3Cpath d='m285.61,156.23c-1.4798,1.9335-3.8561,4.822-5.1287,6.865-0.54421-2.6206-1.71-6.5845-2.4229-9.0227,0.87524,1.9534,1.919,4.7394,2.9052,6.3264,1.4572-0.96185,3.2278-2.915,4.6464-4.1687'/%3E %3Cpath d='m281.4,161.96c-0.0443-0.002-0.49032-7.737-0.49032-7.737l-0.97414,7.6757,0.70154,1.3522,0.76292-1.2909'/%3E %3Cpath d='m285.46,156.67c-1.3891,2.0246-3.6307,5.0578-4.806,7.1817-0.67929-2.6103-2.051-6.5406-2.8906-8.9584,0.97816,1.921,2.1678,4.6717,3.2389,6.218,1.4155-1.045,3.0957-3.1045,4.4578-4.4413'/%3E %3Cpath d='m281.88,162.68c-0.0433-0.0142,0.78724-7.7718,0.78724-7.7718l-2.2149,7.3052,0.46702,1.529,0.96068-1.0624'/%3E %3Cpath d='m285.18,157.39c-1.1974,2.206-3.1506,5.5334-4.1267,7.8084-0.90975-2.5008-2.6261-6.2176-3.6778-8.5047,1.1445,1.7739,2.5738,4.3433,3.7769,5.7318,1.3118-1.2357,2.7952-3.517,4.0276-5.0355'/%3E %3Cpath d='m281.61,163.32c-0.0435,0.0121-2.172-7.3702-2.172-7.3702l0.73403,7.7686,0.97861,1.0955,0.45931-1.4939'/%3E %3Cpath d='m285.13,158.25c-1.2476,2.1993-3.2806,5.5166-4.3014,7.7848-0.91524-2.4932-2.6498-6.1988-3.7125-8.479,1.1622,1.7686,2.6107,4.3302,3.836,5.7144,1.3575-1.232,2.8996-3.5064,4.1778-5.0202'/%3E %3Cpath d='m281.71,164.71c-0.0459,0.00002-0.79743-7.7496-0.79743-7.7496l-0.71779,7.7504,0.77557,1.3281,0.73965-1.329'/%3E %3Cpath d='m285.26,158.93c-1.2828,2.1698-3.3689,5.4389-4.4262,7.6828-0.87461-2.5145-2.5487-6.2606-3.5741-8.5656,1.1332,1.7957,2.5398,4.3912,3.7424,5.8042,1.3771-1.1999,2.9555-3.4378,4.2579-4.9214'/%3E %3Cpath d='m281.64,165.33c-0.0457,0.005-1.438-7.6104-1.438-7.6104l-0.0703,7.7943,0.88248,1.2271,0.62581-1.411'/%3E %3Cpath d='m284.71,160.03c-1.3837,2.078-3.6216,5.1981-4.7836,7.3658-0.7531-2.5716-2.2454-6.4286-3.1591-8.8014,1.0454,1.8718,2.3257,4.5611,3.4586,6.0554,1.4316-1.1029,3.1136-3.2284,4.4842-4.6198'/%3E %3Cpath d='m280.97,166.18c-0.0447-0.0122,0.64352-7.779,0.64352-7.779l-2.1198,7.3762,0.51212,1.5034,0.96413-1.1006'/%3E %3Cpath d='m284.79,160.22c-1.1829,2.2504-3.1184,5.6512-4.0726,7.9608-0.98749-2.4525-2.8292-6.0817-3.9579-8.315,1.2132,1.7179,2.7357,4.2162,4.0008,5.5474,1.321-1.2885,2.7961-3.6264,4.0297-5.1932'/%3E %3Cpath d='m280.71,166.83c-0.0445,0.0139-2.3872-7.25-2.3872-7.25l0.91887,7.7096,1.0284,1.0491,0.44002-1.5087'/%3E %3Cpath d='m284.47,160.8c-0.82599,2.4697-2.2198,6.234-2.8118,8.7118-1.3408-2.1938-3.6994-5.3571-5.1462-7.3047,1.4525,1.4228,3.3268,3.5446,4.7723,4.5761,1.1066-1.5547,2.207-4.1742,3.1857-5.9832'/%3E %3Cpath d='m282.83,167.42c-0.0441,0.0157-2.5849-7.1499-2.5849-7.1499l1.1296,7.6676,1.0567,1.0074,0.39853-1.5251'/%3E %3Cpath d='m284.45,161.56c-0.80817,2.4781-2.1748,6.2568-2.7489,8.7406-1.3566-2.1795-3.7381-5.3178-5.199-7.2501,1.4628,1.4074,3.3524,3.5094,4.8054,4.5256,1.0954-1.5662,2.1769-4.197,3.1425-6.0161'/%3E %3Cpath d='m282.85,168.64c-0.0421,0.0224-3.3258-6.6866-3.3258-6.6866l1.9368,7.4247,1.1558,0.83503,0.23325-1.5732'/%3E %3Cpath d='m284.2,162.18c-0.5167,2.5726-1.4378,6.5146-1.7217,9.0594-1.5966-1.9663-4.3201-4.7362-5.9916-6.4424,1.613,1.1856,3.7295,2.9986,5.2878,3.7978,0.90653-1.7097,1.6769-4.4729,2.4255-6.4148'/%3E %3Cpath d='m283.07,169.69c-0.0454,0.009-1.7934-7.4979-1.7934-7.4979l0.29571,7.7844,0.9389,1.1646,0.55876-1.451'/%3E %3Cpath d='m284.21,162.98c-0.27334,2.6303-0.82051,6.6781-0.86543,9.2492-1.7668-1.7422-4.7264-4.1325-6.5433-5.6057,1.7105,0.96289,3.9788,2.4825,5.5991,3.0682,0.74032-1.8239,1.2476-4.678,1.8097-6.7117'/%3E %3Cpath d='m283.16,170.24c-0.0354,0.0346-4.7406-5.413-4.7406-5.413l3.5722,6.556,1.3053,0.44601-0.1369-1.589'/%3E %3Cpath d='m284.31,163.9c-0.2837,2.6285-0.84683,6.6728-0.90187,9.2435-1.76-1.7521-4.7104-4.1591-6.5216-5.6425,1.7068,0.97255,3.9692,2.505,5.5873,3.0998,0.74754-1.8195,1.266-4.6705,1.8362-6.7008'/%3E %3Cpath d='m283.69,171.49c-0.041,0.0242-3.6411-6.525-3.6411-6.525l2.2874,7.3243,1.195,0.78156,0.15873-1.5808'/%3E %3Cpath d='m284.52,164.98c-0.17301,2.6443-0.56557,6.7207-0.5128,9.2934-1.8299-1.6444-4.8751-3.8712-6.7449-5.244,1.7442,0.8685,4.0662,2.2628,5.7059,2.7592,0.66981-1.8639,1.0678-4.7448,1.5518-6.8086'/%3E %3Cpath d='m284.15,172.69c-0.0369,0.0323-4.4987-5.7041-4.4987-5.7041l3.2806,6.7699,1.2848,0.52845-0.0667-1.5943'/%3E %3Cpath d='m284.57,166.2c-0.15709,2.646-0.52509,6.7261-0.45686,9.2986-1.8395-1.6286-4.8978-3.829-6.7755-5.1857,1.7491,0.8534,4.0793,2.2276,5.7218,2.7098,0.65851-1.8699,1.0392-4.7545,1.5106-6.8227'/%3E %3Cpath d='m284.56,173.66c-0.0427,0.0197-3.1543-6.877-3.1543-6.877l1.7456,7.5287,1.1347,0.90411,0.274-1.5558'/%3E %3Cpath d='m284.69,166.99c0.0903,2.655,0.10463,6.7657,0.41156,9.317-1.9764-1.3734-5.215-3.1518-7.2041-4.2492,1.8146,0.6139,4.2541,1.668,5.9284,1.9268,0.4794-1.9499,0.58873-4.8724,0.86412-6.9945'/%3E %3Cpath d='m285.11,173.39c-0.0266,0.0435-5.7616-3.9448-5.7616-3.9448l4.8844,5.3824,1.3575,0.0701-0.4804-1.5077'/%3E %3Cpath d='m284.87,167.27c0.22922,2.6428,0.45861,6.7394,0.89939,9.2707-2.0509-1.2942-5.3868-2.9444-7.4359-3.9631,1.8492,0.54333,4.347,1.5018,6.0371,1.6964,0.37805-1.9616,0.3347-4.8786,0.49945-7.0041'/%3E %3Cpath d='m285.73,174.86c-0.0353,0.0336-4.8006-5.5183-4.8006-5.5183l3.636,6.6258,1.314,0.47899-0.14944-1.5865'/%3E %3Cpath d='m285.29,168.28c0.34006,2.6317,0.74172,6.7188,1.2879,9.2262-2.0982-1.1719-5.4919-2.6228-7.5767-3.5191,1.8655,0.43245,4.3949,1.2414,6.0871,1.3344,0.29381-1.9864,0.12737-4.9038,0.20173-7.0415'/%3E %3Cpath d='m286.69,175.79c-0.0271,0.0431-5.7175-4.0403-5.7175-4.0403l4.8227,5.4618,1.3574,0.0933-0.4626-1.5148'/%3E %3Cpath d='m285.47,169.4c0.51244,2.6008,1.1827,6.6519,1.8915,9.1088-2.1618-0.97386-5.6288-2.1041-7.7589-2.8035,1.8815,0.25605,4.4475,0.82589,6.1344,0.75872,0.15996-2.0152-0.19901-4.9183-0.26704-7.0641'/%3E %3Cpath d='m287.32,176.59c-0.0357,0.0328-4.729-5.6059-4.729-5.6059l3.5489,6.6901,1.3083,0.50387-0.12812-1.588'/%3E %3Cpath d='m285.78,170.12c0.75054,2.5293,1.7931,6.4861,2.7243,8.8454-2.2284-0.68355-5.7618-1.3487-7.9333-1.7623,1.8841,0.004,4.4741,0.22995,6.1355-0.0628-0.0309-2.0343-0.65805-4.8861-0.92656-7.0203'/%3E %3Cpath d='m287.57,176.6c-0.01,0.0517-6.6064-1.4152-6.6064-1.4152l6.2826,3.1233,1.2691-0.47761-0.94521-1.2305'/%3E %3Cpath d='m286.21,170.91c0.74065,2.533,1.7677,6.4948,2.6898,8.8588-2.2262-0.696-5.7576-1.381-7.9279-1.8067,1.8844,0.0147,4.4742,0.25521,6.137-0.0281-0.0228-2.034-0.63878-4.8887-0.89888-7.024'/%3E %3Cpath d='m288.65,177.3c-0.0197,0.0468-6.3209-3.0528-6.3209-3.0528l5.6692,4.5959,1.3583-0.12728-0.70667-1.4158'/%3E %3Cpath d='m285.88,171.35c1.2554,2.3082,3.0909,5.9481,4.4875,8.0501-2.3158-0.17673-5.9011-0.0474-8.1055,0.0273,1.8392-0.41187,4.4133-0.76254,5.9739-1.4156-0.45081-1.9829-1.6525-4.6337-2.3559-6.6618'/%3E %3Cpath d='m289.65,177.99c-0.0123,0.0508-6.5681-1.814-6.5681-1.814l6.1642,3.4904,1.2962-0.39585-0.89236-1.2805'/%3E %3Cpath d='m286.56,172.33c1.2689,2.2992,3.1258,5.9263,4.5345,8.0181-2.3151-0.15736-5.8968,0.002-8.099,0.0956,1.8352-0.42766,4.4051-0.80025,5.9604-1.4669-0.4629-1.9805-1.6803-4.6231-2.3958-6.6467'/%3E %3Cpath d='m290.48,178.53c-0.0234,0.0441-6.1205-3.6614-6.1205-3.6614l5.3476,5.1176,1.3751,0.0136-0.60219-1.4699'/%3E %3Cpath d='m287.07,172.91c1.4696,2.146,3.6456,5.55,5.2323,7.4692-2.2891,0.14354-5.7916,0.77074-7.9455,1.1516,1.761-0.66908,4.2489-1.3786,5.7118-2.2514-0.64696-1.9306-2.0993-4.4284-2.9986-6.3694'/%3E %3Cpath d='m290.93,179.07c-0.002,0.0538-6.6066-0.15568-6.6066-0.15568l6.5361,1.9315,1.1622-0.72207-1.0918-1.0538'/%3E %3Cpath d='m294.76,147.06c0.00065-0.0206,4.7533-0.79299,4.7533-0.79299l-4.7291,0.11031-0.82503,0.42379,0.80086,0.25889'/%3E %3Cpath d='m297.37,148.07c-1.3791-0.41674-3.4631-1.1148-4.8787-1.4225,1.5043-0.59791,3.7307-1.6585,5.1008-2.309-1.0541,0.65981-2.5868,1.5076-3.4038,2.1691,0.78925,0.5361,2.2218,1.0828,3.1818,1.5624'/%3E %3Cpath d='m294.55,147.22c-0.005-0.0199,4.5986-1.2633,4.5986-1.2633l-4.7642,0.6073-0.7185,0.49317,0.88409,0.16283'/%3E %3Cpath d='m297.59,148.41c-1.6114-0.15181-4.0828-0.46088-5.6728-0.47676,1.198-1.0608,2.8775-2.8356,3.9121-3.9252-0.71132,1.024-1.805,2.3829-2.2765,3.3514,1.0804,0.43367,2.8148,0.724,4.0372,1.0505'/%3E %3Cpath d='m292.84,147.55c0.004-0.0209,4.7795-0.53969,4.7795-0.53969l-4.657-0.14908-0.87096,0.38293,0.74852,0.30584'/%3E %3Cpath d='m296.38,148.59c-1.4653-0.28018-3.6918-0.76832-5.174-0.94216,1.4082-0.69122,3.4606-1.8807,4.7239-2.6105-0.94322,0.71246-2.3349,1.6427-3.0389,2.3371,0.89228,0.44221,2.4349,0.84107,3.489,1.2156'/%3E %3Cpath d='m292.43,147.5c-0.0121-0.018,4.207-1.8106,4.207-1.8106l-4.6079,1.2163-0.55216,0.56093,0.95306,0.0333'/%3E %3Cpath d='m296.24,149.12c-1.2194-0.5036-3.0876-1.3567-4.294-1.7117,0.93412-0.86906,2.2505-2.3921,3.0614-3.3263-0.56395,0.93353-1.4259,2.1406-1.8066,3.0664,0.80976,0.68926,2.1192,1.3658,3.0392,1.9717'/%3E %3Cpath d='m292.67,147.81c-0.009-0.0282,3.2732-1.4184,3.2732-1.4184l-3.5645,0.48835-0.43827,0.63528,0.72961,0.29475'/%3E %3Cpath d='m289.93,178.46c0.003,0.0524-6.7834,0.0512-6.7834,0.0512l6.8687,1.6793,1.1269-0.73842-1.2122-0.99207'/%3E %3Cpath d='m291.15,178.9c-0.008,0.0497-6.8895-1.6024-6.8895-1.6024l6.6159,3.2432,1.2964-0.41713-1.0228-1.2237'/%3E %3Cpath d='m292.28,179.36c-0.00001,0.052-6.8397-0.34479-6.8397-0.34479l6.8394,2.0617,1.1727-0.66479-1.1723-1.0521'/%3E %3Cpath d='m287.94,174.53c1.7794,1.9611,4.4452,5.086,6.3123,6.8152-2.2976,0.34709-5.7574,1.2758-7.8858,1.8423,1.6915-0.81215,4.1133-1.7294,5.4752-2.7134-0.91749-1.8253-2.7273-4.1313-3.9017-5.944'/%3E %3Cpath d='m293.22,179.71c-0.0125,0.0479-6.8369-2.2373-6.8369-2.2373l6.4245,3.8199,1.3459-0.28376-0.9335-1.2989'/%3E %3Cpath d='m288.57,174.98c1.9393,1.7687,4.8642,4.6079,6.8646,6.1309-2.2015,0.63398-5.474,2.0002-7.4877,2.8357,1.5623-1.0308,3.8248-2.2579,5.0481-3.4224-1.0855-1.737-3.0907-3.8515-4.425-5.5442'/%3E %3Cpath d='m293.78,180.13c0.0106,0.0527-6.4875,1.2757-6.4875,1.2757l6.8362,0.46588,0.96514-0.95299-1.3138-0.78855'/%3E %3Cpath d='m292.43,179.72c0.007,0.0521-6.7667,0.51919-6.7667,0.51919l6.9817,1.1997,1.0693-0.81376-1.2844-0.90516'/%3E %3Cpath d='m293.68,180.08c-0.005,0.0501-6.9968-1.1217-6.9968-1.1217l6.8468,2.776,1.2626-0.50524-1.1127-1.1491z'/%3E %3Cpath d='m294.84,180.46c0.004,0.0518-6.8526,0.12836-6.8526,0.12836l6.9812,1.5829,1.1205-0.74354-1.2491-0.96772z'/%3E %3Cpath d='m290.14,175.94c1.9233,1.8319,4.8186,4.7625,6.812,6.3572-2.2671,0.5045-5.6507,1.669-7.7325,2.3804,1.6273-0.92621,3.9756-2.0076,5.261-3.0824-1.0528-1.756-3.0324-3.9295-4.3406-5.6552z'/%3E %3Cpath d='m295.81,180.74c-0.009,0.0487-6.9919-1.7581-6.9919-1.7581l6.6991,3.364,1.3221-0.37572-1.0293-1.2302z'/%3E %3Cpath d='m290.81,176.34c2.0685,1.6291,5.201,4.2571,7.3119,5.637-2.1497,0.78383-5.3134,2.3714-7.2605,3.3431,1.4819-1.1352,3.648-2.5144,4.7815-3.7595-1.2138-1.6564-3.374-3.6256-4.8329-5.2206z'/%3E %3Cpath d='m296.4,181.12c0.0145,0.0519-6.3794,1.7192-6.3794,1.7192l6.8581-0.007,0.89174-1.0165-1.3705-0.6953z'/%3E %3C/g%3E %3Cpath d='m305.21,171.52-5.2112-3.6015-5.2113,3.6015,1.9542-5.7624-4.5599-3.6016,5.8626,0,1.9542-5.7624,1.9542,5.7624,5.8626,0-4.5598,3.6016,1.9542,5.7624z' fill='%23fedf00' stroke='%23000' stroke-width='0.298846'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='800' height='500'%3E %3Crect fill='%234AADD6' width='800' height='500'/%3E %3Ccircle fill='%23FFDE00' cx='350' cy='250' r='150'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='400'%3E %3Crect width='600' height='400' fill='%23f00'/%3E %3Crect width='240' height='400' fill='%23060'/%3E %3Cg fill='%23ff0' fill-rule='evenodd' stroke='%23000' stroke-width='0.573' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m318.24,262.04c-30.21-0.91-168.74-87.38-169.69-101.15l7.6496-12.757c13.741,19.966,155.36,104.06,169.27,101.08l-7.2299,12.823'/%3E %3Cpath d='m154.59,146.4c-2.7101,7.2937,36.149,31.318,82.903,59.754,46.752,28.434,87.065,46.006,90.053,43.486,0.18256-0.32544,1.4701-2.5409,1.352-2.5232-0.56001,0.84402-1.9234,1.1104-4.0506,0.49741-12.631-3.6433-45.575-18.765-86.374-43.506-40.798-24.743-76.294-47.544-81.811-57.232-0.38363-0.67116-0.65702-1.8962-0.60146-2.8487l-0.13405-0.002-1.1747,2.0532-0.16139,0.32191h-0.00088zm164.36,116.04c-0.51238,0.92957-1.4675,0.96044-3.2816,0.76112-11.3-1.2506-45.589-17.925-86.162-42.213-47.21-28.26-86.2-54.01-81.97-60.74l1.1509-2.0346,0.22665,0.0706c-3.8037,11.405,76.948,57.578,81.702,60.522,46.724,28.947,86.115,45.851,89.601,41.458l-1.2682,2.181v-0.002z'/%3E %3Cpath d='m240.17,169.23c30.237-0.23901,67.55-4.1319,89.023-12.69l-4.6265-7.5168c-12.692,7.0247-50.21,11.644-84.652,12.335-40.736-0.37483-69.49-4.1681-83.897-13.835l-4.3672,8.0045c26.484,11.207,53.623,13.587,88.52,13.703'/%3E %3Cpath d='m330.44,156.71c-0.73904,1.1818-14.743,6.0113-35.373,9.5753-13.988,2.1325-32.234,3.9555-55.004,3.9776-21.633,0.0203-39.305-1.5196-52.684-3.3329-21.656-3.3955-32.833-8.1201-36.965-9.7896,0.39509-0.78581,0.64908-1.337,1.0301-2.0708,11.895,4.736,23.124,7.5918,36.279,9.6158,13.291,1.8,30.75,3.362,52.276,3.3417,22.664-0.0229,40.709-1.9844,54.616-4.0534,21.155-3.4122,32.711-7.8034,34.334-9.8425l1.494,2.5788h-0.002zm-4.0603-7.6226c-2.293,1.8415-13.718,5.8932-33.819,9.1034-13.415,1.9226-30.472,3.6433-52.265,3.6645-20.704,0.0203-37.619-1.375-50.485-3.2491-20.414-2.6661-31.279-7.4754-35.196-8.8776,0.3898-0.67381,0.78666-1.3423,1.1941-2.0135,3.0479,1.5346,13.533,5.7909,34.226,8.7224,12.72,1.8036,29.661,3.1477,50.262,3.1265,21.69-0.0221,38.553-1.7762,51.883-3.6883,20.205-2.7799,31.077-7.9472,32.728-9.241l1.4728,2.4509v0.002z'/%3E %3Cpath d='m140.88,205.66c18.598,10.003,59.905,15.044,98.994,15.391,35.591,0.0564,81.958-5.5016,99.297-14.69l-0.47712-10.012c-5.4246,8.4773-55.113,16.609-99.206,16.276-44.093-0.3325-85.038-7.1429-98.687-15.959l0.0794,8.9914'/%3E %3Cpath d='m340.12,204.22,0.00088,2.3874c-2.606,3.1159-18.946,7.8255-39.437,11.142-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7163-58.148-4.0014-23.529-3.4264-38.579-9.4262-41.6-11.217l0.0132-2.7852c9.0748,6.0334,33.661,10.447,41.917,11.798,14.788,2.2701,33.868,3.9732,57.817,3.9732,25.216,0,45.434-1.7912,60.931-4.1663,14.701-2.1237,35.644-7.6465,39.767-11.324h0.00088zm0.01-8.4922,0.00088,2.3874c-2.606,3.1142-18.946,7.8237-39.437,11.14-15.595,2.391-35.927,4.1945-61.262,4.1945-24.069,0-43.263-1.7145-58.148-4.0014-23.529-3.4246-38.579-9.4245-41.6-11.216l0.0132-2.7852c9.0748,6.0325,33.661,10.447,41.917,11.796,14.788,2.2719,33.868,3.9758,57.817,3.9758,25.216,0,45.434-1.7921,60.931-4.169,14.701-2.1237,35.644-7.6465,39.767-11.324l0.00088,0.002z'/%3E %3Cpath d='m239.79,260.32c-42.772-0.25489-79.421-11.659-87.16-13.544l5.6433,8.8344c13.67,5.7503,49.424,14.32,81.927,13.371,32.504-0.94809,60.91-3.466,80.928-13.211l5.7862-9.1555c-13.642,6.425-60.068,13.639-87.125,13.705'/%3E %3Cpath stroke-width='0.55' d='m323.3,253.72c-0.85016,1.2991-1.7171,2.5823-2.5963,3.8294-9.4417,3.3293-24.319,6.8245-30.597,7.844-12.824,2.6423-32.665,4.594-50.274,4.6029-37.89-0.55474-68.905-7.9719-83.496-14.299l-1.1773-2.0241,0.19225-0.30427,1.9966,0.77435c25.948,9.2834,55.091,12.987,82.698,13.652,17.538,0.0617,35.095-2.01,49.292-4.5491,21.771-4.3621,30.574-7.65,33.275-9.1405l0.68701-0.38541h-0.00088zm5.0172-8.2753c0.022,0.0256,0.0441,0.0503,0.0653,0.0776-0.63585,1.0733-1.2911,2.1652-1.9622,3.2623-5.0357,1.8-18.702,5.7988-38.659,8.5893-13.149,1.7912-21.322,3.526-47.479,4.034-49.015-1.2471-80.75-10.831-88.289-13.195l-1.1174-2.1431c28.406,7.4154,57.422,12.592,89.408,13.121,23.931-0.50976,34.112-2.2719,47.152-4.0499,23.271-3.6186,34.996-7.4498,38.515-8.5558-0.0441-0.0635-0.0961-0.13053-0.15433-0.19932l2.5231-0.9428-0.002,0.002z'/%3E %3Cpath d='m328.83,197.76c0.13873,28.137-14.26,53.386-25.858,64.525-16.408,15.759-38.163,25.896-63.569,26.363-28.37,0.52117-55.12-17.974-62.295-26.099-14.028-15.885-25.449-36.057-25.815-63.243,1.7376-30.709,13.793-52.1,31.268-66.769s40.743-21.813,60.121-21.302c22.358,0.59003,48.475,11.558,66.521,33.332,11.823,14.266,16.943,29.748,19.627,53.193zm-89.186-96.342c54.485,0,99.296,44.338,99.296,98.703,0,54.364-44.811,98.704-99.296,98.704s-98.924-44.339-98.924-98.704,44.439-98.703,98.924-98.703'/%3E %3Cpath d='m239.91,101.08c54.534,0,99.011,44.483,99.011,99.022,0,54.538-44.478,99.02-99.011,99.02-54.534,0-99.011-44.481-99.011-99.02s44.478-99.022,99.011-99.022zm-96.832,99.0224c0,53.26,43.736,96.842,96.832,96.842,53.097,0,96.833-43.582,96.833-96.842,0-53.262-43.737-96.844-96.833-96.844s-96.832,43.584-96.832,96.844z'/%3E %3Cpath d='m239.99,109.31c49.731,0,90.693,40.821,90.693,90.704,0,49.884-40.963,90.703-90.693,90.703s-90.693-40.819-90.693-90.703c0-49.883,40.964-90.704,90.693-90.704zm-88.515,90.7034c0,48.685,39.979,88.524,88.515,88.524s88.515-39.839,88.515-88.524c0-48.686-39.978-88.525-88.515-88.525-48.536,0-88.515,39.839-88.515,88.525z'/%3E %3Cpath d='m243.98,100.68-8.48545,0,0.01,198.96,8.51455,0z'/%3E %3Cpath d='m243.13,99.546h2.1598l0.0185,201.25h-2.1616l-0.0159-201.25zm-8.4213,0.0018h2.1766l0.003,201.25h-2.1783v-201.25z'/%3E %3Cpath d='m338.99,203.935,0-7.3554-5.99-5.58-34-9-49-5-59,3-42,10-8.48,6.28,0,7.3572l21.48-9.637,51-8h49l36,4,25,6z'/%3E %3Cpath d='m239.95,184.77c23.383-0.0432,46.07,2.2154,64.065,5.7194,18.569,3.7121,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4902-22.973-11.248-36.518-13.968-17.858-3.474-40.393-5.7168-63.647-5.6736-24.538,0.0459-47.387,2.3698-64.984,5.8032-14.12,2.8019-32.951,8.3679-35.302,13.858v-2.689c1.2911-3.8003,15.313-9.4792,34.984-13.417,17.729-3.4572,40.62-5.7415,65.302-5.7864zm0.01-8.4922c23.383-0.0423,46.07,2.2172,64.065,5.7194,18.569,3.7139,31.637,8.3556,36.105,13.571l-0.005,2.5823c-5.3884-6.4885-22.973-11.247-36.518-13.966-17.858-3.4757-40.393-5.7185-63.647-5.6736-24.538,0.0441-47.276,2.3698-64.875,5.8014-13.626,2.5832-33.226,8.3696-35.412,13.86v-2.6908c1.2911-3.7588,15.597-9.6414,34.985-13.417,17.729-3.4572,40.62-5.7397,65.302-5.7864z'/%3E %3Cpath d='m239.48,132.96c36.849-0.18433,68.99,5.1523,83.695,12.685l5.3638,9.279c-12.781-6.888-47.456-14.05-89.005-12.979-33.854,0.20814-70.027,3.7271-88.176,13.41l6.4035-10.709c14.895-7.7241,50.022-11.643,81.72-11.684'/%3E %3Cpath d='m239.97,140.62c21.017-0.0556,41.325,1.1298,57.476,4.0437,15.041,2.7993,29.385,7.0009,31.436,9.2604l1.5901,2.8099c-4.9881-3.257-17.401-6.8836-33.339-9.906-16.006-3.0083-36.3-4.0049-57.2-3.9502-23.722-0.0811-42.152,1.1712-57.969,3.9291-16.728,3.13-28.334,7.6015-31.197,9.7261l1.5583-2.9704c5.5631-2.8381,14.39-6.2592,29.223-8.9297,16.357-2.988,34.983-3.8841,58.423-4.0128h-0.00088zm-0.009-8.4843c20.113-0.0529,39.972,1.068,55.452,3.8506,12.209,2.3768,24.283,6.0872,28.704,9.3892l2.3256,3.6954c-3.9536-4.3947-18.836-8.5593-31.974-10.892-15.361-2.6494-34.395-3.698-54.508-3.8656-21.108,0.0591-40.615,1.352-55.752,4.1081-14.441,2.7481-23.76,6.0016-27.703,8.5425l2.0451-3.0868c5.4414-2.8646,14.232-5.4954,25.303-7.6465,15.249-2.7764,34.876-4.0358,56.108-4.0949z'/%3E %3Cpath d='m289.15,241.26c-18.218-3.4008-36.469-3.8947-49.217-3.7447-61.407,0.71967-81.244,12.609-83.665,16.209l-4.5894-7.4815c15.634-11.332,49.073-17.687,88.587-17.037,20.518,0.33602,38.224,1.6986,53.119,4.5835l-4.2358,7.4727'/%3E %3Cpath stroke-width='0.55' d='m239.58,236.46c17.082,0.25488,33.849,0.96044,50.033,3.9784l-1.172,2.069c-15.031-2.7746-31.055-3.8365-48.803-3.75-22.663-0.17727-45.585,1.9394-65.541,7.6668-6.2968,1.7524-16.721,5.8006-17.784,9.1458l-1.1659-1.9226c0.33601-1.9773,6.6363-6.081,18.414-9.3901,22.858-6.5458,44.239-7.6491,66.019-7.799v0.002zm0.77519-8.5963c17.698,0.33073,35.975,1.1492,53.74,4.6681l-1.2206,2.1537c-16.042-3.1847-31.369-4.2466-52.415-4.5702-22.735,0.0414-46.851,1.6625-68.778,8.0372-7.0791,2.062-19.297,6.5202-19.704,10.05l-1.1659-2.0655c0.26545-3.2059,10.842-7.388,20.358-10.156,22.096-6.4241,46.275-8.076,69.186-8.1174z'/%3E %3Cpath d='M327.58,247.38,320.201,258.829,299,240,244,203,182,169,149.81,157.99,156.67,145.27,159,144l20,5,66,34,38,24,32,23,13,15z'/%3E %3Cpath d='m148.65,158.29c5.646-3.8294,47.139,14.655,90.555,40.834,43.301,26.254,84.677,55.921,80.942,61.473l-1.2285,1.9323-0.56354,0.4445c0.12083-0.0864,0.74345-0.84755-0.0609-2.906-1.8449-6.0704-31.195-29.491-79.894-58.895-47.475-28.309-87.041-45.371-90.997-40.494l1.247-2.3892h-0.00089zm180.44,88.927c3.57-7.052-34.916-36.044-82.632-64.272-48.813-27.666-83.994-43.951-90.42-39.095l-1.4278,2.5991c-0.0124,0.14287,0.052-0.17727,0.35364-0.4101,1.1685-1.0195,3.1052-0.95074,3.9792-0.96662,11.065,0.16581,42.667,14.709,87.006,40.128,19.428,11.315,82.071,51.491,81.832,62.789,0.0168,0.97102,0.0803,1.1712-0.28485,1.6519l1.5936-2.4236v-0.002z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.67037' d='m180.6,211.01c0,16.271,6.6628,30.987,17.457,41.742,10.815,10.778,25.512,17.579,41.809,17.579,16.381,0,31.247-6.6525,42.016-17.389,10.769-10.735,17.443-25.552,17.446-41.88h-0.002v-79.189l-118.74-0.14111,0.0123,79.278h0.002z'/%3E %3Cpath fill='%23f00' stroke='%23000' stroke-width='0.50734' d='m182.82,211.12v0.045c0,15.557,6.4414,29.724,16.775,40.009,10.354,10.305,24.614,16.712,40.214,16.712,15.681,0,29.912-6.3606,40.222-16.626,10.308-10.265,16.697-24.433,16.699-40.044h-0.002v-76.826l-113.84-0.0185-0.0697,76.748m91.022-53.747,0.004,48.891-0.0414,5.1717h0.00088c0,1.3608-0.082,2.9122-0.24076,4.2333-0.92512,7.7294-4.4801,14.467-9.7451,19.708-6.1636,6.1357-14.671,9.9413-24.047,9.9413-9.327,0-17.639-3.9379-23.829-10.1-6.3497-6.32-10.03-14.986-10.03-23.947l-0.0132-54.023,67.94,0.12259,0.002,0.002z'/%3E %3Cg id='castle3'%3E %3Cg id='castle' fill='%23ff0' stroke='%23000' stroke-width='0.5'%3E %3Cpath stroke='none' d='m190.19,154.43c0.13493-5.521,4.0524-6.828,4.0806-6.8474,0.0282-0.0185,4.2314,1.4076,4.2173,6.8986l-8.2978-0.0512'/%3E %3Cpath d='m186.81,147.69-0.68172,6.3447,4.1406,0.009c0.0397-5.2493,3.9739-6.1225,4.0691-6.1031,0.0891-0.005,3.9889,1.1606,4.0929,6.1031h4.1511l-0.74962-6.3932-15.022,0.0379v0.002z'/%3E %3Cpath d='m185.85,154.06h16.946c0.35717,0,0.64908,0.35277,0.64908,0.78404,0,0.43039-0.29191,0.78141-0.64908,0.78141h-16.946c-0.35717,0-0.64908-0.35102-0.64908-0.78141,0-0.43127,0.29191-0.78404,0.64908-0.78404z'/%3E %3Cpath d='m192.01,154.03c0.0185-3.3126,2.2621-4.2501,2.2736-4.2483,0.00088,0,2.3423,0.96661,2.3609,4.2483h-4.6344'/%3E %3Cpath d='m186.21,145.05h16.245c0.34218,0,0.62263,0.31839,0.62263,0.70468,0,0.38717-0.28045,0.70467-0.62263,0.70467h-16.245c-0.34218,0-0.62263-0.31573-0.62263-0.70467,0-0.38629,0.28045-0.70468,0.62263-0.70468z'/%3E %3Cpath d='m186.55,146.47h15.538c0.32719,0,0.59529,0.31662,0.59529,0.70379,0,0.38805-0.2681,0.70467-0.59529,0.70467h-15.538c-0.32719,0-0.59529-0.31662-0.59529-0.70467,0-0.38717,0.2681-0.70379,0.59529-0.70379z'/%3E %3Cpath d='m191.57,135.88,1.2267,0.002v0.87136h0.89513v-0.89076l1.2567,0.004v0.88723h0.89778v-0.89076h1.2576l-0.002,2.0117c0,0.31574-0.25398,0.52035-0.54854,0.52035h-4.4113c-0.29633,0-0.56972-0.23724-0.5706-0.52652l-0.003-1.9879h0.00088z'/%3E %3Cpath d='m196.19,138.57,0.27691,6.4514-4.3028-0.0159,0.28486-6.4523,3.741,0.0168'/%3E %3Cpath id='cp1' d='m190.94,141.56,0.13141,3.4775-4.1256,0.002,0.11641-3.4793h3.8786-0.00089z'/%3E %3Cuse xlink:href='%23cp1' x='10.609'/%3E %3Cpath id='cp2' d='m186.3,139.04,1.1994,0.003v0.87224h0.8775v-0.89253l1.2294,0.004v0.889h0.87926v-0.89253l1.2302,0.002-0.002,2.0117c0,0.31398-0.2487,0.51859-0.5362,0.51859h-4.3169c-0.28926,0-0.55824-0.23548-0.55913-0.52564l-0.003-1.9888h0.00088z'/%3E %3Cuse xlink:href='%23cp2' x='10.609'/%3E %3Cpath fill='%23000' stroke='none' d='m193.9,140.61c-0.0265-0.62706,0.87661-0.63411,0.86603,0v1.5364h-0.866v-1.536'/%3E %3Cpath id='cp3' fill='%23000' stroke='none' d='m188.57,142.84c-0.003-0.6059,0.83693-0.61824,0.82635,0v1.1871h-0.826v-1.187'/%3E %3Cuse xlink:href='%23cp3' x='10.641'/%3E %3C/g%3E %3Cuse xlink:href='%23castle' y='46.3198'/%3E %3Cuse xlink:href='%23castle' transform='matrix(0.70460892,-0.70959585,0.70959585,0.70460892,-35.341459,275.10898)'/%3E %3C/g%3E %3Cuse xlink:href='%23castle' x='45.7138'/%3E %3Cuse xlink:href='%23castle3' transform='matrix(-1,0,0,1,479.79195,0)'/%3E %3Cg id='quina' fill='%23fff'%3E %3Cpath fill='%23039' d='m232.636,202.406v0.005c0,2.2119,0.84927,4.2272,2.2118,5.6894,1.3652,1.4667,3.2454,2.3777,5.302,2.3777,2.0672,0,3.9439-0.90487,5.3029-2.3654,1.3581-1.4587,2.2021-3.47219,2.2021-5.693v-10.768l-14.992-0.0123-0.0273,10.766'/%3E %3Ccircle cx='236.074' cy='195.735' r='1.486'/%3E %3Ccircle cx='244.392' cy='195.742' r='1.486'/%3E %3Ccircle cx='240.225' cy='199.735' r='1.486'/%3E %3Ccircle cx='236.074' cy='203.916' r='1.486'/%3E %3Ccircle cx='244.383' cy='203.905' r='1.486'/%3E %3C/g%3E %3Cuse xlink:href='%23quina' y='-26.016'/%3E %3Cuse xlink:href='%23quina' x='-20.799'/%3E %3Cuse xlink:href='%23quina' x='20.745'/%3E %3Cuse xlink:href='%23quina' y='25.784'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 6 3'%3E%3Crect fill='%23007A3D' width='6' height='3'/%3E%3Crect fill='%23FFF' width='6' height='2'/%3E%3Crect width='6' height='1'/%3E%3Cpath fill='%23CE1126' d='M0,0l2,1.5L0,3Z'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 45 30'%3E %3Crect fill='%23ED0000' width='45' height='30'/%3E %3Cpath stroke='%23FFF' stroke-width='6' d='M0,9 h 45 m -45,12 h 45'/%3E %3Cpath fill='%230050F0' d='M0,0L25.98076,15L0,30z'/%3E %3Ccomment%3Ethe star is in the center of gravity of the triangle, so the x-pos is irrational (tan(30 deg) * 15)%3C/comment%3E %3Cg fill='%23FFF' transform='translate(8.6602540378443864676372317075294,15) scale(5)'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23triangle' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 30 15'%3E %3CclipPath id='cp'%3E %3Cpath d='M0,0V75H350V150H300zM300,0H150V200H0V150z'/%3E %3C/clipPath%3E %3Crect fill='%2300247D' width='30' height='15'/%3E %3Cg transform='scale(0.05)'%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23cf142b' stroke-width='30'/%3E %3Cpath d='M300,0V150H0V300H600V0z' fill='%2300247d'/%3E %3C/g%3E %3Cg fill='%23F7E017' stroke='%23000000' stroke-width='0.015'%3E %3Cpath d='M20.018 7.954c-0.32 0.271-0.625 0.667-0.7 1.025 -0.211 1.007-0.491 1.231-0.923 1.015 0 0.541 0.474 0.582 0.682 0.266 0 0.507 0.184 0.947 0.599 1.322 0.175 0.158 0.208 0.05 0.125-0.125 -0.083-0.175-0.083-0.74-0.249-1.064 0.266 0.191 0.657 0.083 0.624-0.441 -0.341 0.2-0.68 0.192-0.715-0.283C19.418 9.112 19.635 8.303 20.018 7.954z'/%3E %3Cpath d='M19.613 3.949c0.023-0.2-0.02-0.405-0.166-0.534 -0.282-0.248-0.558-0.166-0.764 0.034 -0.308-0.166-0.471 0.423-0.82 0.324 0.058 0.191 0.15 0.274 0.324 0.208 -0.183 0.166 0 0.366-0.216 0.565 0.391 0.125 0.599-0.091 0.582-0.466 0.15 0.133 0.382 0.125 0.507-0.025 -0.208-0.067-0.209-0.247-0.125-0.416C19.06 3.39 19.646 3.4 19.613 3.949z'/%3E %3Cpath fill='%23337321' d='M20.515 6.842c-0.441 0.233-1.247 0.133-1.322-0.441 -0.075-0.574 0.482-0.832 0.632-0.906 0.233-0.117 0.416 0.091 0.341 0.333 0.258-0.091 0.316-0.391 0.191-0.565 0.341 0.025 0.657-0.233 0.79-0.599 -0.12 0.114-0.446 0.037-0.714 0.02 0.083-0.091 0.082-0.269 0.057-0.361C20.208 4.613 19.8 4.48 19.26 5.32c0.083-0.291 0.241-0.873 0.333-1.256 0.009-0.038 0.016-0.076 0.021-0.115C19.646 3.4 19.061 3.39 18.936 3.64c0.137 0.154 0.065 0.334 0.016 0.607 -0.058 0.324-0.183 1.073-0.291 1.322 -0.033-0.391-0.291-0.416-0.341-0.607 -0.075 0.05-0.116 0.183-0.1 0.274 -0.092-0.1-0.408 0.025-0.524-0.125 -0.125 0.249 0.075 0.499 0.283 0.607 -0.121 0.008-0.15 0.154-0.283 0.154 0.179 0.208 0.362 0.291 0.574 0.308 0.212 0.017 0.37 0.096 0.499 0.353C18.977 6.95 19.769 7.22 20.515 6.842z'/%3E %3Cpath d='M21.613 6.334c-0.249 0.69-0.931 1.181-1.239 1.256 -0.524 0.127-1.592 0.646-1.878 0.913 -0.045-0.01-0.087-0.026-0.118-0.048 -0.141-0.1-0.258-0.424-0.008-0.699 0.782-0.732 1.622-0.416 2.146-0.915 -0.441 0.233-1.247 0.133-1.322-0.441 0.474 0.125 1.331 0.133 2.012-0.599C21.297 5.902 21.563 6.218 21.613 6.334z'/%3E %3Cpath fill='%23337321' d='M20.018 7.954c-0.395 0.335-0.6 1.158-0.558 1.715 0.012 0.155 0.055 0.26 0.121 0.324 0.029-0.316 0.249-1.133 0.81-1.497 0.474-0.308 1.214-0.998 1.489-1.788 -0.05-0.141-0.133-0.241-0.291-0.341C21.316 7.113 20.587 7.471 20.018 7.954z'/%3E %3Cpath fill='%23316D3A' d='M21.359 6.014c-0.141 0.212-0.462 0.503-0.769 0.62 0.066-0.075 0.087-0.17 0.091-0.249 -0.391 0.15-1.173 0.133-1.489 0.017 0.474 0.125 1.331 0.133 2.012-0.599C21.272 5.877 21.33 5.943 21.359 6.014z'/%3E %3Cpath fill='%23337321' d='M18.37 7.756c-0.636 0.595-0.216 1.114 0.033 1.231 -0.066 0.416 0.324 0.366 0.316 0.715 0.158-0.091 0.2-0.333 0.175-0.524 0.2 0.216 0.707-0.025 0.815 0.374 0.067-0.441-0.274-0.881-0.698-0.84 0.175-0.158 0.075-0.416-0.091-0.482 -0.033 0.324-0.399 0.324-0.541 0.225C18.237 8.355 18.12 8.031 18.37 7.756z'/%3E %3Cpath d='M19.746 11.54c-0.069 0.04-0.064 0.129-0.021 0.187 0.087 0.116-0.062 0.38 0.22 0.437 0.083 0.017 0.147-0.034 0.179-0.129 0.087-0.262-0.191-0.291-0.216-0.416C19.883 11.494 19.804 11.507 19.746 11.54z'/%3E %3Cpath d='M19.983 12.031c-0.093 0.043-0.175 0.104-0.137 0.403 0.015 0.124 0.008 0.424-0.1 0.428 0.066 0.033 0.208 0.069 0.266-0.008 0.056 0.094 0.183 0.067 0.233-0.05 0.066 0.054 0.158-0.037 0.158-0.116 0.058 0.037 0.175-0.017 0.145-0.195 0.071 0.025 0.162-0.025 0.195-0.071 -0.104-0.021-0.366-0.162-0.428-0.274C20.253 12.035 20.091 11.981 19.983 12.031z'/%3E %3Cg fill='none'%3E %3Cpath d='M18.542 3.62c0.042-0.062 0.089-0.12 0.141-0.171'/%3E %3Cpath d='M20.124 4.721c0.073-0.042 0.185-0.047 0.309-0.039'/%3E %3Cpath d='M20.012 12.854c-0.029-0.042-0.04-0.216-0.019-0.322'/%3E %3Cpath d='M20.245 12.804c-0.046-0.035-0.133-0.156-0.148-0.262'/%3E %3Cpath d='M20.403 12.688c-0.058-0.027-0.2-0.21-0.231-0.328'/%3E %3Cpath d='M20.548 12.492c-0.069-0.015-0.279-0.152-0.366-0.297'/%3E %3C/g%3E %3Cpath d='M24.382 7.765c1.023 0.857 1.089 1.538 0.931 1.938 -0.083-0.374-0.507-0.956-0.948-1.106L24.382 7.765z'/%3E %3Cpath fill='%23337321' d='M22.553 7.282h1.896c0 0 0 0.499 0 2.245 0 1.913-1.064 3.044-2.146 3.642 -1.081-0.599-2.146-1.73-2.146-3.642 0-1.746 0-2.245 0-2.245h1.331c0.002 0.116 0.013 0.291 0.15 0.466C21.952 7.717 22.307 7.482 22.553 7.282z'/%3E %3Cpath fill='%23006EC7' d='M24.449 7.282c0 0 0 0.499 0 2.245 0 0.577-0.097 1.084-0.262 1.525l-1.883-3.455 -1.883 3.455c-0.165-0.442-0.262-0.948-0.262-1.525 0-1.746 0-2.245 0-2.245H24.449z'/%3E %3Cpath stroke='none' d='M24.244 10.887c-0.033 0.102-0.094 0.267-0.14 0.369l-1.8-3.346 -1.8 3.346c-0.047-0.102-0.107-0.267-0.14-0.369l1.941-3.598L24.244 10.887z'/%3E %3Cpath d='M23.159 12.118c0.05 0.025 0.142 0.071 0.183 0.088 0.1-0.2 0.116-0.482 0.083-0.732 -0.108 0.275-0.474 0.266-0.574 0.432 0.061 0.031 0.118 0.071 0.167 0.106 -0.125 0.125-0.417 0.334-0.583 0.384v-1.784c0-0.125-0.042-0.229-0.042-0.333 0 0 0-0.286 0-0.369 0-0.083-0.017-0.204-0.091-0.204 -0.075 0-0.091 0.121-0.091 0.204 0 0.083 0 0.369 0 0.369 0 0.104-0.042 0.225-0.042 0.333v1.784c-0.091-0.266-0.45-0.175-0.616-0.441 0.065-0.016 0.134-0.021 0.2-0.008 -0.125-0.424-0.466-0.457-0.532-0.582 0 0.175-0.075 0.582 0.042 0.757 0.026-0.031 0.065-0.064 0.113-0.092 0.141 0.308 0.777 0.309 0.927 0.816C22.423 12.659 22.856 12.443 23.159 12.118z'/%3E %3Cpath d='M22.303 10.634c0.141 0 0.59-0.046 0.753-0.046 0.042 0 0.077-0.063 0.077-0.141s-0.034-0.141-0.077-0.141c-0.162 0-0.611-0.046-0.753-0.046 -0.141 0-0.59 0.046-0.753 0.046 -0.042 0-0.077 0.063-0.077 0.141s0.034 0.141 0.077 0.141C21.713 10.588 22.162 10.634 22.303 10.634z'/%3E %3Cpath d='M22.212 9.903c-0.03-0.024-0.069-0.039-0.113-0.039 -0.094 0-0.171 0.07-0.171 0.156 0 0.086 0.076 0.156 0.171 0.156 0.094 0 0.17-0.07 0.17-0.156 0-0.067 0.097-0.067 0.097 0 0 0.135-0.12 0.244-0.267 0.244 -0.148 0-0.267-0.109-0.267-0.244 0-0.135 0.12-0.244 0.267-0.244 0.044 0 0.086 0.01 0.123 0.027C22.219 9.825 22.212 9.867 22.212 9.903z'/%3E %3Cpath d='M21.551 10.588c0.042 0 0.076-0.063 0.076-0.141s-0.034-0.141-0.076-0.141'/%3E %3Cpath d='M21.613 10.588c0.042 0 0.076-0.063 0.076-0.141s-0.034-0.141-0.076-0.141'/%3E %3Cpath d='M22.024 10.617c0.051 0 0.092-0.076 0.092-0.17 0-0.094-0.041-0.17-0.092-0.17'/%3E %3Cpath d='M22.119 10.624c0.053 0 0.096-0.08 0.096-0.178 0-0.098-0.043-0.178-0.096-0.178'/%3E %3Cpath d='M22.439 10.626c0.054 0 0.097-0.081 0.097-0.18 0-0.099-0.044-0.18-0.097-0.18'/%3E %3Cpath d='M22.539 10.621c0.053 0 0.096-0.078 0.096-0.174 0-0.096-0.043-0.174-0.096-0.174'/%3E %3Cpath d='M22.986 10.59c0.043 0 0.078-0.064 0.078-0.144s-0.035-0.144-0.078-0.144'/%3E %3Cpath d='M21.376 12.03c0.051-0.031 0.113-0.059 0.178-0.074'/%3E %3Cpath d='M23.068 12.047c-0.015-0.011-0.032-0.022-0.049-0.035'/%3E %3Cpath d='M23.159 12.118c0.116-0.125 0.213-0.266 0.267-0.428'/%3E %3Cpath fill='%23FFF' d='M21.922 8.87c0-0.041 0.033-0.058 0.072-0.087 0.047-0.035 0.066-0.052 0.108-0.052h0.546c0.04 0 0.05 0.01 0.05 0.048V9.52c0 0.037-0.009 0.048-0.05 0.048h-0.726V8.862'/%3E %3Cpath fill='%23E5E5E5' d='M22.513 9.633c0.072 0 0.059-0.002 0.109-0.052 0.053-0.052 0.048-0.048 0.048-0.096V8.806c0-0.035-0.009-0.045-0.046-0.045h-0.505c-0.04 0-0.057 0.016-0.1 0.049 -0.036 0.027-0.066 0.044-0.066 0.082v0.741H22.513z'/%3E %3Cpath fill='%23FFF' d='M22.567 9.617c0 0.037-0.009 0.048-0.05 0.048h-0.546c-0.041 0-0.049-0.01-0.049-0.048V8.875c0-0.037 0.009-0.048 0.049-0.048h0.546c0.041 0 0.05 0.01 0.05 0.048V9.617z'/%3E %3Cpath fill='%2396877D' d='M23.625 6.847c0.106 0.119 0.141 0.278 0.083 0.434h-0.158c0.066-0.2 0.025-0.39-0.258-0.415 -0.423-0.037-0.915 0.782-1.655 0.881 -0.216-0.258-0.205-0.749 0.07-0.982 -0.142-0.409-0.441-0.859-0.649-1.053 -0.136-0.022-0.293-0.033-0.394-0.027 0.108-0.233 0.416-0.478 0.666-0.578 0.04-0.059 0.084-0.116 0.124-0.167 0.025-0.32 1.547-0.17 1.871 0.029C23.326 5.328 23.467 6.523 23.625 6.847z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='M21.781 7.066c-0.036-0.554-0.26-1.011-0.575-1.322 0.15 0.042 0.457 0.042 0.665-0.108 0.274-0.183 0.99-0.503 1.252-0.366 0.021 0.046 0.033 0.15 0.017 0.216 -0.062-0.166-0.753 0.091-0.948 0.17 -0.187 0.087-0.27 0.204-0.204 0.466 -0.108-0.091-0.071-0.179-0.183-0.245C21.85 5.985 21.887 6.18 21.9 6.338c-0.042-0.112-0.116-0.353-0.279-0.495 0.141 0.274 0.264 0.933 0.206 1.283 0.112 0 0.36-0.11 0.459-0.189 -0.087 0.125-0.339 0.212-0.501 0.245 -0.073 0.087-0.123 0.312-0.119 0.437C21.655 7.465 21.703 7.09 21.781 7.066z'/%3E %3Cpath d='M23.625 6.847c-0.138-0.153-0.395-0.236-0.723-0.147 0.05-0.025 0.158-0.067 0.254-0.083 -0.012-0.087-0.091-0.462-0.104-0.553l0.092-0.037c0.046 0.225 0.104 0.482 0.141 0.586 0.029 0.008 0.096 0.021 0.154 0.05 -0.025-0.087-0.166-0.715-0.162-0.782l0.125-0.067C23.451 6.155 23.53 6.65 23.625 6.847z'/%3E %3C/g%3E %3Cpath fill='%2396877D' d='M23.551 7.282c0.066-0.2 0.025-0.39-0.258-0.415 -0.219-0.019-0.457 0.194-0.738 0.415H23.551z'/%3E %3Cpath fill='%2396877D' d='M21.713 5.49c-0.125 0.017-0.403-0.008-0.545-0.054 0.008-0.038 0.023-0.076 0.041-0.118 -0.087 0.058-0.253 0.172-0.316 0.251C21.093 5.611 21.505 5.632 21.713 5.49z'/%3E %3Cpath fill='none' d='M21.708 6.766c0.046 0.133 0.076 0.261 0.08 0.375'/%3E %3Cpath fill='none' d='M21.331 5.108c-0.075 0.11-0.141 0.228-0.163 0.328 0.141 0.046 0.42 0.071 0.545 0.054'/%3E %3Cpath fill='none' d='M21.059 5.713c0.054 0.009 0.104 0.019 0.147 0.031 0.15 0.042 0.457 0.042 0.665-0.108 0.208-0.15 0.773-0.615 1.414-0.665'/%3E %3Cpath fill='none' d='M20.894 5.569c0.2 0.042 0.612 0.062 0.819-0.079 0.482-0.328 0.948-0.52 1.414-0.545'/%3E %3Cpath fill='%23337321' d='M24.382 7.765c0.698 0.482 1.214 0.948 1.364 1.696 0.15 0.748 0.433 0.948 0.782 0.748 -0.083 0.432-0.516 0.482-0.881 0.15 0.033 0.499-0.166 1.098-0.682 1.314 -0.033-0.299 0.165-0.536 0.108-0.782 -0.025-0.108-0.033-0.358 0.108-0.474 -0.274 0.091-0.707-0.083-0.748-0.491 0.316 0.15 0.723 0.175 0.881-0.225C25.471 9.303 25.405 8.621 24.382 7.765z'/%3E %3Cpath fill='%23337321' d='M25.264 3.873c0.216-0.565 0.782-0.507 0.973-0.266 0.557-0.316 0.632 0.399 1.106 0.258 -0.008 0.133-0.166 0.258-0.341 0.249 0.183 0.166-0.075 0.416 0.316 0.565 -0.333 0.166-0.798-0.008-0.923-0.466 -0.108 0.216-0.499 0.216-0.657 0.042 0.341-0.091 0.316-0.407 0.125-0.532C25.67 3.597 25.33 3.648 25.264 3.873z'/%3E %3Cpath fill='%23337321' d='M23.577 5.118c0.155 0.5 0.476 0.966 0.822 1.283 0.399 0.366 1.002 0.274 1.339-0.075 0.008 0.696-0.713 0.75-1.114 0.532 -0.177-0.096-0.32-0.046-0.15 0.108 0.258 0.233 0.822 0.406 1.488 0.549 1.164 0.249 0.749 1.173 0.408 1.164 0.098-0.002 0.178-0.104 0.037-0.231 -1.01-0.909-3.064-0.551-3.031-2.58 -0.216 0.532-1.106 0.324-0.69-0.308 0.133 0.108 0.366 0.116 0.433-0.05 0.052-0.129 0.018-0.354-0.215-0.548 0.038-0.003 0.121 0 0.112-0.096 0.01 0.056 0.061 0.139 0.192 0.111 0.037 0.059 0.077 0.098 0.13 0.077 0.01-0.004 0.042-0.02 0.029-0.079C23.377 5.087 23.508 5.126 23.577 5.118z'/%3E %3Cpath d='M24.623 6.858c0.482 0.316 1.028 0.316 1.53-0.266 0.158-0.183 0.407-0.341 0.582-0.358 0.175-0.017 0.166-0.183 0.299-0.216 -0.083-0.025-0.116-0.125-0.241-0.112 0.312-0.108 0.22-0.358 0.374-0.478 -0.125 0.046-0.32-0.141-0.499 0.096 0.046-0.108-0.017-0.237-0.062-0.287 0.017 0.125-0.245 0.15-0.295 0.466 -0.028 0.177-0.125 0.166-0.141-0.108 -0.012-0.201-0.108-0.757-0.224-1.039 -0.116-0.283-0.143-0.671 0.015-0.729 -0.024-0.04-0.057-0.076-0.098-0.102 -0.193-0.126-0.532-0.075-0.599 0.15 -0.216 0.565 0.391 0.89 0.341 1.505 -0.091-0.457-0.832-0.574-0.823-1.023 -0.241 0.108-0.208 0.308-0.116 0.466 -0.15-0.233-0.491 0.15-0.782-0.166 -0.033 0.416 0.333 0.574 0.632 0.59 -0.15 0.266 0.05 0.491 0.249 0.565 0.008-0.466 0.963-0.275 0.973 0.524C25.746 7.016 25.014 7.074 24.623 6.858z'/%3E %3Cpath d='M25.962 7.515c1.164 0.249 0.749 1.173 0.408 1.164 -0.217-0.005-0.424-0.187-0.437-0.345 -0.249 0.133-0.183 0.395 0.008 0.499 -0.524-0.062-0.744 0.283-0.757 0.661 0.096-0.175 0.387-0.187 0.495-0.15 0.108 0.037 0.387 0.058 0.499-0.067 -0.092 0.079 0.058 0.262-0.071 0.403 0.437-0.017 0.628-0.424 0.553-0.603C27.226 8.563 27.118 7.723 25.962 7.515z'/%3E %3Cpath d='M25.076 11.466c0.076 0.047 0.066 0.147 0.015 0.21 -0.103 0.126 0.052 0.427-0.265 0.478 -0.094 0.015-0.163-0.045-0.194-0.152 -0.086-0.296 0.226-0.316 0.259-0.455C24.925 11.409 25.012 11.426 25.076 11.466z'/%3E %3Cpath d='M24.79 12.003c0.102 0.052 0.19 0.124 0.136 0.456 -0.023 0.138-0.028 0.473 0.093 0.482 -0.076 0.034-0.235 0.067-0.297-0.021 -0.067 0.102-0.207 0.066-0.258-0.066 -0.077 0.057-0.175-0.049-0.171-0.137 -0.067 0.039-0.194-0.026-0.154-0.224 -0.08 0.025-0.18-0.035-0.215-0.087 0.117-0.019 0.415-0.165 0.49-0.288C24.488 11.996 24.671 11.943 24.79 12.003z'/%3E %3Cpath fill='none' d='M24.721 12.921c0.034-0.045 0.054-0.24 0.035-0.359'/%3E %3Cpath fill='none' d='M24.464 12.855c0.053-0.037 0.155-0.168 0.176-0.286'/%3E %3Cpath fill='none' d='M24.292 12.718c0.066-0.028 0.232-0.226 0.272-0.357'/%3E %3Cpath fill='none' d='M24.138 12.494c0.077-0.013 0.318-0.157 0.421-0.316'/%3E %3Cpath d='M23.376 5.869c-0.014 0.852 0.34 1.284 0.831 1.564 -0.182-0.109-0.103-0.483-0.349-0.604 0.058-0.004 0.15 0.079 0.295 0.046 -0.071-0.158-0.187-0.399-0.457-0.432 0.071-0.008 0.225 0.017 0.324-0.021C23.879 6.205 23.505 6.309 23.376 5.869z'/%3E %3Cpath d='M23.288 5.058c-0.03-0.01-0.055-0.04-0.08-0.079 -0.131 0.028-0.182-0.055-0.192-0.111 0.008 0.096-0.074 0.092-0.113 0.095 0.234 0.194 0.268 0.419 0.216 0.548 -0.067 0.166-0.299 0.158-0.433 0.05 -0.017 0.353 0.441 0.47 0.607 0.025 0 0.075 0.096 0.067 0.121 0.166C23.532 5.561 23.442 5.286 23.288 5.058z'/%3E %3Cpath fill='%23337321' d='M22.557 3.37c-0.208-0.191-0.304-0.511-0.295-0.694 0.008-0.183 0.083-0.383 0.349-0.299 -0.083 0-0.025 0.166-0.112 0.183 0.071 0.025 0.166-0.033 0.179-0.071 0.017 0.058 0.125 0.042 0.133 0.108 0.042-0.033-0.004-0.195-0.066-0.229 0.046-0.025 0.071-0.154 0.05-0.216 -0.042 0.008-0.104 0.067-0.116 0.15 0.021-0.067-0.004-0.233-0.121-0.258 -0.033 0.046-0.042 0.158 0.004 0.22 -0.108-0.025-0.266 0.046-0.304 0.137 0.008-0.11 0.024-0.267 0.092-0.366 0.023-0.033-0.033-0.091-0.077-0.012 -0.081-0.158-0.297-0.241-0.393-0.162s-0.224-0.037-0.303 0.087c-0.079 0.125-0.347 0.138-0.333 0.27 0.008 0.079-0.011 0.201-0.05 0.245 -0.096 0.108 0.046 0.187 0.071 0.283 -0.017-0.316 0.486-0.931 0.99-0.69 -0.046 0.079-0.086 0.237-0.1 0.428 -0.021 0.283 0.021 0.682 0.295 0.915L22.557 3.37z'/%3E %3Cpath fill='%23CF142B' d='M22.706 2.38c-0.003-0.075 0.127-0.172 0.301-0.17 0.21 0.002 0.372 0.193 0.54 0.175 0.168-0.019 0.085 0.075 0.05 0.1 -0.035 0.025-0.056 0.062-0.044 0.108 0.012 0.046-0.009 0.076-0.077 0.033 -0.15-0.094-0.299 0.037-0.497-0.035C22.81 2.527 22.711 2.492 22.706 2.38z'/%3E %3Cpath fill='%2396877D' d='M21.85 4.343c-0.083-0.262-0.399-0.549-0.553-0.615l-0.008-0.141c0.083-0.033 0.283-0.191 0.374-0.279 0.624 0.299 1.472-0.125 1.863-0.565l0.15 0.091 -0.075 0.1 -0.079-0.042c-0.096 0.116-0.453 0.452-0.561 0.523 0.145 0.037 0.344 0.062 0.399 0.059C23.709 3.224 23.983 3 24.116 2.983l0.112 0.15 -0.1 0.071 -0.079-0.046c-0.374 0.308-0.798 0.981-0.965 1.43C22.852 4.538 22.02 4.571 21.85 4.343z'/%3E %3Cpath fill='none' d='M22.961 3.415c-0.054-0.014-0.1-0.029-0.129-0.045 -0.067 0.062-0.233 0.116-0.445 0.125'/%3E %3Cpath fill='none' d='M21.883 4.251c-0.056-0.31 0.033-0.653 0.191-0.757 0.345 0.229 0.936 0.229 1.285-0.021'/%3E %3Cpath fill='none' d='M21.883 4.089c0.266-0.008 0.844 0.037 0.985 0.058 0.141 0.021 0.378 0.079 0.345 0.15'/%3E %3Cpath fill='none' d='M22.006 4.045l0.077-0.076 -0.077-0.076L21.93 3.968 22.006 4.045z'/%3E %3Cpath fill='%23337321' d='M22.187 2.497c-0.096-0.133-0.359-0.175-0.416 0.004 -0.025 0.079-0.062 0.162-0.125 0.2 -0.062 0.037-0.048 0.151-0.021 0.2 0.066 0.121 0.008 0.237 0.137 0.316 0-0.096 0.141-0.195 0.262-0.22 0.121-0.025 0.303-0.133 0.328-0.254C22.378 2.621 22.42 2.521 22.187 2.497z'/%3E %3Cpath fill='%2396877D' d='M21.588 3.694h0.033l0.001 0.227c0.007 0.002 0.014 0.006 0.02 0.01l0.196-0.113 0.017 0.029 -0.197 0.114c0.001 0.007 0.002 0.015 0.001 0.022l0.196 0.113 -0.017 0.029L21.64 4.013c-0.005 0.005-0.012 0.01-0.019 0.012l0 0.226h-0.033l0-0.227c-0.007-0.002-0.014-0.006-0.02-0.01l-0.196 0.113 -0.017-0.029 0.197-0.114c-0.001-0.007-0.002-0.015-0.001-0.022l-0.196-0.113 0.017-0.029 0.197 0.113c0.005-0.005 0.012-0.01 0.019-0.012L21.588 3.694 21.588 3.694z'/%3E %3Cpath fill='%2396877D' d='M21.884 4.25c-0.071 0.072-0.17 0.116-0.28 0.116 -0.218 0-0.394-0.176-0.394-0.394 0-0.218 0.176-0.394 0.394-0.394 0.128 0 0.241 0.061 0.313 0.155 -0.02 0.05-0.044 0.161-0.046 0.211 -0.014-0.136-0.128-0.242-0.268-0.242 -0.149 0-0.269 0.121-0.269 0.269 0 0.149 0.121 0.269 0.269 0.269 0.124 0 0.232-0.087 0.263-0.202C21.867 4.09 21.869 4.209 21.884 4.25z'/%3E %3Cpath fill='%23337321' d='M21.438 4.625c-0.025-0.029-0.071-0.108-0.066-0.166 0.037-0.004 0.108 0.021 0.141 0.054 -0.004-0.042-0.021-0.133-0.012-0.175 0.046 0.017 0.141 0.071 0.175 0.133 -0.008-0.042-0.025-0.15-0.008-0.216 0.05 0.029 0.133 0.108 0.15 0.162 0.004-0.083 0.033-0.22 0.058-0.254 0.037 0.037 0.096 0.071 0.133 0.121 0.008-0.067 0.042-0.146 0.091-0.166 0.037 0.042 0.096 0.137 0.108 0.245 0.037-0.012 0.087-0.075 0.108-0.108 0.021 0.033 0.042 0.091 0.029 0.162 0.046-0.042 0.1-0.1 0.112-0.15 0.033 0.025 0.096 0.087 0.112 0.154 -0.008-0.054-0.004-0.15-0.021-0.204 0.062 0.033 0.112 0.091 0.125 0.154 0.017-0.058 0.054-0.162 0.087-0.187 0.033 0.067 0.067 0.146 0.062 0.212 0.021-0.042 0.054-0.116 0.087-0.133 0.029 0.046 0.025 0.146 0.017 0.2 0.029-0.042 0.083-0.091 0.116-0.108 0.004 0.025 0.008 0.075 0 0.112 0.037-0.021 0.1-0.133 0.121-0.191 0.058 0.029 0.116 0.129 0.121 0.179 0.042-0.017 0.125-0.091 0.15-0.133 0 0.029 0.013 0.108-0.004 0.17 0.025-0.025 0.05-0.075 0.062-0.096 0.017 0.042 0.004 0.141-0.013 0.195 0.037-0.033 0.092-0.054 0.125-0.054 0.004 0.071-0.046 0.195-0.092 0.287C23.114 4.713 22.278 4.671 21.438 4.625z'/%3E %3Cpath stroke='none' d='M22.83 2.423c-0.002-0.031 0.066-0.1 0.189-0.099 0.147 0.001 0.283 0.109 0.4 0.101 0.118-0.008 0.06 0.031 0.035 0.041 -0.025 0.01-0.039 0.026-0.031 0.044 0.009 0.019-0.006 0.031-0.054 0.014 -0.105-0.038-0.21 0.015-0.348-0.014C22.902 2.483 22.833 2.469 22.83 2.423z'/%3E %3Cpath d='M21.567 4.875C21.442 5.025 21.318 5 21.293 4.904c-0.025-0.096 0.067-0.141 0.033-0.225 -0.033-0.083 0.054-0.121 0.096-0.083 0.042 0.037 0.175-0.083 0.233 0.042 0.058 0.125 0.104 0.212 0.071 0.262C21.692 4.95 21.592 4.925 21.567 4.875z'/%3E %3Cpath d='M22.103 4.65c-0.023-0.055 0.106-0.16 0.173-0.085 0.067 0.075 0.171-0.081 0.229 0.037 0.058 0.119 0.077 0.181 0.106 0.247 0.029 0.067-0.158 0.102-0.216 0.044 0.008 0.039-0.162 0.07-0.208-0.042C22.162 4.792 22.135 4.723 22.103 4.65z'/%3E %3Cpath d='M22.968 4.719c-0.031-0.058 0.121-0.141 0.2-0.035 0.021-0.044 0.171-0.052 0.181 0.075 0.01 0.127 0.015 0.202 0.019 0.252 0.004 0.05-0.091 0.096-0.16-0.031 -0.123 0.025-0.179-0.044-0.193-0.116C23 4.79 22.985 4.754 22.968 4.719z'/%3E %3Cpath fill='%23337321' d='M21.648 4.636c-0.019-0.042 0.106-0.125 0.191-0.062 0.085 0.062 0.203-0.054 0.254 0.058 0.102 0.227 0.108 0.243 0.077 0.287 -0.031 0.044-0.164 0.027-0.198-0.033 -0.006 0.042-0.121 0.035-0.181 0.002C21.723 4.85 21.675 4.711 21.648 4.636z'/%3E %3Cpath fill='%23337321' d='M22.523 4.646c-0.029-0.064 0.166-0.121 0.252-0.008 0.044-0.04 0.139-0.042 0.193 0.081 0.054 0.123 0.062 0.191 0.023 0.222 -0.028 0.022-0.129 0.039-0.162-0.017 -0.046 0.029-0.187 0.004-0.218-0.075C22.58 4.771 22.553 4.702 22.523 4.646z'/%3E %3Cpath fill='%23337321' d='M23.351 4.769c-0.004-0.058 0.102-0.085 0.141 0 0.04 0.085 0.166 0.008 0.177 0.15 0.002 0.027-0.015 0.131-0.054 0.181s-0.233 0-0.245-0.106C23.357 4.887 23.353 4.827 23.351 4.769z'/%3E %3Cg fill='none'%3E %3Cpath d='M21.567 4.875c-0.046-0.062-0.108-0.162-0.187-0.054'/%3E %3Cpath d='M21.973 4.885c-0.027-0.035-0.062-0.094-0.075-0.139'/%3E %3Cpath d='M22.395 4.894c-0.029-0.021-0.073-0.062-0.096-0.106'/%3E %3Cpath d='M22.357 4.675c0.073 0.008 0.123 0.077 0.145 0.108 0.023 0.031 0.071 0.087 0.108 0.094'/%3E %3Cpath d='M22.829 4.925c-0.025-0.04-0.05-0.075-0.056-0.104'/%3E %3Cpath d='M22.775 4.638c0.025 0.035 0.044 0.064 0.058 0.098'/%3E %3Cpath d='M23.207 4.979c-0.033-0.062-0.085-0.123-0.129-0.143'/%3E %3Cpath d='M23.191 4.75c0.004 0.123 0.168 0.131 0.175 0.218'/%3E %3Cpath d='M23.492 4.769c0.017 0.031 0.023 0.062 0.025 0.114'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1280' height='800' id='Flag of Poland' viewBox='0 0 16 10'%3E%3Crect width='16' height='10' fill='%23fff'/%3E%3Crect width='16' height='5' fill='%23dc143c' y='5'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='-75 -40 120 80' version='1.1'%3E %3Ctitle%3EFlag of Pakistan%3C/title%3E %3Crect x='-75' y='-40' width='120' height='80' fill='%23fff'/%3E %3Crect x='-45' y='-40' width='90' height='80' fill='%2301411C'/%3E %3Ccircle r='24' fill='%23fff'/%3E %3Ccircle r='22' cx='-7' cy='-40' fill='%2301411C' transform='rotate(-41.63354, 45, -40)'/%3E %3Cpolygon points='0,-513674 301930,415571 -488533,-158734 488533,-158734 -301930,415571' fill='%23fff' transform='rotate(-41.63354) translate(16) rotate(18) scale(0.00001557408)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450' viewBox='0 0 180 90'%3E %3Ctitle%3EFlag of the Philippines%3C/title%3E %3Cdesc%3ECoding according to the official 'description and specification of the FILIPINO flag' in Executive Order No. 23 from 1936%3C/desc%3E %3Crect width='180' height='90' fill='%230038a8'/%3E %3Crect y='45' width='180' height='45' fill='%23ce1126'/%3E %3Cpath d='M 77.942286,45 0,90 0,0' fill='%23fff'/%3E %3C!-- 45*Sqrt(3) --%3E %3Cg transform='translate(28,45)' fill='%23fcd116'%3E %3Ccircle r='9'/%3E %3Cg id='j'%3E %3Cg id='i'%3E %3Cg id='h'%3E %3C!-- these coordinates are -1/(1+tan(k*Pi/48)),1-1/(1+tan(k*Pi/48)) --%3E %3C!-- k in %7B1,2,3%7D. 2nd scaling factor is 85/0.88366349... --%3E %3Cpath d='M -1,0 L -0.93848823,0.06151177 L 0,0 L -0.93848823,-0.06151177 z' transform='scale(19)'/%3E %3Cpath id='g' d='M -0.88366349,0.11633651 L -0.83408932,0.16591068 L 0,0 z' transform='scale(19.238092)'/%3E %3Cuse xlink:href='%23g' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23i' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23j' transform='rotate(180)'/%3E %3Cg transform='translate(-2.019238)'%3E %3C!-- 15*Sqrt(3)-28 --%3E %3Cg id='s' transform='translate(37.961524,0)'%3E %3C!-- 30*Sqrt(3)-14 --%3E %3C!-- 5-pointed star with ri=2 and rc=5, not(!) r2/r1 = 0.381966... --%3E %3Cpath id='t' d='M 5,0 L 1.618034,1.175571 1.545085,4.755283 -0.618034,1.902113 -4.045085,2.938926 -2,0 z'/%3E %3Cuse xlink:href='%23t' transform='scale(1,-1)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='rotate(120)'/%3E %3Cuse xlink:href='%23s' transform='rotate(-120)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='450' viewBox='0 0 768 576'%3E %3Ctitle%3EFlag of Papua New Guinea%3C/title%3E %3Crect width='768' height='576' fill='%23000'/%3E %3Cpath d='M0,0H768V576z' fill='%23ce1126'/%3E %3Cpath d='M475.48467,167.35351C469.81245,174.67996 456.38967,159.98385 440.30967,159.64818C424.22967,159.31251 412.839,175.05784 408.14967,180.41851C403.46034,185.77918 388.38534,213.91818 388.72,216.93318C389.05467,219.94818 398.10067,208.55851 401.45034,206.54851C401.785,210.56851 397.765,215.25885 398.77,216.59851C399.775,217.93818 410.49433,208.55851 414.17967,208.22385C415.18467,210.90418 412.16967,213.58351 413.17467,217.60351C414.51534,218.94318 420.54534,210.90318 424.56534,209.22885C425.23467,212.24385 420.88,217.93918 423.22467,221.62351C424.9,221.95818 434.949,210.23385 438.29967,208.89318C441.65034,207.55251 436.62433,219.94818 438.29967,220.95318C441.31467,218.94318 450.69534,208.22284 453.71034,206.88318C456.72534,205.54351 453.37567,220.61851 454.71534,220.61851C458.39967,217.93818 467.78034,205.20885 468.78534,203.19885C469.79034,201.18885 467.78034,222.62851 478.165,234.01918C488.54967,245.40985 504.29601,258.47385 505.97034,258.47385C507.98034,254.78851 505.30101,247.08418 506.97534,247.41885C511.66467,252.44385 520.375,259.81351 522.385,259.81351C524.395,259.81351 521.04433,251.77351 523.72467,251.77351C529.08534,256.79851 544.495,276.56385 574.645,285.60885C572.635,279.91351 568.27933,274.88851 567.94467,272.20918C569.95467,272.54385 576.99067,275.89452 578.33034,275.55885C579.67,275.22318 563.59,255.45885 564.595,252.77851C568.28034,252.44385 569.95567,254.78851 571.29534,253.11318C569.62,250.43385 555.55,234.68851 555.55,231.00318C555.55,227.31784 559.90567,231.67351 561.24534,231.00318C562.585,230.33284 555.88567,216.26284 557.22534,214.58851C558.565,212.91418 573.30433,223.63351 576.98967,223.63351C580.675,223.63351 577.99467,210.56851 579.67,209.89818C581.34534,209.22784 593.74101,216.93318 596.42034,216.93318C599.09967,216.93318 598.765,211.23784 599.77,211.90818C600.775,212.57851 629.92,241.72351 619.87,275.89351C609.82,300.34918 589.72101,313.41418 560.24034,302.69385C561.91467,305.37418 577.66,318.43918 594.745,313.74885C611.83,309.05851 632.59933,295.65885 630.25467,262.15918C627.91,228.65952 616.854,223.96918 615.17967,218.94418C613.50534,213.91918 617.86101,220.28385 621.54534,221.62452C625.22967,222.96519 620.875,214.58851 619.87,210.90318C618.865,207.21784 630.925,218.60851 633.94,219.61351C636.955,220.61851 626.905,192.14385 623.89,190.13385C620.875,188.12385 626.905,190.80318 628.915,191.47351C630.925,192.14385 610.48933,160.31851 606.13467,160.31851C601.78,160.31851 609.819,158.64318 612.16467,158.64318C614.51034,158.64318 588.71601,137.87284 584.36034,137.87284C580.00467,137.87284 593.739,132.51217 595.07967,132.17751C597.42534,132.51217 565.26534,115.09251 536.455,132.51217C534.77967,131.17351 550.02351,120.62101 550.525,116.09851C550.69284,114.92568 545.50101,112.41318 545.16534,111.07351C544.82967,109.73385 553.20534,105.71386 553.54,102.69886C551.53,100.01853 547.84467,101.02352 545.83467,100.3542C545.33317,97.841696 552.87067,91.643861 552.20034,88.964531C551.69784,87.457031 546.16933,86.954531 544.82967,87.959531C543.49,88.964531 548.34817,80.924531 547.51,78.579866C546.84067,77.574866 544.16034,78.245201 541.48,78.914531C539.80467,78.579866 550.19034,64.174196 548.18034,62.164196C546.17034,60.154196 518.02933,76.903526 507.64467,95.663861C497.26,114.42418 505.30101,129.49918 503.96034,135.86385C502.61967,142.22851 500.94433,148.59418 496.58967,148.59418C492.235,148.59418 482.18601,141.89385 478.83534,138.54418C475.48467,135.19452 474.81534,132.84885 470.125,131.50918C465.43467,130.16952 454.71534,134.18952 450.69534,134.52418C446.67534,134.85885 430.93,131.50918 429.925,132.51418C428.92,133.51918 445.33467,139.54918 449.02,141.55918C452.70534,143.56918 453.04101,146.24952 455.72034,147.92385C458.39967,149.59818 483.52467,156.96885 475.48467,167.35351zM573.64,214.58851C581.68,222.62851 635.95,258.80851 635.95,303.02851C635.95,347.24851 596.41933,345.90985 585.02967,344.56918C597.76,355.28851 646,353.27851 646,303.02851C646,258.80851 583.69,214.58851 575.65,210.56851C567.61,206.54851 565.6,206.54851 573.64,214.58851z' fill='%23fcd116'/%3E %3Cg fill='%23fff'%3E %3Cpath d='M220.254,418.599,231.709,381.748,243.164,419,213,396.168h37.418z'/%3E %3Cpath id='sl' d='m192.418,178.496 -22.909,73.702 60.327,-44.862h-74.836l60.327,45.664z'/%3E %3Cuse xlink:href='%23sl' x='-88' y='112.504'/%3E %3Cuse xlink:href='%23sl' x='87.582' y='104.504'/%3E %3Cuse xlink:href='%23sl' y='264.504'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='400'%3E %3CclipPath id='c'%3E %3Cellipse cx='300' cy='201' rx='85.849' ry='88.189'/%3E %3C/clipPath%3E %3Crect width='600' height='400' fill='%23ce1126'/%3E %3Crect width='600' height='200' y='100' fill='%23fff'/%3E %3Cg clip-path='url(%23c)'%3E %3Cg fill='%23ff9c10'%3E %3Cpath d='m277.29,191.02-14.575-0.41947,0-5.7622,14.575,6.1816z'/%3E %3Cpath d='m277.23,189.34-14.515-7.3829v-9.6023s-1.7009,0.23946-1.4578-1.681c0.0802-4.0011,10.667,7.3028,16.093,10.984l-0.12114,7.6826z'/%3E %3Cpath d='m214.37,214.37,30.606,0.24025,0-18.966l-34.98-1.67,4.3734,20.405z'/%3E %3Cpath d='m212.91,188.2,32.551,3.1209-0.2423-13.444-31.822-12.484-0.48701,22.807z'/%3E %3Cpath d='m219.47,161.32,25.021,12.003,3.5727-3.6863s-2.301-1.5668-2.1871-3.0084c0.0433-1.4582,2.3147-1.6794,2.358-3.2621,0.0417-1.4582-2.573-1.6334-2.6011-3.0924-0.17088-1.5811,2.0154-3.2764,2.0154-3.2764l-22.591-19.446-5.5881,23.768z'/%3E %3Cpath d='m383.68,214.61-32.307,0-0.2423-18.485,35.464-2.6412-2.9148,21.127z'/%3E %3Cpath d='m384.47,187.91c-0.40794-3.001-0.83573-5.9945-1.5312-8.9375-0.93116-3.9401-2.1206-7.8167-3.5625-11.594-0.10645-0.27883-0.26579-0.53476-0.375-0.8125l-27.625,11.562,0.25,13.688,32.844-3.9062z'/%3E %3Cpath d='m365.59,143.47c-5.5104,4.1667-11.021,8.3333-16.531,12.5,0.0273,1.1959,1.2194,2.1156,1.5482,3.2604,0.76317,1.6063-0.75368,3.0262-1.6924,4.1613-0.76068,1.047,0.87892,1.5806,1.4239,2.1993,1.1999,1.2319,0.15476,3.1621-1.1234,3.8787,1.5397,0.9212,2.3175,2.6452,2.6562,4.3438,8.25-4.2917,16.5-8.5833,24.75-12.875-2.9604-6.2356-6.6513-12.132-11.031-17.468z'/%3E %3Cpath d='m319.56,191.44,13.845-0.59944,0.2423-5.5235-14.088,6.1229z'/%3E %3Cpath d='m319.55,188.44-0.0594-6.2411s13.115-11.703,15.909-13.864c0,2.401-1.5172,4.2604-1.5172,4.2604v9.1234l-14.332,6.7216z'/%3E %3Cpath d='m234.54,135.87c0.24229,0.24026,14.718,16.14,14.718,16.14,0.40598-1.5066,3.7436-1.7357,7.1437-1.4954,3.4018,0.23946,6.1128-0.22519,6.1128,2.1758,0,2.4002-1.7258,2.0592-1.7258,3.7402s2.5858,1.5399,2.5858,3.6982c0,2.1607-1.875,1.7198-1.8846,3.3929-0.006,1.3829,1.956,1.4566,1.956,1.4566l13.785,13.205,0.0602-14.105-28.42-44.052-14.331,15.845z'/%3E %3Cpath d='m257.28,119.19c0.21581,0.64069,19.25,38.906,19.25,38.906s0.21583-35.913,3.4604-37.837l-5.4068-9.8338-17.303,8.765z'/%3E %3Cpath d='m319.41,115.06c-2.3958,8.2812-4.7917,16.562-7.1875,24.844,2.2408,0.26667,4.5038,0.33859,6.7557,0.21383,2.0248,0.17376,0.4475,2.0722,0.55535,3.1952-0.01,5.0928-0.0199,10.186-0.0298,15.278,6.7708-11.958,13.542-23.917,20.312-35.875-4.6702-2.4376-9.627-4.2482-14.616-5.9053-1.9021-0.67149-3.8355-1.2533-5.7902-1.7509z'/%3E %3Cpath d='m344.69,125.44c-8.375,12.875-16.75,25.75-25.125,38.625-0.0104,4.9583-0.0208,9.9167-0.0312,14.875,5.5944-5.3224,11.217-10.617,16.794-15.957,1.0585-1.4987-3.3598-2.2326-1.1513-4.0588,2.0005-0.63097,2.3398-3.8629,0.233-4.4839-1.7358-2.5486,1.5703-3.8992,3.6531-3.6202,2.9008,0.13241,5.8889-0.63149,8.725,0.17415,1.5616,1.4931,3-2.2551,4.532-3.0989,3.0298-3.0477,6.0632-6.0921,9.0586-9.1737-4.937-5.1457-10.573-9.615-16.688-13.282z'/%3E %3C/g%3E %3Cg fill='%23083d9c' stroke='%23083d9c' stroke-width='1.932'%3E %3Cpath stroke-width='2.057' d='m279.88,275.41c-6.1779,0.34881-12.334,4.5177-15.219,6.75,5.1802,2.2672,10.71,4.037,16.594,5.25,9.3748,1.574,18.75,1.5625,28.125,1.5625,1.5304-0.1927,3.0449-0.41052,4.5312-0.65625l19.75-6.6562s-9.5008-6.2714-17.031-6c-7.5312,0.27137-12.615,7.6383-18.688,7.0938-6.0727-0.54364-8.5049-7.3438-17.25-7.3438-0.27329,0-0.53902-0.0154-0.8125,0z'/%3E %3Cpath d='m244.01,270.31,112.23,0.4805s-9.7159-10.323-21.134-10.563c-11.417-0.24185-8.2581,4.8012-17.003,5.5203-8.7444,0.72076-10.932-5.2809-18.948-5.0414-8.015,0.23947-12.632,5.0414-18.703,5.2824-6.0726,0.23947-13.846-6.0032-18.462-5.7614-4.6157,0.23946-21.134,7.2013-21.134,7.2013l3.1579,2.8807z'/%3E %3Cpath d='m229.68,257.1,138.46,0.4813c2.1855-3.1209-6.802-10.563-15.06-11.284-6.8036,0.23946-11.66,6.9619-17.247,7.2029-5.5873,0.23947-11.902-6.9634-18.219-6.7216-6.315,0.23946-12.874,6.7216-19.19,6.7216-6.315,0-10.931-6.9634-18.946-6.9634-8.0158,0-11.66,7.6826-17.733,7.2029-6.0743-0.4805-11.418-7.6818-17.247-7.6818-5.8296,0-15.546,8.6421-17.489,8.1616-1.9432-0.47972,2.4278,3.6014,2.6725,2.8807z'/%3E %3Cpath d='m283.21,243.86,30.908-0.0182c0.2407-0.24025-6.9199-10.55-15.449-9.8227-9.5017,0.24581-15.956,9.841-15.459,9.841z'/%3E %3Cpath d='m381.77,243.12-42.294,0s5.4741-3.1971,6.9664-6.1475c2.7359,1.4756,1.9897,2.9505,7.4639,3.1963,5.4725,0.24582,10.697-6.1459,15.923-5.9001,5.2238,0.2458,11.941,9.0972,11.941,8.8514z'/%3E %3Cpath d='m215.1,243.12,42.294,0s-5.4741-3.1971-6.9664-6.1475c-2.7359,1.4756-1.9897,2.9505-7.4638,3.1963-5.4717,0.24582-10.697-6.1459-15.923-5.9001-5.2238,0.2458-11.941,9.0972-11.941,8.8514z'/%3E %3Cpath d='m218.26,229.98,30.121,0.23947s-1.9432-4.0804-2.1855-9.1218c-7.7752-2.6396-14.09,5.7614-19.677,6.0016-5.5856,0.23946-11.415-6.0016-11.415-6.0016l3.1571,8.8823z'/%3E %3Cpath d='m379.07,229.98-30.122,0.23947s1.944-4.0804,2.1863-9.1218c7.7744-2.6396,14.089,5.7614,19.677,6.0016,5.5865,0.23946,11.416-6.0016,11.416-6.0016l-3.1571,8.8823z'/%3E %3Cpath d='m290.89,230.22,15.302-0.47893s0.24389-4.5617-7.7728-4.5617c-8.0158,0-7.2866,5.2817-7.5296,5.0406z'/%3E %3C/g%3E %3Cg fill='%23ce1126' stroke='%23630810' stroke-width='1.9319' stroke-linejoin='round'%3E %3Cpath d='m282.87,181,31.823,8.4034,0-44.895c-14.576,0.72077-26.72-27.368-0.97161-29.288-25.263-3.6015-28.179,2.8807-31.093,9.8426l0.2423,55.937z'/%3E %3Cpath d='m289.94,221.58c-6.9215,11.33-25.425,7.9697-29.752,0.0603-1.2965-0.36317-0.52953-48.8-0.52953-48.8s-2.0675-0.93089-2.163-2.42c-0.0947-1.5042,2.8113-1.6406,2.8113-3.5658,0-1.9236-2.9677-1.1696-3.0271-3.1059,0.0128-1.8515,3.1683-1.5962,3.0271-3.3073-0.16688-1.9284-3.5342-1.6429-3.677-3.4207-0.1091-1.4122,2.4085-2.6436,3.1082-3.2787-0.45251,0.0222-2.3387-0.0278-2.3508-0.0341-1.7667,0.0357-3.5342,0.0714-5.3,0.10704-3.7652,0.004,0.065,0.81116,0.01,2.9584-0.0345,1.4027-1.9095,2.336-2.0772,3.5555-0.0594,1.252,2.6829,2.1314,2.7174,3.634,0.0313,1.3408-2.6941,1.432-2.5963,2.6777,0.16929,2.1084,2.4141,2.5722,2.3804,3.8488-0.0345,1.275-3.0207,1.7611-3.0287,2.7784,0.10429,1.968,0.43244,49.807,0.43244,49.807,4.7585,24.37,32.228,30.569,40.015-1.4955z'/%3E %3Cpath d='m308.05,221.58c6.9215,11.33,25.424,7.9697,29.751,0.0603,1.2965-0.36317,0.53034-48.8,0.53034-48.8s2.0675-0.93089,2.1622-2.42c0.0947-1.5042-2.6292-1.6406-2.6292-3.5658,0-1.9236,2.7864-1.1696,2.845-3.1059-0.012-1.8515-2.9252-1.7159-2.784-3.4278,0.16608-1.9276,2.4534-1.7024,2.5834-3.4801,0.10911-1.5311-1.4361-2.4636-2.1357-3.0987,0.45249,0.0222,2.2168-0.0278,2.2296-0.0341,1.7659,0.0357,3.5334,0.0714,5.2992,0.10704,3.766,0.004-0.065,0.81116-0.009,2.9584,0.0337,1.4027,1.9087,2.336,2.0772,3.5555,0.0586,1.252-2.6837,2.1314-2.7182,3.634-0.0305,1.3408,2.695,1.432,2.5963,2.6777-0.16928,2.1084-2.4141,2.5722-2.3796,3.8488,0.0337,1.275,3.0207,1.7611,3.0279,2.7784-0.10349,1.968-0.43164,49.807-0.43164,49.807-4.7593,24.37-32.228,30.569-40.015-1.4955z'/%3E %3C/g%3E %3Cg fill='%23630810' stroke='%23630810' stroke-width='2.7916' stroke-linecap='round'%3E %3Cpath d='m281.66,223.73c2.6725-1.4415,5.1011-2.8807,6.802-6.2427l-10.446,0.23947s-4.8564,2.8823-7.2866,6.0032h10.931z'/%3E %3Cpath d='m315.42,223.73c-2.6725-1.4415-5.1003-2.8807-6.8012-6.2427l10.445,0.23947s4.8572,2.8823,7.2866,6.0032h-10.931z'/%3E %3Cpath d='m262.71,213.65 71.903,0.23946'/%3E %3Cg id='x'%3E %3Cpath d='m266.11,196.61 8.5023,11.284'/%3E %3Cpath d='m266.11,207.89 9.2315,-11.043'/%3E %3Cpath d='m270.97,195.88 -0.24252,6.9617'/%3E %3C/g%3E %3Cuse xlink:href='%23x' x='13.603532'/%3E %3Cuse xlink:href='%23x' x='27.449532'/%3E %3Cuse xlink:href='%23x' x='41.781532'/%3E %3Cuse xlink:href='%23x' x='55.627532'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg width='900' height='600' xmlns='http://www.w3.org/2000/svg' id='Flag_of_Peru'%3E %3Crect height='600' width='900' fill='%23D91023' x='0' y='0' /%3E %3Crect height='600' width='300' fill='white' x='300' y='0' /%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 36 24'%3E %3Crect width='36' height='24' fill='%23fff'/%3E %3Cg fill='%23005293'%3E %3Cg id='star' transform='translate(9,6)'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-3 v 3 h 1.5 z' transform='rotate(18 0,-3)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Crect y='12' width='18' height='12'/%3E %3C/g%3E %3Cg fill='%23d21034'%3E %3Crect x='18' width='18' height='12'/%3E %3Cuse xlink:href='%23star' x='18' y='12'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 1200 600'%3E %3Ctitle%3EFlag of Oman%3C/title%3E %3Crect width='1200' fill='%23db161b' height='600'/%3E %3Crect height='200' width='900' x='300' fill='%23fff'/%3E %3Crect height='200' width='900' y='400' x='300' fill='%23008000'/%3E %3Cg id='a' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Crect rx='3.2154' ry='3.0152' height='21.217' width='38.669' y='102.64' x='65.854' stroke-width='0.28333pt'/%3E %3Crect rx='3.0505' ry='2.764' height='19.449' width='36.686' y='103.52' x='66.846' stroke-width='0.26422pt'/%3E %3Cpath d='M83.904,108.83l1.853,0.06,0.084,0.84,1.516,0.77,1.18-0.96,1.431,0.77-1.347,0.84,0.337,1.16,1.684-0.06v1.55l-1.347-0.07-0.674,0.97,1.516,1.1-1.179,0.9-1.264-0.97-1.853,0.39,0.084,1.42-2.021,0.13-0.253-1.36-1.684-0.71-0.927,0.97-1.432-0.71,0.843-1.1-1.011-0.71h-1.432l-0.084-2,1.432,0.13,1.01-1.16-1.179-0.9,1.516-1.04,1.095,0.84,1.853-0.25,0.253-0.84z' stroke-width='0.16681166pt'/%3E %3Cellipse cx='68.944' cy='426.78' rx='11.049' ry='9.9439' transform='matrix(0.1841806,0,0,0.1752043,71.76647,38.246478)' stroke-width='1pt'/%3E %3Cpath d='M71.803,104.41l-2.974,2.65'/%3E %3Cpath d='M73.786,104.41l-2.974,2.65'/%3E %3Cpath d='M75.769,104.41l-2.974,2.65'/%3E %3Cpath d='M77.752,104.41l-2.974,2.65'/%3E %3Cpath d='M79.735,104.41l-2.974,2.65'/%3E %3Cpath d='M81.718,104.41l-2.974,2.65'/%3E %3Cpath d='M83.702,104.41l-2.975,2.65'/%3E %3Cpath d='M85.685,104.41l-2.975,2.65'/%3E %3Cpath d='M87.668,104.41l-2.975,2.65'/%3E %3Cpath d='M89.651,104.41l-2.975,2.65'/%3E %3Cpath d='M91.634,104.41l-2.975,2.65'/%3E %3Cpath d='M93.617,104.41l-2.975,2.65'/%3E %3Cpath d='M85.685,104.41l-2.975,2.65'/%3E %3Cpath d='M95.6,104.41l-2.975,2.65'/%3E %3Cpath d='M97.583,104.41l-2.975,2.65'/%3E %3Cpath d='M99.566,104.41l-2.975,2.65'/%3E %3Cpath d='M101.55,104.41l-2.976,2.65'/%3E %3Cpath d='M98.574,104.41l2.976,2.65'/%3E %3Cpath d='M96.591,104.41l2.975,2.65'/%3E %3Cpath d='M94.608,104.41l2.975,2.65'/%3E %3Cpath d='M92.625,104.41l2.975,2.65'/%3E %3Cpath d='M90.642,104.41l2.975,2.65'/%3E %3Cpath d='M88.659,104.41l2.975,2.65'/%3E %3Cpath d='M86.676,104.41l2.975,2.65'/%3E %3Cpath d='M84.693,104.41l2.975,2.65'/%3E %3Cpath d='M82.71,104.41l2.975,2.65'/%3E %3Cpath d='M80.727,104.41l2.975,2.65'/%3E %3Cpath d='M78.744,104.41l2.975,2.65'/%3E %3Cpath d='M76.761,104.41l2.974,2.65'/%3E %3Cpath d='M84.693,104.41l2.975,2.65'/%3E %3Cpath d='M74.778,104.41l2.974,2.65'/%3E %3Cpath d='M72.795,104.41l2.974,2.65'/%3E %3Cpath d='M70.812,104.41l2.974,2.65'/%3E %3Cpath d='M68.829,104.41l2.974,2.65'/%3E %3Cpath d='M71.803,119.43l-2.974,2.66'/%3E %3Cpath d='M73.786,119.43l-2.974,2.66'/%3E %3Cpath d='M75.769,119.43l-2.974,2.66'/%3E %3Cpath d='M77.752,119.43l-2.974,2.66'/%3E %3Cpath d='M79.735,119.43l-2.974,2.66'/%3E %3Cpath d='M81.718,119.43l-2.974,2.66'/%3E %3Cpath d='M83.702,119.43l-2.975,2.66'/%3E %3Cpath d='M85.685,119.43l-2.975,2.66'/%3E %3Cpath d='M87.668,119.43l-2.975,2.66'/%3E %3Cpath d='M89.651,119.43l-2.975,2.66'/%3E %3Cpath d='M91.634,119.43l-2.975,2.66'/%3E %3Cpath d='M93.617,119.43l-2.975,2.66'/%3E %3Cpath d='M85.685,119.43l-2.975,2.66'/%3E %3Cpath d='M95.6,119.43l-2.975,2.66'/%3E %3Cpath d='M97.583,119.43l-2.975,2.66'/%3E %3Cpath d='M99.566,119.43l-2.975,2.66'/%3E %3Cpath d='M101.55,119.43l-2.976,2.66'/%3E %3Cpath d='M98.574,119.43l2.976,2.66'/%3E %3Cpath d='M96.591,119.43l2.975,2.66'/%3E %3Cpath d='M94.608,119.43l2.975,2.66'/%3E %3Cpath d='M92.625,119.43l2.975,2.66'/%3E %3Cpath d='M90.642,119.43l2.975,2.66'/%3E %3Cpath d='M88.659,119.43l2.975,2.66'/%3E %3Cpath d='M86.676,119.43l2.975,2.66'/%3E %3Cpath d='M84.693,119.43l2.975,2.66'/%3E %3Cpath d='M82.71,119.43l2.975,2.66'/%3E %3Cpath d='M80.727,119.43l2.975,2.66'/%3E %3Cpath d='M78.744,119.43l2.975,2.66'/%3E %3Cpath d='M76.761,119.43l2.974,2.66'/%3E %3Cpath d='M84.693,119.43l2.975,2.66'/%3E %3Cpath d='M74.778,119.43l2.974,2.66'/%3E %3Cpath d='M72.795,119.43l2.974,2.66'/%3E %3Cpath d='M70.812,119.43l2.974,2.66'/%3E %3Cpath d='M68.829,119.43l2.974,2.66'/%3E %3C/g%3E %3Cuse xlink:href='%23a' x='-300' transform='scale(-1,1)'/%3E %3Cg id='b'%3E %3Cpath d='M126.51,147.12c-48.114,47.05-68.638,53-59.006,56.79s40.616-20.49,72.856-52.75c32.24-32.25,51.98-60.956,42.35-64.747-9.63-3.792-5.03,10.662-56.2,60.707z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.42368097pt' fill='%23fff'/%3E %3Cpath d='M86.008,181.31l16.852,4.42c-15.861,15.03-33.708,21.22-38.665,18.57-4.958-2.65,8.923-8.84,21.813-22.99z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M86.008,183.08l13.881,3.54c-15.453,14.45-30.737,18.56-34.692,16.8-3.977-1.77,8.255-6.74,20.811-20.34z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028045' fill='%23fff'/%3E %3Cpath d='M137.79,145.06c-0.04,0.23-0.15,1.24-0.25,1.64,0,0.56-0.06,0.98-0.12,1.42-0.16,0.38-0.13,0.73-0.62,0.87-0.33,0.46-0.54,0.58-0.98,0.77-0.3,0.23-0.76,0.46-1.24,0.65-0.49,0.19-0.94,0.21-1.47,0.11-0.44-0.27-0.75-0.54-1.11-0.76-0.09-0.35-0.16-0.86-0.25-1.2,0.13,0.35,0.23,0.91,0.25,1.41-0.05,0.55-0.25,0.79-0.49,1.2' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M133.23,152.37c-0.04-0.03-0.08-0.07-0.12-0.11,0.29,0.26,0.17,0.14-0.5-0.21-0.47-0.22-0.98-0.34-1.6-0.44h-1.72c-0.67,0-1.12,0.09-1.6,0.22-0.35,0.31-0.87,0.48-1.23,0.76-0.38,0.23-0.54,0.5-0.74,0.87-0.34,0.3-0.56,0.76-0.87,0.99-0.13,0.5-0.42,0.48-0.61,0.87,0.58,0.04,1.05,0.11,1.35,0.43,0.52,0.24-0.43-0.23-0.61-0.43-0.41-0.11-0.51-0.22-1.11-0.22-0.56-0.16-0.9,0.13-1.48,0.22-0.33,0.17-0.43,0.22-0.86,0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M126.58,157.83c-0.25,0.01-1.4,0.2-1.85,0-0.5-0.12-0.8-0.36-1.11-0.77-0.15-0.29,0,0.53,0,0.88-0.05,0.64-0.27,0.65-0.61,1.09-0.36,0.2-0.74,0.49-1.11,0.65-0.31,0.24-0.69,0.4-1.11,0.55-0.37,0.15-0.81,0.31-1.11,0.54-0.41,0.26-0.37,0.58-0.61,0.98,0.04,0.54,0.14,0.84,0.49,1.1,0.14,0.36,0.47,0.73,0.74,0.98,0.3,0.5,0.64,0.73-0.13,0.87-0.42,0.16-0.65,0.03-1.1,0' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M118.82,165.46c-0.3-0.06-1.38-0.38-1.85-0.54h-1.72c-0.67,0.04-0.8,0.22-1.36,0.43-0.36,0.33-0.61,0.56-1.11,0.77-0.26,0.3-0.78,0.81-0.98,1.2-0.15,0.37-0.25,0.87-0.25,1.42,0.01,0.63,0.2,0.74,0.25,1.31,0.14,0.46,0.36,0.89,0.74,1.3,0.05,0.14,0.09,0.18,0.24,0.22' stroke='%23db161b' stroke-width='0.33028081' fill='none'/%3E %3Cpath d='M112.95,173c-0.05,0-0.17,0.28-0.35,0.52-0.39,0.4-0.44,0.43-1.05,0.43-0.54-0.02-0.49-0.21-0.87-0.35-0.18-0.27-0.41-0.49-0.61-0.86-0.14-0.22-0.27-0.57-0.44-0.77-0.16-0.26-0.36-0.45-0.53-0.69-0.16-0.07-0.22-0.14-0.43-0.17,0.5,0.08,0.54,0.25,0.87,0.51,0.15,0.25,0.31,0.5,0.44,0.78,0.05,0.37,0.17,0.66,0.17,1.12,0,0.47,0,0.81-0.17,1.2-0.21,0.22-0.36,0.44-0.61,0.61-0.21,0.19-0.46,0.45-0.62,0.68-0.27,0.17-0.47,0.31-0.78,0.52-0.27,0.15-0.55,0.31-0.96,0.35-0.52-0.04-0.67-0.18-1.05-0.35-0.33-0.24-0.59-0.39-0.88-0.6-0.23-0.16-0.46-0.47-0.61-0.69-0.47-0.12-0.77-0.07-1.05,0.17-0.24,0.16-0.45,0.37-0.61,0.6-0.15,0.07-0.38,0.28-0.53,0.35' stroke='%23db161b' stroke-width='0.33028191' fill='none'/%3E %3Cpath d='M103.32,176.56c0.14,0.06,0.64,0.41,0.87,0.54,0.14,0.45,0.36,0.7,0.43,1.18,0.12,0.47,0.11,0.98,0.11,1.51-0.12,0.55-0.35,0.95-0.54,1.39-0.35,0.24-0.52,0.4-0.98,0.65-0.43,0.06-0.86,0.11-1.41,0.11-0.34,0.11-0.98,0.16-1.31,0-0.48-0.07-0.843-0.26-1.194-0.43-0.402-0.23-0.649-0.44-1.088-0.65-0.213-0.31-0.544-0.59-0.869-0.97-0.271-0.36-0.47-0.56-0.653-0.96,0.161,0.46,0.405,0.86,0.544,1.29,0.247,0.45,0.391,0.62,0.435,1.18,0.151,0.45,0.109,0.99,0.109,1.5-0.048,0.35-0.073,1.01-0.218,1.29v0.33' stroke='%23db161b' stroke-width='0.33028162' fill='none'/%3E %3Cpath d='M87.242,186.23v0.16c0-0.42-0.011-0.21,0.175,0.62,0.33,0.37,1.104,0.47,1.749,0.31,0.566-0.41,0.548-0.73,1.574-0.93,0.991,0.06,1.369,0.32,1.924,0.62,0.658,0.29,0.962,0.44,1.399,1.09,0.217,0.53,0.338,0.89-0.35,1.09-0.547,0.35-1.197,0.54-1.924,0.63-0.808,0-1.39-0.09-1.749,0.31-0.555,0.51-0.524,0.82-0.524,1.71-0.187,0.28-0.224,1.1-0.35,1.41-0.486,0.2-0.771,0.31-1.574,0.31-0.189-0.48-0.398-1.35-0.525-1.87-0.137-0.56-0.179-1.34-0.525-1.72-0.326-0.42-0.743-0.8-1.224-1.09-0.214-0.27-0.622-0.49-1.049-0.62,0.686,0.31,0.784,0.65,0.874,1.4-0.603,0.27-0.764,0.46-1.749,0.47-0.968-0.07-1.202-0.29-1.574-0.78-0.067,0.78-0.348,1.04-0.524,1.72-0.36,0.47-0.513,0.95-0.875,1.55,0.154,0.76,0.486,0.79,0.525,1.72,0.227,0.61,0.202,1.19,0.699,1.56,0.222,0.24,0.388,0.29,0.875,0.31-1.013,0-1.603-0.1-2.274-0.47-0.519-0.28-0.911-0.64-1.399-0.93-0.619-0.4-1.384-0.77-2.099-0.94-0.808,0-1.39-0.08-1.749,0.31-0.495,0.32-0.828,0.86-1.049,1.56-0.162,0.81-0.224,1.35,0.175,1.87,0.296,0.61,0.363,0.84,0,1.56-0.407,0.51-1.012,0.57-1.924,0.78-0.666-0.03-1.306-0.16-1.749-0.31' stroke='%23db161b' stroke-width='0.33028123' fill='none'/%3E %3Cpath d='M181.41,104.66c21.35-36.858,35.52-68.222,31.62-70.014-3.89-1.791-24.37,26.665-45.72,63.518l14.1,6.496z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33520904pt' fill='%23fff'/%3E %3Cpath d='M180,104.01c20.59-35.557,34.78-65.574,31.67-67.007s-22.35,26.258-42.95,61.81' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.29448283pt' fill='%23fff'/%3E %3Cpath d='M176.46,85.461c-2.51,4.157-5.16,8.908-7.74,13.352l11.28,5.197c2.57-4.448,5.38-9.13,7.73-13.356l-11.27-5.193z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M177.41,86.895c-2.5,4.157-4.25,7.338-6.82,11.782l8.45,3.893c2.58-4.442,4.48-7.554,6.83-11.78l-8.46-3.895z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Crect transform='matrix(-0.9083207,-0.4182743,-0.5012544,0.8653,0,0)' height='9.9849' width='6.2072' stroke='%23db161b' y='6.5585' x='-205.69' stroke-width='0.33495pt' fill='%23fff'/%3E %3Cpath d='M183.55,91.712l-10.64,6.043' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M178.54,100.35l-0.63-11.235' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cpath d='M209.03,47.727l-5.64-2.597' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33422136pt' fill='%23fff'/%3E %3Cellipse rx='3.5433' ry='3.5433' stroke='%23db161b' transform='matrix(-0.4490005,0.1132067,0.1013394,0.3938715,444.34717,-55.797864)' cy='92.126' cx='545.67' stroke-width='1pt' fill='%23db161b'/%3E %3C/g%3E %3Cuse xlink:href='%23b' x='-300' transform='scale(-1,1)'/%3E %3Cpath d='M135.26,84.958c0,30.942,0.18,42.602-2.1,44.202-2.16,1.71-62.348,0-62.348,8.84s49.578,17.68,64.448,17.68c19.83,0,29.75-8.84,29.75-26.52v-44.202h-29.75z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.30510197pt' fill='%23fff'/%3E %3Cpath d='M135.26,93.798v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.474-19.83,1.474-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,84.958v4.42c9.92,1.473,19.83,1.473,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,89.378v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M135.26,98.218v4.422c9.92,1.47,19.83,1.47,29.75,0v-4.422c-9.92,1.474-19.83,1.474-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402506,84.325604)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402534,84.325604)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='%23fff'/%3E %3Cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Cpath d='M135.26,107.06l29.75,23.87'/%3E %3Cpath d='M138.23,107.06l26.78,21.21'/%3E %3Cpath d='M142.2,107.94l22.81,17.68'/%3E %3Cpath d='M145.18,107.94l19.83,15.03'/%3E %3Cpath d='M148.15,107.94l16.86,12.38'/%3E %3Cpath d='M151.12,107.94l13.89,9.73'/%3E %3Cpath d='M154.1,107.94l10.91,7.07'/%3E %3Cpath d='M157.07,107.94l7.94,5.31'/%3E %3Cpath d='M160.05,107.94l4.96,3.54'/%3E %3Cpath d='M163.02,107.94l1.99,1.77'/%3E %3Cpath d='M135.26,109.71l29.75,23.87'/%3E %3Cpath d='M165.01,107.06l-32.72,26.52'/%3E %3Cpath d='M162.03,107.06l-28.75,22.98'/%3E %3Cpath d='M158.07,107.94l-22.81,17.68'/%3E %3Cpath d='M155.09,107.94l-19.83,15.03'/%3E %3Cpath d='M152.12,107.94l-16.86,12.38'/%3E %3Cpath d='M149.14,107.94l-13.88,9.73'/%3E %3Cpath d='M146.17,107.94l-10.91,7.07'/%3E %3Cpath d='M143.19,107.94l-7.93,5.31'/%3E %3Cpath d='M140.22,107.94l-4.96,3.54'/%3E %3Cpath d='M137.24,107.94l-1.98,1.77'/%3E %3Cpath d='M165.01,109.71l-32.72,26.52'/%3E %3Cpath d='M165.01,112.36l-32.72,26.52'/%3E %3Cpath d='M165.01,115.01l-32.72,26.53'/%3E %3Cpath d='M165.01,117.67l-32.72,26.52'/%3E %3Cpath d='M165.01,120.32l-32.72,26.52'/%3E %3Cpath d='M165.01,122.97l-32.72,26.52'/%3E %3Cpath d='M165.01,125.62l-32.72,26.52'/%3E %3Cpath d='M165.01,128.28l-32.72,26.52'/%3E %3Cpath d='M165.01,130.93l-30.74,24.75'/%3E %3Cpath d='M165.01,133.58l-27.77,22.1'/%3E %3Cpath d='M164.01,137.12l-21.81,17.68'/%3E %3Cpath d='M163.02,140.65l-17.84,14.15'/%3E %3Cpath d='M161.04,145.07l-8.92,7.07'/%3E %3Cpath d='M135.26,112.36l28.75,22.99'/%3E %3Cpath d='M135.26,115.01l28.75,22.99'/%3E %3Cpath d='M135.26,117.67l27.76,22.1'/%3E %3Cpath d='M135.26,120.32l27.76,22.1'/%3E %3Cpath d='M135.26,122.97l26.77,21.22'/%3E %3Cpath d='M134.27,124.74l26.77,21.22'/%3E %3Cpath d='M134.27,127.39l24.79,19.45'/%3E %3Cpath d='M133.28,129.16l24.79,19.45'/%3E %3Cpath d='M132.29,130.93l23.79,18.56'/%3E %3Cpath d='M132.29,133.58l22.8,17.68'/%3E %3Cpath d='M132.29,136.23l19.83,15.91'/%3E %3C/g%3E %3Cpath d='M135.26,102.64v4.42c9.92,1.47,19.83,1.47,29.75,0v-4.42c-9.92,1.47-19.83,1.47-29.75,0z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M132.29,138.88l17.84,14.15' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,141.54l15.86,12.37' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,144.19l13.88,10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,146.84l9.91,7.96' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,149.49l7.93,6.19' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M132.29,152.14l4.95,3.54' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402506,97.586004)' cy='210.83' cx='256.89' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)' cy='246.26' cx='292.32' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)' cy='263.98' cx='327.76' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)' cy='263.98' cx='363.19' stroke-width='4.4629' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)' cy='246.26' cx='398.62' stroke-width='4.4628' fill='%23fff'/%3E %3Cellipse rx='8.8583' ry='26.575' stroke='%23db161b' transform='matrix(0.1526333,0,0,3.5883686e-2,97.402534,97.586004)' cy='210.83' cx='434.06' stroke-width='4.4628' fill='%23fff'/%3E %3Cg fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'%3E %3Cpath d='M92.625,148.61l35.695-18.57'/%3E %3Cpath d='M90.642,147.72l33.708-17.68'/%3E %3Cpath d='M89.651,145.96l30.739-15.92'/%3E %3Cpath d='M88.659,144.19l26.771-14.15'/%3E %3Cpath d='M86.676,142.42l24.784-12.38'/%3E %3Cpath d='M87.668,139.77l16.852-8.84'/%3E %3Cpath d='M86.676,138l12.89-7.07'/%3E %3Cpath d='M86.676,135.35l8.924-4.42'/%3E %3Cpath d='M95.6,149.49l33.71-17.68'/%3E %3Cpath d='M98.574,150.38l31.726-16.8'/%3E %3Cpath d='M101.55,151.26l29.74-15.91'/%3E %3Cpath d='M104.52,152.14l24.79-13.26'/%3E %3Cpath d='M108.49,152.14l21.81-11.49'/%3E %3Cpath d='M111.46,153.03l18.84-9.73'/%3E %3Cpath d='M114.44,153.91l14.87-7.95'/%3E %3Cpath d='M118.4,153.91l11.9-6.19'/%3E %3Cpath d='M122.37,154.8l7.93-4.42'/%3E %3Cpath d='M126.34,154.8l4.95-2.66'/%3E %3C/g%3E %3Cpath d='M133.28,129.16h-4.96c-1.65,8.84-1.65,17.68,0,26.52h4.96c-1.66-8.84-1.66-17.68,0-26.52z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422367pt' fill='%23fff'/%3E %3Cpath d='M74.778,141.54l11.898-8.84' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M74.778,135.35l11.898,10.61' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26422498pt' fill='%23fff'/%3E %3Cpath d='M92.625,130.93l-5.949,0.88c-1.322,5.6-1.322,10.31,0,15.91l5.949,1.77c-1.322-5.6-1.322-12.96,0-18.56z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.18807621pt' fill='%23fff'/%3E %3Cpath d='M164.97,86.726v-4.457c-4.45,0.037-7.43-2.615-7.43-5.305l-14.85,0.037c0,2.653-2.97,5.305-7.43,5.305v4.42h29.71z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.32342911pt' fill='%23fff'/%3E %3Crect height='5.3041' width='12.734' stroke='%23db161b' y='71.697' x='143.75' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='5.3042' width='10.612' stroke='%23db161b' y='66.393' x='144.81' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='5.3042' width='10.612' stroke='%23db161b' y='61.089' x='144.81' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='7.0722' width='8.4893' stroke='%23db161b' y='54.017' x='145.87' stroke-width='0.27335pt' fill='%23fff'/%3E %3Crect height='6.1882' width='9.2211' stroke='%23db161b' y='47.829' x='145.51' stroke-width='0.28488pt' fill='%23fff'/%3E %3Cellipse rx='42.52' ry='33.661' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,81.982856,1.8592021)' cy='161.22' cx='237.4' stroke-width='1pt' fill='%23fff'/%3E %3Cpath d='M156.78,41.64c0,2.319,3.07,6.189,3.07,6.189-2.23,1.52-5.83,2.652-9.22,2.652s-7.62-0.631-9.22-2.652c0,0,3.07-3.87,3.07-6.189,0-2.318-3.07-5.304-3.07-5.304,2.22-1.52,5.83-2.652,9.22-2.652s6.99,1.132,9.22,2.652c0,0-3.07,2.986-3.07,5.304z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='%23fff'/%3E %3Cpath d='M154.73,41.64c0,2.319,3.07,7.073,3.07,7.073-2.22,1.52-3.78,1.768-7.17,1.768s-5.57,0.253-7.17-1.768c0,0,3.07-4.754,3.07-7.073,0-2.318-3.07-6.188-3.07-6.188,2.22-1.52,3.78-1.768,7.17-1.768s4.95,0.248,7.17,1.768c0,0-3.07,3.87-3.07,6.188z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.26859274pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,81.982856,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,106.57247,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,94.277639,0.9751721)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2891558,0,0,0.249492,94.277639,-7.8650879)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823,0,0,0.249492,83.263631,42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.2994823,0,0,0.249492,100.24214,42.524442)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Cpath d='M142.69,77.001h14.85l-7.42,7.957-7.43-7.957z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.27334673pt' fill='%23fff'/%3E %3Cellipse rx='10.63' ry='10.63' stroke='%23db161b' transform='matrix(0.3993101,0,0,0.3326564,72.298311,27.790617)' cy='166.54' cx='194.88' stroke-width='1pt' fill='%23fff'/%3E %3Crect rx='1.2377' ry='0.93811' height='5.3042' width='22.805' stroke='%23db161b' y='109.72' x='133.77' stroke-width='0.33028' fill='%23fff'/%3E %3Cpath d='M163.52,105.3c-2.75,0-4.96,2.06-4.96,4.62v4.02c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0,1.77c-1.65,0-2.98,1.65-2.98,3.7v2.33c0,2.05,1.33,3.69,2.98,3.69s2.97-1.64,2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M137.74,106.19c-1.65,0-2.97,1.64-2.97,3.69v4.1c0,2.05,1.32,3.7,2.97,3.7s2.97-1.65,2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75,0-4.96,2.06-4.96,4.62v5.79c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M129.81,107.95c-1.65,0-2.98,1.65-2.98,3.7v0.96c0,2.05,1.33,3.7,2.98,3.7s2.97-1.65,2.97-3.7v-0.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75,0-4.96,2.06-4.96,4.62v2.65c0,2.56,2.21,4.62,4.96,4.62,2.74,0,4.96-2.06,4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028123' fill='%23fff'/%3E %3Cpath d='M117.91,105.51c-2.97,0-5.35,1.84-5.35,4.13v4.58c0,2.29,2.38,4.13,5.35,4.13s5.35-1.84,5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94,0-8.92,2.31-8.92,5.17v6.47c0,2.86,3.98,5.16,8.92,5.16s8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='%23fff'/%3E %3Cpath d='M182.36,106.39c-2.97,0-5.36,1.85-5.36,4.14v4.58c0,2.29,2.39,4.13,5.36,4.13,2.96,0,5.35-1.84,5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95,0-8.93,2.3-8.93,5.16v6.47c0,2.86,3.98,5.16,8.93,5.16,4.94,0,8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z' fill-rule='evenodd' stroke='%23db161b' stroke-width='0.33028102' fill='%23fff'/%3E %3Crect rx='0.64577' ry='0.93811' height='5.3042' width='11.898' stroke='%23db161b' y='109.72' x='165.5' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='154.6' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.3767' ry='1.2508' height='7.0722' width='6.9406' stroke='%23db161b' y='108.84' x='121.88' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.7534' ry='1.5635' height='8.8403' width='13.881' stroke='%23db161b' y='107.95' x='100.06' stroke-width='0.33028' fill='%23fff'/%3E %3Crect rx='0.69959' ry='1.5635' height='8.8403' width='12.89' stroke='%23db161b' y='108.84' x='186.32' stroke-width='0.33028' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' height='600' width='1200'%3E %3Cdefs%3E %3CclipPath id='Canton'%3E %3Cpath d='M 0,0 L 600,0 L 600,300 L 0,300 z'/%3E %3C/clipPath%3E %3CclipPath id='Diagonals'%3E %3Cpath d='M 0,0 L 300,150 L 0,150 z M 300,0 L 600,0 L 300,150 z M 300,150 L 600,150 L 600,300 z M 300,150 L 300,300 L 0,300 z'/%3E %3C/clipPath%3E %3Cg id='Pentagram'%3E %3Cg id='Arm' transform='translate(0,-0.324925)'%3E %3Cpath d='M 0,0 L 0,0.5 L 1,0 z'/%3E %3Cpath d='M 0,0 L 0,-0.5 L 1,0 z' transform='rotate(-36,1,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23Arm' transform='scale(-1,1)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(72,0,0)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(-72,0,0)'/%3E %3Cuse xlink:href='%23Arm' transform='rotate(-72,0,0) scale(-1,1)'/%3E %3C/g%3E %3C/defs%3E %3Crect fill='%2300247d' x='0' y='0' width='1200' height='600'/%3E %3Cg id='Flag_of_the_United_Kingdom'%3E %3Cpath id='Saint_Andrews_Cross' stroke='%23ffffff' d='M 0,0 L 600,300 M 0,300 L 600,0' stroke-width='60' clip-path='url(%23Canton)'/%3E %3Cpath id='Saint_Patricks_Cross' stroke='%23cc142b' d='M 0,0 L 600,300 M 0,300 L 600,0' stroke-width='40' clip-path='url(%23Diagonals)'/%3E %3Cg id='Saint_Georges_Cross'%3E %3Cpath stroke='%23ffffff' d='M 300,0 L 300,300 M 0,150 L 600,150' stroke-width='100' clip-path='url(%23Canton)'/%3E %3Cpath stroke='%23cc142b' d='M 300,0 L 300,300 M 0,150 L 600,150' stroke-width='60' clip-path='url(%23Canton)'/%3E %3C/g%3E %3C/g%3E %3Cg id='Southern_Cross'%3E %3Cg id='Gamma_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,120) scale(45.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,120) scale(30)'/%3E %3C/g%3E %3Cg transform='rotate(82,900,240)'%3E %3Cg id='Delta_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,120) rotate(-82) scale(40.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,120) rotate(-82) scale(25)'/%3E %3C/g%3E %3Cg id='Beta_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,380) rotate(-82) scale(45.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,380) rotate(-82) scale(30)'/%3E %3C/g%3E %3C/g%3E %3Cg id='Alpha_Crucis'%3E %3Cuse xlink:href='%23Pentagram' fill='%23ffffff' transform='translate(900,480) scale(50.4)'/%3E %3Cuse xlink:href='%23Pentagram' fill='%23cc142b' transform='translate(900,480) scale(35)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 120 60'%3E %3CclipPath id='t'%3E %3Cpath d='M0,0V15H70V30H60zM0,30V40H30V0H60z'/%3E %3C/clipPath%3E %3Ctitle%3EFlag of Niue%3C/title%3E %3Crect width='120' height='60' fill='%23002868'/%3E %3Cg stroke='%23cf142b' stroke-width='6'%3E %3Cpath d='M0,0L60,30M60,0L0,30' stroke='%23fff'/%3E %3Cpath d='M0,0L60,30M60,0L0,30' clip-path='url(%23t)' stroke-width='4'/%3E %3Cpath d='M30,0V40M0,15H70' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0V40M0,15H70'/%3E %3C/g%3E %3Cpath d='M60,0h60V60H0V30H60z' fill='%23fcd116'/%3E %3Cg transform='translate(30,15)'%3E %3Cg transform='scale(5.10390485)'%3E %3Ccircle r='1' fill='%23002868'/%3E %3Cpath id='s' d='M0,-513674 301930,415571 -488533,-158734H488533L-301930,415571' fill='%23fcd116' transform='scale(0.00000194676)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' transform='translate(-17.5,0.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(17.5,0.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(0,10.29) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(0,-9.71) scale(3)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300'%3E %3Crect fill='%23002b7f' width='600' height='300'/%3E %3Crect fill='%23ffc61e' y='137.5' width='600' height='25'/%3E %3Cpath fill='%23fff' d='M 150,262.5 L 143.5295,236.6481 L 125,255.8012 L 132.3223,230.1777 L 106.6987,237.5 L 125.8519,218.9705 L 100,212.5 L 125.8519,206.0295 L 106.6987,187.5 L 132.3223,194.8223 L 125,169.1988 L 143.5295,188.3519 L 150,162.5 L 156.4705,188.3519 L 175,169.1988 L 167.6777,194.8223 L 193.3013,187.5 L 174.1481,206.0295 L 200,212.5 L 174.1481,218.9705 L 193.3013,237.5 L 167.6777,230.1777 L 175,255.8012 L 156.4705,236.6481 L 150,262.5 z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' version='1.1' width='726' height='885' viewBox='-17.582 -4.664 71.571 87.246'%3E %3Ctitle%3EFlag of Nepal%3C/title%3E %3Cdesc%3ECoding according to the official construction in 'Constitution of the Kingdom of Nepal, Article 5, Shedule 1', adopted in November 1990%3C/desc%3E %3C!-- 2*TN= (17955-7335*Sqrt(2))/1468 --%3E %3Cuse xlink:href='%23b' stroke='%23003893' stroke-width='5.1646754223'/%3E %3C!-- F,G,C,A,B,D --%3E %3C!-- Fy=Gy = 80-30*Sqrt(2) --%3E %3Cpath id='b' d='M -15,37.5735931288 h 60 L -15,0 v 80 h 60 L -15,20 z' fill='%23DC143C'/%3E %3Cg fill='%23fff'%3E %3C!-- LN = -Px = Qx = 5/4*Sqrt(609-366*Sqrt(2)), Py = Qy= 50-75/4*Sqrt(2) --%3E %3C!-- MQ = 5/4*(23-9*Sqrt(2)) --%3E %3Cpath d='M -11.9502769431,23.4834957055 A 12.8400974233,12.8400974233 0 0,0 11.9502769431,23.4834957055 A 11.9502769431 11.9502769431 0 0,1 -11.9502769431,23.4834957055'/%3E %3C!-- Px, Py, MQ, MQ, Qx, Qy, LN, LN, Px, Py --%3E %3C!-- Ty = (183895-69735*Sqrt(2))/2936 TM = (37095-14685*Sqrt(2))/2936 --%3E %3Cg transform='translate(0,29.0445562765) scale(5.5610605710)'%3E %3Ccircle r='1'/%3E %3Cg id='jags6'%3E %3Cg id='jags3'%3E %3C!-- sin(Pi/16),-cos(Pi/16), 0, -TS/TM = -Sqrt(884995-8076*Sqrt(2))/673, -sin(Pi/16),-cos(Pi/16) --%3E %3Cpath id='jag' d='M 0.195090322016,-0.980785280403 L 0,-1.388784109750 L -0.195090322016,-0.980785280403' transform='rotate(11.25)'/%3E %3Cuse xlink:href='%23jag' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23jag' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23jags3' transform='rotate(67.5)'/%3E %3C/g%3E %3Cuse xlink:href='%23jags6' transform='scale(-1, 1)'/%3E %3C/g%3E %3C!-- Wy = 80-15*Sqrt(2) NM= 15/4*(5-2*Sqrt(2)) --%3E %3Cg transform='translate(0,58.7867965644) scale(8.1433982822)'%3E %3Ccircle r='1'/%3E %3Cg id='rays4'%3E %3Cg id='rays2'%3E %3C!-- sin(Pi/12),cos(Pi/12), 0, LN/NM=(79+Sqrt(2))/51, -sin(Pi/12),cos(Pi/12) --%3E %3Cpath id='ray' d='M 0.258819045103,0.965925826289 L 0,1.576749285537 L -0.258819045103,0.965925826289'/%3E %3Cuse xlink:href='%23ray' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays2' transform='rotate(90)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays4' transform='rotate(30)'/%3E %3Cuse xlink:href='%23rays4' transform='rotate(60)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='1100' height='800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 9 6'%3E %3Crect fill='%2321468B' width='9' height='6'/%3E %3Crect fill='%23FFF' width='9' height='4'/%3E %3Crect fill='%23AE1C28' width='9' height='2'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='600'%3E %3Cdefs%3E %3ClinearGradient id='cap1' gradientUnits='userSpaceOnUse' x1='498.738' y1='289.055' x2='500.626' y2='283.42'%3E %3Cstop stop-color='%23510000' offset='0'/%3E %3Cstop stop-color='%238a0000' offset='0.3'/%3E %3Cstop stop-color='%23a00' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='cap2' gradientUnits='userSpaceOnUse' x1='501.444' y1='291.373' x2='502.927' y2='287.449'%3E %3Cstop stop-color='%23ff2a2a' offset='0'/%3E %3Cstop stop-color='%23f00' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='mountain' gradientUnits='userSpaceOnUse' x1='484.764' y1='311.709' x2='484.764' y2='317.647'%3E %3Cstop stop-color='%23F5F549' offset='0'/%3E %3Cstop stop-color='%2397C924' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='seafgrad'%3E %3Cstop stop-color='%23025' offset='0'/%3E %3Cstop stop-color='%2304a' offset='0.5'/%3E %3Cstop stop-color='%23025' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='seabgrad' xlink:href='%23seafgrad' gradientUnits='userSpaceOnUse' x1='444.509' y1='317.486' x2='634.411' y2='317.486'/%3E %3CclipPath id='shield'%3E %3Cpath fill='%23000' d='m500,226.375 -63.7015,110.332h127.401z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1000' height='600' fill='%230067C6'/%3E %3Crect width='1000' height='200' y='200' fill='%23fff'/%3E %3Cg id='text' fill='%23c8a400'%3E %3Cpath d='m410,299.329c3.32634,0.22223,6.65268,0.44445,9.97902,0.66668,0.0329-0.48587,0.064-0.97205,0.0981-1.45773-1.30824-0.0873-2.61644-0.17511-3.92471-0.26198,0.0986-1.60327,0.23297-3.20473,0.3036-4.80942,1.38833-1.00412,2.77759-2.00697,4.16149-3.01719,0.0412-0.61599,0.0823-1.23197,0.12346-1.84796-1.46281,1.06196-2.92562,2.12393-4.38843,3.18589-0.14757-1.03794-0.72165-2.10727-1.76463-2.46788-0.91323-0.33059-2.03168-0.3884-2.82311,0.26424-1.00326,0.738-1.18359,2.05857-1.31388,3.20783-0.17463,2.17695-0.29658,4.35998-0.45091,6.53752zm1.51943-1.36222c0.12006-1.63759,0.19451-3.27916,0.35147-4.91355,0.12284-0.80837,0.27116-1.7421,0.97877-2.25692,0.63951-0.42451,1.58455-0.10865,1.84624,0.61403,0.52201,1.24667,0.29033,2.62159,0.22338,3.93021-0.0632,0.94689-0.12655,1.89378-0.18977,2.84068-1.06985-0.0707-2.14151-0.14232-3.21009-0.21445z'/%3E %3Cpath d='m411.299,284.006c3.24602,0.75791,6.49205,1.51582,9.73807,2.27373,0.73769-3.1594,1.47537-6.31879,2.21306-9.47819-0.4612-0.10769-0.92241-0.21537-1.38361-0.32306-0.62753,2.68761-1.25507,5.37521-1.8826,8.06282-0.98811-0.2308-1.97626-0.4614-2.96437-0.69221,0.56551-2.42194,1.13101-4.84387,1.69651-7.26581-0.45886-0.10714-0.91773-0.21428-1.37659-0.32142-0.5655,2.42194-1.13099,4.84388-1.69649,7.26582-0.87427-0.20424-1.7486-0.40821-2.62286-0.61249,0.60401-2.58683,1.208-5.17367,1.812-7.7605-0.46355-0.10824-0.92711-0.21647-1.39066-0.32471-0.71415,3.05867-1.42831,6.11735-2.14246,9.17602z'/%3E %3Cpath d='m414.807,270.929c3.14837,1.09493,6.29675,2.18986,9.44512,3.28479,0.15992-0.45982,0.31983-0.91964,0.47975-1.37946-1.2384-0.4307-2.47682-0.86135-3.71521-1.29209,0.48491-1.42877,1.01619-2.8425,1.46212-4.28396,0.31982-1.1769,0.56684-2.55272-0.12567-3.64707-0.56233-0.80874-1.56218-1.32766-2.54938-1.29642-1.08858,0.0466-1.97544,0.84759-2.45833,1.77548-0.71429,1.34208-1.11369,2.81798-1.63458,4.23987-0.30127,0.86629-0.60255,1.73257-0.90382,2.59886zm1.82516-0.91156c0.50573-1.41719,0.96234-2.85276,1.50949-4.25451,0.34032-0.74874,0.75526-1.63711,1.61685-1.87541,0.70884-0.16219,1.45167,0.38249,1.5132,1.10855,0.17309,1.3358-0.4107,2.59669-0.82087,3.83664-0.25986,0.74722-0.51973,1.49444-0.77958,2.24166-1.01301-0.35237-2.02604-0.70467-3.03909-1.05693z'/%3E %3Cpath d='m420.024,258.833c1.78079,1.03286,3.54652,2.09256,5.33751,3.10726,1.01015,0.54316,2.29139,0.85386,3.34732,0.24536,1.44062-0.79757,2.34305-2.27069,3.05103-3.70714,0.55788-1.21033,0.96223-2.71397,0.25161-3.95061-0.76525-1.23498-2.15613-1.80264-3.34366-2.54015-1.15241-0.67405-2.30482-1.34811-3.45723-2.02216-0.2446,0.4182-0.4892,0.83639-0.7338,1.25459,1.69411,0.99759,3.40038,1.97522,5.08648,2.98594,0.80638,0.49107,1.47446,1.38051,1.33556,2.36857-0.15909,1.178-0.83235,2.21182-1.50327,3.1639-0.5532,0.77126-1.48261,1.39382-2.46901,1.18523-1.02907-0.19727-1.86511-0.87054-2.7694-1.35707-1.13311-0.66277-2.26623-1.32553-3.39934-1.9883-0.24459,0.41819-0.48923,0.83643-0.7338,1.25458z'/%3E %3Cpath d='m427.227,247.062c2.64728,2.02559,5.29456,4.05117,7.94184,6.07676,1.2324-1.60897,2.45998-3.22252,3.70139-4.82374,0.71204-1.0218,1.36783-2.35063,0.88541-3.60415-0.43852-0.99742-1.46605-1.76954-2.56718-1.82076-0.49731-0.0682-1.14581,0.30822-1.41493,0.47419,0.28305-1.06581-0.58942-2.0679-1.57186-2.35041-1.18182-0.42013-2.38052,0.33763-3.16221,1.17835-0.9204,1.00107-1.68892,2.12852-2.53072,3.19463-0.42725,0.55838-0.85449,1.11675-1.28174,1.67513zm2.01433-0.29772c0.92943-1.19063,1.80918-2.42176,2.78303-3.57628,0.45282-0.50395,1.17935-1.07479,1.88161-0.70532,0.64009,0.27772,0.79787,1.08511,0.49233,1.66627-0.48521,1.03983-1.28618,1.88276-1.95401,2.80542-0.36367,0.47529-0.72737,0.95057-1.09102,1.42588-0.70398-0.53866-1.40796-1.07732-2.11194-1.61597zm3.23588,2.47597c0.96434-1.2336,1.87255-2.51286,2.89009-3.70336,0.51954-0.54354,1.17239-1.22856,1.99705-1.07233,0.70444,0.16212,1.21664,0.92689,0.97341,1.63628-0.39626,1.30911-1.37599,2.31142-2.16426,3.39599-0.4137,0.54068-0.82742,1.08134-1.2411,1.62203-0.81839-0.62621-1.6368-1.2524-2.45519-1.87861z'/%3E %3Cpath d='m436.231,236.455,6.8675,7.26894,5.88255-5.55767-0.97575-1.03279-4.70554,4.44565-0.12052,0.11387-0.0869-0.092-5.80486-6.14418z'/%3E %3Cpath d='m445.035,228.752,6.09535,7.92761,1.18915-0.91429-6.09535-7.92762z'/%3E %3Cpath d='m453.991,222.67c-0.98774,0.61544-1.78425,1.33504-2.39782,2.17554-0.6112,0.83726-0.94122,1.71049-0.98884,2.62241-0.0476,0.91165,0.19536,1.79452,0.73286,2.6572,0.49251,0.79046,1.15266,1.40385,1.97619,1.84418,0.82023,0.43856,1.70565,0.60098,2.67598,0.49235,0.96511-0.10804,2.05508-0.53501,3.26884-1.29126,1.16547-0.72616,1.99135-1.56229,2.50028-2.52478,0.48822-0.92337,0.62578-1.90365,0.41645-2.94732l-1.38296,0.5422c0.36225,1.99857-0.92658,2.9588-2.36991,3.87479-2.2587,1.37399-4.45973,1.27451-5.80828-0.78982-1.39827-2.32778,0.12974-4.25089,2.05166-5.49964,1.36386-0.85119,2.70794-1.43321,3.98724-0.61857l1.08262-0.9642c-0.74564-0.51452-1.59209-0.75257-2.55559-0.6994-1.01162,0.0558-2.06822,0.42819-3.18872,1.12632z'/%3E %3Cpath d='m465.808,216.773-1.047,11.2056,1.55741-0.62791,0.31478-3.47417,0.006-0.003,5.05831-2.03938,2.63645,2.28431,1.5574-0.62791-8.52648-7.34584-1.5574,0.62791zm1.36835,1.14857,3.32461,2.87791-3.72338,1.50118,0.39877-4.37909z'/%3E %3Cpath d='m487.726,210.591c0.20805,3.32683,0.41609,6.65367,0.62414,9.9805,1.80444-0.12174,3.6118-0.20647,5.41405-0.35597,1.4176-0.16233,2.93884-0.53067,3.9077-1.65878,1.2513-1.3881,1.42875-3.46194,0.88129-5.18861-0.4596-1.52076-1.82744-2.6711-3.37555-2.9629-1.52435-0.29289-3.07841-0.0617-4.61381,0.008-0.94594,0.0591-1.89188,0.11841-2.83782,0.1774zm1.5393,1.32733c1.43646-0.0757,2.87074-0.21585,4.30969-0.22392,0.81646-0.0241,1.62864,0.21461,2.28786,0.70072,1.00072,0.68405,1.58799,1.91553,1.45667,3.12503-0.0712,1.38985-1.09329,2.66855-2.44413,3.02043-0.77283,0.19999-1.57593,0.25601-2.36712,0.34365-0.93214,0.0583-1.86428,0.11665-2.79643,0.17483-0.14939-2.38021-0.29825-4.76046-0.44654-7.14074z'/%3E %3Cpath d='m501.664,210c-0.19023,3.3279-0.38046,6.6558-0.57069,9.9837,3.23909,0.18516,6.47818,0.37031,9.71727,0.55547,0.027-0.47284,0.0541-0.94567,0.0811-1.41851-2.75541-0.1572-5.51074-0.31562-8.26619-0.47205,0.0573-1.01308,0.11603-2.02606,0.17328-3.03914,2.48308,0.14086,4.96605,0.28372,7.44909,0.42535,0.0269-0.47043,0.0538-0.94086,0.0807-1.41129-2.48304-0.14163-4.966-0.28449-7.44908-0.42535,0.0507-0.89637,0.10241-1.79268,0.15347-2.68903,2.65213,0.15053,5.30416,0.30305,7.95625,0.45434,0.0272-0.47524,0.0543-0.95049,0.0815-1.42573-3.13557-0.17925-6.27113-0.35851-9.4067-0.53776z'/%3E %3Cpath d='m527.774,214.166-3.61612,9.3233,1.28604,0.4988,2.86698-7.3919,0.14904-0.38427,0.15998,0.42657,3.44815,9.91881,1.68397,0.65315,3.61613-9.3233-1.28934-0.50007-2.86569,7.38853-0.1464,0.37752-0.158-0.42191-3.45405-9.91335z'/%3E %3Cpath d='m541.208,219.937-4.54582,8.90705-1.33607-0.68187,4.54582-8.90705z'/%3E %3Cpath d='m548.751,224.356c-0.97142-0.64089-1.95772-1.06453-2.97756-1.27147-1.01591-0.20614-1.9472-0.14174-2.79583,0.19546-0.84836,0.3371-1.54936,0.92626-2.1091,1.77467-0.51289,0.77738-0.79492,1.63325-0.85151,2.56539-0.0563,0.92841,0.16547,1.80086,0.66904,2.63737,0.50084,0.83202,1.34364,1.64445,2.53733,2.432,1.14619,0.75621,2.25064,1.15792,3.33769,1.21888,1.04287,0.0584,1.99114-0.22553,2.85229-0.85122l-1.06975-1.03062c-1.66517,1.16306-3.07555,0.39239-4.5102-0.53714-2.19107-1.47947-3.01898-3.52128-1.70555-5.60813,1.53212-2.24195,3.91737-1.65565,5.8541-0.43,1.3426,0.88435,2.43232,1.86302,2.22572,3.36554l1.32796,0.58161c0.15651-0.89231,0.0197-1.76089-0.43062-2.61434-0.47283-0.89607-1.25205-1.70096-2.35401-2.428z'/%3E %3Cpath d='m558.272,231.538-10.4535,4.16977,1.26814,1.10073,3.2365-1.30154,0.005,0.005,4.1188,3.57507-0.83343,3.38738,1.26814,1.10073,2.65816-10.936-1.26815-1.10073zm-0.39961,1.74123-1.0486,4.27035-3.03182-2.63158,4.08042-1.63877z'/%3E %3Cpath d='m565.825,238.486c-2.572,2.12101-5.14401,4.24201-7.71601,6.36302,0.30955,0.37576,0.6199,0.75094,0.92896,1.12706,1.01157-0.83421,2.02316-1.66839,3.03473-2.50261,1.02878,1.23361,2.02924,2.49136,3.07954,3.70663-0.32075,1.6831-0.6431,3.36591-0.95647,5.05041,0.39278,0.4763,0.78555,0.95259,1.17833,1.42889,0.33526-1.77628,0.67051-3.55257,1.00577-5.32885,0.86447,0.70788,2.1276,1.06331,3.16016,0.50203,0.88803-0.42012,1.67042-1.22768,1.7162-2.25661,0.10773-1.37866-0.87542-2.49623-1.66235-3.51871-1.25571-1.5241-2.5136-3.04745-3.76886-4.57126zm-0.17038,2.03353c1.08022,1.33434,2.21438,2.62669,3.24602,3.99893,0.47574,0.70741,1.06859,1.70139,0.52294,2.52797-0.44979,0.70689-1.43474,0.64494-2.03913,0.18646-1.2247-0.82376-2.0334-2.08693-2.9893-3.18371-0.40756-0.49424-0.81514-0.98846-1.2227-1.4827,0.82739-0.68229,1.6549-1.36466,2.48217-2.04695z'/%3E %3Cpath d='m577.523,254.401-11.2426,0.51528,0.83758,1.45542,3.48429-0.16949,0.003,0.006,2.72039,4.72706-1.89709,2.92745,0.83758,1.45542,6.09396-9.46182-0.83758-1.45542zm-0.94796,1.51425-2.38965,3.69121-2.00246-3.47954,4.39211-0.21167z'/%3E %3Cpath d='m583.939,267.638c-0.62517-1.69658-1.61122-3.43366-3.27989-4.28241-1.85658-0.93284-4.32804-0.47908-5.6446,1.15572-1.14698,1.35925-1.20561,3.28116-0.89925,4.9518,0.36199,1.91793,1.24128,3.74411,2.56297,5.18542-0.24899,0.0895-0.49798,0.17897-0.74697,0.26846,0.15949,0.44375,0.31898,0.88751,0.47847,1.33126,1.56145-0.56118,3.12289-1.12237,4.68434-1.68356-0.60724-1.6861-1.21448-3.37219-1.82172-5.05829-0.36076,0.12966-0.72152,0.25931-1.08228,0.38897,0.44666,1.24274,0.89326,2.4855,1.33997,3.72822-0.52894,0.19019-1.05794,0.38024-1.5869,0.57038-1.39993-1.20263-2.18095-2.98027-2.58642-4.74823-0.30073-1.32658-0.3127-2.91664,0.69375-3.96056,1.15449-1.20086,3.20117-1.57383,4.58696-0.54964,1.36679,1.00022,2.13826,2.6215,2.52811,4.233,0.26694,1.05995,0.22329,2.32-0.58098,3.14709-0.22477,0.16883,0.13155,0.40385,0.19251,0.60544,0.12747,0.21048,0.25493,0.42097,0.3824,0.63145,0.84766-0.66844,1.36007-1.71422,1.34362-2.79667,0.0283-1.06426-0.20642-2.12058-0.56409-3.11785z'/%3E %3Cpath d='m586.811,275.447-5.59255,1.08792c-1.03793,0.20191-1.81583,0.53072-2.3346,0.96809-0.51784,0.43655-0.84913,1.05225-1.00889,1.87102-0.15808,0.81019-0.13548,1.80286,0.0969,3.01081,0.002,0.009,0.004,0.0182,0.005,0.0277,0.23733,1.207,0.58855,2.13574,1.03883,2.82758,0.45504,0.69917,0.99299,1.14578,1.63672,1.35637,0.64489,0.21099,1.48934,0.2242,2.52725,0.0223l5.59255-1.08792-0.27754-1.42669-5.45747,1.06164c-2.44995,0.47659-3.27516-0.81293-3.69596-3.01869-0.002-0.009-0.003-0.0183-0.005-0.0277-0.43677-2.20264-0.15514-3.70748,2.2948-4.18408l5.45748-1.06164-0.27752-1.4267z'/%3E %3Cpath d='m589.879,292.467-10.3479-4.42525,0.12129,1.67483,3.21126,1.36264,0.00051,0.007,0.39395,5.43971-2.98142,1.8111,0.1213,1.67484,9.60233-5.87006-0.1213-1.67483zm-1.51216,0.95131-3.75709,2.28466-0.28998-4.00412,4.04707,1.71946z'/%3E %3Crect width='1.5' height='6.3' x='-322.944' y='414.199' transform='scale(-1,1) rotate(14.748924)'/%3E %3Crect width='1.5' height='6.3' x='644.14' y='159.606' transform='rotate(14.748924)'/%3E %3Cpath d='m433.217,343.989-11.1807,1.28621,0.93557,1.39445,3.46441-0.40839,0.004,0.006,3.03863,4.52906-1.69156,3.05083,0.93557,1.39445,5.42972-9.85801-0.93556-1.39445zm-0.84172,1.57578-2.13049,3.84662-2.23671-3.33381,4.3672-0.51281z'/%3E %3Cpath d='m437.497,350.098-7.12714,6.66478,0.95177,1.0178,6.00626-5.61661-3.15096,8.66999,1.09151,1.16724,8.61117-2.61405-5.89802,5.51541,0.95176,1.0178,7.12714-6.66478-1.44571-1.54602-8.75099,2.61438,3.27652-8.46862z'/%3E %3Cpath d='m447.878,360.689c-2.00517,2.66278-4.01035,5.32555-6.01552,7.98833,2.59171,1.95166,5.18343,3.90333,7.77514,5.85499,0.2849-0.37833,0.5698-0.75667,0.8547-1.135-2.2047-1.6602-4.40935-3.32047-6.61409-4.98063,0.61036-0.8106,1.2208-1.62113,1.83116-2.43173,1.98679,1.49606,3.97352,2.9922,5.96029,4.48829,0.28345-0.37641,0.5669-0.75281,0.85035-1.12922-1.98677-1.49609-3.9735-2.99224-5.96029-4.4883,0.54002-0.71722,1.08018-1.43435,1.62017-2.1516,2.12207,1.59791,4.24406,3.19593,6.3661,4.79388,0.28635-0.38026,0.5727-0.76052,0.85905-1.14078-2.50902-1.88941-5.01804-3.77882-7.52706-5.66823z'/%3E %3Cpath d='m457.662,367.85c-1.56999,2.94092-3.13997,5.88185-4.70996,8.82277,0.42937,0.22948,0.85923,0.45816,1.2883,0.68814,0.61751-1.15665,1.23489-2.31336,1.85248-3.46997,1.42112,0.74871,2.82545,1.53016,4.25943,2.25383,0.34467,1.67837,0.68772,3.35708,1.03974,5.03393,0.54461,0.29074,1.08923,0.58147,1.63384,0.87221-0.36674-1.77005-0.73349-3.5401-1.10023-5.31015,1.06896,0.32516,2.37225,0.17258,3.11309-0.73977,0.62944-0.70484,1.05797-1.69332,0.75635-2.63927-0.35132-1.30341-1.63425-1.98592-2.71701-2.61729-1.80294-0.96908-3.61175-1.92868-5.41603-2.89443zm0.61719,1.94509c1.50709,0.8222,3.04815,1.58484,4.52472,2.46067,0.68458,0.46205,1.55319,1.0947,1.46717,2.02654-0.0761,0.81768-0.95762,1.2541-1.70343,1.08062-1.45923-0.24188-2.68995-1.11223-3.9896-1.76124-0.60467-0.32278-1.20931-0.64561-1.814-0.96836,0.50503-0.94608,1.01013-1.89215,1.51514-2.83823z'/%3E %3Cpath d='m468.957,373.756-3.77856,9.25864,1.38879,0.5668,3.77856-9.25864z'/%3E %3Cpath d='m477.975,376.871c-1.1045-0.36671-2.16696-0.51975-3.20557-0.45482-1.03459,0.0647-1.91722,0.36866-2.6492,0.91462-0.73176,0.5458-1.25576,1.29675-1.57605,2.26139-0.29347,0.88389-0.34361,1.78363-0.15626,2.6985,0.18663,0.9112,0.62734,1.69614,1.33082,2.37323,0.69968,0.67346,1.72451,1.23922,3.08173,1.68985,1.30322,0.43271,2.4741,0.5339,3.5397,0.31054,1.02228-0.21431,1.8643-0.73475,2.53348-1.56255l-1.30064-0.71755c-1.30612,1.5555-2.86822,1.17743-4.495,0.65224-2.50004-0.85988-3.82967-2.61674-3.10307-4.97303,0.89751-2.56285,3.35319-2.61592,5.54172-1.93512,1.52616,0.50545,2.8326,1.16765,3.02317,2.67228l1.43343,0.2169c-0.0805-0.90234-0.43816-1.70562-1.09461-2.41289-0.68925-0.74259-1.65072-1.31757-2.90365-1.73359z'/%3E %3Cpath d='m488.029,379.122-6.54019,9.15906,1.66192,0.24047,2.01921-2.8446,0.007,0.001,5.39774,0.78104,1.13004,3.30029,1.66192,0.24048-3.6757-10.6373-1.66191-0.24047zm0.60512,1.6809,1.42636,4.15944-3.97323-0.57492,2.54687-3.58452z'/%3E %3Cpath d='m511.47,379.193c-1.14266,0.22076-2.14408,0.60727-3.01802,1.1722-0.87056,0.56274-1.4915,1.25979-1.86263,2.09414-0.37102,0.83409-0.46045,1.74541-0.26766,2.74338,0.17666,0.91443,0.57327,1.7236,1.1844,2.42972,0.6087,0.70328,1.37718,1.1721,2.32202,1.41827,0.93976,0.24486,2.11036,0.23669,3.51447-0.0346,1.34825-0.26047,2.41884-0.74526,3.23879-1.46156,0.7866-0.6872,1.26619-1.55314,1.44461-2.60254l-1.4854,0.0108c-0.37773,1.99571-1.925,2.43052-3.60068,2.76868-2.601,0.47368-4.62033-0.40766-5.13988-2.81808-0.47161-2.67419,1.64391-3.9223,3.88562-4.3997,1.57827-0.30613,3.04163-0.36804,3.94421,0.85082l1.35617-0.51239c-0.51183-0.74748-1.21684-1.27295-2.13544-1.56846-0.96449-0.31025-2.08436-0.34112-3.38058-0.0907z'/%3E %3Cpath d='m518.148,378.01c0.94813,3.19565,1.89626,6.39129,2.84439,9.58694,3.11037-0.92283,6.22073-1.84565,9.3311-2.76848-0.13471-0.45405-0.26943-0.90809-0.40414-1.36214-2.64589,0.78505-5.29182,1.57-7.93769,2.35511-0.28864-0.97278-0.57724-1.94559-0.86588-2.91837,2.38433-0.70751,4.7687-1.41486,7.15305-2.12231-0.13403-0.45173-0.26805-0.90347-0.40208-1.3552-2.38435,0.70745-4.76872,1.4148-7.15305,2.12231-0.25541-0.86072-0.51069-1.72147-0.76615-2.58217,2.54667-0.75567,5.09338-1.51119,7.64007-2.2668-0.1354-0.45636-0.27079-0.91271-0.40619-1.36907-3.01114,0.89339-6.02229,1.78679-9.03343,2.68018z'/%3E %3Cpath d='m528.966,374.61c1.39945,3.02534,2.79891,6.05067,4.19836,9.07601,0.41731-0.19304,0.83461-0.38607,1.25192-0.57911-1.16723-2.5233-2.33445-5.04661-3.50169-7.5699,3.2371,1.46816,6.45494,2.97935,9.68455,4.46424,0.21532,0.18677,0.43059,0.0619,0.64586-0.0532,0.41968-0.19414,0.83935-0.38827,1.25903-0.5824-1.39945-3.02534-2.79891-6.05067-4.19836-9.07601-0.41837,0.19353-0.83673,0.38706-1.2551,0.58059,1.16571,2.52002,2.33141,5.04004,3.49712,7.56005-3.32359-1.50694-6.62903-3.05445-9.94557-4.57714-0.54537,0.25228-1.09075,0.50455-1.63612,0.75683z'/%3E %3Cpath d='m539.947,369.452,0.7834,1.1903,3.57155-2.3506,0.13556-0.0892,0.0676,0.10271,4.64663,7.0602,1.2141-0.79904-4.64663-7.06021-0.0676-0.10271,0.13849-0.0912,3.58924-2.36224-0.7834-1.1903z'/%3E %3Cpath d='m550.009,362.562c2.25912,2.45158,4.51825,4.90315,6.77737,7.35473,0.35826-0.32963,0.71559-0.66044,1.07443-0.98933-0.88853-0.9642-1.77701-1.92843-2.66556-2.89261,1.17531-1.0949,2.3759-2.16325,3.53179-3.27856,1.69818,0.22782,3.39617,0.45717,5.09534,0.67753,0.45399-0.41836,0.90799-0.83671,1.36198-1.25507-1.79202-0.23715-3.58403-0.4743-5.37605-0.71145,0.65931-0.90206,0.94479-2.18281,0.32762-3.18296-0.46831-0.86361-1.31769-1.60043-2.34759-1.58963-1.38249-0.0318-2.44436,1.01126-3.42205,1.85319-1.45278,1.3374-2.90492,2.6777-4.35728,4.01416zm2.0398,0.0584c1.27303-1.15184,2.50096-2.35547,3.81453-3.46086,0.6802-0.51389,1.64011-1.16046,2.49542-0.66105,0.73053,0.41027,0.7228,1.39714,0.29822,2.02581-0.75622,1.26942-1.97455,2.14713-3.01826,3.16305-0.46989,0.433-0.93977,0.866-1.40966,1.299-0.72675-0.78859-1.45368-1.57749-2.18025-2.36595z'/%3E %3Cpath d='m561.643,350.918,4.47337,10.3272,1.06321-1.29975-1.39553-3.1971,0.004-0.005,3.45322-4.22148,3.41028,0.73412,1.06321-1.29976-11.009-2.33754-1.06322,1.29975zm1.75217,0.34857,4.29916,0.9234-2.54189,3.1074-1.75727-4.0308z'/%3E %3Cpath d='m565.998,345.253,8.39039,5.44074,4.40302-6.79009-1.19211-0.77303-3.52205,5.43147-0.0902,0.13913-0.10617-0.0688-7.09208-4.59886z'/%3E %3C/g%3E %3Cg clip-path='url(%23shield)'%3E %3Cg id='rays'%3E %3Cpath fill='%23fff' d='m500.001,226.408 -31.4786,54.5355 -15.42,26.7015h93.7971l-14.7145,-25.4844 -32.1841,-55.7526z'/%3E %3Cg id='rays5'%3E %3Cg id='ray'%3E %3Cpath fill='%2317c0eb' stroke='%2317c0eb' stroke-width='0.12869333' opacity='0.62040818' d='m500.001,226.408-2.35655,4.08164,2.35655,54.9769,2.35656-54.9769z'/%3E %3Cpath fill='%23fff' d='m500.001,277.475c-0.044,0 -0.0891,0.002 -0.1335,0.003l0.1335,3.11123 0.13351-3.11123c-0.0443,-0.00097 -0.0892,-0.003 -0.13351,-0.003z'/%3E %3C/g%3E %3Cuse xlink:href='%23ray' transform='rotate(72,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(144,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(216,500.001,285.46654)'/%3E %3Cuse xlink:href='%23ray' transform='rotate(288,500.001,285.46654)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays5' transform='rotate(8,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(16,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(24,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(32,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(40,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(48,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(56,500.001,285.46654)'/%3E %3Cuse xlink:href='%23rays5' transform='rotate(64,500.001,285.46654)'/%3E %3C/g%3E %3Cg id='rainbow'%3E %3Cpath fill='%23f00' d='m500,265.844c-11.0666,0-21.1953,4.05143-28.9688,10.75l-14.656,25.406c-0.50136,2.67038-0.75,5.43402-0.75,8.25h5.03125c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h5.03125c0-2.81337-0.24954-5.58193-0.75-8.25l-14.6562-25.4062c-7.77293-6.69663-17.904-10.75-28.9688-10.75z'/%3E %3Cpath fill='%23f60' d='m500,266.656c-11.764,0-22.4393,4.67488-30.2812,12.25l-12.031,20.844c-0.83351,3.36611-1.28125,6.87625-1.28125,10.5h4.25c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h4.25c0-3.62494-0.44735-7.16414-1.28125-10.5312l-12.0312-20.8125c-7.841-7.57455-18.5177-12.25-30.2812-12.25z'/%3E %3Cpath fill='%23ff0' d='m500,267.469c-12.7024,0-24.1008,5.52218-31.9375,14.3125l-8.71875,15.0938c-1.38396,4.20847-2.125,8.70346-2.125,13.375h3.4375c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h3.4375c0-4.67311-0.74037-9.16532-2.125-13.375l-8.719-15.095c-7.836-8.788-19.237-14.312-31.938-14.312z'/%3E %3Cpath fill='%230f0' d='m500,268.25c-14.5495,0-27.3723,7.41414-34.9062,18.6562l-2.8125,4.875c-2.735,5.574-4.282,11.842-4.282,18.469h2.65625c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h2.6562c0-6.61555-1.55577-12.8712-4.28125-18.4375l-2.844-4.937c-7.536-11.227-20.337-18.625-34.875-18.625z'/%3E %3Cpath fill='%230cf' d='m500,269.062c-22.7472,0-41.1875,18.4403-41.1875,41.1875h1.84375c0-21.7264,17.6173-39.3438,39.3438-39.3438,21.7264,0,39.3438,17.6173,39.3438,39.3438h1.84375c0-22.7472-18.4403-41.1875-41.1875-41.1875z'/%3E %3Cpath fill='%2300f' d='m500,269.844c-22.3058,0-40.375,18.1004-40.375,40.4062h1.34375c0-21.5594,17.4718-39.0312,39.0312-39.0312s39.0312,17.4718,39.0312,39.0312h1.375c0-22.3058-18.1004-40.4062-40.4062-40.4062z'/%3E %3Cpath fill='%23800080' d='m500.001,270.657c-21.8638,0-39.5887,17.7249-39.5887,39.5887,0,0.24501,0.003,0.48981,0.007,0.73377h0.8008c-0.005-0.24405-0.007-0.48864-0.007-0.73377,0-21.4222,17.3658-38.7879,38.7879-38.7879,21.4222,0,38.7879,17.3658,38.7879,38.7879,0,0.24513-0.002,0.48972-0.007,0.73377h0.79727c0.004-0.24396,0.007-0.48876,0.007-0.73377,0-21.8638-17.7214-39.5887-39.5852-39.5887z'/%3E %3C/g%3E %3Cg id='cap'%3E %3Cpath fill='%23510000' d='m500.395,288.134c-0.64444-0.12422-1.22556-0.48362-1.77526-0.60947-0.75553,0.72433-0.83505,1.45617-0.73118,2.07933,0.26291,0.13958,0.31133,0.353,0.87825,0.86011s0.49599,0.7732,0.46178,1.96543c-0.0144,0.50237,0.0702,1.58063,0.57906,1.682,0.54856,0.1093,0.93237-0.34645,1.08988-1.16049,0.15297-0.79058,0.4179-1.2158,0.69822-1.70182,0.30651-1.85224-0.19317-2.50796-1.20075-3.11509z'/%3E %3Cpath fill='%23f00' d='m497.168,283.524c-0.5954,0.015-1.52849,1.01222-1.94312,0.4754-0.2385-0.30879-0.2787-0.90191-0.037-1.40011,0.55866-1.15143,1.12448-1.71603,2.16738-2.33046,2.37772-1.40083,3.8889-0.95056,5.07395,1.06271,1.0982,1.77292,2.15196,3.72986,2.24612,5.37194,0.0291,0.50093,0.28239,1.40776-0.15623,1.85983-1.34779,1.38922-4.59607-1.43513-6.49718-0.9882-0.63913,0.15025-1.37729,0.6166-1.98048,0.21781-0.46922-0.31025-0.0771-0.99697,0.27265-1.29413,0.61215-0.52003,1.50103-2.36524,1.38013-3.16441-0.0677-0.44682-0.08,0.17838-0.52586,0.18962z'/%3E %3Cpath fill='url(%23cap1)' d='m496.927,282.548c-1.08326,0.4452-0.96582,1.07615-1.50945,1.59022,0.15386,0.0578,0.7653,0.31056,1.36345-0.30126,0.25817-0.21386,0.54788-0.29339,0.67713-0.36245-0.30513,0.22158-0.52326,0.55469-0.68366,0.68484-0.40495,0.32861-1.03464,1.08239-1.34095,1.84608-0.30631,0.76368-0.43013,1.67294-0.37506,1.78203,0.0551,0.1091,0.42587,0.77878,1.5653,1.23156,2.03098,0.80708,2.41713,2.43864,4.47768,2.43864,1.61336,0,1.35441-1.05575,2.64581-0.83159,1.1192,0.19425,1.71404-0.69654,0.63574-1.23178-1.371-0.46864-4.09192-0.19196-5.37247,0.0332-0.41337-4.08361-0.0551-2.64985-0.15181-4.40521-0.0968-1.75536-0.62285-1.86055,0.0724-3.28125-0.57778,0.87239-1.27677,0.73447-2.004,0.807z'/%3E %3Cpath fill='%23ff2a2a' d='m500.938,279.795c-0.0401,0.22319-0.0767,0.51644-0.0555,0.6,0.087,0.33854,0.17464,0.69288,0.27745,0.99375,0.11493,0.33621,0.16173,0.57942,0.24047,0.92812,0.0812,0.35981,0.40101,0.50003,0.69364,0.72188,0.36987,0.28044,0.0839,1.03755,0.31445,1.06875,0.18399,0.025,0.48828-1.07134,0.49017-1.24688,0-0.23637-0.001-0.42692-0.037-0.64687-0.1351-0.29493-0.27167-0.58548-0.42543-0.87188-0.002-0.004-0.007-0.006-0.009-0.009-0.0604-0.11211-0.12197-0.22206-0.19422-0.32812-0.21674-0.3182-0.48469-0.61247-0.78613-0.8625-0.0186-0.0154-0.0367-0.0318-0.0555-0.0469-0.0843-0.0645-0.17013-0.13028-0.25896-0.1875-0.0629-0.0405-0.12933-0.0758-0.19422-0.1125z'/%3E %3Cpath fill='url(%23cap2)' d='m501.249,287.398c-0.71834-0.18768-1.42584-0.54264-2.03712-0.72519-1.20046-0.3585-2.47993-1.13407-3.3655-0.81346-0.31696,0.14032-0.28927,0.45588-0.39018,0.90946-0.0419,0.53363-0.59621,1.31951-0.13634,1.06243,0.68545-0.38318,2.49069,0.73271,3.09544,1.10617,0.28651,0.17693,0.89218,0.52377,1.08153,1.02169,0.18934,0.49792,0.092,1.75593,0.0412,2.29553-0.0533,0.56606,0.11902,1.83505,0.68594,1.98695,0.61122,0.16378,1.07804-0.32245,1.31579-1.2298,0.23091-0.8812,0.40519-1.38725,0.75742-1.91526s0.75591-0.75584,1.31984-0.86236c0.56393-0.10651,1.38228,0.46186,1.38228-0.20334,0-0.43694-0.38382-0.85479-0.22071-1.45374,0.12846-0.47174-0.40137-0.37766-0.84179-0.57224-1.03591-0.31872-1.96945-0.41916-2.6878-0.60684z'/%3E %3Cpath fill='%23910000' d='m498.363,288.902c-0.32675-0.17761-2.3152-1.4778-3.04281-1.07105-0.22993,0.12854-0.31747-0.0162-0.32062-0.25731-0.004-0.24106,0.10913-0.59399,0.18399-0.86612,0.0749-0.27214,0.19591-0.79179,0.5164-1.06192,0.68731-0.5793,2.2686,0.57503,3.1082,0.88679-0.0717,0.4352-0.47012,2.35517-0.44516,2.36961z'/%3E %3Cpath fill='%23ff3a3a' d='m501.763,291.361c0.91566-1.60289,1.50762-1.39687,2.61336-1.37357,0.36843,0.008,0.47628-0.32925,0.39238-0.66749-0.278,0.62397-1.66206-0.069-2.41497,0.26261-1.57249,0.69255-1.28027,3.76979-2.02634,4.07028,0.77552,0.65117,1.1236-1.74573,1.43557-2.29183z'/%3E %3C/g%3E %3Cg id='seab' fill='url(%23seabgrad)'%3E %3Cpath fill='%23fff' d='m453.103,307.645-9.95545,17.2366,113.708,0-9.95545-17.2366-93.7972,0z'/%3E %3Cg id='wavesb3'%3E %3Cpath id='waveb1' d='m449.705,321.364c-1.65776,0-3.19731,0.16736-4.70961,0.35278l-0.48684,0.84666c2.43344-0.21658,4.69724-0.64924,7.14027-0.70908,3.29349,0.0801,6.2835,0.82902,9.78611,0.82902,1.51792,0.0147,3.02697-0.0297,4.5262,0,3.49923,0,6.48854-0.74896,9.78259-0.82902,3.29576,0.0801,6.30397,0.82902,9.80375,0.82902,1.51769,0.005,3.17747-0.0238,4.52973,0,3.49922,0,6.47429-0.74896,9.76495-0.82902,3.29293,0.0801,6.26925,0.82902,9.76848,0.82902,1.53042,0.0148,3.03299-0.0299,4.54381,0,3.49923,0,6.49037-0.74896,9.78612-0.82902,3.29632,0.0795,6.28114,0.82902,9.78258,0.82902,1.51624,0.0145,3.03114-0.0297,4.52976,0,3.49867,0,6.47485-0.74896,9.76495-0.82902,2.55081,0.062,4.92094,0.51761,7.48601,0.72319l-0.51507-0.89252c-1.40293-0.16829-2.8346-0.32103-4.36741-0.32103-1.52925-0.0208-3.03636,0.0308-4.54734,0-3.4992,0-6.47369,0.74842-9.76495,0.82902-3.29632-0.0801-6.28347-0.82902-9.78612-0.82902-1.51274-0.0209-3.0301,0.0312-4.52617,0-3.49921,0-6.49263,0.74897-9.7861,0.82902-3.29407-0.0801-6.28337-0.82902-9.7826-0.82902-1.52189-0.0207-3.04194,0.0308-4.54734,0-3.49922,0-6.4754,0.74897-9.76495,0.82902-3.29404-0.0801-6.26924-0.82902-9.76847-0.82902-1.52279-0.0213-3.02634,0.0313-4.52618,0-3.5026,0-6.48979,0.74897-9.78611,0.82902-3.29405-0.0806-6.28335-0.82902-9.78259-0.82902-1.52022-0.0209-3.04332,0.0313-4.54733,0z'/%3E %3Cuse xlink:href='%23waveb1' y='-1.1132812'/%3E %3Cuse xlink:href='%23waveb1' y='-2.2304687'/%3E %3C/g%3E %3Cuse xlink:href='%23wavesb3' y='-3.34375'/%3E %3Cuse xlink:href='%23wavesb3' y='-6.6914063'/%3E %3Cpath d='m453.23,307.458 -0.12347,0.21519h93.7901l-0.12348,-0.21519h-93.5432zm-0.21872,0.37746 -0.127,0.21873h94.2346l-0.127,-0.21873h-93.9806zm-0.20109,0.34572 -0.20461,0.35631h94.792l-0.2046,-0.35631h-94.3828zm-0.3175,0.55033 -0.25047,0.43392h95.5187l-0.25048,-0.43392h-95.0178zm-0.39864,0.69144 -0.25047,0.43392h96.316l-0.25047,-0.43392h-95.815zm-0.39864,0.69144 -0.24695,0.43039h97.1062l-0.24693,-0.43039h-96.6123zm-0.39864,0.69144 -0.25048,0.43039h97.9106l-0.25048,-0.43039h-97.4096zm-0.43039,0.74436 -0.30339,0.52916h98.8772l-0.30339,-0.52916h-98.2704z'/%3E %3Cpath d='m457.357,312.287c3.45019,0.6621 3.7818,0 3.7818,0zm81.5028,0s0.3316,0.6621 3.7818,0z'/%3E %3C/g%3E %3Cg id='mountains' fill='%23ccd11e'%3E %3Cg id='mountain1'%3E %3Cpath fill='url(%23mountain)' d='m530.631,297.043c-1.70879,0-2.23164,0.86208-2.23164,0.86208-2.73683,10.5758-11.8078,21.3327-22.6008,21.3327h-8.08019v10.7684c0,0.003,0.0112,0,0.017,0h61.4976l-6.18652-10.9539c-9.70777-1.44879-17.6397-11.3728-20.1666-21.1472-0.0003,0-0.54017-0.86208-2.24897-0.86208z'/%3E %3Cpath fill='%2397c924' d='m530.631,297.465c-0.78411,0-1.26009,0.18069-1.53836,0.35499-0.26383,0.16497-0.31454,0.2757-0.32096,0.28758,0,0.007-0.0151,0.01-0.0176,0.0168-1.39971,5.32242-4.35191,10.6683-8.33374,14.7065-4.01201,4.06971-9.06971,6.82929-14.605,6.82929h-7.67481v9.92268h60.8557l-5.68004-10.0578c-4.68763-0.61173-8.97309-3.16302-12.4584-6.69417-3.98569-4.03827-6.93211-9.38349-8.33374-14.7065,0,0-0.0164-0.0165-0.017-0.0168-0.007-0.012-0.0696-0.10431-0.33797-0.27057-0.28308-0.17556-0.75393-0.372-1.53804-0.372z'/%3E %3Cpath fill='%23ede71f' d='m530.63,297.465c0.14713,0,0.27966,0.0211,0.4057,0.0341,0.0238,3.01731,0,8.10909,0,10.8013-0.0287,2.34006-0.83034,4.2225-2.01175,6.44085-0.54742,1.5541-0.98612,0.96232-2.34929,2.85666-1.83161,0.65398-3.18666,0.90876-5.13836,1.21655-2.51753,0.39758-8.12164,0.75027-10.8869,0.13523,3.64106-1.06725,6.96079-3.26938,9.77096-6.11954,0.74649-0.7573,1.45945-1.5595,2.12967-2.40011,1.11812-1.40047,2.12751-2.91291,3.00924-4.47944,0.35269-0.6264,0.68645-1.24901,0.99749-1.89326,0.46683-0.9661,0.88335-1.95059,1.25119-2.94104,0.12279-0.3305,0.24396-0.66588,0.35485-0.99747,0.22233-0.66372,0.41706-1.32961,0.59179-1.99495,0.002-0.006,0.0151-0.0103,0.0168-0.0168,0.006-0.0119,0.0579-0.12225,0.32077-0.28724,0.13578-0.0849,0.3316-0.17039,0.57502-0.23692,0.005-0.001,0.0124,0.001,0.0168,0,0.25153-0.0665,0.55446-0.11793,0.9461-0.11793z'/%3E %3Cpath fill='%23c6cb24' d='m529.938,298.902c-0.41166,6.03407-2.27735,13.1917-6.64434,17.8107-1.60658,1.33664-3.65998,2.54995-5.64577,2.2546,6.77038-5.51045,10.8853-13.9468,12.2901-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m524.494,309.281c-1.00181,2.72142-4.78784,6.74649-8.84,10.0451-1.15058,0.0352-1.75967,0.10115-2.80422,0.0379,2.46776-0.22502,8.22171-5.08258,11.6442-10.0829z'/%3E %3C/g%3E %3Cuse xlink:href='%23mountain1' x='-15.340665'/%3E %3Cg id='mountain3' fill='%23c6cb24'%3E %3Cpath fill='url(%23mountain)' d='m502.218,297.911c2.73458,10.5755,11.7902,21.3327,22.5831,21.3327h8.08853v10.7681c0,0.003-0.0144,0-0.017,0h-65.7947c-0.006,0-0.0167,0.003-0.0167,0v-10.7681h8.07151c10.7926,0,19.863-10.7575,22.6001-21.3327,0,0,0.53408-0.86562,2.24287-0.86562s2.24287,0.86562,2.24287,0.86562z'/%3E %3Cpath fill='%2397c924' d='m499.975,297.465c0.78378,0,1.25463,0.19644,1.53836,0.372,0.26865,0.16626,0.33123,0.25869,0.33829,0.27057,0,0,0.017,0.0168,0.017,0.0168,1.40164,5.32275,4.34806,10.6683,8.33375,14.7065,4.0165,4.06971,9.08671,6.82929,14.6226,6.82929h7.64046v9.92238h-64.9804v-9.92238h7.67448c5.53561,0,10.593-2.75991,14.6053-6.82929,3.98184-4.03827,6.93371-9.38379,8.33374-14.7065,0.003-0.007,0.0151-0.01,0.017-0.0168,0.006-0.012,0.0575-0.12228,0.32096-0.28758,0.2786-0.1743,0.75458-0.35499,1.53837-0.35499z'/%3E %3Cpath fill='%23ede71f' d='m499.263,297.53c-0.0864,0.0162-0.16714,0.0347-0.24243,0.0546-0.004,0.001-0.0128-0.001-0.0176,0-0.24288,0.0665-0.43572,0.15144-0.5715,0.23636-0.26398,0.16499-0.31454,0.27385-0.32103,0.28575-0.002,0.006-0.016,0.0111-0.0176,0.0176-0.17526,0.66535-0.37034,1.333-0.59266,1.99672-0.11089,0.33159-0.23352,0.66433-0.35631,0.99484-0.36838,0.99044-0.782,1.97606-1.24883,2.94216-0.31158,0.64425-0.64567,1.26802-0.99836,1.89442-0.88173,1.56653-1.89108,3.07628-3.0092,4.47675-0.67076,0.84061-1.38428,1.64511-2.13077,2.40242-2.80963,2.85016-6.12791,5.04991-9.76842,6.11716,2.76473,0.61504,4.03154-0.056,6.54853-0.45356,1.95224-0.30779,4.21092-0.5631,6.04308-1.21708,1.3637-1.89434,0.89896-1.29988,1.44639-2.85397,1.18086-2.21836,2.90542-4.22182,3.33375-6.68161,1.61858-3.02147,1.90301-8.6137,1.90304-10.2126z'/%3E %3Cpath d='m499.275,298.902c-0.41166,6.03407-2.27681,13.1917-6.6438,17.8107-1.60658,1.33664-3.65998,2.54995-5.64577,2.2546,6.77038-5.51045,10.8848-13.9468,12.2896-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m493.832,309.281c-1.00204,2.72139-4.78809,6.74682-8.84021,10.0453-1.15033,0.035-1.75951,0.10077-2.80424,0.0375,2.46787-0.2253,8.22237-5.08266,11.6444-10.0828z'/%3E %3Cpath fill='%23ede71f' d='m500.951,297.584c0.004,0.001,0.0128-0.001,0.0176,0,0.24288,0.0665,0.43572,0.15144,0.5715,0.23636,0.26398,0.16499,0.31454,0.27385,0.32103,0.28575,0.002,0.006,0.016,0.0111,0.0176,0.0176,0.17526,0.66535,0.37034,1.333,0.59266,1.99672,0.11089,0.33159,0.23352,0.66433,0.35631,0.99484,0.36838,0.99044,0.782,1.97606,1.24883,2.94216,0.31158,0.64425,0.64567,1.26802,0.99836,1.89442,0.88173,1.56653,1.89108,3.07628,3.0092,4.47675,0.67076,0.84061,1.38428,1.64511,2.13077,2.40242,2.80963,2.85016,6.12791,5.44502,9.76842,6.51227-7.24491,0.0274-10.3888-0.63-13.022-4.01661-2.63318-3.38661-3.60599-4.86816-4.1405-6.93644-0.53451-2.06829-2.02539-6.57045-1.86986-10.8063z'/%3E %3Cpath d='m501.476,298.902c0.41166,6.03407,2.2209,12.0063,6.58735,16.6253,1.60659,1.33664,3.65999,2.54994,5.64577,2.2546-7.33482-5.00192-10.8288-12.7615-12.2331-18.8799z'/%3E %3C/g%3E %3Cg id='mountain4'%3E %3Cpath fill='url(%23mountain)' d='m484.749,297.043c-1.70911,0-2.24833,0.86208-2.24833,0.86208-2.52242,9.74649-11.825,22.3182-21.4962,23.8113l-4.78983,8.28981h49.0144v-11.3486c-8.82472-2.37071-15.8893-11.6292-18.2484-20.7525-0.00034,0-0.52284-0.86208-2.23164-0.86208z'/%3E %3Cpath fill='%2397c924' d='m484.749,297.465c-0.7841,0-1.25495,0.19644-1.53836,0.372-0.26864,0.16626-0.33123,0.25869-0.33797,0.27057-0.00033,0-0.017,0.0168-0.017,0.0168-1.40164,5.32275-4.67746,10.7045-8.07974,14.9888-3.40228,4.28421-9.71968,8.61825-14.0417,9.07638l-4.28272,7.39371h48.0605v-10.6937c-3.55405-1.09062-6.79917-3.26637-9.5523-6.05864-3.98183-4.03827-6.93371-9.38379-8.33374-14.7065-0.002-0.007-0.0154-0.01-0.017-0.0168-0.006-0.012-0.0578-0.12228-0.32128-0.28758-0.27891-0.1743-0.7549-0.35499-1.53868-0.35499z'/%3E %3Cpath fill='%2393bc30' d='m483.445,298.903c-0.61721,9.04327-5.65334,20.4536-11.3402,22.4194-1.85433,0.64154-5.09834,0.86441-6.22727,1.00883,9.94892-4.73151,15.8284-15.8536,17.5675-23.4282z'/%3E %3Cpath fill='%23ede71f' d='m484.746,297.465c-0.14713,0-0.27966,0.0211-0.4057,0.0341-0.0233,3.01731,0,8.10909,0,10.8013,0.0292,2.34006,0.83088,4.2225,2.01175,6.44085,0.0687,0.1942,0.13577,0.35377,0.20285,0.49009,0.41003,1.08564,0.7135,1.46267,2.28222,2.6538,4.9869,3.78651,11.1698,4.35287,14.8082,4.04021-1.13975-0.89849-2.35794-1.71529-3.4317-2.46772,1.71152-0.0552,3.3511-0.24883,4.51358-0.5074-3.64051-1.06725-6.96079-3.26938-9.77042-6.11954-0.48955-0.49658-0.94501-1.02182-1.40319-1.55518-0.20826-0.29156-0.50091-0.69725-0.59178-0.81139-1.11812-1.40047-2.26275-2.94699-3.14448-4.51352-0.35269-0.6264-0.6859-1.24901-0.99748-1.89326-0.46683-0.9661-0.88282-1.95059-1.25119-2.94104-0.1228-0.3305-0.24397-0.66588-0.35486-0.99747-0.22232-0.66372-0.41652-1.32961-0.59178-1.99495-0.002-0.006-0.0152-0.0103-0.0168-0.0168-0.006-0.0119-0.0573-0.12225-0.32132-0.28724-0.13578-0.0849-0.3316-0.17039-0.57502-0.23692-0.005-0.001-0.0124,0.001-0.0168,0-0.25153-0.0665-0.55446-0.11793-0.9461-0.11793z'/%3E %3Cpath d='m485.446,298.902c0.41166,6.03407,2.27735,13.1917,6.6438,17.8107,1.60658,1.33664,3.65998,2.54995,5.64577,2.2546-6.77038-5.50991-10.8853-13.9468-12.2896-20.0653z'/%3E %3Cpath fill='%239ecb34' d='m489.613,307.247c2.36901,5.83689,8.37001,11.2893,14.5434,14.9536,1.15032,0.035,1.49118,0.003,2.53623-0.06-4.41834-2.3709-11.5382-5.75379-17.0796-14.8936z'/%3E %3C/g%3E %3Cuse xlink:href='%23mountain4' x='-15.429624' fill='%23c6cb24'/%3E %3C/g%3E %3Cg id='seaf'%3E %3Cpath fill='%23fff' d='m556.5,324.692c-0.57438,0.20274-4.4212-0.18918-6.43291-0.0441l-1.27942,0.33561c-1.12352-0.008-2.2382,0.0249-3.33025,0-3.60215,0-6.64947,0.94833-10.0754,0.94896-3.43268,0-6.47005-0.94896-10.0754-0.94896-1.11911-0.008-2.23365,0.025-3.33025,0-3.6015,0-6.64626,0.94896-10.0754,0.94896-3.42915,0-6.47326-0.94896-10.0754-0.94896-1.13086-0.007-2.24155,0.0238-3.34789,0-3.60182,0-6.63215,0.94896-10.0578,0.94896-3.42883,0-6.45594-0.94896-10.0578-0.94896-0.26736,0-0.51646,0.009-0.77612,0.0177-0.17781-0.004-0.37669-0.0177-0.55739-0.0177-0.11972,0-0.22152-0.003-0.33867,0-0.11714-0.003-0.23659,0-0.35631,0-0.18069,0-0.3443,0.0138-0.52212,0.0177-0.25964-0.008-0.51195-0.0177-0.77963-0.0177-3.60535,0-6.64241,0.94929-10.0754,0.94896-3.42914,0-6.47358-0.94896-10.0754-0.94896-0.2619,0-0.52159,0.01-0.77611,0.0177-0.1807-0.004-0.33885-0.0177-0.52212-0.0177-0.12421,0-0.25198-0.003-0.37394,0-0.11715-0.003-0.23659,0-0.35631,0-0.1807,0-0.36162,0.0138-0.53975,0.0177-0.25902-0.008-0.50844-0.0177-0.77612-0.0177-2.87883,0-6.21806,0.60744-8.93592,0.8502l-6.27243,10.8584,62.9712-0.007,64.3753,0.007z'/%3E %3Cpath fill='url(%23seafgrad)' d='m547.993,323.111c-0.19914,0-0.3979,0-0.5962,0.007-3.24025,0.0945-5.56407,1.1148-11.2007,1.1148-5.63662,0-6.21814-1.01862-12.5836-0.87843-5.9467,0.13098-8.44224,1.2612-11.6699,1.21707-3.22765-0.0441-8.47272-0.69756-12.5095-0.27513-4.03677,0.4224-8.8283,1.28394-11.9733,1.29114-3.90833-0.0174-7.81956-0.73101-11.9062-0.32454-4.08669,0.40647-5.99703,1.49994-11.0631,1.48518-4.35525-0.0126-9.08294-0.69768-12.7459-0.69498-3.43476,0.003-7.26655,0.95724-10.0859,1.44288l-0.84314,1.46403c2.24704-0.26058,8.55148-1.21821,10.802-1.27707,2.34423-0.0613,10.717,0.48306,15.3352,0.32457,4.61831-0.15849,5.15872-1.17123,10.6186-1.17123,3.80095,0,6.66602,0.39864,10.5657,0.39864,2.43414,0,4.64322-1.24179,8.34319-1.24179,0.93595-0.0267,1.86447-0.0608,2.794-0.0914,3.11857-0.51522,8.38344,0.0449,12.0474,0.23274,3.31532,0.17289,5.45733-0.61554,8.9147-0.73023,1.49575-0.0682,2.99739-0.0659,4.47322-0.1483,3.46061-0.11481,6.42225,0.64053,9.68022,0.62442,3.24998-0.20046,6.40346-0.9225,9.86013-1.03716,1.51123-0.0717,2.99793-0.0723,4.49087-0.1482,2.28616-0.0758,5.83581,0.0784,8.27264,0.50094l-0.83962-1.4499c-2.37954-0.0756-5.31192-0.63528-8.18091-0.63501z'/%3E %3Cg id='wavesf3'%3E %3Cpath id='wavef1' fill='url(%23seafgrad)' d='m450.312,334.748c-3.4571,0-6.40225,0.85314-9.65206,0.94542-1.21068-0.0338-2.36647-0.18372-3.53485-0.34572l-0.49037,0.8502c0.48641,0.0323,0.97518,0.0635,1.48873,0.0635,1.50121,0.0181,2.99033-0.0362,4.47333,0,3.4571,0,6.38201-0.85251,9.63442-0.94545,3.25403,0.0923,6.20548,0.94545,9.66617,0.94545,1.5011,0.0185,2.99216-0.0362,4.47329,0,3.45743,0,6.41213-0.85317,9.66616-0.94545,3.25601,0.0923,6.23024,0.94545,9.68735,0.94545,1.49515,0.018,2.99325-0.0361,4.46979,0,3.45745,0,6.40128-0.85317,9.65206-0.94545,3.25339,0.0923,6.19143,0.94545,9.64853,0.94545,1.51281,0.0184,2.99932-0.0362,4.49089,0,3.45713,0,6.41051-0.85317,9.66617-0.94545,3.25762,0.0917,6.21,0.94545,9.66971,0.94545,1.49537,0.018,2.99209-0.0361,4.46978,0,3.45709,0,6.40095-0.85317,9.65206-0.94545,3.25303,0.0923,6.20903,0.94545,9.66616,0.94545,1.49931,0.0181,2.99554-0.0361,4.47325,0,0.60565,0,1.19636-0.0342,1.77801-0.0776l-0.46213-0.79728c-1.06409,0.14412-2.13376,0.27615-3.235,0.3069-3.25439-0.0923-6.19497-0.94542-9.65207-0.94542-1.51059-0.0196-2.99775,0.0292-4.49089,0-3.4571,0-6.39678,0.85314-9.64853,0.94542-3.25694-0.0916-6.2058-0.94542-9.66617-0.94542-1.49604-0.0198-2.99286,0.0297-4.47325,0-3.45713,0-6.41243,0.85314-9.66617,0.94542-3.25435-0.0923-6.20904-0.94542-9.66617-0.94542-1.50326-0.0196-3.00351,0.0292-4.4909,0-3.45712,0-6.39874,0.85314-9.64852,0.94542-3.25406-0.0923-6.19497-0.94542-9.65206-0.94542-1.5058-0.02-2.98967,0.0296-4.47325,0-3.46037,0-6.40921,0.8538-9.66618,0.94542-3.25436-0.0923-6.20873-0.94542-9.66617-0.94542-1.50222-0.0201-3.00578,0.0298-4.49089,0z'/%3E %3Cuse xlink:href='%23wavef1' y='-1.2894435'/%3E %3Cuse xlink:href='%23wavef1' y='-2.5745998'/%3E %3C/g%3E %3Cuse xlink:href='%23wavesf3' y='-3.8671875'/%3E %3Cuse xlink:href='%23wavesf3' y='-7.7286534'/%3E %3C/g%3E %3Cpath fill='%2397c924' d='m443.846,324.705-2.42711,4.191c2.83897-0.47073,7.10222-1.70307,10.6345-1.70568,3.66291-0.003,8.08192,0.90279,12.4372,0.91545,5.06609,0.0147,6.97643-1.07871,11.0631-1.48521,4.08668-0.40644,7.99791,0.52761,11.9062,0.54507,3.14498-0.007,7.93651-1.08924,11.9733-1.51167,4.03678-0.42243,7.73721,0.29346,12.603,0.3687,4.86583,0.0753,5.62964-1.17963,11.5763-1.31061,6.36544-0.14022,6.94696,0.8784,12.5836,0.8784,4.24149,0.22824,7.88284-0.8541,11.6664-1.12182,3.78351-0.26772,5.53834,0.043,8.3044,0.10938l-1.83798-3.25263c-0.0306,0-0.0608,0.003-0.0917,0.004l-101.246,2.2256z'/%3E %3Cpath fill='%23fff' d='m550.067,324.648s2.71009,0.1485,3.84748,0.27558c1.13739,0.12711,2.95452,0.25356,2.95452,0.25356l-0.36909-0.48504c-0.57438,0.20274-4.4212-0.18918-6.43291-0.0441z'/%3E %3C/g%3E %3Cpath fill='%23c8a400' d='m500,224.874 -32.1418,55.6856 -32.8579,56.8991 64.2977,-0.007 65.7018,0.007 -32.153,-55.683 -32.847,-56.902zm0,3.00212 31.5491,54.652 30.8506,53.4278 -63.1018,-0.004 -61.7012,0.004 31.5597,-54.6448z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 3' width='2400' height='1200'%3E %3Crect width='6' height='3' fill='%23008751'/%3E %3Crect x='2' width='2' height='3' fill='%23FFF'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='920' height='460'%3E %3Crect width='920' height='460' fill='%23007934'/%3E %3Crect width='360' height='460' x='280' fill='%23fff'/%3E %3Cpath fill='%23007934' d='m463.32,30.575c-0.80416,8.7038-1.61,17.412-2.4141,26.116-2.9476,0.44414-5.8944,0.88632-8.842,1.3304-0.00002,0,6.141,3.4483,7.2132,6.9121,0.1716,0.55476,0.103,1.0139-0.1454,1.3593-0.0816,0.10798-0.20658,0.22795-0.31994,0.31813-1.7789,1.3671-7.0388,0.72303-7.0388,0.72303,0-0.00002,6.968,5.8794,7.5041,8.0111,0.012,0.0499,0.028,0.0964,0.029,0.14472-0.00068,0.03992,0.008,0.1058,0,0.14452-0.008,0.03074-0.0458,0.08562-0.0582,0.11576-0.0476,0.1046-0.1334,0.2225-0.23268,0.31813-1.6382,1.5132-9.3656,1.9377-9.3656,1.9377s8.5677,6.1091,9.1038,9.5728c0.48584,3.1391,0.0784,4.9777,0,5.2925-0.59872-0.51141-14.415-12.122-23.327-8.7341-0.44388,0.2306-0.70656,0.45033-0.8144,0.66518-0.0474,0.10718-0.0574,0.24076-0.029,0.34705,0.62434,1.9313,13.227,3.9097,22.018,11.511-0.21806,1.9022-25.055-6.0507-25.973-1.0701,0.77684,1.4044,26.729,5.145,28.649,8.5317-9.5578,0.3554-29.303-2.1035-28.649,1.0412-1.9974,3.6306,18.649,1.58,27.311,4.5406,2.5391,2.869,2.294,5.2791-2.1233,5.5817-8.3488-3.9693-27.034-6.9188-27.079-1.8509,0.00044,0.006-0.00092,0.0238,0,0.0289,0.002,0.006,0.027,0.024,0.029,0.0289,0.008,0.016,0.016,0.0433,0.0292,0.0579,0.0298,0.0285,0.0962,0.0603,0.1454,0.0868,2.11,1.0525,19.51,0.53911,26.061,4.8587-9.2879,2.1008-40.782-4.2618-40.982-1.1568,0.89722,1.4502,5.8807,7.8149,14.456,7.5483,8.5749-0.26653,28.414,3.4668,29.755,6.1312,0.0418,0.0832,0.0414,0.16866,0.029,0.23138-0.58064,1.8582-26.126-5.6683-35.95-1.0412-10.182,4.7967,29.198,1.8889,35.63,7.7508,6.4314,5.8619-12.856-0.54949-12.856-0.54949,0.00002,0-26.783-3.7157-30.802-1.8509-4.0199,1.8657-8.5803,6.1312-8.5803,6.1312s2.6722,5.3166,5.3518,4.2514c0.40822-0.16248,0.68724-0.19562,0.8435-0.14452,0.004,0.002,0.0254-0.002,0.0292,0,0.004,0.002,0.0256,0.0269,0.0292,0.0289,0.006,0.004,0.0238,0.024,0.0292,0.0289,0.004,0.006,0.0244,0.0234,0.029,0.0289,0.002,0.002,0.0274,0.0257,0.0292,0.0289,0.012,0.0267,0.0246,0.083,0.029,0.11578,0.0632,0.79931-1.8324,3.1235-1.8324,3.1235s37.532,9.0411,45.839,17.034c8.3068,7.9942-47.7-12.523-47.7-12.523,0-0.00002-22.51,8.2588,1.3379,8.7919-2.6581,3.8668,1.101,6.2468,1.3379,6.3915,0,0,39.668,8.2679,43.687,14.663,4.0199,6.395-27.063-6.1386-34.03-9.6017-6.7217-3.3423-25.432,1.7676-26.497,3.3259-0.008,0.012-0.0238,0.0459-0.029,0.0579-0.002,0.006,0.002,0.0232,0,0.0289-0.002,0.012-0.00088,0.0473,0,0.0579,0.00092,0.006-0.00094,0.0238,0,0.0289,0.002,0.006-0.002,0.0238,0,0.0289,0.002,0.006,0.0266,0.0236,0.029,0.0289,0.002,0.006-0.002,0.0236,0,0.0289,0.012,0.0214,0.0414,0.0653,0.0582,0.0868,0.004,0.006,0.0242,0.0236,0.029,0.0289,1.1986,1.3133,9.5504,3.1219,9.8019,5.3793,0.00092,0.01-0.00068,0.02,0,0.0289,0.004,0.12056-0.0334,0.2632-0.0874,0.37598-1.052,2.0283-11.016,2.8911-11.431,4.8009-0.006,0.0327-0.029,0.0824-0.029,0.11578-0.00002,2.1323,50.125,12.524,63.523,23.715s-39.382-13.333-39.382-13.333,2.9477,3.995,0,5.0612c-2.9477,1.0652-13.419-14.92-30.569-5.0612-3.1236,4.0563,14.974,7.2758,19.575,7.7218-1.5711,4.0166-2.9411,5.3453,3.4903,9.3415,0.70332,0.43718,1.0982,0.7013,1.2507,0.83872,0.004,0.004,0.025,0.0248,0.0292,0.029l0.029,0.029c0.002,0.002-0.00092,0.0264,0,0.029-0.00058,0.002,0.00092,0.0276,0,0.029-0.002,0.0004-0.0256-0.00012-0.029,0-0.004-0.0002-0.0246,0.00048-0.0292,0-0.99616-0.155-12.55-6.0591-13.758-6.3048-0.012-0.002-0.0492,0.00072-0.0582,0-0.004,0.00022-0.0262-0.00054-0.029,0,0,0.53304,1.3379,6.941,1.3379,6.941-5.9372-4.7958-13.114-6.2418-19.836-1.3303-0.01,0.28412-0.0592,4.8825,6.6897,7.7219-3.8039,7.7286,4.2986,5.329,17.161,12.523-19.116-4.9679-20.647,4.2602-6.9805,6.3915s51.19,3.4668,60.033,14.923c1.8653,2.4168,2.3715,3.632,2.0069,4.02-1.4749,1.3291-15.044-8.4295-17.015-8.7919-0.004,0.002-0.025-0.004-0.0292,0-0.004,0.004-0.025,0.0244-0.0292,0.029-0.025,0.0312-0.0624,0.093-0.0874,0.1446-0.48156,1.06-0.93074,5.6685-0.93074,5.6685-5.7166-3.2901-10.962-6.2414-17.8-7.6351-0.5361,1.0652-0.42372,2.5788-0.95982,3.644-6.2053-4.4496-11.611-7.578-20.622-8.0111-0.3574,1.4215-0.71878,2.8588-1.0762,4.2803,0.00002-0.00002-7.5122-9.3259-22.251,0-8.2296,5.8665,31.089,2.1242,37.52,9.0522,6.4314,6.9271,1.338,7.9822,1.338,7.9822-5.3592-1.9537-10.696-3.8883-16.055-5.842,0,0-19.044-3.4819-24.403,0.78086-5.3592,4.2636,78.243,14.658,80.654,26.116,1.626,6.2136-19.642-6.5065-38.044-11.973-0.7118,2.0339-1.4405,4.0684-2.1523,6.1023-0.43642-0.4293-7.5548-7.3139-15.532-8.5027-0.002,0.004-0.027,0.0222-0.0292,0.029-0.00094,0.01,0.00024,0.0448,0,0.058,0.012,0.87446,1.6288,7.1145,1.6288,7.1145-0.00002,0.00002-20.613-9.6029-31.063-4.5406-10.451,5.0623,36.433,7.726,40.72,12.523,0.46888,0.52454,0.66404,0.90692,0.63988,1.1569-0.008,0.0432-0.0374,0.109-0.0582,0.1444-1.0356,1.5081-15.017-4.0618-16.404-1.3014-1.6083,3.1975-24.38-5.8533-24.112-1.5907,0.26804,4.2636,3.2285,6.6518,3.2285,6.6518-0.00002,0,47.43,4.5269,49.038,10.122,1.6074,5.5954-26.264-3.1813-26.264-3.1813s-2.6961,3.9772-0.55262,5.842c0.0838,0.0728,0.1506,0.1426,0.1744,0.1734,0.0007,0.002-0.00016,0.0274,0,0.029-0.002-0.00064-0.0254,0.00092-0.0292,0-0.96878-0.31776-16.07-10.153-14.601-2.6029-5.9093-2.3396-21.166-9.5864-19.022-3.9911,2.112,5.5131,41.905,13.363,43.076,13.593-1.0523,0.0824-17.881,1.4824-17.102,5.871-22.555-13.663-22.502-5.4696-21.989-4.8298,0.00092,0.00088-0.00094,0.0282,0,0.029-1.2671-0.1992-29.016-7.073-6.9515,4.8009,11.833,6.3674,14.717,8.8497,14.776,9.8042,0.00038,0.021,0.002,0.0672,0,0.0868-0.004,0.0254-0.0202,0.064-0.029,0.0868-0.002,0.006-0.0262,0.0236-0.0292,0.029-0.01,0.016-0.018,0.0434-0.029,0.0578-0.004,0.004-0.025,0.0244-0.0292,0.029-0.004,0.004-0.0244,0.0248-0.0292,0.029-0.004,0.004-0.024,0.025-0.029,0.029-0.006,0.004-0.0236,0.0252-0.0292,0.029-0.45872,0.2918-1.5672,0.1696-1.8906,0.1734-0.014,0.0005-0.0482-0.00092-0.0582,0-0.006,0.002-0.028,0.026-0.029,0.029l0.029,0.029c0.3148,0.46536,2.046,5.1646,1.9487,5.9866-0.002,0.014-0.0256,0.0472-0.0292,0.0578-0.002,0.004,0.002,0.0248,0,0.029-0.00092,0.002-0.0276-0.002-0.0292,0-0.002,0.00092,0.002,0.028,0,0.029-0.002,0.00052-0.027-0.00036-0.0292,0-0.002-0.00024-0.026,0.00048-0.0292,0-0.96696-0.24222-15.581-8.0078-20.593-8.5316-5.0921-0.5331-29.215,6.6534-3.4903,17.844s41.526-2.6693,55.728-1.0701c14.202,1.5983,20.914,4.0015,19.575,8.5317-1.3403,4.5293-14.528-14.85-28.388,1.9088-15.766-3.1022-26.462-4.8974-18.324,6.6229-25.747-9.5675-41.47,2.9189-9.0456,7.9822,31.862,0.93378,51.452-7.7219,51.452-7.7219,0,0.00002,5.375,9.878,13.147,2.9499,7.4065-6.6024,7.9891,1.8005,8.2603,2.6029,0.004,0.012,0.025,0.0222,0.0292,0.029,0.002,0.002-0.002,0.0278,0,0.029,0.002,0,0.026,0.0004,0.029,0,0.57222-0.143,7.475-3.2102,7.475-3.2102,0.62546,0.00002,1.2651,0,1.8906,0v63.944c8.6643,0.0888,17.309,0.1714,25.973,0.2603,0,0-8.3071-55.674-3.752-63.134,4.4136-7.2271,8.5863-6.447,8.842-6.3915,0,0,16.885,5.051,18.76,4.2514,0.0218-0.01,0.0664-0.018,0.0874-0.029,0.014-0.008,0.045-0.021,0.0582-0.029,0.0326-0.0206,0.0866-0.0628,0.1164-0.0868,0.006-0.004,0.0232-0.024,0.0292-0.029,1.3722-1.2456-0.0258-6.1609,8.5512-5.4082,2.6483-0.95788,1.6378-5.1559,3.3448-6.1891,0.0302-0.018,0.0846-0.0424,0.1164-0.0578,0.0644-0.0302,0.161-0.065,0.23268-0.0868,0.1-0.0286,0.23388-0.0462,0.34902-0.0578,2.6796-0.26652,54.392,14.376,65.646,0.52058-2.9477-7.7267-13.143-0.52682-15.823-0.2603-2.4116,0.00002-12.602-4.7958-18.498,0-5.3592-3.9962-29.726-6.6518-29.726-6.6518-3.2157-3.1975,58.149,1.5881,61.632-0.80978,7.2347-7.1946-13.392-6.389-16.608-3.9911-5.7166-3.464-12.9-3.2077-17.277-0.80976-2.0988-4.992-22.024-2.8299-33.099-4.2514-3.5452-2.0675-2.9549-3.2542-0.55262-4.5406,23.134,0.97728,46.151,3.9809,69.398,2.9499,6.2834-8.145-7.9101-11.217-16.608-4.2803-5.1061-8.3496-15.545-0.2714-22.512-1.0701-6.9666-0.79962-3.7521-9.3139,5.09-7.9822,8.843,1.3327,24.655-0.5435,27.602-4.5406,2.9467-3.9962-1.7596-8.0449-16.346-4.2514-4.9367-4.7976-15.792-0.008-20.884,1.5907-6.7739-3.7574-22.534-0.52288-27.893,0.80978-5.2466-3.2428,27.602-8.5316,27.602-8.5316,12.679-0.22304,19.831-2.4044,23.85-3.4705,19.168-10.215-0.26688-11.3-10.325-3.8754-6.2434-4.8467-12.173,0.41904-17.8,2.2848-5.2756,1.7483-15.032,3.0217-16.23,2.5161-0.014-0.006-0.0468-0.0218-0.0582-0.029-0.002-0.002-0.0262-0.0264-0.0292-0.029l-0.029-0.029c-0.00092-0.002,0.00064-0.026,0-0.029,0-0.002-0.00046-0.0256,0-0.029,0.004-0.012,0.0208-0.044,0.029-0.0578,0.79028-1.2183,15.241-10.036,15.241-10.036,0-0.00002,18.76-1.3468,22.512-1.8798,2.2862-0.32486,10.299-4.0965,10.296-5.495-0.0672-0.86806-3.4056-0.78834-13.525,1.7642-9.111,0.79958-14.462,0.28294-17.946,0.54946-5.6028-0.57596-7.9633-1.1632-8.4348-1.6774-0.018-0.0218-0.047-0.0652-0.0582-0.0868-0.0392-0.0928-0.014-0.20012,0.0582-0.28922,0.018-0.0206,0.0634-0.0664,0.0874-0.0868,1.3734-1.0907,10.238-1.8799,10.238-1.8799,0,0.00002,27.063-2.4678,28.853-3.8754,0.006-0.006,0.0234-0.0234,0.029-0.029,0.01-0.012,0.0228-0.0468,0.029-0.0578,0.002-0.006,0.0276-0.0236,0.0292-0.029,0.55686-11.002-22.959-5.9217-23.588-5.842,0.0672-7.7363-21.224-0.1136-22.221,0-0.002-0.00028-0.0278,0.00052-0.0292,0-0.91604-0.53664-1.3153-1.1029-1.3961-1.6196-0.0262-0.197-0.00092-0.41868,0.0582-0.60734,0.53332-1.5952,3.752-2.8342,3.752-2.8342,5.8953-1.4206,14.71-1.8641,17.015-3.7308,0,0,16.639-0.1456,18.615-4.5406-4.0831-11.201-35.213,1.9828-39.382,3.9911-0.8353,0-1.3468-0.20866-1.5997-0.5495-1.3688-1.9886,5.3863-8.5371,5.6135-8.763,0.002-0.002,0.0238-0.0268,0.029-0.029,1.0295-0.29038,25.884-1.5549,37.753-17.555,0.83768-9.8933-14.194,5.5817-14.194,5.5817-1.1225-12.831-16.345,0.81374-25.188,1.8799-8.8421,1.0652-9.101-4.0012-2.9377-4.8009,6.1624-0.79868,13.124-0.2758,16.608-9.6017,3.4829-9.3259,13.947,0.54304,15.823-2.921,1.8169-3.3558-3.4237-6.2163-3.752-6.3915,0.00002,0,7.7656-8.0173-4.8282-7.7508-12.467,0.26386-28.585-1.5536-28.911-1.5906,0.78186-0.29674,13.48-5.0591,25.421-4.8009,12.327,0.26652,5.6245-8.792-6.1662-8.792-11.79,0-17.946-3.9911-17.946-3.9911,6.6995-2.4867,13.399-4.9749,20.098-7.4616-0.44678-1.8648-0.89122-3.7169-1.338-5.5817,0,0,11.786-9.3326-4.8282-7.2013-16.614,2.1323-18.498,2.4004-18.498,2.4004-0.00002,0-32.705,4.9833-33.478,5.0612-0.002,0-0.026,0.00034-0.0292,0-0.31656-0.0493-3.5559-1.0501-4.1592-2.2848-0.018-0.0405-0.0456-0.1036-0.0582-0.14452-0.014-0.0493-0.0244-0.12356-0.0292-0.17346-0.004-0.0583-0.01-0.14332,0-0.20244,0.135-0.65065,1.1438-1.3542,3.723-1.9955,8.5749-2.1314,38.87-8.251,43.425-6.6518,0.58728,0.20602,1.016,0.15948,1.2798-0.0579,1.708-1.5368-3.9744-11.338-17.917-12.725-16.078-1.5983-25.973,3.9911-25.973,3.9911s-10.462-3.7435-0.8144-6.941c9.6462-3.1966,24.926,1.0701,24.926,1.0701-0.00002,0,17.14-5.07,2.9376-7.2013-14.202-2.1323-18.68,1.9171-25.188,2.1402-2.5977-3.2243,22.297-3.9855,23.85-6.6518-2.6256-4.7976-18.028,0-27.05,0-3.8374-1.6186-4.0913-4.2523,0.26178-5.8709,9.2004-0.35538,17.849,0.18184,27.05-0.17346-0.26804-4.8846,0.006-10.675-0.26176-15.559-11.67-2.1203-25.355,1.5527-31.907,1.2436,1.7526-5.3298,26.949-6.7055,29.755-8.1557,5.7892-7.1953-24.167-0.11118-24.897,0-5.3173-0.78111-4.9953-4.123-1.6288-6.1312,7.7707-0.88844,25.197,1.1323,23.879-4.1068-1.0098-4.9093-12.082-2.2808-16.637-1.2147-4.555,1.0652-11.256,0.26028-11.256,0.26028-2.917-3.905,26.27-2.3089,26.003-5.3214-0.38064-3.4587-18.501-1.0763-24.665-0.8098-4.7404-3.2522,22.286-5.4145,23.559-5.842,0.006-0.004,0.0256-0.02594,0.0292-0.02894,1.0099-8.8575-18.76,0-22.512,0-0.64484,0-1.1329-0.16008-1.4834-0.43382-0.0782-0.06328-0.167-0.1577-0.2327-0.23136-1.288-1.4941-0.1454-4.9166-0.1454-4.9166s7.0453-3.1479,7.475-3.9043c0.002-0.006,0.027-0.02316,0.0292-0.02894,0.00086-0.002-0.00062-0.02616,0-0.02894-0.00008-0.002,0.00032-0.02654,0-0.02894-0.002-0.004-0.0262-0.02456-0.0292-0.02894-0.016-0.02236-0.0552-0.06068-0.0874-0.08682-0.82702-0.63325-5.673-2.2317-6.3115-2.2848-0.004-0.00022-0.025,0-0.0292,0-0.004-0.0015-0.0252-0.02674-0.029-0.02894-0.008-0.006-0.0222-0.02036-0.0292-0.02894-0.004-0.004-0.0258-0.02336-0.0292-0.02894-0.365-0.74486,0.0874-6.0445,0.0874-6.0445s5.5825-4.1597,5.9335-5.8131c0.002-0.014-0.002-0.04452,0-0.05788,0.002-0.014-0.00068-0.04512,0-0.05788,0.0003-0.012,0.0005-0.0455,0-0.05788-0.00088-0.012,0.002-0.0461,0-0.05788-0.00092-0.006,0.00092-0.02336,0-0.02894-0.004-0.016-0.0228-0.04232-0.0292-0.05788-0.002-0.006,0.002-0.02376,0-0.02894-0.002-0.004-0.0264-0.02396-0.0292-0.02894-0.006-0.01-0.0226-0.02-0.0292-0.02894-0.01-0.014-0.018-0.0455-0.029-0.05788-0.004-0.004-0.0246-0.02496-0.0292-0.02894-0.0224-0.018-0.0604-0.04152-0.0874-0.05788-0.012-0.006-0.0464-0.02296-0.0582-0.02894-1.4099-0.67313-7.2423,1.3304-7.2423,1.3304-0.00002-1.7763,0-3.5451,0-5.3215-0.00002,0,5.1065-0.55195,5.6426-2.9499,0.0314-0.14052,0.016-0.27865,0-0.4049-0.008-0.0501-0.014-0.12556-0.0292-0.17346-0.0332-0.103-0.0834-0.22493-0.1456-0.31813-0.01-0.014-0.0476-0.04392-0.0582-0.05788-1.1684-1.4997-5.9335-1.7063-5.9335-1.7063-0.89348-9.3256-1.7823-18.641-2.6759-27.966zm-4.77,91.332,0,3.673c0.00002,0-6.0093-0.30606-7.126-1.2436-0.006-0.004-0.0244-0.0244-0.0292-0.0289-0.004-0.004-0.0246-0.0242-0.0292-0.0289-0.004-0.004-0.025-0.0242-0.0292-0.0289-0.004-0.004-0.0254-0.0242-0.0292-0.0289-0.01-0.014-0.0216-0.0431-0.0292-0.0579-0.002-0.004,0.002-0.024,0-0.0289-0.002-0.004-0.0276-0.024-0.029-0.0289-0.00092-0.004,0.00088-0.024,0-0.0289-0.00092-0.01,0.0001-0.0475,0-0.0579,0.00022-0.006-0.0005-0.0238,0-0.0289,0.0008-0.006-0.00092-0.0236,0-0.0289,0.006-0.0214,0.018-0.0649,0.029-0.0868,0.002-0.006,0.026-0.0234,0.0292-0.0289,0.014-0.0224,0.0392-0.0641,0.0582-0.0868,0.006-0.006,0.0236-0.0232,0.0292-0.0289,0.012-0.012,0.0454-0.0461,0.0582-0.0579,0.0402-0.0353,0.0928-0.079,0.1454-0.11578,2.0161-1.4035,6.0415-1.3704,6.8351-1.5906,0.006-0.002,0.023,0.002,0.0292,0,0.006-0.002,0.024-0.0267,0.029-0.0289,0.004-0.002,0.0254,0.002,0.0292,0,0.004-0.002,0.0262-0.0265,0.0292-0.0289zm8.5221,4.8876c0.20764,0,11.97,0.1006,13.001,1.6196,0.008,0.012,0.0226,0.0447,0.0292,0.0579,0.008,0.02,0.0242,0.0665,0.0292,0.0868,0.002,0.014-0.00072,0.0439,0,0.0579-0.00014,0.021,0.004,0.0655,0,0.0868-0.006,0.0216-0.02,0.0647-0.0292,0.0868-0.89816,1.8972-12.798,3.0367-12.798,3.0367l-0.23268-5.0322zm-0.66898,7.2591c0.004,0.002,0.0248-0.002,0.029,0,0.004,0.002,0.0232-0.002,0.0292,0,0.69832,0.18344,5.5701,0.34048,6.1662,1.1568,0.006,0.008,0.0246,0.0212,0.0292,0.0289,0.002,0.004-0.002,0.025,0,0.0289,0.004,0.008,0.0264,0.0208,0.0292,0.0289,0.00092,0.004-0.00086,0.025,0,0.0289,0.00044,0.004-0.00026,0.0248,0,0.0289,0.00002,0.004,0.00016,0.0247,0,0.0289-0.0004,0.004,0.00058,0.0246,0,0.0289-0.0008,0.004,0.00092,0.0246,0,0.0289-0.002,0.004-0.0276,0.0244-0.0292,0.0289-0.002,0.004,0.002,0.0244,0,0.0289-0.008,0.014-0.02,0.0439-0.0292,0.0579-0.004,0.004-0.0256,0.0242-0.0292,0.0289-0.004,0.004,0.004,0.0242,0,0.0289-1.0099,1.2272-5.5056,1.5618-5.7299,1.5618-0.002-0.0004-0.0274,0.00074-0.0292,0-0.002-0.00092,0.002-0.0275,0-0.0289-0.004-0.006-0.0254-0.0226-0.029-0.0289-0.20552-0.4149-0.40722-3.0656-0.40722-3.0656zm-35.863,9.6596c3.8405-0.1984,11.462,0.70093,25.77,4.6274,0,0.30278,0.28972,3.9918,0.1744,4.5984-0.00092,0.004-0.0278,0.0246-0.0292,0.0289-0.00092,0.004,0.00094,0.0261,0,0.0289-0.002,0.002-0.0258,0.0285-0.0292,0.0289-0.2243-0.11198-26.031-7.4859-28.388-7.3748-0.0644,0.002-0.1424,0.006-0.2036,0-0.052-0.006-0.1256-0.018-0.1744-0.0289-0.0642-0.016-0.1472-0.0611-0.20358-0.0868-0.0208-0.01-0.0678-0.018-0.0874-0.0289-0.006-0.004-0.0228-0.025-0.0292-0.0289-0.0784-0.0529-0.1562-0.13314-0.20358-0.20244-0.004-0.006-0.0258-0.0234-0.0292-0.0289-0.006-0.012-0.0238-0.0465-0.029-0.0579-0.002-0.006,0.002-0.023,0-0.0289-0.004-0.012-0.0264-0.0459-0.0292-0.0579-0.00092-0.006,0.00092-0.0228,0-0.0289-0.00092-0.012,0.0003-0.0453,0-0.0579,0.00024-0.012-0.00092-0.0451,0-0.0579,0.004-0.0321,0.018-0.0828,0.0292-0.11578,0.0318-0.079,0.097-0.18084,0.1744-0.26028,0.39462-0.38378,1.3829-0.76932,3.2867-0.86764zm13.379,10.903c4.1136-0.14672,13.969,2.211,14.514,2.0823-0.00002,0.78143,0.4361,4.475-0.0582,5.2347-0.004,0.006-0.0242,0.023-0.0292,0.0289-0.004,0.006-0.024,0.024-0.0292,0.0289-0.006,0.004-0.0238,0.0251-0.0292,0.0289-0.01,0.006-0.0466,0.0244-0.0582,0.0289-0.006,0.002-0.0228-0.00092-0.0292,0-0.012,0.00092-0.045,0.00092-0.0582,0-0.006-0.00092-0.022,0.002-0.0292,0-0.83768-0.20822-15.382-4.8016-15.939-6.6807-0.008-0.0309-0.00066-0.0862,0-0.11578,0.006-0.0655,0.038-0.14552,0.0874-0.20244,0.006-0.006,0.0224-0.023,0.0292-0.0289,0.006-0.006,0.022-0.023,0.0292-0.0289,0.27922-0.22006,0.85536-0.34943,1.5997-0.37597zm40.487,10.122c3.9283-0.0764,6.7017,0.25803,5.6717,1.446-2.8052,3.2354-22.192,5.8999-22.192,5.8999l-0.34902-5.8999c0.41636-0.0609,10.267-1.3177,16.87-1.446zm-55.495,18.394c3.2967-0.17446,10.974,1.6257,28.068,8.8209l0.1164,4.2514c0.00002,0-28.948-8.73-29.958-10.18-0.49704-0.71379-1.421-2.7229,1.7742-2.8921zm56.717,6.3337c0.88072-0.0445,1.5006,0.0441,1.716,0.26028,0.006,0.006,0.0244,0.0228,0.029,0.0289,0.012,0.02,0.0222,0.0657,0.0292,0.0868,0.004,0.0218,0.0296,0.0631,0.0292,0.0868-0.012,0.12196-0.104,0.28623-0.26178,0.46274-2.6936,3.0133-17.161,6.0155-17.161,6.0155s-0.00002-3.7923,0-3.9043c0.002,0.0002,0.026-0.00004,0.0292,0,0.65948-0.0224,11.279-2.8188,15.59-3.0367zm-63.465,0.52057c4.3217-0.22785,14.08,2.0514,35.95,12.349-0.00002,0.1068,0.1948,3.6583,0.1162,3.9911-0.002-0.00042-0.0262,0.00082-0.0292,0-1.2966-0.41556-39.353-13.708-39.353-13.708-0.0406-0.14572-0.61308-2.4246,3.3158-2.6318zm72.452,16.63c1.1059-0.0462,1.8315,0.049,2.0069,0.2892,0.016,0.0278,0.027,0.0836,0.0292,0.1158-0.004,0.1156-0.1006,0.26294-0.29088,0.4338-3.451,3.099-25.453,6.8535-26.235,6.9121-0.004,0-0.0258,0.00044-0.0292,0-0.002-0.00092-0.026,0.002-0.029,0-0.002-0.002-0.0264-0.0262-0.0292-0.029-0.008-0.01-0.023-0.0438-0.0292-0.0578-0.002-0.006,0.002-0.0236,0-0.029-0.004-0.012-0.0262-0.0448-0.0292-0.0578-0.1398-0.7183,0.31564-3.2338,0.34902-3.5862,0.00032-0.006,0-0.0254,0-0.029,0.00092,0.00092,0.027-0.00092,0.0292,0,0.004,0.00068,0.0242,0.0286,0.029,0.029,0.006,0.00028,0.0226-0.00008,0.0292,0,1.4083-0.0234,18.27-3.7446,24.199-3.9911zm-64.686,9.6885c6.5501-0.33646,26.397,8.7127,27.37,8.9944,0.002,0.0005,0.0272-0.00006,0.0292,0-0.102,0.40426-0.1188,3.6714-0.20358,4.1935-0.002,0.014,0.002,0.0502,0,0.0578-0.0008,0.002-0.0284-0.0009-0.0292,0-0.53504-0.28494-27.736-11.51-28.94-10.614-0.75036-1.7681,0.0276-2.5421,1.7742-2.6318zm58.52,2.3715c1.3629-0.0596,2.3605,0.00064,2.6759,0.1734,0.0382,0.024,0.0732,0.0576,0.0874,0.0868,0.002,0.004-0.00092,0.0238,0,0.029,0.00024,0.006,0.00048,0.0236,0,0.029-0.002,0.012,0.006,0.0462,0,0.0578-0.004,0.006-0.0248,0.0228-0.0292,0.029-0.02,0.0254-0.0556,0.0588-0.0874,0.0868-2.0197,1.7852-20.767,5.466-20.767,5.466s-0.0874-3.4536-0.0874-3.7886c0.53248-0.1132,12.635-1.9246,18.208-2.1691zm-1.5125,11.944c1.3191-0.0436,2.2543,0.0312,2.4723,0.26028l0.029,0.029c0.006,0.01-0.002,0.0472,0,0.0578,0.0009,0.006,0.0288,0.0234,0.0292,0.029-0.00028,0.006-0.0282,0.0232-0.0292,0.029-0.002,0.012,0.006,0.0452,0,0.0578-0.004,0.006-0.0252,0.0224-0.029,0.029-0.016,0.0262-0.0348,0.0596-0.0582,0.0868-0.018,0.0206-0.064,0.0658-0.0874,0.0868-2.0235,1.7366-17.917,5.0611-17.917,5.0611s-0.43628-3.7923-0.43628-3.9043c0.44088,0.01,11.067-1.6583,16.026-1.822zm-67.071,0.95438c3.8347-0.24108,13.337,1.3301,36.793,9.8042l0.78532,4.5695c0,0.00002-39.055-12.536-40.167-12.928,0.002,0-0.00084-0.0258,0-0.029,0.00092-0.0242-0.006-0.0828,0-0.1448,0.014-0.1148,0.0724-0.2955,0.20358-0.46276,0.27524-0.33548,0.90404-0.71664,2.385-0.80976zm51.452,9.9199c0.47064,0.1,7.0193,0.31614,8.2312,1.3304,0.006,0.004,0.0238,0.0242,0.0292,0.029,0.004,0.004,0.0242,0.024,0.0292,0.029,0.004,0.004,0.025,0.024,0.0292,0.029,0.012,0.016,0.02,0.0426,0.0292,0.0578,0.002,0.006,0.0264,0.0238,0.029,0.029,0.01,0.021,0.0238,0.0652,0.0292,0.0868,0.00092,0.006-0.00082,0.0234,0,0.029,0.00054,0.006-0.00024,0.0234,0,0.029-0.00004,0.012,0.00092,0.0466,0,0.0578-0.0009,0.006,0.00092,0.0232,0,0.029-0.002,0.012-0.025,0.046-0.0292,0.0578-0.002,0.006,0.002,0.023,0,0.029-0.006,0.012-0.0218,0.0458-0.029,0.0578-1.0099,1.5622-7.8531,2.1402-7.8531,2.1402s-0.33622-3.0612-0.49446-4.02zm15.852,8.9076c1.5249-0.0364,2.6194,0.1372,2.8504,0.5784,0.13,0.29904-0.1202,0.74078-0.84346,1.3304-5.6105,4.5746-17.83,5.466-17.83,5.466v-5.0322c0.002,0.00024,0.0234,0.00038,0.0292,0,0.69412-0.082,10.731-2.2219,15.794-2.3426zm15.561,4.6852c1.9368-0.073,2.7713,0.24986,3.0249,0.6941,0.0204,0.0394,0.0464,0.1032,0.0582,0.1448,0.018,0.0752,0.0354,0.18,0.0292,0.26032-0.0624,0.57318-0.68666,1.26-1.1634,1.7063-1.908,1.7852-32.314,11.366-32.314,11.366s-0.22894-6.355-0.1164-6.9121c17.777-5.357,26.472-7.1081,30.482-7.2591zm-19.662,17.989c1.9331-0.0716,3.4447,0.042,3.8975,0.49162,0.0278,0.0298,0.0688,0.0828,0.0874,0.1158,0.01,0.0202,0.0224,0.0654,0.029,0.0868,0.006,0.0216-0.002,0.064,0,0.0868,0.00094,0.0386,0.01,0.1026,0,0.1448-0.022,0.0852-0.0806,0.19-0.1456,0.28922-2.6014,2.5386-15.241,2.921-15.241,2.921v-3.1524c2.3735-0.0796,7.6569-0.84556,11.372-0.9833zm12.652,5.1768c0.60092-0.014,0.96738,0.083,1.018,0.2603,0.002,0.014,0.002,0.043,0,0.0578-0.0304,0.1476-0.20694,0.37124-0.58172,0.63624-5.0493,3.5695-24.025,7.2302-24.025,7.2302s0.23512-2.4946,0.34902-3.0945c0.5278-0.008,18.699-4.9795,23.239-5.0901zm10.645,3.9622c2.236-0.021,3.9426,0.30708,4.9155,1.0122,0.002,0,0.0274-0.00048,0.0292,0,0.00072,0.002-0.00054,0.0258,0,0.029,0.00034,0.004-0.00016,0.025,0,0.029-0.00046,0.01,0.00092,0.0464,0,0.0578-0.0952,0.69158-1.5167,3.945-6.5152,5.3504-6.2343-0.5537-32.693,7.2241-33.216,7.3459-0.002-0.002-0.0278,0.002-0.029,0-0.002-0.01,0.00092-0.0434,0-0.0578-0.014-0.49822,0.34904-3.1813,0.34902-3.1813,9.1205-5.4234,25.695-10.503,34.466-10.585zm-67.74,15.27c0.0584-0.00092,0.1124-0.0002,0.1744,0,11.445,1.2272,15.72,5.4873,16.928,7.2013-2.2821,3.982-20.37-4.9484-18.469-6.8542,0.21758-0.1932,0.6654-0.33254,1.367-0.34706zm65.588,0.75196c0.45456-0.018,0.8697,0.0752,1.1634,0.26028,0.12,0.0798,0.2384,0.1944,0.31996,0.31812,0.1102,0.1776,0.1836,0.41798,0.2036,0.6941-1.1956,1.837-7.3791,1.0351-7.7659,0.9833,0.3115-0.1104,3.8818-2.1726,6.0789-2.2558zm-24.519,12.378c0.84862-0.0348,1.5537,0.0504,1.9487,0.28918,0.0478,0.0308,0.1076,0.0794,0.1454,0.1158,0.012,0.012,0.0474,0.0446,0.0582,0.0578,0.016,0.02,0.0454,0.0652,0.0582,0.0868,0.012,0.022,0.02,0.0632,0.0292,0.0868,0.072,0.21614,0.044,0.51458-0.1454,0.86762-1.7954,3.3474-9.6564,2.1112-9.6564,2.1112v-2.3426c0.002,0.00066,0.0272-0.00054,0.029,0,0.44278,0.0374,4.7752-1.1598,7.5332-1.2725zm-46.304,8.8209c2.4185-0.1214,4.5324,1.4562,6.7479,2.7185,4.9367-1.0041,15.066,0.78088,15.066,0.78088v4.4538c0,0.004-0.0228,0.0258-0.0292,0.029-0.004,0.002-0.023-0.002-0.029,0-0.92204,0.1596-12.793-0.3561-15.444-2.0244-2.1624,0-8.284-3.2125-8.7548-4.8587-0.004-0.014-0.0262-0.0442-0.0292-0.0578-0.004-0.0204,0.002-0.0668,0-0.0868-0.00066-0.014-0.00026-0.045,0-0.058,0.00068-0.012-0.002-0.0456,0-0.0578,0.00092-0.006-0.00094-0.0228,0-0.029,0.002-0.012,0.0252-0.0462,0.0292-0.0578,0.002-0.006-0.002-0.0232,0-0.029,0.84598-0.44826,1.6703-0.68424,2.4432-0.72302zm51.918,2.198c1.8569-0.0994,2.6442,0.47132,1.1925,2.5161-4.0394,5.6898-14.485,3.3548-14.485,3.3548l-0.43628-3.5284c3.6843,0.143,10.418-2.1652,13.728-2.3426zm-39.033,11.539c4.2236-0.1958,8.8129,1.475,8.8129,1.475,0.1082,0.21432,2.27,4.4517,0.34904,5.8709-0.0714,0.0512-0.1498,0.1014-0.23268,0.1446-2.3567,1.2272-13.62-0.95902-14.281-5.466,1.3254-1.3911,3.289-1.9289,5.3517-2.0245zm-43.541,2.198c3.8627-0.23048,8.1774,2.1356,8.6675,2.3715,0.006,0.002,0.0254-0.00092,0.029,0,0,0.1334-0.1454,4.2803-0.1454,4.2803s-7.6465-2.1195-10.064-6.3915c0.48468-0.1314,1.0023-0.22986,1.5125-0.2603zm73.558,0.57842c4.3081-0.0272,9.5129,0.97916,10.267,2.4294,0.1426,0.2966,0.1002,0.62358-0.1744,0.9544-2.1323,2.5654-14.252,0.23136-14.252,0.23136v-3.1234c1.0783-0.31364,2.5636-0.4816,4.1592-0.49168z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='700' height='600'%3E%3Crect width='700' height='600' fill='%230DB02B'/%3E%3Crect width='700' height='400' fill='%23FFF'/%3E%3Crect width='700' height='200' fill='%23e05206'/%3E%3Ccircle cx='350' cy='300' r='85' fill='%23e05206'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450'%3E %3Ctitle%3EFlag of New Caledonia%3C/title%3E %3Crect fill='%23009543' width='900' height='450'/%3E %3Crect fill='%23ed4135' width='900' height='300'/%3E %3Crect fill='%230035ad' width='900' height='150'/%3E %3Ccircle stroke='%23000' stroke-width='5' fill='%23fae600' cx='300' cy='225' r='147.48'/%3E %3Cpath stroke='%23000' stroke-width='6' d='M275,247h50 M275,210h50 M300,78V330'/%3E %3Cpath d='M240.62,360.419 C300.811,384.999,357.228,361.929,357.228,361.929 C357.228,361.929,335.931,338.881,325.014,329.882 C314.361,321.104,283.023,321.451,272.329,329.882 C263.405,336.92,237.809,362.852,240.62,360.419Z'/%3E %3Cellipse cx='300' cy='293' rx='16.5' ry='24'/%3E %3Cellipse cx='300' cy='228.5' rx='20' ry='12.66'/%3E %3Cellipse cx='300' cy='170' rx='20' ry='20'/%3E %3Cpath d='M324,95.5 C323.994,95.4866,325.733,98.3708,322.087,104.936 C304.661,136.319,287.174,136.997,283.855,139.7 C280.197,142.678,278.653,142.474,278.653,142.474 C278.914,139.786,279.157,128.795,279.348,127.736 C281.993,113.073,304.144,113.275,321.48,98.2605 C324.188,95.915,323.994,95.4866,323.994,95.4866Z'/%3E %3Cg id='leaf'%3E %3Cpath d='m 265.5,163 c0,0 3.91436,11.22974 4.5,22.5 c0.93516,17.99657 18.18031,18.5 30,18.5 l0,-10 c-8.85851,0 -16.55267,-1.31658 -23,-14.5 c-3.18045,-6.50336 -11.5,-16.5 -11.5,-16.5z'/%3E %3Cpath d='m 265,308 c0,0 6.29638,-7.76543 13.6619,-25.97461 C282.5048,272.5249 291.6115,267 300,267 l0,-14 c-19.02757,0 -28.1503,7.0552 -29.11281,17.36332 C268.90975,291.54089 265,308 265,308z'/%3E %3C/g%3E %3Cuse xlink:href='%23leaf' transform='translate(600,0)scale(-1,1)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 90 60'%3E %3Cpath d='M90,0H0V60z' fill='%23003580'/%3E %3Cpath d='M0,60H90V0z' fill='%23009543'/%3E %3Cpath d='M0,60 90,0' stroke='%23fff' stroke-width='20'/%3E %3Cpath d='M0,60 90,0' stroke='%23d21034' stroke-width='15'/%3E %3Cg fill='%23ffce00' transform='translate(18,16.34148)'%3E%3C!-- ty=(87*sqrt(13)-281)/2 --%3E %3Cg id='r4'%3E %3Cpath id='r' d='M0,10 1.552914,5.795555H-1.552914z'/%3E%3C!-- x2=6*sin(15deg); y2=6*cos(15deg) --%3E %3Cuse xlink:href='%23r' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(30)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(60)'/%3E %3Ccircle r='5.5' stroke='%23003580'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23000'/%3E %3Crect width='900' height='206.25' fill='%23fff'/%3E %3Crect width='900' height='187.5' fill='%23007168'/%3E %3Crect y='393.5' width='900' height='206.5' fill='%23fff'/%3E %3Crect y='412.5' width='900' height='187.5' fill='%23fce100'/%3E %3Cpath d='M 0,0 V 600 L 393.75,300 z' fill='%23d21034'/%3E %3Cpath d='M 189.54603,214.56867 L 128.78569,171.99623 L 69.930531,217.0706 L 91.643351,146.12847 L 30.587837,104.08263 L 104.76744,102.81043 L 125.88822,31.750306 L 150.02091,101.90617 L 224.12978,100.03443 L 164.86501,144.66535 z' transform='matrix(1.221793,2.542786e-2,-2.542786e-2,1.221793,-21.7604,145.5065)' fill='%23fce100'/%3E %3Cpath d='M 77.1122,167.913 L 118.946,167.913 C 122.312,171.689 129.822,173.229 136.975,167.868 C 150.087,160.688 175.454,167.913 175.454,167.913 L 180.449,162.606 L 168.273,122.645 L 163.902,117.962 C 163.902,117.962 154.537,112.343 136.741,114.216 C 118.946,116.089 112.702,113.592 112.702,113.592 C 112.702,113.592 97.0927,115.465 92.7219,117.65 C 92.2414,118.039 87.7268,122.645 87.7268,122.645 z' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='%23fff' fill-rule='evenodd' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 85.5415,157.611 C 85.5415,157.611 125.502,152.616 137.054,167.913 C 130.53,172.377 124.786,172.745 118.634,168.226 C 119.614,166.593 132.995,152.616 167.024,157.299' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='none' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 128.312,117.65 L 128,161.67 M 163.902,118.274 L 171.395,153.24 M 93.1339,117.725 L 88.9756,135.757' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M 49.9417,172.706 L 59.7799,184.241 C 60.9352,184.93 61.9614,184.886 62.9876,184.241 L 77.5681,166.745 L 83.6919,159.163 C 84.6401,158.04 84.9428,156.787 84.8583,155.664 L 96.5657,145.261 C 97.5234,145.327 98.0938,145.435 99.0515,145.5 C 97.92,145.207 97.0898,144.656 97.9807,143.416 L 100.605,141.375 L 102.646,143.999 C 102.646,143.999 99.7304,147.79 99.4388,147.79 C 99.1472,147.79 96.2311,147.79 96.2311,147.79 L 90.1073,153.331 L 92.7843,155.697 L 96.8143,166.745 L 101.772,163.245 L 98.5639,151.873 L 105.563,144.291 L 102.938,140.208 L 104.688,137.875 C 104.688,137.875 128.91,153.125 138.242,149.043 C 138.494,149.134 138.806,138.167 138.806,138.167 C 138.806,138.167 113.728,135.543 113.144,130.585 C 112.561,125.628 118.685,125.045 118.685,125.045 L 116.06,121.254 L 116.644,119.212 L 121.018,124.753 L 130.933,116.296 L 189.254,182.783 C 192.438,181.492 193.118,180.713 193.337,177.534 C 193.255,177.454 136.182,111.922 136.182,111.922 L 140.556,107.257 C 141.418,106.285 141.721,105.872 141.722,104.34 L 148.429,98.5082 C 150.446,99.2011 151.732,100.41 152.803,102.007 L 171.242,86.3801 C 171.728,86.8661 173.204,87.3521 174.206,86.8055 L 204.691,57.5442 L 171.466,81.0116 L 170.3,80.1368 C 170.3,79.1647 171.505,78.9243 170.3,77.2207 C 169.009,75.6716 167.092,78.6788 166.801,78.6788 C 166.509,78.6788 161.992,77.0824 161.002,75.06 L 160.677,80.4284 L 152.22,88.3019 L 145.805,88.0103 L 136.473,97.0501 L 135.307,100.549 L 136.765,103.466 C 136.765,103.466 131.807,107.84 131.807,107.548 C 131.807,107.257 130.805,106.259 130.762,106.13 L 135.015,102.299 L 135.598,99.6747 L 134.179,97.4589 C 133.749,97.7714 128.308,103.466 128.016,102.882 C 127.53,102.338 112.27,85.0942 112.27,85.0942 L 113.144,81.8865 L 103.23,71.0969 C 99.6155,69.849 93.8982,69.6389 92.7318,77.5123 C 91.8235,79.3616 84.2751,77.8039 84.2751,77.8039 L 80.1926,78.6788 L 57.1554,111.339 L 69.9862,126.794 L 96.2311,93.5508 L 97.0102,84.1332 L 102.517,90.2905 C 104.353,90.5264 106.102,90.5471 107.766,89.7073 L 123.315,107.063 L 120.726,109.589 C 121.601,110.561 122.203,111.182 123.078,112.154 C 123.953,111.571 124.788,110.871 125.663,110.287 C 125.955,110.677 126.441,111.416 126.733,111.805 C 125.43,112.514 124.516,113.458 123.213,114.167 C 121.128,112.808 119.115,111.116 119.268,108.423 L 110.52,115.713 L 110.228,117.171 L 84.2751,138.75 L 81.9422,139.042 L 81.359,145.749 L 98.2723,131.752 L 98.2723,129.71 L 100.022,131.168 L 113.144,120.671 C 113.144,120.671 114.019,121.837 113.728,121.837 C 113.436,121.837 102.063,132.335 102.063,132.335 L 101.772,133.501 L 99.7304,135.251 L 98.5639,134.376 L 82.817,148.373 L 80.4842,148.373 L 71.7359,157.122 C 69.4795,157.318 67.5243,157.557 65.6121,158.871 z' transform='matrix(1.259719,0,0,1.259719,-29.41569,140.9042)' fill='%23000' fill-rule='evenodd' stroke='%23000' stroke-width='1.25' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='2800' height='1400'%3E %3Crect width='2800' height='1400' id='red' style='fill:%23cc0001'/%3E %3Crect width='2800' height='100' y='1300' id='white' style='fill:%23fff'/%3E %3Cuse transform='translate(0,-200)' id='use3035' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-400)' id='use3038' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-600)' id='use3062' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-800)' id='use3064' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-1000)' id='use3066' xlink:href='%23white'/%3E %3Cuse transform='translate(0,-1200)' id='use3068' xlink:href='%23white'/%3E %3Crect width='1400' height='800' id='blue' style='fill:%23010066'/%3E %3Cpath d='M 576,100 C 409.85356,100 275,234.40553 275,400 C 275,565.59446 409.85356,699.99999 576,700 C 636.02725,700 691.95466,682.43566 738.92693,652.21675 C 711.57383,661.65623 682.2175,666.81914 651.65599,666.81914 C 504.3291,666.81915 384.75944,547.64674 384.75944,400.80929 C 384.75944,253.97184 504.32908,134.79944 651.65599,134.79944 C 684.21403,134.79944 715.40185,140.61419 744.2578,151.26671 C 696.21698,118.90999 638.30493,100 576,100 z' id='path4945' style='fill:%23fc0'/%3E %3Cpath d='M 914.28574,471.42858 L 814.74817,418.17806 L 844.17832,527.16068 L 777.60261,435.99589 L 756.83247,546.9551 L 736.40474,435.93234 L 669.5481,526.89131 L 699.31432,418.00001 L 599.61295,470.94319 L 673.67755,385.75059 L 560.87853,390.19195 L 664.57212,345.5715 L 561.01668,300.63137 L 673.80146,305.42069 L 600.00003,220.00001 L 699.53759,273.25053 L 670.10745,164.26791 L 736.68316,255.4327 L 757.4533,144.47349 L 777.88103,255.49624 L 844.73767,164.53728 L 814.97145,273.42858 L 914.67282,220.4854 L 840.60822,305.67799 L 953.40723,301.23664 L 849.71365,345.85709 L 953.26909,390.79722 L 840.48431,386.0079 z' transform='matrix(1.2737922,0,0,1.2422928,-89.4427,-29.478379)' id='path4959' style='fill:%23fc0'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='840' height='480'%3E %3Cdefs%3E %3ClinearGradient id='lg'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%23f15770' offset='1'/%3E %3C/linearGradient%3E %3CradialGradient id='rg1' xlink:href='%23lg' gradientUnits='userSpaceOnUse' cx='842.31' cy='103.66' r='25.859' gradientTransform='matrix(0.185743,0.047185,-0.04532,0.186354,233.798119,198.76959)'/%3E %3CradialGradient id='rg2' xlink:href='%23lg' gradientUnits='userSpaceOnUse' cx='651.52' cy='550.46' r='25.859' gradientTransform='matrix(-0.176418,-0.070669,0.065152,-0.163915,430.544346,377.87561)'/%3E %3CradialGradient id='rg3' xlink:href='%23lg' gradientUnits='userSpaceOnUse' cx='380.84' cy='740.37' r='25.859' gradientTransform='matrix(0.098907,0.003695,-0.004498,0.194304,442.362219,123.304182)'/%3E %3C/defs%3E %3Crect height='480' width='840' fill='%23ce1126'/%3E %3Crect height='480' width='560' fill='%23fff'/%3E %3Crect height='480' width='280' fill='%23006847'/%3E %3Cg id='coa'%3E %3Cg id='branches'%3E %3Cg fill='%23fcca3e' stroke='%23aa8c30'%3E %3Cpath stroke-width='0.35' d='m466.96,303.53,0,0,0.29345,5.8781,2.2196-1.4668-1.702-4.8389z'/%3E %3Ccircle stroke-width='0.3' cx='466.703' cy='301.93' r='1.892'/%3E %3Cpath stroke-width='0.35' d='m474,312.69,0,0-4.3004-4.119-1.9314,1.5534,5.8424,3.4045z'/%3E %3Cpath stroke-width='0.3' d='m473.63,315.01c-0.60827-0.81462-0.40336-2.0033,0.44551-2.6582,0.85314-0.65442,2.0376-0.52396,2.6459,0.28851,0.60132,0.81461,0.40284,2.0065-0.44871,2.6615-0.85368,0.65276-2.0371,0.5207-2.6427-0.29176z'/%3E %3Cpath stroke-width='0.35' d='m507.04,251.22,0,0,4.4071,4.3842,0.51221-2.2192-4.0283-2.7009z'/%3E %3Ccircle stroke-width='0.3' cx='506.451' cy='250.09' r='1.845'/%3E %3Cpath stroke-width='0.35' d='m518.65,253.82,0,0-6.7334,1.9215,0.55489-2.2246,5.789-0.56291z'/%3E %3Ccircle stroke-width='0.3' cx='519.742' cy='252.89' r='1.803'/%3E %3Cpath stroke-width='0.35' d='m496.03,287,0,0-4.1083-6.3977,0.6616-0.33016,4.6472,5.4884z'/%3E %3Ccircle stroke-width='0.3' cx='491.518' cy='279.115' r='1.909'/%3E %3Cpath stroke-width='0.35' d='m496.29,287.17,0,0,5.2181,0.95262,0.19208-0.71446-4.3698-1.732z'/%3E %3Ccircle stroke-width='0.3' cx='503.102' cy='288.18' r='1.889'/%3E %3Cpath stroke-width='0.3' d='m373.59,301.72c0,0.91047-0.7139,1.5562-1.391,1.5562-0.67173,0-1.2191-0.73506-1.2191-1.6401,0-0.90881,0.54688-1.6439,1.2191-1.6439,0.67708,0,1.391,0.8238,1.391,1.7278z'/%3E %3Cpath stroke-width='0.35' d='m373.56,304.65,0,0,1.1952,6.5655-1.59-0.62787-0.5709-5.7049z'/%3E %3Cpath stroke-width='0.3' d='m375.01,302.42c0.76673,0.99436-0.53142,2.5115-1.9091,2.8888-1.3781,0.37564-3.0978-0.26035-3.0807-1.5221,0.0182-1.4317,2.0099-0.68632,2.5445-0.85254,0.82541-0.26036,1.621-1.5838,2.4453-0.51422z'/%3E %3Cellipse stroke-width='0.3' cx='363.566' cy='312.49' rx='2.045' ry='1.483'/%3E %3Cpath stroke-width='0.35' d='m367.03,312.14,0,0,6.3066-0.31393-1.0671-1.2557-5.1808,0.56291z'/%3E %3Cpath stroke-width='0.3' d='m367.56,311.41c0.52556,1.5973,0.56932,3.7744-1.2181,3.5448-1.7911-0.23275-1.4523-1.8333-1.591-2.4498-0.2561-1.121-1.3067-2.1305-0.22783-3.2234,1.0794-1.0966,2.5082,0.52883,3.037,2.1283z'/%3E %3Cellipse stroke-width='0.3' cx='347.006' cy='276.955' rx='1.236' ry='1.881'/%3E %3Cpath stroke-width='0.35' d='m347.03,281.12,0,0,0.14406,6.1108-1.59-1.4452,0.11205-4.8659z'/%3E %3Cpath stroke-width='0.3' d='m349.39,279.26c0.32173,1.4095-1.7452,2.2041-3.1522,1.9421-1.4059-0.25767-2.4693-0.99271-2.2564-2.2891,0.21288-1.2985,1.9592-1.0068,2.5552-0.64738,0.59597,0.35563,2.4058-0.9851,2.8534,0.99436z'/%3E %3Cellipse stroke-width='0.3' cx='336.229' cy='286.5' rx='2.13' ry='0.973'/%3E %3Cpath stroke-width='0.35' d='m340.06,286.5,0,0,4.7966-0.32476,2.0435,1.5805-6.9148-0.2598z'/%3E %3Cpath stroke-width='0.3' d='m338.3,283.93c1.2938,0.0412,2.187,1.4674,2.0024,2.9814-0.18354,1.5134-1.3488,2.7373-2.5413,2.5522-1.193-0.19162-1.1076-1.1984-1.0788-1.4988,0.0293-0.30473,0.69578-0.85249,0.76781-1.3418,0.0699-0.48607-0.34148-1.5697-0.18728-2.0726,0.1574-0.50502,0.45565-0.63818,1.0372-0.62028z'/%3E %3Cpath stroke-width='0.3' d='m334.43,246.74c-0.53623,0.85196-1.5548,1.4988-2.0707,1.167-0.51702-0.33289-0.3324-1.5204,0.20168-2.373,0.53302-0.85036,1.3846-1.2742,1.9021-0.9413,0.51648,0.33397,0.49941,1.2947-0.0331,2.1472z'/%3E %3Cpath stroke-width='0.35' d='m329.08,256.35,0,0,2.6784-6.3111-0.40017-0.3464-3.0359,4.4329z'/%3E %3Cpath stroke-width='0.3' d='m331.27,250.05c-1.3264-0.96999-1.6188-1.9638-1.192-2.9435,0.42471-0.97811,1.4187-0.34317,1.4187-0.34317s0.65357,0.72208,1.1354,0.97812c0.4834,0.26197,1.2517-0.0839,1.8188,0.72047,0.56878,0.80595,0.22677,1.6125-0.22782,1.8154-0.45513,0.1992-1.845,0.57541-2.9532-0.22733z'/%3E %3Cpath stroke-width='0.3' d='m320.14,249.22c0.95075,0.5429,1.4555,1.4576,1.1295,2.0564-0.3276,0.58892-1.3664,0.63332-2.3188,0.0893-0.94814-0.53912-1.4539-1.4576-1.1252-2.0531,0.32652-0.59379,1.3627-0.63493,2.3145-0.0926z'/%3E %3Cpath stroke-width='0.35' d='m322.92,251.99,0,0,4.946,2.9661-0.14406,2.3328-5.3675-4.6115z'/%3E %3Cpath stroke-width='0.3' d='m322.88,252.55c-1.0965,1.2254-2.1038,1.4095-3.0129,0.86767-0.91239-0.54238-0.17714-1.4723-0.17714-1.4723s0.78005-0.57428,1.089-1.0306c0.30999-0.45847,0.0592-1.2714,0.91453-1.751,0.85421-0.47795,1.6049-0.0427,1.7522,0.44006,0.14458,0.47958,0.35107,1.9226-0.56558,2.9462z'/%3E %3C/g%3E %3Cg fill='%23aa8c30'%3E %3Cpath d='m468.03,303.97s-0.36069,0.23925-0.55756,0.62681c-0.18888,0.38755-0.40443,1.1654-0.40443,1.1654l0.0224-1.8994,0.64027-0.36972,0.29933,0.47688z'/%3E %3Cpath d='m468.31,302.78s-0.44232,0.75023-1.4923,0.69065c-1.0463-0.0563-1.5601-0.54451-1.6866-1.0798-0.12857-0.53098-0.12857-0.92019,0.20971-1.5421,0.34145-0.61868-0.49569,0.59052-0.49569,0.59052v1.1822l0.76728,0.90882,0.65042,0.20136,0.64347,0.0412,0.8222-0.27227,0.55274-0.41733,0.0288-0.30312z'/%3E %3Cpath d='m473.84,312.44s-0.52981,0.27551-0.93478,0.12829c-2.4789-0.88012-4.5608-2.3334-4.5608-2.3334l4.9818,3.0934,0.5138-0.88823z'/%3E %3Cpath d='m476.94,313.85s-0.0555,0.8704-1.0207,1.3045c-0.96252,0.43356-1.638,0.23438-1.9896-0.18296-0.35108-0.41733-0.52661-0.7621-0.50368-1.4712,0.031-0.70909-0.17554,0.75236-0.17554,0.75236l0.52981,1.055,1.089,0.45357,0.67602-0.11906,0.58689-0.25927,0.61146-0.62301,0.30734-0.62788-0.11098-0.282z'/%3E %3Cpath d='m508.79,251.4s-0.12646,0.19595-0.12646,0.5191c0,0.3253-0.0198,0.90881-0.0198,0.90881l-1.0852-1.2081,0.54901-0.71395,0.68242,0.4942z'/%3E %3Cpath d='m508.21,249.83c0.0635,0.86387-1.1909,2.0937-2.1289,1.7045-0.93639-0.38593-1.6172-1.3602-1.105-2.3334,0.51007-0.97267-0.25665,0.36806-0.25665,0.36806l0.12966,1.4263,0.89102,0.81952,1.1098,0.066,0.87446-0.49473,0.53142-0.97433-0.0459-0.58186z'/%3E %3Cpath d='m521.38,252.18s-0.21288-0.59218-0.10404,0.0747c0.10404,0.67228-0.75552,2.1088-1.7602,1.9768-0.99772-0.12882-1.456-1.003-1.3717-1.8154,0.0848-0.80921-0.16859,0.28039-0.16859,0.28039l0.15794,1.0836,0.53617,0.50771,0.76567,0.45306,0.89423-0.15318,0.80938-0.51908,0.36122-0.76162v-0.54291l-0.12007-0.58406z'/%3E %3Cpath d='m516.87,253.18s0.0341,0.4536-0.56236,0.77946c-0.59651,0.32368-1.7244,0.99435-1.7244,0.99435l3.7055-1.0798-0.30678-0.8985-1.1119,0.2046z'/%3E %3Cpath d='m494.43,282.57s-0.20007,0.21758-0.21127,0.67933c-0.0128,0.46821,0.0944,1.0192,0.0944,1.0192l-2.0772-3.2839,0.61734-0.38973,1.5766,1.9751z'/%3E %3Cpath d='m493.29,279.48c-0.37028,0.86548-1.8818,1.416-2.6069,0.9943-0.72453-0.42057-1.3408-1.9887-0.45512-2.6794l-0.46153,0.40216-0.23422,0.8953,0.33188,0.93804,0.72453,0.81947,0.66801,0.20623,1.0677-0.21434,0.77684-0.60678c0-0.00036,0.56289-1.6179,0.18886-0.75507z'/%3E %3Cpath d='m500.61,287.01s0.0197,0.38757-0.66105,0.38757c-0.67921,0-2.1065,0.0227-2.1065,0.0227l3.4505,0.6658,0.17072-0.68852-0.85367-0.38756z'/%3E %3Cpath d='m504.85,287.82c0.30893,1.1513-0.71389,2.2609-2.0344,1.8734-1.32-0.39244-1.6743-1.7029-1.2598-2.4087l-0.32652,0.82273,0.24063,1.0945,0.80938,0.70583,0.82754,0.1797,0.84673-0.20947,0.85533-0.82114,0.21234-0.97971-0.17128-0.2571z'/%3E %3Cpath d='m374.92,302.46c0.35587,0.40219-0.19742,1.9015-1.6887,2.5062-1.4918,0.6019-2.2308,0.0281-2.6267-0.47632-0.39803-0.50341-0.37029-1.0355-0.37029-1.0355l-0.21289,0.27226,0.20009,0.77947,0.75338,0.64629,1.3184,0.28688,0.98175-0.18511,0.96572-0.51909,0.49566-0.51963,0.42738-0.63331,0.056-0.77674-0.24117-0.39081h-0.0576l-0.0235,0.0314,0.0224,0.0141z'/%3E %3Cpath d='m373.59,305.73s-0.25504,0.0844-0.48179,0.46226c-0.22569,0.37241-0.31213,1.0338-0.31213,1.0338l-0.11472-1.7543,0.76781-0.40596,0.14086,0.66416z'/%3E %3Cpath d='m368.62,311.01s-0.14032,0.37564,0.25611,0.57535c0.39802,0.2046,1.3349,0.43248,1.3349,0.43248l-2.4421,0.0855-0.25557-0.9483,1.1066-0.14507z'/%3E %3Cpath d='m367.79,312.53s0.0288,0.0877,0.0235,0.24737c-0.008,0.16346-0.0512,0.40054-0.19369,0.70422-0.2849,0.6019-0.39748,1.2964-1.2768,1.121-0.88246-0.17105-1.2506-0.83577-1.336-1.4095-0.0854-0.57539-0.28384-0.80595-0.28384-0.80595v0.77513l0.53891,1.2975,0.8798,0.4038h0.76727l0.59651-0.23113,0.28332-0.77838,0.14405-0.63493-0.14299-0.68904z'/%3E %3Cpath d='m361.63,312.36s0.28544,1.1242,1.5339,1.1524c1.2501,0.0314,1.5628-0.34804,1.5628-0.34804l0.14139,0.43356-0.45404,0.22951-1.0852,0.12394-0.95504-0.18999-0.44392-0.32799-0.33879-0.59,0.0389-0.48337z'/%3E %3Cpath d='m349.24,279.02s0.0422,0.12883-0.0437,0.53913c-0.0854,0.40922-0.84993,1.3836-2.2788,1.4035-1.4262,0.0232-2.0216-0.45521-2.4053-0.92992-0.38416-0.47363-0.44872-1.1443-0.44872-1.1443l-0.0422,0.71342,0.55328,0.88551,1.4059,0.66142,1.3424,0.009,1.3622-0.39893,0.59704-0.66143,0.13926-0.72533-0.18141-0.35183z'/%3E %3Cpath d='m346.98,282.05s-0.5106,0.0444-0.76567,0.27174c-0.25504,0.22948-0.48019,0.50663-0.48019,0.50663l-0.0203-1.6953,1.2661,0.0958v0.82112z'/%3E %3Cpath d='m340.84,286.53s-0.0976,0.0991,0.64134,0.43193c0.73896,0.33289,4.1046,0.69071,4.1046,0.69071l-5.3971-0.1456,0.19848-0.92126,0.45245-0.0557z'/%3E %3Cpath d='m340.23,286.63s-0.0139,0.20461-0.2828,0.75022c-0.26944,0.54778-0.94915,2.0032-2.0867,1.8019-1.137-0.20243-0.99398-0.99597-0.99398-1.1226,0-0.13154-0.0155-0.40542-0.0155-0.40542l-0.19847,0.82274,0.26943,0.57534,0.46793,0.29013,0.92409,0.1153,0.6237-0.27553,0.68189-0.6495,0.35534-0.69071,0.28386-0.73505-0.0288-0.47686z'/%3E %3Cpath d='m337.32,286.77s-0.031,0.25764-0.92462,0.29013c-0.89477,0.0232-2.1721-0.36266-2.1721-0.36266l0.42577,0.53099,0.73842,0.18946,0.92249,0.013,0.72405-0.0709,0.28598-0.58999z'/%3E %3Cpath d='m334.57,248.86s0.19849,0.57701-0.31265,0.95156c-0.51061,0.3724-1.6204,0.60297-2.329,0.19919-0.70962-0.40379-1.9896-1.6985-1.9896-1.6985l0.59811,1.0674,0.93585,0.77839,1.3061,0.3724,1.2491-0.19812,0.56984-0.49419,0.17075-0.40054-0.19849-0.57755z'/%3E %3Cpath d='m330.76,250.59s0.0278,0.14831,0,0.72207c-0.0283,0.57701-0.2561,1.5286-0.2561,1.5286l1.136-2.5392-0.45351-0.40379-0.42632,0.6923z'/%3E %3Cpath d='m323.72,252.58s-0.16967-0.17484,0.16967,0.57539c0.3404,0.75077,3.1234,3.4296,3.1234,3.4296l-4.429-3.7424,0.50955-0.72586,0.62637,0.46334z'/%3E %3Cpath d='m322.24,253.01s-0.56878,0.35075-1.0794,0.37565c-0.51166,0.0298-1.3627-0.0281-1.4763-0.63492-0.11363-0.60137,0.16968-0.86062,0.16968-0.86062l-0.36868,0.83412,0.14245,0.45845,0.65415,0.3762,0.90866,0.0871,0.82219-0.4038,0.22731-0.2322z'/%3E %3Cpath d='m320.45,251.11s0.0555,0.17321-0.76781,0.0579c-0.8238-0.11583-1.8162-1.0652-1.8162-1.0652l0.65196,1.0355,1.392,0.57648,0.53998-0.60464z'/%3E %3C/g%3E %3Cg fill='%239ca168'%3E %3Cpath d='m524.81,238.85c-0.40337,5.0323-5.3672,7.6028-7.9645,9.4841-2.6021,1.8831-3.8581,4.216-3.8581,4.216l-0.87291,2.9348-0.42737,1.8766-0.0843,0.65278c0.17183,0.52287,0.39271,1.4295,0.4258,2.7898,0.0667,2.2886-0.1462,5.5499-0.1462,5.5499l3.4942-2.5062,2.5322-0.95155,0.76561-0.12234s-2.8118,2.7952-3.9184,5.8203c-1.105,3.0258-3.1528,9.4499-6.9856,11.522-3.8309,2.0758-6.221,1.2135-7.4975,2.3378-1.2757,1.121-1.3216,1.423-1.3216,1.423l-1.6321,2.2339-1.2917,1.6704-1.208,0.83632-0.76402,0.61814c-0.0261,0.62301-0.1003,1.4301-0.30894,2.1738-0.41883,1.4772-0.91821,3.121-0.91821,3.121s0.76567-0.46604,1.6951-0.58186c0.92302-0.12016,1.7863-0.10881,1.7863-0.10881s-0.72297,0.88552-0.978,1.7495c-0.25557,0.86601,0.1702,6.0516-4.7699,9.1613-4.9428,3.1113-17.524,2.6214-17.524,2.6214l-2.3828,0.9483-2.243,1.6753-2.0478,2.2452-0.15259,0.60517s-1.5473,1.8863-2.6587,2.6236c-1.105,0.73346-3.6602,2.4157-3.6602,2.4157s2.1694-0.0823,2.8966,0.17266c0.72191,0.26361,4.5992,1.9919,4.5992,1.9919s-2.8406-0.0574-4.7699,0.68905c-1.9341,0.74863-10.735,5.7332-14.995,5.5894-4.2572-0.14183-10.338-6.3674-10.338-6.3674l-2.7547-1.9291-4.5715-0.8915-5.653-0.31828,0.0811-0.74049,0.10724-0.91368s1.9176-0.21761,5.0026,0.14668c2.6389,0.31449,3.5172,1.1903,5.7305,1.449,2.2169,0.25928,3.8538-0.0639,4.6648-0.42869,0.80937-0.37403,7.645-6.1612,7.645-6.1612l7.6877-2.6972,2.9383,0.4287,1.3008,0.34642,1.1957,0.34642s-0.40283,0.62787-1.2576,1.4263c-0.85153,0.79676-1.9181,1.3407-1.9181,1.3407l0.93958,0.75184,4.8532-0.77513,1.5852,0.4092s0.12324,0.033,0.45619,0.24359c0.0752-0.34966,0.26996-1.076,0.70694-1.6471,0.59651-0.77673,3.3235-3.0025,4.4909-3.7803,1.1765-0.77674,1.4305-0.88552,1.8152-1.2964,0.38201-0.41082,1.9587-4.4753,1.9587-4.4753l0.21394-2.0704,5.3672-5.166,3.6196-3.8464,1.5777-4.386-0.1718-0.88391s1.3002,1.3386,1.0661,4.0607c-0.23425,2.7221-0.83236,3.6737-0.83236,3.6737s3.6618-2.5294,5.6236-3.3949c1.5729-0.69231,2.7334-0.64577,3.1367-0.60297,0.517-0.29338,1.9272-1.1654,2.7824-2.419,1.0661-1.5529,1.3445-2.0103,1.3445-2.6366,0-0.62627,0.17019-3.6504,0.17019-3.6504l-0.34145-9.2709,3.1533-6.9781,4.5763-4.1056,0.87504-0.51963s-0.36442,0.97159-0.4279,1.6439c-0.0635,0.66741-0.0635,1.855-0.0635,1.855s2.3199-3.1735,3.514-3.757c0.27318-0.1337,0.51383-0.24737,0.73308-0.34858,0.24863-0.44169,0.68243-1.3288,0.9444-2.5635,0.36867-1.7559,0.42789-4.117,0.42789-4.117l0.0699-3.8382-0.7459-2.9846-2.1305-5.7268-0.0843-7.5386-1.5964-2.1532s1.5116-0.11691,3.3843,2.5852c1.8738,2.7026,2.4298,6.5031,2.4298,6.5031l4.3506-13.352s1.1674,1.5762,1.9928,4.2128c0.83502,2.6366,1.0884,4.4288,1.0884,4.4288l1.7132-3.7067c-0.0144,0.0395-0.0523,0.25711,0.20487,1.3088,0.29558,1.2303,2.9575,2.7671,2.5547,7.801zm-88.327,85.346s-0.81364-2.0444-5.0026-4.1186c-4.19-2.0725-7.3099-2.4764-7.3099-2.4764l-0.0459,1.54,6.5758,2.8677,3.2786,2.6794,2.5039-0.49203z'/%3E %3Cpath fill='%23717732' d='m466.42,311.65c0.40443-0.53913,3.9446-3.6932,5.7519-4.6231,1.812-0.93045,4.2156-1.1015,4.2156-1.1015,2.4933-0.45682,2.8983-0.0871,8.6484-3.2628,5.7519-3.1741,7.031-6.828,8.1376-7.7133,1.1066-0.88717,3.1282-1.1015,3.1282-1.1015s-2.4069,2.8298-4.5133,5.1411c-2.1075,2.3151-4.3687,3.7809-7.6065,5.9645-3.2354,2.1825-9.9628,2.2912-9.9628,2.2912-2.8358,0.6495-3.793,1.3375-5.3698,2.7188-1.575,1.3851-2.6459,2.8904-2.6459,2.8904s-0.18621-0.66308,0.21661-1.2038zm15.868-16.658c-5.3211,4.8623-7.07,9.3788-7.07,9.3788s4.7294-4.0612,7.1576-6.3941c2.4287-2.3345,5.8331-3.4594,7.3692-4.8851,1.5345-1.4268,1.6188-2.635,2.5974-3.5454,0.97853-0.90502,1.7063-1.3392,1.7063-1.3392s-2.3455-1.8133-11.761,6.7847zm-11.228,11.253s2.2756-0.99923,3.1367-3.042c0.64026-1.5134,0.2993-1.8994,1.2789-3.6309,0,0,5.5376-5.3469,7.4943-7.6487,3.4947-4.1056,1.9181-7.474,1.9181-7.474s0.38201,1.7278-1.0645,3.5416c-1.4486,1.8138-8.5918,6.6987-9.4579,9.5086-0.8681,2.8093-0.38201,2.9116-0.76727,4.4055-0.88408,3.4431-2.5386,4.34-2.5386,4.34zm-3.6799,13.813s-2.7857-1.8696-5.9058-1.6704c-6.3615,0.40435-11.743,4.32-15.944,4.4353-4.2065,0.11582-5.8577-1.9935-9.1047-4.2063-3.4617-2.3611-12.039-2.0184-12.039-2.0184l-0.0539,0.2046-0.0598,0.25063s5.8967,0.059,8.4112,0.75669c4.803,1.325,7.3917,6.3263,12.846,6.0067,7.0764-0.41731,12.879-4.727,15.772-4.7124,4.9695,0.032,6.0778,0.95375,6.0778,0.95375zm-31.556-3.2217s4.9343,0.88878,8.767-1.9226c3.8341-2.8092,8.3898-6.61,10.905-6.7831,2.513-0.1727,5.1552,0.47523,5.1552,0.47523s-3.1981-1.4263-5.7503-1.3852c-2.5594,0.0444-5.1552,0.3908-7.5429,1.8166-2.3844,1.4279-3.5348,4.0169-6.1323,5.66-2.6005,1.6461-5.4024,2.1391-5.4024,2.1391zm-0.8814,6.6351c-0.65946,0-1.4273,0.42869-1.6839,0.38754-0.25344-0.0411-1.765-1.5995-3.8746-2.7205-2.1097-1.1226-5.2528-1.8019-5.2528-1.8019s-0.39163,0.0974,0.31213,0.33289c0.7016,0.2387,3.2995,1.121,4.9599,1.8994,1.6631,0.7816,3.3422,2.5494,3.4947,2.8309,0.1494,0.28525,0.74483,1.0798,1.9811,1.0355,1.2352-0.0412,1.726-0.75023,1.5942-1.2298-0.12325-0.47361-0.87077-0.73393-1.5308-0.73393zm3.4718-4.7952s1.9533,1.1151,5.1941,1.0354c6.9039-0.17267,11.247-4.897,15.769-6.625,4.5101-1.731,6.8264-0.23274,6.8264-0.23274s0.11897-0.24413-0.0262-0.34966c-0.63706-0.47688-2.7339-1.6141-5.0447-1.5795-7.584,0.11529-14.68,4.897-17.774,6.1922-2.9906,1.2509-4.9439,1.5589-4.9439,1.5589zm73.393-52.271c-2.3252,2.4022-5.7957,10.071-7.3276,12.165-1.5313,2.0974-3.4526,2.7221-4.2806,3.5665-0.72833,0.74045-3.514,4.4932-4.1542,5.403-0.63706,0.90555-0.83075,0.64629-1.2779,1.0355-0.44551,0.38755-0.68082,0.41083,0.0635,0.21434,0.74536-0.19107,0.98008-0.64577,2.1305-1.9421,1.1487-1.2974,1.0858-1.8815,2.9158-3.5221,1.8317-1.6455,5.1488-3.5151,6.797-5.5333,1.6444-2.0168,5.0058-9.8223,6.7628-11.723,1.9032-2.0612,5.2266-3.2861,5.2266-3.2861s-2.6203-0.76374-6.8558,3.6223zm-11.799,14.544s-0.0864-1.3835,1.6183-3.4166c1.7031-2.033,2.3012-1.7694,3.6618-4.7535,1.3621-2.9808,1.9634-5.8748,3.0685-9.0294,1.105-3.1573,3.0231-6.2702,3.0231-6.2702s-1.7879,0.17267-3.6212,2.6398c-1.8333,2.4634-4.7294,6.9578-6.221,11.365-1.4918,4.4076-1.5291,9.4643-1.5291,9.4643zm-2.1732,2.8904s0.63866-0.34099,0.72191-4.1874c0.088-3.8469-0.21128-9.2468,0.89743-11.927,1.105-2.6777,6.9856-9.1186,6.9856-9.1186s-2.4303,0.60517-5.8363,3.3273c-3.4051,2.7205-4.8548,6.1387-4.6856,8.7269,0.17234,2.5971,1.622,5.5334,1.749,8.0847,0.12271,2.5473,0.16807,5.0945,0.16807,5.0945zm13.841-26.47s1.4513-5.2153,2.0446-6.4844c0.60132-1.2698,0.6275-2.0168,3.5785-5.3278,1.6924-1.8994,3.3544-3.1162,4.0598-5.7626,0.71176-2.6545,0.68616-10.055,0.68616-10.055s-0.76727,0.68744-1.3915,1.9865c-0.62745,1.2991-0.17181,6.1056-1.28,8.3235-1.1087,2.2214-3.6052,7.4376-4.8569,8.5592,0,0-0.25344-3.7446,0.20008-7.5204,0.45512-3.7727,1.7341-4.9235,2.3002-7.4029,0.56823-2.4747,0.22729-8.8728,0.22729-8.8728s-2.0152,2.0775-3.0119,4.465c-0.98922,2.3908-1.5879,6.6827-1.6167,9.9099-0.0299,3.2282,0.73948,5.8502,0.85314,7.693,0.10883,1.8436,0.25236,2.7075-0.48554,4.7243-0.73789,2.0168-0.36709,0.63492-0.82274,2.5938-0.45512,1.9584-0.93424,3.4296-0.93424,3.4296l0.44977-0.25873zm-4.5971-28.292s1.7591,2.2176,1.4726,4.7535c-0.28384,2.5343-1.248,5.878-0.25343,8.5271,0.99457,2.6485,2.472,2.9105,2.87,4.4353,0.39854,1.5264,0.42309,4.5062,0.42309,4.5062s0.8238-5.6605,0.25612-7.2154c-0.56557-1.5529-0.8222-0.83631-1.6444-2.4764-0.82595-1.6406,0.0262-6.1339-0.59812-8.7553-0.62369-2.6225-2.5258-3.7754-2.5258-3.7754z'/%3E %3Cpath d='m402.55,323.75s0.53302-1.4891,4.1105-3.2379c3.578-1.751,8.9647-4.1078,9.4771-3.8058,0.51166,0.30473-0.278,2.2506-0.278,2.2506l-3.4697,1.0571-2.7686,1.6222-3.2365,2.0953-3.8346,0.0184z'/%3E %3Cpath d='m411.67,314.34c-4.572,0.1732-7.0652,1.2975-7.9447,1.4712-0.30307,0.059-0.96144,0.52614-1.5238,0.24899-1.0719-0.53262-2.0045-2.0049-2.0045-2.0049l-0.96626-0.80649-0.22676,3.2818-6.6736-5.7871-0.71123,3.8285-0.85153,1.7608-6.6169-6.2541,0.31265,4.839s-1.7308,0.22788-1.8172,0.17319c-0.0843-0.0579-4.7139-3.2845-4.7139-3.2845l-1.391,0.46171,1.534,2.8515-5.9656,0.46279s-0.48126,0.26198-1.2912,1.0057c-0.80938,0.74698-1.257,1.448-1.257,1.448s-0.17928,0.30366,0.0315,0.4433c0.21394,0.14018,1.844,0.1088,2.3551-0.0877,0.51061-0.19431,0.8409-0.90662,0.98976-0.61489,0.1478,0.29337,0.33988,1.6011,1.129,1.4706,0.78965-0.12993,3.5604-2.2306,5.5371-1.3072,2.2036,1.0257-2.8534,2.5175-2.3316,4.084,0.51862,1.5584,4.1628,0.8969,5.0896,0.39732,0.9257-0.49475,3.6927-3.946,4.8238-2.635,1.5761,1.8268-3.3107,3.2417-2.4063,5.0653,0.87344,1.7608,3.6004,1.3645,4.9188,0.60677,1.3227-0.75562,4.3917-5.4794,5.0714-4.4618,1.1807,1.7694-2.5893,3.4577-1.6423,4.8277,0.94921,1.3716,3.0359-0.0498,4.421-1.0257,1.3846-0.97266,1.9384-3.2861,3.8538-4.3643,1.9171-1.0798,1.7879-0.62952,2.314-0.64789,0.52927-0.0244,2.0099-1.4902,2.0099-1.4902l4.5053-1.9129,2.2057,0.16022,1.1386,0.54073,2.2585,0.31503,0.26519-1.9048s-2.6128-1.2222-4.429-1.1545zm-36.054,0.0363,0.95396-1.6931-0.5405-0.82166s-1.5895-0.89043-3.0375-2.3573c-1.4486-1.4728-1.9779-1.809-2.641-2.1402-0.66425-0.33454-2.8961-1.7873-2.8961-1.7873l-1.0063-3.7132-0.59491-1.0734-1.7212,0.67441-2.2665-7.9869-0.44285-1.4322-0.93585-0.0547-1.8583,4.8423-2.0782-3.0241-0.52822-6.6191-1.2954,1.4528-1.6684,1.6947-2.9644-6.0003s-0.24064-0.15318-0.3927,0.34642c-0.14939,0.48608-0.40549,2.3805-0.22035,3.5042-0.79234-0.49472-2.1545-1.4284-3.9787-3.0009-3.0109-2.5922-3.7348-3.9259-3.7348-3.9259l-1.4048-3.1724,1.3195-2.7898,0.65998-3.3267-2.8961,1.1849-0.51062-7.5199-0.44871-2.3746-3.4926,4.9928s-1.3611-1.9243-1.3611-2.1402c0-0.21435,0.0624-4.7519,0.0624-4.7519l-0.93692-0.28309-1.4288,2.6794s-1.3723-2.7648-1.9784-3.3538c0.0966-1.062,0.25556-3.7743-0.38897-5.8694-0.81739-2.6647-1.7714-4.0845-1.431-6.2606,0.34306-2.1765,1.2261-2.3843,1.1253-3.3538-0.10297-0.9662-1.535,0.62627-1.057-0.65443,0.47805-1.278,5.0442-4.182,4.0902-5.7032-0.95557-1.5221-5.3506,2.386-4.3282-0.2387,1.0207-2.6279,5.247-2.6647,5.4858-6.3279,0.1478-2.282-3.9877,1.4182-4.3623,0.27553-0.37403-1.1388,2.5546-3.4886,2.5226-4.976-0.0347-1.4853,0.54473-1.6569-0.27372-2.4531-0.81685-0.79457-3.339,3.1096-3.339,3.1096l-2.76-1.0387-0.95557,3.9443-0.84993,3.35-3.4083-2.0016,0.91935,4.0791,0.81899,3.9752-3.5454-0.90015,1.8754,3.3868,2.4421,2.4812,1.5089,2.046,1.0933,0.58731,1.4635,1.4555,0.51114,2.1765s0.85366,2.387,0.85366,2.4915c0,0.10176,0.13553,2.3481,0.13553,2.3481l0.0341,1.5545-0.0768,1.2065-0.0528,0.45359-0.0742,0.51963-0.0304,1.423c-0.6664,0.0639-1.7484-1.0208-2.1444-0.34479-0.42418,0.73671,2.0467,2.636,1.5772,3.1113-0.46793,0.47795-4.0892-0.73346-4.3015,0.43194-0.21448,1.167,0.34041,2.8082,2.4282,3.3273,2.0862,0.51908,6.9423,1.6417,6.1339,2.5916-0.81044,0.95321-6.0917-2.8937-5.8774-0.0839,0.21182,2.8065,2.044,3.9736,3.4073,4.4932,1.3632,0.51962,6.6864-0.0839,6.3882,1.167-0.29719,1.2547-4.3442-0.38918-4.7278,1.4252-0.38256,1.8182,2.8118,2.0742,3.4953,2.0742,0.68029,0,2.8945-0.0844,3.7461,0.56348,0.85313,0.64791,3.8325,3.802,5.7091,5.4014,1.591,1.3553,5.0261,3.7359,6.0297,4.4271l-0.0486-0.006c-1.0095-0.0942-3.101-0.31502-3.4334,0.43844-0.42418,0.97159,8.0104,3.979,5.59,4.9122-2.4202,0.92992-5.0271-2.576-5.7257-0.4341-0.7,2.1434,1.6017,3.9541,2.9158,4.7341,1.3109,0.77839,8.7905,0.15805,7.3249,1.8479-1.4652,1.6969-6.8841-1.1405-6.9348,0.86767-0.0512,2.0066,3.6127,5.1855,5.4868,5.0967,1.8749-0.0839,3.935-3.0934,4.7876-1.4674,0.8526,1.6238-1.4491,2.282,0.35747,2.714,1.8056,0.43033,3.0834-1.8501,5.1792-1.436,2.0942,0.41569,5.3848,1.7429,7.2255,3.4193,1.8392,1.6769,3.73,3.6142,3.73,3.6142z'/%3E %3Cpath fill='%23717732' d='m404.74,322.82c1.2784,0.0227,1.4491,0.71341,1.6199,0.69231,0.17073-0.0233,2.322-1.8588,4.3655-2.9814,2.0451-1.1258,5.1536-1.7938,5.1536-1.7938l0.19369,0.28092s-3.7034,0.92505-5.4944,2.1808c-2.2169,1.5567-3.9616,2.531-4.0694,2.8098-0.1067,0.27879-0.91399,0.82114-2.1716,0.84443-1.256,0.0179-1.7895-0.73237-1.7895-1.1047,0-0.36482,0.91555-0.94835,2.1924-0.92832zm11.161-5.6536s-1.1066,0.11529-1.7319-0.43412c-0.62583-0.54724-2.0163-1.0354-3.3528-1.0354-1.3328,0-3.4713,0.73559-5.1653,2.3594-0.13713,0.13209-0.47647,0.7567-1.9341,1.731,0.50633,0.0974,1.488-0.57375,2.5568-1.4392,1.5334-1.2482,3.4643-1.5865,4.827-1.7841,1.3622-0.20621,2.2158,0.57429,2.8417,1.0041,0.62425,0.43519,1.901,0.31503,1.901,0.31503l0.0576-0.71668zm-66.249-27.074c0.13819-0.0579,0.11684-0.3594,0.0256-0.88229-0.20542-0.0779-1.0303-0.42546-2.8833-1.5302-2.1721-1.2974-6.6869-4.8867-6.6869-4.8867s1.8765,1.8182,3.7493,3.5037c1.8733,1.6834,5.2406,3.7576,5.2406,3.7576l0.0165,0.013c0.28759,0.0281,0.49354,0.0444,0.53837,0.0249zm46.769,33.13s0.68189-0.89364,1.8957-2.8461c1.2138-1.9524,2.3209-2.577,2.4911-2.8146,0.17074-0.23707-0.46845-1.1886-0.83128-1.9242-0.36069-0.73506-0.29719-1.5118-0.29719-1.5746,0-0.0655,0.44605,1.1427,1.3408,1.8144,0.89475,0.66576,1.4342,1.2292,1.4342,1.2292s1.781-0.23709,1.8253-0.58347c0.0422-0.34642-0.0443-0.58353-0.342-0.71182-0.29665-0.13044-0.63813,0.26685-1.4475-0.0893-1.6823-0.73073-2.3647-3.2823-3.3662-3.3684-1.0004-0.0861-0.28545,2.7021-0.72404,2.7432-1.5548,0.14995-2.7686-5.66-6.4962-5.8977-2.6235-0.16996-3.0882,0.32476-3.2162,0.90662-0.12591,0.58347,3.1741,4.0645,2.0665,4.5576-1.1071,0.50123-4.6221-5.4644-7.1774-5.5317-2.5552-0.0644-2.7686,0.90988-2.5781,1.4706,0.19155,0.56242,2.8331,1.0588,2.2153,2.9186-0.59865,1.8041-3.173-2.7849-5.536-2.5294-2.3647,0.25927-2.6203,0.43195-2.728,1.1015-0.10405,0.67067,0.83128,1.6423,0.4914,1.8799-0.34041,0.236-1.8328,0.17106-3.0247,0.9927-1.192,0.82381-2.855,3.0702-2.855,3.0702s1.5553-2.203,3.6201-2.4422c2.0665-0.23599,7.2854,0.0233,7.2854,0.0233s-0.70268-0.43411-1.4689-1.1248c-0.76669-0.69232-1.4278-2.0953-1.4278-2.0953s1.1514,1.0814,2.2586,1.9865c1.1066,0.91041,2.4911,1.6011,2.4911,1.6011s2.2153,0.21599,2.3647,0.47688c0.14941,0.25872-0.0651,0.77513-0.97908,1.7678-0.91666,0.99435-2.2372,2.1646-2.2372,2.1646s2.2142-1.6866,2.6411-2.0542c0.42577-0.36647,1.9592-1.5335,1.9592-1.5335s1.6199,0.21437,1.7895,0.17268c0.16912-0.0427,0.0918-0.60517-0.99452-2.2041-1.0847-1.5979-2.1145-3.3289-2.1145-3.3289s1.3339,1.2271,2.6822,3.0057c1.3488,1.7776,1.1508,2.5987,1.7041,2.6864,0.55381,0.0855,1.4475,0.20785,1.8519,0.18783,0.54366-0.0281,0.4055,0.77513-0.53302,2.203-0.93585,1.4263-1.4886,3.2607-1.4886,3.2607s0.9561-1.5351,1.9784-2.5916c1.0228-1.0587,1.5569-2.3145,1.9608-2.3778,0.40549-0.0644,1.7746,0.10717,1.9672,0.0249,0.18994-0.0893-0.32761-0.65117-1.0506-2.1224-0.72458-1.4674-0.95877-3.5005-0.95877-3.5005s0.7032,1.9048,1.8109,3.2861c1.1071,1.3819,1.534,2.4942,1.7741,2.5094,0.24116,0.0114,1.097-0.099,1.7186-0.0904,0.31266,0.006,0.34787-0.0693,0.38362,0.12828,0.10564,0.61002-0.15046,0.97486-0.89476,2.3794-0.74484,1.403-1.2341,2.7882-1.2341,2.7882zm-28.284-16.403c1.598,0.54453,2.2153,0.54453,2.2153,0.54453s-2.1939-1.2991-2.7697-3.1362c-0.57625-1.8339-0.0635-5.7049-1.0004-5.66-0.93746,0.0444-1.4705,2.8525-2.4069,2.2912-0.93799-0.56023,0.31853-5.7278-0.70374-7.9287-1.0207-2.2063-3.4275-3.7414-3.983-2.9419-0.55327,0.80436-0.42417,5.5537-1.9155,4.518-1.4913-1.0354,0.12753-5.1-0.32119-6.9578-0.44659-1.8604-1.574-3.199-2.4266-2.7454-0.8526,0.45683,0.33879,3.934-1.002,3.9752-1.3419,0.0449-1.1498-2.4417-1.7244-2.6788-0.57519-0.23708-0.76781,0.50121-1.0868,0.0265-0.32015-0.4785-0.1478-2.2506-0.85154-2.078-0.70268,0.17322-0.57466,1.5351-0.38362,2.2891,0.19101,0.75669,0.61681,1.8382,0.91506,2.3362,0.29773,0.49635,1.3638,1.121,1.28,1.5351-0.0859,0.41084-0.64135,0.75668-1.3638,0.77672-0.72565,0.0217-2.3658-0.046-2.3658-0.046s1.7463,0.54399,2.4069,0.60837c0.65998,0.0639,1.94-0.28093,2.2575,0.30203,0.31907,0.58513,1.8535,2.6577,1.8535,2.6577s0.36068-1.0798,0.55276-2.9846c0.19153-1.8977,0.10616-3.5649,0.10616-3.5649s0.51061,2.2062,0.44765,3.5254c-0.0624,1.3142-0.55434,3.8864-0.55434,3.8864s1.448,1.2103,1.0239,1.5351c-0.42577,0.32532-1.9389,0.28364-3.7066,0.26036-1.7666-0.0233-4.2802-0.62786-4.2802-0.62786s2.2575,1.0815,3.8325,1.3386c1.5761,0.26197,5.0052,0.34641,5.0052,0.34641l2.3423,2.6545s1.1221-1.9259,1.2784-3.8398c0.1574-1.9178-0.0422-4.1419-0.0422-4.1419s0.48927,2,0.57625,3.7083c0.0843,1.7099-0.55595,4.7324-0.76727,4.9912-0.21342,0.26037-1.4102,1.0041-2.4639,1.2682-1.5473,0.38917-4.6504,0.78326-4.6504,0.78326s2.863,0.38211,4.9198-0.10881c2.06-0.48607,2.3012-1.0588,2.8753-0.71235,0.57626,0.34859,1.0874,0.97486,1.0874,0.97486s1.233,0.95641,1.7895,1.2081c0.0864,0.1927-0.95182,0.62141-1.4784,0.95322-0.52395,0.32966-1.9096,0.97106-1.9096,0.97106s2.0243-0.73505,2.9196-0.97106c0.44712-0.12232,1.5329-0.52071,1.5329-0.52071l0.5965,0.32477s0.0422-0.43194-0.12753-1.6406c-0.16966-1.2097-0.42683-2.3794-0.42683-2.3794s0.70267,1.1031,0.91667,2.1402c0.21181,1.0371,0.21181,2.0942,0.21181,2.0942s0.1718,0.29933,1.7693,0.8401zm-40.808-46.754s0.45511-2.1916,0.45511-4.7243c0-2.5392-1.7623-6.4572-2.0462-6.859-0.28331-0.40543-0.45351-0.75023-0.45351-0.75023l1.1909-1.8404-1.5324,1.206s-0.85099-0.17321-1.5895-0.63166c-0.73842-0.45847-1.1082-1.1508-1.1082-1.1508s0.78324,0.57862,1.534,0.89151c0.74911,0.31016,0.93585,0.20135,0.93585,0.20135l-0.59063-2.5575s-0.78218-0.31178-2.5216-1.2796c-1.7383-0.9678-3.3059-2.4883-3.3059-2.4883s2.3519,1.4182,3.6804,1.9692c1.3307,0.55536,2.0798,0.58998,2.0798,0.58998s1.3979-0.41732,2.1129-0.83412c0.71496-0.41244,2.1812-1.5204,2.1812-1.5204s-1.3968,0.79677-2.3177,1.0041c-0.91934,0.20948-2.0787,0.34317-2.0787,0.34317l-0.40976-3.108-1.4635-1.5204c-1.1578-1.5221-2.0472-3.6986-2.0472-3.6986s1.1936,1.5183,2.1497,2.2442c0.95503,0.73073,1.8397,1.9026,1.8397,1.9026s1.0906-0.58839,2.146-1.3121c1.0548-0.72534,3.6788-2.6284,3.6788-2.6284s-1.4977,0.79297-3.5764,1.7624c-2.0798,0.9678-2.1481,0.86607-2.1481,0.86607s-0.16967-1.3473,0.13766-1.9378c0.30732-0.58513,0.95503-1.5529,0.8526-2.1402-0.10244-0.59053-0.54527-0.38269-0.71604-0.86548-0.17126-0.48662,0.54474-3.4544,0.54474-3.4544s0.17127,1.0701,0.20488,1.6206c0.0341,0.55103-0.2721,1.3142,0.47806,1.3142,0.74911,0,4.2599-3.5253,4.7011-4.183,0.44231-0.65602,1.0922-2.4536-0.75125-1.7262-1.8381,0.72368-1.3995,2.295-2.9287,2.1749-0.44392-0.0346-0.95343-2.0033-1.5329-1.5204-0.57995,0.48662-1.8749,1.6947-2.1144,3.0766-0.23689,1.3835,0.3084,3.4923-0.47592,4.1137-0.78539,0.62355-1.4662-2.3838-2.9996-1.9703-1.5334,0.41408-1.8738,2.5229-1.6342,3.3522,0.23904,0.82926,3.5769,4.701,2.5216,5.1871-1.0575,0.48336-3.6479-3.2861-5.0442-0.72693-1.3984,2.5559,4.3954,5.1854,5.1093,5.8074,0.71602,0.62461,0.0699,0.79837,1.0911,2.0758,1.0239,1.2758,2.3871,1.5897,3.1021,2.4553,0.7139,0.86388,2.8278,4.9738,2.8278,7.6353,0.00036,2.6637-0.1686,3.6352-0.1686,3.6352zm15.388,22.438s-1.4182-1.6558-0.94813-4.3746c0.46792-2.7221,2.3439-7.5215,1.7041-8.1258-0.63866-0.60298-2.6394,2.9386-3.1522,2.1191-0.51167-0.82167,1.1498-5.6194,0.29932-7.6081-0.8542-1.9865-0.93745-3.2395-2.6416-3.0664-1.7052,0.17268-2.4276,5.7904-3.236,4.7979-0.81205-0.9927,0.46632-3.4988-0.087-4.8391-0.55329-1.3402-0.8526-1.8171-1.7041-1.6027-0.851,0.21705-1.2352,2.8092-1.8312,2.7681-0.5965-0.0444-1.5766-3.1162-2.8118-2.6777-1.2352,0.43031,2.9378,5.8753,2.9378,5.8753s0.74589-0.6479,1.1301-1.5778c0.38362-0.92993,0.76567-1.9459,0.76567-1.9459s0.342,1.7727,0.0432,2.4655c-0.29666,0.68852-0.53249,2.3118-0.53249,2.3118s-1.0223,0.32315-2.7046,0.0622c-1.6823-0.25549-3.0668-0.94776-3.0668-0.94776s1.129,0.7567,2.8524,1.2081c1.726,0.45522,3.5577,1.0176,3.5577,1.0176s0.44871,0.56023,1.2138,1.5746c0.76728,1.0171,1.4278,1.8799,1.4278,1.8799s0.49087-1.0354,0.98015-2.7438c0.4898-1.7061,1.6604-4.5143,1.6604-4.5143s-0.36176,3.3917-0.76675,5.055c-0.40389,1.6655-0.83021,4.0201-0.83021,4.0201s-1.4918-0.14993-3.4926-0.51908c-2.0013-0.3697-4.7289-1.0572-4.7289-1.0572s2.386,0.95156,4.7086,1.5762c2.3199,0.62301,3.7685,1.016,3.7685,1.016l1.8242,2.4103s0.49834-0.8774,1.2224-1.8896c0.72298-1.0209,1.2784-2.4022,1.2784-2.4022s-0.3196,1.8821-0.87344,3.0046c-0.55434,1.1243-0.93799,1.7938-0.93799,1.7938s-1.1717,0.28202-2.2575,0.25712c-1.0869-0.0195-3.3011-0.0427-3.3011-0.0427s1.853,0.62461,3.3224,0.86768c1.4699,0.236,2.5354,0.38593,2.5354,0.38593s0.10565,0.66901,0.89369,1.7954c0.78699,1.1215,1.7783,1.6726,1.7783,1.6726z'/%3E %3C/g%3E %3Cg id='ribbon'%3E %3Cpath fill='%23fff' d='m412.7,331.62s-0.83128-0.89364-1.9378-1.4772c-1.1076-0.58186-1.4795-0.40921-1.4795-0.40921l-0.51274-0.18294,0.97053-2.5294,7.2944-6.968,1.129-7.0038,0.26891-0.007,4.2263-0.0444-0.0454,9.5594,1.3408,0.60676,8.1413,4.8824-0.0261,2.1256s-0.40336,0.14346-1.1893,0.4536c-0.78966,0.31502-0.97854,0.54563-0.97854,0.54563l-3.0722,0.2885-5.3666-3.8907-2.2164-2.3302-4.0448,5.1822-2.5024,1.1984z'/%3E %3Cpath fill='%23016848' d='m418.44,313.04s-0.12005,0.36971-0.17233,1.4463c-0.0555,1.0766,0.071,6.7238-0.20489,7.4959-0.27477,0.77187-4.2012,2.3925-6.4454,4.3476-2.243,1.9622-2.3279,3.4014-2.3279,3.4014s-0.73949,0.0563-2.1315,0.5754c-1.3904,0.51583-2.0152,1.2948-2.0152,1.2948s0.82381-3.4826,4.4568-6.7083c3.6388-3.2315,5.396-3.5037,5.8005-4.0461,0.4071-0.53748,0-6.7174,0.088-7.217,0.0822-0.49473,0.5186-0.53912,0.81899-0.58347,0.29932-0.0433,2.1326-0.006,2.1326-0.006z'/%3E %3Cpath fill='%23016848' d='m427.71,333.68s0.57197-1.121,0.93958-1.4977c0.36601-0.37404,1.2517-1.009,1.2517-1.009s0.13819-0.14182-1.8498-1.0073c-1.988-0.86388-3.0103-0.57647-4.429-1.5827-1.4187-1.0074-2.8406-2.7373-2.8406-2.7373l-1.9026,1.6985s1.1392,1.6141,2.2164,2.6512c1.0762,1.0349,3.5188,1.3819,4.5992,1.9865,1.0788,0.60675,2.0152,1.4977,2.0152,1.4977z'/%3E %3Cpath fill='%23cd202a' d='m422,313s2.1518-0.12829,2.4511,0.20459c0.29719,0.3329,0.25344,0.70204,0.26624,0.81248,0.009,0.10393,0.11205,5.2207-0.26624,6.9023-0.40016,1.7576-1.3083,3.5118-1.8205,4.0326-0.51221,0.51802-3.7471,3.3441-5.2822,4.8391-1.5329,1.4977-3.093,3.6325-3.093,3.6325s-0.56824-0.63493-1.0516-1.2417c-0.48072-0.60463-0.96785-0.80596-0.85313-1.2081,0.11312-0.40218,1.734-2.8244,4.3185-4.524,2.5819-1.7001,4.7427-3.6293,5.224-6.3941,0.48713-2.767,0.10671-7.0556,0.10671-7.0556z'/%3E %3Cpath fill='%23cd202a' d='m436.38,330.48s-0.51701-0.52072-2.337-0.55105c-1.8269-0.0314-1.9763,0.24411-1.9763,0.24411s-1.0031-1.2644-2.6122-2.3118c-1.6108-1.049-2.8246-0.89363-4.5555-2.0331-1.7324-1.141-2.641-2.8049-2.641-2.8049l1.3344-2.7107s1.4923,2.0975,3.0375,3.2363c1.5489,1.1378,4.9812,2.2474,6.0773,3.2071,1.0922,0.95535,3.673,3.724,3.673,3.724z'/%3E %3C/g%3E %3C/g%3E %3Cg id='water'%3E %3Cpath fill='%2330c2dc' stroke='%230872a7' stroke-width='0.7' d='m452.73,299.48s-4.6857-1.8166-4.3474-3.462c0.34147-1.6406,10.824-4.4044,10.824-4.4044l0.16754-2.7649s-1.5329-0.0855-4.1756,0.77839c-2.6411,0.86387-6.8162,1.9865-11.328,1.9865-2.7403,0-4.2257-0.28633-4.97-0.51095-0.48393-0.14672-36.95-2.2886-38.139-2.2767-0.51327,0.01-1.1664-0.007-1.9896-0.0628-4.8564-0.34642-7.9794-7.7785-7.9794-7.7785l-2.2996,0.40218s0.70589,3.652-0.51274,3.9752c-2.3839,0.63492-18.229-7.8373-18.229-7.8373l-0.87505,3.4366s9.6882,5.1822,9.3959,7.1096c-0.29185,1.9259-3.1645,1.7792-3.1645,1.7792l1.2314,2.3102c0.43539,0.0395,15.95,0.78811,16.214,5.4462,0.10831,1.8815-3.8047,2.9955-3.8047,2.9955l1.305,1.593v0.79297s8.6169,0.0515,11.003,1.3836c2.385,1.3342,3.5994,3.2585,6.5224,4.9365,2.9207,1.6801,22.752,1.2698,25.851,0.39891,3.5022-0.9873,5.6541-4.956,11.35-6.6842,5.6952-1.7262,7.5349-1.8128,7.5349-1.8128z'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='373.416' cy='292.05' r='2.745'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='389.095' cy='279.26' r='2.746'/%3E %3Ccircle fill='%23fff' stroke='%230872a7' stroke-width='1.37' cx='454.822' cy='299.74' r='2.817'/%3E %3Cpath fill='%23f8c83c' d='m361.11,275.15c-0.8953,2.072,2.6384,6.0051,5.1093,6.4369,2.4714,0.43194,3.8341-0.17104,4.2604-1.3819,0.42683-1.2136,0.095-2.5278-0.46847-3.2823-1.5761-2.1191-8.0094-3.8469-8.9011-1.7727z'/%3E %3Cpath fill='%23fff' d='m368.9,278.31c-0.0672-1.252-2.1289-2.4655-3.4494-2.4655-1.3206,0-2.6421-0.0412-2.4282,0.65116,0.21183,0.68905,3.6207,1.6011,3.705,1.987,0.0854,0.38919-1.0218,0.86228-0.46792,1.3819,0.55381,0.51964,1.2352,0.13208,1.7895-0.25765,0.5538-0.39027,0.89315-0.51908,0.85099-1.2969z'/%3E %3Cpath fill='%23f8c83c' d='m390.71,301.99c0.56664,1.8252-0.851,2.7183-2.6843,3.5416-1.8312,0.82113-5.5788,0.34317-6.4305-1.1226-0.85313-1.4696,1.3627-3.8469,3.6201-4.4093,2.2575-0.56076,4.9823,0.34642,5.4943,1.9903z'/%3E %3Cpath fill='%23fff' d='m386.92,303.07c0.71604-0.12396,0.72507,1.0831,1.3638,0.99216,0.6392-0.0839,1.192-1.121,1.0212-1.8138-0.16968-0.69231-1.3638-1.6423-2.385-1.5546-1.0223,0.0871-4.0459,2.6344-3.7066,3.3267,0.34147,0.68905,1.0223,0.60517,1.5777,0.34696,0.55435-0.26035,1.3627-1.1675,2.1289-1.2975z'/%3E %3Cpath fill='%23f8c83c' d='m458.35,292.53c1.661,2.2095,4.6563,0.17266,5.4495-0.68798,0.79608-0.86549,3.2371-2.2767,2.2441-3.7181-0.99612-1.4393-2.6966-1.324-3.8341-1.2698-1.1359,0.0579-3.4649,1.7316-3.8597,2.5067-0.39858,0.7816-0.73949,2.1927,0,3.1692z'/%3E %3Cpath fill='%23fff' d='m458.89,291.07s0.14462-2.4071,2.3892-2.5067c1.2763-0.0574,1.3328,0.34696,2.3001,0.8953,0.96251,0.54451,1.3328-0.72047,1.3328-0.72047s0.0581,1.7002-1.5014,1.7559c-1.5638,0.0563-0.99827-0.69066-2.5291-0.92127-1.3499-0.20459-1.9918,1.4972-1.9918,1.4972z'/%3E %3C/g%3E %3Cg id='pedestal' fill='%23f9aa51' stroke='%23953220' stroke-width='0.7' stroke-linecap='round' stroke-linejoin='round'%3E %3Cpath d='m422.43,286.4-1.1087-0.71881s-2.2158-0.11367-3.7194-0.0855c-1.5073,0.0281-4.4866,0.17268-4.4866,0.17268l4.4552,12.934,5.3408,7.693,2.0462,0.73507,4.1462-0.27498,0.70534-2.0152-1.5601-12.475-5.8187-5.9656z'/%3E %3Cpath d='m407.71,287.21,0.21342-1.469s1.0079-0.12829,2.4138-0.17105c1.4059-0.0466,2.6336,0.092,2.7846,0.20082,0.14459,0.1088,3.1095,3.7316,4.1297,6.1056,1.0207,2.3795,2.2142,6.3525,3.5353,8.7766,1.3216,2.4174,4.1766,6.4796,4.1766,6.4796s-1.4289,0.0844-2.6864,0.0844c-1.256,0-2.6534,0.0444-2.6534,0.0444l-2.3951-0.92832-7.5178-11.688-2.0008-7.436z'/%3E %3Cpath d='m404.57,285.62s3.0668-0.0563,3.3512,0.11529c0.28439,0.17321,3.6916,3.2006,5.0533,6.9429,1.3654,3.7446,0.68243,4.2642,2.4458,8.1258,1.7564,3.8599,4.2017,6.4518,4.2017,6.4518s-5.1119,0.2885-8.0088-0.23114c-2.8972-0.51908-3.9195-0.46008-4.6019-1.2644-0.68081-0.80981-2.2724-1.7879-2.2724-1.7879h-2.8945l0.67974-4.0342-0.79392-9.0443,0.17073-4.6707,2.6688-0.60351z'/%3E %3Cpath d='m435.24,288.01-4.8836-2.0152-9.0871-0.46172s0.33668,2.4222,0.67815,4.6691c0.34147,2.2442,1.9341,7.545,3.4099,10.139,1.4758,2.5933,2.9548,5.7626,3.7509,6.5095,0.79661,0.75017,6.0217-1.4111,6.0217-1.4111l3.4051-0.51801-0.45352-3.7181-0.48446-1.1507,0.79821-10.574-0.74163-1.6406-2.4138,0.17214z'/%3E %3Cpath d='m403.09,288.07c0,1.1546,1.2223,1.2119,1.534,1.1546,0.31106-0.0595,1.3638-0.46226,1.3638-2.0201,0-1.5546-0.96465-2.7627-2.8694-2.8785-1.9032-0.11529-3.3496,2.2771-3.3496,3.888,0,1.6124,1.6172,2.4488,1.6172,3.0555,0,0-1.6172,1.4977-1.5334,4.117,0.0843,2.6236,2.2158,4.6399,2.2158,4.6399s-2.2729,1.8138-2.2729,3.6304c0,1.8155,1.7341,3.0225,3.3523,3.0225,1.6183,0,3.6916-1.0354,3.6916-2.4157,0-1.3852-1.2213-2.2176-2.2436-2.2176-1.0228,0-1.448,0.60138-1.448,1.0636'/%3E %3Cpath d='m436.8,288.8c0,1.1242-0.72614,1.1708-1.3654,1.1708-0.63919,0-1.4902-0.34805-1.4902-1.776,0-1.4246,1.8754-2.2024,3.0684-2.2024,1.1893,0,3.2371,1.6406,3.2371,3.6309,0,1.9865-1.4496,3.3267-1.4496,3.3267s0.89369,0.4303,0.89369,2.9354c0,2.5094-1.6167,4.321-1.6167,4.321s2.1113,0.82439,2.1113,3.4176c0,2.589-1.7911,3.4366-3.0284,3.4366-1.2362,0-3.3886-0.7367-3.3886-2.5077,0-1.7759,1.1098-2.3979,1.9603-2.3979,0.85154,0,1.6834,0.9943,1.6834,1.9654'/%3E %3Cpath fill='%23953220' stroke='none' d='m406.22,302.5s0.31639,0.20787,0.55541,0.71561c0.24383,0.5126,0.41778,1.3321,0.97907,1.8317,1.1071,0.99436,9.5402,1.2991,12.098,1.2991,2.5547,0,10.221,0.34642,11.671-0.51909,1.4502-0.86281,1.6188-2.2918,2.513-2.9402,0.89369-0.64631,1.1503-0.6019,1.1503-0.6019l-1.1082,0.94835-0.0811,1.8138,0.65624,0.99436s-0.14619,0.52126-1.0436,1.0831c-0.89369,0.56241-1.7031,0.73397-2.9382,0.86441-1.2352,0.12992-17.377,0.0855-19.98-0.3448-2.5968-0.43518-2.426-0.39081-3.1928-0.95155-0.76727-0.56024-1.1935-1.167-1.1935-1.167l0.34147-1.1654-0.42737-1.8604z'/%3E %3Cpath fill='%23953220' stroke='none' d='m432.41,287.01,1.448,0.63492s-1.2368,0.38431-2.1694,2.9365c-0.93959,2.5527-0.17233,3.3716-0.80938,3.6293-0.64027,0.26199-7.6262,0.0444-7.6262,0.0444l-1.1962-2.8985,10.353-4.3465z'/%3E %3C/g%3E %3Cg id='cactus' fill='%23231f20'%3E %3Cpath d='m454.69,286s-1.193-0.43196-1.7453-1.4263c-0.55595-0.9943-1.0244-2.2474-0.59971-2.5077,0.43057-0.25927,1.3216,0.60297,1.24,1.3852-0.088,0.77619,1.105,2.5489,1.105,2.5489z'/%3E %3Cpath d='m468.34,282.23s0.85207,1.5535,1.1487,1.7251c0.30038,0.17267,1.6594,0.78324,1.6594,0.78324s-1.9144,0,-2.5093-0.52126c-0.59971-0.51962-1.4496-1.9459-1.4496-1.9459l1.1509-0.0412z'/%3E %3Cpath d='m472.46,283.49s-1.1503,0.68905-2.1273,0.30202c-0.98014-0.38971-1.7442-0.95321-1.367-1.3819,0.38682-0.43411,0.63812-0.26036,1.1503,0.29987,0.51274,0.56509,2.3439,0.77999,2.3439,0.77999z'/%3E %3Cpath d='m479.4,277.61s-0.93798,0.82544-1.6188,0.82544-2.0462-0.26359-2.0462-0.56561c0-0.30151,1.7879-0.47471,2.0867-0.43033,0.302,0.0427,1.5782,0.17051,1.5782,0.17051z'/%3E %3Cpath d='m469,263.83s-1.5361,0.47363-2.0445,1.2547c-0.50849,0.77672-0.38364,1.6406,0.25663,1.5962,0.63706-0.0412,0.80938-0.90555,0.80938-1.1659,0-0.25548,0.97854-1.685,0.97854-1.685z'/%3E %3Cpath d='m462.15,267.59s-1.1493,0.7302-1.4481,1.3819c-0.30093,0.64577-0.55596,2.0277,0.12485,2.0742,0.68401,0.0427,0.89903-1.0392,0.93798-1.5995,0.0454-0.56241,0.38523-1.8566,0.38523-1.8566z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m449.89,275.88-3.7594,3.9806s8.6468,4.8407,15.29,4.6252c6.6474-0.21435,14.231-5.4014,14.738-6.4834,0.5138-1.0766,0.0875-5.7032-0.76723-7.1742-0.85212-1.4674-5.451-5.054-7.1966-4.8823-1.7442,0.17267-4.8158,2.5061-7.6685,5.2726-2.8545,2.7665-2.5584,5.0967-6.5175,4.8851-3.9621-0.21651-4.1201-0.22355-4.1201-0.22355z'/%3E %3Cpath fill='%230c8489' d='m448.93,277.47s9.2575,1.3852,11.923-0.97812c2.6736-2.3605,5.5681-6.9712,7.4435-8.0099s2.7228-1.0387,2.7228-1.0387,1.3798,0.87852,2.0168,1.4295c0.64027,0.54451,2.3567,1.9556,2.3567,1.9556l0.7411,4.3974,0.0555,2.4174-2.8929,2.3659-5.3147,2.4482-5.0805,1.5827-4.3169-0.11528-8.744-2.5359-2.2185-1.5697-0.56878-0.50448,1.8765-1.8447z'/%3E %3Cpath fill='%2304534e' d='m463.04,272.14c0-0.78971,0.51701-0.75022,1.2224-0.75022,0.70534,0,1.4758,0.13477,1.4758,0.92286,0,0.78807-0.76989,1.9291-1.4758,1.9291-0.70588,0-1.2224-1.3121-1.2224-2.1018z'/%3E %3Cpath fill='%2304534e' d='m466.76,274.47c0-0.70962,0.54478-1.095,1.3894-1.095,0.84833,0,1.6188,0.94829,1.6188,1.6558,0,0.70908-0.68563,1.2828-1.5276,1.2828-0.84779-0.00036-1.4806-1.1351-1.4806-1.8436z'/%3E %3Cpath fill='%2304534e' d='m465.48,280.01c0-0.88552,0.54265-1.0691,1.391-1.0691,0.84512,0,1.3654,0.39892,1.3654,1.2828,0,0.88065-0.69098,1.5995-1.5361,1.5995-0.84833,0.00037-1.2202-0.93317-1.2202-1.8133z'/%3E %3Cpath fill='%2304534e' d='m460.6,278.31c0-0.9451,0.89742-1.2401,1.6594-1.2401,0.76086,0,1.3782,0.76808,1.3782,1.718,0,0.94669-0.6173,1.7115-1.3782,1.7115-0.76194,0-1.6594-1.2434-1.6594-2.1895z'/%3E %3Cpath fill='%2304534e' d='m452.87,279.25c0-1.0458,0.84673-1.8912,1.8888-1.8912,1.0431,0,1.8898,0.84604,1.8898,1.8912,0,1.0387-0.84673,1.8842-1.8898,1.8842-1.042,0.00036-1.8888-0.84549-1.8888-1.8842z'/%3E %3Cpath fill='%238cbebf' d='m466.76,274.47c0-0.63872,0.8729-1.095,1.3894-1.095,0.5202,0,0.93959,0.51475,0.93959,1.1545,0,0.63332-0.41937,1.1508-0.93959,1.1508-0.51649-0.00037-1.3894-0.57594-1.3894-1.2103z'/%3E %3Cpath fill='%238cbebf' d='m465.51,279.78c0-0.7334,0.67601-1.0387,1.4496-1.0387,0.77523,0,1.3606,0.30474,1.3606,1.0387,0,0.73072-0.62906,1.3224-1.4027,1.3224-0.77737,0-1.4075-0.59212-1.4075-1.3224z'/%3E %3Cpath fill='%238cbebf' d='m460.63,278.16c0-0.80922,1.3296-1.1773,1.8786-1.1773,0.54901,0,0.45351,0.54072,0.45351,1.3521,0,0.81461-0.44871,1.469-0.99772,1.469-0.54741,0-1.3344-0.8276-1.3344-1.6439z'/%3E %3Cpath fill='%238cbebf' d='m462.93,272.05c0-0.74045,0.5752-0.77838,1.0532-0.77838,0.47485,0,0.82274,0.22247,0.82274,0.96455,0,0.74044-0.38735,1.3391-0.8649,1.3391-0.48124-0.00036-1.0111-0.78539-1.0111-1.5254z'/%3E %3Cpath fill='%238cbebf' d='m452.85,278.68c0-0.85901,0.74751-1.6704,1.8466-1.6704,1.0986,0,2.2132,0.37891,2.2132,1.2363,0,0.85954-1.3424,2.3345-2.441,2.3345-1.1018,0.00036-1.6188-1.0414-1.6188-1.9004z'/%3E %3Cpath d='m456.39,277.18s-1.2779,0.2176-1.9602,0.86607c-0.67923,0.64791-0.76727,1.3852-0.38203,1.5995,0.38203,0.21434,0.85314-0.47688,0.98014-0.77839,0.12486-0.3042,1.3622-1.6872,1.3622-1.6872z'/%3E %3Cpath d='m462.53,275.84s-1.2341,0.86607-1.3606,1.7315c-0.13018,0.86713,0,1.2958,0.34147,1.3402,0.34147,0.0412,0.55061-1.1258,0.42577-1.5578-0.12699-0.42869,0.5933-1.514,0.5933-1.514z'/%3E %3Cpath d='m463.55,277.14s-0.80831,0.0412-1.3622,0.56076c-0.55114,0.52071-1.0629,1.167-0.67922,1.2114,0.38041,0.0412,0.98175-0.25873,1.0191-0.60623,0.0437-0.3448,1.0223-1.1659,1.0223-1.1659z'/%3E %3Cpath d='m464.87,270.01s-0.64027,0.51963-0.98014,0.82006c-0.34306,0.30475-0.76562,1.167-0.34306,1.3868,0.42897,0.2176,0.72613-0.17483,1.0238-0.77672,0.29932-0.61056,0.29932-1.43,0.29932-1.43z'/%3E %3Cpath d='m469.52,272.99s-1.1957,0.16835-1.5761,0.68799c-0.38203,0.51963-0.64187,1.1264-0.12859,1.1264,0.50901,0,0.63705-0.26035,0.85206-0.73397,0.21449-0.47472,0.85261-1.0804,0.85261-1.0804z'/%3E %3Cpath d='m468.79,278.48s-0.25344,0.82114-0.97855,1.2087c-0.72452,0.39242-0.93585,0.73666-1.2346,0.21705-0.29932-0.51746,0.0843-0.77839,0.46792-0.91042,0.38308-0.12612,1.7452-0.51531,1.7452-0.51531z'/%3E %3Cpath fill='%2304534e' d='m476.2,274.76s0.5138,2.5494-1.7004,3.8004c-2.2148,1.2547-8.4352,5.6621-14.312,5.1427-5.8801-0.51908-12.568-3.888-12.568-3.888l-0.93477,0.43194,1.4891,0.64791,4.5587,1.8999,5.1925,1.515,3.2408,0.21434,2.8118-0.34642,5.1941-1.7251,4.4012-2.249,2.2852-1.8154,0.61254-0.75022-0.0566-1.0636v-1.4696l-0.21395-0.34481z'/%3E %3Cpath d='m360.78,241.54s1.3638,1.167,1.2352,2.1597c-0.12859,0.99435-0.46952,1.3868-0.85048,1.2119-0.38468-0.17322-0.38468-1.2119-0.29931-1.6406,0.0848-0.43735-0.0854-1.731-0.0854-1.731z'/%3E %3Cpath d='m370.86,250.91s-0.38469,1.7262-1.0671,1.8994c-0.68029,0.17321-1.1914-0.56023-1.0645-0.86387,0.12859-0.30367,0.68189-0.0427,0.98068-0.30367,0.29772-0.25548,1.1508-0.73179,1.1508-0.73179z'/%3E %3Cpath d='m348.92,252.25s0.46739,0.99435,1.3627,1.167c0.89369,0.17159,1.3216-0.43356,1.193-0.73505-0.12751-0.30042-0.51113-0.21761-0.98068-0.21761-0.46792,0-1.575-0.21434-1.575-0.21434z'/%3E %3Cpath d='m352.84,259.94s0.81045,0.95321,1.9171,1.0814c1.1066,0.12882,1.661-0.73506,1.7452-0.99436,0.0854-0.25981-1.2768-0.21705-1.7041,0.12882-0.42471,0.34642-1.9582-0.21597-1.9582-0.21597z'/%3E %3Cpath d='m359.78,265.86s1.7879-0.34642,2.0851-0.81953c0.29986-0.47632,0.76728-1.2964,0.38469-1.7738-0.38469-0.47307-0.68189,0.73505-0.89476,1.2081-0.21289,0.47849-1.575,1.3852-1.575,1.3852z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m370.95,261.16s1.1946-8.0104-5.2822-13.657c-6.4753-5.6456-10.678-4.2642-12.895-2.1863-2.2142,2.071-4.1446,8.8728,2.7264,14.808,6.8734,5.9341,15.337,4.091,15.337,4.091l0.11312-3.0555z'/%3E %3Cpath fill='%230c8489' d='m351.2,252.68s-0.12271-4.4006,1.9555-5.7102c2.0787-1.3158,8.9257-2.4569,12.301,4.045,3.3742,6.4962,3.4414,9.7464,2.5899,13.032l-3.6121-0.0358-5.5894-2.2788-4.635-3.4231-3.0103-5.6295z'/%3E %3Cpath fill='%2304534e' d='m370.09,262.31s-1.1344,1.2682-3.4644,1.154c-2.3284-0.11692-13.176-2.9397-15.903-12.676l0.17128,2.1305,0.11258,0.69232,0.71497,1.9622,2.2825,3.3137,2.8646,2.4553,3.6116,1.868,2.5904,0.75995,3.3726,0.58893h1.9432l1.7041-2.249z'/%3E %3Cpath fill='%2304534e' d='m364.44,259.5c0-0.86874,0.44497-0.89529,1.136-0.89529,0.6899,0,1.2207-0.30475,1.2207,0.56076,0,0.86767-0.47379,2.1186-1.1637,2.1186-0.68989,0-1.193-0.91966-1.193-1.7841z'/%3E %3Cpath fill='%2304534e' d='m364.9,254.35c0-0.59977,0.54581-1.0831,1.224-1.0831,0.67387,0,1.2181,0.48337,1.2181,1.0831,0,0.59703-0.54474,1.0766-1.2181,1.0766-0.67762,0-1.224-0.48012-1.224-1.0766z'/%3E %3Cpath fill='%2304534e' d='m359.98,260.03c0-0.46768,0.61628-0.84871,1.3771-0.84871,0.76139,0,1.3776,0.38106,1.3776,0.84871,0,0.4682-1.3685,1.1085-2.1299,1.1085-0.75979,0-0.62477-0.63979-0.62477-1.1085z'/%3E %3Cpath fill='%2304534e' d='m359.53,253.96c0-0.76321,0.37029-0.51963,1.0377-0.51963,0.66746,0,1.4902,0.2176,1.4902,0.98133,0,0.76371-0.82327,1.7857-1.4902,1.7857-0.66692,0-1.0377-1.4858-1.0377-2.2474z'/%3E %3Cpath fill='%2304534e' d='m354.96,254.98c0-0.64305,0.43325-1.5421,1.249-1.5421,0.81525,0,1.7025,0.8985,1.7025,1.5421,0,0.64412-0.65997,1.167-1.4768,1.167-0.81419,0-1.4747-0.52288-1.4747-1.167z'/%3E %3Cpath fill='%2304534e' d='m355.78,249.61c0-0.66575,0.45353-0.63167,1.2912-0.63167,0.83929,0,1.5206,0.33993,1.5206,1.0106,0,0.66633-0.98014,1.4961-1.8188,1.4961-0.83876,0-0.99292-1.2038-0.99292-1.875z'/%3E %3Cpath fill='%2304534e' d='m360.73,249.09c0-0.64631,0.55007-0.43412,1.3344-0.43412,0.78646,0,1.4214,0.52288,1.4214,1.1675,0,0.64304-1.0041,1.3667-1.7901,1.3667-0.78378,0.00036-0.96571-1.4571-0.96571-2.1002z'/%3E %3Cpath fill='%238cbebf' d='m355.78,249.47c0.11258-0.46225,0.43378-0.77999,1.0218-0.77999,0.58742,0,1.1066,0.11042,1.1066,0.77999,0,0.66576-0.47699,1.2119-1.0639,1.2119-0.58849,0.00036-1.2245-0.56508-1.0645-1.2119z'/%3E %3Cpath fill='%238cbebf' d='m354.87,254.74c0-0.65117,0.32653-1.2666,0.99292-1.2666,0.66638,0,1.193,0.066,1.193,0.721,0,0.65442-0.58369,1.4111-1.2496,1.4111-0.66639,0-0.93638-0.21272-0.93638-0.86548z'/%3E %3Cpath fill='%238cbebf' d='m360.69,249.18c0-0.51801,0.44391-0.57541,1.0788-0.57541,0.63385,0,1.05,0.13207,1.05,0.64631,0,0.51962-0.51435,0.93643-1.1498,0.93643-0.63546,0.00054-0.97908-0.48986-0.97908-1.0073z'/%3E %3Cpath fill='%238cbebf' d='m359.56,254.23c0,0.70909,0.52021,1.2861,1.1637,1.2861,0.64346,0,1.3344-0.56403,1.3344-1.2699,0-0.71234-0.71924-1.3857-1.3627-1.3857-0.64402,0.00036-1.1354,0.66202-1.1354,1.3694z'/%3E %3Cpath fill='%238cbebf' d='m365.1,253.49c0,0.64197,0.55809,1.1675,1.248,1.1675,0.69044,0,1.2496-0.52612,1.2496-1.1675,0-0.64577-0.55916-1.1654-1.2496-1.1654-0.68937,0-1.248,0.51963-1.248,1.1654z'/%3E %3Cpath fill='%238cbebf' d='m359.76,259.97c0-0.56349,0.58528-1.108,1.1653-1.108,0.57941,0,1.1354,0.35778,1.1354,0.9218,0,0.564-1.0084,1.3256-1.5895,1.3256-0.58047,0-0.71121-0.57541-0.71121-1.1394z'/%3E %3Cpath fill='%238cbebf' d='m364.47,259.14c0-0.69065,0.52714-0.74858,1.2496-0.74858,0.72245,0,1.0783,0.0693,1.0783,0.76161,0,0.69233-0.58368,1.2579-1.3051,1.2579-0.72245,0.00036-1.0228-0.57807-1.0228-1.2709z'/%3E %3Cpath d='m365.75,251.04s0.72245,0.90556,0.85047,1.5963c0.12698,0.69064,0.12698,1.4706-0.12805,1.5584-0.2561,0.0855-0.68083-0.4341-0.80885-1.0804-0.12698-0.65117,0.0864-2.0742,0.0864-2.0742z'/%3E %3Cpath d='m361.62,246.63s0.46791,0.73725,0.46791,1.3857c0,0.64738-0.0854,1.3386-0.42576,1.3386-0.33988,0-0.33988-0.64738-0.33988-1.1242,0-0.47362,0.29773-1.6,0.29773-1.6z'/%3E %3Cpath d='m356.76,247.28s0.46899,0.73724,0.46899,1.3852c0,0.6463-0.0854,1.3392-0.42578,1.3392-0.34146,0-0.34146-0.64791-0.34146-1.121,0-0.47849,0.29825-1.6032,0.29825-1.6032z'/%3E %3Cpath d='m355.06,248.19s0.63866,0.17321,1.192,0.60349c0.55381,0.43195,0.76673,0.94942,0.55381,1.2098-0.21289,0.25928-0.72351-0.12667-0.851-0.43195-0.12912-0.30257-0.89476-1.3814-0.89476-1.3814z'/%3E %3Cpath d='m358.76,253.28s0.93691,0.0427,1.4491,0.51909c0.51062,0.47687,0.93585,0.86607,0.63813,1.2119-0.29772,0.34481-1.0228-0.26035-1.3216-0.6035-0.29772-0.34589-0.76568-1.1275-0.76568-1.1275z'/%3E %3Cpath d='m354.25,253.11s0.85261,0.21325,1.2773,0.51638c0.42736,0.30474,0.55488,0.91041,0.34146,1.0387-0.21288,0.12666-0.5106-0.0871-0.89369-0.47471-0.38361-0.39134-0.72511-1.0804-0.72511-1.0804z'/%3E %3Cpath d='m365.15,256.53s0.29932,1.0371,0.29932,1.7678c0,0.73725,0.0854,1.3852-0.2561,1.3852-0.34041,0-0.51115-0.90662-0.51115-1.469,0-0.56403,0.46793-1.6839,0.46793-1.6839z'/%3E %3Cpath d='m363.92,258.21s0.76727,0.30204,1.1076,0.6035c0.3404,0.30475,0.42684,0.77946,0.17074,0.86548-0.25505,0.0861-0.42578-0.47469-0.63974-0.69065-0.21181-0.21597-0.63866-0.77838-0.63866-0.77838z'/%3E %3Cpath d='m359.06,258.51s0.82007,0.0974,1.1776,0.34155c0.35641,0.24358,0.3927,1.3646,0.35641,1.5102-0.0347,0.14343-0.56931,0.046-0.78592-0.48769-0.21129-0.53587-0.74804-1.364-0.74804-1.364z'/%3E %3Cpath fill='%2304534e' d='m357.18,243.69s-4.2913,0.93045-5.0746,3.697c-0.78539,2.7665-0.81953,5.8416-0.81953,5.8416l-0.61414-3.5232,0.85367-2.2826,1.248-2.0969,1.8888-1.1886,1.7015-0.58732,0.81633,0.1402z'/%3E %3Cpath fill='%2304534e' d='m370.57,260.1s0.44444-1.0712-0.81579-4.458c-1.2629-3.3884-3.8517-7.8154-3.8517-7.8154l2.012,2.2821,1.5996,2.5938,0.78431,2.3838,0.57947,2.1797-0.0336,2.1402-0.27424,0.69391z'/%3E %3Cpath d='m374.91,254.62s1.4897,0.97592,1.639,1.5134c0.15047,0.54239,0.21183,0.71556-0.16913,0.86607-0.38415,0.15482-1.002-0.45196-1.1728-0.86607-0.17073-0.41082-0.29718-1.5134-0.29718-1.5134z'/%3E %3Cpath d='m368.62,271.52s0.70375-1.3175,1.6401-1.8138c0.93638-0.49636,1.6391-0.43411,1.8952-0.12883,0.25611,0.30204-0.61734,0.9927-1.2554,1.2314-0.63974,0.23816-2.2799,0.71122-2.2799,0.71122z'/%3E %3Cpath d='m379.19,275.56s1.0442-0.49635,1.726-1.233c0.68189-0.73072,0.76722-1.2498,0.51061-1.5102-0.25451-0.25927-1.1071,0.1743-1.4913,0.75617-0.38308,0.58027-0.74536,1.987-0.74536,1.987z'/%3E %3Cpath d='m378.04,274.57s0.36227-1.3602,0.72565-1.7938c0.36174-0.43194,0.87184-0.66902,1.256-0.43194,0.38523,0.23708,0.1494,0.84603-0.12858,1.1659-0.27584,0.32585-1.853,1.0598-1.853,1.0598z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m395.71,266.52s-6.5844-9.5231-16.811-10.026c-8.1793-0.4038-10.763,6.9001-10.465,9.1031,0.29239,2.1684,3.3651,6.9284,14.27,7.7326,10.905,0.80757,12.665-5.1394,13.12-5.4297,0.45298-0.28851-0.11418-1.3802-0.11418-1.3802z'/%3E %3Cpath fill='%230c8489' d='m387.94,259.98s2.7264,2.078,3.8778,3.7181c1.1492,1.6406,1.4054,2.8531,0.72405,3.0702-0.68297,0.21111-6.603-5.2759-11.459-6.4401-4.8574-1.1686-9.0732-0.0855-10.011,2.2474-0.93532,2.3345-0.5949,5.8336,1.6204,7.2565,2.2153,1.4312,12.609,3.1129,12.609,3.1129s4.7278-0.6479,4.8969-0.73233c0.17126-0.0871,3.0252-1.6866,3.0252-1.6866l0.63759-1.6423,0.76776-2.1614,0.34147-0.86441-2.5136-2.7649-4.516-3.1129z'/%3E %3Cpath fill='%2304534e' d='m379.59,261.32c0,0.61003-0.64133,0.91207-1.2773,0.91207-0.63652,0-1.1717-0.32152-1.1717-0.92992,0-0.61001,0.51489-1.1031,1.1498-1.1031,0.63546,0,1.2992,0.5126,1.2992,1.121z'/%3E %3Cpath fill='%2304534e' d='m373.59,263.48c0-0.61163,0.68617-0.60138,1.375-0.60138,0.68882,0,1.2464,0.50124,1.2464,1.1129,0,0.61003-1.0826,1.4528-1.7057,1.1578-0.7646-0.3697-0.9156-1.0523-0.9156-1.6693z'/%3E %3Cpath fill='%2304534e' d='m380.04,267.01c0-0.77727,0.65785-1.4084,1.471-1.4084,0.81098,0,1.4684,0.63113,1.4684,1.4084,0,0.77294-1.105,1.6152-1.916,1.6152-0.81205,0-1.0234-0.84276-1.0234-1.6152z'/%3E %3Cpath fill='%238cbebf' d='m375.16,268.45c0-0.67932,0.69894-0.81948,1.2997-0.81948,0.59811,0,1.3622,0.63819,1.3622,1.3175,0,0.67933-0.76407,1.1443-1.3622,1.1443-0.60024,0-1.2997-0.96133-1.2997-1.6423z'/%3E %3Cpath fill='%2304534e' d='m383.89,270.82c0-0.55372,0.33026-1.0474,0.89583-1.0474,0.56396,0,1.2554,0.33125,1.2554,0.88391,0,0.5575-0.56237,1.1675-1.1279,1.1675-0.56556,0-1.0234-0.44872-1.0234-1.0041z'/%3E %3Cpath fill='%2304534e' d='m387.81,267.83c0-0.70583,0.39909-0.63007,1.0874-0.63007,0.68828,0,1.383,0.39893,1.383,1.1031,0,0.70583-0.86489,1.0798-1.5537,1.0798-0.6883,0.00036-0.91666-0.8525-0.91666-1.5529z'/%3E %3Cpath fill='%238cbebf' d='m379.21,260.76c0,0.54564-0.22675,0.83898-0.76722,0.83898-0.5405,0-1.1935-0.29339-1.1935-0.83898,0-0.55104,0.2497-0.71721,0.78859-0.71721,0.54159-0.00037,1.1722,0.16617,1.1722,0.71721z'/%3E %3Cpath fill='%238cbebf' d='m376.08,263.31c0,0.59971-0.90437,0.97432-1.47,0.97432-0.56503,0-0.93691-0.37404-0.93691-0.97432,0-0.59544,0.43644-0.77513,1.002-0.77513,0.56503,0,1.4048,0.1797,1.4048,0.77513z'/%3E %3Cpath fill='%238cbebf' d='m377.47,268.35c0,0.52289-0.19847,0.92667-0.80831,0.92667-0.61146,0-1.407-0.40379-1.407-0.92667,0-0.52449,0.22036-0.88717,0.83129-0.88717,0.61147,0.00037,1.384,0.36321,1.384,0.88717z'/%3E %3Cpath fill='%238cbebf' d='m382.68,266.64c0,0.54885-1.074,1.167-1.6407,1.167-0.56503,0-0.80884-1.009-0.80884-1.5545,0-0.55104,0.45566-0.9927,1.0223-0.9927,0.5661,0,1.4272,0.83251,1.4272,1.3803z'/%3E %3Cpath fill='%238cbebf' d='m390.24,268.26c0,0.57215-0.90919,0.53913-1.4278,0.53913-0.51541,0-0.97907-0.63818-0.97907-1.2065,0-0.57539,0.17127-1.1031,1.4486-0.95321,0.51381,0.0606,0.95823,1.0506,0.95823,1.6206z'/%3E %3Cpath fill='%238cbebf' d='m385.77,270.57c0,0.57053-0.43805,1.0355-0.978,1.0355-0.53997,0-0.98016-0.46497-0.98016-1.0355,0-0.57375,0.43965-0.80002,0.98016-0.80002,0.54049,0,0.978,0.22625,0.978,0.80002z'/%3E %3Cpath d='m386.45,267.42s1.0639-0.34642,1.8722-0.2636c0.80991,0.0888,0.8542,0.39243,0.8542,0.51963,0,0.13153-0.64026,0.39242-0.93798,0.30149-0.29985-0.0828-1.7884-0.55751-1.7884-0.55751z'/%3E %3Cpath d='m382.02,271.17s0.8526-0.51963,1.4918-0.6463c0.63707-0.12829,1.1492,0.0839,1.106,0.47308-0.0427,0.39135-0.25343,0.4785-0.89369,0.4785-0.63759,0-1.7041-0.30529-1.7041-0.30529z'/%3E %3Cpath d='m379.17,264.61s1.8301,0.7784,2.2153,1.5118c0.38202,0.73504,0.55274,0.9088,0.16966,1.1242-0.38254,0.21596-0.81044-0.26198-1.0644-0.60463-0.25611-0.34479-1.3206-2.0314-1.3206-2.0314z'/%3E %3Cpath d='m378.7,266.94s1.4059-0.38756,2.0446-0.38756c0.64026,0,0.81044,0.0444,0.89529,0.34642,0.0854,0.29986-0.14245,0.43032-0.668,0.40217-0.52448-0.0304-2.2718-0.36103-2.2718-0.36103z'/%3E %3Cpath d='m374.21,267.03s1.5345,0.2046,1.9171,0.60515c0.38362,0.4038,0.38362,0.76647,0.22676,0.99217-0.1558,0.23276-0.88141,0.0877-1.1076-0.14344-0.22676-0.23058-1.0361-1.4539-1.0361-1.4539z'/%3E %3Cpath d='m373.99,269.24c0.0699-0.0709,0.59491-0.86553,1.1498-1.0501,0.55274-0.18782,1.1919-0.15805,1.304,0.12666,0.11631,0.28849-0.48072,0.72101-0.87771,0.80815-0.39749,0.0855-1.5761,0.11529-1.5761,0.11529z'/%3E %3Cpath d='m372.83,262.53l1.5195,0.41732c0.55435,0.41842,0.68082,0.75023,0.55435,0.91042-0.12913,0.15643-0.66694,0.24358-1.1226-0.0574-0.66852-0.45088-0.95135-1.2704-0.95135-1.2704z'/%3E %3Cpath d='m376.16,258.66s1.5489,0.43249,2.06,1.1367c0.50955,0.70742,0.43858,1.1258,0.18354,1.2693-0.2545,0.14398-0.8526-0.21543-1.1919-0.53047-0.34147-0.32043-1.0516-1.8755-1.0516-1.8755z'/%3E %3Cpath fill='%2304534e' d='m393.86,269.79s-3.1512,2.681-10.264,2.4222c-7.1154-0.26035-13.548-3.2861-15.165-6.6132l0.63813,1.6417,1.5772,2.1175,4.9839,2.5505,5.5798,1.2498,4.4306,0.26198,4.1745-0.73506s3.0658-1.469,3.2376-1.5546c0.16967-0.0855,0.51113-0.82167,0.51113-0.82167l0.29613-0.51908z'/%3E %3Cpath fill='%2304534e' d='m394.8,266.42s-1.192-1.4706-2.855-3.0258c-1.662-1.5578-8.1354-5.7514-8.1354-5.7514l5.2384,2.3795,3.4521,2.8975,2.4703,2.7178-0.1702,0.78212z'/%3E %3Cpath d='m395.1,260.11s1.7895,0.69231,2.0878,1.1242c0.29933,0.43032,0.68082,0.82167,0.68082,0.82167s-0.46738,1.1654-0.89369,0.69231c-0.42684-0.47849-0.51113-0.47849-0.98067-1.1264-0.46846-0.65117-0.89423-1.5118-0.89423-1.5118z'/%3E %3Cpath d='m400.42,257.26s1.6626,0.69232,2.258,1.514c0.5965,0.82113,0.46898,1.5118,0.21395,1.5989-0.25664,0.0877-1.3627-0.86553-1.535-1.2525-0.16967-0.38756-0.93692-1.8604-0.93692-1.8604z'/%3E %3Cpath d='m402.09,256.92s1.574,1.1692,1.8301,1.685c0.25664,0.51963,0.76727,1.2087,0.25664,1.3819-0.51274,0.1732-1.2357-0.60298-1.4486-1.0766-0.21396-0.47958-0.63814-1.9903-0.63814-1.9903z'/%3E %3Cpath d='m411.07,259.03s1.2357,0.42869,1.3643,1.469c0.12699,1.0387-0.12859,1.7722-0.12859,1.7722s-0.8526-0.73345-0.8526-0.95322c0-0.21272,0.1286-0.38755,0-0.86062-0.12698-0.47794-0.38309-1.4274-0.38309-1.4274z'/%3E %3Cpath d='m413.46,259.86s0.97908,0.99435,1.1087,1.6406c0.12645,0.64738,0.2529,1.0831-0.29772,1.167-0.55542,0.0909-0.85154-0.56242-0.85154-1.121,0-0.56563,0.0406-1.6866,0.0406-1.6866z'/%3E %3Cpath d='m397.36,279.48s0.76561,0.3448,1.4891,0.0855c0.72458-0.26036,1.3238-0.90662,1.193-1.3391-0.12592-0.43519-0.50955-0.82274-1.065-0.25982-0.55327,0.56023-0.25344,0.82274-0.68081,1.0333-0.42684,0.21813-0.93639,0.48011-0.93639,0.48011z'/%3E %3Cpath d='m406.22,281.89s1.193-0.17268,2.0029-1.0404c0.80885-0.86062,1.1508-1.4658,0.59596-1.6834-0.55273-0.21597-1.2778,0-1.4059,0.69065-0.12752,0.69232-1.193,2.0331-1.193,2.0331z'/%3E %3Cpath d='m413.5,282.15s0.89743-0.51964,1.5798-1.1654c0.67922-0.6495,1.0613-1.0354,0.5933-1.5123-0.46738-0.48012-0.80884-0.13371-1.0202,0.0855-0.21502,0.21759,0,0.21759-0.25556,0.90721-0.25878,0.69064-0.89743,1.685-0.89743,1.685z'/%3E %3Cpath d='m415.72,282.11s0.96038-1.1675,1.1823-1.8187c0.21449-0.64577,0.34148-1.3802-0.095-1.3392-0.43537,0.0412-0.96411,0.64951-0.99136,1.1264-0.0347,0.47308-0.096,2.0315-0.096,2.0315z'/%3E %3Cpath fill='%238cbebf' stroke='%2304534e' stroke-width='0.7' d='m393.56,270.31c0.0624-3.2016,4.6003-10.587,9.8378-10.502,2.1812,0.0374,6.4577,1.1724,9.9254,2.7237,2.894,1.2958,3.8351,2.7254,5.7529,3.1984,1.9171,0.4747,4.8121,0.12828,4.8121,0.12828l6.5176-0.73345-5.1114,7.4772-1.8285,1.6406s-1.622,3.154-6.2632,4.9679c-4.644,1.8154-12.482,0.47525-16.018-0.38755-3.5353-0.86335-7.7096-4.2318-7.6246-8.5127z'/%3E %3Cpath fill='%2304534e' d='m393.56,270.31,0.34148,0.007c0.0106-0.7188,0.28865-1.7429,0.78752-2.8461,0.74483-1.6574,1.9827-3.5086,3.4969-4.9267,1.5168-1.4165,3.2952-2.3908,5.1226-2.3908h0.0838c1.0394,0.0195,2.6395,0.30474,4.398,0.78106,1.7591,0.47849,3.681,1.1459,5.396,1.9091,1.4187,0.63492,2.3487,1.2991,3.1874,1.8799,0.8377,0.5754,1.5942,1.0869,2.6208,1.3392,0.82647,0.20623,1.7927,0.26361,2.6507,0.26361,1.2485,0,2.2756-0.12233,2.2836-0.12504l5.7711-0.65117-4.6611,6.8178-1.8498,1.6585-0.0293,0.0563-0.002,0.007c-0.0747,0.14018-1.6818,3.0799-6.0794,4.8012-1.6268,0.63493-3.7055,0.87686-5.8518,0.87686-3.761,0-7.7331-0.73666-9.9617-1.2806-1.6844-0.40923-3.546-1.4263-4.9668-2.8428-1.4235-1.416-2.4004-3.2136-2.3988-5.205l0.002-0.12234-0.34148-0.007-0.34147-0.01-0.002,0.13857c0.002,2.2274,1.089,4.1928,2.6026,5.6979,1.5174,1.5102,3.4691,2.5754,5.2854,3.022,2.2686,0.55264,6.276,1.3029,10.121,1.3029,2.1977,0,4.3463-0.24413,6.096-0.92666,4.7449-1.8572,6.4192-5.0864,6.4422-5.133l-0.29932-0.15968,0.22409,0.2571,1.8594-1.6666,5.5649-8.1354-7.2634,0.81841s-0.0598,0.006-0.17074,0.0163c-0.33773,0.0341-1.1311,0.10068-2.0344,0.10068-0.82914,0-1.7543-0.0563-2.4901-0.2387-0.89049-0.22247-1.5601-0.66309-2.3951-1.2417-0.83395-0.5754-1.8204-1.2774-3.2995-1.934-1.7522-0.78971-3.7039-1.4625-5.4949-1.9492-1.7927-0.48769-3.4195-0.78486-4.5613-0.80922h-0.096c-1.3798,0-2.6971,0.48932-3.889,1.2515-1.79,1.141-3.3139,2.9067-4.4087,4.6945-1.0916,1.7922-1.7602,3.5962-1.7917,4.8954l0.34147,0.009z'/%3E %3Cpath fill='%230c8489' d='m425.21,271.31c-0.55275,0.43249-1.1492,0.43249-1.8306,0.43249-0.68564,0-15.207-8.8589-19.723-8.4715-4.5133,0.38756-8.8162,2.3345-8.9439,6.9594-0.12751,4.6215,1.0223,4.6664,1.9587,5.9624,0.93799,1.2975,9.7982,3.2433,9.7982,3.2433l5.4094-0.0909,4.3474-0.47307,3.8314-2.0742,2.0894-1.6834,1.4027-1.7294,1.661-2.0748z'/%3E %3Cpath fill='%2304534e' d='m402.26,268.95c0,0.90721-0.35054,1.5421-1.2336,1.5421-0.88087,0-1.5398-0.40056-1.5398-1.3077,0-0.90341,0.50101-1.2433,1.383-1.2433,0.883-0.00036,1.3904,0.10231,1.3904,1.009z'/%3E %3Cpath fill='%2304534e' d='m403.78,264.91c0-0.75402,0.72827-1.0836,1.5644-1.0836,0.83449,0,1.4768,0.30365,1.4768,1.0571,0,0.74857-0.65999,1.3256-1.4945,1.3256-0.8361,0-1.5468-0.54938-1.5468-1.2991z'/%3E %3Cpath fill='%2304534e' d='m412.48,267.27c0-0.65442,0.56236-1.1854,1.2586-1.1854,0.6915,0,1.2538,0.53099,1.2538,1.1854,0,0.65603-0.56236,1.187-1.2538,1.187-0.69627,0.00036-1.2586-0.53099-1.2586-1.187z'/%3E %3Cpath fill='%2304534e' d='m414.23,272.6c0-0.83737,0.60932-1.5134,1.3638-1.5134,0.75178,0,1.4539,0.35237,1.4539,1.187,0,0.8325-0.27213,1.6471-1.0244,1.6471-0.75125,0-1.7933-0.48606-1.7933-1.3207z'/%3E %3Cpath fill='%2304534e' d='m410.01,276.01c0-0.71721,0.63706-1.2964,1.4278-1.2964,0.78753,0,1.4246,0.57866,1.4246,1.2964,0,0.71775-0.56237,1.1822-1.3483,1.1822-0.78912,0-1.5041-0.46441-1.5041-1.1822z'/%3E %3Cpath fill='%2304534e' d='m402.04,274.63c0-0.69392,0.5613-1.2531,1.256-1.2531,0.69573,0,1.2581,0.55915,1.2581,1.2531,0,0.69231-0.56237,1.2531-1.2581,1.2531-0.69411,0-1.256-0.56076-1.256-1.2531z'/%3E %3Cpath fill='%238cbebf' d='m402.21,268.76c0,0.71181-0.61147,1.2964-1.3638,1.2964-0.75445,0-1.3638-0.58406-1.3638-1.2964,0-0.71721,0.60506-1.0008,1.3568-1.0008,0.75337,0.00053,1.3707,0.28363,1.3707,1.0008z'/%3E %3Cpath fill='%238cbebf' d='m406.43,264.65c0,0.69231-0.21502,1.1405-0.94547,1.1405-0.72826,0-1.6951-0.44818-1.6951-1.1405,0-0.69231,0.59329-1.2503,1.3205-1.2503,0.72827,0.00036,1.32,0.55803,1.32,1.2503z'/%3E %3Cpath fill='%238cbebf' d='m414.86,266.9c0,0.59544-0.55274,1.076-1.2352,1.076-0.68243,0-1.2352-0.4812-1.2352-1.076,0-0.59758,0.55275-1.0836,1.2352-1.0836,0.68242,0,1.2352,0.48606,1.2352,1.0836z'/%3E %3Cpath fill='%2304534e' d='m410.39,270.46c0,0.91207-0.35106,1.5464-1.2336,1.5464-0.88194,0-1.5409-0.40217-1.5409-1.3094,0-0.90662,0.50048-1.2412,1.384-1.2412,0.88247,0,1.3904,0.10231,1.3904,1.0041z'/%3E %3Cpath fill='%238cbebf' d='m404.3,274.33c0,0.71881-0.61199,1.2975-1.3638,1.2975-0.75178,0-1.3627-0.5786-1.3627-1.2975,0-0.71069,0.86543-1.0766,1.6199-1.0766,0.75071,0,1.1066,0.36645,1.1066,1.0766z'/%3E %3Cpath fill='%238cbebf' d='m410.13,270.31c0,0.71556-0.59063,1.2948-1.3206,1.2948-0.72826,0-1.32-0.57861-1.32-1.2948,0-0.7134,0.59171-1.2991,1.32-1.2991,0.72988,0,1.3206,0.58567,1.3206,1.2991z'/%3E %3Cpath fill='%238cbebf' d='m417.02,272.09c0,0.78811-0.4802,1.4165-1.3035,1.4165-0.8222,0-1.4897-0.63872-1.4897-1.423,0-0.78811,0.23903-1.0571,1.0602-1.0571,0.82167,0.00037,1.733,0.27551,1.733,1.0636z'/%3E %3Cpath fill='%238cbebf' d='m412.61,275.71c0,0.74211-0.49887,1.1637-1.2522,1.1637-0.75392,0-1.4758-0.42166-1.4758-1.1637,0-0.73831,0.64506-1.0442,1.3968-1.0442,0.7491,0,1.3312,0.30583,1.3312,1.0442z'/%3E %3Cpath d='m413.12,271.39s2.1673-0.21761,2.5525,0.17266c0.3863,0.38918,0.34201,0.9483,0.17073,1.1226-0.17073,0.1732-1.0238,0.21596-1.2352-0.0839-0.21128-0.30474-1.4881-1.2114-1.4881-1.2114z'/%3E %3Cpath d='m410.99,264.39s1.662,0.42869,2.3423,1.121c0.68188,0.69231,0.55541,1.3857,0.42843,1.514-0.12912,0.12666-0.72666,0.26035-1.1935-0.25766-0.46793-0.51908-1.5772-2.3773-1.5772-2.3773z'/%3E %3Cpath d='m406.05,267.76s1.9384,1.0571,2.3647,1.6601c0.42684,0.60517,0.53303,1.0836,0.34147,1.3392-0.19261,0.26036-1.1524-0.0644-1.3002-0.38756-0.14779-0.3226-1.4059-2.6117-1.4059-2.6117z'/%3E %3Cpath d='m405.2,269.25s2.1721,0.282,2.7051,0.69065c0.53249,0.41246,0.91613,0.43356,0.87291,0.75617-0.0416,0.3253-0.27531,0.56561-0.61734,0.51962-0.34148-0.0444-1.2784-0.45521-1.4902-0.6479-0.21395-0.19433-1.4705-1.3186-1.4705-1.3186z'/%3E %3Cpath d='m402.7,262.89s2.2164,0.34804,2.671,0.69231c0.45458,0.34804,0.56824,1.3288,0.056,1.6174-0.51114,0.28308-1.0783-0.28852-1.2491-0.69231-0.17127-0.4038-1.4779-1.6174-1.4779-1.6174z'/%3E %3Cpath d='m397.92,266.24s2.0382,0.96945,2.671,1.8712c0.34148,0.48606,0.63973,0.90502,0,1.1242-0.58421,0.19431-1.192-0.86388-1.192-1.1242,0-0.25874-1.479-1.8712-1.479-1.8712z'/%3E %3Cpath d='m397.47,268.89s1.3051-0.28851,1.9314-0.28851c0.62317,0,1.5222-0.21704,1.5334,0.28851,0.009,0.50664-0.76567,0.6019-1.2272,0.45684-0.45512-0.15535-2.2377-0.45684-2.2377-0.45684z'/%3E %3Cpath d='m408.75,276.17s1.4273-0.88878,2.1294-0.73671c0.70375,0.15317,0.93692,0.0888,0.93692,0.51909,0,0.43248-0.83075,0.34641-1.0874,0.34641-0.25557-0.00036-1.9789-0.12882-1.9789-0.12882z'/%3E %3Cpath d='m400.85,275.02s0.55167-0.82113,1.1487-0.90342c0.5965-0.0893,0.85154-0.0449,0.93692,0.21109,0.0854,0.26361-0.51061,0.73672-0.76722,0.73672-0.2545,0-1.3184-0.0444-1.3184-0.0444z'/%3E %3Cpath fill='%2304534e' d='m423.43,273.58s-2.171,2.6133-5.1968,3.9113c-3.0236,1.2975-5.3238,1.7261-9.5418,1.4674-4.2161-0.25872-6.2606-0.90662-9.1154-2.3741-2.854-1.4696-5.1114-3.5865-5.5382-4.4948-0.42418-0.91041,0.46952,1.5134,0.46952,1.5134l2.5989,3.4101,3.109,1.3852,4.5576,1.121,4.3026,0.51963,3.2781-0.0823,3.9211-0.61057,2.512-0.90175,1.7052-1.0404,1.3216-1.0831,1.6167-2.741z'/%3E %3Cpath fill='%2304534e' d='m419.37,265.86s-1.1807,0.39135-3.7781-1.2114c-2.6-1.5963-5.7107-3.6737-11.589-3.7148-5.8774-0.0412-7.7507,3.979-8.1354,4.2766-0.38415,0.30366,2.6395-3.4972,2.6395-3.4972l2.6848-1.4279,2.0878-0.34642,2.0024,0.0872,2.5978,0.69285,2.3428,0.73344,2.7286,0.90662,2.3828,1.3045,2.8801,1.5031,1.1562,0.69337z'/%3E %3Cpath fill='%2304534e' d='m427.26,267.59s-3.4489-0.0449-4.429,0.0412c-0.98335,0.0855-1.0239,0.25982-1.1541,0.51909-0.12804,0.25928-0.38203,0.60517-0.38203,0.60517l-1.0644-2.2918,4.6856-0.64952,2.5514,0.95482-0.20754,0.82113z'/%3E %3Cpath fill='%230c8489' stroke='%2304534e' stroke-width='0.7' d='m420.91,291.7c0.2369,0.62846,0.78325,1.199,1.4694,1.2152,0.68723,0.02,2.1321-0.0265,2.1321-0.0265l4.6643-0.27876,1.6401-1.8815,1.0009-4.2144s1.2597-1.5313,1.2597-1.5957,4.3426-2.3995,4.3426-2.3995l3.7509-1.0815,2.4058-0.2571,3.3192-1.1015,2.4522-1.2758,1.065-1.5784,1.0415-2.3974-1.0415-3.2434-2.6005-3.4772-4.4044-1.7927h-3.6473l-4.0875,1.4907-7.1983,1.7045s-3.9627,1.7278-5.6039,4.818c-1.6348,3.0896-1.6156,3.8924-1.8919,7.9736-0.28011,4.0872-0.0683,9.3991-0.0683,9.3991z'/%3E %3Cpath fill='%238cbebf' d='m422.86,290.09c1.3782,0,0.31373-2.2788,1.877-4.9879,1.5622-2.7037,3.4638-5.9928,3.9461-5.9928,0.48232,0,0.56396,0.49256,1.1327,0.32152,0.56878-0.17267,1.5377-1.0387,1.5942-1.2715,0.0565-0.22895,0.0565-1.7559,1.2469-2.7356,1.1957-0.98132,2.87-2.3627,3.6628-2.5359,0.79661-0.16833,1.1674-0.31664,1.3083,0.0574,0.14193,0.37404-0.45619,0.89364,0.0864,1.0669,0.53944,0.17482,1.7895,0.11745,2.1001-0.69231,0.31213-0.80762,0.22729-1.2363,0.22729-1.2363s0.82435-0.8065,2.3866-0.46225c1.5633,0.34641,1.7586,0.25764,1.901,0.86607,0.14138,0.60296-0.71176,0.68905-0.53944,1.1226,0.1686,0.42871-0.11738,0.38269,0.0422,0.7107,0.159,0.32693,0.40977,1.2471,1.4593,1.219,1.0548-0.0281,1.5078-0.63492,1.5078-0.63492l0.30892-0.55377s0.28919-0.65496-0.11045-0.91367c-0.39963-0.26036-0.25556-0.57701,0.143-0.40435,0.39643,0.17322,1.9864,2.3908,2.5274,1.4674,0.54159-0.91965,0.59811-2.2176,0.31213-2.5326-0.28438-0.31828-2.5274-3.6899-2.5274-3.6899l-4.0048-1.3537-5.3078,0.43572-5.1423,2.9365-4.7134,2.5067s-0.25663,3.8583-1.1087,3.1686c-0.85154-0.69231-2.0739-2.5922-2.4394-1.9589-0.37188,0.63492-1.1941,3.4561-1.6775,4.8656-0.48392,1.4127-1.8738,5.7642-1.734,7.3789,0.14406,1.6124,1.026,3.8334,1.535,3.8334z'/%3E %3Cpath fill='%238cbebf' d='m427.6,283.85c-0.37189,0.0281-0.91026,0.40379-1.0788,0.61814-0.17233,0.21758-0.41136,0.67986-0.25663,1.1827,0.15579,0.50285,0.89369,0.99435,0.95241,1.0517l0.59117-0.0163,1.2789-0.37241s0.40818-0.4617,0.43112-1.0636c0.0262-0.60843-0.34468-0.76648-0.52662-0.8244-0.18727-0.0568-1.3915-0.57592-1.3915-0.57592z'/%3E %3Cpath fill='%238cbebf' d='m435.72,277.14c-0.72619-0.25873-1.0468,0.23599-1.1717,0.45197-0.12805,0.21759-0.0731,0.7437-0.0731,0.7437s0.15953,1.0052,0.54158,1.1919c0.38202,0.18133,1.3862,0.52938,1.7009,0.18133,0.32333-0.34155,0.6472-0.58187,0.62583-1.2298-0.0176-0.6495-0.92142-0.96945-0.92142-0.96945l-0.70213-0.3697z'/%3E %3Cpath fill='%238cbebf' d='m442.26,278.71c-0.031-0.24737-0.6696-0.42058-1.0954-0.3448-0.42577,0.0742-0.99612,0.61649-0.79286,1.4393,0.19474,0.81952,0.978,0.89203,1.5895,0.73505,0.60986-0.15967,0.49407-1.0257,0.49407-1.1524-0.00037-0.12775-0.19528-0.67714-0.19528-0.67714z'/%3E %3Cpath fill='%238cbebf' d='m423.37,280.03c0,0.37402,0.68082,1.154,1.5926,1.0961,0.90544-0.0574,1.471-0.75023,1.5622-1.2964,0.0811-0.54938-0.48446,0.45847-1.1674,0.63332-0.67922,0.17105-1.0778,0.34642-1.391-0.0298-0.31213-0.37348-0.5965-0.40325-0.5965-0.40325z'/%3E %3Cpath fill='%2304534e' d='m429.52,285.25s0.0976,0.83411-0.50367,1.2666c-0.60132,0.43194-0.98549,0.38755-1.3328,0.38755-0.34628,0-0.72298-0.0709-0.97534-0.41733-0.25344-0.3464-0.44178-0.83571-0.44178-0.83571s0.6632,1.0918,1.7063,0.80435c1.0436-0.28525,1.5473-1.2054,1.5473-1.2054z'/%3E %3Cpath fill='%2304534e' d='m447.11,274.35s-0.009,0.84063-0.66319,1.1886c-0.64988,0.34806-0.94546,0.44819-1.2917,0.4038-0.3436-0.0466-0.82114-0.18674-1.0484-0.54938-0.77203-1.2054-0.31533-1.9935-0.31533-1.9935s0.55541,2.092,1.6284,1.9459c1.073-0.14776,1.6903-0.99542,1.6903-0.99542z'/%3E %3Cpath fill='%2304534e' d='m431.43,278.1s-0.53624,1.6406-1.6188,1.6406c-1.0762,0-0.98816-0.3134-0.90865-0.51964,0.0896-0.19756,0.48606,0.20624,0.96732,0.059,0.48447-0.14127,1.5601-1.18,1.5601-1.18z'/%3E %3Cpath fill='%2304534e' d='m434.47,277.81s-0.11044,1.1886,0.28758,1.5897c0.39804,0.40543,0.85314,0.61002,1.3083,0.61002,0.45511,0,0.79607-0.11907,1.1343-0.577,0.34148-0.46171,0.14138-0.95322,0.14138-0.95322s0.007,0.24901-0.33293,0.59379c-0.34307,0.34642-0.62103,0.40218-0.96251,0.40218-0.33987,0-0.92249-0.0427-1.0954-0.44495-0.17287-0.40217-0.48073-1.2206-0.48073-1.2206z'/%3E %3Cpath fill='%2304534e' d='m440.04,272.09s0.34201,0.89037-0.34148,1.6124c-0.67868,0.72047-1.9859,0.31666-1.9859,0.31666s1.0516,0.25765,1.5633-0.31666c0.51114-0.57699,0.76406-1.6124,0.76406-1.6124z'/%3E %3Cpath fill='%2304534e' d='m422.26,292.59s6.9124-0.11691,7.4681-1.0685c0.55114-0.94835-0.59811-4.6664,3.5774-7.6027,4.1718-2.9381,7.413-2.8975,9.6262-3.0718,2.2153-0.17159,6.9984-1.6617,7.8384-5.9164,0.50902-2.5954-2.9825-2.7681-4.302-5.2298-1.3211-2.4639-4.7273-1.468-4.8985-1.468-0.1686,0-3.9541-0.10989-5.7503,1.6406-1.0676,1.0387-0.93799,2.3345-1.4496,2.9386-0.51221,0.60464-5.0708,0-5.5798,0.73506-0.51168,0.73345,0.12698,2.2869-0.21608,2.6344-0.33615,0.34479-1.4448-0.99596-1.4448-0.99596l0.38201-3.6715,5.8379-3.4133,6.6404-3.6737s4.349,0.21434,4.5186,0.13045c0.17181-0.0893,4.4727,2.2452,4.5992,2.2896,0.12698,0.0449,2.2564,2.5938,2.2564,2.5938s0.41884,1.0404,0.59812,3.0653c0.0859,0.964,0.005,1.7922-0.20488,2.5473-1.0746,3.8252-4.8206,6.3973-8.766,6.5924-3.9429,0.19757-7.4975,1.9784-9.2981,3.2839-1.804,1.3077-2.7014,7.0652-2.727,7.7561-0.0245,0.69065-8.5912,0.22248-8.5912,0.22248l-0.11524-0.31829z'/%3E %3Cpath d='m425.17,279.13c-0.35109,0.28201-0.87131,0.26523-0.98335-0.13208-0.31748-1.1307,0.35587-2.8065,0.35587-2.8065s-0.0165,1.7543,0.11364,2.0444c0.13019,0.28851,0.48074,0.22247,0.63867,0.46226,0.0571,0.0828,0.1542,0.20515-0.12485,0.43194z'/%3E %3Cpath d='m429.52,278.24c-0.33454-0.10338-0.27638-1.167-0.0224-1.6222,0.25664-0.45196,2.1971-1.8815,2.1971-1.8815s-0.61889,1.4295-0.85527,1.9492c-0.23369,0.51584-0.8969,1.6845-1.3195,1.5545z'/%3E %3Cpath d='m427.81,285.26c-0.27159,0.0574-0.36069-0.54238-0.36069-1.2991,0-0.75562,1.3227-2.137,1.3227-2.137s-0.40498,1.2119-0.45032,1.5963c-0.0406,0.39081,0.21609,0.73671,0.1702,1.1919-0.0411,0.45197-0.37935,0.58353-0.68188,0.64791z'/%3E %3Cpath d='m431.03,283.32s-0.61734,0.71394-1.3227,1.1031c-0.69893,0.38595-1.4641,0.96945-1.8952,0.84277-0.42258-0.13207,0.27318-1.0517,0.5122-1.1475,1.1941-0.47362,2.7057-0.79837,2.7057-0.79837z'/%3E %3Cpath d='m436.95,274.87s-0.78539,0.65117-1.1685,1.5762c-0.38523,0.92991-0.55435,1.6883-0.17074,1.8604,0.38736,0.17266,0.95771-1.0604,1.0031-1.4712,0.0406-0.40868,0.33612-1.9654,0.33612-1.9654z'/%3E %3Cpath d='m439.12,277.83s-0.55221-0.51584-1.534-0.75349c-0.97693-0.24086-1.4256-0.0217-1.5313,0.25873-0.10725,0.27931-0.83236,0.72422-0.46954,0.93965,0.36229,0.21435,0.78699-0.37727,1.0852-0.44493,0.30092-0.0644,0.6424-0.28039,1.1717-0.1927,0.53143,0.0871,1.2779,0.1927,1.2779,0.1927z'/%3E %3Cpath d='m437.85,272.03c0.34734,0.30204,0.87767-0.25981,1.3654-0.80756,0.48073-0.54777,0.85047-1.5567,0.85047-1.5567s-0.99666,0.51962-1.4192,0.86607c-0.42951,0.34425-0.99505,1.3256-0.79661,1.4982z'/%3E %3Cpath d='m446.88,271.82s-1.1626,0.55051-1.5606,1.0669c-0.39802,0.5191-0.91025,1.0934-0.51167,1.3819,0.39803,0.2885,0.76194-0.25765,1.0804-0.68905,0.30838-0.43248,0.99184-1.7597,0.99184-1.7597z'/%3E %3Cpath d='m444.3,277.87s-0.39483,0.80815-1.1327,1.2963c-0.73789,0.49312-1.6204,0.72047-1.7586,0.4601-0.14618-0.25712,0.11366-0.80757,0.39323-0.94777,0.28919-0.14561,0.4578-0.11745,1.1082-0.28852,0.65363-0.17212,1.3899-0.52015,1.3899-0.52015z'/%3E %3C/g%3E %3Cg id='blooms'%3E %3Cellipse fill='url(%23rg1)' cx='385.5514' cy='257.828' rx='3.7691' ry='5.631' transform='rotate(8.6669,385.5514,257.828)'/%3E %3Cg fill='%23fcca3e' stroke='%23aa8c30'%3E %3Cpath stroke-width='0.35' d='m387.66,247.73,0,0-2.2409,5.602,1.8301-0.25439,1.0564-4.9309z'/%3E %3Cpath stroke-width='0.3' d='m388.7,245.35c-0.79714-0.10067-1.5302,0.50666-1.6337,1.3608-0.10404,0.8487,0.45832,1.6174,1.256,1.7213,0.79927,0.0991,1.5286-0.51097,1.6342-1.3586,0.10297-0.85143-0.45671-1.6195-1.2565-1.7234z'/%3E %3Cpath stroke-width='0.35' d='m485.22,259.35,0,0-5.5222,5.1798,2.2783,0.57915,3.7882-4.9904z'/%3E %3Cpath stroke-width='0.3' d='m487.68,257.21c-0.88407-0.48823-2.0542-0.15534-2.6165,0.74318-0.56558,0.8953-0.3036,2.0184,0.57887,2.5045,0.88407,0.48824,2.0542,0.15536,2.6197-0.74157,0.56236-0.8969,0.30252-2.0195-0.58213-2.5061z'/%3E %3Cpath stroke-width='0.35' d='m344.88,229.45,0,0,2.9132,6.4193,1.2538-1.7862-3.2973-4.8605z'/%3E %3Cpath stroke-width='0.3' d='m343.71,226.65c-0.72298,0.61328-0.79821,1.731-0.16648,2.4996,0.63065,0.77674,1.7287,0.90503,2.4532,0.29501,0.72244-0.60843,0.79821-1.731,0.16753-2.4996-0.63224-0.77293-1.7292-0.90501-2.4543-0.29499z'/%3E %3C/g%3E %3Cg fill='%23aa8c30'%3E %3Cpath d='m389.25,245.56s0.45031,0.24358-0.0694,0.0839c-0.52287-0.1586-1.7586,0.44167-1.7607,1.3142,0,0.8736,0.64667,1.3586,1.3008,1.3651,0.65518,0.006-0.24223,0.11854-0.24223,0.11854l-0.84251-0.24736-0.34948-0.50772-0.27958-0.70423,0.21556-0.7567,0.49674-0.64464,0.64935-0.23438,0.43003,0.0514,0.45139,0.16184z'/%3E %3Cpath d='m387.99,249.33s-0.35641-0.0725-0.67922,0.40759c-0.32012,0.47957-0.97266,1.3852-0.97266,1.3852l1.2512-3.0815,0.68188,0.35617-0.28118,0.93264z'/%3E %3Cpath d='m488.22,257.69s0.40335,0.48498-0.12645,0.0611c-0.52983-0.42219-2.2868-0.33992-2.7435,0.63168-0.45832,0.97431,0.0555,1.8166,0.81525,2.1316,0.76568,0.31665-0.34147,0.0195-0.34147,0.0195l-0.86115-0.67066-0.143-0.73073,0.031-0.92019,0.64507-0.73672,0.92041-0.48174,0.88033,0.0412,0.47486,0.26685,0.44873,0.38809z'/%3E %3Cpath d='m484.78,261.3s-0.38202-0.2544-1.0095,0.13153c-0.62423,0.38432-1.8562,1.0831-1.8562,1.0831l3.0604-2.8406,0.61574,0.71882-0.81045,0.90721z'/%3E %3Cpath d='m344.33,226.33s0.56398-0.19756,0.0123,0.12883c-0.55006,0.32477-1.0377,1.8728-0.30465,2.5738,0.73362,0.70257,1.6604,0.52939,2.1886-0.0314,0.53088-0.56075-0.0939,0.30474-0.0939,0.30474l-0.88193,0.531-0.70587-0.10879-0.81846-0.3199-0.46153-0.78812-0.14246-0.94995,0.32227-0.75023,0.39003-0.3264,0.49565-0.2636z'/%3E %3Cpath d='m346.49,230.45s-0.34788,0.25223-0.20329,0.91154c0.1494,0.66468,0.38682,1.9508,0.38682,1.9508l-1.5889-3.5464,0.84566-0.30853,0.5597,0.9927z'/%3E %3C/g%3E %3Cellipse fill='url(%23rg2)' cx='351.4697' cy='241.6067' rx='6.0604' ry='4.0788' transform='rotate(62.907,351.4697,241.6067)'/%3E %3Cg fill='%23e92736'%3E %3Cpath d='m344.65,240.24s1.2491,0.2885,1.9293-0.0574c0.68243-0.34643,0.79714-0.86607,0.96518-1.0338,0.1718-0.17321,0.34254-0.8076,0.28545-1.2119-0.0576-0.40379-0.96518-1.7857-1.2507-1.8994-0.28278-0.11692-1.2491,0-1.4171-0.17483-0.17074-0.17321,0.14139-0.54938-0.22942-0.63493-0.36816-0.0861-2.2697,2.0774-1.9309,2.4223,0.342,0.34263,0.53943-0.17158,0.6525,0.11691,0.11419,0.28363,0.0299,1.0918,0.0299,1.436,0,0.34588,0.96571,1.0371,0.96571,1.0371z'/%3E %3Cpath d='m346.5,236.2c0.14886,0.29987,0.85154,1.2368,1.136,1.3521,0.28438,0.11747,1.136,0.14832,1.4208,0.0335,0.28438-0.11583,1.1919-0.98131,1.2207-1.357,0.0283-0.37401,0-0.66142-0.16967-1.0387-0.16967-0.37456-0.0715-1.3803-0.41137-1.4376-0.34147-0.0579-0.49086-0.10392-0.66051-0.30203-0.17074-0.2046,0.10617-0.56402-0.15047-0.93643-0.2529-0.37727-3.2936,1.4117-3.0663,1.7559,0.22782,0.34642,0.53998-0.026,0.65251,0.20298,0.11311,0.2268-0.14245,1.3808,0.0283,1.7272z'/%3E %3Cpath d='m353.37,235.43c0.16968-0.45847,0.11312-1.9589-0.19848-2.2772-0.31212-0.31665-0.82487-0.34317-0.85314-0.54724-0.0266-0.19974,0.36976-0.28851,0.36976-0.63493,0-0.34318-3.379,0.1153-3.1517,0.49473,0.22782,0.37131,0.79661,0.17158,0.76674,0.39892-0.0283,0.23059-0.56878,0.51909-0.62478,0.80975-0.056,0.28689,0.17234,1.2401,0.31214,1.4674,0.14246,0.23437-0.0555,0.51801,0.34147,0.66309,0.39908,0.14506,0.3404,0.14506,0.71123,0.26035,0.36813,0.1153,1.7031,0.0563,1.8749-0.0893,0.167-0.14344,0.28171-0.0855,0.45191-0.54564z'/%3E %3Cpath d='m382.1,252.31s0.55434,0.96075,1.1669,1.1886c0.612,0.22734,0.99611-0.003,1.2037,0.003,0.20542,0.007,0.69312-0.2555,0.90705-0.52776,0.21449-0.27389,0.53142-1.6574,0.43645-1.9048-0.096-0.24737-0.73148-0.79297-0.7256-0.99756,0.006-0.21274,0.41883-0.23114,0.2561-0.51585-0.16433-0.28525-2.6026-0.22084-2.616,0.19594-0.0112,0.42005,0.42259,0.24251,0.31107,0.48175-0.10991,0.24195-0.65416,0.65929-0.86649,0.86062-0.21397,0.20189-0.0731,1.2157-0.0731,1.2157z'/%3E %3Cpath d='m385.66,251.11c-0.0998,0.26847-0.26412,1.2628-0.16701,1.5118,0.0966,0.24411,0.57781,0.80108,0.81312,0.91041,0.23743,0.11529,1.2997,0.18295,1.5452-0.0179,0.24864-0.19973,0.40869-0.38756,0.53784-0.71555,0.13072-0.32694,0.8067-0.85575,0.64454-1.1047-0.16434-0.24738-0.2241-0.36646-0.20009-0.59053,0.0235-0.23275,0.40657-0.26197,0.48661-0.64411,0.0795-0.38106-2.7953-1.2563-2.8742-0.91042-0.079,0.34643,0.33295,0.32314,0.25718,0.52937-0.0747,0.20677-0.9321,0.72261-1.0431,1.0317z'/%3E %3Cpath d='m390.16,255c0.38362-0.16184,1.272-1.0734,1.2827-1.4576,0.0118-0.38215-0.26838-0.72368-0.16272-0.85742,0.10616-0.13695,0.39162,0.0628,0.60612-0.1402,0.21129-0.19919-2.0488-2.0655-2.147-1.7028-0.0976,0.36265,0.35802,0.60349,0.20114,0.72046-0.15899,0.11583-0.65143-0.0574-0.86061,0.0779-0.21129,0.12993-0.66159,0.83252-0.71924,1.0566-0.0581,0.22409-0.35375,0.26902-0.20702,0.60351,0.14299,0.33614,0.10991,0.30041,0.25558,0.60137,0.14458,0.30203,0.95984,1.1102,1.1498,1.1329,0.18834,0.0249,0.21982,0.13045,0.60132-0.0346z'/%3E %3Cpath d='m476.9,262.25s0.0485,1.0701,0.46099,1.5513c0.41616,0.4785,0.83716,0.46659,1.0095,0.57055,0.17074,0.1023,0.69787,0.11041,0.99297-0.0163,0.29613-0.12991,1.1674-1.1459,1.1962-1.3998,0.0261-0.24899-0.26998-1.0089-0.17181-1.1827,0.096-0.17104,0.44817,0.004,0.43697-0.30962-0.0149-0.31827-2.0888-1.4165-2.2804-1.0701-0.19314,0.34643,0.24704,0.40056,0.0507,0.55211-0.19635,0.15156-0.84037,0.24249-1.1034,0.31177-0.2673,0.0709-0.59169,0.9927-0.59169,0.9927z'/%3E %3Cpath d='m480.26,262.95c-0.21448,0.15643-0.84197,0.82326-0.89102,1.0501-0.0486,0.22735,0.0523,0.86061,0.18408,1.0517,0.12965,0.19163,0.93638,0.72368,1.2336,0.68799,0.29932-0.0395,0.52022-0.10393,0.78699-0.29013,0.26996-0.18673,1.0697-0.27064,1.0644-0.53262-0.005-0.25873,0.0101-0.3789,0.14193-0.53208,0.13287-0.15859,0.45512-0.0103,0.70855-0.25928,0.25611-0.24574-1.5835-2.2079-1.8172-1.9833-0.23849,0.22246,0.096,0.39243-0.0651,0.51097-0.16272,0.11962-1.0991,0.1153-1.3462,0.29662z'/%3E %3Cpath d='m480.96,267.83c0.36442,0.14019,1.5574,0.13532,1.8205-0.0925,0.25986-0.22572,0.29615-0.61002,0.45673-0.623,0.1606-0.0163,0.21929,0.28362,0.49567,0.29391,0.2764,0.006,0-2.544-0.30199-2.3843-0.30412,0.16185-0.16593,0.59544-0.34466,0.56728-0.18195-0.0265-0.39963-0.43897-0.62745-0.48931-0.22569-0.0514-0.98815,0.0974-1.1796,0.19756-0.18408,0.10393-0.40819-0.0547-0.53303,0.24034-0.12485,0.2939-0.12485,0.25114-0.22623,0.52666-0.1019,0.27497-0.096,1.2774,0.016,1.4111,0.11098,0.12829,0.064,0.21543,0.42417,0.35238z'/%3E %3C/g%3E %3Cg fill='%23f7e204'%3E %3Cpath d='m346.72,237.45c0.27798,0.41732-0.0902,1.4214-0.31693,1.7061-0.22569,0.28363-1.7399-0.12992-1.7618-0.4103-0.0245-0.28362-0.13394-0.75834,0.064-1.0246,0.19901-0.26522,0.70856-0.8736,1.0938-0.79623,0.38362,0.0698,0.8222,0.38322,0.92089,0.52505z'/%3E %3Cpath d='m347.13,235.57c-0.17766,0.37944,0.0774,0.80815,0.27212,1.0171,0.19581,0.20785,1.2832,0.47849,1.5804,0.29878,0.29612-0.18295,0.75017-1.8685,0.5405-2.1288-0.20807-0.25929-0.79339-0.30367-0.98922-0.27552-0.19848,0.0352-1.28,0.82493-1.4038,1.0885z'/%3E %3Cpath d='m350.75,233.85c-0.14618,0.3448-0.0982,0.82112,0.0251,0.9678,0.12272,0.14831,0.83128,0.64464,1.2475,0.62354,0.4167-0.0265,0.61415-1.1941,0.61415-1.4182,0-0.22409-0.12326-0.31991-0.41778-0.44819-0.29185-0.12233-1.4689,0.27498-1.4689,0.27498z'/%3E %3Cpath d='m385.02,251.98c-0.0934,0.41732-0.92624,0.77513-1.232,0.79623-0.30893,0.0232-0.93959-1.1756-0.78058-1.3554,0.1606-0.17971,0.38683-0.52938,0.66693-0.55536,0.27798-0.0298,0.95081-0.066,1.1306,0.22246,0.17927,0.282,0.24597,0.74318,0.21502,0.89203z'/%3E %3Cpath d='m386.42,251.14c-0.34039,0.10826-0.45404,0.52232-0.46631,0.76968-0.0144,0.24411,0.45671,1.0902,0.74003,1.1692,0.28544,0.0823,1.5879-0.61868,1.6236-0.90395,0.0358-0.2831-0.27639-0.67933-0.41298-0.78432-0.13126-0.10554-1.2522-0.32639-1.4843-0.25061z'/%3E %3Cpath d='m389.59,252.43c-0.30039,0.10717-0.56077,0.41734-0.58262,0.58353-0.0187,0.16346,0.0923,0.90016,0.35108,1.1491,0.25824,0.24738,1.0895-0.30961,1.2277-0.44168,0.13552-0.13153,0.12699-0.26523,0.0304-0.5245-0.0944-0.26035-1.0266-0.76648-1.0266-0.76648z'/%3E %3Cpath d='m479.57,263.19c-0.25984,0.31124-1.1146,0.21922-1.3846,0.0888-0.26679-0.12395-0.27319-1.4312-0.0619-1.5069,0.21129-0.0758,0.55436-0.25873,0.80302-0.15317,0.24382,0.10392,0.82594,0.39729,0.85207,0.72045,0.0241,0.32477-0.12058,0.74211-0.20861,0.8509z'/%3E %3Cpath d='m480.84,263.31c-0.32332-0.0742-0.62263,0.18512-0.75605,0.35941-0.13499,0.17807-0.18514,1.0241-0.002,1.2087,0.18032,0.19269,1.5697,0.26361,1.741,0.0655,0.16861-0.19756,0.12059-0.63273,0.0683-0.77294-0.0523-0.13802-0.82915-0.813-1.0516-0.8606z'/%3E %3Cpath d='m482.29,265.9c-0.26999-0.11367-0.65042-0.0909-0.77364-0.005-0.11738,0.0909-0.53624,0.61222-0.52661,0.92506,0.009,0.31503,0.93318,0.48986,1.1087,0.49473,0.17874,0.009,0.26304-0.0823,0.37029-0.29878,0.10724-0.21707-0.17874-1.1156-0.17874-1.1156z'/%3E %3C/g%3E %3Cellipse fill='url(%23rg3)' cx='476.6946' cy='268.5685' rx='2.9385' ry='5.8621' transform='rotate(47.855,476.6946,268.5685)'/%3E %3C/g%3E %3Cg id='eagle_snake'%3E %3Cg id='snake1' fill='%2378732e'%3E %3Cpath fill='%23a8ac71' d='m375.12,185.22s-5.0261,0.43195-8.5191-0.1732c-3.4926-0.60517-2.7264-9.507-2.8124-9.7656-0.0838-0.25927-2.1294-2.4206-1.789-4.4076,0.34146-1.9881,6.7943-7.233,7.6679-7.5183,0.5965-0.19486,1.8738,0.34642,1.8738,0.34642s1.631-1.5865,2.115-1.5865c0.49834,0,1.1871,0.91528,0.99559,1.3061-0.19262,0.38755-2.4079,1.6834-2.5786,2.6777-0.17073,0.99376,0.0219,1.9881-0.61841,2.9597-0.63813,0.97267-1.8733,2.2902-2.0227,3.1113-0.14886,0.82112-0.5106,1.5351,0.10725,1.8371,0.61787,0.30311,2.727,0.0427,4.5368-0.77673,1.8088-0.82274,2.5541-1.9243,2.8102-1.8155,0.2561,0.10717-1.0436,2.2669-3.045,3.1118-2.0013,0.84224-3.3229,1.8138-4.3239,1.6634,0,0-1.1071,2.6582,2.3226,2.8082,3.4275,0.15155,5.3238-0.75563,5.3238-0.75563l-2.044,6.9776z'/%3E %3Cpath fill='%23a8ac71' d='m355.48,206.18s2.64,1.0354,2.64,3.9784c0,2.9365-2.8945,5.3982-2.8108,10.584,0.087,5.1871,0.89155,5.2385,7.7534,10.804,0.21343,0.17321,1.6615,1.6439,2.044,3.3305,0.38522,1.6818,1.6188,11.622,8.2231,11.576,6.6009-0.0412,7.4964-4.2306,7.4964-4.2306l-2.8118-4.15s-2.3012,0.68851-3.5364,0.38918c-1.2336-0.30366-2.3396-1.1248-3.0668-2.7221-0.72298-1.5995-0.92089-5.4083-2.044-7.0866-2.7686-4.1489-7.7101-4.8412-7.7523-9.2057-0.0432-4.366,3.0236-4.839,2.1716-10.027-0.851-5.1838-7.0284-7.6914-7.0284-7.6914l-2.5125-1.0155-0.87291,5.2072,2.1076,0.25874z'/%3E %3Cpath fill='%23f1a720' d='m373.67,169.89c2.2142-0.51747,0.93692-6.2905,0.93692-6.2905l-1.5329,1.2764s0.94815,1.233,0.94815,2.5592c0.00036,1.3267-0.35214,2.4547-0.35214,2.4547z'/%3E %3Cpath fill='%23a8ac71' d='m377.71,227.47s-1.0271-0.84443-1.129-0.91367c-0.79125-0.52613-4.2566-3.3273-3.7018-11.656,0.62584-9.4215,14.325-14.376,15.219-18.122,0.99244-4.1484,4.094-5.9608-6.8146-14.49l-2.5568,2.996,4.4733,3.357s0.98976-0.5559,1.0474,0.71395c0.0576,1.266-1.193,2.3546-1.5009,3.3473-0.28279,0.90662-7.0855,5.6327-7.5969,6.0944-0.51061,0.46171-3.9056,3.101-3.9056,3.101s-1.7709,1.7413-3.419,5.3998c-1.6455,3.6607-0.79714,8.3545-0.79714,8.3545s0.0539,10.003,10.681,11.817z'/%3E %3Cpath d='m371.03,232.74,0.76727,3.5432-2.1721,0.79836-0.93745-0.0412-0.6803,0.29987-1.6828,1.6244-0.42685-0.1337s-0.25557,0.0893-0.3404-0.94942c-0.0854-1.0355-0.23476-1.9443-0.23476-1.9443l2.0451,0.83952,0.72298,0.046,0.51167-0.17321,0.89476-1.9421,1.5329-1.9676z'/%3E %3Cpath d='m364.68,233.39s-0.68189-0.82113-1.0218-1.3175c-0.29078-0.42383-0.43645-0.52234-1.193-1.1264l1.4897-0.83898,1.5985,0.02-0.23476,1.9226-0.63867,1.3402z'/%3E %3Cpath d='m368.31,227.7s0.99933,0.49635,1.3206,1.2515c0.31852,0.75835,0.78752,1.6866,0.78752,1.6866l-2.5338-0.19161-1.9389-0.61003,1.257-1.7494,1.1076-0.38702z'/%3E %3Cpath d='m367.32,243.37s-0.51275-0.32152-0.81045-1.1405c-0.29932-0.82327-0.53355-2.1418-0.53355-2.1418l1.6839-0.32152,1.98,0.79623,0.55541,0.0466s-0.46899,0.99217-0.53301,1.0371c-0.0635,0.0427-1.9171,1.6601-1.9171,1.6601l-0.42525,0.0639z'/%3E %3Cpath d='m374.04,237.94s-1.4881-0.4682-1.7244-1.1686c-0.25452-0.75402-0.44765-0.6019-0.44765-0.6019l-0.46686,2.0066-0.59758,1.8815s0.12751,0.32368,0.1942,0.32368c0.0619,0,1.4251-0.34642,1.5121-0.38756,0.0843-0.0412,1.1253-1.1248,1.1482-1.1886,0.0213-0.065,0.38204-0.86495,0.38204-0.86495z'/%3E %3Cpath d='m367.77,244.25s0.74536,0.41029,1.7879,1.0155c1.0447,0.60351,1.6626,0.60351,1.6626,0.60351l0.78752-0.84118,0.80885-1.5995,0.10671-0.19433-4.0251,0.36428-1.1285,0.65171z'/%3E %3Cpath d='m373.59,242.7,3.4313-2.0542,0.23262-1.8555-0.68029-0.52071s0.12859,0.0639-0.80831,0.0639h-1.1728l-0.61782,2.2707-0.3847,2.0958z'/%3E %3Cpath d='m371.14,245.94s2.4047,1.0355,6.5582-0.47632c1.8813-0.68419,2.2372-1.5979,2.2372-1.5979l-1.662-0.64578-1.574,1.4046-5.5595,1.3153z'/%3E %3Cpath d='m367.86,219.31s-0.24277-0.77513-0.47859-1.7889c-0.23316-1.0155-0.21342-1.4479-0.21342-1.4479l1.2229,0.63492,1.7677,1.3159-1.257,0.99756-1.0415,0.2885z'/%3E %3Cpath d='m370.75,224.2s-0.59811-0.60517-1.1092-1.3797c-0.51061-0.77999-0.86542-1.5004-0.86542-1.5004l1.2997,0.26847,1.5132,0.73073-0.66853,1.9556-0.16967-0.0747z'/%3E %3Cpath fill='%23c6c7a6' d='m363.02,169.18c-0.22836,0.83572-0.54051,2.3627,0.62477,2.6512,0.63065,0.1548,3.1276-0.0514,5.9629-3.2845,1.3643-1.5562,1.3904-3.0853,1.3904-3.0853l0.54052-1.7543s-1.1076-0.80815-2.8972,0.31502c-1.6086,1.0106-5.6215,5.1579-5.6215,5.1579z'/%3E %3Cellipse fill='%231c242f' cx='370.771' cy='164.639' rx='0.502' ry='0.531'/%3E %3Cpath fill='%23a8ac71' d='m367.16,165.17c-1.2112,0.94509-2.3428,2.1619-2.3428,2.1619s1.9155-0.54238,3.4393-1.9259c0.86489-0.78485,2.5514-1.0902,3.4387-0.88391,0.46152,0.10554,0.30092-0.48986,0.0854-0.6593-0.49674-0.39405-1.8818-0.59216-2.1838-0.36266-0.0422,0.0325-1.2181,0.71828-2.4367,1.6698z'/%3E %3Cpath d='m372.92,218.3s-0.0838-0.39893-0.13765-1.3933c-0.0544-0.99436,0.0592-1.4923,0.0592-1.4923l-1.1349,0.9857-1.0868,1.5118,1.6823,0.6035,0.61788-0.21543z'/%3E %3Cpath d='m367.04,214.94s-0.1558-1.5465-0.0704-3.0138c0.0838-1.4674,0.68027-4.1354,0.68027-4.1354l0.71818,1.8252,2.0648,3.2185,0.66051,0.47633-1.7468,1.2764-1.7874,0.58187-0.51914-0.22897z'/%3E %3Cpath d='m372.96,214.12s0.10457-0.73345,0.28706-1.4127c0.17554-0.66469,0.69465-1.7278,0.69465-1.7278s0.0283,0.1088-0.0571,0.12666c-0.0843,0.0232-1.8104,1.4512-1.853,1.5134-0.0422,0.066-0.80831,0.73345-0.80831,0.73345l1.0847,0.82439,0.7-0.0412'/%3E %3Cpath d='m368.19,206.48s0.2625-0.96454,1.178-2.1316c0.91507-1.1659,1.8178-2.3627,1.8178-2.3627l0.78058,3.1346,0.46792,2.6761,0.0843,0.56563s-0.63706,0.28201-0.89316,0.25873c-0.25663-0.0217-2.1732-0.13207-2.4079-0.45521-0.23209-0.3237-1.0276-1.6856-1.0276-1.6856z'/%3E %3Cpath d='m374.4,210.13s0.58155-0.61815,1.0927-1.0918c0.51061-0.47795,1.3243-1.3949,1.3243-1.3949l-4.2076,0.76973,0.59704,1.423,1.1936,0.29391z'/%3E %3Cpath d='m371.86,201.43s0.39003-0.13856,1.5201-1.2812c1.1269-1.1475,1.7031-1.0089,1.7031-1.0089l0.46952,4.5159-2.2153-0.64952-1.4774-1.5762z'/%3E %3Cpath d='m377.1,207.36,0,0,2.5344-2.571-4.215-1.207,0.76831,2.9607z'/%3E %3Cpath d='m378.87,200.56,0.25556-4.3644s-0.85901,0.40218-1.9459,1.3088c-1.0847,0.90662-1.5895,1.1951-1.5895,1.1951l0.51008,0.77999,1.4913,0.97107,1.2784,0.10933z'/%3E %3Cpath d='m382.62,196.33,0.006-3.4361-0.14779,0.066s-0.60453,0.92992-1.3056,1.5118c-0.70375,0.58347-1.0234,0.99377-1.0234,0.99377l1.1296,0.73558,1.3408,0.12885z'/%3E %3Cpath d='m384.19,200.93s1.1882-0.98784,2.0568-1.6736c1.2986-1.029,1.9469-2.15,1.9469-2.15l-5.451-0.41245,0.21289,2.183,1.2346,2.0531z'/%3E %3Cpath d='m371.51,182.88-0.17074,2.3924,0,0,4.5458-0.0271-1.1098-1.5264-1.3872-0.86601-1.3072-1.3261z'/%3E %3Cpath d='m380.29,204.19c0.23956-0.17971,1.423-1.0669,1.9795-1.6325,0.61787-0.62681,1.5873-1.2531,1.5873-1.2531l-4.3233-0.47631,0.0854,2.8542,0.67121,0.50771z'/%3E %3Cpath d='m388.52,196.4s0.46418-1.7397,0.4199-3.4036c-0.0422-1.6634-0.31372-2.4071-0.31372-2.4071l-3.2366,2.203,0.46739,1.6422,1.2368,1.3408,1.4262,0.62461z'/%3E %3Cpath d='m382.98,192.4s0.95824-1.1594,1.0218-1.8284c0.0645-0.66955,0.0576-0.46171,0.0576-0.46171l2.5568,0.0427,1.5318,0.12882,0.19154,0.15318-1.1492,1.3602-1.5767,0.90663-2.0227,0.23925-0.61093-0.54073z'/%3E %3Cpath d='m388.16,189.85s-0.99985-1.7164-1.566-2.6696c-0.56344-0.94996-1.1183-1.403-1.1183-1.403l-1.2474,3.7132-0.12592,0.3594h4.0577z'/%3E %3Cpath fill='%23fff' d='m356.53,215.28-0.48874,1.0338s1.7031-0.88391,3.0247-0.83898c1.319,0.0427,2.7899,1.6866,2.7899,1.6866l0.31906-1.1941s-1.7468-1.705-2.8971-1.7873c-1.1514-0.0888-2.7478,1.0999-2.7478,1.0999zm0.85154-7.6257s0.36334,0.43033,0.44764,0.55917c0.0843,0.13044,0.12806-1.2742,1.8519-2.0082,1.7255-0.73558,2.664-0.15156,2.664-0.15156s-0.34147-0.99436-1.106-1.2103c-0.76781-0.21759-1.5132-0.0644-2.4516,0.60516-0.93638,0.67067-1.4059,2.2058-1.4059,2.2058zm5.8571,5.7423s-0.8083-1.7229-2.2132-2.0694c-1.4075-0.34641-3.196,0.73073-3.196,0.73073l-0.29665,0.90988s1.9155-1.0831,3.3214-0.51908c1.4059,0.56075,1.9592,2.1619,1.9592,2.1619l0.42524-1.2141zm-6.5795-6.6955c0.0843,0.30367,0.42577,0.68905,0.42577,0.68905s-0.19262-1.855,0.65998-2.8065c0.8526-0.95102,1.4902-1.2958,1.4902-1.2958l-0.78859-0.41245s-1.1279,0.75669-1.5132,1.5784c-0.38255,0.82113-0.35961,1.9443-0.27424,2.2474zm-0.76087-3.0387c0.39644-0.9218,1.5692-1.3256,1.5692-1.3256s-0.11899-0.20406-0.38309-0.34641c-0.26679-0.14182-0.54265,0.0114-0.54265,0.0114s-0.75659,0.39243-1.2122,1.4295c-0.45299,1.0355-0.3959,2.5343-0.3959,2.5343l0.70214,0.3908c0.00037,0.00054-0.13552-1.7722,0.2625-2.694zm10.337-25.064c1.0799-0.57702,1.8749-0.46172,1.8749-0.46172s-1.5942,1.6785-0.8254,3.7679c-0.90438,1.7511-1.1893,3.0815-1.1893,3.0815h0.85046s0.28812-1.3635,0.62423-2.4368c0.9225,1.7857,2.4714,2.7898,2.4714,2.7898l1.3056-0.0574s0.002-1.7397,0.6728-3.2547l0.12484,0.14181c1.4171,1.4988,2.6112,1.8469,2.6112,1.8469l0.0144-0.44711s-1.4913-0.87906-2.3428-2.0314l-0.0843-0.12395,0.0251-0.0493c1.0239-1.6124,2.3876-2.1316,2.3876-2.1316l0.90865,0.75023,0.22571-0.2885-0.68083-0.86387-0.78753,0.0217s-1.4118,1.1773-2.3226,2.2046c-0.65415-1.0225-1.0345-2.0542-1.0345-2.0542l-0.58368-0.21435s-1.4144,0.16347-2.6805,2.2079c-0.15688-1.5004,1.5734-3.1378,1.5734-3.1378l-0.0854-0.6268s-1.7479,0.32965-3.1101,0.73345c-1.3622,0.40433-2.1934,1.6866-2.1934,1.6866l-0.056,0.92019c-0.00036-0.00036,1.2266-1.3971,2.306-1.9729zm1.8744,2.7654c0.79501-1.1524,2.5557-1.901,2.5557-1.901s0.0448,0.93318,1.0143,2.1733c-0.66158,1.1621-0.95716,2.9532-0.95716,2.9532s-1.3627-0.86228-2.5552-2.5922c-0.087-0.12504-0.15366-0.25549-0.20968-0.38756,0.0486-0.0861,0.0987-0.16996,0.15206-0.24574zm-9.9388,27.758,0.064,1.0122s1.0436-1.141,2.6192-1.1854c1.5766-0.0449,2.9191,1.1854,2.9191,1.1854s0.0197-1.3586-0.19261-1.4858c-0.21289-0.13208-1.4913-0.86714-2.6843-0.86714-1.192,0-2.7254,1.3408-2.7254,1.3408zm28.115-14.739c-0.20754-0.37619-0.43323-0.90342-0.61199-1.3489,0.23796-0.0893,0.47379-0.20947,0.69626-0.37619,1.3216-0.99597,2.2575-2.0742,2.2575-2.0742l-0.46846-0.73505h-2.1294c-0.41777,0-1.304-0.10555-1.805-0.16996,0.0934-0.32639,0.35587-1.2433,0.66319-2.1965,0.38415-1.1886,0.72987-1.8268,0.72987-1.8268l-0.72405-0.73345s0.17073,0.67607-1.1076,0.84929c-1.2779,0.17321-3.6351-1.0355-3.6351-1.0355v0.518s2.0734,0.66309,3.2654,0.83572c0.70428,0.1023,1.2549-0.13856,1.59-0.35129-0.18353,0.37782-0.52074,1.1167-0.70214,1.776-0.15526,0.56562-0.37775,0.93478-0.36227,1.1805,0.01,0.15967,0.24223,0.30366,0.24223,0.30366l-0.11365,1.1096s1.2784,0.17158,1.8733,0.17158c0.59704,0,2.2153,0.13045,2.2153,0.13045s-1.1508,1.3408-2.2575,1.8582c-0.14619,0.0693-0.29933,0.12341-0.45993,0.16942-0.0587-0.15643-1.3222-2.0839-1.3222-2.0839l-0.12752,0.71235s0.90385,1.2412,0.99404,1.5037c-0.81686,0.10879-1.9944-0.17104-1.9944-0.17104l-0.51114,0.56236s-0.0363,1.5995,0.0123,3.2547c-1.1044-0.30041-2.3412-0.74857-2.3412-0.74857l-0.45671,0.34642,0.0224-0.0806-0.58796,0.46982s-0.51167,1.9421-0.38254,4.1484l0.007,0.11205c-2.1006-0.52071-3.1602-1.7559-3.1602-1.7559l-0.51114,0.43357s-0.34414,1.9042,0.13019,4.2031c-1.7943-0.35616-3.3534-1.9129-3.3534-1.9129l-0.66693,0.56076s0.39803,3.7181,0.82273,5.7476c0.0352,0.17322,0.0848,0.32315,0.13019,0.47634-0.35161,0.0379-0.68669,0.0574-0.98228,0.0427-1.8301-0.0877-2.9671-1.7727-2.9671-1.7727l-0.54051,1.3094s0.69733,3.5746,2.6987,5.1741c0.16168,0.12882,0.31107,0.24736,0.45086,0.35942-1.71,1.3965-3.7594,1.6157-3.7594,1.6157l0.12591,1.1275s1.2229,0.95808,2.4148,1.7825c0.11791,0.0758,0.24223,0.15319,0.37242,0.22084-0.95081,0.8493-2.1155,1.1941-2.1155,1.1941l0.31265,0.74698s1.5831-1.1048,2.3167-1.7002c1.0607,0.42707,2.4564,0.59539,2.4564,0.59539v-0.60677s-1.0265-0.092-1.9784-0.39567l0.13926-0.12883c0.59651-0.577,1.7607-2.3611,1.7607-2.3611l0.11204-1.2964s-0.73253-0.10393-1.527-0.7367c2.4164-1.652,2.5088-2.4038,2.5088-2.4038l0.45512-0.85415s-0.81525-0.35075-1.4171-1.5383c1.6567-0.32152,3.8037-0.85741,3.8346-0.94777,0.0416-0.12882,0.28705-0.26901,0.28705-0.26901s-0.9289-1.5221-1.3254-3.3852c1.9096,0.49473,3.8592,0.81301,3.8592,0.81301l0.6104-0.52126s-0.47059-1.5448-0.62157-3.2266c2.2654,0.14344,4.1868,0.3134,4.1868,0.3134l0.38256-0.43356s-1.2768-2.4417-1.2341-3.8236l0.003-0.12665c0.43538,0.0823,0.87184,0.13531,1.2731,0.12665,1.8765-0.0449,3.9616,0,3.9616,0l0.32014-0.71394c0.001-0.00036-1.8104-1.2325-2.2345-2.0125zm-13.789,20.331s-0.6088,1.2363-1.845,2.6626c-0.10031,0.11205-0.19742,0.2111-0.29506,0.31178-0.21182-0.0893-0.42737-0.18999-0.64187-0.31178-1.448-0.82273-1.8188-1.7592-1.8188-1.7592s0.79982-0.39243,3.2365-2.0265c1.288,1.0209,1.3643,1.1232,1.3643,1.1232zm1.1354-4.124s-0.76086,0.90502-2.5338,2.4883c-0.18141-0.17321-0.36441-0.36428-0.54692-0.59864-1.1354-1.4723-2.5552-2.7389-2.4127-4.9565,0,0,0.88033,1.5865,2.8412,1.3819,0.39911-0.0379,0.85902-0.10879,1.336-0.19108,0.52234,1.3137,1.3163,1.8761,1.3163,1.8761zm2.6416-3.3256s-1.8146,0.59543-3.499,0.86714c-0.0715-0.17483-0.14138-0.35454-0.20754-0.56509-0.6376-2.0742-0.6376-5.2288-0.6376-5.2288s1.4155,0.97812,3.4008,1.5286c0.57626,2.3546,0.94333,3.3982,0.94333,3.3982zm-0.60132-3.8371c-0.29398-1.9356,0.0918-3.855,0.0918-3.855s1.0548,1.0539,3.0231,1.3835c0.13499,1.7889,0.34147,2.6777,0.34147,2.6777s-1.4945,0.0828-3.4564-0.20623zm7.6311-2.9478s-1.2693,0.49148-3.7087,0.14994c-0.017-0.23221-0.031-0.46983-0.04-0.71234-0.0854-2.203,0.10885-3.9871,0.10885-3.9871l0.007-0.026c0.3468,0.15319,1.6449,0.6842,2.8556,0.97919l0.0106,0.14019c0.16967,1.9871,0.7662,3.4561,0.7662,3.4561zm-0.17233-4.104-0.13179-0.0314c0.0838-1.4127,0.0774-3.4691,0.0774-3.4691s1.1871,0.31664,2.1011,0.19269c0.2417,0.60031,0.0854,0.7567,0.68029,1.6639,0.5981,0.90828,1.4918,1.6439,1.4918,1.6439s-3.0247,0.25711-4.2188,0zm-9.88,24.441-0.17074-0.70583s-1.1914,0.88552-1.5297,1.7954c-0.12912-0.02-0.25558-0.053-0.37456-0.0942-0.79394-0.28849-2.6672-1.0203-2.6672-1.0203l0.26785,0.53101s1.9453,0.89363,2.4554,1.0089l0.16434,0.0298c-0.25451,0.77513-0.64455,1.8414-0.64455,1.8414l0.31266,0.43357s0.17767-1.3142,0.67922-2.2328c0.66693,0.066,1.5916,0.10068,1.5916,0.10068s-0.11364,0.51583-0.28599,1.0934c-0.16807,0.57701-0.5106,1.9307-0.5106,1.9307l0.58262,0.36104,2.7147,0.0563-0.45726-0.53912s-0.0843-0.13532-0.96465-0.16292c-0.88193-0.0298-1.4208,0.11529-1.4208,0.11529s0.11311-0.54938,0.45458-1.6455c0.34041-1.0966,0.35535-1.0322,0.35535-1.0322l-0.34147-0.94942s-0.86757,0.2387-1.4433,0.21922c0.50635-0.74045,1.2325-1.1345,1.2325-1.1345zm-14.825-1.7115c1.662,0,3.0668,1.121,3.0668,1.121l-0.0635-0.79463s-1.2986-1.7526-2.7889-1.7526c-1.4929,0-3.2595,1.5351-3.2595,1.5351v1.6406s1.383-1.7494,3.045-1.7494zm17.507,25.497c-1.7031,0.73232-3.6212,0.73232-3.6212,0.73232s0.51914-0.74209,1.027-2.0249c3.332-0.93477,3.999-3.1589,3.999-3.1589l-0.21182-0.82167s-0.80724,2.0331-3.4921,3.154c0.49675-1.5746,0.99986-4.2339,0.99986-4.2339l-0.91506-0.23708s-1.3136,1.6439-2.5531,2.0612c0.84037-1.6368,0.9561-3.5102,0.9561-3.5102l-0.4055-0.71395s-0.89476,0.8011-2.3006,1.0598c-0.21182,0.0395-0.44391,0.0363-0.68669,0.007l0.005-0.007c0.76775-1.0782,2.2377-4.1912,2.2377-4.1912l-0.25716-0.58565s-1.1279,2.7486-2.2783,4.1272c-0.14779,0.17971-0.29132,0.34643-0.43644,0.50665-1.1764-0.33994-2.8635-1.3473-2.8635-1.3473l0.18994,0.5191s0.9561,0.73072,2.3492,1.174c-0.84833,0.89038-1.7741,1.7196-1.7741,1.7196l0.0838,1.2531s2.1593,0.41083,3.9323,0.59052c-1.4273,2.0195-2.5883,2.6924-2.5883,2.6924l0.57466,0.86606s1.7538-0.0114,4.9023-0.78485c-0.89583,1.6921-1.5788,2.4271-1.5788,2.4271s2.8742,0.19756,4.8345-0.80003c1.9592-0.99436,2.5552-2.0298,2.5552-2.0298l-0.55328-0.60843c-0.00036-0.00036-0.42631,1.429-2.1305,2.1646zm-9.0726-5.4072s0.84671-0.92993,1.5724-1.8842l0.0891,0.0244c2.0013,0.43249,2.5541-0.17266,2.5541-0.17266s0.37989,1.0847-0.83983,3.0334c-1.44-0.0595-3.3758-1.0008-3.3758-1.0008zm1.7884,4.0201,1.7895-2.078c0.12699-0.14668,0.23904-0.29013,0.34148-0.43681,1.9624-0.0693,3.0668-1.6791,3.0668-1.6791s0.22997,1.6244-0.64774,3.6261c-2.4933,0.90827-4.5501,0.56781-4.5501,0.56781zm-2.4282-12.879c1.8749,0.12883,4.3031,1.0127,4.3031,1.0127l-0.29773-0.9927s-2.3081-0.56402-3.745-0.75023c0.64134-1.4376,2.0611-2.1218,2.0611-2.1218l-0.63812-0.34642s-0.78646,0.12829-1.853,1.9454c-0.088,0.14669-0.16647,0.29825-0.23957,0.45143-0.13658-0.01-0.26891-0.0178-0.40016-0.0178-1.7031-0.046-3.1309,0.94776-3.1309,0.94776l0.25666,0.51909s1.4838-0.64144,2.9462-0.6674c-0.52982,1.4756-0.92462,3.1524-0.92462,3.1524l0.38468,0.88717s0.7427-2.3708,1.2618-4.0201h0.0155v0.00053zm-3.9392-8.0382-0.4055-1.0404s-2.0008-0.70908-3.5343,0.0227c-1.534,0.73559-2.6843,2.5077-2.6843,2.5077l0.63974,1.2087s1.0644-1.9654,2.4703-2.4385c1.4048-0.47795,3.514-0.26035,3.514-0.26035zm3.8971,3.0453-1.32-0.69232s-2.1721,0.62842-2.9394,1.4063c-0.76723,0.77999-1.3846,2.767-1.1728,3.3273,0.21342,0.56076,0.89636,0.92832,0.89636,0.92832s0.36068-2.0958,1.4262-3.0886c1.066-0.99377,3.1095-1.8809,3.1095-1.8809zm-5.0666-0.62462c0.89209-0.86387,2.512-1.1903,2.512-1.1903l-0.81045-0.73399s-1.9592,0.23762-2.9815,1.1459c-1.0218,0.90882-2.3428,2.7882-2.3428,2.7882l1.1514,1.1215c0-0.00054,1.5761-2.2707,2.4714-3.1313zm6.7441-58.716,0.0699-0.0893c1.0324-1.3288,2.0344-1.3288,2.4282-1.2216,0.16434,0.046,0.38416,0.0265,0.58101-0.006l-0.007,0.006,0.031-0.0114c0.0491-0.01,0.0934-0.0179,0.13766-0.0281,0.0502,0,0.096,0.0168,0.12165,0.066-0.32759,0.51801-0.79287,1.9373-1.0351,3.1297-0.29878,1.469-0.93531,1.6423-1.4048,2.5489-0.46793,0.90881-1.447,2.4222-1.4902,3.7164-0.0427,1.2975,0.29718,1.9887,0.63866,2.1619,0.34148,0.17321,0.96626-0.56401,0.93692-0.86387-0.0432-0.43195-0.38256,0-0.63813,0s-0.21288-0.43195-0.34147-1.2103c-0.12858-0.77838,0.93585-2.9381,1.3206-3.6309,0.38256-0.69066,1.1914-1.5118,1.3622-2.6794,0.15259-1.0404,0.91079-3.3192,0.91079-3.3273,0-0.0644-0.57941-0.223-1.7079-0.30203-0.84036-0.0612-1.973,0.67606-2.5093,1.5004-0.53249,0.82113-2.2089,1.4788-2.2089,1.4788s1.837,0.0136,2.8049-1.2379z'/%3E %3Cpath d='m374.33,178.91-3.2707,0.0866,0.93905,2.4465z'/%3E %3Cpath d='m370.48,178.78s-0.47539-0.30149-0.70267-0.56242c-0.22729-0.26036-0.40444-0.36753-0.40444-0.36753l-1.178,0.74211-0.68189,2.4206,0.33987,0.34481,2.6272-2.5776z'/%3E %3Cpath d='m370.04,185.34-2.386-3.5151-1.3622,2.9316,0.65251,0.23058s0.65249,0.0644,1.6465,0.20785c0.99452,0.14506,1.4491,0.14506,1.4491,0.14506z'/%3E %3Cpath d='m379.74,244.06s-0.0389,0.0265-0.12005,0.0823c-0.56504,0.37782-3.0685,1.9058-6.1414,1.9058-1.4283,0-2.9799-0.32693-4.5347-1.2482-0.9156-0.54618-1.5414-1.3608-2.0024-2.3464-0.69258-1.4761-0.9956-3.3354-1.3115-5.1394-0.32226-1.8036-0.64882-3.5514-1.4443-4.8358-1.0719-1.7083-3.0898-2.7762-4.8985-4.2983-1.813-1.5221-3.4238-3.4506-3.7615-6.8755-0.0336-0.34643-0.0491-0.68905-0.0491-1.0257-0.002-2.262,0.72565-4.2306,1.4614-5.9522,0.73308-1.7262,1.4897-3.1952,1.495-4.5224,0-0.22248-0.0224-0.44169-0.0715-0.65278-0.2433-1.0257-1.1279-1.8847-1.94-2.5197-0.81472-0.62841-1.567-1.0155-1.575-1.0209l-0.017-0.008-1.2709-0.35128-0.10724,0.39892,1.2491,0.34641,0.0544-0.19973-0.0918,0.18457s0.0432,0.0217,0.12111,0.066c0.28118,0.15482,0.99772,0.57701,1.6828,1.1508,0.6867,0.57373,1.3296,1.311,1.495,2.0444,0.0416,0.17971,0.0608,0.36915,0.0608,0.56077,0.006,1.1621-0.71604,2.6214-1.4609,4.3579-0.7411,1.7391-1.4956,3.7641-1.4972,6.1168,0,0.3513,0.0182,0.70583,0.0529,1.0653,0.3436,3.5519,2.0542,5.6076,3.9077,7.1577,1.8546,1.5481,3.8389,2.6252,4.8131,4.2031,0.98388,1.5697,1.2432,4.0807,1.7154,6.4983,0.2369,1.2054,0.53143,2.3924,1.0164,3.4295,0.48287,1.0387,1.1637,1.9308,2.1657,2.5262,1.6204,0.9608,3.2498,1.3039,4.7406,1.3039,3.665-0.003,6.4807-2.0547,6.4988-2.0672l-0.2353-0.33505z'/%3E %3Cpath d='m376.91,237.6-0.0251,0.0195c-0.14085,0.0823-0.79554,0.44872-1.6401,0.44872-0.67762-0.003-1.4758-0.22409-2.2841-1.0193-0.98655-0.97432-1.2752-1.8777-1.5243-3.0252-0.24438-1.1476-0.43485-2.5294-1.2123-4.34-0.80457-1.8664-2.7841-3.357-4.6253-4.8212-1.8493-1.456-3.547-2.8872-3.8517-4.4434-0.0608-0.29339-0.087-0.58567-0.087-0.8774-0.004-1.3142,0.56395-2.6463,1.1498-4.1533,0.58529-1.5069,1.1812-3.1919,1.1812-5.2152,0-0.34262-0.016-0.69557-0.0534-1.0549-0.27157-2.6084-2.2601-4.5473-4.151-5.8416-1.8957-1.2942-3.7152-1.9492-3.7242-1.9524l-0.13552,0.39081s0.10725,0.0379,0.3036,0.11854c0.68349,0.27876,2.4143,1.0501,4.0187,2.2886,1.606,1.2401,3.0695,2.9316,3.2813,5.0388,0.0347,0.34642,0.0518,0.6858,0.0518,1.0122,0,1.9394-0.57092,3.5616-1.1514,5.0621-0.57995,1.4988-1.1781,2.872-1.1807,4.307,0,0.3199,0.031,0.63818,0.095,0.96134,0.37616,1.7857,2.1582,3.2184,4.0006,4.6875,1.8504,1.4609,3.7775,2.9478,4.5043,4.6594,0.75605,1.7624,0.93638,3.0886,1.1866,4.2588,0.2481,1.1708,0.58262,2.1992,1.6407,3.2385,0.87767,0.86768,1.8002,1.1378,2.568,1.1329,1.0965-0.002,1.8749-0.52125,1.8899-0.53262l-0.22515-0.34804z'/%3E %3Cpath fill='%23a8ac71' d='m388.97,227.59s2.2895,0.53911,2.2057,2.3973c-0.0854,1.8598-1.1076,4.4488-1.1076,4.4488l-3.1533-2.8525,1.7756-1.5697,0.65197-0.93318-0.37242-1.4907z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35' d='m349.61,205.23s-2.2575,0.77673-2.7254-0.21598c-0.46899-0.99435-0.25557-1.7727-0.29718-1.987-0.0448-0.21597-1.3654-0.30312-1.2368-1.5995,0.12752-1.2975,1.7884-1.2103,2.131-1.2103,0.34147,0,0.4247-1.9903,1.5767-1.8994,1.1498,0.0839,1.7025,1.423,1.7025,1.423l-1.1508,5.489z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35' d='m352.12,205.84s-1.916,0.99597-2.5136,0.0428c-0.5965-0.95155,0-2.1619-0.21341-2.3778-0.21396-0.21436-1.3611-0.60352-1.1498-1.7262,0.21342-1.1242,1.4059-0.77998,1.8333-0.99595,0.42417-0.21436,0.72245-1.901,1.9155-1.5979,1.1919,0.30365,1.4059,1.2531,1.4059,1.2531s-0.93852,4.4932-1.2779,5.4019z'/%3E %3Cpath fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35' d='m355.36,206.27s-0.55489,1.2119-1.9171,0.94776c-1.3638-0.25549-0.93692-2.2442-1.1514-2.5922-0.21181-0.34264-1.1914-0.60351-1.0218-1.8566,0.17074-1.2515,1.4059-1.0798,1.8738-1.2515,0.469-0.17483,0.97907-2.1191,1.8749-1.8171,0.89583,0.30367,1.7452,1.4263,1.5756,1.9454,0,0-1.916,0.6035-2.1721,1.901-0.2545,1.2969,0.93799,2.7232,0.93799,2.7232z'/%3E %3Cpath fill='%23af7029' d='m385.51,227.14s-1.7031-1.8718-2.8961-3.5118c-1.193-1.6455-3.0391-3.5205-3.0391-3.5205l-2.9239-1.4674-1.8456-3.0832-0.22942-3.6293,0.79661-2.1023,1.1071-1.6141s-6.057,2.1683-2.9825,13.771c1.3083,4.9268,4.6579,5.644,4.6579,5.644l5.5665-0.34101,1.7885-0.1456z'/%3E %3Cpath fill='%23816c2a' d='m382.71,188.39c0.57573,0.0184,0.86062,0.20947,1.034,0.45034,0.17288,0.24411,0.22837,0.57054,0.22677,0.85089,0,0.15318-0.0155,0.2885-0.031,0.38593l-0.0197,0.11205-0.008,0.0346,0.19848,0.053-0.18622-0.0839c-2.0029,4.4385-6.2557,6.5095-10.07,9.2741-1.9042,1.3835-3.6932,2.9467-5.0074,5.0783-1.3147,2.1354-2.1449,4.838-2.1449,8.4683,0,0.18295,0.002,0.37241,0.007,0.56076,0.14619,6.673,2.6694,10.264,5.4478,12.142,2.775,1.8842,5.7775,2.0742,6.9108,2.0774,0.29665,0,0.4658-0.013,0.46953-0.013l0.006-0.003h0.006c0.002,0,0.77684-0.0991,1.8936-0.20136,1.1146-0.0974,2.5664-0.19974,3.9046-0.19974,0.85473,0,1.6658,0.0412,2.3028,0.14831,0.63866,0.0991,1.1002,0.28688,1.2416,0.48012,0.17874,0.22409,0.24543,0.44656,0.24756,0.67607,0.004,0.50447-0.36494,1.0864-0.81577,1.5513-0.44285,0.46496-0.96466,0.82439-1.1487,0.91042l0.17127,0.37402c0.26518-0.12395,0.78645-0.48986,1.272-0.99595,0.47806-0.50286,0.92356-1.141,0.9305-1.8398,0-0.31665-0.10404-0.6463-0.3404-0.93804-0.29186-0.34804-0.81739-0.51097-1.4929-0.6284-0.67388-0.1088-1.5009-0.14994-2.3679-0.14994-2.7142,0-5.8459,0.40055-5.8518,0.40055l0.0262,0.20786-0.0166-0.20786s-0.0341,0.002-0.10991,0.005c-0.0747,0.003-0.18675,0.006-0.32813,0.006-1.0906,0-4.0144-0.1927-6.6837-2.0033-2.6672-1.8171-5.1125-5.2331-5.2661-11.807-0.002-0.1862-0.006-0.36916-0.006-0.55264,0.003-3.5697,0.81098-6.1831,2.0814-8.2476,1.9053-3.0983,4.8794-4.9841,7.7876-6.945,2.9057-1.9605,5.7513-4.0033,7.3142-7.4574l0.008-0.0168,0.004-0.0178c0.002-0.0103,0.0715-0.28038,0.0715-0.63818-0.002-0.32964-0.0566-0.74046-0.30359-1.0934-0.24384-0.35453-0.69097-0.61163-1.3547-0.62301l-0.0106,0.41517z'/%3E %3Cpath fill='%23fff' d='m390.88,229.04s-1.4358,2.6312-1.8008,2.6577c-0.36492,0.0265,1.2427,0.41571,1.6071,1.0355l-0.34307,0.64304s-1.5894-1.1312-2.5867-1.1789l-0.0891-0.97106s0.81259-0.27389,1.4864-0.88877c0.55383-0.50611,1.1322-1.9226,1.1429-2.249l0.58314,0.95156z'/%3E %3Cpath fill='%23fcca3d' d='m396.48,230.77-3.579,0.98078-1.8237-1.141s0.14939-1.4902-0.66052-2.1283c-0.8345-0.66143-1.3301-0.85416-2.0552-1.1578-0.72406-0.30203-3.2797-0.35615-3.2797-0.35615l-6.4646-6.9995,2.4143,0.25548,3.8192-0.47308,3.5502-0.30203,1.8749,0.27551,2.0008,0.61814,1.0516,0.89044,1.0922,0.9662,1.0943,1.8003,0.69626,2.033,0.28386,2.1878-0.0149,2.55z'/%3E %3Cpath fill='%23af7029' d='m396.62,230.54s-1.28,0.37782-2.8972,0.3448c-1.6204-0.0227-2.6491-0.27388-2.6491-0.27388s0.0928,0.1023-0.24865,1.1692c-0.3404,1.0685-0.6541,1.7278-0.6541,1.7278l0.0587,4.2041,3.4073,0.66795,1.7895-0.69445,0.90918-4.5819,0.28438-2.5635z'/%3E %3Cpath fill='%23fcca3d' d='m395.67,228.76,0,0,0.15473,1.6292,0.66693,0.19486-0.016-1.4668z'/%3E %3Cpath fill='%23fcca3d' d='m392.46,189.47-0.39802-2.8655-1.1215-1.901-1.4203-1.9459-1.5195-1.672-0.851-0.75995-0.35588-0.56242-3.7348,0.1732-1.9576,2.3335s5.1002,3.599,7.0193,7.5317c1.6513,0.49636,2.9367,1.54,3.6692,2.2555l0.17288-0.31016,0.49726-2.2772z'/%3E %3Cpath fill='%23af7029' d='m388.84,192.63c-0.0529,2.9202-0.55435,4.3081-0.94172,4.9549l2.2622-2.5938,1.6294-2.93c-0.73253-0.71555-2.0179-1.7592-3.6692-2.2556,0.45565,0.93804,0.73468,1.8929,0.71924,2.8244z'/%3E %3Cpath fill='%23816c2a' d='m394.11,235.87c-0.003-0.002-1.0522-1.3126-1.8344-2.0791-0.79821-0.77672-1.7212-1.2022-1.7325-1.2087l-0.16966,0.37782s0.0502,0.0227,0.14406,0.0742c0.28171,0.14831,0.92249,0.51909,1.4748,1.0587,0.37454,0.36591,0.82754,0.87906,1.1839,1.2942,0.3564,0.42059,0.61681,0.74372,0.61681,0.74537l0.31692-0.26252z'/%3E %3Cpath fill='%236f5b24' d='m396.31,232.73s-0.342,1.2645-1.6188,2.4157c-1.2789,1.154-2.8972,1.9324-2.8972,1.9324l3.6628,1.3537,2.4426-2.2739-1.5894-3.4279z'/%3E %3Cpath fill='%23404118' d='m396.85,235.77-0.22409,0.433-0.68828,0.66575-0.53888,0.57374,0.91237-3.7996,0,0,0.65092,1.1204,0.0854,0.60621z'/%3E %3Cpath fill='none' stroke='%2378732e' stroke-width='0.3' d='m375.12,185.22s-5.0261,0.43195-8.5191-0.1732c-3.4926-0.60517-2.7264-9.507-2.8124-9.7656-0.0838-0.25927-2.1294-2.4206-1.789-4.4076,0.34146-1.9881,6.7943-7.233,7.6679-7.5183,0.5965-0.19486,1.8738,0.34642,1.8738,0.34642s1.631-1.5865,2.115-1.5865c0.49834,0,1.1871,0.91528,0.99559,1.3061-0.19262,0.38755-2.4079,1.6834-2.5786,2.6777-0.17073,0.99376,0.0219,1.9881-0.61841,2.9597-0.63813,0.97267-1.8733,2.2902-2.0227,3.1113-0.14886,0.82112-0.5106,1.5351,0.10725,1.8371,0.61787,0.30311,2.727,0.0427,4.5368-0.77673,1.8088-0.82274,2.5541-1.9243,2.8102-1.8155,0.2561,0.10717-1.0436,2.2669-3.045,3.1118-2.0013,0.84224-3.3229,1.8138-4.3239,1.6634,0,0-1.1071,2.6582,2.3226,2.8082,3.4275,0.15155,5.3238-0.75563,5.3238-0.75563l-2.044,6.9776z'/%3E %3C/g%3E %3Cg id='eagle'%3E %3Cg id='wings' fill='%23d2a567'%3E %3Cpath fill='%23ab6d29' stroke='%234d2a15' stroke-width='0.51' d='m418.24,147.56s-9.2062-1.7375-9.0545,5.9261c0.048,2.419,0.58422,3.258,2.5306,3.8036,1.9469,0.54239,5.8459,0.74045,9.1538,3.7034,3.3054,2.963,3.5529,5.1362,3.5529,6.9135,0,1.777-0.82594,3.4079-0.82594,3.4079l2.0899,10.124,2.0969,7.5071,6.2296-3.606,3.6521-11.112-4.6744-20.002-14.751-6.6656z'/%3E %3Cpath fill='%234d2a15' d='m427.38,186.09s3.2072-1.2119,4.0326-3.8036c0.22623-0.71234-3.2392-3.8301-3.3235-3.8301-0.0827,0,1.7618,0.89203,2.6133,1.6688,0.85154,0.77999,1.5046,1.0966,1.7586,0.98133,0.25663-0.1153,1.7357-3.5448,1.1674-4.2934-0.56877-0.74857-1.4518-2.5061-2.7862-3.3982-1.3328-0.89364-3.0946-0.77839-3.0946-0.77839s2.4447-0.77838,3.665-0.0861c1.2171,0.69066,1.3328,1.4972,1.4742,1.2103,0.14353-0.28849-0.25664-3.7181-0.80938-4.8705s-1.1199-1.7002-2.5989-1.987c-1.4726-0.29013-3.0636-0.17484-3.0636-0.17484s2.1294-1.1805,3.7461-0.77673c1.6172,0.4038,1.5926,1.2103,1.7308,1.0371,0.1462-0.17321-0.79607-3.1394-1.1749-3.8896-0.38521-0.74856-2.3161-2.2474-2.8561-2.4206-0.53784-0.17321-2.3012-0.22735-2.3012-0.22735l-0.85207,0.0114s1.2256-0.84929,2.7878-0.70582c1.5585,0.14506,1.6428,0.66307,1.869,0.577,0.2273-0.0855-0.17074-0.28687-1.1183-0.95156-0.95396-0.66089-5.5536-2.6214-5.5536-2.6214l-4.2028-0.0574s-0.0448-1.0653,1.1791-1.266c1.2213-0.20298,1.5756,0.15643,1.4897-0.16022-0.0848-0.31611-3.547-1.0782-3.547-1.0782s-1.9907,0.0579-2.8433,0.0861c-0.84993,0.0298-3.9472,0.38755-3.9472,0.38755s0.26997-0.67933,0.87558-1.2087c0.46151-0.40597,1.1765-0.65929,1.7666-0.82113,1.3611-0.37565-0.76728-1.4409-0.76728-1.4409l1.137-1.7278,5.113,0.43033,10.791,6.3102,5.0565,4.3513,3.2066,8.1814-0.96519,14.058-7.2164,5.964s-3.1773,0.49149-3.1773,0.34643c-0.00037-0.14507,0.73895-3.0258,0.73895-3.0258z'/%3E %3Cpath d='m417.97,151.17s-0.34255-0.99436-0.34255-2.2474c0-1.2531,0.2145-1.2103,0.2145-1.2103s-3.4494-0.47632-5.9645,1.5118c-2.5114,1.9887-1.0655,5.4446-1.0655,5.4446s1.0981-1.0798,2.5007-1.5995c1.4048-0.51584,3.9334-0.43031,3.9334-0.43031,0.21235-0.21761-0.55275-1.2119-1.4907-1.4263-0.93959-0.21597-2.7681-0.21597-2.7681-0.21597s1.065-0.73559,2.8972-0.56076c1.8317,0.17159,2.0856,0.73399,2.0856,0.73399z'/%3E %3Cpath fill='%238f4620' d='m428.76,187.3-2.3306,0.80815,1.4203,9.794,9.3131,15.959,4.8852-0.86063,1.6481-2.9402l1.3067,0.57701c0.56237,0.577,2.386,3.6866,3.9205,4.32,1.5308,0.6344,2.3236,0.4038,3.6895,1.5021,1.3653,1.0918,6.3476,8.5111,6.6046,8.7964,0.25236,0.2885-0.28599-3.1822-0.28599-3.1822l-1.5195-4.4369-1.8834-3.0966-0.28599-0.83413,2.584,0.0281,1.6028,0.98132,2.457,2.0558,1.2763,1.5134,0.668,1.5578,0.28224,1.3651,0.65678,2.1186,1.36,2.9402,1.6369,2.7946,0.5229-1.141-0.79608-3.2829-2.4986-7.9655-1.5324-2.6794s2.0152,1.4528,2.553,1.6406c0.53993,0.18999,2.3727,2.9267,2.3727,2.9267l1.1658,2.8212,0.83823,2.6214,0.57519,2.2918,0.84192,2.445,1.4464-0.83252-0.25344-1.7694-1.2501-5.4628-0.53779-5.9197s0.69734-0.0168,1.5441,0.9202c0.85527,0.93478,1.622,3.0566,1.622,3.0566l0.62745,5.357,0.84832,4.9116,1.5895,5.0144,1.661,3.1524,1.0804,1.7694s0.0565-2.5045,0.0406-2.6198c-0.0128-0.11258-2.0302-20.968-2.0302-20.968l0.27158-0.87905s0.24061-0.13207,0.93638,0.86228c0.69573,0.9927,1.3926,2.5478,1.3926,2.5478l0.60988,3.2699,0.29717,2.262,0.42632,4.2636,0.56717,4.6215,2.1326,4.9598,1.1504,2.6761,0.64028-3.1806-1.0122-22.429,0.47327-0.64791s1.1893,0.97971,1.5862,1.6736c0.39964,0.68798,1.1397,1.364,1.1397,1.364l0.69413,4.943,0.6253,14.145,0.4962,3.6439,4.1606-37.049,2.5696-0.56075,0.29717-0.70743-1.8754-1.4409-4.2129-6.5378-2.8428-6.3247-4.9834-9.1822-8.6478-10.544s-5.3656-4.5819-6.7302-5.6188c-1.3637-1.0354-2.4917-1.685-2.4917-1.685l0.42633-1.3175,1.4267-2.3129-0.23369-0.10718-1.1119,0.066-2.8929,0.41028-2.9191-0.86553-5.7273-3.9968-6.1339-2.917-3.602-1.2747-8.6885-2.2046-8.6452-1.1675-3.8794-0.0525-3.5337,0.65929s-1.7965,0.74045-2.3594,1.8501c-0.55916,1.1096-0.60293,1.8863-0.43165,3.507,0.16913,1.6212,1.1492,2.4634,3.578,3.4594,2.4319,0.99216,8.136,4.7963,8.136,4.7963l2.7499,2.7632,1.0207,1.3191,0.1478,1.0171,1.8514,14.584-3.6618,7.9292-2.6251,1.3618z'/%3E %3Cpath fill='%23ab6d29' d='m438.11,210.03s1.5601,2.6512,3.7754,0.60677c2.2185-2.046-0.96732-7.8667-0.93479-8.2129,0.0277-0.34642,1.0207-0.46009,1.0207-0.46009l1.6204,2.996s0.96412,1.6124,0.59331,4.1765c-0.36602,2.5641-2.838,4.7833-2.838,4.7833l-2.8118-0.63491-0.42525-3.2547z'/%3E %3Cpath fill='%234d2a15' d='m492.51,244.21-2.0024-5.9228s-0.59277-3.802-0.59277-4.5804c0-0.77998-0.38576-10.416-0.55755-12.229-0.16913-1.8138-0.0811-3.8913-0.27316-4.1468-0.19315-0.26361-2.1732-2.8758-2.1732-2.8758l-0.84993-0.88717,0.60132-0.43032s0.73788,0.80815,0.93959,0.37132c0.19473-0.4287-0.0325-2.531-0.85207-5.8171-0.82541-3.2845-5.0303-10.976-5.0303-10.976l0.45405,0.37401,1.1669,1.1822,2.4709,1.9865,5.3409,1.9589,2.8961,0.46171,1.8722,3.7462s1.3344,6.4534,1.2501,9.7053c-0.0859,3.2585-0.28599,5.9079-1.534,9.1629-1.2469,3.2564-1.5606,13.57-1.7308,15.21-0.17236,1.6455-0.79661,3.2563-0.79661,3.2563l-0.59918,0.44981z'/%3E %3Cpath fill='%238f4620' d='m492.53,227.08s1.1183-1.3321,1.6092-3.1627c0.48765-1.8268,0.67922-16.196-1.0206-17.975-1.7063-1.7776-5.1845-3.179-5.357-3.062-0.17179,0.11692,1.391,4.6843,1.391,4.6843s0.52234,0.66901,1.0564,1.8582c0.29398,0.66143,0.69893,1.8582,0.76726,2.295,0.19316,1.2368,1.2123,4.15,1.3622,7.9046,0.14458,3.7527,0.19153,7.4579,0.19153,7.4579z'/%3E %3Cpath fill='%234d2a15' d='m484.68,236.1s0.73153-6.7986,0.39005-11.778c-0.3383-4.9776-0.75071-5.5996-1.224-6.4999-0.48072-0.8969-2.1828-4.15-3.3432-8.299-1.1573-4.1467-1.908-7.3276-2.6571-8.1568-0.74911-0.83085-2.2511-2.6268-2.5893-2.1418-0.34149,0.48336-0.34149,1.5204-0.34149,1.5204l-2.0461-0.55536-0.47646-1.3126,0.65624-2.1169-0.1302-0.90882-0.24009-1.4972,2.6427,2.1023,5.4249,3.7165,2.7254,11.252,2.5269,7.0011,0.35427,11.857-0.25556,10.44-1.4171-4.6231z'/%3E %3Cpath fill='%234d2a15' d='m487.87,203.66s1.4187,1.3386,2.2478,1.8036c0.83235,0.46496,2.3988,1.4279,2.0867,1.5351-0.30573,0.10717-1.7783-0.46659-2.695-0.98459-0.91661-0.518-1.5409-1.154-1.5409-1.154l-0.0987-1.2z'/%3E %3Cpath fill='%234d2a15' d='m477.3,233.42s1.081-2.386,0.91025-5.4126c-0.17233-3.0258-1.6172-10.315-2.0723-11.239-0.45512-0.9234-2.6101-2.3004-4.5442-6.3941-1.931-4.0926-1.733-4.9267-3.0071-6.424-1.2805-1.4988-2.6165-3.1973-2.6165-3.1973l0.39642-4.379,4.715,2.3908,2.0168,1.0073,2.3876,11.464,2.131,3.199,0.90491,4.5836,1.1396,10.686,0.62054,8.4998-0.33825,0.74857-2.6437-5.5333z'/%3E %3Cpath fill='%234d2a15' d='m471.86,228.57s0.12647-3.3706-0.72827-6.3941c-0.85314-3.0258-1.4464-5.2764-2.386-6.2247-0.93639-0.94777-3.3187-3.4128-5.4495-6.6116-2.1305-3.1968-5.0724-6.5688-5.0724-6.5688l0.0779-4.2886s1.4134,1.3305,2.6197,1.9162c1.2058,0.58513,3.0129,1.5957,3.0129,1.5957l1.2597,4.9186,1.6268,3.5384,2.3828,3.1643,1.5228,1.4062,0.97052,5.2943,0.52289,2.9792,1.2549,4.2523-0.41564,2.1289-1.1989-1.1058z'/%3E %3Cpath fill='%234d2a15' d='m467.94,228.61-1.3008-1.2515s0.70375-0.84603,0.36283-2.531c-0.34149-1.6834-0.78859-3.3056-1.5569-4.9035-0.76407-1.5979-0.99612-2.5722-1.4662-3.0453-0.47113-0.4747-4.4536-4.2377-5.8374-5.3789-1.3819-1.1476-3.5108-3.3305-4.834-4.1733-1.32-0.84059-2.2799-1.0587-2.2799-1.0587l-0.7459-5.2731s1.7484,2.3334,2.792,2.7221c1.0436,0.3908,2.7499,0.92992,2.7499,0.92992l3.7018,6.5475,1.2581,1.6639,3.4291,2.7432,1.4043,2.8298,1.0436,3.2645,1.3003,4.4964,0.23422,2.7204-0.25504-0.30257z'/%3E %3Cpath fill='%234d2a15' d='m460.66,227.14s-2.186-2.5062-2.5285-4.1224c-0.33988-1.6125,0.22942-1.6125-0.45566-3.4561-0.68243-1.8415-2.9527-4.5489-4.827-6.0511-1.877-1.4972-4.5426-3.685-4.3719-4.897,0.17073-1.2087,0.51059-1.2666,0.51059-1.2666l1.136,0.97811,5.8459,6.2258,1.7943,3.2569,1.3622,4.0596,0.90812,1.9026,0.87927,2.4222-0.25345,0.94777z'/%3E %3Cpath fill='%234d2a15' d='m481.76,196.6s4.0304,4.9992,5.0549,0.4038c0.45512-2.046-1.3979-5.9389-1.3979-5.9389s-3.7461-6.5635-5.0218-8.1483c-1.2779-1.5844-7.5253-9.5947-7.5253-9.5947l-4.5699-2.1316,1.5601,2.681s3.4067,3.3982,7.7561,10.917c4.341,7.5188,3.4894,11.667,3.4894,11.667l0.65411,0.14506z'/%3E %3Cpath fill='%234d2a15' d='m458.35,166.47s8.0046,6.828,13.163,14.216c5.152,7.3901,7.1967,12.319,6.0457,13.31-1.1503,0.99376-4.3885-0.55917-5.7043-2.635-1.3216-2.0742-2.4346-5.7049-7.2875-11.237-4.8569-5.5301-7.1967-6.353-7.1967-6.353l-3.4947-5.6605,4.4743-1.6406z'/%3E %3Cpath fill='%234d2a15' d='m454.18,182.84s4.7278,3.9324,7.7085,7.1293c2.9841,3.199,4.5181,5.489,4.5181,5.489l1.9133,1.901s-1.1492-2.0298-0.50902-2.7221c0.63707-0.69065,1.408-0.34481,1.408-0.34481l-15.039-15.776v4.3238z'/%3E %3Cpath fill='%234d2a15' d='m453.2,183.28s1.5345,2.9386,4.047,5.4014c2.513,2.4617,5.2806,5.1,5.2806,5.1l1.0676,3.8452s-6.8584-5.2694-6.9012-3.9752c-0.0443,1.2958,1.6626,3.9752,1.6626,3.9752l-2.0888-1.1232-2.8977-4.1928-1.7469-3.6293-1.9587-5.0144,3.5353-0.387z'/%3E %3Cpath fill='%234d2a15' d='m432.46,199.53s3.5774,3.1973,5.5387,0.0861c1.9603-3.1118,0.42631-6.6976,0.42631-6.6976s5.0511,7.4488,6.4753,0.4747c0.25557-1.2531-3.0684-6.0938-3.0684-6.0938l1.1925-1.121,2.5514,4.3194s2.3924-1.0798,2.3924-4.0623c0-2.9808-2.4704-6.828-2.4704-6.828l2.3551,2.6214s4.6691,0.1023,4.7571-2.7519c0.0827-2.8509-3.9205-5.8336-3.9205-5.8336s3.1949,0.21597,3.1496-1.6423c-0.0389-1.8566-4.3394-3.1546-4.4274-4.32-0.0843-1.1675,1.2779-3.1562,3.2376-2.0758,1.9602,1.0798,4.6857,1.9454,5.7925-0.17158,1.1082-2.1191-0.0843-2.5489-0.0843-2.5489s-2.5162-0.51908-2.7665-0.60517c-0.25984-0.0871-4.4765-2.3778-4.4765-2.3778l-3.5401-1.3386-3.6554-0.47632,1.3574,2.7221,0.94279,7.4756,0.0389,3.4577,0.68083,7.5204-1.7895,6.2659-0.92784,1.1291-0.65784,0.84117-1.5601,3.3088-2.1881,2.3692-2.8001,3.5811-2.5552,2.7714z'/%3E %3Cpath fill='%23ab6d29' d='m457.82,213.57s-0.90385-2.2442-2.8347-3.7446c-1.9341-1.5005-5.001-1.6141-5.001-1.6141l5.2512,5.5633,2.5845-0.2046z'/%3E %3Cpath fill='%23ab6d29' d='m465.17,214.84s-1.7026-3.3965-3.689-5.474c-1.988-2.0742-3.2963-4.7535-3.8373-4.7535-0.53618,0-0.93424,0.1153-0.93424,0.1153l0.51007,4.2918,3.6346,3.5173c-0.00036,0,3.4094,2.5337,4.3159,2.3032z'/%3E %3Cpath fill='%23ab6d29' d='m471.22,214.58s-0.84833-3.946-2.8668-7.7481c-2.012-3.8041-4.1446-5.3602-4.1446-5.3602l0.48074,4.0629,1.6514,3.9178,2.6656,3.8615,2.2137,1.266z'/%3E %3Cpath fill='%23ab6d29' d='m476.16,212.36s1.4187-8.1237,0.14299-10.373c-1.2757-2.2474-3.689-2.6777-3.689-2.6777l-0.77203,1.1789,0.77203,5.7909,1.9272,4.4353,1.6188,1.6461z'/%3E %3Cpath fill='%23ab6d29' d='m481.02,198.82s1.1909,0.60516,2.639,3.3403c1.4464,2.7373,3.4947,10.835,3.4616,11.266-0.0261,0.4287-0.76407,0.32964-0.96197,0.23275-0.19848-0.10555-5.1135-7.7828-5.1135-7.7828l-0.78005-7.1742,0.75499,0.11746z'/%3E %3Cpath d='m446.72,208.26s2.599-0.56243,2.599-1.469c0-0.90828-3.1058-2.7237-2.8513-4.1928,0.12379-0.73345,2.6395,0.13045,2.8124-0.38919,0.1686-0.51746-2.5974-4.839-1.749-5.832,0.85207-0.99436,3.1954,4.6664,3.1954,4.6664s1.4043,2.6626,0.89423,4.1912c-1.5772,4.7102-4.9007,3.0252-4.9007,3.0252z'/%3E %3Cpath d='m452.81,202.38c0.12644-0.37781,4.0907,0.5191,4.1329,0.25875,0.1526-0.92992-3.5769-3.802-3.5769-3.802s-0.85367-1.6406-0.59329-1.8994c0.25077-0.26036,2.6379,0.25928,2.7691-0.0871,0.12378-0.34641-2.7318-4.1056-2.7318-4.7963,0-0.69284,0.77203-0.0877,0.77203-0.0877s2.2559,2.3345,3.4505,4.236c1.1882,1.901,2.3092,3.4577,1.9128,6.4812-0.42258,3.2395-6.4721,0.73345-6.1355-0.30367z'/%3E %3Cpath d='m470.71,196.42s-0.64348-2.6794-0.25824-3.0258c0.38522-0.3448,1.4096-0.6479,1.4096-0.6479s-2.1129-1.3175-3.1143-1.3408c-1.001-0.0217-1.1487-0.31339-1.4043,0.1088-0.25664,0.42058,1.8109,3.0242,1.8109,3.0242l1.5564,1.8815z'/%3E %3Cpath d='m458.65,198.49s6.0917,1.5134,6.3471,1.0815c0.25557-0.43194-4.8574-5.1887-4.8574-5.1887s-0.33988-0.86062-0.25398-1.1643c0.0843-0.30149,2.2137-0.3448,2.8524,0.17321,0.63707,0.51801,0,1.5107,0.21448,1.901,0.2113,0.38919,2.131,3.3273,2.4725,2.851,0.34146-0.47471-0.38735-4.0613-0.21446-4.32,0.16858-0.25929,2.3439,2.0298,2.935,2.419,0.59811,0.38919,4.008,3.0702,4.349,1.8154,0.34147-1.2515,0.5528-1.469,0.42257-2.2046-0.12485-0.73345,1.1381,3.4594-0.45509,3.9752-1.5884,0.52125-3.4196-0.55862-3.4196-0.55862l-1.4075-1.082-0.82274-0.86387s0.91026,3.2417-0.15579,3.5849c-1.0628,0.34804-2.3001,0.17484-2.3001,0.17484l-2.5531-0.26035-3.1533-2.3335z'/%3E %3Cpath d='m472.64,194.33s6.5015,3.901,7.1432,3.212c0.64187-0.69066-1.6988-9.8479-1.3216-10.803,0.302-0.76374,5.279,10.401,2.854,11.927-1.853,1.1637-2.7691,0.34479-2.7691,0.34479l-3.1933-1.685-2.7131-2.9965z'/%3E %3Cpath d='m490.73,210.76s0.58855,0.43518,1.4171,0.66953c0.26302,0.0758,1.0452,0.31341,0.82915,0.33669-0.2113,0.0178-1.7325,0.20406-1.8413,0.24574-0.10565,0.0422-0.40498-1.252-0.40498-1.252z'/%3E %3Cpath d='m484.42,189.27s0.61949,0.35453,1.0047,0.46171c0.38362,0.10879,0.87451,0.34642,0.87451,0.41083,0,0.066-0.48074,0.27064-0.8222,0.22733-0.34147-0.0433-0.55275-0.14018-0.55275-0.14018l-0.50421-0.95969z'/%3E %3Cpath d='m482.55,186.07s0.6664,0.30528,1.5179-0.30148c0.85527-0.60517,0.91025-1.0073,0.84196-1.3256-0.0715-0.31664-1.4091-0.31664-1.8589-0.62027-0.45675-0.29988-0.42952-0.84876-0.42952-0.84876l-1.4625-0.0281-0.53991,0.20136,1.9309,2.9229z'/%3E %3Cpath d='m488.29,204.93s1.9896,1.1675,2.5466,1.2764c0.55061,0.10879,1.4902,0.62845,1.3606,0.80002-0.12485,0.17321-1.5942,0.30312-2.3407-0.12882-0.74483-0.43357-0.99137-0.1651-0.99137-0.1651l-0.57519-1.7824z'/%3E %3Cpath d='m477.58,175.32,0.0325,0.0114c0.11046,0.0314,0.47806,0.12504,0.79447,0.0904,0.37882-0.0427,0.69418-0.27388,0.82754-0.12666,0.26679,0.29824,0.0507,1.6818-0.48767,2.0758-0.53624,0.39567-1.1925,0.71555-1.287,0.69065-0.0992-0.0232-2.0969-2.8888-2.0969-2.8888l2.2169,0.14722z'/%3E %3Cpath d='m468.26,166.98s1.3019-0.0774,1.9523-0.0741c0.64983,0,1.4059,0.46982,1.9896,0.83951,0.58528,0.37077,1.1701,4.2983,0.85153,5.0388-0.31533,0.74211-4.6953-2.544-4.8137-2.838-0.12484-0.29825-2.0254-3.2379-2.0254-3.2379l2.0457,0.27173z'/%3E %3Cpath d='m464.15,165.2s3.1891,0.19757,2.8962-1.8252c-0.2892-2.0282-1.7516-2.9153-1.7516-2.9153l-3.8197,2.7156,2.6752,2.0249z'/%3E %3Cpath d='m455.6,161.47s0.85367,0.47145,1.8029,0.0974c0.94867-0.3697,3.4552-3.6293,5.2816-4.025,1.8269-0.39405,2.1907-0.36753,2.5354,0.0514,0.33988,0.41841,0.16914,2.2717-0.24703,2.7882-0.41138,0.52127-5.7214,2.7665-5.7214,2.7665s-1.105-0.066-1.9635-0.26522c-0.86115-0.20298-1.7357-0.57214-1.7357-0.57214l0.0475-0.84117z'/%3E %3Cpath d='m454.61,155.6c-0.80671-1.8842-2.2398-2.6512-2.7777-2.5262-0.53516,0.12396,1.8253,2,2.1668,4.5939,0.34147,2.5916,0.31533,4.3314,0.26945,4.4796-0.0485,0.14668,1.0959,0.16293,1.0959,0.16293l0.21768-0.98945,0.13658-0.70742-0.0128-0.63818-0.15633-1.3402-0.28065-1.0571-0.23263-0.8114c-0.00036,0.00053-0.0139-0.19378-0.42631-1.1665z'/%3E %3Cpath d='m447.06,152.92c-2.4442-2.8525-6.8718-4.884-7.1737-4.884-0.30092,0,5.1536,3.2861,6.3888,5.4014,1.2352,2.1185,1.2789,4.9695,1.8322,5.3586,0.55221,0.39079,1.0661-0.19271,1.1098-0.25712,0.0406-0.066,0.4455-0.64951,0.38202-0.82274-0.0651-0.17159-0.34148-1.3602-0.34148-1.3602l-0.84833-1.4263-0.51381-0.88717-0.83556-1.1226z'/%3E %3Cpath d='m439.82,149.94c-3.0914-2.7237-8.6922-4.0185-13.23-4.0824-4.5379-0.066-6.8563,0.34317-6.1986,2.8276,0.66318,2.4866,2.7078,3.5665,6.5389,3.5665,3.8373,0,4.7539-0.41029,6.8178,0.23601,2.0675,0.64955,3.9595,1.8171,4.707,2.5938,0.7475,0.77838-1.4257-1.901-3.3843-3.37-1.9598-1.469-3.2472-2.2393-3.2472-2.2393s-0.37669-0.80815,2.2692-0.44006c2.6358,0.3659,6.1713,2.0758,7.1315,4.2788,0.95717,2.2046,0.80938,3.415,0.78859,3.8896-0.0245,0.4747,0.91507-0.25927,0.91507-0.25927l0.38362-1.0814s0.15099-0.86388-0.36067-1.8355c-0.51062-0.97266-0.59811-1.2975-1.7885-2.7005-1.1941-1.4062-1.3419-1.384-1.3419-1.384z'/%3E %3Cpath d='m427.23,187.35c1.932-0.0574,6.2488-3.7446,6.8766-8.8707,0.62423-5.1297-2.5584-15.559-3.2963-16.653-0.73789-1.0966,1.1898-0.51909,2.243,0.57541s3.2098,8.5276,3.2098,13.944c0,5.4185-1.0804,6.9712-3.9766,9.7384-2.8967,2.7649-5.2272,2.478-5.2272,2.478l0.17074-1.2119z'/%3E %3Cpath d='m433.94,202.57s0.96358,1.2103,2.0408,0.80595c1.9896-0.7437,5.0549-2.2111,5.0549-5.0702,0-1.8452-2.3828-3.4561-2.4965-4.1484-0.11364-0.69065,0-1.2682,0-1.2682l2.0985,0.46171,0.59972,2.9365s0.8222,0.86547,1.6743,0.5207c0.85527-0.34804,3.2925-2.1316,2.9511-3.8615-0.33774-1.7299-2.6651-3.8599-2.8929-4.7243-0.22784-0.86547,0.0555-1.6141,0.0555-1.6141l1.9896,0.34479,0.60826,2.5272s0.52447,0.87419,1.6626,0.64305c1.136-0.23059,3.1234-2.3048,2.6704-3.2845-0.45564-0.97918-1.9309-3.2861-2.0445-3.5151-0.11419-0.22896-0.0566-1.095-0.0566-1.095l0.79607,0.4471s0.76567,0.30204,2.3001-0.14994c1.534-0.45521,3.0263-1.4923,3.0018-2.5505-0.0192-1.0587-1.1487-2.0742-1.2368-2.6561-0.0843-0.58352-0.0208-0.82274-0.0208-0.82274l1.0025,0.15157,1.2352,1.5335,0.29613,1.8365-0.44552,1.5762-1.8722,2.0331-1.8562,0.77838-0.50849-0.0444,1.1295,1.967-0.36601,2.6155-1.638,1.5102-2.1971,1.3191-0.16913,2.4417-1.2138,2.6366-2.8118,1.6634h-0.82595l-0.32333,1.5979-1.7634,2.5077-3.0455,2.0298-2.2185,0.41028-1.2763-1.8582,0.11259-0.6322z'/%3E %3Cpath d='m450.74,174.88s5.1002,1.4393,4.9407-1.7873c-0.0875-1.8155-4.9956-5.9918-5.3078-6.6827-0.31211-0.69231-0.22781-1.6423-0.22781-1.6423l2.5408,2.3264s3.2424,0.77187,4.1654-1.1015c0.92195-1.8696,0.17874-3.0469,0.0166-3.0896-0.15953-0.0412,0.7443-0.16347,0.7443-0.16347l1.5014,0.30691-0.17875,2.8867-1.6641,7.2581s0.4423,2.8493-1.804,3.0523c-2.2436,0.20406-4.7268-1.3634-4.7268-1.3634z'/%3E %3Cpath d='m455.57,213.55s0.088-1.4706-1.0484-2.4948c-1.1376-1.0225-3.3235-1.9871-3.6767-2.2046-0.35586-0.21436,3.6474,4.5505,3.6474,4.5505l1.0778,0.14885z'/%3E %3Cpath d='m462.96,213.79s-2.5584-3.154-3.109-4.2377c-0.55596-1.0766-1.876-3.4561-2.942-3.5649-1.0628-0.10718,1.0031,3.9324,1.0031,3.9324l4.1505,3.7841,0.89744,0.0861z'/%3E %3Cpath d='m469.96,213.72s-2.1923-4.1468-2.727-5.3586c-0.52983-1.2119-1.6818-4.5181-2.9825-5.4249-1.2955-0.90663,0.17074,1.5118,0.17074,1.5118l1.3862,4.2999,2.4319,3.7397,1.7207,1.232z'/%3E %3Cpath d='m475.12,210.71s-0.1494-3.54-0.57893-6.0052c-0.42255-2.4634-2.3407-4.5159-2.4671-4.4288-0.12964,0.0877,0.1462,4.386,0.1462,4.386l2.8998,6.0479z'/%3E %3Cpath d='m485.77,213.38s-1.7879-4.2572-2.513-6.2675c-0.72459-2.0098-2.5125-5.38-2.704-5.4233-0.19156-0.0433,0.533,3.8664,0.533,3.8664l2.171,6.2242,2.513,1.6z'/%3E %3Cpath d='m495.01,202.23s-1.6396-1.685-5.1765-3.0702c-3.5331-1.3803-7.0695-1.5335-7.0695-1.5335l0.4258,0.45306,1.606,1.364,3.6959,1.8994,4.8254,1.1675,1.693-0.28038z'/%3E %3Cpath fill='%23202020' d='m457.05,204.32s0.0277,3.0831,1.6167,4.9565c1.5926,1.8745,5.3392,5.3008,6.0805,5.9934,0.73843,0.68906,1.3622,4.4932,2.4709,7.6636,1.1034,3.166,1.3654,5.7626,1.8445,6.6543,0.48285,0.89043,1.4742,2.3313,0.7395,2.1878-0.7395-0.14343-1.4235-1.0089-1.877-2.1603-0.45564-1.1508-0.31373-1.1508-0.25237-2.7372,0.0555-1.5859-2.4149-9.7085-3.5529-10.6-1.1376-0.8969-6.361-5.2434-8.3796-8.2412-2.0136-2.996-1.5868-3.6883-1.5868-3.6883l2.8967-0.0292z'/%3E %3Cpath fill='%23202020' d='m465.48,224.63c-1.1087-2.2755-1.3067-4.2918-1.6481-5.6471-0.34147-1.3538-4.7427-5.0388-5.7957-5.5317-0.79608-0.37242-2.4543,0.10067-3.1208-0.40218-0.66586-0.50285-4.8286-5.2266-4.8286-5.2266s-0.62585,0.58999-0.42579,0.76161c0.20009,0.17484,4.5149,4.8407,6.0741,6.3364,1.567,1.4988,2.4149,4.8412,3.5524,7.4344,1.138,2.5884,0.68237,2.0725,0.7966,3.3386,0.11365,1.2698,0.90972,1.9919,1.7031,1.9919,0.79447,0,0.99457-0.37564,0.69899-0.59378-0.302-0.21434-1.9214-2.1153-2.8572-4.5803-0.85474-2.2474-1.9603-6.3941-3.3235-7.9527-0.0875-0.0958-0.18995-0.21759-0.30681-0.34642,0.32175-0.0379,0.86436-0.1402,1.6967-0.1862,1.0538-0.0563,5.396,3.9486,5.77,5.1297,0.36708,1.1822-0.0315,1.6406,1.7879,5.59,1.8168,3.9486,2.6672,4.8688,2.6672,4.8688h0.31693c-0.00036,0.00054-1.6519-2.7085-2.7568-4.9841z'/%3E %3Cpath fill='%23202020' d='m458.65,198.49s3.1533,1.9881,4.0876,2.2474c0.93478,0.25873,1.6188,0.34641,1.6188,0.34641s0.47005,5.7498,2.7691,8.9877c2.2969,3.2434,4.1723,4.4104,4.1723,4.4104s0.0859,6.2622,1.7906,10.587c1.7063,4.32,2.0446,9.5482,1.661,10.368-0.38362,0.82113-1.8338-2.5478-2.7664-5.5301-0.9396-2.983-1.8349-6.2194-2.4725-8.2097-0.63812-1.9886-2.386-4.9727-3.364-5.7925-0.98388-0.82112-0.19368-0.73232,0.38202-0.21596,0.57519,0.51909,2.2361,2.5705,3.3022,5.8796,1.0628,3.304,1.4886,6.6533,2.0638,6.6762,0.57573,0.02,1.0207-0.54071,1.0031-1.2119-0.0229-0.66576-0.7459-2.3974-1.2762-5.4874-0.53624-3.0896-1.0692-5.2055-1.5799-6.0709-0.51329-0.86387-1.2576-1.0155-3.2355-4.4732-1.9811-3.4561-2.8556-5.3789-3.197-6.9797-0.34147-1.5995,0.0619-1.4457-0.27905-1.685-0.33826-0.23708-0.59329,0.0232-2.1027-0.81948-1.5142-0.84277-2.577-3.0263-2.577-3.0263z'/%3E %3Cpath fill='%23202020' d='m466.82,197.32s1.9309,1.4988,3.0087,1.9589c1.0804,0.46008,2.6411,0.54563,2.6411,0.54563s-0.39325,5.4463,1.7357,8.9914c2.1294,3.5432,4.3431,5.6156,4.3431,5.6156s0.34148,1.3272,1.0239,8.93c0.68242,7.6092,0.70855,7.7497,0.90705,10.804,0.19955,3.0539,0.29399,13.875-0.14351,13.542-1.6449-1.2682-0.28279-7.1459-1.105-9.5631-0.82381-2.4238-2.1289-2.8276-3.7204-9.6801-1.5911-6.859-0.57034-8.416-1.7031-10.978-1.1359-2.5657-2.641-2.7952-2.641-2.7952s2.1001,0.40434,2.9809,2.5641c0.88253,2.1602,1.0175,7.9009,1.7356,10.747,1.6172,6.424,3.833,9.678,3.833,9.678s-0.48444-8.0655-1.1087-12.646c-0.62585-4.5841-0.59437-8.4112-1.4464-10.169-0.85528-1.7608-2.7014-3.1719-3.8063-5.5056-1.1082-2.3329-1.5052-6.9135-2.0478-8.0943-0.53677-1.1822-0.84513-0.81461-1.6156-1.1226-2.5002-1.0089-2.871-2.8244-2.871-2.8244z'/%3E %3Cpath fill='%23202020' d='m472.64,194.33s1.7047,1.8994,4.0854,3.3126c2.3898,1.4111,3.5806,0.98132,3.951,1.2677,0.36867,0.28851-0.48394,5.1281,2.0168,9.593,2.5002,4.4666,3.4083,4.5527,3.4654,5.1611,0.0555,0.59972,0.51006,13.768,0.82381,18.232,0.31049,4.465,0.65036,19.446-1.1946,19.446-1.8444,0-0.17021-11.065-1.0788-13.656-0.91186-2.5949-0.87879-1.8446-1.7586-3.914-0.88413-2.079-0.87131-10.281-2.274-15.13-1.0484-3.6277-2.1305-4.2063-2.1305-4.2063s1.7655,0.94942,2.5845,3.9486c0.8238,2.9944,1.0804,13.052,2.0446,14.661,0.96358,1.6157,2.3567,3.6028,2.6704,5.1032,0.31373,1.4955-0.19848-19.103-0.62424-20.34-0.42419-1.2417-4.5736-8.7013-4.8873-12.821-0.3084-4.1186-0.45513-4.5246-0.81899-4.8391-0.3735-0.3199-1.5601-0.0595-3.5204-1.9026-1.9634-1.8431-3.3544-3.9173-3.3544-3.9173z'/%3E %3Cpath fill='%23202020' d='m482.01,196.7c0.11685-0.39568,1.3002,2.2144,5.0058,3.685,3.7055,1.469,7.2426,1.2103,7.7117,1.5979,0.46794,0.38918,2.8129,5.9656,2.8945,13.395,0.0897,7.436-1.2773,6.743-2.4266,13.141-1.1487,6.3957-1.1941,19.4-1.916,21.389-0.34306,0.73345-0.72512,1.0355-1.1103,2.2918-0.38203,1.2498,0.29612,3.6287-0.85314,3.6715-1.1477,0.0427-1.2763-1.8138-1.2763-2.8092,0-0.99436,1.1946-4.5359,1.1946-8.081,0-3.5454-0.76888-3.9757-1.2805-8.2129-0.5106-4.2328-0.55274-17.715-1.0207-19.012-0.46844-1.2942-2.7825-4.1008-2.7825-4.1008s2.4847,1.5941,3.0813,3.4079c0.59437,1.8187,0.65357,16.79,1.32,19.796,0.68243,3.0652,0.46793-0.69232,0.72458-2.4239,0.25343-1.7262,1.1503-9.0737,1.0206-13.006-0.12857-3.9292-1.7911-12.444-3.1533-13.871,0,0,0.70855,0.82599,1.4891,2.6972,0.0192,0.053,0.50047,0.54565,1.0591,0.86874,0.5901,0.3394,1.2645,0.5126,1.2843,0.57375,0.0192,0.0444-0.74751-0.0644-1.351-0.32693-0.44657-0.1927-0.7731-0.55697-0.75873-0.52234,0.83978,2.2241,1.6866,5.6632,1.7677,10.58,0.11737,6.6987-0.978,21.437,0.088,21.608,1.0661,0.17483,0.85528-8.0366,1.9603-14.691,1.105-6.6559,2.5968-7.6091,2.1289-13.052-0.46793-5.4446-1.9149-11.323-3.0636-12.058-1.1487-0.73346-4.4322-0.47469-7.3313-2.3345-2.8919-1.856-4.5272-3.8068-4.4066-4.2009z'/%3E %3Cpath fill='%23202020' d='m435.05,204.2s1.0677,0.47471,2.3012-0.12828c1.2384-0.60676,4.517-3.1973,4.517-4.2804,0-1.0798,0.0454-2.1597,0.0454-2.1597s0.0406,0.47634,0.98016,0.60351c0.93317,0.1337,3.618-1.8994,3.8277-3.1952,0.21608-1.2963,0.21608-3.586-0.0811-4.0612-0.29933-0.47633,0.80777,0.4747,1.3606-0.0444,0.55435-0.51909,3.1528-2.2046,3.1138-3.9324-0.0454-1.7294-1.4513-3.3289-1.4513-3.3289s1.279,0.17321,2.043,0c0.76989-0.16942,3.3251-1.6834,3.2386-3.2395-0.0859-1.5562-0.9764-3.9324-2.982-4.1056,0,0,1.4918,0.34642,2.9414-0.17159,1.447-0.5191,1.9603-1.3408,1.9603-2.9846,0-1.6406-2.9399-5.1839-3.4521-5.4853-0.51008-0.30204,3.1512,1.0371,4.0891-0.43357,0.93265-1.469,1.0629-2.5062,0.80778-3.3256-0.25504-0.82273-1.0223-1.0371-1.0223-1.0371s1.5798,0.43032,3.7087-0.64952c2.1294-1.0798,4.0032-2.5061,4.9834-2.4634,0.97855,0.0444-3.1106,2.2025-3.3251,3.415-0.0859,0.49961,1.1151,1.357,2.965,2.7124,0.11684,0.0823,0.17179,0.16129,0.35749,0.26035,0.83823,0.45305,4.0209,0.58351,4.2353,0.74371,0.26624,0.19649-3.0754,0.12395-2.7894,0.34155,2.2495,1.7196,4.9834,4.0233,7.4857,7.0631,0.0944,0.11259,0.6243,0.57214,1.2341,0.74857,0.7459,0.21272,1.5958,0.14507,1.7063,0.28688,0.0811,0.10879-2.1598-0.0563-2.0787,0.0514,1.6022,2.0872,3.0487,4.2009,4.294,6.1596,0.0875,0.13857,0.60934,0.74858,1.2058,1.0057,0.65362,0.28038,1.3867,0.21272,1.4758,0.36104,0.16646,0.25927-1.8231,0.0103-1.6705,0.26198,2.4895,4.0894,4.3362,7.8865,4.3362,7.8865s-4.0112-7.0535-8.9129-12.544c-4.8985-5.4874-6.0479-6.221-6.3028-5.7017-0.2561,0.51801,3.6634,5.357,5.7503,8.7697,2.0851,3.4166,3.9824,7.6626,3.9824,7.6626s-4.9198-10.211-11.819-16.477c-6.9039-6.2654-7.6241-7.3024-8.393-7.0438-0.76722,0.26036-1.36,4.884-0.89369,5.8336,0.46793,0.95156,5.4933,4.7535,9.794,9.8105,4.3031,5.0556,9.7582,13.741,9.7582,13.741s-3.8752-6.2654-10.436-13.224c-6.5614-6.9568-9.071-8.5554-9.5824-8.5127-0.51223,0.0427-0.55756,1.2975-1.32,2.3345-0.76887,1.0355-2.3455,0.90662-2.3908,1.3835-0.0384,0.47471,5.5424,5.6156,6.6474,6.221,1.1066,0.60517,1.7031,0.30366,2.5552,0.77839,0.85153,0.4747,1.7746,1.2682,1.7746,1.2682s-1.1749-0.44709-2.0286-0.70582c-0.85368-0.25927-1.7063-0.30366-1.7063-0.0433,0,0.25766,4.5181,5.7888,5.2816,6.1355,0.76882,0.34643,1.1946,0.17322,2.2169,0.56242,1.0207,0.38917,2.4741,1.4263,2.4741,1.4263s-1.5815-0.90881-2.6886-1.1248c-1.105-0.21596-1.5745,0-1.534,0.30367,0.0454,0.30149,3.4521,4.6664,3.2829,4.7535-0.16912,0.0861-5.2821-6.0511-9.6283-9.896-4.3463-3.8469-6.3038-4.668-6.5176-4.5375-0.21128,0.12882-0.0843,1.2547-1.1503,1.6423-1.065,0.38918-2.0451,0.51908-2.0451,0.90662,0,0.38918,3.9205,4.0629,6.6864,7.1315,2.7691,3.0669,5.1552,5.964,5.1552,5.964s-2.8102-2.8098-5.8769-5.7048c-3.0684-2.8953-4.6414-4.0179-4.9407-3.8452-0.2993,0.17158-0.33986,1.6406-0.0443,2.0298,0.29772,0.38918,5.9667,7.0882,5.7962,7.2597-0.17073,0.17321-6.688-8.0366-7.1138-8.0366-0.42952,0-0.68457,1.0355-1.1087,1.5118-0.42898,0.47632-2.2585,0.47632-2.2585,1.1226,0,0.64951,9.2003,9.6785,8.9455,9.8944,0,0-7.6225-6.5672-7.8795-6.1783-0.25717,0.38919,3.1917,6.6976,2.9804,6.828-0.21396,0.13045-4.4727-6.6116-4.859-6.5672-0.37721,0.0412-0.33986,0.77674-1.4464,1.7706-1.105,0.99436-2.5109,0.56242-2.5552,0.99436-0.0422,0.43194,6.3482,7.5204,6.1761,7.6487-0.17074,0.12882-6.4721-6.742-6.6442-6.353-0.0422,0.1023-0.38201,0.39892-0.21128,0.99435,0.46846,1.6574,1.8904,4.6713,1.7031,4.9252,0,0-2.0446-4.1917-2.6-4.0185-0.55275,0.17321-0.55275,0.99595-1.4923,1.5995-0.93264,0.60516-1.7004,0.47632-1.7879,0.90661-0.0827,0.43194,1.1082,1.1675,1.622,2.1635,0.50688,0.99436,0.93638,3.1557,0.93638,3.1557s-0.64027-1.8187-1.5345-2.9841c-0.89369-1.1675-1.7063-1.9459-2.386-1.9459-0.68083,0-1.1503,0.64957-1.1503,0.64957l-0.64027-1.514z'/%3E %3Cpath fill='%23202020' d='m494.74,201.99s2.0851-0.12829,2.3407-0.56077c0.25665-0.43356-0.76728-0.13045-2.6411-2.1597-1.8728-2.0331-6.6575-15.89-11.884-22.863-8.5554-11.411-16.569-16.636-16.569-16.636s9.5327,5.5168,16.913,16.292c7.4927,10.949,9.3126,19.534,11.411,21.78,2.1043,2.2474,4.1489,2.6496,4.0352,3.2845-0.11416,0.63493-0.45564,1.095-1.2517,1.2103-0.79287,0.11529-2.727,0.28688-2.727,0.28688l0.37189-0.63386z'/%3E %3Cpath fill='%23202020' d='m431.77,198.97s0.0555,0.16672,0.44178,0.2111c0.39162,0.0493,2.9809-2.5343,2.838-3.2796,0,0-1.1508-0.43194-2.0835-1.3819-0.93639-0.95156-1.1525-2.4634-1.1525-2.4634s0.85367,1.685,1.5766,2.1597c0.72458,0.47471,1.8738,0.73345,2.3001,0.38918,0.42737-0.34643,4.2385-3.1687,4.0043-4.2788,0,0-1.1909,0.0433-2.3012-0.77838-1.1055-0.82114-1.3067-2.5078-1.3067-2.5078s0.71336,1.3553,1.8493,1.9048c1.1311,0.54724,2.2414,0.31611,2.5552-0.0877,0.31213-0.40433,2.8118-3.8339,2.5253-4.8391,0,0-1.2757,0.14344-2.4133-0.66308-1.136-0.80815-1.7309-2.8244-1.7309-2.8244s0.8222,1.7002,2.2692,1.987c1.4496,0.2885,2.6427-0.5754,2.8684-1.6108,0.22622-1.0371,1.0223-4.8986-0.19474-5.8785,0,0-1.8786,0.60515-3.212-0.0855-1.3312-0.69231-1.8151-2.3908-1.8151-2.3908s1.1344,1.5551,2.6358,1.7559c1.5084,0.20137,2.1635-0.6035,2.4154-1.2103,0.25983-0.60516,0.31532-2.793-0.14034-4.0033-0.45351-1.2103-1.3926-1.1248-1.6151-2.9381,0,0-0.48767,0.71882-2.4186,0.71882-1.9304,0-2.9548-2.1895-2.9548-2.1895s1.5377,1.4133,3.069,1.2975c1.5324-0.1153,2.1011-1.3835,2.1337-2.3627,0.0229-0.98131-0.77148-1.8452-1.1941-2.8525-0.4263-1.0089-0.45671-2.2193-0.74002-2.0742-0.28438,0.14344-0.65202,1.0653-2.6427,0.74857-1.9859-0.31502-2.4132-1.6704-2.4132-1.6704s1.4486,1.009,2.5552,0.9218c1.1114-0.0855,1.8167-0.60516,1.8167-1.3532,0-0.75023-0.42257-2.1337-2.9233-4.2658-2.497-2.1316-4.5432-3.599-4.5432-3.599s3.2376,1.7857,5.3376,3.5432c2.106,1.7581,3.2931,3.4577,3.2931,3.4577s2.3044,0.74857,2.5579-0.0298c0.25396-0.77839,0.21608-1.7494-0.51008-3.133-0.70856-1.3521-2.6816-3.37-2.6816-3.37s2.0638,1.7061,3.0423,3.4772c0.97854,1.7722,0.53676,3.0041,0.61782,3.436,0.0875,0.43033,4.3885,2.0959,5.3469,1.5134,0.95877-0.58406,0.51168-1.8371-0.29772-3.1129-0.80778-1.2742-1.4742-2.3329-1.4742-2.3329s1.0047,1.1031,1.726,2.3546c0.72618,1.2547,1.3216,2.249,1.0463,2.8309-0.27478,0.58347-0.87452,0.84278-0.80938,1.0814,0.0651,0.236,1.487,0.9927,2.9388,1.7494,1.4497,0.75669,3.1298,1.4263,3.3448,1.0154,0.2129-0.4119,0.36122-1.4046,0.23689-2.8092-0.13124-1.403-0.93905-3.5432-0.93905-3.5432s0.95557,2.0742,1.1274,3.5432c0.16913,1.4706-0.18887,2.5722,0.14939,3.0896,0.34148,0.51908,1.4043,0.64951,1.4043,0.64951s-0.85154,0.60351-2.7462,0.0427c-1.8952-0.56241-10.031-4.668-10.416-4.2788-0.38202,0.38919,3.792,2.917,5.7097,4.7324,1.9181,1.8138,2.8529,3.7165,2.8529,3.7165s-1.4907-1.2547-2.9372-2.0525c-1.448-0.7995-5.7952-3.0252-6.0741-2.7237-0.27105,0.30365,1.6433,0.69064,1.7895,1.0387,0.14941,0.34642-1.3606,1.7066-1.3606,2.2685,0,0.56077,6.197,4.8607,6.0041,5.3354-0.18996,0.47633-1.5734,1.5995-1.829,1.5351-0.25611-0.066-3.3203-2.4206-3.3203-2.0526,0,0.36807,1.7618,1.8582,1.7442,2.1814-0.0197,0.32476-1.1701,1.1031-0.96251,1.8371,0.21609,0.73505,3.4558,3.3933,3.4329,4.2999-0.0229,0.90662-1.853,1.685-1.5116,2.2685,0.33827,0.58407,2.0008,2.635,2.0008,2.635s-1.7895-1.187-2.3668-1.8122c-0.57519-0.62787-1.7276-1.9881-1.9325-1.7738-0.21556,0.2176-1.3654,2.7454-1.2592,3.3072,0.10885,0.56076,1.5553,1.4246,1.8317,2.9581,0.27798,1.5351-0.21395,3.133-0.32172,3.133-0.10565,0-2.147-2.635-2.5552-2.6777-0.40283-0.0428-0.91346,0.13045-1.2549,0.80003-0.34147,0.66902-1.5356,2.7649-1.383,3.154,0.1446,0.38757,2.1465,0.84277,2.1923,2.4417,0.0422,1.5995-1.2581,3.0886-1.3851,3.0886-0.12806,0-2.4917-3.1757-2.7254-3.1757-0.23531,0-2.9191,2.983-2.9826,3.3489-0.0651,0.36752,1.8301,1.7083,1.4923,2.2274-0.3436,0.51802-1.622-0.19594-2.3471,0.21434-0.72137,0.41247-1.9986,0.92832-2.2559,0.92832-0.25396,0-0.63921-0.86226-0.63921-0.86226z'/%3E %3Cpath fill='%23202020' d='m465.92,159.9s0.21449-0.84224,0.62104-1.2742c0.40281-0.43356,2.0478-2.249,1.4267-2.6149-0.61735-0.3659-2.704,0.30367-4.0241,0.1927-1.3216-0.10554-2.1939,0.2176-6.0281-2.9597,0,0-12.158-8.4998-30.989-9.593-5.9651-0.3448-8.6356,1.7873-8.9193,2.9099-0.0266,0.25874,1.5649-2.4206,7.5546-2.3335,2.6427,0.0281,21.604,1.56,31.436,9.2768,0.51382,0.40217,3.7706,3.5221,6.8168,3.1757,3.0455-0.34642,3.6858-0.69065,3.6207-0.25927-0.063,0.43194-1.0207,1.5562-1.2346,2.0725-0.21128,0.51909-0.42258,1.4706-0.42258,1.4706l0.14247-0.0633z'/%3E %3Cpath fill='%23202020' d='m433.06,162.41s-0.016-0.0547-0.0491-0.15481c-0.1702-0.51801-1.3814-2.2095-3.4419-4.1224-2.4709-2.2918-10.143-5.489-10.525-5.6188-0.38257-0.12992,7.8758,3.8041,10.184,6.0067,3.7018,3.5438,3.8325,3.8896,3.8325,3.8896z'/%3E %3Cpath d='m433.04,175.94s-0.50368-0.83087-2.1192-1.8696c-1.622-1.0371-3.2408-1.469-3.2408-1.469l3.7477,0.95156c1.1087,0.94942,1.6124,2.387,1.6124,2.387z'/%3E %3Cpath d='m432.07,168.89s-0.5106-0.73399-2.8102-1.469c-2.3012-0.73506-2.8529-0.69231-2.8529-0.69231s2.1294-0.90662,3.7461-0.0839c1.6177,0.81895,1.9171,2.2452,1.9171,2.2452z'/%3E %3Cpath d='m430.71,163.1s-0.46952-1.0371-2.5141-1.7706c-2.0445-0.73557-3.4948-0.86548-3.4948-0.86548s2.1289-0.60349,4.1772,0.21599c2.0445,0.82059,1.8317,2.42,1.8317,2.42z'/%3E %3Cpath d='m428.24,159.38s-0.59971-0.81953-4.429-1.7262c-3.8373-0.91042-5.3275-0.95322-5.3275-0.95322s5.4543-0.43031,6.9012,0.17484c1.4459,0.60356,2.8556,2.5045,2.8556,2.5045z'/%3E %3Cpath d='m421.21,155.36s-2.3396-0.64791-4.5987-0.82113c-2.2585-0.17321-5.7962,0.12883-5.7962,0.12883s6.5624-1.0355,8.307-0.64631c1.7484,0.38702,2.0878,1.3386,2.0878,1.3386z'/%3E %3C/g%3E %3Cg id='claws' fill='%23f8c83c' stroke='%23977c2e' stroke-width='0.35'%3E %3Cpath d='m399.63,236.56s1.1648,2.046,3.4643,2.1316c2.3012,0.0861,4.0892,3.3716,4.0892,3.3716l-2.5279,2.478-6.0757,0.28525-1.9582-3.1394,3.0082-5.127z'/%3E %3Cpath d='m399.77,234.46c0.19849-0.40054-1.7895-4.3232-3.2098-4.9841-1.4198-0.65929,0.48286,1.2698,0.17073,2.0742-0.31158,0.80815-0.52181,1.8024-0.4087,1.9459,0.11473,0.14344,1.1744,1.8019,0.60719,2.5505-0.56931,0.74857,2.8406-1.5865,2.8406-1.5865z'/%3E %3Cpath d='m398.68,240.44s1.081,0.53912,1.9325,0.29012c0.8526-0.25061,1.6092-1.1166,1.6092-1.1166'/%3E %3Cpath d='m397.58,238.92s3.4099-2.478,3.126-3.8004c-0.28598-1.3272-0.96625-1.2693-1.4214-1.1524-0.45353,0.11367-2.5552,1.8431-2.6678,2.2452-0.11418,0.40271,0.96304,2.7075,0.96304,2.7075z'/%3E %3Cpath d='m395.17,240.62s0.62424,1.6439,1.7308,1.6439c1.1087,0,2.6987-0.89364,2.7264-1.5535,0.0293-0.66741-1.1076-1.8761-1.8461-2.2193-0.73788-0.3448-2.4421,0.54558-2.4421,0.54558l-0.16914,1.5833z'/%3E %3Cpath d='m398.27,238.38c-0.16968,0.51422-2.329,1.5248-3.0391,1.5827-0.70856,0.0574-2.1571-1.7575-1.5628-2.0184,0.59811-0.25928,1.3376-0.23275,1.8754-0.51746,0.5405-0.29177,0.68242-1.009,0.99404-1.0387,0.31212-0.0281,1.193,0.20299,1.4198,0.74697,0.22836,0.55051,0.48233,0.72533,0.31267,1.245z'/%3E %3Cpath d='m396.05,239.81s-3.348,4.5262-4.74,4.2967c-1.392-0.23059,0.56718-6.4256,0.56718-6.4256s0.5405,0.34695,1.6471,0.69444c1.1076,0.34318,2.2153,0.74697,2.5258,1.4344z'/%3E %3Cpath d='m390.09,236.59s4.3175,0.74803,4.5165,1.4414c0.19847,0.69066-2.0739,1.6125-3.2947,1.6125-1.2218-0.00036-1.2218-3.0539-1.2218-3.0539z'/%3E %3Cpath fill='%23202220' stroke='none' d='m379.35,243.13s0.57039,2.0758,2.4447,2.1916c1.8738,0.1153,3.6346-1.9605,3.6346-1.9605l-4.4306-1.7278-1.6487,1.4966z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m379.35,243.13-0.0966,0.0281c0.00037,0.0103,0.14621,0.53587,0.53409,1.0869,0.38522,0.54565,1.0239,1.1226,2.0019,1.1789l0.15686,0.007c1.8877-0.0114,3.5492-2,3.5593-2.0016l0.0944-0.11367-4.6232-1.8008-1.7426,1.5833,0.0187,0.0606,0.0971-0.0287,0.0715,0.0763,1.5996-1.4561,4.3703,1.7067,0.0373-0.0958-0.0758-0.0677s-0.1003,0.11746-0.28437,0.30203c-0.54474,0.54726-1.8162,1.6292-3.1223,1.6238l-0.14619-0.003c-0.89797-0.0547-1.4811-0.577-1.8461-1.0934-0.1846-0.25927-0.31052-0.51585-0.39002-0.70423-0.04-0.0974-0.0688-0.17809-0.088-0.23112l-0.0251-0.0839-0.10085,0.0265,0.0715,0.0763-0.0715-0.0763z'/%3E %3Cpath fill='%23202220' stroke='none' d='m380.6,242.55s0.73681,1.56,3.1805,1.6174c2.4421,0.0563,4.373-1.96,4.373-1.96l-3.8624-3.0539-3.6911,3.3965z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m380.6,242.55-0.0902,0.0466c0.004,0.0178,0.77791,1.6157,3.2675,1.6736h0.10672c2.45-0.003,4.3346-1.9854,4.3436-1.9887l0.0795-0.0823-4.0208-3.179-3.8112,3.5086,0.0347,0.0677,0.0902-0.0466,0.0683,0.078,3.6276-3.3386,3.7956,2.9987,0.0619-0.0801-0.0742-0.0747-0.0811,0.0855c-0.38469,0.36482-2.0707,1.8484-4.1142,1.8452h-0.10139c-1.1989-0.0314-1.9688-0.4222-2.4452-0.80815-0.23531-0.19269-0.39804-0.37727-0.50048-0.51746-0.0523-0.0709-0.0891-0.12828-0.11205-0.17105l-0.0315-0.0595-0.0934,0.0422,0.0683,0.078-0.0683-0.078z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m380.93,242.91s1.0788,0.89311,2.3567,0.96455c1.2789,0.0709,2.8694-0.33127,2.8694-0.33127l-1.4635,0.53046-1.05,0.11691-0.99403-0.15805-0.89369-0.33289-0.69627-0.518-0.12858-0.27172z'/%3E %3Cpath fill='%23202220' stroke='none' d='m383.78,240.76s1.0788,2.6528,3.3507,2.3643c2.2713-0.29012,2.3279-1.6124,2.3279-1.6124l-2.5552-3.6899-3.1234,2.9381z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m383.78,240.76-0.0944,0.0428c0.002,0.007,0.24757,0.61002,0.75659,1.2168,0.50634,0.61056,1.2859,1.2314,2.346,1.2314,0.11525,0,0.23423-0.01,0.35534-0.0244,1.1541-0.1456,1.7661-0.55916,2.0814-0.94995,0.31799-0.38918,0.33827-0.74697,0.33827-0.76161l0.00036-0.0335-2.6443-3.8133-3.2605,3.0664,0.0266,0.0676,0.0944-0.0422,0.0699,0.079,3.0375-2.8558,2.4885,3.5898,0.0827-0.0606-0.10083-0.004-0.006,0.0449c-0.0443,0.22409-0.2812,1.2114-2.2334,1.4674-0.11364,0.0163-0.22356,0.0227-0.33026,0.0227-0.97748,0-1.7009-0.57374-2.1897-1.1556-0.2433-0.29014-0.42416-0.58353-0.54686-0.8027-0.0592-0.1088-0.10297-0.20137-0.13392-0.26199-0.0293-0.066-0.0422-0.10122-0.0422-0.10122l-0.095,0.0379,0.0699,0.079-0.0699-0.079z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m384.1,241.28s1.3622,1.6574,2.5568,1.6309c1.1903-0.0298,1.9448-0.48012,1.9448-0.48012l0.056,0.18999-0.62585,0.31666-1.0799,0.21921-1.106-0.14668-0.90865-0.54618-0.83717-1.1838z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m379.79,243.94s1.05,1.0782,2.0152,1.1226c0.96731,0.0427,2.4431-0.77838,2.4431-0.77838l0.18462-0.0579-0.25451,0.23113-0.99558,0.54617-1.2069,0.34642-0.95076-0.1732-0.72404-0.44493-0.44018-0.56077-0.071-0.23112z'/%3E %3Cpath d='m389.83,236.36c1.0218-0.14344,3.1512,2.767,3.1512,4.2063,0,1.4409-0.62317,3.6022-1.6748,3.5448-1.0522-0.059-3.4371-2.1911-3.976-3.2823-0.5405-1.0966-1.0783-1.8468-0.68028-2.4244,0.39536-0.57648,3.18-2.0444,3.18-2.0444z'/%3E %3Cpath d='m379.24,236.62s-1.7041-1.3224-2.386-0.63167c-0.68189,0.68905-0.45513,2.9943,0,3.4561,0.45351,0.46171,2.497-1.0966,2.497-1.0966l-0.11098-1.7278z'/%3E %3Cpath d='m379.01,238.23s-2.2724,0.23276-2.2724,1.2699c0,1.0387,1.0794,2.1316,1.3061,2.3611,0.22569,0.2322,2.2718-0.92181,2.2718-0.92181l-1.3056-2.7091z'/%3E %3Cpath d='m379.92,240.13s-2.33,0.6923-2.33,1.4972c0,0.8027,1.0223,2.3054,1.7591,2.3054,0.74055,0,1.3093-1.4447,1.5911-1.7294,0.28598-0.28904-1.0202-2.0731-1.0202-2.0731z'/%3E %3Cpath d='m381.06,233.39s-0.45458-0.63167-1.4208-0.23113c-0.96518,0.40433-2.0445,1.3835-1.8738,2.9402,0.17073,1.5529,0.73788,2.5916,0.73788,2.5916l3.522-1.2114-0.96519-4.0894z'/%3E %3Cpath d='m381.34,236.1s-3.0082,0.97972-3.1223,2.1305c-0.11471,1.154,0.68189,2.3086,1.4768,2.5343,0.79554,0.23276,3.3502-2.2452,3.3502-2.2452l-1.7047-2.4195z'/%3E %3Cpath d='m383.95,240.89s-2.9532,1.9535-3.3512,1.9535c-0.39749,0-1.4768-1.5546-1.2517-2.59,0.22836-1.0371,2.2164-1.7857,3.0119-2.0758,0.79608-0.2885,1.5911,2.7124,1.5911,2.7124z'/%3E %3Cpath d='m386.54,230.17s-0.93746-0.77998-2.7264-0.64789c-1.7895,0.12827-3.1085,2.4617-3.3219,3.6293-0.21394,1.1637-0.0432,3.37,0.63866,3.7164,0.68029,0.34317,4.3869-2.6382,4.3869-2.6382l1.0228-4.0596z'/%3E %3Cpath d='m382.92,239.02c-1.2352-0.13153-2.3428-1.9042-2.131-2.9808,0.21181-1.082,2.6421-2.9419,3.9194-2.7237,1.2768,0.21434,1.0207,3.415,1.0207,3.415s-1.5756,2.4185-2.8092,2.2896z'/%3E %3Cpath d='m386.85,238.75s-0.62478,1.4426-1.8749,2.0774c-1.2491,0.63113-1.987,0.11204-2.7264-0.9234-0.73682-1.0387,0.34147-1.5004,0.91025-2.0195,0.56717-0.51422,2.2142-0.92019,2.2142-0.92019l1.4769,1.7857z'/%3E %3Cpath d='m384.86,234.95s-1.392,1.121-0.59545,2.4206c0.79448,1.2975,1.4203,1.7559,2.4122,1.9275,0.99558,0.17483,1.646-0.22896,2.4437-1.1822,0.79501-0.94996,1.9587-1.3802,1.8461-2.5641-0.11418-1.1805-0.56877-2.1023-1.2789-2.4482-0.70856-0.34372-2.8673,0.0308-4.8276,1.8463z'/%3E %3Cpath fill='%23202220' stroke='none' d='m388.82,229.39s-1.4364-0.55104-2.545,0.0991c-1.1071,0.6479-1.8733,1.967-1.9144,3.1741-0.0437,1.2119,0.21503,2.9072,0.21503,2.9072s1.5201-0.43356,2.4997-1.2547c0.97908-0.81947,1.3029-1.0436,1.1648-1.4658-0.0827-0.2571-0.48445-0.54237-0.48445-1.5578,0-1.7732,1.0644-1.902,1.0644-1.902z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m388.82,229.39s-1.6594-0.28039-2.489,0.26035c-0.83075,0.53751-1.534,1.3391-1.8328,2.419-0.29985,1.082-0.0859,1.3619-0.0859,1.3619s-0.1558-0.93965,0.13872-1.8398c0.34041-1.0306,1.1872-2.058,2.0136-2.3004,1.0079-0.29499,2.2553,0.0991,2.2553,0.0991z'/%3E %3Cpath d='m431.58,260.88s1.1994-0.50502,2.028-0.95914c0.83289-0.45684,2.6219-1.6228,2.6219-1.6228l0.5752,2.9846-2.3001,1.7722-2.004,0.02-1.2112-0.88391,0.29025-1.311z'/%3E %3Cpath d='m428.37,261.18s0.031,0.0379,1.4321,0.0693c1.3942,0.0363,1.5308-0.48607,1.7783-0.36591,0.24703,0.12071,0.64027,1.6109,0.64027,1.6109l-0.51061,0.93531-2.0136,1.141-1.6999-0.93531-0.13873-2.3497,0.5122-0.10555z'/%3E %3Cpath d='m444.32,260.22s-0.40015-0.66741-1.1978-1.3586c-0.795-0.69391-2.8412-2.478-2.8412-2.478l-0.0144,6.4668,2.9841-0.0731,1.4219-1.9995-0.35268-0.55751z'/%3E %3Cpath d='m428.37,261.18s-0.44337-0.65443-1.7079-0.51584c-1.2549,0.13694-2.5877,1.1637-2.7211,2.0363-0.13979,0.86767,0,3.3906,0.68082,3.875,0.67922,0.48337,1.5329,0.72694,2.8945,0.38053,1.3659-0.34642,8.3155-4.635,8.3155-4.635s-0.81739,0.17268-1.7714,0.38432c-0.95235,0.20622-1.8397-0.21164-1.8397-0.21164s-0.95396,1.0734-2.043,1.2471c-1.0943,0.17267-1.3963-0.51963-1.6044-1.0355-0.2033-0.51747-0.2033-1.5254-0.2033-1.5254z'/%3E %3Cpath d='m433.01,263.42s-1.0239,0.39079-1.4096,0.67226c-0.38201,0.27931-1.757,0.76375-1.757,0.76375l0.52502,2.1088,2.958,0.75562,1.8546-1.5318,0.0213-2.1218-2.1923-0.64683z'/%3E %3Cpath d='m446.77,261.93s-0.46792-0.43357-1.0238-1.0587c-0.54901-0.62462-1.232-0.75509-1.4251-0.64951-0.19208,0.11042-1.5942,1.9226-1.5942,1.9226l-0.10725,1.3651,1.638,0.88552,1.1503,0.21435,1.5132-0.99437-0.151-1.685z'/%3E %3Cpath d='m436.61,260.89s-1.3216,0.6019-1.9619,1.1443c-0.64025,0.54073-1.638,1.1443-1.638,1.3819,0,0.236,1.4918,1.7825,1.4918,1.7825l1.5116,0.12233,3.2787-2.2934-0.21449-2.0958-2.4677-0.0417z'/%3E %3Cpath d='m449.07,263.61s-0.25238-0.51801-0.76405-0.99435c-0.51222-0.47688-1.1487-0.73233-1.5361-0.69065-0.38043,0.0412-1.661,1.9459-1.661,1.9459l-0.159,0.53752,1.1828,1.3732,2.0969,0.50936,1.4464-1.4593-0.60612-1.2216z'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' d='m443.6629 265.9017 1.4907 0.2571s-0.0443 0.3913 0.3852 0.7372c0.4242 0.3443 0.4679 0.0817 0.4679 0.0817s0.2129 1.43 1.7879 2.6382c0 0 1.8338 0.6068 2.7681 0.0877 0.9396-0.5196 0.8083 0.1597 0.8083 0.1597l2.6427-3.2694s0-0.6512-0.6387-0.6923c0 0 0.4663-2.0314-1.2368-2.4655-1.7005-0.4319-3.0669 0.1732-3.0669 0.1732s-1.3067 2.3974-2.0851 2.0742c-0.1819-0.0763-0.6274-0.315-0.938-0.6463-0.7203-0.7811-0.938-1.167-0.938-1.167s-0.5522 0.1727-1.1909-0.2604c-0.6419-0.4319-1.1909-1.4712-1.1909-1.4712s-0.9801-0.1727-1.32-0.5158c-0.3415-0.3464-0.6957-1.0284-0.6957-1.0284l-2.4378 1.7521s-0.0768 0.7735-1.4988 1.8106c-1.4187 1.0409-2.2692 1.0409-2.2692 1.0409s-0.3964 2.1289-1.9896 1.7803c-1.5894-0.3426-2.6688-2.1267-2.6688-2.1267s-1.1376-0.1732-1.8754 0.8027c-0.7395 0.9813-1.0826 1.3288-1.0826 2.307 0 0.9792 0.6274 2.3605 1.1381 2.8228 0.5138 0.4601 2.1059 1.7262 3.9755 0.747 1.877-0.9781 1.2512-2.5906 1.2512-2.5906s-0.0566 0.1158 1.0794-0.6344c1.1344-0.7508 2.3823-1.9015 3.2371-2.2458'/%3E %3Cpath d='m440.75,252.87,0.0128,4.1803s0.51008,3.7148-0.30198,4.8823c-0.80671,1.167-3.7482,0.90722-4.1707-0.0871-0.42577-0.9927-0.21395-4.2323-0.21395-4.2323l4.6739-4.7432z'/%3E %3Cpath stroke-linecap='round' stroke-linejoin='round' d='m437.45,265.54s-0.62583,1.1069,1.3083,1.2666c0.54901,0.0482,0.91506-0.14831,1.1621-0.43032,0.49941-0.57701,0.39004-1.0566,0.39004-1.0566s-0.17073,1.5448,1.5681,1.6022c1.9341,0.0693,1.7634-1.7857,1.7634-1.7857'/%3E %3Cpath fill='%23202220' stroke='none' d='m421.55,268.97s-1.0762-1.8187,0.20168-2.4785c1.2773-0.66308,1.9598,0.0298,2.7232,0.0579,0.76727,0.0298,0.51701-1.966,0.34787-2.3697-0.17234-0.40379-0.57518-1.2596-0.88407-1.4891-0.31373-0.23221-4.5379,0.18998-4.5059,3.0258,0.031,2.7237,2.1171,3.2536,2.1171,3.2536z'/%3E %3Cpath fill='%23202220' stroke='none' d='m428.17,275.74s-1.3622-1.9302-0.62371-3.0815c0.74109-1.154,1.3029-0.46172,1.6775-0.49257,0.36548-0.0265,0.53623-0.86281-0.088-2.1289-0.62745-1.2698-1.391-1.9048-1.8461-1.9622-0.45565-0.0573-3.0002,1.8138-2.4965,4.2063,0.60131,2.8921,3.3769,3.4588,3.3769,3.4588z'/%3E %3Cpath fill='%23202220' stroke='none' d='m452,273.41s4.5928,1.928,4.9114-2.7091c0.17074-2.4764-2.0446-4.1912-2.7531-4.1749-0.48394,0.009-0.85153,0.28526-1.6743,1.265-0.82541,0.98133-1.4512,1.6985-1.1114,2.0775,0.34146,0.3724,1.7031-0.40379,2.3012,1.0636,1.0239,2.5083-1.6737,2.478-1.6737,2.478z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m428.17,275.74s-3.5785-0.7897-3.5476-4.2869c0.0176-2.3334,2.6165-3.3716,2.6165-3.3716s-2.4037,1.2764-2.4458,3.3273c-0.0747,3.5584,3.3769,4.3314,3.3769,4.3314z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m421.6,268.97s-2.0649-0.45523-2.2895-3.4263c-0.22516-2.9694,4.675-2.8531,4.675-2.8531s-4.6974,0.22462-4.4509,3.0702c0.25345,2.937,2.0654,3.2092,2.0654,3.2092z'/%3E %3Cpath fill='%234b4139' stroke='none' d='m452,273.41s0.92142,0.44547,1.9763,0.40433c1.05-0.0412,2.3145-0.31827,2.7531-2.0742,0.43858-1.7559,0.25663-2.589-0.90063-4.1386-0.81259-1.0782-1.5574-1.0582-1.5574-1.0582s0.7918,0.15642,1.4171,1.1329c0.62584,0.98133,1.5345,2.0774,0.91025,4.0494-0.62744,1.9735-2.5269,2.0146-3.2226,1.9568-0.69364-0.0574-1.376-0.27227-1.376-0.27227z'/%3E %3C/g%3E %3Cg id='body' fill='%234d2a15'%3E %3Cpath fill='%23904720' d='m397.2,176.12-0.86435-0.17862,0.62425-1.4452,2.417-0.88225,2.4116-0.0974,2.5397-0.10284,1.1685,0.80648,0,0,1.3019,3.0094-4.8126,2.8687-0.77898,0.2598-0.29878-1.1854-0.7363-1.9431z'/%3E %3Cpath fill='%23202020' d='m442.21,245.84,0,0-0.29879-7.2204-19.469,6.008,7.7098,7.215z'/%3E %3Cpath fill='%23d2a567' d='m406.16,233.27-1.638-1.2845s-1.1754-0.82924-1.8285-1.0306c-0.65149-0.20298-1.4902-0.0427-1.4902-0.0427l-0.26837,0.38378,0.2545,0.66794,1.7762,2.071s2.8961,1.4988,2.9671,1.5286c0.0704,0.0281,1.0484,1.009,1.0484,1.009l0.68349,0.28849-1.5046-3.5908z'/%3E %3Cpath fill='%23d2a567' d='m405.7,236.33,1.1098,0.14614,1.1098,1.272,0.68828,1.3586,0.90703,1.797,0.28812,1.0446-2.1715-0.4763,0,0-6.3066-1.954,0.54422-1.4993,1.1044-1.0122,0.91236-0.40053,1.2859-0.19486z'/%3E %3Cpath fill='%23d2a567' d='m409.8,241.52,0,0,1.0404-0.0866,0.70429-0.60079-0.3308-2.3599,0.38415-7.5614-5.1221-6.0567-1.0458,3.4911,1.5046,6.1216,1.1098,3.6697z'/%3E %3Cpath fill='%23ab6d29' d='m406.13,227.69s-0.33881,0.63166,0.0854,2.6182c0.42684,1.9865,1.1648,6.4272,2.9255,9.453,1.7602,3.0204-1.7025-2.3908-1.7025-2.3908s-2.7264-6.1387-2.3012-10.777c0.42685-4.6383,0.99297,1.0966,0.99297,1.0966z'/%3E %3Cpath fill='%23ab6d29' d='m409.85,231.52s-1.1071,1.4431-1.2779,2.5077c-0.17073,1.0636,0.0854,2.8802,0.0854,2.8802s-0.17073-1.3797,0.96518-1.7018c1.136-0.3134,0.99297,3.1167,1.05,3.4295,0.056,0.31827,0.65464-6.135,0.65464-6.135l-1.4774-0.98078z'/%3E %3Cpath fill='%23ab6d29' d='m410.42,244.19l-5.7674-1.3234c-2.9799-1.3272-4.5576-2.3659-4.5-3.0832,0.0571-0.72047,5.296,0.17267,6.0623,0.34643,0.76566,0.17267,3.1111,1.3516,3.1111,1.3516h1.3472l2.4453-1.0798,0.33828,2.6068-3.037,1.1816z'/%3E %3Cpath fill='%23ab6d29' d='m400.79,243.1s1.4214,1.0073,0.73949,1.4393c-0.68188,0.43248-2.5007,0.48986-3.0679,0.34696-0.56825-0.14561,5.5654,1.3516,5.5654,1.3516s1.1919-1.0089,1.1076-1.0669c-0.0848-0.059-4.3447-2.0709-4.3447-2.0709z'/%3E %3Cpath fill='%23d2a567' d='m399.27,241.58c0.21394-0.34641,0.38468,0.80761,2.3711,1.0669,1.9896,0.25766,2.8972-0.34642,2.8972-0.34642l0.88033,0.57701,1.0506,0.23058-0.96572,1.4393-3.6351-1.0685-1.9587-1.0918-0.63973-0.80702z'/%3E %3Cpath fill='%23ab6d29' d='m412.22,238.97,1.0244,1.4668,0.63492-3.1934-0.0427-3.3287-2.0862-1.3802,0,0z'/%3E %3Cpath d='m406.47,233.58-1.7041-2.8542-2.2153-4.0596,1.3627-2.3345,1.6626,2.4173s-0.46953,1.6439-0.17074,3.199c0.29826,1.5578,1.065,3.632,1.065,3.632z'/%3E %3Cpath fill='%23d2a567' d='m394.8,243.95s0.73788-1.2271,2.4714-1.3667c1.7319-0.14831,3.1228,0.23113,3.1228,0.23113l3.5204,1.8382,0.71123,1.1562-6.6447-0.89149-3.181-0.96727z'/%3E %3Cpath fill='%238f4620' d='m412.09,232.2s0.12698,3.9735,0.2529,5.2271c0.1286,1.2525,0.89796,2.4617,0.77043,2.9808-0.12913,0.51963-0.38522,0.77839-1.2384,1.0798-0.85154,0.30203-2.5541,0-2.5541,0s1.6599-0.21706,1.7452-0.56023c0.0843-0.34642-0.51061-1.8582-0.59758-3.2417-0.0838-1.383,0.087-2.8953-0.38202-2.8953-0.469,0-0.97907,0.60516-1.0655,0.77838-0.0848,0.17321,0.46686-4.9267,1.0223-5.489,0.5554-0.55915,2.0467,2.1202,2.0467,2.1202z'/%3E %3Cpath fill='%23ab6d29' d='m399.94,242.64s-0.67922-0.63492-0.6664-1.0669c0.0144-0.4341,0.79661,2.0861,4.4434,1.9459,3.6495-0.14398,3.4366-0.20622,3.4366-0.20622h1.7041s-0.38256,1.5897-0.6819,1.731c-0.29772,0.14343-2.8396,1.8582-2.8817,1.9048l-0.91134,0.49961,0.0731-0.25766-0.17075,0.013-0.29772-2.8082-3.1512-1.2103-0.89636-0.54506z'/%3E %3Cpath fill='%238f4620' d='m406.47,233.58s-4.2182-4.366-5.622-7.2597c-1.407-2.8985-0.55436-6.8723-0.55436-6.8723l3.9627,5.1854s-0.51168,0.99436-0.34308,2.635c0.17127,1.6439,2.5568,6.3113,2.5568,6.3113z'/%3E %3Cpath fill='%23ab6d29' d='m403.77,249.48c-0.14085-0.30203-0.29986-1.2617,0.51114-2.2755,2.5056-3.1259,8.8461-5.3715,8.8461-5.3715l0.007,3.8231-8.136,3.9113-1.2288-0.0871z'/%3E %3Cpath fill='%238f4620' d='m404.25,246.59c0.35375-0.25387,1.7725-1.3056,1.822-1.7592,0.0576-0.51585-0.96464-0.60352-2.8091-0.97812-1.8471-0.37565-3.3507-1.2081-3.3507-1.2081s2.2713,1.7559,3.1517,2.1023c0.87927,0.34804,0.79661,0.6923,0.68189,0.92339-0.11363,0.23059,0.45299,0.95482,0.50421,0.91966z'/%3E %3Cpath fill='%238f4620' d='m415.14,247.48s-1.1728-1.751-1.5489-2.8233c-0.37242-1.0712-0.39109-2.7979-0.46152-2.8174-0.0667-0.02-0.78272,0.57049-1.3083,0.81408-0.52822,0.23926-2.4037,0.84603-2.5056,0.91693-0.10298,0.0677,2.5883-0.0563,2.5738,0.87687-0.0182,0.93643-3.8698,1.3343-3.8858,1.4019-0.0166,0.0671,3.101-0.68905,2.9132,0.0671-0.18834,0.76214-1.567,0.83305-3.2365,1.5226-1.67,0.69232-2.4021,1.042-3.0204,1.4014-0.61789,0.35455-0.91507,0.62788-0.91507,0.62788s0.7443,0.42058,1.9293,0.37781c1.1796-0.0449,3.7988-0.69231,3.7988-0.69231l5.0288-1.9129,0.63813,0.23924z'/%3E %3Cpath fill='%23ab6d29' d='m415.14,247.48s-1.4032-0.48986-2.401-6.3471c-1.0004-5.8518-0.70802-7.4296-0.70802-7.4296l2.3695,1.6536,2.123,3.8599-1.3835,8.2632z'/%3E %3Cpath fill='%238f4620' d='m415.9,237.74s-1.1066,3.2824-1.1066,5.1871c0,1.8977-0.19528,3.1919,0.34841,4.5446,0.54371,1.3467,2.4069,3.0236,2.4069,3.0236l0.84993-0.88877,0.38256-2.6545,0.21448-4.4104-3.0956-4.8017z'/%3E %3Cpath fill='%23202020' d='m419.23,242.2s0.53731,8.2658-1.5553,8.4929c-1.0009,0.1088-2.5141-3.1129-2.5333-3.2179-0.0219-0.1088,1.8231,2.9987,2.5114,2.7183,1.3216-0.53913,0.9156-8.5971,0.9156-8.5971l0.66159,0.6041z'/%3E %3Cpath fill='%23202020' d='m415.14,247.48s-0.35428-0.15372-0.92945-1.0918c-0.57515-0.93804-0.0747,0.82925-4.4807,2.387-4.4092,1.5551-5.9848,0.69232-5.9848,0.69232s1.4699,1.1443,5.9191-0.15481c4.4525-1.2942,4.0475-1.5762,4.6419-1.7045,0.60024-0.12828,0.83396-0.12828,0.83396-0.12828z'/%3E %3Cpath fill='%23ab6d29' d='m406.94,236.95s0.69465,0.59379,1.4897,2.2046c0.79554,1.6108,1.3627,2.7389,1.3627,2.7389l0.19901-0.2046s-0.54051-1.5529-1.2773-2.7649c-0.73788-1.2119-2.8694-4.1484-2.8694-4.1484l1.0954,2.1743z'/%3E %3Cpath fill='%238f4620' d='m404.26,247.21s0.45459-1.5465,0-1.8339c-0.45564-0.28688-0.88247,0.0249-3.8901-0.34642-3.0108-0.37943-5.5675-1.0815-5.5675-1.0815s2.044,1.2541,4.0022,1.7722c1.9619,0.51746,4.516,1.0945,4.516,1.0945l0.68189,0.1153,0.2577,0.27984z'/%3E %3Cpath fill='%23202020' d='m404.26,247.21s0.0624-0.36483-0.27798-0.73559c-0.3404-0.36755-0.95877,0.17483-4.6019-0.84278-3.641-1.0106-4.5779-1.6829-4.5779-1.6829s1.2986,1.1459,4.5149,1.967c3.2168,0.8206,4.9428,1.2942,4.9428,1.2942z'/%3E %3Cpath fill='%23ab6d29' d='m405.9,236.32s-2.7568,0.14993-3.6431,0.86062c-0.88194,0.71395-2.1001,2.6041-2.1001,2.6041l1.7917,0.20785s-0.22301-1.6639,0.63011-2.4964c0.85101-0.83139,2.1406-0.90721,3.3214-1.1762z'/%3E %3Cpath fill='%238f4620' d='m400.68,231.08s1.1076,1.4674,2.2575,1.9865c1.1508,0.51908,2.3006,0.95155,2.8556,1.5118,0.55168,0.56077,1.1498,2.3757,1.1498,2.3757s-3.9627-1.7689-4.7278-2.6366c-0.76829-0.86334-1.535-3.2374-1.535-3.2374z'/%3E %3Cpath fill='%238f4620' d='m404.52,231.99s-0.36068-0.59217-1.4475-1.0902c-1.0858-0.49635-1.885-0.4184-2.1934-0.19431-0.30946,0.22733-0.20276,0.36969-0.20276,0.36969l1.4486,2.183,0.80884-0.19594s-2.1529-1.357-1.6498-1.7825c1.0532-0.89909,3.236,0.71015,3.236,0.71015z'/%3E %3Cpath fill='%23202020' d='m415.2,227,22.174-11.453,0,0,10.495,14.609-19.165,5.1366-10.143,0.86601-4.9407-3.5831z'/%3E %3Cpath d='m444.93,233.26,27.643,23.94,0,0-3.0626,2.1055-6.4773-1.8457-13.461-13.304-4.9833-5.0175z'/%3E %3Cpath d='m480.33,252.46s-6.8654-5.4142-15.788-12.038c-8.9198-6.6287-19.949-14.982-19.949-14.982l0.51009,7.1443,22.818,20.972,7.5263,3.6287,3.8063-1.1508,1.931-2.0168-0.85474-1.5584z'/%3E %3Cpath fill='%23803f1d' d='m444.85,235.53s7.9623,8.9861,14.016,13.568c6.0463,4.5787,11.841,9.5914,13.031,8.8979,1.193-0.69232,0.76727-1.4658,0.76727-1.4658l-27.984-22.818,0.16914,1.8171z'/%3E %3Cpath d='m464.4,258.5-2.8118,2.1867,0,0-3.2333-1.3207-16.999-17.374,0.85368-3.1988,2.3796,0.34641z'/%3E %3Cpath fill='%23202020' d='m480.33,252.46s-2.0835,4.9138-6.5143,3.7646c-4.4306-1.1546-28.826-24.332-28.826-24.332l-0.0566,2.419s24.722,22.645,29.494,23.567c4.7715,0.9234,8.6794-3.2185,8.1782-3.6866-0.33452-0.3134-2.2756-1.7316-2.2756-1.7316z'/%3E %3Cpath fill='%23803f1d' d='m442.12,239.16s7.8811,10.111,12.057,13.827c4.1772,3.7181,7.754,6.6527,9.4579,6.3113,1.7015-0.34642-1.0223-2.2468-1.0223-2.2468l-11.929-11.756-6.0901-6.1355c-0.001,0-2.385-0.94996-2.473,0z'/%3E %3Cpath fill='%23202020' d='m444.08,239.16s20.011,20.396,21.595,20.859c3.3544,0.97972,8.1248-2.4796,8.1248-2.4796l-1.7618-1.0355-0.22783,0.63167s-0.85314,2.0758-5.1685,1.1524c-4.3169-0.918-21.879-19.819-21.879-19.819l-0.68296,0.69064z'/%3E %3Cpath d='m451.62,258.68-7.2829-8.3841-1.6167-2.7658-0.43217-3.5452,14.529,14.609,0,0-2.0435,1.3802-1.7927-0.6008z'/%3E %3Cpath fill='%23202020' d='m464.78,258.97s-1.7623,2.5938-4.151,2.0742c-2.3828-0.51585-3.745-2.2452-3.745-2.2452l-13.93-13.64-0.34-2.08s15.281,16.17,18.015,16.884c1.9907,0.51962,3.4718-1.9042,3.4718-1.9042l0.67922,0.9234z'/%3E %3Cpath fill='%23202020' d='m457.05,258.51s-0.68242,2.0168-2.7238,1.731c-2.0483-0.2885-2.672-1.0961-2.672-1.0961l-8.5324-10.14-0.16914-2.7054s8.8707,12.269,10.919,12.962c2.0445,0.69066,2.5552-1.3852,2.5552-1.3852l0.62369,0.63327z'/%3E %3Cpath fill='%23b07229' d='m447.93,231.92s8.2642,7.0866,8.9471,7.4328c0.68082,0.34803,3.5758,0.43409,3.745,0.8628,0.17074,0.43519-1.869,0-2.0413,0.43519-0.16861,0.43032,4.174,3.9773,4.8548,4.0612,0.68081,0.0872,4.1755,0.0872,4.0913,0.51746-0.0848,0.43574-2.386,0-2.4709,0.51963-0.0843,0.51747,3.7514,3.5448,4.429,3.6309,0.68456,0.0871,5.1114,0.0871,5.1114,0.51585,0,0.4368-3.5801-0.0839-3.491,0.6923,0.0827,0.77839,6.0495,4.4932,5.792,5.0144-0.25663,0.51746-7.1576-4.668-7.326-4.4093-0.17232,0.25874-0.4263,1.9026-0.85528,2.1614-0.42255,0.25928,0-2.1614-0.34145-3.1968-0.33986-1.0387-4.3431-4.0629-4.7689-3.7165-0.42256,0.3448-0.0827,2.1597-0.51006,2.1597-0.42631,0,0.0875-2.2468-0.34149-3.0258-0.42629-0.77673-4.174-3.8896-4.684-3.8896-0.51222,0-0.17076,1.6455-0.51222,1.9031-0.34307,0.25874-0.25503-1.9031-0.76727-2.5938-0.50794-0.68906-9.2003-8.5538-8.8605-9.0753z'/%3E %3Cpath d='m433.76,254.86s0.0651,3.1308-1.3424,3.5876c-1.4043,0.45522-4.0662-5.7513-4.0662-5.7513l-0.61782-5.7866,4.1329,3.8452,1.8936,4.1051z'/%3E %3Cpath d='m444.84,253.27s0.0581-0.91693-0.0491-1.6704c-0.10404-0.75562-0.34574-1.8994-0.34574-1.8994l-0.26998-3.2239-0.76568-2.1597-0.61943-1.3618-0.89583,0.0639-2.1726,1.5405-0.74483,2.092,1.1492,3.9129,1.0645,3.5649,1.6167,0.51909,2.0329-1.3781z'/%3E %3Cpath d='m441.99,258.74c0.48766-0.14668-0.45353-4.4353-0.45353-4.4353l-2.5536-6.3402-0.68242-2.2452-2.0723-0.78159-1.3637,1.56,0.31212,2.5062s1.9864,4.1749,2.9548,5.6477c0.96571,1.4663,3.0103,4.3492,3.8586,4.0883z'/%3E %3Cpath fill='%23202020' d='m439.7,245.29c0.74163,0.51585,1.5911,2.2176,1.7884,3.3684,0,0,1.7063,4.6648,1.4784,5.1281-0.22784,0.46225-1.2517,0.51963-1.2517,0.51963s2.2756,2.3611,2.958,2.0742c0.67921-0.28852,0.39483-2.5938,0.16647-3.1129-0.22622-0.51962-0.96572-0.17158-1.2469-0.69064-0.28438-0.52126-1.1397-3.6293-1.1946-5.4756-0.0565-1.8398-0.11363-3.1096,0.11419-3.5719,0.22729-0.46009,1.9325,3.8604,1.9325,6.1686l0.73629,0.86388s-0.45564-3.1719-0.73629-4.15c-0.28438-0.97812-0.90865-2.6512-0.90865-2.996,0-0.34642,0.34147-1.1524,0.34147-1.9589,0-0.80595-0.0566-1.3234-0.0566-1.3234s0.90492,0.62952,1.248,0.57646c0.33987-0.059,0.85047-0.51908,1.0762-2.5386,0.22942-2.0136-0.22569-7.8784-0.22569-7.8784l-8.8589,11.684,2.6394,3.3137z'/%3E %3Cpath fill='%23202020' d='m439.7,244.28s-0.34147,3.1411,0.82434,6.3658c1.1653,3.2288,1.4742,3.3457,1.7031,3.8052,0.22568,0.45901,0.20328,3.8604-0.22942,4.2907,0,0-2.2671-5.7888-3.0327-8.6414-0.76887-2.8531-0.96571-3.9492-1.3643-4.1803-0.39804-0.23058-1.0548-0.28849-1.0548-0.28849l3.1538-1.3516z'/%3E %3Cpath d='m438.86,261c0.25396-0.053,0.0976-1.3337,0.0976-1.3337l-0.36708-3.0242-3.1106-6.3861-3.4099-3.0669-1.7895-2.7649-0.25397,5.2731s2.4703,5.2694,4.0892,6.7826c1.6178,1.5107,4.2929,4.6333,4.7443,4.5197z'/%3E %3Cpath fill='%23202020' d='m426.13,246.61s0.53463,1.4144,0.53463,2.3394v1.7857s1.2469,2.5348,2.3844,4.5543c1.1381,2.0114,2.2153,4.0894,3.1789,3.6287,0.96732-0.46172,1.3099-1.9605,1.3659-2.1348,0.0555-0.16943-1.0794,1.7294-1.6503,1.4409-0.56556-0.28687-3.1186-8.5239-3.0631-8.6992,0.0555-0.1732-0.68243-0.518-1.2517-1.0945-0.56932-0.57753-1.4988-1.8209-1.4988-1.8209z'/%3E %3Cpath fill='%23202020' d='m435.41,253.79s-1.765-2.8769-2.3322-4.1468c-0.56718-1.2693-1.5329-2.2501-1.8168-2.2501-0.28438,0-0.65357-2.5792-0.65357-2.5792s0.93745,1.7164,2.1289,2.2902c1.1946,0.57648,1.9288,1.0387,2.5029,0.80762,0,0,0.33934,1.3272,0.33934,2.6528s-0.1686,3.2255-0.1686,3.2255z'/%3E %3Cpath fill='%235c3a1d' d='m429.73,249.55s0.5949,1.8122,1.7586,3.5416c1.1642,1.7294,3.0754,3.8057,3.0754,3.8057s-2.1097-2.0763-3.2146-3.6899c-1.1082-1.6141-1.8466-3.7197-1.8466-3.7197l0.22729,0.0622z'/%3E %3Cpath fill='%23202020' d='m435.8,247.4s0.56236-1.5676,1.05-1.6439c0.48605-0.0725,1.5116-0.38052,1.5116-0.38052s-0.87766-0.2176-1.5815-1.0387c-0.73789-0.872-0.90865-0.80816-1.7111-1.7413,0,0,0.45512,1.7413,0.59277,2.5619,0.13819,0.82166,0.13819,2.2425,0.13819,2.2425z'/%3E %3Cpath fill='%23202020' d='m435.24,247.91s2.5269,5.4147,3.1773,7.2298c0.64988,1.8166,0.53944,4.5278,0.53944,4.5278s-0.31212-1.9307-0.87873-3.5173c-0.57037-1.5844-2.8705-5.9913-3.0652-6.5096-0.20381-0.5207,0.22728-1.731,0.22728-1.731z'/%3E %3Cpath d='m438.68,244.39,0.59758-7.9559-0.59758-2.8082-3.5806-7.9495s-0.17073,1.1675-1.0645,1.1215c-0.89423-0.0449-3.2797-1.2948-4.0929-2.3779,0,0,0.47166,1.8598,0.30252,3.6309-0.17233,1.7738-0.46845,2.7221-0.46845,2.7221l6.8996,12.965,2.0045,0.65169z'/%3E %3Cpath fill='%238b441f' d='m424.96,249.61s1.0778,1.2991,1.7031,1.1258c0.62264-0.17104,0.39483-2.6523-0.39803-4.0326-0.7966-1.3819-9.2035-12.619-10.452-13.311-1.248-0.68905,9.1474,16.218,9.1474,16.218z'/%3E %3Cpath fill='%238b441f' stroke='%235c3a1d' stroke-width='0.07' d='m430.7,244.97c0.1686,0.51909,0.77363,4.1018-0.67922,4.4369-2.0056,0.4617-11.243-12.297-12.671-14.048,0,0-5.7984-3.6255-5.9111-4.5489-0.11524-0.9234,6.2515,1.2531,6.2515,1.2531l12.382,11.84s0.45459,0.54723,0.62744,1.0669z'/%3E %3Cpath fill='%23202020' d='m424.96,249.61s-1.0223-1.8138-1.1135-3.108c-0.0811-1.2964-0.50687-1.9887-0.59116-2.4223-0.0859-0.43031-6.8157-10.194-7.498-10.804-0.67922-0.60192-2.9799-1.8994-2.9799-1.8994s0.2657,1.5551,0.2657,2.2474c0,0.69066,0.0758,0.88552,0.0758,0.88552s2.1299,4.0444,5.1952,7.5862c3.0652,3.54,6.6458,7.5151,6.6458,7.5151z'/%3E %3Cpath d='m435.24,247.91c0.90651-0.51908,0.50848-3.6287,0.1702-4.6101-0.34467-0.97971-5.8507-12.44-5.8507-12.44l-1.6514,0.63006-3.1208-2.4482-1.757-1.901s0.61895,2.7389,0.56398,4.0645c-0.0581,1.324-0.11365,2.1289-0.11365,2.1289l4.3714,7.6636,7.388,6.9129z'/%3E %3Cpath d='m441.43,241,1.3099-1.7278-0.68242-5.7049-3.634-12.442s-0.91026,0.22898-1.8205-0.34641c-0.90652-0.57861-1.8445-1.6736-1.8445-1.6736l0.88247,7.4328,3.7509,10.429,0.22568,3.1134,1.8125,0.91967z'/%3E %3Cpath fill='%23202020' d='m430.07,243.91s-3.6602-3.9773-4.8564-5.9645c-1.1946-1.9881-2.2137-3.8896-2.2137-3.8896s-1.0207,0.43356-2.3012-0.0839c-1.2784-0.52126-2.9783-2.3345-2.9783-2.3345s-1.0228,1.9865,4.2588,7.3452c6.0463,6.1344,8.0906,4.9273,8.0906,4.9273z'/%3E %3Cpath fill='%238b441f' d='m438.89,245.25c1.5409-0.61867,1.4923-7.0887,0.0454-11.453-1.4528-4.366-3.8367-8.1221-3.8367-8.1221s2.9841,6.9995,3.6212,9.8533c0.63813,2.8526,0,4.8802-0.51222,4.7075-0.51059-0.17321-0.51059-1.6818-1.7031-4.4521-1.1893-2.7621-1.9992-3.4544-1.9992-3.4544s4.2145,11.536,3.0199,11.321c-1.1893-0.21598-7.07-13.007-7.3238-13.354-0.25984-0.34643-0.42576,0.47469-0.42576,0.47469s5.2384,16.032,9.1148,14.479z'/%3E %3Cpath d='m442.31,214.09,2.5877,5.4954,0.81739,5.8101,0.20328,4.8986s0.1686,9.6668-1.0207,9.8976c-1.193,0.23112-1.7618-0.9234-1.8167-1.1546-0.0587-0.23059-2.2169-10.89-2.2169-10.89l-2.2692-11.12,0.80458-0.77839,0.27157-1.6406,1.7586-0.11692,0.88033-0.40163z'/%3E %3Cpath fill='%238b441f' d='m435.24,247.91c1.0287-0.14182,0-2.7632,0-2.7632s-0.85367,1.2666-1.5361,0.40379c-0.68242-0.86387-1.7639-4.0645-1.7639-4.0645l-0.68081-1.9286s-0.73789,2.1305-1.6999,2.1305c-0.96839,0-5.9651-8.4699-5.9651-8.4699l-0.59811,0.83572c0.00036-0.00036,7.0428,14.578,12.244,13.856z'/%3E %3Cpath fill='%23202020' d='m431.94,241.49s0.85367-2.0742,0.51221-3.9735c-0.34147-1.9042-2.8929-6.6527-2.8929-6.6527s-0.76882,0.1732-1.7895-0.17483c-1.0223-0.34642-2.982-1.6439-2.982-1.6439s1.3622,3.5448,2.8929,6.1387c1.5377,2.5906,4.2593,6.3065,4.2593,6.3065z'/%3E %3Cpath fill='%23202020' d='m436.03,238.55s-0.63867-4.4981-2.68-8.6462c-2.0478-4.1484-3.4131-5.489-3.4131-5.489s0.17233,0.90988,0.13019,2.5949c-0.0406,1.6834,0,2.0298,0,2.0298s1.8738,0.69231,3.2829,3.1985c1.4027,2.5067,2.68,6.3124,2.68,6.3124z'/%3E %3Cpath fill='%23202020' d='m441.6,230.86s-0.28438-4.8412-1.05-7.6108c-0.76727-2.7622-1.575-6.4353-1.575-6.4353s0.096-0.3724,0.42258-0.56402c0.19154-0.11853,0.47005-0.17483,0.85634-0.0427,1.0207,0.3448,1.4464,2.8953,1.4464,2.8953s-0.12645-3.9308-0.21395-4.1024c-0.0811-0.17483-0.34147-0.65116-0.34147-0.65116s-0.33827,0.17321-0.80991,0.13207c-0.46793-0.046-1.0207-0.13207-1.0207-0.13207s0.32066,1.2087-0.19155,1.7727c-0.37188,0.41028-0.72773-0.36809-0.93425-0.47363-0.0795-0.0427-0.19367,0.55916-0.19367,0.55916s0.38202,1.3819,0.46846,2.5938c0.0843,1.2119-0.12646,2.2046-0.12646,2.2046s0.75071,2.8921,1.5585,4.668c0.81418,1.7684,1.7047,5.1866,1.7047,5.1866z'/%3E %3Cpath fill='%23202020' d='m445.92,230.3s0.85154-6.9568-0.72191-11.407c-1.5799-4.4537-2.8998-5.6188-2.8998-5.6188l-0.72191,0.86548s2.3711,3.7792,3.0652,7.3008c0.72879,3.6721,1.2784,8.8589,1.2784,8.8589z'/%3E %3Cpath fill='%23202020' d='m438.93,233.8s-0.7715-5.4425-1.7516-8.9428c-0.97854-3.5037-1.2549-4.7552-1.2549-4.7552l-1.4886-1.3819s0.87451,3.7148,0.78646,4.7979c-0.0843,1.0766-0.17181,1.8138-0.17181,1.8138s0.72619,1.8582,1.7063,3.4095c0.97854,1.5589,2.1742,5.0588,2.1742,5.0588z'/%3E %3Cpath fill='%23904720' d='m442.57,242.44c1.3894,0.0412,0.1702-7.832-0.39801-9.8485-0.56878-2.0163-3.8101-11.484-3.8101-11.484s3.8976,13.463,3.5806,14.136c-0.45993,0.99922-1.9832-4.091-2.267-4.0331-0.28278,0.0541,2.8945,9.1026,1.7548,9.2185-1.1311,0.11528-1.6983-1.9048-1.6983-1.9048l0.11045,1.9622c0,0.00053,0.73949,1.9015,2.7275,1.954z'/%3E %3Cpath fill='%23904720' d='m444.27,238.46c0.9476,0-0.26624-7.4296-0.9444-10.716-0.67922-3.2861-2.5776-9.8533-2.5776-9.8533s1.9272,4.5527,3.0103,9.7956c1.0762,5.2402,1.8104,11.984,0.79286,12.1-1.0207,0.11529-1.5345-0.98132-1.5345-0.98132l-0.1686-1.2119c0,0.00036,0.45457,0.86767,1.4219,0.86767z'/%3E %3Cpath fill='%23312317' d='m431.48,247.19c0.14619,0.52938,0.11737,3.0788-1.2346,2.8959-1.3526-0.18349-3.8245-2.4655-4.3329-3.9654,0,0,2.9382,3.2499,3.9488,3.2298,1.0116-0.0227,1.0079-3.3548,0.83876-4.2193-0.17233-0.86228,0.78005,2.059,0.78005,2.059z'/%3E %3Cpath fill='%23d2a567' d='m438.55,211.8s1.7484,1.1194,3.1528,0.29987c1.4064-0.82113,2.3439-2.8082,2.3012-3.8896-0.0454-1.0782-0.0859-2.0309-0.93959-3.1541-0.84993-1.1226,1.3622,0.94942,1.3227,3.0258-0.0422,2.0758,0.12699,5.6584-3.1965,6.4385-3.3235,0.77839-1.8744-0.17321-1.8744-0.17321l-0.7662-2.5473z'/%3E %3Cpath fill='%238f4620' d='m435.92,205.45s2.0968,3.4361,2.9041,6.5261c0.80991,3.0896,0.65999,4.2772,0.1494,4.34-0.51167,0.0677-0.70321-0.36428-0.83075-1.141-0.12645-0.78212-2.2228-9.725-2.2228-9.725z'/%3E %3Cpath fill='%231e2121' d='m399.14,209.67,0,0,13.883,20.14,17.383-19.621-10.991-11.323z'/%3E %3Cpath d='m416.69,197.31,0,0-0.80566,3.1555,1.702,5.3585,2.8972,2.9823,3.3614,2.2408,0.76831-2.506,0.81099-2.9336,0.84834-0.30311,2.1289,0.82271,1.4086-2.0297,2.2569-4.0648-0.46952-1.5751-0.53888-1.1204-3.5161-6.127-1.1845,2.3166-1.1044,0.67116-2.0488-1.1637-2.4703,3.2367-3.0199-1.4019z'/%3E %3Cpath fill='%235c3818' d='m423.85,211.06s0.60185-0.42869,0.85527-2.0282c0.25824-1.5995,0.29932-6.4828-0.12646-8.4288-0.42576-1.9421-1.7063-5.7887-1.9603-5.4874-0.25396,0.30366,2.004,4.2361,1.6626,9.0326-0.33988,4.7963-0.17073,6.1371-1.1946,6.6116-1.0244,0.47362,0.76353,0.30041,0.76353,0.30041z'/%3E %3Cpath fill='%235c3818' d='m424.66,202.98s2.3001,3.2829,3.4099,2.1153c1.105-1.1654,0.55274-5.3586-0.16861-6.9995-0.72832-1.6439-1.4923-4.0201-1.4923-4.0201l0.68242-0.69066s0.76407,2.7649,1.1898,4.4948c0.42579,1.7278,1.7031,6.8259,0.16861,7.7358-1.5308,0.90662-3.7477-1.8598-3.7477-1.8598l-0.0422-0.77619z'/%3E %3Cpath fill='%238f4620' d='m417.23,205.24s0.76674-1.1226,1.8178-1.2384c1.0506-0.11529,1.2528,0.3448,1.2528,0.3448l0.93478,2.7075,1.5622,2.7963,1.3894,1.3802-0.82274,0.77839-1.105,0.20298s-3.3-1.7278-3.3528-1.8436c-0.056-0.1153-0.91025-1.2103-0.91025-1.2103l-0.76621-3.9178z'/%3E %3Cpath fill='%23d2a567' d='m422.69,233.84c-1.082,0.56241-3.5748-0.68093-4.9796-1.9194-1.4064-1.2368-8.8167-8.8012-8.8167-8.8012l-1.0367-4.1928,2.8673,0.77947,5.0277-2.1597,0.93852-1.7722,6.0463-3.1546,3.3694-1.8138,7.3233-0.13045,1.7468-3.5876s2.457,4.2491,2.8668,5.9934c0.41298,1.7429,0.32654,7.1032-0.31158,7.4457-0.63707,0.34642-3.0231-1.6011-3.3646-1.7278-0.34147-0.12829,1.7895,7.5204,0,7.8202-1.7911,0.30205-4.7715-2.8509-4.7715-2.8509s1.1925,6.8258-0.21129,6.8707c-1.4075,0.0444-5.0415-1.7115-6.5886-3.3852-0.00037,0,1.7282,5.6327-0.10512,6.5859z'/%3E %3Cpath fill='%238f4620' d='m421.25,224.98s1.1802,1.7316,1.5473,2.2755c0.36869,0.54564-0.0635,3.7824-0.28598,4.3795-0.45565,1.2401-2.1294-1.4674-3.0397-3.8599,0,0-2.6656-4.4369-2.8369-5.0123-0.1702-0.57753,4.6152,2.2171,4.6152,2.2171z'/%3E %3Cpath fill='%238f4620' d='m435.52,208.07s2.5845,10.66,1.336,11.032c-1.2517,0.37402-4.8025-3.3716-5.1973-3.9178-0.40016-0.54725-5.3408-8.4112-5.3408-8.4112l-1.05-1.0669,0.31213-0.54725,2.1001,0.80436,7.84,2.1062z'/%3E %3Cpath fill='%238f4620' d='m417.23,228.55c-0.5752,0.37078-1.6748-1.3819-2.186-1.8436-0.51167-0.45847-2.2436-2.5938-3.9477-4.3216-1.7015-1.7262-2.9521-2.996-2.9521-3.3424,0-0.34642-1.0228-1.4393-1.0228-1.4393l0.90919-1.1492,1.193-0.17483s7.0433,5.6156,7.5258,6.5063c0.48074,0.89909,0.79554,5.5617,0.48074,5.7647z'/%3E %3Cpath fill='%238f4620' d='m427.83,228.64c-0.33187,0.26197-4.9978-3.1145-6.9594-5.9079-1.9603-2.7946-4.0038-5.2434-4.4877-6.5411-0.48287-1.2964-0.88087-2.4747-0.88087-2.4747l1.4214,0.3134c0.00037,0,11.444,14.175,10.907,14.61z'/%3E %3Cpath fill='%238f4620' d='m429.5,223.71c-0.25985,0.31828-2.2996-1.2087-3.5508-2.8525-1.2501-1.6406-0.5933-3.685-0.5933-3.685s4.398,6.2237,4.1441,6.5378z'/%3E %3Cpath fill='%238f4620' d='m432.11,223.08c-0.63385,0.3015-3.3091-2.9251-5.5355-6.5672-1.6481-2.6929-2.0574-3.0966-2.4122-3.311-0.61147-0.3724-1.7639-0.54723-1.7639-0.54723l-0.22889-0.34643,1.1941-0.29013,0.88246-1.0338,1.3894-1.7889,5.5403,11.18c0.001,0,1.36,2.5061,0.93425,2.7043z'/%3E %3Cpath fill='%23ab6d29' d='m417.72,231.92c0.0443,0.40596-0.0224,0.81627-1.5329,0.66469-1.5105-0.15155-9.4135-4.366-12.972-10.177-3.555-5.8139-4.0245-6.5902-4.0245-6.5902l1.5772-1.7938,12.545,14.302,4.4077,3.5941z'/%3E %3Cpath fill='%238f4620' d='m417.72,231.92c0.16968,0.66469-0.62316,0.83738-1.4187,0.63493-0.79661-0.20135-3.9493-1.3256-8.9754-6.9151-5.0239-5.5884-6.9845-9.5914-6.9845-9.6801,0-0.0839-0.2545-2.3908-0.2545-2.3908l1.4753-0.63332,8.6345,13.164,7.5237,5.8203z'/%3E %3Cpath d='m426.11,226.27s-2.6021-1.8598-4.2631-3.8469c-1.6578-1.9887-5.0271-6.61-4.9417-7.5205,0.0864-0.90662,1.4918-0.90662,1.4918-0.90662l-0.0843-2.3297,0.42578-0.78325,2.4292,0.99436,3.0652,3.7641,1.1242,1.5254s1.9864,4.7811,1.6012,5.2136c-0.38203,0.43356-3.1939-2.6794-3.5353-2.2902-0.34148,0.39081,3.1986,5.8336,2.687,6.1799z'/%3E %3Cpath d='m421.25,224.98s0.85207,1.2964,0.46473,2.2046c-0.37723,0.90502-0.72031,1.3819-1.9998-0.518-1.2789-1.9042-2.823-4.0331-2.966-3.8794-0.14139,0.15967,0.15421,2.9267-0.48286,2.9267-0.64187,0-2.6421-2.3757-3.9211-4.2788-1.2768-1.901-3.2349-5.055-3.2349-5.055s0.17074-0.64952,0.0854-2.8093c-0.0854-2.1619-0.2561-3.2829-0.2561-3.2829s0.18461,0.67607,0.4119,1.1805c0.22516,0.50447,0.56664,0.86387,0.56664,0.86387l4.6857,5.5205,1.3173-0.91693,2.7745,5.4099,2.5546,2.6339z'/%3E %3Cpath d='m403.49,216.94s3.6217,6.353,6.9861,9.8998c3.3651,3.54,7.2426,5.0815,7.2426,5.0815l-10.946-12.948-3.2824-2.0331z'/%3E %3Cpath d='m431.26,220.7c-0.18942,0.13045-2.4282-2.2918-3.8325-4.452-1.4075-2.1597-2.5125-5.1871-2.4282-6.5261,0.088-1.3408,0.46792-4.5787,0.46792-4.5787s3.7514,3.8896,4.4695,5.7033c0.72827,1.8171,2.2692,4.2886,1.9309,4.5933-0.33987,0.30203-2.8636-1.7002-3.1629-1.2216-0.2988,0.47524,2.9393,6.2215,2.5552,6.4818z'/%3E %3Cpath d='m435.52,216.64c-0.45778,0.2306-2.3407-1.9886-2.854-3.3716-0.5122-1.3852-0.68242-4.1056-0.68242-4.1056l-1.661-3.9324,0.1702-4.3627,1.661-0.26198,2.5109,3.4594s0.98175,2.0298,0.93959,4.9695c-0.0448,2.9375,0.42471,7.3447-0.0843,7.6054z'/%3E %3Cpath d='m406,227.32c-3.3662-4.1489-5.4099-8.0398-5.4099-8.0398l-1.1076-3.7164,0.59704,0.47632s0.97908,4.2788,6.174,9.375c5.1978,5.1032,6.3492,5.5317,6.3492,5.5317s1.0207,2.813,0.51167,3.8058c0.00036,0-3.7487-3.2861-7.1149-7.4328z'/%3E %3Cpath fill='%23202020' d='m411.61,233.27s-4.4312-3.914-7.9532-8.3513c-3.5204-4.4353-5.7364-8.6997-5.7364-8.6997l1.535-1.4425s2.9239,6.828,5.0261,9.537c2.1017,2.7091,7.1283,8.9567,7.1283,8.9567z'/%3E %3Cpath fill='%23202020' d='m417.72,231.92s-5.1397-5.0978-7.7523-7.9784c-2.6112-2.8786-4.0587-5.7909-4.0587-5.7909l2.1566,0.83465s0.85261,2.2458,2.7264,4.5836c1.876,2.3329,6.9279,8.3508,6.9279,8.3508z'/%3E %3Cpath fill='%23202020' d='m416.75,222.78s-2.8113-3.4263-4.1457-5.5862c-1.336-2.1602-2.7003-4.9267-2.7003-4.9267s3.7786,4.3216,4.8862,4.6085c1.1066,0.29012,1.0778-0.0265,1.0778-0.0265s-0.45458,1.5534-0.0843,2.8509c0.36922,1.298,0.96625,3.0799,0.96625,3.0799z'/%3E %3Cpath fill='%23202020' d='m417.89,208.88s0.45564,2.4152,0.14246,3.8301c-0.31,1.4095-1.0623,1.3997-1.0623,1.3997s1.4603,2.058,2.3135,2.9202c0.84833,0.86554,2.982,2.3627,2.982,2.3627s-1.7063-2.3627-2.3898-3.5714c-0.67976-1.2103-1.6737-2.564-1.2453-3.7462,0.42418-1.1838,2.727,0.80815,3.3774,1.3553,0.65624,0.54564,3.3544,3.7446,3.3544,3.7446s-0.99772-3.3159-2.3306-4.5224c-1.336-1.2087-5.1418-3.7727-5.1418-3.7727z'/%3E %3Cpath fill='%23202020' d='m429.22,216.13s-1.4486-3.4821-2.2756-5.614c-0.82274-2.1354-2.1129-6.7569-2.1129-6.7569s0.0976,2.117-0.0166,3.6737c-0.11364,1.5562-0.66586,3.9324-1.3451,4.2756-0.68242,0.34642-0.83556,0.41354-2.0904,0.0677-1.2554-0.34643,0.87289,0.58406,0.87289,0.58406s1.2789-0.0412,1.8338-0.66955c0.55061-0.63007,0.67815-1.9686,1.2789-1.7744,0.59438,0.19649,1.232,2.2274,1.7255,3.1129,0.48606,0.88498,2.1294,3.101,2.1294,3.101z'/%3E %3Cpath fill='%23202020' d='m424.81,203.72s2.7014,3.0258,3.8714,1.6639c1.1733-1.3603,0.49086-5.2072,0.49086-5.2072s1.6401,0.62787,2.1518,0.21759c0.5122-0.41029,0.27477-1.9226,0.27477-1.9226s2.9142,4.2555,4.3185,6.9776c1.408,2.7221,2.1289,7.6359,2.1289,7.6359s-2.4117-3.9194-3.634-7.6359c-1.1151-3.3819-2.7467-4.9251-3.0476-4.6014-0.29559,0.32314-0.7443,2.7005-0.38203,3.9324,0.36442,1.2298,1.3622,2.8309,2.0446,4.5803,0.68241,1.7494,1.4464,4.4948,1.4464,4.4948s-1.3846-2.0974-2.1902-3.2417c-0.80991-1.1443-1.6626-1.5995-2.2169-2.137-0.55274-0.54238-1.3851-1.5367-2.1907-1.8598-0.81205-0.32314-2.409-1.1242-2.409-0.49635,0,0.62519-0.31853-1.233-0.31853-1.233l-0.33827-1.1675z'/%3E %3Cpath fill='%23171717' d='m415.76,216.68s1.4907,2.9841,2.6816,4.5392c1.1936,1.5551,2.814,3.7592,2.814,3.7592s-2.5552-2.3329-3.579-3.802c-1.0234-1.4712-1.9165-4.4964-1.9165-4.4964z'/%3E %3Cpath fill='%238f4620' d='m433.35,217.46c-0.38362,0.15156-1.622-0.29987-1.7506,0.15156-0.12485,0.45198,0.70535,2.2274,1.622,3.1573,0.91186,0.92666,1.2992,0.96781,1.5132,0.86228,0.2113-0.11042-0.0976-0.92992-0.24704-1.8815-0.14938-0.94995-0.0325-1.9654-0.13818-2.2707-0.10564-0.30094-0.99932-0.019-0.99932-0.019z'/%3E %3Cpath fill='%23d2a567' d='m401.52,198.44-1.5505,1.0171-1.8744,3.8041,0.51061,6.9728s1.733,2.4488,2.7963,3.9903c1.0655,1.5416,4.588,5.5152,5.4965,5.2862,0.90812-0.23222,1.876-2.9944,1.988-4.4932,0.11365-1.5021,0.22783-4.2636,0.22783-4.2636s0.8526,1.4972,2.3274,3.108c1.4769,1.6157,2.727,3.1129,3.4099,2.9993,0.68243-0.11692,2.7232-4.2063,2.7798-4.7254,0.056-0.51584-5.1114-13.195-5.1114-13.195l-2.299-1.1919-8.7013,0.69177z'/%3E %3Cpath fill='%23ab6d29' d='m413.12,208.99s0.89156,3.2385,1.4464,4.8407c0.55436,1.5963-0.0155,2.9814,0.28545,3.0241,0.29666,0.0395,2.9943-3.5876,3.0359-5.2282,0.0448-1.6406,0.0448-3.3273-0.67922-8.3417-0.72726-5.0123,0.23369-6.47,0.23369-6.47l-1.5542-1.266-2.6848,5.403-0.0832,8.0382z'/%3E %3Cpath fill='%23ab6d29' d='m404.04,206.14s0.59652,4.8823,0.93692,6.4812c0.34149,1.5995,1.2773,4.32,1.7901,4.2756,0.51061-0.0395,2.1289-4.32,2.1721-5.7888,0,0-1.1076-2.0725-1.0655-7.3025,0.0432-5.2288-0.51166-5.7481-0.51166-5.7481l-3.3219,8.0826z'/%3E %3Cpath fill='%2345392d' d='m397.04,196.05s-4.0876,5.9341-4.0054,9.1902c0.087,3.2547,0.62477,2.5343,1.5644,5.4708,0.93585,2.9446,1.4486,7.2928,1.5036,7.6674,0.0576,0.37241,0.65305-0.2046,0.73843-0.63492,0.0848-0.43194,0.19901-21.694,0.19901-21.694z'/%3E %3Cpath fill='%23ab6d29' d='m397.02,196.75s-3.578,5.5301-3.3213,8.5854c0.2545,3.0501,0.7368,2.9678,1.7591,5.7048,1.0223,2.7373,1.1076,7.1988,1.1076,7.1988s1.136-0.34317,2.4133-1.2515c1.2779-0.91042,2.4276-2.7648,2.4276-2.7648s-0.43803-0.99437-1.2629-2.7784c-0.82274-1.7889-0.90865-2.4802-0.90865-2.4802l-1.05-1.4988,0.31213-5.3008,0.93585-3.8317v-1.4414l-2.4128-0.14182z'/%3E %3Cpath fill='%23dbad6c' d='m416.35,206.27s-1.7879-0.38919-2.5136-0.82114c-0.72084-0.43194-1.0207-1.469-1.0207-1.469l0.42737-1.0371,3.1069,3.3273z'/%3E %3Cpath fill='%23d2a567' d='m397.75,197.35s-2.5824,5.5617-2.2718,9.3916c0.31372,3.8334,2.4148,8.7301,2.6138,8.7884,0.19848,0.0574,0.11205-0.37403,0.16967-1.2401,0.0571-0.86228-0.11258-11.436-0.11258-11.436l1.2496-3.7164,0.056-1.9307-1.7047,0.14343z'/%3E %3Cpath fill='%238f4620' d='m404,198.59s0.34201,1.672,0.11365,2.3643c-0.22676,0.69066-1.5905,1.5551-2.1577,2.6501-0.56878,1.0945-1.3627,3.6293-1.3627,3.6293s0.62317-1.4398,1.4768-2.3611c0.851-0.9218,1.193-1.5551,1.3638-1.0387,0.16808,0.51909,0.45352,2.7107,0.28173,3.1145-0.16861,0.40055-0.85154,1.062-1.304,2.5906-0.48339,1.6276,0.0555,3.1129,0.0555,3.1129s0.29825-1.8604,0.56985-2.8244c0.23689-0.8525,0.96357-1.2699,0.96357-1.2699l1.4208,3.0588s0-1.4431,0.22889-2.5392c0.22676-1.0934,1.4166-2.635,1.8007-2.635,0.38415,0,0.97961-0.21597-0.46953-0.95103-0.46685-0.30204-0.16913-5.6172,0.21343-5.8336,0.38415-0.21435,2.385-0.29174,2.1748-1.0257-0.21342-0.73345-1.9501-2.7124-2.1208-2.8856-0.17073-0.17213-3.2488,2.8433-3.2488,2.8433z'/%3E %3Cpath fill='%23dbad6c' d='m416.06,209.9s-1.2394-0.21597-1.9203-0.34643c-0.68028-0.12882-0.76567-0.77672-0.76567-0.77672l0.21555-0.81948,1.5734,0.86388,0.8969,1.0788z'/%3E %3Cpath fill='%238f4620' d='m399.59,210.53c-0.0336,0.57054-0.45671,1.154-0.73147,1.9519-0.33187,0.96454-0.52395,2.1121-0.52395,2.1121s-0.38469-2.5522-0.51114-4.3465c-0.12859-1.7922-0.25556-2.9597-0.46791-3.0669-0.21344-0.10717-0.83129,0.84058-0.83129,0.84058s0-2.0098,0.38255-2.9808c0.38363-0.97106,0.70321-2.3546,0.36336-2.5705-0.34255-0.2176-1.065,0.38919-1.384,0.90661-0.32119,0.5191-0.91667,1.6423-0.91667,1.6423s0.38203-1.7066,0.78646-2.3974c0.4055-0.69231,2.3449-2.9186,2.7062-3.7825,0.36121-0.86388,0.36174-1.7938,0.36174-1.7938l1.344-0.0644s1.3995,1.0934,1.4128,2.0428c0.009,0.53585-1.3419,1.1362-1.3723,1.1984-0.0864,0.17321-1.1279-0.0877-1.3846,4.3644-0.2561,4.4531,0.88247,4.0872,0.76621,5.9437z'/%3E %3Cpath fill='%238f4620' d='m411.84,199.14s0.29719,2.419,0.0416,3.154c-0.25556,0.73506-0.97907,1.3392-1.4897,2.2902-0.51166,0.95156-0.46952,3.2434-0.46952,3.2434s0.25663-1.1264,0.68349-1.8187c0.42418-0.68904,0.76567-1.2958,0.93693-1.2958,0.16913,0,0.68081,0.86549,1.0218,2.1202,0.34147,1.2515,1.0239,3.3684,1.0239,3.3684s-0.29666-1.6439,0.12592-1.6439c0.42416,0,0.59437-0.12829,1.1498,0.30475,0.55649,0.43193,1.1946,1.0355,1.1946,1.0355s-0.0443-0.60351-0.85367-1.469c-0.80831-0.86388-1.2757-0.81948-1.535-1.9871-0.2529-1.1675-0.37883-2.3329-0.2529-2.8092,0.12591-0.47364,0.68189,0.30365,1.1493,0.86388,0.46845,0.56241,1.9598,1.8598,1.9598,1.8598s-0.63867-0.99436-0.81045-1.2975c-0.16967-0.30365-0.0437-2.5922,0-3.8896,0.0427-1.2958-0.0437-2.5045,0.42418-2.8493,0.47112-0.34805,0.55647-2.0347,0.3404-2.3362-0.21022-0.30149-4.6403,3.1562-4.6403,3.1562z'/%3E %3Cpath fill='%231e2121' d='m426.09,194.16s0.11577,2.7351,0.48445,4.3216c0.36709,1.5844,1.4203,5.0404,1.4203,5.0404s-1.4203-2.5641-2.0462-4.7817c-0.62584-2.2176-1.1946-4.6084-1.7618-4.7811-0.56611-0.1732-1.2208,1.0653-1.2208,1.9865,0,0.92126,0.59811,4.3795,1.3654,5.59,0.76727,1.2105-1.2224-1.5849-1.7063-3.0831-0.47913-1.4988-0.96571-2.8228-0.96571-2.8228s-0.48074,1.266-0.28278,2.6794c0.20008,1.4111,1.3947,3.4279,1.3947,3.4279s-0.77042-0.66309-1.2517-1.2401c-0.48287-0.57539-0.91025-0.9202-0.91025-0.9202s0.0843,1.9307,0.5965,2.7649c0.50848,0.83465,1.5046,2.1602,1.5046,2.1602s-1.1909-0.89203-1.6465-1.4111c-0.45511-0.518-0.59438-0.89038-0.59438-0.89038s0.25344,2.7632,0.85154,4.2339c0.59491,1.4674,1.9016,3.8896,1.9016,3.8896s-1.5638-1.2417-2.6133-3.6569c-1.0484-2.4223-1.5628-9.6358-1.3077-10.733,0,0,0.8019-1.3635,1.5414-2.4304,0.74002-1.0653,1.6743-6.1569,1.6743-6.1569s1.1605,4.7092,1.9533,5.6028c0.79715,0.89204,1.6194,1.2103,1.6194,1.2103z'/%3E %3Cpath fill='%231e2121' d='m414.82,192.74s0.60132,1.2628,0.98335,1.8252c0.38256,0.56241,0.76775,1.2845,0.76775,1.2845s-1.4091,1.5134-2.9825,2.7237c-1.5804,1.2087-3.666,2.5489-4.1334,1.8582-0.46845-0.69231-0.44604-1.2861-0.44604-1.2861s1.7341-1.0371,3.0972-2.419c1.3611-1.3835,1.8322-2.1088,2.1321-2.8412,0.29878-0.73666,0.58154-1.1454,0.58154-1.1454z'/%3E %3Cpath fill='%231e2121' d='m400.48,197.41s0.24437,2.9397,1.4806,2.8953c1.2362-0.0427,4.8985-3.7592,5.1536-3.9308,0.25556-0.17322,0.50046-1.082,0.50046-1.3852,0-0.30149-0.22248-0.99377-0.22248-0.99377s-3.9419,4.0412-5.3463,4.1716c-1.027,0.0936-1.566-0.75723-1.566-0.75723z'/%3E %3Cpath fill='%231e2121' d='m400.6,193.55s-0.46953,2.0677-0.40443,2.6512c0.0624,0.58187,0.24863,1.0355,0.24863,1.0355s-2.8262,0.99217-3.2942,0.12991c-0.46952-0.86388-0.16006-2.0958-0.16006-2.0958s1.3099,0.006,2.0334-0.16509c0.72512-0.17375,1.5767-1.5557,1.5767-1.5557z'/%3E %3Cpath fill='%231e2121' d='m427.27,189.4s1.1519,3.0306,1.8915,4.2426c0.74162,1.2103,1.9016,3.7148,1.9016,3.7148s-1.9016-2.2176-2.4981-2.7069c-0.59651-0.48987-1.5638-1.3061-1.5638-1.3061s0.27799-0.81627,0.27799-1.4479c0-0.63493-0.009-2.4964-0.009-2.4964z'/%3E %3Cpath fill='%23dbad6c' d='m396.55,195.29s1.05,0.13047,1.6951,0.0942c0.64988-0.0346,1.0746-0.29501,1.0746-0.29501l1.074-1.6043s-0.54687,1.8994-0.16966,3.2482c0.37454,1.3489,1.1562,1.5562,1.4635,1.5562,0.30627,0,1.805-0.31179,2.9655-1.5221,1.1578-1.2087,2.7595-2.4699,2.7595-2.4699s-0.37562,1.7445,0.23796,3.4723c0.61521,1.7294,1.6001,1.6947,2.9303,0.62301,1.3285-1.0717,2.695-2.9067,3.4232-3.7181,0.3991-0.44494,0.90758-1.3732,0.90758-1.3732l1.4625-1.1659,1.2602-7.1213-0.68242-0.93478-1.8445,0.88012-2.2084-0.88012-0.64829-0.8985-1.2602,2.1434-1.3296,0.86387-0.67172,0.11205-1.5436,0.30367-0.68082-1.3835-0.40976-1.0717-0.75017-0.34479-3.1757,3.2033-1.7986-0.092-1.8066,2.8342-1.2954,1.7954-1.3296,3.1492,0.35108,0.59597z'/%3E %3Cpath fill='%238f4620' d='m411.97,188.08s0.25664,1.7727-0.6376,4.7535c-0.89423,2.9825-2.1294,5.1-2.1294,5.1s3.1938-1.9459,4.7294-5.4446c1.5286-3.5021,1.1754-7.5215,1.1754-7.5215l-3.1378,3.1129z'/%3E %3Cpath fill='%238f4620' d='m415.84,184.83s0.3863,0.51746,0.0443,3.1968c-0.34147,2.6794-0.97907,5.2715-0.97907,5.2715s0.3783,0.64952,0.80778,1.5134c0.42417,0.86388,1.4918,2.3778,2.2575,2.1185,0.76728-0.26035,1.9576-1.1675,2.767-2.9413,0.80992-1.7711,1.5345-3.4988,1.8322-3.7592,0.29772-0.25928,0.42737,0.1732,0.55755,0.30366,0.12646,0.13044,0.3735,1.6423,1.1376,2.2902,0.76728,0.6479,1.7682,1.6639,2.2361,1.3618,0.46846-0.30203,0.92623-1.187,0.84197-1.6228-0.0843-0.43031-1.7047-5.271-1.7047-5.271l-2.043-5.2288-1.3099-2.0309-3.7188,0.34642-2.7264,4.4515z'/%3E %3Cpath fill='%23ab6d29' d='m422.29,180.03s1.05,2.2474,1.1119,4.668c0.0555,2.4206-0.48447,4.9549-0.48447,4.9549s0.22623-3.0242-0.11364-4.839c-0.34147-1.8154-0.88087-2.9976-0.82274-3.5156,0.055-0.51801,0.30893-1.2682,0.30893-1.2682z'/%3E %3Cpath d='m427.34,189.49s0.21129,2.0888,0,3.0799c-0.21288,0.99595-1.6641-0.6463-2.5546-3.9308-0.89744-3.2845-0.72671-4.0185-1.408-5.6172-0.68563-1.6011-1.0954-2.9824-1.0954-2.9824l1.8626-0.25765,3.1954,9.7085z'/%3E %3Cpath d='m418.23,195.59s3.5524-2.0147,4.0022-8.0826c0.2161-2.8509-1.6172-7.4756-1.6172-7.4756s0,4.9251-1.32,8.1023c-1.3206,3.1774-2.4085,5.2959-2.4085,5.2959s0.85261-0.36969,1.2805-0.88717c0.4247-0.518,1.0207-1.4062,1.0207-1.4062s0.19154,0.91041-0.12698,2.0974c-0.31906,1.1881-0.83075,2.3557-0.83075,2.3557z'/%3E %3Cpath d='m415.1,184.96s-0.11365,1.3407-1.6049,2.5505c-1.4918,1.2103-4.1718,2.5506-4.1718,2.5506s1.9582-1.8154,2.68-3.415c0.72725-1.5995,0.17127-2.635,0.17127-2.635s-0.2529,0.86228-1.106,1.5118c-0.85153,0.64951-2.0867,0.77673-2.0867,0.77673s0.10244-0.81948,0.86917-1.6834c0.1574-0.17645,0.12858-0.58351,0.23583-0.918,0.41936-1.2963,1.535-3.1015,1.535-3.1015s0.85153,1.9026,1.7031,2.7221c0.85152,0.82113,1.7751,1.6411,1.7751,1.6411z'/%3E %3Cpath fill='%231e2121' d='m426.21,177.79s0.84993,2.1911,1.1909,5.186c0.34147,2.9976-0.0555,6.5127-0.0555,6.5127s-1.8167-2.8244-2.2708-3.9773c-0.45513-1.1524-0.45513-2.8802-0.85314-3.7456-0.23904-0.518-0.89102-1.0376-1.3718-1.3705-0.31532-0.21922-1.3258-0.17159-1.3258-0.17159s1.0484-0.50285,1.1376-1.4246c0.0811-0.9218,0-1.4111,0-1.4111s0.67922,0.34479,1.7884,0.48985c1.1055,0.1429,1.7602-0.0877,1.7602-0.0877z'/%3E %3Cpath fill='%231e2121' d='m418.25,190.58s1.94-2.7091,2.4468-6.0511c0.51221-3.3408-0.0843-4.4948-0.0843-4.4948s-0.79448-0.11367-1.447-0.74857c-0.65363-0.63273-1.6732-2.2755-1.6732-2.2755s0.28225,1.7294-0.0891,3.8317c-0.36654,2.1023-2.2996,4.117-2.2996,4.117s1.026,0.35616,1.933-0.17158c1.9261-1.1248,1.7879-3.2547,1.7879-3.2547s0.42417,0.25927,0.36814,2.9088c-0.0581,2.6528-0.94279,6.1387-0.94279,6.1387z'/%3E %3Cpath fill='%238f4620' d='m395.31,195.2c-0.41083-0.0574,1.2789-2.681,2.4287-4.4948,1.1508-1.8155,2.7686-4.366,2.7686-4.366s0.29932,0.30367,0.98014,0.26036c0.68083-0.0449,2.4276-0.82113,3.1522-2.1619,0.72458-1.3391,1.2773-2.8082,1.3216-3.2417,0.0422-0.43032-0.12912,2.3345,1.1914,3.8469,1.3216,1.5118,1.2784,1.3835,1.8327,1.2531,0,0-0.0427,1.9026-0.55435,3.6737-0.51062,1.7727-1.0223,4.3232-1.0223,4.3232s0.21288-3.3273-0.342-4.2804c-0.55168-0.94996-0.851,0.0872-1.319,1.2975-0.46792,1.2087-1.4897,2.0742-1.4897,2.0742s0.76568-1.469,1.2768-3.0252c0.5106-1.5551,0.25663-1.5995,0.12698-1.6423-0.12698-0.0427-0.38202-0.0855-0.93531,0.56242-0.55436,0.6479-1.1087,0.82113-1.1087,0.82113s0.68188-0.56241,0.89476-1.3408c0.21395-0.77674,0.85261-1.901,1.2352-2.3329,0.38255-0.43194,0.6392-0.95156,0.6392-1.2531,0-0.30365-0.0859-0.95156-0.34201-0.95156-0.25344,0-0.59544,0.3908-1.829,1.5562-1.2368,1.1659-1.4507,1.2515-1.6636,1.685-0.21288,0.43194-0.38362,0.99217-1.1508,3.415-0.76568,2.419-1.2779,3.415-1.4032,3.6309-0.1286,0.21435-0.68243,0.5754-0.68243,0.5754s0.42631-1.3537,1.0645-3.1259c0.63867-1.7706,1.4913-4.1056,1.2784-4.4948-0.21288-0.38756-0.76726-0.3448-0.93745,0-0.16967,0.34642-1.4048,1.8582-2.6405,3.6721-1.2357,1.8171-1.2357,4.0645-1.534,4.15-0.00036,0.00053-0.8238-0.0276-1.2368-0.0855z'/%3E %3Cpath fill='%23874f20' d='m427.43,175.83c-0.0245,0.20948,0.11418,1.5053-1.2202,1.9589-1.336,0.4552-2.9532-0.0855-3.1255-0.236-0.16859-0.15157-0.16859-1.8598-0.16859-1.8598l4.5144,0.13695z'/%3E %3Cpath fill='%23b27129' d='m401.59,180.06s-0.24329,1.2352-0.97266,2.7649c-0.73147,1.5302-1.9432,2.8049-1.7933,2.9993,0.14833,0.19432,0.83128,0.90881,1.8952,0.88718,1.0655-0.0217,1.448-6.3765,1.448-6.3765l-0.1862-0.22734-0.3911-0.0476z'/%3E %3Cpath fill='%23dbad6c' d='m417.95,176.56s-0.48181,8.4208-2.8454,8.4058c-2.3631-0.0114-3.4328-4.2572-3.4328-4.2572s-0.19582,5.6787-3.2141,5.6787c-1.3626,0-2.8017-4.3843-2.4954-5.1806,0,0-0.55915,3.0242-1.9827,4.1435-2.8241,2.2225-4.6248,1.1362-4.7214,0.78972-0.0976-0.34479,2.385-2.714,2.7254-6.0249,0,0,0.43697,0.14832,1.1188-0.83898,0.68187-0.98728,1.0719-2.0725,1.7527-1.8766,0.68189,0.1965,4.0896-1.3835,4.0896-1.3835l1.7863-2.262s0.20969,0.73233,1.5233-0.15696c1.3142-0.89044,1.7532-2.2225,1.7532-2.2225l3.5038,2.963,0.43859,2.2231z'/%3E %3Cpath fill='%23b27129' d='m408.73,168.56s2.1192,3.2087,3.5358,4.9928c0.0827,0.10393,0.77791-0.67121,0.77791-0.67121,0.46793,0.64139,0.72672,1.1984,0.58422,1.5351-0.55274,1.2975-1.7025,3.0685-0.76781,4.9267,0,0-0.29664-1.0371,0.21556-2.3762,0.51167-1.3408,0.89369-1.8171,1.193-1.7727,0.29772,0.0433,0.81044,7.6914,1.3216,7.6487,0.50901-0.0444,1.1914-3.4577,1.1914-5.8764,0-2.4223,0.4834-0.43357,0.71175,0.0427,0.22676,0.47469,2.3119,3.8896,4.1009,3.3706,1.7895-0.518,1.5361-3.6737,1.4902-4.3632-0.0384-0.69392-1.2757-4.8835-1.2757-4.8835l-8.0099-5.042s-0.23369,0.63165-0.65999,2.059c-0.4279,1.4263-4.4093,0.40921-4.4093,0.40921z'/%3E %3Cpath fill='%238f4620' d='m420.1,167.81s0.4674,0.43194,1.2389,2.4206c0.7646,1.9881,0.84886,8.4272-0.1718,8.3823-1.0239-0.0427-3.07-1.2087-3.4083-2.0742-0.34254-0.86388,0.12593-4.0607-0.55381-4.9267-0.68189-0.86388-1.4918-3.0236-1.5356-3.6293-0.0437-0.60356,0.13019-2.5489,0.13019-2.5489l1.7868-0.64951,2.5136,3.0258z'/%3E %3Cpath d='m419.53,165.81,3.4083,5.0702,3.0119,4.3513s1.5163,0.50286,1.4774,0.6035c-0.0422,0.1023-1.7484,1.9589-4.1115,0.64139-1.1754-0.65603-0.57573-2.7026-2.0643-5.9854-1.4934-3.2845-4.1756-4.7108-4.1756-4.7108l0.93852-0.90722,1.5153,0.93697z'/%3E %3Cpath fill='%231e2121' d='m417.65,163.04s3.0449,2.0114,4.1238,4.2014c1.0794,2.1895,1.7068,3.5156,3.0135,5.6472,1.3029,2.1316,2.6998,2.7946,2.6389,2.9381-0.0555,0.14506-0.93585,0.34641-1.5895-0.14345-0.65518-0.48986-1.3328-1.0653-1.8744-2.046-0.54158-0.97918-2.4426-4.5505-3.1544-5.474-0.70962-0.92179-2.9788-2.6496-3.037-2.4763-0.0555,0.1732,0.70962,0.69231,2.0179,2.7946,1.305,2.1023,1.6172,4.0034,1.5324,4.0331-0.0859,0.0298-0.37028-0.77839-1.5062-2.6794-1.1354-1.9026-3.6052-4.3513-3.7477-4.005-0.14247,0.34643,1.2197,2.5938,1.9021,3.8896,0.68081,1.2958,1.8194,4.3216,1.7047,4.3216-0.11312,0-0.90972-1.7002-2.2745-3.8041-1.3611-2.1024-1.6172-1.843-2.187-2.5326-0.56505-0.69392-1.781-2.2885-1.781-2.2885s1.2165,0.38593,2.4069-0.39242c1.1952-0.77839,1.8114-1.9838,1.8114-1.9838z'/%3E %3Cpath fill='%238f4620' d='m409.9,168.65s1.9603,0.45197,3.0215,0.32152c1.0682-0.12883,1.4294-0.0855,1.4294-0.0855s0.63705,0.86547,0.63705,1.8582c0,0.99435-0.68242,2.8525-0.97908,2.8953-0.29772,0.0427-0.25344-1.685-0.72031-2.2902-0.47112-0.60571-3.3886-2.6994-3.3886-2.6994z'/%3E %3Cpath fill='%23b27129' d='m410.94,173.79s0.63386,2.1251,0.14726,5.0864c-0.48767,2.9646-2.1918,6.026-2.6299,6.026-0.43697,0-0.29238-3.3586-0.48605-5.1341-0.0203-0.18998-0.0416-0.37131-0.0619-0.54398-0.0277-0.24574-0.67066,2.2393-0.69465,2.0249-0.0262-0.22572,0.56663-3.1475,0.54473-3.3359-0.0838-0.70422-0.13766-1.1161-0.13766-1.1161l2.1993-2.6117,1.1188-0.39568z'/%3E %3Cpath fill='%238f4620' d='m407.21,176c-0.59597,0.73559-1.51,0.53585-2.3551,0.80003-0.79234,0.24573-1.0783,1.4544-1.0783,1.4544s0.64026-0.4747,0.93852-0.34642c0.29718,0.13045,0.6525,0.1023,0.0555,1.5697-0.59597,1.4706-2.9239,3.9622-2.8113,3.992,0.11364,0.0298,2.6-2.104,3.4083-3.3142,0.80883-1.2087,0.73788-1.9291,0.90812-2.3627,0.16966-0.43195,1.136-0.94942,1.3488-0.99216,0.21395-0.0449,0.6835,0.0427,0.89476,0.90662,0.21343,0.86388,0.55435,3.3273,0.72458,3.4133,0.17074,0.0855,0.76674-2.2474,1.0218-3.4133,0.25557-1.1675,0.24436-3.7381,0.24436-3.7381s-0.15846-0.0644-0.75604-0.19595c-0.59545-0.12883-2.0243-1.154-2.0243-1.154s0.28066,2.3946-0.51967,3.3809z'/%3E %3Cpath fill='%23dbad6c' d='m417.72,160.94s0.80885,2.0098-0.85313,3.415c-0.49246,0.41408-0.96625,0.69066-1.8456,0.73559-0.88301,0.0412-2.2868-0.71395-2.2868-0.71395l-5.0912-2.1191-2.6827-0.84116-1.3206-0.36754,0.18995-1.469,3.9829,0.17321,3.9419,1.5102,1.725,0.56242,1.4683,0.25872h1.1092l0.9156-0.25872s0.42309-0.17321,0.55006-0.40921c0.13072-0.23871,0.19689-0.47633,0.19689-0.47633z'/%3E %3Cpath fill='%23ab6d29' d='m417.72,160.94c0.16755,0.34641-0.30038,1.469-0.68241,1.6423-0.38576,0.17321-1.0687,0.4747-2.6005,0.12882-1.5318-0.34479-3.1085-1.3392-4.8126-1.8138-1.7031-0.47633-2.9815-0.90828-4.302-0.86548-1.3216,0.0449-0.68189-0.56242-0.68189-0.56242s3.0247-0.34317,5.6669,0.64951c2.6427,0.99436,3.7786,1.6698,5.113,1.6406,1.9992-0.0412,2.2996-0.81953,2.2996-0.81953z'/%3E %3Cpath d='m403.79,159.34s0.5949,0.12882,1.1076,0.0427c0.51221-0.0871,0.89636-0.38918,0.89636-0.38918s0.0854,0.69231-0.25662,0.90828c-0.34149,0.21596-1.3627,0.12882-1.534,0.12882-0.17126,0.00036-0.21342-0.69065-0.21342-0.69065z'/%3E %3Cpath fill='%23dbad6c' d='m413.8,165.63s1.7831,1.7445,1.3051,3.2547l-3.4344-1.5784-5.6018-2.3329-3.0348-0.90662-0.37294-0.47633s0.57571-0.53912,0.85153-1.0571c0.27637-0.5191,0.19154-1.0155,0.19154-1.0155l3.7055,0.49636,3.8762,1.1903,2.5141,2.4254z'/%3E %3Cpath fill='%23dbad6c' d='m409.99,168.13s3.1954,4.1272,2.449,5.4874l-7.4558-4.7092-2.6272,4.3281-6.1323-3.0236s4.9471-3.8122,5.5227-4.5246c0.57464-0.71395,0.61787-0.97266,0.61787-0.97266l2.7691,0.53912,4.3639,1.3852,0.49247,1.4902z'/%3E %3Cpath fill='%23ab6d29' d='m408.26,162.03s2.6112,0.63493,4.2892,1.4972c1.6748,0.86388,4.0187,1.0587,4.0187,1.0587s-0.94173,0.99376-2.7713,1.0452c-0.54052,0.0146-1.845-1.0371-2.6987-1.6406-0.851-0.60676-3.3075-1.3256-3.3075-1.3256l0.46953-0.63493z'/%3E %3Cpath d='m403.66,160.63s1.8754,0.38918,3.0263,0.90662c1.1498,0.51908,1.2352,0.38918,1.5334,0.26036,0.29771-0.13045,0.33986-0.26036,0.33986-0.26036s0.23584,1.1264-0.65998,1.1264c-0.89476,0-1.256-0.30365-2.4053-0.82274-1.1509-0.51801-1.9187,0-1.9187,0l0.0843-1.2103z'/%3E %3Cpath fill='%23ab6d29' d='m414.02,167.88s1.3371,0.83571,1.0783,1.0073c-0.2529,0.17321-0.92303,0.48986-2.0851,0.56241-1.1621,0.0725-1.7191-0.0709-2.544-0.44709-0.82166-0.37403-1.3333-1.8155-3.3219-2.5922-1.987-0.77839-2.329-0.89363-3.6911-1.2401-1.3638-0.3448-1.6759-0.31666-1.6759-0.31666l1.2507-0.51908,4.286,0.86548,3.6639,1.0653,2.2153,1.0668,0.8238,0.54779z'/%3E %3Cpath fill='%23ab6d29' d='m406.82,170.4,0.85261,3.3706-0.46953,2.0331-1.1498,0.73345-1.0645-0.43194-0.29825-0.60517s0.46898-0.77673,0-1.469c-0.46632-0.69066-2.64-1.5551-2.64-1.5551s0.85261-1.6439,1.8306-2.0315c0.97908-0.38919,0.50954-1.6423,0.50954-1.6423l2.4292,1.5979z'/%3E %3Cpath d='m402.64,163.53s0.68081,0.57541,2.075,0.72101c0.59063,0.0628,1.6967,0.26035,2.8347,0.61814,0.38255,0.12071,1.3174-0.39893,1.3958-0.37565l-0.80938,0.48498c1.2368,0.35617,2.7899,0.8969,3.3363,1.1459,1.479,0.66955,2.641,1.7294,2.5552,1.7575-0.0464,0.0146-0.84245-0.46172-2.5552-1.1822-1.2432-0.52288-2.8235-1.0106-3.9755-1.2401-2.5573-0.50123-5.113-0.34263-5.6509-0.51747-0.54159-0.17159,0.22676-0.20135,0.50953-0.48986,0.2844-0.28741,0.2844-0.92232,0.2844-0.92232z'/%3E %3Cpath fill='%23ab6d29' d='m412.18,172.78s0.81152,0.86387-0.0416,1.1659c-0.85153,0.30366-3.1741,0.24899-4.2802-0.91855,0,0-0.27744-1.1113-0.70374-1.6292-0.42525-0.51909-2.1294-1.5995-3.1095-2.2046-0.97908-0.60515,0.3388-0.69231,0.3388-0.69231s3.4953,1.3408,4.7737,2.0314c1.2784,0.69284,3.0226,2.2474,3.0226,2.2474z'/%3E %3Cpath d='m412.23,172.86s-1.7212-2.3778-6.5015-4.2626c-0.13178-0.0509,1.6263-0.3015,1.4891-0.3513-0.20489-0.079-2.3055,0.0412-2.5226-0.033-0.36015-0.12394-0.73308-0.24735-1.1247-0.3659-2.5136-0.76375-2.6966-0.69065-2.8662-1.0371-0.17234-0.3448-0.48445,0.0574-0.73948,0.48931-0.25718,0.43195-0.96519,1.3684-0.90919,1.2828,0.0566-0.0877,1.8472-0.50448,3.2659-0.15806,1.4208,0.34318,1.3622,0.86388,1.2491,1.4111-0.11312,0.54725-1.845,2.6512-1.6465,2.7091,0.19901,0.0563,1.1919-1.9903,2.4981-1.7002,1.3072,0.28851,1.734,1.0073,1.734,1.0073s-0.0299-0.74857-0.28331-1.0669c-0.25664-0.31664-1.7052-1.6704-1.3077-1.6704,0.39748,0,2.0157,0.37403,4.3452,1.5551,2.2676,1.1551,2.6384,1.4999,3.3197,2.1906z'/%3E %3Cpath fill='%23dbad6c' d='m404.43,169.12s3.665,1.0371,3.4942,4.9267c-0.17073,3.888-3.0108,3.1687-3.2675,1.7576-0.25344-1.4127,0.34146,0.67606,1.3638,0.48823,1.1172-0.20298,1.3488-1.3224,1.2784-2.8212-0.0683-1.4398-0.36815-2.1619-1.2501-2.9976-0.87927-0.83571-1.6188-1.3537-1.6188-1.3537z'/%3E %3Cpath fill='%236c3f18' d='m388.58,159.75s0.38362,0.295-0.66051,3.0404c-1.0447,2.7438-1.6092,3.7213-3.1933,5.4676-2.9623,3.2612-4.2609,3.2829-3.9414,4.6664,0.32014,1.3835,1.47,1.0144,1.7244,1.0588,0.25664,0.0433,5.5809-7.8004,5.5809-7.8004l1.1712-4.7108-0.27639-1.3175-0.40496-0.40434z'/%3E %3Cpath fill='%23dbad6c' d='m401.79,154.14s1.534,2.3016,1.05,6.6533c-0.48287,4.3497-6.2162,8.1531-6.2162,8.1531l-8.3786,5.7909-3.5006-0.20948s-0.54211,0.0779-1.05-0.0547c-0.5506-0.14343-1.0671-0.71395-1.1855-0.71395-0.22729,0-0.65411-1.4706-0.65411-1.4706l1.1087-1.3532,3.0386-3.0274,1.9016-2.7356s0.85313-1.5843,0.96625-3.1113c0.11471-1.527-0.28385-2.3053-0.28385-2.3053l0.71123,1.095,0.39589,2.3048-0.31266,2.5641,2.1876-1.469,2.8961-1.2948s0.79661-0.11692,1.3638-1.7294c0.56665-1.6141,1.0442-3.9849,1.0532-5.042,0.0112-1.0604-0.11738-2.3334-0.11738-2.3334s0.18194-0.0114,0.36441,0.0974c0.18035,0.10717,0.946,1.4479,0.946,2.2128,0,0.76807,0.4898,3.5892,0.4898,3.5892l1.3429-1.3635s0.98977-1.2417,1.256-1.888c0.26571-0.64898,0.6376-1.6715,0.62691-2.3589z'/%3E %3Cpath fill='%23904720' d='m402.72,175.91s0.57518,0.47471,0.36174,2.0525c-0.21289,1.5784-1.5116,2.4422-2.1496,2.4634l0.0624-2.203-1.8519-1.4706-1.9822-0.6035s0.1286-0.1088,0.36175-0.34642c0.2353-0.23708,2.2809-1.0799,2.2809-1.0799l2.9169,1.1876z'/%3E %3Cpath fill='%23ab6d29' d='m401.27,175.93s0.57519,0.56076,1.4913,0.32313c0.9156-0.23599,1.3008-1.7083,0.80938-2.2902-0.48981-0.58347-0.27639,1.4046-0.87184,1.6212-0.59758,0.21598-1.2352-1.4907-2.0456-1.6639-0.80938-0.17321-2.0878,0.38918-2.4063,0.92665-0.3196,0.54238,1.3002,0.11043,1.3002,0.11043l0.8713,0.23707,0.64027,0.15157,0.21128,0.58405z'/%3E %3Cpath fill='%23904720' d='m389.17,169.89s1.0889,0.32784,2.2681,0.16817c1.1792-0.16022,4.0763-1.3684,4.0763-1.3684s1.3339-0.75023,2.3145-1.7002c0.97747-0.94995,4.0753-2.8823,4.4157-6.7404,0.3388-3.8615-0.45511-6.1072-0.45511-6.1072s4.5763,5.0009,0.56717,10.746c-2.6112,3.7441-4.883,4.8391-4.883,4.8391s4.4306-1.2964,4.8286-0.23112c0.39484,1.0653-0.20701,2.7237-0.32172,2.983,0,0,2.5136,0.58353,2.8753,1.8582,0.21768,0.76536-2.8534-0.88717-5.1739-0.32476-2.321,0.56241-3.3432,1.9437-3.3432,1.9437s-0.4263-0.66955-2.4922-0.68905c-2.0675-0.0227-3.0034,0.94942-4.1761,0.90662-1.1701-0.0444-4.853-0.83-5.5643-1.8373,0,0,0.87873-1.0973,2.4371-2.875,1.0652-2.0486,2.6267-1.5707,2.6267-1.5707z'/%3E %3Cpath fill='%23ab6d29' d='m398.69,159.53s1.79-1.7575,2.385-3.0534c0.59811-1.2964,0.71123-2.3335,0.71123-2.3335s0.20008,1.4095-0.851,2.9944c-1.0522,1.5865-2.2142,2.681-2.2142,2.681l-0.031-0.28851z'/%3E %3Cpath fill='%23904720' d='m398.2,155.61s1.463,5.6755-0.0992,8.0083c-1.5628,2.3335-8.3593,5.3549-8.3593,5.3549s5.1508-2.7909,6.7703-6.003c1.6172-3.2136,1.5041-5.8913,1.5041-5.8913l0.18461-1.469z'/%3E %3Cpath fill='%231e2121' d='m391.44,170.05s2.1737-0.0449,3.4083-0.77838c1.2362-0.73346,2.9825-2.2902,2.9825-2.2902s-1.6183,1.4263-2.0878,1.4263c-0.46953,0-0.85154-0.73345-0.6392-1.2964,0,0-0.38309,1.0804-1.3622,1.8138-0.97961,0.73506-2.3017,1.1248-2.3017,1.1248z'/%3E %3Cpath fill='%231e2121' d='m396.5,162.97s1.8311-1.9026,1.7879-5.878c-0.0422-3.9752-1.534-3.2401-1.534-3.2401s1.2362,0.90662,0.98014,3.9324c-0.2545,3.0242-1.2341,5.1854-1.2341,5.1854z'/%3E %3Cpath fill='%231e2121' d='m398.72,163.36s2.0632-0.49798,2.7894-1.7083c0.72298-1.2087,0.70374-3.5205,0.70374-3.5205s-0.21448,2.1175-0.81151,2.8937c-0.59544,0.77892-2.6816,2.3351-2.6816,2.3351z'/%3E %3Cpath fill='%231e2121' d='m397.52,175.8s1.0239-1.9887,2.3876-1.469c1.3611,0.51639,1.3611,1.5995,1.3611,1.5995s-0.55328-0.86388-1.574-0.90881c-1.0239-0.0427-2.1748,0.77838-2.1748,0.77838z'/%3E %3Cpath fill='%231e2121' d='m393.65,172.22s3.0231-0.73671,4.8132-1.2975c1.7879-0.56075,3.8346-1.4263,3.8346-1.4263s-1.4918,1.8582-3.7082,3.1113c-2.2153,1.2531-4.0459,1.3392-4.0459,1.3392s4.1761-1.8138,4.5149-2.5478c0.00036,0-4.0027,1.0798-5.4089,0.82113z'/%3E %3Cpath fill='%23fff' d='m388.81,167.55a3.4648,3.5296,67.762,0,1,-3.9761,5.7172'/%3E %3Cpath fill='%23f16e16' d='m388.63,167.94a3.0522,3.1092,67.771,0,1,-3.5737,4.9719'/%3E %3Cpath fill='%23000' d='m387.28,169.62a1.2259,1.2259,0,1,1,-1.1941,1.8534'/%3E %3Cpath fill='%23d5d3ca' d='m387.45,171.18c-0.0386,0.21551-0.24182,0.36146-0.4524,0.32171-0.21425-0.036-0.35504-0.24034-0.31893-0.45585,0.0361-0.21735,0.23934-0.36143,0.45116-0.32355,0.21425,0.036,0.35506,0.2422,0.32017,0.45769z'/%3E %3Cpath fill='%23ab6d29' d='m389.58,165.4s2.0168-1.9865,2.4703-4.6101c0.45512-2.622,0.17874-4.1121,0.17874-4.1121l1.0997,1.1443,0.42418,1.9903-0.71016,3.311,2.218-1.0073c0.73629-1.0073,1.901-5.5024,1.503-8.2669,0,0,0.59811,1.2103-0.19848,4.9831-0.79447,3.776-1.4431,4.2223-4.2826,5.777-1.4646,0.8011-3.3098,2.3405-4.9731,5.5403-0.74013,1.4238-2.7415,3.6732-3.0638,4.0018-0.0518,0.0525,1.4224-2.0151,2.1422-3.5576,1.0778-2.3099,2.2551-3.6079,2.2551-3.6079l0.93691-1.5854z'/%3E %3Cpath fill='%23904720' d='m388.64,166.99s0.87932-2.6512,0.87932-4.091-0.93639-3.1411-0.93639-3.1411,1.2768-0.17322,1.391,2.9662c0.11311,3.1427-0.56877,3.3159-1.3339,4.2658z'/%3E %3Cpath d='m392.69,163.61s0.93638-2.3329,0.87397-3.8896c-0.0651-1.5562-1.3408-3.0469-1.3408-3.0469s1.5756,0.30312,1.7041,3.1346c0.12645,2.8293-0.36388,2.8525-1.2373,3.802z'/%3E %3Cpath fill='%23ab6d29' d='m383.39,174.25s-0.72832-0.93644-0.64401-1.6704c0.0854-0.73345,0.0283-0.90011,1.8376-2.8027,1.8098-1.901,2.8118-3.0669,3.2589-4.0824,0.44764-1.0171,1.916-3.789,0.7459-5.9357,0,0,0.80884,3.1281-1.002,5.6124-1.8109,2.4834-2.8524,3.7792-4.3442,4.8823-1.4902,1.1015-1.6391,1.619-1.5969,2.2474,0.0433,0.62627,0.19101,1.2531,0.44712,1.4046,0.45511,0.26848,1.2976,0.34426,1.2976,0.34426z'/%3E %3Cpath fill='%236c4119' d='m400.94,180.42s0.40389,0.0427,0.65998-0.43195c0.25451-0.47469,0.25451-1.2742-0.38362-2.0742-0.63974-0.79949-1.3638-1.2742-2.2586-1.5351-0.89476-0.25873-2.6181-0.43194-2.6181-0.43194s0.58582,1.0106,1.7452,1.6634c0.56717,0.32152,1.534-0.0855,2.1518,0.51908,0.61788,0.60677,0.70321,2.2907,0.70321,2.2907z'/%3E %3Cpath fill='%236c4119' d='m400.94,180.42s2.012-0.65331,2.1496-2.5922c0.0854-1.2006-0.16967-1.6212-0.16967-1.6212s0.29719,0.62681,1.1076,0.86388l0.72405-0.28038c-0.00036,0.00036-1.1925,3.7597-3.8117,3.6298z'/%3E %3C/g%3E %3Cg id='beak' fill='%23f9c83a'%3E %3Cpath fill='%23bf802d' d='m386.9,180.05s0.39322,0.16347,1.1392,1.0274c0.74589,0.86386,1.097,1.1459,1.097,1.1459l4.8778-1.2531,1.5777-1.5562-1.3216-2.0942h-3.4926l-3.8773,2.7302z'/%3E %3Cpath stroke='%238f4620' stroke-width='0.48' d='m398.72,178.39-0.93959-1.2661s-0.19901-0.48985-0.90865-0.86388c-0.70963-0.37402-3.6634-0.34641-3.6634-0.34641l-2.1299,0.43194s-0.59598,0.54724-1.6759,0.31665c-1.0788-0.22897-3.4643-1.2103-3.4643-1.2103l-2.3855-1.0371s-1.7879-0.74857-2.186-0.60517c-0.39856,0.14345-1.8738,1.7581-1.8738,1.7581s-0.25611,0.86548,0.31159,0.89203c0.56718,0.0298-0.8526,0.28851-0.8526,0.28851s-3.7066,2.0331-4.3015,5.6637c-0.59757,3.6271,6.0901,8.9866,8.5602,6.2638,0,0-3.6201-2.6794-2.8955-4.9267,0.7235-2.2474,2.3855-3.6309,5.2389-3.8004,2.854-0.1732,3.0247-0.5207,4.2599-1.3851,1.2352-0.86388,3.5348-1.3819,5.2395,0.38918,1.7025,1.7705-6.4753,3.4594-6.4753,3.4594l0.89369,1.2942c0.002-0.00054,10.099-3.4582,9.2479-5.3165z'/%3E %3Cpath fill='%23fcf3d8' d='m379.85,187s-4.0886-0.99436-3.7498-4.7535c0.34254-3.7576,3.7498-5.1411,4.3463-5.3137,0.59597-0.17483,0.46899-2.0775,1.1508-2.2902,0.68082-0.21758,1.9896,0,2.5867,0.56077,0.5965,0.56242,1.8631,1.0918,1.8631,1.0918s-7.2399,3.2217-7.3035,7.3767c-0.0443,2.7659,1.1066,3.3283,1.1066,3.3283z'/%3E %3Cpath fill='%23fdeaaf' d='m398.7,177.99s-0.49513,0.30203-0.62905,0.053c-0.76566-1.4246-2.5557-1.8041-4.0048-1.7808-1.8456,0.0281-3.0973,0.71555-4.3474,0.71555-1.2491,0-0.90758-0.19972-2.385-0.26035-1.4774-0.0563-4.6285-2.3892-5.3398-2.1581-0.70962,0.23059-0.99398,1.108-0.90758,1.54,0.0864,0.43193-1.2821,0.45846-1.4806,0.14019-0.19955-0.31665,1.0874-2.3546,2.3658-2.3546,3.4355,0,5.9864,2.3151,7.6343,2.3151,1.6482,0,2.2158-0.95102,4.4296-0.95102,2.2164-0.001,4.6078,0.98298,4.6648,2.741z'/%3E %3Cpath fill='%23513625' d='m387.45,180.66s1.6422-0.32476,2.8742-0.86388c1.2368-0.53913,2.8833-0.97106,2.8833-0.97106s-1.5105,0.99922-2.5547,1.4988c-1.0436,0.49473-2.7339,0.76807-2.7339,0.76807l-0.46899-0.43195z'/%3E %3Cpath d='m381.66,189.16c-0.29718,0.11692-1.7324,0.0574-4.0176-1.469-2.2863-1.527-2.8817-4.1186-2.8817-4.1186s-0.52554-2.4802,1.845-4.9992c2.3722-2.5213,2.7606-1.7954,2.8871-1.6785,0.10884,0.1023-0.11952,0.22463-0.11952,0.22463l-2.0878,1.7002-1.0351,1.7429-0.91881,1.5681,0.072,1.855,1.057,1.8647,3.2706,2.0428,1.9288,1.2671z'/%3E %3Cpath fill='%238b5122' d='m380.41,174.93-0.13179-0.31179v0.33939c0.10565-0.006,0.11899-0.026,0.13179-0.0276l-0.13179-0.31178v0.33939-0.3448l-0.23637,0.24575c0.0854,0.0823,0.18461,0.099,0.23637,0.099v-0.3448l-0.23637,0.24575,0.23637-0.24575h-0.33774c-0.002,0.0563,0.0176,0.16346,0.10137,0.24575l0.23637-0.24575h-0.33774,0.33561l-0.30733-0.14182c-0.008,0.0244-0.0266,0.0509-0.0283,0.14182h0.33561l-0.30734-0.14182,0.26678,0.12179-0.23796-0.17321-0.0283,0.0514,0.26678,0.12178-0.23797-0.1732,0.0592,0.0433-0.0555-0.046-0.004,0.003,0.0592,0.0433-0.0555-0.046c-0.0155,0.02-0.0928,0.10392-0.18353,0.21109-0.13979,0.16347-0.32493,0.38594-0.48287,0.63007-0.15473,0.24898-0.30146,0.50285-0.30946,0.82434l0.01,0.11854c0.0443,0.32964,0.26731,0.58999,0.51115,0.70423,0.24597,0.12503,0.50527,0.15155,0.75178,0.15317,0.54579-0.002,1.05-0.15967,1.0676-0.16346,0.17927-0.0541,0.28279-0.25061,0.2273-0.43195-0.0539-0.18295-0.24544-0.28525-0.42417-0.23058l-0.0144,0.005c-0.0838,0.0249-0.493,0.13044-0.85635,0.12882-0.18515,0.002-0.35375-0.0298-0.44498-0.079-0.0944-0.0541-0.11951-0.079-0.14459-0.19432v-0.01c-0.005-0.033,0.0277-0.15155,0.10244-0.28363,0.10724-0.20299,0.28705-0.43898,0.44124-0.62301,0.0768-0.0904,0.14567-0.16996,0.20009-0.2295l0.0667-0.0806,0.0325-0.0395,0.0266-0.0412,0.0229-0.0493c0.006-0.0227,0.0198-0.0547,0.0213-0.12232,0.002-0.059-0.0198-0.16671-0.10404-0.25061-0.0827-0.0823-0.18461-0.0974-0.23903-0.0974-0.10406,0.006-0.12166,0.0244-0.13446,0.0281-0.17234,0.0742-0.25397,0.27714-0.18034,0.45142,0.0726,0.17593,0.27051,0.2582,0.44552,0.18405z'/%3E %3Cpath d='m387.36,178.44s-4.89,1.3684-5.0148,1.4577c-0.35856,0.25872,1.567-0.0412,3.0786-0.0877,0.99297-0.0281,1.7586,0.22301,1.7586,0.22301s0.58742-0.0168,1.1823-0.24737c1.8749-0.73233,5.8208-2.1992,6.1873-0.47145,0.30573,1.4409-5.45,2.7069-5.45,2.7069l-0.0502,0.56887,4.6269-1.1524,2.385-1.2531,0.76776-1.2314-2.3022-1.6406h-3.3646l-1.5548,0.43195-2.25,0.69557z'/%3E %3Cpath fill='%238f4620' d='m380.21,185.51c0.36174,1.0155,1.1791,2.4948,2.1011,2.9662,0,0,0.15579,0.0168,0.1003,0.11528-0.0576,0.10068-0.73949,0.52126-2.3012,0.1153-1.5617-0.40217-3.9477-1.0371-5.396-5.4142l0.0443,0.96454,0.85154,1.7148,1.5318,1.5843,2.4015,1.5118,1.646,0.40218,1.3915-0.35942,0.62477-0.47469-1.4342-1.2964-1.7591-2.9976c-0.001,0.001-0.071,0.41625,0.19742,1.1681z'/%3E %3C/g%3E %3C/g%3E %3Cg id='snake2' fill='%23816c2a'%3E %3Cpath fill='%23fcca3d' d='m396.5,228.99,0,0-0.0747,1.5859-0.87502-0.0866,0.15473-1.9864z'/%3E %3Cpath fill='%23fcca3d' d='m390.37,183.78,0,0-1.6167-1.8186-1.0511,0.15696,1.6006,2.2787z'/%3E %3Cpath d='m396.42,232.7c-0.003,0-0.97695-0.64138-2.2414-1.2249-1.2912-0.59378-3.1042-0.86227-3.1138-0.86607l-0.0603,0.4092s0.10991,0.0178,0.29612,0.0525c0.56075,0.10231,1.8056,0.36429,2.7099,0.7816,0.61628,0.28526,1.1663,0.5824,1.5596,0.81301,0.19581,0.11366,0.35373,0.20947,0.46257,0.27714,0.10832,0.0677,0.16594,0.10554,0.16594,0.10554l0.22143-0.34804z'/%3E %3Cpath d='m396.28,228.65c-0.002,0-0.89369-0.0644-1.8461-0.0644-0.65892,0-1.3419,0.0298-1.8082,0.14018-1.0938,0.27065-1.8072,0.8244-1.821,0.83412l0.24544,0.32964,0.0277-0.02c0.13392-0.0991,0.76245-0.52287,1.6455-0.74045,0.39217-0.0958,1.0677-0.13369,1.7106-0.12882,0.46632,0,0.92142,0.0151,1.2602,0.0298,0.33719,0.0163,0.55701,0.0346,0.55701,0.0346l0.0288-0.41462z'/%3E %3Cpath d='m395.81,225.17c-0.004,0.003-2.2575,1.0636-3.3043,1.7559-1.0345,0.6858-2.1203,1.5778-2.123,1.5794l0.25823,0.32477s0.26677-0.22084,0.66426-0.52613c0.39376-0.30852,0.91827-0.69609,1.423-1.0322,0.49568-0.32638,1.3158-0.76321,2.0024-1.1112,0.69097-0.35075,1.2517-0.61329,1.2517-0.61329l-0.17233-0.37727z'/%3E %3Cpath d='m393.64,221.59v0.006c0.001,0.0779-0.0187,0.91041-0.42257,1.5519-0.0992,0.15967-0.41777,0.54398-0.82274,1.0025-0.612,0.68903-1.4321,1.5746-2.1017,2.2869-0.6664,0.70743-1.1813,1.2434-1.1813,1.2434l0.29346,0.29175c0.002-0.003,0.91662-0.95968,1.8925-2.0049,0.48499-0.5245,0.98922-1.0766,1.4-1.5383,0.4135-0.4666,0.7288-0.84277,0.86489-1.0571,0.4786-0.77134,0.48447-1.6601,0.48661-1.776v-0.006h-0.40924z'/%3E %3Cpath d='m390.81,219.99,0.016,0.0742c0.0325,0.15155,0.095,0.52613,0.095,1.0257,0,0.5126-0.0683,1.1611-0.30572,1.8333-0.27478,0.78865-0.81579,1.9178-1.2837,2.8428-0.23584,0.46495-0.45192,0.87525-0.60987,1.1773-0.1574,0.295-0.25557,0.47308-0.25557,0.47308l0.35534,0.20622c0.004-0.006,1.599-2.9132,2.179-4.5624,0.25611-0.72532,0.3292-1.4198,0.3292-1.9703,0-0.71394-0.12111-1.1919-0.12538-1.2054l-0.39431,0.10555z'/%3E %3Cpath d='m388.07,219.66s0.017,0.16184,0.0341,0.43194c0.0192,0.27388,0.0373,0.64791,0.0373,1.062,0.002,0.76808-0.0635,1.6769-0.28918,2.3015-0.24597,0.69771-0.58262,1.6124-0.85901,2.3513-0.27424,0.73884-0.48447,1.3023-0.48447,1.3023l0.38096,0.14669s0.84993-2.2588,1.3483-3.6602c0.25184-0.71395,0.31054-1.6504,0.31214-2.4417,0-0.85249-0.0731-1.5351-0.0731-1.5383l-0.40711,0.0444z'/%3E %3Cpath d='m385.96,219.65s-0.003,0.6961-0.0464,1.5616c-0.0416,0.86548-0.12485,1.8977-0.27478,2.5392-0.31639,1.3521-0.64828,3.3013-0.64828,3.3013l0.40282,0.0709s0.0822-0.48824,0.20329-1.1394c0.12272-0.64952,0.28545-1.4706,0.44018-2.137,0.32013-1.3852,0.32919-4.1863,0.33079-4.1933l-0.40762-0.003z'/%3E %3Cpath d='m383.68,220.02s0.0293,0.25549,0.0566,0.64952c0.0283,0.39567,0.0566,0.92019,0.0566,1.4528,0,0.61163-0.0406,1.233-0.15099,1.6536-0.33241,1.2661-0.52982,3.2515-0.53141,3.2564l0.40815,0.0444c0-0.003,0.0481-0.49311,0.13819-1.141,0.0902-0.6463,0.22196-1.4512,0.38096-2.0526,0.12859-0.4877,0.16327-1.1329,0.16327-1.7608,0-1.0966-0.11258-2.1451-0.11525-2.1484l-0.40604,0.046z'/%3E %3Cpath d='m381.89,220.26s0.006,0.0806,0.006,0.23438c0,0.48769-0.0432,1.6698-0.38095,2.8856-0.22783,0.81136-0.49567,1.7694-0.71123,2.5229-0.21128,0.75349-0.36814,1.3045-0.36814,1.3045l0.39322,0.11528s0.62425-2.2046,1.0783-3.8339c0.35374-1.2698,0.39483-2.4845,0.39483-2.9944,0-0.15969-0.002-0.25062-0.002-0.25224l-0.40977,0.0178z'/%3E %3Cpath d='m379.89,220.28s0.0106,0.0904,0.0245,0.24413c0.0112,0.1613,0.0245,0.38377,0.0245,0.65277,0.002,0.76374-0.10565,1.8728-0.57946,2.7389-0.4007,0.73073-1.1541,1.4442-1.8098,1.9605-0.32653,0.26036-0.62797,0.4747-0.8457,0.62033-0.11045,0.0742-0.19902,0.12991-0.25985,0.16944l-0.0944,0.0563,0.20809,0.35941c0.0106-0.0114,2.2575-1.3337,3.1603-2.9678,0.5282-0.9678,0.62905-2.1353,0.62905-2.9365,0-0.56401-0.0512-0.94509-0.0518-0.95102l-0.40551,0.0536z'/%3E %3Cpath d='m378.66,219.89s-0.031,0.1023-0.0886,0.2755c-0.17662,0.5229-0.62104,1.6802-1.2517,2.4618-0.4167,0.51639-1.1023,1.062-1.6786,1.4642-0.28918,0.20298-0.55167,0.36915-0.74055,0.48823-0.18995,0.11854-0.30519,0.18295-0.30519,0.18457l0.20007,0.35942c0.01-0.005,1.9155-1.0896,2.8401-2.2355,0.91822-1.141,1.4118-2.8655,1.4155-2.8791l-0.39109-0.11908z'/%3E %3Cpath d='m376.71,218.91s-0.0432,0.0855-0.11419,0.22409c-0.11204,0.2111-0.29025,0.53912-0.49193,0.85255-0.20221,0.31826-0.43325,0.62461-0.62157,0.78971-0.26784,0.22896-0.7966,0.56728-1.2475,0.83246-0.45192,0.26902-0.83075,0.4747-0.83395,0.47633l0.19314,0.36591c0.002-0.003,0.38789-0.20785,0.84779-0.48337,0.46153-0.27497,0.99137-0.60842,1.3056-0.87905,0.32814-0.28526,0.64668-0.77673,0.89797-1.2054,0.25184-0.42545,0.42898-0.78811,0.42898-0.78811l-0.36441-0.18512z'/%3E %3Cpath d='m375.76,217.69s-0.12272,0.14507-0.32013,0.37133c-0.29932,0.33938-0.76513,0.8525-1.2304,1.2991-0.23263,0.22085-0.46419,0.4287-0.67013,0.58513-0.20542,0.15968-0.39323,0.26901-0.49995,0.30203l0.11472,0.39731c0.26571-0.0823,0.54686-0.28851,0.86062-0.55051,0.93104-0.79297,2.0536-2.1305,2.0558-2.1353l-0.31053-0.26902z'/%3E %3Cpath d='m375.29,216.87s-0.1131,0.092-0.29665,0.23438c-0.27371,0.2111-0.70695,0.52937-1.1408,0.78812-0.42684,0.26197-0.87718,0.4617-1.0954,0.45467h-0.0106v0.41409h0.0106c0.26411-0.003,0.54848-0.11205,0.84833-0.25874,0.89904-0.44709,1.9357-1.3094,1.9421-1.3094l-0.2577-0.32314z'/%3E %3Cpath d='m374.93,215.99c-0.002,0-0.45352,0.26197-0.97587,0.53099-0.26358,0.13369-0.54051,0.27172-0.78752,0.37782-0.24331,0.10555-0.46313,0.17646-0.56183,0.1862l0.04,0.41028c0.18994-0.02,0.41776-0.10392,0.68029-0.21434,0.77897-0.33126,1.8039-0.93318,1.8098-0.93318l-0.20488-0.35778z'/%3E %3Cpath d='m374.5,214.17-0.0427,0.046c-0.0966,0.10554-0.36174,0.37402-0.70375,0.61002-0.33987,0.24412-0.75819,0.45035-1.1376,0.45035l0.006,0.41569c0.5885-0.013,1.1215-0.33288,1.5206-0.63272,0.39749-0.30854,0.65837-0.61003,0.66212-0.61708l-0.30466-0.27227z'/%3E %3Cpath d='m374.65,211.31c-0.002,0-0.36975,0.29176-0.77524,0.67607-0.40283,0.38756-0.84197,0.84763-1.0057,1.2698,0.002,0.003-0.0571,0.0991-0.11952,0.16292l-0.0886,0.0742-0.0266,0.0163h-0.004l0.006,0.0249v-0.0249h-0.006l0.006,0.0249v-0.0249,0.41245c0.19635-0.008,0.31052-0.11692,0.40709-0.21434,0.0976-0.1088,0.16702-0.20461,0.20543-0.30366,0.0971-0.27877,0.51807-0.74857,0.90705-1.1129,0.19421-0.1862,0.38202-0.35291,0.52074-0.4682,0.13659-0.11854,0.22676-0.1862,0.22676-0.1862l-0.25397-0.3264z'/%3E %3Cpath d='m388.69,194.52s0.92142,0.005,1.503,0.005c0.13392,0,0.2497-0.002,0.33346-0.002h0.096l0.0304-0.003h0.016l0.0187-0.003,0.0315-0.008,0.0491-0.0227,0.0502-0.0476,0.0416-0.12395-0.0363-0.12071-0.0747-0.0628-0.0587-0.0227-0.031-0.002-0.017,0.41408,0.007-0.16185-0.0176,0.16185h0.0106l0.007-0.16185-0.0176,0.16185,0.0213-0.19811-0.0416,0.19432,0.0203,0.003,0.0213-0.19811-0.0416,0.19433,0.0432-0.20299-0.0747,0.1927,0.032,0.01,0.0432-0.20298-0.0747,0.19269,0.0747-0.19269-0.12058,0.16671,0.0454,0.0265,0.0747-0.1927-0.12058,0.16672-0.0464-0.0476,0.167-0.11854h-0.20381l0.0373,0.11854,0.167-0.11854h-0.20381l0.0416-0.12503,0.0811-0.0644,0.0795,0.18619-0.0229-0.20298-0.0566,0.0163,0.0795,0.18621-0.0229-0.20298,0.0144,0.13694-0.004-0.13694h-0.0106l0.0144,0.13694-0.004-0.13694h-0.4471c-0.58,0-1.4993-0.002-1.5009-0.002l-0.004,0.41462z'/%3E %3Cpath d='m388.74,193.29,0.13018,0.008c0.29026-0.002,0.58048-0.11854,0.87612-0.27552,0.44125-0.23599,0.89743-0.5786,1.3099-0.85901,0.20488-0.14019,0.40123-0.26577,0.57037-0.35128,0.16807-0.0855,0.31374-0.13209,0.4023-0.13209l-0.006-0.4157c-0.25984,0.008-0.50848,0.13045-0.77844,0.2885-0.40497,0.23708-0.8494,0.57701-1.2757,0.8525-0.42258,0.282-0.83449,0.48336-1.0991,0.47633l-0.0747-0.003-0.055,0.41136z'/%3E %3Cpath d='m388.57,191.32c0.30572-0.0412,0.62584-0.18999,0.96839-0.38269,0.51061-0.28851,1.065-0.68253,1.5718-1.0025,0.50313-0.32314,0.97854-0.55915,1.233-0.55535l-0.006-0.41571c-0.29505,0.008-0.60025,0.13857-0.9321,0.31503-0.49301,0.26902-1.0442,0.65981-1.5617,0.9911-0.5154,0.33288-1.0095,0.6035-1.3243,0.63819l0.0512,0.41192z'/%3E %3Cpath d='m387.84,189.49c0.4914-0.26198,1.2357-0.83572,2.0099-1.4344,0.77043-0.59704,1.567-1.2168,2.1011-1.5437l-0.21183-0.35454c-0.57144,0.34804-1.3654,0.97105-2.1363,1.5681-0.76722,0.59544-1.5222,1.1692-1.9501,1.3965l0.18727,0.36806z'/%3E %3Cpath d='m386.46,187.4c0.97908-0.69066,3.3747-2.4071,4.2727-2.9765l-0.21609-0.35074c-0.92089,0.58348-3.3091,2.2966-4.2892,2.9879l0.23263,0.3394z'/%3E %3Cpath d='m384.63,185.39c0.64615-0.55044,1.5612-1.1637,2.4047-1.7045,0.84673-0.54072,1.6161-1.0106,2.0013-1.2963l-0.24062-0.33451c-0.35374,0.2636-1.1317,0.73884-1.9795,1.2796-0.84832,0.54559-1.7714,1.1637-2.4469,1.7375l0.2609,0.31827z'/%3E %3Cpath d='m383.19,184.15c0-0.002,0.96358-0.70204,2.0141-1.4458,0.52502-0.37077,1.0719-0.75183,1.5281-1.0587,0.45405-0.30636,0.82968-0.54398,0.96946-0.60842l-0.16968-0.37565c-0.19902,0.0936-0.56236,0.32639-1.0254,0.63819-1.3798,0.92832-3.5545,2.5132-3.5561,2.5148l0.23957,0.33558z'/%3E %3Cpath fill='%2378732e' d='m386.48,180.09s0.0886,0.0709,0.24864,0.1992c0.55915,0.45684,1.9661,1.6688,3.2269,3.2498,1.2618,1.5811,2.3663,3.5297,2.362,5.4329,0,0.18296-0.009,0.36591-0.0299,0.54564-0.28278,2.478-1.5254,4.6577-3.2488,6.6746-2.5851,3.0236-6.245,5.6589-9.2703,8.33-1.5147,1.3337-2.8694,2.6794-3.8554,4.1023-0.98174,1.4225-1.5958,2.93-1.5958,4.557,0,0.0742,0.003,0.14832,0.005,0.22085,0.0512,1.4972,0.53623,3.1345,1.47,4.4547,0.93371,1.3202,2.3284,2.328,4.1665,2.511,0.30358,0.0314,0.6136,0.0433,0.92355,0.0433,2.3626-0.002,4.9359-0.75563,7.3912-0.75184,2.0665,0.003,4.0256,0.51259,5.7706,2.4206,1.6657,1.8203,2.1785,4.7503,2.1753,7.5696,0,2.0195-0.25771,3.9768-0.51541,5.4313-0.12805,0.72693-0.25717,1.3256-0.35375,1.7424-0.096,0.41624-0.16006,0.64951-0.16006,0.64951l0.39323,0.11258c0.003-0.0114,1.0442-3.8306,1.0442-7.9361-0.003-2.8672-0.50367-5.8913-2.2863-7.8517-1.8226-2.0033-3.9414-2.5592-6.0687-2.5522-2.5322,0-5.1114,0.75349-7.3912,0.75023-0.29932,0-0.5949-0.013-0.88301-0.0412-1.7089-0.17321-2.9932-1.0934-3.8746-2.3362-0.88087-1.2449-1.3456-2.8147-1.3947-4.2328-0.00036-0.066-0.002-0.13369-0.002-0.20408,0-2.0282,1.0132-3.8782,2.5904-5.6787,2.3679-2.7026,5.9768-5.258,9.1132-8.0906,3.1351-2.8325,5.8149-5.9576,6.2621-9.8468,0.0224-0.19756,0.0336-0.39567,0.0336-0.59324-0.005-2.3611-1.5195-4.6496-3.0119-6.3626-1.4934-1.7099-2.9831-2.8439-2.9895-2.8477l-0.24437,0.32856z'/%3E %3Cpath fill='%23a8ac71' d='m383.38,184.11,0,0-0.49086-0.42218-0.42151,0.15155,0.79499,0.64951z'/%3E %3Cpath fill='%23a8ac71' d='m384.7,185.36,0,0-0.36815-0.37888-0.19208,0.10826,0.30412,0.40053z'/%3E %3Cpath fill='%2378732e' d='m386.54,187.39,0,0-0.31479-0.40054-0.19208,0.24898,0.32013,0.36806z'/%3E %3Cpath fill='%2378732e' d='m387.92,189.45,0,0-0.22943-0.41135-0.36815,0.0649,0.4802,0.51961z'/%3E %3Cpath fill='%2378732e' d='m388.7,191.39,0,0-0.18141-0.56291-0.0534,0.0974-0.032,0.42759z'/%3E %3Cpath fill='%2378732e' d='m388.79,193.34,0,0,0.0213-0.53584-0.24543-0.15155,0.032,0.73611z'/%3E %3Cpath fill='%2378732e' d='m388.71,194.59,0,0,0.0534-0.60621-0.16006-0.10825,0.0107,0.79024z'/%3E %3Cpath fill='%2378732e' d='m372.77,213.96s0.0422-0.49798,0.18301-0.92992c0.13552-0.43356-0.39482,0.20406-0.39482,0.20406l-0.0651,0.59705,0.2769,0.12881z'/%3E %3Cpath fill='%23fff' d='m372.64,215.2-0.23476,0.10718,0.0854,0.58239,0.12859-0.18295c-0.00037-0.00054,0.0208-0.32693,0.0208-0.50664z'/%3E %3Cpath fill='%2378732e' d='m372.68,217.51,0,0-0.032-0.56832-0.17074-0.065,0,0.92555z'/%3E %3Cpath fill='%23fff' d='m372.83,218.8,0,0-0.0534-0.5142-0.18141,0.0271-0.0107,0.48714z'/%3E %3Cpath fill='%23fff' d='m373.18,220.66,0,0-0.10671-0.49796-0.11738,0.11907,0.096,0.49796z'/%3E %3Cpath fill='%23fff' d='m373.67,222.57,0,0-0.20275-0.67116-0.14939,0.0649,0.20275,0.6441z'/%3E %3Cpath fill='%23a8ac71' d='m374.91,225.13,0,0-0.27744-0.41676-0.26144-0.0433,0.33613,0.50879z'/%3E %3Cpath fill='%23a8ac71' d='m376.8,227s-0.25611-0.15155-0.62905-0.45467c-0.37135-0.30204-0.14832,0.28201-0.14832,0.28201l0.53247,0.28201,0.24491-0.10935z'/%3E %3Cpath fill='%23a8ac71' d='m389.63,227.96s-0.29878-0.20406-0.51167-0.30149c-0.21289-0.0974,0.11631,0.02,0.29826,0.4433,0.18034,0.42221,0.21341-0.14181,0.21341-0.14181z'/%3E %3Cpath fill='%23fff' d='m390.73,228.85s-0.24543-0.31178-0.40709-0.42005c-0.159-0.10555-0.10405,0.32316-0.10405,0.32316l0.3292,0.14181,0.18194-0.0449z'/%3E %3Cpath fill='%23a8ac71' d='m390.95,229.36c-0.13711-0.18296-0.28544,0.27064-0.28544,0.27064l0.39323,0.36807s0.0315-0.45197-0.10779-0.63871z'/%3E %3Cpath fill='%23a8ac71' d='m391.01,231.13s0.0859-0.37782,0.064-0.61708c-0.0213-0.23708-0.21183,0.0844-0.21183,0.0844l0.0203,0.53262h0.12752z'/%3E %3Cpath fill='%23fff' d='m390.39,233,0,0,0.14939-0.46548-0.19208,0.005-0.11738,0.48172z'/%3E %3Cpath fill='%23fff' d='m370.86,164.65s0.73468-0.15156,0.17927,0.68093c-0.55328,0.83139,0.37242-0.74478,0.37242-0.74478l-0.29773-0.0877-0.25396,0.15155z'/%3E %3C/g%3E %3Cg id='eagle2'%3E %3Cpath fill='%23f9c83a' d='m386.69,179.57,0.4471,0.45521s-0.41723-0.10879-0.59596-0.13044c-0.18088-0.0232,0.14886-0.32477,0.14886-0.32477z'/%3E %3Cpath fill='%238f4620' d='m387.13,180.03s-0.62904,0.0855-0.851,0.11854c-0.22515,0.0314,0.25505-0.24899,0.25505-0.24899l0.59597,0.13045z'/%3E %3Cpath fill='%23977c2e' d='m394.97,237.46s0.53463-0.0563,0.77363-0.38431c0.23743-0.32639-0.15206,0.51314-0.15206,0.51314l-0.34201,0.12828-0.27958-0.25711z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-225 -114 450 300'%3E %3Ctitle%3EFlag of Malawi%3C/title%3E %3Crect x='-225' y='-114' width='450' height='300'/%3E %3Cg fill='%23CE1126'%3E %3Ccircle r='64.5'/%3E %3Crect x='-225' y='-14' width='450' height='100'/%3E %3Cg id='r16'%3E %3Cg id='r8'%3E %3Cg id='r4'%3E %3Cg id='r2'%3E %3Cpath id='r' d='M0-102c-2.2,0-3,3.3-3,6.5 0,8 1,12 3,23.5 2.04-11.5 3-15.6 3-23.5 0-3.3-1-6.5-3-6.5'/%3E %3Cuse transform='rotate(5)' xlink:href='%23r'/%3E%3C/g%3E %3Cuse transform='rotate(10)' xlink:href='%23r2'/%3E%3C/g%3E %3Cuse transform='rotate(20)' xlink:href='%23r4'/%3E%3C/g%3E %3Cuse transform='rotate(40)' xlink:href='%23r8'/%3E%3C/g%3E %3Cuse transform='rotate(-80)' xlink:href='%23r16'/%3E%3C/g%3E %3Crect x='-225' y='-21.5' width='450' height='7.5'/%3E %3Crect x='-225' y='86' width='450' height='100' fill='%23339E35'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='720' height='480'%3E %3Crect fill='%23D21034' width='720' height='480'/%3E %3Cg fill='%23007E3A'%3E %3Crect width='480' height='240' x='120' y='120'/%3E %3Ccircle fill='%23FFF' cx='390' cy='240' r='80'/%3E %3Ccircle cx='420' cy='240' r='80'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 6 4'%3E %3Crect fill='%2300A551' width='6' height='4'/%3E %3Crect fill='%23FFD500' width='6' height='3'/%3E %3Crect fill='%231A206D' width='6' height='2'/%3E %3Crect fill='%23EA2839' width='6' height='1'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23cf142b'/%3E %3Crect width='450' height='600' fill='%23fff'/%3E %3Cg%3E %3Cpath fill='%23e60d2e' d='m22.222,82.828,0,45.457,45.455,0c0,7.5741,7.5762,15.151,15.152,15.151v45.454h45.452v-45.454c7.5762,0,15.152-7.5766,15.152-15.151h45.455v-45.457h-45.455c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-45.452v45.454c-7.5762,0-15.152,7.5766-15.152,15.151h-45.455z'/%3E %3Cpath fill='%2396877d' d='m25.254,85.857,0,39.397,45.452,0c0,7.5738,7.5762,15.15,15.152,15.15v45.454h39.392v-45.454c7.5762,0,15.152-7.5766,15.152-15.15h45.452v-39.397h-45.452c0-7.5741-7.5762-15.151-15.152-15.151v-45.454h-39.392v45.454c-7.5762,0-15.152,7.5766-15.152,15.151h-45.452z'/%3E %3Cpath fill='%23ccc' d='m26.77,87.373,0,36.364,45.452,0c0,7.5741,7.5762,15.153,15.152,15.153v45.454h36.362v-45.454c7.5762,0,15.152-7.5791,15.152-15.153h45.452v-36.364h-45.452c0-7.5738-7.5762-15.15-15.152-15.15v-45.454h-36.362v45.454c-7.5762,0-15.152,7.5766-15.152,15.15h-45.452z'/%3E %3Cg id='vi' fill='%23d0d0d0'%3E %3Cpath fill='%2396877d' d='m84.536,71.681c2.6626,2.6628,1.9431,7.6994-1.6071,11.25-3.5502,3.5503-8.5867,4.2698-11.249,1.6072-2.6626-2.6626-1.9431-7.6994,1.6071-11.25,3.5502-3.5501,8.5867-4.2698,11.249-1.6072z'/%3E %3Cpath d='m71.143,79.715,1.0712-1.0722,4.2856,2.1422-2.143-4.2853,1.0714-1.0722,4.2855,8.5711-8.5708-4.2856z'/%3E %3Cpath d='m77.572,73.287,1.0714-1.0714,6.4282,6.4283-1.0714,1.0714z'/%3E %3C/g%3E %3Cuse xlink:href='%23vi' transform='rotate(90,105.555,105.557)'/%3E %3Cuse xlink:href='%23vi' transform='rotate(180,105.555,105.557)'/%3E %3Cuse xlink:href='%23vi' transform='rotate(270,105.555,105.557)'/%3E %3Cg fill='none' stroke='%2396877d' stroke-width='0.514'%3E %3Ccircle cx='105.555' cy='105.557' r='31.822'/%3E %3Ccircle cx='105.555' cy='105.557' r='24.245'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Ccircle cx='93.434' cy='131.31' r='1.515'/%3E %3Ccircle cx='117.675' cy='131.31' r='1.515'/%3E %3Cpath d='m104.55,131.31,0,1.5798-2.0203,0c-2.0203,0-2.0203,1.5798,0,1.5798h2.0203v1.5798c0.007,1.637,1.7632,1.8358,1.8917,0.13718l0.12826-1.7078h2.0203c2.02,0,2.02-1.5798,0-1.5798h-2.0203v-1.5798c0-1.5798-2.02-1.5798-2.02,0z'/%3E %3Cpath d='m75.954,113.4,2.0836-0.49669-0.23018-0.96558c-0.05274-0.22154-0.14029-0.37212-0.26261-0.45176-0.12227-0.0796-0.33208-0.10192-0.62945-0.0669l-0.03456-0.14462,1.7943-0.42772,0.03456,0.14462c-0.20528,0.0516-0.35004,0.11445-0.43437,0.18823-0.08431,0.0738-0.13986,0.16141-0.16664,0.26283-0.02678,0.10141-0.01904,0.24072,0.02319,0.41794l0.23018,0.96558,1.6653-0.39698c0.26844-0.064,0.44162-0.12317,0.51955-0.17754,0.05893-0.0416,0.10192-0.10968,0.12895-0.20426,0.03521-0.12958,0.0379-0.25691,0.0081-0.38202l-0.04572-0.19152,0.14462-0.0346,0.54235,2.2752-0.14462,0.0346-0.04465-0.18767c-0.05228-0.21889-0.15392-0.36268-0.30524-0.43127-0.0983-0.0427-0.30644-0.0261-0.62439,0.0497l-3.4245,0.81632c-0.26844,0.064-0.44161,0.12317-0.51955,0.17753-0.05893,0.0416-0.10222,0.10838-0.1299,0.20035-0.03582,0.12697-0.03853,0.25431-0.0081,0.38201l0.04465,0.18768-0.14462,0.0346-0.94026-3.9444,1.1528-0.32851,0.03261,0.13683c-0.23143,0.12678-0.39442,0.24896-0.48896,0.3665-0.09453,0.11756-0.15218,0.24837-0.17294,0.39239-0.02075,0.14403,0.0018,0.35418,0.06766,0.63043l0.27863,1.1689zm-1.3422-9.402c0.03979-0.70618,0.34243-1.303,0.90792-1.7904,0.56549-0.48738,1.2495-0.70846,2.052-0.66326,0.82656,0.0466,1.498,0.34604,2.0143,0.89839,0.5163,0.55236,0.75358,1.199,0.71183,1.94-0.0422,0.74898-0.34381,1.3633-0.90484,1.8428-0.56102,0.47958-1.2642,0.69556-2.1095,0.64794-0.864-0.0487-1.5523-0.38264-2.0648-1.0019-0.44467-0.53759-0.64696-1.1622-0.6069-1.8737zm0.28861,0.0927c-0.02742,0.48684,0.13113,0.88756,0.47566,1.2021,0.42874,0.39179,1.0765,0.6121,1.9431,0.66093,0.88808,0.05,1.5822-0.10137,2.0824-0.45424,0.38022-0.27106,0.58382-0.64601,0.6108-1.1248,0.02878-0.51091-0.14672-0.94411-0.52652-1.2996-0.3798-0.35548-0.99903-0.55741-1.8577-0.6058-0.93088-0.0524-1.6353,0.0917-2.1134,0.43237-0.38036,0.27376-0.58517,0.67009-0.61441,1.189zm7.894-9.9511-0.5176,1.3596-3.0375,0.8174c-0.04359,0.12962-0.08066,0.23448-0.11117,0.3146-0.0124,0.03256-0.02636,0.06738-0.04191,0.10444-0.01555,0.03709-0.03221,0.07518-0.04997,0.11428l1.4798,0.56335c0.3205,0.12201,0.5329,0.16274,0.63721,0.12218,0.14641-0.05317,0.25581-0.17496,0.32826-0.36525l0.07577-0.19905,0.13896,0.0529-0.83073,2.1821-0.13896-0.0529,0.07293-0.19155c0.08198-0.21532,0.07048-0.39601-0.03445-0.54204-0.05761-0.08213-0.23164-0.17848-0.52208-0.28906l-3.2901-1.2525c-0.32049-0.12201-0.5329-0.16274-0.63721-0.12218-0.14736,0.05566-0.25771,0.17998-0.33112,0.37276l-0.07293,0.19155-0.13896-0.0529,0.70634-1.8554c0.2059-0.54083,0.39713-0.92456,0.57371-1.1512,0.17658-0.22662,0.40474-0.38916,0.68447-0.48765s0.56608-0.09195,0.85903,0.01957c0.31299,0.11916,0.54581,0.32462,0.69848,0.61637,0.15267,0.29177,0.19508,0.66984,0.12722,1.1342l1.8614-0.49542c0.42703-0.11264,0.72853-0.23431,0.90446-0.36521,0.17594-0.13082,0.33184-0.32948,0.46769-0.59598l0.13896,0.0529zm-3.9947,2.6203c0.01811-0.04758,0.03447-0.08865,0.04906-0.12322,0.01461-0.03458,0.02618-0.06313,0.03477-0.08567,0.18493-0.48575,0.21917-0.89198,0.10274-1.2187-0.1164-0.32671-0.3374-0.55201-0.66291-0.67593-0.31799-0.12105-0.6144-0.11994-0.88925,0.0033-0.27484,0.12328-0.47469,0.34893-0.59956,0.67693-0.05529,0.14523-0.10632,0.35084-0.15312,0.61683l2.1183,0.80642zm11.596-18.053,1.0531,1.3672-0.11806,0.07646c-0.35222-0.2826-0.68176-0.4538-0.98862-0.51362-0.4425-0.08686-0.87738,0.0081-1.3046,0.28477-0.58242,0.37723-0.87613,0.89464-0.88114,1.5522-0.0021,0.55362,0.17083,1.0991,0.51894,1.6366,0.28254,0.43626,0.62467,0.77966,1.0264,1.0302,0.40168,0.25056,0.79339,0.37113,1.1751,0.3617,0.38172-0.0094,0.71651-0.10735,1.0043-0.29378,0.16864-0.10923,0.31785-0.23619,0.44759-0.38087,0.12973-0.14467,0.24074-0.30595,0.33302-0.48382l-0.85639-1.3223c-0.14856-0.22936-0.26321-0.36818-0.34394-0.41644-0.08075-0.04825-0.16966-0.06726-0.26677-0.05704-0.09711,0.01023-0.23785,0.07513-0.42227,0.19448l-0.08302-0.12817,1.7709-1.147,0.08302,0.12817-0.08432,0.05462c-0.1754,0.1136-0.25784,0.25-0.24732,0.40916,0.0089,0.11233,0.09274,0.29106,0.2515,0.53617l0.90664,1.3998c-0.16831,0.30692-0.35727,0.57454-0.56689,0.80287-0.20962,0.22834-0.46847,0.44227-0.77654,0.6418-0.88375,0.57238-1.7385,0.7238-2.5643,0.45423-0.61932-0.20217-1.1089-0.58098-1.4686-1.1364-0.26069-0.40252-0.41379-0.8508-0.45924-1.3449-0.05463-0.58706,0.04172-1.1283,0.28906-1.6236,0.20835-0.41264,0.54077-0.7668,0.99726-1.0625,0.1664-0.10776,0.32637-0.19222,0.4799-0.25335,0.15351-0.0612,0.38497-0.12637,0.69427-0.1959,0.15647-0.03441,0.25611-0.0654,0.29888-0.09297,0.04269-0.02776,0.06653-0.071,0.07138-0.13003,0.0049-0.059-0.02647-0.14805-0.09404-0.26709l0.1248-0.08083zm8.8735,0.61442-2.039,0.5422-0.1363,0.92615c-0.03364,0.22797-0.03703,0.39242-0.01019,0.4934,0.02126,0.08029,0.07829,0.14067,0.17086,0.1812s0.26812,0.03612,0.52668-0.01322l0.03817,0.14372-1.6584,0.44098-0.03817-0.14372c0.20976-0.09736,0.33873-0.18572,0.38694-0.26507,0.099-0.1594,0.17816-0.45074,0.23748-0.87404l0.70002-4.827,0.13591-0.0362,2.9981,3.8935c0.24122,0.31289,0.43597,0.50576,0.58426,0.5786,0.14827,0.07285,0.33159,0.08718,0.54994,0.04297l0.0382,0.14372-2.0778,0.55252-0.03817-0.14372c0.20698-0.06609,0.33943-0.13878,0.39738-0.21796,0.058-0.07918,0.0756-0.16149,0.0529-0.24693-0.0303-0.11391-0.12993-0.2801-0.2989-0.49854l-0.51986-0.67266zm-0.18516-0.25849-1.4592-1.8908-0.35063,2.3721,1.8099-0.48127zm9.6209-0.02828,0.13143,0.03327-0.52332,1.4597-4.2165-0.16404,0.006-0.14858,0.20481,0.008c0.23023,0.009,0.39779-0.0596,0.50268-0.20567,0.0596-0.08349,0.0954-0.28049,0.10745-0.59105l0.1367-3.5138c0.0132-0.34-0.016-0.55428-0.0876-0.64287-0.0998-0.12186-0.25281-0.18679-0.45895-0.19481l-0.20481-0.008,0.006-0.14858,2.4657,0.09592-0.006,0.14858c-0.28903-0.01392-0.49287,0.005-0.61151,0.05664-0.11865,0.05169-0.20105,0.11954-0.24721,0.20354-0.0462,0.08402-0.0756,0.28798-0.0882,0.61191l-0.1331,3.4214c-0.009,0.2222,0.007,0.37563,0.0465,0.46029,0.0299,0.05749,0.0778,0.10089,0.14374,0.13026,0.0659,0.02938,0.27418,0.05088,0.62489,0.06453l0.39756,0.01547c0.41764,0.01626,0.71198-0.0031,0.88304-0.05815,0.17109-0.05493,0.32924-0.15811,0.47454-0.30932,0.1453-0.15119,0.29412-0.39275,0.44646-0.72466zm7.2573,1.942,0.11707,0.06835-0.90692,1.2578-4.0064-1.3248,0.0467-0.14118,0.1946,0.06436c0.21875,0.07234,0.39874,0.05284,0.53997-0.05847,0.0803-0.06374,0.16929-0.24314,0.26686-0.53821l1.104-3.3386c0.10682-0.32305,0.13808-0.53705,0.0938-0.642-0.0622-0.14473-0.19123-0.24947-0.38709-0.31424l-0.1946-0.06436,0.0467-0.14118,2.3428,0.7747-0.0467,0.14118c-0.27388-0.09339-0.47498-0.13166-0.60329-0.11484-0.12831,0.01684-0.22625,0.05931-0.2939,0.12715-0.0676,0.06794-0.15231,0.25582-0.25409,0.56359l-1.075,3.2509c-0.0698,0.21112-0.0974,0.36285-0.0828,0.45516,0.0128,0.06352,0.0469,0.11852,0.10206,0.16497,0.0552,0.04647,0.24939,0.12479,0.58261,0.23499l0.37774,0.12491c0.39682,0.13122,0.68503,0.19407,0.86463,0.18856,0.17959-0.0055,0.36014-0.06081,0.54163-0.16584,0.18148-0.10507,0.39135-0.29599,0.62961-0.57275zm5.8487,3.0973-1.7221-1.2189-0.79864,0.48837c-0.19664,0.12013-0.32513,0.22285-0.38549,0.30813-0.048,0.06779-0.0579,0.15021-0.0298,0.24726,0.0282,0.09704,0.14395,0.22907,0.34742,0.39607l-0.0859,0.12138-1.4007-0.99138,0.0859-0.12137c0.2091,0.09875,0.35956,0.14125,0.45138,0.12746,0.18582-0.02604,0.46028-0.15182,0.82341-0.37729l4.1557-2.5533,0.11481,0.08126-1.0706,4.796c-0.0858,0.38563-0.10928,0.65872-0.0703,0.81927,0.039,0.16053,0.14539,0.31051,0.31915,0.44992l-0.0859,0.12138-1.7549-1.2421,0.0859-0.12138c0.18331,0.11663,0.32394,0.17185,0.42187,0.16566,0.0979-0.0062,0.17241-0.04539,0.22351-0.11752,0.0681-0.09623,0.13193-0.27916,0.19151-0.54882l0.18376-0.83003zm0.08-0.30775,0.51785-2.3316-2.0464,1.2496,1.5286,1.0819zm6.4627,1.191,0.88066,1.1881-1.2996,5.1103,2.5247-1.8714c0.26904-0.19942,0.41459-0.35399,0.43665-0.46372,0.0314-0.14663-0.0168-0.30606-0.14439-0.47825l-0.11246-0.15174,0.11946-0.08854,1.1295,1.5239-0.11946,0.08854-0.11487-0.15497c-0.13721-0.18511-0.29049-0.27492-0.45985-0.26945-0.10398,0.0037-0.27868,0.0964-0.52401,0.27837l-3.6903,2.7353-0.0862-0.11622,1.3862-5.4996-2.6959,1.9982c-0.26905,0.19942-0.41539,0.35292-0.43904,0.4605-0.0298,0.14879,0.0183,0.30822,0.14439,0.47825l0.11487,0.15497-0.11946,0.08854-1.1295-1.5239,0.11946-0.08854,0.11247,0.15174c0.13879,0.18726,0.29287,0.27815,0.46223,0.27267,0.10397-0.0037,0.27868-0.0964,0.52402-0.27835l3.0445-2.2567c0.0544-0.23707,0.0809-0.40598,0.0796-0.50673-0.001-0.10075-0.0286-0.22977-0.0818-0.38707-0.0269-0.07677-0.0874-0.17867-0.18154-0.30565l0.11946-0.08854zm6.871,12.662-1.1847,0.48309-0.0508-0.144c0.20233-0.10285,0.34047-0.19436,0.41442-0.27451,0.11879-0.13013,0.1899-0.27253,0.21334-0.42717,0.0234-0.15465-0.002-0.33806-0.0774-0.55022l-0.2561-0.72361-3.925,1.3887c-0.31574,0.11164-0.50066,0.2155-0.55483,0.3114-0.0721,0.13351-0.0729,0.30003-0.002,0.49957l0.0629,0.17808-0.14018,0.04957-0.77076-2.1785,0.14019-0.04957,0.0644,0.18184c0.0769,0.2172,0.19703,0.34805,0.36054,0.39251,0.10048,0.02697,0.2947-0.01047,0.58263-0.11236l3.925-1.3887-0.2184-0.61758c-0.0849-0.23993-0.16291-0.40418-0.23401-0.4927-0.0944-0.11436-0.22643-0.19414-0.39587-0.23933-0.16946-0.0452-0.3735-0.03554-0.61212,0.029l-0.0508-0.144,1.2262-0.36564,1.4839,4.194zm-4.3136,9.6659-0.0755-1.4528,2.4487-1.9744c-0.0125-0.13618-0.0209-0.24707-0.0254-0.33268-0.002-0.0348-0.003-0.0722-0.004-0.11247-0.00067-0.0402-0.00091-0.0818-0.00045-0.12474l-1.5813,0.0822c-0.34247,0.0178-0.55323,0.0663-0.63228,0.14555-0.11245,0.10779-0.16337,0.26336-0.1528,0.46671l0.0111,0.21271-0.14849,0.008-0.12122-2.3318,0.14849-0.008,0.0106,0.20469c0.012,0.2301,0.0954,0.39075,0.25042,0.48195,0.0859,0.0519,0.28397,0.0697,0.59434,0.0536l3.5157-0.18276c0.34247-0.0178,0.55323-0.0663,0.63229-0.14554,0.11228-0.11047,0.16309-0.26871,0.15238-0.47473l-0.0106-0.20467,0.14849-0.008,0.10307,1.9826c0.03,0.57792,0.01,1.0062-0.06,1.2848-0.07,0.27863-0.21311,0.51947-0.42924,0.72253-0.21615,0.20305-0.48074,0.31272-0.79378,0.32899-0.33444,0.0174-0.63041-0.0765-0.8879-0.28181-0.25749-0.20526-0.44896-0.53401-0.57442-0.98625l-1.5028,1.2049c-0.34518,0.27549-0.57183,0.50861-0.67995,0.69934s-0.17053,0.43543-0.1872,0.73409l-0.14849,0.008zm2.5964-4.0103c0.003,0.0508,0.004,0.095,0.005,0.13254,0.00064,0.0375,0.002,0.0683,0.003,0.0924,0.027,0.51906,0.1597,0.90452,0.39806,1.1564,0.23845,0.25186,0.53158,0.36875,0.87941,0.35067,0.33979-0.0177,0.61052-0.13838,0.81217-0.36215,0.20164-0.22378,0.29336-0.5109,0.27514-0.8614-0.008-0.15519-0.0444-0.3639-0.10902-0.62613l-2.2635,0.11767zm1.4941,11.21-0.48239,1.8386-0.14382-0.0377,0.0265-0.10106c0.0177-0.0674,0.0137-0.17368-0.0119-0.31889s-0.0803-0.28555-0.16376-0.42104c-0.0836-0.1355-0.23063-0.31396-0.4412-0.53539l-1.6684-1.7964-1.3216-0.34676c-0.32394-0.085-0.53559-0.10174-0.63496-0.0503-0.13468,0.0699-0.2299,0.21113-0.28565,0.42363l-0.0449,0.17104-0.14382-0.0377,0.58744-2.239,0.14382,0.0377-0.049,0.1866c-0.0585,0.22285-0.0326,0.39862,0.0777,0.52727,0.068,0.0788,0.24967,0.15691,0.54509,0.23442l1.2478,0.32737,2.5873-0.86676c0.30401-0.10305,0.49641-0.17651,0.57717-0.22043,0.0807-0.044,0.19165-0.14983,0.33267-0.31782,0.0395-0.045,0.0722-0.11677,0.098-0.21525l0.14383,0.0378-0.59152,2.2546-0.14382-0.0377,0.0306-0.11662c0.0319-0.12181,0.0328-0.24136,0.003-0.35868-0.0302-0.11731-0.10225-0.19095-0.21628-0.22086-0.0933-0.0245-0.28248,0.0104-0.56755,0.10454l-1.9874,0.65431,1.3536,1.4603c0.20279,0.21939,0.3638,0.34473,0.48301,0.37601,0.0726,0.019,0.14227,0.0172,0.20915-0.005,0.0669-0.0226,0.12568-0.0647,0.17643-0.12614,0.0508-0.0615,0.0945-0.16218,0.1312-0.30212l0.14382,0.0377z'/%3E %3C/g%3E %3Cg fill='%2396877d' stroke='%23000' stroke-width='0.203'%3E %3Cpath d='m122.85,110.19c0.53163-0.13451,1.4092-0.0256,1.4092-0.0256s0.0769,0.3651-0.15373,0.4868c0.25621,0.14732,1.1786,0.10248,1.1786,0.10248s-0.3587,0.27543-0.53804,0.38431c0.33307,0.032,0.743,0.46118,0.743,0.46118s-0.76862,0.1281-1.1017-0.0512c0.20497,0.40993,0.17935,0.76863,0.17935,0.76863s-1.2426-0.30745-1.691-1.1273'/%3E %3Cpath d='m120.77,109.49c-0.30104,0.74301-2.5108-0.64052-2.5108-0.64052s0.9736,1.5437,2.434,1.7166'/%3E %3Cpath d='m93.181,123.66,25.877,0,1.9984-1.5885-3.3307-1.7935-5.1242-1.7422-2.0497-1.1273-3.7919,0.20497-3.177,1.691-4.3556,0.51242-1.0248,1.1786-3.2282,0.25621-5.0729-0.10248,8.4549,1.3323-6.9689-0.3587,1.7935,1.5373z'/%3E %3Cpath d='m107.12,116.23c-3.241-1.7422-4.189,2.5493-5.5854,3.5869,1.8831,0.32026,3.3051-1.4476,4.9192-2.3059,1.224,3.333,3.1514,1.1273,3.1514,1.1273s2.0112,3.1898,4.6886,1.7422c0.73019,0.55085,1.5372,0.0512,1.5372,0.0512s0.9736,0.17935,1.1786-0.25621c0.51241,0.17935,1.0761-0.46117,1.0761-0.46117s1.1145,0.0128,1.3323-0.56366c1.6526,0.29464,3.8431-3.382,3.8431-3.382l0.66615-1.281,0.97359-0.20497s0.0641-0.64052-0.46118-0.6149c-0.0128-0.38432-0.34588-0.58929-0.81986-0.51242,0.0897-0.23059-0.25621-0.40994-0.25621-0.40994-0.92236,0.23059-0.9736,2.5621-0.9736,2.5621s-1.6141,1.2298-2.2034,1.5372c-0.0256-1.3323-2.2546-3.1386-1.7935-3.9969,0.46117-0.8583,1.9088,1.3195,3.177,0.92235,1.2682-0.39712,1.8914-2.0468,1.9472-3.3307-0.35869-0.87111-1.2298-2.3059-1.2298-2.3059l-0.81987-0.0512-0.71739-1.7422s-1.5116,0.98641-1.486,1.8447c0.0256,0.8583,1.5885,1.5885,1.5885,1.5885s-0.90121,0.56325-1.7422,0.30745c-0.0769,0.87111,1.0248,0.70457,1.4348,0.71738,0.20497,0.62771,0.81987,0.9736,0.81987,0.9736s0.38432,0.96078-0.6149,0.87111c-0.99922-0.0897-2.1781-2.3919-3.5869-1.3323-1.4988,1.1273,0.66614,3.177,0.66614,3.177s-1.3195,0.69176-2.1009,2.4596c-3.1898-2.6902-5.0601-1.4348-8.6086-0.71739z'/%3E %3Cpath d='m102.46,111.67c1.3323,1.2554,0.40316,3.3422,0.92235,3.7407,0.55085,0.42274,1.3323-0.20497,1.3323-0.20497,1.3963,0.37151,3.8944-0.40993,3.8944-0.40993,1.0994,0.61473,0.66541-0.29241,1.3323-0.25621,0.58928,1.5116,2.5621,1.2298,2.5621,1.2298s-1.8063-1.8447-2.9208-2.3571c-0.8583,0.51242-3.3564,0.58928-3.7919,0.51242-0.48533-0.0857-0.17935-0.67896-0.40994-1.0248,0.91849-0.89406,0.19216-3.1129-0.30745-3.9456-2.036-1.3563-4.4684,0.96777-2.6133,2.7158z'/%3E %3Cpath d='m93.599,107.92c-1.6758,0.45291-4.5835-2.165-5.9423-1.1595s-0.72467,3.4784,0.18117,4.7104c0.885,1.2036-1.2953,1.6396-1.8841,2.3552-0.55353,0.67276,0.18117,1.4493,0.18117,1.4493l0.61597,0.39857-0.1087,0.90583,0.3261,1.087s0.29892,0.26269,0.39857-0.0725c0.28081,0.28081,0.02966,1.0928,0.72467,1.1957-0.24887-0.52003,0.18117-1.9566,0.18117-1.9566s1.2138,0.0906,1.5218-0.4348c0.30798-0.52539-0.28987-1.6667-0.28987-1.6667h0.36233c-0.40763-0.28081-0.5435-1.1232-0.5435-1.1232s1.6849-0.53444,1.6667-1.8117c-0.01812-1.2772-2.7356-2.636-1.7392-3.2972,1.1051-0.73373,3.0255,1.9023,4.6741,0.68844,1.6315-1.2012,0.57974-0.0362,0.57974-0.0362s0.74569-1.6783-0.90584-1.2319z'/%3E %3Cpath d='m102.25,89.971c-2.2418-0.93516-6.8216-0.99281-9.3773-2.2546-1.1209,0.07046-1.6205,0.95438-1.6654,1.3067-1.1722-0.05765-1.9664,1.7871-1.7935,2.1522-2.1329-0.86471-3.1258,2.5108-2.434,3.2026-1.8191,0.07686-1.5949,2.402-1.7678,3.0489-0.58288,1.4156,0.1298,1.8919,1.281,1.3835,0.17294,0.6149-0.06911,0.95934-0.58928,1.0761,3.1575,3.6133,4.9421-2.2236,7.7119-2.2034,3.4583-1.0124,4.8167-2.7158,4.8167-2.7158l1.3579,0.17934s2.4596-5.1754,2.4596-5.1754z'/%3E %3Ccircle cx='105.145' cy='87.384' r='3.305'/%3E %3Cpath d='m99.33,113.41c-2.0497-0.37151-5.4444-2.498-5.7903-5.2779,1.9088-7.4941,11.755-3.5807,12.604-9.2173-0.21639-3.7187,0.44951-7.3999,2.5119-10.511,0.96079-1.217,2.2034-1.5373,2.2034-1.5373s0.22257,0.79372-0.10248,1.3323c1.6269-0.17935,3.856,0.7302,5.3804,0.81987,0.44837,0.90954,0.40994,1.2426,0.30745,1.7935-0.10248,0.55085-0.71738,0.40993-0.71738,0.40993-0.39767,0.37723-0.87565,0.76105-1.9472,0.56366-0.80706,0.6149-2.5108,0.76863-2.5108,0.76863s3.5613,3.7535,2.972,4.9192c0.74301,0.34588,1.8447,1.9984,1.8447,1.9984s2.434-1.281,3.2282-2.4596c1.4092,0,3.715,1.4732,4.868,1.6397,1.4092,1.1401,2.8183,2.3059,2.8183,2.3059s-1.6782,1.1017-2.4084-0.3587c-0.88392,0.0769-2.7927-2.0369-5.4316-1.3835-0.0769,2.3443-2.6646,3.9969-2.6646,3.9969s2.4153-0.33802,3.7406,0.46117c1.3707,1.153,3.382,2.7158,3.382,2.7158l1.7935,3.0745s-1.6397,0.28183-2.2546-1.8447c-0.61491,1.7166-0.64052-1.0633-3.0745-2.3571-0.74301,0.0897-1.1145,0.14092-1.7422-0.35869-1.755,0.47399-3.8303,1.4988-6.3028,1.2298-1.755,0.55085-3.0361,2.0112-4.8167,2.8183-1.7807,0.80706-2.3059,0.40993-2.3059,0.40993l-1.4348,0.0512c-0.20699,0.86376-0.0897,2.1778-0.87111,2.4084,0.49961,0.53804-0.35869,2.8311-1.2298,3.2282,0.40993,1.4732,1.6108,1.9242,2.8695,2.6646,0,0,1.1145-0.51241,1.8447,0.15373,0.73019,0.66614,1.486,2.5621,1.486,2.5621s-1.5197,0.10268-1.9984-0.10248c-0.47871-0.20516-0.52523-0.70458-1.0761-0.56366-3.4716-3.0873-5.3024-1.8593-5.6366-2.5621-0.34252-0.72035,0.81987-2.6005,0.46118-3.7919z'/%3E %3Cpath d='m90.99,99.655c0.18117-0.22646,1.4493,0.25363,1.4493,0.25363l2.3189,1.4493,4.7104,3.0436,1.6667,2.4276-3.0074-0.9783-4.1668-3.5871-2.2465-1.4493s-0.90584-0.93301-0.72467-1.1595z'/%3E %3Cpath d='m118.85,107.37c-1.6269-0.40994-5.6366,4.458-5.6366,4.458l3.0233,3.2795s0.0897-5.5854,2.6133-7.7375z'/%3E %3Cpath d='m99.023,93.789c-0.88723,1.1368-0.96662,3.4287,0.18756,4.3531,0.10881,1.3911,1.2915,4.1971,2.2208,4.4605,1.0153,0.28784,5.0729,1.2298,6.6614,0.97359-0.30381,2.5745,1.7164,4.641,3.5869,5.9953-0.0136,0.23103-0.0168,0.51306,0.19928,0.79864,0.20936,0.27664,1.1923,0.32734,1.2355,0.17495,0.43591,0.6126,2.5473,0.88157,2.7003,0.60869,0.14884-0.26552-3.1056-2.5307-3.8276-3.222-0.6133-1.1442-1.7749-3.6938-2.0497-5.7391-1.5973-1.9003-4.3395-1.8623-4.3395-1.8623l0.0864-3.7231,0.15373-4.2018-1.486-0.76863s0.29956-0.13652,0.46117-0.30745c0.36089,0.15517,1.0391-0.56988,1.1273-0.77484,0.34187,0.12113,0.65138,0.11952,0.71117-0.06314,0.0528-0.16132,0.11399-0.87942,0.23863-1.2505,1.1211-0.98705-0.16365-3.08-1.8778-3.1144-1.6961-0.03441-2.0765,2.0232-2.044,2.1796,0.15932,0.64556,0.12499,0.97102,0,1.1273-0.12777,0.15976-0.71739,0.51242-0.71739,0.51242s-0.94797-0.44837-2.1009,0-2.4468,1.0505-2.5108,1.7935c-0.52523,0.07686-1.3835,0.75582-1.5373,1.3323-0.46118-0.08967-1.0633,0.29464-2.0497,1.8959-1.7678,0.78144-1.8703,4.5605-1.8703,4.5605s-0.47719,0.69496-0.49961,1.0633c-0.02242,0.3683,0.16654,0.70458,0.39712,0.64053,0.02562,0.24339,0.34588,0.46117,0.4868,0.38431,0.05124,0.2434,0.40298,0.37952,0.6149,0.34588,0.01922,0.16654,0.70137,0.12491,0.75582-0.0256,0.06008-0.16611-0.0675-0.99692,0.0128-1.0633,0.07366-0.0609,0.64052,0.37151,0.79425,0.25621,0.15373-0.11529-0.02936-0.48449-0.11529-0.62771-0.07686-0.12811-0.56366-0.26902-0.67895-0.87111s0.30745-1.4348,0.30745-1.4348,1.9216-1.5116,2.1393-2.8055c1.4476,0.14092,2.213-1.1241,2.6261-1.6013z'/%3E %3Cpath d='m95.679,88.37c0.43876-1.0729,2.0241-0.97359,2.0241-0.97359s0.56686-1.4924,2.703-0.60209c0.80386-0.62131,2.9208,0.26902,2.9208,0.26902s0.7927-1.0562,1.8319-0.93516c1.9248,0.22418,2.245,1.9888,2.1265,2.2931-1.0537,0.26582-2.879-0.85629-4.2659-0.53804-0.81026,0.45797-2.1233,0.94157-2.6133,1.6013-1.2842,0.13451-2.655-1.1818-4.7271-1.1145z'/%3E %3Cpath d='m99.689,90.151c0.4804-0.29464,1.6588-0.81262,2.4596-0.17935,0.83908,0.90314,2.1265,1.7422,2.1265,1.7422l1.4604,0.6149,0.66614,0.40994-0.43556,6.6871c-1.3518-1.3831-2.6186-1.6253-3.5869-3.2539-0.51883-0.69817-0.1217-2.3763-1.0248-3.4844-0.90314-1.1081-1.8639-1.8575-1.6654-2.5365z'/%3E %3Cpath d='m103.2,92.082s0.76544-0.14493,0.97831,0.03623c0.26722,0.09058,0.52538,0.16758,0.59785,0.39857,0.28987,0.08605,0.48915,0.23552,0.48915,0.45292,0.27175,0.07247,0.38045,0.56162,0.38045,0.56162l-0.25363,0.38045s-0.28987-0.27175-0.3261-0.56162c-0.1834-0.09031-0.5888-0.1857-0.68844-0.45292-0.31704-0.0317-0.52085-0.19476-0.57973-0.47104-0.2944,0.06794-0.59786-0.34422-0.59786-0.34422z'/%3E %3Cpath d='m109.68,87.717c-0.43556-0.4868-1.2042-0.1281-1.2042-0.1281l-2.0497,3.5357-0.89673,0.74301-0.0769,2.7671,0.743,2.5877-0.25621,1.9984s1.0322-0.96837,1.153-1.5116c0.11529-0.51882-0.38432-2.2034-0.38432-2.2034s-0.6149-1.0505,0.12811-2.9976c0.743-1.9472,2.434-3.5613,2.8439-4.7911z'/%3E %3Cpath d='m114.74,90.868s-3.2003,4.5733-8.4398,6.2003c-1.4476,0.34588-0.92236-3.382-0.92236-3.382l-0.35869,0.10248s-0.80706,3.651,1.1273,3.6894c5.2651-1.0376,9.2156-6.5806,9.2156-6.5806l-0.63-0.028z'/%3E %3Cpath d='m116.91,117.16s-0.4868,0.3587-1.1273,0c-0.33307-0.76862-1.2298-0.81987-1.2298-0.81987s-0.57758-1.6593-1.486-1.1786c-0.14091-0.8583-1.1273-0.40993-1.1273-0.40993s-0.0256-1.2426-1.1786-1.0761c0.38431-1.422-1.5885-1.3323-1.5885-1.3323s-0.064-1.6013-2.972-1.281c6.2643-2.8055,11.222,4.4068,11.222,4.4068'/%3E %3Cpath d='m119.88,117.77s1.4476,1.6269,2.2034,1.6397c0.75582,0.0128,0.81987-1.5885,0.81987-1.5885s0.2434,0.69176,0.6149,0.51242c-0.0384,0.48679,0.46118,0.6149,0.46118,0.6149s-1.3067,3.0361-5.0217,0.15372'/%3E %3Cpath d='m108.55,118.39-0.51242,2.1009s-0.65333,0.58928-0.46118,0.71739c0.19216,0.1281,1.2298-0.20497,1.2298-0.20497s1.6141-0.19215,2.1009-0.66614c0.33308,0.75582,1.0761,0.81987,1.0761,0.81987s0.0512-0.32026-0.0512-0.51242c0.35869,0.0641,0.66615-0.0512,0.66615-0.0512s0.20496-0.58929-0.25621-0.81987c0.0512-0.43556,0.26901-0.81987-0.51242-0.76863-0.57647,0.6149-1.9984,1.3195-2.3571,1.0761-0.35869-0.2434,1.4092-1.0248,0.92236-2.0497'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m769.466,147.526,256.879,0-0.306,182.787c2.1373,73.4798-43.6616,119.076-127.931,139.634-59.834-14.86-128.837-45.596-128.939-137.549l0.30537-184.872z'/%3E %3Cpath fill='%2300a2bd' stroke='%23000' stroke-width='1.8125' d='m775.152,153.036,245.493,0-0.2914,175.155c2.0416,70.4101-41.7273,114.102-122.261,133.802-57.188-14.237-123.132-43.692-123.229-131.805l0.29189-177.152z'/%3E %3Cpath fill='%23a53d08' d='m1018.74,348.938c-8.9307,67.2099-60.6921,96.5757-120.655,112.162-53.073-14.238-110.174-36.968-121.243-111.824l241.901-0.33785z'/%3E %3Cpath fill='%23000' d='m888.365,185.664-0.34221-22.0753,17.4554,0.17111,0.17111,21.9042,47.7434,0,0.17109,17.1126-47.9145,0.17111-0.38281,201.815-17.0262,0.10728-0.2175-202.093-47.5824,0.17125,0.0101-17.4548z'/%3E %3Cg fill='%23ff9a08' stroke='%23000' stroke-width='0.9676'%3E %3Cpath d='m849.714,357.267,43.703,45.3378c15.1121-16.61,4.62991-78.6955-15.247-90.1304-2.3824,7.35162-6.43375,16.1663-10.7403,19.0083-9.47444,6.45695-32.6922,14.0058-24.9316,18.8401,1.76989-2.45053,6.39893-4.76476,8.5773,0.68151,2.58684,8.57687-9.66655,9.12208-9.66655,9.12208s-7.76038-0.95411-9.12194-8.85092c-1.36144-7.89537,11.5591-15.1049,12.6619-15.6559,1.08911-0.40891,17.9714-4.90107,20.8308-19.8783,3.53951-14.7047,7.21531-12.5253,7.89681-12.7979,22.0548,2.17794,36.4869,41.662,37.3047,69.4357,0.81634,27.7737-11.3,46.1542-13.4794,47.3794-2.17793,1.22527-52.553-59.7684-52.553-59.7684l4.76521-2.72313z' fill-rule='evenodd'/%3E %3Cpath d='m881.573,315.061,0.27116,81.8247'/%3E %3Cpath d='m876.672,316.558c0,0.13629,0.27116,74.3382,0.27116,74.3382'/%3E %3Cpath d='m871.362,327.314,0.27115,59.0884'/%3E %3Cpath d='m867.005,331.534,0.27261,48.8788'/%3E %3Cpath d='m862.376,333.713v41.2531'/%3E %3Cpath d='m857.338,336.981v32.6748'/%3E %3Cpath d='m852.982,339.568v25.0506'/%3E %3Cg fill='none' stroke='%23ffdf00' stroke-width='1.8125' stroke-linecap='round'%3E %3Cpath stroke-width='0.9676' d='m849.033,362.441,45.0653,51.6004'/%3E %3Cpath d='m896.276,329.901s20.4236,44.6578,1.49788,81.4172'/%3E %3Cpath d='m843.723,353.046s1.49772-3.94841,3.40377-2.31424'/%3E %3Cpath d='m840.184,341.61s-8.16898,7.2153-3.67594,11.8452'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.3987'%3E %3Cpath fill='%23008021' d='m905.779,228.044c3.02538-2.59499,4.59503-4.18109,6.46848-3.89248,1.87346,0.28798,4.42414,0.14367,6.2976-0.43292,1.87978-0.57723,11.1774-1.73042,15.0003-0.43292,1.2975,0.14431,3.02538,0.86584,5.68999,3.10069,2.67094,2.23422,6.56342,6.12797,5.26592,16.9415-1.29749,10.8135-0.87343,15.4389-1.44306,21.4833-1.00635,10.6698-3.37349,19.4554-7.63939,18.744,5.76593,10.0932,6.34189,18.744,10.0888,25.6651,3.75324,6.92102,6.05708,21.051,4.61402,36.3349-1.43674,15.2838-5.47479,49.5991,6.63304,72.6692-2.01903,1.4418-6.91786,0-11.2471-4.61402-4.32287-4.61401-6.22164-4.46275-9.80399-1.73041-10.9559,8.36282-21.2156,18.4421-36.3298,8.36282-3.46209-2.30701-4.55705-5.07415-2.01902-12.1116,6.34189-17.5902,9.42423-41.7249,8.42421-53.0599v-127.027z'/%3E %3Cg fill='%23ffe1cf'%3E %3Cpath d='m916.171,217.23c0.79116,2.45131,1.22155,5.62289-0.076,8.50649-1.29749,2.8836-1.58231,6.34443,0.57596,10.5255,3.4621-4.902,8.36726-3.89249,11.2471-6.77609,2.88613-2.88423,3.46209-5.62352,5.62669-6.20075-2.1646-1.87409-5.48112-3.89248-4.75959-9.3717,0.72154-5.47923,8.36093-9.9483,1.44307-18.3118-4.46844-5.39821-10.9622-3.89248-13.7724-1.80193-1.32281,0.9823-2.44942,2.37853-2.87981,3.31589-0.43671,0.93736,0.1076,3.07031-0.94305,4.32603-0.71521,0.86457-1.58864,1.72472-2.59499,2.45068-0.64558,0.469-1.05065,1.15192-0.36077,1.94688,0.27849,0.31772,0.78483,0.38545,1.3418,0.57849-0.32279,0.64875-0.68988,1.29559-1.05065,1.76459-0.34178,0.43988-0.19621,0.85951,0.21519,1.21775-0.54431,1.72978,0.50634,1.91775-0.21519,3.21588-0.6266,1.12218-1.47471,2.45005,0.8671,3.74881,0.64559,0.36013,3.71527,1.07217,5.33555,0.86521z'/%3E %3Cpath d='m888.126,245.923c-4.03806,1.00952-10.5255-0.72026-15.4307-0.1443-2.1646,0.2557-3.89248-0.86458-3.60133-3.02728,0.28481-2.16333,0.57596-5.47922,0.13924-8.50713-0.6709-4.71845,1.58864-11.2464,4.75959-18.4561,3.17095-7.209,4.75958-11.2458,4.75958-14.6345,0-2.23486,0.2152-4.75832,2.23423-6.05582,1.4937-0.95888,1.77851-1.88991,2.31017-2.66714,1.22154-1.80257,2.37346-2.23485,2.51903-1.15319,0.0886,0.64305-0.14557,1.22534-0.72153,2.09055,1.2975-1.08167,3.50007-2.34372,4.00008-2.70385,0.50634-0.36013,3.06968-2.1627,3.20892-0.46836,1.01268-0.50444,1.69624-0.469,1.94941,0.0715,0.27216,0.58482,0.1076,0.82976-0.39874,1.26205,0.72153-0.14431,1.55066,1.11774,0.10759,2.23485,0.75951-0.25254,1.51269,1.00952,0.18355,2.1627-1.37977,1.19053-2.95575,2.01903-3.46209,2.95576-0.50634,0.93736-3.93046,3.56905-5.29757,4.14565-1.37345,0.57659-1.44307,1.36775-1.44307,3.38804,0,22.2042-2.66461,20.4004-2.66461,25.7372,0,1.44181-0.29114,2.7393,1.15192,2.30638,1.44307-0.43229,3.53172-1.08103,5.69632-1.08103v12.5439z'/%3E %3Cpath d='m888.987,293.792c6.51912-3.25829,13.9876-4.46971,17.8801-5.47859,3.89248-1.00951,10.0951-4.03679,13.1205-5.62289,3.03171-1.58674,5.48112-3.74945,7.20901-4.32604,1.73421-0.57659,3.67095-1.76965,4.75958-3.89248,5.62037-10.9584,8.65207-19.7523,8.65207-27.3955,0-5.0463-1.29749-10.6698-6.20265-6.63241-4.60769,3.79502-9.62677,11.1104-10.9559,16.437-2.01903,8.07421-3.74691,9.80462-4.18363,11.3901-0.43039,1.58674-2.06333,1.58485-4.03805,2.01903-8.5065,1.87472-10.5255,3.17158-16.8674,7.9299-6.3419,4.75833-13.2661,8.94005-17.8801,11.535-4.61402,2.59562-5.47479,2.8836-6.48747,4.97415-1.00635,2.09055-1.94308,3.67665-2.81018,4.61465-0.86711,0.93673-1.11395,2.03232-0.93673,3.17158,0.14557,0.93736-0.29115,5.26276-0.36077,6.70456-0.076,1.4418,0.28482,1.80257,0.86711,1.87409,0.57596,0.0728,1.36711-0.21583,1.65826-1.94624-0.29115,1.73041,2.08865,1.15319,2.23422-0.14368-0.076,1.87409,2.44941,0.79306,2.59499-0.93736,0,1.22534,1.91143,0.37786,2.08865-0.21646,0.43038-1.4418,0.79115-3.0279,1.36711-4.18109,0.84179-1.67408,1.74054-3.84248,3.39247-5.04694,1.87346-1.36964,1.00635-2.8836,4.89883-4.83047z'/%3E %3Cpath d='m935.703,411.88c0.43672,1.5861,1.22787,3.38867,1.51269,4.47034,0.29115,1.08103-0.21519,1.41838-0.50001,2.01839-1.51269,3.17222-3.1393,8.22865-3.39247,10.9578-0.13924,1.58611-1.22154,3.10006-1.72788,4.03742-0.55698,1.03357-0.34178,1.83105,0.93672,2.81145,0.61394,0.46837,2.59499-0.1443,2.81019-1.15319,0.72153,0.72027,2.01902,0.43229,2.59498-0.64938,0.65192,0.64938,1.73422,0.21646,2.45575-0.86457,0.64558,0.43229,1.58231-0.43292,1.94307-1.01015,1.01268,0.50508,2.09498-0.10759,2.12663-2.08991,0.006-0.39811,0.25317-1.08167,0.54431-1.55003,0.28482-0.469,0.39242-1.36965,0.36077-2.16333-0.038-0.79306,0.46836-2.37853,1.15192-3.49628,0.68356-1.11774,1.87346-3.10006,1.36712-4.97414-0.46837-1.74624-1.22155-1.58611-1.87346-4.10895-1.58231-1.65889-3.74691-3.9659-5.98113-4.1102-2.23422-0.14368-3.53171,1.37028-4.3292,1.87472z'/%3E %3Cpath d='m894.683,424.28c2.01902,2.0184,6.56342,2.09055,9.73437-1.29813-1.15192-0.50444-3.67729-1.65826-4.82921-2.59498-1.58864,1.5861-3.39247,3.38804-4.90516,3.89311z'/%3E %3C/g%3E %3Cpath fill='%23870f00' d='m915.089,195.026c0.79116-5.11846,4.41781-4.99757,6.70267-4.46971,0.93672,0.21646,3.2469,0.43229,5.40517-0.14431,4.27856-1.13989,7.50014,0.36077,7.06976,4.47035,1.15192,0.86457,2.37346,2.88296,2.15827,4.61401-0.2152,1.72978,0.14557,2.45068,1.73421,2.66651,1.58231,0.21709,4.97478,2.16333,2.73423,4.90263,2.1646,1.29812,3.82286,4.61401,2.67094,6.84887-1.15192,2.23485-4.61402,2.59562-6.05708,0.57659-1.58231,0.7209-4.18363,0.86521-5.76594-0.79242-1.0823,1.29686-3.82286,1.15319-4.3292,0-0.50001-1.15382-1.35446-1.77092-2.37346-2.09118-1.15825-0.36014-1.22788-3.53235,0.50001-3.89312-0.2152-0.93736-0.13925-2.01839,0.29114-2.52283s0.0696-1.4418-0.93673-2.23549c-1.01267-0.79305-1.87345-3.82096-0.8671-5.47859-1.72788,0.5766-5.55074-1.08166-6.3419-2.23485-0.79748-1.15382-1.87345-1.22534-2.59499-0.21646z'/%3E %3Cg fill='none'%3E %3Cpath d='m916.171,217.23c2.81018-0.36077,3.74691-2.09055,5.83556-1.94688'/%3E %3Cpath d='m910.184,209.401c0.18355,0.16202,0.41773,0.2943,0.68356,0.44051,0.56963,0.3076,1.1899,0.34305,1.76586,0.41457'/%3E %3Cpath d='m911.019,206.418c0.39242,0.13544,0.81014,0.33292,1.18357,0.719'/%3E %3Cpath d='m917.538,195.026c-1.65826-1.58611,2.81018-4.82984,7.50015-0.21646,0.87343,0.86141,3.09499,0.86584,3.7469,0.64875'/%3E %3Cpath d='m924.026,197.477c2.1646-0.50507,5.40517-0.50507,6.34189,1.94624,0.94306,2.45132,2.81652,0.86521,4.3292,3.74944,1.51269,2.88361,3.89249,6.12734,6.19633,3.89249'/%3E %3Cpath d='m931.741,213.698c-0.65191-0.86521-0.93673-2.73993-0.50634-4.03806-0.86711-1.00888-0.50634-3.09942,0-4.10894'/%3E %3Cpath d='m925.539,207.714c0.076,0.86521,1.22787,2.45132,3.0317,2.7393'/%3E %3Cpath d='m937.507,214.491c-1.00635-1.2975-0.86711-2.45068-0.64559-4.03742'/%3E %3Cpath d='m926.982,200.145c-0.0696,1.29749,0.72154,3.0279,2.08865,3.6045,0.29115,0.72027,1.73421,2.73929,4.61402,2.45131'/%3E %3Cpath d='m934.267,194.882c-1.58231-1.22788-3.72793-2.74057-6.56342-3.11462'/%3E %3Cpath d='m916.671,236.262c-2.44941,3.31652-4.03805,7.9299-2.8798,14.4186,1.15192,6.48874,3.02537,16.0048-1.73421,20.3302'/%3E %3Cpath d='m935.418,283.555c-3.31652-0.72027-8.07611-0.72027-10.6711,1.15382s-6.92419,2.01839-9.80399,0.57659'/%3E %3Cpath d='m928.425,283.339c-2.88613,0.50444-4.25325,2.52284-4.25325,7.85775,0,5.33492-1.15192,13.1205-0.14557,20.7624'/%3E %3Cpath d='m923.159,285.574c-1.87345,0.50444-3.81653,0.57596-3.45576,5.62289'/%3E %3Cpath d='m913.431,291.341c0.0696-3.10006,1.15192-5.98366,3.17095-5.47922'/%3E %3Cpath d='m934.191,291.918c0.14558-6.84887-1.36711-8.79511-3.38614-8.72295,2.74056,0.0721,4.60769,0.40697,5.76594,11.6066,0.8671,8.36283,2.61397,11.323,4.61401,17.8795,5.18998,17.0136,2.59499,43.2553,5.18998,52.4833'/%3E %3Cpath d='m930.228,293.936c5.47479,15.8611,8.36093,33.4513-0.57596,61.7113,6.05075,16.7256,12.1078,28.8366,13.2598,35.7583'/%3E %3Cpath d='m912.924,331.424c1.00635-3.60387-2.59498-4.03679,0.57596-16.725,1.37345-5.49631,1.58864-8.79511,0.72154-10.5255'/%3E %3Cpath d='m914.222,311.672c-1.2975,5.62352,4.18362,16.149,1.44306,23.7903'/%3E %3Cpath d='m908.886,336.904c0,4.90199,1.15192,11.2464,0.8671,16.149-0.29114,4.902,1.7089,7.17356,4.03806,11.823,8.36092,16.7256,14.0509,28.6588,13.2598,44.4091-0.13924,2.8836,0.86711,8.93942-2.15827,10.6692'/%3E %3Cpath d='m909.101,424.208c0.86711,0.0721,1.80384-0.36014,2.88614-2.95576s4.54439-18.1674,3.10132-28.8373'/%3E %3Cpath d='m916.817,404.527c0.43039,3.31589,0.43039,10.0926-1.72788,15.4275'/%3E %3Cpath d='m922.298,394.578c1.29749,7.06533,1.15192,13.4098,0.14557,17.8788'/%3E %3Cpath d='m919.412,412.456c0.14558,2.8836,1.44307,10.0932-0.72153,10.6705'/%3E %3Cpath d='m930.228,379.006c5.32922,8.36283,9.51285,28.9816,13.9813,33.3064'/%3E %3Cpath d='m934.842,408.996c-0.14558-2.30701-0.29115-5.47859-1.58864-6.92103'/%3E %3Cpath d='m877.24,308.067c0.0696-1.58674-0.2152-3.10069,1.51268-5.55137'/%3E %3Cpath d='m874.645,309.004c0.21519-5.55137,0.13924-6.05644,1.72788-7.5704'/%3E %3Cpath d='m872.411,309.148c0.0696-3.96464-0.43672-5.33492,1.15192-7.85838'/%3E %3Cpath d='m892.304,190.196c-0.61393,0.39621-4.21527,3.1355-5.72796,4.28932'/%3E %3Cpath d='m893.854,191.529c-0.68356,0.10759-2.66461,1.73041-6.19633,4.46971'/%3E %3Cpath d='m893.962,193.764c-1.11394,0.50444-3.24057,2.55955-5.18997,3.92919'/%3E %3Cpath d='m885.095,193.368c-0.53798,0.39621-1.58231,1.55003-2.08865,1.94624'/%3E %3Cpath d='m935.343,435.022c-0.3228-0.36076-0.3228-1.62281,0.25317-3.0279'/%3E %3Cpath d='m937.937,434.373c-0.39241-0.39621,0-2.12662,0.39875-3.24436'/%3E %3Cpath d='m940.393,433.508c-0.46837-0.21646-0.61394-1.22597,0.0696-2.59562'/%3E %3Cpath d='m942.336,432.498c-0.32279-0.10759-0.46836-0.64874,0.1076-2.23422'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m913.969,199.567c1.04432,1.36965,2.12662,1.22471,2.3165,2.10764,0.18988,0.88419,0.32912,0.94685,0.53165,1.20888,0.20254,0.2614-0.49368,0.20887-0.83545,0.0677-0.33545-0.14114-1.18357-0.12658-1.70257-0.11899-0.51267,0.008-1.1266-0.59874-0.74052-0.67026,0.37975-0.0709,0.32912-0.19051,0.27216-0.4595-0.057-0.26836,0.21519-0.69306,0.37342-0.77091,0.16456-0.0779,0.0506-0.0633-0.0949-0.42342-0.1519-0.36077-0.34178-1.2361-0.12025-0.94116z'/%3E %3Cpath d='m914.602,198.313c1.17091,0.13734,3.18994,0.76963,4.2849,1.98168,0.86077,0.95318,0.15823,0.70065-0.27849,0.73609-0.43672,0.0367-1.29117-0.27279-1.72155-0.81457-0.42406-0.54115-1.69624-1.22724-2.37347-1.40573-0.4114-0.10633-0.79748-0.60191,0.0886-0.49747z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns='http://www.w3.org/2000/svg' height='600' width='900' version='1.1' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/' viewBox='-72 -28 144 96'%3E%3Cpath fill='%23cd2a3e' d='m-72-28h144v96h-144z'/%3E %3Cpath fill='%23006233' d='M-72,-13.6H72V53.6H-72Z'/%3E %3Cpath d='m29.999999 2.9199999c-0.08 16.4960001-13.488 29.8400001-29.99999952 29.8400001-16.51200048 0-29.91999948-13.344-29.99999948-29.8400001-0.656 2.512-1.008 5.1360001-1.008 7.8400001 0 17.12 13.871999 31.008 31.00799948 31.008 17.13599952 0 31.00799952-13.872 31.00799952-31.008 0-2.704-0.352-5.3440001-1.008-7.8400001z' class='st1' fill='%23ffc400'/%3E %3Cpath d='m-0.000001-9.2399582-2.694398 8.291438-8.718241 0.000318 7.053009 5.12472l-2.693771 8.2916412 7.053401-5.1241852 7.0534 5.1241862-2.693771-8.2916422 7.053012-5.12472-8.718243-0.000318z' fill='%23ffc400'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Crect width='750' height='500' fill='%2321428e'/%3E %3Cpath d='M 375,0 V 500 M 0,250 H 750' stroke='%23fff' stroke-width='72.5'/%3E %3Cpath id='path8' d='M 62.3,11.9 C 59.9,13 58,14.6 58,15.4 C 58,16.3 59.4,16.3 57.6,16.9 C 55.9,17.5 51.3,18.3 48.1,18.2 C 47,18.2 44.4,17.5 43.7,17.5 C 42.9,17.6 47.1,19.3 45.5,18.9 C 43.3,18.3 42,18.1 43.7,19.2 C 45,20 47.9,20 52,19.5 C 53.6,19.3 57.8,18.4 59.3,18.2 C 60.3,18.1 60.3,19 60.9,19 C 66.3,19.3 75.9,19.1 80.1,18.5 C 83.6,18 84.9,18.2 85.9,19.4 C 87.9,21.7 85.8,23.7 80.1,24.9 C 73.1,26.4 70.2,27.7 67.5,30.6 C 61,37.6 68.6,45.5 82.8,46.6 C 91.1,47.3 96.5,48.9 95.2,50.2 C 94.7,50.7 89.2,51.5 82.9,52 C 69.2,53.1 63.1,55 57.9,60 C 55,62.8 54,64.5 54,66.8 C 54,70 54,70 48.7,70 C 45.9,70 42,69.6 40.2,69 C 37.4,68.3 37,68.3 38,69.5 C 40,71.9 45.7,74 50.4,74 C 54,74 56,74.7 59.2,77 C 65.6,81.7 72.9,83.5 85,83.4 C 100.9,83.3 110,79.1 110,72 C 110,66.7 104,63.6 91.5,62.5 C 85.2,61.9 72.8,62.9 67.4,64.5 C 66.4,64.8 67.5,64.1 69.9,62.9 C 72.8,61.5 77.6,60.5 84.1,59.9 C 98.5,58.7 105,55.5 105,49.5 C 105,43.7 98.6,40.4 84.9,39.1 C 71.4,37.9 70.4,35.5 81.8,32 C 89.9,29.6 94,26 94,21.1 C 94,13.6 89.9,11.1 76.2,10.4 C 67.9,10 65.9,10.2 62.3,11.9 z M 69.5,14 C 69.2,14.5 68.4,15 67.9,15 C 67.3,15 67.2,14.5 67.5,14 C 67.8,13.4 68.6,13 69.1,13 C 69.7,13 69.8,13.4 69.5,14 z M 98.4,70 C 100.3,70.7 101,71.4 100.4,72 C 98.7,73.7 87.7,75.2 81,74.7 C 73.6,74 65.6,71.6 68,70.6 C 74.7,68 92.3,67.7 98.4,70 z' transform='scale(2.3)' fill='%23fff'/%3E %3Cuse xlink:href='%23path8' x='411.25'/%3E %3Cuse xlink:href='%23path8' y='286.25'/%3E %3Cuse xlink:href='%23path8' x='411.25' y='286.25'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E %3Crect width='1000' height='500' fill='%230071bc'/%3E %3Cg%3E %3Cg fill='none' stroke='%23000' stroke-width='1.93488'%3E %3Cpath fill='%23fff' d='m557.8173,395.54368c0,0 17.63179,-18.64915 34.58541,-15.08878 5.08623,-19.66633 24.24388,-21.19218 24.24388,-21.19218 0,0 -1.86484,-21.70066 22.71782,-26.4477 0.67818,-14.74979 15.59747,-26.95637 15.59747,-26.95637 0,0 -3.05169,-22.88732 12.54577,-28.14305 -9.49408,-18.14048 3.22119,-31.36461 3.05169,-31.7036 -0.1695,-0.33899 -16.10595,-28.65192 -1.86503,-36.78945 -15.08878,-12.71528 -10.17206,-27.12593 -10.17206,-27.12593 0,0 -16.44513,-4.23859 -10.51143,-23.9048 -13.56294,-2.37343 -16.27545,-24.24373 -16.27545,-24.24373 0,0 -20.85318,4.23831 -23.39619,-13.90209 -13.73244,2.20413 -15.25829,-11.35889 -15.42778,-11.35889 -0.1695,0 -27.29557,7.29005 -32.72077,-13.22393 -10.51106,5.42533 -15.08879,-4.238455 -15.08879,-4.238455 0,0 -15.08879,7.459663 -24.07418,-6.950964 -17.9708,11.189419 -27.97355,-0.508699 -27.97355,-0.508699 0,0 -23.56569,15.597348 -31.36442,3.560296 -13.90213,14.071702 -26.27819,7.968364 -26.27819,7.968364 0,0 -10.51132,18.648948 -27.46502,13.901928 -3.89937,17.29277 -23.3961,17.63186 -23.3961,17.63186 0,0 2.03443,15.25841 -21.36167,19.32726 -3.05166,17.97078 -15.25832,21.02252 -15.25832,21.02252 0,0 1.18674,17.46223 -9.83316,23.05701 3.89936,9.83336 -6.27287,21.87026 -6.27287,21.87026 0,0 10.85037,13.56293 -3.89935,28.82141 14.24112,3.72968 3.89935,28.31272 3.89935,28.31272 0,0 19.66631,8.81591 7.29011,25.09135 14.07156,4.57755 9.66359,15.76715 9.83315,22.37904 8.98545,4.06866 16.9537,2.03432 13.05435,20.1748 27.6345,3.0517 14.58016,18.30999 14.58016,18.30999 0,0 12.88483,0.50867 7.79872,10.68093 23.56565,-0.5085 26.95637,17.63179 26.95637,17.63179 0,0 21.87032,-5.7644 24.7524,2.71251 2.88214,8.47692 -9.49405,65.61086 -9.49405,65.61086 0,0 -18.47953,0 -32.21204,-14.7496 -32.21203,-0.84767 -25.09149,-22.04004 -25.60009,-22.04004 -0.5086,0 -10.68084,3.89937 -15.93648,-13.73243 -21.5312,4.40805 -20.85307,-13.73224 -21.0226,-13.90193 -0.16953,-0.1695 -9.66358,-4.40804 -6.10333,-13.39345 -22.20934,2.03415 -20.51398,-19.66632 -20.51398,-19.66632 -4.86006,-1.97802 -6.66845,-6.49888 -5.93379,-11.01992 -2.88212,-1.01736 -22.54842,-1.35635 -12.3762,-27.29537 -18.81862,-11.35911 -7.12056,-24.41336 -7.12056,-24.41336 0,0 -25.93915,-13.39344 -5.9338,-28.82141 -14.91924,-22.03986 1.18676,-33.05959 1.18676,-33.05959 0,0 -20.68351,-21.02267 0.33909,-35.94194 -3.39074,-31.87287 15.59741,-39.50199 15.59741,-39.50199 0,0 -10.00268,-25.93931 17.12324,-36.78964 1.69536,-26.278245 20.68351,-26.956402 20.68351,-26.956402 0,0 0.5086,-20.853066 30.34712,-18.818577 5.76424,-18.648947 26.10869,-14.919173 26.10869,-14.919173 0,0 6.27289,-22.548468 33.90742,-11.698137 14.07148,-27.464941 34.9247,-13.393384 34.9247,-13.393384 0,0 13.22375,-8.646532 19.83582,-5.933874 8.39584,-14.428497 26.26988,-0.559337 37.82654,2.23289 4.18844,-1.628821 19.13791,-12.913767 30.66633,1.327406 15.25847,-10.002714 28.31272,7.968209 28.31272,7.968209 0,0 21.02249,-10.680583 30.85575,13.732627 44.58818,-4.068997 38.1458,25.091366 38.1458,25.091366 0,0 35.0941,-7.968209 27.46506,26.956399 31.87291,2.20396 28.65172,23.22664 28.65172,23.22664 0,0 20.17481,15.25811 11.35892,28.99074 17.97098,0.84778 11.35891,18.14056 11.35891,18.14056 0,0 13.73263,5.25569 2.37351,26.61721 26.27821,21.02248 5.08623,41.87586 4.91673,41.70616 -0.16969,-0.16949 14.07162,16.95363 1.18666,36.61996 3.89938,31.19493 -11.86759,39.16296 -11.86759,39.16296 0,0 4.06887,20.17501 -13.56294,25.93922 -0.33899,23.73519 -22.71802,26.61738 -22.71802,26.61738 0,0 5.93389,10.31001 -16.27544,21.16045 -0.87593,15.88188 -24.07437,17.15485 -24.07437,17.15485 0,0 -2.20384,29.1602 -31.70343,21.36167 -7.15963,23.39658 -41.70597,16.44513 -42.38415,16.10614 -0.67817,-0.33918 -6.61187,-50.18288 -6.61187,-50.35258 z'/%3E %3Cpath d='m599.01,420.07s-2.6164,5.0315,7.8492,9.4592'/%3E %3Cpath d='m619.94,408.19s11.673-2.8176,19.522,0'/%3E %3Cpath d='m654.76,378.81c0,0.20143-1.61,5.2329,7.648,12.478'/%3E %3Cpath d='m661.4,365.73s6.8427,5.0315,18.315,4.8302'/%3E %3Cpath d='m592.37,380.42s0.40246,13.283-6.4402,19.522'/%3E %3Cpath d='m615.31,359.89s11.27,2.8176,20.529-1.8112'/%3E %3Cpath d='m687.56,340.37s2.4151,3.4214,14.893,2.8178'/%3E %3Cpath d='m638.86,332.52c0.40246,0.20122,14.692,4.8302,23.749,0.60388'/%3E %3Cpath d='m667.43,277.77s0.60368-0.8051,5.0315,14.692'/%3E %3Cpath d='m678.5,234.1s-0.60388,8.2515-7.2454,11.874'/%3E %3Cpath d='m720.97,200.29s-9.6605,7.849-7.849,11.069'/%3E %3Cpath d='m672.87,194.65s5.0315,8.4528-3.22,14.289'/%3E %3Cpath d='m648.52,158.43s8.6542-0.4027,12.478,7.044'/%3E %3Cpath d='m666.63,103.69c0,0.20119,1.8112,1.8112-1.61,5.2327'/%3E %3Cpath d='m604.84,104.49s4.629,7.2453,3.8239,16.101'/%3E %3Cpath d='m631.61,79.937c2.0125-0.20119,8.8554-3.2202,8.8554-3.2202'/%3E %3Cpath d='m601.82,51.157c-0.20124,0-2.6164,9.0566,1.8114,12.277'/%3E %3Cpath d='m590.75,92.415c0,9.6605,7.648,7.2452,2.4153,16.503'/%3E %3Cpath d='m572.04,84.365c-0.20123,0-12.075,9.258-12.075,10.868'/%3E %3Cpath d='m541.04,79.333s5.0315,5.0313,3.8239,11.874'/%3E %3Cpath d='m499.58,73.295c-0.20123,0.40257-4.2266,9.0566-7.0441,10.667'/%3E %3Cpath d='m462.96,73.497c0.20122,0,4.0251,8.0504-1.0063,13.887'/%3E %3Cpath d='m397.75,106.91c0.20126,0.40242,10.264,2.0125,10.264,2.0125'/%3E %3Cpath d='m372.59,130.25c0.20126-0.20136,12.277-3.8239,12.277-3.8239'/%3E %3Cpath d='m353.07,145.35c0.40253,0,8.4529,1.4089,10.465,0.40255'/%3E %3Cpath d='m347.43,152.79s2.6164,1.4089,0.40252,14.893'/%3E %3Cpath d='m308.19,117.37,4.8302,7.2453'/%3E %3Cpath d='m291.68,154.6c0-0.20134,4.8302,7.2452,11.271,8.6541'/%3E %3Cpath d='m329.72,192.44c0.20127,0,7.8491-1.6102,9.0567-2.4152'/%3E %3Cpath d='m326.3,219.81c0.20127,0-0.20125-5.0315,6.0378-8.4529'/%3E %3Cpath d='m318.05,232.29c0,0.20124,5.8365,7.4466,9.8617,8.4529'/%3E %3Cpath d='m314.63,246.18c0.60377-0.20143,6.8428-5.6356,14.088-5.2329'/%3E %3Cpath d='m312.61,264.89s0.20125,6.2392,18.717,4.6292'/%3E %3Cpath d='m314.43,286.83c0-0.20122,5.434-12.478,16.503-17.107'/%3E %3Cpath d='m329.32,302.53s1.6101-5.2329,10.868-8.8554'/%3E %3Cpath d='m339.58,323.26s6.6416-5.4339,9.0567-6.2388'/%3E %3Cpath d='m347.84,339.36s4.0252,4.2264,14.088-3.019'/%3E %3Cpath d='m299.33,342.78c1.2076-0.20123,15.899-3.6225,20.931,4.0253'/%3E %3Cpath d='m305.17,354.86s15.497-2.0127,17.51-0.40246'/%3E %3Cpath d='m360.51,358.08s-2.0126,4.2266,17.107-2.8176'/%3E %3Cpath d='m384.26,365.73c-3.4214,5.8364,0.80503,10.465-3.6227,13.082'/%3E %3Cpath d='m326.1,373.78c0.60378-0.40226,7.0441-2.6162,6.0378-11.874'/%3E %3Cpath d='m331.94,387.66c0.80505-0.20122,11.472-4.8302,13.686-2.4151'/%3E %3Cpath d='m352.87,401.15s1.4088-9.4592,4.4277-10.465'/%3E %3Cpath d='m368.97,415.44s8.8554-0.20122,12.679-3.0188'/%3E %3Cpath d='m386.07,383.44c0.20127,0.20123,8.2517,4.4276,25.359,0.20123'/%3E %3Cpath d='m392.51,421.88s2.4151,12.277,2.2139,15.094'/%3E %3Cpath d='m632.21,133.87,6.6417-0.00015'/%3E %3Cpath d='m526.35,75.308s-2.6163,7.6477-6.0376,9.6604'/%3E %3Cpath d='m454.5,31.836c0.20122,0.20119,0.80511,6.2389-3.0188,11.472'/%3E %3Cpath d='m418.28,45.522c0,0.20134,1.6101,6.8431-9.0566,9.0568'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23f7df73' stroke='%23000' stroke-linejoin='round' fill-rule='evenodd'%3E %3Cpath d='m561.72,423.68s100.53-28.397,130.89-151.78c-17.626,126.65-127.63,166.79-127.63,166.79l-3.264-15.015z' stroke-width='2.4186'/%3E %3Cpath d='m429.95,421.01s-99.612-28.908-129.69-154.51c17.464,128.92,126.46,169.79,126.46,169.79l3.234-15.285z' stroke-width='2.429'/%3E %3C/g%3E %3Cg fill='%238c1800'%3E %3Cpath d='m572.03,431.37c3.1074,0,10.794-8.5048,15.21-9.486,4.416-0.98118,4.9065-5.3974-0.1635-5.5607-5.07-0.1635-9.4858,5.7242-9.4858,5.7242s-4.416,3.7618-8.9953,4.2525c-4.5795,0.49068-1.6356,6.2146,3.4344,5.07z'/%3E %3Cpath d='m593.45,415.67s-3.1076-1.1449,4.9065-4.2523c8.0139-3.1074,7.5232-6.7055,10.14-8.1776,2.6167-1.4719,8.1774-5.3972,9.3223-3.1074,1.1449,2.2897-5.8878,6.8692-7.5232,7.3599-1.6356,0.49069-9.6496,7.8504-11.939,8.5046-2.2897,0.65418-3.9253,0.32719-4.9065-0.32719z'/%3E %3Cpath d='m419.74,428.84c-3.079,0-10.695-8.6576-15.071-9.6565-4.3755-0.99882-4.8615-5.4944,0.162-5.6606,5.0235-0.16644,9.3988,5.827,9.3988,5.827s4.3755,3.8294,8.9128,4.3289c4.5375,0.49951,1.6206,6.3264-3.4029,5.1611z'/%3E %3Cpath d='m398.51,412.86s3.0791-1.1654-4.8615-4.3287c-7.9405-3.1633-7.4543-6.8261-10.047-8.3246-2.5928-1.4983-8.1024-5.4942-9.2368-3.1633s5.8339,6.9927,7.4543,7.4922c1.6206,0.4995,9.5612,7.9915,11.83,8.6574,2.2688,0.66595,3.8893,0.33307,4.8615-0.33307z'/%3E %3Cpath stroke='%238c1800' stroke-width='2.4186' d='m629.92,388.19s-10.467,6.0511-8.9953,7.5232c1.4721,1.4721,10.794-5.7242,10.958-5.8876,0.1635-0.16369,3.9253-4.743-1.9626-1.6356z'/%3E %3Cpath stroke='%238c1800' stroke-width='2.429' d='m362.37,384.89s10.371,6.1599,8.9128,7.6584c-1.4586,1.4985-10.695-5.827-10.857-5.9935-0.162-0.16663-3.8893-4.8282,1.9446-1.665z'/%3E %3C/g%3E %3Cg fill='none' stroke='%238c1800' stroke-linecap='round'%3E %3Cpath stroke-width='3.14418' d='m645.46,372.82c-6.869,7.6869-6.869,7.5234-6.869,7.5234'/%3E %3Cpath stroke-width='2.90232' d='m655.76,360.23-6.542,8.0141'/%3E %3Cpath stroke-width='2.66046' d='m666.07,343.87-7.3599,11.776'/%3E %3Cpath stroke-width='2.4186' d='m674.74,327.19-6.0513,12.103'/%3E %3Cpath stroke-width='2.4186' d='m678.66,318.36-1.9626,4.2523'/%3E %3Cpath stroke-width='1.45116' d='m683.08,306.75-1.6356,5.07'/%3E %3Cpath stroke-width='3.15775' d='m346.98,369.24c6.8061,7.8251,6.8061,7.6586,6.8061,7.6586'/%3E %3Cpath stroke-width='2.914845' d='m336.77,356.42,6.4821,8.1582'/%3E %3Cpath stroke-width='2.67194' d='m326.56,339.77,7.2925,11.987'/%3E %3Cpath stroke-width='2.429' d='m317.97,322.79,5.9959,12.32'/%3E %3Cpath stroke-width='2.429' d='m314.08,313.8,1.9446,4.3287'/%3E %3Cpath stroke-width='1.4574' d='m309.71,301.98,1.6206,5.1611'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23217900' stroke='%23000' stroke-width='1.93488133' stroke-linejoin='round'%3E %3Cpath d='m343.56,115.74c0.0863,0,7.4767,6.4097,6.0965,16.07-1.38,9.6605-6.9591,23.09-5.8378,33.095,0.68549,4.011,0.42592,11.198,0.42592,11.198s-6.6997-9.5198-6.786-19.698,7.2549-19.842,7.2549-27.346c0-7.5041-1.3261-13.492-1.1535-13.319z'/%3E %3Cpath d='m339.9,118.62s-9.6981,9.258-10.947,18.255c-0.92216,4.6376-1.2801,26.247-1.3891,35.839-0.21797,2.9426-1.4376,14.558-1.6965,18.785-0.25868,4.2264,7.1339-7.2146,7.5566-16.53-0.23134-9.6425-0.23191-29.953,0.74897-33.005,0.87192-3.9237,0.68199-8.2587,2.0308-12.194,1.7845-5.4608,3.7826-11.064,3.6963-11.15z'/%3E %3C/g%3E %3Cg fill='none' stroke='%236b18b5' stroke-linejoin='round'%3E %3Cpath stroke-width='1.9349' d='m276.41,180.31s6.574,9.1024,7.7539,14.328c1.18,5.2254,3.3713,15.508,6.2368,19.722,2.8656,4.214,19.216,27.644,20.059,37.421,0.16855,6.4052-6.7425,17.362-17.025,17.53-6.4054-0.16833-22.924-4.3823-23.599-18.542-0.67426-14.159,5.0569-14.497,5.7311-23.093,0.67425-8.5967,0.84282-47.197,0.84282-47.366z'/%3E %3Cpath d='m389.35,56.361s-6.8061,0.48536-12.046,3.326c-4.0599,2.5035-10.937,6.1054-15.743,12.769-12.223,9.5289-30.612,13.975-36.412,21.891-3.4716,5.3855-3.2583,18.338,5.4402,23.823,5.5606,3.1839,21.865,8.1648,29.797-3.5835,7.9319-11.748,3.21-15.014,7.0999-22.71,6.4183-17.641,21.776-35.372,21.864-35.517z'/%3E %3Cpath d='m554.44,39.166s-5.0831-4.5518-10.769-6.3401c-4.6226-1.1752-12.322-0.66401-20.288-1.4458-15.348-2.1526-31.171-13.253-40.892-11.912-6.2839,1.2523-15.441,10.416-13.331,20.481,1.5808,6.2095,8.5255,18.768,22.483,16.294,13.958-2.4741,13.837-5.5188,22.072-8.0777,20.085-11.262,40.56-8.9616,40.724-8.9991z'/%3E %3Cpath d='m718.18,198.3c1.1458-2.6191-0.96454-7.5419-2.4637-13.311-1.4552-4.5424-3.6275-11.592-8.9417-17.858-6.3145-14.154-5.2323-33.564-11.524-41.094-4.3941-4.6633-17.019-7.5668-24.433-0.44034-4.4262,4.6333-13.177,19.264-3.6774,29.785,9.4995,10.521,13.64,6.558,20.176,12.182,15.583,10.467,23.215,28.816,30.863,30.736z'/%3E %3Cpath d='m712.59,321.94c2.128-2.9464,5.9383-8.6249,5.4852-13.354-0.35873-3.7457,1.7166-15.101,1.9434-20.055,1.4084-15.434,11.069-27.962,8.4423-41.372-1.5543-6.216-10.658-15.083-20.61-12.489-6.126,1.879-19.765,9.3842-16.62,23.206,3.1459,13.822,7.6118,13.593,10.566,21.694,8.4798,16.748,3.054,36.642,10.793,42.37z'/%3E %3C/g%3E %3Cg fill='%236b18b5'%3E %3Cpath d='m491.8,26.96c0.00082-2.1778-2.449-3.9435-5.4712-3.9435s-5.472,1.7657-5.4712,3.9435c-0.00082,2.1778,2.449,3.9435,5.4712,3.9435s5.472-1.7657,5.4712-3.9435z'/%3E %3Cpath d='m494.14,36.133c0-2.0885-2.5216-3.7816-5.6321-3.7816s-5.6321,1.6931-5.6321,3.7816,2.5216,3.7816,5.6321,3.7816,5.6321-1.6931,5.6321-3.7816z'/%3E %3Cpath d='m501.14,25.271s-6.4368,4.8276-3.7815,6.7586c2.655,1.931,9.9768-4.1838,9.9768-4.1838l-6.1953-2.5748z'/%3E %3Cpath d='m690.31,135.8c0.002-1.3724-0.6414-2.6413-1.687-3.3281-1.0455-0.68677-2.3342-0.68677-3.3798,0-1.0456,0.68678-1.6888,1.9558-1.687,3.3281-0.002,1.3723,0.6414,2.6413,1.687,3.3281,1.0456,0.68677,2.3342,0.68677,3.3798,0s1.6888-1.9558,1.687-3.3281z'/%3E %3Cpath d='m687.86,126.59c0-2.2888-1.5806-4.1443-3.5303-4.1443-1.9498,0-3.5303,1.8554-3.5303,4.1443,0,2.2888,1.5806,4.1443,3.5303,4.1443s3.5303-1.8555,3.5303-4.1443z'/%3E %3Cpath d='m689.55,145.32c0-1.1868-0.61848-2.1489-1.3814-2.1489-0.76294,0-1.3814,0.9621-1.3814,2.1489s0.61849,2.1489,1.3814,2.1489c0.76295,0,1.3814-0.96211,1.3814-2.1489z'/%3E %3Cpath d='m695.23,128.59c0-1.3564-0.61849-2.456-1.3814-2.456-0.76295,0-1.3814,1.0996-1.3814,2.456s0.61848,2.456,1.3814,2.456c0.76294,0,1.3814-1.0996,1.3814-2.456z'/%3E %3Cpath d='m679.72,130.28c0-1.102-0.61849-1.9954-1.3814-1.9954-0.76295,0-1.3814,0.89336-1.3814,1.9954s0.61848,1.9954,1.3814,1.9954c0.76294,0,1.3814-0.89335,1.3814-1.9954z'/%3E %3Cpath d='m682.18,143.48c0.00057-1.7807-1.3053-3.2246-2.9163-3.2246-1.6111,0-2.9169,1.4439-2.9163,3.2246-0.00058,1.7807,1.3053,3.2246,2.9163,3.2246,1.6111,0,2.9169-1.4439,2.9163-3.2246z'/%3E %3Cpath d='m674.5,137.64c0-1.5259-1.0995-2.7628-2.4559-2.7628-1.3563,0-2.4559,1.237-2.4559,2.7628,0,1.5259,1.0995,2.7628,2.4559,2.7628s2.4559-1.237,2.4559-2.7628z'/%3E %3Cpath d='m673.28,129.82c0.001-0.82331-0.40833-1.5846-1.0736-1.9965-0.6653-0.41197-1.4853-0.41197-2.1506,0-0.66529,0.41198-1.0746,1.1732-1.0736,1.9965-0.001,0.82331,0.40831,1.5846,1.0736,1.9965,0.66531,0.41198,1.4853,0.41198,2.1506,0,0.66529-0.41197,1.0746-1.1732,1.0736-1.9965z'/%3E %3Cpath d='m708.27,169.62c-3.1705-4.1843-8.2462-5.9474-11.337-3.9381-3.0907,2.0094-3.0261,7.0303,0.14438,11.215,3.1705,4.1843,8.2462,5.9474,11.337,3.9381,3.0907-2.0094,3.0261-7.0303-0.1444-11.215z'/%3E %3Cpath d='m717.28,246.81c0.61438-5.1345-1.8899-9.656-5.5934-10.099-3.7035-0.44315-7.2039,3.3599-7.8183,8.4944-0.61437,5.1345,1.8899,9.656,5.5934,10.099,3.7036,0.44316,7.2039-3.3599,7.8183-8.4944z'/%3E %3Cpath d='m719.18,291.75c1.0554-5.0622-1.049-9.7831-4.7005-10.544-3.6514-0.76131-7.4671,2.7253-8.5226,7.7875-1.0554,5.0622,1.049,9.7832,4.7004,10.544,3.6514,0.76132,7.4672-2.7253,8.5226-7.7875z'/%3E %3Cpath d='m727.84,249.69c0-2.0345-1.3744-3.6838-3.0699-3.6838-1.6954,0-3.0699,1.6493-3.0699,3.6838s1.3744,3.6839,3.0699,3.6839c1.6954,0,3.0699-1.6493,3.0699-3.6839z'/%3E %3Cpath d='m720.32,258.13-6.2932,7.1374s-5.9093,0.15343-5.6024,2.0721c0.30705,1.9186,8.1352,7.6747,8.0584,9.977-0.0768,2.3025,5.2188-0.53712,5.2188-0.53712s4.2209-12.817,4.2209-12.893c0-0.0768-0.23025-8.9028-2.5326-8.7491-2.3025,0.15343-2.9263,2.8303-3.0699,2.9933z'/%3E %3Cpath d='m306.38,255.31c0-1.6541-1.341-2.9951-2.9951-2.9951-1.6542,0-2.9952,1.3409-2.9952,2.9951,0,1.6541,1.341,2.9951,2.9952,2.9951s2.9951-1.3409,2.9951-2.9951z'/%3E %3Cpath d='m309.21,246.16c0-1.7461-1.341-3.1616-2.9951-3.1616-1.6542,0-2.9951,1.4155-2.9951,3.1616s1.341,3.1616,2.9951,3.1616c1.6542,0,2.9951-1.4155,2.9951-3.1616z'/%3E %3Cpath d='m284.61,202.63c-1.1233-2.5177-3.4627-3.9213-5.2251-3.135-1.7624,0.78632-2.2805,3.4648-1.1572,5.9825s3.4627,3.9213,5.2251,3.135c1.7624-0.78632,2.2805-3.4648,1.1572-5.9825z'/%3E %3Cpath d='m292.04,229.75c-1.5431-3.2632-4.7567-5.0823-7.1777-4.0632s-3.1327,4.4906-1.5896,7.7538,4.7567,5.0823,7.1777,4.0632,3.1327-4.4906,1.5896-7.7538z'/%3E %3Cpath d='m299.99,249.63c0.49995-4.0758-1.1889-7.8199-3.7722-8.3627-2.5833-0.54278-5.0828,2.3213-5.5827,6.3971-0.49995,4.0758,1.1889,7.8199,3.7722,8.3627,2.5833,0.54278,5.0828-2.3213,5.5827-6.3971z'/%3E %3Cpath d='m287.23,252.54c1.5978-3.7828,0.99957-7.8464-1.3361-9.0763s-5.5243,0.83956-7.1221,4.6223c-1.5978,3.7828-0.99957,7.8464,1.3361,9.0763s5.5243-0.83957,7.1221-4.6223z'/%3E %3Cpath d='m281.42,243.99c0-1.9299-1.49-3.4944-3.3279-3.4944-1.838,0-3.3279,1.5645-3.3279,3.4944s1.49,3.4945,3.3279,3.4945c1.838,0,3.3279-1.5645,3.3279-3.4945z'/%3E %3Cpath d='m278.76,235.34c0-1.7461-1.341-3.1616-2.9952-3.1616s-2.9951,1.4155-2.9951,3.1616,1.341,3.1616,2.9951,3.1616c1.6542,0,2.9952-1.4155,2.9952-3.1616z'/%3E %3Cpath d='m281.58,218.7c0-2.9408-1.3037-5.3248-2.912-5.3248-1.6082,0-2.9119,2.384-2.9119,5.3248s1.3037,5.3248,2.9119,5.3248,2.912-2.384,2.912-5.3248z'/%3E %3Cpath d='m290.54,217.42c0.38801-2.9151-0.58979-5.4502-2.184-5.6624-1.5942-0.21218-3.201,1.979-3.589,4.8941-0.38799,2.9151,0.5898,5.4502,2.184,5.6624,1.5942,0.21218,3.201-1.979,3.589-4.8941z'/%3E %3Cpath d='m354.39,90.042c1.1868-4.1283-0.0372-8.2775-2.7339-9.2673-2.6967-0.98984-5.845,1.5544-7.0318,5.6828-1.1868,4.1283,0.0372,8.2775,2.7339,9.2673,2.6967,0.98984,5.845-1.5544,7.0318-5.6828z'/%3E %3Cpath d='m342.27,108.42c3.5565-3.0269,5.0759-7.2124,3.3936-9.3486-1.6823-2.1361-5.9293-1.414-9.4858,1.6129s-5.0759,7.2124-3.3936,9.3486,5.9293,1.414,9.4858-1.6129z'/%3E %3Cpath d='m335.19,98.217c3.517-2.5985,5.0195-6.1916,3.3559-8.0255-1.6636-1.8338-5.8634-1.2139-9.3805,1.3846-3.517,2.5985-5.0195,6.1916-3.3559,8.0255,1.6636,1.8338,5.8634,1.2139,9.3805-1.3846z'/%3E %3Cpath d='m362.46,80.281c2.3718-1.8131,3.385-4.3202,2.2631-5.5997s-3.9541-0.84699-6.3258,0.96612c-2.3718,1.8131-3.385,4.3202-2.2631,5.5997s3.954,0.84699,6.3258-0.96612z'/%3E %3Cpath d='m348.25,97.659c1.6219-2.5064,1.7308-5.2083,0.24334-6.0348-1.4875-0.82655-4.0082,0.53523-5.6301,3.0416s-1.7308,5.2083-0.24334,6.0348c1.4875,0.82655,4.0082-0.53523,5.6301-3.0416z'/%3E %3Cpath d='m368.76,86.92c2.5506-2.1495,3.5444-4.9969,2.2197-6.3598s-4.4663-0.72518-7.017,1.4244c-2.5506,2.1495-3.5444,4.9969-2.2197,6.3598s4.4663,0.72518,7.017-1.4244z'/%3E %3Cpath d='m331.69,111.97c2.3843-0.11899,4.1842-1.3067,4.02-2.6528-0.16412-1.3461-2.23-2.3409-4.6144-2.2219-2.3843,0.11898-4.1841,1.3067-4.02,2.6528,0.16411,1.3461,2.23,2.3409,4.6143,2.222z'/%3E %3Cpath d='m376.57,73.606c1.6219-2.5064,1.7308-5.2083,0.24334-6.0348-1.4875-0.82655-4.0082,0.53523-5.6301,3.0416s-1.7308,5.2083-0.24334,6.0348c1.4875,0.82655,4.0082-0.53523,5.6301-3.0416z'/%3E %3C/g%3E %3Cg fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.93488133'%3E %3Cpath d='m553.24,88.375s12.574-5.8004,16.169-16.603c3.5942-10.802-10.882-10.906-12.795-7.4727-1.9124,3.4337,1.6313,11.983,0.71862,14.243-0.91288,2.26-6.0283,7.7162-4.0925,9.8326z'/%3E %3Cpath stroke-width='2.4186' d='m441.8,92.316s8.1629-11.186,6.0466-22.372c-2.1164-11.186-14.814-4.2327-14.814-0.30232s7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m419.73,98.967s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m395.24,106.53s8.1629-11.186,6.0466-22.372c-2.1164-11.186-14.814-4.2327-14.814-0.30232s7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m378.01,123.76s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath stroke-width='2.4186' d='m359.87,140.39s8.1629-11.186,6.0465-22.372-14.814-4.2327-14.814-0.30232,7.2558,9.6746,7.5582,12.093c0.30223,2.4186-1.5117,9.6744,1.2093,10.581z'/%3E %3Cpath d='m401.57,43.519s-10.87,8.5789-11.84,19.922c-0.9698,11.343,13.13,8.0606,14.187,4.2751,1.057-3.7856-4.3868-11.269-4.0276-13.68,0.35932-2.4108,4.0577-8.9115,1.6809-10.517z'/%3E %3Cpath d='m437.85,32.333s-10.87,8.5789-11.84,19.922c-0.96981,11.343,13.13,8.0606,14.187,4.2751,1.057-3.7856-4.3868-11.269-4.0276-13.68,0.35933-2.4108,4.0577-8.9115,1.6809-10.517z'/%3E %3Cpath d='m302.66,130.27s2.2963,13.656,11.776,19.96c9.48,6.3037,13.38-7.6378,10.569-10.385-2.8112-2.7468-11.991-1.5714-13.932-3.0453-1.9412-1.4741-5.8632-7.8423-8.4136-6.53z'/%3E %3Cpath d='m284.54,176.64s0.11238,13.847,8.4788,21.568c8.3664,7.7207,14.418-5.4306,12.076-8.5865-2.3425-3.156-11.592-3.444-13.277-5.2058-1.6842-1.762-4.5521-8.6694-7.2776-7.7759z'/%3E %3Cpath d='m326.34,228.44s-4.9424-12.936-15.479-17.248c-10.536-4.3119-11.613,10.125-8.3155,12.264,3.2974,2.1388,12.065-0.82252,14.259,0.24011,2.1936,1.0626,7.2936,6.5329,9.5354,4.744z'/%3E %3Cpath d='m317.66,206.05s8.3793-11.025,6.481-22.25-14.729-4.5203-14.805-0.59063c-0.0764,3.9296,7.0662,9.8139,7.3214,12.238,0.25509,2.424-1.6996,9.643,1.003,10.603z'/%3E %3Cpath d='m578.94,99.561s12.574-5.8004,16.169-16.603c3.5942-10.802-10.882-10.906-12.795-7.4727-1.9124,3.4337,1.6313,11.983,0.71862,14.243-0.91288,2.26-6.0283,7.7162-4.0925,9.8326z'/%3E %3Cpath d='m616.97,118.53s7.3965-11.707,4.5367-22.726-15.064-3.2326-14.801,0.68905c0.26295,3.9215,7.8866,9.1676,8.3502,11.561,0.46321,2.393-0.86141,9.7539,1.9142,10.477z'/%3E %3Cpath d='m720.74,226.27s-4.9601-12.929-15.502-17.226c-10.542-4.2976-11.599,10.141-8.2989,12.275,3.3005,2.1342,12.064-0.83896,14.259,0.22038,2.1951,1.0597,7.3024,6.5233,9.5419,4.7308z'/%3E %3Cpath d='m670,234.3s0.28772-13.845,8.7511-21.459c8.4636-7.6145,14.348,5.6121,11.966,8.7385-2.3824,3.126-11.635,3.2968-13.342,5.0373-1.7064,1.7406-4.6611,8.6112-7.3754,7.6832z'/%3E %3Cpath d='m661.83,87.484s-12.945-4.9172-23.175,0.07937c-10.23,4.9968-0.16872,15.406,3.6223,14.367,3.7906-1.0386,7.4135-9.5536,9.6665-10.485,2.253-0.93052,9.7301-1.0977,9.8859-3.962z'/%3E %3Cpath d='m632.21,62.693s-12.945-4.9172-23.175,0.07937c-10.23,4.9968-0.16872,15.406,3.6223,14.367,3.7906-1.0385,7.4135-9.5537,9.6665-10.485,2.253-0.93052,9.7301-1.0977,9.8859-3.962z'/%3E %3Cpath d='m588.02,39.053s-10.975,8.4448-12.084,19.775c-1.1087,11.331,13.03,8.2212,14.133,4.4487,1.1033-3.7723-4.248-11.322-3.8595-13.729,0.38891-2.4064,4.167-8.861,1.8097-10.495z'/%3E %3Cpath d='m559.27,32.131s-5.0048,12.912-0.0772,23.175,15.404,0.27293,14.391-3.525c-1.0127-3.7976-9.5034-7.4779-10.419-9.7372-0.9154-2.2592-1.0321-9.7372-3.8953-9.9123z'/%3E %3Cpath d='m477.66,81.887s8.9517-10.565,7.6509-21.875c-1.3006-11.31-14.468-5.295-14.753-1.3747-0.28481,3.92,6.5356,10.174,6.6622,12.609,0.12635,2.4343-2.2087,9.5394,0.4398,10.641z'/%3E %3C/g%3E %3Cg fill='%23de2010' stroke='%23000' stroke-width='2.38277'%3E %3Cpath d='m701.62,233.11c-0.50236-4.0492-2.4537-7.607-5.117-9.3315-2.6632-1.7245-5.6335-1.3532-7.7903,0.97376s-3.172,6.2556-2.6626,10.304c0.50235,4.0492,2.4537,7.607,5.117,9.3315,2.6632,1.7245,5.6335,1.3532,7.7902-0.97377,2.1568-2.327,3.172-6.2556,2.6626-10.304z'/%3E %3Cpath d='m699.95,212.66c-0.50236-4.0492-2.4537-7.607-5.117-9.3315-2.6632-1.7245-5.6335-1.3532-7.7903,0.97377s-3.172,6.2556-2.6626,10.304c0.50235,4.0492,2.4537,7.607,5.117,9.3315,2.6632,1.7245,5.6335,1.3532,7.7902-0.97377,2.1568-2.327,3.172-6.2556,2.6626-10.304z'/%3E %3Cpath d='m695.8,190.82c-0.85624-3.9894-3.1127-7.362-5.9172-8.8458s-5.7306-0.85294-7.6745,1.6546c-1.944,2.5076-2.61,6.5102-1.7468,10.498,0.85624,3.9894,3.1127,7.362,5.9172,8.8458s5.7306,0.85294,7.6746-1.6546c1.944-2.5076,2.61-6.5102,1.7468-10.498z'/%3E %3Cpath d='m688.23,168c-1.8449-3.6393-4.8866-6.3252-7.9767-7.0451-3.0901-0.71985-5.7587,0.63609-6.9992,3.5563-1.2405,2.9203-0.86415,6.9604,0.98712,10.597,1.8449,3.6393,4.8866,6.3252,7.9767,7.0451,3.09,0.71985,5.7587-0.6361,6.9992-3.5563,1.2405-2.9203,0.86415-6.9604-0.98712-10.597z'/%3E %3Cpath d='m680.14,149.69c-1.8449-3.6393-4.8866-6.3252-7.9767-7.0451-3.0901-0.71985-5.7587,0.63609-6.9992,3.5563-1.2405,2.9203-0.86415,6.9604,0.98712,10.597,1.8449,3.6393,4.8866,6.3252,7.9767,7.0451,3.09,0.71985,5.7587-0.6361,6.9992-3.5563,1.2405-2.9203,0.86415-6.9604-0.98712-10.597z'/%3E %3Cpath d='m668.64,131.28c-2.1465-3.47-5.4047-5.8887-8.5446-6.3443s-5.6841,1.1215-6.6729,4.1363c-0.98876,3.0148-0.27162,7.0086,1.8809,10.475,2.1465,3.47,5.4047,5.8887,8.5446,6.3443,3.1399,0.45559,5.6841-1.1215,6.6729-4.1363,0.98877-3.0148,0.27162-7.0086-1.8809-10.475z'/%3E %3Cpath d='m655.85,113.54c-2.4719-3.2462-5.9486-5.3386-9.1179-5.4885-3.1692-0.14991-5.5491,1.6657-6.2418,4.762-0.69268,3.0963,0.40721,7.002,2.8848,10.244,2.4719,3.2462,5.9486,5.3386,9.1179,5.4885,3.1693,0.14991,5.5491-1.6657,6.2418-4.762,0.69268-3.0963-0.40721-7.002-2.8848-10.244z'/%3E %3Cpath d='m640.59,96.996c-2.9164-2.8536-6.6597-4.4199-9.8172-4.1088-3.1575,0.31109-5.249,2.4525-5.4856,5.6165-0.23652,3.164,1.4179,6.8691,4.3393,9.7176,2.9164,2.8536,6.6597,4.4199,9.8172,4.1088,3.1575-0.31109,5.249-2.4525,5.4855-5.6165,0.23652-3.164-1.4179-6.8691-4.3393-9.7176z'/%3E %3Cpath d='m623.41,81.776c-3.1665-2.5733-7.038-3.7886-10.154-3.1884-3.1155,0.60021-5.0012,2.925-4.9457,6.0973s2.0438,6.7095,5.2147,9.2772c3.1665,2.5733,7.038,3.7886,10.154,3.1884,3.1155-0.60021,5.0012-2.925,4.9457-6.0973s-2.0438-6.7095-5.2147-9.2772z'/%3E %3Cpath d='m605.21,69.628c-3.5497-2.0119-7.5693-2.5676-10.542-1.4585-2.9726,1.1091-4.4462,3.7146-3.8648,6.8337s3.1293,6.2771,6.6825,8.2828c3.5497,2.0119,7.5693,2.5676,10.542,1.4585,2.9726-1.1091,4.4462-3.7146,3.8648-6.8337s-3.1293-6.2771-6.6825-8.2828z'/%3E %3Cpath d='m584.84,58.844c-3.7181-1.6805-7.7716-1.8681-10.631-0.49302-2.8594,1.375-4.0897,4.1039-3.2268,7.1571,0.86286,3.0532,3.6876,5.9663,7.4086,7.6402,3.7181,1.6805,7.7716,1.8681,10.631,0.49302,2.8594-1.375,4.0897-4.1039,3.2268-7.1571-0.86285-3.0532-3.6876-5.9663-7.4086-7.6402z'/%3E %3Cpath d='m564.86,50.799c-3.8224-1.4274-7.8794-1.3428-10.64,0.22081-2.7607,1.5636-3.8053,4.3688-2.7397,7.3573s4.0793,5.7056,7.9042,7.1263c3.8224,1.4274,7.8794,1.3428,10.64-0.22081,2.7607-1.5636,3.8053-4.3688,2.7397-7.3573s-4.0793-5.7056-7.9042-7.1263z'/%3E %3Cpath d='m544.56,44.43c-3.9202-1.1315-7.9588-0.73759-10.592,1.0322-2.6334,1.7698-3.4608,4.6465-2.1702,7.5449,1.2906,2.8985,4.5028,5.3777,8.425,6.5023,3.9202,1.1315,7.9588,0.73759,10.592-1.0322,2.6334-1.7698,3.4608-4.6465,2.1702-7.5449-1.2906-2.8985-4.5028-5.3777-8.425-6.5023z'/%3E %3Cpath d='m522.21,40.62c-4.0477-0.51427-7.9775,0.49696-10.307,2.6512-2.3294,2.1542-2.7039,5.1241-0.98236,7.7892,1.7216,2.6651,5.2773,4.62,9.3259,5.1272,4.0477,0.51427,7.9775-0.49696,10.307-2.6512,2.3294-2.1542,2.7039-5.1241,0.98236-7.7892-1.7216-2.6651-5.2773-4.62-9.3259-5.1272z'/%3E %3Cpath d='m500.15,39.375c-4.0768-0.16747-7.9061,1.175-10.043,3.5199-2.1373,2.3449-2.2574,5.3358-0.31502,7.8446,1.9424,2.5087,5.6518,4.1535,9.7289,4.3139,4.0768,0.16747,7.9061-1.175,10.043-3.5199,2.1373-2.3449,2.2574-5.3358,0.31501-7.8446-1.9424-2.5087-5.6518-4.1535-9.7289-4.3139z'/%3E %3Cpath d='m479.94,40.089c-4.0768-0.16747-7.9061,1.175-10.043,3.5199-2.1373,2.3449-2.2574,5.3358-0.31502,7.8446,1.9424,2.5087,5.6518,4.1535,9.7289,4.3139,4.0768,0.16747,7.9061-1.175,10.043-3.5199,2.1373-2.3449,2.2574-5.3358,0.31501-7.8446-1.9424-2.5087-5.6518-4.1535-9.7289-4.3139z'/%3E %3Cpath d='m456.25,42.895c-3.9785,0.90558-7.3229,3.2036-8.7718,6.0263-1.449,2.8226-0.78191,5.7407,1.7495,7.6535s6.542,2.5291,10.519,1.6166c3.9785-0.90558,7.3228-3.2036,8.7718-6.0263,1.449-2.8226,0.78192-5.7407-1.7495-7.6535s-6.542-2.5291-10.519-1.6166z'/%3E %3Cpath d='m434.7,48.296c-3.8902,1.2306-7.0337,3.7967-8.2449,6.7292s-0.30576,5.7856,2.3748,7.4831,6.7283,1.9809,10.616,0.74352c3.8902-1.2306,7.0337-3.7967,8.2449-6.7292s0.30576-5.7856-2.3748-7.4831-6.7283-1.9809-10.616-0.74352z'/%3E %3Cpath d='m415.04,56.715c-3.7159,1.6852-6.5314,4.6075-7.3847,7.6634-0.85329,3.0559,0.38555,5.7809,3.2492,7.147,2.8637,1.3661,6.9164,1.1654,10.629-0.5263,3.7159-1.6852,6.5314-4.6075,7.3847-7.6634s-0.38555-5.7809-3.2492-7.147c-2.8637-1.3661-6.9164-1.1654-10.629,0.5263z'/%3E %3Cpath d='m395.43,66.766c-3.5586,1.9961-6.1145,5.1479-6.704,8.2654-0.58948,3.1176,0.87731,5.7269,3.8471,6.8437s6.9906,0.57113,10.546-1.4312c3.5586-1.9961,6.1145-5.1479,6.704-8.2654,0.58948-3.1176-0.87731-5.7269-3.8471-6.8437s-6.9906-0.57113-10.546,1.4312z'/%3E %3Cpath d='m376.88,79.349c-3.3206,2.371-5.5189,5.7818-5.7661,8.945-0.24721,3.1632,1.4944,5.5977,4.568,6.3851,3.0736,0.78747,7.0113-0.19191,10.328-2.5687,3.3206-2.371,5.5189-5.7818,5.7661-8.945,0.24721-3.1632-1.4944-5.5977-4.568-6.3851-3.0736-0.78747-7.0112,0.19191-10.328,2.5687z'/%3E %3Cpath d='m359.71,92.358c-3.1081,2.6435-5.0099,6.2281-4.9886,9.4008s1.9627,5.4511,5.0919,5.9757c3.1292,0.52459,6.9699-0.78445,10.073-3.4333,3.1081-2.6435,5.0099-6.2281,4.9885-9.4008-0.0213-3.1727-1.9627-5.4511-5.0918-5.9757-3.1292-0.52459-6.9699,0.78446-10.073,3.4333z'/%3E %3Cpath d='m344.56,108.19c-2.9106,2.8595-4.5504,6.5713-4.3016,9.7343,0.24877,3.163,2.3486,5.2964,5.5072,5.5952,3.1587,0.29886,6.8957-1.2822,9.8012-4.1468,2.9106-2.8595,4.5504-6.5713,4.3016-9.7343-0.24876-3.163-2.3485-5.2964-5.5072-5.5952-3.1587-0.29885-6.8957,1.2822-9.8012,4.1468z'/%3E %3Cpath d='m331.51,125.79c-2.661,3.0931-3.9844,6.9291-3.4718,10.06,0.51264,3.1311,2.7836,5.0812,5.9562,5.1146s6.7642-1.8549,9.4198-4.9526c2.661-3.0931,3.9844-6.9291,3.4718-10.06-0.51264-3.1311-2.7836-5.0812-5.9562-5.1146s-6.7642,1.8549-9.4198,4.9526z'/%3E %3Cpath d='m319.58,143.81c-2.316,3.3593-3.2227,7.3145-2.3791,10.373,0.84363,3.0586,3.3096,4.7554,6.4677,4.4503,3.1581-0.30511,6.5278-2.5657,8.8379-5.929,2.316-3.3593,3.2227-7.3145,2.3791-10.373-0.84363-3.0586-3.3096-4.7554-6.4677-4.4503-3.1581,0.30511-6.5278,2.5657-8.8379,5.929z'/%3E %3Cpath d='m309.64,164.24c-1.7045,3.7072-1.9183,7.7594-0.56184,10.628,1.3565,2.8682,4.0773,4.1162,7.136,3.2731,3.0588-0.84308,5.99-3.6489,7.688-7.359,1.7045-3.7072,1.9183-7.7594,0.56184-10.628-1.3565-2.8682-4.0773-4.1162-7.136-3.2731-3.0588,0.84308-5.99,3.6489-7.688,7.359z'/%3E %3Cpath d='m301.77,185.59c-1.3614,3.8464-1.207,7.9013,0.40393,10.635,1.6109,2.7334,4.4337,3.7296,7.4034,2.6127s5.6346-4.1769,6.9892-8.0257c1.3614-3.8464,1.207-7.9013-0.40393-10.635-1.6109-2.7334-4.4337-3.7296-7.4034-2.6127s-5.6346,4.1769-6.9892,8.0257z'/%3E %3Cpath stroke-width='2.1334' d='m294.94,226.01c-0.38059,3.2566,0.75959,6.3785,2.9894,8.1879s5.2104,2.031,7.8173,0.58131c2.607-1.4498,4.4436-4.3503,4.8171-7.6074,0.3806-3.2566-0.75959-6.3785-2.9894-8.1879s-5.2104-2.031-7.8173-0.5813c-2.607,1.4498-4.4436,4.3503-4.8171,7.6074z'/%3E %3Cpath d='m296.76,207.14c-0.91046,3.9774-0.29124,7.9877,1.6231,10.518,1.9143,2.5302,4.8328,3.1955,7.6545,1.7448,2.8218-1.4507,5.1174-4.7966,6.0209-8.7755,0.91046-3.9774,0.29123-7.9876-1.6231-10.518-1.9143-2.5302-4.8328-3.1955-7.6545-1.7448-2.8218,1.4507-5.1174,4.7966-6.0209,8.7755z'/%3E %3C/g%3E %3Cg fill='%23ffe300'%3E %3Cpath d='m685.33,197.47c2.4854-2.6607,4.7977-3.413,7.7239-2.4427-1.0319-7.0192-3.2529-9.4006-5.9587-8.5554-2.7057,0.84519-3.9303,4.4536-1.7652,10.998z'/%3E %3Cpath d='m689.13,218.66c2.6788-2.4658,5.0415-3.0416,7.8862-1.8536-0.49998-7.077-2.5355-9.6191-5.2971-8.9802-2.7617,0.6389-4.2546,4.1447-2.5891,10.834z'/%3E %3Cpath d='m680.14,178.14c1.7282-3.2047,3.7738-4.5196,6.8502-4.3242-2.7806-6.527-5.5336-8.2663-7.9361-6.7616-2.4024,1.5046-2.6703,5.3057,1.0859,11.086z'/%3E %3Cpath d='m670.71,158.86c1.7282-3.2047,3.7738-4.5196,6.8502-4.3242-2.7806-6.527-5.5336-8.2663-7.9361-6.7616-2.4024,1.5046-2.6703,5.3057,1.0859,11.086z'/%3E %3Cpath d='m648.1,123.54c1.1907-3.4408,2.9985-5.0674,6.0662-5.369-3.7935-5.9952-6.7903-7.2694-8.9196-5.3982s-1.783,5.6659,2.8534,10.767z'/%3E %3Cpath d='m633.32,108.15c1.0599-3.4833,2.8048-5.1771,5.859-5.5945-4.0174-5.8476-7.0602-7.0076-9.1172-5.0572-2.0572,1.9503-1.5676,5.7293,3.2582,10.652z'/%3E %3Cpath d='m602.26,81.935c-0.0644-3.6404,1.074-5.7893,3.8512-7.127-5.6232-4.326-8.8753-4.4925-10.231-2.0035-1.3565,2.4891,0.27302,5.9336,6.3803,9.1305z'/%3E %3Cpath d='m618.42,94.057c0.56691-3.5966,2.0602-5.5159,5.027-6.3525-4.789-5.2344-7.9632-5.9615-9.7299-3.7449-1.7671,2.2166-0.75848,5.8912,4.7029,10.097z'/%3E %3Cpath d='m583.81,71.756c-0.4396-3.6144,0.47096-5.8692,3.0952-7.4863-6.0394-3.7227-9.2915-3.5528-10.384-0.93706-1.0924,2.6158,0.88386,5.8737,7.2883,8.4234z'/%3E %3Cpath d='m564.96,63.528c-0.95234-3.5143-0.37382-5.8762,1.992-7.8522-6.5099-2.8202-9.7042-2.1866-10.411,0.55846-0.70701,2.7452,1.7153,5.6868,8.4187,7.2938z'/%3E %3Cpath d='m544.65,57.235c-1.2464-3.421-0.86992-5.8235,1.32-7.9927-6.7252-2.259-9.8544-1.3572-10.326,1.4378-0.47212,2.7952,2.1905,5.5212,9.0059,6.5549z'/%3E %3Cpath d='m524.7,53.373c-1.4906-3.3219-1.2888-5.7453,0.73855-8.0672-6.8711-1.7667-9.9267-0.64101-10.195,2.1808-0.26875,2.8221,2.584,5.3483,9.4563,5.8864z'/%3E %3Cpath d='m503.57,51.753c-1.8271-3.1494-1.8776-5.5807-0.10196-8.1003-7.0172-1.0447-9.9397,0.39174-9.9138,3.2261,0.0253,2.8347,3.1246,5.0515,10.016,4.8742z'/%3E %3Cpath d='m462.21,54.869c-2.5324-2.616-3.1674-4.9634-2.0518-7.8368-7.0621,0.67789-9.5519,2.7765-8.8436,5.521,0.70797,2.745,4.2504,4.1492,10.895,2.3157z'/%3E %3Cpath d='m482.57,52.189c-2.1551-2.9348-2.4666-5.3465-0.97229-8.0424-7.0888-0.28422-9.8398,1.4581-9.5094,4.2733,0.32989,2.8155,3.6496,4.6863,10.482,3.7691z'/%3E %3Cpath d='m442.23,59.185c-2.8813-2.2259-3.8463-4.458-3.1541-7.4616-6.892,1.6834-9.0552,4.1173-7.9606,6.7319,1.0942,2.6151,4.8013,3.4969,11.115,0.7297z'/%3E %3Cpath d='m403.98,76.772c-3.2521-1.6372-4.6241-3.645-4.5159-6.7254-6.4459,2.9637-8.1066,5.7647-6.5347,8.1233,1.5717,2.3592,5.3788,2.5197,11.051-1.398z'/%3E %3Cpath d='m422.42,67.35c-3.0292-2.02-4.1472-4.1796-3.6657-7.224-6.7581,2.1589-8.7467,4.7375-7.4729,7.2696,1.2735,2.5326,5.033,3.1543,11.139-0.04555z'/%3E %3Cpath d='m369.67,100.66c-3.5219-0.92352-5.2822-2.6013-5.8183-5.6366-5.6867,4.242-6.7272,7.3275-4.6983,9.3068,2.0288,1.9798,5.7859,1.3434,10.517-3.6703z'/%3E %3Cpath d='m386.04,87.263c-3.4388-1.1964-5.0623-3.0068-5.3592-6.0747-6.0013,3.7838-7.2802,6.7784-5.4124,8.9105,1.8676,2.1326,5.6629,1.7922,10.772-2.8358z'/%3E %3Cpath d='m355.13,114.99c-3.5912-0.59954-5.4968-2.1103-6.3066-5.0843-5.2776,4.7413-6.0333,7.9087-3.8328,9.6954,2.2004,1.7872,5.884,0.8119,10.139-4.6111z'/%3E %3Cpath d='m342.09,131.9c-3.6308-0.27111-5.6656-1.6027-6.7421-4.4909-4.8254,5.2008-5.2905,8.4237-2.9369,10.003,2.3535,1.5801,5.9334,0.27444,9.679-5.5124z'/%3E %3Cpath d='m331.19,149.2c-3.6295,0.2881-5.8442-0.71618-7.3503-3.4054-3.9721,5.8784-3.9381,9.1345-1.3704,10.335,2.5678,1.2011,5.9055-0.63741,8.7207-6.9296z'/%3E %3Cpath d='m321.61,167.67c-3.5615,0.75666-5.8878,0.0483-7.73-2.4229-3.1757,6.3441-2.7195,9.5683-0.0177,10.425,2.7019,0.85774,5.7728-1.3983,7.7478-8.0026z'/%3E %3Cpath d='m313.95,186.62c-3.3966,1.3114-5.8058,0.98047-8.0163-1.1675-2.1304,6.7671-1.1692,9.8783,1.6342,10.297,2.8037,0.41883,5.4784-2.2953,6.382-9.1291z'/%3E %3Cpath d='m308.82,207.75c-3.3012,1.5359-5.7271,1.3668-8.0764-0.62825-1.6727,6.8946-0.50531,9.9344,2.3199,10.164,2.8254,0.23006,5.3124-2.657,5.7566-9.5359z'/%3E %3Cpath d='m306.73,225.33c-3.1078,1.646-5.5296,1.8405-8.0697,0.59614-0.92446,5.6189,0.55546,7.8398,3.3793,7.6391,2.8241-0.20045,4.9816-2.794,4.6904-8.2352z'/%3E %3Cpath d='m662.3,141.68c1.2428-3.4223,3.0749-5.0212,6.1469-5.2762-3.702-6.0522-6.679-7.3718-8.8366-5.5331-2.1574,1.8386-1.8687,5.6382,2.6897,10.809z'/%3E %3Cpath d='m691.45,240.12c2.6788-2.4658,5.0415-3.0416,7.8862-1.8536-0.49997-7.077-2.5355-9.6191-5.2971-8.9802-2.7617,0.6389-4.2546,4.1447-2.5891,10.834z'/%3E %3C/g%3E %3Cpath d='m646.9,149.66s7.3965-11.707,4.5367-22.726-15.064-3.2326-14.801,0.68906c0.26295,3.9215,7.8866,9.1676,8.3502,11.561,0.4632,2.393-0.86142,9.7539,1.9142,10.477z' fill='%23ffd200' stroke='%23ef8a10' stroke-width='1.008'/%3E %3Cg fill='%23217900' stroke='%23000' stroke-width='2.4186' stroke-linejoin='round'%3E %3Cpath stroke-width='1.9349' d='m663.67,124.92c-0.0863,0-8.0216,7.9354-6.6415,17.596,1.38,9.6605,7.504,21.564,6.3828,31.569-1.1215,10.006-2.9327,16.647-2.9327,16.647s9.3155-10.609,9.4018-20.787-6.383-23.548-6.383-31.052c0-7.5041,0.34519-14.146,0.17259-13.973z'/%3E %3Cpath stroke-width='1.9349' d='m678.42,157.35s-6.2104,4.5715-5.6065,15.095c0.60369,10.523,11.472,29.844,11.472,29.844s7.9355,16.302,7.6766,20.529c-0.25869,4.2264,1.4664-4.0538,0.69017-13.369-0.77627-9.3155-12.766-29.844-12.766-29.844s-2.5877-4.2263-2.3288-11.213c0.25869-6.9867,0.94886-10.954,0.86257-11.041z'/%3E %3Cpath d='m505.65,52.293s26.653,1.0353,26.825,18.286c-0.0863,2.674-0.00019,5.8651-0.94886,13.542,5.2615-2.8462,8.7981-10.782,8.1079-15.871,0.0863-17.51-23.806-29.499-33.984-15.957z'/%3E %3Cpath d='m488.75,51.517s21.477-4.4853,21.65,12.766c0.17259,17.251-6.8141,20.011-6.8141,20.011s16.475-3.5365,16.561-21.046c0.0863-17.51-21.218-25.272-31.397-11.731z'/%3E %3Cpath d='m697.38,249.19c0.49396,7.7393,8.0686,15.149,5.1048,28.652-3.7873,15.314-17.125,51.705-14.82,58.127-3.952-5.4341-3.2934-10.539-3.6227-18.113-0.32931-7.5745,11.032-35.732,12.021-45.283-0.00019-8.5624,0.82311-20.254,1.3171-23.382z'/%3E %3Cpath d='m697.38,249.36s12.35,15.643,11.691,27.993c-0.65862,12.35-7.5747,26.84-5.2693,33.262-3.952-5.4341-4.9399-8.8921-5.2693-16.467-0.32931-7.5745,6.0926-15.973,4.7753-24.206-1.3175-8.2333-6.0928-20.583-5.9281-20.583z'/%3E %3Cpath d='m292.82,252.81c-0.49397,7.7393-6.2574,14.655-3.2936,28.158,3.7873,15.314,17.29,34.744,15.149,56.974,3.952-5.4343,5.1048-11.527,5.4341-19.102,0.32931-7.5745-14.984-33.098-15.973-42.648,0.00019-8.5624-0.8231-20.254-1.3171-23.382z'/%3E %3Cpath d='m292.82,252.98s-12.021,15.149-11.362,27.499c0.16465,8.2331,15.314,42.648,13.009,49.07,3.952-5.4339,5.1046-4.7755,4.9398-13.009-4.446-21.077-12.35-34.58-11.032-42.813,1.3175-8.2333,4.6108-20.748,4.4462-20.748z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='1.9349'%3E %3Cpath fill='%238c8a8c' d='m526.38,104.56s21.457,1.3504,22.508,13.655c1.0502,12.304-5.1017,19.807-5.1017,19.807s2.7009,26.559-18.306,34.361c-22.508,2.701-57.769,0.60024-57.769,0.60024s-10.354,2.551-14.555-18.906c-4.2014-21.457-5.4018-36.612-5.4018-36.612s2.1007-12.004,17.256-12.754c15.155-0.75019,61.22,0.15013,61.371-0.14998z'/%3E %3Cpath stroke-linecap='round' d='m543.63,137.87s-11.554,14.405-10.353,20.257'/%3E %3Cpath fill='%238c8a8c' d='m528.18,171.63c2.851,2.4008,5.5518,5.1016,6.152,13.955,0.6002,8.853,1.2004,17.706,1.2004,17.706l15.005,135.05,13.204,97.683,0.9003,15.155s-3.151,11.104-12.004,12.004c-6.452,13.504-41.414,17.406-44.865,17.256-3.151-0.14996-14.255-4.8016-21.007-4.2014-6.7524,0.60001-18.456,5.1015-23.708,4.3514-5.2516-0.75015-17.106-4.8016-19.206-13.354-14.705-4.6516-17.106-15.905-17.106-15.905l15.905-112.99,15.455-142.85s1.8006-19.056,9.4531-21.907c7.9527-0.7502,49.066,0.7502,60.62-1.9506z'/%3E %3Cpath d='m447.15,367.15-3.151,99.934'/%3E %3Cpath d='m544.23,380.35,8.853,82.378'/%3E %3Cpath fill='%23fff' stroke-width='2.0159' stroke-linejoin='round' d='m498.19,114.45,29.923,92.093,96.82,0.004-78.327,56.92,29.916,92.095-78.331-56.915-78.331,56.914,29.916-92.095-78.327-56.92,96.82-0.004z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 660 440'%3E %3Crect fill='%2300785E' width='660' height='440'/%3E %3Cpolygon fill='%23FBD116' points='330 82.958 315.792 126.693 352.995 99.666 307.005 99.666 344.208 126.693 '/%3E %3Cg id='h'%3E %3Cpath fill='%23FFF' d='M330 303.99h-93.937c-1.184-1.2-2.35-2.423-3.488-3.667H330c0.751 0.269 1.267 0.958 1.306 1.736C331.348 302.903 330.818 303.694 330 303.99zM330 275.265c0.545-1.114 1.607-3.694 1.125-6.921 -0.218-1.463-0.692-2.644-1.125-3.492 -5.271 4.988-15.175 12.981-29.785 17.401 -6.821 2.064-14.055 3.173-21.548 3.173h-57.872c1.706 2.507 3.494 4.954 5.364 7.333h55.945C300.346 292.76 317.058 286.179 330 275.265zM229.539 252.628c-2.785 1.072-5.772 1.741-8.887 1.926 13.629 15.415 33.545 25.144 55.723 25.144 21.066 0 40.091-8.775 53.625-22.867 2.297-15.839 3.968-33.969 4.167-53.998 0.232-23.321-1.581-44.2-4.167-62.032 -6.045 5.419-17.371 17.128-22.71 35.079 -1.998 6.72-3.072 13.837-3.072 21.203 0 15.291 4.623 29.506 12.547 41.329 -9.731-12.57-15.526-28.338-15.526-45.454 0-11.369 2.558-22.144 7.126-31.783 -3.154-3.334-5.551-7.392-6.904-11.902 -6.121 10.804-9.618 23.284-9.618 36.581 0 16.539 5.409 31.819 14.552 44.172 -15.923-16.693-38.377-27.099-63.25-27.099 -1.336 0-2.667 0.034-3.989 0.093 2.503 2.333 4.604 5.089 6.188 8.157 24.742 0.038 47.078 10.377 62.964 26.949 -15.171-12.672-34.698-20.303-55.995-20.303 -11.902 0-23.25 2.382-33.594 6.696 10.629 28.085 37.78 48.075 69.574 48.075 2.059 0 4.1-0.093 6.116-0.258 -4.29 0.771-8.709 1.174-13.22 1.174C261.128 273.51 242.92 265.554 229.539 252.628zM330 334.01h-48.684c15.067 5.988 31.492 9.281 48.684 9.281 0.414-0.788 1.125-2.395 1.146-4.542C331.168 336.492 330.417 334.804 330 334.01zM330 311.552h-85.83c2.322 1.99 4.711 3.902 7.169 5.729H330c0.197-0.201 1.167-1.236 1.167-2.865S330.197 311.753 330 311.552zM330 323.01h-70.304c4.257 2.686 8.675 5.139 13.242 7.333H330c0.33-0.523 1.112-1.917 1.063-3.844C331.018 324.78 330.335 323.54 330 323.01z'/%3E %3Cpolygon fill='%23FBD116' points='237.639 150.67 224.197 179.509 252.019 164.076 220.444 160.202 243.712 181.901'/%3E %3Cpolygon fill='%23FBD116' points='260.663 112.27 269.966 142.699 280.328 112.607 254.26 130.861 286.079 131.413'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='matrix(-1,0,0,1,660,0)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='4800' height='2400'%3E %3Cg fill='%23f9cf02'%3E%3Cg transform='scale(5)'%3E%3Crect width='960' height='480' fill='%23c4272f'/%3E %3Crect x='320' width='320' height='480' fill='%23015197'/%3E%3Ccircle cx='160' cy='164' r='44'/%3E %3Ccircle cx='160' cy='144' r='48' fill='%23c4272f'/%3E%3Ccircle cx='160' cy='152' r='32'/%3E %3Cpath d='M140,92a20,20 0 0,0 40,0c0-8-5-9-5-12 0-3,3-7-3-12 3,5-2,6-2,11 0,5,2,5,2,9a4,4 0 0,1-8,0c0-4,4-8,4-14 0-6-1-8-4-13-3-5-8-9-4-13-6,2-3,10-3,15 0,5-4,8-4,14 0,6,3,7,3,11a4,4 0 0,1-8,0c0-4,2-4,2-9 0-5-5-6-2-11-6,5-3,9-3,12 0,3-5,4-5,12Z'/%3E %3Cpath d='M72,216V408H112V216ZM208,216V408H248V216ZM120,248V264H200V248ZM120,360V376H200V360ZM120,216H200L160,240ZM120,384H200L160,408Z'/%3E%3C/g%3E %3Cg stroke='%23c4272f' stroke-width='24'%3E%3Ccircle cx='800' cy='1560' r='212'/%3E %3Cpath fill='none' d='M800,1348A106,106 0 0,1 800,1560A106,106 0 0,0 800,1772'/%3E%3C/g%3E%3C/g%3E %3Cg fill='%23c4272f'%3E%3Ccircle cx='800' cy='1454' r='40'/%3E %3Ccircle cx='800' cy='1666' r='40'/%3E%3C/g%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1800' height='1200' viewBox='0 0 18 12'%3E %3Crect width='18' height='6' fill='%23FECB00'/%3E %3Crect width='18' height='6' y='6' fill='%23EA2839'/%3E %3Crect width='18' height='4' y='4' fill='%2334B233'/%3E %3Cg transform='translate(9,6.422)scale(4.422)'%3E %3Cpolygon id='pt' points='-0.3249196962329062,0 0,-1 0.3249196962329062,0' fill='%23FFF'/%3E %3Cuse xlink:href='%23pt' transform='rotate(-144)'/%3E%3Cuse xlink:href='%23pt' transform='rotate(-72)'/%3E%3Cuse xlink:href='%23pt' transform='rotate(72)'/%3E%3Cuse xlink:href='%23pt' transform='rotate(144)'/%3E%3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%23CE1126' width='450' height='300'/%3E %3Crect fill='%23FCD116' width='300' height='300'/%3E %3Crect fill='%2314B53A' width='150' height='300'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1400' height='700' viewBox='0 0 56 28'%3E %3Crect width='56' height='28' fill='%23d20000'/%3E %3Cg fill='%23ffe600'%3E %3Cpath d='M 0,0 8.4,0 28,13.5 47.6,0 56,0 0,28 8.4,28 28,14.5 47.6,28 56,28 z M 56,11.2 56,16.8 0,11.2 0,11.2 0,16.8 z M 25.2,0 28,12 30.8,0 z M 25.2,28 28,16 30.8,28 z'/%3E %3Ccircle cx='28' cy='14' r='4.5' stroke='%23d20000'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='570' height='300'%3E %3Ctitle%3EFlag of the Marshall Islands%3C/title%3E %3Crect height='300' width='570' fill='%23003893'/%3E %3Cpath d='M0,295.2V288L570,35V122.4z' fill='%23fff'/%3E %3Cpath d='M0,290.4V285.6L570,4.8V63.6z' fill='%23dd7500'/%3E %3Cg fill='%23fff' transform='translate(109.536,109.536)'%3E %3Cg id='r6'%3E %3Cpath d='M0,-93 5.59,0H-5.59z'/%3E %3Cpath id='r1' d='M0,-66.588 6.824,0H-6.824z' transform='rotate(15)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(15)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(30)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(45)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(60)'/%3E %3C/g%3E %3Cuse xlink:href='%23r6' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r6' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r6' transform='rotate(270)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23007E3A' width='900' height='600'/%3E %3Crect fill='%23FC3D32' width='900' height='300'/%3E %3Crect fill='%23FFF' width='300' height='600'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='640' height='320'%3E %3Crect width='640' height='320' fill='%23d3ae3b'/%3E %3Crect width='608' height='288' x='16' y='16' fill='%23c40308'/%3E %3Cg%3E %3Cpath fill='%23B96B29' d='M389.64,157.4c1.874-0.529,8.39-2.433,12.981-6.158,4.591-3.726,5.487-6.711,5.858-8.323,0.368-1.612,0.527-2.88-0.66-1.955-1.187,0.923-4.749,3.725-7.176,5.073-2.429,1.347-4.672,1.982-5.991,2.353-1.319,0.368-2.375,0.606-1.107,0.104,1.265-0.501,5.409-1.956,8.602-5.152,3.192-3.197,5.714-7.988,5.768-10.93,0.053-2.941-0.157-2.732-1.103-1.996-0.946,0.735-4.308,4.886-6.198,6.461-1.891,1.577-4.938,3.678-6.461,4.57-1.524,0.894-3.677,1.892-0.683-0.157,2.994-2.047,8.666-6.881,10.979-13.132,2.311-6.251,1.89-9.927,1.838-10.558-0.052-0.63-0.578-1.891-1.103-0.734-0.525,1.154-4.309,8.719-7.354,11.975-3.048,3.257-2.312,2.627-2.995,3.152-0.682,0.525-1.839,1.471-0.366-0.369,1.471-1.837,4.517-6.093,6.094-10.294,1.574-4.203,1.995-8.406,2.047-10.822,0.053-2.416-0.997-5.777-1.471-6.774-0.472-1-0.945-1.734-1.104-0.58-0.156,1.156-2.573,8.615-3.887,12.239-1.313,3.625-3.938,7.723-4.465,8.511-0.524,0.788-1.89,2.416-0.42-0.315,1.471-2.732,4.307-10.769,4.676-18.385,0.367-7.617-0.683-11.819-1.734-13.92-1.05-2.102-1.96-2.847-1.96-2.847s0.18,5.2-1.372,12.67c-1.553,7.471-3.819,11.415-3.819,11.415s-0.954,1.076-0.3-0.717c0.443-1.206,1.354-3.86,1.771-8.358,0.439-4.719,0.491-10.088-0.887-14.659-1.5-4.978-4.104-7.523-4.104-7.523-0.726,7.142-0.582,16.344-3.199,23.803-0.49-0.438-1.138-1.248-1.396,0.401-0.478,2.451-1.433,7.053-4.654,12.91-3.224,5.857-4.535,6.634-4.535,6.634s-0.597-1.435-1.016-2.211c-0.417-0.777-0.656-1.196-1.194-0.12-0.535,1.076-2.326,5.2-6.266,9.742-3.938,4.542-6.146,6.753-6.026,10.159,0.12,3.407,1.909,5.141,4.296,6.694,2.388,1.555,2.807,2.39,2.447,4.243-0.358,1.854-2.507,2.51-4.355,2.57-1.852,0.06-4.179-0.12-5.014,0.358-0.836,0.479-0.895,1.673-1.731,2.509-0.834,0.838-1.192,1.314-1.969,1.436-0.273,0.042-0.495,0.067-0.667,0.086-0.172-8.985,3.31-12.991,3.31-12.991l-9.731-11.433c-0.503,0.247-1.005,0.478-1.509,0.696-0.068-0.132-0.162-0.276-0.285-0.432-1.295-1.654-1.719-3.056-1.719-5.176,0.484,0.048,1.455,0.398,2.337,0.221,0.882-0.176,0.22-1.061-0.044-1.901-0.265-0.842-0.53-3.76-0.354-4.866,0.177-1.106,0.264-1.549,0.264-1.549s1.413,1.549,2.294,1.549c0.884,0,0.794-0.884,0.927-1.858,0.199-1.467,0.889-3.319,2.028-4.335,0,0,1.543,1.063,3.309,1.063,1.763,0,4.144-0.487,6.04-2.3,1.897-1.813,1.853-2.256,1.853-2.256s3.527,1.238,6.218,1.372c2.69,0.132,5.557-0.311,6.924-3.141,1.367-2.831-0.398-5.44-0.705-5.883-0.31-0.443-1.191-0.797-1.191,0s0.045,2.919-1.588,3.981c-1.632,1.061-2.91,1.016-4.454,0.53-1.543-0.486-3.704-1.106-6.174-0.752-2.215,0.317-2.515,0.492-2.553,0.525,0.115-0.118,2.126-2.18,4.096-2.781,2.029-0.619,3.221,0.221,3.882,1.017s1.234,2.08,1.764,0.221c0.529-1.857,0.221-3.98-0.661-5.352-0.883-1.371-2.778-2.256-4.763-2.034-1.985,0.221-2.689,0.53-2.689,0.53s-1.016-2.874-3.573-3.405c-3.12-0.648-6.562,0.525-9.261,2.034,0,0-2.117,0.488-4.277-0.132-1.415-0.406-2.83-1.267-3.639-1.811,0.246-0.827,0.73-2.354,0.73-2.354s0.618-0.188,1.264-0.431c0.646-0.242,0.512-0.458,0.593-0.996,0.08-0.538-1.214-1.475-1.214-1.475s-0.187-1.617,1.94-2.726c2.126-1.109,1.895-0.924,1.895-0.924s1.247,0.231,1.756-0.139c0.508-0.37,0.508-0.601,0.508-0.601s0.942-0.309,1.288-0.877c0.345-0.567,0.409-1.387,0.156-2.049-0.25-0.663-0.567-0.789-0.219-1.105,0.345-0.315,0.66-1.072,0.691-1.608,0.032-0.538,0.032-0.662,0.032-0.662s0.723-0.254,0.69-1.357c-0.032-1.105-0.629-1.547-0.976-1.642-0.345-0.094-0.564-0.094-0.564-0.094s-0.063-0.663-0.629-1.545c-0.568-0.884-0.944-1.262-0.944-1.262s0.408-0.313,0.188-1.039c-0.22-0.726-0.724-1.167-1.227-1.327-0.503-0.157-1.037,0-1.037,0s-1.667-1.009-2.453-1.419c-0.787-0.41-0.976-0.504-0.976-0.504s-0.031-0.694-0.314-1.073-0.944-0.537-1.29-0.537-0.723,0.19-0.723,0.19-2.832-0.727-3.995-0.916c-1.164-0.189-1.228-0.284-1.228-0.284s-2.515-1.199-3.489-1.388c-0.976-0.189-1.258-0.283-1.258-0.283s1.018-1.232,1.08-2.651c0.064-1.42-0.879-2.759-1.885-3.358-0.568-0.337-0.873-0.393-1.058-0.509l-0.021-0.977,1.89,0.19,0.156-3.042-1.84,0.233,0.282-1.831-3.856-0.044,0.282,1.83-1.855-0.127,0.157,2.998,1.951-0.252-0.189,1.134s-0.714,0.121-1.319,0.567c-1.006,0.6-1.857,1.768-1.794,3.188,0.062,1.419,0.911,2.682,0.911,2.682s-0.251,0.063-1.226,0.251c-0.975,0.189-3.492,1.388-3.492,1.388s-0.063,0.094-1.227,0.284c-1.163,0.189-3.994,0.916-3.994,0.916s-0.377-0.19-0.724-0.19c-0.346,0-1.006,0.158-1.289,0.537-0.283,0.378-0.314,1.073-0.314,1.073s-0.189,0.095-0.976,0.504c-0.787,0.41-2.453,1.419-2.453,1.419s-0.536-0.157-1.039,0c-0.503,0.159-1.006,0.601-1.226,1.327s0.188,1.039,0.188,1.039-0.378,0.378-0.944,1.262c-0.565,0.882-0.628,1.545-0.628,1.545s-0.221,0-0.566,0.094c-0.346,0.095-0.944,0.537-0.975,1.642-0.032,1.103,0.692,1.357,0.692,1.357s0,0.125,0.031,0.662c0.032,0.537,0.347,1.293,0.692,1.608,0.346,0.316,0.032,0.442-0.22,1.105-0.251,0.662-0.189,1.482,0.157,2.049,0.346,0.568,1.287,0.877,1.287,0.877s0,0.231,0.508,0.601c0.508,0.37,1.756,0.139,1.756,0.139s-0.23-0.185,1.895,0.924c2.125,1.109,1.94,2.726,1.94,2.726s-1.294,0.938-1.213,1.475c0.081,0.538-0.054,0.754,0.592,0.996,0.646,0.243,1.265,0.431,1.265,0.431s0.483,1.526,0.729,2.354c-0.809,0.544-2.223,1.405-3.637,1.811-2.161,0.62-4.279,0.132-4.279,0.132-2.697-1.509-6.139-2.682-9.26-2.034-2.558,0.531-3.573,3.405-3.573,3.405s-0.705-0.309-2.689-0.53c-1.984-0.222-3.881,0.663-4.764,2.034-0.882,1.372-1.19,3.495-0.661,5.352,0.529,1.859,1.103,0.575,1.764-0.221,0.662-0.796,1.853-1.636,3.881-1.017,1.97,0.601,3.981,2.663,4.096,2.781-0.039-0.033-0.337-0.208-2.553-0.525-2.469-0.354-4.63,0.266-6.173,0.752s-2.822,0.531-4.454-0.53c-1.632-1.063-1.588-3.185-1.588-3.981s-0.882-0.443-1.19,0-2.073,3.053-0.706,5.883c1.367,2.83,4.233,3.273,6.923,3.141,2.69-0.134,6.218-1.372,6.218-1.372s-0.043,0.443,1.853,2.256c1.896,1.813,4.277,2.3,6.042,2.3s3.307-1.063,3.307-1.063c1.139,1.017,1.831,2.869,2.029,4.335,0.132,0.974,0.045,1.858,0.927,1.858,0.881,0,2.293-1.549,2.293-1.549s0.088,0.443,0.264,1.549c0.176,1.106-0.088,4.024-0.353,4.866-0.264,0.84-0.926,1.725-0.043,1.901,0.882,0.177,1.852-0.173,2.337-0.221,0,2.12-0.425,3.522-1.72,5.176-0.114,0.146-0.204,0.281-0.272,0.407-0.482-0.211-0.964-0.434-1.446-0.671l-9.731,11.433s3.498,4.025,3.309,13.059v-0.063c-0.177-0.017-0.413-0.045-0.708-0.09-0.777-0.121-1.134-0.598-1.97-1.436-0.835-0.836-0.895-2.03-1.73-2.509s-3.163-0.299-5.013-0.358c-1.851-0.061-3.998-0.717-4.357-2.57-0.357-1.854,0.061-2.688,2.447-4.243,2.387-1.554,4.177-3.287,4.297-6.694,0.119-3.406-2.088-5.618-6.027-10.159-3.939-4.542-5.729-8.666-6.266-9.742s-0.776-0.657-1.194,0.12c-0.418,0.776-1.014,2.211-1.014,2.211s-1.313-0.777-4.535-6.634c-3.223-5.857-4.178-10.458-4.655-12.91-0.259-1.649-0.908-0.838-1.396-0.401-2.62-7.459-2.475-16.662-3.2-23.803,0,0-2.604,2.545-4.104,7.523-1.377,4.57-1.325,9.94-0.886,14.659,0.417,4.498,1.327,7.153,1.769,8.358,0.656,1.793-0.298,0.717-0.298,0.717s-2.268-3.944-3.819-11.415c-1.552-7.47-1.373-12.67-1.373-12.67s-0.909,0.745-1.96,2.847c-1.05,2.101-2.1,6.303-1.733,13.92,0.368,7.617,3.205,15.653,4.676,18.385,1.471,2.731,0.105,1.103-0.421,0.315-0.525-0.788-3.151-4.885-4.465-8.511-1.313-3.624-3.729-11.083-3.887-12.239-0.158-1.155-0.63-0.42-1.104,0.58-0.473,0.998-1.523,4.359-1.471,6.774,0.053,2.416,0.473,6.619,2.049,10.822,1.576,4.202,4.622,8.457,6.093,10.294,1.471,1.84,0.315,0.894-0.368,0.369s0.053,0.104-2.994-3.152-6.829-10.821-7.354-11.975c-0.526-1.157-1.051,0.104-1.104,0.734-0.052,0.631-0.473,4.307,1.839,10.558,2.311,6.251,7.984,11.085,10.979,13.132,2.994,2.049,0.84,1.051-0.683,0.157-1.523-0.892-4.57-2.993-6.461-4.57-1.891-1.575-5.253-5.726-6.198-6.461-0.946-0.736-1.155-0.946-1.103,1.996s2.575,7.732,5.768,10.93c3.192,3.196,7.334,4.651,8.602,5.152,1.267,0.502,0.211,0.264-1.109-0.104-1.318-0.37-3.561-1.006-5.989-2.353-2.428-1.349-5.989-4.15-7.177-5.073-1.188-0.925-1.029,0.343-0.66,1.955,0.37,1.612,1.267,4.598,5.857,8.323,4.591,3.726,11.108,5.629,12.981,6.158,1.874,0.527,0.554,0.527,0.554,0.527s-0.739-0.104-4.538-0.952c-3.799-0.845-9.552-3.856-11.109-4.834-1.557-0.979-1.793-1.348-1.583,0.713,0.212,2.06,2.402,6.474,5.911,8.535s9.842,3.119,11.478,3.197c1.636,0.08,1.214,0.317,0.475,0.369-0.739,0.053-2.56,0.053-5.541-0.289-2.444-0.282-6.074-1.469-7.305-1.889-0.138-0.526-0.265-1.036-0.323-1.35-0.145-0.785-0.551-0.669-0.813-0.493-0.262,0.172-0.407,0.318-1.276,0.755-0.872,0.438-0.901-0.086-0.93-0.348-0.029-0.264-0.203-1.399-0.232-1.979-0.029-0.584-0.349-0.613-0.754-0.438-0.407,0.176-2.352,0.99-3.077,1.312-0.726,0.319-0.058,0.901,0.319,1.599,0.377,0.701,0.958,1.719,0.958,1.719s-1.829,0.495-2.41,0.641c-0.58,0.146-0.406,0.554-0.261,0.962,0.146,0.406,1.045,2.445,1.277,3.027s0.755,0.233,0.755,0.233l1.828-1.077,0.638,2.444c-0.031,0.039-0.845,0.194-1.77,0.843-0.924,0.648-0.693,1.483,0.416,1.808,1.108,0.324,2.403,0.881,3.835,3.476,1.432,2.597,1.802,7.276,2.68,14.647,0.878,7.367,5.591,11.122,6.238,11.586s0.277,0.834,0.277,0.834-0.647,0.929-0.369,2.365c0.277,1.435,1.524,2.271,2.171,2.502,0.646,0.23,0.462,0.88,0.462,0.88s-0.324,1.575,0,4.45c0.323,2.873,2.68,6.117,3.327,6.674,0.646,0.555,0.693,0.834,0.601,1.066-0.092,0.231-0.509,0.047-1.294,0.648-0.786,0.603-1.664,1.437-2.217,2.456-0.555,1.021-0.37,1.623-0.186,3.014,0.185,1.391,2.218,2.642,2.218,2.642s-0.37,0.093-0.461,1.112c-0.092,1.02,0.646,2.178,1.571,2.919,0.924,0.742,2.68,1.113,2.68,1.113s0.139,0.88,0.231,1.482c0.092,0.604,1.248,1.204,1.987,1.622,0.739,0.417,2.171,0.186,2.772-0.093,0.6-0.277,1.016,0.047,1.385,0.648,0.371,0.604,0.232,2.92,0.232,3.848,0,0.927-0.555,1.9-0.232,2.364,0.324,0.463,1.202,0.138,2.08-0.371,0.878-0.511,1.109-0.139,1.895,0.371,0.786,0.509,2.033,0.974,2.357,0.927,0.323-0.047,0.185-0.881,0.185-1.576s0.125-2.268,0.448-2.5c0.153-0.11,1.513-0.211,2.555-0.652,0.485-0.204,1.109-0.416,1.155-0.88,0.046-0.463-0.647-0.463-2.171-1.251-1.525-0.787-1.802-1.253-2.772-1.901-0.971-0.648-0.508-0.88-0.508-1.158,0-0.276,0.461-0.602,0.646-0.973s0.092-1.204,0.092-1.204,0.786-0.788,1.155-1.206c0.37-0.416,0.832-1.067,1.34-1.483s1.293-2.409,1.802-3.059c0.508-0.648,1.664-1.344,2.356-2.225,0.693-0.881,2.542-2.317,3.605-3.013,1.063-0.695,3.927-2.04,3.927-2.04s-0.046,1.715,0.693,2.549c0.739,0.836,1.709-0.647,4.99-2.966,3.281-2.317,5.776-3.151,5.776-3.151s0.693,1.065,1.57,2.178c0.878,1.113,1.664-0.047,5.684-5.607,3.171-4.388,7.348-8.399,8.97-9.898,0.299,0.133,0.595,0.266,0.89,0.402-0.076,0.214-0.16,0.456-0.244,0.721-0.369,1.152-0.967,1.89-1.75,3.5-0.783,1.611-1.979,1.979-3.361,4.145-1.381,2.164-1.565,3.636-1.704,5.847-0.138,2.21,1.105,2.671,1.105,2.671s-2.026,1.979-2.625,3.453c-0.598,1.473-0.921,4.467-0.921,4.467s-0.323,0.137-1.059,1.657c-0.737,1.521-2.073,1.749-4.006,3.684-1.935,1.934-4.098,2.763-5.111,3.359-1.013,0.601-0.737,1.198-0.46,1.981,0.275,0.782,1.657,1.565,3.269,2.164,1.612,0.598,2.164,0.368,3.27,0.322,1.105-0.045,0.23,0.829-0.23,1.288-0.46,0.462-1.059,2.072-0.967,3.868,0.092,1.797,1.428,1.381,3.086,1.105,1.657-0.275,3.591-1.105,3.591-1.105s0,0-0.184,0.508c-0.184,0.506-0.276,0.873-0.276,2.303,0,1.427,0.23,2.117,0.645,2.484,0.415,0.369,1.244-0.413,1.842-0.597,0.599-0.187,1.612-0.783,3.085-1.105,1.473-0.323,2.025-0.967,2.025-0.967s-0.368,0.459-0.46,1.473c-0.093,1.014-0.046,2.532,0.185,3.408,0.229,0.873,0.874,1.933,1.887,2.854,1.013,0.922,1.243,0.507,1.979-0.644,0.737-1.152,2.256-2.626,2.256-2.626s0.092,0.369,1.105,3.638c1.013,3.27,4.328,5.986,4.328,5.986s3.315-2.717,4.328-5.986c1.013-3.269,1.104-3.638,1.104-3.638s1.521,1.474,2.257,2.626c0.737,1.15,0.968,1.565,1.98,0.644,1.013-0.921,1.657-1.98,1.888-2.854,0.23-0.876,0.276-2.395,0.186-3.408-0.094-1.014-0.462-1.473-0.462-1.473s0.553,0.644,2.026,0.967c1.473,0.322,2.486,0.919,3.084,1.105,0.599,0.184,1.429,0.966,1.843,0.597,0.414-0.367,0.645-1.058,0.645-2.484,0-1.43-0.092-1.797-0.276-2.303-0.185-0.508-0.185-0.508-0.185-0.508s1.935,0.83,3.592,1.105,2.992,0.691,3.086-1.105c0.091-1.796-0.508-3.406-0.968-3.868-0.461-0.459-1.335-1.333-0.23-1.288,1.104,0.046,1.657,0.275,3.269-0.322,1.611-0.599,2.993-1.382,3.27-2.164,0.276-0.783,0.553-1.381-0.46-1.981-1.013-0.597-3.178-1.426-5.111-3.359-1.933-1.935-3.27-2.163-4.007-3.684-0.735-1.521-1.057-1.657-1.057-1.657s-0.324-2.994-0.922-4.467c-0.599-1.475-2.625-3.453-2.625-3.453s1.244-0.461,1.105-2.671c-0.138-2.211-0.321-3.683-1.703-5.847-1.382-2.165-2.58-2.533-3.363-4.145-0.782-1.61-1.381-2.348-1.749-3.5-0.073-0.232-0.153-0.464-0.235-0.696,0.395-0.176,0.792-0.351,1.188-0.521,1.611,1.485,5.806,5.51,8.987,9.911,4.021,5.563,4.807,6.722,5.685,5.608,0.877-1.111,1.57-2.177,1.57-2.177s2.495,0.833,5.776,3.15c3.28,2.318,4.251,3.801,4.989,2.967,0.391-0.439,0.478-1.168,0.525-1.727,0,0,1.885,0.551,4.044,1.307,1.295,0.454,2.733,1.026,3.801,1.477,2.842,1.203,3.15,1.822,5.411,3.608s5.48,1.614,8.529,0.686c3.047-0.926,11.167-3.605,14.42-5.014,3.254-1.411,5.584-2.646,5.927-3.3,0.342-0.652,0.718-2.474,0.718-3.125,0-0.653-0.718-1.614-0.959-1.787-0.238-0.173-0.135-0.688-0.068-1.099,0.068-0.413-0.136-1.649-0.649-2.2-0.514-0.55-0.445-0.754-0.377-2.337,0.145-3.351-2.247-7.576-5.636-8.921,0,0-0.091-0.39-0.366-0.62-0.272-0.229-0.73-0.435-0.73-0.435s0.067-1.927,0.045-2.341c-0.022-0.413,0.16-0.365,0.391-0.252,0.228,0.114,0.593,0.574,1.142,0.712,0.549,0.137,0.892-0.254,1.007-0.872,0.113-0.619,0.571-1.858,0.777-2.478,0.207-0.618-0.047-0.711-0.298-0.779-0.251-0.07-1.074-0.16-1.464-0.254-0.388-0.091-0.388-0.114-0.297-0.32,0.093-0.205,0.229-0.526,0.731-1.308,0.504-0.78,0.047-0.803-0.435-0.962-0.48-0.161-2.651-0.826-3.246-0.919-0.596-0.092-0.733,0.413-0.733,0.665,0,0.254,0.023,1.354,0.046,1.767s-0.365,0.298-0.594,0.184c-0.23-0.114-0.755-0.437-1.166-0.758-0.412-0.32-0.709-0.022-0.87,0.437-0.16,0.458-0.662,2.341-0.822,2.891-0.16,0.551-0.115,0.986,0.114,1.077,0.229,0.093,1.303,0,1.944,0,0.639,0,0.273,0.368,0.273,0.368s-0.686,1.124-0.915,1.559c-0.228,0.437-0.617,0.506-1.143,0.506s-1.408-0.007-1.408-0.007-3.514,0.132-6.101,2.056c-2.586,1.923-3.315,3.514-3.713,4.441-0.398,0.93-0.861,0.729-1.261,1.062-0.397,0.332-1.524,1.526-1.524,2.256,0,0.729,0.265,1.126-0.861,1.855-1.129,0.73-2.057,3.913-0.531,5.571,1.525,1.656,2.122,3.313,2.587,4.11,0.462,0.796,0,1.127-0.399,1.127-0.397,0-1.228-0.676-1.922-1.194-0.694-0.517-4.197-3.253-5.702-4.375-1.507-1.124-0.398-0.995-0.398-0.995s0.383,0.035,1.262-0.335c0.877-0.371,1.017-0.833,0.137-1.112-0.877-0.277-2.587-1.251-3.048-1.715-0.463-0.463-0.693-0.973,0.185-1.437,0.877-0.463,2.818-1.715,1.294-2.132-1.526-0.419-3.328-0.741-4.807-1.159-1.479-0.417-1.618-0.834-1.618-0.834l0.972-1.391s0.785-1.111-0.139-1.251-3.142-0.417-5.175-1.299c-4.061-1.759-6.605-4.742-7.548-8.383l0.067-0.088c0.759,1.501,2.525,4.306,5.188,4.393,3.64,0.12,4.057-1.017,3.222-2.212s-1.79-2.271-2.028-2.629c-0.24-0.359-0.3-0.838,0.655,0.06s2.773,3.944,8.264,3.586c5.489-0.358,5.462-1.435,5.462-1.733,0-1.054-1.118-1.221-1.777-1.882-0.344-0.345-0.553-0.846,0.555-0.423s3.824,0.924,7.52,0.131c1.458-0.311,5.324-1.999,5.698-3.962,0,0-2.454-0.134-4.168-0.873-1.716-0.741-2.745-1.347-0.924-0.977,1.821,0.369,5.357,1.108,8.47,0.053,1.819-0.618,4.17-2.09,4.169-4.783,0,0-3.377-0.713-4.617-1.163-1.24-0.449-1.636-0.792-1.636-0.792s4.826,1.531,9.208-0.688c4.38-2.219,4.564-5.257,4.564-5.971s-0.105-0.926-0.105-0.926-3.984,0.979-6.965,0.952c-2.982-0.026-3.906-0.291-3.906-0.291s8.339-0.238,12.533-2.801c4.195-2.563,4.434-7.611,4.434-7.611s-4.751,1.691-7.731,2.036c-2.981,0.342-4.803,0.342-5.541,0.289-0.739-0.052-1.16-0.289,0.475-0.369,1.638-0.078,7.968-1.137,11.478-3.197,3.51-2.062,5.699-6.476,5.911-8.535,0.211-2.061-0.026-1.691-1.584-0.713-1.557,0.978-7.308,3.989-11.107,4.834-3.799,0.848-4.538,0.952-4.538,0.952s-1.46-0.07,0.42-0.59zm-150.1,9.58c-0.406,0.233-1.683,0.96-1.683,0.96s-0.668-1.368-0.842-1.775c-0.174-0.408-0.087-0.583,0.144-0.583,0.233,0,0.93-0.203,1.481-0.261,0.079-0.009,0.151-0.021,0.215-0.036,0.184,0.525,0.426,1.094,0.744,1.665-0.02,0.02-0.04,0.03-0.06,0.04zm51.18,29.97c-1.017,1.902-3.789,3.895-5.822,4.775s-4.251,1.159-5.175,1.297c-0.924,0.139-0.139,1.252-0.139,1.252l0.97,1.392s-0.138,0.416-1.617,0.834c-1.479,0.416-3.28,0.74-4.805,1.158-1.525,0.416,0.416,1.668,1.293,2.133,0.878,0.462,0.647,0.973,0.185,1.436-0.462,0.464-2.171,1.437-3.049,1.715s-0.74,0.743,0.138,1.113c0.878,0.369,3.281,0.833,3.281,0.833s-0.046,0.093-1.524,1.206c-1.479,1.112-4.067,1.854-5.776,1.946-1.71,0.092-4.413,0.204-7.841,0.046-3.427-0.156-3.821-0.235-3.821-0.235s-0.118-1.144-0.355-2.838c-0.236-1.693-1.26-4.097-2.048-5.199-0.789-1.104-2.442-3.31-2.442-3.31s0.039-0.473,0.157-1.024,0.039-1.143-0.361-2.184c-0.401-1.042-2.403-2.563-2.403-2.563s-0.081-1.121-0.081-2.163c0-1.041-0.72-5.126-1.362-7.048-0.64-1.922-3.764-6.968-5.206-9.371-1.442-2.402-2.298-5.964-2.734-8.729-0.436-2.766-0.261-3.668-0.116-4.396,0.064-0.319,0.2-0.609,0.328-0.867,0.592,0.765,1.35,1.489,2.318,2.082,4.195,2.563,12.533,2.801,12.533,2.801s-0.924,0.265-3.905,0.291c-2.981,0.026-6.965-0.952-6.965-0.952s-0.106,0.212-0.106,0.926,0.186,3.752,4.565,5.971c4.379,2.22,9.208,0.688,9.208,0.688s-0.396,0.343-1.636,0.792c-1.24,0.45-4.617,1.163-4.617,1.163,0,2.693,2.351,4.165,4.168,4.783,3.114,1.056,6.649,0.316,8.471-0.053,1.82-0.37,0.792,0.235-0.924,0.977-1.714,0.739-4.168,0.873-4.168,0.873,0.376,1.963,4.242,3.651,5.699,3.962,3.694,0.793,6.411,0.292,7.52-0.131s0.897,0.078,0.554,0.423c-0.659,0.661-1.777,0.828-1.777,1.882,0,0.299-0.028,1.375,5.462,1.733s7.308-2.688,8.263-3.586c0.955-0.897,0.895-0.419,0.656-0.06-0.238,0.357-1.193,1.434-2.028,2.629-0.836,1.195-0.418,2.332,3.222,2.212,2.681-0.088,4.455-2.932,5.204-4.424l0.05,0.069c0.049,0.067,0.099,0.133,0.147,0.196-0.34,0.88-0.93,2.32-1.58,3.54zm44.28-118.76c-0.496-0.945-0.759-1.39-0.759-1.39s2.068,0.97,3.299,2.361c1.23,1.393,1.203,2.127,1.387,2.811,0.184,0.683,0,1.942-0.183,3.124-0.184,1.181-0.184,1.891,0.053,2.311,0.235,0.42,0.445,0.63,0.445,0.63s-0.918,0.236-1.781,0.578c-0.864,0.342-1.989,0.656-2.617,0.131-0.629-0.525-0.785-0.893-0.392-1.234,0.392-0.342,1.857-0.762,2.041-3.282,0.18-2.521-0.99-5.094-1.49-6.04zm-11.28,6.857c0.472-1.197,0.666-2.34,0.305-4.792-0.303-2.061-0.703-3.826-0.805-6.047,0,0,1.528,0.335,3.723,2.341,2.193,2.006,2.695,4.068,2.695,5.072,0,1.002-0.529,2.229-0.612,3.205-0.083,0.975,0.277,1.839,0.277,1.839s-0.806,0.333-1.527,0.834c-0.722,0.502-1.222,0.809-2.333,0.753-1.112-0.056-1.779-0.557-2.418-0.892s-1.054-0.39-1.054-0.39,1.27-0.724,1.74-1.923zm-10.7-8.498c2.195-2.005,3.722-2.341,3.722-2.341-0.101,2.221-0.501,3.986-0.806,6.047-0.36,2.452-0.166,3.595,0.306,4.792,0.473,1.199,1.75,1.923,1.75,1.923s-0.416,0.056-1.056,0.39c-0.638,0.334-1.305,0.836-2.417,0.892-1.111,0.055-1.611-0.251-2.333-0.753-0.723-0.501-1.528-0.834-1.528-0.834s0.361-0.864,0.277-1.839c-0.083-0.975-0.61-2.202-0.61-3.205,0.01-1.004,0.51-3.066,2.7-5.072zm-7.91,12.197c-0.629,0.525-1.754,0.211-2.619-0.131-0.864-0.342-1.78-0.578-1.78-0.578s0.209-0.209,0.445-0.63c0.236-0.419,0.236-1.129,0.052-2.311-0.183-1.182-0.367-2.441-0.183-3.124,0.183-0.684,0.157-1.418,1.387-2.811,1.231-1.391,3.299-2.361,3.299-2.361s-0.262,0.445-0.759,1.39c-0.498,0.946-1.676,3.519-1.492,6.041,0.184,2.52,1.65,2.939,2.042,3.282,0.39,0.34,0.23,0.708-0.4,1.233zm29.24,21.078c-2.162,1.195-3.396,0.929-3.308,1.813,0.089,0.885,2.027,1.549,2.027,1.549s-1.984,2.123-3.528,3.097c-1.542,0.973-3.353,1.592-3.353,1.592s-0.616,0.089-0.264,1.062c0.354,0.973,0.971,1.636,1.455,1.902,0.485,0.265,0.751,0.354,0.751,0.354s-2.69,2.875-3.881,3.804c-1.191,0.929-1.853,1.238-2.822,1.637-0.971,0.398-0.484,1.99-0.265,2.699,0.22,0.706,1.058,1.68,1.544,1.813,0.483,0.133,0.661,0.486,0.044,1.46-0.462,0.726-2.001,2.657-2.735,3.722l-0.045,0.023c-0.729-1.058-2.289-3.014-2.753-3.745-0.617-0.974-0.441-1.327,0.044-1.46s1.324-1.106,1.544-1.813c0.219-0.709,0.705-2.301-0.267-2.699-0.969-0.399-1.631-0.708-2.821-1.637-1.191-0.929-3.881-3.804-3.881-3.804s0.265-0.089,0.75-0.354c0.486-0.266,1.103-0.929,1.456-1.902,0.352-0.973-0.265-1.062-0.265-1.062s-1.808-0.619-3.352-1.592c-1.542-0.974-3.528-3.097-3.528-3.097s1.94-0.664,2.029-1.549c0.088-0.885-1.147-0.619-3.308-1.813s-2.867-2.698-2.867-2.698,2.514-0.841,3.749-3.362c0.437-0.893,0.542-1.708,0.496-2.39l0.095,0.032c4.014,1.307,8.706,1.83,12.9,1.83,4.187,0,8.877-0.526,12.883-1.83l0.095-0.032c-0.047,0.682,0.058,1.497,0.495,2.39,1.235,2.521,3.75,3.362,3.75,3.362s-0.7,1.51-2.86,2.71z'/%3E%3Cg%3E%3Cpath fill='%23D4AF3A' d='M347.47,158.5c0-6.785,3.122-11.076,3.122-11.076l-8.493-9.73c-8.089,3.127-15.5,3.317-22.098-0.04-6.598,3.357-14.009,3.167-22.096,0.04l-8.496,9.73s3.123,4.291,3.123,11.076c0,6.786-1.312,11.82-2.079,15.103-0.766,3.283-1.422,9.411,0.329,13.79,1.75,4.376,3.611,8.207,11.162,11.381s11.491,4.814,14.117,7.004c2.627,2.187,3.94,3.938,3.94,3.938s1.313-1.752,3.94-3.938c2.625-2.189,6.565-3.83,14.117-7.004,7.55-3.174,9.411-7.005,11.162-11.381,1.75-4.379,1.094-10.507,0.328-13.79-0.76-3.28-2.07-8.31-2.07-15.1z'/%3E%3Cpath fill='%23B96B29' d='M344.8,161.3c-1.065-6.481,2.671-12.189,2.671-12.189l-7.271-8.501c-5.602,3.147-13.398,2.724-20.174-0.393-6.774,3.116-14.573,3.54-20.173,0.393l-7.271,8.501s3.736,5.708,2.669,12.189c-1.067,6.48-3.363,16.736-2.789,20.919,0.574,4.184,3.528,9.024,6.563,11.567s7.547,4.677,10.745,5.825c3.2,1.148,6.318,3.363,7.795,4.512,1.476,1.148,2.46,2.134,2.46,2.134s0.985-0.985,2.462-2.134,4.594-3.363,7.792-4.512c3.2-1.148,7.713-3.282,10.747-5.825,3.036-2.543,5.989-7.384,6.563-11.567,0.57-4.2-1.73-14.45-2.8-20.93z'/%3E%3Cpath fill='%231D5E91' d='M344.1,162.07c-1.053-6.998,2.104-12.635,2.104-12.635l-6.563-7.308c-5.547,2.849-12.289,2.113-19.634-0.434-7.344,2.547-14.085,3.282-19.633,0.434l-6.564,7.308s3.159,5.637,2.106,12.635-2.663,14.924-2.354,19.57c0.021,0.319,0.055,0.644,0.101,0.972h5.978s0.346-0.403,1.012-0.687c0.664-0.287,0.854-0.478,0.854-0.478s0.127-1.207,0.855-1.461c0.728-0.255,1.045-0.255,1.33-0.255s0.507-0.063,0.855-0.413c0.349-0.349,1.297-1.206,1.709-2.413s0.666-1.684,0.666-2.478c0-0.793,0.285-2.063,0.285-2.063s-0.159-0.381-0.76-0.158c-0.602,0.222-0.697-0.381-0.759-0.985-0.064-0.604-0.032-1.841,0.316-2.413s0.475-0.763,0.475-0.763l-0.254-0.951s-3.799,0.761-4.463-2.192c-0.665-2.953-0.792-4.384-0.887-4.699-0.095-0.319-0.19-0.479-0.697-0.445-0.507,0.031-1.583-0.317-2.343-1.843-0.76-1.524-0.823-2.159-0.602-2.762,0.222-0.604,0.634-0.381,0.76-0.191,0.126,0.191,1.14,1.652,1.552,1.238,0.411-0.413,0.19-0.413-0.38-1.556s-0.38-1.523-0.317-2.097c0.063-0.571-0.189-1.334-0.189-1.651,0-0.316,0.348-0.571,0.696-0.413,0.349,0.159,0.665,0.413,0.823,0.604,0.158,0.19,0.222,0.478,0.539,0.287s0.126-1.24,0.126-1.588c0-0.35,0.412-0.604,0.919-0.318,0.506,0.286,0.759,0.825,0.759,1.206,0,0.382,0.032,0.731,0.222,0.731s0.412-0.572,0.443-0.954c0.031-0.379,0.253-0.952,0.602-0.475,0.349,0.475,0.475,1.176,0.349,1.905-0.127,0.729,0.126,0.35-0.127,1.62-0.252,1.271-0.379,1.842-0.348,2.795,0.032,0.952,0.063,1.492,0.538,2.668,0.475,1.175,0.854,2.539,1.741,2.571,0.887,0.031,1.14,0.031,1.14,0.031s0.981-1.905,1.742-2.35c0.76-0.444,1.836-0.509,2.596-0.604,0.76-0.096,1.076-0.318,1.076-0.509s-0.253-0.253-1.171-0.381c-0.917-0.126-1.677-0.35-1.708-1.048-0.032-0.698,0.157-1.302-0.444-1.333-0.601-0.032-2.089-0.511-2.627-1.493-0.538-0.985-0.412-1.208-0.348-1.746,0.063-0.54,0.759-1.621,1.203-0.604s0.729,1.143,1.108,1.365c0.38,0.224,0.886,0.287,0.634-0.413-0.254-0.698-0.412-1.142-0.349-1.649,0.063-0.51,0.412-0.73,0.824-0.826,0.411-0.096,1.646-0.478,2.279-0.604,0.632-0.126,0.665-0.189,0.665-0.189s0.063-0.445,0.886-0.699c0.823-0.254,1.361-0.285,1.963-0.285,0.601,0,1.044,0.095,1.836-0.287,0.792-0.38,1.424-0.443,1.931-0.412,0.506,0.032,0.887,0.223,1.267,0.476,0.38,0.255,0.253,0.604,0.253,0.953,0,0.35,0.063,0.54,0.601,0.54,0.54,0,1.015,0,1.521,0.19,0.508,0.191,1.204,0.476,0.76,1.016-0.442,0.541-0.473,1.144-0.76,1.112-0.283-0.032-0.252,0.286-0.38,0.477-0.126,0.189-0.221,0.349,0.097,0.54,0.314,0.19,0.347,0.381,0.791,0.793,0.442,0.413,1.107,0.858,0.442,1.525-0.663,0.666-1.835,1.207-1.835,1.207s-0.666,0.316,0.094,0.763c0.76,0.443,1.109,1.365,1.394,1.523,0.284,0.159,0.57,0.413,0.76,0.508,0.189,0.096,0.158,0.73,0.158,0.73s-0.411,0.287-0.981,0.509c-0.57,0.223-1.172,0.477-1.709,0.477-0.539,0-0.824,0-0.602,0.508,0.221,0.507,0.602,1.049,0.696,1.333,0.095,0.286,0.222,0.795,0.222,0.795s0.885,0.189,1.678,0.189c0.791,0,1.14,0.032,2.881-0.158,1.741-0.189,2.249-0.254,3.927-0.064,1.679,0.19,1.93,0.128,2.374,0.286,0.443,0.159,0.886,0.383,0.886,0.383s2.375-0.033,3.673-0.318c1.298-0.286,1.616-1.113,1.427-1.556-0.19-0.445-0.16-1.111-2.439-1.43-2.278-0.319-3.197-0.191-5.003-0.541-1.804-0.349-4.623-1.27-5.128-3.524-0.508-2.255,1.329-3.207,2.248-3.651,0.918-0.446,2.912-1.144,3.831-1.524,0.917-0.382,2.597-0.762,4.369-0.509,1.772,0.255,2.785,0.73,3.482,0.318,0.696-0.413,1.267-0.096,1.14,0.539-0.125,0.635-0.823,1.938-2.818,2.541-1.994,0.604-4.399,0.667-5.698,0.318-1.299-0.351-2.279-0.858-3.071-0.573-0.791,0.286-1.678,1.271-0.824,2.445,0.857,1.177,5.226,1.525,6.396,1.651,1.172,0.129,5.509-0.19,6.744,1.969,1.234,2.161,0.252,4.573-1.203,5.114-1.456,0.539-2.691,0.89-3.799,1.048s-1.108,0.158-1.108,0.158,0.506,1.144,0.506,1.621c0,0.476-0.063,1.365,0.476,1.713,0.538,0.351,1.299,0.604,2.217,0.509,0.918-0.094,2.026,0.54,2.09,1.366,0.062,0.825,0.316,1.968,0.41,3.62,0.096,1.651,0,3.017,0,3.017s-0.063,0.636-0.284,1.238c-0.222,0.604-1.362,2.943-1.362,2.943h6.375c0.046-0.328,0.08-0.652,0.102-0.972,0.26-4.71-1.35-12.63-2.4-19.63z'/%3E%3Cpath fill='%236D8C3E' d='M294.42,185.72c1.25,3.571,3.826,7.187,7.748,9.549,5.45,3.282,7.804,2.849,12.944,6.193,5.141,3.344,4.831,3.902,4.893,3.902s-0.248-0.559,4.894-3.902c5.14-3.345,7.493-2.911,12.943-6.193,3.923-2.362,6.498-5.978,7.747-9.549h-51.158z'/%3E%3Cpath fill='%23D4AF3A' d='M298.88,158.13c0.585,0.615,1.017,0.802,1.91,0.71,0.894-0.095,1.109,0.555,1.263,1.263,0.154,0.709,0.154,2.372,0.801,3.912,0.646,1.54,2.803,1.633,2.803,1.633,0.06-0.743,0.319-1.742,0.647-2.557,0.058-0.146,0.338-0.833-0.432-0.833s-0.739-0.308-1.201-1.047c-0.461-0.739-1.355-2.71-1.57-3.974-0.215-1.263,0.185-3.142,0.4-3.819,0.216-0.678,0.247-1.14,0-1.263-0.247-0.124-0.739,0-0.739,0s0.185,0.585-0.032,0.677c-0.215,0.094-0.4-0.308-0.553-0.738-0.155-0.432-0.339-0.37-0.647-0.34-0.308,0.031-0.308,0.309-0.092,0.617,0.215,0.307,0.092,0.861,0.092,0.861s-0.678-0.492-0.955-0.616c-0.277-0.122-0.924,0.124-0.986,0.494-0.061,0.368,0.247,1.323,0.832,1.816,0.585,0.494,0.585,1.51,0.4,1.973-0.184,0.461-1.047,0.399-1.232,0.185-0.185-0.216-0.554-0.277-0.801,0-0.25,0.28-0.5,0.44,0.09,1.05z'/%3E%3Cpath fill='%23D4AF3A' d='M298.54,156.5s-0.339-0.276-0.462-0.43c-0.123-0.156-0.37-0.495-0.37-0.495s-0.062,0.154-0.062,0.524,0.4,0.771,0.4,0.771l0.49-0.37z'/%3E%3Cpath fill='%23D4AF3A' d='M299.83,152.22c0.278-0.123,0.493-0.186,0.278-0.493-0.216-0.308-0.401-0.647-0.617-0.709-0.216-0.061-0.4-0.03-0.4-0.03s0.246,0.555,0.307,0.894c0.06,0.34,0.16,0.46,0.43,0.34z'/%3E%3Cpath fill='%23D4AF3A' d='M301.44,150.92c-0.031,0.277,0.031,0.401,0.277,0.277,0.247-0.124,0.339-0.462,0.215-0.709-0.123-0.246-0.4-0.43-0.4-0.43l-0.185-0.125c-0.02,0,0.11,0.71,0.08,0.98z'/%3E%3Cpath fill='%23D4AF3A' d='M303.74,151.29c0.03-0.308-0.093-0.646-0.093-0.646s0,0.369-0.154,0.586c-0.154,0.215-0.123,0.154,0.031,0.339,0.15,0.19,0.18,0.03,0.21-0.28z'/%3E%3Cpath fill='%23D4AF3A' d='M307.36,166.95c0.453,1.05,1.604-0.595,2.65-1.925,1.045-1.329,1.011-0.313,0.871,0.77-0.139,1.085,0.279,2.24,0.698,2.975,0.418,0.732,0.767,0.313,0.94-0.212,0.175-0.522,0.314-1.607,0.663-2.132s0.697-0.07,0.732,0.384,0.592,1.47,1.115,2.063c0.522,0.596,0.767-0.209,0.941-0.943s0.383-1.854,0.523-2.31c0.139-0.454,0.627-0.069,0.627-0.069s0.35,0.35,1.047,1.014c0.695,0.666,0.766-0.385,0.836-0.907,0.069-0.526-0.105-1.68,0.104-1.856,0.209-0.174,0.801,0.246,1.709,0.702,0.906,0.453,0.872-0.421,0.768-0.911-0.106-0.488-0.627-1.608-1.36-2.237-0.732-0.63-0.836-1.364-0.592-1.68,0.243-0.313,1.115-0.035,1.672-0.104,0.559-0.07,0.838-0.139,1.256-0.208,0.418-0.071,0.418-0.491,0.418-0.491s-0.313-0.524-0.906-1.048c-0.594-0.526-0.94-0.944-1.673-1.12-0.733-0.175-1.743,0-1.743,0s0,0-0.105-0.21c-0.104-0.209-0.313-0.209-0.453,0-0.14,0.21-0.488,0.49-0.768,0.734-0.278,0.245-0.453,0.385-0.627,0.279-0.175-0.104,0.139-0.35,0.139-0.35s0.384-0.278,0.733-0.979c0.348-0.7,0.453-1.365,0.174-1.679-0.279-0.316-1.046,0-1.464,0-0.419,0-0.663,0.069-0.697-0.14-0.036-0.21,0.418-0.104,0.941-0.176,0.524-0.069,0.837-0.699,1.011-1.224s0.314-0.455,0.628-0.14c0.313,0.315,0.594,0.245,0.662,0.034,0.068-0.21,0.349-0.733,0.697-1.259,0.349-0.524,0.558-1.258,0.174-1.747-0.384-0.49-1.325-0.422-1.708-0.104-0.383,0.313-0.627,0.628-0.731,1.397-0.105,0.77-0.314,0.349-0.314,0.104s-0.314-0.63-0.175-0.944c0.14-0.313,0-0.665,0-0.665s-0.069-0.663-0.802-0.804-1.569,0.035-2.301,0.21-0.593,0.806-0.593,0.806-0.558,0.033-1.151,0.104c-0.592,0.069-1.29,0.313-1.848,0.453-0.557,0.141-0.767,0.21-0.767,0.489,0,0.281,0.105,0.736,0.105,0.736s0.453,0,0.697,0.139c0.244,0.141,0.104,0.385-0.175,0.49-0.278,0.106-0.383,0.14-0.383,0.489,0,0.351,0.14,0.421,0.418,0.421s0.872,0,1.569,0.313c0.698,0.314,0.872,0.943,0.802,1.293-0.07,0.351-1.047,0.805-1.535,0.805s-0.627,0.106-0.627,0.42c0,0.315,0.593,0.281,0.593,0.281s0.592,0.034,1.743,0.173c1.151,0.141,1.325,0.386,1.849,0.84,0.522,0.455,0.139,0.56-0.105,0.699-0.244,0.141-0.628,0.455-1.011,0.596-0.384,0.139-0.628,0.42-0.977,0.488-0.349,0.07-1.221,0.036-2.824,0.666-1.604,0.629-2.162,2.729-2.162,2.729s0.209-0.071,0.941-0.457c0.732-0.384,1.639-0.804,2.476-1.328,0.836-0.523,0.836,0.246,0.418,0.979-0.418,0.734,0.384,0.594,0.628,0.385,0.244-0.211,0.558-0.42,1.359-0.84,0.803-0.419,0.523,0.245,0.523,0.245s-0.244,0.489-0.313,1.645c-0.07,1.154,1.15,0.069,1.708-0.665s0.802,0,0.383,0.84c-0.418,0.84-1.22,1.503-1.673,1.503-0.454,0-0.802-0.489-0.837-0.769s0.14-1.12-0.139-1.329c-0.28-0.209-1.082,0.035-1.674,0.384-0.593,0.35-0.733,0.071-0.872-0.244-0.14-0.315,0.209-0.42,0.07-0.629-0.14-0.211-0.453,0-0.698,0.104-0.244,0.104-0.802,0.42-1.882,0.979-1.082,0.559-1.011,0.873-1.011,1.678s0.2,0.99,0.65,2.04z'/%3E%3Cpath fill='%23D4AF3A' d='M317.82,149.44c0.227-0.144,0.639-0.309,0.639-0.309s0.515-0.123,0.988-0.186c0.473-0.062,0.391-0.33,0.287-0.555-0.102-0.229-0.287-0.31-0.903-0.31-0.619,0-1.011,0.31-1.36,0.452-0.351,0.145-0.762,0.248-0.762,0.248s0.083,0.103,0.309,0.433c0.22,0.35,0.57,0.39,0.79,0.24z'/%3E%3Cpath fill='%23D4AF3A' d='M320.34,151.94c0.247,0,0.515-0.145,0.515-0.145s0.451-0.227,0.865-0.37c0.411-0.145,0.576-0.207,0.822-0.701,0.247-0.494-0.268-0.494-0.987-0.678-0.721-0.188-1.071,0.06-1.152,0.328-0.084,0.268-0.063,0.576-0.351,1.092-0.29,0.51,0.04,0.47,0.29,0.47z'/%3E%3Cpath fill='%23D4AF3A' d='M320.11,152.57c-0.699,0-1.481,1.05-1.77,1.235s-0.124,0.37-0.124,0.37,0.206,0.433,0.287,0.844c0.084,0.413,0.104,1.113,0.104,1.113s0.103,0.042,0.514,0.042c0.413,0,0.659-0.207,1.051-0.495s0.7-0.392,1.256-0.495c0.557-0.102,0.823-0.205,1.44-0.534,0.619-0.329-0.329-0.906-0.987-1.441-0.66-0.51-1.07-0.62-1.77-0.62z'/%3E%3Cpath fill='%23D4AF3A' d='M310.8,154.99c0.554-0.062,0.801-0.338,0.801-0.646s-0.28-0.647-0.986-0.585c-1.735,0.154-3.417-0.468-3.727-2.187,0,0-0.585,1.076,0.493,2.279,1.09,1.2,2.87,1.2,3.43,1.14z'/%3E%3Cpath fill='%23D4AF3A' d='M304.89,182.31c0.088,0.153,0.196,0.248,0.306,0.305h2.658c0.453-0.127,0.456-0.544,0.478-0.832,0.026-0.343,0.289-1.317,0.657-3.084,0.368-1.765,0.999-3.028,1.261-3.74s-0.263-0.948-0.447-1.397c-0.184-0.447-0.473-1.237-0.552-1.632-0.079-0.396-0.709-0.343-1.051-0.317s-0.395,0.58-0.447,1.107c-0.052,0.525-0.289,2.081-0.551,3.425-0.263,1.344-1.787,3.136-2.207,3.53-0.421,0.396-0.762,0.554-1.051,0.554s-0.919,0-1.235,0.185c-0.314,0.185-0.629,0.686-0.656,1.079-0.026,0.396,0.605,0.607,0.605,0.607s0.499-0.29,0.683-0.527c0.184-0.237,0.604-0.29,1.024-0.368,0.42-0.079,0.473,0.078,0.315,0.288-0.16,0.2-0.11,0.25,0.21,0.81z'/%3E%3Cpath fill='%23D4AF3A' d='M300.82,182.17c-0.201,0.071-0.348,0.271-0.439,0.437h1.737c-0.021-0.142-0.068-0.311-0.168-0.437-0.21-0.26-0.77-0.13-1.13,0z'/%3E%3Cpath fill='%23D4AF3A' d='M303.18,182.12c-0.212,0.115-0.468,0.303-0.598,0.489h1.87c0.066-0.174,0.087-0.407-0.142-0.594-0.42-0.35-0.84-0.06-1.13,0.1z'/%3E%3Cpath fill='%23D4AF3A' d='M319.4,181.35c-0.204,0-0.385,0.182-0.679,0.385-0.293,0.204-0.383,0.521-0.428,0.771-0.008,0.044-0.003,0.079,0.011,0.108h0.794c0.031-0.028,0.053-0.064,0.053-0.108,0-0.228,0.09-0.432,0.43-0.726,0.35-0.3,0.03-0.43-0.17-0.43z'/%3E%3Cpath fill='%23D4AF3A' d='M320.96,182.21c0-0.248-0.091-0.475-0.271-0.452s-0.474,0.34-0.722,0.521c-0.138,0.101-0.241,0.235-0.317,0.336h1.174c0.07-0.14,0.14-0.29,0.14-0.41z'/%3E%3Cpath fill='%23D4AF3A' d='M328.18,173.58c0.563-0.408,0.474-0.521,0.495-0.951,0.022-0.431,0.022-0.566-0.203-0.724-0.226-0.16-1.06-0.521-1.85-0.521s-2.281,0.181-2.845,0.565c-0.565,0.386-0.836,1.767-0.836,2.49s0.113,0.838,0.316,0.838,0.542-0.521,0.542-0.521,0.744,0.974,1.196,1.654c0.452,0.679,0.248,0.95,0.047,1.47-0.204,0.521-0.948,1.902-1.535,2.197-0.589,0.295-1.04,0.021-1.739-0.09-0.699-0.114-1.084,0.09-1.49,0.497s-0.021,0.726,0.226,0.726c0.249,0,0.587-0.023,0.858,0.316,0.188,0.235,0.061,0.772-0.034,1.082h3.459c0.59-0.262,0.997-1.072,1.156-1.514,0.182-0.497,0.926-1.153,1.288-1.492,0.36-0.341,0.406-0.567,0.406-1.314s-0.203-1.177-0.476-1.697c-0.271-0.521-0.474-1.269-0.384-1.698,0.06-0.46,0.81-0.93,1.37-1.34z'/%3E%3Cpath fill='%23D4AF3A' d='M322.49,164.95c0.346,0.562,0.174,0.669-0.323,0.776-0.495,0.108-1.033,0.194-1.811,0.13-0.775-0.065-0.755,0.043-0.775,0.432-0.021,0.388-0.088,1.208-0.54,1.811-0.453,0.604-1.014,0.367-1.359,0.13s-0.539-0.174-0.668,0.258-0.367,0.734-0.733,1.38c-0.367,0.647-0.604,0.669-0.863,0.604s-0.496-0.453-0.755-0.475-0.669-0.538-1.057-1.165c-0.388-0.624-0.582,0.064-0.84,0.605-0.26,0.538-0.517,0.928-1.014,0.861-0.496-0.063-1.056-0.991-1.336-1.552-0.281-0.562-0.453-1.1-0.884-1.079-0.431,0.022-1.143,0.928-1.618,1.164-0.475,0.238-0.604,0.152-0.819-0.149-0.215-0.302-0.496,0.108-0.776,0.819-0.28,0.712,0.022,1.314,0.41,1.509,0.388,0.194,1.164-0.367,1.682-0.712,0.517-0.344,0.754-0.258,1.294-0.258,0.539,0,0.496,0.885,0.733,2.177,0.237,1.294,0.992,1.467,0.992,1.467s0.259,0.216,0.841-0.775c0.582-0.992,0.646-1.963,1.208-1.963,0.56,0,0.604,0.129,1.164,0.905,0.561,0.776,1.035,1.358,1.358,0.776,0.323-0.583,0.604-1.445,0.971-1.746,0.366-0.303,0.711-0.389,0.323,0.172-0.389,0.561-0.561,1.164,0.237,0.928s3.838-1.467,5.067-1.703c0,0,1.444-0.237,3.105-0.323,1.66-0.088,2.069-0.195,2.717-0.195,0.646,0,0.668-0.065,0.712-0.496,0.042-0.432-0.302-0.345-1.51-0.345-1.207,0-2.049,0.151-2.89,0.281-0.841,0.129-1.228,0.107-1.079-0.108,0.152-0.216,0.389-0.367,1.36-0.517,0.969-0.151,2.954-0.26,3.989-0.281,1.034-0.021,0.711,0.302,0.624,0.992-0.087,0.689,0.087,1.704,0.152,2.351,0.063,0.646,0.085,0.841,0.646,1.746s2.5,1.467,3.062,1.769c0.561,0.302,0.475,0,0.453-0.54-0.022-0.538,0.431-0.517,0.927-0.237,0.495,0.282,1.315,0.519,1.897,0.67,0.582,0.149,0.668,0.258,0.668,0.56s0.065,0.971,0.131,1.597c0.063,0.625,0.042,0.818-0.217,1.207s-1.358,1.508-1.358,1.508-0.496,0-1.553,0.261c-1.057,0.259-1.381,0.755-1.488,1.186s0.195,0.561,0.238,0.733c0.023,0.095,0.014,0.328,0.001,0.518h0.244c0.089-0.151,0.215-0.349,0.379-0.562,0.368-0.474,1.296-0.582,1.898-0.302,0.396,0.185,0.401,0.599,0.359,0.863h2.415c0.326-0.629,1.099-2.133,1.302-2.589,0.258-0.581,0.409-0.948,0.431-1.746s0.107-3.881-0.043-4.054c-0.151-0.173,0.043-0.69,0-1.553-0.044-0.862,0-1.51-1.596-1.66-1.597-0.151-2.092-0.818-2.631-1.359-0.541-0.538-0.41-1.789-0.84-3.298-0.432-1.509-1.488-1.747-3.364-2.114-1.877-0.365-3.257-0.409-4.658-0.279s-3.147,0.324-4.118,0.236c-0.95-0.12-0.8,0.16-0.45,0.72z'/%3E%3Cpath fill='%23D4AF3A' d='M331.55,182.27c-0.164,0.106-0.273,0.232-0.346,0.342h1.63c0.008-0.14-0.015-0.297-0.16-0.472-0.24-0.3-0.72-0.13-1.12,0.13z'/%3E%3Cpath fill='%23D4AF3A' d='M334.47,182.16c-0.265,0.134-0.436,0.306-0.541,0.452h1.653c0.006-0.063,0.004-0.129-0.009-0.191-0.05-0.26-0.55-0.54-1.1-0.26z'/%3E%3Cpath fill='%23D4AF3A' d='M293.75,183.19c0.092,0.512,0.212,1.031,0.361,1.553h51.785c0.149-0.521,0.27-1.041,0.36-1.553h-52.506z'/%3E%3Cpath fill='%23D4AF3A' d='M328.65,158.45c1.636,1.089,6.83,1.147,9.269,1.636,2.439,0.487,2.269,2.353,1.521,3.328-0.746,0.977-4.177,1.094-4.792,1.176,0.332,0.23,0.832,0.947,0.832,0.947s0.374-0.027,1.406-0.115c1.032-0.085,2.841-0.343,4.075-1.377,1.234-1.032,1.147-2.696,0.058-3.815-1.091-1.12-2.899-1.234-4.736-1.435-1.836-0.201-3.271-0.345-5.337-0.689-2.065-0.344-3.07-1.176-3.07-2.382,0-1.205,1.12-1.836,1.923-2.066,0.803-0.229,2.094-0.572,3.242-0.144,1.148,0.431,2.497,0.487,4.764,0.202,2.268-0.288,2.784-1.866,2.784-1.866s-0.288,0.144-1.435,0.172c-1.148,0.028-1.981-0.487-4.074-0.518-2.097-0.028-2.843,0.72-3.818,1.063-0.976,0.345-3.586,0.604-4.361,2.296-0.77,1.7,0.12,2.5,1.76,3.59z'/%3E%3Cellipse rx='0.977' ry='0.962' cy='150.64' cx='315.04' fill='%23B96B29'/%3E%3Cpath fill='%23B96B29' d='M336.02,152.28c-1.293-0.114-2.986,0.229-2.986,0.229s0.315,0.259,0.746,0.23c0.43-0.029,1.206-0.058,2.468,0.171,1.263,0.231,2.181-0.373,2.181-0.373s-1.12-0.14-2.41-0.26z'/%3E%3Cpath fill='%231D5E91' d='M323.74,176.38c-0.316-0.498-0.407-0.452-0.77-0.135-0.361,0.316-0.725-0.771-0.77-1.449-0.045-0.677,0.271-2.759,0.271-2.759s-1.765,0.362-2.714,0.678c-0.949,0.317-1.854,0.408-2.623,0.59s-1.176,0.36-1.583,0.271c-0.407-0.09-1.267-0.136-1.945-0.136s-0.632,0.136-1.312,0.814c-0.678,0.677-0.859,1.039-1.402,2.307-0.543,1.265-0.724,2.441-0.904,3.979-0.119,1.007-0.314,1.702-0.436,2.064h8.108c0.097-0.26,0.223-0.587,0.333-0.829,0.212-0.468,0.658-0.765,0.977-0.914s0.596-0.149,0.743-0.508c0.148-0.362,0.553-0.66,0.978-0.851s1.168-0.085,1.849,0.106c0.679,0.19,0.913-0.276,1.103-0.531,0.191-0.255,0.277-0.616,0.639-1.082,0.361-0.469,0.09-0.894,0.09-0.894s-0.33-0.22-0.65-0.72z'/%3E%3Cpath fill='%231D5E91' d='M336.75,176.6c-0.105-0.468-0.063-0.53-0.34-0.596-0.276-0.064-0.743-0.148-1.146-0.317-0.403-0.17-0.361,0.913-0.361,0.913s-0.957,0.104-2.039-0.021c-1.083-0.128-2.357-1.104-2.804-1.424-0.445-0.318-0.935-1.04-0.935-1.04s-0.34,0.318-0.68,0.51-0.531,0.871-0.594,1.551c-0.064,0.68,0.786,1.507,0.849,2.187,0.064,0.681-0.743,2.04-1.147,2.592-0.275,0.379-0.632,1.186-0.829,1.657h3.914c0.082-0.201,0.216-0.455,0.42-0.658,0.402-0.404,1.084-0.489,1.084-0.489s0-0.17,0.148-0.53c0.147-0.361,0.552-0.786,1.528-1.169,0.978-0.382,2.146-0.446,2.146-0.446s0.466-0.382,0.807-0.913c0.34-0.53,0.09-1.33-0.02-1.8z'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23D4AF3A' d='M304.15,219.77c0.729,0.243,2.091-0.291,2.772-1.118,0.68-0.827,0.924-2.093,1.41-2.821,0.486-0.73,0.839-1.271,0.839-1.271s-0.104,1.202-0.749,2.813c-0.615,1.536-0.722,3.637-0.576,4.537,0.292,1.799,1.459,2.091,2.14,1.847,0.517-0.184,1.3-0.981,2.019-2.177,0.227-0.379,0.386-0.903,0.608-1.324,0.462-0.875,0.875-2.309,1.079-2.269,0.45,0.088,0.162,1.101-0.008,1.782-0.341,1.361-1.021,3.356-1.07,4.572s0.098,3.404,1.313,3.502c1.216,0.097,1.848-0.974,2.528-3.454,0.681-2.479,0.828-3.259,1.119-3.259,0.292,0,0.292,1.702,0.292,2.432,0,0.251,0.01,0.942,0.109,1.637,0.189,1.329,0.577,2.925,0.961,3.276,0.583,0.535,1.07,0.437,1.07,0.437s0.485,0.099,1.07-0.437c0.583-0.535,1.069-4.184,1.069-4.913s0-2.432,0.291-2.432c0.294,0,0.438,0.779,1.119,3.259,0.682,2.48,1.313,3.551,2.529,3.454,1.216-0.098,1.363-2.286,1.314-3.502s-0.729-3.211-1.071-4.572c-0.341-1.362,0.146-1.265,1.071,0.486,0.288,0.547,0.587,1.217,0.88,1.685,0.648,1.031,1.278,1.649,1.746,1.816,0.68,0.244,1.848-0.048,2.14-1.847,0.292-1.801-1.07-6.956-1.07-6.956s0.098,0.146,0.584,0.876c0.486,0.729,0.729,1.994,1.411,2.821,0.68,0.827,2.043,1.361,2.772,1.118s0.827-1.606,0.291-4.038c-0.535-2.432-2.724-3.793-4.28-5.739-1.432-1.788-2.535-4.936-2.701-5.429-1.959,0.97-3.677,2.071-5.229,3.692-3.219,3.358-3.918,4.197-3.918,4.197s-0.7-0.839-3.918-4.197c-1.563-1.631-3.291-2.734-5.265-3.709-0.182,0.415-1.52,3.421-2.966,5.23-0.719,0.899-1.71,1.578-2.414,2.441-0.818,1.003-1.316,2.206-1.604,3.513-0.52,2.42-0.42,3.78,0.31,4.03z'/%3E%3Cpath fill='%23D4AF3A' d='M304.06,228.01c0.942-0.829,1.427-1.286,1.427-1.286s0.685-0.57,0.514,0.515c-0.172,1.084-0.543,3.311-0.314,4.28,0.228,0.971,0.342,1.798,1.541,1.084,1.199-0.713,1.484-1.142,2.055-1.74,0.57-0.6,1.17-0.855,1.027,0.086-0.144,0.941-0.571,2.368-0.371,4.28,0.2,1.911,1.142,2.196,2.368,0.57,1.228-1.626,1.969-3.109,2.34-3.909,0.371-0.799,1.113-1.483,1.113,0,0,3.192,0.732,7.835,4.251,9.074,3.521-1.239,4.253-5.882,4.253-9.074,0-1.483,0.74-0.799,1.11,0,0.372,0.8,1.113,2.283,2.341,3.909,1.227,1.626,2.169,1.341,2.368-0.57,0.199-1.912-0.229-3.339-0.371-4.28s0.457-0.686,1.028-0.086c0.57,0.599,0.854,1.027,2.054,1.74,1.199,0.714,1.313-0.113,1.541-1.084,0.228-0.97-0.143-3.196-0.313-4.28-0.172-1.085,0.513-0.515,0.513-0.515s0.485,0.457,1.428,1.286c0.94,0.827,2.233,0.877,2.233,0.877s0.605-3.351-0.791-5.352-1.909-2.652-1.909-2.652-0.79-0.046-1.395-0.278c-0.604-0.233-1.192-0.67-1.192-0.67s0,1.027,0,1.368v0.486s1.711,1.626,2.111,2.111c0.398,0.483,1.198,1.312,0.029,0.513-1.17-0.799-2.141-1.598-2.141-1.598s-0.229,1.684-0.714,2.112c-0.484,0.427-1.17,0.483-1.454,0.37-0.285-0.115-0.285-0.115-0.285-0.115l-0.086,0.658s1.055,1.969,1.197,2.768c0.144,0.799-0.086,0.712-0.57-0.315-0.485-1.025-1.426-2.339-1.854-3.052s-1.056-1.199-0.999-0.285c0.058,0.913-0.313,2.567-0.628,3.166-0.313,0.6-0.513,0.799-0.513,0.799s0.655,2.313,0.741,2.74c0.087,0.428,0.028,0.913-0.342,0.37-0.371-0.542-1.428-2.824-1.428-2.824s-1.398-0.057-1.797-0.457c-0.399-0.4-1.027-1.938-1.027-1.938s-0.572,1.964-1.046,2.595c-0.473,0.63-1.575,1.259-1.575,1.259s-0.079,3.416-0.156,4.02c-0.08,0.604-0.105,0.866-0.361,0.866-0.255,0-0.282-0.263-0.361-0.866-0.077-0.604-0.156-4.02-0.156-4.02s-1.104-0.629-1.577-1.259c-0.472-0.631-1.045-2.595-1.045-2.595s-0.627,1.538-1.027,1.938c-0.399,0.4-1.797,0.457-1.797,0.457s-1.056,2.282-1.427,2.824c-0.371,0.543-0.428,0.058-0.342-0.37s0.742-2.74,0.742-2.74-0.2-0.199-0.514-0.799c-0.314-0.599-0.685-2.253-0.627-3.166,0.056-0.914-0.572-0.428-1,0.285s-1.369,2.026-1.854,3.052c-0.485,1.027-0.713,1.114-0.57,0.315s1.198-2.768,1.198-2.768l-0.085-0.658-0.285,0.115c-0.286,0.113-0.97,0.057-1.456-0.37-0.485-0.429-0.713-2.112-0.713-2.112s-0.97,0.799-2.14,1.598c-1.17,0.799-0.371-0.029,0.029-0.513,0.399-0.485,2.11-2.111,2.11-2.111s0-0.144,0-0.486v-1.368s-0.586,0.437-1.191,0.67c-0.605,0.232-1.396,0.278-1.396,0.278s-0.512,0.651-1.908,2.652c-1.396,2.001-0.791,5.352-0.791,5.352s1.3-0.04,2.24-0.86z'/%3E%3Cpath fill='%23D4AF3A' d='M321.23,250.32c-0.902-1.055-1.203-1.58-1.203-1.58s-0.301,0.525-1.202,1.58c-0.904,1.053-3.01,2.708-3.01,2.708s0.188,2.784,1.204,4.287c0.856,1.27,1.675,2.43,3.008,3.311,1.333-0.881,2.153-2.041,3.009-3.311,1.017-1.503,1.204-4.287,1.204-4.287s-2.11-1.66-3.01-2.71z'/%3E%3Cpath fill='%23B96B29' d='M319.57,253.73c0.083,0.646,0.028,2.279,0.421,2.279s0.336-1.634,0.421-2.279c0.083-0.646,0.111-2.195,0.111-2.195h-1.067c0.01-0.01,0.04,1.54,0.12,2.19z'/%3E%3Cpath fill='%23D4AF3A' d='M319.98,100.87c-3.766,0.064-8.184-0.456-10.615-1.361-0.864,0.191-1.728,0.381-2.592,0.571,4.007,1.509,7.355,2.094,13.207,2.153,5.853-0.059,9.2-0.644,13.206-2.153-0.864-0.19-1.729-0.38-2.593-0.571-2.43,0.901-6.85,1.421-10.62,1.361z'/%3E%3Cpath fill='%23D4AF3A' d='M333.68,97.727c-0.299-0.249-2.013-1.471-2.46-1.694-0.447-0.225-0.099-0.822-0.024-1.071,0.074-0.25,2.012-0.798,3.081-1.072,1.067-0.274,0.894-0.499,0.894-0.499s-0.622-0.723-4.498-1.146c-3.874-0.423-10.68-0.324-10.68-0.324s-6.807-0.1-10.683,0.324c-3.875,0.423-4.496,1.146-4.496,1.146s-0.174,0.225,0.895,0.499c1.068,0.274,3.005,0.822,3.08,1.072,0.075,0.249,0.423,0.847-0.024,1.071-0.447,0.223-2.162,1.445-2.459,1.694-0.298,0.25-0.323,0.648,0.149,0.673,0.472,0.024,0.48,0.017,1.813-0.25,3.988-0.793,7.742-1.015,11.727-1.07,3.983,0.055,7.736,0.277,11.726,1.07,1.332,0.266,1.34,0.274,1.813,0.25,0.47-0.025,0.45-0.423,0.15-0.673z'/%3E%3Cpath fill='%23D4AF3A' d='M329.27,99.373c-2.659-0.315-4.347-0.659-9.27-0.615-4.922,0.043-6.609,0.3-9.27,0.615,1.675,0.672,4.384,1.01,9.27,1.01,4.89,0,7.6-0.34,9.27-1.007z'/%3E%3Cpolygon points='319.18,62.889,321.21,62.725,321.02,60.951,323.2,61.254,323.29,59.503,321,59.714,321.4,57.823,318.88,57.8,319.32,59.714,317.1,59.503,317.1,61.254,319.3,60.998' fill='%23D4AF3A'/%3E%3Cpath fill='%23D4AF3A' d='M323.61,65.76h-2.726v-2.325c-0.26-0.053-0.528-0.079-0.805-0.079-0.244,0-0.481,0.021-0.712,0.063v2.342h-2.82c-0.095,0.295-0.146,0.61-0.146,0.935,0,0.133,0.009,0.265,0.026,0.396h7.301c0.018-0.131,0.026-0.263,0.026-0.396-0.01-0.326-0.07-0.64-0.16-0.936z'/%3E%3Cpath fill='%231D5E91' d='M320.08,70.032c1.621,0,2.997-0.954,3.485-2.276h-6.972c0.49,1.323,1.87,2.276,3.49,2.276z'/%3E%3Cpath fill='%231D5E91' d='M321.58,63.648v1.598h1.808c-0.37-0.706-1.01-1.275-1.81-1.598z'/%3E%3Cpath fill='%231D5E91' d='M318.57,63.648c-0.791,0.323-1.434,0.892-1.809,1.598h1.809v-1.598z'/%3E%3Cpath fill='%23B96B29' d='M322.17,93.312c-0.688-0.325-2.188-0.966-2.188-0.966s-1.426,0.703-2.201,1.092c-0.775,0.388-0.675,0.275-0.913,0.84s0.024,0.765,0.362,0.915c0.338,0.151,2.79,1.406,2.79,1.406s2.426-1.129,3.013-1.406c0.589-0.275,0.478-0.551,0.314-0.979-0.16-0.425-0.49-0.575-1.17-0.902z'/%3E%3Cpolygon points='317.64,94.027,320.04,95.249,322.41,94.027,319.98,92.889' fill='%23D4AF3A'/%3E%3Cpath fill='%23D4AF3A' d='M319.98,84.648s-0.202,0.847-0.473,1.206c-0.271,0.36-0.476,0.681-0.398,1.119,0.078,0.437,0.578,0.729,0.871,0.729,0.292,0,0.793-0.292,0.87-0.729,0.079-0.438-0.126-0.759-0.397-1.119-0.26-0.359-0.47-1.206-0.47-1.206z'/%3E%3Ccircle cy='88.56' cx='320' r='0.451' fill='%23D4AF3A'/%3E%3Cpath fill='%23D4AF3A' d='M318.39,86.24s0.78-0.866,1.068-1.415c0.289-0.548,0.524-1.039,0.524-1.039s0.234,0.491,0.523,1.039c0.289,0.548,1.068,1.415,1.068,1.415s1.097-0.578,1.731-2.684c0.636-2.107-0.146-4.329-0.434-6.724s-0.52-6.521-0.52-6.521c-0.831,0.476-1.616,0.678-2.37,0.691-0.754-0.014-1.54-0.216-2.371-0.691,0,0-0.23,4.126-0.519,6.521-0.289,2.396-1.068,4.617-0.433,6.724,0.64,2.106,1.73,2.684,1.73,2.684z'/%3E%3Cellipse rx='1.894' ry='1.828' cy='81.506' cx='319.98' fill='%23B96B29'/%3E%3Cellipse rx='1.822' ry='1.759' cy='77.22' cx='319.98' fill='%23B96B29'/%3E%3Cellipse rx='1.738' ry='1.677' cy='73.121' cx='319.98' fill='%23B96B29'/%3E%3Cellipse rx='1.004' ry='0.968' cy='81.178' cx='319.98' fill='%23D4AF3A'/%3E%3Cellipse rx='0.966' ry='0.931' cy='76.905' cx='319.98' fill='%23D4AF3A'/%3E%3Cellipse rx='0.847' ry='0.817' cy='72.82' cx='319.98' fill='%23D4AF3A'/%3E%3Cpath fill='%23b96b29' d='m319.93,224.04c0.117,0.024,0.14-0.277,0.163-0.835,0.022-0.556,0.094-1.9,0.231-2.688,0.139-0.789-0.209-0.742-0.418-0.695-0.208,0.046-0.323,0.648-0.323,0.997,0,0.347,0.092,2.341,0.092,2.758s0.139,0.44,0.255,0.463z'/%3E%3C/g%3E%3Cg id='g4017'%3E%3Cpath fill='%23d4af3a' d='m300.28,239.41c0.841-0.534,1.571-1.126,3.478-2.392,1.907-1.267,2.608-2.673,2.608-2.673h-0.673c-0.365,0-0.673-0.507-0.701-1.013-0.029-0.507,0-1.547,0.14-2.757,0.14-1.209-0.196-2.194-0.196-2.194s-0.813,0.758-2.047,1.406c-1.234,0.647-1.74,0.337-1.74,0.337l-0.309-1.236s-0.532,1.126-1.29,2.446c-0.758,1.322-2.805,2.786-4.263,3.882-1.459,1.098-3.058,2.252-4.264,2.674-1.206,0.421-0.504,0.985-0.504,0.985s1.206,1.208,4.319,1.771,4.601-0.702,5.442-1.236z'/%3E%3Cpath fill='%23d4af3a' d='m311.17,238.2c-1.112-0.117-1.777-0.537-1.992-1.745-0.141-0.787,0.057-3.798,0.057-3.798s-0.365,0.309-0.786,0.817c-0.421,0.505-1.375,0.618-1.375,0.618s-0.14,0.422-0.561,1.096c-0.421,0.677-0.954,1.493-2.02,2.167-1.065,0.676-2.299,1.464-3.113,2.139-0.814,0.676-1.767,1.464-2.833,2.054-1.066,0.591-2.02,1.548-2.385,3.122-0.364,1.575-0.083,2.082,1.15,1.998,1.234-0.085,1.375,0.028,3.366-0.479,1.992-0.506,4.824-2.728,6.899-4.05,2.079-1.323,3.593-3.939,3.593-3.939z'/%3E%3Cpath fill='%23d4af3a' d='m316.69,240.02s-0.842-1.067-1.15-2.279c-0.309-1.209-0.897-3.6-0.897-3.6s-0.281,0.76-0.954,2.192c-0.674,1.436-1.823,1.774-1.823,1.774s-0.057,0.618-1.01,1.828c-0.954,1.209-2.355,2.334-3.787,3.18-1.431,0.842-3.282,1.998-4.292,3.432-1.009,1.435-1.094,2.925-0.616,3.572,0.477,0.646,1.149-0.085,2.103-0.563s3.675-0.9,7.433-2.926c3.758-2.025,4.993-6.61,4.993-6.61z'/%3E%3Cpath fill='%23d4af3a' d='m318.32,248.44c1.038-1.547,1.207-5.315,1.207-5.315s-0.364-0.253-0.87-0.677c-0.504-0.422-1.486-1.912-1.486-1.912s-0.617,1.293-1.29,2.503c-0.673,1.211-1.011,1.632-2.413,2.926-1.402,1.295-3.31,2.561-4.124,3.939-0.813,1.378-0.364,4.135,0.169,5.063,0.533,0.93,1.29,0.618,2.075-0.14,0.786-0.759,1.038-0.956,2.412-2.138s3.283-2.702,4.32-4.249z'/%3E%3Cpath fill='%23b96b29' d='m305.98,216.89c0.552-1.128,1.176-2.496,1.68-3.19,0.503-0.697,0.863-1.489,0.863-1.489s-1.344,1.224-1.872,2.088c-0.527,0.863-0.863,1.703-1.104,2.64-0.238,0.935-0.119,1.078,0.433-0.049z'/%3E%3Cpath fill='%23b96b29' d='m311.31,217.85c0.216-0.745,0.337-1.24,0.337-1.24s0.217-0.72,0.097-0.768c-0.12-0.049-0.673,0.447-1.057,1.67-0.385,1.225-0.96,2.999-0.84,3.071,0.119,0.073,1.247-1.989,1.463-2.733z'/%3E%3Cpath fill='%23b96b29' d='m315.51,221.23c0.24-0.527,0.24-0.551,0.24-0.551s0.432-1.392,0.432-1.68c0-0.287-0.144-0.623-0.503,0.096-0.361,0.721-0.384,1.415-0.457,1.728-0.071,0.312-0.479,1.392-0.36,1.488,0.12,0.096,0.408-0.551,0.648-1.081z'/%3E%3Cpath fill='%23b96b29' d='m302.47,234.03-0.562-0.338s-0.336,0.451-0.813,0.957c-0.477,0.505-1.011,0.703-1.375,1.182-0.364,0.478-0.926,1.069-1.795,1.519s-1.206,0.591-1.037,0.732c0.168,0.141,0.757-0.197,0.757-0.197s0.252-0.029,1.29-0.647,1.29-0.956,1.963-1.547,1.572-1.661,1.572-1.661z'/%3E%3Cpath fill='%23b96b29' d='m307.02,239.41c0.393-0.422,0.813-0.704,0.589-0.93-0.225-0.224-0.505-0.196-0.87,0.113-0.364,0.31-1.402,1.293-1.879,1.716-0.477,0.422-0.869,0.676-1.346,1.041-0.477,0.366-1.515,0.928-2.019,1.209-0.505,0.282-0.028,0.312-0.028,0.312s0.393-0.199,0.813-0.34c0.42-0.14,1.626-0.675,1.626-0.675s0.477-0.225,1.122-0.675c0.645-0.449,1.599-1.35,1.992-1.771z'/%3E%3Cpath fill='%23b96b29' d='m312.26,243.04c0.336-0.674-0.028-0.479-0.589-0.252-0.561,0.225-1.823,1.604-2.552,2.109s-1.347,0.703-1.963,1.014c-0.617,0.309-0.617,0.477-0.588,0.618,0.027,0.141,0.279,0.141,0.532,0.028,0.253-0.112,1.122-0.619,1.122-0.619s0.365-0.111,0.702-0.141c0.337-0.028,0.813-0.396,1.571-1.041,0.755-0.647,1.428-1.039,1.765-1.716z'/%3E%3Cpath fill='%23b96b29' d='m314.7,247.85c-0.926,0.563-2.524,1.828-2.945,2.673-0.422,0.845-0.702,1.435-0.562,1.575,0.14,0.141,0.589-0.141,0.786-0.479,0.196-0.337,0.617-0.844,0.617-0.844s1.598-1.574,2.187-1.94,1.543-1.406,1.768-2.025c0.224-0.62,0.056-0.956,0.056-0.956s-0.982,1.433-1.907,1.996z'/%3E%3Cpath fill='%23c52126' d='m289.99,113.28c-0.848-0.498-3.128-1.473-5.556-1.679-2.426-0.205-4.302,0.16-6.316,0.704-1.443,0.39-2.612,0.45-3.768,0.14-1.737-0.463-3.084-2.031-3.542-3.952,0,0-1.602,2.054,0.036,4.283,0.787,1.072,1.812,1.742,2.856,1.953,3.399,0.685,6.733-1.39,9.564-1.571,2.719-0.177,4.854,1.547,4.854,1.547s0.643,0.534,1.549,0.007c0.908-0.53,1.171-0.934,0.323-1.432z'/%3E%3Cpath fill='%23d4af3a' d='m280.2,211.66s-0.334-0.033-0.802-0.101c-0.468-0.067-1.471-0.402-1.772-0.537-0.301-0.133-0.769-0.167-1.07,0.168-0.301,0.336-2.742,1.777-2.742,1.777h4.046c1.404,0,2.34-1.307,2.34-1.307z'/%3E%3Cpath fill='%23d4af3a' d='m291.59,210.97v-0.404l-0.539-1.161s-0.629,0.395-1.242,1.029c-0.789,0.819-1.638,1.97-2.017,2.456-0.674,0.863-1.616,1.675-0.808,0.296,0.808-1.378,1.077-1.972,1.723-2.891,0.647-0.918,1.132-1.323,1.052-1.378-0.081-0.054-0.594-0.134-2.291-0.35-1.696-0.218-2.747-0.865-3.528-1.325-0.781-0.459-2.182-1.215-2.182-1.215s-2.882,1.215-3.96,1.485-1.724,0.432-0.674,0.946c1.051,0.513,1.939,0.675,2.451,0.998,0.511,0.326,2.101,0.838,3.071,0.838,0.969,0,2.612,0.026,1.966,0.702-0.646,0.677-1.374,1.974-2.074,3.944-0.7,1.974-0.727,3.729-0.727,4.594s0.107,1.728,0.107,1.728,1.185-1.322,4.364-3.321c3.178-2,4.363-2.675,4.956-2.946,0.592-0.269,0.89-0.269,0.781-1.025-0.106-0.757-0.429-2.621-0.429-3z'/%3E%3Cpath fill='%23d4af3a' d='m303.73,201.31c-0.192-0.086-0.39-0.175-0.59-0.268-0.053,0.014-0.102,0.029-0.146,0.052-0.373,0.187-2.312,1.492-3.095,2.761-0.783,1.267-1.566,1.38-0.709,0,0.858-1.382,1.492-2.164,2.163-2.761,0.259-0.23,0.491-0.422,0.677-0.569-1.56-0.752-3.254-1.663-4.893-2.804-0.212,0.423-0.619,1.173-1.08,1.659-0.671,0.708-2.163,1.306-2.163,1.306s1.193-1.231,1.604-2.164c0.261-0.595,0.432-1.236,0.521-1.621-1.141-0.889-2.234-1.902-3.21-3.065-0.199,0.807-0.844,2.771-2.755,4.91-2.498,2.798-7.496,4.214-7.496,4.214s-1.752,0.187-0.335,0.56,2.424,1.007,5.184,0.521c2.759-0.483,2.945-0.596,3.318-0.706,0.373-0.113,1.38-0.038,0,0.484-1.379,0.521-4.587,1.005-5.817,0.895-1.231-0.111-2.909-0.373-1.156,0.56s2.499,1.305,3.58,1.305c1.082,0,1.529,0.336,2.574,0.336,1.044,0,1.341-0.187,2.088-0.336,0.746-0.148,1.23,0.111,1.23,0.41,0,0.298-1.006,1.118-0.969,3.17,0.037,2.051,0.186,3.394,0.372,3.988,0.188,0.599,0.635,1.567,0.933,2.128,0.298,0.559,0.411,1.117,0.708-0.075,0.298-1.194,0.969-2.909,1.231-4.064,0.261-1.156,0.41-1.193,0.522-1.79,0.111-0.597,0.746-1.044,0.447,0.037s-0.634,2.461-0.857,3.431c-0.225,0.97-0.746,2.759,0.148,1.342,0.895-1.416,4.251-5.183,4.81-5.854s1.007-1.306,1.417-1.864c0.41-0.56,1.566-1.306,2.126-2.126,0.506-0.742,1.988-2.187,2.624-2.704-0.949-0.403-1.95-0.825-3.006-1.298z'/%3E%3Cpath fill='%23d4af3a' d='m257.37,115.23c0.089,2.055,2.364,5.987,3.658,8.087,1.294,2.101,1.65,2.947,1.428,3.082-0.224,0.134-0.759-0.938-1.473-1.875-0.714-0.938-2.096-3.127-3.256-4.78s-2.855-5.584-3.078-5.942c-0.223-0.357-0.313-0.581-0.892-0.135-0.58,0.447-1.695,4.781-0.356,7.73,1.338,2.948,3.345,5.091,4.192,6.119,0.848,1.028,1.963,2.636,1.784,2.771-0.178,0.133-0.49-0.269-1.516-1.341s-2.722-2.904-3.836-4.244c-0.906-1.088-2.135-3.298-2.566-4.088-0.162-0.299-0.371-0.218-0.527-0.062-0.367,0.369-0.955,1.226-0.699,3.569,0.357,3.262,2.052,5.138,3.568,6.791,1.517,1.653,3.034,3.037,2.811,3.261s-1.784-1.162-2.855-2.189c-1.07-1.027-3.703-3.573-4.282-4.289-0.581-0.714-1.427-0.358-1.383,2.457s3.167,5.674,4.46,7.238c1.295,1.563,2.9,2.5,2.767,2.813-0.134,0.313-1.428-0.49-2.275-1.072-0.847-0.581-4.015-2.636-4.639-3.083-0.624-0.446-0.937,0.402-0.134,3.083,0.803,2.679,3.123,4.824,4.505,5.806,1.383,0.983,3.613,2.188,3.479,2.503-0.133,0.312-1.07-0.09-2.364-0.716-1.293-0.625-2.854-1.206-3.97-1.518-1.116-0.313-1.115,0.49-1.115,0.49s-0.224,2.278,1.427,4.11,3.524,2.547,5.308,2.858c1.784,0.313,2.052,0.403,2.007,0.672-0.044,0.268-0.223,0.312-0.624,0.312s-2.052,0.179-3.569,0.179-2.319,0.356-2.319,1.027-0.045,1.564,2.23,3.082c2.274,1.52,4.817,1.743,5.888,1.967,1.07,0.223,1.114,0.313,0.892,0.626-0.223,0.312-0.713,0.268-2.409,0.446-1.695,0.178-2.721,0.849-2.944,1.295-0.223,0.447,0.134,1.788,1.518,2.725,1.382,0.939,3.166,1.252,5.843,1.073,2.677-0.18,3.346-0.224,3.435,0.224,0.09,0.446-0.802,0.581-2.141,0.805-1.338,0.222-2.365,0.222-3.123,0.848-0.759,0.626-0.178,1.921,1.115,2.859s4.506,0.938,5.844,0.849,3.39-0.581,3.524-0.224-0.981,0.895-2.363,1.385c-1.384,0.493-1.786,0.804-2.052,1.386-0.269,0.58-0.045,1.116,1.605,1.741,1.65,0.626,4.059,0.626,5.308,0.045,1.25-0.58,1.918-0.805,2.142-0.58,0.222,0.225,0,0.447-0.268,0.76-0.267,0.313-1.338,1.161-2.721,1.519s-1.517,0.358-2.008,1.474c-0.49,1.117,0.758,2.012,3.256,2.102,2.499,0.088,5.844-0.894,6.915-1.521,1.071-0.626,1.472-0.759,1.65-0.535,0.178,0.223,0.134,0.357-0.401,0.758-0.536,0.404-2.231,1.609-3.078,1.833-0.847,0.223-0.937,0.848-0.937,1.429,0,0.58-0.223,1.742,2.007,2.279,2.231,0.536,4.862,0.135,7.271-1.564,0.776-0.546,1.227-0.997,1.481-1.388-0.195-2.281-0.092-3.849,0.182-5.295-0.473-0.05-1.37-0.186-2.288-0.555-1.338-0.535-1.873-1.786-2.186-2.457-0.313-0.67-0.758-0.67-1.294-0.492-0.536,0.181-1.071,0.403-1.829,0.359s-2.364-0.447-3.524-1.833c-1.16-1.385-0.938-2.724-0.982-3.396-0.045-0.67-1.115-0.178-1.65-0.178-0.536,0-2.097-0.224-3.523-1.206-1.428-0.983-1.428-2.323-1.562-2.86-0.134-0.535-0.714-0.892-1.16-1.072-0.445-0.178-1.16-0.356-2.142-1.161-0.981-0.804-1.337-2.367-1.382-2.903-0.044-0.536-0.625-0.581-2.632-1.608s-1.829-3.172-1.739-4.02c0.089-0.85,1.025-1.563,1.025-1.878,0-0.313-0.669-0.401-1.338-0.804-0.669-0.401-2.364-1.072-2.408-3.573-0.045-2.502,1.606-2.77,1.606-2.77s-0.313-0.135-0.982-0.536c-0.669-0.403-2.497-1.653-2.497-3.128,0-1.474,0.668-2.144,1.159-2.502,0.491-0.357,1.829-0.714,1.829-0.714s-0.848-0.537-1.205-1.698c-0.357-1.162-0.491-2.59,0.356-3.618,0.848-1.028,2.275-1.028,3.034-1.028s1.427,0.402,1.695,0.18c0.268-0.224,0.312-0.402,0.044-0.983-0.267-0.58-0.312-2.011-0.089-2.501,0.224-0.492,0.268-1.474,2.187-2.1,1.917-0.625,3.924,0.67,4.549,1.028s0.357-0.493,0.357-1.117c0-0.625-1.293-2.189-2.766-4.423-1.472-2.234-2.141-3.396-3.792-6.791s-2.722-7.773-2.944-8.89c-0.223-1.117-0.669-0.582-0.669-0.582s-0.446,0.18-1.472,2.77c-1.024,2.592-1.202,4.96-1.113,7.013z'/%3E%3Cpath fill='%23d4af3a' d='m291.02,160.92c-1.15-0.058-2.643-0.689-3.792-2.358-1.148-1.669-2.873-2.073-5.861-2.016-2.988,0.058-4.367-1.38-5.114-3.451-0.747-2.073,0.115-4.433,3.16-5.929s4.425-3.165,4.539-5.753c0.115-2.59-3.044-5.813-6.205-9.438s-5.631-8.748-5.631-8.748-0.919,1.209-0.919,2.417,0.459,2.474,0,2.819c-0.46,0.346-0.632-0.517-2.47-1.323-1.839-0.806-3.333-0.92-4.482,0.403s0,3.625,1.034,4.719c1.035,1.093,1.896,1.9,1.609,2.303s-1.839-0.633-2.356-0.979-1.724-1.668-3.505-1.496-2.414,0.69-2.586,2.187c-0.172,1.496,1.609,2.818,2.758,3.395,1.149,0.574,1.609,1.093,1.321,1.322-0.287,0.231-0.575,0-1.092-0.171-0.516-0.173-1.953-0.345-2.872,0-0.92,0.345-2.414,1.61-1.035,3.165,1.379,1.554,4.252,2.129,4.827,2.243,0.574,0.115,0.862-0.058,0.919,0.402,0.057,0.462-1.207,0.462-2.758,0.52s-2.011,1.553-1.781,2.704,2.815,2.416,4.251,2.647c1.438,0.23,1.954,0,2.069,0.402,0.116,0.402-0.172,0.575-0.977,0.806-0.804,0.229-2.356,0.403-2.644,1.669-0.287,1.266-0.344,1.841,0.863,2.936,1.207,1.093,3.161,0.92,3.735,0.805,0.575-0.114,1.265-0.749,1.839-0.172,0.574,0.574-0.518,1.035-1.495,1.726-0.977,0.692-0.919,2.015,0.747,2.936,1.666,0.922,3.333,0.574,4.022,0.345s1.609-1.323,2.068-0.633c0.46,0.69-1.436,0.921-2.241,1.899-0.804,0.977-0.517,2.588,1.092,3.566,1.609,0.979,4.252,0.288,4.712-0.114,0.459-0.402,1.033-0.574,1.378-0.229,0.344,0.343-0.172,1.264-0.517,2.07-0.344,0.806-0.977,3.165,1.437,4.086,2.414,0.92,4.597-1.151,4.999-1.555,0.402-0.402,0.804-0.46,1.149-0.287,0.344,0.174,0.173,0.518-0.115,0.921-0.287,0.402-0.919,2.128,0.804,3.338,1.177,0.825,2.461,0.764,3.157,0.644,0.359-1.348,0.826-2.788,1.302-4.805h-0.36c-0.23,0-0.276,0.345-0.276,0.483s0.069,0.253-0.139,0.253c-0.207,0-0.23,0.115-0.529,0.323-0.299,0.207-0.575,0.459-0.737,0.345-0.161-0.115,0.622-0.53,0.829-0.783,0.208-0.254,0.622-0.645,0.645-0.92,0.023-0.277,0.161-0.438,0.575-0.783,0.129-0.107,0.23-0.235,0.31-0.359,0.277-1.342,0.548-2.913,0.795-4.815,0.167-1.291,0.262-2.507,0.299-3.643l-0.755-0.039z'/%3E%3Cpath fill='%23d4af3a' d='m241.91,125.05c2.567,5.193,6.192,8.117,6.192,8.117s-0.476-1.29-0.687-2.177c-0.209-0.888-0.046-1.892-0.046-1.892s-0.91-1.167-2.591-3.758-2.568-6.419-2.568-6.419,1.564,3.828,2.778,5.86c1.215,2.031,2.616,3.688,2.616,3.688s0.489-1.796,0.84-1.89c0.35-0.093,0.607,0.187,0.91,0.583,0.304,0.397,0.562,0.36,0.562,0.36s-0.415-0.857-1.053-1.885c-0.29-0.467-0.713-0.971-1.012-1.443-0.957-1.512-3.02-4.385-4.078-7.259-1.058-2.875-3.373-10.083-3.776-12.202-0.402-2.117-0.805-0.958-1.208,0.606-0.402,1.563-0.956,3.781-0.604,7.108s1.157,7.41,3.725,12.603z'/%3E%3Cpath fill='%23d4af3a' d='m245.23,139.07c0.956,0.706,2.366,1.663,2.366,1.663s-0.223-0.521-0.364-1.146-0.201-1.912-0.201-1.912-1.126-0.988-1.91-1.672c-0.784-0.685-1.77-1.571-3.72-3.987-1.95-2.417-0.382-0.966,1.206,0.766s4.625,4.248,4.625,4.248,0-0.04,0.02-0.563c0.021-0.523,0.182-0.906,0.463-1.268,0.282-0.363,0.133-0.414-1.579-1.724-1.711-1.311-6.142-6.302-7.954-9.278-1.813-2.975-3.776-7.008-3.776-7.008s-0.956,5.95,2.669,12.504c3.624,6.553,7.199,8.671,8.155,9.377z'/%3E%3Cpath fill='%23d4af3a' d='m264.25,176.6c1.986-0.77,1.442-2.729,1.442-2.761s-1.218,0.386-2.338,0.802c-1.122,0.419-3.877,1.22-4.966,1.251-1.088,0.032-1.088-0.127-1.121-0.288-0.032-0.159,0.833,0,2.402-0.288,1.57-0.289,4.325-1.733,4.805-2.053,0.48-0.322,0.416-0.387-0.288-0.451-0.705-0.063-1.313-0.385-1.57-0.608-0.255-0.225-0.992,0.097-2.786,0.515-1.795,0.416-5.511,1.058-8.362,1.058s-5.509-0.481-5.958-0.578c-0.449-0.096-0.929,0.161,0.449,2.472,1.377,2.309,6.215,3.561,9.578,3.528,3.363-0.034,6.727-1.83,8.713-2.599z'/%3E%3Cpath fill='%23d4af3a' d='m255.31,171.83c3.47,0.029,4.764-1.002,4.764-1.002s0-0.177-0.47-0.883c-0.471-0.706-0.382-1.914-0.382-1.914s-0.824,0.147-2.265,0.354c-1.441,0.206-3.117,0.412-4.97,0.088s-1.058-0.53,0.412-0.354c1.471,0.177,4.293-0.354,5.205-0.677,0.911-0.324,0.529-0.618-0.088-0.826-0.617-0.204-2.293-1.266-2.293-1.266s-4.205,0.53-8.116,0.09c-3.911-0.444-6.382-1.444-7.176-1.562s-0.765,0.207-0.765,0.207-0.206,0.352,1.146,2.471c1.353,2.123,4,3.507,6.235,4.154,2.235,0.649,5.293,1.091,8.763,1.12z'/%3E%3Cpath fill='%23d4af3a' d='m254.42,163.7s-0.147-0.206-0.353-0.914c-0.206-0.707,0.382-1.236,0.382-1.236s-0.794-0.235-3.382-0.56c-2.588-0.324-2.734-0.53-4.323-0.884-1.588-0.353-2.646-0.824-2.617-1.001s0.529,0.089,1.47,0.441c0.94,0.354,4.911,0.766,6.587,1.002,1.676,0.235,2.617,0.413,2.911,0.235,0.294-0.177,1.323-0.442,1.323-0.442s-0.706-0.204-1.588-0.353c-0.883-0.147-1.676-0.53-2.146-0.854-0.471-0.324-0.618-0.414-2.735-0.647-2.118-0.235-3.823-0.914-7.617-2.298-3.792-1.385-6.646-3.033-7.41-3.651-0.765-0.618-0.706-0.176-0.5,0.618,0.206,0.796,0.176,1.796,2.088,4.034,1.911,2.239,2.852,3.21,7.674,4.979,4.825,1.766,10.236,1.531,10.236,1.531z'/%3E%3Cpath fill='%23d4af3a' d='m240.16,151.95c4.264,3.004,9.261,4.107,10.321,4.24,0.238-0.278-0.258-1.276-0.03-1.885,0.276-0.729,0.736-0.736,1.765-0.795,1.029-0.061,0.353-0.266,0.118-0.266s-0.294-0.029-2-0.471c-1.706-0.44-3.44-0.707-5.792-1.591-2.353-0.883-3.058-1.531-3-1.708,0.059-0.176,1.088,0.561,3.265,1.385,2.176,0.824,4.705,1.148,6.087,1.444,1.382,0.292,0.176-0.296-0.471-0.679-0.647-0.384-1.559-1.797-1.559-1.797s-1.529-0.265-4.028-1.03c-2.5-0.766-4.587-1.621-6.675-2.798-0.717-0.406-1.411-0.929-2.159-1.466-1.431-1.026-2.869-2.075-3.428-2.48-0.854-0.618-0.588-0.118-0.5,0.265s0.676,2.151,2.028,4.094c1.353,1.944,1.794,2.533,6.058,5.538z'/%3E%3Cpath fill='%23d4af3a' d='m239.46,143.5c4.205,3.329,7.821,4.357,8.439,4.623,0.617,0.266,0.559-0.088,0.441-0.441-0.118-0.354-0.207-1.501-0.207-1.501s-1.5-0.855-3.176-1.827c-1.676-0.973-3.528-2.297-4.763-3.15-1.235-0.854-0.5-0.795-0.118-0.473,0.382,0.324,2.088,1.326,3.793,2.386,1.706,1.061,4.293,2.592,4.293,2.592s0.059-0.559,0.412-0.913,1.234-0.264,1.234-0.264-0.441-0.442-0.706-0.854c-0.264-0.414-1.647-0.854-3.205-1.592-1.559-0.735-4.353-2.796-6.411-4.534-2.058-1.737-6.058-6.096-6.322-6.45-0.265-0.354-0.441-0.294-0.471,0.147-0.029,0.441-0.176,0.736,0.265,2.739,0.444,2.002,2.296,6.184,6.502,9.512z'/%3E%3Cpath fill='%23d4af3a' d='m254.34,112.03c0.477,0.99,0.999,1.738,1.375,2.383,0.568,0.974,0.888,1.605,0.888,1.605s0.114-0.343,0.024-0.928-0.18-1.396-0.022-2.363c0.083-0.518,0.195-1.034,0.167-1.494-0.033-0.523-0.208-0.975-0.279-1.273-0.135-0.564-0.741-3.016-1.034-4.748-0.292-1.733-0.606-4.208-0.584-6.392,0.022-2.183,0.337-1.081,0.337-0.022s0.112,2.679,0.449,5.176c0.337,2.498,1.393,6.301,1.393,6.301s0.067-0.585,0.382-1.418,0.832-1.777,1.236-2.813c0.404-1.035,0.262-1.208,0.262-1.208s-1.476-7.066-1.864-10.406c-0.389-3.339-1.01-12.116-1.01-12.116-2.16,2.173-3.766,7.892-4.052,13.301-0.214,4.075,0.444,7.847,0.635,9.376,0.378,3.028,0.904,5.392,1.697,7.039z'/%3E%3Cpath fill='%23d4af3a' d='m249.55,123.18c0.067-1.6,0.435-2.811,1.467-3.166,0,0-0.913-1.601-1.711-3.883-0.545-1.563-0.996-3.567-1.225-5.105-0.564-3.787-1.016-7.688,0.113-1.3,1.128,6.387,2.483,8.648,2.483,8.648l1.637,2.657c-0.242-1.167-0.28-1.987-0.218-3.262s0.225-3.002,0.613-4.369c0,0-1.976-3.956-3.217-8.706s-1.951-9.069-1.976-11.644c-0.113-2.488-0.169-3.449-0.169-3.449s-2.031,1.526-2.708,9.27c-0.678,7.745,1.355,15.151,2.37,17.978,1.016,2.825,2.541,6.331,2.541,6.331z'/%3E%3Cpath fill='%23d4af3a' d='m271.71,182.24s-0.32-0.224-1.281-0.834c-0.961-0.608-0.672-2.438-0.672-2.438s-0.256,0.192-0.962,0.674c-0.705,0.481-1.505,1.025-2.466,1.411s-1.442,0.642-2.05,0.834c-0.609,0.193-0.448-0.063,0.064-0.353,0.512-0.288,0.673-0.449,1.955-0.962,1.28-0.514,3.843-2.76,3.843-2.76s-0.609-0.064-1.666-0.096-2.403-0.577-2.403-0.577-1.056,0.962-5.317,2.79c-4.261,1.83-7.881,2.31-7.881,2.31s0.449,2.183,2.499,2.921c1.698,0.738,4.037,1.187,8.618,0.097,4.58-1.09,7.719-3.017,7.719-3.017z'/%3E%3Cpath fill='%23d4af3a' d='m277.32,186.61c0.353-1.799-0.673-3.05-0.673-3.05s-0.224,0.128-0.864,0.706c-0.641,0.578-1.571,1.669-3.364,2.566s-2.435,0.834-0.705-0.097,4.261-3.561,4.261-3.561l-0.672-0.257c-0.674-0.257-1.827,0.192-6.632,3.079-4.805,2.888-7.625,2.985-7.625,2.985s2.146,2.599,7.977,2.406c5.831-0.19,7.945-2.982,8.297-4.777z'/%3E%3Cpath fill='%23d4af3a' d='m288.34,184.52s-0.641,0.897-1.506,1.475-3.171,0.931-3.171,0.931-0.096,0.257-0.544,0.834c-0.449,0.578-1.442,1.958-2.467,2.696-1.024,0.738-2.627,1.218-2.723,1.025s0.929-0.577,1.922-1.187c0.993-0.608,1.89-1.733,2.563-2.502,0.673-0.771-0.288-0.642-0.288-0.642s-1.217,0.031-2.339-0.064c-1.121-0.098-0.897,0-1.217,0.546s-0.769,1.026-1.602,1.989c-1.016,1.174-1.981,2.238-2.947,3.399-0.64,0.771-0.16,0.995-0.16,0.995s0.289,0.482,2.883,0.77c1.602,0.179,3.337-0.023,5.163-1.076,1.131-0.656,2.298-1.695,3.488-2.998,3.105-3.399,2.945-6.191,2.945-6.191z'/%3E%3Cpath fill='%23d4af3a' d='m289.72,191.54c-0.641,0.835-0.994,1.188-0.994,1.188s0.449-1.38,0.833-2.022c0.205-0.342,0.427-0.667,0.592-0.894-0.429-0.964-0.781-2-1.041-3.117-0.285,0.923-1.172,3.631-2.274,5.392-1.344,2.148-2.531,2.919-1.762,3.495,0.769,0.578,2.274,0.707,3.973-0.128,1.64-0.805,2.114-2.211,2.347-3.346-0.288-0.446-0.558-0.909-0.808-1.394-0.212,0.131-0.52,0.376-0.866,0.826z'/%3E%3Cellipse rx='1.192' ry='1.092' cy='105.75' cx='289.34' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m286.83,103.69c1.088-0.026,1.673-0.541,2.874-0.425,1.417,0.138,3.337,0.964,5.669,2.202,1.823,0.824,4.23,1.236,6.548,0.571,0.649-0.187,1.291-0.542,1.912-0.892,2.835-1.606,2.149-4.771,2.149-4.771-2.092,1.509-4.678,2.32-7.087,2.156,0,0,0.183,0.138,0.594,0.551,0.412,0.413,1.165,0.893,0.915,1.102-0.249,0.207-1.28-0.781-2.149-1.423-0.869-0.643-2.149-1.514-4.344-2.154-2.195-0.644-4.664-0.688-6.31,0.227-1.646,0.919-1.783,2.066-1.554,2.524,0.126,0.257,0.429,0.341,0.783,0.332z'/%3E%3Cpath fill='%23d4af3a' d='m317.64,126.8c-0.503-0.138-1.371-0.275-2.514-1.33-1.144-1.054-3.887-4.082-4.208-4.632-0.32-0.551-0.183-1.055,0.595-1.377,0.777-0.32,1.326-1.33,1.326-1.33s-1.691-0.643-2.834-1.469c-1.144-0.824-3.796-3.21-4.162-3.806s-0.183-0.688,0.366-0.871c0.55-0.184,0.687-0.551,0.687-0.551s-1.235-0.779-2.377-1.696c-1.144-0.917-2.698-2.431-2.698-2.431-1.713,0.688-4.401,0.398-5.853,0.138-2.561-0.458-4.435-1.514-4.435-1.514s-0.092,0.413-0.412,1.193c-0.32,0.779-1.509,1.239-2.698,0.458-1.189-0.779-0.915-2.476-0.915-2.476s-0.96-0.596-2.926-1.33-3.566-0.826-5.167-0.092c-1.601,0.733-2.378,2.935-2.378,4.587,0,1.65,0.87,0.963,1.052,0.732,0.183-0.229,0.549-1.422,2.561-1.742,2.012-0.322,3.841,0.642,6.127,2.521,2.286,1.882,2.789,2.019,3.932,3.211,1.143,1.193,0.229,1.834-1.737,2.477s-4.481-0.642-4.573-0.595c-0.378,0.189,0.848,1.938,2.544,2.599,1.696,0.66,3.864,0.232,5.55-0.444,1.143-0.458,1.356,0.015,1.691,0.367,1.857,1.952,2.34,3.781,2.652,6.009,0.949-0.292,1.606-1.24,1.738-2.018,0.063-0.373,0.183-1.193,0.823-0.597,0.64,0.597,1.143,3.898,1.143,5.412s-0.458,3.532-0.458,3.532l0.458-0.046c0.275-0.046,0.823-0.367,1.555-0.779,0.731-0.414,0.777,0.046,0.777,0.871s0.274,2.385,1.372,5.183,2.698,3.714,2.698,3.714,0.321-0.55,0.641-1.65c0.319-1.101,0.549-3.256,0.549-5.137s-0.503-5.917-0.503-5.917,2.287,2.798,4.664,3.487c2.378,0.688,4.756,0.275,5.762-0.872,1.003-1.146,0.088-1.65-0.415-1.789z'/%3E%3Cpath fill='%23d4af3a' d='m302,134.04s-0.722,1.597-1.116,2.166-0.569,0.658-0.569,0.658,0.722,0.612,1.773,0.94c1.051,0.329,1.992,0.525,1.992,0.525s-1.183-1.621-1.598-2.758c-0.416-1.138-0.482-1.531-0.482-1.531z'/%3E%3Cpath fill='%23d4af3a' d='m316.28,133.1c-0.351-0.897-0.569-1.401-0.569-1.401-1.459,0.292-4.227-0.393-5.429-1.116,0,0,1.095,2.231,2.189,2.998,1.095,0.766,1.248,0.81,1.248,0.81s-1.094,0.176-2.561-1.269c-1.466-1.445-2.123-3.109-2.123-3.109s0.328,3.853-0.263,6.216-0.722,2.67-0.722,2.67,3.107,0.547,6.566-0.416c3.458-0.964,3.72-1.27,3.72-1.27s0.415-0.109-0.131-0.831c-0.547-0.721-1.575-2.385-1.925-3.282z'/%3E%3Cpath fill='%23b96b29' d='m310,124.64c-1.064-1.223-1.17-1.516-1.17-1.516s-0.372,0.372-0.054,0.905c0.319,0.531,1.835,1.86,2.872,2.445,1.038,0.585,2.074,0.771,2.074,0.771l-0.053-0.213c0,0.001-2.606-1.169-3.669-2.392z'/%3E%3Cpath fill='%23b96b29' d='m305.78,132.67s-0.266-4.84-0.266-5.558-0.452-0.532-0.452-0.532l-0.531,0.239s0.907,6.173,1.04,7.077c0.113,0.762,0.488,0.697,0.68,0.663-0.38-0.197-0.455-1.668-0.471-1.889z'/%3E%3Cpath fill='%23b96b29' d='m299.25,111.72c-0.395-0.394-1.283-0.689-0.427,0.264,0.855,0.954,1.975,2.14,2.303,3.128,0.33,0.987,0.527,2.204-0.032,1.941-0.56-0.264-0.955-0.264-1.547-0.757-0.593-0.494-1.711-1.318-2.172-1.448-0.461-0.132-1.283,0-0.625,0.723,0.658,0.725,1.383,1.417,2.633,2.337,1.251,0.922,1.975,1.316,2.633,1.777,0.658,0.462,1.316,0.856,1.316,0.856s-0.593-3.949-1.679-5.693-2.008-2.732-2.403-3.128z'/%3E%3Cpath fill='%23b96b29' d='m277.91,177.87c-0.802,0.608-1.853,0.857-1.853,0.857s-0.498-0.026-0.498,0.167,0.581,0,1.189-0.11c0.608-0.111,1.438-0.72,1.742-0.941,0.304-0.222,0.747-0.499,0.608-0.887-0.138-0.388-0.387,0.305-1.188,0.914z'/%3E%3Cpath fill='%23b96b29' d='m284.8,181.56c-0.166,0.192-1.493,1.19-1.493,1.19s-0.415,0.276-0.858,0.442c-0.442,0.167-0.552,0.417-0.552,0.417s0.083,0.109,0.552-0.027c0.47-0.14,1.854-1.109,2.295-1.497,0.442-0.389,0.637-0.498,0.471-0.664-0.165-0.166-0.248-0.055-0.415,0.139z'/%3E%3Cpath fill='%23b96b29' d='m256.87,131.93c0.248,0.302,0.55,0.715,0.688,0.577,0.138-0.137-0.028-0.275-0.358-0.661-0.33-0.385-0.522-0.578-0.522-0.578s-0.467-0.744-0.743-1.02c-0.275-0.275-0.688-0.413-0.165,0.22,0.523,0.635,0.853,1.158,1.1,1.462z'/%3E%3Cpath fill='%23b96b29' d='m254.75,136.58c0.302,0.277,0.577,0.523,0.907,0.881s0.578,0.743,0.77,0.551c0.193-0.193-0.495-0.605-0.797-0.992-0.303-0.386-0.55-0.633-0.936-0.936s-0.853-0.551-0.853-0.551,0.606,0.772,0.909,1.047z'/%3E%3Cpath fill='%23b96b29' d='m255.54,144.09c0.525,0.553,1.299,0.719,1.41,0.499,0.111-0.222-0.055-0.4-0.496-0.62-0.439-0.22-1.155-0.688-1.513-0.936-0.357-0.249-0.715-0.524-0.963-0.771-0.247-0.248-0.54-0.471-0.632-0.387-0.092,0.085,0.729,0.968,0.977,1.107,0.249,0.138,0.692,0.554,1.217,1.108z'/%3E%3Cpath fill='%23b96b29' d='m257.06,150.1c0-0.221,0.054-0.331-0.388-0.36-0.442-0.027-1.051-0.109-1.051-0.109s-0.857-0.333-0.913-0.167c-0.055,0.167,0.719,0.5,1.051,0.555,0.332,0.056,0.746,0.166,0.939,0.275,0.195,0.11,0.362,0.026,0.362-0.194z'/%3E%3Cpath fill='%23b96b29' d='m257.72,156.63c-0.939,0-1.742-0.223-1.797-0.084s0.442,0.361,0.913,0.526c0.471,0.167,1.356,0.222,1.964,0.249s0.719-0.11,0.691-0.414c-0.028-0.306-0.83-0.277-1.771-0.277z'/%3E%3Cpath fill='%23b96b29' d='m265.08,163.78c-0.138-0.138-0.47-0.027-0.996,0.083-0.524,0.112-1.382,0.278-1.88,0.251s-1.576-0.056-1.576-0.056l-0.608,0.138c0,0.139,0.801,0.111,1.963,0.249,1.161,0.139,1.935-0.11,2.488-0.194,0.554-0.083,0.748-0.331,0.609-0.471z'/%3E%3Cpath fill='%23b96b29' d='m268.12,168.87c-0.581,0.222-0.995,0.276-1.438,0.276-0.442,0-1.493,0.194-1.493,0.194s-0.498,0.056-0.415,0.25c0.083,0.193,0.249,0,0.69-0.056,0.443-0.056,0.775,0,1.549-0.027,0.774-0.028,1.217-0.223,1.687-0.305,0.47-0.084,0.995-0.333,0.747-0.638-0.249-0.303-0.746,0.084-1.327,0.306z'/%3E%3Cpath fill='%23b96b29' d='m274.04,172.72c-0.332,0.333-1.604,1.191-1.604,1.191s-0.249,0.194-0.747,0.443-0.47,0.361-0.387,0.499,0.387-0.194,0.663-0.305,1.189-0.722,1.659-1.107c0.47-0.39,1.078-0.694,0.967-0.97-0.109-0.277-0.219-0.082-0.551,0.249z'/%3E%3Cpath fill='%23b96b29' d='m264.19,122.87s0.11,0.253,1.131,1.531c1.022,1.277,0.475,0.072,0.219-0.254-0.256-0.33-1.751-2.444-2.262-3.029-0.51-0.584-0.583-0.292-0.328,0.072,0.256,0.365,1.24,1.68,1.24,1.68z'/%3E%3Cpath fill='%23b96b29' d='m262.04,129.43c0.146-0.146-0.183-0.292-0.766-1.021-0.584-0.73-1.751-2.225-1.751-2.225s-0.329-0.693-0.438-0.621c-0.109,0.073,0.401,1.167,0.875,1.643,0.475,0.474,1.094,1.386,1.423,1.787s0.511,0.583,0.657,0.437z'/%3E%3Cpath fill='%23b96b29' d='m264.87,141.73c0-0.357-1.155-0.303-1.677-0.413-0.523-0.11-1.458-0.303-1.458-0.303s-1.101-0.193-1.128-0.055c-0.028,0.136,0.22,0.274,0.825,0.386,0.605,0.109,1.513,0.385,2.201,0.495s1.237,0.249,1.237-0.11z'/%3E%3Cpath fill='%23b96b29' d='m262.04,135.09c0.766,0.62,1.276,0.912,1.678,1.131,0.401,0.218,0.729,0.548,0.949,0.292,0.219-0.257-0.183-0.438-0.839-0.73-0.657-0.292-0.985-0.547-0.985-0.547s-0.365-0.182-0.694-0.365c-0.329-0.182-0.876-0.401-0.109,0.219z'/%3E%3Cpath fill='%23b96b29' d='m268.64,130.71c-0.475-0.401-0.876-0.622-0.876-0.622s-0.583-0.547-0.693-0.365c-0.109,0.184,0.656,0.73,1.021,1.058,0.365,0.329,1.022,1.278,1.35,1.095,0.328-0.182-0.329-0.765-0.802-1.166z'/%3E%3Cpath fill='%23b96b29' d='m264.33,147.85s-0.637,0.165-1.051,0.276-0.442,0.306,0.305,0.306,1.051-0.194,1.797-0.334c0.747-0.138,0.997-0.221,0.885-0.47-0.11-0.25-0.498-0.166-0.802-0.083s-1.134,0.305-1.134,0.305z'/%3E%3Cpath fill='%23b96b29' d='m265.49,154.06c-0.055,0.14,0.525,0,0.912-0.138,0.387-0.139,1.189-0.553,1.659-0.692,0.471-0.138,0.471-0.222,0.471-0.499,0-0.276-0.499-0.056-1.106,0.139-0.608,0.194-1.383,0.804-1.383,0.804s-0.498,0.248-0.553,0.386z'/%3E%3Cpath fill='%23b96b29' d='m273.48,157.82c0.554-0.334,0.665-0.582,0.47-0.749-0.193-0.165-0.359-0.138-0.801,0.222-0.443,0.36-1.3,0.969-1.3,0.969s-0.442,0.167-0.774,0.333-0.747,0.443-0.636,0.609c0.11,0.166,0.802,0,1.161-0.305,0.36-0.304,1.328-0.748,1.88-1.079z'/%3E%3Cpath fill='%23b96b29' d='m277.25,162.81c0.221-0.195,0.884-0.414,1.189-0.637,0.304-0.222,0.498-0.886,0.249-0.969s-0.387,0.276-0.912,0.663c-0.526,0.389-2.323,1.579-2.323,1.579l-0.471,0.194c-0.498,0.193-0.276,0.333,0.139,0.277,0.415-0.057,0.691-0.057,1.189-0.442,0.497-0.388,0.718-0.471,0.94-0.665z'/%3E%3Cpath fill='%23b96b29' d='m282.83,167.54c0.471-0.193,1.162-0.803,1.494-1.106,0.331-0.306,0.746-0.693,0.498-0.887-0.25-0.193-0.525,0.056-0.913,0.414-0.387,0.361-1.411,1.441-1.411,1.441s-0.138,0.027-0.691,0.471c-0.553,0.442,0.028,0.359,0.221,0.166,0.194-0.193,0.333-0.305,0.802-0.499z'/%3E%3Cpolygon points='305.58,96.588,307.83,94.99,305.18,94.311,303.48,95.668' fill='%23d4af3a'/%3E%3Cellipse rx='2.146' ry='2.069' transform='translate(-5.9509277e-6,-3.4236908e-6)' cy='94.716' cx='312.78' fill='%23b96b29'/%3E%3Cellipse cx='312.78' rx='1.295' cy='94.278' ry='1.237' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m308.3,87.608c0.552,0.205,1.27,0.115,1.27,0.115s0.217-0.952-0.308-1.416c-0.525-0.462-1-0.796-1.308-1.105-0.308-0.31-0.384-0.413-0.384-0.413s0,0.823-0.04,1.338c-0.037,0.516,0.219,1.274,0.77,1.481z'/%3E%3Cellipse cx='309.44' rx='0.394' cy='88.65' ry='0.373' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m306.51,88.25c-0.167,0.232-0.525,0.604-0.525,0.604s0.436,0.013,0.795,0.27c0.359,0.258,0.821,0.476,1.244,0.425,0.423-0.053,0.603-0.452,0.513-0.734-0.089-0.283-0.294-0.577-0.987-0.836-0.693-0.256-0.873,0.039-1.04,0.271z'/%3E%3Cpath fill='%23d4af3a' d='m308.01,90.756c-1.348,0.121-3.129-1.369-3.129-1.369-0.166,1.197-0.906,1.818-2.04,2.045l0.104,0.053s1.054,0.539,2.299,0.728c0.563,0.086,1.064-0.011,1.669-0.132,0.73-0.148,1.551-0.356,1.995-0.63,0.813-0.502,0.57-1.803,0.57-1.803s-0.119,0.986-1.468,1.108z'/%3E%3Cpath fill='%23d4af3a' d='m302.76,89.404c-0.553-0.208-1.383-0.607-1.729-0.625-0.346-0.017-0.848-0.104-0.761,0.538,0.086,0.642,0.743,0.954,1.382,0.971,0.64,0.018,0.969-0.225,1.349-0.417,0.381-0.19,0.312-0.259-0.241-0.467z'/%3E%3Cpath fill='%23d4af3a' d='m298.54,87.114c-0.604-0.433-1.142-0.554-1.142-0.554s-0.397,1.041-0.173,1.683c0.225,0.642,0.692,0.814,1.262,0.796,0.571-0.016,1.418-0.312,1.176-0.745-0.241-0.432-0.518-0.746-1.123-1.18z'/%3E%3Cellipse cx='299.09' rx='0.466' cy='90.041' ry='0.336' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m300.38,84.865c-0.374-1.774-0.311-3.704,1.37-6.163,1.682-2.46,4.607-3.456,4.607-3.456s0.093-0.187,1.027-1.182c0.934-0.997,2.833-2.241,2.833-2.241s-2.204,0.544-3.457,0.945c0,0.022,0.001,0.043,0.001,0.066,0,0.851-0.676,1.541-1.51,1.541-0.318,0-0.615-0.102-0.859-0.274-0.68,0.132-2.944,1.485-3.523,1.968,0.144,0.236,0.228,0.514,0.228,0.812,0,0.849-0.677,1.54-1.511,1.54-0.25,0-0.485-0.061-0.693-0.172-0.068,0.108-0.132,0.217-0.193,0.328-0.475,0.873-0.825,1.711-1.083,2.478,0.387,0.267,0.646,0.766,0.646,1.336,0,0.846-0.573,1.534-1.281,1.541-0.049,0.498-0.045,0.846-0.026,0.995,0.062,0.499,0.249,0.81,1.12,1.059,0.872,0.249,2.055,1.774,2.055,1.774,0.084,0,0.706-1.12,0.249-2.895z'/%3E%3Cpath fill='%23d4af3a' d='m305.74,73.506c0.318-0.258,0.374-0.653,0.121-0.879-0.25-0.227-0.711-0.2-1.029,0.06-0.317,0.26-0.373,0.655-0.121,0.881,0.251,0.226,0.712,0.2,1.029-0.062z'/%3E%3Cpath fill='%23d4af3a' d='m300.1,77.317c0.357-0.326,0.42-0.819,0.136-1.104-0.283-0.284-0.803-0.25-1.162,0.076-0.358,0.324-0.419,0.818-0.136,1.102,0.283,0.285,0.803,0.251,1.162-0.074z'/%3E%3Cellipse cx='296.74' rx='0.871' cy='82.109' ry='0.856' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m315.54,70.017c-0.452,0.099-1.288,0.371-2.539,1.026h0.023c0.87,0,1.546,0.556,1.546,1.276,0,0.721-0.791,1.504-1.66,1.504s-1.461-0.755-1.461-1.476c0-0.169,0.04-0.333,0.111-0.482-0.371,0.229-0.767,0.482-1.189,0.767-2.771,1.868-3.424,2.771-4.793,5.324-1.37,2.551-1.868,5.353-1.277,7.003,0.592,1.649,2.771,1.992,2.802,1.992s-0.249-0.249-0.281-0.559c-0.031-0.313,0.063-0.468,0.156-1.091,0.093-0.621,0.031-1.368,0.031-1.368s0.498-0.063,0.778,0.28c0.281,0.342,0.686,0.747,0.965,1.088,0.28,0.342,1.027,0.997,1.027,0.997s0.437-0.624,0.437-1.371c0-0.746-0.498-1.555-0.592-2.863s0.592-3.643,1.867-5.354c1.277-1.712,3.673-3.268,4.389-3.611,0.716-0.341,0.84-0.872,0.872-1.183,0.031-0.311,0.093-0.528,0.155-1.307,0.064-0.778-0.652-0.747-1.367-0.592z'/%3E%3Cpath fill='%23d4af3a' d='m312.79,72.973c0.49,0,0.936-0.441,0.936-0.845,0-0.405-0.381-0.717-0.872-0.717-0.49,0-0.888,0.329-0.888,0.732s0.333,0.83,0.824,0.83z'/%3E%3Cpath fill='%23d4af3a' d='m316.91,89.249c0.668,0.272,1.422,0.119,1.777-0.118,0.355-0.238,0.475-0.843,0.054-1.189-0.419-0.345-1.044-0.333-1.432-0.118-0.388,0.216-1.261,0.831-1.261,0.831s0.194,0.324,0.862,0.594z'/%3E%3Cpath fill='%23d4af3a' d='m319.05,89.999c-0.241,0.372-0.419,0.598-1.161,0.63s-1.547-0.016-2.031-0.501c-0.484-0.484-0.822-1.164-0.822-1.164l-0.838-0.016s-0.273,1.165-0.644,1.486c-0.371,0.324-1.661,0.373-2.225-0.048s-1.08-0.938-1.176-0.873,0,0.485,0.58,0.986c0.58,0.5,0.982,0.809,1.918,0.809h5.318s1.08,0.063,1.387-0.583c0.306-0.646,0.32-1.051,0.177-1.212-0.144-0.161-0.241,0.113-0.483,0.486z'/%3E%3Cpath fill='%23d4af3a' d='m310.96,89.098c0.798,0.443,1.239,0.173,1.529-0.184,0.292-0.356,0.345-0.518,0.345-0.518s-0.754-0.271-1.12-0.487c-0.367-0.215-0.614-0.421-0.98-0.378-0.367,0.044-0.42,0.098-0.42,0.098s-0.151,1.025,0.646,1.469z'/%3E%3Cellipse cx='307.11' rx='1.775' cy='81.24' ry='1.759' fill='%23b96b29'/%3E%3Cpath fill='%23b96b29' d='m310.19,75.144c-0.71-0.478-1.753-0.287-2.331,0.426-0.576,0.715-0.467,1.683,0.245,2.16,0.71,0.479,1.755,0.287,2.332-0.426,0.576-0.712,0.466-1.68-0.246-2.16z'/%3E%3Cellipse cx='307.04' rx='1.031' cy='81.012' ry='0.983' fill='%23d4af3a'/%3E%3Cpath fill='%23d4af3a' d='m309.45,75.338c-0.457-0.125-1.022,0.1-1.26,0.502-0.238,0.403,0.014,0.832,0.623,0.956,1.121,0.229,1.655-1.179,0.637-1.458z'/%3E%3C/g%3E%3Cg%3E%3Cpath fill='%23D4AF3A' d='M282.34,212.67s-2.742,1.31-3.611,1.543c-0.869,0.237-1.07,0.237-1.07,0.237s-1.873,1.709-3.244,2.513c-1.44,0.848-3.093,1.463-4.748,1.646-2.141,0.233-8.025,0.166-10.667,0.066s-4.279,0.536-5.417,1.811c-1.137,1.275-1.404,3.119,0.034,4.528s3.042,0.705,3.578-0.167c0.534-0.873,0.267-1.98,0.033-2.482-0.233-0.504,0.469-0.672,1.204-0.705,0.736-0.033,1.973,0.067,3.11,0.235,1.137,0.167,3.144,0.838,4.013,1.308,0.87,0.47,0.368,0.537-0.234,0.436s-1.27-0.335-2.341-0.736c-1.07-0.402-1.973-0.604-2.641-0.639-0.668-0.033-0.436,0.336-0.301,0.57,0.133,0.235,0.501,0.805,0.601,1.074,0.101,0.269-0.2,1.272-0.2,1.272l0.334,0.639s0.401-0.639,0.535-0.972c0.133-0.337-0.034-0.973,0.1-1.275s0.702-0.302,1.137,0.202c0.435,0.502,0.937,1.107,1.17,2.379,0.234,1.275-0.201,2.181-0.201,2.181s0.536,0.438,0.636,0.737c0.101,0.303-0.134,1.511-0.134,1.511s0.368,0.234,0.703-0.471c0.334-0.703,0.735-1.944,0.835-2.381,0.1-0.436,0.401-1.24,0.936-0.637s0.903,1.342,1.004,1.711c0.099,0.368,0.099,0.671,0.099,0.671s1.204-1.175,1.605-1.846,1.237-1.677,2.375-2.615c1.137-0.939,3.109-2.817,4.079-3.455,0.969-0.637,3.444-1.979,4.213-2.448s0.903-0.502,1.037-1.812c0.134-1.309,0.77-2.48,1.07-3.387,0.29-0.91,0.36-1.24,0.36-1.24z'/%3E%3Cpath fill='%23D4AF3A' d='M238.49,163.52c-0.022-0.223-0.468-1.006-0.579-1.408-0.112-0.401-0.513-0.157-0.513-0.157s-0.87,0.492-1.516,0.671-0.736-0.066-0.803-0.401c-0.066-0.338-0.223-1.387-0.334-2.125-0.112-0.736-0.268-0.691-0.535-0.582-0.267,0.113-1.07,0.403-1.627,0.65-0.557,0.245-0.379,0.514-0.201,0.826,0.178,0.314,0.825,1.632,1.114,2.102,0.29,0.469,0.022,0.671-0.313,0.828-0.334,0.156-0.824,0.223-1.493,0.446s-0.624,0.38-0.558,0.604c0.067,0.225,0.513,1.141,0.758,1.564,0.245,0.425,0.468,0.135,0.468,0.135s0.714-0.647,1.315-0.939c0.602-0.289,0.646-0.201,0.802,0.247,0.156,0.447,0.848,2.795,0.981,3.242,0.134,0.445,0.357,0.401,0.669,0.269,0.312-0.134,0.735-0.202,1.092-0.314,0.357-0.111,0.491-0.827,0.491-0.827s-1.315-2.369-1.672-2.974c-0.357-0.604,0-0.738,0.268-0.782,0.267-0.044,1.047-0.156,1.716-0.313,0.66-0.17,0.48-0.55,0.46-0.78z'/%3E%3Cpath fill='%23D4AF3A' d='M253.35,227.9c-0.1-0.571,0-1.142-0.435-1.577-0.435-0.437-0.97-1.308-1.17-2.012-0.2-0.705,0.167-1.04,0.1-1.443-0.066-0.402-0.602-0.402-1.136,0.035-0.536,0.436-1.238,0.838-1.238,2.112,0,1.273,0.469,2.784,2.241,3.319,1.77,0.54,1.74,0.14,1.64-0.43z'/%3E%3Cpath fill='%23D4AF3A' d='M255.15,227.29s-0.368-0.234-0.535,0.101-0.134,0.504,0.334,1.241,0.77,0.906,1.304,1.24c0.535,0.336,0.167-0.334,0.1-0.536-0.066-0.202,0-0.469-0.133-0.638-0.134-0.168-0.202-0.369-0.202-0.904,0-0.53-0.87-0.5-0.87-0.5z'/%3E%3Cpath fill='%23D4AF3A' d='M257.32,233.33c0.334-0.505,0.636-0.638,1.438-1.006s2.273-0.57,2.774-0.604c0.502-0.034,1.639-1.006,1.471-2.014-0.167-1.006-0.903-1.408-1.538-1.542s-1.204-0.134-1.404,0.167c-0.201,0.303-0.569,0.705-1.271,0.939s-0.803,0.47-1.237,0.604c-0.435,0.135-0.101,0.403-0.468,0.705-0.368,0.301-0.869,0-1.438-0.168-0.568-0.168-0.602-0.268-1.237-0.303-0.635-0.033-2.307-0.133-2.307-0.133s-0.067-0.034-0.434-0.034c-0.368,0-0.402,0.067-0.568,0.47-0.167,0.402,0.033,1.409,0.435,1.912,0.401,0.502,1.705,0.737,2.574,1.006,0.87,0.267,1.305,0.369,2.041,0.502,0.76,0.13,0.86-0.01,1.19-0.51z'/%3E%3Cpath fill='%23D4AF3A' d='M265.45,234.13c0.702-0.47,0.3-1.275,0.134-1.777-0.167-0.504-1.137-0.604-1.639-0.604s-0.769,0-1.037,0.234c-0.268,0.234-0.635,0.57-1.371,0.806-0.734,0.234-1.304,0.502-2.307,0.905-1.003,0.401-1.305,1.072-1.739,1.343-0.435,0.267-1.27,0-1.27,0s-0.603-0.169-0.803,0c-0.201,0.165,0,0.501,0.401,0.937,0.402,0.438,1.17,0.403,2.039,0.672,0.87,0.268,1.037,0.066,1.372-0.168,0.334-0.234,0.602-0.737,1.204-1.107,0.602-0.368,1.906-0.436,2.541-0.502,0.65-0.07,1.79-0.27,2.49-0.74z'/%3E%3Cpath fill='%23D4AF3A' d='M265.45,231.08c0.3,0.27,0.635,0.639,0.903,0.201,0.268-0.435,0.702-1.341,0.401-1.877-0.302-0.536-0.668-1.007-0.668-1.007s-0.502,1.543-0.736,1.946c-0.22,0.41-0.19,0.47,0.11,0.74z'/%3E%3Cpath fill='%23D4AF3A' d='M262.74,226.45c0-0.873-0.602-1.946-0.602-1.946s-0.201,0.805-0.568,1.51c-0.368,0.703-0.736,1.073-0.736,1.073s0.87,0.234,1.204,0.234,0.71,0.01,0.71-0.86z'/%3E%3Cpath fill='%23D4AF3A' d='M257.73,228.3c0.936-0.201,1.438-0.57,1.839-0.905s0.636-1.242,0.368-1.71c-0.267-0.472-0.936-0.973-1.203-0.973h-0.502s-0.268,0.872-0.635,1.308c-0.368,0.437-0.802,0.737-0.769,1.308,0.03,0.56-0.04,1.16,0.9,0.96z'/%3E%3Cpath fill='%23D4AF3A' d='M259.63,224.04c0.034-0.436-0.135-0.905-0.435-1.207-0.301-0.302-0.502-0.502-0.502-0.502s-0.067,0.67-0.133,1.039c-0.067,0.369-0.1,0.436-0.1,0.436s0.268,0.27,0.502,0.37c0.23,0.09,0.63,0.3,0.66-0.14z'/%3E%3Cpath fill='%23D4AF3A' d='M248.07,200.25l0.632-3.952c-0.475-3.951-2.53-7.691-4.162-10.274-1.634-2.581-3.32-6.638-4.058-8.799-0.737-2.161-1.232-5.119-1.232-6.667,0-1.55,0.661-2.347,0.661-2.347s0.287-0.42,0.022-0.686c-0.265-0.265-0.683-0.021-1.103,0.398s-0.86,1.194-1.037,1.747c-0.177,0.555-0.177,0.753-0.177,0.753s-0.838-0.198-2.184-0.087c-1.346,0.109-1.985,0.221-2.03,0.508-0.044,0.288,0.177,0.51,1.147,0.93,0.971,0.42,1.589,0.597,2.074,1.173,0.486,0.575,1.727,3.465,2.106,4.86,0.379,1.396,1.19,5.18,1.519,8.15s1.331,6.568,2.732,9.573c0.46,0.99,2.97,5.67,5.09,4.73z'/%3E%3Cpath fill='%23D4AF3A' d='M250.52,207.21c-0.915,0.511-0.881,4.25-0.475,6.188,0.407,1.939,2.305,4.353,2.881,4.999,0.577,0.646,0.712,0.646,1.018,0.476,0.306-0.169,0.44-0.169,0.44-0.169s0.814-0.272,1.425-0.748c0.609-0.477,0.372-1.667,0.27-2.721-0.102-1.056-0.915-3.164-2.406-5.61-1.48-2.45-2.23-2.93-3.14-2.42z'/%3E%3Cpath fill='%23D4AF3A' d='M251.53,204.18c0-1.22-1.058-2.142-2.274-2.142-0.575,0-1.082,0.145-1.396,0.428-1.234,1.113-0.49,3.891,1.293,3.891,0.646,0,1.401-0.108,1.868-0.555,0.42-0.39,0.51-1.04,0.51-1.62z'/%3E%3Cpath fill='%23D4AF3A' d='M269.21,239.32c-0.487-0.086-0.774-0.285-1.492-0.773-0.717-0.487-1.865-1.492-2.066-1.98-0.202-0.488-0.202-0.517-0.89-0.286-0.689,0.229-1.665,0.2-2.41,0.229-0.746,0.029,0.085,0.86,0.602,1.637,0.517,0.774,0.344,3.385,0.344,3.385s0,0.23-0.115,0.604c-0.115,0.372-0.028,0.631,0.172,0.717,0.201,0.086,0.315-0.086,0.832-0.69,0.517-0.602,1.464-2.179,1.464-2.179s0.144,0.027,0.947,0.229,2.095,0.086,2.755-0.115c0.68-0.2,0.36-0.69-0.13-0.78z'/%3E%3Cpath fill='%23D4AF3A' d='M266.14,241.34c-0.344-0.058-0.487-0.087-0.66,0.141-0.171,0.231-0.315,0.663-0.401,0.891-0.086,0.23-0.058,0.432,0.144,0.604,0.201,0.173,0.488,0.373,0.488,0.373s0.287,0.316,0.575,0.458c0.287,0.145,0.343-0.285,0.343-0.602,0-0.315,0.172-0.89,0.172-1.263s-0.3-0.55-0.65-0.6z'/%3E%3Cpath fill='%231D5E91' d='M396.62,216.11c-0.839-0.199-1.195-0.518-1.195-0.518s-0.359-0.04-0.641,0.479c-0.276,0.517-1.354,1.195-1.354,1.195s-1.515,0.4-1.715,1.438c-0.199,1.036,0.519,1.395,1.236,1.275,0.72-0.12,2.474-0.479,3.229-1.395,0.758-0.918,0.878-1.437,1.037-1.797,0.14-0.35,0.23-0.47-0.61-0.67z'/%3E%3Cpath fill='%231D5E91' d='M398.97,207.85c-0.545-2.306-2.034-5.155-4.905-6.582,0,0-1.077,3.79-1.396,4.987-0.32,1.195-0.32,1.156,0.598,1.396,0.916,0.238,3.867,0.876,4.466,1.036s1.6,0.67,1.24-0.85z'/%3E%3Cpath fill='%231D5E91' d='M385.29,205.7c0.677,0.12,0.598-0.16,0.837-1.077,0.239-0.916,1.435-5.463,1.435-5.463s-3.029-0.12-5.662,1.155c-2.633,1.276-3.789,3.629-3.789,3.629s0.679,0.279,2.474,0.679c1.8,0.39,4.03,0.95,4.71,1.07z'/%3E%3Cpath fill='%231D5E91' d='M378.27,211.96c-1.075-0.199-1.475-0.319-1.475-0.319s0.678,2.591,1.795,4.028c1.116,1.436,2.353,2.155,4.666,2.194,2.313,0.04,4.067-1.236,4.347-2.233,0.279-0.998,0.758-1.754,0.758-1.754s-4.188-0.561-5.903-0.959c-1.74-0.4-3.13-0.76-4.21-0.96z'/%3E%3Cpath fill='%23D4AF3A' d='M377.55,210.32c1.038,0.239,9.572,1.874,10.29,2.034,0.719,0.158,1.316,0.318,1.516,0.118,0.201-0.198,0.319-0.318,1.077-0.599,0.758-0.277,0.719-1.036,0.719-1.036s0.199-0.719,0.277-1.436c0.081-0.717,0.48-0.957,1.317-0.079,0.838,0.876,0.997,2.152,1.156,3.39,0.16,1.236,2.115,1.555,2.871,1.675,0.759,0.12,1.116-0.12,1.556-0.837,0.439-0.718,0.679-2.154,0.798-3.072,0.119-0.916,0.041-0.837-0.917-1.076-0.957-0.238-5.384-1.235-6.183-1.437-0.796-0.199-0.637-0.717-0.518-1.275s1.874-6.183,1.874-6.183c-1.249-0.772-3.004-1.232-5.104-1.475,0,0-1.276,5.742-1.517,6.621-0.238,0.876-0.798,0.876-1.714,0.716-0.918-0.158-7.539-1.712-7.539-1.712s0,0-0.517,1.234c-0.519,1.236-0.758,2.713-0.758,3.47s0.27,0.74,1.3,0.97z'/%3E%3Cpath fill='%23D4AF3A' d='M400.2,215.51c-0.88-0.575-1.527-0.727-1.985,0.344-0.459,1.071-0.496,2.64-1.642,3.748-1.146,1.109-2.75,2.256-4.354,2.142-1.603-0.115-2.52-0.498-2.139-2.333,0.383-1.835,2.827-2.409,3.399-3.365s0.42-2.065-0.421-2.791c-0.84-0.728-2.062-0.88-2.405-0.65-0.343,0.229-1.337,1.071-1.832,2.446-0.497,1.377-0.802,2.486-1.872,3.366-1.067,0.879-3.817,1.759-5.955,1.261-2.138-0.497-2.901-1.147-3.704-3.25-0.802-2.103-1.756-5.582-2.177-5.965-0.419-0.382-0.954-0.688-1.87-0.039-0.917,0.649-0.993,1.606-1.107,2.372-0.115,0.764,0,1.646,0.915,2.754,0.917,1.108,1.872,2.217,2.216,3.363,0.344,1.147,1.374,2.907-0.077,2.983-1.45,0.076-2.099,0.114-3.207-0.955-1.107-1.071-5.423-4.016-6.605-4.973-1.184-0.956-1.68-1.261-1.68-1.261-1.997-0.035-3.997-0.856-5.994-2.217,0,0,1.146,2.943,1.374,4.052,0.229,1.109,0.191,1.72,0.191,1.72s4.352,2.218,6.071,3.06c1.718,0.841,5.192,2.83,6.871,3.861,1.682,1.034,3.094,2.64,6.072,2.028,2.979-0.612,9.01-2.447,10.957-3.021,1.948-0.574,7.332-1.912,9.317-3.288s2.177-1.3,2.519-2.677c0.34-1.35,0-2.11-0.88-2.69z'/%3E%3Cpath fill='%23D4AF3A' d='M388.71,194.92c0.331-0.044,0.464-0.089,1.479-0.221,1.017-0.134,0.64,0.84,0.463,1.216-0.176,0.375-0.485,1.127-0.903,1.834-0.422,0.71,0.131,0.82,0.418,0.93,0.287,0.112,0.706,0.155,1.523,0.377,0.818,0.22,0.662-0.377,0.685-0.686,0.022-0.311,0.065-1.925,0.155-2.499,0.088-0.574,0.617-0.42,0.816-0.31s0.706,0.396,1.127,0.617c0.418,0.224,0.617-0.021,0.706-0.264s0.286-0.685,0.464-1.327c0.177-0.641-0.221-0.509-0.62-0.509-0.396,0-0.971,0-1.633-0.021-0.662-0.022-0.243-0.664-0.243-0.664s0.486-0.795,0.861-1.393c0.376-0.597,0.244-0.685-0.133-0.797-0.374-0.111-1.545-0.376-1.876-0.464-0.331-0.087-0.485-0.044-0.485,0.178s-0.045,1.37-0.045,1.813c0,0.441-0.043,0.707-0.618,0.729-0.574,0.021-0.928-0.312-1.391-0.819-0.464-0.507-0.662-0.309-0.707-0.109-0.044,0.199-0.42,1.658-0.508,2.056-0.11,0.39,0.11,0.37,0.44,0.32z'/%3E%3Cpath fill='%23D4AF3A' d='M391.91,209.41s-0.041,1.157-0.16,1.555c-0.12,0.4-0.398,0.998,0.08,1.157,0.479,0.16,0.917,0.358,1.194,0.279,0.281-0.079,0.16-0.638,0-1.116-0.158-0.479-0.397-1.078-0.757-1.476-0.35-0.39-0.35-0.39-0.35-0.39z'/%3E%3Cpath fill='%23D4AF3A' d='M398.93,214.03c0.16,0.358,0.479,0.438,0.719,0.519,0.239,0.079,0.559,0.079,0.559-0.359s0.079-0.997-0.278-1.476c-0.359-0.479-0.55-0.828-0.758-0.12-0.21,0.72-0.4,1.09-0.24,1.44z'/%3E%3Cpath fill='%23D4AF3A' d='M374.48,209.37c0.199,0.04,0.957,0.279,0.957,0.279s0-1.117,0.159-1.875c0.159-0.756,0.479-1.275,0.2-1.275s-0.438,0.239-0.64,0.558c-0.198,0.318-0.758,0.399-0.956,1.316-0.2,0.91,0.08,0.95,0.28,0.99z'/%3E%3Ccircle cy='207.45' cx='379.27' r='1.556' fill='%23B96B29'/%3E%3Ccircle cy='208.53' cx='383.65' r='1.595' fill='%23B96B29'/%3E%3Ccircle cy='211.24' cx='396.42' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='209.57' cx='388.04' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='205.74' cx='389.2' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='201.91' cx='390.32' r='1.596' fill='%23B96B29'/%3E%3Ccircle cy='207.3' cx='379.38' r='0.777' fill='%23D4AF3A'/%3E%3Ccircle cy='208.37' cx='383.77' r='0.798' fill='%23D4AF3A'/%3E%3Ccircle cy='211.08' cx='396.54' r='0.797' fill='%23D4AF3A'/%3E%3Ccircle cy='209.41' cx='388.16' r='0.797' fill='%23D4AF3A'/%3E%3Ccircle cy='205.58' cx='389.32' r='0.797' fill='%23D4AF3A'/%3E%3Ccircle cy='201.75' cx='390.44' r='0.798' fill='%23D4AF3A'/%3E%3C/g%3E%3Cuse xlink:href='%23g4017' transform='matrix(-1,0,0,1,639.96566,0)' height='320' width='640' y='0' x='0'/%3E%3C/g%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1800' height='900'%3E %3Crect width='1800' height='900' fill='%23cc092f'/%3E %3Crect width='1200' height='900' fill='%23ffd200'/%3E %3Crect width='600' height='900' fill='%230046ae'/%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23000' d='m847.69 183.24c-3.223 0-6.038 0.822-7.68 2.1 2.609 0.76 4.506 3.166 4.506 6.092v7.423h-7.422c-2.907 0-5.315-1.87-6.093-4.454-1.278 1.642-2.099 4.457-2.099 7.679 0 3.223 0.821 6.039 2.099 7.679 0.761-2.61 3.166-4.506 6.093-4.506h7.422v35.681c0 2.805-1.754 5.132-4.198 5.989 3.541 0.482 6.588 5.234 7.423 7.833 0.837-2.593 3.884-7.351 7.424-7.833-2.47-0.842-4.251-3.166-4.251-5.989v-35.683h7.424c2.908 0 5.315 1.87 6.093 4.456 1.277-1.642 2.098-4.459 2.098-7.68 0-3.223-0.82-6.038-2.098-7.679-0.761 2.609-3.167 4.504-6.093 4.504h-7.424v-7.422c0-2.908 1.869-5.315 4.455-6.093-1.64-1.276-4.457-2.098-7.679-2.098z'/%3E %3Cpath fill='%23f5d402' d='m847.69 184.78c-1.678 0-3.156 0.314-4.402 0.716 1.664 1.447 2.765 3.544 2.765 5.939v7.423c0 0.106-0.031 0.207-0.052 0.308v1.177h-1.178c-0.1 0.021-0.202 0.051-0.307 0.052h-7.424c-2.367 0-4.439-1.083-5.886-2.713-0.416 1.259-0.768 2.697-0.768 4.403 0 1.678 0.314 3.156 0.716 4.402 1.447-1.664 3.543-2.763 5.938-2.763h8.959c-0.01 0.154-0.052 0.303-0.052 0.459v0.768c0.021 0.1 0.051 0.201 0.052 0.307v35.681c0 2.317-1.195 4.139-2.765 5.58 1.123 0.693 2.09 1.565 2.918 2.561 0.737 0.885 1.03 1.751 1.536 2.661 0.507-0.908 0.799-1.776 1.536-2.661 0.815-0.978 1.768-1.82 2.867-2.509-1.584-1.437-2.765-3.305-2.765-5.631v-37.168h1.229c0.1-0.02 0.201-0.05 0.307-0.05h7.423c2.366 0 4.438 1.083 5.886 2.712 0.415-1.258 0.769-2.695 0.769-4.402 0-1.677-0.315-3.156-0.717-4.402-1.447 1.664-3.543 2.763-5.938 2.763h-7.423c-0.105 0-0.207-0.031-0.307-0.052h-1.178v-1.177c-0.021-0.099-0.051-0.201-0.052-0.308v-7.422c0-2.367 1.084-4.438 2.713-5.887-1.259-0.414-2.696-0.768-4.402-0.768'/%3E %3Cpath fill='%23000' d='m940.609,313.987c-4.535-3.221-8.258-6.862-10.904-11.11-6.372-10.223-9.061-22.773-9.061-35.527,0-5.391,6.04-11.46,6.04-15.82,0-6.59-0.614-10.544-0.614-10.544,2.143,0.292,5.887,4.095,5.887,4.095s-0.129-10.938-3.585-12.849c0,0,1.398-1.438,6.451-1.587-1.42-3.596-8.446-7.986-8.446-7.986,0.351-0.629,1-1.173,1.842-1.638,1.765-0.976,4.245-1.62,6.142-1.997-2.022-0.419-4.352-1.061-6.91-1.895-5.842-1.903-12.719-4.697-19.146-7.78-11.732-5.628-20.669-5.99-25.596-5.9895-3.575,0.0005-8.84,0.0985-11.927,2.1515-2.825,1.875-2.595,4.314-3.584,5.17-2.33,2.016-6.321,1.945-8.243,1.945-12.44,0-12.901,13.311-12.901,13.311s3.181-4.813,8.805-4.813c9.351,0,16.433,5.094,16.433,7.013,0,0.777-0.964,0.921-1.023,0.921-6.108,0-15.326-3.516-20.223-3.686v2.406c10.931,3.803,22.013,9.187,22.013,32.917,0,14.943-1.789,30.19-9.265,42.183-2.648,4.247-6.418,7.881-10.955,11.11l44.385,7.9995z'/%3E %3Cg id='eagle_half'%3E %3Cpath fill='%23000' d='m896.222,303.988-44.383,10.0005c-2.019-0.61-11.513-3.56-18.174-7.269-11.726-6.532-17.806-13.031-31.74-13.669v-10.598c0-5.662,2.049-10.763,2.049-16.177-5.874-1.575-22.178-21.51-37.218-30.358-22.13,14.334-39.265,37.865-39.265,48.686,0,0,0.665,232.51,0,313.51,0,4.668-2.815,11.263-2.815,11.263,8.079-3.418,22.888-23.68,26.006-31.382v3.687c12.201-5.564,21.135-20.184,25.136-27.747,0.071,1.093,0.257,3.838,0.257,3.838,10.9-9.555,24.776-66.038,24.776-66.038l23.124,22.7255s-8.363,16.9755-11.621,20.0155c0,0,2.184,0.277,4.658,0.256-1.522,2.188-13.147,18.925-16.791,25.238-3.41,5.906-5.816,3.277-11.058,3.277-4.347,0-14.2,6.925-15.818,9.727-1.701,2.945-2.968,6.523-2.968,9.471,0,3.24,3.43,7.679,3.43,7.679,0.369-1.551,1.023-2.099,1.023-2.099s9.013,11.228,10.341,12.695c1.034,1.143,5.645,1.886,7.27,0.411,4.066-3.697,8.002-6.282,11.621-11.621,1.863-2.751,2.005-5.904,4.146-8.858,7.162-9.88,21.415-28.799,24.675-33.121,0.218,1.203,0.405,2.205,0.612,3.43,3.694-7.457,21.451-21.706,21.451-21.706l18.578,8.55s-34.687,79.735-65.476,91.995c0,0,13.395,5.691,29.845,14.232,2.4,1.246,4.871,2.584,7.372,3.943,2.071-2.494,4.251-5.265,6.399-8.141,9.836-13.16,19.455-28.412,19.455-28.412,0.67,3.961-4.524,16.194-13.31,31.281-1.728,2.964-3.53,6.064-5.529,9.213,2.229,1.273,4.441,2.559,6.655,3.892,16.295,9.805,31.598,21.077,37.267,31.432l4,-10.009 -4,-10.009v-349.957l2,-5z'/%3E %3Cg fill='%23b07f55'%3E %3Cpath d='m896.202,667.221c-5.749-6.236-17.769-13.855-31.278-20.886,16.334-29.316,24.428-75.655,20.63-84.88,0,0-6.705,24.033-14.898,37.729-7.586,12.684-16.925,26.95-25.954,37.526-7.428-3.169-14.631-5.828-20.785-7.68,27.058-20.843,54.726-89.742,54.726-89.742l-28.612-13.26s-10.704,12.479-14.18,14.796c0,0-1.485-6.206-2.355-8.396,0,0-4.101,3.102-6.346,3.176,0,0-0.671-4.212-1.178-6.964-2.825,1.883-7.525,1.485-7.525,1.485,4.127-1.954,9.01-13.925,9.01-13.925l-27.322-36.343s-9.597,46.116-20.528,55.596v-198.58l8.652,8.036,13.105-12.235v-9.317l-11.621,10.852v-28.105c1.751-2.649,2.912-4.626,3.788-6.194,1.881,3.279,7.96,13.329,15.101,19.505,1.175-4.778,8.908-9.318,8.908-9.318s2.771,7.508,7.012,9.368c1.492-2.628,10.394-8.446,10.394-8.446s-7.616,1.157-10.7,4.045c-2.649-0.593-3.328-11.058-3.328-11.058s-11.207,5.459-13.156,9.368c-2.137-0.578-5.464-8.988-6.759-12.44,1.955-0.213,4.716-0.46,8.345-0.46,3.196,0,7.285,1.514,11.569,3.532,4.707,2.216,9.631,5.022,14.028,7.014,5.632,2.55,14.153,3.068,16.637,3.174-2.845,2-5.973,3.826-9.367,5.529,0,0,13.411-0.124,22.832-4.813,3.361-2.162,6.849-4.316,9.829-6.86-1.293,3.593-3.306,7.839-6.452,11.467,13.836-1.171,20.726-9.072,22.679-11.723,0.918,2.375,2.553,6.187,5.119,9.47h5v340z'/%3E %3Cpath d='m794.247,267.298,0.255,6.348,0,18.687c-5.019-1.727-11.326-9.973-14.384-14.334v-2.56c0-2.408,1.417-4.167,2.457-5.119l-3.02-1.074c-1.152,1.313-2.406,3.263-2.406,5.784v1.485l-9.009,9.676-8.856-13.413v-3.276c0-2.208,1.698-4.67,3.123-6.348l-2.97-1.075c-1.499,1.942-3.072,4.559-3.072,7.013v2.661c-2.083,2.156-10.187,10.496-10.187,10.496s-4.066-8.737-5.17-11.109c6.205-8.595,16.266-18.219,25.7488-25.1245,0,0,20.5642,18.8805,27.4902,21.2825z'/%3E %3Cpath d='m742.127,285.421,0,15.411-7.167,6.654,0-22.883c0-2.191,0.918-4.831,2.4565-7.731z'/%3E %3Cpath d='m764.447,291.359,0,9.522-8.241,7.731,0-29.794z'/%3E %3Cpath d='m753.286,308.561-8.243-7.679,0-11.159,8.243-8.652z'/%3E %3Cpath d='m790.913,296.991c-1.914,2.705-6.927,9.321-12.337,12.236v-26.1605c1.241,2.0645,6.934,11.2745,12.337,13.9245z'/%3E %3Cpath d='m775.656,284.397,0,24.163-8.243-7.679,0-8.549z'/%3E %3Cpath d='m742.126,310.147,0,24.113-7.167-6.707,0-10.7z'/%3E %3Cpath d='m753.28,317.878,0,8.651-8.244,7.678,0-24.0085z'/%3E %3Cpath d='m764.438,310.2,0,24.01-8.241-7.731,0-8.549z'/%3E %3Cpath d='m775.651,317.93,0,8.549-8.243,7.73,0-24.0095z'/%3E %3Cpath d='m786.81,334.26-8.244-7.731,0-8.036c2.843-1.735,5.702-4.924,8.2435-8.2935z'/%3E %3Cpath d='m765.925,344.908,8.703-8.089,0,198.63s0.607,9.856,1.024,16.279c-3.87,3.912-18.429,18.634-18.429,18.634v-233.596z'/%3E %3Cpath d='m752.253,562.94c0,6.385-11.659,21.273-17.303,24.675v-250.74l8.6,8.036,8.703-8.0895z'/%3E %3C/g%3E %3Cg fill='%23d10429'%3E %3Cpath d='m824.535,541.388,6.348-4.352s0.423,2.1,0.972,4.967c-2.718,3.716-18.331,25.024-26.057,35.425-1.921,2.584-3.534,9.163-3.534,9.163s-2.814-1.331-2.814-3.736c0-2.362,0.308-5.171,0.308-5.171s-2.101,2.406-5.735,2.406c0-2.903,5.614-6.052,5.836-10.186-4.281,3.174-7.999,1.545-12.951,3.072-5.393,1.661-6.895,3.927-8.549,3.84-0.974-0.053-1.856-1.733-1.484-2.765,0.644-1.787,7.314-6.733,11.977-7.627,1.117-0.214,9.903,1.912,11.673-0.819,7.292-11.252,19.13-29.518,20.272-31.278,0.752-0.18,1.444-0.371,1.9955-0.719,0,0-0.0675,5.751,1.7425,7.78z'/%3E %3Cpath d='m783.72,576.452c0.353,0.408,0.322,1.006-0.053,1.33l-2.866,2.508c-0.375,0.324-0.977,0.255-1.33-0.154-0.354-0.408-0.324-1.006,0.052-1.331l2.866-2.508c0.187-0.163,0.428-0.233,0.6655-0.204,0.2375,0.027,0.4875,0.154,0.6655,0.359z'/%3E %3Cpath d='m788.071,579.472c0.857,0.988,0.802,2.388-0.103,3.175l-6.962,6.091c-0.906,0.788-2.367,0.63-3.226-0.357-0.857-0.988-0.803-2.439,0.103-3.225l6.962-6.041c0.339-0.296,0.802-0.477,1.229-0.5125,0.712-0.0585,1.46,0.2535,1.997,0.8695z'/%3E %3Cpath d='m792.061,584.182c0.857,0.988,0.803,2.387-0.103,3.174l-7.012,6.092c-0.906,0.787-2.316,0.63-3.175-0.358-0.858-0.987-0.803-2.438,0.104-3.224l6.961-6.041c0.339-0.295,0.75-0.476,1.178-0.5125,0.711-0.0585,1.51,0.2515,2.047,0.8695z'/%3E %3Cpath d='m794.464,587.919c0.713-0.058,1.461,0.201,1.997,0.819,0.858,0.988,0.803,2.439-0.102,3.225l-6.963,6.042c-0.906,0.787-2.316,0.629-3.174-0.359s-0.854-2.388,0.051-3.175l7.014-6.091c0.338-0.296,0.749-0.427,1.177-0.461z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23eagle_half' transform='matrix(-1,0,0,1,1792.404,0)'/%3E %3Cpath fill='%23b07f55' d='m885.934,206.637c11.458,0,19.517,5.224,30.359,10.033,2.841,1.26,5.45,2.281,7.779,3.071-1.459,1.293-2.594,2.592-2.918,3.687,0,0,4.859,0.9,7.064,4.967,0,0-4.62,0.524-5.375,3.224,2.588,0.195,5.159,3.457,5.171,6.605l-6.553-2.049s1.587,7.358,1.587,15.358c0,4.086-5.886,8.894-5.886,15.819,0,21.734,5.475,30.088,9.369,36.807,1.523,2.629,2.761,5.654,5.324,7.935-11.218-5.973-19.556-13.439-19.556-20.374v-26.262h-2.918v26.262c0,5.029,1.228,7.372,1.228,7.372,1.761,5.564,5.321,14.152,7.526,17.61-10.321-5.578-15.564-12.563-15.564-15.153v-36.092h-2.918v36.603l0.563,2.508c-1.251,1.88-2.877,4.106-3.993,4.863-1.113-0.756-2.69-2.986-3.943-4.863l0.564-2.508v-36.603h-2.918v36.092c0,2.589-5.243,9.575-15.563,15.153,2.205-3.459,5.764-12.046,7.524-17.61,0,0,1.229-2.342,1.229-7.372v-26.262h-2.918v26.262c0,6.927-8.307,14.405-19.505,20.374,2.537-2.283,3.757-5.321,5.272-7.935,4.258-7.348,9.522-16.683,9.522-43.258,0-9.974-1.475-16.755-4.044-21.501-0.781-1.566-1.833-5.734,4.146-5.734,3.097,0,10.188,5.478,10.188,5.478s-0.292-4.371-3.891-6.86c-0.597-0.413-1.586-1.712-1.586-2.919,0-0.904,1.551-3.135,2.763-3.686,0.833-0.378-12.183-2.646-12.183-8.549,0-1.229,0.773-2.048,3.479-2.048,3.545,0,9.312,4.249,14.438,4.249,3.789,0,5.283-0.922,9.163-0.922,4.742,0,14.635,8.979,18.019,8.651-3.783-2.375-9.894-11.365-19.145-11.365-3.211,0-6.117,0.717-9.114,0.717-3.841,0-7.623-3.533-11.774-3.533-2.782,0-5.889,0.155-6.349-0.564-0.805-1.255-0.08-1.983,0.666-3.02,1.409-1.957,5.366-2.525,9.267-2.661,1.17-0.041,2.338-0.061,3.4325-0.0505,1.0905,0.0115,2.0995,0.0535,2.9715,0.0535z'/%3E %3Cpath fill='%23cc092f' d='m848.73 220.69s2.419-4.581 8.534-4.581c2.556 0 10.992-0.177 10.992-0.177 1.124 2.921 6.249 7.802 6.249 12.878 0 0-5.202-9.377-19.723-9.377-3.649 0-6.054 1.256-6.054 1.256z'/%3E %3Cpath fill='%23d10429' d='m872.34 230.6s-3.093 3.258-3.765 4.997c-3.061-1.16-8.399-6.661-8.399-6.661s4.525 2.642 12.163 1.664z'/%3E %3Cpath fill='%23000' d='m867.44 221.97s-3.568-1.144-3.568-2.342c0-1.526 1.733-1.526 2.769-0.337 0.713 0.819 0.798 2.68 0.798 2.68z'/%3E %3Cellipse fill='%23000' cx='882.798' cy='222.06' rx='5.112' ry='4.043'/%3E %3Ccircle fill='%23f5d402' cx='882.8' cy='222.06' r='3.56'/%3E %3Ccircle fill='%23000' cx='882.799' cy='222.06' r='1.511'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23000'%3E %3Crect width='20.503' height='20.503' x='1052.3' y='157.29' transform='matrix(0.7902,0.4311,-0.1917,0.8793,0,0)'/%3E %3Cpath d='m725.9 418.73-5.836 2.663 65.936 144.42h7.014zm77.762 170.32-4.76 4.915 2.969 6.553 5.784-2.662z'/%3E %3Cpath d='m746.39 532.6s5.554 11.472 9.775 13.045c-2.183-0.595-9.271 2.006-9.271 2.006s12.499 11.165 23.1 11.898c8.99 0.619 13.355-3.868 13.355-3.868l-1.801-9.524s-5.5-6.642-14.302-9.707c-8.894-3.098-20.857-3.848-20.857-3.848z'/%3E %3Cpath d='m788.26 512.05s-7.669 6.565-9.768 14.169c-2.1 7.605 1.368 16.247 1.368 16.247l6.444 12.021s8.931-4.753 12.73-11.86c3.799-7.108 2.406-16.698 2.406-16.698s-7.075 2.634-7.975 3.8c1.493-7.884-5.206-17.679-5.206-17.679z'/%3E %3Cpath d='m763.61 508.98s-8.722 2.948-17.192 2.438c-8.068-0.487-14.777-7.262-14.777-7.262s6.688-4.526 9.989-3.923c-3.631-1.327-8.896-10.423-8.896-10.423s7.482-2.261 14.116 0.24c6.634 2.503 12.419 9.77 12.419 9.77l4.342 9.16z'/%3E %3Cpath d='m766.61 466.38s4.362 9.032 3.328 12.171c1.353-2.09 6.474-5.345 6.474-5.345s3.096 14.624 0.135 23.656c-2.96 9.031-11.974 12.47-11.974 12.47l-9.943-19.337s-1.48-7.164 1.62-12.837c3.101-5.673 10.36-10.779 10.36-10.779z'/%3E %3Cpath d='m709.86 442.47s9.427-0.99 18.051 2.583c7.21 2.993 9.42 8.433 9.42 8.433l3.551 9.52s-10.261 3.848-18.368 0.906c-8.108-2.945-14.065-12.68-14.065-12.68s5.666-2.149 7.823-1.343c-3.142-1.39-6.41-7.419-6.41-7.419v0.001z'/%3E %3Cpath d='m739.51 424.8s4.137 5.313 4.261 11.424c1.103-3.249 6.268-6.84 6.268-6.84s5.312 12.855 4.146 21.982c-1.166 9.128-8.809 14.527-8.809 14.527l-9.531-18.092s-3.106-7.415-2.191-13.167c0.916-5.75 5.856-9.836 5.856-9.836z'/%3E %3Cpath d='m706.86 390.2s-1.709 9.854 1.199 15.53c2.598 5.065 4.252 6.176 4.252 6.176-4.954-3.269-12.444-3.551-12.444-3.551s2.666 10.721 9.037 15.612 16.195 3.748 16.195 3.748 6.46-8.6 6.01-17.865c-0.449-9.265-7.808-19.197-7.808-19.197s-2.902 6.02-3.158 10.514c-1.878-4.633-13.285-10.966-13.285-10.966z'/%3E %3Cpath d='m783.86 555.27 0.265 3.537c5.875 0.055 6.75-0.53 8.256 1.322 1.003 1.234 3.389 2.311 5.787 1.215 2.4-1.095 3.475-3.977 2.38-6.376s-3.326-2.92-5.475-2.496c-1.319 0.26-2.187 1.313-3.306 1.891-2.128 1.102-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m783.35 552.57 2.859 2.095c-3.067 5.014-4.024 5.446-3.251 7.705 0.515 1.504 0.166 4.097-2.035 5.553-2.2 1.455-5.214 0.841-6.669-1.358-1.454-2.2-0.715-4.366 0.783-5.965 0.92-0.982 2.27-1.16 3.353-1.803 2.062-1.223 4.959-6.228 4.959-6.228z'/%3E %3Cpath d='m763.45 510.57 0.264 3.537c5.876 0.054 6.75-0.53 8.256 1.321 1.002 1.233 3.389 2.311 5.787 1.215 2.401-1.095 3.476-3.976 2.379-6.375-1.095-2.4-3.325-2.92-5.474-2.496-1.32 0.261-2.187 1.313-3.305 1.891-2.129 1.101-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m764.64 511.82 2.5 2.517c-3.809 4.474-4.824 4.753-4.411 7.104 0.276 1.567-0.473 4.075-2.874 5.17-2.399 1.095-5.279 0.021-6.376-2.379-1.095-2.399-0.028-4.425 1.701-5.771 1.061-0.825 2.425-0.793 3.593-1.258 2.227-0.887 5.867-5.382 5.867-5.382z'/%3E %3Cpath d='m743.67 468.72 0.265 3.537c5.876 0.054 6.75-0.53 8.257 1.323 1.003 1.231 3.388 2.309 5.788 1.213 2.398-1.095 3.474-3.975 2.379-6.377-1.097-2.399-3.326-2.919-5.476-2.495-1.32 0.261-2.187 1.313-3.306 1.891-2.128 1.102-7.908 0.907-7.908 0.907z'/%3E %3Cpath d='m745.3 467.98 2.499 2.516c-3.809 4.475-4.822 4.754-4.411 7.105 0.276 1.566-0.473 4.074-2.873 5.169-2.399 1.094-5.28 0.02-6.376-2.379-1.094-2.4-0.027-4.426 1.701-5.771 1.061-0.827 2.424-0.793 3.594-1.26 2.227-0.887 5.866-5.38 5.866-5.38z'/%3E %3Cpath d='m722.6 424.54 0.264 3.536c5.876 0.055 6.751-0.53 8.256 1.321 1.004 1.234 3.39 2.311 5.788 1.217 2.4-1.097 3.475-3.977 2.38-6.377s-3.326-2.921-5.476-2.496c-1.318 0.261-2.186 1.314-3.305 1.891-2.128 1.101-7.909 0.908-7.909 0.908z'/%3E %3Cpath d='m724.23 423.8 2.498 2.517c-3.808 4.475-4.823 4.753-4.41 7.105 0.276 1.566-0.474 4.074-2.873 5.169-2.4 1.095-5.28 0.021-6.375-2.379-1.096-2.399-0.028-4.427 1.699-5.771 1.062-0.825 2.425-0.793 3.594-1.26 2.226-0.886 5.866-5.38 5.866-5.38z'/%3E %3C/g%3E %3Cg fill='%23f5d402'%3E %3Crect width='12.717' height='12.718' x='1056.2' y='161.19' transform='matrix(0.7902,0.4311,-0.1917,0.8793,0,0)'/%3E %3Cpath d='m759.72 500.09c-2.106 0.874-5.23-8.295-7.524-13.318-2.353-5.155-7.131-13.1-5.774-13.72 1.489-0.68 3.451 3.492 5.859 8.767 2.408 5.273 9.412 17.449 7.439 18.269z'/%3E %3Cpath d='m738.09 451.8c-2.105 0.877-4.41-5.127-6.703-10.151-2.353-5.154-4.645-8.795-3.288-9.415 1.49-0.68 3.69 3.837 5.616 8.055 1.866 4.088 6.348 10.69 4.374 11.512z'/%3E %3Cpath d='m788.13 561.29c-1.653 0.442-8.869-14.662-14.703-27.442-5.833-12.779-10.177-23.119-8.82-23.736 1.49-0.681 6.213 11.391 12.049 24.172 5.835 12.781 12.713 26.673 11.475 27.006z'/%3E %3C/g%3E %3Cg fill='%23097754'%3E %3Cpath d='m709.76 396.19s-0.255 7.201 2.127 11.285c2.383 4.086 7.704 5.715 7.704 5.715s0.254-7.199-2.128-11.283c-2.383-4.086-7.703-5.717-7.703-5.717z'/%3E %3Cpath d='m704.78 412.48s6.255 0.368 9.868 3.136c3.61 2.768 5.009 8.535 5.009 8.535s-4.146 0.421-7.756-2.347c-3.611-2.769-7.121-9.324-7.121-9.324z'/%3E %3Cpath d='m724.41 397.94s-2.08 4.77-1.84 9.912c0.239 5.143 3.24 10.937 3.24 10.937s2.713-6.174 2.474-11.318c-0.238-5.143-3.147-8.075-3.874-9.531z'/%3E %3Cpath d='m713.88 444.3s3.071 4.288 7.799 6.626c4.728 2.337 11.773 2.424 11.773 2.424s-3.516-4.562-8.245-6.9c-4.728-2.337-11.327-2.152-11.327-2.152z'/%3E %3Cpath d='m715.4 454.26s2.257 4.421 6.384 6.316c4.129 1.896 12.574 1.74 12.574 1.74s-3.24-4.131-7.368-6.027c-4.128-1.897-11.591-2.029-11.591-2.029z'/%3E %3Cpath d='m739.17 430.68s-2.495 4.123-2.251 8.666c0.245 4.545 3.227 9.511 3.227 9.511s2.097-5.693 1.852-10.237c-0.244-4.545-2.829-7.94-2.829-7.94z'/%3E %3Cpath d='m748.36 436.51s-4.269 5.73-4.882 11.621c-0.613 5.89 2.428 11.942 2.428 11.942s5.157-5.178 5.77-11.068c0.613-5.892-3.316-12.493-3.316-12.493z'/%3E %3Cpath d='m736.59 490.91s0.513 2.118 2.297 4.367c1.783 2.251 4.836 4.632 4.836 4.632s2.949-0.948 6.615-0.155c3.665 0.795 8.54 4.06 8.54 4.06s-5.247-7.831-10.695-10.876c-5.448-3.043-11.591-2.029-11.591-2.029z'/%3E %3Cpath d='m736.05 504.37s6.793-2.902 12.387-2.153c5.595 0.749 10.639 5.171 10.639 5.171s-7.561 2.616-13.155 1.868c-5.596-0.749-9.872-4.886-9.872-4.886z'/%3E %3Cpath d='m764.76 472.79s-6.007 6.364-6.511 11.887c-0.503 5.522 4.871 10.669 4.871 10.669s-0.264-3.542 0.661-5.874c0.926-2.332 2.893-4.822 2.893-4.822s0.838-2.843 0.514-5.123c-0.453-3.186-2.428-6.737-2.428-6.737z'/%3E %3Cpath d='m773.38 480.16s-5.662 5.729-7.158 11.864c-1.497 6.135 1.17 12.676 1.17 12.676s5.149-4.062 6.646-10.196c1.497-6.135-0.659-14.344-0.659-14.344z'/%3E %3Cpath d='m787.56 517.14s2.565 5.355 3.215 9.833c0.652 4.477 0.048 6.027 0.048 6.027s-2.652 2.607-3.841 4.14c-1.528 1.97-1.752 5.576-1.752 5.576s-5.325-7.916-4.504-13.703c0.82-5.786 6.834-11.874 6.834-11.874z'/%3E %3Cpath d='m798.78 529.53s-6.818 4.503-9.523 9.123c-2.708 4.617-1.304 9.349-1.304 9.349s4.858-0.428 7.566-5.046c2.706-4.618 3.26-13.427 3.26-13.427z'/%3E %3Cpath d='m753.98 548.55s9.826-0.268 15.832 1.209c6.006 1.475 8.192 4.695 8.192 4.695s-6.753 3.162-12.759 1.686c-6.006-1.475-11.266-7.591-11.266-7.591z'/%3E %3Cpath d='m752.32 536.89s4.433 6.873 10.164 9.367c7.898 3.435 17.043 1.77 17.043 1.77s-4.968-6.089-11.804-8.777c-6.838-2.687-15.403-2.359-15.403-2.359z'/%3E %3C/g%3E %3Cpath fill='%23000' d='m1088.74,401.944,1.281,2.712s-2.08,0.714-3.022,2.559c-0.94,1.847,0.615,4.455,0.615,4.455s-10.804-0.943-12.491,0.154c-1.528,0.99,0.647,8.474-0.359,14.795-1.402,8.81-4.875,8.07-5.017,9.777-0.138,1.659,1.331,4.249,1.331,4.249s-2.026,0.638-2.458,1.485c-0.695,1.362,0.484,3.875-0.358,5.528-4.7,9.223-11.64,22.836-16.228,31.843-0.641,1.257-2.363,1.737-3.226,3.43-0.796,1.562-0.153,3.839-0.153,3.839s-3.041,0.182-4.096,2.253c-1.121,2.2-0.461,5.17-0.461,5.17s-1.923,0.246-2.868,2.099c-1.009,1.981,0.7,3.02,0.259,3.891-6.169,12.102-13.434,26.368-17.867,35.068-1.631,3.199-7.338,3.84-10.65,10.341-3.214,6.306,1.382,10.955,1.382,10.955s-4.772,0.432-6.04,2.919c-1.292,2.535-0.27,6.384,3.174,8.139,3.444,1.754,7.207,0.334,8.5-2.201,1.267-2.487-1.281-6.604-1.281-6.604s6.463,0.931,9.675-5.376c3.313-6.501,0.52-11.441,2.15-14.641,4.434-8.7,11.7-22.965,17.867-35.068,0.445-0.871,2.267-0.117,3.276-2.098,0.944-1.853,0-3.532,0-3.532s2.822-1.23,3.943-3.431c1.056-2.071-0.563-4.658-0.563-4.658s2.223-0.792,3.02-2.354c0.862-1.693,0.228-3.35,0.869-4.609,4.59-9.006,11.531-22.62,16.229-31.841,0.843-1.655,3.555-2.221,4.249-3.585,0.432-0.846-0.255-2.866-0.255-2.866s2.988-0.296,4.248-1.383c1.298-1.118-1.337-3.516,4.967-9.829,4.522-4.528,11.817-7.192,11.722-9.01-0.105-2.01-7.218-10.187-7.218-10.187s3.001-0.253,3.942-2.098c0.941-1.846,0.308-3.994,0.308-3.994l2.968-0.512,0.0005-14.078zm-98.136,196.074c-0.448,0.877-0.53,2.076,0,3.121,0,0-3.583-1.12-4.812-0.512-1.158,0.573,0,17.458,0,17.458s14.295-9.018,14.077-10.29c-0.23-1.352-3.225-3.635-3.225-3.635,1.158-0.186,2.061-0.912,2.509-1.791,0.47-0.925,0.533-3.568-2.714-5.223-1.216-0.62-2.299-0.804-3.1745-0.716-1.4555,0.147-2.3655,1.01-2.6605,1.588z'/%3E %3Cg fill='%23f5d402'%3E %3Cpath d='m1091.34,402.51,6.757,3.431-0.101-8.1405z'/%3E %3Cpath d='m1088.73,407.425c-0.868,1.704-0.025,3.886,1.894,4.863,1.92,0.977,4.148,0.373,5.018-1.33,0.868-1.704,0.023-3.885-1.895-4.863-0.72-0.367-1.476-0.511-2.2015-0.4615-1.2075,0.0825-2.2725,0.7265-2.8155,1.7915z'/%3E %3Cpath d='m1077.11,413.62c-0.711,0.46,0.256,6.545,0.051,11.722-0.194,4.882-1.756,6.257-2.611,7.935-0.789,1.549-3.634,3.379-3.634,3.379l2.354,2.355s1.532-2.386,3.942-7.118c2.843-5.579,2.751-15.688,3.585-16.227,0.725-0.469,6.655-1.946,6.655-1.946-0.001,0-5.442-0.294-8.447-0.2545-1.003,0.0125-1.73,0.0475-1.895,0.1545z'/%3E %3Cpath d='m1077.73,441.725s0.787-2.188,3.533-7.577c3.311-6.499,10.379-11.213,10.544-12.389,0.172-1.212-2.4565-6.9105-2.4565-6.9105s-6.2355,1.1955-7.1175,2.0485c-0.852,0.823-0.476,9.267-3.788,15.767-2.744,5.388-4.094,7.372-4.094,7.372z'/%3E %3Cpath d='m1093.65,422.22c0.052,0.989-8.163,6.861-11.007,12.439-2.41,4.731-3.43,7.373-3.43,7.373l3.277,0.512s-0.226-3.367,0.563-4.915c0.854-1.677,1.079-3.731,4.915-6.757,4.068-3.209,9.567-6.014,9.522-6.861-0.041-0.782-6.1435-8.344-6.1435-8.344s2.2565,5.692,2.3035,6.553z'/%3E %3Cpath d='m1069.59,458.72c4.936-9.688,6.444-10.348,7.065-11.569,0.669-1.312,0.509-3.078-1.689-4.199-0.824-0.419-1.531-0.526-2.1495-0.459-1.0335,0.111-1.7845,0.767-2.2015,1.586-0.622,1.222-0.285,2.855-5.223,12.544l-11.212,21.961s-1.175,2.156,1.024,3.276c2.199,1.119,3.174-1.127,3.174-1.127z'/%3E %3Cpath d='m1049.78,483.908c-0.611,1.201,0.436,2.964,2.355,3.943,1.919,0.976,3.996,0.791,4.607-0.41,0.611-1.2-0.486-2.964-2.406-3.943-0.959-0.489-1.935-0.687-2.7645-0.613-0.8295,0.072-1.4855,0.424-1.7915,1.023z'/%3E %3Cpath d='m1045.63,490.153c-0.792,1.553,0.443,3.783,2.765,4.968,2.322,1.183,4.84,0.886,5.631-0.667,0.792-1.554-0.444-3.782-2.765-4.967-0.871-0.442-1.733-0.677-2.5595-0.716-1.3745-0.065-2.5765,0.411-3.0715,1.382z'/%3E %3Cpath d='m1043.02,497.117c-0.611,1.199,0.437,2.963,2.355,3.941,1.919,0.978,3.995,0.791,4.608-0.409,0.611-1.2-0.437-2.964-2.355-3.942-0.96-0.49-1.986-0.688-2.8155-0.615-0.8285,0.073-1.4855,0.424-1.7925,1.025z'/%3E %3Cpath d='m1041.33,503.772s-12.448,24.5-16.84,33.121c-1.404,2.754-7.312,4.47-9.625,9.011-2.33,4.568-0.686,8.844,2.354,10.392,3.039,1.549,7.502,0.423,9.83-4.146,2.313-4.54,0.235-10.353,1.637-13.106,4.393-8.624,16.843-33.122,16.843-33.122s1.226-2.156-0.973-3.276c-0.55-0.28-1.028-0.308-1.433-0.2555-1.212,0.1555-1.793,1.3815-1.793,1.3815z'/%3E %3Cpath d='m1009.84,560.646c-0.933,1.83,0.134,4.269,2.405,5.426,2.272,1.158,4.904,0.601,5.837-1.228,0.933-1.83-0.186-4.27-2.457-5.427-0.852-0.435-1.721-0.637-2.56-0.6135-1.399,0.0395-2.643,0.6995-3.225,1.8425z'/%3E %3Cpath d='m993.257,598.069c-0.71,0.024-1.298,0.249-1.535,0.717-0.477,0.935,0.508,2.413,2.201,3.276,1.693,0.862,3.464,0.782,3.942-0.154,0.477-0.937-0.51-2.414-2.201-3.276-0.847-0.432-1.695-0.588-2.407-0.564z'/%3E %3Cpath d='m987.421,602.675v12.082l9.83-7.065s-1.333-2.354-4.25-3.84c-2.917-1.485-5.58-1.178-5.58-1.178z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23f5d402' d='m993.643,333.597c0-6.626,8.703-13.157,8.703-13.157h-212.246s8.703,6.53,8.703,13.157v157.986c0,4.162,1.286,6.872,3.328,9.521,2.041,2.853,6.39,6.795,10.903,9.727,13.94,9.053,37.246,18.599,54.88,26.621,14.694,6.684,20.671,9.381,28.309,18.839,7.639-9.458,13.667-12.154,28.361-18.839,17.631-8.021,40.938-17.568,54.879-26.621,4.515-2.932,8.864-6.873,10.904-9.727,2.042-2.649,3.276-5.359,3.276-9.521z'/%3E %3Cpath fill='%23d10429' d='m803.82,422.981,0-89.385c0-5.059-2.5605-8.139-2.5605-8.139h189.928s-2.56,3.081-2.56,8.139l0.054,89.385-92.4305,28z'/%3E %3Cpath fill='%230b45bb' d='m988.681,422.981-57.234-1.075-70.393,0-57.234,1.075,0,68.601c0,3.448,3.578,11.525,24.215,21.807,34.111,16.998,60.33,24.934,68.189,34.607,7.858-9.673,34.077-17.61,68.189-34.607,20.636-10.282,24.214-18.359,24.214-21.807z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m930.063,419.401s33.019-8.326,33.019-43.617c0-27.563-33.103-41.237-34.044-47.814-3.235,11.381,11.058,27.1,11.058,45.715,0,24.086-17.764,25.239-17.764,25.239-4.157,0-5.841,2.968-7.475,2.968-3.497-0.365-5.143-4.813-8.601-4.813-3.247,0-5.74,5.017-10.033,5.017-4.292,0-6.735-5.017-9.983-5.017-3.456,0-5.103,4.448-8.6,4.813-1.634,0-3.319-2.968-7.476-2.968,0,0-17.763-1.153-17.763-25.239,0-18.615,14.295-34.336,11.058-45.715-0.938,6.577-34.041,20.25-34.041,47.814,0,35.291,33.019,43.617,33.019,43.617l-9.42,17.149s13.645,0.683,20.887,6.861c8.733,7.448,7.883,23.229,7.883,34.709,0,9.045-1.143,18.59-5.784,22.524-6.232,5.284-10.445,5.675-10.445,11.878,0,5.174,3.977,6.211,10.445,9.625,8.287,4.373,7.901,10.238,20.22,10.238,12.321,0,11.985-5.864,20.273-10.238,6.468-3.414,10.444-4.451,10.444-9.625,0-6.203-4.214-6.594-10.444-11.878-4.641-3.936-5.784-13.48-5.784-22.524,0-11.48-0.849-27.261,7.883-34.709,7.243-6.177,20.886-6.861,20.887-6.861z'/%3E %3Cpath d='m896.22,330.42-5.735,16.281-15.614-7.424,7.423,15.615-16.279,5.784,16.279,5.785-7.423,15.563,15.614-7.423,5.735,16.279,5.785-16.279,15.614,7.423-7.422-15.563,16.279-5.785-16.279-5.784,7.422-15.615-15.614,7.424-5.785-16.281z'/%3E %3Cpath d='m861.05,421.91s-20.387-4.984-28.002-15.051c-13.313,11.976-29.232,16.126-29.232,16.126s16.607,7.498,29.232,17.048c5.817-8.336,28.002-18.123,28.002-18.123z'/%3E %3Cpath d='m931.44,421.91s22.186,9.786,28.004,18.123c12.623-9.55,29.229-17.048,29.229-17.048s-15.917-4.151-29.229-16.126c-7.615,10.066-28.004,15.051-28.004,15.051z'/%3E %3Cpath d='m869.4,443.61-7.935,7.934,7.935,7.935,7.935-7.935-7.935-7.934z'/%3E %3Cpath d='m923.1,443.61-7.934,7.934,7.934,7.935,7.935-7.935-7.935-7.934z'/%3E %3Cpath d='m867.403,489.94c0,10.025-0.972,15.307-0.972,15.307s11.186-3.293,13.414-14.641c1.044-5.32,2.207-24.918-3.175-28.259l-14.5895-2.867c1.5755,3.899,5.3225,15.977,5.3225,30.46z'/%3E %3Cpath d='m915.829,462.348c-5.381,3.34-4.218,22.938-3.174,28.259,2.227,11.348,13.413,14.641,13.413,14.641s-0.972-5.282-0.972-15.307c0-14.483,3.747-26.562,5.3245-30.4605z'/%3E %3Cpath d='m833.005,462.915c-5.031,1.262-8.071,6.385-6.808,11.416,0.193,0.77,0.511,1.481,0.87,2.15-0.733-0.244-1.498-0.406-2.304-0.461-0.323-0.022-0.655-0.011-0.972,0-4.761,0.16-8.73,3.903-9.061,8.755-0.354,5.174,3.579,9.629,8.755,9.983,0.772,0.052,1.523,0.024,2.251-0.103-0.445,0.611-0.83,1.263-1.125,1.996-1.937,4.813,0.409,10.351,5.222,12.288,4.812,1.935,10.298-0.461,12.234-5.273,0.296-0.735,0.461-1.452,0.564-2.202,0.443,0.615,0.976,1.179,1.586,1.689,3.979,3.328,9.931,2.801,13.259-1.177,3.329-3.978,2.801-9.881-1.178-13.208-0.602-0.504-1.27-0.9-1.945-1.228,0.723-0.232,1.426-0.552,2.098-0.972,4.395-2.755,5.725-8.609,2.969-13.004-1.894-3.021-5.222-4.574-8.549-4.351-1.513,0.101-3.029,0.572-4.403,1.434-0.671,0.421-1.267,0.888-1.791,1.433,0.001-0.756-0.064-1.534-0.256-2.303-1.104-4.403-5.151-7.305-9.5215-7.117-0.6245,0.027-1.2655,0.098-1.8945,0.255z'/%3E %3Cpath d='m932.825,490.25c1.017,9.587,8.808,17.619,18.429,19.914-1.643-2.687-2.735-5.682-3.072-8.856-1.205-11.37,7.588-20.581,19.607-20.581,1.894,0,3.729,0.234,5.528,0.667-4.237-6.947-12.215-11.775-20.887-11.7745-12.018,0.0005-20.813,9.2625-19.605,20.6305z'/%3E %3C/g%3E %3Cg fill='%23ffd200'%3E %3Cpath d='m847.592,373.684c0,18.128,9.667,28.821,22.576,28.821,2.462,0,5.155,3.328,7.475,3.328,3.782,0,6.298-4.198,8.601-4.198,2.927,0,4.9,4.607,9.982,4.607,5.083,0,7.107-4.607,10.034-4.607,2.302,0,4.818,4.198,8.6,4.198,2.321,0,5.012-3.328,7.475-3.328,12.909,0,22.577-10.693,22.577-28.821,0-14.784-12.416-32.81-11.058-35.734,0,0,24.214,17.369,24.214,37.832,0,32.963-33.429,41.109-33.429,41.109l7.525,16.944s-10.362,1.554-16.689,6.656c-8.439,6.805-8.55,25.191-8.55,37.626,0,14.648,0.545,20.855,5.837,24.829,5.58,4.193,9.777,5.096,9.777,9.369,0,3.723-4.345,5.246-9.983,7.73-6.413,2.827-7.052,7.731-16.33,7.731-9.279,0-9.867-4.904-16.28-7.731-5.637-2.484-9.983-4.006-9.983-7.73,0-4.273,4.197-5.176,9.777-9.369,5.292-3.974,5.836-10.181,5.836-24.829,0-12.435-0.11-30.821-8.549-37.626-6.328-5.104-16.689-6.656-16.689-6.656l7.524-16.944s-33.428-8.145-33.428-41.109c0-20.463,24.215-37.832,24.215-37.832,1.358,2.924-11.057,20.95-11.057,35.734zm35.988,136.126c-6.567,0-10.75,1.386-10.75,3.379,0,1.994,4.184,3.328,10.75,3.328,1.75,0,3.737-1.019,3.737-3.328s-1.988-3.379-3.737-3.379zm25.34,0c-1.75,0-3.737,1.071-3.737,3.379-0.001,2.309,1.987,3.328,3.737,3.328,6.568,0,10.75-1.333,10.75-3.328,0-1.994-4.183-3.379-10.75-3.379z'/%3E %3Cpath d='m896.28,341.38,3.686,10.394,9.931-4.761-4.71,9.982,10.342,3.687-10.342,3.686,4.71,9.931-9.931-4.71-3.737,10.341-3.686-10.341-9.931,4.71,4.71-9.931-10.341-3.686,10.341-3.687-4.71-9.982,9.931,4.761,3.737-10.394z'/%3E %3Cpath d='m850.147,422.528c-0.002,0-17.099,12.696-17.099,12.696l-0.206,0.255-0.358-0.307-18.941-11.877s12.087-4.167,19.1975-11.4155c6.7285,7.7035,17.4065,10.6485,17.4065,10.6485z'/%3E %3Cpath d='m978.948,423.295s-12.609,6.28-18.943,11.877l-0.357,0.307-0.204-0.255c-5.986-6.871-17.098-12.696-17.098-12.696s10.676-2.945,17.4045-10.648c7.1115,7.248,19.1975,11.415,19.1975,11.415z'/%3E %3Cpath d='m869.4,447.4,4.147,4.145-4.147,4.199-4.198-4.199,4.198-4.145z'/%3E %3Cpath d='m923.1,447.4,4.199,4.145-4.199,4.199-4.146-4.199,4.146-4.145z'/%3E %3Cpath d='m875.033,465.519c2.897,3.998,2.405,10.462,2.405,19.455,0,9.067-6.808,12.541-6.808,12.541,0-21.794-2.247-27.034-3.43-33.6345z'/%3E %3Cpath d='m925.3,463.88c-1.185,6.602-3.429,11.841-3.429,33.634,0,0-6.809-3.474-6.809-12.541,0-8.993-0.492-15.455,2.406-19.454l7.832-1.639z'/%3E %3Cpath id='leaf' d='m842.832,472.128c0.204,0.816,0.226,1.618,0.153,2.407-0.06,0.654-0.234,1.248-0.46,1.842-1.133-0.414-2.359-0.615-3.635-0.615-3.159,0-5.987,1.39-7.935,3.585-0.511-0.452-0.955-0.952-1.33-1.536-0.42-0.649-0.775-1.359-0.973-2.15-0.982-3.913,1.411-7.876,5.324-8.857,0.488-0.124,1-0.185,1.4845-0.2045,3.3925-0.1455,6.5115,2.1055,7.3715,5.5285z'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(72,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(144,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(216,838.89,486.468)'/%3E %3Cuse xlink:href='%23leaf' transform='rotate(288,838.89,486.468)'/%3E %3Ccircle cx='838.890' cy='486.468' r='7.065'/%3E %3Cpath d='m962.925,476.942c-11.729,2.268-20.17,12.628-18.942,24.727-3.738-3.096-6.473-7.266-6.962-11.877-0.951-8.979,5.571-15.922,15.4095-15.922,3.7615,0,7.3755,1.152,10.4945,3.072z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='750' height='600'%3E %3Crect fill='%23FFF' width='750' height='600'/%3E %3Crect fill='%23CE1126' width='750' height='300'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='900' height='600' id='svg2' version='1.1' inkscape:version='0.48.4 r9939' sodipodi:docname='AJAX.svg'%3E %3Cmetadata id='metadata12'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3E%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cdefs id='defs10' /%3E %3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1920' inkscape:window-height='1057' id='namedview8' showgrid='false' fit-margin-top='0' fit-margin-left='0' fit-margin-right='0' fit-margin-bottom='0' inkscape:zoom='0.63555556' inkscape:cx='455.8698' inkscape:cy='278.86414' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='svg2' /%3E %3Crect width='900' height='600' id='rect4' x='-900' y='0' transform='scale(-1,1)' style='fill:%23c1272d;fill-opacity:1;stroke:none' /%3E %3Cpath d='m 449.99991,224.31497 -44.4674,136.87006 116.40181,-84.55895 H 378.06451 l 116.4028,84.55895 z' id='path6' inkscape:connector-curvature='0' style='fill:none;stroke:%23006233;stroke-width:14.62993431;stroke-miterlimit:4;stroke-dasharray:none' /%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='960' height='480'%3E %3Crect width='960' height='480' fill='%23239e46'/%3E %3Crect width='960' height='360' fill='%23000'/%3E %3Crect width='960' height='120' fill='%23e70013'/%3E %3Ccircle cx='480' cy='240' r='60' fill='%23fff'/%3E %3Ccircle cx='492.132034' cy='240' r='52.132034' fill='%23000'/%3E %3Cpath d='M509.175411,240 589.875233,213.779039 540,282.426407V197.573593L589.875233,266.220961z' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3Cpath fill='%239E3039' d='m0,0h1200v600H0'/%3E %3Cpath fill='%23FFF' d='m0,240h1200v120H0'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600'%3E %3Crect width='1000' height='300' y='300' fill='%2300A1DE '/%3E %3Crect width='1000' height='300' fill='%23ed2939'/%3E %3Crect width='1000' height='200' y='200' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='500' height='300' viewBox='0 0 5 3'%3E %3Crect fill='%23C1272D' width='5' height='3'/%3E %3Crect fill='%23006A44' width='5' height='2'/%3E %3Crect fill='%23FDB913' width='5' height='1'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 450 300'%3E %3Crect width='450' height='300' fill='%23009543'/%3E %3Crect width='450' height='210' fill='%23fff'/%3E %3Crect width='450' height='90' fill='%2300209f'/%3E %3Cg fill='%23fff'%3E %3Cpath fill='%23000' stroke='%23000' d='m224.76,95.569c-1.7098,0.03684-3.3781,1.9308-3.3781,1.9308l0.14732,20.233-6.3878,6.692h5.1711l-0.0437,11.603-30.591,41.193-4.5222-1.563-7.9041,16.861s19.55,12.242,47.925,11.907c31.144-0.37035,48.064-12.471,48.064-12.471l-8.1677-16.644-3.9996,1.7393-30.983-40.979-0.0437-11.949h5.1711l-7.0378-6.6088,0.0416-20.159s-1.7514-1.8203-3.4613-1.7835z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='5' d='m235.43,144.01-21.153,0s-7.6776-16.176-6.4331-27.485c1.2672-11.515,7.8483-16.963,16.598-17.059,10.345-0.11526,15.767,5.0691,17.405,16.598,1.6231,11.424-6.4172,27.947-6.4172,27.947z'/%3E %3Cpath d='m187.79,182.57c-0.3458,0.46106-2.8816,5.5326-2.8816,5.5326l4.38-0.92211-1.4984-4.6105z'/%3E %3Cpath d='m190.32,189.14-4.6105,1.4984,5.5327,2.19-0.92212-3.6884z'/%3E %3Cpath d='m192.4,182.68,2.3053,6.8006,5.6479-1.6137-1.4984-3.2274-6.4548-1.9595z'/%3E %3Cpath d='m195.97,191.91,0.80685,2.7663,7.4921,1.8442-2.9968-6.3395-5.3021,1.729z'/%3E %3Cpath d='m204.27,186.14,2.6511,6.3395,5.6479-2.19-1.8442-2.7663-6.4548-1.3832z'/%3E %3Cpath d='m207.96,194.79,0.92211,2.4205,8.76,1.2679-3.6884-5.7632-5.9937,2.0747z'/%3E %3Cpath d='m216.37,187.99,3.2274,5.6479,8.1837-2.9969-0.9221-2.19-10.489-0.46106z'/%3E %3Cpath d='m221.1,195.71,1.729,2.9969,10.143-0.3458-3.8037-5.6479-8.0684,2.9968z'/%3E %3Cpath d='m231.82,188.22,2.7663,4.7258,6.4548-3.1121-1.729-2.5358-7.4921,0.92212z'/%3E %3Cpath d='m242.42,191.79-6.4548,3.2274,1.729,2.7663,8.6448-1.3832-3.919-4.6106z'/%3E %3Cpath d='m244.5,186.83,3.3426,4.1495,5.4174-4.2648-1.8442-1.9595-6.9158,2.0748z'/%3E %3Cpath d='m254.41,189.02-5.1869,3.919,1.3832,2.4205,7.1464-1.8442-3.3426-4.4953z'/%3E %3Cpath d='m261.56,180.84,1.2679,1.8442-3.5732,5.3021-3.6884-4.7258,5.9937-2.4205z'/%3E %3Cpath d='m263.98,185.45,2.19,4.38-4.38,1.4984-0.34579-2.0748,2.5358-3.8037z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1140' height='600' viewBox='0 0 209 110' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Crect fill='%23bf0a30' width='209' height='110'/%3E %3Cpath d='M0,15H209 M0,35H209 M0,55H209 M0,75H209 M0,95H209' stroke='%23fff' stroke-width='10'/%3E %3Crect fill='%23002868' width='50' height='50'/%3E %3Cg transform='translate(25,25) scale(15)'%3E %3Cg id='B'%3E %3Cpolygon id='A' fill='%23fff' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E %3Cuse xlink:href='%23A' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23B' transform='rotate(72)'/%3E %3Cuse xlink:href='%23B' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23B' transform='rotate(144)'/%3E %3Cuse xlink:href='%23B' transform='rotate(-144)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Crect width='1200' height='600' fill='%23ffb700'/%3E %3Cpath d='M50,300 215,50H380V550H215z' fill='%23ff5b00'/%3E %3Crect width='165' height='500' x='50' y='50' fill='%23005641'/%3E %3Crect width='725' height='500' x='430' y='50' fill='%238d2029'/%3E %3Cpath id='leaf' d='m1086.1,466.06s6.7982,13.841,14.309,19.48c11.128,8.3556,33.945,7.752,43.629,17.5,11.604,11.495-0.9004,26.682-0.7959,28l0.6363,8.0206s-7.8245,0.0943-11.119,0.60793c-4.9538,0.7724-6.886,4.8032-16.109,4.2045-23.189-1.5052-22.254-22.397-23.566-40.25-1.1646-6.7983-3.8594-15.662-5.3908-22.458-1.313-5.8277-1.5933-15.105-1.5933-15.105z' fill='%23ffb700' stroke='%23000' stroke-width='2.12575722'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(-1,0,0,1,1585,0)'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(1,0,0,-1,0,600)'/%3E %3Cuse xlink:href='%23leaf' transform='matrix(-1,0,0,-1,1585,600)'/%3E %3Cuse xlink:href='%23lion' stroke='%23000' stroke-width='5.5598'/%3E %3Cg id='lion' fill='%23ffb700'%3E %3Cpath d='m681.54,479.56,4.3593-2.517,1.8649,2.5215c2.4846,3.3595,9.3595,3.3215,13.921-0.0773l3.4882-2.5985,2.9208,2.5985c3.8402,3.4168,11.012,3.4213,15.591,0.0122,3.206-2.3882,3.653-2.4362,5.7728-0.61944,1.2637,1.0831,4.9702,2.3162,8.2366,2.7402,5.8828,0.76367,5.9719,0.72173,9.4138-4.442,2.8826-4.3245,3.3335-6.0748,2.6456-10.269-0.45593-2.7807-0.9471-7.2562-1.0915-9.9454-0.26119-4.8694-0.23309-4.8997,6.8598-7.3695,3.9171-1.364,8.4514-3.1933,10.076-4.0653,2.8328-1.5202,10.643-10.699,10.643-12.508,0-0.47938-3.0511-1.2137-6.7801-1.632-14.833-1.6637-17.345-9.6288-7.7022-24.423,15.725-24.128,25.215-47.625,25.278-62.593,0.0285-6.6906,0.40945-8.937,1.2692-7.482,3.5135,5.9459-2.7808,30.877-12.316,48.78l-3.8392,7.2089,3.6635-0.84337c2.0149-0.46382,13.861-5.4619,26.325-11.107,34.115-15.451,45.833-18.479,67.911-17.549,18.497,0.77911,26.374,4.3927,39.434,18.09,6.9185,7.2565,13.583,12.449,25.775,20.08,25.975,16.259,27.058,17.667,28.293,36.788,1.2515,19.373,0.62869,20.424-14.024,23.661-12.524,2.7669-20.375,8.6054-22.481,16.717-1.1245,4.3318,1.242,4.4565,7.5561,0.39845l4.6275-2.9741,2.0576,2.9741c2.7051,3.91,8.455,3.9256,13.23,0.0356l3.6067-2.9381,3.6869,2.9381c5.7286,4.565,13.347,3.458,15.497-2.252,0.41335-1.0975,1.5164-0.74587,3.75,1.1953,4.1852,3.6374,14.914,5.1976,16.072,2.3376,0.44221-1.0912-0.3978-3.7862-1.8666-5.9887-6.2419-9.3596-8.1945-13.823-8.2758-18.918-0.11266-7.0863,2.0014-10.505,10.061-16.268,9.7908-7.0008,12.816-16.033,5.3706-16.033-4.5972,0-9.2317-4.0634-12.187-10.686-6.0079-13.461-4.8304-28.552,4.1866-53.657,9.1588-25.5,10.175-30.202,10.211-47.256,0.03-13.789-0.3175-16.174-3.4548-23.734-1.9182-4.6223-5.8102-11.505-8.6489-15.294l-5.1614-6.8903,6.6267-5.49c20.234-16.763,16.095-44.198-8.263-54.769-7.4516-3.2338-9.3134-3.5194-22.372-3.4316-7.8342,0.0527-19.78,1.0836-26.546,2.2911-6.8986,1.2311-18.575,2.2205-26.585,2.2526-12.725,0.0512-14.885-0.26249-19.789-2.8727-5.1132-2.7217-5.9899-4.0139-6.991-10.305-0.20575-1.2931-1.1099-2.5831-2.0089-2.8666-1.7392-0.54841-9.771,6.4223-10.958,9.51-0.58543,1.5235-1.0633,1.4182-2.7808-0.61319-1.1407-1.349-2.7333-4.4487-3.5393-6.8883-2.0267-6.1353,0.46204-10.735,7.6738-14.181l5.5952-2.6741-3.2993-2.0474c-6.8083-4.2248-18.385-1.3347-22.572,5.635-1.1843,1.9715-2.4761,3.5881-2.8706,3.5924-0.39444,0.003-2.6455-1.8765-5.0025-4.1795-8.7904-8.5893-5.7666-21.297,5.9908-25.177,6.2696-2.0689,11.818-0.49068,12.972,3.69,1.7624,6.3826,7.2409-2.0071,6.2584-9.584-0.6533-5.0374-0.55514-5.212,2.9305-5.212,4.8473,0,15.165,6.3619,18.356,11.319,3.7064,5.7573,3.4367,14.823-0.64203,21.58l-3.2027,5.3055,4.1894-0.83896c6.1434-1.2302,12.112-5.0453,15.131-9.6721,3.192-4.8914,3.5352-14.416,0.70469-19.555-2.7429-4.981-2.4284-5.7717,1.6267-4.0885,6.8969,2.8628,10.584,6.0201,13.35,11.431,2.4908,4.8729,2.6298,6.0838,1.2814,11.156-0.83198,3.1291-2.6831,7.246-4.1137,9.1486-2.2274,2.9626-2.3034,3.4593-0.52871,3.4593,3.3052,0,10.206-3.1281,12.658-5.7373,1.2383-1.3182,3.0437-4.564,4.012-7.2129l1.7607-4.8162,2.023,3.6712c2.8609,5.1912,8.4225,9.8627,15.204,12.77,7.293,3.1265,10.33,3.3027,6.5164,0.37792-2.5718-1.9723-7.3109-15.878-5.8747-17.238,0.84508-0.80031,10.747,6.8186,22.053,16.968,10.695,9.6009,17.415,12.746,27.238,12.746,12.548,0.00008,19.854-10.923,14.214-21.251-3.288-6.0216-10.613-6.8581-14.896-1.7011-1.9696,2.3714-2.5103,4.2577-1.9334,6.745,0.7066,3.047,0.4309,3.453-2.3451,3.453-3.6473,0-10.837-4.6664-23.606-15.321-19.471-16.248-43.13-30.02-60.214-35.05-10.963-3.2285-34.383-4.4883-45.528-2.4492-12.062,2.207-26.329,9.1099-34.101,16.499-13.772,13.094-13.991,30.518-0.58141,46.385l3.8411,4.5452-2.6005,4.0394c-3.7831,5.8765-3.4591,13.785,0.80339,19.61,1.8774,2.5656,3.7712,4.6637,4.2085,4.6623,0.43728-0.001,0.91679-1.6508,1.0654-3.6654,0.37644-5.0966,2.5638-8.5113,6.3183-9.8632,3.3816-1.2176,5.5676-0.64252,21.051,5.5376,16.289,6.5015,43.077,6.9484,71.561,1.1938,13.964-2.8211,30.43-2.6552,37.674,0.37962,13.279,5.5631,16.357,20.036,6.5955,31.022-4.2256,4.7559-8.3008,6.6927-21.983,10.448-10.412,2.8575-12.878,3.0472-36.543,2.8109-20.218-0.20184-27.484,0.18642-35.737,1.9096-8.9598,1.8707-14.471,2.0594-40.79,1.3961l-30.431-0.76685,3.3746,2.7943c1.856,1.5368,4.4782,3.4277,5.8271,4.202,2.2952,1.3174,2.2187,1.4944-1.1927,2.7593-2.0049,0.7434-6.4548,1.3516-9.8886,1.3516h-6.2432l-0.84015,5.3057c-0.46215,2.9182-0.42705,6.3252,0.0776,7.5711,0.74459,1.8377,0.46708,2.1016-1.4696,1.3977-1.313-0.47719-4.97-1.4158-8.1265-2.0857-3.1565-0.66995-7.4054-2.0342-9.442-3.0316-3.4248-1.6773-3.8054-1.6322-5.0669,0.60016-1.1264,1.9935-11.702,9.8644-13.254,9.8644-0.25046,0-0.57378-1.5176-0.71843-3.3725-0.14464-1.8549-1.6703-6.6837-3.3904-10.731-1.7202-4.047-3.5162-8.4619-3.9913-9.8109-0.71672-2.035-1.0412-2.1394-1.9056-0.61319-0.573,1.0118-1.4096,3.7711-1.8591,6.1318-0.44947,2.3607-2.043,6.1958-3.5412,8.5224l-2.724,4.2301-1.7374-3.617c-1.8651-3.8828-4.9615-7.9092-6.0825-7.9092-0.37837,0-1.0228,1.2417-1.432,2.7593-0.85453,3.1692-8.197,11.957-9.9903,11.957-0.66041,0-1.2007-2.4834-1.2007-5.5186s-0.5827-5.5186-1.2949-5.5186-1.2949,0.78545-1.2949,1.7454c0,2.3335-6.2706,9.2918-8.3736,9.2918-0.91771,0-2.394,0.82779-3.2807,1.8395-2.3118,2.638-4.2029,2.2678-3.231-0.63242,0.45568-1.3596,0.15939-4.5328-0.65846-7.0516-0.81788-2.5188-1.6875-5.1996-1.9325-5.9573-0.30871-0.95429-2.5558-0.70116-7.3116,0.82362-7.6852,2.4639-10.261,2.028-6.3087-1.0676,1.4449-1.1316,3.6425-5.0514,4.8838-8.7107,1.2412-3.6592,3.0726-6.9061,4.0698-7.2151,1.3963-0.43282,1.322,0.10204-0.32373,2.3272-1.1753,1.5891-2.1404,3.7321-2.1448,4.7624,0,1.0303-0.88884,3.473-1.9656,5.4282-1.0766,1.9552-1.7534,3.7483-1.5039,3.9845,0.24941,0.23626,3.1735-0.87452,6.4978-2.4684l6.0442-2.8979,0.0246,2.5925c0.0142,1.4259,0.74212,5.1875,1.6186,8.3592l1.5937,5.7666,4.1143-1.891c4.2049-1.9326,8.1874-8.8222,8.1874-14.164,0-2.6406,1.5126-2.2353,2.132,0.57128,0.18181,0.8236,1.1312,3.9147,2.1099,6.8692l1.7795,5.3717,2.817-3.3916c1.5494-1.8654,3.4917-5.5244,4.3163-8.131,1.4315-4.5251,3.6793-6.4706,3.6793-3.1845,0,2.368,6.4622,10.861,7.7088,10.131,0.60253-0.35262,1.8023-3.5401,2.6661-7.0833,1.7967-7.3686,4.6952-12.38,6.537-11.302,0.69252,0.40535,0.96225,1.192,0.59929,1.7482-0.36297,0.55613,1.1254,5.3468,3.3075,10.646,2.1821,5.2991,4.3732,10.634,4.8693,11.856,0.797,1.9632,1.5174,1.678,6.1947-2.4527,2.911-2.5708,5.5531-5.4487,5.8713-6.3953,0.48094-1.431,1.1303-1.3786,3.8524,0.31056,3.8067,2.3622,16.605,6.1683,17.593,5.2321,0.37021-0.35059,0.74975-3.7118,0.8435-7.4694l0.17042-6.8319,3.6804,0.76323c2.0242,0.41978,6.2805,0.39398,9.4584-0.0575l5.7779-0.82057-5.1492-3.5327c-2.8322-1.943-5.6958-4.4574-6.3636-5.5875-0.71142-1.204-3.232-2.2263-6.0873-2.469-7.7147-0.65558-21.388-8.3244-21.388-11.996,0-0.68925,1.8938,0.48271,4.2085,2.6043,5.1349,4.7067,12.269,7.6609,18.499,7.6609h4.6621l-2.884-3.8358c-1.6567-2.2034-3.1425-6.3832-3.4914-9.8218-0.55604-5.481-1.1346-6.3525-6.8578-10.331-3.4376-2.3899-7.6957-5.972-9.4622-7.9603l-3.2119-3.615-1.6387,4.2921c-0.90139,2.3607-2.003,4.2921-2.4479,4.2921-0.44494,0-2.1777-1.3797-3.8503-3.0659-1.6728-1.6862-3.3768-3.0596-3.7867-3.0518-0.4101,0.007-1.8919,2.2791-3.2929,5.0474l-2.5474,5.0333-1.9684-2.9012c-1.0827-1.5957-3.64-4.4189-5.6829-6.2738s-3.1174-3.3725-2.3877-3.3725c0.72956,0,3.251,1.9323,5.6033,4.294l4.2765,4.294,1.7405-3.146c1.0328-1.8669,1.4199-4.7346,0.95201-7.0533-0.68203-3.3797-0.5862-3.5761,0.70963-1.4546,0.82408,1.349,3.3259,3.9353,5.5597,5.7473l4.0616,3.2946,2.8028-5.1341c2.7895-5.1094,2.8091-5.1194,4.0782-2.0682,1.6972,4.0805,13.98,14.149,24.437,20.032,1.6118,0.9067,0.9322-2.2112-2.0444-9.3809-0.78834-1.8988-1.4333-5.3219-1.4333-7.607,0-3.39-0.97793-4.8988-5.3136-8.1981-6.2592-4.7632-8.2835-8.1504-9.463-15.835-0.47783-3.1128-1.5732-6.5749-2.4343-7.6935-1.2773-1.6596-1.4884-0.73081-1.1466,5.0465,0.23036,3.8942-0.27608,8.7359-1.1256,10.759l-1.5443,3.6791-1.1938-3.0659c-0.65653-1.6862-3.5605-4.6187-6.4535-6.5166-2.8929-1.8979-4.9233-3.7694-4.5119-4.1589,0.41126-0.38953,3.3874,1.3402,6.6134,3.8437,4.9147,3.814,5.9973,4.227,6.678,2.5471,0.79975-1.9739-0.001-10.562-1.5461-16.563-0.77113-2.9968-0.70366-2.9807,2.9932,0.71559,2.7266,2.7261,4.2342,5.9776,5.4023,11.65,1.4838,7.2068,2.2324,8.4066,8.8962,14.258,4.0018,3.5138,7.4844,6.1913,7.7391,5.9502,0.25458-0.24116,0.75961-9.3307,1.1222-20.199,0.69536-20.841-0.0906-25.8-5.1098-32.239l-2.5788-3.3085,4.054-4.3729c5.2886-5.7045,7.7168-10.277,8.7701-16.515l0.85683-5.0748-4.5751,4.3329c-3.7462,3.5479-5.5352,4.3329-9.8743,4.3329-4.2965,0-5.9749-0.72001-8.8702-3.8052-3.4739-3.7017-9.6295-7.2634-15.549-8.9969-2.1867-0.64031-2.9136-0.3614-2.9136,1.1179,0,1.0841-1.2079,4.2133-2.6842,6.9538l-2.6841,4.9828-5.6238-5.5587c-3.4497-3.4096-7.5436-6.0635-10.589-6.8644-7.7808-2.0462-8.2022-1.843-8.2022,3.954,0,8.7932-3.7543,10.431-10.511,4.5868-5.1508-4.4554-9.4235-5.4241-19.191-4.3505l-7.5435,0.82916,1.3573,3.4054c1.1337,2.8446,0.8782,4.0425-1.5508,7.2732-3.9398,5.2399-9.0624,7.5098-16.948,7.5098-3.6319,0-8.1768,0.75156-10.1,1.6701-1.9232,0.91856-6.7016,1.9768-10.619,2.3517-3.9171,0.37491-8.0922,1.044-9.2778,1.4869-1.8554,0.69306-2.059,0.12189-1.4614-4.098,0.91472-6.4581-3.5965-11.222-10.627-11.222-9.1217,0-13.329,8.1592-9.7568,18.922,0.68749,2.0714,1.5871,5.3381,1.999,7.2593,0.42746,1.9932,4.5362,7.2825,9.5688,12.318,4.8509,4.8537,9.4354,9.9041,10.188,11.223,0.75262,1.3191,3.2407,3.4359,5.529,4.704l4.1608,2.3058-0.5488-4.4519c-0.60318-4.8928,0.46295-5.6604,3.0662-2.2077,0.93053,1.2343,3.2945,3.2293,5.2531,4.4333,3.0853,1.8967,3.561,1.9353,3.561,0.28842,0-1.0454,0.62895-3.4543,1.3976-5.3531l1.3977-3.4523,2.4251,4.6972c1.3338,2.5835,5.6714,8.455,9.639,13.048,7.6986,8.9118,12.389,18.871,9.9683,21.163-0.98194,0.92988-3.6363,0.85791-9.1376-0.24774-4.2646-0.85709-9.5394-1.3101-11.722-1.0068-4.4571,0.61953-4.8082,0.0441-2.067-3.3881,2.8931-3.6226,2.4329-4.2201-3.2508-4.2201-6.5757,0-22.901-3.1522-29.168-5.6319-6.0934-2.4112-7.4993-1.8108-9.2928,3.9686-0.80725,2.601-2.2853,7.3142-3.2844,10.474l-1.8166,5.7444,6.5927-0.6349c3.626-0.3492,8.2897-1.1431,10.364-1.7642,2.0741-0.62112,3.9591-0.95122,4.1889-0.73356,0.22985,0.21769-0.6946,2.4623-2.0543,4.988l-2.4721,4.5922,4.1103-0.8379c2.2608-0.46085,5.662-1.5885,7.5584-2.5059,3.2998-1.5963,3.5648-1.4804,6.1676,2.6973,3.2006,5.1376,5.7611,4.9265,6.3292-0.52181,0.58738-5.6325,2.4401-4.7994,5.9255,2.6645,3.3515,7.1772,6.8385,9.7112,7.5085,5.4565,0.22232-1.4126,2.0278-3.7122,4.012-5.1101,4.0136-2.8276,7.0382-1.9792,8.7723,2.4603,1.795,4.5955-2.2084,9.3323-13.853,16.391-23.327,14.14-36.886,33.479-40.757,58.128-3.4915,22.233,7.4134,45.207,29.29,61.708,10.469,7.8966,27.1,16.231,26.043,13.051-4.4882-13.505-4.3404-39.274,0.2503-43.621,0.68891-0.65244,0.45194,2.0364-0.52663,5.9752-3.645,14.672-2.0615,26.363,7.282,53.763,8.4506,24.782,7.2809,35.373-4.6794,42.374-3.8414,2.2484-6.3146,2.6189-16.643,2.4936-11.207-0.13613-12.428,0.0895-16.026,2.9564-3.4881,2.7798-8.0108,11.906-8.0108,16.165,0,2.3072,2.562,2.0018,7.5966-0.90506z'/%3E %3Cpath d='m863.45,479.06,4.7011-3.0213,3.1903,3.0213c4.1796,3.9583,9.0759,3.8698,13.094-0.23669,1.7536-1.792,3.3283-3.0336,3.4993-2.7593,0.17093,0.27434,0.95293,1.6025,1.7376,2.9515,0.99334,1.7076,3.0357,2.5662,6.7222,2.8263,4.4417,0.31334,5.6344-0.1165,7.3993-2.6674l2.1038-3.041,4.6277,2.9741c12.669,8.1426,19.42-0.40017,13.758-17.411-2.879-8.6495-1.296-13.512,7.983-24.521,3.9128-4.6423,7.1176-9.5973,7.1215-11.011,0-2.2539-0.72386-2.5559-5.9314-2.4527-4.9834,0.0994-6.4413-0.43585-9.0644-3.3233-4.2665-4.6965-4.013-10.075,0.75623-16.044l3.81-4.7681-6.7596-4.5873c-3.7178-2.5231-10.422-8.4924-14.899-13.265-10.054-10.719-19.939-15.802-32.975-16.955l-8.7404-0.77298,0.0129,6.6158c0.0168,8.5168,4.0137,16.71,14.924,30.588,12.405,15.779,13.271,18.222,13.774,38.846l0.42473,17.442-3.5896,3.4057c-3.2436,3.0773-4.7062,3.47-15.173,4.0736-9.9645,0.57467-12.058,1.0888-14.982,3.6791-3.8836,3.4404-5.0449,5.3118-6.244,10.063-0.69887,2.7688-0.41568,3.3725,1.5825,3.3725,1.3386,0,4.5493-1.3597,7.1349-3.0214z'/%3E %3Cpath d='m596.82,433.98c1.1086-1.4991,2.0158-3.9198,2.0158-5.3794,0-2.2052,0.98543-2.7937,5.8314-3.4819l5.8314-0.82816-3.889-3.0993c-4.6204-3.6819-5.0478-6.5584-0.97546-6.5647,4.056,0,10.925-4.2118,11.969-7.3279,0.48536-1.4483,0.18013-3.3834-0.69044-4.3769-2.2738-2.5946-6.5486-2.2034-7.3427,0.67204-0.85348,3.091-2.2824,3.0992-5.5219,0.0306-4.8732-4.6153-4.9826-14.169-0.22595-19.732,2.2418-2.6218,2.2218-2.7938-0.6362-5.5005-3.0745-2.9118-5.2702-8.6748-3.826-10.043,0.45957-0.43524,2.8886-0.0884,5.3979,0.77114,3.5656,1.2211,4.9732,1.2396,6.4421,0.0846,4.4496-3.4973-0.37114-7.9944-7.5068-7.0025-2.8718,0.3992-4.0582,0-4.4706-1.4897-0.31195-1.1298-2.8238-2.605-5.6539-3.3204-5.0569-1.2784-5.0926-1.2628-5.0926,2.2213,0,3.8179-2.1794,4.5382-6.3206,2.0889-3.365-1.9903-6.6286-0.44518-6.6286,3.1383,0,3.3434,3.3623,4.9923,9.3882,4.604,4.6219-0.29789,4.7939,3.1391,0.40427,8.0796l-3.1567,3.5529,2.5008,3.5928c3.7037,5.321,3.3919,14.158-0.65433,18.547l-3.1721,3.4409-2.081-2.7593c-2.8919-3.8346-6.8476-3.5776-7.9323,0.51543-0.71028,2.6802-0.12315,3.905,3.2331,6.745,2.2555,1.9086,5.5485,3.4702,7.3178,3.4702,4.3784,0,4.2072,3.4433-0.34417,6.9217l-3.561,2.7216,5.5034,0.85366c3.0269,0.46958,5.5034,1.3529,5.5034,1.9628,0,2.339,3.8141,9.6148,5.0401,9.6148,0.70818,0,2.1948-1.2265,3.3034-2.7256z'/%3E %3Cpath d='m668.48,402.92c5.0001-1.9709,15.821-11.134,15.821-13.398,0-0.71202-2.9869-3.997-6.6374-7.3001-7.6824-6.9509-16.039-18.657-18.204-25.501-1.1289-3.5687-6.5843-9.6779-21.951-24.581l-20.448-19.832-5.8934,1.4927c-3.2414,0.82104-7.1962,1.5127-8.7885,1.537-2.7441,0.0417-2.6943,0.19928,0.95383,3.0226l3.8489,2.9786,5.3959-2.9948c5.2303-2.9029,5.4165-2.9208,6.0615-0.58461,0.37773,1.3676-0.43704,3.7378-1.8831,5.479-1.4019,1.6877-2.2004,3.6023-1.7748,4.2546,0.42564,0.65216-0.92107,2.016-2.9927,3.0306-3.8397,1.8805-6.5048,8.0707-3.4747,8.0707,2.7261,0,8.7373-7.4169,8.0447-9.9256-0.35481-1.2846-0.18323-2.6059,0.38121-2.9363,2.3412-1.3703,2.1949,4.4528-0.18374,7.3168-1.4019,1.6877-2.2004,3.6023-1.7748,4.2546,0.42564,0.65218-0.92107,2.016-2.9927,3.0306-3.8148,1.8683-6.5067,8.0707-3.5029,8.0707,2.944,0,8.8566-7.0875,8.1244-9.7388-0.38303-1.3874-0.23476-2.7927,0.32968-3.1231,1.5768-0.92296,2.4275,3.6741,1.0964,5.9264-0.71298,1.2066-0.70651,2.8536,0.0168,4.1598,1.3096,2.3663-0.0182,6.9107-2.4316,8.3233-1.0345,0.60546-0.33394,1.7936,2.1753,3.6885,3.631,2.7423,3.7014,3.0302,3.7014,15.13,0,10.112,0.40827,12.722,2.2661,14.482,2.0848,1.9754,2.2661,1.9825,2.2661,0.0884,0-2.069,3.6318-4.5981,6.6028-4.5981,0.8764,0,6.3518,4.6402,12.167,10.312,5.8509,5.7058,11.973,10.561,13.707,10.87,1.7232,0.30733,3.5888,0.63391,4.1458,0.72575,0.55695,0.092,3.1792-0.68688,5.8271-1.7306z'/%3E %3Cpath d='m605.96,354c0-3.2598-6.7241-6.7394-14.767-7.6415-6.4933-0.72835-6.5996-0.68714-6.5996,2.5565,0,2.685,1.0211,3.7413,5.5034,5.6928,7.2024,3.1357,15.863,2.804,15.863-0.60778z'/%3E %3Cpath d='m613.33,353.7c3.2799-2.976,4.8339-6.5156,2.8606-6.5156-2.2695,0-8.293,5.4052-8.293,7.4417,0,3.1786,1.1188,2.9878,5.4324-0.92616z'/%3E %3Cpath d='m606.34,344.06c0.27788-1.8392-0.8597-3.0666-4.2697-4.6066-7.3558-3.3221-16.15-4.8607-18.268-3.196-3.901,3.0662-1.3018,7.1829,5.0028,7.9235,2.5382,0.29812,5.98,1.0722,7.6482,1.7202,4.8456,1.882,9.4537,1.0239,9.8867-1.8411z'/%3E %3Cpath d='m606.34,334.21c0.39598-2.6237-1.2816-3.5626-14.978-8.3834-10.225-3.5989-14.752-1.9018-11.484,4.3058,1.1384,2.1624,3.049,3.1503,7.3339,3.7919,3.187,0.4773,7.5427,1.4104,9.6793,2.0738,5.7081,1.772,9.0058,1.148,9.4489-1.788z'/%3E %3Cpath d='m613.2,324.98c2.0666-2.0947,3.7572-4.567,3.7572-5.4936,0-3.0061-8.1614,2.3121-9.2017,5.9959-1.2478,4.4187,0.77501,4.2322,5.4449-0.50233z'/%3E %3Cpath d='m606.34,324.36c0.45051-2.9886-4.5198-5.6876-14.294-7.7622-7.1711-1.522-10.334-0.6588-9.7971,2.6736,0.29315,1.8191,2.6814,3.1481,9.4566,5.2626,10.843,3.3836,14.104,3.3449,14.634-0.17403z'/%3E %3Cpath d='m615.9,310.45c12.525-5.5755,13.608-19.635,1.7976-23.326-4.9037-1.5327-8.0341-0.70686-9.9112,2.6147-1.4372,2.5434-0.476,7.1676,1.4899,7.1676,0.66417,0,1.2076,0.85596,1.2076,1.9021,0,4.8819-19.123,7.0939-26.965,3.119-2.7551-1.3964-3.9546-5.0211-1.6616-5.0211,1.7134,0,2.8981-3.6935,2.0226-6.3059-1.1928-3.5592-4.7799-4.7922-9.9831-3.4317-11.74,3.0699-11.41,16.865,0.54277,22.719,9.8013,4.8001,31.287,5.0919,41.46,0.56291z'/%3E %3Cpath d='m608.11,299.64c0.72529-0.68694,0.41011-1.7425-0.80582-2.6982-2.6627-2.0928-2.5207-5.2056,0.4-8.7689,2.1933-2.6759,2.4673-6.6804,3.2223-47.074,1.3008-69.611,6.4773-121.97,13.3-134.53,2.7163-5.0009,2.3354-5.0208-4.6839-0.24499-9.0418,6.1522-15.926,14.163-22.026,25.631-11.516,21.651-15.518,50.78-15.518,112.96,0,35.305,0.24051,39.924,2.2515,43.243,1.9103,3.1523,2.0118,4.3165,0.66998,7.6833-0.86981,2.1824-1.2645,4.2682-0.87709,4.6351,2.5711,2.435,21.302,1.789,24.067-0.82993z'/%3E %3Cpath d='m713.34,233.26c0.39236-0.6012-0.47458-3.6364-1.9264-6.745-2.2635-4.8468-3.1753-5.6519-6.4-5.6519-10.102,0-26.341-4.5144-43.083-11.976-9.6677-4.3091-13.007-5.2994-14.166-4.2013-2.958,2.8014,1.9582,9.4508,9.5715,12.946,6.754,3.1007,25.635,6.9107,34.248,6.9107,4.9966,0,5.1147,0.22548,2.2713,4.3354l-2.0914,3.0228,5.6524,0.14508c3.1087,0.0799,7.4004,0.56638,9.5371,1.0813,5.5493,1.3373,5.6012,1.3384,6.3876,0.13328z'/%3E %3Cpath fill='%23000' d='m772.35,264.63c0-1.7992-5.2837-6.6752-10.638-9.817-4.2046-2.4674-4.8992-2.5424-4.9086-0.52996-0.0143,3.0552-2.7311,10.731-3.798,10.731-0.60162,0-1.4912-1.4999-1.9771-3.3332-0.48587-1.8332-2.5241-5.4462-4.5295-8.0287l-3.6462-4.6956-2.8391,4.3506c-2.6467,4.0557-7.2315,8.0278-9.2662,8.0278-0.48599,0-0.58103-2.1359-0.21134-4.7465,0.40169-2.8364,0.092-5.0863-0.77073-5.591-0.79353-0.4645-1.4428-0.30245-1.4428,0.3601,0,1.5283-6.367,8.751-7.7142,8.751-0.55513,0-1.3322-2.0695-1.727-4.5989-0.39469-2.5294-1.0656-6.5304-1.4908-8.8911-0.42526-2.3608,0.48144-0.75983,2.015,3.5576l2.7884,7.8498,3.0577-4.7839c1.6817-2.6312,3.0607-5.5063,3.0643-6.3893,0-0.88294,0.57248-1.2741,1.2641-0.86936,0.69149,0.40477,1.654,3.5676,2.1387,7.0284l0.88145,6.2925,3.3646-3.689c1.8506-2.0289,4.019-4.7452,4.8188-6.0363,1.427-2.3036,1.5078-2.3017,4.3463,0.10554,1.5907,1.349,4.0363,4.5757,5.4345,7.1704,1.3984,2.5947,2.7296,4.5262,2.9584,4.2923,0.22868-0.23399,0.74108-2.9088,1.1388-5.9441,0.39754-3.0352,0.75248-5.6312,0.7886-5.7688,0.19786-0.7521,10.135,5.7072,13.812,8.9778,2.3631,2.1022,4.6074,3.5278,4.9873,3.1681,0.37993-0.35979,0.69071-3.4612,0.69071-6.8921,0-5.3167-0.56355-6.7417-3.8155-9.6485-3.7391-3.3422-3.8437-3.3606-5.2252-0.91579-1.7931,3.173-3.9084,3.2188-3.9084,0.0846,0-2.2875-7.0659-11.08-8.9041-11.08-0.47653,0-1.9646,1.9315-3.3071,4.2923-1.3424,2.3607-2.786,4.29-3.208,4.2874-1.8125-0.0111-11.774-11.117-11.769-13.122,0-1.5945,0.67129-1.1868,2.4176,1.4761,1.3269,2.0235,3.9777,5.0443,5.8904,6.7129,3.8731,3.3787,5.2811,2.5571,6.7757-3.9536,0.42577-1.8549,1.1658-3.3725,1.6444-3.3725,1.6558,0,10.327,9.2097,11.547,12.264l1.2244,3.0659,0.92741-3.3725c1.134-4.124,2.3852-4.2774,4.1958-0.51425,0.75626,1.572,4.4918,4.8404,8.3011,7.263l6.926,4.4047,1.39-4.4303c0.76451-2.4366,1.7773-3.8368,2.2506-3.1116,0.70585,1.0815-1.0945,8.4227-2.4528,10.002-0.20356,0.23674-2.4479-1.0705-4.9875-2.9049l-4.6172-3.3353-0.0182,5.9708c-0.0129,3.2839-0.36905,7.2125-0.79856,8.7301-0.83976,2.9674-3.0686,3.8021-3.0686,1.1492z'/%3E %3Cpath fill='%23000' d='m737.82,217.03c-8.2314-6.8725-9.481-8.4451-9.2987-11.702l0.19399-3.4668,0.537,3.3485c0.31363,1.9552,2.5058,4.8853,5.2686,7.0422l4.7318,3.6937,2.9076-3.3631c1.5993-1.8497,2.9287-4.0529,2.9544-4.896,0.0673-2.1985,0.46176-2.0139,6.0347,2.8216,4.9515,4.2963,5.0287,4.3168,5.7651,1.533,0.41049-1.5519,0.26481-4.4736-0.32372-6.4926-1.6179-5.5499-1.3009-6.3875,1.1507-3.0403,1.2214,1.6677,3.1854,4.0253,4.3644,5.239,2.0523,2.1129,2.1775,2.0868,2.9412-0.6132,0.43872-1.551,0.80557-4.3898,0.81528-6.3085l0.0182-3.4885,4.4645,5.0607c4.1702,4.7272,4.5544,4.9018,5.8272,2.6494,0.7495-1.3262,1.3716-4.5171,1.3824-7.0908,0.0142-3.3248,0.36439-4.1637,1.21-2.8977,1.4121,2.114,0.43172,7.87-2.1758,12.775l-1.8712,3.5199-2.4571-3.8264c-3.1417-4.8928-4.1876-4.8142-6.2036,0.46582-1.9052,4.9898-3.1441,5.3696-5.0005,1.533-1.2013-2.4829-1.43-2.1787-2.2827,3.0374l-0.94776,5.7967-5.6785-4.4068-5.6786-4.4068-2.5528,2.9023c-1.4041,1.5963-2.5722,3.5922-2.5959,4.4353-0.0517,1.8274-1.4176,1.8844-3.4995,0.14622z'/%3E %3Cpath fill='%23000' d='m811.04,191.43c-2.9962-2.6993-5.0602-5.2746-4.5867-5.723,0.47342-0.44838,1.0065-0.57681,1.1846-0.28542,0.17806,0.29139,2.6271,2.8668,5.4424,5.723,6.4822,6.5765,5.1496,6.7629-2.0403,0.28543z'/%3E %3Cpath fill='%23000' d='m713.51,181.35c-2.7255-3.6852-2.5373-6.1267,0.7803-10.121,2.3974-2.8864,3.4925-3.2781,7.6788-2.7463,2.6854,0.34111,8.4638,2.7138,12.841,5.2725,5.0555,2.9552,10.285,4.9349,14.335,5.427,3.5069,0.42609,6.3763,0.58673,6.3763,0.35699,0-0.22973-1.4568-2.6032-3.2373-5.2744-4.2283-6.3433-4.0835-7.0241,0.68552-3.2237,4.8954,3.9012,10.751,5.0421,23.836,4.6444l6.393-0.19431-3.7088-3.6663c-5.1869-5.1273-3.5906-5.587,2.1375-0.61554,5.3722,4.6626,5.0358,4.991-6.2715,6.1196-4.8048,0.47958-9.9719,0.1317-14.267-0.96048-6.4256-1.6342-6.675-1.6093-5.4578,0.54471,0.70158,1.2414,1.8378,2.2571,2.5248,2.2571,0.68721,0,1.2495,0.62908,1.2495,1.3979,0,2.3644-13.879,0.28524-20.511-3.0727-15.151-7.6712-17.058-8.3355-20.664-7.1991-2.0067,0.63235-4.0153,2.4833-4.7074,4.3381-2.3091,6.1873,6.4658,10.997,10.085,5.5273,1.049-1.5853,0.804-2.6696-1.0397-4.5988-2.5248-2.6423-2.288-3.0188,1.1205-1.7801,2.4199,0.87945,2.7455,6.6892,0.49439,8.8212-2.5757,2.4393-8.4536,1.7488-10.674-1.254z'/%3E %3Cpath fill='%23000' d='m773.19,166.07c-1.8946-1.7944-0.40932-2.2338,8.0847-2.3922,10.508-0.19593,16.89-1.947,24.42-6.7006,6.0333-3.8088,7.669-3.0593,1.9424,0.88996-5.2242,3.6027-13.372,6.3723-21.239,7.2191-3.8093,0.41006-8.1505,0.9781-9.6473,1.2623-1.4967,0.28421-3.0991,0.15887-3.561-0.27852z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' width='1000' height='600'%3E %3Crect width='1000' height='600' fill='%23002b7f'/%3E %3Crect y='300' width='1000' height='300' fill='%23ce1126'/%3E %3Cg fill='%23ffd83d' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E %3Cg id='half'%3E %3Cpath d='M 216.37706,122.2886 L 214.53882,184.7886 L 151.1197,184.7886 C 143.31716,169.62032 136.87338,156.73735 136.87338,139.29228 C 136.87338,124.69269 148.35647,113.09742 164.90647,113.09742 C 182.42619,113.09742 201.67512,119.001 216.37706,122.2886 z' stroke='none'/%3E %3Cg stroke-width='1.5'%3E %3Cpath d='M 144.45611,125.16084 V 161.23621'/%3E %3Cpath d='M 149.54956,121.47933 V 169.51333'/%3E %3Cpath d='M 154.64301,118.95176 V 176.17693'/%3E %3Cpath d='M 159.73645,117.77081 V 162.65201'/%3E %3Cpath d='M 164.82989,117.54815 V 162.87466'/%3E %3Cpath d='M 169.92335,115.96463 V 162.84973'/%3E %3Cpath d='M 175.01679,115.96463 V 162.84973'/%3E %3Cpath d='M 180.11024,116.42419 V 163.30929'/%3E %3Cpath d='M 185.20367,116.88375 V 163.76885'/%3E %3Cpath d='M 190.29712,119.87088 V 166.75598'/%3E %3Cpath d='M 195.39057,120.33044 V 173.1898'/%3E %3Cpath d='M 200.48402,120.33044 V 167.21554'/%3E %3Cpath d='M 205.57747,120.33044 V 167.21554'/%3E %3Cpath d='M 176.39544,117.92279 C 187.15891,119.69824 210.80151,130.75993 208.105,145.72611 C 204.28366,166.93537 191.89725,158.42373 175.47632,155.37684 L 163.06823,159.51287 C 158.62839,164.04466 152.09048,168.19641 147.67301,162.72978 L 140.32007,162.72978 L 140.32007,191.4522 L 221.66198,191.4522 L 221.66198,122.05882 z' fill='%23000'/%3E %3C/g%3E %3Ccircle cx='212.81549' cy='112.98255' r='4.94026'/%3E %3Ccircle cx='201.713' cy='110.31052' r='4.94026'/%3E %3Ccircle cx='190.44973' cy='107.48178' r='4.94026'/%3E %3Ccircle cx='179.14295' cy='105.59596' r='4.94026'/%3E %3Ccircle cx='167.83617' cy='104.48071' r='4.94026'/%3E %3Ccircle cx='156.74931' cy='105.11261' r='4.94026'/%3E %3Ccircle cx='146.17946' cy='108.73163' r='4.94026'/%3E %3Ccircle cx='137.27551' cy='115.28035' r='4.94026'/%3E %3Ccircle cx='130.95657' cy='124.41408' r='4.94026'/%3E %3Ccircle cx='127.912' cy='135.15627' r='4.94026'/%3E %3Ccircle cx='128.02689' cy='146.30057' r='4.94026'/%3E %3Ccircle cx='130.15236' cy='157.21509' r='4.94026'/%3E %3Cpath d='M 214.99838,119.53125 L 214.53882,125.96507 C 202.24782,124.08194 184.82391,117.23346 168.58294,117.23346 C 153.57656,117.23346 141.92853,123.23616 141.92853,138.37316 C 141.92853,153.29163 148.24631,166.85838 156.63441,180.65257 L 147.90279,184.7886 C 140.10025,169.62032 133.65647,156.73735 133.65647,139.29228 C 133.65647,124.69269 145.13956,110.34007 164.90647,110.34007 C 182.42619,110.34007 200.29644,116.24365 214.99838,119.53125 z'/%3E %3C/g%3E %3Cuse xlink:href='%23half' transform='translate(443.9375) scale(-1,1)'/%3E %3Cpath d='M 221.96875,53.125 L 216.8125,62.78125 L 221.96875,72.40625 L 227.125,62.78125 L 221.96875,53.125 z M 221.96875,77.5 L 216.8125,87.125 L 221.96875,96.78125 L 227.125,87.125 L 221.96875,77.5 z'/%3E %3Cpath d='M 203.58731,74.953125 L 211.71883,80.109375 L 219.82403,74.953125 L 211.71883,69.796875 L 203.58731,74.953125 z M 224.11347,74.953125 L 232.21867,80.109375 L 240.35019,74.953125 L 232.21867,69.796875 L 224.11347,74.953125 z'/%3E %3Ccircle cx='221.96875' cy='75.06893' r='3.90625'/%3E %3Ccircle cx='221.96875' cy='100' r='10.45496'/%3E %3Cpath d='M 219.34375,89.875 C 219.34375,92.989438 219.32163,94.799139 219.3125,96.5 C 216.79207,96.611865 214.30676,96.876712 211.875,97.28125 M 232.0625,97.28125 C 229.63074,96.876712 227.14543,96.611865 224.625,96.5 C 224.625,94.801655 224.625,92.997132 224.625,89.875 M 211.84375,102.5625 C 215.13846,102.01215 218.51788,101.71875 221.96875,101.71875 C 225.41962,101.71875 228.79904,102.01215 232.09375,102.5625' fill='none' stroke-width='1.5'/%3E %3Cpath d='M 211.75,117.6875 C 210.75812,134.76968 208.74143,152.16667 202.09375,164.8125 L 212.90625,160.4375 C 216.68272,146.10873 217.47609,127.59492 218.625,118.84375 L 211.75,117.6875 z M 232.1875,117.6875 L 225.3125,118.84375 C 226.4614,127.59492 227.25478,146.10873 231.03125,160.4375 L 241.84375,164.8125 C 235.19607,152.16667 233.17938,134.76968 232.1875,117.6875 z'/%3E %3Cpath d='M 221.95313,154.6875 C 209.03974,154.6875 199.55398,160.77412 198.98438,176.28125 C 195.82773,170.72636 182.4742,153.25552 170.01563,155.59375 C 162.60576,156.98444 156.05854,167.25962 157.17188,179.03125 C 151.037,161.40135 133.06509,158.51225 119.95313,168.9375 C 131.59529,178.51001 136.77421,206.77225 146.57813,219.03125 L 221.95313,219.03125 L 297.32813,219.03125 C 307.13204,206.77225 312.34222,178.51001 323.98438,168.9375 C 310.87241,158.51225 292.90051,161.40135 286.76563,179.03125 C 287.87896,167.25962 281.3005,156.98444 273.89063,155.59375 C 261.43205,153.25552 248.10978,170.72636 244.95313,176.28125 C 244.38354,160.77412 234.86652,154.6875 221.95313,154.6875 z'/%3E %3Cg stroke-width='1.5'%3E %3Cpath d='M 297.10662,219.02573 C 297.10662,224.60663 263.44486,230.74447 221.96875,230.74447 C 180.49265,230.74447 146.83089,224.60663 146.83089,219.02573 C 146.83089,213.44487 180.49265,210.5239 221.96875,210.5239 C 263.44486,210.5239 297.10662,213.44487 297.10662,219.02573 z' fill='%23000'/%3E %3Ccircle cx='221.96875' cy='114.44459' r='3.50414'/%3E %3Ccircle cx='221.96875' cy='122.02731' r='3.73392'/%3E %3Ccircle cx='221.96875' cy='130.18447' r='4.07859'/%3E %3Ccircle cx='221.96875' cy='139.26075' r='4.65303'/%3E %3Ccircle cx='221.96875' cy='149.37105' r='5.11259'/%3E %3Cpath d='M 219.93751,159.20588 C 219.38456,159.19901 218.86165,159.6649 219.00001,160.54963 C 219.16297,161.59315 219.36706,163.54482 219.56251,164.86213 C 219.78339,166.35532 220.65373,165.99233 220.87501,164.83088 C 221.09631,163.66986 221.00709,162.925 221.06251,160.76838 C 221.09024,159.69029 220.49047,159.21276 219.93751,159.20588 z M 224.00001,159.20588 C 223.44705,159.21276 222.8473,159.69029 222.87501,160.76838 C 222.93043,162.925 222.84123,163.66986 223.06251,164.83088 C 223.28379,165.99233 224.15415,166.35532 224.37501,164.86213 C 224.57046,163.54482 224.77457,161.59315 224.93751,160.54963 C 225.07587,159.6649 224.55298,159.19901 224.00001,159.20588 z M 216.31251,159.76838 C 215.80668,159.83874 215.2822,160.34892 215.31251,160.89338 C 215.36753,161.88856 215.64291,163.0823 215.75001,164.58088 C 215.86046,166.12907 216.95166,165.52771 217.06251,164.64338 C 217.17296,163.75866 217.29793,162.45118 217.18751,160.73713 C 217.1461,160.09422 216.8653,159.8115 216.53126,159.76838 C 216.46168,159.75941 216.38477,159.75833 216.31251,159.76838 z M 227.40626,159.76838 C 227.07222,159.8115 226.79144,160.09422 226.75001,160.73713 C 226.63959,162.45118 226.76458,163.75866 226.87501,164.64338 C 226.98586,165.52771 228.07708,166.12907 228.18751,164.58088 C 228.29461,163.0823 228.57001,161.88856 228.62501,160.89338 C 228.65532,160.34892 228.13086,159.83874 227.62501,159.76838 C 227.55275,159.75833 227.47586,159.75941 227.40626,159.76838 z M 211.96876,161.51838 C 211.50567,161.63805 211.0804,162.19494 211.21876,162.83088 C 211.49507,164.10277 211.75001,165.50899 211.75001,166.79963 C 211.75002,167.90566 212.69459,167.511 212.75001,166.73713 C 212.80503,165.96284 212.90626,164.32364 212.90626,162.83088 C 212.90627,161.71632 212.43186,161.39872 211.96876,161.51838 z M 231.65626,161.51838 C 231.32747,161.60947 231.03126,161.99496 231.03126,162.83088 C 231.03126,164.32364 231.13251,165.96284 231.18751,166.73713 C 231.24293,167.511 232.18752,167.90566 232.18751,166.79963 C 232.18751,165.50899 232.44247,164.10277 232.71876,162.83088 C 232.85712,162.19494 232.43187,161.63805 231.96876,161.51838 C 231.85299,161.48846 231.76586,161.48802 231.65626,161.51838 z M 172.56251,161.68934 C 172.00845,161.67094 171.61973,162.42254 172.00001,163.25184 C 172.60804,164.57916 173.25407,165.41659 173.87501,166.84559 C 174.42803,168.11748 175.2763,167.32448 175.00001,166.43934 C 174.7233,165.55461 174.42308,164.56923 173.59376,162.68934 C 173.28263,161.98423 172.89495,161.70039 172.56251,161.68934 z M 271.37501,161.68934 C 271.04257,161.70039 270.65489,161.98423 270.34376,162.68934 C 269.51444,164.56923 269.21422,165.55461 268.93751,166.43934 C 268.66122,167.32448 269.50949,168.11748 270.06251,166.84559 C 270.68345,165.41659 271.32948,164.57916 271.93751,163.25184 C 272.31779,162.42254 271.92907,161.67094 271.37501,161.68934 z M 176.56251,161.75184 C 176.15469,161.8763 175.90747,162.39361 176.15626,163.00184 C 176.65427,164.21831 177.37284,165.46536 177.87501,166.78309 C 178.31718,167.94413 179.3009,167.61494 178.96876,166.56434 C 178.63704,165.51375 178.53846,164.89884 177.87501,162.90809 C 177.54309,161.91293 176.97034,161.62739 176.56251,161.75184 z M 267.06251,161.75184 C 266.71381,161.82629 266.31145,162.16172 266.06251,162.90809 C 265.39906,164.89884 265.30048,165.51375 264.96876,166.56434 C 264.63662,167.61494 265.62034,167.94413 266.06251,166.78309 C 266.56468,165.46536 267.28325,164.21831 267.78126,163.00184 C 268.03005,162.39361 267.78283,161.8763 267.37501,161.75184 C 267.27305,161.72073 267.17874,161.72702 267.06251,161.75184 z M 181.56251,162.72059 C 181.04838,162.81843 180.65026,163.60277 181.00001,164.56434 C 181.4426,165.78081 182.072,166.93202 182.62501,168.31434 C 183.17803,169.69667 184.0963,169.41781 183.87501,168.53309 C 183.65374,167.64836 183.38263,166.18221 182.71876,163.97059 C 182.42851,163.00283 181.9624,162.6445 181.56251,162.72059 z M 262.37501,162.72059 C 261.97512,162.6445 261.50901,163.00283 261.21876,163.97059 C 260.55489,166.18221 260.28378,167.64836 260.06251,168.53309 C 259.84122,169.41781 260.75949,169.69667 261.31251,168.31434 C 261.86552,166.93202 262.49492,165.78081 262.93751,164.56434 C 263.28726,163.60277 262.88914,162.81843 262.37501,162.72059 z M 169.18751,163.40809 C 168.63064,163.46496 168.12339,164.37333 168.46876,165.06434 C 169.0222,166.17037 169.37242,166.54665 169.90626,167.72059 C 170.45928,168.93706 171.06504,167.99489 170.84376,167.22059 C 170.62248,166.4463 170.33882,165.54493 170.06251,164.43934 C 169.85999,163.62937 169.52164,163.37397 169.18751,163.40809 z M 274.75001,163.40809 C 274.41588,163.37397 274.07753,163.62937 273.87501,164.43934 C 273.5987,165.54493 273.31504,166.4463 273.09376,167.22059 C 272.87248,167.99489 273.47824,168.93706 274.03126,167.72059 C 274.5651,166.54665 274.91532,166.17037 275.46876,165.06434 C 275.81413,164.37333 275.30688,163.46496 274.75001,163.40809 z M 207.71876,166.20588 C 207.13501,166.20536 206.51143,166.98024 206.71876,167.70588 C 207.05049,168.86734 207.56328,169.89687 207.93751,171.39338 C 208.26924,172.72029 209.21168,172.05937 209.15626,171.17463 C 209.10085,170.28991 208.94926,169.0862 208.56251,167.20588 C 208.41734,166.50092 208.06902,166.2062 207.71876,166.20588 z M 236.21876,166.20588 C 235.8685,166.2062 235.5202,166.50092 235.37501,167.20588 C 234.98826,169.0862 234.83669,170.28991 234.78126,171.17463 C 234.72584,172.05937 235.6683,172.72029 236.00001,171.39338 C 236.37424,169.89687 236.88705,168.86734 237.21876,167.70588 C 237.42609,166.98024 236.80253,166.20536 236.21876,166.20588 z M 221.96876,167.39338 C 221.24958,167.39339 221.15023,168.35899 221.12501,169.14338 C 221.04236,171.71466 219.97517,174.21192 219.06251,175.45588 C 218.15028,176.70025 216.80689,176.36933 215.56251,175.70588 C 214.31815,175.04245 213.5769,174.54522 212.25001,173.54963 C 210.9227,172.55448 209.91641,173.13633 211.50001,175.39338 C 216.11747,181.97369 221.12501,187.5982 221.12501,198.33088 C 221.12502,199.71862 221.36747,200.14338 221.96876,200.14338 C 222.57005,200.14338 222.84374,199.71862 222.84376,198.33088 C 222.84376,187.5982 227.82007,181.97369 232.43751,175.39338 C 234.02111,173.13633 233.01484,172.55448 231.68751,173.54963 C 230.36062,174.54522 229.61939,175.04245 228.37501,175.70588 C 227.13063,176.36933 225.78726,176.70025 224.87501,175.45588 C 223.96235,174.21192 222.89518,171.71466 222.81251,169.14338 C 222.78729,168.35899 222.68796,167.39339 221.96876,167.39338 z M 186.68751,165.78309 C 186.62459,165.78137 186.55597,165.79672 186.50001,165.81434 C 186.23143,165.89895 186.05249,166.22315 186.15626,166.78309 C 186.34172,167.78535 187.03621,169.7496 187.31251,170.68934 C 187.58924,171.62952 188.74506,171.42956 188.46876,170.15809 C 188.19206,168.88621 188.20674,168.50208 187.87501,167.06434 C 187.69361,166.27808 187.12805,165.79517 186.68751,165.78309 z M 257.25001,165.78309 C 256.80947,165.79517 256.24393,166.27808 256.06251,167.06434 C 255.73078,168.50208 255.74548,168.88621 255.46876,170.15809 C 255.19246,171.42956 256.3483,171.62952 256.62501,170.68934 C 256.90131,169.7496 257.5958,167.78535 257.78126,166.78309 C 257.88503,166.22315 257.70609,165.89895 257.43751,165.81434 C 257.38155,165.79672 257.31295,165.78137 257.25001,165.78309 z M 165.71876,166.18934 C 165.13997,166.23465 164.72491,166.96181 165.31251,168.03309 C 165.94637,169.18996 167.03368,170.64128 167.53126,171.47059 C 168.02886,172.29991 168.88969,171.74036 168.28126,170.68934 C 167.67324,169.63877 167.46889,168.4321 166.75001,166.93934 C 166.48045,166.37941 166.06604,166.16216 165.71876,166.18934 z M 278.21876,166.18934 C 277.87148,166.16216 277.45707,166.37941 277.18751,166.93934 C 276.46863,168.4321 276.26428,169.63877 275.65626,170.68934 C 275.04783,171.74036 275.90866,172.29991 276.40626,171.47059 C 276.90384,170.64128 277.99115,169.18996 278.62501,168.03309 C 279.21261,166.96181 278.79755,166.23465 278.21876,166.18934 z M 134.03126,169.51838 C 133.36345,169.4829 133.15409,170.68863 133.78126,171.48713 C 134.69393,172.64817 135.32901,173.26405 136.37501,174.20588 C 137.20474,174.95227 137.44592,173.98351 137.03126,173.23713 C 136.61662,172.49076 136.01682,171.7315 135.18751,170.48713 C 134.73288,169.80512 134.33481,169.53451 134.03126,169.51838 z M 309.90626,169.51838 C 309.60271,169.53451 309.20464,169.80512 308.75001,170.48713 C 307.9207,171.7315 307.3209,172.49076 306.90626,173.23713 C 306.4916,173.98351 306.73278,174.95227 307.56251,174.20588 C 308.60851,173.26405 309.24359,172.64817 310.15626,171.48713 C 310.78343,170.68863 310.57407,169.4829 309.90626,169.51838 z M 139.06251,170.51838 C 138.53029,170.52532 138.17911,170.91843 138.59376,171.83088 C 139.18763,173.13695 139.97076,174.61654 140.46876,175.61213 C 140.96636,176.60732 142.48303,176.94156 141.87501,175.39338 C 141.26659,173.84521 141.14677,173.04988 140.59376,171.61213 C 140.31726,170.89327 139.59474,170.51145 139.06251,170.51838 z M 304.87501,170.51838 C 304.34278,170.51145 303.62026,170.89327 303.34376,171.61213 C 302.79075,173.04988 302.67093,173.84521 302.06251,175.39338 C 301.45449,176.94156 302.97116,176.60732 303.46876,175.61213 C 303.96676,174.61654 304.74989,173.13695 305.34376,171.83088 C 305.75841,170.91843 305.40723,170.52532 304.87501,170.51838 z M 129.31251,170.86213 C 128.53874,170.87003 128.47208,171.6458 129.15626,172.14338 C 130.06892,172.80684 131.15649,173.54322 132.21876,174.39338 C 133.46273,175.38856 133.9447,174.4731 133.28126,173.64338 C 132.61782,172.81408 131.97153,171.9731 130.31251,171.14338 C 129.89776,170.93606 129.57043,170.8595 129.31251,170.86213 z M 314.62501,170.86213 C 314.36709,170.8595 314.03976,170.93606 313.62501,171.14338 C 311.96599,171.9731 311.3197,172.81408 310.65626,173.64338 C 309.99282,174.4731 310.47479,175.38856 311.71876,174.39338 C 312.78103,173.54322 313.86859,172.80684 314.78126,172.14338 C 315.46544,171.6458 315.39877,170.87003 314.62501,170.86213 z M 204.96876,171.58088 C 204.5358,171.64145 204.16235,172.13322 204.34376,172.76838 C 204.67549,173.92942 205.05205,175.15983 205.28126,176.36213 C 205.50256,177.52359 206.8463,177.53773 206.62501,176.48713 C 206.40415,175.43655 206.29299,174.12199 205.90626,172.51838 C 205.76109,171.91704 205.45795,171.62817 205.15626,171.58088 C 205.09342,171.57104 205.03061,171.57223 204.96876,171.58088 z M 238.78126,171.58088 C 238.47957,171.62817 238.17645,171.91704 238.03126,172.51838 C 237.64453,174.12199 237.53339,175.43655 237.31251,176.48713 C 237.09122,177.53773 238.43498,177.52359 238.65626,176.36213 C 238.88547,175.15983 239.26205,173.92942 239.59376,172.76838 C 239.77517,172.13322 239.40174,171.64145 238.96876,171.58088 C 238.90691,171.57223 238.84412,171.57104 238.78126,171.58088 z M 174.87501,169.59559 C 174.53504,169.68956 174.33942,170.33955 174.59376,171.25184 C 176.004,176.31148 176.4363,178.97621 176.18751,180.22059 C 175.93873,181.46457 175.256,181.63524 174.34376,181.22059 C 173.43153,180.80594 172.36056,180.20736 171.53126,179.62684 C 170.70196,179.04592 169.83939,179.74084 171.03126,180.72059 C 177.08606,185.69729 181.28306,191.38482 182.90626,198.28309 C 183.238,199.69294 184.12381,199.85878 183.87501,198.28309 C 182.5027,189.59329 182.23882,182.44969 184.31251,177.97059 C 185.09182,176.28738 184.30689,174.67095 183.06251,177.40809 C 182.23321,179.23301 180.89102,179.95295 179.81251,178.37684 C 178.7344,176.80116 176.5072,172.59717 175.84376,170.68934 C 175.59482,169.97391 175.28778,169.64292 175.03126,169.59559 C 174.97783,169.58574 174.92358,169.58217 174.87501,169.59559 z M 268.90626,169.59559 C 268.64974,169.64292 268.3427,169.97391 268.09376,170.68934 C 267.43032,172.59717 265.20312,176.80116 264.12501,178.37684 C 263.0465,179.95295 261.70431,179.23301 260.87501,177.40809 C 259.63063,174.67095 258.8457,176.28738 259.62501,177.97059 C 261.6987,182.44969 261.43482,189.59329 260.06251,198.28309 C 259.81371,199.85878 260.69952,199.69294 261.03126,198.28309 C 262.65446,191.38482 266.85146,185.69729 272.90626,180.72059 C 274.09813,179.74084 273.23556,179.04592 272.40626,179.62684 C 271.57696,180.20736 270.50599,180.80594 269.59376,181.22059 C 268.68152,181.63524 267.99879,181.46457 267.75001,180.22059 C 267.50122,178.97621 267.93352,176.31148 269.34376,171.25184 C 269.5981,170.33955 269.40248,169.68956 269.06251,169.59559 C 269.01394,169.58217 268.95969,169.58574 268.90626,169.59559 z M 144.43751,172.01838 C 143.89144,172.02532 143.43872,172.40782 143.68751,173.23713 C 144.08634,174.5657 144.91121,176.00157 145.18751,176.83088 C 145.46423,177.66021 146.35337,177.27317 146.18751,176.11213 C 146.02167,174.95111 145.94005,174.25902 145.71876,172.98713 C 145.60813,172.35141 144.98359,172.01145 144.43751,172.01838 z M 299.50001,172.01838 C 298.95393,172.01145 298.32939,172.35141 298.21876,172.98713 C 297.99747,174.25902 297.91585,174.95111 297.75001,176.11213 C 297.58415,177.27317 298.47329,177.66021 298.75001,176.83088 C 299.02631,176.00157 299.85118,174.5657 300.25001,173.23713 C 300.4988,172.40782 300.04608,172.02532 299.50001,172.01838 z M 163.21876,170.28309 C 162.58372,170.16913 162.49242,171.80734 163.03126,172.47059 C 163.75015,173.35576 164.74859,174.42538 165.75001,175.62684 C 166.57933,176.62244 167.09175,175.73741 166.59376,174.90809 C 166.09619,174.07837 165.35814,173.19678 164.03126,171.09559 C 163.69944,170.5703 163.43044,170.32108 163.21876,170.28309 z M 280.71876,170.28309 C 280.50708,170.32108 280.23808,170.5703 279.90626,171.09559 C 278.57938,173.19678 277.84133,174.07837 277.34376,174.90809 C 276.84577,175.73741 277.35819,176.62244 278.18751,175.62684 C 279.18893,174.42538 280.18737,173.35576 280.90626,172.47059 C 281.4451,171.80734 281.3538,170.16913 280.71876,170.28309 z M 148.71876,174.23713 C 148.32474,174.20948 147.9904,174.52908 148.15626,175.33088 C 148.38756,176.44733 148.7233,177.37403 149.00001,178.42463 C 149.27633,179.47524 150.00001,179.29522 150.00001,178.29963 C 150.00002,177.30446 149.82212,176.19398 149.65626,175.14338 C 149.57334,174.61809 149.11279,174.26479 148.71876,174.23713 z M 295.21876,174.23713 C 294.82473,174.26479 294.36418,174.61809 294.28126,175.14338 C 294.1154,176.19398 293.9375,177.30446 293.93751,178.29963 C 293.93751,179.29522 294.66119,179.47524 294.93751,178.42463 C 295.21422,177.37403 295.54996,176.44733 295.78126,175.33088 C 295.94712,174.52908 295.61278,174.20948 295.21876,174.23713 z M 161.81251,175.65809 C 161.19365,175.75159 160.6491,176.34985 161.37501,177.28309 C 162.53607,178.77584 163.80743,179.82383 164.25001,180.37684 C 164.69218,180.92987 165.81263,180.72579 165.09376,179.56434 C 164.35906,178.37789 163.2476,176.94908 162.75001,176.06434 C 162.56343,175.73257 162.18383,175.602 161.81251,175.65809 z M 281.87501,175.65809 C 281.60285,175.6867 281.32745,175.81551 281.18751,176.06434 C 280.68992,176.94908 279.57846,178.37789 278.84376,179.56434 C 278.12489,180.72579 279.24534,180.92987 279.68751,180.37684 C 280.13009,179.82383 281.40145,178.77584 282.56251,177.28309 C 283.28842,176.34985 282.74387,175.75159 282.12501,175.65809 C 282.03218,175.64407 281.96573,175.64855 281.87501,175.65809 z M 141.15626,179.83088 C 140.668,179.78654 140.49938,180.18047 141.15626,181.08088 C 142.64903,183.12666 144.29582,186.22273 144.40626,187.54963 C 144.51713,188.87695 143.86095,188.86213 143.25001,188.86213 C 141.42512,188.86215 140.53363,187.53012 138.87501,187.14338 C 137.21599,186.75625 136.97522,187.62865 138.15626,188.48713 C 144.23856,192.91082 150.33501,197.84636 152.78126,202.33088 C 153.77645,204.15578 155.12181,204.82284 154.37501,203.08088 C 152.08795,197.74371 151.53367,193.22426 152.03126,190.48713 C 152.52926,187.75001 153.20794,185.90698 153.12501,184.33088 C 153.0421,182.7552 152.1484,182.86271 151.78126,184.33088 C 151.53247,185.32648 151.05048,186.64538 150.71876,187.14338 C 150.38705,187.64099 149.05314,187.91993 147.78126,186.20588 C 146.50937,184.49186 143.30061,181.19144 142.25001,180.36213 C 141.85605,180.05115 141.44922,179.85749 141.15626,179.83088 z M 302.78126,179.83088 C 302.4883,179.85749 302.08147,180.05115 301.68751,180.36213 C 300.63691,181.19144 297.42815,184.49186 296.15626,186.20588 C 294.88438,187.91993 293.55047,187.64099 293.21876,187.14338 C 292.88704,186.64538 292.40505,185.32648 292.15626,184.33088 C 291.78912,182.86271 290.89542,182.7552 290.81251,184.33088 C 290.72958,185.90698 291.40826,187.75001 291.90626,190.48713 C 292.40385,193.22426 291.84957,197.74371 289.56251,203.08088 C 288.81571,204.82284 290.16107,204.15578 291.15626,202.33088 C 293.60251,197.84636 299.69896,192.91082 305.78126,188.48713 C 306.9623,187.62865 306.72153,186.75625 305.06251,187.14338 C 303.40389,187.53012 302.5124,188.86215 300.68751,188.86213 C 300.07657,188.86213 299.42039,188.87695 299.53126,187.54963 C 299.6417,186.22273 301.28849,183.12666 302.78126,181.08088 C 303.43814,180.18047 303.26952,179.78654 302.78126,179.83088 z' fill='%23000' stroke='none'/%3E %3Cpath d='M 150.12687,212.65106 152.07661,218.82525 M 154.13742,211.48082 155.86506,217.72081 M 158.46968,210.7684 159.65672,217.1334 M 162.48993,209.96408 163.7604,216.31295 M 167.64553,209.45517 168.67848,215.84698 M 173.13007,209.46186 174.24249,215.84031 M 178.48383,207.65149 179.28735,214.07616 M 183.52067,207.97645 184.32419,214.40112 M 188.39503,207.32654 189.19855,213.75121 M 193.28767,206.82164 193.72967,213.28125 M 198.51623,206.81977 198.89973,213.28312 M 203.25656,206.49325 203.58317,212.95973 M 208.48353,206.16701 208.75481,212.63605 M 214.49524,206.00453 214.76652,212.47357 M 293.81064,212.65106 291.8609,218.82525 M 289.80009,211.48082 288.07245,217.72081 M 285.46783,210.7684 284.28079,217.1334 M 281.44758,209.96408 280.17711,216.31295 M 276.29198,209.45517 275.25903,215.84698 M 270.80744,209.46186 269.69502,215.84031 M 265.45368,207.65149 264.65016,214.07616 M 260.41684,207.97645 259.61332,214.40112 M 255.54248,207.32654 254.73896,213.75121 M 250.64984,206.82164 250.20784,213.28125 M 245.42128,206.81977 245.03778,213.28312 M 240.68095,206.49325 240.35434,212.95973 M 235.45398,206.16701 235.1827,212.63605 M 229.44227,206.00453 229.17099,212.47357 M 221.96876,205.58364 221.96876,212.7068'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 600 300'%3E %3Crect fill='%236Cf' width='600' height='300'/%3E %3Cpolygon fill='%23FFF' points='200,274 300,260 400,274 300,27'/%3E %3Cpolygon points='213.5,274 300,260 386.5,274 300,60'/%3E %3Cpolygon fill='%23FCD116' points='200,274 400,274 300,150'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Crect fill='%23ed1c24' width='750' height='500'/%3E %3Crect fill='%23fff' y='125' width='750' height='250'/%3E %3Cpath fill='%2300a651' d='M 371.5894,125 C 366.22315,136.2997 356.11736,144.19789 346.45832,151.67157 C 344.86925,153.05938 340.91845,155.74726 343.78458,157.79271 C 346.24017,155.04836 352.97951,158.68259 349.06268,161.63346 C 345.55402,164.9176 340.72308,166.12 336.82746,168.82984 C 333.37726,170.7043 329.87796,172.66173 327.14196,175.53105 C 326.95559,180.0135 332.70358,177.53219 335.03612,179.3996 C 338.07363,182.64705 333.74816,188.12133 329.76182,186.86927 C 324.66471,187.02546 321.14438,191.51029 319.21689,195.78908 C 315.22977,201.95458 307.67448,203.78032 301.65953,207.28899 C 298.21778,209.29528 294.87854,211.51505 291.6746,213.85608 C 287.54383,216.68042 291.13754,222.27234 295.53278,220.89972 C 300.27728,220.4267 304.54592,216.69896 309.45786,217.77316 C 313.91254,219.33833 315.16278,225.16012 313.64459,229.22483 C 312.52055,232.47922 309.79569,234.77154 307.6125,237.31372 C 304.06844,240.90414 299.43359,243.23508 294.54641,244.34656 C 289.82305,245.93241 285.57789,248.826 282.47971,252.73228 C 278.88376,256.35224 275.30219,260.03085 271.1692,263.04934 C 269.86365,266.38067 273.54807,269.21835 276.6199,269.12991 C 283.09222,268.72234 287.57797,263.42506 293.09028,260.70292 C 297.66461,258.64703 303.04806,263.57727 301.92906,268.34281 C 301.57508,272.97905 297.23424,275.33164 293.37475,276.75816 C 282.02885,282.4619 272.1777,290.73284 263.43076,299.85875 C 261.62169,303.54889 256.64826,302.46257 253.97025,305.03499 C 252.22562,308.29039 256.60402,310.00685 259.21608,309.67223 C 270.44112,308.32214 280.91539,303.57761 290.83812,298.3575 C 294.52819,296.59322 297.99323,294.27138 301.82962,292.86533 C 305.43319,291.97509 310.45809,293.54159 311.10283,297.64287 C 311.09773,301.97233 306.80857,304.37035 303.4117,306.06172 C 292.93651,311.56524 281.44052,314.60765 270.24434,318.24607 C 266.05289,317.07424 262.89523,324.53141 267.49329,325.87225 C 272.3554,327.53952 277.52429,326.20279 282.49779,325.98426 C 297.87642,323.62817 311.32634,315.30653 325.70163,309.9273 C 331.67794,307.97923 338.73226,310.6978 341.68165,316.29776 C 344.64481,321.28931 344.37398,327.85334 341.24819,332.70293 C 336.30834,343.27146 328.79833,352.98464 318.7165,359.0613 C 312.38812,362.19434 305.00126,363.39297 299.57757,368.18972 C 294.56146,369.8432 302.09226,376.62136 303.18084,371.24168 C 306.19505,367.13063 311.51128,365.90189 316.33356,365.73205 C 323.58078,364.94312 331.27713,363.60631 336.9083,358.58922 C 341.95671,354.66896 346.93162,349.26076 353.78678,349.17636 C 357.57531,349.62563 361.32238,352.66984 365.17025,350.81231 C 368.53626,349.27162 373.81755,350.17444 374.69678,354.31369 C 376.30415,359.15581 381.29505,361.35894 385.25295,363.95016 C 386.68557,365.96192 391.44596,371.15043 392.54374,366.57601 C 391.65792,363.31338 392.92361,358.32091 397.20351,359.41116 C 400.94191,359.57808 404.50446,360.95653 408.23564,361.18262 C 413.20452,362.21183 417.34927,365.6135 420.17071,369.72085 C 422.11167,372.40126 426.36333,377.00677 429.52222,373.45251 C 431.48249,369.77666 427.74062,366.71103 424.69446,365.39845 C 420.25243,362.64573 416.45462,358.97987 412.57076,355.50887 C 406.84653,350.16275 401.90235,343.36292 400.99374,335.37635 C 399.76199,327.41308 400.4102,319.29095 401.44945,311.34932 C 402.75741,306.23638 409.29554,303.44506 413.86725,306.16167 C 420.30003,309.09681 426.68843,313.29666 434.06328,312.84127 C 444.72,313.07089 455.67072,311.03044 466.08536,314.11859 C 476.21984,317.31095 483.46556,325.86344 493.33765,329.56419 C 495.54761,330.90725 498.37484,329.62908 499.18462,327.26866 C 500.16303,325.1476 499.47268,322.43378 497.42896,321.22499 C 485.98778,309.67613 470.35146,304.06569 457.11353,295.04126 C 452.94587,293.98288 452.18706,287.27769 456.03973,285.34185 C 461.10528,281.66065 468.2721,283.37428 472.76607,287.16972 C 476.56118,289.39278 480.8368,291.05827 485.2894,291.06224 C 489.85029,289.63448 487.63912,283.03469 483.55544,282.53841 C 476.15622,278.36058 470.8569,271.50481 464.44632,266.0718 C 460.75559,262.94683 456.716,259.78287 451.7557,259.17634 C 449.04451,258.68263 446.27094,258.57459 443.52394,258.75896 C 440.9476,255.95914 444.38123,251.67208 447.71241,252.02262 C 451.1308,252.25288 454.52965,252.50697 457.94359,252.03127 C 461.75876,251.75176 465.57064,251.35683 469.39939,251.33063 C 472.48995,253.43534 478.66583,249.7996 475.87651,246.17083 C 472.82951,243.50085 468.42334,243.73277 464.78211,242.36257 C 458.38547,240.26395 451.87572,238.56782 445.28454,237.23756 C 440.67325,236.9626 441.242,230.89376 445.29497,230.22441 C 447.94739,229.23496 450.25279,231.27278 452.79892,231.5887 C 457.14735,232.52313 461.63683,232.51113 465.9831,233.45849 C 469.66816,231.63935 466.81948,226.2555 463.48593,225.94179 C 455.62045,223.12924 448.82304,218.05295 442.17788,213.11487 C 434.84116,207.59721 428.18494,201.21633 420.75826,195.82617 C 418.06357,194.15628 413.64683,193.67534 412.93795,189.97462 C 412.68795,186.57015 416.69529,185.01965 419.53592,185.81559 C 423.56634,187.00583 427.32195,189.07846 431.42972,190.09605 C 434.65252,190.64375 437.97545,191.59738 441.08179,191.19126 C 445.02496,188.71371 439.39058,187.13019 437.35122,186.27058 C 432.0938,183.43513 427.42242,179.65733 422.69107,176.0548 C 418.69278,172.64193 426.08234,171.13414 428.62427,172.44822 C 432.87417,174.22617 433.35847,168.03333 430.18167,166.47498 C 426.43855,164.88338 423.2196,162.24124 419.82552,159.93707 C 413.69304,155.57159 406.74727,152.1159 399.20847,151.156 C 390.75634,150.3067 382.86721,145.44628 378.38327,138.21818 C 375.60269,134.09908 373.56207,129.54384 371.5894,125 z M 343.8321,172.41771 C 348.18843,172.54695 347.51872,180.39793 343.22983,179.87413 C 339.06481,179.60609 339.31972,171.57429 343.8321,172.41771 z M 384.92234,176.64564 C 389.16127,175.88738 390.05889,183.62274 385.82379,183.98589 C 381.41121,184.77575 379.7758,176.15615 384.92234,176.64564 z M 372.88731,177.65384 C 377.18466,178.49924 376.42021,185.98556 372.08328,186.05098 C 368.91022,186.75752 365.49025,188.92314 362.28008,187.30008 C 359.66952,184.53908 363.44271,180.45635 366.35676,179.55883 C 368.59191,179.10829 370.64832,178.09344 372.88731,177.65384 z M 400.58563,177.68637 C 404.72688,179.19709 403.26629,186.50778 398.8981,186.41459 C 394.76724,186.96811 392.84357,180.07706 396.6956,178.44266 C 397.9426,178.00052 399.24903,177.62794 400.58563,177.68637 z M 353.8613,185.97958 C 356.90649,188.87754 355.10789,194.47009 351.35311,195.80715 C 348.64664,197.31266 344.95682,200.87381 342.00892,197.94369 C 340.40943,194.36455 344.42423,191.66946 346.78572,189.68283 C 348.89329,188.04409 351.21909,186.55653 353.8613,185.97958 z M 388.63905,202.14325 C 392.99893,204.2019 390.78574,212.05909 386.00062,211.57069 C 382.07061,210.57486 382.58371,203.83444 386.54227,203.29678 C 387.29055,203.01039 387.9769,202.58881 388.63905,202.14325 z M 374.80463,202.92376 C 378.88224,204.83283 375.76886,211.63754 371.6618,210.657 C 367.40345,210.15691 367.48196,202.67024 372.17815,203.34611 C 373.06305,203.30222 373.97688,203.27971 374.80463,202.92376 z M 404.62678,206.82647 C 409.096,205.43963 414.4766,210.04402 413.02612,214.71319 C 411.03543,218.33295 406.10946,218.79124 402.58121,217.43842 C 398.52983,217.23842 395.80478,211.1478 399.41404,208.56875 C 400.90756,207.44072 402.79022,206.97715 404.62678,206.82647 z M 338.611,207.99725 C 342.30631,205.98682 346.22984,212.02929 343.08717,214.69451 C 341.00551,217.75492 335.66012,219.00525 333.30317,215.60189 C 331.34505,212.27783 334.51104,206.69321 338.611,207.99725 z M 321.56135,210.85925 C 325.75319,211.43274 328.48457,215.24015 330.03376,218.86551 C 330.41193,223.28362 323.89286,225.70783 321.04899,222.49331 C 317.85114,220.48713 315.05191,216.36132 316.72839,212.53213 C 317.76131,211.0116 319.81909,210.38426 321.56135,210.85925 z M 423.56431,226.82777 C 428.11364,225.62888 431.41652,232.89939 427.51018,235.52953 C 423.93847,238.77373 416.99376,234.47573 418.85644,229.84687 C 419.78218,228.1308 421.63401,226.99026 423.56431,226.82777 z M 365.66037,235.121 C 369.47498,235.6068 368.2391,242.21814 364.71192,241.99623 C 360.92636,241.29454 361.79307,234.74813 365.66037,235.121 z M 346.3099,238.6334 C 349.42124,236.43197 353.434,241.80509 350.84595,244.3089 C 347.74396,246.49354 343.72032,241.20565 346.3099,238.6334 z M 377.07598,239.28385 C 380.68235,241.47514 382.82338,245.56095 383.27166,249.68389 C 381.54334,253.53578 374.86866,252.60724 374.11615,248.50531 C 372.79639,245.26124 374.01269,241.08758 377.07598,239.28385 z M 387.81313,245.65826 C 392.46055,244.49084 390.79279,254.20485 386.91238,250.83545 C 385.62285,249.30414 386.31349,246.78444 387.81313,245.65826 z M 320.38146,252.42293 C 323.45884,251.52156 327.94465,252.46899 328.7941,256.00085 C 329.15292,259.32013 325.5028,261.04696 322.8282,261.86956 C 318.54137,263.19231 314.34875,265.36394 309.73883,265.07221 C 306.28351,263.09729 305.04323,259.05585 303.81128,255.53103 C 307.14601,252.40445 312.05643,253.32163 316.19018,252.53906 C 317.58613,252.4675 318.98379,252.43346 320.38146,252.42293 z M 424.98018,267.64343 C 428.90575,265.71883 433.12728,271.9498 429.84137,274.86023 C 425.73054,279.59171 417.81599,280.47093 412.90065,276.49605 C 412.30974,272.3088 416.49236,269.26764 420.20768,268.66669 C 421.77056,268.22519 423.32385,267.56559 424.98018,267.64343 z M 447.04443,272.42422 C 451.50464,271.6566 455.01805,278.01951 451.83272,281.3126 C 448.81821,285.85801 441.62942,287.05014 437.51912,283.32422 C 435.91659,279.55585 439.16741,275.62934 442.62728,274.42031 C 444.11438,273.78742 445.52241,272.97626 447.04443,272.42422 z M 336.10372,279.1889 C 340.23431,278.78128 344.01843,282.87955 343.47633,286.95187 C 346.46651,289.89444 341.17144,295.37643 338.19238,292.32933 C 335.56714,289.14836 335.58095,284.83298 334.56407,281.02604 C 334.51857,280.18042 335.14459,279.08508 336.10372,279.1889 z M 367.81369,281.56305 C 372.08402,279.7168 377.60876,284.82551 375.28387,289.15052 C 373.6236,292.67309 367.14833,291.4924 367.3635,287.41217 C 367.35245,285.46035 367.19489,283.45856 367.81369,281.56305 z M 352.38642,284.32743 C 356.66836,283.34572 360.59695,288.89644 358.21743,292.60021 C 353.94846,292.97974 351.73219,287.9133 352.38642,284.32743 z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400'%3E %3Crect fill='%23ce1126' width='600' height='400'/%3E %3Crect fill='%23002868' y='100' width='600' height='200'/%3E %3Ccircle fill='%23fff' cx='300' cy='200' r='80'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 2000 1000'%3E %3Ctitle%3EFlag of Kazakhstan%3C/title%3E %3Crect width='2000' height='1000' fill='%2300afca'/%3E %3Cg id='sun' fill='%23fec50c' transform='translate(1080.4716,420)'%3E %3Ccircle r='134.5497'/%3E %3Cg id='r16'%3E %3Cg id='r4'%3E %3Cpath id='r' d='m0,-152.9c8,-0.1 11,-5.1 11,-11.1c0,-8 -11,-46.1 -11,-46.1s-11,38.1 -11,46.1c0,6 3,11.1 11,11.1z'/%3E %3Cuse xlink:href='%23r' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(45)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(67.5)'/%3E %3C/g%3E %3Cuse xlink:href='%23r16' transform='rotate(11.25)'/%3E %3C/g%3E %3Cg id='bird' fill='%23fec50c'%3E %3Cpath d='M316.94,213.44c-1.08,0.06-2.13,0.2-3.16,0.53-1.41,0.19-2.76,0.68-4.16,0.91l-0.56,0.09-0.94,0.09c0.06,0.26,0.1,0.52,0.1,0.78,0,0.27-0.03,0.53-0.1,0.75-0.06,0.21-0.25,0.47-0.4,0.63-0.2,0.22-0.41,0.41-0.66,0.53-0.24,0.12-0.51,0.17-0.78,0.19-0.27,0.01-0.55,0-0.81-0.1-0.27-0.09-0.52-0.26-0.75-0.46-0.28,0.07-0.57,0.12-0.84,0.15-0.28,0.03-0.54,0.03-0.79,0-0.28-0.08-0.57-0.17-0.84-0.28s-0.53-0.25-0.78-0.41c-1.02,0.6-2.16,1.17-2.78,2.22-0.35,0.48-0.42,1.03-0.5,1.6-0.05,0.7,0.13,1.44,0.43,2.09,0.11,0.19,0.2-0.69,0.54-0.81,0.57-0.47,1.28-0.81,2-1,0.61-0.31,0.53,0.02,0.28,0.5-0.06,0.25-0.4,1.2,0.06,0.72,2.03-0.9,4.28-1.08,6.47-1.25,3.18-0.33,6.37-0.4,9.56-0.44,3,0.04,6,0.08,9,0.19,1.43,0.04,2.87,0.36,4.28,0.12,0.34-0.09,0.87-0.11,1.07-0.31-0.64-0.37-1.39-0.38-2.1-0.47h-5.72c-1.59-0.16-3.25-0.18-4.75-0.78-0.4-0.16-0.77-0.54-1.15-0.13-0.57,0.2-1.18,0.34-1.78,0.38-1.05,0.08-2.1-0.14-3.07-0.53,0.7-0.97,1.54-1.82,2.31-2.72-0.62-0.1-1.22-0.23-1.84-0.38,1.09-0.75,2.1-1.6,3.16-2.4z' transform='scale(3.3333333,3.3333333)'/%3E %3Cpath d='m1212.2,746.01c-7.2452,4.3503-12.775-3.3623-18.831-5.6752-4.3249,2.3488-4.7288,10.208-8.7706,13.93-4.8342,5.5019-10.76-1.5363-10.318-6.9649-5.7825,4.8741-8.7067,15.922-18.057,14.446-4.4308-3.6151-7.7219-11.201-11.106-2.5636-2.7613,4.2221-10.11,10.229-13.916,3.8533-1.1784-5.6287-4.0008-12.25-7.0634-3.3078-2.1024,6.3247-8.8507,10.978-15.379,8.2088-3.5737-2.9216,2.8649-13.727-1.6841-12.958-6.7998,4.4958-10.753,15.658-20.242,14.764-3.6847-4.1359,2.236-11.144-1.8057-15.735-4.7711,6.1235-10.063,15.089-18.315,15.735-3.9884-3.2319,0.1571-12.501-2.3893-13.873-8.4677,5.0781-17.402,14.128-28.05,11.294,4.1497-15.873,21.49-21.442,36.072-22.68,25.089-3.0835,51.484,2.5863,75.624-6.469,3.9004-2.3734,13.35-5.7392,9.9847-11.244-2.9805-4.3463,7.7529-2.647,8.7855-7.7238-0.639-6.4302,4.9265-5.5452,10.364-6.108,24.376-1.0516,48.455,4.0818,72.758,4.9546,1.8358,11.842-11.301,20.157-21.876,16.5-5.0519,0.81828-12.627-11.615-11.142-2.5698-1.0183,4.7472-0.3056,11.017-4.6433,14.188m-207.4-24.248c5.6435,5.1653,9.6005-0.97254,14.875-3.2155,17.692-6.085,33.128-16.719,48.346-27.344,9.221-7.6305,17.214-17.525,29.597-20,24.155-7.303,49.832-6.4173,74.081-13.157,18.464-25.281,49.825-34.299,76.096-48.831,5.8991-1.8316,8.1781-6.6867,10.062-12.047,10.028-15.83,23.689-29.857,39.845-39.439,7.6441-4.1767,16.764-6.5825,25.418-4.6718-0.6201,10.307-6.5329,19.442-13.672,26.57,5.842-0.12861,10.863-3.8191,16.767-3.6114,2.0233,10.578-9.4007,16.114-15.478,22.7,3.3855,0.78754,16.353,1.7684,9.2865,5.1591-9.0054,6.2497-19.289,10.541-27.602,17.799,7.6694,1.3778,8.5436,3.0082,0.7445,5.782-4.2215,2.8617-12.341,3.8616-13.126,9.4374,5.7939,3.5608-2.6685,7.0964-5.933,8.2546-6.2414,1.4535-12.798,4.1652-4.5067,8.9071-3.1365,4.7384-9.8653,5.7486-15.356,5.2805,1.6661,5.3701,4.0776,11.378-2.8919,13.747-15.624,11.811-33.96,20.402-53.601,22.367,24.536,1.8866,49.807-2.668,70.773-16.011,2.768-3.2727,17.282-6.7896,9.1636-9.5419-3.822-1.5904-12.016-3.3567-12.57-6.2707,11.355-7.006,25.664-4.514,37.88-8.6758,0.3163-3.9551-9.2914-2.8547-12.874-3.7554-8.5427-0.69975-8.0417-2.8803,0.1954-3.6882,10.422-2.759,22.226-3.3028,30.993-10.098-7.1383-3.3066-16.116-0.39512-23.732-3.0955,12.911-5.6498,28.142-6.2167,39.726-14.704,5.2763-5.871-6.7598-4.0356-10.267-3.8931-7.1509,1.2447-10.456-2.1779-2.3324-5.1489,13.871-10.227,31.433-16.871,41.176-31.697,2.3078-3.3186,5.4328-13.319-1.9277-9.7216-9.681,3.2185-18.198,14.101-29.228,10.735,21.733-16.844,42.413-36.02,57.267-59.33,0.7674-6.7232-9.7852-7.4509-12.532-2.172-13.963,13.454-26.6,29.335-44.477,37.77,17.121-16.525,31.276-36.092,43.626-56.372,2.6476-6.0321,9.7642-13.286,5.9021-19.983-6.2255-5.1532-14.013-0.43606-17.248,5.7304-10.854,14.169-19.096,30.708-33.054,42.25,12.219-23.322,24.871-48.148,25.179-75.047-0.037-5.5382-1.1493-13.694-8.6693-12.659-5.9622,1.0681-4.5464,9.9912-7.0042,14.504-5.4111,18.377-7.9508,38.279-19.05,54.371,2.4971-14.934,6.8661-30.5,3.512-45.58-1.5667-6.7396-12.45-3.8412-11.048,2.8288-13.002,65.86-57.194,123.46-114.99,156.78-26.464,14.973-56.023,24.626-86.096,29.002-8.0899,1.7718-16.839,0.73198-24.572,3.4906-18.736,14.367-30.079,38.407-53.802,45.935-10.632,5.2835-24.496,6.3556-32.098,16.233-0.658,1.2632-0.7991,2.7266-0.7739,4.1273'/%3E %3Cpath d='m1075.8,654.95c-3.5006,6.354-5.5592,13.658-10.06,19.347-13.541-12.321-33.171-11.914-50.347-12.734-14.177-0.75657-29.594-2.0646-40.563-12.176-11.539-9.452-20.958-21.724-33.852-29.393-11.769-3.2001-23.633-7.2042-33.095-15.271-20.22-16.482-31.8-40.937-51.558-57.933-3.7669-3.7078-8.209-6.5812-12.429-9.7268-4.0096,0.97695-2.1955,9.6311-7.1022,5.2194-2.6694-1.8995-9.348-2.0844-9.9492,0.56937,6.0404,7.96,12.087,17.049,12.924,27.23-4.1198,0.4224-11.445-0.87064-13.487,0.66378,5.4715,8.2003,12.484,15.473,20.452,21.263-3.8217,0.61454-11.353,0.27988-12.818,1.8198,7.9092,6.4462,16.391,13.034,26.747,14.69,2.12,2.7948-3.099,8.1901,1.2898,10.576,2.5458,1.0399,10.945,2.7801,5.1592,5.6751-3.9705,2.6755-2.4971,8.9111,2.5797,8.7706,3.2101,1.6391,10.418,2.0412,10.982,4.879-2.8453,2.8956-11.698,6.3288-4.1637,9.0409,7.039,3.904,15.067,6.4384,23.105,6.7168-4.0336,3.3936-9.004,5.3206-13.156,8.5127,18.55,10.877,39.113,18.03,59.433,24.919,8.0909,2.7031,16.274,5.2237,24.661,6.8102-24.369-1.4066-47.922-8.6212-70.116-18.495-11.503-5.0452-23.084-9.9197-34.873-14.265,5.1692-2.6897,11.148-3.3471,16.509-5.6751-11.128-2.2291-23.285-2.9605-33.067-9.0768,1.4997-2.6758,7.1829-2.8021,10.326-4.1642,5.9114-1.416,9.5779-3.1339,1.2438-3.6475-8.4057-2.2812-18.045-1.2576-25.452-6.3278,0.4769-3.04,8.2283-1.9813,11.386-3.2934,3.9751-0.683,8.3958-1.2548,11.573-3.9294-12.994-5.388-29.99-1.5707-40.168-13.046-2.3476-4.3712,7.2884-0.85006,10.033-1.5782,6.9723,0.00003,14.467,2.2158,21.107-0.59559-18.934-8.3124-39.215-16.095-53.655-31.471-1.6039-2.4716-6.4071-9.2249-2.5317-10.06,11.239,1.4869,19.374,13.753,31.396,11.844,1.5973-2.1526-6.9835-5.6809-9.1254-8.7582-17.528-15.041-34.541-31.364-46.825-51.066-0.84492-6.5792,9.4971-7.565,12.22-2.4832,13.405,12.911,25.514,27.977,42.209,36.791,5.9247,2.8724-3.4012-3.4-4.6433-5.6751-15.427-17.914-30.113-36.834-40.895-57.932-1.9299-3.8028-5.1284-10.686,0.64643-12.71,5.7722-2.8919,11.501,1.0476,14.428,6.0066,11.342,14.305,19.688,31.307,33.817,43.225-12.037-23.359-24.889-47.948-25.2-74.828,0.28226-5.2109,0.61728-13.092,7.6832-12.878,5.9331-0.89942,4.9962,6.696,6.941,10.318,5.845,19.747,8.3946,41.121,20.121,58.556-2.5904-14.649-6.4022-29.735-3.8694-44.627,0.58422-4.8898,6.0884-6.37,9.6818-3.4138,2.9046,7.11,3.5106,15.889,6.1574,23.491,15.06,51.519,48.875,96.832,92.941,127.24,36.292,24.891,79.362,39.749,123.32,42.341,3.9698,0.346,7.9556,0.46548,11.932,0.70954'/%3E %3Ccircle cx='1020' cy='720.887' r='2.367'/%3E %3Ccircle cx='1019.8' cy='720.507' r='0.965' stroke='%2300afca' stroke-width='0.38127393'/%3E %3C/g%3E %3Cg id='ornament' fill='%23fec50c'%3E %3Cg id='oh'%3E %3Cg id='oq'%3E %3Cpath d='m120,72.922s-9.6109-8.0762-12.874-4.0253c-5.2494,6.5154,16.14,38.968,16.14,50.396,0,18.759-12.517,23.861-27.973,26.539-10.371,1.7981-27.259-0.752-27.259-0.752,3.1796-4.2726,5.2478-5.5316,10.606-5.8731-5.9648-3.0968-12.039-9.8188-12.039-20.284,0-16.138,6.6434-22.789,6.6434-40.983,0-10.093-8.2759-22.941-8.2759-22.941,14.628,1.464,21.878,15.009,17.753,25.834,2.3286,0.33542,4.4428-0.18873,6.2586-1.9094,1.0706,3.0005-0.61945,6.4832-2.8834,9.4837,1.8233,0.97432,3.1624,0.39003,6.0661-0.20942-0.27536,3.0915-2.1278,6.3758-6.6597,9.4671,13.151-3.4144,21.243,5.7517,21.243,15.347,0,7.248-5.0791,12.443-10.044,12.443-1.6044,0-3.9611-0.66078-5.2908-1.6532-0.93725,1.9948-0.45429,4.6646,0.51121,6.6596-3.6388-0.96187-5.9484-3.1229-4.3043-7.6212-2.7948-0.25675-5.0181-1.2011-6.5305-3.0005,1.5323-1.9624,3.8568-3.0927,6.5305-3.0005-2.035-4.1994,0.23284-6.5505,3.5373-8.456,0,0-2.1015,8.4558,3.2654,8.4558,2.4133,0,4.6122-0.78561,4.6122-4.3421,0-3.097-2.7075-7.387-8.9659-7.1142-6.2586,0.27277-11.332,4.3152-11.332,14.306,0,9.2162,7.4334,13.8,17.229,14.096,8.8338,0.27277,15.501-4.5126,15.501-13.625,0-12.128-17.508-39.773-17.508-50.581,0-8.109,7.2922-12.635,14.427-12.635,9.2518,0,17.058,9.1612,17.058,9.1612l-5.4352,6.8146z'/%3E %3Cpath id='op' d='m122.02,292.14c0,20.27-18.198,30.688-32.498,30.688-19.266,0-29.524-11.519-29.524-26.598,0-8.5475,1.5661-13.911,5.5074-22.092,0,0,31.78-66.091,44.153-91.653,1.543-3.1882,2.0408-6.8175,2.0408-12.138,0-8.2171-7.97-14.933-16.327-15.139-7.618-0.19053-15.918,7.1022-15.918,15.412,0,10.093,5.2358,14.593,10.612,14.593,6.6157,0,9.2518-2.7198,9.2518-7.3649,0-3.2366-1.5632-4.6371-3.8095-4.6371-5.6744,0-4.0817,7.6376-4.0817,7.6376-2.8183-0.617-5.1335-3.4965-3.8095-7.0921-2.0617-0.45904-3.9929-1.5413-5.5102-3.2733,1.5211-1.4747,3.266-2.6132,5.5102-3.0005-1.3289-4.3872,0.44687-6.5308,4.2857-7.433-0.77466,1.6876-0.80131,3.2401-0.54421,4.7054,6.0436-1.7186,15.306,1.0163,15.306,11.456,0,10.365-7.1935,19.093-20.681,16.912,3.2087,1.5341,4.8407,4.6732,5.1701,8.1832-2.4491-0.9547-5.1701-1.0911-5.1701-1.0911,1.577,2.7808,3.7672,5.1776,3.6734,10.638-2.5006-1.1368-4.8227-3.2419-8.0272-1.9094,5.0294,9.8968-1.1497,23.511-16.871,26.732,5.7537-6.7443,8.5714-14.027,8.5714-21.277,0-23.496-6.5305-27.445-6.5305-43.78,0-6.8343,3.5133-14.215,10.476-19.231v0.27276c-4.6021-1.2324-7.5502-3.4985-9.2447-6.5775,10.515-2.9816,25.799-2.9269,34.006,0.30202,9.434,1.0925,16.019,8.3308,17.959,12.004,1.9406,3.6708,5.7096,16.953,0,28.912-6.2487,13.088-35.711,75.559-44.897,95.198-1.9484,4.1654-3.1293,8.5827-3.1293,13.366,0,12.03,11.02,16.23,17.279,16.23,7.4829,0,15.102-5.7008,15.102-12.82,0-4.5112-2.4491-7.2285-5.9864-7.2285-8.4587,0-7.9449,7.1957-6.2586,11.729-5.2643-2.3667-8.3243-6.5917-7.4829-11.047-2.9805-0.40822-5.8174-1.822-8.4353-4.7735,2.0598-2.601,4.5722-4.5671,8.4353-4.6371-1.6873-6.9119,2.9406-9.8352,7.4829-11.456-1.437,5.0729-2.3803,10.911,6.2586,10.911,6.2986,0,11.258,1.0911,14.15,5.1827,0.17007-5.4553,0.68027-27.005,0.68027-27.005,0.36281-8.0977-10.839-7.8662-17.959-5.4554,2.6871-9.3276,8.1979-14.371,20.952-13.093-3.0953-1.2957-6.3946-4.2084-6.3946-9.8198,0.002-7.593,6.1621-16.005,10.206-18.492l2.022,79.051z'/%3E %3Cuse xlink:href='%23op' transform='matrix(1,0,0,-1,0,645.08)'/%3E %3C/g%3E %3Cuse xlink:href='%23oq' transform='matrix(-1,0,0,1,240,0)'/%3E %3C/g%3E %3Cuse xlink:href='%23oh' transform='matrix(1,0,0,-1,0,1000)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg stroke='%23000' stroke-width='1.4377'%3E %3Cg id='border' stroke='%23fff' stroke-width='9.6' stroke-linejoin='round'%3E %3Cuse xlink:href='%23shield'/%3E %3Cuse xlink:href='%23motto1'/%3E %3Cuse xlink:href='%23motto2'/%3E %3Cuse xlink:href='%23rope'/%3E %3Cuse xlink:href='%23turtle'/%3E %3Cuse xlink:href='%23pineapple1'/%3E %3Cuse xlink:href='%23pineapple2'/%3E %3C/g%3E %3Cg id='motto'%3E %3Cg id='motto1' fill='%23fcea83'%3E %3Cpath d='m754.417,449.563c2.87535,7.66776,23.4825,17.7317,47.4443,4.79235,16.294-9.10547,26.8372-22.0448,36.9011-45.0481,2.87534-5.75082,4.31301-12.9394-2.39625-17.2525-5.27159-3.83388-13.8978-8.14701-17.7317-11.9809-1.91689-1.91694-3.83392-3.35465-5.27159-4.79236,0.95845,0.95848,1.9169,1.91695,2.87535,3.35465,9.58473,11.5016-0.47923,28.2749-11.0224,38.3388-7.66771,7.18852-21.5656,24.9202-41.6934,8.14699-4.31314-3.83388-14.3771,11.9809-9.10551,24.441z'/%3E %3Cpath d='m1045.79,449.563c-3.3547,7.66776-23.9618,17.7317-47.4443,4.79235-16.294-9.10547-26.8372-22.0448-37.3804-45.0481-2.39625-5.75082-3.83392-12.9394,2.87534-17.2525,5.27159-3.83388,13.8979-8.14701,17.7317-11.9809,1.91702-1.91694,3.35469-3.35465,5.27159-4.79236-0.95845,0.95848-1.9169,1.91695-2.87535,3.35465-9.58473,11.5016,0.47923,28.2749,10.5432,38.3388,7.66769,7.18852,22.0448,24.9202,42.1727,8.14699,4.3132-3.83388,13.8978,11.9809,9.1055,24.441z'/%3E %3Cpath d='m900.105,490.778c38.3388,0,97.2848-17.2525,128.914-77.6361,5.2716-10.0639,0-15.3355-6.23-18.6902-6.7093-2.87541-14.8564-9.58471-19.1694-13.8978,7.6677,7.66778,6.2301,12.9394,0.9585,21.5656-24.4411,40.735-57.9875,61.3421-104.473,61.3421-46.4859,0-80.0323-20.6071-104.473-61.3421-5.27159-8.62625-6.70939-13.8978,0.47922-21.5656-3.83392,4.31312-12.4602,11.0224-19.1695,13.8978-6.23004,3.35465-11.5016,8.62623-6.23004,18.6902,31.6295,60.3837,91.0547,77.6361,129.394,77.6361z'/%3E %3C/g%3E %3Cg id='motto2' fill='%23db161c'%3E %3Cpath d='m811.446,409.787c-0.95847-4.79235-7.18853-2.87541-9.10547,2.87541-2.39617-3.35464-4.79235-6.70929-6.70929-10.5432-5.75083-8.62623-6.7093-14.3771,1.4377-22.5241,3.83389-3.83388,11.5016-8.147,16.7732-3.35464,11.0224,9.10547,5.27159,23.9618-2.39618,33.5465z'/%3E %3Cpath d='m988.284,409.787c0.95847-4.79235,7.66776-2.87541,9.5847,2.87541,2.39616-3.35464,4.79236-6.70929,6.70926-10.5432,5.7509-8.62623,6.7093-14.3771-1.9169-22.5241-3.35465-3.83388-11.0224-8.147-16.7732-3.35464-10.5432,9.10547-5.27159,23.9618,2.39618,33.5465z'/%3E %3Cpath d='m754.417,449.563c-4.79236-7.18853-8.62624-25.8787-9.58471-30.6711-1.43771-4.31312-1.91694-8.147,3.35465-10.0639,5.27159-1.91694,10.0639,4.79235,12.4601,10.5432,2.39617,5.75082,6.23006,14.3771,10.5432,24.9202-10.5432-6.23006-19.1694-1.91695-16.7732,5.27158z'/%3E %3Cpath d='m1045.79,449.563c4.3131-7.18853,8.147-25.8787,9.5847-30.6711,0.9585-4.31312,1.9169-8.147-3.3547-10.0639-5.2715-1.91694-10.0639,4.79235-12.4601,10.5432-2.3962,5.75082-6.23,14.3771-10.5432,24.9202,10.5432-6.23006,18.6902-1.91695,16.7733,5.27158z'/%3E %3C/g%3E %3Cg fill='%2300493d' stroke='none'%3E %3Cpath d='m782.213,406.432-3.83389,1.91694c-0.95847,0.47924-0.95847,1.43771-0.95847,1.91695h-0.47923l-1.91694-4.31312h0.47923c0,0.47923,0.47924,0.95847,1.43771,0.47923l8.147-4.31312c0.95847-0.47923,0.95847-0.95847,0.47923-1.4377l0.47924-0.47924,2.39618,4.79236h-0.47924c-0.47923-0.47924-0.95847-0.95847-1.91694-0.47924l-3.35465,1.91694,1.43771,2.87542,3.83388-1.43771c0.95847-0.47924,0.47924-1.43771,0.47924-1.91694h0.47923l1.91694,4.31312c-0.47923-0.47924-0.95847-0.95847-1.91694-0.47924l-8.147,4.31312c-0.95847,0.47923-0.95847,0.95847-0.47923,1.4377l-0.47924,0.47924-2.39618-4.31312,0.47924-0.47923c0.47923,0.47923,0.95847,0.95847,1.91694,0.47923l3.83388-1.91694-1.4377-3.35465z'/%3E %3Cpath d='m790.36,412.662c0.95847-0.47923,0.95847-0.95847,0.47923-1.91694h0.47924l4.79235,7.18853-3.35465,2.39618v-0.47924c1.91695-1.4377,1.91695-3.35464,1.43771-3.83388-0.47923-0.47924-0.95847-0.95847-0.95847-1.43771-0.47924,0-0.47924-0.47923-1.43771,0.47924-0.47923,0.47923-3.35464,2.39618-3.35464,2.39618,0.47923,0.47923,0.95847,1.91694,3.35464,0.47923h0.47924l-5.27159,3.83388v-0.47923c2.39618-1.91694,1.43771-3.35465,0.95847-3.83388l-3.35465,2.39617c-0.95847,0.47924-0.95847,0.95847-0.95847,1.43771,0.47924,0,0.47924,0.47923,0.95847,0.95847,0.47924,0.95847,1.91695,1.91694,4.31312,0.95847l0.47924,0.47924-3.83389,1.4377-4.79235-7.66776h0.47924c0.47923,0.47923,0.95847,0.95847,1.91694,0.47923l7.18853-5.27159z'/%3E %3Cpath d='m798.027,430.873-3.35464,2.87541c-0.47924,0.47923-0.47924,1.4377,0,1.91694h-0.47924l-3.35465-3.35465,0.47924-0.47923c0.47923,0.47923,0.95847,0.95847,1.91694,0l6.23006-6.23006c0.95847-0.47924,0.95847-0.95847,0.47924-1.91694l3.35464,3.83388c-0.47923-0.47924-1.4377-0.47924-1.91694,0l-2.87541,2.87541,2.39618,2.39618,2.87541-2.39618c0.95847-0.95847,0.47923-1.43771,0-1.91694l0.47923-0.47924,3.35465,3.83389h-0.47923c-0.47924,0-0.95848-0.47924-1.91695,0.47923l-6.23006,5.75083c-0.95847,0.95847-0.95847,1.4377-0.47923,1.91694v0.47923l-3.35465-3.83388c0.47924,0,1.43771,0.47924,1.91694,0l3.35465-3.35465-2.39618-2.39617z'/%3E %3Cpath d='m805.216,440.937,1.43771,1.4377c1.91694-4.31311,1.91694-4.31311,1.91694-4.31311s-1.4377,0.47923-3.83388,1.91694l0.47923,0.95847-0.47923,0.47923-0.95847-0.95847c-0.47924,0.47924-0.95847,0.47924-1.43771,0.95847-1.4377,0.95847-0.95847,1.43771-0.47923,1.91694v0.47924l-2.39618-2.39618h0.47924l1.91694-0.47923c9.5847-5.27159,9.5847-5.27159,9.5847-5.27159l0.47924,0.47923s-0.47924,0.47924-4.79235,10.064c0,0.95847-0.47924,1.4377,0,2.39617l-3.83389-3.35464,0.47924-0.47924c0.47923,0.95847,1.4377,0.95847,1.91694,0,0-0.47923,0.47923-1.43771,0.47923-1.91694l-1.4377-1.43771,0.47923-0.47923z'/%3E %3Cpath d='m809.05,450.522,0.47923-0.47924c0.47924,0.47924,0.95847,0.47924,1.91694,0l6.23006-8.147-0.47923-0.47924c-0.95847-0.47923-2.39618-0.47923-3.83388,0.95847v-0.47923l1.91694-2.39618,7.18853,5.27159-2.39618,2.87541h-0.47924c1.43771-1.4377,0.95848-3.35464,0-3.83388v-0.47924l-6.23005,8.14701c-0.95848,0.47923-0.47924,1.4377,0,1.91694h-0.47924l-3.83388-2.87541z'/%3E %3Cpath d='m821.51,452.439-2.39618,3.35464c-0.47924,0.95847,0,1.43771,0.47923,1.91695l-0.47923,0.47923-3.83388-2.87541v-0.47924c0.95847,0.47924,1.4377,0.47924,1.91694-0.47923l5.27159-7.18853c0.47923-0.95847,0-1.43771-0.47924-1.91694l0.47924-0.47924,3.83388,2.87541v0.47924c-0.95847-0.47924-1.43771-0.47924-1.91694,0.47923l-2.39618,3.35465,2.87541,1.91694,2.39618-3.35464c0.47924-0.95848,0-1.43771-0.47924-1.91695l0.47924-0.47923,3.83388,2.87541v0.47924c-0.47923-0.47924-1.4377-0.47924-1.91694,0.47923l-4.79235,7.66777c-0.95847,0.47923-0.47924,0.95847,0,1.4377v0.47924l-4.31312-2.87541h0.47924c0.47923,0,0.95847,0,1.4377-0.47924l2.39618-3.83388-2.87541-1.91694z'/%3E %3Cpath d='m831.095,465.857,0.47924-0.47924c0.47923,0.47924,1.4377,0.47924,1.91694-0.47923l3.83388-8.14701c0.47924-0.95847,0-1.4377-0.47923-1.91694l8.147,3.83389-1.91694,3.83388-0.47924-0.47924c1.43771-1.91694,0-3.83388-0.47923-4.31311-0.47924,0-0.95847-0.47924-1.43771-0.47924s-0.47924,0-0.95847,0.95847c-0.47924,0.47924-1.91694,3.35465-1.91694,3.35465,0.47923,0.47923,1.4377,1.4377,3.35465-0.95847h0.47923l-2.87541,5.75082-0.47924-0.47923c1.43771-2.87542-0.47923-3.35465-0.95847-3.35465l-1.91694,3.83388c-0.47923,0.95847,0,1.43771,0.47924,1.43771v0.47923l-4.79236-2.39617z'/%3E %3Cpath d='m844.992,472.567c-1.43771-0.95847-1.43771-3.83388,0-6.70929,0.95847-2.87542,2.87541-5.27159,4.79235-4.31312,1.43771,0.47923,0.95847,3.35465,0,6.23006-1.4377,3.35465-3.35465,5.27159-4.79235,4.79235h-0.47924c3.35465,1.43771,5.75083-0.47923,7.18853-3.83388,1.43771-2.87541,0.95847-6.23006-1.91694-7.66777-2.87541-1.4377-5.75082,0.47924-7.18853,3.83389-1.4377,3.35464-0.95847,6.70929,1.91694,7.66776h0.47924z'/%3E %3Cpath d='m859.849,473.525,1.91695-5.75082c0.47923-0.95847,0-1.43771-0.47924-1.91694l2.39618,0.47923v0.47924c-0.47924,0-0.95847,0-1.43771,0.95847l-1.91694,5.75082c-0.95847,2.39618-2.39618,4.31312-5.27159,3.35465-1.91694-0.47924-3.35465-2.87541-2.39618-5.27159l2.39618-6.23006c0.47924-0.95847,0-1.4377-0.47923-1.91694v-0.47924l4.31311,1.91695v0.47923c-0.47923-0.47923-1.4377-0.47923-1.4377,0.47924l-2.39618,6.23006c-0.47923,1.91694-0.47923,3.83388,0.95847,4.31311,1.43771,0.47924,2.87541-0.47923,3.83388-2.87541z'/%3E %3Cpath d='m864.162,467.295c0-0.47923,0-0.47923-0.47923-0.47923l3.35464,0.47923,2.87542,9.10547,1.4377-5.75082c0.47924-0.95847,0-1.43771-0.47923-1.91694l2.87541,0.47923-0.47924,0.47924c-0.47923,0-0.95847,0-1.4377,0.95847l-2.39618,10.5432h-0.47923l-3.83389-11.5016-2.39617,7.66776c0,1.43771,0.47923,1.43771,0.95847,1.91695v0.47923l-2.87542-0.95847v-0.47923c0.47924,0.47923,1.43771,0,1.43771-0.95848l2.39618-8.62623-0.47924-1.43771z'/%3E %3Cpath d='m880.456,476.88c-0.95847,4.31312-2.87541,5.27159-3.83388,5.27159h-0.95847s-0.47923-0.47924,0-0.95847l1.43771-9.58471c0.47923-0.47923,0.47923-0.95847,0.95847-0.47923h0.95847c0.95847,0,1.91694,1.91694,1.4377,5.75082l1.43771,0.47923c0.95847-4.79235-0.95847-6.70929-3.35465-7.18853-1.91694-0.47923-4.79235-0.95847-4.79235-0.95847v0.47924c0.47923,0.47923,1.43771,0.47923,0.95847,1.91694l-1.43771,8.62624c-0.47923,0.95847-0.95847,1.4377-1.4377,1.4377h-0.47924l4.79236,0.95847c2.39617,0.47924,4.79235,0,5.75082-5.27159l-1.43771-0.47923z'/%3E %3Cpath d='m884.769,473.046c0-0.95847-0.95847-1.43771-1.4377-1.43771v-0.47923l8.62623,0.95847-0.47923,3.83388c0-2.39618-1.43771-3.35465-2.39618-3.35465-0.47923-0.47923-0.95847-0.47923-1.43771-0.47923-0.47923,0-0.47923,0-0.47923,1.4377,0,0.47924-0.47924,3.83388-0.47924,3.83388,0.47924,0,1.91695,0.47924,2.87542-2.39617l-0.47924,6.23006h-0.47923c0-2.87541-1.43771-2.87541-1.91695-2.87541l-0.47923,4.31311c0,0.95847,0,0.95847,0.47923,0.95847l0.95847,0.47924c1.43771,0,2.87542-0.47924,3.83389-3.35465h0.47923l-0.95847,3.83389-9.10547-0.95848c0.95847,0,1.43771-0.47923,1.91694-1.4377l0.95847-9.10547z'/%3E %3Cpath d='m900.584,478.797c0,4.31312-1.43771,5.75083-2.87541,5.75083-0.47924-0.47924-0.47924-0.47924-0.95847-0.47924l-0.47924-0.47924,0.47924-10.0639c0-0.47923,0-0.47923,0.47923-0.47923h0.95847c0.95847,0,2.39618,1.4377,2.39618,5.75082h1.91694c0-4.79235-2.39618-6.23006-4.79235-6.23006-1.91694-0.47923-4.79236-0.47923-4.79236-0.47923v0.47923c0.47924,0,1.43771,0.47924,1.43771,1.43771l-0.47924,9.10547c0,0.95847-0.47923,1.43771-0.95847,1.43771v0.47923h4.31312c2.39618,0,4.79235-0.95847,5.27159-6.23006h-1.91694z'/%3E %3Cpath d='m914.482,482.631c0,0.95847,0.47924,0.95847,1.43771,0.95847v0.47924l-5.27159,0.47924c0.47924-0.47924,1.43771-0.95848,1.43771-1.91695l-0.95847-9.10547c-0.47924-0.95847-0.95847-0.95847-1.91694-0.95847v-0.47923l5.27158-0.47924c-0.47923,0.47924-1.4377,0.95847-0.95847,1.91694l0.95847,9.10547z'/%3E %3Cpath d='m919.274,483.589,0-0.47923c0.47923,0,0.95847-0.47924,0.95847-1.43771l-1.91694-10.0639h-0.47924c-0.95847,0.47924-1.91694,1.43771-1.4377,3.35465h-0.47924l-0.47924-3.35465,8.62624-1.43771,0.47924,3.35465h-0.47924c0-1.91694-1.43771-2.39617-2.87541-2.39617h-0.47924l1.91694,10.0639c0,0.95847,0.47924,1.4377,1.43771,1.4377v0.47924l-4.79235,0.47923z'/%3E %3Cpath d='m939.881,474.004-1.91694-5.75083c0-0.95847-0.95847-0.95847-1.43771-0.95847v-0.47923l2.39618-0.95847v0.47923c-0.47924,0.47924-0.47924,0.47924-0.47924,1.43771l1.91694,6.23006c0.47924,1.91694,0.47924,4.79235-2.39617,5.75082-1.91695,0.47924-4.31312-0.47923-4.79236-3.35465l-1.91694-6.23006c-0.47923-0.95847-0.95847-0.95847-1.4377-0.95847l-0.47924-0.47923,4.79235-1.43771v0.47924c-0.47923,0.47923-0.95847,0.95847-0.47923,1.91694l1.4377,6.23006c0.47924,1.91694,1.91695,2.87541,3.35465,2.87541,1.43771-0.47923,1.91694-2.39618,1.43771-4.79235z'/%3E %3Cpath d='m945.153,470.65c2.39617-0.95847,1.91694-2.39618,1.4377-3.83388-0.47923-1.43771-1.4377-2.39618-2.39617-1.91694-0.47924,0-0.95848,0.47923-0.47924,0.95847l1.43771,4.79235,0.47923,0.47924,0.95847,3.83388c0.47924,0.95847,1.43771,0.95847,1.91694,0.47923v0.47924l-4.31311,1.91694-0.47924-0.47924c0.95847-0.47923,0.95847-0.95847,0.95847-1.91694l-3.35465-8.147c-0.47923-1.4377-0.95847-0.95847-1.91694-0.95847v-0.47923l4.79236-1.91694c1.91694-0.47924,3.83388,0,4.79235,1.91694,0.47923,2.39617-0.47924,3.83388-2.39618,4.79235-0.47923,0-0.95847,0.47924-0.95847,0.47924l-0.47923-0.47924z'/%3E %3Cpath d='m957.134,472.087c-1.43771,0.47923-3.35465-1.43771-4.79235-4.79236-1.43771-2.87541-1.43771-5.75082,0-6.23006,1.4377-0.47923,3.35464,1.43771,4.79235,4.31312s1.43771,5.75083,0,6.7093c2.87541-0.95847,3.83388-4.31312,2.39618-7.66777-1.43771-2.87541-4.31312-4.79235-7.18853-3.83388-2.87542,1.4377-3.83389,4.79235-2.39618,7.66776,1.43771,3.35465,4.31312,5.27159,7.18853,3.83389z'/%3E %3Cpath d='m957.613,458.669h-0.47924-0.47924l2.87542-1.91695,8.62623,4.79236-2.87541-5.27159c-0.47923-0.95847-1.43771-0.95847-1.91694-0.95847v-0.47924l2.39618-0.95847c-0.47924,0.47924-0.95847,0.95847,0,1.91694l4.79235,9.58471-0.47924,0.47924-10.5432-5.75083,3.83388,7.18853c0.47923,0.95847,1.43771,0.95847,1.91694,0.47924v0.47923l-2.39618,1.43771v-0.47924c0.47924-0.47923,0.47924-0.95847,0-1.91694l-3.83388-7.66776-1.4377-0.95847z'/%3E %3Cpath d='m979.178,460.107,0-0.47923c0-0.47924,0.47923-0.95847,0-1.91694l-5.75083-8.14701h-0.47923c-0.95847,0.47924-1.43771,2.39618,0,3.83389l-0.47924,0.47923-1.91694-3.35464,7.18853-4.79236,1.91694,2.87541c-1.4377-1.4377-2.87541-1.4377-3.83388-0.95847l-0.47924,0.47924,5.75083,8.147c0.47923,0.95847,1.4377,0.95847,1.91694,0.47923v0.47924l-3.83388,2.87541z'/%3E %3Cpath d='m984.45,448.605,2.87541,3.35465c0.47923,0.47924,1.4377,0.47924,1.91694,0v0.47924l-3.83388,3.35464v-0.47923c0.47923-0.47924,0.47923-0.95847,0-1.91694l-5.75083-7.18853c-0.47923-0.95847-0.95847-0.47924-1.91694-0.47924l3.83388-3.35465v0.47924c0,0.47923-0.47923,0.95847,0,1.91694l2.39618,2.87541,2.87541-1.91694-2.39617-3.35465c-0.47924-0.95847-1.43771-0.47923-1.91695-0.47923l3.83389-3.35465v0.47924c-0.47924,0.47923-0.47924,0.95847,0,1.91694l5.75082,7.18853c0.47924,0.47923,0.95847,0.47923,1.43771,0l0.47923,0.47923-3.83388,3.35465-0.47924-0.47923c0.47924-0.47924,0.95847-0.95847,0.47924-1.91695l-2.87541-3.35464-2.87541,2.39617z'/%3E %3Cpath d='m988.763,438.541c-0.47923-0.47923-1.4377-0.47923-1.91694,0v-0.47923l6.23006-5.75083,2.87541,2.87541h-0.47923c-1.43771-1.91694-3.35465-0.95847-4.31312-0.47923,0,0.47923-0.47924,0.47923-0.95847,0.95847,0,0,0,0.47923,0.47923,1.43771,0.47924,0.47923,2.87542,2.87541,2.87542,2.87541,0.47923-0.47924,1.91694-1.43771,0-3.83389h0.47923l3.83388,4.31312v0.47924c-2.39617-2.39618-3.35464-0.95847-3.83388-0.47924l2.87541,2.87541c0.47924,0.95848,0.95847,0.95848,0.95847,0.95848,0.47924-0.47924,0.95848-0.95848,1.43771-1.43771,0.47924-0.47924,0.95845-1.91694,0-4.79235h0.47924l1.91691,3.35464-6.23003,6.23006-0.47924-0.47923c0.47924-0.47924,0.95847-0.95847,0-1.91694l-6.23006-6.7093z'/%3E %3Cpath d='m1000.26,425.122c-0.47921,0.47924-0.47921,1.43771,0.4793,1.91694,0.9584,0.95847,1.9169,0.95847,3.8338,0,0.9585-0.47923,2.8755-0.95847,4.3132,0.47924,2.3961,2.39618,1.4377,4.31312,0.9584,5.27159-0.4792,0.47923-1.4377,0.95847-1.9169,1.4377-0.4792,0-0.4792,0-0.4792,0.47924v0.47923l-3.3547-2.87541h0.4792c1.917,0.95847,3.8339,1.43771,4.7924,0,0.9585-0.95847,0-1.91694-0.4792-2.39617-0.9585-0.95848-1.917-0.95848-3.3547,0-1.4377,0.47923-3.3546,0.47923-4.7923-0.47924-1.91698-1.91694-1.91698-3.35465-0.95851-4.79235,0.47921-0.47924,1.43771-0.95847,1.91691-1.43771,0.4793,0,0.4793,0,0-0.95847l3.3547,2.39618h-0.4793c-2.3961-0.95847-3.8338-0.47924-4.3131,0.47923z'/%3E %3Cpath d='m1004.58,421.288c-0.9584-0.47924-1.4377,0-1.9169,0.47923h-0.4792l5.2716-7.66776,3.3546,2.39618-0.4792,0.47923c-1.917-1.43771-3.8339-0.47923-4.3132,0,0,0.47924-0.4792,0.95847-0.4792,1.43771-0.4792,0-0.4792,0.47923,0.4792,0.95847,0.4793,0.47923,3.3547,2.39617,3.3547,2.39617,0.4792-0.47923,1.4377-1.4377-0.4792-3.35464v-0.47924l4.7923,3.83388c-2.8754-1.4377-3.3546,0-3.8339,0.47924l3.3547,2.39618c0.9584,0.47923,1.4377,0.47923,1.4377,0.47923,0-0.47923,0.4792-0.95847,0.9585-1.4377,0.4792-0.95848,0.9584-2.39618-0.9585-4.31312l0.4792-0.47924,2.3962,2.87541-4.7924,7.18853h-0.4792c0.4792-0.95847,0.4792-1.4377-0.4792-2.39617l-7.1886-5.27159z'/%3E %3Cpath d='m1017.52,412.662-1.4377,2.39618c-1.917-1.91694-2.8754-3.35465-2.8754-3.35465l4.3131,0.95847h0.9585c0.4792,0,1.4377,0.47924,1.9169,0.47924,1.4377,0.47923,0.9585,0.95847,0.4792,1.91694h0.4793l2.3962-4.31312c-0.9585,0.95847-1.4378,0.47924-2.3962,0.47924-10.064-1.91694-11.0224-2.39618-11.0224-2.39618v0.47924l7.6677,8.62623c0.4793,0.47924,0.4793,1.43771,0.4793,1.91694h0.4792l1.4377-2.39617-0.4792-0.47924c-0.4793,0.95847-0.9585,1.43771-1.917,0-0.4792-0.47923-0.9584-0.95847-0.9584-0.95847l1.4377-3.35465h-0.9585z'/%3E %3Cpath d='m1014.64,402.119c-0.4793,0.47924-0.4793,1.43771,0.9585,1.91695,1.4377,0.47923,1.9169,0,3.3546-0.95847,1.4377-0.95848,2.8754-1.91695,4.7924-0.95848,2.8754,1.43771,2.3961,3.83389,1.9169,4.79236-0.4792,0.47923-0.9585,1.4377-1.4377,1.91694v0.47924,0.47923l-3.8339-1.91694c2.3962,0.47923,4.3131,0,4.7924-1.43771,0.4792-0.95847-0.4793-1.91694-0.9585-2.39617-0.9585-0.47924-1.917,0-3.3547,0.95847-1.4377,1.4377-2.8754,1.91694-4.7923,0.95847-1.917-0.95847-2.8754-2.39618-1.917-3.83389,0-0.95847,0.9585-1.4377,1.4378-1.91694,0-0.47923,0-0.47923-0.4793-0.95847v-0.47923l3.8339,1.91694h-0.4792c-2.3962-0.47924-3.8339,0.47923-3.8339,1.4377z'/%3E %3C/g%3E %3C/g%3E %3Cg id='crest'%3E %3Cg id='rope' fill='%23073163'%3E %3Cpath fill='%23fff' d='m863.203,232.47c-6.23006,1.43771-10.5432,1.91694-16.294-3.35465-3.83388-3.83388-2.87541-10.5432,0.95847-12.9394,4.31312-2.87541,8.147-4.79235,13.4186-3.35465,5.27159,1.43771,19.1694,14.3771,15.8148,14.8563-3.35465,0-8.62624,3.35464-13.8978,4.79235z'/%3E %3Cpath fill='%23fff' d='m878.06,209.466c1.91694-1.4377,4.31312-2.39617,10.5432-2.87541,5.75082-0.47923,10.0639-0.47923,11.5016,3.83388,1.91694,5.27159,3.35465,11.5016,7.18853,14.3771-2.39617,1.4377-14.3771,2.87541-18.6902,0.47923-5.75083-2.87541-7.18854-13.8978-10.5432-15.8148z'/%3E %3Cpath fill='%23fff' d='m919.274,209.946c1.91694-1.43771,4.31312-1.43771,10.5432-0.95847,6.23005,0.47923,8.62623,0.95847,10.0639,5.27159,1.4377,4.79235,0,11.0224,2.87541,15.3355-2.87541,0.95847-12.4601,0.95847-15.8148-2.39618-5.27159-3.83388-4.79235-14.8563-7.66776-17.2525z'/%3E %3Cpath d='m948.028,212.821c-4.31312-0.95847-7.18853-1.4377-9.10547,0,2.39617,2.87541,0.47923,14.3771,5.27159,18.2109,3.35464,2.39618,11.9809,2.87542,13.8978-2.39617,2.39618-4.79236,2.39618-11.9809-10.0639-15.8148z'/%3E %3Cpath d='m898.667,208.029c1.4377-1.43771,4.31312-1.91694,10.0639-1.91694,6.23006,0,10.0639,0.95847,11.9809,4.79235,1.91694,4.79235,1.43771,11.0224,4.79236,14.8563-1.43771,1.91694-14.3771,1.91694-18.211-0.95847-5.27159-3.35465-5.75082-14.3771-8.62623-16.7732z'/%3E %3Cpath d='m857.932,212.342c0-2.39618,3.35465-2.87542,11.9809-3.35465,8.62623-0.95847,9.10547-0.47924,11.9809,5.75082,1.43771,3.35465,3.35465,9.10547,7.18853,11.0224-10.5432,2.39617-13.8978,3.83388-19.6486,0.47923-4.31312-2.39618-9.10547-8.147-10.0639-10.5432-0.47924-1.4377-0.47924-2.87541-1.43771-3.35464z'/%3E %3C/g%3E %3Cg fill='%23f9d050' stroke-width='0.6469'%3E %3Cg id='pineapple1'%3E %3Cpath d='m880.935,163.46c-10.0639-7.66777-22.0448-14.8563-33.0672-16.294,7.18853,4.31312,27.3164,20.1279,32.588,25.3995'/%3E %3Cpath d='m886.686,156.271c-11.9809-8.147-25.8787-17.2525-39.2973-18.2109,10.064,5.27159,24.9202,17.7317,33.0672,27.7956'/%3E %3Cpath d='m902.021,142.853c6.7093-14.8563,13.8978-23.0033,23.4825-32.1088-4.79236,10.0639-10.064,30.6711-12.4601,38.8181'/%3E %3Cpath d='m912.565,140.457c4.79236-10.5432,11.9809-19.6486,24.441-25.3995-6.23006,6.23006-15.8148,24.9202-18.211,34.9842'/%3E %3Cpath d='m916.878,150.041c5.75082-8.147,17.2525-23.4825,37.8596-31.6295-11.9809,11.9809-29.7126,34.0257-34.0257,42.6519'/%3E %3Cpath d='m923.587,160.584c8.62623-4.79236,25.8787-12.4601,38.3388-10.0639-7.66776,2.87541-30.6711,13.4186-40.735,23.0033'/%3E %3Cpath d='m921.67,157.23c8.14701-8.62624,23.0033-21.5656,38.8181-26.8372-11.5016,11.0224-35.9426,35.9426-39.2973,39.7765'/%3E %3Cpath d='m898.667,151.958c-5.75083-17.7317-14.3771-34.5049-27.3164-39.7765,7.18853,10.5432,16.294,25.8787,21.0864,48.882'/%3E %3Cpath d='m887.644,151.479c-9.5847-11.5016-22.5241-23.0033-37.3804-25.3995,10.0639,5.75083,26.8372,22.5241,33.0672,38.8181'/%3E %3Cpath d='m892.916,151c-11.9809-21.5656-21.0864-25.3995-26.3579-29.7126,4.31312,8.147,14.8563,29.7126,21.0864,38.8181'/%3E %3Cpath fill='none' d='m868.954,149.562c5.75082,3.35464,14.3771,11.5016,17.2525,16.7732'/%3E %3Cpath d='m868.954,159.626c2.87541,2.39617,8.147,5.27159,12.9394,9.5847'/%3E %3Cpath d='m925.983,166.814c4.79236-3.83388,15.3355-10.0639,20.6071-11.9809'/%3E %3Cpath d='m922.629,163.46c4.79236-6.23006,14.3771-14.8563,17.7317-17.7317'/%3E %3Cpath d='m936.047,133.747c-4.31311,4.79235-14.3771,16.7732-18.2109,22.5241'/%3E %3Cpath d='m923.587,129.434c-3.35465,4.31312-10.064,16.7732-11.9809,21.0864'/%3E %3Cpath d='m885.727,130.393c2.87542,7.66777,8.147,20.6071,10.064,25.8787'/%3E %3Cpath d='m881.414,138.54c1.91695,2.87541,5.75083,9.58471,7.18854,14.3771'/%3E %3C/g%3E %3Cg id='pineapple2'%3E %3Cpath d='m897.708,136.143c0-4.31312,2.87541-9.10548,5.75082-9.10548,3.35465,0,5.75083,5.75083,5.75083,9.10548,0,3.83388-2.87542,7.18853-5.75083,7.18853s-5.75082-2.87542-5.75082-7.18853z'/%3E %3Cpath d='m891.478,139.977c0.47923-4.79236,3.83388-8.62624,6.70929-8.147,2.87541,0.47923,4.31312,6.23006,3.83388,9.5847-0.47923,3.83389-3.83388,6.7093-6.23005,6.23006-2.39618,0-4.79236-3.35464-4.31312-7.66776z'/%3E %3Cpath d='m904.418,141.415c-0.95847-4.31311,0.95847-9.10547,3.83388-9.5847,2.87542-0.47924,5.75083,4.31312,6.23006,8.147,0.95847,3.83388-1.4377,7.66776-3.83388,7.66776-2.39618,0.47924-5.75082-1.91694-6.23006-6.23006z'/%3E %3Cpath d='m897.229,145.249c0-4.79236,2.87541-9.10547,5.75083-9.10547,3.35464,0,5.75082,5.27158,5.75082,9.10547,0,3.83388-2.87541,7.18853-5.75082,7.18853-2.87542,0-5.75083-2.87541-5.75083-7.18853z'/%3E %3Cpath d='m888.603,147.645c0-4.31311,3.35464-9.10547,6.23005-9.10547,2.87542,0,5.75083,5.75083,5.75083,9.10547,0,3.83389-3.35465,7.18853-5.75083,7.18853-2.87541,0-6.23005-2.87541-6.23005-7.18853z'/%3E %3Cpath d='m906.335,145.728c0-4.31312,2.87542-9.10547,5.75083-9.10547,3.35464,0,5.75082,5.75083,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75083-2.87541-5.75083-7.18853z'/%3E %3Cpath d='m904.418,149.562c0-4.79236,3.35465-9.10548,6.23006-9.10548s5.75083,5.27159,5.75083,9.10548c0,3.83388-2.87542,7.18853-5.75083,7.18853s-6.23006-2.87542-6.23006-7.18853z'/%3E %3Cpath d='m896.75,153.875c0-4.79235,2.87541-9.10547,5.75082-9.10547,3.35465,0,5.75082,5.75083,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75082-2.87541-5.75082-7.18853z'/%3E %3Cpath d='m884.769,153.875c0-4.79235,2.39618-9.10547,4.79236-9.10547,2.39617,0,4.31311,5.75083,4.31311,9.10547,0,3.83389-2.39617,7.18853-4.31311,7.18853-2.39618,0-4.79236-2.87541-4.79236-7.18853z'/%3E %3Cpath d='m911.606,152.917c0-4.31312,2.39618-8.62623,4.79236-8.62623,2.39617,0,4.79235,5.27159,4.79235,8.62623,0,4.31312-2.87541,7.18853-4.79235,7.18853-2.39618,0-4.79236-2.87541-4.79236-7.18853z'/%3E %3Cpath d='m914.482,161.064c0.95847-4.79235,3.83389-8.62623,5.75083-8.147,1.91694,0.47924,2.39617,6.23006,1.4377,9.58471-0.47923,4.31312-3.35464,6.70929-5.27158,6.23006-1.91695-0.47924-2.87542-3.83388-1.91695-7.66777z'/%3E %3Cpath d='m905.376,159.626c0.47924-4.31312,3.35465-8.62624,5.75083-8.147,2.87541,0,4.31311,5.75082,3.83388,9.10547-0.47924,4.31312-2.87541,7.18853-5.27159,6.70929-2.39618,0-4.79235-3.35464-4.31312-7.66776z'/%3E %3Cpath d='m891.958,161.064c-1.4377-4.79235-4.31312-8.147-6.23006-7.66776-1.91694,0.47923-2.39617,6.23006-1.4377,9.58471,0.95847,3.83388,3.83388,6.23005,5.75082,5.75082,1.43771-0.47924,2.87541-3.83388,1.91694-7.66777z'/%3E %3Cpath d='m888.603,160.105c0-4.31312,2.39617-8.62623,4.79235-8.62623,2.87541,0,4.79235,5.27159,4.79235,8.62623,0,4.31312-2.39617,7.18853-4.79235,7.18853-1.91694,0-4.79235-2.87541-4.79235-7.18853z'/%3E %3Cpath d='m895.791,162.022c0-4.79235,2.87541-9.10547,5.75082-9.10547,3.35465,0,5.75082,5.27159,5.75082,9.10547,0,3.83389-2.87541,7.18853-5.75082,7.18853s-5.75082-2.87541-5.75082-7.18853z'/%3E %3Cpath d='m898.188,109.306c-0.95847,3.83388-4.31312,7.18853-1.91694,12.4601-4.31312-1.43771-8.147-1.91695-11.5016,1.91694,4.31312-0.47924,8.147,0.95847,10.0639,3.83388-3.83388-0.47924-5.75082,1.43771-6.70929,3.83388,3.35465-0.95847,6.70929-1.91694,8.147-1.4377-1.43771,1.4377-3.83388,3.83388-4.31312,5.75082,2.87541-2.39618,6.23006-1.91694,8.147-3.35465-1.4377,3.35465,1.43771,6.7093,3.83389,10.064-0.47924-4.79236,2.39617-8.14701,0.95847-10.5432,4.31312,0.95847,4.79235,4.79235,11.0224,4.79235-2.39618-1.43771-3.83388-6.23006-6.70929-6.23006,1.4377-0.47923,7.18853-0.95847,8.147,0-0.95847-1.91694-4.31312-3.83388-6.23006-3.83388,1.91694-1.91694,5.27159-5.75083,7.66776-6.7093-3.35465,0.47924-8.62623,0.95847-10.5432,3.83389,4.79236-3.83389,3.83389-11.0224,9.10548-11.9809-2.87542-0.47923-7.18853,1.43771-10.5432,4.79236,1.4377-2.87542,1.4377-6.7093,3.35465-7.66777-3.83389,0.95847-8.14701,5.75082-9.58471,8.147,0-2.39618-1.43771-6.23006-2.39618-7.66776z'/%3E %3Cpath d='m900.584,116.974c0,1.43771,0,4.31312-0.47924,5.27159'/%3E %3Cpath d='m906.814,116.495c-0.95847,0.95847-2.87541,4.31311-2.87541,7.18853'/%3E %3Cpath fill='none' d='m909.689,122.246c-1.43771,0.95847-2.87541,2.39618-3.35465,4.31312'/%3E %3C/g%3E %3C/g%3E %3Cg id='turtle' fill='%23059334'%3E %3Cpath d='m858.89,169.69c-3.35464,0-6.23006-1.43771-8.147-3.83388-3.35465-4.31312-12.4601-6.23006-16.294-2.39618-1.43771,0.95847-3.35465,0.95847-4.79235,1.43771-2.39618,0-5.27159,2.39617-4.31312,7.18853,1.91694-1.43771,2.39618,0,3.83388,0,0.95847-0.47924,0.47924,0.47923,0.47924,1.4377,0,2.39618,5.27159,7.18853,10.0639,6.7093,5.27159,0,7.66776,1.91694,8.62624,2.87541,1.4377,1.43771,0.47923,0.95847,1.4377,3.35465,1.43771,1.4377,1.91694,1.91694-0.47923,3.83388-3.35465,2.87541-5.75083,9.58471,0,14.8563,6.23006,4.79235,22.0448,11.9809,39.7765-1.91695,17.2525-13.4186,44.0896-5.75082,46.0066-0.95847,2.39618,4.79236,3.35465,7.66777,3.83389,10.064,0.47923,1.91694,2.87541,3.83388,6.23006,3.35464,3.35464,0,7.18853,1.43771,9.10547,2.87542,2.39617,1.4377,5.75082,0.95847,4.79235-3.35465-1.91694-13.4186-10.0639-15.3355-11.0224-21.5656,4.79235,0.47923,8.147,0.47923,10.0639-1.43771,1.43771-1.91694,3.35465-5.27159,5.27159-6.23006,1.43771-0.95847,1.43771-1.91694-0.47924-1.4377-2.39617,0.47923-3.83388,1.4377-8.147,0.95847-22.0448-2.39618-83.8662-19.1694-95.8471-15.8148z'/%3E %3Cpath fill='%23000' d='m956.654,185.984c-2.39617,1.43771-4.79235,3.83388-9.10547,9.58471-4.79235,6.23006-19.1694,12.4601-36.9011,12.4601-17.2525,0-27.7956-2.87541-35.4634-9.10547-4.31312-3.35465-7.66777-5.27159-10.5432-6.7093-5.27159-2.39618-6.23006-7.66776-4.79236-11.9809-1.4377,2.39617-2.39617,4.79235-5.27158,4.31312-1.91695,0-5.75083,0-4.79236,1.91694-0.47923-0.95847-0.47923-2.39618-0.95847-2.87541-0.47923-0.47924-0.95847-0.95848-0.95847-0.95848,1.43771,0.95848,4.79235-1.91694,7.18853-1.91694,1.91694,0.47924,4.31312-1.91694,3.83388-4.79235-0.47923-2.39618-0.95847-4.31312-1.4377-6.23006,3.83388-1.91694,54.1536,7.18853,64.2175,8.147,10.064,0.47924,38.8181,4.79235,34.9842,8.147z'/%3E %3Cpath d='m865.6,167.773c4.79235-4.79235,10.5432-7.18853,16.294-5.75083h1.43771c2.87541-2.39617,9.5847-2.87541,13.4186-0.95847h1.91694c5.75082-1.91694,16.7732,0,20.6071,3.83389l1.4377,0.95847c12.9394-0.95847,20.6071,4.79235,29.7126,13.8978,0.95847,0.95847,2.39617,2.87541,4.79235,3.35465,2.87541,0.47924,3.35465,1.91694,0.95847,3.35465-2.87541,1.4377-5.27159,3.83388-10.0639,9.10547-4.31312,5.75082-18.211,11.5016-35.4634,11.5016-16.7732,0-26.8372-2.87541-34.5049-8.62624-4.31312-3.35465-7.66777-5.27159-10.064-6.70929-2.87541-0.95847-6.70929-4.79236-5.27159-8.62624,0.95848-3.83388-1.4377-8.62624-3.35464-13.4186,1.4377-0.95847,5.27159-2.39618,7.18853-1.43771l0.95847-0.47923z'/%3E %3Cg fill='%2300493d'%3E %3Cpath d='m950.424,179.754c-9.10548-9.10547-16.7732-14.8563-29.7126-13.8978,0,0.47923,0,1.91694-0.47923,2.87541,7.66776,2.87541,18.6902,11.5016,23.4825,17.7317,1.91694-1.91694,5.27159-4.31312,6.7093-6.7093z'/%3E %3Cpath d='m919.274,164.898c-3.83389-3.83389-14.8563-5.75083-20.6071-3.83389,0,1.91695,0,4.79236-0.95847,6.7093,3.35464,1.4377,6.23006,4.79235,9.10547,8.147,1.91694-0.47924,6.70929-1.91694,9.10547-2.39618,0.95847-1.91694,2.87541-6.23006,3.35465-8.62623z'/%3E %3Cpath d='m896.75,161.064c-3.83389-1.91694-10.5432-1.4377-13.4186,0.95847-0.95847,1.91695-1.43771,5.75083-1.43771,7.66777,1.91694,0,4.79235,1.43771,5.75082,2.39618,2.87542-0.95847,6.7093-2.87542,8.14701-4.31312,0.47923-1.91694,1.4377-4.79235,0.95847-6.7093z'/%3E %3Cpath d='m865.6,167.773c4.79235-4.79235,10.5432-7.18853,16.294-5.75083-0.95847,1.43771-1.43771,4.31312-1.43771,7.18853-5.27158-0.47923-11.9809,0.95848-14.8563,2.87542v-4.31312z'/%3E %3Cpath d='m941.798,187.422c-4.31312-6.23006-14.8563-13.4186-22.0448-16.7732,0,0.47924-0.95847,2.39618-1.4377,3.83388,2.87541,4.31312,8.62623,13.8978,11.0224,19.1694,2.39618-0.95847,9.10547-3.83389,12.4601-6.23006z'/%3E %3Cpath d='m905.376,197.965c0.95847-6.7093,1.43771-16.294,1.43771-19.6486,2.39618-0.47924,7.18853-1.91694,9.10547-2.39618,2.39618,3.83388,8.147,13.8978,10.5432,18.6902-5.75083,1.4377-15.3355,3.83388-21.0864,3.35465z'/%3E %3Cpath d='m888.603,174.961c2.39617-0.95847,5.75082-2.87541,8.147-4.79235,1.91694,1.4377,5.75082,4.79235,7.18853,6.70929,0,4.31312-1.43771,16.7732-1.91695,21.0864-3.83388,0-10.0639-0.95847-13.4186-2.87542,0.47923-7.18853,0.95847-15.3355,0-20.1279z'/%3E %3Cpath d='m864.641,180.712c0.47923-0.95847,0.95847-4.31311,0.95847-5.75082,3.83388-2.39618,13.4186-4.79235,20.6071-0.95847,0.47923,4.79235,0,16.7732-0.47924,19.6486-6.23006-4.79236-16.294-11.5016-21.0864-12.9394z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' stroke='none' d='m840.679,172.086c-0.95847,0-1.43771-2.87542-3.35465-2.87542-0.47923,0-1.91694,0.47924-2.39617,0,0,0.95848,0.47923,1.91695,0.95847,2.39618,0.47923,1.43771,2.87541,0.47924,4.79235,0.47924z'/%3E %3Cpath d='m840.679,180.233c5.75082,0,6.70929-7.18853,9.58471-7.66777'/%3E %3Cpath d='m844.034,180.712c4.31312,1.91694,7.66776-8.147,11.0224-7.66776'/%3E %3Cpath d='m835.408,168.252c1.43771,0,2.39618-1.91694,4.79235,0.47924,0.95848,0.95847,2.39618,1.43771,3.35465,1.43771'/%3E %3Cpath d='m842.596,175.441c-1.91694,2.87542-5.27159,4.79236-7.18853,3.83389'/%3E %3Cpath d='m834.449,163.46c-1.43771,0.95847-2.39618,2.87541-3.35465,4.31312'/%3E %3Cpath d='m829.657,170.648v2.39618'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg stroke='none'%3E %3Cpath id='shield' fill='%23fff' d='m989.722,232.949v93.4509c0,80.9908-38.3388,108.786-89.617,130.831-51.2781-22.0448-90.0962-49.8405-90.0962-130.831v-93.4509h179.713z'/%3E %3Cpath fill='%23cf142b' d='m900.105,312.023c4.31315,0,11.0224-3.83388,16.7732-9.5847,6.23004-6.70929,16.7732-9.10547,27.7958,0,11.0224,9.10548,17.7317,5.27159,23.4825,0,5.75082-5.27158,10.5432-7.18853,21.5656-7.18853v-62.3006h-179.713v62.3006c11.0224,0,15.8148,1.91695,21.5656,7.18853,5.75082,5.27159,12.4602,9.10548,23.4826,0,11.5016-9.10547,21.5656-6.70929,28.2748,0,5.27159,5.75082,11.9808,9.5847,16.7732,9.5847z'/%3E %3Cg fill='%230b50a0'%3E %3Cpath d='m900.105,359.946c5.75083,0,17.2525-6.23006,20.1279-7.66776,10.5432-6.23006,18.2109-0.47924,24.441,2.39618,6.7093,2.87541,19.1694,6.23005,26.8372,0,7.66777-6.23006,11.9809-5.75083,17.2525-5.75083,0.95847-7.18853,0.95847-14.3771,0.95847-22.5241v-5.75082c-6.70929-1.43771-10.0639,0.47923-17.2525,6.70929-7.18853,6.23006-15.3355,4.79235-25.8787,0.95847-10.0639-4.31312-20.1279-11.9809-30.1918,0-2.87542,3.35465-9.58471,8.147-16.294,8.147-7.18853,0-13.4186-4.79235-16.294-8.147-10.5432-11.9809-20.1279-4.31312-30.1918,0-10.5432,3.83388-19.1694,5.27159-26.3579-0.95847-6.70929-6.23006-10.0639-8.147-17.2525-6.70929v5.75082c0,8.147,0.47923,15.3355,1.4377,22.5241,5.27159,0,9.10548-0.47923,16.7732,5.75083,7.66777,6.23005,20.6071,2.87541,26.8372,0,6.7093-2.87542,14.3771-8.62624,24.9202-2.39618,2.87541,1.4377,13.8978,7.66776,20.1279,7.66776z'/%3E %3Cpath d='m900.105,380.553c7.18853,0,15.8148-2.87541,23.4825-7.18853,9.5847-5.27158,16.294-2.87541,25.8787,1.91695,10.064,4.79235,18.211,3.35464,23.9618,0,2.87541-1.91695,5.27159-5.75083,11.5016-4.31312-2.87541,11.9809-7.18853,22.5241-12.4601,31.1503-9.58471,2.39618-14.8563,2.39618-24.9202-1.91694-10.0639-4.79235-22.5241-7.66776-29.2334-3.35464-6.23006,3.83388-12.9394,5.75082-18.211,5.75082-5.27159,0-11.9809-1.91694-18.2109-5.75082-6.70929-4.31312-19.1694-1.43771-29.2334,3.35464-10.0639,4.31312-15.3355,4.31312-24.9202,1.91694-5.27159-8.62623-9.58471-19.1694-12.4601-31.1503,6.23006-1.43771,8.62623,2.39617,11.5016,4.31312,5.27159,3.35464,13.8978,4.79235,23.4825,0,10.0639-4.79236,16.7732-7.18853,26.3579-1.91695,7.66777,4.31312,16.294,7.18853,23.4825,7.18853z'/%3E %3Cpath d='m900.105,457.231c19.1694-8.147,36.9011-17.2525,51.2782-29.7126-3.83389-1.43771-6.23006-0.47924-9.58471-2.87541-3.35465-2.39618-13.4186-3.35465-22.0448,1.4377-9.10547,4.31312-12.9394,5.27159-19.6486,5.27159-6.70929,0-10.5432-0.95847-19.6486-5.27159-8.62623-4.79235-18.6902-3.83388-22.0448-1.4377-3.35465,2.39617-5.75083,1.4377-9.58471,2.87541,14.3771,12.4601,31.6295,21.5656,51.2782,29.7126z'/%3E %3C/g%3E %3Cg id='lion' stroke='%23000' stroke-width='1.4377'%3E %3Cpath fill='%23f9d050' d='m887.644,256.432c0.47924,0.95847-0.47923,3.35465,0,4.31312,0.95848,1.91694,0.95848,2.87541,2.39618,3.83388h3.35465c10.5432,0,23.0033-4.31312,33.5465-4.31312,10.064,0,16.294,3.35465,22.0448,3.35465,3.35465,0,6.23006-2.39618,6.23006-4.79235,0-2.39618-3.83388-3.83389-11.9809-3.83389-11.5016,0-17.7317,2.87541-27.3164,2.87541-14.3771,0-16.7732-5.27158-16.7732-7.66776s2.39618-5.75083,10.064-5.75083c2.39617,0,4.31311-0.47923,5.27158-1.4377,0.47924-0.95847,1.91695-2.87541,4.79236-4.31312,3.35464-1.91694,10.0639,0,13.4186-2.39618,0,1.91695-2.87541,4.79236-5.27159,5.75083,4.79235-1.43771,10.0639-1.43771,11.0224,2.39617-2.39618-1.4377-6.23006-0.47923-7.66776,0-1.91695,0.47924-2.87542,0.95848-4.79236,1.43771,1.91694-0.47923,2.87541,3.35465,5.75083,3.35465-2.87542,2.39617-7.66777,2.39617-12.4601,0.47923-1.43771-0.47923-5.27159-1.91694-7.66777-1.91694-4.79235,0-7.66776,0.95847-7.66776,2.87541,0,2.39618,2.87541,3.83389,11.5016,3.83389,8.62624,0,13.4186-2.39618,26.358-2.39618-0.95847-1.43771,0.47923-2.87541-1.43771-4.31312,4.79236,0,10.064,1.43771,11.9809,4.79236-0.47924-3.35465,2.39617-6.23006,1.4377-9.10548,2.87541,0.47924,5.27159,3.35465,5.75083,5.75083,0-1.43771,1.91694-1.43771,1.91694-2.87541,2.87541,1.4377,4.31312,4.79235,3.83388,7.66776,1.43771-2.39618,2.87541-1.4377,3.83388-4.31312,0.95847,1.91694,0.47924,7.66777-2.87541,9.58471,2.87541-1.91694,7.18853-1.91694,10.0639,1.43771-2.87541-0.47924-4.31311,0.95847-5.75082,1.4377-5.75082,3.35465-15.3355,5.27159-22.5241,4.79236-7.66777-0.47924-8.62624-1.91695-13.4186-1.91695,2.87541,0.47924,8.62623,6.23006,13.8978,6.23006,3.35465,0,5.75083,0,7.18853-0.47923,1.43771-0.47924,3.83389,0,5.75083,0.95847,1.4377,1.43771,4.31312,2.87541,6.23006,2.39618-0.47924,1.91694-1.43771,2.87541-2.87541,3.35464,2.39617,1.43771,0.95847,2.39618,3.35464,4.31312-0.95847,0-1.91694,0.95847-3.35464,0.47924,1.4377,1.4377,1.4377,3.35464,2.87541,4.31312-0.47924,0-1.91694,0.47923-2.87541,0,1.4377,1.91694,0,4.31311,1.4377,5.27158,1.43771,1.91695-1.4377,4.31312-3.83388,2.39618,0.47923,1.43771-0.95847,2.87541-2.39618,2.39618-1.4377-0.47924-2.39617-1.91694-1.91694-2.39618,0-0.47923,0-0.47923,0.47924-0.95847-0.95847,1.43771-2.87542,1.43771-3.83389,0.95847-0.47923-0.47923-0.95847-0.95847-0.95847-1.4377-3.35464,0.95847-4.79235-1.91695-4.31312-3.35465,0.47924-1.43771,3.35465-1.91694,4.31312-1.43771,0.95847,0.47924,1.91694,0.95847,2.87541,0,0.95848-0.47923,1.43771-1.4377,1.43771-2.39618,0-1.4377-1.43771-5.75082-7.66776-5.27158-7.18854,0.47923-18.6902-1.43771-24.441-3.35465-0.47923-0.47924-0.95847-0.47924-1.4377-0.95847,0,1.91694-1.91695,2.87541-1.91695,4.79235,0,2.39618,0.95848,4.31312,3.83389,5.27159-1.43771,2.39618-3.83389,1.91694-4.79236,0.47924,0,1.4377-1.91694,2.39617-1.91694,4.31311-0.47923-0.95847-0.95847-1.4377-1.4377-2.39617-1.43771,3.35464-5.27159,5.27159-7.18853,4.31312-2.39618,1.91694-5.27159,1.4377-6.23006-0.47924-1.43771,0.95847-3.35465,0.95847-4.31312,0,0,1.43771-0.95847,0.95847-1.43771,2.87541,0,0.95847-1.91694,1.43771-2.87541,0.95847-0.95847-0.47923-1.43771-2.39617-0.47923-3.35464-1.43771,0.95847-2.87542,0.95847-3.83389,0,0-0.95848,0-2.39618,0.95847-2.87542h0.95847c-0.95847-0.47923-2.39617,0-3.35464-0.47923-0.95847-0.95847-0.95847-1.91694-0.47924-2.87541,0.47924-0.47924,1.91694-1.43771,2.87541-0.47924l0.47924,0.47924c0-0.95848,0.47923-1.91695,0.95847-1.91695,0.95847-0.47923,2.39618-0.47923,3.83388,0.95847,0.95847,1.43771,1.91694,1.43771,4.79236,0.95848,2.39617,0,6.23006-2.39618,9.10547-4.79236-8.147-1.4377-3.35465-6.70929-0.95847-8.62623-1.91694-0.47924-4.79236-0.47924-6.7093,0.47923-10.0639,5.27159-20.6071,11.5016-27.3164,9.58471,0,0.95847,0.47923,1.91694,0.95847,2.87541-1.43771,0-4.31312,0-5.27159-1.43771-0.47924,0.95847-1.43771,3.35465-0.47924,5.27159-0.95847-0.95847-3.83388-1.91694-5.27159-2.39617,0.95847,0.95847,0,2.87541,0.47924,4.31311-1.43771-1.4377-3.83388-2.39617-4.79235-1.4377s-2.87542,1.4377-4.31312,0.95847c-0.95847,1.43771-2.39618,2.39618-3.83388,2.87541,0-0.95847,0-2.39618-0.47924-2.87541-0.47924,1.43771-1.91694,3.35465-3.83388,4.31312,0-0.95847,0-2.39618-0.47924-3.35465,0,1.91694-3.83388,2.87541-4.31312,4.31312,0.47924-1.43771,0.47924-2.87541,0.47924-3.83388-0.95847,1.4377-2.39618,2.87541-4.79235,3.35464,0.47923-0.95847,0.95847-1.91694,0.47923-2.87541-0.47923,1.91694-3.35465,2.87541-5.75082,2.39618,0,0.95847-1.91694,2.39617-4.31312,0.95847-1.43771-0.47924-2.39618-1.91694-1.43771-2.87541-1.91694,0-3.83388-1.91695-2.87541-3.35465,0-0.47924,0.47924-0.95847,0.47924-1.43771-1.43771-0.95847-1.91695-2.87541-0.47924-4.31312,0.47924-0.47923,1.91694-0.47923,2.87541-0.47923,0-3.83388,3.35465-3.83388,4.79236-0.95847,0.95847,1.4377,3.83388,3.83388,6.23006,3.35465,0.95847,0,1.4377-0.47924,2.39617-0.47924,2.87541-0.95847,8.62624-3.35465,11.9809-6.23006,0.47923-1.43771,0.47923-2.39618,0.47923-3.35465-1.91694,0.95847-3.83388,1.91694-4.79235,3.35465v-1.43771c-1.43771,0-3.83389-0.47923-4.79236-0.47923,0.47924-0.47924,0.95847-2.87541,1.91695-3.35465-2.39618,0.47924-4.79236,0-6.7093-0.47923,0.95847-0.95847,0.95847-2.39618,1.43771-3.83389-0.95847,0.47924-3.35465-0.47923-5.27159,0,0.47923-1.4377,0.95847-3.35464,2.39617-3.83388-1.91694,0.47924-4.31311,0-6.70929-0.95847,1.91694,0,2.87541-2.39618,4.31312-2.39618-3.83388,0-4.79236-1.91694-6.7093-2.87541,1.43771,0.47924,2.39618-0.95847,3.83389-0.95847-1.43771-0.47923-3.83389-2.87541-2.87542-4.31312-0.47923,0.47924-0.95847,1.43771-1.91694,1.91694-0.95847,0.47924-2.87541,0-4.31312-1.4377-0.95847-1.91694-0.47923-4.31312,1.43771-4.79236-2.39618-0.47923-2.39618-2.87541-1.43771-3.83388,0.47924-0.95847,2.39618-2.39618,3.35465-0.95847,0.47924,0.47924,0.95847,1.43771,1.43771,1.91694-0.47924-0.95847-0.47924-2.87541-0.47924-4.31312,0.47924-1.4377,1.43771-1.4377,2.87541-1.91694,1.43771,0,2.39618,1.43771,2.39618,2.87541,0,1.43771,0.47924,2.39618,0.95847,4.31312,0-0.47923,0.47924-1.4377,0.47924-1.91694,0-1.91694,2.39617-1.4377,3.83388-0.95847,1.43771,0.47924,1.91694,3.35465,0,4.79235-0.95847,0.95847-0.47924,2.39618,0.47924,3.35465,3.35464,5.27159,9.10547,9.58471,13.8978,10.0639,0-1.91694,0.95847-3.83388,2.39618-5.27158,0-0.95848,0.47923-2.39618,0.95847-3.35465,0.47923-2.87541,1.91694-4.31312,3.83388-3.35465-0.47923-0.47924-0.95847-0.95847-0.95847-1.43771-1.43771-1.4377-2.87541-3.83388-1.91694-5.75082s3.83388-1.43771,4.79235-0.47924c-0.47923-2.87541,2.87541-5.27158,2.87541-6.70929,0.47924,1.43771,1.43771,3.35465,0.95847,4.79235,0.47924-1.91694,3.83389-4.31311,6.23006-5.27159-0.95847,1.43771,1.91695,3.83389,1.43771,5.27159,0.95847-2.39617,4.79235-3.83388,7.66777-3.83388-0.95847,0.95847-0.95847,2.87541-0.95847,3.83388,1.4377,0,3.83388-0.47923,4.79235-1.91694,0,1.91694-0.95847,3.83388-1.91694,4.79236,0.47923-0.47924,2.39617-0.47924,3.83388-0.47924-1.43771,1.43771-0.95847,2.87541-2.39618,3.83388,1.91695-0.95847,4.31312-0.95847,4.79236,0.95847,0.95847,1.43771-0.47924,3.83389-1.43771,5.27159-0.95847,0.47924-1.91694,1.43771-2.39618,1.43771z'/%3E %3Cg fill='none'%3E %3Cpath d='m857.932,262.182c-3.35464,1.43771-4.31312,4.79236-4.79235,6.7093'/%3E %3Cpath d='m857.453,265.537c-4.79236,2.87541-6.7093,5.27159-5.75083,10.5432'/%3E %3Cpath d='m859.849,279.914c2.87542-0.95847,4.79236-1.91694,7.18853-6.23006'/%3E %3Cpath d='m865.6,275.601c-0.95847,1.91694,0,5.27159-1.43771,6.7093,2.39618-1.43771,4.31312-3.35465,4.79236-6.7093'/%3E %3Cpath d='m866.558,280.872c1.91694-0.95847,4.79235-3.83388,6.23006-7.18853-0.47924,1.43771,0,3.83388-0.95847,5.27159,2.39617-2.39618,3.35465-3.83388,3.83388-6.23006,0,0.47924,0.47924,1.43771,0.47924,1.91694,0.95847-0.95847,1.91694-1.91694,1.91694-3.83388'/%3E %3Cpath d='m878.06,272.246v2.39617c1.91694-1.4377,2.39617-3.35465,2.39617-5.75082'/%3E %3Cpath d='m879.977,271.767c2.87541-1.91694,3.35465-4.79235,3.35465-9.10547'/%3E %3Cpath d='m883.331,267.454c1.91694-1.4377,2.39617-2.39618,2.39617-6.70929'/%3E %3Cpath d='m879.497,247.805c-0.95847,0-1.91694,0.47924-1.91694,1.91694,0,0.95847-1.4377,2.39618-1.4377,3.83389-0.47924,1.91694-1.43771,2.39617-2.87542,1.91694-1.4377-0.95847-1.4377-0.95847-1.4377-2.39618,0-1.91694,2.39617-2.39618,2.39617-4.31312,0.47924-0.95847,0.95848-2.39617,1.43771-2.39617-2.39618,1.4377-5.75082,0.47923-6.23006-2.39618'/%3E %3Cpath d='m883.811,249.243c-0.95847,0.47923-1.91694-0.95847-3.35465-0.47924-0.47923,0-1.91694,0.47924-2.39617,0'/%3E %3Cpath d='m877.101,251.639c0.47923,0.47924,2.87541,1.43771,5.27159,0.47924-1.91695,0.47924-3.35465-1.91694-1.43771-3.35465'/%3E %3Cpath d='m872.788,246.847c-1.91694,0-3.35465,1.43771-2.87541,2.87541,0.47923,1.43771,2.39617,1.43771,3.83388,0.47924'/%3E %3Cpath d='m869.433,270.809c0.47924-0.47924,0.95847-1.43771,0.95847-1.91694,0.95847,0,1.91694-0.47924,2.39618-0.95847,1.91694,0,3.35465-1.43771,3.83388-2.87542,0.95847,0,1.43771-2.39617,1.91694-3.35464,0.47924,0.47923,1.43771,0,1.91694-1.91694,0.95847,0.47923,2.39618,0,2.87542-1.43771'/%3E %3Cpath d='m863.683,254.994c0,0.47924-0.95847,1.43771-1.91694,1.91694,0.47923,0.95847,0,3.35465-0.95848,3.83389,0.47924,0.95847,0,2.39617-0.47923,3.35464,0,0.47924,0.47923,1.91695,0.47923,2.39618'/%3E %3Cpath d='m865.6,245.409c-0.95847,2.39617-0.47924,5.27158,1.4377,5.75082'/%3E %3Cpath d='m866.558,253.077c-0.47924,2.39618-0.47924,5.75083-0.95847,7.18853-0.47924,0.95847-1.43771,4.31312,2.39617,5.27159,4.31312,0.95847,6.7093,0.47924,9.10548-6.70929'/%3E %3Cpath d='m884.29,277.518c0,0.47924-0.47924,1.43771-1.43771,1.43771'/%3E %3Cpath d='m887.644,276.559c0,0.95847-0.95847,2.39618-1.4377,2.87542'/%3E %3Cpath d='m890.999,275.601c0,0.95847,0,2.39618-0.95847,2.87541'/%3E %3Cpath d='m861.766,245.888c0.47923,0,0.95847,0.95847,1.4377,1.91694-1.4377-0.95847-2.87541,1.43771-1.91694,2.87541'/%3E %3Cpath d='m860.328,254.035c-0.47924,0.47924-1.43771,0.95847-1.91694,1.43771'/%3E %3Cpath d='m858.89,258.348c-0.47923,0-0.95847,0.47924-1.4377,0.47924'/%3E %3Cpath d='m835.887,249.722c0-0.47923,0-0.47923,0.47923-0.95847'/%3E %3Cpath d='m831.574,248.284c-0.47924,0-0.47924,0-0.95847-0.47924'/%3E %3Cpath d='m832.053,254.994h0.95847'/%3E %3Cpath d='m830.136,252.118c-0.95847-0.95847-2.39617-1.43771-2.87541-1.43771'/%3E %3Cpath d='m856.494,269.85c-3.35465,2.87541-4.79236,5.27159-5.27159,8.62623'/%3E %3Cpath d='m859.849,272.246c-0.95847,1.91694-2.39617,3.35464-3.83388,4.31311'/%3E %3Cpath d='m841.159,286.623c-3.83389,0.95847-6.7093,0.47923-9.58471-1.43771-0.47924-0.47924-0.95847-0.47924-1.43771-0.95847'/%3E %3Cpath d='m855.536,279.914c-0.47924,1.91694-0.95847,4.31312-1.91695,4.79235,3.83389-1.91694,7.18853-4.79235,7.66777-9.10547'/%3E %3Cpath d='m827.74,289.02c1.4377-0.47923,2.87541,0.47924,3.83388-0.47923'/%3E %3Cpath d='m911.127,273.205c0.95847,0.47923,2.39617,0.95847,2.87541,1.4377,0.47923-0.95847,2.39618-2.39617,3.83388-2.87541'/%3E %3Cpath d='m877.101,283.269c-0.47924-1.91694,0.47923-4.31312,3.35464-5.27159'/%3E %3Cpath d='m858.411,291.416c0.47923-0.95847,0.47923-2.39618,0.95847-3.35465'/%3E %3Cpath d='m837.325,292.853c-0.47923,0.95847-1.4377,1.91694-1.4377,2.87541'/%3E %3Cpath d='m830.136,293.812s0-0.47924,0.47924-0.47924c0.95847-0.47923,2.39617-1.43771,2.87541-2.39618'/%3E %3Cpath d='m895.312,287.103c-0.95847,0.47924-1.43771,0-1.91694-0.47923'/%3E %3Cpath d='m894.833,289.499s-0.47923,0.47923-0.95847,0.47923'/%3E %3Cpath d='m897.229,291.895c-0.47923,0.47924-0.95847,0.95848-1.4377,0.95848'/%3E %3Cpath d='m911.127,292.853c0.95847-0.47924,1.4377-1.43771,1.91694-3.35465'/%3E %3Cpath d='m904.897,292.374c1.4377-0.47924,2.39617-1.43771,3.83388-2.87541'/%3E %3Cpath d='m918.315,288.54c0-0.95847,0-1.91694,0.47923-2.87542'/%3E %3Cpath d='m953.779,292.853c-0.95847-0.95848-0.95847-2.39618,0.47924-3.35465,0.95847-0.47924,1.4377-0.95847,2.39617-1.43771'/%3E %3Cpath d='m924.546,276.08c-7.66777-3.35465-7.18853-7.66777-13.4186-7.18853'/%3E %3Cpath d='m958.571,290.936c0.47923,0.47924,0,1.91695,0,2.39618'/%3E %3Cpath d='m962.884,290.936c-0.47923,1.43771-0.47923,1.91695-0.47923,3.35465'/%3E %3Cpath d='m925.983,245.888h-3.83388'/%3E %3Cpath d='m885.727,262.182c0,0.95847,1.43771,2.87541,5.27159,2.87541-0.47923,0-0.95847-0.47923-0.95847-0.47923'/%3E %3Cpath d='m887.644,256.432c-0.47923,0.47923-0.95847,0-0.95847,0-0.95847-0.95847,0.47924-2.87541,1.91695-3.83388-1.43771,0.47923-2.39618,0.47923-3.35465,0.47923-0.95847,2.87541-3.83389,4.31312-5.75083,2.39618-0.47923,1.91694-2.87541,4.31312-4.79235,3.83388-1.91694-0.95847-2.39618-2.39618-1.91694-3.83388-2.39618,2.87541-5.27159,0.95847-6.23006,0-0.47924-0.95847,0-3.35465,0.95847-6.23006'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m918.315,274.642c-1.43771,0.95847-2.87542,0-4.31312,1.43771-0.95847,0.95847,0.47923,1.4377,1.4377,1.4377-0.47923,1.43771-0.47923,1.91695,1.91695,1.91695-0.95847,1.4377,1.91694,1.91694,1.4377,3.83388,1.43771-1.43771,1.43771-3.35465,0.95847-4.79236-0.47923-1.4377-2.87541-2.39617-1.4377-3.83388z'/%3E %3Cg fill='%23073163' stroke='none'%3E %3Cpath d='m874.705,259.307c-1.91694-0.95847-2.39618-2.39618-1.91694-3.83388-0.47924,0.95847-1.43771,1.4377-2.39618,1.4377-1.91694,4.31312-4.31312,8.147-7.18853,8.147-3.35465,0.47924-2.87541,3.83389-0.47923,3.83389,5.27158,0.95847,7.66776-0.95847,11.9809-9.58471z'/%3E %3Cpath d='m827.261,247.805c1.43771-1.4377,0.47924-2.87541-0.47924-3.35465-1.4377-0.47923-4.31311,0-5.75082,2.39618,1.43771-0.47923,2.87541-0.47923,3.35465,0.47924,0.47923,0.95847,1.4377,1.91694,2.87541,0.47923z'/%3E %3Cpath d='m829.657,239.179c3.35464,0,4.31312,0.47923,4.79235,1.91694,0.47924,0.95847-0.47923,2.39617-1.43771,2.39617-1.4377,0-2.87541-0.95847-2.39617-1.4377,0.47923-0.95847,0.47923-2.39618-0.95847-2.87541z'/%3E %3Cpath d='m839.242,246.847c2.39618,0.47924,3.35465-0.95847,1.91695-2.87541-0.47924-1.43771-1.91695-2.39618-4.31312-1.91694,2.39617,1.4377,0,3.83388,2.39617,4.79235z'/%3E %3Cpath d='m821.51,254.994c1.4377,2.39618,3.83388,2.39618,4.79235,1.91694,1.43771-0.47923,1.91694-1.91694,1.43771-2.87541-0.95848-1.4377-2.39618-1.91694-2.87542,0-0.95847,1.91694-2.39617,1.43771-3.35464,0.95847z'/%3E %3Cpath d='m828.698,284.227c-0.95847-1.91694-3.83389-1.91694-6.23006,0,0.95847-0.47924,2.87541,0,3.35464,0.95847,0.47924,0.95847,1.43771,0.95847,1.91695,0.95847,0.47923-0.47924,1.4377-0.95847,0.95847-1.91694z'/%3E %3Cpath d='m832.532,281.352c0-2.39618-3.35465-2.87542-5.27159-1.91694,0.95847,0,2.39618,0.95847,2.39618,1.91694,0.47923,0.95847,1.4377,1.4377,1.91694,1.4377,0.95847-0.47923,1.4377-0.95847,0.95847-1.4377z'/%3E %3Cpath d='m827.74,289.978c-2.87542-0.47923-4.31312,2.87542-4.31312,5.27159,0.47923-1.4377,1.91694-2.39617,3.35464-1.91694,1.43771,0,1.91695-0.47923,1.91695-1.43771,0.47923-0.95847,0-1.4377-0.95847-1.91694z'/%3E %3Cpath d='m828.219,298.125c0.95847,0.47924,1.91694-0.47923,2.39618-1.91694,0-0.95847,1.91694-0.95847,2.39617-0.47923,0.95848,0.47923,0.95848,2.39617-0.47923,3.35464-0.95847,0.47924-3.35465,0.95848-4.31312-0.95847z'/%3E %3Cpath d='m894.833,283.748c-0.95847-0.47923-3.35464-1.4377-5.27158,0,1.4377-0.47923,2.39617,0.47924,2.87541,1.43771,0,0.95847,1.4377,1.43771,1.91694,0.47923,0.47923-0.47923,0.95847-1.4377,0.47923-1.91694z'/%3E %3Cpath d='m890.52,287.103c-1.91694-0.95847-4.31312,1.43771-4.79236,3.35465,0.47924-0.47924,2.39618-1.43771,3.35465-1.43771,0.95847,0.47924,1.91694,0,1.91694-0.95847,0.47924-0.47923,0.47924-0.95847-0.47923-0.95847z'/%3E %3Cpath d='m892.916,290.936c-1.4377,0-3.35464,1.91695-3.35464,3.83389,0.47923-0.95847,1.4377-1.43771,2.39617-0.95847,0.95847,0,2.39618-0.47924,2.39618-1.43771s-0.47924-1.43771-1.43771-1.43771z'/%3E %3Cpath d='m897.229,294.77c-0.95847-0.47924-2.39618,0-2.39618,1.4377,0,1.43771,0,2.87541-0.47923,3.35465,0.95847-0.95847,1.91694-1.43771,2.87541-1.91694,0.47924-0.47924,0.95847-1.91694,0-2.87541z'/%3E %3Cpath d='m951.383,290.457c-0.95847-0.95847-2.39618-0.47924-2.87542,0.47923-0.47923,0.95847-0.95847,3.35465,0,5.27159,0-0.95847,0.95847-2.39617,1.91695-2.39617,1.4377-0.47924,1.91694-2.39618,0.95847-3.35465z'/%3E %3Cpath d='m954.258,292.374c-1.91694,0.95847-1.91694,4.31312-0.47924,6.23006,0-0.95847,0.47924-2.39618,1.43771-2.87541,1.4377,0,1.91694-1.91694,1.4377-2.87541-0.95847-0.95848-1.91694-0.47924-2.39617-0.47924z'/%3E %3Cpath d='m960.009,294.291c-0.95847-0.47923-1.91694,0.47924-1.91694,1.43771-0.47923,1.4377,0.47924,3.35464,1.91694,4.31312,0-0.95848,0.47924-1.91695,0.95847-2.39618,1.43771-0.95847,0.95847-2.87541-0.95847-3.35465z'/%3E %3Cpath d='m964.322,293.812c-0.95847,0-1.91694,1.4377-0.95847,2.87541,0.47923,0.95847,1.43771,1.4377,3.35465,0.95847-0.47924,0-1.43771-1.43771-0.95847-1.91694,0.47923-0.95847,0-1.91694-1.43771-1.91694z'/%3E %3C/g%3E %3C/g%3E %3Cg id='star'%3E %3Cpath fill='%23f9d050' d='m831.095,383.429,23.9618-73.8022,23.9618,73.8022-62.7798-45.5274,77.6361,0z'/%3E %3Cpath fill='%23024919' d='m835.887,376.72,49.8405-36.4219-61.3421,0,49.3612,36.4219-18.6902-58.4667z'/%3E %3C/g%3E %3Cuse xlink:href='%23star' x='90.09665'/%3E %3Cuse xlink:href='%23star' x='45.04765' y='52.23713'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.4377' d='m989.722,232.949v93.4509c0,80.9908-38.3388,108.786-89.617,130.831-51.2781-22.0448-90.0962-49.8405-90.0962-130.831v-93.4509h179.713z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 12 6'%3E %3Crect width='12' height='2' fill='%23007a3d'/%3E %3Crect width='12' height='2' y='2' fill='%23fff'/%3E %3Crect width='12' height='2' y='4' fill='%23ce1126'/%3E %3Cpolygon points='0,0 3,2 3,4 0,6'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='-36 -24 72 48'%3E %3Ctitle%3EFlag of South Korea%3C/title%3E %3Crect fill='%23fff' x='-36' y='-24' width='72' height='48'/%3E %3Cg transform='rotate(-56.3099325)'%3E%3C!--arctan(-3/2)--%3E %3Cg id='b2'%3E%3Cpath id='b' d='M-6-25H6M-6-22H6M-6-19H6' stroke='%23000' stroke-width='2'/%3E %3Cuse xlink:href='%23b' y='44'/%3E%3C/g%3E %3Cpath stroke='%23fff' stroke-width='1' d='M0,17v10'/%3E %3Ccircle fill='%23c60c30' r='12'/%3E %3Cpath fill='%23003478' d='M0-12A6,6 0 0 0 0,0A6,6 0 0 1 0,12A12,12 0 0,1 0-12Z'/%3E%3C/g%3E %3Cg transform='rotate(-123.6900675)'%3E%3Cuse xlink:href='%23b2'/%3E %3Cpath stroke='%23fff' stroke-width='1' d='M0-23.5v3M0,17v3.5M0,23.5v3'/%3E%3C/g%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1600' height='800' viewBox='0 0 72 36'%3E %3Crect fill='%23024FA2' width='72' height='36'/%3E %3Crect fill='%23fff' y='6' width='72' height='24'/%3E %3Crect fill='%23ED1C27' y='7' width='72' height='22'/%3E %3Ccircle fill='%23fff' cx='24' cy='18' r='8'/%3E %3Cg id='star' transform='translate(24,18) scale(7.75)' fill='%23ED1C27'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E%3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use12'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Cdefs%3E %3C/defs%3E %3Cpath d='M750,0H0V500' fill='%23009e49'/%3E %3Cpath d='M0,500H750V0' fill='%23ce1126'/%3E %3Cpath d='M0,500 750,0' stroke='%23fcd116' stroke-width='210'/%3E %3Cpath d='M0,500 750,0' stroke='%23000' stroke-width='150'/%3E %3C!-- Rotation angle should be -arctan(2/3) --%3E %3Cg id='star' transform='translate(517.5,155) rotate(-33.69)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-70V0H35' transform='rotate(18,0,-70)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='translate(-285,190)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='600' viewBox='0 0 500 300'%3E %3Crect fill='%233A75C4' width='500' height='300'/%3E %3Crect fill='%23CE1126' width='500' height='225'/%3E %3Crect fill='%23FFF' width='500' height='150'/%3E %3Crect fill='%23FFC61E' width='500' height='75'/%3E %3Cpath fill='%233D8E33' d='M0,300l250-150L0,0V300z'/%3E %3Ccircle fill='%23FFF' cx='85' cy='150' r='67.5'/%3E %3Ccircle fill='%233D8E33' cx='115' cy='150' r='67.5'/%3E %3Cpath id='star' fill='%23FFF' d='M100.0104,89.1996l7.3594,22.5883L88.1125,97.8394h23.775l-19.2573,13.9486L100.0104,89.1996z'/%3E %3Cuse xlink:href='%23star' y='32.2083'/%3E %3Cuse xlink:href='%23star' y='64.4166'/%3E %3Cuse xlink:href='%23star' y='96.625'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300'%3E %3Crect width='600' height='300' fill='%23ce1126'/%3E %3Cg fill='%23fcd116' stroke='%23bd9c08' stroke-width='1.2'%3E %3Cpath stroke-width='1.5' d='M349.39,141.29c8.76,2.35,22.01,1.76,27.96,8.71-8.75-2.35-19.55,11.81-27.96,8.71,7.43,5.2-108.04,0-98.78,0-8.76-2.35-22.01-1.76-27.96-8.71,8.75,2.35,19.55-11.81,27.96-8.71-7.43-5.2-20.31-9.23-23.3-17.75,7.43,5.2,22.54-4.44,29.26,1.38-5.2-7.42-16.07-15.57-15.83-24.64,5.2,7.43,22.71,3.45,27.02,11.3-2.34-8.76-9.41-20.05-6.44-28.57,2.35,8.758,19.98,10.933,21.53,19.86,0.79-9.031-2.4-22.103,3.72-29.049-0.79,9.033,15.13,17.097,13.43,26.026,3.83-8.217,5.95-21.492,13.43-26.026-3.83,8.218,8.67,21.199,3.72,29.049,6.41-6.409,12.6-18.286,21.53-19.86-6.41,6.411,0.42,22.74-6.44,28.57,8.21-3.83,17.91-12.877,27.02-11.3-8.22,3.83-7.41,21.54-15.83,24.64,9.04-0.79,21.17-5.91,29.26-1.38-9.03,0.79-14.04,17.75-23.3,17.75z'/%3E %3Cpath stroke-width='1.5' stroke-linejoin='round' d='M258.36,150l-31.59-12.91,34.1-1.33-25.27-22.94,32.5,10.42-15.9-30.198,26.98,20.898-4.61-33.809,18.2,28.869,7.23-33.353,7.23,33.353,18.2-28.869-4.61,33.809,26.97-20.898-15.89,30.198,32.49-10.42-25.26,22.94,34.09,1.33-31.58,12.91,31.58,12.91h-146.45l31.59-12.91z'/%3E %3Ccircle stroke-width='1.8' cx='300' cy='150' r='41.358'/%3E %3Cpath d='M313.6,49.862l22.18,0.147c0.14-0.938-1.9-2.805-3.65-3.078-5.61-0.882-9.82,0.936-16.64,1.006l-1.89,1.925z'/%3E %3Cpath d='M269.43,44.643c5.21,6.58,15.31,11.153,24.95,11.213,13,0.08,27.42-10.441,44.85-13.662l-56.91-1.172c-7.37-5.045-12.96-4.405-16.77-1.277l-10.88,0.329c-1.54,0.839,1.27,4.343,3.55,4.471l11.21,0.098z'/%3E %3Cpath d='M295.16,40.868c-2.07-9.518-9.71-13.62-18.89-14.837-10.61-1.406-35.02-2.847-51.24-7.505,7.02,6.901,21.71,10.346,31.92,11.904,10.81,1.65,21.33,4.054,29.67,10.351l8.54,0.087z'/%3E %3Cpath stroke-linecap='round' d='M288.27,47.221c3.39,4.354,8.65,4.108,14.31,0.309,5.64-3.786,11.77-14.447,14.73-14.622,20.69-1.202,45.72-9.936,57.66-16.681-15.14,2.143-30.14,4.573-45.41,4.633-26.05,0.104-29.13,11.968-39.75,20.286'/%3E %3Cpath fill='none' stroke-linecap='round' d='M292.31,42.103c5.55-3.536,10.06-8.151,15.26-12.006,8.61-6.382,18.55-6.569,29.23-6.701,9.46-0.116,26.04-4.069,35.04-6.178'/%3E %3Cpath fill='none' d='M286.53,40.436c-1.63-8.511-9.6-11.065-19.66-12.594-10.95-1.663-22.12-2.589-33.04-5.607-2.71-0.748-5.23-2.07-7.85-3.105'/%3E %3Cpath fill='none' stroke-linecap='round' d='M290.02,52.983c10.28,0.754,17.91-2.336,26.68-6.706'/%3E %3Cpath fill='none' stroke-linecap='round' d='M254.63,41.831h12.96'/%3E %3Ccircle fill='%23bd9c08' stroke='none' cx='271.75' cy='40.437' r='1.62'/%3E %3C/g%3E %3Crect fill='%23003f87' width='600' height='135' y='165'/%3E %3Cpath id='w' fill='%23fff' d='M0,257.14c20,0,40,12.86,60,12.86s40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86,40,12.86,60,12.86,40-12.86,60-12.86v-21.43c-20,0-40,12.86-60,12.86s-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86-40,12.86-60,12.86-40-12.86-60-12.86v21.43z'/%3E %3Cuse xlink:href='%23w' y='-42.8571'/%3E %3Cuse xlink:href='%23w' y='-85.7142'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='625' height='400'%3E %3Crect width='625' height='400' fill='%23032ea1'/%3E %3Crect width='625' height='200' y='100' fill='%23e00025'/%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.96' transform='translate(117.14286,-434.9336)'%3E %3Cg stroke-linejoin='bevel'%3E %3Cpath d='m139.02,623.46,113.8,0,0,43.788-113.8,0z'/%3E %3Crect width='3.5864' height='16.495' x='246.95' y='647.64'/%3E %3Crect width='113.8' height='5.0903' x='139.02' y='639.49'/%3E %3Crect width='113.8' height='4.489' x='139.02' y='632.59'/%3E %3Crect stroke-width='0.94545' width='113.8' height='4.354' x='139.02' y='625.7'/%3E %3Crect width='3.5864' height='16.495' x='168.98' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='217.97' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='139.92' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='146.95' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='154.45' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='161.95' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='224.77' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='232.27' y='647.64'/%3E %3Crect width='3.5864' height='16.495' x='239.77' y='647.64'/%3E %3Cpath stroke-linejoin='miter' d='m94.509,669.55c1.7604-0.89672,3.7684-2.9836,4.425-5.319h193.07c0.65665,2.3354,2.6647,4.4222,4.425,5.319z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath d='m193,556.8s-0.14437-4.1125,2.2507-4.1572c2.3951,0.0447,2.2507,4.1572,2.2507,4.1572z'/%3E %3Cpath d='m180.51,611.34,0-5.5357c-0.0789-2.768-2.7591-2.9681-2.838-4.9862,0,0-0.34606-3.0266,0.45159-4.4082,1.0845,4.0474,3.0561,3.3039,3.0561,1.6397,0-1.4526-1.117-2.8031-3.408-6.3302-0.73206-1.127-0.27901-4.6597,0.74692-5.9224,0.39808,3.0709,0.85311,4.5398,2.1717,4.5398,0.80428,0,1.4612-0.52417,1.4612-2.0621,0-1.9565-1.325-2.9445-1.9762-4.725-0.76004-2.0777-0.23675-4.1957,1.0259-5.3795,0.54129,3.0293,0.38028,4.2372,1.7255,4.2372,2.7133-0.8584,0.00063-4.7866-0.57911-5.7773-0.667-1.1553,0.89682-3.4598,0.89682-3.4598,0.86209,2.6898,1.1394,2.909,2.0699,2.6597,1.1738-0.31452,1.0224-2.056-0.40996-3.4633-0.90449-0.88866-0.80857-2.2116,0.16248-3.274,0.97489,1.9056,2.2229,1.7898,2.343,0.65821l-0.78373-4.3931h17.255l-0.85683,4.2488c-0.24526,1.2162,1.396,1.4801,2.4162-0.51392,0.97105,1.0624,1.067,2.3854,0.16248,3.274-1.4323,1.4073-1.5837,3.1488-0.40996,3.4633,0.93041,0.2493,1.2078,0.0302,2.0699-2.6597,0,0,1.403,1.5708,0.89682,3.4598-0.57974,0.99071-3.2924,4.9189-0.57911,5.7773,1.3453,0,1.1842-1.2079,1.7255-4.2372,1.2627,1.1838,1.786,3.3017,1.0259,5.3795-0.65127,1.7804-1.9762,2.7685-1.9762,4.725,0,1.538,0.65688,2.0621,1.4612,2.0621,1.3186,0,1.7736-1.4689,2.1717-4.5398,1.0259,1.2627,1.479,4.7953,0.74692,5.9224-2.291,3.527-3.408,4.8776-3.408,6.3302,0,1.6641,1.9716,2.4076,3.0561-1.6397,0.79765,1.3816,0.4516,4.4082,0.4516,4.4082-0.0789,2.018-2.7591,2.2182-2.838,4.9862v5.5357z'/%3E %3Cpath d='m187.73,565.32-0.39721-3.125,15.838,0-0.39721,3.125z'/%3E %3Cpath d='m188.79,562.13-0.34117-2.5686,13.604,0-0.34117,2.5686z'/%3E %3Cpath d='m190.95,559.47-0.22717-2.5686,9.0585,0-0.22718,2.5686z'/%3E %3Cpath d='m223.97,669.55c-2.0266-0.78125-4.9773-2.9188-4.9773-5.0695v-24.297l2.6385-3.3588-52.776,0.00008,2.5293,3.3588v24.297c0,2.1508-2.0264,4.2883-4.0529,5.0695z'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='178.24' y='647.64'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='208.56' y='647.64'/%3E %3Cpath d='m167.91,609.17,0,14.648,0,7.0117,0,5.9961,54.023,0,0-5.957,0.0783-21.699c-2.2097,0.8681-2.5976,2.8711-2.5976,2.8711v11.777h-48.75v-11.777s-0.5442-2.003-2.7539-2.8711z'/%3E %3Cpath d='m214.6,669.55c-1.7655-0.78125-5.6118-2.9188-5.6118-5.0695v-27.192c0.37751-1.518,2.436-2.414,3.761-3.3588h-35.823c1.7049,0.90271,3.6054,1.6522,4.2846,3.3588v27.192c0,2.1508-3.041,4.2883-4.8065,5.0695z'/%3E %3Cpath d='m219.41,634.22-0.00027-19.587-4.9104-0.00008,0-1.9085-38.839,0,0,1.9085-4.9109-0.00018,0.00017,19.587z'/%3E %3Cpath d='m206.86,669.55c-1.7299-0.78125-4.2489-2.9186-4.2489-5.0694v-23.215l1.4205-2.1088h-17.691l1.4205,2.109v23.215c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath stroke-width='0.981' d='m190.71,639.16,8.9655-0.00005,0,30.377-8.9655,0z'/%3E %3Cpath stroke-linejoin='bevel' d='m204.38,632.48c0.0215-2.0012,5.8375-2.091,8.8318-3.7949h-35.952c2.9943,1.7039,8.6755,1.8441,8.6755,3.7949l1.2166,3.8818,14.883,0.59776z'/%3E %3Cpath d='m211.41,611.34c0-4.8986,0.20532-6.7857,1.7103-6.7857l0.00001,15.58c-3.6912,1.3393-6.3254,6.0491-6.3254,6.0491l-23.211-0.00027s-2.6342-4.7096-6.3254-6.0488v-15.58c1.856,0,1.8682,1.9717,1.8682,6.7857z'/%3E %3Cpath d='m213.12,609.33c0-5.6184,4.8512-6.2503,4.8512-6.2503v5c-1.8465-0.0789-2.7368,1.578-2.7368,4.0444,0,2.4663,1.4868,2.5056,1.4868,2.5056v14.19h-3.6012z'/%3E %3Cpath d='m177.28,609.33c0-5.6184-4.8512-6.2503-4.8512-6.2503v5c1.8465-0.0789,2.7368,1.578,2.7368,4.0444,0,2.4663-1.4868,2.5056-1.4868,2.5056v14.19h3.6012z'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.8'%3E %3Cpath d='m186.84,570.62h17.128'/%3E %3Cpath d='m184.81,575.97h20.921'/%3E %3Cpath d='m182.78,582.46h24.904'/%3E %3Cpath d='m180.66,590.39h29.536'/%3E %3Cpath d='m179.98,599.43h30.426'/%3E %3Cpath stroke-width='0.96' d='m170.75,628.92h48.661'/%3E %3Crect stroke-width='0.96' width='18.036' height='6.6291' x='186.19' y='628.93'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m183.93,614.24c2.9903,3.59,2.7128,9.6801,2.6786,13.27h17.343c-0.0342-3.59-0.31172-9.68,2.6786-13.27z'/%3E %3Cpath d='m193.68,573.11-2.3764-1.2239,0-3.4974c0.97149,0.29214,2.062,0.41142,2.1686,1.9595,0.33824-2.2099,0.94822-2.1018,1.9064-2.963,0.95814,0.86127,1.5681,0.75315,1.9064,2.963,0.10661-1.5481,1.1971-1.6674,2.1686-1.9595v3.4974l-2.3764,1.2239z'/%3E %3Cpath d='m193.52,578.85-3.9464-2.7128,0-3.2231c1.3836,0.32035,2.9366,0.45115,3.0885,2.1488,0.48172-2.4232,1.3504-3.6754,2.715-4.6198,1.3646,0.94444,2.2332,2.1966,2.715,4.6198,0.15183-1.6976,1.7049-1.8284,3.0885-2.1488v3.2231l-3.9464,2.7128z'/%3E %3Cpath d='m193.24,587.8-4.5378-3.9854,0-4.7351c1.5909,0.47062,3.3767,0.66279,3.5513,3.1567,0.55391-3.56,1.5528-5.3995,3.1218-6.787,1.569,1.3875,2.5679,3.227,3.1218,6.787,0.17458-2.4939,1.9604-2.6861,3.5513-3.1567v4.7351l-4.5378,3.9854z'/%3E %3Cpath d='m201.61,593.09-4.1037,5.6759-4.6463,0-4.1037-5.6759z'/%3E %3Cpath d='m186.39,602.62c2.0526,1.1219,2.8106,3.3568,3.0299,7.5527h11.55c0.21927-4.1959,0.97728-6.4308,3.0298-7.5527z'/%3E %3Cpath stroke-linejoin='bevel' d='m204.17,593.09,0-5.7018c-1.9498,0.53675-3.2129,1.6912-3.7755,3.2577,0-1.8927-2.4906-6.2573-5.2071-8.4294-2.7242,2.4314-5.2575,6.3801-5.2066,8.4294-0.46332-1.4918-1.8258-2.7209-3.7755-3.2577v5.702z'/%3E %3Cpath stroke-linejoin='bevel' d='m205.04,602.62-0.00021-5.7022c-2.1373,0.53675-3.522,1.6912-4.1387,3.2577,0-1.8927-2.7299-6.2573-5.7077-8.4294-2.9863,2.4314-5.7635,6.3801-5.7077,8.4294-0.50788-1.4918-2.0014-2.7209-4.1387-3.2577v5.702z'/%3E %3Cpath stroke-linejoin='bevel' d='m207.44,614.32,0-6.5765c-2.6591,0.68624-4.3124,2.653-5.1491,3.7996,0-3.5614-4.0212-8.9902-7.1011-10.768-3.1599,1.8244-7.1011,7.435-7.1011,10.768-0.85883-1.1395-2.49-3.1134-5.1491-3.7996v6.5765z'/%3E %3Cpath stroke-linejoin='bevel' d='m206,628.92,0-6.7617c-2.3465,0.9193-3.0479,3.1802-3.7862,4.7163,0.28981-6.8584-3.8614-14.23-7.0239-16.1-3.1624,1.8699-7.3926,9.3996-7.0239,16.1-0.75787-1.5265-1.4397-3.797-3.7862-4.7163v6.7618z'/%3E %3Cpath d='m204.36,639.16,0-6.7618c-2.4581,0.58449-2.61,1.491-3.3916,3.0055,0.28981-4.0963-2.6114-8.7695-5.7739-10.639-3.1624,1.8699-6.0637,6.5431-5.7739,10.639-0.78168-1.5145-0.87771-2.421-3.3916-3.0055v6.7618z'/%3E %3C/g%3E %3C/g%3E %3Cg id='tower'%3E %3Cg%3E %3Cpath d='m98.935,664.23,0-20.44c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-17.993l3.7418,2.0232,4.2712,18.811v22.965z'/%3E %3Cpath d='m98.935,664.31,0-20.519c-0.66964-2.6026-2.8793-4.9052-4.5407-5.3664v-19.243c2.5118,0,3.7418,3.2732,3.7418,3.2732l4.2712,18.811v22.886z'/%3E %3Cpath d='m96.275,669.55c1.7299-0.78125,4.2487-2.9188,4.2487-5.0695v-25.547l-1.1852-2.1088h43.522l-1.6983,2.1088v25.547c0,2.1508,1.7297,4.2883,3.4596,5.0695z'/%3E %3Cpath d='m135.84,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-24.297l3.619-3.359-29.588,0.00008,3.6191,3.3589v24.297c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath d='m131.69,669.55c-1.7299-0.78125-4.2487-2.9188-4.2487-5.0695v-21.965l2.369-3.359h-18.798l2.3688,3.359v21.965c0,2.1508-2.5189,4.2883-4.2488,5.0695z'/%3E %3Cpath d='m115.92,639.16,8.9819-0.00004-0.00002,30.393-8.9818,0z'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='103.7' y='647.64'/%3E %3Crect stroke-linejoin='bevel' width='3.5864' height='16.495' x='134.45' y='647.64'/%3E %3Cpath stroke-linejoin='bevel' d='m100.64,619.82h4.3202v16.909h-4.3202z'/%3E %3Cpath stroke-linejoin='bevel' d='m100.64,616.64h4.2946v3.1387h-4.2946z'/%3E %3Cpath stroke-width='1.0337' stroke-linejoin='bevel' d='m136.17,623.46h6.1594v13.054h-6.1594z'/%3E %3Cpath d='m104.89,636.6,0-28.941c1.2321,0,1.4222,4.2418,4.249,4.2418,1.4716,0,1.3152-1.757,0.4889-3.1882-0.73168-1.2673-1.6372-3.0176-0.40702-6.2783,0.84298,2.4949,3.1119,3.2866,2.6927,1.722-0.72042-2.6886-2.7945-3.1298-1.2383-7.3021,0.54049,3.4806,2.7732,3.3273,2.2309,1.3034-0.61083-2.2796-1.8732-3.2139-0.3157-6.4275,0.87209,3.6492,2.0519,3.4352,2.0519,1.1711,0-3.347-0.1285-6.9568,4.2027-8.296,0,0,0.25002-3.0682,1.8123-3.0682s1.8123,3.0682,1.8123,3.0682c4.3312,1.3393,4.2027,4.949,4.2027,8.296,0,2.264,1.1798,2.4781,2.0519-1.1711,1.5574,3.2136,0.29513,4.1479-0.3157,6.4275-0.54227,2.0238,1.6904,2.1772,2.2309-1.3034,1.5562,4.1722-0.5179,4.6134-1.2383,7.3021-0.41923,1.5646,1.8497,0.77297,2.6927-1.722,1.2302,3.2606,0.32466,5.011-0.40702,6.2783-0.82627,1.4311-0.98274,3.1882,0.4889,3.1882,2.8268,0,3.0168-4.2418,4.249-4.2418v28.941z'/%3E %3Cpath d='m98.124,614.74,0.000081,22.079,2.5111,0-0.00019-22.135c-0.90498-0.45686-1.7546-0.5274-2.511,0.0558z'/%3E %3Cpath d='m98.203,629.03c3.1124,1.5914,6.1949,3.4325,6.9754,7.7931h-6.9754z'/%3E %3Cpath d='m141.37,622.42,0.00006,14.407,2.0354,0,0-14.443c-0.63587-0.2981-1.5039-0.34413-2.0354,0.0364z'/%3E %3Cpath d='m143.41,628.92c-3.1124,1.5914-6.1949,3.4325-6.9754,7.7931h6.9754z'/%3E %3C/g%3E %3Cg%3E %3Cpath d='m122.83,595.27,1.8142-1.5247,0-1.9528c-0.6637,0.0645-1.0258,0.29275-1.516,0.93531-0.41694-1.2944-1.3337-2.3051-2.5624-2.9327-1.2287,0.6276-2.1454,1.5924-2.5624,2.8867-0.49022-0.64256-0.8523-0.8249-1.516-0.88935v1.9528l1.8142,1.5247z'/%3E %3Cpath d='m123.8,600.16,0.8432-1.8253,0-2.5384c-0.6637,0.0654-1.0258,0.29688-1.516,0.94855-0.41694-1.3127-1.3337-2.3377-2.5624-2.9742-1.2287,0.63649-2.1454,1.6149-2.5624,2.9276-0.49022-0.65166-0.8523-0.83658-1.516-0.90194v2.5384l0.8432,1.8253z'/%3E %3Cpath d='m123.93,606.79,2.6948-3.2865,0-3.2432c-0.98588,0.11068-1.5237,0.50272-2.2519,1.6061-0.61934-2.2227-1.9811-2.7084-3.8062-3.7861-1.8251,1.0777-3.1869,1.4845-3.8062,3.7072-0.72818-1.1034-1.266-1.4165-2.2519-1.5272v3.2432l2.6949,3.2865z'/%3E %3Cpath d='m124.72,613.3s3.1405-2.7397,3.3269-4.2436v-3.4672c-1.2171,0.14291-2.3682,0.45834-3.2672,1.8831-0.76458-2.8701-1.9586-3.6704-4.2117-5.0621-2.2532,1.3916-3.4471,2.192-4.2117,5.0621-0.89895-1.4248-2.0501-1.7402-3.2672-1.8831v3.4672c0.3965,1.5039,3.3269,4.2436,3.3269,4.2436z'/%3E %3Cpath d='m126.06,625.32s4.3013-4.7614,4.3999-6.6164v-5.4059c-1.6097,0.22281-3.1321,1.3298-4.321,3.5513-1.0112-4.4748-2.5903-7.5949-5.5702-9.7647-2.9799,2.1698-4.559,5.2898-5.5702,9.7647-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.30884,1.8551,4.3999,6.6164,4.3999,6.6164z'/%3E %3Cpath d='m126.06,632.43s3.6763-3.7418,4.3999-5.3664v-5.4059c-1.6097,0.22281-3.1321,1.3299-4.321,3.5513-1.0112-4.4748-2.5903-7.0369-5.5702-9.2067-2.9799,2.1698-4.559,4.7318-5.5702,9.2067-1.1889-2.2215-2.7113-3.3285-4.321-3.5513v5.4059c0.93384,1.6247,4.3999,5.3664,4.3999,5.3664z'/%3E %3Cpath d='m127.54,636.56c-1.0733-4.6678-1.9959-8.1303-7.163-11.641-5.167,3.5104-6.0894,6.9728-7.1627,11.641z'/%3E %3Cpath d='m130.2,639.16,0-6.7618c-2.3465,0.91931-4.467,2.2802-5.2487,3.7947-0.87376-3.754-2.5569-5.4078-4.6536-7.6786-2.0967,2.2708-3.5008,3.9245-4.3746,7.6786-0.78168-1.5145-2.9024-2.8754-5.2489-3.7946l0.00022,6.7618z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23tower' transform='matrix(-1,0,0,1,390.73979,0)'/%3E %3Cg%3E %3Cpath d='m72.694,694.25,245.33,0,0.00018,12.531-245.33,0.00001z'/%3E %3Cpath d='m66.228,706.76,258.26,0,0.00018,12.512-258.26,0.00002z'/%3E %3Cpath d='m85.576,675.51,219.56,0,0.00015,8.1093-219.56,0.00001z'/%3E %3Cpath d='m79.157,683.56,232.4,0,0.00017,10.622-232.4,0.00001z'/%3E %3Cpath d='m89.412,669.28,211.89,0,0.00015,6.174-211.89,0z'/%3E %3Cpath d='m112.41,669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m115.95,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3Cpath d='m187.08,669.31h16.006v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m190.73,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3Cpath d='m262.19,669.31h16.005v49.935h-16.005z' stroke-width='1.0446'/%3E %3Cpath d='m265.73,669.31h8.9171v49.936h-8.917z' stroke-width='1.0429'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m98.935,664.23h193.07'/%3E %3Cpath d='m115.79,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438'/%3E %3Cpath d='m190.77,712.98h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071m-8.6071,-6.2533h8.6071'/%3E %3Cpath d='m265.57,712.97h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438m-9.2438,-6.25h9.2438'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='450' viewBox='0 0 250 150'%3E %3CclipPath id='c'%3E %3Ccircle r='25'/%3E %3C/clipPath%3E %3Crect width='250' height='150' fill='%23e8112d'/%3E %3Cg transform='translate(125,75)'%3E %3Cg id='r20' transform='scale(0.25)'%3E %3Cg id='r4'%3E %3Cpath id='r1' d='m-8.4,108c8.4,22 -9.6,56 8.4,72c-6,-24 14-50 8.4,-72s-25.2,-22 -16.8,0z' fill='%23ffef00'/%3E %3Cuse xlink:href='%23r1' transform='rotate(90)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(180)'/%3E %3Cuse xlink:href='%23r1' transform='rotate(270)'/%3E %3C/g%3E %3Cuse xlink:href='%23r4' transform='rotate(18)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(36)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(54)'/%3E %3Cuse xlink:href='%23r4' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23r20' transform='rotate(9)'/%3E %3Ccircle r='27' fill='%23e8112d'/%3E %3Ccircle cy='-1.5' r='22.5' fill='%23ffef00'/%3E %3Cg id='x' fill='%23e8112d' clip-path='url(%23c)'%3E %3Cpath d='M-23.055236,18a37.755236,37.755236 0 1,1 75.510472,0H52.760449a36.260449,36.260449 0 1,0 -72.520898,0z'/%3E %3Cpath d='M-17.601203,18a35.301203,35.301203 0 1,1 70.602406,0H53.424578a33.924578,33.924578 0 1,0 -67.849156,0z'/%3E %3Cpath d='M20.7,-15.052356a33.052356,33.052356 0 1,0 0,66.104712L22.5,49.819805a31.819805,31.819805 0 1,1 0,-63.63961z'/%3E %3C/g%3E %3Cuse xlink:href='%23x' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg%3E %3Csvg width='900' height='600' viewBox='-120 -80 240 160' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cdefs%3E %3Cpath id='spearshape' d='M -1,55.4256258422040733928782829281879157421699 h 2 V -38 C 3,-40 3,-43 3,-46 C 3,-48 3,-56 0,-64.6632301492380856250246634162192350325315 C -3,-56 -3,-48 -3,-46 C -3,-43 -3,-40 -1,-38 z' stroke-miterlimit='10' transform='rotate(30)'/%3E%3C!-- 32*sqrt(3), -112/sqrt(3)--%3E %3C/defs%3E %3Crect x='-120' y='-80' width='240' height='160' fill='%23fff'/%3E %3Crect x='-120' y='-80' width='240' height='48'/%3E %3Crect x='-120' y='32' width='240' height='48' fill='%23060'/%3E %3Cg id='spear'%3E %3Cuse xlink:href='%23spearshape' stroke='%23000'/%3E %3Cuse xlink:href='%23spearshape' fill='%23fff'/%3E %3C/g%3E %3Cuse xlink:href='%23spear' transform='scale(-1,1)'/%3E %3Cpath fill='%23b00' d='M -120,-24 V 24 H -19 c 3,8 13,24 19,24 s 16,-16 19,-24 H 120 V -24 H 19 c -3,-8 -13,-24 -19,-24 s -16,16 -19,24 z'/%3E %3Cpath id='deco_r' d='M 19,24 c 3,-8 5,-16 5,-24 s -2,-16 -5,-24 c -3,8 -5,16 -5,24 s 2,16 5,24'/%3E %3Cuse xlink:href='%23deco_r' transform='scale(-1,1)'/%3E %3Cg fill='%23fff'%3E %3Cellipse rx='4' ry='6'/%3E %3Cpath id='deco_br' d='M 1,5.85 c 0,0 4,8 4,21 s -4,21 -4,21 z'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(-1)'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(-1,1)'/%3E %3Cuse xlink:href='%23deco_br' transform='scale(1,-1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23fff' height='600' width='900'/%3E %3Ccircle fill='%23bc002d' cx='450' cy='300' r='180'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='840' height='420'%3E %3Crect width='840' height='420' fill='%23007a3d'/%3E %3Crect width='840' height='280' fill='%23fff'/%3E %3Crect width='840' height='140' fill='%23000'/%3E %3Cpath d='M0,0V420L420,210z' fill='%23ce1126'/%3E %3Cpath d='M129.787138,180 136.295394,196.485467 153.242082,191.295306 144.411056,206.662186 159.034975,216.675628 141.51461,219.352347 142.80365,237.029066 129.787138,225 116.770625,237.029066 118.059665,219.352347 100.5393,216.675628 115.163219,206.662186 106.332193,191.295306 123.278882,196.485467 129.787138,180z' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='300' viewBox='0 0 12 6'%3E %3Cpath fill='%23009B3A' d='m0,0h12v6H0'/%3E %3Cpath stroke='%23FED100' d='m-6,9 24-12v12L-6-3'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='600' viewBox='0 0 30 18'%3E %3Crect width='30' height='18' fill='%23fff'/%3E %3Cpath d='M0,0 30,18M0,18 30,0' stroke='%23df112d' stroke-width='2'/%3E %3Cg stroke='%23000' stroke-width='0.0153'%3E %3Cpath fill='%23e8112d' d='M16.5698,2.69297c0.3855,1.56106,0.1741,3.48906-1.5673,4.55878-1.7415-1.06972-1.9529-2.99772-1.5673-4.55878,0.410478-0.373168,2.2762-0.60328,3.13453,0z'/%3E %3Cpath fill='%23f9dd16' d='m15,2.37955c0.638439,0,1.23302,0.16898,1.58351,0.388048,0.06878-0.538251,0.312867-1.07649,0.600812-1.4833-0.300406-0.00627-0.435033,0.15333-0.438087,0.319183-0.07513-0.212788-0.369307-0.200279-0.460077-0.08449,0.328627,0.222183,0.07513,0.616473-0.222097,0.535123-0.139636-0.038201-0.213424-0.135568-0.239567-0.276926a0.161537,0.161537 0 1,0 -0.068908,-0.010714c-0.09395,0.153343-0.262412,0.199375-0.383112,0.165584-0.156495-0.043809-0.22222-0.184629-0.22222-0.3098,0-0.32545,0.312867-0.375514,0.406812-0.319183-0.0061-0.21905-0.3504-0.394295-0.4568-0.21279,0.1189-0.212791,0.1127-0.513211-0.1002-0.713486-0.2127,0.200275-0.219,0.500695-0.1,0.713486-0.106406-0.181501-0.45067-0.00625-0.4569,0.2128,0.09382-0.056331,0.406812-0.00627,0.406812,0.319183,0,0.125171-0.06572,0.265992-0.22222,0.3098-0.120699,0.033791-0.289166-0.012241-0.383234-0.165584a0.161537,0.161537 0 1,0 -0.068908,0.010714c-0.0262,0.14136-0.1001,0.23872-0.2396,0.27692-0.2972,0.08135-0.5507-0.31294-0.2222-0.53512-0.0907-0.11579-0.3848-0.1283-0.46,0.08449-0.0032-0.16585-0.1377-0.32545-0.4381-0.31918,0.287823,0.406812,0.53191,0.945051,0.600812,1.4833,0.350494-0.219068,0.945075-0.388048,1.58339-0.388048z'/%3E %3Cg id='leopard'%3E %3Cg fill='%23f9dd16'%3E %3Cpath d='m16.3243,3.91058c-0.03848,0.00917-0.03848,0.058762-0.05864,0.058762,0.100054-0.00276,0.148676-0.030297,0.178973-0.080801-0.02199,0.020194-0.0028,0.058762-0.01014,0.067937,0.07342-0.025704,0.108361-0.088131,0.08271-0.130363,0.01649,0.023859,0.06426,0.036723,0.07892,0.038556-0.05143-0.0404-0.01466-0.132208-0.09737-0.179938,0.02761-0.00184,0.08087,0.029369,0.09553,0.066104-0.01283-0.082633-0.02578-0.135885-0.0937-0.181783,0.0073,0.00826,0.04593,0.015601,0.06243,0-0.04398-0.027548-0.05693-0.073446-0.05314-0.102827,0.0051-0.041109-0.02211-0.049587-0.07354-0.036723-0.0463,0.011569-0.15234,0.018362-0.214767,0.018362-0.128519,0-0.240545,0-0.347073-0.073446,0.159793,0.066092,0.363565-0.073446,0.363565-0.189125,0-0.128543-0.15796-0.233202-0.477424-0.163421-0.319464,0.069769-0.708684,0.040388-0.708684-0.066104,0-0.106504,0.279027-0.121189,0.422327-0.09915,0.143179,0.022027,0.24592,0.036723,0.514074-0.058762-0.06609,0.025704-0.279149,0.033046-0.447982-0.014684-0.168956-0.047742-0.583953-0.047742-0.587618,0.176273-0.0037,0.224003,0.441874,0.203602,0.82633,0.146892,0.22393-0.033058,0.341454-0.011019,0.341454,0.062427,0,0.069769-0.205606,0.09915-0.363566,0.080788-0.157838-0.018349-0.319464-0.014684-0.506744,0.0404-0.156372,0.045983-0.264367,0-0.436987,0.029381-0.08368,0.01422-0.286479,0-0.386533-0.165266-0.06157,0.044078-0.24702,0.136337-0.278172,0.226312-0.0441,0.082621-0.01466,0.164802,0.04398,0.24559,0.07403,0.101679-0.03665,0.086298-0.115569,0.089975-0.108239,0.00503-0.253128-0.011496-0.328749-0.097317-0.06695-0.076048-0.156128-0.136997-0.22735-0.08063-0.03665,0.029014-0.0015,0.067204,0.02749,0.056514,0.02871-0.010567,0.06267,0.01069,0.09333,0.024116-0.04899-0.021061-0.102864-0.00472-0.123876,0.014061-0.02895,0.02596,0.0062,0.075547,0.04129,0.058029,0.02749-0.013744,0.08393-0.022906,0.120577,0.010689-0.0397-0.00764-0.081-0.00602-0.100786,0.015271-0.01979,0.021294-0.0045,0.052299,0.03824,0.050393,0.06866-0.00305,0.08625,0.045055,0.155029,0.035172-0.04227,0.00551-0.06621,0.027536-0.07721,0.044065,0.06426-0.029381,0.135238,0.049819,0.218555,0.031213-0.0325,0.013377-0.08491,0.045324-0.08442,0.069781,0.04948-0.056929,0.381891,0.044065,0.389221-0.080788,0.0092,0.025704,0.0073,0.064259-0.01832,0.097317,0.04251-0.025716,0.17995-0.03489,0.222097-0.134053,0.0037,0.029381-0.0018,0.067949-0.02749,0.077123,0.0441,0.014416,0.102131-0.018423,0.161503-0.106492,0.02358-0.034939,0.0292-0.058163,0.02517-0.084429,0.05888,0.00222,0.101519-0.012559,0.147454-0.051456,0.04777-0.040388,0.0992,0.033058,0.17995-0.018362,0.08087-0.051407,0.150631-0.00734,0.19461-0.033046,0.0441-0.025704,0.104697,0.00917,0.152463-0.020194,0.04777-0.029381,0.1218,0.014379,0.200841-0.048048,0.124365,0.045556,0.269498,0.129972,0.625489,0.064565,0.204017-0.037493,0.268032,0.031213,0.268032,0.124866,0,0.064259-0.03763,0.069854-0.06609,0.071614-0.113493,0.00698-0.162237-0.042489-0.207072-0.026632-0.03005,0.010702-0.04838,0.059568-0.0049,0.076366-0.03592,0.018325-0.03128,0.05269-0.01295,0.065285,0.01832,0.012595,0.0656,0.00115,0.09773-0.013744-0.04129,0.018704-0.08405,0.052299-0.05962,0.087422,0.01478,0.021318,0.05216,0.039386,0.0871-0.0061,0.03506-0.045824,0.0992-0.084001,0.140002-0.077942z'/%3E %3Cpath d='m14.0632,2.94108c-0.102864-0.04222-0.137559-0.043381-0.113859,0.0404,0.01014,0.035807,0.03482,0.086298,0.05962,0.109253,0.000978-0.034878,0.0138-0.131279,0.05424-0.149653z'/%3E %3Cpath d='m14.3845,2.94108c0.102864-0.04222,0.137559-0.043381,0.113859,0.0404-0.01014,0.035807-0.03494,0.086298-0.05974,0.109253-0.000855-0.034878-0.01368-0.131279-0.05412-0.149653z'/%3E %3Cpath d='m14.2243,2.88464c0.19461,0,0.218921,0.091343,0.217944,0.205178-0.000855,0.123021-0.06695,0.080788-0.104574,0.2387-0.01466,0.061743-0.06389,0.065188-0.11337,0.065188-0.0496,0-0.09871-0.00345-0.113492-0.065188-0.0374-0.15792-0.1036-0.11569-0.1045-0.23871-0.0009-0.11383,0.0234-0.20517,0.2181-0.20517z'/%3E %3Cpath d='m13.7226,3.33585c-0.0496-0.029381-0.08161-0.00905-0.101765-0.00353,0.06426,0.016517,0.06682,0.099015,0.213791,0.137571-0.03311-0.00917-0.05143,0.00919-0.08271-0.00734,0.06059,0.047742,0.128519,0.103022,0.271819,0.10466,0.0799,0.0009162,0.02468,0.042233-0.02761,0.018361,0.05424,0.056001,0.161625,0.010103,0.22955,0.112014,0.01283-0.078956-0.126686-0.203822-0.06243-0.293784-0.198153-0.00844-0.214401-0.118269-0.328626-0.205654-0.09297-0.071052-0.101276-0.143276-0.142324-0.278502-0.01869-0.06123-0.0904-0.099406-0.130106-0.084905-0.03469,0.012681-0.0474,0.04277-0.01759,0.065285,0.02981,0.022527,0.06792,0.025582,0.07611,0.082657-0.03873-0.046386-0.09675-0.063184-0.124609-0.03417-0.01698,0.017665-0.01014,0.058884,0.02639,0.062622,0.0595,0.00611,0.01674,0.064137,0.08442,0.120908-0.05998-0.06746-0.111903-0.073568-0.144033-0.036919-0.01918,0.021953,0,0.061083,0.04129,0.056893,0.05974-0.00608,0.129007,0.145463,0.218433,0.183835z'/%3E %3Cpath d='m15.32,3.90323c-0.03127,0.00551-0.02199,0.056929-0.06426,0.060606,0.101032,0,0.152341-0.023883,0.200108-0.062439-0.02199,0.012852-0.03115,0.04591-0.03299,0.064259,0.05326-0.045898,0.179951-0.049563,0.246042-0.036711,0.06609,0.012852,0.07709-0.018362,0.100909-0.060594,0.02395-0.042233-0.0092-0.066104-0.04215-0.09915-0.03311-0.033058-0.04044-0.078956-0.03311-0.156079-0.176285-0.235023-0.492084-0.121188-0.495749-0.018362,0.113859,0.132196,0.128519,0.117511,0.224052,0.135873,0.09541,0.018361,0.153929,0.018313,0.08991,0.071614-0.02199,0.018362-0.113858,0.00974-0.185447,0.012852-0.16016,0.00696-0.233459-0.110633-0.280738-0.049551-0.03897,0.050235,0.0012,0.07242,0.08063,0.069745-0.05498,0.0003909-0.127908-0.00258-0.115447,0.048622,0.02101,0.086274,0.103475-0.01604,0.135604,0.019461-0.02749-0.00649-0.07024,0.010311-0.07183,0.036271-0.0015,0.025972,0.06108,0.059556,0.129862,0.00496,0.03763-0.029931,0.08564-0.041133,0.114592-0.041377z'/%3E %3Cpath d='m15.4566,3.54488c-0.0573-0.020964-0.109827-0.033779-0.177018-0.019901'/%3E %3Cpath d='m14.5929,3.51764c-0.04716,0.101324-0.01857,0.151339-0.0116,0.198348'/%3E %3Cpath d='m14.0908,3.03734c0.03237,0.016187,0.05058-0.029564,0.0981,0.019009-0.01307-0.014171-0.02932,0.037664-0.06573,0.00326'/%3E %3Cpath d='m14.355,3.03734c-0.03237,0.016187-0.05058-0.029564-0.0981,0.019009,0.01307-0.014171,0.02932,0.037664,0.06572,0.00326'/%3E %3Cpath d='m14.2569,3.05635c-0.01112,0.00917-0.01222-0.00732-0.0038,0.036014,0.01564,0.079567,0.03408,0.116791-0.0303,0.116791-0.06573,0-0.04581-0.037224-0.0303-0.116791,0.0086-0.043332,0.0075-0.02684-0.0037-0.036014'/%3E %3C/g%3E %3Cg fill='%23ff0016' stroke-width='0.00765'%3E %3Cpath d='m14.2238,3.36157c0.05229,0,0.08258-0.0009163,0.0744-0.074362-0.0034-0.029479,0.03579-0.041219,0.02199-0.089059,0.01466,0.058749-0.09639,0.053142-0.09639,0.02651,0,0.026632-0.111049,0.032239-0.09639-0.02651-0.0138,0.04784,0.02529,0.05958,0.02199,0.089059-0.0082,0.073446,0.02211,0.074362,0.0744,0.074362z'/%3E %3Cpath d='M14.1768,3.21299,14.0512,3.17796'/%3E %3Cpath d='m14.1768,3.21952-0.140246-0.00117'/%3E %3Cpath d='m14.1781,3.2267-0.1196,0.032044'/%3E %3Cpath d='m14.2709,3.21299,0.125587-0.035037'/%3E %3Cpath d='m14.2709,3.21952,0.140246-0.00117'/%3E %3Cpath d='m14.2695,3.2267,0.119601,0.032044'/%3E %3C/g%3E %3Cg fill='%230051ba' stroke-width='0.00159'%3E %3Cpath d='m13.5733,2.83723c-0.03653-0.045482-0.12803-0.00707-0.129862,0.049355,0.03091-0.036576,0.08136,0.016114,0.108849,0.00503,0.01906-0.00767,0.0358-0.03588,0.02101-0.054388z'/%3E %3Cpath d='m13.5259,2.9449c-0.03653-0.045482-0.127908-0.00707-0.129741,0.049355,0.03079-0.036576,0.08124,0.016114,0.10885,0.00503,0.01906-0.00766,0.0358-0.03588,0.02089-0.054388z'/%3E %3Cpath d='m13.5021,3.08953c-0.04141-0.041084-0.127908,0.00737-0.123387,0.063636,0.02663-0.039814,0.08258,0.00688,0.108727-0.00724,0.01808-0.00976,0.03152-0.039667,0.01466-0.056392z'/%3E %3Cpath d='m13.5457,3.53777c-0.04593-0.036039-0.126197,0.022026-0.115324,0.077416,0.02187-0.042599,0.08283-0.00268,0.107139-0.019693,0.01686-0.011789,0.02688-0.043039,0.0082-0.057723z'/%3E %3Cpath d='m13.5434,3.63587c-0.05473-0.020182-0.11337,0.059788-0.08588,0.109131,0.0076-0.047254,0.07794-0.028025,0.0959-0.051725,0.01246-0.016395,0.01222-0.049184-0.01002-0.057406z'/%3E %3Cpath d='m13.6136,3.70918c-0.05473-0.020194-0.11337,0.059776-0.08601,0.109131,0.0077-0.047266,0.07806-0.028037,0.09602-0.051737,0.01246-0.016395,0.01222-0.049184-0.01002-0.057393z'/%3E %3Cpath d='m15.0476,3.8512c-0.05473-0.020182-0.11337,0.059788-0.08588,0.109131,0.0077-0.047254,0.07794-0.028025,0.0959-0.051725,0.01246-0.016395,0.01222-0.049184-0.01002-0.057406z'/%3E %3Cpath d='m15.1215,3.91773c-0.05669-0.013829-0.105796,0.072298-0.07293,0.118196,0.0022-0.047828,0.07428-0.036723,0.08943-0.062317,0.01051-0.017702,0.0066-0.050259-0.01649-0.055879z'/%3E %3Cpath d='m15.0695,3.75701c-0.05058-0.029198-0.121921,0.039643-0.10323,0.092932,0.01564-0.045262,0.08161-0.014355,0.103353-0.034646,0.01503-0.014049,0.0204-0.046399-0.000123-0.058285z'/%3E %3Cpath d='m16.0897,3.87191c-0.05669-0.013817-0.105796,0.072298-0.07293,0.118208,0.0023-0.047828,0.0744-0.036723,0.08943-0.062317,0.01051-0.017702,0.0066-0.050259-0.01649-0.055891z'/%3E %3Cpath d='m16.0914,3.78185c-0.05143-0.027438-0.120333,0.043821-0.09993,0.096438,0.01405-0.045776,0.08112-0.017152,0.102131-0.038189,0.01454-0.014562,0.01881-0.04707-0.0022-0.058249z'/%3E %3Cpath d='m16.1312,3.9524c-0.05717-0.011337-0.102497,0.076855-0.06768,0.121274,0.000245-0.047877,0.07269-0.039948,0.08662-0.066165,0.0098-0.018154,0.0044-0.050503-0.01894-0.055109z'/%3E %3Cpath d='m14.228,3.31754c0.03592,0,0.05045,0.010482,0.05045,0.075364,0,0.137461-0.0016,0.196565-0.04581,0.196565-0.04435,0-0.04129-0.05616-0.04129-0.157081,0-0.052653,0-0.07898-0.01063-0.074594,0-0.034353,0.01527-0.040254,0.04728-0.040254z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23leopard' transform='matrix(0.9,0,0,0.9,1.45342,1.67136)'/%3E %3Cuse xlink:href='%23leopard' transform='matrix(0.67,0,0,0.75,4.90869,3.35378)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1500' height='1000' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' fill='%23009246'/%3E %3Crect width='1' height='2' x='1' fill='%23fff'/%3E %3Crect width='1' height='2' x='2' fill='%23ce2b37'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='2500' height='1800'%3E %3Cpath d='M0,0H2500V1800H0' fill='%23003897'/%3E %3Cpath d='M700,0h400V1800h-400M0,700H2500v400H0' fill='%23fff'/%3E %3Cpath d='M800,0h200V1800h-200M0,800H2500v200H0' fill='%23d72828'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='630' height='360'%3E %3Crect width='630' height='360' fill='%23da0000'/%3E %3Crect width='630' height='240' fill='%23fff'/%3E %3Crect width='630' height='120' fill='%23239f40'/%3E %3Cg transform='translate(8.4,100.4)'%3E %3Cg id='tb4'%3E %3Cg id='tb1' fill='none' stroke='%23fff' stroke-width='2'%3E %3Cpath id='tbp1' d='M0,1H26M1,10V5H9V9H17V5H12M4,9H6M26,9H21V5H29M29,0V9H37V0M33,0V9' transform='scale(1.4)'/%3E %3Cpath id='tbp2' d='M0,7H9M10,7H19' transform='scale(2.8)'/%3E %3Cuse xlink:href='%23tbp2' y='120'/%3E %3Cuse xlink:href='%23tbp1' y='145.2'/%3E %3C/g%3E %3Cg id='tb3'%3E %3Cuse xlink:href='%23tb1' x='56'/%3E %3Cuse xlink:href='%23tb1' x='112'/%3E %3Cuse xlink:href='%23tb1' x='168'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23tb3' x='168'/%3E %3Cuse xlink:href='%23tb4' x='392'/%3E %3C/g%3E %3Cg fill='%23da0000' transform='matrix(45,0,0,45,315,180)'%3E %3Cg id='emblem_half'%3E %3Cpath d='M-0.54815,0.83638A0.912046,0.912046 0 0,0 0.328544,-0.722384A1,1 0 0,1 -0.54815,0.83638'/%3E %3Cpath d='M0.618339,0.661409A0.763932,0.763932 0 0,0 0.421644,-0.741049A1,1 0 0,1 0.618339,0.661409'/%3E %3Cpath d='M0,1 -0.05,0 0,-0.787278A0.309995,0.309995 0 0,0 0.118034,-0.688191V-0.100406L0.077809,0.892905z'/%3E %3Cpath d='M-0.02,-0.85 0,-0.831217A0.14431,0.14431 0 0,0 0.252075,-0.967708A0.136408,0.136408 0 0,1 0,-0.924634'/%3E %3C/g%3E %3Cuse xlink:href='%23emblem_half' transform='scale(-1,1)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' version='1.0' id='Layer_1' x='0px' y='0px' width='411px' height='274px' viewBox='79.461 52.641 411 274' enable-background='new 79.461 52.641 411 274' xml:space='preserve' inkscape:version='0.48.1 ' sodipodi:docname='Flag of Iraq.svg'%3E%3Cmetadata id='metadata34'%3E%3Crdf:RDF%3E%3Ccc:Work rdf:about=''%3E%3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E%3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E%3C/cc:Work%3E%3C/rdf:RDF%3E%3C/metadata%3E%3Cdefs id='defs32' /%3E%3Csodipodi:namedview pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1' objecttolerance='10' gridtolerance='10' guidetolerance='10' inkscape:pageopacity='0' inkscape:pageshadow='2' inkscape:window-width='1440' inkscape:window-height='838' id='namedview30' showgrid='false' inkscape:zoom='0.95255474' inkscape:cx='205.5' inkscape:cy='137' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' inkscape:current-layer='Layer_1' /%3E %3Crect id='rect7_1_' x='79.501' y='139.356' fill='%23FFFFFF' width='410.998' height='101.287' /%3E %3Crect id='rect3' x='79.5' y='53' fill='%23CF2029' width='410.998' height='91.288' style='fill:%23ce1126;fill-opacity:1' /%3E %3Crect id='rect7' x='79.5' y='235.713' fill='%23020202' width='410.998' height='91.287' style='fill:%23000000;fill-opacity:1' /%3E %3Cg id='g6' style='fill:%23007a3d;fill-opacity:1'%3E %3Cg id='g8' style='fill:%23007a3d;fill-opacity:1'%3E %3Cg id='g10' style='fill:%23007a3d;fill-opacity:1'%3E %3Cpath fill='%23119B4A' d='M325.525,173.177c-0.558-0.294-1.186-0.767-1.395-1.053c-0.314-0.439-0.131-0.456,1.163-0.105 c2.319,0.629,3.815,0.384,5.298-0.872l1.308-1.103l1.54,0.784c0.848,0.428,1.748,0.724,2.008,0.656 c0.667-0.176,2.05-1.95,2.005-2.564c-0.054-0.759,0.587-0.569,0.896,0.263c0.615,1.631-0.281,3.503-1.865,3.918 c-0.774,0.202-1.488,0.127-2.659-0.28c-1.439-0.502-1.684-0.495-2.406,0.057C329.801,174.118,327.549,174.234,325.525,173.177z' id='path12' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M331.258,167.935c-0.563-0.716-1.239-3.423-1.02-4.088c0.192-0.575,0.39-0.69,0.914-0.526 c0.918,0.287,1.13,0.92,0.993,3.063C332.038,168.132,331.779,168.591,331.258,167.935z' id='path14' style='fill:%23007a3d;fill-opacity:1' /%3E %3C/g%3E %3Cpath fill='%23119B4A' d='M263.743,165.991c-0.185,1.31,2.325,4.567,3.458,5.157c-0.77,0.345-1.728,0.189-2.434,0.577 c-3.948,3.948-18.367,18.005-21,21.366c7.799,0.154,16.449-0.106,23.761-0.44c-0.007-5.299,5.018-5.573,8.381-7.503 c1.73,2.725,6.075,2.516,6.618,6.618c0,4.91,0.009,12.306,0.009,17.646c-22.059,0-44.566,0-66.625,0 c-1.172,5.176-5.844,9.125-12.354,7.5c2.014-2.103,5.406-2.827,6.619-5.734c1.025-6.365-2.045-10.296-4.031-13.907 c3.284-1.195,3.782-1.493,7.121-3.737c-2.343,7.12,6.091,6.338,12.353,6.175c0.211-2.417,0.089-5.271-1.766-5.624 c2.396-0.87,2.794-1.168,6.619-4.412c0,2.942,0,6.652,0,9.592c14.886,0,30.943-0.111,46.139-0.111 c0-3.002,0.795-7.824-1.581-7.824c-2.269,0-0.107,6.173-1.87,6.173s-23.719,0-35.63,0c0-1.328-0.034-4.104-0.034-6.104 c1.51-1.511,1.331-1.38,11.648-11.698C250.172,178.672,257.41,172.134,263.743,165.991z' id='path16' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M352.803,165.737c2.488,1.338,4.457,3.191,7.502,3.971c-0.353,1.26-1.475,1.759-1.769,3.087 c0,8.97,0,17.941,0,26.91c3.402,0.75,4.118-1.178,5.737-2.205c0.442,4.307,3.185,8.53,3.088,11.91c-4.851,0-9.706,0-14.559,0 C352.803,194.855,352.803,180.296,352.803,165.737z' id='path18' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M333.391,180.149c0,0,5.296-4.471,5.296-4.643c0,7.646,0,15.837,0,23.485l3.814-0.006 c0-8.948-0.118-18.023-0.118-26.338c1.548-1.549,4.58-3.792,5.338-5.359c0,15.987,0,29.519,0,42.059 c-10.746,0-30.793,0.013-33.443,0.013c-0.493-8.73-0.577-17.771,9.599-15.827c0-1.488,0-2.369,0-3.562 c-0.31-0.609-0.868,0.147-0.998-0.645c1.616-1.617,2.163-2.029,6.538-5.851c0,4.612,0.081,15.499,0.081,15.499 c1.07,0,3.153,0.004,3.857,0.004C333.356,198.979,333.391,180.75,333.391,180.149z M320.837,198.751 c0.716,1.075,3.155,1.056,3.04-0.755C323.466,196.503,320.262,197.072,320.837,198.751z' id='path20' style='fill:%23007a3d;fill-opacity:1' /%3E %3Ccircle fill='%23119B4A' cx='224.026' cy='214.369' r='2.042' id='circle22' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M341.175,199.295' id='path24' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M329.451,199.295' id='path26' style='fill:%23007a3d;fill-opacity:1' /%3E %3Cpath fill='%23119B4A' d='M287.048,165.779c2.488,1.339,4.457,3.191,7.502,3.971c-0.353,1.26-1.476,1.759-1.768,3.087 c0,8.97,0,17.94,0,26.911c3.401,0.749,4.117-1.179,5.736-2.206c0.441,4.307,3.185,8.529,3.088,11.91c-4.851,0-9.706,0-14.559,0 C287.048,194.897,287.048,180.338,287.048,165.779z' id='path28' style='fill:%23007a3d;fill-opacity:1' /%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 600 300'%3E %3Cdefs%3E %3CclipPath id='cp'%3E %3Cpath d='M0 0V75H350V150H300zM300 0H150V200H0V150z'/%3E %3C/clipPath%3E %3CclipPath id='cp2'%3E %3Crect width='300' height='150'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect fill='%23FFF' width='600' height='300'/%3E %3Cpath id='wave' fill='%23002b7f' d='M600 260.881C593.277 264.926 587.501 274.379 569.64 274.379 533.929 274.379 524.999 254.477 498.213 254.477 480.357 254.477 471.428 274.379 453.572 274.379 417.857 274.379 408.929 254.477 382.143 254.477 364.286 254.477 355.357 274.379 337.5 274.379 301.786 274.379 292.857 254.477 266.072 254.477 248.214 254.477 239.286 274.379 221.429 274.379 185.715 274.379 176.786 254.477 150 254.477 132.142 254.477 123.214 274.379 105.357 274.379 69.643 274.379 60.714 254.477 33.929 254.477 16.071 254.477 10.714 268.659 0 268.659L0 294.28C10.714 294.28 16.071 280.099 33.929 280.099 60.714 280.099 69.643 300 105.357 300 123.214 300 132.142 280.099 150 280.099 176.785 280.099 185.715 300 221.429 300 239.286 300 248.214 280.099 266.072 280.099 292.857 280.099 301.786 300 337.5 300 355.357 300 364.286 280.099 382.143 280.099 408.929 280.099 417.857 300 453.572 300 471.428 300 480.357 280.099 498.213 280.099 524.999 280.099 533.929 300 569.64 300 587.501 300 593.277 294.36 600 290.316L600 260.881z'/%3E %3Cuse transform='translate(0,-49.75348)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-99.50701)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-149.26056)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-199.01404)' xlink:href='%23wave'/%3E %3Cuse transform='translate(0,-248.76752)' xlink:href='%23wave'/%3E %3Crect fill='%23FFF' width='300' height='152'/%3E %3Cg clip-path='url(%23cp2)'%3E %3Crect width='300' height='150' fill='%2300247d'/%3E %3Cpath d='M0 0L300 150M300 0L0 150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0 0L300 150M300 0L0 150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150 0V200M0 75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150 0V200M0 75H350' stroke='%23cf142b' stroke-width='30'/%3E %3C/g%3E %3Cg%3E %3Cg transform='matrix(0.604762,0,0,0.604762,0,-1.160721e-4)'%3E %3Cpath d='M814.961-301.181L797.244 407.48C797.244 444.778 877.341 444.778 885.827 407.48L868.11-301.181 814.961-301.181z' transform='matrix(0.200004,0,0,0.475,575.1662,274.5648)' style='fill:%23a24300;stroke-width:6.935;stroke:%23fff'/%3E %3Cg transform='matrix(0.725195,0,0,0.6231,202.0636,41.43416)'%3E %3Cg transform='matrix(-0.314512,0.10485,-0.138292,-0.303235,1046.472,373.319)'%3E %3Cg id='t3' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M496.063 549.213L513.78 620.079 549.213 566.929 531.496 655.512 566.929 620.079 531.496 708.661 566.929 673.228 531.496 761.811 566.929 726.378 531.496 832.677 566.929 797.244 531.496 903.543 566.929 868.11 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 425.197 868.11 460.63 903.543 425.197 797.244 460.63 832.677 425.197 726.378 460.63 761.811 425.197 673.228 460.63 708.661 425.197 620.079 460.63 655.512 442.913 566.929 478.346 620.079 496.063 549.213z' transform='translate(177.1655,-224.0517)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M496.063 549.213L496.063 1045.28' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 868.11L496.063 974.409 566.929 868.11' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 797.244L496.063 903.543 566.929 797.244' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 726.378L496.063 832.677 566.929 726.378' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 673.228L496.063 761.811 566.929 673.228' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M425.197 620.079L496.063 708.661 566.929 620.079' transform='translate(177.1655,-224.0517)'/%3E %3Cpath d='M442.913 566.929L496.063 673.228 549.213 566.929' transform='translate(177.1655,-224.0517)'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t3' transform='matrix(0.236516,-0.281856,0.294964,0.227618,354.5673,204.654)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(0.15164,0.335243,-0.332899,0.167308,907.5388,-153.4696)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(-0.209517,0.302465,-0.314697,-0.199448,1141.363,167.5798)'/%3E %3Cuse xlink:href='%23t3' transform='matrix(-0.207724,-0.258384,0.236176,-0.235153,689.9856,567.2772)'/%3E %3Cg transform='matrix(-0.362184,-9.947167e-2,-0.209809,0.317733,1222.415,-24.22945)'%3E %3Cg id='t2' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M460.63 549.213L489.273 620.079 531.496 566.929 521.312 655.512 549.212 620.079 531.496 708.661 556.745 673.228 531.496 761.811 566.929 726.378 531.496 832.677 566.929 797.244 531.496 903.543 566.929 868.11 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 425.197 868.11 460.63 903.543 425.197 797.244 460.63 832.677 425.197 726.378 460.63 761.811 415.013 673.228 460.63 708.661 407.48 620.079 450.446 655.512 425.196 566.929 460.629 620.079 460.63 549.213z' transform='translate(283.4647,-124.0162)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M467.208 584.646L496.063 708.662 496.063 1045.28' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M436.23 885.827L496.063 974.409 556.745 885.827' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M434.533 814.961L496.063 903.543 556.745 814.961' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M435.381 744.095L496.063 832.677 555.896 744.095' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M432.835 690.945L496.063 761.811 549.212 690.945' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M425.197 637.796L496.063 708.661 541.469 637.796' transform='translate(283.4647,-124.0162)'/%3E %3Cpath d='M436.124 593.238L489.274 680.124 524.601 584.646' transform='translate(283.4647,-124.0162)'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t2' transform='matrix(0.360878,0.10411,1.321056e-2,0.380525,452.7614,-239.2657)'/%3E %3Cg transform='matrix(4.613187e-2,-0.364743,0.326017,6.479648e-2,379.5799,479.5432)' style='fill:none;stroke-width:1;stroke:%23000'%3E %3Cpath d='M354.331 531.496L442.914 620.079 460.63 566.93 460.63 655.512 496.063 620.079 478.347 708.662 513.779 673.228 496.063 761.812 531.496 726.379 513.78 832.678 549.213 797.245 513.78 903.544 549.213 868.111 531.496 974.409 513.78 1027.56 496.063 1045.28 478.346 1027.56 460.63 974.409 407.48 892.115 442.914 903.544 407.481 797.245 442.914 832.678 389.764 726.379 425.197 761.812 372.047 673.228 425.197 708.662 354.331 620.079 407.48 655.512 336.614 584.646 407.48 620.079 354.331 531.496z' transform='translate(442.9136,-42.96583)' style='fill:%23006d00;stroke-width:8.25;stroke:%23fff'/%3E %3Cpath d='M378.962 560.015L442.914 655.512 460.63 708.662 469.489 753.867 478.347 832.678 487.662 903.544 496.063 1045.28' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M425.197 903.544L488.862 974.41 539.611 885.827' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M417.082 814.961L487.661 903.544 538.411 814.961' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M407.48 752.443L478.347 832.678 524.295 744.095' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M372.047 637.796L460.63 708.662 486.461 637.796' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M360.618 602.363L442.914 655.512 453.429 602.363' transform='translate(442.9136,-42.96583)'/%3E %3Cpath d='M389.764 690.945L470.859 761.811 504.805 690.945' transform='translate(442.9136,-42.96583)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.253333,0,0,0.253333,412,157.1807)'%3E %3Cpath d='M52.504 257.674L151.04 239.994 253.682 257.674 206.056 277.475 118.195 278.89 52.504 257.674z' style='fill:%239d9d9d;stroke-width:1.008;stroke:%23000'/%3E %3Cpath d='M151.789 98.445C134.566 104.432 115.487 90.02 84.43 113.539 84.43 113.539 30.286 90.376 26.173 143.91 26.008 146.077 34.743 159.133 35.959 158.2 42.763 152.976 32.729 163.272 32.729 164.76 32.729 166.26 33.727 167.093 34.064 167.754 34.395 168.421 35.227 169.419 35.393 172.248 35.558 175.076 29.256 182.792 31.919 185.62 34.576 188.449 34.741 196.604 34.741 198.931 34.741 201.257 36.407 207.747 37.57 209.082 38.733 210.41 40.729 213.735 40.729 216.563 40.729 219.392 41.892 227.21 41.39 229.2 40.894 231.196 44.384 233.694 47.55 234.692 50.709 235.69 91.485 236.398 148.712 235.4 205.945 234.402 225.04 243.457 248.686 234.857 252.341 233.529 253.008 230.535 252.678 228.869 252.341 227.21 252.678 221.89 253.676 220.555 254.674 219.227 261.329 208.58 259.994 206.584 261.25 205.45 270.583 211.974 264.639 206.148 263.115 204.655 265.492 188.932 266.312 185.62 267.139 182.302 268.408 176.071 269.933 174.914 271.465 173.757 267.335 169.426 267.628 168.644 267.926 167.856 269.039 165.415 270.59 164.303 270.59 164.303 273.475 150.776 271.696 144.127 269.929 137.472 263.426 107.544 222.834 113.539 222.834 113.539 168.494 92.639 151.789 98.445z' style='fill:%23c00;stroke-width:1.629;stroke:%23000'/%3E %3Cg transform='translate(0,-2.600445e-4)'%3E %3Cg transform='matrix(1.085779,0,0,1.085779,6.91471,26.11235)'%3E %3Cg transform='matrix(0.496967,-4.459677e-2,8.946727e-2,0.726775,44.70009,100.5425)' stroke-width='1.241'%3E %3Cg id='t4'%3E %3Cpath d='M49.75 0.125C44.657 1.015 34.594 29.37 37.141 38.875 38.904 45.455 41.639 49.995 43.188 52.781 39.783 48.096 31.805 39.031 20.938 39.031 7.274 39.031 5.507 68.979 5.844 70.906 5.845 70.913 5.842 70.932 5.844 70.938 5.845 70.942 5.873 70.965 5.875 70.969 5.877 70.968 5.904 70.97 5.906 70.969 6.519 70.254 12.048 57.875 25.563 57.875 34.459 57.875 41.392 64.91 43.938 67.906 43.937 68.851 43.96 69.764 43.969 70.688 41.965 73.516 40.687 80.219 34.5 88.656 27.023 98.852 4.128 99.897 0.281 100 1.252 100 37.806 100 49.813 100 49.86 100 49.922 100.003 49.969 100 49.991 100.002 50.009 99.999 50.031 100 50.078 100.003 50.14 100 50.188 100 62.194 100 98.748 100 99.719 100 95.872 99.897 72.539 98.852 65.063 88.656 58.875 80.219 58.035 73.516 56.031 70.688 56.04 69.764 56.063 68.851 56.063 67.906 58.608 64.91 65.541 57.875 74.438 57.875 87.952 57.875 93.481 70.254 94.094 70.969 94.096 70.97 94.123 70.968 94.125 70.969 94.127 70.965 94.155 70.942 94.156 70.938 94.158 70.932 94.155 70.913 94.156 70.906 94.493 68.979 92.726 39.031 79.063 39.031 68.195 39.031 60.217 48.096 56.813 52.781 58.361 49.995 61.103 44.206 62.531 38.875 65.118 29.219 55.091 0.132 50 0.125 49.92 0.125 49.831 0.111 49.75 0.125zM43.313 52.969C43.665 53.459 43.975 53.881 44.219 54.25 44.224 54.258 44.76 57.227 44.766 57.234 44.763 57.298 47.393 67.42 47.39 67.484 47.126 67.092 43.653 53.569 43.313 52.969zM56.688 52.969C56.347 53.569 52.655 67.092 52.391 67.484 52.388 67.42 55.784 54.345 55.781 54.281 55.781 54.271 55.344 57.245 55.344 57.234 55.588 56.865 56.335 53.459 56.688 52.969z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3E %3Cpath d='M42 67.578C42 67.578 46 65.719 50 65.719 54 65.719 58 67.578 58 67.578L58 72.531C58 72.531 54 70.672 50 70.672 46 70.672 42 72.531 42 72.531L42 67.578z' style='fill:%23f7d917;stroke-width:1.241;stroke:%23000'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t4' transform='matrix(0.495379,5.970303e-2,-6.359282e-2,0.729495,168.9189,96.59048)'/%3E %3Cg style='fill:%23f7d917;stroke-width:0.715;stroke:%23000'%3E %3Cpath d='M24.308 134.56L33.998 122.746C33.998 122.746 34.901 123.914 33.998 122.746 14.132 97.065 13.127 82.331 15.363 74.87 17.599 67.409 22.072 59.326 33.998 49.377 45.924 39.429 54.154 44.958 65.334 44.958 76.515 44.958 79.497 47.445 89.186 48.689 98.876 49.932 124.964 51.176 124.964 51.176L124.964 44.336C124.964 44.336 125.993 44.528 124.964 44.336 113.446 42.189 98.876 44.336 89.186 41.849 79.497 39.362 71.297 38.741 60.862 38.741 50.427 38.741 42.942 35.698 36.234 40.051 29.525 44.403 21.326 51.864 15.363 58.082 9.4 64.3 6.419 76.735 7.164 84.818 7.91 92.901 10.891 99.741 15.363 105.958 19.836 112.176 19.09 117.15 20.581 121.502 22.072 125.855 24.308 135.181 24.308 134.56z'/%3E %3Cpath d='M239.255 134.56L229.565 122.746C229.565 122.746 228.661 123.914 229.565 122.746 249.43 97.065 250.435 82.331 248.199 74.87 245.963 67.409 241.491 59.326 229.565 49.377 217.639 39.429 209.409 44.958 198.228 44.958 187.047 44.958 184.066 47.445 174.376 48.689 164.686 49.932 138.598 51.176 138.598 51.176L138.598 44.336C138.598 44.336 137.569 44.528 138.598 44.336 150.117 42.189 164.686 44.336 174.376 41.849 184.066 39.362 192.265 38.741 202.7 38.741 213.136 38.741 220.62 35.698 227.329 40.051 234.037 44.403 242.236 51.864 248.199 58.082 254.162 64.3 257.144 76.735 256.398 84.818 255.653 92.901 252.671 99.741 248.199 105.958 243.727 112.176 244.472 117.15 242.982 121.502 241.491 125.855 239.255 135.181 239.255 134.56z'/%3E %3Crect width='34.563' height='70.894' x='115.553' y='38.701' style='stroke-width:0.835'/%3E %3C/g%3E %3Cg transform='translate(0,-8)' style='fill:%23f7d917;stroke-width:0.5;stroke:%23000'%3E %3Cpath d='M119.684-15.799C119.684-15.799 123.404-12.771 126.259-8.877 129.115-4.984 131.105-0.225 131.105-0.225 131.105-0.225 126.346-2.215 122.453-5.071 118.559-7.926 115.531-11.646 115.531-11.646L115.531 14.656C115.531 14.656 118.559 10.936 122.453 8.081 126.346 5.225 131.105 3.235 131.105 3.235 131.105 3.235 129.571 7.162 128.581 11.888 127.69 16.138 120.398 25.952 120.398 25.952L141.701 27.381C141.701 27.381 138.159 16.138 136.732 11.888 135.196 7.31 134.565 3.235 134.565 3.235 134.565 3.235 139.324 5.225 143.218 8.081 147.111 10.936 150.139 14.656 150.139 14.656L150.139-11.646C150.139-11.646 147.111-7.926 143.218-5.071 139.324-2.215 134.565-0.225 134.565-0.225 134.565-0.225 136.555-4.984 139.411-8.877 142.266-12.771 145.986-15.799 145.986-15.799L119.684-15.799z'/%3E %3Cpath d='M150 23.076A17.143 17.143 0 1 1 115.714 23.076 17.143 17.143 0 1 1 150 23.076z' transform='translate(-2.209282e-2,8)'/%3E %3Cpath d='M116.074 33.535L150.176 33.535C150.176 33.535 150.67 26.939 148.202 24.471 145.823 24.471 137.608 24.471 137.608 24.471L137.429 14.583 133.484 14.583 127.387 14.583 127.208 24.471C127.208 24.471 120.081 24.828 116.798 24.828 115.309 28.869 115.538 29.209 115.538 29.209L116.074 33.535z'/%3E %3C/g%3E %3Cg style='fill:%23f7d917;stroke-width:0.75;stroke:%23000'%3E %3Cpath d='M110.877 107.221C110.877 107.221 117.089 112.277 121.856 118.778 126.623 125.279 129.946 133.224 129.946 133.224 129.946 133.224 122 129.901 115.5 125.134 108.999 120.367 103.943 114.155 103.943 114.155L103.943 158.071C103.943 158.071 108.999 151.86 115.5 147.092 122 142.325 129.946 139.002 129.946 139.002 129.946 139.002 126.623 146.948 121.856 153.449 117.089 159.949 110.877 165.006 110.877 165.006L154.793 165.006C154.793 165.006 148.581 159.949 143.814 153.449 139.047 146.948 135.724 139.002 135.724 139.002 135.724 139.002 143.67 142.325 150.17 147.092 156.671 151.86 161.727 158.071 161.727 158.071L161.727 114.155C161.727 114.155 156.671 120.367 150.17 125.134 143.67 129.901 135.724 133.224 135.724 133.224 135.724 133.224 139.047 125.279 143.814 118.778 148.581 112.277 154.793 107.221 154.793 107.221L110.877 107.221z'/%3E %3Cpath d='M27.24 181.78L48.865 177.967C48.865 177.967 41.87 174.066 36.046 168.492 30.222 162.918 25.57 155.67 25.57 155.67 25.57 155.67 33.972 157.562 41.202 161.128 48.432 164.694 54.49 169.934 54.49 169.934L46.864 126.685C46.864 126.685 42.963 133.68 37.389 139.504 31.815 145.328 24.567 149.979 24.567 149.979 24.567 149.979 26.459 141.578 30.025 134.348 33.591 127.118 38.831 121.06 38.831 121.06L17.206 124.873 27.24 181.78z'/%3E %3Cpath d='M226.839 121.06C226.839 121.06 232.079 127.118 235.645 134.348 239.211 141.578 241.103 149.979 241.103 149.979 241.103 149.979 233.855 145.328 228.281 139.504 222.707 133.68 218.806 126.685 218.806 126.685L211.18 169.934C211.18 169.934 217.238 164.694 224.468 161.128 231.698 157.562 240.1 155.67 240.1 155.67 240.1 155.67 235.448 162.918 229.624 168.492 223.801 174.066 216.805 177.967 216.805 177.967L238.43 181.78 248.464 124.873 226.839 121.06z'/%3E %3Cpath d='M27.464 179.533L27.614 211.039C27.614 211.039 80.262 193.111 132.91 193.111 185.558 193.111 238.206 211.039 238.206 211.039L238.206 179.533C238.206 179.533 185.521 161.604 132.835 161.604 80.149 161.604 27.464 179.533 27.464 179.533z'/%3E %3C/g%3E %3Cg fill='%23FFF' store-width='1.5' stroke='%23000'%3E %3Cg transform='matrix(0.661234,0,0,0.661234,21.24618,-360.3206)'%3E %3Cpath id='c3' d='M2.02 723.052A12.122 12.122 0 1 1-22.223 723.052 12.122 12.122 0 1 1 2.02 723.052z'/%3E %3C/g%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,10.96519,-378.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,8.822333,-400.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,15.25091,-420.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,28.82233,-436.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,47.39376,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,68.10805,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,88.82233,-443.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,109.5366,-440.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,242.3163,-360.3206)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,252.5973,-378.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,254.7402,-400.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,248.3116,-420.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,234.7402,-436.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,216.1687,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,195.4544,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,174.7402,-443.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(-0.661234,0,0,0.661234,154.0259,-440.8875)'/%3E %3Cg transform='translate(1.040326,0)'%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-378.3206)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-392.6019)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-404.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-414.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-447.8875)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-446.459)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-439.0304)'/%3E %3Cuse xlink:href='%23c3' transform='matrix(0.661234,0,0,0.661234,138.4742,-428.8875)'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23FFF' stroke='%23000'%3E %3Cg transform='translate(-0.457137,-2)'%3E %3Cpath id='circle1' d='M143.571 136.291A10.357 10.357 0 1 1 122.857 136.291 10.357 10.357 0 1 1 143.571 136.291z'/%3E %3C/g%3E %3Cuse xlink:href='%23circle1' transform='translate(-108.7143,16.78571)'/%3E %3Cuse xlink:href='%23circle1' transform='translate(107.2857,16.78571)'/%3E %3C/g%3E %3C/g%3E %3Crect width='34.762' height='15.153' x='134.791' y='210.096' style='fill:%23002b7f;stroke-width:0.841;stroke:%23000'/%3E %3Cpath d='M16.043 233.111A22.995 8.556 0 1 1-29.947 233.111 22.995 8.556 0 1 1 16.043 233.111z' transform='matrix(-0.678154,-6.882792e-2,2.382547e-2,0.957698,195.4766,-0.830297)' style='fill:%233e8225;stroke-width:1.5;stroke:%23000'/%3E %3Cpath d='M36.937 229.285L28.228 237.994 38.329 243.826 61.822 237.532 57.635 224.228 36.937 229.285z' style='fill:%23c00;stroke-width:1.086;stroke:%23000'/%3E %3Cpath d='M267.406 229.285L276.116 237.994 266.014 243.826 242.521 237.532 246.708 224.228 267.406 229.285z' style='fill:%23c00;stroke-width:1.086;stroke:%23000'/%3E %3Cpath d='M16.043 233.111A22.995 8.556 0 1 1-29.947 233.111 22.995 8.556 0 1 1 16.043 233.111z' transform='matrix(0.678154,-6.882792e-2,-2.382547e-2,0.957698,108.8665,-0.830297)' style='fill:%233e8225;stroke-width:1.5;stroke:%23000'/%3E %3Cg fill='%23FFF' store-width='0.7' stroke='%23000'%3E %3Cg transform='translate(1.069518,-3.475935)'%3E %3Cpath id='c2' d='M126.203 214.704A4.278 4.278 0 1 1 117.647 214.704 4.278 4.278 0 1 1 126.203 214.704z'/%3E %3C/g%3E %3Cuse xlink:href='%23c2' transform='translate(2.406416,10.16042)'/%3E %3Cuse xlink:href='%23c2' transform='translate(-52.40642,6.149728)'/%3E %3Cuse xlink:href='%23c2' transform='translate(-47.05882,18.98396)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,303.0748,-3.475943)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,301.7379,10.16041)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,356.5507,6.14972)'/%3E %3Cuse xlink:href='%23c2' transform='matrix(-1,0,0,1,351.2031,18.98395)'/%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(0,-2.600445e-4)'%3E %3Cpath d='M238.538 280.603C241.805 280.036 261.515 275.35 265.665 272.843 262.987 268.015 258.181 264.238 261.921 265.825 263.935 266.68 265.528 260.026 259.682 254.94 242.709 260.507 202.002 270.679 150.853 270.679 98.509 270.679 57.291 259.972 40.318 254.406 34.472 259.492 36.293 265.27 35.94 267.429 35.937 267.446 35.943 270.154 37.009 272.308 42.763 278.559 61.403 281.64 64.671 282.208 80.023 284.874 95.376 288.905 150.819 288.905 202.108 288.905 223.185 283.27 238.538 280.603z' style='fill:%23fff;stroke-width:1.714;stroke:%23000'/%3E %3Cg transform='matrix(1.085779,0,0,1.085779,-81.34112,-69.11104)'%3E %3Cpath d='M132.906 289.655C129.897 290.178 110.759 296.956 106.938 299.265 106.941 299.279 106.935 299.31 106.938 299.326 107.263 301.314 103.616 310.577 109 315.261 124.632 310.134 168.525 294.855 215.634 294.855 263.843 294.855 303.774 310.134 319.406 315.261 324.79 310.577 321.143 301.314 321.469 299.326 321.472 299.31 321.465 299.279 321.469 299.265 317.647 296.956 298.509 290.178 295.5 289.655 281.36 287.2 266.728 278.069 215.665 278.069 168.428 278.069 147.046 287.2 132.906 289.655z' style='fill:%23fff;stroke-width:1.578;stroke:%23000'/%3E %3Cg transform='matrix(1.384389,-0.143242,0.15642,1.267764,-86.62648,-64.7552)'%3E %3Cg id='t1' fill='%23000' store-width='1.6' stroke='%23000'%3E %3Cg transform='matrix(0.4996,0,0,0.4996,56.86367,150.9007)'%3E %3Cpath id='a1' d='M115.508 301.56A1.872 1.872 0 1 1 111.765 301.56 1.872 1.872 0 1 1 115.508 301.56z'/%3E %3C/g%3E %3Cuse xlink:href='%23a1' transform='matrix(0.4996,0,0,0.4996,55.52674,153.307)'/%3E %3Cuse xlink:href='%23a1' transform='matrix(0.4996,0,0,0.4996,57.3984,154.9114)'/%3E %3Cpath stroke-width='1' d='M113.518 303.669L122.044 300.503 117.859 302.895 120.545 302.812 118.053 303.98 122.054 304.255 113.518 303.669z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,-0.143242,0.15642,1.267764,-45.03159,-76.65847)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.378425,0.192343,-0.151629,1.268346,100.1696,-120.8592)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,0.143242,0.15642,-1.267764,54.4337,659.4577)'/%3E %3Cuse xlink:href='%23t1' transform='matrix(1.384389,0.143242,0.15642,-1.267764,96.41226,670.4203)'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 225 150' width='1350' height='900'%3E%3Crect width='225' height='150' fill='%23f93'/%3E%3Crect width='225' height='50' y='50' fill='%23fff'/%3E%3Crect width='225' height='50' y='100' fill='%23128807'/%3E%3Cg transform='translate(112.5,75)'%3E%3Ccircle r='20' fill='%23008'/%3E%3Ccircle r='17.5' fill='%23fff'/%3E%3Ccircle r='3.5' fill='%23008'/%3E%3Cg id='d'%3E%3Cg id='c'%3E%3Cg id='b'%3E%3Cg id='a'%3E%3Ccircle r='0.875' fill='%23008' transform='rotate(7.5) translate(17.5)'/%3E%3Cpath fill='%23008' d='M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z'/%3E%3C/g%3E%3Cuse xlink:href='%23a' transform='rotate(15)'/%3E%3C/g%3E%3Cuse xlink:href='%23b' transform='rotate(30)'/%3E%3C/g%3E%3Cuse xlink:href='%23c' transform='rotate(60)'/%3E%3C/g%3E%3Cuse xlink:href='%23d' transform='rotate(120)'/%3E%3Cuse xlink:href='%23d' transform='rotate(-120)'/%3E%3C/g%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Sodipodi ('http://www.sodipodi.com/') --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' version='1.1' x='0' y='0' width='600' height='300' id='svg378' sodipodi:version='0.32' sodipodi:docname='AJAX1.svg' inkscape:version='0.48.2 r9819' inkscape:export-filename='C:%5CDocuments and Settings%5CJoshua.JOSHPC%5CDesktop%5Cisleofman.png' inkscape:export-xdpi='90.000000' inkscape:export-ydpi='90.000000' inkscape:output_extension='org.inkscape.output.svg.inkscape'%3E %3Cmetadata id='metadata56'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Csodipodi:namedview id='base' showguides='true' inkscape:guide-bbox='true' inkscape:zoom='1' inkscape:cx='207.11039' inkscape:cy='66.341622' inkscape:window-width='1280' inkscape:window-height='1004' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:current-layer='svg378' inkscape:showpageshadow='false' showgrid='false' fit-margin-top='0' fit-margin-left='0' fit-margin-right='0' fit-margin-bottom='0' inkscape:window-maximized='1'%3E %3C/sodipodi:namedview%3E %3Cdefs id='defs380' /%3E %3Cpath style='fill:%23cf142b;fill-opacity:1;fill-rule:nonzero;stroke:none' d='m 0,0 600,0 0,300 -600,0 z' id='rect2489' inkscape:connector-curvature='0' sodipodi:nodetypes='ccccc' /%3E %3Cg id='g4408' transform='matrix(0.3498026,0,0,0.3498026,163.24255,23.83426)'%3E %3Cpath id='path4410' d='m 419.10237,546.46443 c 0.2907,-0.8793 0.87689,-9.94616 0.58379,-9.94616 -0.29309,0 -13.74684,-15.79373 -13.45374,-15.79373 0.2931,0 17.25683,3.80308 17.25683,3.21688 0,-0.58379 6.72687,-16.67062 6.72687,-16.96372 0,-0.2907 8.18997,19.59681 8.18997,19.59681 l 16.67062,7.31307 -11.69995,9.65066 c 0,0 2.63309,18.71992 2.63309,19.01302 0,0.2907 -11.69995,-11.11615 -11.69995,-11.11615 l -12.86994,1.46309 c 0,0 -1.7538,-5.84997 -2.33759,-6.43377 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4412' d='m 328.4794,300.67417 c -11.11375,5.72264 -53.76692,54.47804 -59.6169,62.08181 -4.901,11.03928 -14.48679,25.00474 -24.36088,33.99472 -10.53956,7.97375 -16.39675,18.86648 -14.94567,29.18021 -0.11772,12.83391 7.07763,21.57163 12.80989,30.60246 3.39226,4.12501 7.95693,6.79174 12.80988,7.11607 9.95577,1.31414 10.83988,4.37967 15.82257,6.27761 19.62805,26.7249 48.90915,46.43223 69.9979,62.04337 13.44173,7.08484 22.78967,14.16968 25.99215,18.03763 6.1743,11.78884 5.03794,23.28458 4.19228,28.93275 -5.21813,19.69052 -10.43866,39.38103 -15.65679,59.07154 -2.63309,16.08683 11.34679,12.46874 12.09875,9.25185 6.30885,-8.18996 15.72407,-2.43849 29.17781,-49.81969 6.1671,-8.30288 12.3366,-16.60576 18.5037,-24.90864 0,0 7.11847,-2.84691 7.11847,-3.55803 10.82305,-12.99488 2.58264,-20.43288 -3.56044,-22.77287 -4.507,-1.66009 -9.014,-3.32259 -13.52101,-4.98268 0,0 -15.65679,-15.6568 -16.36792,-15.6568 -7.4404,-21.64371 -43.9601,-67.8501 -52.44317,-74.28388 -5.87159,-6.11905 -8.66565,-8.72571 -14.23934,-12.12999 -8.56955,-4.09858 -11.33478,-5.43194 -16.58414,-7.52688 -4.37006,-1.7538 -1.25889,-6.5515 1.52075,-8.74494 28.92555,-15.74568 51.85457,-33.24515 79.61012,-51.03773 1.42225,-0.94897 2.84691,-1.89794 4.26916,-2.84691 -3.32019,-18.97698 -6.64278,-37.95637 -9.96297,-56.93335 -15.41895,-5.45598 -30.84031,-10.91435 -46.25926,-16.37032 -2.42648,1.66009 -4.26916,3.32259 -6.40494,4.98269 z' style='font-size:12px;fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath inkscape:export-ydpi='90.000000' inkscape:export-xdpi='90.000000' sodipodi:nodetypes='ccccc' id='path4414' d='m 367.18534,600.42835 c 0.14655,-0.58379 28.95437,-5.84997 28.95437,-5.84997 0,0 -3.36343,10.6765 -3.50998,10.6765 l -28.66128,8.62721 3.21689,-13.45374 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cs' id='path4416' d='m 292.11345,491.95755 c 5.55688,-14.77028 20.98304,-26.46543 31.34482,-29.69193' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4418' d='m 366.14988,600.68782 c 1.8595,-0.52374 10.11673,-2.9334 12.52159,-3.30818 2.56582,-0.60062 5.11963,-1.2733 7.58695,-2.06852 2.84691,-0.58139 4.62953,-1.11714 7.58695,-1.65529 2.31596,-0.8841 4.6055,-1.48952 7.08243,-2.06851 m -39.99365,26.91229 c 0.24025,-0.32193 2.20305,-2.0565 3.61329,-2.89496 1.6601,-0.52373 7.3371,-2.93339 9.48489,-3.30818 2.29194,-0.60061 4.57187,-1.2733 6.77492,-2.06851 2.5442,-0.58139 4.13462,-1.11714 6.77732,-1.65529 2.06852,-0.8841 4.11301,-1.48952 6.32326,-2.06851' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.65663357pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4420' d='m 372.6317,496.13782 c -0.13934,0 -0.27628,0 -0.41322,0 1.29492,0 0.49971,-0.10811 -1.24207,2.06852 -0.61983,1.6721 -5.92926,5.37669 -9.92694,5.37669 -1.92917,0.20661 -4.8938,0.41322 -6.82537,0.41322 -0.55016,0 -1.30934,-0.41322 -1.8619,-0.41322' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4422' d='m 372.21848,581.34806 c 0.13694,0 0.27388,0 0.41322,0 -0.55256,0 1.10273,0 1.65289,0 2.14539,0 4.29799,0.38199 6.20554,0.41322 2.06851,0 4.13702,0.5862 6.20554,0.5862 2.08773,0.2955 4.6031,0.19941 6.7629,0.50692 2.42168,0.0817 4.36526,0.55977 6.88544,0.55977 2.03247,0.0769 3.12799,0.41563 5.37909,0.41563 l -5.37909,-0.41563 c 2.03247,0.0769 3.12799,0.41563 5.37909,0.41563' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4424' d='m 358.15451,631.80921 c 0.22103,-0.32193 2.01806,-2.0565 3.30818,-2.89496 1.52076,-0.52374 6.71967,-2.9334 8.68728,-3.30818 2.09734,-0.60061 4.18507,-1.2733 6.20313,-2.06851 2.33038,-0.5814 3.78627,-1.11714 6.20554,-1.65529 1.89554,-0.88411 3.76705,-1.48953 5.78991,-2.06852' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4426' d='m 396.88928,559.91337 c -1.17,3.39707 0.34595,4.24994 0.97299,5.71544 1.09072,1.41985 3.87516,3.58446 8.27405,4.96347 1.69614,0.45646 3.00067,0.90332 4.96347,1.65529 1.29973,0.12012 1.93878,0.44445 2.89496,0.82644' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4428' d='m 233.23651,435.33412 c 0.13694,0 0.27629,0 0.41323,0 -1.29733,0 -0.51893,0.0841 1.65529,-1.6553 1.34297,-1.50153 2.46492,-2.18142 3.7214,-3.7214' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4430' d='m 260.01907,464.80021 c 0.27628,0 24.06298,-11.98824 26.60237,-14.54926 1.79944,-1.30453 3.16163,-2.68114 5.35027,-4.16345 1.40303,-0.73275 2.40966,-1.67211 3.7238,-2.48174 1.09312,-1.58321 2.52018,-2.53939 3.30818,-3.98807 1.46069,-1.26609 0.83365,-2.63789 2.01806,-4.16345 0.55978,-1.5616 1.60725,-4.19228 1.94839,-5.62174' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccc' id='path4432' d='m 333.26509,447.62267 c 0.12973,0.85527 -0.37959,3.49076 -0.34355,5.49681 -0.0817,2.32558 -3.07274,9.50892 -6.68843,11.65431' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4434' d='m 290.53024,447.35599 c 0.13934,0 3.75984,1.17721 9.81162,3.03911 7.28424,2.61867 22.43412,12.16603 23.93805,13.48017 1.53517,1.20843 4.28117,2.28713 5.33345,3.7214 1.64568,1.42225 2.85171,3.06313 4.13702,4.55025 1.51115,1.84268 2.79886,3.40187 3.72141,4.96347 4.6007,3.73101 16.97574,29.5646 17.37214,31.02289 0.69431,1.36459 1.55439,3.26493 2.06851,4.55024 0.91774,1.05708 1.53998,2.55141 2.48174,4.13703 0.86488,2.0565 1.83307,2.99346 2.89736,4.55025 1.3694,0.95137 3.21448,2.75801 4.96347,3.7214 1.8643,1.59523 3.61329,2.24389 4.96347,3.31058 1.95079,0.82885 23.75066,14.60932 24.76209,15.29883 1.99164,1.60003 8.07225,7.90167 3.80309,12.48555 -1.81145,1.54958 -3.44272,3.60128 -4.9899,4.47818 -1.57601,1.57841 -3.76945,2.28473 -5.5809,3.10156 -9.82123,2.90217 -14.82314,1.86191 -16.75472,1.86191 -0.6895,0 -1.379,0 -2.06851,0' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4436' d='m 242.38266,398.62222 c 2.79165,1.09311 1.6649,0.28589 4.17786,1.42946 1.68893,0.73995 2.80127,0.75917 4.46136,1.36459 1.761,0.56458 6.68123,1.45108 9.04524,3.82471 1.73457,1.5664 3.05832,2.89015 4.96347,4.03372 2.2535,1.55438 3.87996,2.24629 6.67402,3.41148 2.35681,0.8817 4.9923,1.8595 7.37553,1.94359 2.47693,0.14414 3.07034,0.0216 5.44636,0.0216 1.93158,0 3.86075,0 5.79232,0 l -5.79232,0 c 1.93158,0 3.86075,0 5.79232,0' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4438' d='m 241.71718,426.23362 c 6.20313,-0.41322 16.5433,1.44868 16.74991,1.44868 0.002,0 13.65074,-0.20661 13.65074,-0.20661 7.17133,-0.69191 8.75454,-3.44752 9.92694,-5.3791 2.68835,-4.13462 4.55025,-5.5833 6.61876,-8.68487 3.30818,-2.48173 7.86083,3.30818 8.06744,3.30818 11.57983,10.9624 2.27272,24.40413 1.65289,24.81735 -5.78991,5.30942 -7.03198,5.65298 -10.54677,2.27513 -3.5172,-4.13703 -4.55025,-5.99653 -7.44521,-7.44521 -5.5833,-2.68835 -17.16553,-0.61983 -17.37455,-0.61983 -0.20661,0 -5.99652,2.27512 -5.99652,2.27512 -2.82769,1.03306 -4.61992,3.51719 -9.51372,4.34124 -4.96347,0.34595 -6.61876,-0.13694 -9.10049,-4.13463 -3.30818,-5.17008 -1.6553,-11.37562 3.31058,-11.99545 z' style='font-size:12px;fill:%23ffe606;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245399pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4440' d='m 565.56641,175.3593 c -0.90893,0.17754 -9.09957,4.11011 -8.95592,4.36559 0.14364,0.25549 -7.02986,19.72306 -7.1735,19.46758 -0.14365,-0.25549 -5.14228,-16.90618 -5.65326,-16.61889 -0.50888,0.28611 -17.8281,2.3064 -18.08358,2.45004 -0.2534,0.14247 13.06825,-16.74311 13.06825,-16.74311 l -1.79543,-18.11539 14.14621,5.46889 c 0,0 15.02723,-11.46956 15.28272,-11.61321 0.25339,-0.14247 -3.95568,15.64642 -3.95568,15.64642 l 7.58272,10.50136 c 0,0 -4.23976,4.39573 -4.46253,5.19072 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4442' d='m 395.73044,374.8114 c 10.43497,6.88298 73.83751,20.16833 83.33251,21.5411 12.02457,-1.13811 28.89576,0.3733 41.57125,4.57443 12.1158,5.27925 24.48123,5.04643 32.76029,-1.27306 11.24468,-6.1871 15.33479,-16.74134 20.39743,-26.16388 1.93317,-4.97857 2.0206,-10.26439 -0.0751,-14.65354 -3.73368,-9.32223 -1.49482,-11.59526 -2.28239,-16.86869 13.67598,-30.20677 16.50408,-65.38866 19.77662,-91.42198 -0.41193,-15.18899 1.18244,-26.80954 2.98454,-31.49668 7.25009,-11.15953 17.82755,-15.8029 23.16536,-17.83384 19.72104,-5.10154 39.44326,-10.20098 59.1643,-15.30251 15.31292,-5.58873 5.30778,-16.00146 2.13517,-15.08038 -10.23086,-1.48547 -9.83171,-12.51119 -57.72617,-1.01762 -10.25981,-1.30658 -20.5208,-2.61525 -30.78062,-3.92183 0,0 -5.97024,-4.80976 -6.59011,-4.46124 -16.63152,-3.06558 -19.07652,7.76264 -18.10559,14.2642 0.76175,4.74223 1.52142,9.48564 2.28317,14.22787 0,0 -5.97444,21.3208 -5.62593,21.94067 -15.21982,17.09288 -37.87596,71.98059 -39.32668,82.52817 -0.6867,9.9113 -4.42988,8.12142 -3.42621,17.75484 0.0376,7.52791 -0.83827,2.8278 1.67498,18.33746 0.61297,4.66878 -5.0938,4.30813 -8.36803,2.96016 -27.90111,-17.49692 -54.39214,-28.90732 -83.50407,-44.38123 -1.52422,-0.77467 -3.04962,-1.55143 -4.57384,-2.32609 -14.91456,12.19448 -29.83005,24.39223 -44.74461,36.58671 2.80078,16.1142 5.60064,32.23167 8.40142,48.34588 2.63625,1.30151 4.98848,2.09296 7.48226,3.14108 z' style='font-size:12px;fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:3.71638179;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4444' d='m 638.04917,194.1671 c -0.5807,0.15836 -19.28941,-22.37181 -19.28941,-22.37181 0,0 10.95481,-2.30058 11.02663,-2.17284 l 21.56661,20.75523 -13.30383,3.78942 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke-width:1pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cs' id='path4446' d='m 580.28966,312.76536 c -15.59823,2.39492 -33.35273,-5.32004 -41.24335,-12.77088' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4448' d='m 638.7828,194.94252 c -1.36784,-1.36421 -7.51503,-7.38089 -9.02031,-9.29346 -1.78101,-1.94221 -3.61896,-3.83863 -5.52133,-5.5996 -1.90201,-2.19665 -3.24265,-3.48795 -5.16113,-5.80212 -1.90567,-1.58548 -3.55547,-3.28451 -5.27407,-5.15983 m 43.05908,21.67211 c -0.39836,-0.0516 -2.87229,-0.91248 -4.29429,-1.73083 -1.27011,-1.19039 -6.15277,-4.95794 -7.53206,-6.64645 -1.64679,-1.70347 -3.35051,-3.36115 -5.12336,-4.89177 -1.75367,-1.93278 -3.00011,-3.05655 -4.76435,-5.09639 -1.7844,-1.36978 -3.3141,-2.8552 -4.90201,-4.49807' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.65663414pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4450' d='m 544.47263,240.53096 c 0.0683,0.12146 0.1354,0.24083 0.20251,0.3602 -0.63462,-1.12875 -0.33914,-0.3826 2.41179,0.0689 1.76131,-0.27918 7.59257,2.53334 9.55178,6.01802 1.12556,1.58035 2.75858,4.06328 3.70521,5.74699 0.26963,0.47956 0.2815,1.34383 0.5523,1.82548' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4452' d='m 618.9507,199.13082 c -0.0671,-0.11937 -0.13422,-0.23874 -0.20251,-0.3602 0.2708,0.48166 -0.54043,-0.96122 -0.81006,-1.44078 -1.05143,-1.87008 -1.77341,-3.93366 -2.68105,-5.61172 -1.01375,-1.80307 -1.51653,-3.89343 -2.53028,-5.6965 -0.76558,-1.96465 -2.0821,-4.11013 -2.87253,-6.14349 -1.11563,-2.15094 -1.65142,-4.07942 -2.88652,-6.27619 -0.92908,-1.80934 -1.1707,-2.93029 -2.27393,-4.89251 l 2.27393,4.89251 c -0.92908,-1.80934 -1.1707,-2.93029 -2.27393,-4.89251' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4454' d='m 669.82893,186.65972 c -0.38894,-0.0349 -2.78162,-0.75123 -4.14475,-1.46488 -1.20183,-1.06893 -5.85018,-4.41974 -7.14117,-5.95118 -1.55142,-1.53385 -3.16095,-3.024 -4.84314,-4.39337 -1.64887,-1.7464 -2.82938,-2.7529 -4.48412,-4.59797 -1.69963,-1.21901 -3.14455,-2.55365 -4.64062,-4.03318' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4456' d='m 588.17582,188.13075 c 3.53454,-0.645 3.53502,-2.38439 4.50515,-3.64919 0.7031,-1.6466 1.22532,-5.13457 0.27153,-9.64481 -0.43336,-1.70218 -0.68318,-3.05831 -0.98965,-5.13776 -0.53227,-1.19181 -0.56275,-1.90781 -0.69839,-2.92849' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4458' d='m 559.78723,391.83724 c -0.0671,-0.11936 -0.1354,-0.24082 -0.20251,-0.36019 0.6358,1.13084 0.32761,0.41113 -2.25411,-0.63164 -1.96702,-0.43476 -3.10952,-1.07952 -5.06766,-1.42005' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4460' d='m 572.34631,354.05065 c -0.1354,-0.24083 -22.24277,-15.09982 -25.71966,-16.05822 -2.01901,-0.9292 -3.88655,-1.44193 -6.25127,-2.62324 -1.32632,-0.86388 -2.63847,-1.28097 -3.98824,-2.02969 -1.91577,-0.17692 -3.44863,-0.95225 -5.0976,-0.92915 -1.81948,-0.65276 -2.70794,0.56612 -4.61819,0.28136 -1.63554,0.27737 -4.442,0.65358 -5.85521,1.05677' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccc' id='path4462' d='m 521.47624,298.62243 c 0.68194,-0.53224 3.22885,-1.37989 4.9598,-2.39444 2.06718,-1.06853 9.79458,-1.98176 13.43667,0.11852' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4464' d='m 542.18754,336.00401 c -0.0683,-0.12146 -0.8165,-3.85429 -2.15943,-10.04196 -1.28727,-7.63287 -0.38983,-25.51765 0.0186,-27.47264 0.30099,-1.9304 -0.10451,-4.85268 0.63,-6.47283 0.43321,-2.13153 1.27246,-3.98697 1.93883,-5.83616 0.86563,-2.2203 1.59365,-4.1069 2.50272,-5.67637 0.99749,-5.83883 17.45113,-29.28652 18.52801,-30.34674 0.84921,-1.27398 2.08417,-2.95502 2.95258,-4.03309 0.47166,-1.31802 1.46928,-2.59276 2.38988,-4.19076 1.36873,-1.76176 1.71095,-3.06489 2.54638,-4.75557 0.15816,-1.65992 0.82872,-4.15365 0.81132,-6.15033 0.47685,-2.40687 0.18512,-4.24932 0.45322,-5.949 -0.23357,-2.10667 1.0947,-27.86267 1.20004,-29.08223 0.41863,-2.52021 2.93159,-10.90887 9.01949,-9.43405 2.2385,0.81957 4.82637,1.23599 6.34899,2.15488 2.14824,0.60021 3.8389,2.16602 5.43868,3.34469 7.34299,7.13861 8.88758,12.00846 9.83422,13.69217 0.33792,0.60102 0.67583,1.20204 1.01375,1.80307' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath id='path4466' d='m 523.19361,401.02311 c -0.0671,-0.11937 -0.13541,-0.24083 -0.20252,-0.3602 0.5475,0.97378 0.24424,0.48833 -0.45104,-1.64539 -0.18272,-1.83483 -0.74862,-4.3169 -1.03448,-6.06067 -0.37092,-1.81171 -1.21985,-3.87557 -0.98966,-5.13776 -0.64874,-1.84017 -0.24065,-3.35949 -0.0667,-5.1826 0.5153,-2.27965 0.74819,-3.92922 0.81133,-6.15034 0.25051,-2.7261 0.0491,-4.65792 0.20469,-7.23419 -0.71831,-2.12077 -0.86479,-3.89605 -1.95948,-6.01466 -0.97405,-2.02659 -1.71911,-3.9008 -2.88357,-5.97192 -0.94664,-1.6837 -1.8921,-3.36531 -2.83873,-5.04902 l 2.83873,5.04902 c -0.94664,-1.6837 -1.8921,-3.36531 -2.83873,-5.04902' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4468' d='m 547.69831,388.90489 c -3.40026,-5.2046 -6.84486,-15.13035 -6.94612,-15.31045 -0.001,-0.002 -6.87013,-11.79774 -6.87013,-11.79774 -4.11769,-5.91197 -7.2956,-5.94153 -9.55387,-6.01685 -4.92157,-0.31704 -7.09684,-1.23003 -10.81414,-1.51307 -3.78456,-1.66739 -0.96883,-8.47338 -1.07009,-8.65347 3.88053,-15.46636 20.15862,-13.9412 20.82259,-13.60342 7.46564,2.44485 8.37382,3.35916 7.15199,8.07835 -1.88241,5.09334 -2.99701,6.90515 -2.841,10.13858 0.39293,6.18435 7.87229,15.26653 7.97473,15.44873 0.10125,0.18009 4.92197,4.11201 4.92197,4.11201 2.2863,1.95854 5.33001,2.30334 8.44669,6.16529 2.73408,4.15698 3.12439,5.83651 0.85598,9.95899 -2.88534,5.41744 -9.1046,7.0179 -12.0786,2.99305 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40245457pt' inkscape:connector-curvature='0' /%3E %3Cg transform='matrix(-1.107009,2.132209,-2.132209,-1.10701,906.73765,-15.62964)' id='g4470'%3E %3Cpath id='path4472' d='m 238.862,224.504 c 0.121,-0.366 0.365,-4.14 0.243,-4.14 -0.122,0 -5.722,-6.574 -5.6,-6.574 0.122,0 7.183,1.583 7.183,1.339 0,-0.243 2.8,-6.939 2.8,-7.061 0,-0.121 3.409,8.157 3.409,8.157 l 6.939,3.044 -4.87,4.017 c 0,0 1.096,7.792 1.096,7.914 0,0.121 -4.87,-4.627 -4.87,-4.627 l -5.357,0.609 c 0,0 -0.73,-2.435 -0.973,-2.678 z' style='fill:%23f9dd16;fill-opacity:0.98823499;fill-rule:evenodd;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccccccccccccccccccc' id='path4474' d='m 201.141,122.196 c -4.626,2.382 -22.38,22.676 -24.815,25.841 -2.04,4.595 -6.03,10.408 -10.14,14.15 -4.387,3.319 -6.825,7.853 -6.221,12.146 -0.049,5.342 2.946,8.979 5.332,12.738 1.412,1.717 3.312,2.827 5.332,2.962 4.144,0.547 4.512,1.823 6.586,2.613 8.17,11.124 20.358,19.327 29.136,25.825 5.595,2.949 9.486,5.898 10.819,7.508 2.57,4.907 2.097,9.692 1.745,12.043 -2.172,8.196 -4.345,16.392 -6.517,24.588 -1.096,6.696 4.723,5.19 5.036,3.851 2.626,-3.409 6.545,-1.015 12.145,-20.737 2.567,-3.456 5.135,-6.912 7.702,-10.368 0,0 2.963,-1.185 2.963,-1.481 4.505,-5.409 1.075,-8.505 -1.482,-9.479 -1.876,-0.691 -3.752,-1.383 -5.628,-2.074 0,0 -6.517,-6.517 -6.813,-6.517 -3.097,-9.009 -18.39,-28.426 -21.921,-31.104 -3.456,-2.271 -2.043,-3.264 -5.743,-4.865 -2.739,-1.522 -0.855,-0.881 -6.995,-3.133 -1.819,-0.73 -0.524,-2.727 0.633,-3.64 12.04,-6.554 21.584,-13.838 33.137,-21.244 0.592,-0.395 1.185,-0.79 1.777,-1.185 -1.382,-7.899 -2.765,-15.799 -4.147,-23.698 -6.418,-2.271 -12.837,-4.543 -19.255,-6.814 -1.01,0.691 -1.777,1.383 -2.666,2.074 z' style='fill:%23ffffff;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.54691064;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4476' d='m 217.252,246.966 c 0.061,-0.243 12.052,-2.435 12.052,-2.435 0,0 -1.4,4.444 -1.461,4.444 l -11.93,3.591 1.339,-5.6 z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:none' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cs' id='path4478' d='m 186.004,201.816 c 2.313,-6.148 8.734,-11.016 13.047,-12.359' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccccccc' id='path4480' d='m 216.821,247.074 c 0.774,-0.218 4.211,-1.221 5.212,-1.377 1.068,-0.25 2.131,-0.53 3.158,-0.861 1.185,-0.242 1.927,-0.465 3.158,-0.689 0.964,-0.368 1.917,-0.62 2.948,-0.861 m -16.647,11.202 c 0.1,-0.134 0.917,-0.856 1.504,-1.205 0.691,-0.218 3.054,-1.221 3.948,-1.377 0.954,-0.25 1.903,-0.53 2.82,-0.861 1.059,-0.242 1.721,-0.465 2.821,-0.689 0.861,-0.368 1.712,-0.62 2.632,-0.861' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:1.10579996pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4482' d='m 219.519,203.556 c -0.058,0 -0.115,0 -0.172,0 0.539,0 0.208,-0.045 -0.517,0.861 -0.258,0.696 -2.468,2.238 -4.132,2.238 -0.803,0.086 -2.037,0.172 -2.841,0.172 -0.229,0 -0.545,-0.172 -0.775,-0.172' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4484' d='m 219.347,239.024 c 0.057,0 0.114,0 0.172,0 -0.23,0 0.459,0 0.688,0 0.893,0 1.789,0.159 2.583,0.172 0.861,0 1.722,0.244 2.583,0.244 0.869,0.123 1.916,0.083 2.815,0.211 1.008,0.034 1.817,0.233 2.866,0.233 0.846,0.032 1.302,0.173 2.239,0.173 l -2.239,-0.173 c 0.846,0.032 1.302,0.173 2.239,0.173' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccc' id='path4486' d='m 213.493,260.028 c 0.092,-0.134 0.84,-0.856 1.377,-1.205 0.633,-0.218 2.797,-1.221 3.616,-1.377 0.873,-0.25 1.742,-0.53 2.582,-0.861 0.97,-0.242 1.576,-0.465 2.583,-0.689 0.789,-0.368 1.568,-0.62 2.41,-0.861' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccc' id='path4488' d='m 229.616,230.102 c -0.487,1.414 0.144,1.769 0.405,2.379 0.454,0.591 1.613,1.492 3.444,2.066 0.706,0.19 1.249,0.376 2.066,0.689 0.541,0.05 0.807,0.185 1.205,0.344' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath id='path4490' d='m 161.497,178.247 c 0.057,0 0.115,0 0.172,0 -0.54,0 -0.216,0.035 0.689,-0.689 0.559,-0.625 1.026,-0.908 1.549,-1.549' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4492' d='m 172.645,190.512 c 0.115,0 10.016,-4.99 11.073,-6.056 0.749,-0.543 1.316,-1.116 2.227,-1.733 0.584,-0.305 1.003,-0.696 1.55,-1.033 0.455,-0.659 1.049,-1.057 1.377,-1.66 0.608,-0.527 0.347,-1.098 0.84,-1.733 0.233,-0.65 0.669,-1.745 0.811,-2.34' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccc' id='path4494' d='m 203.133,183.362 c 0.054,0.356 -0.158,1.453 -0.143,2.288 -0.034,0.968 -1.279,3.958 -2.784,4.851' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccccccc' id='path4496' d='m 185.345,183.251 c 0.058,0 1.565,0.49 4.084,1.265 3.032,1.09 9.338,5.064 9.964,5.611 0.639,0.503 1.782,0.952 2.22,1.549 0.685,0.592 1.187,1.275 1.722,1.894 0.629,0.767 1.165,1.416 1.549,2.066 1.915,1.553 7.066,12.306 7.231,12.913 0.289,0.568 0.647,1.359 0.861,1.894 0.382,0.44 0.641,1.062 1.033,1.722 0.36,0.856 0.763,1.246 1.206,1.894 0.57,0.396 1.338,1.148 2.066,1.549 0.776,0.664 1.504,0.934 2.066,1.378 0.812,0.345 9.886,6.081 10.307,6.368 0.829,0.666 3.36,3.289 1.583,5.197 -0.754,0.645 -1.433,1.499 -2.077,1.864 -0.656,0.657 -1.569,0.951 -2.323,1.291 -4.088,1.208 -6.17,0.775 -6.974,0.775 -0.287,0 -0.574,0 -0.861,0' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath id='path4498' d='m 165.629,163.096 c 0.057,0 0.115,0 0.172,0 -0.465,0 -0.227,-0.011 0.689,0.172 0.703,0.308 1.719,0.609 2.41,0.861 0.733,0.235 1.655,0.348 2.066,0.689 0.8,0.14 1.268,0.598 1.894,1.033 0.722,0.652 1.273,1.073 2.066,1.549 0.938,0.647 1.68,0.968 2.583,1.55 0.916,0.172 1.59,0.481 2.582,0.516 0.934,0.06 1.766,0.172 2.755,0.172 0.804,0 1.607,0 2.411,0 l -2.411,0 c 0.804,0 1.607,0 2.411,0' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath id='path4500' d='m 221.241,142.952 c -0.115,0 -0.23,0 -0.345,0 0.637,0 0.458,-0.023 -0.516,0.172 -1.017,0.525 -2.371,0.922 -3.272,1.377 -1.028,0.34 -2.133,0.717 -3.099,1.206 -1.094,0.641 -2.102,1.162 -3.099,1.893 -0.991,0.531 -1.965,1.185 -2.927,1.722 -0.959,0.521 -1.751,1.024 -2.582,1.722 -0.694,0.385 -1.637,0.93 -2.411,1.549 -0.727,0.261 -1.252,0.779 -1.721,1.206 -0.911,0.807 -1.469,1.226 -2.411,2.066 -0.495,0.468 -1.153,1.018 -1.894,1.721 -0.778,0.519 -1.62,1.517 -2.238,2.066 -0.396,0.517 -0.976,1.132 -1.549,1.55 -0.441,0.555 -0.952,1.285 -1.55,1.722 -0.355,0.528 -0.976,1.216 -1.55,1.894 -0.465,0.569 -1.105,1.142 -1.549,1.721 -0.598,0.662 -1.056,1.329 -1.722,1.894 -0.119,0.398 -0.369,0.604 -0.516,0.861' style='fill:none;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='cccccccccccccc' id='path4502' d='m 165.027,174.459 c 2.582,-0.172 6.886,0.603 6.972,0.603 0.001,0 5.682,-0.086 5.682,-0.086 2.985,-0.288 3.644,-1.435 4.132,-2.239 1.119,-1.721 1.894,-2.324 2.755,-3.615 1.377,-1.033 3.272,1.377 3.358,1.377 4.82,4.563 0.946,10.158 0.688,10.33 -2.41,2.21 -2.927,2.353 -4.39,0.947 -1.464,-1.722 -1.894,-2.496 -3.099,-3.099 -2.324,-1.119 -7.145,-0.258 -7.232,-0.258 -0.086,0 -2.496,0.947 -2.496,0.947 -1.177,0.43 -1.923,1.464 -3.96,1.807 -2.066,0.144 -2.755,-0.057 -3.788,-1.721 -1.377,-2.152 -0.689,-4.735 1.378,-4.993 z' style='fill:%23f9dd16;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1pt;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1' inkscape:connector-curvature='0' /%3E %3C/g%3E %3Cpath sodipodi:nodetypes='cccccccccc' id='path4504' d='m 332.30165,290.148 c -2.276,-2.067 42.811,16.337 49.014,16.546 8.481,-3.102 43.433,-32.676 43.433,-32.676 0.345,2.895 1.584,10.409 4.961,11.996 -13.51,10.962 -25.782,21.508 -39.293,32.468 0.966,17.373 -2.205,35.78 6.618,55.221 0,0 -10.546,0.205 -10.546,0 -9.307,-9.307 -12.618,-54.185 -12.618,-54.185 -14.821,-6.619 -29.644,-13.029 -44.465,-19.648 2.138,-1.38 3.861,-5.652 2.896,-9.722 z' style='font-size:12px;fill:%23f9dd16;fill-opacity:0.98742095;fill-rule:evenodd;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4506' d='m 375.19865,336.153 c 0.721,-0.523 -8.133,4.113 -10.407,5.277 -40.961,21.85 -62.04,53.634 -63.354,54.835 -0.708,1.354 -2.011,3.16 -3.204,4.929 -0.96,1.483 -2.338,3.018 -3.246,4.518 -1.255,1.738 -3.893,5.17 -5.334,6.694 -0.18,0.982 0.683,-0.336 0.401,0.317' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0' /%3E %3Cpath sodipodi:nodetypes='ccccccc' id='path4508' d='m 403.18665,310.185 c -0.795,-0.402 7.378,5.351 9.453,6.84 38.166,26.431 76.072,30.638 77.741,31.257 1.528,0.01 3.73,0.343 5.848,0.595 1.759,0.175 3.753,0.698 5.503,0.82 2.119,0.32 6.378,1.096 8.393,1.681 0.954,-0.29 -0.611,-0.453 0.098,-0.502' style='font-size:12px;fill:none;stroke:%23000000;stroke-width:2.40244999pt' inkscape:connector-curvature='0' /%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' width='660' height='480' viewBox='0 0 220 160'%3E %3Cdesc%3EFlag of Israel%3C/desc%3E %3Cdefs%3E %3C!-- Specs are taken from 'The Provisional Council of State Proclamation of the Flag of the State of Israel,' 25 Tishrei 5709 (28 October 1948) For Magen David, the 'Israel Science and Technology Homepage' at http://www.science.co.il/Israel-flag.asp specifies each side as 60 cm. Outer radius is then 30 / cos(30) = 20 * sqrt(3) For equilateral triangles, middle radius = outer radius - width: 20 * sqrt(3) - 5.5 Coordinates for upward-pointing triangle relative to center are then: ( 0,-(20*sqrt(3) - 5.5) ) (-(20*sqrt(3) - 5.5) * cos(30), (20*sqrt(3) - 5.5) * sin(30)) ( (20*sqrt(3) - 5.5) * cos(30), (20*sqrt(3) - 5.5) * sin(30)) --%3E %3Cpolygon id='triangle' points='0,-29.1410161513775421 -25.2368602791855814, 14.5705080756887710 25.2368602791855814, 14.5705080756887710' stroke='%230038b8' stroke-width='5.5' fill-opacity='0'/%3E %3C/defs%3E %3C!-- 'The flag is 220 cm long and 160 cm wide. The background is white' --%3E %3Crect width='220' height='160' fill='white'/%3E %3C!-- '...two stripes of dark sky-blue, 25 cm broad, over the whole length of the flag, at a distance of 15 cm from the top and from the bottom...' Legislation does not specify exact shade of blue; '%230038b8' is typical of flags used in Israel --%3E %3Crect width='220' height='25' fill='%230038b8' y='15'/%3E %3Crect width='220' height='25' fill='%230038b8' y='120'/%3E %3Cuse xlink:href='%23triangle' transform='translate(110,80)'/%3E %3Cuse xlink:href='%23triangle' transform='translate(110,80) rotate(180)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Inkscape (http://www.inkscape.org/) --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' width='600' height='300' viewBox='0 0 600 300' id='svg2' version='1.1' inkscape:version='0.91 r13725' sodipodi:docname='Ireland.svg'%3E %3Cdefs id='defs4' /%3E %3Csodipodi:namedview id='base' pagecolor='%23ffffff' bordercolor='%23666666' borderopacity='1.0' inkscape:pageopacity='0.0' inkscape:pageshadow='2' inkscape:zoom='1.348785' inkscape:cx='187.47867' inkscape:cy='143.80555' inkscape:document-units='px' inkscape:current-layer='layer1' showgrid='false' units='px' inkscape:window-width='1440' inkscape:window-height='837' inkscape:window-x='-8' inkscape:window-y='-8' inkscape:window-maximized='1' /%3E %3Cmetadata id='metadata7'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3E%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cg inkscape:label='Layer 1' inkscape:groupmode='layer' id='layer1' transform='translate(0,-752.36216)'%3E %3Crect style='fill:%23169b62;fill-opacity:1;stroke:none' id='rect4148' width='200' height='300' x='0' y='752.36218' /%3E %3Crect style='fill:%23ffffff;fill-opacity:1;stroke:none' id='rect4150' width='200' height='300' x='200' y='752.36212' /%3E %3Crect style='fill:%23ff883e;fill-opacity:1;stroke:none' id='rect4152' width='200' height='300' x='400' y='752.36218' /%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 3 2'%3E %3Crect fill='%23FFF' width='3' height='2'/%3E %3Crect fill='%23CE1126' width='3' height='1'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 6 3'%3E %3Crect fill='%23436F4D' width='6' height='3'/%3E %3Crect fill='%23FFF' width='6' height='2'/%3E %3Crect fill='%23CD2A3E' width='6' height='1'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='300'%3E %3Ctitle%3EFlag of Haiti%3C/title%3E %3Crect width='500' height='300' fill='%23d21034'/%3E %3Crect width='500' height='150' fill='%2300209f'/%3E %3Cg id='coa' fill='%23f1b517' stroke='%23000' stroke-width='0.1826'%3E %3Crect fill='%23fff' stroke='none' width='94.6416' height='75.3413' x='202.679' y='112.284'/%3E %3Cpath fill='%23016a16' stroke='%23016a16' d='m269.047,166.766-19.3141,0.56058-19.227,0.21862s-9.8781,3.65352-13.9162,4.4734c-4.02618,0.81746-3.50263,2.14025-6.61818,2.83651-2.49547,0.55768-2.78328,0.73353-4.24748,0.82965-0.88604,0.0582-1.97735,0.73987-3.04471,1.49113v10.4491h94.6416v-9.939c-1.02588-0.55902-2.0035-0.94359-3.00404-1.28372-1.39031-0.47263-2.32725-0.9895-4.82272-1.54718-3.11555-0.69626-2.592-2.01905-6.61818-2.83651-4.03807-0.81988-13.829-5.2526-13.829-5.2526z'/%3E %3Cg id='flags'%3E %3Cg id='flags_half'%3E %3Cg%3E %3Cpath d='m244.529,143.512,1.39696-0.0329,2.55541,10.749-0.54516,3.38576-3.40721-14.1018z'/%3E %3Cpath fill='%23fff' d='m243.064,136.346,0.95402,8.2836,1.02216-0.0657-1.97618-8.21786z'/%3E %3Cpath d='m245.722,154.589-4.29308-11.5379,1.60139-0.0986,5.0086,14.1018-2.31691-2.46536z'/%3E %3Cpath fill='%23fff' d='m239.419,136.477,1.77175,8.02063,1.43103,0-3.20278-8.02063z'/%3E %3Cpath d='m241.906,150.546-2.52134-5.42379,1.09031-0.2301,4.59973,9.00677-3.1687-3.35288z'/%3E %3Cpath fill='%23fff' d='m236.08,138.778,2.79391,7.62618,1.43103,0-4.22494-7.62618z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m242.249,151.364-11.4356-12.4841c-3.57164,2.82814-2.90807,8.02116-2.90807,8.02116l12.957,10.1661,1.38665-5.70318z'/%3E %3Cpath fill='%23d20014' d='m248.861,158.235-8.4834-8.59356c-3.5866,0.12446-0.74067,5.47902-0.56005,6.15114l9.04345,7.73433v-5.29191z'/%3E %3Cpath d='m248.139,156.757-17.5394-18.7806-0.6845,0.48355,18.5612,20.6216-0.3373-2.32459z'/%3E %3Cpath d='m229.586,136.772-0.38503-0.44575,0.0385-0.89151-3.61925-2.30304,1.61711,3.6403,1.23209,0.22287,0.38503,0.44575,0.73155-0.66862z'/%3E %3Cpath d='m227.738,138.11c0.61604-0.74292,1.34759-1.48584,2.65668-2.19161l1.00107,1.44869-2.15615,1.82015-1.5016-1.07723z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m225.811,141.278s0.5879,1.02632,0.5879,1.02632c0.36393-0.13504,4.03128-3.45709,4.03128-3.45709l2.63154-0.081,0.75587-0.83726c-1.93166-2.07966-3.75134,0.29709-3.75134,0.29709l-4.25525,3.05196z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m227.911,143.007c0.13998-0.91829,1.87567-3.21402,2.12762-3.29504,1.30317,0.39117,2.51537,1.14116,3.83533-1.83658-1.1478,1.45846-3.47139-0.027-3.47139-0.027l-1.00782,0.83726,0.028,0.40513-3.05146,2.8359,1.53973,1.08034z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m237.252,154.672-14.367-11.4113c-2.45972,2.50307-0.41467,10.2317-0.41467,10.2317l14.0422,7.6072,0.73945-6.42753z'/%3E %3Cpath fill='%23d20014' d='m249.166,163.917-11.8183-9.46696c-4.03608,0.56639-0.86322,6.50618-0.62257,7.16056l12.481,6.76847-0.0402-4.46207z'/%3E %3Cpath d='m248.697,162.005-25.5539-19.1816-0.58707,0.59088,26.8371,20.9549-0.69613-2.36409z'/%3E %3Cpath d='m221.928,141.807-0.45941-0.37447-0.12254-0.88441-3.97879-1.66173,2.24776,3.31408,1.25348,0.0131,0.45941,0.37447,0.60009-0.78102z'/%3E %3Cpath d='m220.349,143.433c0.47297-0.83483,1.05969-1.68902,2.22186-2.60338l1.24661,1.25897-1.79578,2.15371-1.67269-0.8093z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m218.925,146.641s0.15919,1.06,0.15919,1.06c0.33756-0.1883,3.56107-3.72584,3.56107-3.72584l2.58599-0.47719,0.52682-0.83299c-1.79717-2.11364-3.71297,0.69754-3.71297,0.69754l-3.1201,3.27848z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m220.971,148.545c-0.12263-0.98212,1.21945-3.86265,1.45516-3.9807,1.54652,0.45977,2.8934,1.15261,3.46231-2.0687-0.89718,1.61373-3.46102,0.36219-3.46102,0.36219l-0.85966,0.97906,0.12134,0.53096-2.61004,3.36954,1.89191,0.80765z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230a328c' d='m236.224,161.651c-0.19061-0.046-18.5172-10.4422-18.5172-10.4422-1.33424,2.25264-0.12758,5.52064,0.45732,6.02891,0.0339,1.4999-0.60253,2.30652,0.7066,5.43903,0.38609,2.03671,1.32844,3.91312,2.70015,5.02765,1.67114,6.41674,8.22234,6.84773,10.7458,1.62404l3.90743-7.67738z'/%3E %3Cpath fill='%23d20014' d='m248.352,168.512-12.5481-7.35467c-4.03608,0.56638,0.0855,8.05519,0.32619,8.70957l12.1161,4.30413,0.10579-5.65903z'/%3E %3Cpath d='m246.243,165.846-28.3496-15.0889-0.48403,0.67221,29.9045,16.6466-1.07089-2.22992z'/%3E %3Cpath d='m216.528,149.937-0.51447-0.30053-0.26444-0.85502-4.19926-1.04078,2.75747,2.93404,1.24017-0.17626,0.51447,0.30053,0.46606-0.86198z'/%3E %3Cpath d='m215.232,151.782c0.33178-0.89594,0.77277-1.82816,1.77237-2.90666l1.4354,1.05533-1.42445,2.39822-1.78332-0.54689z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m214.1,155.181s0.59329,1.16676,0.59329,1.16676c0.3071-0.2318,3.00342-4.57817,3.00342-4.57817l2.492-0.81976,0.4691-1.01389c-2.00158-1.84905-3.49738,1.34225-3.49738,1.34225l-3.06043,3.90281z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m216.772,156.836c-0.20042-0.99867,0.48376-4.19683,0.70015-4.34538,1.56074,0.46564,2.86327,0.59786,3.22314-2.62209-0.90761,1.52943-3.32789,0.95334-3.32789,0.95334l-0.71005,1.08496,0.14955,0.37953-2.05871,3.95082,2.02381,0.59882z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23flags_half' transform='matrix(-1,0,0,1,499.85852,0)'/%3E %3C/g%3E %3Cg id='tree'%3E %3Cpath fill='%23016a16' stroke='%23016a16' d='m248.757,125.603-0.46484,9.07011,2.89945,0-0.42417-8.99163,3.02233-0.42447-0.33476-3.58228-7.51056,0.28993,0.042,3.25311,2.77054,0.38523z'/%3E %3Cg id='tree_half' fill='%23016a16'%3E %3Cpath d='m249.817,121.898c-7.76384-7.77113-13.8779-3.97919-15.3336-2.90247,0.96228,0.18793,1.82599-0.41145,2.27298-0.48045-0.28013,0.35359-0.86579,1.22948-0.86579,1.22948s2.40063-1.13341,2.66882-1.02991c-0.34602,0.27599-0.72786,0.93628-0.72786,0.93628,0.1788,0.069,1.52885-1.05714,1.79539-1.07672-0.41123,0.46573-0.53888,1.52761-0.53888,1.52761l1.16969-0.54452c0.30396,0.21562-0.0845,0.63021,0.1798,0.60852,1.94414-0.15959,4.67774,1.77726,5.05322,2.37237'/%3E %3Cpath d='m247.895,123.321c-0.80914-1.85399-15.5878-5.00514-18.5596,0.24395,1.16313,0.29273,2.2757-0.97579,2.2757-0.97579l-0.10114,1.17094,1.97228-1.51246-0.708,1.56125,1.56771-1.26852-0.0506,1.26852,1.92171-2.09793-0.25285,1.21973,1.71942-0.73184-0.20229,1.02457'/%3E %3Cpath d='m247.238,123.614c-3.79284-2.53704-9.6591-0.82942-9.6591-0.82942-3.74227,2.09793-5.73699,1.71946-6.22027,5.61075,0.354-0.14637,1.36543-1.3661,1.36543-1.3661l0.75857,1.51247,0.25285-2.14673,0.60686,1.65883,0.91028-2.73219,0.20228,1.85399,1.416-1.85399,0.65742,0.53668,0.60686-1.41488,0.55628,0.92699s0.96085-0.58547,1.51714-0.24394l1.06199-1.21973,0.25286,0.8782,0.91028-1.07336,0.354,0.78063,0.91028-0.82942-0.0506,0.58547,3.13541,0.0488'/%3E %3Cpath d='m246.38,124.053c-2.64328-0.0494-10.2265,2.81155-12.1877,5.8059,0.78094-0.43617,1.26251-0.63483,1.26251-0.63483l0.38693,1.20328,0.47279-1.20328,0.10114,0.927c0.28991-0.72391,0.61743-0.80561,1.16314-0.0488,0,0,0.20228-1.12215,0.20228-1.12215l0.30343,1.07336,0.50571-1.17094s0.31812,1.26908,0.50571,1.21973c0,0,0.83854-2.19438,1.21371-2.29309l0.10114,1.36609,0.50571-1.36609,0.45515,1.02457,0.10114-1.46367,0.50571,1.12215s0.2652-1.10343,0.65743-1.31731l0.75856,0.68305,3.37743-2.42674'/%3E %3Cpath d='m246.888,124.678c-3.52111,1.34951-6.67031,6.17871-6.42914,8.22623,1.56462-1.94163,1.22764-1.67427,1.92704,0.55939,0,0,0.26458-1.95434,0.52987-2.18701l0.45923,1.44665,0.17053-1.89204,0.46972,0.0217-0.12058-1.18663,0.69939,0.53515c-0.16335-0.6785-0.33764-0.90743,0.38588-1.48911,0,0-0.91645,0.11634-0.19294-1.53564l0.67528,0.65148s-0.12058-0.72128,0.12059-1.00049l2.48407-0.86089'/%3E %3Cpath d='m247.229,125.04-1.33017,2.53368,0.68214,0.19743-1.53481,1.15167,1.29606-0.13162s-1.9782,0.72391-2.21694,2.6653l2.0123-0.88844s-1.70534,1.74397-1.94409,2.79692l1.15963-1.02005s-1.12552,1.21748-0.95499,3.06016l0.85267-0.95424c-0.20464,2.23753-0.13642,2.43496,0.88678,4.14602,0,0-0.27285-2.6324,0.0341-2.96145l2.25105,2.33625-1.26195-3.32339s1.39837,2.10591,2.25105,1.90848l-1.77356-2.6982,1.73945,1.41491-1.9782-2.96144,1.84177,0.55938s-1.33016-1.67815-1.22784-2.73111l1.26195,1.38201s-0.4775-1.57944-0.34107-2.04011l0.64803,0.13162-1.26195-1.44782,0.85267-0.16452-0.10232-0.95424,0.61392-0.19743-0.0341-1.05296'/%3E %3Cpath d='m248.559,125.797c-2.18283,2.96144-1.05731,7.53523-2.35337,9.87148'/%3E %3C/g%3E %3Cuse xlink:href='%23tree_half' transform='matrix(-1,0,0,1,499.85867,0)'/%3E %3Cg id='trunk'%3E %3Cpath d='m250.945,166.535s1.18865-9.94478,1.18579-14.2254c-0.002-3.36865-0.81392-10.8349-0.81392-10.8349h-3.41702s-0.52001,7.42903-0.44204,10.7889c0.0994,4.28179,1.18578,14.2713,1.18578,14.2713h2.30141z'/%3E %3Cpath d='m247.674,141.953,3.95963,0-0.46487-2.6659-2.87012,0-0.62464,2.6659z'/%3E %3Cpath d='m247.927,139.816,3.53853,0-0.667-2.6659-2.17951,0-0.69202,2.6659z'/%3E %3Cpath d='m248.155,137.655,2.94897,0-0.49856-2.6659-1.87631,0-0.5741,2.6659z'/%3E %3Cpath d='m250.709,134.673-2.06274,0-0.20917,0.96419,2.44041,0-0.1685-0.96419z'/%3E %3Cpath d='m251.132,164.367h-2.62035'/%3E %3Cpath d='m251.275,162.42h-2.9404'/%3E %3Cpath d='m251.664,160.444h-3.72683'/%3E %3Cpath d='m251.856,158.291h-3.90057'/%3E %3Cpath d='m251.883,156.139h-4.10175'/%3E %3Cpath d='m252.043,154.171h-4.44923'/%3E %3Cpath d='m252.053,152.38h-4.65041'/%3E %3Cpath d='m252.025,150.219h-4.65042'/%3E %3Cpath d='m251.87,148.084h-4.49496'/%3E %3Cpath d='m251.664,145.914h-4.06517'/%3E %3Cpath d='m251.467,143.955h-3.67197'/%3E %3C/g%3E %3Cg id='cap'%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m249.909,119.044c-0.68827-0.32391-2.24539-1.3126-1.78345-1.90279,0,0,0.71338-1.21454,0.71338-1.21454,1.01062-2.27664-0.0184-1.39459-0.12589-2.10521-0.10324-0.68238,3.86451-0.1495,3.92359,1.39673,0.0163,0.42592-0.2943,0.17596-0.25178,2.61126,0,0-0.75534,1.45746-0.75534,1.45746-0.56496,0.0526-1.23395-0.0139-1.72051-0.24291z'/%3E %3Cpath d='m250.392,124.934-0.98614-0.82994,0.27276-7.10507,0.96516,0.28339-0.25178,7.65162z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m251.672,119.246c0.61915-0.36236,1.02443-1.44301,0.65043-2.08496-1.01607-1.28744-1.6737-0.7562-3.37806-1.336-0.3399,0.36203-1.05561,1.05866-0.90222,1.5789,2.24222,1.05562,1.37162,0.15654,2.1135,0.28804,0.39994,0.0709,0.65837,0.54508,1.51635,1.55402z'/%3E %3C/g%3E %3C/g%3E %3Cg id='items'%3E %3Cg id='i1'%3E %3Cuse xlink:href='%23ip' transform='matrix(1,0,0,-1,-0.00226132,320.36968)'/%3E %3Cpath fill='%23016a16' stroke='%23fff' stroke-width='0.1811' stroke-linecap='round' d='m238.358,161.75c0,1.29873-0.81458,2.35278-1.81827,2.35278s-1.81827-1.05405-1.81827-2.35278v-1.27647h3.63654v1.27647z'/%3E %3Cellipse fill='%23fff' stroke='none' cx='236.539' cy='160.063' rx='1.806' ry='0.898'/%3E %3Cpath fill='%23016a16' stroke='%23f1b517' d='m236.126,161.075-0.31022-3.29722,1.38188,0-0.22561,3.29722-0.84605,0z'/%3E %3Cpath id='ip' fill='%23016a16' stroke='%23fff' stroke-width='0.2373' stroke-linecap='round' d='m238.538,160.118c-0.26498,0.49319-1.06061,0.85208-1.99881,0.85208-0.9382-0.00001-1.72802-0.35889-1.99301-0.85208-0.0611,0.11381-0.0988,0.23335-0.0988,0.35877,0,0.66892,0.93708,1.21084,2.09179,1.21084s2.09178-0.54192,2.09178-1.21084c0-0.12542-0.0318-0.24496-0.093-0.35877z'/%3E %3C/g%3E %3Cg id='items_half'%3E %3Cpath id='cannon_base' d='m246.035,172.786-7.06013-2.18936-3.0762-5.25446-10.8928-0.53517,0.3783,3.94069,9.27903,1.77619,0.88243,1.58127,10.6659,2.96795-0.17658-2.28711z'/%3E %3Cg id='i2'%3E %3Cpath fill='%23503200' d='m238.662,174.254-11.1485-16.3982-0.54716,0.41156,11.0604,16.4667,0.63525-0.48015z'/%3E %3Cpath fill='%23fff' d='m228.551,158.5-1.19022-1.99181c-0.22281-0.36812-0.56118-0.49033-1.05837-0.22832-0.48411,0.25512-0.43705,0.75928-0.23987,1.12295l1.10042,1.85207,1.38804-0.75489z'/%3E %3C/g%3E %3Cg id='cannon'%3E %3Cpath d='m239.986,164.127-22.4964-2.28644-0.54691,3.27137,22.387,2.25127,0.6563-3.2362z'/%3E %3Cpath d='m217.089,160.997-0.58337,4.5377,0.94798,0,0.6563-4.15077-1.02091-0.38693z'/%3E %3Cpath d='m220.844,161.735-0.25522,4.08042,0.58337,0.0704,0.47399-3.62314-0.80214-0.52764z'/%3E %3Cpath d='m236.085,163.494-0.54691,3.83419,1.09382-0.0352,0.43753-3.79901-0.98444,0z'/%3E %3Cpath d='m239.436,163.599-0.77861,4.43415,1.23764,0.17939,0.35444-2.33199c0.0995,0.46856,0.53095,0.82404,1.04589,0.82404,0.58851,0,1.06914-0.46369,1.06914-1.03146s-0.48063-1.02585-1.06914-1.02585c-0.40919,0-0.78043,0.23995-0.9413,0.68697l0.23242-1.66237-1.15048-0.0729z'/%3E %3Cpath d='m231.317,164.319-3.09381,3.48224,0.36095,0.42285,3.97038-2.71118-1.23752-1.19391z'/%3E %3Cpath d='m224.124,173,3.09381-3.48225-0.36094-0.42284-3.97039,2.71118,1.23752,1.19391z'/%3E %3Cpath d='m232.22,172.129-3.76413-2.91016-0.38673,0.2736,2.9649,3.75585,1.18596-1.11929z'/%3E %3Cpath d='m222.938,165.413,3.8157,2.81067,0.46407-0.34823-2.99068-3.75585-1.28909,1.29341z'/%3E %3Cpath d='m227.09,163.094,0.36461,4.57288,0.51357-0.0219,1.2071-4.45153-2.08528-0.0995z'/%3E %3Cpath d='m228.341,174.189-0.3646-4.57289-0.56515-0.0528-0.69146,4.62565,1.62121,0z'/%3E %3Cpath d='m233.401,168.026-4.79461,0.51005-0.0729,0.45729,4.84929,0.63317,0.0182-1.60051z'/%3E %3Cpath d='m221.993,169.609,4.6808-0.73994,0.0987-0.36384-4.84175-0.54096,0.0622,1.64474z'/%3E %3Cellipse cx='227.693' cy='168.548' rx='1.27' ry='1.225'/%3E %3Cpath fill-rule='evenodd' stroke-linecap='round' d='m234.438,168.548c0,3.59202-3.02175,6.50727-6.74495,6.50727-3.72321,0-6.74496-2.91525-6.74496-6.50727,0-3.592,3.02175-6.50726,6.74496-6.50726,3.7232,0,6.74495,2.91526,6.74495,6.50726zm-1.34742,0.00001c0,2.87446-2.41811,5.20734-5.39755,5.20734s-5.39754-2.33288-5.39754-5.20734c0-2.87445,2.4181-5.20734,5.39754-5.20734s5.39755,2.33289,5.39755,5.20734z'/%3E %3Cpath d='m223.48,165.264-1.05705-0.79595'/%3E %3Cpath d='m231.034,164.493,0.90236-0.92031'/%3E %3Cpath d='m232.967,172.701-1.10862-0.87056'/%3E %3Cpath d='m223.48,173.696,0.95392-1.0198'/%3E %3C/g%3E %3Cg id='axe'%3E %3Cpath d='m246.196,162.122,1.15496,5.8864-0.94208,0.4962-1.01348-6.29841,0.8006-0.0842z'/%3E %3Cpath fill='%23fff' d='m245.592,161.364c-0.53548-0.22387-1.2316,0.15498-2.37396-1.29153-1.87831,1.72203-0.10709,1.98034,0.17849,3.68515,0.53115,0.21828,0.85836-1.32283,2.30256-1.48095,0.1785-0.0172,2.29785-0.20311,2.29785-0.20311s-0.53201-0.72513-0.53201-0.72513-1.47399,0.0387-1.87293,0.0156z'/%3E %3Cpath fill='%23fff' d='m246.359,162.518-0.21419-1.75647c-0.23204-0.61993-0.99956-0.0861-0.99956,0.27552l0.19634,1.61871,1.01741-0.13776z'/%3E %3C/g%3E %3Cpath id='bugle' fill-rule='evenodd' d='m240.765,167.372,0.0188,1.63686c-0.53573,0.18339-0.454,0.58498-0.43672,1.16852l0.0188,4.77113c-0.1901,0.31678-0.77767,0.33153-1.05418,0.5797-0.2765,0.24817-0.24194,0.72975,1.01961,1.04653l0.97557,0.0349c1.48622-0.32512,1.79297-0.81731,1.0477-1.09485-0.39645-0.14764-0.91809-0.32374-1.11682-0.55716l0.033-1.1367,0.96456,0.0349c0.25923,0,0.7525-0.65168,0.76978-1.1852l0.005-2.47044c-0.0346-1.4005-1.08551-1.55803-1.3793-1.54136l0.0204-1.28978-0.88602,0.003zm1.63059,2.73012c0.0173-0.40014-0.5556-0.75694-0.78631-0.76694s-0.73447,0.46683-0.75175,0.86697v1.00036c0.0346,0.3668,0.32755,1.60924,0.91592,1.7006,0.27872,0.0433,0.63942-0.40014,0.63942-0.76694l-0.0173-2.03405z'/%3E %3Cg id='i3' fill='%23fff'%3E %3Cpath d='m234.275,172.328c-0.63643-0.25722-0.63028,1.17186-0.63028,1.17186l1.00278,0.0105c0.43862,0.19913,0.79146,0.84264,0.51178,1.1585-0.23124,0.26115-2.17731-0.44106-2.30792-0.0372,0.34401,1.94159,2.91678,2.68867,3.84773,1.83931,0.91051-0.83072,1.14108-3.04781-1.81748-3.62862l-0.60661-0.51433z'/%3E %3Cpath d='m234.87,172.856-0.29241,0.63889'/%3E %3C/g%3E %3Cg id='small_flag'%3E %3Cpath d='m214.943,173.055-0.96325-4.04912'/%3E %3Cpath d='m216.112,172.822-1.47928-3.15301'/%3E %3Cpath d='m218.658,171.993-3.33698-1.79223'/%3E %3Cpath d='m220.103,171.628-6.19232-2.68836'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' d='m210.215,166.013s-2.25377-0.0356-2.65571,0.122c-0.16218,0.0636,0.56688,0.82456,0.41552,1.11549-0.56308,1.08226-4.3943,0.93396-4.69718,0.69717-0.51817-0.4051,3.56833-0.75265,3.59515-1.02833,0.0308-0.31645-0.60433-1.14672-0.50585-1.6558,0.12777-0.66051,1.78854-0.90633,1.78854-0.90633l2.05953,1.6558z'/%3E %3Cpath fill='%23503200' d='m213.233,168.05-5.10223-4.22211s-0.22478-0.2382-0.41282-0.0332c-0.18413,0.20074,0.0688,0.43146,0.0688,0.43146l5.26348,4.34783,0.18277-0.52399z'/%3E %3Cpath d='m218.146,172.217c-0.0903-0.0871-4.1552-3.60789-4.1552-3.60789l-0.27099-1.02833s-0.6278,0.42527-0.85814,0.64488-0.58715,0.81919-0.58715,0.81919l1.13817,0.0523,3.59515,3.29416,1.13816-0.1743z'/%3E %3C/g%3E %3Cg id='cannonballs'%3E %3Cellipse cx='232.534' cy='177.056' rx='0.740' ry='0.715'/%3E %3Cellipse cx='230.641' cy='175.716' rx='0.740' ry='0.715'/%3E %3Cellipse cx='228.091' cy='176.593' rx='0.740' ry='0.715'/%3E %3Cellipse cx='224.153' cy='177.445' rx='0.740' ry='0.715'/%3E %3Cellipse cx='222.487' cy='177.64' rx='0.740' ry='0.715'/%3E %3Cellipse cx='220.846' cy='177.64' rx='0.740' ry='0.715'/%3E %3Cellipse cx='219.18' cy='177.591' rx='0.740' ry='0.715'/%3E %3Cellipse cx='219.988' cy='176.325' rx='0.740' ry='0.715'/%3E %3Cellipse cx='221.604' cy='176.398' rx='0.740' ry='0.715'/%3E %3Cellipse cx='223.144' cy='176.203' rx='0.740' ry='0.715'/%3E %3Cellipse cx='222.361' cy='174.961' rx='0.740' ry='0.715'/%3E %3Cellipse cx='220.846' cy='174.937' rx='0.740' ry='0.715'/%3E %3C/g%3E %3Cpath id='chain' fill-rule='evenodd' d='m236.47,177.991c0-0.31649-0.76859-0.18036-0.76859-0.55072,0-0.41154,1.17217-0.10903,1.33411,0.25303,0.65964-0.59607,0.94402-0.16037,1.34812,0.0197,0.57546-0.85539,1.28698-0.82343,1.98133-0.19706,0.40146-0.44287,1.40966-0.29647,1.75664,0.19706,0.66466-0.6591,1.25491-0.49671,1.71579-0.0197,0.18538-0.34652,0.45745-0.2707,0.65363-0.0197,0.35414-0.62828,1.24209-0.43967,1.61583-0.0249,0.33231-0.36526,0.67271-0.08,1.11376,0.18982,0.29784-0.2787,0.77827-0.22616,0.77827,0.0509,0,0.28889-0.62779,0.18719-0.62779,0.4739,0,0.25579,0.45796,0.12646,0.45796,0.45,0,0.25469-0.67973,0.35017-0.78477-0.0559-0.23021,0.43971-1.06186,0.27088-1.14386-0.13794-0.27669,0.33403-0.89704,0.43568-1.24599-0.0591-0.28657,0.23315-0.6295,0.26652-0.78695,0.0311-0.51709,0.55594-1.3887,0.4417-1.68895-0.17117,0,0-0.29346,0.0125-0.29346,0.0125-0.50794,0.68971-1.30179,0.37107-1.52011-0.0104-0.8527,0.61519-1.36211,0.42145-1.83835,0.0197-0.54713,0.66665-1.38081,0.62012-1.57281,0-0.36819,0.26829-1.13636,0.33144-1.13636,0.0176,0-0.30068,0.65255-0.19137,0.65255-0.46876zm1.65458,0.14977c0,0.1432-0.19492,0.25942-0.43509,0.25942s-0.43508-0.11622-0.43508-0.25942,0.19491-0.25943,0.43508-0.25943,0.43509,0.11623,0.43509,0.25943zm1.82033-0.21792c0,0.17238-0.23462,0.31227-0.52371,0.31227-0.28908,0-0.52371-0.13989-0.52371-0.31227,0-0.17236,0.23463-0.31226,0.52371-0.31226,0.28909,0,0.52371,0.1399,0.52371,0.31226zm3.57497,0.19716c0,0.1745-0.21232,0.31611-0.47392,0.31611s-0.47392-0.14161-0.47392-0.31611c0-0.17449,0.21232-0.31611,0.47392-0.31611s0.47392,0.14162,0.47392,0.31611zm-1.90344-0.083c0,0.22051-0.20766,0.39948-0.46353,0.39948s-0.46353-0.17897-0.46353-0.39948,0.20766-0.39948,0.46353-0.39948,0.46353,0.17897,0.46353,0.39948zm4.05961,0.0104c0,0.19712-0.18564,0.35711-0.41437,0.35711s-0.41436-0.15999-0.41436-0.35711c0-0.19713,0.18563-0.35711,0.41436-0.35711s0.41437,0.15998,0.41437,0.35711zm-1.24369,0.083c0,0.12739-0.11997,0.23078-0.26778,0.23078-0.14782,0-0.26778-0.10339-0.26778-0.23078s0.11996-0.23078,0.26778-0.23078c0.14781,0,0.26778,0.10339,0.26778,0.23078zm2.42185,0.0934c0,0.183-0.13521,0.33153-0.30181,0.33153s-0.30181-0.14853-0.30181-0.33153c0-0.18301,0.13521-0.33154,0.30181-0.33154s0.30181,0.14853,0.30181,0.33154z'/%3E %3C/g%3E %3Cuse xlink:href='%23items_half' transform='matrix(-1,0,0,1,499.85853,0)'/%3E %3Cg id='drum' stroke-width='0.231'%3E %3Cpath fill='%230a328c' stroke='%230a328c' d='m249.837,165.718c-2.5116,0-4.54963,0.94401-4.54963,2.10216,0,0.19861,0.0565,0.38965,0.1685,0.57178,0.54316,0.62909,2.30675,1.08752,4.39856,1.08752,1.95672,0,3.6243-0.40275,4.27654-0.9698,0.16439-0.21675,0.25566-0.44698,0.25566-0.6895,0-1.15816-2.03804-2.10216-4.54963-2.10216z'/%3E %3Cpath stroke-width='0.1869' d='m254.427,167.981v7.05811c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-7.05811c0,0.82757,2.04845,1.49922,4.57244,1.49922,2.52398,0,4.57243-0.67165,4.57243-1.49922z'/%3E %3Cpath fill='%23d20014' stroke='%23d20014' stroke-width='0.1826' d='m245.282,167.982v1.08191l2.21961,6.84463,1.77221-5.2638,1.94652,5.46561,1.42429-5.15885,1.78311,3.46807v-1.91933l-1.65599-3.36345c-0.18576,0.0506-0.38384,0.094-0.59268,0.13454l-1.02846,3.81191-1.44681-3.6045c-0.24229-0.003-0.48334-0.008-0.7147-0.0224l-1.45263,3.62692-1.6618-4.36688c-0.37558-0.21764-0.59267-0.46661-0.59267-0.73436z'/%3E %3Cpath fill='%230a328c' stroke='%230a328c' stroke-width='0.1869' d='m254.427,173.721v1.31782c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-1.31782c0,0.82757,2.04845,1.49922,4.57244,1.49922,2.52398,0,4.57243-0.67165,4.57243-1.49922z'/%3E %3Cpath stroke-width='0.1869' d='m251.737,175.085c-0.37176,0.0553-0.76859,0.0967-1.18535,0.11772l0.0116,1.31736c0.41688-0.0214,0.81373-0.062,1.18535-0.11773l-0.0116-1.31735z'/%3E %3Cpath stroke-width='0.1869' d='m246.868,174.855-0.0116,1.31174c0.35286,0.10094,0.74975,0.18477,1.18534,0.24666v-1.31736c-0.43047-0.0611-0.82391-0.1417-1.17372-0.24104z'/%3E %3Cpath stroke-width='0.1869' d='m245.282,173.723v1.31736c0,0.24576,0.18539,0.47354,0.50551,0.67829l0.0232-1.30053c-0.33594-0.20864-0.52875-0.44293-0.52875-0.69512z'/%3E %3Cpath stroke-width='0.1869' d='m254.428,173.863-0.0232,0.006c-0.0801,0.26749-0.37874,0.51556-0.8309,0.72315l0.006,1.31174c0.53035-0.2448,0.84834-0.54036,0.84834-0.86328v-1.17721z'/%3E %3Cpath fill='none' stroke-width='0.1869' d='m254.427,168.027v7.01203c0,0.82757-2.04845,1.49922-4.57243,1.49922-2.52399,0-4.57244-0.67165-4.57244-1.49922v-7.01203'/%3E %3Cpath fill='%23fff' stroke='%23fff' stroke-width='0.1916' d='m253.392,167.52c0,0.50111-1.58376,0.90734-3.53741,0.90734-1.95366,0-3.53741-0.40623-3.53741-0.90734s1.58375-0.90734,3.53741-0.90734c1.95365,0,3.53741,0.40623,3.53741,0.90734z'/%3E %3Cpath d='m248.698,168.19,0.15688,1.25008c0.30701,0.0223,0.62606,0.0382,0.95293,0.0392l0.23242-1.28932h-1.34223z'/%3E %3Cpath d='m252.801,167.887-0.91225,0.24665,0.0581,1.17721c0.3102-0.0525,0.60208-0.11708,0.86576-0.1906l-0.0116-1.23326z'/%3E %3Cpath d='m247.397,165.979c-0.25878,0.0764-0.50082,0.16525-0.7205,0.26347l0.12783,0.94417,0.58105-0.18499,0.0116-1.02265z'/%3E %3Cpath d='m249.837,165.606c-0.12168,0-0.24098,0.007-0.36025,0.0112l0.19756,1.18249,0.60429-0.0112,0.23823-1.15447c-0.22219-0.0155-0.44837-0.028-0.67983-0.028z'/%3E %3Cpath d='m252.51,166.024-0.12203,1.0337,0.69146,0.24441,0.0755-1.01464c-0.19636-0.0968-0.41236-0.18511-0.64496-0.26347z'/%3E %3Cpath stroke-width='0.1826' d='m245.993,168.8,0.18421-1.28763-0.93496-0.50634,0.0278,1.46536,0.72294,0.32861z'/%3E %3Cpath stroke-width='0.1826' d='m254.396,168.522,0.0417-1.28759-0.87584,0.26154,0.83413,1.02605z'/%3E %3C/g%3E %3Cg id='helmet'%3E %3Cpath d='m263.686,160.029c0.83083-0.11451,2.06245,1.02446,2.13643,2.4333,0.0587,1.11791-1.69134,1.0592-1.69134,1.0592-0.089,0.45803-1.0541,0.88186-1.83971,0.91606-0.76216,0.0332,0.20771-1.43135,0.20771-1.43135-0.47476-1.25959,0.14836-2.74819,0.14836-2.74819l1.03855-0.22902z'/%3E %3Cpath d='m262.499,162.948,0.80116-0.0286s0.0613,0.41314,0.20771,0.42941c0.15745,0.0175,0.3264-0.40078,0.3264-0.40078l1.21658-0.0286'/%3E %3Cpath fill='%23d20014' stroke='%23f1b517' d='m264.131,160.859c0.67974-0.49144,0.084-1.48026-0.38575-1.4886,0,0-1.09789,0.0286-1.09789,0.0286-0.51741,0.0107-1.39215,0.57267-1.27592,1.05921,0.10134,0.42425,0.38608,0.61772,0.83083,0.54391,0.20197-0.0335,0.62612-0.56336,0.83084-0.57254,0.27465-0.0123,0.87787,0.58848,1.09789,0.4294z'/%3E %3C/g%3E %3Cpath id='anchor' fill-rule='evenodd' d='m214.242,174.855c-0.61672,0.078-0.73098,0.78846-0.4997,1.44067-2.68636,0.7552-5.08627,1.73945-7.45489,2.40487-0.0953-0.4735,1.17372-1.84429,1.17372-1.84429,0.33571,0.16194,0.58686,0.93056,0.58686,0.93056,0.0839-1.57891,1.63857-2.6291,1.63857-2.6291-0.9232-0.12146-3.73165,0.96732-4.06736,1.41265,0,0,1.08722-0.12146,1.25507,0,0,0-2.14094,2.31168-2.23705,2.99907,0.33303,0.75114,4.02669,1.31175,4.02669,1.31175-0.0583,0.19445-1.08657,0.93056-1.08657,0.93056,1.4691,0.32268,3.68473-0.71797,4.34627-1.35099,0,0-1.72808-0.14248-3.07377-1.23327,0,0,0.2775,0.67919,0.1104,1.00343,0,0-2.09936-0.60528-2.31839-0.95297,0.006-0.0301,4.96602-1.31472,7.36773-2.00126,0.0889,0.42909,0.56583,1.23978,1.13886,1.04828,0.37379-0.12492,0.25537-0.8657,0.11621-1.39023,0.13517,0.11606,0.31047,0.18499,0.50551,0.18499,0.42228,0,0.76699-0.32696,0.76699-0.73435,0-0.4074-0.34471-0.73996-0.76699-0.73996-0.33769,0-0.61915,0.21145-0.7205,0.50452-0.0956-0.45275-0.34512-1.35347-0.80766-1.29493zm1.8887,1.52779c0,0.19057-0.16032,0.34523-0.35785,0.34523s-0.35784-0.15466-0.35784-0.34523,0.16031-0.34524,0.35784-0.34524,0.35785,0.15467,0.35785,0.34524z'/%3E %3Cg id='i4'%3E %3Cpath d='m293.068,177.884c0.18296-0.36659-0.16181-2.21178-0.16181-2.21178-0.37288,0.0414-0.88217,0.68114-0.88217,0.68114,0.48088-1.51138-0.86509-4.03755-0.86509-4.03755,0.91058,0.1905,3.94542,3.12828,4.103,3.65753,0,0-1.32902-0.47414-1.52981-0.4154,0.21676,1.50571,1.25802,2.20544,1.64916,2.98821,0,0-1.7257,0.37897-1.55229,1.82194l-1.12718,0.0209c-0.39017-0.48099,0.15174-1.27567,0.15174-1.27567l-7.73851-3.24146c-0.49856-0.20913-1.6204-0.71815-1.45233-1.3175,0.16946-0.6043,2.01592,0.25096,2.47112,0.39734l6.93417,2.93229z'/%3E %3Cpath d='m285.635,176.541,0.91042-1.67302c0.32514-0.43916-0.34683-0.92015-0.82371-0.35551l-1.0188,1.52662c-0.4552,0.83651,0.49856,1.06655,0.93209,0.50191z'/%3E %3C/g%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff'%3E %3Cpath d='m231.367,180.366-0.0631-1.82484-2.20675,0.12166-0.1261,1.98705,2.3959-0.28387z'/%3E %3Cpath d='m215.237,182.924-2.9508-1.65512c12.1686,1.11518,14.6537-3.12916,17.5942-3.35618,1.80755-0.14118,2.0898,2.0019-1.41275,0.98242l0.90579,2.24135s-8.6385,4.85952-17.1292,2.85219l2.99283-1.06466z'/%3E %3Cpath d='m268.249,180.366,0.063-1.82484,2.6992,0.0623,0.1261,1.98705-2.88835-0.22448z'/%3E %3Cpath d='m284.939,182.477,2.77669-1.51514c-13.9388,0.41529-10.7652-2.28929-17.7392-3.04823-1.80213-0.1953-3.15679,2.12067,1.41275,0.98242l-0.90579,2.24135s2.1922,0.002,2.1922,0.002c4.74805,3.12663,11.156,3.40575,15.4013,2.40209l-3.13793-1.06466z'/%3E %3Cpath d='m228.418,178.908,0,3.15421s7.728,2.86747,21.5188,2.86747c13.8501,0,21.5188-2.86747,21.5188-2.86747v-3.15421s-5.84903,2.69542-21.5188,2.69542c-15.6103,0-21.5188-2.69542-21.5188-2.69542z'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m229.573,182.08,0.68194-2.30932,0.31676,0.0871-0.60146,2.0368,1.17887,0.32402-0.0805,0.27252-1.49564-0.41108zm2.23639-1.01549,0.0381-0.45359,0.10174-0.38911,0.33747,0.0821-0.10174,0.38911-0.1928,0.41593-0.18273-0.0445zm3.32525-0.15591,0.32275,0.0634-0.28686,1.35944c-0.0499,0.23647-0.11725,0.41881-0.20205,0.54702s-0.20878,0.22171-0.37192,0.28049c-0.16314,0.0588-0.36227,0.0651-0.5974,0.0189-0.22847-0.0449-0.40734-0.11956-0.5366-0.22407-0.12926-0.1045-0.20976-0.23481-0.2415-0.39093-0.0317-0.15611-0.0213-0.35882,0.0313-0.60813l0.28685-1.35945,0.32275,0.0634-0.28652,1.35784c-0.0431,0.20437-0.0552,0.35884-0.0363,0.46341s0.0708,0.19249,0.15571,0.26376c0.0849,0.0713,0.19663,0.12052,0.33527,0.14775,0.23734,0.0466,0.41743,0.0279,0.54026-0.056,0.12283-0.084,0.2154-0.27362,0.27771-0.56894l0.28652-1.35784zm0.36326,2.51013,0.40178-2.36971,0.33342,0.0526,0.97468,2.06413,0.31545-1.86053,0.31164,0.0492-0.40178,2.36971-0.33342-0.0526-0.9744-2.06574-0.31573,1.86215-0.31164-0.0492zm2.54115,0.38367,0.34172-2.37847,0.32625,0.0436-0.34173,2.37846-0.32624-0.0436zm0.9374-1.04907c0.0469-0.39598,0.19381-0.69384,0.44075-0.89358,0.24694-0.19973,0.54471-0.28038,0.89332-0.24196,0.22827,0.0252,0.42783,0.10047,0.59866,0.22591,0.17084,0.12544,0.29318,0.28758,0.36704,0.4864,0.0739,0.19883,0.0966,0.41759,0.0684,0.65626-0.0286,0.24193-0.10489,0.45279-0.22871,0.63258-0.12382,0.17978-0.28432,0.30854-0.48149,0.38627-0.19718,0.0777-0.40316,0.10475-0.61794,0.0811-0.23278-0.0257-0.43439-0.10284-0.60484-0.23154-0.17044-0.12869-0.29178-0.29209-0.36402-0.49019-0.0722-0.1981-0.0959-0.40184-0.0711-0.61123zm0.33678,0.0421c-0.0341,0.28749,0.0192,0.5228,0.15989,0.70591,0.14065,0.18311,0.33186,0.28799,0.57364,0.31464,0.24627,0.0272,0.45885-0.034,0.63776-0.18358,0.17891-0.14953,0.28654-0.37781,0.32291-0.68483,0.023-0.1942,0.009-0.36746-0.0418-0.5198-0.0509-0.15233-0.13711-0.27559-0.25867-0.36977-0.12156-0.0942-0.26387-0.15026-0.42692-0.16823-0.23166-0.0255-0.44007,0.0293-0.62524,0.16435-0.18517,0.1351-0.29903,0.38221-0.34155,0.74131zm2.30844,1.41617,0.2028-2.39322,0.33674,0.0266,1.1437,1.98175,0.15922-1.87899,0.31474,0.0248-0.20281,2.39322-0.33673-0.0266-1.14356-1.98339-0.15937,1.88062-0.31473-0.0248zm3.48923,0.24265,0.10868-2.39892,1.67748,0.0707-0.0128,0.28309-1.34843-0.0569-0.0336,0.74292,1.16694,0.0492-0.0128,0.28309-1.16694-0.0492-0.0494,1.08982-0.32905-0.0139zm1.83353,0.0783,1.00383-2.38291,0.35477,0.007,0.97029,2.41977-0.37513-0.007-0.27567-0.73253-1.04054-0.0194-0.28787,0.722-0.34968-0.007zm0.7378-0.97244,0.84363,0.0157-0.24637-0.66973c-0.0752-0.20345-0.13067-0.3705-0.16654-0.50113-0.0348,0.15334-0.0825,0.30535-0.1433,0.45603l-0.28742,0.69907zm1.9137,1.01069,0.005-2.4012,0.32936,0.00054-0.005,2.4012-0.32937-0.00054zm1.54203-0.007-0.0313-2.11763-0.81994,0.0113-0.004-0.28333,1.97259-0.0271,0.004,0.28333-0.82333,0.0113,0.0313,2.11763-0.32933,0.005zm2.44223-0.0577-0.1164-2.39858,0.32901-0.0148,0.10266,2.11553,1.22444-0.0553,0.0137,0.28305-1.55345,0.0702zm1.67472-0.073,0.77655-2.46067,0.35394-0.0243,1.19294,2.3253-0.37425,0.0257-0.34315-0.7055-1.0381,0.0714-0.21908,0.74414-0.34885,0.024zm0.6437-1.03278,0.84166-0.0579-0.30809-0.64551c-0.0939-0.19606-0.16484-0.35758-0.21279-0.48456-0.0203,0.15575-0.0536,0.3113-0.10001,0.46665l-0.22077,0.72127zm2.92174,0.75811-0.27296-2.38673,1.66896-0.17765,0.0322,0.28165-1.34158,0.14281,0.0845,0.73913,1.16102-0.12358,0.0322,0.28165-1.16101,0.12359,0.124,1.08428-0.32738,0.0349zm1.82509-1.37024c-0.0584-0.39457,0.006-0.71858,0.19234-0.97205,0.18659-0.25346,0.45356-0.40411,0.80091-0.45194,0.22746-0.0313,0.44026-0.007,0.63841,0.0726,0.19815,0.0797,0.359,0.20675,0.48255,0.38111,0.12354,0.17436,0.20291,0.38045,0.23809,0.61827,0.0357,0.24107,0.0171,0.46367-0.0556,0.66781s-0.19425,0.36785-0.36465,0.49114c-0.17041,0.12329-0.36262,0.19966-0.57664,0.22913-0.23194,0.0319-0.44722,0.006-0.64585-0.0765-0.19863-0.083-0.35884-0.21146-0.48063-0.38551-0.12178-0.17406-0.19811-0.3654-0.22897-0.57403zm0.33686-0.0414c0.0424,0.28646,0.1556,0.50113,0.33965,0.644,0.18406,0.14286,0.39654,0.19771,0.63745,0.16454,0.24538-0.0338,0.43503-0.14483,0.56896-0.33314,0.13392-0.1883,0.17825-0.43541,0.133-0.74134-0.0286-0.19349-0.0875-0.35773-0.17665-0.49271-0.0891-0.13498-0.20485-0.23321-0.34714-0.29469-0.14229-0.0615-0.29467-0.081-0.45714-0.0587-0.23082,0.0318-0.41811,0.13561-0.56188,0.31148-0.14376,0.17588-0.18918,0.44272-0.13625,0.80053zm2.61378,0.80601-0.4445-2.3626,1.0858-0.19014c0.21827-0.0382,0.38819-0.0461,0.50977-0.0235,0.12158,0.0225,0.22644,0.0816,0.31458,0.17713,0.0881,0.0956,0.14445,0.20832,0.16891,0.33832,0.0315,0.16761,0.002,0.31874-0.089,0.4534-0.0909,0.13466-0.25083,0.23814-0.47995,0.31044,0.0932,0.0247,0.16576,0.0525,0.21758,0.0834,0.11042,0.0672,0.21978,0.15629,0.32807,0.26717l0.54695,0.56843-0.40759,0.0714-0.41655-0.43479c-0.12135-0.12524-0.21972-0.2201-0.29512-0.28459-0.0754-0.0645-0.14015-0.10752-0.19425-0.12912s-0.10733-0.0339-0.15966-0.037c-0.0382-0.001-0.099,0.006-0.18254,0.0203l-0.37585,0.0658,0.19739,1.04915-0.32407,0.0568zm0.0757-1.37664,0.69658-0.12199c0.14812-0.0259,0.26116-0.061,0.33912-0.10516,0.078-0.0442,0.13255-0.10256,0.16375-0.17517,0.0312-0.0726,0.0396-0.14705,0.0253-0.22333-0.021-0.11174-0.0804-0.19624-0.17797-0.2535-0.0976-0.0573-0.2372-0.07-0.41872-0.0382l-0.7751,0.13573,0.14706,0.78163zm3.93115-0.26168,0.33959,0.009c-0.008,0.26923-0.0838,0.4897-0.22765,0.66141-0.14382,0.17171-0.34216,0.28502-0.59502,0.33993-0.2617,0.0568-0.48653,0.0517-0.67449-0.0155s-0.34748-0.18896-0.47854-0.36533c-0.13107-0.17636-0.2227-0.3764-0.2749-0.60011-0.0569-0.24395-0.0583-0.46723-0.004-0.66985,0.0542-0.20262,0.15952-0.37043,0.31585-0.50344s0.3416-0.22278,0.55582-0.2693c0.24293-0.0528,0.46112-0.0375,0.6546,0.0459,0.19347,0.0833,0.34801,0.22607,0.46362,0.42817l-0.29958,0.14061c-0.0961-0.15821-0.20676-0.26457-0.33201-0.31908-0.12525-0.0545-0.26904-0.0641-0.43136-0.0289-0.18661,0.0405-0.33251,0.11755-0.4377,0.23105-0.1052,0.11351-0.16622,0.24849-0.18309,0.40493-0.0169,0.15644-0.007,0.3119,0.0288,0.46637,0.0465,0.19921,0.11715,0.36658,0.212,0.50212,0.0949,0.13554,0.21436,0.22627,0.35849,0.2722,0.14414,0.0459,0.29018,0.0528,0.43815,0.0207,0.17998-0.0391,0.32068-0.12225,0.42209-0.24949,0.10141-0.12723,0.1512-0.29419,0.14939-0.50086zm0.91487,0.65288-0.66928-2.31277,1.73334-0.46687,0.079,0.27293-1.4161,0.38142,0.20498,0.70835,1.32617-0.3572,0.0785,0.27134-1.32617,0.3572,0.22781,0.78723,1.47171-0.3964,0.079,0.27292-1.78894,0.48185z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Crect fill='%23171796' width='1200' height='600'/%3E %3Crect fill='%23fff' width='1200' height='400'/%3E %3Crect fill='%23f00' width='1200' height='200'/%3E %3Cg transform='scale(0.00296202)'%3E %3Cg%3E %3Cpath fill='%23f00' d='m202577,153674,0,0c21658,0,39377-17720,39377-39377v-46791h-78755v46791c0,21658,17720,39377,39377,39377z'/%3E %3Cpath fill='%23fff' d='m202577,153043,0,0c21245,0,38626-17382,38626-38626v-46153h-77253v46153c0,21245,17382,38626,38627,38626z'/%3E %3Cg fill='%23f00'%3E %3Cpath d='m180254,69716-14865,0,0,16332,14865,0z'/%3E %3Cpath d='m180254,102379,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m165389,114326c0,1483,92,2946,263,4385h14602v-16332h-14865v11947z'/%3E %3Cpath d='m209985,102379-14866,0,0,16332,14866,0z'/%3E %3Cpath d='m209985,135042,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m224850,143976c3296-2488,6169-5509,8487-8933h-8487v8933z'/%3E %3Cpath d='m180255,135042,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m171754,135042c2321,3429,5199,6454,8501,8944v-8944h-8501z'/%3E %3Cpath d='m205141,151374c1645-115,3262-337,4843-661v-15671h-14865v15673c1576,323,3189,544,4829,658,1731,107,3462,101,5192,0z'/%3E %3Cpath d='m239437,118711c172-1444,264-2912,264-4400v-11931h-14852v16332h14588z'/%3E %3Cpath d='m209985,102379,14865,0,0-16331-14865,0z'/%3E %3Cpath d='m209985,69716-14865,0,0,16332,14865,0z'/%3E %3Cpath d='m239701,86048,0-16332-14851,0,0,16332z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fff' d='m240533,67027,9217-20893-7022-11339-11634,4307-8168-9337-10763,6168-9597-7860-9597,7860-10763-6168-8169,9336-11634-4307-7024,11342,9205,20897c11599-5250,24460-8175,37983-8175,13517,0,26372,2923,37968,8169z'/%3E %3Cg%3E %3Cpath fill='%230093dd' d='m174293,40024-17,20-11537-4272-6456,10424,2473,5623,6265,14222c4678-2068,9555-3764,14594-5048l-5321-20968z'/%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='118.162625' d='m173629,50332c413,783,647,1674,647,2617,0,3106-2533,5639-5639,5639-2737,0-5029-1968-5535-4561,974,1722,2823,2888,4935,2888,3121,0,5667-2545,5667-5667,0-312-26-618-75-917z'/%3E %3Cpolygon fill='%23000' points='168461,42530,168442,42623,168049,44647,169602,46004,169673,46066,169583,46097,167634,46769,167235,48792,167216,48885,167145,48822,165589,47470,163638,48136,163547,48167,163566,48073,163959,46050,162407,44693,162335,44630,162425,44599,164374,43928,164773,41905,164792,41812,164863,41874,166419,43227,168370,42561'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m166119,45404,1455,1269,1821-627z'/%3E %3Cpath d='m166131,45340,3277,641-1450-1268z'/%3E %3Cpath d='m162613,44651,3276,641-1455-1268z'/%3E %3Cpath d='m165877,45357-3277-641,1450,1267z'/%3E %3Cpath d='m166060,45234,2194-2517-1823,622z'/%3E %3Cpath d='m163704,47937,2194-2517-1826,626z'/%3E %3Cpath d='m165948,45463-2194,2517,1823-622z'/%3E %3Cpath d='m168304,42760-2194,2517,1826-626z'/%3E %3Cpath d='m165933,45242-1083-3158-373,1890z'/%3E %3Cpath d='m167096,48634-1083-3158-371,1894z'/%3E %3Cpath d='m166075,45454,1083,3159,373-1890z'/%3E %3Cpath d='m164912,42062,1083,3159,371-1895z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23171796' d='m193069,36886-20,16-10673-6116-8083,9238,5321,20968c4938-1257,10031-2115,15242-2546l-1788-21560z'/%3E %3Cg fill='%23f00'%3E %3Cpath d='m178294,55788c5221-1329,10608-2237,16119-2692l-452-5450c-5816,481-11502,1439-17013,2841l1345,5301z'/%3E %3Cpath d='m175619,45250c5797-1476,11777-2483,17895-2989l-444-5350c-6418,530-12691,1588-18772,3135l1321,5204z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230093dd' d='m212105,36890-23,13-9517-7794-9497,7778,1788,21560c2543-210,5113-322,7709-322,2608,0,5190,113,7744,325l1795-21560z'/%3E %3Cg id='lion'%3E %3Cpath fill='%23000' d='m202545,46585c-18-2-44,10-69,45-186,250-359,469-545,720-195,61-242,180-167,348-261-26-291,193-302,432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172,74,267,434,535,868,802,1302-14,80,6,151,88,204,47,133,93,265,140,397-11,38-21,75-32,113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92,82-3,534,162,1014,599,1492-231,4-462,11-694,21-79,6-95,39-73,104,126,304,339,579,822,766-208,112-327,285-357,520-9,224-75,382-212,455-60,32-81,65-24,106,253,185,565,193,895,112-157,270-226,553-198,850,208,56,412,15,614-52-29,61-44,175-52,309-7,115-41,229-104,343-32,33-65,84,4,102,336,91,648,52,915-47,0,243,2,487,76,727,18,58,70,102,125,26,155-214,322-396,527-517,31,90,75,168,156,215,96,55,147,170,153,343,0,30-2,60,35,90,149,7,514-380,589-597,206,121,284,246,439,461,55,76,99,29,128-25,62-243,67-481,66-724,267,99,579,138,915,47,69-19,36-70,4-102-62-114-105-250-113-365-9-133-14-226-43-287,202,68,405,108,614,52,29-297-53-579-211-850,330,80,655,73,908-112,57-41,35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520,483-187,696-463,822-766,22-66,6-99-73-104-231-10-480-24-711-27,437-478,606-961,604-1495-1-108-38-146-92-82-74,87-179,137-348,146-222,15-435,24-656,128-11-38-21-75-32-113,46-132,106-260,153-393,82-53,102-123,88-204,267-434,513-868,781-1302,54-79-46-162-171-74-60,42-110,64-170,106-117,80-257,134-437,145-251,54-417,167-428,397-293-175-564-73-814,307-11-239-41-457-302-432,75-168,17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m205075,47978c-51-26-124,17-162,95s-33,170,19,196c40,20,84-6,119-56l22-36c2-3,4-6,5-9,38-78,49-163-2-188z'/%3E %3Cpath d='m200067,47978c52-26,124,17,162,95s39,165-13,191-103-24-141-102-60-158-9-184z'/%3E %3Cpath d='m204606,48883c-32,0-59,27-59,59s26,59,59,59,59-26,59-59c0-32-26-59-59-59z'/%3E %3Cpath d='m200574,48883c-32,0-59,26-59,59,0,32,26,59,59,59s59-26,59-59-26-59-59-59z'/%3E %3Cpath d='m204868,48579c-754-91-1506-133-2260-133s-1509,41-2269,115c-26,8-21,90,14,86,756-73,1507-113,2256-113,743,0,1485,40,2228,129,39,4,54-80,32-84z'/%3E %3Cpath d='m200319,48495c768-75,1530-117,2289-116,754,0,1507,42,2261,133l111-184c-32,10-62,9-90-5-76-38-92-161-36-274,56-114,164-175,240-138,39,19,62,62,68,114l446-739c-204,130-328,214-581,252-281,41-409,139-368,307,38,156-57,133-201,54-314-171-541,71-652,353-73,186-159,181-168-13-4-70,0-131-7-200-21-223-89-286-216-224-161,78-175,25-137-58,28-60,86-128,66-221-9-67-66-92-151-98-182-244-467-483-649-727-182,244-374,483-556,727-86,5-142,30-152,98-20,93,52,157,80,217,38,82,23,135-137,57-127-61-186-3-207,220-7,69-10,139-13,209-9,194-95,199-168,13-111-282-352-524-667-353-145,79-203,102-182-54,23-172-107-266-388-307-253-37-377-122-581-252l419,682c12-25,29-45,53-57,76-38,184,24,240,138,56,113,40,237-36,274-10,5-21,8-32,10l100,163z'/%3E %3Cpath d='m204708,49406c-7,3-7,4-24,11-46,19-80,66-134,124-57,60-128,125-211,188-12,10-25,19-44-6s-7-35,6-44c80-62,149-124,204-182,30-32,56-63,77-92-95-11-190-21-284-30-79,24-157,55-222,95-59,35-107,77-137,125-8,14-16,27-44,11-27-16-19-30-11-44,35-58,91-107,158-147,33-20,69-38,106-54-107-9-214-18-321-25-22,13-42,29-61,47-20,19-39,42-56,67-9,13-18,26-44,8s-18-31-8-44c19-29,41-54,64-77,3-3,6-6,9-9-80-5-161-10-241-14-2,2-5,5-8,7-21,18-40,38-55,59s-28,43-38,67c-6,15-12,29-41,18-29-12-23-26-17-41,12-29,27-55,45-81,8-11,18-22,27-33-115-5-230-9-344-12-4,5-9,8-14,11-25,15-47,32-66,51s-35,40-48,63c-8,14-16,28-43,12-28-16-20-29-12-43,16-28,35-54,59-77,7-7,14-13,21-19-122-2-244-4-365-4-120,0-240,1-360,3,8,7,15,13,22,20,23,23,42,49,59,77,8,14,16,27-12,43s-35,2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115,2-230,6-345,11,11,11,20,23,29,35,19,25,33,52,45,81,6,15,12,29-17,41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81,4-162,8-243,13,4,4,9,8,13,12,24,23,45,48,64,77,9,13,18,26-8,44s-35,5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110,7-220,14-330,23,43,18,85,38,122,61,67,40,124,89,158,147,8,14,16,27-11,44-27,16-35,3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90,7-179,15-268,24,22,33,51,68,86,106,55,58,124,120,204,182,13,9,25,19,6,44s-32,15-44,6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79,36,85,75,164,126,229,53,68,120,121,209,147,8,2,21,16,22,25,28,157,84,286,169,386,52,60,114,110,188,149-75-81-132-166-172-251-67-142-90-286-77-420,1-16,3-32,34-29,32,3,30,19,29,35-11,123,9,256,72,387,56,118,159,237,291,346,24,19,0,63-29,55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205,28,428,182,801,456,1137,61,75,165,182,255,216,92,35,95,100-20,101-34,1-69,1-105,1,84,31,164,66,233,105,127,73,217,162,224,273,1,16,2,32-29,34-32,2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154,0-312-1-459,3,39,28,80,57,131,84,82,44,188,86,343,122,89,21,166,52,233,91,71,42,130,93,177,150,10,12,20,25-5,45s-34,8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123,180,393,450,573,835,689,23,7,43,13,61,19,3,1,6,1,9,2,86,21,175,40,266,55,92,15,166,28,261,37,16,1,32,3,29,34-3,32-19,30-34,29-99-9-174-22-266-38-58-10-115-21-171-33-26,6-64,9-107,12-232,14-420,225-435,494,0,5,0,11-1,16,88-80,179-157,273-212,117-68,239-103,364-69,15,4,31,8,22,39-8,31-23,27-39,22-106-28-212,3-316,63-108,63-213,158-315,253-24,147-82,285-205,377,61,34,104,65,163,45,86-39,172-78,261-108,91-31,184-52,282-57,16-1,32-1,33,31s-14,32-31,33c-91,4-179,24-264,53-75,26-149,58-222,91,221,47,460-1,667-79,60-22,105-42,133-41,51-30,112-53,172-79,66-28,132-51,182-57,16-2,32-4,35,28,4,32-12,33-28,35-112,13-127,21-222,79,0,21-66,57-126,96-36,24-70,52-87,67-95,86-144,181-188,287-29,70-52,145-68,224,55-108,121-211,201-303,94-108,208-201,345-265,14-7,29-13,42,15,13,29-1,35-15,42-129,60-236,147-324,250-90,103-161,222-219,345-31,64-8,1-42,86,110-122,212-224,323-307,132-100,283-157,418-133,15,3,31,6,26,37s-21,28-37,26c-116-21-250,32-369,121-121,92-244,223-366,361,184,26,366-26,542-85,91-30,183-135,239-152,19-24,38-46,57-67,33-37,67-71,102-100,12-10,24-20,45,4s8,34-4,45c-33,28-65,60-96,94-32,35-62,73-92,113-6,8-13,17-24,16-60,70-151,162-172,240-57,210-25,370-122,576,71-38,128-81,175-134,53-60,94-135,128-230,37-104,95-195,167-270,75-77,165-136,261-172,15-5,30-11,41,19s-4,35-19,41c-87,32-169,86-238,157-66,68-119,151-153,247-37,102-81,183-141,250-44,50-95,91-156,127,52-3,78-10,121-7,79-6,211-66,279-119,66-51,116-120,154-206,6-15,13-29,42-16s23,27,16,42c-42,96-99,174-173,231-56,43-121,75-196,93,161-5,311-42,467-100,65-24,87-168,127-208,32-58,66-112,105-158,47-56,101-101,164-127,15-6,29-12,41,18,12,29-3,35-17,41-52,21-98,60-139,108-36,42-68,93-98,147,10,73-51,228-53,305-7,205-2,409,53,612,53-71,107-134,162-192,0-5,0-10,1-15,18-106,33-219,40-332,7-112,7-223-6-329-2-16-4-32,27-35,32-4,34,12,35,28,14,111,14,226,7,340-6,90-16,180-30,269,54-51,53-51,77-103,37-80,59-159,67-237,9-80,5-157-13-230-4-15-7-31,24-38s35,8,38,24c19,80,25,165,14,252-8,65-24,132-49,199,56-42,114-82,178-122-4-75-5-153-3-227,2-68,7-134,18-190,4-20,7-40,47-33s37,27,33,48c-9,50-14,111-16,177-2,78,0,162,4,243,5,82,49,185,125,230,103,62,158,163,186,274,16-145,17-280,3-400-17-143-55-267-114-368-8-14-16-27,12-44,27-16,35-2,43,12,63,110,104,241,122,393,17,146,13,310-13,488,102-82,381-258,352-594-7-27-16-52-28-75-7-14-14-28,14-42s35,0,42,14c17,33,30,69,39,110,5,24,8,49,11,76,13-7,45-43,51-39,24,16,58,38,80,54-21-60-35-120-42-178-10-87-5-172,14-252,4-15,7-31,38-24s27,23,24,38c-18,73-22,151-13,230,9,77,31,157,67,237,4,8,8,16,5,25,24,21,47,42,70,65-13-84-22-170-28-255-8-115-7-230,7-341,2-16,4-32,35-28s29,20,27,35c-13,106-13,217-6,329,7,113,22,225,40,332,1,2,1,5,1,7,54,59,95,120,152,196,55-203,73-407,66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41,12-29,27-24,41-18,62,26,117,71,164,127,38,45,72,98,103,154,57,7,78,179,143,212,154,57,298,94,453,100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29,16-42s35,2,42,16c38,86,88,156,154,206,85,66,289,124,400,127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247-68-71-150-124-238-157-15-6-29-11-19-41,11-29,26-24,41-19,96,36,186,94,261,172,72,74,130,166,167,270,34,95,75,169,128,230,47,54,105,98,177,135-98-207-66-367-122-577-35-129-232-277-193-320,45-51,133,88,248,127,175,59,357,111,540,85-122-138-244-269-366-361-119-90-237-140-352-120-16,3-31,6-37-26-5-31,10-34,26-37,135-24,269,32,401,132,111,84,201,175,311,298-18-47,0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42,13-28,28-22,42-15,137,65,251,157,345,265,81,93,147,198,203,307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35,4-32,19-30,35-28,50,6,115,28,182,56,33,14,66,43,98,60,53,4,139,47,208,74,206,78,446,126,666,79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31,33-31c98,4,191,26,282,57,89,30,175,69,261,108,59,27,101-7,163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15,4-31,8-39-22-8-31,7-35,22-39,125-33,247,1,364,69,94,55,186,132,274,213,0-6-1-11-1-17-15-270-203-480-435-494-78-5-189,21-186-32,4-59,97-44,234-86,385-116,655-296,836-690-54,41-110,83-186,124-86,47-198,91-358,128-82,19-154,48-216,84-64,38-117,84-159,135-10,12-20,25-45,5s-14-32-5-45c47-57,106-108,177-150,67-39,145-70,233-91,155-36,261-78,343-122,51-27,92-55,131-84-148-4-305-3-459-3-143,44-289,96-402,160-110,63-186,136-192,223-1,16-2,32-34,29-32-2-31-18-29-34,8-111,97-200,224-273,69-39,149-74,233-105-35,0-70,0-104-1-116-2-112-66-20-101,90-34,190-141,251-216,271-334,412-714,456-1130-33,72-69,140-115,198-57,73-128,131-222,164-31,160-91,293-180,397-92,108-216,185-369,230-29,8-52-35-29-55,132-109,221-226,278-344,62-131,83-264,72-387-1-16-3-32,29-35,31-3,33,13,34,29,12,134-10,278-78,420-40,85-97,170-172,251,73-39,136-89,187-149,85-100,141-229,170-386,1-8,14-22,22-25,89-27,155-79,209-147,51-65,90-143,126-228-140,69-304,64-457,78-213,19-369,68-554,152z'/%3E %3Cpath d='m204649,49231c-680-88-1359-113-2041-114-684,0-1369,40-2058,112-20,6-15,33-14,46,2,28,37,35,121,27,643-60,1285-93,1932-93,674,0,1351,21,2038,102,33,9,77-85,22-81z'/%3E %3Cpath fill-rule='evenodd' d='m200570,49160c683-71,1362-110,2038-110,675,0,1349,40,2025,127l31-127c-17,9-37,15-58,15-67,0-123-55-123-123s55-123,123-123c51,0,94,31,113,75l60-170c-724-84-1446-122-2171-122-729,0-1459,38-2193,107l58,164c22-32,59-54,101-54,68,0,123,55,123,123s-55,123-123,123c-12,0-25-2-36-6l33,94-2,7zm3067-416c-68,0-123,55-123,123s55,123,123,123,123-55,123-123-55-123-123-123zm0,64c-33,0-59,27-59,59s26,59,59,59c32,0,59-27,59-59s-26-59-59-59zm-1082-91c-67,0-123,55-123,123s55,123,123,123,123-55,123-123-55-123-123-123zm0,64c-32,0-59,26-59,59s26,59,59,59,59-26,59-59c0-32-26-59-59-59zm-1064-40c-68,0-123,55-123,123s55,123,123,123c67,0,123-55,123-123s-55-123-123-123zm0,64c-33,0-59,26-59,59s26,59,59,59c32,0,59-26,59-59,0-32-26-59-59-59z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m202601,47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68,60-20,114-67,157-133,45-69,79-157,95-256,5-34,64-35,69-1,15,84,51,153,97,208,55,66,125,112,193,138,31,12,25,63-8,68-59,9-105,42-141,87-50,62-81,145-100,221-8,33-62,31-69-2zm33-118c20-52,47-103,81-146,28-34,60-64,99-84-51-30-100-70-143-120-28-34-53-73-73-116-19,59-45,112-75,158-31,47-67,86-108,116,50,19,95,47,134,82,34,31,63,68,85,110z'/%3E %3Cpath d='m203433,52971-515,206c-17,7-35,14-48-21-14-34,4-41,21-48l515-206c17-7,35-14,48,21,14,34-4,41-21,48zm59-326-604,328c-16,9-33,18-51-15s-1-42,15-51l604-328c16-9,33-18,51,15s1,42-15,51zm-1826-65,604,328c16,9,33,18,15,51s-34,24-51,15l-604-328c-16-9-33-18-15-51s34-24,51-15zm51,322,515,206c18,7,35,14,21,48-14,35-31,28-49,21l-515-206c-17-7-34-14-21-48,14-35,31-28,48-21zm224,434c137,33,261,48,358,31,88-16,155-60,191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329,5-18,9-36,45-27s32,27,27,45c-20,82-33,194,1,284,23,60,69,110,152,133,91,25,198,38,307,38,107,0,214-13,304-40,82-24,148-69,192-123s65-117,57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94,7-142,16-25,5-50,9-77,13-19,2-37,5-42-32s14-40,32-42c23-3,48-8,73-12,52-10,105-20,159-18,60,2,121,18,168,51,42,29,72,72,80,131,11,80-16,163-73,233-53,65-131,119-229,147-83,24-178,38-274,42v483c3,5,3,11,2,16,37,82,102,125,188,141,97,18,221,2,358-31,18-5,36-9,45,27,8,37-9,41-28,45-146,35-279,51-388,32-92-17-165-58-215-132-49,74-124,115-215,132-109,20-242,4-388-32-18-4-37-8-28-45,8-36,27-32,45-27zm356,210,402-9c19,0,38-1,38,37,1,38-18,38-37,38l-402,9c-19,0-37,1-38-37s18-38,37-38z'/%3E %3Cpath d='m202890,50464c151-125,293-227,423-297,133-72,254-111,359-106,19,1,37,1,36,39-1,37-20,37-39,36-92-4-200,32-322,97-125,67-263,166-410,289-14,12-29,24-53-5s-9-41,5-53zm-605,56c-141-130-298-240-445-314-139-71-268-108-363-100-19,2-37,4-40-34-4-37,15-39,34-40,110-10,252,31,404,107,152,77,315,191,461,325,14,13,28,25,2,53-25,27-39,15-53,2zm-213,1004c37-83,83-155,136-219,53-63,112-119,174-170,14-12,29-24,52,5,24,29,9,41-5,53-59,48-114,101-164,160-49,59-91,125-125,201-8,17-15,34-49,19s-27-32-19-49zm371-1734c49,66,88,139,114,223,26,82,40,175,39,279,5,80,6,165-7,249-13,86-42,170-97,246-43,60-101,97-165,113-53,13-109,10-164-7,29,100,51,208,6,308-8,18-33,27-51,18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1,2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27,1-53s40-12,53,1c39,40,89,80,150,121,60,40,128,81,204,121,124,13,247,51,370,109,106,50,211,115,317,192,13,7,19,16,27,20,8,6,16,13,25,19,51,22,104,28,152,16,47-11,90-39,122-84,48-66,72-139,84-214,12-77,11-157,6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30,7-52s41-7,52,7zm-375,1047c-104-77-207-141-311-190-105-49-210-83-314-98,2,48,8,93,18,135,13,52,35,99,71,138l1,1c30,37,73,72,130,107,60,36,134,71,225,106l-1-1c45,16,89,34,133,54,31,14,61,28,93,44,19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44,59-79,125-102,201-24,76-36,161-35,258v2c-5,77-6,158,6,234,12,75,37,148,84,214,32,45,75,72,122,84,48,12,101,6,152-16,8-6,17-13,25-19,6-4,13-12,27-20,105-77,211-143,317-192,123-58,246-95,370-109,75-40,144-80,204-121s111-81,149-121c13-13,26-27,53-1s14,39,0,53c-43,44-97,88-161,131-57,38-122,77-194,116-2,61-8,119-22,174-16,63-44,121-88,170l1-2c-35,44-85,85-150,124-63,38-141,75-237,112l-1,1c-43,15-85,32-127,51-43,19-85,40-128,62-18,9-43,0-51-18-45-100-23-208,6-308-55,18-111,20-164,7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104,13-196,39-279,26-84,65-158,114-223,11-15,22-30,52-7,30,22,19,37,7,52zm940,715c-105,15-209,49-314,98-104,49-207,113-311,190-4,13-6,21-8,29-27,88-56,184-37,267,31-15,62-30,93-44,44-20,87-38,133-54l-1,1c91-35,165-70,225-106,58-34,100-70,131-107,0,0,1-1,1-1,35-39,57-86,71-138,11-42,16-87,19-135z'/%3E %3Cpath fill-rule='evenodd' d='m203459,50602c-119,0-216,97-216,216s97,217,216,217,216-97,216-217c0-119-97-216-216-216zm0,69c-81,0-147,66-147,147s66,147,147,147,147-66,147-147-66-147-147-147zm0,60c-48,0-87,39-87,87s39,87,87,87,87-39,87-87-39-87-87-87zm-1697-124c119,0,217,97,217,216s-97,217-217,217c-119,0-216-97-216-217,0-119,97-216,216-216zm0,69c81,0,147,66,147,147s-66,147-147,147-147-66-147-147,66-147,147-147zm0,60c48,0,87,39,87,87s-39,87-87,87-87-39-87-87,39-87,87-87z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23lion' transform='matrix(0.99928092,-0.03791625,0.03791625,0.99928092,-5965.3264,-1993.2203)'/%3E %3Cuse xlink:href='%23lion' transform='matrix(0.99927613,0.03804216,-0.03804216,0.99927613,6277.9506,-17381.167)'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23171796' d='m230880,40035-25,9-8100-9258-10650,6104-1796,21560c5212,432,10304,1293,15241,2551l5329-20965z'/%3E %3Cpath fill='%23000' d='m214206,41363c370-90,735-109,1089,108,155,64,272,146,344,251,164-127,331-246,504-348,243-180,491-339,758-428,382-194,763-309,1145-344,404-69,810-73,1214-49,337,20,663,113,974,292,282,140,563,281,845,421,298,166,596,316,894,442,378,149,803,199,1256,216,222,8,440,8,654-49,173-46,281,64,90,181-1400,859-2497,95-3433-247,343,232,645,472,900,717,356,343,754,691,1458,1012,427,194,892,347,1489,352,202,2,420-6,656-45,119-19,170-8,172,54,2,42-9,126-80,173-361,242-701,306-1080,330-722,46-1494-191-2200-570-565-304-946-674-1396-1006-449-331-837-515-1254-603-411-88-856-78-1231,38,112,22,207,75,265,142,193,114,441,164,800,205,187,22,129,151-159,306-173,223-398,343-697,314-412,273-559,108-697-71-17,113-50,224-99,331,18,58,20,122-6,180,66,102,98,201,76,310,11,58,30,114,92,166,86,78,141,168,152,278,1,73,41,133,99,187,84,69,169,130,253,233,249,90,364,281,405,528,188,61,266,197,303,359,107,45,205,99,261,194,384,1,759,1,1110,38,329,35,597,240,837,506,162,25,326,33,494-5,173-76,356-134,555-151,329-28,659-45,973,30,213,51,379,164,515,318,196,223,498,193,756,83,350-149,641-144,999,13,153-59,306-87,459-71,131-142,270-177,413-181,233-8,402,28,358,327-12,81-60,159-121,187-107,231-311,299-570,277-28,159-93,277-197,353,119,367,5,514-267,509-57,106-142,172-287,151-106,129-231,195-368,217,16,96,57,141,125,244,185,280-93,393-347,397,65,185,73,370,50,555,259,157,294,322,55,485,175,306,107,531-221,695-5,171-22,343-136,439-78,66-190,78-116,202,133,220,104,498-93,506-42-4-80,2-83,69,0,23-20,46-59,69-236,127-457,272-660,439-30,20-60,34-90,7-148,322-424,649-729,978-47,242-184,406-411,491-16,75-64,119-135,138,127,141,175,277,52,411-151,165-350,326-549,377-423,108-688,88-858-74-150-143-91-251,4-296-261,21-314-117-307-301,15-92,46-80,138-77,142,4,270-73,404-117,52-88,120-164,204-228,47-296,234-460,488-557,205-78,401-276,591-532,117-202,235-403,352-605-82-107-104-214-107-321-108-60-183-134-235-218-184-13-260-96-287-211-42,1-88-3-138-18-90,58-181,109-294,104-149,153-303,278-460,384-55,152-164,213-297,232-378,45-604,516-812,708-84,62-136,172-173,304-18,248-61,442-197,446-122-5-141-18-145-31-53-5-106-5-159,7,102,112,118,253,24,377-94,122-229,160-359,169-269,18-487-6-689-88-193-79-216-194-210-306-139-66-167-132-152-197,19-84,96-127,193-100,84-40,168-67,252-83,244-263,495-489,771-594,81-98,174-186,287-259,32-236,187-422,377-595,17-85,45-171,93-256-11-51,3-75,4-123-77-143-123-315-66-458-23-69-30-159-21-228-454,270-594,178-646-41-166,139-321,204-432,4-161,48-323,102-484,38-105,41-211,78-332,86-49,97-115,194-204,291-5,204-76,408-207,612-76,218-170,435-294,653,2,70-8,140-45,211,35,251-49,373-187,435-37,101-92,203-176,304-4,33-7,67-11,100,55,148,64,295-86,443-121,76-250,156-378,219-151,74-291,39-418-7-223-80-206-158-177-234-70,28-150,31-220-3-54-34-88-69-142-104-48-87-65-166,52-228,147-65,247-113,363-232,40-90,91-158,163-176,70-164,156-275,273-305,86-203,178-427,287-621,38-59,66-120,48-187-2-55,2-107,48-138,26-22,72-42,14-73-53-181-20-354,69-487,118-178,250-608,125-819-23-118-46-253-31-364-43-2-75,4-118-26-96-59-176-3-249,104-53,134-106,252-159,252-50,346-220,615-397,684-41,159-67,318-45,477,18,173,0,291-80,311-88,22-170,73-221,214-14,39-30,86-31,142,122,126,85,283-32,399-264,260-592,222-939,120-251-99-312-204-287-311-356-30-285-303,10-385,317-89,574-292,785-582,19-344,98-578,283-615,18-211,84-401,173-581,93-163,150-342,117-560-197-123-205-250-24-380,60-35,53-71-21-107-120-12-105-127-97-235-5-56-34-85-87-86-266-39-200-148-86-266,48-54,80-134,30-166-41-26-69-117-78-197-163-123-93-249,0-370-92-78-135-192-148-325-303-13-416-167-252-391,69-95,158-186,266-273,70-113,137-226,104-339-87-221,191-388,429-560-33-58-50-115-52-173-134-129-100-249,48-363-33-59-49-118-55-176-333,66-331-133-176-453-193-111-139-308,211-608,5-69,18-122,38-159-166,4-303,53-422,128-133,87-265,76-398,21-41-66-104-122-176-173-91-80-112-170-93-266-392,22-467-268-232-439,131-104,227-213,263-332,106-269,331-452,550-640,0-77,17-154,41-232-97-65-199-112-311-121-40-100-115-208-242-269-73-44-97-85-52-184-208-186-156-299-103-406z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m221318,51461c-23,2-47,4-74,3-101,103-222,206-334,294-97-112-241,11-100,79-24,17-48,34-72,50-46,122-88,174-224,195-21,3-42,7-63,12-1-52,1-102,6-151,6-61,16-120,29-178,2-11,5-21-16-26s-24,6-26,17c-13,60-24,121-31,183-6,55-8,111-6,167-343,110-541,467-775,721-101,87-152,207-189,333-20,67-27,374-96,379-33,1-68,0-105,0-37-56-87-57-150-4-143-3-295-4-422,16-87,94,152,59,279,137,58,35,83,104,60,200-117,279-770,189-987,74-101-53-105-114-101-201,45,0,91-3,137-10,78-11,155-34,231-77,21-12,43-24,19-67s-46-31-67-19c-64,37-130,56-196,65-68,10-138,10-205,7-6,0-12-1-17,0-38-22-67-48-51-71,16-22,79,2,91,6,101-47,189-77,298-98,230-246,464-477,781-604,95-114,198-204,322-286,44-274,177-420,376-602,24-113,52-194,108-293-12-63-3-103,0-167-76-144-121-269-61-430-37-117-32-196-18-304,4-28,3-48-1-61,62-49,125-95,187-137,57-38,114-73,171-105-9,108-5,221,16,339,0,0-1,1-1,1-34,37-63,73-83,111-21,39-33,78-31,117,0,11,0,22,22,21,22,0,22-11,21-22-1-31,8-63,26-95,18-33,45-67,77-101,3-3,6-7,8-11,105-3,208-59,311-142,93-76,186-174,278-277-1,150-2,300-4,450-90,80-167,178-227,297-5,10-10,19,9,29,20,10,25,0,29-10,55-109,125-199,206-274h4c22,0,22-11,22-22v-1c14-12,29-24,44-35,102-79,218-139,343-187-19,132-28,261-5,385,25,136,89,264,219,376,2,2,5,3,8,4z'/%3E %3Cpath d='m214786,47657c17-31,60-71,74-68,3-1,5-1,8-2,47-88,96-170,147-244,66-96,136-181,210-253,8-8,16-15,31,0,15,16,7,23,0,31-72,70-140,152-205,246-50,73-98,153-144,240,15,20,22,51,14,73,15,137,33,214,94,293,7-6,14-11,21-14,25-61,59-115,101-163,52-58,115-107,191-148,52-43,94-87,128-133,34-45,61-91,80-138,4-10,8-20,29-12,20,8,16,19,12,29-21,51-49,100-85,148-37,48-82,95-138,141,0,0-3,2-4,2-71,39-132,85-180,139-37,41-66,87-89,138,32,23,46,86,16,126-91,131-199,208-29,320-6,88,22,155,80,216,39,41,35,184-61,287-90,91-21,67,72,78,7,2,14,5,21,7v-1c34-66,74-125,118-180,43-54,90-105,138-153,67-66,120-138,158-211,37-71,59-144,63-214,1-11,1-22,24-20,22,1,21,12,20,23-5,76-28,154-68,232-40,77-96,152-166,221-47,47-92,95-134,149-42,53-80,110-113,173,112,68,76,190,93,302,22,3,41,8,58,16,1-2,2-4,4-6,22-34,44-69,66-104l104-165c6-9,12-19,30-7,19,12,13,21,7,30l-104,165c-22,35-44,69-66,104-1,2-2,4-3,5,69,56,74,158-11,236-167,126-120,165,36,265,20,147,21,265-11,390,1,3,1,7,2,11,4,41,7,83,10,124l10,125c1,11,2,22-20,24s-23-9-24-20l-10-125c-1-11-2-21-2-32-8,19-16,39-26,60-112,245-228,445-253,720-269,64-229,329-244,563-212,286-458,515-799,629-64,21-219,59-234,140-2,29,104,92,172,55,188-180,282-80,66,104-17,35-3,74,34,107,195,175,678,232,898,93,163-102,248-214,106-369,9-220,95-435,327-497,27-50,19-143,7-194-22-191,8-361,55-545,8-23,25-42,63-52,88-18,257-273,310-518,13-53,21-108,31-163,14-85,47-100,90-50,41-55,40-88,65-151,90-131,220-236,372-162-39-107-66-228-74-351-11-146,3-297,48-435,6-21,13-41,46-36,44-104,87-207,131-311s88-209,132-313c4-10,8-20,28-12s16,19,12,29c-44,104-88,208-132,313-44,104-87,207-131,310,19,14,13,32,7,50-40,125-53,263-43,398,10,146,46,287,100,402,5,11,11,22,9,33,72,42,71,52,68,148-2,75,8,149,26,239,143,264-6,706-145,927-67,107-85,229-57,352,86,83,30,169-46,227-6,20,0,43,1,63,8,86-23,158-68,229-117,211-207,436-301,657-170,47-205,146-273,305-99,28-109,57-151,148-114,115-223,184-369,250-121,55-4,108,81,166,77,57,178-67,241-161,69-104,139-73,94,8-50,89-86,217-91,284-26,72,248,127,295,129,167,8,377-155,508-238,109-111,92-208,44-343l1-9c-70,2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29,8-20,19-16,29-12,78,32,153,59,229,75,63,14,128,21,197,19l11-105c87-107,147-212,194-340,185-87,186-177,161-375,41-80,50-127,47-218,122-217,222-439,305-674,146-194,216-377,199-608,13-90,46-141,112-138,48-67,91-136,130-213,8,1,16,2,24,2-2-5-1-11,0-16,12-53,26-100,44-139,17-39,37-70,60-95,27-66,37-130,30-192-7-64-29-126-65-187-22-25-42-51-49-78-9-31-3-62,28-93,8-8,16-15,31,0,15,16,8,24,0,31-18,17-21,33-16,49,6,20,22,41,41,63,0,0,2,4,2,4,39,67,65,136,72,207s-3,144-35,217c0,1-4,6-4,7-21,22-39,50-55,85-16,37-30,80-41,130-1,3-1,6-2,8,103,0,194-32,293-81,2-2,4-4,6-6,50-40,103-101,147-181,37-67,67-149,84-243,2-11,4-21,26-18,21,4,19,15,18,25-18,100-50,185-89,257-34,63-74,114-114,154,160,48,299,1,451-46-22-214-19-377,4-505,25-139,72-237,131-311,7-9,13-17,31-4,17,14,11,22,4,31-55,69-99,161-122,292-22,122-26,278-5,484,2-1,5-1,8-2,64,109,98,188,229,103,48-32,98-64,138-106,15-16,10-25,22-38,125-133,251-257,376-367,126-111,252-206,378-283,9-6,19-12,30,7s2,24-7,30c-124,75-248,170-372,278-107,94-214,198-321,310,6,19,9,52,12,102,11,148,38,237,249,156,118-45,130-50,239-115,53-32,98-59,129-66,69-54,137-105,206-151,67-45,135-86,202-122,11-80,29-158,55-233,65-192,174-370,311-538,1-1,6-5,7-6,114-62,207-135,281-218,75-83,131-176,173-277,4-10,8-20,29-12,20,8,16,19,12,29-44,105-103,202-180,289-77,86-172,162-290,226-133,164-239,336-301,521-22,65-39,131-49,200,4,1,8,5,12,13,10,20,0,25-9,29-3,1-6,3-9,5-13,108-10,222,10,340,93-3,187-55,282-132,101-82,204-195,306-310,1-3,1-5,4-7,25-82,57-154,99-212,45-62,100-109,168-138,10-4,20-9,29,12,8,20-1,24-12,29-60,26-110,68-150,123-40,56-71,126-95,206-1,156-3,312-4,468,5-4,11-8,16-13,115-89,247-155,390-207,15-6,32,8,29,24-22,140-34,279-11,407,22,120,76,232,184,332,41-74,89-140,141-200,18-21,37-41,56-60,1-2,2-4,5-5,41-41,83-79,127-115,32-29,64-59,95-89,32-29,64-59,96-89,8-8,16-15,31,1s7,24-1,31c-32,30-64,59-96,89-32,29-64,59-96,89,0,0-1,1-1,1-41,33-81,68-118,106,1,41,3,81,5,122,1,22,1,44,2,66,92,25,147,26,241,24,31,185,47,214,208,218-2-66-1-130,6-193,8-72,23-142,48-208,4-10,8-20,28-13,21,8,17,18,13,28-24,62-38,128-46,197-7,61-8,124-6,189h13c64,132,140,197,276,256,38-60,66-120,84-180,20-67,28-134,24-201-1-11-1-22,20-23,22-1,23,9,24,20,5,72-4,144-26,216s-57,143-105,214c-4,6-8,12-15,12,6,77,19,134,46,192,20-43,41-86,65-126,33-58,71-110,117-156,8-8,15-15,31,0,15,15,8,23,0,31-43,42-78,93-110,147-28,48-53,100-77,153,15,26,34,52,56,82-256,439-530,1047-1035,1247-261,103-375,236-427,515-98,76-168,153-232,259-170,57-322,142-506,134,0,119,39,171,158,172,227-114,278-135,298-119,28,24-32,187-220,319-29,18-28,29-11,59,159,249,576,160,800,101,160-42,449-232,529-392,31-74-39-169-109-247-320,49-259-258,16-130,93-28,105-29,131-132,245-95,347-198,403-461,247-266,495-540,673-859,49-60,78-166,64-221,44-52,68-118,84-178,16-64,26-127,24-191,0-11-1-22,21-23s22,10,23,21c2,68-8,135-25,203-14,52-32,104-51,156,16,40,24,67,59,57,214-172,430-293,661-436,16-98,79-146,176-150,39,1,53-11,67-47,54-135-14-228-79-340-60-167,47-207,154-287,112-83,104-303,108-430h1c-4-21-8-43-13-65-9-44-22-88-38-135-4-10-7-21,13-28,21-7,24,3,28,14,17,49,30,95,40,140,4,18,7,36,11,53,107-55,219-119,261-238,37-132-35-257-99-369-27,13-55,26-84,38-52,23-108,47-167,70-10,4-20,8-28-12s2-25,12-28c57-23,112-46,165-70,44-19,86-39,125-58,48-32,97-66,132-111,77-111-130-211-202-256,0-3,1-6,1-9-104-95-207-191-311-286-8-7-16-15-1-31s23-9,31-1c96,88,192,176,288,264,16-163,18-319-33-481-16-52-35-103-53-154-4,0-8-2-12-5-88-45-150-100-190-163-41-63-61-133-67-209-1-11-1-22,21-24,22-1,22,10,24,21,5,68,22,132,59,188,37,57,93,107,174,148,87,45,270,22,376-29,147-83-45-251-90-350-32-71-40-144-54-220,13-2,26-5,40-7-19-24-39-45-59-62-25-22-52-38-79-48-10-4-21-7-13-28,7-21,18-17,28-13,33,12,64,31,93,56,28,24,54,53,79,87,14-2,29-5,43-8,145-29,225-110,313-214-48-58-101-112-158-163-59-53-119-103-180-152-8-7-17-14-3-31s22-10,31-3c62,50,124,101,182,154,59,54,115,111,166,173,5,6,10,12,6,20,133,12,155-15,222-134-17-61-45-118-80-173-37-57-82-111-133-163-8-8-15-16,0-31,16-15,24-7,31,0,52,54,100,111,138,170,38,58,67,118,85,183,62,1,129,4,182-28,116-69,18-317-12-413,2-1,3-2,5-4-15-10-31-20-46-29-27-17-55-34-82-52-9-6-18-12-7-30,12-19,21-13,30-7,27,17,55,35,82,52,20,13,40,25,60,38,9-7,18-14,27-21,85-68,115-158,141-252,40-144,48-80,216-105,181-28,279-48,386-260,56-28,85-52,95-121,18-125,8-189-135-200-200-16-322,24-457,156,18,27,36,55,54,82,6,9,12,18-6,31-18,12-24,3-30-6-17-26-34-52-51-78-182-18-328,11-498,75-17-7-34-14-51-21,36,48,64,94,85,139,29,64,44,125,46,183,0,11,1,22-21,23s-22-10-23-21c-2-53-15-108-42-167s-68-121-126-187l-1-1c-142-51-272-77-405-74,22,22,45,44,67,65,29,28,58,56,86,84,8,8,16,15,0,31-15,16-23,8-31,0-29-28-58-56-86-84-29-28-58-56-86-84-3-3-6-6-8-9-113,9-230,39-359,93-81,34-164,60-245,75,60,58,111,123,151,197,42,76,74,160,95,253,2,11,5,21-16,26s-24-6-26-16c-20-89-51-170-91-242s-90-136-149-192c-6-5-11-11-9-19-75,11-150,12-222,1l89,147c5,10,9,20-10,29-20,9-25,0-29-10l-82-172c-69-14-137-40-200-79,21,79,37,164,49,254,16,119,26,246,29,380,0,11,1,22-21,22s-22-11-22-21c-3-133-12-259-28-375-15-107-35-208-63-300-31-24-61-52-90-84-72-79-152-140-240-187,5,37,5,73,0,109-9,66-36,133-88,198-7,9-13,17-31,4-17-14-11-22-4-31,47-59,71-118,79-177,6-42,4-85-5-127-137-63-288-94-444-107,42,55,82,110,118,167,42,66,80,133,114,201,62,51,95,113,114,181,18,67,22,139,25,212,0,11,1,22-21,23s-22-10-23-21c-2-70-6-139-23-202-17-61-47-117-102-161-1-1-6-6-6-7-34-68-72-135-113-201-42-66-88-130-139-192l-2-2c-53-3-106-4-159-3,9,12,18,24,26,37,19,31,32,65,36,104,1,11,2,22-20,24s-23-9-24-20c-4-32-14-60-30-86-13-21-28-40-47-58-110,3-219,12-324,21,110,141,198,287,266,437,76,167,127,339,156,517,2,11,4,22-18,25-21,4-23-7-25-18-29-174-79-343-153-506-71-155-163-306-279-451-5,0-11,1-16,1-85,8-171,26-253,49,37,23,69,46,97,69,38,31,68,62,94,93,7,9,14,17-3,31s-24,6-31-3c-24-29-53-59-88-88-35-28-76-57-126-86-44,14-87,30-130,47-24,9-47,18-71,25,74,53,145,111,213,176,82,79,159,168,228,271,6,9,12,18-6,30s-24,3-31-6c-67-100-141-187-221-264-75-72-155-135-238-193-90,20-181,25-272,22,56,111,105,223,142,336,40,122,68,245,77,370,1,11,2,22-20,24s-23-9-24-20c-9-122-36-241-75-360-40-119-92-236-151-352-55-4-111-11-167-18,32,102,60,207,84,314,28,126,51,255,68,386,1,11,2,22-19,25-22,3-23-8-25-19-16-130-39-258-67-382-26-116-57-230-93-342-158-171-333-338-547-427,44,56,79,114,104,175,39,94,57,194,54,299,0,11-1,22-22,21-22,0-22-12-21-22,2-99-14-193-51-282-33-79-81-153-148-222-48-14-99-25-151-30-140-14-281-23-422-28,108,98,193,188,185,297-1,11-2,22-24,20s-21-13-20-24c7-101-93-192-210-296-84-3-169-4-253-5,46,47,86,94,118,141,44,64,75,128,90,192v3c9,99,33,186,77,258,43,71,105,126,190,165,10,5,20,9,11,29s-19,16-29,11c-93-42-161-104-209-182-47-77-73-169-83-274-14-58-42-117-83-176-38-55-87-111-145-167-94,0-187-1-281-1,39,111,66,225,85,341,22,142,32,287,35,434,0,11,0,22-22,22s-22-11-22-21c-2-145-12-289-34-428-19-119-47-235-88-348h-26c-61-100-118-144-206-185-1,10-2,20-5,29-7,30-19,60-40,90-6,9-13,18-31,6s-12-21-6-30c17-25,28-50,33-74,3-13,5-26,5-40-14-6-29-12-45-19-45-188-87-266-237-330-1,52-4,106-14,161-12,68-34,137-75,203-6,9-12,19-30,7-19-12-13-21-7-30,38-61,58-124,69-187,10-57,13-115,13-171-8-3-17-6-26-9-40-263-88-410-361-514,3,34,4,69,2,104-3,59-14,119-38,181-4,10-8,21-28,13s-16-18-13-28c22-57,32-113,35-168,3-52-1-104-8-155-58-66-141-129-212-199,2,97-11,193-38,290-33,117-87,235-163,352-6,9-12,19-30,7-19-12-13-21-7-30,73-113,126-227,158-340,31-108,42-217,34-326-31-34-57-71-75-110-2,5-4,10-6,14-11,24-21,48-32,72-5,10-9,20-29,12-20-9-16-19-12-29,11-24,21-48,32-72,8-19,17-39,25-58-2-12-4-24-5-37-9-84-54-149-115-204l-1-1c-8,26-18,53-30,79-19,41-44,81-76,122-7,9-13,17-31,4-17-14-10-22-4-31,30-38,53-76,71-113,15-32,26-64,34-97-28-33-48-67-64-104-10,24-24,48-42,72-21,28-48,55-82,83-8,7-17,14-31-3s-5-24,3-31c31-25,55-50,74-75s32-49,41-74c14-39,19-14,6-77,23-124-23-198-89-301,1-3,2-5,4-8-39,1-84,14-133,35-59,26-124,65-192,112-9,6-18,12-30-6-13-18-4-24,6-30,71-48,138-88,199-115,62-27,119-42,168-39,12-33,13-58,5-96-200,74-358,109-485,117-133,8-235-13-320-49-10-5-20-9-11-29,8-20,19-16,29-12,79,34,174,54,300,46,125-8,279-42,477-116-1-2-1-4-2-6,36-80,65-158,85-236-71,19-141,18-211,16h-14c-11,0-22-1-22-22,0-22,12-22,22-22h14c74,1,148,3,221-21,5-26,9-52,13-78,11-87,113-108,185-30,60,64,115,132,174,160,120,57,255,6,352-72-29-9-59-19-89-29-11-3-21-7-14-27,7-21,17-18,27-14,38,12,76,24,114,37,9-9,18-18,26-27,248,21,409-31,568-191-141,3-267-1-376-13-120-14-219-38-292-74-10-5-20-10-10-29,10-20,20-15,29-10,68,34,163,57,278,70,117,13,255,17,412,12h2c14-16,28-33,43-51,68-28,136-59,186-115-289-31-564-88-823-223-67-75-173-117-286-146-210-26-396,26-567,115-45-42-80-80-124-121-66-8-128-43-194-51-88-10-180,7-268-3-11-1-22-2-19-24,2-22,13-21,24-19,88,10,180-7,268,3,85,10,166,47,251,57,284-107,519-166,722-157,237-69,483-98,729-92-3-2-6-5-9-8-29-29-15-44,0-58,133-135,164-259,121-371-44-116-164-225-331-325-178,20-349-28-538-7-118,13-234,39-348,77,95,34,178,90,246,170,84,99,144,234,176,404,4,20,7,41-33,48-40,8-44-13-48-33-29-155-83-277-158-366-79-113-260-157-317-180-189,19-375,40-537,82-122,31-229,74-311,138,122-26,249-21,359,34,105,52,194,150,250,309,7,19,13,39-26,52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681,101-88,66-176,151-263,250-16,19-33,37-70,5-37-33-21-51-4-69,91-103,183-194,278-264,92-68,187-117,285-140,100-111,248-178,419-222,167-43,358-65,552-84-57-115-130-184-214-221-90-40-193-46-305-35-233,80-440,205-639,346,18,0,36,0,53,1,59,4,112-5,161,14,19,7,39,14,25,53-17,47-146,18-191,15-51-3-107,1-169,16-9,2-19,5-28,2-243,150-417,302-619,473l-34,12c-180-7-304,18-378,74-67,51-72,131-59,239-31,101-70,212-80,330-211,181-446,362-555,626-24,77-65,145-116,206,43,7,78,20,105,41,10,8,19,16,27,26,5-45,12-90,23-133,15-62,37-119,66-165,6-9,12-18,30-6,19,12,13,21,7,30-27,41-47,94-61,152-17,69-26,145-28,215-1,22-41,24-44,2-5-37-21-66-47-85-27-20-65-32-114-36-45,49-96,93-147,134-42,34-82,71-91,126-6,96,112,113,224,120,255,15,52,160,192,287,68,47,131,102,179,169,97,35,157,27,223-3,13-173-2-261,74-261h8c4-22,9-44,18-66,13-32,32-65,58-97,7-8,14-17,31-3s10,22,3,31c-23,29-40,58-51,86-9,24-15,48-18,72,13,26,10,77,9,168,145-71,277-89,425-96,277-324,395-242,152-6-14,27-27,51-39,74-42,81-69,144-78,254-71,62-419,348-289,454,91-13,148-9,113,59-43,91-173,280-130,384,16,38,72,34,127,21,4-4,8-7,12-11,91-74,187-159,277-258,89-97,172-208,239-335,9-18,18-35,44-29,27-100,59-199,95-299,37-103,79-207,124-311,7-15,28-18,38-4,38,55,75,95,112,121,33,24,66,35,98,35s65-11,98-33c36-25,72-63,109-115,6-9,13-18,31-5s12,21,5,31c-40,56-79,97-120,125s-81,42-123,41c-41,0-82-15-123-44-33-24-67-57-100-101-39,91-75,182-108,273-37,101-69,203-97,304,23,19,13,37,4,55-72,135-160,252-254,355-76,84-157,158-236,225,11,74,30,144,64,216,151-130,292-262,416-398,124-137,232-278,317-425,6-9,11-19,30-8s13,21,8,30c-44,76-94,150-148,223,10,15,2,21-6,28-16,13-25,65-29,132-6,91,0,204,10,285,1,11,3,22-19,25s-23-8-25-19c-11-85-16-201-11-293,1-24,4-46,7-66-33,39-67,78-102,117-126,139-270,273-424,405-1,1-3,2-4,3,4,8,9,16,14,24-134,97-243,131-93,261,50-36,100-72,150-108l160-115c9-6,18-13,31,5s4,24-5,31l-161,115c-52,37-103,74-155,111-3,61,11,105,38,153,13-2,24-3,33-3,112-81,224-163,336-244,9-7,18-13,31,5s4,24-5,31c-108,79-217,158-326,237-7,13-21,30-39,50-110,79-494,316-453,480v1c92-26,184-58,272-103,91-47,180-110,264-196,8-8,15-15,31,0,15,15,8,23,0,31-87,89-179,153-274,203v4c-1,15-1,30-2,45s-1,30-2,45c-1,11-1,22-23,21s-21-12-21-23c1-15,1-30,2-45,1-8,1-17,1-25-78,36-157,63-237,85,33,155-48,288-131,421-47,38-431,349-271,442,43,21,91,31,139,36z'/%3E %3Cpath d='m214960,42248c-80-48-183-107-283-127-51-98-120-177-213-237-74-48-74-44-46-97,84-9,119-32,120-55,44,1,82,7,114,18,37,13,65,32,85,59,7,9,13,18,31,4,18-13,11-22,4-31-26-33-61-58-106-74-43-15-95-22-156-20-5,0-9,0-13,2-32-15-80-25-140-23-57-54-105-117-82-195,3,3,8,4,13,5,45,13,87,26,123,43,35,15,64,34,84,56,7,8,15,16,31,1s9-23,2-31c-25-27-58-48-98-67-29-13-61-25-95-35,330-67,625-62,920,113,155,64,228,138,312,252-28,24-56,47-84,71-193-5-335,22-424,90-80,60-96,168-99,276z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m221520,51380c-65,40-118,68-185,79,3-2,6-5,8-8,43-81,93-152,149-216,7-8,15-17,22-25,1,27,2,53,3,80,1,30,2,61,3,91z'/%3E %3Cpath d='m222347,53150c-44,66-98,126-159,181-60,54-128,105-201,153-9,6-19,12-31-6s-3-24,6-30c70-46,136-96,196-149,59-53,111-110,152-173,6-9,12-18,31-6,18,12,12,21,6,30z'/%3E %3Cpath d='m222894,52498c-28,42-55,84-83,127-6,9-12,18-31,6-18-12-12-21-6-30,28-42,55-85,83-127,6-9,12-18,31-6,18,12,12,21,6,31z'/%3E %3Cpath d='m222596,52456c-14,63-37,123-77,178s-99,104-184,143c-10,5-20,9-29-11s1-25,11-29c78-36,131-80,167-129,37-49,57-104,70-162,2-11,5-21,26-16s19,15,16,26z'/%3E %3Cpath d='m223132,51802c-22,22-41,47-58,75-16,28-31,58-42,92-4,10-7,21-28,14s-18-18-14-28c12-36,27-69,46-100s40-58,64-83c8-8,15-15,31,0,15,15,8,23,0,31z'/%3E %3Cpath d='m223570,51845c-19,62-37,125-60,187-23,64-51,127-87,190-6,9-11,19-30,8s-14-21-8-30c35-61,61-122,84-182,22-61,40-123,59-185,3-11,6-21,27-15s18,16,15,27z'/%3E %3Cpath d='m223371,49282c136,200,166,406,171,613,15-75,32-151,53-226,0-1,3-7,3-7,57-80,93-160,111-239s18-159,4-238c-2-11-4-21,18-25,21-4,24,7,26,18,15,85,15,171-4,256-19,84-56,168-115,252-37,139-64,279-90,419l-5,26c-4,21-44,18-44-4,0-16,0-31,1-47,3-261,6-523-163-771-6-9-13-18,6-31,18-12,25-3,31,6z'/%3E %3Cpath d='m223038,49711c-2,17-3,34-5,50-1,17-3,34-4,51-1,11-2,22-24,20s-21-13-20-24c1-17,3-34,4-50,1-17,3-34,5-51,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m222945,50293c34,111,60,224,79,340,13,79,21,159,25,241,9-15,19-29,30-43,36-45,84-84,141-117,9-6,19-11,30,8s2,25-8,30c-53,31-96,66-128,107-32,40-53,85-62,136-4,22-44,18-44-4,1-120-9-237-27-351s-44-225-77-334c-3-11-7-21,14-27s24,4,27,14z'/%3E %3Cpath d='m223409,50501c19,90,31,176,35,259s1,164-8,243c-1,11-3,22-25,19s-20-14-19-25c9-75,12-153,8-235-4-81-15-166-34-252-2-11-5-21,17-26,21-5,24,6,26,17z'/%3E %3Cpath d='m223807,50427c15,82,23,162,19,239-4,78-19,152-51,224-27,82-29,164-15,246,14,84,46,168,84,253,5,10,9,20-11,29s-25-1-29-11c-40-87-73-175-88-263-15-90-13-179,17-269,0,0,1-2,1-2,29-66,44-136,47-209,4-74-4-151-19-229-2-11-4-21,18-25s24,7,26,18z'/%3E %3Cpath d='m223999,49767c-10,41-20,83-31,125-10,41-20,83-31,125-2,11-5,21-26,16s-19-16-16-27c10-41,20-83,31-125,10-41,20-83,31-125,3-11,5-21,27-16,21,5,19,16,16,27z'/%3E %3Cpath d='m223802,48671c12,38,23,76,35,114,3,11,6,21-15,27-21,7-24-4-27-14-12-38-23-76-35-114-4-11-7-21,14-27s24,4,27,14z'/%3E %3Cpath d='m223903,47838c1,52,1,104-3,327-47,42-81,95-99,161-18,67-20,149-3,247,2,11,4,22-18,26s-24-7-26-18c-19-105-16-193,4-266,20-75,59-135,112-182l-9-139c-1-52-1-104-2-155,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m223076,47548c128,84,238,177,314,287,77,111,121,238,116,388-1,15-17,25-31,19-72-31-145-62-217-93,48,311,36,559-32,749-72,201-205,338-395,416-17,7-35-9-29-27,37-118,59-236,68-354s4-236-16-353c-2-11-4-22,18-25,22-4,24,7,25,18,20,121,26,243,16,364-8,106-26,211-56,318,155-76,265-198,327-371,68-191,78-445,24-767-3-17,15-31,30-24,74,32,149,64,223,96-2-126-42-234-108-329-73-105-178-194-302-275-9-6-18-12-6-31,12-18,21-12,30-6z'/%3E %3Cpath d='m225241,47122c-6,14-12,29-18,43s-11,29-17,43c-4,10-8,20-28,12s-16-18-12-28c6-14,12-29,18-43s11-29,17-43c4-10,8-20,28-12s16,18,12,28z'/%3E %3Cpath d='m224732,47111c42,17,76,40,104,68,28,27,49,59,67,94,5,10,10,20-9,29-20,10-25,0-29-9-16-31-35-59-59-83s-53-44-90-58c-10-4-20-8-12-28s18-16,28-12z'/%3E %3Cpath d='m223976,47328c55,61,91,132,110,213,19,79,22,167,12,261-1,11-2,22-24,20s-21-13-19-24c9-90,7-173-11-247-18-73-50-138-100-193-7-8-15-16,2-31,16-15,24-6,31,2z'/%3E %3Cpath d='m221421,47574c-3,29-6,58-9,86-3,29-6,58-8,86-1,11-2,22-24,20s-21-13-19-24c3-29,6-58,8-86,3-29,6-58,9-86,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m221895,47324c12,41,24,82,37,123l11,37c3,11,6,21-15,27s-24-4-27-15l-11-37c-12-41-24-82-37-123-3-10-6-21,15-27s24,4,27,15z'/%3E %3Cpath d='m222867,47977c5,18,8,36,9,53,1,18,1,35,0,53-1,11-2,22-24,20s-21-13-20-24c1-15,1-31,0-46-1-16-4-31-8-46-3-11-6-21,15-27s24,5,27,16z'/%3E %3Cpath d='m223202,47237c21,21,35,44,40,66,6,24,2,48-10,71-5,10-11,20-30,9-19-10-14-20-9-30,7-14,9-27,6-41s-13-30-28-46c-8-8-15-15,0-31,15-15,23-8,31,0z'/%3E %3Cpath d='m220882,47354c0,52,8,102,25,148,17,47,44,91,82,132,51,58,77,115,91,173,14,57,15,113,18,168,0,11,1,22-21,23s-22-10-23-21c-2-54-4-108-16-160-13-52-36-103-81-155-42-45-71-94-91-146-19-52-28-107-28-164,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m221821,47986c52,97,81,192,92,288,12,95,6,192-11,293-19,117,6,231,70,338,59,100,152,195,272,283-37-129-59-256-54-379,6-144,50-283,151-414,43-56,72-114,92-173,21-59,32-119,40-177,1-11,3-22,24-19,22,2,20,13,19,24-8,62-20,124-41,186s-53,125-99,185c-95,124-136,254-142,389-6,137,24,279,70,425,6,19-17,35-33,25-151-102-266-214-337-333-69-117-97-240-75-367,16-97,21-190,10-281s-38-180-87-272c-5-9-11-19,9-29,19-11,25-1,30,9z'/%3E %3Cpath d='m221444,48563c0,104-29,208-81,312-41,82-95,163-159,244,33-13,67-26,100-42,58-27,116-59,174-103,40-30,81-65,121-107,41-42,82-91,124-149,6-9,13-18,31-5s11,22,5,31c-43,59-86,110-128,154-38,39-76,73-114,102,6,27,10,47,14,68,5,25,10,50,15,76,2,11,5,21-17,26-21,5-24-6-26-17-7-31-11-54-16-77-3-16-6-32-10-48-52,37-105,65-156,89-60,28-119,49-178,71-19,7-37-19-24-35,84-100,155-199,204-298,49-98,77-195,77-292,0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m220985,48526v99c0,11,0,22-22,22s-22-11-22-22v-99c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m220697,47964c60,147,76,284,53,412-22,128-83,247-174,359,0,0-3,3-3,3-87,75-152,165-200,266-33,68-58,141-77,218,24-33,48-64,77-93,57-58,125-103,215-128,92-51,179-107,260-170,82-64,158-134,228-213,7-8,15-16,31-2s9,22,2,31c-72,81-150,153-234,218s-173,123-268,175c0,0-5,2-5,2-82,22-145,64-198,117s-95,119-136,187c-11,18-44,6-40-15,22-124,55-241,105-347s118-200,210-279c86-106,143-218,164-338s6-249-51-388c-4-10-8-20,12-29,20-8,25,2,29,12z'/%3E %3Cpath d='m221630,49460c-14,40,15,77,74,153,13,17,27,35,40,52,79,105,108,224,110,349,2,122-21,249-45,372-4,21-40,20-43-1-20-136-78-256-163-363-86-108-201-204-333-292-9-6-18-12-6-31,12-18,21-12,30-6,136,91,254,190,343,302,68,85,119,177,149,278,15-87,26-174,25-258-2-116-29-226-101-323-15-21-28-37-39-51-69-89-102-132-81-194,4-10,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m222028,49434c16,17,33,34,49,52,16,17,33,34,49,52,8,8,15,16-1,31s-24,7-31-1c-16-17-33-34-49-52-16-17-33-34-49-52-7-8-15-16,1-31s24-7,31,1z'/%3E %3Cpath d='m222516,49591c-31,98-61,195-91,293-31,98-61,195-92,293-3,11-6,21-27,14-21-6-18-17-14-27,31-98,61-195,91-293,31-98,61-195,92-293,3-11,6-21,27-15,21,7,18,17,14,28z'/%3E %3Cpath d='m222792,51228c-9,25-9,49,0,73,4,10,8,21-13,28-20,8-24-2-28-13-13-35-13-70,0-105,4-11,8-21,28-13,21,8,17,18,13,28z'/%3E %3Cpath d='m222502,50747c-13,51-27,103-40,154-13,52-26,103-40,155-3,11-6,21-27,16-21-6-19-16-16-27,13-52,27-103,40-155,13-51,27-103,40-154,3-11,5-21,27-16,21,5,19,16,16,27z'/%3E %3Cpath d='m222084,50745,38,38c8,8,15,15,0,31-16,15-24,8-31,0l-38-38c-8-8-15-15,0-31,16-15,24-8,31,0z'/%3E %3Cpath d='m221593,50510c-10,29-20,58-31,87-10,29-20,58-31,87-4,10-7,21-28,13-20-7-17-18-13-28,10-29,20-58,31-87,10-29,20-58,31-87,4-11,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m220890,51253c-27,29-45,61-58,94-13,34-20,69-26,106-2,11-4,22-25,18-22-4-20-14-18-25,7-39,15-77,29-114,14-38,35-74,66-108,7-8,15-16,31-1s9,23,1,31z'/%3E %3Cpath d='m218878,53224c-10,22-24,45-43,67-18,22-40,43-67,65-8,7-17,14-31-4-14-17-5-24,3-31,25-19,45-39,61-59,16-19,28-38,36-56,5-10,9-20,29-12,20,9,15,19,11,29z'/%3E %3Cpath d='m219193,53057c-9,22-24,41-43,57-18,15-41,28-68,39-11,4-21,8-28-13-8-21,3-25,13-28,22-8,41-19,55-31s24-26,31-41c4-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m219611,52802c-7,12-15,24-26,36s-26,24-45,36c-9,6-19,12-30-7s-2-25,8-30c16-9,27-19,36-28,8-9,15-19,21-28s11-19,30-7c19,11,13,20,8,30z'/%3E %3Cpath d='m220240,51166c-20,59-34,117-39,175s-2,116,10,173c2,11,5,21-16,26s-24-6-26-17c-14-62-17-125-11-187s20-124,41-185c4-11,7-21,28-14s17,18,14,28z'/%3E %3Cpath d='m220668,46813c-2,49-15,97-38,145s-56,95-99,142c-7,8-15,16-31,1s-9-23-1-31c40-44,71-88,92-131,20-43,32-86,33-128,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m220231,46427c38,66,61,133,74,200,13,66,16,133,12,199,0,11-1,22-23,21s-21-12-21-23c4-63,1-125-11-188-12-62-34-125-69-187-5-9-11-19,8-30s25-1,30,8z'/%3E %3Cpath d='m219652,47145c-79-58-135-117-171-176-36-61-49-122-40-184,2-11,4-21,25-18,22,4,20,14,18,25-8,52,4,103,34,155,32,54,85,108,159,163,9,6,18,13,5,31s-22,11-31,5z'/%3E %3Cpath d='m220293,48234v48,47c0,11,0,22-22,22s-22-11-22-22v-47-48c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m219474,47409c129,122,206,269,247,432,26,101,37,208,39,320,1,0,3-1,5-1,58-20,103-72,134-155,33-88,50-210,53-365,0-1,2-10,3-11,46-75,74-151,93-226s28-152,35-229c2-19,28-27,40-11,75,106,141,216,192,334s85,243,98,379c1,11,2,22-20,24s-23-9-24-20c-12-130-46-251-94-365-41-97-93-188-153-277-6,58-15,117-30,176-19,78-48,155-95,233-3,158-21,283-55,374-36,97-90,157-161,181-7,2-13,4-19,1-1,54-4,109-8,165-1,11-2,22-24,20s-21-13-20-24c15-182,11-355-29-511-39-155-113-295-235-411-8-7-16-15-1-31s23-8,31-1z'/%3E %3Cpath d='m219954,49462c-9,58-18,115-27,173-9,57-18,115-27,172-1,11-3,22-25,18-21-3-20-14-18-25,9-58,18-115,27-172,9-58,18-115,27-173,2-11,3-21,25-18,21,4,20,14,18,25z'/%3E %3Cpath d='m219032,49853c8,44,16,87,24,131,2,11,4,21-18,25-21,4-24-7-26-18-8-44-16-87-24-131-2-11-4-21,18-25,21-4,24,7,25,18z'/%3E %3Cpath d='m219829,48795c-11,87-33,171-67,252-35,81-83,160-146,235l-1,1c-79,86-117,175-129,268s1,190,27,289c3,11,5,21-16,27-21,5-24-5-27-16-27-103-41-205-28-305,13-101,55-199,140-292,60-71,106-146,139-223,33-78,54-158,64-241,1-11,3-22,24-19,22,3,20,14,19,25z'/%3E %3Cpath d='m219621,48485c15,84,2,167-33,251-35,81-91,163-163,244,0,0-2,2-2,2-75,63-128,132-170,203-42,72-73,147-104,223-4,10-8,20-29,12-20-8-16-18-12-28,31-77,63-154,107-229s100-147,178-213c68-77,121-154,154-231,32-75,44-151,30-225-2-11-4-21,18-26,21-4,24,7,26,18z'/%3E %3Cpath d='m218604,48968c24,168-2,312-65,438-62,126-161,234-282,331-8,7-17,14-31-4-14-17-5-24,4-31,116-93,211-197,270-316s84-254,61-413c-1-11-3-22,19-25s23,8,25,19z'/%3E %3Cpath d='m217305,49687c13,26,25,52,37,78,14,28,27,55,40,83,5,10,9,20-10,29-20,9-25,0-29-10-13-28-27-55-40-83-12-26-25-52-37-77-5-10-9-20,10-29,20-9,25,0,29,10z'/%3E %3Cpath d='m216790,49697c-1,99,7,197,31,291,25,94,65,185,131,272,0,0,2,4,2,4,33,67,52,134,65,202,9,50,15,100,18,150,63-67,111-135,146-206,40-82,61-167,63-255,0-11,0-22,22-21,22,0,22,11,21,22-2,94-25,185-67,273-43,88-106,172-189,253-13,13-36,4-37-15-3-65-8-130-20-193s-30-126-60-189c-68-91-111-187-137-286s-34-200-33-303c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216860,51456c4-54,12-107,25-162,13-54,29-107,51-161,4-10,8-20,28-12,21,8,16,18,13,28-21,52-37,104-49,155s-20,103-24,154c-1,11-1,22-24,20-22-1-21-12-20-23z'/%3E %3Cpath d='m216800,51946c9-65,18-130,27-195,1-11,3-22,25-19s20,14,19,25c-9,65-18,130-27,195-1,11-3,22-25,19s-20-14-19-25z'/%3E %3Cpath d='m216463,52767c32-32,63-70,92-112,30-43,58-90,86-139,5-10,11-19,30-9,19,11,14,20,8,30-28,51-58,99-88,143-31,44-63,84-98,118-8,8-16,15-31,0s-7-23,0-31z'/%3E %3Cpath d='m215976,50012v81c0,11,0,22-22,22s-22-11-22-22v-81c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m215152,51910c-1-20-2-40-4-60l-4-61c0-11-1-22,21-23s23,9,23,21l4,60c1,20,2,40,4,60,0,11,1,22-21,23s-23-9-23-21z'/%3E %3Cpath d='m217221,48534c-42,145-75,296-72,425,2,125,37,229,127,287,105,68,151,170,195,269,3,6,5,12,8,18,13-49,24-101,29-153,7-64,7-126-2-182-2-11-4-22,18-26,21-4,24,7,25,18,10,60,10,127,3,194-8,75-25,151-47,217-6,18-32,20-40,3-11-23-22-47-33-72-41-93-84-189-179-250-104-67-145-184-148-323-2-134,31-289,74-438,3-11,6-21,27-15s18,16,15,27z'/%3E %3Cpath d='m217076,47981c14,113,10,217-9,322-19,104-53,208-98,321-53,135-77,278-70,422,7,143,44,285,110,420,5,10,10,20-10,29-20,10-25,0-29-10-70-140-108-289-115-437-7-150,18-299,73-440,44-110,77-212,95-313,19-100,23-200,9-308-1-11-3-22,19-25,21-3,23,8,25,19z'/%3E %3Cpath d='m216115,49349c-30,66-36,132-25,198,12,67,41,135,82,203,6,9,11,19-7,30-19,11-25,2-30-8-43-72-75-145-87-218-13-74-6-149,28-223,5-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m215696,49199c7,39,9,85,5,131-4,40-14,79-30,114v1c-19,37-23,74-16,111,8,39,28,78,55,118,6,9,12,18-6,31s-24,4-31-6c-31-44-53-89-62-134-9-47-5-93,20-140,14-30,22-64,26-99,4-41,2-83-4-119-2-11-4-22,18-25,22-4,24,7,25,18z'/%3E %3Cpath d='m218146,45570c-13,115-7,223,16,326,23,102,62,200,116,293,6,9,11,19-8,30s-24,1-30-8c-55-96-97-198-121-305s-31-220-16-340c1-11,2-22,24-19,22,2,21,13,19,24z'/%3E %3Cpath d='m217839,45867c57,101,106,210,143,329s62,250,71,395c1,11,1,22-21,23s-22-10-23-21c-8-141-33-268-69-384s-84-221-139-320c-5-10-11-19,8-30s25-1,30,8z'/%3E %3Cpath d='m216317,45914c-147,209-211,379-223,526-12,146,27,268,85,381,0,0,1,3,1,3,40,116,58,231,55,347-2,115-26,231-67,346-4,11-7,21-28,13-21-7-17-18-13-28,40-111,62-221,65-332,2-110-14-220-52-330-61-119-102-249-89-403s79-332,231-548c6-9,13-18,31-6,18,13,12,22,5,31z'/%3E %3Cpath d='m217736,45312c13,63,7,129-22,193-26,59-71,115-138,168-68,53-108,122-126,205-19,85-15,184,6,295,2,11,4,22-18,26-21,4-24-7-26-18-21-117-25-221-5-312,20-92,65-170,142-230,61-48,101-99,125-151,25-55,30-112,19-166-2-11-5-21,17-26,21-4,24,7,26,17z'/%3E %3Cpath d='m216233,45441c29,93,30,184,3,275-26,90-80,179-162,266,0,0-2,2-2,2-79,66-127,150-157,243-31,95-42,201-48,311-1,11-1,22-23,21s-21-12-21-23c6-113,18-222,50-322s84-190,169-262c77-82,127-165,152-248,24-82,23-166-3-250-3-11-7-21,14-27s24,4,27,15z'/%3E %3Cpath d='m217093,45486c-5,34-5,66,0,98,5,31,17,61,37,90,6,9,12,18-6,31-18,12-24,4-31-6-24-35-38-71-44-107-6-37-6-74,0-111,1-11,3-22,25-19s20,14,19,25z'/%3E %3Cpath d='m217052,45260c-79,33-139,89-182,169-42,79-67,181-75,306,5,6,8,11,8,15,42,57,71,125,89,201,20,83,27,177,24,279,0,11-1,22-23,21s-21-12-21-22c3-99-4-189-23-268-16-67-41-127-76-177-163,152-243,320-248,503-6,191,69,399,213,621,6,9,12,19-6,31s-24,2-30-7c-149-230-226-446-220-646,6-197,92-377,269-539v-1c7-137,34-249,81-337,48-89,115-152,204-189,10-4,20-8,29,12,8,20-2,25-12,29z'/%3E %3Cpath d='m216808,44944c-2,18-4,32-5,47-11,104-22,221-101,292-44,39-72,85-92,134-20,51-30,106-37,164-1,11-2,22-24,19-22-2-20-13-19-25,7-61,19-120,40-175,22-56,54-107,103-151,66-59,78-168,87-263,2-18,4-35,5-48,1-11,3-22,25-19s20,14,19,25z'/%3E %3Cpath d='m219197,47493c26,54,47,110,61,167s21,116,18,177c0,11-1,22-23,21s-21-12-21-23c3-57-4-111-16-165-13-53-34-106-59-158-5-10-9-20,11-29s24,0,29,10z'/%3E %3Cpath d='m219204,48277c19,90,20,182,4,274s-50,186-100,281c-34,79-67,158-101,237-5,10-9,20-29,12s-16-19-12-29c34-79,67-159,101-238,0,0,1-2,1-2,49-91,81-180,97-268,15-87,14-174-4-258-2-11-4-22,17-26,21-5,24,6,26,17z'/%3E %3Cpath d='m218706,47547c143,159,236,327,280,504,45,177,40,363-14,557-3,11-6,21-27,15s-18-16-15-27c52-187,57-365,14-535s-133-332-271-486c-7-8-14-16,2-31s24-6,31,2z'/%3E %3Cpath d='m218662,48427c-44,93-93,186-153,279s-130,186-213,279c-48,53-92,112-130,177-38,66-71,138-97,219-6,20-44,13-42-8,4-66-4-132-22-198s-48-133-88-199v1c-80-118-114-237-108-355,7-118,54-235,138-352,48-82,82-165,106-247s36-165,39-248c0-11,1-22,23-21s21,12,21,23c-4,86-16,172-41,258s-61,172-111,258c0,0-1,2-1,2-79,111-124,221-130,330-6,110,27,219,101,329l1,1c42,70,73,140,93,211,9,33,16,66,20,99,19-43,39-84,62-122,40-68,86-130,136-185,82-91,151-183,209-274,59-92,108-183,150-274,5-10,9-20,29-11s15,19,11,29z'/%3E %3Cpath d='m217357,48007c-3,109,7,211,29,307,22,95,58,184,108,266,6,9,11,19-7,30-19,12-24,2-30-7-52-86-90-179-113-278-23-100-33-206-30-318,0-11,1-22,22-21,22,1,22,12,21,22z'/%3E %3Cpath d='m216614,48405v64,64c0,11,0,22-22,22s-22-11-22-22v-64-64c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216860,47726c2,75-8,148-31,218-24,70-61,137-115,200-7,8-14,17-31,2-17-14-9-22-2-31,50-59,85-121,106-186,22-65,31-133,29-203,0-11-1-22,21-22s22,11,22,21z'/%3E %3Cpath d='m216191,49044c-120-299-149-536-119-729,30-195,120-343,238-464,79-81,148-161,193-261s66-220,50-382c-1-11-2-22,20-24s22,9,24,20c16,170-6,297-54,404-47,106-119,190-201,274-112,114-197,256-226,440-29,186,0,416,117,707,4,10,8,20-12,28s-25-2-29-12z'/%3E %3Cpath d='m215805,48553c-18,48-25,97-19,145,5,48,23,97,53,146,6,9,12,19-7,30-19,12-24,2-30-7-33-54-53-109-59-164s1-110,22-165c4-10,8-20,28-13,21,8,16,18,13,28z'/%3E %3Cpath d='m217703,47205c79,111,125,226,134,346s-18,244-86,373c-5,9-10,19-29,9-20-10-14-20-9-29,64-121,90-237,81-349-8-112-52-220-126-324-7-9-13-18,5-31s24-4,31,5z'/%3E %3Cpath d='m218296,46741c48,115,73,232,78,350,5,117-12,236-48,355-6,20-42,16-43-6-4-110-27-209-68-296s-102-162-181-226c-8-7-17-14-3-31s22-10,31-3c85,68,149,148,193,241,27,57,47,119,59,185,13-73,19-146,16-219-4-112-28-224-74-334-4-10-8-20,12-29,20-8,25,2,29,12z'/%3E %3Cpath d='m218648,46260c78,77,133,179,167,305,33,124,45,270,39,437v1c-8,71-11,140-3,204,7,63,25,121,58,173,6,9,12,19-6,31-19,12-25,2-31-7-37-58-57-123-65-192-8-68-5-140,3-214v1c6-163-6-305-37-424-32-118-83-213-155-285-8-8-16-15,0-31,15-16,23-8,31,0z'/%3E %3Cpath d='m217714,46167c-51,62-82,135-97,216-15,82-13,172,2,270,2,11,4,21-18,25-21,4-23-7-25-18-16-102-18-198-2-285,16-88,51-167,106-236,7-8,14-17,31-3s10,22,3,31z'/%3E %3Cpath d='m215883,47400c-8,182-61,330-146,452-85,121-201,217-338,297-9,6-19,11-30-8s-2-24,8-30c131-77,243-169,324-285,81-115,131-255,139-428,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m215836,46770c10,68,6,134-9,200-15,65-41,130-74,197-5,10-10,19-29,10-20-10-15-20-10-29,32-64,57-126,71-187s18-121,9-184c-1-11-3-22,19-25s24,8,25,19z'/%3E %3Cpath d='m217076,46679v62c7,107,14,215,21,322l2,29c1,11,1,22-20,24h-7c-3,4-8,6-18,6-22,0-22-11-22-22v-356c-2-29-4-58-6-87-1-11-2-22,20-24,22-1,23,9,24,20v7c5,4,5,11,5,18z'/%3E %3Cpath d='m217375,46126c-88,107-123,210-125,311s29,202,75,302c104,167,138,333,127,500-10,166-65,331-138,496-5,10-9,20-29,11s-15-19-11-29c72-160,124-321,134-481,10-159-22-317-121-476,0,0-1-2-1-2-49-106-82-213-80-323,2-111,41-223,135-338,7-8,14-17,31-3s10,22,3,31z'/%3E %3Cpath d='m215452,42697c145-111,287-174,436-190,148-15,301,17,467,95,55-1,110-1,165-2,56-1,113-2,169-2,11,0,22,0,22,22s-11,22-22,22c-57,1-113,2-169,2-51,1-101,1-152,2-1,1-2,2-3,3-178,157-330,243-465,271-139,29-259-2-368-80-11-8-22-16-7-38s27-15,38-7c98,68,204,96,326,71,118-25,252-98,409-231-144-63-276-88-403-75-138,14-272,74-409,179-11,8-22,16-38-5-16-22-6-30,5-38z'/%3E %3Cpath d='m215882,42613c61,0,110,49,110,110,0,60-49,110-110,110-60,0-110-49-110-110s49-110,110-110z'/%3E %3Cpath d='m216639,43278c79-41,140-85,191-130,50-45,90-91,124-137,6-9,13-18,31-5s11,22,5,31c-36,49-78,98-130,145-53,47-117,92-200,135-10,5-20,10-29-9-10-19-1-25,9-29z'/%3E %3Cpath d='m218200,42632c41-11,81-11,122,1,40,11,79,33,118,65,8,7,17,14,3,31s-22,10-31,3c-34-28-69-47-102-56s-66-9-99-1c-11,3-21,6-27-16-6-21,5-24,15-27z'/%3E %3Cpath d='m217307,42668c35-80,88-141,161-180,72-38,163-54,274-44,11,1,22,2,20,24s-13,21-24,20c-103-9-186,5-250,39-64,33-110,87-141,159-4,10-9,20-29,11s-16-19-11-29z'/%3E %3Cpath d='m217409,42814c6-39,22-74,49-101,26-28,63-48,113-62,11-3,21-6,27,15s-5,24-15,27c-41,11-72,28-92,50-20,21-32,48-37,78-2,11-4,21-25,18s-20-14-18-25z'/%3E %3Cpath d='m215923,43308c-24,38-46,77-62,119-15,42-23,87-20,140,1,11,2,22-20,23s-23-9-24-20c-4-59,6-111,22-158,16-46,40-88,66-128,6-9,12-19,30-7,19,12,13,21,7,30z'/%3E %3Cpath d='m216349,43499v66c0,11,0,22-22,22s-22-11-22-22v-66c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m216072,43023c44,16,87,24,131,25,44,0,89-6,133-16,11-2,21-5,26,16s-6,24-16,27c-48,11-96,18-144,17-49-1-97-9-146-28-11-4-21-8-13-28,8-21,18-16,28-13z'/%3E %3Cpath d='m216346,42224c-37-1-66,10-88,27-29,22-47,53-55,80-3,11-6,21-27,15s-18-17-15-27c11-35,34-74,71-102,29-22,68-37,115-36,11,0,22,1,22,22,0,22-11,22-22,22z'/%3E %3Cpath d='m215903,42269c-33,14-59,30-79,46-18,15-30,32-35,48-4,11-7,21-28,14s-17-17-14-28c8-25,25-47,49-68,23-19,53-37,91-53,10-4,20-8,28,12,9,20-1,25-12,29z'/%3E %3Cpath d='m215630,42277c-27,19-50,39-69,62s-34,49-45,77c-4,10-7,21-28,13-20-7-17-18-13-28,12-33,30-63,52-90s48-50,78-71c9-6,18-12,31,6s4,24-6,31z'/%3E %3Cpath d='m215279,42558c-29,22-57,46-84,74s-52,58-76,91c-6,9-13,18-31,5s-11-22-5-31c25-35,52-67,80-96s58-55,89-78c9-7,18-13,31,4,13,18,4,24-5,31z'/%3E %3Cpath d='m215314,42945c-21,23-42,46-63,68l-64,68c-7,8-15,16-31,1s-9-23-1-31l63-68c21-22,42-45,64-68,7-8,15-16,31-1s9,23,1,31z'/%3E %3Cpath d='m214959,43048v136c0,11,0,22-22,22s-22-11-22-22v-136c0-11,0-22,22-22s22,11,22,22z'/%3E %3Cpath d='m215414,43646c-7,74-14,148-21,223-1,7-1,14-2,21-1,11-2,22-24,20s-21-13-20-24c1-7,1-14,2-21,7-74,14-149,21-223,1-11,2-22,24-20s21,13,20,24z'/%3E %3Cpath d='m215147,43448c-1,48-3,97-5,145,0,11-1,22-23,21s-21-12-21-22c1-49,3-97,5-146,0-11,1-22,23-21s21,12,21,23z'/%3E %3Cpath d='m214899,41554c46,17,87,41,120,73,34,33,60,74,77,124,4,11,7,21-14,28s-24-4-28-14c-15-44-38-79-66-107-29-28-64-49-105-64-10-4-20-8-13-28,8-21,18-17,28-13z'/%3E %3Cpath d='m217077,44394c42,95,65,190,66,284,2,95-17,190-57,285-4,10-8,20-28,12s-16-19-12-29c37-89,55-178,53-267-1-89-22-178-62-267-5-10-9-20,11-29s25,1,29,11z'/%3E %3Cpath d='m216367,45215c31-107,76-200,128-285s111-162,170-238c68-88,113-184,137-282,26-106,27-216,8-320-2-11-4-21,18-25,21-4,24,7,25,18,20,110,19,225-8,338-25,104-72,206-145,299-58,75-116,151-167,234-50,82-94,172-123,274-3,11-6,21-27,15s-18-16-15-27z'/%3E %3Cpath d='m215454,44974c15-40,37-75,67-106s67-57,111-78c10-5,20-9,29,10,9,20,0,25-11,29-40,19-73,42-99,69-26,26-45,57-57,91-4,10-8,21-28,13-20-7-17-18-13-28z'/%3E %3Cpath d='m215277,44910c34-44,68-85,107-121,40-37,85-68,137-89,10-4,20-8,28,12,8,21-2,25-13,28-47,19-87,47-123,80-37,34-70,75-102,116-7,9-13,18-31,4-18-13-11-22-4-31z'/%3E %3Cpath d='m216223,43972c38,17,74,25,109,26s69-4,102-13c11-3,21-6,27,15s-5,24-15,27c-37,11-75,16-115,15s-81-11-125-30c-10-5-20-9-11-29s19-15,29-11z'/%3E %3Cpath d='m215752,43911c11-13,22-25,33-38l4-5c7-8,15-16,31-2,16,15,9,23,2,31l-4,5c-11,13-22,25-34,38-7,8-14,16-31,2-16-14-9-23-2-31z'/%3E %3Cpath d='m225936,46849c21,23,39,47,55,73,15,26,27,53,37,82,4,11,7,21-14,27-21,7-24-4-28-14-8-26-19-50-33-73-13-23-30-45-49-65-7-8-15-16,1-31s24-7,31,1z'/%3E %3Cpath d='m214630,52155c48,44,98,84,153,112,54,27,114,44,182,44,11,0,22,0,22,22s-11,22-22,22c-75,0-141-19-202-49-59-30-113-72-163-118-8-7-16-15-1-31s23-9,31-1z'/%3E %3C/g%3E %3Cg fill='%23f00'%3E %3Cpath d='m223164,42025c251,11,493,1,699-33-220,159-501,266-804,316,59-46,97-94,114-143,16-47,13-94-9-140z'/%3E %3Cpath d='m222565,41963c163,27,332,46,499,57,2,4,5,7,7,11,27,37,35,73,23,108-14,40-52,82-114,125-17,12-34,24-10,57-111,14-224,20-339,18-58-1-115-4-173-9,6-3,12-9,17-14,61-64,100-130,111-199,8-51,2-102-21-153z'/%3E %3Cpath d='m218139,40691c282-37,569-46,861-39,96,39,167,96,211,171,48,84,65,194,45,331-3,20-6,41,35,46,41,6,44-15,46-35,22-156,2-283-55-383-28-48-64-89-108-124,26,1,52,2,78,4,336,18,597,114,889,259,2,2,5,5,7,8,62,65,83,132,73,201-11,73-55,152-125,233-13,16-27,31,5,58,31,27,45,11,58-5,79-93,131-185,144-275,7-51,3-99-15-147,246,122,496,239,739,367,5,3,10,5,15,8,0,5,2,11,4,16,20,69,12,128-22,179-37,53-104,99-201,135-19,7-38,14-24,53,14,38,34,31,53,24,114-43,194-98,240-166,39-57,54-120,45-191,161,87,322,177,487,256l1,1c29,58,34,110,11,158-24,51-80,99-169,143-18,9-37,18-19,55s37,28,55,19c107-53,175-114,207-182,22-47,28-95,18-146,57,25,115,49,174,71,159,59,351,110,557,148,1,2,3,4,5,6,38,53,51,104,42,153-9,51-40,103-90,155-14,15-28,29,1,58,5,5,9,8,13,11-625-64-1181-363-1763-588-69-27-139-53-208-80-215-81-432-191-648-279-7-7-18-11-28-14-15-5-29-10-44-14-9-4-19-7-28-11,1,1,3,2,4,3-197-63-396-112-598-140-224-31-452-37-686-7-13-2-25-4-38-6,20-123,4-231-57-325-43-67-108-126-198-175z'/%3E %3Cpath d='m217116,40966c287-125,578-205,875-254,136,54,226,120,277,198,49,77,61,167,44,271-126-12-251-11-373,2-137,15-271,46-403,93-66-139-155-223-259-269-51-23-105-36-161-42z'/%3E %3Cpath d='m220263,42558c-77-49-155-97-236-141-389-214-835-346-1282-363,4-3,7-7,11-10,159-162,194-315,140-458-42-111-139-214-273-307,150-8,289,1,445,23,220,31,505,105,765,210,64,140,82,263,54,367-29,109-111,200-243,275-18,10-36,20-16,56s38,26,56,15c153-86,247-194,282-326,27-102,19-216-26-343,176,79,335,173,446,276,145,100,288,201,428,307,1,178-51,279-137,332-91,55-221,62-369,47-20-2-41-4-45,37v2z'/%3E %3Cpath d='m221119,43202c-260-203-514-415-787-598,151,12,286,0,388-61,99-61,164-167,175-340,163,126,320,259,469,402,75,71,150,141,227,210,0,1,1,2,1,4,18,64,24,119,19,165-5,45-21,82-47,111-27,30-66,52-115,65-73,21-168,25-285,12-19-2-39-4-44,31z'/%3E %3Cpath d='m222016,43793c-90-46-176-94-259-143-199-118-386-253-569-394,112,9,206,3,282-18,65-18,117-48,154-89,38-42,61-94,68-158,3-28,3-58-1-90,179,153,367,295,570,419,106,65,213,126,319,183-1,7,0,14,1,22,13,82-33,134-117,167-98,39-244,55-411,65-19,1-37,2-39,34z'/%3E %3Cpath d='m222974,44169c-304-83-598-199-867-330,154-11,290-29,388-68,111-44,175-112,171-221,178,90,356,168,537,232,32,71,34,129,4,178-36,60-115,110-213,153-19,8-38,17-21,54v1z'/%3E %3Cpath d='m224970,43966c26-4,186-46,103,15-588,385-1334,384-2037,203,109-49,198-108,243-182,34-55,40-118,24-187,224,73,451,125,685,155,1,36-9,72-37,107-37,46-100,91-203,136-19,8-38,16-21,54,16,38,35,29,54,21,116-51,191-105,235-160,39-49,55-98,55-149,289,31,588,27,900-14z'/%3E %3Cpath d='m220904,54095c-44,46-81,97-117,157-171,57-322,142-506,134,0,119,39,171,158,172,227-114,278-135,298-119,28,24-32,187-220,319-29,18-28,29-11,59,159,249,576,160,800,101,160-42,449-232,529-392,31-73-39-169-109-247-177,27-238-55-210-112-187-66-395-80-612-72z'/%3E %3Cpath d='m214511,52080c-130,106-275,190-444,246-64,21-219,59-234,140-2,29,104,92,172,55,188-180,282-80,66,104-17,35-3,74,34,107,195,175,678,232,898,93,163-102,248-214,106-369,1-35,5-69,11-104l-269-27-165-96-175-149z'/%3E %3Cpath d='m218719,53544c-16,2-33,4-49,7-87,94,152,59,279,137,58,35,83,104,60,200-117,279-770,189-987,74-101-53-105-114-101-201,45,0,91-3,137-10,78-11,155-34,231-77,21-12,43-25,19-67-24-43-46-31-67-19-64,36-130,56-196,65-68,10-138,10-205,7h-17c-38-22-67-48-51-71,16-22,79,2,91,6,101-47,189-77,298-98,15-15,29-31,44-46,199,17,389,47,515,93z'/%3E %3Cpath d='m215700,53373c-40,24-54,58-83,121-114,115-223,184-369,250-121,55-4,108,81,166,77,57,178-67,241-161,69-104,139-73,94,8-50,89-86,217-91,284-26,72,248,127,295,129,167,8,377-155,508-238,109-111,92-208,44-343l1-9c-70,2-136-6-201-20-79-18-157-45-236-78-10-4-20-8-12-29,5-13,11-16,18-15l-288-66z'/%3E %3Cpath d='m216869,42243c46-2,92-4,137,1,85,10,166,47,251,57,284-107,519-166,722-157,237-69,483-98,729-92-3-2-6-5-9-8-29-29-15-44,0-58,133-135,164-259,121-371-44-116-164-225-331-325-178,20-349-28-538-7-118,13-234,39-348,77,95,34,178,90,246,170,84,99,144,234,176,404,4,20,7,40-33,48s-44-13-48-33c-29-155-83-277-158-366-79-113-260-157-317-180-189,19-375,40-537,82-122,31-229,74-311,138,122-26,249-21,359,34,105,52,194,150,250,309,7,19,13,39-26,52s-46-6-52-26c-47-137-121-219-208-262-173-86-530-11-681,101-88,66-176,151-263,250-9,11-19,21-31,22,324,22,650,39,902,140zm-961-183c-7-18,5-31,16-44,91-103,183-194,278-264,92-68,187-117,285-140,100-111,248-178,420-222,167-43,358-65,551-84-57-115-130-184-214-221-90-40-194-46-305-35-233,80-440,205-639,346,18,0,36,0,53,1,59,4,112-5,161,14,20,7,39,14,25,53-17,47-146,18-191,15-51-3-107,1-169,16-10,2-19,5-28,2-209,129-367,260-536,403,128,45,228,98,293,160z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230093dd' d='m240096,66034,8752-19837-6456-10424-11513,4263-5329,20965c5022,1281,9882,2973,14545,5034z'/%3E %3Cpath fill='%23fff' d='m228935,47685c5767,1471,11350,3414,16705,5782l-3377,7657c-4934-2181-10076-3971-15390-5326z'/%3E %3Cpath fill='%23f00' d='m242806,59894,2256-5113c-5283-2336-10790-4252-16479-5704l-1330,5231c5396,1377,10620,3195,15631,5410l-78,176z'/%3E %3Cpath fill='%23000' d='m230207,53061c151-95,312-72,474-46,131-49,282-66,446-60,70-38,151-65,243-82,49-38,51-79,7-123-41-50-64-99-67-149-260-151-356-381-455-609-148-39-217-89-233-145-72-7-143-14-214-22-337,37-424-72-544-161-100-33-187-88-243-193-37-47-74-93-111-140-92-117-64-272,75-263,98,11,195,11,285-28,105-47,262-46,381-36,141-8,230-99,367-227-1-55-1-109-2-164-22-59,6-85,84-77,183,6,292,92,366,214,213,37,381,139,494,318,283,1,474,108,497,213,17,77-66,165-194,259,1,19,2,39,2,58,76,66,126,132,152,197,159,61,311,143,453,263,405-47,1088,247,2011,836,599,107,1180,273,1738,514,118,4,236,7,353,11,1001-148,1971-34,2871,654,340,41,645,148,940,270,219,90,442,125,667,146,364,35,733,125,1099,295,411,92,795,221,1033,509,169,204,128,392-87,470-130,274-389,286-777,151-267,49-561-165-828-366-371-119-712-333-1049-561-175-131-352-214-524-251-135-29-256-48-337,0-40,24-35,38,0,67,94,79,160,197,181,339,19,125-1,269,6,422,8,161,105,278,267,378,111,68,243,140,434,167,91,18,117,71,114,140,51,244,98,490,187,711,25,63,73,93,145,146,247,178,119,377-106,420-197,174-367,291-569,337-161,54-227-12-281-91-97-2-146-41-187-104-197-145-29-397,442-289,10-55,50-72,90-71-28-122-44-258,9-385-42-27-78-61-139-81-170-54-331-132-458-251-241-227-618-417-981-608-300-15-523-153-758-270-106-1-212-3-318-4-93-31-169,1-225,68-94,114-203,95-332,80-148-17-298-6-446-8-73,18-145,41-224,42-167-9-330-11-441,82-92,97-184,90-276,54-69-32-119-66-148-102-116-24-191-53-216-88-195-55-250-110-241-165-259-62-136-266,32-273,198-8,379,30,573,57,163,46,364,19,497-101,86-78,118-145,223-203-335-22-582-81-764-196-490-309-882-384-1194-122-83,47-148,66-237,32-75-29-171-29-246-12-177,40-352,18-529-46-259,65-517,79-776,26-219,115-379,128-481,40-96-54-187-109-273-168-139-21-199-56-205-102-178-20-200-85-199-156-74-85-46-150,28-205,132-55,269-75,421,3,91,43,158,85,213,128,101-12,188,0,264,28,56-88,215-92,389-82,87-58,191-99,324-111-4-21-8-42-11-62-175-46-265-173-352-301-269-5-462-118-654-236-158,13-285-39-408-113-100,8-211,12-316-15-208,57-405,53-591,0-131,12-236-1-344-11-123,141-261,166-412,94-83-105-201-174-350-213-113-37-148-86-168-139-138-85-110-169,23-233,100-48,225-57,415,37,62,23,131,39,209,45z'/%3E %3Cpath fill='%23fff' d='m236801,55071c-13-23-41-81-142-23-313-17-663-13-926-168-274-161-556-329-859-317,90-85,202-143,332-178,174-46,380-49,608-12,320,52,602,114,820,196,210,79,358,177,423,303,2,3,15,18,18,20,84,54,157,109,218,167,46,43,86,88,120,136-99,9-201,2-301-18-110-22-216-59-312-108z'/%3E %3Cpath fill='%23000' d='m237521,39962,18,94,394,2040-1567,1366-72,63,91,32,1964,679,399,2040,19,94,72-63,1570-1361,1967,674,91,31-18-94-394-2041,1567-1366,72-63-91-31-1964-680-399-2040-19-94-72,63-1571,1362-1966-675z'/%3E %3Cg fill='%23f7db17'%3E %3Cpath d='m236561,43439,1464-1276,1841,634z'/%3E %3Cpath d='m240110,42750,1469-1277,1835,635z'/%3E %3Cpath d='m243427,42173-1464,1276-1841-634z'/%3E %3Cpath d='m239878,42863-1469,1276-1835-634z'/%3E %3Cpath d='m237729,40150,1837,630,372,1911z'/%3E %3Cpath d='m240101,42878,1840,634,368,1907z'/%3E %3Cpath d='m242259,45462-1837-629-372-1911z'/%3E %3Cpath d='m239887,42734-1840-633-368-1907z'/%3E %3Cpath d='m241162,39516,373,1906-1469,1277z'/%3E %3Cpath d='m239985,42934,371,1911-1467,1273z'/%3E %3Cpath d='m238826,46096-373-1906,1469-1277z'/%3E %3Cpath d='m240003,42678-371-1911,1467-1272z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='500' viewBox='0 0 72 36'%3E %3Crect width='72' height='36' style='fill:%230073cf'/%3E %3Crect width='72' height='12' y='12' style='fill:%23fff' /%3E %3Cg id='star' transform='translate(36,18) scale(2)' fill='%230073cf'%3E %3Cg id='cone'%3E %3Cpolygon id='triangle' points='0,0 0,1 .5,1' transform='translate(0,-1) rotate(18)'/%3E%3Cuse xlink:href='%23triangle' transform='scale(-1,1)' id='use12'/%3E %3C/g%3E %3Cuse xlink:href='%23cone' transform='rotate(72)' id='use14'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-72)' id='use16'/%3E %3Cuse xlink:href='%23cone' transform='rotate(144)' id='use18'/%3E %3Cuse xlink:href='%23cone' transform='rotate(-144)' id='use20'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='translate(10,-3.2)'/%3E %3Cuse xlink:href='%23star' transform='translate(10,2.8)'/%3E %3Cuse xlink:href='%23star' transform='translate(-10,-3.2)'/%3E %3Cuse xlink:href='%23star' transform='translate(-10,2.8)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1280' height='640' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z'/%3E %3C/clipPath%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3Cuse id='Cstar' xlink:href='%23Star7' transform='scale(2.1)'/%3E %3C/defs%3E %3Cg transform='scale(840)'%3E %3Crect width='12' height='6' fill='%2300008b'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23fff' stroke-width='0.6'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23f00' stroke-width='0.4' clip-path='url(%23c)'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23fff'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23f00' stroke-width='0.6'/%3E %3Cpath d='M0,3H6V0H8V4H0z' fill='%2300008b'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse id='Comwlth' xlink:href='%23Cstar' x='2520' y='3780'/%3E %3Cuse id='αCrucis' xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse id='βCrucis' xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse id='γCrucis' xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse id='δCrucis' xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse id='εCrucis' xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23de2910'/%3E %3Cg id='petal'%3E %3Cpath d='m 449.96406,299.9134 c -105.26305,-44.48626 -58.60174,-181.58185 42.06956,-174.6907 -20.36609,10.46694 -23.31775,29.99772 -11.68704,48.09021 13.02444,20.2558 -1.19897,52.84856 -18.80577,60.7674 -28.93485,13.02443 -34.72791,47.74999 -11.57675,65.83309 z' fill='%23fff'/%3E %3Cpath d='m 444.27188,200.91974 -5.91976,9.29378 -2.14454,-10.8142 -10.67812,-2.75928 9.62461,-5.3895 -0.67104,-10.99955 8.08542,7.48945 10.25578,-4.04271 -4.61053,10.00942 7.00143,8.50541 z' fill='%23de2910'/%3E %3Cpath d='m 450.56002,298.75902 c -12.73114,-6.53451 -22.9963,-20.15491 -27.46839,-36.43134 -5.11498,-18.66969 -2.17269,-38.74247 8.08308,-55.03768 l -2.20789,-1.39371 c -10.64057,16.92871 -13.69313,37.74293 -8.38575,57.11886 4.72784,17.22201 15.21355,31.09815 28.78703,38.06438 z' fill='%23de2910'/%3E %3C/g%3E %3Cuse xlink:href='%23petal' transform='rotate(72 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(144 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(216 450,300)'/%3E %3Cuse xlink:href='%23petal' transform='rotate(288 450,300)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='500' height='300'%3E %3Crect width='500' height='300' fill='%23009e49'/%3E %3Cpath d='M 0,0 L 500,150 L 0,300 z' fill='%23fff'/%3E %3Cpath d='M 0,13.05 L 456,150 L 0,286.95 z' fill='%23fcd116'/%3E %3Cpath d='M 0,0 L 250,150 L 0,300 z' fill='%23000'/%3E %3Cpath d='M 0,17.5 L 220.85,150 L 0,282.5 z' fill='%23ce1126'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600' viewBox='-2 -3 12 6'%3E %3Crect x='-2' y='-3' width='4' height='6' fill='%23ce1126'/%3E %3Crect x='2' y='-3' width='8' height='3' fill='%23fcd116'/%3E %3Crect x='2' width='8' height='3' fill='%23009e49'/%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-1 v 1 h .5' transform='rotate(18 0,-1)' fill='%23000'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='820' height='440'%3E %3Crect fill='%23c62139' width='820' height='440'/%3E %3Crect fill='%2300297b' width='780' height='400' x='20' y='20'/%3E %3Cg%3E %3Cpath fill='%23c62139' d='M410.25782,100.00041C410.25782,100.00041 330.00038,154.71073 330.00038,219.22153C330.00038,283.74266 410.25782,340.00123 410.25782,340.00123C410.25782,340.00123 490.00057,288.38227 490.00057,219.22153C490.00057,150.06596 410.25782,100.00041 410.25782,100.00041'/%3E %3Cpath fill='%2366afeb' d='M477.92277,240.56171C479.68326,233.69776 480.68341,226.5706 480.68341,219.22153C480.68341,157.29117 410.25782,111.35948 410.25782,111.35948C410.25782,111.35948 338.80284,158.84459 338.80284,219.22153C338.80284,226.47255 339.82054,233.53777 341.61613,240.38108L477.92277,240.56171'/%3E %3Cpath fill='%23007bde' d='M409.67295,328.12609C409.67295,328.12609 464.90916,291.54588 477.89938,240.38108L341.56349,240.38108C354.75257,290.56016 409.67295,328.12609 409.67295,328.12609'/%3E %3Cpath fill='%239c8431' d='M480.33833,226.4519C468.25468,235.06023 400.2505,230.92637 400.2505,230.92637L396.44877,240.56171L477.91692,240.56171C478.25615,239.24053 478.56615,237.91934 478.84689,236.58268L480.33833,226.4519'/%3E %3Cg fill='%23fff100'%3E %3Cpath d='M406.07592,287.35526C405.04068,280.14553 373.23483,272.42488 356.35514,273.05967C361.62492,281.32737 367.59656,288.8932 373.6033,295.6178C382.17767,286.41598 406.41515,289.73442 406.07592,287.35526'/%3E %3Cpath d='M470.45384,260.54973C466.4123,260.69424 459.07789,261.33935 454.05376,263.9559C446.80708,267.73882 430.58246,271.87267 423.32993,269.80316C416.08324,267.73882 404.68975,274.27763 406.07592,275.65042C408.3745,277.94701 425.05533,275.3098 425.05533,290.106C425.05533,302.49207 405.73084,296.99059 398.13323,302.15146C393.5536,305.25314 390.36015,308.62318 388.54703,310.79074C400.40842,321.7679 409.69634,328.12609 409.69634,328.12609C409.69634,328.12609 431.71713,313.54148 451.21708,289.92537L460.38802,277.75605C464.08448,272.34231 467.51188,266.59827 470.45384,260.54973'/%3E %3C/g%3E %3Cg fill='%23009270'%3E %3Cpath d='M405.85951,165.16664C405.85951,165.16664 394.85205,158.71556 379.83814,161.80692C364.82422,164.90344 361.58399,174.31686 361.58399,174.31686L366.63151,171.99963L366.76019,174.06397L371.29302,171.2255L371.42169,173.28984L375.3053,169.6824L375.94283,171.99963L379.44041,168.90311L379.70361,170.58039L385.39451,166.96779L385.39451,169.29017L389.92734,167.22067L389.54132,169.4192L398.08645,167.8761C398.08645,167.8761 377.89048,174.58006 375.3053,190.70776L379.18307,186.0733L379.57494,188.25635L382.03144,183.35869L382.68066,185.29401L384.87981,180.77826L385.52319,183.48255L388.88626,178.57973L389.14946,181.42337L393.02722,176.13348L393.02722,178.70359L397.17403,174.18783L397.04535,177.55272C397.04535,177.55272 401.05764,174.18783 402.34438,174.18783L397.56005,180.38603L399.11584,180.90212C399.11584,180.90212 395.74692,183.61157 395.48957,184.12766C395.23222,184.63858 397.69457,184.12766 397.69457,184.12766C397.69457,184.12766 394.71168,187.21902 394.583,188.12733C394.45433,189.03564 396.5248,188.12733 396.5248,188.12733C396.5248,188.12733 393.80511,191.60575 393.41909,192.90629C393.02722,194.1965 394.84034,193.15917 394.84034,193.15917C394.84034,193.15917 393.16174,197.28786 393.02722,198.44906C392.89854,199.59993 394.96902,198.18585 394.96902,198.18585L396.13879,205.28204L398.20926,196.77694L399.50185,198.71226L399.50185,192.64308L400.66576,193.6701L400.5371,189.68075L402.08704,191.22385L401.31499,186.32103L402.9936,188.24603L402.73625,184.12766L404.41486,185.8101L404.41486,180.38603L405.97065,181.79495L406.228,178.0688L408.04112,178.96679C408.04112,178.96679 408.29847,174.45104 410.3748,174.58006C412.43943,174.69876 415.03046,176.89729 413.99522,177.9243L415.80835,177.4237L415.42233,181.79495L417.10094,180.76794L416.84359,183.99348L418.26485,183.34837L417.75016,187.4719L419.43462,186.45521L419.55744,191.47157L421.4934,190.06265L421.36472,195.98732L423.30653,194.44939L423.30653,199.34705L425.11967,198.06715L427.06732,202.83579L426.67546,195.7396L428.10257,196.89564L425.50568,191.86895L427.45334,191.60575L425.37701,188.24603L427.31882,188.39053L424.4763,185.03081L426.41226,184.64891L422.13676,181.54723L424.47045,180.64924L420.06629,177.8056L421.75075,177.16049L418.65088,173.93495L421.88527,175.22517L422.91466,173.16082L426.79827,176.2625L426.79827,173.16082L430.16134,177.8056L430.55322,174.96196L433.14424,178.57973L433.65894,176.90761L435.47207,180.51505L436.37279,177.81592L438.18591,181.68657L438.70061,178.96679L440.38507,183.22967L441.94086,181.54723L442.71875,185.93912L444.26284,184.25668L445.6841,188.12733L447.49723,186.70809L449.05302,191.09999C449.05302,191.09999 453.32265,167.61289 416.69152,167.22067L405.81858,165.16664'/%3E %3Cpath d='M389.03248,144.25998L391.0971,146.83009L390.06187,147.61455L393.55946,149.54987L392.78156,150.96395L396.27916,152.25416L394.98072,153.2915L398.09228,155.08748L396.02181,155.74291L399.7709,157.54405L399.25621,159.21617L402.49059,159.99546L401.06933,161.15149L404.81843,164.12931L409.09391,167.09165L412.07096,166.06463L410.9012,160.37736C410.9012,160.37736 398.60698,143.60455 389.03248,144.24966'/%3E %3Cpath d='M400.29144,128.00326L401.71855,131.3475L399.7709,131.73973L404.17505,136.12646L400.67747,136.25548L404.95295,139.60489L402.87662,140.26031L406.76609,144.13096L404.68975,145.15797L408.70204,149.15764L405.98819,150.18466L410.52102,154.31851L407.93,154.45269L410.64385,157.92595L408.18735,158.70524C408.18735,158.70524 411.1644,164.24801 411.02986,166.57556L416.0774,166.82844C416.0774,166.82844 416.85528,151.86194 416.21192,149.92661L414.91348,150.82976L415.29951,145.41086L413.3577,146.57721L412.97752,140.12613L411.02986,142.18532L410.52102,135.86326L409.09391,138.06179L407.6668,131.86359L406.11686,133.79891L404.68975,129.8044L403.52584,131.3475L400.29144,127.99294'/%3E %3Cpath d='M413.36355,165.67757C414.79066,156.64606 424.24235,143.48585 441.97595,142.96977L437.95781,145.03411L440.2915,146.06629L435.62999,147.74873L437.95781,149.15764L432.39559,149.54987L435.23812,151.48519L431.103,152.00128L427.86276,152.64639L430.19058,154.83459L425.52909,155.34552L428.51198,156.89894C428.51198,156.89894 421.13078,159.47937 420.61608,160.25866C420.61608,160.25866 445.47354,153.9366 451.55631,165.66725L446.76028,163.6029L447.15216,165.80143L443.78908,163.35002L444.30378,165.15632L440.81204,163.35002L441.32674,165.53823L437.70046,163.47388L438.47836,165.41953L433.81685,163.221L434.59474,165.28534L430.58246,163.99513L430.97433,166.18333L426.9562,165.93045L427.34806,168.51088L414.91933,168.24768L413.36355,165.66725'/%3E %3C/g%3E %3Cg fill='%237b4800'%3E %3Cpath d='M409.56767,173.46015L412.15869,173.28984C410.94798,197.89684 412.08262,233.17651 415.43403,246.23866C421.12493,268.42521 437.71802,276.9716 441.66597,279.09788C443.90606,280.2952 443.04628,285.28575 438.5544,284.94514C434.0742,284.59936 418.41693,273.06999 413.01262,252.42653C405.77178,224.72818 409.28692,176.34508 409.56767,173.46015'/%3E %3Ccircle cx='413.755' cy='168.129' r='2.926'/%3E %3Ccircle cx='409.094' cy='167.092' r='2.739'/%3E %3Ccircle cx='409.094' cy='171.871' r='2.558'/%3E %3Ccircle cx='412.586' cy='170.58' r='2.739'/%3E %3C/g%3E %3Cg fill='%237b4800'%3E %3Cpath fill='%23000' d='M384.64001,257.16421L387.56442,257.16421L387.56442,225.68294L384.64001,225.68294L384.64001,257.16421z'/%3E %3Cpath d='M394.13849,263.0992C394.13849,263.0992 392.93949,263.3108 391.03277,263.55336L391.03277,261.09678L389.09097,261.09678L389.09097,263.76495C387.10236,263.96623 384.69266,264.13137 382.16596,264.13137C379.48136,264.13137 376.77336,263.93526 374.53911,263.70818L374.53911,261.16388L372.39844,261.16388L372.39844,263.46562C370.55022,263.23338 369.35706,263.03211 369.35706,263.03211C369.35706,263.03211 368.77218,266.25765 381.97881,266.25765C395.17957,266.25765 394.14434,263.0992 394.14434,263.0992'/%3E %3Cpath d='M381.60448,257.07131C392.30781,257.07131 401.28575,255.3579 401.28575,255.3579C401.28575,255.3579 402.66021,262.23217 381.60448,262.23217C360.54874,262.23217 362.27415,256.39008 362.27415,256.39008C362.27415,256.39008 370.90699,257.07131 381.60448,257.07131'/%3E %3Cpath fill='%23fff' d='M372.62655,227.47892C372.62655,227.47892 389.19624,233.67711 395.75861,255.3579C395.75861,255.3579 380.56924,252.26655 371.93638,255.70368L367.10526,255.70368C367.10526,255.69293 375.39303,243.65823 372.62655,227.47892'/%3E %3C/g%3E %3Cg fill='%23c62139'%3E %3Cpath d='M374.97192,211.16026L371.90129,211.16026C371.66149,209.83908 371.08246,208.91013 370.16419,208.3992C369.6495,208.10503 369.08216,207.96569 368.45634,207.96569C367.24564,207.96569 366.26304,208.53855 365.49099,209.72038C364.7131,210.88674 364.32708,212.66208 364.32708,215.01027C364.32708,217.38943 364.74819,219.06155 365.58458,220.06276C366.42095,221.03816 367.37431,221.5336 368.44465,221.5336C369.49158,221.5336 370.34551,221.14654 371.01812,220.36209C371.68489,219.58796 372.09431,218.56094 372.25807,217.28621L368.79557,217.28621L368.79557,214.07099L375.01871,214.07099L375.01871,224.42369L372.95408,224.42369L372.63825,222.01356C372.03582,222.9322 371.49773,223.5773 371.01812,223.95921C370.19344,224.61464 369.1816,224.93977 367.97674,224.93977C365.99984,224.93977 364.37387,224.0521 363.11637,222.27677C361.80039,220.50143 361.13947,218.0655 361.13947,214.9793C361.13947,211.85698 361.80624,209.34364 363.13977,207.45993C364.4616,205.57621 366.22209,204.63693 368.41541,204.63693C370.31041,204.63693 371.83696,205.2614 372.98917,206.50517C374.13554,207.74377 374.80231,209.29719 374.97192,211.16026'/%3E %3Cpath d='M389.58811,216.9972L389.58811,205.13238L392.75817,205.13238L392.75817,216.9972C392.75817,218.31838 392.88685,219.28346 393.12664,219.89761C393.50682,220.97623 394.32565,221.52328 395.6007,221.52328C396.85819,221.52328 397.68288,220.97623 398.06304,219.89761C398.3087,219.28346 398.41982,218.31838 398.41982,216.9972L398.41982,205.13238L401.59573,205.13238L401.59573,216.9972C401.59573,219.0409 401.35008,220.63561 400.85878,221.78648C399.93467,223.87147 398.18587,224.91913 395.59485,224.91913C393.00966,224.91913 391.24918,223.88179 390.32506,221.78648C389.83377,220.64593 389.58811,219.0409 389.58811,216.9972'/%3E %3Cpath d='M423.125 205.125L417.78125 224.4375L421.0625 224.4375L422.09375 220.46875L427.59375 220.46875L428.5625 224.4375L431.9375 224.4375L426.625 205.125L423.125 205.125z M424.84375 209.53125L426.71875 217.125L422.9375 217.125L424.84375 209.53125z'/%3E %3Cpath d='M451.65574,220.30015L454.35204,205.13238L458.83808,205.13238L458.83808,224.42369L455.93122,224.42369L455.93122,211.38218C455.93122,211.00028 455.93704,210.47387 455.94297,209.7978C455.94879,209.12172 455.95472,208.60048 455.95472,208.23922L453.12389,224.42369L450.09422,224.42369L447.28678,208.23922C447.28678,208.60048 447.2926,209.12172 447.29853,209.7978C447.30435,210.47387 447.31028,211.00028 447.31028,211.38218L447.31028,224.42369L444.40342,224.42369L444.40342,205.13238L448.9421,205.13238L451.65595,220.30015'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='960' height='600'%3E %3Cdefs%3E %3CradialGradient id='rgbase'%3E %3Cstop stop-color='%23f9f0aa' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='rg1' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='447.41758' cy='308.26917' r='16.53415'/%3E %3CradialGradient id='rg2' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='451.55806' cy='312.99521' r='10.9114'/%3E %3CradialGradient id='rg3' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='454.11008' cy='308.64279' r='9.7796'/%3E %3CradialGradient id='rg4' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='458.39039' cy='307.05652' r='17.35437'/%3E %3CradialGradient id='rg5' xlink:href='%23rgbase' gradientUnits='userSpaceOnUse' cx='445.97552' cy='252.36294' r='13.01791'/%3E %3CradialGradient id='rg6' gradientUnits='userSpaceOnUse' cx='477.85817' cy='215.26555' r='0.34463'%3E %3Cstop stop-color='%23a50a0a' offset='0.2592'/%3E %3Cstop stop-color='%234c0505' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='rg7'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%23fff' stop-opacity='0' offset='1'/%3E %3C/radialGradient%3E %3ClinearGradient id='lg1' gradientUnits='userSpaceOnUse' x1='473.90569' y1='259.17123' x2='472.35656' y2='231.96319'%3E %3Cstop stop-color='%23b07e09' stop-opacity='0' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='lg2' gradientUnits='userSpaceOnUse' x1='483.12617' y1='296.65618' x2='485.49465' y2='326.58339'%3E %3Cstop stop-color='%23b07e09' stop-opacity='0' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='lg3' gradientUnits='userSpaceOnUse' x1='451.54058' y1='249.52251' x2='455.36642' y2='240.57625'%3E %3Cstop stop-color='%23f9f0aa' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='lg4' gradientUnits='userSpaceOnUse' x1='473.31357' y1='237.24661' x2='475.92895' y2='270.44556'%3E %3Cstop stop-color='%23f9f0aa' offset='0.2165'/%3E %3Cstop stop-color='%23b07e09' offset='1'/%3E %3C/linearGradient%3E %3C/defs%3E %3Crect width='960' height='600' fill='%234997d0'/%3E %3Crect width='320' height='600' x='320' fill='%23fff'/%3E %3Cg%3E %3Cg stroke='%2324420e'%3E %3Cg fill='none' stroke-width='0.437'%3E %3Cpath d='m452.12,377.48c2.67-0.40662,4.2078-1.1381,6.035-1.7864'/%3E %3Cpath d='m460.37,371.64c1.3468,1.4287,2.4172,2.9497,2.9932,4.6354'/%3E %3Cpath d='m455.25,371.2c1.4045,1.3127,2.3761,2.7115,3.138,4.1523'/%3E %3Cpath d='m408.81,238.77c-1.0444,1.6022-3.0921,2.7264-4.7798,3.4277'/%3E %3Cpath d='m403.69,242c0.035-1.3682-0.23597-3.0257,0.0496-4.3935'/%3E %3Cpath d='m401.76,242.63c0.11383,0.36926,0.43502,1.401,0.67602,2.0278'/%3E %3Cpath d='m404.46,245.58c-0.37821,0.0817-1.5209,0.25695-2.0278,0.33845'/%3E %3Cpath d='m398.48,245.04c-0.0127,2.5201,0.28557,5.5528,0.53116,7.8214'/%3E %3Cpath d='m397.22,251.9c0.47195,0.75686,0.94717,1.5041,1.545,1.8828'/%3E %3Cpath d='m394.18,260.25c0.48878,0.93952,0.94259,2.1224,1.3038,3.9589'/%3E %3Cpath d='m399.2,259.58c-0.41449,0.20451-1.2148,0.93057-1.9313,1.5448'/%3E %3Cpath d='m398.86,265.52c-0.97864,0.87201-2.1978,1.5043-3.428,2.1244'/%3E %3Cpath d='m391.62,308.05c1.1534,1.8935,2.4205,3.5595,3.9589,4.6836'/%3E %3Cpath d='m396.16,314.42c-1.2944-0.16606-2.1607-0.54537-2.9451-0.96575'/%3E %3Cpath d='m397.61,321.86,1.6892,0.96575'/%3E %3Cpath d='m398.86,326.3c1.2548,0.81629,2.5101,2.2826,3.7653,3.8625'/%3E %3Cpath d='m401.18,333.01c1.3853,0.29278,2.493,0.64106,3.2348,1.0621'/%3E %3Cpath d='m403.35,336.49,2.1244,0.0725'/%3E %3Cpath d='m406.68,331.18c-0.10248,1.534-0.25346,2.972-0.48266,4.2486'/%3E %3Cpath d='m407.21,337.02,0.43437-1.6418'/%3E %3Cpath d='m412.33,341.37-0.14573,3.2357'/%3E %3Cpath d='m451.39,372.51-1.1587,1.593'/%3E %3Cpath d='m447.82,370.19-0.6758-1.8343'/%3E %3C/g%3E %3Cg stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m486.11,384.93c-0.79663-1.2555-2.1076-2.0278-3.2774-2.6556-7.7262-4.0566-15.406-5.8439-24.116-7.244-2.0126-0.33757-4.0264-2.2216-6.0868-3.187-4.9633-2.3654-10.489-3.2842-15.311-5.6975-0.32796-0.14595-1.5452-0.86939-2.1076-1.5448-1.9193-2.2221-5.3848-2.899-7.5387-4.9747-8.3347-7.8713-17.184-15.116-21.772-25.547-5.5729-12.7-12.504-25.786-11.567-40.226,0.60851-9.1267-0.75031-18.35,1.4976-27.043,3.325-12.894,7.5864-25.641,15.406-36.314l-1.3112,0.82044c-7.8669,10.674-12.127,23.422-15.452,36.315-2.2479,8.6922-0.89037,17.916-1.4989,27.043-0.93647,14.439,5.9951,27.526,11.567,40.274,4.5882,10.383,13.485,17.626,21.774,25.547,2.1539,2.027,5.6195,2.7034,7.5387,4.9729,0.56218,0.62774,1.8255,1.4014,2.1067,1.5452,4.8237,2.4146,10.349,3.332,15.313,5.6505,2.0602,1.0136,4.0736,2.8481,6.087,3.1878,8.7098,1.3992,16.388,3.2348,24.115,7.2422,1.217,0.6273,2.4819,1.401,3.2783,2.6565l1.3575-0.82154'/%3E %3Cg fill='%2367923d'%3E %3Cpath d='m406.34,331.62c-2.7941-6.3005-1.3649-21.608-0.19817-23.53,6.6331,13.006,4.4252,23.741,0.19817,23.53z'/%3E %3Cpath d='m452.2,377.01c-7.0923,0.36358-20.61,9.2946-21.864,11.396,15.085,0.11624,24.02-7.3152,21.864-11.396z'/%3E %3Cpath d='m459.66,372.72c-6.8452-5.4495-14.189-23.661-14.032-26.501,15.11,10.834,18.936,24.281,14.032,26.501z'/%3E %3Cpath d='m454.61,372.78c-6.9503-4.2351-15.786-20.115-15.938-22.754,15.202,8.1944,20.198,20.129,15.938,22.754z'/%3E %3Cpath d='m439.05,366c0.9841-7.8223-5.6658-24.241-7.5855-25.979-2.9503,16.467,2.9971,27.573,7.5855,25.979z'/%3E %3Cpath d='m411.74,341.72c-2.3045-5.6455-0.61288-19.321,0.46998-20.998,5.5198,11.696,3.2645,21.218-0.46998,20.998z'/%3E %3Cpath d='m398.03,264.89c3.5892-6.6479,18.381-15.712,20.99-15.931-6.7705,14.569-18.037,19.829-20.99,15.931z'/%3E %3Cpath d='m398.74,259.33c2.1485-7.2816,14.874-19.265,17.36-20.034-3.7269,15.676-13.678,23.179-17.36,20.034z'/%3E %3Cpath d='m426.55,358.48c-4.9917-6.176-8.0115-23.865-7.2903-26.361,11.271,12.515,12.029,25.234,7.2903,26.361z'/%3E %3Cpath d='m397.9,322.02c-6.9088,1.0885-21.36-4.6362-22.921-6.3372,14.533-3.1503,24.288,2.0722,22.921,6.3372z'/%3E %3Cpath d='m395.68,312.34c0.82307-5.5775,8.6653-15.809,10.361-16.66-1.11,11.958-7.4489,18.6-10.361,16.66z'/%3E %3Cpath d='m447.01,370.88c-8.4752,0.4348-24.63,11.107-26.128,13.618,18.028,0.14334,28.705-8.7407,26.128-13.618z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='m406.41,331.47c4.2268,0.20997,6.4054-10.396-0.26853-23.379,1.2109,12.319,1.2078,22.309,0.26853,23.379z'/%3E %3Cpath d='m417.59,351.46c-4.4741-5.4704-19.381-11.328-21.712-11.141,8.8846,12.081,19.88,15.097,21.712,11.141z'/%3E %3Cpath d='m393.17,298.48c-1.1475-8.0434-12.334-22.713-14.743-23.969,1.5168,17.175,10.548,26.697,14.743,23.969z'/%3E %3Cpath d='m401.56,332.77c-4.9928-3.6812-18.971-5.3442-20.94-4.723,10.137,8.3046,20.212,8.4582,20.94,4.723z'/%3E %3Cpath d='m392.2,307.94c-2.8852-5.6898-14.812-13.482-16.892-13.701,5.5172,12.387,14.558,16.939,16.892,13.701z'/%3E %3Cpath d='m394.93,260.4c0.90544-7.573-5.5329-23.446-7.3449-25.158-2.8662,15.925,2.918,26.664,7.3449,25.158z'/%3E %3Cpath d='m399.4,245.48c2.6582-6.4958,0.756-22.429-0.52176-24.417-6.4032,13.509-3.8276,24.648,0.52176,24.417z'/%3E %3Cpath d='m404.42,237.83c3.1363-4.7713,4.1621-17.685,3.4848-19.47-7.2359,9.7147-6.9582,18.944-3.4848,19.47z'/%3E %3Cpath d='m410.37,231.69c4.4018-3.4769,9.2242-15.501,9.0837-17.433-9.7398,6.9542-12.221,15.841-9.0837,17.433z'/%3E %3Cpath d='m394.32,274.89c0.10772,0.86786-0.97776-8.1807-10.054-18.314,0.40902,14.818,6.2503,20.421,10.054,18.314z'/%3E %3Cpath d='m426.88,360.67c-6.1755-4.5593-23.385-6.7285-25.767-5.9267,12.562,10.355,24.878,10.551,25.767,5.9267z'/%3E %3Cpath d='m438.95,365.91c-4.5421,1.593-10.443-9.4167-7.5398-25.883,2.8105,13.955,6.181,25.063,7.5398,25.883z'/%3E %3Cpath d='m452.25,377.06c2.1159,4.0815-6.7004,11.436-21.787,11.315,11.952-4.8908,21.239-9.8613,21.787-11.315z'/%3E %3Cpath d='m459.64,372.59c4.8646-2.2494,1.1006-15.536-14.009-26.369,8.5947,13.214,14.455,24.609,14.009,26.369z'/%3E %3Cpath d='m454.57,372.67c4.2779-2.6663-0.68957-14.444-15.891-22.639,9.404,11.183,16.095,20.967,15.891,22.639z'/%3E %3Cpath d='m411.78,341.68c3.7347,0.22155,5.9566-9.2618,0.47698-20.924,0.71841,10.974,0.41841,19.978-0.47698,20.924z'/%3E %3Cpath d='m398.02,264.94c2.9514,3.8975,14.055-1.3092,20.837-15.923-10.165,9.3385-19.225,16.064-20.837,15.923z'/%3E %3Cpath d='m398.86,259.33c3.6818,3.1446,13.542-4.3017,17.269-19.977-8.0961,11.245-15.644,19.736-17.269,19.977z'/%3E %3Cpath d='m426.58,358.42c4.7402-1.1248,3.9539-13.784-7.2536-26.272,5.0127,13.416,8.0159,24.756,7.2536,26.272z'/%3E %3Cpath d='m397.71,321.96c1.4071-4.2401-8.2971-9.3693-22.803-6.259,12.261,2.1948,22.043,5.0424,22.803,6.259z'/%3E %3Cpath d='m395.77,312.35c2.9031,1.8871,9.1781-4.6592,10.286-16.617-4.674,9.1814-9.1663,16.265-10.286,16.617z'/%3E %3Cpath d='m446.97,371.03c2.5758,4.8764-7.9595,13.667-26.035,13.522,14.283-5.8438,25.38-11.783,26.035-13.522z'/%3E %3Cpath d='m399.36,326.3c-2.6584-6.2616-14.798-15.462-16.982-15.841,4.9458,13.638,14.248,19.146,16.982,15.841z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='m392.42,273.92c4.0745-4.6657,17.469-9.134,19.599-8.8646-8.0424,10.409-17.941,12.515-19.599,8.8646z'/%3E %3Cpath d='m417.49,351.51c-1.8072,3.9185-12.696,0.91615-21.646-11.152,10.885,6.8299,20.244,11.511,21.646,11.152z'/%3E %3Cpath d='m393.1,298.46c-4.1951,2.7268-13.128-6.7377-14.685-23.884,6.6226,13.203,13.037,23.384,14.685,23.884z'/%3E %3Cpath d='m401.52,332.8c-0.76888,3.731-10.688,3.5903-20.864-4.7173,10.729,3.4063,19.739,5.3328,20.864,4.7173z'/%3E %3Cpath d='m392.07,307.85c-2.3335,3.2394-11.289-1.2692-16.807-13.657,8.1922,7.9668,15.492,13.744,16.807,13.657z'/%3E %3Cpath d='m394.83,260.3c-4.4269,1.5557-10.16-9.0789-7.294-25.005,2.6667,13.488,5.9354,24.175,7.294,25.005z'/%3E %3Cpath d='m399.3,245.44c-4.3039,0.22724-6.8712-10.815-0.4678-24.322-0.82219,12.797-0.50691,23.234,0.4678,24.322z'/%3E %3Cpath d='m404.34,237.77c-3.4732-0.52504-3.7166-9.6555,3.5206-19.369-2.7393,9.9762-4.1512,18.366-3.5206,19.369z'/%3E %3Cpath d='m410.32,231.69c-3.1365-1.6426-0.70137-10.431,9.0376-17.337-5.5251,8.6441-9.3179,16.178-9.0376,17.337z'/%3E %3Cpath d='m394.25,274.9c-3.804,2.1063-9.5773-3.5031-9.9867-18.322,5.1018,11.684,8.6028,17.807,9.9867,18.322z'/%3E %3Cpath d='m426.82,360.7c-0.88599,4.6251-13.144,4.4011-25.678-5.895,13.168,4.2742,24.246,6.6944,25.678,5.895z'/%3E %3Cpath d='m418.65,351.22c-4.0227-4.343-7.1579-17.347-6.7467-19.242,9.0116,8.7431,10.215,18.165,6.7467,19.242z'/%3E %3Cpath d='m401.77,326.23c-3.5704-5.7862-3.8759-20.907-2.9193-22.956,8.263,11.809,7.2531,22.585,2.9193,22.956z'/%3E %3Cpath d='m399.14,326.32c-2.7356,3.3047-11.93-2.1585-16.872-15.833,8.1324,9.1108,15.474,15.812,16.872,15.833z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='m392.37,274c1.6173,3.6231,11.45,1.5297,19.493-8.8798-11.97,6.7926-16.711,9.7409-19.493,8.8798z'/%3E %3Cpath d='m401.71,326.07c4.3325-0.37079,5.3311-11.037-2.9328-22.846,2.6634,11.854,3.7909,21.678,2.9328,22.846z'/%3E %3Cpath d='m418.67,351.18c3.4697-1.0706,2.2496-10.451-6.713-19.178,4.4027,9.7272,7.2055,18.011,6.713,19.178z'/%3E %3Cpath d='m394.23,291.77c2.0582-8.3856-1.7025-22.601-4.3-25.559-4.7164,15.427-0.24471,26.599,4.3,25.559z'/%3E %3C/g%3E %3Cpath fill='%2367923d' d='m393.93,293.77c-5.8954,1.3394-8.645-12.034-4.0797-27.078,1.0708,13.546,2.8334,26.147,4.0797,27.078z'/%3E %3Cpath fill='%2367923d' d='m392.73,293.72c-0.55781-7.5274,6.9344-23.087,8.915-24.707,2.0147,15.803-4.4625,26.308-8.915,24.707z'/%3E %3Cpath fill='%23406325' d='m392.84,293.61c4.4134,1.6359,10.851-8.7614,8.8348-24.564-3.5106,13.267-7.4452,23.764-8.8348,24.564z'/%3E %3Cpath fill='%2367923d' d='m394.13,303.26c0.005-7.6093,8.4702-22.23,10.562-23.619,0.83443,16.162-6.3315,25.829-10.562,23.619z'/%3E %3Cpath fill='%23406325' d='m394.21,303.41c4.2309,2.2096,11.306-7.3639,10.471-23.525-4.4092,12.857-9.0481,22.899-10.471,23.525z'/%3E %3C/g%3E %3Cg fill='%23ba1f3e' stroke='%23511124' stroke-width='0.2185'%3E %3Ccircle stroke-width='0.1857' cx='396.835' cy='251.27' r='1.085'/%3E %3Ccircle stroke-width='0.1857' cx='405.205' cy='245.07' r='1.085'/%3E %3Ccircle stroke-width='0.1857' cx='401.564' cy='241.71' r='1.086'/%3E %3Ccircle cx='392.503' cy='313.12' r='1.277'/%3E %3Ccircle cx='395.033' cy='297.13' r='1.277'/%3E %3Ccircle cx='408.213' cy='334.46' r='1.277'/%3E %3Ccircle cx='402.393' cy='336.43' r='1.277'/%3E %3Ccircle cx='446.703' cy='367.63' r='1.277'/%3E %3Ccircle cx='449.613' cy='374.71' r='1.277'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%2324420e'%3E %3Cg fill='none' stroke-width='0.437'%3E %3Cpath d='m561.15,258.97c0.62271,0.6214,1.174,0.80799,2.2946,1.8946'/%3E %3Cpath d='m556.82,241.92c-0.035-1.3682-0.63254-3.605-0.91833-4.9729'/%3E %3Cpath d='m559.35,239.93c0.0551,1.952-0.21849,3.8094-1.0617,5.5041'/%3E %3Cpath d='m554.13,244.9c1.7526,1.5758,3.5053,3.0766,5.2576,3.8918'/%3E %3Cpath d='m563.21,250.02c0.10488,1.9802-0.14202,3.9602-0.6828,5.9404'/%3E %3Cpath d='m562.85,257.47,1.314-2.2623'/%3E %3Cpath d='m562.3,267.43c1.3997,0.29126,2.8096,1.9457,3.5053,3.4822'/%3E %3Cpath d='m566.28,269.62,1.6387-2.185'/%3E %3Cpath d='m569.63,298.16c-0.74769,1.304-1.5815,2.4353-2.4576,3.4826'/%3E %3Cpath d='m563.21,301.57c0.78942,1.456,1.5563,2.9458,2.5946,4.0288'/%3E %3Cpath d='m568.26,311.47c-1.307,1.7726-2.7661,3.1651-4.4383,4.0286'/%3E %3Cpath d='m563.96,320c-1.0925,0.7514-2.4264,2.9527-3.6871,4.7116'/%3E %3Cpath d='m568.71,304.53-2.1244,0.86896'/%3E %3Cpath d='m565.19,297.91,1.2555,1.1108'/%3E %3Cpath d='m557.15,336.41c-0.83945-0.10793-1.456,0.009-2.1244,0.0725'/%3E %3Cpath d='m553.03,334.55,0.61462,1.6387'/%3E %3Cpath d='m545.93,341.31c-0.26197,1.8662-0.0725,3.7328,0.20408,5.5989'/%3E %3Cpath d='m550.44,337.89,1.0243,2.2536'/%3E %3Cpath d='m555.29,339.94-2.5265,0.40968'/%3E %3Cpath d='m521.91,365.62-0.91702,1.7377'/%3E %3Cpath d='m532.89,363.43c-1.4923,0.18681-2.7782-0.0435-4.0968-0.20408'/%3E %3Cpath d='m523.33,369.17c-1.0835-0.42344-2.0335-0.7136-2.9361-0.95591'/%3E %3Cpath d='m505.65,370.87c-0.90588,0.77282-1.9892,2.4353-3.0727,4.0968'/%3E %3Cpath d='m502.03,370.4c-2.4334,1.2528-3.1815,3.71-4.4383,5.8041'/%3E %3Cpath d='m500.39,379.07c-1.5528-0.46081-3.4118-1.2277-5.3258-2.0484'/%3E %3Cpath d='m511.83,376.34c-2.3211-1.2052-4.7479-1.087-7.1352-1.4685'/%3E %3Cpath d='m515.45,374.53c-3.6279-0.70749-7.01-0.60982-10.276-0.137'/%3E %3Cpath d='m512.95,371.79-1.399-0.58032'/%3E %3Cpath d='m506.02,376.71-2.3226-1.2957'/%3E %3Cpath d='m561.64,326.22c-1.2555,0.81629-2.5105,2.2826-3.766,3.8626'/%3E %3Cpath d='m559.7,250.46-2.153-0.72431'/%3E %3C/g%3E %3Cg stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m474.39,384.85c0.79664-1.2555,2.1076-2.0278,3.2774-2.6556,7.7258-4.0566,15.406-5.8439,24.117-7.244,2.0126-0.33758,4.0264-2.2217,6.0866-3.187,4.9629-2.3654,10.489-3.2842,15.311-5.6975,0.32818-0.14596,1.5452-0.86939,2.1076-1.5448,1.9195-2.2221,5.385-2.899,7.5389-4.9747,8.3345-7.8713,17.184-15.116,21.772-25.546,5.5729-12.7,12.503-25.787,11.567-40.225-0.60851-9.1267,0.75031-18.35-1.4978-27.043-3.3255-12.893-7.5883-25.643-15.408-36.314l1.3114,0.82045c7.8667,10.674,12.127,23.423,15.452,36.314,2.2477,8.6922,0.89015,17.916,1.4987,27.043,0.93668,14.439-5.9951,27.526-11.566,40.275-4.5884,10.383-13.486,17.626-21.774,25.546-2.1541,2.027-5.6195,2.7034-7.5389,4.9729-0.56197,0.62774-1.8255,1.4014-2.1065,1.5452-4.8239,2.4146-10.349,3.332-15.313,5.6505-2.06,1.0136-4.0738,2.8481-6.087,3.1878-8.7094,1.3992-16.388,3.2348-24.113,7.2422-1.2174,0.6273-2.4823,1.401-3.2787,2.6565l-1.3579-0.82154'/%3E %3Cg fill='%23406325'%3E %3Cpath d='m553.65,334.6c2.741-7.4159-0.009-24.838-1.4893-26.951-6.6486,15.372-3.3412,27.502,1.4893,26.951z'/%3E %3Cpath d='m546.54,341.64c2.3045-5.6455,0.61287-19.321-0.46977-20.998-5.52,11.696-3.265,21.218,0.46977,20.998z'/%3E %3Cpath d='m563.35,267.49c-3.2932-6.1004-16.867-14.418-19.261-14.618,6.2129,13.368,16.552,18.195,19.261,14.618z'/%3E %3Cpath d='m561.76,259.47c-1.7906-6.0678-12.395-16.053-14.466-16.694,3.105,13.063,11.398,19.315,14.466,16.694z'/%3E %3Cpath d='m566.5,274.43c-3.537-4.0507-15.164-7.9285-17.013-7.6952,6.9807,9.0363,15.572,10.864,17.013,7.6952z'/%3E %3Cpath d='m563.7,320.76c6.1323,0.96619,18.959-4.1151,20.345-5.6254-12.9-2.7965-21.559,1.8395-20.345,5.6254z'/%3E %3Cpath d='m563.55,315.12c-0.0435-5.6378-6.3949-16.856-7.9563-17.933-0.5552,11.996,4.8038,19.453,7.9563,17.933z'/%3E %3Cpath d='m563.96,301.44c-0.005-7.6093-8.4697-22.23-10.562-23.619-0.83421,16.161,6.3318,25.828,10.562,23.619z'/%3E %3Cpath d='m511.07,376.71c4.4772,5.5034,19.653,11.133,22.088,10.904-8.8047-12.233-20.07-15.05-22.088-10.904z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='m553.56,334.43c-4.8235,0.55082-8.0898-11.437-1.3946-26.785-0.49074,14.192,0.2386,25.629,1.3946,26.785z'/%3E %3Cpath d='m500.19,378.09c7.0926,0.36314,20.61,9.2946,21.865,11.396-15.086,0.11689-24.021-7.3146-21.865-11.396z'/%3E %3Cpath d='m500.19,370.15c2.0984-7.9674,15.006-21.21,17.514-22.151-3.6025,17.134-13.74,25.535-17.514,22.151z'/%3E %3Cpath d='m521.46,365.92c-0.98454-7.8223,5.6651-24.24,7.585-25.979,2.9506,16.466-2.9967,27.574-7.585,25.979z'/%3E %3Cpath d='m542.92,351.38c4.4741-5.4704,19.381-11.328,21.712-11.141-8.8849,12.081-19.88,15.097-21.712,11.141z'/%3E %3Cpath d='m568.71,298.12c0.9026-6.3318,9.7097-17.881,11.606-18.87-1.1936,13.521-8.3041,21.018-11.606,18.87z'/%3E %3Cpath d='m557.02,336.18c5.817-4.2901,22.105-6.228,24.399-5.5037-11.813,9.676-23.552,9.8548-24.399,5.5037z'/%3E %3Cpath d='m567.29,311.66c3.0329-5.9791,15.566-14.169,17.754-14.399-5.7991,13.019-15.301,17.802-17.754,14.399z'/%3E %3Cpath d='m565.81,266.1c-0.0983-7.6255,7.9838-22.728,9.9655-24.24,1.1659,16.139-5.7222,26.206-9.9649,24.24z'/%3E %3Cpath d='m558.88,240.18c-2.3224-5.2808-1.101-18.414-0.0931-20.074,5.5504,10.963,3.6722,20.17,0.0931,20.074z'/%3E %3Cpath d='m554.65,238c-5.2745-4.6832-10.645-19.756-10.411-22.103,11.751,9.2631,14.386,20.361,10.411,22.103z'/%3E %3Cpath d='m566.28,272.54c-0.31659,0.81521,2.9447-7.6949,14.219-15.308-4.0118,14.271-11.044,18.279-14.219,15.308z'/%3E %3Cpath d='m532.18,362.44c7.0056-5.1726,26.532-7.634,29.232-6.7237-14.253,11.748-28.225,11.97-29.232,6.7237z'/%3E %3Cpath d='m546.51,341.6c-3.7345,0.22156-5.9566-9.2618-0.47675-20.924-0.71885,10.974-0.41842,19.978,0.47675,20.924z'/%3E %3Cpath d='m563.36,267.53c-2.7082,3.5763-12.897-1.2015-19.121-14.611,9.3275,8.5696,17.642,14.742,19.121,14.611z'/%3E %3Cpath d='m561.66,259.47c-3.0683,2.6202-11.285-3.5835-14.391-16.646,6.746,9.3701,13.036,16.446,14.391,16.646z'/%3E %3Cpath d='m566.55,274.5c-1.4045,3.145-9.9393,1.328-16.92-7.7078,10.389,5.8959,14.505,8.4546,16.92,7.7078z'/%3E %3Cpath d='m563.86,320.71c-1.2491-3.764,7.3648-8.3166,20.241-5.5559-10.884,1.9485-19.567,4.4765-20.241,5.5559z'/%3E %3Cpath d='m563.46,315.11c-3.1365,1.4672-8.4452-5.8845-7.8885-17.881,3.3598,9.74,6.8284,17.376,7.8885,17.881z'/%3E %3Cpath d='m563.88,301.59c-4.2307,2.2092-11.305-7.3641-10.471-23.525,4.4092,12.857,9.0479,22.898,10.471,23.525z'/%3E %3Cpath d='m511.19,376.66c2.0178-4.1459,13.15-1.3776,21.976,10.888-10.995-6.7493-20.482-11.305-21.976-10.888z'/%3E %3C/g%3E %3Cg fill='%23406325'%3E %3Cpath d='m521.55,365.83c4.5423,1.593,10.443-9.4167,7.5402-25.883-2.8103,13.955-6.1816,25.064-7.5402,25.883z'/%3E %3Cpath d='m531.83,360.59c4.3386-6.6505,5.5498-24.554,4.579-26.967-9.9432,13.594-9.4086,26.324-4.579,26.967z'/%3E %3Cpath d='m500.14,378.13c-2.1163,4.081,6.7004,11.436,21.787,11.315-11.951-4.8897-21.238-9.8604-21.787-11.315z'/%3E %3Cpath d='m500.3,370.08c3.7852,3.3384,13.808-4.948,17.409-22.083-8.1269,12.423-15.723,21.799-17.409,22.083z'/%3E %3Cpath d='m543.01,351.43c1.8072,3.9185,12.696,0.91615,21.646-11.152-10.885,6.8301-20.244,11.512-21.646,11.152z'/%3E %3Cpath d='m568.76,298.1c3.3025,2.1469,10.335-5.3035,11.561-18.803-5.2139,10.395-10.263,18.409-11.561,18.803z'/%3E %3Cpath d='m557.07,336.21c0.89539,4.3476,12.454,4.1833,24.312-5.496-12.502,3.9692-23.001,6.214-24.312,5.496z'/%3E %3Cpath d='m567.43,311.57c2.4526,3.405,11.865-1.3337,17.664-14.352-8.6094,8.3729-16.281,14.445-17.664,14.352z'/%3E %3Cpath d='m565.92,266.01c4.2377,2.0156,11.064-7.9523,9.8985-24.093-4.0786,13.13-8.4597,23.412-9.8985,24.093z'/%3E %3Cpath d='m558.96,240.14c3.5416,0.0933,5.4145-9.0334-0.13393-19.995,0.94936,10.498,0.91309,19.08,0.13393,19.995z'/%3E %3Cpath d='m554.73,237.9c3.9722-1.7421,1.3306-12.711-10.422-21.972,6.4718,11.02,10.853,20.573,10.422,21.972z'/%3E %3Cpath d='m566.34,272.57c3.175,2.9709,10.143-1.0606,14.155-15.33-7.7985,10.084-12.688,15.169-14.155,15.33z'/%3E %3Cpath d='m532.25,362.48c1.0051,5.2474,14.913,4.9935,29.132-6.6879-14.94,4.849-27.508,7.5951-29.132,6.6879z'/%3E %3Cpath d='m539.14,354.75c3.272-4.9336,4.2744-18.274,3.5639-20.077-7.4878,10.079-7.1605,19.572-3.5639,20.077z'/%3E %3Cpath d='m558.74,326.14c3.5702-5.7857,3.8761-20.908,2.9191-22.957-8.2635,11.81-7.254,22.586-2.9191,22.957z'/%3E %3C/g%3E %3Cg fill='%2367923d'%3E %3Cpath d='m531.79,360.54c-4.8298-0.638-5.3313-13.312,4.5517-26.873-3.6261,13.856-5.4632,25.442-4.5517,26.873z'/%3E %3Cpath d='m566.95,292.21c-0.94346-7.7646,3.976-20.143,6.6318-22.522,2.5732,14.385-2.6602,23.949-6.6318,22.522z'/%3E %3Cpath d='m539.11,354.7c-3.5966-0.49883-3.9012-9.9535,3.5407-20.007-2.7803,10.308-4.2141,18.935-3.5407,20.007z'/%3E %3Cpath d='m562.47,250.46c-2.167-5.8812,0.0291-20.041,1.2358-21.774,5.2887,12.257,2.6381,22.116-1.2358,21.774z'/%3E %3Cpath d='m504.39,370.61c2.4738-8.0911,16.191-21.081,18.807-21.915-4.3352,17.421-15.065,25.529-18.807,21.915z'/%3E %3Cpath d='m558.92,329.02c2.6582-6.2616,14.798-15.462,16.981-15.841-4.9452,13.638-14.248,19.146-16.981,15.841z'/%3E %3Cpath d='m558.8,325.99c-4.3328-0.37078-5.3313-11.037,2.9326-22.846-2.6637,11.854-3.7907,21.678-2.9326,22.846z'/%3E %3C/g%3E %3Cpath fill='%23406325' d='m567,294.04c5.158,1.8423,9.0778-9.8897,6.5983-23.914-2.4286,12.067-5.3769,23.211-6.5983,23.914z'/%3E %3Cpath fill='%23406325' d='m567.77,293.64c0.55738-7.5274-6.9346-23.086-8.9152-24.707-2.0147,15.803,4.463,26.309,8.9152,24.707z'/%3E %3Cpath fill='%23406325' d='m562.55,250.42c3.8344,0.33692,6.4733-9.4346,1.1869-21.69,0.33015,11.446-0.28251,20.75-1.1869,21.69z'/%3E %3Cpath fill='%23406325' d='m504.5,370.53c3.7874,3.6209,14.369-4.4169,18.704-21.838-8.839,12.353-16.968,21.612-18.704,21.838z'/%3E %3Cpath fill='%23406325' d='m559.14,329.04c2.7351,3.3047,11.93-2.1581,16.872-15.833-8.133,9.111-15.474,15.812-16.872,15.833z'/%3E %3Cpath fill='%2367923d' d='m567.66,293.53c-4.4134,1.6359-10.851-8.761-8.8346-24.563,3.5099,13.267,7.445,23.763,8.8346,24.563z'/%3E %3C/g%3E %3Cg fill='%23ba1f3e' stroke='%23511124' stroke-width='0.2185'%3E %3Ccircle cx='564.625' cy='254.9' r='1.085'/%3E %3Ccircle cx='568.415' cy='266.82' r='1.085'/%3E %3Ccircle cx='569.757' cy='304.3' r='1.277'/%3E %3Ccircle cx='564.647' cy='297.29' r='1.277'/%3E %3Ccircle cx='549.907' cy='337.17' r='1.277'/%3E %3Ccircle cx='556.197' cy='339.9' r='1.277'/%3E %3Ccircle cx='513.797' cy='372.26' r='1.277'/%3E %3Ccircle cx='506.797' cy='377.29' r='1.277'/%3E %3Ccircle cx='557.054' cy='249.25' r='1.084'/%3E %3C/g%3E %3C/g%3E %3Cg id='gun' fill='%238c959d' stroke='%23485654' stroke-width='0.1092'%3E %3Cpath d='m434.25,336.27c-0.13416,1.066,0.84186,2.339,2.1284,2.0698,0.38608-0.0784,0.62359-0.58076,0.1311-0.48987-0.42497,0.10794-0.87857-0.0699-1.2017-0.37384-0.59693-0.56372-0.65527-1.3516-0.39613-1.9186-0.23073,0.24755-0.44966,0.48352-0.66051,0.71141l-0.001,0.001z'/%3E %3Cpath stroke='none' d='m437.24,338.34c-1.0156,1.165-2.568,1.6758-3.4266,0.83421-0.57311-0.56503-0.77784-1.2056-0.46845-1.9118-0.44289,0.48134-0.82241,0.89692-1.1211,1.2308,0.0468,0.0896,0.71492,1.3088,1.708,1.7582,1.2231,0.5506,2.9724-0.27946,4.0179-1.5644,0.73873-0.90894,1.5612-2.4277,0.96706-3.6087-0.36467-0.7289-1.2384-1.4246-1.9673-1.6997-0.35047,0.37515-0.69482,0.74769-1.0261,1.101,0.50888-0.23947,1.1475-0.13437,1.6949,0.31289,1.2732,1.0348,0.5364,2.4987-0.378,3.546l-0.00022,0.002z'/%3E %3Cpath fill='%23485654' stroke='none' d='m437.24,338.34c-0.32446,0.38324-0.71469,0.71775-1.162,0.95591-0.4442,0.2351-0.95679,0.39045-1.4726,0.31835-0.25521-0.0358-0.50669-0.13394-0.71186-0.2965-0.20386-0.16562-0.37035-0.35942-0.50953-0.57945-0.13656-0.2198-0.23007-0.47369-0.24734-0.73742-0.019-0.26328,0.0387-0.52875,0.14115-0.76779l0.12236,0.0798-1.1097,1.2389,0.0129-0.099c0.27574,0.47916,0.62314,0.93756,1.0418,1.2998,0.21041,0.17917,0.44158,0.33539,0.69394,0.43656,0.2493,0.10072,0.52351,0.14093,0.79663,0.1335,0.54886-0.0157,1.0879-0.20604,1.5729-0.47632,0.48681-0.27137,0.92576-0.62905,1.2981-1.0424,0.37144-0.41645,0.68979-0.88687,0.93516-1.3883,0.23968-0.50014,0.41011-1.0486,0.37384-1.5948-0.0188-0.2718-0.09-0.53465-0.22418-0.77456-0.13087-0.23685-0.30567-0.45753-0.49991-0.65505-0.39154-0.39307-0.85912-0.72584-1.3711-0.93319l0.0929-0.0218-1.0359,1.0925-0.0843-0.11602c0.23576-0.10707,0.4997-0.14509,0.75359-0.11734,0.25433,0.0291,0.49795,0.11646,0.7147,0.24494,0.42781,0.25695,0.79838,0.64914,0.92554,1.1445,0.12913,0.49424,0.002,1.0079-0.20823,1.448-0.21237,0.44594-0.51062,0.84207-0.8377,1.2052l-0.001,0.002zm0.00022-0.002c0.3142-0.37516,0.59496-0.7809,0.79336-1.2251,0.1962-0.44005,0.30196-0.94237,0.16714-1.404-0.13175-0.45993-0.49314-0.82613-0.90019-1.0625-0.40793-0.23816-0.92445-0.30545-1.3455-0.10072l-0.0843-0.11646,1.0171-1.1091,0.0389-0.0417,0.0542,0.021c0.54929,0.2091,1.033,0.5493,1.4456,0.95985,0.20495,0.20735,0.38958,0.43524,0.53597,0.69678,0.14639,0.25695,0.23095,0.55651,0.25148,0.85169,0.042,0.5978-0.13852,1.177-0.38433,1.6988-0.2528,0.52351-0.57748,1.007-0.96116,1.4429-0.38979,0.43196-0.84907,0.79925-1.3588,1.0804-0.50888,0.27858-1.0759,0.47829-1.6704,0.49293-0.29584,0.006-0.59627-0.0389-0.87572-0.15273-0.27683-0.11362-0.52308-0.28251-0.74354-0.47326-0.44027-0.38783-0.79292-0.85104-1.0735-1.363l-0.0293-0.0537,0.0415-0.0457,1.1322-1.2218,0.12258,0.0797c-0.099,0.22068-0.15448,0.45993-0.14115,0.69984,0.012,0.23947,0.0924,0.4737,0.21675,0.68192,0.12476,0.20692,0.28841,0.40247,0.47282,0.55695,0.18659,0.15447,0.41623,0.25258,0.65723,0.29365,0.48681,0.0824,0.99197-0.0524,1.4357-0.27312,0.44638-0.22461,0.84645-0.54077,1.1851-0.91177z'/%3E %3Cpath fill='%236c301e' stroke='%23351710' stroke-width='0.2185' stroke-linejoin='round' d='m515.24,249.25-40.137,39.515c-3.0526,3.0316-37.963,36.379-41.105,39.384-1.1025,1.323-4.2327,4.8584-4.5611,5.3531-2.129,2.3104-4.4389,5.3297-7.1968,8.0297-0.49118,0.61878-1.1421,0.39394-1.7344,0.73742-1.8133,1.0503-3.6965,2.8695-5.0527,4.3699l-12.208,13.506c-0.78636,0.85344-0.99568,1.38-0.4643,1.871l6.6232,8.849c1.2288,1.2142,2.6444,1.838,3.1955,0.81936,3.1463-5.4466,10.962-13.759,13.915-20.334,1.7641-3.929,3.9779-11.058,5.5581-12.782,1.9383-2.1572,7.1697-7.7301,11.806-12.705,0.31332-0.33539,0.62314-0.66881,0.92882-0.99721,0.32119-0.34434,0.63691-0.68454,0.94761-1.019,23.506-23.951,50.715-53.046,70.526-73.558-0.77784-0.775-0.28622-0.31158-1.0416-1.04z'/%3E %3Cpath d='m431.89,328.11c-1.2251,0.043-2.0215-0.70705-2.8481-1.4001,1.1687,0.34609,2.3449,0.79707,3.452,0.33845l-0.60392,1.0617z'/%3E %3Cpath fill='%23b2b6ba' stroke-width='0.2185' d='m557.05,220.1-31.804,26.219c-0.30589,0.37407-0.62358,0.26657-0.9286,0l-2.895-2.4172c0.004-0.0363,0.0138-0.0723,0.0138-0.10925,0-0.16256-0.0317-0.31878-0.0819-0.4643l1.4202-1.4475c0.17633-0.22068,0.11952-0.3096-0.12301-0.54623-0.1831-0.19053-0.34391-0.36489-0.58753-0.60086-0.22789-0.17567-0.41558-0.0354-0.64194,0.17763l-1.434,1.4748c-0.73392,0.0297-1.3311,0.63014-1.352,1.3656-19.238,18.731-35.794,35.435-54.938,53.872l-22.573,21.549c-0.80581,1.0429-4.2901,2.9075-6.5959,4.411-0.81673,0.53269-1.5233,1.0164-1.8163,1.5432l-1.8437,5.4351c-0.58207,1.1941-2.4308,4.0028-2.5127,4.1927,2.3683,2.3864,2.2479,2.2127,3.8647,3.7282,1.8179-2.0233,6.6894-7.1118,11.116-11.853,0.3568-0.38236,0.37887-0.42169,0.83312-0.96968-0.34653-0.48855-0.92751-1.2048-1.3929-1.6527-0.39613-0.37843-0.82547-0.76735-1.2013-1.0925-0.24493-0.21216-0.46758-0.39133-0.62817-0.54624-0.163-0.15622,0.24034-0.44376,0.42344-0.64194,26.464-25.579,54.962-53.695,78.276-76.595,0.12454,0.0367,0.25957,0.0546,0.39613,0.0546,0.22702,0,0.44005-0.0553,0.62817-0.15032l2.7858,3.2092c0.65417,0.6522,1.2081,0.63953,1.7346,0.39613l31.859-28.542z'/%3E %3Cpath fill='%23485654' stroke='none' d='m430.95,330.39c0.20145,0.0286,0.40509,0.0478,0.60633,0.0312,0.20079-0.0166,0.397-0.0699,0.57354-0.16256l-0.0164,0.0197c0.22832-0.79641,0.47151-1.5876,0.71404-2.3792,0.24733-0.78986,0.49795-1.5791,0.75948-2.365l0.006,0.0269c-0.19489-0.22308-0.43589-0.42126-0.73108-0.4962,0.29956,0.0573,0.55913,0.24406,0.77063,0.45971l0.0111,0.0112-0.005,0.0153c-0.22789,0.79663-0.4667,1.5887-0.70857,2.3807-0.24712,0.79029-0.49293,1.5802-0.75447,2.3663l-0.005,0.0138-0.012,0.006c-0.18725,0.0922-0.39548,0.13831-0.60086,0.14093-0.20626,0.003-0.40946-0.0284-0.60873-0.0686z'/%3E %3Ccircle fill='none' stroke-width='0.1639' cx='438.17876' cy='328.1347' r='0.61921'/%3E %3Ccircle fill='none' stroke-width='0.1639' cx='434.43594' cy='331.87751' r='0.61921'/%3E %3Cpath fill='%23485654' stroke='none' d='m440.97,322.38c-0.319-0.24078-0.61528-0.50538-0.90631-0.77544-0.28842-0.27268-0.57137-0.55126-0.83181-0.85387,0.319,0.24034,0.61484,0.50494,0.90588,0.775,0.28863,0.27312,0.57136,0.55148,0.83224,0.85431z'/%3E %3Cpath d='m502.17,259.06,3.487,3.4098,0.64521-0.58578-3.487-3.4094-0.64522,0.58534z'/%3E %3C/g%3E %3Cuse xlink:href='%23gun' transform='matrix(-0.99877061,-0.04957067,-0.04957067,0.99877061,973.59129,23.686411)'/%3E %3Cg stroke='%2324420e' stroke-width='0.1639'%3E %3Cpath fill='%2367923d' d='m433.91,365.36c-7.8658-3.3213-26.89-0.67034-29.219,0.9321,16.285,8.0113,29.54,4.5738,29.219-0.9321z'/%3E %3Cpath fill='%2367923d' d='m522.93,368.68c7.8658-3.3209,26.89-0.6699,29.219,0.93254-16.285,7.9823-29.54,4.5733-29.219-0.93254z'/%3E %3Cpath fill='%23406325' d='m433.76,365.48c0.32054,5.5058-12.789,8.8853-29.075,0.90304,15.295,0.93209,27.793,0.37843,29.075-0.90304z'/%3E %3Cpath fill='%23406325' d='m523.08,368.77c-0.32053,5.5058,12.789,8.8853,29.075,0.90304-15.295,0.93253-27.793,0.40793-29.075-0.90304z'/%3E %3C/g%3E %3Cg id='sword'%3E %3Cpath fill='%23b2b6ba' stroke='%23485654' stroke-width='0.2185' d='m508.49,359.99c-20.733-30.119-51.995-54.611-76.102-67.991,3.5569-0.16649,11.46,3.8809,14.67,5.9485,23.94,15.427,44.3,35.803,65.664,59.822-1.2579,1.2456-2.0818,1.9802-3.4461,3.0517l-0.7857-0.83006z'/%3E %3Cpath fill='%238c959d' d='m510.55,359.75-1.4506,1.3938c-23.01-29.619-55.093-57.945-76.668-69.13,30.08,13.855,55.391,41.77,78.033,67.65l0.085,0.0856z'/%3E %3Cpath fill='%23485654' d='m510.56,359.75-1.4475,1.3968-0.004,0.003-0.003-0.004c-5.3258-6.8234-10.975-13.389-16.864-19.73-5.8849-6.3453-12.012-12.466-18.368-18.337-6.3591-5.8677-12.943-11.495-19.81-16.76-3.4345-2.6296-6.9411-5.1665-10.542-7.5628-3.601-2.3932-7.2966-4.6522-11.133-6.6442l0.0957-0.19577c7.8922,3.6436,15.339,8.1949,22.375,13.281,7.0388,5.0907,13.677,10.715,20.029,16.631,6.3521,5.9199,12.422,12.135,18.328,18.497,5.902,6.3667,11.629,12.892,17.343,19.425zc-5.7401-6.5109-11.494-13.012-17.42-19.353-5.9164-6.3497-11.991-12.556-18.349-18.463-6.3573-5.9039-12.999-11.515-20.037-16.591-7.0358-5.0702-14.478-9.6039-22.36-13.229l0.0957-0.19555c3.8448,1.9999,7.5413,4.2696,11.144,6.6702,3.6014,2.4041,7.1078,4.948,10.542,7.585,6.8644,5.278,13.444,10.918,19.798,16.798,6.3512,5.8832,12.472,12.013,18.35,18.369,5.8675,6.3641,11.489,12.957,16.789,19.8l-0.006-0.00044,1.4536-1.3901z'/%3E %3Cg fill='%23fab81c' stroke='%236c301e' stroke-width='0.1092'%3E %3Cpath stroke-width='0.2185' d='m517.5,355.07c-1.9737,0.51128-3.7256,1.2533-5.2585,2.2256-0.22701,1.3973-1.9525,2.9578-3.5864,3.3115-0.29737-0.37799-0.36707-0.48855-0.5919-0.77106-0.0376-0.0496-0.10204-0.073-0.1689-0.038-0.14202,0.0756-0.33211,0.18047-0.57355,0.33932-0.60938-0.10204-1.3365,0.19796-1.6597,0.97602-0.37843,0.96924,0.38542,2.2481,1.2244,3.084,0.92402,0.72933,1.3866,1.0691,2.4572,0.91964,1.0835-0.22396,1.6813-1.2129,1.9258-1.5277,3.7196,4.503,6.517,6.9326,11.229,10.64,2.0984,0.017,3.225-1.3059,2.5203-2.8028-0.23248-0.50188-0.84121-0.83509-1.3324-0.65155,0.0406-0.15142,0.0238-0.30546,0-0.45098,2.4624-2.2643,3.5134-5.0881,0.91461-9.8733-2.2238-4.0293-4.712-5.397-7.0875-5.3804l-0.0129-0.00066zm6.2459,4.5307c0.4383,0.74091,0.69176,1.3796,1.0245,2.053,1.4829,2.9993,0.19556,6.6027-2.334,7.7065-0.12301-0.005-0.085-0.0214-0.21303,0.0218,0.41274-0.68739-0.82744-2.1537-1.4613-1.6387,0.29955-0.75883-0.66925-2.0189-1.4615-1.6938,0.4147-0.70574-0.53291-1.9059-1.4202-1.5159,0.4584-0.76648-0.32381-1.8653-1.2424-1.666,0.27662-0.81717-0.4182-1.753-1.3523-1.5978,0.0789-0.723-0.1571-1.1202-0.50691-1.4493,1.1126-0.84666,2.3475-2.1509,3.4378-2.738,2.7218-1.1788,4.4031,1.0724,5.5272,2.5173h0.001v0.00044h0.00065z'/%3E %3Cpath d='m524.89,362.77c-0.51543-0.25345-0.75577-0.76036-0.58687-1.1049,0.16846-0.34217,0.70158-0.43241,1.217-0.17764,0.51587,0.25345,0.80144,0.74376,0.63276,1.0879-0.17195,0.34304-0.74725,0.44989-1.2636,0.19556l0.00065-0.00088z'/%3E %3Cpath d='m524.59,361.75c-0.51543-0.25345-0.75577-0.76014-0.58688-1.1045,0.16846-0.3426,0.70159-0.43262,1.2175-0.17785,0.51542,0.25345,0.80143,0.74419,0.63254,1.0881-0.17196,0.34304-0.74725,0.44945-1.2636,0.19512l0.00044-0.00088z'/%3E %3Cpath d='m523.97,360.62c-0.51543-0.25346-0.75621-0.76037-0.58732-1.1049,0.16846-0.34216,0.70159-0.43262,1.2174-0.17764,0.51587,0.25346,0.80188,0.74376,0.63255,1.0879-0.17196,0.34303-0.74726,0.44988-1.2636,0.19555l0.00088-0.00087z'/%3E %3Cpath d='m523.19,359.6c-0.51586-0.25346-0.75577-0.76037-0.58731-1.1049,0.1689-0.34216,0.70159-0.4324,1.2174-0.17764,0.51587,0.25302,0.80144,0.74376,0.63254,1.0879-0.17151,0.3426-0.74725,0.44944-1.2631,0.19555l0.00043-0.00087z'/%3E %3Cpath d='m522.16,358.61c-0.51543-0.25346-0.75577-0.76015-0.58688-1.1049,0.0229-0.0465,0.007-0.13656,0.0551-0.11384,0.20998,0.10794,0.64391,0.18682,0.59628-0.13699-0.0645-0.11362-0.14596-0.22702-0.0695-0.14203,0.14858,0.004,0.4643,0.1335,0.63626,0.22156,0.51543,0.25345,0.80144,0.74375,0.63254,1.0879-0.17195,0.34304-0.74725,0.44988-1.2636,0.19556v-0.007z'/%3E %3C/g%3E %3Cg fill='%23fab81c'%3E %3Cpath d='m511.27,363.6c0.68192-1.7735,2.0468-3.414,3.5077-3.8057'/%3E %3Cpath d='m511.5,363.85c1.2629,0.26241,3.3089-1.243,3.806-2.5878'/%3E %3Cpath d='m512.69,365.3c1.6558,0.38149,3.2912-1.2175,3.9338-2.4085'/%3E %3Cpath d='m514.18,366.88c1.9566,0.064,3.1636-1.3263,3.7387-2.3901'/%3E %3Cpath d='m515.69,368.41c1.661,0.0111,3.1717-1.3597,3.6458-2.424'/%3E %3Cpath d='m517.15,369.81c1.808-0.073,3.084-0.89539,3.6196-2.0748'/%3E %3Cpath d='m518.79,371.23c1.661,0.0959,3.0026-0.89583,3.443-1.8622'/%3E %3Cpath d='m520.57,372.68c1.6614,0.0959,2.6954-0.92991,3.1363-1.8965'/%3E %3C/g%3E %3Cg fill='%236c301e'%3E %3Cpath d='m511.27,363.6c0.13961-0.42344,0.32555-0.83312,0.54405-1.224,0.21893-0.39089,0.47763-0.76014,0.76451-1.1054,0.29453-0.33845,0.6179-0.65505,0.98585-0.91506,0.36663-0.25913,0.77587-0.46649,1.2133-0.56197-0.42366,0.13962-0.81302,0.36183-1.1633,0.62992-0.35046,0.26875-0.66925,0.57858-0.95198,0.9179-0.57748,0.67274-1.0284,1.4456-1.3925,2.2586z'/%3E %3Cpath d='m511.5,363.85c0.4053,0.0572,0.80864-0.0448,1.1796-0.1925,0.37209-0.15185,0.72387-0.35374,1.0481-0.59277,0.32861-0.23292,0.63035-0.50451,0.90172-0.80188,0.2705-0.29824,0.51172-0.62817,0.67646-1.0007-0.12301,0.39001-0.35112,0.74179-0.61287,1.0562-0.26373,0.31441-0.5718,0.58972-0.90129,0.83421-0.33539,0.23598-0.69438,0.44376-1.0826,0.58251-0.38411,0.1359-0.80952,0.21784-1.2091,0.11493z'/%3E %3Cpath d='m512.69,365.3c0.40465,0.0712,0.81848,0.035,1.2035-0.0863,0.38586-0.12039,0.74769-0.31114,1.0763-0.54798,0.33321-0.23052,0.63408-0.50604,0.91156-0.80406,0.27749-0.29803,0.52701-0.62228,0.74245-0.97078-0.17589,0.37123-0.4123,0.71361-0.67974,1.0267-0.26853,0.3142-0.57573,0.59496-0.91156,0.83727-0.34063,0.23423-0.71316,0.43262-1.1154,0.53903-0.40181,0.10859-0.83247,0.12214-1.2271,0.006z'/%3E %3Cpath d='m514.18,366.88c0.39089-0.0125,0.77806-0.0653,1.1458-0.18266,0.36751-0.1169,0.71776-0.28645,1.0333-0.50691,0.32097-0.21413,0.60632-0.47763,0.86546-0.76473,0.25979-0.2871,0.48768-0.60436,0.69481-0.93582-0.3332,0.70705-0.84841,1.3378-1.4982,1.7906-0.32861,0.21937-0.68956,0.39482-1.0711,0.49664-0.38214,0.10422-0.78068,0.1359-1.17,0.10291z'/%3E %3Cpath d='m515.69,368.41c0.76691-0.0417,1.4932-0.33233,2.1128-0.76517,0.3142-0.21216,0.60086-0.46299,0.86109-0.73873,0.26023-0.27618,0.49205-0.58076,0.67121-0.92008-0.1383,0.35899-0.35723,0.68454-0.60894,0.97645-0.25214,0.29279-0.5458,0.54886-0.86153,0.77238-0.3214,0.21456-0.66706,0.39766-1.0352,0.51762-0.36795,0.12039-0.75621,0.18244-1.1394,0.15753z'/%3E %3Cpath d='m517.15,369.81c0.36489-0.0384,0.72628-0.0935,1.078-0.18681,0.35069-0.0935,0.69482-0.21631,1.0127-0.38827,0.32228-0.1643,0.6179-0.37777,0.87835-0.62904,0.25979-0.25127,0.47828-0.54668,0.65111-0.87005-0.13197,0.34304-0.33757,0.65898-0.59147,0.92991-0.25476,0.27006-0.56065,0.48987-0.88774,0.66619-0.6616,0.33933-1.4084,0.49293-2.141,0.47807z'/%3E %3Cpath d='m518.79,371.23c0.34522-0.004,0.68739-0.0398,1.0195-0.12039,0.33124-0.0815,0.65373-0.19752,0.95285-0.35965,0.30306-0.15447,0.58251-0.3533,0.83378-0.58294s0.47064-0.49598,0.63625-0.79969c-0.1241,0.32381-0.33233,0.61331-0.57791,0.86065-0.24625,0.24843-0.53466,0.45228-0.8423,0.61878-0.31157,0.15841-0.64259,0.27901-0.98585,0.34434-0.34216,0.0653-0.69328,0.0802-1.0363,0.0389z'/%3E %3Cpath d='m520.57,372.68c0.326-0.005,0.65002-0.0363,0.96051-0.11952,0.31026-0.0815,0.60981-0.2032,0.88031-0.37471,0.27487-0.16344,0.5198-0.37516,0.73698-0.61157,0.21762-0.23685,0.4016-0.50538,0.55826-0.79073-0.23008,0.612-0.67646,1.1445-1.2384,1.4954-0.28426,0.16934-0.59452,0.29694-0.91833,0.36314-0.3225,0.0677-0.65527,0.0771-0.9793,0.038z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23sword' transform='matrix(-0.99823174,-0.05944245,-0.05944245,0.99823174,979.09134,28.304721)'/%3E %3Cg stroke='%2324420e' stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m409.24,240.02c7.2105-2.3667,18.73-15.453,19.478-17.917-15.593,4.154-22.757,14.343-19.478,17.917z'/%3E %3Cpath fill='%23406325' d='m554.98,244.72c-1.7023-7.0449-13.279-19.011-15.568-19.911,2.7633,15.161,11.916,22.759,15.568,19.911z'/%3E %3Cpath fill='%2367923d' d='m409.24,240.02c-3.3248-3.5739,3.7915-13.666,19.339-17.82-10.957,8.4033-19.199,16.178-19.339,17.82z'/%3E %3Cpath fill='%2367923d' d='m554.98,244.72c-3.6558,2.8916-12.72-4.6537-15.486-19.77,7.1631,11.072,13.934,19.511,15.486,19.77z'/%3E %3C/g%3E %3Cg stroke='%23999270' stroke-width='0.1639'%3E %3Cpath fill='url(%23rg1)' d='m452.21,318.1s-6.1583,0.66182-7.8844-7.8335c-1.8458-9.0861,5.3064-10.052,5.3064-10.052s8.1033-0.78046,13.15-0.90894l2.24,17.953-12.812,0.84165z'/%3E %3Cpath fill='url(%23rg2)' d='m453.02,315.36s-3.9845,0.76167-4.8069-5.5533c-0.58272-4.4732,2.185-5.1073,2.185-5.1073l9.236,1.5636,0.0503,8.2414-6.6643,0.85562z'/%3E %3Cpath fill='url(%23rg3)' d='m450.4,304.7s5.9055-0.43022,8.9889-0.82963l1.2806,5.7108-7.1011,0.44464c-0.00022,0-0.48746-5.1552-3.1684-5.3258z'/%3E %3Cpath fill='url(%23rg4)' d='m449.16,300.36s7.5754-1.8574,8.5165,6.4886c0.24581,2.1814-0.94106,7.1673-4.6555,8.5145l13.874-1.4565-1.2563-15.007-4.6738,0.39045s-9.9225,0.34107-11.805,1.0702z'/%3E %3Cpath fill='%23f9f0aa' d='m452.2,318.1c0.0472,0,51.903-3.4913,57.217-3.2739,15.743-8.6382-0.076-42.559-13.342-61.532,1.5146-4.2757-29.858-13.892-44.047-13.024-1.782,0.10903-3.5051,0.22724-5.1541,0.35397-7.6956,0.81629-7.7754,10.694-4.6367,16.923,3.0449,6.0429,30.315,55.126,11.14,60.317l-1.1766,0.23576z'/%3E %3Cpath fill='url(%23lg1)' d='m507.79,273.34c-3.5202-7.304-7.7338-14.349-11.718-20.046,1.5142-4.2757-29.859-13.892-44.047-13.024-1.782,0.10903-3.5051,0.22724-5.1541,0.35397-7.6956,0.81629-7.7754,10.694-4.6367,16.923,0.95591,1.8976,4.3011,8.0393,7.8464,15.733'/%3E %3Cpath fill='url(%23lg2)' d='m455.04,284.95c5.5546,14.65,8.6644,30.117-1.6413,32.907l-1.1766,0.23598c0.0472,0,51.903-3.4913,57.216-3.2735,8.5377-4.6843,7.7926-16.804,3.2073-29.943'/%3E %3Cpath fill='url(%23rg5)' d='m447.4,243.49c-3.705,0-4.6563,3.5621-4.6052,5.8172,0.13371,5.9085,4.6052,6.1921,4.6052,6.1921l5.9645-0.33233,2.8577-12.163-8.8222,0.48615z'/%3E %3Cpath fill='url(%23lg3)' d='m447.4,243.53,8.8222-0.48615,0.90762,9.0857-7.696,0.33757c0,0.00022,2.4913-7.2746-2.0338-8.9371z'/%3E %3Cpath fill='url(%23lg4)' d='m496.12,253.29c6.6855-1.0741,6.5946-10.069,2.0257-13.673-15.498-0.56939-35.895-0.14311-50.63,0.95941,1.6761-0.0483,6.3372,0.37625,6.8557,6.5111,0.24187,2.8625-1.1654,5.4912-3.0609,6.9859-1.8533,1.4615-3.906,1.4615-3.906,1.4615,0.24799,0.0955,2.1622,0.007,3.5984-0.0867,0.73895-0.0485,2.5518-0.26438,3.0554-0.33058,21.012-2.7616,41.987-1.8229,41.987-1.8229l0.0797,0.003c-0.002-0.003-0.003-0.005-0.005-0.008z'/%3E %3Cg fill='%23b07e09' stroke='none'%3E %3Cpath d='m458.47,267.42c-0.14307-0.33143-0.32344-0.74904-0.72915-0.80525-0.24955,0.0146-0.64602-0.0516-0.56795-0.39173,0.23471-0.11275,0.53358-0.0411,0.79388-0.0653,0.5617,0.01,1.1134-0.1139,1.6713-0.14811,0.33714,0.0924,0.26114,0.53754-0.1051,0.46371-0.40765,0.0923-0.17515,0.56277-0.075,0.80926,0.44356,1.0343,0.87222,2.0753,1.3282,3.1041,0.12646,0.30356,0.38018,0.57176,0.72219,0.60554,0.36132,0.0353,0.75556,0.0449,1.0901-0.1161,0.31087-0.19947,0.24167-0.62374,0.20014-0.93675-0.1251-0.36343,0.53948-0.28153,0.4942,0.0441,0.12951,0.42948,0.27963,0.85338,0.4476,1.2683-0.0221,0.20027-0.27563,0.14416-0.42122,0.1692-0.99242,0.0761-1.9867,0.13132-2.9778,0.22273-0.31888-0.0172-0.79628,0.28094-0.9909-0.0956-0.11854-0.38638,0.51127-0.1693,0.59555-0.46271-0.003-0.32725-0.19548-0.6154-0.30674-0.91676-0.38977-0.91578-0.7797-1.8351-1.1694-2.7487z'/%3E %3Cpath d='m463.3,267.08c-0.1404-0.31992-0.302-0.71957-0.68686-0.79561-0.24688-0.0227-0.65282-0.0174-0.61569-0.37437,0.15627-0.16169,0.45617-0.0582,0.67049-0.0921,0.59111,0.0192,1.1738-0.0896,1.7598-0.1438,0.2904-0.0276,0.3982,0.51827,0.0255,0.44396-0.35822,0.0116-0.3836,0.40448-0.23349,0.65107,0.47033,1.1419,0.95892,2.2765,1.4375,3.415,0.10488,0.24466,0.24008,0.54794,0.54004,0.58586,0.2521,0.0492,0.64789-0.0288,0.70423,0.31605-0.0398,0.26696-0.43337,0.11891-0.62879,0.16072-0.52229-0.0363-1.0425,0.0314-1.5563,0.11861-0.22635,0.0642-0.5502,0.0273-0.55928-0.26976,0.0528-0.27221,0.58365-0.0683,0.60981-0.40128-0.0398-0.3261-0.21556-0.61575-0.3303-0.92008-0.37873-0.89791-0.75873-1.7974-1.1367-2.6943z'/%3E %3Cpath d='m467.76,267.79c0.0905,0.22743,0.40406,0.0636,0.58583,0.0752,0.26329-0.0255,0.54341-0.21507,0.51879-0.50891-0.0427-0.4512-0.26334-0.90844-0.63162-1.1828-0.34103-0.23966-0.7793-0.21343-1.172-0.1626-0.0226,0.15488,0.0979,0.30397,0.14476,0.45347,0.18473,0.44188,0.36966,0.8837,0.55426,1.3256zm0.6684,1.5962c0.16337,0.34893,0.27899,0.74478,0.56455,1.0172,0.24365,0.17131,0.5689,0.093,0.84351,0.0652,0.30167-0.0202,0.47917-0.33066,0.3856-0.60827-0.14179-0.6355-0.55438-1.3008-1.2378-1.4371-0.30016-0.0516-0.61793-0.0654-0.91565-0.001-0.0232,0.14403,0.0918,0.28859,0.13557,0.42942,0.0747,0.17817,0.1496,0.35716,0.22424,0.53482zm-2.0348-2.3717c-0.15771-0.34702-0.30945-0.76722-0.68808-0.92519-0.24435-0.0813-0.64253,0.0301-0.69582-0.32286,0.065-0.30322,0.56261-0.0904,0.80178-0.15976,0.86327-0.0225,1.7427-0.26404,2.5932-0.004,0.73402,0.18212,1.3916,0.80958,1.4496,1.5869,0.0243,0.3773-0.26107,0.6843-0.58138,0.83788-0.0394-0.13577,0.3671,0.0609,0.50625,0.082,0.58325,0.18645,1.1192,0.57568,1.3783,1.1433,0.20099,0.39775,0.35617,0.931,0.0394,1.3146-0.36178,0.39514-0.93916,0.41299-1.4376,0.43714-0.75022,0.0198-1.5053,0.0256-2.2443,0.17278-0.26712,0.0465-0.45804-0.48213-0.0897-0.44892,0.37045-0.0136,0.40329-0.41383,0.2441-0.66837-0.42527-1.0153-0.85054-2.0307-1.2758-3.0459z'/%3E %3Cpath d='m473.81,265.11c0.32718-0.0544,0.35831,0.3161,0.45793,0.53166,0.0983,0.28394,0.27637,0.54219,0.34849,0.83144-0.27729,0.27636-0.5018-0.14465-0.62456-0.3594-0.1439-0.24731-0.3827-0.47568-0.69009-0.45095-0.40636-0.002-0.81669,0.0145-1.2186,0.0722-0.14455,0.15755,0.0652,0.39285,0.11247,0.57653,0.1894,0.44547,0.36011,0.9006,0.56164,1.3398,0.27062-0.0225,0.61991,0.0146,0.81331-0.20808,0.0751-0.22898-0.26998-0.74689,0.20987-0.64006,0.29748,0.1698,0.26318,0.6021,0.41591,0.88216,0.12636,0.38776,0.38401,0.72392,0.49191,1.1148-0.26291,0.28875-0.52448-0.12967-0.61934-0.3631-0.18831-0.34686-0.62469-0.30588-0.95946-0.2961-0.24094-0.0507-0.0753,0.17151-0.041,0.28277,0.21575,0.49335,0.38321,1.0111,0.65934,1.4753,0.20678,0.34329,0.65054,0.29169,0.99357,0.28011,0.3281-0.0177,0.73213-0.0248,0.92609-0.33842,0.21559-0.25167-0.27414-0.75134,0.13115-0.83062,0.34698-0.0306,0.33749,0.37589,0.42927,0.60648,0.0734,0.28174,0.18493,0.55171,0.28456,0.82364-0.0264,0.19879-0.27783,0.14023-0.42383,0.16319-1.0195,0.065-2.0406,0.10828-3.0588,0.19006-0.30025,0.001-0.80525,0.23909-0.90167-0.19822,0.0262-0.2876,0.64599-0.13478,0.55396-0.54392-0.0732-0.34705-0.24884-0.66262-0.37267-0.99381-0.37616-0.89638-0.73147-1.8019-1.1229-2.6916-0.14057-0.2963-0.36799-0.61968-0.73047-0.62841-0.23799,0.0464-0.60085-0.12899-0.46164-0.40696,0.34613-0.067,0.71114-0.0198,1.0641-0.0569,0.92382-0.0545,1.8476-0.10915,2.7714-0.16357z'/%3E %3Cpath d='m476.12,266.43c-0.15374-0.34845-0.30185-0.76874-0.67875-0.92975-0.25693-0.0765-0.72611,0.0133-0.69679-0.39387,0.24605-0.18988,0.65923-0.0315,0.96836-0.0898,0.80068-0.0109,1.6199-0.23795,2.4073,0.00027,0.82463,0.22961,1.5151,0.97195,1.5727,1.8413,0.0267,0.41568-0.30657,0.75244-0.6847,0.86344-0.29656,0.0153,0.22879,0.10055,0.30962,0.19647,0.63275,0.30389,1.0688,0.87693,1.406,1.4737,0.0757,0.22539,0.51881,0.69649,0.58657,0.24657-0.0269-0.49,0.6373-0.075,0.48723,0.26344,0.002,0.35658-0.35128,0.58745-0.68118,0.58286-0.46451,0.0366-0.90432-0.23136-1.138-0.62365-0.42141-0.55349-0.70862-1.2243-1.2649-1.6634-0.23114-0.16553-0.55903-0.26894-0.82981-0.15171-0.0582,0.1395,0.0681,0.28041,0.10427,0.41651,0.17986,0.40844,0.30537,0.84509,0.547,1.2225,0.2006,0.30876,0.59311,0.35831,0.9303,0.35601,0.3598,0.0889,0.25929,0.57544-0.12356,0.43251-0.58509-0.001-1.1749-0.0442-1.7528,0.0764-0.26879,0.12586-0.86512,0.0102-0.64932-0.37044,0.283-0.0161,0.6752-0.17232,0.47996-0.52437-0.33128-0.87221-0.69856-1.7309-1.0447-2.5975-0.0849-0.20914-0.17-0.41822-0.25479-0.62739zm1.404,0.89347c0.13446,0.32598,0.59518,0.14488,0.86133,0.11358,0.35755-0.0786,0.34757-0.50799,0.23351-0.77734-0.16266-0.46877-0.37331-1.0295-0.89017-1.1951-0.26165-0.035-0.84451-0.20185-0.88465,0.15199,0.18883,0.53496,0.42263,1.0546,0.62982,1.5834,0.0167,0.0411,0.0334,0.0825,0.0502,0.12348z'/%3E %3Cpath d='m484.74,269.04c0.10917,0.25915,0.21273,0.60969,0.53838,0.65626,0.25495,0.0587,0.66431-0.0241,0.71644,0.32963-0.0491,0.26525-0.43911,0.10496-0.63631,0.14317-0.53793-0.0503-1.0754,0.0123-1.608,0.0839-0.23088,0.0709-0.5509-0.0297-0.51807-0.31944,0.12458-0.20956,0.64721-0.0374,0.61945-0.40227-0.0857-0.39995-0.27577-0.76838-0.41598-1.1514-0.38316-0.96139-0.76234-1.9244-1.148-2.8848-0.0945-0.30484-0.44335-0.29727-0.7022-0.2799-0.27334,0.002-0.68302,0.0613-0.68325,0.41585-0.0873,0.2297,0.21725,0.61574-0.0444,0.7351-0.3013,0.0636-0.36166-0.27486-0.42591-0.48749-0.0983-0.32057-0.26015-0.61799-0.38487-0.92568,0.0357-0.21414,0.3206-0.17639,0.49259-0.19361,1.3772-0.0572,2.7542-0.12015,4.1314-0.17371,0.30284-0.047,0.50224,0.19156,0.51743,0.47691,0.10822,0.33686,0.26985,0.65337,0.41381,0.97461-0.11306,0.33043-0.50781,0.0472-0.55333-0.19565-0.19914-0.34881-0.50948-0.69255-0.9391-0.71063-0.25705,0.0125-0.64239-0.0856-0.8153,0.14506,0.007,0.23983,0.14513,0.45279,0.21975,0.67783,0.4084,1.0285,0.81753,2.0591,1.2255,3.0862z'/%3E %3Cpath d='m488.47,268.13c-0.1915,0.001-0.0974,0.242-0.11817,0.36667,0.0118,0.28256-0.017,0.56914,0.0297,0.84837,0.13231,0.3102,0.52709,0.2343,0.78488,0.31822,0.22981,0.13123,0.17292,0.50149-0.13592,0.38771-0.42261-0.0259-0.85122-0.0688-1.2678,0.0331-0.24848,0.1327-0.71306-0.12286-0.49305-0.39157,0.2016-0.0347,0.44875-0.10136,0.49484-0.33467,0.0718-0.41378,0.0335-0.83739,0.0472-1.2559,0.007-1.238,0.015-2.476,0.0225-3.714,0.11955-0.27851,0.51386-0.0443,0.60235,0.16635,1.1921,1.516,2.3695,3.0443,3.5933,4.5348,0.19176,0.23288,0.46186,0.40029,0.76809,0.4178,0.25954,0.002,0.40172,0.53161,0.0275,0.42657-0.51126-0.0289-1.0269-0.0629-1.5353,0.0229-0.22818,0.006-0.49228,0.11148-0.69618-0.022-0.24312-0.17858-0.0701-0.43576,0.19588-0.40343,0.35203-0.10003-0.005-0.47695-0.11676-0.65245-0.1898-0.25561-0.37883-0.5135-0.58929-0.75233-0.17041-0.0841-0.37343-0.0217-0.55849-0.0313-0.35132,0.012-0.70591,0.022-1.0552,0.0352zm1.1732-0.51153c0.18229,0.0111-0.0571-0.15544-0.0868-0.23536-0.42445-0.55445-0.84889-1.1089-1.2733-1.6633,0.0839-0.0129,0.0172,0.17549,0.0386,0.25552-0.002,0.5612,0.004,1.1226-0.002,1.6837,0.44105-0.0106,0.88396-0.0264,1.3238-0.0405z'/%3E %3Cpath d='m492.7,265.77c-0.14936-0.39834-0.34992-0.88654-0.81752-0.98102-0.24305,0.0438-0.70218-0.17699-0.45279-0.43884,0.55052-0.008,1.1029,0.0301,1.6534-0.0168,0.69784-0.0604,1.416-0.0428,2.0797,0.20455,1.4601,0.49242,2.672,1.7777,2.9142,3.3212,0.10741,0.60447-0.0788,1.3034-0.62503,1.6411-0.73524,0.46702-1.6421,0.38035-2.4704,0.33336-0.46991-0.0221-0.93798,0.0398-1.4038,0.086-0.30403-0.0415-0.3372-0.51217,0.0233-0.45643,0.37223-0.0121,0.36467-0.42242,0.22829-0.66787-0.37645-1.008-0.75316-2.0193-1.1294-3.0252zm1.97,2.4936c0.14884,0.34026,0.23924,0.75541,0.56296,0.97636,0.30214,0.14269,0.6575,0.11564,0.98151,0.0803,0.43944-0.0594,0.71224-0.49285,0.71647-0.91173,0.0269-0.75326-0.28171-1.4733-0.63171-2.1243-0.37441-0.7006-1.0557-1.2335-1.8441-1.3722-0.32451-0.0534-0.66476-0.10312-0.99053-0.0491-0.0707,0.123,0.059,0.27181,0.0864,0.40147,0.373,0.99972,0.74599,1.9994,1.119,2.9991z'/%3E %3Cpath d='m473.56,280.68c0.11606,0.34963,0.43958,0.60007,0.80483,0.63405,0.25677,0.0452,0.69924-0.0156,0.7128,0.35386-0.13761,0.2344-0.52951,0.0712-0.76858,0.1225-0.51864-0.009-1.0376,0.008-1.5504,0.0922-0.27697,0.0118-0.56691,0.12559-0.8373,0.0485-0.24472-0.11624-0.19392-0.47039,0.10657-0.42647,0.24725-0.0579,0.60421-0.13495,0.622-0.44863-0.023-0.28469-0.18161-0.53458-0.27762-0.79946-0.38512-0.91649-0.76056-1.8372-1.1519-2.751-0.0861-0.32419-0.44627-0.33313-0.71537-0.28394-0.24766,0.0472-0.61627,0.1239-0.67679-0.21966,0.0302-0.29194,0.49713-0.23832,0.70232-0.38999,0.31181-0.12117,0.61996-0.25633,0.93884-0.35646,0.2159-0.0466,0.32497,0.1506,0.37916,0.32165,0.57039,1.3671,1.1415,2.7383,1.7114,4.1028z'/%3E %3Cpath d='m474.31,276.17c0.68157-0.0264,1.3667,0.0766,2.0461,0.002,0.30072-0.0289,0.0947-0.49726,0.38365-0.47016,0.37142,0.0171,0.31167,0.47765,0.33508,0.73916,0.0422,0.33127-0.23741,0.62475-0.56978,0.58312-0.53305,0.0289-1.0648-0.0493-1.598-0.0213,0.12116,0.41264,0.28802,0.80975,0.44482,1.2092,0.0275-0.13437,0.46005-0.15534,0.63873-0.1809,1.0643-0.0467,2.1676,0.56093,2.6138,1.5434,0.21451,0.47701,0.32727,1.1006-0.0285,1.5406-0.38664,0.45626-1.0303,0.54904-1.5958,0.55416-0.48924-0.006-1.0641-0.11235-1.353-0.5493-0.16678-0.21528-0.13828-0.68045,0.22108-0.64108,0.30463,0.004,0.65887,0.26426,0.60927,0.59572,0.16287,0.22213,0.52468,0.14404,0.77532,0.13986,0.29921-0.0105,0.58436-0.24171,0.56922-0.55843,0.007-0.48591-0.18499-0.96182-0.45431-1.3595-0.29162-0.42264-0.78266-0.70723-1.3024-0.69596-0.29377-0.0494-0.5476,0.1472-0.82727,0.14669-0.28405-0.0376-0.33434-0.36628-0.43468-0.58118-0.2377-0.59776-0.46117-1.2018-0.64986-1.817-0.0191-0.10564,0.0752-0.19163,0.17659-0.17909z'/%3E %3Cpath d='m481.16,277.19c-0.16047-0.39514-0.37046-0.88248-0.8414-0.96765-0.24185,0.0565-0.70339-0.16996-0.46203-0.42988,0.55717-0.022,1.1176-0.001,1.6734-0.0676,0.70408-0.0848,1.4324-0.0708,2.1052,0.17584,1.486,0.49365,2.7091,1.8179,2.9341,3.3872,0.0887,0.58373-0.11406,1.2385-0.63224,1.5634-0.71804,0.46579-1.6078,0.39631-2.4238,0.37712-0.4528-0.005-0.90098,0.0699-1.3477,0.12798-0.30094-0.0344-0.35294-0.50358,0.008-0.4612,0.3732-0.0274,0.34313-0.44024,0.20295-0.68191-0.4054-1.0075-0.81109-2.0171-1.2163-3.0233zm2.0307,2.4609c0.15813,0.33874,0.25946,0.75312,0.58863,0.9696,0.30223,0.13593,0.65449,0.098,0.97409,0.0527,0.43943-0.0753,0.68696-0.52453,0.67805-0.94167,0.003-0.76061-0.32573-1.4787-0.69458-2.1277-0.38903-0.6907-1.0775-1.2137-1.869-1.3328-0.32242-0.044-0.66071-0.0842-0.98153-0.0206-0.0653,0.12618,0.068,0.27222,0.0991,0.40236,0.40169,0.99938,0.8037,1.9988,1.2052,2.9981z'/%3E %3Cpath d='m489.63,275.39c0.31178-0.0532,0.35285,0.29338,0.437,0.50448,0.10128,0.28312,0.24535,0.54906,0.3459,0.83193-0.1893,0.31085-0.50732-0.0573-0.58803-0.28325-0.14484-0.24762-0.35587-0.519-0.67346-0.51186-0.4115-0.0205-0.82498,0.002-1.2352,0.0343-0.22517,0.10065,0.0154,0.38945,0.0539,0.56683,0.18315,0.45139,0.34635,0.91271,0.54261,1.3576,0.26528-0.009,0.57328,0.0123,0.79839-0.15157,0.17488-0.21253-0.26822-0.73665,0.21199-0.68033,0.32664,0.11904,0.27678,0.56859,0.41544,0.83786,0.12466,0.39688,0.35587,0.74837,0.4908,1.1405-0.17513,0.33071-0.54337-0.0556-0.59294-0.30249-0.14146-0.32034-0.52112-0.36204-0.82832-0.35078-0.20477-0.0355-0.37006,0.0103-0.22596,0.21599,0.21474,0.51544,0.37925,1.0551,0.65528,1.5422,0.20328,0.34681,0.64962,0.30164,0.9943,0.29753,0.33009-0.0121,0.73597-0.008,0.93997-0.31739,0.20676-0.24272-0.19639-0.65729,0.0819-0.81092,0.33772-0.0958,0.41613,0.27773,0.46617,0.5222,0.0755,0.30705,0.18428,0.60483,0.28994,0.90134-0.0315,0.19742-0.28035,0.13291-0.42657,0.15311-1.0295,0.0442-2.0601,0.0672-3.0888,0.12727-0.28711-0.0192-0.69076,0.20649-0.86993-0.11391-0.18386-0.39605,0.50285-0.17964,0.5304-0.52494,0.0206-0.30461-0.15923-0.57313-0.25097-0.8547-0.38399-0.9655-0.75106-1.938-1.1469-2.8986-0.13617-0.31314-0.36116-0.66186-0.74051-0.67914-0.23682,0.0409-0.60259-0.13649-0.45593-0.41257,0.35614-0.0589,0.72799-0.005,1.0901-0.0347,0.92646-0.0354,1.8533-0.0702,2.7795-0.10605z'/%3E %3Cpath d='m462.35,289.67c0.14889,0.48692,0.66813,0.68606,1.1115,0.81754,0.76953,0.26088,1.5999,0.5188,2.1474,1.158,0.30658,0.3717,0.51888,0.85427,0.49645,1.3425-0.0396,0.49631-0.46485,0.86901-0.92484,0.99075-0.5659,0.18399-1.1912,0.1355-1.735-0.0972-0.26579-0.1147-0.16456,0.46707-0.49617,0.27047-0.23849-0.18227-0.16339-0.5597-0.29566-0.81493-0.10452-0.33044-0.24388-0.64843-0.38522-0.96389,0.0122-0.3258,0.47952-0.15603,0.49529,0.0975,0.32751,0.59399,0.92384,1.12,1.6332,1.1256,0.35806,0.011,0.80671-0.17966,0.83786-0.58366,0.007-0.53472-0.41913-0.95354-0.86493-1.1829-0.63918-0.33173-1.3753-0.43717-1.9939-0.81201-0.55467-0.33412-0.94649-0.95389-0.9475-1.6079,0.0124-0.43668,0.36971-0.77784,0.7672-0.90267,0.50247-0.17158,1.0552-0.20067,1.5676-0.0533,0.23849,0.12524,0.34031-0.27354,0.59498-0.0757,0.11428,0.19555,0.0847,0.46072,0.19379,0.67176,0.0806,0.28622,0.27144,0.5368,0.33396,0.82495-0.15855,0.24419-0.46565,0.0144-0.51716-0.20276-0.22085-0.36611-0.51648-0.77262-0.98273-0.80483-0.34605-0.0265-0.7856-0.0294-1.0066,0.28776-0.0965,0.1537-0.0917,0.34996-0.0294,0.51496z'/%3E %3Cpath d='m469.04,288.02c0.32657-0.0589,0.33649,0.314,0.41808,0.52848,0.0813,0.27158,0.20932,0.52697,0.28887,0.79855-0.13999,0.28678-0.49293,0.0246-0.53577-0.21096-0.13686-0.26048-0.33786-0.57167-0.67348-0.55212-0.4093-0.007-0.81908,0.0304-1.2254,0.0755-0.22745,0.10072-0.007,0.39086,0.0247,0.5716,0.15781,0.4505,0.29564,0.90987,0.46654,1.3546,0.2675-0.0184,0.57594-0.01,0.79916-0.17995,0.1955-0.20067-0.19249-0.60425,0.13885-0.69572,0.37391-0.0471,0.34474,0.44123,0.43459,0.68421,0.0967,0.44975,0.33494,0.84931,0.46752,1.2862-0.14491,0.31671-0.5323,0.01-0.55108-0.24764-0.11183-0.32857-0.48297-0.39833-0.78805-0.36789-0.17891-0.0113-0.42194-0.0128-0.2756,0.21065,0.181,0.50461,0.3186,1.0269,0.54996,1.5117,0.12108,0.28359,0.45097,0.34613,0.72676,0.32248,0.39263-0.0271,0.84683,0.0151,1.1533-0.28135,0.24544-0.23384,0.0408-0.58484,0.095-0.85328,0.24945-0.19893,0.52577,0.068,0.49972,0.34236,0.0692,0.34542,0.16129,0.68631,0.26731,1.0211-0.0418,0.20112-0.29151,0.14397-0.4453,0.16981-1.0176,0.0778-2.0371,0.13304-3.0531,0.22801-0.28026-0.0136-0.68355,0.23497-0.85527-0.0871-0.15839-0.38323,0.45714-0.20653,0.53743-0.50154,0.081-0.295-0.0978-0.57443-0.17249-0.85371-0.33603-0.9796-0.65391-1.9657-1.0027-2.9407-0.11595-0.30747-0.32641-0.66035-0.69818-0.66291-0.23795,0.0555-0.59246-0.13222-0.42986-0.40217,0.3458-0.072,0.71148-0.0279,1.0643-0.0703,0.92469-0.066,1.8496-0.13171,2.7742-0.19787z'/%3E %3Cpath d='m473.22,292.16c0.091,0.30434,0.2697,0.63825,0.61206,0.6999,0.24923,0.0888,0.66447-0.0731,0.73162,0.28619-0.0121,0.32758-0.49229,0.14975-0.71215,0.20375-0.50985-0.0271-1.0209,0.008-1.5222,0.10462-0.21782,0.0315-0.54463,0.10754-0.60795-0.18878-0.0545-0.33567,0.4631-0.14679,0.57268-0.39914,0.0804-0.25911-0.0661-0.51646-0.13591-0.76453-0.33739-1.0049-0.66303-2.0138-1.0085-3.0159-0.11428-0.29175-0.27006-0.67408-0.62939-0.70776-0.23232-0.0105-0.6288-0.0315-0.55781-0.36759,0.1746-0.16557,0.48564-0.0523,0.71242-0.0825,0.73096,0.0161,1.4495-0.19235,2.1804-0.144,0.75108,0.0285,1.4823,0.50765,1.7354,1.2278,0.1648,0.40531,0.21971,0.91647-0.0793,1.2755-0.38705,0.45469-1.0216,0.5475-1.5803,0.62208-0.21194-0.0276-0.04,0.19166-0.0267,0.30158,0.10509,0.31628,0.21129,0.63246,0.31569,0.94881zm-0.57141-1.7202c0.2055,0.0293,0.46107-0.0251,0.67612-0.0833,0.31359-0.0633,0.47812-0.39914,0.39601-0.69578-0.0877-0.42243-0.22807-0.86517-0.54377-1.1743-0.30389-0.25301-0.74642-0.26101-1.112-0.16344-0.13967,0.12196,0.002,0.31915,0.0355,0.46985,0.18281,0.54879,0.36475,1.0991,0.5481,1.647z'/%3E %3Cpath d='m478.8,291.87c0.0897,0.25498,0.17001,0.61087,0.49187,0.65157,0.24649,0.0547,0.66053-0.036,0.69072,0.32033-0.0607,0.26474-0.44121,0.11529-0.64317,0.1555-0.53863-0.0414-1.0748,0.0309-1.6059,0.11158-0.22567,0.0776-0.54836-0.0218-0.49373-0.31187,0.13752-0.21281,0.64999-0.0496,0.64426-0.4153-0.0549-0.39043-0.21769-0.75577-0.3292-1.1326-0.31766-0.96675-0.63085-1.935-0.95132-2.9008-0.0762-0.30964-0.42906-0.29003-0.67893-0.26934-0.25453,0.019-0.62035,0.0473-0.69252,0.35027-0.0828,0.25442,0.0399,0.53291-0.0153,0.7784-0.23703,0.16264-0.46687-0.089-0.45654-0.33006-0.0829-0.34413-0.20809-0.6764-0.34461-1.0016-0.009-0.23925,0.30469-0.21863,0.47906-0.23639,1.3809-0.0816,2.7616-0.17001,4.1427-0.24727,0.30058-0.0552,0.49009,0.18787,0.48207,0.47102,0.0834,0.33503,0.22364,0.65237,0.3452,0.97347-0.0677,0.28279-0.4853,0.13043-0.50147-0.11884-0.17371-0.35344-0.44476-0.73357-0.87382-0.76235-0.28084-0.005-0.62542-0.0571-0.85908,0.1244-0.0529,0.20577,0.0778,0.40251,0.12516,0.59989,0.3483,1.0632,0.69586,2.1274,1.0446,3.19z'/%3E %3Cpath d='m480.9,288.58c-0.10511-0.30537-0.21974-0.69305-0.57144-0.78928-0.23567-0.0608-0.64922,0.009-0.62597-0.35547,0.0961-0.2119,0.41704-0.0804,0.60887-0.11995,0.59887,0.0268,1.1927-0.0588,1.7867-0.11794,0.26641-0.12052,0.47853,0.42109,0.15225,0.42081-0.25499-0.002-0.54577,0.18766-0.44215,0.47338,0.13157,0.53152,0.32425,1.0457,0.48566,1.5688,0.24059,0.73278,0.46742,1.4703,0.71758,2.1998,0.0665,0.22873,0.24776,0.43142,0.49851,0.44095,0.24128,0.001,0.66349,0.0343,0.58769,0.37901-0.1803,0.1561-0.47927,0.0579-0.70826,0.0802-0.53844-0.0442-1.0723,0.0478-1.6044,0.11402-0.23234,0.0989-0.53601-0.13911-0.39232-0.37822,0.20623-0.0973,0.64726-0.043,0.61705-0.38405-0.0778-0.41061-0.23705-0.80053-0.35686-1.2003-0.25102-0.77713-0.50179-1.555-0.75297-2.3317z'/%3E %3Cpath d='m486.66,286.98c0.31717-0.0569,0.33321,0.30467,0.40399,0.51705,0.0781,0.27686,0.20196,0.53879,0.27922,0.81529-0.14497,0.28325-0.49455,0.0177-0.53358-0.21905-0.13249-0.26332-0.32917-0.57588-0.66559-0.56223-0.41104-0.014-0.82341,0.0142-1.2324,0.0527-0.23041,0.0941-0.0151,0.38839,0.0135,0.56872,0.14972,0.4516,0.28011,0.91144,0.44239,1.3577,0.26893-0.0116,0.57851,0.002,0.80688-0.163,0.20002-0.19577-0.18048-0.60674,0.15397-0.68977,0.3753-0.0418,0.33671,0.44565,0.4235,0.6897,0.0859,0.45005,0.32007,0.85096,0.44274,1.2887-0.11466,0.28936-0.52699,0.0423-0.52805-0.21334-0.095-0.31925-0.42841-0.45271-0.73858-0.42294-0.1459,0.017-0.50285-0.0743-0.35829,0.1705,0.17515,0.51627,0.30659,1.0495,0.53275,1.5467,0.11732,0.28608,0.44757,0.35292,0.72429,0.33446,0.39424-0.0213,0.85017,0.0326,1.164-0.2582,0.2504-0.22688,0.0537-0.58104,0.11246-0.84692,0.2531-0.19218,0.52629,0.0749,0.4951,0.35,0.0621,0.345,0.1479,0.68566,0.24775,1.0205-0.0412,0.19413-0.28099,0.13883-0.42978,0.15928-1.0307,0.0587-2.063,0.0955-3.0926,0.1711-0.27507-0.0176-0.64413,0.20276-0.83815-0.0655-0.21721-0.38819,0.37975-0.2524,0.50742-0.48641,0.13455-0.26611-0.0422-0.5471-0.10792-0.80986-0.32143-0.99485-0.6289-1.9944-0.95988-2.986-0.11127-0.3225-0.31496-0.70295-0.7037-0.71373-0.23837,0.0517-0.59267-0.14098-0.42458-0.40838,0.34344-0.0639,0.70388-0.0156,1.0537-0.0492,0.93604-0.0492,1.8754-0.0989,2.8094-0.14777z'/%3E %3Cpath d='m488.66,287.94c-0.0657-0.35753-0.33894-0.67675-0.73368-0.62169-0.37451,0.0966-0.49968-0.57125-0.0338-0.43032,0.50848,0.003,1.0301-0.0779,1.5292,0.0357,0.24359,0.26365,0.43909,0.576,0.66317,0.85939,0.72332,0.96789,1.4466,1.9358,2.17,2.9037-0.15869,0.0356-0.0357-0.18539-0.0528-0.30101,0.11819-1.1806,0.23638-2.3613,0.35457-3.5419,0.27347-0.22599,0.73028-0.13101,1.0778-0.20207,0.28161-0.0423,0.92456-0.13543,0.745,0.34872-0.33791,0.0556-0.77046,0.22133-0.53651,0.64662,0.35919,1.1968,0.73766,2.388,1.1146,3.5793,0.0684,0.41823,0.48925,0.54588,0.85784,0.52738,0.31687,0.0176,0.33222,0.56251-0.0483,0.43054-0.59356-0.0131-1.1911-0.049-1.7788,0.0635-0.26548,0.0904-0.82078,0.0613-0.64053-0.35521,0.2974-0.0534,0.79403-0.14241,0.58654-0.57225-0.31695-1.0602-0.65767-2.1134-0.98417-3.1707,0.0684,0.095-0.0116,0.25498-0.004,0.37763-0.0959,0.98935-0.22807,1.9758-0.29215,2.9677-0.0395,0.26019,0.0492,0.57372-0.0735,0.79806-0.23587,0.11618-0.38592-0.11309-0.50374-0.27632-0.95195-1.2325-1.9039-2.465-2.8558-3.6975,0.0969-0.0356,0.0852,0.20949,0.13956,0.29186,0.3062,0.95953,0.58871,1.9272,0.91128,2.8811,0.10061,0.3878,0.4941,0.50099,0.84781,0.50431,0.37869,0.19377,0.0985,0.54795-0.23164,0.40323-0.50034-0.0717-0.99765,0.0282-1.4927,0.0846-0.31467-0.009-0.33014-0.51374,0.0285-0.44736,0.46931,0.004,0.32648-0.52269,0.21748-0.80097-0.3411-1.0914-0.68219-2.1828-1.0233-3.2742,0.0141-0.004,0.0283-0.008,0.0424-0.0118z'/%3E %3Cpath d='m497.4,288.79c0.0593,0.22476,0.36397,0.0736,0.52636,0.0972,0.28524-0.0165,0.61957-0.17486,0.63537-0.4985,0.0105-0.43614-0.15685-0.90446-0.49909-1.188-0.33014-0.25253-0.7692-0.22938-1.1607-0.19218-0.0424,0.14588,0.0624,0.3026,0.0924,0.45097,0.13509,0.44347,0.27115,0.88718,0.40563,1.3305zm0.48727,1.5984c0.1243,0.34789,0.19268,0.74271,0.45051,1.0221,0.23769,0.17962,0.56719,0.10432,0.84205,0.087,0.25743-0.0181,0.48711-0.22901,0.46145-0.49857-0.0314-0.59699-0.31608-1.2607-0.90721-1.4938-0.34005-0.12467-0.71258-0.12688-1.0689-0.0911-0.11162,0.0967,0.0379,0.28888,0.0537,0.42193,0.0561,0.18406,0.11246,0.36888,0.16841,0.55248zm-1.7731-2.4024c-0.11732-0.34452-0.22409-0.76964-0.58576-0.93399-0.23304-0.0884-0.64285,0.0181-0.66332-0.33802,0.0833-0.28874,0.54417-0.0786,0.77388-0.13791,0.88678,0.011,1.7946-0.22455,2.6611,0.0631,0.69317,0.18493,1.2838,0.81885,1.2791,1.5575-0.003,0.40874-0.3333,0.71678-0.6865,0.86554-0.0233-0.13426,0.361,0.07,0.49973,0.0951,0.52848,0.18831,1.0182,0.55649,1.225,1.0936,0.17741,0.4142,0.27983,0.9529-0.0379,1.328-0.36163,0.40228-0.94951,0.43124-1.454,0.44425-0.79021,0.003-1.5851-0.0181-2.3676,0.11407-0.28387,0.0354-0.39564-0.50222-0.0385-0.44706,0.35957-0.001,0.45947-0.37887,0.32266-0.65627-0.30878-1.0152-0.62145-2.0365-0.9278-3.0479z'/%3E %3Cpath d='m501.12,287.81c-0.11404-0.34551-0.21756-0.77042-0.57837-0.93689-0.23778-0.0893-0.68709,0.0123-0.6651-0.37022,0.1937-0.25554,0.6567-0.0412,0.95446-0.10429,0.67824,0.005,1.3575-0.13005,2.0341-0.0445,0.79087,0.0929,1.5491,0.64555,1.7414,1.4413,0.14245,0.42071,0.0486,0.95351-0.35953,1.1906-0.0865,0.0956-0.51977,0.19808-0.44425,0.19026,0.60412,0.23923,1.1193,0.69009,1.4122,1.2729,0.15965,0.26189,0.2415,0.58058,0.46616,0.7966,0.2655,0.19822,0.29658-0.1638,0.34165-0.32636,0.3514-0.17469,0.5287,0.31622,0.386,0.58035-0.14669,0.42164-0.67828,0.50437-1.06,0.40458-0.34269-0.0777-0.60222-0.34-0.75643-0.6456-0.34142-0.53715-0.55388-1.1701-1.0298-1.6109-0.2241-0.19542-0.56642-0.30903-0.85076-0.19697-0.0741,0.13476,0.0394,0.28906,0.0626,0.42985,0.12706,0.39123,0.20766,0.80039,0.38614,1.1723,0.15783,0.32729,0.5426,0.40775,0.87264,0.40953,0.3218-0.008,0.34475,0.55927-0.032,0.42881-0.61-0.003-1.224-0.0761-1.8297,0.0331-0.22134-0.005-0.5324,0.13592-0.67395-0.10107-0.21466-0.41912,0.41715-0.22783,0.55717-0.46773,0.0897-0.27847-0.0644-0.55997-0.12956-0.83138-0.26816-0.90409-0.53726-1.8139-0.80484-2.7144zm1.3126,0.91741c0.0983,0.32687,0.55572,0.14918,0.80494,0.14415,0.29054-0.0294,0.45975-0.32567,0.39805-0.59836-0.075-0.44854-0.19181-0.94321-0.54745-1.2556-0.30615-0.22447-0.72127-0.2232-1.0797-0.16157-0.1535,0.12803-0.0127,0.3413,0.0189,0.50327,0.13493,0.45593,0.27113,0.91278,0.40527,1.3681z'/%3E %3Cpath d='m509.32,286.19c0.31224-0.0488,0.32571,0.29784,0.38442,0.50986,0.0709,0.28206,0.18743,0.55093,0.25681,0.83269-0.13482,0.25829-0.48808,0.0312-0.51432-0.2046-0.12875-0.2599-0.29229-0.58898-0.62453-0.60507-0.42769-0.0352-0.85882-0.0179-1.2866,0.005-0.23408,0.0833-0.0305,0.38309-0.008,0.5622,0.13486,0.45258,0.24983,0.91319,0.39766,1.3605,0.25857,0.00033,0.53808,0.008,0.77834-0.10389,0.28143-0.15885-0.11061-0.58931,0.1868-0.70182,0.37332-0.0818,0.36884,0.39384,0.426,0.63885,0.068,0.46738,0.29585,0.8879,0.40974,1.3417-0.12441,0.28166-0.53048,0.028-0.52429-0.22846-0.0805-0.2955-0.37283-0.45338-0.66666-0.44026-0.14063,0.0268-0.55645-0.12009-0.43577,0.13659,0.16066,0.52292,0.27429,1.0625,0.48729,1.5675,0.11003,0.29024,0.44075,0.36352,0.71812,0.3554,0.3983-0.007,0.85477,0.0615,1.1832-0.2172,0.26034-0.21419,0.0738-0.57422,0.14373-0.83477,0.25814-0.18142,0.52699,0.087,0.4865,0.3627,0.0504,0.34399,0.12514,0.68435,0.21332,1.0195-0.053,0.19462-0.29552,0.12713-0.44878,0.14399-1.0382,0.0236-2.077,0.0258-3.1147,0.0658-0.26829-0.0246-0.60747,0.15841-0.81792-0.0558-0.26364-0.37823,0.29767-0.30441,0.47311-0.46745,0.1894-0.22034,0.0327-0.51217-0.0246-0.75657-0.29628-1.0238-0.57846-2.0518-0.88432-3.0728-0.10036-0.30857-0.27116-0.6801-0.6367-0.72204-0.23665,0.0117-0.6103-0.0938-0.48481-0.40469,0.30107-0.10493,0.65561-0.003,0.97706-0.0349,0.98244-0.0168,1.9704-0.0371,2.9494-0.0525z'/%3E %3Cpath d='m476.5,299.32c-0.0934-0.36829-0.21694-0.84959-0.6443-0.94876-0.23667,0.006-0.64397-0.0622-0.49975-0.39344,0.30684-0.12338,0.67358-0.0278,1.003-0.0757,0.81944-0.0426,1.6529-0.24547,2.465-0.0271,1.1924,0.27335,2.2307,1.1874,2.5821,2.3689,0.22609,0.73058,0.26116,1.602-0.23082,2.237-0.51874,0.66626-1.4103,0.85237-2.2124,0.86219-0.6166-0.006-1.2373-0.0111-1.8449,0.1133-0.23578,0.14216-0.62923-0.0921-0.42203-0.35446,0.25782-0.0745,0.66966-0.1498,0.59153-0.51787-0.0949-0.51357-0.24249-1.0168-0.3601-1.5259-0.14236-0.57881-0.28538-1.1622-0.42733-1.7381zm1.6413,2.4389c0.0991,0.32378,0.13668,0.70991,0.40472,0.94539,0.27474,0.16116,0.61568,0.0966,0.91779,0.0711,0.46892-0.0634,0.81472-0.47881,0.8889-0.93115,0.14121-0.75838-0.0791-1.5356-0.37855-2.2291-0.2592-0.60261-0.79874-1.0799-1.4469-1.2138-0.37709-0.0769-0.77868-0.11418-1.1574-0.0394-0.0844,0.11562,0.0226,0.27276,0.0359,0.40346,0.24516,0.99783,0.49037,1.9957,0.7355,2.9935z'/%3E %3Cpath d='m485.2,297.33c0.31751-0.0599,0.3103,0.30394,0.36154,0.51419,0.0564,0.27571,0.15977,0.53983,0.21483,0.81525-0.12851,0.26041-0.48747,0.0612-0.50141-0.18582-0.11291-0.2546-0.26765-0.58408-0.59289-0.58558-0.42598-0.0187-0.85316,0.0187-1.2768,0.0589-0.2345,0.0864-0.049,0.38539-0.0319,0.56853,0.1139,0.45184,0.20726,0.91087,0.3345,1.3581,0.27365-0.0154,0.58483-0.006,0.81844-0.17075,0.21328-0.18819-0.13012-0.61637,0.20804-0.69169,0.37629-0.0458,0.30263,0.44717,0.36776,0.68698,0.0505,0.44535,0.25212,0.85205,0.34087,1.2876-0.1201,0.28437-0.53015,0.0584-0.51079-0.2098-0.0687-0.3233-0.40261-0.45182-0.70361-0.41733-0.14571,0.0204-0.49528-0.0733-0.37278,0.17365,0.13438,0.51618,0.22207,1.0468,0.41064,1.5469,0.0962,0.29139,0.4297,0.34951,0.69682,0.32934,0.41639-0.0214,0.90481,0.0215,1.2204-0.30646,0.24471-0.22532,0.0177-0.60203,0.17019-0.83264,0.29085-0.16695,0.48367,0.14183,0.44323,0.40792,0.0325,0.33023,0.0931,0.65735,0.16165,0.9806-0.0589,0.19934-0.30534,0.14109-0.46594,0.16517-1.0253,0.0667-2.0522,0.11211-3.0763,0.19516-0.2567-0.009-0.55177,0.15352-0.7803,0.0117-0.2579-0.27125,0.0945-0.40864,0.32475-0.43973,0.28961-0.0955,0.26016-0.44281,0.18662-0.67677-0.26272-1.0796-0.51185-2.1627-0.78379-3.24-0.0831-0.30026-0.23842-0.67663-0.5989-0.70188-0.2364,0.0282-0.60358-0.0817-0.46308-0.38846,0.29574-0.11893,0.6518-0.0314,0.97047-0.0755,0.97561-0.0585,1.9542-0.11668,2.9278-0.17758z'/%3E %3Cpath d='m491.69,301.43c0.0446,0.30912,0.28477,0.57044,0.59589,0.62091,0.23667,0.0983,0.60539-0.0382,0.73338,0.24268,0.0925,0.35055-0.38792,0.23525-0.59032,0.2514-0.57299-0.01-1.148-0.0211-1.7165,0.066-0.28534,0.0184-0.57319,0.0958-0.85811,0.0647-0.27732-0.11669-0.15-0.50142,0.14665-0.44363,0.26817-0.0588,0.63011-0.12887,0.70639-0.44099,0.0331-0.26867-0.079-0.52694-0.12588-0.78863-0.2154-0.92095-0.42177-1.8442-0.64295-2.7637-0.0304-0.32556-0.38717-0.33441-0.63464-0.29444-0.2285,0.009-0.58736,0.16253-0.66028-0.16279-0.0359-0.33806,0.46553-0.2687,0.67085-0.4065,0.36855-0.12678,0.732-0.27248,1.1066-0.37935,0.21164-0.0481,0.30106,0.1503,0.31907,0.32049,0.31649,1.3713,0.63402,2.7426,0.94986,4.1138z'/%3E %3Cpath d='m495.38,298.11c-0.0726-0.36321-0.27901-0.7858-0.68883-0.83918-0.29181-0.0554-0.67132,0.0288-0.77688,0.34277-0.11265,0.37317,0.0381,0.80935,0.36877,1.0224,0.27207,0.19826,0.59182,0.31183,0.89418,0.4538,0.0592-0.11868,0.24697-0.34967,0.23698-0.55858,0.0137-0.14055-0.007-0.28821-0.0342-0.4212zm0.83637,2.8932c-0.10281-0.48732-0.5702-0.7696-0.99649-0.94842-0.1846-0.0322-0.44459-0.27742-0.55824-0.17656-0.30832,0.268-0.45707,0.71405-0.32031,1.1068,0.11379,0.48284,0.47947,0.96037,1.0057,1.0009,0.3479,0.0459,0.75979-0.11009,0.86327-0.47412,0.0535-0.16421,0.0442-0.34228,0.006-0.50864zm0.88943-0.20863c0.13592,0.47897-0.0601,1.0199-0.47068,1.3005-0.58142,0.40047-1.3554,0.42767-2.016,0.23143-0.58667-0.17203-1.0812-0.66342-1.185-1.2762-0.12189-0.48865,0.0785-1.0449,0.51326-1.3111,0.10093-0.10012,0.48787-0.14045,0.17512-0.21569-0.49885-0.24496-0.98962-0.64525-1.0924-1.2224-0.12081-0.48733,0.10613-1.0354,0.55173-1.2747,0.85828-0.46833,2.0876-0.192,2.5834,0.67512,0.21739,0.36862,0.25955,0.86121-0.001,1.2206-0.1401,0.19397-0.32105,0.38958-0.56398,0.44303,0.48542,0.099,0.92759,0.39815,1.2228,0.79362,0.13902,0.18823,0.2327,0.40754,0.28275,0.63563z'/%3E %3Cpath d='m500.37,301.35c0.24295,0.009,0.50439-0.13521,0.54094-0.39284,0.0851-0.19635-0.0838-0.61545,0.25474-0.59164,0.30868,0.0197,0.27738,0.37878,0.30899,0.60186,0.0259,0.39781-0.002,0.87237-0.34408,1.1374-0.24853,0.15789-0.55805,0.0922-0.83593,0.0963-0.56166-0.0186-1.123-0.13696-1.685-0.0727-0.23517,0.024-0.49487,0.28626-0.71675,0.0978-0.19209-0.22319-0.077-0.51875-0.005-0.76428,0.19446-0.61516,0.62428-1.1173,1.0997-1.5381,0.33451-0.31284,0.71044-0.65162,0.76033-1.1362,0.0412-0.41146-0.0782-0.836-0.29245-1.1863-0.28303-0.45124-0.94979-0.60823-1.3988-0.32122-0.23138,0.14903-0.41348,0.49488-0.22791,0.74502,0.21074,0.16246,0.59983,0.0174,0.70201,0.35421,0.13004,0.23361-0.005,0.59858-0.30108,0.59523-0.44024,0.068-0.83814-0.27723-0.95201-0.68516-0.18088-0.51011,0.0211-1.1303,0.49487-1.4058,0.49942-0.31245,1.1347-0.30455,1.6897-0.16948,0.56589,0.13998,1.0426,0.57886,1.2146,1.1377,0.15369,0.43258,0.16049,0.93304-0.0813,1.336-0.37581,0.71765-1.149,1.0743-1.6571,1.6769-0.14278,0.15646-0.24423,0.37142-0.18553,0.5856,0.0763-0.20325,0.39739-0.13277,0.58205-0.16726,0.3472-0.0144,0.68867,0.0763,1.0351,0.067z'/%3E %3Cpath d='m504.31,300.93c0.038,0.30996,0.27363,0.57568,0.58352,0.63192,0.22828,0.10146,0.56734-0.0157,0.71536,0.22534,0.14451,0.345-0.33305,0.28338-0.53603,0.27056-0.59094-0.0206-1.184-0.0507-1.7725,0.0266-0.28688,0.0121-0.57763,0.0817-0.86298,0.0444-0.28059-0.1282-0.1302-0.49628,0.1579-0.43846,0.26995-0.0519,0.6339-0.11286,0.7198-0.42222,0.0384-0.26561-0.0671-0.52405-0.10789-0.7845-0.19476-0.9229-0.38014-1.848-0.58094-2.7695-0.0191-0.28415-0.3155-0.34607-0.54674-0.31214-0.23597-0.0262-0.56287,0.16536-0.71312-0.0926-0.1734-0.35216,0.34436-0.34537,0.5521-0.43795,0.40776-0.1253,0.80848-0.27728,1.2211-0.38452,0.21179-0.0436,0.29799,0.15464,0.31202,0.32504,0.28623,1.3726,0.57163,2.7456,0.85839,4.118z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='%23448127' stroke='%2334541f' stroke-width='0.2185'%3E %3Cpath fill='url(%23rg6)' stroke='%234c0505' d='m475.8,219.41-3.7712,4.4831c-1.1995,5.2399,1.782,9.187,7.6495,12.614,4.7523,2.9497,13.549,3.6886,16.327,1.311l-13.714-13.071-6.4917-5.3367z'/%3E %3Cpath d='m503.58,354.27c-0.67209-0.80996-1.352-1.6173-2.0351-2.424-8.5576,11.298-19.248,21.429-32.617,28.575,15.077-4.2692,24.945-15.257,34.652-26.151z'/%3E %3Cpath d='m488.14,389.98c5.3164-10.772,11.731-21.544,18.203-32.317-0.70661-0.87988-1.4224-1.7595-2.1441-2.6357-7.3517,12.186-15.979,26.679-16.059,34.952z'/%3E %3Cpath d='m529.87,275.48c-0.98453-4.2467-2.2704-8.8375-4.3089-13.055-2.6573-5.4313-6.6232-10.831-11.832-16.804-9.3826-10.173-18.771-19.997-31.926-27.251,0.0242-0.0465,0.0452-0.0913,0.0686-0.13743l0.0774,0.0459h0.16387l-0.16125-0.20036h0.47064l-0.25481-0.255h0.43698l-0.35199-0.4005h0.46124l-0.32861-0.32775h0.49248l-0.27312-0.36423,0.39767,0.0304-0.3721-0.38695,0.54798-0.10881-0.4442-0.27946,0.48047-0.0918-0.40334-0.27552,0.58557-0.18747-0.51587-0.30568,0.65243-0.28797-0.63167-0.45644,0.66794-0.22854-0.72584-0.29541,0.61244-0.32162-0.72125-0.13023,0.48899-0.56612-0.70202,0.0371,0.31965-0.59693-0.66706,0.0555c-0.0149-0.019-0.0286-0.0389-0.0444-0.0577l0.36576-0.44945-0.67514,0.12018,0.29693-0.61092-0.64958,0.32469,0.18528-0.70705-0.62774,0.43218,0.0953-0.71906-0.57901,0.4962,0.0601-0.68739-0.50996,0.53335,0.0457-0.72453-0.50275,0.61026-0.0503-0.71273-0.4029,0.56-0.20495-0.67624-0.33452,0.67624-0.17064-0.7171-0.3166,0.7171-0.15447-0.7171-0.27312,0.7171-0.20648-0.67624-0.21456,0.67624-0.15928-0.59431-0.24079,0.71535-0.22352-0.67449-0.24078,0.76976-0.29191-0.68782-0.12629,0.82241-0.35155-0.67231-0.0406,0.79357-0.38281-0.60239-0.0247,0.78746-0.40836-0.56809,0.0323,0.69088-0.43393-0.36488,0.2126,0.74375-0.52482-0.30589,0.19708,0.65177-0.43197-0.24209,0.15404,0.63123-0.39307-0.12585,0.2056,0.4702c-0.0103,0.0212-0.0192,0.043-0.0291,0.0642l-0.30392-0.0566,0.17414,0.36598,0.001,0.00066c-0.38411,1.0385-0.41405,2.2785-0.35112,3.5147,0.0116,0.23051,0.59365,0.46409,0.68542,0.60698,0.27617,0.42912,0.2257,0.66073,0.2257,0.66073-1.5913,2.5804-3.0146,4.5731-3.1749,7.5311,1.2786-1.6184,2.6036-3.5997,4.4608-3.5997-0.92008,1.5373-1.3562,6.1718-0.32315,6.8771l0.77107-1.352c0.0282,1.0748,0.1796,1.7914,0.38914,2.3215,0.32227-0.6498,0.6415-1.271,0.96268-1.7412,0.0734,1.5056,0.26678,2.7141,0.70334,3.3115,0.42934-0.74026,1.0088-1.191,1.6182-1.5705-0.21129,0.86-0.52024,1.6721-0.38914,2.7039,0.6439-1.1014,1.2887-1.7526,1.9324-2.5127-0.37297,1.5867-0.0336,2.771,0.41688,4.5222,0.40029-2.0757,0.55738-2.2959,1.5159-3.1699,0.10619,1.9033-0.25739,3.6323,0.1429,4.6941,0.87397-1.6752,1.46-1.4357,1.9826-2.5192-0.10204,1.5795-0.41908,3.291-0.014,4.7009,0.33627-1.4128,1.2435-2.169,1.9442-2.6707,0.0572,2.1987,0.56502,1.8369-0.80144,3.7017,0.57901,0.26504,2.5413-0.3769,3.6052-0.8329-0.51455,1.1781-0.36314,2.1024-0.87835,2.9359,1.08-0.54253,2.0001-1.4204,2.9014-2.3215-0.41776,1.352-1.5251,2.7041-0.96968,4.0559,0.25171-1.2633,1.2734-2.3036,2.2422-2.493-0.15033,0.70814-0.25215,2.1742-1.2725,2.8824,2.4428,0.25193,3.4068-1.3975,4.6367-2.7039-0.15885,1.358-0.11384,2.4434,1.5522,4.3553-0.3367-2.4308,0.24144-1.9306,1.3429-3.3924,0.53182,2.1482,1.1425,4.4302,3.3821,6.0143-0.9286-2.2669-1.1001-3.435-0.57355-4.8615,0.28841,1.4722,1.6844,3.2488,2.0189,4.6441,0.20779-1.5476,0.44158-3.0454,0.96269-4.0559,0.65155,1.7569,1.1974,3.5711,1.352,5.5989,0.48812-1.0108,0.88425-2.0353,1.1611-3.0862,19.736,20.623,24.137,46.84,2.5127,74.541,7.7703-5.2493,9.7757-13.569,14.093-20.662-4.2141,9.2876-6.0923,19.737-13.513,27.421,7.1876-6.2024,8.7118-11.885,13.034-17.862-4.6067,12.501-10.982,26.2-19.821,38.742,1.5705,1.7071,3.1413,3.4409,4.7182,5.1892,1.3715-2.2839,2.7423-4.5646,4.0966-6.8489,9.3688-15.436,24.658-37.5,16.913-71.147z'/%3E %3C/g%3E %3Cpath fill='%23eac102' stroke='%23a08307' stroke-width='0.2185' d='m473.16,215.29c-0.99699,0.22614-1.392,0.64238-2.1111,1.4429,0.91746,0.20014,1.6925,0.24603,2.5212,0.26416,0.25695-0.0225,0.34348-0.34784,0.28645-0.58491l-0.1276-0.95504c-0.0227-0.2174-0.6013-0.20014-0.87354-0.0863l0.30458-0.0808z'/%3E %3Cpath fill='%23a08307' d='m471.04,216.73c0.34544-0.12301,0.69831-0.21412,1.0532-0.29781,0.35549-0.0795,0.71273-0.15141,1.0776-0.19118-0.34566,0.12323-0.69853,0.21434-1.0531,0.29781-0.35593,0.0793-0.71317,0.1512-1.0776,0.19118z'/%3E %3Cellipse fill='%23000' stroke='%23000' stroke-width='0.0978' cx='477.680' cy='215.416' rx='0.775' ry='0.811'/%3E %3Cellipse fill='url(%23rg7)' cx='477.860' cy='215.261' rx='0.337' ry='0.353'/%3E %3Cg fill='%2334541f'%3E %3Cpath d='m488.18,389.69c0.46649-1.4941,0.9782-2.9744,1.5282-4.4402,0.55695-1.4628,1.1543-2.9112,1.7825-4.3461,1.2594-2.8686,2.663-5.6715,4.1352-8.4348,1.4886-2.7554,3.0474-5.4726,4.6631-8.1534,0.80864-1.3405,1.6276-2.6744,2.4537-4.0037l2.5101-3.9674-2.4192,4.0234c-0.8069,1.3409-1.6092,2.6838-2.4004,4.0336-1.5845,2.6984-3.1439,5.4112-4.6153,8.1708-1.4864,2.7517-2.8844,5.5506-4.1741,8.3996-0.64565,1.4242-1.2594,2.8632-1.8362,4.3166-0.58273,1.451-1.1276,2.9182-1.6276,4.4016z'/%3E %3Cpath d='m469.34,380.23c1.6549-0.73392,3.2842-1.5249,4.8812-2.3748,1.6002-0.84273,3.1699-1.7436,4.7022-2.7047,3.0653-1.9177,5.9902-4.0605,8.733-6.4165,2.755-2.3416,5.3276-4.8938,7.7616-7.5693,1.2188-1.3365,2.4004-2.7074,3.5549-4.1014,1.1591-1.389,2.2892-2.8042,3.3991-4.2342-1.0818,1.4521-2.1841,2.8892-3.3163,4.3019-1.1377,1.4091-2.3071,2.7935-3.5125,4.1464-2.4128,2.703-4.993,5.2614-7.745,7.6231-2.762,2.3488-5.6942,4.5006-8.7863,6.3927-1.5465,0.94521-3.128,1.8325-4.7416,2.6569-1.6162,0.8187-3.2617,1.578-4.9303,2.28z'/%3E %3Cpath d='m506.62,350.89c0.7691-1.0741,1.4855-2.1863,2.2016-3.2962,0.71557-1.1104,1.4156-2.2315,2.0984-3.362,1.3678-2.2605,2.6897-4.549,3.9591-6.866,1.2854-2.3086,2.5208-4.6456,3.7507-6.9846l3.6773-7.0268-1.7453,3.5612-1.7825,3.5429c-1.1991,2.356-2.4367,4.6937-3.709,7.0128-1.2876,2.3104-2.608,4.6032-4.0078,6.8485-1.4054,2.2396-2.8529,4.4573-4.4424,6.5701z'/%3E %3Cpath d='m512.51,325.78c1.7073-2.0313,3.2774-4.177,4.6917-6.42,1.4237-2.2365,2.694-4.5696,3.8103-6.9735,2.235-4.8099,3.8411-9.8941,4.9751-15.071,0.14377-0.64674,0.28251-1.2948,0.41361-1.9439,0.10881-0.64631,0.20516-1.3064,0.29365-1.9619,0.17589-1.3132,0.31027-2.6316,0.40029-3.9534,0.18004-2.6431,0.17829-5.2998-0.0299-7.9416-0.20604-2.6425-0.62271-5.2675-1.2397-7.8455-0.60676-2.5811-1.4185-5.1136-2.403-7.578,1.0173,2.4511,1.8644,4.9751,2.5072,7.5525,0.63319,2.5798,1.0608,5.2107,1.2802,7.8588,0.22111,2.6484,0.23553,5.3131,0.0666,7.9654-0.0837,1.3263-0.21304,2.6495-0.38281,3.9674-0.0859,0.66007-0.17785,1.3142-0.28688,1.9763-0.12891,0.65155-0.26285,1.302-0.40618,1.9509-1.16,5.1834-2.7939,10.274-5.0566,15.084-1.1314,2.4043-2.4128,4.7378-3.8527,6.9696-1.4464,2.2289-3.0462,4.3555-4.7809,6.3636z'/%3E %3Cpath d='m510.87,320.07c1.8434-1.7624,3.4714-3.7408,4.898-5.8493,1.4364-2.1034,2.682-4.3328,3.795-6.6232,1.1143-2.2907,2.0984-4.6426,3.0272-7.015,0.4643-1.1866,0.91527-2.3788,1.3612-3.5728l0.33233-0.89605c0.10619-0.29584,0.20189-0.59933,0.29409-0.90369,0.1866-0.60851,0.35549-1.2238,0.57792-1.8297l-0.005,0.0168c0.50647-2.5236,0.7785-5.0946,0.8104-7.67,0.0323-2.5752-0.17064-5.1528-0.57136-7.6976-0.39985-2.5461-0.99568-5.0603-1.7314-7.5315-0.72541-2.4749-1.5926-4.9087-2.5538-7.3038,0.99393,2.3816,1.8952,4.8038,2.656,7.2724,0.7514,2.4714,1.3588,4.9882,1.7722,7.5396,0.41405,2.5507,0.63123,5.1364,0.61026,7.7233-0.0205,2.5861-0.27771,5.1718-0.78003,7.7102l-0.002,0.008-0.003,0.009c-0.2198,0.59081-0.39263,1.2054-0.58207,1.8148-0.0948,0.30502-0.19074,0.60982-0.30174,0.91331l-0.33801,0.89539c-0.45097,1.1928-0.90763,2.3831-1.3789,3.5693-0.94193,2.3707-1.9387,4.7214-3.0666,7.0124-1.1266,2.2896-2.3833,4.5202-3.8374,6.6193-1.4589,2.0934-3.1164,4.0522-4.9841,5.789z'/%3E %3Cpath d='m505.05,349.23c1.2017-1.6588,2.3886-3.3274,3.5733-4.9985l1.7774-2.5064c0.58972-0.83771,1.2076-1.6544,1.7331-2.5315,1.068-1.7445,1.9896-3.5748,2.8979-5.4095,0.90086-1.8393,1.8196-3.67,2.7089-5.5139,1.7816-3.6867,3.5053-7.405,4.9673-11.228,1.4681-3.8197,2.6228-7.7566,3.4511-11.763,0.84667-4.0033,1.4158-8.062,1.8854-12.129,0.42585-4.0649,0.47108-8.1798,0.0376-12.248-0.4289-4.0688-1.3617-8.0802-2.7253-11.939-1.3503-3.8647-3.1153-7.5772-5.0975-11.16,2.0134,3.565,3.8121,7.2632,5.1982,11.124,1.38,3.8608,2.3261,7.88,2.7692,11.959,0.44638,4.0791,0.41426,8.2025-0.001,12.284-0.45797,4.0716-1.0149,8.1374-1.8528,12.153-0.84208,4.0144-2.0126,7.9611-3.4946,11.784-1.477,3.8267-3.2134,7.5427-5.0066,11.226-0.89626,1.8428-1.8196,3.6705-2.7268,5.5067-0.91418,1.833-1.8406,3.6644-2.92,5.4095-0.53597,0.87748-1.1624,1.6912-1.7587,2.5221l-1.7986,2.4904c-1.2,1.6612-2.4008,3.3205-3.6172,4.9686z'/%3E %3Cpath d='m507.81,352.25c2.3617-3.8352,4.7108-7.6786,6.954-11.583,2.2498-3.9006,4.4831-7.8142,6.4653-11.856,1.9857-4.0378,3.7011-8.2136,4.9972-12.523,0.65002-2.153,1.2008-4.3362,1.6525-6.5396,0.22921-1.1023,0.42716-2.2068,0.59322-3.3192,0.17108-1.1126,0.32905-2.2262,0.47195-3.3423,0.58163-4.4617,0.92816-8.957,0.92226-13.457-0.005-4.4977-0.36576-9.0013-1.1982-13.424-0.82963-4.4206-2.141-8.756-3.9768-12.865-1.8218-4.114-4.1706-7.9958-6.9573-11.533,2.8149,3.5158,5.1965,7.3818,7.055,11.49,1.8533,4.1105,3.1776,8.4531,4.022,12.882,0.84623,4.4296,1.2196,8.943,1.2376,13.45,0.0184,4.5097-0.31529,9.0155-0.88797,13.486-0.14639,1.1167-0.3072,2.2328-0.48178,3.3458-0.16846,1.1139-0.37166,2.226-0.60392,3.3281-0.4584,2.2077-1.0169,4.3942-1.6741,6.5505-1.311,4.3161-3.0419,8.4962-5.0411,12.534-1.9964,4.0417-4.2384,7.9528-6.5033,11.846-2.2756,3.8892-4.6546,7.7142-7.0465,11.53z'/%3E %3Cpath d='m480,220.77c0.47435-0.012,0.94871,0.0402,1.4176,0.11275,0.46932,0.0736,0.9345,0.17392,1.3946,0.29409,0.91877,0.24559,1.815,0.57224,2.6864,0.95373,1.7429,0.76757,3.3718,1.774,4.9008,2.9029,1.5188,1.1449,2.9398,2.4161,4.2558,3.7854,0.65702,0.68563,1.2917,1.392,1.9038,2.117,0.60654,0.72956,1.1976,1.4718,1.7584,2.2363-0.59977-0.73415-1.2065-1.4617-1.8393-2.1664-0.62729-0.70923-1.2738-1.4008-1.9431-2.0696-1.3352-1.3394-2.7469-2.6042-4.2661-3.7282-1.5085-1.1362-3.1253-2.1314-4.8388-2.9252-0.8565-0.39701-1.7396-0.73851-2.6464-1.0038-0.90544-0.26548-1.8362-0.47217-2.7838-0.5091z'/%3E %3C/g%3E %3Cg fill='%23448127'%3E %3Cpath d='m496.38,231.57s3.0589,1.7982,4.7254,4.4385c0,0-4.7173-0.8825-8.0699-4.6513'/%3E %3Cpath fill='%2334541f' d='m496.38,231.57c0.47872,0.26111,0.93253,0.56612,1.3794,0.88032,0.44136,0.32184,0.86939,0.66269,1.2804,1.0245,0.41208,0.36074,0.79663,0.75271,1.1609,1.1628,0.36183,0.4123,0.7029,0.84623,0.9959,1.3132l0.13634,0.21719-0.24755-0.0535c-0.78418-0.16955-1.5345-0.42016-2.2728-0.71185-0.73611-0.29409-1.4539-0.63582-2.1371-1.0376-1.3693-0.7951-2.6232-1.7997-3.6397-3.008,1.0804,1.1493,2.3482,2.1072,3.7203,2.8658,0.68825,0.37603,1.3979,0.71251,2.1286,0.99699,0.72934,0.28186,1.482,0.52504,2.2404,0.68279l-0.111,0.16366c-0.28907-0.45382-0.61157-0.88775-0.96465-1.2966-0.35091-0.41099-0.73415-0.79379-1.1255-1.1681-0.39285-0.37319-0.8045-0.72737-1.2308-1.0636-0.42257-0.34217-0.86131-0.66357-1.3132-0.96794z'/%3E %3Cpath d='m489.58,230.69s7.2265,4.6109,8.2733,4.9782c0,0-1.6083-3.4784-5.0488-4.9721'/%3E %3Cpath fill='%2334541f' d='m489.58,230.69,4.1403,2.4878c0.68716,0.41886,1.3759,0.83487,2.0689,1.2428,0.34676,0.20364,0.69438,0.40553,1.0444,0.60174,0.34719,0.19402,0.70202,0.40508,1.0538,0.5482l-0.12848,0.14115c-0.25695-0.52964-0.57791-1.0414-0.92401-1.526-0.35047-0.48331-0.72759-0.9487-1.1423-1.3796-0.41361-0.43218-0.86589-0.82656-1.3462-1.1842-0.48025-0.35877-0.99895-0.66553-1.5421-0.92554,0.56022,0.22133,1.0938,0.51215,1.5957,0.84951,0.50275,0.33713,0.96683,0.73064,1.3997,1.1543,0.43197,0.42519,0.83247,0.88316,1.189,1.3739,0.35746,0.49139,0.68433,0.99983,0.95832,1.5509l0.1241,0.24952-0.25258-0.10815c-0.76801-0.32927-1.4368-0.75774-2.1351-1.1676-0.69066-0.41514-1.3763-0.83792-2.0602-1.2638-1.3588-0.86436-2.7124-1.7375-4.0432-2.6449z'/%3E %3Cpath d='m492.46,228.36s3.7596,1.5992,4.6111,4.3791c0,0-6.7528-2.8409-7.9617-4.3491'/%3E %3Cpath fill='%2334541f' d='m492.46,228.36c0.50778,0.19927,0.99218,0.45534,1.4646,0.73065,0.46779,0.2836,0.91789,0.59824,1.34,0.95089,0.42257,0.35155,0.80669,0.75206,1.1399,1.1941,0.32993,0.44311,0.60764,0.93559,0.76954,1.4718l0.0673,0.22243-0.21238-0.0913c-0.69984-0.30087-1.3925-0.61332-2.0822-0.93429-0.68914-0.32162-1.3754-0.65002-2.0495-1.0031-0.6745-0.35177-1.344-0.71447-1.9942-1.1113-0.32359-0.20058-0.64281-0.40902-0.95023-0.63407-0.30502-0.22636-0.60894-0.46496-0.84361-0.76561,0.25171,0.28558,0.56438,0.5056,0.87573,0.71951,0.31485,0.21084,0.64085,0.40487,0.97077,0.59081,0.65898,0.37471,1.3337,0.7219,2.0152,1.0544,1.3643,0.66204,2.7443,1.2976,4.142,1.8847l-0.14508,0.13109c-0.15688-0.50669-0.4088-0.98388-0.72475-1.4158-0.31419-0.43437-0.69197-0.8211-1.0909-1.1836-0.40072-0.36139-0.83334-0.68913-1.2861-0.98759-0.44922-0.30458-0.91986-0.57836-1.406-0.82373z'/%3E %3Cpath d='m486.76,231.25s6.6462,4.7577,8.6126,4.7577c0,0-1.9477-3.258-5.3876-4.7516'/%3E %3Cpath fill='%2334541f' d='m486.76,231.25c0.68826,0.45622,1.3794,0.90785,2.0761,1.3499,0.69459,0.44529,1.3955,0.8801,2.1061,1.2981,0.70661,0.42344,1.4224,0.83268,2.1565,1.2013,0.36729,0.18354,0.73938,0.35724,1.1191,0.50538,0.37668,0.14574,0.77063,0.28863,1.1547,0.29978l-0.0891,0.15666c-0.31376-0.50582-0.68236-0.99022-1.0704-1.4497-0.39198-0.45774-0.80472-0.8991-1.2476-1.3094-0.44158-0.41143-0.91528-0.78811-1.4106-1.1346-0.49532-0.34719-1.0221-0.64915-1.5699-0.9109,1.1296,0.4501,2.1657,1.1285,3.0812,1.9337,0.45884,0.40246,0.89343,0.83399,1.2913,1.2974,0.39897,0.46386,0.77281,0.94433,1.104,1.467l0.10247,0.16147-0.19118-0.005c-0.44617-0.0107-0.84361-0.15797-1.2345-0.30371-0.38826-0.15557-0.76342-0.33495-1.1329-0.52373-0.73829-0.37909-1.4532-0.79663-2.1587-1.2282-0.70136-0.43874-1.3916-0.89386-2.0744-1.3588-0.68039-0.46976-1.3544-0.94761-2.0123-1.4469z'/%3E %3Cpath d='m486.76,232.74s3.4605,2.9195,5.427,2.9195c0,0-1.9477-3.2578-5.3876-4.7514'/%3E %3Cpath fill='%2334541f' d='m486.76,232.74c0.41754,0.31179,0.84077,0.61463,1.2716,0.90479,0.42868,0.29365,0.86655,0.57333,1.3153,0.83159,0.44507,0.26394,0.90194,0.50865,1.3759,0.70792,0.23663,0.0994,0.47806,0.18638,0.72343,0.25214,0.24362,0.0688,0.49336,0.11712,0.74092,0.11952l-0.0892,0.15666c-0.31376-0.50581-0.68236-0.99022-1.0704-1.4495-0.3922-0.45775-0.80472-0.89911-1.2476-1.3094-0.44179-0.41143-0.91527-0.78811-1.4106-1.1346-0.49533-0.34719-1.0223-0.64893-1.5699-0.91091,1.1296,0.4501,2.1655,1.1285,3.0812,1.9337,0.45884,0.40247,0.89342,0.83378,1.2913,1.2974,0.39897,0.46387,0.77282,0.94434,1.1041,1.467l0.0996,0.15732-0.18834-0.00044c-0.55083-0.00087-1.0634-0.18004-1.5456-0.38848-0.48353-0.21172-0.94325-0.4667-1.3896-0.74048-0.44223-0.28076-0.86983-0.58141-1.2876-0.89495-0.4147-0.31769-0.82045-0.64653-1.2046-0.99918z'/%3E %3Cpath d='m485.03,226.18s7.2073,5.1165,8.0592,7.8964c0,0-6.5225-2.9945-7.7314-4.5025'/%3E %3Cpath fill='%2334541f' d='m485.03,226.18c0.78614,0.53378,1.5482,1.1019,2.304,1.6785,0.75031,0.58382,1.4879,1.1842,2.2053,1.8098,0.71754,0.62512,1.4075,1.2839,2.0536,1.9872,0.32185,0.35287,0.63123,0.71863,0.912,1.1091,0.27618,0.39176,0.54034,0.8045,0.68738,1.2799l0.0719,0.23292-0.22024-0.10335c-0.67974-0.31857-1.3525-0.64784-2.0224-0.98519-0.66925-0.3378-1.3352-0.68193-1.9892-1.0496-0.65439-0.3662-1.3038-0.74245-1.9339-1.1506-0.31354-0.20604-0.62293-0.4193-0.92074-0.64784-0.29584-0.22942-0.5895-0.47086-0.82023-0.76735,0.24756,0.28164,0.55083,0.50494,0.85344,0.72212,0.30546,0.21456,0.62184,0.41361,0.94237,0.60545,0.63953,0.3863,1.2946,0.74703,1.9566,1.0944,1.3252,0.69175,2.665,1.3601,4.0236,1.9826l-0.14814,0.12957c-0.14006-0.43284-0.38411-0.83859-0.65286-1.221-0.27094-0.3828-0.57311-0.74572-0.8884-1.0968-0.63167-0.70268-1.3208-1.354-2.0193-1.9938-0.70071-0.63822-1.4235-1.2533-2.1594-1.8522-0.73152-0.60414-1.4794-1.1888-2.2354-1.7639z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%2324420e' stroke-width='0.1639'%3E %3Cpath fill='%23406325' d='m445.02,370.33c-4.8888,3.644-18.553,5.4292-20.448,4.8005,9.9428-8.2718,19.725-8.471,20.448-4.8005z'/%3E %3Cpath fill='%23406325' d='m514.78,374.77c5.2537,4.768,21.104,8.0531,23.475,7.4607-10.542-10.77-22.102-11.863-23.475-7.4607z'/%3E %3Cpath fill='%2367923d' d='m444.98,370.3c-0.72081-3.6709-10.458-3.4489-20.378,4.775,10.446-3.4422,19.238-5.4047,20.378-4.775z'/%3E %3Cpath fill='%2367923d' d='m514.89,374.71c1.3715-4.4018,12.794-3.338,23.364,7.4616-11.884-5.021-21.947-8.0983-23.364-7.4616z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='375' viewBox='0 0 750 375'%3E %3Cdefs%3E %3ClinearGradient id='linearGradient795'%3E %3Cstop stop-color='%23d5dfff' offset='0'/%3E %3Cstop stop-color='%23FFF' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient783'%3E %3Cstop stop-color='%23474747' offset='0'/%3E %3Cstop stop-color='%23f50' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient746' y2='102.99' xlink:href='%23linearGradient783' gradientUnits='userSpaceOnUse' x2='228.97' gradientTransform='matrix(.74087 0 0 1.3286 40.513 .0061069)' y1='102.99' x1='215.83'/%3E %3ClinearGradient id='linearGradient747' y2='173.45' xlink:href='%23linearGradient783' gradientUnits='userSpaceOnUse' y1='218.47' gradientTransform='matrix(1.5101 0 0 .65184 40.513 .0061069)' x2='110.94' x1='109.34'/%3E %3ClinearGradient id='linearGradient748' y2='337.23' gradientUnits='userSpaceOnUse' y1='316.38' gradientTransform='matrix(1.2315 0 0 .79928 40.513 .0061069)' x2='126.02' x1='125.91'%3E %3Cstop stop-color='%23b50000' offset='0'/%3E %3Cstop stop-color='%23ffc500' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='linearGradient794' y2='1003.7' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='1040.4' gradientTransform='matrix(2.5627 0 0 .38409 40.513 .0061069)' x2='78.221' x1='117.6'/%3E %3ClinearGradient id='linearGradient800' y2='226.38' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='245.98' gradientTransform='matrix(.88634 0 0 1.1105 40.513 .0061069)' x2='255.03' x1='264.72'/%3E %3ClinearGradient id='linearGradient801' y2='147.35' xlink:href='%23linearGradient795' gradientUnits='userSpaceOnUse' y1='149.38' gradientTransform='matrix(.55904 0 0 1.7607 40.513 .0061069)' x2='456.4' x1='407.87'/%3E %3C/defs%3E %3Crect width='750' height='375' fill='%2300247d'/%3E %3Cg transform='matrix(.75595 0 0 .75595 0 -.000017730)'%3E %3Cg transform='matrix(8.2677 0 0 8.2677 0 .000022888)'%3E %3Cpath d='m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z' fill='%23FFF'/%3E %3Cpath d='m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z' fill='%23FFF'/%3E %3Cpath d='m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z' fill='%23cf142b'/%3E %3Cpath d='m0 30l20-10h4.472l-20 10h-4.472zm0-30l20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10l20-10h4.472l-20 10h-4.472zm24.472 20l-20-10h4.472l15.528 7.764v2.236z' fill='%23cf142b'/%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.621 0 0 0.621 461.4 21.482)'%3E %3Cpath d='m146.97 393.04s-3.35 8.84-5.26 8.84-8.84-3.82-8.84-3.82-5.02 8.13-7.65 8.6c-2.63 0.48-9.56-1.19-9.56-1.19s-6.69 0-6.93-0.96c-0.24-0.95 0.24-2.86 0.24-2.86s-9.558 7.64-11.709 7.16c-2.151-0.47-9.32-9.55-9.32-9.55l-1.195 4.78-13.621-0.48-11.949-7.65s-6.691 10.99-6.93 10.75-11.709 2.63-11.709 2.63l-0.717-2.15-7.647-4.54s5.974-8.36 5.974-8.6-2.868-1.2-2.868-1.2l-4.301 3.59-8.842 5.73-8.842-4.06 3.824-7.17 0.478-5.26 6.93-10.51 84.834-82.45 41.82 77.19-6.21 23.18z' stroke='%23000' stroke-width='1pt' fill='%236a4c2d'/%3E %3Cpath d='m207.24 398.04l22.08-0.8-9.4-4.64 84.14-3.17-11.89-4.53-10.53-14.27-43.6-3.28s-3.28-2.49-8.61-1.25c-0.22-3.39-4.3-7.81-4.3-7.81l-26.84-2.04-16.76 11.44 11.32 28.99 14.39 1.36z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m121.32 150.76l2.22-7.56s3.89-6.56 3.89-9.46c0-2.89 2.9-6.33 2.9-6.33s8.89-2.56 10.78 2.89c9.57-14.46 20.8-0.67 20.8-0.67l3.11-3.67 6.34-7.78s9.01 8.45 9.12 9.89c0.11 1.45 1.55 0.45 1.55 0.45l9.79-0.78s4.64 3.64 3.67 10.56c3.45 2.04 6.56 14.01 6.56 14.01l-80.73-1.55z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient747)'/%3E %3Cpath d='m207.25 240.72c1.69-1.03 7.01-2.72 6.36-10.5s-7.39-8.69-11.15-8.43c-3.77 0.26-7.14 3.5-7.14 3.5l-12.45-7.91s6.23-39.3 12.84-41.76c6.28-4.53 7.39-6.49 7.39-7.52 0-1.04-2.33-3.64-2.33-3.64l-40.6-4.8-38.39 4.54s-2.98 4.54-2.59 6.36c0.39 1.81 0.52 3.76 7.39 9.08 7.61 5.85 12.84 39.43 12.84 39.43s-10.76 5.31-11.41 4.66c-0.65-0.64-3.89-1.29-5.58-1.03-1.68 0.26-7.26 3.11-7.26 10.5 0 7.4 5.58 11.68 5.58 11.68s36.7-4.28 42.15 5.83c5.32-12.19 40.2-7.91 44.35-9.99z' stroke='%23000' stroke-width='1pt' fill='%23656263'/%3E %3Cpath stroke-linejoin='round' d='m246.79 199.87s0.41-4.27 3.45-6.3c3.05-2.03 23.36-3.05 28.24 0 4.87 3.05 6.7 18.08 6.7 18.08s3.05 5.28 3.25 9.14 0.61 6.5 0.61 6.5 16.25 21.13 16.45 40.22c1.83 13 1.42 47.73-3.65 60.93-0.21 16.46-7.11 27.22-7.11 27.22s1.62 2.84 1.42 5.89c-0.21 3.05-1.83 5.89-1.83 5.89l23.76 11.78-8.73-3.25s8.94 7.52 8.73 7.32c-0.2-0.21-9.95-4.68-9.95-4.68l5.89 5.89c-0.2-0.2-14.42-6.5-14.42-6.5s6.7 6.3 6.3 6.1c-0.41-0.2-10.77-5.08-10.77-5.08s6.5 6.91 6.3 6.5-9.34-4.06-9.34-4.06l0.4 3.45s-7.31-0.41-7.31-5.89c-3.66-2.03-6.09-4.88-6.09-4.88l-16.86-2.84-19.1-57.08 4.47-96.48 1.22-4.87-2.03-13z' stroke-opacity='.97854' stroke='%23000' stroke-width='1.25'/%3E %3Cpath stroke-width='.99323pt' d='m234.03 508.2s-9.78-20.57-14.65-20.86c-4.4-8.39 15.29-76.96 53.38-80.87 20.94 1.72 1.72 24.14-12.05 17.24 1.72 6.03 8.6 14.66 8.6 14.66s-27.25 11.78-35.28 69.83z' stroke='%23000' fill='%23fb0'/%3E %3Cpath d='m102.91 511.2s8.1-23.42 13.01-23.71c4.92-0.29-13.01-78.05-52.032-78.63-21.104 1.74-1.735 24.28 12.141 17.34-1.734 6.08-8.672 14.75-8.672 14.75s27.463 11.85 35.553 70.25z' stroke='%23000' stroke-width='1pt' fill='%23fb0'/%3E %3Cpath d='m138.71 364.93c-0.1-0.19-9.69 3.01-3.48 13.45 0.47-4.04 4.79-6.49 4.79-6.49s-6.58 7.81 0.38 14.39c0.85-6.21 4.8-8.18 4.8-8.18s-4.89 14.39 0.09 17.3c0.57-5.74 4.23-8.27 4.23-8.27s-4.42 12.88-0.47 15.79c0.47-4.88 3.76-7.05 3.76-7.05s-1.97 13.36 3.2 14.3c0.1-4.71 3.86-9.31 3.86-9.31s-1.7 10.9 6.39 11.38c0.1-4.14 1.6-8.84 1.6-8.84s3.67 11.56 9.03 9.68c-0.09-3.38 0.09-9.78 0-9.78-0.1 0 3.38 11 9.78 8.94-0.94-3.11 0.37-6.78 0.37-6.78s3.39 6.87 9.5 4.61c1.04-2.07-0.28-6.11-0.28-6.11s8.93 9.22 11.66 3.67-7.15-7.43-7.15-7.43h6.68s-2.16-5.64-11.19-6.87c3.1-1.41 6.3-0.37 6.3-0.37s-1.88-7.06-11.1-7.81c3.58-1.22 7.53-0.37 7.53-0.37s-1.23-6.68-11.38-8.56c1.6-1.79 5.92-1.22 5.92-1.22s-4.04-6.3-8.65-5.93c-4.61 0.38-46.27-4.23-46.17-4.14z' stroke='%23000' stroke-width='1pt' fill='%2300713d'/%3E %3Cg stroke-width='1.25' stroke-linecap='round' stroke='%233ec26d' fill='none'%3E %3Cg%3E %3Cpath d='m179.8 398.88s3.67 1.79 3.58 3.39'/%3E %3Cpath d='m181.97 395.97s4.7 3.29 4.61 5.73'/%3E %3Cpath d='m186.1 394.27s3.77 2.35 3.95 6.02'/%3E %3Cpath d='m192.4 395.78s1.89 4.04 1.23 4.79'/%3E %3Cpath d='m196.17 397.94c0.28 3.2-0.29 3.48-0.29 3.48'/%3E %3C/g%3E %3Cpath d='m149.8 377.72s4.42 2.82 4.05 6.77'/%3E %3Cpath d='m149.52 381.11s2.07 1.97 1.6 3.29'/%3E %3Cpath d='m154.98 377.82s2.91 4.04 1.97 6.86'/%3E %3Cpath d='m159.96 380.45s1.32 2.54 0.1 3.95'/%3E %3Cpath d='m162.31 381.67s1.6 2.54 0.19 3.39'/%3E %3Cpath d='m160.53 390.04s4.13 0.94 4.7 4.04'/%3E %3Cpath d='m162.97 387.22s4.33 0.28 4.8 4.89'/%3E %3Cpath d='m168.71 385.62c0.09 0 2.91 4.99 2.44 6.58'/%3E %3Cpath d='m174.26 386.09s1.12 4.8 0.28 6.3'/%3E %3Cpath d='m177.83 387.97c0 0.1 0.09 5.55 0.09 5.55'/%3E %3Cpath d='m172.38 380.45s2.72 1.03 2.53 3.67'/%3E %3Cpath d='m174.91 378s3.48 1.98 3.11 5.74'/%3E %3Cpath d='m178.96 376.41s3.01 3.57 1.88 7.52'/%3E %3Cpath d='m184.22 377.25s-1.12 4.42-0.66 6.21'/%3E %3Cpath d='m187.42 380.26s-1.97 1.51-0.94 3.39'/%3E %3Cpath d='m170.31 397.47s0.65 3.39 0 3.95'/%3E %3Cpath d='m165.98 395.5s2.16 3.76 1.41 5.64'/%3E %3Cpath d='m161.37 395.31s2.45 2.82 2.35 5.08'/%3E %3Cpath d='m157.61 395.87s2.26 2.17 2.07 3.39'/%3E %3Cpath d='m155.64 399.16s2.16 2.26 2.06 2.73'/%3E %3C/g%3E %3Cpath d='m108.86 244.78c10.37-0.19 20.74-0.37 31.11-0.56 0 0 20.55 0 22.77 6.67 3.89-8.89 21.66-8.33 21.66-8.33 10.74-0.37 21.48-0.74 32.21-1.11 0.19 25.92 0.37 51.84 0.56 77.76-6.29 30.17-28.14 51.47-52.21 60.54-28.7-9.26-46.84-33.51-52.76-61.1-1.12-24.62-2.23-49.25-3.34-73.87z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m119.94 244.49l45.31 120.74 40.93-123.37c-12.7 0.82-39.94-2-43.32 9.58-5.24-10.36-33.9-6.18-42.92-6.95z' stroke='%23000' stroke-width='1pt' fill='%23006b00'/%3E %3Cpath d='m150.78 309.86c1.75 0.91 1.7-32.77 3.99-33.81 0.65-2.79 0.98-4.01 1.8-6.97-1.97-3.49-10.79-3.32-14.06-0.35 1.47 4.7 2.12 6.27 2.12 6.27 4.42 7.15 3.54 35.62 6.15 34.86z' stroke='%23006b00' stroke-linecap='round' stroke-width='.68918' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m138.64 49.548s3.21-3.638 3.35-4.51c0.15-0.873 14.55-1.455 23.13-17.458 4.8-8.438 0-3.492 0-3.492l-0.29-4.074s5.97-5.673 3.79-8.729c-2.19-3.0546-1.46 3.929-4.95 3.783s-1.6-7.565-1.6-7.565-0.29-0.873-1.31-1.3094c-1.46 0.1455-1.02 2.7642-2.33 3.0551-1.31 0.291-2.47-6.1103-2.47-6.1103s-2.18-2.9096-4.08 6.2558c1.02 9.7478 7.28 7.8558 7.28 14.258 0 6.401-5.53 11.347-7.13 11.493-1.6 0.145-1.02-5.383-1.02-5.383s-0.87-2.619-1.45-2.619 3.2-0.582 2.62-7.856c-1.31-8.729-2.33 2.037-4.66 1.6-2.33-0.436-0.58-8.001 0.29-8.874s-1.02-4.51-6.11 4.801c-0.44 4.51-1.02-1.164-2.04-0.873-1.74 3.637-1.45 6.256 1.02 9.602 3.64 3.346 5.97 6.692 5.82 8.438-0.14 1.746-2.04 5.674-4.65 5.674-2.62 0 0.14-4.801 0-6.402-0.15-1.6-4.51-7.419-4.51-7.419s-3.06-4.947-2.77-5.092c0.29-0.146-0.29-0.873-1.74 4.219-1.46 5.092-3.21-3.346-3.21-3.346s-2.03 6.255 2.33 10.038c-3.34-0.436-3.63 0.873-3.63 0.873 0 1.746 4.51 2.473 5.09 5.528 0.58 3.056-4.66 4.801-4.66 4.801s2.19 3.055 8.29-2.909c0.15 3.782-2.32 6.401-2.32 6.401 2.03 0.921 3.63 0.824 3.92 3.201z' stroke='%23000' stroke-width='1.25' fill='%23cdad56'/%3E %3Cpath stroke-linejoin='round' d='m118.68 49.548s-2.72-4.037-2.84-4.832c-0.13-0.794-13.38 1.004-19.648-15.158-4.078-7.678 0-3.177 0-3.177l0.247-3.707s-4.339-5.308-2.486-8.088 1.09 3.574 3.474 3.587c2.963-0.132 1.359-6.884 1.359-6.884s0.246-0.794 1.112-1.191c1.232 0.132 1.742 4.115 2.852 4.38s3.41-4.687 4.13-5.7054c1.02-0.1457 0.98-4.1023 2.59 4.2374-0.86 8.87-8.21 7.149-8.21 12.974 0 5.824 4.69 10.325 6.05 10.458 1.36 0.132 0.87-4.898 0.87-4.898s0.74-2.383 1.23-2.383c0.5 0-4.32 0.925-3.82-5.694 1.11-6.197 3.57 0.399 5.55 0.001 1.98-0.397-0.23-6.553 0.34-7.493 0.13-0.94 3.04-4.977 4.17 3.932 0.37 4.104 2.61-3.532 3.47-3.267 1.49 3.309-0.65 7.729-2.75 10.774-3.09 3.044-4.49 6.38-4.36 7.969 0.12 1.588 0.85 3.562 3.08 3.562 2.22 0 0.75-2.768 0.87-4.224s3.83-6.17 3.83-6.17c0.73-1.163 0.12-3.337 0.89-4.342 1.21 0.013 1.71-1.667 2.94 2.966 1.24 4.633 2.72-3.045 2.72-3.045s1.73 5.693-1.98 9.135c2.84-0.397 3.09 0.794 3.09 0.794 0 1.589-1.35 2.25-1.85 5.03s1.48 4.369 1.48 4.369-1.85 2.78-7.04-2.648c-0.13 3.442 1.98 5.825 1.98 5.825-1.74 0.839-3.09 0.75-3.34 2.913z' stroke='%23000' stroke-width='1.0989' fill='%23cdad56'/%3E %3Cpath stroke-width='1pt' d='m198.62 262.5c-2.71-2.46-3.03-0.31-4.36-0.86-0.66-0.27-1.17-0.88-1.74-1.44-0.49-0.51-1.08-0.72-1.73-0.99-0.25 0.73-0.49 1.45-0.74 2.18s0.69 1.94 0.67 3.03c-0.19 1.62-0.85 2.97-2.89 3.52 0.58-1.15 0.91-1.2 0.73-2.61-0.08-0.7-2.05-1.95-1.81-2.61 0.36-1.07 0.98-2.3 0.52-3.37-0.83 0.57-1.93 0.27-2.76 0.62-0.71 0.31-0.75 1.62-1.73 2.16-1 0.47-3.21 0.24-5.06-0.81 1.13-0.85 2.06-0.28 3.19-1.13 0.56-0.43 0.54-2.26 1.1-2.69 0.57-0.43 1.92-0.88 2.48-1.31-0.51-0.58-0.48-1.49-0.99-2.07-0.5-0.58-2.75-0.46-3.26-1.03-1.02-1.16-0.82-2.68-1.84-3.83 2.63 0.94 2.25 2.22 2.91 2.12 1.24-0.6 2.48-0.71 3.13-0.44 0.66 0.28 1.9 1.9 2.55 2.17 0.25-0.73 0.61-1.65 0.85-2.38 0.25-0.73-1.1-1.99-0.86-2.72 0.5-1.45 1.72-2.74 2.21-4.2 0.18 1.41 0.41 2.59 0.59 3.99 0.09 0.7 1.47 1.07 1.56 1.77 0.09 0.71-0.72 2.33-0.64 3.04 0.76-0.15 1.85-0.05 2.6-0.2 0.76-0.15 1.26-1.9 2.01-2.05 1.51-0.3 2.6-0.21 4.13 0.08-1.13 1.05-2 0.98-2.71 1.94-0.56 0.43 0.22 1.84-1.41 2.83-0.61 0.36-2.22-0.07-2.79 0.36 0.51 0.58 1.02 1.15 1.53 1.73 0.5 0.58 2.78 0.85 3.29 1.43 1.01 1.15 1.55 2.53 1.27 3.77z' fill='%23ffc900'/%3E %3Cpath stroke-width='1pt' d='m128.95 263.69c2.71-2.46 3.03-0.31 4.37-0.86 0.65-0.28 1.16-0.89 1.73-1.44 0.49-0.51 1.08-0.72 1.73-1 0.25 0.73 0.5 1.46 0.74 2.19 0.25 0.73-0.68 1.93-0.66 3.02 0.18 1.63 0.84 2.97 2.88 3.53-0.58-1.15-0.91-1.21-0.73-2.61 0.09-0.7 2.05-1.95 1.81-2.62-0.36-1.06-0.98-2.3-0.52-3.37 0.84 0.58 1.93 0.28 2.77 0.62 0.7 0.32 0.75 1.63 1.72 2.17 1.01 0.47 3.22 0.24 5.06-0.81-1.13-0.86-2.06-0.28-3.19-1.14-0.56-0.42-0.53-2.26-1.1-2.68-0.56-0.43-1.91-0.89-2.48-1.32 0.51-0.57 0.48-1.49 0.99-2.07 0.51-0.57 2.76-0.45 3.26-1.03 1.02-1.15 0.83-2.67 1.84-3.83-2.63 0.94-2.24 2.22-2.9 2.13-1.25-0.6-2.49-0.72-3.14-0.44-0.65 0.27-1.9 1.89-2.55 2.17-0.25-0.73-0.6-1.65-0.85-2.38s1.11-1.99 0.86-2.72c-0.49-1.46-1.72-2.74-2.21-4.2-0.18 1.4-0.41 2.58-0.59 3.99-0.09 0.7-1.47 1.07-1.56 1.77-0.08 0.7 0.73 2.33 0.64 3.03-0.76-0.15-1.85-0.05-2.6-0.19-0.75-0.16-1.25-1.91-2.01-2.06-1.51-0.3-2.59-0.21-4.13 0.08 1.13 1.06 2 0.98 2.71 1.95 0.56 0.43-0.22 1.84 1.41 2.83 0.61 0.36 2.23-0.07 2.79 0.36-0.51 0.57-1.02 1.15-1.52 1.73-0.51 0.58-2.79 0.85-3.29 1.42-1.02 1.16-1.56 2.54-1.28 3.78z' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m196.19 270.28c-2.46 1.91-18.31 5.92-18.48 19.69-0.16 13.77 2.78 16.91-0.16 17.26-5.72 0-6.54-15.34-6.38-22.14 0.17-6.8 0.33-5.75 0.33-5.75s3.92 1.04 3.6 4.36c-0.33 3.31 3.92-8.2 2.45-11.33 2.61 2.61 6.05 1.57 6.05 1.39 0-0.17-1.96-2.26-2.78-3.83s2.94 0.87 2.94 0.87 0.16-2.62-3.11-2.44c-4.25 0 0.66-1.4 0.66-1.4s2.45 2.27 4.09-0.17c-1.8-1.92-4.42-2.97-4.42-2.97s-2.29-4.35-5.39-5.22c-3.6-0.88-3.11 1.56-7.2 1.22-0.81 1.56-0.81 1.74 0.82 2.26-2.78 1.92-1.31 5.75-1.31 5.75s4.42-1.91 4.25 1.22c-0.16 3.14-2.61 2.62-4.25 0.7-1.47-0.87-1.96 0.87-1.96 0.87l2.29 2.44s-4.41-0.17-5.56 2.79c2.45-0.17 3.76 0.53 3.76 0.53s-5.07 2.26-5.56 3.48-0.65-1.39-0.81-1.39c-0.17 0-4.91-1.75-4.91-1.75l-1.64 7.54s3.28 3.27 5.07 2.22c1.8-1.04 5.07-4.18 7.03-3.31-5.72 4.36-11.44 10.63-14.55 11.51-0.81-0.7-3.59-3.49-4.74-2.1-1.14 1.4-0.32 3.14 1.15 2.97 1.47-0.18-4.74 1.39-3.44 4.01 1.31 2.61 1.15 2.44 2.29 1.74 1.15-0.7-0.98-0.87 3.27-2.09s4.09-2.44 4.09-2.44-0.82 1.91-3.11 2.44c-2.29 0.52-4.08 0.52-3.59 1.22 0.49 0.69 1.47 1.91 1.14 2.61s4.74-3.66 6.05-0.17c3.43-0.18 5.72-4.36 4.09-6.8 0.16 2.61 1.8 3.49 0.81 4.71-0.98 1.22 7.69-4.01 3.44-7.15 1.14 2.61 1.31 4.71 1.31 4.71s1.96-0.18 2.45-0.88c0.49-0.69-0.98 1.92-0.33 2.44 0.65 0.53 3.76 3.49 2.45 5.58-0.81-1.22-0.98-3.14-1.96-2.96-0.98 0.17-5.07 3.14-7.52 3.31s2.94 9.07 2.94 9.07-3.76-0.53-4.25-0.18-2.94-3.14-3.43-1.04c-0.82 2.61 0.82 1.56 0.82 1.56s-2.13-1.04-3.27 0.18c-1.15 1.22-2.29 2.44-1.47 2.96 0.81 0.52 4.41 0.52 4.9 0.35s-4.09 0.35-4.41 0.87c-0.33 0.52-0.98 2.44 0 3.14s3.43-0.35 3.59-0.87c0.17-0.53 0.33 1.91 0.33 1.91s4.25 0.35 4.25-4c0-4.36 0.33 3.13 0.33 3.13s4.25 0.7 4.41-3.66c0.17-4.35 0.49 2.97 0.49 2.97s2.78-0.88 2.78-1.57c0-0.7-0.16 8.71-2.12 11.33-3.11-2.1-5.07 1.39-5.07 1.39s0.16 5.05-0.17 6.27c-0.32 1.22 2.13-0.69 2.29-1.22 0.17-0.52 3.11-1.91 3.27-2.26 0.17-0.35 0.98-2.09 0.98-2.09s-0.65 2.44-1.79 2.79c-1.15 0.34-2.29 1.56-1.8 2.61s2.29 1.74 2.94 2.79c0.65 1.04 2.94-6.1 2.94-6.1l0.17 1.57s2.94-0.7 3.27-2.09c0.32-1.4-3.11-2.62-0.33-4.88 2.78-2.27 0 2.09 0 2.09s0.98 3.31 1.63 3.31c0.66 0 2.29-6.28 0.66-7.84-1.64-1.57 2.45 1.91 2.45 1.91s2.29-6.45-0.16-7.32c-2.46-0.87-3.6-1.22-3.6-1.22s1.31-1.74 0.65-1.91c-0.65-0.18 3.44 3.83 4.09 2.78 0.66-1.04 1.64-4.18-3.1-5.92-4.75-1.74-0.17-6.63-0.17-6.63s2.95 3.49 5.07 1.57c2.12-1.91-0.16-1.91-0.16-1.91s6.04-3.84 6.21-5.76c-1.15-0.17-3.11 0.18-3.11 0.18s3.44-2.27 2.62-5.93c-1.31 1.92-3.11 1.92-3.11 1.92s2.95-2.96 2.45-5.75c-1.79 1.39-1.63 2.44-2.78 2.09-1.14-0.35-3.1-11.33 1.48-12.03 4.57-0.69 2.12 5.41 2.28 5.41 0.17 0 6.87-2.79 0-7.32 1.64-0.53 5.07 2.61 5.07 2.61s-1.47-7.67-8.83-2.96c1.8-1.92 2.95-3.14 4.42-2.79s6.7-0.18 6.7-1.74c-1.3-1.05-4.08 0.52-5.56 0-1.47-0.53 10.47-1.4 9.49-7.32z' stroke='%23006b00' stroke-linecap='round' stroke-width='.68918' fill='%23ffc900'/%3E %3Cpath d='m481.3 118.54s12.25-6.43 18.37 1.54' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m504.57 132.32c-0.31 0-4.29 3.98-5.21 3.98' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m512.84 145.18s11.32 0.92 18.67-10.41' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m525.08 141.81s0.92 6.13 2.76 6.13c1.83 0-3.06 1.53-4.9 0.3 2.14 2.76 3.37 7.66 0 9.49' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m519.26 218.97s-3.98 4.28-8.88 4.59' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath d='m523.86 199.37s-2.45-12.24-0.92-15.31c0.92-3.98 4.9-5.51 7.96-10.71' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m522.63 190.49s-3.06 7.35-16.53 4.9' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m526.31 172.12s0.91 9.8-11.33 6.13' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m511.3 128.04s-4.9 4.28-3.06 10.1' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m529.67 117.32s6.43-2.45 7.66-3.68c1.22-1.22 3.37-3.67 3.98-5.51 0.61-1.83-4.29-4.59-1.84-8.569 1.53-1.837 3.67-2.143 7.35 0 3.67 2.139-3.37-6.735-7.04-7.041-3.68-0.307-6.13 2.449-7.04 1.836-0.92-0.612 0.3 2.45-1.23 2.45s3.06 2.449 2.76 3.984c-0.31 1.53 4.89 6.73 4.59 7.96-0.31 1.22-7.66 8.26-9.19 8.57z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke-linecap='round' stroke-width='1.25' fill='%23006b00'/%3E %3Cpath stroke-linejoin='round' d='m534.27 97.112c2.79-0.636 3.24 0.07 2.75 2.449-1.31-0.66-1.79-1.217-2.75-2.449z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23ffc900' stroke-linecap='round' stroke-width='1.25' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m514.71 233.52s-1.03 6.41 1.49 6.94c-0.13-2.48 0.54-4.17 1.16-4.83-0.54-0.25-2.53-2.07-2.65-2.11z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m509.03 225.63c-2.32-0.33-6.23 1.59-5.11 3.91 1.89-1.62 3.63 0.13 4.95-1.52 0.4-0.46 0.29-1.81 0.16-2.39z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m509.01 221.05s-3.65-0.58-4.16 1.95c2.52-0.32 3.27-0.59 4.11-0.06 0.24-0.54 0.01-1.76 0.05-1.89z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1.25' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m493.54 184.94s2.19 0.82 2.81 3.06c1.74-1.08 2.57-5.83-2.81-3.06z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m488.12 190.39c0.09-0.04 4.59-2.77 5.05-0.16-0.95 0.95-1.37 1.57-2.11 1.78-0.58 0-1.74-1.78-2.94-1.62z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m487.67 199.24c0.08-0.04 2.89-2.52 3.97-0.87 1.07 1.66-0.87 1.57-0.87 1.57s-0.99-0.45-3.1-0.7z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m483.7 149.96c-0.04 0-3.6-1.37-5.09 1.11 2.36 0.29 3.19 1.12 4.26 1.95-0.29-1.04-0.78-2.61 0.83-3.06z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m476.8 168.52s0.16-4.17 2.14-5.87c1.12 0.62 1.45 1.61 2.2 2.85-1.49 0.33-3.48 0.42-4.34 3.02z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m486.3 165.54s-3.92 1.82-2.64 3.81c1.28-1.37 2.69-0.95 2.69-0.99s0-2.77-0.05-2.82z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m480.64 125.6c-1.41 1.58 1.74 5.01 5.04 4.51 0.83-3.72-4.21-5.66-5.04-4.51z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23ffc900'/%3E %3Cpath stroke-linejoin='round' d='m480.6 118.41c-0.69 1.75 2.05 4.21 3.64 3.52 0.64-1.8-2.92-4.91-3.64-3.52z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m484.28 122.75s0.62 2.94 3.47 2.15c-0.45-2.27-2.44-3.97-2.44-3.97-0.12 0.67 0.41 1.7-1.03 1.82z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m486.18 131.27s1.57 1.69 4.67-1.78c-1.4 0.41-3.88-0.83-3.88-0.83s0 2.4-0.79 2.61z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23e80000'/%3E %3Cpath stroke-linejoin='round' d='m480.46 118.86c-1.4 1.57 0.59 3.76 3.89 3.27 0.83-3.72-3.06-4.42-3.89-3.27z' transform='matrix(.53397 0 0 .56928 -112.64 207.32)' stroke='%23006b00' stroke-width='1pt' fill='%23ffc900'/%3E %3Cpath d='m144.62 266.62s7.04-2.01 10.78 1.01c3.73 3.01 3.73 0.28 3.73 0.28s5.46 2.01 7.04 1.58-1.15 0.15 1-1.15c2.16-1.29-4.31 0.29-4.88-2.44-1.01-1.72 0.14-3.88-2.15-3.16-1.58-2.01 1-3.44 0.43-5.6-1.58 1.15-2.45-0.43-3.74 2.44-3.01-0.57-0.43-4.74-3.73-5.17 0 3.02-2.44 3.16-2.59 4.89-1.43 1-7.75 4.74-5.89 7.32z' fill='url(%23linearGradient748)'/%3E %3Cpath d='m63.624 495.58c4.566-1.1 29.306 5.47 38.846 15.69-2.03-18.21-7.072-32.16-7.072-32.16s-14.743-4.21-16.767-2.18c-2.968 3.12-11.883 12.49-15.007 18.65z' stroke='%23000' stroke-width='1pt' fill='%23c01500'/%3E %3Cpath d='m56.082 411.46c-1.734 0.29-3.469 1.45-5.203 4.34-2.024 4.91-3.469 17.34-6.36 20.23s-5.493 3.18-5.493 5.79c0 2.6 0.29 8.67 8.095 10.98 7.805 0.29 20.236-12.43 20.236-12.43s6.36-6.94 8.961-14.45c-15.032 5.2-25.728-8.68-20.236-14.46z' stroke='%23000' stroke-width='1pt' fill='%23c01500'/%3E %3Cpath stroke-width='.99323pt' d='m273.49 492.68c-4.53-1.09-29.55 5.44-39.02 15.6 2.01-18.1 7.02-31.98 7.02-31.98 1.75-0.47 14.47-4.18 16.48-2.16 2.94 3.1 12.42 12.42 15.52 18.54z' stroke='%23000' fill='%23c01500'/%3E %3Cpath stroke-width='.99323pt' d='m280.5 409.05c1.72 0.29 2.33 2.55 3.74 5.43 2 4.88 4.07 12 6.94 14.87 2.87 2.88 5.45 7.13 5.45 9.72s-0.6 6.08-8.35 8.38c-7.74 0.29-18.97-9.66-18.97-9.66s-6.31-6.89-8.89-14.37c14.92 5.18 24.58-8.14 20.08-14.37z' stroke='%23000' fill='%23c01500'/%3E %3Cpath d='m47.41 479.69s15.61 10.69 15.9 15.61c41.92-62.16 148.88-81.53 209.87-4.34 8.1-10.7 16.48-14.16 16.48-14.16-64.17-83.84-191.95-73.43-242.25 2.89z' stroke='%23000' stroke-width='1pt' fill='%23fb0'/%3E %3Cg stroke-width='1pt' transform='translate(-.0000071526 .000045776)' stroke='%23000' fill='%231e5aa6'%3E %3Cpath d='m206.44 241.88l6.11-0.15-10.91 13.82 13.09 15.28-25.75 32.44 24.3 29.24c-2.67 6.55-5.77 12.51-9.9 17.9l-13.96-15.43 25.31-31.56-20.8-23.57 12.51-37.97z'/%3E %3Cpath d='m119.15 244.64l-6.55 0.15 12.22 13.23-12.94 16.15 26.91 29.25-22.26 29.82c2.67 6.55 6.5 13.82 10.62 19.2l13.24-16.73-27.2-30.26 19.93-25.31-13.97-35.5z'/%3E %3Cpath d='m149.41 323.2l-9.6 12.8 34.33 39.72c6.06-3.06 10.82-6.55 16.01-10.76l-17.9-20.66 7.28-21.39 10.47 12.07-32.73 41.76c-5.48-2.33-11.54-5.97-17.02-10.48l17.31-21.96-8.15-21.1z'/%3E %3Cpath d='m138.79 303.27l6.26 7.86-4.08-10.62-2.18 2.76z'/%3E %3Cpath stroke-width='.96849pt' d='m183.6 310.22c0.13-0.15 5.05-6.7 5.05-6.7l-1.91-2.61-3.14 9.31z'/%3E %3C/g%3E %3Cg font-family='Timmons' font-size='14px' font-weight='bold' line-height='100%25'%3E %3Ctext y='362.39716' x='-328.34363' transform='rotate(-49.557)'%3E %3Ctspan y='362.39716' x='-328.34363'%3EL%3C/tspan%3E %3C/text%3E %3Ctext y='384.26642' x='-292.33514' transform='rotate(-45.392)'%3E %3Ctspan y='384.26642' x='-292.33514'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='451.6806' x='-239.78038' transform='matrix(.76280 -.54464 .56769 .75422 0 0)'%3E %3Ctspan y='451.6806' x='-239.78038'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='429.95776' x='-188.5262' transform='matrix(.82844 -.56007 .56007 .82844 0 0)'%3E %3Ctspan y='429.95776' x='-188.5262'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='451.47876' x='-115.42612' transform='rotate(-25.549)'%3E %3Ctspan y='451.47876' x='-115.42612'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='453.04584' x='-94.110794' transform='rotate(-23.988)'%3E %3Ctspan y='453.04584' x='-94.110794'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='454.98212' x='-68.37056' transform='rotate(-21.911)'%3E %3Ctspan y='454.98212' x='-68.37056'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='445.66595' x='112.01579' transform='rotate(-4.7626)'%3E %3Ctspan y='445.66595' x='112.01579'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='430.7926' x='180.22531' transform='rotate(.85649)'%3E %3Ctspan y='430.7926' x='180.22531'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='275.21735' x='414.75919' transform='rotate(29.645)'%3E %3Ctspan y='275.21735' x='414.75919'%3ER%3C/tspan%3E %3C/text%3E %3Ctext y='193.05025' x='483.87762' transform='rotate(39.802)'%3E %3Ctspan y='193.05025' x='483.87762'%3EE%3C/tspan%3E %3C/text%3E %3Ctext y='414.02829' x='309.11557' transform='matrix(.96356 .18112 -.15531 .95184 0 0)'%3E %3Ctspan y='414.02829' x='309.11557'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='459.27182' x='105.05786' transform='matrix(.90188 -.13160 .13648 0.975 0 0)'%3E %3Ctspan y='459.27182' x='105.05786'%3EO%3C/tspan%3E %3C/text%3E %3Ctext y='455.83463' x='-45.707756' transform='rotate(-20.292)'%3E %3Ctspan y='455.83463' x='-45.707756'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='144.72449' x='518.34955' transform='matrix(.70468 .70952 -.70952 .70468 0 0)'%3E %3Ctspan y='144.72449' x='518.34955'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='388.29758' x='271.18784' transform='matrix(.98042 .19691 -.19691 .98042 0 0)'%3E %3Ctspan y='388.29758' x='271.18784'%3EA%3C/tspan%3E %3C/text%3E %3Ctext y='455.1676' x='40.321587' transform='rotate(-10.645)'%3E %3Ctspan y='455.1676' x='40.321587'%3EM%3C/tspan%3E %3C/text%3E %3Ctext y='448.07883' x='94.428757' transform='rotate(-5.9402)'%3E %3Ctspan y='448.07883' x='94.428757'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='437.60687' x='155.08846' transform='rotate(-1.4626)'%3E %3Ctspan y='437.60687' x='155.08846'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='276.66531' x='405.13382' transform='rotate(29.499)'%3E %3Ctspan y='276.66531' x='405.13382'%3EP%3C/tspan%3E %3C/text%3E %3Ctext y='409.79309' x='232.09538' transform='matrix(.99340 .11468 -.11468 .99340 0 0)'%3E %3Ctspan y='409.79309' x='232.09538'%3EI%3C/tspan%3E %3C/text%3E %3Ctext y='132.08934' x='530.39215' transform='rotate(46.586)'%3E %3Ctspan y='132.08934' x='530.39215'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='218.51869' x='464.15771' transform='rotate(36.816)'%3E %3Ctspan y='218.51869' x='464.15771'%3ET%3C/tspan%3E %3C/text%3E %3Ctext y='361.96112' x='313.72498' transform='rotate(16.412)'%3E %3Ctspan y='361.96112' x='313.72498'%3EM%3C/tspan%3E %3C/text%3E %3Ctext y='123.24773' x='513.7041' transform='rotate(47.66)'%3E %3Ctspan y='123.24773' x='513.7041'%3EG%3C/tspan%3E %3C/text%3E %3C/g%3E %3Cg stroke='%23fff700' stroke-linecap='round' stroke-width='1pt' fill='none'%3E %3Cpath d='m255.94 200.94s6.04-5.17 10.34-5.32'/%3E %3Cpath d='m256.81 200.22c0.14-0.14 36.05-5.17 37.19-6.32'/%3E %3Cpath d='m256.95 200.51c0.14-0.15 40.21-3.45 40.21-3.45'/%3E %3Cpath d='m256.81 200.65s42.65-2.01 45.24 0.15'/%3E %3Cpath d='m256.66 200.51s41.8 0.29 42.52 1.29'/%3E %3Cpath d='m256.81 200.51l40.21 3.3'/%3E %3Cpath d='m256.38 200.8c0.14 0 40.93 3.59 44.95 8.76'/%3E %3Cpath d='m303.48 216.88c-0.14-0.14-13.93-16.52-47.25-16.23'/%3E %3Cpath d='m256.38 200.94s23.12 1.58 30.44 9.62'/%3E %3Cpath d='m256.81 200.65s14.93-2.87 30.59 15.95'/%3E %3C/g%3E %3Cpath d='m247.4 217.74s20.72 0.82 20.72 2.85-15.44 5.89-15.64 14.42 11.78 9.14 12.59 19.9c0.81 10.77-9.34 12.39-11.37 15.24-2.04 1.42-6.91 16.65-6.3 25.59s3.25 39.2 7.92 45.3c3.66 2.84 9.14 11.98 15.03 9.14 5.89-2.85 1.83-13.2 1.22-16.05-0.61-2.84 2.44-7.51 2.44-11.78s-2.24-7.72-2.03-8.73c0.2-1.02 16.45 3.86 15.43 19.9-1.01 16.05-7.51 11.17-7.51 11.17s2.03 19.71-3.05 22.35c-9.14 4.87-15.84-1.02-15.84-1.02l0.86 4.01-6.95-3.6s-8.94-12.8-10.97-18.49c-2.03-5.68-4.47-31.07-3.66-36.56 0.81-5.48 1.42-37.58 1.02-39.2-0.41-1.63-2.03-28.44-1.02-32.5 1.02-4.06 7.31-21.94 7.11-21.94z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient801)'/%3E %3Cpath d='m225.06 212.46s14.42-14.01 22.75-12.39c4.26 0 0.2 3.05 0.2 3.05s7.31 0.61 8.33 3.86c0.2 1.42-3.46 1.83-3.46 1.83s3.05 0.61 3.25 3.25c0.21 2.64-30.87 0.6-31.07 0.4z' stroke='%23000' stroke-width='1pt' fill='%23ff7000'/%3E %3Cpath d='m225.87 211.85s15.44-2.03 21.94-8.53' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m241.51 207.59s11.37-0.41 11.37 1.22' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m281.93 373.74s9.75-2.24 12.39-5.69c1.63-1.22 10.16 12.8-12.39 5.69z' stroke='%23000' stroke-width='1.25' fill='%23FFF'/%3E %3Cpath d='m279.29 293.1s1.22 7.52-2.23 12.59c-1.83 2.03-7.32 5.49-7.32 7.93 0 2.43 2.03 5.68 1.63 8.53-0.41 2.84-3.45 5.69-3.25 8.12 0 2.44 3.45 15.44 3.04 15.64' stroke='%23FFF' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m261.42 268.73s-7.72 2.64-9.35 10.36' stroke='%23FFF' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m258.16 207.59s2.65 7.31 11.18 0.4c-5.49-7.51-11.18-0.2-11.18-0.4z' stroke='%23000' stroke-width='1pt' fill='%23c75b00'/%3E %3Cpath d='m264.87 206.47c0 0.39265-0.40924 0.71095-0.91405 0.71095s-0.91405-0.3183-0.91405-0.71095c0-0.39264 0.40924-0.71094 0.91405-0.71094s0.91405 0.3183 0.91405 0.71094z' transform='translate(-.40625 .8125)'/%3E %3Cpath d='m188.41 190.62s16.18 17.51 26.65 17.32c1.9 5.14-4.76 9.92-7.42 12.2-5.33-1.71-10.15 0.31-22.52-14.91 0.77-9.71 3.48-14.23 3.29-14.61z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m210.3 149.89c2.09-6.47 6.28-11.61 9.89-12.18-0.95-4.95 7.62-26.83 32.55-35.21 1.52 11.23-10.66 22.27-10.66 22.27s36.73-6.28 44.15-15.61c-0.76 4.19-8.18 30.26-47.39 30.07 14.85 14.09-4.75 25.32-13.13 21.89 15.42-11.8-4.37-18.84-15.41-11.23z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m222.86 140.76c7.42-4.76 10.08-4.76 16.18-3.81-4.38 0.57-4.38 0.76-4.38 0.76s-0.38 0.57 2.28 3.05c-3.04-0.77-5.71-2.48-14.08 0z' stroke='%23CCC' stroke-width='1pt' fill='%23cccccd'/%3E %3Cpath d='m220 137.71s14.66-7.8 22.84-13.13' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m207.44 220.12s20.18 5.52 22.46-23.41c-4.38-12.56-10.47-39.59-1.14-47.39-8.57-5.9-17.89 0.19-17.89 0.19-0.57 1.33-8.19 12.18 2.09 31.21-24.36-6.47-14.46 16.56-14.46 16.56 0.95-3.62 13.89-7.04 17.13 11.42 1.33 4.57-8.76 11.61-8.19 11.42z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m230.09 196.9s21.32-11.42 20.74-38.25c-18.08 0.38-24.55 23.78-24.55 23.78l3.81 14.47z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m134.55 195.57s-15.79 13.7-24.74 9.32c-6.66 4-14.462-3.04-14.462-3.04s9.132 33.68 41.872 9.32c-0.57-7.42-2.29-15.03-2.67-15.6z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m109.62 204.32c1.33-7.04 6.85-10.47 11.23-3.81 5.9 1.15 11.8-23.02-9.14-19.03 5.9-31.59-11.795-43.39-11.795-43.39s-6.28 35.02-3.426 41.49c2.855 6.47-4.186-11.99-26.834-17.13-0.381 26.46 25.312 38.83 25.312 38.83s7.233 6.66 14.653 3.04z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m111.71 181.29s-9.89 8.38-7.61 19.8' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m96.68 180.15s-2.284 8.18 2.664 19.79' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m95.157 202.61s4.568-7.42 14.463 2.09' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m97.06 151.22c0-0.19-15.034 0-6.09 15.23-6.661 2.09-21.505-7.61-11.228-20.56-33.686-0.76-47.389-16.93-47.389-31.78 9.897 10.28 33.496 6.09 41.87 12.37-10.277-9.51-8.184-22.65-8.184-22.65s28.738 8.57 33.876 34.07c-1.713 4.95-2.474 13.7-2.855 13.32z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m73.942 125.82c5.546 5.64 19.795 7.33 27.028 13.61' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-width='.94781' d='m80.503 142.47s11.797-1.52 15.216 2.66c-4.616 0-6.155-1.14-12.822 1.34 1.88-0.96 1.367-2.67 2.393-2.67s-4.274-1.33-4.787-1.33z' stroke='%23CCC' fill='%23cccccd'/%3E %3Cpath d='m139.31 50.166s6.47-5.71 13.51-0.571c-3.18 9.507-14.65 5.9-14.65 5.9s0.38 4.758-0.76 7.041c2.29 1.727 4.18 7.423 4.18 7.423s11.8-2.855 14.28 2.284c4.52-0.624 7.8 0 7.8 0s9.14-2.284 12.37-2.284c3.24 0 13.51 2.664 14.46 4.567 0.96 1.903 4.38 14.655 6.67 14.464 2.28-0.19-5.52 3.045-7.62-0.19-2.09-3.236-1.52 4.187-1.52 4.187s6.47 6.851 7.23 8.373c0.76 1.52-3.99 13.89-0.38 22.46-3.17 0.29-3.42 3.61-3.42 3.61-0.18 3.77-4.95 4.76-4.95 4.76l-1.14-5.14-3.24 1.91 1.33-4s4.38-10.66 4.76-14.08c0.38-3.43-4-9.52-7.42-9.52-3.43 0-5.9 10.85-5.9 10.85s-1.71 8.18-1.14 8.94-2.29-2.66-2.29-2.66-1.52 4.95-2.66 6.47-3.62 2.09-3.62 2.09-1.71-4.95-1.14-6.85 9.33-9.32 8.57-14.65c-0.77-5.33 0-4-0.2-4.19-0.19-0.19-4.56-3.996-4.75-6.089-0.19-2.094-5.71 2.664-12.94 1.141-2.22 3.868-2.48 13.508-2.48 13.508s-0.76 11.61 0.76 12.95c1.53 1.33-3.8 4.18-3.8 4.18l-3.81 5.14s-1.33-3.23-1.33-3.04-2.67 1.9-2.67 1.9l1.53-3.81c-0.1-2.88 3.7-10.75 3.7-17.41s0.48-13.798 0.48-13.798-7.04-0.381-6.85 6.848c0.19 7.24-1.71 7.62-1.33 9.71s2.28 7.99 1.71 9.71c-0.57 1.71-2.85 2.28-2.85 2.28l-0.57 0.95s-7.04 3.24-6.85 4.57-0.19-3.81-0.19-3.81l-0.39-5.52s4.19-2.66 4.19-9.32-0.96-7.61-0.77-9.13c0.19-1.53 1.15-7.05 0.96-7.62-0.19-0.571-3.99 1.522-5.14 1.522-1.14 0 2.1-3.996 2.48-6.851s-3.81 2.664-7.23-0.571c1.59-3.514 3.99-4.568 4.37-7.232s-2.66 2.284-5.33 0.381c0.22-2.554 2.86-4.758 2.86-4.758s-2.17-0.266-3.05 0c-1.71-0.571 1.91-3.236 2.1-7.042s-2.1-5.329-2.1-5.519-3.8-3.426-4.37-4.758-0.57-2.855-0.57-2.855-6.29 4.568-13.71-5.138c6.8-5.803 14.09-1.523 14.09-1.523s1.9-5.329 10.65-4.948c8.76 0.381 10.47 5.329 10.09 4.758z' stroke='%23000' stroke-width='1pt' fill='%23923f00'/%3E %3Cpath d='m187.19 148.61c0.15 0 16.16 0.48 16.32 9.04 0.16 8.55-4.91 6.34-5.07 6.34s-11.73-1.43-11.73-1.43l0.48-13.95z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m171.65 146.23s19.97-0.15 18.86 8.56c-1.11 8.72-6.18 6.98-6.18 6.98l-9.67-0.8-3.01-14.74z' stroke='%23000' stroke-width='1pt' fill='%23fffeff'/%3E %3Cpath d='m160.4 145.28l11.57 0.95s6.97 0.95 6.66 7.61c-0.32 6.66-7.14 6.82-7.14 6.82l-11.25-0.64 0.16-14.74z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m133.3 148.61c-0.16 0-16.17 0.48-16.33 9.04-0.15 8.55 4.92 6.34 5.08 6.34s11.73-1.43 11.73-1.43l-0.48-13.95z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m148.83 146.23s-19.97-0.15-18.86 8.56c1.11 8.72 6.18 6.98 6.18 6.98l9.67-0.8 3.01-14.74z' stroke='%23000' stroke-width='1pt' fill='%2300F'/%3E %3Cpath d='m160.09 145.28l-11.57 0.95s-6.98 0.95-6.66 7.61 7.13 6.82 7.13 6.82l11.25-0.64-0.15-14.74z' stroke='%23000' stroke-width='1pt' fill='%23FFF'/%3E %3Cpath d='m191.07 241.51s8.32-12.26 11.83-10.95c3.06 1.02 0.73 10.51-0.73 11.39l-11.1-0.44z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath d='m134.04 243.7c-2.62-3.65-6.42-13.72-9.92-10.95-3.07 1.02-0.73 10.51 0.73 11.39l9.19-0.44z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath d='m139.55 219.45s16.21 9.99 21.53 10.25 22.18-12.97 22.18-12.97' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m141.11 180.29l3.11-3.89 15.57 7.91 15.82-7.01 3.11 3.25-17.64 12.45-19.97-12.71z' stroke='%23000' stroke-width='1pt' fill='%235e0043'/%3E %3Cpath stroke-linejoin='round' d='m128.75 180.08c1.26 1.59 11.32 13.82 13.14 23.94 1.81 10.12-1.04-13.88-1.04-13.88s12.45 6.1 12.84 9.99 5.95-0.26 6.22-0.93l-36.05-23.41 4.89 4.29z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath stroke-linejoin='round' d='m190.26 179.38s-13.1 17.25-11.54 36.05c-2.7-9-0.52-23.86-0.52-23.86l-2.85 1.82s-2.98 12.71-6.75 14.65c-0.63-1.51-0.51-2.07-0.51-2.07s-4.02 5.18-4.8 5.7 0.26 17.51 0.26 17.51 1.35 12.32 2.9 12.19c-1.77 0.86-3.94 2.21-3.94 2.21l-1.61-32.88 3.68-3.7s4.93-5.96 5.32-11.8c-2.14 1.82-4.54 2.34-4.54 2.34s-0.65 8.3-2.59 9.46c-1.95 1.17-2 3.34-2 3.34l-0.46-10.85 29.95-20.11z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath d='m160.3 199.35l2.54 51.87' stroke='%23000' stroke-linecap='round' stroke-width='1.25' fill='none'/%3E %3Cpath d='m128.4 224.12s5.96 3.51 8.17 14.14c19.45-1.43 25.55 5.45 25.55 5.45s15.95-7.65 23.35-6.23c2.59-5.44 9.98-12.45 9.98-12.45' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m120.26 173.28l40.04 26.2 36.06-24.25s7.52-4.15 6.87-7.13c-0.64-2.99-3.24-1.82-4.54-1.3-1.29 0.52-37.74 26.33-37.74 26.33l-38.78-24.52s-2.85-0.9-3.37 0.91c-0.52 1.82 1.07 2.85 1.46 3.76z' stroke='%23000' stroke-width='1pt' fill='%23b4b6b9'/%3E %3Cpath stroke-linejoin='round' d='m191.87 166.48s-10.25-4.35-10.25-0.58c0 3.76 0.29 4.15 1.94 6.57 1.64 2.41-1.26 3.96-1.26 3.96s-0.39-1.06-0.97-2.71c-0.58-1.64-6.09-2.8-6.57-4.73-0.48-1.94 1.16-5.03-2.13-5.41-3.28-0.39-6.47 1.35-7.15 5.12s-4.93 12.56-4.93 12.56l0.58-20c7.22 0.51 20.62 2.09 30.93 3.28-3.09-0.48 1.16 0.2 1.07 1.26-0.29 0.87-1.36 0.96-1.26 0.68z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath stroke-linejoin='round' d='m155.62 161.45c-1.83 0-11.02 1.06-13.34 2.42-2.32 1.35 3.77 3.47 3 5.31s-0.87 5.51-3.77 4.74c-2.9-0.78-12.66-5.61-12.95-7.25s-2.32-1.74-2.32-1.74 28.03-3.77 29.38-3.48z' stroke='%23474747' stroke-width='1.25' fill='%23474747'/%3E %3Cpath d='m160.04 159.15l-0.07 24.58' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m141.11 130.19s-11.23 18.23-11.45 18.79' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m161.8 129.74s4.89 6.67 4.33 8.56c2 1.56 4.23 7.79 4.23 7.79' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient746)'/%3E %3Cpath d='m180.7 128.63s-10.56 14.9-10.23 16.01' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z' transform='matrix(1.0161 .31118 -.30126 1.0495 15.15 -41.141)'/%3E %3Cpath d='m126.5 56.748c0 0.79388-1.1339 1.4375-2.5327 1.4375s-2.5327-0.64357-2.5327-1.4375c0-0.79388 1.1339-1.4375 2.5327-1.4375s2.5327 0.64357 2.5327 1.4375z' transform='matrix(-1.0161 .31118 .30126 1.0495 242.3 -41.435)'/%3E %3Cpath stroke-linejoin='round' d='m254.49 366.13s-3.92 0.74-3.79 1.1c0.12 0.37-11.39 0.74-11.63 0.37-0.25-0.37-1.72 1.96-1.72 1.96l1.84-1.1s2.81 2.93 3.67 2.69-0.37 1.1-0.12 1.35c0.24 0.24 1.1-0.49 1.1-0.49l19.02-0.32-8.37-5.56z' stroke='%23000' stroke-width='1pt' fill='%23ff7000'/%3E %3Cpath stroke-linejoin='round' d='m261.58 372.05l-15.54 0.45s-3.91 3.55-4.16 4.4c-0.24 0.86 2.57 1.1 2.57 1.1l0.86 2.94 1.96-0.73s13.21 1.96 25.34-0.74c6.12-2.14 7.19-4.71 2.9-6.27-4.28-1.56-13.81-1.09-13.93-1.15z' stroke='%23000' stroke-width='1.25' fill='%23ff7000'/%3E %3Cpath d='m208.37 403.93l27.97-1.25-5.21-4.42 75.65-3.05-2.61-6.01-84.7 3.4 10.19 4.76-22.88 0.68 0.68 2.38-6-0.23s6.68 2.6 6.91 3.74z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient794)'/%3E %3Cpath d='m239.73 249.42c-2.23-1.11-12-2.44-22.89 4.67l0.45 25.11s15.99-8.67 23.77-6.67c-0.45-7.78-0.45-17.77-1.33-23.11z' stroke='%23000' stroke-width='1pt' fill='url(%23linearGradient800)'/%3E %3Cg stroke='%23000' stroke-width='1pt' fill='none'%3E %3Cpath d='m85.074 325.65l-65.956 65.48'/%3E %3Cpath d='m114.47 326.13l-53.532 70.5'/%3E %3Cpath d='m112.08 307.73l-71.455 86.51'/%3E %3Cpath d='m38.474 393.04l6.93-8.12'/%3E %3Cpath d='m125.7 351.22l-27.722 38.24'/%3E %3Cpath d='m96.783 394.48l0.717 14.57'/%3E %3Cpath d='m138.36 364.6l-29.39 36.81'/%3E %3Cpath d='m133.11 398.54l11.95-19.6'/%3E %3Cpath d='m137.65 375.12l-14.34 16.25'/%3E %3Cpath d='m133.35 359.83l-9.8 11.94'/%3E %3Cpath d='m120.68 342.38s-29.871 43.73-29.393 47.32'/%3E %3Cpath d='m117.57 336.65c-0.71 0.47-25.805 33.69-25.805 33.69'/%3E %3Cpath d='m90.331 380.85l-4.541 5.5'/%3E %3Cpath d='m80.055 394.72l-6.93 9.08'/%3E %3C/g%3E %3Cpath d='m81.811 225s-2.024 6.36 0 9.54c2.023 3.18 14.743 28.91 14.743 28.91s8.676-10.7 11.856-10.99c3.18-0.28 1.73 27.76 1.73 27.76s-5.2 4.91-8.38 4.62c-3.182-0.29 7.8 10.99 7.51 20.53s-14.45 56.95-19.654 57.81c-5.203 0.87 2.313-8.67 2.024-11.27s-1.735-0.87-2.891-3.76 1.735-7.23 1.156-10.12c-0.578-2.89-3.18-2.31-3.469-4.33-0.289-2.03 1.735-2.6 1.446-4.92-0.289-2.31-3.469-1.73-3.18-3.76 0.289-2.02 0.578-1.15 0.289-4.91s-0.867 2.6-4.047 2.89-5.782 7.52-5.782 7.52-6.36 8.96-12.72 4.91c3.758 8.1 0.868 11.57-0.578 11.85-1.445 0.29 1.156 6.36-2.313 6.65s2.602 13.59-1.445 14.75c4.336 2.02 0.867 4.62 0.867 4.62s-10.02 0.84-7.805 13.88c-29.487-10.41-43.941-28.33-43.652-46.54 0.2893-18.22 6.071-34.69 20.236-40.76 4.047-15.04 10.985-31.23 10.985-31.23s-1.156-6.65-0.289-10.98c0.868-4.34 4.915-8.67 4.915-8.67s-0.579-10.41-0.289-15.61c0.289-5.21 2.312-7.52 2.601-10.41s-0.867-17.64 2.024-20.24 8.383-2.31 11.274-4.04c2.891-1.74 6.649-4.92 10.407-4.63s6.938 2.89 6.938 2.89 14.166 0 15.033 5.49c0.867 5.5-2.891 7.52-2.891 7.52s2.024 7.81-6.649 15.03z' stroke='%232b2b2b' stroke-width='1pt' fill='%238a9396'/%3E %3Cpath d='m69.666 206.45c0 0.95295-1.5933 1.7255-3.5588 1.7255s-3.5588-0.77251-3.5588-1.7255c0-0.95295 1.5933-1.7255 3.5588-1.7255s3.5588 0.77251 3.5588 1.7255z' transform='matrix(.87942 -.47604 .47604 .87942 -90.31 56.579)' stroke='%232b2b2b' stroke-width='1pt' fill='%23cecfcf'/%3E %3Cpath d='m66.68 206.44c0 0.35596-0.44597 0.64453-0.99609 0.64453-0.55013 0-0.99609-0.28857-0.99609-0.64453 0-0.35597 0.44597-0.64453 0.99609-0.64453 0.55013 0 0.99609 0.28856 0.99609 0.64453z' transform='matrix(1.0784 0 0 1.4848 -5.0735 -100.09)'/%3E %3Cpath d='m87.971 216s3.511 15.68-0.687 26.5' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.051 209.14s6.85 9.06 5.966 20.33' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.714 207.15c0.221 0 5.745 4.86 5.524 8.17' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m91.04 205.16s3.757 2.65 4.64 5.3' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m89.272 203.61s-13.479 21.88-11.711 35.58' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m90.156 202.95s-17.899 10.61-21.213 45.3' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m88.167 209.36l-7.071 5.3' stroke='%23000' stroke-width='1pt' fill='none'/%3E %3Cpath d='m62.314 250.24s9.943-41.32 27.621-47.29' stroke='%232b2b2b' stroke-width='.625' fill='none'/%3E %3Cpath d='m96.785 264.16s9.505-11.93 11.715-11.49 1.54 27.62 1.54 27.62-7.07 5.3-8.61 5.08c-1.551-0.22 7.95 12.82 7.73 17.68s-0.44 4.86-0.44 4.86 0-2.87-2.21-7.51-0.89-9.95-15.249-21.66c-3.536-7.29 7.071 4.42 9.279 2.65 2.21-1.76-3.976-17.01-3.755-17.23z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m79.893 196.96s-3.994 1.09-4.539 2.72c-0.545 1.64-2.905 3.27-4.176 2.72-1.271-0.54-3.632-2.54-3.632-2.54' stroke='%232b2b2b' stroke-width='1pt' fill='none'/%3E %3Cpath stroke-linejoin='round' d='m57.196 210.94s-5.992 5.99-3.086 6.72c2.905 0.72 5.992-4.72 5.992-4.72s0 9.26 2.542 7.8c2.542-1.45 9.986-6.71 9.986-6.71s2.542-0.19 3.087 0c0.545 0.18 6.9 5.62 11.076 3.63-2.36 6.17-5.084 6.9-5.084 6.9s-4.358 5.63-9.986 4.35c-5.629-1.27-7.082-3.63-7.082-3.63s-4.721 0.37-6.174-1.81c-1.452-2.18-1.997-3.45-1.997-3.45s-2.723 2.72-3.45 1.45c-0.726-1.27 0-8.72 4.176-10.53z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath d='m91.151 202.59s-11.076-3.27-14.889 2.18c-3.813 5.44-2.905 8.53-0.908 9.07' stroke='%232b2b2b' stroke-width='1pt' fill='none'/%3E %3Cpath d='m92.86 202.28c0 1.3059-0.93488 2.3645-2.0881 2.3645s-2.0881-1.0586-2.0881-2.3645 0.93488-2.3645 2.0881-2.3645 2.0881 1.0586 2.0881 2.3645z'/%3E %3Cpath d='m60.624 230.54s4.517 6.95 9.902 8.86-3.735 3.56-9.12-0.08c-3.908-5.3-2.866-9.12-2.866-9.12s1.042-1.05 2.084 0.34z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m99.275 271.54s-12.681-17.63-16.329-18.59c-3.648-0.95 2.779-1.73 6.688 2 3.908 3.73-1.042-6.08-1.042-6.08l10.683 22.67z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m59.409 373.42c4.863-1.3 26.056 12.16 30.833 15.55 4.777 3.38 14.768 1.21 14.768 1.21s-4.61 2.78-7.472 3.48c-2.866 0.69 8.512 0.69 8.512 0.69s-27.099 7.47-54.632-7.03c-2.519-11.29 5.906-13.81 7.991-13.9z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath d='m90.416 275.88s-3.561-0.69-5.385-2.78c-1.824-2.08-4.43-7.21-7.122-9.38-2.693-2.17-16.155-9.55-21.019-9.03s-6.341-0.52-6.949-1.13-2.605 0.26-2.258 2.78c0.348 2.52-3.735 8.08-2.258 10.68 1.476 2.61 8.425 13.2 9.815 13.55 1.389 0.35 0.521 6.17 0.521 6.17s6.166 6.25 7.73 6.6c1.563 0.35 3.126 1.48 2.953 2.95-0.174 1.48-6.775 9.56-6.775 9.56s-7.122 3.73-7.209 5.82c-0.087 2.08 1.737 6.42 7.383 7.81 5.645 1.39 20.845 0.26 21.627-1.04 0.781-1.3 1.997-9.12 1.476-9.9s-4.256-3.13-6.167-2.78c-1.91 0.35-3.647 1.91-3.474 2.26 0.174 0.35-2.692 1.82-2.692 0.43s5.645-7.64 6.166-7.12c0.522 0.52 8.512 1.3 9.989 5.3 1.476 3.99 1.476 6.86 5.645 6.43 4.169-0.44 9.987-4.26 10.507-12.25s-4.687-13.38-5.99-14.16-5.646-3.39-5.993-4.6c-0.348-1.22-1.216-5.21-0.521-6.17z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m15.286 311.15s13.463-3.48 16.937-3.39c3.474 0.08 16.589 6.16 20.411 9.9 3.821 3.73 11.638 12.59 16.763 11.81 5.124-0.78 6.601-1.82 6.601-1.82l-1.998 3.82s-4.169 1.13-6.253 0.61c-2.085-0.52-6.167-1.83-10.249-5.82-4.082-4-16.676-14.77-27.359-13.99-10.684 0.79-16.85 11.3-16.85 11.3s0.087-5.13 0.521-6.26-2.258 2.43-2.258 2.43l3.734-8.59z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m64.88 321.57c0.087 0.08 3.388 0.95 8.946 0.95 5.559 0 8.512-2.43 8.512-2.43l-0.347-2.17 0.868-3.04s4.256 4.34 4.169 5.21-1.737 1.22-1.737 1.22l-0.608-2.09-1.476 1.83s-8.078 6.42-12.507 5.47c-4.43-0.96-8.512-3.82-7.383-4.52 1.129-0.69 1.737-0.43 1.563-0.43z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m45.251 332.95s-4.864-0.09-7.035 0.95-2.953 2.35-4.43 2.17c-1.476-0.17-2.605-2.08-2.171-2.86 0.608-1.22 3.474-2.78 8.946-2.35 5.472 0.44 4.69 2.09 4.69 2.09z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath d='m62.275 346.15c0-0.26-0.348-7.12-3.04-9.9-2.693-2.78-5.993-2.78-7.47-2.44-1.476 0.35 5.472 3.39 6.167 5.39s2.953 7.56 2.345 8.95c-0.608 1.38-1.737-3.91-5.993-5.39s-10.162-0.69-8.946 1.22 5.993 0.17 8.425 4.25 4.256 8.43 4.256 8.43l0.782-2.96 2.171-0.6 0.26-5.65 1.043-1.3z' stroke='%232b2b2b' stroke-width='1pt' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m58.801 368.38l-4.43-8.86s-1.39-5.64-5.124-7.21c-3.735-1.56-8.686-1.3-8.773 0.61s7.991 4.34 8.512 5.39c0.521 1.04 0.261 2.78-0.434 2.86-0.695 0.09-4.256-1.3-6.08-0.87-1.824 0.44-2.866 2.78-5.559 2.09-2.692-0.7-4.951-9.29-3.908-10.16 1.042-0.87-1.998 1.56-2.606-0.7s0.869-9.29-0.174-10.16c-1.042-0.87-6.079-3.91-6.166-4.52-0.087-0.6 0.26-34.56 28.662-6.42-12.16-14.42-16.937-12.86-19.195-12.94-1.65 0-12.681 0.95-15.46 15.02-2.78 14.07-6.08 5.3-6.08 5.3s-0.608 6.08 2.345 7.82c2.953 1.73-1.39 6.77-1.39 6.77s-5.2978-12.94-4.5161-18.59c-1.0423 4.52-0.9554 15.72 5.7321 27.97 7.817 8.25 15.2 15.9 34.829 24.49 10.336-15.8 9.815-17.71 9.815-17.89z' stroke='%232b2b2b' stroke-width='1.25' fill='%232b2b2b'/%3E %3Cpath stroke-linejoin='round' d='m40.214 368.47s5.732 0.69 7.295 3.65c1.564 2.95 2.259 7.47 2.259 7.47 0.955-1.91 1.389-3.56 3.3-4.95s3.301-1.57 3.214-2.61-6.08-7.38-9.12-7.73-8.338 3.3-8.338 3.3-0.955 1.39 1.39 0.87z' stroke='%232b2b2b' stroke-width='1.25' fill='%238a9396'/%3E %3Cg stroke-width='1.25' stroke-linecap='round' fill='none'%3E %3Cpath d='m53.307 383.41s14.856 6.77 39.324 7.21' stroke='%238a9396'/%3E %3Cpath d='m102.9 314.45s-1.27 12.47-10.861 37.07' stroke='%232b2b2b'/%3E %3Cpath d='m100.99 322.12s-2.879 8.95-10.869 15.66' stroke='%232b2b2b' stroke-linecap='butt' stroke-width='1pt'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 27 18'%3E %3Crect fill='%230D5EAF' width='27' height='18'/%3E %3Cpath fill='none' stroke-width='2' stroke='%23FFF' d='M5,0V11 M0,5H10 M10,3H27 M10,7H27 M0,11H27 M0,15H27'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800' viewBox='0 0 3600 2400'%3E %3Ctitle%3EFlag of Equatorial Guinea%3C/title%3E %3Crect width='3600' height='2400' fill='%23e32118'/%3E %3Crect width='3600' height='1600' fill='%23fff'/%3E %3Crect width='3600' height='800' fill='%233e9a00'/%3E %3Cpath d='M0,0V2400L900,1200z' fill='%230073ce'/%3E %3Cg stroke='%23000'%3E %3Cg id='shield'%3E %3Cpath fill='%23fff' stroke-width='4.8' d='M1608,958.8H1991V1360C1991,1495 1815,1391 1800,1463C1774,1389 1609,1496 1609,1352C1609,1212 1608,958.8 1608,958.8z'/%3E %3Cpath fill='%2373452b' d='M1827,1399C1827,1399 1822,1404 1813,1400C1804,1396 1803,1143 1803,1143C1823,1121 1839,1114 1839,1114C1839,1114 1851,1124 1851,1124C1806,1147 1810,1180 1814,1237C1815,1258 1815,1285 1820,1311C1827,1344 1841,1372 1842,1393C1843,1406 1827,1399 1827,1399z'/%3E %3Cpath fill='%2373452b' d='M1796,1108H1814C1799,1253 1812,1339 1812,1381C1812,1395 1820,1400 1819,1400C1801,1420 1792,1399 1792,1399z'/%3E %3Cpath fill='%23a36629' d='M1768,1399C1751,1407 1749,1391 1750,1389C1787,1314 1803,1149 1769,1131C1769,1131 1771,1115 1771,1115C1784,1119 1796,1136 1796,1136C1801,1321 1796,1397 1793,1400C1775,1419 1768,1397 1767,1395'/%3E %3Cpath fill='none' d='M1767,1396C1764,1380 1793,1339 1791,1296'/%3E %3Cpath fill='none' d='M1816,1331C1825,1356 1829,1378 1827,1399'/%3E %3Cpath fill='%23009a3b' d='M1855,1040C1861,1033 1861,1033 1872,1033C1874,1018 1899,1018 1901,1037C1921,1033 1925,1045 1917,1057C1936,1052 1953,1057 1948,1079C1982,1088 1969,1112 1954,1117C1952,1132 1938,1137 1919,1131C1895,1148 1881,1142 1870,1125C1843,1129 1841,1123 1829,1108C1808,1117 1804,1117 1786,1106C1785,1120 1780,1116 1771,1115C1772,1133 1765,1141 1749,1135C1761,1160 1730,1171 1715,1150C1701,1151 1700,1147 1693,1142C1687,1162 1665,1159 1661,1148C1633,1144 1636,1129 1659,1128C1661,1112 1675,1115 1684,1117C1685,1107 1691,1109 1696,1111C1693,1104 1695,1100 1704,1098C1691,1081 1699,1075 1712,1069C1705,1053 1717,1054 1726,1053C1725,1036 1730,1033 1748,1031C1746,1025 1749,1020 1759,1020C1753,1003 1761,999.1 1779,1002C1782,977.3 1835,989 1831,1023C1846,1025 1851,1028 1855,1040z'/%3E %3Cg fill='none' stroke='%23000'%3E %3Cpath d='M1748,1031C1752,1033 1757,1031 1758,1042C1766,1028 1776,1036 1776,1052'/%3E %3Cpath d='M1831,1023C1827,1029 1812,1029 1814,1045C1809,1038 1799,1036 1795,1043'/%3E %3Cpath d='M1855,1040C1855,1044 1854,1056 1850,1062'/%3E %3Cpath d='M1917,1057C1918,1058 1903,1057 1896,1062'/%3E %3Cpath d='M1954,1117C1950,1115 1942,1110 1936,1118C1936,1114 1936,1103 1925,1103'/%3E %3Cpath d='M1919,1131C1919,1121 1917,1118 1915,1115'/%3E %3Cpath d='M1886,1117C1878,1111 1870,1120 1870,1125'/%3E %3Cpath d='M1828,1108C1828,1104 1825,1096 1832,1093'/%3E %3Cpath d='M1714,1150C1716,1140 1723,1140 1722,1135C1721,1127 1712,1120 1701,1131'/%3E %3Cpath d='M1722,1135C1728,1133 1734,1134 1736,1137'/%3E %3Cpath d='M1705,1098C1709,1094 1719,1095 1725,1098'/%3E %3Cpath d='M1725,1074C1730,1074 1739,1072 1742,1081C1753,1064 1761,1066 1763,1070'/%3E %3Cpath d='M1783,1068C1791,1065 1805,1073 1813,1087C1817,1076 1823,1078 1829,1077'/%3E %3Cpath d='M1867,1087C1880,1081 1888,1093 1892,1098C1898,1090 1903,1090 1909,1090'/%3E %3Cpath d='M1746,1111C1749,1106 1756,1105 1761,1108C1760,1099 1766,1095 1770,1097'/%3E %3C/g%3E %3C/g%3E %3Cg id='stars' fill='%23ffd700' stroke-width='3.5'%3E %3Cpath d='M1787,902.6 1765,903.6 1754,923.3 1742,904.5 1720,905.4 1730,885.6 1718,866.8 1741,865.8 1751,846.1 1763,864.9 1785,864 1775,883.8z'/%3E %3Cpath d='M1693,909.9 1671,915.3 1665,936.6 1649,920.6 1628,925.8 1634,904.5 1619,888.3 1640,883 1646,861.6 1662,877.6 1684,872.4 1677,893.8z'/%3E %3Cpath d='M1602,928.6 1582,938.5 1581,960.7 1562,948.5 1542,958.3 1544,936.1 1525,923.8 1545,913.8 1547,891.6 1565,903.8 1585,894 1584,916.2z'/%3E %3Cpath d='M1816,902.6 1838,903.6 1848,923.3 1860,904.5 1882,905.4 1872,885.6 1884,866.8 1862,865.8 1851,846.1 1839,864.9 1817,864 1827,883.8z'/%3E %3Cpath d='M1910,909.9 1931,915.3 1937,936.6 1953,920.6 1974,925.8 1968,904.5 1984,888.3 1962,883 1956,861.6 1940,877.6 1919,872.4 1925,893.8z'/%3E %3Cpath d='M2000,928.6 2020,938.5 2021,960.7 2040,948.5 2060,958.3 2059,936.1 2077,923.8 2057,913.8 2056,891.6 2037,903.8 2017,894 2019,916.2z'/%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff' stroke-width='3.5'%3E %3Cpath d='M2027,1352 2052,1388 2075,1354 2059,1325z'/%3E %3Cpath d='M1868,1457 1870,1493C1870,1493 1880,1493 1889,1490C1897,1487 1904,1481 1904,1481L1903,1462z'/%3E %3Cpath d='M1734,1457 1732,1492C1732,1492 1723,1492 1714,1490C1706,1488 1699,1483 1699,1483L1689,1459z'/%3E %3Cpath d='M1573,1352 1547,1388 1519,1342 1540,1320z'/%3E %3Cpath d='M1698,1529C1698,1563 1904,1563 1904,1529V1481C1904,1506 1698,1501 1698,1481z'/%3E %3Cpath d='M1514,1418C1532,1510 1698,1512 1698,1512C1698,1512 1698,1481 1698,1481C1694,1469 1701,1465 1728,1461C1739,1460 1734,1444 1734,1444C1734,1444 1662,1457 1611,1437C1542,1409 1532,1355 1532,1355C1532,1355 1527,1397 1514,1418z'/%3E %3Cpath d='M2087,1418C2070,1510 1904,1512 1904,1512C1904,1512 1904,1481 1904,1481C1907,1469 1900,1465 1873,1461C1862,1460 1868,1444 1868,1444C1868,1444 1940,1457 1991,1437C2059,1409 2067,1355 2067,1355C2067,1355 2074,1397 2087,1418z'/%3E %3Cpath d='M1527,1383C1481,1358 1517,1332 1521,1258C1528,1303 1579,1322 1573,1351C1552,1352 1542,1320 1532,1355C1532,1355 1527,1383 1527,1383z'/%3E %3Cpath d='M2074,1383C2120,1357 2082,1332 2078,1258C2071,1303 2021,1322 2027,1351C2047,1352 2057,1320 2067,1355C2067,1355 2074,1382 2074,1382z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m1555,1417,5,4-11,12c-4.4031,4.8033-5.4674,7.9808-2.4093,10.905,3.7958,3.6295,6.4648,2.3682,10.409-1.905l12-13,4,4-11.989,13.989c-6.5084,7.5942-12.55,5.8563-17.618,1.1231-4.4158-4.1237-6.9466-10.102-0.4536-17.454l12.1-13.6z'/%3E %3Cpath d='m1575,1434,5,3-1,24,11-17,5,3-16,26-6-3,1-24-11,17-5-3z'/%3E %3Cpath d='m1584,1476,14-28,5,3-13,27z'/%3E %3Cpath d='m1606,1452-11.04,28.98,11.04,4.02c10.29,3.75,15.12-0.78,18.39-9.48,3.3-8.85,1.86-15.36-8.43-19.5l-9.96-4.02zm3.96,7.02c10.35,3.6,10.98,7.53,8.16,14.64-2.73,6.75-5.28,9.39-15.12,4.32l6.96-18.96z'/%3E %3Cpath d='m1639,1463-18,27,6.96,2.04,4.02-7.02,12,3,1.02,7.02,6.96,0.96-6.96-31.98-6-1.02zm1.98,7.02,1.98,12-7.98-1.02,6-10.98z'/%3E %3Cpath d='m1656.1,1465.6-1.0838,30.99,11.772,0.2309c10.941,0.2072,14.051-5.6204,14.318-14.91,0.2713-9.4506-3.2083-15.154-14.298-15.716l-10.708-0.5955zm6.0026,5.3771c10.964,0.044,12.838,3.5434,12.453,11.195-0.3657,7.273-1.9548,10.588-12.884,8.9686l0.4302-20.164z'/%3E %3Cpath d='m1761,1509v31.98h7.02v-12s6,0.36,10.98-0.96c3.93-1.02,6.66-3.54,6.75-9.75,0.09-6.09-3.45-9.27-9.57-9.27h-15.2zm7.02,4.98,7.05,0.09c5.88,0,4.77,8.91,0.18,8.91h-7.23v-9z'/%3E %3Cpath d='m1797,1509-13.02,31.98h7.02l3-7.98h13.02l3,7.98h6.96l-13-32h-7zm3,7.02,4.98,12h-9l4.02-12z'/%3E %3Cpath d='m1817,1535,17-21-15,0,0-5,24,0,0,5-18,21,18,0,0,6-26,0z'/%3E %3Cpath d='m1918,1473,6-1,3,18c1.0669,6.4013-1.8581,10.764-6.4144,12.445-5.1887,1.9138-11.806,0.1639-12.586-8.4449l5-1c1.1649,5.1523,3.2378,5.5985,5.6366,4.791,1.9038-0.6409,2.8885-3.6406,2.3634-6.791z'/%3E %3Cpath d='m1928,1471.2,5.9209-1.1228,2.7393,14.979c1.1722,6.4098,3.1827,9.1354,7.3509,8.4077,5.1735-0.9034,5.741-3.8003,4.6402-9.5106l-3.6807-15.98,6.0571-0.9143,4.0192,16.623c2.3505,9.7215-2.7285,13.578-9.5455,14.851-5.9392,1.1094-12.253-0.3988-14.322-9.9873z'/%3E %3Cpath d='m1959,1485,5-2c2.4529,4.4051,6.2799,4.1782,9.2549,2.8632,4.133-1.8269,4.6059-5.4402,2.5625-6.6628-2.9146-1.7438-9.8689,0.7328-13.615-0.6341-4.482-1.6353-6.4062-4.1562-6.1771-8.0319,0.2759-4.6664,4.3807-7.231,8.8456-8.6157,4.996-1.5495,9.9262-1.0022,13.129,5.0813l-6,2c-1.9531-3.2866-4.4662-3.1313-6.6964-2.0777-1.8668,0.882-4.784,2.5382-3.222,5.2058,1.2767,2.1802,8.6258,0.7645,12.498,0.9228,4.0034,0.1636,7.2389,2.8362,7.7805,6.6867,0.7551,5.3683-1.2338,8.2764-7.4407,10.697-7.6662,2.9898-14.582-0.3597-15.919-5.4346z'/%3E %3Cpath d='m1986,1460-8,4-2-5,22-9,2,4-8,4,9,22-5,3z'/%3E %3Cpath d='m1999,1449,5-3,14,26-5,3z'/%3E %3Cpath d='m2033,1451,6-2c2.8215,5.9317-1.4152,16.715-11.775,16.493-15.164-0.3249-16.805-17.027-14.421-22.536,4.0051-9.252,15.224-9.0747,20.196-3.957l-5,4c-3.1698-4.0667-10.212-1.5041-10.688,2.2374-0.7756,6.1053,1.9122,11.788,7.371,14.483,4.6287,2.2846,11.761-3.4602,8.3165-8.7202z'/%3E %3Cpath d='m2030,1430,5-4,18,24-5,4z'/%3E %3Cpath d='m2049,1415-4.98,4.02,10.98,30,4.98-4.98-3-6,9-8.04,6,3,5.04-3.96-28.02-14.04zm1.98,7.02,10.02,4.98-6,6-4.02-10.98z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600'%3E%3Crect width='900' height='600' fill='%23ED2939'/%3E%3Crect width='600' height='600' fill='%23fff'/%3E%3Crect width='300' height='600' fill='%23002395'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='450' height='300' viewBox='0 0 3 2'%3E %3Crect width='1' height='2' fill='%23ce1126'/%3E %3Crect width='1' height='2' x='1' fill='%23fcd116'/%3E %3Crect width='1' height='2' x='2' fill='%23009460'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 27 18'%3E %3Ctitle%3EFlag of The Gambia%3C/title%3E %3Cpath d='m0,0h27v18H0' fill='%233A7728'/%3E %3Cpath d='m0,0h27v11H0' fill='%230C1C8C'/%3E %3Cpath d='m0,0h27v6H0' fill='%23CE1126'/%3E %3Cpath d='m0,6.5h27m0,5H0' stroke='%23FFF'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 18 12'%3E %3Crect width='18' height='12' fill='%23fff'/%3E %3Cpath fill='%23d00c33' d='m0,6h18v6H0zm3,0a4,4 0 0,0 8,0a4,4 0 0,0-8,0'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='500' viewBox='0 0 512 256'%3E %3Crect fill='%23da000c' width='512' height='256'/%3E %3Crect fill='%23fff' width='512' height='171.5'/%3E %3Cg stroke='%23000'%3E %3Cg id='castle_half' fill='%23da000c' stroke-linecap='square'%3E %3Crect fill='%23000' stroke='none' width='64' height='43.992859' x='196.57106' y='116.30338'/%3E %3Cpath d='M229.81889,153.86465H190.75L182.08989,159.56444V165.60411H229.81889'/%3E %3Cpath d='M213.46875,128.59375C219.09357,128.59375 223.6875,133.28303 223.6875,139.0625V153.84375H231.03125V97.84375H190.75V153.84375H203.25V139.0625C203.24999,133.50878 207.76491,128.59375 213.46875,128.59375z'/%3E %3Crect fill='%23000' stroke='none' width='18.523308' height='33.9594' x='204.5282' y='59.961655'/%3E %3Cpath d='M223,88.65625H206.79108V82.90625H194.90625V88.65625H186.84375V82.90625H182.03125V93.34375H223M186.84375,93.306038H221.81414V97.843752H186.84375z'/%3E %3Cpath d='M200.71875,47.625V82.90625H206.79108V73.21875C206.79108,69.589448 209.35314,66.619386 212.9375,66.4375C213.05312,66.431633 213.16418,66.4375 213.28125,66.4375C217.02763,66.437497 220.0625,69.472374 220.0625,73.21875V82.90625H225.84375V47.625z'/%3E %3Cpath d='M198.53125,42.84375V47.625H227.78125V42.84375z'/%3E %3Cpath d='M194.78125,33.6875V42.84375H229.875V33.6875H224.46875V38.34375H217.9375V33.6875H207.96875V38.34375H201.4375V33.6875z'/%3E %3Cpath d='M182.08989,159.56444H230'/%3E %3Cpath d='M261,156.8125H228.5625L218.78125,161.53125V168.5625H261'/%3E %3Cpath stroke-linecap='butt' d='M218.771,161.51923H262'/%3E %3C/g%3E %3Cuse xlink:href='%23castle_half' transform='matrix(-1,0,0,1,512,0)'/%3E %3Cg fill='%23f8d80e'%3E %3Cg stroke-linecap='round'%3E %3Cpath stroke-width='0.768' d='m273.297,150.031c-2.65428,0.88339-5.05329,2.369-7.46888,3.75283-3.1004,1.83163-6.10683,3.82731-8.90451,6.09885-0.98462,0.64912-1.92929,1.36065-2.68911,2.27332-1.02583,0.8776-2.06486,2.05478-1.86885,3.51297,0.0518,0.64315,0.87359-0.75523,1.41401-0.82297,0.94235-0.54095,2.0838-0.7154,3.14219-0.4713,1.27117-1.33857,2.90994-2.23563,4.3249-3.40609,3.00467-2.24222,6.23664-4.16769,9.52502-5.96082,1.1481-0.58838,2.30104-1.18568,3.52508-1.60184-0.33328-1.12498-0.66657-2.24997-0.99985-3.37495z'/%3E %3Cpath d='M260.40041,157.3913V161.3032'/%3E %3Cpath d='M262.81691,155.68544V159.56821'/%3E %3Cpath d='M265.23339,154.17984V158.03797'/%3E %3Cpath d='M267.64986,152.69367V156.67498'/%3E %3Cpath stroke-width='0.768' d='m238.891,150.156c-0.39583,1.10417-0.79167,2.20833-1.1875,3.3125,5.53699,2.10036,10.8089,4.87874,15.7978,8.06036,1.69067,1.15075,3.46718,2.26632,4.79593,3.84589,0.2927,0.81098-0.51392,1.48903-1.31413,1.24403-0.73225-0.24871-1.45351-0.53169-2.22629-0.004-1.10637,0.50311-2.10598,2.1416-0.42575,2.69112,2.31528,1.55489,6.08158,0.87915,7.19454-1.84522,0.58146-1.40134,0.61878-3.19523-0.50753-4.34456-2.06261-2.36404-4.79728-4.00804-7.4215-5.67182-4.68917-2.82023-9.57283-5.37389-14.7055-7.28801z'/%3E %3Cpath d='M254.04985,158.03521 253.73747,161.37469'/%3E %3Cpath d='M256.8319,159.73914 255.96991,163.00882'/%3E %3Cpath d='M259.80442,162.01152 257.99552,164.54884'/%3E %3Cpath d='M260.71528,168.18078 258.10512,166.78032'/%3E %3Cpath d='M261.52792,165.42898 258.53251,165.70943'/%3E %3Cpath d='M257.66497,169.7646 257.45987,167.13228'/%3E %3Cpath d='M256.56809,166.75559 254.09509,168.57779'/%3E %3Cpath d='M244.67669,152.9368V156.05184'/%3E %3Cpath d='M250.96338,156.24386V159.77805'/%3E %3Cpath d='M247.82004,154.59318V157.9121'/%3E %3C/g%3E %3Cpath d='M235.78125,227.5625V235.59375H240.8125V231.5625H247.65625V235.59375H253.0625V227.5625zM235.78125,238.625V246.6875H253.0625V238.625H247.65625V242.65625H240.8125V238.625z'/%3E %3Crect width='4.9902272' height='58.115017' x='253.05186' y='193.65144'/%3E %3Crect width='4.9902272' height='50.060368' x='253.05186' y='198.6788'/%3E %3Cpath stroke-width='1.024' d='M255.54688,179.40625 266.17188,185.59375 255.54688,191.75 244.92188,185.59375zM241.32813,183.375H238.54688V187.8125H241.32813L255.54688,196.0625 269.76563,187.8125H272.54688V183.375H269.76563L255.54688,175.125z'/%3E %3Cpath stroke-width='1.024' d='m255.344,164.281c-2.41872,0.33922-4.22593,2.73018-4.09375,5.13412,0.009,3.73773-0.0185,7.47634,0.0141,11.2135,0.12824,2.40829,2.23219,4.56615,4.6744,4.58823,1.98493,0.18804,3.97892-0.97232,4.81154-2.77961-0.57292-0.34375-1.14583-0.6875-1.71875-1.03125-0.44378,1.18388-1.72345,1.91762-2.96875,1.78125-1.63507,0.046-2.95917-1.54398-2.8125-3.13412,0.01-3.71344-0.0192-7.42801,0.0146-11.1407,0.0899-1.5151,1.53488-2.75487,3.04795-2.60016,0.6265-0.17973,1.48748,0.67715,1.8747-0.0623,0.5838-0.82944-0.41442-1.47737-0.96875-1.9374-0.61348-0.0841-1.25418-0.008-1.8747-0.0316zm5.78125,3.90625c-0.39638,0.7459-1.21626,1.18923-1.875,1.58041v7.51334c0.66667,0.38542,1.33333,0.77083,2,1.15625-0.008-3.20377,0.0153-6.40813-0.0117-9.61152-0.0315-0.19722-0.008-0.4984-0.11328-0.63848z'/%3E %3C/g%3E %3Cg fill='%23da000c'%3E %3Crect fill='%23000' stroke='none' width='29.328571' height='53.254513' x='240.80301' y='38.351128'/%3E %3Cpath d='M238.75,38.375V82.9375H248.0625V69.71875C248.0625,66.669822 250.01501,62.4375 256,62.4375C261.98499,62.4375 263.9375,66.669822 263.9375,69.71875V82.9375H273.25V38.375zM254.5625,43.375H257.4375V58.625H254.5625zM246.3125,46.375H249.21875V57.53125H246.3125zM262.78125,46.375H265.6875V57.53125H262.78125z'/%3E %3Cpath d='M235.59375,31.96875V38.3125H276.40625V31.96875z'/%3E %3Cpath d='M231.75,24.59375V31.96875H280.25V24.59375H274.15625V28.65625H267.28125V24.59375H259.4375V28.65625H252.5625V24.59375H244.71875V28.65625H237.84375V24.59375z'/%3E %3Cpath d='M222.75,97.84375V102.4375H289.25V97.84375z'/%3E %3Cpath d='M220.03125,82.90625V97.84375H291.96875V82.90625H285.15625V88.65625H276.09375V82.90625H263.9375V88.65625H248.0625V82.90625H235.90625V88.65625H226.84375V82.90625z'/%3E %3Cpath stroke-linejoin='round' d='M228.6875,102.4375V156.78125H241.53125V136.4375C241.53125,126.85477 247.92755,122.34375 256,122.34375C263.75894,122.34375 270.46875,126.85477 270.46875,136.4375V156.78125H283.3125V102.4375z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect width='450' height='300' fill='%23006b3f'/%3E %3Crect width='450' height='200' fill='%23fcd116'/%3E %3Crect width='450' height='100' fill='%23ce1126'/%3E %3Cpath d='M225,100 257.492,200 172.427,138.197H277.573L192.508,200z' fill='%23000'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg%3E %3Csvg width='900' height='600' viewBox='-18 -12 36 24' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Crect x='-18' y='-12' width='36' height='24' fill='white'/%3E %3Cpath d='M 0,-12 v 24 M -18,0 h 36' stroke='%23e8112d' stroke-width='6' fill='none'/%3E %3Cpath id='arm' d='M -9,2 l 1,-1 h 9 v -2 h -9 l -1,-1 z' fill='%23f9dd16'/%3E %3Cuse xlink:href='%23arm' transform='rotate(90)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(-90)'/%3E %3Cuse xlink:href='%23arm' transform='rotate(180)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg width='900' height='600' xmlns='http://www.w3.org/2000/svg' id='Flag of French Guiana'%3E %3C!-- This file is in the public domain --%3E %3Cpolygon fill='%23078930' points='0,0 900,0 900,600' /%3E %3Cpolygon fill='%23FCDD09' points='0,0 900,600 0,600' /%3E %3Cpolygon fill='%23DA121A' id='pentagram' transform='translate(450,300) scale(100) rotate(0)' points='0,-1 0.587785252292473129168705954639072768597652,0.809016994374947424102293417182819058860155 -0.951056516295153572116439333379382143405699,-0.309016994374947424102293417182819058860155 0.951056516295153572116439333379382143405699,-0.309016994374947424102293417182819058860155 -0.587785252292473129168705954639072768597652,0.809016994374947424102293417182819058860155' /%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 300 200'%3E %3Cdefs%3E %3Cg id='smallcross'%3E%3CclipPath id='vclip'%3E%3Cpath d='M-109,104 a104,104 0 0,0 0,-208 H109 a104,104 0 0,0 0,208 z'/%3E%3C/clipPath%3E%3Cpath id='varm' d='M-55,74 a55,55 0 0,1 110,0 V-74 a55,55 0 0,1 -110,0 z' clip-path='url(%23vclip)'/%3E %3Cuse xlink:href='%23varm' transform='rotate(90)'/%3E%3C/g%3E %3C/defs%3E %3Crect width='300' height='200' style='fill:%23fff'/%3E %3Cpath d='m 130,0 0,80 -130,0 L 0,120 l 130,0 0,80 40,0 0,-80 130,0 0,-40 -130,0 L 170,0 130,0 z' style='fill:%23ff0000' /%3E %3Cuse xlink:href='%23smallcross' transform='translate(64.45,39.45)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(235.55,160.55)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(235.55,39.45)' fill='%23f00'/%3E %3Cuse xlink:href='%23smallcross' transform='translate(64.45,160.55)' fill='%23f00'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='360' viewBox='0 0 500 300'%3E %3Cdefs%3E %3Cg id='s'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-1 v 1 h .5' transform='rotate(18 0,-1)' fill='%23fcd116'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/defs%3E %3Crect width='500' height='300' fill='%23ce1126'/%3E %3Crect x='42' y='42' width='416' height='216' fill='%23007a5e'/%3E %3Cpath d='M 42,42 h 416 l -416,216 h 416 z' fill='%23fcd116'/%3E %3Ccircle cx='250' cy='150' r='36' fill='%23ce1126'/%3E %3Cuse xlink:href='%23s' transform='translate(250,150) scale(33)'/%3E %3Cuse xlink:href='%23s2' x='-100'/%3E %3Cuse id='s2' xlink:href='%23s' transform='translate(250,21) scale(19.5)'/%3E %3Cuse xlink:href='%23s2' x='100'/%3E %3Cuse xlink:href='%23s2' x='-100' y='258'/%3E %3Cuse xlink:href='%23s2' y='258'/%3E %3Cuse xlink:href='%23s2' x='100' y='258'/%3E %3Cpath d='M 67.749,150.41 c 4.504,8.39 13.265,17.52 20.916,20.73 c .123,-8.52 -2.9,-19.44 -7.034,-28.14 l -13.882,7.41 z' fill='%23ce1126'/%3E %3Cpath d='M 60.112,121.63 c 6.529,13.61 -16.933,46.08 22.156,53.69 c -4.822,-6.58 -7.931,-17.44 -6.755,-26.16 c 8.201,3.12 16.83,12.25 20.317,19.23 c 10.23,-37.15 -26.24,-34.89 -35.718,-46.76 z' fill='%23fcd116'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30' width='1200' height='600'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='830' height='498'%3E %3Crect width='830' height='498' fill='%2300ab39'/%3E %3Crect width='830' height='249' fill='%23fff'/%3Eheight='496.06' width='826.76' %3Cg transform='translate(1.72,0.97)' stroke='%23000' stroke-width='1.8'%3E %3Cpath d='M541.562,28.5625c-0.011,0.0194-0.019,0.0431-0.031,0.0625,0.033-0.0182,0.061-0.0443,0.094-0.0625h-0.063zm-0.031,0.0625c-52.242,28.8873-99.003,58.9451-144.969,97.25-22.06,19.27-15.833,34.631-16.687,51.937,0.711,11.618-2.511,22.426-9.656,28.938-16.35,3.306-32.715,6.632-49.063,9.938-1.566-4.524-3.121-9.042-4.687-13.563,1.495-6.94,7.232-10.352,19.312-6,0.952-8.923-6.227-12.555-14.625-15.656-2.885-2.246-6.468-3.971-6-11.688-1.412-17.467,26.615,1.25,26.875,1.25,0.261,0-0.934-17.627-13.812-21.156-7.022-2.485-9.994-9.892-7.313-15.375,5.618-11.209,16.194,0.878,24.282,1.312-0.304-7.316-2.387-12.531-8.688-18.437-3.392-2.087-11.722-3.657-11.938-7.156-0.176-4.752,7.808-6.784,18.782-5.469-2.288-6.6597-9.668-10.9678-19.813-14.0938-2-3.4786-4-6.9582-6-10.4374-2.841-5.26-4.115-5.4018,2.469-15.375,5.915-3.8266,13.774-9.2366,19.688-13.0626-2.176-0.261-4.357-0.5203-6.532-0.7812,0.869-7.1313,0.969-9.5307,2.625-21.375-6.346,8.6716-14.275,7.1213-21.406,10.6875,0,0-20.33,3.6092-26.875,12.25-0.261,0-51.125-2.5937-51.125-2.5937-10.84,1.5094-20.099,4.5822-21.906,15.125-24.792,2.5024-50.755,0.2888-69.657,24,12.87-0.6088,24.136-3.6738,38.594-1.8126,0,0,12.321,0.233,14.875,13.2808,0.261,0.522,4.188,0.532,4.188,0.532,1.566,1.217,3.121,2.439,4.687,3.656,0.609-1.652,1.204-3.317,1.813-4.9688,1.392,0.9568,2.795,1.9178,4.187,2.8748,0.434-1.826,0.879-3.6423,1.313-5.4685,1.392,0.9565,2.764,1.9184,4.156,2.8745,0.087-2.1736,0.195-4.3568,0.281-6.5308,1.827,1.3044,3.643,2.6019,5.469,3.9063v-8.5937s20.192-0.0472,26.344,12.7812c0.262,0.261-56.665,10.463-111.657,5.75,5.306-2.609,10.602-5.235,15.907-7.8438-20.05-4.0762-38.901-7.7612-56.594-21.6562,6.677,25.137,41.181,54.663,48.25,54.531,0,0.261-6.781-12.25-6.781-12.25,19.916,0.87,39.835,1.725,59.75,2.594,2.175,6.61,1.213,14.02,6.531,19.844,0,0-3.299,10.925,4.031,15.375,0.262,0.521,8.75-22.157,8.75-22.157s2.6,6.101,5.219,10.157c3.795-19.508,25.031-22.688,25.031-22.688s4.438,10.176,4.438,10.438c-6.636,0.96-14.89,14.486-10.438,21.906-4.45,0.085-12.351,13.186-9.906,20.344-3.741,3.723-13.058,8.686-10.688,24.281-7.334,1.572-11.676,14.991-9.406,29.219-11.349,10.564-8.563,29.956,1.563,37.812-4.203,3.74-6.791,6.616-6.781,11.219-3.996-1.485-7.68-0.244-9.407,2.375-4.898-5.021-11.931-9.418-16.937-4.719-1.296-5.94-9.032-12.474-17.5-11.718,0.496-6.264-2.755-14.018-11.719-16.719,0,0-1.814-29.358-10.719-38.875-0.873-5.326,0.51-8.948,7.844-13.313,7.323-3.906,8.879-6.935,8.344-18,2.887-7.396,5.08-14.936-3.906-20.062,0.27,8.795-2.43,13.031-6,16.937-4.266-0.621-5.756,4.358-8.626,6.532-4.016-5.414,8.472-13.799-0.781-25.844-0.521-0.523-6.459-15.723-21.125-15.375,6.971,4.082,9.92,10.951,9.906,18-4.624,13.045-6.973,23.127-2.343,38.093-6.093-9.128-9.549-26.482-14.594-29.5-4.422-0.862-6.582-11.321-23.75-8.343,7.4057,1.992,9.7571,7.647,11.75,12.781-4.541,2.342-2.285,8.519,1.0312,12.781-0.6296,10.015,5.3698,15.866,14.3438,19.594-1.478,13.653-2.96,27.283-4.438,40.937-3.564-0.454-9.05,13.425-11.2182,13.844-3.4888,2.171-9.5812,8.01-2.5938,9.656-2.0758,7.492-4.0012,12.009-15.1562,13.563,0,0,11.7874,6.991,21.5622-4.969,10.474-0.262,7.03-12.752,12.094-18.25,0-0.26,2.874-2.066,7.062-13.062,1.832,9.819,11.908,39.888,34.688,54.812,19.856,21.256,36.175,41.33,36,69.656,7.75-7.208,12.378-18.624,15.938-29.5,10.776-3.748,26.191-5.179,39.937-4.562-2.358,4.961-4.997,9.721-1.594,12.938-9.593,3.294-11.695,10.256-7.843,17.218-10.112,6.867-10.778,11.28-10.938,22.688-18.708,23.985-30.249,23.188-48.781,16.968-6.086-3.572-15.505-8.714-19.844-6-8.004-5.334-19.512-6.126-21.406,6,6.006-4.978,9.592-4.018,14.375,0.782-0.962,2.436-1.766,4.862,1.812,6.25-1.566,1.739-3.121,3.48-4.687,5.218-8.613-1.324-20.194-1.25-23.219,11.219,4.424-3.665,14.24-4.525,22.156-1.031,1.479,0.522,2.959,1.04,4.438,1.562,0.174,2,0.358,4,0.531,6,0,0-11.732-1.811-14.875,17.219,11-11.702,18.781-8.625,18.781-8.625,4.239,6.205,19.841,5.271,31.063-4.937,15.762-8.812,20.357,3.851,30.531-4.438,8.436-6.292,18.417-2.108,25.281,5.219,7.915,2.969,16.2,5.413,22.719,0,0,0,7.963-5.081,15.906,3.125,0.087-9.253-6.47-14.169-15.375-14.344l-2.625-2.625c-8.349-1.74-17.73-1.034-25.031-5.218,3.442-13.066,8.457-24.904,18.25-34.969,12.088-12.958,20.987-18.85,36.25-38.688-0.589,11.211,8.003,23.677,12.531,35.063,0,0,9.116-14.555,10.438-26.375,0.26,0,11.423-5.81,16.187-10.75,10.056,6.237,26.446-4.994,37.032-14.281,6.524,2.47,11.478,2.292,19.062,0-6.088,12.39,3.521,23.883,18.781,28.687,1.411,10.938,12.459,13.229,29.219,13.313,0.706,6.436,10.688,7.312,10.688,7.312-6.308,2.94-9.596,5.886-9.376,12.531-6.464,0.044-11.36,1.671-13.062,9.125-8.876,0.152-17.922,0.833-25.562,5.219-8.176-1.269-18.122-4.657-24.532-11.219-3.306-2.783-4.131-6.796-9.906-8.344-3.66-4.326-8.039-3.36-9.406,0.782-3.783-2.955-17.972-4.328-20.344,9.125,6.624-4.848,12.564-6.696,16.719-0.781-2.264,4.106,5.516,6.455,12.25,8.093,4.776,0.296,13.247,4.647,15.906,12-6.16,1.869-15.496,1.253-21.656-3.406-5.476-4.582-12.872-4.036-16.938-1.031-5.64-3.596-19.071,3.193-19.593,14.062,5.658-5.184,10.807-7.691,15.937-4.406-2.553,0.606-1.583,0.855-1.313,2.344,4.348,2.522,8.684,5.04,13.032,7.562-6.394,1.687-12.405,4.238-9.625,16.156,0,0,5.208-10.296,16.937-6.5,0.261-0.26,1.617,3.678,4.969,1.032,5.076-5.776,16.682-8.362,26.875-9.375,8.18-0.977,16.347-3.387,23.469,1.281,6.341-3.262,13.401-5.456,20.625-0.25,8.523,2.696,14.746,12.631,25.562,8.094,5.379-3.723,11.99-3.912,18.782,3.656,0.082-9.543-7.069-12.742-17.219-14.875-2.349-1.393-4.683-2.795-7.031-4.187-6.522-0.958-13.072,0.198-19.594-2.876,34.134-8.824,58.062-27.859,74.906-55.031,5.392,1.913,10.764,3.805,16.156,5.719,3.825,0.245,4.117,1.574,12,3.938,0.297-11.614-4.689-23.578-25.562-24.782l-27.406-10.437c-5.818-6.135-8.447-19.152-1.032-26.875,7.258-6.463,8.525-5.689,13.313-13.563,5.822-0.53,11.309,5.469,16.687,5.469,2.554,7.587,17.274,14.294,26.625,12,5.859,5.187,17.008,8.07,29.219,3.906,6.93,6.067,15.959,8.6,26.594,3.906,2.823,2.824,8.783,5.069,15.656,3.657,0.522,0,3.473,7.541,10.969,10.187-3.268,3.176-1.259,16.966,2.093,21.906-2.288,5.302-3.008,10.958-1.062,16.438-7.559,4.86-9.098,8.475-5.719,16.688-9.899,15.906-21.741,17.724-32.875,12.812-4.002-2.522-7.998-5.071-12-7.594-4.261-4.175-8.52-8.325-12.781-12.5-2.17-2.037-6.66-2.677-7.594,1.813,0,0-16.399-3.658-17.719,10.187,6.798-6.62,16.438-0.792,16.438-0.531s-2.296,1.823-0.531,4.469c0.397-0.331,11.973,4.32,22.281,8.75,5.6,2.122,6.831,2.786,9.281,4.094-2.685-1.23-5.858-2.623-9.281-4.094-6.275-2.379-12.388-4.279-14.188-3.813-5.84-0.545-12.034-1.27-14.874,3.125-6.278,2.656-16.084,4.783-15.657,16.438,4.239-6.94,10.055-6.647,17.469-6-0.174,0.522-0.326,1.04-0.5,1.562,8.05,3.667,6.523-0.998,14.031-1.687,6.277-0.576,15.174,1.672,19.875,3.25-5.913,1.739-13.954,1.009-17.75,5.219-0.696,1.392-3.131,0.823-2.062,4.156,0,0-11.534-0.298-14.625,15.656,11.728-7.509,20.615-7.281,20.875-7.281,0.261,0,3.656,0.781,3.656,0.781s14.084-9.406,14.344-9.406c0.262,0,13.638-5.923,19.812,0.781,5.389,2.649,11.153,2.818,16.719-0.531,10.966-4.77,21.231-5.104,31.313,1.594l9.124,5.468c1.304-0.869,2.603-1.755,3.907-2.625,0,0,10.329-2.917,17.906,6.281-3.132-15.914-14.5-16.437-14.5-16.437-0.87-0.783-1.756-1.561-2.625-2.344-5.392-2.087-10.764-4.194-16.156-6.281-2.354-5.826-8.268-10.465-2.375-17.469,6.02-29.926,13.218-52.401,1.562-82.719,10.871,4.696,19.005,19.217,32.625,14.094,0-12.176-44.822-35.294-79.062-53.875,56.094-2.87,123.51-44.277,97.594-96.906,4.088-12.697,8.162-25.397,12.25-38.094,5.77,11.623,17.453,20.483,27.937,24.25-8.641-16.496-13.6-66.93-8.625-101.75-22.603,27.922-47.563,52.7018-74.094,77.8748,13.05,3.05,24.453,0.904,37.063-0.656-3.566,7.305-7.029,14.632-10.594,21.938-34.473-20.188-74.947-5.038-75.25,21.906,1.179,31.42,40.027,35.885,62.437,24.937-4.442,28.647-70.281,18.094-70.281,18.094-23.394-8.064-45.613-6.683-70.187-6.5,5.106-15.71,33.46-29.652,55.062-23.5-30.243-33.909,4.275-76.008,45.906-88.969-45.376-14.9658-6.304-49.5575,27.657-74.3435,0,0-97.663,41.1007-106.563,40.9687-27.779-2.0867-20.207-34.9672-9.625-52.6562zm-306.531,39.4688c2.273,0.0119,4.945,0.2339,7.062,0.75,4.404,1.073,9.763,1.6886,9.688,3-2.039,3.4124-7.047,7.5288-11.969,7.2812-4.921-0.2476-7.766-3.1984-9.406-10.5938,0.503-0.2725,2.352-0.4494,4.625-0.4374zm411.094,115.875c6.403-0.088,14.074,2.621,21.562,10.562-3.6,10.371-34.842,15.697-36.937,0.344-0.633-4.641,6.016-10.779,15.375-10.906z' fill='%23d21034'/%3E %3Cpath d='m 267.26,158.74l4.737,6.891 m -0.215,0.217 c 0,0 0,9.259 1.938,9.476 m -4.307,4.952 c 0.215,0.216 4.954,8.184 4.954,8.184 m -13.569,2.153 c 0.215,0 6.031,6.677 6.031,6.677 m 5.051,-5.18 c 0,0.215 5.501,10.565 5.932,10.565 m -13.136,-3.447 c 0,0 1.938,12.491 3.66,12.061 m -11.801,10.828 5.556,8.339 m 4.738,-17.229 c 0,0 3.015,11.845 5.383,10.767 m 2.364,-17.879 c 0.216,0.215 5.606,7.974 7.112,6.897 m -1.291,3.014 5.168,10.338 m -13.783,-2.37 c 0.215,0.432 4.307,12.277 4.307,12.277 m -14.214,-6.03 c 0,0 3.877,13.137 7.323,10.982 m -8.83,6.462 c 0,0 0.215,6.891 3.661,7.321 m 2.37,-10.767 c 0,0.215 3.445,4.954 3.445,4.954 m 6.398,-13.149 2.862,4.534 m 6.246,-12.921 4.308,5.383 m -24.293,-67.137 c 0.215,5.815 9.437,-2.048 13.098,-7.002 m -17.018,27.19 c 0,0 10.122,-7.107 17.875,-17.875 m -21.106,34.889 c 7.107,-1.938 20.183,-17.753 22.767,-26.152 m -24.275,41.873 c 1.94,0.861 26.367,-16.732 27.014,-29.653 m -27.659,43.221 c 0,-0.215 22.33,-5.693 31.591,-30.244 m -32.79,48.826 c 0,0 35.657,-21.381 37.595,-37.102 m 240.77,73.006 c 0,0 -2.299,18.453 -20.82,21.252 m 26.635,11.699 c 0.215,-0.216 17.659,-19.383 13.137,-25.198 m 27.351,6.676 c 0,0 -0.215,13.353 -11.199,22.613 m 32.95,-18.735 c 0,0 0.432,16.151 -6.46,22.612 m 26.488,-12.922 c 0,0 -7.727,15.126 -10.526,16.634 m 10.191,10.173 c 0,0 10.167,2.534 13.397,-4.143 m -10.761,26.084 c 0,0 9.399,1.697 13.706,-7.347 m -14.714,24.284 c 0,0 7.607,6.391 12.776,-2.007 m -121.95,-122.44 c 0,0 -0.862,32.735 45.225,39.41 51.472,14.215 75.807,6.677 78.823,64.394 -1.938,21.967 -4.668,46.778 -20.604,37.301 M 464.552,286.27 c 0,0 7.323,13.136 16.152,12.275 11.629,-3.446 15.936,3.661 15.936,3.661 m -63.53,-2.8 c 0,0 19.383,9.476 35.964,-5.815 m -33.811,-7.753 c 1.722,22.613 -26.059,35.535 -37.043,33.382 m 38.36,53.27 c 0.216,0 15.05,-8.905 12.036,-15.152 m -41.566,1.94 c 0.431,-0.432 24.982,-2.801 29.505,-11.631 m -40.919,-24.552 c 0,-0.215 34.845,0.097 37.213,6.557 m 9.09,-27.231 c 0,0 -34.028,58.148 28.858,58.148 m -64.824,-59.01 c 0,0 -7.323,21.753 -17.66,29.074 m -18.52,-36.61 c 0,0 12.636,24.449 -0.071,36.509 m -32.879,-29.618 c 0.215,0.43 4.091,34.673 -4.524,44.364 m -11.843,-43.287 c 0,0 1.291,21.751 -5.169,29.504 -6.462,7.753 1.513,23.856 1.513,23.856 m -78.5,10.457 c 0,0 4.624,8.114 11.086,5.313 m -3.231,-23.042 c 0,0 10.337,4.522 13.783,2.799 m -2.584,-39.411 c 0,0 -15.291,4.307 -9.476,22.397 8.829,7.108 17.444,6.03 17.444,6.03 m -38.119,48.456 c -0.215,0 1.723,14.215 11.63,3.446 6.891,-14.428 28.643,-55.132 33.597,-69.131 m 10.121,-6.675 c 0,0 -10.553,-8.184 -10.121,3.23 -0.217,7.106 3.229,8.829 3.229,8.829 0.43,5.169 4.954,12.49 8.614,5.815 1.508,-6.461 -1.076,-9.261 -1.076,-9.261 m 6.03,-11.63 c -9.476,-0.646 -14.644,20.245 3.662,7.11 m 6.245,-14.216 c 0,0 -2.368,3.232 -6.03,-0.215 -1.939,-3.445 -8.829,15.507 3.231,16.152 2.153,-5.6 8.83,-7.107 8.83,-7.107 m 5.6,-17.875 c 0,0 -5.385,2.584 -7.323,2.153 -6.461,1.508 -5.17,16.584 3.014,15.722 2.799,-3.23 5.815,-7.753 5.815,-7.753 m -52.29,-29.83 c -0.216,0 -21.372,33.268 11.794,42.098 m 256.71,-92.175 c 0,0 -12.922,10.984 -0.862,28.643 -40.058,-0.645 -61.592,17.875 -63.315,30.365 -51.041,-3.66 -41.78,11.416 -58.364,16.368 -22.182,-18.521 -54.702,-8.183 -52.548,10.337 -14.861,-20.89 -37.688,-10.767 -40.487,-5.599 -2.8,5.169 -1.723,-25.628 -1.723,-25.628 0,0 -14.86,6.677 -25.199,18.952 0.217,-8.183 0,-21.536 0,-25.843 -12.418,2.512 -24.407,2.654 -37.257,2.369 m -33.596,-9.476 c 0,0 18.52,10.337 41.349,-3.661 m -42.857,-33.596 c 0,0 14.43,12.92 41.566,8.829 m -32.52,-38.55 c 0,0 3.229,10.553 34.243,11.199 m -23.74,-35.604 c 0,0 11.679,14.283 27.4,12.13 m -17.443,-32.52 c 0,0 4.522,7.753 21.751,9.045 m -11.631,-31.658 c 0,0 9.046,9.907 19.384,8.184 m 34.431,-88.698 c 0,0 4.006,-4.0053 10.682,-2.0026 m -13.573,23.142 c 0,0 -12.463,-0.4451 -11.573,-5.3405 0.892,-5.563 13.13,-9.5684 13.13,-9.5684 0,0 16.243,-10.458 18.691,-14.019 m -73.432,56.966 15.8,30.263 7.565,-11.349 4.006,7.788 6.453,-11.348 11.126,7.12 -4.228,-13.796 9.345,-0.667 c 0,0 -2.448,-6.676 -10.904,-8.011 2.226,-1.7803 10.014,-6.8983 10.014,-6.8983 0,0 -4.449,-5.118 -11.348,-5.3406 2.225,-2.4476 5.34,-8.4558 5.118,-8.4558 -0.222,0 -6.899,-1.5576 -6.899,-1.5576 0,0 15.8,5.1179 28.038,-2.0027 m -30.25,-24.467 c 0.222,0.2225 -0.891,6.2305 -4.229,9.791 m -56.742,6.8981 c 0,0 9.7742,-2.6898 17.088,-1.165 7.245,1.4888 16.958,4.0578 16.958,4.0578 0,0 11.57,-1.5576 15.354,-4.2279 m -73.656,7.7882 c 0,0 -1.334,4.6728 -1.779,7.7883 0,2.2252 -7.122,5.1181 -7.122,5.1181 m 13.353,-22.475 c 0,0 6.23,7.7881 6.452,12.238 0.223,4.4505 -4.672,7.7885 -4.672,7.7885 m -66.089,33.156 -6.454,-10.458 5.786,-2.003 m 117.2,156.72 c -5.168,-6.676 3.876,-109.19 23.044,-135.89 -6.676,48.241 15.506,97.558 21.105,97.343 m -102.4,-125.99 c 0,0 8.722,3.3378 26.812,-10.984 m 24.443,34.676 12.975,0.161 m 389.49,-80.51 c 0,0 -216.19,101.02 -219.34,106.37 36.505,-11.016 191.33,-36.82 195.11,-34.617 -9.126,2.203 -197,45.315 -205.81,55.701 46.889,-1.574 145.08,15.105 160.49,31.154 -33.358,-7.552 -133.12,-22.343 -163.64,-15.735 22.344,5.351 107.94,60.737 107.94,69.548 -12.902,-12.272 -115.81,-54.757 -119.9,-50.665 23.6,14.161 56.96,66.714 56.958,79.617 -6.923,-11.014 -66.4,-74.898 -69.861,-70.807 6.294,8.813 18.766,84.222 12.39,87.717 0,-9.126 -23.09,-75.129 -24.978,-77.017 -4.721,1.258 -34.152,80.528 -28.321,87.899 -3.776,-26.433 0.628,-81.604 7.866,-79.402 -12.901,1.888 -54.078,56.18 -49.673,64.677 1.259,-13.532 3.1,-22.507 26.386,-67.509 -25.805,1.572 -79.302,35.246 -88.43,47.204 7.239,-21.398 52.555,-57.59 72.381,-60.107 m 93.316,-78.747 c 22.85,-12.68 93.46,-38.557 140.56,-57.543 m -184.91,125.78 c 0,0 15.576,-0.222 31.153,-42.501 15.35,-57.85 137.07,-122.38 139.52,-134.4 m -376.67,235.07 c 0,0 -3.615,7.703 -8.066,9.929 m 25.525,1.744 c 0,0 -4.829,9.382 -5.942,13.832 m 22.65,-9.243 c 0,0 4.052,12.803 0.714,18.812 m -47.239,-52.053 c -12.238,6.899 6.964,50.494 65.041,54.722 m -9.346,-23.587 c 0,0 -1.557,7.788 9.346,23.365 -3.115,17.356 13.195,30.996 19.649,33.221 m -33.67,-213.01 c 0,-0.223 1.78,-4.673 1.78,-4.673 l 1.9836,5.1444 3.1933,-0.0834 2.1072,-5.1575 1.7301,5.1769 3.1729,0 1.9573,-5.7483 2.9571,5.4428 2.5111,0.12743 1.9776,-6.6295 4.0772,4.7487 1.4806,-0.57339 1.2699,-6.6313 4.0277,4.6378 1.1554,-0.67754 1.8676,-6.5354 3.3459,4.8596 1.6845,-0.54918 1.5632,-5.4927 3.1098,5.0477 m -50.532,8.149 24.274,-0.361 c 7.723,-0.115 20.442,-10.819 34.684,-7.481 m -110.12,59.774 c 0,0 4.005,8.679 9.569,3.783 m -18.914,2.003 c 0,0 -7.789,20.917 1.557,25.811 m -12.684,-48.954 c 0,0 0,4.895 10.236,-2.67 m -42.073,112.59 c 0,0 8.2332,2.448 6.8982,8.679 m -3.788,-104.81 c 0,0 5.1179,2.448 10.014,-5.117 m 44.282,245.89 c 8.01,-0.445 9.735,3.172 17.023,3.172 8.396,0.256 16.577,-3.172 27.259,-6.065 m 68.758,19.36 c -0.223,0 -3.783,7.565 -0.667,11.347 m -113.49,-10.68 c 0,0 12.685,-10.459 19.36,-4.005 6.454,2.226 10.013,1.78 10.013,1.78 m -22.69,-27.59 c 0,0 3.115,8.01 -7.344,6.898 m -3.115,11.571 c 0,0 6.675,4.229 -0.89,9.791 m 4.895,7.566 c 0,0 9.123,1.336 3.782,8.678 m 290.91,-64.115 c 0,0 24.776,2.564 25.915,4.415 2.849,-2.991 24.972,-20.911 -2.225,-23.473 -4.555,18.654 -23.263,19.343 -23.69,19.058 z m -8.828,12.388 c 9.255,7.404 5.463,11.841 34.513,-7.666 m -47.756,16.923 c 0,0 13.669,14.667 23.637,-3.134 m -49.695,8.402 -18.511,9.682 m -33.321,13.671 c 0,0 11.249,-9.683 16.518,-4.557 5.268,5.126 27.624,-4.413 27.624,-4.413 m -35.741,-33.037 c 0,0 3.846,7.689 -3.56,8.686 m -11.106,15.379 c 0,0 3.901,7.23 -3.646,9.223 m 12.332,10.428 c 0,0 11.677,0.569 7.547,9.397 m 101.67,-10.964 c 0,0 -6.408,5.411 -1.708,11.535 m 94.691,-50.408 c 0,0 7.404,3.559 -1.424,9.683 m -7.404,12.815 c 0,0 5.553,5.839 1.851,10.679 m 13.67,11.676 c 0,0 7.688,2.136 6.835,8.544 m 100.81,-14.239 c 0,0 -6.408,4.698 -2.99,10.822 M 551.9922,243.2931 c 15.38,-1.851 37.449,32.323 48.698,39.016 m 67.272,-87.425 c 0,0 7.7898,6.7994 0.9361,23.205 m 13.505,-49.366 c 2.167,1.686 10.539,6.154 16.069,16.496 m 5.312,-67.659 c 0,0.142 -10.822,29.191 -10.822,29.191 m 22.925,-30.615 c 0,0 -2.136,25.915 -5.268,31.184 m -42.957,47.223 c -3.6,10.371 -34.84,15.678 -36.935,0.32544 -1.0657,-7.8158 18.503,-19.872 36.935,-0.32544 z' fill='none' stroke-linejoin='round' /%3E %3Cpath d='m 234.76,68.178 12.02,2.225 c 0,0 -8.46,11.349 -12.02,-2.225 z' fill='%23000' stroke-linejoin='round' /%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600' viewBox='0 0 5 3'%3E %3Cdefs%3E %3CclipPath id='a'%3E %3Crect width='5' height='3' /%3E %3C/clipPath%3E %3C/defs%3E %3Cg clip-path='url(%23a)'%3E %3Crect width='50' height='30' fill='%230065BD' /%3E %3Cpath d='M 0,0 L 5,3 M 0,3 L 5,0' fill='none' stroke='white' stroke-width='0.6' /%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30' width='1200' height='600'%3E %3CclipPath id='t'%3E %3Cpath d='M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z'/%3E %3C/clipPath%3E %3Cpath d='M0,0 v30 h60 v-30 z' fill='%2300247d'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' stroke='%23fff' stroke-width='6'/%3E %3Cpath d='M0,0 L60,30 M60,0 L0,30' clip-path='url(%23t)' stroke='%23cf142b' stroke-width='4'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23fff' stroke-width='10'/%3E %3Cpath d='M30,0 v30 M0,15 h60' stroke='%23cf142b' stroke-width='6'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 25 15' width='800' height='480'%3E%3Crect width='25' height='15' fill='%23FFF'/%3E%3Cg fill='%23CE1124'%3E%3Crect width='3' height='15' x='11'/%3E%3Crect width='25' height='3' y='6'/%3E%3C/g%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300'%3E %3Crect fill='%233a75c4' width='400' height='300'/%3E %3Crect fill='%23fcd116' width='400' height='200'/%3E %3Crect fill='%23009e60' width='400' height='100'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='900' height='600' viewBox='0 0 3 2'%3E %3Crect width='3' height='2' fill='%23ED2939'/%3E %3Crect width='2' height='2' fill='%23fff'/%3E %3Crect width='1' height='2' fill='%23002395'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1100' height='800' viewBox='0 0 22 16'%3E %3Crect fill='%23FFF' width='22' height='16'/%3E %3Cg fill='%230065BD'%3E %3Crect x='6' width='4' height='16'/%3E %3Crect y='6' width='22' height='4'/%3E %3C/g%3E %3Cg fill='%23ED2939'%3E %3Crect x='7' width='2' height='16'/%3E %3Crect y='7' width='22' height='2'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='760' height='400' viewBox='-19 -10 38 20'%3E %3Crect x='-19' y='-10' width='38' height='20' fill='%2375b2dd'/%3E %3Cg id='star' transform='translate(0,-6)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-2 V 0 H 1' transform='rotate(18 0,-2)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23star' transform='rotate(90)'/%3E %3Cuse xlink:href='%23star' transform='rotate(180)'/%3E %3Cuse xlink:href='%23star' transform='rotate(270)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Cdefs%3E %3ClinearGradient id='gradbase' gradientUnits='userSpaceOnUse'%3E %3Cstop stop-color='%23a43907' stop-opacity='0.9961' offset='0'/%3E %3Cstop stop-color='%23fff' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='grad1' xlink:href='%23gradbase' x1='826.45044' y1='419.93194' x2='786.12402' y2='396.11032'/%3E %3ClinearGradient id='grad2' xlink:href='%23gradbase' x1='851.56865' y1='436.06697' x2='763.03312' y2='419.67318'/%3E %3ClinearGradient id='grad3' xlink:href='%23gradbase' x1='1016.1496' y1='398.53933' x2='974.91928' y2='400.94143'/%3E %3ClinearGradient id='grad4' xlink:href='%23gradbase' x1='1033.33547' y1='421.21868' x2='945.904' y2='428.64452'/%3E %3ClinearGradient id='grad5' xlink:href='%23gradbase' x1='1023.35736' y1='445.13212' x2='776.64586' y2='445.13212'/%3E %3ClinearGradient id='grad6' xlink:href='%23gradbase' x1='783.43027' y1='462.50282' x2='1144.08805' y2='465.42083'/%3E %3ClinearGradient id='grad7' xlink:href='%23gradbase' x1='1032.1278' y1='442.28699' x2='1002.94064' y2='444.03323'/%3E %3ClinearGradient id='grad8' xlink:href='%23gradbase' x1='775.74733' y1='471.7178' x2='803.90792' y2='476.1845'/%3E %3ClinearGradient id='grad9' xlink:href='%23gradbase' x1='803.17707' y1='466.88819' x2='755.30821' y2='440.32034'/%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2300247d'/%3E %3Cg stroke='%23000' stroke-width='1.8'%3E %3Cuse xlink:href='%23scroll' stroke='%23fff' stroke-width='12'/%3E %3Cg id='scroll' stroke-linejoin='bevel'%3E %3Cpath fill='url(%23grad1)' d='m826.45,427.735s-8.53598-13.8843-15.65-12.8926c-7.11256,0.99174-13.7516,9.91737-14.2266,10.4124-0.47347,0.49666-10.9063-11.4042-10.4329-11.9008,0.47498-0.49508,10.9078-26.2802,16.5985-27.272,5.69065-0.99174,17.9773,1.89709,17.9773,2.88882,0,0.99174,5.73375,38.7641,5.73375,38.7641z'/%3E %3Cpath fill='url(%23grad2)' d='m845.419,412.859c0,0.99174-2.84532,37.686-15.1751,50.5786-12.3297,12.8926-32.247,20.8265-39.3611,18.843-7.11255-1.98348-23.2361-39.1728-23.2361-39.1728s17.072,17.8513,29.8752,14.8761c12.8047-2.97521,20.3922-25.2901,22.7626-36.1992,2.37186-10.9091,0.47498-32.2323,0.47498-32.2323l24.6595,23.3066z'/%3E %3Cpath fill='url(%23grad3)' d='m973.576,427.735s8.53598-13.8843,15.65-12.8926c7.11256,0.99174,13.7516,9.91737,14.2266,10.4124,0.4734,0.49666,10.9063-11.4042,10.4328-11.9008-0.4749-0.49508-10.9078-26.2802-16.5984-27.272-5.69065-0.99174-17.9773,1.89709-17.9773,2.88882,0,0.99174-5.73375,38.7641-5.73375,38.7641z'/%3E %3Cpath fill='url(%23grad4)' d='m954.608,412.859c0,0.99174,2.84532,37.686,15.1751,50.5786,12.3297,12.8926,32.247,20.8265,39.361,18.843,7.1126-1.98348,23.2361-39.1728,23.2361-39.1728s-17.072,17.8513-29.8752,14.8761c-12.8047-2.97521-20.3922-25.2901-22.7626-36.1992-2.37186-10.9091-0.47498-32.2323-0.47498-32.2323l-24.6595,23.3066z'/%3E %3Cpath fill='url(%23grad5)' d='m788.945,407.482c-5.69068,6.94218-8.7289,12.308-11.1,16.275-2.3711,3.96694-0.97668,9.4873,4.5,17.3625,5.90463,8.48767,54.4484,41.6625,117.675,41.6625,63.2265,0,111.77-33.1748,117.675-41.6625,5.4766-7.87519,6.8336-13.3956,4.4625-17.3625-2.3711-3.96695-5.3719-9.33282-11.0625-16.275,0,10.4124-40.2141,48.0375-111.075,48.0375-70.8609,0.00002-111.075-37.625-111.075-48.0375z'/%3E %3Cpath fill='url(%23grad6)' d='m1008.25,476.741c0.9485-1.48681,10.9063-18.843,10.9063-18.843l-5.46-4.02724c-1.6768,4.90949-7.8182,6.50738-8.7666,12.4578s4.2688,11.9008,3.3203,10.4124z'/%3E %3Cpath fill='url(%23grad7)' d='m1018.15,471.371s1.8969-8.42897-4.2673-9.42071c-6.1656-0.99173-9.4293,4.71805-8.5359,2.47855,0.9921-2.48691,4.7422-4.95868,5.2156-13.3877,0.475-8.43056-0.4734-12.8926-0.4734-12.8926s2.3703-10.9107,12.3297-9.4223c9.9579,1.4884,10.4329,9.4223,10.4329,12.3975,0,2.97521-0.9485,4.46202-0.9485,4.46202l-13.7531,25.7852z'/%3E %3Cpath fill='url(%23grad8)' d='M791.773,476.741c-0.949-1.487-10.907-18.843-10.907-18.843l5.45999-4.02724c1.67684,4.90949,7.81819,6.50738,8.76663,12.4578s-4.26874,11.9008-3.3203,10.4124z'/%3E %3Cpath fill='url(%23grad9)' d='m781.873,471.371s-1.89688-8.42897,4.26723-9.42071c6.16563-0.99173,9.42936,4.71805,8.53597,2.47855-0.99208-2.48691-4.7422-4.95868-5.21567-13.3877-0.47498-8.43056,0.47347-12.8926,0.47347-12.8926s-2.37035-10.9107-12.3297-9.4223c-9.95788,1.4884-10.4329,9.4223-10.4329,12.3975,0,2.97521,0.94844,4.46202,0.94844,4.46202l13.7532,25.7852z'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m813.43,438.565-5.16779-3.55994-0.60012,0.95373,1.0182,0.84192,0.0874,0.5064-6.50543,10.3388-0.47909,0.11619-1.14073-0.6472-0.60011,0.95374,5.16779,3.55994c1.7705,1.21965,3.2807,1.84224,4.96633,1.66477,2.1944-0.22005,4.06492-1.49869,5.5102-3.7956,2.573-4.08915,1.85084-8.10322-2.25661-10.9327zm-2.1551,0.0781,1.02686,0.70737c2.8141,1.93856,3.06199,4.64992,0.75905,8.30989-2.30295,3.65997-4.79294,4.51187-7.60704,2.57332l-1.02686-0.70738,6.84799-10.8832z'/%3E %3Cpath d='m815.174,457.273,10.2685,5.13308,1.71686-3.76452-1.2992-0.64945-1.34262,2.06734-0.40209,0.21206-4.43568-2.21733,2.495-5.47071,2.48537,1.2424,0.1338,0.42897-0.50075,1.60932,1.12889,0.56432,2.22605-4.88099-1.12889-0.56431-0.88123,1.42089-0.4021,0.15932-2.48537-1.24239,2.2835-5.00695,3.80416,1.90164,0.12401,0.39771-0.55685,1.9961,1.33839,0.66904,1.50666-3.30361-9.63852-4.81815-0.47001,1.03059,1.11826,0.68907,0.17148,0.44781-5.11404,11.2134-0.45937,0.18343-1.21422-0.47866-0.47002,1.03059z'/%3E %3Cpath d='m828.786,462.999c1.10133,0.90962,2.37746,1.60988,3.66831,2.04514,3.30819,1.11547,5.93074-0.10665,6.74176-2.74783,0.40203-1.30927,0.12479-2.72592-0.79298-3.94194-0.93036-1.24359-1.89776-1.93807-2.39314-2.57005-0.85035-1.06996-1.21179-1.92674-0.89833-2.94757,0.37514-1.22168,1.55506-1.80204,3.02713-1.30568,0.64543,0.21763,1.07577,0.48438,1.37702,0.80593l0.18745,0.4065-0.36563,2.42474,1.45141,0.48939,1.10408-3.59557c-1.11994-0.91756-2.30851-1.61162-3.55962-2.03348-2.88374-0.97235-5.34572,0.30391-6.10202,2.7669-0.33434,1.08879-0.18493,2.33902,0.47776,3.51735,0.6348,1.1206,1.46794,1.81814,2.13759,2.53387,1.18703,1.28181,1.66823,2.32562,1.30052,3.52314-0.37514,1.22168-1.61594,1.78318-3.25016,1.23214-0.62476-0.21066-1.17546-0.51966-1.6786-0.90929l-0.16029-0.42066,0.49527-2.77265-1.53408-0.51727-1.23345,4.01689z'/%3E %3Cpath d='m839.509,467.153,6.02979,2.03315,0.33386-1.08727-1.3174-0.56586-0.21374-0.46369,3.63266-11.8302,0.41824-0.20227,1.38557,0.34388,0.33387-1.08728-6.02979-2.03316-0.33387,1.08728,1.29628,0.56041,0.22719,0.41989-3.63267,11.8302-0.43168,0.24606-1.36444-0.33842-0.33387,1.08728z'/%3E %3Cpath d='m852.462,454.82-0.23018,1.11771,1.19889,0.38514,0.26548,0.39304-2.50447,12.1613-0.40647,0.29156-1.24589-0.15694-0.23018,1.11771,5.84014,1.29106,0.23018-1.11771-1.24001-0.39261-0.25622-0.43806,1.05723-5.1337c0.12405,0.0274,0.2481,0.0549,0.35256,0.0779,2.0909,0.46223,2.42749,1.5624,2.62266,3.87132,0.10596,1.16768,0.0804,2.23648,0.9697,3.38743,0.40864,0.54317,1.11789,0.98561,2.00909,1.18263,0.64147,0.14181,1.35903,0.22902,2.10708,0.27591l0.2257-1.09598c-0.10283-0.0227-0.18607-0.0411-0.26932-0.0595-1.3874-0.3067-1.93731-0.78534-2.11449-2.13756-0.15871-1.2264-0.0697-2.49543-0.50599-3.64198-0.32473-0.83462-0.94066-1.42361-1.8829-1.89485,2.43941,0.0378,3.93433-1.01461,4.36656-3.11342,0.52174-2.53347-0.85301-4.26891-4.06362-4.97867l-6.29553-1.39173zm3.97754,2.23942,0.95323,0.21072c2.00765,0.44383,2.84759,1.72669,2.46236,3.5973-0.43255,2.10036-1.68585,2.82472-3.9008,2.33507-0.22851-0.0505-0.47661-0.10536-0.74113-0.18819l1.22634-5.9549z'/%3E %3Cpath d='m865.586,473.888,11.3628,0.56256,0.18257-4.16851-1.43933-0.0713-0.4684,2.45157-0.2915,0.35885-4.90839-0.24301,0.26531-6.0578,2.75023,0.13616,0.28257,0.3412,0.13837,1.6874,1.24753,0.0618,0.23671-5.40479-1.24753-0.0618-0.28532,1.66801-0.3111,0.31022-2.75024-0.13616,0.24282-5.54426,4.21124,0.20849,0.26193,0.31636,0.22707,2.06665,1.48102,0.0733,0.16021-3.65813-10.664-0.52797-0.05,1.14119,1.28576,0.1812,0.32426,0.34327-0.5438,12.4168-0.35488,0.35571-1.29596,0.0518-0.05,1.14119z'/%3E %3Cpath d='m885.562,460.702-0.039,4.12848,1.49873,0.0179,0.37128-2.49165,0.35057-0.29889,2.60866,0.0312-0.11983,12.6869-0.3735,0.36844-1.41418,0.0989-0.0108,1.14239,6.49852,0.0777,0.0108-1.14239-1.412-0.13272-0.36645-0.37729,0.11983-12.6869,2.60866,0.0312,0.32257,0.30694,0.3464,2.50023,1.49874,0.0179,0.039-4.12847-12.538-0.14991z'/%3E %3Cpath d='m898.767,461.149,0.0199,1.1423,1.26256,0.0954,0.35417,0.36677,0.21614,12.3829-0.34115,0.3789-1.25849,0.13782,0.0199,1.14231,6.14838-0.10732-0.0199-1.14231-1.30534-0.0931-0.35417-0.36677-0.10258-5.87653,6.27854-0.1096,0.10257,5.87654-0.31889,0.37852-1.3013,0.13857,0.0199,1.1423,6.12782-0.10696-0.0199-1.14231-1.26252-0.0938-0.35417-0.36677-0.21615-12.3829,0.34116-0.37891,1.25845-0.1394-0.0199-1.14231-6.12782,0.10696,0.0199,1.14231,1.30537,0.0947,0.33191,0.36716,0.0891,5.10707-6.27853,0.10959-0.0892-5.10707,0.34116-0.3789,1.30127-0.14016-0.0199-1.1423-6.14838,0.10732z'/%3E %3Cpath d='m916.073,476.413,11.6241-1.06432-0.3543-4.15727-1.47242,0.13481-0.15864,2.4965-0.24986,0.39724-5.02124,0.45975-0.51488-6.04148,2.81346-0.2576,0.33145,0.29782,0.35921,1.65255,1.27621-0.11685-0.45938-5.39023-1.27621,0.11685-0.074,1.69382-0.27608,0.35185-2.81346,0.25761-0.47124-5.52933,4.30807-0.39446,0.30724,0.27614,0.4985,2.01576,1.51507-0.13872-0.31092-3.64828-10.9092,0.99887,0.097,1.13811,1.33054-0.004,0.37411,0.29391,1.05536,12.3833-0.3147,0.40318-1.31073,0.23631,0.097,1.13811z'/%3E %3Cpath d='m932.555,458.353,0.1778,1.12752,1.36566-0.11428,0.41605,0.26022,1.9346,12.2681-0.30714,0.4304-1.32936,0.34448,0.1778,1.12753,6.43651-1.09951-0.1778-1.12752-1.41039,0.12352-0.42321-0.30563-0.81666-5.17879c0.13672-0.0233,0.27523-0.047,0.38857-0.0664,2.3044-0.39365,3.05412,0.49466,4.10583,2.56004,0.53928,1.04166,0.90964,2.04302,2.24033,2.76132,0.61756,0.34319,1.50472,0.47469,2.48692,0.3069,0.70698-0.12076,1.47144-0.32211,2.25213-0.57287l-0.17434-1.1056c-0.11334,0.0194-0.20508,0.035-0.29683,0.0507-1.52907,0.2612-2.26699,0.0335-2.94708-1.1514-0.6148-1.07539-0.99257-2.28777-1.85931-3.18021-0.64135-0.64629-1.48738-0.95045-2.62113-1.01731,2.50154-0.92425,3.63852-2.48866,3.30465-4.6059-0.40302-2.55573-2.44673-3.62504-5.98519-3.02059l-6.93841,1.18524zm4.88592,0.51304,1.05056-0.17946c2.21267-0.37798,3.5435,0.48182,3.84107,2.36886,0.33413,2.11881-0.6774,3.28386-3.11853,3.70086-0.25185,0.043-0.52528,0.0897-0.82581,0.11695l-0.94729-6.00721z'/%3E %3Cpath d='m951.81,470.606,6.6025-2.07914-0.32891-1.09305-1.51294,0.35511-0.46072-0.24548-3.57863-11.893,0.25926-0.42401,1.44579-0.57827-0.3289-1.09304-6.60249,2.07913,0.3289,1.09305,1.49077-0.34646,0.44747,0.20145,3.57864,11.893-0.24602,0.46803-1.42362,0.56963,0.3289,1.09305z'/%3E %3Cpath d='m965.54,457.738,0.31433,1.09468,1.67193-0.3998,0.4444,0.20245,1.30881,4.55813c-0.56356,0.22413-0.97784,0.37842-1.1996,0.44771-3.41021,1.06553-6.16697-0.62955-7.32211-4.6525-1.12284-3.91044,0.24784-6.87029,3.54979-7.902,0.64258-0.20077,1.27163-0.27637,1.94128-0.21721l0.44702,0.29773,1.10098,2.23728,1.61693-0.50522-1.09053-3.79793c-1.78108,0.0197-3.42289,0.26594-4.88616,0.72314-4.91713,1.53637-7.20583,5.58661-5.89047,10.1676,1.33457,4.64783,5.40358,6.88389,10.0553,5.43045,1.61693-0.50521,3.16663-1.33072,4.69929-2.46735l-1.49479-5.20581,0.26454-0.42396,1.25285-0.51406-0.31432-1.09468-6.46946,2.0214z'/%3E %3Cpath d='m968.961,448.387,0.49355,1.02007,1.24791-0.52701,0.49129,0.15867,5.35021,11.0578-0.16911,0.50721-1.14714,0.73527,0.49355,1.02007,5.84114-3.08282-0.49355-1.02007-1.28951,0.55074-0.49129-0.15867-2.53904-5.24769,5.96476-3.14807,2.53904,5.24769-0.14796,0.49605-1.18944,0.75759,0.49355,1.02007,5.82-3.07166-0.49355-1.02007-1.24722,0.52842-0.49129-0.15867-5.35022-11.0578,0.16912-0.50721,1.14645-0.73669-0.49355-1.02007-5.81999,3.07167,0.49355,1.02007,1.2902-0.54933,0.47014,0.16983,2.20658,4.56056-5.96477,3.14807-2.20658-4.56056,0.16912-0.50721,1.18874-0.75901-0.49355-1.02007-5.84114,3.08283z'/%3E %3Cpath d='m983.583,439.937,2.02787,3.54597,1.36886-0.85444-0.90834-2.3419,0.16871-0.45852,2.38104-1.48624,6.23168,10.8968-0.1532,0.5302-1.23374,0.9051,0.56113,0.98121,5.93381-3.70388-0.56113-0.98121-1.34597,0.70516-0.52106-0.10933-6.23169-10.8969,2.3826-1.48721,0.44609,0.0747,1.56227,1.93372,1.37042-0.85542-2.02787-3.54597-11.4515,7.14802z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%230072c4' stroke='%23fff' stroke-width='6' d='m900.011,448.344s-114.465-33.7349-113.798-162.077l0.88167-169.649h225.834l0.8847,168.675c0.6677,128.342-113.802,163.051-113.802,163.051z'/%3E %3Cg fill='%23bcbcbc'%3E %3Cpath d='m802.805,155.04c0.18817,0,1.57517-1.31703,2.84532-2.47855,1.77396-0.88859,3.41438-2.13739,5.21718-2.97521,1.34299-0.77752,3.99711-1.3805,5.21566-1.98347,1.59794-0.83623,2.90147-1.79941,4.26875-3.47187,0.16389-2.21832,0.47498-3.81145,0.47498-6.4455,1.88625-0.90763,3.56006-1.7883,5.21566-2.48013,2.37338-0.66804,2.88781-1.61693,5.21718-1.98348,1.4993-0.52363,3.97738-0.49666,6.16411-0.49666,2.35972,0,3.84839,1.67723,5.96834,2.07392,2.51299,1.01395,3.68602,1.71531,5.69065,3.47187,1.13206,1.43286,1.83618,2.59756,3.76645,3.67657,1.52812,0.78387,2.95913,1.97078,4.7422,2.47855,1.95758,1.13454,3.69512,1.79147,5.21566,3.47187,1.39307,0.99015,1.96821,2.46109,3.3203,3.47028,1.56607,1.29958,3.05171,2.46903,4.74221,3.47188,2.03194,1.36145,4.04567,2.39603,7.33713,2.0993,1.7421-0.10314,3.61774-0.30307,5.69065,0.0841,2.32026,0,4.58438-0.0412,6.63908,0.49666,2.41891,0,4.37649,0.32688,6.63909,0.49508,2.11995,0.39669,4.28088,0.49666,6.63908,0.49666,2.05622,0.53633,4.31882,0.49508,6.63909,0.49508h6.63908,6.63908c2.41587,0,4.86209,0.0984,6.63909,0.49666,2.3931,0,4.45084-0.22374,6.63908-0.49666,2.57521,0,4.53886-0.47128,7.11407-0.49508h8.0625c2.06988,0.56648,4.71489,0.95524,6.16411,1.98347,1.89839,0.5411,2.8438,1.4408,4.7422,1.98348,1.45377,0.74578,3.66174,1.92635,4.7422,3.47028,1.33844,1.39954,2.7133,3.40364,3.79376,5.45535,1.32023,1.90413,1.82253,4.08119,2.84533,6.44549,0.54175,2.26592,0.9196,4.42076,0.94844,6.94216,0.51443,2.15008,0.47498,4.51597,0.47498,6.94215-0.54175,2.26116-0.66012,4.77779-1.42342,6.94216-0.082,2.41984-0.56603,4.60959-0.94844,6.44708-0.42187,2.02949-0.91809,3.33541-0.94844,5.95042v6.94215c-0.16693,2.27703-0.66467,3.9495-0.94845,6.4455-1.14723,2.16595-2.2459,4.69845-3.31878,7.43882-1.5782,1.09963-2.94699,2.6642-3.79376,3.96694-1.01218,0.62519-1.59793,1.57409-1.42342,1.98348,1.89536,0.6601,1.42342,1.97871,1.42342,4.46202,0.24583,1.91206,0.43097,4.28271,0.94844,6.44708,0.17299,2.36747,0.67984,3.81461,1.4219,5.45376,0.74813,0.97745,0.89381,0.49666-0.94844,0.49666-1.37031,1.07425-2.75731,0.51253-3.31878-1.4884-1.10626-1.33448-1.47046-2.94982-1.89688-5.45376-0.26253-2.29607-0.62977-4.53343-1.42342-5.95042-0.2428-2.79432-0.98638-2.76575-3.79377-2.97521-1.3354-1.18373-3.09874-1.4884-5.69064-1.4884-2.58128,0-2.79828-0.2634-2.84532,2.48014v6.94215c-0.44615,2.01204-1.42494,3.64325-1.89688,5.45376-1.41432,1.03617-2.15031,2.77528-3.79377,3.96695-0.78303,2.25164-1.92116,2.64357-4.26874,2.97521-0.82097-1.02506-2.15941-2.36272-2.84532-3.47029,1.32782-2.22783,2.48719-2.56423,3.3203-4.95868,1.00763-1.97395,1.59945-3.25448,2.37035-4.95868-1.01218-1.55822-1.92117-2.26116-2.84533-4.46361-0.77999-1.1996-1.86046-3.78129-2.37034-5.45376-1.55696-0.54268-4.00925-0.62995-5.21718-1.4884-2.30054-0.53474-2.94396,1.98348-5.68913,1.98348h-6.63908c-2.93637,0-3.66933,1.63914-6.16563,1.4884-0.73295,0.23801-2.51147-0.10473-5.21718,0-1.98186,0.69024-4.36889,0.49507-6.63908,0.49507-2.40525-0.0301-4.37345-0.58393-6.16411-0.99174-2.17913-0.59662-4.34613-1.20119-6.63908-1.48681-2.78462,0-3.82108,0.22215-5.69065,1.48681-1.47956,0.87749-3.6238,2.88318-5.21718,3.96695-0.67377,1.64549-1.02431,4.43029-1.89688,6.44708-0.50381,1.93428-1.32326,3.16086-1.89688,4.95868-0.6419,1.67723-1.24891,3.40364-1.4219,5.95042-0.16086,3.34176-0.89078,2.93237-2.84532,1.98348-0.8149-1.38367-2.11389-2.9054-2.84533-4.46361,0.43098-2.52298,0.91658-3.77812,0.94844-6.4455-0.46132-1.92476-1.53875-1.86287-2.84532-0.49666,0,2.59597,0.11989,4.59849-0.94844,5.95042-0.53416,2.04853-1.39307,2.93396-2.84532,3.96695-0.71019,1.84066-2.28688,2.68324-3.79376,3.47187-0.24129-0.0841,0-0.66486,0-1.98347-1.13661-2.26751-0.082-4.14943-0.082-6.94216,0.0288-2.50394-0.11381-4.16371,0.61307-6.44708,0-2.40397-1.11536-4.69052-1.47956-6.44549-0.88167-1.84225-1.39004-2.75307-3.79377-3.47188-1.68898-0.6712-4.12306-1.57884-5.21718-2.97521-1.37637-1.78512-2.25501-2.5198-4.26722-3.47028-2.18217-0.79022-3.24139-1.51379-4.7422-2.48014-1.46591-1.61692-2.65716-2.31828-3.32031-4.46202-0.98941-1.52489-1.15937-4.35729-1.89688-6.44708-0.16085-2.17706-0.78455-4.2002-1.4219-5.95042-0.28225-2.17706-0.62521-3.77018-1.42342-5.95042-0.26404-2.03901-0.85284-4.17164-1.4219-6.44549,0-2.42618,0.0394-4.79366-0.47498-6.94216v-6.94215c-0.34144-2.0041-0.46739-4.93806-0.94844-6.44708,0-2.69753-0.28681-4.22083-0.94844-5.95042-1.08502-1.75181-1.17303-2.53726-2.84532-2.97521-1.20794,1.54076-3.1989,2.16912-5.69065,2.48013-1.74058-0.39669-4.19742-0.65534-6.16562-1.4884-1.90143-0.4681-3.20194-1.22023-4.7422-1.98347-0.84222-1.2964-1.84832-2.76417-2.84532-3.96695-0.2944-2.58962-0.85891-3.92251-0.94845-6.44549,0-1.89303,0.0455-0.8886,1.89689-3.47187z'/%3E %3Cpath fill='%23fefefe' d='m830.89,172.905c3.01016-0.99728,9.58467-5.8759,13.3643-9.00378,4.30335-2.72739,13.1109,0.10252,13.4622-7.28709-0.53305,2.22171-5.62641,7.74585-8.11654,11.089-5.48978,3.48825,2.68529,7.04297,4.00373,2.05723,2.84772-5.09972,6.46988-10.277,12.1601-12.2836-1.03729,3.67567-1.80247,7.24947,0.67074,10.5203,0.88987-1.60958,1.11142-8.21765,1.01654-2.77785-1.79843,3.09405,2.65737,12.1065,2.76993,5.09501,0.71142-4.43341,0.442,4.79493,1.79515,6.18455,2.83476,5.46966,2.58586-5.03246,3.21522-7.11238,0.47597-3.93153,0.67377-2.89436,0.0994-0.0538-0.57065,3.56033,0.61326-7.43531,0.82573-1.37487,0.39079,3.16821-0.0413,11.7806,3.02049,4.94723,2.45143-4.06247,3.03655-4.12345,0.36045-0.51803-0.87211,1.35908,4.0207-7.40192,2.08539-1.2911-0.12835,4.39044,0.0335,10.9195,2.41805,13.7864,1.83004-2.2556,0.7635-13.983,2.60342-5.92305,0.70504,2.27261,0.021,8.59829,2.99262,3.74338,3.2098-3.78269,4.97961-7.06438,4.63014-12.2524,0.40126-2.64755,2.01363-6.90493,3.43146-2.21596-0.97348,6.11645,5.39407,10.007,4.61587,15.8908,2.85773-4.49568,1.57127-11.1875-0.33184-15.4883-0.40174-5.09276,7.74442-2.0564,5.71932,2.43583-0.2315,3.22891,4.39599,11.5246,4.76657,3.84607,0.62156-3.6492,2.63103-3.9712,2.19105,0.10944,0.83861,2.63565,4.4214,10.3898,4.03435,3.63695,0.31893-3.67806-0.59578-7.55212,1.0582-11.0187,1.17289,2.21486,1.29679,5.61678,2.68143,1.40272,2.83045-0.0846,1.11836,7.78332,4.69516,9.46672,1.43727,2.82372,5.01505,7.43827,4.01209,1.35967,0.55544-3.29147-2.39218-10.095-1.11413-10.9712,3.74549,4.75485,5.12978,11.0333,10.1799,14.8701,4.80966,2.44003,0.59783-6.74784,0.33537-9.11604-2.867-1.57623-5.20908-7.70196-1.15198-2.91591,2.34206,4.25118,9.46311,7.97131,11.6877,8.89564-2.12213-1.56996-4.05621-2.15463-0.45716,0.018,2.66474,1.09269-1.58101-6.64142-3.12753-7.95206-1.37513-2.47279-8.07162-6.07864-6.17271-7.7839,5.23969,1.13266,6.77331,6.86107,9.95197,10.4396,1.98126,1.65983,6.75982,5.18605,4.09075-0.0764,1.49352-0.62278,8.86655,7.55936,7.10936,0.99791-1.21487-2.82231-7.67666-7.91561-6.96393-8.22312,2.20398,3.19048,0.87344,0.90986-0.8825-0.76238,6.38867,0.70949,10.1398,7.08678,14.1572,11.1402,0.50039,1.92977,1.96129,11.3292-0.0119,5.16368-4.15457-1.77377,1.603,8.43181-2.93355,7.10807-0.20511-2.26067-4.20708-7.00283-2.27102-2.31615,3.33625,6.84409,0.82153,14.361,1.11885,21.5783,0.0883,3.55373-0.082,7.08496-0.33537,10.6211,0.24069-2.60941,0.4433-6.95281,0.0161-1.25452-0.14842,3.95896-1.6073-5.71316-3.58581-6.2059-0.41055-1.80097-1.96739-10.901-3.2803-5.47185,0.0104,5.32009,5.14076,10.9028,1.04345,15.5915-1.38269,1.28818-2.11236,4.99701-2.85006,1.1098-2.01798-4.59595-3.30949-9.46095-6.84794-13.2155-1.49315-2.92571-6.61967-10.0186-5.19949-2.5725,0.88879,3.36447,1.4857,6.77784,1.25569,10.2672-1.99097-5.1616-4.70684-9.96075-7.37811-14.7269,0.3869,2.22649,3.09039,11.7834,0.73938,5.58987-1.62661-5.08029-4.24819-10.1509-9.31077-12.4046-1.39782-0.17335,3.40031,8.93365,1.55009,8.99929-0.44381-2.93678-3.10484-9.47314-5.7487-8.28005,0.1185,5.24793,2.25357,10.1348,1.03362,15.4864,0.26607,5.219-3.21916-5.18977-4.3598-6.58553-5.12431-3.13598,0.37497,8.83935-3.68753,4.20655-3.26935-2.29695-5.01393-4.83396-4.69516-9.11605-6.08182-1.03487-3.73498,5.39502-4.02291,9.05002-0.51339,2.77358-2.01069,8.04045-3.70171,8.85003-0.70603-4.00858-0.14054-8.20487-0.32271-12.2908,0.97716-2.34563-0.0982-8.37465-2.94714-5.50964-0.48257,5.29352,2.9743,12.0158-0.95631,16.3378-2.0801,2.3795-5.9375-3.71409-9.57596-2.08571-4.62086-2.36747-2.72652-9.7724-5.86328-13.6612-3.11725-3.26284-1.65536,13.0789-3.7059,5.3359,1.47374-4.93096-7.51607-6.85911-5.75896-1.60077,2.20795,2.23726,2.60646,5.04299,2.31646,8.01757,0.62655,3.49911-1.97233,4.5372-2.57748,0.60989-0.24863-4.3276-7.65601-6.12206-6.14058-0.43021-3.88245-2.49914-0.23824,9.85086-4.99598,6.05452-5.36181-3.7405-8.80139,3.31203-14.6754,1.92791-3.33986,0.55613-11.3287,1.42615-6.48435-3.42362,4.52943-2.7321,6.44443-10.9898,12.7568-6.76537,4.82565-0.28129,9.95052-3.67983,13.8907-6.84495,3.22258-2.17258,1.7812-7.6997-2.16866-4.27267-3.27934,4.92682-12.6992,4.92224-15.524,4.53229,2.79931-2.65078,11.3625-3.04043,9.23663-7.68244-3.14315,0.25665-8.66152,4.96533-10.4304,2.22426,1.09847-1.20979,4.70733-4.56024,0.54478-3.09798-5.27085,1.71677-10.9218,1.29897-16.3532,0.86776-5.4353-5.32188,7.928-3.86431,7.73453-7.36265-1.31761-0.10864-6.52147,0.59403-4.24666-1.31787,4.39919,0.0865,8.83744,0.42098,11.992-3.75434,1.90848-1.98275,8.54789-6.5335,6.92454-8.13266-4.8995,2.82138-10.0443,7.60914-16.1838,4.81979,5.27508-3.93443-2.03747-4.27138-5.37085-3.88706-2.42534,0.74896-9.16747-2.00823-3.40053-1.83108,3.92909,0.83158,7.83231-4.61133,1.78491-3.56902-1.26541-0.38878-2.62461-0.14135-3.92934-0.21075z'/%3E %3Cpath fill='%23fefefe' d='m801.857,164.957c-0.23136-2.56198-1.26283-5.10739-0.83642-7.69477,1.26199-1.84481,3.00745-3.18724,4.63018-4.70114,2.90484-1.61981,5.66804-3.59092,8.95369-4.38807,2.28115-0.69646,4.25854-2.20213,5.7479-4.04248,0.73309-2.21398-0.56236-5.75944,1.51487-6.95213,2.55642-1.39969,5.32409-2.30112,7.92882-3.58637,2.84468-0.91895,5.92331-1.06205,8.87362-0.70987,2.36179,1.01464,4.75592,1.93853,7.09929,2.99747,2.11924,1.03086,3.67999,2.77694,5.11286,4.5868,1.67465,1.52753,3.77083,2.51915,5.7413,3.60912,1.6371,0.11322,1.09701,2.23527,0.058,2.15219-0.6743,3.14003-4.59158,0.47595-5.33677-1.37364,0.65699-1.21901,0.38844,2.78457-0.86509,2.83893-2.20894,0.97651-2.14283-2.78465-2.46626-4.2221,0.28044-1.2152-0.67864-2.65619-1.17917-0.74693-1.48609,1.6347,1.60134,5.13888-1.62587,4.173-2.39804-0.31622-5.07777-0.81085-7.16045,0.77882-1.74322,1.81824,1.88708,2.56492,3.01891,3.44643,1.52572,1.43611,3.56554,0.0173,5.34179-0.15924,2.4299-0.83935,5.16356-0.40458,7.41596,0.72101,1.041,2.24835-1.04678,4.48315-3.03758,5.39487-1.85974,1.00879-3.93569,1.44558-6.00856,1.69755-3.03896,0.13471-2.44922,3.90074-5.40932,4.20221-1.89031,0.80048-4.01961,0.9837-6.03641,0.7181-0.39697-1.08631,2.00358-2.80708,2.25276-4.46644,2.17427-2.58539-3.11509-2.11424-2.34758,0.35068,0.36642,1.67133-3.29636,4.13969-2.05854,1.29917,0.0586-1.52756,1.6414-3.89874-1.0236-2.7979-1.45836-0.0133-4.44773-0.0666-3.62523,2.20009-1.80834,0.38287-4.12631,0.42325-5.67717-0.47586-0.9259-2.4702-3.81144-3.5558-5.62049-1.31137-1.8025,2.38467-4.30551-0.74156-6.09503,0.49461-0.0237,2.23527,2.28093,3.40462,4.32116,3.38734,2.06562-0.18234,4.18492-0.56558,6.26763-0.22477,1.91711,2.28659-1.83037,3.00321-3.60897,2.6894-2.39695-0.0867-4.54102-1.45657-6.97935-1.26693-1.16492-0.16461-3.8206,1.28459-1.31556,1.4787,1.85975,0.37786,5.66791,0.25128,4.81789,3.16927-1.45811,0.67958-3.26393-0.0665-4.91285,0.63698-0.96797-0.25022-3.87338,0.5347-2.25582-0.29811-0.85609-1.48198-2.51249-2.32067-3.61455-3.60462z'/%3E %3Cpath d='m812.447,153.269c-0.11078,0-1.11233,0.6966-2.01221,1.40272-1.4735,0.78863-3.04715,2.13104-4.02442,2.80542-0.76938,0.61567-0.76482,0.88384-1.67533,1.05204,1.59794-0.22691,2.30964-0.63313,3.68754-1.40272,1.7421-0.20945,3.42956-0.57917,4.35979-1.40271,0.87257-0.30466-0.0652-1.70261-0.33537-2.45475z'/%3E %3Cpath d='m827.873,136.789c0.19272,0,0.58576,1.09647,1.33996,1.75339,0.48256,1.34559,0.92719,2.29607,1.0061,3.85746,0.41125-1.71372,1.11385-3.09104,1.34148-4.90949-0.52202-0.92351-0.55693-1.3567-2.01221-1.40271,0,0.9473,0.11077,0.32846-1.67533,0.70135z'/%3E %3Cpath d='m833.908,137.14v0.35068c0-0.94572-0.0213-0.46334,0.33537,1.40271,0.55389,1.1758,0.67073,2.43729,0.67073,4.20814,0.88016-0.65693,1.61463-1.96761,2.01222-3.1561,0-2.76893-0.37483-2.6055-3.01832-2.80543z'/%3E %3Cpath d='m846.315,177.463h0.33537c-0.98638,0-0.43097,0.0603,1.34147-1.05204,1.14724-0.79973,2.08657-1.98188,3.68906-2.45474,1.5524-1.27419,2.74668-1.87082,4.35827-2.45316,0.78607-0.37766,1.47957-1.033,2.34758-0.35068-0.24887,1.72959-0.53568,2.38334-2.01221,3.15451-0.76331,0.99967-1.96517,1.58361-3.0168,2.10407-1.09109,0.50142-2.29143,0.52681-2.68295,1.75339-1.82404,0.83941-2.04863,0.69818-4.35979-0.70135z'/%3E %3Cpath d='m852.687,187.631c0.5979-0.47286,2.69813-2.66261,3.68754-3.50519,1.11992-1.54394,2.25198-2.7245,3.35369-3.50678,0.97727-1.50427,2.22921-2.51187,3.01831-3.85746,0.93175-1.17898,1.61766-2.17706,2.68295-3.50519,0,1.53282-0.13961,3.56549,0.33385,4.55722,0,2.11835-0.23369,2.69753-1.00458,4.20814-0.76179,1.24086-1.32934,2.06281-3.01832,2.80543-1.52358,0.84416-2.43712,1.14089-3.68906,2.10248-0.95451,0.61408-1.94847,1.22499-3.01831,1.75339-0.95907,0.43001-0.51899,0.24277-2.34607-1.05204z'/%3E %3Cpath d='m842.291,195.696h0.33536c-0.98637,0-0.43248,0.0603,1.34148-1.05204,1.43101-1.49633,2.57065-2.01679,4.35979-2.80542,1.3612-0.10949,3.0077-0.46334,4.02442-1.05203,0.81035-0.14916,1.37486-0.66487,2.0107,0,1.05315,1.48839,1.34299,1.90889-0.33537,2.80542-0.80276,0.71246-2.21859,1.42969-3.35217,1.75339-0.83766,0.72198-2.49478,0.76641-4.02442,1.05203-1.37031,0-2.1321,0.16186-2.68295-0.70135l2.68295,0.70135c-1.37031,0-2.1321,0.16186-4.35979-0.70135z'/%3E %3Cpath d='m856.71,195.696v-0.35068c0,0.97904-0.041,0.46017,0.67074-1.40271,1.25649-1.96126,1.72995-3.04344,3.35368-3.50678,0.76027-0.96159,2.07747-1.21071,3.68906-1.75339,0.60396,1.05362,0.13961,2.28178,0,3.50678-0.43856,1.30909-1.63436,2.23259-2.34758,3.1561-1.04556,0.74261-1.47198,1.45666-3.01832,1.75339-1.27926,0-0.60093-0.0333-2.34758-1.40271z'/%3E %3Cpath fill='%23c4c4c2' stroke='%23000' stroke-width='1.3578' d='m817.476,151.165c-0.74964,0,1.32175-0.7807,2.01222-1.05204,0.55237-1.21706,0.99093-2.07868,2.01221-2.80384,1.67988,0.13488,2.50388,0.64106,3.35368,1.75181,1.41128,0.40304,1.91965,1.10598,3.68906,1.40271,0.65708,0.58076,1.54634,0.64741,0,1.05203-1.05163,0.58077-2.37338,0.70136-4.02443,0.70136-1.72995,0.13012-2.9652,0.5284-4.02442,1.05203-2.24439,0-1.88474,0.0778-3.01832-2.10406z'/%3E %3Cellipse fill='%23000' cx='138.108' cy='302.603' rx='1.10487' ry='1.10489' transform='matrix(1.517505,0,0,1.5867785,612.59226,-330.0498)'/%3E %3C/g%3E %3Cg fill='%23005121' stroke='%23002b0e' stroke-width='1.9397'%3E %3Cpath d='m827.872,247.944h1.34148c-4.20501,0-1.69202-0.29355,5.36438,5.60927,2.95611-2.57535,2.9212-2.92285,5.36591,1.40271,1.41128,2.46268,1.82556-0.25071,4.0229-2.80384,1.05922,5.09515,1.73755,10.4378,5.36591,5.60926,4.14431,0,8.48286-0.36019,10.7303,1.40272,2.71634,5.27604,1.82708-0.89495,4.02443,1.40271,5.90613,0.74103,5.79384-5.29667,12.2266-6.85806,3.99863,5.22526,5.74983,1.20437,10.7318-1.40113,3.69968,1.08219,7.18691,6.95168,7.89103,1.24563,3.02894-5.16656,3.29299-4.72702,5.3659,0,2.94548,2.77369,4.1868-1.38685,6.70586-2.80384,4.49031,2.74671,9.49808,3.12754,16.0962,1.40271,1.11689,4.67148,3.93338,2.64516,6.70586,1.40113,5.93345,2.60707,8.00333,3.40522,14.7547,0,3.34458-4.13198,1.45073,0.11583,4.0229,2.80542,5.0017-1.62327,3.62077-1.9676,9.39033-1.40271,5.79839,0,6.2673-0.14598,8.04734-4.20655,2.91361,3.04661,3.96676,5.24272,8.04733,1.40271,6.25213,0.192,4.31883,0.82513,8.04886-1.40271,2.75882,6.38837,3.4068,1.77243,6.70586,4.20655-2.17307,5.76159-5.51159,8.46388-9.38881,11.2201-2.57977,4.46837-4.19287,9.29377-9.38882,11.2217-3.79073,4.04311-7.83033,6.38678-12.0718,9.8174-5.81508,1.52013-12.2159,1.40271-18.7791,1.40271h-18.7776-18.7791-18.7776c-4.00622,2.09296-10.5588,3.09105-16.0962,4.20655-6.18384,0-13.1932,0.0762-17.4361-1.40271-2.87568-3.00536-7.91987-6.36457-10.7303-9.8174-2.84381-2.39762-2.92575-7.07704-5.3659-9.8174-2.24439-4.01297-2.93789-10.2918-5.36439-14.0256v-9.8174z'/%3E %3Cpath d='m957.978,260.567v1.40271c0-3.92093,0.16541-1.83749-2.68295,5.60927-0.57665,1.80893-1.83922,2.23418-4.02442,2.80542'/%3E %3Cpath d='m945.906,266.177h1.34148c-4.9668,4.90474-8.30987,7.16431-9.39033,12.6228l9.39033-12.6228c-4.9668,4.90474-8.30987,7.16431-9.39033,12.6228'/%3E %3Cpath d='m927.127,259.165c0,0.12535-0.18817,5.00311-1.34147,7.01197'/%3E %3Cpath d='m921.763,268.982v1.40271-1.40271z'/%3E %3Cpath d='m911.032,260.567h1.34148-1.34148z'/%3E %3Cpath d='m835.919,260.567c0.64039,0,3.27933,4.4525,6.70586,7.01198-0.85284,4.10341-2.16396,8.85105,0,12.6228'/%3E %3Cpath d='m846.649,268.982c0.64038,0,3.27933,4.45409,6.70737,7.01356l-6.70737-7.01356c0.64038,0,3.27933,4.45409,6.70737,7.01356v1.40272c0-4.3335-0.34447-8.87169,1.33996-11.2217,1.49171,2.63882,3.37493,6.88187,4.02443,2.80543,7.55414-0.28245,11.2007-2.50076,16.0962-4.20655,0,2.06281-0.31716,1.07107,1.34147,2.80384'/%3E %3Cpath d='m967.367,261.97h1.34148c-2.52968,2.20404-4.47057,6.69938-6.70738,9.81741'/%3E %3Cpath d='m912.374,257.762h10.7303'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m824.718,268.429c-16.1311,0-21.4775,16.8577-37.6086,16.8577-0.31034,0-0.6046-0.0255-0.90714-0.0377v1.02053c-0.0608,11.6854,0.85765,22.57,2.53244,32.7327,14.8808-1.08684,20.4088-16.8577,35.9833-16.8577,16.1311,0,21.5153,16.8955,37.6464,16.8955,16.131,0,21.5153-16.8955,37.6464-16.8955s21.5153,16.8955,37.6464,16.8955,21.5153-16.8955,37.6464-16.8955c15.5338,0,21.0768,15.6596,35.8699,16.8199,1.7721-10.4347,2.7084-21.6456,2.6458-33.6777v-0.0377c-0.3025,0.0122-0.5968,0.0377-0.9071,0.0377-16.1311,0-21.4776-16.8577-37.6086-16.8577-16.1311,0-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577c-16.1311,0-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577z'/%3E %3Cpath d='m824.718,334.234c-12.5486-0.00001-18.585,10.1721-28.2348,14.7033,3.37126,9.2945,7.44582,17.7549,11.9818,25.5134,4.58242-3.46521,9.4537-6.46339,16.253-6.46339,16.1311-0.00001,21.5153,16.8577,37.6464,16.8577,16.131,0,21.5153-16.8577,37.6464-16.8577,16.1311-0.00001,21.5153,16.8577,37.6464,16.8577s21.5153-16.8577,37.6464-16.8577c6.64925,0,11.4555,2.86935,15.9506,6.23661,4.53503-7.72309,8.62643-16.1692,12.0196-25.4-9.49735-4.59095-15.5359-14.5899-27.9702-14.5899-16.1311-0.00001-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577c-16.1311-0.00001-21.5153,16.8577-37.6464,16.8577s-21.5154-16.8577-37.6464-16.8577z'/%3E %3Cpath d='m900.011,400.04c-16.1311-0.00001-21.5153,16.8955-37.6464,16.8955-15.2555,0-20.902-15.1039-35.114-16.7444,18.9944,21.1594,40.5334,33.9695,55.2223,41.0104,4.96772-3.85569,10.1124,4.68691,17.5381,4.68691,7.37272,0,12.4898-8.58651,17.4247-4.7625,14.5266-7.07257,35.8026-19.9033,54.6932-40.8592-13.7469,2.00976-19.4462,16.6688-34.4714,16.6688-16.1311,0-21.5154-16.8955-37.6464-16.8955z'/%3E %3C/g%3E %3Cg stroke='%23522108'%3E %3Cg fill='none'%3E %3Cpath stroke-width='0.7371' d='m800.148,342.754c2.64653-0.92192,15.4376-5.07293,15.8792-4.61277,0.44159,0.46176,24.702,24.9077,24.702,24.9077l-20.2906,4.15101-20.2906-24.4459z'/%3E %3Cg stroke-width='0.7513'%3E %3Cpath d='m848.358,374.785c0.37408-5.78836,11.2095-38.709,11.2095-38.709'/%3E %3Cpath d='m852.095,375.177c0-0.36216,8.59483-38.7388,8.59483-38.7388'/%3E %3Cpath d='m855.039,375.237c0.37279-2.17048,7.14479-38.7986,7.14479-38.7986'/%3E %3Cpath d='m851.349,364.293c1.86783,0,5.60476-1.44741,5.60476-1.44741'/%3E %3Cpath d='m852.47,359.952c0-0.36216,5.60477-1.4474,5.60477-1.4474'/%3E %3Cpath d='m853.216,354.526,5.97884-1.08524'/%3E %3Cpath d='m855.832,349.823c0,0.36216,4.10973,0.36216,4.10973,0.36216'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m914.897,400.376c-0.44159-9.91194-13.2326-66.2848-13.2326-66.2848'/%3E %3Cpath d='m910.485,398.517c0-0.62016-10.146-63.8063-10.146-63.8063'/%3E %3Cpath d='m906.074,393.56c-0.44007-3.71671-7.498-58.8493-7.498-58.8493'/%3E %3Cpath d='m914.455,392.322c-2.20494-1.85836-8.82126-4.33687-8.82126-4.33687'/%3E %3Cpath d='m911.367,382.41c-2.20493,0-6.61632-2.47852-6.61632-2.47852'/%3E %3Cpath d='m910.044,374.977c0-0.62016-6.61633-2.47852-6.61633-2.47852'/%3E %3Cpath d='m909.162,365.685-7.05792-1.85835'/%3E %3Cpath d='m906.074,357.631c0,0.62016-4.85147,0.62016-4.85147,0.62016'/%3E %3Cpath d='m904.75,350.198c-0.88167,0-4.85147,1.23819-4.85147,1.23819'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m948.797,372.677c-2.20493,0-6.61632-1.84543-6.61632-1.84543'/%3E %3Cpath d='m952.326,386.053c-0.44159-7.38011-13.2326-49.3536-13.2326-49.3536'/%3E %3Cpath d='m947.915,384.67c0-0.46175-10.146-47.5082-10.146-47.5082'/%3E %3Cpath d='m943.504,380.979c-0.44007-2.76734-7.498-43.8173-7.498-43.8173'/%3E %3Cpath d='m947.473,367.142c0-0.46175-6.61633-1.84542-6.61633-1.84542'/%3E %3Cpath d='m946.592,360.224-7.05792-1.38367'/%3E %3Cpath d='m943.504,354.227c0,0.46176-4.85147,0.46176-4.85147,0.46176'/%3E %3Cpath d='m942.18,348.693c-0.88167,0-4.85147,0.92192-4.85147,0.92192'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23dd8b59' stroke-width='0.7371'%3E %3Cpath d='m895.426,391.646c0-0.46175,1.32326-115.771,1.32326-115.771s3.9698-0.46175,3.9698,0-0.44008,115.31-0.88167,115.771c-0.4416,0.46175-4.85299,0.92192-4.41139,0z'/%3E %3Cpath d='m938.656,280.947c0,0.92351-0.88319,97.3219-0.88319,97.3219l-3.08813,3.69085,0.88319-101.013h3.08813z'/%3E %3Cpath d='m861.903,369.507c0.44007-2.76893,0.44007-86.2526,0.44007-86.2526l-2.64653-0.46175-0.44007,85.3306,2.64653,1.38367z'/%3E %3Cpath d='m845.141,338.141c1.76486,0,31.7599-5.07293,31.7599-5.07293l-0.44159,5.07293-29.5534,3.2291-1.76486-3.2291z'/%3E %3Cpath d='m845.581,311.389c1.76486,0.46176,36.1713-9.6857,36.1713-9.6857s0,3.2291-0.4416,3.2291c-0.44007,0-35.7297,9.6857-35.7297,9.6857v-3.2291z'/%3E %3Cpath d='m846.906,298.013c-0.44159,1.84543,0.44008,4.1526,0.44008,4.1526l28.6718-10.1474s1.32327-2.30718,0-2.30718c-1.32326,0-29.5534,9.22554-29.1118,8.30203z'/%3E %3Cpath d='m884.84,291.556c0.88167,0,29.5534-9.6857,29.5534-9.6857s0.44159,4.15101,0,4.15101c-0.44008,0-26.9069,8.30203-26.9069,8.30203l-2.64653-2.76734z'/%3E %3Cpath d='m882.634,303.549s-0.88167,4.15101-0.44008,4.15101c0.44008,0,37.493-10.1474,37.493-10.1474v-2.76735l-37.053,8.76379z'/%3E %3Cpath d='m883.957,336.297,0,3.2275,31.7599-4.61118-0.88167-2.30717-30.8782,3.69085z'/%3E %3Cpath d='m920.57,338.603,0.44007,2.76734s31.7599-4.15102,31.7599-4.61277c0-0.46016,0-3.22751-0.44008-3.22751-0.44159,0-31.3198,5.53469-31.7599,5.07294z'/%3E %3Cpath d='m920.128,309.084,0.4416,3.22751,37.493-10.6076s0.88319-2.76734,0.4416-2.76734c-0.4416,0-37.4946,11.5311-38.3762,10.1474z'/%3E %3Cpath d='m924.098,294.324s-0.44008,2.76734,0,2.76734c0.44159,0,27.7901-6.91835,27.7901-7.38011,0-0.46016,2.64653-3.22909,0.44159-2.76734-2.20645,0.46175-27.3485,8.76378-28.2317,7.38011z'/%3E %3C/g%3E %3Cg fill='%23fecf3e' stroke-width='0.7371'%3E %3Cpath d='m864.108,303.549c3.9698-1.38367,1.32327-4.61277,2.20494-4.61277,0.88319,0,3.9698,2.30559,5.73466,0.46017,1.76486-1.84384,3.08812-7.37853,2.20645-6.91836-0.79468,0.41547-19.8018,7.55232-23.9258,7.63379,2.58255,0.99754,10.3417,4.63553,13.7798,3.43717z'/%3E %3Cpath d='m925.421,297.091s2.20646,5.53469,4.41139,4.61277c2.20494-0.92192,4.41139-2.76734,4.41139-2.76734s1.76486,4.61277,4.85147,3.68926c3.08813-0.92192,4.85299-5.99644,4.85299-5.99644s3.0866,0.92351,4.40987,0.46175c1.32478-0.46175,3.08812-7.84027,3.08812-7.84027l-26.0252,7.84027z'/%3E %3Cpath d='m922.775,341.832c-0.44159,0.92192,2.20646,3.2291,4.41139,3.2291,2.20494,0,3.08813-3.2291,3.52821-2.30718,0.44159,0.92351,0.44159,5.07452,6.17625,3.69085,5.73465-1.38367,5.73465-5.53469,5.73465-5.53469s-1.76486,1.38367,2.20494,1.84384c3.96979,0.46175,7.93959-5.99644,7.49951-5.99644-0.44159,0-28.6718,5.53627-29.555,5.07452z'/%3E %3Cpath d='m922.775,311.851s-4.41139,5.07293-3.08812,11.9913c1.32326,6.91994,3.08812,12.9148,3.52972,12.9148,0.44159,0,5.29306-9.22395,10.5861-9.6857,5.29306-0.46175,14.9975,5.07452,14.9975,5.07452s-1.32326-11.071-0.88167-16.1439c0.44008-5.07452,7.9396-13.8367,7.9396-13.8367l-33.0832,9.68571z'/%3E %3Cpath d='m846.464,341.832c0.44159,0,0,4.15102,3.5282,3.2291,3.52972-0.92351,4.41139-3.2291,4.41139-3.2291s0.88167,5.07293,5.73466,4.61277c4.85146-0.46175,7.49799-5.99644,7.49799-5.99644s0.4416,4.15101,3.52972,2.76734c3.08813-1.38367,3.9698-4.61276,3.9698-4.61276l-27.7901,4.15101-0.88167-0.92192z'/%3E %3Cpath d='m846.464,314.619s-3.9698,1.38367-2.64653,9.6857c1.32326,8.30203,4.41139,12.9148,4.85146,12.9148,0.4416,0,3.9698-7.84027,9.26286-9.22394,5.29458-1.38526,14.5574,4.15101,14.5574,4.15101s-0.88319-7.38011,0.44159-14.2985c1.32327-6.91994,5.73314-11.9929,5.73314-11.9929s-30.8767,8.76378-32.2,8.76378z'/%3E %3Cpath d='m885.722,292.94c1.76486,0.46175,4.85299,5.07293,6.61633,4.15101,1.76486-0.92191,4.41139-3.68926,4.41139-3.68926s-0.44159,5.53469,3.08813,4.61118c3.5282-0.92192,3.96979-4.61118,3.96979-4.61118s2.64653,1.38367,4.85147,0c2.20645-1.38367,4.41139-8.30361,3.52972-8.30361s-25.5836,8.30361-26.4668,7.84186z'/%3E %3Cpath d='m884.84,306.317c0,0.92192-4.41139,8.30203-3.08812,15.2204,1.32326,6.91835,3.96979,13.3765,4.41139,13.3765,0.44159,0,7.05792-7.38011,12.7926-8.76378,5.73313-1.38367,14.1143,4.61277,13.6742,4.61277-0.44159,0-2.20645-6.91994-2.20645-11.9929,0-5.07452,6.61633-20.7567,6.61633-20.7567l-32.2,8.30362z'/%3E %3Cpath d='m884.84,339.525c0,0.46176,1.32327,3.69085,4.41139,3.69085,3.08661,0,3.52821-3.22909,3.52821-3.22909s-0.4416,5.53468,4.41139,5.07452c4.85146-0.46176,6.61632-5.53628,6.61632-5.53628s0.4416,2.76893,4.41139,1.38526c3.9698-1.38526,9.26286-5.99644,8.82127-5.99644-0.44008,0-31.7584,5.99644-32.2,4.61118z'/%3E %3C/g%3E %3Cg fill='%23dd8b59' stroke-width='0.7371'%3E %3Cpath d='m846.464,372.734s4.41139,47.5082,55.1386,46.1245c50.7272-1.38367,64.8415-47.9683,64.8415-47.9683s-21.6138-0.92351-22.0554-0.92351c-0.44007,0-17.644,22.1403-39.6995,21.6786-22.0554-0.46175-29.1118-5.99644-33.9648-10.6076-4.85147-4.61277-9.26286-11.5311-9.26286-11.5311l-25.5836-10.6092,1.32326,10.1474,9.26286,3.68927z'/%3E %3Cpath d='m983.411,367.799c-0.4416-1.38367-1.52813-6.13449-1.52813-6.13449v-5.53468l2.44166-5.60451s-38.3762,5.74891-38.3762,6.21066c0-0.53157-0.23673,10.925-0.23673,10.925l37.6994,0.13805z'/%3E %3Cpath d='m976.149,356.13-0.88167,9.6857,6.17473,0-0.44007-9.6857-4.85299,0z'/%3E %3Cpath d='m969.532,356.592-0.44159,10.1459,3.9698-0.46017,0.44159-9.6857-3.9698,0z'/%3E %3Cpath d='m962.916,366.738,0-7.84028,3.96979-1.38367,0.4416,7.84028-4.41139,1.38367z'/%3E %3Cpath d='m955.416,366.278,0.88319-6.91836,4.40987,0.46017,0.4416,7.38011-5.73466-0.92192z'/%3E %3Cpath d='m947.035,366.278,0.4416-5.99644,4.41139-0.46175,0,6.91836-4.85299-0.46017z'/%3E %3Cpath d='m942.625,369.967,41.9044,0.92351,0.44159-3.2291-43.2292-0.46175,0.88319,2.76734z'/%3E %3Cpath d='m944.389,358.436c4.85299,0,41.4643-7.38011,41.4643-7.38011s1.32327-4.61118,0-4.61118c-1.32326,0-41.4643,8.76378-41.4643,8.76378v3.22751z'/%3E %3Cpath d='m798.825,342.294,33.5232,17.0658-0.88168,2.30559s-32.2015-15.6821-32.2015-16.1439c0-0.46016,0.4416-2.30559-0.44007-3.22751z'/%3E %3Cpath d='m814.263,337.219c0,1.38368,4.85298,29.5189,4.85298,29.5189s3.08813,0.46175,3.08813,0c0-0.46017-5.29458-29.0571-5.29458-29.0571l-2.64653-0.46176z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cg stroke-width='0.7513'%3E %3Cpath d='m882.044,389.315c0.44159-7.66848,13.2326-51.282,13.2326-51.282'/%3E %3Cpath d='m886.456,389.834c0-0.47979,10.146-51.3216,10.146-51.3216'/%3E %3Cpath d='m889.931,389.913c0.44007-2.87547,8.4343-51.4007,8.4343-51.4007'/%3E %3Cpath d='m882.486,383.084c2.20494-1.43773,8.82126-3.35527,8.82126-3.35527'/%3E %3Cpath d='m885.574,375.416c2.20493,0,6.61632-1.91753,6.61632-1.91753'/%3E %3Cpath d='m886.897,369.665c0-0.4798,6.61633-1.91753,6.61633-1.91753'/%3E %3Cpath d='M887.779,362.476,894.837,361.038'/%3E %3Cpath d='m890.867,356.245c0,0.4798,4.85147,0.4798,4.85147,0.4798'/%3E %3Cpath d='m892.19,350.494c0.88167,0,4.85147,0.95794,4.85147,0.95794'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m919.474,388.989c0.44159-7.38011,13.2326-49.3536,13.2326-49.3536'/%3E %3Cpath d='m923.885,387.605c0-0.46175,10.146-47.5082,10.146-47.5082'/%3E %3Cpath d='m928.296,383.914c0.44007-2.76734,7.498-43.8173,7.498-43.8173'/%3E %3Cpath d='m919.915,382.992c2.20494-1.38368,8.82126-3.2291,8.82126-3.2291'/%3E %3Cpath d='m923.003,375.612c2.20493,0,6.61632-1.84543,6.61632-1.84543'/%3E %3Cpath d='m924.326,370.077c0-0.46175,6.61633-1.84542,6.61633-1.84542'/%3E %3Cpath d='m925.208,363.159,7.05792-1.38367'/%3E %3Cpath d='m928.296,357.162c0,0.46176,4.85147,0.46176,4.85147,0.46176'/%3E %3Cpath d='m929.62,351.628c0.88167,0,4.85147,0.92192,4.85147,0.92192'/%3E %3C/g%3E %3Cg stroke-width='0.7371'%3E %3Cpath d='m877.156,384.068c-0.44159-7.42463-13.2326-49.6514-13.2326-49.6514'/%3E %3Cpath d='m872.744,382.676c0-0.46454-10.146-47.7948-10.146-47.7948'/%3E %3Cpath d='m868.333,378.963c-0.44007-2.78404-7.498-44.0817-7.498-44.0817'/%3E %3Cpath d='m876.714,378.036c-2.20494-1.39202-8.82126-3.24858-8.82126-3.24858'/%3E %3Cpath d='m873.626,370.611c-2.20493,0-6.61632-1.85656-6.61632-1.85656'/%3E %3Cpath d='m872.303,365.043c0-0.46454-6.61633-1.85656-6.61633-1.85656'/%3E %3Cpath d='m871.421,358.083-7.05792-1.39202'/%3E %3Cpath d='m868.333,352.05c0,0.46454-4.85147,0.46454-4.85147,0.46454'/%3E %3Cpath d='m867.01,346.482c-0.88167,0-4.85147,0.92748-4.85147,0.92748'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23b6b6b4' stroke-width='0.73708421' d='m834.995,359.359s-8.82127-1.38367-8.38119,0.92192c0.44159,2.30559,4.41139,4.61277,4.85298,5.99644,0.44008,1.38367-1.32326,6.45661,1.32327,5.99644,2.64653-0.46175,5.29306-2.30718,5.29306-3.69085s-0.44159-7.84027-0.44159-7.84027l-2.64653-1.38368z'/%3E %3Cg fill='none' stroke-width='0.7371'%3E %3Cpath d='m844.699,372.274c1.32326,0,11.4693,2.30559,11.4693,2.30559l10.5861,14.7602'/%3E %3Cpath d='m852.199,374.118c0.44008,0.46175,9.26286,31.3643,51.6089,31.3643s52.4921-35.0535,52.4921-35.0535'/%3E %3Cpath d='m962.916,371.351s-20.2906,46.1245-59.1084,42.8954c-38.8178-3.22751-44.9925-18.4495-48.0807-26.2898-3.08813-7.84186-4.85147-14.2985-4.85147-14.2985'/%3E %3Cg%3E %3Cpath d='m951.888,333.99c0.44159-1.38367,1.76486-29.0571,1.76486-29.0571'/%3E %3Cpath d='m982.765,347.828-27.3485-45.2026'/%3E %3Cpath d='m899.838,277.258c0-0.46175,13.6742,5.99644,13.6742,6.45661,0,0.46175,48.5208,67.8031,48.9623,67.8031'/%3E %3Cpath d='m938.214,283.714,12.351,5.53627,3.9698,10.1459'/%3E %3Cpath d='m861.462,282.793c-0.44159,0,13.6742,11.0694,13.6742,11.0694l1.76486,9.22553'/%3E %3Cpath d='m813.381,350.134c6.17473-2.76734,48.9623-41.9735,48.9623-41.9735'/%3E %3Cpath d='m801.912,342.754c5.29458-4.61277,48.0807-42.4336,48.0807-42.4336'/%3E %3Cpath d='m882.194,306.777,45.4341,78.8724'/%3E %3Cpath d='m922.268,339.393s5.35983,18.5828,10.6529,21.3501c5.29306,2.76734,11.4678,7.38011,11.4678,7.38011'/%3E %3Cpath d='m921.656,339.779s3.76493,21.8864,9.058,26.0375c5.29306,4.15101,10.5876,8.76378,10.5876,8.76378'/%3E %3Cpath d='m885.067,338.251s5.29306,30.4424,15.8807,37.3607c10.5861,6.91835,19.4074,12.9148,19.4074,12.9148'/%3E %3Cpath d='m884.627,337.79s11.4678,23.9858,21.1722,31.3659c9.70445,7.37852,22.9371,14.2985,22.9371,14.2985'/%3E %3Cpath d='m847.574,339.635c3.08661,5.53469,2.64653,16.1439,6.17474,19.8332,3.5282,3.69085,8.82278,11.9929,8.82278,11.9929'/%3E %3Cpath d='m848.456,340.097c1.76486,2.76735,6.68614,16.5469,9.70446,20.7551,2.20645,3.69084,24.702,27.2133,24.702,27.2133'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%23000' stroke-width='0.475'%3E %3Cellipse rx='3.308315' ry='3.45929' cx='872.054473' cy='389.218617'/%3E %3Cellipse rx='2.867176' ry='2.998061' cx='888.816847' cy='396.598727'/%3E %3Cellipse rx='2.867176' ry='2.998061' cx='909.549017' cy='398.444151'/%3E %3Cellipse rx='2.646652' ry='2.536816' cx='928.074732' cy='391.294124'/%3E %3Cellipse rx='2.426128' ry='2.998045' cx='942.190575' cy='382.30026'/%3E %3C/g%3E %3Cg fill='%23ff0101' stroke-width='0.7371'%3E %3Cpath d='m859.483,283.363c-1.32326,0.92351-23.3787,6.45819-20.2906,5.99644,3.0866-0.46017,20.7322,4.61277,20.2906,3.22909-0.44159-1.38367,0-8.30202,0-9.22553z'/%3E %3Cpath d='m896.978,276.445c-0.88319,0-13.6758,5.07452-13.2342,5.07452s14.5574,4.15102,14.1158,3.22751c-0.4416-0.92192-0.4416-6.91836-0.88167-8.30203z'/%3E %3Cpath d='m935.354,281.057c-0.88319,0.46175-15.8807,4.15101-13.2342,4.61277,2.64653,0.46175,12.7926,4.15101,12.7926,3.22909,0-0.9235,0-7.38011,0.44159-7.84186z'/%3E %3C/g%3E %3Cg fill='%23be1017' stroke-width='0.5813' transform='matrix(0.04915326,-1.2962189,1.2382477,0.05145445,0,0)'%3E %3Ccircle r='1.8894' cx='-216.002142' cy='726.376815'/%3E %3Ccircle r='1.8894' cx='-212.21777' cy='739.051036'/%3E %3Ccircle r='1.8894' cx='-219.249357' cy='732.917906'/%3E %3Ccircle r='1.8894' cx='-208.970565' cy='732.509881'/%3E %3Ccircle r='1.8894' cx='-214.109961' cy='732.713893'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM0,300V400H300V0H600z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%23002868'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M0,300 600,0' stroke='%23ce1126' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V400M0,150H700' stroke='%23ce1126' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%2368bfe5'/%3E %3Cg id='coa' stroke-miterlimit='4.8'%3E %3Cpath fill='%23fff' d='m778.8,143.94,0,205.09c0,67.08,121.2,106.91,121.2,106.91s121.2-39.833,121.2-106.91v-205.09z'/%3E %3Cpath fill='%23d21034' d='m883.2,216,0,92.344-104.4,0,0,33.6,104.4,0,0,107.6,16.8,6.396,16.8-6.396,0-107.6,104.4,0,0-33.6-104.4,0,0-92.344z'/%3E %3Cpath fill='%23d21034' d='m778.8,143.94,242.4,0,0,79.2-242.4,0z'/%3E %3Cg id='lion' stroke-miterlimit='3'%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.805'%3E %3Cellipse stroke-width='0.803' cx='798.23' cy='192.212' rx='13.623' ry='10.962'/%3E %3Cellipse cx='798.23' cy='186.525' rx='12.114' ry='6.123'/%3E %3Cellipse cx='798.23' cy='198.769' rx='12.114' ry='6.123'/%3E %3Cellipse cx='798.23' cy='192.213' rx='12.114' ry='6.123'/%3E %3C/g%3E %3Cpath fill='%23ffd100' stroke='%23000' stroke-width='1.2' d='m1015.2,207.43-1.9848-5.4756s-5.4336-2.2164-5.8476-5.1024c-0.9672-7.6944-3.714-10.578-7.83-11.678-4.1244-1.0992-6.8676,0.6888-6.8676,0.6888-1.2408,1.7868-7.4256,1.7868-10.859,1.9212-3.4344,0.1404-3.4932-1.4916-3.4932-1.4916-2.6676,0.0192-3.7896-1.9416-3.7896-1.9416-1.746-3.4872-3.0456-4.7916-3.9084-5.2332,4.4568,0.066,7.8132-1.9908,12.844-7.2696,5.4936-5.772,9.4152-3.54,9.4152-3.54-2.6664,5.3892,0.8868,4.9128,0.8868,4.9128,7.2804-3.7056,0.96-13.051-1.2372-12.638-2.1972,0.4104-2.8248-1.0692-2.8248-1.0692,0.0672,1.6776-2.4396,2.3448-2.4396,2.3448,1.8804-10.674-4.4892-13.504-4.4892-13.504-0.9636,0.9612-1.5156,2.8836-1.5156,2.8836-1.7832,6.4584-7.6908,5.4972-14.29,2.3352-6.5928-3.1584-24.179,3.3-29.672,5.4972-5.5008,2.1984-15.528,5.634-24.596,0.5496-9.0648-5.0868-11.269-4.1244-14.839-3.1608-3.5748,0.96-9.888,2.4756-12.222,1.236-2.3388-1.236-5.0028-1.3128-5.0028-1.3128,0.636-0.3552-0.3576-1.8468-0.3576-1.8468-2.7468-3.708,0.3576-5.9808,0.3576-5.9808s-5.1144,1.44-3.0804,10.169l0.9348,1.3092s0.6852,2.7456,2.2008,3.5712l-0.0552,0.6012s1.2936-0.6012,1.7004,1.1832c0.4176,1.7856,2.34,0.138,3.1644-1.3716,0,0-1.3764,7.9692,8.5188,9.8916,0,0-1.1064-1.2372-0.6924-2.0616,0.4104-0.8244-1.2336-1.5168-1.0944-2.7492,0.1356-1.2324-2.4696-1.7832-0.414-2.7492,2.058-0.9612,3.0252-2.886,7.4196-0.2748s7.8336,2.064,7.8336,2.064-2.6808-5.502-1.2036-5.4984c1.4772,0.002,8.1228,8.2296,11.394,7.8228,3.2724-0.4032,9.5928-4.1136,12.754-2.7396,0,0,0.2712-1.6488,12.36-3.7104,12.092-2.0616,27.006-8.0868,32.599-2.8068,0,0,0.654,4.182,2.9868,5.2824,0,0-0.4176,8.6544-15.385,3.8424l-5.43-1.428s-0.834-2.6292-29.304,4.6932c0,0-1.6752,0.5844-2.7744,1.4112-1.1028,0.8208-2.6148-0.414-8.2476,1.6452-5.628,2.0652-26.654,8.9352-39.564,6.4596l-0.0168,0.0348c-2.844-0.8496-5.508-0.4104-5.616-0.8592-0.1392-0.5496,1.5132,0.1392,1.5132,0.1392-0.96-1.1016-1.374-1.1904-1.374-1.1904-10.855-1.1904-8.9364-6.0936-8.9364-6.0936l0.5532,1.512c1.7868-2.334-0.6924-7.83-0.6924-7.83l-0.1044,0.018c-0.0276-0.1692-0.0588-0.3372-0.1008-0.5004l0.8976-0.6192c5.2224-4.398,11.269-5.2224,11.269-5.2224-3.5748-4.3944-11.134-2.058-11.134-2.058,0.1392-5.358-2.058-11.542-2.058-11.542-7.4232,0.8244-11.678,7.0056-11.678,7.0056-0.2748-5.4936-7.284-8.652-7.284-8.652,2.6076,3.1584,0.9636,10.714,0.9636,10.714l0.2748,0.138c-0.4344-0.0108-0.6888,0-0.6888,0l-0.156,1.62-0.2568-0.108s-2.6076,0.96-5.6292,7.83c0,0-0.306,1.6236-1.4748,3.0876-0.01-0.1896,0.0108-0.3612-0.0132-0.5592,0,0-3.3756,4.4232-11.176,0,0,0-10.598-6.288-14.323-6.0552-3.7248,0.2316-6.174,1.9788-5.9364,3.0264,0,0-8.5044-0.6996-11.413,4.1892,0,0-6.4032,2.3292-0.93,7.5696,0,0,0.7332,2.2776,2.3256,3.498,0,0-0.2256-4.7844,0.9336-3.378,0,0,0.3012,0.4716,0.8736,0.8016,0.1524,0.6708,0.666,2.5344,1.8036,3.4836l0.8196-0.2604c0.1248-1.1928,0.3828-2.7,0.648-3.3336,0.1248,0.0168,0.2244,0.0312,0.27,0.0348-0.036,0.0348-0.0696,0.0552-0.1044,0.0864l1.5132,2.3292,1.7448-0.9312c0.8172-0.1188,1.8636,0.6996,1.8636,0.6996l1.98-1.6308c-0.012-0.018-0.024-0.0216-0.036-0.0408,1.95,0.3264,2.4828-3.4536,2.4828-3.4536,1.752,0.4608,3.39-0.0552,4.7844-0.9,0.8496,3.1344,7.7916,6.4956,7.7916,6.4956s0.12-0.0108,0.2988-0.0252c-0.588,0.3756-0.9372,0.6576-0.9372,0.6576,3.1584,2.202,9.0672,1.6512,9.0672,1.6512-2.4708,0.9636-2.1252,5.5368-2.1252,5.5368-1.4436,0.5928-1.5852,2.0184-1.5852,2.0184,4.8096,1.9188,8.0952,0.33,8.0952,0.33,0.264,1.5648-0.1248,1.7316-0.1248,1.7316-1.9224,4.1208-2.7468,8.1048-2.7468,8.1048,0.042,0.018,0.0912,0.0276,0.132,0.042-0.0588,0.108-0.132,0.2124-0.1776,0.324,0,0-8.3832,2.91-12.109,6.9864,0,0-0.3504-1.1664-1.3992-1.1664-1.0476,0-4.308-2.6748-5.8224-3.1428-1.5108-0.4632-3.7248,0.468-4.308-0.2292-0.5268-0.636-0.2904-5.406-1.2984-6.1752,0.004,0,0.0192,0.004,0.0192,0.004l-1.0488-2.91c-0.6984,1.512-3.6084,1.1616-3.6084,1.1616-0.1152,0.0696-0.5628,0.396-1.1964,0.8688-0.5808,0.0312-1.2492-0.1692-1.2492-0.1692-0.2988,0.0612-0.594,0.9-0.8112,1.7148-0.1164,0.0864-0.2352,0.1764-0.3528,0.2664v-0.8172c-0.5796,0.4656-1.7448-0.2328-2.2128-0.2328-0.228,0-0.51,0.6672-0.7392,1.3524-1.1844,0.2196-2.754,0.2784-2.754,0.2784-0.4656,0.2328-0.1188,3.8424-0.1188,3.8424-3.3744,1.8648-1.746,4.6572-1.746,4.6572,1.8636,9.0828,17.35,5.0064,18.515,6.174,1.1616,1.1652,3.8424,1.3944,5.2404,1.3944,1.3944,0,3.1392,3.378,5.1216,3.7272,1.9812,0.3504,0-2.6772,9.1824-4.8708,9.1788-2.1936,12.239-5.958,12.239-5.958,2.8752-0.5544,3.6756-4.0488,3.8904-5.46,0.0276,0.6504,0.1044,1.3704,0.2088,2.19,0.414,3.1608-1.77,4.3116-1.77,4.3116l7.9548-2.388c3.1572-0.8244,2.7468-3.5748,2.7468-3.5748,3.0216,8.6568,8.5188,9.2064,8.5188,9.2064,1.0992-3.2988,0.9636-4.2612,0.9636-4.2612l2.472-0.1344c0.1008-1.8636-1.5444-3.2256-2.4972-3.8592l3.87,2.3472,1.5084-0.2748c0,1.374,2.0616,2.6076,2.0616,2.6076l0.2784-1.782c1.7868,2.3352,5.0832,1.5096,5.0832,1.5096-0.066-0.4152-0.1668-0.8448-0.2916-1.2828,7.0404,4.3452,18.286-1.1892,18.286-1.1892,3.0216,0.6864,3.4344-1.1004,3.4344-1.1004,3.4344,0.4104,4.2312-1.9368,4.2312-1.9368,8.0832-0.6996,13.772-6.4464,13.772-6.4464,3.9804-0.2748,4.11-3.1212,4.11-3.1212s3.9912,0.7872,7.8396-4.0224c8.928-12.775,22.28-6.1236,22.28-6.1236l-7.7196,0.4884c-20.194-0.1356-11.822,13.598-11.822,13.598l1.2444-0.132c1.9236,0.4116,8.5152,5.6328,6.0852,9.522-0.0384,0.0684-0.0912,0.1308-0.1356,0.1932-4.1172,5.6364-11.742,0.2604-13.915-4.4952-2.2008-4.8072-6.5988-3.7068-6.5988-3.7068s-11.401,1.9236-6.7308,10.991l0.1704,0.005c0.0864,2.2128,1.4748,4.734,5.5416,7.2396,2.2848,3.2316,9.7944,3.5688,15.31,2.3736,2.5668-0.5604,16.112-6.384,16.112-6.384,0.9936-2.9496,4.3596-2.2704,7.3812-6.5292s-4.26-5.772-5.9076-8.1048c-1.6512-2.3388,0.414-1.9248,0.414-1.9248,6.5916,3.5724,7.1412-7.8324,7.1412-7.8324,0.6888,6.5928,6.4572,8.3796,6.4572,8.3796,3.5748-3.5676,0.9672-10.852,0.9672-10.852,8.5188,15.25,13.678,12.822,13.678,12.822-4.5864-2.8392-2.2776-6.6396-2.2776-6.6396,4.1172,16.211,21.022,2.0616,21.022,2.0616-0.8244,2.3328,0.004,3.7056,1.5132,5.2176,1.5096,1.512,3.2964,2.1996,2.4756,4.9476-0.8268,2.7468-8.6532,2.1996-8.6532,2.1996s-7.698-0.4104-7.0068,6.0468c0.4032,1.5084,5.49,2.058,7.4136,1.6476,0,0-0.7932,0.1728,2.0508,0.5532,0.9528,0.1224,2.1036,0.1428,3.2748,0.1044,3.2784-0.1008,6.7704-0.6576,6.7704-0.6576,4.3908-0.9588,3.7068-2.4756,3.7068-2.4756,6.726-1.2396,7.4172-5.7756,7.4172-5.7756z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m791.954,179.295c0.005-0.007,0.3612-0.8484,1.0392-0.9492,0.5232-0.078,1.158,0.3096,1.8288,1.1244l0.3672-0.276c-0.0156-0.0276-1.8132-2.646-1.0968-4.4952,0.3192-0.8244,1.1136-1.3896,2.3568-1.6692l-0.1008-0.4524c-1.4028,0.3216-2.3052,0.9804-2.6856,1.9572-0.1416,0.3648-0.2016,0.7512-0.2016,1.1364,0,0.9036,0.318,1.8192,0.6444,2.5224-0.4068-0.2556-0.8028-0.3612-1.1832-0.3036-0.69,0.1044-1.026,0.6012-1.2084,0.9252z'/%3E %3Cpath d='m1004,215.28c-4.59,0.7284-11.328,1.1316-11.864-0.2568-0.0936-0.2472-0.1104-1.2384,3.648-3.6852l-0.438-0.6732c-3.1356,2.0424-4.398,3.5184-3.96,4.6464,0.9624,2.4996,10.799,1.0716,12.763,0.7584z'/%3E %3Cpath d='m916.2,217.93c-1.0464-1.6008-0.576-3.7932,1.398-6.5232l-0.6504-0.4692c-2.1936,3.018-2.6712,5.5236-1.422,7.434z'/%3E %3Cpath d='m910,211.02c0.1008,2.7684,2.0556,5.3388,5.7996,7.632l0.4212-0.6864c-3.5052-2.1432-5.3232-4.4904-5.418-6.9732-0.138-3.8124,3.8904-6.7524,3.9288-6.7836l-0.4692-0.654c-0.1812,0.1284-4.4184,3.216-4.2624,7.4652z'/%3E %3Cpath d='m988.29,212.05c-1.2588,1.8588-0.8376,4.11-0.8208,4.2048l0.7884-0.1548c-0.007-0.0216-0.372-2.0256,0.7032-3.6036,0.6456-0.9492,1.686-1.5648,3.0972-1.8324l-0.1452-0.7896c-1.6344,0.3096-2.85,1.0404-3.6228,2.1756z'/%3E %3Cpath d='m808.92,176.89-0.2484-0.0624-0.0336,0.2556c-0.007,0.0252-0.3576,2.4636-1.464,3.1272-0.3096,0.1848-0.6432,0.2052-1.0284,0.0648l-1.878-1.1424c-0.3744-0.33-0.696-0.5724-1.2372-0.414-0.108-0.1392-0.5388-0.7236-0.5388-1.662,0-0.1044,0.007-0.216,0.0228-0.3288,0.1332-1.1004,0.9012-2.1612,2.2896-3.1512l-0.264-0.3756c-1.5048,1.0752-2.3376,2.2428-2.484,3.48-0.168,1.4328,0.6612,2.406,0.6972,2.448l0.1116,0.1284,0.1524-0.0696c0.4176-0.1848,0.5388-0.0756,0.9456,0.2844l2.0268,1.2324c0.5148,0.1896,0.9912,0.1548,1.422-0.102,1.1448-0.6852,1.5456-2.6808,1.6392-3.2352,4.8768,1.0488,8.802-4.8792,8.9724-5.1348l-0.39-0.252c-0.0348,0.0624-4.0404,6.1344-8.7132,4.9092z'/%3E %3Cpath d='m797.23,175.98c-0.2436,0.9876-0.0768,1.9572,0.4872,2.8824,0.5388,0.8772,1.0692,1.344,1.6224,1.4172,0.6744,0.0936,1.2132-0.4068,1.6884-0.8448,0.3456-0.324,0.6744-0.6252,0.9444-0.6048l0.4188,0.2892,0.3612-0.2868-0.7476-0.4608c-0.4716-0.0348-0.8676,0.3324-1.29,0.726-0.4212,0.3864-0.8532,0.7932-1.314,0.7296-0.3996-0.0552-0.8316-0.462-1.29-1.206-0.4968-0.8148-0.6468-1.6692-0.4356-2.5308,0.5256-2.1756,3.1272-3.774,3.1548-3.7896l-0.2364-0.3924c-0.1164,0.0672-2.7912,1.7088-3.3636,4.0716z'/%3E %3Cpath d='m790.52,207.04c0.2328-0.8412,0.8796-1.5576,1.9188-2.1348-0.2052,0.0192,1.0188,1.0152,2.0688,0.9036,0,0,0.426-0.2292,0.6816-0.3684,0.2784,0.24,2.0964,1.8948,2.0964,3.9912,0,0.4416-0.0804,0.894-0.2784,1.3536l0.426,0.1788c1.3296-3.15-2.0148-5.9436-2.046-5.9736l-0.1224-0.096-0.2064,0.1332-0.5964,0.324c-0.8592,0.09-1.9788-0.8184-1.9872-0.8268-1.4112,0.6156-2.1324,1.4304-2.4,2.3988z'/%3E %3Cpath d='m806.05,199c-1.0044,0.0852-3.8016,0.6192-4.7148,2.0712-0.33,0.5268-0.3792,1.1064-0.1392,1.7328l0.3672,0.9768c0.8712,2.3436,1.776,4.7652,2.7624,5.3124l0.2232-0.4008c-0.8376-0.4644-1.7496-2.9124-2.556-5.0712l-0.3648-0.9768c-0.1872-0.4944-0.156-0.9288,0.0948-1.3284,0.75-1.1904,3.2652-1.7652,4.3656-1.8564,0.6408-0.0516,0.8496,2.3136,0.9768,3.7272l0.4572-0.042c-0.1836-2.0832-0.3768-4.236-1.4724-4.1448z'/%3E %3Cpath d='m798.38,201.3c-0.588,0.5256-0.4692,1.3176-0.462,1.3524,0.005,0.2172,0.2664,6.0672,3.0444,7.2768l0.1824-0.4212c-2.514-1.0956-2.7672-6.8448-2.7708-6.9012-0.001-0.0348-0.0828-0.6156,0.3168-0.966,0.4212-0.3744,1.2588-0.4032,2.4204-0.084l0.1224-0.4416c-1.3404-0.3696-2.3004-0.3084-2.8536,0.1848z'/%3E %3Cpath d='m796.18,201.78c-1.2288,0.8556-1.1784,3.2976-1.1772,3.3996l0.4596-0.008c0-0.0252-0.0456-2.3028,0.9804-3.0144,0.3828-0.264,0.8868-0.2748,1.5012-0.0276l0.1704-0.4248c-0.7656-0.312-1.4184-0.2868-1.9344,0.0756z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m862.33,169.49c0.0216,0.0384,1.3104,2.9448,1.3104,5.3052,0,0.4188-0.198,0.7164-0.2916,1.0812-0.0516-0.1356-0.5004-1.3668-0.5004-1.3668l-0.3888,0.9876c-0.018,0.0552-0.5256,1.3836,0.3816,2.8824,1.2,1.9776,4.1868,3.2436,8.8836,3.7584h-0.002c0,0.004,0.0588,0.0552,0.066,0.0648-0.1944,0.0264-0.3408,0.0804-0.3852,0.1224l-0.1884,0.1596,0.0252,0.4008c0.1212,0.4872,0.678,0.5112,1.7832,0.5532,0.1872,0.0108,0.4908,0.0552,0.7056,0.066,0.2748,0.0768,0.5568,0.1536,0.5568,0.1536s-0.0768-0.0888-0.0936-0.108c1.0704,0.0732,2.274,0.3372,3.5808,0.8256-0.2892,0.0756-0.9948,0.252-0.9948,0.252l1.1616,0.4584c0.0876,0.0348,8.6484,3.474,12.191,6.3024-1.0056,0.8724-5.2992,4.08-12.736,2.2476l-1.2456-0.306,0.8448,0.9648c0.0516,0.0576,4.896,5.6136,5.9004,8.9832-1.6872,0.0168-8.1852-0.042-10.456-1.9716l-0.588,0.5352c0.0312,0.0492,3.1152,4.5756,3.804,8.1048-0.8832,0.1164-3,0.2028-4.2516-1.4328l-0.5772-0.7512s-0.2328,1.5168-0.3132,2.0376c-0.6048-0.456-1.3668-1.1376-1.3668-1.8672v-0.48s-1.5924,0.2892-1.8324,0.3324c-0.2124-0.1272-2.85-1.728-3.7656-2.2824-0.324-0.21-0.5352-0.33-0.6048-0.3648-0.004-0.004-0.0348-0.0228-0.0348-0.0228l-0.0276-0.0156-0.39,0.7056s0.4488,0.2676,0.5772,0.348c0.8064,0.5256,2.1864,1.6704,2.3256,3.1884-0.5952,0.0348-2.448,0.1356-2.448,0.1356l0.0456,0.426v0.0672c0,0.252-0.0792,1.3044-0.8484,3.6792-1.158-0.276-5.3688-1.7436-7.8576-8.874l-0.7752,0.192c0.004,0.0192,0.0132,0.114,0.0132,0.2652,0,0.6492-0.2292,2.2788-2.4648,2.8596-0.0132,0.004-4.1508,1.248-6.4524,1.9368,0.4308-0.6156,0.8244-1.4604,0.8244-2.6844,0-0.2604-0.0168-0.54-0.0516-0.8376-0.1392-1.0356-0.2232-1.8984-0.2232-2.6184,0-1.5012,0.3684-2.3952,1.4052-3.0312l-0.3612-0.7164c-0.0972,0.0384-9.618,3.8196-14.339,2.25,0.216-0.9216,1.0152-4.1616,2.628-7.6152l-0.2088,0.198c0.3096-0.132,0.6252-0.6156,0.3648-2.166l-0.0864-0.528-0.4836,0.2328c-0.0312,0.0144-3.0528,1.3632-7.4172-0.2364,0.0888-0.3576,0.3204-1.0008,1.2348-1.38l0.2676-0.108-0.0252-0.2916c0-0.0108-0.0108-0.2136-0.0108-0.5316,0-1.1784,0.1848-3.9396,1.8804-4.602l-0.18-0.7764c-0.0552,0.007-5.1612,0.4152-8.2572-1.3068,0.8124-0.5604,2.5188-1.5924,4.5048-1.878l0.318-0.0456,0.0228-0.318c0.004-0.0156,0.0108-0.1092,0.0108-0.2592,0-0.4032-0.156-1.2192-0.5112-2.0412,1.1784,0.3288,2.5908,0.6252,3.0912,0.2496l0.1704-0.1284-0.1464-3.0984-0.8028,0.0384s0.0972,2.0544,0.1224,2.562c-0.504,0.0276-1.788-0.2292-3.0348-0.6252l-1.2336-0.3924,0.7944,1.0236c0.6456,0.8292,0.7272,1.8588,0.7368,2.3316-2.79,0.5184-4.9752,2.2512-5.0688,2.3292l-0.4104,0.3372,0.4344,0.3036c2.4,1.6716,6.1536,1.8168,8.0808,1.7748-1.1364,1.2792-1.3284,3.4212-1.3284,4.4916,0,0.2196,0.007,0.2784,0.0108,0.3864-1.3632,0.7356-1.5684,2.118-1.5768,2.1816l-0.03,0.3012,0.282,0.1152c4.1244,1.644,6.9408,0.8508,7.8972,0.4968,0.007,0.1284,0.0348,0.3024,0.0348,0.3936,0,0.378-0.0696,0.4932-0.0696,0.4932-2.0268,4.248-2.8752,8.286-2.886,8.3244l-0.066,0.3336,0.3132,0.1248c3.828,1.53,10.705-0.5592,13.751-1.6344-0.3996,0.6888-0.6324,1.464-0.6324,2.4288,0,0.8088,0.0972,1.7184,0.2328,2.7312,0.0348,0.2568,0.0492,0.4944,0.0492,0.7236,0,2.28-1.5408,3.1428-1.614,3.1812l0.306,0.7404,7.9548-2.3892c1.8396-0.4776,2.5308-1.5648,2.8236-2.4888,3.1392,7.4436,8.0664,8.1144,8.2848,8.1396l0.3204,0.0276,0.1008-0.3024c0.7656-2.2872,0.942-3.4488,0.9768-4.0092,0.5316-0.024,2.4624-0.132,2.4624-0.132l0.0204-0.3612c0.004-0.0624,0.004-0.1224,0.004-0.1812,0-0.6588-0.2052-1.2408-0.4896-1.764,0.4968,0.3,1.3764,0.834,1.3764,0.834s0.9108-0.1656,1.3176-0.24c0.3444,1.3296,1.9236,2.3736,2.1276,2.4984l0.5112,0.3072s0.1884-1.212,0.2676-1.74c1.9644,1.758,4.7532,1.2348,4.8852,1.2024l0.3516-0.09-0.0516-0.3576c-0.3996-2.688-2.2044-5.886-3.2652-7.596,3.4908,1.5876,9.8496,1.4712,10.163,1.4616l0.474-0.0168-0.0936-0.4644c-0.564-2.8248-4.0932-7.272-5.5704-9.0408,8.202,1.542,12.607-2.7132,12.796-2.9064l0.288-0.306-0.3168-0.2784c-2.7576-2.4012-9.1128-5.19-11.665-6.2568,0.1392-0.0348,0.894-0.2256,0.894-0.2256l-0.8832-0.4944c-2.1348-1.2-4.398-1.3488-5.928-1.4148l-0.007-0.012c-0.9708-1.1112-1.464-1.2888-1.5888-1.3164-5.5464-0.612-7.5792-2.166-8.3172-3.366-0.0624-0.0984-0.0312-0.1656-0.0768-0.2616,0.1188-0.1596,0.2436-0.318,0.2436-0.318,0.5352-0.6972,0.726-1.6296,0.726-2.6172,0-2.5464-1.2936-5.4564-1.3668-5.6244l-0.738,0.3336z'/%3E %3Cpath d='m836.8,167.86c-0.0168,0.0792-0.6084,3.1188-3.1956,4.5432-1.9476,1.0704-4.5204,0.9816-7.6392-0.2664l-0.3516-0.1392,0.0372,0.3756c0.008,0.078,0.2136,1.8636,1.8972,3.1716,1.4016,1.092,3.408,1.4748,5.922,1.2-0.8412,0.9984-3.5436,4.452-3.5436,7.8024,0,0.1764,0.0108,0.354,0.0276,0.528,0.3444,0.2472,4.5792,1.3944,6.5436-1.116,0.0696,1.0764,0.3792,4.5216,1.7244,5.8692,0.7368,0.7332,0.9108,1.8048,0.9108,2.6604,0,0.7716-0.1464,1.3668-0.1464,1.3788l-0.1524,0.6132,0.5112-0.372c0.1632-0.1188,4.0572-2.9712,5.3016-6.7068-0.004,0.01,0.6228-0.9372,1.8252-1.3248-0.0252,0.1632-0.0456,0.33-0.0456,0.5628,0,1.4436,0.6324,4.0644,4.836,5.6712l0.3444,0.132-0.0312-0.3672c-0.004-0.008-0.0276-0.2964-0.0276-0.726,0-1.0548,0.1464-2.9928,1.1508-3.9972,0.6612-0.66,0.8592-1.404,0.8592-2.0484,0-0.5076-0.1116-0.918-0.2256-1.2204,0.8484,0.2148,2.8548,0.8616,3.672,2.3904,1.1856,2.2224,5.3376,0.4536,5.5152,0.3792l-0.1428-0.4368c-0.0168,0.004-1.746,0.3912-2.8368-0.3576-0.48-0.33-0.768-0.8376-0.8688-1.5108l-0.192-2.31c-0.042-1.0464-0.1872-1.7112-0.7128-2.2704,0.5496-0.0504,1.6512-0.0312,2.118,1.0008,0.7332,1.6164,3.2508,1.7736,3.3552,1.782l0.8616,0.0456-0.7236-0.468c-0.024-0.0144-2.1972-1.4568-1.8216-3.336l0.3132-1.3764c0.5952-2.4804,1.5852-6.6324,0.7788-9.1812l-0.438,0.1404c0.1992,0.636,0.282,1.3896,0.282,2.196,0,2.2596-0.6396,4.944-1.0716,6.738l-0.3168,1.3944c-0.0384,0.1812-0.0516,0.3648-0.0516,0.5388,0,1.2168,0.7896,2.1456,1.4052,2.7048-0.7404-0.1596-1.7664-0.5124-2.1516-1.3704-0.6048-1.326-2.2284-1.3872-3.0036-1.23l-0.5424,0.1092,0.462,0.3072c0.7296,0.4872,0.7512,1.0536,0.8028,2.2932l0.1944,2.358c0.1152,0.804,0.4728,1.4184,1.0608,1.824,0.5148,0.3504,1.116,0.3996,1.6656,0.4392-1.2336,0.3216-2.9244,0.522-3.5316-0.6192-1.1448-2.1324-4.2912-2.7024-4.4232-2.7276l-0.48-0.0828,0.24,0.4212c0.0252,0.0456,0.3576,0.6516,0.3576,1.422,0,0.546-0.1668,1.1712-0.7332,1.7352-1.116,1.1256-1.2864,3.1668-1.2864,4.296,0,0.2208,0.0108,0.252,0.0144,0.3864-3.5952-1.5108-4.2312-3.7488-4.2312-5.016,0-0.5388,0.1044-0.8976,0.1188-0.9444l0.1044-0.354-0.36481,0.0612c-1.746,0.288-2.472,1.71-2.5032,1.77-0.9984,2.9916-3.7092,5.3592-4.6908,6.1488,0.0312-0.2496,0.066-0.5412,0.066-0.8952,0-0.9348-0.2016-2.1264-1.05-2.976-1.4292-1.4292-1.6236-5.9736-1.6236-6.0192l-0.0312-0.8208-0.3996,0.7128c-1.5816,2.8332-6.1992,1.4724-6.2448,1.4604-0.1944-3.5796,3.8664-8.16,3.9084-8.2068l0.4248-0.4716-0.6264,0.0924c-2.652,0.384-4.7112,0.0288-6.1224-1.0608-1.1052-0.8568-1.5024-1.9476-1.644-2.4984,3.0756,1.146,5.6556,1.2096,7.6416,0.1128,2.7744-1.5336,3.3828-4.6752,3.4068-4.8072,2.9136-6.606,5.4588-7.6488,5.4864-7.656l-0.1596-0.4308c-0.1152,0.0396-2.7396,1.0728-5.7684,7.95z'/%3E %3Cpath d='m843.45,158.07-0.1944,0.007-2.364,3.24,0.702,0.0696c12.829,1.248,19.613,8.988,19.679,9.0684l0.2964,0.3444,2.3256-2.5272-0.1704-0.2604c-6.5052-10.244-20.135-9.9468-20.274-9.942zm0.2196,0.804c1.5852,0.004,13.271,0.3648,19.189,9.3312-0.2892,0.3132-0.9348,1.0188-1.2792,1.3968-1.3872-1.4376-7.962-7.5816-19.237-8.9064,0.4368-0.6012,1.164-1.5984,1.3272-1.8216z'/%3E %3Cpath d='m841.6,164.84c-1.0956,1.4952-2.1144,3.7068-2.1144,4.7424,0,0.198,0.0384,0.354,0.1224,0.4524,0.007,0.01,0.0456,0.0132,0.0588,0.0288-1.3356,1.1976-2.1312,3.1968-2.1312,5.4564,0,1.2432,0.2196,2.538,0.6816,3.7728l0.2568,0.6948c1.2588,3.4248,2.3436,6.384,7.788,4.6416,5.244-1.6752,5.4492-2.0112,6.7704-4.1892l0.3444-0.564c0.72-1.17,1.506-1.404,2.3436-1.6524,0.9984-0.3,2.034-0.6072,2.9412-2.4l0.8832-1.3236c0.9528-1.3128,2.142-2.94,2.2848-5.0232l-0.4596-0.0312c-0.132,1.95-1.2792,3.5184-2.1972,4.7808l-0.9216,1.3872c-0.8208,1.6164-1.7148,1.884-2.664,2.1672-0.8832,0.2628-1.7904,0.534-2.604,1.8528l-0.348,0.5664c-1.2696,2.0964-1.4316,2.3664-6.5124,3.9936-5.0268,1.6068-5.946-0.9-7.218-4.3632l-0.2568-0.702c-1.4328-3.8184-0.3132-7.6692,1.5504-9.0492l0.6396-0.4752s-0.7932,0.0888-0.8868,0.1008c-0.01-0.0384-0.0204-0.072-0.0204-0.132,0-0.624,0.6816-2.6112,2.0376-4.464,1.158-1.578,3.8904-3.1416,3.9192-3.1572l-0.2292-0.3984c-0.1152,0.0684-2.8452,1.6296-4.0584,3.2868z'/%3E %3Cpath d='m839.16,178.65c0.9,0.624,2.166,0.5808,3.6924,0,0.007,0.5436,0.1284,1.6992,1.0776,2.538,1.116,0.9876,2.9652,1.1784,5.4996,0.5736l-0.108-0.4452c-2.3748,0.5664-4.0884,0.4068-5.0868-0.4692-1.0716-0.9456-0.9216-2.4504-0.918-2.4636l0.042-0.3936-0.3648,0.1548c-1.5372,0.6624-2.7396,0.702-3.5748,0.1248-1.4952-1.0392-1.3836-3.7548-1.38-3.786l-0.4596-0.0216c-0.002,0.1236-0.1272,3.0024,1.5804,4.188z'/%3E %3Cpath d='m842.07,174.99c-0.6564,0.156-0.8268,0.7056-0.8268,1.1304,0,0.102,0.0108,0.1968,0.024,0.2784,0.1152,1.182,1.398,1.9692,2.5632,2.3064,1.1328,0.3276,2.5272,0.3492,3.0768-0.3564,0.2196-0.282,0.3792-0.7896-0.1008-1.6104-1.7496-2.976-4.5804-1.8108-4.7364-1.7484zm1.8876,3.2712c-1.0188-0.2916-2.142-0.9528-2.232-1.9332-0.0216-0.0936-0.132-0.7524,0.4488-0.8904l0.0456-0.0144c0.1044-0.0468,2.6112-1.1364,4.1904,1.5504,0.2808,0.4788,0.3264,0.8448,0.132,1.092-0.3384,0.4404-1.4544,0.5268-2.5848,0.1956zm-1.9332-3.2544c0.004-0.004,0.0456-0.018,0.0456-0.018l-0.0456,0.018z'/%3E %3Cpath d='m843.65,180.98c-0.2952,2.514-0.1152,2.574,0.066,2.6304l0.1596,0.0504,0.18-0.2124,1.4568-1.92-1.8288-0.8664-0.0336,0.318zm0.4212,0.3756c0.2604,0.1224,0.5004,0.2364,0.7368,0.348-0.198,0.2532-0.5664,0.744-0.8448,1.1112,0.007-0.3792,0.0528-0.9132,0.108-1.4592z'/%3E %3Cpath d='m839.86,178.96-0.0972,2.376,1.9956-2.4132-1.8876-0.2088-0.0108,0.246zm0.4488,0.2664c0.1764,0.0204,0.3024,0.0312,0.552,0.0588-0.1944,0.234-0.324,0.3924-0.5844,0.7068,0.0192-0.3696,0.0264-0.5748,0.0324-0.7656z'/%3E %3Cpath d='m838.53,178.2c0.0168,0.0312,1.4844,2.9004,1.7448,3.9468,0.1668,0.6648,1.0152,1.422,2.0268,1.7976,1.008,0.3792,1.9536,0.318,2.6592-0.174l1.3248-1.1016c0.4416-0.4248,0.588-0.5436,0.9456-0.4824l0.0768-0.4536c-0.6012-0.1008-0.894,0.1788-1.3392,0.6036l-1.2696,1.0572c-0.7824,0.546-1.7388,0.3132-2.2392,0.1212-0.9456-0.3504-1.6308-1.0284-1.7424-1.4808-0.2748-1.0944-1.7208-3.9192-1.7796-4.0404l-0.408,0.2064z'/%3E %3Cpath d='m840.44,169.6c-1.62,0.7476-2.3052,2.7132-2.3328,2.796l0.4344,0.1512c0.007-0.0192,0.654-1.8696,2.0928-2.5308,0.702-0.3216,1.488-0.3108,2.3436,0.0252l0.1704-0.4248c-0.9732-0.3924-1.884-0.396-2.7084-0.0168z'/%3E %3Cpath d='m851.33,174.76c0.1284,0.096,3.1884,2.4144,1.4292,5.2428l0.39,0.2436c1.9848-3.1884-1.5132-5.8308-1.5444-5.8584l-0.2748,0.372z'/%3E %3Cpath d='m842.13,175.21s-0.4764,1.7292,1.9572,2.34c0,0-2.2884-0.0192-2.4336-0.6108-0.1536-0.5904,0.0132-1.8996,0.4764-1.7292z'/%3E %3Cpath d='m849.57,177.28c0,0.15-0.1224,0.2736-0.2712,0.2736-0.1464,0-0.2712-0.1236-0.2712-0.2736,0-0.1476,0.1248-0.2712,0.2712-0.2712,0.15,0,0.2712,0.1236,0.2712,0.2712z'/%3E %3Cpath d='m849.84,178.36c0,0.15-0.1224,0.2748-0.2712,0.2748s-0.2676-0.1248-0.2676-0.2748c0-0.1464,0.1188-0.27,0.2676-0.27s0.2712,0.1248,0.2712,0.27z'/%3E %3Ccircle cx='848.01' cy='177.825' r='0.27'/%3E %3Cpath d='m848.75,179.45c0,0.1464-0.1224,0.2676-0.2712,0.2676-0.1464,0-0.2676-0.1212-0.2676-0.2676,0-0.1512,0.1224-0.2748,0.2676-0.2748,0.1488,0,0.2712,0.1224,0.2712,0.2748z'/%3E %3Cpath d='m841.65,172.13c0,0.15-0.1212,0.2724-0.2748,0.2724-0.1464,0-0.2712-0.1236-0.2712-0.2724,0-0.1464,0.1248-0.2712,0.2712-0.2712,0.1536,0,0.2748,0.1248,0.2748,0.2712z'/%3E %3Ccircle cx='841.65' cy='173.22' r='0.27'/%3E %3Ccircle cx='840.09' cy='172.68' r='0.27'/%3E %3Cpath d='m840.83,174.3c0,0.1464-0.1248,0.2712-0.2748,0.2712-0.1464,0-0.2676-0.1248-0.2676-0.2712,0-0.1512,0.1224-0.2748,0.2676-0.2748,0.1488,0.001,0.2748,0.1236,0.2748,0.2748z'/%3E %3Cpath d='m845.57,164.75s3.5184,2.1648,0.132,6.228c0,0,1.6656-1.2372,1.836-3.3624,0.1776-2.1228-1.2072-3.816-1.968-2.8656z'/%3E %3Cpath d='m859.07,170.59c-1.1328,0.582-2.7636-0.4956-3.5808-1.5144-0.8136-1.0188-2.4996-1.2792-3.5496,0.5808-1.0476,1.8636-2.5596,2.562-2.5596,2.562s1.4772-0.8724,2.9976-2.5032c1.512-1.6272,2.3856-0.3204,3.87,0.4656s1.7172,0.9588,2.7636,0.552l0.0588-0.1428z'/%3E %3Cpath d='m858.78,170.86c-0.4632,0.348-1.3116,0.6396-2.2116-0.09-0.9-0.7272-1.6584-1.7148-2.7924-1.134-1.1376,0.5844-3.2928,2.2116-3.2928,2.2116s3.4944-2.4168,4.1652-1.8912c0.6672,0.5256,2.2428,1.8048,3.2016,1.4292,0.9612-0.3828,0.93-0.5256,0.93-0.5256z'/%3E %3Cpath d='m856.1,172.34c-1.1052-0.8436-2.2116,0.9888-3.1428,0.7596-0.9312-0.2364-1.6896-1.7784-1.6896-1.7784s0.876,1.6308,2.0964,1.2516c1.224-0.3768,2.0688-1.1352,2.8236-0.5544,0.7572,0.5844-0.0876,0.3216-0.0876,0.3216z'/%3E %3Cpath d='m854.37,172.57c-2.1828,0.2256-2.3988-1.8132-2.3988-1.8336,0,0,0.6888,1.7796,2.6184,1.4568l-0.2196,0.3768z'/%3E %3Cpath d='m854.3,171.18c0.1428,0.552,0.1116,0.8028-0.4728,0.8028-0.588,0-0.9876-0.1956-0.9876-0.7656,0-0.5712,1.374-0.3924,1.4604-0.0372z'/%3E %3Cpath d='m846.46,168.15c0,0.3792-0.3132,0.6852-0.6996,0.6852s-0.462-0.2604-0.462-0.636,0.0756-0.7296,0.462-0.7296,0.6996,0.306,0.6996,0.6804z'/%3E %3Cpath d='m844.05,165.71s3.7404,0.0396,1.8876,4.7196c0,0,1.4256-2.3292,0.5316-4.0056-0.8976-1.674-2.3052-1.2516-2.3052-1.2516s-0.3432,0.3168-0.114,0.5376z'/%3E %3Cpath d='m843.94,167.58c-0.0108,0.9384,0.6156,1.9068,1.8564,2.8764l0.2856-0.36c-1.1232-0.876-1.6896-1.7208-1.6824-2.5068,0.007-0.786,0.612-1.2528,0.6192-1.2588l-0.2748-0.3708c-0.0324,0.0264-0.7908,0.6036-0.804,1.62z'/%3E %3Cpath d='m844.77,168.37c0.1596,0.5388,0.5772,0.9456,1.2444,1.212l0.1704-0.4248c-0.528-0.21-0.8556-0.5184-0.9732-0.9132-0.2364-0.7956,0.4032-1.7244,0.4104-1.7316l-0.372-0.2676c-0.036,0.048-0.7788,1.1208-0.48,2.1252z'/%3E %3Cpath d='m849.9,170.97s0.696,1.512-0.3204,3.1428c-1.0188,1.6308-0.9912,1.5444-0.9912,1.5444s1.224-2.2416,0.7584-3.1752c-0.462-0.9312,0.5532-1.512,0.5532-1.512z'/%3E %3Cpath d='m864.45,186.76c3.8424,0.7236,12.51,7.5204,12.6,7.59l0.498-0.636c-0.3648-0.282-8.9148-6.9852-12.948-7.7436l-0.15,0.7896z'/%3E %3Cpath d='m867.86,196.35c0.2568,3.4092,3.9672,5.5284,4.1268,5.6136l0.3924-0.6996c-0.0384-0.018-3.4908-1.9956-3.72-4.9752l-0.7992,0.0612z'/%3E %3Cpath d='m858.65,197.06c0,3.8244,3.5844,8.4504,3.738,8.6472l0.6324-0.4968c-0.0348-0.0432-3.5676-4.602-3.5676-8.1504h-0.8028z'/%3E %3Cpath d='m846.5,197.49c0.6324,1.2624,0.5664,1.902,0.4032,2.2152-0.1908,0.3528-0.5808,0.4068-0.594,0.4104l0.0936,0.8004c0.2952-0.0348,0.8868-0.24,1.2-0.816,0.3828-0.7008,0.2532-1.6992-0.3828-2.964l-0.72,0.354z'/%3E %3C/g%3E %3Cg fill='%23fff' stroke='%23000' stroke-width='0.36'%3E %3Cpath d='m791.86,178.63s0.2328,2.5596,2.2116,4.0788c0,0-0.2328-2.7996,0.3504-3.96,0-0.001-1.0464-1.1652-2.562-0.1188z'/%3E %3Cpath d='m795.81,180.26s0.468,2.3256,1.8648,3.3756l0.8196-0.2328s0.348-2.9136,0.8136-3.2616c0.4656-0.3468-1.9788,1.0476-3.498,0.1188z'/%3E %3Cpath d='m799.31,180.14,1.5132,2.3292,1.7448-0.9312-0.348-2.7924s-1.0464-0.2364-2.91,1.3944z'/%3E %3Cpath d='m806.41,180.61-1.98,1.6308s-1.0464-0.8172-1.8636-0.6996l0.3516-2.562s1.3968-1.0476,3.492,1.6308z'/%3E %3Cpath d='m792.32,204.71s-0.348-3.6096,0.1188-3.8424c0,0,1.3944,0.4656,1.9776-0.1188,0,0,0.816,2.9136,0.582,4.0776-0.2316,1.1628-1.6284,0.7008-2.6784-0.1164z'/%3E %3Cpath d='m801.29,200.98s-0.1152-3.0276,0.4656-3.3792c0,0,2.91,0.3504,3.6084-1.1616l1.0488,2.91s-3.2604-0.3504-5.1228,1.6308z'/%3E %3Cpath stroke-width='0.35' d='m798.15,201.56s0.5808-3.1428,1.1652-3.2592c0,0,1.5132,0.4644,1.9788-0.12l-0.1152,3.846c0-0.001,0.1152-1.632-3.0288-0.4668z'/%3E %3Cpath stroke-width='0.35' d='m794.77,202.03s0.6984-2.7948,1.1652-2.7948c0.468,0,1.632,0.6984,2.2128,0.2328v2.0964s-2.5656-0.5808-2.9112,2.91l-0.4668-2.4444z'/%3E %3C/g%3E %3C/g%3E %3Cg id='sugarcanes' fill='%2300a651' stroke='%23000' stroke-width='0.78'%3E %3Cpath d='m840.16,260s7.914,7.35,5.8452,13.758c0,0,5.0868-10.932-0.3756-14.137-5.4696-3.2028-5.6568-0.7476-5.4696,0.3792z'/%3E %3Cpath fill='%23964b36' d='m830.17,267.15s-2.07,2.8332,0.1884,4.9056c0,0-2.448,3.5748-0.5604,6.5952,0,0-1.5108,3.2028-1.1328,6.5964,0,0-1.3212,5.2752,1.5048,7.7292,0,0,3.018,1.5084,4.3392,0.1884,0,0,2.6364-3.9564,0.9384-8.1084,0,0,1.8852-3.39-0.1872-7.7256,0,0,0.5664-2.4504-1.1304-5.274,0,0,1.1304-1.8876,0.186-3.3936,0,0-3.7668-3.9612-4.146-1.5132z'/%3E %3Cpath d='m832.43,257.92s-9.4224-18.09-16.02-18.848c-6.5976-0.7548-6.972-7.1604-6.972-7.1604s0.7524,3.0156,6.0312,3.0156c5.2776,0,15.456,7.3488,16.585,13.003,1.1292,5.6532,2.2632,4.902,2.2632,4.902l-1.8876,5.088z'/%3E %3Cpath d='m832.43,256.6s3.3936-22.805,18.286-23.184c14.885-0.3792,9.9888,1.1304,13.567-1.3212,0,0-9.9852,5.2812-16.208,6.0324-6.2172,0.7536-11.308,12.812-11.119,15.079,0.1872,2.2596-3.3912,6.5964-5.088,5.0904-1.6968-1.5084,0.5628-1.6968,0.5628-1.6968z'/%3E %3Cpath d='m835.82,265.09s3.3912-9.0468,9.2352-6.0288c0,0-4.5264-8.6736-12.629-1.134,0,0,3.582,4.8996,3.3936,7.1628z'/%3E %3Cpath d='m824.51,256.03s4.902,20.17-2.6388,26.387c0,0,0.1872-10.361-4.3356-16.582-4.5204-6.2232,4.5228-13.003,6.9744-9.8052z'/%3E %3Cpath d='m825.08,259.62s8.8608,8.484,9.4272,11.31c0.5664,2.8272,2.6364-8.4804-1.5084-11.682-4.1472-3.2088-8.67-3.7728-8.67-3.7728l0.7512,4.1448z'/%3E %3Cpath fill='%23964b36' d='m808.74,281.85s0.8028,3.5604,2.988,4.2492c0,0,0.1128,2.646,2.0676,3.4488,0,0-1.0368,2.184,0.6912,3.5604,0,0-0.348,4.3668,1.2624,5.2884,0,0,3.9108-0.2292,5.2848-1.38,0,0,0.8064-2.868-1.374-5.7468,0,0,0.3408-2.7576-1.8432-4.2492,0,0,0.69-3.6816-2.0688-5.058,0,0-0.4572-2.9904-2.184-4.482,0.001-0.001-3.33,4.71-4.824,4.3692z'/%3E %3Cpath d='m813.1,277.48s-11.606-4.2516-18.042,1.8396c0,0,9.8808,1.38,11.147,3.3336,1.2636,1.95,7.3524-3.216,6.8952-5.1732z'/%3E %3Cpath d='m809.54,284.72s-0.918-0.8028-2.0664-1.6092c-1.1496-0.8028-10.916-3.4464-12.299,5.976,0,0-3.564-9.3072,1.608-10.573,5.1756-1.266,9.312,1.7244,12.757,6.2064'/%3E %3Cpath d='m801.9,265.46s3.5772,7.7256,4.8996,8.1084c1.3188,0.372,2.2596-0.942,2.2596-0.942s-4.71-6.9744-7.1592-7.1664z'/%3E %3Cpath d='m799.26,253.59s-3.018-9.9876-6.5964-7.35c-3.5808,2.6388-2.6388,9.798-2.6388,9.798s-7.1628-7.3464-3.018-13.192c4.152-5.8416,12.253,0.5664,12.253,10.744z'/%3E %3Cpath fill='%23964b36' d='m807.37,274.13s0,1.8852,1.32,2.448c1.32,0.5664,3.7692,1.5048,3.7692,0.3792,0-1.1304-1.8828-5.466-2.6412-4.8996-0.7548,0.5676-2.0688,0.5604-2.448,2.0724z'/%3E %3Cpath d='m805.11,262.45s-0.3768-8.6676,5.274-11.876c0,0,1.134,0.1944,1.7004-1.5012,0,0-4.5288,10.927-3.2076,16.393l-0.1872,0.7548'/%3E %3Cpath d='m806.24,251.89s10.177-21.112,22.618-13.762c0,0-13.004,2.64-17.714,11.876l-4.7148,6.9672-0.1884-5.082z'/%3E %3Cpath d='m800.77,259.62s-3.0168-14.134-4.9008-16.016c-1.8864-1.8864-5.0904-3.9588-8.8608-0.756,0,0,6.5988-5.8452,13.572-0.942,6.9708,4.9008,5.4636,12.628,5.4636,12.628l-0.7512,9.8016-4.7124-4.3356'/%3E %3Cpath d='m811.7,276.39s-12.44-23.552-20.542-6.78c0,0-1.512,4.332,0.1836,6.0252,0,0-4.524-3.39-2.4492-11.682,2.07-8.2896,15.828-4.524,19.79,2.2632,3.9564,6.7836,5.0904,10.18,4.524,10.552-0.5676,0.3792-1.5072-0.378-1.5072-0.378z'/%3E %3Cpath d='m846.76,283.18s9.0504-18.66,14.324-10.18c0,0,1.506,4.1448-0.7572,5.8452,0,0-3.5772-4.3356-6.78,0.942-3.2052,5.2752-1.8852,4.902-1.8852,4.902s-3.3936,0.942-4.902-1.5096z'/%3E %3Cpath d='m860.32,278.84s4.8996,2.6352,3.2088,7.9128c0,0,6.5916-12.625-2.4516-13.758,0.001,0,1.698,3.96-0.7572,5.8452z'/%3E %3Cpath d='m860.89,266.03s11.876,3.39,12.252,8.484c0,0,2.076-9.8052-4.7112-12.82,0.001,0.001-8.1072,1.3224-7.5408,4.3356z'/%3E %3Cpath d='m866.17,250.38c5.0904-9.9888,11.498,3.204,11.498,3.204s2.2596-10.364-4.1448-12.252c-6.4116-1.884-10.556,22.05-10.556,22.05l-7.5408,1.6968s2.0748-20.917,13.382-22.805l1.3176,0.1908'/%3E %3Cpath d='m857.12,256.41s-7.1592-14.7-12.061-16.206c-4.902-1.5084,2.6424-3.7704,5.6568-0.9444,3.0108,2.8248,8.6652,6.408,8.1012,13.948l-1.6968,3.2028z'/%3E %3Cpath d='m849.77,276.58s2.0724-9.9852,7.7256-13.003c5.6532-3.018,10.932-1.884,10.932-1.884s-6.7872,1.5048-7.914,4.902c-1.1328,3.39-3.018,3.5772-3.018,3.5772l-7.7256,6.408z'/%3E %3Cpath fill='%23964b36' d='m846.76,283.18s-3.2028,6.0324-2.4516,6.972c0,0-3.39,4.8996-2.0724,7.35,0,0,3.3936,2.6388,4.902,1.506,0,0,3.9528-5.4624,2.8236-8.4804,0,0,2.6388-3.5772,1.7004-5.838,0,0-3.9564,0.1872-4.902-1.5096z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m830.18,272.41c0.2124,0.108,2.1156,1.032,3.396,0.6048l0.9156-0.7824-0.72-0.3576c-0.4692,0.9312-2.5416,0.1632-3.234-0.18l-0.3576,0.7152z'/%3E %3Cpath d='m829.87,278.26-0.156,0.7896c0.162,0.0312,3.9864,0.7716,5.8104-0.8484l-0.5352-0.5988c-1.524,1.3524-5.0808,0.6684-5.1192,0.6576z'/%3E %3Cpath d='m828.9,284.92-0.4716,0.6504c0.0456,0.0348,4.4892,3.1992,7.3332-0.2568l-0.6228-0.5112c-2.3616,2.868-6.0804,0.2328-6.2388,0.1176z'/%3E %3Cpath d='m811.64,285.88,0.1668,0.4308c0.1596-0.066,3.9252-1.578,4.164-4.332l-0.4572-0.042c-0.2148,2.472-3.8376,3.9288-3.8736,3.9432z'/%3E %3Cpath d='m813.77,289.32,0.0324,0.4584c0.1464-0.0108,3.6228-0.2712,4.23-2.7012l-0.4488-0.1152c-0.5232,2.1072-3.78,2.3544-3.8136,2.358z'/%3E %3Cpath d='m814.49,292.88-0.0252,0.462c0.1668,0.007,4.0608,0.2088,5.382-1.9476l-0.3924-0.2436c-1.1796,1.9272-4.926,1.7328-4.9644,1.7292z'/%3E %3Cpath d='m844.02,290.44c0.0696,0.0732,1.7484,1.7316,3.7092,1.6584,0.96-0.0348,1.812-0.4764,2.5308-1.3032l-0.6084-0.528c-0.5664,0.6528-1.224,1.0008-1.9476,1.0284-1.6056,0.0588-3.1044-1.4076-3.1188-1.4256l-0.5652,0.57z'/%3E %3C/g%3E %3C/g%3E %3Cg id='palm'%3E %3Cg fill='%23964b36' stroke='%23000' stroke-width='0.42'%3E %3Cpath d='m961.06,304.22c-0.2088,0.0804-0.4176,0.2052-0.6084,0.4032l0.6084-0.4032z'/%3E %3Cpath d='m974.92,300.75c-0.1344-0.3444-0.222-0.1992-0.3996-0.3516-0.2532-0.2088-0.3996-0.876-0.6228-1.1256-0.132-0.1524-0.2844-0.004-0.4272-0.042-0.324-0.7128-0.7056-1.464-1.0464-2.1516,0.0528-0.0792,0.0864-0.174,0.0936-0.3204,0-0.0276-0.1596-0.5772-0.1704-0.6012-0.0972-0.1524-0.2508-0.0624-0.3444-0.2988-0.1044-0.2364-0.0252-0.702-0.0624-0.9804-0.0276-0.2328-0.1188-0.3612-0.1044-0.6888,0.0144-0.2844,0.1668-0.6156,0.1488-0.8652-0.007-0.156-0.1908-0.5076-0.246-0.6396-0.2232-0.5388-0.4104-1.0464-0.438-1.7112-0.0276-0.6012,0.0936-0.9696,0.138-1.4916,0.0564-0.62521-0.2748-0.92881-0.2748-1.506,0.004-0.4416,0.1908-0.9384,0.2436-1.3344,0.0732-0.5424,0.0792-1.3284,0.0336-1.884-0.0408-0.5316-0.1908-0.852-0.108-1.4496,0.0216-0.1464,0.0912-0.264,0.108-0.4692-0.004-0.1464-0.004-0.288-0.004-0.4308v-0.858c0-0.2784,0.0276-0.5916,0.004-0.8628-0.024-0.2256-0.156-0.4584-0.156-0.636,0-0.306,0.1944-0.4512,0.1524-0.8664-0.0264-0.2988-0.0696-0.3684-0.138-0.6288-0.132-0.4932-0.042-0.9912-0.1224-1.5192-0.0384-0.2532-0.1188-0.3336-0.1428-0.6228-0.0336-0.3408,0.0708-0.4584,0.1044-0.6996,0.0348-0.24,0.0708-0.5556,0.0384-0.81-0.0384-0.306-0.1836-0.522-0.1428-0.8556l-0.1116,3.7824c-0.0936-3.3-0.2256-6.3552-0.2256-6.3552l-5.0184-2.3568s-0.4248,9.2136-0.3168,10.496c0.1008,1.2864,0.5316,10.076,0.3168,11.147-0.216,1.0716-0.744,6.4284-0.744,6.4284s-2.454,1.7148-3.414,3.6408c-0.9636,1.9296-0.7476,2.5728-1.0716,2.5728l2.3844-0.372-1.776,1.1856c0.366-0.13801,0.7512-0.108,1.1064,0.1716,0.0408,0.0336,0.306,0.2604,0.3396,0.2604,0.0936,0,0.2232-0.2388,0.3372-0.2808,0.3696-0.1248,0.6816,0.5676,1.032,0.5148,0.1884-0.0276,0.4452-0.2256,0.5988-0.4272,0.1272-0.1704,0.1764-0.46921,0.3096-0.58321,0.1224-0.1044,0.4212,0.0168,0.5496,0.0168,0.3504,0,0.7056,0.0108,1.056,0,0.4668-0.0132,0.8448-0.6708,1.2756-1.0428,0.4008-0.3372,0.696-0.456,1.1244-0.4308,0.4692,0.0348,0.8928,0.4728,1.3704,0.5004,0.3612,0.018,0.612,0.0624,0.9036-0.3168,0.2016-0.264,0.3444-0.6564,0.5352-0.9312l1.1856-0.1836c0.2352,0.0972,0.4752,0.2052,0.6768,0.198,0.3024-0.0144,0.6156-0.0516,0.9156-0.004,0.114,0.0144,0.3396,0.282,0.4332,0.216,0.0636-0.0492,0.1716-0.4104,0.2364-0.5184-0.0264-0.1452-0.0708-0.5064-0.1236-0.6276z'/%3E %3Cpath d='m964.77,304.05c0.3024,0,0.5796-0.0696,0.834,0.15241,0.042,0.0804,0.0792,0.1572,0.1188,0.2328,0.0828,0.0564,0.1704,0.0672,0.2508,0.0348,0.1704,0.1152,0.2052,0.18,0.3924,0.2232,0.174,0.0372,0.3648-0.007,0.5388-0.004,0.2196,0.007,0.3264,0.0828,0.5316,0.1668,0.3576,0.1464,0.594,0.007,0.9036-0.216,0.3588-0.264,0.4896-0.0624,0.834,0.2688,0.258,0.246,0.2052,0.2232,0.438,0.0552,0.0348-0.0792,0.0756-0.156,0.1152-0.2232,0.1152-0.048,0.2328-0.0792,0.3504-0.1008,0.192-0.09,0.3828-0.0792,0.564-0.1488,0.1908-0.0744,0.33-0.2856,0.5316-0.2472,0.174,0.0348,0.3732,0.1764,0.5388,0.2292,0.1596,0.0552,0.2292,0.0864,0.3624,0.1836,0.2388-0.49321,0.768-0.63961,1.1052-0.87841,0.3516-0.2436,0.678,0.0516,1.0644,0.0552,0.2052,0,0.288-0.1188,0.4344-0.1668,0.1632-0.06,0.3504,0.0264,0.5076-0.0384,0.1668-0.0624,0.198-0.2232,0.38161-0.2436,0.3408-0.042,0.72,0.5136,1.0608,0.618,0.1908,0.0636,1.0752,0.26161,0.9456-0.3888-0.1248-0.6192-0.6804-0.1908-0.7992-0.6252-0.0636-0.2472,0.066-0.5988-0.0108-0.876-0.066-0.2532-0.3444-0.546-0.5112-0.6012-0.2088-0.066-0.33,0.1524-0.5076-0.018-0.1464-0.1356-0.2016-0.6432-0.33001-0.8448-0.1716,0.1248-0.2784,0.24-0.504,0.1944-0.258-0.0624-0.2328-0.15-0.4248-0.3936-0.4176-0.522-0.6576,0.3132-1.0428,0.1812-0.2928-0.0936-0.564-0.8304-0.7932-1.1304-0.1224-0.1596-0.4668-0.678-0.6432-0.5628-0.2988,0.1944-0.0276,0.7584-0.1836,1.008-0.1116,0.174-0.5076-0.004-0.6504,0.024-0.2256,0.0492-0.2676,0.108-0.4308,0.3792-0.33,0.546-0.522,0.9804-1.0356,0.918-0.2436-0.0276-0.4272-0.2748-0.6648-0.1848-0.2532,0.0972-0.396,0.3684-0.6744,0.3996-0.2016,0.0168-0.4344,0.024-0.6324-0.0516-0.1944-0.0876-0.414-0.4524-0.5916-0.5532-0.0756-0.0624-0.1524-0.0756-0.2388-0.0456-0.0216-0.0108-0.2892-0.1668-0.2928-0.1668-0.3096-0.09-0.2844-0.0792-0.4104,0.33-0.0732,0.2532-0.1008,0.5148-0.1944,0.7548-0.09,0.2016-0.288,0.4512-0.4032,0.5868-0.216,0.2328-0.3204,0.1704-0.6012,0.2544-0.2256,0.0732-0.5256,0.4248-0.6468-0.0276-0.18-0.6816,0.5004-1.7004-0.258-1.5228-0.198,0.0456-0.3168,0.0828-0.438,0.3756-0.1344,0.3372-0.0264,0.5556-0.0864,0.9252-0.0792,0.4656-0.9672,1.248-0.792,1.6692,0.1188,0.29641,0.5148-0.1596,0.6228-0.0864,0.18,0.1248,0.1284,0.42121,0.2568,0.61921,0.2688,0.4104,1.0644-0.63601,1.11-0.0696'/%3E %3Cpath d='m961.55,300.4c-0.002-0.0588-0.0132-0.1152-0.0168-0.1764-0.2124-0.0384-0.4524-0.264-0.6468-0.2676-0.1836-0.0108-0.5424,0.438-0.6684,0.6528-0.3888,0.6432-0.2808,1.5192-0.9348,1.506-0.1596-0.004-0.5352-0.1116-0.6756-0.0144-0.246,0.174-0.09,0.6888-0.09,1.0392,0,0.33,0.15,0-0.0264,0.4284-0.0528,0.1176-0.2124,0.156-0.2544,0.3132-0.132,0.55921,0.3336,0.38161,0.5388,0.37561,0.528-0.004,1.0536-0.004,1.5756,0,0.3168,0.007,0.5076-0.1044,0.8028-0.21961,0.1944-0.066,0.6084-0.0624,0.7728-0.2364,0.0588-0.066,0.2508-0.5076,0.2772-0.612,0.042-0.216-0.0408-0.4764,0.0108-0.6564,0.0828-0.3168,0.366-0.1956,0.4176-0.6228,0.1356-1.0476-0.9828-0.264-0.8064-1.2936'/%3E %3C/g%3E %3Cg fill='%23000' stroke='%23000' stroke-width='0.78'%3E %3Cpath d='m974.21,271.28c0,1.356-0.9276,2.448-2.0784,2.448-1.1364,0-2.0724-1.092-2.0724-2.448,0-1.3524,0.9348-2.4516,2.0724-2.4516,1.1496,0.001,2.0784,1.0992,2.0784,2.4516z'/%3E %3Cpath d='m967.43,268.26c0,1.3524-0.9288,2.448-2.0736,2.448-1.1472,0-2.0784-1.0956-2.0784-2.448s0.9312-2.4504,2.0784-2.4504c1.1448,0,2.0736,1.098,2.0736,2.4504z'/%3E %3Cpath d='m971.01,269.2c0,1.356-0.9288,2.448-2.0736,2.448s-2.0724-1.092-2.0724-2.448,0.9276-2.4504,2.0724-2.4504,2.0736,1.0956,2.0736,2.4504z'/%3E %3Cpath d='m967.54,271.44c0,1.356-0.9324,2.454-2.076,2.454s-2.0724-1.0992-2.0724-2.454c0-1.3524,0.9276-2.448,2.0724-2.448s2.076,1.0944,2.076,2.448z'/%3E %3Cpath d='m970.76,273.31c0,1.3524-0.9348,2.454-2.0748,2.454-1.1436,0-2.076-1.1016-2.076-2.454s0.9324-2.448,2.076-2.448c1.1388,0.001,2.0748,1.0956,2.0748,2.448z'/%3E %3C/g%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.78' d='m971.76,246.58s20.918-29.209,43.348,1.134c0,0,0.1872,3.018-1.8852,6.2196l-0.5664-2.448-1.3188,0.3744-0.3756-1.5072-2.4552-0.1872,0.7584-3.2052-2.6424,2.0736,0.3792-2.2632-3.0156,3.0204,0.3792-6.4116-3.2064,5.466,0.3756-3.7668-1.1292,1.6932-0.68041-2.196-1.0128,2.196-1.512-1.128v1.5072l-2.6352-2.262-0.942,3.0144-1.3188-3.2016-0.378,2.2596-1.3224-2.6388-0.1836,2.8284-4.3392-1.8864,0.942,2.6388-2.0688-1.5048,0.3756,1.5048-2.8236-0.5628,0.1848,1.6944-3.0156-0.5664,0.5676,1.506-4.1484-0.5616,1.5024,1.6956-0.4176,0.69s22.66-7.4724,24.168,20.796l-4.1472,2.0724,1.1328-2.256-1.1328-0.7572-3.39-2.6352,0.942-3.5844-1.1292,0.3792-0.1908-2.0724-0.564,0.3756-1.3224-2.0724-0.3756,0.75479-0.942-2.454-0.942,1.7004-0.5676-4.1484-1.5048,2.6424-0.192-1.5084-0.5664,0.942-1.884-2.2632-0.5604,1.5084-0.7584-1.1304-0.5628,1.3176-2.0736-1.8876v1.5132l-1.3176-1.134-0.5712,0.7548-3.198-1.6968-0.19561,1.5048-1.692-1.5048-0.5676,1.5048s20.549,11.689,14.137,30.725l-1.134,2.448-0.372-6.4044-1.884,3.39,1.3104-7.35-1.3104,1.3176-0.1944-2.8236-1.6896,2.8236-0.5748-3.2016-0.7476,0.942-1.1364-4.902-0.942,2.076-1.506-5.466-1.1292,2.2596-0.75481-4.7076-0.7548,2.826-2.2632-4.1484-0.3732,1.6932-1.3176-3.39-0.7584,1.134s-3.7692-0.192-4.8984-1.134c-1.1304-0.9384-4.3356,5.6568-4.3356,5.6568l0.378-3.96-1.3176,2.6352v-2.6352l-2.4516,7.914-0.5664-5.6532-1.3188,4.8996-0.5676-1.5048-0.3756,2.0748-0.7548-0.7572-0.6576,2.2248-1.23-0.9036v3.0144l-1.1292-1.5084-0.942,4.524-0.564-1.8804v2.0688l-0.942-1.1256-0.9456,4.524-1.3176-1.884-0.1848,3.1992,0.5604,2.454-1.506-0.7548,0.5676,3.9528s-5.844-10.927,1.1328-21.484c6.9684-10.549,16.393-13.379,16.393-13.379l-0.9456-0.9384-0.1872-0.9456-5.6532,2.826,0.1908-1.7004-1.5096,1.3212-0.3756-1.884-0.9456,1.6968-0.1836-0.7548-1.3224,2.076-0.7572-3.018-0.9396,3.5844-0.8892-2.5068-1.9368,5.3292v-3.9564l-1.5084,4.1484-0.564-4.524-1.1292,5.274v-4.7112l-1.7004,4.7112-1.1292-4.5204-0.7548,4.332-1.1292-3.39-1.134,5.0868-1.6932-4.524-0.942,6.7872-1.1292-2.6424-0.1908,4.902-1.3152-3.0144,1.3152,6.4044-1.6968-2.448,0.5676,3.9564-2.448-4.3356,0.1872,5.094-1.3212-1.7004-0.5676,1.8852s-0.5604-19.6,12.816-23.372c13.386-3.768,22.055,1.1328,22.055,1.1328l-5.0868-4.1448,0.564-1.3212h-1.884l0.7536-1.5084-3.9564,0.1908,1.1292-1.5084-3.018,0.3756v-0.9408l-1.884,1.5036,0.7548-1.6932-2.6388,1.6932-0.1608-2.5068-1.3488,2.1348-0.7476-2.2632-6.0348,6.0276,1.6956-6.2172-1.1292,1.3212-0.1872-1.3212-1.6968,2.6412-0.378-1.8864-0.7548,2.2596-0.5676-2.6364-1.314,2.6364-1.3224-2.4456-0.5628,3.2052-0.9456-1.7004-1.1304,2.4504-1.5048-1.5096-0.1908,1.5096-3.0156-1.32,0.7548,2.2632-2.2632-1.884-0.5676,3.0144-1.3152-1.5084-0.942,3.7728-0.942-3.5832-0.942,2.8272s11.786-30.286,41.605-10.526c0,0,3.2472,3.1752,4.002,5.436,0.7548,2.2632,0.1908,0.3804,0.1908,0.3804l-0.5676-20.921,1.1304,9.0468,0.7536-3.2052-0.1872,4.7124,3.012-6.5976s-3.5772,10.933-2.2608,14.89c0,0,1.3224-12.626,5.8488-14.136l-4.1484,9.0456,1.3176-0.1896-0.942,1.8876h1.1304l-1.3668,2.9904-0.7068,1.5336,0.7512,1.506,1.1388-1.1412z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m968.66,258.87,0.594,0.5352c0.0804-0.0828,1.944-2.0688,5.0736,0.5736l0.5184-0.6156c-3.7416-3.1644-6.1692-0.522-6.186-0.4932z'/%3E %3Cpath d='m967.75,248.61-0.1224,0.7248s1.0764-0.4584,1.4532-0.6204c-0.2328,0.4152-0.9984,1.7484-0.9984,1.7484s1.5816-0.5256,2.1672-0.7212c-0.9456,1.2384-2.688,3.5172-2.688,3.5172l0.6396,0.4944,4.2768-5.6016s-1.9692,0.6576-2.6568,0.8868c0.2772-0.4824,1.14-2.0052,1.14-2.0052s-1.7448,0.75-2.298,0.9876c0.1524-0.9288,0.4752-2.874,0.4752-2.874l-0.7956-0.1332-0.5928,3.5964z'/%3E %3Cpath d='m963.76,248.84s0.528,1.1688,0.9252,2.0388c-0.1716-0.0708-1.4748-0.5928-1.4748-0.5928l4.3488,7.6944s0.5256-0.6708,0.5568-0.7128c-0.438,1.1232-0.876,2.256-0.876,2.256l0.7512,0.2928,1.8744-4.8228-0.6912-0.39241s-1.0284,1.3176-1.5096,1.9332c-0.4068-0.7236-1.9116-3.3864-2.6256-4.6452,0.09,0.0336,1.2072,0.4836,1.2072,0.4836s-0.8208-1.812-1.2036-2.6532c0.5076,0.3168,1.6308,1.0188,1.6308,1.0188v-2.868h-0.804v1.4184c-0.6252-0.39-2.6628-1.662-2.6628-1.662l0.5532,1.2132z'/%3E %3Cpath d='m961.02,258.5,0.3204,0.7368c1.1772-0.504,2.148-0.588,2.8848-0.2364,0.8628,0.414,1.1232,1.3032,1.1256,1.3104l0.7752-0.2088c-0.0108-0.0516-0.3516-1.248-1.5432-1.8216-0.9516-0.4584-2.1516-0.3852-3.5628,0.2196z'/%3E %3Crect width='4.2659' height='0.80638' x='-412.82' y='911.45' transform='rotate(-98.911264)'/%3E %3Crect width='3.3937' height='0.80643' x='-559.16' y='836.26' transform='rotate(-108.438572)'/%3E %3Crect width='3.3157' height='0.80642' x='-496.74' y='877.86' transform='rotate(-104.075153)'/%3E %3C/g%3E %3C/g%3E %3Cg id='dove'%3E %3Cg stroke='%23000' stroke-width='0.78' fill='%2300a651'%3E %3Cpath d='m811.41,365.04s-3.534-1.6056-5.1432-0.4308c-1.608,1.182-1.3884,2.8932-2.7828,2.7852,0,0,5.3544,1.1784,6.5316-0.216,1.1772-1.3872,1.3944-1.8192,1.3944-1.8192'/%3E %3Cpath d='m812.06,366.52s-2.3256,3.1092-1.5216,4.9296c0.8016,1.8228,2.5224,1.9788,2.1156,3.3156,0,0,2.3016-4.974,1.1964-6.426-1.1052-1.4424-1.4748-1.7448-1.4748-1.7448'/%3E %3Cpath d='m808.14,357.91s-3.7104,1.1508-4.1256,3.0948c-0.426,1.9464,0.8784,3.0864-0.2328,3.9312,0,0,4.782-2.6796,4.7376-4.506-0.0456-1.8228-0.1632-2.2836-0.1632-2.2836'/%3E %3Cpath d='m810.32,359.19s1.7592-3.4668,0.6516-5.118c-1.1052-1.6632-2.832-1.5204-2.6616-2.904,0,0-1.4136,5.2956-0.0732,6.5364,1.3428,1.23,1.7628,1.4676,1.7628,1.4676'/%3E %3Cpath d='m806.68,357.93s0.0852-3.876-1.632-4.8888c-1.7148-1.0152-3.2088-0.1416-3.6576-1.4676,0,0,1.026,5.3892,2.7732,5.928,1.746,0.5256,2.2272,0.5568,2.2272,0.5568'/%3E %3Cpath d='m813.02,364.39s4.068-1.3968,4.392,2.9976c0.3204,4.3908-0.216,2.8932-0.216,2.8932s-2.142-4.7124-4.4964-5.4636l0.3204-0.4272z'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m811.99,366.59c0,0.0936,0.426,3.414,0.426,3.414l0.5724-0.0732-0.4308-3.3216c0.0144,0.004,1.3908-7.3008,1.3908-7.3008l-0.5676-0.1044-1.3908,7.386z'/%3E %3Cpath d='m808.29,365.51-0.1896,0.5424c1.9452,0.684,4.6608-1.4544,4.7736-1.5444l-0.36-0.4476c-0.024,0.0168-2.5776,2.034-4.224,1.4496z'/%3E %3Crect width='10.201' height='0.80398' x='-888.86' y='44.844' transform='rotate(-153.165895)'/%3E %3Crect width='0.80159' height='2.574' x='-825' y='316.26' transform='rotate(-134.967588)'/%3E %3Crect width='4.6033' height='0.80282' x='-665.49' y='585.05' transform='rotate(-114.758335)'/%3E %3Cpath d='m812.67,364.42,0.0516,0.804c2.4756-0.168,3.0804,1.4352,3.084,1.4532l0.7896-0.1644c-0.0936-0.4584-1.0848-2.2836-3.9252-2.0928z'/%3E %3C/g%3E %3Cpath d='m854.43,366.27c3.0348-1.7004,3.6432-7.6572,3.6432-7.6572-0.72601,2.1912-6.3108,4.3752-6.3108,4.3752,4.1268-2.556,9.102-14.084,9.102-14.084-1.3344,4.1292-12.138,7.5264-19.061,11.411-6.9228,3.8832-3.2784,15.058-3.2784,15.058-1.9404-1.3368-5.706-7.2828-6.432-12.509-0.7332-5.2188-2.796-7.2804-7.5312-7.8888-4.7376-0.6084-7.5288,4.7316-7.5288,4.7316l-7.0404,3.6468,7.1592,0.24s5.106,1.704,5.106,5.7096c0,4.0092-4.4928,20.035,2.91,29.022,5.1528,6.2448,24.166,9.8328,24.166,9.8328' stroke='%23000' stroke-width='1' fill='%23FFF'/%3E %3Cpath d='m840.47,378.65s1.4568-7.1652,6.192-6.9216c4.7352,0.2424,6.0708-5.34,8.8632-6.192,2.7924-0.8484,17.242-4.7316,18.821-11.656,0,0-1.3356,11.416-14.568,17.122,0,0,10.681-3.5232,11.898-5.8308,0,0-4.7388,10.2-16.272,11.778,0,0,10.806-0.8484,12.385-3.7608,0,0-4.8576,6.4332-12.869,7.2852,0,0,7.4052,3.0348,9.3492,0.4836,0,0-4.008,4.7352-8.988,5.0964l1.3392,0.366s-4.7352,5.5872-9.9576,1.8216c-5.2188-3.7656-5.3436,0.9744-5.3436,0.9744' stroke='%23000' stroke-width='1' fill='%23FFF'/%3E %3Cpath d='m851.25,389.45s6.0984,10.202,6.7068,15.665c0,0,11.658,12.872,16.028,13.595,0,0-2.0652,0.8484-5.8308-2.3052,0,0,3.1572,3.2784,3.7656,3.4008,0.6048,0.12482-2.5512-0.2436-3.0384-1.0956,0,0,1.338,1.9476,2.1864,2.19,0.852,0.2436-0.8484-0.2424-0.8484-0.2424s-1.5816-0.2436-2.3088-0.852c-0.7296-0.6048-0.2436,1.5756-0.2436,1.5756s-1.8216-0.486-2.4264-1.092c-0.6084-0.6048,0.2436,1.3392,0.2436,1.3392l-1.578-0.366-1.092,0.726s-0.1224,0.7296-0.8556,0.1224c-0.7236-0.6012-2.0616,0-2.0616,0s-0.9744,0.852-1.4568,0.2436c-0.4824-0.606-2.3232,2.3352-2.3232,2.3352l-7.6452-18.455' stroke='%23000' stroke-width='1' fill='%23FFF'/%3E %3Cg fill='%23000'%3E %3Crect width='20.776' height='1.146' x='-773.68' y='563.31' transform='rotate(-117.71558)'/%3E %3Crect width='24.817' height='1.1507' x='-892.01' y='365.7' transform='rotate(-131.769152)'/%3E %3Crect width='25.786' height='1.1485' x='-923.37' y='286.33' transform='rotate(-137.017935)'/%3E %3C/g%3E %3Cg fill='%23000'%3E %3Cpath d='m823.44,360.84s-1.2312-2.2044-2.3028-1.3764c-1.0692,0.8256-1.6848,0.9768-1.8696,0.9192,0,0,1.0752,0.0588,1.686-0.522,0.6132-0.5856,1.656-0.216,2.4864,0.9792z'/%3E %3Cpath d='m816.78,359.83s0.6756,1.398,0.6852,1.422c-0.0684,0.004-0.7632,2.2572-0.7632,2.2572l0.5532,0.1704,0.75-2.454c-0.0132-0.2124-0.7032-1.6416-0.7032-1.6416l-0.522,0.246z'/%3E %3Cpath d='m823.16,360.5s-0.918,1.0752-2.1756,0.7656c-1.2528-0.306-1.2528-0.306-1.2528-0.306s1.0668,0.06,1.776,0.0936c0.7008,0.0288,1.6188-0.3372,1.6524-0.5532z'/%3E %3Cpath d='m822.86,360.72s-1.1316-1.1952-1.8996-0.858c0,0,1.35-0.4308,2.1156,0.7296l-0.216,0.1284z'/%3E %3Cpath d='m822.67,360.5s-1.2864,0.8868-2.6988-0.09l-0.0864-0.066,0.1836-0.0588c0.001,0.001,1.7772,0.7344,2.6016,0.2148z'/%3E %3Ccircle cx='821.5728' cy='360.2836' r='0.3828'/%3E %3C/g%3E %3Cpath d='m822.61,394.2s-0.996,1.8336-0.4752,2.9388c0.528,1.1028,2.8908,1.6752,3.2052,3.1464,0.3168,1.4748,1.1052,1.4712,2.208,1.266,1.1052-0.2124,1.314-0.264,1.314-0.264s-4.6248-2.4732-5.8344-6.4608l-0.4176-0.6264z' fill='%23000'/%3E %3C/g%3E %3Cg id='bananas'%3E %3Cg stroke='%23000' fill='%23964b36' stroke-width='0.48'%3E %3Cpath d='m972.09,356.85s8.418-11.099,15.882-8.184c7.4652,2.9172,12.316,4.3212,12.316,4.3212s0.1416,7.4748-3.828,7.4748c-3.96,0-7.7568-7.4652-11.366-5.2464-3.6156,2.2152-6.5844,5.25-6.8184,6.2964-0.2328,1.0476-9.5616,1.2828-6.1848-4.662z'/%3E %3Cpath stroke-width='0.78' d='m940.14,410.37s-2.328,2.4444-1.278,3.0312c1.0536,0.5808,3.1464-0.1224,3.1464-0.9348-0.001-0.8208-1.3956-2.3292-1.8684-2.0964z'/%3E %3Cpath stroke-width='0.78' d='m938.28,412.7s-4.3116-2.4552-7.6944,3.3756c-3.3864,5.8296-6.1812,15.277-8.1636,16.561-1.9812,1.2816,19.241-9.3288,19.475-13.759,0,0,1.3968-5.7156-0.8172-5.6016-2.2152,0.1224-2.3328,0.3564-2.7996-0.576z'/%3E %3Cpath d='m938.86,413.4s-4.4292,1.0428-5.3616,7.3368c-0.9324,6.3036-7.1148,9.5652-7.4628,9.7968'/%3E %3Cpath d='m1000.3,352.99s-6.738,2.3436-5.574,7.0104'/%3E %3C/g%3E %3Cpath fill='%23fff200' stroke='%23000' stroke-width='0.48' d='m948.54,366.64s0.2316-15.976,13.284-15.277c2.4732,0.2292,1.2936,3.1464,1.2936,3.1464s2.8236-1.9776,4.1136,1.1652c0,0,4.1172-1.8636,4.5852,2.2188,0,0,4.4688-0.5808,3.8796,3.0312,0,0,3.0564-0.6984,2.9424,1.8672,0,0,3.5256-1.4004,3.1704,2.2152,0,0,3.8808-2.5656,3.2964,2.0964,0,0,3.9984-2.7948,5.4036,1.8684,1.4112,4.662-3.9948,14.574-9.2868,17.138'/%3E %3Cg fill='%23000'%3E %3Cpath d='m984.81,367.61c0.018,0.1248,1.7592,12.498-5.2572,17.026l0.2472,0.39c7.2696-4.6908,5.4816-17.356,5.466-17.484l-0.456,0.0684z'/%3E %3Cpath d='m976.36,381.16,0.324,0.33c4.4436-4.3248,5.4-15.976,5.4336-16.469l-0.4548-0.0384c-0.0108,0.1224-0.9768,11.974-5.3028,16.177z'/%3E %3Cpath d='m972.21,378.39,0.4584,0.0372c0.5712-7.1952,6.1956-15.425,6.2556-15.509l-0.3792-0.258c-0.0588,0.0816-5.7516,8.4132-6.3348,15.73z'/%3E %3Cpath d='m968.95,376.29,0.4584,0.0456c0.8004-8.6796,6.5328-15.196,6.5892-15.258l-0.3408-0.3072c-0.06,0.0636-5.8908,6.6876-6.7068,15.52z'/%3E %3Cpath d='m964.4,373.39,0.4584,0.0168c0.456-10.249,7.1796-15.28,7.2468-15.329l-0.2724-0.372c-0.0648,0.0516-6.9672,5.2008-7.4328,15.684z'/%3E %3Cpath d='m960.2,370.84,0.462-0.0144c-0.336-9.3276,6.8352-14.912,6.9096-14.969l-0.2784-0.3648c-0.0732,0.06-7.434,5.7804-7.0932,15.348z'/%3E %3Cpath d='m952.63,367.43,0.4548,0.0564c1.2492-10.097,10.236-12.725,10.326-12.75l-0.1248-0.4416c-0.09,0.024-9.3732,2.7288-10.656,13.135z'/%3E %3C/g%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.48' d='m940.84,386s-2.2116-14.813,6.648-19.472c0,0,1.6368-0.3516,2.5656,1.7484,0,0,4.6668-1.9812,4.7844,1.9776,0,0,2.3292-1.8636,2.9136,0.6996,0,0,5.0136-1.0464,4.0812,2.6832,0,0,4.1964-1.1652,3.846,2.4456,0,0,4.2-1.5144,3.4968,1.6344,0,0,4.4292-1.0464,3.3828,2.5668,0,0,5.4828-0.5808,3.8496,3.2652,0,0,4.0812-1.0476,3.1464,2.1,0,0,5.3652,0.9348,2.9136,4.3152-2.448,3.378-8.6292,8.5092-14.686,10.724'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.48' d='m936.06,400.92s-3.6156-12.355,3.2688-15.509c0,0,1.2756-0.3516,1.5096,0.9348,0,0,1.5192-1.9848,2.6868-0.2328,0,0,3.4944-1.6332,4.3152,0.9312,0,0,2.3292-1.9848,3.498,0.9276,0,0,2.2152-0.9276,2.2152,1.4016,0,0,3.0312-1.2828,3.0312,1.5168,0,0,2.91-1.1652,2.3292,1.9812,0,0,4.4328,0.6984,3.15,2.7972,0,0,3.9708,1.0464,2.448,2.6832,0,0,4.3116-0.4656,1.9812,2.448,0,0,3.2652-1.0464,1.4016,2.5704-1.8684,3.612-7.6944,7.5756-11.776,8.0412'/%3E %3Cpath fill='%2300a651' stroke='%23000' stroke-width='0.48' d='m940.37,410.71s-7.6944-7.4616-4.0752-9.6756c0,0,1.626,0.462,2.2116,2.0964,0,0,1.8636-2.6808,2.9172,0.1152,0,0,2.7996-0.9312,2.7996,0.9384l2.2116,1.6332s2.5692-0.2352,2.1036,1.398c0,0,2.7984-0.3516,2.6796,1.1652,0,0,2.4516,0.1152,2.2188,1.7448,0,0,4.1928,0.6996,2.3292,2.8032,0,0-7.3464,1.512-12.475-0.5844,0-0.001-2.688-0.936-2.9208-1.6344z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m966.76,398.38,0.1644,0.4272c4.5588-1.7556,12.478-12.564,12.816-13.024l-0.372-0.2748c-0.084,0.1164-8.1744,11.164-12.608,12.871z'/%3E %3Cpath d='m964.17,396.41,0.2232,0.3996c3.9672-2.2128,11.867-12.676,12.2-13.121l-0.366-0.2772c-0.0792,0.1116-8.1744,10.834-12.058,12.998z'/%3E %3Cpath d='m961.92,395.49,0.2964,0.3516c4.1892-3.4776,10.291-14.966,10.552-15.452l-0.4068-0.216c-0.0612,0.1176-6.3204,11.896-10.441,15.317z'/%3E %3Cpath d='m959.86,392.84,0.456,0.0636c0.7956-5.8068,8.9532-14.947,9.0324-15.037l-0.3408-0.3072c-0.3372,0.3792-8.334,9.336-9.1476,15.281z'/%3E %3Cpath d='m943.53,385.78,0.4596-0.0408c-0.6852-8.202,6.1812-17.237,6.2508-17.327l-0.3648-0.2772c-0.0732,0.0888-7.044,9.2616-6.3456,17.645z'/%3E %3Cpath d='m947.85,386.5,0.456-0.0792c-1.1364-6.5772,6.63-15.929,6.7104-16.02l-0.3516-0.2988c-0.3264,0.3888-7.9836,9.6048-6.8148,16.398z'/%3E %3Cpath d='m954.49,388.92,0.4596-0.0132c-0.2256-7.5072,6.9768-15.032,7.0512-15.109l-0.33-0.3204c-0.0732,0.0768-7.4148,7.7424-7.1808,15.443z'/%3E %3Cpath d='m938.65,402.52,0.4308-0.1608c-2.616-6.936,1.9248-15.818,1.9716-15.905l-0.414-0.2124c-0.0456,0.0912-4.6776,9.1488-1.9884,16.278z'/%3E %3Cpath d='m941.67,402.97,0.438-0.1416c-2.2812-7.0656,1.5852-16.535,1.626-16.628l-0.4272-0.1764c-0.0372,0.0924-3.966,9.7212-1.6368,16.946z'/%3E %3Cpath d='m954.17,410.03,0.1572,0.4344c7.44-2.676,12.305-9.4608,12.353-9.5256l-0.3756-0.2688c-0.0456,0.0672-4.8252,6.738-12.134,9.36z'/%3E %3Cpath d='m952.64,408.41,0.1872,0.4212c5.934-2.6772,11.467-10.146,11.519-10.223l-0.3684-0.2688c-0.0564,0.0744-5.5152,7.4424-11.338,10.07z'/%3E %3Cpath d='m951.2,407.85,0.2688,0.3732c4.6416-3.3624,10.604-11.982,10.667-12.07l-0.378-0.2568c-0.0612,0.0876-5.9772,8.6376-10.558,11.953z'/%3E %3Cpath d='m943.76,403.52,0.456-0.066c-1.026-7.4136,3.7728-16.208,3.8244-16.295l-0.4032-0.2232c-0.0516,0.0912-4.9236,9.018-3.8772,16.584z'/%3E %3Cpath d='m946.99,405.53,0.3096,0.3408c4.788-4.3224,6.4188-15.972,6.4848-16.465l-0.456-0.0636c-0.0144,0.1188-1.6728,11.981-6.3384,16.188z'/%3E %3Cpath d='m950.27,406.91,0.2688,0.372c6.7584-4.8876,8.5908-14.274,8.6052-14.365l-0.4488-0.0864c-0.018,0.09-1.8156,9.2952-8.4252,14.08z'/%3E %3Cpath d='m951.05,386.68c0,0.438,0.0216,0.8748,0.0624,1.3176-0.007-0.0372-5.1252,16.583-5.1252,16.583l0.438,0.1356,5.1384-16.674c-0.7932-8.0604,6.2964-16.859,6.366-16.945l-0.354-0.288c-0.0708,0.0792-6.5256,8.0928-6.5256,15.871z'/%3E %3Cpath d='m956.41,390.74c-0.0672,0.2328-1.6272,11.618-7.7676,15.818l0.2604,0.3792c6.3144-4.3188,7.848-15.544,7.9104-16.018,2.7252-3.2436,9.0048-14.614,9.0684-14.728l-0.4032-0.222c-0.0636,0.114-6.318,11.45-9.0684,14.77z'/%3E %3Cpath d='m938.28,403.18c0.0456,0.2388,1.0716,5.8956,2.2464,7.8912l0.396-0.2316c-1.1364-1.926-2.1756-7.68-2.1864-7.74l-0.456,0.0804z'/%3E %3Cpath d='m941.19,403.25c0.0492,2.8164,0.0636,7.4364-0.0936,7.8468l0.4272,0.168c0.2364-0.5916,0.1464-6.7836,0.1284-8.0184l-0.462,0.004z'/%3E %3Cpath d='m941.45,411.32,0.4176,0.1872c1.9716-4.29,2.5788-7.2492,2.586-7.2768l-0.4512-0.09c-0.007,0.024-0.6024,2.9412-2.5524,7.1796z'/%3E %3Cpath d='m941.89,411.45,0.2328,0.396c3.6576-2.1252,4.506-5.8212,4.536-5.976l-0.4476-0.1008c-0.0108,0.0372-0.8412,3.6612-4.3212,5.6808z'/%3E %3Cpath d='m942.57,411.77,0.0456,0.4548c3.5844-0.3576,6.0252-4.7112,6.1296-4.8948l-0.4044-0.2232c-0.0228,0.0456-2.4288,4.3284-5.7708,4.6632z'/%3E %3Cpath d='m942.93,412,0.0276,0.4584c5.754-0.354,8.3436-3.7932,8.448-3.9384l-0.372-0.2724c-0.024,0.0324-2.5764,3.4152-8.1036,3.7524z'/%3E %3Cpath d='m943.34,412.12-0.0936,0.4488c0.3096,0.0708,7.6416,1.6248,10.152-2.1972l-0.3852-0.2508c-2.334,3.558-9.6012,2.0136-9.6732,1.9992z'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='none' stroke='%23000' stroke-width='4.2' d='m778.8,143.94,0,205.09c0,67.08,121.2,106.91,121.2,106.91s121.2-39.833,121.2-106.91v-205.09z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1800' height='1100'%3E %3Crect width='1800' height='1100' fill='%23fff'/%3E %3Crect width='1800' height='300' y='400' fill='%23003580'/%3E %3Crect width='300' height='1100' x='500' fill='%23003580'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='720' height='360'%3E %3Crect fill='%23da121a' height='360' width='720'/%3E %3Crect fill='%23fcdd09' height='240' width='720'/%3E %3Crect fill='%23078930' height='120' width='720'/%3E %3Cg transform='translate(360,180)'%3E %3Ccircle fill='%230f47af' r='120'/%3E %3Cg id='t'%3E %3Cpath fill='%23fcdd09' d='M0,-96 -4.205849,-83.055728 13.141645,-29.665631H-9.987258L-12.586616,-21.665631H61.576052L72.587108,-29.665631H21.553343z'/%3E %3Cpath stroke='%23fcdd09' stroke-width='4' d='M0,44V96' transform='rotate(216)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3Cuse xlink:href='%23t' transform='rotate(144)'/%3E %3Cuse xlink:href='%23t' transform='rotate(216)'/%3E %3Cuse xlink:href='%23t' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' height='500' width='750'%3E %3Crect fill='%23c60b1e' height='500' width='750'/%3E %3Crect fill='%23ffc400' height='250' width='750' y='125'/%3E %3Cpath d='M167.989 222.241C167.989 222.241 167.478 222.241 167.197 222.081 166.916 221.918 166.069 221.116 166.069 221.116L165.39 220.632 164.772 219.776C164.772 219.776 164.037 218.605 164.374 217.692 164.711 216.783 165.277 216.46 165.788 216.194 166.297 215.927 167.366 215.605 167.366 215.605 167.366 215.605 168.217 215.231 168.498 215.175 168.779 215.122 169.799 214.855 169.799 214.855 169.799 214.855 170.081 214.696 170.362 214.589 170.647 214.482 171.041 214.482 171.269 214.426 171.494 214.372 172.061 214.191 172.398 214.173 172.923 214.152 173.755 214.266 174.04 214.266 174.321 214.266 175.282 214.322 175.675 214.322 176.069 214.322 177.482 214.212 177.879 214.212 178.273 214.212 178.558 214.163 179.012 214.212 179.462 214.266 180.253 214.531 180.481 214.642 180.707 214.749 182.064 215.231 182.571 215.391 183.08 215.547 184.325 215.764 184.892 216.031 185.453 216.301 185.799 216.752 186.08 217.127 186.365 217.501 186.417 217.909 186.53 218.178 186.638 218.445 186.642 219.02 186.534 219.287 186.42 219.553 186.02 220.104 186.02 220.104L185.397 221.119 184.607 221.758C184.607 221.758 184.04 222.298 183.591 222.241 183.136 222.195 178.558 221.385 175.619 221.385 172.679 221.385 167.985 222.241 167.985 222.241' fill='%23ad1519'/%3E %3Cpath d='M167.989 222.241C167.989 222.241 167.478 222.241 167.197 222.081 166.916 221.918 166.069 221.116 166.069 221.116L165.39 220.632 164.772 219.776C164.772 219.776 164.037 218.605 164.374 217.692 164.711 216.783 165.277 216.46 165.788 216.194 166.297 215.927 167.366 215.605 167.366 215.605 167.366 215.605 168.217 215.231 168.498 215.175 168.779 215.122 169.799 214.855 169.799 214.855 169.799 214.855 170.081 214.696 170.362 214.589 170.647 214.482 171.041 214.482 171.269 214.426 171.494 214.372 172.061 214.191 172.398 214.173 172.923 214.152 173.755 214.266 174.04 214.266 174.321 214.266 175.282 214.322 175.675 214.322 176.069 214.322 177.482 214.212 177.879 214.212 178.273 214.212 178.558 214.163 179.012 214.212 179.462 214.266 180.253 214.531 180.481 214.642 180.707 214.749 182.064 215.231 182.571 215.391 183.08 215.547 184.325 215.764 184.892 216.031 185.453 216.301 185.799 216.752 186.08 217.127 186.365 217.501 186.417 217.909 186.53 218.178 186.638 218.445 186.642 219.02 186.534 219.287 186.42 219.553 186.02 220.104 186.02 220.104L185.397 221.119 184.607 221.758C184.607 221.758 184.04 222.298 183.591 222.241 183.136 222.195 178.558 221.385 175.619 221.385 172.679 221.385 167.985 222.241 167.985 222.241L167.989 222.241z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M174.277 215.682C174.277 214.301 174.895 213.186 175.656 213.186 176.417 213.186 177.036 214.301 177.036 215.682 177.036 217.057 176.417 218.175 175.656 218.175 174.895 218.175 174.277 217.057 174.277 215.682' fill='%23c8b100'/%3E %3Cpath d='M174.277 215.682C174.277 214.301 174.895 213.186 175.656 213.186 176.417 213.186 177.036 214.301 177.036 215.682 177.036 217.057 176.417 218.175 175.656 218.175 174.895 218.175 174.277 217.057 174.277 215.682z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.049 215.682C175.049 214.412 175.334 213.382 175.682 213.382 176.035 213.382 176.316 214.412 176.316 215.682 176.316 216.943 176.035 217.973 175.682 217.973 175.334 217.973 175.049 216.943 175.049 215.682' fill='%23c8b100'/%3E %3Cpath d='M175.049 215.682C175.049 214.412 175.334 213.382 175.682 213.382 176.035 213.382 176.316 214.412 176.316 215.682 176.316 216.943 176.035 217.973 175.682 217.973 175.334 217.973 175.049 216.943 175.049 215.682z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M174.752 213.044C174.752 212.565 175.165 212.167 175.675 212.167 176.185 212.167 176.598 212.565 176.598 213.044 176.598 213.527 176.185 213.914 175.675 213.914 175.165 213.914 174.752 213.527 174.752 213.044' fill='%23c8b100'/%3E %3Cpath d='M176.327 212.735L176.327 213.317 174.899 213.317 174.899 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.327 212.735' fill='%23c8b100'/%3E %3Cpath d='M176.327 212.735L176.327 213.317 174.899 213.317 174.899 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.327 212.735' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M176.965 212.735L176.965 213.317 174.43 213.317 174.43 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.965 212.735' fill='%23c8b100'/%3E %3Cpath d='M176.965 212.735L176.965 213.317 174.43 213.317 174.43 212.735 175.367 212.735 175.367 211.425 174.749 211.425 174.749 210.846 175.367 210.846 175.367 210.278 175.974 210.278 175.974 210.846 176.59 210.846 176.59 211.425 175.974 211.425 175.974 212.735 176.965 212.735' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M175.941 212.203C176.324 212.309 176.598 212.647 176.598 213.044 176.598 213.527 176.185 213.914 175.675 213.914 175.165 213.914 174.752 213.527 174.752 213.044 174.752 212.64 175.041 212.295 175.435 212.199' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.678 222.081L170.871 222.081 170.76 220.902 170.534 219.674 170.295 218.14C168.97 216.392 167.752 215.245 167.343 215.491 167.441 215.168 167.557 214.926 167.813 214.777 168.99 214.077 171.419 215.757 173.246 218.516 173.41 218.768 173.568 219.02 173.707 219.273L177.677 219.273C177.82 219.024 177.977 218.772 178.142 218.516 179.965 215.757 182.397 214.077 183.571 214.777 183.826 214.926 183.943 215.168 184.044 215.491 183.632 215.249 182.417 216.392 181.085 218.14L180.849 219.674 180.624 220.902 180.515 222.081 175.682 222.081' fill='%23c8b100'/%3E %3Cpath d='M175.678 222.081L170.871 222.081 170.76 220.902 170.534 219.674 170.295 218.14C168.97 216.392 167.752 215.245 167.343 215.491 167.441 215.168 167.557 214.926 167.813 214.777 168.99 214.077 171.419 215.757 173.246 218.516 173.41 218.768 173.568 219.02 173.707 219.273L177.677 219.273C177.82 219.024 177.977 218.772 178.142 218.516 179.965 215.757 182.397 214.077 183.571 214.777 183.826 214.926 183.943 215.168 184.044 215.491 183.632 215.249 182.417 216.392 181.085 218.14L180.849 219.674 180.624 220.902 180.515 222.081 175.682 222.081 175.678 222.081z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M167.554 215.445C168.457 214.912 170.568 216.585 172.281 219.183M183.83 215.445C182.923 214.912 180.816 216.585 179.102 219.183' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.577 224.251C168.378 223.679 168 223.168 168 223.168 169.946 222.596 172.657 222.237 175.671 222.23 178.682 222.237 181.416 222.596 183.358 223.168 183.358 223.168 183.14 223.551 182.84 224.084 182.671 224.379 182.451 224.893 182.465 224.893 180.707 224.354 178.442 224.077 175.656 224.074 172.874 224.077 170.197 224.418 168.802 224.929 168.817 224.929 168.705 224.606 168.566 224.251L168.577 224.251' fill='%23c8b100'/%3E %3Cpath d='M168.577 224.251C168.378 223.679 168 223.168 168 223.168 169.946 222.596 172.657 222.237 175.671 222.23 178.682 222.237 181.416 222.596 183.358 223.168 183.358 223.168 183.14 223.551 182.84 224.084 182.671 224.379 182.451 224.893 182.465 224.893 180.707 224.354 178.442 224.077 175.656 224.074 172.874 224.077 170.197 224.418 168.802 224.929 168.817 224.929 168.705 224.606 168.566 224.251L168.577 224.251' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.671 226.726C178.101 226.722 180.781 226.353 181.768 226.098 182.432 225.905 182.817 225.607 182.747 225.263 182.713 225.1 182.571 224.958 182.379 224.876 180.924 224.411 178.31 224.081 175.671 224.077 173.035 224.081 170.403 224.411 168.952 224.876 168.761 224.958 168.618 225.1 168.585 225.263 168.513 225.607 168.9 225.905 169.559 226.098 170.549 226.353 173.242 226.722 175.671 226.726' fill='%23c8b100'/%3E %3Cpath d='M175.671 226.726C178.101 226.722 180.781 226.353 181.768 226.098 182.432 225.905 182.817 225.607 182.747 225.263 182.713 225.1 182.571 224.958 182.379 224.876 180.924 224.411 178.31 224.081 175.671 224.077 173.035 224.081 170.403 224.411 168.952 224.876 168.761 224.958 168.618 225.1 168.585 225.263 168.513 225.607 168.9 225.905 169.559 226.098 170.549 226.353 173.242 226.722 175.671 226.726z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M183.482 222.081L182.886 221.546C182.886 221.546 182.323 221.893 181.614 221.786 180.909 221.68 180.681 220.825 180.681 220.825 180.681 220.825 179.889 221.488 179.241 221.439 178.592 221.381 178.168 220.825 178.168 220.825 178.168 220.825 177.464 221.328 176.841 221.279 176.219 221.222 175.626 220.448 175.626 220.448 175.626 220.448 175.004 221.25 174.382 221.307 173.759 221.357 173.249 220.767 173.249 220.767 173.249 220.767 172.968 221.357 172.176 221.488 171.386 221.623 170.71 220.874 170.71 220.874 170.71 220.874 170.257 221.598 169.721 221.786 169.185 221.974 168.476 221.516 168.476 221.516 168.476 221.516 168.363 221.786 168.281 221.946 168.195 222.106 167.97 222.135 167.97 222.135L168.146 222.614C170.084 222.053 172.709 221.705 175.678 221.702 178.652 221.705 181.348 222.053 183.291 222.618L183.489 222.081' fill='%23c8b100'/%3E %3Cpath d='M183.482 222.081L182.886 221.546C182.886 221.546 182.323 221.893 181.614 221.786 180.909 221.68 180.681 220.825 180.681 220.825 180.681 220.825 179.889 221.488 179.241 221.439 178.592 221.381 178.168 220.825 178.168 220.825 178.168 220.825 177.464 221.328 176.841 221.279 176.219 221.222 175.626 220.448 175.626 220.448 175.626 220.448 175.004 221.25 174.382 221.307 173.759 221.357 173.249 220.767 173.249 220.767 173.249 220.767 172.968 221.357 172.176 221.488 171.386 221.623 170.71 220.874 170.71 220.874 170.71 220.874 170.257 221.598 169.721 221.786 169.185 221.974 168.476 221.516 168.476 221.516 168.476 221.516 168.363 221.786 168.281 221.946 168.195 222.106 167.97 222.135 167.97 222.135L168.146 222.614C170.084 222.053 172.709 221.705 175.678 221.702 178.652 221.705 181.348 222.053 183.291 222.618L183.489 222.081 183.482 222.081z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.686 219.492L175.967 219.543C175.922 219.66 175.911 219.783 175.911 219.915 175.911 220.497 176.409 220.97 177.029 220.97 177.523 220.97 177.94 220.664 178.086 220.242 178.105 220.253 178.195 219.858 178.24 219.865 178.273 219.865 178.269 220.274 178.288 220.267 178.356 220.795 178.843 221.158 179.391 221.158 180.006 221.158 180.499 220.686 180.499 220.104 180.499 220.06 180.499 220.018 180.493 219.976L180.842 219.627 181.033 220.071C180.955 220.206 180.928 220.362 180.928 220.53 180.928 221.087 181.405 221.538 181.989 221.538 182.36 221.538 182.682 221.357 182.874 221.087L183.099 220.803 183.095 221.155C183.095 221.502 183.245 221.815 183.587 221.872 183.587 221.872 183.972 221.9 184.498 221.488 185.015 221.08 185.3 220.739 185.3 220.739L185.333 221.158C185.333 221.158 184.824 221.996 184.359 222.262 184.107 222.411 183.716 222.568 183.41 222.514 183.088 222.465 182.856 222.202 182.735 221.904 182.506 222.042 182.233 222.12 181.94 222.12 181.31 222.12 180.744 221.772 180.52 221.258 180.231 221.57 179.83 221.758 179.357 221.758 178.854 221.758 178.393 221.534 178.105 221.183 177.82 221.446 177.433 221.606 177.01 221.606 176.455 221.606 175.956 221.328 175.675 220.92 175.393 221.328 174.899 221.606 174.344 221.606 173.92 221.606 173.534 221.446 173.249 221.183 172.961 221.534 172.499 221.758 171.996 221.758 171.524 221.758 171.123 221.57 170.834 221.258 170.61 221.769 170.043 222.12 169.413 222.12 169.12 222.12 168.847 222.042 168.618 221.904 168.498 222.202 168.266 222.465 167.943 222.514 167.636 222.568 167.25 222.411 166.995 222.262 166.53 221.996 165.982 221.158 165.982 221.158L166.053 220.739C166.053 220.739 166.342 221.08 166.856 221.488 167.378 221.9 167.767 221.872 167.767 221.872 168.109 221.815 168.259 221.502 168.259 221.155L168.255 220.803 168.479 221.087C168.67 221.357 168.994 221.538 169.364 221.538 169.949 221.538 170.425 221.087 170.425 220.53 170.425 220.362 170.399 220.206 170.325 220.071L170.512 219.627 170.86 219.976C170.853 220.018 170.849 220.06 170.849 220.104 170.849 220.686 171.345 221.158 171.963 221.158 172.511 221.158 172.994 220.795 173.066 220.267 173.081 220.274 173.077 219.865 173.114 219.865 173.159 219.858 173.253 220.253 173.268 220.242 173.414 220.664 173.834 220.97 174.329 220.97 174.943 220.97 175.443 220.497 175.443 219.915 175.443 219.783 175.435 219.66 175.386 219.543L175.678 219.492' fill='%23c8b100'/%3E %3Cpath d='M175.686 219.492L175.967 219.543C175.922 219.66 175.911 219.783 175.911 219.915 175.911 220.497 176.409 220.97 177.029 220.97 177.523 220.97 177.94 220.664 178.086 220.242 178.105 220.253 178.195 219.858 178.24 219.865 178.273 219.865 178.269 220.274 178.288 220.267 178.356 220.795 178.843 221.158 179.391 221.158 180.006 221.158 180.499 220.686 180.499 220.104 180.499 220.06 180.499 220.018 180.493 219.976L180.842 219.627 181.033 220.071C180.955 220.206 180.928 220.362 180.928 220.53 180.928 221.087 181.405 221.538 181.989 221.538 182.36 221.538 182.682 221.357 182.874 221.087L183.099 220.803 183.095 221.155C183.095 221.502 183.245 221.815 183.587 221.872 183.587 221.872 183.972 221.9 184.498 221.488 185.015 221.08 185.3 220.739 185.3 220.739L185.333 221.158C185.333 221.158 184.824 221.996 184.359 222.262 184.107 222.411 183.716 222.568 183.41 222.514 183.088 222.465 182.856 222.202 182.735 221.904 182.506 222.042 182.233 222.12 181.94 222.12 181.31 222.12 180.744 221.772 180.52 221.258 180.231 221.57 179.83 221.758 179.357 221.758 178.854 221.758 178.393 221.534 178.105 221.183 177.82 221.446 177.433 221.606 177.01 221.606 176.455 221.606 175.956 221.328 175.675 220.92 175.393 221.328 174.899 221.606 174.344 221.606 173.92 221.606 173.534 221.446 173.249 221.183 172.961 221.534 172.499 221.758 171.996 221.758 171.524 221.758 171.123 221.57 170.834 221.258 170.61 221.769 170.043 222.12 169.413 222.12 169.12 222.12 168.847 222.042 168.618 221.904 168.498 222.202 168.266 222.465 167.943 222.514 167.636 222.568 167.25 222.411 166.995 222.262 166.53 221.996 165.982 221.158 165.982 221.158L166.053 220.739C166.053 220.739 166.342 221.08 166.856 221.488 167.378 221.9 167.767 221.872 167.767 221.872 168.109 221.815 168.259 221.502 168.259 221.155L168.255 220.803 168.479 221.087C168.67 221.357 168.994 221.538 169.364 221.538 169.949 221.538 170.425 221.087 170.425 220.53 170.425 220.362 170.399 220.206 170.325 220.071L170.512 219.627 170.86 219.976C170.853 220.018 170.849 220.06 170.849 220.104 170.849 220.686 171.345 221.158 171.963 221.158 172.511 221.158 172.994 220.795 173.066 220.267 173.081 220.274 173.077 219.865 173.114 219.865 173.159 219.858 173.253 220.253 173.268 220.242 173.414 220.664 173.834 220.97 174.329 220.97 174.943 220.97 175.443 220.497 175.443 219.915 175.443 219.783 175.435 219.66 175.386 219.543L175.678 219.492 175.686 219.492z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.671 222.234C172.657 222.237 169.946 222.596 168.004 223.172 167.872 223.214 167.711 223.114 167.67 222.997 167.628 222.874 167.722 222.721 167.85 222.678 169.803 222.081 172.581 221.705 175.671 221.702 178.757 221.705 181.547 222.081 183.5 222.678 183.628 222.721 183.721 222.874 183.68 222.997 183.643 223.114 183.478 223.214 183.35 223.172 181.405 222.596 178.682 222.237 175.671 222.234' fill='%23c8b100'/%3E %3Cpath d='M175.671 222.234C172.657 222.237 169.946 222.596 168.004 223.172 167.872 223.214 167.711 223.114 167.67 222.997 167.628 222.874 167.722 222.721 167.85 222.678 169.803 222.081 172.581 221.705 175.671 221.702 178.757 221.705 181.547 222.081 183.5 222.678 183.628 222.721 183.721 222.874 183.68 222.997 183.643 223.114 183.478 223.214 183.35 223.172 181.405 222.596 178.682 222.237 175.671 222.234z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M172.754 223.303C172.754 223.076 172.949 222.891 173.192 222.891 173.433 222.891 173.627 223.076 173.627 223.303 173.627 223.533 173.433 223.714 173.192 223.714 172.949 223.714 172.754 223.533 172.754 223.303' fill='%23fff'/%3E %3Cpath d='M172.754 223.303C172.754 223.076 172.949 222.891 173.192 222.891 173.433 222.891 173.627 223.076 173.627 223.303 173.627 223.533 173.433 223.714 173.192 223.714 172.949 223.714 172.754 223.533 172.754 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.705 223.481L174.738 223.481C174.558 223.481 174.408 223.339 174.408 223.168 174.408 223 174.554 222.863 174.73 222.863L176.694 222.863C176.875 222.863 177.018 223 177.018 223.168 177.018 223.339 176.871 223.481 176.691 223.481L175.705 223.481' fill='%23ad1519'/%3E %3Cpath d='M175.705 223.481L174.738 223.481C174.558 223.481 174.408 223.339 174.408 223.168 174.408 223 174.554 222.863 174.73 222.863L176.694 222.863C176.875 222.863 177.018 223 177.018 223.168 177.018 223.339 176.871 223.481 176.691 223.481L175.705 223.481' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M170.849 223.814L170.156 223.917C169.979 223.942 169.807 223.828 169.781 223.658 169.755 223.491 169.875 223.335 170.051 223.31L170.748 223.207 171.461 223.097C171.637 223.076 171.802 223.186 171.832 223.353 171.854 223.519 171.734 223.679 171.558 223.704L170.849 223.814' fill='%23058e6e'/%3E %3Cpath d='M170.849 223.814L170.156 223.917C169.979 223.942 169.807 223.828 169.781 223.658 169.755 223.491 169.875 223.335 170.051 223.31L170.748 223.207 171.461 223.097C171.637 223.076 171.802 223.186 171.832 223.353 171.854 223.519 171.734 223.679 171.558 223.704L170.849 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.048 224.3L168.356 223.804 169.012 223.928 168.629 224.486 168.048 224.3' fill='%23ad1519'/%3E %3Cpath d='M168.048 224.3L168.356 223.804 169.012 223.928 168.629 224.486 168.048 224.3' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M177.718 223.303C177.718 223.076 177.914 222.891 178.157 222.891 178.397 222.891 178.592 223.076 178.592 223.303 178.592 223.533 178.397 223.714 178.157 223.714 177.914 223.714 177.718 223.533 177.718 223.303' fill='%23fff'/%3E %3Cpath d='M177.718 223.303C177.718 223.076 177.914 222.891 178.157 222.891 178.397 222.891 178.592 223.076 178.592 223.303 178.592 223.533 178.397 223.714 178.157 223.714 177.914 223.714 177.718 223.533 177.718 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M180.496 223.814L181.194 223.917C181.37 223.942 181.536 223.828 181.566 223.658 181.592 223.491 181.475 223.335 181.299 223.31L180.598 223.207 179.889 223.097C179.709 223.076 179.545 223.186 179.518 223.353 179.488 223.519 179.612 223.679 179.792 223.704L180.496 223.814' fill='%23058e6e'/%3E %3Cpath d='M180.496 223.814L181.194 223.917C181.37 223.942 181.536 223.828 181.566 223.658 181.592 223.491 181.475 223.335 181.299 223.31L180.598 223.207 179.889 223.097C179.709 223.076 179.545 223.186 179.518 223.353 179.488 223.519 179.612 223.679 179.792 223.704L180.496 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M183.241 224.329L182.994 223.8 182.319 223.856 182.641 224.449 183.241 224.329' fill='%23ad1519'/%3E %3Cpath d='M183.241 224.329L182.994 223.8 182.319 223.856 182.641 224.449 183.241 224.329' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.663 226.161C173.231 226.158 171.03 225.945 169.357 225.512 171.03 225.082 173.231 224.816 175.663 224.809 178.097 224.812 180.309 225.079 181.986 225.512 180.309 225.945 178.097 226.158 175.663 226.161' fill='%23ad1519'/%3E %3Cpath d='M175.663 226.161C173.231 226.158 171.03 225.945 169.357 225.512 171.03 225.082 173.231 224.816 175.663 224.809 178.097 224.812 180.309 225.079 181.986 225.512 180.309 225.945 178.097 226.158 175.663 226.161z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M183.339 220.885C183.402 220.697 183.343 220.511 183.208 220.465 183.073 220.427 182.908 220.548 182.844 220.728 182.78 220.92 182.836 221.109 182.975 221.151 183.11 221.19 183.271 221.073 183.339 220.885' fill='%23c8b100'/%3E %3Cpath d='M183.339 220.885C183.402 220.697 183.343 220.511 183.208 220.465 183.073 220.427 182.908 220.548 182.844 220.728 182.78 220.92 182.836 221.109 182.975 221.151 183.11 221.19 183.271 221.073 183.339 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M178.495 219.948C178.517 219.752 178.423 219.578 178.281 219.56 178.138 219.543 178.003 219.692 177.981 219.887 177.955 220.082 178.049 220.256 178.191 220.274 178.334 220.288 178.469 220.139 178.495 219.948' fill='%23c8b100'/%3E %3Cpath d='M178.495 219.948C178.517 219.752 178.423 219.578 178.281 219.56 178.138 219.543 178.003 219.692 177.981 219.887 177.955 220.082 178.049 220.256 178.191 220.274 178.334 220.288 178.469 220.139 178.495 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M172.866 219.948C172.844 219.752 172.938 219.578 173.081 219.56 173.223 219.543 173.358 219.692 173.384 219.887 173.407 220.082 173.313 220.256 173.17 220.274 173.031 220.288 172.892 220.139 172.866 219.948' fill='%23c8b100'/%3E %3Cpath d='M172.866 219.948C172.844 219.752 172.938 219.578 173.081 219.56 173.223 219.543 173.358 219.692 173.384 219.887 173.407 220.082 173.313 220.256 173.17 220.274 173.031 220.288 172.892 220.139 172.866 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.022 220.885C167.959 220.697 168.018 220.511 168.154 220.465 168.289 220.427 168.453 220.548 168.517 220.728 168.581 220.92 168.524 221.109 168.385 221.151 168.251 221.19 168.089 221.073 168.022 220.885' fill='%23c8b100'/%3E %3Cpath d='M168.022 220.885C167.959 220.697 168.018 220.511 168.154 220.465 168.289 220.427 168.453 220.548 168.517 220.728 168.581 220.92 168.524 221.109 168.385 221.151 168.251 221.19 168.089 221.073 168.022 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.663 217.149L174.805 217.667 175.443 219.048 175.663 219.194 175.881 219.048 176.522 217.667 175.663 217.149' fill='%23c8b100'/%3E %3Cpath d='M175.663 217.149L174.805 217.667 175.443 219.048 175.663 219.194 175.881 219.048 176.522 217.667 175.663 217.149' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M173.785 219.237L174.175 219.806 175.517 219.393 175.656 219.206 175.513 219.013 174.175 218.622 173.785 219.237' fill='%23c8b100'/%3E %3Cpath d='M173.785 219.237L174.175 219.806 175.517 219.393 175.656 219.206 175.513 219.013 174.175 218.622 173.785 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M177.553 219.237L177.164 219.806 175.821 219.393 175.678 219.206 175.824 219.013 177.164 218.622 177.553 219.237' fill='%23c8b100'/%3E %3Cpath d='M177.553 219.237L177.164 219.806 175.821 219.393 175.678 219.206 175.824 219.013 177.164 218.622 177.553 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M170.084 217.764L169.409 218.399 170.271 219.536 170.501 219.627 170.669 219.453 170.969 218.08 170.084 217.764' fill='%23c8b100'/%3E %3Cpath d='M170.084 217.764L169.409 218.399 170.271 219.536 170.501 219.627 170.669 219.453 170.969 218.08 170.084 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M168.67 220.043L169.177 220.518 170.399 219.858 170.493 219.646 170.317 219.485 168.918 219.365 168.67 220.043' fill='%23c8b100'/%3E %3Cpath d='M168.67 220.043L169.177 220.518 170.399 219.858 170.493 219.646 170.317 219.485 168.918 219.365 168.67 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M172.361 219.301L172.102 219.929 170.699 219.802 170.519 219.641 170.617 219.425 171.843 218.779 172.361 219.301' fill='%23c8b100'/%3E %3Cpath d='M172.361 219.301L172.102 219.929 170.699 219.802 170.519 219.641 170.617 219.425 171.843 218.779 172.361 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M167.321 220.22L167.208 220.885 165.81 221.03 165.6 220.909 165.645 220.683 166.699 219.809 167.321 220.22' fill='%23c8b100'/%3E %3Cpath d='M167.321 220.22L167.208 220.885 165.81 221.03 165.6 220.909 165.645 220.683 166.699 219.809 167.321 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M170.021 219.649C170.021 219.39 170.242 219.18 170.512 219.18 170.782 219.18 171.003 219.39 171.003 219.649 171.003 219.904 170.782 220.114 170.512 220.114 170.242 220.114 170.021 219.904 170.021 219.649' fill='%23c8b100'/%3E %3Cpath d='M170.021 219.649C170.021 219.39 170.242 219.18 170.512 219.18 170.782 219.18 171.003 219.39 171.003 219.649 171.003 219.904 170.782 220.114 170.512 220.114 170.242 220.114 170.021 219.904 170.021 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M181.27 217.764L181.944 218.399 181.081 219.536 180.849 219.627 180.685 219.453 180.381 218.08 181.27 217.764' fill='%23c8b100'/%3E %3Cpath d='M181.27 217.764L181.944 218.399 181.081 219.536 180.849 219.627 180.685 219.453 180.381 218.08 181.27 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M182.679 220.043L182.173 220.518 180.95 219.858 180.853 219.646 181.037 219.485 182.436 219.365 182.679 220.043' fill='%23c8b100'/%3E %3Cpath d='M182.679 220.043L182.173 220.518 180.95 219.858 180.853 219.646 181.037 219.485 182.436 219.365 182.679 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M178.993 219.301L179.252 219.929 180.646 219.802 180.831 219.641 180.729 219.425 179.507 218.779 178.993 219.301' fill='%23c8b100'/%3E %3Cpath d='M178.993 219.301L179.252 219.929 180.646 219.802 180.831 219.641 180.729 219.425 179.507 218.779 178.993 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M183.837 220.22L183.954 220.885 185.353 221.03 185.562 220.909 185.514 220.683 184.461 219.809 183.837 220.22' fill='%23c8b100'/%3E %3Cpath d='M183.837 220.22L183.954 220.885 185.353 221.03 185.562 220.909 185.514 220.683 184.461 219.809 183.837 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M175.18 219.209C175.18 218.946 175.402 218.74 175.671 218.74 175.945 218.74 176.163 218.946 176.163 219.209 176.163 219.464 175.945 219.674 175.671 219.674 175.402 219.674 175.18 219.464 175.18 219.209' fill='%23c8b100'/%3E %3Cpath d='M175.18 219.209C175.18 218.946 175.402 218.74 175.671 218.74 175.945 218.74 176.163 218.946 176.163 219.209 176.163 219.464 175.945 219.674 175.671 219.674 175.402 219.674 175.18 219.464 175.18 219.209z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M180.358 219.649C180.358 219.39 180.579 219.18 180.849 219.18 181.123 219.18 181.34 219.39 181.34 219.649 181.34 219.904 181.123 220.114 180.849 220.114 180.579 220.114 180.358 219.904 180.358 219.649' fill='%23c8b100'/%3E %3Cpath d='M180.358 219.649C180.358 219.39 180.579 219.18 180.849 219.18 181.123 219.18 181.34 219.39 181.34 219.649 181.34 219.904 181.123 220.114 180.849 220.114 180.579 220.114 180.358 219.904 180.358 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M165.431 220.998C165.416 221.009 165.053 220.515 164.775 220.267 164.576 220.093 164.1 219.944 164.1 219.944 164.1 219.855 164.378 219.656 164.681 219.656 164.861 219.656 165.03 219.73 165.127 219.855L165.168 219.663C165.168 219.663 165.412 219.709 165.525 219.983 165.638 220.267 165.566 220.697 165.566 220.697 165.566 220.697 165.521 220.895 165.431 220.998' fill='%23c8b100'/%3E %3Cpath d='M165.431 220.998C165.416 221.009 165.053 220.515 164.775 220.267 164.576 220.093 164.1 219.944 164.1 219.944 164.1 219.855 164.378 219.656 164.681 219.656 164.861 219.656 165.03 219.73 165.127 219.855L165.168 219.663C165.168 219.663 165.412 219.709 165.525 219.983 165.638 220.267 165.566 220.697 165.566 220.697 165.566 220.697 165.521 220.895 165.431 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M165.45 220.753C165.566 220.632 165.806 220.657 165.982 220.81 166.162 220.963 166.215 221.186 166.099 221.311 165.982 221.435 165.742 221.407 165.566 221.254 165.386 221.101 165.334 220.874 165.45 220.753' fill='%23c8b100'/%3E %3Cpath d='M165.45 220.753C165.566 220.632 165.806 220.657 165.982 220.81 166.162 220.963 166.215 221.186 166.099 221.311 165.982 221.435 165.742 221.407 165.566 221.254 165.386 221.101 165.334 220.874 165.45 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M185.731 220.998C185.742 221.009 186.11 220.515 186.388 220.267 186.578 220.093 187.062 219.944 187.062 219.944 187.062 219.855 186.781 219.656 186.477 219.656 186.301 219.656 186.132 219.73 186.031 219.855L185.99 219.663C185.99 219.663 185.746 219.709 185.634 219.983 185.525 220.267 185.596 220.697 185.596 220.697 185.596 220.697 185.638 220.895 185.731 220.998' fill='%23c8b100'/%3E %3Cpath d='M185.731 220.998C185.742 221.009 186.11 220.515 186.388 220.267 186.578 220.093 187.062 219.944 187.062 219.944 187.062 219.855 186.781 219.656 186.477 219.656 186.301 219.656 186.132 219.73 186.031 219.855L185.99 219.663C185.99 219.663 185.746 219.709 185.634 219.983 185.525 220.267 185.596 220.697 185.596 220.697 185.596 220.697 185.638 220.895 185.731 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M185.742 220.753C185.627 220.632 185.386 220.657 185.207 220.81 185.026 220.963 184.974 221.186 185.09 221.311 185.207 221.435 185.446 221.407 185.627 221.254 185.806 221.101 185.855 220.874 185.742 220.753' fill='%23c8b100'/%3E %3Cpath d='M185.742 220.753C185.627 220.632 185.386 220.657 185.207 220.81 185.026 220.963 184.974 221.186 185.09 221.311 185.207 221.435 185.446 221.407 185.627 221.254 185.806 221.101 185.855 220.874 185.742 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M164.58 232.369L186.867 232.369 186.867 226.527 164.58 226.527 164.58 232.369z' fill='%23c8b100'/%3E %3Cpath d='M164.58 232.369L186.867 232.369 186.867 226.527 164.58 226.527 164.58 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M166.919 236.256C167.058 236.2 167.16 236.193 167.332 236.193L184.022 236.193C184.187 236.193 184.344 236.221 184.475 236.274 183.905 236.083 183.493 235.565 183.493 234.953 183.493 234.343 183.939 233.814 184.516 233.615 184.385 233.657 184.19 233.697 184.033 233.697L167.332 233.697C167.163 233.697 167.002 233.69 166.864 233.643L166.954 233.657C167.55 233.842 167.891 234.371 167.891 234.953 167.891 235.514 167.512 236.076 166.919 236.256' fill='%23c8b100'/%3E %3Cpath d='M166.919 236.256C167.058 236.2 167.16 236.193 167.332 236.193L184.022 236.193C184.187 236.193 184.344 236.221 184.475 236.274 183.905 236.083 183.493 235.565 183.493 234.953 183.493 234.343 183.939 233.814 184.516 233.615 184.385 233.657 184.19 233.697 184.033 233.697L167.332 233.697C167.163 233.697 167.002 233.69 166.864 233.643L166.954 233.657C167.55 233.842 167.891 234.371 167.891 234.953 167.891 235.514 167.512 236.076 166.919 236.256z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M167.332 236.193L184.022 236.193C184.587 236.193 185.045 236.544 185.045 236.974 185.045 237.407 184.587 237.759 184.022 237.759L167.332 237.759C166.766 237.759 166.308 237.407 166.308 236.974 166.308 236.544 166.766 236.193 167.332 236.193' fill='%23c8b100'/%3E %3Cpath d='M167.332 236.193L184.022 236.193C184.587 236.193 185.045 236.544 185.045 236.974 185.045 237.407 184.587 237.759 184.022 237.759L167.332 237.759C166.766 237.759 166.308 237.407 166.308 236.974 166.308 236.544 166.766 236.193 167.332 236.193z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M167.332 232.369L184.033 232.369C184.595 232.369 185.057 232.667 185.057 233.029 185.057 233.398 184.595 233.697 184.033 233.697L167.332 233.697C166.766 233.697 166.308 233.398 166.308 233.029 166.308 232.667 166.766 232.369 167.332 232.369' fill='%23c8b100'/%3E %3Cpath d='M167.332 232.369L184.033 232.369C184.595 232.369 185.057 232.667 185.057 233.029 185.057 233.398 184.595 233.697 184.033 233.697L167.332 233.697C166.766 233.697 166.308 233.398 166.308 233.029 166.308 232.667 166.766 232.369 167.332 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.28 330.676C189.74 330.676 188.367 330.353 187.354 329.813 186.349 329.302 184.989 328.989 183.489 328.989 181.982 328.989 180.587 329.306 179.582 329.82 178.573 330.35 177.179 330.676 175.656 330.676 174.115 330.676 172.743 330.317 171.73 329.778 170.734 329.287 169.398 328.989 167.936 328.989 166.425 328.989 165.083 329.277 164.078 329.799 163.065 330.336 161.663 330.676 160.126 330.676L160.126 333.09C161.663 333.09 163.065 332.739 164.078 332.206 165.083 331.688 166.425 331.394 167.936 331.394 169.394 331.394 170.73 331.695 171.73 332.189 172.739 332.725 174.115 333.09 175.656 333.09 177.179 333.09 178.573 332.757 179.582 332.232 180.587 331.71 181.982 331.394 183.489 331.394 184.989 331.394 186.349 331.71 187.354 332.225 188.367 332.764 189.717 333.09 191.262 333.09L191.28 330.676' fill='%23005bbf'/%3E %3Cpath d='M191.28 330.676C189.74 330.676 188.367 330.353 187.354 329.813 186.349 329.302 184.989 328.989 183.489 328.989 181.982 328.989 180.587 329.306 179.582 329.82 178.573 330.35 177.179 330.676 175.656 330.676 174.115 330.676 172.743 330.317 171.73 329.778 170.734 329.287 169.398 328.989 167.936 328.989 166.425 328.989 165.083 329.277 164.078 329.799 163.065 330.336 161.663 330.676 160.126 330.676L160.126 333.09C161.663 333.09 163.065 332.739 164.078 332.206 165.083 331.688 166.425 331.394 167.936 331.394 169.394 331.394 170.73 331.695 171.73 332.189 172.739 332.725 174.115 333.09 175.656 333.09 177.179 333.09 178.573 332.757 179.582 332.232 180.587 331.71 181.982 331.394 183.489 331.394 184.989 331.394 186.349 331.71 187.354 332.225 188.367 332.764 189.717 333.09 191.262 333.09L191.28 330.676z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.28 333.09C189.74 333.09 188.367 332.764 187.354 332.225 186.349 331.71 184.989 331.394 183.489 331.394 181.982 331.394 180.587 331.71 179.582 332.232 178.573 332.757 177.179 333.09 175.656 333.09 174.115 333.09 172.743 332.725 171.73 332.189 170.734 331.695 169.398 331.394 167.936 331.394 166.425 331.394 165.083 331.688 164.078 332.206 163.065 332.739 161.663 333.09 160.126 333.09L160.126 335.498C161.663 335.498 163.065 335.154 164.078 334.621 165.083 334.095 166.425 333.804 167.936 333.804 169.394 333.804 170.73 334.106 171.73 334.6 172.739 335.136 174.115 335.498 175.656 335.498 177.179 335.498 178.573 335.165 179.582 334.639 180.587 334.121 181.982 333.804 183.489 333.804 184.989 333.804 186.349 334.121 187.354 334.635 188.367 335.172 189.717 335.498 191.262 335.498L191.28 333.09' fill='%23cccccc'/%3E %3Cpath d='M191.28 333.09C189.74 333.09 188.367 332.764 187.354 332.225 186.349 331.71 184.989 331.394 183.489 331.394 181.982 331.394 180.587 331.71 179.582 332.232 178.573 332.757 177.179 333.09 175.656 333.09 174.115 333.09 172.743 332.725 171.73 332.189 170.734 331.695 169.398 331.394 167.936 331.394 166.425 331.394 165.083 331.688 164.078 332.206 163.065 332.739 161.663 333.09 160.126 333.09L160.126 335.498C161.663 335.498 163.065 335.154 164.078 334.621 165.083 334.095 166.425 333.804 167.936 333.804 169.394 333.804 170.73 334.106 171.73 334.6 172.739 335.136 174.115 335.498 175.656 335.498 177.179 335.498 178.573 335.165 179.582 334.639 180.587 334.121 181.982 333.804 183.489 333.804 184.989 333.804 186.349 334.121 187.354 334.635 188.367 335.172 189.717 335.498 191.262 335.498L191.28 333.09' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.28 335.498C189.74 335.498 188.367 335.172 187.354 334.635 186.349 334.121 184.989 333.804 183.489 333.804 181.982 333.804 180.587 334.121 179.582 334.639 178.573 335.165 177.179 335.498 175.656 335.498 174.115 335.498 172.743 335.136 171.73 334.6 170.734 334.106 169.398 333.804 167.936 333.804 166.425 333.804 165.083 334.095 164.078 334.621 163.065 335.154 161.663 335.498 160.126 335.498L160.126 337.905C161.663 337.905 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.717 337.905 191.262 337.905L191.28 335.498' fill='%23005bbf'/%3E %3Cpath d='M191.28 335.498C189.74 335.498 188.367 335.172 187.354 334.635 186.349 334.121 184.989 333.804 183.489 333.804 181.982 333.804 180.587 334.121 179.582 334.639 178.573 335.165 177.179 335.498 175.656 335.498 174.115 335.498 172.743 335.136 171.73 334.6 170.734 334.106 169.398 333.804 167.936 333.804 166.425 333.804 165.083 334.095 164.078 334.621 163.065 335.154 161.663 335.498 160.126 335.498L160.126 337.905C161.663 337.905 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.717 337.905 191.262 337.905L191.28 335.498' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.262 340.317C189.717 340.317 188.367 339.991 187.354 339.451 186.349 338.94 184.989 338.626 183.489 338.626 181.982 338.626 180.587 338.94 179.582 339.458 178.573 339.984 177.179 340.317 175.656 340.317 174.115 340.317 172.743 339.954 171.73 339.415 170.734 338.925 169.398 338.626 167.936 338.626 166.425 338.626 165.083 338.918 164.078 339.436 163.065 339.973 161.663 340.317 160.126 340.317L160.126 337.921C161.663 337.921 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.74 337.905 191.28 337.905L191.262 340.317' fill='%23cccccc'/%3E %3Cpath d='M191.262 340.317C189.717 340.317 188.367 339.991 187.354 339.451 186.349 338.94 184.989 338.626 183.489 338.626 181.982 338.626 180.587 338.94 179.582 339.458 178.573 339.984 177.179 340.317 175.656 340.317 174.115 340.317 172.743 339.954 171.73 339.415 170.734 338.925 169.398 338.626 167.936 338.626 166.425 338.626 165.083 338.918 164.078 339.436 163.065 339.973 161.663 340.317 160.126 340.317L160.126 337.921C161.663 337.921 163.065 337.561 164.078 337.025 165.083 336.507 166.425 336.216 167.936 336.216 169.394 336.216 170.73 336.518 171.73 337.007 172.739 337.547 174.115 337.905 175.656 337.905 177.179 337.905 178.573 337.576 179.582 337.051 180.587 336.532 181.982 336.216 183.489 336.216 184.989 336.216 186.349 336.528 187.354 337.044 188.367 337.586 189.74 337.905 191.28 337.905L191.262 340.317' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M191.262 342.728C189.717 342.728 188.367 342.401 187.354 341.866 186.349 341.347 184.989 341.031 183.489 341.031 181.982 341.031 180.587 341.35 179.582 341.869 178.573 342.394 177.179 342.728 175.656 342.728 174.115 342.728 172.743 342.362 171.73 341.826 170.734 341.333 169.398 341.031 167.936 341.031 166.425 341.031 165.083 341.326 164.078 341.847 163.065 342.38 161.663 342.728 160.126 342.728L160.126 340.338C161.663 340.338 163.065 339.973 164.078 339.436 165.083 338.918 166.425 338.63 167.936 338.63 169.394 338.63 170.73 338.928 171.73 339.419 172.739 339.954 174.115 340.317 175.656 340.317 177.179 340.317 178.573 339.984 179.582 339.458 180.587 338.94 181.982 338.63 183.489 338.63 184.989 338.63 186.349 338.94 187.354 339.454 188.367 339.991 189.732 340.317 191.276 340.317L191.262 342.728' fill='%23005bbf'/%3E %3Cpath d='M191.262 342.728C189.717 342.728 188.367 342.401 187.354 341.866 186.349 341.347 184.989 341.031 183.489 341.031 181.982 341.031 180.587 341.35 179.582 341.869 178.573 342.394 177.179 342.728 175.656 342.728 174.115 342.728 172.743 342.362 171.73 341.826 170.734 341.333 169.398 341.031 167.936 341.031 166.425 341.031 165.083 341.326 164.078 341.847 163.065 342.38 161.663 342.728 160.126 342.728L160.126 340.338C161.663 340.338 163.065 339.973 164.078 339.436 165.083 338.918 166.425 338.63 167.936 338.63 169.394 338.63 170.73 338.928 171.73 339.419 172.739 339.954 174.115 340.317 175.656 340.317 177.179 340.317 178.573 339.984 179.582 339.458 180.587 338.94 181.982 338.63 183.489 338.63 184.989 338.63 186.349 338.94 187.354 339.454 188.367 339.991 189.732 340.317 191.276 340.317L191.262 342.728z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M166.919 320.783C166.973 320.986 167.047 321.185 167.047 321.401 167.047 322.864 165.784 324.028 164.239 324.028L187.175 324.028C185.63 324.028 184.366 322.864 184.366 321.401 184.366 321.188 184.407 320.986 184.461 320.783 184.329 320.83 184.172 320.837 184.022 320.837L167.332 320.837C167.197 320.837 167.04 320.822 166.919 320.783' fill='%23c8b100'/%3E %3Cpath d='M166.919 320.783C166.973 320.986 167.047 321.185 167.047 321.401 167.047 322.864 165.784 324.028 164.239 324.028L187.175 324.028C185.63 324.028 184.366 322.864 184.366 321.401 184.366 321.188 184.407 320.986 184.461 320.783 184.329 320.83 184.172 320.837 184.022 320.837L167.332 320.837C167.197 320.837 167.04 320.822 166.919 320.783z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M167.332 319.267L184.022 319.267C184.587 319.267 185.045 319.622 185.045 320.052 185.045 320.485 184.587 320.837 184.022 320.837L167.332 320.837C166.766 320.837 166.308 320.485 166.308 320.052 166.308 319.622 166.766 319.267 167.332 319.267' fill='%23c8b100'/%3E %3Cpath d='M167.332 319.267L184.022 319.267C184.587 319.267 185.045 319.622 185.045 320.052 185.045 320.485 184.587 320.837 184.022 320.837L167.332 320.837C166.766 320.837 166.308 320.485 166.308 320.052 166.308 319.622 166.766 319.267 167.332 319.267z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M164.269 329.863L187.145 329.863 187.145 324.028 164.269 324.028 164.269 329.863z' fill='%23c8b100'/%3E %3Cpath d='M164.269 329.863L187.145 329.863 187.145 324.028 164.269 324.028 164.269 329.863z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M162.48 298.618C160.216 299.925 158.682 301.263 158.93 301.931 159.054 302.545 159.773 303.003 160.8 303.685 162.417 304.811 163.399 306.821 162.63 307.748 163.969 306.669 164.816 305.056 164.816 303.263 164.816 301.388 163.924 299.698 162.48 298.618' fill='%23ad1519'/%3E %3Cpath d='M162.48 298.618C160.216 299.925 158.682 301.263 158.93 301.931 159.054 302.545 159.773 303.003 160.8 303.685 162.417 304.811 163.399 306.821 162.63 307.748 163.969 306.669 164.816 305.056 164.816 303.263 164.816 301.388 163.924 299.698 162.48 298.618z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M167.546 318.322L183.8 318.322 183.8 238.686 167.546 238.686 167.546 318.322z' fill='%23cccccc'/%3E %3Cpath d='M179.132 238.796L179.132 318.259M180.958 238.796L180.958 318.259' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M167.546 318.322L183.8 318.322 183.8 238.686 167.546 238.686 167.546 318.322z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M200.403 268.474C196.856 267.008 190.827 265.921 183.909 265.694 181.524 265.712 178.866 265.936 176.121 266.394 166.399 268.016 158.993 271.897 159.582 275.058 159.593 275.125 159.615 275.263 159.63 275.324 159.63 275.324 155.987 267.111 155.926 266.798 155.278 263.29 163.493 258.979 174.284 257.179 177.67 256.614 180.973 256.394 183.841 256.422 190.745 256.422 196.744 257.306 200.357 258.649L200.403 268.474' fill='%23ad1519'/%3E %3Cpath d='M200.403 268.474C196.856 267.008 190.827 265.921 183.909 265.694 181.524 265.712 178.866 265.936 176.121 266.394 166.399 268.016 158.993 271.897 159.582 275.058 159.593 275.125 159.615 275.263 159.63 275.324 159.63 275.324 155.987 267.111 155.926 266.798 155.278 263.29 163.493 258.979 174.284 257.179 177.67 256.614 180.973 256.394 183.841 256.422 190.745 256.422 196.744 257.306 200.357 258.649L200.403 268.474' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M167.52 278.47C163.013 278.147 159.935 276.943 159.582 275.058 159.304 273.556 160.827 271.894 163.549 270.385 164.764 270.516 166.132 270.683 167.546 270.683L167.52 278.47' fill='%23ad1519'/%3E %3Cpath d='M167.52 278.47C163.013 278.147 159.935 276.943 159.582 275.058 159.304 273.556 160.827 271.894 163.549 270.385 164.764 270.516 166.132 270.683 167.546 270.683L167.52 278.47' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M183.83 272.384C186.646 272.81 188.761 273.509 189.814 274.369L189.908 274.542C190.41 275.573 187.936 277.764 183.804 280.21L183.83 272.384' fill='%23ad1519'/%3E %3Cpath d='M183.83 272.384C186.646 272.81 188.761 273.509 189.814 274.369L189.908 274.542C190.41 275.573 187.936 277.764 183.804 280.21L183.83 272.384' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M157.422 293.832C156.994 292.546 161.39 289.972 167.602 287.693 170.441 286.677 172.784 285.618 175.689 284.337 184.318 280.522 190.692 276.144 189.908 274.547L189.822 274.383C190.283 274.756 190.995 282.621 190.995 282.621 191.783 284.084 185.949 288.398 178.003 292.205 175.461 293.42 170.092 295.404 167.557 296.292 163.024 297.865 158.517 300.831 158.93 301.931L157.422 293.836' fill='%23ad1519'/%3E %3Cpath d='M157.422 293.832C156.994 292.546 161.39 289.972 167.602 287.693 170.441 286.677 172.784 285.618 175.689 284.337 184.318 280.522 190.692 276.144 189.908 274.547L189.822 274.383C190.283 274.756 190.995 282.621 190.995 282.621 191.783 284.084 185.949 288.398 178.003 292.205 175.461 293.42 170.092 295.404 167.557 296.292 163.024 297.865 158.517 300.831 158.93 301.931L157.422 293.836 157.422 293.832z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M166.425 264.654C168.413 263.929 169.714 263.073 169.076 261.507 168.674 260.513 167.647 260.321 166.114 260.883L163.395 261.87 165.844 267.903C166.11 267.782 166.376 267.657 166.654 267.555 166.927 267.455 167.216 267.38 167.497 267.299L166.425 264.657 166.425 264.654zM165.244 261.742L165.93 261.493C166.5 261.284 167.145 261.586 167.43 262.289 167.643 262.825 167.587 263.421 166.931 263.84 166.717 263.972 166.47 264.071 166.23 264.167L165.244 261.742' fill='%23c8b100'/%3E %3Cpath d='M172.777 259.218C172.492 259.295 172.207 259.381 171.918 259.437 171.63 259.494 171.333 259.526 171.041 259.565L172.45 265.84 176.833 264.959C176.781 264.835 176.713 264.703 176.687 264.575 176.657 264.444 176.661 264.298 176.653 264.167 175.885 264.387 175.045 264.626 174.036 264.828L172.781 259.218' fill='%23c8b100'/%3E %3Cpath d='M181.555 264.629C182.383 262.353 183.384 260.172 184.37 257.964 184.194 257.992 184.006 258.017 183.83 258.027 183.654 258.038 183.463 258.041 183.286 258.034 182.762 259.636 182.109 261.237 181.423 262.832 180.598 261.319 179.687 259.842 178.993 258.318 178.652 258.362 178.303 258.411 177.958 258.436 177.618 258.457 177.261 258.453 176.92 258.457 178.184 260.516 179.402 262.569 180.557 264.693 180.718 264.664 180.883 264.626 181.058 264.614 181.22 264.603 181.39 264.619 181.555 264.626' fill='%23c8b100'/%3E %3Cpath d='M190.718 259.8C190.871 259.494 191.026 259.195 191.198 258.911 190.962 258.688 190.238 258.362 189.39 258.276 187.602 258.099 186.575 258.894 186.455 259.974 186.203 262.232 189.769 262.037 189.605 263.535 189.533 264.182 188.847 264.444 188.12 264.373 187.306 264.291 186.714 263.844 186.608 263.18L186.388 263.159C186.271 263.553 186.099 263.933 185.914 264.312 186.435 264.65 187.115 264.842 187.763 264.905 189.586 265.087 190.977 264.356 191.108 263.156 191.345 261.01 187.745 260.886 187.883 259.622 187.943 259.09 188.352 258.741 189.282 258.834 189.949 258.901 190.362 259.263 190.542 259.781L190.718 259.8' fill='%23c8b100'/%3E %3Cpath d='M324.846 220.423C324.846 220.423 324.111 221.197 323.574 221.307 323.039 221.414 322.36 220.825 322.36 220.825 322.36 220.825 321.877 221.328 321.284 221.463 320.692 221.598 319.869 220.795 319.869 220.795 319.869 220.795 319.304 221.598 318.797 221.786 318.288 221.974 317.669 221.546 317.669 221.546 317.669 221.546 317.444 221.943 317.02 222.163 316.84 222.248 316.541 222.106 316.541 222.106L315.943 221.733 315.264 221.009 314.643 220.767C314.643 220.767 314.362 219.858 314.332 219.699 314.31 219.539 314.249 219.134 314.249 219.134 314.123 218.485 315.123 217.731 316.551 217.408 317.373 217.217 318.088 217.231 318.614 217.394 319.184 216.908 320.392 216.57 321.812 216.57 323.098 216.57 324.227 216.843 324.85 217.266 325.464 216.843 326.593 216.57 327.883 216.57 329.296 216.57 330.503 216.908 331.074 217.394 331.602 217.231 332.314 217.22 333.14 217.408 334.564 217.731 335.569 218.485 335.441 219.134 335.441 219.134 335.381 219.539 335.356 219.699 335.326 219.858 335.045 220.767 335.045 220.767L334.422 221.009 333.743 221.733 333.155 222.106C333.155 222.106 332.855 222.248 332.675 222.163 332.251 221.946 332.022 221.546 332.022 221.546 332.022 221.546 331.4 221.974 330.893 221.786 330.384 221.598 329.818 220.795 329.818 220.795 329.818 220.795 329 221.598 328.403 221.463 327.811 221.328 327.33 220.825 327.33 220.825 327.33 220.825 326.651 221.414 326.117 221.307 325.577 221.197 324.85 220.423 324.85 220.423' fill='%23ad1519'/%3E %3Cpath d='M324.846 220.423C324.846 220.423 324.111 221.197 323.574 221.307 323.039 221.414 322.36 220.825 322.36 220.825 322.36 220.825 321.877 221.328 321.284 221.463 320.692 221.598 319.869 220.795 319.869 220.795 319.869 220.795 319.304 221.598 318.797 221.786 318.288 221.974 317.669 221.546 317.669 221.546 317.669 221.546 317.444 221.943 317.02 222.163 316.84 222.248 316.541 222.106 316.541 222.106L315.943 221.733 315.264 221.009 314.643 220.767C314.643 220.767 314.362 219.858 314.332 219.699 314.31 219.539 314.249 219.134 314.249 219.134 314.123 218.485 315.123 217.731 316.551 217.408 317.373 217.217 318.088 217.231 318.614 217.394 319.184 216.908 320.392 216.57 321.812 216.57 323.098 216.57 324.227 216.843 324.85 217.266 325.464 216.843 326.593 216.57 327.883 216.57 329.296 216.57 330.503 216.908 331.074 217.394 331.602 217.231 332.314 217.22 333.14 217.408 334.564 217.731 335.569 218.485 335.441 219.134 335.441 219.134 335.381 219.539 335.356 219.699 335.326 219.858 335.045 220.767 335.045 220.767L334.422 221.009 333.743 221.733 333.155 222.106C333.155 222.106 332.855 222.248 332.675 222.163 332.251 221.946 332.022 221.546 332.022 221.546 332.022 221.546 331.4 221.974 330.893 221.786 330.384 221.598 329.818 220.795 329.818 220.795 329.818 220.795 329 221.598 328.403 221.463 327.811 221.328 327.33 220.825 327.33 220.825 327.33 220.825 326.651 221.414 326.117 221.307 325.577 221.197 324.85 220.423 324.85 220.423L324.846 220.423z' fill='none' stroke='%23000' stroke-width='0.27'/%3E %3Cpath d='M323.447 216.197C323.447 215.114 324.063 214.237 324.823 214.237 325.584 214.237 326.203 215.114 326.203 216.197 326.203 217.284 325.584 218.164 324.823 218.164 324.063 218.164 323.447 217.284 323.447 216.197' fill='%23c8b100'/%3E %3Cpath d='M323.447 216.197C323.447 215.114 324.063 214.237 324.823 214.237 325.584 214.237 326.203 215.114 326.203 216.197 326.203 217.284 325.584 218.164 324.823 218.164 324.063 218.164 323.447 217.284 323.447 216.197z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.216 216.197C324.216 215.203 324.501 214.394 324.85 214.394 325.201 214.394 325.483 215.203 325.483 216.197 325.483 217.195 325.201 218.005 324.85 218.005 324.501 218.005 324.216 217.195 324.216 216.197' fill='%23c8b100'/%3E %3Cpath d='M324.216 216.197C324.216 215.203 324.501 214.394 324.85 214.394 325.201 214.394 325.483 215.203 325.483 216.197 325.483 217.195 325.201 218.005 324.85 218.005 324.501 218.005 324.216 217.195 324.216 216.197z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.747 224.251C317.545 223.679 317.165 223.168 317.165 223.168 319.113 222.596 321.823 222.237 324.838 222.23 327.853 222.237 330.582 222.596 332.529 223.168 332.529 223.168 332.311 223.551 332.007 224.084 331.839 224.379 331.617 224.893 331.632 224.893 329.873 224.354 327.609 224.077 324.827 224.074 322.041 224.077 319.363 224.418 317.968 224.929 317.988 224.929 317.871 224.606 317.732 224.251L317.747 224.251' fill='%23c8b100'/%3E %3Cpath d='M317.747 224.251C317.545 223.679 317.165 223.168 317.165 223.168 319.113 222.596 321.823 222.237 324.838 222.23 327.853 222.237 330.582 222.596 332.529 223.168 332.529 223.168 332.311 223.551 332.007 224.084 331.839 224.379 331.617 224.893 331.632 224.893 329.873 224.354 327.609 224.077 324.827 224.074 322.041 224.077 319.363 224.418 317.968 224.929 317.988 224.929 317.871 224.606 317.732 224.251L317.747 224.251' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.838 226.726C327.271 226.722 329.949 226.353 330.939 226.098 331.598 225.905 331.985 225.607 331.913 225.263 331.88 225.1 331.737 224.958 331.545 224.876 330.094 224.411 327.478 224.081 324.838 224.077 322.203 224.081 319.574 224.411 318.118 224.876 317.932 224.958 317.785 225.1 317.754 225.263 317.68 225.607 318.067 225.905 318.73 226.098 319.717 226.353 322.407 226.722 324.838 226.726' fill='%23c8b100'/%3E %3Cpath d='M324.838 226.726C327.271 226.722 329.949 226.353 330.939 226.098 331.598 225.905 331.985 225.607 331.913 225.263 331.88 225.1 331.737 224.958 331.545 224.876 330.094 224.411 327.478 224.081 324.838 224.077 322.203 224.081 319.574 224.411 318.118 224.876 317.932 224.958 317.785 225.1 317.754 225.263 317.68 225.607 318.067 225.905 318.73 226.098 319.717 226.353 322.407 226.722 324.838 226.726z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M330.736 217.075C330.736 216.836 330.939 216.645 331.185 216.645 331.437 216.645 331.64 216.836 331.64 217.075 331.64 217.313 331.437 217.501 331.185 217.501 330.939 217.501 330.736 217.313 330.736 217.075' fill='%23fff'/%3E %3Cpath d='M330.736 217.075C330.736 216.836 330.939 216.645 331.185 216.645 331.437 216.645 331.64 216.836 331.64 217.075 331.64 217.313 331.437 217.501 331.185 217.501 330.939 217.501 330.736 217.313 330.736 217.075z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M330.482 215.576C330.482 215.338 330.683 215.147 330.932 215.147 331.181 215.147 331.385 215.338 331.385 215.576 331.385 215.81 331.181 216.003 330.932 216.003 330.683 216.003 330.482 215.81 330.482 215.576zM329.349 214.638C329.349 214.401 329.55 214.209 329.803 214.209 330.049 214.209 330.253 214.401 330.253 214.638 330.253 214.877 330.049 215.068 329.803 215.068 329.55 215.068 329.349 214.877 329.349 214.638zM327.934 214.187C327.934 213.946 328.138 213.754 328.388 213.754 328.64 213.754 328.839 213.946 328.839 214.187 328.839 214.419 328.64 214.614 328.388 214.614 328.138 214.614 327.934 214.419 327.934 214.187zM326.495 214.237C326.495 213.999 326.697 213.808 326.945 213.808 327.197 213.808 327.4 213.999 327.4 214.237 327.4 214.475 327.197 214.663 326.945 214.663 326.697 214.663 326.495 214.475 326.495 214.237z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M335.206 219.986C335.341 219.656 335.425 219.29 335.425 218.91 335.425 217.32 334.164 216.027 332.6 216.027 332.101 216.027 331.632 216.162 331.224 216.396' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='0.26'/%3E %3Cpath d='M330.174 217.962C330.32 217.703 330.425 217.387 330.425 217.089 330.425 215.942 329.24 215.012 327.782 215.012 327.159 215.012 326.589 215.182 326.14 215.462' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M335.596 218.68C335.596 218.445 335.802 218.25 336.05 218.25 336.3 218.25 336.503 218.445 336.503 218.68 336.503 218.918 336.3 219.106 336.05 219.106 335.802 219.106 335.596 218.918 335.596 218.68zM335.425 217.103C335.425 216.864 335.63 216.677 335.88 216.677 336.128 216.677 336.331 216.864 336.331 217.103 336.331 217.338 336.128 217.529 335.88 217.529 335.63 217.529 335.425 217.338 335.425 217.103zM334.411 215.896C334.411 215.661 334.613 215.47 334.861 215.47 335.112 215.47 335.314 215.661 335.314 215.896 335.314 216.133 335.112 216.325 334.861 216.325 334.613 216.325 334.411 216.133 334.411 215.896zM333.053 215.252C333.053 215.019 333.256 214.827 333.506 214.827 333.755 214.827 333.957 215.019 333.957 215.252 333.957 215.491 333.755 215.686 333.506 215.686 333.256 215.686 333.053 215.491 333.053 215.252zM331.61 215.31C331.61 215.072 331.813 214.88 332.063 214.88 332.314 214.88 332.518 215.072 332.518 215.31 332.518 215.544 332.314 215.736 332.063 215.736 331.813 215.736 331.61 215.544 331.61 215.31z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M332.647 222.081L332.056 221.546C332.056 221.546 331.49 221.893 330.782 221.786 330.077 221.68 329.851 220.825 329.851 220.825 329.851 220.825 329.057 221.488 328.411 221.439 327.763 221.381 327.339 220.825 327.339 220.825 327.339 220.825 326.63 221.328 326.008 221.279 325.386 221.222 324.793 220.448 324.793 220.448 324.793 220.448 324.171 221.25 323.548 221.307 322.926 221.357 322.419 220.767 322.419 220.767 322.419 220.767 322.134 221.357 321.343 221.488 320.553 221.623 319.874 220.874 319.874 220.874 319.874 220.874 319.428 221.598 318.887 221.786 318.352 221.974 317.647 221.516 317.647 221.516 317.647 221.516 317.534 221.786 317.448 221.946 317.362 222.106 317.136 222.135 317.136 222.135L317.313 222.614C319.25 222.053 321.877 221.705 324.846 221.702 327.819 221.705 330.518 222.053 332.453 222.618L332.652 222.081' fill='%23c8b100'/%3E %3Cpath d='M332.647 222.081L332.056 221.546C332.056 221.546 331.49 221.893 330.782 221.786 330.077 221.68 329.851 220.825 329.851 220.825 329.851 220.825 329.057 221.488 328.411 221.439 327.763 221.381 327.339 220.825 327.339 220.825 327.339 220.825 326.63 221.328 326.008 221.279 325.386 221.222 324.793 220.448 324.793 220.448 324.793 220.448 324.171 221.25 323.548 221.307 322.926 221.357 322.419 220.767 322.419 220.767 322.419 220.767 322.134 221.357 321.343 221.488 320.553 221.623 319.874 220.874 319.874 220.874 319.874 220.874 319.428 221.598 318.887 221.786 318.352 221.974 317.647 221.516 317.647 221.516 317.647 221.516 317.534 221.786 317.448 221.946 317.362 222.106 317.136 222.135 317.136 222.135L317.313 222.614C319.25 222.053 321.877 221.705 324.846 221.702 327.819 221.705 330.518 222.053 332.453 222.618L332.652 222.081 332.647 222.081z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.977 217.075C317.977 216.836 318.178 216.645 318.43 216.645 318.677 216.645 318.88 216.836 318.88 217.075 318.88 217.313 318.677 217.501 318.43 217.501 318.178 217.501 317.977 217.313 317.977 217.075' fill='%23fff'/%3E %3Cpath d='M317.977 217.075C317.977 216.836 318.178 216.645 318.43 216.645 318.677 216.645 318.88 216.836 318.88 217.075 318.88 217.313 318.677 217.501 318.43 217.501 318.178 217.501 317.977 217.313 317.977 217.075z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M318.232 215.576C318.232 215.338 318.434 215.147 318.685 215.147 318.933 215.147 319.135 215.338 319.135 215.576 319.135 215.81 318.933 216.003 318.685 216.003 318.434 216.003 318.232 215.81 318.232 215.576zM319.36 214.638C319.36 214.401 319.563 214.209 319.814 214.209 320.065 214.209 320.268 214.401 320.268 214.638 320.268 214.877 320.065 215.068 319.814 215.068 319.563 215.068 319.36 214.877 319.36 214.638zM320.774 214.187C320.774 213.946 320.977 213.754 321.227 213.754 321.479 213.754 321.681 213.946 321.681 214.187 321.681 214.419 321.479 214.614 321.227 214.614 320.977 214.614 320.774 214.419 320.774 214.187zM322.217 214.237C322.217 213.999 322.419 213.808 322.667 213.808 322.919 213.808 323.121 213.999 323.121 214.237 323.121 214.475 322.919 214.663 322.667 214.663 322.419 214.663 322.217 214.475 322.217 214.237z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M314.408 219.986C314.276 219.656 314.19 219.29 314.19 218.91 314.19 217.32 315.453 216.027 317.015 216.027 317.515 216.027 317.983 216.162 318.393 216.396' fill='none' stroke='%23000' stroke-linecap='round' stroke-width='0.26'/%3E %3Cpath d='M319.476 217.927C319.33 217.671 319.19 217.387 319.19 217.089 319.19 215.942 320.376 215.012 321.834 215.012 322.453 215.012 323.027 215.182 323.477 215.462' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M313.114 218.68C313.114 218.445 313.315 218.25 313.568 218.25 313.813 218.25 314.017 218.445 314.017 218.68 314.017 218.918 313.813 219.106 313.568 219.106 313.315 219.106 313.114 218.918 313.114 218.68zM313.282 217.103C313.282 216.864 313.488 216.677 313.736 216.677 313.988 216.677 314.19 216.864 314.19 217.103 314.19 217.338 313.988 217.529 313.736 217.529 313.488 217.529 313.282 217.338 313.282 217.103zM314.302 215.896C314.302 215.661 314.504 215.47 314.756 215.47 315.004 215.47 315.206 215.661 315.206 215.896 315.206 216.133 315.004 216.325 314.756 216.325 314.504 216.325 314.302 216.133 314.302 215.896zM315.659 215.252C315.659 215.019 315.861 214.827 316.108 214.827 316.361 214.827 316.562 215.019 316.562 215.252 316.562 215.491 316.361 215.686 316.108 215.686 315.861 215.686 315.659 215.491 315.659 215.252zM317.099 215.31C317.099 215.072 317.301 214.88 317.553 214.88 317.804 214.88 318.003 215.072 318.003 215.31 318.003 215.544 317.804 215.736 317.553 215.736 317.301 215.736 317.099 215.544 317.099 215.31z' fill='none' stroke='%23000' stroke-width='0.21'/%3E %3Cpath d='M324.853 219.492L325.134 219.543C325.09 219.66 325.081 219.783 325.081 219.915 325.081 220.497 325.581 220.97 326.195 220.97 326.691 220.97 327.111 220.664 327.254 220.242 327.271 220.253 327.361 219.858 327.406 219.865 327.448 219.865 327.441 220.274 327.451 220.267 327.525 220.795 328.009 221.158 328.557 221.158 329.172 221.158 329.67 220.686 329.67 220.104 329.67 220.06 329.667 220.018 329.66 219.976L330.012 219.627 330.199 220.071C330.124 220.206 330.094 220.362 330.094 220.53 330.094 221.087 330.571 221.538 331.156 221.538 331.528 221.538 331.854 221.357 332.041 221.087L332.266 220.803 332.262 221.155C332.262 221.502 332.413 221.815 332.752 221.872 332.752 221.872 333.146 221.9 333.664 221.488 334.186 221.08 334.471 220.739 334.471 220.739L334.501 221.158C334.501 221.158 333.99 221.996 333.529 222.262 333.275 222.411 332.887 222.568 332.581 222.514 332.254 222.465 332.026 222.202 331.905 221.904 331.674 222.042 331.4 222.12 331.107 222.12 330.478 222.12 329.912 221.772 329.69 221.258 329.4 221.57 328.996 221.758 328.523 221.758 328.022 221.758 327.561 221.534 327.271 221.183 326.987 221.446 326.601 221.606 326.176 221.606 325.622 221.606 325.123 221.328 324.842 220.92 324.56 221.328 324.069 221.606 323.51 221.606 323.086 221.606 322.701 221.446 322.416 221.183 322.127 221.534 321.67 221.758 321.164 221.758 320.692 221.758 320.29 221.57 320.002 221.258 319.779 221.769 319.21 222.12 318.584 222.12 318.292 222.12 318.021 222.042 317.789 221.904 317.669 222.202 317.437 222.465 317.114 222.514 316.807 222.568 316.42 222.411 316.166 222.262 315.7 221.996 315.15 221.158 315.15 221.158L315.221 220.739C315.221 220.739 315.505 221.08 316.024 221.488 316.544 221.9 316.938 221.872 316.938 221.872 317.279 221.815 317.424 221.502 317.424 221.155L317.424 220.803 317.647 221.087C317.838 221.357 318.163 221.538 318.531 221.538 319.121 221.538 319.596 221.087 319.596 220.53 319.596 220.362 319.566 220.206 319.491 220.071L319.679 219.627 320.027 219.976C320.02 220.018 320.02 220.06 320.02 220.104 320.02 220.686 320.515 221.158 321.125 221.158 321.677 221.158 322.161 220.795 322.232 220.267 322.247 220.274 322.242 219.865 322.28 219.865 322.33 219.858 322.419 220.253 322.434 220.242 322.58 220.664 323 220.97 323.495 220.97 324.111 220.97 324.609 220.497 324.609 219.915 324.609 219.783 324.602 219.66 324.557 219.543L324.846 219.492' fill='%23c8b100'/%3E %3Cpath d='M324.853 219.492L325.134 219.543C325.09 219.66 325.081 219.783 325.081 219.915 325.081 220.497 325.581 220.97 326.195 220.97 326.691 220.97 327.111 220.664 327.254 220.242 327.271 220.253 327.361 219.858 327.406 219.865 327.448 219.865 327.441 220.274 327.451 220.267 327.525 220.795 328.009 221.158 328.557 221.158 329.172 221.158 329.67 220.686 329.67 220.104 329.67 220.06 329.667 220.018 329.66 219.976L330.012 219.627 330.199 220.071C330.124 220.206 330.094 220.362 330.094 220.53 330.094 221.087 330.571 221.538 331.156 221.538 331.528 221.538 331.854 221.357 332.041 221.087L332.266 220.803 332.262 221.155C332.262 221.502 332.413 221.815 332.752 221.872 332.752 221.872 333.146 221.9 333.664 221.488 334.186 221.08 334.471 220.739 334.471 220.739L334.501 221.158C334.501 221.158 333.99 221.996 333.529 222.262 333.275 222.411 332.887 222.568 332.581 222.514 332.254 222.465 332.026 222.202 331.905 221.904 331.674 222.042 331.4 222.12 331.107 222.12 330.478 222.12 329.912 221.772 329.69 221.258 329.4 221.57 328.996 221.758 328.523 221.758 328.022 221.758 327.561 221.534 327.271 221.183 326.987 221.446 326.601 221.606 326.176 221.606 325.622 221.606 325.123 221.328 324.842 220.92 324.56 221.328 324.069 221.606 323.51 221.606 323.086 221.606 322.701 221.446 322.416 221.183 322.127 221.534 321.67 221.758 321.164 221.758 320.692 221.758 320.29 221.57 320.002 221.258 319.779 221.769 319.21 222.12 318.584 222.12 318.292 222.12 318.021 222.042 317.789 221.904 317.669 222.202 317.437 222.465 317.114 222.514 316.807 222.568 316.42 222.411 316.166 222.262 315.7 221.996 315.15 221.158 315.15 221.158L315.221 220.739C315.221 220.739 315.505 221.08 316.024 221.488 316.544 221.9 316.938 221.872 316.938 221.872 317.279 221.815 317.424 221.502 317.424 221.155L317.424 220.803 317.647 221.087C317.838 221.357 318.163 221.538 318.531 221.538 319.121 221.538 319.596 221.087 319.596 220.53 319.596 220.362 319.566 220.206 319.491 220.071L319.679 219.627 320.027 219.976C320.02 220.018 320.02 220.06 320.02 220.104 320.02 220.686 320.515 221.158 321.125 221.158 321.677 221.158 322.161 220.795 322.232 220.267 322.247 220.274 322.242 219.865 322.28 219.865 322.33 219.858 322.419 220.253 322.434 220.242 322.58 220.664 323 220.97 323.495 220.97 324.111 220.97 324.609 220.497 324.609 219.915 324.609 219.783 324.602 219.66 324.557 219.543L324.846 219.492 324.853 219.492z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.838 222.234C321.823 222.237 319.116 222.596 317.17 223.172 317.04 223.214 316.88 223.114 316.837 222.997 316.795 222.874 316.89 222.721 317.015 222.678 318.974 222.081 321.749 221.705 324.838 221.702 327.924 221.705 330.713 222.081 332.668 222.678 332.797 222.721 332.892 222.874 332.851 222.997 332.81 223.114 332.644 223.214 332.518 223.172 330.571 222.596 327.853 222.237 324.838 222.234' fill='%23c8b100'/%3E %3Cpath d='M324.838 222.234C321.823 222.237 319.116 222.596 317.17 223.172 317.04 223.214 316.88 223.114 316.837 222.997 316.795 222.874 316.89 222.721 317.015 222.678 318.974 222.081 321.749 221.705 324.838 221.702 327.924 221.705 330.713 222.081 332.668 222.678 332.797 222.721 332.892 222.874 332.851 222.997 332.81 223.114 332.644 223.214 332.518 223.172 330.571 222.596 327.853 222.237 324.838 222.234z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M321.921 223.303C321.921 223.076 322.116 222.891 322.36 222.891 322.6 222.891 322.795 223.076 322.795 223.303 322.795 223.533 322.6 223.714 322.36 223.714 322.116 223.714 321.921 223.533 321.921 223.303' fill='%23fff'/%3E %3Cpath d='M321.921 223.303C321.921 223.076 322.116 222.891 322.36 222.891 322.6 222.891 322.795 223.076 322.795 223.303 322.795 223.533 322.6 223.714 322.36 223.714 322.116 223.714 321.921 223.533 321.921 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.875 223.481L323.905 223.481C323.724 223.481 323.574 223.339 323.574 223.168 323.574 223 323.72 222.863 323.901 222.863L325.862 222.863C326.042 222.863 326.183 223 326.183 223.168 326.183 223.339 326.038 223.481 325.858 223.481L324.875 223.481' fill='%23ad1519'/%3E %3Cpath d='M324.875 223.481L323.905 223.481C323.724 223.481 323.574 223.339 323.574 223.168 323.574 223 323.72 222.863 323.901 222.863L325.862 222.863C326.042 222.863 326.183 223 326.183 223.168 326.183 223.339 326.038 223.481 325.858 223.481L324.875 223.481' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M320.017 223.814L319.323 223.917C319.145 223.942 318.978 223.828 318.948 223.658 318.921 223.491 319.04 223.335 319.217 223.31L319.914 223.207 320.626 223.097C320.804 223.076 320.968 223.186 320.999 223.353 321.025 223.519 320.901 223.679 320.725 223.704L320.017 223.814' fill='%23058e6e'/%3E %3Cpath d='M320.017 223.814L319.323 223.917C319.145 223.942 318.978 223.828 318.948 223.658 318.921 223.491 319.04 223.335 319.217 223.31L319.914 223.207 320.626 223.097C320.804 223.076 320.968 223.186 320.999 223.353 321.025 223.519 320.901 223.679 320.725 223.704L320.017 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.215 224.3L317.523 223.804 318.183 223.928 317.8 224.486 317.215 224.3' fill='%23ad1519'/%3E %3Cpath d='M317.215 224.3L317.523 223.804 318.183 223.928 317.8 224.486 317.215 224.3' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M326.886 223.303C326.886 223.076 327.084 222.891 327.324 222.891 327.565 222.891 327.763 223.076 327.763 223.303 327.763 223.533 327.565 223.714 327.324 223.714 327.084 223.714 326.886 223.533 326.886 223.303' fill='%23fff'/%3E %3Cpath d='M326.886 223.303C326.886 223.076 327.084 222.891 327.324 222.891 327.565 222.891 327.763 223.076 327.763 223.303 327.763 223.533 327.565 223.714 327.324 223.714 327.084 223.714 326.886 223.533 326.886 223.303z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M329.664 223.814L330.362 223.917C330.538 223.942 330.702 223.828 330.732 223.658 330.758 223.491 330.643 223.335 330.467 223.31L329.769 223.207 329.057 223.097C328.877 223.076 328.711 223.186 328.685 223.353 328.655 223.519 328.783 223.679 328.959 223.704L329.664 223.814' fill='%23058e6e'/%3E %3Cpath d='M329.664 223.814L330.362 223.917C330.538 223.942 330.702 223.828 330.732 223.658 330.758 223.491 330.643 223.335 330.467 223.31L329.769 223.207 329.057 223.097C328.877 223.076 328.711 223.186 328.685 223.353 328.655 223.519 328.783 223.679 328.959 223.704L329.664 223.814' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M332.409 224.329L332.161 223.8 331.484 223.856 331.809 224.449 332.409 224.329' fill='%23ad1519'/%3E %3Cpath d='M332.409 224.329L332.161 223.8 331.484 223.856 331.809 224.449 332.409 224.329' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.834 226.161C322.401 226.158 320.2 225.945 318.524 225.512 320.2 225.082 322.401 224.816 324.834 224.809 327.268 224.812 329.48 225.079 331.151 225.512 329.48 225.945 327.268 226.158 324.834 226.161' fill='%23ad1519'/%3E %3Cpath d='M324.834 226.161C322.401 226.158 320.2 225.945 318.524 225.512 320.2 225.082 322.401 224.816 324.834 224.809 327.268 224.812 329.48 225.079 331.151 225.512 329.48 225.945 327.268 226.158 324.834 226.161z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.26'/%3E %3Cpath d='M332.506 220.885C332.57 220.697 332.514 220.511 332.374 220.465 332.239 220.427 332.079 220.548 332.015 220.728 331.948 220.92 332.007 221.109 332.142 221.151 332.277 221.19 332.442 221.073 332.506 220.885' fill='%23c8b100'/%3E %3Cpath d='M332.506 220.885C332.57 220.697 332.514 220.511 332.374 220.465 332.239 220.427 332.079 220.548 332.015 220.728 331.948 220.92 332.007 221.109 332.142 221.151 332.277 221.19 332.442 221.073 332.506 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M327.661 219.948C327.687 219.752 327.59 219.578 327.448 219.56 327.309 219.543 327.17 219.692 327.148 219.887 327.122 220.082 327.215 220.256 327.358 220.274 327.5 220.288 327.635 220.139 327.661 219.948' fill='%23c8b100'/%3E %3Cpath d='M327.661 219.948C327.687 219.752 327.59 219.578 327.448 219.56 327.309 219.543 327.17 219.692 327.148 219.887 327.122 220.082 327.215 220.256 327.358 220.274 327.5 220.288 327.635 220.139 327.661 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M322.038 219.948C322.012 219.752 322.104 219.578 322.247 219.56 322.39 219.543 322.524 219.692 322.551 219.887 322.572 220.082 322.48 220.256 322.341 220.274 322.199 220.288 322.063 220.139 322.038 219.948' fill='%23c8b100'/%3E %3Cpath d='M322.038 219.948C322.012 219.752 322.104 219.578 322.247 219.56 322.39 219.543 322.524 219.692 322.551 219.887 322.572 220.082 322.48 220.256 322.341 220.274 322.199 220.288 322.063 220.139 322.038 219.948z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.193 220.885C317.125 220.697 317.186 220.511 317.32 220.465 317.454 220.427 317.62 220.548 317.684 220.728 317.747 220.92 317.691 221.109 317.557 221.151 317.418 221.19 317.256 221.073 317.193 220.885' fill='%23c8b100'/%3E %3Cpath d='M317.193 220.885C317.125 220.697 317.186 220.511 317.32 220.465 317.454 220.427 317.62 220.548 317.684 220.728 317.747 220.92 317.691 221.109 317.557 221.151 317.418 221.19 317.256 221.073 317.193 220.885z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.834 217.149L323.976 217.667 324.612 219.048 324.834 219.194 325.052 219.048 325.693 217.667 324.834 217.149' fill='%23c8b100'/%3E %3Cpath d='M324.834 217.149L323.976 217.667 324.612 219.048 324.834 219.194 325.052 219.048 325.693 217.667 324.834 217.149' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M322.951 219.237L323.343 219.806 324.681 219.393 324.823 219.206 324.681 219.013 323.343 218.622 322.951 219.237' fill='%23c8b100'/%3E %3Cpath d='M322.951 219.237L323.343 219.806 324.681 219.393 324.823 219.206 324.681 219.013 323.343 218.622 322.951 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M326.724 219.237L326.33 219.806 324.992 219.393 324.85 219.206 324.992 219.013 326.33 218.622 326.724 219.237' fill='%23c8b100'/%3E %3Cpath d='M326.724 219.237L326.33 219.806 324.992 219.393 324.85 219.206 324.992 219.013 326.33 218.622 326.724 219.237' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M319.25 217.764L318.577 218.399 319.439 219.536 319.668 219.627 319.837 219.453 320.14 218.08 319.25 217.764' fill='%23c8b100'/%3E %3Cpath d='M319.25 217.764L318.577 218.399 319.439 219.536 319.668 219.627 319.837 219.453 320.14 218.08 319.25 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M317.838 220.043L318.343 220.518 319.566 219.858 319.659 219.646 319.484 219.485 318.086 219.365 317.838 220.043' fill='%23c8b100'/%3E %3Cpath d='M317.838 220.043L318.343 220.518 319.566 219.858 319.659 219.646 319.484 219.485 318.086 219.365 317.838 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M321.527 219.301L321.269 219.929 319.869 219.802 319.687 219.641 319.783 219.425 321.01 218.779 321.527 219.301' fill='%23c8b100'/%3E %3Cpath d='M321.527 219.301L321.269 219.929 319.869 219.802 319.687 219.641 319.783 219.425 321.01 218.779 321.527 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M316.492 220.22L316.376 220.885 314.975 221.03 314.763 220.909 314.816 220.683 315.869 219.809 316.492 220.22' fill='%23c8b100'/%3E %3Cpath d='M316.492 220.22L316.376 220.885 314.975 221.03 314.763 220.909 314.816 220.683 315.869 219.809 316.492 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M319.188 219.649C319.188 219.39 319.409 219.18 319.679 219.18 319.952 219.18 320.17 219.39 320.17 219.649 320.17 219.904 319.952 220.114 319.679 220.114 319.409 220.114 319.188 219.904 319.188 219.649' fill='%23c8b100'/%3E %3Cpath d='M319.188 219.649C319.188 219.39 319.409 219.18 319.679 219.18 319.952 219.18 320.17 219.39 320.17 219.649 320.17 219.904 319.952 220.114 319.679 220.114 319.409 220.114 319.188 219.904 319.188 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M330.436 217.764L331.111 218.399 330.248 219.536 330.019 219.627 329.851 219.453 329.547 218.08 330.436 217.764' fill='%23c8b100'/%3E %3Cpath d='M330.436 217.764L331.111 218.399 330.248 219.536 330.019 219.627 329.851 219.453 329.547 218.08 330.436 217.764' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M331.85 220.043L331.344 220.518 330.121 219.858 330.023 219.646 330.204 219.485 331.602 219.365 331.85 220.043' fill='%23c8b100'/%3E %3Cpath d='M331.85 220.043L331.344 220.518 330.121 219.858 330.023 219.646 330.204 219.485 331.602 219.365 331.85 220.043' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M328.16 219.301L328.418 219.929 329.818 219.802 329.997 219.641 329.904 219.425 328.678 218.779 328.16 219.301' fill='%23c8b100'/%3E %3Cpath d='M328.16 219.301L328.418 219.929 329.818 219.802 329.997 219.641 329.904 219.425 328.678 218.779 328.16 219.301' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M333.008 220.22L333.121 220.885 334.518 221.03 334.729 220.909 334.676 220.683 333.627 219.809 333.008 220.22' fill='%23c8b100'/%3E %3Cpath d='M333.008 220.22L333.121 220.885 334.518 221.03 334.729 220.909 334.676 220.683 333.627 219.809 333.008 220.22' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M324.351 219.209C324.351 218.946 324.567 218.74 324.842 218.74 325.108 218.74 325.333 218.946 325.333 219.209 325.333 219.464 325.111 219.674 324.842 219.674 324.567 219.674 324.351 219.464 324.351 219.209' fill='%23c8b100'/%3E %3Cpath d='M324.351 219.209C324.351 218.946 324.567 218.74 324.842 218.74 325.108 218.74 325.333 218.946 325.333 219.209 325.333 219.464 325.111 219.674 324.842 219.674 324.567 219.674 324.351 219.464 324.351 219.209z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M329.525 219.649C329.525 219.39 329.746 219.18 330.016 219.18 330.289 219.18 330.512 219.39 330.512 219.649 330.512 219.904 330.289 220.114 330.016 220.114 329.746 220.114 329.525 219.904 329.525 219.649' fill='%23c8b100'/%3E %3Cpath d='M329.525 219.649C329.525 219.39 329.746 219.18 330.016 219.18 330.289 219.18 330.512 219.39 330.512 219.649 330.512 219.904 330.289 220.114 330.016 220.114 329.746 220.114 329.525 219.904 329.525 219.649z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M323.92 213.954C323.92 213.47 324.332 213.08 324.842 213.08 325.35 213.08 325.768 213.47 325.768 213.954 325.768 214.436 325.35 214.827 324.842 214.827 324.332 214.827 323.92 214.436 323.92 213.954' fill='%23c8b100'/%3E %3Cpath d='M325.494 213.644L325.494 214.223 324.069 214.223 324.069 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.753 211.755 325.753 212.337 325.146 212.337 325.146 213.644 325.49 213.644' fill='%23c8b100'/%3E %3Cpath d='M325.494 213.644L325.494 214.223 324.069 214.223 324.069 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.753 211.755 325.753 212.337 325.146 212.337 325.146 213.644 325.49 213.644 325.494 213.644z' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M326.132 213.644L326.132 214.223 323.597 214.223 323.597 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.756 211.755 325.756 212.337 325.146 212.337 325.146 213.644 326.132 213.644' fill='%23c8b100'/%3E %3Cpath d='M325.108 213.115C325.49 213.218 325.768 213.556 325.768 213.954 325.768 214.436 325.356 214.827 324.842 214.827 324.332 214.827 323.92 214.436 323.92 213.954 323.92 213.549 324.209 213.211 324.602 213.108' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M314.598 220.998C314.587 221.009 314.219 220.515 313.942 220.267 313.747 220.093 313.268 219.944 313.268 219.944 313.268 219.855 313.549 219.656 313.853 219.656 314.029 219.656 314.197 219.73 314.297 219.855L314.332 219.663C314.332 219.663 314.58 219.709 314.688 219.983 314.801 220.267 314.73 220.697 314.73 220.697 314.73 220.697 314.684 220.895 314.598 220.998' fill='%23c8b100'/%3E %3Cpath d='M314.598 220.998C314.587 221.009 314.219 220.515 313.942 220.267 313.747 220.093 313.268 219.944 313.268 219.944 313.268 219.855 313.549 219.656 313.853 219.656 314.029 219.656 314.197 219.73 314.297 219.855L314.332 219.663C314.332 219.663 314.58 219.709 314.688 219.983 314.801 220.267 314.73 220.697 314.73 220.697 314.73 220.697 314.684 220.895 314.598 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M314.617 220.753C314.734 220.632 314.973 220.657 315.15 220.81 315.33 220.963 315.382 221.186 315.264 221.311 315.15 221.435 314.913 221.407 314.734 221.254 314.553 221.101 314.501 220.874 314.617 220.753' fill='%23c8b100'/%3E %3Cpath d='M314.617 220.753C314.734 220.632 314.973 220.657 315.15 220.81 315.33 220.963 315.382 221.186 315.264 221.311 315.15 221.435 314.913 221.407 314.734 221.254 314.553 221.101 314.501 220.874 314.617 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M334.897 220.998C334.912 221.009 335.275 220.515 335.554 220.267 335.746 220.093 336.229 219.944 336.229 219.944 336.229 219.855 335.948 219.656 335.644 219.656 335.468 219.656 335.299 219.73 335.198 219.855L335.161 219.663C335.161 219.663 334.912 219.709 334.804 219.983 334.692 220.267 334.762 220.697 334.762 220.697 334.762 220.697 334.807 220.895 334.897 220.998' fill='%23c8b100'/%3E %3Cpath d='M334.897 220.998C334.912 221.009 335.275 220.515 335.554 220.267 335.746 220.093 336.229 219.944 336.229 219.944 336.229 219.855 335.948 219.656 335.644 219.656 335.468 219.656 335.299 219.73 335.198 219.855L335.161 219.663C335.161 219.663 334.912 219.709 334.804 219.983 334.692 220.267 334.762 220.697 334.762 220.697 334.762 220.697 334.807 220.895 334.897 220.998z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M334.91 220.753C334.792 220.632 334.554 220.657 334.373 220.81 334.193 220.963 334.145 221.186 334.256 221.311 334.373 221.435 334.613 221.407 334.792 221.254 334.972 221.101 335.026 220.874 334.91 220.753' fill='%23c8b100'/%3E %3Cpath d='M334.91 220.753C334.792 220.632 334.554 220.657 334.373 220.81 334.193 220.963 334.145 221.186 334.256 221.311 334.373 221.435 334.613 221.407 334.792 221.254 334.972 221.101 335.026 220.874 334.91 220.753z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M313.714 232.369L335.999 232.369 335.999 226.527 313.714 226.527 313.714 232.369z' fill='%23c8b100'/%3E %3Cpath d='M313.714 232.369L335.999 232.369 335.999 226.527 313.714 226.527 313.714 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M333.661 236.256C333.521 236.2 333.416 236.193 333.249 236.193L316.559 236.193C316.394 236.193 316.237 236.221 316.098 236.274 316.672 236.083 317.084 235.565 317.084 234.953 317.084 234.343 316.635 233.814 316.057 233.615 316.196 233.657 316.382 233.697 316.547 233.697L333.249 233.697C333.416 233.697 333.575 233.69 333.717 233.643L333.623 233.657C333.027 233.842 332.686 234.371 332.686 234.953 332.686 235.514 333.064 236.076 333.661 236.256' fill='%23c8b100'/%3E %3Cpath d='M333.661 236.256C333.521 236.2 333.416 236.193 333.249 236.193L316.559 236.193C316.394 236.193 316.237 236.221 316.098 236.274 316.672 236.083 317.084 235.565 317.084 234.953 317.084 234.343 316.635 233.814 316.057 233.615 316.196 233.657 316.382 233.697 316.547 233.697L333.249 233.697C333.416 233.697 333.575 233.69 333.717 233.643L333.623 233.657C333.027 233.842 332.686 234.371 332.686 234.953 332.686 235.514 333.064 236.076 333.661 236.256z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M316.559 236.193L333.249 236.193C333.81 236.193 334.269 236.544 334.269 236.974 334.269 237.407 333.81 237.759 333.249 237.759L316.559 237.759C315.993 237.759 315.535 237.407 315.535 236.974 315.535 236.544 315.993 236.193 316.559 236.193' fill='%23c8b100'/%3E %3Cpath d='M316.559 236.193L333.249 236.193C333.81 236.193 334.269 236.544 334.269 236.974 334.269 237.407 333.81 237.759 333.249 237.759L316.559 237.759C315.993 237.759 315.535 237.407 315.535 236.974 315.535 236.544 315.993 236.193 316.559 236.193z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.547 232.369L333.249 232.369C333.81 232.369 334.269 232.667 334.269 233.029 334.269 233.398 333.81 233.697 333.249 233.697L316.547 233.697C315.982 233.697 315.524 233.398 315.524 233.029 315.524 232.667 315.982 232.369 316.547 232.369' fill='%23c8b100'/%3E %3Cpath d='M316.547 232.369L333.249 232.369C333.81 232.369 334.269 232.667 334.269 233.029 334.269 233.398 333.81 233.697 333.249 233.697L316.547 233.697C315.982 233.697 315.524 233.398 315.524 233.029 315.524 232.667 315.982 232.369 316.547 232.369z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.297 330.676C310.841 330.676 312.212 330.353 313.225 329.813 314.231 329.302 315.592 328.989 317.091 328.989 318.595 328.989 319.994 329.306 320.999 329.82 322.004 330.35 323.398 330.676 324.921 330.676 326.458 330.676 327.838 330.317 328.85 329.778 329.847 329.287 331.178 328.989 332.644 328.989 334.156 328.989 335.494 329.277 336.503 329.799 337.511 330.336 338.917 330.676 340.454 330.676L340.454 333.09C338.917 333.09 337.511 332.739 336.503 332.206 335.494 331.688 334.156 331.394 332.644 331.394 331.178 331.394 329.847 331.695 328.85 332.189 327.842 332.725 326.458 333.09 324.921 333.09 323.402 333.09 322.007 332.757 320.999 332.232 319.994 331.71 318.599 331.394 317.091 331.394 315.592 331.394 314.231 331.71 313.225 332.225 312.212 332.764 310.86 333.09 309.319 333.09L309.297 330.676' fill='%23005bbf'/%3E %3Cpath d='M309.297 330.676C310.841 330.676 312.212 330.353 313.225 329.813 314.231 329.302 315.592 328.989 317.091 328.989 318.595 328.989 319.994 329.306 320.999 329.82 322.004 330.35 323.398 330.676 324.921 330.676 326.458 330.676 327.838 330.317 328.85 329.778 329.847 329.287 331.178 328.989 332.644 328.989 334.156 328.989 335.494 329.277 336.503 329.799 337.511 330.336 338.917 330.676 340.454 330.676L340.454 333.09C338.917 333.09 337.511 332.739 336.503 332.206 335.494 331.688 334.156 331.394 332.644 331.394 331.178 331.394 329.847 331.695 328.85 332.189 327.842 332.725 326.458 333.09 324.921 333.09 323.402 333.09 322.007 332.757 320.999 332.232 319.994 331.71 318.599 331.394 317.091 331.394 315.592 331.394 314.231 331.71 313.225 332.225 312.212 332.764 310.86 333.09 309.319 333.09L309.297 330.676z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.297 333.09C310.841 333.09 312.212 332.764 313.225 332.225 314.231 331.71 315.592 331.394 317.091 331.394 318.595 331.394 319.994 331.71 320.999 332.232 322.004 332.757 323.398 333.09 324.921 333.09 326.458 333.09 327.838 332.725 328.85 332.189 329.847 331.695 331.178 331.394 332.644 331.394 334.156 331.394 335.494 331.688 336.503 332.206 337.511 332.739 338.917 333.09 340.454 333.09L340.454 335.498C338.917 335.498 337.511 335.154 336.503 334.621 335.494 334.095 334.156 333.804 332.644 333.804 331.178 333.804 329.847 334.106 328.85 334.6 327.842 335.136 326.458 335.498 324.921 335.498 323.402 335.498 322.007 335.165 320.999 334.639 319.994 334.121 318.599 333.804 317.091 333.804 315.592 333.804 314.231 334.121 313.225 334.635 312.212 335.172 310.86 335.498 309.319 335.498L309.297 333.09' fill='%23cccccc'/%3E %3Cpath d='M309.297 333.09C310.841 333.09 312.212 332.764 313.225 332.225 314.231 331.71 315.592 331.394 317.091 331.394 318.595 331.394 319.994 331.71 320.999 332.232 322.004 332.757 323.398 333.09 324.921 333.09 326.458 333.09 327.838 332.725 328.85 332.189 329.847 331.695 331.178 331.394 332.644 331.394 334.156 331.394 335.494 331.688 336.503 332.206 337.511 332.739 338.917 333.09 340.454 333.09L340.454 335.498C338.917 335.498 337.511 335.154 336.503 334.621 335.494 334.095 334.156 333.804 332.644 333.804 331.178 333.804 329.847 334.106 328.85 334.6 327.842 335.136 326.458 335.498 324.921 335.498 323.402 335.498 322.007 335.165 320.999 334.639 319.994 334.121 318.599 333.804 317.091 333.804 315.592 333.804 314.231 334.121 313.225 334.635 312.212 335.172 310.86 335.498 309.319 335.498L309.297 333.09' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.297 335.498C310.841 335.498 312.212 335.172 313.225 334.635 314.231 334.121 315.592 333.804 317.091 333.804 318.595 333.804 319.994 334.121 320.999 334.639 322.004 335.165 323.398 335.498 324.921 335.498 326.458 335.498 327.838 335.136 328.85 334.6 329.847 334.106 331.178 333.804 332.644 333.804 334.156 333.804 335.494 334.095 336.503 334.621 337.511 335.154 338.917 335.498 340.454 335.498L340.454 337.905C338.917 337.905 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.86 337.905 309.319 337.905L309.297 335.498' fill='%23005bbf'/%3E %3Cpath d='M309.297 335.498C310.841 335.498 312.212 335.172 313.225 334.635 314.231 334.121 315.592 333.804 317.091 333.804 318.595 333.804 319.994 334.121 320.999 334.639 322.004 335.165 323.398 335.498 324.921 335.498 326.458 335.498 327.838 335.136 328.85 334.6 329.847 334.106 331.178 333.804 332.644 333.804 334.156 333.804 335.494 334.095 336.503 334.621 337.511 335.154 338.917 335.498 340.454 335.498L340.454 337.905C338.917 337.905 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.86 337.905 309.319 337.905L309.297 335.498' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.319 340.317C310.86 340.317 312.212 339.991 313.225 339.451 314.231 338.94 315.592 338.626 317.091 338.626 318.595 338.626 319.994 338.94 320.999 339.458 322.004 339.984 323.398 340.317 324.921 340.317 326.458 340.317 327.838 339.954 328.85 339.415 329.847 338.925 331.178 338.626 332.644 338.626 334.156 338.626 335.494 338.918 336.503 339.436 337.511 339.973 338.917 340.317 340.454 340.317L340.454 337.921C338.917 337.921 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.841 337.905 309.297 337.905L309.319 340.317' fill='%23cccccc'/%3E %3Cpath d='M309.319 340.317C310.86 340.317 312.212 339.991 313.225 339.451 314.231 338.94 315.592 338.626 317.091 338.626 318.595 338.626 319.994 338.94 320.999 339.458 322.004 339.984 323.398 340.317 324.921 340.317 326.458 340.317 327.838 339.954 328.85 339.415 329.847 338.925 331.178 338.626 332.644 338.626 334.156 338.626 335.494 338.918 336.503 339.436 337.511 339.973 338.917 340.317 340.454 340.317L340.454 337.921C338.917 337.921 337.511 337.561 336.503 337.025 335.494 336.507 334.156 336.216 332.644 336.216 331.178 336.216 329.847 336.518 328.85 337.007 327.842 337.547 326.458 337.905 324.921 337.905 323.402 337.905 322.007 337.576 320.999 337.051 319.994 336.532 318.599 336.216 317.091 336.216 315.592 336.216 314.231 336.528 313.225 337.044 312.212 337.586 310.841 337.905 309.297 337.905L309.319 340.317' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M309.319 342.728C310.86 342.728 312.212 342.401 313.225 341.866 314.231 341.347 315.592 341.031 317.091 341.031 318.595 341.031 319.994 341.35 320.999 341.869 322.004 342.394 323.398 342.728 324.921 342.728 326.458 342.728 327.838 342.362 328.85 341.826 329.847 341.333 331.178 341.031 332.644 341.031 334.156 341.031 335.494 341.326 336.503 341.847 337.511 342.38 338.917 342.728 340.454 342.728L340.454 340.338C338.917 340.338 337.511 339.973 336.503 339.436 335.494 338.918 334.156 338.63 332.644 338.63 331.178 338.63 329.847 338.928 328.85 339.419 327.842 339.954 326.458 340.317 324.921 340.317 323.402 340.317 322.007 339.984 320.999 339.458 319.994 338.94 318.599 338.63 317.091 338.63 315.592 338.63 314.231 338.94 313.225 339.454 312.212 339.991 310.845 340.317 309.304 340.317L309.319 342.728' fill='%23005bbf'/%3E %3Cpath d='M309.319 342.728C310.86 342.728 312.212 342.401 313.225 341.866 314.231 341.347 315.592 341.031 317.091 341.031 318.595 341.031 319.994 341.35 320.999 341.869 322.004 342.394 323.398 342.728 324.921 342.728 326.458 342.728 327.838 342.362 328.85 341.826 329.847 341.333 331.178 341.031 332.644 341.031 334.156 341.031 335.494 341.326 336.503 341.847 337.511 342.38 338.917 342.728 340.454 342.728L340.454 340.338C338.917 340.338 337.511 339.973 336.503 339.436 335.494 338.918 334.156 338.63 332.644 338.63 331.178 338.63 329.847 338.928 328.85 339.419 327.842 339.954 326.458 340.317 324.921 340.317 323.402 340.317 322.007 339.984 320.999 339.458 319.994 338.94 318.599 338.63 317.091 338.63 315.592 338.63 314.231 338.94 313.225 339.454 312.212 339.991 310.845 340.317 309.304 340.317L309.319 342.728z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M333.657 320.783C333.605 320.986 333.534 321.185 333.534 321.401 333.534 322.864 334.796 324.028 336.338 324.028L313.405 324.028C314.946 324.028 316.207 322.864 316.207 321.401 316.207 321.188 316.166 320.986 316.12 320.783 316.244 320.83 316.402 320.837 316.555 320.837L333.245 320.837C333.379 320.837 333.537 320.822 333.653 320.783' fill='%23c8b100'/%3E %3Cpath d='M333.657 320.783C333.605 320.986 333.534 321.185 333.534 321.401 333.534 322.864 334.796 324.028 336.338 324.028L313.405 324.028C314.946 324.028 316.207 322.864 316.207 321.401 316.207 321.188 316.166 320.986 316.12 320.783 316.244 320.83 316.402 320.837 316.555 320.837L333.245 320.837C333.379 320.837 333.537 320.822 333.653 320.783L333.657 320.783z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M316.559 319.267L333.249 319.267C333.81 319.267 334.269 319.622 334.269 320.052 334.269 320.485 333.81 320.837 333.249 320.837L316.559 320.837C315.993 320.837 315.535 320.485 315.535 320.052 315.535 319.622 315.993 319.267 316.559 319.267' fill='%23c8b100'/%3E %3Cpath d='M316.559 319.267L333.249 319.267C333.81 319.267 334.269 319.622 334.269 320.052 334.269 320.485 333.81 320.837 333.249 320.837L316.559 320.837C315.993 320.837 315.535 320.485 315.535 320.052 315.535 319.622 315.993 319.267 316.559 319.267z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M313.432 329.863L336.309 329.863 336.309 324.028 313.432 324.028 313.432 329.863z' fill='%23c8b100'/%3E %3Cpath d='M313.432 329.863L336.309 329.863 336.309 324.028 313.432 324.028 313.432 329.863z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M338.096 298.618C340.361 299.925 341.899 301.263 341.651 301.931 341.526 302.545 340.807 303.003 339.78 303.685 338.164 304.811 337.177 306.821 337.947 307.748 336.612 306.669 335.768 305.056 335.768 303.263 335.768 301.388 336.657 299.698 338.096 298.618' fill='%23ad1519'/%3E %3Cpath d='M338.096 298.618C340.361 299.925 341.899 301.263 341.651 301.931 341.526 302.545 340.807 303.003 339.78 303.685 338.164 304.811 337.177 306.821 337.947 307.748 336.612 306.669 335.768 305.056 335.768 303.263 335.768 301.388 336.657 299.698 338.096 298.618z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.777 318.322L333.031 318.322 333.031 238.686 316.777 238.686 316.777 318.322z' fill='%23cccccc'/%3E %3Cpath d='M328.568 238.657L328.568 318.123M330.395 238.657L330.395 318.123' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.777 318.322L333.031 318.322 333.031 238.686 316.777 238.686 316.777 318.322z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M300.174 268.474C303.723 267.008 309.754 265.921 316.672 265.694 319.055 265.712 321.714 265.936 324.459 266.394 334.178 268.016 341.584 271.897 340.995 275.058 340.983 275.125 340.965 275.263 340.946 275.324 340.946 275.324 344.593 267.111 344.647 266.798 345.299 263.29 337.087 258.979 326.297 257.179 322.911 256.614 319.604 256.394 316.739 256.422 309.833 256.422 303.833 257.306 300.219 258.649L300.174 268.474' fill='%23ad1519'/%3E %3Cpath d='M300.174 268.474C303.723 267.008 309.754 265.921 316.672 265.694 319.055 265.712 321.714 265.936 324.459 266.394 334.178 268.016 341.584 271.897 340.995 275.058 340.983 275.125 340.965 275.263 340.946 275.324 340.946 275.324 344.593 267.111 344.647 266.798 345.299 263.29 337.087 258.979 326.297 257.179 322.911 256.614 319.604 256.394 316.739 256.422 309.833 256.422 303.833 257.306 300.219 258.649L300.174 268.474' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M333.06 278.47C337.568 278.147 340.646 276.943 340.995 275.058 341.277 273.556 339.75 271.894 337.031 270.385 335.813 270.516 334.444 270.683 333.031 270.683L333.06 278.47' fill='%23ad1519'/%3E %3Cpath d='M333.06 278.47C337.568 278.147 340.646 276.943 340.995 275.058 341.277 273.556 339.75 271.894 337.031 270.385 335.813 270.516 334.444 270.683 333.031 270.683L333.06 278.47' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M316.751 272.384C313.931 272.81 311.819 273.509 310.762 274.369L310.669 274.542C310.162 275.573 312.64 277.764 316.773 280.21L316.751 272.384' fill='%23ad1519'/%3E %3Cpath d='M316.751 272.384C313.931 272.81 311.819 273.509 310.762 274.369L310.669 274.542C310.162 275.573 312.64 277.764 316.773 280.21L316.751 272.384' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M343.154 293.832C343.581 292.546 339.186 289.972 332.975 287.693 330.136 286.677 327.792 285.618 324.887 284.337 316.259 280.522 309.885 276.144 310.672 274.547L310.756 274.383C310.301 274.756 309.59 282.621 309.59 282.621 308.802 284.084 314.636 288.398 322.572 292.205 325.116 293.42 330.488 295.404 333.023 296.292 337.556 297.865 342.06 300.831 341.651 301.931L343.154 293.836' fill='%23ad1519'/%3E %3Cpath d='M343.154 293.832C343.581 292.546 339.186 289.972 332.975 287.693 330.136 286.677 327.792 285.618 324.887 284.337 316.259 280.522 309.885 276.144 310.672 274.547L310.756 274.383C310.301 274.756 309.59 282.621 309.59 282.621 308.802 284.084 314.636 288.398 322.572 292.205 325.116 293.42 330.488 295.404 333.023 296.292 337.556 297.865 342.06 300.831 341.651 301.931L343.154 293.836 343.154 293.832z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M310.304 264.984C310.92 262.651 311.714 260.396 312.494 258.113 312.322 258.159 312.135 258.195 311.962 258.223 311.787 258.248 311.598 258.265 311.419 258.272 311.048 259.913 310.545 261.561 310.005 263.208 309.045 261.767 307.999 260.367 307.167 258.911 306.834 258.979 306.487 259.06 306.147 259.111 305.813 259.16 305.456 259.185 305.112 259.218 306.563 261.163 307.965 263.109 309.312 265.129 309.473 265.087 309.629 265.033 309.807 265.008 309.968 264.987 310.136 264.991 310.304 264.984' fill='%23c8b100'/%3E %3Cpath d='M316.485 258.159C316.188 258.173 315.892 258.195 315.595 258.19 315.3 258.187 315.004 258.152 314.711 258.13L314.591 264.543 319.075 264.619C319.052 264.487 319.019 264.345 319.023 264.21 319.023 264.078 319.064 263.94 319.086 263.808 318.283 263.861 317.407 263.912 316.379 263.894L316.485 258.159' fill='%23c8b100'/%3E %3Cpath d='M323.525 259.214C324.242 259.274 324.932 259.398 325.622 259.523 325.609 259.388 325.588 259.253 325.599 259.114 325.609 258.983 325.66 258.851 325.697 258.723L319.626 258.22C319.641 258.355 319.664 258.486 319.649 258.617 319.637 258.759 319.589 258.887 319.554 259.018 320.173 259.004 320.92 258.997 321.756 259.068L321.227 264.838C321.523 264.845 321.819 264.842 322.112 264.866 322.407 264.888 322.701 264.941 322.993 264.984L323.522 259.214' fill='%23c8b100'/%3E %3Cpath d='M326.008 265.534C326.301 265.58 326.596 265.615 326.886 265.68 327.174 265.74 327.456 265.833 327.737 265.914L328.457 262.967 328.535 262.984C328.703 263.389 328.922 263.882 329.034 264.167L329.934 266.394C330.286 266.45 330.638 266.496 330.984 266.571 331.339 266.649 331.68 266.752 332.022 266.848L331.71 266.18C331.226 265.175 330.717 264.174 330.297 263.156 331.415 263.205 332.281 262.8 332.498 261.902 332.652 261.277 332.404 260.786 331.815 260.367 331.381 260.058 330.538 259.895 329.994 259.774L327.546 259.239 326.008 265.534M329.149 260.112C329.855 260.268 330.736 260.382 330.736 261.184 330.732 261.386 330.713 261.528 330.68 261.656 330.451 262.598 329.739 262.924 328.55 262.569L329.149 260.112' fill='%23c8b100'/%3E %3Cpath d='M337.57 267.455C337.516 268.151 337.392 268.826 337.257 269.557 337.564 269.703 337.868 269.834 338.164 269.997 338.46 270.161 338.733 270.342 339.019 270.52L339.619 263.29C339.476 263.233 339.348 263.173 339.214 263.102 339.078 263.028 338.963 262.953 338.838 262.864L332.464 266.912C332.632 266.994 332.807 267.068 332.971 267.157 333.136 267.25 333.275 267.348 333.44 267.441 333.975 266.99 334.538 266.624 335.183 266.145L337.568 267.452 337.57 267.455zM335.764 265.804L337.886 264.43 337.639 266.827 335.764 265.804' fill='%23c8b100'/%3E %3Cpath d='M225.199 200.449C225.199 199.312 226.17 198.393 227.366 198.393 228.558 198.393 229.533 199.312 229.533 200.449 229.533 201.582 228.562 202.501 227.366 202.501 226.17 202.501 225.199 201.582 225.199 200.449z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M249.649 182.723C256.294 182.723 262.206 183.706 266.057 185.233 268.261 186.228 271.221 186.963 274.46 187.396 276.927 187.726 279.271 187.793 281.31 187.637 284.037 187.584 287.981 188.382 291.926 190.119 295.191 191.568 297.917 193.329 299.727 195.034L298.16 196.43 297.707 200.392 293.409 205.313 291.261 207.136 286.173 211.209 283.574 211.421 282.784 213.67 249.866 209.813 216.848 213.67 216.057 211.421 213.454 211.209 208.367 207.136 206.219 205.313 201.922 200.392 201.475 196.43 199.9 195.034C201.719 193.329 204.445 191.568 207.703 190.119 211.648 188.382 215.593 187.584 218.317 187.637 220.356 187.793 222.701 187.726 225.168 187.396 228.409 186.963 231.371 186.228 233.571 185.233 237.426 183.706 243.009 182.723 249.649 182.723z' fill='%23ad1519' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M250.154 226.179C237.89 226.161 226.904 224.709 219.065 222.348 218.491 222.174 218.191 221.648 218.224 221.104 218.214 220.576 218.51 220.097 219.065 219.929 226.904 217.571 237.89 216.119 250.154 216.101 262.416 216.119 273.395 217.571 281.235 219.929 281.79 220.097 282.081 220.576 282.071 221.104 282.101 221.648 281.805 222.174 281.235 222.348 273.395 224.709 262.416 226.161 250.154 226.179' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.124 224.57C239.056 224.556 229.053 223.278 221.438 221.311 229.053 219.34 239.056 218.136 250.124 218.115 261.19 218.136 271.247 219.34 278.862 221.311 271.247 223.278 261.19 224.556 250.124 224.57' fill='%23ad1519'/%3E %3Cpath d='M250.946 224.637L250.946 218.07' fill='none' stroke='%23000' stroke-width='0.09'/%3E %3Cpath d='M249.162 224.637L249.162 218.07' fill='none' stroke='%23000' stroke-width='0.14'/%3E %3Cpath d='M247.478 224.637L247.478 218.07' fill='none' stroke='%23000' stroke-width='0.18'/%3E %3Cpath d='M245.809 224.637L245.809 218.07' fill='none' stroke='%23000' stroke-width='0.23'/%3E %3Cpath d='M244.321 224.637L244.321 218.07' fill='none' stroke='%23000' stroke-width='0.28'/%3E %3Cpath d='M241.484 224.283L241.445 218.306M242.829 224.362L242.829 218.109' fill='none' stroke='%23000' stroke-width='0.33'/%3E %3Cpath d='M238.865 224.014L238.865 218.507M240.192 224.172L240.153 218.311' fill='none' stroke='%23000' stroke-width='0.37'/%3E %3Cpath d='M235.352 223.7L235.352 218.861M236.504 223.778L236.504 218.704M237.692 223.936L237.692 218.664' fill='none' stroke='%23000' stroke-width='0.42'/%3E %3Cpath d='M234.12 223.66L234.12 218.979' fill='none' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M232.972 223.424L232.972 219.058' fill='none' stroke='%23000' stroke-width='0.51'/%3E %3Cpath d='M231.74 223.306L231.74 219.254' fill='none' stroke='%23000' stroke-width='0.56'/%3E %3Cpath d='M229.219 222.953L229.179 219.727M230.511 223.11L230.511 219.491' fill='none' stroke='%23000' stroke-width='0.6'/%3E %3Cpath d='M227.927 222.677L227.927 219.844' fill='none' stroke='%23000' stroke-width='0.63'/%3E %3Cpath d='M226.743 222.447L226.743 220.088' fill='none' stroke='%23000' stroke-width='0.68'/%3E %3Cpath d='M225.451 222.133L225.451 220.285' fill='none' stroke='%23000' stroke-width='0.73'/%3E %3Cpath d='M224.123 221.976L224.123 220.6' fill='none' stroke='%23000' stroke-width='0.77'/%3E %3Cpath d='M222.718 221.661L222.718 220.993' fill='none' stroke='%23000' stroke-width='0.91'/%3E %3Cpath d='M258.043 224.283L258.043 218.267M255.021 224.48L255.06 218.109M252.818 224.559L252.818 218.07' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M250.069 216.091C237.658 216.115 226.519 217.671 218.678 220.086 219.329 219.776 219.271 218.974 218.46 216.887 217.482 214.361 215.956 214.472 215.956 214.472 224.625 211.912 236.691 210.31 250.121 210.292 263.556 210.31 275.72 211.912 284.389 214.472 284.389 214.472 282.862 214.361 281.884 216.887 281.074 218.974 281.014 219.776 281.666 220.086 273.827 217.671 262.479 216.115 250.069 216.091' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.121 210.295C236.691 210.317 224.625 211.915 215.956 214.479 215.378 214.652 214.767 214.426 214.58 213.879 214.393 213.331 214.704 212.703 215.282 212.526 223.987 209.855 236.365 208.179 250.124 208.151 263.887 208.176 276.312 209.855 285.018 212.526 285.596 212.703 285.907 213.331 285.72 213.879 285.532 214.426 284.921 214.652 284.344 214.479 275.674 211.915 263.556 210.317 250.121 210.295' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.124 224.57C239.056 224.556 229.053 223.278 221.438 221.311 229.053 219.34 239.056 218.136 250.124 218.115 261.19 218.136 271.247 219.34 278.862 221.311 271.247 223.278 261.19 224.556 250.124 224.57z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.39'/%3E %3Cpath d='M240.542 213.346C240.542 212.774 241.032 212.309 241.636 212.309 242.244 212.309 242.736 212.774 242.736 213.346 242.736 213.917 242.244 214.386 241.636 214.386 241.032 214.386 240.542 213.917 240.542 213.346' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.148 214.163L246.862 214.163C246.256 214.163 245.753 213.701 245.753 213.126 245.753 212.554 246.245 212.086 246.849 212.086L253.491 212.086C254.095 212.086 254.588 212.554 254.588 213.126 254.588 213.701 254.085 214.163 253.476 214.163L250.148 214.163' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M233.639 215.068L231.275 215.342C230.672 215.413 230.113 215.008 230.038 214.443 229.964 213.872 230.392 213.353 230.995 213.286L233.373 213.009 235.791 212.731C236.39 212.661 236.938 213.058 237.013 213.63 237.084 214.198 236.646 214.72 236.046 214.787L233.639 215.068' fill='%23058e6e' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M224.033 215.275C224.033 214.703 224.524 214.237 225.127 214.237 225.735 214.237 226.226 214.703 226.226 215.275 226.226 215.85 225.735 216.315 225.127 216.315 224.524 216.315 224.033 215.85 224.033 215.275' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M216.725 217.164L217.944 215.569 221.311 215.995 218.618 217.959 216.725 217.164' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M266.661 215.068L269.023 215.342C269.622 215.413 270.186 215.008 270.26 214.443 270.328 213.872 269.904 213.353 269.304 213.286L266.927 213.009 264.509 212.731C263.905 212.661 263.358 213.058 263.286 213.63 263.211 214.198 263.654 214.72 264.253 214.787L266.661 215.068' fill='%23058e6e' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M257.564 213.346C257.564 212.774 258.056 212.309 258.66 212.309 259.267 212.309 259.758 212.774 259.758 213.346 259.758 213.917 259.267 214.386 258.66 214.386 258.056 214.386 257.564 213.917 257.564 213.346' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.073 215.275C274.073 214.703 274.565 214.237 275.169 214.237 275.776 214.237 276.267 214.703 276.267 215.275 276.267 215.85 275.776 216.315 275.169 216.315 274.565 216.315 274.073 215.85 274.073 215.275' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M283.574 217.164L282.356 215.569 278.989 215.995 281.681 217.959 283.574 217.164' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M220.115 221.662C227.869 219.485 238.412 218.136 250.124 218.115 261.835 218.136 272.431 219.485 280.185 221.662' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.338 191.419L226.725 192.531 228.805 189.133C226.548 187.751 225 185.351 225 182.616 225 182.307 225.018 182.006 225.057 181.707 225.274 177.371 230.556 173.788 237.264 173.788 240.744 173.788 243.887 174.74 246.099 176.267 246.158 175.596 246.219 175.021 246.312 174.41 243.875 172.989 240.714 172.134 237.264 172.134 229.552 172.134 223.519 176.515 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.338 191.419' fill='%23c8b100'/%3E %3Cpath d='M225.338 191.419L226.725 192.531 228.805 189.133C226.548 187.751 225 185.351 225 182.616 225 182.307 225.018 182.006 225.057 181.707 225.274 177.371 230.556 173.788 237.264 173.788 240.744 173.788 243.887 174.74 246.099 176.267 246.158 175.596 246.219 175.021 246.312 174.41 243.875 172.989 240.714 172.134 237.264 172.134 229.552 172.134 223.519 176.515 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.338 191.419' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.427 191.457C222.795 189.494 221.161 186.824 221.161 183.884 221.161 180.496 223.376 177.475 226.743 175.472 224.666 177.14 223.406 179.296 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.427 191.457' fill='%23c8b100'/%3E %3Cpath d='M225.427 191.457C222.795 189.494 221.161 186.824 221.161 183.884 221.161 180.496 223.376 177.475 226.743 175.472 224.666 177.14 223.406 179.296 223.226 181.704 223.196 182.006 223.181 182.311 223.181 182.616 223.181 185.383 224.445 187.875 226.443 189.608L225.427 191.457' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M202.207 194.888C200.733 193.237 199.83 191.103 199.83 188.77 199.83 187.363 200.155 186.018 200.744 184.818 202.874 180.436 209.555 177.247 217.497 177.247 219.661 177.247 221.731 177.482 223.643 177.918 223.219 178.38 222.886 178.887 222.561 179.399 220.973 179.09 219.271 178.923 217.497 178.923 210.227 178.923 204.145 181.75 202.383 185.57 201.914 186.544 201.651 187.63 201.651 188.77 201.651 191.092 202.739 193.173 204.441 194.594L201.809 198.893 200.4 197.772 202.207 194.892' fill='%23c8b100'/%3E %3Cpath d='M202.207 194.888C200.733 193.237 199.83 191.103 199.83 188.77 199.83 187.363 200.155 186.018 200.744 184.818 202.874 180.436 209.555 177.247 217.497 177.247 219.661 177.247 221.731 177.482 223.643 177.918 223.219 178.38 222.886 178.887 222.561 179.399 220.973 179.09 219.271 178.923 217.497 178.923 210.227 178.923 204.145 181.75 202.383 185.57 201.914 186.544 201.651 187.63 201.651 188.77 201.651 191.092 202.739 193.173 204.441 194.594L201.809 198.893 200.4 197.772 202.207 194.892 202.207 194.888z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M204.903 180.482C202.99 181.686 201.543 183.167 200.744 184.818 200.155 186.018 199.83 187.363 199.83 188.77 199.83 191.103 200.733 193.237 202.207 194.888L200.609 197.481C199.08 195.516 198.191 193.223 198.191 190.783 198.191 186.582 200.864 182.911 204.903 180.482' fill='%23c8b100'/%3E %3Cpath d='M204.903 180.482C202.99 181.686 201.543 183.167 200.744 184.818 200.155 186.018 199.83 187.363 199.83 188.77 199.83 191.103 200.733 193.237 202.207 194.888L200.609 197.481C199.08 195.516 198.191 193.223 198.191 190.783 198.191 186.582 200.864 182.911 204.903 180.482z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.039 171.267C251.801 171.267 253.316 172.432 253.677 173.995 253.912 175.376 254.059 176.949 254.092 178.625 254.095 178.799 254.08 178.969 254.08 179.14 254.085 179.338 254.123 179.552 254.126 179.754 254.186 183.269 254.689 186.373 255.404 188.273L250.036 193.408 244.609 188.273C245.329 186.373 245.828 183.269 245.895 179.754 245.899 179.552 245.938 179.338 245.938 179.14 245.938 178.969 245.926 178.799 245.93 178.625 245.956 176.949 246.106 175.376 246.342 173.995 246.699 172.432 248.277 171.267 250.036 171.267' fill='%23c8b100'/%3E %3Cpath d='M250.039 171.267C251.801 171.267 253.316 172.432 253.677 173.995 253.912 175.376 254.059 176.949 254.092 178.625 254.095 178.799 254.08 178.969 254.08 179.14 254.085 179.338 254.123 179.552 254.126 179.754 254.186 183.269 254.689 186.373 255.404 188.273L250.036 193.408 244.609 188.273C245.329 186.373 245.828 183.269 245.895 179.754 245.899 179.552 245.938 179.338 245.938 179.14 245.938 178.969 245.926 178.799 245.93 178.625 245.956 176.949 246.106 175.376 246.342 173.995 246.699 172.432 248.277 171.267 250.036 171.267L250.039 171.267z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.039 172.94C250.954 172.94 251.725 173.523 251.914 174.331 252.135 175.638 252.277 177.13 252.307 178.706 252.307 178.87 252.299 179.033 252.299 179.192 252.299 179.388 252.333 179.583 252.337 179.782 252.394 183.102 252.87 186.028 253.552 187.829L250.012 191.181 246.469 187.829C247.145 186.032 247.621 183.102 247.681 179.782 247.685 179.583 247.719 179.388 247.722 179.192 247.722 179.033 247.711 178.87 247.711 178.706 247.741 177.13 247.883 175.638 248.107 174.331 248.292 173.523 249.127 172.94 250.039 172.94' fill='%23c8b100'/%3E %3Cpath d='M250.039 172.94C250.954 172.94 251.725 173.523 251.914 174.331 252.135 175.638 252.277 177.13 252.307 178.706 252.307 178.87 252.299 179.033 252.299 179.192 252.299 179.388 252.333 179.583 252.337 179.782 252.394 183.102 252.87 186.028 253.552 187.829L250.012 191.181 246.469 187.829C247.145 186.032 247.621 183.102 247.681 179.782 247.685 179.583 247.719 179.388 247.722 179.192 247.722 179.033 247.711 178.87 247.711 178.706 247.741 177.13 247.883 175.638 248.107 174.331 248.292 173.523 249.127 172.94 250.039 172.94z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.7 191.419L273.312 192.531 271.232 189.133C273.488 187.751 275.037 185.351 275.037 182.616 275.037 182.307 275.019 182.006 274.982 181.707 274.767 177.371 269.477 173.788 262.776 173.788 259.289 173.788 256.15 174.74 253.935 176.267 253.875 175.596 253.823 175.021 253.721 174.41 256.159 172.989 259.319 172.134 262.776 172.134 270.486 172.134 276.518 176.515 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.7 191.419' fill='%23c8b100'/%3E %3Cpath d='M274.7 191.419L273.312 192.531 271.232 189.133C273.488 187.751 275.037 185.351 275.037 182.616 275.037 182.307 275.019 182.006 274.982 181.707 274.767 177.371 269.477 173.788 262.776 173.788 259.289 173.788 256.15 174.74 253.935 176.267 253.875 175.596 253.823 175.021 253.721 174.41 256.159 172.989 259.319 172.134 262.776 172.134 270.486 172.134 276.518 176.515 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.7 191.419' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.61 191.457C277.242 189.494 278.877 186.824 278.877 183.884 278.877 180.496 276.66 177.475 273.298 175.472 275.371 177.14 276.63 179.296 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.61 191.457' fill='%23c8b100'/%3E %3Cpath d='M274.61 191.457C277.242 189.494 278.877 186.824 278.877 183.884 278.877 180.496 276.66 177.475 273.298 175.472 275.371 177.14 276.63 179.296 276.814 181.704 276.84 182.006 276.855 182.311 276.855 182.616 276.855 185.383 275.593 187.875 273.594 189.608L274.61 191.457' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M297.834 194.888C299.304 193.237 300.206 191.103 300.206 188.77 300.206 187.363 299.881 186.018 299.297 184.818 297.163 180.436 290.482 177.247 282.539 177.247 280.375 177.247 278.306 177.482 276.394 177.918 276.822 178.38 277.152 178.887 277.479 179.399 279.06 179.09 280.77 178.923 282.535 178.923 289.807 178.923 295.892 181.75 297.65 185.57 298.122 186.544 298.382 187.63 298.382 188.77 298.382 191.092 297.294 193.173 295.592 194.594L298.224 198.893 299.637 197.772 297.831 194.892' fill='%23c8b100'/%3E %3Cpath d='M297.834 194.888C299.304 193.237 300.206 191.103 300.206 188.77 300.206 187.363 299.881 186.018 299.297 184.818 297.163 180.436 290.482 177.247 282.539 177.247 280.375 177.247 278.306 177.482 276.394 177.918 276.822 178.38 277.152 178.887 277.479 179.399 279.06 179.09 280.77 178.923 282.535 178.923 289.807 178.923 295.892 181.75 297.65 185.57 298.122 186.544 298.382 187.63 298.382 188.77 298.382 191.092 297.294 193.173 295.592 194.594L298.224 198.893 299.637 197.772 297.831 194.892 297.834 194.888z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M295.135 180.482C297.047 181.686 298.495 183.167 299.297 184.818 299.878 186.018 300.206 187.363 300.206 188.77 300.206 191.103 299.304 193.237 297.834 194.888L299.428 197.481C300.957 195.516 301.842 193.223 301.842 190.783 301.842 186.582 299.173 182.911 295.135 180.482' fill='%23c8b100'/%3E %3Cpath d='M295.135 180.482C297.047 181.686 298.495 183.167 299.297 184.818 299.878 186.018 300.206 187.363 300.206 188.77 300.206 191.103 299.304 193.237 297.834 194.888L299.428 197.481C300.957 195.516 301.842 193.223 301.842 190.783 301.842 186.582 299.173 182.911 295.135 180.482z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.131 188.933C248.131 187.939 248.985 187.137 250.036 187.137 251.086 187.137 251.941 187.939 251.941 188.933 251.941 189.931 251.086 190.738 250.036 190.738 248.985 190.738 248.131 189.931 248.131 188.933' fill='%23fff'/%3E %3Cpath d='M248.131 188.933C248.131 187.939 248.985 187.137 250.036 187.137 251.086 187.137 251.941 187.939 251.941 188.933 251.941 189.931 251.086 190.738 250.036 190.738 248.985 190.738 248.131 189.931 248.131 188.933z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.131 185.4C248.131 184.406 248.985 183.596 250.036 183.596 251.086 183.596 251.941 184.406 251.941 185.4 251.941 186.395 251.086 187.2 250.036 187.2 248.985 187.2 248.131 186.395 248.131 185.4' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.513 181.6C248.513 180.804 249.196 180.162 250.036 180.162 250.871 180.162 251.554 180.804 251.554 181.6 251.554 182.395 250.871 183.039 250.036 183.039 249.196 183.039 248.513 182.395 248.513 181.6' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.94 178.173C248.94 177.603 249.432 177.137 250.036 177.137 250.643 177.137 251.13 177.603 251.13 178.173 251.13 178.749 250.643 179.215 250.036 179.215 249.432 179.215 248.94 178.749 248.94 178.173' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M249.158 175.177C249.158 174.715 249.55 174.346 250.036 174.346 250.519 174.346 250.913 174.715 250.913 175.177 250.913 175.635 250.519 176.008 250.036 176.008 249.55 176.008 249.158 175.635 249.158 175.177' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.197 199.777L251.434 200.005C251.235 200.505 251.194 201.052 251.194 201.628 251.194 204.195 253.399 206.283 256.113 206.283 258.292 206.283 260.148 204.934 260.785 203.07 260.857 203.119 261.254 201.386 261.46 201.408 261.632 201.426 261.614 203.208 261.677 203.176 261.993 205.523 264.137 207.111 266.552 207.111 269.262 207.111 271.46 205.033 271.46 202.462 271.46 202.271 271.449 202.079 271.423 201.894L272.964 200.367 273.791 202.313C273.462 202.924 273.331 203.61 273.331 204.345 273.331 206.799 275.431 208.783 278.022 208.783 279.652 208.783 281.084 207.999 281.925 206.809L282.911 205.555 282.904 207.093C282.904 208.637 283.556 210.023 285.064 210.267 285.064 210.267 286.794 210.374 289.087 208.574 291.382 206.773 292.645 205.282 292.645 205.282L292.843 207.085C292.843 207.085 290.939 210.03 288.866 211.23 287.733 211.89 286.012 212.582 284.644 212.359 283.196 212.124 282.165 210.963 281.633 209.625 280.601 210.232 279.383 210.586 278.078 210.586 275.274 210.586 272.753 209.049 271.756 206.734 270.467 208.126 268.67 208.981 266.564 208.981 264.325 208.981 262.273 207.974 260.988 206.425 259.724 207.576 258.006 208.286 256.113 208.286 253.634 208.286 251.423 207.071 250.17 205.239 248.918 207.071 246.709 208.286 244.234 208.286 242.342 208.286 240.62 207.576 239.356 206.425 238.075 207.974 236.02 208.981 233.781 208.981 231.674 208.981 229.878 208.126 228.587 206.734 227.591 209.049 225.072 210.586 222.266 210.586 220.961 210.586 219.747 210.232 218.716 209.625 218.179 210.963 217.148 212.124 215.705 212.359 214.336 212.582 212.615 211.89 211.48 211.23 209.405 210.03 207.503 207.085 207.503 207.085L207.703 205.282C207.703 205.282 208.967 206.773 211.258 208.574 213.553 210.377 215.282 210.267 215.282 210.267 216.789 210.023 217.44 208.637 217.44 207.093L217.433 205.555 218.419 206.809C219.259 207.999 220.696 208.783 222.323 208.783 224.914 208.783 227.013 206.799 227.013 204.345 227.013 203.61 226.881 202.924 226.552 202.313L227.379 200.367 228.922 201.894C228.899 202.079 228.885 202.271 228.885 202.462 228.885 205.033 231.08 207.111 233.792 207.111 236.211 207.111 238.352 205.523 238.667 203.176 238.734 203.208 238.716 201.426 238.887 201.408 239.091 201.386 239.491 203.119 239.559 203.07 240.2 204.934 242.053 206.283 244.239 206.283 246.953 206.283 249.151 204.195 249.151 201.628 249.151 201.052 249.116 200.505 248.914 200.005L250.197 199.777' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M283.957 205.913C284.241 205.08 283.987 204.255 283.387 204.075 282.788 203.887 282.067 204.412 281.783 205.243 281.497 206.074 281.753 206.894 282.353 207.082 282.952 207.263 283.672 206.741 283.957 205.913' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M262.582 201.773C262.693 200.903 262.277 200.144 261.651 200.072 261.025 199.998 260.425 200.64 260.313 201.507 260.2 202.373 260.616 203.137 261.242 203.212 261.869 203.282 262.469 202.64 262.582 201.773' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M237.763 201.773C237.651 200.903 238.071 200.144 238.693 200.072 239.319 199.998 239.919 200.64 240.032 201.507 240.14 202.373 239.728 203.137 239.102 203.212 238.475 203.282 237.875 202.64 237.763 201.773' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M216.391 205.913C216.106 205.08 216.361 204.255 216.961 204.075 217.561 203.887 218.277 204.412 218.562 205.243 218.843 206.074 218.588 206.894 217.992 207.082 217.392 207.263 216.676 206.741 216.391 205.913' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.675 191.65C226.736 192.32 227.662 193.436 227.984 194.683 227.984 194.683 228.108 194.427 228.692 194.089 229.282 193.759 229.78 193.769 229.78 193.769 229.78 193.769 229.612 194.739 229.529 195.087 229.444 195.428 229.436 196.469 229.211 197.406 228.985 198.344 228.577 199.093 228.577 199.093 228.161 198.751 227.591 198.581 227.002 198.677 226.417 198.777 225.945 199.121 225.675 199.575 225.675 199.575 225.018 199.004 224.471 198.198 223.92 197.391 223.545 196.418 223.335 196.123 223.128 195.825 222.622 194.966 222.622 194.966 222.622 194.966 223.088 194.792 223.759 194.916 224.429 195.041 224.64 195.243 224.64 195.243 224.498 193.962 224.922 192.622 225.675 191.65' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M226.125 201.859C225.788 201.592 225.533 201.219 225.45 200.779 225.367 200.342 225.461 199.909 225.683 199.554 225.683 199.554 224.797 199.107 223.848 198.858 223.128 198.67 221.862 198.663 221.479 198.656 221.096 198.645 220.332 198.628 220.332 198.628 220.332 198.628 220.396 198.802 220.613 199.181 220.875 199.639 221.108 199.926 221.108 199.926 219.84 200.218 218.76 201.052 218.078 202.019 219.069 202.703 220.385 203.119 221.677 202.987 221.677 202.987 221.565 203.333 221.483 203.854 221.416 204.284 221.42 204.462 221.42 204.462 221.42 204.462 222.132 204.199 222.488 204.068 222.844 203.936 224.033 203.524 224.644 203.112 225.442 202.566 226.125 201.862 226.125 201.862' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M228.967 201.382C229.188 201.028 229.294 200.594 229.211 200.154 229.128 199.714 228.888 199.341 228.551 199.075 228.551 199.075 229.218 198.368 230.017 197.825 230.625 197.413 231.816 196.997 232.172 196.87 232.529 196.739 233.242 196.472 233.242 196.472 233.242 196.472 233.245 196.653 233.177 197.083 233.096 197.602 232.982 197.946 232.982 197.946 234.277 197.811 235.595 198.244 236.586 198.933 235.904 199.895 234.816 200.715 233.553 201.007 233.553 201.007 233.781 201.294 234.047 201.752 234.265 202.136 234.329 202.306 234.329 202.306 234.329 202.306 233.564 202.289 233.181 202.282 232.799 202.275 231.532 202.271 230.812 202.079 229.864 201.826 228.967 201.386 228.967 201.386' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.199 200.449C225.199 199.312 226.17 198.393 227.366 198.393 228.558 198.393 229.533 199.312 229.533 200.449 229.533 201.582 228.562 202.501 227.366 202.501 226.17 202.501 225.199 201.582 225.199 200.449' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M250.114 188.365C251.156 189.31 251.959 190.722 252.061 192.175 252.061 192.175 252.248 191.913 252.972 191.65 253.695 191.387 254.25 191.49 254.25 191.49 254.25 191.49 253.864 192.545 253.695 192.913 253.527 193.283 253.309 194.441 252.858 195.439 252.42 196.444 251.809 197.2 251.809 197.2 251.411 196.746 250.812 196.451 250.136 196.451 249.465 196.451 248.866 196.746 248.468 197.2 248.468 197.2 247.857 196.444 247.415 195.439 246.968 194.441 246.747 193.283 246.582 192.913 246.414 192.545 246.023 191.49 246.023 191.49 246.023 191.49 246.582 191.387 247.302 191.65 248.025 191.913 248.217 192.175 248.217 192.175 248.318 190.722 249.076 189.31 250.114 188.365' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M248.498 199.831C248.176 199.472 247.97 199.007 247.97 198.503 247.97 198.002 248.161 197.534 248.483 197.182 248.483 197.182 247.591 196.514 246.586 196.06 245.825 195.712 244.411 195.471 243.987 195.392 243.56 195.311 242.712 195.151 242.712 195.151 242.712 195.151 242.747 195.353 242.911 195.818 243.11 196.383 243.309 196.746 243.309 196.746 241.84 196.834 240.455 197.565 239.495 198.514 240.455 199.454 241.835 200.168 243.309 200.265 243.309 200.265 243.11 200.623 242.911 201.191 242.747 201.649 242.712 201.855 242.712 201.855 242.712 201.855 243.56 201.699 243.987 201.621 244.411 201.535 245.825 201.298 246.586 200.946 247.591 200.491 248.498 199.835 248.498 199.835' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M251.764 199.831C252.087 199.472 252.292 199.007 252.292 198.503 252.292 198.002 252.102 197.534 251.779 197.182 251.779 197.182 252.672 196.514 253.677 196.06 254.441 195.712 255.854 195.471 256.278 195.392 256.698 195.311 257.545 195.151 257.545 195.151 257.545 195.151 257.516 195.353 257.347 195.818 257.147 196.383 256.953 196.746 256.953 196.746 258.423 196.834 259.806 197.565 260.762 198.514 259.806 199.454 258.426 200.168 256.953 200.265 256.953 200.265 257.147 200.623 257.347 201.191 257.512 201.649 257.545 201.855 257.545 201.855 257.545 201.855 256.702 201.699 256.278 201.621 255.854 201.535 254.441 201.298 253.677 200.946 252.672 200.491 251.764 199.835 251.764 199.835' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.669 191.65C273.612 192.32 272.687 193.436 272.364 194.683 272.364 194.683 272.235 194.427 271.652 194.089 271.067 193.759 270.563 193.769 270.563 193.769 270.563 193.769 270.732 194.739 270.819 195.087 270.906 195.428 270.909 196.469 271.133 197.406 271.359 198.344 271.766 199.093 271.766 199.093 272.187 198.751 272.757 198.581 273.342 198.677 273.926 198.777 274.4 199.121 274.673 199.575 274.673 199.575 275.326 199.004 275.878 198.198 276.424 197.391 276.803 196.418 277.005 196.123 277.212 195.825 277.722 194.966 277.722 194.966 277.722 194.966 277.253 194.792 276.582 194.916 275.911 195.041 275.7 195.243 275.7 195.243 275.85 193.962 275.423 192.622 274.669 191.65' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.223 201.859C274.558 201.592 274.816 201.219 274.894 200.779 274.977 200.342 274.887 199.909 274.666 199.554 274.666 199.554 275.547 199.107 276.495 198.858 277.216 198.67 278.487 198.663 278.864 198.656 279.248 198.645 280.012 198.628 280.012 198.628 280.012 198.628 279.952 198.802 279.732 199.181 279.468 199.639 279.237 199.926 279.237 199.926 280.503 200.218 281.583 201.052 282.266 202.019 281.28 202.703 279.964 203.119 278.667 202.987 278.667 202.987 278.783 203.333 278.862 203.854 278.925 204.284 278.921 204.462 278.921 204.462 278.921 204.462 278.209 204.199 277.857 204.068 277.501 203.936 276.312 203.524 275.7 203.112 274.906 202.566 274.223 201.862 274.223 201.862' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M271.378 201.382C271.156 201.028 271.056 200.594 271.133 200.154 271.217 199.714 271.46 199.341 271.797 199.075 271.797 199.075 271.126 198.368 270.328 197.825 269.72 197.413 268.527 196.997 268.172 196.87 267.815 196.739 267.107 196.472 267.107 196.472 267.107 196.472 267.104 196.653 267.17 197.083 267.25 197.602 267.362 197.946 267.362 197.946 266.068 197.811 264.748 198.244 263.762 198.933 264.445 199.895 265.529 200.715 266.792 201.007 266.792 201.007 266.564 201.294 266.3 201.752 266.08 202.136 266.02 202.306 266.02 202.306 266.02 202.306 266.78 202.289 267.163 202.282 267.542 202.275 268.817 202.271 269.532 202.079 270.478 201.826 271.374 201.386 271.374 201.386' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M270.812 200.449C270.812 199.312 271.782 198.393 272.979 198.393 274.179 198.393 275.15 199.312 275.15 200.449 275.15 201.582 274.179 202.501 272.979 202.501 271.782 202.501 270.812 201.582 270.812 200.449' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M295.052 205.008C294.541 204.469 293.484 204.582 292.694 205.257 291.902 205.928 291.673 206.915 292.183 207.451 292.694 207.991 293.751 207.874 294.541 207.203 295.333 206.525 295.562 205.541 295.052 205.008' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M291.974 206.315C292.083 205.946 292.33 205.569 292.694 205.257 293.484 204.582 294.541 204.469 295.052 205.008 295.115 205.08 295.187 205.175 295.228 205.26 295.228 205.26 296.327 203.176 297.628 202.484 298.93 201.784 301.131 201.961 301.131 201.961 301.131 200.363 299.822 199.072 298.134 199.072 297.144 199.072 296.207 199.483 295.655 200.179L295.428 199.107C295.428 199.107 294.07 199.377 293.447 200.928 292.829 202.484 293.503 204.731 293.503 204.731 293.503 204.731 293.166 203.766 292.657 203.122 292.15 202.484 290.849 201.784 290.171 201.465 289.492 201.149 288.798 200.673 288.798 200.673 288.798 200.673 288.768 200.847 288.742 201.277 288.716 201.791 288.757 202.107 288.757 202.107 287.512 201.944 286.06 202.147 284.929 202.587 285.412 203.538 286.334 204.433 287.542 204.891 287.542 204.891 287.107 205.25 286.709 205.644 286.38 205.978 286.275 206.134 286.275 206.134 286.275 206.134 287.126 206.255 287.554 206.315 287.976 206.372 289.39 206.595 290.234 206.539 290.856 206.499 291.554 206.397 291.974 206.315' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M208.371 206.315C208.263 205.946 208.017 205.569 207.651 205.257 206.86 204.582 205.806 204.469 205.292 205.008 205.225 205.08 205.157 205.175 205.116 205.26 205.116 205.26 204.013 203.176 202.713 202.484 201.416 201.784 199.215 201.961 199.215 201.961 199.215 200.363 200.524 199.072 202.21 199.072 203.204 199.072 204.134 199.483 204.692 200.179L204.918 199.107C204.918 199.107 206.275 199.377 206.897 200.928 207.518 202.484 206.841 204.731 206.841 204.731 206.841 204.731 207.178 203.766 207.689 203.122 208.198 202.484 209.499 201.784 210.177 201.465 210.853 201.149 211.55 200.673 211.55 200.673 211.55 200.673 211.576 200.847 211.603 201.277 211.63 201.791 211.588 202.107 211.588 202.107 212.829 201.944 214.284 202.147 215.417 202.587 214.932 203.538 214.013 204.433 212.803 204.891 212.803 204.891 213.238 205.25 213.634 205.644 213.966 205.978 214.073 206.134 214.073 206.134 214.073 206.134 213.218 206.255 212.796 206.315 212.367 206.372 210.958 206.595 210.114 206.539 209.492 206.499 208.794 206.397 208.371 206.315' fill='%23c8b100' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M205.292 205.008C205.806 204.469 206.86 204.582 207.651 205.257 208.446 205.928 208.67 206.915 208.161 207.451 207.651 207.991 206.593 207.874 205.803 207.203 205.011 206.525 204.783 205.541 205.292 205.008' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M247.97 198.503C247.97 197.367 248.94 196.451 250.136 196.451 251.333 196.451 252.307 197.367 252.307 198.503 252.307 199.639 251.337 200.559 250.136 200.559 248.94 200.559 247.97 199.639 247.97 198.503' fill='%23ad1519' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M245.625 167.301C245.625 164.978 247.61 163.103 250.054 163.103 252.499 163.103 254.482 164.978 254.482 167.301 254.482 169.616 252.499 171.491 250.054 171.491 247.61 171.491 245.625 169.616 245.625 167.301' fill='%23005bbf' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M248.894 155.537L248.894 157.802 246.471 157.802 246.471 160.099 248.894 160.099 248.894 163.246 248.894 166.707 245.842 166.707C245.806 166.923 245.622 167.08 245.622 167.305 245.622 167.884 245.743 168.44 245.968 168.941 245.974 168.955 245.993 168.959 245.999 168.973L254.117 168.973C254.123 168.959 254.143 168.955 254.149 168.941 254.373 168.44 254.495 167.884 254.495 167.305 254.495 167.081 254.31 166.922 254.275 166.707L251.317 166.707 251.317 163.277 251.317 160.099 253.74 160.099 253.74 157.802 251.317 157.802 251.317 155.537 248.894 155.537z' fill='%23c8b100' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M250.493 344.333C237.411 344.333 224.445 341.127 213.545 335.793 205.51 331.813 200.182 323.788 200.182 314.605L200.182 281.304 300.605 281.304 300.605 314.605C300.605 323.788 295.278 331.813 287.241 335.793 276.342 341.127 263.578 344.333 250.493 344.333' fill='%23cccccc'/%3E %3Cpath d='M250.493 344.333C237.411 344.333 224.445 341.127 213.545 335.793 205.51 331.813 200.182 323.788 200.182 314.605L200.182 281.304 300.605 281.304 300.605 314.605C300.605 323.788 295.278 331.813 287.241 335.793 276.342 341.127 263.578 344.333 250.493 344.333z' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.279 281.247L300.601 281.247 300.601 225.533 250.279 225.533 250.279 281.247z' fill='%23cccccc'/%3E %3Cpath d='M250.279 281.247L300.601 281.247 300.601 225.533 250.279 225.533 250.279 281.247z' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.317 314.566C250.317 327.726 239.165 338.393 225.274 338.393 211.378 338.393 200.115 327.726 200.115 314.566L200.115 281.215 250.317 281.215 250.317 314.566' fill='%23ad1519'/%3E %3Cpath d='M211.082 334.229C212.651 335.062 214.805 336.448 217.107 337.003L216.961 280.04 211.082 280.04 211.082 334.229z' fill='%23c8b100' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M200.032 314.117C200.185 321.145 202.975 326.369 205.765 329.791L205.765 280.317 200.103 280.317 200.032 314.117z' fill='%23c8b100' stroke='%23000' stroke-linejoin='round' stroke-width='0.5'/%3E %3Cpath d='M222.275 338.252C224.575 338.483 226.291 338.437 228.154 338.252L228.154 280.04 222.275 280.04 222.275 338.252z' fill='%23c7b500' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M233.323 337.003C235.625 336.541 238.22 335.108 239.349 334.368L239.349 280.04 233.47 280.04 233.323 337.003z' fill='%23c8b100' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M200.118 281.247L250.297 281.247 250.297 225.533 200.118 225.533 200.118 281.247z' fill='%23ad1519'/%3E %3Cpath d='M200.118 281.247L250.297 281.247 250.297 225.533 200.118 225.533 200.118 281.247z' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M244.813 329.236C247.261 327.063 249.562 322.115 250.399 316.475L250.545 280.04 244.666 280.04 244.813 329.236z' fill='%23c8b100' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.317 314.566C250.317 327.726 239.165 338.393 225.274 338.393 211.378 338.393 200.115 327.726 200.115 314.566L200.115 281.215 250.317 281.215 250.317 314.566' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M300.65 281.215L300.65 314.566C300.65 327.726 289.372 338.393 275.476 338.393 261.584 338.393 250.317 327.726 250.317 314.566L250.317 281.215 300.65 281.215' fill='%23ad1519'/%3E %3Cpath d='M300.65 281.215L300.65 314.566C300.65 327.726 289.372 338.393 275.476 338.393 261.584 338.393 250.317 327.726 250.317 314.566L250.317 281.215 300.65 281.215' fill='none' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M259.472 306.388C259.552 306.558 259.597 306.729 259.597 306.91 259.597 307.524 259.076 308.014 258.426 308.014 257.781 308.014 257.257 307.524 257.257 306.91 257.257 306.729 257.302 306.558 257.384 306.409L255.75 306.388C255.716 306.555 255.696 306.729 255.696 306.91 255.696 308.067 256.496 309.048 257.6 309.378L257.598 313.391 259.312 313.401 259.315 309.36C260.111 309.101 260.737 308.504 261.011 307.744L265.614 307.744 265.614 306.388 259.472 306.388M282.052 306.388L282.052 307.744 277.913 307.755C277.849 307.936 277.746 308.103 277.647 308.262L282.454 313.724 281.164 314.768 276.38 309.3C276.292 309.328 276.248 309.363 276.155 309.388L276.143 318.425 274.449 318.425 274.445 309.349C274.373 309.332 274.313 309.296 274.246 309.264L269.266 314.768 267.976 313.724 272.953 308.199C272.866 308.06 272.803 307.908 272.746 307.744L268.468 307.744 268.468 306.388 282.056 306.388 282.052 306.388zM284.809 306.388L284.809 307.744 289.416 307.744C289.69 308.504 290.309 309.101 291.111 309.36L291.114 313.401 292.825 313.391 292.821 309.378C293.927 309.048 294.73 308.067 294.73 306.91 294.73 306.729 294.711 306.555 294.669 306.388L293.042 306.388C293.121 306.558 293.162 306.729 293.162 306.91 293.162 307.524 292.645 308.014 291.996 308.014 291.352 308.014 290.826 307.524 290.826 306.91 290.826 306.729 290.871 306.558 290.954 306.409L284.809 306.388M277.852 329.429C279.195 329.217 280.433 328.847 281.655 328.333L282.495 329.764C281.089 330.367 279.574 330.801 277.995 331.038 277.732 332.206 276.642 333.083 275.33 333.083 274.021 333.083 272.929 332.217 272.659 331.057 270.991 330.829 269.409 330.399 267.928 329.764L268.772 328.333C270.058 328.876 271.43 329.238 272.854 329.436 273.155 328.784 273.706 328.28 274.43 328.045L274.445 321.039 276.135 321.039 276.151 328.02C276.901 328.244 277.534 328.755 277.849 329.429L277.852 329.429zM266.359 327.079L265.525 328.517C264.095 327.629 262.821 326.533 261.727 325.303 260.857 325.559 259.874 325.407 259.132 324.803 257.984 323.872 257.845 322.239 258.828 321.156L258.971 321.004C258.279 319.441 257.811 317.761 257.651 316L259.361 316.007C259.495 317.51 259.87 318.941 260.454 320.283 260.935 320.215 261.449 320.272 261.91 320.443L266.188 315.709 267.477 316.75 263.226 321.476C263.8 322.349 263.777 323.475 263.121 324.334 264.065 325.379 265.149 326.309 266.359 327.079zM260.016 322.115C260.437 321.646 261.175 321.593 261.666 321.99 262.158 322.388 262.218 323.091 261.798 323.553 261.376 324.018 260.639 324.075 260.148 323.677 259.657 323.276 259.597 322.58 260.016 322.115zM257.86 317.434L256.102 317.041 255.854 312.588 257.598 312.012 257.6 314.566C257.6 315.556 257.688 316.494 257.86 317.434zM259.319 311.913L261.07 312.325C261.07 312.325 261.16 315.187 261.123 314.544 261.077 313.795 261.314 316.782 261.314 316.782L259.548 317.364C259.372 316.455 259.312 315.524 259.312 314.566L259.315 311.913 259.319 311.913zM265.092 326.159C266.567 327.31 268.281 328.244 270.133 328.836L270.523 327.143C269.001 326.663 267.59 325.961 266.349 325.048L265.092 326.159M264.245 327.622C265.741 328.748 267.452 329.65 269.285 330.275L267.976 331.5C266.506 330.957 265.124 330.24 263.856 329.387L264.245 327.622M266.53 317.808L268.202 318.518 271.261 315.123 270.256 313.678 266.53 317.808M265.233 316.76L264.23 315.308 267.291 311.913 268.958 312.626 265.233 316.76M284.066 327.079L284.902 328.517C286.33 327.629 287.606 326.533 288.7 325.303 289.566 325.559 290.553 325.407 291.294 324.803 292.442 323.872 292.574 322.239 291.597 321.156L291.452 321.004C292.146 319.441 292.615 317.761 292.768 316L291.067 316.007C290.932 317.51 290.553 318.941 289.971 320.283 289.488 320.215 288.978 320.272 288.513 320.443L284.239 315.709 282.949 316.75 287.197 321.476C286.627 322.349 286.649 323.475 287.302 324.334 286.36 325.379 285.277 326.309 284.066 327.079zM290.406 322.115C289.986 321.646 289.251 321.593 288.761 321.99 288.268 322.388 288.209 323.091 288.629 323.553 289.049 324.018 289.788 324.075 290.279 323.677 290.771 323.276 290.826 322.58 290.406 322.115zM292.563 317.434L294.321 317.041 294.569 312.588 292.829 312.012 292.825 314.566C292.825 315.556 292.738 316.494 292.563 317.434zM291.108 311.913L289.357 312.325C289.357 312.325 289.262 315.187 289.301 314.544 289.349 313.795 289.109 316.782 289.109 316.782L290.875 317.364C291.052 316.455 291.111 315.524 291.111 314.566L291.108 311.913M285.333 326.159C283.856 327.31 282.142 328.244 280.294 328.836L279.904 327.143C281.423 326.663 282.836 325.961 284.074 325.048L285.333 326.159M286.181 327.622C284.68 328.748 282.975 329.65 281.141 330.275L282.45 331.5C283.92 330.957 285.303 330.24 286.571 329.387L286.181 327.622M283.897 317.808L282.225 318.518 279.165 315.123 280.17 313.678 283.897 317.808M285.193 316.76L286.196 315.308 283.136 311.913 281.468 312.626 285.193 316.76M264.25 307.748L264.764 309.416 269.477 309.416 269.985 307.748 264.25 307.748M286.266 307.748L285.749 309.416 281.039 309.416 280.531 307.748 286.266 307.748M274.16 330.495C274.16 329.88 274.684 329.384 275.33 329.384 275.974 329.384 276.495 329.88 276.495 330.495 276.495 331.106 275.974 331.599 275.33 331.599 274.684 331.599 274.16 331.106 274.16 330.495zM276.143 322.42L277.902 321.927 277.902 317.47 276.143 316.987 276.143 322.42M274.438 322.42L272.683 321.927 272.683 317.47 274.438 316.987 274.438 322.42' fill='%23c8b100'/%3E %3Cpath d='M255.75 306.427C255.952 305.498 256.678 304.744 257.614 304.462L257.6 298.96 259.297 298.96 259.3 304.492C260.137 304.755 260.781 305.374 261.04 306.171L265.614 306.178 265.614 306.427 259.472 306.427C259.282 306.089 258.883 305.837 258.426 305.837 257.973 305.837 257.575 306.089 257.384 306.448L255.75 306.427M268.464 306.427L268.464 306.178 272.713 306.178C272.761 306.039 272.824 305.904 272.896 305.776L267.654 299.934 268.943 298.888 274.119 304.635C274.208 304.591 274.303 304.552 274.395 304.52L274.4 296.864 276.094 296.864 276.094 304.473C276.17 304.495 276.285 304.516 276.361 304.538L281.416 298.782 282.715 299.813 277.64 305.545C277.771 305.737 277.86 305.951 277.932 306.178L282.049 306.178 282.049 306.427 268.46 306.427 268.464 306.427zM290.954 306.427C291.144 306.089 291.539 305.837 291.996 305.837 292.454 305.837 292.848 306.089 293.042 306.448L294.669 306.427C294.466 305.498 293.747 304.744 292.81 304.462L292.821 298.963 291.129 298.963 291.122 304.495C290.29 304.758 289.645 305.374 289.386 306.171L284.809 306.178 284.809 306.427 290.954 306.427M259.571 290.887L265.876 297.956 267.167 296.91 260.827 289.869C260.953 289.68 261.043 289.475 261.119 289.253L265.731 289.253 265.731 287.645 261.116 287.645C260.762 286.603 259.728 285.856 258.51 285.856 257.002 285.856 255.776 287.016 255.776 288.447 255.776 289.581 256.543 290.549 257.616 290.898L257.606 296.352 259.3 296.352 259.3 290.934C259.372 290.913 259.502 290.913 259.571 290.887zM292.84 290.923L292.825 296.352 291.129 296.352 291.129 290.902C290.999 290.861 290.871 290.808 290.75 290.747L284.479 297.825 283.182 296.793 289.573 289.577C289.521 289.475 289.465 289.368 289.427 289.253L284.79 289.253 284.79 287.645 289.413 287.645C289.769 286.603 290.793 285.856 292.007 285.856 293.514 285.856 294.741 287.016 294.741 288.447 294.741 289.61 293.949 290.591 292.84 290.923zM276.113 290.902L276.098 294.245 274.404 294.245 274.408 290.93C273.564 290.68 272.899 290.055 272.622 289.253L268.486 289.253 268.486 287.645 272.622 287.645C272.979 286.603 273.998 285.856 275.213 285.856 276.428 285.856 277.455 286.603 277.812 287.645L282.03 287.645 282.03 289.253 277.801 289.253C277.534 290.026 276.92 290.642 276.113 290.902zM257.621 294.96L255.863 295.455 255.863 299.924 257.621 300.408 257.621 294.96M259.327 294.96L261.081 295.455 261.081 299.924 259.327 300.408 259.327 294.96M291.114 294.96L289.36 295.455 289.36 299.924 291.114 300.408 291.114 294.96M292.821 294.96L294.58 295.455 294.58 299.924 292.821 300.408 292.821 294.96M266.209 295.842L267.883 295.132 270.943 298.533 269.938 299.984 266.209 295.842M264.914 296.896L263.913 298.352 266.972 301.749 268.64 301.034 264.914 296.896M284.126 295.711L282.45 295.014 279.42 298.44 280.436 299.881 284.126 295.711M285.431 296.754L286.446 298.198 283.417 301.624 281.745 300.923 285.431 296.754M264.25 306.175L264.764 304.506 269.477 304.506 269.985 306.175 264.25 306.175M257.34 288.45C257.34 287.839 257.864 287.34 258.51 287.34 259.154 287.34 259.676 287.839 259.676 288.45 259.676 289.062 259.154 289.556 258.51 289.556 257.864 289.556 257.34 289.062 257.34 288.45zM269.945 289.257L269.428 290.93 264.718 290.93 264.209 289.257 269.945 289.257M269.945 287.638L269.428 285.97 264.718 285.97 264.209 287.638 269.945 287.638M286.266 306.175L285.749 304.506 281.039 304.506 280.531 306.175 286.266 306.175M290.838 288.45C290.838 287.839 291.359 287.34 292.007 287.34 292.653 287.34 293.174 287.839 293.174 288.45 293.174 289.062 292.653 289.556 292.007 289.556 291.359 289.556 290.838 289.062 290.838 288.45zM274.044 288.45C274.044 287.839 274.569 287.34 275.213 287.34 275.859 287.34 276.38 287.839 276.38 288.45 276.38 289.062 275.859 289.556 275.213 289.556 274.569 289.556 274.044 289.062 274.044 288.45zM280.571 289.257L281.089 290.93 285.798 290.93 286.308 289.257 280.571 289.257M280.571 287.638L281.089 285.97 285.798 285.97 286.308 287.638 280.571 287.638M274.419 292.858L272.664 293.352 272.664 297.821 274.419 298.305 274.419 292.858M276.106 292.858L277.86 293.352 277.86 297.821 276.106 298.305 276.106 292.858' fill='%23c8b100'/%3E %3Cpath d='M277.852 329.429C279.195 329.217 280.433 328.847 281.655 328.333L282.495 329.764C281.089 330.367 279.574 330.801 277.995 331.038 277.732 332.206 276.642 333.083 275.33 333.083 274.021 333.083 272.929 332.217 272.659 331.057 270.991 330.829 269.409 330.399 267.928 329.764L268.772 328.333C270.058 328.876 271.43 329.238 272.854 329.436 273.155 328.784 273.706 328.28 274.43 328.045L274.445 321.039 276.135 321.039 276.151 328.02C276.901 328.244 277.534 328.755 277.849 329.429L277.852 329.429zM272.949 308.202C272.863 308.06 272.799 307.908 272.742 307.744L268.464 307.744 268.464 306.139 272.713 306.139C272.761 306.004 272.829 305.869 272.899 305.741L267.654 299.907 268.943 298.863 274.123 304.598C274.212 304.555 274.303 304.517 274.4 304.485L274.404 296.843 276.094 296.843 276.094 304.438C276.17 304.459 276.285 304.481 276.361 304.506L281.416 298.756 282.715 299.79 277.64 305.508C277.771 305.699 277.86 305.912 277.932 306.139L282.049 306.139 282.049 307.744 277.909 307.755C277.849 307.936 277.744 308.103 277.647 308.262L282.454 313.728 281.164 314.772 276.38 309.3C276.292 309.332 276.248 309.367 276.151 309.392L276.139 318.429 274.445 318.429 274.44 309.353C274.369 309.332 274.31 309.296 274.242 309.264L269.262 314.772 267.974 313.728 272.949 308.202M259.571 290.877L265.876 297.933 267.167 296.889 260.827 289.861C260.953 289.673 261.043 289.468 261.119 289.247L265.731 289.247 265.731 287.642 261.116 287.642C260.762 286.602 259.728 285.856 258.51 285.856 257.002 285.856 255.776 287.014 255.776 288.442 255.776 289.574 256.543 290.54 257.616 290.887L257.606 296.332 259.3 296.332 259.3 290.924C259.372 290.903 259.502 290.903 259.571 290.877zM266.359 327.079L265.525 328.517C264.095 327.629 262.821 326.533 261.727 325.303 260.857 325.559 259.874 325.407 259.132 324.803 257.984 323.872 257.845 322.239 258.828 321.156L258.971 321.004C258.279 319.441 257.811 317.761 257.651 316L259.361 316.007C259.495 317.51 259.87 318.941 260.454 320.283 260.935 320.215 261.449 320.272 261.91 320.443L266.188 315.709 267.477 316.75 263.226 321.476C263.8 322.349 263.777 323.475 263.121 324.334 264.065 325.379 265.149 326.309 266.359 327.079zM257.598 313.391L257.6 309.378C256.496 309.051 255.693 308.067 255.693 306.91 255.693 305.755 256.507 304.761 257.614 304.427L257.6 298.938 259.297 298.938 259.3 304.459C260.137 304.722 260.781 305.336 261.04 306.132L265.614 306.139 265.614 307.744 261.011 307.744C260.737 308.504 260.111 309.101 259.315 309.36L259.312 313.401 257.598 313.391M260.016 322.115C260.437 321.646 261.175 321.593 261.666 321.99 262.158 322.388 262.218 323.091 261.798 323.553 261.376 324.018 260.639 324.075 260.148 323.677 259.657 323.276 259.597 322.58 260.016 322.115zM257.86 317.434L256.102 317.041 255.854 312.588 257.598 312.012 257.6 314.566C257.6 315.556 257.688 316.494 257.86 317.434zM259.319 311.913L261.07 312.325C261.07 312.325 261.16 315.187 261.123 314.544 261.077 313.795 261.314 316.782 261.314 316.782L259.548 317.364C259.372 316.455 259.312 315.524 259.312 314.566L259.315 311.913 259.319 311.913zM265.092 326.159C266.567 327.31 268.281 328.244 270.133 328.836L270.523 327.143C269.001 326.663 267.59 325.961 266.349 325.048L265.092 326.159M264.245 327.622C265.741 328.748 267.452 329.65 269.285 330.275L267.976 331.5C266.506 330.957 265.124 330.24 263.856 329.387L264.245 327.622' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M266.53 317.808L268.202 318.518 271.261 315.123 270.256 313.678 266.53 317.808M265.233 316.76L264.23 315.308 267.291 311.913 268.958 312.626 265.233 316.76M257.257 306.91C257.257 306.295 257.781 305.799 258.426 305.799 259.072 305.799 259.593 306.295 259.593 306.91 259.593 307.524 259.072 308.014 258.426 308.014 257.781 308.014 257.257 307.524 257.257 306.91zM284.066 327.079L284.902 328.517C286.33 327.629 287.606 326.533 288.7 325.303 289.566 325.559 290.553 325.407 291.294 324.803 292.442 323.872 292.574 322.239 291.597 321.156L291.452 321.004C292.146 319.441 292.615 317.761 292.768 316L291.067 316.007C290.932 317.51 290.553 318.941 289.971 320.283 289.488 320.215 288.978 320.272 288.513 320.443L284.239 315.709 282.949 316.75 287.197 321.476C286.627 322.349 286.649 323.475 287.302 324.334 286.36 325.379 285.277 326.309 284.066 327.079zM292.829 313.391L292.825 309.378C293.931 309.051 294.733 308.067 294.733 306.91 294.733 305.755 293.92 304.761 292.814 304.427L292.825 298.938 291.129 298.938 291.122 304.459C290.29 304.722 289.645 305.336 289.386 306.132L284.809 306.139 284.809 307.744 289.416 307.744C289.69 308.504 290.309 309.101 291.111 309.36L291.114 313.401 292.825 313.391 292.829 313.391zM290.406 322.115C289.986 321.646 289.251 321.593 288.761 321.99 288.268 322.388 288.209 323.091 288.629 323.553 289.049 324.018 289.788 324.075 290.279 323.677 290.771 323.276 290.826 322.58 290.406 322.115zM292.563 317.434L294.321 317.041 294.569 312.588 292.829 312.012 292.825 314.566C292.825 315.556 292.738 316.494 292.563 317.434zM291.108 311.913L289.357 312.325C289.357 312.325 289.262 315.187 289.301 314.544 289.349 313.795 289.109 316.782 289.109 316.782L290.875 317.364C291.052 316.455 291.111 315.524 291.111 314.566L291.108 311.913M292.84 290.913L292.825 296.332 291.129 296.332 291.129 290.891C290.999 290.852 290.871 290.799 290.75 290.738L284.479 297.802 283.182 296.772 289.573 289.57C289.521 289.468 289.465 289.361 289.427 289.247L284.79 289.247 284.79 287.642 289.413 287.642C289.769 286.602 290.793 285.856 292.007 285.856 293.514 285.856 294.741 287.014 294.741 288.442 294.741 289.603 293.949 290.582 292.84 290.913zM276.113 290.891L276.098 294.229 274.404 294.229 274.408 290.92C273.564 290.671 272.899 290.047 272.622 289.247L268.486 289.247 268.486 287.642 272.622 287.642C272.979 286.602 273.998 285.856 275.213 285.856 276.428 285.856 277.455 286.602 277.812 287.642L282.03 287.642 282.03 289.247 277.801 289.247C277.534 290.017 276.92 290.633 276.113 290.891zM285.333 326.159C283.856 327.31 282.142 328.244 280.294 328.836L279.904 327.143C281.423 326.663 282.836 325.961 284.074 325.048L285.333 326.159M286.181 327.622C284.68 328.748 282.975 329.65 281.141 330.275L282.45 331.5C283.92 330.957 285.303 330.24 286.571 329.387L286.181 327.622M257.621 294.943L255.863 295.437 255.863 299.897 257.621 300.379 257.621 294.943M259.327 294.943L261.081 295.437 261.081 299.897 259.327 300.379 259.327 294.943M291.114 294.943L289.36 295.437 289.36 299.897 291.114 300.379 291.114 294.943' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M292.821 294.943L294.58 295.437 294.58 299.897 292.821 300.379 292.821 294.943M283.897 317.808L282.225 318.518 279.165 315.123 280.17 313.678 283.897 317.808M285.193 316.76L286.196 315.308 283.136 311.913 281.468 312.626 285.193 316.76M266.209 295.823L267.883 295.113 270.943 298.509 269.938 299.957 266.209 295.823M264.914 296.874L263.913 298.327 266.972 301.719 268.64 301.005 264.914 296.874M284.126 295.692L282.45 294.997 279.42 298.416 280.436 299.854 284.126 295.692M285.431 296.732L286.446 298.174 283.417 301.594 281.745 300.894 285.431 296.732M264.25 306.136L264.764 304.47 269.477 304.47 269.985 306.136 264.25 306.136M264.25 307.748L264.764 309.416 269.477 309.416 269.985 307.748 264.25 307.748M257.34 288.445C257.34 287.835 257.864 287.337 258.51 287.337 259.154 287.337 259.676 287.835 259.676 288.445 259.676 289.056 259.154 289.549 258.51 289.549 257.864 289.549 257.34 289.056 257.34 288.445zM269.945 289.251L269.428 290.92 264.718 290.92 264.209 289.251 269.945 289.251M269.945 287.635L269.428 285.97 264.718 285.97 264.209 287.635 269.945 287.635M290.826 306.91C290.826 306.295 291.352 305.799 291.996 305.799 292.645 305.799 293.162 306.295 293.162 306.91 293.162 307.524 292.645 308.014 291.996 308.014 291.352 308.014 290.826 307.524 290.826 306.91zM286.266 306.136L285.749 304.47 281.039 304.47 280.531 306.136 286.266 306.136M286.266 307.748L285.749 309.416 281.039 309.416 280.531 307.748 286.266 307.748M274.16 330.495C274.16 329.88 274.684 329.384 275.33 329.384 275.974 329.384 276.495 329.88 276.495 330.495 276.495 331.106 275.974 331.599 275.33 331.599 274.684 331.599 274.16 331.106 274.16 330.495zM276.143 322.42L277.902 321.927 277.902 317.47 276.143 316.987 276.143 322.42M274.438 322.42L272.683 321.927 272.683 317.47 274.438 316.987 274.438 322.42M290.838 288.445C290.838 287.835 291.359 287.337 292.007 287.337 292.653 287.337 293.174 287.835 293.174 288.445 293.174 289.056 292.653 289.549 292.007 289.549 291.359 289.549 290.838 289.056 290.838 288.445zM274.044 288.445C274.044 287.835 274.569 287.337 275.213 287.337 275.859 287.337 276.38 287.835 276.38 288.445 276.38 289.056 275.859 289.549 275.213 289.549 274.569 289.549 274.044 289.056 274.044 288.445zM280.571 289.251L281.089 290.92 285.798 290.92 286.308 289.251 280.571 289.251M280.571 287.635L281.089 285.97 285.798 285.97 286.308 287.635 280.571 287.635' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M274.419 292.845L272.664 293.338 272.664 297.798 274.419 298.281 274.419 292.845M276.106 292.845L277.86 293.338 277.86 297.798 276.106 298.281 276.106 292.845' fill='none' stroke='%23c8b100' stroke-width='0.26'/%3E %3Cpath d='M272.592 306.938C272.592 305.504 273.819 304.343 275.33 304.343 276.837 304.343 278.063 305.504 278.063 306.938 278.063 308.366 276.837 309.523 275.33 309.523 273.819 309.523 272.592 308.366 272.592 306.938' fill='%23058e6e'/%3E %3Cpath d='M275.929 239.261L275.985 238.643 276.071 238.298C276.071 238.298 274.46 238.43 273.612 238.192 272.764 237.951 272 237.602 271.208 236.935 270.418 236.263 270.106 235.844 269.54 235.76 268.183 235.543 267.137 236.158 267.137 236.158 267.137 236.158 268.157 236.533 268.922 237.468 269.682 238.409 270.512 238.884 270.871 238.998 271.464 239.179 273.527 239.051 274.092 239.073 274.658 239.101 275.929 239.264 275.929 239.264' fill='%23db4446'/%3E %3Cpath d='M275.929 239.261L275.985 238.643 276.071 238.298C276.071 238.298 274.46 238.43 273.612 238.192 272.764 237.951 272 237.602 271.208 236.935 270.418 236.263 270.106 235.844 269.54 235.76 268.183 235.543 267.137 236.158 267.137 236.158 267.137 236.158 268.157 236.533 268.922 237.468 269.682 238.409 270.512 238.884 270.871 238.998 271.464 239.179 273.527 239.051 274.092 239.073 274.658 239.101 275.929 239.264 275.929 239.264L275.929 239.261z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M283.463 236.995C283.463 236.995 283.467 237.716 283.537 238.405 283.605 239.066 283.324 239.644 283.432 240.01 283.537 240.38 283.589 240.671 283.732 240.936 283.867 241.203 283.942 241.878 283.942 241.878 283.942 241.878 283.556 241.604 283.199 241.338 282.847 241.068 282.595 240.901 282.595 240.901 282.595 240.901 282.667 241.622 282.7 241.931 282.739 242.24 282.919 242.822 283.211 243.167 283.5 243.504 284.078 244.058 284.256 244.502 284.441 244.95 284.404 245.937 284.404 245.937 284.404 245.937 283.935 245.187 283.532 245.053 283.136 244.914 282.266 244.431 282.266 244.431 282.266 244.431 283.064 245.223 283.064 245.976 283.064 246.728 282.739 247.584 282.739 247.584 282.739 247.584 282.378 246.902 281.91 246.455 281.438 246.011 280.785 245.564 280.785 245.564 280.785 245.564 281.295 246.728 281.295 247.513 281.295 248.305 281.153 249.984 281.153 249.984 281.153 249.984 280.755 249.335 280.357 249.019 279.957 248.714 279.488 248.44 279.341 248.237 279.199 248.032 279.815 248.884 279.881 249.398 279.952 249.914 280.196 251.749 281.801 254.093 282.739 255.464 284.19 257.86 287.298 257.072 290.41 256.287 289.255 252.105 288.603 250.151 287.95 248.202 287.624 246.039 287.662 245.283 287.696 244.534 288.239 242.308 288.168 241.892 288.096 241.484 287.927 239.893 288.314 238.611 288.712 237.276 289.042 236.758 289.255 236.207 289.468 235.66 289.648 235.351 289.72 234.872 289.792 234.393 289.792 233.497 289.792 233.497 289.792 233.497 290.369 234.563 290.515 234.939 290.658 235.319 290.658 236.445 290.658 236.445 290.658 236.445 290.766 235.319 291.637 234.772 292.507 234.218 293.518 233.639 293.772 233.33 294.025 233.018 294.099 232.816 294.099 232.816 294.099 232.816 294.025 234.737 293.484 235.493 293.125 235.983 291.708 237.581 291.708 237.581 291.708 237.581 292.435 237.304 292.94 237.276 293.447 237.237 293.807 237.276 293.807 237.276 293.807 237.276 293.192 237.756 292.397 238.92 291.602 240.081 291.926 240.184 291.348 241.143 290.766 242.101 290.297 242.137 289.573 242.72 288.486 243.593 289.072 247.065 289.214 247.581 289.36 248.092 291.239 252.345 291.276 253.372 291.309 254.402 291.494 256.696 289.682 258.169 288.516 259.125 286.608 259.132 286.173 259.405 285.737 259.675 284.875 260.531 284.875 262.314 284.875 264.1 285.521 264.37 286.027 264.817 286.537 265.264 287.186 265.023 287.331 265.368 287.478 265.708 287.549 265.914 287.767 266.12 287.985 266.322 288.131 266.564 288.056 266.936 287.985 267.317 287.152 268.173 286.863 268.794 286.571 269.404 285.993 271.02 285.993 271.258 285.993 271.5 285.925 272.253 286.173 272.632 286.173 272.632 287.077 273.688 286.461 273.893 286.064 274.028 285.675 273.644 285.487 273.688 284.947 273.83 284.665 274.163 284.509 274.135 284.148 274.067 284.148 273.89 284.111 273.382 284.078 272.87 284.096 272.661 283.935 272.661 283.717 272.661 283.608 272.839 283.571 273.109 283.532 273.382 283.532 273.996 283.282 273.996 283.028 273.996 282.667 273.552 282.45 273.453 282.232 273.349 281.618 273.247 281.583 272.974 281.546 272.7 281.944 272.118 282.341 272.014 282.739 271.911 283.102 271.709 282.847 271.504 282.593 271.297 282.341 271.297 282.09 271.504 281.835 271.709 281.295 271.535 281.329 271.227 281.366 270.918 281.438 270.544 281.399 270.371 281.366 270.204 280.931 269.859 281.505 269.546 282.086 269.241 282.337 269.824 282.915 269.72 283.496 269.622 283.785 269.408 284.002 269.071 284.22 268.73 284.182 268.009 283.785 267.566 283.387 267.118 282.99 267.047 282.843 266.773 282.697 266.5 282.484 265.85 282.484 265.85 282.484 265.85 282.589 267.047 282.517 267.221 282.447 267.392 282.484 268.108 282.484 268.108 282.484 268.108 282.086 267.664 281.76 267.324 281.438 266.98 281.111 265.954 281.111 265.954 281.111 265.954 281.077 266.912 281.077 267.292 281.077 267.664 281.508 268.009 281.366 268.148 281.22 268.283 280.535 267.427 280.354 267.292 280.17 267.154 279.593 266.71 279.338 266.227 279.087 265.747 278.902 265.066 278.832 264.821 278.759 264.582 278.641 263.514 278.759 263.244 278.94 262.835 279.23 262.114 279.23 262.114 279.23 262.114 278.58 262.114 277.819 262.114 277.062 262.114 276.518 261.877 276.229 262.388 275.941 262.903 276.083 263.933 276.444 265.268 276.807 266.599 277.02 267.253 276.916 267.494 276.81 267.732 276.339 268.283 276.159 268.382 275.974 268.489 275.468 268.453 275.25 268.354 275.037 268.25 274.677 268.076 273.987 268.076 273.301 268.076 272.866 268.108 272.615 268.048 272.361 267.978 271.745 267.668 271.452 267.736 271.163 267.806 270.664 268.062 270.8 268.457 271.021 269.074 270.586 269.213 270.294 269.178 270.005 269.142 269.758 269.039 269.39 268.939 269.031 268.833 268.486 268.939 268.559 268.524 268.629 268.112 268.776 268.08 268.955 267.775 269.138 267.462 269.206 267.264 269.003 267.242 268.749 267.217 268.494 267.189 268.296 267.352 268.104 267.512 267.793 267.857 267.538 267.729 267.282 267.594 267.084 267.299 267.084 266.652 267.084 266.01 266.405 265.449 267.028 265.477 267.65 265.506 268.442 265.961 268.584 265.612 268.723 265.261 268.637 265.105 268.3 264.831 267.96 264.565 267.538 264.405 267.991 264.057 268.442 263.712 268.554 263.712 268.727 263.521 268.896 263.336 269.138 262.733 269.455 262.882 270.076 263.177 269.484 263.606 270.106 264.298 270.729 264.994 271.123 265.24 272.169 265.129 273.214 265.023 273.5 264.888 273.5 264.593 273.5 264.298 273.413 263.766 273.383 263.549 273.357 263.336 273.527 262.558 273.527 262.558 273.527 262.558 273.046 262.856 272.904 263.147 272.768 263.442 272.483 263.947 272.483 263.947 272.483 263.947 272.368 263.347 272.401 262.856 272.42 262.569 272.522 262.068 272.511 261.969 272.483 261.703 272.285 261.032 272.285 261.032 272.285 261.032 272.115 261.756 272.004 261.969 271.891 262.182 271.835 263.042 271.835 263.042 271.835 263.042 271.171 262.463 271.356 261.49 271.494 260.74 271.242 259.75 271.467 259.427 271.689 259.104 272.225 257.793 273.527 257.736 274.827 257.687 275.843 257.793 276.298 257.769 276.75 257.736 278.36 257.445 278.36 257.445 278.36 257.445 275.392 255.922 274.715 255.464 274.036 255.013 272.99 253.834 272.649 253.298 272.31 252.761 272 251.721 272 251.721 272 251.721 271.467 251.745 270.984 252.012 270.504 252.275 270.025 252.684 269.743 252.999 269.457 253.322 269.008 254.047 269.008 254.047 269.008 254.047 269.09 253.11 269.09 252.815 269.09 252.527 269.034 251.956 269.034 251.956 269.034 251.956 268.696 253.241 268.018 253.72 267.339 254.206 266.548 254.874 266.548 254.874 266.548 254.874 266.634 254.157 266.634 253.994 266.634 253.834 266.803 253.003 266.803 253.003 266.803 253.003 266.323 253.72 265.588 253.862 264.853 253.994 263.777 253.966 263.691 254.424 263.609 254.874 263.89 255.492 263.721 255.811 263.551 256.134 263.185 256.348 263.185 256.348 263.185 256.348 262.762 255.996 262.393 255.971 262.026 255.943 261.685 256.134 261.685 256.134 261.685 256.134 261.374 255.73 261.486 255.464 261.602 255.197 262.165 254.796 262.026 254.633 261.884 254.473 261.431 254.69 261.149 254.821 260.868 254.956 260.272 255.087 260.328 254.633 260.385 254.178 260.526 253.912 260.385 253.589 260.244 253.273 260.328 253.056 260.557 252.975 260.781 252.9 261.685 252.999 261.771 252.794 261.854 252.577 261.546 252.31 260.95 252.175 260.357 252.044 260.073 251.693 260.385 251.398 260.696 251.103 260.781 251.025 260.922 250.756 261.063 250.486 261.119 250.005 261.658 250.247 262.191 250.486 262.078 251.075 262.649 251.263 263.208 251.454 264.539 251.185 264.819 251.025 265.105 250.861 266.008 250.194 266.319 250.031 266.631 249.875 267.928 248.909 267.928 248.909 267.928 248.909 267.167 248.379 266.882 248.106 266.601 247.84 266.095 247.2 265.844 247.065 265.588 246.927 264.344 246.451 263.92 246.423 263.496 246.395 262.195 245.944 262.195 245.944 262.195 245.944 262.788 245.752 262.986 245.592 263.185 245.432 263.631 245.027 263.863 245.056 264.085 245.085 264.14 245.085 264.14 245.085 264.14 245.085 262.93 245.027 262.674 244.953 262.42 244.867 261.685 244.413 261.405 244.413 261.119 244.413 260.557 244.523 260.557 244.523 260.557 244.523 261.318 244.041 261.94 243.934 262.562 243.831 263.043 243.852 263.043 243.852 263.043 243.852 262.083 243.585 261.854 243.266 261.629 242.943 261.405 242.467 261.231 242.25 261.063 242.038 260.95 241.686 260.639 241.661 260.328 241.633 259.79 242.038 259.48 242.009 259.173 241.985 258.944 241.792 258.913 241.341 258.892 240.884 258.913 241.043 258.806 240.805 258.693 240.561 258.24 239.999 258.663 239.868 259.091 239.733 259.994 239.947 260.076 239.786 260.163 239.626 259.597 239.144 259.23 238.956 258.862 238.77 258.269 238.447 258.58 238.181 258.892 237.915 259.201 237.809 259.372 237.567 259.541 237.326 259.739 236.658 260.107 236.87 260.474 237.084 260.983 238.131 261.266 238.05 261.551 237.968 261.572 237.219 261.52 236.9 261.464 236.576 261.52 236.016 261.798 236.068 262.083 236.121 262.308 236.495 262.762 236.526 263.211 236.551 263.89 236.42 263.833 236.736 263.777 237.056 263.521 237.453 263.211 237.805 262.908 238.156 262.765 238.849 262.96 239.303 263.158 239.761 263.669 240.486 264.119 240.777 264.568 241.071 265.416 241.289 265.956 241.633 266.491 241.985 267.737 242.971 268.161 243.078 268.584 243.188 269.008 243.401 269.008 243.401 269.008 243.401 269.487 243.188 270.14 243.188 270.789 243.188 272.285 243.294 272.851 243.053 273.417 242.808 274.152 242.41 273.926 241.899 273.703 241.394 272.457 240.936 272.57 240.539 272.683 240.138 273.136 240.11 273.896 240.081 274.658 240.056 275.704 240.216 275.9 239.144 276.098 238.075 276.155 237.456 275.086 237.219 274.01 236.977 273.217 236.953 273.024 236.175 272.824 235.4 272.626 235.213 272.851 234.996 273.08 234.786 273.473 234.676 274.265 234.627 275.056 234.57 275.959 234.57 276.215 234.378 276.47 234.197 276.522 233.686 276.833 233.469 277.143 233.26 278.363 233.067 278.363 233.067 278.363 233.067 279.815 233.778 281.164 234.779 282.371 235.681 283.463 237.013 283.463 237.013' fill='%23ed72aa' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M273.046 236.242C273.046 236.242 272.877 235.76 272.848 235.625 272.822 235.493 272.734 235.33 272.734 235.33 272.734 235.33 273.612 235.33 273.583 235.596 273.556 235.866 273.301 235.866 273.245 235.969 273.189 236.079 273.046 236.242 273.046 236.242'/%3E %3Cpath d='M273.046 236.242C273.046 236.242 272.877 235.76 272.848 235.625 272.822 235.493 272.734 235.33 272.734 235.33 272.734 235.33 273.612 235.33 273.583 235.596 273.556 235.866 273.301 235.866 273.245 235.969 273.189 236.079 273.046 236.242 273.046 236.242z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M277.062 234.847L277.002 234.418C277.002 234.418 277.767 234.425 278.134 234.684 278.701 235.085 279.064 235.702 279.038 235.728 278.94 235.823 278.502 235.461 278.19 235.355 278.19 235.355 277.965 235.408 277.737 235.408 277.512 235.408 277.399 235.302 277.369 235.195 277.344 235.085 277.399 234.9 277.399 234.9L277.062 234.851'/%3E %3Cpath d='M277.062 234.847L277.002 234.418C277.002 234.418 277.767 234.425 278.134 234.684 278.701 235.085 279.064 235.702 279.038 235.728 278.94 235.823 278.502 235.461 278.19 235.355 278.19 235.355 277.965 235.408 277.737 235.408 277.512 235.408 277.399 235.302 277.369 235.195 277.344 235.085 277.399 234.9 277.399 234.9L277.062 234.851 277.062 234.847z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M282.574 240.898C282.574 240.898 282.232 240.415 282.15 240.252 282.063 240.096 281.921 239.772 281.921 239.772' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M261.88 236.079C261.88 236.079 262.36 236.423 262.728 236.477 263.095 236.533 263.493 236.533 263.549 236.533 263.605 236.533 263.721 235.993 263.661 235.625 263.463 234.418 262.36 234.151 262.36 234.151 262.36 234.151 262.689 234.883 262.529 235.22 262.304 235.702 261.88 236.079 261.88 236.079' fill='%23db4446'/%3E %3Cpath d='M261.88 236.079C261.88 236.079 262.36 236.423 262.728 236.477 263.095 236.533 263.493 236.533 263.549 236.533 263.605 236.533 263.721 235.993 263.661 235.625 263.463 234.418 262.36 234.151 262.36 234.151 262.36 234.151 262.689 234.883 262.529 235.22 262.304 235.702 261.88 236.079 261.88 236.079z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M259.589 237.123C259.589 237.123 259.165 236.346 258.262 236.452 257.358 236.558 256.762 237.258 256.762 237.258 256.762 237.258 257.76 237.226 258.006 237.389 258.375 237.631 258.487 238.249 258.487 238.249 258.487 238.249 259.027 237.926 259.195 237.712 259.364 237.496 259.589 237.123 259.589 237.123' fill='%23db4446'/%3E %3Cpath d='M259.589 237.123C259.589 237.123 259.165 236.346 258.262 236.452 257.358 236.558 256.762 237.258 256.762 237.258 256.762 237.258 257.76 237.226 258.006 237.389 258.375 237.631 258.487 238.249 258.487 238.249 258.487 238.249 259.027 237.926 259.195 237.712 259.364 237.496 259.589 237.123 259.589 237.123z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M258.487 240.252C258.487 240.252 257.725 240.361 257.302 240.845 256.874 241.327 256.935 242.236 256.935 242.236 256.935 242.236 257.44 241.704 257.894 241.704 258.349 241.704 259.053 241.864 259.053 241.864 259.053 241.864 258.828 241.296 258.828 241.057 258.828 240.817 258.487 240.252 258.487 240.252' fill='%23db4446'/%3E %3Cpath d='M258.487 240.252C258.487 240.252 257.725 240.361 257.302 240.845 256.874 241.327 256.935 242.236 256.935 242.236 256.935 242.236 257.44 241.704 257.894 241.704 258.349 241.704 259.053 241.864 259.053 241.864 259.053 241.864 258.828 241.296 258.828 241.057 258.828 240.817 258.487 240.252 258.487 240.252z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M273.076 240.145L273.413 239.612 273.746 240.096 273.076 240.145'/%3E %3Cpath d='M273.076 240.145L273.413 239.612 273.746 240.096 273.076 240.145' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M273.893 240.12L274.29 239.587 274.715 240.066 273.893 240.12'/%3E %3Cpath d='M273.893 240.12L274.29 239.587 274.715 240.066 273.893 240.12' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M273.527 236.828L274.347 237.123 273.612 237.496 273.527 236.828'/%3E %3Cpath d='M273.527 236.828L274.347 237.123 273.612 237.496 273.527 236.828' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M274.515 237.098L275.25 237.283 274.658 237.737 274.515 237.098'/%3E %3Cpath d='M274.515 237.098L275.25 237.283 274.658 237.737 274.515 237.098' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M269.003 243.387C269.003 243.387 268.198 243.622 267.901 244.055 267.534 244.59 267.561 245.127 267.561 245.127 267.561 245.127 268.239 244.566 269.116 244.804 269.994 245.045 270.076 245.127 270.447 245.102 270.815 245.074 271.719 244.75 271.719 244.75 271.719 244.75 270.984 245.606 271.067 246.199 271.152 246.785 271.261 247.051 271.238 247.35 271.177 248.074 270.643 248.958 270.643 248.958 270.643 248.958 270.954 248.767 271.689 248.607 272.42 248.447 273.046 248.095 273.44 247.804 273.834 247.506 274.343 246.785 274.343 246.785 274.343 246.785 274.179 247.776 274.343 248.205 274.512 248.635 274.569 249.867 274.569 249.867 274.569 249.867 275.041 249.449 275.415 249.249 275.614 249.14 276.124 248.873 276.324 248.554 276.462 248.326 276.635 247.488 276.635 247.488 276.635 247.488 276.747 248.39 277.028 248.827 277.313 249.249 277.732 250.567 277.732 250.567 277.732 250.567 278.018 249.711 278.329 249.36 278.637 249.012 279.008 248.558 279.034 248.288 279.06 248.021 278.952 247.435 278.952 247.435L279.345 248.288M267.928 248.902C267.928 248.902 268.408 248.074 268.862 247.804 269.316 247.535 269.938 247.055 270.106 247.002 270.271 246.948 271.01 246.544 271.01 246.544M272 251.714C272 251.714 273.088 251.156 273.413 250.961 274.092 250.563 274.572 249.839 274.572 249.839' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M261.058 250.372C261.058 250.372 260.635 249.921 259.9 250.052 259.165 250.187 258.685 251.018 258.685 251.018 258.685 251.018 259.307 250.854 259.676 250.936 260.042 251.018 260.298 251.391 260.298 251.391 260.298 251.391 260.635 251.096 260.748 250.936 260.861 250.777 261.055 250.372 261.055 250.372' fill='%23db4446'/%3E %3Cpath d='M261.058 250.372C261.058 250.372 260.635 249.921 259.9 250.052 259.165 250.187 258.685 251.018 258.685 251.018 258.685 251.018 259.307 250.854 259.676 250.936 260.042 251.018 260.298 251.391 260.298 251.391 260.298 251.391 260.635 251.096 260.748 250.936 260.861 250.777 261.055 250.372 261.055 250.372L261.058 250.372z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M260.211 253.343C260.211 253.343 259.589 253.238 259.053 253.667 258.517 254.096 258.487 254.924 258.487 254.924 258.487 254.924 258.997 254.494 259.395 254.552 259.788 254.601 260.268 254.817 260.268 254.817 260.268 254.817 260.354 254.306 260.38 254.175 260.467 253.801 260.211 253.343 260.211 253.343' fill='%23db4446'/%3E %3Cpath d='M260.211 253.343C260.211 253.343 259.589 253.238 259.053 253.667 258.517 254.096 258.487 254.924 258.487 254.924 258.487 254.924 258.997 254.494 259.395 254.552 259.788 254.601 260.268 254.817 260.268 254.817 260.268 254.817 260.354 254.306 260.38 254.175 260.467 253.801 260.211 253.343 260.211 253.343z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M261.655 256.078C261.655 256.078 261.614 256.873 261.993 257.36 262.39 257.871 263.125 257.95 263.125 257.95 263.125 257.95 262.878 257.417 262.84 257.146 262.784 256.746 263.178 256.397 263.178 256.397 263.178 256.397 262.814 256.025 262.447 256.025 262.078 256.025 261.655 256.078 261.655 256.078' fill='%23db4446'/%3E %3Cpath d='M261.655 256.078C261.655 256.078 261.614 256.873 261.993 257.36 262.39 257.871 263.125 257.95 263.125 257.95 263.125 257.95 262.878 257.417 262.84 257.146 262.784 256.746 263.178 256.397 263.178 256.397 263.178 256.397 262.814 256.025 262.447 256.025 262.078 256.025 261.655 256.078 261.655 256.078z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M278.333 257.413C278.333 257.413 280.369 258.674 280.313 259.718 280.253 260.762 279.18 262.128 279.18 262.128' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M269.003 263.119C269.003 263.119 268.494 262.477 267.789 262.502 267.08 262.53 266.344 263.194 266.344 263.194 266.344 263.194 267.223 263.119 267.447 263.41 267.676 263.709 267.901 264.078 267.901 264.078 267.901 264.078 268.296 263.868 268.468 263.733 268.637 263.603 269.003 263.119 269.003 263.119' fill='%23db4446'/%3E %3Cpath d='M269.003 263.119C269.003 263.119 268.494 262.477 267.789 262.502 267.08 262.53 266.344 263.194 266.344 263.194 266.344 263.194 267.223 263.119 267.447 263.41 267.676 263.709 267.901 264.078 267.901 264.078 267.901 264.078 268.296 263.868 268.468 263.733 268.637 263.603 269.003 263.119 269.003 263.119z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M266.826 265.928C266.826 265.928 265.896 265.794 265.442 266.276 264.988 266.756 265.018 267.64 265.018 267.64 265.018 267.64 265.585 267.026 266.091 267.078 266.601 267.132 267.167 267.402 267.167 267.402 267.167 267.402 267.08 266.866 267.024 266.624 266.968 266.383 266.826 265.928 266.826 265.928' fill='%23db4446'/%3E %3Cpath d='M266.826 265.928C266.826 265.928 265.896 265.794 265.442 266.276 264.988 266.756 265.018 267.64 265.018 267.64 265.018 267.64 265.585 267.026 266.091 267.078 266.601 267.132 267.167 267.402 267.167 267.402 267.167 267.402 267.08 266.866 267.024 266.624 266.968 266.383 266.826 265.928 266.826 265.928z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M268.835 268.901C268.835 268.901 268.381 269.543 268.723 270.051 269.06 270.562 269.766 270.804 269.766 270.804 269.766 270.804 269.514 270.431 269.627 269.997 269.716 269.657 270.305 269.195 270.305 269.195L268.835 268.904' fill='%23db4446'/%3E %3Cpath d='M268.835 268.901C268.835 268.901 268.381 269.543 268.723 270.051 269.06 270.562 269.766 270.804 269.766 270.804 269.766 270.804 269.514 270.431 269.627 269.997 269.716 269.657 270.305 269.195 270.305 269.195L268.835 268.904 268.835 268.901z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M281.242 270.108C281.242 270.108 280.426 269.916 279.972 270.186 279.522 270.452 279.154 271.578 279.154 271.578 279.154 271.578 279.889 270.964 280.426 271.038 280.961 271.123 281.359 271.337 281.359 271.337 281.359 271.337 281.441 270.878 281.384 270.562 281.351 270.371 281.242 270.108 281.242 270.108' fill='%23db4446'/%3E %3Cpath d='M281.242 270.108C281.242 270.108 280.426 269.916 279.972 270.186 279.522 270.452 279.154 271.578 279.154 271.578 279.154 271.578 279.889 270.964 280.426 271.038 280.961 271.123 281.359 271.337 281.359 271.337 281.359 271.337 281.441 270.878 281.384 270.562 281.351 270.371 281.242 270.108 281.242 270.108z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M281.64 273.102C281.64 273.102 281.018 273.744 281.242 274.28 281.471 274.816 281.865 275.377 281.865 275.377 281.865 275.377 281.842 274.579 282.094 274.362 282.458 274.042 283.136 273.986 283.136 273.986 283.136 273.986 282.6 273.506 282.428 273.453 282.262 273.396 281.64 273.102 281.64 273.102' fill='%23db4446'/%3E %3Cpath d='M281.64 273.102C281.64 273.102 281.018 273.744 281.242 274.28 281.471 274.816 281.865 275.377 281.865 275.377 281.865 275.377 281.842 274.579 282.094 274.362 282.458 274.042 283.136 273.986 283.136 273.986 283.136 273.986 282.6 273.506 282.428 273.453 282.262 273.396 281.64 273.102 281.64 273.102z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M284.748 274.042C284.748 274.042 284.437 274.816 285.033 275.324 285.625 275.835 286.136 275.889 286.136 275.889 286.136 275.889 285.682 275.082 285.825 274.656 285.971 274.212 286.36 273.935 286.36 273.935 286.36 273.935 285.625 273.691 285.513 273.719 285.401 273.744 284.748 274.042 284.748 274.042' fill='%23db4446'/%3E %3Cpath d='M284.748 274.042C284.748 274.042 284.437 274.816 285.033 275.324 285.625 275.835 286.136 275.889 286.136 275.889 286.136 275.889 285.682 275.082 285.825 274.656 285.971 274.212 286.36 273.935 286.36 273.935 286.36 273.935 285.625 273.691 285.513 273.719 285.401 273.744 284.748 274.042 284.748 274.042z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M252.907 329.55C255 330.18 256.06 331.738 256.06 333.563 256.06 335.939 253.755 337.742 250.763 337.742 247.771 337.742 245.345 335.939 245.345 333.563 245.345 331.766 246.342 329.76 248.423 329.615 248.423 329.615 248.359 329.426 248.18 329.117 247.964 328.887 247.539 328.457 247.539 328.457 247.539 328.457 248.333 328.308 248.791 328.482 249.252 328.656 249.555 328.947 249.555 328.947 249.555 328.947 249.773 328.521 250.077 328.191 250.384 327.864 250.782 327.658 250.782 327.658 250.782 327.658 251.242 328.045 251.393 328.304 251.543 328.571 251.641 328.887 251.641 328.887 251.641 328.887 252.064 328.538 252.431 328.396 252.798 328.251 253.271 328.138 253.271 328.138 253.271 328.138 253.136 328.596 253.046 328.829 252.956 329.061 252.907 329.55 252.907 329.55' fill='%23ffd691' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.321 340.321C250.321 340.321 246.342 337.64 244.618 337.277 242.412 336.812 239.934 337.189 238.862 337.132 238.892 337.163 240.148 338.058 240.699 338.612 241.25 339.163 243.088 340.264 244.126 340.523 247.354 341.333 250.321 340.321 250.321 340.321' fill='%23058e6e' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M251.456 340.555C251.456 340.555 254.005 337.905 256.672 337.54 259.825 337.103 261.888 337.8 263.112 338.119 263.14 338.119 262.1 338.612 261.551 338.989 260.998 339.365 259.578 340.555 257.407 340.58 255.232 340.612 252.833 340.352 252.435 340.413 252.037 340.466 251.456 340.555 251.456 340.555' fill='%23058e6e' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M250.692 337.277C249.69 336.347 249.067 335.026 249.067 333.56 249.067 332.097 249.694 330.776 250.695 329.849 251.693 330.776 252.311 332.097 252.311 333.56 252.311 335.026 251.689 336.347 250.692 337.277' fill='%23ad1519' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M249.679 342.71C249.679 342.71 250.294 341.191 250.354 339.884 250.406 338.791 250.2 337.711 250.2 337.711 250.2 337.711 250.538 337.711 250.721 337.711 250.906 337.711 250.995 337.711 250.995 337.711 250.995 337.711 251.393 338.872 251.393 339.884 251.393 340.899 251.209 342.249 251.209 342.249 251.209 342.249 250.658 342.334 250.475 342.419 250.294 342.508 249.679 342.71 249.679 342.71' fill='%23058e6e' stroke='%23000' stroke-width='0.52'/%3E %3Cpath d='M300.005 198.674C300.005 198.098 300.496 197.64 301.1 197.64 301.708 197.64 302.195 198.098 302.195 198.674 302.195 199.249 301.708 199.71 301.1 199.71 300.496 199.71 300.005 199.249 300.005 198.674' fill='%23fff'/%3E %3Cpath d='M300.005 198.674C300.005 198.098 300.496 197.64 301.1 197.64 301.708 197.64 302.195 198.098 302.195 198.674 302.195 199.249 301.708 199.71 301.1 199.71 300.496 199.71 300.005 199.249 300.005 198.674z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M301.504 196.018C301.504 195.446 301.992 194.984 302.6 194.984 303.203 194.984 303.694 195.446 303.694 196.018 303.694 196.597 303.203 197.058 302.6 197.058 301.992 197.058 301.504 196.597 301.504 196.018' fill='%23fff'/%3E %3Cpath d='M301.504 196.018C301.504 195.446 301.992 194.984 302.6 194.984 303.203 194.984 303.694 195.446 303.694 196.018 303.694 196.597 303.203 197.058 302.6 197.058 301.992 197.058 301.504 196.597 301.504 196.018z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M302.501 192.943C302.501 192.371 302.993 191.906 303.602 191.906 304.205 191.906 304.696 192.371 304.696 192.943 304.696 193.518 304.205 193.983 303.602 193.983 302.993 193.983 302.501 193.518 302.501 192.943' fill='%23fff'/%3E %3Cpath d='M302.501 192.943C302.501 192.371 302.993 191.906 303.602 191.906 304.205 191.906 304.696 192.371 304.696 192.943 304.696 193.518 304.205 193.983 303.602 193.983 302.993 193.983 302.501 193.518 302.501 192.943z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M302.63 189.643C302.63 189.068 303.12 188.607 303.723 188.607 304.327 188.607 304.819 189.068 304.819 189.643 304.819 190.219 304.327 190.68 303.723 190.68 303.12 190.68 302.63 190.219 302.63 189.643' fill='%23fff'/%3E %3Cpath d='M302.63 189.643C302.63 189.068 303.12 188.607 303.723 188.607 304.327 188.607 304.819 189.068 304.819 189.643 304.819 190.219 304.327 190.68 303.723 190.68 303.12 190.68 302.63 190.219 302.63 189.643z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M301.816 186.395C301.816 185.823 302.308 185.361 302.91 185.361 303.518 185.361 304.009 185.823 304.009 186.395 304.009 186.973 303.518 187.435 302.91 187.435 302.308 187.435 301.816 186.973 301.816 186.395' fill='%23fff'/%3E %3Cpath d='M301.816 186.395C301.816 185.823 302.308 185.361 302.91 185.361 303.518 185.361 304.009 185.823 304.009 186.395 304.009 186.973 303.518 187.435 302.91 187.435 302.308 187.435 301.816 186.973 301.816 186.395z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M300.129 183.447C300.129 182.872 300.62 182.41 301.224 182.41 301.831 182.41 302.321 182.872 302.321 183.447 302.321 184.023 301.831 184.488 301.224 184.488 300.62 184.488 300.129 184.023 300.129 183.447' fill='%23fff'/%3E %3Cpath d='M300.129 183.447C300.129 182.872 300.62 182.41 301.224 182.41 301.831 182.41 302.321 182.872 302.321 183.447 302.321 184.023 301.831 184.488 301.224 184.488 300.62 184.488 300.129 184.023 300.129 183.447z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M297.879 181.025C297.879 180.45 298.37 179.985 298.974 179.985 299.582 179.985 300.072 180.45 300.072 181.025 300.072 181.597 299.582 182.062 298.974 182.062 298.37 182.062 297.879 181.597 297.879 181.025' fill='%23fff'/%3E %3Cpath d='M297.879 181.025C297.879 180.45 298.37 179.985 298.974 179.985 299.582 179.985 300.072 180.45 300.072 181.025 300.072 181.597 299.582 182.062 298.974 182.062 298.37 182.062 297.879 181.597 297.879 181.025z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M295.265 179.012C295.265 178.436 295.757 177.971 296.365 177.971 296.968 177.971 297.459 178.436 297.459 179.012 297.459 179.583 296.968 180.048 296.365 180.048 295.757 180.048 295.265 179.583 295.265 179.012' fill='%23fff'/%3E %3Cpath d='M295.265 179.012C295.265 178.436 295.757 177.971 296.365 177.971 296.968 177.971 297.459 178.436 297.459 179.012 297.459 179.583 296.968 180.048 296.365 180.048 295.757 180.048 295.265 179.583 295.265 179.012z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M292.143 177.364C292.143 176.789 292.633 176.331 293.238 176.331 293.845 176.331 294.336 176.789 294.336 177.364 294.336 177.94 293.845 178.405 293.238 178.405 292.633 178.405 292.143 177.94 292.143 177.364' fill='%23fff'/%3E %3Cpath d='M292.143 177.364C292.143 176.789 292.633 176.331 293.238 176.331 293.845 176.331 294.336 176.789 294.336 177.364 294.336 177.94 293.845 178.405 293.238 178.405 292.633 178.405 292.143 177.94 292.143 177.364z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M288.903 176.189C288.903 175.617 289.394 175.152 290.001 175.152 290.604 175.152 291.097 175.617 291.097 176.189 291.097 176.764 290.604 177.229 290.001 177.229 289.394 177.229 288.903 176.764 288.903 176.189' fill='%23fff'/%3E %3Cpath d='M288.903 176.189C288.903 175.617 289.394 175.152 290.001 175.152 290.604 175.152 291.097 175.617 291.097 176.189 291.097 176.764 290.604 177.229 290.001 177.229 289.394 177.229 288.903 176.764 288.903 176.189z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M285.281 175.542C285.281 174.971 285.771 174.502 286.376 174.502 286.984 174.502 287.473 174.971 287.473 175.542 287.473 176.114 286.984 176.58 286.376 176.58 285.771 176.58 285.281 176.114 285.281 175.542' fill='%23fff'/%3E %3Cpath d='M285.281 175.542C285.281 174.971 285.771 174.502 286.376 174.502 286.984 174.502 287.473 174.971 287.473 175.542 287.473 176.114 286.984 176.58 286.376 176.58 285.771 176.58 285.281 176.114 285.281 175.542z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M281.842 175.361C281.842 174.789 282.334 174.328 282.941 174.328 283.545 174.328 284.037 174.789 284.037 175.361 284.037 175.937 283.545 176.402 282.941 176.402 282.334 176.402 281.842 175.937 281.842 175.361' fill='%23fff'/%3E %3Cpath d='M281.842 175.361C281.842 174.789 282.334 174.328 282.941 174.328 283.545 174.328 284.037 174.789 284.037 175.361 284.037 175.937 283.545 176.402 282.941 176.402 282.334 176.402 281.842 175.937 281.842 175.361z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M278.467 175.479C278.467 174.907 278.96 174.442 279.566 174.442 280.174 174.442 280.661 174.907 280.661 175.479 280.661 176.054 280.174 176.519 279.566 176.519 278.96 176.519 278.467 176.054 278.467 175.479' fill='%23fff'/%3E %3Cpath d='M278.467 175.479C278.467 174.907 278.96 174.442 279.566 174.442 280.174 174.442 280.661 174.907 280.661 175.479 280.661 176.054 280.174 176.519 279.566 176.519 278.96 176.519 278.467 176.054 278.467 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M275.097 175.479C275.097 174.907 275.588 174.442 276.192 174.442 276.795 174.442 277.286 174.907 277.286 175.479 277.286 176.054 276.795 176.519 276.192 176.519 275.588 176.519 275.097 176.054 275.097 175.479' fill='%23fff'/%3E %3Cpath d='M275.097 175.479C275.097 174.907 275.588 174.442 276.192 174.442 276.795 174.442 277.286 174.907 277.286 175.479 277.286 176.054 276.795 176.519 276.192 176.519 275.588 176.519 275.097 176.054 275.097 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M276.785 178.373C276.785 177.798 277.276 177.333 277.879 177.333 278.487 177.333 278.974 177.798 278.974 178.373 278.974 178.945 278.487 179.413 277.879 179.413 277.276 179.413 276.785 178.945 276.785 178.373' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M277.471 181.569C277.471 180.994 277.962 180.528 278.566 180.528 279.173 180.528 279.665 180.994 279.665 181.569 279.665 182.137 279.173 182.602 278.566 182.602 277.962 182.602 277.471 182.137 277.471 181.569' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M277.594 184.754C277.594 184.175 278.086 183.713 278.693 183.713 279.297 183.713 279.786 184.175 279.786 184.754 279.786 185.325 279.297 185.791 278.693 185.791 278.086 185.791 277.594 185.325 277.594 184.754' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M276.597 187.651C276.597 187.079 277.088 186.611 277.691 186.611 278.299 186.611 278.787 187.079 278.787 187.651 278.787 188.226 278.299 188.688 277.691 188.688 277.088 188.688 276.597 188.226 276.597 187.651' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M274.733 190.315C274.733 189.743 275.225 189.275 275.828 189.275 276.434 189.275 276.923 189.743 276.923 190.315 276.923 190.887 276.434 191.352 275.828 191.352 275.225 191.352 274.733 190.887 274.733 190.315' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M272.544 173.469C272.544 172.897 273.035 172.435 273.642 172.435 274.246 172.435 274.737 172.897 274.737 173.469 274.737 174.044 274.246 174.509 273.642 174.509 273.035 174.509 272.544 174.044 272.544 173.469' fill='%23fff'/%3E %3Cpath d='M272.544 173.469C272.544 172.897 273.035 172.435 273.642 172.435 274.246 172.435 274.737 172.897 274.737 173.469 274.737 174.044 274.246 174.509 273.642 174.509 273.035 174.509 272.544 174.044 272.544 173.469z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M269.547 171.814C269.547 171.242 270.036 170.774 270.643 170.774 271.247 170.774 271.736 171.242 271.736 171.814 271.736 172.386 271.247 172.851 270.643 172.851 270.036 172.851 269.547 172.386 269.547 171.814' fill='%23fff'/%3E %3Cpath d='M269.547 171.814C269.547 171.242 270.036 170.774 270.643 170.774 271.247 170.774 271.736 171.242 271.736 171.814 271.736 172.386 271.247 172.851 270.643 172.851 270.036 172.851 269.547 172.386 269.547 171.814z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M266.245 170.816C266.245 170.244 266.736 169.783 267.342 169.783 267.946 169.783 268.438 170.244 268.438 170.816 268.438 171.391 267.946 171.857 267.342 171.857 266.736 171.857 266.245 171.391 266.245 170.816' fill='%23fff'/%3E %3Cpath d='M266.245 170.816C266.245 170.244 266.736 169.783 267.342 169.783 267.946 169.783 268.438 170.244 268.438 170.816 268.438 171.391 267.946 171.857 267.342 171.857 266.736 171.857 266.245 171.391 266.245 170.816z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M262.81 170.227C262.81 169.655 263.302 169.19 263.905 169.19 264.512 169.19 265 169.655 265 170.227 265 170.798 264.512 171.264 263.905 171.264 263.302 171.264 262.81 170.798 262.81 170.227' fill='%23fff'/%3E %3Cpath d='M262.81 170.227C262.81 169.655 263.302 169.19 263.905 169.19 264.512 169.19 265 169.655 265 170.227 265 170.798 264.512 171.264 263.905 171.264 263.302 171.264 262.81 170.798 262.81 170.227z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M259.447 170.283C259.447 169.712 259.937 169.243 260.542 169.243 261.149 169.243 261.64 169.712 261.64 170.283 261.64 170.859 261.149 171.321 260.542 171.321 259.937 171.321 259.447 170.859 259.447 170.283' fill='%23fff'/%3E %3Cpath d='M259.447 170.283C259.447 169.712 259.937 169.243 260.542 169.243 261.149 169.243 261.64 169.712 261.64 170.283 261.64 170.859 261.149 171.321 260.542 171.321 259.937 171.321 259.447 170.859 259.447 170.283z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M255.948 170.873C255.948 170.302 256.44 169.839 257.044 169.839 257.651 169.839 258.142 170.302 258.142 170.873 258.142 171.451 257.651 171.914 257.044 171.914 256.44 171.914 255.948 171.451 255.948 170.873' fill='%23fff'/%3E %3Cpath d='M255.948 170.873C255.948 170.302 256.44 169.839 257.044 169.839 257.651 169.839 258.142 170.302 258.142 170.873 258.142 171.451 257.651 171.914 257.044 171.914 256.44 171.914 255.948 171.451 255.948 170.873z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M252.709 171.992C252.709 171.416 253.2 170.951 253.803 170.951 254.411 170.951 254.902 171.416 254.902 171.992 254.902 172.563 254.411 173.032 253.803 173.032 253.2 173.032 252.709 172.563 252.709 171.992' fill='%23fff'/%3E %3Cpath d='M252.709 171.992C252.709 171.416 253.2 170.951 253.803 170.951 254.411 170.951 254.902 171.416 254.902 171.992 254.902 172.563 254.411 173.032 253.803 173.032 253.2 173.032 252.709 172.563 252.709 171.992z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M197.842 198.674C197.842 198.098 198.334 197.64 198.937 197.64 199.545 197.64 200.032 198.098 200.032 198.674 200.032 199.249 199.545 199.71 198.937 199.71 198.334 199.71 197.842 199.249 197.842 198.674' fill='%23fff'/%3E %3Cpath d='M197.842 198.674C197.842 198.098 198.334 197.64 198.937 197.64 199.545 197.64 200.032 198.098 200.032 198.674 200.032 199.249 199.545 199.71 198.937 199.71 198.334 199.71 197.842 199.249 197.842 198.674z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M196.342 196.018C196.342 195.446 196.833 194.984 197.437 194.984 198.045 194.984 198.536 195.446 198.536 196.018 198.536 196.597 198.045 197.058 197.437 197.058 196.833 197.058 196.342 196.597 196.342 196.018' fill='%23fff'/%3E %3Cpath d='M196.342 196.018C196.342 195.446 196.833 194.984 197.437 194.984 198.045 194.984 198.536 195.446 198.536 196.018 198.536 196.597 198.045 197.058 197.437 197.058 196.833 197.058 196.342 196.597 196.342 196.018z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M195.341 192.943C195.341 192.371 195.832 191.906 196.44 191.906 197.044 191.906 197.535 192.371 197.535 192.943 197.535 193.518 197.044 193.983 196.44 193.983 195.832 193.983 195.341 193.518 195.341 192.943' fill='%23fff'/%3E %3Cpath d='M195.341 192.943C195.341 192.371 195.832 191.906 196.44 191.906 197.044 191.906 197.535 192.371 197.535 192.943 197.535 193.518 197.044 193.983 196.44 193.983 195.832 193.983 195.341 193.518 195.341 192.943z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M195.217 189.643C195.217 189.068 195.709 188.607 196.313 188.607 196.92 188.607 197.411 189.068 197.411 189.643 197.411 190.219 196.92 190.68 196.313 190.68 195.709 190.68 195.217 190.219 195.217 189.643' fill='%23fff'/%3E %3Cpath d='M195.217 189.643C195.217 189.068 195.709 188.607 196.313 188.607 196.92 188.607 197.411 189.068 197.411 189.643 197.411 190.219 196.92 190.68 196.313 190.68 195.709 190.68 195.217 190.219 195.217 189.643z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M196.031 186.395C196.031 185.823 196.522 185.361 197.125 185.361 197.729 185.361 198.221 185.823 198.221 186.395 198.221 186.973 197.729 187.435 197.125 187.435 196.522 187.435 196.031 186.973 196.031 186.395' fill='%23fff'/%3E %3Cpath d='M196.031 186.395C196.031 185.823 196.522 185.361 197.125 185.361 197.729 185.361 198.221 185.823 198.221 186.395 198.221 186.973 197.729 187.435 197.125 187.435 196.522 187.435 196.031 186.973 196.031 186.395z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M197.714 183.447C197.714 182.872 198.206 182.41 198.814 182.41 199.417 182.41 199.908 182.872 199.908 183.447 199.908 184.023 199.417 184.488 198.814 184.488 198.206 184.488 197.714 184.023 197.714 183.447' fill='%23fff'/%3E %3Cpath d='M197.714 183.447C197.714 182.872 198.206 182.41 198.814 182.41 199.417 182.41 199.908 182.872 199.908 183.447 199.908 184.023 199.417 184.488 198.814 184.488 198.206 184.488 197.714 184.023 197.714 183.447z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M199.965 181.025C199.965 180.45 200.456 179.985 201.063 179.985 201.666 179.985 202.158 180.45 202.158 181.025 202.158 181.597 201.666 182.062 201.063 182.062 200.456 182.062 199.965 181.597 199.965 181.025' fill='%23fff'/%3E %3Cpath d='M199.965 181.025C199.965 180.45 200.456 179.985 201.063 179.985 201.666 179.985 202.158 180.45 202.158 181.025 202.158 181.597 201.666 182.062 201.063 182.062 200.456 182.062 199.965 181.597 199.965 181.025z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M202.578 179.012C202.578 178.436 203.069 177.971 203.676 177.971 204.28 177.971 204.772 178.436 204.772 179.012 204.772 179.583 204.28 180.048 203.676 180.048 203.069 180.048 202.578 179.583 202.578 179.012' fill='%23fff'/%3E %3Cpath d='M202.578 179.012C202.578 178.436 203.069 177.971 203.676 177.971 204.28 177.971 204.772 178.436 204.772 179.012 204.772 179.583 204.28 180.048 203.676 180.048 203.069 180.048 202.578 179.583 202.578 179.012z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M205.701 177.364C205.701 176.789 206.192 176.331 206.8 176.331 207.404 176.331 207.895 176.789 207.895 177.364 207.895 177.94 207.404 178.405 206.8 178.405 206.192 178.405 205.701 177.94 205.701 177.364' fill='%23fff'/%3E %3Cpath d='M205.701 177.364C205.701 176.789 206.192 176.331 206.8 176.331 207.404 176.331 207.895 176.789 207.895 177.364 207.895 177.94 207.404 178.405 206.8 178.405 206.192 178.405 205.701 177.94 205.701 177.364z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M208.941 176.189C208.941 175.617 209.432 175.152 210.036 175.152 210.643 175.152 211.134 175.617 211.134 176.189 211.134 176.764 210.643 177.229 210.036 177.229 209.432 177.229 208.941 176.764 208.941 176.189' fill='%23fff'/%3E %3Cpath d='M208.941 176.189C208.941 175.617 209.432 175.152 210.036 175.152 210.643 175.152 211.134 175.617 211.134 176.189 211.134 176.764 210.643 177.229 210.036 177.229 209.432 177.229 208.941 176.764 208.941 176.189z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M212.567 175.542C212.567 174.971 213.057 174.502 213.662 174.502 214.265 174.502 214.756 174.971 214.756 175.542 214.756 176.114 214.265 176.58 213.662 176.58 213.057 176.58 212.567 176.114 212.567 175.542' fill='%23fff'/%3E %3Cpath d='M212.567 175.542C212.567 174.971 213.057 174.502 213.662 174.502 214.265 174.502 214.756 174.971 214.756 175.542 214.756 176.114 214.265 176.58 213.662 176.58 213.057 176.58 212.567 176.114 212.567 175.542z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M216.002 175.361C216.002 174.789 216.492 174.328 217.1 174.328 217.703 174.328 218.195 174.789 218.195 175.361 218.195 175.937 217.703 176.402 217.1 176.402 216.492 176.402 216.002 175.937 216.002 175.361' fill='%23fff'/%3E %3Cpath d='M216.002 175.361C216.002 174.789 216.492 174.328 217.1 174.328 217.703 174.328 218.195 174.789 218.195 175.361 218.195 175.937 217.703 176.402 217.1 176.402 216.492 176.402 216.002 175.937 216.002 175.361z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M219.375 175.479C219.375 174.907 219.867 174.442 220.47 174.442 221.078 174.442 221.569 174.907 221.569 175.479 221.569 176.054 221.078 176.519 220.47 176.519 219.867 176.519 219.375 176.054 219.375 175.479' fill='%23fff'/%3E %3Cpath d='M219.375 175.479C219.375 174.907 219.867 174.442 220.47 174.442 221.078 174.442 221.569 174.907 221.569 175.479 221.569 176.054 221.078 176.519 220.47 176.519 219.867 176.519 219.375 176.054 219.375 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M222.75 175.479C222.75 174.907 223.241 174.442 223.845 174.442 224.452 174.442 224.944 174.907 224.944 175.479 224.944 176.054 224.452 176.519 223.845 176.519 223.241 176.519 222.75 176.054 222.75 175.479' fill='%23fff'/%3E %3Cpath d='M222.75 175.479C222.75 174.907 223.241 174.442 223.845 174.442 224.452 174.442 224.944 174.907 224.944 175.479 224.944 176.054 224.452 176.519 223.845 176.519 223.241 176.519 222.75 176.054 222.75 175.479z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M221.063 178.373C221.063 177.798 221.554 177.333 222.158 177.333 222.765 177.333 223.256 177.798 223.256 178.373 223.256 178.945 222.765 179.413 222.158 179.413 221.554 179.413 221.063 178.945 221.063 178.373' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M220.377 181.569C220.377 180.994 220.864 180.528 221.472 180.528 222.075 180.528 222.567 180.994 222.567 181.569 222.567 182.137 222.075 182.602 221.472 182.602 220.864 182.602 220.377 182.137 220.377 181.569' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M220.25 184.754C220.25 184.175 220.741 183.713 221.348 183.713 221.951 183.713 222.443 184.175 222.443 184.754 222.443 185.325 221.951 185.791 221.348 185.791 220.741 185.791 220.25 185.325 220.25 184.754' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M221.251 187.651C221.251 187.079 221.742 186.611 222.345 186.611 222.953 186.611 223.444 187.079 223.444 187.651 223.444 188.226 222.953 188.688 222.345 188.688 221.742 188.688 221.251 188.226 221.251 187.651' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M223.113 190.315C223.113 189.743 223.606 189.275 224.208 189.275 224.816 189.275 225.307 189.743 225.307 190.315 225.307 190.887 224.816 191.352 224.208 191.352 223.606 191.352 223.113 190.887 223.113 190.315' fill='%23fff' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M225.3 173.469C225.3 172.897 225.792 172.435 226.395 172.435 227.002 172.435 227.493 172.897 227.493 173.469 227.493 174.044 227.002 174.509 226.395 174.509 225.792 174.509 225.3 174.044 225.3 173.469' fill='%23fff'/%3E %3Cpath d='M225.3 173.469C225.3 172.897 225.792 172.435 226.395 172.435 227.002 172.435 227.493 172.897 227.493 173.469 227.493 174.044 227.002 174.509 226.395 174.509 225.792 174.509 225.3 174.044 225.3 173.469z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M228.3 171.814C228.3 171.242 228.791 170.774 229.394 170.774 230.001 170.774 230.493 171.242 230.493 171.814 230.493 172.386 230.001 172.851 229.394 172.851 228.791 172.851 228.3 172.386 228.3 171.814' fill='%23fff'/%3E %3Cpath d='M228.3 171.814C228.3 171.242 228.791 170.774 229.394 170.774 230.001 170.774 230.493 171.242 230.493 171.814 230.493 172.386 230.001 172.851 229.394 172.851 228.791 172.851 228.3 172.386 228.3 171.814z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M231.598 170.816C231.598 170.244 232.091 169.783 232.697 169.783 233.301 169.783 233.792 170.244 233.792 170.816 233.792 171.391 233.301 171.857 232.697 171.857 232.091 171.857 231.598 171.391 231.598 170.816' fill='%23fff'/%3E %3Cpath d='M231.598 170.816C231.598 170.244 232.091 169.783 232.697 169.783 233.301 169.783 233.792 170.244 233.792 170.816 233.792 171.391 233.301 171.857 232.697 171.857 232.091 171.857 231.598 171.391 231.598 170.816z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M235.036 170.227C235.036 169.655 235.528 169.19 236.131 169.19 236.74 169.19 237.231 169.655 237.231 170.227 237.231 170.798 236.74 171.264 236.131 171.264 235.528 171.264 235.036 170.798 235.036 170.227' fill='%23fff'/%3E %3Cpath d='M235.036 170.227C235.036 169.655 235.528 169.19 236.131 169.19 236.74 169.19 237.231 169.655 237.231 170.227 237.231 170.798 236.74 171.264 236.131 171.264 235.528 171.264 235.036 170.798 235.036 170.227z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M238.401 170.283C238.401 169.712 238.887 169.243 239.495 169.243 240.099 169.243 240.59 169.712 240.59 170.283 240.59 170.859 240.099 171.321 239.495 171.321 238.887 171.321 238.401 170.859 238.401 170.283' fill='%23fff'/%3E %3Cpath d='M238.401 170.283C238.401 169.712 238.887 169.243 239.495 169.243 240.099 169.243 240.59 169.712 240.59 170.283 240.59 170.859 240.099 171.321 239.495 171.321 238.887 171.321 238.401 170.859 238.401 170.283z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M241.899 170.873C241.899 170.302 242.39 169.839 242.993 169.839 243.602 169.839 244.089 170.302 244.089 170.873 244.089 171.451 243.602 171.914 242.993 171.914 242.39 171.914 241.899 171.451 241.899 170.873' fill='%23fff'/%3E %3Cpath d='M241.899 170.873C241.899 170.302 242.39 169.839 242.993 169.839 243.602 169.839 244.089 170.302 244.089 170.873 244.089 171.451 243.602 171.914 242.993 171.914 242.39 171.914 241.899 171.451 241.899 170.873z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M245.135 171.992C245.135 171.416 245.625 170.951 246.233 170.951 246.837 170.951 247.328 171.416 247.328 171.992 247.328 172.563 246.837 173.032 246.233 173.032 245.625 173.032 245.135 172.563 245.135 171.992' fill='%23fff'/%3E %3Cpath d='M245.135 171.992C245.135 171.416 245.625 170.951 246.233 170.951 246.837 170.951 247.328 171.416 247.328 171.992 247.328 172.563 246.837 173.032 246.233 173.032 245.625 173.032 245.135 172.563 245.135 171.992z' fill='none' stroke='%23000' stroke-width='0.39'/%3E %3Cpath d='M217.341 238.412L216.417 238.412 216.417 237.488 214.799 237.488 214.799 241.185 216.417 241.185 216.417 243.726 212.951 243.726 212.951 251.121 214.799 251.121 214.799 265.909 211.102 265.909 211.102 273.535 239.524 273.535 239.524 265.909 235.827 265.909 235.827 251.121 237.675 251.121 237.675 243.726 234.209 243.726 234.209 241.185 235.827 241.185 235.827 237.488 234.209 237.488 234.209 238.412 233.285 238.412 233.285 237.488 231.667 237.488 231.667 238.412 230.512 238.412 230.512 237.488 228.894 237.488 228.894 241.185 230.512 241.185 230.512 243.726 227.046 243.726 227.046 235.639 228.894 235.639 228.894 231.942 227.046 231.942 227.046 232.866 226.122 232.866 226.122 231.942 224.504 231.942 224.504 232.866 223.58 232.866 223.58 231.942 221.731 231.942 221.731 235.639 223.58 235.639 223.58 243.726 220.114 243.726 220.114 241.185 221.731 241.185 221.731 237.488 220.114 237.488 220.114 238.412 219.189 238.412 219.189 237.488 217.341 237.488 217.341 238.412zM211.102 273.535L239.524 273.535M211.102 271.686L239.524 271.686M211.102 269.837L239.524 269.837M211.102 267.989L239.524 267.989M211.102 265.909L239.524 265.909M214.799 264.292L235.827 264.292M214.799 262.443L235.827 262.443M214.799 260.364L235.827 260.364M214.799 258.515L235.827 258.515M214.799 256.666L235.827 256.666M214.799 254.818L235.827 254.818M214.799 252.969L235.827 252.969M212.951 251.121L237.675 251.121M212.951 249.272L237.675 249.272M212.951 247.424L237.675 247.424M212.951 245.575L237.675 245.575M216.417 243.726L234.209 243.726M223.58 241.878L227.046 241.878M223.58 240.029L227.046 240.029M223.58 238.181L227.046 238.181M223.58 236.332L227.046 236.332M221.731 234.022L228.894 234.022M216.417 241.878L220.114 241.878M214.799 239.567L221.731 239.567M214.799 273.535L214.799 271.686M214.799 269.837L214.799 267.989M212.951 269.837L212.951 271.686M216.417 271.686L216.417 269.837M218.265 273.535L218.265 271.686M218.265 269.837L218.265 267.989M218.265 265.909L218.265 264.292M218.265 262.443L218.265 260.364M216.417 267.989L216.417 265.909M212.951 267.989L212.951 265.909M220.114 265.909L220.114 267.989M221.731 265.909L221.731 264.292M216.417 262.443L216.417 264.292M220.114 262.443L220.114 264.292M223.58 262.443L223.58 264.292M221.731 262.443L221.731 260.364M223.58 258.515L223.58 260.364M223.58 254.818L223.58 256.666M221.731 252.969L221.731 254.818M223.58 251.121L223.58 252.969M220.114 251.121L220.114 252.969M216.417 251.121L216.417 252.969M214.799 249.272L214.799 251.121M218.265 249.272L218.265 251.121M221.731 249.272L221.731 251.121M223.58 247.424L223.58 249.272M220.114 247.424L220.114 249.272M216.417 247.424L216.417 249.272M214.799 245.575L214.799 247.424M221.731 245.575L221.731 247.424M218.265 241.878L218.265 243.726M234.209 241.878L230.512 241.878M235.827 239.567L228.894 239.567M235.827 273.535L235.827 271.686M235.827 269.837L235.827 267.989M237.675 269.837L237.675 271.686M234.209 271.686L234.209 269.837M232.36 273.535L232.36 271.686M232.36 269.837L232.36 267.989M232.36 265.909L232.36 264.292M232.36 262.443L232.36 260.364M234.209 267.989L234.209 265.909M237.675 267.989L237.675 265.909M230.512 265.909L230.512 267.989M228.894 265.909L228.894 264.292M234.209 262.443L234.209 264.292M230.512 262.443L230.512 264.292M227.046 262.443L227.046 264.292M228.894 262.443L228.894 260.364M227.046 258.515L227.046 260.364M227.046 254.818L227.046 256.666M228.894 252.969L228.894 254.818M227.046 251.121L227.046 252.969M230.512 251.121L230.512 252.969M234.209 251.121L234.209 252.969M235.827 249.272L235.827 251.121M232.36 249.272L232.36 251.121M228.894 249.272L228.894 251.121M227.046 247.424L227.046 249.272M230.512 247.424L230.512 249.272M234.209 247.424L234.209 249.272M235.827 245.575L235.827 247.424M228.894 245.575L228.894 247.424M232.36 241.878L232.36 243.726M225.197 262.443L225.197 260.364M225.197 254.818L225.197 252.969M225.197 258.515L225.197 256.666M225.197 251.121L225.197 249.272M225.197 247.424L225.197 245.575M225.197 241.878L225.197 240.029M225.197 238.181L225.197 236.332M216.417 241.185L220.114 241.185M223.58 235.639L227.046 235.639M230.512 241.185L234.209 241.185' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M230.05 273.535C230.05 271.224 230.05 269.606 230.05 268.682 230.05 267.758 229.588 264.985 225.197 264.985 221.038 264.985 220.576 267.758 220.576 268.682 220.576 269.606 220.576 271.224 220.576 273.535L230.05 273.535z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M222.193 268.913L219.883 268.682C219.883 267.758 220.114 266.371 220.807 265.909L222.887 267.527C222.656 267.758 222.193 268.451 222.193 268.913z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M228.432 268.913L230.743 268.682C230.743 267.758 230.512 266.371 229.819 265.909L227.739 267.527C227.97 267.758 228.432 268.451 228.432 268.913z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M226.122 266.602L227.277 264.523C226.815 264.292 225.89 264.061 225.197 264.061 224.735 264.061 223.811 264.292 223.349 264.523L224.504 266.602C224.966 266.602 225.659 266.602 226.122 266.602z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M221.731 260.826C221.731 260.826 221.731 257.129 221.731 255.742 221.731 254.356 220.807 253.2 219.189 253.2 217.572 253.2 216.648 254.356 216.648 255.742 216.648 257.129 216.648 260.826 216.648 260.826L221.731 260.826z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M228.894 260.826C228.894 260.826 228.894 257.129 228.894 255.742 228.894 254.356 229.819 253.2 231.436 253.2 233.054 253.2 233.978 254.356 233.978 255.742 233.978 257.129 233.978 260.826 233.978 260.826L228.894 260.826z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M227.046 248.348L227.508 243.726 223.118 243.726 223.349 248.348 227.046 248.348z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M230.512 248.348L230.05 243.726 234.671 243.726 234.209 248.348 230.512 248.348z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M220.114 248.348L220.345 243.726 215.954 243.726 216.417 248.348 220.114 248.348z' fill='%23c8b100' stroke='%23000' stroke-width='0.46'/%3E %3Cpath d='M228.432 273.535C228.432 271.686 228.432 270.068 228.432 269.375 228.432 268.682 227.97 266.602 225.197 266.602 222.656 266.602 222.193 268.682 222.193 269.375 222.193 270.068 222.193 271.686 222.193 273.535L228.432 273.535z' fill='%230039f0'/%3E %3Cpath d='M221.269 260.364C221.269 260.364 221.269 257.129 221.269 255.973 221.269 254.818 220.576 253.662 219.189 253.662 217.803 253.662 217.11 254.818 217.11 255.973 217.11 257.129 217.11 260.364 217.11 260.364L221.269 260.364z' fill='%230039f0'/%3E %3Cpath d='M229.357 260.364C229.357 260.364 229.357 257.129 229.357 255.973 229.357 254.818 230.05 253.662 231.436 253.662 232.823 253.662 233.516 254.818 233.516 255.973 233.516 257.129 233.516 260.364 233.516 260.364L229.357 260.364z' fill='%230039f0'/%3E %3Cpath d='M234.175 281.006C234.175 270.904 241.453 262.714 250.429 262.714 259.409 262.714 266.687 270.904 266.687 281.006 266.687 291.108 259.409 299.297 250.429 299.297 241.453 299.297 234.175 291.108 234.175 281.006' fill='%23ad1519'/%3E %3Cpath d='M234.175 281.006C234.175 270.904 241.453 262.714 250.429 262.714 259.409 262.714 266.687 270.904 266.687 281.006 266.687 291.108 259.409 299.297 250.429 299.297 241.453 299.297 234.175 291.108 234.175 281.006z' fill='none' stroke='%23000' stroke-width='0.61'/%3E %3Cpath d='M238.997 280.971C238.997 273.563 244.115 267.559 250.436 267.559 256.754 267.559 261.873 273.563 261.873 280.971 261.873 288.381 256.754 294.389 250.436 294.389 244.115 294.389 238.997 288.381 238.997 280.971' fill='%23005bbf'/%3E %3Cpath d='M238.997 280.971C238.997 273.563 244.115 267.559 250.436 267.559 256.754 267.559 261.873 273.563 261.873 280.971 261.873 288.381 256.754 294.389 250.436 294.389 244.115 294.389 238.997 288.381 238.997 280.971z' fill='none' stroke='%23000' stroke-width='0.61'/%3E %3Cpath d='M245.033 271.737C245.033 271.737 243.675 273.225 243.675 274.603 243.675 275.988 244.249 277.138 244.249 277.138 244.044 276.592 243.489 276.198 242.836 276.198 242.012 276.198 241.34 276.83 241.34 277.615 241.34 277.842 241.479 278.197 241.584 278.392L242.071 279.376C242.232 279.013 242.612 278.811 243.054 278.811 243.645 278.811 244.126 279.262 244.126 279.824 244.126 279.908 244.115 279.994 244.093 280.071L242.874 280.075 242.874 281.112 243.961 281.112 243.152 282.717 244.224 282.299 245.033 283.211 245.873 282.299 246.942 282.717 246.136 281.112 247.223 281.112 247.223 280.075 246.001 280.071C245.979 279.994 245.975 279.908 245.975 279.824 245.975 279.262 246.447 278.811 247.039 278.811 247.481 278.811 247.861 279.013 248.025 279.376L248.508 278.392C248.614 278.197 248.753 277.842 248.753 277.615 248.753 276.83 248.085 276.198 247.257 276.198 246.604 276.198 246.053 276.592 245.847 277.138 245.847 277.138 246.417 275.988 246.417 274.603 246.417 273.225 245.03 271.737 245.03 271.737' fill='%23c8b100'/%3E %3Cpath d='M245.033 271.737C245.033 271.737 243.675 273.225 243.675 274.603 243.675 275.988 244.249 277.138 244.249 277.138 244.044 276.592 243.489 276.198 242.836 276.198 242.012 276.198 241.34 276.83 241.34 277.615 241.34 277.842 241.479 278.197 241.584 278.392L242.071 279.376C242.232 279.013 242.612 278.811 243.054 278.811 243.645 278.811 244.126 279.262 244.126 279.824 244.126 279.908 244.115 279.994 244.093 280.071L242.874 280.075 242.874 281.112 243.961 281.112 243.152 282.717 244.224 282.299 245.033 283.211 245.873 282.299 246.942 282.717 246.136 281.112 247.223 281.112 247.223 280.075 246.001 280.071C245.979 279.994 245.975 279.908 245.975 279.824 245.975 279.262 246.447 278.811 247.039 278.811 247.481 278.811 247.861 279.013 248.025 279.376L248.508 278.392C248.614 278.197 248.753 277.842 248.753 277.615 248.753 276.83 248.085 276.198 247.257 276.198 246.604 276.198 246.053 276.592 245.847 277.138 245.847 277.138 246.417 275.988 246.417 274.603 246.417 273.225 245.03 271.737 245.03 271.737L245.033 271.737z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.34'/%3E %3Cpath d='M242.874 281.112L247.226 281.112 247.226 280.075 242.874 280.075 242.874 281.112z' fill='%23c8b100'/%3E %3Cpath d='M242.874 281.112L247.226 281.112 247.226 280.075 242.874 280.075 242.874 281.112z' fill='none' stroke='%23000' stroke-width='0.34'/%3E %3Cpath d='M255.663 271.737C255.663 271.737 254.306 273.225 254.306 274.603 254.306 275.988 254.876 277.138 254.876 277.138 254.673 276.592 254.119 276.198 253.466 276.198 252.637 276.198 251.97 276.83 251.97 277.615 251.97 277.842 252.109 278.197 252.214 278.392L252.697 279.376C252.863 279.013 253.242 278.811 253.684 278.811 254.276 278.811 254.752 279.262 254.752 279.824 254.752 279.908 254.745 279.994 254.723 280.071L253.503 280.075 253.503 281.112 254.591 281.112 253.781 282.717 254.85 282.299 255.663 283.211 256.5 282.299 257.572 282.717 256.762 281.112 257.849 281.112 257.849 280.075 256.631 280.071C256.608 279.994 256.601 279.908 256.601 279.824 256.601 279.262 257.077 278.811 257.67 278.811 258.112 278.811 258.491 279.013 258.652 279.376L259.139 278.392C259.245 278.197 259.382 277.842 259.382 277.615 259.382 276.83 258.712 276.198 257.886 276.198 257.235 276.198 256.678 276.592 256.474 277.138 256.474 277.138 257.047 275.988 257.047 274.603 257.047 273.225 255.66 271.737 255.66 271.737' fill='%23c8b100'/%3E %3Cpath d='M255.663 271.737C255.663 271.737 254.306 273.225 254.306 274.603 254.306 275.988 254.876 277.138 254.876 277.138 254.673 276.592 254.119 276.198 253.466 276.198 252.637 276.198 251.97 276.83 251.97 277.615 251.97 277.842 252.109 278.197 252.214 278.392L252.697 279.376C252.863 279.013 253.242 278.811 253.684 278.811 254.276 278.811 254.752 279.262 254.752 279.824 254.752 279.908 254.745 279.994 254.723 280.071L253.503 280.075 253.503 281.112 254.591 281.112 253.781 282.717 254.85 282.299 255.663 283.211 256.5 282.299 257.572 282.717 256.762 281.112 257.849 281.112 257.849 280.075 256.631 280.071C256.608 279.994 256.601 279.908 256.601 279.824 256.601 279.262 257.077 278.811 257.67 278.811 258.112 278.811 258.491 279.013 258.652 279.376L259.139 278.392C259.245 278.197 259.382 277.842 259.382 277.615 259.382 276.83 258.712 276.198 257.886 276.198 257.235 276.198 256.678 276.592 256.474 277.138 256.474 277.138 257.047 275.988 257.047 274.603 257.047 273.225 255.66 271.737 255.66 271.737L255.663 271.737z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.34'/%3E %3Cpath d='M253.503 281.112L257.853 281.112 257.853 280.075 253.503 280.075 253.503 281.112z' fill='%23c8b100'/%3E %3Cpath d='M253.503 281.112L257.853 281.112 257.853 280.075 253.503 280.075 253.503 281.112z' fill='none' stroke='%23000' stroke-width='0.34'/%3E %3Cpath d='M250.347 280.881C250.347 280.881 248.989 282.369 248.989 283.751 248.989 285.132 249.563 286.282 249.563 286.282 249.357 285.735 248.805 285.341 248.15 285.341 247.325 285.341 246.653 285.974 246.653 286.758 246.653 286.989 246.792 287.34 246.897 287.535L247.384 288.519C247.55 288.157 247.924 287.951 248.366 287.951 248.959 287.951 249.44 288.405 249.44 288.967 249.44 289.056 249.428 289.14 249.405 289.219L248.187 289.222 248.187 290.259 249.278 290.259 248.468 291.864 249.537 291.442 250.347 292.354 251.187 291.442 252.259 291.864 251.445 290.259 252.536 290.259 252.536 289.222 251.317 289.219C251.295 289.14 251.287 289.056 251.287 288.967 251.287 288.405 251.764 287.951 252.357 287.951 252.798 287.951 253.173 288.157 253.339 288.519L253.827 287.535C253.93 287.34 254.07 286.989 254.07 286.758 254.07 285.974 253.399 285.341 252.574 285.341 251.922 285.341 251.371 285.735 251.16 286.282 251.16 286.282 251.734 285.132 251.734 283.751 251.734 282.369 250.343 280.881 250.343 280.881' fill='%23c8b100'/%3E %3Cpath d='M250.347 280.881C250.347 280.881 248.989 282.369 248.989 283.751 248.989 285.132 249.563 286.282 249.563 286.282 249.357 285.735 248.805 285.341 248.15 285.341 247.325 285.341 246.653 285.974 246.653 286.758 246.653 286.989 246.792 287.34 246.897 287.535L247.384 288.519C247.55 288.157 247.924 287.951 248.366 287.951 248.959 287.951 249.44 288.405 249.44 288.967 249.44 289.056 249.428 289.14 249.405 289.219L248.187 289.222 248.187 290.259 249.278 290.259 248.468 291.864 249.537 291.442 250.347 292.354 251.187 291.442 252.259 291.864 251.445 290.259 252.536 290.259 252.536 289.222 251.317 289.219C251.295 289.14 251.287 289.056 251.287 288.967 251.287 288.405 251.764 287.951 252.357 287.951 252.798 287.951 253.173 288.157 253.339 288.519L253.827 287.535C253.93 287.34 254.07 286.989 254.07 286.758 254.07 285.974 253.399 285.341 252.574 285.341 251.922 285.341 251.371 285.735 251.16 286.282 251.16 286.282 251.734 285.132 251.734 283.751 251.734 282.369 250.343 280.881 250.343 280.881L250.347 280.881z' fill='none' stroke='%23000' stroke-linejoin='round' stroke-width='0.34'/%3E %3Cpath d='M248.187 290.259L252.54 290.259 252.54 289.222 248.187 289.222 248.187 290.259z' fill='%23c8b100'/%3E %3Cpath d='M248.187 290.259L252.54 290.259 252.54 289.222 248.187 289.222 248.187 290.259z' fill='none' stroke='%23000' stroke-width='0.34'/%3E %3Cpath d='M282.882 232.706L282.593 232.727C282.58 232.762 282.45 232.969 282.327 233.083 282.071 233.327 281.685 233.355 281.468 233.15 281.362 233.043 281.31 232.894 281.329 232.741 281.16 232.827 280.984 232.827 280.818 232.734 280.56 232.585 280.495 232.23 280.684 231.935 280.714 231.878 280.744 231.804 280.789 231.761L280.77 231.438 280.421 231.52 280.32 231.711C280.103 231.957 279.78 232.02 279.619 231.875 279.541 231.808 279.483 231.62 279.488 231.612 279.491 231.62 279.405 231.697 279.315 231.718 278.78 231.85 278.566 230.671 278.554 230.366L278.378 230.615C278.378 230.615 278.536 231.32 278.456 231.918 278.378 232.514 278.167 233.111 278.167 233.111 278.914 233.302 280.032 233.909 281.141 234.765 282.251 235.614 283.124 236.537 283.485 237.184 283.485 237.184 284.059 236.863 284.662 236.672 285.259 236.477 286.019 236.473 286.019 236.473L286.236 236.26C285.917 236.307 284.655 236.36 284.68 235.83 284.685 235.746 284.748 235.653 284.759 235.653 284.752 235.66 284.55 235.642 284.459 235.586 284.276 235.465 284.28 235.156 284.483 234.9L284.659 234.772 284.67 234.432 284.332 234.478C284.301 234.52 284.224 234.57 284.178 234.613 283.913 234.844 283.53 234.861 283.32 234.644 283.193 234.52 283.153 234.353 283.208 234.179 283.054 234.225 282.893 234.211 282.757 234.133 282.499 233.977 282.45 233.611 282.649 233.327 282.742 233.188 282.926 233.025 282.958 233.008L282.889 232.709' fill='%23c8b100'/%3E %3Cpath d='M282.882 232.706L282.593 232.727C282.58 232.762 282.45 232.969 282.327 233.083 282.071 233.327 281.685 233.355 281.468 233.15 281.362 233.043 281.31 232.894 281.329 232.741 281.16 232.827 280.984 232.827 280.818 232.734 280.56 232.585 280.495 232.23 280.684 231.935 280.714 231.878 280.744 231.804 280.789 231.761L280.77 231.438 280.421 231.52 280.32 231.711C280.103 231.957 279.78 232.02 279.619 231.875 279.541 231.808 279.483 231.62 279.488 231.612 279.491 231.62 279.405 231.697 279.315 231.718 278.78 231.85 278.566 230.671 278.554 230.366L278.378 230.615C278.378 230.615 278.536 231.32 278.456 231.918 278.378 232.514 278.167 233.111 278.167 233.111 278.914 233.302 280.032 233.909 281.141 234.765 282.251 235.614 283.124 236.537 283.485 237.184 283.485 237.184 284.059 236.863 284.662 236.672 285.259 236.477 286.019 236.473 286.019 236.473L286.236 236.26C285.917 236.307 284.655 236.36 284.68 235.83 284.685 235.746 284.748 235.653 284.759 235.653 284.752 235.66 284.55 235.642 284.459 235.586 284.276 235.465 284.28 235.156 284.483 234.9L284.659 234.772 284.67 234.432 284.332 234.478C284.301 234.52 284.224 234.57 284.178 234.613 283.913 234.844 283.53 234.861 283.32 234.644 283.193 234.52 283.153 234.353 283.208 234.179 283.054 234.225 282.893 234.211 282.757 234.133 282.499 233.977 282.45 233.611 282.649 233.327 282.742 233.188 282.926 233.025 282.958 233.008L282.889 232.709 282.882 232.706z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M280.631 233.395C280.681 233.334 280.785 233.337 280.864 233.398 280.942 233.458 280.964 233.555 280.916 233.611 280.868 233.668 280.766 233.668 280.684 233.604 280.609 233.548 280.583 233.451 280.631 233.395'/%3E %3Cpath d='M280.631 233.395C280.681 233.334 280.785 233.337 280.864 233.398 280.942 233.458 280.964 233.555 280.916 233.611 280.868 233.668 280.766 233.668 280.684 233.604 280.609 233.548 280.583 233.451 280.631 233.395z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M281.58 234.193L281.253 233.941C281.194 233.895 281.175 233.821 281.213 233.778 281.25 233.739 281.329 233.739 281.389 233.781L281.715 234.037 282.049 234.29C282.105 234.332 282.126 234.407 282.09 234.453 282.049 234.492 281.97 234.488 281.91 234.446L281.58 234.193'/%3E %3Cpath d='M281.58 234.193L281.253 233.941C281.194 233.895 281.175 233.821 281.213 233.778 281.25 233.739 281.329 233.739 281.389 233.781L281.715 234.037 282.049 234.29C282.105 234.332 282.126 234.407 282.09 234.453 282.049 234.492 281.97 234.488 281.91 234.446L281.58 234.193' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M279.837 233L279.578 232.848C279.514 232.809 279.48 232.734 279.511 232.685 279.537 232.631 279.615 232.624 279.679 232.663L279.936 232.816 280.2 232.969C280.264 233.004 280.294 233.079 280.268 233.132 280.238 233.178 280.163 233.188 280.096 233.15L279.837 233'/%3E %3Cpath d='M279.837 233L279.578 232.848C279.514 232.809 279.48 232.734 279.511 232.685 279.537 232.631 279.615 232.624 279.679 232.663L279.936 232.816 280.2 232.969C280.264 233.004 280.294 233.079 280.268 233.132 280.238 233.178 280.163 233.188 280.096 233.15L279.837 233' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M278.805 232.287C278.854 232.234 278.96 232.234 279.038 232.294 279.117 232.355 279.139 232.45 279.091 232.507 279.041 232.564 278.937 232.56 278.858 232.504 278.78 232.439 278.756 232.348 278.805 232.287'/%3E %3Cpath d='M278.805 232.287C278.854 232.234 278.96 232.234 279.038 232.294 279.117 232.355 279.139 232.45 279.091 232.507 279.041 232.564 278.937 232.56 278.858 232.504 278.78 232.439 278.756 232.348 278.805 232.287z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M282.63 234.925C282.679 234.868 282.655 234.776 282.578 234.712 282.499 234.651 282.394 234.648 282.345 234.709 282.297 234.765 282.319 234.861 282.397 234.921 282.475 234.982 282.58 234.982 282.63 234.925'/%3E %3Cpath d='M282.63 234.925C282.679 234.868 282.655 234.776 282.578 234.712 282.499 234.651 282.394 234.648 282.345 234.709 282.297 234.765 282.319 234.861 282.397 234.921 282.475 234.982 282.58 234.982 282.63 234.925z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M283.204 235.582L283.417 235.788C283.47 235.837 283.552 235.856 283.598 235.816 283.643 235.781 283.637 235.71 283.586 235.66L283.376 235.451 283.158 235.237C283.106 235.188 283.024 235.174 282.978 235.213 282.93 235.244 282.937 235.323 282.993 235.372L283.204 235.582'/%3E %3Cpath d='M283.204 235.582L283.417 235.788C283.47 235.837 283.552 235.856 283.598 235.816 283.643 235.781 283.637 235.71 283.586 235.66L283.376 235.451 283.158 235.237C283.106 235.188 283.024 235.174 282.978 235.213 282.93 235.244 282.937 235.323 282.993 235.372L283.204 235.582' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M284.151 236.391C284.201 236.331 284.178 236.239 284.1 236.175 284.021 236.114 283.916 236.111 283.867 236.172 283.818 236.232 283.841 236.324 283.92 236.388 283.998 236.445 284.104 236.449 284.151 236.391'/%3E %3Cpath d='M284.151 236.391C284.201 236.331 284.178 236.239 284.1 236.175 284.021 236.114 283.916 236.111 283.867 236.172 283.818 236.232 283.841 236.324 283.92 236.388 283.998 236.445 284.104 236.449 284.151 236.391z' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M281.402 230.355L280.811 230.373 280.696 231.243 280.759 231.381 280.913 231.371 281.67 230.862 281.402 230.355' fill='%23c8b100'/%3E %3Cpath d='M281.402 230.355L280.811 230.373 280.696 231.243 280.759 231.381 280.913 231.371 281.67 230.862 281.402 230.355' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M279.8 230.838L279.783 231.381 280.703 231.495 280.846 231.434 280.834 231.285 280.298 230.571 279.8 230.838' fill='%23c8b100'/%3E %3Cpath d='M279.8 230.838L279.783 231.381 280.703 231.495 280.846 231.434 280.834 231.285 280.298 230.571 279.8 230.838' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M281.7 231.921L281.209 232.194 280.672 231.478 280.661 231.332 280.804 231.271 281.727 231.381 281.7 231.921' fill='%23c8b100'/%3E %3Cpath d='M281.7 231.921L281.209 232.194 280.672 231.478 280.661 231.332 280.804 231.271 281.727 231.381 281.7 231.921' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M280.51 231.25C280.594 231.118 280.77 231.076 280.904 231.157 281.039 231.232 281.084 231.399 281.003 231.527 280.919 231.658 280.744 231.697 280.609 231.623 280.474 231.545 280.429 231.378 280.51 231.25' fill='%23c8b100'/%3E %3Cpath d='M280.51 231.25C280.594 231.118 280.77 231.076 280.904 231.157 281.039 231.232 281.084 231.399 281.003 231.527 280.919 231.658 280.744 231.697 280.609 231.623 280.474 231.545 280.429 231.378 280.51 231.25z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M278.36 230.352C278.345 230.355 278.231 229.894 278.104 229.638 278.018 229.453 277.714 229.212 277.714 229.212 277.744 229.155 278.127 229.017 278.584 229.304 278.955 229.61 278.554 230.171 278.554 230.171 278.554 230.171 278.456 230.306 278.363 230.352' fill='%23c8b100'/%3E %3Cpath d='M278.36 230.352C278.345 230.355 278.231 229.894 278.104 229.638 278.018 229.453 277.714 229.212 277.714 229.212 277.744 229.155 278.127 229.017 278.584 229.304 278.955 229.61 278.554 230.171 278.554 230.171 278.554 230.171 278.456 230.306 278.363 230.352L278.36 230.352z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M279.393 230.664L278.974 231.026 278.291 230.433 278.351 230.348 278.375 230.202 279.3 230.134 279.393 230.664' fill='%23c8b100'/%3E %3Cpath d='M279.393 230.664L278.974 231.026 278.291 230.433 278.351 230.348 278.375 230.202 279.3 230.134 279.393 230.664' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M278.236 230.294C278.288 230.145 278.419 230.057 278.524 230.089 278.628 230.127 278.671 230.273 278.621 230.419 278.569 230.568 278.438 230.653 278.333 230.625 278.224 230.585 278.183 230.44 278.236 230.294' fill='%23c8b100'/%3E %3Cpath d='M278.236 230.294C278.288 230.145 278.419 230.057 278.524 230.089 278.628 230.127 278.671 230.273 278.621 230.419 278.569 230.568 278.438 230.653 278.333 230.625 278.224 230.585 278.183 230.44 278.236 230.294z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M283.668 231.772L283.079 231.708 282.832 232.557 282.878 232.702 283.032 232.706 283.856 232.304 283.668 231.772' fill='%23c8b100'/%3E %3Cpath d='M283.668 231.772L283.079 231.708 282.832 232.557 282.878 232.702 283.032 232.706 283.856 232.304 283.668 231.772' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M282.007 232.034L281.914 232.571 282.806 232.805 282.956 232.762 282.967 232.617 282.543 231.832 282.007 232.034' fill='%23c8b100'/%3E %3Cpath d='M282.007 232.034L281.914 232.571 282.806 232.805 282.956 232.762 282.967 232.617 282.543 231.832 282.007 232.034' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M283.732 233.355L283.204 233.565 282.78 232.783 282.791 232.634 282.941 232.595 283.833 232.83 283.732 233.355' fill='%23c8b100'/%3E %3Cpath d='M283.732 233.355L283.204 233.565 282.78 232.783 282.791 232.634 282.941 232.595 283.833 232.83 283.732 233.355' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M282.652 232.539C282.75 232.418 282.934 232.408 283.054 232.5 283.178 232.592 283.196 232.762 283.099 232.88 282.997 232.997 282.817 233.011 282.693 232.918 282.574 232.827 282.55 232.656 282.652 232.539' fill='%23c8b100'/%3E %3Cpath d='M282.652 232.539C282.75 232.418 282.934 232.408 283.054 232.5 283.178 232.592 283.196 232.762 283.099 232.88 282.997 232.997 282.817 233.011 282.693 232.918 282.574 232.827 282.55 232.656 282.652 232.539z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M285.645 233.608L285.752 234.165 284.879 234.456 284.725 234.425 284.707 234.279 285.071 233.472 285.645 233.608' fill='%23c8b100'/%3E %3Cpath d='M285.645 233.608L285.752 234.165 284.879 234.456 284.725 234.425 284.707 234.279 285.071 233.472 285.645 233.608' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M285.487 235.202L284.929 235.326 284.62 234.495 284.655 234.353 284.809 234.332 285.66 234.68 285.487 235.202' fill='%23c8b100'/%3E %3Cpath d='M285.487 235.202L284.929 235.326 284.62 234.495 284.655 234.353 284.809 234.332 285.66 234.68 285.487 235.202' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M283.972 233.66L283.792 234.176 284.644 234.52 284.8 234.499 284.83 234.357 284.527 233.53 283.972 233.66' fill='%23c8b100'/%3E %3Cpath d='M283.972 233.66L283.792 234.176 284.644 234.52 284.8 234.499 284.83 234.357 284.527 233.53 283.972 233.66' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M284.914 234.627C285.029 234.52 285.033 234.35 284.929 234.239 284.82 234.133 284.635 234.126 284.52 234.225 284.407 234.332 284.4 234.499 284.509 234.613 284.613 234.723 284.798 234.726 284.914 234.627' fill='%23c8b100'/%3E %3Cpath d='M284.914 234.627C285.029 234.52 285.033 234.35 284.929 234.239 284.82 234.133 284.635 234.126 284.52 234.225 284.407 234.332 284.4 234.499 284.509 234.613 284.613 234.723 284.798 234.726 284.914 234.627z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M286.289 236.43C286.286 236.445 286.788 236.456 287.077 236.519 287.283 236.562 287.602 236.793 287.602 236.793 287.658 236.751 287.715 236.37 287.321 236.005 286.927 235.724 286.435 236.218 286.435 236.218 286.435 236.218 286.316 236.335 286.289 236.43' fill='%23c8b100'/%3E %3Cpath d='M286.289 236.43C286.286 236.445 286.788 236.456 287.077 236.519 287.283 236.562 287.602 236.793 287.602 236.793 287.658 236.751 287.715 236.37 287.321 236.005 286.927 235.724 286.435 236.218 286.435 236.218 286.435 236.218 286.316 236.335 286.289 236.43z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M285.749 235.535L285.461 236.001 286.218 236.512 286.311 236.43 286.435 236.388 286.319 235.514 285.749 235.535' fill='%23c8b100'/%3E %3Cpath d='M285.749 235.535L285.461 236.001 286.218 236.512 286.311 236.43 286.435 236.388 286.319 235.514 285.749 235.535' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M286.372 236.533C286.51 236.456 286.578 236.314 286.522 236.225 286.461 236.132 286.301 236.121 286.162 236.2 286.023 236.281 285.956 236.416 286.016 236.512 286.071 236.601 286.233 236.612 286.372 236.533' fill='%23c8b100'/%3E %3Cpath d='M286.372 236.533C286.51 236.456 286.578 236.314 286.522 236.225 286.461 236.132 286.301 236.121 286.162 236.2 286.023 236.281 285.956 236.416 286.016 236.512 286.071 236.601 286.233 236.612 286.372 236.533z' fill='none' stroke='%23000' stroke-width='0.26'/%3E %3Cpath d='M326.132 213.644L326.132 214.223 323.597 214.223 323.597 213.644 324.535 213.644 324.535 212.337 323.916 212.337 323.916 211.755 324.535 211.755 324.535 211.184 325.146 211.184 325.146 211.755 325.756 211.755 325.756 212.337 325.146 212.337 325.146 213.644 326.132 213.644' fill='none' stroke='%23000' stroke-width='0.3'/%3E %3Cpath d='M175.435 226.15L175.435 224.883' fill='none' stroke='%23000' stroke-width='0.02'/%3E %3Cpath d='M175.091 226.15L175.091 224.883' fill='none' stroke='%23000' stroke-width='0.03'/%3E %3Cpath d='M174.766 226.15L174.766 224.883' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M174.443 226.15L174.443 224.883' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M174.156 226.15L174.156 224.883' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M173.609 226.082L173.601 224.928M173.868 226.097L173.868 224.89' fill='none' stroke='%23000' stroke-width='0.06'/%3E %3Cpath d='M173.103 226.03L173.103 224.967M173.359 226.06L173.352 224.929' fill='none' stroke='%23000' stroke-width='0.07'/%3E %3Cpath d='M172.425 225.969L172.425 225.035M172.648 225.984L172.648 225.005M172.877 226.015L172.877 224.997' fill='none' stroke='%23000' stroke-width='0.08'/%3E %3Cpath d='M172.187 225.962L172.187 225.058' fill='none' stroke='%23000' stroke-width='0.09'/%3E %3Cpath d='M171.966 225.916L171.966 225.073' fill='none' stroke='%23000' stroke-width='0.1'/%3E %3Cpath d='M171.728 225.893L171.728 225.111' fill='none' stroke='%23000' stroke-width='0.11'/%3E %3Cpath d='M171.242 225.825L171.234 225.202M171.491 225.855L171.491 225.157' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M170.992 225.772L170.992 225.225' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M170.764 225.727L170.764 225.272' fill='none' stroke='%23000' stroke-width='0.13'/%3E %3Cpath d='M170.514 225.667L170.514 225.31' fill='none' stroke='%23000' stroke-width='0.14'/%3E %3Cpath d='M170.258 225.637L170.258 225.371' fill='none' stroke='%23000' stroke-width='0.15'/%3E %3Cpath d='M169.987 225.576L169.987 225.447' fill='none' stroke='%23000' stroke-width='0.18'/%3E %3Cpath d='M176.805 226.082L176.805 224.921M176.221 226.12L176.229 224.89M175.796 226.135L175.796 224.883' fill='none' stroke='%23000' stroke-width='0.01'/%3E %3Cpath d='M324.768 226.172L324.768 224.904' fill='none' stroke='%23000' stroke-width='0.02'/%3E %3Cpath d='M324.424 226.172L324.424 224.904' fill='none' stroke='%23000' stroke-width='0.03'/%3E %3Cpath d='M324.099 226.172L324.099 224.904' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M323.777 226.172L323.777 224.904' fill='none' stroke='%23000' stroke-width='0.04'/%3E %3Cpath d='M323.49 226.172L323.49 224.904' fill='none' stroke='%23000' stroke-width='0.05'/%3E %3Cpath d='M322.942 226.103L322.934 224.949M323.202 226.118L323.202 224.912' fill='none' stroke='%23000' stroke-width='0.06'/%3E %3Cpath d='M322.436 226.051L322.436 224.988M322.693 226.082L322.685 224.95' fill='none' stroke='%23000' stroke-width='0.07'/%3E %3Cpath d='M321.758 225.991L321.758 225.057M321.981 226.006L321.981 225.026M322.21 226.036L322.21 225.019' fill='none' stroke='%23000' stroke-width='0.08'/%3E %3Cpath d='M321.521 225.983L321.521 225.08' fill='none' stroke='%23000' stroke-width='0.09'/%3E %3Cpath d='M321.299 225.938L321.299 225.095' fill='none' stroke='%23000' stroke-width='0.1'/%3E %3Cpath d='M321.061 225.915L321.061 225.133' fill='none' stroke='%23000' stroke-width='0.11'/%3E %3Cpath d='M320.575 225.846L320.567 225.224M320.824 225.877L320.824 225.178' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M320.325 225.793L320.325 225.246' fill='none' stroke='%23000' stroke-width='0.12'/%3E %3Cpath d='M320.097 225.749L320.097 225.294' fill='none' stroke='%23000' stroke-width='0.13'/%3E %3Cpath d='M319.847 225.688L319.847 225.332' fill='none' stroke='%23000' stroke-width='0.14'/%3E %3Cpath d='M319.591 225.658L319.591 225.392' fill='none' stroke='%23000' stroke-width='0.15'/%3E %3Cpath d='M319.32 225.597L319.32 225.468' fill='none' stroke='%23000' stroke-width='0.18'/%3E %3Cpath d='M326.138 226.103L326.138 224.942M325.555 226.141L325.562 224.912M325.13 226.156L325.13 224.904' fill='none' stroke='%23000' stroke-width='0.01'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E %3Crect width='1000' height='500' fill='%23ea0437'/%3E %3Cpath d='M 0,500 H 1000 V 250' fill='%234189dd'/%3E %3Cpath d='M 0,0 H 1000 V 250' fill='%2312ad2b'/%3E %3Cpath d='m 230.24958,369.16163 c -10.81019,2.98487 -17.00779,11.37176 -16.84908,19.28459 l 53.21067,-.21363 c .47814,-8.50288 -6.51706,-16.36688 -17.16651,-19.46365 52.09769,-1.07633 97.35688,-20.59084 105.581,-33.1122 -8.13867,-3.53218 -17.549,2.15268 -24.25731,.84438 15.92738,-7.36142 63.64648,-38.2477 55.88829,-71.3599 -6.03077,18.39137 -24.30006,33.60865 -32.08062,37.69427 17.82572,-27.0672 42.16648,-55.24736 21.04864,-77.06919 1.06617,12.64749 -8.03695,26.56668 -12.05744,27.61248 10.34017,-28.59929 20.20628,-64.50713 -2.19744,-88.17848 2.94212,8.55578 1.75387,32.69103 -2.29716,33.77551 -1.24724,-19.44736 -4.56579,-60.35236 -25.04676,-59.77044 6.50483,5.79067 9.35132,21.59597 9.49579,37.55999 -4.66752,-10.93635 -9.97191,-19.17065 -21.31722,-27.24625 -9.1784,-17.60192 -25.50865,-32.18643 -41.84094,-42.63446 1.83323,12.81231 3.3511,22.92055 21.2399,36.20897 -9.32691,-.57988 -18.65181,-18.26115 -28.61965,-18.75151 -7.9291,-.38252 -14.15112,7.18442 -27.10788,2.83023 1.43443,4.27687 7.47944,6.17115 8.75516,9.33506 -2.77528,1.91666 -9.36353,-.2991 -14.84086,-3.1517 7.53437,10.26287 19.2093,16.29769 29.12018,14.26099 11.78683,-2.26662 24.42417,-1.0682 36.47755,5.79067 -3.07847,1.58094 -15.06063,1.57076 -22.74963,.60837 6.98908,7.07657 11.67696,11.76649 23.83003,11.68917 10.85496,-.0712 16.54593,-5.79067 19.33342,-2.24831 6.80802,8.06746 11.39008,16.13085 17.08512,25.62869 -12.58035,1.38968 -8.78773,-14.22843 -22.79846,-22.21654 -7.87213,16.29363 9.05427,35.60873 20.57661,43.63753 .15464,12.24667 1.94515,22.49328 7.13964,31.81816 3.50167,6.57402 8.02882,13.30267 6.32173,28.13947 -6.89753,-5.0236 -13.63838,-21.96628 -11.15813,-35.41544 -8.6331,2.35412 -12.00862,17.53477 -7.93928,25.177 3.0398,5.81712 5.06836,16.95083 1.56263,21.92763 -3.41621,4.63701 -3.77431,4.11816 -3.72955,14.06973 .12208,5.95547 -3.2046,12.99747 -8.62293,17.90712 1.13128,-4.19549 2.42126,-11.4145 1.1679,-15.9274 -4.28297,7.26581 -15.02806,14.78391 -18.41171,22.59501 -3.32262,7.82941 -4.16498,21.39048 -20.24496,24.51776 -20.68648,4.10597 -27.82614,7.69106 -41.13694,13.13786 -1.47717,-10.11027 2.94416,-31.19351 11.39822,-29.99103 8.25464,1.46904 33.28107,-8.62292 24.32853,-29.70616 -1.76813,6.64524 -7.66663,13.12972 -14.04328,13.41661 6.88939,-8.9383 19.18489,-18.19401 13.19686,-33.17121 -3.32872,6.36648 -8.56392,14.00667 -16.5032,18.30592 8.51101,-16.30991 .98885,-21.18904 -9.11736,-7.75616 -3.81704,5.1823 -6.12232,15.56724 -8.54765,28.75598 -3.96963,-10.72678 -3.70716,-24.84738 -8.41131,-36.31274 -4.91373,-12.39928 6.52111,-15.67305 11.90282,-14.67811 13.17651,3.51795 35.19773,3.51591 33.56185,-18.25301 -5.69096,7.36346 -15.67102,9.63823 -26.44865,6.98704 12.10424,-8.83859 21.66109,-25.46387 8.17326,-34.14377 -.44966,9.20485 -7.57304,19.52469 -17.08309,24.27768 -2.22592,-7.76634 -2.22592,-16.00879 -.3174,-25.04475 -5.31048,5.58923 -9.18856,17.2194 -12.27312,30.44068 -.23196,-13.06868 2.24017,-22.48513 4.0734,-29.51491 2.77936,-10.26897 9.68706,-3.58712 20.26124,-2.83022 10.18352,.57784 24.20443,-5.05005 21.52476,-18.85935 -3.47724,5.46309 -10.61486,7.58932 -17.90712,7.01148 8.7796,-5.31863 24.07624,-14.76967 15.6873,-29.30738 -3.52405,5.50581 -4.6655,10.21606 -14.8653,11.90485 2.67152,-6.14471 3.11509,-14.83274 11.03199,-18.27539 -14.12264,-2.81192 -22.20842,6.456 -26.31845,20.97132 -1.6664,-10.06347 -3.65019,-13.7686 -4.04493,-21.13003 7.63408,-8.47848 8.43371,-25.06509 -8.0939,-28.7743 -.98072,8.55579 -.68976,10.59453 1.19027,17.56123 -7.75819,-4.60852 -18.6925,-7.15186 -25.97254,-.63481 4.93203,5.3227 12.56611,10.00854 24.3326,4.20363 -2.77936,9.09292 -10.00854,7.53641 -19.94179,4.06932 6.07146,11.40432 13.73402,13.43087 22.1901,12.11647 4.42744,11.67289 4.62277,20.54201 -8.3157,37.54168 .59819,-10.564 -.15259,-18.43411 -8.5456,-26.97565 -7.19256,-7.04402 -13.03816,.30114 -1.79865,15.96198 -6.81818,-5.02156 -14.53567,-15.21321 -16.85927,-25.40284 -2.2483,12.58849 -.22381,27.42531 6.74493,35.74304 -3.29616,3.522 -7.04403,-.37439 -12.5885,-8.99122 2.09775,27.57587 13.8622,32.89653 29.67362,26.74981 .44966,15.13589 .44966,29.1507 1.34898,47.43424 -9.21908,-13.26199 -20.90623,-23.15455 -27.42733,-25.62667 -2.02247,7.41841 5.62179,17.08308 9.89256,22.47902 -6.51909,-1.34898 -20.68242,-12.13883 -20.68242,-12.13883 -1.42427,12.28941 14.46447,23.67949 24.72938,28.77429 -12.06357,-.52495 -17.38626,-5.0948 -25.17904,-12.5885 .15057,34.09496 36.94145,28.17406 43.83694,22.92869 .89933,16.78601 2.18117,36.19065 3.0805,52.97669 -10.40123,-1.81493 -9.5833,-4.94223 -18.48295,-5.76626 -24.70088,-.9624 -44.29473,-29.65123 -50.78329,-50.75482 -1.86173,3.47317 -.38456,7.10709 -2.08757,11.3738 -4.01034,-10.3585 -9.13363,-23.73645 -16.00471,-29.96253 1.74981,6.03889 1.93497,12.17545 1.3266,23.46176 -2.35818,-7.31259 -4.55155,-9.5548 -4.71026,-18.13907 .15057,-6.59029 6.35834,-11.45316 6.01449,-20.72311 -.25434,-6.76731 -6.42752,-21.43525 -7.33499,-32.79073 -2.98893,11.68715 -4.86489,24.00707 -9.44289,31.24235 2.27476,-12.48066 1.54553,-21.09341 5.3939,-29.49253 4.44575,-8.84267 8.22617,-16.73718 5.26573,-25.66125 -2.83837,3.44674 -1.86173,6.57808 -8.99304,14.95279 -1.54899,-9.10719 9.22092,-23.68356 19.67301,-29.5434 7.37162,-3.88419 16.66394,-17.77691 10.6108,-27.29915 -6.93211,4.97883 -10.04516,11.70544 -19.83802,23.1993 6.98502,-27.30527 25.13426,-34.44899 46.8625,-34.54258 4.80792,-.0224 14.50109,-1.75796 17.22144,-8.12037 -6.12435,2.36429 -13.36574,2.66542 -19.80954,1.37544 4.68991,-6.88532 14.5662,-5.99007 23.769,-6.03076 7.219,-.0346 18.48904,-1.01327 23.04467,-11.29445 -8.80605,3.815 -22.54007,4.60853 -31.18741,1.90648 13.75232,-7.12541 35.29336,-7.89248 46.34162,-17.24382 -12.59256,-9.39813 -44.10349,2.18931 -64.00661,15.8399 5.56278,-5.08667 14.35457,-14.11043 19.20523,-21.39454 -10.88547,-5.21893 -38.41454,25.27873 -47.89814,43.39949 -9.00748,5.08666 -12.61088,13.06054 -16.10848,18.62537 4.79979,-16.21836 5.30845,-27.98688 9.31268,-41.34245 -30.87691,10.62911 -18.04263,67.6792 -24.75887,81.32776 .79047,-15.06877 .15036,-34.42661 -6.05355,-44.40869 -9.51045,7.25563 -10.27792,49.95927 -1.34898,85.51104 -3.22434,-9.51411 -9.31004,-18.39545 -11.2625,-29.97475 -14.075438,25.67142 8.25119,55.95747 26.9207,79.8811 -14.05509,-7.32073 -27.95188,-23.06704 -37.08022,-36.26796 2.51954,45.94689 50.5009,55.49356 57.94982,66.78596 -10.11027,-4.70617 -29.43881,-14.01886 -37.64056,-4.26059 13.3519,3.08253 24.00218,6.64523 32.58441,12.27109 12.45217,15.54691 36.03195,22.34677 77.09767,24.06403 z' fill='%23ffc726'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='600' height='300'%3E %3Crect width='600' height='150' fill='%23000'/%3E %3Crect y='150' width='600' height='150' fill='%23007a3d'/%3E %3Crect y='100' width='600' height='100' fill='%23fff'/%3E %3Cpath d='M 0,0 200,150 0,300 z' fill='%23c4111b'/%3E %3Ccircle cx='300' cy='150' r='40' fill='%23c4111b'/%3E %3Ccircle cx='315' cy='150' r='40' fill='%23fff'/%3E %3Cpath d='m 289.26294,174.2204 17.05633,-12.19273 16.92296,12.37709 -6.32527,-19.98928 17.00081,-12.26999 -20.96556,-0.16131 -6.41591,-19.96036 -6.63215,19.88957 -20.96606,-0.0661 16.86669,12.45373 -6.54184,19.91946 z' fill='%23c4111b'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23000'/%3E %3Crect width='900' height='400' fill='%23fff'/%3E %3Crect width='900' height='200' fill='%23ce1126'/%3E %3Cg fill='%23fff' stroke='%23c09300'%3E %3Cpath stroke-width='1.2703' stroke-linejoin='round' d='m450.81,302.4,68.488,63.579-4.8759-115.47c-0.71638-17.5-15.924-13.485-26.971-7.1723-11.191,7.1723-23.958,7.1723-37.446,2.437-13.485,4.7353-26.253,4.7353-37.444-2.437-11.046-6.3123-26.252-10.328-26.97,7.1723l-4.8789,115.47,70.098-63.579z'/%3E %3Cg id='w' fill='%23c09300' stroke='none'%3E %3Cpath d='m393.47,246.49-4.7342,112.32-8.0347,7.168,4.8784-115.47c2.2949-1.5782,6.3132-4.0171,7.8905-4.0171z'/%3E %3Cpath d='m403.09,254.53-4.0171,93.955-8.0323,8.2204,4.8772-108.49c1.5791,1.577,6.3138,5.4498,7.1721,6.3104z'/%3E %3Cpath d='m411.84,261.7-3.1545,78.362-6.4556,6.3092,4.0177-89.405c1.5748,1.5782,4.7311,3.8734,5.5924,4.7334z'/%3E %3Cpath d='m421.31,265.72-3.1563,66.787-6.3132,5.1193,3.1563-74.344c1.5791,0.71638,4.7348,2.4376,6.3132,2.4376z'/%3E %3Cpath d='m430.06,265.72-2.2974,55.657-6.4544,6.3129,2.4392-61.252c1.576-0.00061,5.5937-0.00061,6.3126-0.7182z'/%3E %3C/g%3E %3Cuse xlink:href='%23w' transform='matrix(-1,0,0,1,900,0)'/%3E %3Cpath fill='%23c09300' stroke-width='1.0739' d='m453.16,315.06,9.6126,43.755-3.1575,3.1552-3.2993-2.4388-5.4518-39.018,2.2955,39.018-3.1569,4.0158-3.1563-4.0158,2.2962-39.018-5.4506,39.018-3.3024,2.4388-3.1545-3.1552,9.6113-43.755h6.3138z'/%3E %3Cg id='b' fill='none' stroke-width='1.2705' stroke-linejoin='round'%3E %3Cpath fill='%23fff' stroke-width='1.1888' d='m428.48,295.84-19.08,67.705,26.255,4.0177,11.188-50.924-18.363-20.799z'/%3E %3Cpath d='m422.17,318.94,2.2955,5.5928,12.405-11.848'/%3E %3Cpath d='m430.76,304.92,2.5957,24.346,7.8905-10.328'/%3E %3Cpath d='m438.09,322.95,4.31,14.875'/%3E %3Cpath d='m444.09,332.36-8.7177,13.241m2.7189,13.216-2.7902-13.198-2.4356-13.423-5.8406,7.9091-2.5613-9.1191-8.1747,8.3847,4.1575,15.251,5.7375-9.4349,3.1557,9.6123,5.8903-9.1621'/%3E %3Cpath d='m414.99,361.97,5.2997-7.4437,3.4528,11.457,4.7342-8.0323,3.1575,9.6136'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(-1,0,0,1,900,0)'/%3E %3Cg stroke-width='1.2705' stroke-linejoin='round' stroke-linecap='round'%3E %3Cpath stroke-width='2.3777' stroke-linejoin='round' d='m450,393.81c19.943,0,39.024-1.5776,50.213-4.734,4.7354-0.8588,4.7354-3.2976,4.7354-6.4553,4.7354-1.5776,2.2949-7.1704,5.5943-7.1704-3.2994,0.86244-4.0158-5.5941-8.0329-4.7316,0-5.5965-5.5955-6.3129-10.33-4.7377-9.4695,3.1576-26.255,3.8752-42.18,3.8752-15.924-0.71758-32.567-0.71758-42.179-3.8752-4.7342-1.5752-10.327-0.85881-10.327,4.7377-4.0183-0.86245-4.7354,5.5941-8.0341,4.7316,3.2988,0,0.85954,5.5928,5.5943,7.1704,0,3.1576,0,5.5965,4.8778,6.4553,11.045,3.1564,30.128,4.734,50.068,4.734z'/%3E %3Cpath d='m422.89,363.54c6.4544,0.86123,13.628,1.5776,19.225,0.86123,3.1533,0,5.4494,5.4504-0.86257,6.3129-5.5931,0.71515-14.345,0-19.08-0.86245-4.0171-0.71759-12.768-2.2946-18.364-3.8752-5.5949-2.4364-1.576-7.168,1.5772-6.4522,4.879,1.577,11.192,3.1564,17.505,4.0158z'/%3E %3Cpath d='m477.12,363.54c-6.4569,0.86123-13.628,1.5776-19.081,0.86123-3.3006,0-5.5961,5.4504,0.71711,6.3129,5.5955,0.71515,14.347,0,19.078-0.86245,4.0189-0.71759,12.769-2.2946,18.364-3.8752,5.5967-2.4364,1.5803-7.168-1.5772-6.4522-4.8778,1.577-11.19,3.1564-17.501,4.0158z'/%3E %3Cpath d='m403.09,360.39c-4.8771-0.86123-7.1723,4.7316-5.5928,7.8868,0.71637-1.5776,4.0164-1.5776,4.7346-3.1552,0.8582-2.437-0.7182-2.437,0.8582-4.7316z'/%3E %3Cpath d='m422.17,375.06c0-3.1528,3.1545-2.7651,3.1545-5.9215,0-1.577-0.85893-4.0171-2.4368-4.0171-1.5785,0-3.1575,1.5776-3.1575,3.1552-0.7177,3.157,2.4398,3.6312,2.4398,6.7834z'/%3E %3Cpath d='m444.88,365.98c4.7305,0,4.2618,6.3141,1.9656,9.4699,0-2.2952-4.0164-3.1558-4.0164-4.7316,0-2.4419,3.6262-2.4419,2.0508-4.7383z'/%3E %3Cpath d='m496.91,360.39c4.8777-0.86123,7.1741,4.7316,5.5953,7.8868-0.71819-1.5776-4.017-1.5776-4.734-3.1552-0.86124-2.437,0.71759-2.437-0.86124-4.7316z'/%3E %3Cpath d='m477.83,375.06c0-3.1528-3.1532-2.7651-3.1532-5.9215,0-1.577,0.85953-4.0171,2.438-4.0171,1.5772,0,3.1563,1.5776,3.1563,3.1552,0.71771,3.157-2.441,3.6312-2.441,6.7834z'/%3E %3Cpath d='m455.12,365.98c-4.7323,0-4.263,6.3141-1.9674,9.4699,0-2.2952,4.0158-3.1558,4.0158-4.7316,0.00061-2.4419-3.6262-2.4419-2.0484-4.7383z'/%3E %3Cg stroke-width='0.8915'%3E %3Cpath d='m404.67,361.97c1.58,0,4.0177,0.71758,4.7353,1.577l-4.74-1.58z'/%3E %3Cpath d='m412.55,364.41c0.86184,0,4.0183,0.71639,5.5959,1.5752l-5.6-1.58z'/%3E %3Cpath d='m441.25,367.56c-1.5776,0-4.734,0-5.5928,0.71516l5.59-0.72z'/%3E %3Cpath d='m432.5,367.56c-0.8588-0.86245-4.0165-0.86245-5.5935,0h5.59z'/%3E %3Cpath d='m495.34,361.97c-1.5776,0-3.8746,0.71758-4.7353,1.577l4.7353-1.577z'/%3E %3Cpath d='m487.45,364.41c-0.86002,0-4.0171,0.71639-5.5953,1.5752l5.6-1.58z'/%3E %3Cpath d='m458.75,367.56c1.5794,0,4.7352,0,5.5953,0.71516l-5.6-0.72z'/%3E %3Cpath d='m467.5,367.56c0.86002-0.86245,4.0183-0.86245,5.5953,0h-5.6z'/%3E %3C/g%3E %3Cg fill='%23c09300' stroke='none'%3E %3Cpath d='m403.34,374.58c-0.53406-0.10208-0.81452-0.52459-0.68011-1.0246,0.16371-0.609,0.65161-0.95739,1.1126-0.79442,0.29312,0.10362,0.82973,0.64469,0.83184,0.83874,0.003,0.22275-0.28059,0.75257-0.40266,0.75379-0.0527,0.00053-0.1342,0.0465-0.18122,0.10201-0.10001,0.11816-0.41341,0.17549-0.68041,0.12446z'/%3E %3Cpath d='m458.27,378.5c-0.19869-0.0736-0.51521-0.5185-0.51485-0.72377,0.002-0.38717,0.57418-1.0178,0.92881-1.0214,0.17516-0.001,0.65475,0.2481,0.83411,0.43462,0.32504,0.33789,0.25419,0.89278-0.15423,1.2079-0.20096,0.15505-0.80025,0.21125-1.0938,0.1026z'/%3E %3Cpath d='m458.63,380.98c-0.42018-0.14209-0.57388-0.34776-0.60803-0.8136-0.0355-0.4854,0.0116-0.56097,0.52453-0.84064l0.36556-0.19931,0.34646,0.1545c0.47988,0.21397,0.69338,0.44463,0.71031,0.76742,0.0182,0.34768-0.2397,0.70345-0.64012,0.8829-0.35162,0.15758-0.37253,0.15904-0.69871,0.0488z'/%3E %3Cpath d='m407.75,370.09c-0.34619-0.0109-0.82136,0.30729-1.0938,0.46875-0.64912,0.15215-1.4047,0.5511-2.0312,0.125-0.61719-0.19079-1.438-0.0404-1.5312,0.71875,0.15839,0.65179,1.0715,1.0243,1.625,0.59375,0.4106-0.53758,1.5312-0.8528,1.6562,0.0625-0.45705,0.69215-0.40489,1.6089-0.78125,2.3438-0.0612,0.45773-0.25176,0.8924-0.5,1.2812-0.4621,0.0464-0.95375-0.008-1.3438,0.28125-0.62601,0.0342-1.2647,0.34537-1.625,0.875-0.40338,0.57818-0.78869,1.1654-0.90625,1.875,0.10725,0.72494,0.93754,0.93275,1.5625,0.96875,0.66694,0.18359,1.3344,0.42433,2,0.625,1.0853,0.24303,2.102,0.63539,3.1875,0.875,1.5844,0.47758,3.2479,0.69739,4.8438,1.125,0.16722,0.0555,0.32405,0.1038,0.5,0.125,0.66233,0.13773,1.0079-0.58289,1.0625-1.125,0.32864-1.1596,0.57948-2.3391,0.90625-3.5,0.22487-0.46559,0.49645-1.5172-0.40625-1.2812-0.51485,0.30872-0.95182,0.7734-1.5938,0.8125-0.87392,0.0509-0.37513,0.94518-0.0312,1.3125,0.0759,0.5872-0.10989,1.2888-0.5,1.75-0.51994,0.32957-1.1716-0.0561-1.7188-0.1875-0.57469,0.01-1.7234-0.28325-1.1875-1.0625,0.19033-0.57691,0.20718-1.2083,0.4375-1.7812,0.29353-0.61455,0.33553-1.2851,0.46875-1.9375-0.36122-0.77733-0.97856,0.25585-1.4688,0.34375-0.33769,0.23455-1.6054,0.33418-0.9375,0.9375,0.57518,0.43696,0.1343,1.1967,0.0312,1.75-0.0369,0.77025-0.83781,0.95394-1.4688,0.78125-0.62768-0.0303-1.5013-0.49748-0.96875-1.1875,0.12115-0.57512,0.322-1.1402,0.4375-1.7188,0.2374-0.69777,0.43732-1.3628,0.6875-2.0625,0.10851-0.61996,0.33113-1.2079,0.625-1.75,0.0173-0.68543,0.47775-1.2752,0.46875-1.9688-0.0469-0.33876-0.19853-0.4622-0.40625-0.46875zm-3.5938,7.25c0.0817-0.0141,0.1399-0.002,0.21875,0.0312,0.24971,0.10625,0.25708,0.30938,0,0.53125-0.11238,0.097-0.23995,0.1905-0.28125,0.1875-0.46771-0.0402-0.6056-0.10974-0.625-0.28125-0.0172-0.15117,0.0307-0.19455,0.34375-0.34375,0.15556-0.0742,0.26207-0.11086,0.34375-0.125z'/%3E %3Cpath d='m403.12,382.36c-0.49596-0.46627-0.41621-0.80642,0.31729-1.3532,0.31384-0.23393,0.50421-0.20747,0.8631,0.11997,0.55237,0.50393,0.57448,0.82295,0.0869,1.2548-0.24101,0.21344-0.34645,0.25721-0.62697,0.26001-0.29347,0.003-0.3766-0.0334-0.64036-0.28155z'/%3E %3Cpath d='m406.17,383.28c-0.48488-0.11955-0.76441-0.60787-0.62254-1.0876,0.12852-0.43459,0.20285-0.47736,0.84026-0.48378,0.71478-0.007,0.85352,0.11244,0.86039,0.74185,0.004,0.35432-0.0235,0.43652-0.19971,0.60041-0.2071,0.19261-0.6052,0.29644-0.8784,0.22908z'/%3E %3Cpath d='m495.28,383.36c-0.22701-0.18894-0.27272-0.27435-0.27532-0.51479-0.003-0.41064,0.23349-0.71172,0.74605-0.94382,0.68183-0.30882,0.95981-0.26636,1.2166,0.18575,0.34158,0.60129,0.32512,0.84675-0.0839,1.252-0.22578,0.22366-0.26805,0.2367-0.78493,0.2419-0.50756,0.003-0.56562-0.0105-0.8185-0.22102z'/%3E %3Cpath d='m410.22,384.51c-0.36389-0.0971-0.5525-0.37016-0.55726-0.80675-0.004-0.33383,0.0201-0.38706,0.25362-0.56985,0.15122-0.11834,0.39018-0.21971,0.57856-0.24541,0.2669-0.0365,0.36442-0.0132,0.57916,0.13775,0.55052,0.38698,0.66746,0.76972,0.3487,1.1412-0.33953,0.39572-0.66141,0.48753-1.2028,0.34303z'/%3E %3Cpath d='m432.14,385.49c-0.0807-0.10062-0.25916-0.16012-0.2775-0.287,0.032-0.55487,0.0585-1.1167,0.23525-1.6482,0.0962-0.52301,0.012-1.0692,0.19432-1.5787,0.18698-0.92682,0.18682-1.8826,0.40217-2.8036,0.01-0.47427,0.0549-0.949,0.19241-1.4054,0.15774-0.72168,0.0136-1.4762,0.22606-2.1894-0.0228-0.26786,0.28574-0.98321,0.55658-0.55944,0.39321,0.57645,0.91139,1.0451,1.4208,1.5153,0.43771,0.25252,0.0359,0.62445-0.26658,0.74975-0.41521,0.16364-0.51613,0.62086-0.48666,1.0222-0.0582,0.41455-0.22464,0.80685-0.24153,1.23-0.0878,0.62242-0.0706,1.2546-0.15153,1.8765-0.18211,0.60901-0.11244,1.2597-0.17323,1.8875,0.008,0.39859-0.18142,0.7606-0.15525,1.1604-0.0484,0.40592-0.0665,0.89432-0.40713,1.1724-0.32888,0.16605-0.80429,0.13737-1.0682-0.14228z'/%3E %3Cpath d='m461.84,375.69c-0.48222,0.36463-0.91353,0.79527-1.3438,1.2188-0.59251,0.4489,0.48677,0.70998,0.625,1.0938,0.15716,0.58638,0.1478,1.2106,0.1875,1.8125,0.17923,0.55142,0.25835,1.1384,0.21875,1.7188-0.0519,0.6223-0.86338,0.49115-1.2188,0.84375-0.49176,0.20722-0.68789,0.69047-1.0625,1.0312-0.24625,0.48275-0.31215,1.0763-0.34375,1.625,0.0353,0.44788-0.30248,0.94931,0,1.3438,0.039,0.0557,0.0852,0.132,0.125,0.1875,0.10115,0.1452,0.3425,0.0292,0.5,0.0625,0.50368-0.0282,1.0285,0.0473,1.5-0.15625,1.21-0.20943,2.4311-0.22605,3.6562-0.28125,0.74925,0.0239,1.4701-0.23695,2.2188-0.21875,0.58681,0.12974,0.85075-0.50626,0.84375-0.96875-0.33224-0.65359-0.045-1.4285-0.3125-2.0938-0.23494-0.67246-0.14236-1.428-0.25-2.125-0.0148-0.54835-0.71068-0.75172-1.0625-0.34375-0.34144,0.34514-0.89289,0.41403-1.1562,0.84375-0.29659,0.60239,0.62745,0.60317,0.78125,1.0625,0.17589,0.4642,0.11825,0.98059,0.15625,1.4688,0.11422,0.59237-0.52919,0.6262-0.9375,0.6875-0.53675,0.20112-1.29,0.33589-1.5938-0.3125-0.1909-0.47948-0.16475-0.99286-0.21875-1.5-0.0131-0.89182-0.22755-1.7684-0.28125-2.6562-0.0514-1.0968-0.2407-2.1866-0.3125-3.2812-0.01-0.45549-0.0706-1.198-0.71875-1.0625zm-0.625,8.25,0.3125,0.0312,0.0312,0.375,0.0312,0.375-0.40625,0.125c-0.21512,0.0636-0.40325,0.0943-0.40625,0.0937-0.003-0.00085-0.088-0.0531-0.1875-0.125-0.21959-0.1586-0.16345-0.38503,0.125-0.6875,0.1626-0.17028,0.23879-0.2033,0.5-0.1875z'/%3E %3Cpath d='m431.25,374.66c-0.38018,0.13504-0.86245,0.69313-1.25,0.6875-0.88,0.0623-0.75718,0.91919-0.125,1.2188,0.0833,0.25988,0.005,0.58789,0.0312,0.875,0.12288,0.7896-0.37535,1.4249-0.28125,2.2188-0.0442,0.87031-0.30695,1.7177-0.34375,2.5938-0.24704,0.90327-0.24984,1.8321-0.40625,2.75-0.10431,0.82323-0.69963,0.53271-1.2188,0.3125-0.004-0.35689-0.0272-0.70562-0.0312-1.0625,0.21637-0.81711-0.44101-1.0556-1.0938-1.1562-0.68611,0.0649-1.0228-0.52316-0.875-1.125,0.29488-0.35103,1.036-0.2534,1.5-0.3125,0.9813,0.20342,0.9416-1.1118,0.4375-1.5625-0.34472-0.63567-1.1982-0.90926-1.4375-1.5625,0.0956-0.86642-0.47971-1.7322-1.1875-2.1562-1.0885-0.0764-1.9104,0.86306-2.3125,1.7812-0.4525,0.13085-0.90391,0.26657-1.3438,0.4375-0.70889,0.17748-1.7197,1.407-0.75,1.875,0.54424,0.14988,2.2002,0.52782,1.4688,1.2812-0.41224,0.7071-1.201,0.71914-1.9062,0.53125-0.72365,0.00063-1.5294-0.35207-1.5-1.1875-0.14765-0.74985-0.12337-1.5579-0.46875-2.25-0.14847-0.83929-1.1008-0.64297-1.1562,0.125-0.73341,0.53403-0.6357,1.3978-0.125,2.0312,0.31876,0.72891,0.003,1.5776-0.3125,2.25-0.19091,0.87497-1.1559,0.90473-1.8438,1.1875-0.33751,0.13104-1.6285-0.0779-1.1562,0.65625,0.75312,0.26578,1.6525,0.50493,2.4375,0.3125,0.82295-0.10214,1.5375-0.66484,1.9375-1.375,0.55266-0.56003,1.502-0.26685,2.2188-0.28125,0.7728-0.002,1.5626,0.54243,2.3125,0.1875,0.21739-0.56438,1.2219-1.4958,1.5312-0.53125-0.0526,0.86265,0.70932,1.3257,1.5,1.2188,0.86375-0.0494,0.54445,0.61096,0.53125,1.125,0.0571,0.93448,0.65972,1.4247,1.4375,1.8125,0.26491,0.0715,0.545,0.0474,0.8125,0,0.74793-0.23513,1.5536-0.5689,1.7812-1.4062,0.30361-0.68071,0.31071-1.4507,0.53125-2.1562,0.17722-1.1299,0.406-2.26,0.4375-3.4062,0.27617-1.0383,0.19684-2.136,0.40625-3.1875,0.13231-0.7818,0.2308-1.5634,0.3125-2.3438-0.0917-0.41735-0.27189-0.48727-0.5-0.40625zm-6.7812,4.1562c0.15144,0.0185,0.2356,0.20409,0.25,0.53125,0.016,0.36409,0.20628,0.66075,0.4375,0.71875,0.18245,0.0457,0.16681,0.23882-0.0312,0.375-0.11507,0.0791-0.3209,0.127-0.6875,0.125-0.57804-0.003-0.93643-0.15276-1.25-0.46875l-0.1875-0.1875,0.28125-0.1875c0.14178-0.10831,0.39834-0.33259,0.5625-0.5,0.28494-0.29065,0.47356-0.42473,0.625-0.40625z'/%3E %3Cpath d='m490.5,370.94c-0.56713,0.026-1.1373,0.11796-1.6562,0.25-1.0402-0.0647-1.5624,1.0271-0.5625,1.5625,0.60166,1.5343,1.5404-0.31684,2.5-0.1875,1.4375,0.27956,1.559,1.8323,1.7812,3,0.0809,1.1567,0.41439,2.2816,0.75,3.375,0.96222,1.0695-0.72072,1.7402-1.4375,0.90625-0.61128-0.66434-1.9204-1.4795-2.6562-0.5625-0.9036,0.38266-0.94069,1.5903-1.6875,1.9375-1.2091,0.36803-1.3613-1.1188-2-1.75-0.58724-0.82427-1.7103-0.89646-2.625-1.1875-0.42913-0.86865-0.20548-2.3456-1.0938-2.9375-0.7458,0.30425-2.1131,1.7022-0.96875,2.3438,1.1177,0.96067-0.48782,1.4011-1,2.0625-0.73158,0.81456-0.84849,1.936-0.96875,2.9688-1.2593,0.69566-1.5044-0.78769-1.6562-1.7188-0.0981-1.1115-1.0358-0.78521-1.6875-0.375-0.95249,0.38586-1.4281,1.2903-2.0938,2-0.0799,0.64767,0.0372,1.3567,0.0312,2.0312,0.21646,0.81142,1.2024,0.4303,1.8125,0.375,0.9788-0.40937,1.3795,0.62745,0.59375,1.2188-0.53181,0.67603-2.2198,0.32293-2.0625,1.4062,0.54395,0.0636,1.1105,0.0432,1.6562,0,1.0905-0.29799,2.2614-1.0673,2.375-2.2812,0.1436-1.0582,1.6676-0.86544,2.5-1.0938,1.0408-0.30002,2.2948-0.37704,2.5312,0.9375,0.70943,0.74499,2.2486,1.584,3.0312,0.5625,0.79451-0.48523,1.1764-1.3376,1.125-2.25-0.16203-0.78461,1.2688-0.81314,1.625-0.375,0.52141,0.85796,2.151,0.60478,2.9375,0.125,0.8361-0.61721,1.0176-1.705,2.2188-1.7188,1.7823-0.53352,3.6342-0.84122,5.375-1.5,1.4104-0.3073-0.2099-1.1977-0.5625-1.7188-1.0737-0.53098-2.0081,1.6419-3.2188,0.5625-0.93564-0.71605-0.87212-2.0766-1.2188-3.125-0.23714-1.3573-0.17721-2.9227-1.1562-4-0.67242-0.71491-1.586-0.887-2.5312-0.84375zm-6.8125,9.4688c0.12573-0.003,0.26757,0.0593,0.5,0.1875,0.43841,0.24193,0.75063,0.64294,0.75,0.96875-0.00043,0.21261-0.0545,0.22697-0.375,0.375-0.19719,0.091-0.4214,0.1885-0.5,0.1875-0.18098-0.002-0.62438-0.35688-0.625-0.5-0.00065-0.0594-0.0581-0.28649-0.125-0.46875-0.11761-0.32068-0.0994-0.31643,0.0625-0.53125,0.10347-0.13744,0.18677-0.21532,0.3125-0.21875zm6.5312,0.34375c0.37229-0.0244,0.59356,0.0918,0.75,0.375,0.18178,0.32896,0.0582,0.58095-0.40625,0.78125-0.20349,0.0878-0.407,0.15925-0.4375,0.15625-0.0306-0.003-0.19844-0.10253-0.375-0.21875-0.27012-0.17777-0.3095-0.26387-0.3125-0.46875-0.003-0.31541,0.34928-0.5967,0.78125-0.625zm-8.9375,0.0937c0.10904-0.017,0.20831,0.04,0.34375,0.15625,0.17999,0.15456,0.23685,0.27887,0.28125,0.59375,0.0314,0.21884,0.0265,0.50184,0,0.625-0.0486,0.2261-0.0532,0.21575-0.5625,0.21875-0.64029,0.006-0.6997-0.0639-0.6875-0.65625,0.008-0.37682,0.0118-0.4782,0.21875-0.6875,0.16044-0.16228,0.29721-0.23305,0.40625-0.25zm-5.5,1.4375c0.19951,0.0469,0.3879,0.19761,0.4375,0.4375,0.0656,0.3175,0.008,0.46223-0.25,0.59375-0.2221,0.1131-0.73401,0.1508-0.875,0.0625-0.0457-0.0286-0.1399-0.103-0.1875-0.1875-0.068-0.12114-0.0555-0.1794,0.0312-0.25,0.0605-0.0492,0.12539-0.11985,0.125-0.15625-0.0004-0.0364,0.0673-0.16316,0.15625-0.28125,0.14608-0.1939,0.36299-0.26563,0.5625-0.21875zm9.25,1.1875c0.17794-0.001,0.32863,0.0609,0.4375,0.15625,0.18526,0.16231,0.179,0.40039-0.0312,0.5625-0.13509,0.1044-0.87165,0.0948-1.125,0-0.11272-0.0421-0.15563-0.0987-0.15625-0.21875-0.002-0.14091,0.0375-0.22767,0.28125-0.34375,0.20425-0.0976,0.41581-0.15507,0.59375-0.15625z'/%3E %3Cpath d='m467.86,388.29c-0.0958-0.0625-0.23767-0.11699-0.0948-0.22157,0.17277-0.30247,0.51785-0.40716,0.82434-0.51974,0.54779-0.23732,1.0207-0.64036,1.3737-1.1184,0.05-0.33298,0.42384-0.51355,0.42219-0.86174,0.003-0.47487,0.0311-0.9616-0.0846-1.426-0.12837-0.4257-0.45147-0.75199-0.82649-0.97395-0.25667-0.20149-0.674-0.25712-0.76877-0.61402-0.0525-0.34279,0.25343-0.60401,0.36053-0.90935,0.22325-0.42151,0.41109-0.86364,0.6509-1.275,0.25912-0.2878,0.65892-0.0156,0.79298,0.26239,0.18915,0.27771,0.35679,0.57593,0.45076,0.89748,0.30225,0.33175,0.57024,0.72087,0.679,1.1618,0.14839,0.31056,0.38316,0.60234,0.36929,0.96609,0.0003,0.4164,0.23509,0.78738,0.22034,1.2063,0.0133,0.56042,0.0131,1.1449-0.19184,1.6741-0.14001,0.29344-0.42058,0.46964-0.60639,0.73256-0.31897,0.29554-0.67037,0.57899-1.0797,0.73615-0.28928,0.092-0.45706,0.42565-0.81934,0.34466-0.51458,0.009-1.0366,0.079-1.5472-0.004,0.0323,0.0542-0.15633-0.0915-0.12493-0.0573z'/%3E %3Cpath d='m461.01,388.74c-0.24268-0.24958-0.2952-0.35543-0.29788-0.60032-0.003-0.24747,0.0446-0.34567,0.2822-0.58569,0.43829-0.44275,0.65248-0.45344,1.4091-0.0705,0.72304,0.36598,0.9675,0.39912,1.0322,0.14002,0.0625-0.25022,0.47885-0.47916,0.87435-0.4808,0.25006-0.002,0.39157,0.0477,0.59183,0.20368,0.25136,0.19583,0.26349,0.22634,0.26989,0.67935,0.004,0.46299-0.002,0.48055-0.29042,0.73591-0.27723,0.24409-0.32183,0.25915-0.66541,0.22476-0.43718-0.0439-0.69954-0.24407-0.77073-0.58844-0.0516-0.25001-0.13942-0.3097-0.20523-0.1397-0.0209,0.0546-0.12864,0.12185-0.23894,0.1496-0.20352,0.0514-0.5488,0.26862-0.79415,0.50006-0.0927,0.0874-0.25526,0.12855-0.51863,0.13122-0.35563,0.003-0.40513-0.0183-0.67826-0.29915z'/%3E %3Cpath d='m441.19,379.84c-0.66466,0.007-1.3805,0.5662-1.4688,1.2188,0.15206,0.75226,0.77698,1.4895,0.375,2.2812,0.27756,1.0131-0.76147,1.3974-1.4688,0.8125-0.4271-0.97134-0.64349-2.0358-1.2812-2.9062-0.80411-0.22762-1.1545,1.0569-1.7188,1.5,0.27975,0.75505,1.0958,1.4324,1.1875,2.375,0.1952,0.91482-0.36128,1.9306-1.1562,2.4062-0.68584,0.65472-1.6254,0.42074-2.4688,0.5625-1.0242,0.59857,0.75182,0.81755,1.2188,0.84375,1.0477,0.10646,2.1354-0.0317,2.9062-0.8125,0.76911-0.36708,0.70971-1.6972,1.625-1.8438,1.5884-0.0709,3.1626,0.24355,4.75,0.28125,0.84936,0.20336,2.1635-0.10098,2.75,0.53125,0.002,1.1075,0.94078,1.7905,1.8438,2.2188,0.4987,0.13872,1.0241-0.47928,1.5312-0.59375,0.96531-0.30764,0.67182-1.502,1.25-1.9688,1.6504-0.0893,3.3163-0.0704,4.9688-0.0937,0.31463,0.008,0.40734-0.43988,0.625-0.625-0.0363-0.63881-0.0593-1.2726-0.15625-1.9062-0.31819-0.80653,0.0513-1.8446-0.53125-2.5312-0.83011-0.22606-1.5362,0.53355-2.375,0.59375-0.92616,0.41246-1.7065,1.2677-1.75,2.3125-0.54833,0.89658-1.4277-0.15958-1.125-0.90625-0.0346-0.32541,0.0704-0.70429-0.0312-1-0.50698-0.60814-1.3947-0.4094-2.0938-0.5-1.0184,0.0406-2.0127-0.17955-3.0312-0.15625-0.89293-0.0674-1.822,0.0777-2.6875-0.15625-1.0317-0.0293-0.88959-1.0382-1.0625-1.75-0.18299-0.13571-0.40345-0.18973-0.625-0.1875zm2,3.6875c0.34308,0.007,0.66656,0.052,1,0.0937,0.43082,0.0709,0.8899-0.14816,1.3125,0,0.97651,0.16608,1.9536,0.12685,2.9375,0.21875,0.25985-0.004,0.44579,0.18471,0.625,0.34375,0.002,0.68357,0.00066,1.3789,0,2.0625-0.0299,0.25767,0.0763,0.5982-0.15625,0.78125-0.0747,0.0513-0.1583,0.1072-0.25,0.125-0.27065-0.07-0.55731-0.2479-0.6875-0.5-0.0414-0.35742,0.0179-0.70404,0.0312-1.0625-0.007-0.0927,0.0404-0.237,0-0.3125-0.21278-0.15067-0.45387-0.249-0.71875-0.25-0.84945-0.0291-1.682-0.0916-2.5312-0.125-0.7069-0.0446-1.4333,0.0604-2.125-0.125-0.26845-0.0976-0.61789-0.0641-0.78125-0.34375-0.23417-0.27227,0.10362-0.59695,0.34375-0.71875,0.31827-0.1447,0.65692-0.19411,1-0.1875zm11.281,0.25c0.15866-0.002,0.20935,0.05,0.28125,0.34375,0.0459,0.18765,0.0996,0.4172,0.125,0.5,0.0363,0.11811-0.0218,0.15625-0.1875,0.21875-0.494,0.18646-0.98566,0.16797-1.1562-0.0625-0.0774-0.10454,0.0129-0.43451,0.15625-0.5625,0.28946-0.25851,0.60992-0.43691,0.78125-0.4375z'/%3E %3C/g%3E %3C/g%3E %3Cpath stroke-width='1.1502' d='m449.98,327.23c32.642-25.106,29.843-61.883,29.843-61.883-0.8613,0.17223-1.6795,0.25835-2.5408,0.25835-6.8471,0-23.178-3.9171-26.988-8.8926-4.0812,4.5034-20.77,8.8926-27.574,8.8926-0.86129,0-1.7225-0.0861-2.5407-0.25835,0,0-2.8422,36.776,29.8,61.883z'/%3E %3Cpath stroke-width='0.9157' d='m477.22,268.04c-0.28097,0.0176-0.5633,0.0264-0.8477,0.0264-6.2055,0-20.619-3.1838-26.175-7.9572-5.8195,4.4095-20.471,7.9572-26.576,7.9572-0.28635,0-0.56925-0.035-0.84965-0.0865-0.0142,1.3908,0.0581,2.8324,0.14448,4.1436,0.323,4.9008,1.1826,9.819,2.4876,14.552,4.1081,14.895,12.516,27.553,24.572,37.155,12.066-9.61,20.484-22.28,24.601-37.186,1.3071-4.7319,2.1694-9.6497,2.4955-14.55,0.0853-1.2845,0.15716-2.6918,0.14745-4.0545z'/%3E %3Cpath fill='%23c09300' stroke='none' d='m439.38,265.03c-5.8724,1.8448-12.229,3.0312-15.75,3.0312-0.28633,0-0.56336-0.0423-0.84375-0.0937-0.0142,1.3907,0.0699,2.8451,0.15625,4.1562,0.32298,4.9006,1.1638,9.7995,2.4688,14.531,2.765,10.025,7.5063,19.032,13.969,26.781v-48.406z'/%3E %3Cpath fill='%23c09300' stroke='none' d='m460,264.94,0,49.25c6.794-7.9213,11.733-17.206,14.594-27.562,1.307-4.7317,2.1427-9.6313,2.4688-14.531,0.0853-1.2844,0.16596-2.6999,0.15625-4.0625-0.28095,0.0176-0.55937,0.0312-0.84375,0.0312-3.7302,0-10.42-1.1704-16.375-3.125z'/%3E %3Cg stroke-width='1.2704'%3E %3Cpath stroke-width='1.2179' d='m462.31,253.09c0.66655,0.0392-0.90178-3.568-0.90178-3.568,1.7643,1.8036,8.4297,2.2349,8.4297,2.2349-3.999-1.7656-7.9979-15.096-7.528-25.721,0.4319-10.664-1.5284-14.859-3.0971-16.428-1.9995-1.9995-8.4298-3.7639-12.664-3.9991-2.3922-0.11761-1.9995,1.8036-1.9995,1.8036-4.4308-1.137-8.8606-1.5684-10.861-0.2353-1.882,1.2547-2.274,7.5278-0.90178,6.43,3.3326-2.6661,6.2341-0.23524,8.2335,2.6661,1.7644,2.5485,1.6467,9.7627-0.90178,18.192-2.6661,8.8609-9.9588,17.722-9.9588,17.722,3.96,0,9.5276-3.5287,9.5276-3.5287l-1.3331,5.5283c4.1951-1.9996,7.5278-5.0969,7.5278-5.0969l3.9992,4.1951c1.333-1.7643,3.9991-4.1951,3.9991-4.1951s3.3328,3.5286,8.4297,3.9992z'/%3E %3Cpath fill='none' d='m446.12,227.57s-2.2349,16.428-6.43,21.094'/%3E %3Cpath fill='none' d='m449.65,227.14s-0.86252,16.623-3.7639,21.956'/%3E %3Cpath fill='none' d='m452.78,227.81s0,18.192,1.0978,21.289'/%3E %3Cpath fill='none' d='m456.74,228.71s0.90178,15.291,4.6657,20.819'/%3E %3Cpath fill='%23c09300' stroke-width='0.3542' d='m442.08,219.61c-0.19598-1.4508-0.54888-2.5878-1.0586-3.3328-1.9996-2.9013-4.9009-5.3321-8.2335-2.6661,0,0,1.137-3.5287,3.5678-3.6463,1.882-0.11767,6.1556,1.4115,9.9196,7.8415,0,0-2.7837-0.62739-3.4502-0.0393-1.2546,1.0979-0.74495,1.8428-0.74495,1.8428z'/%3E %3Cpath fill='%23c09300' stroke-width='0.3542' d='m432.44,209.26c0.27439-0.90178,0.7057-1.7251,1.2546-2.078,1.9996-1.333,6.43-0.90177,10.86,0.23524,0,0-0.39205-1.9212,1.9996-1.8036,4.2344,0.23523,10.665,1.9996,12.664,3.9992,0.47046,0.50973,1.0194,1.2547,1.4899,2.3916h-0.0784c-0.98015-1.3721-3.764-1.2937-4.4308-1.2154-1.0586,0.11756-1.7251,0.0784-3.1365,0.4312-0.66655,0.15693-1.686,0.3529-2.2349,0.78422-0.43131,0.3529-0.7841,1.6467-1.4506,1.6467-1.0586,0-0.98019-0.27449-1.2547-0.58814-0.35279-0.43131-0.54888-1.0586-0.90178-1.0194-1.0978,0.19608-2.8621-0.66644-5.0969-2.4308-2.2344-1.7644-3.0971-2.1956-5.9984-1.9996-2.8622,0.23524-3.7639,1.8427-3.7639,1.8427l0.0784-0.19598z'/%3E %3Ccircle cx='448.824' cy='210.672' r='1.176' stroke='none'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='990' height='630' viewBox='0 0 33 21'%3E %3Crect fill='%23FFF' width='33' height='21'/%3E %3Crect width='33' height='14'/%3E %3Crect fill='%234891D9' width='33' height='7'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1440' height='960'%3E %3Cdefs%3E %3ClinearGradient id='grad1' y2='277.58' gradientUnits='userSpaceOnUse' x2='601.38' gradientTransform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' y1='342.3' x1='597.92'%3E %3Cstop stop-color='%23fff' offset='0'/%3E %3Cstop stop-color='%231ea8d1' offset='1'/%3E %3C/linearGradient%3E %3ClinearGradient id='grad2' y2='399.5' gradientUnits='userSpaceOnUse' x2='600.31' gradientTransform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' y1='326.43' x1='599.96'%3E %3Cstop stop-color='%23FFF' offset='0'/%3E %3Cstop stop-color='%23c1d3e8' offset='0.1312'/%3E %3Cstop stop-color='%2388b0d5' offset='0.2994'/%3E %3Cstop stop-color='%235998c6' offset='0.4634'/%3E %3Cstop stop-color='%232c87bc' offset='0.6191'/%3E %3Cstop stop-color='%23007db5' offset='0.7645'/%3E %3Cstop stop-color='%230077b0' offset='0.8956'/%3E %3Cstop stop-color='%230075af' offset='1'/%3E %3C/linearGradient%3E %3C/defs%3E %3Crect width='1440' height='960' fill='%23ed1c24'/%3E %3Crect width='1440' height='720' fill='%23034ea2'/%3E %3Crect width='1440' height='480' fill='%23fd0'/%3E %3Cg id='coa'%3E %3Cg id='supporters'%3E %3Cg id='flag1' stroke='%23000' stroke-width='0.458' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='%23b1babf' d='m452.3,476.58c-0.046,0.094-0.086,0.165-0.111,0.179,0,0-2.727,1.422-5.709,1.624,0,0-2.696,8.413-5.89,11.002,3.717-2.491,9.801-4.766,11.332-4.928,0.078-2.351,0.51-5.128,2.017-6.002l0.218-0.048h0.001c-0.525-0.682-1.147-1.295-1.858-1.827z'/%3E %3Cpath fill='none' stroke-width='0.23' d='m442.15,487.98,10.946-10.447'/%3E %3Cpath fill='none' stroke-width='0.23' d='m451.94,484.32-5.442-6.075'/%3E %3Cpath fill='%23b1babf' d='m472.76,455.57,3.209,3.783-20.287,19.026-1.261,0-2.292-2.063,0.115-1.605z'/%3E %3Cpath fill='none' stroke-width='0.23' d='m454.08,476.66,19.829-18.339'/%3E %3Cpath fill='%23b1babf' d='m478.97,217.63,8.482,8.023-2.178,0.917-8.367-7.907,2.063-1.033'/%3E %3Cpath fill='%23034ea2' d='m509.97,317.7,11.08,10.953,5.195-12.531,0.992-7.688c-0.779-22.019-0.381-43.662-0.381-43.662l3.259,2.842c-3.621-3.623-7.897-7.904-12.438-12.452l-7.326-7.2c0.001,0-0.138,46.318-0.381,69.738z'/%3E %3Cpath fill='%23ed1c24' d='m527.24,308.43,10.998-32.694-11.379-10.967s-0.399,21.642,0.381,43.661z'/%3E %3Cpath fill='%23fd0' d='m510.36,247.96,7.324,7.2c-13.331-13.353-28.932-28.999-36.852-37.016-1.463-1.482-1.807,31.898-1.646,69.118l30.79,30.436c0.243-23.42,0.384-69.738,0.384-69.738z'/%3E %3Cpath fill='none' stroke-width='0.23' d='M534.98,272.44,475.85,212.95'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m476.98,214.13c-0.115-0.059-0.199-0.111-0.215-0.143,0,0-1.674-3.449-1.857-7.196,0,0-10.173-3.55-13.254-7.607,2.951,4.712,5.591,12.39,5.757,14.315,2.857,0.145,6.223,0.741,7.256,2.649l0.053,0.274,0.003,0.002c0.838-0.644,1.597-1.413,2.257-2.294z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m484.95,223.48-2.609-2.653c-0.191,0.594-0.5,1.624-0.988,3.418-1.041,3.819-0.232,16.615-0.811,21.008s-1.618,10.409-1.733,12.987c-0.003,0.054-0.011,0.103-0.015,0.156-0.036,3.053,1.113,6.798,1.113,6.798s1.834,0.946,2.14,0.126,0.458-7.195,0.458-8.52,0.382-2.082,1.528-8.393,0.611-9.908,0.153-13.757c-0.459-3.85,0.764-11.17,0.764-11.17z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m480.06,218.04s-2.87,7.829-2.754,13.845c0.115,6.016-0.81,14.324-0.926,15.565-0.085,0.918-1.18,5.794-1.279,9.473-0.036,1.302,0.286,1.157,0.589,1.931,0,0,1.975,1.24,3.104-0.457,0.004-0.052,0.013-0.102,0.015-0.156,0.115-2.578,1.155-8.594,1.733-12.987,0.578-4.392-0.23-17.189,0.811-21.008,0.488-1.794,0.797-2.823,0.988-3.417,0.217-0.671,0.283-0.785,0.283-0.785l-2.564-2.004z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m487.82,216.7c-1.457,0.486-5.995,1.31-7.411,1.562-0.27,0.048-0.426,0.076-0.426,0.076,6.5,0.134,9.108,4.027,9.108,4.027l2.197-2.659c1.965-3.238-1.735-3.585-3.468-3.006z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.23' d='m479.99,218.34,0.175,0.332c0.763,1.393,3.938,6.644,7.584,4.731l1.35-1.035c-0.001,0-2.608-3.894-9.109-4.028z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m480.53,218.34s6.414-3.56,7.309-3.526c0.896,0.033,1.005,1.506,1.221,2.37s-0.024,1.911-3.192,1.821c-3.17-0.089-2.241-0.432-5.338-0.665z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m490.62,214.23c-0.953-4.402-5.465-3.483-5.465-3.483-4.422,0.747-4.985,6.127-5.058,7.543-0.01,0.216-0.01,0.34-0.01,0.34,10.455-8.897,9.003,0.21,9.003,0.21,1.05-1.855,1.53-4.61,1.53-4.61z'/%3E %3Cpath fill='none' stroke-width='0.23' d='m462.2,200.03,13.749,15.311'/%3E %3Cpath fill='none' stroke-width='0.23' d='m467.41,213.52,7.57-6.708'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m480.04,203.82c-0.087-0.142-0.236-0.297-0.435-0.461,0.484,2.866,0.199,5.812-0.992,8.464-0.4,0.891-0.886,1.704-1.439,2.439-0.669,0.89-1.439,1.666-2.29,2.317-3.458,2.645-8.228,3.265-12.769,1.435,0.081,0.055,0.159,0.112,0.241,0.166,0.381,0.253,0.773,0.493,1.176,0.721,7.185,4.058,15.186,2.522,17.871-3.432,1.605-3.553,0.952-7.878-1.363-11.649z'/%3E %3Ccircle fill='%23e8b909' cx='477.02' cy='257.56' r='2.09'/%3E %3Cpath fill='%23e8b909' d='m479.63,269.7c-2.965-0.112-4.609-0.279-6.526-0.395,0.247-4.088,0.591-9.756,3.854-9.558,3.229,0.195,2.92,5.866,2.672,9.953z'/%3E %3Cpath fill='none' d='m475.83,263.2s-0.557,5.841-0.611,6.176'/%3E %3Cpath fill='none' d='m477.45,263.26s0.068,4.427-0.278,6.263'/%3E %3Ccircle fill='%23e8b909' cx='480.7' cy='263.46' r='2.09'/%3E %3Cpath fill='%23e8b909' d='m484.04,275.42c-2.966,0.067-4.616,0-6.537,0,0-4.095-0.001-9.774,3.269-9.774,3.234,0,3.268,5.679,3.268,9.774z'/%3E %3Cpath fill='none' d='m479.86,269.15s-0.202,5.864-0.236,6.201'/%3E %3Cpath fill='none' d='m481.48,269.12s0.337,4.415,0.101,6.269'/%3E %3C/g%3E %3Cuse xlink:href='%23flag1' transform='matrix(-1,0,0,1,1439.0324,0)'/%3E %3Cg id='laurel' stroke='%23000' stroke-width='0.344' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='none' d='m529.89,257.24c-3.951,1.175-6.94,3.097-11.212,3.631'/%3E %3Cpath fill='%2339b54a' d='m511.32,264.35s-0.396-8.102-0.075-8.994c0.32-0.888,7.384-6.382,5.246-20.159,0,0-1.39-4.62-0.672-5.753,0,0-6.114,11.651-6.623,15.135-0.508,3.481,0.361,9.155,0.701,10.532,0.34,1.378,0.889,5.106,0.889,5.106'/%3E %3Cpath fill='none' d='m515.3,233.09c0.009,1.67-0.571,3.388-0.853,5.021-0.278,1.617-0.501,3.129-1.055,4.675-0.712,1.985-1.68,4.029-2.05,6.082-0.30895,1.7175-0.29754,3.4764-0.35087,5.2175'/%3E %3Cpath fill='none' d='m510.66,255.44c-0.101-1.507,1.77-3.495,2.964-4.531'/%3E %3Cpath fill='none' d='m511.26,249.28c0.439-1.087-0.95-3.337-1.102-4.538'/%3E %3Cpath fill='none' d='m511.16,251.06c-0.048-2.644,3.191-3.361,3.318-5.762'/%3E %3Cpath fill='none' d='m512.36,245.31c-0.28-1.266-2.34-2.268-1.711-3.731'/%3E %3Cpath fill='none' d='m513.32,242.88c0.26-0.806,0.92-1.607,1.41-2.346,0.448-0.671,1.325-1.16,1.641-1.859'/%3E %3Cpath fill='none' d='m514,240.05c0.057-1.665-0.477-3.007-0.422-4.618'/%3E %3Cpath fill='%2339b54a' d='m518.47,255.06c0.017-2.97,0.411-4.652,2.813-6.483,2.098-1.599,4.84-2.35,5.727-4.972-0.479,0.899-0.281,2.061-0.498,3.054-0.255,1.16-0.717,2.435-1.246,3.52-0.799,1.636-1.88,3.356-2.965,4.754'/%3E %3Cpath fill='%2339b54a' d='m508,264.51c1.627-3.748,4.271-6.778,8.075-8.458,2.905-1.284,6.025-1.721,9.152-1.885,1.911-0.099,3.671-0.116,5.527-0.73,1.333-0.441,3.665-1.043,4.523-2.193-5.329,2.983-8.409,8.88-14.194,11.254-4.563,1.873-10.604,0.947-14.616,4.055'/%3E %3Cpath fill='none' d='m508.38,264.89c2.883-2.966,6.495-4.992,10.485-6.099,3.119-0.865,6.646-1.904,9.433-3.604'/%3E %3Cpath fill='none' d='m518.98,259.15c0.911,0.463,2.995,1.463,4.085,1.277'/%3E %3Cpath fill='none' d='m522.82,257.73c0.955,0.003,2.535,0.753,3.32,0.383'/%3E %3Cpath fill='none' d='m519.74,258.51c-1.102-1.927,1.652-2.055,2.298-3.192'/%3E %3Cpath fill='%2339b54a' d='m536.73,243.83c1-1.15,0.653-4.406,1.177-5.97,0.685-2.036,2.243-3.479,3.146-5.355-0.827,1.848-0.091,4.381-0.747,6.34-0.732,2.184-2.476,4.05-3.704,6.007'/%3E %3Cpath fill='none' d='m538.26,241.27c-0.209-1.838,1.28-3.325,1.661-4.98'/%3E %3Cpath fill='%2339b54a' d='m505.23,305.87c2.208,3.341,4.85,8.697,1.846,12.422-0.646-0.961-0.711-2.817-1.75-3.483-0.747-0.478-2.115-0.265-3.007-0.645-2.387-1.017-1.929-3.593-3.525-4.88l-0.383-0.944,6.281-3.098,0.538,0.628z'/%3E %3Cpath fill='none' d='m502.38,308.56c2.804,2.082,4.737,5.504,4.469,9.065'/%3E %3Cpath fill='none' d='m502,308.43c0.804,1.921,0.111,3.375,0.281,5.203,0.075-0.116,0.136-0.247,0.229-0.352'/%3E %3Cpath fill='none' d='m503.14,308.94c1.827,1.352,3.088,2.359,4.341,4.215'/%3E %3Cpath fill='%2339b54a' d='m495.23,296.18c1.016-1.228,1.286-3.411,2.174-4.859,1.106-1.804,2.975-3.602,4.969-4.306,2.448-0.864,4.788-1.326,7.384-1.432,2.429-0.1,5.253,0.952,7.321,0.758-4.256,1.559-9.485,1.748-13.412,4.184-2.557,1.586-5.125,4.242-7.158,6.452-1.691,1.838-2.125,3.899-3.065,6.098'/%3E %3Cpath fill='none' d='m495.36,297.71c1.038-2.534,3.186-5.73,5.391-7.409,2.21-1.684,5.092-2.701,7.888-2.55'/%3E %3Cpath fill='none' d='m497.14,294.39c1.439-0.997,3.373-1.943,4.597-3.192'/%3E %3Cpath fill='%2339b54a' d='m505.44,288.1c1.352-1.517,3.247-1.388,4.979-1.629'/%3E %3Cpath fill='%2339b54a' d='m493.57,305.11c0.561-0.751,0.855-1.724,1.306-2.579,0.62-1.178,1.463-2.191,2.272-3.268,1.639-2.182,3.209-4.148,5.229-6.025,1.716-1.595,4.053-2.883,6.395-3.424,2.205-0.51,6.096,0.039,7.736-1.645-1.216,1.47-1.767,3.279-3.196,4.705-2.068,2.065-4.23,4.367-6.866,5.817-1.991,1.095-4.608,2.317-6.781,2.816-1.919,0.439-5.231,0.439-6.333,2.428,0.09,0.053,0.174,0.145,0.236,0.228,0.348-0.233,0.715-0.526,1.024-0.841'/%3E %3Cpath fill='none' d='m494.85,302.56c1.127-0.381,2.156-1.979,3.028-2.806,1.26-1.196,2.607-2.13,4.086-3.065,1.883-1.188,3.686-2.245,5.742-3.103,1.642-0.684,3.232-1.288,4.635-2.39'/%3E %3Cpath fill='none' d='m500.97,297.33c1.351-0.439,2.682-1.04,4.085-1.28,0.781-0.133,1.723,0.032,2.427-0.38'/%3E %3Cpath fill='none' d='m503.02,295.92c1.012-1.479,2.69-2.719,3.318-4.342'/%3E %3Cpath fill='%2339b54a' d='m524.72,254.04c1.745-2.375,3.823-4.09,6.165-5.933,1.567-1.234,2.775-2.908,4.66-3.679,5.015-2.049,10.551,1.902,15.695,1.817-2.225,0.963-4.186,2.363-6.602,2.979-2.396,0.61-4.771,0.961-7.271,0.986-4.41,0.043-10.245,0.102-12.775,4.468'/%3E %3Cpath fill='none' d='m527.66,251.49c2.898-0.723,5.768-2.563,8.581-3.668,2.845-1.117,5.977-0.527,8.784-1.44'/%3E %3Cpath fill='none' d='m536.15,247.91c1.854-0.684,4.49,0.759,6.513,0.766'/%3E %3Cpath fill='none' d='m533.41,249.06c0.921-0.761,1.859-1.599,2.843-2.295,0.736-0.518,1.777-1.007,2.009-1.919'/%3E %3Cpath fill='%2339b54a' d='m504.58,280.18c2.101-0.421,2.834-4.027,3.396-5.619,0.768-2.177,1.422-5.225,2.783-7.087,0.892-1.219,2.619-2.165,3.877-3.066,1.597-1.144,2.373-1.566,4.253-1.847,2.521-0.379,5.196-0.63,7.757-0.656,2.305-0.024,4.939,0.36,7.078-0.725-2.347,0.78-4.693,2.745-6.118,4.611-2.228,2.919-3.659,5.595-6.988,7.702-2.977,1.885-6.643,2.768-10.021,3.79-1.918,0.582-5.112,1.273-5.594,3.468'/%3E %3Cpath fill='none' d='m507.61,277.54c3.653-3.69,5.158-9.006,10.734-10.47,3.402-0.894,8.688-1.374,10.973-4.341'/%3E %3Cpath fill='none' d='m510.51,274.11c1.187-1.138,2.687-1.783,4.313-1.788,1.638-0.005,3.369,0.411,4.88-0.382'/%3E %3Cpath fill='none' d='m518.72,267.32c1.004-0.369,2.024,0.253,3.034,0.263,1.044,0.009,1.878-0.594,2.84-0.773'/%3E %3Cpath fill='none' d='m515.4,268.34c0.471-1.996,1.511-2.825,2.555-4.469'/%3E %3Cpath fill='%2339b54a' d='m501.48,285.78c1.622-0.106,2.352-2.107,2.855-2.977,0.688-1.187,1.332-2.877,2.458-3.848,0.738-0.634,2.099-1.062,3.102-1.495,1.271-0.548,1.883-0.737,3.33-0.778,1.938-0.055,3.99-0.027,5.944,0.121,1.758,0.132,3.747,0.518,5.431,0.039-1.826,0.293-3.708,1.26-4.884,2.23-1.837,1.515-3.055,2.944-5.692,3.93-2.359,0.88-5.196,1.149-7.819,1.514-1.491,0.209-3.958,0.398-4.43,1.614'/%3E %3Cpath fill='none' d='m503.92,284.47c2.959-1.863,4.358-4.786,8.679-5.264,2.637-0.291,6.689-0.228,8.571-1.767'/%3E %3Cpath fill='none' d='m506.92,282.53c0.958-0.571,2.131-0.841,3.371-0.741,1.25,0.101,2.551,0.447,3.74,0.093'/%3E %3Cpath fill='none' d='m512.87,279.37c0.783-0.145,1.531,0.273,2.301,0.343,0.795,0.071,1.459-0.218,2.202-0.259'/%3E %3Cpath fill='none' d='m510.29,279.74c0.453-1.105,1.285-1.509,2.159-2.376'/%3E %3Cpath fill='%2339b54a' d='m491.42,308.23s-13.454-14.308-6.193-32.034c0,0,0.215,4.911,0.642,5.552,0.426,0.641,7.9,11.853,6.833,21.57-1.067,9.718-0.533,5.767-0.533,5.767l-0.749-0.855z'/%3E %3Cpath fill='none' d='m491.42,307.05s-1.709-11.319-3.844-14.416c-2.136-3.096-2.457-9.61-2.243-10.784'/%3E %3Cpath fill='none' d='m487.57,291.36c0.585-0.728,1.211-1.507,1.28-2.456'/%3E %3Cpath fill='none' d='m489.5,296.16c0.6-0.798,0.697-1.843,0.961-2.669'/%3E %3Cpath fill='none' d='m489.28,298.4c-0.695-0.877-3.29-1.042-3.417-2.029'/%3E %3Cpath fill='none' d='m487.15,293.07c-0.522-1.085-3.155-1.356-3.203-2.67'/%3E %3Cpath fill='none' d='m485.22,286.77c-1.013-0.755-1.222-1.407-1.603-2.563'/%3E %3Cpath fill='none' d='m490.35,302.57c-1.022-1.157-2.163-1.543-3.311-2.242'/%3E %3Cpath fill='none' d='m490.46,300.11c0.198-1.01,1.215-1.997,1.175-2.99'/%3E %3Cpath fill='%2339b54a' d='m514.17,250.18s3.231-7.338,3.917-7.978c0.682-0.638,9.485-2.237,13.665-15.388,0,0,0.793-4.72,1.944-5.391,0,0-10.678,7.475-12.679,10.319-2.001,2.84-3.732,8.251-4.037,9.624-0.304,1.373-1.462,4.918-1.462,4.918'/%3E %3Cpath fill='none' d='m531.62,224.41c-0.733,1.48-2.016,2.729-2.994,4.041-0.967,1.302-1.839,2.534-3.022,3.643-1.521,1.427-3.299,2.787-4.542,4.43-1.084,1.43-1.873,3.063-2.733,4.637'/%3E %3Cpath fill='none' d='m517.52,242.01c0.577-1.378,3.145-2.273,4.681-2.637'/%3E %3Cpath fill='none' d='m520.79,236.85c0.878-0.758,0.623-3.387,1.018-4.515'/%3E %3Cpath fill='none' d='m520.32,237.5c0.81-2.346,5.548-0.331,6.518-2.322'/%3E %3Cpath fill='none' d='m523.55,233.85c0.31-1.247-1.104-3.079,0.112-4.083'/%3E %3Cpath fill='none' d='m525.49,232.15c0.591-0.593,1.542-0.996,2.312-1.424,0.701-0.384,1.707-0.413,2.301-0.886'/%3E %3Cpath fill='none' d='m527.36,229.96c0.788-1.445,0.901-2.875,1.666-4.273'/%3E %3Cpath fill='%2339b54a' d='m496.94,255.01s0.499-4.559,0.286-5.06c-0.214-0.501-5.287-3.602-3.359-11.351,0,0,1.145-2.599,0.643-3.237,0,0,4.216,6.563,4.502,8.524s-0.5,5.152-0.785,5.927c-0.286,0.775-0.787,2.872-0.787,2.872'/%3E %3Cpath fill='none' d='m494.84,237.54c-0.047,0.938,0.337,1.908,0.502,2.827,0.164,0.91,0.29,1.762,0.659,2.632,0.474,1.118,1.137,2.269,1.357,3.424,0.191,1.008,0.125,2.041,0.125,3.062'/%3E %3Cpath fill='none' d='m497.7,250.13c0.113-0.85-1.218-1.969-2.07-2.553'/%3E %3Cpath fill='none' d='m497.41,246.66c-0.296-0.613,0.787-1.877,0.931-2.554'/%3E %3Cpath fill='none' d='m497.49,247.12c0.303-1.398-3.434-1.611-3.357-2.872'/%3E %3Cpath fill='none' d='m496.7,244.43c0.239-0.713,1.786-1.272,1.357-2.097'/%3E %3Cpath fill='none' d='m496.06,243.06c-0.17-0.454-0.637-0.906-0.979-1.322-0.313-0.379-0.948-0.654-1.163-1.048'/%3E %3Cpath fill='none' d='m495.63,241.46c0-0.937,0.427-1.691,0.427-2.598'/%3E %3Cpath fill='%2339b54a' d='m496.44,275.23s0.504-9.383,0.908-10.369c0.402-0.988,7.735-6.468,7.194-22.594,0,0-0.822-5.49-0.015-6.709,0,0-7.096,12.689-7.96,16.639-0.862,3.951-0.651,10.591-0.478,12.218s0.291,5.989,0.291,5.989'/%3E %3Cpath fill='none' d='m503.64,239.7c-0.175,1.922-0.915,3.832-1.36,5.681-0.439,1.829-0.816,3.545-1.515,5.259-0.893,2.201-2.039,4.439-2.614,6.759-0.502,2.023-0.676,4.141-0.934,6.222'/%3E %3Cpath fill='none' d='m496.79,264.88c0.066-1.751,2.066-3.814,3.317-4.864'/%3E %3Cpath fill='none' d='m498.03,257.86c0.536-1.198-0.543-3.957-0.558-5.359'/%3E %3Cpath fill='none' d='m498.04,258.92c-0.038-2.902,4.84-2.714,5.06-5.299'/%3E %3Cpath fill='none' d='m499.51,253.43c-0.129-1.493-1.984-2.892-1.226-4.502'/%3E %3Cpath fill='none' d='m500.69,250.75c0.334-0.898,1.055-1.743,1.601-2.533,0.5-0.722,1.39-1.179,1.766-1.947'/%3E %3Cpath fill='none' d='m501.64,247.56c0.236-1.91-0.128-3.52,0.103-5.37'/%3E %3Cpath fill='%2339b54a' d='m495.94,265.35s-2.67-4.484-3.524-6.941c-0.854-2.456-2.349-4.805-2.883-5.232s5.874,3.309,6.301,4.378'/%3E %3Cpath fill='none' d='m495.83,261.29c-0.905-2.104-2.113-4.898-4.271-5.98'/%3E %3Cpath fill='none' d='m495.08,260.97c-0.21-0.945-1.26-1.612-1.922-2.136'/%3E %3Cpath fill='none' d='m494.87,259.26c-0.261-0.847-0.42-1.836-0.641-2.67'/%3E %3Cpath fill='%2339b54a' d='m496.36,280.08s0.748-9.717,5.126-12.28c0,0,4.271-2.136,6.086-3.844,0,0,2.563-3.524,0.961-1.281-1.603,2.242-2.669,14.735-2.776,15.483-0.106,0.747-1.709,5.552-4.699,9.183-2.988,3.631-4.378,5.873-5.018,7.155-0.641,1.281-1.175,4.697-1.175,4.697'/%3E %3Cpath fill='none' d='m495.94,291.19c1.613-1.339,1.935-3.465,2.671-5.371,0.807-2.094,1.738-4.065,2.054-6.283,0.322-2.262,0.897-4.27,1.813-6.365,0.946-2.161,2.698-3.762,3.821-5.686'/%3E %3Cpath fill='none' d='m500.72,280.47c1.396-1.926,2.959-1.976,4.725-3.191'/%3E %3Cpath fill='none' d='m498.57,286.26c0.987-1.512,3.104-1.221,3.83-3.064'/%3E %3Cpath fill='none' d='m499.32,282c0.573-2.072-1.241-3.219-1.66-5.107'/%3E %3Cpath fill='none' d='m501.41,276.03c-1.013-2.407-0.88-4.108,0-6.257'/%3E %3Cpath fill='none' d='m496.89,274.22c0.133-2.469,1.027-5.57,2.04-7.793,0.619-1.359,1.537-2.64,2.267-3.919,0.512-0.898,1.148-2.178,2.078-2.716'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m503.27,259.4c-0.094,0.482,0.596,0.772,1.127,0.489,0.039-0.117,0.02-0.228,0.041-0.349,0.652,0.191,2.151,0.198,1.299-0.78,0.607-0.108,1.575-0.673,0.741-1.176,0.487-0.478,0.527-1.325-0.016-1.771-0.085,0.062-0.175,0.164-0.263,0.222-0.043-0.579-0.546-0.823-1.123-0.703-0.02,0.104,0.014,0.225-0.009,0.318-0.396-0.271-0.867-0.297-1.267-0.048,0.038,0.075,0.154,0.15,0.189,0.229-0.354-0.063-0.524,0.128-0.826,0.144,0.054,0.104,0.063,0.397,0.115,0.498,0.098-0.007,0.098-0.013,0.002-0.016-0.404,0.145-0.674,0.435-0.765,0.874,0.147,0.036,0.307,0.139,0.463,0.182-0.757,0.22-0.739,0.871-0.081,1.128,0.098-0.003,0.1-0.008,0.005-0.016-0.747,0.677,0.558,0.847,1.004,0.264'/%3E %3Cpath fill='%23de2126' stroke='none' d='m504.11,256.99c0.426,0.258,0.197,0.998,1.036,1.061,0.164-0.431,0.295-0.565,0.388-1.005-0.245-0.006-1.247,0.145-0.685,0.314'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m504.45,265.29c-0.094,0.482,0.597,0.772,1.127,0.489,0.039-0.117,0.021-0.228,0.041-0.349,0.652,0.191,2.151,0.198,1.299-0.78,0.607-0.108,1.575-0.673,0.741-1.176,0.487-0.478,0.527-1.325-0.016-1.771-0.084,0.062-0.174,0.164-0.262,0.222-0.043-0.579-0.547-0.823-1.123-0.703-0.021,0.104,0.013,0.225-0.01,0.318-0.396-0.271-0.866-0.297-1.268-0.048,0.039,0.075,0.156,0.15,0.191,0.229-0.355-0.063-0.525,0.128-0.826,0.144,0.053,0.104,0.063,0.397,0.114,0.498,0.098-0.007,0.099-0.013,0.003-0.016-0.405,0.146-0.675,0.435-0.766,0.874,0.148,0.036,0.308,0.139,0.463,0.182-0.757,0.22-0.738,0.871-0.081,1.128,0.099-0.003,0.101-0.008,0.004-0.016-0.745,0.677,0.559,0.847,1.006,0.264'/%3E %3Cpath fill='%23de2126' stroke='none' d='m505.33,262.81c0.384,0.265,0.179,1.024,0.932,1.09,0.147-0.443,0.266-0.582,0.349-1.033-0.22-0.005-1.12,0.15-0.614,0.323'/%3E %3Cpath fill='none' d='m503.78,264.38c-4.634,2.68-8.541,7.49-7.405,13.152'/%3E %3Cpath fill='%2339b54a' d='m513.74,252.13c3.735-1.835,4.712-6.083,8.204-8.137,2.264-1.331,4.95-1.713,7.494-2.198,1.806-0.345,4.236-0.662,5.303-2.372-1.6,1.95-3.466,3.458-5.273,5.173-1.892,1.795-3.494,3.324-6.122,4.09-1.988,0.579-4.061,0.369-6.03,1.049-1.624,0.562-2.585,1.893-3.958,2.906l0.382-0.511z'/%3E %3Cpath fill='none' d='m517.45,249.44c1.898-1.179,3.117-3.058,5.206-3.925,2.306-0.958,4.909-1.177,7.179-2.203'/%3E %3Cpath fill='none' d='m520.26,247.11c1.683-0.965,4.067,0.002,5.617-1.149'/%3E %3Cpath fill='none' d='m522.94,245.36c0.848-0.723,1.896-1.336,2.682-2.043'/%3E %3Cpath fill='none' d='m514.64,261.32c-2.098,1.015-6.444,1.684-7.278,4.342'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m514.64,261.19c0.275,0.766,1.01,1.021,1.766,0.875,0.051-0.115,0.101-0.243,0.146-0.351,0.931,0.438,1.839-0.234,1.195-1.169,0.642-0.098,0.728-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.479-0.044,1.112-1.392-2.423-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.687,0.362-0.849,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m515.79,259.79c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m522.3,267.32c0.276,0.766,1.011,1.021,1.767,0.876,0.051-0.116,0.099-0.244,0.146-0.352,0.932,0.438,1.839-0.234,1.196-1.169,0.641-0.098,0.727-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.48-0.044,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.686,0.362-0.848,1.446,0.048,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m523.45,265.92c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m517.57,270.77c0.276,0.766,1.011,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.48-0.044,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.686,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m518.72,269.36c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath fill='%23ffdf4f' stroke='none' d='m511.32,271.28c0.276,0.766,1.01,1.021,1.767,0.876,0.052-0.116,0.1-0.244,0.146-0.352,0.931,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.48-0.044,1.113-1.392-2.422-2.45-2.458-0.886-0.659-0.039-1.535,0.436-0.794,0.908-0.687,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m512.47,269.87c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m506.59,276.51c0.276,0.766,1.011,1.021,1.767,0.875,0.051-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.839-0.234,1.196-1.169,0.641-0.098,0.727-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.48-0.044,1.113-1.393-2.422-2.45-2.458-0.887-0.659-0.039-1.535,0.437-0.794,0.909-0.686,0.362-0.848,1.446,0.049,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m507.74,275.11c0.039,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m530.08,258.51c0.276,0.766,1.012,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.145-0.351,0.932,0.438,1.84-0.235,1.197-1.169,0.642-0.099,0.727-0.609,0.448-1.124-0.15,0.005-0.331-0.045-0.48-0.044,1.113-1.393-2.422-2.45-2.458-0.887-0.659-0.039-1.535,0.437-0.794,0.908-0.686,0.363-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m531.23,257.1c0.04,2.039,1.692-1.125,0.021-0.095,0.026,0.158,0.188,0.13,0.235,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m538.64,246c0.276,0.766,1.011,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.838-0.234,1.196-1.169,0.642-0.098,0.729-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.479-0.044,1.112-1.392-2.422-2.45-2.459-0.887-0.659-0.039-1.535,0.437-0.794,0.909-0.686,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m539.79,244.59c0.039,2.039,1.69-1.125,0.02-0.095,0.026,0.158,0.189,0.13,0.235,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m531.75,245.49c0.276,0.766,1.011,1.021,1.767,0.875,0.052-0.115,0.099-0.243,0.146-0.351,0.932,0.438,1.838-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.448-1.124-0.151,0.005-0.33-0.045-0.479-0.045,1.111-1.392-2.423-2.45-2.459-0.886-0.659-0.039-1.535,0.437-0.795,0.909-0.685,0.362-0.847,1.446,0.049,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m532.9,244.08c0.038,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m514.12,281.11c0.276,0.766,1.01,1.021,1.767,0.875,0.052-0.115,0.1-0.243,0.146-0.351,0.931,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.447-1.124-0.149,0.005-0.329-0.045-0.479-0.044,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.687,0.362-0.847,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m515.28,279.7c0.037,2.039,1.69-1.125,0.02-0.096,0.026,0.159,0.189,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m506.98,283.54c0.276,0.766,1.01,1.021,1.766,0.875,0.052-0.115,0.101-0.243,0.146-0.351,0.931,0.438,1.839-0.234,1.196-1.169,0.642-0.098,0.727-0.609,0.447-1.124-0.15,0.005-0.329-0.045-0.479-0.044,1.113-1.393-2.422-2.45-2.458-0.887-0.659-0.039-1.535,0.437-0.794,0.909-0.687,0.362-0.848,1.446,0.049,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m508.12,282.13c0.039,2.039,1.691-1.125,0.021-0.096,0.026,0.159,0.188,0.131,0.235,0.224'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m506.59,294.26c0.276,0.766,1.011,1.021,1.767,0.876,0.051-0.116,0.1-0.244,0.146-0.352,0.932,0.438,1.839-0.234,1.196-1.169,0.641-0.098,0.727-0.609,0.448-1.123-0.151,0.004-0.33-0.046-0.48-0.045,1.113-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.686,0.362-0.848,1.446,0.049,1.664'/%3E %3Cpath fill='%23de2126' stroke='none' d='m507.74,292.86c0.039,2.039,1.69-1.125,0.02-0.095,0.026,0.158,0.189,0.13,0.235,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m500.08,298.73c0.275,0.767,1.01,1.021,1.766,0.875,0.052-0.114,0.101-0.242,0.146-0.351,0.931,0.438,1.839-0.234,1.195-1.169,0.643-0.099,0.728-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.479-0.044,1.112-1.392-2.422-2.45-2.458-0.887-0.659-0.038-1.535,0.437-0.794,0.909-0.687,0.362-0.848,1.446,0.049,1.664l0.134,0.08'/%3E %3Cpath fill='%23de2126' stroke='none' d='m501.23,297.33c0.039,2.039,1.691-1.125,0.021-0.095,0.025,0.158,0.188,0.13,0.234,0.223'/%3E %3Cpath stroke-width='0.23' fill='%23ffdf4f' d='m520.13,253.4c0.275,0.766,1.01,1.021,1.766,0.875,0.051-0.115,0.1-0.243,0.146-0.351,0.932,0.438,1.84-0.234,1.196-1.169,0.643-0.098,0.728-0.609,0.448-1.124-0.15,0.005-0.33-0.045-0.48-0.045,1.113-1.392-2.422-2.449-2.458-0.886-0.658-0.039-1.534,0.437-0.794,0.909-0.686,0.362-0.847,1.446,0.05,1.663'/%3E %3Cpath fill='%23de2126' stroke='none' d='m521.28,252c0.039,2.039,1.691-1.125,0.021-0.096,0.025,0.159,0.188,0.131,0.234,0.224'/%3E %3Cpath fill='%2339b54a' d='m537.75,242.93c2.741-2.494,2.588-6.662,6.383-8.428,1.916-0.892,4.212-1.437,5.823-2.766-2.946,4.999-7.018,8.714-12.206,11.194'/%3E %3Cpath fill='%2339b54a' d='m537.11,243.19c1.866-0.68,3.247-2.276,5.042-3.117,1.997-0.936,3.686-0.266,5.793-0.451,2.11-0.185,4.03-0.723,6.018-1.395-3.801,5.194-11.868,1.362-16.598,4.708'/%3E %3Cpath fill='none' d='m539.28,241.15c1.685-0.301,2.508-2.208,3.415-3.44,1.083-1.471,2.627-1.791,4.246-2.561'/%3E %3Cpath fill='none' d='m499.22,291.68c0.955-1.316,1.789-2.826,2.937-3.958'/%3E %3Cpath fill='%2339b54a' d='m492.65,309.16c0.664-1.44,0.851-3.01,1.944-4.182,1.209-1.295,3.299-2.666,4.895-3.418,4.459-2.102,10.476-1.276,14.218-4.752-1.597,4.512-7.271,8.457-11.465,10.437-1.754,0.828-3.613,1.609-5.531,1.919-1.503,0.242-3.398-0.085-4.827,0.379'/%3E %3Cpath fill='none' d='m492.9,309.28c1.449-0.662,2.328-2.016,3.604-2.83,1.471-0.938,3.054-1.658,4.703-2.182,2.004-0.633,4.092-1.269,6.043-2.113,0.741-0.32,3.019-1.34,3.143-2.067'/%3E %3Cpath fill='none' d='m497.13,306.35c1.39,0.38,2.683,1.349,4.214,0.511'/%3E %3Cpath fill='none' d='m500.56,304.43c2.556,0.015,4.573,0.359,7.022-0.766'/%3E %3Cpath fill='none' d='m497.37,306.15c0.557-0.579,0.645-1.432,1.112-2.083,0.451-0.629,1.154-1.177,1.57-1.806'/%3E %3Cpath fill='none' d='m501.58,303.92c0.533-0.621,1.048-1.233,1.761-1.693,0.698-0.453,1.809-0.623,2.325-1.371'/%3E %3Cpath fill='none' d='m491.62,308.57c0.271-1.812,1.585-3.127,2.337-4.71,0.487-1.026,0.933-3.061,0.983-4.168'/%3E %3Cpath fill='%2339b54a' d='m493.27,305.39s0.747-10.679,0.427-11.853c-0.321-1.174-7.902-8.436-5.019-26.588,0,0,1.709-6.086,0.961-7.581,0,0,6.3,15.376,6.727,19.967,0.428,4.592-0.746,12.067-1.174,13.882-0.427,1.815-1.175,6.727-1.175,6.727'/%3E %3Cpath fill='none' d='m490.06,264.17c-0.072,2.198,0.502,4.466,0.75,6.62,0.244,2.132,0.432,4.126,0.983,6.165,0.709,2.619,1.699,5.315,2.029,8.021,0.288,2.36,0.188,4.781,0.188,7.17'/%3E %3Cpath fill='%2339b54a' d='m494.34,293.64c0.169-1.987-1.819-4.61-3.096-5.98'/%3E %3Cpath fill='none' d='m493.91,285.53c-0.445-1.434,1.175-4.395,1.388-5.979'/%3E %3Cpath fill='%2339b54a' d='m494.02,286.6c0.453-3.275-5.132-3.773-5.019-6.727'/%3E %3Cpath fill='none' d='m492.84,280.29c0.357-1.668,2.668-2.98,2.029-4.912'/%3E %3Cpath fill='none' d='m491.88,277.09c-0.255-1.063-0.954-2.122-1.466-3.096-0.468-0.888-1.416-1.534-1.737-2.456'/%3E %3Cpath fill='none' d='m491.24,273.35c0-2.195,0.64-3.962,0.64-6.087'/%3E %3C/g%3E %3Cg id='palm' stroke='%23000'%3E %3Cg fill='%23009c4f' stroke-width='0.4315' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath d='m706.69,299.29c-0.764-11.431-6.036-56.734-16.338-71.321,0,0,9.997,14.142,11.095,76.807l5.243-5.486z'/%3E %3Cpath d='m705.16,292.54c-5.615-35.752-25.082-67.015-25.082-67.015,7.349,15.128,20.257,53.835,23.641,77.449l2.328-2.238-0.887-8.196z'/%3E %3Cpath d='m674.47,227.34c16.469,29.836,23.278,73.261,24.321,80.452l5.789-5.565c-5.346-33.638-30.11-74.887-30.11-74.887'/%3E %3Cpath d='m664.8,224.38c2.815,4.744,15.4,29.582,20.514,43.938,4.141,11.628,8.347,32.79,10.206,42.734l7.125-6.849c-6.56-30.92-33.85-73.69-37.84-79.82'/%3E %3Cpath d='m654.57,221.39s21.012,32.359,27.469,54.44c2.043,6.989,8.146,28.02,10.461,37.934l8.215-6.551c-6.506-19.03-26.893-67.197-46.145-85.823'/%3E %3Cpath d='m654.81,240.03c10.932,14.653,29.603,49.287,34.662,76.938l9.453-9.088c-8.159-22.15-34.411-55.826-44.115-67.85'/%3E %3Cpath d='m661.97,260.62c13.04,17.111,23.015,45.735,23.745,59.024l8.084-6.549c-8.229-22.019-31.829-52.475-31.829-52.475'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.2665' stroke-linecap='round'%3E %3Cpath d='m823.61,452.48c-3.0012-14.104-10.055-29.283-16.957-42.468'/%3E %3Cpath d='m829.61,446.19c-6.6042-19.317-18.144-41.614-31.064-61.325'/%3E %3Cpath d='m827.66,427.33c-7.9535-20.237-24.31-59.792-36.915-75.736'/%3E %3Cpath d='m834.41,435.46c-5.702-21.771-18.308-50.745-25.061-64.391'/%3E %3Cpath d='m836.36,428.87c-6.0024-24.07-13.654-45.227-18.459-56.265'/%3E %3Cpath d='m840.26,432.09c-1.8009-19.164-11.706-51.052-19.208-67.764'/%3E %3Cpath d='m838.16,408.17c-0.7498-9.3518-3.751-28.669-5.8511-37.101'/%3E %3C/g%3E %3C/g%3E %3Cg id='flag2' fill='none' stroke='%23000' stroke-width='0.458' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='%23b1babf' d='m486.92,512.12c-0.046,0.094-0.086,0.165-0.111,0.179,0,0-2.727,1.422-5.709,1.624,0,0-2.696,8.413-5.89,11.002,3.716-2.491,9.801-4.766,11.332-4.928,0.078-2.352,0.509-5.128,2.017-6.002l0.218-0.048h0.001c-0.525-0.683-1.147-1.297-1.858-1.827z'/%3E %3Cpath stroke-width='0.23' d='m476.77,523.52,10.946-10.447'/%3E %3Cpath stroke-width='0.23' d='M486.55,519.85,481.11,513.77'/%3E %3Cpath fill='%23b1babf' d='m527.78,478.26-37.48,35.647-1.26,0-2.293-2.064,0.115-1.604,37.709-35.76,3.209,3.781'/%3E %3Cpath stroke-width='0.23' d='m488.69,512.19,35.186-33.01'/%3E %3Cpath fill='%23fd0' d='m517.38,449.99c-24.757-15.589-28.807-63.192-28.425-69.688s0.61-82.524,0.61-82.524l7.326,7.2c-13.332-13.352-28.932-28.999-36.852-37.016-2.537-2.569-0.719,99.609-0.719,144.98,0,21.273,13.271,96.323,91.104,58.556,0,0,38.888-13.962,50.247-30.79-2.648,0-5.267-0.169-7.853-0.494-1.182,0.633-2.445,1.225-3.774,1.774-44.894,30.249-71.664,7.999-71.664,7.999z'/%3E %3Cpath fill='%23034ea2' d='m488.96,380.3c-0.382,6.495,3.668,54.1,28.425,69.688,0,0,26.77,22.25,71.665-7.998-13.575,5.598-24.652,6.783-31.911,4.635-21.701-6.418-44.645-31.48-48.312-56.849-3.668-25.369-2.751-75.189-2.751-75.189l3.259,2.842c-3.621-3.623-7.898-7.904-12.438-12.451l-7.326-7.2c0-0.001-0.229,76.027-0.611,82.522z'/%3E %3Cpath fill='%23ed1c24' d='m520.74,347.46c-0.217-2.3-0.384-10.479-0.392-19.398-5.119-5.118,0.969,1.162-10.954-10.77l-3.323-3.415s-0.004,1.036-0.013,1.636c-0.104,6.892-0.609,50.931,2.766,74.271,3.667,25.369,25.983,50.432,47.684,56.85,7.26,2.148,18.964,0.964,32.538-4.635,0.916-0.618,1.839-1.253,2.771-1.914-39.245-5.588-66.326-42.184-71.077-92.625z'/%3E %3Cpath stroke-width='0.23' d='M519.52,327.41,460.39,267.92'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m458.98,264.71c-0.912-0.904-2.003-1.46-3.055-1.648,0.162-0.7,0.07-1.321-0.321-1.708-0.832-0.827-2.691-0.298-4.153,1.178-1.461,1.477-1.971,3.344-1.139,4.169,0.39,0.387,1.007,0.472,1.701,0.306,0.197,1.056,0.764,2.147,1.679,3.054,1.945,1.927,4.707,2.292,6.167,0.815,1.461-1.477,1.067-4.238-0.879-6.166z'/%3E %3Cpath d='m458.96,267.62-0.175-0.332c0.001,0,0.062,0.125,0.175,0.332z'/%3E %3Cpath d='m467.89,271.31-1.349,1.035c0.444-0.233,0.895-0.57,1.349-1.035z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m460.84,324.05c0.306-0.993,0.458-8.712,0.458-10.315,0-1.605,0.382-2.522,1.528-10.163,1.146-7.642,0.611-11.997,0.153-16.658-0.459-4.661,0.993-14.656,0.993-14.656l-2.839-2.08c-0.191,0.719-0.5,1.966-0.989,4.138-1.04,4.624-0.231,20.118-0.81,25.437-0.577,5.318-1.618,12.603-1.733,15.725-0.002,0.065-0.01,0.126-0.015,0.188-0.035,3.698,1.112,8.231,1.112,8.231'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m458.64,267.84s-2.658,8.44-2.544,15.724c0.116,7.285-0.809,17.344-0.925,18.847-0.115,1.503-2.081,11.794-0.924,15.378l1.387,1.965s1.769-1.112,1.952-4.089c0.003-0.063,0.011-0.123,0.013-0.188,0.116-3.122,1.156-10.406,1.735-15.726,0.578-5.319-0.231-20.813,0.809-25.437,0.489-2.172,0.798-3.418,0.989-4.138,0.216-0.812,0.283-0.95,0.283-0.95l-2.775-1.386z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m466.62,265.65c-1.457,0.486-5.995,1.31-7.411,1.562-0.27,0.048-0.427,0.076-0.425,0.076,6.5,0.134,9.107,4.027,9.107,4.027l2.197-2.659c1.965-3.237-1.735-3.584-3.468-3.006z'/%3E %3Cpath fill='%23ed1c24' stroke-width='0.344' d='m458.78,267.28,0.175,0.332c0.763,1.393,3.938,6.644,7.584,4.731l1.35-1.035c-0.001,0-2.608-3.894-9.109-4.028z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m459.21,267.21s5.095-5.278,5.961-5.508c0.866-0.229,1.401,1.147,1.859,1.911,0.459,0.764,0.534,1.834-2.522,2.674-3.055,0.84-2.267,0.241-5.298,0.923z'/%3E %3Cpath fill='%23034ea2' stroke-width='0.344' d='m467.66,260.33c-2.196-3.931-6.244-1.734-6.244-1.734-4.011,2.005-2.978,7.315-2.633,8.69,0.053,0.21,0.09,0.328,0.09,0.328,7.4-11.562,8.671-2.428,8.671-2.428,0.463-2.081,0.116-4.856,0.116-4.856z'/%3E %3Cpath fill='%23e8b909' stroke-width='0.5307' d='m558.44,469.55c0.2843-4.7866,0.63967-11.427-3.0631-11.657-3.7406-0.23189-4.1338,6.4063-4.4175,11.223,2.1982,0.16631,4.0839,0.3619,7.4818,0.49307' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Ccircle fill='%23e8b909' stroke-width='0.458' cx='455.517' cy='318.822' r='2.089'/%3E %3Cpath d='m454.26,324.19s-0.558,5.841-0.611,6.176'/%3E %3Cpath d='m455.88,324.26s0.068,4.427-0.278,6.263'/%3E %3Cpath fill='%23e8b909' stroke-width='0.5307' d='m560.55,463.61s0.38633,5.1707,0.11579,7.342m-1.9718-7.3034s-0.23157,6.8677-0.2694,7.2624m5.0612,0.0797c-3.4001,0.0785-5.2928,0-7.4949,0,0-4.7959-0.001-11.447,3.7475-11.447,3.7085,0,3.7475,6.651,3.7475,11.447z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Ccircle fill='%23e8b909' cx='459.27' cy='321.64' r='2.089'/%3E %3Cellipse fill='%23c0cad0' stroke-width='0.23' cx='452.96' cy='264.03' rx='1.974' ry='3.499' transform='matrix(0.7101,0.7041,-0.7041,0.7101,317.193,-242.381)'/%3E %3Cpath fill='%23b1babf' stroke-width='0.344' d='m448.94,274.96s-2.805-1.607-3.076-4.923c-0.191-2.317,1.43-4.409,2.434-5.48,0.474,0.338,0.877,0.535,1.074,0.541l0.608-0.354,2.159-2.231,1.364-1.342c0.506-0.628,0.856-1.151,0.864-1.36l-0.196-0.492c1.751-1.917,5.711-6.564,3.937-7.736-1.513-0.985-6.032,2.679-7.56,3.983l-0.733-0.317c-0.213,0.023-0.575,0.276-1.026,0.639-0.691-1.393-2.674-5.698-3.121-10.403,0,0-15.828-4.694-20.832-10.677,4.843,6.991,9.442,18.548,9.841,21.462,4.083,0.013,8.867,0.626,10.881,3.012-0.286,0.375-0.484,0.709-0.49,0.869-0.05,0.379,0.072,0.803,0.272,1.223-0.573,0.585-2.485,2.355-4.978,2.795-2.995,0.536-5.738-2.717-5.738-2.717l-0.05-0.003c-0.339,1.074-0.521,2.22-0.521,3.41,0,6.127,4.838,11.094,10.806,11.094,1.492,0,2.913-0.31,4.206-0.872l-0.125-0.121z'/%3E %3Cpath stroke-width='0.23' d='m426.06,236.42,21.319,21.319'/%3E %3Cpath stroke-width='0.23' d='M434.65,256.4,445.53,245.69'/%3E %3Cpath stroke-width='0.344' d='m446.18,260.15c0.06-1.876,1.598-3.353,3.435-3.294,1.838,0.06,3.276,1.633,3.216,3.508s-1.598,3.352-3.434,3.293c-1.837-0.058-3.277-1.632-3.217-3.507z'/%3E %3Cpath stroke-width='0.2665' d='m533,389.88c-0.27398,2.299,0.93199,7.1781,3.3485,9.6457s6.203,4.3181,10.265,3.8133' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3C/g%3E %3Cuse xlink:href='%23flag2' transform='matrix(-1,0,0,1,1440,0)'/%3E %3Cg id='flag3' stroke='%23000' stroke-width='0.458' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath fill='%23fd0' d='m581.88,467.92c-6.188,0.174-17.652,1.607-17.652,1.607s-19.972,26.468-20.453,32.003c-0.481,5.534-0.481,10.105,12.753,8.181,0,0,6.407-1.212,11.691-1.61,5.823-1.894,6.458-0.508,7.07-0.112,0.469-2.016,1.604-6.858,2.965-12.491,2.694-11.151,6.275-25.383,7.347-26.873,0.018-0.13,0.035-0.261,0.052-0.389-0.336-0.297-1.778-0.371-3.773-0.316z'/%3E %3Cpath fill='%23ed1c24' d='m587.08,458.22s-0.287,1.865-0.729,4.964l5.302,2.495s-0.481,7.699-0.722,12.271c-0.159,3.019-2.205,23.759-3.578,37.508-0.461,4.622-0.847,8.45-1.059,10.552,0.271,4.221-3.063,8.007-3.063,8.007-2.235,2.17-3.333,3.96-3.678,5.41-0.037,0.443-0.075,0.86-0.113,1.247,0.012,0.17,0.036,0.334,0.071,0.492,0.571,2.545,4.038,3.488,6.366,3.197,3.851-0.48,11.076-5.087,11.076-5.087l0.715-73.117-10.588-7.939z'/%3E %3Cpath fill='%23034ea2' stroke-linecap='round' d='m586.35,463.18c-0.205,1.439-0.445,3.146-0.704,5.053,0.102,0.09,0.105,0.198-0.01,0.329-0.013,0.017-0.028,0.04-0.042,0.061-1.071,1.489-4.653,15.722-7.348,26.873-1.361,5.633-3.018,12.359-3.486,14.375-0.571,1.254-10.672,12.838-10.862,16.596-0.077,1.537,1.163,2.463,4.653,2.253,5.325-0.319,9.045-1.291,11.687-1.945,3.326-0.823,4.94-1.144,5.879,0.983,0,0,0.065-0.635,0.178-1.751,0.212-2.103,0.597-5.929,1.058-10.552,1.373-13.749,3.419-34.489,3.578-37.508,0.241-4.571,0.722-12.271,0.722-12.271l-5.303-2.496z'/%3E %3Cpath fill='%23ebc900' stroke-width='0.456' d='m574.87,507.48c-0.418-0.309-0.122-1.375-7.419,0.681-1.628,7.314-3.555,18.309-3.555,18.309,0.036-3.718,7.813-11.375,10.061-14.845,1.134-1.751,1.443-3.269,0.913-4.145z'/%3E %3Cpath fill='%23023f88' stroke-width='0.462' d='m585.7,529.77c0.215-0.833,0.511-2.013,0.511-2.013-0.952-2.126-2.588-1.806-5.961-0.982-0.176,4.412-0.398,9.329-0.678,12.676,0.349-1.45,1.445-3.268,3.711-5.437,0,0,1.691-1.434,2.417-4.244z'/%3E %3C/g%3E %3Cuse xlink:href='%23flag3' transform='matrix(-1,0,0,1,1435.184,0)'/%3E %3C/g%3E %3Cg id='condor_tail' fill='%23452c25' stroke='%23000' stroke-width='0.473' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'%3E %3Cpath stroke-width='0.585' d='m593.68,214.48s-8.426,19.153-5.515,21.053c0,0,8.549-14.868,16.052-20.496,3.902-3.601,6.274,0.032,6.777-3.135,0.502-3.168-10.267-7.711-10.267-7.711l-6.894,9.497'/%3E %3Cpath d='m562.94,229.06s-12.246,20.868-9.035,21.113c3.211,0.246,16.305-26.609,16.305-26.609l-4.464,0.748-2.806,4.748z'/%3E %3Cpath d='m566.64,223.25s-12.8,20.532-9.598,20.863c3.203,0.332,17.012-26.163,17.012-26.163l-4.482,0.629-2.932,4.671z'/%3E %3Cpath d='m569.23,219.67s-14.575,19.312-11.414,19.928c3.16,0.615,19.27-24.548,19.27-24.548l-4.521,0.228-3.335,4.392z'/%3E %3Cpath d='m573.13,216.28s-17.065,17.151-14.019,18.19c3.047,1.039,22.43-21.698,22.43-21.698l-4.51-0.39-3.901,3.898z'/%3E %3Cpath d='m573.74,210.04s-14.893,19.069-11.743,19.736,19.674-24.225,19.674-24.225l-4.523,0.153-3.408,4.336z'/%3E %3Cpath d='m569.94,226.43s-14.575,19.312-11.414,19.928c3.16,0.615,19.27-24.548,19.27-24.548l-4.521,0.228-3.335,4.392z'/%3E %3Cpath d='m578.14,222.61s-8.532,15.721-7.558,16.371c0.976,0.65,11.337-8.965,16.457-18.32s-9.265,1.559-9.265,1.559'/%3E %3Cpath stroke-width='0.585' d='m586.61,219.12s-8.426,19.153-5.515,21.053c0,0,10.569-11.555,13.329-20.736,2.757-9.181,0-0.633,0-0.633l-0.767-9.973-6.894,9.497'/%3E %3Cpath stroke-width='0.585' d='m579.05,221.05s-8.426,19.153-5.515,21.053c0,0,10.569-11.555,13.329-20.736,2.757-9.181,0-0.633,0-0.633l-0.767-9.973-6.894,9.497'/%3E %3Cpath d='m574.68,219.38s-17.066,17.151-14.02,18.19,22.431-21.698,22.431-21.698l-4.511-0.39-3.9,3.898z'/%3E %3Cpath d='m576.03,221.7s-17.066,17.151-14.02,18.19c3.048,1.039,22.431-21.698,22.431-21.698l-4.51-0.39-3.901,3.898z'/%3E %3Cpath d='m577.39,224.42s-17.065,17.151-14.019,18.19,22.43-21.698,22.43-21.698l-4.51-0.39-3.901,3.898z'/%3E %3Cpath d='m578.66,200.87s-12.678,15.851-10.851,18.58c1.829,2.729,13.41-7.277,17.067-14.292,3.657-7.016-6.095-4.807-6.095-4.807'/%3E %3Cpath d='m578.26,217.71s-10.867,20.358-8.063,19.189c2.804-1.17,13.82-16.48,15.039-19.858,1.22-3.378,0.809-6.908,0.809-6.908l-8.412,5.067,0.722,3.944'/%3E %3Cpath stroke-width='0.404' d='m578.33,211.01s9.018-16.228-0.063,3.056c-9.08,19.284-12.477,16.1-12.477,16.1-0.7-1.097,7.896-14.163,7.896-14.163s6.383-10.054,7.913-11.009'/%3E %3Cpath stroke-width='0.431' d='m588,208.86s10.029-16.116-0.024,3.06c-10.054,19.176-13.976,15.935-13.976,15.935-0.815-1.111,8.783-14.066,8.783-14.066s7.122-9.971,8.851-10.905'/%3E %3Cpath d='m588.39,209.96s-10.125,21.095-7.809,22.654c0,0,8.411-9.485,10.605-17.02,2.193-7.536,0-0.52,0-0.52l2.812-13.559'/%3E %3Cpath d='m598.82,205.26s-10.125,21.095-7.81,22.654c0,0,8.411-9.485,10.606-17.021,2.194-7.536,0-0.52,0-0.52l2.811-13.559'/%3E %3Cpath d='m584.32,202.05s-12.678,15.851-10.851,18.58c1.829,2.729,13.41-7.277,17.067-14.292,3.657-7.016-6.095-4.807-6.095-4.807'/%3E %3C/g%3E %3Cg id='fasces' fill='%23c69024' stroke='%23000' stroke-width='0.5307'%3E %3Cpath fill='%23b1babf' stroke-width='0.458' d='m682.1,459.3c0,2.913-0.97,3.466-0.97,3.466h-149.07v-6.634h149.08s0.97,0.255,0.97,3.168z' transform='matrix(1.146366,0,0,1.1711652,33.17831,82.13841)'/%3E %3Cpath fill='%23b87510' d='m655.42,620.46c0,1.1653,0.024,2.3236,0.0677,3.476h126.56c0.044-1.1478,0.069-2.3013,0.069-3.4631,0-1.3691-0.03-2.73-0.089-4.0803h-126.52c-0.0573,1.3468-0.0894,2.703-0.0894,4.0675z'/%3E %3Cpath fill='%23b76e11' d='m655.51,616.38,126.52,0c-0.084-1.9137-0.2235-3.8074-0.4207-5.6813h-125.68c-0.19832,1.8739-0.33818,3.7688-0.42185,5.6813z'/%3E %3Cpath fill='%23ac620e' d='m655.94,610.69,125.68,0c-0.1972-1.8821-0.454-3.7442-0.7624-5.5829h-124.15c-0.31066,1.8387-0.5663,3.7009-0.76348,5.5829z'/%3E %3Cpath fill='%23a2550b' d='m776.82,599.51-116.1,0c-2.3328,0-3.7016,3.695-4.0215,5.5829h124.15c-0.3164-1.8868-1.8112-5.5829-4.0226-5.5829z'/%3E %3Cpath fill='%23b76e11' d='m655.91,630.01,125.72,0c0.2075-2.0004,0.3462-4.0241,0.4219-6.069h-126.56c0.0734,2.046,0.21437,4.0686,0.41957,6.069z'/%3E %3Cpath fill='%23ac620e' d='m656.56,634.94,124.43,0c0.258-1.6244,0.4746-3.2664,0.6455-4.926h-125.72c0.17195,1.6596,0.38862,3.3027,0.64656,4.926z'/%3E %3Cpath fill='%23a2550b' d='m660.71,640.2,116.09,0c2.2755,0,3.9034-3.476,4.1831-5.2456h-124.43c0.28086,1.7708,1.7184,5.2456,4.1487,5.2456z'/%3E %3Cpath d='m671.4,640.34c-1.1441-3.6107-1.9534-12.013-2.0875-20.901-0.13528-8.8903,2.5598-20.276,2.5598-20.276h-6.2683s-2.6963,11.387-2.5598,20.276c0.13297,8.888,0.94231,17.29,2.0875,20.901h6.2683z'/%3E %3Cpath d='m766.43,640.4c1.1464-3.6107,1.9545-12.013,2.0898-20.902,0.133-8.8891-2.561-20.276-2.561-20.276h6.2672s2.6963,11.387,2.561,20.276c-0.1353,8.8891-0.9435,17.291-2.0887,20.902h-6.2683z'/%3E %3Cpath d='m708.86,640.34c-0.93773-5.3909-1.0455-12.527-1.0455-20.901,0-8.3738,0.88271-17.899,1.5166-20.276h-6.2683c-1.1085,3.551-1.5178,13.033-1.5178,20.276,0,7.2425,0.21209,15.684,1.0455,20.901h6.2695z'/%3E %3Cpath d='m728.44,640.34c0.93773-5.3909,1.0455-12.527,1.0455-20.901,0-8.3738-0.88384-17.899-1.5166-20.276h6.2672c1.1097,3.551,1.5178,13.033,1.5178,20.276,0,7.2425-0.20979,15.684-1.0455,20.901h-6.2683z'/%3E %3Cpath stroke-width='0.5481' d='m686.12,620.17c3.7016,6.6452,11.281,20.39,11.281,20.39l5.2962-0.157s-3.086-6.5433-11.43-20.636c-8.3444-14.093-13.942-20.821-13.942-20.821l-5.2974,0.15811s10.392,14.419,14.092,21.066z'/%3E %3Cpath stroke-width='0.5481' d='m751.71,620.17c-3.7017,6.6452-11.283,20.39-11.283,20.39l-5.2962-0.157s3.0872-6.5433,11.432-20.636c8.3421-14.093,13.942-20.821,13.942-20.821l5.2973,0.15811s-10.392,14.419-14.092,21.066z'/%3E %3Cpath stroke-width='0.5481' d='m749.23,620.17c3.7005,6.6452,11.281,20.39,11.281,20.39l5.2962-0.157s-3.0872-6.5433-11.432-20.636c-8.3444-14.093-13.942-20.821-13.942-20.821l-5.2962,0.15811c0.0009,0,10.392,14.419,14.092,21.066z'/%3E %3Cpath fill='%23b1babf' d='m634.54,627.22s2.7719-13.451-1.6313-21.006c-4.4032-7.5552-10.11-9.7675-11.414-9.2136-1.3057,0.55397,14.012-22.667,30.325-0.36892,0,0-14.346,1.6595-11.41,29.668'/%3E %3Cpath fill='%23d3dce0' stroke='none' d='m623.71,597.01c4.4536-4.9634,14.812-12.417,25.969,0.29044,1.2667-0.56918,2.1357-0.67107,2.1357-0.67107-16.312-22.297-31.628,0.92289-30.324,0.36774,0.36569-0.1546,1.0787-0.0903,2.0119,0.24479,0.0688-0.0773,0.13872-0.1546,0.2075-0.2319'/%3E %3Cpath fill='%23b1babf' d='m631.92,622.28c-1.2942,0.44621-5.1999,1.9184-8.3983,4.6202,0,0-10.853-5.9191-17.866-6.5117-0.59611-0.0504-1.1853-0.13585-1.7173-0.10308,0.54797-0.10068,1.128-0.14639,1.6989-0.27756,7.1178-1.6385,15.85-5.4471,17.754-6.9263,2.5461,2.5836,5.898,5.2292,8.6298,4.995'/%3E %3Cpath fill='none' stroke-width='0.3986' d='m605.71,620.21,26.483,0'/%3E %3Cpath fill='none' stroke-width='0.3986' d='m623.45,612.98,0.10663,13.702'/%3E %3Cpath fill='%23b1babf' d='m640.52,627.22c-0.20864,4.1729-1.3814,7.369-2.8017,7.369-1.441,0-2.6286-3.2898-2.8109-7.5552'/%3E %3Crect fill='%23b1babf' width='13.046' height='13.636' x='631.2' y='613.4'/%3E %3Crect fill='none' width='7.8274' height='8.1794' x='633.81' y='616.12'/%3E %3Crect fill='none' width='3.1307' height='3.2734' x='636.16' y='618.58'/%3E %3Cpath fill='none' d='m649.58,597.36c0.0344-0.0164,0.26481-0.0903,0.30149-0.10656,1.2094-0.52702,2.0302-0.62306,2.0302-0.62306-16.312-22.298-31.629,0.92288-30.324,0.36892,0.3462-0.14639,1.0008-0.0984,1.8606,0.19208,0.0516,0.0164,0.16508,0.0891,0.21552,0.10896'/%3E %3Cpath fill='none' stroke-width='0.2665' d='m649.56,597.28c-11.256-12.768-21.693-5.0419-26.063-0.0867'/%3E %3Cpath stroke-width='0.5481' d='m688.61,620.17c-3.7005,6.6452-11.281,20.39-11.281,20.39l-5.2962-0.157s3.0872-6.5433,11.43-20.636c8.3444-14.093,13.942-20.821,13.942-20.821l5.2974,0.15811s-10.392,14.419-14.092,21.066z'/%3E %3C/g%3E %3Cg id='shield' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'%3E %3Cpath transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' fill='url(%23grad1)' d='m631.37,476.35c0,62.571,39.414,113.29,88.034,113.29s88.033-50.723,88.033-113.29c0-62.572-39.413-113.3-88.033-113.3s-88.034,50.723-88.034,113.3'/%3E %3Cpath fill='%23395054' stroke='%23000' stroke-width='0.458' d='m641.6,329.09c3.347-2.147,6.543-2.111,10.553-3.377,2.785-0.88,6.16-1.054,8.864-1.688,2.477-0.58,9.951,4.315,12.452,5.065l0.169,6.794s-12.391,1.301-16.815-0.371c-4.425-1.671-15.223-6.845-15.223-6.845'/%3E %3Cpath fill='%23006c3c' d='m567.06,345.54c1.395,1.133,0.231,1.621-0.579,2.547-0.463,0.53,2.663,2.894,6.02,3.936,1.399,0.435,2.084,1.273,2.548,1.968,0.463,0.694,1.505,1.39,3.126,2.548,1.619,1.156,0.347,1.505,4.168,1.62,3.819,0.115,5.324,1.042,6.83,1.39,1.505,0.347,2.431,0.579,6.136,1.042,3.704,0.463,16.832-0.035,16.484,0.081-0.347,0.116-9.199,1.942-10.01,2.407-0.81,0.463-4.97-0.521-5.781-0.058-0.81,0.463-1.62,1.157-2.547,1.853-0.926,0.694-0.23,0.926,0.695,1.157s1.968,0.464,3.589,1.273c1.62,0.81,1.62,0.926,5.209,1.389,3.589,0.464,2.2,0,5.557,0.695,3.358,0.694,2.548,0.463,6.368,0.579,3.82,0.115,0.811,0.463,5.788,0.116,4.979-0.349,3.821-0.232,5.788-0.232,1.968,0,1.969-0.347,4.168-0.463s3.746,3.279,1.547,3.279,1.727-0.689,0.223-0.573c-1.505,0.116-5.475-0.275-6.284,0.188-0.811,0.464-1.62,1.39-3.82,3.012-2.2,1.62-0.463,2.43,0.231,2.893,0.694,0.464,1.736,0.695,2.663,1.042,0.926,0.349,1.852,0.232,4.747,1.274,2.894,1.041,3.588,1.157,5.44,1.272,1.853,0.116,4.516,0.812,4.516,0.812s3.589,1.505,5.44,1.621c1.853,0.115,1.157,0.463,3.473,1.504,2.315,1.042,2.199,0.231,4.053,0.231,1.852,0,2.546,0.232,3.588,0.927,1.042,0.693,2.548,1.273,2.548,1.273s-0.811,2.199-8.452,14.587c-7.64,12.388-19.449,19.796-28.131,24.658-8.683,4.862-20.028,5.441-36.004,3.82-15.977-1.621-31.489-17.712-38.204-26.048-6.714-8.335-9.377-16.671-9.377-16.671l1.389-0.114c0.812-0.116,1.621-0.232,2.895-0.464,1.273-0.232,1.158-0.116,2.663-0.464s1.968-0.348,3.356-0.926c1.391-0.578,0.926-0.81,3.126-1.389s1.505-0.463,2.084-0.579c0.578-0.115,1.505-0.231,2.778-0.695,1.273-0.463,2.779-1.156,1.39-1.852s0-0.812,0-0.812,1.505,0.116,3.588,0.232c2.084,0.115,1.274,0.347,2.663,0.463,1.39,0.116,1.273,0,2.315-0.231,1.042-0.232-0.231-1.389-0.463-2.547-0.231-1.157-0.811-0.463-1.273-0.927-0.463-0.463-0.926-0.23-2.431-1.157-1.506-0.926-1.042-0.115-4.284-1.157-3.241-1.041-0.34,0.934-4.392-0.225s-1.801,0.813-5.157-0.229c-3.358-1.042-4.459-3.367-1.333-2.904s0.926-0.116,1.273-0.579,0.927-0.116,2.778-0.231c1.853-0.116,1.621,0,3.357-0.115,1.735-0.116,2.432-0.579,2.432-0.579s1.504,0.579,2.546,0.579,0.695-0.231,0.695-0.926,1.042,0,1.852,0.23c0.812,0.232,2.778-0.115,2.778-0.115s0.927-0.115,2.663-0.115c1.737,0,0.695-0.349,2.315-0.928,1.621-0.578,0-1.156-0.578-1.272-0.579-0.116-0.695-0.349-1.506-1.042-0.81-0.694-1.491-1.113-2.533-1.46-1.042-0.348-7.137,0.445-8.642-0.018s-1.443-2.343,1.566-2.459c3.01-0.115,1.158,0,2.663,0s1.157,0.231,1.736,0.231c0.578,0,1.157,0,3.589-0.347,2.431-0.349,1.389-0.464,3.01-1.158s3.356-0.463,4.747-1.041c1.389-0.579-0.579-1.158-2.316-1.969-1.736-0.811,0,0.464-1.272-0.811-1.273-1.272-7.747-4.99-9.716-6.726-1.813-1.602,1.563-1.004,3.27-1.77,0,0,0.737-1.683-1.157-2.313-1.893-0.632-1.683-0.632-3.682-1.368s-2.946-2.104-4.419-2.42c-1.474-0.316-2.209-0.737-2.209-0.737'/%3E %3Cpath fill='%236dbe45' d='m567.06,345.54c-0.884,0.65-0.884,1.528-0.579,2.547,0.203,0.674,1.541,3.502,4.898,4.544,1.398,0.434,3.205,0.665,3.669,1.359,0.463,0.694,1.505,1.39,3.126,2.548,1.619,1.156,0.347,1.505,4.168,1.62,3.819,0.115,5.324,1.042,6.83,1.39,1.505,0.347,2.431,0.579,6.136,1.042,3.704,0.463,16.16,0.146,15.813,0.263-0.347,0.116-11.132,2.313-11.941,2.775-0.811,0.464-2.366-1.07-3.178-0.607-0.81,0.463-1.62,1.157-2.547,1.853-0.926,0.694-0.23,0.926,0.695,1.157s1.968,0.464,3.589,1.273c1.62,0.81,1.62,0.926,5.209,1.389,3.589,0.464,2.2,0,5.557,0.695,3.358,0.694,2.548,0.463,6.368,0.579,3.82,0.115,0.768,0.908,5.746,0.561s3.305,0.076,5.272,0.076,2.538,0.575,4.738,0.459c2.198-0.116,7.378,1.404,5.178,1.404-1.365,0-3.501-0.618-5.92-0.432-1.505,0.115-2.976-0.217-3.785,0.246-0.811,0.464-1.62,1.39-3.82,3.012-2.2,1.62-0.463,2.43,0.231,2.893,0.694,0.464,1.736,0.695,2.663,1.042,0.926,0.349,1.852,0.232,4.747,1.274,2.894,1.041,3.588,1.157,5.44,1.272,1.853,0.116,4.516,0.812,4.516,0.812s3.589,1.505,5.44,1.621c1.853,0.115,1.157,0.463,3.473,1.504,2.315,1.042,2.199,0.231,4.053,0.231,1.852,0,2.546,0.232,3.588,0.927,0.653,0.435,1.489,0.824,2.021,1.056,0,0,4.775-13.075,6.628-18.759,1.854-5.685,3.831-22.119,3.831-23.108,0-0.988-2.718-2.472-3.583-2.224-0.864,0.247-4.571,0.247-5.685,0.247h-15.57c-0.988,0-1.729,0.741-3.584-0.124-1.853-0.865-5.189-1.359-6.302-1.235-1.112,0.123-5.685,0.247-6.672,0.247-0.989,0-11.987-0.495-13.841-0.371s-5.314,0.123-7.538,0c-2.225-0.124-5.066-0.124-6.179-0.248-1.112-0.123-5.189-0.37-6.179,0.372-0.989,0.741-3.707,0.988-4.942,1.235s-4.572,0.865-6.303,0.988c-1.729,0.124-6.797,1.112-8.402,0.865-1.607-0.247-7.073-0.27-7.073-0.27'/%3E %3Cpath fill='%23000' d='m567.06,345.42c-1.023,0.877-0.896,2.158-0.371,3.293,0.899,1.946,2.687,3.356,4.69,4.027,1.148,0.385,2.563,0.43,3.538,1.208,0.308,0.244,0.547,0.65,0.849,0.918,0.543,0.483,1.158,0.891,1.748,1.312,0.632,0.45,1.17,0.871,1.676,1.451,0.429,0.494,1.159,0.518,1.763,0.57,1.449,0.129,2.887,0.114,4.325,0.365,1.03,0.18,2.02,0.512,3.009,0.838,1.644,0.541,3.398,0.8,5.105,1.044,4.094,0.585,8.229,0.527,12.358,0.512,1.272-0.005,2.545-0.016,3.817-0.021,0.269-0.001,1.339-0.173,1.56,0.022v-0.229c-0.212,0.122-0.57,0.134-0.805,0.184-0.733,0.16-1.469,0.315-2.204,0.473-1.879,0.402-3.758,0.808-5.632,1.238-1.17,0.27-2.36,0.512-3.479,0.951-0.751,0.294-1.874-0.695-2.645-0.763-0.534-0.049-1.201,0.636-1.59,0.927-0.58,0.432-1.321,0.856-1.733,1.459-0.596,0.868,2.825,1.419,3.254,1.575,0.927,0.339,1.772,0.845,2.674,1.237,0.791,0.346,1.667,0.464,2.513,0.592,1.981,0.299,4.002,0.321,5.97,0.684,2.032,0.374,3.892,0.728,5.956,0.756,1.072,0.015,2.193-0.025,3.245,0.211,0.359,0.08,0.651,0.31,1.006,0.397,0.927,0.229,2.029,0.048,2.962-0.015,1.133-0.074,2.279-0.177,3.415-0.125,1.125,0.054,2.375,0.166,3.471,0.347,2.232,0.367,4.461,0.269,6.676,0.793,0.681,0.161,1.446,0.326,2.055,0.689,0.117,0.069,0.075-0.055-0.026-0.023-0.124,0.038-0.274,0.026-0.401,0.029-0.682,0.015-1.373-0.12-2.044-0.215-1.583-0.223-3.098-0.21-4.689-0.19-1.287,0.016-2.444-0.216-3.526,0.601-0.888,0.67-1.704,1.434-2.582,2.115-0.603,0.469-1.741,1.063-1.768,1.968-0.04,1.491,2.179,2.115,3.269,2.468,1.131,0.367,2.262,0.574,3.411,0.871,1.854,0.479,3.598,1.314,5.479,1.699,1.586,0.325,3.221,0.32,4.816,0.641,0.905,0.183,1.716,0.405,2.569,0.734,1.462,0.563,3.008,1.14,4.578,1.278,1.491,0.131,2.502,1.087,3.857,1.67,1.49,0.641,2.891,0.027,4.445,0.083,1.863,0.065,3.188,1.24,4.831,1.965,0.001-0.001,0.003-0.003,0.004-0.004,1.009-2.763,2.006-5.531,2.995-8.3,1.4-3.918,2.978-7.849,4.042-11.874,1.088-4.117,1.693-8.379,2.303-12.588,0.431-2.979,0.901-5.983,1.117-8.987,0.082-1.134-1.162-1.789-2.043-2.219-0.777-0.38-1.34-0.344-2.153-0.248-1.118,0.132-2.262,0.125-3.387,0.139-2.968,0.037-5.938,0.008-8.905,0.008h-5.705c-1.057,0-2.219-0.13-3.262,0.079-1.221,0.244-2.048,0.205-3.218-0.313-1.234-0.548-2.62-0.805-3.948-1.001-1.899-0.283-3.856-0.008-5.768,0.055-3.168,0.102-6.311-0.048-9.478-0.159-3.861-0.137-7.684-0.038-11.542-0.053-2.875-0.011-5.764-0.148-8.636-0.274-1.964-0.087-3.897-0.341-5.863-0.082-0.866,0.115-1.495,0.613-2.308,0.88-1.176,0.388-2.44,0.495-3.654,0.705-2.221,0.385-4.421,0.858-6.671,1.041-2.736,0.223-5.634,1.22-8.385,0.832-2.27-0.319-4.641-0.24-6.93-0.251-0.018,0-0.019,0.229,0,0.229,3.438,0.017,6.928,0.514,10.343,0.095,4.438-0.545,8.833-1.257,13.244-1.976,1.052-0.172,2.229-0.335,3.134-0.938,0.765-0.507,1.892-0.477,2.77-0.505,2.086-0.066,4.177,0.205,6.261,0.262,2.938,0.081,5.866,0.246,8.806,0.198,1.61-0.027,3.2-0.109,4.812-0.075,3.585,0.076,7.166,0.258,10.75,0.36,3.707,0.105,7.341-0.596,10.997,0.238,1.25,0.284,2.406,0.97,3.665,1.159,0.806,0.123,1.574-0.278,2.376-0.278h14.498c1.429,0,2.856,0.001,4.285-0.043,0.833-0.026,1.647-0.084,2.466-0.229,0.889-0.155,2.063,0.673,2.711,1.177,1.086,0.847,0.624,2.126,0.484,3.319-0.228,1.955-0.486,3.907-0.761,5.857-0.621,4.404-1.269,8.847-2.36,13.164-1.013,4.009-2.61,7.917-3.998,11.806-1.019,2.858-2.048,5.712-3.089,8.562-0.016,0.045-2.821-1.528-3.152-1.664-1.101-0.449-2.549-0.421-3.691-0.175-1.06,0.229-1.81,0.06-2.816-0.374-0.868-0.373-1.618-1.105-2.516-1.378-0.959-0.291-2.022-0.269-3.005-0.544-1.03-0.288-2.039-0.663-3.033-1.057-1.585-0.627-3.445-0.864-5.132-0.974-2.452-0.158-4.61-1.149-6.944-1.825-1.933-0.561-4.038-0.705-5.773-1.827-0.308-0.198-0.604-0.39-0.866-0.645-0.866-0.842,0.525-1.766,1.113-2.204,1.004-0.748,1.929-1.591,2.911-2.366,0.938-0.741,1.985-0.642,3.13-0.607,1.721,0.051,3.366-0.04,5.086,0.197,0.32,0.044,2.805,0.672,2.568-0.159-0.092-0.328-1.209-0.527-1.464-0.601-1.036-0.301-2.106-0.506-3.178-0.62-1.133-0.123-2.251,0.006-3.384-0.199-1.041-0.188-2.046-0.239-3.095-0.323-1.154-0.092-2.211-0.19-3.393-0.128-1.632,0.087-3.336,0.456-4.865-0.21-0.748-0.326-1.711-0.264-2.502-0.286-1.031-0.029-2.067,0.002-3.096-0.072-1.736-0.124-3.411-0.703-5.138-0.897-1.855-0.208-3.707-0.307-5.556-0.622-1.594-0.271-2.883-1.111-4.369-1.698-0.979-0.387-2.052-0.504-3.015-0.919-0.479-0.207,1.364-1.557,1.494-1.656,0.455-0.35,0.999-0.861,1.59-0.928,0.729-0.081,1.552,0.604,2.252,0.767,0.37,0.086,0.808-0.176,1.163-0.28,1.326-0.392,2.688-0.673,4.037-0.976,1.631-0.365,3.266-0.715,4.901-1.064,0.691-0.147,1.79-0.17,2.411-0.529,0.026-0.015,0.022-0.21,0-0.229-0.109-0.099-0.589-0.023-0.722-0.024-0.709-0.003-1.419,0.004-2.129,0.008-2.06,0.015-4.12,0.025-6.181,0.013-4.01-0.023-7.961-0.21-11.895-1.063-1.769-0.384-3.447-1.07-5.232-1.382-1.416-0.247-2.852-0.207-4.276-0.334-0.602-0.054-1.159-0.151-1.568-0.62-0.561-0.646-1.215-1.097-1.913-1.594-0.492-0.352-0.981-0.709-1.445-1.097-0.382-0.318-0.637-0.75-1.021-1.056-0.943-0.753-2.587-0.809-3.706-1.185-1.249-0.418-2.336-1.23-3.21-2.2-1.033-1.146-2.269-3.261-0.769-4.547,0.046-0.038-0.026-0.206,0-0.229'/%3E %3Cpath fill='%236dbe45' d='m564.64,348.63c1.232,1.484,0.128,0.47-2.826,2.027-2.321,1.226,10.005,7.528,11.278,8.801,1.272,1.274-0.463,0,1.272,0.812,1.737,0.81,3.705,1.389,2.316,1.968-1.39,0.578-3.126,0.347-4.746,1.042-1.621,0.694-0.579,0.81-3.011,1.157s-3.01,0.348-3.588,0.348c-0.579,0-0.442-0.216-1.948-0.216-1.505,0-0.237,0.303-3.247,0.412-0.298,0.01-4.248,0.448-4.214,0.452,1.898,0.201,6.392,0.39,8.406,0.472,1.113,0.046,2.145,0.573,3.664,1.08,1.042,0.347,1.737,0.81,2.548,1.504,0.811,0.695,0.926,0.926,1.505,1.042s2.199,0.695,0.579,1.274c-1.62,0.578-0.579,0.926-2.315,0.926-1.737,0-2.663,0.116-2.663,0.116s-1.968,0.347-2.779,0.114c-0.81-0.23-1.852-0.926-1.852-0.23s0.348,0.926-0.694,0.926-2.547-0.579-2.547-0.579-0.695,0.464-2.431,0.579c-1.737,0.116-1.505,0-3.358,0.116-1.852,0.116-2.835-0.345-2.778,0.23,0.111,1.124-1.595,0.61-1.307,1.433,0.253,0.084-2.143,0.088-1.952,0.144,3.357,1.042,4.302-0.418,8.354,0.74,4.051,1.158,1.272,0.579,4.515,1.62,3.241,1.042,2.778,0.232,4.283,1.158s1.968,0.693,2.431,1.158c0.463,0.463,1.042-0.232,1.274,0.926,0.23,1.158,1.505,2.314,0.463,2.546s-0.926,0.348-2.315,0.231c-1.39-0.115-0.579-0.347-2.663-0.463-2.084-0.114-3.589-0.23-3.589-0.23s-1.389,0.115,0,0.81c1.39,0.695-0.115,1.39-1.389,1.853-1.274,0.464-2.2,0.58-2.779,0.694-0.579,0.116,0.116,0-2.084,0.579-2.198,0.579-1.735,0.812-3.126,1.39-1.389,0.578-1.852,0.578-3.355,0.926-1.506,0.348-1.391,0.23-2.663,0.463-1.274,0.231-2.084,0.348-2.895,0.464-0.811,0.115-2.309,0.366-2.309,0.366s-5.33-8.628-7.983-19.336c-2.652-10.709-3.854-28.118-3.854-28.971,0-0.854,3.92-0.887,5.247-0.412,1.327,0.474,7.676,0.947,10.614,1.326,2.938,0.38,10.234,1.423,10.804,1.611,0.567,0.19,2.31-0.956,3.73-0.008,1.423,0.948,5.557,3.799,5.557,3.799'/%3E %3Cpath fill='%23000' d='m564.64,348.74c0.169,0.206,0.66,0.573,0.277,0.723-0.346,0.136-0.75,0.177-1.108,0.272-0.603,0.16-2.034,0.445-2.273,1.113-0.182,0.508,0.287,1.027,0.599,1.356,1.093,1.157,2.545,2.027,3.874,2.883,1.563,1.007,3.165,1.953,4.753,2.92,0.557,0.34,1.111,0.684,1.653,1.046,0.178,0.118,0.351,0.242,0.517,0.373,0.057,0.045,0.109,0.094,0.161,0.143,0.126,0.124,0.247,0.252,0.363,0.385,0.125,0.238,0.17,0.235,0.135-0.012-0.178,0.089,0.71,0.409,0.774,0.438,0.693,0.311,1.396,0.601,2.079,0.933,0.955,0.466,0.252,0.828-0.427,1.021-0.827,0.236-1.72,0.263-2.567,0.398-0.986,0.156-1.874,0.523-2.674,1.107-0.829,0.607-2.316,0.548-3.284,0.67-0.682,0.085-1.366,0.152-2.054,0.155-0.813,0.004-1.59-0.238-2.425-0.206-0.353,0.013-0.646,0.16-0.981,0.238-0.729,0.169-1.497,0.123-2.239,0.193-1.28,0.124-2.598,0.201-3.865,0.424-0.021,0.003-0.018,0.227,0,0.229,4.912,0.497,10.552-0.347,14.618,3.056,0.416,0.35,0.772,0.772,1.281,0.984,0.39,0.163,0.796,0.208,1.181,0.411,0.751,0.395-0.751,0.841-0.992,0.961-0.323,0.161-0.488,0.479-0.835,0.594-0.981,0.324-2.313,0.067-3.357,0.161-0.684,0.062-1.354,0.187-2.045,0.211-0.532,0.021-0.973-0.088-1.466-0.281-0.341-0.133-0.926-0.512-1.255-0.211-0.239,0.221,0.156,0.79-0.088,1.023-0.557,0.53-2.452-0.233-3.054-0.443-0.181-0.062-0.199-0.009-0.381,0.075-0.553,0.254-1.178,0.342-1.774,0.418-1.01,0.129-2.034,0.075-3.049,0.113-0.73,0.025-1.447,0.07-2.18,0.029-0.364-0.021-0.949-0.188-1.272,0.043-0.064,0.045-0.055,0.197-0.058,0.255-0.018,0.4-0.196,0.574-0.548,0.719-0.356,0.146-0.793,0.144-0.793,0.614,0,0.09-0.008,0.227,0.063,0.286v-0.229c-0.604,0.216-1.351-0.002-1.978,0.119-0.021,0.003-0.018,0.204-0.003,0.225,0.14,0.207,1.028,0.271,1.276,0.315,0.518,0.093,1.047,0.104,1.571,0.094,1.126-0.021,2.222-0.176,3.351-0.083,1.681,0.138,3.49,0.659,4.993,1.436,1.564,0.807,3.304,0.948,4.982,1.307,0.854,0.182,1.581,0.852,2.401,1.153,0.311,0.113,0.622,0.18,0.9,0.365,0.377,0.251,0.66,0.216,1.061,0.377,0.348,0.143,0.603,1.423,0.781,1.771,0.309,0.603,0.56,1.069-0.27,1.264-0.938,0.222-1.852,0.293-2.806,0.044-0.922-0.24-1.779-0.334-2.746-0.39-0.88-0.052-1.886-0.269-2.765-0.179-0.239,0.023-0.595,0.076-0.595,0.371,0,0.739,1.839,0.869,0.567,1.701-1.508,0.986-3.48,1.104-5.188,1.59-1.046,0.296-2.138,0.489-3.063,1.088-0.945,0.608-2.009,0.969-3.103,1.212-2.36,0.525-4.747,0.899-7.141,1.251-0.276,0.04-1.951,0.485-2.084,0.266-0.214-0.352-0.418-0.709-0.621-1.067-0.958-1.694-1.832-3.436-2.655-5.198-2.555-5.472-4.411-11.196-5.562-17.122-1.03-5.312-1.689-10.695-2.236-16.074-0.207-2.031-0.389-4.064-0.545-6.101-0.051-0.657-0.52-2.478,0.183-2.845,1.476-0.771,3.726-0.298,5.241,0.081,2.096,0.523,4.353,0.603,6.494,0.818,4.316,0.436,8.615,1.036,12.899,1.715,0.541,0.086,1.092,0.158,1.623,0.29,0.346,0.086,0.7-0.049,1.034-0.138,0.715-0.193,1.384-0.298,2.116-0.146,0.852,0.179,1.771,1.062,2.475,1.542,0.92,0.628,1.839,1.261,2.758,1.893,0.316,0.217,0.632,0.435,0.948,0.652-0.022-0.016,0.046-0.197,0-0.229-1.378-0.951-2.759-1.899-4.142-2.842-0.842-0.574-1.626-1.254-2.677-1.337-0.908-0.071-1.757,0.542-2.646,0.344-3.766-0.838-7.722-1.24-11.552-1.678-2.419-0.276-4.847-0.475-7.264-0.779-1.744-0.219-3.388-0.752-5.159-0.741-0.691,0.004-2.556-0.08-2.521,0.96,0.03,0.92,0.112,1.841,0.184,2.758,1.222,15.681,3.245,31.867,11.657,45.53l0.004,0.004c4.277-0.714,8.85-0.914,12.698-3.035,1.365-0.753,3.173-1.03,4.712-1.337,0.889-0.176,4.191-0.745,3.682-2.21-0.06-0.175-1.189-0.692-0.961-0.847,0.116-0.079,0.349-0.124,0.491-0.113,1.188,0.09,2.378,0.162,3.566,0.229,1.83,0.104,3.347,0.815,5.192,0.154,0.238-0.085,0.207-0.437,0.188-0.625-0.033-0.33-0.259-0.66-0.408-0.946-0.223-0.424-0.331-1.352-0.658-1.658-0.27-0.253-0.584-0.169-0.915-0.28-0.279-0.094-0.506-0.365-0.812-0.466-0.94-0.314-1.729-0.927-2.654-1.241-0.412-0.139-0.889-0.121-1.316-0.186-1.074-0.162-2.128-0.532-3.148-0.896-0.917-0.327-1.738-0.757-2.688-1.041-1.254-0.373-2.495-0.666-3.808-0.696-0.908-0.022-1.813,0.116-2.721,0.135-0.444,0.009-0.887-0.036-1.326-0.1-0.314-0.044-0.621-0.124-0.928-0.202-0.19-0.049-0.451,0.117-0.078,0.097,0.522-0.031,1.212,0.083,1.71-0.095,0.023-0.01,0.02-0.213,0-0.229-0.187-0.158,0.835-0.484,0.886-0.506,0.223-0.09,0.366-0.277,0.406-0.511,0.033-0.198,0.006-0.422,0.233-0.485,0.505-0.14,1.233,0.056,1.749,0.071,1.061,0.031,2.148-0.059,3.212-0.085,1.098-0.028,2.313-0.079,3.31-0.594,0.425-0.22,3.385,1.382,3.365,0.146-0.005-0.298-0.149-0.773,0.236-0.828,0.45-0.063,1.132,0.393,1.551,0.532,0.822,0.272,1.918,0.026,2.75-0.11,0.743-0.123,1.525-0.106,2.274-0.119,0.489-0.008,1.091,0.083,1.535-0.175,0.427-0.247,0.702-0.557,1.198-0.753,1.595-0.633,0.094-1.329-0.803-1.561-0.492-0.127-0.92-0.666-1.281-0.984-0.494-0.433-1.026-0.803-1.604-1.115-1.245-0.672-2.906-1.232-4.306-1.444-2.374-0.359-4.901-0.214-7.3-0.379-0.471-0.032-0.94-0.07-1.409-0.117v0.229c1.046-0.183,2.13-0.241,3.186-0.353,1.07-0.113,2.275,0.01,3.286-0.372,0.968-0.366,1.963,0.038,2.938,0.077,1.426,0.055,2.916-0.229,4.312-0.463,0.481-0.08,0.908-0.191,1.296-0.487,0.724-0.557,1.624-0.812,2.506-0.984,0.648-0.127,3.736-0.119,3.708-1.133-0.009-0.32-0.2-0.434-0.463-0.607-0.858-0.565-2.03-1.027-3.006-1.344-0.325-0.104-0.11,0.3-0.086,0.288,0.032-0.016,0.012-0.194,0.002-0.225-0.148-0.455-0.806-0.854-1.19-1.116-0.76-0.519-1.555-0.986-2.342-1.463-1.989-1.205-3.994-2.394-5.898-3.731-0.717-0.502-1.425-1.032-2.04-1.655-0.228-0.228-0.438-0.483-0.563-0.782-0.203-0.492,1.114-0.835,1.346-0.931,0.357-0.146,2.125-0.348,2.226-0.776,0.088-0.375-0.297-0.724-0.503-0.975,0.032,0.035-0.039,0.178,0.004,0.23'/%3E %3Cpath fill='%23557176' d='m525.48,343.25s0.229-1.834,4.813-1.834,3.209,0.459,8.481,1.146c5.272,0.688,9.17,0.688,11.004,0.917s5.73,0.688,7.105,1.146c1.375,0.459,3.669,1.604,3.669,1.604s-0.917,0.688,2.979,0.688c3.897,0,2.75-0.23,8.252-0.23s1.834,1.376,8.94,0c7.105-1.375,12.607-2.063,14.441-2.521,1.834-0.459-2.063-1.834,4.814-0.917s10.086,0.229,11.231,0.229c1.146,0,5.96,0.229,8.253,0.229,2.292,0,5.501,0,6.878,0.229,1.375,0.229,3.438-0.229,6.418,0.229,2.979,0.458,3.668-0.917,5.96,0.458,2.293,1.376,6.419,0.459,8.022,0.229,1.605-0.229,4.814,0,5.731,0s5.272,0.458,7.336,0.458c2.063,0,6.188-0.458,6.188-0.458l3.897,0.458s0.688-9.856,0.688-11.003c0-1.146,2.487-2.864-1.901-3.281-16.137-1.532-9.889-2.517-19.417-3.138-2.292-0.458-13.296-3.209-15.588-3.667-2.292-0.459-14.672-4.127-18.34-4.127-3.667,0-12.837,0.459-15.129,0.459s-22.235-0.459-24.985-0.459c0,0-7.336-2.521-9.17-3.209s-2.063-0.458-8.023-0.229-7.335,0.917-12.837,0.229-10.086,0-12.608,0.459c-2.521,0.458-6.188,1.834-6.188,1.834l-0.914,24.072z'/%3E %3Cpath fill='%23000' d='m525.5,343.44c0.083-0.553,0.717-0.943,1.158-1.173,1.563-0.809,3.584-0.661,5.28-0.602,1.119,0.039,2.172,0.25,3.258,0.501,2.027,0.471,4.107,0.704,6.175,0.915,3.417,0.35,6.848,0.414,10.257,0.85,1.698,0.217,3.44,0.404,5.095,0.863,1.327,0.368,2.61,1.046,3.838,1.657v-0.458c-0.208,0.165-0.167,0.65,0.029,0.802,0.589,0.456,1.848,0.326,2.522,0.341,1.008,0.023,2.021-0.001,3.027-0.053,3.234-0.168,6.445-0.414,9.606,0.363,0.506,0.125,1.046,0.073,1.559,0.025,1.448-0.138,2.882-0.459,4.309-0.73,3.063-0.583,6.143-1.086,9.222-1.581,0.979-0.157,1.959-0.314,2.936-0.487,0.562-0.099,1.255-0.145,1.763-0.423,0.183-0.1,0.217-0.283,0.222-0.474,0.006-0.214,0.058-0.756-0.059-0.37,0.101-0.332,0.941-0.243,1.165-0.241,1.481,0.02,2.959,0.296,4.428,0.466,2.501,0.289,5.027,0.397,7.543,0.248,3.558-0.212,7.076,0.04,10.642,0.051,2.532,0.007,5.023,0.157,7.543,0.291,1.225,0.065,2.459-0.067,3.687-0.03,1.557,0.049,3.033,0.406,4.596,0.19,1.019-0.141,1.861-0.246,2.842,0.156,0.563,0.229,1.045,0.565,1.63,0.756,0.679,0.22,1.413,0.267,2.121,0.292,2.274,0.079,4.485-0.592,6.754-0.611,4.152-0.034,8.296,0.721,12.44,0.522,1.131-0.056,2.26-0.157,3.387-0.264,0.479-0.045,1.072-0.211,1.552-0.154,1.293,0.151,2.587,0.304,3.88,0.456,0.017,0.002,0.021-0.109,0.021-0.113,0.211-3.014,0.417-6.03,0.595-9.046,0.072-1.219,0.087-2.093,0.601-3.204,0.372-0.805,0.268-1.613-0.585-2.004-1.275-0.585-2.983-0.482-4.354-0.628-1.397-0.148-2.791-0.316-4.182-0.514-1.516-0.214-3.031-0.469-4.513-0.858-1.811-0.478-3.492-1.052-5.37-1.271-1.54-0.179-3.026-0.27-4.54-0.62-1.99-0.461-3.977-0.944-5.963-1.425-3.145-0.758-6.316-1.428-9.448-2.231-4.095-1.052-8.162-2.208-12.3-3.09-1.608-0.344-3.244-0.679-4.896-0.668-2.218,0.012-4.437,0.106-6.653,0.188-3.22,0.119-6.441,0.302-9.665,0.25-3.628-0.058-7.256-0.139-10.884-0.213-3.655-0.075-7.311-0.155-10.967-0.21-0.854-0.013-1.518,0.001-2.318-0.274-1.824-0.629-3.646-1.26-5.466-1.897-1.976-0.692-3.798-1.554-5.921-1.505-4.159,0.095-8.294,0.53-12.446,0.723-2.277,0.105-4.506-0.199-6.767-0.413-2.527-0.24-5.079-0.182-7.603,0.068-3.403,0.336-6.674,1.17-9.875,2.364-0.028,0.012-0.021,0.148-0.022,0.17-0.305,8.022-0.611,16.046-0.917,24.068-0.005,0.146,0.032,0.443,0.045,0.122,0.212-5.574,0.424-11.146,0.636-16.72,0.092-2.391,0.184-4.78,0.274-7.171,0.002-0.056,0.004-0.111,0.006-0.167-0.01,0.246,0.143,0.096,0.351,0.021,1.09-0.395,2.192-0.753,3.305-1.081,2.336-0.688,4.76-1.037,7.184-1.237,3.316-0.276,6.526,0.076,9.823,0.358,2.414,0.207,4.798,0.002,7.204-0.197,2.799-0.23,5.613-0.327,8.421-0.438,1.183-0.047,2.233,0.025,3.349,0.438,3.033,1.124,6.103,2.155,9.161,3.207,0.278,0.097,0.75,0.009,1.044,0.013,0.664,0.009,1.328,0.02,1.993,0.03,1.817,0.032,3.634,0.068,5.45,0.104,6.665,0.133,13.351,0.458,20.015,0.218,2.419-0.087,4.837-0.186,7.256-0.266,1.798-0.06,3.646-0.217,5.438-0.025,4.184,0.445,8.336,1.73,12.389,2.803,6.668,1.766,13.408,3.398,20.15,4.854,1.465,0.315,3.035,0.253,4.523,0.497,0.836,0.136,1.646,0.354,2.45,0.613,2.857,0.918,5.815,1.327,8.79,1.678,1.574,0.186,3.165,0.286,4.734,0.512,0.884,0.127,2.093,0.425,1.592,1.509-0.451,0.977-0.479,1.671-0.537,2.739-0.175,3.18-0.401,6.357-0.623,9.534,0.01-0.128-3.229-0.436-3.737-0.495-0.396-0.046-0.821,0.056-1.217,0.095-1.187,0.119-2.376,0.221-3.567,0.293-4.227,0.257-8.483-0.5-12.722-0.506-2.272-0.004-4.475,0.63-6.754,0.611-1.255-0.011-2.377-0.296-3.466-0.91-1.016-0.573-2.027-0.462-3.127-0.294-1.426,0.218-2.788-0.071-4.209-0.171-1.358-0.095-2.715,0.042-4.073,0.011-1.027-0.025-2.055-0.207-3.087-0.245-1.484-0.053-2.971-0.047-4.456-0.047-3.565,0-7.085-0.281-10.642-0.05-2.517,0.163-5.04,0.022-7.543-0.248-1.409-0.153-2.808-0.386-4.223-0.459-0.347-0.018-1.099-0.124-1.356,0.205-0.086,0.108-0.063,0.32-0.059,0.447,0.002,0.074,0.009,0.149,0.021,0.224,0.047,0.302,0.036,0.004,0.02,0.043-0.13,0.319-0.778,0.359-1.051,0.416-0.811,0.17-1.63,0.299-2.447,0.433-2.55,0.418-5.102,0.819-7.646,1.266-2.57,0.451-5.166,1.153-7.778,1.308-0.856,0.051-1.574-0.282-2.398-0.436-2.014-0.378-4.197-0.191-6.232-0.111-1.338,0.053-2.668,0.159-4.008,0.171-1.042,0.009-2.121,0.039-3.145-0.188-0.169-0.038-0.404-0.102-0.5-0.264,0.201,0.344-0.105,0.367,0.074,0.224,0.044-0.035,0.049-0.434,0-0.458-1.24-0.618-2.513-1.245-3.838-1.658-1.719-0.536-3.614-0.673-5.393-0.901-3.584-0.458-7.201-0.513-10.793-0.898-3.188-0.342-6.3-1.298-9.506-1.353-1.297-0.021-5.251-0.155-5.555,1.861-0.017,0.09,0.015,0.434,0.021,0.395'/%3E %3Cg fill='%2399afca'%3E %3Cpath d='m655.19,337.19c-0.431,0.861-0.868,1.716-1.374,2.536-0.064,0.104,0.042,0.391,0.012,0.438,0.506-0.819,0.943-1.676,1.373-2.536,0.056-0.113-0.04-0.381-0.011-0.438'/%3E %3Cpath d='m537.59,335.71c-0.535,0.75-1.061,1.503-1.479,2.324-0.058,0.113,0.041,0.383,0.013,0.439,0.42-0.821,0.943-1.575,1.479-2.324,0.068-0.097-0.041-0.399-0.013-0.439'/%3E %3Cpath d='m540.65,334.47c-0.019,0.111-0.086,0.203-0.104,0.316-0.019,0.102-0.016,0.209-0.01,0.312,0.001,0.014,0.017,0.169,0.031,0.082,0.021-0.112,0.086-0.204,0.106-0.318,0.017-0.1,0.014-0.209,0.008-0.311-0.001-0.014-0.016-0.169-0.031-0.081'/%3E %3Cpath d='m544.35,332.96c-0.225,0.865-0.532,1.7-0.846,2.536-0.046,0.123,0.037,0.371,0.012,0.439,0.313-0.836,0.622-1.673,0.846-2.536,0.033-0.129-0.032-0.361-0.012-0.439'/%3E %3Cpath d='m545.6,332.23c-0.006,0.506-0.102,1-0.2,1.494-0.021,0.1-0.015,0.211-0.008,0.311,0.001,0.017,0.014,0.168,0.03,0.082,0.125-0.627,0.216-1.247,0.224-1.887,0.002-0.259-0.043-0.258-0.046,0'/%3E %3Cpath d='m547.94,330.54c-1.131,1.86-2.19,3.761-3.17,5.706-0.057,0.112,0.041,0.382,0.013,0.438,0.979-1.944,2.039-3.844,3.169-5.705,0.064-0.105-0.041-0.392-0.012-0.439'/%3E %3Cpath d='m549.31,329.75c-0.143,1.398-0.721,2.675-1.258,3.956-0.05,0.12,0.039,0.375,0.012,0.439,0.556-1.323,1.132-2.633,1.278-4.074,0.006-0.058-0.013-0.499-0.032-0.321'/%3E %3Cpath d='m550.57,329.74c-0.017,0.923-0.213,1.819-0.412,2.717-0.021,0.088,0.014,0.434,0.022,0.392,0.22-0.988,0.416-1.972,0.434-2.987,0.002-0.147-0.039-0.442-0.044-0.122'/%3E %3Cpath d='m552.16,329.54c0.062,0.747-0.26,1.471-0.519,2.155-0.046,0.122,0.038,0.371,0.013,0.438,0.367-0.976,0.626-1.868,0.537-2.915-0.015-0.177-0.036,0.263-0.031,0.322'/%3E %3Cpath d='m541.19,340.39c0.515-0.282,0.964-0.668,1.479-0.951,0.088-0.048-0.034-0.437,0-0.455-0.515,0.282-0.964,0.669-1.479,0.951-0.087,0.048,0.034,0.436,0,0.455'/%3E %3Cpath d='m544.24,338.78c-0.183,0.277-0.345,0.567-0.527,0.845-0.04,0.062-0.019,0.213-0.017,0.28,0,0.016,0.014,0.181,0.028,0.159,0.183-0.278,0.345-0.567,0.528-0.846,0.04-0.061,0.018-0.213,0.016-0.279,0-0.017-0.013-0.182-0.028-0.159'/%3E %3Cpath d='m561.04,326.2c-0.112,0.314-0.29,0.596-0.521,0.837-0.04,0.041-0.023,0.177-0.023,0.228,0,0.02,0.027,0.224,0.023,0.228,0.236-0.245,0.419-0.532,0.534-0.854,0.029-0.083,0.018-0.193,0.016-0.279,0-0.021-0.023-0.179-0.029-0.16'/%3E %3Cpath d='m561.9,329.71c1.107-1.308,1.82-2.945,1.71-4.675-0.019-0.28-0.044,0.155-0.039,0.229,0.09,1.421-0.784,2.943-1.671,3.99-0.086,0.102,0.057,0.389,0,0.456'/%3E %3Cpath d='m565.36,324.78c-0.013,0.962-0.205,1.89-0.412,2.823-0.02,0.088,0.014,0.435,0.023,0.393,0.227-1.025,0.418-2.042,0.433-3.095,0.002-0.145-0.039-0.44-0.044-0.121'/%3E %3Cpath d='m562.52,325.15c-0.36,1.221-1.039,2.299-1.69,3.381-0.063,0.105,0.041,0.391,0.013,0.438,0.651-1.083,1.33-2.159,1.689-3.381,0.037-0.127-0.035-0.363-0.012-0.438'/%3E %3Cpath d='m549.42,336.77c-0.229,0.572-0.466,1.139-0.74,1.691-0.056,0.114,0.041,0.381,0.012,0.438,0.274-0.553,0.512-1.12,0.74-1.69,0.048-0.121-0.038-0.373-0.012-0.439'/%3E %3Cpath d='m550.8,336.77c-0.418,0.626-0.839,1.248-1.368,1.788-0.089,0.091,0.057,0.398,0,0.455,0.534-0.544,0.959-1.172,1.381-1.804,0.067-0.101-0.041-0.395-0.013-0.439'/%3E %3Cpath d='m553.65,337.3c-0.211,0.423-0.422,0.845-0.634,1.269-0.036,0.071-0.017,0.203-0.016,0.279,0.001,0.017,0.018,0.181,0.028,0.159,0.212-0.423,0.423-0.846,0.634-1.268,0.036-0.073,0.018-0.203,0.016-0.28,0-0.015-0.016-0.179-0.028-0.159'/%3E %3Cpath d='m554.92,336.03c-0.546,1.194-1.14,2.37-2.001,3.373-0.086,0.1,0.057,0.389,0,0.455,0.865-1.007,1.464-2.189,2.013-3.39,0.053-0.116-0.041-0.378-0.012-0.438'/%3E %3Cpath d='m581.23,327.25c-0.275,0.193-0.486,0.451-0.641,0.748-0.037,0.071-0.018,0.204-0.016,0.279,0,0.016,0.017,0.181,0.028,0.159,0.15-0.292,0.358-0.541,0.628-0.731,0.039-0.027,0.022-0.188,0.022-0.228,0.001-0.012-0.018-0.228-0.021-0.227'/%3E %3Cpath d='m580.92,331.51c1.631-1.007,2.429-3.132,2.453-4.981,0.003-0.26-0.042-0.259-0.046,0-0.021,1.661-0.976,3.643-2.407,4.526-0.089,0.056,0.039,0.431,0,0.455'/%3E %3Cpath d='m568.34,334.02c-0.536,0.731-1.22,1.33-2.002,1.788-0.088,0.052,0.038,0.433,0,0.455,0.789-0.462,1.473-1.067,2.014-1.804,0.07-0.095-0.04-0.4-0.012-0.439'/%3E %3Cpath d='m564.96,339.86c2.669-0.736,4.843-2.977,6.239-5.291,0.063-0.105-0.041-0.39-0.012-0.438-1.389,2.301-3.569,4.541-6.228,5.275-0.068,0.018,0.006,0.453,0.001,0.454'/%3E %3Cpath d='m569.19,342.82c1.114-0.609,2.047-1.604,2.753-2.648,0.066-0.101-0.041-0.397-0.013-0.439-0.701,1.037-1.633,2.028-2.74,2.633-0.088,0.046,0.033,0.435,0,0.454'/%3E %3Cpath d='m575.1,338.98c-1.577,2.082-3.356,3.955-5.388,5.6-0.092,0.074,0.049,0.415,0,0.455,2.031-1.645,3.811-3.518,5.388-5.6,0.082-0.108-0.057-0.38,0-0.455'/%3E %3Cpath d='m576.7,338.26c0.328-0.662,0.666-1.336,1.155-1.895,0.086-0.099-0.057-0.39,0-0.455-0.495,0.565-0.836,1.242-1.168,1.91-0.056,0.115,0.04,0.383,0.013,0.44'/%3E %3Cpath d='m581.13,342.38c0.917-1.649,1.767-3.441,3.164-4.746,0.09-0.085-0.055-0.405,0-0.455-1.403,1.312-2.255,3.107-3.177,4.763-0.06,0.108,0.042,0.386,0.013,0.438'/%3E %3Cpath d='m584.93,338.88c-0.939,1.032-1.971,1.98-2.854,3.063-0.084,0.104,0.058,0.386,0,0.455,0.883-1.084,1.914-2.031,2.854-3.063,0.087-0.097-0.056-0.394,0-0.455'/%3E %3Cpath d='m595.71,337c0.469-1.27,0.684-2.626,0.649-3.978-0.009-0.319-0.048-0.024-0.044,0.121,0.029,1.154-0.219,2.338-0.618,3.418-0.045,0.123,0.038,0.371,0.013,0.439'/%3E %3Cpath d='m595.06,333.09c-0.297,1.346-0.417,2.749-1.051,3.992-0.058,0.112,0.041,0.383,0.012,0.438,0.642-1.258,0.763-2.678,1.063-4.039,0.019-0.087-0.014-0.432-0.024-0.391'/%3E %3Cpath d='m597.6,332.99c-0.196,1.305-0.15,2.636-0.629,3.886-0.046,0.122,0.038,0.372,0.013,0.439,0.485-1.269,0.44-2.608,0.64-3.934,0.013-0.088-0.018-0.429-0.024-0.391'/%3E %3Cpath d='m598.96,334.18c-0.027,1.302-0.413,2.567-0.935,3.751-0.053,0.118,0.04,0.376,0.012,0.438,0.57-1.291,0.938-2.652,0.967-4.067,0.003-0.146-0.037-0.441-0.044-0.122'/%3E %3Cpath d='m600.34,334.99c0.145,2.604-1.06,5.218-2.728,7.158-0.087,0.101,0.057,0.39,0,0.455,1.875-2.183,2.928-4.96,2.767-7.844-0.014-0.28-0.042,0.157-0.039,0.231'/%3E %3Cpath d='m601.72,335.61c-0.433,1.172-0.939,2.315-1.374,3.487-0.045,0.122,0.038,0.37,0.014,0.438,0.434-1.171,0.939-2.313,1.373-3.485,0.046-0.124-0.037-0.372-0.013-0.44'/%3E %3Cpath d='m602.78,334.97c-0.304,0.784-0.744,1.492-1.162,2.219-0.062,0.108,0.041,0.388,0.013,0.439,0.418-0.728,0.857-1.436,1.162-2.22,0.047-0.121-0.039-0.371-0.013-0.438'/%3E %3Cpath d='m603.62,336.45c-0.823,1.566-1.496,3.227-2.847,4.43-0.091,0.08,0.053,0.408,0,0.454,1.355-1.207,2.032-2.871,2.858-4.445,0.061-0.113-0.04-0.385-0.011-0.439'/%3E %3Cpath d='m604.57,335.74c-0.114,0.578-0.228,1.149-0.522,1.667-0.062,0.108,0.041,0.388,0.013,0.438,0.301-0.53,0.416-1.121,0.533-1.714,0.02-0.099,0.014-0.21,0.008-0.31-0.002-0.016-0.016-0.167-0.032-0.081'/%3E %3Cpath d='m606.06,335.4c-0.913,1.775-2.141,3.333-3.275,4.966-0.068,0.098,0.042,0.396,0.013,0.438,1.134-1.634,2.362-3.19,3.275-4.966,0.057-0.112-0.04-0.382-0.013-0.438'/%3E %3Cpath d='m612.17,330.81c0.068,0.651-0.27,1.357-0.518,1.943-0.051,0.12,0.039,0.375,0.012,0.439,0.372-0.877,0.639-1.746,0.538-2.704-0.018-0.177-0.038,0.262-0.032,0.322'/%3E %3Cpath d='m611.77,337.42c1.462-1.988,2.469-4.153,2.964-6.574,0.019-0.089-0.014-0.433-0.022-0.392-0.492,2.407-1.502,4.552-2.952,6.526-0.072,0.097,0.039,0.401,0.01,0.44'/%3E %3Cpath d='m616.5,330.59c-0.011,0.746-0.218,1.434-0.617,2.061-0.066,0.102,0.041,0.393,0.012,0.438,0.464-0.727,0.636-1.524,0.65-2.378,0.001-0.144-0.04-0.439-0.045-0.121'/%3E %3Cpath d='m607.44,337.08c-1.038,1.153-1.979,2.389-2.958,3.592-0.084,0.104,0.057,0.385,0,0.455,0.979-1.203,1.92-2.438,2.958-3.593,0.087-0.097-0.056-0.392,0-0.454'/%3E %3Cpath d='m608.91,337.83c-1.084,1.508-2.229,2.969-3.375,4.431-0.084,0.105,0.057,0.382,0,0.453,1.15-1.465,2.299-2.932,3.386-4.444,0.07-0.099-0.041-0.401-0.011-0.44'/%3E %3Cpath d='m609.65,339.82c-0.49,0.392-0.989,0.771-1.479,1.162-0.093,0.073,0.049,0.416,0,0.455,0.489-0.391,0.988-0.771,1.479-1.162,0.091-0.072-0.049-0.416,0-0.455'/%3E %3Cpath d='m623.7,332.96c-0.411,0.601-0.96,1.069-1.474,1.577-0.089,0.089,0.056,0.4,0,0.455,0.519-0.514,1.07-0.988,1.485-1.593,0.069-0.099-0.041-0.397-0.011-0.439'/%3E %3Cpath d='m624.24,335.42c0.79-0.549,1.06-1.574,1.079-2.491,0.002-0.145-0.038-0.44-0.044-0.12-0.017,0.799-0.362,1.689-1.035,2.157-0.091,0.063,0.045,0.424,0,0.454'/%3E %3Cpath d='m618.08,338.72c-0.006,0.383-0.098,0.782-0.302,1.109-0.039,0.063-0.018,0.21-0.016,0.279,0.001,0.016,0.014,0.182,0.028,0.159,0.261-0.42,0.325-0.94,0.333-1.427,0.001-0.086,0.014-0.197-0.017-0.28-0.004-0.017-0.026,0.142-0.026,0.16'/%3E %3Cpath d='m619.91,342.38c0.599-1.404,1.314-2.749,1.489-4.285,0.007-0.059-0.012-0.5-0.032-0.322-0.17,1.494-0.889,2.808-1.468,4.169-0.052,0.118,0.039,0.376,0.011,0.438'/%3E %3Cpath d='m619.69,337.83c-0.305,0.784-0.744,1.492-1.162,2.219-0.063,0.108,0.041,0.389,0.011,0.439,0.419-0.728,0.858-1.436,1.162-2.219,0.048-0.122-0.037-0.372-0.011-0.439'/%3E %3Cpath d='m622.31,337.58c0.042,1.139-0.965,2.15-1.463,3.102-0.059,0.111,0.041,0.383,0.012,0.438,0.642-1.225,1.548-2.204,1.495-3.66-0.012-0.321-0.049-0.026-0.044,0.12'/%3E %3Cpath d='m623.08,341.43c0.376-0.774,0.922-1.479,1.063-2.348,0.016-0.102,0.014-0.208,0.008-0.312-0.001-0.013-0.018-0.169-0.031-0.081-0.137,0.85-0.684,1.544-1.051,2.302-0.057,0.115,0.039,0.381,0.011,0.439'/%3E %3Cpath d='m626.13,333.18c-0.622,0.959-1.056,2.008-1.479,3.064-0.05,0.121,0.037,0.374,0.012,0.438,0.424-1.058,0.856-2.105,1.479-3.063,0.066-0.102-0.041-0.393-0.012-0.439'/%3E %3Cpath d='m628.56,334.15c-0.226,0.966-0.592,1.904-1.157,2.724-0.067,0.1,0.041,0.397,0.014,0.439,0.574-0.834,0.938-1.788,1.167-2.771,0.02-0.087-0.014-0.434-0.024-0.392'/%3E %3Cpath d='m630.46,334.97c-0.315,1.031-0.707,2.034-1.268,2.958-0.063,0.104,0.042,0.391,0.013,0.438,0.56-0.924,0.951-1.927,1.267-2.958,0.039-0.126-0.034-0.364-0.012-0.438'/%3E %3Cpath d='m632.06,340.17c0.516-0.767,0.438-1.663,0.439-2.544,0-0.258-0.045-0.258-0.047,0,0,0.749,0.029,1.461-0.404,2.104-0.068,0.101,0.041,0.397,0.012,0.44'/%3E %3Cpath d='m634.15,338.26c-0.082,1.816-1.508,3.264-2.624,4.564-0.077,0.09,0.051,0.348,0,0.407,1.188-1.384,2.572-2.847,2.659-4.767,0.003-0.065-0.024-0.455-0.035-0.204'/%3E %3Cpath d='m628.04,340.04c-0.427,0.426-0.857,0.844-1.374,1.162-0.089,0.055,0.04,0.431,0,0.455,0.517-0.318,0.947-0.736,1.374-1.162,0.04-0.04,0.023-0.178,0.023-0.229,0-0.017-0.027-0.222-0.023-0.226'/%3E %3Cpath d='m630.89,339.72c-0.904,0.717-1.672,1.565-2.43,2.431-0.087,0.099,0.057,0.39,0,0.455,0.758-0.865,1.525-1.715,2.43-2.431,0.091-0.073-0.049-0.416,0-0.455'/%3E %3Cpath d='m640.06,334.77c0,0.251-0.015,0.489-0.089,0.731-0.026,0.086-0.019,0.191-0.017,0.279,0,0.021,0.023,0.176,0.028,0.159,0.116-0.381,0.122-0.775,0.123-1.17,0-0.017,0.003-0.228-0.023-0.228-0.025,0.001-0.022,0.212-0.022,0.229'/%3E %3Cpath d='m641.33,333.62c0.065,1.003-0.363,1.938-0.937,2.73-0.069,0.096,0.04,0.398,0.011,0.438,0.742-1.024,1.047-2.147,0.965-3.399-0.018-0.279-0.044,0.156-0.039,0.231'/%3E %3Cpath d='m643.46,334.55c-0.64,1.177-1.239,2.374-1.796,3.592-0.055,0.117,0.038,0.378,0.011,0.439,0.558-1.218,1.158-2.415,1.796-3.592,0.06-0.111-0.04-0.386-0.011-0.439'/%3E %3Cpath d='m645.03,335.67c-0.121,1.114-0.514,2.134-1.046,3.111-0.061,0.109,0.041,0.386,0.011,0.438,0.554-1.017,0.942-2.074,1.067-3.229,0.007-0.058-0.014-0.498-0.032-0.32'/%3E %3Cpath d='m647.26,336.45c-0.74,1.374-1.48,2.747-2.22,4.121-0.06,0.109,0.041,0.385,0.013,0.438,0.738-1.373,1.479-2.747,2.218-4.12,0.059-0.111-0.04-0.386-0.011-0.439'/%3E %3Cpath d='m648.53,338.56c-0.622,1.243-1.25,2.483-2.107,3.584-0.082,0.107,0.057,0.383,0,0.456,0.861-1.107,1.494-2.351,2.118-3.601,0.057-0.114-0.041-0.381-0.011-0.439'/%3E %3Cpath d='m650.44,340.25c-1.062,1.2-1.838,2.648-3.064,3.698-0.091,0.078,0.051,0.411,0,0.455,1.227-1.05,2.003-2.499,3.064-3.698,0.087-0.098-0.057-0.391,0-0.455'/%3E %3Cpath d='m640.4,343.13c0.409-0.135,0.76-0.315,0.985-0.691,0.234-0.39,0.377-0.771,0.705-1.104,0.09-0.092-0.056-0.399,0-0.455-0.295,0.3-0.473,0.637-0.657,1.009-0.216,0.436-0.584,0.64-1.033,0.787-0.074,0.023,0.011,0.45,0,0.454'/%3E %3Cpath d='m643.44,341.05c-0.029,0.851-0.676,1.519-1.146,2.166-0.069,0.096,0.04,0.399,0.011,0.439,0.572-0.789,1.144-1.47,1.179-2.484,0.005-0.144-0.033-0.439-0.044-0.121'/%3E %3Cpath d='m644.82,341.69c-0.049,1.187-1.124,2.056-1.882,2.846-0.078,0.081,0.048,0.347,0,0.397,0.884-0.921,1.865-1.779,1.921-3.139,0.005-0.126-0.027-0.383-0.039-0.104'/%3E %3Cpath d='m656.55,335.56c-0.191,1.686-1.664,2.879-2.626,4.16-0.081,0.108,0.057,0.379,0,0.453,1.003-1.335,2.459-2.535,2.657-4.293,0.007-0.057-0.011-0.499-0.031-0.32'/%3E %3Cpath d='m657.1,339.75c0.807-0.81,1.372-1.809,1.802-2.86,0.049-0.12-0.038-0.374-0.012-0.439-0.427,1.046-0.988,2.04-1.79,2.845-0.089,0.09,0.055,0.4,0,0.454'/%3E %3Cpath d='m660.47,336.45c-0.564,1.304-1.388,2.45-2.219,3.594-0.068,0.095,0.04,0.398,0.012,0.438,0.831-1.143,1.654-2.29,2.219-3.592,0.052-0.12-0.039-0.377-0.012-0.44'/%3E %3Cpath d='m662.8,336.55c-0.948,1.164-1.854,2.357-2.958,3.382-0.091,0.084,0.053,0.404,0,0.454,1.104-1.023,2.01-2.217,2.958-3.381,0.084-0.103-0.057-0.384,0-0.455'/%3E %3Cpath d='m664.28,336.98c-0.243,0.91-0.671,1.738-1.162,2.536-0.065,0.104,0.041,0.392,0.011,0.439,0.493-0.799,0.92-1.626,1.162-2.536,0.035-0.128-0.033-0.362-0.011-0.439'/%3E %3Cpath d='m662.06,341.52c-1.031,1.303-2.538,2.062-4.016,2.747-0.083,0.039,0.027,0.443,0,0.455,1.478-0.686,2.984-1.444,4.016-2.747,0.082-0.105-0.058-0.383,0-0.455'/%3E %3Cpath d='m655.51,342.92c0.667-0.487,1.452-0.77,2.219-1.057,0.077-0.029-0.017-0.448,0-0.455-0.767,0.287-1.552,0.568-2.219,1.057-0.091,0.068,0.047,0.421,0,0.455'/%3E %3Cpath d='m664.28,341.52c-0.597,1.008-1.64,1.651-2.637,2.211-0.087,0.049,0.036,0.435,0,0.455,1.005-0.563,2.048-1.212,2.647-2.228,0.064-0.106-0.039-0.389-0.01-0.438'/%3E %3Cpath d='m632.68,328.32c-0.576,0.972-1.592,1.466-2.635,1.788-0.072,0.022,0.009,0.452,0,0.455,1.052-0.326,2.067-0.828,2.647-1.804,0.063-0.106-0.04-0.389-0.012-0.439'/%3E %3Cpath d='m590.1,332.32c0.233,1.522-0.688,2.786-1.679,3.803-0.09,0.091,0.055,0.397,0,0.455,1.282-1.316,1.983-2.811,1.701-4.65-0.005-0.04-0.035,0.301-0.022,0.392'/%3E %3Cpath d='m544.04,324.72c-1.348,0.921-2.771,1.699-4.228,2.431-0.085,0.043,0.031,0.439,0,0.455,1.456-0.732,2.88-1.512,4.228-2.431,0.09-0.061-0.044-0.424,0-0.455'/%3E %3Cpath d='m537.7,324.08c-0.956,1.051-2.007,1.985-3.276,2.643-0.086,0.044,0.032,0.438,0,0.453,1.27-0.655,2.32-1.59,3.276-2.641,0.087-0.096-0.056-0.393,0-0.455'/%3E %3C/g%3E %3Cpath transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' fill='url(%23grad2)' d='m665.39,508.83c-0.1731-0.0469-0.26825-0.0714-0.26825-0.0714s0.094,0.0246,0.26825,0.0714m57.327-1.7005c-0.0183,0.007-0.0126,0.007,0.0138,0.005,0.0424-0.014,0.0585-0.0222,0.0516-0.0222-0.006,0.001-0.0275,0.006-0.0653,0.0176m0.90907-0.18036c0.94232-0.20144,2.5014-0.54342,4.1338-0.90297-1.4777,0.29396-2.9565,0.60315-4.1338,0.90297m4.8652-1.0646c-0.24303,0.0539-0.48835,0.10774-0.73024,0.16162,3.0195-0.60198,6.0345-1.1396,6.4575-1.4124-0.0607,0-2.89,0.6254-5.7272,1.2508m5.7272-1.2508zm-60.41-33.451c-1.1177,0.73901-5.5186,2.6866-7.8171,3.8262-2.2996,1.1419-2.3661,3.4233-1.5774,3.8274,0.7887,0.40288,6.0436,3.6248,6.438,4.2267,0.39435,0.60549-2.2354,1.7368-2.5381,1.9195-0.30264,0.18036-0.1559,0.9018-0.1559,0.9018,2.7799,3.8051,13.549,4.0288,11.825,5.2503-1.7253,1.2192-4.8709,1.0154-2.7146,3.1598,1.4421,1.4358,5.0796,4.3403,7.3562,5.5033,3.2224,1.6467,3.0516,3.0263,3.767,3.7594,1.4605,1.4909,0.6156,0.99783,2.6045,1.9465,1.9912,0.94981,4.2473,1.6291,2.655,2.3048-1.5923,0.67811-3.5835,0.40874-5.4418,1.2204-1.8583,0.81396-0.66375,0.94981-3.4506,1.355-2.7857,0.40874-3.4506,0.40874-4.1132,0.40874-0.66374,0-0.26595-0.27171-1.9912-0.27171-1.7264,0,0.39894-0.13586-3.0528,0-3.0482,0.12063-8.8935-1.348-10.214-1.69,1.4352,0.37711,8.1885,2.1561,10.082,2.6398,2.1242,0.54225,1.9901,0.27172,3.7154,0.81396,1.7253,0.54225,3.3187,0.67811,4.5132,1.0845,1.1957,0.40757,1.989,0.94982,2.9186,1.7626,0.92971,0.81279,1.0627,1.0845,1.7264,1.2192,0.66375,0.13586,2.522,0.81396,0.66375,1.4921-1.8583,0.67694-0.66375,1.0845-2.655,1.0845-1.9889,0-3.0516,0.13586-3.0516,0.13586s-2.256,0.40639-3.1835,0.13585c-0.93085-0.27171-2.1254-1.0845-2.1254-0.27171,0,0.81396,0.40009,1.0857-0.79443,1.0857-1.1968,0-2.9209-0.67693-2.9209-0.67693s-0.79558,0.54342-2.7868,0.67693c-0.9962,0.0679-1.4272,0.0679-1.8743,0.0679-0.44938,0-0.91251,0-1.9763,0.0679-0.7715,0.0492-1.3516,0.0269-1.7929,0.005-0.77609-0.0398-1.1372-0.0773-1.3905,0.26703-0.39894,0.54342,2.1231,1.2215-1.4605,0.6781-3.5835-0.54225-2.2549-0.54225,1.5946,0.67928,3.8472,1.2192,1.0615,0,5.7055,1.3539,4.6451,1.3562,1.4605,0.6781,5.177,1.8985s3.1835,0.27171,4.9099,1.3562c1.7253,1.0845,2.256,0.81279,2.788,1.355,0.53077,0.54225,1.1945-0.27054,1.4582,1.0857,0.2671,1.355,1.7253,2.7101,0.53191,2.983-1.1945,0.27054-1.0615,0.4064-2.6538,0.27054-1.5934-0.13586-0.66374-0.40757-3.0516-0.54342-2.389-0.13468-4.1143-0.27054-4.1143-0.27054s-1.5934,0.13468,0,0.94864c1.5912,0.81514-0.13298,1.6291-1.5934,2.1713-1.4605,0.54225-2.5232,0.67811-3.1846,0.81396-0.66375,0.13352,0.13183,0-2.389,0.67811-2.5209,0.67693-1.9901,0.94981-3.5824,1.6268-1.5946,0.67693-2.1254,0.67693-3.8484,1.0845-1.7264,0.40756-1.5934,0.27054-3.0539,0.54225-1.4582,0.27053-2.389,0.40873-3.3176,0.54225-0.9297,0.13585-1.5934,0.13585-1.5934,0.13585s3.0528,9.7605,10.749,19.523c7.6967,9.7617,25.483,28.608,43.796,30.505,18.315,1.8996,31.321,1.2215,41.273-4.4727,9.955-5.693,23.49-14.371,32.25-28.879,8.7617-14.507,9.3956-16.568,9.3956-16.568s-1.8101-0.8245-3.2121-0.50946c-1.3928,0.3127-1.4066-2.5812-3.5297-2.5812s-1.9912,0.94865-4.6451-0.27054c-2.6527-1.2215-1.8571-1.6279-3.9813-1.7638-2.1231-0.13351-6.2362-1.8973-6.2362-1.8973s-3.0516-0.81279-5.1758-0.94981c-2.1254-0.13469-2.9209-0.27054-6.2374-1.4921-3.3199-1.2204-4.3803-1.0845-5.4418-1.4897-1.0615-0.40756-2.2572-0.6781-3.0528-1.2204-0.79558-0.54225-2.7868-1.4909-0.26367-3.3905,2.5197-1.8985,3.4506-2.983,4.3791-3.5252,0.92856-0.54225,2.9186-1.7626,4.6439-1.8985,1.7264-0.13469,1.8583-0.54225,4.3803-0.54225,2.5208,0-1.3275-1.0857-3.8484-0.94982-2.522,0.13469-2.522,0.54342-4.7781,0.54342-2.2572,0-0.9297-0.13585-6.6352,0.26937-5.7078,0.40757-2.2572,0-6.6363-0.13351-4.3791-0.13586-3.4483,0.13351-7.2978-0.67928s-2.2572-0.27054-6.3715-0.81279-4.1143-0.6781-5.9714-1.6267c-1.8583-0.95099-3.0516-1.2204-4.1154-1.4921-1.0615-0.26937-1.8583-0.54225-0.79558-1.355,1.0615-0.81279,5.1369-3.9269,6.0631-4.4738,0.38289-0.22486,1.1578-0.47081,2.146-0.72378-0.48721,0.10424-0.80819,0.17099-0.89531,0.18505-0.0722,0.0211-0.21552,0.0574-0.44135,0.0937-0.70502,0.11477-2.2033,0.22721-4.7505-0.0984-4.2461-0.54225-5.3077-0.81162-7.033-1.2192-1.7253-0.40757-3.4517-1.4921-7.8308-1.6279-4.3791-0.13586-2.9186-0.54342-4.7769-1.8973-1.8583-1.3562-3.0516-2.169-3.5835-2.9841-0.52962-0.81279-1.316-1.7954-2.9198-2.3037-3.8484-1.2204-7.4319-3.9902-6.9023-4.612,0.93085-1.0833,2.2641-1.6548,0.66375-2.983-1.6267-1.3492-10.823-2.9513-13.407-3.7559,0,0,0.0676-0.44036,0.21666-0.49189,0.57662-0.20027,1.9018-0.56099,2.8911-1.252,1.2484-0.87252,0-1.4089-1.5109-2.217-2.0623-1.0974-5.584-2.6843-7.1602-3.825-1.6382-1.1852,1.7069-3.2207,5.0578-4.6999,3.3508-1.4757,11.759-8.7228,13.008-9.8659l-0.0653-0.40288c0.001-0.002-9.2615,7.4486-10.379,8.1853'/%3E %3Cpath fill='%23000' d='m567.95,325.42c-1.854,1.65-3.806,3.2-5.771,4.713-1.202,0.926-2.426,1.826-3.698,2.654-1.404,0.914-2.964,1.494-4.423,2.308-0.798,0.444-2.223,1.184-2.252,2.257-0.026,0.912,1.476,1.411,2.117,1.754,1.73,0.923,3.523,1.725,5.262,2.636,2.589,1.356-1.944,1.778-2.148,2.777-0.005,0.025-0.022,0.206,0.006,0.215,3.676,1.09,7.802,1.259,11.277,2.947,0.451,0.22,1.222,0.775,0.954,1.387-0.222,0.507-0.854,0.727-1.117,1.194-0.065,0.12-0.082,0.331-0.025,0.462,0.307,0.712,1.126,1.208,1.734,1.628,1.316,0.906,2.801,1.579,4.314,2.072,1.252,0.407,1.847,1.153,2.655,2.117,0.818,0.977,1.989,1.665,3.018,2.396,0.451,0.322,0.753,0.742,1.147,1.115,0.532,0.505,1.589,0.44,2.252,0.478,1.445,0.08,2.859,0.139,4.28,0.443,0.953,0.204,1.865,0.547,2.793,0.833,1.754,0.542,3.63,0.781,5.441,1.026,1.421,0.192,2.842,0.364,4.279,0.333,0.456-0.009,1.086,0.01,1.514-0.19,0.023-0.011,0.017-0.227,0-0.229-0.021-0.004-0.048,0.01-0.067,0.018-0.022,0.011-0.016,0.227,0,0.229,0.433,0.063,1.102-0.221,1.52-0.311,1.133-0.24,2.266-0.485,3.398-0.729,1.149-0.248,2.3-0.497,3.449-0.744,0.5-0.108,1.158-0.377,1.675-0.352v-0.229c-1.144,0.623-2.854,0.674-4.11,0.913-1.953,0.372-3.923,0.717-5.839,1.253-1.521,0.426-2.729,1.497-3.982,2.417-0.754,0.552-1.503,1.11-2.25,1.669-0.354,0.266-0.688,0.475-0.66,0.947,0.033,0.563,1.451,0.681,1.86,0.786,1.246,0.321,2.393,0.855,3.539,1.431,1.808,0.906,3.983,1.013,5.96,1.213,1.926,0.195,3.758,0.477,5.67,0.838,1.955,0.37,3.966,0.202,5.944,0.322,1.103,0.067,2.065,0.227,3.188,0.163,1.969-0.112,3.948-0.357,5.921-0.347,1.625,0.008,3.139-0.209,4.748-0.389,1.257-0.14,2.51-0.03,3.746,0.222,0.351,0.07,0.722,0.154,1.037,0.331-0.094-0.054,0.089-0.097-0.201-0.049-0.397,0.066-0.828,0.023-1.229,0.037-2.317,0.081-4.687,0.707-6.695,1.837-0.733,0.413-1.35,0.929-1.99,1.471-1.021,0.867-2.438,1.607-3.172,2.739-1.605,2.475,5.788,3.6,7.128,3.988,2.344,0.679,4.438,1.595,6.896,1.754,1.664,0.108,3.463,0.397,5.021,1.017,0.947,0.374,1.909,0.71,2.886,0.998,1.039,0.307,2.142,0.281,3.163,0.592,0.813,0.245,1.582,0.968,2.358,1.33,1.081,0.505,1.884,0.574,3.014,0.332,0.996-0.216,1.85-0.111,2.521,0.688,0.446,0.53,0.747,1.52,1.595,1.416,0.649-0.078,1.223-0.034,1.859,0.117,0.376,0.089,0.823,0.45,0.938,0.094-0.015,0.047-0.036,0.094-0.056,0.14-0.713,1.678-1.708,3.262-2.618,4.834-2.983,5.155-5.957,10.431-9.73,15.055-3.721,4.561-8.182,8.477-12.948,11.909-3.979,2.864-8.242,5.599-12.661,7.739-4.435,2.149-9.347,3.108-14.226,3.521-6.249,0.53-12.562,0.138-18.791-0.449-5.753-0.543-11.008-2.426-16.016-5.284-8.969-5.118-16.712-12.588-23.209-20.552-3.651-4.475-6.646-9.511-8.842-14.854-0.229-0.556-0.443-1.115-0.646-1.681-0.048-0.131-0.093-0.262-0.138-0.395-0.007-0.024-0.016-0.048-0.023-0.073,0.111,0.341,0.297,0.213,0.664,0.186,2.444-0.173,4.922-0.729,7.316-1.232,1.082-0.228,2.161-0.537,3.12-1.103,0.986-0.58,1.946-0.883,3.059-1.184,1.73-0.467,3.521-0.754,5.158-1.503,0.43-0.197,0.939-0.479,0.924-1.008-0.015-0.53-1.561-0.991-0.791-1.193,0.562-0.147,1.283,0.04,1.846,0.077,1.177,0.078,2.54-0.046,3.656,0.387,0.591,0.23,1.268,0.235,1.892,0.24,0.341,0.003,1.617-0.14,1.746-0.47,0.3-0.77-0.472-1.617-0.729-2.29-0.287-0.75-0.209-0.956-1.033-1.048-0.254-0.029-0.46-0.305-0.685-0.417-0.27-0.136-0.588-0.199-0.871-0.304-0.732-0.268-1.337-0.792-2.073-1.042-0.412-0.14-0.889-0.121-1.315-0.186-1.283-0.194-2.823-0.576-3.953-1.249-1.098-0.653-2.532-0.887-3.747-1.212-0.801-0.214-1.604-0.248-2.402-0.431-1.582-0.363-3.116-0.924-4.698-1.3v0.229c0.501,0.046,3.543,0.783,3.543,0.293,0-0.2-0.157-0.28-0.3-0.407-0.577-0.516,1.688-0.378,1.868-0.376,1.057,0.012,2.129-0.063,3.188-0.091,1.097-0.028,2.313-0.079,3.309-0.593,0.425-0.221,3.385,1.381,3.366,0.144-0.005-0.297-0.15-0.771,0.234-0.827,0.45-0.063,1.134,0.394,1.553,0.532,0.82,0.272,1.918,0.026,2.75-0.11,0.743-0.123,1.524-0.106,2.273-0.118,0.489-0.009,1.091,0.081,1.534-0.176,0.427-0.247,0.703-0.557,1.199-0.754,1.595-0.632,0.094-1.328-0.802-1.56-0.491-0.127-0.92-0.666-1.282-0.984-0.494-0.434-1.026-0.803-1.604-1.115-1.354-0.731-3.003-0.818-4.471-1.197-4.207-1.087-8.464-2.04-12.679-3.128,0.001,0-0.034,0.22,0,0.229,1.508,0.397,3.035,0.729,4.567,1.014,2.167,0.405,4.195,0.403,6.382,0.44,0.978,0.017,1.95,0.292,2.911,0.28,0.833-0.011,1.664-0.129,2.488-0.237,0.913-0.12,2.04-0.126,2.804-0.711,0.933-0.715,2.128-0.94,3.264-1.095,0.53-0.073,2.87-0.135,2.948-0.91,0.025-0.268-0.056-0.405-0.257-0.583-0.935-0.83-2.5-1.146-3.611-1.714-1.266-0.646-1.703-2.294-2.709-3.223-0.927-0.855-2.18-1.322-3.238-1.993-1.189-0.756-2.315-1.613-3.409-2.499-0.504-0.406-2.654-1.903-1.93-2.58,0.689-0.646,1.948-0.727,2.756-1.239,0.418-0.266,0.055-0.646-0.243-0.776-1.416-0.613-3.1-0.764-4.587-1.152-1.789-0.469-3.738-1.063-5.113-2.358-1.35-1.274,2.023-1.472,2.023-2.622,0-0.267-0.237-0.404-0.429-0.554-0.757-0.59-1.594-1.087-2.406-1.594-0.765-0.477-1.536-0.941-2.318-1.392-0.202-0.117-0.416-0.22-0.61-0.348-0.781-0.515,0.049-1.791,0.457-2.25,0.741-0.83,2.092-1.23,3.078-1.685,1.192-0.548,2.389-1.089,3.567-1.663,1.955-0.953,3.621-2.454,5.329-3.781,1.644-1.278,3.283-2.563,4.92-3.851,0.046-0.036-0.025-0.21,0-0.229-2.348,1.848-4.7,3.69-7.069,5.511-1.031,0.793-2.012,1.541-3.18,2.12-1.081,0.536-2.183,1.029-3.279,1.532-1.131,0.519-2.445,0.955-3.366,1.815-0.493,0.463-1.197,1.944-0.547,2.616,0.391,0.403,1.067,0.651,1.545,0.935,0.926,0.55,1.841,1.116,2.741,1.703,0.272,0.178,1.725,0.924,1.388,1.325-0.497,0.592-1.415,0.861-2.079,1.215-0.214,0.114-0.193,0.546-0.173,0.739,0.063,0.594,0.738,1,1.193,1.313,1.591,1.098,3.622,1.572,5.475,2.015,0.793,0.189,1.592,0.359,2.385,0.552,0.444,0.109,1.041,0.199,1.396,0.515,0.108,0.095-1.905,0.911-2.166,1.008-0.466,0.172-0.931,0.379-0.945,0.919-0.014,0.463,0.349,0.813,0.645,1.121,0.836,0.87,1.846,1.608,2.804,2.337,1.009,0.767,2.056,1.49,3.155,2.118,1.164,0.665,2.317,1.207,3.072,2.366,0.368,0.565,0.613,1.016,1.086,1.514,0.583,0.612,1.079,0.874,1.861,1.235,0.688,0.32,1.394,0.601,2.076,0.934,0.956,0.466,0.254,0.829-0.427,1.021-1.533,0.437-3.087,0.317-4.553,1.049-0.563,0.28-0.906,0.623-1.542,0.769-1.213,0.275-2.5,0.4-3.741,0.49-1.003,0.071-1.932-0.196-2.939-0.211-0.916-0.014-1.835,0.009-2.755,0.008-2.9-0.003-5.901-0.775-8.694-1.509v0.229c3.138,0.811,6.271,1.65,9.423,2.41,2.445,0.591,5.1,0.81,7.432,1.776,1.187,0.49,1.934,1.511,2.994,2.16,0.332,0.204,0.814,0.235,1.178,0.39,1.032,0.436-0.398,0.858-0.803,1.06-0.272,0.136-0.432,0.396-0.689,0.546-0.463,0.269-1.309,0.112-1.813,0.12-0.701,0.011-1.409,0.038-2.103,0.146-0.921,0.144-1.914,0.283-2.815-0.016-0.381-0.126-1.564-0.875-1.586-0.055-0.005,0.17,0.015,0.339,0.036,0.508,0.063,0.537-1.059,0.315-1.322,0.283-0.669-0.08-1.576-0.688-2.188-0.404-1.021,0.472-2.248,0.481-3.35,0.51-1.188,0.029-2.387,0.112-3.573,0.073-0.392-0.014-1.867-0.103-1.379,0.713,0.072,0.121,0.211,0.212,0.316,0.304,0.099,0.086,0.066-0.064-0.052-0.051-0.168,0.021-0.357-0.015-0.522-0.03-0.961-0.09-1.906-0.346-2.864-0.434-0.007-0.001-0.026,0.224,0,0.229,1.732,0.411,3.472,1.203,5.237,1.396,1.722,0.19,3.426,0.7,5.058,1.281,1.361,0.485,2.616,1.103,4.062,1.429,0.58,0.132,1.188,0.114,1.76,0.271,0.933,0.255,1.716,0.943,2.654,1.24,0.326,0.104,0.54,0.268,0.812,0.467,0.427,0.312,0.695-0.131,1.023,0.484,0.278,0.521,0.394,1.16,0.678,1.702,0.445,0.847-0.109,0.929-0.818,1.115-0.774,0.204-1.741,0.15-2.498-0.1-1.096-0.362-2.263-0.33-3.407-0.402-0.296-0.019-2.636-0.499-2.589,0.298,0.01,0.161,0.015,0.148,0.117,0.283,0.17,0.225,0.58,0.37,0.815,0.513,0.619,0.379-0.532,0.936-0.668,1.008-1.21,0.645-2.584,0.872-3.909,1.142-0.915,0.186-1.841,0.504-2.731,0.772-1.275,0.385-2.326,1.228-3.62,1.621-1.359,0.414-2.799,0.643-4.203,0.847-1.61,0.233-3.224,0.656-4.858,0.676-0.021,0-0.011,0.202-0.003,0.225,2.69,8.358,8.143,15.683,14.042,22.048,7.424,8.009,16.361,15.622,26.838,19.188,2.749,0.937,5.548,1.382,8.429,1.654,3.319,0.313,6.648,0.533,9.981,0.616,5.451,0.137,10.97-0.146,16.279-1.469,4.608-1.146,8.642-3.399,12.672-5.842,4.696-2.848,9.18-6.052,13.248-9.749,3.087-2.806,5.882-5.927,8.314-9.317,2.462-3.429,4.558-7.156,6.697-10.793,0.992-1.685,1.979-3.377,2.878-5.112,0.189-0.363,0.412-0.739,0.538-1.132,0.011-0.028,0.029-0.212-0.003-0.225-0.88-0.38-1.848-0.583-2.801-0.436-0.817,0.125-1.188-0.875-1.595-1.417-0.636-0.846-1.557-0.861-2.521-0.688-1.169,0.209-1.882,0.156-3.014-0.331-0.835-0.358-1.527-1-2.358-1.331-0.414-0.165-0.9-0.155-1.336-0.192-0.619-0.055-1.231-0.231-1.827-0.398-1.461-0.41-2.827-1.082-4.304-1.423-2.151-0.495-4.385-0.459-6.51-1.026-2.274-0.606-4.435-1.445-6.739-1.953-1.072-0.234-2.264-0.643-3.206-1.2-0.299-0.178-0.59-0.374-0.856-0.597-1.046-0.868,0.298-1.825,0.979-2.333,1.866-1.39,3.393-2.872,5.547-3.826,1.079-0.477,2.2-0.508,3.333-0.754,0.451-0.098,0.9-0.17,1.361-0.212,0.567-0.053,1.233,0.081,1.776-0.11,0.09-0.032,0.047-0.231,0.033-0.296-0.093-0.415-1.926-0.543-2.23-0.584-2.232-0.305-4.376,0.4-6.602,0.372-1.218-0.016-2.421,0.048-3.638,0.128-1.653,0.11-3.522,0.504-5.174,0.165-1.8-0.368-3.703-0.146-5.527-0.245-1.929-0.105-3.774-0.823-5.702-0.941-2.084-0.127-4.271-0.265-6.284-0.847-0.895-0.259-1.715-0.779-2.556-1.162-0.676-0.309-1.385-0.536-2.1-0.731-0.474-0.128-2.425-0.356-1.317-1.187,1.694-1.271,3.37-2.652,5.188-3.744,0.622-0.374,1.433-0.512,2.128-0.681,1.196-0.294,2.407-0.526,3.615-0.762,1.168-0.227,2.338-0.441,3.504-0.677,0.592-0.119,1.324-0.183,1.863-0.477,0.024-0.014,0.015-0.229,0-0.229-0.466-0.023-1.058,0.219-1.51,0.316-1.132,0.242-2.263,0.487-3.395,0.731-1.151,0.248-2.302,0.497-3.452,0.742-0.463,0.099-1.207,0.415-1.686,0.346v0.229c0.02-0.008,0.047-0.021,0.067-0.019v-0.229c-0.37,0.172-0.889,0.157-1.283,0.181-1.507,0.091-3.02-0.127-4.51-0.324-1.821-0.239-3.673-0.51-5.441-1.025-0.846-0.247-1.668-0.555-2.523-0.771-1.494-0.376-3.02-0.438-4.55-0.506-0.693-0.031-1.577-0.01-2.18-0.419-0.456-0.309-0.767-0.836-1.22-1.173-0.976-0.725-2.051-1.357-2.892-2.247-0.916-0.971-1.427-1.791-2.781-2.267-1.423-0.501-2.762-1.095-4.044-1.896-0.482-0.302-0.938-0.643-1.367-1.016-0.153-0.133-0.29-0.281-0.423-0.435-0.354-0.406,0.155-0.716,0.443-0.989,2.694-2.571-4.868-3.764-6.135-4.053-1.554-0.354-3.115-0.675-4.665-1.05-0.272-0.065-0.546-0.138-0.815-0.214-0.21-0.059,0.983-0.535,1.034-0.552,0.654-0.228,1.844-0.587,1.996-1.371,0.186-0.948-1.948-1.594-2.566-1.902-1.836-0.916-4.025-1.668-5.61-2.998-1.276-1.071,4.481-3.587,5.022-3.858,1.422-0.715,2.725-1.702,4-2.646,2.37-1.753,4.696-3.604,6.899-5.565,0.05-0.035-0.023-0.2,0.004-0.224'/%3E %3Cpath d='m531.57,329.37c-0.529,0.822-1.207,1.521-1.896,2.211-0.089,0.089,0.056,0.399,0,0.455,0.693-0.695,1.376-1.398,1.908-2.228,0.066-0.102-0.041-0.394-0.012-0.438'/%3E %3Cpath d='m532.52,330.32c-0.444,0.674-0.84,1.374-1.162,2.113-0.053,0.118,0.039,0.376,0.012,0.439,0.323-0.739,0.718-1.44,1.162-2.113,0.065-0.101-0.041-0.395-0.012-0.439'/%3E %3Cg fill='%234f91c5'%3E %3Cpath d='m584.28,363.1c0.815-0.563,1.559-0.303,2.448-0.091,0.809,0.192,1.456,0.067,2.216-0.238,0.038-0.016-0.012-0.223,0-0.229-0.776,0.313-1.394,0.408-2.216,0.239-0.903-0.186-1.615-0.483-2.448,0.091-0.045,0.032,0.021,0.212,0,0.228'/%3E %3Cpath d='m585.6,364.14c0.21-0.521,0.981-0.384,1.424-0.38,0.017,0,0.018-0.227,0-0.227-0.451-0.004-1.218-0.143-1.43,0.387-0.024,0.062,0.019,0.188,0.006,0.22'/%3E %3Cpath d='m583.07,362.33c0.886-0.571,1.75-0.42,2.742-0.548,0.027-0.004,0.009-0.229,0-0.229-0.992,0.13-1.856-0.022-2.742,0.55-0.046,0.027,0.02,0.214,0,0.227'/%3E %3Cpath d='m577.67,365.04c-1.93-0.817-3.919,0.564-5.871-0.22,0.011,0.004-0.04,0.211,0,0.229,1.952,0.783,3.941-0.6,5.871,0.219-0.01-0.005,0.04-0.21,0-0.228'/%3E %3Cpath d='m573.63,365.4c-1.146-0.505-2.259,0.399-3.45,0.009,0.007,0.002-0.036,0.216,0,0.229,1.191,0.389,2.304-0.514,3.45-0.01-0.011-0.005,0.041-0.209,0-0.228'/%3E %3Cpath d='m571.33,366.28c-0.862-0.677-2.25-0.072-3.237-0.109-0.015,0-0.02,0.227,0,0.228,0.987,0.036,2.375-0.566,3.237,0.109-0.024-0.02,0.046-0.192,0-0.228'/%3E %3Cpath d='m574.84,414.12c-0.94,0.361-2.849,0.492-3.626-0.293-1.021-1.033-2.098-0.461-3.404-0.318-0.023,0.003-0.009,0.228,0,0.227,1.073-0.116,2.412-0.761,3.267,0.16,0.841,0.905,2.68,0.869,3.764,0.451,0.038-0.015-0.011-0.223-0.001-0.227'/%3E %3Cpath d='m559.07,387.6c1.889-1.07,3.772,0.335,5.731-0.229,0.035-0.01-0.003-0.227,0-0.228-1.959,0.563-3.843-0.84-5.731,0.229-0.044,0.026,0.018,0.218,0,0.228'/%3E %3Cpath d='m542.91,391.73c0.779-0.291,1.458-0.405,2.263-0.164,0.747,0.224,1.41,0.556,2.192,0.672,1.928,0.287,3.931-0.464,5.859-0.508,0.02,0,0.017-0.228,0-0.227-1.965,0.045-3.886,0.669-5.859,0.507-0.769-0.063-1.477-0.416-2.192-0.672-0.776-0.278-1.514-0.115-2.263,0.165-0.039,0.014,0.009,0.224,0,0.227'/%3E %3Cpath d='m544.85,393.79c2.148-0.839,4.44,0.033,6.647-0.458,0.031-0.008,0.001-0.229,0-0.229-2.207,0.492-4.499-0.38-6.647,0.459-0.039,0.016,0.01,0.224,0,0.228'/%3E %3Cpath d='m563.08,386.11c1.901-0.733,3.654-0.266,5.616-0.229,0.016,0,0.019-0.228,0-0.229-1.962-0.037-3.715-0.505-5.616,0.23-0.039,0.016,0.009,0.224,0,0.228'/%3E %3Cpath d='m569.15,384.2c1.152-0.165,2.169-0.212,3.323-0.038,0.007,0.001,0.027-0.223,0-0.228-1.154-0.175-2.171-0.127-3.323,0.038-0.028,0.004-0.007,0.229,0,0.228'/%3E %3Cpath d='m549.44,399.87c2.347-1.294,4.945,0.808,7.221-0.572,0.044-0.027-0.02-0.217,0-0.228-2.275,1.379-4.874-0.722-7.221,0.573-0.045,0.024,0.017,0.217,0,0.227'/%3E %3Cpath d='m551.39,401.58c1.556-0.327,3.125-0.576,4.699-0.803,0.026-0.004,0.007-0.229,0-0.228-1.574,0.226-3.144,0.475-4.699,0.803-0.031,0.007-0.002,0.228,0,0.228'/%3E %3Cpath d='m556.43,395.85c1.497-0.812,3.482,0.141,4.699-1.261,0.043-0.049-0.028-0.195,0-0.227-1.217,1.4-3.202,0.448-4.699,1.261-0.044,0.023,0.017,0.217,0,0.227'/%3E %3Cpath d='m564,403.99c1.695-1.267,3.868,0.045,5.616-1.031,0.045-0.027-0.02-0.215,0-0.228-1.748,1.076-3.921-0.234-5.616,1.032-0.046,0.034,0.024,0.21,0,0.227'/%3E %3Cpath d='m563.42,399.75c1.129-0.151,2.297-0.53,3.431-0.266,1.097,0.256,1.928,0.978,3.103,0.953,0.02-0.001,0.017-0.228,0-0.228-1.026,0.021-1.853-0.481-2.779-0.848-1.197-0.475-2.538-0.003-3.754,0.16-0.026,0.005-0.007,0.23-0.001,0.229'/%3E %3Cpath d='m564.57,412.59c1.733-0.815,3.324-0.761,5.158-0.344,1.596,0.362,2.635,1.006,3.896-0.458,0.043-0.05-0.028-0.195,0-0.229-1.192,1.385-2.359,0.951-3.896,0.459-1.732-0.555-3.529-0.423-5.158,0.345-0.042,0.019,0.014,0.222,0,0.227'/%3E %3Cpath d='m580.62,407.66c1.91,0.368,3.502,0.143,5.314-0.511,0.951-0.343,1.852-0.724,2.867-0.814,0.93-0.081,1.895,0.111,2.821,0.18,0.012,0.001,0.022-0.227,0-0.229-0.941-0.067-1.876-0.205-2.821-0.178-1.001,0.029-1.943,0.474-2.867,0.813-1.805,0.663-3.411,0.879-5.314,0.513-0.004-0.002-0.031,0.22,0,0.226'/%3E %3Cpath d='m593.34,406.74c1.508-0.226,2.966-0.65,4.503-0.525,1.558,0.126,2.794,0.939,4.323,0.182,0.042-0.021-0.015-0.219,0-0.227-1.345,0.666-2.522,0.154-3.897-0.115-1.657-0.324-3.299,0.214-4.929,0.459-0.026,0.003-0.005,0.227,0,0.226'/%3E %3Cpath d='m605.49,406.51c2.968-1.084,5.166,1.517,8.023,1.72,0.012,0.001,0.021-0.226,0-0.228-2.857-0.204-5.056-2.804-8.023-1.719-0.039,0.013,0.008,0.224,0,0.227'/%3E %3Cpath d='m616.83,406.97c1.337-0.426,2.572-0.196,3.91,0.086,1.427,0.3,2.69,0.265,3.998-0.43,0.043-0.023-0.017-0.219,0-0.228-1.317,0.699-2.563,0.716-3.998,0.43-1.346-0.27-2.565-0.515-3.91-0.085-0.036,0.011,0.005,0.225,0,0.227'/%3E %3Cpath d='m626.35,408.12c2.131-1.185,4.375-0.785,6.648-1.375,0.032-0.009-0.002-0.228,0-0.229-2.273,0.59-4.518,0.192-6.648,1.376-0.044,0.025,0.017,0.217,0,0.228'/%3E %3Cpath d='m610.53,415.34c1.014-0.86,2.169-0.815,3.416-0.624,1.162,0.178,2.401,0.482,3.347-0.408,0.046-0.042-0.027-0.201,0-0.227-0.869,0.818-1.988,0.628-3.072,0.451-1.33-0.215-2.596-0.349-3.69,0.58-0.047,0.039,0.025,0.206-0.001,0.228'/%3E %3Cpath d='m612.02,417.75c1.715-1.365,3.864-0.781,5.731-1.72,0.042-0.021-0.016-0.22,0-0.228-1.867,0.938-4.017,0.354-5.731,1.72-0.046,0.036,0.025,0.207,0,0.228'/%3E %3Cpath d='m633.22,412.36c1.95-0.091,3.91,0.089,5.845-0.229,0.029-0.005,0.006-0.229,0-0.229-1.935,0.319-3.895,0.139-5.845,0.23-0.02,0.002-0.014,0.228,0,0.228'/%3E %3Cpath d='m633.91,414.54c0.71-0.358,1.405-0.613,2.207-0.63,0.68-0.014,1.352,0.09,2.034,0.058,0.021-0.002,0.013-0.229,0-0.228-0.682,0.033-1.354-0.046-2.034-0.058-0.79-0.015-1.514,0.278-2.207,0.631-0.043,0.021,0.016,0.219,0,0.227'/%3E %3Cpath d='m638.04,409.84c0.619-0.662,1.602-0.397,2.406-0.573,0.031-0.007,0.001-0.228,0-0.227-0.805,0.174-1.787-0.089-2.406,0.573-0.044,0.047,0.027,0.197,0,0.227'/%3E %3Cpath d='m583.02,413.28c1.149-0.893,2.356-0.924,3.754-0.859,1.521,0.069,2.756-0.177,3.925-1.203,0.047-0.04-0.025-0.205,0-0.228-1.175,1.033-2.4,1.263-3.925,1.203-1.401-0.054-2.599-0.038-3.754,0.86-0.046,0.035,0.024,0.208,0,0.227'/%3E %3Cpath d='m584.17,414.54c1.796-1.371,4.051-0.237,6.075-0.802,0.034-0.01-0.003-0.227,0-0.228-2.024,0.563-4.279-0.569-6.075,0.803-0.045,0.034,0.024,0.209,0,0.227'/%3E %3Cpath d='m581.53,410.07c2.642-1.442,5.954,1.508,8.252-0.802,0.046-0.045-0.026-0.2,0-0.229-2.298,2.312-5.61-0.64-8.252,0.804-0.044,0.023,0.017,0.217,0,0.227'/%3E %3Cpath d='m590.36,421.07c1.079-0.798,1.693-0.399,2.865-0.115,1.666,0.407,3.334,0.458,5.044,0.459,0.016,0,0.016-0.228,0-0.228-1.557,0-3.089-0.036-4.616-0.354-1.303-0.27-2.092-0.878-3.293,0.011-0.046,0.033,0.022,0.21,0,0.227'/%3E %3Cpath d='m590.36,422.79c2.066-1.476,4.625,0.813,6.877,0.458,0.027-0.004,0.006-0.229,0-0.228-2.252,0.355-4.811-1.934-6.877-0.458-0.045,0.032,0.022,0.211,0,0.228'/%3E %3Cpath d='m577.29,385.42c2.13-1.508,4.375,0.427,6.647-0.344,0.037-0.013-0.007-0.226,0-0.228-2.272,0.771-4.518-1.164-6.647,0.345-0.045,0.032,0.021,0.212,0,0.227'/%3E %3Cpath d='m578.55,386.57c1.452-0.37,2.902,0.256,4.354-0.115,0.034-0.008-0.001-0.228,0-0.228-1.452,0.37-2.902-0.256-4.354,0.115-0.033,0.008,0.001,0.228,0,0.228'/%3E %3Cpath d='m566.75,397.69c1.773-0.771,3.506-0.593,5.387-0.572,0.018,0,0.019-0.228,0-0.228-1.881-0.021-3.613-0.199-5.387,0.573-0.041,0.017,0.011,0.222,0,0.227'/%3E %3Cpath d='m631.04,400.9c1.28-1.485,3.415-1.064,5.158-1.262,0.024-0.003,0.009-0.228,0-0.227-1.743,0.196-3.878-0.225-5.158,1.261-0.043,0.049,0.029,0.195,0,0.228'/%3E %3Cpath d='m625.77,404.68c2.111-2.024,4.774-0.284,7.221-1.262,0.039-0.015-0.01-0.223,0-0.227-2.446,0.976-5.109-0.764-7.221,1.261-0.045,0.044,0.028,0.202,0,0.228'/%3E %3Cpath d='m573.97,408c1.358-1.756,3.362-1.221,5.272-1.719,0.034-0.009-0.001-0.227,0-0.228-1.91,0.497-3.914-0.036-5.272,1.72-0.041,0.054,0.029,0.19,0,0.227'/%3E %3Cpath d='m647.58,390.26c1.216-0.257,2.365-0.566,3.619-0.465,1.284,0.104,2.352,0.231,3.567-0.311,0.041-0.019-0.013-0.222,0-0.228-1.189,0.531-2.304,0.462-3.567,0.31-1.234-0.147-2.424,0.213-3.619,0.466-0.03,0.007-0.001,0.228,0,0.228'/%3E %3Cpath d='m646.62,392.41c0.847-0.166,1.63-0.197,2.486-0.236,0.711-0.03,1.298-0.354,1.902-0.696,0.044-0.025-0.018-0.217,0-0.228-0.55,0.312-1.073,0.598-1.707,0.682-0.902,0.121-1.774,0.073-2.682,0.252-0.03,0.005-0.002,0.226,0.001,0.226'/%3E %3Cpath d='m643.19,388.12c1.542-0.701,3.946,0.892,5.051-0.772,0.033-0.05-0.02-0.197-0.006-0.22-1.1,1.656-3.51,0.067-5.045,0.766-0.041,0.017,0.013,0.22,0,0.226'/%3E %3Cpath d='m649.47,393.58c0.848-0.293,1.568-0.513,2.473-0.484,0.782,0.023,1.474,0.174,2.191-0.229,0.044-0.024-0.019-0.218,0-0.228-0.7,0.393-1.422,0.284-2.191,0.229-0.895-0.064-1.642,0.197-2.473,0.485-0.038,0.013,0.007,0.226,0,0.227'/%3E %3Cpath d='m637.84,387.58c1.488-1.684,4.103,0.912,5.871-0.221,0.045-0.027-0.021-0.214,0-0.227-1.769,1.131-4.383-1.463-5.871,0.22-0.044,0.048,0.028,0.195,0,0.228'/%3E %3Cpath d='m634.83,386.75c0.529-0.847,1.673-0.565,2.524-0.641,0.961-0.086,1.684-0.626,2.357-1.275,0.044-0.043-0.028-0.2,0-0.228-0.697,0.673-1.385,1.142-2.357,1.275-0.874,0.118-1.984-0.225-2.53,0.648-0.033,0.054,0.02,0.199,0.006,0.221'/%3E %3Cpath d='m590.38,367.97c1.411-0.683,2.824,0.127,4.28-0.221,0.033-0.007,0-0.227,0-0.227-1.456,0.347-2.869-0.462-4.28,0.22-0.042,0.021,0.015,0.22,0,0.228'/%3E %3Cpath d='m592.13,369.24c0.718-0.587,1.581-0.027,2.358-0.384,0.042-0.019-0.013-0.222,0-0.228-0.777,0.355-1.641-0.202-2.358,0.385-0.046,0.037,0.025,0.206,0,0.227'/%3E %3Cpath d='m623.86,409.38c0.771-0.085,1.641,0.335,2.359-0.056,0.044-0.023-0.018-0.218,0-0.227-0.719,0.389-1.589-0.031-2.359,0.055-0.025,0.003-0.009,0.229,0,0.228'/%3E %3Cpath d='m567.98,373.9c-1.139-0.392-2.37-0.606-3.56-0.32-0.804,0.193-0.752,0.982-1.728,0.688,0.005,0.002-0.035,0.217,0,0.228,0.884,0.267,1.011-0.363,1.728-0.687,1.011-0.459,2.579-0.017,3.56,0.318-0.007-0.003,0.038-0.214,0-0.227'/%3E %3Cpath d='m567.27,375.11c-2.007-0.907-4.154-0.117-6.255-0.329-0.011-0.001-0.025,0.225,0,0.227,2.101,0.213,4.248-0.578,6.255,0.329-0.014-0.006,0.041-0.209,0-0.227'/%3E %3Cpath d='m564.69,376.26c-1.035-0.358-2.009-0.861-3.061-1.174-1.198-0.356-2.52-0.355-3.743-0.638,0,0-0.032,0.221,0,0.228,1.104,0.256,2.226,0.388,3.347,0.549,1.204,0.174,2.318,0.869,3.457,1.262-0.007-0.002,0.038-0.214,0-0.227'/%3E %3Cpath d='m560.3,397.45c1.412-1.768,3.505-0.529,5.377-0.933,0.032-0.006,0.002-0.228,0-0.228-1.872,0.403-3.965-0.836-5.377,0.934-0.042,0.052,0.028,0.191,0,0.227'/%3E %3Cpath d='m560.36,398.49c0.685-0.307,1.314-0.702,2.085-0.713,0.701-0.011,1.391,0.451,2.085,0.549,0.007,0.001,0.026-0.225,0-0.229-0.72-0.1-1.365-0.447-2.085-0.549-0.712-0.1-1.467,0.438-2.085,0.714-0.041,0.019,0.012,0.222,0,0.228'/%3E %3Cpath d='m561.62,401.51c0.424-0.414,0.828-0.54,1.385-0.336,0.459,0.167,0.829,0.347,1.304,0.116,0.043-0.021-0.015-0.22,0-0.227-0.467,0.227-0.853,0.061-1.304-0.116-0.549-0.218-0.971-0.069-1.385,0.336-0.045,0.045,0.027,0.201,0,0.227'/%3E %3Cpath d='m562.55,394.65c0.534-0.303,0.992-0.285,1.549-0.065,0.563,0.225,1.011,0.365,1.579,0.065,0.043-0.023-0.016-0.219,0-0.228-0.516,0.272-0.948,0.194-1.467-0.019-0.597-0.244-1.078-0.312-1.661,0.019-0.044,0.026,0.019,0.218,0,0.228'/%3E %3Cpath d='m557.06,393.99c0.909-0.22,1.606,0.283,2.488,0.41,0.689,0.101,1.454-0.34,2.121-0.466,0.03-0.006,0.004-0.228,0-0.227-0.711,0.134-1.39,0.493-2.121,0.466-0.91-0.033-1.544-0.638-2.488-0.411-0.032,0.007,0,0.228,0,0.228'/%3E %3Cpath d='m570.29,406.23c1.116-1.142,2.71-0.188,4.006-0.823,0.042-0.021-0.015-0.22,0-0.227-1.296,0.636-2.89-0.319-4.006,0.823-0.044,0.045,0.027,0.199,0,0.227'/%3E %3Cpath d='m594.76,407.93c1.488-0.882,3.056-0.268,4.664-0.275,0.019,0,0.018-0.227,0-0.227-1.608,0.007-3.176-0.607-4.664,0.274-0.044,0.027,0.02,0.216,0,0.228'/%3E %3Cpath d='m605.08,407.66c1.891-0.671,3.384,1.088,5.267,0.713,0.031-0.006,0.003-0.228,0-0.228-1.883,0.375-3.376-1.385-5.267-0.713-0.038,0.013,0.007,0.225,0,0.228'/%3E %3Cpath d='m618.08,407.98c1.521-0.273,3.807,1.175,5.049-0.11,0.044-0.045-0.028-0.199,0-0.227-1.242,1.283-3.527-0.163-5.049,0.109-0.029,0.005-0.004,0.229,0,0.228'/%3E %3Cpath d='m627.14,409.13c0.557-1.104,1.728-0.626,2.72-0.523,1.186,0.125,2.298,0.025,3.257-0.735,0.046-0.035-0.023-0.208,0-0.227-1.074,0.851-2.3,0.835-3.604,0.698-0.943-0.099-1.867-0.444-2.378,0.566-0.03,0.058,0.019,0.193,0.005,0.221'/%3E %3Cpath d='m584.88,408.42c1.011-0.047,1.864-0.449,2.806-0.772,1.042-0.354,2.162-0.021,3.175-0.435,0.04-0.017-0.011-0.223,0-0.229-0.904,0.371-1.911,0.145-2.857,0.347-1.087,0.231-1.985,0.809-3.123,0.862-0.021,0.002-0.015,0.227-0.001,0.227'/%3E %3Cpath d='m591.74,417.42c1.591-1.813,4.049-0.037,5.926-1.152,0.044-0.026-0.019-0.216,0-0.228-1.877,1.115-4.335-0.66-5.926,1.152-0.043,0.05,0.028,0.196,0,0.228'/%3E %3Cpath d='m593.94,418.03c1.511-0.534,3.944,0.372,5.048-1.043,0.042-0.053-0.029-0.189,0-0.227-1.104,1.414-3.537,0.508-5.048,1.043-0.038,0.013,0.008,0.224,0,0.227'/%3E %3Cpath d='m608.2,424.06c1.118-1.151,2.381-1.289,3.893-1.008,1.77,0.329,3.424,0.692,5.215,0.294,0.032-0.008,0.001-0.229,0-0.228-1.641,0.365-3.188,0.111-4.813-0.214-1.652-0.331-3.043-0.361-4.295,0.928-0.044,0.045,0.027,0.199,0,0.228'/%3E %3Cpath d='m608.92,424.56c0.924-0.623,1.913-0.854,3.018-0.714,0.008,0.001,0.026-0.224,0-0.227-1.104-0.143-2.094,0.091-3.018,0.714-0.045,0.031,0.022,0.213,0,0.227'/%3E %3Cpath d='m578.51,405.44c0.735-0.917,2.142-0.375,3.111-0.8,0.041-0.019-0.014-0.223,0-0.228-0.97,0.425-2.376-0.118-3.111,0.8-0.042,0.053,0.029,0.192,0,0.228'/%3E %3Cpath d='m583.85,405.52c0.236-1.287,2.084-0.613,2.927-1.14,0.045-0.028-0.021-0.216,0-0.228-0.868,0.543-2.694-0.156-2.938,1.171-0.009,0.045,0.007,0.217,0.011,0.197'/%3E %3Cpath d='m593.35,404.68c-0.761-0.045-1.453-0.319-2.223-0.268-0.851,0.058-1.682,0.468-2.488,0.712-0.036,0.011,0.005,0.227,0,0.228,0.83-0.252,1.627-0.578,2.488-0.712,0.75-0.117,1.479,0.223,2.223,0.267,0.014,0.001,0.022-0.226,0-0.227'/%3E %3Cpath d='m596.73,405.09c1.014-0.21,1.984-0.229,3.01-0.101,0.843,0.105,1.754,0.583,2.589,0.455,0.027-0.003,0.006-0.228,0-0.227-0.734,0.111-1.502-0.271-2.23-0.4-1.134-0.202-2.242-0.188-3.368,0.045-0.032,0.007-0.003,0.228-0.001,0.228'/%3E %3Cpath d='m607.49,405.44c1.293-0.134,2.641,0.276,3.732-0.622,0.045-0.038-0.024-0.207,0-0.229-1.092,0.9-2.439,0.488-3.732,0.623-0.025,0.002-0.01,0.229,0,0.228'/%3E %3Cpath d='m614.51,405.18c2.1-2.153,5.062,0.104,7.555-0.622,0.035-0.011-0.004-0.227,0-0.228-2.493,0.728-5.455-1.531-7.555,0.623-0.044,0.046,0.028,0.199,0,0.227'/%3E %3Cpath d='m569,405.18c0.979-0.767,2.153-0.775,3.289-1.156,0.037-0.012-0.007-0.225,0-0.227-1.136,0.38-2.311,0.389-3.289,1.156-0.046,0.035,0.024,0.209,0,0.227'/%3E %3Cpath d='m604.38,405.26c0.836-1.19,2.263-1.247,3.552-1.596,0.034-0.01-0.002-0.228,0-0.228-1.294,0.35-2.72,0.411-3.558,1.603-0.034,0.049,0.02,0.2,0.006,0.221'/%3E %3Cpath d='m623.13,404.56c0.839-0.847,2.038-0.65,3.111-0.89,0.03-0.007,0.001-0.227,0-0.227-1.073,0.239-2.272,0.043-3.111,0.889-0.045,0.046,0.029,0.2,0,0.228'/%3E %3Cpath d='m628.28,402.78c0.779-0.56,1.661-0.541,2.578-0.622,0.022-0.002,0.011-0.228,0-0.228-0.917,0.082-1.799,0.062-2.578,0.623-0.046,0.032,0.022,0.21,0,0.227'/%3E %3Cpath d='m628.28,400.38c0.853-0.246,1.747-0.369,2.489-0.89,0.045-0.031-0.022-0.211,0-0.227-0.742,0.52-1.637,0.643-2.489,0.889-0.035,0.012,0.004,0.227,0,0.228'/%3E %3Cpath d='m565.36,401.09c0.982-0.106,1.938-0.411,2.933-0.267,0.007,0.001,0.027-0.224,0-0.228-0.995-0.144-1.95,0.159-2.933,0.268-0.025,0.003-0.009,0.228,0,0.227'/%3E %3C/g%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.458' d='m523.83,317.68s8.07-0.732,7.675,0.649c-0.394,1.381,0.396,1.381,2.565,1.381s8.088-0.789,8.68,0.196c0.591,0.986,6.313-0.395,8.482-0.788,2.17-0.396,3.748-0.396,4.932-0.593,1.183-0.196,3.353-0.789,3.353,0s0.593,2.565,0.593,2.565,2.564,2.17,4.34,2.17c1.774,0,2.367,0.592,2.762,1.183,0.395,0.593,0,1.775,1.578,1.382,1.578-0.395,0.197,0.394,3.945-0.986,3.748-1.381,2.17-0.197,3.155-0.987,0.987-0.789,2.17-1.381,3.946-0.986,1.775,0.396,3.156,1.185,3.748,0.986,0.592-0.197,1.972-0.591,4.537,0.592,2.563,1.185,5.326,1.579,7.496,1.776s3.354,0.592,4.537,0,3.944-0.592,4.733-0.592c0.79,0-0.788-0.396,3.749,0.197,4.537,0.592,4.932,0.592,5.523,0s2.169-0.986,2.959-1.184c0.789-0.198,1.183-1.184,1.973-0.79,0.789,0.396,2.763,1.185,4.34,1.974,1.577,0.788,5.325,1.184,7.495,0.788,2.171-0.394,0.79-0.196,4.342,0.593,3.55,0.789,4.733,0.986,6.114,0.986s6.349-0.587,6.349-0.587l-1.813-0.417c-2.17-1.775-1.183-0.18-5.325-2.35s-2.366-1.381-8.482-2.762c-6.115-1.382-4.734-2.564-6.707-3.748-1.973-1.185-2.17,0-4.34,0-2.171,0-1.382-1.382-6.51-5.129-5.129-3.748-4.734-2.762-6.708-4.341-1.972-1.578-6.114-4.142-8.284-6.114-2.171-1.973-6.708-1.512-8.681-1.578-4.374-0.149-6.037-4.306-9.86-3.475-1.725,0.375-4.736-2.246-9.076-3.232-4.34-0.987-8.482,2.564-11.639,4.537-3.156,1.973-10.652,6.114-14.007,9.073-3.353,2.959-10.526,6.5-14.867,7.882-4.34,1.381-7.477,1.351-7.477,1.351'/%3E %3Cg fill='%23000'%3E %3Cpath d='m573.47,303.6c-0.552,0.357-1.154,0.582-1.776,0.789-0.072,0.025,0.014,0.451,0,0.455,0.622-0.207,1.225-0.432,1.776-0.789,0.09-0.057-0.042-0.428,0-0.455'/%3E %3Cpath d='m600.5,307.94c-2.096,1.107-3.716,2.894-5.721,4.144-0.089,0.055,0.041,0.429,0,0.455,2.005-1.25,3.625-3.036,5.721-4.144,0.086-0.046-0.034-0.438,0-0.455'/%3E %3Cpath d='m600.67,304.97c-1.108,1.535-2.38,2.877-4.043,3.813-0.088,0.049,0.036,0.434,0,0.454,1.668-0.938,2.943-2.29,4.056-3.828,0.069-0.096-0.041-0.4-0.013-0.439'/%3E %3Cpath d='m599.07,303.51c-0.767,0.682-1.592,1.272-2.599,1.528-0.066,0.017,0.003,0.454,0,0.455,1.007-0.256,1.832-0.848,2.599-1.528,0.091-0.081-0.053-0.408,0-0.455'/%3E %3Cpath d='m599.22,304.74c-1.146,1.157-2.228,2.451-3.743,3.133-0.083,0.037,0.024,0.444,0,0.455,1.516-0.682,2.597-1.976,3.743-3.133,0.09-0.09-0.054-0.4,0-0.455'/%3E %3Cpath d='m599.98,310.62c-1.062,1.382-1.741,3.096-3.439,3.82-0.081,0.035,0.024,0.445,0,0.455,1.705-0.727,2.375-2.436,3.439-3.82,0.083-0.108-0.058-0.381,0-0.455'/%3E %3Cpath d='m599.07,313.91c-0.625,0.72-1.123,1.641-2.063,1.987-0.077,0.028,0.016,0.448,0,0.455,0.94-0.347,1.438-1.268,2.063-1.987,0.086-0.099-0.058-0.39,0-0.455'/%3E %3Cpath d='m599.53,316.5c0.901,0.637,1.314,1.731,2.216,2.369-0.045-0.032,0.091-0.392,0-0.455-0.9-0.637-1.313-1.732-2.216-2.369,0.045,0.033-0.091,0.391,0,0.455'/%3E %3Cpath d='m601.51,321.16c0.437,0.305,0.703,0.77,1.069,1.146-0.005-0.004,0.023-0.208,0.023-0.228,0-0.05,0.016-0.187-0.023-0.228-0.366-0.376-0.633-0.842-1.069-1.146-0.004-0.003-0.023,0.214-0.023,0.229,0,0.039-0.016,0.199,0.023,0.227'/%3E %3Cpath d='m571.33,307.56c-1.21,1.263-2.615,2.316-4.203,3.057-0.083,0.039,0.028,0.442,0,0.454,1.588-0.739,2.993-1.793,4.203-3.056,0.088-0.092-0.057-0.397,0-0.455'/%3E %3Cpath d='m569.34,311c-1.938,1.647-4.256,2.582-6.648,3.362-0.073,0.023,0.012,0.451,0,0.455,2.393-0.78,4.711-1.715,6.648-3.362,0.091-0.078-0.052-0.411,0-0.455'/%3E %3Cpath d='m566.13,314.45c-1.01,1.436-2.495,3.152-4.273,3.583-0.065,0.017,0.002,0.455,0,0.455,1.787-0.434,3.27-2.154,4.285-3.599,0.069-0.096-0.041-0.398-0.012-0.439'/%3E %3Cpath d='m555.21,315.97c-1.099,0.703-2.219,1.361-3.438,1.834-0.078,0.03,0.019,0.447,0,0.455,1.22-0.473,2.34-1.131,3.438-1.834,0.089-0.057-0.041-0.427,0-0.455'/%3E %3Cpath d='m552.92,315.21c-0.289,0.078-0.559,0.207-0.84,0.306-0.076,0.026,0.014,0.449,0,0.455,0.281-0.099,0.551-0.228,0.84-0.306,0.067-0.02-0.004-0.454,0-0.455'/%3E %3Cpath d='m569.5,318.11c-0.576,0.331-1.138,0.685-1.681,1.069-0.092,0.064,0.045,0.424,0,0.455,0.543-0.385,1.104-0.738,1.681-1.069,0.087-0.051-0.038-0.435,0-0.455'/%3E %3Cpath d='m590.51,319.03c-0.81,0.37-1.603,0.768-2.369,1.223-0.088,0.052,0.039,0.433,0,0.455,0.767-0.455,1.56-0.853,2.369-1.223,0.083-0.038-0.025-0.443,0-0.455'/%3E %3Cpath d='m595.94,318.11c-0.543,0.319-0.986,0.764-1.306,1.307-0.039,0.066-0.018,0.208-0.016,0.28,0.001,0.016,0.015,0.181,0.029,0.159,0.314-0.538,0.755-0.976,1.292-1.291,0.09-0.053-0.037-0.434,0.001-0.455'/%3E %3C/g%3E %3Cg opacity='0.59' fill='%23007638'%3E %3Cpath d='m545.32,369.22c-0.088,1.037-0.089,2.198,0.518,3.091-0.028-0.043,0.08-0.339,0.013-0.439-0.469-0.687-0.568-1.508-0.498-2.33,0.004-0.059-0.019-0.499-0.033-0.322'/%3E %3Cpath d='m544.71,372.13c-0.365-0.547-0.995-1.318-0.96-2.018,0.004-0.074-0.025-0.511-0.039-0.229-0.054,1.048,0.417,1.833,0.987,2.687-0.029-0.045,0.079-0.34,0.012-0.44'/%3E %3Cpath d='m543.08,371.71c-1.221-1.464-1.811-3.356-1.928-5.24-0.017-0.28-0.044,0.154-0.039,0.229,0.122,1.965,0.689,3.935,1.967,5.467-0.058-0.069,0.085-0.353,0-0.456'/%3E %3Cpath d='m547.22,371.88c-0.149-0.164-0.225-0.362-0.318-0.56-0.01-0.021-0.028,0.143-0.028,0.159-0.002,0.079-0.02,0.206,0.015,0.279,0.099,0.203,0.179,0.407,0.332,0.576-0.006-0.006,0.022-0.207,0.022-0.228,0-0.051,0.015-0.183-0.023-0.226'/%3E %3Cpath d='m548.27,372.04c-0.188-0.066-0.375-0.135-0.479-0.316-0.014-0.021-0.028,0.144-0.028,0.158-0.003,0.072-0.022,0.214,0.015,0.28,0.11,0.188,0.295,0.264,0.493,0.333-0.015-0.005,0.074-0.43-0.001-0.455'/%3E %3Cpath d='m540.08,371.07c-0.68-1.307-0.718-2.754-0.797-4.193-0.017-0.281-0.044,0.153-0.04,0.229,0.083,1.507,0.113,3.035,0.825,4.404-0.029-0.055,0.07-0.328,0.012-0.44'/%3E %3Cpath d='m541.27,358.96c0.01,0.806,0.343,2.504-0.707,2.774-0.067,0.017,0.002,0.454,0,0.455,1.127-0.29,0.762-2.398,0.753-3.229-0.003-0.257-0.049-0.258-0.046,0'/%3E %3Cpath d='m539.51,362.27c0.225-0.235,0.387-0.513,0.493-0.819,0.029-0.083,0.019-0.193,0.016-0.279,0-0.02-0.021-0.176-0.028-0.159-0.104,0.3-0.26,0.573-0.48,0.803-0.039,0.041-0.022,0.177-0.022,0.229-0.001,0.017,0.026,0.22,0.021,0.225'/%3E %3Cpath d='m541.54,362.27c0.669-0.458,0.594-1.292,0.59-2.012-0.001-0.258-0.046-0.258-0.045,0,0.003,0.61,0.006,1.181-0.545,1.557-0.091,0.062,0.044,0.425,0,0.455'/%3E %3Cpath d='m549,360.16c0.246,0.594,0.071,1.338,0.063,1.971-0.003,0.259,0.042,0.258,0.046,0,0.009-0.769,0.208-1.674-0.098-2.41,0.027,0.065-0.062,0.319-0.011,0.439'/%3E %3Cpath d='m542.43,362.35c0.877-0.541,0.905-1.785,0.741-2.695-0.007-0.04-0.039,0.303-0.023,0.393,0.127,0.7-0.095,1.464-0.718,1.848-0.089,0.054,0.039,0.429,0,0.454'/%3E %3Cpath d='m548.36,362.18c0.184-0.296,0.249-0.625,0.259-0.97,0.002-0.085,0.014-0.197-0.017-0.28-0.006-0.018-0.027,0.141-0.027,0.159-0.006,0.229-0.108,0.462-0.228,0.651-0.039,0.064-0.018,0.21-0.016,0.28,0.001,0.018,0.014,0.182,0.029,0.16'/%3E %3Cpath d='m545.02,358.62c0.394,0.968-0.136,2.262-0.253,3.27-0.008,0.059,0.011,0.5,0.031,0.321,0.148-1.269,0.746-2.771,0.233-4.03,0.028,0.065-0.06,0.318-0.011,0.439'/%3E %3Cpath d='m549.67,362.04v-0.892c0-0.016,0.003-0.228-0.023-0.228-0.025,0-0.022,0.212-0.022,0.228v0.892c0,0.017-0.003,0.228,0.022,0.228,0.026,0,0.023-0.211,0.023-0.228'/%3E %3Cpath d='m558.25,363.25c0.538-0.587,0.509-1.425,0.509-2.174,0-0.258-0.045-0.258-0.045,0,0,0.623-0.022,1.237-0.464,1.719-0.088,0.095,0.055,0.393,0,0.455'/%3E %3Cpath d='m545.43,362.11c0.807-0.955,0.907-2.16,0.993-3.356,0.006-0.074-0.019-0.511-0.039-0.229-0.082,1.127-0.199,2.237-0.954,3.131-0.085,0.101,0.058,0.387,0,0.454'/%3E %3Cpath d='m543.32,362.27c1.449-0.467,0.84-3.089,0.66-4.155-0.006-0.039-0.038,0.304-0.023,0.394,0.17,1.008,0.656,2.89-0.637,3.307-0.073,0.023,0.01,0.45,0,0.454'/%3E %3Cpath d='m546.87,360.23c-0.039,0.584-0.106,1.23-0.629,1.59-0.091,0.063,0.044,0.425,0,0.455,0.583-0.402,0.625-1.17,0.668-1.816,0.005-0.074-0.02-0.509-0.039-0.229'/%3E %3Cpath d='m549.81,362.35c0.255-0.188,0.334-0.431,0.348-0.735,0.003-0.084,0.013-0.198-0.017-0.28-0.007-0.018-0.027,0.143-0.027,0.159-0.008,0.154-0.191,0.319-0.304,0.401-0.039,0.028-0.022,0.187-0.022,0.228,0,0.013,0.02,0.229,0.022,0.227'/%3E %3Cpath d='m547.3,362.35c0.743-0.965,0.979-2.138,0.995-3.331,0.002-0.145-0.039-0.44-0.044-0.12-0.015,1.085-0.283,2.13-0.951,2.996-0.082,0.106,0.058,0.381,0,0.455'/%3E %3Cpath d='m538.7,362.03c0.087-0.088,0.146-0.153,0.173-0.273,0.023-0.099,0.015-0.212,0.009-0.312-0.001-0.017-0.012-0.167-0.031-0.082-0.034,0.083-0.085,0.154-0.15,0.212-0.039,0.041-0.023,0.179-0.023,0.229-0.002,0.018,0.026,0.222,0.022,0.226'/%3E %3Cpath d='m541.78,371.39c-0.826-1.052-1.119-2.375-1.454-3.642,0.021,0.077-0.046,0.31-0.012,0.438,0.337,1.275,0.635,2.601,1.466,3.658-0.058-0.072,0.083-0.347,0-0.454'/%3E %3Cpath d='m538.95,371.07c-0.25-0.417-0.489-0.836-0.648-1.298-0.007-0.018-0.028,0.141-0.028,0.159-0.002,0.086-0.013,0.196,0.016,0.28,0.16,0.462,0.399,0.88,0.649,1.298,0.013,0.021,0.028-0.144,0.028-0.159,0.001-0.071,0.022-0.215-0.017-0.28'/%3E %3Cpath d='m549.47,370.88c0.027,0.296,0.085,0.585,0.172,0.87,0.005,0.017,0.027-0.14,0.027-0.159,0.003-0.089,0.012-0.194-0.016-0.28-0.076-0.247-0.127-0.495-0.152-0.752-0.007-0.077-0.023-0.077-0.031,0-0.012,0.106-0.011,0.215,0,0.321'/%3E %3Cpath d='m557.42,379.56c0.052,0.532,0.404,0.909,0.659,1.356,0.013,0.022,0.027-0.144,0.027-0.159,0.002-0.072,0.022-0.213-0.016-0.279-0.225-0.396-0.593-0.768-0.639-1.239-0.007-0.077-0.024-0.077-0.032,0-0.009,0.106-0.008,0.215,0.001,0.321'/%3E %3Cpath d='m557.36,381.12c-0.418-0.354-0.578-0.863-0.725-1.37,0.022,0.075-0.049,0.31-0.012,0.438,0.147,0.516,0.313,1.03,0.736,1.388-0.051-0.046,0.092-0.38,0.001-0.456'/%3E %3Cpath d='m603.5,362.92c0.822-0.532,1.123-1.493,1.466-2.359,0.047-0.122-0.039-0.373-0.013-0.439-0.339,0.86-0.639,1.815-1.453,2.345-0.089,0.057,0.042,0.426,0,0.453'/%3E %3Cpath d='m605.54,362.43c0.987-1.639,0.686-3.628,0.582-5.444-0.017-0.279-0.044,0.155-0.04,0.229,0.093,1.621,0.319,3.327-0.553,4.775-0.064,0.107,0.04,0.392,0.011,0.44'/%3E %3Cpath d='m648.62,367.72v-1.054c0-0.017,0.003-0.229-0.023-0.229-0.025,0-0.022,0.212-0.022,0.229v1.054c0,0.016-0.003,0.228,0.022,0.228s0.023-0.212,0.023-0.228'/%3E %3Cpath d='m653.32,367.92c0.076-0.333,0.092-0.668,0.092-1.008,0-0.015,0.003-0.227-0.023-0.227-0.025,0-0.021,0.212-0.021,0.227,0,0.21-0.022,0.411-0.07,0.615-0.023,0.097-0.014,0.212-0.008,0.311,0,0.018,0.009,0.167,0.03,0.082'/%3E %3Cpath d='m649.42,368.51c0.56-1.27,0.732-2.624,0.823-3.998,0.006-0.075-0.02-0.51-0.038-0.229-0.088,1.306-0.267,2.584-0.798,3.788-0.052,0.119,0.041,0.378,0.013,0.439'/%3E %3Cpath d='m652.11,368.21c0.011-0.922,0.15-1.836,0.162-2.758,0.003-0.258-0.042-0.258-0.046,0-0.011,0.922-0.15,1.836-0.162,2.758-0.002,0.26,0.043,0.259,0.046,0'/%3E %3Cpath d='m650.96,368.1c0.49-1.713,0.954-3.395,0.987-5.188,0.003-0.144-0.036-0.439-0.043-0.121-0.032,1.684-0.497,3.268-0.957,4.87-0.035,0.127,0.035,0.363,0.013,0.439'/%3E %3Cpath d='m647.65,368.05c0.005-0.433,0.075-0.863,0.081-1.297,0-0.017,0.003-0.229-0.022-0.229-0.026,0-0.022,0.212-0.023,0.229-0.005,0.432-0.076,0.863-0.081,1.297,0,0.016-0.003,0.227,0.023,0.227s0.022-0.211,0.022-0.227'/%3E %3Cpath d='m649.99,368.51c0.47-1.482,0.348-3.043,0.573-4.565,0.013-0.09-0.018-0.431-0.023-0.393-0.222,1.504-0.098,3.057-0.562,4.519-0.04,0.127,0.035,0.366,0.012,0.439'/%3E %3Cpath d='m648.94,368.57c0.166-0.745,0.323-1.479,0.335-2.245,0.002-0.145-0.039-0.44-0.044-0.121-0.01,0.672-0.168,1.322-0.313,1.973-0.022,0.099-0.015,0.211-0.008,0.312,0.001,0.014,0.011,0.167,0.03,0.081'/%3E %3Cpath d='m650.73,368.13c0.011-0.848,0.149-1.687,0.161-2.534,0.002-0.146-0.039-0.44-0.044-0.121-0.012,0.888-0.151,1.767-0.163,2.655-0.003,0.26,0.043,0.259,0.046,0'/%3E %3Cpath d='m604.56,362.68c0.724-0.944,1.126-2.063,1.157-3.249,0.004-0.145-0.035-0.44-0.043-0.121-0.029,1.053-0.48,2.088-1.114,2.915-0.083,0.108,0.058,0.381,0,0.455'/%3E %3Cpath d='m602.54,363.08c0.224-0.443,0.475-0.872,0.73-1.298,0.038-0.065,0.018-0.209,0.016-0.28,0-0.016-0.015-0.181-0.028-0.159-0.255,0.428-0.506,0.854-0.729,1.299-0.037,0.071-0.02,0.203-0.018,0.279,0.001,0.016,0.019,0.18,0.029,0.159'/%3E %3Cpath d='m606.84,361.84c0.08-0.604,0.092-1.211,0.092-1.819,0-0.016,0.003-0.228-0.022-0.228s-0.022,0.212-0.022,0.228c0,0.478-0.007,0.952-0.07,1.427-0.014,0.103-0.014,0.208-0.008,0.311,0,0.013,0.02,0.169,0.03,0.081'/%3E %3Cpath d='m608.7,361.29c0.312-1.211,0.496-2.446,0.736-3.673,0.018-0.09-0.016-0.434-0.023-0.393-0.237,1.21-0.417,2.432-0.724,3.626-0.034,0.13,0.03,0.361,0.011,0.44'/%3E %3Cpath d='m610.1,360.5c0.006-0.704,0.076-1.405,0.081-2.109,0.002-0.258-0.043-0.258-0.046,0-0.005,0.704-0.075,1.405-0.081,2.109-0.002,0.258,0.044,0.258,0.046,0'/%3E %3Cpath d='m611.38,359.99c0.403-1.25,0.645-2.527,0.744-3.836,0.006-0.074-0.019-0.509-0.039-0.229-0.095,1.237-0.336,2.444-0.717,3.626-0.04,0.126,0.036,0.366,0.012,0.439'/%3E %3Cpath d='m613.16,359.75c0.465-0.824,0.574-1.729,0.659-2.654,0.005-0.059-0.016-0.499-0.032-0.321-0.082,0.89-0.194,1.747-0.638,2.536-0.063,0.108,0.04,0.388,0.011,0.439'/%3E %3Cpath d='m614.62,360.16c0.546-0.826,0.727-1.766,0.82-2.735,0.007-0.059-0.015-0.499-0.031-0.321-0.092,0.934-0.278,1.826-0.802,2.618-0.067,0.1,0.041,0.394,0.013,0.438'/%3E %3Cpath d='m617.05,359.27c0.87-0.739,1.441-1.684,1.79-2.766,0.041-0.126-0.035-0.366-0.013-0.439-0.345,1.074-0.912,2.016-1.777,2.75-0.091,0.078,0.051,0.411,0,0.455'/%3E %3Cpath d='m620.38,359.34c0.742-1.005,0.587-2.334,0.662-3.511,0.005-0.075-0.021-0.511-0.039-0.23-0.071,1.124,0.07,2.347-0.635,3.302-0.07,0.095,0.041,0.401,0.012,0.439'/%3E %3Cpath d='m622.32,358.62c1.003-0.544,1.304-1.607,1.32-2.681,0.002-0.146-0.039-0.44-0.044-0.121-0.015,0.967-0.402,1.873-1.276,2.347-0.087,0.047,0.034,0.437,0,0.455'/%3E %3Cpath d='m618.78,359.37c0-0.369,0.002-0.737,0.07-1.101,0.018-0.102,0.014-0.21,0.008-0.312-0.001-0.015-0.015-0.169-0.031-0.082-0.091,0.492-0.092,0.995-0.093,1.494,0,0.017-0.003,0.228,0.023,0.228s0.023-0.211,0.023-0.227'/%3E %3Cpath d='m613.83,360.42c0-0.45,0-0.899,0.069-1.345,0.017-0.102,0.015-0.208,0.009-0.312-0.001-0.014-0.018-0.169-0.031-0.082-0.09,0.576-0.092,1.157-0.093,1.738,0,0.016-0.003,0.227,0.022,0.227,0.027,0.001,0.024-0.21,0.024-0.226'/%3E %3Cpath d='m611.45,361.54c0.58-0.542,0.587-1.356,0.665-2.094,0.006-0.059-0.014-0.5-0.032-0.321-0.074,0.698-0.085,1.447-0.633,1.961-0.09,0.083,0.053,0.404,0,0.454'/%3E %3Cpath d='m610.32,361.7c0.332-0.711,0.342-1.477,0.342-2.247,0-0.259-0.046-0.259-0.046,0-0.001,0.633-0.036,1.229-0.308,1.809-0.055,0.115,0.04,0.378,0.012,0.438'/%3E %3Cpath d='m608.8,362.37v-1.136c0-0.015,0.003-0.227-0.022-0.227-0.026,0-0.023,0.212-0.023,0.227v1.136c0,0.017-0.003,0.228,0.023,0.228,0.025-0.001,0.022-0.212,0.022-0.228'/%3E %3Cpath d='m607.32,362.83c0.42-1.224,0.961-2.399,1.223-3.673,0.019-0.089-0.015-0.433-0.023-0.393-0.259,1.257-0.797,2.419-1.21,3.627-0.046,0.125,0.034,0.368,0.01,0.439'/%3E %3Cpath d='m615.68,360.32c0.4-0.84,0.568-1.734,0.659-2.655,0.006-0.059-0.016-0.499-0.032-0.321-0.086,0.882-0.256,1.734-0.638,2.537-0.056,0.116,0.039,0.379,0.011,0.439'/%3E %3Cpath d='m617.38,359.83c0.093-0.185,0.176-0.372,0.243-0.568,0.029-0.083,0.019-0.192,0.016-0.279,0-0.02-0.021-0.176-0.027-0.158-0.067,0.195-0.15,0.382-0.243,0.567-0.036,0.072-0.019,0.202-0.017,0.279,0,0.016,0.019,0.18,0.028,0.159'/%3E %3Cpath d='m619.65,359.42c0.658-1.194,0.359-2.579,0.253-3.868-0.015-0.178-0.037,0.263-0.033,0.322,0.087,1.046,0.3,2.144-0.231,3.106-0.061,0.111,0.04,0.389,0.011,0.44'/%3E %3Cpath d='m621.6,359.18c0.637-1.275,0.736-2.678,0.824-4.079,0.005-0.073-0.021-0.509-0.039-0.229-0.084,1.333-0.192,2.657-0.797,3.869-0.056,0.115,0.04,0.383,0.012,0.439'/%3E %3Cpath d='m601.46,360.18c-0.093,0.75-0.477,1.45-0.32,2.224,0.017,0.086,0.03-0.067,0.031-0.082,0.006-0.101,0.012-0.211-0.009-0.312-0.05-0.245,0.129-0.61,0.193-0.848,0.061-0.218,0.109-0.437,0.136-0.661,0.008-0.058-0.009-0.499-0.031-0.321'/%3E %3Cpath d='m601.48,363.16c0.144-0.593,0.242-1.195,0.405-1.784,0.035-0.128-0.034-0.362-0.013-0.438-0.162,0.589-0.261,1.19-0.405,1.784-0.032,0.129,0.031,0.359,0.013,0.438'/%3E %3Cpath d='m609.53,361.4v-0.892c0-0.016,0.003-0.228-0.022-0.228-0.026,0-0.023,0.212-0.023,0.228v0.892c0,0.017-0.003,0.228,0.023,0.228,0.025,0,0.022-0.211,0.022-0.228'/%3E %3Cpath d='m612.61,360.69c-0.016-0.758-0.233-1.458-0.422-2.187,0.021,0.079-0.045,0.31-0.011,0.438,0.158,0.616,0.375,1.226,0.389,1.869,0.007,0.32,0.047,0.025,0.044-0.12'/%3E %3Cpath d='m616.24,360.07c0.563-0.929,0.811-1.962,0.979-3.024,0.014-0.09-0.018-0.431-0.023-0.393-0.167,1.049-0.414,2.063-0.967,2.979-0.066,0.104,0.04,0.39,0.011,0.438'/%3E %3Cpath d='m629.06,371.75c0.468-0.865,0.875-1.755,1.217-2.677,0.046-0.122-0.037-0.37-0.013-0.438-0.341,0.923-0.75,1.812-1.216,2.677-0.059,0.11,0.041,0.385,0.012,0.438'/%3E %3Cpath d='m631.89,371.52c0.714-0.813,1.142-1.719,1.309-2.788,0.015-0.091-0.017-0.432-0.022-0.394-0.165,1.053-0.583,1.927-1.286,2.728-0.087,0.099,0.056,0.39-0.001,0.454'/%3E %3Cpath d='m634.24,371.11c0.923-1.15,1.291-2.464,1.066-3.912-0.006-0.038-0.037,0.303-0.023,0.394,0.18,1.15-0.348,2.197-1.043,3.063-0.084,0.104,0.057,0.384,0,0.455'/%3E %3Cpath d='m636.44,370.54c0.763-1.401,0.593-3.07,0.416-4.598-0.021-0.178-0.039,0.262-0.032,0.321,0.151,1.309,0.249,2.654-0.396,3.838-0.06,0.11,0.04,0.386,0.012,0.439'/%3E %3Cpath d='m630.91,369.64c0.104,0.318,0.406,0.807,0.006,1.013-0.086,0.045,0.032,0.439,0,0.455,0.301-0.155,0.288-0.529,0.271-0.825-0.022-0.378-0.149-0.724-0.265-1.082,0.023,0.073-0.053,0.313-0.012,0.439'/%3E %3Cpath d='m632.87,371.28c0.453-0.495,0.429-1.219,0.43-1.849,0-0.017,0.002-0.229-0.023-0.229-0.026,0-0.022,0.212-0.022,0.229-0.002,0.502-0.028,1.006-0.384,1.394-0.088,0.096,0.055,0.394-0.001,0.455'/%3E %3Cpath d='m635.47,370.78c0.263-0.629,0.41-1.261,0.421-1.942,0.002-0.146-0.039-0.44-0.044-0.121-0.009,0.57-0.171,1.104-0.389,1.625-0.05,0.119,0.039,0.374,0.012,0.438'/%3E %3Cpath d='m630.21,371.13c0-0.289,0.005-0.575,0.07-0.858,0.021-0.098,0.014-0.212,0.008-0.311-0.001-0.017-0.013-0.167-0.031-0.082-0.094,0.409-0.092,0.834-0.093,1.251,0,0.016-0.003,0.228,0.022,0.228,0.027,0,0.024-0.212,0.024-0.228'/%3E %3Cpath d='m627.93,371.89c0.076-0.38,0.151-0.762,0.319-1.113,0.035-0.074,0.018-0.201,0.015-0.279,0-0.017-0.018-0.181-0.028-0.159-0.173,0.365-0.25,0.765-0.328,1.158-0.021,0.101-0.015,0.211-0.009,0.312,0.001,0.014,0.015,0.167,0.031,0.081'/%3E %3Cpath d='m634.79,366.85c-0.038,0.898-0.577,1.717-0.309,2.633-0.022-0.075,0.05-0.312,0.013-0.439-0.115-0.393,0.137-0.886,0.229-1.268,0.063-0.269,0.1-0.529,0.111-0.805,0.005-0.144-0.031-0.439-0.044-0.121'/%3E %3Cpath d='m631.9,368.9c-0.062-0.392-0.07-0.785-0.07-1.182,0-0.016,0.003-0.227-0.022-0.227-0.026,0-0.023,0.211-0.023,0.227,0,0.527,0.011,1.053,0.093,1.575,0.014,0.087,0.03-0.068,0.031-0.082,0.004-0.101,0.006-0.209-0.009-0.311'/%3E %3Cpath d='m633.69,369.22c0.081-0.568,0.162-1.136,0.243-1.703,0.015-0.102,0.015-0.208,0.009-0.311-0.001-0.015-0.02-0.17-0.032-0.082-0.081,0.566-0.162,1.135-0.243,1.703-0.015,0.102-0.014,0.208-0.008,0.311,0.001,0.014,0.019,0.17,0.031,0.082'/%3E %3Cpath d='m632.48,369.02c0-0.37,0.016-0.729,0.145-1.078,0.031-0.082,0.019-0.195,0.016-0.28,0-0.018-0.021-0.178-0.027-0.159-0.178,0.484-0.178,1.009-0.179,1.518,0,0.016-0.003,0.227,0.022,0.227,0.026-0.001,0.023-0.212,0.023-0.228'/%3E %3Cpath d='m636.3,368.86c0-0.393-0.005-0.785-0.092-1.17-0.021-0.085-0.031,0.065-0.032,0.082-0.005,0.099-0.014,0.213,0.008,0.311,0.06,0.258,0.07,0.514,0.07,0.777,0,0.016-0.003,0.227,0.023,0.227,0.026-0.001,0.023-0.211,0.023-0.227'/%3E %3Cpath d='m633.52,371.1c0.182-0.381,0.252-0.794,0.26-1.213,0.001-0.086,0.014-0.197-0.018-0.28-0.005-0.019-0.026,0.14-0.026,0.159-0.005,0.31-0.096,0.617-0.228,0.895-0.036,0.075-0.018,0.202-0.016,0.28,0.001,0.015,0.018,0.179,0.028,0.159'/%3E %3Cpath d='m631.02,368.96c-0.005-0.354-0.075-0.702-0.081-1.054-0.001-0.02-0.022-0.179-0.028-0.159-0.03,0.082-0.017,0.192-0.016,0.279,0.006,0.354,0.076,0.701,0.081,1.055,0,0.019,0.021,0.177,0.027,0.159,0.031-0.082,0.018-0.194,0.017-0.28'/%3E %3Cpath d='m657.62,378.79c0.251-1.741,1.708-2.977,2.028-4.704,0.016-0.09-0.017-0.434-0.024-0.394-0.319,1.728-1.775,2.959-2.027,4.704-0.013,0.09,0.017,0.432,0.023,0.394'/%3E %3Cpath d='m658.76,378.16c0.008-0.474,0.183-0.904,0.547-1.212,0.091-0.077-0.052-0.411,0-0.455-0.467,0.395-0.581,0.961-0.591,1.546-0.002,0.145,0.039,0.44,0.044,0.121'/%3E %3Cpath d='m656.64,378.57c0.23-0.455,0.489-0.881,0.887-1.209,0.04-0.033,0.022-0.184,0.022-0.228,0-0.016-0.022-0.227-0.022-0.227-0.402,0.333-0.666,0.763-0.897,1.224-0.037,0.072-0.019,0.203-0.017,0.28,0,0.016,0.016,0.18,0.027,0.16'/%3E %3Cpath d='m659.64,377.84c0.313-0.996,0.41-2.024,0.496-3.06,0.006-0.059-0.018-0.499-0.032-0.321-0.083,0.996-0.175,1.984-0.477,2.942-0.04,0.127,0.036,0.367,0.013,0.439'/%3E %3Cpath d='m656.06,377.96c-0.044-0.112-0.066-0.144-0.065-0.095-0.007-0.078-0.023-0.077-0.031,0-0.012,0.105-0.011,0.215,0,0.32,0.008,0.095,0.039,0.156,0.097,0.229-0.008-0.01,0.022-0.203,0.022-0.228-0.001-0.056,0.015-0.178-0.023-0.226'/%3E %3Cpath d='m660.04,378.49c1.035-1.652,1.295-3.582,1.064-5.49-0.021-0.178-0.039,0.263-0.032,0.322,0.204,1.686-0.152,3.305-1.044,4.729-0.065,0.104,0.042,0.392,0.012,0.439'/%3E %3Cpath d='m652.67,368.13c0.087-0.745,0.086-1.49-0.086-2.224-0.019-0.085-0.029,0.065-0.03,0.082-0.007,0.1-0.016,0.214,0.008,0.312,0.118,0.501,0.137,0.994,0.077,1.509-0.008,0.059,0.011,0.499,0.031,0.321'/%3E %3Cpath d='m660.77,377.92c0.793-1.271,0.65-2.927,0.821-4.356,0.007-0.06-0.01-0.5-0.032-0.322-0.168,1.408-0.023,2.993-0.8,4.24-0.065,0.104,0.04,0.392,0.011,0.438'/%3E %3Cpath d='m644.29,378.35c-0.034,0.314-0.036,0.65,0.091,0.948,0.01,0.02,0.028-0.143,0.028-0.159,0.003-0.082,0.019-0.203-0.015-0.28-0.02-0.042-0.077-0.14-0.072-0.188,0.012-0.104,0.011-0.216,0-0.32-0.007-0.078-0.023-0.077-0.032-0.001'/%3E %3Cpath d='m598.48,360.73c0.967-0.608,1.357-1.708,1.629-2.765,0.031-0.13-0.033-0.361-0.014-0.439-0.268,1.051-0.653,2.145-1.615,2.749-0.09,0.057,0.04,0.43,0,0.455'/%3E %3Cpath d='m643.43,379.32c0-0.285,0.016-0.601-0.099-0.869-0.008-0.02-0.027,0.143-0.027,0.159-0.002,0.082-0.019,0.202,0.016,0.28,0.06,0.139,0.064,0.28,0.064,0.43,0,0.017-0.003,0.228,0.022,0.228,0.027-0.001,0.024-0.212,0.024-0.228'/%3E %3Cpath d='m645.06,379.16v-2.028c0-0.258-0.046-0.258-0.046,0v2.028c0,0.258,0.046,0.258,0.046,0'/%3E %3Cpath d='m598.62,357.34c-0.084,0.961-0.119,2.135-1.038,2.691-0.09,0.054,0.038,0.432,0,0.455,0.952-0.578,0.983-1.832,1.069-2.825,0.005-0.057-0.017-0.498-0.031-0.321'/%3E %3Cpath d='m601.81,363.32c0.556-1.457,0.887-2.897,0.907-4.458,0.002-0.145-0.039-0.44-0.044-0.12-0.02,1.46-0.359,2.788-0.876,4.139-0.046,0.122,0.038,0.371,0.013,0.439'/%3E %3Cpath d='m596.86,360.48c0.146-0.229,0.239-0.474,0.324-0.73,0.028-0.085,0.019-0.192,0.017-0.279-0.002-0.02-0.022-0.177-0.028-0.159-0.085,0.256-0.179,0.501-0.324,0.729-0.04,0.063-0.018,0.212-0.016,0.28,0,0.016,0.013,0.181,0.027,0.159'/%3E %3Cpath d='m600.45,362.69v-0.568c0-0.015,0.003-0.227-0.023-0.227-0.025,0-0.022,0.212-0.022,0.227v0.568c0,0.016-0.003,0.227,0.022,0.227,0.026-0.001,0.023-0.212,0.023-0.227'/%3E %3Cpath d='m596.2,360.41c0.066-0.015,0.112-0.036,0.162-0.081,0.04-0.036,0.023-0.182,0.023-0.229,0-0.017-0.024-0.226-0.023-0.227-0.05,0.045-0.096,0.066-0.162,0.081-0.062,0.013-0.004,0.457,0,0.456'/%3E %3Cpath d='m642.94,352.73c0-0.305,0.029-0.57,0.194-0.833,0.039-0.063,0.017-0.21,0.016-0.279-0.001-0.016-0.014-0.182-0.027-0.158-0.239,0.381-0.228,0.836-0.229,1.271,0,0.017-0.003,0.228,0.023,0.228,0.026-0.002,0.023-0.212,0.023-0.229'/%3E %3Cpath d='m656.41,353.05c0.005-0.39,0.1-0.771,0.192-1.147,0.023-0.09,0.02-0.189,0.017-0.28,0-0.021-0.024-0.173-0.027-0.159-0.132,0.527-0.22,1.043-0.229,1.587,0,0.017-0.003,0.228,0.023,0.228,0.028-0.001,0.024-0.212,0.024-0.229'/%3E %3Cpath d='m649.66,353.27c0.534-1.712,0.64-3.486,0.647-5.269,0.001-0.26-0.045-0.26-0.046,0-0.007,1.639-0.124,3.258-0.614,4.829-0.04,0.129,0.035,0.366,0.013,0.44'/%3E %3Cpath d='m647.99,353.26v-1.157c0-0.016,0.003-0.228-0.022-0.228-0.026,0-0.023,0.212-0.023,0.228v1.157c0,0.016-0.003,0.227,0.023,0.227,0.025,0,0.022-0.211,0.022-0.227'/%3E %3Cpath d='m653.34,353.37c0.127-0.464,0.044-0.938-0.104-1.386-0.007-0.018-0.028,0.14-0.028,0.159-0.002,0.087-0.012,0.194,0.016,0.279,0.051,0.153,0.149,0.348,0.106,0.508-0.025,0.088-0.02,0.19-0.017,0.28,0,0.021,0.023,0.175,0.027,0.16'/%3E %3Cpath d='m646.52,352.84c0.013-1.076,0.204-2.137,0.309-3.206,0.007-0.06-0.015-0.499-0.031-0.321-0.115,1.177-0.308,2.341-0.323,3.527-0.004,0.259,0.042,0.258,0.045,0'/%3E %3Cpath d='m651.44,353.16c0.529-0.802,0.545-1.764,0.641-2.688,0.007-0.06-0.013-0.499-0.032-0.321-0.093,0.889-0.112,1.801-0.619,2.571-0.068,0.1,0.039,0.394,0.01,0.438'/%3E %3Cpath d='m644.19,353.04c0.104-0.557,0.107-1.126,0.21-1.683,0.02-0.101,0.015-0.211,0.01-0.312-0.002-0.015-0.017-0.169-0.032-0.082-0.104,0.557-0.107,1.127-0.21,1.684-0.02,0.1-0.015,0.21-0.008,0.311,0,0.014,0.014,0.169,0.03,0.082'/%3E %3Cpath d='m648.82,353.24c0.119-0.512,0.115-1.041,0.116-1.563,0-0.016,0.003-0.228-0.023-0.228s-0.022,0.212-0.022,0.228c0,0.395-0.004,0.784-0.094,1.172-0.022,0.097-0.014,0.211-0.008,0.31,0.001,0.016,0.01,0.166,0.031,0.081'/%3E %3Cpath d='m646.92,353.37c0.438-1.165,1.034-2.262,1.269-3.495,0.016-0.089-0.016-0.432-0.024-0.393-0.229,1.219-0.823,2.299-1.256,3.448-0.047,0.123,0.037,0.371,0.011,0.44'/%3E %3Cpath d='m645.13,352.51c-0.166-0.262-0.294-0.58-0.3-0.894,0-0.019-0.021-0.178-0.027-0.159-0.03,0.083-0.019,0.194-0.017,0.28,0.009,0.428,0.102,0.845,0.332,1.211,0.014,0.022,0.027-0.144,0.028-0.159,0.002-0.068,0.023-0.217-0.016-0.279'/%3E %3Cpath d='m650.81,353.16c0.092-0.204,0.12-0.427,0.21-0.631,0.034-0.076,0.02-0.199,0.018-0.28-0.001-0.017-0.02-0.179-0.028-0.158-0.091,0.203-0.12,0.427-0.21,0.631-0.035,0.076-0.019,0.199-0.017,0.279,0,0.017,0.018,0.179,0.027,0.159'/%3E %3Cpath d='m655.32,351.38c0.235,0.488,0.178,0.961,0.099,1.478-0.015,0.103-0.013,0.208-0.008,0.312,0.001,0.014,0.018,0.169,0.032,0.082,0.115-0.763,0.234-1.59-0.112-2.311,0.029,0.059-0.067,0.323-0.011,0.439'/%3E %3Cpath d='m652.07,353.49c0.35-0.25,0.53-0.656,0.638-1.061,0.023-0.088,0.019-0.188,0.016-0.279,0-0.022-0.024-0.175-0.028-0.159-0.104,0.398-0.279,0.798-0.625,1.044-0.039,0.028-0.022,0.188-0.022,0.228-0.002,0.013,0.018,0.229,0.021,0.227'/%3E %3Cpath d='m654.5,353.77c0.235-1.36,0.659-2.978-0.215-4.203,0.027,0.04-0.081,0.342-0.014,0.439,0.733,1.024,0.404,2.224,0.205,3.372-0.015,0.089,0.018,0.431,0.024,0.392'/%3E %3Cpath d='m649.98,353c0.107-0.904,0.297-1.793,0.517-2.677,0.031-0.129-0.031-0.358-0.013-0.438-0.228,0.922-0.424,1.849-0.536,2.794-0.007,0.058,0.011,0.499,0.032,0.321'/%3E %3Cpath d='m645.57,352.94v-2.104c0-0.258-0.046-0.258-0.046,0v2.104c0,0.258,0.046,0.258,0.046,0'/%3E %3Cpath d='m643.34,352.96c0.152-0.174,0.127-0.431,0.127-0.647,0-0.017,0.004-0.229-0.022-0.229-0.025,0-0.022,0.212-0.022,0.229,0,0.084-0.027,0.13-0.082,0.192-0.039,0.045-0.023,0.174-0.023,0.229-0.001,0.02,0.028,0.22,0.022,0.226'/%3E %3Cpath d='m654.2,352.84c0-0.734-0.006-1.468-0.116-2.195-0.015-0.088-0.031,0.068-0.032,0.082-0.006,0.103-0.007,0.209,0.008,0.311,0.092,0.598,0.094,1.199,0.094,1.803-0.001,0.257,0.046,0.257,0.046-0.001'/%3E %3Cpath d='m656.6,352.95c0.104-0.239,0.121-0.487,0.122-0.745,0-0.016,0.003-0.228-0.023-0.228s-0.022,0.212-0.022,0.228c0,0.106-0.047,0.21-0.088,0.306-0.034,0.077-0.019,0.2-0.017,0.28,0.001,0.017,0.018,0.178,0.028,0.159'/%3E %3Cpath d='m645.88,352.99c-0.088-0.857-0.1-1.715-0.1-2.575,0-0.258-0.045-0.258-0.045,0,0.001,0.968,0.012,1.934,0.112,2.896,0.019,0.177,0.039-0.263,0.033-0.321'/%3E %3Cpath d='m647.25,353.48c0.098-1.472,0.113-2.947,0.21-4.419,0.005-0.074-0.021-0.51-0.039-0.229-0.098,1.471-0.113,2.946-0.21,4.418-0.005,0.075,0.019,0.51,0.039,0.23'/%3E %3Cpath d='m649.24,352.95c0.24-0.781,0.24-1.657,0-2.438,0.021,0.074-0.051,0.313-0.013,0.439,0.163,0.531,0.163,1.029,0,1.56-0.038,0.126,0.034,0.364,0.013,0.439'/%3E %3Cpath d='m651.13,353.37c0.221-0.69,0.324-1.39,0.332-2.113,0.003-0.259-0.042-0.258-0.045,0-0.007,0.573-0.125,1.131-0.299,1.674-0.04,0.125,0.036,0.365,0.012,0.439'/%3E %3Cpath d='m653.22,351.58c0.176,0.555,0.563,1.238,0.516,1.829-0.005,0.06,0.019,0.5,0.032,0.322,0.075-0.934-0.258-1.714-0.536-2.59,0.023,0.074-0.052,0.313-0.012,0.439'/%3E %3Cpath d='m643.68,352.73v-0.421c0-0.015,0.003-0.227-0.022-0.227-0.026,0-0.023,0.212-0.023,0.227v0.421c0,0.017-0.003,0.228,0.023,0.228,0.025-0.001,0.022-0.211,0.022-0.228'/%3E %3Cpath d='m657.22,352.61c-0.1-0.112-0.182-0.26-0.191-0.413-0.001-0.014-0.016-0.169-0.03-0.082-0.018,0.101-0.016,0.209-0.009,0.313,0.015,0.237,0.067,0.453,0.23,0.638-0.006-0.007,0.023-0.207,0.023-0.229,0.001-0.052,0.016-0.183-0.023-0.227'/%3E %3Cpath d='m652.29,353.24c0.225-1.177,0.318-2.364,0.327-3.563,0.002-0.258-0.044-0.258-0.047,0-0.006,1.066-0.103,2.122-0.304,3.171-0.017,0.089,0.016,0.432,0.024,0.392'/%3E %3Cpath d='m647.87,368.42c0.116-0.47,0.217-0.935,0.226-1.421,0.002-0.086,0.014-0.197-0.016-0.28-0.006-0.018-0.028,0.141-0.028,0.159-0.007,0.375-0.104,0.742-0.194,1.104-0.021,0.09-0.019,0.188-0.016,0.279-0.001,0.023,0.023,0.173,0.028,0.159'/%3E %3Cpath d='m651.23,368.11c0.554-0.603,0.549-1.457,0.55-2.227,0-0.259-0.045-0.259-0.047,0,0,0.64-0.05,1.279-0.503,1.771-0.088,0.096,0.057,0.394,0,0.456'/%3E %3Cpath d='m659.42,376.78c0.03,0.386,0.066,0.771,0.105,1.156,0.008,0.077,0.024,0.077,0.033,0,0.01-0.104,0.01-0.215,0-0.32-0.04-0.386-0.075-0.771-0.106-1.157-0.006-0.078-0.024-0.076-0.032,0-0.01,0.106-0.008,0.214,0,0.321'/%3E %3Cpath d='m645.52,378.51v0.526c0,0.016-0.004,0.229,0.022,0.229s0.023-0.213,0.023-0.229v-0.526c0-0.016,0.003-0.227-0.023-0.227s-0.022,0.212-0.022,0.227'/%3E %3Cpath d='m644.68,377.25v2.209c0,0.258,0.046,0.258,0.046,0v-2.209c0-0.259-0.046-0.259-0.046,0'/%3E %3Cpath d='m636.08,370c0.431-0.777,0.633-1.587,0.646-2.473,0.002-0.146-0.039-0.44-0.044-0.121-0.012,0.776-0.243,1.481-0.615,2.155-0.06,0.109,0.042,0.387,0.013,0.439'/%3E %3Cpath d='m636.39,372.53c0.627-0.324,0.954-0.811,1.063-1.504,0.015-0.102,0.014-0.208,0.008-0.311-0.001-0.015-0.018-0.169-0.03-0.082-0.105,0.669-0.441,1.132-1.041,1.441-0.087,0.045,0.031,0.439,0,0.456'/%3E %3Cpath d='m643.88,379.5c-0.01-0.485-0.109-0.95-0.227-1.421-0.004-0.014-0.028,0.138-0.028,0.159-0.003,0.091-0.006,0.19,0.016,0.28,0.091,0.361,0.188,0.728,0.195,1.103,0,0.02,0.021,0.178,0.027,0.159,0.031-0.083,0.019-0.194,0.017-0.28'/%3E %3Cpath d='m636.07,370.42c0.128,0.41,0.089,0.831,0.089,1.253,0,0.018-0.003,0.229,0.022,0.229,0.026,0,0.022-0.211,0.022-0.229,0.001-0.567,0.049-1.141-0.122-1.691,0.024,0.072-0.05,0.311-0.011,0.438'/%3E %3Cpath d='m634.93,371.76c0.108-0.535,0.213-1.061,0.22-1.608,0.002-0.086,0.016-0.197-0.016-0.28-0.006-0.018-0.027,0.14-0.027,0.159-0.006,0.454-0.109,0.894-0.199,1.337-0.021,0.099-0.015,0.211-0.009,0.311,0.001,0.015,0.015,0.167,0.031,0.081'/%3E %3Cpath d='m629.95,365.46c0.006,1.139,0.151,2.316-0.403,3.356-0.061,0.111,0.041,0.385,0.012,0.439,0.626-1.173,0.443-2.518,0.438-3.796-0.002-0.257-0.048-0.257-0.047,0.001'/%3E %3Cpath d='m630.95,371.67c0-0.25,0.015-0.487,0.088-0.729,0.027-0.086,0.018-0.19,0.017-0.278-0.001-0.021-0.022-0.177-0.027-0.159-0.116,0.379-0.122,0.772-0.123,1.166,0,0.016-0.003,0.227,0.022,0.227,0.026,0,0.023-0.211,0.023-0.227'/%3E %3Cpath d='m637.75,368.15c0.076,0.962-0.589,2.023-1.247,2.663-0.09,0.087,0.055,0.402,0,0.455,0.939-0.913,1.383-2.146,1.278-3.439-0.014-0.178-0.037,0.262-0.031,0.321'/%3E %3Cpath d='m631.75,366.84c-0.102,0.775-0.334,1.513-0.327,2.302,0.003,0.258,0.048,0.258,0.046,0-0.006-0.646,0.221-1.273,0.304-1.908,0.014-0.104,0.014-0.208,0.008-0.312-0.001-0.013-0.02-0.17-0.031-0.082'/%3E %3Cpath d='m633.66,371.69c0.637-0.672,0.939-1.547,1.064-2.451,0.014-0.102,0.014-0.208,0.008-0.311-0.001-0.014-0.019-0.17-0.031-0.082-0.122,0.883-0.42,1.733-1.041,2.389-0.088,0.094,0.056,0.396,0,0.455'/%3E %3Cpath d='m613.23,359.74c0.006,0.283-0.197,0.586-0.398,0.765-0.04,0.035-0.022,0.182-0.022,0.228,0,0.016,0.023,0.226,0.022,0.228,0.394-0.348,0.452-0.844,0.442-1.341,0-0.019-0.022-0.177-0.028-0.158-0.031,0.082-0.018,0.192-0.016,0.278'/%3E %3Cpath d='m609.38,361.46v-1.263c0-0.016,0.003-0.228-0.023-0.228-0.025,0-0.022,0.212-0.022,0.228v1.263c0,0.016-0.003,0.227,0.022,0.227,0.026,0,0.023-0.211,0.023-0.227'/%3E %3Cpath d='m607.15,361.68c0.27-0.426,0.35-1.003,0.21-1.49-0.005-0.016-0.028,0.138-0.028,0.159-0.002,0.089-0.009,0.192,0.016,0.279,0.055,0.187-0.109,0.455-0.21,0.613-0.04,0.063-0.018,0.211-0.016,0.279,0,0.018,0.013,0.183,0.028,0.16'/%3E %3Cpath d='m603.26,362.4c0.104-0.445,0.116-0.9,0.116-1.354,0-0.016,0.004-0.228-0.022-0.228-0.027,0-0.022,0.212-0.022,0.228,0,0.325-0.021,0.643-0.095,0.961-0.022,0.097-0.014,0.212-0.008,0.311,0.001,0.017,0.011,0.167,0.031,0.082'/%3E %3Cpath d='m599.04,362.96c0.296-0.303,0.433-0.585,0.442-1.009,0.002-0.085,0.015-0.197-0.016-0.28-0.007-0.018-0.028,0.142-0.028,0.159-0.007,0.269-0.225,0.497-0.398,0.675-0.04,0.041-0.023,0.179-0.023,0.229,0,0.018,0.027,0.222,0.023,0.226'/%3E %3Cpath d='m599.88,359.9c-0.031,0.171-0.153,0.203-0.305,0.181-0.011-0.003-0.055,0.445,0,0.454,0.197,0.03,0.293-0.054,0.327-0.241,0.02-0.101,0.015-0.21,0.008-0.312,0-0.015-0.014-0.169-0.03-0.082'/%3E %3Cpath d='m602.31,362.84c0.317-0.431,0.599-0.889,0.842-1.367,0.036-0.072,0.018-0.203,0.015-0.28,0-0.017-0.017-0.18-0.027-0.158-0.242,0.479-0.523,0.937-0.842,1.367-0.071,0.095,0.039,0.4,0.012,0.438'/%3E %3Cpath d='m616.28,358.4c-0.025,0.574-0.134,1.118-0.506,1.571-0.085,0.102,0.058,0.385,0,0.455,0.424-0.516,0.517-1.15,0.545-1.798,0.004-0.073-0.026-0.508-0.039-0.228'/%3E %3Cpath d='m619.01,357.69c0.019,0.391,0.072,0.808-0.19,1.131-0.038,0.048-0.023,0.172-0.023,0.228,0,0.022,0.031,0.219,0.023,0.227,0.386-0.474,0.257-1.251,0.229-1.814-0.011-0.282-0.042,0.155-0.039,0.228'/%3E %3Cpath d='m620.93,359.05c0.12-0.242,0.208-0.466,0.224-0.735,0.007-0.103,0.01-0.211-0.008-0.312-0.015-0.088-0.03,0.067-0.031,0.082-0.012,0.184-0.116,0.364-0.196,0.526-0.036,0.072-0.019,0.203-0.017,0.279,0,0.018,0.018,0.182,0.028,0.16'/%3E %3Cpath d='m623.85,358.14c-0.006-0.058-0.033-0.079-0.083-0.062-0.04,0.001-0.029,0.456,0,0.455,0.148-0.005,0.123-0.157,0.127-0.272,0.003-0.085,0.014-0.198-0.016-0.28-0.006-0.019-0.028,0.141-0.028,0.159'/%3E %3Cpath d='m599.27,348.83c0.117-0.512,0.116-1.042,0.116-1.564,0-0.016,0.004-0.228-0.022-0.228s-0.022,0.212-0.022,0.228c0,0.395-0.005,0.786-0.094,1.172-0.023,0.098-0.015,0.211-0.009,0.311,0.001,0.015,0.012,0.166,0.031,0.081'/%3E %3Cpath d='m605.91,348c0.008-0.737,0.098-1.471,0.104-2.209,0.003-0.259-0.043-0.258-0.045,0-0.008,0.737-0.098,1.472-0.105,2.209-0.002,0.258,0.043,0.257,0.046,0'/%3E %3Cpath d='m602.61,345.25c0.088,0.492,0.357,1.283-0.199,1.575-0.086,0.045,0.033,0.438,0,0.455,0.723-0.38,0.331-1.817,0.222-2.423-0.015-0.088-0.029,0.066-0.03,0.081-0.007,0.102-0.011,0.21,0.007,0.312'/%3E %3Cpath d='m604.21,346.62c-0.073-0.241-0.088-0.479-0.088-0.729,0-0.015,0.002-0.227-0.023-0.227-0.026,0-0.022,0.212-0.022,0.227,0,0.395,0.007,0.787,0.122,1.167,0.005,0.016,0.026-0.139,0.027-0.159,0.001-0.089,0.009-0.194-0.016-0.279'/%3E %3Cpath d='m601.45,344.94c-0.031,0.699,0.021,1.464-0.303,2.105-0.057,0.112,0.041,0.382,0.013,0.438,0.352-0.697,0.295-1.555,0.328-2.313,0.005-0.075-0.026-0.51-0.038-0.23'/%3E %3Cpath d='m604.83,347.07c0.225-0.249,0.232-0.539,0.232-0.859,0-0.015,0.005-0.227-0.022-0.227-0.026,0-0.022,0.212-0.022,0.227-0.001,0.164-0.084,0.289-0.188,0.404-0.039,0.044-0.023,0.175-0.023,0.229-0.001,0.019,0.027,0.22,0.023,0.226'/%3E %3Cpath d='m599.91,348.58c0.008-0.27,0.11-0.535,0.195-0.788,0.026-0.084,0.018-0.193,0.015-0.28,0-0.019-0.021-0.176-0.028-0.159-0.12,0.366-0.215,0.72-0.226,1.106-0.003,0.085-0.014,0.198,0.016,0.28,0.007,0.018,0.028-0.14,0.028-0.159'/%3E %3Cpath d='m601.68,347.27c0.121-0.242,0.208-0.466,0.225-0.735,0.006-0.103,0.009-0.21-0.009-0.312-0.015-0.087-0.029,0.067-0.03,0.081-0.012,0.186-0.117,0.365-0.196,0.527-0.037,0.073-0.02,0.203-0.018,0.279,0,0.017,0.018,0.181,0.028,0.16'/%3E %3Cpath d='m600.22,347.74c0.008-0.282,0.095-0.558,0.105-0.842,0.004-0.085,0.014-0.198-0.017-0.279-0.006-0.019-0.026,0.14-0.027,0.158-0.013,0.282-0.098,0.557-0.105,0.842-0.002,0.085-0.014,0.198,0.017,0.28,0.007,0.017,0.027-0.141,0.027-0.159'/%3E %3Cpath d='m603.36,346.82c-0.048-0.057-0.075-0.121-0.083-0.193,0-0.016,0.004-0.228-0.022-0.228-0.025,0-0.022,0.212-0.022,0.228,0.001,0.215-0.012,0.47,0.128,0.648-0.008-0.011,0.023-0.203,0.023-0.229-0.001-0.055,0.015-0.177-0.024-0.226'/%3E %3Cpath d='m604.94,347.91c0.222-0.239,0.324-0.545,0.427-0.85,0.028-0.084,0.018-0.193,0.016-0.28-0.001-0.02-0.021-0.176-0.027-0.159-0.101,0.298-0.198,0.6-0.415,0.834-0.039,0.043-0.023,0.176-0.023,0.228-0.001,0.02,0.027,0.222,0.022,0.227'/%3E %3Cpath d='m536.58,348.21v-3.998c0-0.258-0.046-0.258-0.046,0v3.998c0,0.258,0.046,0.258,0.046,0'/%3E %3Cpath d='m532.14,348.73c-1.252-1.815-2.043-3.928-1.473-6.188,0.032-0.13-0.032-0.36-0.013-0.439-0.629,2.492,0.028,4.97,1.474,7.067-0.029-0.042,0.08-0.34,0.012-0.44'/%3E %3Cpath d='m535.3,348.41c-0.222-0.392-0.37-0.8-0.21-1.244,0.044-0.124-0.038-0.37-0.012-0.438-0.246,0.685-0.146,1.496,0.21,2.122-0.029-0.054,0.073-0.332,0.012-0.44'/%3E %3Cpath d='m537.08,348.85c0.107-0.455,0.121-0.91,0.121-1.377,0-0.015,0.004-0.227-0.022-0.227s-0.022,0.212-0.022,0.227c0,0.319-0.015,0.627-0.089,0.938-0.021,0.09-0.018,0.188-0.016,0.28,0,0.023,0.025,0.174,0.028,0.159'/%3E %3Cpath d='m533.72,348.52c-0.512-0.853-0.813-1.796-0.937-2.782-0.022-0.178-0.04,0.263-0.032,0.321,0.127,1.025,0.423,2.01,0.957,2.899-0.029-0.048,0.076-0.333,0.012-0.438'/%3E %3Cpath d='m536.04,348.54c-0.101-0.5-0.199-1-0.321-1.495,0.019,0.078-0.044,0.309-0.012,0.438,0.118,0.48,0.213,0.965,0.31,1.449,0.019,0.087,0.03-0.066,0.031-0.081,0.005-0.101,0.011-0.212-0.008-0.311'/%3E %3Cpath d='m534.14,348.3c-0.391-1.039-0.629-2.403,0.099-3.341,0.083-0.105-0.057-0.381,0-0.455-0.854,1.103-0.563,3.029-0.11,4.235-0.027-0.068,0.057-0.317,0.011-0.439'/%3E %3Cpath d='m531.93,347.46c-0.483-1.135-0.227-2.312,0.941-2.814,0.081-0.034-0.023-0.444,0-0.454-1.447,0.623-1.497,2.431-0.953,3.708-0.026-0.065,0.064-0.32,0.012-0.44'/%3E %3Cpath d='m537.72,348.1c-0.042-0.095-0.088-0.2-0.089-0.307,0-0.016,0.004-0.228-0.022-0.228-0.027,0-0.022,0.212-0.022,0.228,0.001,0.258,0.017,0.507,0.122,0.745,0.009,0.021,0.027-0.142,0.027-0.158,0.002-0.081,0.018-0.203-0.016-0.28'/%3E %3Cpath d='m534.66,345.56c-0.354,0.426-0.395,1.069-0.531,1.586-0.034,0.129,0.032,0.362,0.012,0.439,0.135-0.512,0.17-1.149,0.52-1.57,0.084-0.101-0.058-0.387-0.001-0.455'/%3E %3Cpath d='m532.77,348.41c-0.176-0.271-0.295-0.564-0.3-0.893,0-0.02-0.021-0.178-0.027-0.159-0.03,0.083-0.018,0.194-0.017,0.279,0.007,0.441,0.09,0.837,0.332,1.212,0.014,0.021,0.028-0.145,0.028-0.159,0.003-0.069,0.024-0.218-0.016-0.28'/%3E %3Cpath d='m534.88,348.3c-0.093-0.192-0.188-0.415-0.197-0.632-0.001-0.014-0.016-0.168-0.03-0.081-0.018,0.102-0.013,0.208-0.009,0.312,0.013,0.295,0.098,0.574,0.225,0.841,0.01,0.02,0.027-0.144,0.027-0.159,0.002-0.08,0.02-0.207-0.016-0.281'/%3E %3Cpath d='m537.48,348.1v0.842c0,0.016-0.003,0.228,0.022,0.228,0.026,0,0.023-0.212,0.023-0.228v-0.842c0-0.016,0.003-0.227-0.023-0.227-0.025,0-0.022,0.211-0.022,0.227'/%3E %3Cpath d='m531,348.74c-0.007-1.088-0.098-2.174-0.104-3.262-0.002-0.258-0.048-0.258-0.046,0,0.008,1.089,0.099,2.174,0.104,3.262,0.002,0.259,0.046,0.26,0.046,0'/%3E %3C/g%3E %3Cpath fill='%23999b9e' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' d='m692.79,473.45c-0.42874,0.15576-0.80475,0.41459-1.1819,0.66991-0.0447,0.0305-0.0252,0.22134-0.0252,0.26701,0,0.0152,0.0219,0.26821,0.0252,0.26587,0.37716-0.25532,0.75317-0.51297,1.1819-0.66875,0.0872-0.034-0.0172-0.52936,0-0.53404'/%3E %3Cpath fill='%23999b9e' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)' d='m686.56,470.11c-1.0764,0.63126-2.021,1.478-2.7788,2.484-0.094,0.12414,0.0653,0.44621,0,0.53288,0.75774-1.006,1.7012-1.854,2.7788-2.484,0.1009-0.0597-0.0424-0.50945,0-0.53287'/%3E %3Cg id='sun_and_signs' fill='none' stroke='%23000' stroke-width='0.917'%3E %3Cpath fill='%23949699' stroke-width='0.23' d='m660.05,288.89c0.776,1.404,4.048,12.048,4.048,12.048-10.84-11.929-36.219-20.299-65.798-20.299-29.173,0-54.438,8.159-65.532,19.829-0.179,0.188,1.69-5.334,3.905-10.62,2.16-5.158,4.666-10.078,4.831-10.179,13.047-7.956,33.633-13.089,56.796-13.089,23.329,0,44.045,5.206,57.077,13.258,0.001,0,4.027,6.371,4.673,9.052z'/%3E %3Cg fill='%23fd0' stroke-width='0.458'%3E %3Cpath d='m597.16,284.19s1.027,5.905,1.969,7.873c0,0,2.226-6.29,2.226-7.787'/%3E %3Cpath d='m593.36,282.54s-1.476,5.808-1.423,7.99c0,0,4.603-4.83,5.215-6.197'/%3E %3Cpath d='m590.43,279.25s-3.847,4.597-4.741,6.585c0,0,6.241-2.36,7.384-3.327'/%3E %3Cpath d='m589.27,275.66s-5.286,2.828-6.858,4.338c0,0,6.67,0.143,8.091-0.328'/%3E %3Cpath d='m589.52,271.93s-5.955,0.677-7.975,1.499c0,0,6.146,2.596,7.641,2.683'/%3E %3Cpath d='m591.04,268.71s-5.811-1.472-7.991-1.418c0,0,4.832,4.601,6.199,5.21'/%3E %3Cpath d='m593.73,266.13s-4.855-3.513-6.902-4.268c0,0,2.792,6.06,3.837,7.131'/%3E %3Cpath d='m597.64,264.65s-2.98-5.199-4.537-6.73c0,0,0.052,6.673,0.564,8.079'/%3E %3Cpath d='m601.08,264.74s-1.024-5.905-1.963-7.876c0,0-2.232,6.287-2.23,7.785'/%3E %3Cpath d='m604.97,266.45s1.538-5.791,1.509-7.975c0,0-4.656,4.778-5.281,6.139'/%3E %3Cpath d='m607.56,269.24s3.603-4.789,4.398-6.822c0,0-6.113,2.675-7.203,3.701'/%3E %3Cpath d='m608.9,272.79s5.138-3.086,6.639-4.673c0,0-6.671,0.186-8.065,0.727'/%3E %3Cpath d='m608.9,276.11s5.869-1.217,7.811-2.219c0,0-6.359-2.028-7.854-1.977'/%3E %3Cpath d='m607.74,279.37s5.931,0.872,8.098,0.596c0,0-5.276-4.087-6.697-4.553'/%3E %3Cpath d='m605.43,282.12s5.23,2.927,7.354,3.442c0,0-3.475-5.699-4.638-6.64'/%3E %3Cpath d='m601.44,284.11s3.425,4.921,5.107,6.313c0,0-0.631-6.644-1.265-8.001'/%3E %3Cellipse cx='599.04' cy='274.46' rx='10.521' ry='10.096'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23000' stroke='none' d='m595.62,271.52c0,0.489-0.421,0.885-0.941,0.885s-0.942-0.396-0.942-0.885c0-0.488,0.423-0.883,0.942-0.883,0.52,0.001,0.941,0.396,0.941,0.883'/%3E %3Cpath stroke-width='0.684' d='m592.77,271.5c1.021-1.516,2.713-1.452,3.88,0'/%3E %3Cpath fill='%23000' stroke='none' d='m604.29,271.64c0,0.489-0.421,0.884-0.941,0.884s-0.941-0.395-0.941-0.884c0-0.488,0.421-0.884,0.941-0.884s0.941,0.396,0.941,0.884'/%3E %3Cpath stroke-width='0.684' d='m601.44,271.61c1.021-1.516,2.714-1.452,3.88,0'/%3E %3Cpath stroke-width='0.684' d='m597.38,275.32c0.611,0.049,1.043,0.331,1.672,0.362,0.649,0.032,1.03-0.264,1.58-0.419'/%3E %3Cellipse fill='none' stroke-width='0.684' cx='599' cy='278.37' rx='2.339' ry='0.325'/%3E %3Cpath stroke-width='0.814' d='m598.04,280.83c0.6-0.003,1.188,0.12,1.736-0.064'/%3E %3C/g%3E %3Cpath d='m557.53,278.96-0.949-2.001s-2.948,0.21-4.318,2.739c0,0-1.894-2.213-5.16-0.949l-0.106,2.95s2.215-3.054,4.529-0.948c0,0-1.053,4.423,1.581,4.213,2.632-0.211,0.841-3.897,0.316-4.108l-0.527-0.211c-0.001,0,1.474-2.527,4.634-1.685zm-4.333,3.569c0.155,0.621,0.077,1.176-0.177,1.24-0.253,0.064-0.585-0.387-0.743-1.008-0.157-0.62-0.078-1.175,0.177-1.239s0.585,0.388,0.743,1.007z'/%3E %3Cpath d='m575,271.52c-0.214-0.128-0.727-0.47-1.476-0.342,0,0,0.685,0.642,0.578,0.899,0,0-0.107,0.556-0.707,0.492,0,0-2.332-0.257-4.236,1.005,0,0-1.326,0.193-1.433-0.085,0,0-0.224-0.446-0.028-0.628,0.014-0.014,0.031-0.026,0.049-0.035,0.279-0.151-1.412,0.235-1.026,1.048,0.385,0.813,1.283,1.112,2.054,1.048,0.048-0.004,0.075-0.007,0.112-0.009,0-0.002-0.006-0.012-0.006-0.012s0.568-0.036,0.006,0.012c0.058,0.127,2.175,4.773,3.547,4.31,1.39-0.471,1.562-4.857,1.412-5.328-0.032-0.1-0.05-0.151-0.063-0.193l-0.002,0.001s-0.048-0.159,0.002-0.001c0.024-0.009,3.013-1.104,1.217-2.182zm-2.867,6.055c-1.006,0.193-2.219-2.943-2.098-3.038,1.316-1.028,2.29-0.886,2.565-0.815-0.162-0.206,0.088,0.023,0.088,0.023s-0.036-0.011-0.088-0.023c0.003,0.001,0.001,0,0.003,0.002,0.172,0.214,0.535,3.659-0.47,3.851z'/%3E %3Cpath stroke-width='1.6052' d='m626.1,274.92c0.009-0.375-0.016-0.752-0.11-1.104-0.079-0.287-0.258-0.56-0.441-0.792-0.218-0.277-0.586-0.664-0.891-0.85-0.56-0.343-1.119-0.087-1.085,0.573,0.032,0.665,0.6,1.2,1.131,1.52,0.437,0.263,0.909,0.471,1.396,0.653,1.6659,0.59675,3.3115,0.94104,4.262,1.553,0.398,0.244,0.758,0.512,1.207,0.687,0.686,0.268,1.454,0.282,2.094-0.09,0.46-0.268,1.148-0.974,0.623-1.493-0.601-0.594-1.639-0.389-2.352-0.118-0.563,0.215-1.17,0.548-1.649,0.904,0.27392,0.57761-0.096,1.1805-0.222,1.828-0.16,0.508-0.324,1.013-0.314,1.552,0.013,0.721,1.076,2.254,1.527,0.978,0.261-0.741,0.133-1.851-0.629-2.254-0.188-0.1-0.384-0.191-0.584-0.276-1.4613-0.59415-2.9766-0.85949-4.267-1.439-0.494-0.18-1.022-0.346-1.546-0.305-0.445,0.035-0.891,0.205-1.108,0.621-0.166,0.323-0.353,0.73-0.144,1.069,0.429,0.698,1.602,0.063,2.06-0.276,0.354-0.263,0.584-0.671,0.738-1.109,0.19585-0.4904,0.29381-1.2849,0.304-1.832z'/%3E %3Cpath d='m645.98,282.55s-1.348-0.707-2.247,0.727c0,0-3.357-0.364-1.219-5.498,0.06-0.144-2.161,0.919-1.69,4.193,0,0,0.429,2.76,3.595,4.022,0,0,2.652,0.578,2.546-1.99-0.001,0-0.129-1.239-0.985-1.454zm-0.77,2.246c-0.32,0-0.578-0.268-0.578-0.599s0.258-0.599,0.578-0.599c0.319,0,0.577,0.268,0.577,0.599,0.001,0.331-0.257,0.599-0.577,0.599z'/%3E %3Cpath d='m644.19,281.61s1.46,0.429,2.061-1.151c0,0,3.366-0.298,2.267,5.156-0.03,0.153,1.941-1.324,0.842-4.443,0,0-0.958-2.624-4.309-3.244,0,0-2.715-0.051-2.109,2.447-0.001,0,0.365,1.193,1.248,1.235zm0.315-2.353c0.314-0.063,0.62,0.15,0.685,0.475,0.064,0.325-0.137,0.638-0.449,0.7-0.314,0.063-0.619-0.151-0.685-0.476-0.062-0.324,0.136-0.636,0.449-0.699z'/%3E %3Cpath fill='%23fd0' stroke='none' d='m557.53,278.96-0.949-2.001s-2.948,0.21-4.318,2.739c0,0-1.894-2.213-5.16-0.949l-0.106,2.95s2.215-3.054,4.529-0.948c0,0-1.053,4.423,1.581,4.213,2.632-0.211,0.841-3.897,0.316-4.108l-0.527-0.211c-0.001,0,1.474-2.527,4.634-1.685m-4.333,3.569c0.155,0.621,0.078,1.176-0.177,1.24-0.253,0.064-0.585-0.387-0.743-1.008-0.157-0.62-0.078-1.175,0.177-1.239s0.585,0.388,0.743,1.007'/%3E %3Cpath fill='%23fd0' stroke='none' d='m575,271.52c-0.214-0.128-0.727-0.47-1.476-0.342,0,0,0.685,0.642,0.578,0.899,0,0-0.107,0.556-0.707,0.492,0,0-2.332-0.257-4.236,1.005,0,0-1.326,0.193-1.433-0.085,0,0-0.225-0.446-0.028-0.628,0.014-0.014,0.031-0.026,0.049-0.035,0.279-0.151-1.412,0.235-1.026,1.048,0.385,0.813,1.283,1.113,2.054,1.048,0.048-0.004,0.075-0.007,0.112-0.009,0-0.002-0.006-0.012-0.006-0.012s0.568-0.036,0.006,0.012c0.058,0.127,2.175,4.773,3.547,4.31,1.39-0.471,1.562-4.857,1.412-5.328-0.032-0.1-0.05-0.151-0.063-0.193l-0.002,0.001s-0.048-0.159,0.002-0.001c0.024-0.009,3.013-1.104,1.217-2.182m-2.867,6.055c-1.006,0.193-2.219-2.943-2.098-3.038,1.316-1.028,2.29-0.886,2.565-0.815-0.162-0.206,0.088,0.023,0.088,0.023s-0.036-0.011-0.088-0.023c0.003,0.001,0.001,0,0.003,0.002,0.172,0.214,0.535,3.659-0.47,3.851'/%3E %3Cpath fill='none' stroke='%23fd0' d='m626.1,274.92c0.009-0.375-0.016-0.752-0.11-1.104-0.079-0.287-0.258-0.56-0.441-0.792-0.218-0.277-0.586-0.664-0.891-0.85-0.56-0.343-1.119-0.087-1.085,0.573,0.032,0.665,0.6,1.2,1.131,1.52,0.437,0.263,0.909,0.471,1.396,0.653,1.6659,0.59675,3.3115,0.94104,4.262,1.553,0.398,0.244,0.758,0.512,1.207,0.687,0.686,0.268,1.454,0.282,2.094-0.09,0.46-0.268,1.148-0.974,0.623-1.493-0.601-0.594-1.639-0.389-2.352-0.118-0.563,0.215-1.17,0.548-1.649,0.904,0.27392,0.57761-0.096,1.1805-0.222,1.828-0.16,0.508-0.324,1.013-0.314,1.552,0.013,0.721,1.076,2.254,1.527,0.978,0.261-0.741,0.133-1.851-0.629-2.254-0.188-0.1-0.384-0.191-0.584-0.276-1.4613-0.59415-2.9766-0.85949-4.267-1.439-0.494-0.18-1.022-0.346-1.546-0.305-0.445,0.035-0.891,0.205-1.108,0.621-0.166,0.323-0.353,0.73-0.144,1.069,0.429,0.698,1.602,0.063,2.06-0.276,0.354-0.263,0.584-0.671,0.738-1.109,0.19585-0.4904,0.29381-1.2849,0.304-1.832z'/%3E %3Cpath fill='%23fd0' stroke='none' d='m645.98,282.55s-1.348-0.707-2.247,0.727c0,0-3.357-0.364-1.219-5.498,0.06-0.144-2.161,0.919-1.69,4.193,0,0,0.429,2.76,3.595,4.022,0,0,2.652,0.578,2.546-1.99-0.001,0-0.129-1.239-0.985-1.454m-0.77,2.246c-0.32,0-0.578-0.268-0.578-0.599s0.258-0.599,0.578-0.599c0.319,0,0.577,0.268,0.577,0.599,0.001,0.331-0.257,0.599-0.577,0.599'/%3E %3Cpath fill='%23fd0' stroke='none' d='m644.19,281.61s1.46,0.429,2.061-1.151c0,0,3.365-0.298,2.267,5.156-0.03,0.153,1.941-1.324,0.842-4.443,0,0-0.958-2.624-4.309-3.244,0,0-2.715-0.051-2.109,2.447-0.001,0,0.365,1.193,1.248,1.235m0.315-2.353c0.313-0.063,0.62,0.15,0.684,0.475,0.065,0.325-0.136,0.638-0.448,0.7-0.314,0.063-0.619-0.151-0.685-0.476-0.062-0.324,0.136-0.636,0.449-0.699'/%3E %3C/g%3E %3Cg id='boat' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'%3E %3Cpath fill='%23fd0' d='m716.54,549.26,0.0872-3.6435s16.092,0.70739,23.833,0.62191v2.8436s-21.137,0.35486-23.92,0.17802'/%3E %3Cg%3E %3Crect fill='%235c5342' width='6.4529' height='1.6619' x='744.34' y='543.92'/%3E %3Cg fill='%23000'%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' d='M628.76,394.94V397.84H628.46V394.94L625.3,378.79 625.48,378.74 628.65,394.78 631.34,389.42 631.5,389.44'/%3E %3Crect width='0.34506' height='2.3037' x='740.68' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='741.29' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='742.76' y='545.91'/%3E %3Crect width='0.3462' height='2.3037' x='743.59' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='744.84' y='545.91'/%3E %3Crect width='0.3462' height='2.3037' x='746.12' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='746.95' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='747.99' y='545.91'/%3E %3Crect width='0.3462' height='2.3037' x='749.03' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='750.02' y='545.91'/%3E %3Crect width='0.34735' height='2.3037' x='751.42' y='545.91'/%3E %3Crect width='0.34506' height='2.3037' x='755.06' y='545.68'/%3E %3Crect width='0.34506' height='5.3358' x='756.01' y='542.28'/%3E %3Crect width='0.34506' height='4.9716' x='751.98' y='543.24'/%3E %3Crect width='0.48262' height='0.62189' x='741.99' y='547.59'/%3E %3Cpath d='m752.88,547.84s0.01-0.007,0.029-0.0199c0.2476-0.1745,2.0898-1.4476,2.5942-1.4394,0.5411,0.012,1.1384-0.0352,1.1384-0.0352v0.38766l-1.1728,0.0364-2.0245,1.0564'/%3E %3Cpath d='m754.73,548s0.011-0.007,0.028-0.0199c0.2454-0.17918,2.0681-1.4827,2.5702-1.4804,0.5411,0.003,1.1395-0.0539,1.1395-0.0539l0.01,0.38765-1.1705,0.0551-2.0084,1.0904'/%3E %3Crect width='1.6026' height='0.29162' x='750.75' y='543.04'/%3E %3Cpath d='m752.37,541.74c-0.2086,0.0281-0.36,0.61955-0.3416,1.3211,0.019,0.70386,0.204,1.2485,0.4115,1.2204,0.2075-0.0258,0.3588-0.6172,0.3405-1.3211-0.021-0.70153-0.204-1.2473-0.4104-1.2204m0.058,2.1714c-0.1467,0.0187-0.2763-0.36774-0.2912-0.86315-0.014-0.49658,0.094-0.91585,0.2408-0.9346,0.1479-0.0199,0.2785,0.36659,0.2911,0.86316,0.015,0.49657-0.094,0.9135-0.2407,0.93459'/%3E %3Cpath d='M621.84,380.89 613.98,381.22V381.02L622.17,380.73' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m737.14,522.23c0.0367,0.26703,4.0398,23.159,4.0398,23.159l-3.7417-12.842,0.0367-0.64882,2.8063,9.7839-3.18-17.961,0.039-1.4909z'/%3E %3Cpath d='M615.94,395.68 614.37,383.18 614.24,383.67 615.61,395.51 615.87,395.61' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m738.15,545.43s-0.0367-5.3124-0.67407-6.7635l-0.0735,0.42045s0.56172,5.809,0.59725,6.2669c0.039,0.45793,0.15019,0.0761,0.15019,0.0761'/%3E %3Cpath d='M614.34,385.72 613.03,395.48 613.26,395.61 614.44,386.02' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='M614.01,380.93 612.32,394.6 612.48,394.83 613.98,381.22' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' d='m614.27,384.45-10.866,7.08-0.13-0.196,10.93-7.08,0,0.13'/%3E %3C/g%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' fill='%23858d8d' d='M620.67,393.36H626.3L626,394.29H620.37z'/%3E %3Cpath fill='%23755338' d='M629.87,395.42 629.89,395.32 631.54,388.46 631.76,388.5 630.1,395.25' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23fd0' d='m761.19,540.61c-0.8231,0.3045-1.8709-1.4522-2.357-2.2931-0.486-0.84208-1.7207-0.53524-1.7207-0.53524l-0.3175,1.0576c0.2453-0.0468,1.2392-0.18739,1.6645,0.5481,0.4861,0.8409,1.5339,2.5988,2.3558,2.292l-0.454,1.334c0,0.00092,0.01,0.004,0.01,0.004l0.822-2.4067z'/%3E %3Cpath fill='%23034ea2' d='m758.46,539.39c-0.4253-0.73432-1.418-0.59495-1.6645-0.5481l-0.1697,0.56332c0.3141-0.0515,1.2129-0.13116,1.6095,0.55748,0.4861,0.8409,1.5339,2.5988,2.357,2.2932l-0.2545,0.74602c0.012,0.007,0.019,0.012,0.024,0.014l0.4539-1.3328c-0.8219,0.30568-1.8697-1.4534-2.3557-2.2932'/%3E %3Cpath fill='%23ed1c24' d='m756.52,539.77c0.021,0,0.044,0,0.068,0.00092,1.3458,0.0364,1.7207,1.0318,1.982,1.6818,0.2408,0.59848,1.5556,1.4206,1.7643,1.5483l0.2556-0.74604c-0.8219,0.30568-1.8697-1.4522-2.3558-2.2931-0.3989-0.68865-1.2965-0.609-1.6095-0.55747l-0.093,0.30802s-0.031,0.0561-0.012,0.0573'/%3E %3Cg fill='%23a37853'%3E %3Cpath d='m614.36,385.5,11.429-6.828v-0.147h-0.245l-11.208,6.534v0.319' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m614.49,381.15,0.22,14.317-0.441,0.171-0.368-13.852,0.051-11.086,0.122,0.074,0.097,10.254z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath d='m736.25,545.64c0.003,0.22135,0.15934,0.40054,0.34849,0.3982l19.456-0.2846c0.1891-0.004,0.3404-0.18504,0.3382-0.40873,0-0.22254-0.1594-0.39937-0.3485-0.39703l-19.456,0.28342c-0.1903,0.004-0.34162,0.18622-0.33818,0.40874'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.1333'%3E %3Cpath fill='%23616264' stroke='none' d='m727.71,541.95s0.79673,0.0411,2.4268,0.29865c0,0-1.7906,0.2436-2.7708,0.55513-0.98016,0.31269-2.8648,2.1807-3.2614,2.5332-0.39892,0.35135-0.58349,0.5282-0.58349,0.5282l-3.0642-0.014s1.4192-1.8294,2.0302-2.2756c0.61101-0.44621,1.8158-1.2602,2.412-1.355,0.59611-0.0949,1.6966-0.3654,2.8097-0.29748'/%3E %3Cpath fill='%23a3a5a8' d='m736.66,546.21c-0.87124-2.3388-3.1456-4.0522-5.9302-3.9527-0.031,0.00092-0.0619,0.004-0.0917,0.005-4.5408,0.18737-4.7643,2.0495-6.4793,3.6118l-0.31754-0.0108c-0.024,0.0386-0.039,0.0632-0.039,0.0632s9.3131,0.28343,12.858,0.28343z'/%3E %3Cg fill='%23797a7d' stroke='none'%3E %3Cpath d='m735.41,545.57c-0.0539,0.0258-0.11687,0.00092-0.141-0.0515-0.024-0.0515-0.0009-0.11712,0.0504-0.14523,0.0516-0.0258,0.11581-0.004,0.14101,0.0515,0.0253,0.0551,0.004,0.12064-0.0504,0.14523'/%3E %3Cpath d='m735.17,545.08c-0.0504,0.0305-0.11809,0.0152-0.15018-0.0328-0.0321-0.048-0.0183-0.11364,0.0309-0.14757,0.0493-0.0317,0.11582-0.0175,0.15018,0.0328,0.0333,0.0504,0.0195,0.11592-0.031,0.14757'/%3E %3Cpath d='m734.87,544.63c-0.0482,0.034-0.11124,0.0247-0.14331-0.0245-0.0333-0.0468-0.0321-0.11005,0.0149-0.14875,0.0436-0.0387,0.11688-0.0352,0.15247,0.014,0.0321,0.0527,0.023,0.12298-0.024,0.15928'/%3E %3Cpath d='m734.52,544.22c-0.0436,0.0411-0.11123,0.0387-0.14788-0.004-0.039-0.0433-0.0379-0.11364,0.003-0.15577,0.0412-0.0421,0.10771-0.0411,0.14903,0.005,0.0412,0.0457,0.039,0.11473-0.004,0.15459'/%3E %3Cpath d='m734.14,543.84c-0.0379,0.0445-0.10666,0.0527-0.15133,0.0164-0.0458-0.0352-0.0528-0.10428-0.0161-0.15108s0.10313-0.0551,0.15132-0.0164c0.0482,0.0387,0.0549,0.10656,0.0161,0.15108'/%3E %3Cpath d='m733.73,543.51c-0.0344,0.0504-0.0951,0.0563-0.14675,0.0293-0.0493-0.0269-0.0665-0.0937-0.0344-0.14405,0.0321-0.0504,0.0997-0.0667,0.15132-0.0352,0.0551,0.0258,0.0619,0.10188,0.0298,0.1499'/%3E %3Cpath d='m733.27,543.23c-0.0286,0.0527-0.0917,0.0726-0.14216,0.0421-0.0481-0.0281-0.0698-0.096-0.0435-0.14992,0.0264-0.0539,0.0894-0.0726,0.14102-0.0421,0.0516,0.0305,0.071,0.0972,0.0447,0.1499'/%3E %3Cpath d='m732.79,543c-0.0241,0.0563-0.0848,0.0832-0.13871,0.0632-0.0549-0.0211-0.0814-0.0832-0.0619-0.14054,0.0207-0.0563,0.0814-0.0832,0.13756-0.062,0.0561,0.0211,0.0837,0.0844,0.0631,0.13938'/%3E %3Cpath d='m732.29,542.8c-0.0149,0.0563-0.0744,0.0925-0.13069,0.0809-0.0561-0.0128-0.0894-0.0691-0.0756-0.12649,0.0137-0.0573,0.0722-0.096,0.13068-0.0832,0.0585,0.014,0.0951,0.0703,0.0756,0.12881'/%3E %3Cpath d='m731.77,542.69c-0.0118,0.0585-0.0642,0.0972-0.11922,0.0855-0.0573-0.0128-0.0951-0.0714-0.0884-0.13,0.008-0.0585,0.0619-0.0972,0.12151-0.0844,0.0585,0.012,0.0986,0.0703,0.086,0.12882'/%3E %3Cpath d='m731.24,542.62c-0.005,0.0609-0.0549,0.10656-0.11347,0.10428-0.0573-0.003-0.10089-0.0539-0.0985-0.11364,0.003-0.0609,0.0516-0.10656,0.11123-0.10428,0.0607,0.004,0.10548,0.0539,0.1009,0.11364'/%3E %3Cpath d='m730.71,542.6c0.0009,0.0609-0.0447,0.10189-0.10208,0.10657-0.0585,0.003-0.10665-0.0387-0.11006-0.0996-0.003-0.0585,0.0436-0.11472,0.10208-0.11712,0.0595-0.006,0.10888,0.0515,0.11006,0.11004'/%3E %3Cpath d='m730.18,542.64c0.005,0.0597-0.039,0.11244-0.0974,0.11832-0.0585,0.005-0.11006-0.0375-0.11581-0.0984-0.005-0.0585,0.0378-0.11244,0.0963-0.11712,0.0607-0.006,0.1123,0.0387,0.11688,0.0972'/%3E %3Cpath d='m729.65,542.69c0.007,0.0597-0.0321,0.11245-0.0917,0.11713-0.0573,0.006-0.11123-0.0363-0.11922-0.0972-0.0106-0.0585,0.0321-0.11124,0.0906-0.11712,0.0607-0.006,0.11347,0.0375,0.12036,0.0972'/%3E %3Cpath d='m729.13,542.77c0.0118,0.0585-0.0241,0.11832-0.0814,0.12999-0.0573,0.012-0.11347-0.0245-0.12496-0.082-0.0118-0.0573,0.024-0.11712,0.0826-0.12999,0.0585-0.014,0.11347,0.0234,0.12381,0.082'/%3E %3Cpath d='m728.61,542.89c0.0149,0.0573-0.0183,0.11472-0.0734,0.12648-0.0573,0.0152-0.11699-0.0234-0.13413-0.0785-0.0172-0.0585,0.0172-0.11472,0.0734-0.12883,0.0596-0.0128,0.11809,0.0222,0.13414,0.0808'/%3E %3Cpath d='m728.11,543.06c0.0207,0.0563-0.006,0.11952-0.0585,0.14171-0.0528,0.0222-0.11464-0.004-0.1387-0.0597-0.024-0.0551,0.0009-0.11832,0.0573-0.14054,0.0561-0.0234,0.11807,0.003,0.13985,0.0585'/%3E %3Cpath d='m727.62,543.27c0.0263,0.0551,0.0117,0.1218-0.0379,0.1546-0.047,0.0305-0.11229,0.0152-0.14101-0.0364-0.0309-0.0504-0.0149-0.12063,0.0367-0.15225,0.0504-0.0352,0.11464-0.0187,0.14215,0.034'/%3E %3Cpath d='m727.17,543.56c0.0344,0.048,0.0241,0.11472-0.024,0.14523-0.0458,0.034-0.10771,0.0317-0.14444-0.0164-0.0379-0.0457-0.0333-0.12062,0.0161-0.15694,0.0504-0.0328,0.12037-0.0211,0.15246,0.0281'/%3E %3Cpath d='m726.76,543.91c0.0402,0.0445,0.0379,0.11244-0.006,0.14991-0.0412,0.0399-0.11006,0.0375-0.15246-0.005-0.0424-0.0421-0.039-0.11005,0.005-0.15109,0.0447-0.0411,0.11347-0.0387,0.15246,0.006'/%3E %3Cpath d='m726.39,544.29c0.0424,0.0398,0.0458,0.10896,0.008,0.15342-0.04,0.0433-0.10665,0.0468-0.15018,0.01-0.0447-0.0399-0.0482-0.11004-0.009-0.1546,0.0402-0.0457,0.10771-0.0492,0.15131-0.008'/%3E %3Cpath d='m726.03,544.7c0.0447,0.0399,0.0493,0.10896,0.0106,0.15459-0.039,0.0445-0.10548,0.0492-0.14903,0.0108-0.0447-0.0387-0.0482-0.10896-0.0106-0.15343,0.0367-0.0468,0.10431-0.0515,0.14903-0.012'/%3E %3Cpath d='m725.68,545.1c0.0436,0.0411,0.0447,0.11004,0.003,0.15224-0.0402,0.0445-0.10889,0.0457-0.15018,0.004-0.0424-0.0399-0.0424-0.11004-0.004-0.15224,0.039-0.0421,0.10771-0.0445,0.15132-0.004'/%3E %3C/g%3E %3Cpath fill='%23939598' d='m729.55,542.2c-4.6497,0.16748-4.8468,2.0554-6.5882,3.633l0.87812,0.0305,0.3164,0.0108c1.715-1.5623,1.9385-3.4245,6.4792-3.6118-0.35078-0.0492-0.71304-0.075-1.0856-0.062z'/%3E %3Cg fill='%23442c13' stroke-width='0.115' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'%3E %3Cpath d='m596.42,395.94,0.13-2.252,0.524-0.032,0,0.62,3.719-0.098-0.815,2.088-3.525-0.13-0.065-0.294'/%3E %3Cpath d='m598.22,389.02,0.099,5.579-0.457,0.033,0.227-5.612z'/%3E %3Cpath d='m600.28,388.69,0.098,5.677-0.327,0.066,0.034-5.743z'/%3E %3Cpath d='m602.59,393.2-0.228-5.416-0.131,0.032,0.098,5.416z'/%3E %3Cpath d='m605.91,392.63,0.986-4.98-0.098,0.066-1.207,4.895z'/%3E %3Cpath d='m602.23,387.81-2.251,6.494-0.359-0.065,2.349-6.461z'/%3E %3Cpath d='m602.75,387.91,0.555,4.893,0.294-0.032-0.62-4.861z'/%3E %3C/g%3E %3Cpath fill='%23a48b58' stroke-width='0.115' d='m606.8,387.71-5.091,0-3.621,1.305,4.276,0.131z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23a37853' stroke-width='0.115' d='m597.96,389.15,3.85-1.273,5.092-0.097,0.031-0.359-5.221,0.097-3.718,1.207z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23000' d='m722.38,542.35c0-0.79756,0.53421-1.4452,1.1945-1.4452,0.57777,0,1.0592,0.49657,1.1704,1.1559,0.078-0.014,0.16049-0.0293,0.24188-0.0399-0.1284-0.80576-0.71074-1.4124-1.4123-1.4124-0.79558,0-1.4398,0.77999-1.4398,1.7415,0,0.27991,0.0595,0.54108,0.15704,0.77531,0.0653-0.0445,0.13642-0.0925,0.21438-0.14171-0.078-0.19207-0.1261-0.40405-0.1261-0.6336z'/%3E %3Cpath fill='%23939598' d='m721.11,545.75c1.8949-1.594,1.9649-3.5849,6.6695-3.7794-0.35192-0.048-0.71417-0.075-1.0867-0.0608-4.7975,0.17099-4.8526,2.176-6.759,3.7817-0.047,0.0399-0.0826,0.0832-0.11229,0.12766l1.1945,0.0269c0.0275-0.0305,0.0584-0.0644,0.094-0.096z'/%3E %3C/g%3E %3Cpath fill='%23fd0' d='m743.67,548.94,0-0.24829s12.591,0.0199,12.664-0.71559c0.073-0.7472-6.1044-0.44621-15.755,0.0515'/%3E %3Cpath fill='%23696161' opacity='0.75' d='m588.68,383.14c-0.659,0.074-1.138-0.657-1.749,0.295-0.018,0.019-0.035,0.039-0.051,0.059-0.418,0.478-0.637,1.144-0.377,1.643,0.153,0.299,0.872,0.568,1.197,0.612,0.8,0.107,1.447-0.543,1.524-1.305,0.376,0.466,1.469,0.484,2.021,0.514,0.962,0.051,1.227-0.121,1.38-1.126,0.563,0.792,1.013,0.854,1.979,0.689,1.104-0.19,2.392-0.323,3.199-1.139,0.308,0.465,0.749,0.72,1.291,0.727,0.473,0.007,1.09-0.076,1.531-0.241,0.365-0.135,0.768-0.641,1.141-0.71,0.286,0.423,0.849,0.26,1.228,0.333,0.706,0.432,1.472,0.696,2.607,0.094,0.298-0.159,1.358,0.232,1.731,0.056,0.26-0.122,0.31-0.376,0.528-0.505,0.464,0.356,1.216-0.012,1.711-0.139,0.395,0.02,0.945-0.044,1.087-0.521,0.689-0.411,0.489-0.755,0.274-0.951-1.096-0.438-1.861-0.438-2.887,0.293-0.338-0.087-0.504-0.078-0.747,0.357-0.438-0.666-1.216-0.857-2.016-0.378-0.675-0.379-1.028-0.101-1.574-0.081-1.095-0.82-3.059-0.712-4.417,0.08-1.542-0.712-2.014-0.303-3.033,0.458-0.574-0.251-1.281-0.097-1.91-0.049-0.57,0.043-0.866,0.756-1.364,0.517-1.1-0.529-1.633,0.28-2.465,0.243-0.903-0.773-1.839,0.175-1.839,0.175' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cg%3E %3Cpath fill='%2384848a' d='m707.99,548.97c0,0.61017-0.48376,1.1044-1.0799,1.1044-0.59611,0-1.0787-0.49541-1.0787-1.1044v-13.587c0-0.609,0.48263-1.1021,1.0787-1.1021,0.59611,0,1.0799,0.49423,1.0799,1.1021v13.587z'/%3E %3Cpath fill='%23453717' d='m717.07,546.5s-0.70158,0.68748-0.87124,0.74602c-0.16737,0.0563-1.01,0.42864-1.1762,0.42864-0.16852,0-0.53421,0.0269-0.92742,0.0269h-0.75661l-0.67406-0.0561,0.27971,1.3468,3.7601,0.0855,0.36569-2.5777z'/%3E %3Cpath fill='%236a5e46' d='M593.02,396.59H591.8L591.78,396.71H590.72L590.48,398.64 592.97,398.62' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cg fill='%23453717'%3E %3Cpath d='m710.59,548.62c0,0.0328-0.0253,0.0573-0.0573,0.0573-0.0298,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.0253-0.0573,0.0561-0.0573,0.031,0,0.0573,0.0245,0.0573,0.0573v1.1747z'/%3E %3Cpath d='m710.9,548.62c0,0.0328-0.0253,0.0573-0.0573,0.0573-0.0298,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.0252-0.0573,0.0561-0.0573,0.031,0,0.0573,0.0245,0.0573,0.0573v1.1747z'/%3E %3Cpath d='m711.23,548.62c0,0.0328-0.0241,0.0573-0.0561,0.0573-0.0321,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.024-0.0573,0.0561-0.0573s0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3Cpath d='m711.74,548.62c0,0.0328-0.0253,0.0573-0.0561,0.0573-0.0309,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.024-0.0573,0.0561-0.0573,0.0298,0,0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3Cpath d='m712.21,548.62c0,0.0328-0.0241,0.0573-0.0561,0.0573-0.0321,0-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.024-0.0573,0.0561-0.0573s0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3Cpath d='m712.61,548.62c0,0.0328-0.024,0.0573-0.0561,0.0573s-0.0561-0.0246-0.0561-0.0573v-1.1747c0-0.0317,0.0241-0.0573,0.0561-0.0573,0.0321,0,0.0561,0.0245,0.0561,0.0573v1.1747z'/%3E %3C/g%3E %3Cpath fill='%232f2311' d='M590.11,398.57V398.47L590.16,396.25 589.92,396.32 589.89,397.45 589.65,397.54 589.55,397.28H588.96L588.76,397.37V398.42z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%232f2311' d='M582.5,397.2 582.18,397.23V397.4H581.81L581.79,397.05H581.47V396.78L581.08,396.76 581.01,395.83H580.81V394.56L580.54,394.53 580.62,397.25 580.47,397.27V397.57H580.64L580.57,398.47 584.29,398.67 584.19,397.2H583.84V397.4L582.87,397.3 582.82,397.64H582.57z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23866d46' d='M584.95,397.54 584.16,397.5 584.29,398.57 584.97,398.5z' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23acacad' d='m708.09,539.94c-0.27399-0.26702-0.70158-0.44037-1.1865-0.44037-0.48607,0-0.91366,0.17335-1.1865,0.44037-0.0117,0.0457-0.0207,0.0925-0.0207,0.14053,0,0.048,0.009,0.0925,0.0195,0.13938,0.27169-0.2682,0.69928-0.44388,1.1876-0.44388,0.4872,0,0.91479,0.17451,1.1865,0.44388,0.0106-0.0468,0.0195-0.0913,0.0195-0.13938,0-0.048-0.0106-0.0948-0.0195-0.14053'/%3E %3Cpath fill='%23866d46' d='M588.03,397.2 588,396.88 588.23,396.59 587.64,396.49 587.61,396.79 587.3,396.81 587.25,396.98H587.03L586.88,397.03 586.78,397.35 586.61,397.13 586.68,398.5 588.62,398.45V397.22' transform='matrix(1.146366,0,0,1.1711652,33.178094,82.138839)'/%3E %3Cpath fill='%232f2311' d='M584.73,398.57 586.83,398.5 586.76,397.45 584.8,397.47' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'/%3E %3Cpath fill='%23453717' d='m698.38,548.94,0.0367-1.7579-0.4872,0.0761-0.33589,0-0.26251-0.15225-0.0367,0.11472-1.2346,0.0375-0.15018-0.38178-0.74744,0.075-0.0378,0.26821-0.93429,0.0375-0.14903-0.34316-0.26252,0,0-1.9125-0.4104,0.0387-0.18801,2.2931-0.37371,0.0375,0-0.30567-0.48606-0.0387-0.0744,0.57386-0.56172-0.0761,0.0379-0.53523-0.52389,0-0.0744,0.61135-3.1789,0.075,0.15019-2.751-0.5239-0.0761,0.0367,2.7522s-2.0566-0.68748-2.3936-1.0318l1.2346,1.4886c-0.00091,0.004,4.1132,0.80575,11.931,0.88305'/%3E %3Cpath fill='%23895f33' d='m685.52,547.95s-0.67406-0.1909-5.9095-1.7966c-5.2377-1.6033-7.7448-2.7511-8.2298-2.9033-0.4872-0.15343-1.1991,0,1.01,0.99314,2.2068,0.99432,10.511,3.8602,11.895,3.8227,1.3848-0.0375,1.4972,0.0761,2.4314-0.11592,0.93543-0.1909-1.1968,0-1.1968,0'/%3E %3Cpath fill='%23fff' d='m708.02,530.86c-0.75546,0.0867-1.3046-0.76945-2.005,0.34549-0.0207,0.0223-0.0402,0.0457-0.0585,0.0691-0.47917,0.55982-0.73022,1.3398-0.43216,1.9242,0.17539,0.35018,0.99961,0.66522,1.3722,0.71675,0.9171,0.12531,1.6588-0.63594,1.7471-1.5284,0.43104,0.54577,1.684,0.56685,2.3168,0.60198,1.1028,0.0597,1.4066-0.1417,1.582-1.3187,0.6454,0.92756,1.1613,1.0002,2.2687,0.80693,1.2656-0.22252,2.7421-0.37829,3.6672-1.334,0.35308,0.54459,0.85863,0.84324,1.48,0.85143,0.54223,0.008,1.2495-0.0891,1.7551-0.28225,0.41843-0.1581,0.88041-0.75071,1.308-0.83153,0.32786,0.4954,0.97327,0.30451,1.4078,0.39,0.80934,0.50595,1.6874,0.81513,2.9886,0.11005,0.34163-0.18622,1.5568,0.27171,1.9844,0.0656,0.29806-0.14289,0.35538-0.44036,0.60528-0.59144,0.53192,0.41694,1.394-0.014,1.9614-0.16279,0.45282,0.0235,1.0833-0.0515,1.2461-0.61017,0.78984-0.48135,0.56057-0.88424,0.31411-1.1138-1.2564-0.51297-2.1334-0.51297-3.3096,0.34316-0.38748-0.10188-0.57778-0.0913-0.85633,0.41809-0.50211-0.77999-1.394-1.0037-2.3111-0.44269-0.77379-0.44388-1.1784-0.11832-1.8044-0.0948-1.2553-0.96037-3.5067-0.83387-5.0635,0.0937-1.7677-0.83386-2.3088-0.35486-3.4769,0.5364-0.65801-0.29396-1.4685-0.11365-2.1896-0.0573-0.65341,0.0504-0.99275,0.88541-1.5636,0.60549-1.261-0.61954-1.872,0.32793-2.8258,0.2846-1.0352-0.90532-2.1082,0.20494-2.1082,0.20494'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23ffe600' d='m740.68,548.21,0.61102,0.76596-24.689,0-18.028-0.22838s-7.8572-0.1909-11.71-0.57271c-3.8518-0.3818-8.2298-1.4909-8.2298-1.4909,0.0379,1.1852,0.86093,1.7966,1.5339,2.4091,0.0872,0.0785,0.2499,0.16396,0.46656,0.25062,1.4502,0.58676,5.4086,1.3129,6.6776,1.5448,1.4582,0.26821,6.6581,0.57271,10.175,0.53524,3.5148-0.0375,39.239-0.19091,39.239-0.19091v-0.34433c1.3848,0.22838,18.929-1.0693,18.929-1.0693,0.05-0.0761,0.11-0.21198,0.1742-0.37126,0.1777-0.44152,0.3852-1.0927,0.4677-1.3586,0.024-0.0737,0.037-0.11712,0.037-0.11712l-15.654,0.23774z'/%3E %3Cpath transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' fill='%23000' d='m567.16,401.22-7.701-6.005,0.587,0.197,7.114,5.546z'/%3E %3Ccircle transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)' fill='%23565759' stroke='%23000' stroke-width='0.23' cx='567.74' cy='398.67' r='0.48'/%3E %3Cpath fill='%23565759' stroke='%23000' stroke-width='0.1333' d='m684.74,550.52,0.0631,0.19441c-0.35881,0.41225-0.67636,0.21784-0.67636,0.21784v-1.5822c0.0826-0.0293,0.1456-0.11124,0.1456-0.2073,0-0.12179-0.0975-0.22134-0.21781-0.22134-0.11922,0-0.21667,0.0996-0.21667,0.22134,0,0.0844,0.0493,0.15694,0.11807,0.19442v1.594s-0.31754,0.19442-0.67635-0.21782l0.0631-0.19442-0.4872,0.0655,0.19029,0.43334,0.086-0.13001s0.50555,0.43216,0.88729,0.43216h0.0436c0.38174,0,0.88957-0.43216,0.88957-0.43216l0.0837,0.13001,0.19144-0.43334-0.48721-0.0644z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m686,549.04c0-0.1827,0.14558-0.33145,0.32556-0.33145,0.17883,0,0.32443,0.14875,0.32443,0.33145,0,0.18387-0.1456,0.33261-0.32443,0.33261-0.17998,0.00092-0.32556-0.14757-0.32556-0.33261'/%3E %3Cpath d='m689.02,549.65c0-0.18271,0.14559-0.33261,0.32442-0.33261,0.17997,0,0.32557,0.1499,0.32557,0.33261,0,0.18388-0.1456,0.33261-0.32557,0.33261-0.17883,0-0.32442-0.14873-0.32442-0.33261'/%3E %3Cpath d='m692,549.76c0-0.18386,0.14674-0.33261,0.32443-0.33261,0.17997,0,0.3267,0.14875,0.3267,0.33261,0,0.1827-0.14673,0.33145-0.3267,0.33145-0.17769,0-0.32443-0.14875-0.32443-0.33145'/%3E %3Cpath d='m695.42,549.71c0-0.1827,0.14558-0.33144,0.32557-0.33144,0.17998,0,0.32556,0.14874,0.32556,0.33144,0,0.18386-0.14558,0.33261-0.32556,0.33261-0.17999,0-0.32557-0.14875-0.32557-0.33261'/%3E %3Cpath d='m698.73,549.76c0-0.18386,0.14559-0.33261,0.32556-0.33261,0.17998,0,0.32558,0.14875,0.32558,0.33261,0,0.1827-0.1456,0.33145-0.32558,0.33145-0.17997,0-0.32556-0.14875-0.32556-0.33145'/%3E %3Cpath d='m701.82,549.71c0-0.1827,0.14559-0.33144,0.32442-0.33144,0.17997,0,0.32557,0.14874,0.32557,0.33144,0,0.18386-0.1456,0.33261-0.32557,0.33261-0.17883,0-0.32442-0.14875-0.32442-0.33261'/%3E %3Cpath d='m710.57,550.05c0-0.18388,0.1456-0.33263,0.32443-0.33263,0.17998,0,0.32556,0.14875,0.32556,0.33263,0,0.18386-0.14558,0.3326-0.32556,0.3326-0.17883,0-0.32443-0.14874-0.32443-0.3326'/%3E %3Cpath d='m719.55,550.28c0-0.18387,0.14559-0.33262,0.32558-0.33262,0.17997,0,0.32556,0.14875,0.32556,0.33262,0,0.1827-0.14559,0.33143-0.32556,0.33143-0.17999,0-0.32558-0.14873-0.32558-0.33143'/%3E %3Cpath d='m722.63,550.39c0-0.18388,0.14557-0.33261,0.32556-0.33261,0.18112,0,0.32556,0.14873,0.32556,0.33261,0,0.18386-0.14444,0.3326-0.32556,0.3326-0.17999,0-0.32556-0.14874-0.32556-0.3326'/%3E %3Cpath d='m725.33,550.39c0-0.18388,0.14559-0.33261,0.32557-0.33261,0.18112,0,0.32556,0.14873,0.32556,0.33261,0,0.18386-0.14444,0.3326-0.32556,0.3326-0.17998,0-0.32557-0.14874-0.32557-0.3326'/%3E %3Cpath d='m728.08,550.39c0-0.18388,0.1456-0.33261,0.32557-0.33261,0.17998,0,0.32442,0.14873,0.32442,0.33261,0,0.18386-0.14444,0.3326-0.32442,0.3326-0.17997,0-0.32557-0.14874-0.32557-0.3326'/%3E %3Cpath d='m730.71,550.34c0-0.1827,0.14559-0.33262,0.32557-0.33262,0.17883,0,0.32442,0.14992,0.32442,0.33262s-0.14559,0.33143-0.32442,0.33143c-0.17998,0-0.32557-0.14873-0.32557-0.33143'/%3E %3Cpath d='m733.24,550.22c0-0.1827,0.14559-0.33262,0.32557-0.33262s0.32557,0.14992,0.32557,0.33262c0,0.18387-0.14559,0.33261-0.32557,0.33261s-0.32557-0.14757-0.32557-0.33261'/%3E %3Cpath d='m735.88,550.22c0-0.1827,0.14558-0.33262,0.32557-0.33262,0.17997,0,0.32442,0.14992,0.32442,0.33262,0,0.18387-0.14445,0.33261-0.32442,0.33261-0.17999,0-0.32557-0.14757-0.32557-0.33261'/%3E %3Cpath d='m704.79,549.76c0-0.18386,0.14558-0.33261,0.32557-0.33261,0.17998,0,0.32556,0.14875,0.32556,0.33261,0,0.1827-0.14558,0.33145-0.32556,0.33145-0.17999,0-0.32557-0.14875-0.32557-0.33145'/%3E %3Cpath d='m707.6,549.93c0-0.18386,0.14559-0.33261,0.32556-0.33261,0.17884,0,0.32557,0.14875,0.32557,0.33261,0,0.18388-0.14673,0.33262-0.32557,0.33262-0.17997,0-0.32556-0.14874-0.32556-0.33262'/%3E %3C/g%3E %3Cg fill='none' stroke-width='0.23' stroke='%23000' transform='matrix(1.146366,0,0,1.1711652,33.178489,82.1384)'%3E %3Ccircle cx='622.02' cy='399.23' r='0.355'/%3E %3Ccircle cx='624.18' cy='399.04' r='0.355'/%3E %3Ccircle cx='626.28' cy='398.89' r='0.355'/%3E %3C/g%3E %3Cpath fill='%23ed1c24' d='M682.56,551.38l0.5,0.4-0.09,0.31c0.04,0.09,0.11,0.18,0.22,0.29l0.09,0.09c0.01,0,0.03-0.01,0.03,0,1.05,1.03,3.88,2.59,3.88,2.59l12.15,0.35h0.22s55.16-0.37,55.16-0.66-0.47-2.56-0.47-2.56-0.29-0.23-0.59-0.16c-0.73,0.17-4.72,0.52-7.57,0.81-0.94,0.1-1.79,0.18-2.31,0.25-2.09,0.31-0.28,0-0.28,0s-21.54,0.24-24.53,0.16c-2.99-0.07-20.38,0.09-20.38,0.09s-10.91-0.78-11.81-0.78-2.69-0.76-3.44-0.84c-0.17-0.02-0.45-0.15-0.78-0.34z'/%3E %3Cpath fill='%23034ea2' d='m755.83,549.45c-0.064,0.16162-0.1238,0.29513-0.1742,0.37126,0,0-17.544,1.2988-18.929,1.0704v0.34198s-35.722,0.15459-39.239,0.19324c-3.517,0.0375-8.717-0.26821-10.174-0.53522-1.2702-0.23307-5.2297-0.95918-6.6787-1.5459l-0.72794,0.0925s1.5717,1.293,2.647,1.9383c0.33129,0.19793,0.61789,0.3373,0.79443,0.35488,0.74628,0.0773,2.5438,0.84089,3.4414,0.84089s11.82,0.76477,11.82,0.76477,17.357-0.15343,20.349-0.0773c2.992,0.0773,24.538-0.15226,24.538-0.15226s-1.7952,0.30684,0.29921,0c2.0956-0.30685,8.9038-0.8409,9.8759-1.0704,0.3073-0.0726,0.6455-0.35955,0.963-0.71675,0.6867-0.77413,1.2816-1.8809,1.2816-1.8809-0.018,0.003-0.053,0.007-0.087,0.0108'/%3E %3Cpath fill='%23fd0' d='m716.54,549.26,0.0872-3.6435s16.092,0.70739,23.833,0.62191v2.8436s-21.137,0.35486-23.92,0.17802'/%3E %3Cg fill='%239b7e39'%3E %3Cpath d='m730.02,554.92,0.38519,0.28576,0.423-0.28459-0.1708-2.778c-0.21093-0.008-0.38748-0.014-0.52389-0.0187l-0.11347,2.7956z'/%3E %3Cpath d='m729.34,552.14-0.83342,2.4653,0.28775,0.38647,0.48607-0.14873,0.62133-2.7241c-0.0585-0.003-0.094-0.004-0.094-0.004-0.15821,0.01-0.31068,0.0164-0.46772,0.0246'/%3E %3Cpath d='m727.16,553.87,0.16965,0.45558,0.50441-0.004,1.2037-2.1667c-0.23729,0.012-0.47001,0.0223-0.70272,0.0316l-1.175,1.683z'/%3E %3Cpath d='m726.12,552.82,0.0402,0.48485,0.48835,0.13938,1.2312-1.2391c-0.35653,0.0152-0.70503,0.0258-1.0489,0.0352l-0.71075,0.57972z'/%3E %3Cpath d='m731.86,554.7,0.4574,0.13469,0.30148-0.41693-0.96179-2.2334c-0.21208-0.007-0.41154-0.0152-0.59382-0.0222l0.79673,2.5379z'/%3E %3Cpath d='m732.96,554.21,0.4746,0.0246,0.20176-0.4755-1.1315-1.5506c-0.25565-0.008-0.49752-0.0175-0.7268-0.0246l1.1819,2.0261z'/%3E %3Cpath d='m734.1,553.31,0.46542-0.10656,0.0699-0.51297-0.54567-0.42864c-0.37945-0.0128-0.74857-0.0247-1.104-0.0364l1.1143,1.0845z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg fill='none' stroke='%23d0c9ce' stroke-width='0.1333'%3E %3Cpath fill='%23fff' stroke='%23999b9e' d='m716.79,523.61,0.11807,0.0972s0.12611-0.19324,0.24304-0.19324c0.11807,0,0.42415,0.14406,0.42415,0.14406l0.0631-0.19326,0.54223,0.14523-0.0275-0.25765s0.35308,0.0492,0.34277,0.0175c-0.008-0.0317-0.0356-0.21784-0.0356-0.21784s0.42415,0.0164,0.45167,0.0305l-0.0355-0.20027s0.61789,0.0773,0.59609,0.0328c-0.0275-0.0573-0.12724-0.23424-0.12724-0.23424s0.49753,0.0492,0.70387,0.0492c0.20635,0,0.18113,0.0632,0.18113,0.0632v-0.16045l0.79329-0.0246-0.12611-0.18504,0.59611-0.0152-0.25335-0.27407s1.2002,0.39469,1.5694,0.0411c0,0-0.5491,0.0317-1.1636-0.16981-0.61445-0.20144-1.1911-0.25649-1.4158-0.31271-0.22583-0.0573-0.74055-0.20963-1.0283-0.33846-0.28888-0.12767-0.69928-0.32441-0.66719-0.3209,0.0722,0.01,0.2075-0.007,0.2075-0.007s-1.3447-0.50712-2.0302-0.61135c0,0-0.87353-0.1827-1.2805,0.11364,0,0-0.18915,0.24008-0.34275,0.30451-0.15363,0.0655-0.47689,0.28225-0.50442,0.31503-0.0263,0.0305-0.0997-0.0656-0.49638,0.17568,0,0-0.0894,0.0352-0.11807,0.0222,0,0-0.77035-0.38531-1.684-0.0222l-0.0665,0.0317s-0.36798-0.16746-0.65802-0.16746c-0.0355,0-0.34276-0.17685-0.39663-0.21083-0.0539-0.0305-0.0275-0.008-0.0275-0.008s-0.36913-0.77062-1.0558-0.7062c-0.68439,0.0644-1.0008,0.23188-1.0994,0.25648-0.0997,0.0246-0.79329,0.26586-0.93887,0.29748-0.1433,0.0317-0.45053,0.16864-0.45053,0.16864s-0.62248,0.27288-0.76692,0.29631c-0.14329,0.0245-0.98243,0.21901-1.0191,0.21901-0.0367,0,0.0802,0.0399,0.10889,0.0399,0,0-0.64999,0.19324-1.0214,0.24126-0.36799,0.048-1.5052,0.2237-1.5957,0.20143-0.0906-0.0245-0.0367-0.008-0.0367-0.008s0.3267,0.17099,1.2725,0.0867c0.17998-0.0152,0.29805-0.008,0.36913-0.0152,0.0722-0.008,0.0906-0.008,0.0356,0.007-0.0549,0.0175-0.41384,0.19324-0.41384,0.19324,0.0253-0.008,0.99046-0.008,0.81163,0.0317-0.0722,0.0164-0.31525,0.17684-0.31525,0.17684l0.93773,0.0164-0.12611,0.12767s0.85633,0.0411,0.9469,0.0246l-0.15361,0.17802s0.44136-0.0187,0.73941-0.10656l-0.14444,0.22486s0.56859-0.0246,0.62362-0.0317l-0.22583,0.23305s0.39778,0.0563,0.49637,0.0399c0.0997-0.0164,0.0539-0.0164,0.0539-0.0164l-0.1708,0.14522h0.60413l-0.0631,0.12064,0.53192-0.10428,0.13527,0.16044s0.42415-0.18386,0.46886-0.17567l0.27054,0.19207s0.27055-0.22486,0.30723-0.23306l0.0344-0.008s0.0997,0.23189,0.21666,0.29045c0,0,0.19833-0.14523,0.25334-0.13703,0.0539,0.008,0.15362,0.15224,0.15362,0.15224l0.1433-0.12881,0.3439,0.12881s0.0722-0.19323,0.17081-0.16981c0.0986,0.0246,0.5193,0.78937,1.457,0.84676,1.1853,0.0714,1.6531-0.58091,1.6531-0.58091l0.35307-0.22485,0.0447,0.2108,0.36913-0.16981,0.0106,0.10428s0.45969-0.20144,0.47689-0.28928l0.16277,0.24829s0.30265-0.19793,0.33474-0.19208c0.0447,0.0108,0.0894,0.13703,0.3336,0.17685'/%3E %3Cpath d='m713.3,523.5c0.0195,0.0269,0.0402,0.0551,0.0631,0.0797'/%3E %3Cpath d='m713.12,523.57c0.005,0.041,0.0161,0.0797,0.0447,0.11244'/%3E %3Cpath stroke='%23fff' d='m706.23,522.25c-0.0207,0.0247-0.0539,0.0421-0.0906,0.048'/%3E %3Cpath stroke='%23fff' d='m705.93,522.31c-0.047,0.0246-0.0882,0.0597-0.1456,0.0655'/%3E %3Cpath d='m720.25,522.73s-1.371-0.35486-1.8307-0.82685c0,0,0.0447-0.0891-0.0195-0.16278-0.0631-0.0727-0.0263-0.0247-0.0263-0.0247s0.23502,0.14523,0.45053,0.12766c0,0-0.0263-0.16865-0.14329-0.24945'/%3E %3Cpath d='m719.97,521.74s-0.72107,0.0317-1.1727-0.0247'/%3E %3Cpath d='m720.57,522.06s-0.24303,0.008-0.41269,0.0399c-0.17196,0.0328-0.6947,0.0492-0.88385-0.0644-0.18915-0.11244-0.29805-0.12765-0.4425-0.16162'/%3E %3Cpath d='m719.34,522.77c-0.0447-0.008-1.01-0.33729-1.3252-0.72378'/%3E %3Cpath d='m718.89,522.99s-0.66833-0.12766-1.4524-0.91585'/%3E %3Cpath d='m718.48,523.17c-0.0367-0.0317-1.4536-0.46494-1.4983-1.1337'/%3E %3Cpath d='m718.16,523.36s-0.80131-0.16044-1.5052-1.1887'/%3E %3Cpath d='m717.64,523.46s-0.8208-0.63477-1.0444-1.1161'/%3E %3Cpath d='m717.16,523.53c-0.0183-0.0399-0.58693-0.76243-0.66719-1.2297'/%3E %3Cpath d='m716.43,523.42s-0.30837-0.89242-0.19031-1.2859'/%3E %3Cpath d='m715.94,523.38c0-0.0328-0.0447-0.0797,0.0183-0.33731,0.0631-0.25765-0.0183-0.46494-0.0447-0.51297'/%3E %3Cpath d='m715.45,523.56c0-0.0247,0-0.31388,0.0985-0.52234,0.0997-0.20847,0.14444-0.40875-0.009-0.64297'/%3E %3Cpath d='m715.03,523.53s-0.0631-0.19324,0.1261-0.44973l0.0253-0.23305s0.0642,0.0164,0.0447-0.0328c-0.0172-0.0468-0.0539-0.14405-0.0539-0.14405'/%3E %3Cpath d='m714.37,522.05c0.0802-0.0738,0.19833-0.24127,0.18916-0.27407-0.009-0.0317-0.0447-0.096-0.0447-0.096l0.071,0.096s0.0458,0.0164,0.13642-0.048c0.0906-0.0644,0.20749-0.0714,0.26253-0.13702,0.0549-0.0632,0.0985-0.11952,0.14444-0.14405,0.0447-0.0234,0.12495,0.0247,0.19717-0.008,0.0722-0.0305,0.30722-0.14405,0.3439-0.20026,0.0356-0.0561,0.0631-0.10428,0.0997-0.13703,0.0356-0.0305,0.10665-0.12063,0.10665-0.12063s0.24418,0.0644,0.41499,0.0644c0.17196,0,0.22584-0.008,0.38977-0.008,0.16164,0,0.51242-0.0246,0.64769,0,0.13528,0.0246,0.48721,0.0726,0.53307,0.0808,0.0447,0.008,0.20749,0.0563,0.32441,0.0714,0.11688,0.0164,0.31412-0.0399,0.38749-0.0551'/%3E %3Cpath d='m715.05,522.61c0.0607,0.0164,0.19603,0.0844,0.21781,0.12766-0.0504-0.11364,0.13297-0.20262,0.19374-0.27406,0.0768-0.0913,0.0826-0.19206,0.0826-0.30449'/%3E %3Cpath d='m715.39,521.98c0.21208,0.18388,0.38862,0.37829,0.55943,0.59145,0.0241-0.12063,0.0161-0.24361,0.0699-0.36657,0.0286-0.0667,0.13643-0.1347,0.11922-0.21668'/%3E %3Cpath d='m715.78,521.36c0.0424,0.11484,0.10665,0.22721,0.15361,0.33964,0.0435,0.0996,0.0837,0.22018,0.15361,0.30918,0.0595,0.0761,0.15706,0.13352,0.24418,0.18506,0.0735,0.0433,0.16049,0.11592,0.24189,0.13702,0.0573-0.0515,0.0722-0.16279,0.0734-0.23189,0.00091-0.0797-0.0951-0.20729-0.0435-0.27171'/%3E %3Cpath d='m716.39,521.32c0.0344,0.31856,0.21781,0.48487,0.50669,0.65352,0.10665,0.0597,0.31869,0.16864,0.44823,0.15107,0.17998-0.0247,0.086-0.22368,0.0906-0.3209'/%3E %3Cpath d='m716.72,521.41c0.0756,0.0785,0.2052,0.11712,0.29461,0.18388,0.0735,0.0585,0.13413,0.13467,0.21208,0.18738,0.0344-0.0258,0.0332-0.0855,0.0183-0.11364'/%3E %3Cpath d='m717.01,521.26c0.0172,0.10188,0.12036,0.24712,0.18914,0.3291,0.0975,0.11712,0.21667,0.23424,0.35881,0.31036,0.086,0.0468,0.23271,0.11952,0.33474,0.12532,0.13299,0.01,0.1284-0.13937,0.0814-0.21901,0.0745,0.13,0.33015,0.0797,0.45052,0.12765'/%3E %3Cpath d='m715.74,521.37c0.24189,0,0.45969-0.075,0.69584-0.10428,0.16393-0.0199,0.3485-0.0317,0.51243-0.0108,0.13986,0.0187,0.28086,0.0738,0.42186,0.0738,0.0355-0.0808-0.039-0.1956-0.0884-0.26352'/%3E %3Cpath d='m717.44,521.12c0.11581,0.10308,0.24304,0.18972,0.39664,0.2436,0.0607,0.0222,0.13299,0.0235,0.1903,0.0539,0.0493,0.0246,0.0814,0.0655,0.12495,0.0972'/%3E %3Cpath d='m717.56,521.41c0.13184,0.0411,0.26367,0.0785,0.29921,0.21784'/%3E %3Cpath d='m714.87,522.73c-0.0607,0.0891-0.10772,0.18036-0.17997,0.26469'/%3E %3Cpath d='m715.4,522.74c0,0.062,0.0218,0.1194,0,0.16981'/%3E %3Cpath d='m715.38,523.17c-0.0195,0.0844-0.0561,0.16982-0.0528,0.25648,0.0195,0.004,0.0207-0.007,0.0344-0.0152'/%3E %3Cpath d='m715.87,523.18c-0.009,0.034-0.0275,0.10776-0.0275,0.1218'/%3E %3Cpath d='m715.6,522.3c0.0458,0.0679,0.0722,0.14172,0.12151,0.20612,0.0412,0.0515,0.0744,0.0808,0.0872,0.14758'/%3E %3Cpath d='m716.14,522.54c-0.0229-0.0281-0.0412-0.0608-0.0458-0.0972'/%3E %3Cpath d='m716.1,522.32c0.0275,0.0364,0.0539,0.0785,0.0642,0.1218'/%3E %3Cpath d='m716.11,522.18c0.0126,0.0293,0.0253,0.0561,0.0447,0.0797'/%3E %3Cpath d='m716.31,523.31c0.0137,0.014,0.0253,0.0305,0.0355,0.048'/%3E %3Cpath d='m716.54,523.05c0.0447,0.0632,0.0412,0.12531,0.0642,0.19324'/%3E %3Cpath d='m716.86,523.41c-0.0447-0.0539-0.0172-0.11472-0.0447-0.16982'/%3E %3Cpath d='m717.63,523.25c0.039,0.0387,0.0756,0.0703,0.13526,0.0797'/%3E %3Cpath d='m717.93,523.41c0.039,0.0421,0.15819,0.0585,0.17079-0.008'/%3E %3Cpath d='m717.91,523c0.039,0.062,0.10313,0.11004,0.17082,0.13704'/%3E %3Cpath d='m718.83,522.68c0.10889-0.012,0.18113,0.0679,0.27856,0.0808'/%3E %3Cpath d='m718.86,522.27c0.0321,0.0504,0.15934,0.19559,0.22584,0.19325'/%3E %3Cpath d='m719.43,522.56c0.0241,0.0551,0.18571,0.0608,0.24417,0.0879'/%3E %3Cpath d='m717.15,520.76c0.0791,0.0269,0.12839,0.0551,0.19832,0.0925,0.0539,0.0293,0.1284,0.0691,0.18916,0.0421'/%3E %3Cpath d='m716.92,520.76c0.11006-0.006,0.19029,0.0901,0.29118,0.0867-0.0333-0.0211-0.071-0.0352-0.11241-0.048'/%3E %3Cpath d='m716.67,520.78c0.1238,0.0328,0.1238,0.0363,0.19602,0.11712,0.004-0.0108,0.00091-0.0187,0.003-0.0269'/%3E %3Cpath d='m716.43,520.72c0.0504,0.0468,0.13183,0.0737,0.16278,0.13702'/%3E %3Cpath d='m716.3,520.73c-0.005,0.0421,0.031,0.0713,0.0722,0.0891'/%3E %3Cpath d='m716,520.8c-0.0367-0.0222-0.071-0.0585-0.0802-0.0972'/%3E %3Cpath d='m716.11,521.45c0.18571,0.0984,0.22927,0.30919,0.27971,0.47433'/%3E %3Cpath d='m718.7,521.38c0.14904,0.034,0.21094,0.13468,0.33245,0.20027,0.005-0.0269-0.0149-0.0199-0.0344-0.0317'/%3E %3Cpath d='m718.24,521.29c0.11687,0.0468,0.24532,0.048,0.34047,0.13468,0.0412,0.0364,0.0665,0.0808,0.11347,0.11244,0.007-0.012,0.0137-0.0258,0.0161-0.0387'/%3E %3Cpath d='m717.34,522.2c0.0665,0.0515,0.14559,0.13352,0.19718,0.20028,0.0332,0.0411,0.0504,0.11124,0.0917,0.13702'/%3E %3Cpath d='m714.95,521.66c0.0756,0.0667,0.25678,0.0785,0.24417,0.20964-0.005,0.0468-0.0642,0.0808-0.0711,0.12765-0.008,0.0515,0.0275,0.096,0.0344,0.14406'/%3E %3Cpath d='m714.88,521.86c0.0321,0.0561,0.10089,0.10428,0.0355,0.16747,0.003-0.008,0.009-0.0128,0.0183-0.0152'/%3E %3Cpath d='m715.35,521.5c0.11688,0.0867,0.24876,0.14171,0.34849,0.24711,0.0493,0.0527,0.1043,0.1991,0.15706,0.21316'/%3E %3Cpath d='m715.19,521.16c0.18457,0.0573,0.20634-0.0984,0.31526-0.16981'/%3E %3Cpath d='m715.58,521.09c0.0698-0.0691,0.0379-0.22838,0.15362-0.25766'/%3E %3Cpath d='m715.4,520.85c0.11922-0.10189,0.16393-0.22603,0.34276-0.25063'/%3E %3Cpath d='m714.21,521.58c0.0722,0.0293,0.13871,0.0679,0.13413,0.14522'/%3E %3Cpath d='m714.16,521.73c0.0241,0.0305,0.0493,0.0609,0.0516,0.0949-0.0149-0.006-0.0275-0.0128-0.0424-0.0222'/%3E %3Cpath d='m713.95,521.65c0.024,0.0259,0.0435,0.0551,0.0631,0.0832,0.0253,0.0317,0.0137,0.048,0.0275,0.0375'/%3E %3Cpath d='m714.36,522.18c-0.0321,0.0761-0.006,0.171,0,0.23189'/%3E %3Cpath d='m714.01,523.45c0.0207,0.0411,0.0458,0.2354-0.0344,0.21667'/%3E %3Cpath d='m711.49,522.3c0.0561-0.005,0.0607-0.0468,0.10313-0.0726,0.0493-0.0293,0.0997-0.0246,0.15935-0.0246'/%3E %3Cpath d='m711.78,522.47c0.0229,0.0305,0.024,0.0632,0,0.0644'/%3E %3Cpath d='m711.62,522.49c0.004,0.0187,0.0009,0.0375-0.009,0.048'/%3E %3Cpath d='m711.5,522.48c-0.003,0.0211-0.005,0.0421-0.0106,0.0644'/%3E %3Cpath d='m712.08,521.56c-0.0493,0.0761-0.0975,0.16279-0.12037,0.24828,0.009,0.01,0.0195,0.01,0.031,0'/%3E %3Cpath d='m712.25,521.65c-0.0321,0.0363-0.0585,0.0996-0.0539,0.15225'/%3E %3Cpath d='m712.53,521.4c-0.0539,0.0363-0.11006,0.0738-0.16279,0.11364'/%3E %3Cpath d='m711.49,521.82c-0.14788-0.048-0.18343-0.0937-0.19029-0.22369-0.11923-0.005-0.30035-0.18622-0.20865-0.28928-0.0321,0.20377-0.29462,0.1218-0.42415,0.0539-0.19833-0.10068-0.35882-0.27756-0.4425-0.46378-0.0528,0.0891-0.13297,0.0797-0.23959,0.0797-0.21897-0.00093-0.42415,0.0364-0.64082,0.0468-0.2373,0.0128-0.45397-0.0714-0.68781-0.0632-0.19374,0.006-0.35538,0.10777-0.54912,0.1265-0.16508,0.0152-0.33245,0.003-0.49638,0.0175'/%3E %3Cpath d='m711.71,521.48c-0.0974,0.0164-0.22124,0.012-0.29805,0.0808,0.0137,0.0128-0.0009,0.0187-0.0009,0.0245'/%3E %3Cpath d='m705.85,521.64c0.27282,0.0108,0.53648,0.0738,0.81277,0.0644,0.13642-0.005,0.26366-0.0316,0.39664-0.0539,0.11808-0.0223,0.25679-0.0293,0.35996-0.082'/%3E %3Cpath d='m705.95,522.57c0.24075-0.0128,0.50899-0.10777,0.744-0.16749,0.26022-0.0667,0.51701-0.13586,0.74857-0.26,0.11687-0.0608,0.18343-0.13936,0.22698-0.24712,0.0379-0.096,0.11241-0.19909,0.11922-0.30684'/%3E %3Cpath d='m706.75,522.74c0.12152-0.0258,0.22928-0.17334,0.34048-0.23424,0.11123-0.0632,0.24417-0.0937,0.36569-0.13468,0.27054-0.0903,0.52159-0.23423,0.71762-0.41811'/%3E %3Cpath d='m707.33,522.84c0.10207-0.0984,0.25908-0.11484,0.38747-0.17335,0.17195-0.0773,0.33703-0.20026,0.47689-0.31737,0.17654-0.15109,0.33015-0.29748,0.46198-0.48018'/%3E %3Cpath d='m707.85,522.99c0.26251-0.13469,0.54223-0.25649,0.79557-0.40406,0.13413-0.0785,0.24877-0.16865,0.35997-0.27288,0.094-0.0879,0.13871-0.22019,0.22125-0.30333'/%3E %3Cpath d='m708.17,523.26c0.28431-0.17215,0.57432-0.35485,0.8357-0.55396,0.23271-0.17685,0.50555-0.30098,0.62706-0.57152'/%3E %3Cpath d='m708.58,523.42c0.14216-0.24945,0.37716-0.45324,0.62249-0.61954,0.18801-0.12883,0.36455-0.28459,0.38746-0.51297'/%3E %3Cpath d='m709.08,523.44c0.004-0.0879,0.0884-0.17918,0.14216-0.25062,0.0768-0.10068,0.15704-0.20496,0.22583-0.31154,0.0802-0.12297,0.13297-0.26234,0.19143-0.39469'/%3E %3Cpath d='m709.7,523.4c0.0872-0.24945,0.0997-0.54458,0.13298-0.80341,0.009-0.0703-0.0117-0.12531-0.007-0.19206,0.005-0.096,0.0458-0.18739,0.0722-0.28226'/%3E %3Cpath d='m710.27,523.33c0.0195-0.0563-0.0183-0.11244-0.0183-0.16865,0.0009-0.0597,0.0286-0.0984,0.039-0.15576,0.0172-0.0949,0.004-0.23189-0.003-0.33378-0.005-0.10068-0.0424-0.22838-0.0117-0.32911,0.0253-0.0867,0.12266-0.13233,0.20978-0.16981'/%3E %3Cpath d='m710.75,523.5c-0.0826-0.26351-0.27743-0.4954-0.26252-0.77297,0.005-0.11244,0.0149-0.28694,0.13527-0.34432'/%3E %3Cpath d='m711.02,523.53c0.0677-0.16865,0.0698-0.47432,0.0106-0.64181'/%3E %3Cpath d='m711.56,523.49c-0.0756-0.16162-0.24417-0.26117-0.19832-0.44973,0.023-0.0972,0.0791-0.17217,0.0894-0.27288'/%3E %3Cpath d='m711.3,522.71c-0.0378,0.0644-0.14444,0.1464-0.22583,0.16162-0.0928,0.0175-0.20978-0.0175-0.27168,0.062-0.0631-0.082-0.0321-0.28927-0.0333-0.39001-0.003-0.12999-0.023-0.2717,0.0264-0.39584,0.0928-0.22838,0.31526-0.35837,0.5686-0.39351'/%3E %3Cpath d='m711.18,521.61c-0.11808,0.18036-0.37371,0.0855-0.51242,0.24011-0.1284,0.1417-0.14788,0.41107-0.11123,0.5844,0.047-0.0457,0.10888-0.0585,0.16507-0.0937'/%3E %3Cpath d='m710.45,521.28c-0.0424,0.12179-0.16622,0.18387-0.24187,0.28225-0.0677,0.0855-0.0872,0.17802-0.11006,0.2764-0.024,0.10656-0.0402,0.20261,0.003,0.30567,0.0344,0.0879,0.0802,0.17568,0.0974,0.2682'/%3E %3Cpath d='m710.06,521.06c-0.0275,0.2108-0.32442,0.39584-0.47917,0.53757-0.0722,0.0691-0.13527,0.14991-0.11124,0.24944,0.0195,0.0738,0.0837,0.12298,0.11922,0.1874,0.0218,0.0411,0.0275,0.0925,0.0504,0.13117,0.0642-0.0433,0.11006-0.0726,0.18571-0.0925,0.0722-0.0222,0.18228-0.0269,0.23501-0.082'/%3E %3Cpath d='m707.94,521.14c-0.19487,0.17919-0.56514,0.27171-0.67749,0.52117'/%3E %3Cpath d='m708.67,521.72c-0.0665,0.0644-0.13987,0.14523-0.22355,0.19208-0.0928,0.0527-0.2029,0.0411-0.30837,0.0411'/%3E %3Cpath d='m707.66,521.94c0.11699-0.0585,0.54223-0.0573,0.55943-0.21667'/%3E %3Cpath d='m708.77,522.11c0.15935-0.0108,0.29462-0.0128,0.37831-0.14523'/%3E %3Cpath d='m708.21,521.71c-0.023,0.0751-0.071,0.1628-0.0814,0.23423'/%3E %3Cpath d='m708.66,521.74c0.11007,0.10536,0,0.3045,0.12611,0.38414'/%3E %3Cpath d='m709.56,521.2c-0.0802,0.096-0.1559,0.18152-0.2522,0.26819-0.0584,0.0527-0.14329,0.10776-0.1731,0.17918-0.0435,0.096,0.005,0.21082,0.0286,0.30685'/%3E %3Cpath d='m708.94,521.08c0.0768,0.0751,0.19832,0.007,0.29118,0.0175,0.0734,0.007,0.15246,0.0281,0.25449,0.0175,0.094-0.01,0.17654-0.0375,0.26252,0.0108,0.054,0.0305,0.0826,0.0972,0.1582,0.10068'/%3E %3Cpath d='m709.42,521.86c-0.0677,0.0492-0.18114,0.0984-0.26253,0.12064'/%3E %3Cpath d='m708.25,521.53c-0.0137,0.0364-0.0207,0.075-0.0367,0.11244'/%3E %3Cpath d='m708.49,521.5c0.0906-0.14874,0.20291-0.18622,0.34162-0.26469'/%3E %3Cpath d='m711,521.08c-0.005,0.0421-0.0207,0.0879,0.003,0.12414,0.008-0.014,0.004-0.0234,0.006-0.0352'/%3E %3Cpath d='m710.8,520.92c-0.005,0.0984,0.024,0.12296,0.0596,0.21314-0.0137-0.0187-0.0275-0.034-0.0402-0.0527'/%3E %3Cpath d='m710.68,520.89c-0.0137,0.0468-0.0149,0.11592,0.0106,0.14522'/%3E %3Cpath d='m710.37,520.73c0.0264-0.0411,0.0643-0.0855,0.10889-0.12064'/%3E %3Cpath d='m710.33,520.6c-0.0321,0.0468-0.0894,0.10896-0.14444,0.13703'/%3E %3Cpath d='m710.15,520.58c-0.009,0.0585-0.0607,0.12999-0.1261,0.15226'/%3E %3Cpath d='m709.94,520.64c-0.0333,0.0515-0.10207,0.0879-0.16392,0.11245'/%3E %3Cpath d='m709.63,520.66c-0.0367,0.0387-0.086,0.0713-0.13528,0.0972'/%3E %3Cpath d='m709.36,520.67c-0.0106,0.0317-0.0504,0.048-0.0894,0.048'/%3E %3Cpath d='m711.39,522.05c0.0183-0.0903,0.18456-0.0996,0.26136-0.0809'/%3E %3Cpath d='m711.2,522.18c0.0379-0.012,0.0688-0.0457,0.0723-0.0797'/%3E %3Cpath d='m710.12,522.61c0,0.0972,0.0126,0.17451-0.0551,0.25765'/%3E %3Cpath d='M709.92,523.42V523.32'/%3E %3Cpath d='m710.04,523.29c0,0.0246-0.005,0.0515-0.0183,0.0738'/%3E %3Cpath d='m709.87,523.21c-0.003,0.0199-0.009,0.0387-0.0183,0.0561'/%3E %3Cpath d='m709.32,523.42c0-0.006,0.009-0.0258,0.0183-0.0387'/%3E %3Cpath d='m709.54,523.29c0.005,0.0258,0.0009,0.0515-0.009,0.0563'/%3E %3Cpath d='m709.76,522.47c0,0.10776-0.0009,0.26468-0.0906,0.34549'/%3E %3Cpath d='m710.25,521.28c-0.0906,0.12999-0.41728,0.24009-0.40581,0.41107'/%3E %3Cpath d='m709.35,521.25c-0.0172,0.0246-0.0412,0.0457-0.0723,0.0563'/%3E %3Cpath d='m709.6,521.32c-0.0309,0.0515-0.0677,0.0972-0.0997,0.14523'/%3E %3Cpath d='m710.66,521.59c-0.14789,0.0504-0.2866,0.10536-0.3164,0.24947'/%3E %3Cpath d='m708.75,522.2c0.0195,0.14289-0.15476,0.26352-0.29002,0.3045'/%3E %3Cpath d='m709.42,522.19c-0.0505,0.0551-0.12955,0.14171-0.20979,0.16161'/%3E %3Cpath d='m708.39,522.89c-0.0161,0.0468-0.0722,0.0808-0.10771,0.11244'/%3E %3Cpath d='m708.09,523.04c-0.0447,0.0199-0.12266,0.0996-0.16393,0.0725'/%3E %3Cpath d='m707.6,522.44c-0.024,0.0585-0.094,0.0891-0.14444,0.12063'/%3E %3Cpath d='m707.11,522.67c-0.0756,0.0222-0.18114,0.0433-0.24418,0.0561'/%3E %3Cpath stroke='%23fff' d='m706.76,522.55c-0.0321,0.0504-0.0917,0.0761-0.15476,0.0891'/%3E %3Cpath d='m707.13,521.42c-0.14559,0.006-0.29577,0.0667-0.40581,0.14404'/%3E %3Cpath stroke='%23fff' d='m706.03,522.48c-0.0412,0.0234-0.11464,0.062-0.16279,0.0399'/%3E %3Cpath stroke='%23fff' d='m704.9,522.16c0.20175-0.11713,0.47918-0.17335,0.70845-0.2237,0.11006-0.0246,0.20176-0.0421,0.29919-0.096,0.0848-0.0468,0.16853-0.11004,0.25565-0.14405'/%3E %3Cpath d='M706.66,522.49H706.52'/%3E %3C/g%3E %3Cpath fill='%232f3b30' stroke='%23fff' stroke-width='0.1333' d='m711.87,544.25s0.25908-1.3703,1.2381-1.6338c0.98014-0.26351,2.0119-1.0529,2.0119-2.0554,0-1.0002-0.56629-1.5811-1.1853-1.8973,0,0,1.8571-1.2637,1.8571-3.1071,0-1.8446-1.9614-2.8471-1.9614-2.8471s2.9909-1.1583,3.1972-2.6878c0.2075-1.5272-1.3401-3.3191-1.8044-3.8449-0.46313-0.52703-1.1853-0.57973-1.1853-0.57973l0.30953,0.63243-0.61905-0.26585s0.30608,0.86549,1.1349,1.5834c0.61216,0.52819,1.7024,1.6326,1.3928,2.4747-0.30952,0.8444-3.0425,2.2147-3.0425,2.2147v1.1583s1.9591,1.211,1.9076,2.2674c-0.0516,1.054-1.7528,2.2662-1.7528,2.2662l-0.10313,1.0529s1.1854,0.79053,1.1338,1.6338c-0.0516,0.8444-1.2897,1.2648-1.2897,1.2648s-1.496,0.68396-1.2897,2.2135'/%3E %3Cpath fill='%232f3b30' stroke='%23fff' stroke-width='0.1333' d='m714.47,544.25s-0.25794-1.3703-1.2381-1.6338c-0.979-0.26351-2.0119-1.0529-2.0119-2.0554,0-1.0002,0.56745-1.5811,1.1865-1.8973,0,0-1.8571-1.2637-1.8571-3.1071,0-1.8446,1.9603-2.8471,1.9603-2.8471s-2.992-1.1583-3.1972-2.6878c-0.20634-1.5272,1.3412-3.3191,1.8044-3.8449,0.46427-0.52703,1.1865-0.57973,1.1865-0.57973l-0.31067,0.63243,0.61904-0.26585s-0.30494,0.86549-1.1349,1.5834c-0.61216,0.52819-1.7012,1.6326-1.3928,2.4747,0.31066,0.8444,3.0436,2.2147,3.0436,2.2147v1.1583s-1.9603,1.211-1.9087,2.2674c0.0528,1.054,1.7539,2.2662,1.7539,2.2662l0.10431,1.0529s-1.1876,0.79053-1.136,1.6338c0.0516,0.8444,1.2897,1.2648,1.2897,1.2648s1.496,0.68396,1.2897,2.2135'/%3E %3Crect fill='%2364472d' width='0.74743' height='27.897' x='712.67' y='520.55'/%3E %3Crect fill='%2364472d' width='0.20061' height='0.53405' x='712.94' y='520.2'/%3E %3Cpath fill='%2364472d' d='m712.32,519.45c0-0.42045,0.33474-0.76243,0.74629-0.76243,0.4127,0,0.74858,0.34198,0.74858,0.76243,0,0.42163-0.33588,0.76478-0.74858,0.76478-0.41155,0-0.74629-0.34315-0.74629-0.76478'/%3E %3C/g%3E %3C/g%3E %3Cg id='border' fill='none' stroke='%23000'%3E %3Cpath stroke-width='1.285' d='m630.79,241.91c27.114,16.283,45.968,52.392,45.968,94.323,0,49.904-26.707,91.565-62.261,101.37'/%3E %3Cpath stroke-width='0.643' d='m629.83,243.6c26.741,15.865,45.366,51.372,45.366,92.627,0,48.973-26.241,89.844-61.153,99.377'/%3E %3Cpath stroke-width='1.297' d='m581.76,438.03c5.403,1.578,11.016,2.41,16.772,2.41,5.917,0,11.682-0.878,17.226-2.544'/%3E %3Cpath stroke-width='1.291' d='m658.8,386.73c-10.246,22.965-27.379,39.604-47.497,44.598l0.188-1.006c-4.098,1.031-8.319,1.569-12.631,1.569-4.933,0-9.744-0.704-14.39-2.045l0.121,1.146c-18.509-5.085-34.389-20.058-44.538-40.696l0.524,1.049c10.167,20.097,25.82,34.648,44.014,39.647l-0.121-1.146c4.646,1.341,9.457,2.045,14.39,2.045,4.312,0,8.533-0.538,12.631-1.569l-0.188,1.006c19.75-4.903,36.622-21.026,46.929-43.342'/%3E %3Cpath fill='%23b1babf' stroke='none' d='m631.36,241.24s-14.748-8.942-33.978-8.723c-14.087,0.16-30.156,8.067-30.156,8.067-16.126,9.438-29.363,26.161-37.612,46.732-5.859,14.608-9.222,31.026-9.222,48.739,0,50.48,28.659,90.88,64.466,100.49,0,0,5.32,2.292,12.608,2.292,7.286,0,13.983-0.917,13.983-0.917,36.52-8.859,65.331-50.171,65.331-101.32,0.001-66.317-52.397-99.617-45.42-95.361m-19.88,190.13s-7.366,1.314-13.928,1.314c-6.56,0-12.836-1.648-12.836-1.648-32.236-8.8-57.854-47.072-57.854-93.285,0-16.217,3.666-32.244,8.939-45.617,7.426-18.832,20.05-33.414,34.567-42.054,0,0,14.644-8.919,27.326-9.065,17.312-0.201,30.411,9.666,30.411,9.666,24.299,15.072,41.174,48.27,41.174,86.801,0.002,46.826-24.921,85.775-57.799,93.888'/%3E %3Cg fill='%23c69024' stroke='%23080101' stroke-width='0.458'%3E %3Cpath d='m566.69,242.43c-26.899,15.875-45.662,51.71-45.662,93.374,0,49.341,26.313,90.508,61.295,100.03l-0.932,1.871c-35.39-10.02-61.93-51.84-61.93-101.89,0-41.968,18.572-78.14,45.456-94.645l1.7737,1.271z'/%3E %3Cpath d='m630.28,242.57c26.943,15.88,45.735,51.727,45.735,93.403,0,49.358-26.356,90.539-61.394,100.06l0.933,1.872c35.444-10.032,62.03-51.858,62.03-101.94,0-41.98-18.688-78.165-45.614-94.675l-0.212-0.146-1.898,1.213,0.42,0.205z'/%3E %3Cpath d='m570.08,251.03c-24.518,14.614-41.619,47.604-41.619,85.958,0,45.423,23.983,83.322,55.868,92.086l0.588,2.332-1.436-0.61c-32.256-9.232-56.449-47.724-56.449-93.808,0-38.635,17.005-71.934,41.511-87.128l0.191-0.135,1.729,1.117-0.383,0.188z'/%3E %3Cpath stroke-width='0.492' d='m631.14,240.63c0.08,0.056,0.159,0.112,0.239,0.169l-4.734,9.936c-0.05-0.031-0.101-0.062-0.153-0.094-3.839-2.371-15.169-8.52-29.127-8.333-11.096,0.149-23.563,6.608-26.468,8.199,0.921-2.253-5.0756-9.8827-5.0756-9.8827s1.3096-0.75627,1.3096-0.75627,16.038-9.154,30.098-9.339c19.191-0.253,33.911,10.1,33.911,10.1'/%3E %3Cpath d='m626.76,251.03c24.558,14.619,41.688,47.621,41.688,85.986,0,45.439-24.023,83.35-55.959,92.117l0.048,1.989c0.156-0.045,1.118-0.357,1.274-0.404,32.07-9.474,56.067-47.827,56.067-93.702,0-38.646-17.033-71.958-41.577-87.157l-0.022-0.016-1.418-0.824-0.483,1.822,0.382,0.189z'/%3E %3Cpath stroke-width='0.57' d='m758.74,365.2-0.079,0.0362c-2.5747,1.2649-4.6829,4.3076-5.5186,8.1127-0.2625,1.1887-0.4081,2.6972-0.3577,3.7618,0,0-2.8705-1.5635-2.8762-1.8012-0.022-0.98145,0.08-2.0261,0.3176-3.1059,0.932-4.2361,3.4906-7.6582,6.4036-8.5706,0.042-0.012,2.1104,1.567,2.1104,1.567z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.57' d='m679.17,365.5,0.0791,0.0364c2.5748,1.2648,4.6829,4.3075,5.5198,8.1127,0.26251,1.1887,0.40696,2.6972,0.35651,3.7618,0,0,2.8705-1.5635,2.8762-1.8013,0.023-0.98143-0.0791-2.0261-0.3164-3.1059-0.93314-4.2361-3.4483-7.6313-6.3623-8.5436-0.039-0.0128-2.1529,1.5401-2.1529,1.5401z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.5307' d='m738.76,595.14s-0.5984-0.46612-1.3688-1.3176c-0.56057-3.654-2.5862-5.3124-2.5862-5.3124l-0.42185,0.0433c-0.36914-1.3211-0.51817-2.8038-0.26138-4.4165l-0.21209,0.034c-4.7379,1.1325-10.137,1.9078-15.93,1.8387-4.5729-0.0551-9.3498-0.93693-13.746-2.1233-0.0435-0.012-0.80474-0.0108-0.78182,0.062,0.53536,1.5799,0.45166,3.1399,0.0607,4.5629l-0.0367-0.004s-1.809,1.4886-2.4807,4.7397c-0.77608,0.98379-1.41,1.5717-1.41,1.5717,0.38977,0.11712,0.78297,0.23071,1.1773,0.34432-0.003,0.0737-0.0106,0.1417-0.0126,0.21549-0.0826,3.1832,2.8946,3.7266,4.8686,3.7372,0.611,4.023,3.1284,3.3917,4.4594,2.7452-0.17655,0.24594-0.28315,0.38882-0.28315,0.38882,0.19717,2.703,1.59,2.9221,3.1559,4.2513,0.14102,0.12063,1.1429,0.76009,1.4674,1.2215,0.0207-0.006,0.0424-0.0199,0.0642-0.0245,1.4582,2.0425,2.5518,7.1687,4.4513,7.1687h0.49638c1.8915,0,2.984-5.0852,4.4353-7.1441,0.32212-0.46144,1.324-1.1009,1.4651-1.2215,1.5659-1.3293,2.9588-1.5483,3.1571-4.2513,0,0-0.10771-0.14289-0.28315-0.38882,1.3286,0.64648,3.8472,1.2777,4.4594-2.7452,1.9534-0.012,4.887-0.5481,4.8652-3.6458,0.41384-0.10776,0.82538-0.219,1.2312-0.33027z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.5307' d='m740.44,594.56c-2.1208-1.2496-3.9034-4.1272-4.4089-7.4826-0.15704-1.0494-0.17538-2.0519-0.0734-2.9736l-2.365-0.23188c-0.27055,1.1911-0.32098,2.566-0.10207,4.0311,0.56974,3.7864,2.7696,6.9661,5.2423,7.8808l1.7069-1.2239z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3Cpath stroke-width='0.5307' d='m698.03,594.44c2.1196-1.2496,3.9034-4.1272,4.4078-7.4826,0.1582-1.0494,0.17654-2.0519,0.0745-2.9736l2.3638-0.23189c0.27168,1.1911,0.32214,2.5648,0.10313,4.0311-0.56974,3.7864-2.7696,6.9661-5.2423,7.8808l-1.7069-1.2239z' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'/%3E %3C/g%3E %3Cg fill='%23000' stroke='none' transform='matrix(0.872322,0,0,0.853851,-28.9422,-70.1339)'%3E %3Cpath d='m705.48,599.31c1.8204-1.3422,2.4257-3.6095,2.9038-5.7411,0.0241-0.10308-0.0149-0.50945-0.0263-0.46027-0.47115,2.1046-1.0764,4.3415-2.8774,5.6684-0.10313,0.0785,0.0528,0.49423,0,0.53287'/%3E %3Cpath d='m709.73,602.29c2.1185-0.87252,3.2224-4.1951,3.7509-6.2528,0.039-0.15108-0.0367-0.42163-0.0126-0.51297-0.53193,2.0612-1.6404,5.3674-3.7394,6.2329-0.0882,0.0364,0.0264,0.52235,0.0009,0.53288'/%3E %3Cpath d='m714.61,607.9c1.5052-2.0589,2.1701-4.324,2.3833-6.8572,0.005-0.0691-0.0195-0.58442-0.0367-0.37595-0.21092,2.4911-0.87352,4.6882-2.3466,6.7014-0.094,0.12648,0.0653,0.4427,0,0.53171'/%3E %3Cpath d='m732.58,598.77c-1.7998-1.3269-2.4051-3.5638-2.8774-5.6684-0.0118-0.048-0.0493,0.35603-0.0263,0.46026,0.47918,2.1315,1.0833,4.4001,2.9037,5.7411-0.0528-0.0387,0.1043-0.45442,0-0.53288'/%3E %3Cpath d='m728.47,601.76c-2.0978-0.86549-3.2064-4.1729-3.7372-6.2318,0.0241,0.0903-0.0528,0.36306-0.0149,0.51297,0.53077,2.0554,1.6347,5.378,3.7509,6.2517-0.0219-0.01,0.0928-0.4954,0.0009-0.53288'/%3E %3Cpath d='m723.59,607.52c-1.4731-2.0132-2.1357-4.2103-2.3466-6.7014-0.0183-0.20847-0.0424,0.30801-0.0367,0.37595,0.21436,2.5332,0.87811,4.7994,2.3833,6.8572-0.0653-0.0879,0.094-0.40407,0-0.53172'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='condor'%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='0.5481'%3E %3Cpath d='m662.23,304.61s-4.2049,9.7289-1.927,10.683c2.2767,0.95333,8.0578-0.5727,12.964-9.3482,4.9053-8.7755-2.909-5.4917-2.909-5.4917l-8.1282,4.1566z'/%3E %3Cpath d='m688.15,311.1s-0.69928,12.781,0,13.735c0.70044,0.95333,7.1843,0.95333,7.5328-8.5846,0.35078-9.5391-1.4009-9.9198-1.4009-9.9198l-6.3073,4.3872'/%3E %3Cpath d='m692.03,295.69s-4.5545,14.307-0.17425,17.169c4.3791,2.8612,7.8836-14.117,8.0578-17.932,0.17541-3.8156-7.8836,0.76243-7.8836,0.76243z'/%3E %3Cpath d='m695.16,313.96s0.87581,13.354,3.3279,13.925c2.4532,0.57269,6.4816-3.8145,6.4816-7.2484,0-3.4338-4.2049-11.446-4.2049-11.446l-5.7811,4.1974'/%3E %3Cpath d='m695.28,297.97s-4.5545,14.307-0.1754,17.168c4.3803,2.8623,7.8847-14.116,8.059-17.931,0.1754-3.8156-7.8836,0.76243-7.8836,0.76243z'/%3E %3Cpath d='m695.63,275.01s-6.6581,6.8677-6.4816,10.683c0.17425,3.8145,9.8094-5.1508,10.686-6.8689,0.87468-1.7158-4.2049-3.8145-4.2049-3.8145z'/%3E %3Cpath d='m691.06,271.16s-5.2561,9.7289-3.8541,12.781,6.4816-2.2884,8.9348-5.7223c2.4532-3.4338-5.0807-7.0586-5.0807-7.0586z'/%3E %3Cpath d='m679.24,272.84s-3.5044,13.163-0.87582,14.498c5.1426,2.6129,8.4648-9.1117,8.9348-13.545,0.52503-4.9599-8.059-0.95333-8.059-0.95333z'/%3E %3Cpath d='m686.82,272.73s-6.657,6.8677-6.4804,10.683c0.1731,3.8145,9.8094-5.1508,10.685-6.8689,0.87697-1.7158-4.2049-3.8145-4.2049-3.8145z'/%3E %3Cpath d='m573.28,273.7s-13.755,6.904-14.959,9.8577c-1.206,2.9537,41.489-4.475,64.947-21.055l-9.5148-5.6345-40.474,16.832z'/%3E %3Cpath d='m589.51,276.18s-25.054,9.3523-6.9504,9.7177c0,0,35.876-7.4685,54.988-22.076l-4.8274-7.1441-43.21,19.503z'/%3E %3Cpath d='m626.31,251.19s-26.452,13.545-23.475,15.071c2.9771,1.526,21.724-2.6714,31.534-8.7755,9.8117-6.1041,14.017-9.538,14.017-9.538l-11.738-3.243-10.338,6.4859z'/%3E %3Cpath d='m616.32,280.9s-9.4506,7.9112-8.3559,8.8118c1.0948,0.9018,20.419-2.1456,35.474-13.958l-1.9053-6.9743-25.407,11.748'/%3E %3Cpath d='m599.85,279.39s-9.0563,7.2202-7.0731,7.8093c1.9844,0.59027,9.6604,6.035,43.646-16.133l4.01-2.463-5.9955-8.4664-34.587,19.253z'/%3E %3Cpath d='m592.86,253.31c-28.581,9.9982-57.24,29.914-57.24,29.914,2.8017-0.9545,73.544-29.433,73.544-29.433'/%3E %3Cpath d='m655.57,297.93s-6.1308,9.3471-4.9053,10.492c1.2266,1.1442,8.7605,4.769,17.519-7.2495,8.7605-12.017-8.2344-10.111-8.2344-10.111l-4.3791,6.8677z'/%3E %3Cpath d='m648.65,289.83s-9.1979,11.541-7.2708,13.067c1.9282,1.526,12.44,1.3363,20.324-9.7289,7.8836-11.064,0.17425-0.57153,0.17425-0.57153l-2.2767-10.111-10.951,7.3444z'/%3E %3Cpath d='m639.8,284.39s-8.9348,10.683-8.059,12.399c0.87696,1.7181,12.965,1.1454,22.951-9.3471s1.927-14.307,1.927-14.307l-16.643,10.682'/%3E %3Cpath d='m623.95,284.87-5.6928,7.9165s1.5762,7.4392,21.197-6.1041c19.621-13.545,18.571-12.399,18.571-12.399l-10.513-1.9078-23.562,12.495z'/%3E %3Cpath d='m561.45,273.47-12.437,5.59s-2.8109,2.4641,4.4938,2.648c7.3046,0.18387,22.395-1.8352,48.649-16.722,11.871-6.7318,19.388-13.148,19.388-13.148l-9.5641-3.5533-50.531,25.185z'/%3E %3Cpath d='m540.15,281.31s17.894-1.9453,25.005-6.6077c0,0-1.4536,2.1749,7.6944-1.3972l51.975-25.351-1.7322-3.3858s-56.616,24.248-60.898,25.598c-4.284,1.3515-22.043,11.144-22.043,11.144z'/%3E %3Cpath stroke-width='0.6431' d='m670.11,304.2s-1.7516,14.183,0.35079,14.707c2.1024,0.52586,8.0578-3.9386,10.511-12.606,2.4532-8.6678-9.6341-7.6161-9.6341-7.6161l-1.7516,4.9892'/%3E %3Cpath d='m679.4,310.24s-1.0512,10.396,0.3508,11.35c1.402,0.9545,4.9053,1.3363,9.109-6.8665,4.2049-8.2028,2.2778-5.1508,2.2778-5.1508l-9.4598-5.1508-2.2778,5.8184z'/%3E %3Cpath d='m682.02,292.21s-7.7082,16.787-3.3268,16.597c4.378-0.1909,10.336-12.782,11.21-15.643,0.87697-2.8623-7.8836-0.95333-7.8836-0.95333z'/%3E %3Cpath d='m681.35,292.06s-2.9003,18.501,1.2404,16.934c4.1395-1.567,6.4827-15.499,6.5584-18.514,0.0756-3.0169-7.7987,1.5799-7.7987,1.5799z'/%3E %3Cpath d='m687.63,293.93s-4.5545,14.307-0.17539,17.168c4.3803,2.8623,7.8836-14.116,8.059-17.931,0.17539-3.8156-7.8836,0.76243-7.8836,0.76243z'/%3E %3Cpath d='m669.67,289.22s-3.5056,13.163-0.87697,14.498c5.1426,2.6129,8.4659-9.1117,8.9348-13.545,0.52503-4.9599-8.0578-0.95332-8.0578-0.95332z'/%3E %3Cpath d='m637,262.07s-11.738,9.7289-10.338,11.255c1.4031,1.526,15.068-1.1442,21.199-5.3405,6.1319-4.1974,8.584-6.4871,8.584-6.4871l-10.511-6.4859-8.9336,7.0586z'/%3E %3Cpath d='m647.34,252.15s-7.5316,6.1041-6.1319,7.6301c1.402,1.5272,14.891-4.0054,17.343-6.6768,2.4532-2.6703,2.2778-5.5314,2.2778-5.5314l-13.489,4.5781z'/%3E %3Cpath d='m654.52,251s-9.6352,8.5846-7.1831,11.637c2.4532,3.052,16.644-10.492,18.57-12.208,1.927-1.7181-11.387,0.57153-11.387,0.57153z'/%3E %3Cpath d='m650.49,247.38-20.497,9.7289s-17.345,11.255-15.593,12.399c1.7516,1.1454,15.242-2.4794,24.877-7.2483,9.6352-4.769,20.323-12.781,20.323-12.781'/%3E %3Cpath d='m656.2,258.45s-22.18,19.068-18.85,20.976c3.3268,1.9066,15.367-3.3287,25.352-12.486'/%3E %3Cpath d='m659.84,263.77s-13.383,22.143-11.982,24.24c1.402,2.0987,10.511-4.9599,15.067-10.3,4.5556-5.3417,8.1369-13.231,8.1369-13.231'/%3E %3Cpath d='m666.23,266.6s-13.599,25.273-12.023,27.371c1.5774,2.0976,9.461,0.3818,14.192-9.538,4.7288-9.9209,4.323-16.319,4.323-16.319l-6.4919-1.5143z'/%3E %3Cpath d='m674.13,267.81s-15.113,31.192-12.134,34.244c2.9794,3.0521,19.713-23.656,20.48-27.429,1.347-6.6346-8.521-7.3877-8.521-7.3877'/%3E %3Cpath d='m642.26,247.19s-13.665,6.4859-10.862,7.821c2.8017,1.3351,15.592-4.3872,17.343-4.9599,1.7539-0.5727-6.4816-2.8612-6.4816-2.8612z'/%3E %3Cpath d='m644.36,249.29s-8.4086,6.6768-6.657,8.3938c1.7505,1.7169,14.541-5.1508,16.993-7.2495,2.4521-2.0987-10.336-1.1442-10.336-1.1442z'/%3E %3Cpath stroke-width='0.5817' d='m662,249.82s-11.491,15.452-7.9707,16.063c3.5228,0.60901,16.869-9.9631,17.053-11.792,0.18571-1.8305-9.0827-4.2701-9.0827-4.2701z'/%3E %3Cpath d='m667.13,253.29s-12.263,15.451-8.7605,16.406c3.5044,0.95333,3.8541-1.526,3.8541-1.526s9.6352-8.0119,10.336-10.111c0.70158-2.0987-5.0795-4.9599-5.0795-4.9599'/%3E %3Cpath d='m670.99,256.92s-8.9359,15.452-6.6581,16.406c2.2778,0.9545,5.9565-2.8612,9.6352-7.4404,3.6787-4.5769-2.9771-8.9653-2.9771-8.9653z'/%3E %3Cpath d='m673.26,263.98s-5.2561,9.7289-3.8541,12.781c1.4009,3.0521,6.4816-2.2885,8.9348-5.7223,2.4532-3.4339-5.0807-7.0586-5.0807-7.0586z'/%3E %3Cpath d='m675.47,290.98s-3.5044,13.163-0.87582,14.498c5.1415,2.6129,8.4648-9.1117,8.9348-13.545,0.52504-4.9599-8.059-0.95332-8.059-0.95332z'/%3E %3Cpath d='m699.54,273.18s-3.5044-1.1442-6.1319-1.1442c0,0-7.7082-6.1041-11.913-6.6768-4.2037-0.5727-0.61331-0.66756-0.61331-0.66756s-0.4379-10.016-1.6645-10.778c0,0-0.70042-10.302-7.182-11.064-6.4827-0.76359-21.024,0.57153-23.652-0.3818-2.6275-0.9545-10.68-4.3134-25.927-0.19089-15.604,4.2185-46.304,18.003-47.88,18.385-1.5774,0.3818,35.267-8.0834,45.602-12.663,0,0,10.336-0.76243,13.489-1.7158,0,0-11.736,5.7223-0.87583,3.243,10.862-2.4805,8.4086,0,8.4086,0s-1.0512,2.4794,5.0807,1.1442c6.133-1.3363,6.133,0,6.133,0s7.0077,2.4794,12.438-0.7636c0,0,2.8029,9.73,6.3073,11.064,0,0,4.1636,8.9149,12.923,10.632,0,0,4.1613,2.949,5.0371,3.5217l4.9489,1.6244,5.2962-4.1412'/%3E %3Cpath d='m627.71,246.81s-35.036,12.59-33.812,16.024c1.2266,3.4338,36.615-9.7289,42.221-13.354,5.608-3.6236-7.8836-2.8612-7.8836-2.8612'/%3E %3C/g%3E %3Cg fill='%23452c25' stroke='%23000' stroke-width='0.5481'%3E %3Cpath stroke-width='0.4948' d='m869.44,278.12,13.78,7.8187s3.3611,2.7874-4.018,1.1466c-7.3792-1.6408-23.115-7.0715-52.843-26.202-13.44-8.6502-17.682-8.4066-17.682-8.4066l18.734,0.50828,42.028,25.136z'/%3E %3Cpath stroke-width='0.4948' d='m873.99,274.72,13.78,7.8187s3.3612,2.7874-4.0192,1.1466c-7.378-1.6408-23.114-7.0715-52.842-26.202-13.44-8.6502-2.6275,7.1359-2.6275,7.1359l2.2778-10.38,43.43,20.481z'/%3E %3Cpath stroke-width='0.482' d='m896.91,282.25s-16.455-3.0579-22.446-7.4428c0,0,1.0524,1.8926-6.9951-1.772,0,0,3.1021,7.0551-19.551-8.3797-22.654-15.432-14.734-7.6758-14.734-7.6758l6.3371-1.635s34.78,13.896,38.594,15.349c3.8151,1.4534,18.796,11.556,18.796,11.556z'/%3E %3Cpath d='m810.88,288.41,5.5129,7.862s-1.8331,7.3701-20.97-6.9708c-19.137-14.34-18.128-13.153-18.128-13.153l10.57-1.4745,23.21,13.172'/%3E %3Cpath d='m786.02,292.35s8.889,11.628,6.9092,13.075c-1.9786,1.4452-12.475,0.82333-19.97-10.557-7.4949-11.38-0.1571-0.57972-0.1571-0.57972l0.6959-18.399,12.716,15.896'/%3E %3Cpath d='m795.15,287s8.5576,11.042,7.6222,12.721c-0.9331,1.6806-12.995,0.61252-22.61-10.283-9.6145-10.894-1.4295-14.376-1.4295-14.376l16.262,11.359'/%3E %3Cpath d='m843.91,280.48s24.388,10.49,6.3005,9.8038c0,0-35.431-9.5426-53.762-25.243l5.1839-6.8548,41.995,21.683'/%3E %3Cpath d='m856.71,277.45s13.2,8.0084,14.182,11.052c0.9836,3.0439-41.019-7.8456-63.178-26.296l9.8966-4.8451,39.1,20.089z'/%3E %3Cpath d='m818.37,284.71s9.5458,7.8374,8.4625,8.7474c-1.0822,0.90999-20.443-1.9863-35.64-13.683l1.8192-6.9883,25.547,11.549'/%3E %3Cpath d='m834.7,284.04s9.4162,6.4953,7.4651,7.1792c-1.9534,0.68279-9.3406,6.4883-44.394-14.043l-4.1304-2.2697,5.5645-8.7427,35.513,17.305'/%3E %3Cpath d='m798.72,264.81s11.393,10.204,9.9402,11.672c-1.4548,1.4675-15.017-1.7626-20.998-6.2084-5.9806-4.4457-10.337-10.143-10.337-10.143l12.712-2.7405,8.6825,7.4205z'/%3E %3Cpath d='m785.14,247.77,20.757,12.372s16.94,11.959,15.152,13.03c-1.7918,1.0716-15.144-3.1036-24.608-8.2661-9.4633-5.1613-20.441-16.277-20.441-16.277'/%3E %3Cpath d='m772.04,306.29s3.8656,9.894,1.5556,10.754c-2.3099,0.8608-8.0337-0.9018-12.632-9.8729-4.598-8.97,2.428-4.2911,2.428-4.2911l8.6482,3.4104z'/%3E %3Cpath d='m778.92,299.89s5.8029,9.5918,4.5385,10.686c-1.2656,1.0939-8.9188,4.4059-17.257-7.9639-8.3364-12.369,8.5794-9.7652,8.5794-9.7652l4.1395,7.0434z'/%3E %3Cpath d='m761.58,256.61s19.799,38.228,18.152,40.26c-1.6496,2.0331-9.4678-0.007-13.849-10.113-4.3837-10.108-7.9661-23.23-7.9661-23.23l3.6638-6.9169z'/%3E %3Cpath d='m784.64,266.33s16.519,14.042,13.127,15.811c-3.3932,1.7708-9.9642-0.79054-19.627-10.351-9.6616-9.5602,6.344-6.0385,6.344-6.0385'/%3E %3Cpath d='m776.64,266.57s11.808,21.682,10.334,23.722c-1.473,2.039-10.332-5.3885-14.699-10.914-4.3665-5.5244-7.6714-13.555-7.6714-13.555'/%3E %3Cpath d='m764.94,258.27s8.3926,15.808,6.0849,16.668c-2.3076,0.85963-5.8533-3.1048-9.3704-7.8304-3.5193-4.7268,3.2855-8.8376,3.2855-8.8376z'/%3E %3Cpath d='m765.13,290.6s3.0447,13.297,0.3725,14.524c-5.2297,2.3997-8.1438-9.4525-8.459-13.902-0.3542-4.9774,8.0865-0.62189,8.0865-0.62189z'/%3E %3Cpath d='m754.67,311.68s0.7073,9.9561-0.7268,10.852c-1.433,0.89477-4.9477,1.1325-8.8649-7.2378-3.9183-8.3691-2.0967-5.2398-2.0967-5.2398l9.6307-4.7584,2.0909,5.4319'/%3E %3Cpath d='m764.03,309.58s1.394,10.366-0.7211,10.661c-2.1139,0.29513-7.9535-3.1903-10.187-9.5825-2.232-6.391,9.8209-5.132,9.8209-5.132l1.6244,3.6938'/%3E %3Cpath d='m754.39,277.06s10.825,24.22,9.0826,27.669c-3.4093,6.7518-13.243-14.753-16.213-23.145-3.321-9.3892,7.1304-4.5242,7.1304-4.5242z'/%3E %3Cpath d='m749.37,281.11s14.756,26.657,8.5313,27.278c-6.2213,0.62072-17.536-19.334-19.433-23.971-1.8984-4.639,10.902-3.3062,10.902-3.3062z'/%3E %3Cpath d='m748.49,286.64s7.26,25.548,2.5828,23.289c-4.6772-2.2592-10.309-21.501-11.077-25.654-0.76807-4.1541,8.4946,2.3658,8.4946,2.3658z'/%3E %3Cpath d='m773.99,250.32s11.192,17.097,7.5626,17.604c-3.6305,0.50711-16.902-11.422-17.025-13.398-0.1204-1.9746,9.4621-4.2056,9.4621-4.2056z'/%3E %3Cpath d='m767,251.04s14.271,19.479,9.9665,20.468c-4.3046,0.98846-4.6267-2.0566-4.6267-2.0566s-11.388-10.264-12.152-12.861c-0.7646-2.5976,6.3922-5.802,6.3922-5.802'/%3E %3Cpath d='m793.99,249.73s13.431,7.0434,10.582,8.2614c-2.8464,1.2204-15.429-5.0243-17.16-5.6684-1.7298-0.64415,6.5779-2.593,6.5779-2.593z'/%3E %3Cpath d='m781.14,251.34s9.814,10.124,7.2381,13.549c-2.5736,3.4268-16.206-12.817-18.062-14.881-1.856-2.0659,11.889,0.93459,11.889,0.93459'/%3E %3Cpath d='m757.34,265.4s15.802,30.784,12.892,33.913c-2.9083,3.1305-20.472-23.08-21.084-26.881-0.6098-3.8004,8.3536-7.6091,8.3536-7.6091'/%3E %3Cpath stroke-width='0.6396' d='m748.26,268.19s6.321,9.6317,5.9622,14.822c-0.3577,5.1871-9.555-7.4275-10.347-9.8026-0.79443-2.3763,4.3849-5.0196,4.3849-5.0196z'/%3E %3Cpath d='m761.25,263.2s4.9156,9.9385,3.4082,12.931c-1.5052,2.9912-8.2023-6.0374-10.534-9.5696-2.3329-3.5322,7.1258-3.3612,7.1258-3.3612z'/%3E %3Cpath stroke-width='0.6581' d='m738.45,272.97s7.7128,8.5565,7.3425,13.118c-0.3703,4.5617-11.57-6.6546-12.552-8.7556-0.98015-2.0987,5.2091-4.3626,5.2091-4.3626z'/%3E %3Cpath d='m788.31,248.28s11.676,10.475,9.8645,12.118c-1.8113,1.6432-17.606-9.668-19.985-11.866-2.3776-2.1971,10.12-0.2518,10.12-0.2518z'/%3E %3Cpath d='m778.44,247.52,9.132,7.691s8.4831,5.6696,7.0307,7.1371c-1.4525,1.4675-14.741-4.6156-17.099-7.3842-2.3593-2.7698-2.0853-5.6216-2.0853-5.6216l3.0218-1.8223z'/%3E %3Cpath d='m808.53,249.94s34.577,14.02,33.232,17.401c-1.3447,3.3812-36.25-11.226-41.728-15.078-5.4762-3.8531,7.9776-2.5368,7.9776-2.5368'/%3E %3Cpath d='m809.78,254.39s25.965,14.621,22.936,16.024c-3.0287,1.4031-21.615-3.5615-31.206-10.064-9.5928-6.5035-13.677-10.107-13.677-10.107l11.842-2.7593,10.105,6.9064z'/%3E %3Cpath d='m745.86,272.16s4.9156,9.9385,3.4093,12.931c-1.5064,2.9923-6.3979-2.5543-8.7296-6.0854-2.334-3.5334,5.3203-6.8455,5.3203-6.8455z'/%3E %3Cpath d='m747.03,294.57s4.0559,14.484-0.4196,17.163c-4.4754,2.6796-7.3883-14.43-7.4307-18.249-0.0436-3.8203,7.8503,1.0857,7.8503,1.0857z'/%3E %3Cpath d='m726.92,270.71s14.437-6.3384,16.997-5.8312c0,0,3.0286-0.76126,4.6576-2.0285,1.6302-1.2672,5.3559-4.3099,5.3559-4.3099s-2.561-17.495,15.834-15.719c18.396,1.7743,42.61,4.0569,47.501,4.817,4.8892,0.76008,22.818,5.8312,27.01,7.8597,4.1911,2.0285,31.501,14.39,37.09,16.419,3.3096,1.2004,10.611,5.7656,16.015,9.2908,3.7222,2.4267-0.1147,0.68982-0.1147,0.68982s-44.229-23.48-59.863-26.619c-3.9126-0.78585,0.2682,4.4797,0.2682,4.4797s-10.16-4.0066-14.351-5.7809c-4.1923-1.7743-7.6841-2.5356-11.642-2.2826-3.9584,0.25415-6.9848-0.50594-9.3131-1.2672-2.3294-0.76008-15.601-1.2672-17.929-1.5213-2.3283-0.25298-4.1912-0.76009-4.1912-0.76009l0.9309,1.5214-6.5194-1.0142-1.8628,2.7886s-6.2867,1.2672-6.7533-0.76126c-0.4643-2.0273-3.7257,9.1281-5.3558,12.424-1.6301,3.2968-7.6841,3.2957-9.5469,5.3253-1.8617,2.0285-3.0265,3.2957-3.9562,3.8028-0.9319,0.50712-5.5885,3.2957-7.2198,3.2957-1.6301,0-11.64,0.76126-11.64,0.76126l-2.5621-4.0569,1.1636-1.5213z'/%3E %3Cpath d='m745.91,311.7s0.2579,12.801-0.4757,13.725c-0.7348,0.92522-7.2107,0.65937-7.2313-8.8868-0.0195-9.5462,1.7436-9.8554,1.7436-9.8554l6.1491,4.6425'/%3E %3Cpath d='m742.56,296.15s4.0559,14.485-0.41956,17.163c-4.4743,2.6796-7.3872-14.43-7.4308-18.249-0.0447-3.8204,7.8503,1.0857,7.8503,1.0857z'/%3E %3Cpath d='m739.24,298.29s4.0558,14.485-0.41957,17.163c-4.4754,2.6796-7.3883-14.43-7.4319-18.249-0.0435-3.8203,7.8515,1.0857,7.8515,1.0857z'/%3E %3C/g%3E %3Cg fill='%23d9c0b9' stroke-width='0.5481' stroke='%23000'%3E %3Cpath d='m741.9,357.31s2.4865,3.0942,2.1781,4.1002c0,0,2.5576-2.5789-0.73483-6.24l-1.4433,2.1397z'/%3E %3Cpath d='m721.32,351.43,1.4926,0,0.56746,1.3925-0.21208,1.2895-1.2885,0.5926s-2.1231-0.54107-1.6015,1.9863c0,0-0.99619-4.6425,1.042-5.2609z'/%3E %3Cpath d='m731.86,361.82,1.5407-1.7017,1.6565,0.87604s-0.68667,4.4879-0.94691,4.8229c-0.26022,0.33495-0.30836,0.38647-0.30836,0.51531,0,0.12882-0.26137-0.85027-0.75775-1.4183-0.49637-0.56684-1.018-3.0427-1.1842-3.0942z'/%3E %3Cpath d='m715.75,356.23-0.75889-2.2674,0.8827-1.1934,1.7826-0.0199,0.75662,0.35603s1.4352,3.2734,0.17997,4.9892c0,0-0.53077-1.8469-1.1395-2.1011,0,0-1.3286-0.20847-1.7035,0.23657z'/%3E %3Cpath d='m699.07,360.14s-2.5117,4.1951,0.74628,6.295c0,0-0.20176-3.914,2.3524-4.7549l-3.0986-1.5401z'/%3E %3Cpath d='m690.43,358.44,2.2709-0.58675,0.21781,0.089s-1.4891,2.8764-1.0845,3.5732c0.40582,0.69685-2.0302-1.2625-1.4043-3.0755z'/%3E %3C/g%3E %3Cpath fill='%23bd8759' stroke='%23000' stroke-width='0.5481' d='m730.39,333.74s0.0808,7.7976,0.0808,9.1831c0,1.3867-0.16048,3.4655-0.95606,4.6776-0.79443,1.2133-1.5912,1.9066-2.8636,1.9066-1.2736,0-4.6141-0.17333-5.2504,1.0388-0.63624,1.2133-1.1154,1.9066-1.1154,1.9066s2.0692-1.2133,2.3867,0c0.31869,1.2122-0.79443,2.2522-0.79443,2.2522s1.9098,0.34667,3.658-0.69333c1.7505-1.0388,2.7054-1.2122,3.5022-1.2122,0.79672,0,1.433,0.86549,1.433,0.86549s0.47689,2.5988,0.31641,4.1588c-0.15934,1.5588-0.47689,4.6788,1.2736,4.6788,0,0,0.63508-1.56,1.2725-1.7333,0.63624-0.17333,2.3867,1.5588,2.0692,2.0788,0,0,0.31754-3.2921-0.3187-5.1976-0.63623-1.9055-0.95491-3.9855-0.95491-3.9855s5.4108,1.9067,5.8877,2.5988c0.47804,0.69333,1.7505,1.9066,2.2274,1.7333,0.47689-0.17333,0-1.7333,0.95378-2.0788,0.95608-0.34666,1.4329,0.51883,1.4329,0.51883s-1.5911-3.6376-3.9778-4.851c-2.3867-1.2122-3.9779-1.2133-4.9328-2.2522-0.95493-1.04-1.1154-2.2522-1.2725-3.4655-0.15935-1.2133,0.0424-11.687,0.0424-11.687l-4.1-0.44153z'/%3E %3Cpath fill='%23bd8759' stroke='%23000' stroke-width='0.5481' d='m703.37,353.57s-3.9618,3.0661-4.4089,4.5113c-0.44594,1.4452-0.57088,2.8366-0.57088,2.8366s3.5468-0.42864,3.1135,1.5272c0,0,1.151,0.66287,2.9806-3.5838,1.8273-4.2478,3.5572-6.0807,4.8537-5.9577,1.2966,0.12297,2.9484,1.3843,3.7807,2.2709,0.83456,0.88774,1.9821,1.5494,3.4265,1.1337,0,0-1.5166-2.3119-0.55942-2.8155,0.95722-0.50477,2.4154-0.40756,2.4154-0.40756s-1.2094-2.8787-3.8082-3.2945c-2.5988-0.41694-4.3986-1.1407-3.7819-2.2721,0.6179-1.1314,3.9424-9.9116,3.9424-9.9116l-4.4055-6.4695-1.7654,5.6286s0.57432,3.3273,0.59725,4.1799c0.023,0.85144-3.5033,8.1255-3.9779,8.5472-0.47344,0.42279-9.9195,4.0745-11.044,4.434-1.1211,0.36072-3.4724,3.1563-3.4724,3.1563l-0.26824,2.0987s1.5831-1.2941,2.0898-0.52468c0,0,1.0948-1.3832,2.0784-0.86432,0.98358,0.51883,0.82882,0.71558,0.82882,0.71558s1.7471-1.1512,2.0566-1.7158c0.30837-0.56685,0.39206-0.49541,0.39206-0.49541s1.5017-0.26862,2.7903-0.48646'/%3E %3Cg fill='none' stroke='%23000' stroke-width='0.5481'%3E %3Cpath d='m708.49,345.51c-0.41498,0.075-0.70502,0.0129-0.97557-0.17684'/%3E %3Cpath d='m710.01,341.66c-0.49294-0.0703-0.93658-0.22838-1.308-0.46378'/%3E %3Cpath d='m708.44,343.64c0.29348,0.1663,0.6328,0.23189,0.97557,0.17802'/%3E %3Cpath d='m705.2,349.67c0.188,0.13117,0.41039,0.21316,0.65344,0.23189'/%3E %3Cpath d='m732.38,346.04c0.64885,0.1136,1.2415,0.45909,1.9098,0.51999'/%3E %3Cpath d='m733.5,344.13c-0.51472,0.12766-0.95492,0.0258-1.2725-0.34667'/%3E %3Cpath d='m733.81,341.88c-0.59269,0.0738-1.2312,0.0398-1.7505-0.17333'/%3E %3Cpath d='m731.59,349.5c0.60528,0.082,1.1659,0.37946,1.7505,0.52'/%3E %3Cpath d='m731.75,351.93c0.29118-0.0679,0.56745-0.0141,0.79557,0.17333'/%3E %3Cpath d='m732.22,358.51c0.39664-0.0703,0.78296-0.0129,1.1131,0.17333'/%3E %3Cpath d='m712.33,350c-0.50097,0.0773-0.90106,0.3818-1.1086,0.87252'/%3E %3Cpath d='m715.57,350.31c-0.69813,0.40288-1.3183,0.96856-1.4089,1.779'/%3E %3Cpath d='m695.45,353.88c0.54339,0.49072,1.3412,0.78116,1.8113,1.2344'/%3E %3Cpath d='m738.11,351.24c-0.41154,0.18973-0.68667,0.56333-0.79443,1.04'/%3E %3Cpath d='m740.34,351.93c-0.28202,0.1136-0.45396,0.36071-0.47689,0.69333'/%3E %3C/g%3E %3Cpath fill='%23452c25' stroke='%23000' stroke-width='0.5492' d='m747.46,301.88s-1.2254-5.542-2.1024-6.3067c-0.87583-0.76477,0.3508-1.5284,0.3508-1.5284s-2.2767-5.5431-3.6787-6.4976c-1.402-0.95567,0.17425-1.7204,0.17425-1.7204s-2.4521-3.8227-4.2037-4.9681c-1.7516-1.1477,0-1.3386,0-1.3386s-1.8307-5.132-6.0998-7.4837c0,0-2.8304-2.9771-5.7169-3.7969-2.89-0.82099-10.049-1.5822-18.704-1.4241-9.1182,0.16631-12.984,6.4859-12.984,6.4859l-0.58234,7.3327,1.3137-0.89477-1.9282,9.1281c-0.30493,2.0882,1.6347,5.7165,1.7425,10.08,0.0333,1.3808,0.11922,2.826,0.27513,4.3064,0.41499,3.9152,1.3309,8.0728,3.1089,11.903,0.141,0.30216,0.27055,1.1899,0.44021,0.90179,0.44594-0.76594,1.4456,2.5848,2.3455,3.7864,0,0,0.53994,4.5558,0.97098,2.867,0.16736-0.65585,1.6301,2.5801,2.5335,4.6097,0.32785,0.739,2.0531,5.7539,1.9878,3.4702-0.0722-2.4981,1.5155,5.3218,1.5155,6.4438l2.1024-3.0579,1.0512,3.4409,1.7505-0.19207-0.52502,3.2488s4.9053-4.0124,5.0818-5.542c0.1731-1.5284,0.34965-2.6749,0.34965-2.6749l1.5762-1.5295,2.4532-3.8227s6.1331,4.7784,6.8323,6.4988c0.70042,1.7193,1.4032,3.2488,1.4032,3.2488l1.5762-1.5295,1.4009,3.4397,0.87697-1.7193,0.8506,2.388,0.0745-0.1464,0.56057,1.5752c0.42301,0.39702,1.4043,0.59729,3.2431-2.4794,2.6275-4.3954,2.4544-7.8351,2.6275-8.5999,0.17539-0.76477,1.2266,1.3375,1.2266,1.3375s2.2778-4.2045,1.927-6.8794c-0.35079-2.6761,1.4031-1.7204,1.4031-1.7204s0.3497-7.0715,0-8.7908c-0.3519-1.7204,1.2244-1.3375,1.2244-1.3375s-0.5251-8.409-1.0513-9.3646c-0.5261-0.95567,1.2255-1.1466,1.2255-1.1466z'/%3E %3Cg fill='%23000'%3E %3Cpath d='m735.18,282.43c1.2358,0.37009,1.8399,1.765,2.3695,2.8471-0.0333-0.0668,0.078-0.38062,0.0137-0.51414-0.52961-1.0822-1.1452-2.4946-2.3833-2.8658,0.008,0.002-0.0826,0.50829,0,0.53288'/%3E %3Cpath d='m736.3,287.71c2.2847,1.9324,2.4807,4.5687,2.3535,7.4545-0.004,0.0867,0.0309,0.59729,0.0447,0.26936,0.13527-3.0532,0.0985-6.1451-2.3982-8.2567,0.0573,0.0492-0.10431,0.44387,0,0.53288'/%3E %3Cpath d='m741.05,290.41c1.2576,2.0694,1.3756,4.3509,1.3779,6.7412,0,0.30333,0.0528,0.30333,0.0528,0-0.0009-2.5391-0.0653-5.029-1.418-7.2554,0.0344,0.055-0.0884,0.39234-0.0126,0.51414'/%3E %3Cpath d='m742.71,300.4c-0.14215,1.478-0.40925,2.9302-0.69355,4.386-0.0207,0.10424,0.0183,0.50712,0.0263,0.4591,0.29003-1.4815,0.55943-2.963,0.70387-4.4692,0.007-0.0668-0.0183-0.58441-0.0367-0.37594'/%3E %3Cpath d='m741.18,308.06c0.11923,0.96855,0.24303,1.9289,0.13986,2.9092-0.007,0.0679,0.0149,0.58442,0.0367,0.37595,0.13069-1.2321,0.0106-2.4384-0.13986-3.6611-0.0253-0.20964-0.0447,0.30684-0.0367,0.37594'/%3E %3Cpath d='m738.23,298.44c0,1.6361,0.0126,3.2699,0.14674,4.9013,0.0183,0.20847,0.0436-0.30684,0.0379-0.37711-0.1238-1.5061-0.13183-3.0134-0.13183-4.5242,0-0.30216-0.0528-0.30216-0.0528,0'/%3E %3Cpath d='m736.98,309.06c0.12725,1.553,0.13185,3.1094,0.13185,4.6671,0,0.30333,0.0528,0.30333,0.0528,0-0.00091-1.683-0.009-3.3659-0.14789-5.043-0.0183-0.20847-0.0424,0.30685-0.0367,0.37595'/%3E %3Cpath d='m743.99,307.71c0.67632,0.71441,1.0913,1.553,1.2449,2.5344,0.016,0.10306,0.034-0.0796,0.036-0.096,0.01-0.11946,0.01-0.24477-0.01-0.36423-0.1593-1.0049-0.58-1.875-1.2713-2.607,0.0631,0.0679-0.10208,0.42513,0,0.53288'/%3E %3Cpath d='m743.57,296.99c0.69469,0.5809,1.2599,1.286,1.8181,1.9992-0.065-0.0832,0.096-0.4099,0-0.53171-0.5582-0.71323-1.1222-1.4194-1.8181-2.0004,0.0585,0.048-0.10431,0.44505,0,0.53288'/%3E %3Cpath d='m737.81,305.01c-0.009,1.4604-0.13757,2.9057-0.40581,4.3403-0.0217,0.10423,0.0172,0.50711,0.0253,0.46027,0.29805-1.5858,0.42186-3.1867,0.43218-4.8006,0.004-0.30216-0.0493-0.30216-0.0516,0'/%3E %3Cpath d='m734.75,308.2c0.11922,1.3047,0.11922,2.6047,0,3.9082-0.005,0.0691,0.0195,0.58441,0.0367,0.37595,0.141-1.5553,0.141-3.1059,0-4.6601-0.0183-0.20847-0.0424,0.30684-0.0367,0.37594'/%3E %3Cpath d='m724.71,273.96c0.80132,0.13352,1.48,0.49541,2.1976,0.8655,0.0217,0.0106,0.32901,0.20144,0.38403,0.12297,0.0561-0.0785-0.21552-0.31973-0.23272-0.33613-0.43217-0.4263-0.95377-0.83035-1.4914-1.1079-0.91594-0.47198-1.8101-0.96387-2.8361-1.1349-0.20292-0.0328,0.55369,0.69099,0.60528,0.73315,0.36798,0.29514,0.89187,0.77766,1.3733,0.85729'/%3E %3Cpath d='m697.43,300.41c0.5193,0.99549,0.59954,2.1467,1.12,3.1422-0.0332-0.0644,0.0802-0.38414,0.0137-0.51414-0.5193-0.99549-0.59955-2.1468-1.1188-3.1422,0.0321,0.0632-0.0826,0.38415-0.0149,0.51415'/%3E %3Cpath d='m702.19,273.43c1.1727-0.41576,2.4142-0.4263,3.6351-0.57153,0.0573-0.007,0.0207-0.53522,0-0.53288-1.2197,0.14523-2.4612,0.15577-3.6351,0.57153-0.086,0.0305,0.0161,0.52702,0,0.53288'/%3E %3Cpath d='m709.18,272.86c1.1108-0.52585,2.2904-0.57036,3.4953-0.57036,0.039,0,0.039-0.53405,0-0.53405-1.2048,0.001-2.3844,0.0457-3.4953,0.57153-0.0951,0.0457,0.0298,0.51883,0,0.53288'/%3E %3Cpath d='m697.02,279.04c-0.14558,0.0258-0.15475,0.14405-0.16279,0.27522-0.008,0.11947-0.0117,0.24595,0.0106,0.36424,0.0161,0.10189,0.0332-0.0796,0.0355-0.096-0.008,0.0996,0.0528,0.001,0.11688-0.0106,0.0665-0.0118,0.0106-0.53406,0-0.53288'/%3E %3Cpath d='m696.29,297.87c0,0.98495,0.005,1.9687,0.15247,2.9431,0.0172,0.10307,0.0355-0.0796,0.0367-0.0949,0.007-0.12063,0.008-0.24477-0.0106-0.3654-0.12495-0.82333-0.12609-1.6513-0.12609-2.4829-0.0009-0.30216-0.0528-0.30216-0.0528,0'/%3E %3Cpath d='m730.99,279.29c0.49522,0.14171,0.80361,0.5036,0.97211,0.98963,0.007,0.0223,0.031-0.16279,0.031-0.18504,0.004-0.10072,0.0149-0.23072-0.0183-0.32793-0.16852-0.49306-0.48148-0.86432-0.98472-1.0096,0.007,0.002-0.0791,0.51063,0,0.53289'/%3E %3Cpath d='m731.55,287.85c0.77609,0.81396,1.3504,1.7591,1.6714,2.8471-0.0253-0.0867,0.0585-0.3654,0.0137-0.51414-0.32327-1.095-0.90563-2.0484-1.6852-2.8658,0.0631,0.0668-0.10207,0.42748,0,0.53288'/%3E %3Cpath d='m729.73,281.57c0.75775,0.65585,1.3997,1.423,2.0967,2.1421-0.0641-0.0656,0.10313-0.42748,0-0.53288-0.69699-0.71792-1.339-1.4862-2.0967-2.1421,0.0573,0.0515-0.1043,0.4427,0,0.53288'/%3E %3Cpath d='m731.82,295.82c0.22009,1.2824-0.0745,2.3775-0.55141,3.5123-0.0595,0.13936,0.0447,0.43918,0.0149,0.51414,0.60871-1.4522,0.83111-2.9279,0.56401-4.4856-0.008-0.0468-0.0458,0.35487-0.0275,0.4591'/%3E %3Cpath d='m733.77,300.24c0.1009,0.65936,0.11922,1.3094,0,1.9687-0.0207,0.11711-0.0161,0.24477-0.009,0.36423,0.00091,0.0164,0.0172,0.19675,0.0356,0.0949,0.16966-0.95333,0.14444-1.9336,0-2.8869-0.0149-0.10306-0.0344,0.0785-0.0356,0.0949-0.007,0.11946-0.009,0.2436,0.009,0.36423'/%3E %3Cpath d='m741.33,315.84c0.49866,1.786,0.53879,3.6107,0.53993,5.4553,0.0009,0.30333,0.0528,0.30333,0.0528,0-0.00091-2.0144-0.0332-4.0183-0.57892-5.9694,0.0253,0.089-0.0551,0.36423-0.0137,0.51414'/%3E %3Cpath d='m740.07,319.47c-0.41154,1.2602-0.82767,2.518-1.3986,3.7138-0.0642,0.13351,0.047,0.44504,0.0137,0.51297,0.57204-1.1946,0.98588-2.4536,1.3974-3.7126,0.0493-0.14639-0.0402-0.43099-0.0126-0.51414'/%3E %3Cpath d='m697.86,307.42c1.1704,1.5248,1.8032,3.3495,2.7903,4.9892-0.0332-0.0562,0.086-0.39117,0.0137-0.51414-0.99046-1.6443-1.6278-3.4772-2.8029-5.0079,0.0653,0.0855-0.0963,0.40873-0.0009,0.53288'/%3E %3Cpath d='m705.27,307.6c-1.0673,0.14054-1.3286-1.3937-2.2366-1.7134,0.0149,0.005-0.086,0.50243,0,0.53171,0.90333,0.31973,1.1704,1.8551,2.2366,1.7146,0.0595-0.008,0.0161-0.53522,0-0.53288'/%3E %3Cpath d='m701.07,314.69c0.76692,1.3457,1.2713,2.8295,2.0967,4.1412-0.0333-0.0527,0.0894-0.39351,0.0149-0.51414-0.82653-1.3117-1.3309-2.7944-2.0978-4.1412,0.0333,0.0586-0.0848,0.38883-0.0137,0.51414'/%3E %3Cpath d='m705.97,316.42c0.86206,1.0365,1.6416,2.1268,2.0887,3.4186-0.0263-0.082,0.0653-0.36892,0.0149-0.51414-0.45167-1.2988-1.2381-2.3962-2.1036-3.4374,0.0653,0.0785-0.0985,0.41459,0,0.53288'/%3E %3Cpath d='m705.54,321.55c0.43447,0.89711,0.82309,1.8165,1.2587,2.7136-0.0321-0.0668,0.078-0.38062,0.0137-0.51414-0.43563-0.89711-0.82424-1.8165-1.2587-2.7136,0.0321,0.0691-0.078,0.3818-0.0137,0.51415'/%3E %3Cpath d='m710.15,322.55c0.25221,0.94162,0.39207,1.9078,0.40009,2.8846,0.004,0.30216,0.0549,0.30333,0.0528,0-0.0106-1.1501-0.14101-2.2873-0.43906-3.3987,0.023,0.0914-0.0549,0.36423-0.0137,0.51414'/%3E %3Cpath d='m708.19,326.81c0.30264,1.3562,0.69929,2.6843,1.4043,3.8836-0.0321-0.0574,0.086-0.39117,0.0149-0.51414-0.69469-1.1829-1.0936-2.4911-1.3917-3.8285-0.0137-0.0492-0.0505,0.35603-0.0275,0.4591'/%3E %3Cpath d='m709.32,308.71c1.1051,0.42279,2.2114,0.83972,3.3554,1.143-0.004-0.001,0.0768-0.51297,0-0.53288-1.1441-0.30333-2.2503-0.72026-3.3554-1.143,0.0195,0.008-0.0884,0.49891,0,0.53288'/%3E %3Cpath d='m710.16,313.42c1.3183,0.73432,2.7077,1.3199,4.0535,1.9992-0.0332-0.0164,0.0975-0.48369,0-0.5317-1.3458-0.67928-2.7352-1.266-4.0535-2.0004,0.0402,0.0222-0.0997,0.47667,0,0.53289'/%3E %3Cpath d='m711.42,318.7c0.68209,0.82802,1.4249,1.5881,2.2366,2.285-0.0595-0.0504,0.10431-0.4427,0-0.53288-0.81163-0.69685-1.5545-1.4558-2.2366-2.285,0.0653,0.0796-0.0974,0.4146,0,0.53288'/%3E %3Cpath d='m712.81,325.26c0.56745,0.90648,0.83456,1.9125,0.97327,2.9724,0.0137,0.10307,0.0344-0.0808,0.0356-0.096,0.007-0.12063,0.007-0.24361-0.0106-0.36424-0.14101-1.0751-0.40582-2.1034-0.98359-3.0263,0.0321,0.0539-0.0894,0.39351-0.0149,0.51414'/%3E %3Cpath d='m716.72,308.95c0.12496,0.63243,0.27283,1.2578,0.42531,1.8832-0.0229-0.0925,0.0516-0.36189,0.0149-0.51297-0.14902-0.60784-0.29232-1.2157-0.41384-1.8294-0.0195-0.1019-0.0333,0.0773-0.0344,0.0949-0.008,0.11946-0.0149,0.24829,0.008,0.36423'/%3E %3Cpath d='m726.51,305.04c-0.27512,0.6945-0.60413,1.3562-0.979,1.9992-0.0722,0.12414,0.047,0.45675,0.0137,0.51414,0.37487-0.64414,0.70388-1.3047,0.97786-1.9992,0.0585-0.14171-0.0436-0.43802-0.0126-0.51414'/%3E %3Cpath d='m730.54,304.87c0,1.1232-0.0183,2.2404-0.26596,3.3425-0.0241,0.10307,0.0149,0.50712,0.0253,0.4591,0.28201-1.2473,0.29232-2.5262,0.29348-3.8004,0-0.30333-0.0528-0.30333-0.0528-0.001'/%3E %3Cpath d='m731.39,311.06c0.10207,0.96387-0.004,1.9125-0.13411,2.867-0.0149,0.10541,0.0217,0.5036,0.0263,0.45909,0.16852-1.2321,0.27513-2.4606,0.14444-3.702-0.0218-0.20847-0.0436,0.30685-0.0367,0.37594'/%3E %3Cpath d='m734.47,316.92c-0.18228,1.3258-0.98244,2.3857-1.9431,3.2488-0.1043,0.0925,0.0595,0.47901,0,0.53288,0.98358-0.88423,1.7826-1.9664,1.9694-3.3226,0.0161-0.10541-0.0207-0.5036-0.0263-0.4591'/%3E %3Cpath d='m724.55,311.18c-0.27857,0.55513-0.63968,1.0552-0.979,1.5705-0.047,0.0714-0.0207,0.25063-0.0183,0.3291,0,0.0176,0.0149,0.21198,0.0298,0.18504,0.34046-0.51531,0.70042-1.0166,0.97899-1.5705,0.0424-0.0831,0.0207-0.23892,0.0183-0.32793,0.0009-0.0188-0.0172-0.21081-0.0298-0.18621'/%3E %3Cpath d='m725.68,319.03c-0.41842,0.56919-0.84257,1.1325-1.3986,1.5705-0.10548,0.0831,0.0561,0.48955,0,0.53288,0.55483-0.43802,0.97899-1.0014,1.3986-1.5705,0.0436-0.0597,0.0253-0.19793,0.0253-0.26703,0-0.0293-0.0355-0.25297-0.0253-0.26586'/%3E %3Cpath d='m722.18,323.17c-1.3653-1.3515-2.0061-3.0848-1.3905-5.0466,0.0458-0.14756-0.0412-0.42864-0.0149-0.51297-0.68552,2.1831-0.23271,4.4727,1.4054,6.0924-0.0631-0.0621,0.10313-0.43099,0-0.53288'/%3E %3Cpath d='m717.56,318.81c0.10548,0.8081,0.0997,1.5916-0.13297,2.3693-0.0447,0.14873,0.039,0.42747,0.0137,0.51414,0.32442-1.0833,0.29117-2.2311,0.14673-3.3425-0.0149-0.10306-0.0344,0.0796-0.0355,0.0949-0.008,0.12063-0.007,0.2436,0.008,0.36423'/%3E %3Cpath d='m728.19,324.04c-0.29003,0.96855-0.81162,1.8176-1.2587,2.7136-0.0653,0.13234,0.047,0.44738,0.0149,0.51414,0.4471-0.89594,0.96983-1.7462,1.2576-2.7136,0.0447-0.14874-0.039-0.42748-0.0137-0.51414'/%3E %3Cpath d='m735.04,326.89c-0.59151,1.0412-1.2736,2.0214-1.958,2.9994-0.078,0.11243,0.047,0.4673,0.0149,0.51298,0.68552-0.97793,1.3653-1.957,1.9557-2.9982,0.0723-0.12648-0.047-0.45558-0.0126-0.51414'/%3E %3Cpath d='m738.38,330.49c-0.28544,1.8305-0.42874,3.6763-0.56859,5.522-0.007,0.0878,0.0217,0.5973,0.0458,0.26937,0.13413-1.7837,0.27399-3.5639,0.54912-5.3323,0.0183-0.10424-0.0195-0.5036-0.0263-0.4591'/%3E %3Cpath d='m742.71,324.08c0.0106,0.62189,0.12954,1.2356,0.13986,1.8563,0.005,0.3736,0.0528,0.0281,0.0493-0.14171-0.009-0.62189-0.12955-1.2356-0.13872-1.8563-0.005-0.3736-0.0528-0.0269-0.0504,0.14171'/%3E %3Cpath d='m696.73,303.93c-0.26023,1.8376-0.0344,3.592,0.56515,5.3429-0.0275-0.082,0.0642-0.36892,0.0137-0.51415-0.49296-1.4347-0.77495-2.7967-0.55256-4.3696,0.0149-0.10424-0.0218-0.50478-0.0263-0.4591'/%3E %3C/g%3E %3Cpath fill='%23dcddde' d='m697.1,285.19s-0.52504-5.3077,0.96295-5.8804c0,0,0.52617-4.865,7.0089-4.1975,0,0,2.1896-3.6248,5.6929-1.7169,0,0,3.329-1.6209,5.2561-0.66756,1.9282,0.9545,4.292,2.5754,4.4674,2.9572,0,0,2.8017-0.5727,4.1166,0.47667s0.70158,4.4832,0.70158,4.4832,3.1525,2.4138,3.415,4.5453c0.26252,2.1315,0.26252,2.99-0.43905,3.5615,0,0,1.402,1.1454,1.1395,2.7663-0.26367,1.6221-1.5774,3.9738-1.8399,3.9738-0.26253,0,0.17539,4.2291-1.2255,5.6602-1.402,1.4312-2.7157,1.7169-3.3279,1.9078-0.61331,0.1909-2.1907,2.4794-3.6798,2.7663-1.4891,0.28576-3.5033-2.2896-3.6787-3.0532-0.17539-0.76243-2.1896-1.6209-2.1896-1.6209s-4.5557,4.865-7.6199,4.1014c-3.0665-0.76243-4.5557-3.339-4.817-3.8156-0.26367-0.47667-1.1395-4.0054-1.1395-4.0054s-3.4162-2.0039-3.1537-3.9105c0.26253-1.9078,1.6645-4.1975,1.6645-4.1975l-1.3149-4.1342z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m712.57,281.17c2.9519-2.7089,6.8507-5.5619,11.037-4.564,0,0,0.0735-0.51531,0-0.53288-4.1865-0.99783-8.0853,1.8551-11.037,4.564-0.1043,0.096,0.0607,0.47667,0,0.53288'/%3E %3Cpath d='m726.76,284.4c-2.9622-2.0144-8.1358-2.7511-11.037-0.26819-0.10548,0.089,0.0585,0.48251,0,0.53287,2.9014-2.4829,8.075-1.7462,11.037,0.2682-0.0493-0.034,0.10313-0.46378,0-0.53288'/%3E %3Cpath d='m715.46,288.95c1.2128,3.9293,2.7811,7.93,2.0956,12.131-0.0172,0.10541,0.0195,0.50594,0.0263,0.46027,0.74169-4.5523-0.78526-8.8177-2.1093-13.105,0.0275,0.0867-0.0585,0.36657-0.0126,0.51414'/%3E %3Cpath d='m710.72,291.34c0.72565,3.9749,0.26138,7.9897-0.009,11.985-0.006,0.0878,0.024,0.59729,0.0447,0.26937,0.2866-4.2373,0.76004-8.5003-0.009-12.713-0.008-0.0468-0.0458,0.35486-0.0263,0.4591'/%3E %3Cpath d='m717.04,288.42c3.861,0.91585,7.6371,3.4901,9.7155,6.9708-0.0332-0.0562,0.0872-0.39117,0.0149-0.51414-2.0841-3.4912-5.8556-6.0702-9.7292-6.9895-0.003,0.001-0.0756,0.51649-0.0009,0.53288'/%3E %3Cpath d='m713.6,293.79c0.0137,2.443,0.20405,4.8884-0.50669,7.26-0.0435,0.14874,0.04,0.42748,0.0137,0.51414,0.76118-2.5391,0.55943-5.1555,0.54682-7.7742-0.004-0.30216-0.0551-0.30333-0.0539,0'/%3E %3Cpath d='m719.67,293.25c2.4257,2.005,4.347,5.036,4.7116,8.2438,0.0241,0.20964,0.0447-0.30684,0.0355-0.37594-0.37142-3.2758-2.2629-6.3465-4.7482-8.4008,0.0573,0.048-0.10207,0.44622,0.00091,0.53288'/%3E %3Cpath d='m701.8,299.95c0.8036-1.1466,1.7998-2.4548,3.1468-2.9431,0.0872-0.0328-0.0172-0.52702,0-0.53405-1.3562,0.49306-2.3501,1.8083-3.1605,2.963-0.0791,0.11477,0.047,0.46729,0.0137,0.51414'/%3E %3Cpath d='m707.58,279.07c-0.51242-2.1831-2.1506-3.4713-3.9068-4.646,0.0424,0.0281-0.0928,0.41225,0,0.47433,1.7436,1.1665,3.3841,2.4559,3.8931,4.6296-0.0183-0.0831,0.0458-0.32207,0.0137-0.45792'/%3E %3Cpath d='m704.16,279.03c-2.0222-0.96036-4.1132-1.0728-6.3084-1.074-0.0379,0-0.0379,0.53288,0,0.53288,2.1953,0.002,4.2863,0.11361,6.3084,1.074-0.0309-0.0152,0.094-0.48721,0-0.53288'/%3E %3Cpath d='m710.48,278.69c0.26711-2.0976-0.0435-4.0792-1.8514-5.3733,0.0447,0.0328-0.0906,0.40171,0,0.46612,1.5178,1.0868,2.0726,2.5988,1.8285,4.5043-0.0126,0.0925,0.0172,0.44036,0.023,0.40288'/%3E %3Cpath d='m718.09,281.17c1.9007-1.0095,3.971-0.82098,6.0436-0.80576,0.0379,0,0.0412-0.53171,0-0.53171-2.0738-0.0164-4.143-0.20495-6.0436,0.80459-0.0985,0.0527,0.0379,0.51297,0,0.53288'/%3E %3Cpath d='m721.51,286.27c2.9324,0.31036,5.1678,1.8165,7.0948,4.0276-0.12953-0.14874,0.19948-0.83855,0-1.0658-1.9282-2.21-4.1636-3.7173-7.0948-4.0276-0.0436-0.005-0.11124,1.054,0,1.0658'/%3E %3Cpath d='m708.62,294.35c-0.69354,2.8038-0.16277,6.3489-3.4036,7.4978-0.17195,0.0609,0.0321,1.054,0,1.0658,3.282-1.163,2.7318-4.7069,3.4299-7.5364,0.0756-0.30334-0.0722-0.84324-0.0263-1.0271'/%3E %3Cpath d='m715.45,292.16c1.1246,2.9478,2.694,5.9566,2.0887,9.2288-0.0379,0.20847,0.0355,1.0131,0.0528,0.91937,0.74283-4.0312-0.70159-7.4744-2.115-11.175,0.0595,0.15577-0.13642,0.74252-0.0263,1.0271'/%3E %3Cpath d='m719.67,291.64c2.859,0.36423,5.3753,2.9092,5.7548,5.8336,0.0275,0.20613,0.0711-0.16045,0.0722-0.1909,0.0126-0.24243,0.0118-0.48838-0.0207-0.72964-0.38633-2.9759-2.8762-5.6052-5.8064-5.9788-0.0367-0.005-0.11808,1.0517,0,1.0658'/%3E %3Cpath d='m719.64,295.86c0.44823,2.4489,1.1418,4.9002,0.27399,7.3491-0.10207,0.28811,0.086,0.86549,0.0275,1.0271,1.081-3.0544,0.31296-6.2165-0.24991-9.2967-0.0172-0.0925-0.0894,0.7109-0.0516,0.92054'/%3E %3Cpath d='m718.09,285.2c3.1456-0.53171,6.4747-1.006,9.1973,1.074-0.10771-0.0832,0.20865-0.90648,0-1.0658-2.7226-2.0788-6.0516-1.6057-9.1973-1.074-0.12838,0.0222-0.0218,1.0693,0,1.0658'/%3E %3Cpath d='m712.33,278.95c0.37716-2.6012,2.6676-4.4598,4.9672-5.2972,0.17424-0.0632-0.0356-1.0517,0-1.0646-2.373,0.86315-4.6325,2.7757-5.02,5.4412-0.0355,0.24009-0.0321,0.48838-0.0195,0.72964,0.003,0.0328,0.0424,0.39703,0.0723,0.1909'/%3E %3Cpath d='m709.46,280.51c-0.0768-2.8834-1.3401-5.2046-2.5828-7.7262,0.0573,0.11712-0.14101,0.67459-0.0253,0.90999,1.1143,2.2568,2.4509,4.4633,2.5186,7.0668,0.0183,0.66288,0.0975,0.0515,0.0894-0.25063'/%3E %3Cpath d='m706.82,282.06c-0.56057-2.5672-2.2549-4.2689-4.4938-5.4424,0.0722,0.0386-0.19602,0.96269,0,1.0658,2.1632,1.1325,3.8942,2.7991,4.441,5.2972,0.023,0.096,0.0975-0.71324,0.0528-0.92054'/%3E %3Cpath d='m702.58,281.03c-1.4685-1.0224-3.0115-1.9851-4.7975-2.2592-0.024-0.004-0.0974,0.8163,0,0.83036,1.786,0.27405,3.3279,1.2356,4.7975,2.2592-0.078-0.055,0.1628-0.71792,0-0.83035'/%3E %3Cpath d='m711.75,293.09c0.2522,2.7276,0.59153,5.4822-0.76577,7.9698-0.13871,0.25415,0.0951,0.90531,0.0275,1.0271,1.6255-2.9818,1.112-6.5058,0.81162-9.75-0.0379-0.41811-0.086,0.61486-0.0734,0.75305'/%3E %3Cpath d='m714.92,291.62c0.91136,2.5648,1.9878,5.2937,1.8078,8.0764-0.0106,0.17568,0.0482,1.1946,0.0906,0.53874,0.21896-3.3905-0.74858-6.4883-1.8709-9.6422,0.0573,0.16046-0.12954,0.73784-0.0275,1.0271'/%3E %3Cpath d='m717.04,287.88c2.608,0.80107,5.1965,1.6548,7.0937,3.7583-0.12839-0.14289,0.20176-0.84324,0-1.0646-1.8972-2.1046-4.4857-2.9584-7.0937-3.7594,0.0195,0.006-0.16393,1.0154,0,1.0658'/%3E %3Cpath d='m709.98,282.09c0.27627-2.2697,0.5193-4.5312,0.54109-6.8197,0.005-0.60667-0.0985-0.60549-0.1043,0-0.0195,2.0343-0.26481,4.0511-0.51128,6.0666-0.0161,0.1382,0.0241,1.17,0.0745,0.75306'/%3E %3Cpath d='m705.21,280.64c-1.9259-0.87603-3.6374-2.1257-5.2561-3.4889,0.11582,0.0972-0.20978,0.88892,0,1.0658,1.6187,1.3644,3.3302,2.614,5.2561,3.4901-0.0585-0.0269,0.18686-0.98144,0-1.0669'/%3E %3Cpath d='m704.42,294.33c-1.2369,0.78233-2.0887,1.8739-2.6412,3.2406-0.0745,0.18504-0.0424,0.46261-0.0367,0.65585,0.0009,0.041,0.0458,0.41811,0.0653,0.37126,0.54568-1.3515,1.3928-2.4302,2.6126-3.202,0.20634-0.13-0.0917-1.0084,0-1.0658'/%3E %3Cpath d='m707.79,296.33c-0.0482,1.8692-1.0776,3.4175-2.3157,4.7092-0.20404,0.21316,0.12611,0.93342,0,1.0658,1.4926-1.5576,2.3592-3.2945,2.4154-5.4916,0.009-0.33964-0.0802-1.0306-0.0997-0.28342'/%3E %3Cpath d='m716.61,281.63c1.551-2.4501,5.2996-2.6539,7.8033-3.3378,0.15706-0.0422-0.009-1.0622,0-1.0646-2.5358,0.69216-6.2626,0.89711-7.8308,3.3753-0.15133,0.23892,0.094,0.92288,0.0275,1.0271'/%3E %3Cpath d='m699.38,281.59c-0.60069-0.18036-1.151-0.48837-1.6978-0.79522,0.0482,0.0269-0.12381,0.58793,0,0.6582,0.54796,0.30684,1.0971,0.61603,1.6978,0.79639-0.0106-0.004,0.0997-0.62892,0-0.65937'/%3E %3Cpath d='m699.72,294.13c-0.54108,0.22135-1.0994,0.44739-1.4731,0.9264-0.0882,0.11243-0.0516,0.40053-0.0516,0.53288,0,0.12531,0.003,0.2518,0.0149,0.37594-0.003-0.0176,0.0252,0.16982,0.0367,0.15577,0.37372-0.47784,0.932-0.70505,1.4731-0.92523,0.0826-0.034,0.0516-0.46729,0.0516-0.53287,0-0.0269-0.0241-0.5446-0.0516-0.53289'/%3E %3Cpath d='m701.98,294.71c-1.112,0.49774-1.9213,1.4604-2.6171,2.4454-0.12267,0.17685,0.0734,0.73432,0.0229,0.80694,0.68896-0.97441,1.496-1.9242,2.5954-2.415,0.14559-0.0668-0.0447-0.81747-0.0009-0.83738'/%3E %3Cpath d='m706.27,295.77c-0.97098,2.3658-3.6168,4.9798-1.6978,7.6254-0.0665-0.089,0.188-0.80693,0.0263-1.0271-1.3275-1.8329,1.0111-3.893,1.6989-5.5712,0.11464-0.27991-0.0894-0.87721-0.0275-1.0271'/%3E %3Cpath d='m709.3,295.73c0.0735,2.4114-0.35193,4.7912-0.77036,7.1535-0.0356,0.20964,0.0355,1.0119,0.0539,0.92054,0.49065-2.771,0.90219-5.5338,0.81736-8.3574-0.024-0.74603-0.11124-0.0562-0.1009,0.28343'/%3E %3Cpath d='m717.05,292.88c1.7574,2.3013,3.313,4.7772,4.0639,7.6208-0.047-0.18036,0.10771-0.72612,0.0275-1.0271-0.75545-2.86-2.3248-5.3452-4.0914-7.6594,0.12954,0.17099-0.19029,0.8163,0,1.0658'/%3E %3Cpath d='m717.96,291.03c2.89,2.2018,6.1078,4.2724,8.1438,7.3889-0.0677-0.10072,0.17998-0.79288,0.0264-1.0271-2.0463-3.1329-5.2664-5.214-8.1713-7.4275,0.10888,0.0832-0.20634,0.90765,0.0009,1.0658'/%3E %3Cpath d='m719.66,287.22c1.0776-0.10423,2.0784-0.0632,3.1021,0.31388,0.91594,0.33846,1.6748,1.095,2.5082,1.5975,0.84028,0.50594,1.6886,0.96504,2.3741,1.6876,0.8976,0.94396,0.90563,2.5531,1.1704,3.7676,0.0172,0.082,0.0814-0.60783,0.0447-0.78468-0.21553-0.99666-0.32901-2.005-0.66948-2.9689-0.33015-0.94162-1.1441-1.5202-1.9385-2.0273-0.95034-0.60783-1.8835-1.2239-2.8258-1.8434-1.1188-0.73549-2.4865-0.77531-3.7658-0.65117-0.0929,0.009-0.0412,0.91234,0,0.90882'/%3E %3Cpath d='m726.73,293.14c0.31754,0.93342,0.6924,1.8458,1.0122,2.778-0.0367-0.10658,0.0814-0.47901,0.0183-0.66757-0.3187-0.93342-0.6924-1.8458-1.0122-2.778,0.0367,0.10775-0.0826,0.48018-0.0183,0.66756'/%3E %3Cpath d='m718.64,278.41c2.036-0.55982,4.1177-0.92991,6.1182-1.6209,0.17081-0.0586-0.0286-1.0552,0-1.0646-2.0004,0.68982-4.0822,1.0599-6.1182,1.6197-0.1559,0.0433,0.0106,1.0634,0,1.0658'/%3E %3Cpath d='m710.15,279.43c0.28545-1.0798,0.74629-1.9594,1.3619-2.8799,0.75776-1.1314,0.86437-2.5496,1.7952-3.5838,0.20061-0.22252-0.12725-0.9217,0-1.0646-0.76691,0.85027-1.0329,1.9441-1.4742,2.983-0.52734,1.2461-1.355,2.1667-1.7104,3.5182-0.0802,0.30099,0.0756,0.84675,0.0275,1.0271'/%3E %3Cpath d='m703.2,298.49c-0.36225,1.7532-0.29462,3.5826,0.35193,5.2562-0.0595-0.1546,0.13757-0.74252,0.0275-1.0271-0.42301-1.0986-0.5686-2.1362-0.32671-3.3086,0.0482-0.23189,0.0309-0.49423,0.0183-0.72963-0.003-0.0363-0.0298-0.39234-0.0711-0.1909'/%3E %3Cpath d='m707.42,301.8c-0.7291,0.99314-0.73941,2.5063-0.35423,3.647,0.0149,0.0386,0.0607-0.30802,0.0619-0.35018,0.005-0.1909,0.0264-0.43216-0.0344-0.61604-0.21552-0.63711-0.0561-1.1583,0.32671-1.6783,0.0814-0.11126,0.0493-0.3736,0.0493-0.50126,0-0.0562-0.0699-0.47549-0.0493-0.50125'/%3E %3Cpath d='m710.56,300.12c-0.0332,1.0096-0.57203,1.9687-0.99389,2.8565-0.0906,0.19442,0.0677,0.64297,0.0217,0.74135,0.52274-1.1021,1.0042-2.1538,1.0455-3.394,0.008-0.24477-0.0539-0.74134-0.0734-0.20378'/%3E %3Cpath d='m710.65,294.2,0,1.2731c0,0.0375-0.008,0.53288,0.0516,0.53288,0.0619,0,0.0528-0.4954,0.0528-0.53288v-1.2731c0-0.0363,0.009-0.53288-0.0528-0.53288-0.0596,0-0.0516,0.49775-0.0516,0.53288'/%3E %3Cpath d='m709.22,294.94c0.0814,0.14991,0.14903,0.29981,0.20406,0.46378,0.0356,0.22486,0.0528,0.23657,0.0516,0.0351-0.0106,0.089-0.024,0.17684-0.0412,0.26351-0.0435,0.2354-0.0309,0.49189-0.0183,0.72964,0.0009,0.034,0.0321,0.39468,0.0711,0.1909,0.16049-0.87369,0.19718-1.9137-0.2396-2.7101-0.0263-0.0515-0.0631,0.33495-0.0642,0.37243-0.005,0.17099-0.0504,0.49657,0.0367,0.65468'/%3E %3Cpath d='m707.18,294.27c-0.21092,0.66171-0.35194,1.3351-0.46542,2.0214-0.039,0.23658-0.0333,0.48955-0.0183,0.72847,0.00091,0.0328,0.0367,0.39585,0.0711,0.1909,0.10771-0.64883,0.24073-1.2859,0.44135-1.9137,0.0631-0.1991,0.0402-0.44973,0.0356-0.65468-0.003-0.048-0.0516-0.41459-0.0642-0.37243'/%3E %3Cpath d='m705.61,294.36c-0.95263,1.1665-2.2228,1.9406-3.5125,2.662-0.19947,0.11243,0.0791,1.0213,0,1.0658,1.2897-0.72143,2.5598-1.4956,3.5125-2.662,0.0872-0.10892,0.0516-0.40406,0.0516-0.53288,0-0.0539-0.0688-0.51298-0.0516-0.53288'/%3E %3Cpath d='m702.89,294.82c-0.58121,0.46261-1.2312,0.79756-1.927,1.0412-0.17081,0.0609,0.0309,1.0552,0,1.0658,0.6947-0.2436,1.3458-0.57972,1.927-1.0412,0.0906-0.0726,0.0516-0.43568,0.0516-0.53288,0-0.0351-0.0482-0.53523-0.0516-0.53288'/%3E %3Cpath d='m699.04,293.88c-0.56172,0.24946-1.1372,0.46613-1.6989,0.71676-0.15018,0.0656,0.0436,0.83504,0,0.85495,0.56171-0.24946,1.1372-0.46613,1.6989-0.71676,0.15017-0.0668-0.0447-0.83504,0-0.85495'/%3E %3Cpath d='m710.77,293.41c0.0106,0.69685,0.11923,1.3738,0.25106,2.0554,0.039,0.20144,0.0699-0.15577,0.0722-0.19207,0.0126-0.23541,0.0253-0.49541-0.0183-0.72847-0.0917-0.46729-0.19718-0.94044-0.20406-1.4183-0.0009-0.0445-0.0493-0.41459-0.0642-0.37126-0.0688,0.19324-0.039,0.45441-0.0367,0.65468'/%3E %3Cpath d='m712.58,292.58c0.009,0.81513,0.0882,1.5998,0.37829,2.3658,0.0161,0.0445,0.0631-0.33027,0.0642-0.37244,0.006-0.19675,0.0344-0.46612-0.0367-0.65468-0.1605-0.42396-0.29692-0.87954-0.3015-1.3386,0-0.0363,0.008-0.53288-0.0528-0.53288-0.0595,0-0.0516,0.49658-0.0516,0.53288'/%3E %3Cpath d='m713.98,292.4c0.24304,0.34315,0.5193,0.81162,0.53077,1.2485,0.0009,0.0445,0.0482,0.41577,0.0631,0.37243,0.0711-0.19324,0.0412-0.45558,0.0367-0.65585-0.0172-0.73315-0.17539-1.3902-0.60184-1.9922-0.0367-0.0527-0.0642,0.33495-0.0653,0.37243-0.004,0.14991-0.0573,0.52234,0.0367,0.65468'/%3E %3Cpath d='m715.69,291.72c0.59841,0.13,1.1406,0.3736,1.5866,0.81045-0.007-0.007,0.0516-0.49072,0.0516-0.53288,0-0.11243,0.039-0.44388-0.0516-0.53288-0.44595-0.43685-0.98703-0.68045-1.5866-0.81045-0.008-0.002-0.14215,1.0353,0,1.0658'/%3E %3Cpath d='m716.6,290.33c0.70043,0.58441,1.4742,1.0212,2.3776,1.1571,0.0286,0.005,0.12495-1.0458,0-1.0658-0.90333-0.13586-1.6771-0.5727-2.3776-1.1571-0.00091-0.001-0.0528,0.49657-0.0528,0.53288,0,0.10072-0.039,0.45675,0.0528,0.53288'/%3E %3Cpath d='m718.52,285.7c0.61444,0.007,1.2117,0.10891,1.8124,0.23189,0.0126,0.002,0.13986-1.0376,0-1.0658-0.6007-0.12297-1.198-0.22486-1.8124-0.23189-0.0756-0.001-0.0826,1.0658,0,1.0658'/%3E %3Cpath d='m717.63,283.49c0.36798-0.60315,0.92283-1.047,1.4582-1.4862,0.0906-0.0738,0.0528-0.43216,0.0528-0.53171,0-0.0363-0.0516-0.53406-0.0528-0.53288-0.5491,0.44972-1.1085,0.90531-1.4868,1.5237-0.0906,0.14757-0.0412,0.49189-0.0367,0.65468,0.0009,0.0363,0.0333,0.42396,0.0653,0.37243'/%3E %3Cpath d='m715.94,281.35c0.10665-0.70504,0.33589-1.3293,0.76692-1.895,0.0872-0.11477,0.0528-0.39936,0.0528-0.53288,0-0.0574-0.0722-0.50828-0.0528-0.53288-0.46428,0.61018-0.70502,1.2801-0.81964,2.0402-0.0356,0.23892-0.0321,0.48838-0.0195,0.72964,0.004,0.0305,0.0412,0.39585,0.0722,0.1909'/%3E %3Cpath d='m714.57,280.36c0.69814-0.98261,1.1658-2.1081,1.8124-3.1247,0.0917-0.14406,0.0412-0.49658,0.0367-0.65586-0.00091-0.0363-0.031-0.42396-0.0653-0.37126-0.64541,1.0166-1.1143,2.1421-1.8124,3.1247-0.094,0.13234-0.0402,0.50477-0.0356,0.65468,0.00091,0.0363,0.0275,0.42397,0.0643,0.37244'/%3E %3Cpath d='m711.45,276.86c0.0263,1.1958,0.11007,2.3903,0.3634,3.5592,0.0447,0.20027,0.0698-0.15226,0.0722-0.1909,0.0149-0.23306,0.031-0.49892-0.0183-0.72847-0.21093-0.96387-0.29576-1.9371-0.3164-2.9232-0.0161-0.7472-0.10666-0.0562-0.1009,0.28343'/%3E %3Cpath d='m706.39,277.7c0.18342,0.43333,0.42301,0.83972,0.63853,1.2567,0.13526,0.26234,0.25678,0.52936,0.3634,0.80459,0.039,0.10423,0.0722,0.20964,0.10207,0.31738-0.0653-0.21666,0.047-0.15927-0.0848,0.0668-0.14444,0.24829,0.0951,0.91234,0.0286,1.0271,0.30723-0.52936,0.25908-1.3878,0.12037-1.9664-0.21781-0.91937-0.77839-1.6771-1.1418-2.5332,0.0631,0.14639-0.14446,0.74954-0.0264,1.0271'/%3E %3Cpath d='m705.38,279.78c-0.69242-0.69567-1.4777-1.2766-2.2652-1.8516-0.007-0.005-0.0528,0.50009-0.0528,0.53288,0,0.0914-0.0379,0.46613,0.0528,0.53171,0.78755,0.57622,1.5717,1.1571,2.2652,1.8528-0.008-0.008,0.0516-0.49071,0.0516-0.53287,0-0.11361,0.0402-0.44153-0.0516-0.53289'/%3E %3Cpath d='m708.69,280.89c0.46886-2.3376,0.37944-4.6776-0.57892-6.8771,0.0631,0.14405-0.14788,0.75188-0.0286,1.0271,0.69814,1.6022,0.90792,3.1727,0.55483,4.9294-0.047,0.23306-0.0321,0.49423-0.0195,0.72964,0.003,0.0351,0.0321,0.39351,0.0723,0.1909'/%3E %3Cpath d='m713.65,277.83c0.078,0,0.078-1.0658,0-1.0658s-0.078,1.0658,0,1.0658'/%3E %3Cpath d='m708.04,280.99c0.12266-1.3211,0.43447-2.6152,0.56631-3.9363,0.0379-0.37126,0.0355-0.75775,0-1.129-0.0253-0.27054-0.0826-0.26937-0.11123,0-0.13299,1.3199-0.4425,2.6129-0.56631,3.9351-0.0344,0.3736-0.0356,0.75774,0,1.1302,0.0263,0.2682,0.086,0.27054,0.11124,0'/%3E %3Cpath d='m722.38,289.21c1.1464,0.37595,2.2778,1.1536,2.8109,2.2861,0.0355,0.0738,0.0951-0.50009,0.0963-0.55865,0.008-0.27405,0.0677-0.72378-0.0539-0.98261-0.54682-1.1571-1.6806-1.9582-2.8533-2.3435,0.0379,0.0129-0.25106,1.5167,0,1.5986'/%3E %3Cpath d='m718.5,297.17c0.20521,0.68162,0.2224,1.3094,0.0951,2.0121-0.0642,0.35252-0.0482,0.73666-0.0286,1.0927,0.004,0.0515,0.0528,0.59261,0.10889,0.28693,0.28888-1.5928,0.33702-3.3718-0.13183-4.933-0.0183-0.0586-0.0951,0.48721-0.0975,0.55865-0.009,0.31036-0.0367,0.68045,0.0539,0.98261'/%3E %3Cpath d='m715.27,295.01c0.005,1.3222,0.078,2.6363-0.18801,3.9398-0.071,0.34784-0.0482,0.74135-0.0264,1.0939,0.004,0.0539,0.0447,0.58909,0.10665,0.28693,0.35881-1.7532,0.27285-3.5416,0.2648-5.3206,0-0.055,0.0126-0.79874-0.078-0.79874-0.0894,0.001-0.0791,0.74369-0.0791,0.79874'/%3E %3Cpath d='m713.63,296.44c-0.45625,1.7544-0.90792,3.51-1.2656,5.289-0.0688,0.34901-0.0482,0.74135-0.0275,1.0939,0.004,0.0539,0.047,0.5891,0.10889,0.28694,0.34505-1.7251,0.78297-3.4268,1.2255-5.1285,0.11808-0.45206-0.11241-1.2695-0.0412-1.5412'/%3E %3Cpath d='m715.84,297.56c0.0149,1.5061,0.18915,3.0275,0.023,4.5277-0.0412,0.37009-0.0356,0.76008,0,1.1302,0.0263,0.27171,0.0802,0.26703,0.11006,0,0.21208-1.8914,0.0424-3.763,0.0241-5.6579,0-0.055,0.0126-0.79873-0.078-0.79873s-0.0791,0.74369-0.0791,0.79873'/%3E %3Cpath d='m705.23,298.36c0.0309-0.4755,0.0263-0.57036-0.0137-0.28577-0.0207,0.10423-0.0504,0.2073-0.0838,0.30685-0.0561,0.17099-0.13757,0.33026-0.22355,0.48603-0.13182,0.23658-0.0619,0.72612-0.0551,0.98261,0.003,0.055,0.0539,0.63594,0.0963,0.55864,0.556-1.0037,0.51472-2.3212,0.35881-3.428-0.0435-0.30918-0.1043,0.23892-0.10665,0.28694-0.0219,0.36189-0.0229,0.73315,0.0275,1.0927'/%3E %3Cpath d='m709.89,295.2c0.30951,0.59847,0.28658,1.1196,0.28314,1.7767-0.00091,0.0539-0.0118,0.79873,0.0768,0.79873,0.0894,0,0.0768-0.74486,0.078-0.79873,0.008-1.1032,0.1238-2.3084-0.39779-3.3179-0.039-0.075-0.094,0.50243-0.0963,0.55864-0.005,0.26469-0.071,0.73667,0.0561,0.98261'/%3E %3Cpath d='m711.16,294.65c0.17196,0.1382,0.31868,0.29045,0.43677,0.48135,0.0516,0.0843,0.0884,0.17568,0.12265,0.2682,0.0367,0.0972,0.0504,0.38766,0.0435,0.0527,0.004,0.15811,0.0106,0.3209,0.0356,0.47784-0.0009-0.008,0.0263,0.17684,0.0607,0.0808,0.10431-0.29045,0.0619-0.68162,0.0561-0.98378-0.0161-0.77766-0.12724-1.4745-0.75545-1.9758-0.0253-0.0199-0.0573,0.25883-0.0551,0.23423-0.0195,0.18856-0.024,0.37712-0.024,0.56568,0,0.18738,0.005,0.37711,0.024,0.5645,0.005,0.0469,0.005,0.19324,0.0551,0.23423'/%3E %3Cpath d='m712.73,293.23c0.2522,0.50829,0.54108,0.99666,0.79328,1.505,0.0402,0.082,0.0585-0.0679,0.0607-0.0808,0.0241-0.15694,0.0298-0.31856,0.0355-0.47784,0.005-0.20495,0.004-0.4099-0.009-0.61603-0.006-0.10072,0.0009-0.27054-0.047-0.36657-0.25219-0.50829-0.54108-0.99667-0.79213-1.505-0.0412-0.082-0.0573,0.0679-0.0607,0.0808-0.0253,0.15694-0.031,0.31856-0.0356,0.47784-0.005,0.20495-0.004,0.41107,0.008,0.61486,0.006,0.10189-0.0009,0.27171,0.047,0.36774'/%3E %3Cpath d='m716.24,291.96c0.61904,0.88188,1.2599,1.7486,1.9465,2.5754-0.023-0.0281,0.078-0.72027,0.078-0.79874,0-0.19207,0.0561-0.63945-0.078-0.7999-0.67293-0.80928-1.3-1.6549-1.9053-2.518-0.0539-0.0785-0.0951,0.5036-0.0963,0.55865-0.006,0.22603-0.086,0.78234,0.0551,0.98261'/%3E %3Cpath d='m718.05,288.95c0.47001,0.82684,1.0111,1.6057,1.6061,2.3435-0.024-0.0304,0.078-0.71909,0.078-0.79873,0-0.19441,0.0551-0.63477-0.078-0.79991-0.58122-0.71909-1.1074-1.4792-1.5659-2.2861-0.0424-0.0773-0.094,0.5036-0.0963,0.55864-0.006,0.25298-0.0768,0.74955,0.0561,0.98261'/%3E %3Cpath d='m700.4,280.9c-0.52389-0.42162-1.081-0.78234-1.6989-1.0412-0.0412-0.0187-0.078,0.75891-0.078,0.79873,0,0.0996-0.047,0.7472,0.078,0.79874,0.6179,0.25999,1.175,0.61954,1.6989,1.0423,0.004,0.002,0.078-0.7472,0.078-0.7999,0-0.14757,0.0585-0.68865-0.078-0.79874'/%3E %3Cpath d='m705.93,279c0.039,0.0902,0.0735,0.18036,0.10666,0.27288,0.0219,0.0668,0.0402,0.13468,0.0551,0.20378,0.0183,0.12649,0.0218,0.12883,0.0106,0.007,0.003,0.15811,0.0118,0.32207,0.0367,0.47784-0.003-0.009,0.0253,0.17684,0.0596,0.0796,0.10431-0.29045,0.0607-0.68045,0.0549-0.98261-0.008-0.54928-0.0619-1.0939-0.28086-1.5998-0.0379-0.0878-0.0607,0.0761-0.0607,0.0808-0.0253,0.15693-0.0309,0.31855-0.0355,0.47783-0.0106,0.28343-0.0642,0.71441,0.0539,0.98261'/%3E %3Cpath d='m710.29,274.85c0.0263,1.0505-0.086,2.1526-0.62478,3.0685-0.13413,0.2272-0.0631,0.73432-0.0551,0.9826,0.0009,0.055,0.0504,0.63595,0.0963,0.55748,0.84717-1.4394,0.77838-3.4128,0.73482-5.0337-0.003-0.0656-0.0735-0.62306-0.0963-0.55747-0.10313,0.28927-0.0631,0.68279-0.0549,0.9826'/%3E %3Cpath d='m711.27,280.76c0.92855-0.62306,1.5636-1.5787,2.06-2.5754,0.12496-0.25063,0.0619-0.71441,0.0551-0.98261-0.00091-0.0562-0.0585-0.6336-0.0963-0.55864-0.4872,0.97909-1.1074,1.9066-2.0188,2.518-0.13412,0.0913-0.078,0.66757-0.078,0.79991,0,0.0468,0.0619,0.81045,0.078,0.79873'/%3E %3Cpath d='m713.99,280.65c0.31869-0.33261,0.58924-0.70855,0.90678-1.0412,0.0482-0.0515,0.0482-0.17333,0.0561-0.23423,0.0183-0.18739,0.023-0.37711,0.023-0.56567s-0.005-0.37712-0.023-0.5645c0.003,0.0258-0.0344-0.25649-0.0561-0.23424-0.31754,0.33261-0.58809,0.70856-0.90678,1.0412-0.0493,0.0515-0.0493,0.17333-0.0551,0.23423-0.0195,0.18856-0.0229,0.37712-0.0229,0.56567,0,0.18739,0.004,0.37712,0.0229,0.56451-0.003-0.0269,0.0355,0.25531,0.0551,0.23423'/%3E %3Cpath d='m718.07,281.36c-1.0214-0.004-2.0417-0.014-3.0585-0.11594-0.0698-0.007-0.16623,1.5822,0,1.5986,1.0168,0.10071,2.0371,0.11243,3.0585,0.11594,0.11464,0.001,0.11809-1.5986,0-1.5986'/%3E %3Cpath d='m717.16,285.04c1.3584,0.81514,2.6756,1.6994,4.0799,2.4302-0.10771-0.0562,0.29346-1.444,0-1.5975-1.4043-0.73198-2.7215-1.615-4.0799-2.4313,0.12954,0.0785-0.30492,1.4159,0,1.5986'/%3E %3Cpath d='m717.28,287.82c1.2106,0.77063,2.5335,1.3632,3.626,2.3154-0.003-0.001,0.0768-0.74369,0.0768-0.7999,0-0.15577,0.0585-0.67928-0.0768-0.79874-1.0925-0.95215-2.4154-1.5448-3.626-2.3154-0.0207-0.0118-0.078,0.7554-0.078,0.79991,0,0.12531-0.0561,0.71206,0.078,0.79873'/%3E %3Cpath d='m709.48,282.01c0.17425-0.58324,0.17081-1.2086,0.17081-1.8118,0-0.055,0.0117-0.79873-0.078-0.79873-0.0906,0-0.0791,0.74369-0.0791,0.79873,0,0.21901,0.003,0.034,0.005,0.002-0.007,0.0914-0.0333,0.18036-0.0596,0.2682-0.0906,0.30333-0.0631,0.67107-0.0551,0.9826,0.005,0.15928,0.009,0.3209,0.0356,0.47784-0.003-0.0188,0.0286,0.18504,0.0607,0.0808'/%3E %3Cpath d='m699.94,277.75c1.0638,1.3023,2.4119,2.2451,3.7222,3.2652,0.97096,0.7554,1.6886,2.0413,2.7375,2.6375-0.12152-0.0679,0.30035-1.4265,0-1.5975-0.9446-0.53756-1.5751-1.6759-2.4142-2.3786-1.3837-1.1606-2.8854-2.1058-4.0444-3.5252,0.19488,0.24009-0.29346,1.2403-0.0009,1.5986'/%3E %3Cpath d='m702.21,282.06c-0.64195-0.66053-1.23-1.3691-1.8124-2.0835-0.0183-0.0211-0.0596,0.26-0.0573,0.23423-0.0172,0.18739-0.023,0.37595-0.023,0.56451,0,0.19324-0.0549,0.63594,0.0791,0.7999,0.58234,0.71441,1.1704,1.4218,1.8124,2.0835-0.0137-0.014,0.0768-0.73314,0.0768-0.7999,0.0009-0.17333,0.0595-0.6582-0.0756-0.79874'/%3E %3Cpath d='m700.94,292.62c-0.4276,0.77531-0.78871,1.5904-1.339,2.2861-0.13183,0.16747-0.078,0.60315-0.078,0.7999,0,0.082,0.10431,0.76594,0.078,0.79874,0.56401-0.71676,0.94002-1.5471,1.3791-2.3435,0.13069-0.23657,0.0631-0.72612,0.0561-0.9826-0.0009-0.055-0.0539-0.63594-0.0963-0.55865'/%3E %3Cpath d='m702.13,294.22c-0.0195,0.88892-0.32328,1.7755-0.43333,2.6562-0.0458,0.36891-0.0355,0.76242,0,1.1313,0.0275,0.27406,0.078,0.26351,0.11124,0,0.13986-1.1349,0.44823-2.2112,0.47344-3.3624,0.007-0.30099,0.0482-0.69333-0.0551-0.98378-0.0217-0.0644-0.0951,0.49306-0.0963,0.55864'/%3E %3Cpath d='m706.31,301.57c0.75545-2.5274,0.67292-5.1988,0.62133-7.8117-0.0219-1.122-0.1605-0.0843-0.15133,0.42396,0.039,1.9781,0.0596,3.9351-0.51127,5.8465-0.13183,0.44504,0.11922,1.2813,0.0412,1.5413'/%3E %3Cpath d='m708.76,295.43c0.28774,0.8772,0.3462,1.6759,0.20864,2.5906-0.0551,0.35838-0.0493,0.73198-0.0275,1.0939,0.003,0.0469,0.0595,0.59378,0.10665,0.28576,0.27398-1.8094,0.33245-3.7559-0.24533-5.5115-0.0207-0.0621-0.094,0.49072-0.0963,0.55864-0.0106,0.30333-0.0435,0.68631,0.054,0.98261'/%3E %3Cpath d='m711.16,294.54c0.88269,1.0798,1.1498,2.5133,1.065,3.8906-0.0149,0.26117,0.0744,1.7907,0.13528,0.80693,0.12609-2.0823,0.18226-4.605-1.2002-6.2962,0.0241,0.0293-0.078,0.71909-0.078,0.7999,0,0.19207-0.0549,0.63595,0.078,0.79874'/%3E %3Cpath d='m711.82,293.47c0.5514,2.2978,0.97785,4.6156,1.2129,6.9708,0.0619,0.6254,0.12953-0.92288,0.11123-1.1302-0.24991-2.4934-0.697-4.9482-1.2816-7.3818,0.0665,0.27874-0.1513,1.0857-0.0424,1.5412'/%3E %3Cpath d='m714.09,292.89c1.0065,1.3878,1.8858,2.8506,2.3787,4.5148,0.0183,0.0574,0.094-0.48721,0.0951-0.55865,0.0106-0.31153,0.0356-0.67927-0.0549-0.9826-0.49294-1.6631-1.3711-3.127-2.3787-4.5148,0.0975,0.13469-0.282,1.211-0.0402,1.5413'/%3E %3Cpath d='m718.77,289.03c-0.46543-0.8081-1.4548-0.90765-2.287-0.83855-0.15706,0.0129-0.0756,1.6045,0,1.5986,0.78755-0.0656,1.7998,0.008,2.2446,0.78116,0.0447,0.0773,0.0951-0.5036,0.0975-0.55864,0.005-0.2518,0.078-0.75189-0.0549-0.98261'/%3E %3Cpath d='m716.37,288.4c1.4673-0.21315,2.9393-0.23071,4.4181-0.23189,0.11922,0,0.11922-1.5975,0-1.5975-1.4777,0-2.9496,0.0176-4.4181,0.23071-0.18457,0.0269-0.0458,1.6068,0,1.5986'/%3E %3Cpath d='m719.09,276.27c-1.1739,1.4042-1.7964,3.3109-2.1918,5.0864-0.0768,0.34316-0.0482,0.74487-0.0275,1.0927,0.004,0.0586,0.0402,0.58676,0.10665,0.28694,0.37601-1.6865,1.0008-3.5358,2.1139-4.8674,0.13413-0.16045,0.078-0.60901,0.078-0.79991,0-0.0773-0.10208-0.7718-0.0791-0.79873'/%3E %3Cpath d='m712.71,277.64c0.21895,1.3504,0.7738,2.5953,1.1521,3.9,0.0172,0.0574,0.094-0.48603,0.0951-0.55864,0.009-0.31271,0.0344-0.67811-0.0539-0.98261-0.36225-1.2508-0.90448-2.4454-1.1143-3.7384-0.0493-0.30802-0.10431,0.23775-0.10666,0.28693-0.0207,0.35838-0.0298,0.7355,0.0275,1.0927'/%3E %3Cpath d='m711.5,279.97c-0.52961-0.65702-0.979-1.3515-1.2243-2.1702-0.031-0.10423-0.0642,0.0984-0.0607,0.0796-0.0253,0.15694-0.031,0.31973-0.0355,0.47784-0.009,0.31152-0.0356,0.68044,0.0549,0.98377,0.25106,0.84207,0.72336,1.553,1.2656,2.2276,0.0183,0.0211,0.0573-0.26117,0.0551-0.23423,0.0195-0.18856,0.024-0.37712,0.024-0.56568,0-0.19324,0.0551-0.63243-0.0791-0.79873'/%3E %3Cpath d='m709.35,281.02c-1.778-0.57622-3.4804-1.2859-4.9867-2.4302,0.16393,0.12297-0.31182,1.3586,0,1.5975,1.5052,1.1454,3.2087,1.854,4.9867,2.4313-0.0367-0.0118,0.24991-1.5178,0-1.5986'/%3E %3C/g%3E %3Cg stroke-width='0.001159'%3E %3Cpath fill='%23d9c0b9' stroke='%23000' stroke-width='0.5481' d='m670.35,297.23s-2.953-5.0817,5.2389-7.5716c0,0,2.4762,1.348,3.0482,2.2814,0,0-1.4284,2.3857-6.0964,3.0087,0,0-2.0956,0.62189-2.1907,2.2814z'/%3E %3Cpath fill='%235e3f17' d='m675.77,290.98c-1.3401,0.81981-3.4494,0.83035-3.8678,2.6808-0.006,0.0258,0.004,0.12649,0.007,0.11477,0.41727-1.8434,2.5323-1.8493,3.861-2.6621,0.0253-0.0176-0.0118-0.12648,0-0.13351'/%3E %3Cpath fill='%23d9c0b9' stroke='%23000' stroke-width='0.5481' d='m671.21,296.4s3.297,0.69567,5.5232-0.93342c1.825-1.3351,2.4773-0.72612,2.953-0.62189,0,0,0.0963-1.6595-1.0478-2.9045,0,0-2.3145,1.9114-4.0295,2.4302-1.7127,0.51883-2.8728,0.34667-3.399,2.0296z'/%3E %3Cpath fill='%23dba05f' stroke='%23000' stroke-width='0.5481' d='m711.3,280.57s-7.049,1.2063-8.9084,1.6326c-1.8594,0.42631-6.0689,0.85261-7.5362,0.85261-1.4685,0-3.72-1.1723-5.2859-1.4921-1.5659-0.31973-6.6558-0.85261-8.5152,1.0658s-3.0344,2.5578-3.6214,3.1973c-0.58695,0.63946-2.945,2.7312-3.0379,3.6576-0.0928,0.92522,0.59153,2.3107,1.7654,2.3107,1.175,0,3.6432,2.4993,3.6397,3.0216-0.006,0.87135,3.2236,1.8094,6.2683,1.7919,5.4899-0.0304,8.1919-2.8003,16.422-1.8294,4.4812,0.52819,12.724-2.9841,14.193-5.1156,1.4674-2.1315,2.3489-4.3696,0.88042-6.8209-1.4685-2.4512-5.8694-2.1994-6.2638-2.2721z'/%3E %3Cpath fill='%23000' d='m681.79,288.47c0.00091,0-0.0183,0.15576-0.0504-0.0855l-0.0412-0.18856-0.0493-0.13-0.009-0.14405c-0.0321-0.0504,0.14787,0.0351,0.71648-0.52469,0.003,0.0106,0.17195-0.26819,0.48033-0.7308-0.0333,0.0211,0.70042-0.91117,1.778-1.1583,1.0741-0.25063,2.068-0.0703,2.2056-0.0621,0.0458-0.0597-2.436-0.0867-2.5988,0.20379,0.007-0.19442,2.3936-0.2764,2.5208-0.11009,0.0309-0.0562-2.248-0.075-2.4177,0.23774-0.003-0.14171,2.068-0.24126,2.2927-0.0504,0,0-0.38518-0.0433-0.4895-0.0328l0.17998,0.0316-0.29004-0.004-0.16737-0.0164c0-0.005,0.45397,0.055,0.48377,0.096,0.003,0.007,0.20406-0.0574-0.60642-0.014,0.003,0.002-0.49638-0.0914-1.3034,0.16631-1.0604,0.15459-1.0272,1.594-2.6344,2.5157'/%3E %3Cpath fill='none' stroke='%23939598' d='m681.62,287.87c0.094,0.008,0.78526-0.27171,1.4479-1.4991-0.18799-0.33496,2.4899-1.3785,2.7673-1.0435,0.0118-0.0106,0.73023,0,1.1498,0.0679'/%3E %3Cpath fill='none' stroke='%23000' d='m684.27,285.55c-0.27284-0.0375-1.6324,1.1079-1.5086,1.1723-0.29346,0.70387-1.057,1.1641-1.1452,1.1454'/%3E %3Cpath fill='none' stroke='%23000' d='m684.38,285.72c0-0.089,1.8388-0.26468,2.2022-0.12765'/%3E %3Cpath fill='none' stroke='%23939598' d='m684.04,286.21c-0.0504-0.19207,1.9144-0.45909,2.0967-0.32558'/%3E %3Cpath fill='%23000' d='m686.09,287.46s0.0826,0.0504-0.0298-0.0609l-0.0838-0.096-0.0493-0.082-0.0699-0.0609s-0.0619,0.0258-0.55483,0.46261c-0.003-0.004-0.21552,0.16045-0.47001,0.39936-0.006-0.0211-0.47804,0.39703-1.0065,0.68631-0.56286,0.0831-1.3779,0.44855-1.3779,0.59378-0.0493-0.21784,1.6164-0.65468,1.5923-0.68162,0.11922,0.0785-1.4765,0.37126-1.5063,0.69567-0.0573-0.19558,1.4639-0.57738,1.527-0.58207,0.078,0.089-1.3412,0.32324-1.3837,0.63009,0.003,0.008,0.19488-0.19324,0.27283-0.19676l-0.0997,0.075c0.0493-0.0492,0.11581-0.0586,0.17769-0.082l0.1043-0.048c-0.003,0.002-0.28314,0.12532-0.27398,0.18388,0.0137,0.0316-0.16164-0.0176,0.36684-0.16045,0.007,0.0504,1.3424-0.27054,2.8648-1.6759'/%3E %3Cpath fill='none' stroke='%23939598' d='m685.84,287.12c-0.009-0.0222-0.58923,0.57855-1.1957,1.006,0.005,0.10072-1.2427,0.8327-1.5694,0.74486-0.0207-0.0386-0.53305,0.21549-0.74628,0.47666'/%3E %3Cpath fill='none' stroke='%23000' d='m683.99,288.6c0.0951-0.0937,0.88155-0.63009,0.88155-0.63595,0.27971-0.29747,0.97327-0.85026,0.97442-0.85143'/%3E %3Cpath fill='none' stroke='%23000' d='m684.02,288.74c0.0653,0.0644-1.1704,0.23424-1.3676,0.53171'/%3E %3Cpath fill='none' stroke='%23939598' d='m684.37,288.71c0.0791,0.15928-1.3218,0.53288-1.3791,0.57504'/%3E %3Cpath fill='%23c6262c' stroke='%23000' stroke-width='0.5481' d='m688.04,281.76s-0.0986-2.2381-2.2515-3.0907c-2.1529-0.85261-4.6015-0.95919-5.4808-0.85261-0.88155,0.10657-1.0272,0.50009-2.1276,0.67693-1.1016,0.17568-2.2755,0.70856-2.2755,0.70856s0-0.10657-0.58807,0.95918c-0.58809,1.0658-1.5648,1.5986-1.0753,2.5578,0.48835,0.95918,0.16393,1.1267,0.76691,1.3094,0.60299,0.1827-0.29919-0.32676-0.29919-0.32676s-3.7727,1.2157-2.8544,3.5264c0.91823,2.3119,1.8376,1.4476,2.1116,1.4007,0.27513-0.048,2.1345-1.0072,2.1345-1.0072l3.0562-2.8565s3.5985-1.4066,3.9894-1.5131c0.3932-0.10658,2.0967,0.0398,2.0967,0.0398l2.7971-1.5319z'/%3E %3Cpath fill='%23000' d='m685.31,287.01c0,0.55747-0.5663,1.2777-1.2656,1.608-0.70044,0.32909-1.2679,0.14522-1.2679-0.41225,0-0.55865,0.56631-1.2789,1.2656-1.6092,0.69928-0.3291,1.2679-0.14523,1.2679,0.41342'/%3E %3Cpath fill='%235e3f17' d='m708.62,292.91c0.68323-0.11595,1.3642-0.46495,2.0463-0.92874'/%3E %3Cg fill='%23842116'%3E %3Cpath d='m674.86,285.06c0.57664,0.0106,1.253,0.31388,1.1647,1.0213-0.0161,0.12297-0.0126,0.25414,0,0.37712,0.008,0.0914,0.0253,0.0878,0.0367,0,0.0539-0.43216,0.0745-0.92874-0.0917-1.3386-0.18457-0.45324-0.67291-0.58441-1.1097-0.59261-0.0367,0-0.0424,0.53288,0,0.53288'/%3E %3Cpath d='m677.63,286.13c0.27628-0.78234,0.21094-1.7087-0.26252-2.3927,0.0321,0.0468-0.0928,0.39937-0.0137,0.51297,0.29347,0.42397,0.44594,0.85144,0.26252,1.3656-0.0516,0.14523,0.0424,0.43333,0.0137,0.51414'/%3E %3Cpath d='m679.87,283.76c-0.14216-0.93225-0.46887-1.9687-1.3275-2.4524,0.0402,0.0222-0.0997,0.47549,0,0.53288,0.8357,0.47081,1.1647,1.471,1.3023,2.3786,0.0161,0.10305,0.0333-0.0785,0.0344-0.0949,0.007-0.11946,0.009-0.24478-0.009-0.36424'/%3E %3Cpath d='m681.84,283.28c0.12038-0.86783,0.0458-1.7942-0.67061-2.3751,0.0573,0.0457-0.10548,0.44738,0,0.53288,0.39778,0.32207,0.71991,0.8409,0.64426,1.3832-0.0172,0.11946-0.0161,0.24243-0.009,0.36306,0.0009,0.0164,0.0218,0.1991,0.0355,0.096'/%3E %3Cpath d='m678.54,280.37c1.9259-0.97675,5.8488-1.4101,7.3585,0.53639-0.0665-0.0831,0.0951-0.40873,0-0.53171-1.5098-1.9476-5.4326-1.5143-7.3585-0.53756-0.0975,0.0492,0.0355,0.51648,0,0.53288'/%3E %3C/g%3E %3Cg fill='%237a2e26'%3E %3Cpath d='m680.38,294.73c0.61446,0,1.2369,0.007,1.8399-0.13468,0.0722-0.0164,0-0.53288,0-0.53171-0.603,0.14054-1.2255,0.13351-1.8399,0.13351-0.039-0.001-0.039,0.53288,0,0.53288'/%3E %3Cpath d='m679.22,286.19c-0.50671,0.002-0.35424,0.61018-0.65803,0.86549-0.0458,0.0375-0.0263,0.21549-0.0263,0.26585,0,0.0187,0.0253,0.26703,0.0263,0.26703,0.30379-0.25414,0.16395-0.86315,0.65803-0.86549,0.0402,0,0.0379-0.53288,0-0.53288'/%3E %3Cpath d='m680.92,287.34c0.25564-0.47901,0.76119-0.67459,1.2163-0.90414,0.0974-0.048-0.0333-0.51531,0-0.53171-0.46313,0.23307-0.96868,0.43333-1.2289,0.92171-0.0424,0.0808-0.0219,0.24126-0.0195,0.32793,0.0009,0.0187,0.0195,0.21198,0.0321,0.18621'/%3E %3Cpath d='m683.13,290.28c0.41614,0.0328,0.74055-0.14523,0.98817-0.48135,0.0412-0.0586,0.0253-0.19793,0.0253-0.26586,0-0.0293-0.0367-0.25297-0.0253-0.26702-0.24875,0.33612-0.57203,0.51414-0.98817,0.48135-0.0263-0.002-0.0516,0.52819,0,0.53288'/%3E %3Cpath d='m684.87,289.66c0.67292-0.28342,1.1888-0.71207,1.5579-1.355,0.0447-0.0773,0.0219-0.2436,0.0195-0.32793,0-0.0176-0.0183-0.21198-0.0321-0.18621-0.36684,0.63828-0.87925,1.0564-1.5453,1.3363-0.0917,0.0387,0.024,0.52234,0,0.53288'/%3E %3Cpath d='m682.13,286.78c-0.38517,0.64883-1.1143,0.9791-1.5522,1.5858-0.0802,0.11127,0.0458,0.46964,0.0137,0.51414,0.43791-0.60783,1.1658-0.93576,1.5522-1.5858,0.0447-0.0761,0.0217-0.24594,0.0195-0.32792-0.003-0.0187-0.0183-0.21198-0.0333-0.18622'/%3E %3Cpath d='m683.32,295.28c1.3963,0.075,2.7444-0.1136,4.0925-0.48018,0.0768-0.0222-0.005-0.53171,0-0.53288-1.3493,0.36658-2.6974,0.55514-4.0925,0.48018-0.031-0.001-0.0482,0.53054,0,0.53288'/%3E %3Cpath d='m689.76,295.04c1.8239-1.3234,3.3623-2.4559,3.9584-4.7678,0.039-0.15108-0.0367-0.42279-0.0137-0.51297-0.59382,2.2943-2.1414,3.4385-3.9447,4.7479-0.10313,0.0749,0.0516,0.49541,0,0.53288'/%3E %3Cpath d='m690.85,291.87c1.2965-0.7718,2.224-1.9898,2.7352-3.4222,0.0516-0.14405-0.0424-0.43333-0.0137-0.51414-0.50784,1.4265-1.433,2.6363-2.7215,3.4034-0.10313,0.0597,0.0424,0.50711,0,0.53288'/%3E %3Cpath d='m690.23,283.8c0.99389-0.11946,2.0784,0.70622,2.7754,1.3457-0.0607-0.055,0.10431-0.43684,0-0.53288-0.69585-0.63946-1.7815-1.4651-2.7754-1.3457-0.0573,0.007-0.0195,0.53522,0,0.53288'/%3E %3Cpath d='m716.07,287.82c1.1315-1.8282,0.51358-4.1155-0.65801-5.7528,0.0321,0.0457-0.094,0.40288-0.0137,0.51414,0.99046,1.3843,1.6473,3.1294,0.65916,4.7245-0.0756,0.12063,0.0458,0.46027,0.0126,0.51414'/%3E %3Cpath d='m696.35,285.24c1.1418,0.82801,4.2863,2.9361,3.4276,4.6671-0.0665,0.13234,0.0458,0.44856,0.0137,0.51414,1.1762-2.3693-1.8605-4.5675-3.4414-5.7141,0.0505,0.0363-0.10431,0.45558,0,0.53288'/%3E %3Cpath d='m705.21,293.75c0.17997-0.4872,0.24303-0.99549,0.29347-1.5108,0.0126-0.12414,0.0126-0.2518,0-0.37595-0.0106-0.0902-0.0275-0.0902-0.0367,0-0.0458,0.46964-0.10548,0.92874-0.27055,1.3726-0.0355,0.0949-0.0207,0.22955-0.0183,0.32793,0.00091,0.0211,0.023,0.20846,0.0321,0.18621'/%3E %3Cpath d='m673.95,288.41c0.43676-0.64765,0.2969-1.5155-0.13069-2.1245,0.0321,0.0457-0.0928,0.40054-0.0149,0.51414,0.11464,0.15928,0.2098,0.3209,0.28545,0.50243,0.0928,0.22252-0.0332,0.41577-0.15361,0.59378-0.047,0.0691-0.0207,0.25063-0.0183,0.32793,0.0009,0.0188,0.0149,0.21198,0.0321,0.18621'/%3E %3Cpath d='m693.62,294.06c0.62018-0.39585,1.0546-0.98495,1.1934-1.7251,0.023-0.11712,0.0172-0.24595,0.009-0.36423,0-0.0176-0.0161-0.19676-0.0344-0.0949-0.13297,0.70738-0.57662,1.2742-1.1681,1.6513-0.10208,0.0656,0.0458,0.5036,0,0.53288'/%3E %3Cpath d='m696.57,293.82c0.26595-0.29396,0.36453-0.64765,0.37944-1.04,0.004-0.0984,0.0161-0.23189-0.0183-0.32676-0.008-0.0222-0.0321,0.16397-0.0321,0.18505-0.008,0.2272-0.18686,0.49189-0.329,0.64882-0.0447,0.0504-0.0253,0.20613-0.0253,0.26703-0.00091,0.0234,0.031,0.25883,0.0253,0.26585'/%3E %3Cpath d='m714.39,284.04c0.48492,0.85963,0.56401,1.8059,0.34735,2.7686-0.023,0.10423,0.0161,0.50829,0.0263,0.46027,0.27512-1.2192,0.26366-2.6363-0.36111-3.743,0.0344,0.0597-0.0837,0.38883-0.0126,0.51415'/%3E %3Cpath d='m712.61,285.85c0.35078,0.86783,0.32441,1.7708,0.22469,2.6902-0.008,0.0691,0.0137,0.58559,0.0367,0.37595,0.13298-1.218,0.21896-2.4208-0.24762-3.5803,0.031,0.0761-0.0698,0.37361-0.0137,0.51415'/%3E %3Cpath d='m710.94,287.4c0,0.64883,0.007,1.2976-0.21551,1.9137-0.0539,0.14406,0.0424,0.43451,0.0137,0.51414,0.27971-0.77062,0.25448-1.6185,0.25564-2.4278-0.00091-0.30216-0.0539-0.30216-0.0539,0'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='%23dcddde' stroke='%23000' stroke-width='0.2665' d='m694.56,275.41c-7.0731,0.40639-14.048-4.2923-14.048-4.2923-8.7617-1.7169-9.2718-9.6387-9.2718-9.6387-3.5056-1.3351-6.5205-10.337-6.5205-10.337-5.4303,3.2418-12.226,0.0352-12.226,0.0352s0-1.3351-6.1319,0c-6.1331,1.3351-5.0818-1.1442-5.0818-1.1442s2.4532-2.4805-8.4086,0c-10.862,2.4794,0.87697-3.243,0.87697-3.243-3.1536,0.95333-13.49,1.7169-13.49,1.7169-3.7933,0.17099-7.6428,2.0425-11.835,3.2371-2.6091,0.7437-7.0731,1.6104-9.3303,2.5742-6.0219,2.5742-18.091,8.1056-28.058,12.017-13.104,5.1426-23.489,9.0554-22.806,8.8903,0.8185-0.19792,14.23-8.6924,31.028-16.308,15.597-7.0738,33.501-13.619,42.528-16.183,11.714-3.8812,21.307-2.0273,26.749-0.0527,2.6275,0.95333,17.123-0.44622,23.604,0.31621,6.4827,0.76243,7.1579,11.422,7.1579,11.422,1.2266,0.76359,1.6645,10.778,1.6645,10.778s-3.5916,0.0949,0.6133,0.66756c4.2049,0.5727,11.913,6.6768,11.913,6.6768,2.6275,0,2.9255-0.0937,2.9255-0.0937s1.527-1.9242,3.6305-2.7288c2.1013-0.80576,4.0295-1.6115,6.3933-1.7895,2.365-0.18036,5.7043-0.20144,8.0681,0.0668,2.365,0.26937,5.1575,0.29045,8.4865,0.91702,3.3291,0.62657,3.6787,0.80576,4.7299,1.163,1.0512,0.35837,1.9924,0.12648,1.9924,0.12648,4.3287-1.8094,12.357-5.0067,14.205-4.6402,0,0,3.0287-0.76126,4.6576-2.0285,1.629-1.2672,5.3547-4.3111,5.3547-4.3111s-2.5713-18.106,15.823-16.332c18.395,1.7755,42.784,4.1366,47.674,4.8978,4.8881,0.76008,22.402,5.7633,26.593,7.7918,4.1911,2.0284,16.235,7.424,21.594,9.7944,2.1758,0.96153,10.463,4.6331,16.596,7.0551,9.203,3.6341,16.08,9.6879,16.08,9.6879-5.7674-2.4395-10.43-5.2292-14.998-7.2132-3.6947-1.6045-7.5591-2.3505-10.565-3.6856-6.3772-2.833-11.289-5.4131-15.154-7.2132-14.246-6.6347-14.115-6.9005-19.886-7.3526-3.9779-0.3127,2.8579,4.8521,2.8579,4.8521s-13.039-5.0711-17.23-6.8466c-4.19-1.7743-7.6829-2.5344-11.641-2.2814-3.9584,0.25415-6.986-0.50594-9.3131-1.2672-2.3283-0.76125-15.601-1.2672-17.93-1.5213-2.3271-0.25297-4.19-0.76009-4.19-0.76009l0.9309,1.5202-6.5194-1.0131-1.8629,2.7886s-6.2866,1.2672-6.7532-0.76126c-0.4654-2.0273-3.7257,9.1269-5.3558,12.424-1.6302,3.2957-9.0678,2.203-10.931,4.2314-1.8629,2.0285-5.8362,3.3858-6.7659,3.893-0.93201,0.50712-3.7566,0.2682-5.3868,0.2682-2.4257,0-0.3588,0.0363-4.3378,0.79288,0,0-3.4368-0.0328-4.7505-0.56919-1.3137-0.53756-4.2049-1.3691-5.6608-1.7848-1.9878-0.56919-13.047-0.82099-14.623-0.73081-1.5774,0.089-4.2438,0.90531-5.9955,1.6209-1.7505,0.71559-4.8182,2.5953-4.8182,3.0427'/%3E %3Cpath fill='%23452c25' d='m695.29,273.29s-0.74171,0.56919-0.92856,1.9922c-0.1857,1.4241-0.0928,0.85495-0.0928,0.85495'/%3E %3Cpath fill='%23574f4c' d='m731.03,271.21c0.93774,0.69918,1.9041,1.4101,2.7364,2.2428,0.0275,0.0293,0.29575,0.27405,0.20405,0.0773-0.10207-0.21549-0.27628-0.41576-0.44136-0.58207-0.92282-0.92405-1.9798-1.724-3.023-2.5004-0.17197-0.12883,0.0172,0.18505,0.039,0.21901,0.13413,0.19441,0.29348,0.40171,0.48491,0.54342'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23fff' width='900' height='600'/%3E %3Crect fill='%23006233' width='450' height='600'/%3E %3Cpath fill='%23d21034' d='M580,225a150,150 0 1,0 0,150 120,120 0 1,1 0-150m5,75-135-44 84,115v-142l-84,115z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Crect width='750' height='500' fill='%23fff'/%3E %3Crect width='325' height='200' fill='%23002d62'/%3E %3Crect width='325' height='200' y='300' fill='%23ce1126'/%3E %3Crect width='325' height='200' x='425' y='300' fill='%23002d62'/%3E %3Crect width='325' height='200' x='425' fill='%23ce1126'/%3E %3Cg transform='matrix(0.8,0,0,0.8,-25,0)'%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23fff' d='m474.5,281.05c0.0652,0.43268,0.0326,36.778,0.0326,40.539,0,3.5948,0.0422,5.8758,1.7514,8.1524,1.4074,1.9695,3.7673,3.5913,6.0751,4.1297,1.6305,0.33285,7.631,0.19971,9.718,0.19971,4.6352-0.21717,5.1883,0.81376,6.9424,3.1076,1.9946-3.2202,4.1878-3.2679,8.287-3.1076,2.0871,0,6.5546,0.16642,8.4136-0.233,2.217-0.52932,3.948-1.5887,5.3808-3.3617,2.348-2.696,2.2175-6.058,2.2175-9.5861v-38.312c0-1.7308-0.19568-1.2981,0.68479-2.1968l5.772-6.058-61.668,0.0333,6.3916,6.6902z'/%3E %3Cpath fill='%23002d62' d='m493.76,299.09,0-24.768-25.509,0,6.3326,6.6902,0.0597,18.078z'/%3E %3Cpath fill='%23ce1126' d='m503.98,299.09,0-24.768,25.986,0-6.631,7.108,0,17.66z'/%3E %3Cpath fill='%23ce1126' d='m493.76,309.32-19.299,0-0.0565,15.602c0.87384,6.8138,5.9126,9.1346,10.433,9.1125,3.0581,0.0321,4.0988-0.0213,8.9223-0.0552z'/%3E %3Cpath fill='%23002d62' d='m503.98,309.32,19.418,0-0.0629,15.602c-0.45606,6.7541-5.9126,9.1346-10.433,9.1125l-8.9223-0.0552z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='0.4544' d='m474.61,281.05c0.0652,0.43268,0.0326,36.778,0.0326,40.539,0,3.5948,0,5.7914,1.7936,8.3212,1.4074,1.9695,3.4297,3.5491,6.0329,3.9609,1.6305,0.33285,7.631,0.19971,9.718,0.19971,2.674,0,3.9133-0.13314,5.707,1.6642,0.55438,0.53255,0.68483,0.79883,1.1088,1.4645,0.22828-0.16642,0.22828-0.1997,0.35871-0.43268,0.58701-1.0651,1.5653-1.8972,2.674-2.3299,1.4022-0.56585,3.7502-0.36615,5.3808-0.36615,2.0871,0,6.5546,0.16643,8.4136-0.23299,2.217-0.52932,4.1801-1.9474,5.3808-3.3617,2.348-2.6961,2.2175-6.058,2.2175-9.5861v-38.312c0-1.7308-0.19567-1.2981,0.6848-2.1968l5.772-6.058-61.668,0.0333,6.3916,6.6902z'/%3E %3C/g%3E %3Cpath fill='%23eac102' stroke='%23000' stroke-width='0.2734' d='m497.92,280.41,0,2.773-2.7979,0,0,2.3456,2.7979,0,0,9.9264,2.3031,0,0-9.9264,2.8332,0,0-2.3456-2.8332,0,0-2.773z'/%3E %3Cg id='h'%3E %3Cg%3E %3Cpath fill='%23fff' d='m481.88,284.06,0.03,4.53-1.91-1.93,0.28,31.93c0,4.76,3.43,8.6,7.66,8.6,4.19,0,7.6-3.79,7.65-8.5l-0.31-16.44-2.06-2.13-0.03-1.68z'/%3E %3Cpath fill='%23002d62' d='m481.88,284.22,0.03,4.56-1.91-1.94,0.16,18.19,8.25,7.85,0.06-17.41-0.31-0.35v-2.93l-6.28-7.97z'/%3E %3Cpath fill='%23ce1126' d='m490.77,295.51,2.424,3.0788,0.016,1.0449-2.4462-2.5101z'/%3E %3Cpath fill='%23ce1126' d='m495.3,302.42,0.21797,11.442c-1.177,2.2102-3.5688,1.0123-3.5688,1.0123l0.076-15.791z'/%3E %3Cpath fill='%23002d62' d='m495.55,319.64c-3.1282,2.3386-3.9974-1.128-3.9974-1.128,2.3416-0.22719,3.4544-1.5964,3.9772-2.9779z'/%3E %3Cpath fill='%23ce1126' d='m480.21,309.72c4.2926,4.8716,7.965,7.5023,7.965,7.5023,0.96489,7.6676,5.4998,5.1206,7.1339,3.9248-0.92265,3.5955-3.8683,6.2232-7.3588,6.2232-4.2296,0-7.6595-3.8597-7.6595-8.6218z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='0.2619' d='m493.2,299.63-0.0176-1.1586-11.321-14.382,0.0293,3.9624z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='0.3168' d='m480,286.66,0.29392,31.922c0,4.7599,3.4284,8.6196,7.6562,8.6196,4.1958,0,7.6029-3.8011,7.6541-8.5113l-0.30981-16.445z'/%3E %3C/g%3E %3Cg fill='%23eac102' stroke='%23000' stroke-width='0.06394'%3E %3Cpath d='m486.17,281.23c-0.77767-1.4568-0.62186-2.0847-0.081-2.6414l-2.9334-3.0053,0.8167,4.1992c0.83917-0.21179,1.4251,0.00007,2.1978,1.4474z'/%3E %3Cpath d='m483.15,275.58,3.0021,5.6235'/%3E %3Cpath d='m498.07,300.74-0.7623,0.2925-11.924-20.421,0.70235-0.39514z'/%3E %3Cpath d='m484.98,280.59c-0.10238-0.18962,0.10746-0.50686,0.46853-0.70909,0.36106-0.20216,0.73627-0.21248,0.8387-0.0231,0.1024,0.18962-0.10747,0.50686-0.46854,0.70909-0.36105,0.20215-0.73627,0.21247-0.83869,0.0231z'/%3E %3Cpath d='m481.02,282.22c-0.95493-1.3423-0.87965-1.9856-0.4136-2.6089l-3.2879-2.5941,1.3396,4.0569c0.80541-0.32053,1.4131-0.18758,2.3619,1.146z'/%3E %3Cpath d='m477.32,277.02,3.6864,5.1816'/%3E %3Cpath d='m495.28,300.01-0.719,0.39045-14.401-18.682,0.6466-0.48435z'/%3E %3Cpath d='m479.76,281.75c-0.12544-0.17457,0.0426-0.51681,0.37514-0.76491,0.33252-0.24802,0.70328-0.30766,0.82874-0.13337,0.12546,0.17457-0.0426,0.51681-0.37514,0.76491-0.33253,0.24802-0.70329,0.30766-0.82874,0.13337z'/%3E %3Cpath d='m480.18,286.36c-1.0977-1.2238-1.0942-1.8716-0.70026-2.5446l-3.5545-2.199,1.7809,3.8767c0.76471-0.41118,1.3833-0.34903,2.4739,0.86681z'/%3E %3Cpath d='m475.93,281.61,4.2374,4.7241'/%3E %3Cpath d='m495.66,302.86-16.38-16.905,0.5889-0.5557,16.462,16.99z'/%3E %3Cpath d='m478.88,286.03c-0.144-0.15901-0.015-0.5184,0.28791-0.80319,0.30289-0.2847,0.66467-0.38664,0.80864-0.22791,0.14402,0.15901,0.015,0.51841-0.28791,0.80319-0.30289,0.28471-0.66467,0.38664-0.80864,0.22791z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='matrix(-1,0,0,1,998.257,0)'/%3E %3Cg stroke='%23000' stroke-width='0.2359'%3E %3Cpath fill='%23ce1126' d='m496.73,314.54-0.63423,10.104c-0.64064-0.0569-1.8765-0.16008-1.9693-0.98118-0.0524-0.46411,1.2625-8.7318,1.3126-9.5363,0.43648,0.12124,0.89314,0.32327,1.2909,0.41358z'/%3E %3Cpath fill='%23002d62' d='m495.77,314.12c-0.0629,0.39574-0.28285,2.8061-0.22002,3.0939,0.1886,0.97137,1.3829,0.82746,2.0429,0.86343l0.1257-5.1807c-0.22,0.21586-1.6971,1.1153-1.9486,1.2232z'/%3E %3Cpath fill='%23002d62' d='m495.88,327.04c1.664-2.0848,4.784-0.53555,4.784-0.53555,3.4147,0.76506,2.5653-3.1367,2.5653-3.1367-0.69331-7.8036-1.5204-13.144-1.5204-13.144l-4.9886,3.3317z'/%3E %3Cpath fill='%23002d62' stroke-width='0.1881' d='m495.86,327.17c-0.35961,2.317,1.9579,1.9774,1.9579,1.9774,2.7571-0.04,1.9679-2.9562,1.9679-2.9562-2.9569-0.84889-3.926,0.97874-3.926,0.97874z'/%3E %3Cpath fill='%23ce1126' d='m497.83,312.74c-0.17263,8.0717-0.24615,8.8947-0.24615,8.8947,0.11508,2.2123,2.5317,1.0164,2.5317,1.0164,0.57536-0.23917,1.2083-0.0598,1.2083-0.0598-0.11507-2.7504-0.11507-2.7504-0.11507-2.7504,4.0223-0.29834,3.0873-2.6392,3.0873-2.6392-1.6398-7.6233-1.7469-7.2905-1.7469-7.2905z'/%3E %3Cpath fill='none' stroke-width='0.2253' d='m501.31,319.81c-2.5367-0.04-3.568,0.95952-3.568,0.95952l-0.10313,0.21989'/%3E %3Cpath fill='%23fff' stroke-width='0.2094' d='m500.99,326.45-0.87502-15.193,1.7501-1.1724,1.5167,14.216,0,0.14655,0,0c0,2.6381-2.3917,2.0028-2.3917,2.0028z'/%3E %3C/g%3E %3Cg fill='%23fff' stroke='%23000'%3E %3Cpath fill='%23000' stroke-width='0.04238' d='m488.23,302.2,6.7879,12.45,14.63-9.7118-7.6204-11.249z'/%3E %3Cpath stroke-width='0.2723' d='m488.49,302.1,13.753-8.0135,7.5193,10.823-14.53,9.3466z'/%3E %3Cpath fill='%23000' stroke-width='0.03889' d='m495.43,313.53,13.697-8.8202-1.0532-1.6855-6.8618-9.3232-4.9619,4.008-6.3349,3.5098-1.116-0.69637,0.22291,1.4884z'/%3E %3Cpath stroke-width='0.1478' d='m496.18,297.77c-2.0262-0.9592-4.3793,2.0673-5.0572,2.6681-0.67812,0.60088-2.0409,0.24028-2.0409,0.24028l6.1791,11.086c1.823,0.72017,2.9988-1.6155,3.8456-2.3381,1.5531-1.3254,3.3767-1.2233,3.3767-1.2233z'/%3E %3Cpath stroke-width='0.1478' d='m496.36,297.88c0.006-2.3781,2.9517-3.1355,3.7383-3.5574,0.78651-0.42185,1.0325-1.9058,1.0325-1.9058l6.9276,10.563c-0.12673,2.0816-2.5916,2.2882-3.5502,2.8262-1.7582,0.9868-1.9975,2.5089-1.9975,2.5089z'/%3E %3Cpath stroke-width='0.105' d='m495.02,311.82c-3.9532-7.236-6.127-11.017-6.127-11.017-0.0935,1.3259-0.0192,1.2423-0.0192,1.2423,4.6102,7.429,6.4879,11.413,6.4879,11.413-0.10276-0.54832-0.22404-1.093-0.3417-1.6383z'/%3E %3Cg fill='%23000' stroke='none'%3E %3Cpath d='m490.87,302.2c0.0378,0.0618,0.0755,0.12351,0.11326,0.18527,0.0317-0.0175,0.0598-0.0491,0.0544-0.0879,0.006-0.0291-0.0321-0.066-0.0164-0.0856,0.01-0.005,0.0134,0.017,0.0205,0.0234,0.0432,0.0707,0.0864,0.14136,0.12962,0.21204-0.0245,0.021-0.0359-0.0369-0.0613-0.0407-0.0304-0.0283-0.0887-0.0226-0.10916,0.007,0.0342,0.0545,0.0657,0.11096,0.10255,0.16376,0.0207,0.0238,0.0505,0.003,0.0709-0.0104,0.0553-0.0309,0.10459-0.0846,0.10468-0.15141,0.0112-0.0265-0.0263-0.0675,0.002-0.0823,0.0227,0.0525,0.0455,0.10498,0.0682,0.15747-0.12937,0.0821-0.25874,0.16419-0.38811,0.24629-0.0149-0.0125,0.00057-0.0177,0.0116-0.0245,0.042-0.0215,0.0235-0.0698,0.0003-0.0979-0.0653-0.10629-0.12962-0.21323-0.19566-0.31907-0.0165-0.0341-0.0589-0.0235-0.0827-0.004-0.0106,0.007-0.0175-0.0162-0.002-0.0166,0.1215-0.0771,0.24301-0.15421,0.36451-0.23131,0.0274,0.0449,0.0549,0.0897,0.0823,0.13459-0.0249,0.0202-0.0405-0.0342-0.067-0.0384-0.0475-0.0277-0.10365-0.005-0.14526,0.0228-0.0195,0.012-0.0383,0.0252-0.0575,0.0378z'/%3E %3Cpath d='m491.27,301.92c0.0812,0.1326,0.16202,0.26539,0.24338,0.39786,0.0108,0.0281,0.0427,0.0377,0.0657,0.023,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0518,0.0329-0.10363,0.0658-0.15545,0.0986-0.0197-0.0197,0.0309-0.0294,0.0141-0.0555-0.0166-0.0377-0.041-0.0715-0.0617-0.10703-0.0528-0.0862-0.10534-0.17266-0.15837-0.25877-0.0108-0.0278-0.0424-0.0376-0.0652-0.0227-0.008-0.008-0.008-0.0142,0.003-0.018,0.0399-0.0253,0.0798-0.0505,0.11971-0.0758z'/%3E %3Cpath d='m491.79,301.56c0.0321,0.0498,0.0643,0.0996,0.0964,0.1494-0.023,0.0233-0.0372-0.0281-0.0617-0.0319-0.0566-0.0347-0.14047-0.0344-0.18523,0.0198-0.0326,0.0349-0.0193,0.10196,0.0307,0.11155,0.0585,0.0145,0.11863-0.003,0.17778-0.004,0.0565-0.003,0.12044,0.003,0.1604,0.0478,0.0495,0.0504,0.0537,0.13238,0.0188,0.19204-0.036,0.0645-0.10808,0.0997-0.17943,0.10761-0.0351,0.00096-0.0358,0.0405-0.0435,0.0603-0.01,0.0108-0.0127-0.009-0.0188-0.0151-0.031-0.0508-0.0621-0.10155-0.0931-0.15232,0.0216-0.0209,0.0355,0.0282,0.0572,0.0322,0.0587,0.0447,0.15042,0.0554,0.2084,0.004,0.0443-0.0326,0.0457-0.11263-0.009-0.13524-0.056-0.0233-0.11755-0.004-0.1756-0.003-0.0624,0.005-0.13497-0.003-0.17581-0.0567-0.0521-0.062-0.0391-0.16162,0.0211-0.21344,0.0362-0.0335,0.0847-0.0499,0.13327-0.0528,0.0356,0.003,0.0382-0.0335,0.0307-0.0549,0.003-0.002,0.005-0.004,0.008-0.006z'/%3E %3Cpath d='m492.3,301.83c-0.0146,0.0473-0.036,0.10043-0.0841,0.12212-0.0405,0.0183-0.0874-0.0116-0.0962-0.0531-0.0138-0.0523,0.0172-0.10151,0.0411-0.14569,0.0116-0.027,0.0394-0.0532,0.0438-0.0794-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0332-0.0225-0.0903,0.0136-0.0816,0.0529,0.0218,0.0154,0.0612,0.0215,0.0561,0.0577-0.002,0.0439-0.0638,0.068-0.0952,0.037-0.0326-0.0398-0.0122-0.0976,0.017-0.13316,0.032-0.0385,0.0748-0.0725,0.12523-0.081,0.0479-0.008,0.0911,0.0213,0.11071,0.0637,0.0326,0.052,0.0635,0.10508,0.0967,0.15669,0.009,0.0233,0.0404,0.0117,0.0361-0.0118,0.0277-0.003,0.01,0.0321,0.008,0.0478-0.0118,0.0377-0.0525,0.069-0.0928,0.0615-0.0149-0.004-0.0266-0.0145-0.0363-0.0254zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10507-0.0185,0.0376-0.0372,0.0817-0.0239,0.12389,0.0113,0.0433,0.0728,0.0362,0.0821-0.004l0.003-0.007,0.003-0.008,0.0005,0.00047z'/%3E %3Cpath d='m492.43,301.37c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10301,0.0847-0.11995,0.0449-0.0165,0.0921,0.0127,0.1142,0.0515,0.0404,0.0605,0.0755,0.1245,0.11579,0.18507,0.01,0.0249,0.0384,0.0181,0.0541,0.0147,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0506-0.0859-0.0759-0.12887-0.0194-0.0305-0.0361-0.063-0.0595-0.0907-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.1231,0.11301,0.18392,0.01,0.0239,0.0367,0.0302,0.0561,0.0242,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14345,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0597-0.0259-0.0485-0.0565-0.0944-0.0846-0.1416-0.0209-0.0328-0.039-0.0677-0.0635-0.0981-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0419-0.0265,0.0838-0.053,0.12563-0.0794z'/%3E %3Cpath d='m492.74,301.02c0.0234,0.0383,0.0468,0.0765,0.0702,0.11477,0.0245-0.0155,0.049-0.0311,0.0735-0.0466,0.007,0.0111,0.0135,0.0221,0.0203,0.0332-0.0245,0.0156-0.049,0.0311-0.0735,0.0467,0.0433,0.0703,0.0857,0.14117,0.12956,0.21115,0.0118,0.0332,0.0609,0.028,0.062-0.008,0.003-0.0147-0.004-0.0355,0.0168-0.0287,0.0108,0.0505-0.0128,0.10799-0.0625,0.12766-0.0438,0.0206-0.0987-0.002-0.11772-0.0457-0.0408-0.0654-0.0805-0.13137-0.12087-0.19702-0.0135,0.009-0.0269,0.0171-0.0404,0.0256-0.0165-0.0183,0.01-0.0397,0.0108-0.0601,0.0173-0.0532,0.0241-0.10963,0.0209-0.16545,0.004-0.002,0.007-0.005,0.011-0.007z'/%3E %3Cpath d='m493.05,300.97c0.0543-0.0356,0.13041-0.036,0.18278,0.004,0.057,0.0409,0.0962,0.10807,0.10048,0.17841,0.004,0.058-0.025,0.11647-0.0746,0.1472-0.0431,0.0307-0.1019,0.0414-0.15078,0.0181-0.1013-0.0425-0.16122-0.16937-0.12243-0.27349,0.0124-0.0311,0.0365-0.0562,0.0645-0.0738zm0.0158,0.023c-0.0438,0.0306-0.0101,0.0848,0.009,0.12028,0.0304,0.0534,0.0592,0.10899,0.10144,0.15423,0.0296,0.0377,0.0964,0.0101,0.0848-0.0383-0.008-0.0403-0.0331-0.0747-0.0524-0.11047-0.024-0.0391-0.0457-0.0807-0.0779-0.11391-0.0167-0.0158-0.0439-0.0281-0.0645-0.0118z'/%3E %3Cpath d='m491.4,303.06c0.0378,0.0618,0.0755,0.12351,0.11326,0.18526,0.0317-0.0175,0.0598-0.0491,0.0544-0.0879,0.006-0.0291-0.0321-0.066-0.0164-0.0856,0.01-0.005,0.0134,0.017,0.0205,0.0234,0.0432,0.0707,0.0864,0.14135,0.12962,0.21203-0.0245,0.021-0.0359-0.0369-0.0613-0.0407-0.0304-0.0283-0.0888-0.0227-0.10926,0.007,0.0342,0.0546,0.0657,0.11096,0.10255,0.16377,0.0207,0.0238,0.0505,0.003,0.0709-0.0104,0.0553-0.031,0.10459-0.0846,0.10468-0.15141,0.0111-0.0265-0.0262-0.0673,0.002-0.0823,0.0227,0.0525,0.0455,0.10499,0.0682,0.15748-0.12937,0.0821-0.25875,0.16419-0.38812,0.24628-0.0149-0.0125,0.00057-0.0177,0.0116-0.0245,0.042-0.0215,0.0235-0.0698,0.0003-0.0979-0.0653-0.10628-0.12961-0.21323-0.19566-0.31906-0.0164-0.0344-0.0589-0.0232-0.0827-0.004-0.0106,0.007-0.0175-0.0162-0.002-0.0166,0.1215-0.0771,0.24301-0.1542,0.36451-0.2313,0.0274,0.0449,0.0549,0.0897,0.0823,0.13458-0.0249,0.0202-0.0405-0.0342-0.067-0.0384-0.0475-0.0277-0.10369-0.005-0.14526,0.0229-0.0194,0.012-0.0382,0.0251-0.0573,0.0376z'/%3E %3Cpath d='m492.1,303.24c-0.0915-0.0637-0.18238-0.12825-0.2742-0.19144-0.021-0.0154-0.0492-0.0303-0.0733-0.0216-0.005-0.006-0.009-0.0124,0.00091-0.0154,0.0523-0.0332,0.10461-0.0664,0.15691-0.0996,0.008,0.009,0.0104,0.0165-0.004,0.0224-0.0226,0.0324,0.0236,0.0558,0.0452,0.0725,0.0394,0.0274,0.0789,0.0548,0.11835,0.0823-0.01-0.0562-0.0177-0.11273-0.0297-0.16847-0.002-0.0279-0.0269-0.0591-0.0558-0.0376-0.005,0.006-0.0177-0.0116-0.008-0.013,0.0322-0.0204,0.0644-0.0408,0.0965-0.0613,0.0189,0.0165-0.0147,0.0282-0.0104,0.0487,0.002,0.0458,0.0115,0.0909,0.0177,0.13626,0.012,0.0789,0.0239,0.15775,0.0359,0.23663-0.005,0.003-0.0107,0.006-0.0161,0.01z'/%3E %3Cpath d='m492.43,302.94c-0.0146,0.0473-0.036,0.10044-0.0841,0.12213-0.0405,0.0183-0.0874-0.0116-0.0962-0.0531-0.0138-0.0523,0.0172-0.10144,0.0411-0.1456,0.0116-0.027,0.0394-0.0532,0.0438-0.0794-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0331-0.0224-0.0903,0.0135-0.0818,0.0527,0.0214,0.0157,0.0614,0.0212,0.0561,0.0577-0.002,0.0439-0.0638,0.068-0.0952,0.037-0.0326-0.0397-0.0123-0.0975,0.0171-0.13306,0.0319-0.0385,0.0747-0.0725,0.12523-0.081,0.048-0.008,0.0911,0.0213,0.11071,0.0637,0.0326,0.052,0.0635,0.10506,0.0967,0.15667,0.009,0.0234,0.0403,0.0118,0.036-0.0117,0.0277-0.003,0.01,0.032,0.008,0.0478-0.0118,0.0377-0.0525,0.069-0.0928,0.0615-0.0147-0.004-0.0267-0.014-0.036-0.0255zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10507-0.0185,0.0376-0.0372,0.0817-0.0239,0.1239,0.0113,0.0433,0.0728,0.0364,0.0822-0.004l0.003-0.007,0.003-0.008,0.0004,0.00037z'/%3E %3Cpath d='m492.57,302.49c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10302,0.0847-0.12,0.0449-0.0164,0.0921,0.0127,0.11418,0.0516,0.0404,0.0605,0.0755,0.1245,0.11579,0.18509,0.01,0.0249,0.0384,0.0181,0.0543,0.0148,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0219-0.0443-0.0501-0.0851-0.0752-0.12768-0.0197-0.0309-0.0365-0.0638-0.0602-0.0918-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.12308,0.11299,0.18389,0.01,0.0239,0.0366,0.0303,0.0561,0.0243,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0596-0.0265-0.0493-0.0575-0.096-0.0862-0.14405-0.0204-0.032-0.038-0.066-0.0619-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0419-0.0265,0.0837-0.0531,0.12562-0.0796z'/%3E %3Cpath d='m493.02,302.21c0.0348-0.0221,0.0695-0.0441,0.10432-0.0662,0.008,0.0123,0.0151,0.0246,0.0226,0.0369-0.0198,0.0125-0.0395,0.0251-0.0593,0.0376,0.0618,0.009,0.1023,0.0775,0.0863,0.1364-0.0136,0.053-0.0532,0.0977-0.10297,0.11989-0.0504,0.0115-0.0285,0.0997,0.0214,0.0695,0.0534-0.0303,0.10194-0.0722,0.16293-0.0863,0.0435-0.009,0.0858,0.0224,0.0974,0.0636,0.0164,0.0502-0.0107,0.10209-0.0478,0.13531-0.0496,0.046-0.11032,0.0836-0.17745,0.0963-0.0498,0.0146-0.0906-0.0467-0.0527-0.0848,0.006-0.0101,0.027-0.0251,0.003-0.0192-0.0383,0.003-0.075-0.027-0.0765-0.0659-0.004-0.0352,0.0133-0.0685,0.0329-0.0966-0.0478,0.0127-0.10446,0.004-0.13684-0.0363-0.0466-0.052-0.0336-0.1361,0.0137-0.18313,0.0285-0.0297,0.0701-0.0523,0.10922-0.0571zm-0.0526,0.0441c-0.037,0.0263-0.015,0.077,0.003,0.10811,0.0217,0.0348,0.0437,0.0845,0.0906,0.0874,0.0437-0.003,0.0503-0.0588,0.0302-0.0895-0.0196-0.0385-0.0416-0.0789-0.0773-0.10485-0.0138-0.01-0.0335-0.01-0.0468-0.001zm0.19366,0.36112c-0.0355,0.0122-0.0729,0.0694-0.0233,0.0895,0.0431,0.0123,0.0825-0.0188,0.11686-0.0404,0.0317-0.0221,0.0809-0.0665,0.0477-0.10595-0.0453-0.0188-0.0847,0.0265-0.12284,0.0446-0.006,0.004-0.0134,0.008-0.0184,0.0122z'/%3E %3Cpath d='m493.5,302.08c-0.0566,0.0359-0.11326,0.0719-0.16989,0.10781,0.0277,0.0415,0.0698,0.0802,0.12193,0.0833,0.0486,0.003,0.0829-0.0445,0.0816-0.0899-0.001-0.0121-0.002-0.0227,0.0119-0.019,0.0127-0.00013,0.002,0.0244,0.006,0.0324,0.002,0.0458-0.0111,0.0947-0.0467,0.12571-0.0399,0.0365-0.0998,0.0554-0.15145,0.0335-0.0643-0.026-0.10758-0.0874-0.12998-0.15106-0.0248-0.071-0.004-0.16136,0.0627-0.20224,0.0526-0.035,0.12575-0.0181,0.16852,0.0249,0.0173,0.016,0.0323,0.0353,0.0451,0.0545zm-0.0952,0.0292c-0.0234-0.034-0.0433-0.0803-0.0878-0.0896-0.0478-0.00017-0.0452,0.0601-0.031,0.0916,0.007,0.0198,0.018,0.0376,0.0286,0.0555,0.0301-0.0192,0.0601-0.0383,0.0902-0.0575z'/%3E %3Cpath d='m493.49,301.7c0.0812,0.1326,0.16202,0.26539,0.24338,0.39787,0.0108,0.0281,0.0427,0.0377,0.0657,0.023,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0518,0.0329-0.10363,0.0658-0.15545,0.0986-0.0197-0.0196,0.0309-0.0294,0.0142-0.0555-0.0166-0.0377-0.041-0.0714-0.0617-0.10702-0.0528-0.0862-0.10534-0.17267-0.15837-0.25878-0.0107-0.0277-0.0423-0.0376-0.0651-0.0227-0.008-0.008-0.008-0.0142,0.003-0.018,0.0399-0.0253,0.0797-0.0506,0.11961-0.0758z'/%3E %3Cpath d='m493.62,301.59c0.0324-0.0229,0.0818-0.002,0.0904,0.0359,0.011,0.0395-0.0254,0.0834-0.0667,0.0768-0.0441-0.004-0.0683-0.0613-0.0417-0.0962,0.005-0.007,0.0108-0.0127,0.018-0.0164zm0.1393,0.12261c0.0524,0.0855,0.10445,0.17118,0.15701,0.25656,0.0108,0.0279,0.0426,0.0379,0.0656,0.0229,0.007,0.008,0.007,0.0137-0.004,0.0172-0.0524,0.0332-0.10479,0.0665-0.15719,0.0997-0.0197-0.019,0.0267-0.0264,0.0154-0.0508-0.0117-0.0332-0.0335-0.0616-0.0509-0.0919-0.0296-0.0479-0.0582-0.0965-0.0886-0.14391-0.0108-0.0275-0.0427-0.0249-0.0613-0.017-0.008-0.007-0.007-0.013,0.003-0.0165,0.0401-0.0254,0.0802-0.0508,0.12027-0.0762z'/%3E %3Cpath d='m493.97,301.58c0.0543-0.0356,0.13041-0.036,0.18278,0.004,0.0591,0.0425,0.0995,0.11339,0.10066,0.18675,0.002,0.0573-0.0299,0.11274-0.0791,0.14174-0.0449,0.0309-0.1059,0.0378-0.15458,0.0115-0.0963-0.0457-0.15198-0.16854-0.11424-0.26981,0.0124-0.0311,0.0365-0.0562,0.0645-0.0738zm0.0158,0.023c-0.0436,0.0307-0.01,0.085,0.009,0.12048,0.0304,0.0534,0.0592,0.109,0.10144,0.15424,0.0296,0.0378,0.0964,0.0101,0.0848-0.0383-0.008-0.0403-0.0331-0.0747-0.0524-0.11044-0.0254-0.0407-0.0472-0.0851-0.0827-0.11805-0.0161-0.0139-0.0411-0.0221-0.0598-0.008z'/%3E %3Cpath d='m492.04,303.81c0.0321,0.0498,0.0643,0.0996,0.0964,0.14939-0.023,0.0233-0.0372-0.0281-0.0617-0.0319-0.0566-0.0347-0.14047-0.0344-0.18523,0.0198-0.0326,0.0349-0.0194,0.10202,0.0307,0.11155,0.0585,0.0145,0.11863-0.003,0.17778-0.004,0.0565-0.003,0.12041,0.003,0.1604,0.0478,0.0495,0.0504,0.0537,0.13235,0.0188,0.19197-0.0361,0.0644-0.10796,0.1-0.17933,0.10781-0.0351,0.00097-0.0358,0.0404-0.0435,0.0603-0.01,0.0107-0.0126-0.009-0.0187-0.0151-0.031-0.0508-0.0621-0.10155-0.0931-0.15233,0.0216-0.0209,0.0355,0.0282,0.0572,0.0322,0.0587,0.0448,0.15046,0.0553,0.20838,0.004,0.0443-0.0326,0.0459-0.11266-0.009-0.13514-0.056-0.0233-0.11755-0.004-0.1756-0.003-0.0624,0.005-0.13494-0.004-0.1758-0.0568-0.0542-0.0643-0.0378-0.16847,0.0274-0.21884,0.0354-0.0301,0.0811-0.0447,0.12699-0.0475,0.0355,0.003,0.0383-0.0334,0.0307-0.055,0.002-0.002,0.005-0.004,0.007-0.005z'/%3E %3Cpath d='m492.57,303.89c-0.0566,0.0359-0.11326,0.0719-0.16989,0.1078,0.0278,0.0414,0.0697,0.0802,0.12193,0.0833,0.0486,0.003,0.0829-0.0445,0.0816-0.0899-0.001-0.0121-0.002-0.0227,0.0119-0.019,0.0127-0.00014,0.002,0.0244,0.006,0.0324,0.002,0.0458-0.0111,0.0947-0.0467,0.12572-0.0399,0.0365-0.0998,0.0554-0.15144,0.0335-0.0644-0.026-0.10758-0.0874-0.12998-0.15106-0.0248-0.071-0.004-0.16141,0.0627-0.20226,0.0527-0.035,0.12578-0.0181,0.16857,0.0249,0.0173,0.0161,0.0323,0.0352,0.0451,0.0546zm-0.0952,0.0292c-0.0233-0.034-0.0433-0.0803-0.0878-0.0896-0.0478-0.00017-0.0452,0.0601-0.031,0.0916,0.007,0.0198,0.018,0.0376,0.0286,0.0555,0.0301-0.0192,0.0601-0.0383,0.0902-0.0575z'/%3E %3Cpath d='m492.71,303.59c0.0348-0.0221,0.0695-0.0441,0.10432-0.0662,0.008,0.0123,0.0151,0.0246,0.0226,0.0369-0.0198,0.0125-0.0395,0.0251-0.0593,0.0376,0.0618,0.009,0.10231,0.0775,0.0863,0.1364-0.0136,0.053-0.0532,0.0976-0.1029,0.11989-0.0504,0.0115-0.0285,0.0997,0.0214,0.0695,0.0534-0.0304,0.10194-0.0722,0.16287-0.0864,0.0435-0.009,0.0858,0.0224,0.0974,0.0636,0.0164,0.0502-0.0107,0.10209-0.0478,0.13531-0.0496,0.046-0.11034,0.0835-0.17745,0.0963-0.0498,0.0146-0.0906-0.0467-0.0527-0.0848,0.006-0.01,0.027-0.025,0.003-0.0192-0.0383,0.003-0.075-0.027-0.0765-0.066-0.004-0.0352,0.0133-0.0685,0.0328-0.0965-0.0478,0.0127-0.10446,0.004-0.13684-0.0363-0.0466-0.052-0.0336-0.13609,0.0136-0.18316,0.0285-0.0297,0.0702-0.0526,0.10935-0.057zm-0.0526,0.044c-0.037,0.0263-0.015,0.077,0.003,0.10811,0.0216,0.0348,0.0437,0.0845,0.0906,0.0874,0.0438-0.003,0.0503-0.0589,0.0302-0.0895-0.0197-0.0385-0.0417-0.0788-0.0773-0.10481-0.0138-0.01-0.0335-0.01-0.0468-0.001zm0.19364,0.36113c-0.0355,0.0122-0.0729,0.0694-0.0233,0.0895,0.0431,0.0123,0.0825-0.0188,0.11686-0.0404,0.0317-0.0221,0.0809-0.0665,0.0477-0.10594-0.0454-0.0186-0.0847,0.0267-0.12284,0.0448-0.006,0.004-0.0132,0.008-0.0184,0.012z'/%3E %3Cpath d='m493.15,303.31c0.0536,0.0872,0.10624,0.17495,0.16055,0.26167,0.01,0.0244,0.0378,0.0313,0.0581,0.0198,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0381,0.0242-0.0763,0.0484-0.11442,0.0726-0.009-0.014-0.0171-0.0279-0.0256-0.0419-0.005,0.0506-0.0323,0.10324-0.0829,0.12059-0.0439,0.015-0.0915-0.01-0.11375-0.0484-0.0415-0.061-0.0766-0.12606-0.1176-0.18738-0.01-0.0245-0.0381-0.0177-0.054-0.0142-0.009-0.008-0.004-0.0134,0.005-0.0175,0.0381-0.0242,0.0763-0.0484,0.11443-0.0726,0.0484,0.0786,0.0958,0.15788,0.14492,0.23602,0.0151,0.0422,0.0743,0.0298,0.0764-0.0132,0.005-0.0193,0.009-0.0404-0.005-0.0562-0.0343-0.0556-0.0677-0.11184-0.10269-0.16704-0.01-0.0245-0.0376-0.0309-0.0579-0.0195-0.008-0.008-0.008-0.0142,0.003-0.0179,0.0388-0.0244,0.0776-0.0487,0.11636-0.0731z'/%3E %3Cpath d='m493.36,303.18c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10301,0.0847-0.12,0.0449-0.0165,0.0922,0.0126,0.11428,0.0515,0.0404,0.0605,0.0755,0.1245,0.11579,0.18509,0.01,0.0249,0.0384,0.0181,0.0542,0.0148,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0506-0.086-0.076-0.12889-0.0194-0.0305-0.036-0.063-0.0595-0.0906-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.12308,0.113,0.18389,0.01,0.0239,0.0366,0.0303,0.0561,0.0243,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0597-0.0265-0.0493-0.0575-0.096-0.0862-0.14404-0.0204-0.032-0.038-0.066-0.0619-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0418-0.0265,0.0837-0.053,0.12552-0.0795z'/%3E %3Cpath d='m493.98,302.58c0.0321,0.0498,0.0643,0.0996,0.0964,0.1494-0.023,0.0233-0.0372-0.0281-0.0617-0.0319-0.0566-0.0347-0.14047-0.0344-0.18523,0.0198-0.0326,0.0349-0.0193,0.10196,0.0307,0.11155,0.0585,0.0145,0.11863-0.003,0.17778-0.004,0.0565-0.003,0.12042,0.003,0.16041,0.0478,0.0495,0.0504,0.0537,0.13235,0.0188,0.19197-0.0361,0.0644-0.10796,0.1-0.17933,0.10781-0.0351,0.00095-0.0358,0.0405-0.0435,0.0603-0.01,0.0108-0.0127-0.009-0.0188-0.0151-0.031-0.0508-0.0621-0.10155-0.0931-0.15233,0.0217-0.0209,0.0355,0.0282,0.0573,0.0322,0.0587,0.0447,0.15048,0.0553,0.2084,0.004,0.0443-0.0326,0.0458-0.11267-0.009-0.13514-0.056-0.0233-0.11755-0.004-0.1756-0.003-0.0625,0.005-0.13495-0.003-0.17581-0.0567-0.0521-0.062-0.0392-0.16164,0.0211-0.21339,0.0362-0.0335,0.0847-0.05,0.13333-0.0528,0.0355,0.003,0.0382-0.0335,0.0306-0.055,0.002-0.002,0.005-0.004,0.007-0.006z'/%3E %3Cpath d='m494.48,302.82c-0.0146,0.0473-0.036,0.10038-0.0841,0.12216-0.0404,0.0184-0.0873-0.0118-0.0962-0.0532-0.0134-0.05,0.0152-0.0976,0.038-0.14003,0.0125-0.029,0.0413-0.057,0.0469-0.0849-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0331-0.0223-0.0903,0.0134-0.0818,0.0527,0.0214,0.0157,0.0614,0.0212,0.0561,0.0578-0.002,0.0439-0.0638,0.068-0.0952,0.037-0.0326-0.0397-0.0123-0.0975,0.017-0.13306,0.0319-0.0385,0.0748-0.0725,0.12527-0.0809,0.048-0.008,0.091,0.0213,0.11067,0.0636,0.0326,0.052,0.0635,0.10506,0.0967,0.15666,0.009,0.0233,0.0403,0.0117,0.036-0.0118,0.0277-0.003,0.009,0.032,0.007,0.0477-0.0117,0.0378-0.0525,0.069-0.0928,0.0616-0.0147-0.004-0.0266-0.0142-0.0361-0.0254zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10505-0.0185,0.0376-0.0372,0.0817-0.0239,0.12389,0.0113,0.0433,0.0727,0.0364,0.082-0.004l0.003-0.007,0.003-0.008,0.0005,0.00035z'/%3E %3Cpath d='m494.62,302.38c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10303,0.0847-0.11996,0.0449-0.0165,0.0922,0.0126,0.11428,0.0514,0.0404,0.0605,0.0755,0.1245,0.11579,0.18509,0.01,0.0249,0.0384,0.0181,0.0542,0.0148,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14345,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0506-0.0859-0.0759-0.12889-0.0194-0.0305-0.0361-0.063-0.0595-0.0906-0.0422-0.0327-0.0736,0.0333-0.0665,0.0699,0.0378,0.0612,0.0746,0.12308,0.113,0.18389,0.01,0.0239,0.0366,0.0303,0.0561,0.0243,0.01,0.009,0.0009,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0596-0.0265-0.0493-0.0575-0.096-0.0862-0.14405-0.0204-0.032-0.038-0.066-0.0619-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0418-0.0265,0.0837-0.053,0.12552-0.0795z'/%3E %3Cpath d='m495.04,301.94c-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0758-0.0481,0.15164-0.0962,0.22746-0.14434,0.008,0.009,0.009,0.0155-0.003,0.0194-0.0381,0.0153-0.0432,0.0614-0.0165,0.09,0.0516,0.0849,0.10421,0.16925,0.15504,0.25464,0.0237,0.0411,0.0445,0.0913,0.0247,0.13828-0.022,0.0619-0.0822,0.10594-0.14541,0.11824-0.0482,0.008-0.1085-0.0113-0.1245-0.0621-0.0142-0.0417,0.0303-0.0875,0.0723-0.0737,0.0443,0.0111,0.0309,0.062,0.0425,0.0925,0.0403,0.0241,0.097-0.0306,0.0657-0.0714-0.0407-0.0752-0.0875-0.14688-0.13151-0.22017-0.0277-0.0442-0.0532-0.0898-0.0831-0.13247-0.0196-0.0261-0.0553-0.0126-0.0767,0.004-0.003,0.002-0.007,0.004-0.01,0.006z'/%3E %3Cpath d='m495.68,301.71c0.0536,0.0872,0.10624,0.17496,0.16055,0.26168,0.01,0.0244,0.0378,0.0313,0.058,0.0198,0.008,0.009,0.005,0.0142-0.005,0.0183-0.0381,0.0242-0.0763,0.0484-0.11443,0.0726-0.009-0.014-0.0171-0.0279-0.0256-0.0419-0.005,0.0483-0.0293,0.0982-0.076,0.11808-0.0427,0.0187-0.0941-0.002-0.11731-0.0412-0.0432-0.0621-0.0789-0.12914-0.121-0.192-0.01-0.0245-0.0381-0.0177-0.054-0.0142-0.009-0.008-0.004-0.0134,0.005-0.0175,0.0381-0.0242,0.0763-0.0484,0.11442-0.0726,0.0484,0.0786,0.0958,0.15788,0.14492,0.23602,0.0151,0.0422,0.0743,0.0298,0.0764-0.0132,0.005-0.0193,0.009-0.0404-0.005-0.0562-0.0343-0.0556-0.0677-0.11184-0.10268-0.16704-0.01-0.0245-0.0376-0.0309-0.0579-0.0195-0.008-0.008-0.008-0.0142,0.003-0.0179,0.0388-0.0244,0.0777-0.0488,0.11648-0.0732z'/%3E %3Cpath d='m496.09,301.81c-0.0146,0.0473-0.036,0.10039-0.0841,0.12214-0.0404,0.0184-0.0874-0.0117-0.0962-0.0532-0.0138-0.0523,0.0172-0.10142,0.0411-0.14559,0.0115-0.027,0.0394-0.0532,0.0438-0.0794-0.0153-0.0237-0.0278-0.0499-0.048-0.0699-0.0331-0.0223-0.0903,0.0135-0.0818,0.0527,0.0214,0.0157,0.0614,0.0212,0.0561,0.0577-0.002,0.0439-0.0638,0.0681-0.0952,0.037-0.0326-0.0397-0.0123-0.0975,0.017-0.13306,0.0319-0.0385,0.0748-0.0725,0.12527-0.0809,0.0479-0.008,0.091,0.0213,0.11067,0.0636,0.0326,0.052,0.0635,0.10508,0.0967,0.1567,0.009,0.0234,0.0403,0.0118,0.036-0.0117,0.0277-0.003,0.009,0.032,0.008,0.0477-0.0117,0.0378-0.0525,0.069-0.0928,0.0616-0.0147-0.004-0.0266-0.0141-0.0361-0.0254zm-0.015-0.0245c-0.0214-0.035-0.0428-0.07-0.0642-0.10505-0.0185,0.0377-0.0372,0.0817-0.0239,0.12399,0.0113,0.0433,0.0727,0.0362,0.0821-0.004l0.003-0.007,0.003-0.008,0.0005,0.00035z'/%3E %3Cpath d='m496.22,301.36c0.008,0.0135,0.0165,0.0271,0.0248,0.0406,0.007-0.05,0.0337-0.10299,0.0847-0.12,0.0449-0.0165,0.0921,0.0126,0.1142,0.0515,0.0404,0.0605,0.0755,0.12449,0.11579,0.18506,0.01,0.0249,0.0384,0.0182,0.0542,0.0148,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0186-0.0179,0.0228-0.0322,0.006-0.0546-0.0221-0.0447-0.0505-0.086-0.0759-0.12889-0.0194-0.0305-0.036-0.063-0.0595-0.0906-0.0422-0.0327-0.0736,0.0333-0.0664,0.0699,0.0378,0.0612,0.0746,0.12309,0.11299,0.1839,0.01,0.0239,0.0367,0.0302,0.0561,0.0242,0.01,0.009,0.00091,0.0134-0.008,0.0179-0.0478,0.0303-0.0956,0.0607-0.14344,0.091-0.0196-0.0198,0.0302-0.0349,0.008-0.0597-0.0265-0.0492-0.0575-0.096-0.0862-0.14401-0.0204-0.032-0.038-0.0661-0.062-0.0956-0.0128-0.024-0.0488,0.0121-0.0509-0.015,0.0418-0.0265,0.0836-0.053,0.12542-0.0794z'/%3E %3Cpath d='m493.52,306.1c0.035,0.0494,0.0699,0.0988,0.10486,0.1482-0.022,0.0178-0.0404-0.0301-0.0642-0.0328-0.057-0.0367-0.1341-0.0291-0.18673,0.0119-0.0508,0.0355-0.0787,0.0993-0.07,0.16073,0.009,0.0775,0.0483,0.14935,0.0979,0.20848,0.0418,0.0493,0.10732,0.0827,0.17289,0.07,0.0759-0.0129,0.14741-0.0706,0.16089-0.14896,0.0111-0.0198-0.002-0.0627,0.0162-0.0713,0.0205,0.002,0.002,0.0428,0.006,0.0581-0.006,0.073-0.0495,0.1398-0.1122,0.17698-0.065,0.0438-0.15118,0.0574-0.22415,0.0258-0.14473-0.0579-0.22323-0.2435-0.16103-0.38702,0.0377-0.0887,0.12634-0.15422,0.22338-0.15872,0.0355,0.002,0.0252-0.0395,0.0285-0.056,0.003-0.002,0.005-0.004,0.008-0.005z'/%3E %3Cpath d='m494.06,306.18c-0.058,0.0368-0.11591,0.0736-0.17386,0.11032,0.007,0.0418,0.0104,0.0842,0.0209,0.12526,0.008,0.0421,0.0568,0.0171,0.0767,0.0112,0.0119,0.01-0.00031,0.0141-0.009,0.0193-0.0421,0.0267-0.0842,0.0534-0.12626,0.0801-0.0228-0.0225,0.0335-0.0352,0.0231-0.0642,0.002-0.0509-0.011-0.10075-0.0172-0.15102-0.0198-0.13247-0.0396-0.26493-0.0594-0.39739,0.009-0.009,0.0168-0.005,0.0248,0.003,0.13049,0.0937,0.26038,0.18828,0.39126,0.28143,0.03,0.0268,0.0758,0.0322,0.10783,0.0169,0.0119,0.01-0.00031,0.0141-0.009,0.0193-0.054,0.0343-0.10801,0.0686-0.16202,0.10282-0.0233-0.0221,0.035-0.0286,0.0248-0.0574-0.008-0.0294-0.039-0.0436-0.0616-0.0617-0.0171-0.0125-0.0341-0.0249-0.0512-0.0374zm-0.0245-0.019c-0.0629-0.0452-0.12573-0.0904-0.1886-0.13559,0.0114,0.0778,0.0229,0.15568,0.0343,0.23352,0.0514-0.0326,0.10287-0.0653,0.1543-0.0979z'/%3E %3Cpath d='m494.34,305.91c0.0313,0.0505,0.0614,0.10175,0.0936,0.15164,0.0152,0.0351,0.058,0.0379,0.0844,0.0145,0.007-0.0111,0.0164-0.00002,0.0161,0.007-0.0637,0.0404-0.12741,0.0808-0.19111,0.12127-0.009-0.009-0.009-0.0157,0.004-0.0198,0.0415-0.0169,0.0404-0.067,0.0137-0.0967-0.064-0.10453-0.12741-0.2094-0.19202-0.31353-0.0144-0.0363-0.0581-0.0447-0.0861-0.0188-0.008,0.0108-0.0173,0.002-0.0171-0.007,0.0665-0.0415,0.1316-0.0852,0.19925-0.12469,0.0481-0.0279,0.10921-0.0423,0.16167-0.0175,0.0742,0.0342,0.10514,0.13869,0.0575,0.20637-0.0334,0.0497-0.0892,0.0772-0.14387,0.0973l0.0003-0.00063zm-0.0118-0.0192c0.0421-0.0153,0.0916-0.0371,0.10055-0.0866,0.0156-0.0633-0.0302-0.13153-0.0901-0.15135-0.0478-0.0141-0.095,0.0146-0.12592,0.0493,0.0385,0.0629,0.077,0.1258,0.1155,0.1887z'/%3E %3Cpath d='m494.92,305.84c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.0649-0.10663-0.12985-0.21332-0.19549-0.31953-0.0142-0.0373-0.0597-0.042-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18988-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0922,0.0631,0.10426,0.12697,0.2081,0.19059,0.31207,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m495.05,305.13c0.0234,0.0345,0.0468,0.069,0.0702,0.10356-0.0241,0.0215-0.0351-0.036-0.0638-0.0338-0.0435-0.0148-0.0807,0.0182-0.11567,0.0392-0.009,0.006-0.0175,0.0111-0.0262,0.0166,0.074,0.12065,0.14727,0.24181,0.22182,0.36214,0.0146,0.0369,0.0586,0.043,0.0862,0.0172,0.007-0.0129,0.021,0.006,0.0122,0.01-0.062,0.0394-0.12411,0.0788-0.18616,0.11813-0.0109-0.01-0.006-0.0165,0.006-0.0214,0.043-0.0189,0.0333-0.07,0.008-0.0993-0.0706-0.11542-0.14112-0.23084-0.21168-0.34626-0.0336,0.023-0.0722,0.0404-0.099,0.0718-0.0239,0.03-0.002,0.0738-0.00019,0.0997-0.0106,0.0122-0.0132-0.007-0.0188-0.0139-0.0165-0.0303-0.033-0.0606-0.0494-0.0908,0.12214-0.0774,0.24429-0.15488,0.36643-0.23232z'/%3E %3Cpath d='m495.41,304.93c-0.0123-0.0106-0.004-0.0169,0.007-0.0222,0.0478-0.0303,0.0957-0.0607,0.1435-0.0911,0.0123,0.0106,0.004,0.0169-0.007,0.0222-0.0419,0.022-0.0291,0.0752-0.004,0.10503,0.0445,0.0741,0.0915,0.1468,0.13397,0.22213,0.0255,0.046,0.0419,0.10158,0.0228,0.15302-0.0239,0.0751-0.0969,0.12062-0.16619,0.14868-0.068,0.0276-0.15055-0.001-0.18949-0.0627-0.0503-0.0716-0.0931-0.14802-0.13944-0.22212-0.0178-0.0266-0.0313-0.0622-0.0643-0.0722-0.0218-0.005-0.0413,0.0165-0.0578,0.0207-0.0134-0.0109,0.0003-0.0158,0.01-0.0216,0.059-0.0375,0.11805-0.0749,0.17707-0.11235,0.0123,0.0106,0.004,0.0169-0.007,0.0222-0.0422,0.0191-0.0331,0.0703-0.008,0.0997,0.0451,0.0729,0.0886,0.14674,0.13478,0.21889,0.0287,0.0403,0.0639,0.0886,0.1188,0.0886,0.0617,0.00062,0.11796-0.0422,0.14777-0.0941,0.0237-0.0385,0.023-0.0876,0.002-0.12698-0.0339-0.0682-0.077-0.13129-0.11577-0.19675-0.0209-0.0319-0.037-0.0676-0.0648-0.0942-0.0246-0.0172-0.0513,0.003-0.0729,0.0152z'/%3E %3Cpath d='m496.15,304.88c0.0131-0.0102,0.015,0.002,0.017,0.0133,0.0108,0.0432,0.0217,0.0864,0.0325,0.12962-0.11591,0.0736-0.23183,0.14711-0.34774,0.22066-0.0112-0.0101-0.005-0.0165,0.006-0.0216,0.0443-0.0195,0.0327-0.0717,0.007-0.1018-0.0628-0.10223-0.12472-0.20499-0.18807-0.30687-0.0147-0.0367-0.0591-0.0443-0.0871-0.0183-0.007,0.0131-0.0225-0.004-0.0133-0.009,0.0663-0.0421,0.13267-0.0842,0.199-0.12628,0.0222,0.023-0.0326,0.0284-0.0381,0.0509-0.0235,0.0321,0.007,0.0654,0.0225,0.0937,0.0593,0.0965,0.11779,0.19363,0.17763,0.28984,0.0216,0.0461,0.0689,0.0136,0.0973-0.007,0.0385-0.0258,0.0837-0.0469,0.10685-0.0888,0.0183-0.0368,0.0126-0.0793,0.008-0.11843z'/%3E %3Cpath d='m496.23,304.38c0.0997-0.0666,0.24302-0.0399,0.32136,0.0477,0.0674,0.0732,0.10284,0.17963,0.0757,0.27743-0.0269,0.12069-0.15301,0.20988-0.2758,0.19252-0.0851-0.009-0.15869-0.0663-0.20096-0.13907-0.048-0.0742-0.0593-0.17102-0.0254-0.25317,0.02-0.052,0.058-0.096,0.10511-0.12536zm0.009,0.0285c-0.0521,0.0299-0.077,0.0925-0.0695,0.15074,0.009,0.0814,0.0533,0.15489,0.10477,0.21688,0.0428,0.0488,0.10552,0.0929,0.17375,0.0811,0.0729-0.0137,0.12916-0.0831,0.12809-0.15725-0.001-0.0786-0.0441-0.14916-0.0883-0.21127-0.0403-0.0535-0.0971-0.10671-0.16845-0.10652-0.0287,0.00043-0.0565,0.0109-0.0804,0.0263z'/%3E %3Cpath d='m497.12,303.82c0.0213,0.0202-0.0246,0.0332-0.0203,0.0578-0.006,0.0467,0.008,0.0927,0.0138,0.13874,0.0225,0.13699,0.0451,0.27398,0.0676,0.41097-0.009,0.01-0.0173,0.007-0.0257-0.001-0.13844-0.0966-0.27636-0.19398-0.41514-0.29008-0.0254-0.0281-0.067-0.007-0.0905-0.005-0.012-0.01,0.004-0.0132,0.0112-0.0188,0.0556-0.0353,0.11128-0.0706,0.16692-0.10592,0.024,0.0235-0.0383,0.0322-0.0274,0.0619,0.009,0.0307,0.0409,0.0462,0.0651,0.0646,0.088,0.0616,0.17599,0.1233,0.26399,0.18495-0.0198-0.11767-0.0389-0.23545-0.0591-0.35304,0.002-0.0434-0.0417-0.0709-0.0774-0.0443-0.007,0.004-0.0169-0.0149-0.003-0.0156,0.0433-0.0282,0.0867-0.0564,0.13007-0.0846z'/%3E %3Cpath d='m497.61,304.13c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.065-0.10663-0.12985-0.21331-0.1955-0.31951-0.0142-0.0373-0.0597-0.0421-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18989-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0922,0.0631,0.10426,0.12697,0.2081,0.19059,0.31207,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m497.84,303.98c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.065-0.10663-0.12985-0.21331-0.1955-0.31951-0.0142-0.0373-0.0597-0.042-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18989-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0921,0.0631,0.10428,0.12698,0.20812,0.19059,0.3121,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m498.06,303.84c0.008,0.009,0.009,0.0155-0.003,0.0196-0.0604,0.0383-0.12072,0.0766-0.18108,0.11491-0.008-0.009-0.009-0.0155,0.003-0.0196,0.0384-0.0159,0.0429-0.0624,0.0171-0.0919-0.065-0.10663-0.12986-0.21331-0.19551-0.31951-0.0142-0.0373-0.0597-0.042-0.0877-0.0172-0.007,0.0114-0.0179-0.004-0.0138-0.009,0.0633-0.0402,0.12659-0.0803,0.18989-0.12049,0.008,0.009,0.009,0.0155-0.003,0.0196-0.0385,0.0159-0.0428,0.0625-0.0173,0.0922,0.0631,0.10426,0.12697,0.2081,0.19059,0.31207,0.0137,0.0385,0.0595,0.0544,0.0912,0.0256,0.003-0.002,0.007-0.004,0.01-0.007z'/%3E %3Cpath d='m494.14,307.96c-0.009-0.0549-0.003-0.12048,0.0427-0.15826,0.0356-0.0315,0.0884-0.0494,0.1338-0.0285,0.0532,0.019,0.0713,0.0819,0.0601,0.13283,0.002,0.0144-0.018,0.0457-0.005,0.0473,0.0536-0.011,0.11311,0.0101,0.14348,0.0567,0.0488,0.0655,0.0448,0.16278-0.008,0.22465-0.0321,0.0374-0.074,0.0679-0.12114,0.0829-0.0342,0.0149-0.0691-0.0323-0.0331-0.0538,0.038-0.0209,0.0891-0.003,0.12315-0.0357,0.0472-0.037,0.0482-0.11324,0.007-0.15539-0.0287-0.0348-0.0755-0.0526-0.11983-0.0417-0.0247,0.00061-0.0494,0.0187-0.0686,0.027-0.0149-0.0175,0.025-0.0272,0.0267-0.0458,0.0297-0.0416,0.0328-0.10108,0.00055-0.14218-0.0307-0.0482-0.10484-0.0459-0.13867-0.003-0.0258,0.0232-0.0239,0.0669-0.0334,0.0915-0.003,0.00034-0.006,0.00068-0.01,0.001z'/%3E %3Cpath d='m494.5,307.67c0.0254-0.0411,0.0508-0.0822,0.0762-0.12338,0.008-0.008,0.0138-0.007,0.0173,0.004,0.0798,0.13029,0.15914,0.26089,0.23928,0.39098,0.0113,0.0313,0.0462,0.0457,0.0732,0.023,0.0107-0.0119,0.0172-0.008,0.0222,0.004-0.0563,0.0357-0.1126,0.0715-0.1689,0.10717-0.0223-0.0219,0.03-0.0262,0.0323-0.0493,0.008-0.0282-0.0174-0.0517-0.029-0.0756-0.0562-0.0912-0.11106-0.18318-0.16819-0.27376-0.0115-0.0298-0.0522-0.0525-0.0718-0.0158-0.009,0.0125-0.01,0.0201-0.0226,0.009z'/%3E %3Cpath d='m495.23,307.16c0.0522-0.0331,0.10443-0.0663,0.15664-0.0994,0.0199,0.0169-0.0147,0.0196-0.0186,0.0367-0.0324,0.0472-0.0225,0.1067-0.0251,0.16085-0.00081,0.0649-0.002,0.12972-0.002,0.19458,0.0293,0.0467,0.0563,0.095,0.0876,0.14034,0.0183,0.0336,0.0585,0.0216,0.0826,0.003,0.009-0.004,0.0164,0.0161,0.001,0.0168-0.06,0.0381-0.12005,0.0762-0.18008,0.11427-0.0121-0.0105-0.005-0.0168,0.007-0.0221,0.0434-0.0198,0.0307-0.071,0.006-0.10029-0.0213-0.0349-0.0427-0.0698-0.064-0.10464-0.0938-0.0434-0.1867-0.0889-0.28124-0.13071-0.0255-0.018-0.0651,0.004-0.0836-0.002-0.0105-0.0102,0.0118-0.0132,0.0173-0.0199,0.0569-0.0361,0.11381-0.0722,0.17071-0.10833,0.0204,0.0176-0.0162,0.0204-0.0215,0.0364-0.0289,0.038,0.0237,0.061,0.0524,0.0733,0.0579,0.0275,0.11574,0.055,0.17361,0.0825,0.0004-0.0722,0.002-0.14432,0.002-0.21647,0.009-0.0454-0.0429-0.0733-0.0748-0.045-0.002-0.003-0.004-0.007-0.005-0.01z'/%3E %3Cpath d='m496.05,307.2c-0.008,0.0518-0.0425,0.10117-0.0945,0.1154-0.0685,0.0193-0.14239-0.0196-0.1783-0.0784-0.0436-0.0652-0.0543-0.15594-0.0162-0.22606,0.0265-0.0439,0.0793-0.0795,0.1323-0.0672-0.0253-0.0402-0.048-0.0821-0.0768-0.1199-0.0173-0.0266-0.0437,0.001-0.0556,0.0106-0.0126-0.005-0.007-0.0126,0.0001-0.0203,0.0199-0.0274,0.0388-0.056,0.0593-0.0827,0.008-0.006,0.0162-0.0114,0.0197,0.002,0.0786,0.12807,0.15622,0.2568,0.23564,0.38439,0.0104,0.0266,0.0469,0.0546,0.0668,0.0201,0.005-0.0145,0.0238,0.005,0.01,0.0117-0.0206,0.0287-0.0402,0.0584-0.0614,0.0863-0.008,0.005-0.016,0.0141-0.0192,0.00041-0.007-0.012-0.0143-0.0241-0.0215-0.0361zm-0.0143-0.0235c-0.0323-0.0528-0.0646-0.10561-0.0969-0.15842-0.0249-0.0371-0.0779-0.0607-0.1189-0.0351-0.0453,0.0303-0.0441,0.0949-0.0243,0.13998,0.0257,0.059,0.0696,0.12203,0.13795,0.13234,0.0386,0.008,0.0813-0.0132,0.0941-0.0514,0.004-0.009,0.006-0.0183,0.008-0.0274z'/%3E %3Cpath d='m496.13,306.94c0.0276,0.0482,0.0749,0.0905,0.13276,0.0932,0.0542,0.005,0.11073-0.0363,0.11486-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0546,0.023-0.005,0.0176,0.0319,0.0238,0.0458,0.007,0.0526-0.006,0.11301-0.0504,0.14615-0.0454,0.0375-0.11245,0.0401-0.16318,0.0121-0.0521-0.0287-0.0862-0.0818-0.10606-0.13652-0.0243-0.0652-0.006-0.14588,0.0512-0.18814,0.0379-0.0313,0.0927-0.0435,0.13836-0.0226,0.0267,0.0121,0.0625,0.0406,0.0657,0.0659-0.0686,0.0437-0.13729,0.0873-0.20594,0.13098zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14041-0.0891-0.0186-0.0338-0.0571-0.0608-0.0968-0.0483-0.0484,0.013-0.0691,0.0731-0.0519,0.11733,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m496.69,306.7c0.0218,0.0554,0.022,0.12259-0.0136,0.1724-0.0315,0.0455-0.0926,0.0655-0.14531,0.0499-0.0657-0.016-0.11195-0.0731-0.1376-0.13285-0.0334-0.0755-0.009-0.17522,0.0634-0.21874,0.0382-0.0258,0.0916-0.0331,0.13173-0.008,0.0297,0.0155,0.0272,0.0615-0.007,0.0697-0.046,0.0211-0.0551-0.0594-0.10189-0.0414-0.0479,0.0126-0.0682,0.0674-0.0561,0.11218,0.0151,0.0639,0.0618,0.12138,0.12358,0.14514,0.0492,0.0204,0.10832-0.0108,0.12597-0.0595,0.0147-0.0268,0.003-0.0648,0.007-0.0883,0.003-0.00029,0.006-0.00057,0.009-0.00086z'/%3E %3Cpath d='m496.59,306.26c0.0471-0.0324,0.0877,0.0541,0.0346,0.072-0.0448,0.0172-0.0753-0.0474-0.0346-0.072zm0.12577,0.14333c0.0532,0.0866,0.10569,0.17374,0.1594,0.26006,0.0125,0.0301,0.049,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0314-0.025,0.0236-0.0512-0.003-0.0293-0.024-0.0526-0.0379-0.0778-0.0308-0.0493-0.0591-0.10025-0.0933-0.14736-0.0149-0.0264-0.0449-0.008-0.0563,0.009-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0212-0.0292,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0137-0.009z'/%3E %3Cpath d='m497.13,306.51c-0.0161,0.038-0.0243,0.0841-0.0609,0.1087-0.0422,0.0349-0.10789,0.0122-0.1288-0.0357-0.0228-0.0398-0.004-0.0869,0.0161-0.12353,0.0222-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0312-0.0542-0.06-0.0661-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0264,0.0338,0.0174,0.0542-0.0178,0.0388-0.0703,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0986,0.0727-0.12403,0.0339-0.0213,0.0797-0.0412,0.11755-0.018,0.0279,0.0198,0.0425,0.0521,0.0607,0.0802,0.0283,0.0455,0.0548,0.0923,0.0856,0.13619,0.0189,0.0259,0.0416-0.005,0.0408-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.071-0.01,0.0376-0.0629,0.058-0.085,0.0192-0.005,0.001-0.004-0.0144-0.009-0.0121zm-0.0133-0.0218c-0.0239-0.039-0.0477-0.0781-0.0716-0.11712-0.027,0.0399-0.0638,0.0791-0.0659,0.12982-0.001,0.0409,0.0412,0.0814,0.0822,0.0676,0.0317-0.0134,0.0443-0.0512,0.0552-0.0803z'/%3E %3Cpath d='m497.23,305.88c-0.006-0.008-0.0109-0.0148,0.001-0.0183,0.061-0.0387,0.12202-0.0774,0.18303-0.11614,0.006,0.008,0.0109,0.0148-0.001,0.0184-0.033,0.0141-0.0484,0.0546-0.024,0.0841,0.0515,0.0874,0.10613,0.17298,0.15785,0.26027,0.0265,0.045,0.0423,0.10013,0.0248,0.15129-0.0132,0.0442-0.0561,0.0805-0.10275,0.0815-0.0487,0.006-0.0785-0.0725-0.0234-0.0862,0.035-0.011,0.0649,0.0547,0.094,0.0211,0.0106-0.0304-0.0136-0.0562-0.0276-0.0813-0.0619-0.10087-0.12312-0.20217-0.18546-0.30277-0.0141-0.0368-0.0591-0.0422-0.0872-0.0178-0.003,0.002-0.006,0.004-0.009,0.006z'/%3E %3Cpath d='m497.65,305.97c0.0277,0.0482,0.0749,0.0905,0.1328,0.0932,0.0542,0.005,0.11067-0.0363,0.11482-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0547,0.023-0.005,0.0176,0.0319,0.0238,0.0458,0.007,0.0526-0.006,0.11301-0.0504,0.14615-0.0431,0.0355-0.106,0.0399-0.15559,0.0158-0.0564-0.0271-0.0928-0.0831-0.11361-0.14031-0.0244-0.0652-0.006-0.14587,0.0511-0.18814,0.0378-0.0313,0.0927-0.0435,0.13836-0.0226,0.0267,0.0121,0.0625,0.0406,0.0657,0.0659-0.0686,0.0437-0.13729,0.0874-0.20593,0.13108zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14042-0.0891-0.0186-0.0338-0.0571-0.0609-0.0968-0.0483-0.0484,0.013-0.0691,0.0732-0.0519,0.11738,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m498.02,305.56c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0171,0.0178-0.0291-0.0175-0.046-0.0223-0.0366-0.031-0.0948-0.0203-0.12179,0.0178-0.0305,0.0392,0.0142,0.0893,0.058,0.0819,0.0468-0.00076,0.0931-0.014,0.13992-0.008,0.0451,0.004,0.0821,0.0426,0.0867,0.0872,0.005,0.0547-0.0328,0.10681-0.0824,0.12728-0.0254,0.0164-0.0678,0.0127-0.0775,0.0444-0.007,0.008-0.0101,0.001-0.0135-0.006-0.0203-0.0332-0.0405-0.0663-0.0608-0.0995,0.0171-0.0179,0.0276,0.0181,0.0447,0.0225,0.0403,0.0292,0.10379,0.0291,0.13679-0.0112,0.0258-0.0298,0.008-0.0796-0.0294-0.0896-0.0584-0.0136-0.11857,0.0105-0.17711-0.003-0.0566-0.0166-0.0842-0.0893-0.0578-0.14087,0.0182-0.0397,0.0602-0.061,0.10096-0.0704,0.0163-0.001,0.0282-0.0137,0.0251-0.0296,0.003-0.002,0.007-0.004,0.0103-0.006z'/%3E %3Cpath d='m498.37,305.37c0.0486,0.0787,0.0956,0.15843,0.14574,0.23619,0.0128,0.0335,0.0524,0.0268,0.0661,0.004,0.01,0.004,0.0108,0.0101,0.003,0.0172-0.0207,0.0287-0.0405,0.0584-0.0618,0.0864-0.007,0.003-0.0151,0.0137-0.0179,0.001-0.0119-0.0194-0.0238-0.0388-0.0356-0.0583-0.0101,0.045-0.0163,0.0984-0.0576,0.12682-0.0358,0.0291-0.0917,0.0195-0.11957-0.0159-0.0329-0.0388-0.0561-0.0844-0.0834-0.12708-0.0183-0.0283-0.0333-0.059-0.0553-0.0846-0.0195-0.0219-0.0491,0.006-0.0645,0.005-0.009-0.008-0.003-0.0123,0.005-0.0162,0.0317-0.0201,0.0634-0.0402,0.0951-0.0604,0.0442,0.0719,0.0877,0.14421,0.13229,0.21589,0.0178,0.0425,0.0773,0.0513,0.10349,0.0122,0.0143-0.023,0.0381-0.0569,0.0266-0.0835-0.0353-0.0575-0.0701-0.11514-0.10561-0.17244-0.0139-0.0323-0.0517-0.0237-0.0731-0.009-0.006-0.007-0.01-0.0137,0.002-0.017,0.0318-0.0202,0.0635-0.0403,0.0953-0.0605z'/%3E %3Cpath d='m498.63,305.18c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0171,0.0178-0.0291-0.0175-0.046-0.0223-0.0366-0.031-0.0948-0.0204-0.12176,0.0178-0.0304,0.0393,0.0143,0.0893,0.0581,0.0819,0.0468-0.00077,0.093-0.014,0.13988-0.008,0.0451,0.004,0.0821,0.0428,0.0867,0.0873,0.005,0.0547-0.0328,0.10681-0.0824,0.12728-0.0254,0.0164-0.0678,0.0127-0.0776,0.0444-0.007,0.008-0.0101,0.001-0.0135-0.006-0.0203-0.0332-0.0405-0.0663-0.0608-0.0995,0.0171-0.0179,0.0276,0.0181,0.0447,0.0225,0.0403,0.0292,0.10379,0.029,0.13679-0.0112,0.0258-0.0298,0.008-0.0796-0.0294-0.0896-0.0607-0.0144-0.12408,0.0133-0.18438-0.005-0.0536-0.0217-0.0767-0.0934-0.0481-0.14322,0.0194-0.037,0.0596-0.0564,0.0986-0.0657,0.0163-0.002,0.0281-0.0138,0.025-0.0297,0.003-0.002,0.007-0.004,0.0102-0.006z'/%3E %3Cpath d='m499.2,305.2c-0.016,0.038-0.0243,0.084-0.0609,0.1087-0.0422,0.0349-0.10789,0.0122-0.1288-0.0357-0.0228-0.0398-0.004-0.0869,0.0161-0.12353,0.0223-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0313-0.0542-0.06-0.0662-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0264,0.0338,0.0174,0.0542-0.0178,0.0388-0.0704,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0987,0.0727-0.12403,0.0339-0.0213,0.0798-0.0412,0.11755-0.018,0.0279,0.0198,0.0425,0.052,0.0607,0.0802,0.0283,0.0455,0.0548,0.0923,0.0856,0.13618,0.0189,0.0259,0.0416-0.005,0.0409-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.0709-0.01,0.0376-0.0629,0.058-0.085,0.0192l-0.004-0.006-0.004-0.006-0.0002,0.00022zm-0.0133-0.0218c-0.0239-0.039-0.0477-0.0781-0.0716-0.11712-0.027,0.0399-0.0636,0.0792-0.0659,0.12982-0.001,0.0409,0.0412,0.0814,0.0822,0.0676,0.0317-0.0134,0.0443-0.0512,0.0552-0.0803z'/%3E %3Cpath d='m494.69,308.65c0.086,0.14022,0.17122,0.28091,0.25767,0.42083,0.0129,0.0377,0.0552,0.0283,0.0771,0.0154,0.009,0.008,0.003,0.0132-0.006,0.0172-0.0457,0.029-0.0914,0.058-0.13711,0.087-0.0208-0.0209,0.0301-0.0249,0.0223-0.0504-0.004-0.0298-0.0248-0.0535-0.039-0.0792-0.0593-0.0964-0.11741-0.19349-0.17767-0.28927-0.01-0.0264-0.0444-0.0464-0.0619-0.0153-0.003,0.0122-0.0258-0.003-0.0122-0.01,0.0211-0.0292,0.0413-0.0594,0.063-0.0879,0.005-0.003,0.009-0.006,0.0138-0.009z'/%3E %3Cpath d='m495.02,308.65c0.0462-0.0315,0.10829-0.0357,0.15838-0.0109,0.0715,0.0315,0.11325,0.10884,0.11633,0.18484,0.005,0.0611-0.0267,0.12262-0.0791,0.1543-0.0463,0.0319-0.10898,0.0337-0.15806,0.007-0.0726-0.0344-0.11572-0.11469-0.11438-0.19363-0.002-0.0568,0.0296-0.1115,0.0768-0.14159zm0.003,0.0283c-0.0383,0.0235-0.0438,0.076-0.0277,0.11468,0.0251,0.0647,0.0712,0.12433,0.1346,0.15498,0.0396,0.0216,0.0961,0.008,0.11462-0.0353,0.0207-0.0455-0.005-0.0939-0.0283-0.13282-0.0309-0.0504-0.0746-0.0998-0.13475-0.11297-0.0201-0.004-0.0429,0.002-0.0584,0.0114z'/%3E %3Cpath d='m495.4,308.41c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0171,0.0178-0.0291-0.0175-0.046-0.0223-0.0365-0.0307-0.0948-0.0201-0.12174,0.0178-0.0304,0.0392,0.0143,0.0893,0.058,0.0819,0.0468-0.00076,0.0931-0.014,0.13992-0.008,0.0451,0.004,0.0821,0.0427,0.0867,0.0872,0.005,0.0547-0.0328,0.10681-0.0824,0.12728-0.0254,0.0164-0.0678,0.0127-0.0775,0.0444-0.007,0.008-0.0101,0.001-0.0135-0.006-0.0203-0.0332-0.0406-0.0663-0.0608-0.0995,0.0171-0.0179,0.0276,0.0181,0.0447,0.0225,0.0403,0.0292,0.10378,0.029,0.13679-0.0112,0.0258-0.0298,0.008-0.0796-0.0294-0.0896-0.0584-0.0136-0.11857,0.0105-0.17711-0.003-0.0565-0.0166-0.0841-0.0893-0.0577-0.14086,0.0183-0.0397,0.0603-0.0608,0.10096-0.0703,0.0163-0.001,0.0281-0.0138,0.025-0.0296,0.003-0.002,0.007-0.004,0.0102-0.006z'/%3E %3Cpath d='m495.62,308.06c0.0477-0.0323,0.089,0.054,0.0352,0.0728-0.0456,0.017-0.0747-0.0476-0.0352-0.0728zm0.12696,0.14301c0.0658,0.10808,0.13241,0.21571,0.19771,0.32409,0.0297,0.0505,0.0461,0.11732,0.0134,0.17047-0.0241,0.0359-0.0695,0.0748-0.11542,0.0589-0.0417-0.0271,0.008-0.0789,0.0456-0.0599,0.0369,0.0172,0.0722-0.0228,0.0483-0.0566-0.0339-0.0644-0.0744-0.12514-0.11165-0.18764-0.0316-0.05-0.0597-0.10239-0.0956-0.14951-0.0179-0.0288-0.0432,0.008-0.0561,0.01-0.0143-0.005-0.002-0.0139,0.003-0.0217,0.0197-0.0267,0.0382-0.0548,0.0586-0.0808,0.004-0.002,0.008-0.005,0.0122-0.007z'/%3E %3Cpath d='m496.11,307.99c0.0486,0.0787,0.0956,0.15843,0.14574,0.23619,0.0128,0.0335,0.0524,0.0268,0.0661,0.004,0.01,0.004,0.0108,0.0101,0.003,0.0172-0.0207,0.0287-0.0405,0.0584-0.0618,0.0864-0.007,0.003-0.015,0.0137-0.0179,0.001-0.0119-0.0194-0.0238-0.0388-0.0356-0.0583-0.0102,0.045-0.0163,0.0984-0.0576,0.12675-0.0358,0.0291-0.0917,0.0194-0.11957-0.016-0.0326-0.0384-0.0556-0.0837-0.0827-0.12604-0.0185-0.0287-0.0338-0.0598-0.056-0.0858-0.0194-0.022-0.0491,0.006-0.0645,0.005-0.009-0.008-0.003-0.0123,0.005-0.0162,0.0317-0.0201,0.0634-0.0402,0.0951-0.0603,0.0442,0.0719,0.0877,0.14421,0.1323,0.21588,0.0178,0.0425,0.0773,0.0513,0.10349,0.0122,0.0143-0.023,0.0381-0.0569,0.0266-0.0835-0.0352-0.0575-0.0701-0.11514-0.10561-0.17244-0.0139-0.0323-0.0517-0.0236-0.0731-0.009-0.006-0.007-0.01-0.0137,0.002-0.017,0.0318-0.0201,0.0635-0.0402,0.0953-0.0604z'/%3E %3Cpath d='m496.56,308.09c-0.008,0.0518-0.0425,0.1011-0.0945,0.1153-0.0685,0.0193-0.14239-0.0196-0.1783-0.0784-0.0436-0.0653-0.0543-0.15596-0.0162-0.2261,0.0266-0.0439,0.0793-0.0795,0.1323-0.0671-0.0253-0.0402-0.048-0.0821-0.0768-0.1199-0.0173-0.0266-0.0437,0.001-0.0557,0.0105-0.0125-0.005-0.007-0.0126,0.0001-0.0203,0.0199-0.0274,0.0388-0.056,0.0593-0.0827,0.008-0.006,0.0162-0.0114,0.0197,0.002,0.0786,0.12807,0.15622,0.2568,0.23564,0.38439,0.0104,0.0266,0.0469,0.0546,0.0668,0.0201,0.005-0.0145,0.0238,0.005,0.01,0.0117-0.0206,0.0287-0.0402,0.0584-0.0614,0.0863-0.008,0.005-0.016,0.0141-0.0192,0.00041-0.007-0.012-0.0143-0.0239-0.0214-0.0359zm-0.0144-0.0235c-0.0323-0.0528-0.0645-0.10561-0.0968-0.15842-0.0249-0.0371-0.0779-0.0606-0.1189-0.035-0.0453,0.0303-0.0441,0.0949-0.0243,0.13998,0.0256,0.059,0.0696,0.12197,0.13795,0.13234,0.0386,0.008,0.0813-0.0132,0.0941-0.0514,0.004-0.009,0.006-0.0182,0.008-0.0275z'/%3E %3Cpath d='m496.49,307.51c0.0471-0.0324,0.0877,0.0541,0.0346,0.072-0.0448,0.0172-0.0753-0.0474-0.0346-0.072zm0.12578,0.14333c0.0532,0.0866,0.10569,0.17374,0.15939,0.26006,0.0125,0.0301,0.0491,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0315-0.0251,0.0236-0.0513-0.003-0.0294-0.024-0.0527-0.0379-0.0779-0.0308-0.0493-0.0591-0.10025-0.0933-0.14736-0.0149-0.0264-0.0449-0.008-0.0563,0.009-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0213-0.0291,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0137-0.009z'/%3E %3Cpath d='m496.84,307.5c0.0462-0.0315,0.1083-0.0357,0.15839-0.0109,0.0715,0.0315,0.11325,0.10884,0.11633,0.18484,0.005,0.0611-0.0267,0.12262-0.0791,0.1543-0.0463,0.0319-0.10896,0.0337-0.15803,0.007-0.0726-0.0344-0.11577-0.11467-0.11441-0.19363-0.002-0.0568,0.0296-0.11151,0.0768-0.14159zm0.003,0.0283c-0.0383,0.0235-0.0438,0.076-0.0277,0.11468,0.0251,0.0647,0.0713,0.1243,0.1346,0.15498,0.0397,0.0217,0.0961,0.008,0.11462-0.0353,0.0207-0.0455-0.005-0.0939-0.0283-0.13281-0.0309-0.0504-0.0746-0.0998-0.13474-0.11298-0.0201-0.005-0.0428,0.002-0.0585,0.0114z'/%3E %3Cpath d='m497.23,307.25c0.0213,0.0349,0.0427,0.0698,0.064,0.10473-0.0212,0.0178-0.0367-0.0274-0.0596-0.0306-0.045-0.0275-0.11919,0.005-0.11806,0.0612,0.007,0.0459,0.0629,0.0527,0.10041,0.0447,0.0509-0.004,0.10669-0.0194,0.15271,0.0109,0.0435,0.0294,0.0538,0.0926,0.0268,0.13653-0.0242,0.0481-0.0778,0.0684-0.12637,0.0826-0.0126,0.003-0.0219,0.0436-0.0331,0.0165-0.0201-0.0329-0.0402-0.0657-0.0602-0.0986,0.0213-0.0178,0.0357,0.0291,0.0595,0.0312,0.0433,0.0235,0.10935,0.0133,0.13047-0.0349,0.0161-0.038-0.02-0.0801-0.0593-0.0783-0.0564-0.005-0.11507,0.0171-0.16948-0.004-0.0546-0.0274-0.0713-0.10598-0.0332-0.15358,0.0248-0.0354,0.0684-0.0456,0.10677-0.0586,0.0144-0.008,0.0002-0.0251,0.0187-0.0297z'/%3E %3Cpath d='m497.73,306.93c0.0834,0.13618,0.16632,0.27273,0.25015,0.40867,0.0128,0.0361,0.0535,0.0286,0.0758,0.0122,0.01,0.009,0.005,0.0147-0.005,0.0192-0.0468,0.0297-0.0936,0.0594-0.14036,0.0891-0.0187-0.0161,0.0107-0.0208,0.0189-0.034,0.0186-0.0258-0.007-0.0535-0.0197-0.0767-0.0246-0.0403-0.0492-0.0805-0.0738-0.12074-0.006,0.0505-0.0219,0.10886-0.0723,0.13205-0.0602,0.0277-0.13267-0.004-0.17135-0.0531-0.049-0.0585-0.0743-0.14158-0.0466-0.21533,0.0202-0.0584,0.075-0.11088,0.13938-0.11081,0.0256,0.002,0.0203-0.0445,0.0453-0.0505zm0.0933,0.27666c-0.0321-0.0519-0.0631-0.10445-0.0959-0.15593-0.0206-0.0369-0.0715-0.0435-0.10463-0.0202-0.0487,0.03-0.0556,0.0986-0.0318,0.1468,0.0243,0.0538,0.064,0.11368,0.12785,0.12119,0.0479,0.007,0.0979-0.029,0.10271-0.0781-0.004,0.0006,0.007-0.0149,0.002-0.0138z'/%3E %3Cpath d='m498.08,306.74c0.0486,0.0787,0.0956,0.15843,0.14573,0.23619,0.0128,0.0335,0.0524,0.0268,0.0661,0.004,0.01,0.004,0.0108,0.0101,0.003,0.0172-0.0207,0.0287-0.0405,0.0584-0.0618,0.0864-0.007,0.003-0.015,0.0137-0.0179,0.001-0.0119-0.0194-0.0238-0.0388-0.0356-0.0583-0.0102,0.045-0.0163,0.0984-0.0576,0.12675-0.0358,0.0291-0.0916,0.0194-0.11947-0.016-0.0326-0.0384-0.0556-0.0837-0.0827-0.12603-0.0185-0.0287-0.0338-0.0598-0.056-0.0858-0.0194-0.022-0.0491,0.006-0.0645,0.005-0.009-0.008-0.003-0.0123,0.005-0.0162,0.0317-0.0201,0.0634-0.0402,0.0951-0.0604,0.0442,0.0719,0.0877,0.14421,0.1323,0.21588,0.0178,0.0425,0.0773,0.0513,0.10349,0.0122,0.0143-0.023,0.0381-0.0569,0.0266-0.0835-0.0353-0.0575-0.0701-0.11514-0.10561-0.17243-0.0138-0.0323-0.0516-0.0237-0.073-0.009-0.006-0.007-0.01-0.0137,0.002-0.017,0.0317-0.0201,0.0634-0.0402,0.0951-0.0603z'/%3E %3Cpath d='m498.27,306.76c0.0276,0.0483,0.075,0.0905,0.1329,0.0932,0.0542,0.005,0.11067-0.0363,0.11482-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0547,0.023-0.005,0.0176,0.0319,0.0238,0.0458,0.007,0.0526-0.006,0.113-0.0504,0.14611-0.0432,0.0355-0.10602,0.0399-0.15563,0.0158-0.0564-0.0271-0.0928-0.0831-0.1136-0.14031-0.0244-0.0652-0.006-0.14587,0.0511-0.18814,0.0378-0.0313,0.0927-0.0435,0.13835-0.0226,0.0267,0.0121,0.0625,0.0406,0.0657,0.0659-0.0687,0.0437-0.13735,0.0874-0.20602,0.13108zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14042-0.0891-0.0186-0.0338-0.0571-0.0609-0.0968-0.0483-0.0484,0.013-0.0691,0.0732-0.0519,0.11738,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m498.63,306.15c0.086,0.14022,0.17122,0.28092,0.25767,0.42084,0.0129,0.0377,0.0552,0.0283,0.0771,0.0155,0.009,0.008,0.003,0.0132-0.006,0.0172-0.0457,0.029-0.0914,0.058-0.13711,0.087-0.0208-0.021,0.03-0.0248,0.0223-0.0503-0.004-0.0298-0.0248-0.0535-0.039-0.0792-0.0593-0.0964-0.11741-0.19349-0.17767-0.28926-0.01-0.0264-0.0444-0.0464-0.0619-0.0153-0.003,0.0122-0.0258-0.003-0.0122-0.01,0.0211-0.0292,0.0413-0.0594,0.063-0.0879,0.005-0.003,0.009-0.006,0.0138-0.009z'/%3E %3Cpath d='m498.93,306.35c0.0276,0.0483,0.0749,0.0905,0.13286,0.0932,0.0542,0.005,0.11073-0.0363,0.11486-0.0923,0.005-0.0169-0.006-0.0432-0.00098-0.0546,0.023-0.005,0.0176,0.0319,0.0238,0.0459,0.007,0.0526-0.006,0.11298-0.0504,0.14611-0.0431,0.0355-0.10601,0.0399-0.1556,0.0158-0.0564-0.0271-0.0928-0.0831-0.1136-0.14031-0.0244-0.0652-0.006-0.14588,0.0511-0.18814,0.0379-0.0313,0.0927-0.0435,0.13838-0.0226,0.0267,0.0121,0.0624,0.0406,0.0656,0.0659-0.0687,0.0437-0.13735,0.0874-0.20602,0.13108zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14042-0.0891-0.0186-0.034-0.057-0.0604-0.0968-0.0487-0.0482,0.0135-0.0691,0.0734-0.0519,0.11775,0.002,0.007,0.005,0.0136,0.008,0.0201z'/%3E %3Cpath d='m495.2,309.52c0.0458,0.075,0.0917,0.14993,0.13749,0.22489,0.009-0.0489,0.0204-0.10685,0.0687-0.13219,0.0436-0.0264,0.0967,0.002,0.12174,0.0407,0.0423,0.0593,0.076,0.12428,0.11704,0.18439,0.0138,0.0303,0.0489,0.0138,0.0657,0.008,0.0113,0.0103-0.003,0.0143-0.011,0.0198-0.0442,0.0281-0.0884,0.0561-0.13266,0.0842-0.0197-0.0197,0.0237-0.0213,0.0254-0.0415,0.009-0.027-0.0143-0.0488-0.0259-0.0712-0.0318-0.0503-0.0601-0.10305-0.0961-0.15059-0.0308-0.0432-0.0915-0.0138-0.10552,0.0285-0.007,0.0216-0.0234,0.0478-0.005,0.0672,0.0353,0.0569,0.069,0.11487,0.10564,0.17091,0.0149,0.0346,0.0539,0.004,0.0701,0.006,0.0109,0.0102-0.007,0.0134-0.0131,0.0192-0.0442,0.0281-0.0884,0.0561-0.13261,0.0841-0.0204-0.0223,0.037-0.0292,0.0239-0.0584-0.0133-0.037-0.0378-0.0688-0.0573-0.10282-0.0547-0.0885-0.10755-0.17808-0.16373-0.2656-0.0132-0.0349-0.0515-0.0241-0.0664-0.004-0.0142-0.005-0.005-0.0135,0.001-0.0215,0.0198-0.0271,0.0384-0.0553,0.0589-0.0816,0.004-0.003,0.009-0.006,0.0135-0.009z'/%3E %3Cpath d='m495.88,309.68c-0.0161,0.038-0.0243,0.084-0.0609,0.1087-0.0422,0.0349-0.10789,0.0122-0.1288-0.0357-0.0228-0.0398-0.004-0.0869,0.0161-0.12353,0.0222-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0313-0.0542-0.06-0.0662-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0264,0.0338,0.0174,0.0542-0.0178,0.0388-0.0704,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0987,0.0727-0.12403,0.0339-0.0213,0.0798-0.0412,0.11755-0.018,0.0279,0.0198,0.0425,0.0521,0.0607,0.0802,0.0283,0.0455,0.0548,0.0922,0.0856,0.13618,0.0189,0.0259,0.0416-0.005,0.0409-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.0709-0.01,0.0376-0.0629,0.058-0.085,0.0192l-0.004-0.006-0.004-0.006-0.0002,0.00022zm-0.0133-0.0218c-0.0239-0.0391-0.0477-0.0781-0.0716-0.11714-0.0269,0.0399-0.0637,0.0792-0.0658,0.12982-0.001,0.0408,0.0411,0.0814,0.0821,0.0676,0.0317-0.0133,0.0443-0.0513,0.0552-0.0803z'/%3E %3Cpath d='m495.96,309.33c0.002-0.0521,0.0223-0.11159,0.0751-0.13184,0.0634-0.0261,0.13661,0.009,0.17397,0.0622,0.0415,0.0528,0.0634,0.12446,0.0437,0.19039-0.0154,0.0657-0.0698,0.11947-0.1361,0.13261-0.0234,0.00021-0.0613,0.0183-0.0781-0.001-0.0714-0.11629-0.14183-0.23324-0.21404-0.34905-0.0106-0.0271-0.0465-0.0532-0.0665-0.0189-0.004,0.0132-0.0251-0.004-0.0114-0.0107,0.0213-0.0292,0.0416-0.0595,0.0635-0.0881,0.007-0.005,0.0157-0.0128,0.0189,0.0002,0.0437,0.0715,0.0874,0.14294,0.13106,0.21441zm0.0131,0.0215c0.0375,0.0613,0.075,0.12263,0.11245,0.18394,0.0442,0.0114,0.10361,0.00038,0.12055-0.0478,0.0227-0.0583-0.006-0.12083-0.04-0.16806-0.0276-0.0404-0.0792-0.0712-0.1288-0.056-0.0385,0.0121-0.0568,0.0514-0.0642,0.0879z'/%3E %3Cpath d='m496.17,308.9c0.0473-0.0319,0.0875,0.054,0.0346,0.072-0.0447,0.0174-0.0755-0.0479-0.0346-0.072zm0.12577,0.14333c0.0532,0.0866,0.10569,0.17374,0.1594,0.26006,0.0125,0.0301,0.049,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0315-0.0251,0.0236-0.0513-0.003-0.0294-0.024-0.0527-0.0379-0.0779-0.0309-0.0493-0.0591-0.10027-0.0933-0.14738-0.0149-0.0264-0.0449-0.008-0.0563,0.009-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0212-0.0292,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0136-0.009z'/%3E %3Cpath d='m496.71,309.15c-0.0161,0.038-0.0243,0.084-0.0609,0.10867-0.0422,0.0349-0.10785,0.0122-0.1288-0.0357-0.0228-0.0397-0.004-0.0869,0.0161-0.12343,0.0222-0.0383,0.049-0.0738,0.0759-0.10895-0.015-0.0258-0.0313-0.0542-0.06-0.0662-0.0416-0.0135-0.098,0.0315-0.0755,0.0755,0.0101,0.0162,0.0263,0.0338,0.0174,0.0542-0.0178,0.0388-0.0704,0.013-0.0697-0.0235-0.007-0.0522,0.0301-0.0987,0.0727-0.12403,0.0339-0.0213,0.0798-0.0411,0.11755-0.0179,0.0279,0.0198,0.0425,0.052,0.0607,0.0802,0.0284,0.0455,0.0548,0.0922,0.0856,0.13618,0.0189,0.0259,0.0416-0.005,0.0408-0.0267,0.001-0.012,0.003-0.0184,0.009-0.006,0.0153,0.0206-0.002,0.0491-0.007,0.0709-0.01,0.0376-0.0629,0.058-0.085,0.0192-0.005,0.00049-0.004-0.0132-0.009-0.0122zm-0.0133-0.0218c-0.0239-0.039-0.0477-0.0781-0.0716-0.11715-0.0269,0.0399-0.0636,0.0792-0.0659,0.12982-0.001,0.0408,0.0411,0.0814,0.0821,0.0676,0.0317-0.0134,0.0442-0.0513,0.0553-0.0803z'/%3E %3Cpath d='m496.81,308.82c0.007-0.0516,0.0227-0.11252,0.0743-0.13645,0.0441-0.0225,0.0942,0.008,0.1185,0.0453,0.0388,0.058,0.0726,0.11922,0.1108,0.17759,0.0132,0.032,0.0512,0.0231,0.0703,0.0119,0.009,0.008,0.003,0.0132-0.006,0.0171-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0106-0.0108-0.004-0.0172,0.009-0.0228,0.0346-0.0214,0.0111-0.0606-0.006-0.0847-0.0296-0.0473-0.0571-0.096-0.0883-0.14222-0.0202-0.042-0.0775-0.047-0.10221-0.007-0.0134,0.0229-0.0382,0.0566-0.0241,0.0828,0.0355,0.0574,0.0698,0.11561,0.10621,0.1725,0.0137,0.0353,0.0537,0.018,0.073,0.009,0.009,0.008,0.003,0.0132-0.006,0.0171-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0118-0.0119-0.002-0.0169,0.0102-0.0238,0.029-0.0239,0.003-0.0596-0.0116-0.0841-0.0349-0.0559-0.0675-0.11327-0.105-0.16739-0.0149-0.0267-0.0455-0.01-0.057,0.007-0.008-0.005-0.0145-0.01-0.005-0.0171,0.0212-0.029,0.0414-0.0591,0.0632-0.0875,0.007-0.005,0.0149-0.0127,0.0181-0.00015,0.0117,0.0189,0.0234,0.0379,0.0351,0.0569z'/%3E %3Cpath d='m497.57,308.52c0.0218,0.0554,0.022,0.12256-0.0136,0.17238-0.0314,0.0455-0.0925,0.0657-0.1453,0.05-0.0656-0.016-0.11196-0.0732-0.13761-0.13289-0.0334-0.0755-0.009-0.17521,0.0634-0.21873,0.0381-0.0261,0.0916-0.0331,0.13177-0.008,0.0296,0.0155,0.0271,0.0615-0.007,0.0697-0.046,0.0211-0.055-0.0595-0.10189-0.0414-0.0479,0.0126-0.0682,0.0674-0.0561,0.11218,0.015,0.0639,0.0618,0.12138,0.12355,0.14516,0.0492,0.0204,0.10834-0.0107,0.126-0.0595,0.0147-0.0268,0.003-0.0646,0.007-0.0883,0.003-0.00034,0.006-0.00069,0.009-0.001z'/%3E %3Cpath d='m497.58,308.24c0.0141,0.023,0.0282,0.0461,0.0423,0.0691-0.001-0.0412-0.001-0.0924,0.0359-0.11873,0.0354-0.0314,0.0955,0.0197,0.0603,0.056-0.0215,0.0247-0.0731-0.0123-0.0774,0.032-0.00095,0.0224-0.01,0.0496,0.005,0.0691,0.0306,0.0495,0.0603,0.0997,0.0915,0.14879,0.0155,0.0342,0.059,0.0322,0.0829,0.0168,0.004,0.006,0.008,0.0123-0.002,0.015-0.0493,0.0313-0.0986,0.0626-0.14789,0.0939-0.0185-0.0185,0.02-0.0227,0.023-0.0413,0.01-0.0253-0.0115-0.0466-0.0229-0.0675-0.0341-0.0551-0.0667-0.11114-0.10255-0.16513-0.014-0.029-0.0492-0.014-0.061,0.006-0.004-0.005-0.014-0.009-0.006-0.0146,0.022-0.0302,0.0433-0.0613,0.0659-0.091,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m497.83,308.23c0.0277,0.0482,0.0749,0.0905,0.13276,0.0932,0.0542,0.005,0.11073-0.0363,0.11486-0.0922,0.005-0.0169-0.006-0.0432-0.00098-0.0546,0.023-0.005,0.0176,0.0319,0.0238,0.0459,0.007,0.0526-0.006,0.11298-0.0504,0.14611-0.0431,0.0355-0.10601,0.0399-0.15561,0.0158-0.0564-0.0271-0.0928-0.0831-0.11364-0.14031-0.0243-0.0652-0.006-0.14588,0.0512-0.18816,0.0379-0.0312,0.0927-0.0435,0.13839-0.0226,0.0267,0.0121,0.0624,0.0406,0.0657,0.0659-0.0686,0.0437-0.13729,0.0874-0.20593,0.13111zm-0.0119-0.0195c0.0468-0.0297,0.0936-0.0594,0.14041-0.0891-0.0186-0.0338-0.0571-0.0608-0.0968-0.0483-0.0485,0.013-0.0689,0.0733-0.0518,0.11743,0.002,0.007,0.005,0.014,0.008,0.02z'/%3E %3Cpath d='m497.99,307.74c0.0473-0.0319,0.0875,0.054,0.0346,0.072-0.0448,0.0172-0.0753-0.0474-0.0346-0.072zm0.12577,0.14333c0.0532,0.0866,0.10569,0.17374,0.1594,0.26006,0.0125,0.0301,0.0491,0.0388,0.0727,0.0157,0.005,0.007,0.01,0.0146-0.002,0.0178-0.0462,0.0293-0.0924,0.0586-0.13852,0.0879-0.0206-0.0213,0.0315-0.0251,0.0236-0.0513-0.003-0.0294-0.024-0.0527-0.0379-0.0779-0.0308-0.0493-0.0591-0.10027-0.0933-0.14739-0.0149-0.0264-0.0449-0.008-0.0563,0.008-0.008-0.005-0.0142-0.009-0.005-0.0167,0.0213-0.0291,0.0416-0.0592,0.0634-0.0878,0.005-0.003,0.009-0.006,0.0136-0.009z'/%3E %3Cpath d='m498.59,307.99c-0.008,0.0542-0.0461,0.10529-0.10132,0.11708-0.0705,0.0156-0.14265-0.0274-0.17666-0.0884-0.0391-0.0643-0.0477-0.15079-0.0111-0.21801,0.0265-0.0439,0.0793-0.0794,0.1323-0.0672-0.0253-0.0402-0.048-0.0821-0.0768-0.1199-0.0172-0.0266-0.0436,0.001-0.0556,0.0105-0.0125-0.005-0.007-0.0126,0.0001-0.0203,0.0199-0.0274,0.0388-0.056,0.0593-0.0827,0.008-0.006,0.0162-0.0114,0.0197,0.002,0.0786,0.12806,0.15623,0.25679,0.23565,0.38438,0.0104,0.0266,0.0469,0.0546,0.0668,0.0201,0.005-0.0145,0.0238,0.005,0.01,0.0117-0.0206,0.0286-0.0402,0.0584-0.0614,0.0863-0.008,0.005-0.016,0.0141-0.0192,0.00043-0.007-0.0119-0.0143-0.0239-0.0215-0.0358zm-0.0144-0.0235c-0.0323-0.0528-0.0645-0.10561-0.0968-0.15842-0.0249-0.0372-0.0779-0.0606-0.1189-0.035-0.0453,0.0303-0.044,0.0949-0.0243,0.13998,0.0256,0.059,0.0696,0.12197,0.13795,0.13234,0.0386,0.008,0.0813-0.0132,0.094-0.0514,0.004-0.009,0.006-0.0182,0.008-0.0275z'/%3E %3Cpath d='m498.69,307.54c0.0462-0.0315,0.1083-0.0357,0.15839-0.0109,0.0736,0.0325,0.11536,0.11331,0.11646,0.19146,0.003,0.0625-0.0331,0.12343-0.0879,0.15283-0.0501,0.031-0.1153,0.0249-0.16386-0.006-0.0788-0.0461-0.11613-0.1477-0.0935-0.23482,0.0113-0.0379,0.0372-0.0714,0.0704-0.0926zm0.003,0.0283c-0.0386,0.0232-0.044,0.0757-0.0279,0.11433,0.0251,0.0648,0.0712,0.12437,0.1346,0.15503,0.0397,0.0217,0.0961,0.008,0.11462-0.0353,0.0207-0.0455-0.005-0.0939-0.0283-0.13281-0.0309-0.0504-0.0746-0.0998-0.13474-0.113-0.02-0.004-0.0426,0.002-0.0583,0.0117z'/%3E %3Cpath d='m497.67,298.28c0.0275,0.0449,0.0549,0.0898,0.0824,0.1347-0.0186,0.0194-0.0279-0.0255-0.0459-0.0293-0.0492-0.0443-0.1393-0.0325-0.17128,0.0267-0.0204,0.0356-0.002,0.0895,0.0411,0.0951,0.0747,0.0128,0.15064-0.009,0.2254,0.002,0.0616,0.0111,0.10531,0.0766,0.0921,0.13771-0.011,0.0678-0.074,0.11567-0.13841,0.12855-0.0253,0.005-0.0719,0.0146-0.0536,0.0489-0.008,0.009-0.0126,0.004-0.0165-0.005-0.0248-0.0406-0.0496-0.0812-0.0744-0.12182,0.0192-0.0194,0.0301,0.0263,0.0487,0.0301,0.053,0.0444,0.13937,0.0233,0.17777-0.0303,0.0316-0.0412,0.006-0.10629-0.0459-0.11377-0.0521-0.008-0.1049,0.003-0.15731,0.0009-0.0467,0.002-0.10043-0.008-0.12794-0.0499-0.0396-0.0539-0.0187-0.13476,0.0343-0.17169,0.0326-0.0317,0.0828-0.0255,0.11866-0.0467,0.0109-0.0147-0.01-0.0296,0.0108-0.0357z'/%3E %3Cpath d='m497.79,298.17c0.0404-0.0272,0.0749,0.0464,0.0293,0.0618-0.0383,0.0141-0.0641-0.041-0.0293-0.0618zm0.10762,0.12263c0.0455,0.0741,0.0905,0.14865,0.13637,0.22254,0.0108,0.0269,0.0436,0.0305,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0183,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11995-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.0361-0.0513,0.055-0.0761,0.004-0.003,0.007-0.005,0.0113-0.008z'/%3E %3Cpath d='m498.11,298.18c0.0407-0.0258,0.0814-0.0517,0.12212-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0294,0.0124-0.0162,0.0486,0.008,0.0586,0.0489,0.0351,0.0979,0.0702,0.14685,0.10534-0.0111-0.0662-0.0219-0.13243-0.0332-0.19859,0.00071-0.021-0.0213-0.0339-0.0378-0.0188-0.004,0.0114-0.0183-0.007-0.0108-0.009,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.005,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0437-0.009,0.0657,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15519-0.11084-0.23272-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.002-0.004-0.005-0.005-0.007z'/%3E %3Cpath d='m498.54,297.9c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0927,0.18256-0.008,0.0774-0.0885,0.14127-0.16572,0.12365-0.0685-0.0147-0.12178-0.0757-0.13176-0.14437-0.008-0.0429-0.00081-0.09,0.0279-0.12411,0.01-0.0123,0.0217-0.0233,0.0351-0.0314zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0264,0.0495,0.0664,0.0972,0.12181,0.11427,0.0395,0.0127,0.0852-0.018,0.0872-0.0598,0.00078-0.0459-0.0266-0.0866-0.0526-0.12229-0.0308-0.0388-0.0831-0.0818-0.13528-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m498.87,297.69c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0984-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.019,0.0506-0.0741,0.0665-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0232,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00044-0.0804,0.0122-0.11809-0.003-0.0464-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.036,0.0685-0.0345,0.0973-0.0575-0.00095-0.0122,0.00032-0.0135,0.009-0.0184z'/%3E %3Cpath d='m499.06,297.58c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0926,0.18256-0.008,0.0774-0.0885,0.14127-0.16575,0.12365-0.0685-0.0148-0.12174-0.0757-0.13172-0.14437-0.009-0.046,0.00092-0.0967,0.034-0.13134,0.009-0.009,0.0182-0.0177,0.029-0.0242zm0.003,0.0242c-0.0426,0.0262-0.0352,0.0849-0.0132,0.12226,0.0265,0.0496,0.0664,0.0972,0.12181,0.11427,0.0396,0.0127,0.0852-0.0181,0.0872-0.0599,0.00079-0.0459-0.0266-0.0866-0.0525-0.12229-0.0307-0.0388-0.0832-0.0818-0.13529-0.0588l-0.008,0.004-0.0001,0.0001z'/%3E %3Cpath d='m499.24,297.34c0.0176,0.0288,0.0352,0.0577,0.0528,0.0865,0.0202-0.0128,0.0404-0.0257,0.0606-0.0385,0.004,0.007,0.008,0.0134,0.0123,0.0201-0.0202,0.0128-0.0404,0.0257-0.0606,0.0385,0.0361,0.0589,0.0719,0.11791,0.10815,0.17668,0.01,0.0247,0.0459,0.0363,0.0601,0.009,0.0113-0.0121-0.001-0.0327,0.0168-0.038,0.011,0.0382-0.003,0.091-0.0446,0.10459-0.0372,0.0125-0.0663-0.0201-0.0816-0.0497-0.0351-0.0574-0.0702-0.11481-0.10528-0.17221-0.0137,0.009-0.0274,0.0174-0.0411,0.0261-0.0146-0.0138,0.0118-0.028,0.011-0.0444,0.0143-0.0363,0.006-0.0781,0.005-0.11346,0.002-0.002,0.004-0.003,0.006-0.005z'/%3E %3Cpath d='m499.46,297.32c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00052-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12644,0.0132,0.0296,0.0501,0.0278,0.071,0.0143,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0123-0.0251-0.0408-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m499.7,297.17c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0927,0.18256-0.008,0.0774-0.0885,0.14127-0.16572,0.12365-0.0685-0.0148-0.12184-0.0757-0.13177-0.14437-0.008-0.0429-0.00081-0.09,0.0279-0.12411,0.01-0.0124,0.0217-0.0232,0.0351-0.0314zm0.003,0.0242c-0.0426,0.0262-0.0352,0.0849-0.0132,0.12226,0.0265,0.0496,0.0664,0.0972,0.12181,0.11427,0.0395,0.0127,0.0852-0.018,0.0872-0.0598,0.00079-0.0459-0.0266-0.0866-0.0525-0.12229-0.0307-0.0388-0.0832-0.0818-0.13529-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m500.03,296.96c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.019,0.0506-0.0741,0.0665-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0232,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00044-0.0804,0.0122-0.11809-0.003-0.0464-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.036,0.0685-0.0345,0.0973-0.0575-0.00095-0.0122,0.00032-0.0135,0.009-0.0184z'/%3E %3Cpath d='m497.95,299.35c0.0204-0.028,0.04-0.0568,0.061-0.0842,0.007-0.007,0.0125-0.006,0.0157,0.003,0.0105,0.0172,0.0211,0.0344,0.0316,0.0516-0.002-0.042,0.006-0.0913,0.0448-0.1153,0.0396-0.0275,0.0935-0.0153,0.12895,0.0134,0.062,0.0509,0.0984,0.14039,0.0708,0.21852-0.0166,0.0431-0.0597,0.077-0.10635,0.0789-0.014-0.002-0.025-0.005-0.0136,0.008,0.0206,0.0325,0.0389,0.0667,0.0621,0.0975,0.0161,0.0228,0.0435-0.006,0.0568-0.003,0.009,0.008-0.00019,0.0109-0.007,0.015-0.0414,0.0263-0.0828,0.0525-0.1242,0.0788-0.0105-0.01-0.004-0.0146,0.007-0.0196,0.0338-0.0208,0.009-0.0562-0.007-0.0799-0.0525-0.0854-0.10415-0.17131-0.15719-0.25636-0.0111-0.0313-0.0442-0.0175-0.0575-0.002-0.002-0.002-0.005-0.003-0.007-0.005zm0.11858-0.0119c0.0277,0.0443,0.0534,0.09,0.0832,0.13285,0.0264,0.0344,0.082,0.0276,0.10682-0.005,0.0281-0.0378,0.0119-0.0891-0.009-0.12621-0.0244-0.0424-0.0634-0.0883-0.11676-0.0871-0.0435,0.004-0.0603,0.0484-0.0641,0.0856z'/%3E %3Cpath d='m498.34,299.19c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0492,0.004,0.10025-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12507-0.0408,0.0337-0.10189,0.0341-0.14603,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11792,0.0543-0.14941,0.0332-0.0252,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0374-0.11801,0.0748-0.17702,0.11223zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0188,0.0274-0.0164,0.0639-0.002,0.0921z'/%3E %3Cpath d='m498.56,298.9c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m498.8,298.84c0.009-0.0453,0.0207-0.0998,0.0683-0.11958,0.0298-0.0141,0.0664-0.003,0.0874,0.021,0.006-0.0461,0.021-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.10729,0.0442,0.032,0.0494,0.0605,0.10099,0.0934,0.14978,0.0116,0.0283,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0366,0.0232-0.0732,0.0465-0.10985,0.0697-0.0187-0.02,0.0353-0.0245,0.0228-0.0514-0.0107-0.0278-0.0293-0.0519-0.0441-0.0777-0.0217-0.0337-0.0398-0.07-0.0657-0.10063-0.0371-0.0384-0.0891,0.009-0.0971,0.0495-0.0105,0.0158-0.007,0.0306,0.005,0.0433,0.0296,0.0476,0.0576,0.0961,0.0884,0.14292,0.0126,0.0302,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0377,0.0239-0.0753,0.0478-0.11297,0.0717-0.0177-0.0198,0.0333-0.0249,0.0235-0.0507-0.007-0.0251-0.0246-0.0456-0.037-0.0683-0.0227-0.0355-0.0422-0.0733-0.0683-0.10645-0.0303-0.0387-0.0854-0.009-0.0968,0.031-0.009,0.0179-0.017,0.0391-0.001,0.0551,0.03,0.0481,0.0582,0.0975,0.0897,0.14468,0.0129,0.0283,0.0451,0.008,0.0597,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11144,0.0707-0.018-0.0191,0.0318-0.0242,0.0196-0.0492-0.0127-0.035-0.0358-0.0649-0.0542-0.0971-0.0219-0.0337-0.0393-0.0712-0.0678-0.0998-0.0167-0.0136-0.0443,0.0344-0.0448,0.006,0.0192-0.0262,0.0373-0.0534,0.0571-0.0789,0.009-0.0102,0.0147-0.005,0.0192,0.006,0.009,0.0139,0.0178,0.0278,0.0267,0.0417z'/%3E %3Cpath d='m499.42,298.68c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.05,0.01-0.0951-0.0439-0.0866-0.0918,0.0107-0.055,0.0488-0.0986,0.0805-0.14279,0.0145-0.0111-0.008-0.0249-0.0115-0.0362-0.0194-0.0403-0.0776-0.0391-0.0976-0.00063-0.01,0.0163-0.003,0.0347,0.007,0.0482,0.0203,0.0196,0.005,0.0595-0.0253,0.0509-0.0445-0.0226-0.0284-0.0874,0.002-0.11585,0.0311-0.0292,0.074-0.058,0.11857-0.0485,0.0308,0.009,0.0449,0.0404,0.0612,0.0654,0.0249,0.0403,0.0488,0.0811,0.0749,0.1207,0.008,0.0219,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0349-0.0245,0.0956-0.0689,0.0745-0.01-0.005-0.0159-0.0185-0.0226-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.033-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m499.5,298.39c0.007-0.0439,0.0195-0.0964,0.0636-0.11676,0.0378-0.0194,0.0807,0.006,0.10141,0.0387,0.0332,0.0496,0.0622,0.10202,0.0949,0.15199,0.0112,0.0256,0.0427,0.0219,0.0596,0.009,0.006,0.007,0.006,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11951,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0192,0.0305-0.0187,0.009-0.0521-0.006-0.0732-0.0242-0.039-0.0472-0.0787-0.0723-0.11709-0.0158-0.0342-0.063-0.0476-0.0867-0.0139-0.0141,0.0197-0.0347,0.0498-0.0246,0.0738,0.0306,0.0495,0.0602,0.0996,0.0915,0.14858,0.0116,0.0298,0.0461,0.0153,0.0625,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.0251-0.079,0.0502-0.11852,0.0753-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.019,0.008-0.0535-0.006-0.0754-0.0288-0.0465-0.0562-0.0938-0.0867-0.13925-0.0124-0.0282-0.041-0.0112-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0155-0.00038,0.01,0.0166,0.02,0.0331,0.03,0.0496z'/%3E %3Cpath d='m499.79,298.27c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10189,0.0341-0.14603,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0546,0.006-0.11792,0.0543-0.14934,0.0332-0.0251,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0374-0.11808,0.0748-0.17712,0.11224zm-0.0102-0.0167c0.04-0.0254,0.0801-0.0508,0.12014-0.0762-0.0201-0.0459-0.0897-0.0615-0.11864-0.0159-0.0188,0.0274-0.0164,0.064-0.001,0.0921z'/%3E %3Cpath d='m500.26,298.06c0.0185,0.0474,0.0192,0.10488-0.0114,0.14747-0.0268,0.039-0.0792,0.0561-0.12433,0.0428-0.0588-0.0145-0.0998-0.0672-0.1207-0.12143-0.0241-0.0633-0.002-0.14388,0.0573-0.17938,0.0366-0.0251,0.097-0.0315,0.1261,0.008,0.0234,0.0387-0.0478,0.0692-0.0635,0.0274-0.0329-0.0469-0.0986,0.006-0.0936,0.0512-0.00059,0.0477,0.0265,0.092,0.0609,0.12318,0.028,0.0243,0.0682,0.0437,0.10503,0.0283,0.0457-0.0167,0.0643-0.07,0.0552-0.11496-0.004-0.014-0.00035-0.0102,0.009-0.0122z'/%3E %3Cpath d='m500.3,297.94c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10189,0.0341-0.14603,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11797,0.0543-0.14944,0.0332-0.0251,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0375-0.11808,0.0749-0.17712,0.11234zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.0639-0.001,0.0921z'/%3E %3Cpath d='m500.53,297.65c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00052-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0124-0.0248-0.041-0.0117-0.0515,0.007-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0188-0.0259,0.0371-0.0524,0.0563-0.0779,0.004-0.003,0.008-0.005,0.012-0.008z'/%3E %3Cpath d='m500.75,297.66c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0966-0.0434,0.12503-0.0408,0.0337-0.10189,0.0341-0.14604,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11789,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11772-0.0123,0.0211,0.011,0.0468,0.0329,0.0516,0.0534-0.059,0.0374-0.11807,0.0749-0.17711,0.11234zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0188,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m500.89,297.24c0.0403-0.0272,0.075,0.0466,0.0293,0.0616-0.0386,0.014-0.0639-0.0407-0.0293-0.0616zm0.10761,0.12263c0.0455,0.0741,0.0905,0.14866,0.13639,0.22256,0.0108,0.027,0.0435,0.0304,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0183,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11997-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0113-0.008z'/%3E %3Cpath d='m501.23,297.2c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0982-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0747,0.0454,0.11724-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00042-0.0805,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13136,0.0215-0.0359,0.0685-0.0345,0.0973-0.0575-0.0008-0.0122,0.00008-0.0135,0.009-0.0183z'/%3E %3Cpath d='m498.51,300.12c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0463,0.004,0.0949-0.0312,0.0982-0.0791,0.004-0.014-0.006-0.0377-0.00045-0.0467,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12503-0.0369,0.0304-0.0907,0.0342-0.13314,0.0135-0.0507-0.0245-0.0829-0.076-0.0997-0.12806-0.017-0.0541-0.00025-0.1188,0.0462-0.15299,0.0338-0.0282,0.0839-0.0378,0.12369-0.0167,0.0211,0.011,0.0468,0.0329,0.0516,0.0534-0.059,0.0375-0.11807,0.075-0.17711,0.11256zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m498.76,299.87c0.007-0.0439,0.0195-0.0963,0.0636-0.11673,0.0377-0.0194,0.0806,0.006,0.10131,0.0387,0.0332,0.0496,0.0621,0.10205,0.0948,0.15203,0.0112,0.0256,0.0427,0.0219,0.0596,0.009,0.006,0.007,0.005,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11951,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0191,0.0301-0.0187,0.009-0.0522-0.006-0.0733-0.0242-0.039-0.0472-0.0787-0.0723-0.11708-0.0158-0.0341-0.0629-0.0477-0.0866-0.0139-0.0141,0.0197-0.0347,0.0498-0.0246,0.0738,0.0306,0.0495,0.0602,0.0996,0.0915,0.14858,0.0116,0.0298,0.0461,0.0153,0.0625,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.025-0.079,0.0501-0.11852,0.0752-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.019,0.008-0.0535-0.006-0.0754-0.0288-0.0465-0.0562-0.0938-0.0867-0.13925-0.0125-0.0282-0.041-0.0113-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0154-0.00038,0.01,0.0166,0.0201,0.0332,0.0301,0.0498z'/%3E %3Cpath d='m499.19,299.6c0.009-0.0453,0.0207-0.0998,0.0683-0.11958,0.0298-0.0142,0.0663-0.003,0.0874,0.021,0.006-0.046,0.0209-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.1073,0.0442,0.032,0.0494,0.0606,0.101,0.0934,0.14982,0.0116,0.0283,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0145,0.0179-0.0366,0.0232-0.0732,0.0465-0.10985,0.0697-0.0187-0.02,0.0352-0.0245,0.0229-0.0513-0.0103-0.0273-0.0287-0.0509-0.0432-0.0763-0.022-0.0341-0.0403-0.0709-0.0665-0.10198-0.0371-0.0383-0.0891,0.009-0.097,0.0495-0.0105,0.0158-0.007,0.0306,0.004,0.0433,0.0296,0.0476,0.0576,0.0962,0.0884,0.14292,0.0126,0.0302,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0376,0.0239-0.0753,0.0478-0.11296,0.0716-0.0177-0.0198,0.0333-0.0249,0.0234-0.0508-0.006-0.0252-0.0246-0.0457-0.037-0.0684-0.0227-0.0355-0.0422-0.0733-0.0683-0.10642-0.0302-0.0388-0.0855-0.009-0.0967,0.0311-0.009,0.0179-0.0171,0.039-0.001,0.055,0.03,0.0481,0.0582,0.0975,0.0897,0.14466,0.0129,0.0283,0.0451,0.008,0.0597,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11145,0.0708-0.0181-0.019,0.0318-0.0241,0.0196-0.0491-0.0126-0.035-0.0358-0.0649-0.0542-0.097-0.0219-0.0337-0.0393-0.0713-0.0678-0.0998-0.0167-0.0136-0.0443,0.0344-0.0448,0.006,0.0192-0.0262,0.0373-0.0534,0.0571-0.0789,0.009-0.0102,0.0146-0.005,0.0192,0.006,0.009,0.0139,0.0177,0.0278,0.0266,0.0418z'/%3E %3Cpath d='m499.52,299.12c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14865,0.13637,0.22254,0.0107,0.0269,0.0435,0.0305,0.0627,0.0144,0.006,0.007,0.006,0.0117-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0272-0.0214,0.0207-0.0437-0.003-0.0259-0.0215-0.0462-0.0337-0.0685-0.025-0.0401-0.0484-0.0812-0.0753-0.11996-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.0761,0.004-0.003,0.008-0.005,0.0115-0.008z'/%3E %3Cpath d='m499.84,299.15c0.0204-0.0279,0.04-0.0567,0.061-0.0841,0.007-0.007,0.0125-0.006,0.0157,0.003,0.0105,0.0172,0.0211,0.0345,0.0316,0.0517-0.002-0.042,0.006-0.0912,0.0447-0.1153,0.0396-0.0275,0.0935-0.0153,0.12895,0.0134,0.062,0.0509,0.0984,0.1404,0.0708,0.21852-0.0166,0.0431-0.0597,0.077-0.10635,0.0789-0.014-0.002-0.025-0.005-0.0136,0.008,0.0206,0.0326,0.0389,0.0667,0.0621,0.0975,0.0159,0.0229,0.0435-0.006,0.0568-0.003,0.009,0.008-0.00019,0.0109-0.007,0.015-0.0414,0.0263-0.0828,0.0525-0.12419,0.0788-0.0105-0.009-0.004-0.0157,0.007-0.0206,0.0338-0.0208,0.009-0.0562-0.007-0.0799-0.0525-0.0854-0.10415-0.17131-0.15719-0.25636-0.0111-0.0313-0.0442-0.0176-0.0577-0.002-0.002-0.001-0.004-0.003-0.007-0.004zm0.1186-0.0119c0.0277,0.0443,0.0533,0.0899,0.0832,0.13282,0.0263,0.0344,0.082,0.0277,0.10685-0.005,0.0281-0.0378,0.0119-0.0891-0.009-0.12621-0.0244-0.0424-0.0634-0.0882-0.11676-0.087-0.0435,0.004-0.0601,0.0482-0.0641,0.0856z'/%3E %3Cpath d='m500.43,299.08c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0651-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0851,0.0877-0.10449,0.0373-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0983,0.091,0.14616,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0954-0.0685,0.0745-0.01-0.005-0.0162-0.0183-0.023-0.0239zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m500.39,298.57c0.0736,0.11999,0.14651,0.24036,0.22046,0.3601,0.0113,0.0274,0.0444,0.0303,0.0647,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0182-0.0179,0.026-0.0212,0.0195-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16352-0.15012-0.24455-0.008-0.0222-0.038-0.0403-0.0528-0.0136-0.001,0.0104-0.0221-0.001-0.0111-0.007,0.0183-0.0252,0.0358-0.0514,0.0546-0.0761,0.004-0.002,0.007-0.004,0.0112-0.007z'/%3E %3Cpath d='m500.85,298.81c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0993-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0504-0.0567-0.058-0.0355-0.007-0.08,0.0339-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0652-0.01-0.0574-0.0407,0.003-0.0502,0.0455-0.0851,0.0877-0.10452,0.0373-0.0222,0.0872-0.008,0.10532,0.0317,0.031,0.0483,0.0593,0.0983,0.0909,0.14616,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0954-0.0685,0.0745-0.01-0.005-0.0162-0.0181-0.023-0.0239zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m500.91,298.51c0.001-0.0445,0.0193-0.0955,0.0642-0.11277,0.0514-0.0213,0.11154,0.004,0.14389,0.0465,0.0405,0.048,0.0615,0.11584,0.0401,0.17682-0.016,0.0581-0.0692,0.10208-0.12889,0.10842-0.019-0.00029-0.0489,0.0133-0.0566-0.0111-0.0604-0.0983-0.11981-0.1972-0.18102-0.29499-0.009-0.0236-0.0395-0.0395-0.0544-0.012-0.003,0.0111-0.0214-0.004-0.01-0.01,0.0182-0.025,0.0356-0.0509,0.0544-0.0753,0.006-0.004,0.0135-0.0113,0.0162-0.00011,0.0373,0.0613,0.0746,0.12267,0.1119,0.184zm0.0112,0.0184c0.0321,0.0525,0.0641,0.10493,0.0962,0.1574,0.0443,0.0128,0.1036-0.006,0.10808-0.0587,0.01-0.052-0.019-0.10239-0.0516-0.14062-0.0283-0.0331-0.0832-0.0513-0.11982-0.0209-0.0193,0.0154-0.0272,0.0403-0.0329,0.0628z'/%3E %3Cpath d='m501.18,298.28c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0391-0.006,0.0515,0.0589,0.0107,0.0629-0.0181,0.00097-0.048-0.007-0.0498,0.0202-0.002,0.0194-0.008,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0296,0.0502,0.0279,0.071,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0193,0.0195-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0407-0.0133-0.0515,0.006-0.003-0.004-0.0126-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m501.59,298.34c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14362-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0852,0.0877-0.10459,0.0373-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0983,0.091,0.14616,0.008,0.0219,0.0362,0.0131,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0244,0.0954-0.0685,0.0743-0.01-0.005-0.0165-0.0184-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.0221-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m499.01,300.66c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.0189,0.0507-0.0741,0.0664-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0232,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00039-0.0805,0.013-0.11811-0.003-0.0464-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.0359,0.0685-0.0345,0.0973-0.0575-0.00094-0.0122,0.00031-0.0135,0.009-0.0184z'/%3E %3Cpath d='m499.18,300.7c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12511-0.0408,0.0337-0.10184,0.0341-0.14598,0.007-0.0454-0.0287-0.075-0.0782-0.0889-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0187,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11814,0.0749-0.17721,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m499.4,300.41c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0267-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0215-0.01-0.0398-0.0195-0.0576-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0132-0.0515,0.006-0.003-0.004-0.0126-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m499.63,300.42c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12506-0.0408,0.0337-0.10185,0.0341-0.14599,0.007-0.0454-0.0287-0.075-0.0782-0.0889-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0187,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0375-0.11813,0.0749-0.1772,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m499.76,300.01c0.0403-0.0272,0.075,0.0466,0.0293,0.0616-0.0386,0.014-0.0639-0.0407-0.0293-0.0616zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14865,0.13637,0.22254,0.0108,0.027,0.0435,0.0306,0.0628,0.0145,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0214,0.0207-0.0437-0.003-0.026-0.0215-0.0463-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11995-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0512,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m500.1,299.97c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00024,0.0458,0.0157,0.0665,0.0748,0.0453,0.11725-0.019,0.0507-0.0741,0.0664-0.11952,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0382,0.0293,0.10908,0.0231,0.1259-0.0272,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0805,0.013-0.11811-0.003-0.0465-0.0233-0.0611-0.0906-0.0284-0.13125,0.0215-0.036,0.0685-0.0345,0.0973-0.0575-0.00085-0.0123,0.00014-0.0135,0.009-0.0183z'/%3E %3Cpath d='m500.29,299.85c0.0407-0.0258,0.0814-0.0517,0.12213-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0293,0.0125-0.0161,0.0487,0.008,0.0587,0.0489,0.0351,0.0979,0.0702,0.14685,0.10534-0.0111-0.0662-0.0219-0.13243-0.0332-0.19859,0.0007-0.0211-0.0212-0.0337-0.0377-0.0186-0.004,0.0114-0.0183-0.007-0.0108-0.009,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.006,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0437-0.009,0.0657,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15519-0.11084-0.23272-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.003-0.004-0.005-0.005-0.008z'/%3E %3Cpath d='m500.7,299.73c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0392,0.006,0.045-0.005,0.0967-0.0433,0.12511-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0782-0.089-0.12919-0.0143-0.0547,0.006-0.11796,0.0544-0.14936,0.0347-0.0264,0.0848-0.0324,0.12291-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11814,0.0749-0.17721,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0273-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m500.93,299.44c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0169-0.0193,0.0196-0.0354,0.008-0.0215-0.01-0.0398-0.0195-0.0576-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m501.37,299.49c-0.007,0.0504-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.11672-0.0327-0.14355-0.0848-0.0296-0.054-0.0356-0.12443-0.005-0.1794,0.0196-0.0415,0.0784-0.0638,0.11139-0.0607-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.0147-0.0226-0.0377,0-0.0477,0.009-0.0101-0.004-0.007-0.0102-0.00079-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00014,0.0666,0.10865,0.13263,0.21769,0.19972,0.32606,0.009,0.0236,0.0411,0.0527,0.0597,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.006,0.004-0.0137,0.0114-0.0165-0.00012-0.006-0.01-0.012-0.0194-0.0179-0.029zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0237,0.0456,0.0636,0.091,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m501.63,299.33c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.14364-0.0139-0.0232-0.0288-0.0504-0.0567-0.0579-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0851,0.0877-0.10459,0.0374-0.0222,0.0872-0.008,0.10532,0.0317,0.031,0.0482,0.0593,0.0982,0.0909,0.14608,0.008,0.0218,0.0361,0.013,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0349-0.0246,0.0956-0.0689,0.0743-0.009-0.005-0.0162-0.0182-0.0223-0.0236zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0224,0.0329-0.0517,0.065-0.0562,0.1062-0.007,0.0454,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m501.92,299.14c-0.007,0.0504-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.11673-0.0327-0.14357-0.0848-0.0296-0.054-0.0356-0.12444-0.005-0.17941,0.0196-0.0415,0.0784-0.0638,0.11139-0.0607-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.0147-0.0226-0.0377,0-0.0477,0.009-0.0101-0.004-0.007-0.0102-0.00079-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00014,0.0666,0.10864,0.13263,0.21769,0.19972,0.32605,0.009,0.0236,0.0412,0.0526,0.0598,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.006,0.004-0.0137,0.0113-0.0165-0.00011-0.006-0.01-0.012-0.0194-0.018-0.029zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0797-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0237,0.0455,0.0636,0.091,0.11846,0.0938,0.0414,0.005,0.0725-0.0299,0.0773-0.0686z'/%3E %3Cpath d='m501.99,298.92c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12506-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0782-0.089-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.059,0.0375-0.11807,0.0749-0.17711,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m502.22,298.62c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0297,0.0502,0.0279,0.071,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12654,0.0803-0.0159-0.0157,0.0168-0.0193,0.0195-0.0354,0.008-0.0215-0.01-0.0398-0.0194-0.0576-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0409-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m502.63,298.69c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0527-0.0988,0.0855-0.1436-0.0138-0.0233-0.0288-0.0504-0.0567-0.058-0.0355-0.007-0.08,0.0339-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0502,0.0455-0.0851,0.0877-0.10449,0.0374-0.0222,0.0872-0.008,0.10532,0.0317,0.031,0.0482,0.0593,0.0982,0.091,0.14608,0.008,0.0218,0.0362,0.013,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0349-0.0246,0.0956-0.0689,0.0743-0.009-0.005-0.0161-0.0184-0.0224-0.0236zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0224,0.033-0.0517,0.065-0.0562,0.1063-0.007,0.0453,0.0555,0.0891,0.0891,0.0497,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m502.71,298.4c0.009-0.0453,0.0205-0.0998,0.0682-0.11958,0.0298-0.0142,0.0663-0.003,0.0874,0.021,0.006-0.0461,0.021-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.10729,0.0442,0.032,0.0494,0.0606,0.101,0.0934,0.14983,0.0115,0.0284,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0145,0.0179-0.0366,0.0232-0.0732,0.0465-0.10986,0.0697-0.0187-0.02,0.0353-0.0246,0.0228-0.0514-0.0107-0.0277-0.0293-0.0519-0.044-0.0777-0.0217-0.0337-0.0398-0.07-0.0657-0.10062-0.037-0.0383-0.0892,0.009-0.097,0.0494-0.0105,0.0158-0.007,0.0306,0.004,0.0433,0.0296,0.0476,0.0576,0.0961,0.0884,0.14292,0.0126,0.0302,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0377,0.0239-0.0753,0.0478-0.11298,0.0717-0.0177-0.0198,0.0333-0.0249,0.0235-0.0508-0.006-0.0252-0.0246-0.0457-0.037-0.0684-0.0227-0.0355-0.0422-0.0733-0.0683-0.10642-0.0303-0.0388-0.0854-0.009-0.0968,0.031-0.009,0.0179-0.017,0.039-0.001,0.055,0.03,0.0481,0.0582,0.0975,0.0897,0.14467,0.0129,0.0283,0.0451,0.008,0.0597,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11144,0.0708-0.018-0.0191,0.0318-0.0242,0.0196-0.0492-0.0127-0.0349-0.0358-0.0649-0.0542-0.097-0.0219-0.0337-0.0393-0.0713-0.0678-0.0998-0.0167-0.0136-0.0443,0.0344-0.0448,0.006,0.0192-0.0262,0.0373-0.0534,0.0571-0.0789,0.009-0.0102,0.0147-0.005,0.0192,0.006,0.009,0.014,0.0179,0.028,0.0268,0.042z'/%3E %3Cpath d='m503.15,298.18c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12506-0.0408,0.0337-0.10185,0.0341-0.14599,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12919-0.0143-0.0547,0.006-0.1179,0.0543-0.14936,0.0347-0.0265,0.0848-0.0324,0.12289-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.059,0.0375-0.11807,0.0749-0.1771,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m503.42,297.95c0.007-0.0439,0.0195-0.0963,0.0636-0.11675,0.0378-0.0194,0.0806,0.006,0.10141,0.0387,0.0332,0.0496,0.0621,0.10203,0.0948,0.15201,0.0113,0.0256,0.0427,0.0219,0.0597,0.009,0.006,0.007,0.005,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11951,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0192,0.0304-0.0187,0.009-0.0521-0.006-0.0733-0.0242-0.039-0.0472-0.0787-0.0723-0.11707-0.0158-0.0342-0.063-0.0476-0.0867-0.0139-0.0141,0.0197-0.0347,0.0498-0.0247,0.0738,0.0306,0.0495,0.0601,0.0996,0.0915,0.14858,0.0116,0.0299,0.046,0.0153,0.0624,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.0251-0.079,0.0501-0.11852,0.0752-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.0191,0.008-0.0536-0.006-0.0755-0.0288-0.0464-0.0562-0.0938-0.0867-0.13915-0.0125-0.0282-0.041-0.0113-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0154-0.00038,0.01,0.0166,0.0201,0.0332,0.0301,0.0498z'/%3E %3Cpath d='m503.62,297.62c0.0176,0.0288,0.0352,0.0577,0.0528,0.0865,0.0202-0.0128,0.0404-0.0257,0.0606-0.0385,0.004,0.007,0.008,0.0134,0.0123,0.0201-0.0202,0.0128-0.0404,0.0257-0.0606,0.0385,0.0361,0.0589,0.0719,0.11791,0.10815,0.17669,0.01,0.0247,0.0459,0.0363,0.0601,0.009,0.012-0.012-0.002-0.0327,0.0168-0.038,0.011,0.0382-0.003,0.091-0.0446,0.10459-0.0372,0.0125-0.0662-0.0201-0.0816-0.0497-0.0351-0.0574-0.0702-0.11481-0.10528-0.17222-0.0137,0.009-0.0274,0.0174-0.0411,0.0261-0.0146-0.0138,0.0118-0.028,0.011-0.0444,0.0143-0.0363,0.006-0.0781,0.005-0.11346,0.002-0.002,0.004-0.003,0.006-0.005z'/%3E %3Cpath d='m503.86,297.73c0.0237,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10023-0.036,0.0988-0.0872,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0392,0.006,0.045-0.005,0.0967-0.0434,0.12511-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0782-0.089-0.12919-0.0143-0.0547,0.006-0.11796,0.0544-0.14936,0.0347-0.0264,0.0848-0.0324,0.12291-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11814,0.0749-0.17721,0.11236zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.0201-0.046-0.0898-0.0615-0.11874-0.0159-0.0186,0.0273-0.0166,0.0639-0.001,0.0921z'/%3E %3Cpath d='m499.4,301.51c0.009-0.0453,0.0205-0.0998,0.0682-0.11958,0.0298-0.0141,0.0664-0.003,0.0874,0.021,0.006-0.0461,0.021-0.0986,0.067-0.11921,0.0407-0.0204,0.0869,0.008,0.10728,0.0442,0.032,0.0494,0.0605,0.10099,0.0934,0.14978,0.0116,0.0283,0.045,0.006,0.0578,0.008,0.009,0.009-0.009,0.012-0.0145,0.0179-0.0366,0.0232-0.0732,0.0465-0.10986,0.0697-0.0187-0.02,0.0352-0.0245,0.0229-0.0513-0.0104-0.0273-0.0287-0.0509-0.0432-0.0763-0.022-0.0341-0.0403-0.0709-0.0665-0.10195-0.037-0.0383-0.0892,0.009-0.097,0.0494-0.0105,0.0158-0.007,0.0306,0.004,0.0433,0.0296,0.0476,0.0577,0.0961,0.0884,0.14295,0.0126,0.0301,0.0472,0.002,0.0605,0.005,0.009,0.009-0.009,0.012-0.0146,0.0179-0.0376,0.0239-0.0753,0.0478-0.11296,0.0716-0.0177-0.0198,0.0333-0.0248,0.0235-0.0507-0.007-0.0251-0.0246-0.0456-0.037-0.0683-0.0228-0.0355-0.0422-0.0733-0.0683-0.10646-0.0303-0.0387-0.0854-0.009-0.0968,0.031-0.009,0.0179-0.017,0.039-0.001,0.055,0.03,0.0481,0.0582,0.0975,0.0897,0.14467,0.013,0.0283,0.0451,0.007,0.0598,0.004,0.0105,0.01-0.006,0.0128-0.0125,0.0184-0.0371,0.0236-0.0743,0.0472-0.11144,0.0708-0.018-0.0191,0.0318-0.0242,0.0196-0.0492-0.01-0.0306-0.0305-0.056-0.0462-0.0839-0.0236-0.037-0.0438-0.0766-0.0723-0.1102-0.0181-0.0231-0.0437,0.0323-0.0494,0.005,0.0195-0.0266,0.0379-0.0543,0.058-0.0801,0.009-0.0102,0.0146-0.005,0.0192,0.006,0.009,0.014,0.0178,0.0279,0.0267,0.0419z'/%3E %3Cpath d='m499.72,301.04c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0141-0.0641-0.041-0.0293-0.0618zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14866,0.13639,0.22256,0.0108,0.027,0.0435,0.0303,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0214,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11997-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0252,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0113-0.008z'/%3E %3Cpath d='m500.07,301c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0747,0.0453,0.11724-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0382,0.0293,0.10908,0.0231,0.1259-0.0272,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13136,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00081-0.0122,0.00013-0.0134,0.009-0.0182z'/%3E %3Cpath d='m500.61,301.01c-0.007,0.0504-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.1167-0.0327-0.14347-0.0848-0.0297-0.0539-0.0356-0.12444-0.005-0.17941,0.0196-0.0416,0.0784-0.0636,0.11139-0.0607-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0476,0.009-0.0101-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.0499-0.0525,0.0738-0.006,0.004-0.0137,0.0113-0.0165-0.00015-0.006-0.01-0.012-0.0198-0.018-0.0297zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0798-0.0549-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13127,0.0238,0.0455,0.0636,0.091,0.11846,0.0938,0.0414,0.005,0.0724-0.0299,0.0773-0.0686z'/%3E %3Cpath d='m500.55,300.52c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10761,0.12263c0.0455,0.0741,0.0905,0.14866,0.13639,0.22256,0.0108,0.027,0.0435,0.0303,0.0627,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0463-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11998-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m500.89,300.48c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0665,0.0748,0.0453,0.11734-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0192,0.0382,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0805,0.013-0.11811-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00089-0.0121,0.00025-0.0135,0.009-0.0184z'/%3E %3Cpath d='m501.27,300.47c0.0185,0.0474,0.0192,0.10488-0.0114,0.14748-0.0269,0.039-0.0792,0.0561-0.12434,0.0428-0.0588-0.0145-0.0998-0.0672-0.1207-0.12143-0.0241-0.0633-0.002-0.14388,0.0573-0.17938,0.0366-0.0251,0.097-0.0315,0.1261,0.008,0.0235,0.0387-0.0481,0.0689-0.0637,0.0272-0.0331-0.0468-0.0987,0.006-0.0936,0.0512-0.00061,0.0476,0.0265,0.0919,0.0609,0.12308,0.028,0.0243,0.0682,0.0437,0.10507,0.0284,0.0457-0.0168,0.0643-0.07,0.0552-0.115-0.004-0.0143-0.00019-0.0101,0.009-0.0119z'/%3E %3Cpath d='m501.19,300.11c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0141-0.0641-0.041-0.0293-0.0618zm0.10762,0.12264c0.0455,0.0741,0.0905,0.14866,0.13638,0.22256,0.0107,0.027,0.0434,0.0303,0.0627,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.0263-0.0219-0.0469-0.0343-0.0695-0.0247-0.0398-0.048-0.0805-0.0747-0.11901-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m501.37,300.23c0.0204-0.028,0.04-0.0568,0.061-0.0842,0.007-0.007,0.0125-0.006,0.0157,0.003,0.0105,0.0172,0.0211,0.0344,0.0316,0.0516-0.002-0.042,0.006-0.0913,0.0448-0.1152,0.0396-0.0275,0.0936-0.0154,0.12895,0.0133,0.062,0.0509,0.0984,0.14039,0.0708,0.21852-0.0166,0.0431-0.0597,0.077-0.10635,0.0789-0.014-0.002-0.025-0.005-0.0136,0.008,0.0206,0.0326,0.0389,0.0667,0.0621,0.0975,0.016,0.0229,0.0436-0.006,0.0568-0.003,0.009,0.008-0.00019,0.011-0.007,0.015-0.0414,0.0263-0.0828,0.0525-0.12419,0.0788-0.0105-0.009-0.004-0.0157,0.007-0.0206,0.0338-0.0208,0.009-0.0562-0.007-0.0799-0.0525-0.0854-0.10415-0.17131-0.15719-0.25637-0.0112-0.0312-0.0442-0.0177-0.0577-0.002-0.002-0.001-0.004-0.003-0.007-0.004zm0.11859-0.0119c0.0277,0.0443,0.0534,0.09,0.0832,0.13285,0.0264,0.0344,0.082,0.0276,0.10682-0.005,0.0281-0.0378,0.0119-0.0891-0.009-0.12621-0.0244-0.0424-0.0634-0.0883-0.11676-0.0871-0.0435,0.004-0.0602,0.0484-0.0641,0.0856z'/%3E %3Cpath d='m501.64,299.82c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10762,0.12264c0.0455,0.0741,0.0905,0.14866,0.13638,0.22256,0.0107,0.027,0.0435,0.0303,0.0627,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11997-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0252,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0114-0.008z'/%3E %3Cpath d='m501.82,299.71c0.0736,0.11999,0.14652,0.24037,0.22048,0.36012,0.0113,0.0274,0.0443,0.0302,0.0646,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0182-0.0179,0.026-0.0212,0.0195-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16354-0.15014-0.24458-0.008-0.0222-0.0379-0.0402-0.0529-0.0137-0.002,0.0102-0.0221-0.002-0.0112-0.007,0.0183-0.0252,0.0358-0.0515,0.0546-0.0761,0.004-0.002,0.008-0.004,0.0114-0.006z'/%3E %3Cpath d='m502.1,299.71c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0926,0.18256-0.008,0.0774-0.0885,0.14127-0.16575,0.12365-0.0685-0.0147-0.12174-0.0757-0.13172-0.14437-0.008-0.0429-0.00081-0.09,0.0279-0.12411,0.01-0.0123,0.0217-0.0233,0.0351-0.0314zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0264,0.0495,0.0664,0.0972,0.12181,0.11425,0.0395,0.0126,0.0852-0.0179,0.0872-0.0598,0.00079-0.0459-0.0266-0.0866-0.0525-0.12229-0.0308-0.0389-0.0832-0.0818-0.1354-0.0588l-0.008,0.004z'/%3E %3Cpath d='m502.43,299.5c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0747,0.0453,0.11724-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0155,0.0235,0.0157,0.0379,0.0192,0.0381,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00079-0.0122,0.00007-0.0135,0.009-0.0183z'/%3E %3Cpath d='m500.67,303.76c-0.008-0.0471-0.003-0.10287,0.0363-0.13545,0.0322-0.0293,0.0819-0.0434,0.12173-0.021,0.0458,0.0216,0.0535,0.0794,0.0418,0.1235,0.001,0.01-0.0173,0.0351,0.003,0.0264,0.0507-0.01,0.10375,0.0182,0.12664,0.0641,0.0372,0.0626,0.0207,0.14814-0.0334,0.19573-0.028,0.024-0.06,0.0496-0.0978,0.0537-0.0393,0.005-0.0361-0.053-0.0008-0.0544,0.043-0.002,0.097-0.008,0.11396-0.0555,0.0215-0.0483-0.007-0.10444-0.0516-0.1276-0.0368-0.0198-0.0833-0.0101-0.11794,0.01-0.007,0.007-0.0114,0.006-0.014-0.003,0.0355-0.0307,0.0604-0.0827,0.0412-0.1289-0.0133-0.0464-0.0721-0.0722-0.11271-0.0429-0.0357,0.0178-0.0409,0.0653-0.0477,0.0947-0.003,0.00032-0.006,0.00064-0.009,0.00096z'/%3E %3Cpath d='m501.34,303.66c0.006,0.0307,0.0126,0.0613,0.0189,0.092-0.0756,0.048-0.15113,0.0959-0.22669,0.14385-0.0176-0.0218,0.0108-0.0508,0.0102-0.0755,0.0194-0.0845,0.043-0.17235,0.0258-0.25929-0.009-0.0477-0.0444-0.0971-0.0969-0.0988-0.059-0.004-0.10573,0.0573-0.0967,0.11343,0.004,0.0118,0.005,0.0216-0.007,0.0262-0.0229-0.0475-0.0257-0.10949,0.0102-0.15152,0.037-0.045,0.10455-0.0644,0.15783-0.0376,0.0526,0.0246,0.0715,0.0873,0.0713,0.14139,0.00083,0.0817-0.0208,0.16123-0.036,0.2409-0.004,0.0131-0.008,0.0245,0.006,0.0127,0.0415-0.0268,0.0839-0.0522,0.12449-0.0804,0.0238-0.0133,0.0237-0.0442,0.0323-0.0632,0.002-0.001,0.004-0.003,0.007-0.004z'/%3E %3Cpath d='m501.45,303.62c0.0186-0.0133,0.0477-0.003,0.0542,0.0186,0.009,0.0211-0.006,0.0471-0.0283,0.0506-0.0199,0.004-0.0398-0.0112-0.0425-0.031-0.003-0.0149,0.004-0.0303,0.0166-0.0382z'/%3E %3Cpath d='m501.73,302.97c0.0447-0.0284,0.0893-0.0567,0.13403-0.0851,0.0179,0.0152-0.0151,0.0201-0.0175,0.036-0.0254,0.0418-0.0164,0.092-0.0186,0.13867-0.00053,0.0539-0.001,0.10789-0.002,0.16183,0.0251,0.0399,0.0482,0.0812,0.0749,0.12001,0.0163,0.0297,0.051,0.0178,0.0718,0.00072,0.009,0.00041,0.0111,0.0144-0.001,0.016-0.0509,0.0323-0.10185,0.0646-0.15277,0.0969-0.0103-0.009-0.004-0.0145,0.006-0.0192,0.0379-0.0172,0.026-0.0619,0.004-0.0872-0.018-0.0294-0.036-0.0588-0.054-0.0882-0.0802-0.0372-0.15977-0.076-0.2406-0.11184-0.0217-0.0163-0.0554,0.005-0.0717-0.002-0.009-0.009,0.01-0.0114,0.0147-0.0171,0.0487-0.0309,0.0974-0.0618,0.14606-0.0927,0.0175,0.0148-0.0128,0.0177-0.0176,0.0313-0.0252,0.0332,0.0214,0.0529,0.0463,0.0636,0.049,0.0233,0.0981,0.0466,0.14712,0.07,0.00023-0.0642,0.003-0.12851,0.001-0.19271,0.004-0.0373-0.0404-0.0503-0.064-0.0302-0.002-0.003-0.004-0.006-0.007-0.009z'/%3E %3Cpath d='m502.44,302.93c0.0185,0.0474,0.0192,0.10489-0.0114,0.14749-0.0268,0.039-0.0792,0.0561-0.12433,0.0428-0.0588-0.0145-0.0999-0.0672-0.1207-0.12149-0.0241-0.0633-0.002-0.14386,0.0573-0.17935,0.0367-0.0251,0.0971-0.0315,0.1262,0.008,0.0235,0.0387-0.0478,0.0691-0.0635,0.0273-0.0329-0.0469-0.0986,0.006-0.0936,0.0512-0.00061,0.0476,0.0265,0.0919,0.0609,0.12308,0.028,0.0243,0.0682,0.0437,0.10503,0.0284,0.0457-0.0168,0.0643-0.07,0.0552-0.115-0.004-0.0141-0.0005-0.0102,0.009-0.012z'/%3E %3Cpath d='m502.5,302.66c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0927,0.18256-0.008,0.0774-0.0885,0.14127-0.16572,0.12365-0.0685-0.0147-0.12184-0.0757-0.13177-0.14437-0.009-0.046,0.00092-0.0967,0.034-0.13134,0.008-0.009,0.0183-0.0176,0.029-0.0242zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0265,0.0495,0.0664,0.0972,0.12179,0.11425,0.0395,0.0126,0.0852-0.0179,0.0872-0.0598,0.00079-0.0459-0.0266-0.0865-0.0525-0.12229-0.0308-0.0388-0.0832-0.0818-0.13533-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m502.77,302.55c0.007-0.0439,0.0195-0.0963,0.0636-0.11675,0.0378-0.0194,0.0806,0.006,0.10141,0.0387,0.0332,0.0496,0.0621,0.10205,0.0948,0.15203,0.0113,0.0256,0.0427,0.0219,0.0597,0.009,0.006,0.007,0.005,0.0118-0.003,0.0149-0.0398,0.0253-0.0797,0.0506-0.11952,0.0759-0.009-0.009-0.003-0.0141,0.007-0.0191,0.0304-0.0187,0.009-0.0521-0.006-0.0733-0.0242-0.039-0.0472-0.0787-0.0723-0.11709-0.0158-0.0342-0.063-0.0476-0.0867-0.0139-0.0141,0.0197-0.0347,0.0498-0.0246,0.0738,0.0306,0.0495,0.0602,0.0996,0.0915,0.14858,0.0116,0.0298,0.046,0.0154,0.0624,0.007,0.007,0.007,0.003,0.0111-0.005,0.0145-0.0395,0.0251-0.079,0.0501-0.11853,0.0752-0.007-0.008-0.006-0.0136,0.005-0.0174,0.0303-0.019,0.008-0.0536-0.006-0.0755-0.0288-0.0464-0.0562-0.0938-0.0867-0.13915-0.0125-0.0282-0.041-0.0113-0.0529,0.002-0.008-0.004-0.01-0.009-0.003-0.0151,0.0179-0.0245,0.035-0.0499,0.0534-0.0739,0.006-0.004,0.0128-0.0113,0.0154-0.00038,0.01,0.0166,0.02,0.0332,0.03,0.0498z'/%3E %3Cpath d='m503.08,302.29c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.0645,0.0321,0.0976,0.10743,0.0933,0.17721-0.005,0.0769-0.0814,0.14263-0.15848,0.13046-0.0719-0.0116-0.12926-0.0745-0.13952-0.14583-0.009-0.046,0.00092-0.0967,0.034-0.13134,0.008-0.009,0.0182-0.0176,0.0289-0.0242zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0265,0.0495,0.0664,0.0972,0.12181,0.11425,0.0395,0.0126,0.0852-0.0179,0.0872-0.0598,0.00079-0.0459-0.0266-0.0865-0.0525-0.12229-0.0308-0.0388-0.0832-0.0818-0.13533-0.0588l-0.008,0.004h-0.0001z'/%3E %3Cpath d='m503.57,302.22c0.0185,0.0474,0.0192,0.10486-0.0114,0.14748-0.0269,0.039-0.0792,0.0561-0.12436,0.0428-0.0588-0.0145-0.0999-0.0672-0.1207-0.12149-0.0241-0.0634-0.002-0.14388,0.0573-0.17944,0.0366-0.0251,0.097-0.0315,0.1261,0.008,0.0234,0.0387-0.0478,0.0692-0.0635,0.0274-0.0329-0.0469-0.0986,0.006-0.0936,0.0512-0.00059,0.0477,0.0265,0.092,0.0609,0.12318,0.028,0.0242,0.0682,0.0437,0.10502,0.0284,0.0456-0.0168,0.0643-0.07,0.0551-0.115-0.004-0.0142-0.00027-0.0102,0.009-0.0121z'/%3E %3Cpath d='m503.61,302.1c0.0236,0.0413,0.0641,0.0774,0.11362,0.0798,0.0492,0.004,0.10025-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10186,0.0341-0.14599,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11789,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11772-0.0123,0.0211,0.011,0.0469,0.033,0.0516,0.0534-0.059,0.0374-0.11808,0.0748-0.17712,0.11224zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0616-0.11864-0.016-0.0188,0.0274-0.0163,0.064-0.001,0.0922z'/%3E %3Cpath d='m503.83,301.81c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.008,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m504.06,301.82c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0491,0.004,0.10014-0.036,0.0987-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12507-0.0408,0.0337-0.10186,0.0341-0.14599,0.007-0.0454-0.0287-0.0751-0.0781-0.089-0.12917-0.0143-0.0547,0.006-0.11789,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11772-0.0123,0.0211,0.011,0.0468,0.0329,0.0516,0.0534-0.059,0.0374-0.11801,0.0748-0.17702,0.11224zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0616-0.11864-0.016-0.0188,0.0274-0.0163,0.064-0.002,0.0922z'/%3E %3Cpath d='m504.19,301.38c0.0404-0.0272,0.0749,0.0465,0.0293,0.0618-0.0383,0.0142-0.0641-0.041-0.0293-0.0618zm0.10761,0.12264c0.0455,0.0741,0.0905,0.14866,0.13638,0.22256,0.0108,0.027,0.0435,0.0304,0.0628,0.0144,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11758,0.0746-0.0179-0.0182,0.0273-0.0213,0.0207-0.0437-0.003-0.026-0.0215-0.0462-0.0337-0.0685-0.0249-0.0401-0.0484-0.0812-0.0753-0.11995-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0253,0.036-0.0513,0.0549-0.076,0.004-0.003,0.008-0.005,0.0113-0.008z'/%3E %3Cpath d='m504.54,301.37c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0982-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0665,0.0748,0.0453,0.11734-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0193,0.0381,0.0294,0.10908,0.0231,0.1259-0.0272,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13139,0.0215-0.0359,0.0685-0.0344,0.0973-0.0574-0.00089-0.0121,0.00025-0.0135,0.009-0.0184z'/%3E %3Cpath d='m504.74,301.03c0.0736,0.11999,0.14652,0.24037,0.22048,0.36012,0.0113,0.0274,0.0444,0.0302,0.0647,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0183-0.018,0.0261-0.0212,0.0196-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16351-0.15013-0.24455-0.008-0.0222-0.038-0.0403-0.0528-0.0136-0.001,0.0104-0.0221-0.001-0.0111-0.007,0.0183-0.0253,0.0358-0.0515,0.0546-0.0762,0.004-0.002,0.007-0.004,0.0111-0.007z'/%3E %3Cpath d='m505.19,301.28c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.05,0.01-0.0952-0.0439-0.0865-0.0918,0.0107-0.0549,0.0488-0.0986,0.0805-0.14279,0.0145-0.0111-0.008-0.0249-0.0115-0.0362-0.0193-0.0402-0.0774-0.0391-0.0974-0.00063-0.01,0.0163-0.003,0.0347,0.007,0.0482,0.0203,0.0196,0.005,0.0595-0.0253,0.0509-0.0445-0.0226-0.0284-0.0874,0.002-0.11585,0.03-0.0284,0.0702-0.055,0.11332-0.0498,0.0329,0.006,0.0485,0.0387,0.065,0.0642,0.0254,0.0411,0.0498,0.0828,0.0764,0.12315,0.008,0.0219,0.0361,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.0119,0.0132,0.008,0.0221-0.001,0.0346-0.0243,0.0955-0.0685,0.0744-0.01-0.005-0.0162-0.019-0.0233-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.033-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0558z'/%3E %3Cpath d='m501.13,304.57c0.0407-0.0258,0.0814-0.0517,0.12213-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0294,0.0124-0.0163,0.0487,0.008,0.0587,0.0489,0.0351,0.0979,0.0702,0.14684,0.10532-0.0111-0.0662-0.0219-0.13242-0.0332-0.19857,0.00087-0.0208-0.0216-0.0341-0.0379-0.0189-0.004,0.0118-0.0181-0.006-0.0105-0.008,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.005,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0436-0.009,0.0656,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15519-0.11084-0.23272-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.003-0.004-0.005-0.005-0.008z'/%3E %3Cpath d='m501.53,304.43c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0491,0.004,0.10022-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.0321-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12511-0.0408,0.0337-0.10186,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0781-0.089-0.12919-0.0143-0.0547,0.006-0.11791,0.0543-0.14944,0.0347-0.0264,0.0848-0.0323,0.12289-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.059,0.0374-0.11807,0.0748-0.17711,0.11226zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12015-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m501.75,304.14c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00051-0.048-0.008-0.0497,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0103-0.001,0.0126-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14124-0.0123-0.0251-0.0408-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0128-0.008z'/%3E %3Cpath d='m502.21,304.21c-0.007,0.0505-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.11677-0.0326-0.14347-0.0848-0.0297-0.0539-0.0356-0.12445-0.005-0.17944,0.0196-0.0415,0.0784-0.0638,0.11139-0.0606-0.0209-0.0333-0.0399-0.068-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0476,0.009-0.0101-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13262,0.2177,0.19972,0.32607,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0114-0.0165-0.00016-0.006-0.01-0.012-0.0199-0.018-0.0299zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0233-0.0363-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0237,0.0455,0.0636,0.0909,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m502.45,304.03c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0993-0.0494-0.0852-0.0991,0.0144-0.0549,0.0528-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0502,0.0455-0.0851,0.0877-0.10459,0.0374-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0982,0.0909,0.14612,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0953-0.0685,0.0744-0.01-0.005-0.0165-0.0184-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.0329-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.0221-0.0362,0.0284-0.0558z'/%3E %3Cpath d='m502.75,303.86c-0.007,0.0505-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.1167-0.0327-0.14347-0.0848-0.0297-0.0539-0.0356-0.12444-0.005-0.17941,0.0196-0.0415,0.0784-0.0639,0.11139-0.0606-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0477,0.009-0.01-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0114-0.0165-0.00016-0.006-0.01-0.012-0.0199-0.018-0.0299zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0233-0.0363-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13131,0.0238,0.0455,0.0636,0.091,0.11846,0.0938,0.0414,0.005,0.0724-0.0299,0.0773-0.0686z'/%3E %3Cpath d='m502.95,303.91c-0.003-0.004-0.005-0.008-0.008-0.0126,0.0279-0.0315,0.041-0.0885,0.008-0.1207-0.0141-0.002-0.0131,0.0195-0.0251,0.0233-0.0271,0.0219-0.0648-0.0128-0.0535-0.0427,0.0104-0.0404,0.0666-0.0433,0.0909-0.0145,0.0341,0.0337,0.0354,0.0896,0.0122,0.12973-0.006,0.0134-0.0173,0.0254-0.0246,0.0375z'/%3E %3Cpath d='m502.99,303.38c0.0403-0.0256,0.0807-0.0512,0.12099-0.0768,0.0151,0.0129-0.006,0.0164-0.0126,0.0278-0.0112,0.0269,0.0203,0.0418,0.039,0.0546,0.0445,0.0286,0.089,0.0571,0.13353,0.0857-0.011-0.0631-0.0208-0.12647-0.0325-0.18944,0.00003-0.0282-0.0299-0.029-0.0442-0.0188-0.009-0.008-0.002-0.012,0.006-0.0161,0.0242-0.0154,0.0484-0.0307,0.0725-0.0461,0.017,0.0155-0.0171,0.0256-0.0113,0.0463,0.01,0.0684,0.0224,0.13653,0.0334,0.20481,0.009,0.0568,0.0197,0.11345,0.0276,0.17045,0.005,0.0445-0.009,0.0981-0.0514,0.11987-0.0372,0.0236-0.0787-0.0362-0.0367-0.0573,0.025-0.0106,0.0652-0.0113,0.0614-0.0496-0.00042-0.0306-0.008-0.0605-0.0129-0.0907-0.0732-0.0475-0.1463-0.0952-0.21967-0.14246-0.0202-0.0144-0.0482-0.0187-0.0689-0.0136-0.002-0.003-0.003-0.006-0.005-0.009z'/%3E %3Cpath d='m503.44,302.89c0.0736,0.11999,0.14651,0.24036,0.22047,0.3601,0.0114,0.0274,0.0444,0.0303,0.0647,0.0109,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.11931,0.0757-0.0182-0.0179,0.026-0.0212,0.0195-0.0429-0.004-0.0265-0.0224-0.0478-0.0352-0.0708-0.0501-0.0815-0.0993-0.16356-0.15018-0.24456-0.008-0.0222-0.0379-0.0402-0.0529-0.0137-0.002,0.0102-0.0221-0.002-0.0112-0.007,0.0183-0.0252,0.0358-0.0515,0.0546-0.0761,0.004-0.002,0.008-0.004,0.0114-0.006z'/%3E %3Cpath d='m503.88,303.12c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0994-0.0494-0.0852-0.0991,0.0144-0.0549,0.0528-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.002-0.0502,0.0455-0.0851,0.0877-0.10449,0.0374-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0482,0.0593,0.0982,0.0909,0.14608,0.008,0.0218,0.0361,0.013,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0953-0.0685,0.0744-0.01-0.005-0.0164-0.0186-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0454,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m503.99,302.75c0.0407-0.0258,0.0814-0.0517,0.12213-0.0775,0.002,0.005,0.0112,0.0109,0.003,0.0132-0.0294,0.0124-0.0163,0.0486,0.008,0.0586,0.0489,0.0351,0.0979,0.0702,0.14684,0.10532-0.0111-0.0662-0.0219-0.13242-0.0332-0.19857,0.00088-0.0208-0.0216-0.0341-0.0379-0.0189-0.004,0.0118-0.018-0.006-0.0104-0.008,0.0272-0.0172,0.0543-0.0345,0.0815-0.0517,0.002,0.006,0.0136,0.0128,0.00043,0.0154-0.019,0.0166-0.0118,0.0437-0.009,0.0657,0.0147,0.0909,0.0294,0.18187,0.0441,0.2728-0.005,0.001-0.0101,0.01-0.0147,0.005-0.0776-0.0555-0.15518-0.11084-0.23271-0.16636-0.0176-0.0176-0.0455-0.009-0.0631-0.007-0.002-0.003-0.004-0.005-0.005-0.008z'/%3E %3Cpath d='m504.39,302.61c0.0237,0.0413,0.0641,0.0774,0.11362,0.0798,0.0491,0.004,0.10022-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.0321-0.00092-0.0384,0.0197-0.004,0.0152,0.0272,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0434,0.12511-0.0408,0.0337-0.10185,0.0341-0.14599,0.007-0.0454-0.0287-0.075-0.0782-0.0889-0.12919-0.0143-0.0547,0.006-0.11798,0.0543-0.14946,0.0347-0.0264,0.0848-0.0322,0.12291-0.01,0.0186,0.0113,0.0427,0.0319,0.0464,0.0506-0.0591,0.0374-0.11813,0.0748-0.1772,0.11226zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.0459-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.064-0.002,0.0921z'/%3E %3Cpath d='m504.62,302.32c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00051-0.048-0.008-0.0497,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12647,0.0132,0.0297,0.0502,0.0279,0.071,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0196-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0133-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0126-0.008z'/%3E %3Cpath d='m505.07,302.39c-0.007,0.0505-0.0463,0.0971-0.0985,0.10227-0.0601,0.007-0.1167-0.0327-0.14347-0.0848-0.0296-0.054-0.0356-0.12442-0.006-0.17941,0.0196-0.0415,0.0784-0.0639,0.11143-0.0606-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0371,0.002-0.0476,0.009-0.0101-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0486,0.0515-0.0718,0.006-0.004,0.0136-0.0113,0.0163,0.00013,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0527,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0113-0.0165-0.00015-0.006-0.01-0.0121-0.0199-0.0181-0.0299zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0233-0.0363-0.0798-0.0551-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13127,0.0237,0.0456,0.0636,0.0909,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m505.32,302.21c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0527,0.01-0.0993-0.0494-0.0852-0.0991,0.0144-0.0549,0.0528-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0504-0.0567-0.058-0.0355-0.007-0.08,0.0338-0.0573,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.002-0.0469,0.0405-0.0807,0.0795-0.10053,0.0382-0.0258,0.094-0.0166,0.11355,0.0278,0.031,0.0482,0.0593,0.0982,0.0909,0.14608,0.008,0.0218,0.0361,0.013,0.0362-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0953-0.0685,0.0744-0.01-0.005-0.0165-0.0184-0.0229-0.0237zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10022-0.0224,0.0329-0.0517,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.0221-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m505.62,302.04c-0.007,0.0504-0.0463,0.0971-0.0985,0.10226-0.0601,0.007-0.11676-0.0328-0.14357-0.0849-0.0297-0.054-0.0354-0.12445-0.005-0.17941,0.0196-0.0415,0.0784-0.0639,0.11139-0.0606-0.021-0.0333-0.0399-0.0681-0.0637-0.0994-0.015-0.0231-0.0372,0.002-0.0477,0.009-0.01-0.004-0.007-0.0102-0.00081-0.0166,0.0173-0.0238,0.0337-0.0485,0.0515-0.0718,0.006-0.004,0.0135-0.0113,0.0162,0.00014,0.0666,0.10865,0.13263,0.2177,0.19972,0.32606,0.009,0.0235,0.041,0.0526,0.0596,0.0205,0.005-0.0122,0.0201,0.005,0.008,0.0105-0.0176,0.0245-0.0343,0.05-0.0525,0.0739-0.007,0.004-0.0138,0.0114-0.0165-0.00016-0.006-0.01-0.0119-0.0199-0.0179-0.0298zm-0.0123-0.0201c-0.0276-0.0452-0.0553-0.0904-0.0829-0.13555-0.0232-0.0364-0.0798-0.055-0.11296-0.021-0.0327,0.0366-0.0219,0.0921,0.00009,0.13128,0.0237,0.0456,0.0636,0.091,0.11846,0.0937,0.0414,0.005,0.0724-0.0298,0.0773-0.0685z'/%3E %3Cpath d='m505.85,301.54c0.0415-0.0285,0.0979-0.0304,0.14182-0.006,0.066,0.033,0.0993,0.11124,0.0926,0.18256-0.008,0.0774-0.0885,0.14127-0.16575,0.12365-0.0685-0.0147-0.12172-0.0757-0.13172-0.14434-0.009-0.046,0.00091-0.0967,0.034-0.13137,0.009-0.009,0.0182-0.0177,0.029-0.0242zm0.003,0.0242c-0.0426,0.0263-0.0352,0.0849-0.0132,0.12226,0.0264,0.0495,0.0664,0.0972,0.12181,0.11427,0.0396,0.0127,0.0852-0.0181,0.0872-0.0599,0.00079-0.0459-0.0266-0.0866-0.0526-0.12229-0.0307-0.0388-0.0832-0.0818-0.13529-0.0588l-0.008,0.004-0.0001,0.0001z'/%3E %3Cpath d='m506.18,301.33c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0748,0.0453,0.11728-0.019,0.0507-0.0741,0.0665-0.11952,0.0836-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0187-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0192,0.0382,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.00041-0.0805,0.013-0.11811-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0215-0.0359,0.0685-0.0345,0.0973-0.0575-0.00094-0.0122,0.00031-0.0135,0.009-0.0184z'/%3E %3Cpath d='m501.57,305.09c0.0392,0.0641,0.0784,0.12829,0.11763,0.19243,0.008-0.0417,0.017-0.0917,0.0587-0.11295,0.0391-0.0235,0.0858,0.004,0.10707,0.0387,0.0348,0.0498,0.0631,0.10372,0.0973,0.15384,0.0117,0.0249,0.0421,0.0128,0.0562,0.007,0.01,0.009-0.003,0.0121-0.009,0.0168-0.0378,0.024-0.0757,0.048-0.11352,0.072-0.0157-0.0149,0.0141-0.0181,0.019-0.0309,0.0136-0.0239-0.008-0.0458-0.0195-0.0659-0.0272-0.0431-0.0516-0.0881-0.0822-0.12878-0.0337-0.0444-0.0914,0.00043-0.0971,0.0436-0.009,0.016-0.005,0.0303,0.006,0.0433,0.0293,0.0471,0.0571,0.0952,0.0876,0.14148,0.0124,0.0297,0.0463,0.003,0.0599,0.005,0.009,0.009-0.006,0.0113-0.0113,0.0163-0.0378,0.024-0.0756,0.048-0.11347,0.072-0.0183-0.0192,0.032-0.0244,0.0199-0.0496-0.0119-0.0325-0.0333-0.0604-0.0505-0.0903-0.0463-0.0749-0.0911-0.15077-0.13861-0.22492-0.0118-0.0318-0.0434-0.0188-0.0567-0.003-0.012-0.004-0.005-0.0117,0.00089-0.0187,0.0169-0.0231,0.0328-0.0473,0.0504-0.0698,0.004-0.002,0.008-0.005,0.0119-0.008z'/%3E %3Cpath d='m502.17,305.24c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0853-0.0992,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0566-0.058-0.0355-0.007-0.0797,0.0339-0.0571,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0255,0.0324-0.0652-0.01-0.0574-0.0408,0.003-0.0501,0.0455-0.0851,0.0877-0.10449,0.0374-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0982,0.091,0.14612,0.008,0.0219,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0954-0.0685,0.0745-0.01-0.005-0.0163-0.0186-0.0231-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0223,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m502.21,304.89c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0405,0.003-0.1043,0.0543-0.10933,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.026,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0708,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0268-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0195-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0123-0.0251-0.0408-0.0133-0.0516,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.009-0.005,0.0129-0.008z'/%3E %3Cpath d='m502.61,304.96c-0.0152,0.0429-0.0316,0.098-0.0835,0.1069-0.0528,0.01-0.0994-0.0494-0.0853-0.0992,0.0144-0.0549,0.0527-0.0988,0.0855-0.14366-0.0138-0.0233-0.0288-0.0505-0.0566-0.058-0.0355-0.007-0.0797,0.0339-0.0571,0.0689,0.01,0.014,0.0226,0.0323,0.0106,0.0489-0.0254,0.0324-0.0652-0.01-0.0574-0.0407,0.003-0.0501,0.0455-0.0851,0.0877-0.10452,0.0373-0.0222,0.0872-0.008,0.10536,0.0317,0.031,0.0483,0.0593,0.0983,0.091,0.14616,0.008,0.0218,0.0362,0.0131,0.0363-0.008,0.003-0.005,0.003-0.0224,0.007-0.0213,0.003,0.007,0.012,0.0132,0.008,0.0221-0.001,0.0347-0.0243,0.0955-0.0685,0.0745-0.01-0.005-0.0163-0.0186-0.0231-0.0238zm-0.0114-0.0186c-0.0204-0.0334-0.0409-0.0668-0.0613-0.10024-0.0224,0.033-0.0518,0.065-0.0562,0.1062-0.007,0.0453,0.0554,0.0892,0.0891,0.0498,0.0136-0.016,0.022-0.0362,0.0284-0.0557z'/%3E %3Cpath d='m502.73,304.36c0.0736,0.11999,0.14651,0.24036,0.22047,0.3601,0.0114,0.0274,0.0443,0.0302,0.0648,0.0111,0.005,0.006,0.008,0.0125-0.002,0.0153-0.0398,0.0252-0.0795,0.0505-0.1193,0.0757-0.0182-0.0179,0.026-0.0213,0.0194-0.0431-0.003-0.0261-0.0217-0.0464-0.034-0.0688-0.0505-0.0821-0.10013-0.16484-0.15135-0.24654-0.008-0.0221-0.038-0.0403-0.0528-0.0136-0.001,0.0104-0.0221-0.001-0.0111-0.007,0.0183-0.0253,0.0358-0.0515,0.0546-0.0762,0.004-0.002,0.007-0.004,0.0112-0.007z'/%3E %3Cpath d='m502.86,304.27c0.0404-0.0273,0.075,0.0466,0.0293,0.0616-0.0386,0.014-0.0639-0.0407-0.0293-0.0616zm0.10761,0.12263c0.0455,0.0741,0.0905,0.14865,0.13638,0.22254,0.0108,0.027,0.0435,0.0306,0.0628,0.0145,0.006,0.007,0.006,0.0118-0.003,0.0147-0.0392,0.0249-0.0784,0.0497-0.11757,0.0746-0.0179-0.0182,0.0273-0.0215,0.0206-0.0439-0.003-0.0263-0.0219-0.047-0.0343-0.0696-0.0247-0.0398-0.048-0.0805-0.0747-0.11899-0.0117-0.0257-0.0397-0.0154-0.0507,0.004-0.005-0.004-0.0141-0.008-0.006-0.0144,0.0184-0.0252,0.036-0.0513,0.0549-0.076,0.004-0.002,0.008-0.005,0.0114-0.007z'/%3E %3Cpath d='m503.15,304.35c0.001-0.0445,0.0192-0.0955,0.0642-0.1128,0.0514-0.0213,0.11161,0.004,0.14391,0.0466,0.0404,0.0481,0.0614,0.11587,0.0401,0.17686-0.016,0.0581-0.0692,0.10206-0.12889,0.10841-0.019-0.00029-0.0489,0.0132-0.0566-0.0111-0.0604-0.0983-0.11978-0.19719-0.18102-0.29494-0.009-0.0236-0.0395-0.0395-0.0544-0.012-0.003,0.0111-0.0214-0.004-0.01-0.01,0.0182-0.025,0.0356-0.0509,0.0544-0.0753,0.006-0.004,0.0135-0.0113,0.0162-0.00011,0.0373,0.0613,0.0747,0.12263,0.112,0.18394zm0.0112,0.0184c0.0321,0.0525,0.0641,0.10491,0.0962,0.15737,0.0441,0.0134,0.10374-0.007,0.10818-0.0587,0.01-0.052-0.019-0.10239-0.0516-0.14062-0.0283-0.0331-0.0832-0.0513-0.11982-0.0209-0.0194,0.0154-0.027,0.0401-0.033,0.0628z'/%3E %3Cpath d='m503.42,304.12c0.0121,0.0197,0.0241,0.0395,0.0362,0.0592-0.002-0.0404,0.003-0.10429,0.0543-0.10932,0.0392-0.006,0.0514,0.0586,0.0108,0.0633-0.0181,0.00053-0.048-0.008-0.0498,0.0198-0.002,0.0194-0.009,0.043,0.004,0.0599,0.0261,0.0421,0.0512,0.0848,0.0779,0.12645,0.0132,0.0296,0.0501,0.0279,0.0709,0.0142,0.004,0.005,0.007,0.0104-0.001,0.0127-0.0422,0.0267-0.0844,0.0535-0.12655,0.0803-0.0159-0.0157,0.0168-0.0194,0.0196-0.0354,0.008-0.0216-0.01-0.04-0.0195-0.0578-0.0292-0.0471-0.0571-0.0951-0.0878-0.14126-0.0122-0.0251-0.0408-0.0132-0.0515,0.006-0.003-0.004-0.0127-0.007-0.006-0.0126,0.0185-0.0258,0.037-0.0516,0.0555-0.0774,0.004-0.003,0.008-0.005,0.0127-0.008z'/%3E %3Cpath d='m503.64,304.13c0.0236,0.0413,0.0641,0.0774,0.11364,0.0798,0.0492,0.004,0.10022-0.0359,0.0988-0.0871,0.003-0.0112-0.007-0.032-0.00092-0.0384,0.0197-0.004,0.0152,0.0273,0.0204,0.0393,0.006,0.045-0.005,0.0967-0.0433,0.12507-0.0408,0.0337-0.10185,0.0341-0.146,0.007-0.0455-0.0287-0.0751-0.0781-0.089-0.12919-0.0143-0.0547,0.006-0.11793,0.0543-0.14942,0.0332-0.0252,0.0803-0.0321,0.11774-0.0123,0.0211,0.011,0.0469,0.0329,0.0516,0.0534-0.059,0.0374-0.11807,0.0748-0.17711,0.11224zm-0.0102-0.0167c0.0401-0.0254,0.0801-0.0508,0.12014-0.0762-0.02-0.046-0.0897-0.0615-0.11864-0.0159-0.0187,0.0274-0.0164,0.0639-0.002,0.0921z'/%3E %3Cpath d='m503.96,303.78c0.0183,0.0299,0.0365,0.0597,0.0548,0.0896-0.013,0.0147-0.0224-0.0117-0.035-0.0162-0.0342-0.0329-0.0983-0.0192-0.11443,0.0254-0.0148,0.0467,0.045,0.0659,0.0808,0.0549,0.0383-0.003,0.0777-0.0132,0.11526-0.00023,0.0458,0.0158,0.0666,0.0748,0.0453,0.11734-0.019,0.0506-0.074,0.0665-0.11942,0.0835-0.003,0.004-0.009,0.0237-0.0165,0.0176-0.0186-0.0305-0.0373-0.061-0.0559-0.0915,0.0143-0.0156,0.0234,0.0158,0.0379,0.0192,0.0381,0.0294,0.10908,0.0231,0.1259-0.0271,0.0126-0.0459-0.041-0.0709-0.079-0.0624-0.0392,0.0004-0.0804,0.013-0.11809-0.003-0.0464-0.0234-0.0611-0.0907-0.0284-0.13135,0.0214-0.036,0.0685-0.0344,0.0973-0.0575-0.00088-0.0121,0.00024-0.0135,0.009-0.0184z'/%3E %3Cpath d='m504.2,303.92c0.0186-0.0133,0.0477-0.003,0.0542,0.0186,0.009,0.0211-0.006,0.0472-0.0283,0.0506-0.0198,0.004-0.0398-0.0112-0.0425-0.031-0.003-0.0149,0.004-0.0303,0.0166-0.0382z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23201b18' d='m484.35,254.87c-7.744-0.13352-15.563,1.6319-22.066,5.6673-2.99,1.8545-3.6925,2.4776-2.0481,5.4596-0.38869,0.26705-3.1096,1.0978-3.7822,1.3352-2.4892,0.94255-5.0162,1.8903-7.131,3.16-1.2857,0.77145-1.8239,1.35-2.8106,2.3737l6.2041-0.47474c-0.19435,0.40056-0.64282,0.97914-0.89698,1.3649-1.0614,1.5281-1.7192,2.7446-2.6461,4.3469,1.7572-1.1898,3.3387-2.3027,5.3668-3.2935,4.4399-2.2402,12.423-2.2995,15.697-6.2311,0.83718-0.99398,0.3289-1.5874-0.37374-3.2045,2.4218-0.80111,3.3337-1.3649,6.2787-2.0325,7.1161-1.5874,12.02,0.29671,15.458-0.54893,1.0764-0.26705,2.1229-0.86048,2.1976-1.988l-0.50828-3.5902,11.556-0.0148c0.0148,2.0325-1.9434,4.6434,1.6445,5.5782,3.244,0.84564,9.8069-1.0088,15.473,0.56375l6.2787,2.0325c-0.0299,0.29671-0.47841,1.0978-0.61295,1.5132-0.26908,0.72696-0.23918,1.1127,0.22426,1.6319,0.61293,0.69727,1.48,1.3945,2.4069,1.9286,1.8388,1.0533,4.2457,1.7209,6.5182,2.2699,6.533,1.5874,7.146,2.0028,12.169,5.3557-0.3289-0.97917-2.7209-4.4656-3.5131-5.697l6.1742,0.48958c-1.0614-1.6171-4.3206-3.3232-6.2041-4.0651l-7.5196-2.7446c0.68373-1.3109,1.2543-2.4034,0.56808-3.4865-1.0465-1.5874-7.3239-4.6708-8.91-5.1035-2.7092-0.73914-5.5574-1.342-8.2333-1.7697-2.676-0.42776-7.8227-0.79685-7.8227-0.79685-0.36827-0.38926,0.70904-2.4303-0.94182-3.8574-0.97172-0.77146-2.377-1.0385-3.8121-1.1869-5.7406-0.54892-13.559-0.38574-19.36,0-1.6744,0.10385-2.8554,0.28188-3.8121,1.1869-1.1661,1.0978-1.3156,1.7654-1.2109,3.8275z'/%3E %3Cg fill='%23002d62'%3E %3Cpath d='m485.96,258.96c0.85213-0.75661,0.97172-0.97917,2.3321-1.4391,2.9601-0.99399,7.6244-0.90499,10.749-0.90499,2.5414,0.0148,5.023-0.0297,7.5347,0.2077,2.5414,0.25221,4.0364,0.56375,5.7258,2.0325,0.29897-1.7654,0.68767-3.2788,0.74746-5.2221,0.0748-2.0918-1.1063-2.715-2.9601-3.0859-3.0646-0.63793-8.2073-0.57859-11.511-0.54893-2.1528,0.0148-9.8069,0.0742-11.362,0.63793-1.4202,0.50442-2.5414,1.6171-2.4218,3.5457,0.0448,0.96433,0.76244,4.1688,1.166,4.777z'/%3E %3Cpath d='m463.44,268.96c0.52324-0.47474,0.16445-0.94948,2.5863-2.2995,3.0498-1.7061,7.3254-3.2788,10.823-3.9759,3.0347-0.59342,6.1592-0.57858,9.3286-0.34121,1.4053,0.10385,3.2591,0.32637,4.6495,0.10385,0,0,1.4992-0.35087,1.9202-0.72236,0.55134-0.48647,0.51656-1.6068,0.51656-1.6068-1.0166-0.81596-3.9168,2.0028-6.5478,1.1127-0.85213-0.28187-1.0913-1.6616-1.4202-2.611l-0.85213-3.2341c-4.8138-0.62311-13.066,1.3055-17.521,3.2936-2.0182,0.89014-5.3371,2.5666-6.5777,3.8574-1.1063,1.1275,0.0299,2.7743,0.6578,3.605,0.79157,1.0274,1.8591,2.243,2.4369,2.8183z'/%3E %3Cpath d='m504.86,260.04c-0.26908,1.6913,0.97172,2.1808,2.4667,2.4034,3.0945,0.43024,7.7289-0.97916,13.873,0.22254,2.6312,0.51924,5.2024,1.3945,7.4897,2.3292,0.92688,0.38574,4.156,1.8841,4.8138,2.5369l1.1661,1.3946c0.32889-0.17803,2.1079-2.3144,2.4667-2.7743,0.68767-0.8753,1.7042-2.4479,0.65777-3.6495-0.91193-1.0533-4.8886-3.1156-6.6526-3.8722-2.3546-1.0099-6.0986-1.9134-9.003-2.4033-2.9594-0.49922-8.8576-0.92915-8.8576-0.92915s-0.37804,5.4836-1.888,5.9435c-2.945,0.8753-4.3804-1.5874-6.533-1.2017z'/%3E %3Cpath d='m528.14,266.85c-0.19436,0.84564-0.56811,0.9198,0.98667,2.2105,3.6327,2.9968,9.7471,3.1452,13.574,4.7919,1.9434,0.84564,3.0199,1.5429,4.7392,2.5814-0.16446-0.50442-2.392-3.7238-2.945-4.5694,1.7043-0.0297,3.9317,0.13352,5.6808,0.23737-0.0897-0.0593-0.13456-0.14836-0.2392-0.23737-2.5714-2.255-9.1193-4.3172-12.408-5.4001-0.94731,1.1093-1.8564,2.1881-2.9002,3.2787-0.40364,0.38574-0.65779,0.65277-1.4651,0.43024-1.0166-0.28187-1.8089-1.1572-2.4218-1.7061-0.59798-0.53409-1.8089-1.5429-2.6013-1.6171z'/%3E %3Cpath d='m504.95,259.49c1.8538,0.13352,2.1079,0.47474,3.5131,1.0978,0.56811,0.25221,1.2857,0.3709,2.0182,0.31156,1.0016-0.0742,1.1212-0.2077,1.3903-0.99399,0.3887-1.1275-1.5099-1.8693-2.3919-2.0622l-4.0812-0.60827z'/%3E %3Cpath d='m493.14,259.51-0.3887-2.2253c-1.2259-0.13353-6.9068,0.83079-6.488,2.5814,0.20929,0.81596,0.3887,0.94948,1.2857,1.0385,2.4667,0.22253,2.8553-1.3204,5.5911-1.3945z'/%3E %3Cpath d='m463.9,269.3c0.82221,1.4687,3.0199-1.1572,4.3055-2.1066,0.73254-0.54893,0.82223-0.53409,1.6445-0.8753l-0.44849-0.71211c-0.70262,0.14835-2.4667,1.1127-3.1244,1.4687-0.97172,0.53409-2.0481,1.2314-2.377,2.2254z'/%3E %3Cpath d='m528.3,266.32c0.26908,0.13353,0.53818,0.1632,0.85213,0.35606,1.8388,1.0682,4.0812,3.9315,4.9632,2.8632,0.53819-0.66761-1.465-2.0325-2.078-2.3589l-3.244-1.5578c-0.17941,0.14835-0.40364,0.44505-0.49333,0.69727z'/%3E %3Cpath d='m469.91,266.91c0.19435,0.84564,0.56811,0.9198-0.98667,2.2105-3.6327,2.9968-9.7471,3.1452-13.574,4.7919-1.9434,0.84564-3.0199,1.5429-4.7392,2.5814,0.16445-0.50442,2.392-3.7238,2.945-4.5694-1.7043-0.0297-3.9317,0.13352-5.6808,0.23737,0.0897-0.0593,0.13454-0.14836,0.2392-0.23737,2.5714-2.255,9.1193-4.3172,12.408-5.4001,0.34385,0.35606,0.6279,0.7418,0.94183,1.1127,0.38869,0.47474,1.5248,1.7506,1.9584,2.166,0.40364,0.38574,0.6578,0.65277,1.4651,0.43024,1.0166-0.28187,1.8089-1.1572,2.4218-1.7061,0.598-0.53408,1.8089-1.5429,2.6013-1.6171z'/%3E %3C/g%3E %3Cg fill='%23eac102'%3E %3Cpath d='m470.77,258.54c-0.524-0.0106-0.99379,0.24777-1.4638,0.4419-0.15079,0.0445-0.54491,0.19166-0.24419,0.33108,0.23224,0.10457,0.23273,0.40136,0.34076,0.60359,0.12548,0.34994,0.23599,0.70533,0.38133,1.0475,0.17369,0.56836,0.38561,1.1243,0.59709,1.6795,0.0372,0.13963-0.1368,0.49927,0.16035,0.35497,0.30012-0.1211,0.60858-0.22043,0.90909-0.3409,0.42579-0.13308,0.80583-0.41989,1.0159-0.81775,0.11134-0.17347,0.12288-0.38557,0.17834-0.58023,0.0375-0.16504,0.0507-0.33686-0.002-0.49969-0.0371-0.2429-0.0546-0.49515-0.17332-0.71565-0.12335-0.30842-0.25369-0.63006-0.50609-0.85692-0.21456-0.23624-0.46442-0.45156-0.77166-0.554-0.1317-0.0596-0.27515-0.1044-0.42139-0.0933zm-0.249,0.36582c0.35609-0.0199,0.61095,0.28971,0.77607,0.56693,0.14503,0.28477,0.26142,0.58404,0.39319,0.87432,0.14756,0.46176,0.31436,0.94036,0.24363,1.4326-0.0534,0.25994-0.30899,0.42687-0.51898,0.56472-0.23183,0.12834-0.45305-0.092-0.45614-0.32242-0.0832-0.23287-0.18706-0.45902-0.25975-0.69492-0.173-0.4035-0.27687-0.83317-0.45918-1.2334-0.10313-0.27361-0.19999-0.55245-0.2574-0.83943-0.0666-0.27271,0.28237-0.33685,0.4804-0.35513,0.0195,0.00036,0.0397,0.004,0.0582,0.007z'/%3E %3Cpath d='m472.57,257.89c0.0848,0.12899,0.29142,0.1532,0.28416,0.34418,0.0825,0.24126,0.17057,0.48149,0.22617,0.73016,0.0623,0.19464,0.0972,0.39586,0.17675,0.58508,0.0709,0.25623,0.14838,0.5107,0.21793,0.76734,0.0855,0.24503,0.18013,0.48788,0.22908,0.74353,0.0327,0.19386,0.18032,0.41648,0.0564,0.60112-0.0807,0.0876-0.0492,0.21888,0.0868,0.14803,0.20243-0.0149,0.37574-0.14114,0.57766-0.15028,0.11508-0.0395,0.39075-0.039,0.37866-0.17626-0.12439-0.10615-0.29226-0.17811-0.28574-0.37109-0.0871-0.29115-0.18302-0.58087-0.26264-0.87333-0.063-0.20886-0.11848-0.41948-0.19161-0.62353-0.0483-0.16106-0.0698-0.33087-0.13015-0.48955-0.1051-0.33886-0.20911-0.67822-0.30609-1.0195-0.0555-0.14081-0.0978-0.28062,0.0289-0.40393,0.0447-0.20721-0.27006-0.0231-0.38197-0.0239-0.24041,0.0491-0.46748,0.14942-0.70439,0.21193z'/%3E %3Cpath d='m475.98,256.94c-0.31031-0.0136-0.59022,0.16956-0.81073,0.36925-0.2321,0.27596-0.40037,0.6211-0.38953,0.98868-0.0176,0.32472-0.045,0.65686,0.0476,0.9735,0.10195,0.50049,0.34871,0.9612,0.65555,1.3648,0.21352,0.21039,0.47681,0.37132,0.755,0.47939,0.23744,0.0541,0.49325,0.0748,0.73021,0.0115,0.39264-0.12781,0.7002-0.46071,0.81555-0.85491,0.0961-0.27103,0.17353-0.55297,0.15867-0.84347,0.007-0.27377-0.0956-0.53424-0.14212-0.80085-0.076-0.29177-0.20963-0.56539-0.36836-0.81979-0.16929-0.22736-0.38761-0.4135-0.58953-0.60953-0.23721-0.17562-0.52893-0.26613-0.82373-0.25619l-0.0385-0.002-0.00003,0.00002zm-0.018,0.2645c0.33727,0.0506,0.56781,0.34978,0.68181,0.65063,0.22513,0.43869,0.31784,0.92694,0.46051,1.395,0.0619,0.19699,0.0453,0.40493,0.0977,0.60299,0.0397,0.27564,0.0367,0.57392-0.0807,0.83032-0.14447,0.23014-0.4977,0.30319-0.7061,0.11677-0.21525-0.14269-0.3036-0.3965-0.42789-0.61046-0.08-0.29308-0.21948-0.5661-0.27746-0.86552-0.0547-0.23872-0.15894-0.46415-0.17827-0.71009-0.0573-0.37977-0.15647-0.7852-0.0144-1.1579,0.065-0.18501,0.26363-0.25336,0.44472-0.25169l0.00001,0.00002z'/%3E %3Cpath d='m478.71,256.61c-0.14026,0.18736-0.25596,0.3891-0.28496,0.6236-0.0475,0.24011,0.034,0.47967,0.0812,0.71237,0.0795,0.22189,0.22933,0.42034,0.44245,0.52823,0.30955,0.22575,0.66616,0.37276,1.0077,0.54052,0.22844,0.0901,0.47602,0.23126,0.54767,0.48356,0.0549,0.17061,0.0787,0.36658,0.0171,0.537-0.0849,0.18978-0.26859,0.35884-0.48975,0.30008-0.20887-0.007-0.4144-0.0896-0.55417-0.24752-0.20564-0.17925-0.35997-0.41629-0.43013-0.6801-0.0894-0.17451-0.26265-0.001-0.20826,0.13601-0.0403,0.19451-0.077,0.40983-0.0336,0.60234,0.12951,0.1389,0.32091,0.202,0.47641,0.30981,0.20297,0.0933,0.42298,0.17271,0.64838,0.17368,0.21278-0.0317,0.44307-0.0177,0.63152-0.13737,0.20921-0.1042,0.3963-0.24135,0.48887-0.46452,0.12697-0.26104,0.18876-0.5696,0.098-0.85237-0.0696-0.44255-0.39007-0.83011-0.80328-0.9982-0.22401-0.12857-0.46145-0.23171-0.70277-0.32129-0.26604-0.12635-0.58046-0.28501-0.64641-0.60154-0.06-0.21647-0.002-0.50359,0.23078-0.58862,0.21742-0.0961,0.4669-0.0103,0.63301,0.14464,0.14505,0.12531,0.23818,0.29747,0.31637,0.46962-0.0432,0.22873,0.31983,0.13947,0.2011-0.0463-0.0621-0.18705,0.19836-0.46671-0.0504-0.58272-0.20038-0.11852-0.40999-0.23234-0.64567-0.25691-0.25074-0.0508-0.51799-0.024-0.74278,0.10288-0.0763,0.0372-0.15085,0.0791-0.22832,0.11315z'/%3E %3Cpath d='m491.74,251.51c-0.3478-0.00093-0.68704,0.0848-1.0282,0.14083-0.14028,0.10574-0.4801-0.0236-0.50312,0.18177,0.13779,0.13295,0.22004,0.30532,0.23586,0.4961,0.0454,0.32094-0.0349,0.65136,0.0551,0.96737,0.0162,0.22755-0.039,0.46646,0.0525,0.68385,0.0293,0.34111-0.0462,0.69378,0.0649,1.0255,0.0297,0.21259,0.0963,0.47631-0.0829,0.64364-0.19153,0.15735,0.12347,0.23923,0.24379,0.15568,0.24404-0.0265,0.49017-0.0485,0.73161-0.0833,0.18329-0.0491,0.0673-0.19817-0.0328-0.25581-0.14222-0.23806-0.10103-0.5278-0.12201-0.79255-0.003-0.20381,0.00083-0.40769-0.005-0.61147,0.23867-0.11738,0.51728-0.0888,0.76206-0.18815,0.4637-0.10671,0.91961-0.44134,1.0061-0.93335,0.0957-0.43742-0.10456-0.90486-0.44334-1.1839-0.27548-0.17891-0.60945-0.25528-0.93503-0.2462zm-0.0783,0.35887c0.2936-0.0405,0.49553,0.23976,0.58489,0.48327,0.0705,0.21267,0.0638,0.44213,0.0562,0.66343-0.0148,0.34163-0.31801,0.60392-0.64214,0.6537-0.15782,0.0193-0.44004,0.0707-0.37741-0.17272-0.0292-0.2624-0.0719-0.52518-0.0493-0.78981-0.0133-0.25143-0.14393-0.52299-0.005-0.76106,0.10546-0.13266,0.29352-0.0389,0.43243-0.0768z'/%3E %3Cpath d='m494.76,251.32c-0.22479-0.0584-0.42491,0.15777-0.39409,0.37529-0.0625,0.26833-0.0836,0.54616-0.16738,0.80919-0.0467,0.39277-0.12889,0.77948-0.21568,1.1648-0.10208,0.47818-0.17213,0.96654-0.33778,1.4283-0.007,0.13644-0.30607,0.30579-0.14001,0.39452,0.24016-0.0252,0.48263-0.0119,0.72384-0.0219,0.21563-0.0847-0.10266-0.2425-0.14106-0.35878-0.033-0.18376,0.0159-0.37462,0.0468-0.55715,0.0175-0.10082,0.0243-0.21984,0.15368-0.18292,0.30086-0.003,0.60172-0.005,0.90258-0.008,0.0205,0.24915,0.16593,0.48067,0.1423,0.73327-0.0613,0.11169-0.15032,0.36776,0.0761,0.31033,0.2828-0.005,0.55933-0.0928,0.84331-0.0735,0.23705-0.0679-0.0813-0.22749-0.10896-0.35496-0.11755-0.26252-0.18891-0.54383-0.26501-0.8206-0.0786-0.34158-0.18754-0.67457-0.2726-1.0144-0.0793-0.18568-0.10984-0.38415-0.16966-0.57662-0.1271-0.38122-0.21459-0.77506-0.29852-1.1679-0.0141-0.12834-0.2744-0.0607-0.37789-0.0789zm-0.18275,0.93745c0.17518,0.4996,0.26315,1.0256,0.44523,1.5228,0.1032,0.18078-0.0818,0.28132-0.23981,0.2338-0.17609-0.0275-0.56811,0.16588-0.57101-0.11921,0.0759-0.19535,0.10104-0.39987,0.13574-0.60537,0.0576-0.25421,0.10276-0.51096,0.13649-0.76908,0.0216-0.0907,0.0567-0.17745,0.0934-0.26295z'/%3E %3Cpath d='m497.98,251.19c-0.48387,0.006-0.96773,0.0111-1.4516,0.0167,0.006,0.16459-0.0152,0.33003-0.0749,0.45048-0.0202,0.15796-0.0404,0.31591-0.0606,0.47387,0.16044,0.0269,0.21691-0.16403,0.31375-0.25287,0.14732-0.15424,0.30527-0.34582,0.54042-0.33651,0.12168,0.006,0.31475-0.07,0.26455,0.12215,0.006,0.20027,0.0726,0.39199,0.0539,0.59435,0.01,0.89236,0.0304,1.7851,0.0136,2.6774-0.005,0.12484-0.14045,0.16928-0.18649,0.2757,0.0444,0.0589,0.28765,0.0115,0.4079,0.0284,0.23093-0.00032,0.46224,0.006,0.69292-0.005,0.1084,0.0228,0.0973-0.15997-0.0299-0.16557-0.0863-0.2045-0.0679-0.43593-0.084-0.65399-0.01-0.95692-0.041-1.9146-0.003-2.8712,0.11683-0.0701,0.26775-0.14433,0.39423-0.0548,0.10903,0.0651,0.22528,0.12033,0.3298,0.1916,0.0725,0.10568,0.14503,0.21136,0.21755,0.31704-0.0336,0.0254,0.23178,0.13703,0.16454-0.027,0.0105-0.18221-0.0791-0.34741-0.0842-0.52988-0.0336-0.14164,0.0208-0.3551-0.19495-0.29546-0.40911-0.0276-0.81505,0.0402-1.2232,0.0451z'/%3E %3Cpath d='m501.29,251.08c-0.31221-0.0177-0.61738,0.0798-0.92924,0.0567-0.10177-0.005-0.2992,0.0349-0.13592,0.13174,0.18345,0.13054,0.12619,0.35899,0.12954,0.54967-0.0216,0.9673,0.0277,1.9355-0.0222,2.9023-0.0324,0.16225-0.0611,0.33981-0.21936,0.42845,0.0322,0.12604,0.29314,0.0248,0.41185,0.0625,0.25367,0.006,0.50735,0.0109,0.76103,0.0165-0.006-0.14916-0.21974-0.21607-0.16031-0.3812,0.002-0.44788,0.004-0.89575,0.006-1.3436,0.21834-0.0665,0.37382,0.075,0.38752,0.29542,0.0296,0.20258,0.13444,0.37931,0.21626,0.56368,0.10463,0.2001,0.231,0.39029,0.37399,0.56402,0.17113,0.14045,0.31403,0.31765,0.50419,0.43308,0.14128,0.0504,0.29157,0.0741,0.43692,0.11286,0.006-0.18228-0.17693-0.28373-0.25555-0.43044-0.16291-0.27003-0.24648-0.57852-0.38199-0.86212-0.094-0.1868-0.14149-0.38681-0.18082-0.59015-0.11903-0.19131,0.12005-0.16614,0.23292-0.25179,0.208-0.11748,0.38585-0.28764,0.49-0.50457,0.12756-0.21369,0.11305-0.47059,0.10001-0.70927-0.0144-0.21683-0.15274-0.39229-0.27238-0.56304-0.1335-0.15207-0.33436-0.23811-0.51273-0.33152-0.22744-0.0655-0.45986-0.1245-0.6956-0.14679-0.0944-0.004-0.19081,0.001-0.28401-0.002zm0.28502,0.31756c0.21248-0.0149,0.40297,0.099,0.53655,0.25599,0.10274,0.13303,0.13953,0.31239,0.15704,0.48011-0.002,0.17896,0.0149,0.36378-0.0322,0.53776-0.0828,0.22906-0.26292,0.45121-0.52025,0.47854-0.18555,0.0232-0.38474,0.064-0.56672,0.0246-0.045-0.1312-0.006-0.28563-0.0191-0.42603-0.0006-0.36266-0.004-0.7255,0.0111-1.0879,0.0226-0.25365,0.2321-0.25424,0.43359-0.26302z'/%3E %3Cpath d='m504.16,251.77c-0.006,0.18073-0.0581,0.35769-0.0422,0.53959-0.008,0.31679-0.0121,0.6339-0.0519,0.94864-0.0409,0.5335-0.012,1.0694-0.0264,1.6033-0.0336,0.15641-0.0743,0.3194-0.18442,0.442-0.0639,0.0657-0.10392,0.13068,0.0204,0.1059,0.16093-0.0182,0.30789,0.0361,0.46155,0.0615,0.19171,0.001,0.38277,0.0106,0.57405,0.0134,0.1864-0.0555-0.10403-0.14391-0.079-0.26124-0.0954-0.21955-0.0433-0.46119,0.003-0.68526,0.0279-0.50474-0.02-1.0153,0.0672-1.5161,0.0261-0.30771-0.0338-0.61886,0.0232-0.92457,0.0918-0.17842-0.0332-0.42621,0.15643-0.56187,0.0413-0.0763,0.11364-0.16826-0.024-0.13988-0.23283-0.002-0.4693,0.0106-0.69684-0.0474-0.11034,0.006-0.37629-0.0862-0.38167,0.0576,0.0606,0.11987,0.21099,0.21865,0.17995,0.36401l0.00008,0.00033z'/%3E %3Cpath d='m507.09,251.63c-0.0758,0.33344-0.22414,0.64538-0.30457,0.97794-0.0598,0.20291-0.13633,0.3996-0.19054,0.60433-0.12063,0.32007-0.20561,0.65281-0.32169,0.9745-0.12687,0.40615-0.23122,0.83871-0.51167,1.1722-0.15843,0.0553-0.12999,0.3218,0.0632,0.22198,0.18991,0.0121,0.37364,0.0746,0.56587,0.0606,0.15495,0.0518,0.19704-0.10671,0.0523-0.17012-0.18363-0.1433-0.19973-0.39822-0.0854-0.58726-0.004-0.23028,0.18621-0.34512,0.39511-0.28015,0.23527,0.02,0.46884,0.0691,0.70593,0.0608,0.008,0.22421,0.10407,0.43603,0.10833,0.66077,0.0386,0.16015-0.27959,0.46127,0.008,0.44746,0.2462,0.027,0.4877,0.083,0.73677,0.0749,0.11186,0.008,0.27374-0.005,0.15115-0.13864-0.16429-0.32351-0.18027-0.69344-0.25637-1.0417-0.0121-0.3741-0.12346-0.73508-0.15413-1.1064-0.0668-0.37724-0.17054-0.74943-0.18415-1.1345-0.008-0.18768-0.0491-0.37137-0.10379-0.54938,0.0215-0.15442-0.0938-0.23252-0.23464-0.18561-0.14744-0.0142-0.28963-0.0794-0.43969-0.0616zm0.0457,0.88526c0.1121,0.23506,0.0719,0.49993,0.12988,0.74702,0.0447,0.29362,0.0568,0.59343,0.14442,0.87898,0.0839,0.3282-0.32837,0.1711-0.50202,0.1537-0.15588,0.0115-0.45505,0.001-0.30492-0.23229,0.0662-0.16995,0.10387-0.34934,0.16524-0.52238,0.0504-0.16535,0.0974-0.33173,0.14097-0.499,0.138-0.14223,0.0994-0.37209,0.20857-0.52432l0.0179-0.002-0.00004,0.00004z'/%3E %3Cpath d='m514.58,256.63c0.002,0.18376,0.26101,0.25595,0.21034,0.46433-0.0188,0.44331,0.002,0.88671,0.037,1.3286,0.0108,0.67629,0.0475,1.354,0.003,2.0298,0.001,0.10809-0.0394,0.2051-0.11977,0.27615-0.14078,0.0965,0.082,0.13708,0.16711,0.11815,0.67976-0.0238,1.3595-0.0493,2.0392-0.0737,0.0558-0.30316,0.1317-0.60596,0.14173-0.91503-0.002-0.15076-0.13336-0.0798-0.15954,0.0299-0.18234,0.25952-0.43273,0.52716-0.77191,0.5403-0.1659-0.003-0.38716,0.0604-0.51395-0.0749-0.0608-0.16255-0.0439-0.34549-0.0617-0.51698-0.0364-0.91135-0.0504-1.8245-0.0191-2.7362-0.0157-0.19361,0.088-0.35825,0.15836-0.52963-0.37015,0.0198-0.74029,0.0395-1.1104,0.0593z'/%3E %3Cpath d='m517.35,260.74,1.0972-0.005c-0.009-0.21902-0.14658-0.0913-0.16879-0.40611-0.0178-0.27835,0.0178-3.1941,0.0444-3.3903,0.0533-0.36048,0.16435-0.2099,0.16435-0.37873l-1.0794-0.0274c0.004,0.28292,0.13771,0.0274,0.14659,0.44261,0.004,0.18252-0.004,0.37417-0.004,0.55668,0,0.46998,0.009,2.4824-0.0178,2.7972-0.0222,0.27378-0.17324,0.1962-0.18212,0.41066z'/%3E %3Cpath d='m519.06,256.53c0.0422,0.16175,0.2119,0.27215,0.16,0.47,0.009,0.45514-0.087,0.90323-0.0894,1.358-0.0102,0.53396-0.0482,1.0668-0.0872,1.5993-0.0271,0.19059-0.0142,0.39753-0.10342,0.57268-0.0812,0.0348-0.26156,0.15417-0.0751,0.19,0.44818,0.0885,0.91199,0.0563,1.3571,0.16661,0.32794,0.0816,0.67016-0.0248,0.95709-0.18328,0.39483-0.26715,0.49515-0.81233,0.38185-1.2508-0.0406-0.21178-0.20653-0.35436-0.36037-0.48846-0.12775-0.11746-0.25887-0.2311-0.39058-0.34407,0.36811-0.0377,0.6936-0.31938,0.76867-0.6839,0.0698-0.29119,0.0237-0.63232-0.20007-0.84719-0.0683-0.0781-0.12781-0.16696-0.22882-0.20492-0.16653-0.096-0.33483-0.1963-0.5298-0.22036-0.51429-0.0944-1.0395-0.10031-1.56-0.13363zm0.97,0.38c0.21207,0.0153,0.46561-0.0174,0.61282,0.17302,0.26052,0.27862,0.24652,0.71447,0.0837,1.0385-0.0224,0.1433-0.1899,0.23562-0.32125,0.27856-0.172,0.0431-0.3508,0.0204-0.52531,0.01-0.0435-0.34552,0.0439-0.69148,0.0353-1.0381,0.005-0.15915,0.0174-0.32881,0.11468-0.4619zm-0.22,1.81c0.30831,0.0156,0.65531,0.0656,0.85874,0.3252,0.19192,0.24568,0.13069,0.57525,0.14413,0.86437-0.0329,0.36404-0.39111,0.70162-0.7673,0.63622-0.20059-0.0102-0.32124-0.14295-0.28338-0.34162-0.019-0.49473-0.002-0.99165,0.0478-1.4842z'/%3E %3Cpath d='m521.8,261.04c0.0869,0.14706,0.2918,0.10342,0.43219,0.16233,0.33917,0.0742,0.67826,0.14914,1.0132,0.23935,0.29025,0.0561,0.57914,0.11902,0.86888,0.17781,0.0534-0.227,0.23054-0.40838,0.25677-0.64393,0.12342-0.16565-0.13651-0.27334-0.21272-0.10118-0.28076,0.22388-0.67386,0.29962-1.0142,0.17917-0.23847-0.0101-0.40633-0.21279-0.32204-0.44416,0.0261-0.47848,0.0768-0.96175,0.20822-1.4228,0.14445-0.0525,0.33405,0.0281,0.47939,0.0866,0.20417,0.0857,0.30758,0.288,0.40042,0.47477,0.13886,0.10756,0.13087-0.22448,0.15295-0.31535,0.018-0.2823,0.0586-0.56213,0.0914-0.84292-0.22728,0.0334-0.31872,0.39779-0.59401,0.25996-0.17922-0.0709-0.58193,0.0359-0.48181-0.26256,0.0289-0.33297,0.12782-0.65376,0.20074-0.9785,0.3566-0.11266,0.75183,0.0584,0.96874,0.35018,0.12759,0.11323,0.2155,0.39395,0.3393,0.42387,0.069-0.2798,0.0208-0.57002,0.0246-0.8535-0.10774-0.17398-0.36573-0.12564-0.53748-0.20632-0.52034-0.12362-1.0363-0.27532-1.5662-0.35168-0.29648-0.0562,0.10087,0.21548,0.0317,0.36193-0.0941,0.63249-0.18683,1.2667-0.28286,1.8994-0.072,0.48894-0.11252,0.98367-0.21355,1.4676-0.0396,0.1361-0.11769,0.26784-0.24361,0.33994z'/%3E %3Cpath d='m525.31,257.72c0.12089,0.22899,0.13676,0.49712,0.0652,0.74361-0.12824,0.62002-0.29824,1.2315-0.38703,1.8594-0.0716,0.37449-0.14344,0.75018-0.21191,1.1244-0.0359,0.16775-0.44094,0.29198-0.13664,0.39782,0.25983,0.10756,0.53601,0.1684,0.80107,0.26097,0.26503,0.0101-0.0616-0.27448,0.0223-0.41948,0.0391-0.28329,0.13421-0.55607,0.16044-0.84223,0.0466-0.14705-0.00022-0.43777,0.21711-0.43857,0.2369,0.0167,0.11275,0.32651,0.17383,0.47868,0.0836,0.44981,0.21118,0.89538,0.40054,1.3122,0.13991,0.27109,0.39487,0.45438,0.64372,0.61593,0.0596-0.17088-0.14796-0.44034-0.17398-0.64738-0.0856-0.28679-0.0895-0.58571-0.10132-0.88243-0.0111-0.23111-0.0222-0.46221-0.0333-0.69332,0.23825-0.0761,0.49096-0.13168,0.68036-0.30577,0.27321-0.29777,0.37199-0.74061,0.26548-1.13-0.1011-0.41284-0.39488-0.75891-0.76407-0.96136-0.42943-0.25167-0.94291-0.26567-1.4046-0.42865-0.0712-0.0194-0.1443-0.0364-0.21722-0.0438zm0.94,0.56c0.28477-0.012,0.57665,0.1716,0.69124,0.43283,0.14839,0.40969,0.0972,0.89329-0.14706,1.2556-0.14825,0.20181-0.41567,0.21863-0.63948,0.16284-0.19209-0.009-0.44206-0.0735-0.32303-0.31729,0.0648-0.40898,0.17254-0.81026,0.23478-1.2195,0.0347-0.11776,0.10241-0.22336,0.18355-0.31449z'/%3E %3Cpath d='m528.03,259.63c0.19338,0.0193,0.31272-0.20066,0.4986-0.2379,0.16985-0.0709,0.39513-0.16099,0.54824-0.006,0.11202,0.13585,0.0352,0.33022-0.008,0.47904-0.0752,0.25549-0.12591,0.51934-0.19163,0.77807-0.1512,0.63169-0.30015,1.2645-0.45254,1.8955-0.0657,0.17288-0.0652,0.39653-0.28515,0.44465-0.0959,0.19642,0.26555,0.18872,0.38415,0.28122,0.21543,0.0936,0.43399,0.18154,0.66082,0.24373-0.0112-0.17198-0.15821-0.31786-0.0843-0.50608,0.087-0.49149,0.23309-0.97042,0.33894-1.4581,0.13916-0.59081,0.28324-1.1807,0.45181-1.7639,0.24685-0.0768,0.45085,0.14476,0.54825,0.34622,0.0927,0.18777,0.14071,0.39436,0.238,0.58007,0.15512-0.10144,0.0946-0.31832,0.11872-0.47543,0.0152-0.15485,0.0304-0.30969,0.0457-0.46453-0.31304-0.1647-0.66153-0.24833-0.97839-0.40212-0.23421-0.10598-0.4801-0.18831-0.71932-0.28456-0.2544-0.0981-0.50881-0.19622-0.76321-0.29433-0.14869,0.21099-0.19903,0.47202-0.34035,0.68786-0.0203,0.0495-0.016,0.10463-0.0107,0.15623z'/%3E %3Cpath d='m531.94,260.41c-0.16271,0.10621-0.22053,0.31112-0.32,0.47-0.11254,0.1949-0.26592,0.36296-0.37261,0.56205-0.33714,0.54561-0.66725,1.0957-1.0091,1.6384-0.14114,0.19219-0.30407,0.39241-0.52894,0.48695-0.15152,0.20048,0.20873,0.22646,0.31999,0.30686,0.10953,0.0742,0.32476,0.25919,0.40927,0.17838-0.036-0.19844-0.17904-0.39357-0.0675-0.59673,0.0893-0.15477,0.13329-0.51433,0.37585-0.35124,0.23331,0.14442,0.5003,0.24453,0.6992,0.43859,0.0649,0.17778-0.0714,0.37222-0.0378,0.56373,0.0705,0.2028-0.2648,0.33466-0.17639,0.48402,0.17528,0.13355,0.39001,0.20535,0.57612,0.32362,0.12943,0.0543,0.38207,0.25307,0.30999-0.0141-0.0105-0.27111-0.0661-0.54926-0.007-0.81697,0.10295-0.19812,0.0525-0.43767,0.0774-0.65383-0.002-0.29751,0.0705-0.58655,0.0902-0.88209,0.0501-0.48468,0.0911-0.97059,0.14753-1.4544,0.014-0.16128,0.14039-0.4454-0.0833-0.48327-0.14115-0.0465-0.24474-0.23664-0.40315-0.19986zm-0.28,0.87c0.0278,0.0668,0.0788,0.13005,0.0507,0.20561-0.0574,0.51053-0.13959,1.0185-0.17803,1.5309,0.006,0.2528-0.29329-0.0253-0.40847-0.0715-0.15363-0.0928-0.43584-0.15647-0.24917-0.37249,0.15257-0.26407,0.36848-0.48587,0.4999-0.76291,0.10207-0.17193,0.22776-0.33524,0.2851-0.52959z'/%3E %3Cpath d='m534.22,261.81c-0.0439,0.25209-0.008,0.5259-0.19284,0.73355-0.12665,0.23906-0.25368,0.47766-0.41498,0.69489-0.1486,0.26788-0.28184,0.54404-0.44896,0.80148-0.20769,0.35204-0.41742,0.70293-0.63322,1.0501-0.12473,0.0301-0.36159,0.0562-0.16831,0.21579,0.15231,0.19713,0.36399,0.3342,0.5239,0.52666,0.23791,0.21698,0.47801,0.43387,0.70592,0.6603,0.35949,0.25709,0.89441,0.3795,1.2746,0.0972,0.18196-0.17673,0.38141-0.34007,0.53918-0.5386,0.15646-0.2349,0.27043-0.49769,0.37333-0.7587,0.10407-0.34603,0.16398-0.70825,0.12088-1.0696-0.0385-0.57425-0.32726-1.107-0.7179-1.5189-0.22762-0.22684-0.47591-0.43428-0.70708-0.65535-0.096-0.0657-0.16948-0.15966-0.25448-0.23877zm0.69,1.03c0.30867,0.21593,0.50751,0.58387,0.47959,0.96465-0.0316,0.60253-0.31197,1.1613-0.6529,1.6479-0.18454,0.29997-0.39973,0.64377-0.76978,0.72365-0.28023,0.0719-0.56473-0.11609-0.69466-0.35574-0.11909-0.26651,0.0825-0.53363,0.18764-0.77031,0.30217-0.52421,0.63752-1.03,0.91057-1.5706,0.10528-0.21598,0.22963-0.43768,0.41912-0.59093,0.0368-0.0186,0.0763-0.0578,0.12042-0.0486z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23006300' d='m485.28,351.54c0.74989,0.25691,2.2844,0.97101,2.9039,1.2601,0,0,2.1485,4.007,2.1193,3.9502,0.81509,0.57807,0.68468,0.44962,1.5976,0.67442l-5.0536,2.0874c-1.4671,0.54596-0.8803,1.8306-0.19562,2.0875,0.74988,0.2248,2.3149-0.41751,2.8692-0.67442,2.5104-1.1561,4.7927-2.3444,7.0424-3.7896,0.35864-0.22481,2.0215-1.3809,2.3474-1.3168l8.9334,5.0741c0.65207,0.28904,1.9562,1.124,2.6735,0.6102,0.29343-0.1927,0.74989-0.64231,0.58687-1.1561-0.13041-0.54595-0.48905-0.64229-0.91291-0.80288-0.68468-0.28903-4.7275-2.1196-4.858-2.1196l1.076-0.28903c0.32604-0.22481-0.23638-0.89111,0.18747-0.76266l2.2252-3.6371,2.7713-0.99559c-0.0196-2.553-20.861-4.1412-26.313-0.20026z'/%3E %3Cpath fill='%23ff0' d='m486.73,360.12c-0.74988,0.2248-0.55426,1.67,0.9455,1.1883,1.0107-0.35327,0.22823-1.5737-0.9455-1.1883z'/%3E %3Cpath fill='%23ff0' d='m508.9,360.18c-0.22823,0.54595-0.19562,0.80287,0.32604,1.0277,0.55425,0.25692,0.8803,0.25692,1.2389-0.12847,0.48906-0.48171,0.0978-0.67441-0.32604-0.89921-0.45644-0.25693-0.0978-0.22481-0.45644-0.12847-0.26083,0.0964-0.45645,0.0642-0.78249,0.12847z'/%3E %3Cpath fill='%23006300' stroke='%23808000' stroke-width='0.2548' d='m530.27,277.34c-0.0659,0.10115-0.12699,0.0671,0.0706,0.40428,1.8767,3.7761,1.212,1.9907,2.7595,6.9133-0.29632-0.30345-0.69143-0.8406-0.98777-1.2452-0.82311-1.1126-1.5742-2.3278-2.2656-3.5417-0.16461-0.33717-0.26812-0.4351-0.56444-0.67113-0.1317,0.37088,0.52526,2.3552,0.68988,2.8948,0.69143,2.4276,2.5385,5.1986,3.8884,7.3902-0.39508-0.2023-0.62716-0.51321-0.95642-0.81664-1.1853-0.97776-0.85293-0.73488-1.5444-1.9486-0.65852-1.1464-1.1853-2.3668-1.6463-3.6144-0.32924-0.87662-0.65697-1.7122-1.0191-2.5551-0.1317,0.16858-0.0345-0.13639-0.13329,0.23449-0.0988,0.33717,0.0298,0.73824,0.0627,1.0754,0.16462,1.4161,0.39667,2.8371,0.62716,4.2532-0.95484-0.40459-1.8768-1.0467-2.7986-1.5524-0.19756-0.10115-0.45941-0.27217-0.68988-0.3396l-0.26654,0.0323c-0.19753,0.50574,1.6149,2.1236,1.9442,2.3934,0.42802,0.33717,2.2719,1.6222,2.4694,2.0942,0.72435,1.6858,1.3814,3.0014,2.5008,4.35l0.98778,1.2776-2.1716-2.1912c-1.5804-1.4498-2.2045-2.0527-3.9825-3.4687,0.0329,0.50574,0.65852,0.94174,0.98778,1.2452l2.7282,3.0646c0.85605,1.1126,1.8768,2.0623,2.6341,3.2423l1.7169,2.8948c-0.19756-0.33717-0.69302-0.97272-0.95642-1.3099l-2.63-3.27c-0.9219-1.1126-1.9427-1.886-3.128-2.8301-0.98775-0.80919-1.6463-1.3135-2.7986-1.8193-0.0658,0.30345,0.32612,0.5335,0.55659,0.73581,1.317,1.0789,2.4726,2.2968,3.7238,3.477,0.49388,0.47202,0.958,0.94022,1.4189,1.4797,0.46097,0.50574,0.88899,0.94832,1.317,1.4878,0.7902,1.0789,1.5742,2.321,2.2656,3.501l1.0583,1.8597c-0.82313-0.30346-4.6442-4.6512-5.5662-5.5953-0.75728-0.77547-1.0834-1.2179-2.0383-1.6899,0.0658,0.47202,2.6607,3.4426,3.2535,4.0832,0.26341,0.26971,0.36689,0.4351,0.56445,0.67112l1.1524,1.318c0.75729,0.91033,2.1386,2.522,2.6654,3.5334l0.7918,1.6252c-0.0329-0.16858-1.5491-2.1574-1.7796-2.3934-0.32924-0.43831-0.59267-0.77592-0.98778-1.1805-0.85605-0.94405-2.2719-2.5343-3.2926-3.2423l-2.6341-1.512c-0.13168,0.26974,0.43121,0.66822,0.76044,0.93794l0.98778,0.94601c1.1853,0.94405,2.7941,2.7644,3.7158,3.9782,0.62555,0.74176,1.0881,1.4548,1.6149,2.264-0.32923-0.2023-0.59269-0.50651-0.82316-0.77623-0.36217-0.37088-0.52526-0.47277-0.85449-0.77622-0.49388-0.50574-1.1524-0.97533-1.8109-1.4474l-4.2491-2.0942c0.0658,0.33717,1.4785,1.2113,1.8736,1.4474,0.82314,0.53945,2.2076,1.4158,2.9321,2.1912,0.32923,0.33716,0.49545,0.57927,0.79178,0.84898,0.62558,0.57317,1.0897,1.1759,1.5836,1.884,0.49387,0.70802,0.91881,1.2473,1.3798,1.9891,0.49388,0.77547,0.78869,1.4534,1.1838,2.2963l1.4503,5.3609c-0.46097-1.7532-1.35-3.6816-1.9756-5.4012-0.49388-1.3149-1.582-4.5109-3.2612-3.9378-0.62558,0.23601-0.92034,0.9079-1.1838,1.4474-0.39509,0.74176-0.92509-0.27158-2.2421,2.4257-0.72435,1.5172-1.2151,3.2708-1.5444,4.9565-0.0658,0.30346-0.0658,0.50512,0,0.80857,0.32926-0.13486,0.55818-1.0427,0.68988-1.4474,0.65852-1.6521,1.3202-2.6293,2.2421-4.1802l-1.2543,5.7004c0.42802-0.0674,0.56444-0.81636,0.72909-1.221,0.55972-1.4161,1.0489-2.8288,1.5757-4.2449,1.8768,1.3149,2.4726,8.3952,2.7359,10.924-0.19755-0.87662-0.92193-2.7634-1.317-3.6064l-1.9128-3.1696c-1.1194,0.13487-1.2496,1.5491-1.513,2.4257-0.32923-0.43831-0.66165-1.1752-1.4189-1.1077-0.69141,0.0337-0.95171,0.84167-1.0505,1.6171-0.0988,0.80919-0.10035,1.6812,0.0314,2.4904,0.0329,0.16858,0.23047,1.8218,0.32926,1.9567l0.23518,0.23448,0.39198-4.8514c0.72437,0.33717,2.1104,3.4731,1.9128,4.7544-0.72437,4.6866-1.1587,6.1651-3.6611,10.042-0.42803,0.67431-0.88588,1.3822-1.3798,1.9891-0.23047,0.33716-0.45785,0.64258-0.72123,0.94601l-0.82314,0.91367c1.2841-2.2253,1.8376-3.1057,2.7595-5.668,0.65849-1.9218,1.2198-3.943,1.4503-5.9997,0.0329-0.33717,0.0345-0.64121-0.0314-0.97836-0.26339,0.10115-0.3324,0.47278-0.43116,0.77623-2.1731,6.7434-2.4648,6.9762-6.0208,12.977l0.65852-3.8408c-0.32926,0.0337-0.26812,0.20321-0.39983,0.5741-0.0988,0.26974-0.19128,0.47417-0.29005,0.74388-0.49387,1.4835-0.98938,2.93-1.7796,4.2449,0.0658-0.40459,0.29163-0.9457,0.42334-1.3503,0.36217-1.2475,0.59424-2.5918,0.7918-3.8731l0.0314-0.88133c-0.39509-0.0337-0.42336,0.74084-0.58798,1.2129-0.42802,1.3824-1.0521,2.5998-1.6776,3.8811v-0.37195c0.1317-0.8429,0.36061-2.1246,0.196-2.9675,0,0,0.12856,0.20657-0.10193-0.29916-0.32924,0.10115-0.39667,0.73961-0.46252,1.043-0.0988,0.4046-0.22891,0.80963-0.36062,1.1805-0.82313,2.2927-1.8408,3.7717-3.0259,5.8621-0.69555-0.0203-0.14932,0.0487,0.15679,0.0728-0.0986-0.0249-0.16996-0.042-0.16465-0.0485,0.48297,0.0668,0.36571,0.0643,0.16465,0.0485,0.98266,0.24786,6.593,1.3099,6.593,1.3099,3.2595-0.13488,5.4282-0.40186,8.6548-0.0647,0.49388,0.0337,2.5024,0.40584,2.7986,0.1698-0.95482-0.53945-1.8706-0.77866-2.9241-1.1158l-3.0967-0.77622,8.788-0.23449-0.79178-0.43663c-1.4487-0.57316-5.367-0.81253-6.9143-0.91367,2.8975-0.26974,5.0439-0.49994,7.9414-0.53365,0.75633-0.21626,3.3342,0.61671,2.2029-0.54176-1.0207-0.70802-4.3462-0.80994-5.4327-0.77623l5.2054-0.23448c0.82745-0.21367,6.1768,1.0337,4.2802-0.20214-1.4816-0.74174-4.7461-1.4216-6.3265-1.6576,0.9219-0.53948,1.7482-1.0751,2.7359-1.4797,1.9755-0.8429,4.1488-1.4482,6.2561-2.0214,2.32-0.36074,4.0668-1.4665,1.0191-0.97836-1.8767,0.2023-4.147,0.73703-5.7935,0.9056l1.4817-0.80857c1.4487-0.74176,3.1233-1.0453,4.7037-1.5848,0.29633-0.10114,0.19914,0.003,0.29791-0.26681l-0.2587-0.097c-0.29632-0.0337-0.56602,0.0957-0.86234,0.12937,0.95484-0.57316,3.5906-1.1143,4.5783-1.3503,1.1853-0.26972,2.3738-0.60078,3.559-0.93794,0.36217-0.10115,0.85291-0.10085,1.0505-0.40429l-0.22736-0.13746c-0.36217-0.13486-6.7482,0.81116-7.4396,0.94602-0.62558,0.10115-1.8172,0.37194-2.344,0.37194,1.9426-0.80919,3.854-1.6571,5.8953-2.264,0.36218-0.10114,1.8486-0.36627,2.0461-0.70346-0.39511-0.16859-0.72595-0.0688-1.2857,0.0323-1.9096,0.30345-3.7552,0.80947-5.5662,1.3827-0.62558,0.20228-1.4848,0.53624-2.0775,0.67112,6.5521-2.5287,4.0547-1.7874,10.113-2.9675,0.69141-0.13487,1.2512-0.0697,1.317-0.54176l-3.4885-0.20214c-1.1524,0.0337-2.3378,0.30588-3.2926,0.3396l2.5949-2.1912c0.72434-0.60688,0.39513-0.77486,1.6463-0.80857,0.49388-0.0337,2.0085,0.0716,2.3048-0.097-0.88899-0.91033-1.1508-0.44167-2.0069-0.91367l1.0583-1.2856c0.26339-0.33717,0.52368-0.6371,0.72124-1.0754,0.0988-0.2023,0.0972-0.16431,0.0314-0.29916l-0.42334,0.0647-2.7046,2.2236c-0.46096,0.33717-0.35908,0.30589-1.0505,0.3396-1.1853,0.10115-2.3393,0.46882-3.4258,0.67113,1.2841-1.0115,2.1042-1.6152,3.5199-2.458,0.62558-0.4046,1.2857-0.74495,1.9442-1.1158,0.52679-0.26974,1.8454-0.70587,1.9442-1.043l-4.1784,1.0754c-0.82313,0.30346-3.0967,1.3824-3.5906,1.7869,1.8438-2.0567,4.6708-4.4121,6.8438-6.0644,0.26341-0.2023,0.9282-0.53746,1.027-0.84092-0.16464-0.0674-0.23518-0.10649-0.39983-0.0728-1.1524,0.23602-3.7519,1.99-4.641,2.5632-1.4816,0.97776-3.0967,2.0556-4.4137,3.2019,0.7902-0.8429,1.5177-1.6179,2.4067-2.3934,0.19756-0.2023,0.45941-0.43785,0.68988-0.60644,0.23049-0.2023,0.39669-0.37179,0.62716-0.5741,0.46096-0.37088,0.82474-0.73687,1.2857-1.1077,0.88899-0.74176,1.7733-1.5195,2.5636-2.3287l1.317-1.1482c0.29632-0.26971,1.1853-0.80552,1.1524-1.2775-1.8109,1.0115-3.4855,2.1189-5.1977,3.299-0.85605,0.57317-1.6464,1.1814-2.4695,1.7546-0.62558,0.40459-1.9128,1.5833-2.4067,1.8193,1.0207-1.6521,2.0775-3.3706,3.3944-4.7867,1.6133-1.787,3.6518-3.6415,5.4954-5.1588,0.49388-0.4046,0.95798-0.90803,1.4189-1.2452v-0.1698c-0.42802-0.0337-1.8502,1.0159-2.1794,1.2856-1.9755,1.4498-3.912,3.0604-5.5582,4.7464-0.29632,0.30345-0.52684,0.61161-0.82316,0.88133-0.85605,0.80919-1.6839,1.8846-2.3754,2.8622-0.92193,1.3149-1.9113,2.7318-2.7673,4.1479,0.55973-2.5624,2.3723-4.5471,3.7552-6.0644l3.1594-3.477c0.23046-0.23601,0.3355-0.40276,0.53308-0.63878,2.1101-2.317,3.1245-4.1168,3.5512-6.8324-0.35831,0.52436-0.86819,1.1396-1.6698,2.1346-0.25224,0.29523-0.46897,0.51687-0.72124,0.84899l-6.4128,7.3822c0.28832-1.0333,1.5479-3.2462,2.1245-4.1319,0.8649-1.3285,1.6234-2.4369,2.5244-3.6547,0.61263-0.84878,3.4233-4.507,4.1079-5.1345,0.0422-0.0433,0.20114-0.20182,0.2979-0.29916,0.0738-0.44941,0.43274-0.67726,0.90153-1.0673,0.52682-0.43831,0.62875-0.67356,1.2543-1.0107-0.59265-0.60691-2.8019,0.77196-3.2299,1.0754-2.7986,1.9218-4.8026,4.5502-6.8438,7.1801,0.2634-1.4161,1.9379-5.5635,2.7282-6.7434,0.65849-0.87662,1.2543-2.0208,1.9128-2.8301l1.8423-2.9028c-0.42805,0.0337-0.92035,0.6763-1.1838,0.94601-0.19756,0.2023-0.32771,0.33944-0.52526,0.54176-2.4694,2.6298-3.9245,5.5604-5.6367,8.7972,0.0988-1.6184,1.5538-4.3451,2.344-5.66,1.0207-1.7532,2.1684-3.2384,3.2221-4.9241-0.59264-0.16858-2.3378,1.9227-2.6341,2.361-0.75728,0.94405-1.513,1.8885-2.1716,2.9675-1.1853,1.9892-2.3378,4.2095-3.128,6.4686l-0.196,0.47707c0.1317-2.1241,2.2374-7.1855,3.1594-8.8376,0.55973-0.97776,1.1524-1.7526,1.8109-2.5954,0.26338-0.30345,0.42805-0.5698,0.65852-0.87326,0.46096-0.57316,0.85607-1.0844,1.317-1.6576l1.2857-1.7142c-0.82313-0.30345-3.7913,3.0679-4.351,3.7761-0.72434,0.91033-1.3813,1.9169-2.0069,2.8948,0.32923-1.6184,1.5491-3.8747,2.4381-5.2235,0.7902-1.2138,1.6118-2.1877,2.5008-3.2666,0.29632-0.33716,0.52993-0.67889,0.76042-1.0835-0.9219-0.13487-4.707,4.2861-5.4641,5.2638-0.32926,0.43831-0.59738,0.83924-0.8937,1.2775l-1.2465,1.9891c-0.0658,0.13487-0.10503,0.20336-0.20382,0.37194l-0.2587,0.3396c0.19756-1.5509,1.1211-4.7937,1.6149-6.2098,0.69141-1.8207,1.64-3.4687,2.4302-5.2556-0.65852-0.10115-1.9035,1.5871-2.2656,2.1266l-1.4816,2.8301c0.16461-1.3149,2.2014-5.8986,2.8927-7.5842-0.39508,0.10114-0.65696,0.70574-1.0191,1.2452-0.92193,1.4498-1.7467,2.8666-2.6027,4.35,0.1317-1.4835,1.0897-3.0366,1.7482-4.3179-1.2182,0.53945-3.2612,4.892-3.7552,6.2745-0.23047,0.57317-0.46251,1.2434-0.62716,1.884l-0.25869,0.6792c-0.0658-3.3378,0.61936-6.7477,1.1132-10.018-0.29632,0.0674-0.36222,0.40809-0.4939,0.71154-0.13173,0.30345-0.22891,0.53746-0.36062,0.84091-0.19755,0.60688-0.42805,1.1773-0.65852,1.8516l-0.95642,3.9782c-1.4158-1.9893-1.7718-5.6608-4.5705-9.8079-0.88899-1.3149-1.1901-1.4534-2.3754-2.2963zm1.4895,39.789c1.1524,3.203,1.6134,4.3166,2.4694,7.7219-0.16464,0.10115-0.23046,0.16293-0.32926,0.3315-0.13167,0.33717-0.26343,0.95106-0.4939,1.4231l-0.85449-2.9675c-0.32924-1.0789,0.13481-3.2757-0.22736-3.6467-0.32926,0.57317-0.23205,0.67705-0.2979,1.7222-0.19753-0.23601-0.39353-0.90803-0.52524-1.2452-0.65851-1.8207-0.75728-1.2835-0.32926-2.3287,0.13171-0.30345,0.32455-0.87584,0.58796-1.0107z'/%3E %3Cg fill='%23008f4c'%3E %3Cpath d='m540.42,311.56c0.42469-4.4486,5.9151-14.97,7.5254-15.198,0.24256-0.0321-1.8045,2.9357-3.2264,5.8711-1.4218,2.9354-2.9381,6.7757-3.4434,8.5576-0.47176,1.7637-0.90304,3.1036-0.94346,3.0252-0.0404-0.0783-0.007-1.1007,0.0877-2.2566z'/%3E %3Cpath d='m552.36,308.82c-0.0158,0.0856-1.0098,1.0722-2.254,2.1868-4.1568,3.8811-8.998,10.665-11.222,16.14-2.3608,5.8616-1.7644,4.3774-1.0684,1.5286,1.8046-6.1488,6.7392-13.944,11.333-17.739,1.615-1.3667,3.27-2.4299,3.2113-2.1162z'/%3E %3Cpath d='m538.54,298.82c0.005-4.0573,0.38754-5.4716,2.7186-10.343,1.4916-3.1269,2.0543-4.1526,2.2185-3.9176,0.10165,0.17169-0.032,0.73648-0.31265,1.2787-1.3801,2.6658-3.636,10.275-4.0239,13.601-0.13318,1.116-0.33159,2.0513-0.4292,2.0559-0.10928,0.0271-0.18569-1.1747-0.17119-2.6749z'/%3E %3Cpath d='m531.97,321.48c0.261,3.158-0.26246,6.747-1.6548,10.362-0.83809,2.1645-4.1423,7.1643-4.9295,7.4844-0.38696,0.15093-0.29253-0.0592,0.57872-1.0708,3.4587-4.0933,5.7586-10.175,5.8048-15.772-0.19934-3.0369,0.0155-3.4382,0.20087-1.0042z'/%3E %3Cpath d='m542.03,317.66c0.47323,1.4206,0.54026,4.7691,0.0271,6.496-1.2433,4.1761-4.216,7.2321-8.4524,8.7116-0.83169,0.27833-1.5471,0.48662-1.6047,0.43339-0.0384-0.0355,0.60093-0.40296,1.4526-0.78704,5.285-2.4802,8.5793-7.4758,8.6159-13.052,0.007-1.0411-0.20376-1.5475-0.26173-1.8077-0.096-0.43114-0.19136-0.76681-0.0538-0.8767,0.0727-0.0581-0.0697-0.15819,0.27688,0.88208z'/%3E %3Cpath d='m553.59,326.55c-0.0582,0.0527-2.3577,0.48271-5.1013,0.96355-2.7434,0.4632-6.299,1.1342-7.8646,1.4796-2.4158,0.51771-2.8987,0.58597-3.0518,0.37346-0.0956-0.14162-0.17182-0.28316-0.17147-0.3361,0-0.10587,7.459-1.4463,11.69-2.0787,3.0716-0.46162,4.7323-0.61242,4.4992-0.40177z'/%3E %3Cpath d='m531.89,279.97c1.761,2.1251,2.1754,3.042,3.0728,6.6683,0.57856,2.3256,0.72994,3.1225,0.54194,3.0754-0.12779-0.0428-0.30337-0.40012-0.39218-0.81359-0.4366-2.0329-2.5633-7.0572-3.8059-8.9766-0.41538-0.64551-0.71808-1.2266-0.66898-1.2741,0.0454-0.0647,0.60774,0.52879,1.2521,1.3204z'/%3E %3Cpath d='m529.98,282.57c0.83472,2.6596,1.3756,3.5036,3.9024,6.1896,1.619,1.7252,2.1982,2.2751,2.2577,2.0852,0.0315-0.13474-0.17191-0.47598-0.46711-0.77035-1.4514-1.4473-4.4905-5.9451-5.4264-8.0412-0.31609-0.70279-0.6379-1.2729-0.70282-1.2546-0.0772,0.006,0.11901,0.81084,0.43597,1.7914z'/%3E %3Cpath d='m545.76,290.82c-2.7944,2.5591-7.325,10.743-6.663,12.017,0.10112,0.19085,1.266-1.6886,2.5315-4.1986,1.2655-2.5101,3.0954-5.5467,4.0449-6.813,0.95414-1.2329,1.6422-2.222,1.5687-2.2114s-0.74798,0.55272-1.4821,1.2062z'/%3E %3Cpath d='m547.02,292.91c-3.1215,2.8588-8.1827,12.001-7.4432,13.424,0.11297,0.21319,1.4143-1.8863,2.828-4.6902,1.4137-2.804,3.4577-6.1961,4.5186-7.6106,1.0658-1.3772,1.8344-2.4822,1.7524-2.4704s-0.83555,0.61746-1.6556,1.3474z'/%3E %3Cpath d='m529.11,284.53c0.4935,2.7489,0.92384,3.6578,3.0919,6.659,1.3886,1.927,1.8938,2.5498,1.9767,2.3694,0.0481-0.1294-0.11065-0.49494-0.36638-0.82629-1.2573-1.6291-3.7055-6.4952-4.3703-8.6987-0.22513-0.73912-0.47258-1.3474-0.53929-1.3379-0.0773-0.004,0.0161,0.8199,0.20724,1.8345z'/%3E %3Cpath d='m527.1,286.46c1.9567,1.9345,2.8207,2.4134,6.2796,3.544,2.2182,0.72826,2.9808,0.92953,2.9462,0.73328-0.0342-0.13404-0.37003-0.33518-0.76519-0.45019-1.9429-0.56543-6.685-3.0415-8.4722-4.4304-0.60117-0.46449-1.1464-0.80932-1.1952-0.76145-0.0652,0.0431,0.47724,0.65594,1.2068,1.3646z'/%3E %3Cpath d='m552.36,299.7c-4.2471,2.9486-11.848,13.208-11.174,15.063,0.10353,0.27818,2.018-2.0545,4.1806-5.2245,2.1627-3.1701,5.1849-6.9485,6.6983-8.4896,1.5138-1.4944,2.623-2.708,2.5214-2.7075-0.1016,0.00078-1.1135,0.6097-2.226,1.3588z'/%3E %3Cpath d='m551.71,305.98c-1.8541,3.7282-8.9784,10.868-10.459,10.494-0.22224-0.058,1.3802-1.8327,3.5989-3.8876,2.2189-2.055,4.8219-4.8654,5.8569-6.2401,0.99959-1.3704,1.8226-2.3858,1.8318-2.3032,0.009,0.0826-0.36129,0.9621-0.82916,1.9365z'/%3E %3Cpath d='m526.67,331.71c-0.75962,3.6757-5.3088,11.577-6.675,11.611-0.20561,0.003,0.77926-1.9201,2.2343-4.2351,1.4551-2.3149,3.0713-5.3769,3.6558-6.8168,0.55464-1.4279,1.0369-2.5058,1.0636-2.4364,0.0265,0.0694-0.0946,0.9203-0.27861,1.877z'/%3E %3Cpath d='m538.31,309.63c-0.74475-2.3534-2.8373-5.1883-5.731-7.7563-2.9068-2.6123-3.7951-3.0291-1.2383-0.5813,2.3562,2.2403,5.3018,6.2316,6.3572,8.6174,0.44915,0.967,0.88698,1.7396,0.98246,1.671,0.12242-0.056-0.0436-0.92788-0.3704-1.9508z'/%3E %3Cpath d='m540.5,339.51c-3.2675-0.95323-11.656-0.85667-12.323,0.13447-0.0989,0.14987,1.8858,0.21653,4.4007,0.0983,2.5148-0.11824,5.6969-0.0478,7.1112,0.1146,1.3908,0.17935,2.4704,0.2679,2.4279,0.21979-0.0426-0.0481-0.77334-0.30902-1.6174-0.56714z'/%3E %3Cpath d='m536.91,340.96c-3.3014-0.82014-11.68-0.38382-12.308,0.63353-0.0931,0.15376,1.8926,0.13998,4.4012-0.08,2.5085-0.22002,5.6909-0.27853,7.1102-0.17356,1.3965,0.12288,2.4787,0.16764,2.4344,0.12126-0.0444-0.0463-0.7845-0.27745-1.6377-0.50118z'/%3E %3Cpath d='m533.22,342.75c-3.3207-0.73234-11.686-0.074-12.288,0.95963-0.0892,0.15618,1.8955,0.0897,4.3976-0.1967,2.5022-0.28645,5.6821-0.4293,7.1035-0.362,1.3991,0.0858,2.482,0.10187,2.4366,0.0567-0.0455-0.0451-0.79115-0.25656-1.6497-0.45761z'/%3E %3Cpath d='m531.04,344.85c-2.8157-1.0607-10.114-1.2414-10.72-0.27277-0.0901,0.14653,1.6341,0.27872,3.8244,0.24365,2.1902-0.0351,4.9556,0.14046,6.1813,0.34951,1.2046,0.22522,2.1411,0.3494,2.1055,0.29988-0.0358-0.0494-0.66417-0.33442-1.3912-0.62028z'/%3E %3Cpath d='m544.08,334.5c-6.887,1.9576-15.21,3.1507-15.686,4.7997-0.0695,0.24858,3.0397-0.25642,6.0983-1.4693,3.0585-1.2128,7.0054-2.4431,8.8053-2.8086,1.777-0.33218,3.1707-0.72609,3.1333-0.90687-0.0693-0.0487-1.2211,0.3899-2.3516,0.38498z'/%3E %3Cpath d='m553.06,330.08c-0.0693,0.0626-2.8042,0.57413-6.0674,1.146-3.263,0.55092-7.4918,1.349-9.3537,1.7598-2.8734,0.61575-3.4476,0.69695-3.6295,0.44421-0.11367-0.16845-0.20438-0.33678-0.20395-0.39976,0-0.12592,8.8716-1.7201,13.903-2.4724,3.6533-0.54902,5.6284-0.72838,5.3514-0.47787z'/%3E %3Cpath d='m550.93,328.3c-0.053,0.0583-2.3004,0.71896-4.9849,1.4751-2.6863,0.7386-6.1607,1.7662-7.6857,2.2683-2.3549,0.75969-2.829,0.87649-3.0014,0.68052-0.10857-0.13127-0.19793-0.26441-0.20262-0.31712-0.009-0.10543,7.2854-2.1941,11.435-3.2516,3.0129-0.77023,4.6513-1.0884,4.4393-0.85517z'/%3E %3Cpath d='m549.23,320.19c-4.7589,1.9473-14.305,10.3-14.03,12.26,0.0437,0.29455,2.3962-1.5637,5.1643-4.1857,2.768-2.6218,6.5014-5.6494,8.2986-6.822,1.7878-1.1273,3.1225-2.0692,3.0229-2.091-0.0994-0.0216-1.2139,0.35091-2.4557,0.83823z'/%3E %3Cpath d='m552.76,322.47c-4.7446,0.31156-15.516,5.1596-15.826,7.1095-0.0445,0.29383,2.5533-0.71071,5.733-2.3062s7.3247-3.264,9.2398-3.797c1.894-0.49285,3.3362-0.95605,3.2547-1.0089-0.0816-0.0526-1.1691-0.059-2.4013,0.003z'/%3E %3Cpath d='m552.61,323c-12.14,10.201-18.961,15.189-21.382,14.133-0.36325-0.16189,4.4606-2.9318,8.5848-5.5692,4.1242-2.6376,9.0376-6.3772,11.04-8.2792,1.9418-1.9062,3.5194-3.2933,3.5191-3.1572,0,0.13619-0.78995,1.4427-1.7617,2.8726z'/%3E %3Cpath d='m539.62,326.19c2.4465-3.9823,3.6737-5.1265,8.8946-8.4184,3.3468-2.1163,4.5168-2.7636,4.5366-2.4276-0.004,0.2337-0.47464,0.70292-1.0767,1.0558-2.96,1.735-9.7551,7.7646-12.138,10.783-0.80247,1.0109-1.5602,1.8026-1.6588,1.7446-0.12367-0.0433,0.52459-1.2728,1.4416-2.737z'/%3E %3Cpath d='m540.95,314.72c0.42469-4.4486,8.0407-19.308,9.651-19.535,0.24256-0.0321-1.8045,2.9357-3.2264,5.8711-1.4218,2.9354-2.9381,6.7757-3.4434,8.5576-0.47175,1.7637-3.2547,8.2345-3.2951,8.1561-0.0404-0.0783,0.21943-1.8936,0.31383-3.0495z'/%3E %3Cpath d='m537.74,297.58c-1.2794-3.0185-1.3208-4.1751-0.38834-8.4371,0.59354-2.7346,0.86618-3.6519,1.1148-3.5223,0.16223,0.0998,0.19921,0.55642,0.0729,1.0367-0.62101,2.3613-0.60706,8.6386,0.0339,11.218,0.21193,0.86645,0.2974,1.6164,0.19522,1.6466-0.10742,0.0502-0.56898-0.82257-1.0285-1.942z'/%3E %3Cpath d='m540.07,313.88c-0.67054-2.1189-2.5546-4.6713-5.16-6.9837-2.6173-2.3519-3.417-2.7274-1.115-0.52335,2.1215,2.0171,4.7734,5.6108,5.724,7.7589,0.4044,0.87067,0.7986,1.5663,0.88458,1.5045,0.11023-0.0504-0.0393-0.83543-0.3335-1.7565z'/%3E %3Cpath d='m528.4,317.3c2.3968-8.6291,4.2963-7.1364,4.2963-7.1364,5.2458,4.944,2.6682,21.922,2.6682,21.922-0.0452-34.749-6.9642-14.786-6.9642-14.786z'/%3E %3Cpath d='m530.34,316.7c2.3968-8.6291,3.0299-8.2557,3.0299-8.2557,4.3415,0.88622,4.07,19.916,4.07,19.916-1.8993-32.651-7.1-11.661-7.1-11.661z'/%3E %3Cpath d='m528.05,323.4c-0.0959-6.1984,1.1279-5.2706,1.1279-5.2706,3.5083,3.1391,4.8126,15.202,4.8126,15.202-5.4455-24.357-5.9405-9.9313-5.9405-9.9313z'/%3E %3Cpath d='m538.69,305.19c-1.0537-3.3298-4.0141-7.3405-8.1084-10.974-4.1127-3.6959-5.3695-4.2858-1.752-0.82241,3.3337,3.1696,7.5008,8.8169,8.9945,12.192,0.63546,1.3682,1.2549,2.4613,1.39,2.3642,0.1732-0.0792-0.0618-1.3128-0.52405-2.76z'/%3E %3Cpath d='m538.34,302.27c-0.81112-2.5632-3.0902-5.6507-6.2418-8.4477-3.1659-2.8451-4.1335-3.2992-1.3487-0.63309,2.5663,2.44,5.7741,6.7871,6.9239,9.3856,0.48918,1.0532,0.96602,1.8947,1.07,1.82,0.13334-0.061-0.0475-1.0106-0.40341-2.1247z'/%3E %3Cpath d='m520.88,336.62c-0.24888,1.8826-2.2542,6.0424-2.9416,6.1125-0.10351,0.01,0.32283-0.9982,0.97197-2.2217s1.3523-2.8299,1.5944-3.5784c0.22753-0.7414,0.43136-1.3035,0.44734-1.2695,0.0158,0.034-0.014,0.46762-0.072,0.95706z'/%3E %3Cpath d='m519.15,337.71c-0.24889,1.8826-2.2542,6.0424-2.9416,6.1125-0.10351,0.01,0.32284-0.9982,0.97198-2.2217,0.64913-1.2235,1.3523-2.8299,1.5944-3.5784,0.22754-0.7414,0.43137-1.3035,0.44735-1.2695,0.0158,0.034-0.014,0.46762-0.072,0.95706z'/%3E %3Cpath d='m521.76,337.85c-0.24889,1.8826-2.2542,6.0424-2.9416,6.1125-0.10351,0.01,0.32284-0.9982,0.97198-2.2217,0.64913-1.2235,1.3523-2.8299,1.5944-3.5784,0.22754-0.7414,0.43137-1.3035,0.44735-1.2695,0.0158,0.034-0.014,0.46762-0.072,0.95706z'/%3E %3C/g%3E %3Cpath fill='%2300873f' d='m457.76,290.38c0.0131,0.93148,0.2693,1.1727,0.68309,1.7624l0.10509-1.8227c-0.34156-0.20773-0.47291-0.0335-0.78818,0.0603z'/%3E %3Cg fill='none' stroke='%23006300' stroke-width='0.6268'%3E %3Cpath d='m455.17,303.94c-0.86564-0.69253-0.86564-0.69253-0.86564-0.69253'/%3E %3Cpath d='m456.08,298.62c-0.69253-0.99551-0.7358-0.99551-0.7358-0.99551'/%3E %3Cpath d='m453.57,311.08c-0.25969-2.1208-1.4716-2.7268-1.4716-2.7268'/%3E %3Cpath d='m463.44,338.34c-5.3999-5.9702-7.1651-16.77-7.1651-16.77,1.7652-4.5176,4.1016-5.5566,4.1016-5.5566'/%3E %3Cpath d='m456.28,321.52c-1.7654-6.9574-1.3247-14.228-1.3247-14.228,0.62303-8.9303,3.4535-16.822,3.4535-16.822'/%3E %3Cpath d='m454.9,309.78c1.4318-6.5359,6.8702-5.7462,6.8702-5.7462'/%3E %3Cpath d='m454.83,310.99c4.8829-1.9826,4.3006-6.2884,5.1767-8.0404,1.3217-2.6434,2.2762-3.4145,2.2762-3.4145'/%3E %3Cpath d='m459.7,332.37c-1.6615-4.2057,0.31153-4.9844,0.31153-4.9844'/%3E %3Cpath d='m459.03,331.02c-2.1294-2.7516-4.8293-2.5432-4.8293-2.5432'/%3E %3Cpath d='m458.09,318.2c1.298-2.3884-0.0519-4.7804-0.0519-4.7804'/%3E %3Cpath d='m458.73,329.72-3.7984-4.9251'/%3E %3Cpath d='m457.21,294.36c0.51401-1.9459-1.028-2.827-1.028-2.827'/%3E %3Cg transform='matrix(0.15669945,0,0,0.15669945,442.05165,224.217)'%3E %3Cpath id='b' fill='%23f00' stroke='%23006300' stroke-width='2' d='m91.376,425.97c0,3.2997-2.6749,5.9746-5.9746,5.9746s-5.9746-2.6749-5.9746-5.9746,2.6749-5.9746,5.9746-5.9746,5.9746,2.6749,5.9746,5.9746z'/%3E %3C/g%3E %3Cuse xlink:href='%23b' transform='matrix(0.15669945,0,0,0.18127975,444.56657,235.35279)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.15669945,0,0,0.15669945,443.68543,248.31983)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.16898961,0,0,0.16898961,439.99242,252.04284)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.16898961,0,0,0.16898961,438.74414,256.22825)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.16898961,0,0,0.16898961,440.28613,257.84368)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.1228861,0,0,0.1228861,463.22156,286.0505)'/%3E %3Cuse xlink:href='%23b' transform='matrix(0.1228861,0,0,0.1228861,464.29275,287.30532)'/%3E %3Cpath d='m458.76,316.61c-0.22029-0.95456-1.1014-1.2483-1.1014-1.2483'/%3E %3Cpath d='m472.4,339.53c1.5914,1.163,2.0811,0.42848,2.0811,0.42848'/%3E %3C/g%3E %3Cg fill='%23006300'%3E %3Cpath d='m474.38,342.94c-0.97938-3.4891-0.73453-4.2848-0.73453-4.2848'/%3E %3Cpath d='m466.03,336.65s-0.58368-1.3619,0.36854-2.141c0.56415-0.46158,3.0031,0.8661,4.2574-4.5778,0,0-0.75943-0.0887-2.5052,0.70258v-0.43282s-0.38954-1.2119-0.21642-2.7267c0,0,0.83107-1.2779,0.85778-1.7925,0,0-1.5734-0.58187-4.6461,3.3712,0,0-0.28024-0.84292-2.531-2.3579,0,0-1.2209,3.4543-0.60596,5.4104,0.47746,1.5188,0.51197,2.057,2.1208,3.1597,0,0,1.2985,0.56267,1.4716,2.2939,0.60596,0,1.396-0.10292,1.396-0.10292s0.0756,0.0164,0.0323-0.80601z'/%3E %3Cpath d='m463.74,340.68c-0.49774,0.28134-0.71921,0.53616-1.6015,0.64924-3.9646,0.50814-6.1895-4.7178-6.1895-4.7178-0.12985-1.0388,0.3471-0.49052,1.1686-0.19478,1.0821,0.38954,1.4045,0.0827,2.6186-0.0649,1.6015-0.19477,3.3977,1.385,3.3977,1.385,1.0171,0.88729,1.1037,2.6618,1.1037,2.6618-0.10821,0.28134-0.49774,0.28134-0.49774,0.28134z'/%3E %3Cpath d='m459.03,331.25c-4.1471-1.7597-6.6107,0.21424-6.6107,0.21424-0.15303,0.26015,0.24484,0.38256,0.24484,0.38256,2.6015,0.32136,1.7655,0.20058,2.8463,1.6833,1.8516,2.5402,5.1264,2.0046,5.1264,2.0046,0.67332,0.15303,1.3466,0.96406,1.3466,0.96406-0.27544-2.2648-2.9535-5.2488-2.9535-5.2488z'/%3E %3Cpath d='m451.85,314.83c-0.79573-0.5509-0.61581,0.55089-0.61581,0.55089-1.714-2.9994-6.2398-3.2299-6.2398-3.2299-0.36897-0.0169-0.58537-0.29821-0.58537-0.29821-0.75744,0,0.17314,1.5149,0.17314,1.5149,1.3634,3.6357,2.6618,4.0469,2.6618,4.0469-1.545,0.88325-4.019-1.036-3.4626,0.3679,2.4022,2.532,4.0253,2.8782,4.0253,2.8782,3.0298,0.7358,4.3716,0,4.3716,0,0.69252,1.2552,1.147,1.4283,1.147,1.4283,2.7485,0.82237,3.3545,2.4022,3.3545,2.4022,0-3.0082-1.1319-6.7176-1.1319-6.7176-0.85981-1.2912-3.698-2.946-3.698-2.946z'/%3E %3Cpath d='m473.25,343.98c-1.4691,0.45908-1.5914,1.4997-1.5914,1.4997-1.4384,1.9587-6.6108,0.0918-6.6108,0.0918-1.5914-0.42848-1.2854-0.85695-1.2854-0.85695,1.4385-0.73453,1.9282-1.316,1.9282-1.316-2.7545-2.479-3.1523-5.6926-3.1523-5.6926,4.2848-0.85695,5.6008-0.0612,5.6008-0.0612-0.27545-1.6527-1.6833-1.6833-1.6833-1.6833-0.33665-0.52029,0.39788-0.5509,0.39788-0.5509,3.7644,0.36728,5.7844,2.7239,5.7844,2.7239,1.4078,1.9893,0.97937,3.948,0.97937,3.948,0.33666,1.9893-0.36727,1.8975-0.36727,1.8975z'/%3E %3Cpath d='m455.76,326.72c-2.0824-0.61308-3.2894,0.0649-3.2894,0.0649-1.0821,0.43282-3.0514-0.82236-3.0514-0.82236-2.597-2.1625-3.0948-3.5054-3.0948-3.5054,0-0.38954,2.2931-0.3019,2.2931-0.3019,3.0224-0.0727,3.711,0.54709,3.711,0.54709,1.5609,0.88756,1.4001,1.7007,1.9588,2.0275,1.3466,0.78809,1.5609,1.1554,1.5609,1.1554,0.38257,0.52029,0.55007,1.0231-0.0882,0.83517z'/%3E %3Cpath d='m459.8,327.78c1.4283-1.6447,3.3761-0.5194,3.3761-0.5194,2.9865,0.34626,3.9386-3.0298,3.9386-3.0298,0.69252-1.385,1.2119-2.0343,1.2119-2.0343,0.17312-0.77907-1.2985-0.12984-1.2985-0.12984-2.5537,0.64923-2.6402,0.90893-2.6402,0.90893,0.43282-4.0253,0.43282-4.0685,0.43282-4.0685,0.0433-0.64924-0.69251-0.17312-0.69251-0.17312-3.679,2.1208-4.1118,3.679-4.1118,3.679-1.5149-2.8566-1.5149-2.8566-1.5149-2.8566-0.47612-1.1686-0.82236,0.12984-0.82236,0.12984-0.69252,3.4626-0.43282,3.7656-0.43282,3.7656,0.47612,1.8611,0.95222,2.3806,0.95222,2.3806,0.86565,1.1254,0.86565,1.5582,0.86565,1.5582z'/%3E %3Cpath d='m481.45,337.25c-0.5815,0.15303-2.1118,2.5708-2.1118,2.5708-1.8364-3.4584-4.2848-4.0093-4.2848-4.0093-0.48969,0.21424,0.0612,1.01,0.0612,1.01,0.73453,1.8364-0.12242,3.2747-0.12242,3.2747-0.27545,1.3466,0.0306,1.6527,0.0306,1.6527-2.9076-1.4997-3.0912-1.3466-3.0912-1.3466-0.0306,1.8669,2.2035,5.356,2.2035,5.356,4.8356-1.2854,5.2029-1.1936,5.2029-1.1936,1.8056-0.27544,1.7597-0.30605,1.7597-0.30605,1.4538-4.1622,0.35196-7.0087,0.35196-7.0087z'/%3E %3Cpath d='m457.75,318.21c1.8669,0.91817,1.9893,2.1424,1.9893,2.1424,0.48968,1.5914,4.8356,1.9587,4.8356,1.9587,3.5502-0.36727,3.1829-1.01,3.1829-1.01-2.0506-1.8056-1.4611-1.6629-2.326-2.5097-1.5476-1.5152-3.5809-1.5609-3.5809-1.5609-2.7239,0.42848-3.3054-0.12242-3.3054-0.12242-0.97937,0.52029-0.79573,1.1018-0.79573,1.1018z'/%3E %3Cpath d='m453.54,311.97c-0.8773-3.1993,2.02-7.1616,2.02-7.1616,2.4179,4.499,1.9587,5.7538,1.9587,5.7538-0.85714,2.9992-2.043,5.2024-2.043,5.2024-0.44378-2.2643-1.6138-2.6216-1.9359-3.7953z'/%3E %3Cpath d='m451.99,313.22c-3.0649,0.0878-5.9878-3.3831-5.9878-3.3831,4.5695-1.1851,5.5956-0.49794,5.5956-0.49794,2.5053,1.4267,4.2242,2.9745,4.2242,2.9745-2.1308-0.0978-2.7073,0.87476-3.8318,0.90656z'/%3E %3Cpath d='m449.63,308.91c-1.9478,0.30298-3.6357-1.6015-3.6357-1.6015-2.597-3.4626-1.7314-4.588-1.7314-4.588,0.21641-0.12985,0.51939,0.30298,0.51939,0.30298,0.82238,0.7358,2.2939,0.90893,2.2939,0.90893-4.1552-2.597-1.4283-8.3535-1.4283-8.3535,0.51939-0.56267,0.69252,0.82238,0.69252,0.82238,0.56267,1.5149,2.2074,2.4238,2.2074,2.4238,0.86566,1.1686,0.86566,1.6447,0.86566,1.6447,0.43282-1.9478,0.90893-1.4283,0.90893-1.4283,0.5194,1.5582,2.2427,2.6482,2.4671,3.7222,0.60595,2.8999,0.12985,3.2894,0.12985,3.2894-0.34626,1.688-0.3679,2.9649-0.3679,2.9649-1.5798-0.58432-2.9215-0.10821-2.9215-0.10821z'/%3E %3Cpath d='m459.41,315.88c0.99549-1.3418,0-3.8522,0-3.8522-0.38954-2.6835,3.6357-5.2372,3.6357-5.2372,1.1686,2.1642,1.0388,3.4626,1.0388,3.4626,3.073-0.73579,3.7656-0.95221,3.7656-0.95221,0.12985,1.7314-1.5149,4.2417-1.5149,4.2417,2.5103,0.7358,3.3761-0.47611,3.3761-0.47611-1.2119,5.5835-6.5356,4.4581-6.5356,4.4581-2.2074-1.4283-3.7656-1.6447-3.7656-1.6447z'/%3E %3Cpath d='m451.06,299.6c0.30605-3.3665,0.91817-3.4891,0.91817-3.4891,0.36227,0.13356,0.54039,1.6302,1.0251,1.8536,2.11,0.97288,2.0966,3.2269,2.0966,3.2269-0.0612,2.6934-0.45165,2.4516-0.45165,2.4516-2.9439-0.0376-3.5883-4.0413-3.5883-4.0413z'/%3E %3Cpath d='m460.8,300.27c1.0285-3.8161,0.40679-4.1983,0.40679-4.1983-0.45142-0.00031-1.2531,1.5687-1.8752,1.6174-2.7081,0.21203-3.6069,2.6893-3.6069,2.6893-1.0242,2.9784-0.498,2.8715-0.498,2.8715,3.2441,1.1509,5.2074-1.6223,5.5733-2.98z'/%3E %3Cpath d='m451.19,293.29c0.35592-3.9361,1.0715-4.0797,1.0715-4.0797,0.42363,0.15595,0.63272,1.9055,1.1995,2.1665,2.4674,1.1362,2.4531,3.7714,2.4531,3.7714-0.07,3.1489-0.52666,2.8664-0.52666,2.8664-3.4419-0.0431-4.3241-3.3245-4.1975-4.7248z'/%3E %3Cpath d='m462.18,294.23c1.1134-3.7921,0.50037-4.1883,0.50037-4.1883-0.45129-0.0104-1.2878,1.5404-1.911,1.5751-2.7122,0.15155-3.666,2.6081-3.666,2.6081-1.0904,2.9549-0.56196,2.8598-0.56196,2.8598,3.2177,1.223,5.2424-1.5058,5.6385-2.8548z'/%3E %3Cpath d='m466.7,304.83c3.1305-2.4124,2.8676-3.0932,2.8676-3.0932-0.3589-0.27381-1.9475,0.48855-2.4719,0.15031-2.2828-1.4724-4.4988-0.0463-4.4988-0.0463-2.6196,1.7488-2.1363,1.9824-2.1363,1.9824,1.8832,2.8814,5.1256,1.865,6.2393,1.0068z'/%3E %3Cpath d='m466.6,306.9c2.981-1.3679,2.8782-1.9329,2.8782-1.9329-0.24984-0.26671-1.6855,0.072-2.0608-0.27011-1.6341-1.4893-3.6973-0.73779-3.6973-0.73779-2.4494,0.93687-2.0904,1.1922-2.0904,1.1922,1.0697,2.5113,3.9096,2.2352,4.9702,1.7484z'/%3E %3Cpath d='m456.32,288.83c-1.1871-3.5311,2.3872-8.2023,2.3872-8.2023,0.75119,2.193,1.163,3.9175,1.163,3.9175,2.8411-2.8861,5.3612-3.3308,5.3612-3.3308-0.0581,1.3466-0.0971,2.2289-0.0971,2.2289,1.8975-0.18363,2.6934-0.61209,2.6934-0.61209-0.40746,2.8306-3.9788,5.6926-3.9788,5.6926-1.3466,0.85696-2.9994,0.5509-2.9994,0.5509-2.5862,0.73452-3.1906,2.4943-3.1906,2.4943-0.25249-1.5303-0.43158-0.0401-1.339-2.7391z'/%3E %3Cpath d='m461.53,300.64c1.6015-2.1208,4.1552-1.2119,4.1552-1.2119,2.2939,0.17312,4.2417-2.2074,4.2417-2.2074,1.0388-1.688,1.688-2.0775,1.688-2.0775-0.0866-0.56268-0.64923-0.47612-0.64923-0.47612-1.385,0.30298-1.385,0.34626-1.385,0.34626,1.0388-3.8521,0.47612-4.0253,0.47612-4.0253-0.34626,0-0.56268,0.25969-0.56268,0.25969-0.60596,1.7746-3.073,1.688-3.073,1.688-0.12985-2.5537-0.69252-2.2074-0.69252-2.2074-0.38954,0.64923-1.2119,1.0388-1.2119,1.0388-2.4238,2.4238-2.4238,3.4626-2.4238,3.4626,0.12985,2.8566-0.56268,5.4104-0.56268,5.4104z'/%3E %3C/g%3E %3Cg fill='%2300863d'%3E %3Cpath d='m461.07,314.65c0.32184-0.36856,1.0509-0.92475,1.6092-1.2397,0.55831-0.32166,0.38094-0.18764,0.65024-0.79746,0.24959-0.57629,0.17734-0.44896,0.57799-0.84434l-0.35469,1.0789c0.56488-0.32165,0.77506-0.50258,1.5698-0.93148,0.0657,0.31496-0.51889,0.59642-0.99836,0.91135-0.42693,0.28816-0.79474,0.52941-1.2414,0.79746l-2.1675,1.8361c2.0493-0.47579,1.6814-0.13402,2.7061-0.30155,2.1938-0.36186,3.2316-3.4645,3.9739-5.274-1.5041,0.28145-3.0608,0.61651-4.1641,1.3604-1.4122,0.95158-1.3071,1.816-2.1609,3.4042z'/%3E %3Cpath d='m455.47,322.47c-0.13136-0.33507-0.51233-0.89126-0.72251-1.2598-0.58456-1.0454-0.65023-1.3536-1.4122-2.5464-0.48603-0.77063-0.3087-0.36856-0.62398-1.2263,0.289,0.0201,0.68966,0.89126,1.0181,1.2464l-0.007-1.2665c0.34812,0.0268,0.24959,0.33506,0.2693,0.71701,0.0657,1.2397-0.0525,1.0253,0.70937,2.3856l1.5435,2.5398c-0.0919-0.40208-0.28899-0.75724-0.40067-1.1727-0.45321-1.6552,0.58457-3.6253-3.5074-6.058l-1.0115-0.61651c0.0722,2.0104,0.29557,5.3275,2.1412,6.366,0.32184,0.18094,0.69622,0.26135,1.0443,0.40208,0.37438,0.16083,0.63711,0.34176,0.95895,0.48919z'/%3E %3Cpath d='m454.52,297.3c-0.1512-0.51424-0.39062-0.9706-0.54812-1.5491-0.14491-0.52066-0.063-0.39852-0.42844-0.65566l-0.47883-0.58493,0.60482,0.30854c-0.1071-0.33425-0.30871-0.68778-0.48513-0.94491-0.37803-0.53995-0.20791-0.17998-0.59853-0.88061,0.69933-0.0771,1.4365,1.9991,1.594,2.539,0.47883,1.6005,0.45991,1.4077,1.405,2.6933-0.006-0.21855-0.34652-0.61065-0.43473-0.93848-0.25202-0.88061,0.69933-2.0762-0.23941-3.9595-0.56072-1.1313-1.72-1.3177-2.287-2.2691l-0.49772-0.97703c-0.18271,0.34069-0.46621,1.6841-0.49143,2.1276-0.0819,1.382,0.25202,3.1947,1.2096,4.1139,0.34652,0.32782,1.2034,0.79705,1.6759,0.97703z'/%3E %3Cpath d='m459.74,287.33c0.19704-0.14073,0.57799-0.67683,0.91956-0.97167l0.99836-0.83765-0.15107-0.92478c0.19704,0.067,0.11823-0.0871,0.31527,0.6299,0.25616-0.22783,0.85385-1.233,1.1166-1.6351,0.19705,0.27475-0.38751,1.1258-0.56487,1.3938-0.289,0.4624-0.56487,0.79073-0.9918,1.1191l-1.9114,2.3454c0.40068-0.12732,0.69622-0.26804,1.1298-0.35515,1.2414-0.24795,1.7209-0.35516,2.5878-1.7423,0.82103-1.3067,1.0443-2.915,1.3727-4.4226-1.7734,0.71032-3.6454,1.4274-4.565,3.0893-0.34156,0.60982-0.19048,1.1325-0.25616,2.3119z'/%3E %3Cpath d='m448.55,304.1c-0.50576-1.3067-1.8982-2.8413-2.0493-3.5047l-0.20361-1.5547c0.289,0.0402,0.15763-0.0737,0.24302,0.20104,0,0,0.0788,0.87787,0.18391,1.1258l0.63054,1.1325c0.0263-0.75724-0.0985-0.38198,0.19705-1.032,0.30214,0.38869-0.1642,1.0588,0.289,1.816,0.23645,0.39538,0.55831,1.0186,0.85385,1.3604-0.0131-1.0789,0.72907-2.7408-0.4926-4.3155-0.42692-0.5428-0.92612-0.73045-1.4581-1.1794l-1.0246-1.615c-0.8276,1.7557-0.66996,5.3275,0.98523,6.5134,0.31528,0.22784,0.60429,0.30826,0.94582,0.49589,0.17734,0.10051,0.289,0.16083,0.45978,0.26804,0.15764,0.10052,0.27586,0.20104,0.44005,0.28816z'/%3E %3Cpath d='m456.55,297.13c0.71414-0.58738,0.48932-0.82037,2.1516-2.0703,0.41041-0.30773,0.71102-0.65465,1.0665-1.0457,0.50874-0.55767,0.33854-0.44562,1.0168-1.102,0.1689,0.2972-0.92864,1.4353-1.2724,1.8538l0.66668,0.0812c-0.10588,0.39716-0.4788,0.10292-1.0191,0.24966-0.4864,0.12266-1.7717,1.5866-2.1261,1.9576,0.32035-0.0909,0.60998-0.22368,0.99524-0.29785,1.0298-0.20213,1.6734,0.0725,2.7853-1.3467,0.9356-1.1866,1.2687-2.6793,1.7247-4.132-1.4247,0.33621-3.1455,1.0598-3.9417,1.8376-1.1417,1.1022-1.0455,2.0466-1.4775,3.0309-0.17079,0.38041-0.4141,0.63634-0.57006,0.98396z'/%3E %3Cpath d='m450.99,307.87c-0.16421-0.24124-0.72251-0.67013-0.99836-0.87116-0.57144-0.40878-0.64367-0.41548-1.4384-0.47579l-2.3843-1.3201c0.29557-0.15413,0.44665,0.19433,1.0049,0.48918l1.1166,0.48249-0.13793-0.61651c0.21018,0.0134,0.22988,0.0469,0.32184,0.27474l0.0657,0.39538c1.0706,0.0871,0.89983,0.10722,1.9639,0.78403-0.11822-0.48248-0.1839-0.45569-0.48603-0.69692-0.26273-0.20774-0.32185-0.36855-0.53202-0.65673-0.33496-0.46239,0.0394,0.21444-0.53202-0.65-0.92612-1.3938-1.9442-0.78403-2.601-0.95158l-1.7012-0.69692c0.28899,1.6418,1.156,2.8681,2.0033,3.6588,0.44665,0.41547,0.96551,0.89126,1.7865,1.032,0.25616,0.0402,2.22-0.12062,2.5485-0.18093z'/%3E %3Cpath d='m450.03,316.77c-0.33496-0.32836-0.70938-0.60311-1.11-0.89795-0.28901-0.20774-0.43349-0.18094-0.8276-0.22114l-0.76849-0.26135,0.86702-0.0335c-0.0985-0.067-0.27587-0.22783-0.40067-0.32835-0.61086-0.48919-0.72907-0.48249-1.1232-1.0722,0.17078-0.16083,0.28243,0.0402,0.51889,0.22114,0.70278,0.5495,2.069,1.6485,2.7521,2.1176l1.2742,0.70361c-0.0591-0.68352-1.2217-2.8815-2.1806-3.3037l-4.2562-1.166c0.21675,0.71702,1.2742,2.7006,1.7143,3.297,1.2414,1.6887,1.3727,1.1258,2.2726,0.99176,0.45978-0.067,0.81447-0.0335,1.2676-0.0469z'/%3E %3Cpath d='m452.07,307.18-1.6116-5.3332c0.29266,0.0967,0.25293,0.45359,0.42558,1.0509l0.42753,1.1044c0.21335-0.46367-0.0877-0.0639,0.37244-0.79126,0.2056,0.234-0.0326,0.73878-0.12041,1.037-0.16378,0.56246-0.15156,0.35416,0.0729,0.92944l0.76105,1.9709c0.0366-0.44387-0.005-0.68379,0.0772-1.1427,0.24276-1.2895,0.44695-2.0076-0.16673-3.3533-0.53544-1.181-1.4276-2.0474-2.2561-2.9698-0.12333,0.22572-0.37686,1.7637-0.42924,2.1344-0.20049,1.3685-0.087,3.2419,1.003,4.1279,0.86015,0.70664,0.36024,0.14797,1.4444,1.2355z'/%3E %3Cpath d='m455.25,314.08c0.0328-0.5495-0.0591-3.0893-0.0394-4.2418,0-0.24795,0.0131-0.48919,0.0131-0.73715,0.007-0.38868-0.0328-0.26134,0.17734-0.5495,0.0943,0.13537,0.10886,0.28932,0.1051,0.48248l-0.0263,1.749,0.50576-0.85774c0.32184,0.12062,0.046,0.44227-0.0985,0.74384-0.11822,0.23455-0.38094,0.67683-0.42036,0.89796l0.0854,2.5062c0.0131-0.0201,0.0328-0.067,0.0394-0.0536,0.0263,0.0402,0.27587-0.65004,0.42693-0.89796,0.51889-0.88457,1.1231-2.1511,0.87358-3.2836l-1.399-4.0275c-0.29557,0.49588-0.65684,1.3268-0.89984,1.8696-0.289,0.65-0.52545,1.4341-0.63711,2.2181-0.26272,1.8763,0.24303,2.2583,0.82104,3.23,0.17734,0.30155,0.3087,0.62321,0.47291,0.95157z'/%3E %3Cpath d='m457.5,290.17c0.0197-0.47579,0.21675-2.9351,0.15764-3.1429-0.0197-0.067-0.16421-0.34846-0.20361-0.46909l-0.22989-0.98507c0.34813,0.0402,0.20361,0.25465,0.40067,0.61651l0.13136,0.18764c0.0197-0.24125,0.0394-0.48919,0.0591-0.72371,0.0394-0.48919-0.0328-0.24795,0.17734-0.72372,0.19704,0.11392,0.0854-0.0804,0.13793,0.22114,0.007,0.0402-0.0197,0.32166-0.0263,0.36856-0.17078,1.6418-0.23646,3.4444-0.31528,5.0928,0.15764-0.26804,0.21675-0.69692,0.38751-1.0186,0.42693-0.83765,1.1626-2.2784,1.0903-3.2568l-0.92612-4.8182c-0.33496,0.50928-0.6634,1.3134-0.94582,1.8965-0.63054,1.2866-1.2085,3.2434-0.82103,4.7043l0.82103,1.9032c0.0591,0.10721,0.046,0.0804,0.10509,0.14742z'/%3E %3Cpath d='m444.63,317.91c0.289,0.35516,0.88014,0.87117,1.2939,1.1861,0.80787,0.60311,2.6929,1.4005,3.6387,1.3402l2.1609-0.39538-0.33496-1.0052c-0.40068,0.0134-0.70938,0.18093-1.1691,0.18763-0.45322,0.0134-0.89983-0.0335-1.3268-0.0938-0.42036-0.0603-0.83416-0.12733-1.2283-0.21444-0.72907-0.15413-0.47291-0.0402-1.0312-0.42887l2.2726,0.33506c-0.59112-0.45569-0.38094-0.22114-0.81447-0.81755,0.32841-0.0335,1.0049,0.61651,1.294,0.81755l1.9442-0.0938-0.15107-1.1459c-0.9721-0.40208-2.3383-0.38198-3.3366-0.0335-2.0164,0.69022-1.3005,0.5294-3.2118,0.36185z'/%3E %3Cpath d='m447.19,322.95c0.11823,0.37525,2.1609,2.714,2.647,2.8748l4.4796,0.18764c-0.5583-0.30826-1.3465-0.62991-1.977-0.88457-0.86041-0.34846-0.91296-0.16753-2.3054-0.0201,0.0723-0.30826,0.33497-0.24795,1.0838-0.42217-0.31527-0.16753-1.6749-0.5495-1.6946-0.5629l-0.19704-0.21444c0.0919-0.0938,0.0263-0.10722,0.22988-0.0871,0.0657,0.007,0.25616,0.0804,0.34813,0.10722,2.069,0.67682,2.6601,0.94487,4.6239,1.7557-0.63055-0.48249-0.78162-0.65001-1.2611-1.2665-1.7997-2.2851-3.6912-1.5413-5.9769-1.4676z'/%3E %3Cpath d='m462.76,297.96,0.68591-1.2526c0.33687-0.70985-0.19813-0.73138,0.0421-1.6828,0.24265,0.0764,0.16864,0.0549,0.294,0.8722l0.82964-1.9014c0.23766,0.64116-1.0735,3.0748-1.3532,3.6661l-0.444,1.2283c1.0722-1.1934,2.3815-1.7523,2.5922-2.7486l0.15749-4.8021c-0.77047,0.63393-1.815,1.6641-2.3397,2.5085-0.7786,1.246-0.70848,2.3898-0.46454,4.1122z'/%3E %3Cpath d='m460.69,326.32c0.3941-0.17423,0.68965-0.40877,1.1429-0.58972,1.7668-0.48918,1.064,0.35516,2.1872-1.2062l-0.29557,0.83095c0.80131-0.26805,1.0115-0.76394,1.6026-1.3537,0.15107,0.29485-0.3087,0.79076-0.54515,1.0186-0.9918,0.97837-1.9967,0.66343-2.5813,0.89127l-1.1626,0.57629c1.3333-0.20774,1.1823,0.0335,2.2857,0.20103,2.2463,0.34176,2.8834-1.9032,3.6454-3.23l0.53201-0.93818c-1.2742,0.13402-2.8178,0.91136-3.8031,1.4608-0.7422,0.40878-0.98524,0.62991-1.5107,1.1191-0.20362,0.18763-0.44665,0.44226-0.68965,0.61651-0.33497,0.24794-0.59113,0.31495-0.80791,0.60311z'/%3E %3Cpath d='m460.53,314.42c0.78818-0.75054,0.61742-2.5062,1.202-3.565,0.11166-0.20104,0.19705-0.30825,0.32841-0.46909,0.21675-0.27475,0.13793-0.22114,0.42036-0.21444,0.092,0.20774-0.33496,0.42887-0.49919,0.80416l-0.35469,1.1325c0.0722-0.0536,0.046-0.0335,0.11822-0.10722,0.0591-0.067,0.0788-0.0938,0.11823-0.15412,0.55174-0.78403,1.0509-0.97837,1.8456-1.481l-0.76189-2.8346-1.3925,1.2062c-0.36782,0.32165-0.88671,0.93818-1.1823,1.4542-0.99179,1.749,0.0854,2.5732,0.15764,4.2284z'/%3E %3Cpath d='m460.12,326.06,1.8408-3.0163,0-1.4157c0.2789,0.0427,0.18129-0.10671,0.36259,0.83945,0.62057-0.91058,0.18826-0.80388,0.8925-1.2592,0.0488,0.27032-0.71818,1.6575-0.81581,1.7998-0.78094,1.0956-1.1575,1.7856-1.8338,2.9452,0.43929-0.17785,1.039-0.81812,1.3527-1.1098,0.26496-0.24186,0.41139-0.36992,0.69729-0.55489,0.26496-0.17073,0.54387-0.29878,0.79488-0.46239l0.78094-4.3182c-0.70425,0.29879-2.6008,1.6291-3.1517,2.3263-1.1505,1.4655-1.2133,1.9136-0.9204,4.2257z'/%3E %3Cpath d='m464.25,315.48,2.3974-0.22114c-0.0722,0.31496-0.4138,0.32166-1.0903,0.42217-1.0772,0.16754-3.0739,0.14743-4.2298,0.16754,0.33497,0.18763,0.66997,0.30155,1.0115,0.50258,0.34813,0.20773,0.59769,0.37525,0.95238,0.55619,0.75533,0.38868,1.6683,0.35516,2.4762,0.0469l3.1396-2.9217c-1.6486,0.38198-0.7422,0.44226-2.9688-0.007-0.34156,0.29485-0.4926,0.65673-1.2085,1.1392-0.1445,0.10052-0.34813,0.19434-0.47947,0.31496z'/%3E %3Cpath d='m447.21,309.68c0.67716,1.39,2.6569,3.0539,4.4394,2.835,0.79424-0.10153,0.93885-0.35331,1.4153-0.81956-0.10374-0.12129,0.0229-0.0241-0.13234-0.10467-0.0561-0.0274-0.14563-0.0523-0.20427-0.0598-1.3629-0.26811-1.5289-0.16088-2.9191-0.007l0.63067-0.32502c-0.36547-0.0938-0.72609-0.17351-1.0842-0.27315-0.56889-0.16025-0.4924-0.137-0.92934-0.44933,0.15884-0.15542,0.12118-0.11968,0.40194-0.0367,1.8194,0.58293,2.2475,0.5496,4.2281,0.8558-0.18868-0.59823-1.749-1.3441-2.5887-1.4577-1.3227-0.16841-1.7798,0.50971-3.2574-0.15804z'/%3E %3Cpath d='m458.96,325.63-0.60428-3.8734c0.31527,0.0871,0.22332,0.20774,0.37438,1.0186l0.68965,3.5114c0.0591-1.3335,0.51233-2.2851,0.11166-3.6588l-1.3793-2.647c-0.25616,0.6299-0.44005,2.4124-0.38751,3.163,0.0854,1.1794,0.32841,1.5346,0.94582,2.2449,0.11823,0.13402,0.11166,0.14072,0.24959,0.24124z'/%3E %3Cpath d='m464.21,286.08c0.19704-0.12062,0.35468-0.32836,0.53201-0.5495l0.57144-0.44227c0.0131,0.32836-0.45978,0.71032-0.77505,1.1057-0.45322,0.57629-0.73564,0.67013-0.95895,0.94488-0.88671,1.1191-0.79474,0.93148-2.2003,1.548,2.89,0.17423,4.4531-2.8748,5.6946-4.9521-2.7324,0.38868-2.2332,0.57629-2.4959,1.3604-0.11823,0.34176-0.28243,0.66343-0.36782,0.98507z'/%3E %3Cpath d='m465.15,298.29,0.78764-1.305c0.47418-0.6917,0.78108-0.20964,1.53-0.94183-0.20069-0.18287-0.14115-0.12612-0.96246,0.19675l1.3091-1.7857c-0.71906,0.12476-2.2609,2.6403-2.6565,3.2156l-0.89501,1.0687c0.52575-1.6296,0.33885-3.1375,1.145-3.8664l4.346-2.722c-0.17145,1.051-0.56138,2.5674-1.059,3.5047-0.73175,1.3869-1.8247,1.936-3.5449,2.6351z'/%3E %3Cpath d='m454.31,303.42c-0.23646-0.71701-1.1034-1.4608-1.248-1.8562l-0.62398-2.5197c0.34812,0.0402,0.34812,0.71032,0.4138,1.0052l0.33496,1.0789c0.21018-0.77063-0.13793-0.22784,0.34156-0.97167,0.23646,0.46909-0.28243,1.2531,0.0394,1.6887,0.32184,0.44227,0.34812,0.38199,0.85385,1.1392,0.289-1.1593,0.33497-2.6336-0.36782-3.431l-2.0164-2.2114c-0.51233,0.74384-0.46635,2.848-0.10509,3.9136,0.41379,1.1928,0.87357,1.3268,1.6289,1.7289,0.29557,0.15413,0.46634,0.30826,0.74876,0.43557z'/%3E %3Cpath d='m456.06,303.14c0.5141-0.67552,1.7082-1.1485,2.0067-1.5158l1.5866-2.4496c-0.38476-0.0848-0.63031,0.6275-0.80817,0.91685l-0.75141,1.0241c0.059-0.89618,0.2301-0.19164-0.007-1.158-0.42324,0.41196-0.15898,1.4355-0.66071,1.7806-0.50419,0.35218-0.51002,0.27846-1.3251,0.89803,0.11763-1.3382,0.60898-2.9221,1.6483-3.5124l2.9538-1.6117c0.272,0.9784-0.54793,3.1982-1.3224,4.1983-0.87697,1.1163-1.4148,1.0903-2.365,1.2409-0.37067,0.0555-0.60868,0.15678-0.95553,0.18862z'/%3E %3Cpath d='m461.37,303.44c0.78818-0.0402,2.936-0.0737,3.5928-0.42217l0.9064-0.42217c0,0.24125,0,0.11392-0.34156,0.46239,0.86702-0.0402,0.48604-0.10051,1.3202,0.0469-0.0985,0.17423,0.17077,0.14743-0.68966,0.20104-0.9655,0.067-1.4778,0.16753-2.3448,0.26135l-3.2053,0.32165c2.0493,0.74384,2.3843,1.8763,4.703,1.0119,1.8456-0.69023,2.2135-1.4408,3.3825-2.848-2.8834,0.67013-3.1921-1.7691-6.0164,0.0938-0.34156,0.22784-1.1034,0.99846-1.3071,1.2933z'/%3E %3Cpath d='m465.21,305.21c0.75532,0.0938,0.44005-0.0134,1.0706,0.28145-0.29557,0.25465-1.5501-0.0603-2.0493,0.0402l-2.069-0.0402c0.6634,0.91805,1.7734,1.3604,3.3432,1.1995,1.5435-0.16753,1.9442-0.56289,3.1856-1.3201l-2.3448-0.77063z'/%3E %3Cpath d='m464.35,318.67c-0.19704-0.19434-0.70936-0.44898-1.0312-0.56961-1.3071-0.49589-2.3317-0.0268-2.9952-0.0402l-1.491-0.17424c0.39409,0.43558,1.9967,1.032,2.7783,1.1593,2.0098,0.32837,0.65682,0.85776,2.739-0.37526z'/%3E %3Cpath d='m464.56,320.15,0.5977,0.5361c-0.15764,0.0804-0.37438-0.067-0.62397-0.18764l-0.11167,1.3603,2.7258-0.34176c-0.86044-1.0856-1.4122-1.6084-2.4368-2.5598-0.0788,0.42218-0.19704,0.73044-0.15106,1.1928z'/%3E %3Cpath d='m461.06,320.92,1.6289-1.233c-0.4138-0.32166-1.1691-0.30826-1.7406-0.48248l-1.5698-0.62992c0.37439,0.52269,0.38752,0.40208,0.83416,1.1727,0.24959,0.42887,0.4335,0.88455,0.84729,1.1727z'/%3E %3Cpath d='m468.95,296.79c-0.70787,0.41387-1.206,1.058-1.9973,1.3891-1.0686,0.43326-2.2098,0.005-2.8833,0.69183,1.8033-0.10364,2.9913,0.58413,4.3888-0.70566,0.85861-0.79106,1.6086-2.0125,2.3107-3.0233-0.28383-0.0183-1.2157,0.26667-1.4028,0.4579-0.0999,0.0993-0.23421,0.41524-0.33744,0.57515-0.321,0.51387-0.10467,0.13314-0.0788,0.61494z'/%3E %3Cpath d='m463,337.81,1.3136,2.6671,1.8128,2.2181c0.37438-0.17423,0.79474-0.47578,1.2217-0.69022l1.4581-0.51601c-0.81447-0.34846-0.85386-0.75054-1.3136-0.78403-1.1232-0.0737-0.46634,0.10722-1.9573-0.14742,0.13793-0.24125,0.0723-0.12732,0.84729-0.14073l0.94581-0.0268c-0.55174-0.50928-1.2348-0.86447-1.8522-1.3134l1.9442,0.99176-0.0591-1.2933c0.47291,0.0536,0.18391,0.78406,0.40067,1.5011,0.1051,0.32836,0.72908,0.74383,1.064,0.91135,0.64367,0.32166,0.88014,0.24794,1.5435,0.41547l1.5238,0.48249c-0.62398-0.88456-0.34156,0.11392-1.399-2.0707-0.42693-0.88456-0.8276-1.4207-1.5501-1.8696-1.7603-1.0923-3.9277-0.36185-5.9441-0.33506z'/%3E %3Cpath d='m465.21,335.19c0.0197-1.0722-0.0591-2.0506,0.0263-3.1429,0.0394-0.50928-0.19704-1.8227-0.28243-2.5732,0.24959,0.0737,0.21019,0.18764,0.2693,0.50258l0.19705,0.69692c0.24959-1.1258,0.3087-1.0923,0.91956-1.9032,0.0985,0.26135-0.60429,1.1392-0.72907,2.4191l-0.1248,3.1831c0.1248-0.14742,0.13793-0.20103,0.28243-0.36186,0.11166-0.12732,0.19705-0.21443,0.31527-0.34176,0.22332-0.22783,0.38095-0.44896,0.59769-0.78403,1.5238-2.3722,0.5977-3.7257,0.62398-4.4293l0.44006-2.2985c-0.47291,0.19433-1.7734,1.1392-2.069,1.4408-1.1757,1.1928-2.3383,3.2903-1.6026,5.0861,0.17077,0.42217,0.40723,0.77733,0.59112,1.1861,0.18392,0.41548,0.32841,0.95828,0.54515,1.3201z'/%3E %3Cpath d='m464.4,344.3c0.25616,0.16083,1.7274,0.63661,2.1084,0.75054,1.399,0.43557,3.5928,0.59642,4.565-0.70362,0.53201-0.71701,0.85385-0.90466,1.5238-1.4408-1.0378,0.0201-1.7537,0.41547-2.6601,0.62321-0.67652,0.15413-0.72251,0.62991-1.2742,1.1526l-0.51233,0.35516c0.007-0.33506,0.65024-0.96497,0.95238-1.3201l-2.0361-0.0201c0.0657-0.32836,0.61085-0.16753,1.5107-0.24794,1.7603-0.14743,2.0558-0.61651,3.9672-0.84434,0.1839-0.0201,0.21674-0.0268,0.37438-0.10722-2.8506-0.0134-3.4746-1.93-6.8902,0.49588z'/%3E %3Cpath d='m477.44,342.54,0-1.4274c-0.62398-0.47579-0.62398-0.62991-1.0049-1.3604,0.33497,0.0268,0.47291,0.56289,0.98524,0.92478-0.0525-0.68352-0.33497-1.8294-0.4926-2.5598,0.32841,0.0536,0.48603,0.96497,0.56487,1.2933,0.40067,1.6686,0.0525,2.9552,0.34812,3.4913l0.81447,1.099c0.27586-1.1593,1.4713-1.9098,0.046-4.7646-0.86702-1.7423-1.5698-2.0372-3.0279-3.1362,0.17734,0.79746,0.37438,1.0789,0.24959,2.0573-0.0919,0.68353-0.36125,1.1995-0.44005,1.8696-0.18391,1.5413,0.289,1.4542,0.59113,1.6284,0.51232,0.28814,0.98523,0.59641,1.3662,0.88456z'/%3E %3Cpath d='m463.33,339.83-0.43349-0.95828c-1.202,0.0201-1.5567,0.50928-3.2316-0.61651-0.44005-0.29485-0.36781-0.26135-0.61085-0.72371l1.8522,1.0387c-0.0985-0.20774-0.32185-0.42217-0.68966-1.1794,0.0591-0.0402-0.0394-0.12732,0.17077-0.007,0.0854,0.0469,0.11823,0.11391,0.15764,0.16752l0.89984,1.1928,1.2348-0.13403c-0.0263-0.20773-0.23646-0.5562-0.32841-0.77063-0.17734-0.41547-0.092-0.48249-0.40724-0.71032-0.4138-0.30155-0.92612-0.59641-1.5567-0.65673-0.77505-0.0737-1.2348,0.19434-1.9376,0.24795l-1.8916-0.39538c0.0854,0.36855,0.79474,1.548,0.9918,1.8294,0.8013,1.1258,2.9228,2.7676,4.7224,2.064,0.26273-0.10052,0.83416-0.26805,1.0575-0.38868z'/%3E %3Cpath d='m453.48,331.06,0.0985,0.0536c0.0919,0.0469,0.0591,0.0335,0.1445,0.067,0.53858,0.22114,1.0115,0.46909,1.3925,0.90465,0.48603,0.5495,0.51888,0.81755,1.2611,1.4341,1.1954,0.99849,2.4894,0.96497,4.0854,1.1727-0.1445-0.22114-0.53858-0.67682-0.72907-0.87116-1.2742-1.3604-1.0443-1.2866-1.8588-1.1727l-1.3334,0.10722c0.0591-0.27475,0.86042-0.32836,1.445-0.4557-0.29556-0.12732-0.53201-0.21444-0.86041-0.27475-0.66997-0.12062-0.19705,0.0536-0.96551-0.23454,0.34812-0.46909,2.069,0.14743,2.8637,0.89126,0.59113,0.54281,1.3268,1.4139,1.8916,2.0774l-0.92613-1.997c-0.94581-1.7222-3.4484-2.3387-5.2874-2.0104-0.29557,0.0469-0.96551,0.15413-1.2217,0.30826z'/%3E %3Cpath d='m464.61,335.62c-0.6634-2.1042-1.7471-2.9954-2.0427-4.2753-0.19705-0.87117-0.1248-0.95158,0.0328-1.7423,0.42692,0.58299-0.36126,0.98507,0.8867,3.0759-0.0722-0.67683-0.24302-0.97837-0.12479-1.7959,0.0525-0.32836,0.45321-1.5815,0.44665-1.615-0.0591-0.34176-1.5698-1.7289-1.9836-2.1645-0.21675,1.8562-0.69622,3.5114-0.092,5.361,0.62398,1.9166,1.6486,1.4676,2.8769,3.1563z'/%3E %3Cpath d='m474.66,345.09,1.3268-0.35516c-0.19704-0.16083-0.66339-0.76393-0.86041-1.0588-0.578-0.84434-0.51233-0.91805-0.28244-1.3402,0.0722,0.12732,0.0197,0.0134,0.0525,0.17423,0.0328,0.22784-0.0197,0.29485,0.1445,0.58299,0.1248,0.21444,0.21675,0.34176,0.38095,0.5495,0.32841,0.43556,0.54514,0.69022,0.95238,1.0052-0.0263-0.66343-0.15108-0.98507,0.0328-1.3804,0.24959,0.0938,0.0854-0.0737,0.17734,0.18094l0.0788,1.1392,1.4713-0.38868c-0.9918-1.749-2.8966-2.3789-4.637-3.0692,0.15764,0.67683,0.31528,1.3804,0.47948,2.0573,0.18391,0.78403,0.40067,1.233,0.68309,1.9032z'/%3E %3Cpath d='m472.33,341.31c-0.15763-0.39538-0.44005-0.81755-0.65683-1.2732-0.47291-1.0253-0.40067-1.4944-1.353-2.4794-0.16421-0.16753-0.29557-0.33507-0.4926-0.48919-0.0985-0.0737-0.35469-0.22783-0.39411-0.32835-0.007-0.007-0.0131-0.0268-0.0131-0.0402l0.0131-0.14072c0.32841-0.067,0.98523,0.69022,1.1888,0.89126,0.57144,0.5495,1.8851,3.3305,2.3252,4.1882-0.0591-0.38199-0.25616-0.83765-0.1248-1.2062,0.38094-1.099-0.67653-2.7944-1.1954-3.1429l-4.1182-1.8227c0.4926,0.46909,0.78161,0.73714,1.1231,1.4944,0.2693,0.60312,0.39411,0.0804,1.4647,1.2263,1.1363,1.1995,1.0444,2.6939,2.2332,3.1228z'/%3E %3Cpath d='m479.89,341.3c0.0722-0.19433,0.1445-0.39538,0.21675-0.60981,0.13136-0.37529,0.0263-0.22114,0.34153-0.52941,0.15764,0.24795,0,0.38199-0.17077,0.90466-0.33497,0.9985-0.55174,1.8361-0.83416,2.8547,0.91299-0.12062,0.87358-0.14073,1.2611-0.82425,0.23645-0.41547,0.42036-0.99846,0.51232-1.5346l-0.11166-3.8734-1.1888,1.548c-0.61741,0.89126-0.22989,0.40877-0.0263,2.064z'/%3E %3Cpath d='m467.51,332.51c0.29557-0.16753,0.98524-0.99846,1.2808-1.3268,0.17078,0.31496-0.62398,1.1392-0.79474,1.3134-0.66996,0.63661-0.24959,0-1.1232,1.0454,1.7668,0.26135,2.4959-2.0707,3.0674-3.2635-0.34813,0.0201-1.4713,0.38869-1.7471,0.5562-0.23646,0.13402-0.16421,0.067-0.22989,0.36856-0.046,0.18763-0.0591,0.27475-0.1248,0.46909-0.092,0.28814-0.21675,0.56289-0.32841,0.83764z'/%3E %3C/g%3E %3Cg fill='%23ce1126' stroke='%23000'%3E %3Cpath stroke-width='0.2662' d='m483.96,354.64,2.2214,1.1526-1.2645,2.4922c0.92274-0.15578,4.272-1.3084,5.3657-1.6511-0.2734-0.77884-0.37592-0.87231-0.2734-1.838l-0.37593-1.7757-2.6999,0.90341c-1.0253,0.31153-1.8797,0.52961-2.9733,0.71652z'/%3E %3Cpath stroke-width='0.2662' d='m513.11,354.25-2.2214,1.1526,1.2645,2.4922c-0.92274-0.15578-4.272-1.3084-5.3657-1.6511,0.2734-0.77884,0.37592-0.87231,0.2734-1.838l0.37593-1.7757,2.6999,0.90342c1.0253,0.31152,1.8797,0.5296,2.9733,0.71651z'/%3E %3Cpath stroke-width='0.271' d='m492.02,358.17c2.4991-0.35282,4.7338-1.6759,4.7338-1.6759,0.38222,0.41162,2.3815,0.1176,2.3815,0.1176,0.91146-0.17641,1.3231-0.32342,1.3231-0.32342,2.4991,1.5877,4.4103,1.8229,4.4103,1.8229,2.2051-0.11761,2.2639-1.8229,2.2639-1.8229-0.0882-1.4995-0.23522-1.5583-0.23522-1.5583,1.1761-1.8523-0.0882-3.3224-0.0882-3.3224-0.58805-0.67622-3.9987,0.41162-3.9987,0.41162-2.2933,1.0878-2.4404,0.61742-2.4404,0.61742-0.65081-1.0204-3.0453-0.83992-4.0868-0.0588-2.5285-0.55864-2.8814-0.73503-2.8814-0.73503-2.558-0.97027-2.9696-0.38222-2.9696-0.38222-0.91145,1.0879-0.61741,2.2345-0.61741,2.2345,0,0.64682,0.20579,1.2055,0.20579,1.2055-0.55861,3.293,1.9993,3.4695,1.9993,3.4695z'/%3E %3Cpath stroke-width='0.2153' d='m500.45,355.39c5.4983,1.2366,5.1088,2.021,5.1088,2.021-0.33377,0.57502-1.9475-0.16399-1.9475-0.16399-4.29-1.5018-3.1613-1.857-3.1613-1.857z'/%3E %3Cpath stroke-width='0.2153' d='m497.04,355.41c-5.4983,1.2366-5.1088,2.021-5.1088,2.021,0.33376,0.57502,1.9475-0.16399,1.9475-0.16399,4.29-1.5018,3.1613-1.857,3.1613-1.857z'/%3E %3Cpath fill='%23aa241e' stroke-width='0.2008' d='m497.27,351.68c-2.3624,0.41973-0.49736,2.1826-0.41447,3.2738,0,0.58761-0.58021,1.595,0.0414,1.8468,0.58025,0.25184,1.8236-0.042,2.4867-0.042,0.9118-0.042,1.5335,0.042,1.4092-1.1333-0.0829-0.88142-0.37301-1.1752-0.37301-2.3085-0.0414-0.79745,0.12432-1.6789-0.74601-1.7628-0.53879-0.042-1.865,0.042-2.4038,0.12593z'/%3E %3Cpath fill='none' stroke-width='0.2167' d='m500.53,352.99c6.2702-0.031,5.8086-1.0336,5.8086-1.0336'/%3E %3Cpath fill='none' stroke-width='0.2167' d='m500.64,354.9c6.2079,0.83282,5.3701,1.7375,5.3701,1.7375'/%3E %3Cpath fill='none' stroke-width='0.2106' d='m496.75,354.72c-5.7825,1.2847-5.2624,2.2019-5.2624,2.2019'/%3E %3Cpath fill='none' stroke-width='0.2106' d='m496.11,352.86c-5.9079,0.42803-5.3141-0.57567-5.3141-0.57567'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23000' d='m473.93,345.8c-3.1233,1.0261-5.1969,1.7416-8.1833,3.492-1.1394-1.7118-2.6932-4.2452-3.7981-5.7174-0.6215-0.78741-1.4847-1.6433-2.5551-2.191-1.6919-0.78741-2.3134-0.54776-3.3838,0.37659l-0.75961-1.4378c-1.5193-2.6703-3.1075-3.9029-4.7994-6.0596l-1.5193-1.7802c-0.20717-0.23965-0.27622-0.41082-0.55244-0.54776,0.65455,2.1483,1.1284,4.2027,1.5538,6.5389-0.93225-0.51353-1.7954-1.027-2.7623-1.4379-0.72509-0.27387-2.5896-0.68469-3.4873-0.58198l1.1049,0.9928c1.8991,1.6775,3.1421,3.9029,3.9016,6.4019,0.82867,2.7046,2.7623,5.5804,4.7994,7.566,0.41434,0.41082,1.5883,1.4721,2.3479,1.746,2.2789,0.82163,2.1753-0.0342,3.004-0.44505,1.7528,2.9686,2.8824,4.4562,4.903,6.71,2.1753,2.2937,5.5934,2.91,8.7013,2.191,1.3811-0.34236,2.2443-0.71892,3.3147-1.3352,4.0399-2.328,2.1062-4.1423,1.6228-5.991,1.3121-0.41082,6.4501-1.9651,8.2974-2.307,6.506-1.204,18.564-1.3626,26.276-0.23964,0.69089,0.1006,8.4669,2.1712,9.2264,2.6162-0.54825,1.2883-0.76596,1.9277-0.68785,3.3426,0.13166,1.3111,1.2566,1.9969,2.258,2.5788,1.0704,0.61624,1.9336,0.9928,3.3147,1.3352,1.3466,0.30811,2.7968,0.37659,4.1778,0.17117,2.9004-0.47931,4.4196-2.1568,5.6628-3.6631,2.0663-2.3573,2.7078-3.7865,3.7636-5.4434,0,0,0.58842,0.54775,1.0073,0.68443,0.39491,0.12884,1.6859-0.10243,2.0312-0.23938,1.0013-0.37659,1.6228-1.1297,2.3134-1.7802,2.1408-2.0541,3.9364-4.7244,4.7994-7.6343,1.0358-3.4236,2.4515-5.0325,4.9722-7.2579-3.2564,0.11082-4.3815,0.99673-6.2152,2.0199l0.69055-3.355c0.20717-0.92435,0.72509-2.2937,0.82867-3.1838-1.4811,1.5773-2.7963,3.2273-4.1089,4.6902-0.6215,0.82163-1.3121,1.5063-1.9336,2.3964-1.3064,2.0152-1.0571,2.0774-1.5538,2.7388-4.5837-2.546-6.6427,3.6564-9.7371,7.4632-5.745-3.2298-10.748-4.2425-17.506-5.4776-1.5144-0.1592-2.8658-0.37659-4.1088-0.51353-8.494-0.9928-17.851-0.95857-26.311,0.30812-4.3675,0.55322-7.0688,1.355-10.91,2.2596z'/%3E %3Cg fill='%23ce1126'%3E %3Cpath d='m468.02,359.01c0.52703-1.5062,1.1845-1.8325,2.4861-2.4649,4.1778-1.9172,6.2495-2.7046,11.014-3.9712,2.5896-0.6847,5.6628-1.2667,8.3905-1.5748,1.4585-0.23639,1.8118-0.25227,4.3851-0.41083,3.7981-0.2054,6.008-0.2054,9.8061,0,1.647,0.0173,3.0526,0.19254,4.3851,0.41083,2.8313,0.34237,5.8352,0.85586,8.494,1.5748,4.2817,1.0955,7.1129,2.1226,10.98,3.937,1.761,0.82164,1.5193,0.85587,2.5206,2.4649,1.2775-0.85586,2.2098-2.7046,2.9349-3.937,0.37981-0.65047,0.93229-1.5406,1.174-2.2937,0.41434-1.2667-0.3798-1.6775-0.96678-2.1568-2.1408-1.8487-6.146-3.4578-9.5643-4.4163-14.675-4.074-34.873-4.2452-49.515-0.0342-3.5563,1.0271-7.1819,2.4649-9.5298,4.348-0.31075,0.23964-0.6215,0.51353-0.89772,0.82164-0.82867,0.95857,0.5352,2.8586,0.96681,3.6631,0.43162,0.80452,0.80456,1.5914,1.243,2.191,0.53196,0.72633,1.181,1.3492,1.6934,1.8485z'/%3E %3Cpath d='m453.52,345.94c1.6574,0.30811,2.2443,0.78738,3.3147,2.2253,2.3824,3.2866,2.486,5.6145,6.5259,10.065,0.93223,1.0271,1.6228,1.8487,3.0385,2.4649,1.4847,0.65046,3.0385,0.85587,4.7994,0.61622,1.6574-0.2054,2.9004-0.65045,4.1434-1.3694,0,0,1.4879-0.8558,1.8792-1.3808,0.39132-0.52493,0.46871-1.7689,0.46871-1.7689-1.2085-0.37658-3.3838,1.9857-4.7994,2.91-2.5896,1.7118-3.5909,1.0955-5.4209-0.51352-1.5883-1.3694-2.1753-2.8415-3.2111-4.6217-0.41434-0.71895-1.174-1.8144-0.89777-2.9442l1.9336-1.9856c-0.76386-1.2564-1.7204-2.6541-2.417-3.7317-0.96678-1.4721-1.5193-2.4649-2.7622-3.4235-0.72506-0.582-2.1753-1.4379-3.2111-0.82166-0.86731,0.67869-1.4918,1.477-2.2444,2.3964-0.41434,0.47929-0.89777,1.164-1.1394,1.883z'/%3E %3Cpath d='m450.76,339.63c-0.37981-0.13694-1.7609-1.1982-2.4861-1.5063l-3.0385-1.0271c0.41434,0.51352,0.82869,0.82166,1.6574,1.8487,1.9336,2.4649,1.9336,4.4506,3.4528,7.3947,0.51792,0.9928,1.4157,2.2937,2.1753,3.1839,0.51792,0.65046,2.2677,2.3183,2.7278,2.7045,1.0607,0.88202,2.1723,1.0074,2.7716,0.27609,0.13649-0.51939-1.2523-1.4401-2.0119-1.8167-0.93224-0.51352-1.7609-1.0613-2.417-1.6775-1.7955-1.8145-0.41434-4.0397,0.96678-5.6145l0.93224-1.0955c0.2063-0.74346-1.3022-2.8471-2.1062-3.9028-0.82868-0.99279-2.9349-3.355-3.8672-4.4163,0.13811,0.85587,0.41434,2.0199,0.58698,2.91,0.13811,0.61623,0.6215,2.2595,0.65604,2.7388z'/%3E %3Cpath d='m477.59,356.24-0.72506-1.7118c-1.0013,0.10271-5.9044,2.2595-7.0438,2.9784-0.34528,0.20541-1.7264,1.3009-1.0704,1.9857,1.8991,2.0541,4.7649-0.95859,6.4568-2.2595,0.58698-0.47929,1.3466-1.0271,2.3824-0.99279z'/%3E %3Cpath d='m458.63,352.28c-0.31075-0.1027-0.24169-0.71895-1.3466-1.5405-0.41434-0.34235-2.9132-1.643-3.342-2.122,0,0-0.81755-0.58445-0.72031-1.4251,0.0746-0.64519,0.60951-0.76652,0.60951-0.76652,2.2443,0.0685,4.903,5.5803,4.7994,5.8542z'/%3E %3Cpath d='m545.04,346.04c-1.6574,0.30811-2.2443,0.78738-3.3147,2.2253-2.3824,3.2866-2.486,5.6145-6.5259,10.065-0.93223,1.0271-1.6228,1.8487-3.0385,2.4649-1.4847,0.65046-3.0385,0.85587-4.7994,0.61622-1.6574-0.2054-2.9004-0.65045-4.1434-1.3694,0,0-1.4879-0.8558-1.8792-1.3808-0.39132-0.52493-0.46871-1.7689-0.46871-1.7689,1.2085-0.37658,3.3838,1.9857,4.7994,2.91,2.5896,1.7118,3.5909,1.0955,5.4209-0.51352,1.5883-1.3694,2.1753-2.8415,3.2111-4.6217,0.41434-0.71895,1.174-1.8144,0.89777-2.9442l-1.9336-1.9856c0.76386-1.2564,1.7204-2.6541,2.417-3.7317,0.96678-1.4721,1.5193-2.4649,2.7622-3.4235,0.72506-0.582,2.1753-1.4379,3.2111-0.82166,0.86731,0.67869,1.4918,1.477,2.2444,2.3964,0.41434,0.47929,0.89777,1.164,1.1394,1.883z'/%3E %3Cpath d='m547.81,339.74c0.37981-0.13694,1.7609-1.1982,2.4861-1.5063l3.0385-1.0271c-0.41434,0.51352-0.82869,0.82166-1.6574,1.8487-1.9336,2.4649-1.9336,4.4506-3.4528,7.3947-0.51792,0.9928-1.4157,2.2937-2.1753,3.1839-0.51792,0.65046-2.2677,2.3183-2.7278,2.7045-1.0607,0.88202-2.4374,0.87482-2.7716,0.27609-0.13649-0.51939,1.2523-1.4401,2.0119-1.8167,0.93224-0.51352,1.7609-1.0613,2.417-1.6775,1.7955-1.8145,0.41434-4.0397-0.96678-5.6145l-0.93224-1.0955c0.27983-1.4064,1.3022-2.8471,2.1062-3.9028,0.82868-0.99279,2.9349-3.355,3.8672-4.4163-0.13811,0.85587-0.41434,2.0199-0.58698,2.91-0.22386,0.91247-0.45374,1.8322-0.656,2.7388z'/%3E %3Cpath d='m520.98,356.35,0.72506-1.7118c1.0013,0.10271,5.9044,2.2595,7.0438,2.9784,0.34528,0.20541,1.7264,1.3009,1.0704,1.9857-1.8991,2.0541-4.7649-0.95859-6.4568-2.2595-0.58698-0.47929-1.3466-1.0271-2.3824-0.99279z'/%3E %3Cpath d='m539.94,352.38c0.31075-0.1027,0.24169-0.71895,1.3466-1.5405,0.41434-0.34235,2.9132-1.643,3.342-2.122,0,0,0.81755-0.58445,0.72031-1.4251-0.0746-0.64519-0.60951-0.76652-0.60951-0.76652-2.2443,0.0685-4.903,5.5803-4.7994,5.8542z'/%3E %3C/g%3E %3Cg fill='%23eac102'%3E %3Cpath d='m473.14,349.1c-0.24453,0.001-0.48146,0.089-0.7138,0.15328-0.35355,0.1448-0.70007,0.30774-1.0582,0.44046-0.14625,0.039-0.17866,0.20472-0.00042,0.22218,0.19806,0.15826,0.14739,0.44382,0.25478,0.65293,0.0677,0.24133,0.12509,0.48516,0.20417,0.7233,0.0732,0.30654,0.18124,0.60552,0.23704,0.91687,0.082,0.30128,0.18441,0.59978,0.23172,0.90873,0.0214,0.13362-0.25208,0.41238,0.0166,0.32853,0.27035-0.0615,0.50385-0.2403,0.7848-0.26222,0.10721-0.005,0.29569-0.18554,0.082-0.18806-0.24941-0.13137-0.16508-0.46907-0.29422-0.6835-0.0573-0.22726-0.13282-0.45195-0.17713-0.68129,0.0616-0.26466,0.41345-0.0846,0.4379,0.12533,0.14263,0.1921,0.32491,0.35931,0.50994,0.51283,0.22695,0.16089,0.44601,0.35394,0.7294,0.40473,0.20319,0.0455,0.42297,0.0355,0.61384-0.0521-0.27349-0.24158-0.59741-0.43435-0.8085-0.73948-0.17957-0.24218-0.33233-0.50286-0.50367-0.75081,0.26463-0.24559,0.51025-0.55153,0.56415-0.91906,0.0243-0.38974-0.17336-0.79768-0.51699-0.9915-0.18618-0.0772-0.39063-0.12677-0.59338-0.12114zm-0.32702,0.3434c0.21592,0.004,0.38962,0.15178,0.49477,0.32965,0.12066,0.22233,0.19602,0.48305,0.17549,0.73775-0.018,0.22586-0.15764,0.43049-0.36276,0.52733-0.15682,0.12326-0.55642,0.38634-0.57723,0.0327-0.10586-0.39295-0.24092-0.78004-0.31114-1.1813-0.0592-0.24642,0.19753-0.34566,0.38535-0.39956,0.0637-0.021,0.12894-0.0379,0.19552-0.0466z'/%3E %3Cpath d='m474.51,348.55c0.0328,0.18774,0.27919,0.27044,0.24817,0.48791,0.0505,0.2892,0.12302,0.57383,0.19864,0.85697,0.0214,0.26271,0.1097,0.51163,0.14581,0.77197,0.0403,0.18489,0.10309,0.36309,0.12861,0.55153,0.0449,0.25643,0.12112,0.50707,0.15632,0.76455,0.0505,0.11128-0.25305,0.34821-0.0391,0.33406,0.70395-0.19799,1.4185-0.36607,2.1213-0.56976,0.18593,0.0292,0.24204-0.10973,0.20651-0.26837,0.002-0.21391,0.003-0.42783,0.004-0.64174-0.21718-0.00069-0.20706,0.29685-0.37129,0.39089-0.25164,0.26931-0.60633,0.402-0.95178,0.50101-0.19883,0.0268-0.29871-0.17085-0.32608-0.33564-0.0673-0.16333-0.0433-0.34234-0.1041-0.50679-0.0609-0.2463-0.0998-0.49749-0.15266-0.74562,0.25217-0.10369,0.5365-0.16101,0.80683-0.10843,0.13572,0.009,0.25104,0.27418,0.36816,0.14357-0.00079-0.22166-0.0897-0.43682-0.12848-0.65502-0.046-0.0909-0.0683-0.43206-0.21201-0.33362-0.0725,0.14764-0.0942,0.3519-0.27917,0.40595-0.18308,0.0903-0.3721,0.1723-0.57782,0.1927-0.12984-0.13321-0.13108-0.422-0.15928-0.62456,0.0172-0.21804-0.13235-0.54857,0.17423-0.59697,0.29446-0.16062,0.67504-0.15752,0.95185,0.0393,0.1037,0.0759,0.34219,0.30783,0.35353,0.0473-0.13055-0.20766-0.13982-0.50047-0.3043-0.67633-0.19694-0.0274-0.37298,0.0971-0.56425,0.1235-0.56946,0.13123-1.1316,0.29863-1.6935,0.4517z'/%3E %3Cpath d='m479.22,347.26c-0.28589,0.0186-0.56593,0.0886-0.84496,0.14919-0.30613,0.0912-0.61034,0.18949-0.91552,0.28313-0.23532,0.13119,0.23292,0.22524,0.21055,0.41371,0.0334,0.19951,0.0639,0.40279,0.1151,0.59733,0.036,0.20334,0.0913,0.40282,0.11131,0.6088,0.0726,0.29416,0.12063,0.59424,0.18073,0.89069,0.0219,0.27817,0.14536,0.5387,0.14724,0.82011,0.0516,0.17722-0.0442,0.36483-0.0935,0.50081,0.3005-0.0735,0.6063-0.135,0.90248-0.22819,0.15689,0.013,0.22919-0.20422,0.0449-0.21717-0.13168-0.19608-0.13188-0.44668-0.19433-0.66844-0.0395-0.23778-0.0955-0.47236-0.14256-0.70867,0.42204-0.10019,0.85237-0.23519,1.1999-0.50263,0.23198-0.1995,0.42255-0.47199,0.42529-0.78878,0.0187-0.28434-0.071-0.57208-0.23211-0.80506-0.11344-0.13033-0.26954-0.22538-0.42471-0.29437-0.15918-0.0446-0.32594-0.0448-0.48984-0.0505zm0.52455,0.0551-0.0001,0.0001,0.0001-0.0001zm-0.85685,0.2743c0.26112,0.002,0.50366,0.18045,0.58455,0.4286,0.0981,0.24039,0.14464,0.51166,0.10189,0.76824-0.0471,0.17093-0.14369,0.33827-0.32124,0.39792-0.17401,0.0727-0.33371,0.23881-0.53545,0.20091-0.11989-0.11546-0.0358-0.34287-0.12867-0.49709-0.0707-0.30527-0.1087-0.61906-0.19955-0.91899-0.0381-0.18493,0.12129-0.3262,0.28974-0.35478,0.0682-0.0168,0.13867-0.023,0.20873-0.0248z'/%3E %3Cpath d='m482.7,346.54c0.11554,0.10637,0.23279,0.20828,0.30655,0.35058,0.10712,0.14445,0.0741,0.33407,0.13001,0.49752,0.0705,0.2424,0.0639,0.49685,0.12744,0.74065,0.0418,0.20257,0.0846,0.40699,0.0846,0.61478,0.0869,0.25369,0.0809,0.52952,0.0687,0.79378-0.0571,0.37964-0.46002,0.67043-0.83924,0.58969-0.17831-0.0214-0.32309-0.14707-0.39635-0.30693-0.12145-0.14766-0.16208-0.33342-0.19916-0.5156-0.0447-0.26535-0.10078-0.52817-0.13476-0.79528-0.0307-0.26923-0.0791-0.53512-0.1121-0.8033-0.033-0.21601-0.089-0.42725-0.12069-0.64257-0.0419-0.11776,0.27091-0.37407,0.0248-0.33282-0.31241,0.0312-0.61495,0.12327-0.92467,0.16825-0.22998,0.15365,0.16948,0.2117,0.15753,0.39702,0.0411,0.18784,0.0275,0.38411,0.0733,0.5724,0.0695,0.40851,0.16879,0.81283,0.19971,1.227,0.0269,0.19086,0.0868,0.37247,0.0972,0.56465,0.0471,0.19414,0.16212,0.36102,0.2679,0.52723,0.18025,0.16669,0.38913,0.32733,0.64413,0.34161,0.44225,0.0767,0.93508-0.0261,1.2502-0.36226,0.12972-0.16341,0.24216-0.35686,0.27638-0.56373,0.0107-0.29905,0.0127-0.60314-0.0672-0.8938-0.0298-0.29962-0.0324-0.6065-0.12891-0.89446-0.031-0.24978-0.0772-0.49758-0.10015-0.74839-0.0384-0.0616-0.058-0.25831-0.0173-0.37046-0.01-0.12877,0.22402-0.24851,0.11664-0.34374-0.19217-0.008-0.37478,0.0771-0.56769,0.0753-0.083,0.007-0.17298,0.0365-0.21679,0.11292z'/%3E %3Cpath d='m485.72,345.97c-0.41609-0.012-0.82533,0.0869-1.233,0.15203-0.1676,0.0667-0.4404,0.0482-0.53906,0.18505,0.11891,0.12734,0.25982,0.24676,0.23661,0.44369,0.0839,0.42355,0.1174,0.85472,0.19541,1.2792,0.003,0.26772,0.0966,0.52448,0.10408,0.79243,0.0256,0.31183,0.0751,0.6257,0.0674,0.93783,0.0123,0.1089-0.22318,0.3579-0.00085,0.30829,0.16915-0.07,0.34872-0.0291,0.52291-0.0912,0.22789-0.055,0.46126-0.0813,0.69347-0.1031,0.27937-0.0478,0.55965-0.10636,0.82512-0.20684,0.13971-0.10355,0.28355-0.21927,0.39969-0.3534,0.12168-0.12136,0.17762-0.28773,0.17956-0.4573,0.0215-0.28928-0.0254-0.63013-0.26567-0.82162-0.15303-0.12645-0.34717-0.17393-0.53134-0.24098-0.13272-0.035-0.2976-0.15208-0.0879-0.21113,0.21736-0.12698,0.40945-0.3161,0.47331-0.56658,0.0708-0.23406,0.0134-0.49905-0.1492-0.68165-0.089-0.21657-0.31862-0.28833-0.52919-0.32845-0.11894-0.0234-0.24069-0.0326-0.36131-0.0363zm-0.56,0.31c0.26631-0.0613,0.57215,0.0326,0.71896,0.27276,0.14358,0.1911,0.0924,0.44589,0.0696,0.66576-0.009,0.24824-0.26933,0.32881-0.45966,0.40907-0.13842,0.0832-0.48944,0.1893-0.44754-0.0892,0.0425-0.1918-0.0339-0.3734-0.0516-0.56224-0.02-0.17793-0.0212-0.35727-0.0197-0.5361,0.0633-0.0533,0.12675-0.10671,0.18997-0.16zm0.31,1.69c0.21044-0.0112,0.46557-0.0202,0.60779,0.16587,0.1985,0.17009,0.25604,0.43774,0.25456,0.68767-0.007,0.20276,0.003,0.44774-0.18257,0.57993-0.19035,0.12552-0.42924,0.22991-0.66118,0.1959-0.21631-0.0991-0.20056-0.39254-0.23136-0.59528-0.0276-0.20619-0.0826-0.41033-0.0955-0.61983-0.0524-0.15074-0.0922-0.43362,0.15385-0.38589,0.0503-0.0148,0.10192-0.0271,0.15442-0.0284z'/%3E %3Cpath d='m487.39,345.62c-0.0231,0.15181,0.21746,0.16609,0.21035,0.34234,0.0319,0.21041,0.001,0.42729,0.0679,0.63305,0.0315,0.2049,0.00063,0.41791,0.0519,0.61894,0.0655,0.24817-0.006,0.51713,0.0864,0.76186,0.0477,0.25328-0.0222,0.51815,0.0662,0.76598,0.0583,0.22516,0.0312,0.4899-0.13618,0.66288-0.0768,0.12833,0.20518,0.0734,0.28515,0.0435,0.3033-0.0235,0.60798-0.0344,0.90907-0.0821,0.17585-0.0185,0.35232-0.028,0.52376-0.0718,0.20472-0.0206,0.40943-0.0413,0.61415-0.0619,0.0623-0.25429,0.0969-0.5143,0.10469-0.77629,0.0173-0.0944,0.0262-0.25122-0.10214-0.16484-0.0612,0.16603-0.18004,0.30505-0.28033,0.44806-0.0991,0.074-0.20671,0.14534-0.33067,0.17033-0.1474,0.0429-0.29335,0.0991-0.45029,0.0854-0.17038,0.0425-0.35527-0.0262-0.36162-0.22499-0.0514-0.24167-0.0229-0.49263-0.0825-0.73292-0.0577-0.46546-0.0752-0.93477-0.10721-1.4021-0.0335-0.2804-0.0934-0.56377-0.0584-0.84672,0.0163-0.11537,0.31416-0.34188,0.059-0.29807-0.14434,0.0359-0.29139,0.0567-0.44086,0.0535-0.15918,0.0168-0.31456,0.0644-0.47661,0.06-0.0508,0.002-0.10275,0.006-0.15184,0.0159z'/%3E %3Cpath d='m490.3,345.3c-0.0352,0.13753,0.16091,0.0702,0.183,0.21759,0.0808,0.15036,0.008,0.33121,0.0774,0.48657,0.0274,0.18196,0.0308,0.36775,0.0481,0.55142,0.0446,0.58993,0.0893,1.1799,0.13388,1.7698,0.0505,0.14787,0.0466,0.3041,0.0446,0.45865,0.0226,0.13064-0.18725,0.23604-0.15636,0.33092,0.37388-0.009,0.75032-0.0242,1.1161-0.1081,0.11874-0.02-0.003-0.16246-0.0809-0.16409-0.11045-0.1214-0.10206-0.30208-0.1232-0.45581-0.0214-0.28099-0.0234-0.56467-0.0805-0.84155-0.0256-0.21909,0.0101-0.44252-0.0439-0.65835-0.0515-0.30498-0.0115-0.61878-0.0867-0.92057-0.02-0.19429-0.0635-0.40092,0.002-0.59043,0.0293-0.0703,0.25086-0.23262,0.0675-0.21597-0.34909,0.0177-0.70035,0.0438-1.0424,0.11836-0.0199,0.006-0.0402,0.0115-0.0585,0.0216z'/%3E %3Cpath d='m494.92,347.69c-0.20206-0.0201-0.27501,0.18735-0.38845,0.3129-0.12105,0.19337-0.34187,0.27657-0.55453,0.32333-0.24136,0.0627-0.4554-0.11825-0.62331-0.26675-0.14283-0.18582-0.24834-0.39937-0.31299-0.62437-0.0774-0.20252-0.0928-0.41912-0.14424-0.62771-0.0464-0.31258-0.0318-0.63331,0.00014-0.94562,0.0715-0.2178,0.14762-0.46376,0.33485-0.60983,0.24283-0.1493,0.57207-0.076,0.75809,0.1314,0.17442,0.1391,0.23102,0.35456,0.32467,0.54464,0.14041,0.21766,0.21299-0.10169,0.2184-0.22376,0.024-0.15409,0.12367-0.31698,0.0837-0.46915-0.12986-0.15963-0.34179-0.22315-0.53051-0.2851-0.44875-0.13047-0.97457-0.0568-1.3221,0.27138-0.14104,0.0997-0.23827,0.24021-0.32341,0.38749-0.10715,0.13357-0.15722,0.29351-0.20228,0.45562-0.0785,0.20712-0.0858,0.43095-0.12726,0.647-0.0358,0.47296,0.0808,0.94702,0.25842,1.3828,0.12669,0.21861,0.32316,0.38566,0.47714,0.58459,0.14261,0.19146,0.39679,0.24305,0.62067,0.27054,0.28157,0.026,0.57422-0.0351,0.80223-0.2078,0.20521-0.1307,0.34669-0.3321,0.4598-0.54301,0.0994-0.14624,0.15557-0.27517,0.18856-0.44762,0.004-0.0172,0.008-0.0435,0.002-0.0609z'/%3E %3Cpath d='m496.52,344.77c-0.16624,0.038-0.39694-0.0183-0.52412,0.0598-0.0383,0.29157-0.1131,0.57718-0.16779,0.86555-0.0445,0.20001-0.10769,0.39659-0.11342,0.6017-0.13098,0.5025-0.22723,1.0136-0.33062,1.5226-0.10151,0.23862-0.18163,0.4867-0.28664,0.72429-0.11856,0.0723-0.0888,0.23517,0.0631,0.17073,0.24058-0.006,0.48117-0.0111,0.72175-0.0168-0.014-0.16183-0.23206-0.21679-0.25221-0.39154-0.0562-0.17715,0.0194-0.34153,0.0287-0.51329,0.0134-0.21002,0.31328-0.0704,0.45258-0.11644,0.20591-0.004,0.41183-0.009,0.61774-0.0129-0.0265,0.23235,0.18003,0.4175,0.15286,0.65191,0.0419,0.12721-0.24027,0.38796,0.0131,0.36237,0.28478,0.0217,0.56218-0.0744,0.8468-0.0708,0.2615-0.0154-0.0624-0.24939-0.0836-0.37362-0.0797-0.29251-0.20029-0.57279-0.27087-0.86834-0.11724-0.41216-0.24171-0.82224-0.35317-1.2358-0.11611-0.36125-0.20044-0.73111-0.30389-1.0959-0.0347-0.12205-0.0122-0.29726-0.19053-0.26317l-0.0199-0.00038,0.00007-0.00003zm-0.38902,0.89631c0.15268,0.49659,0.29628,0.99631,0.44666,1.4932,0.077,0.20323-0.14173,0.15074-0.26567,0.16988-0.15708,0.0155-0.31659,0.0374-0.473,0.0322-0.10925-0.15392,0.0327-0.37745,0.0435-0.55549,0.0217-0.23091,0.12563-0.44824,0.12915-0.68265,0.0526-0.14904,0.008-0.32952,0.11933-0.45714z'/%3E %3Cpath d='m501.1,344.63c-0.37587,0.0236-0.75173,0.0473-1.1276,0.0709-0.0662,0.13046,0.20003,0.14871,0.14894,0.3067,0.0259,0.30293,0.006,0.60829,0.006,0.91228-0.0161,0.82389-0.042,1.6483-0.0553,2.4718-0.0123,0.11192-0.30767,0.34361-0.0556,0.32194,0.55307,0.0197,1.1191,0.0732,1.6611-0.0683,0.17522-0.0435,0.31937-0.15181,0.45062-0.27062,0.18344-0.15994,0.32197-0.3704,0.43831-0.58338,0.10473-0.24274,0.15346-0.50846,0.1839-0.76984,0.0214-0.27651,0.0288-0.55665-0.024-0.8297-0.0355-0.23449-0.13173-0.45848-0.21966-0.67662-0.11423-0.14561-0.18449-0.32166-0.31521-0.45346-0.14425-0.14414-0.32369-0.24579-0.50429-0.33711-0.20013-0.003-0.386-0.12101-0.58744-0.0946zm0.0936,0.30344c0.22949-0.008,0.47404,0.11688,0.54978,0.34348,0.0846,0.15518,0.14621,0.31414,0.16911,0.48939,0.0524,0.18329,0.01,0.3761,0.055,0.56124,0.0663,0.34659,0.003,0.69919-0.045,1.043-0.007,0.25551-0.0898,0.50194-0.21233,0.72395-0.0581,0.18431-0.26778,0.2417-0.41891,0.31915-0.19366,0.0514-0.46002,0.0377-0.50374-0.20507-0.0358-0.21719-0.0159-0.44-0.0218-0.65976,0.004-0.78803,0.007-1.5776,0.0577-2.3638-0.0138-0.22251,0.18391-0.28811,0.37009-0.2516l0.00005,0.00006z'/%3E %3Cpath d='m504.63,344.75c-0.23619-0.0176-0.47988,0.0391-0.66424,0.19243-0.22638,0.15191-0.34887,0.4033-0.50809,0.61598-0.16987,0.30153-0.23309,0.6484-0.27483,0.98799,0.0125,0.28602-0.041,0.57472,0.009,0.85875,0.091,0.20954,0.14039,0.43785,0.21537,0.65473,0.0702,0.2811,0.27925,0.50371,0.504,0.67515,0.17956,0.10556,0.36573,0.19942,0.57743,0.21379,0.39658,0.0398,0.77062-0.20901,1.0009-0.51534,0.17385-0.24971,0.36324-0.50423,0.41421-0.81207,0.0744-0.23937,0.096-0.48964,0.12122-0.73761,0.0127-0.18928-0.0304-0.37498-0.0367-0.56316-0.0278-0.25016-0.13049-0.48253-0.23643-0.70694-0.16118-0.24896-0.28904-0.54382-0.55728-0.69739-0.16786-0.10599-0.36453-0.17222-0.56451-0.16631zm-0.0112,0.24531c0.299,0.006,0.48086,0.30998,0.52141,0.57676,0.0605,0.2129,0.0825,0.43176,0.1101,0.65137-0.0163,0.35945,0.0109,0.72137-0.0294,1.08-0.0617,0.22729-0.0244,0.47121-0.11462,0.69273-0.0422,0.22381-0.12913,0.4501-0.29763,0.60867-0.15444,0.10164-0.35956,0.15965-0.50693,0.0115-0.17793-0.10323-0.1944-0.31764-0.27763-0.48538-0.1023-0.29334-0.059-0.60958-0.068-0.91421,0.007-0.43173,0.024-0.864,0.0398-1.295,0.0572-0.21837,0.0861-0.44813,0.18722-0.65228,0.0764-0.17537,0.24785-0.27435,0.43576-0.27426z'/%3E %3Cpath d='m506.12,349c0.24582-0.0236,0.48383,0.0883,0.72609,0.0797,0.17903-0.16032-0.19439-0.2921-0.14591-0.49524-0.0219-0.24655,0.0371-0.4923,0.0949-0.7307,0.037-0.22517,0.0617-0.45284,0.0981-0.67876,0.0591-0.21936,0.0576-0.45235,0.11643-0.67286,0.0259-0.18938,0.0344-0.506,0.10741-0.61136,0.12026,0.19318,0.0502,0.43299,0.1225,0.64137,0.04,0.24412,0.0499,0.48812,0.0941,0.73279,0.0465,0.2561,0.0831,0.51169,0.10174,0.77141,0.0455,0.22847,0.0744,0.46554,0.10543,0.69939,0.0515,0.1657-0.0492,0.49237,0.23065,0.42377,0.25397,0.0889,0.16856-0.24911,0.28066-0.39533,0.0874-0.35605,0.15502-0.71765,0.25126-1.0715,0.083-0.19884,0.10892-0.41703,0.17469-0.62174,0.0899-0.33647,0.16766-0.6776,0.30539-0.9986,0.00017,0.96982,0.0764,1.9407,0.006,2.9097-0.0448,0.10919-0.29778,0.28976-0.0279,0.30712,0.24662,0.0141,0.49145,0.0387,0.7339,0.0819,0.23613,0.0598,0.19967-0.14671,0.0523-0.24023-0.14843-0.24602-0.0545-0.54441-0.071-0.81406,0.01-0.4782-0.0378-0.95467-0.0315-1.4328-0.006-0.43923-0.007-0.88071,0.039-1.3174,0.0557-0.0738,0.27433-0.26092,0.0681-0.2685-0.28995-0.0135-0.57989-0.0269-0.86984-0.0404-0.0368,0.23659-0.13952,0.45711-0.17508,0.69453-0.0608,0.27767-0.13899,0.55132-0.22225,0.82242-0.0293,0.25318-0.11884,0.49142-0.1682,0.74026-0.009,0.10521-0.0949,0.21893-0.0978,0.0419,0.0167-0.22256-0.11124-0.42854-0.0793-0.65109-0.005-0.18602-0.0974-0.35551-0.0715-0.54447-0.021-0.38411-0.14514-0.75673-0.14561-1.1428-0.0507-0.18515-0.30925-0.0887-0.45748-0.16082-0.15999-0.006-0.32033-0.0114-0.48044-0.0188,0.0707,0.24667,0.13538,0.49769,0.0815,0.75407-0.0364,0.21462-0.0894,0.42606-0.10542,0.64395-0.0798,0.50126-0.19778,0.99686-0.25713,1.5009-0.0709,0.17802-0.0521,0.37643-0.13234,0.54936-0.0562,0.16295-0.0991,0.3146-0.25418,0.41008-0.0135,0.033-0.007,0.0705,0.003,0.10283z'/%3E %3Cpath d='m509.98,349.42c0.20879,0.0846,0.44143,0.0677,0.65432,0.13693,0.10895,0.001,0.36573,0.11104,0.3774-0.0394-0.0899-0.13449-0.21398-0.26007-0.15927-0.43853,0.024-0.22372,0.074-0.4453,0.0617-0.67174-0.004-0.20499,0.0735-0.39897,0.0721-0.60309,0.0224-0.45091,0.0508-0.90164,0.0968-1.3507-0.0106-0.17403,0.0266-0.33659,0.0706-0.50029-0.0139-0.13238,0.0913-0.19405,0.17403-0.25174,0.0634-0.21689-0.21486-0.12069-0.33465-0.15431-0.23718-0.016-0.46951-0.0813-0.70823-0.0781-0.0536,0.10029,0.15017,0.18093,0.13064,0.3086,0.0347,0.16753-0.0106,0.33816-0.014,0.50574-0.0739,0.24578-0.0482,0.50624-0.0734,0.75893-0.0143,0.24032-0.0428,0.47939-0.0642,0.71886-0.0736,0.17579-0.0628,0.3735-0.0655,0.56347,0.006,0.21888-0.0123,0.43765-0.0544,0.65201,0.0104,0.14336-0.0416,0.30317-0.15757,0.36652-0.002,0.0256-0.003,0.0515-0.006,0.0769z'/%3E %3Cpath d='m511.32,349.71c0.18965-0.0127,0.36997,0.0864,0.55585,0.0716,0.10228,0.0422,0.31419,0.10403,0.21023-0.0859-0.10911-0.16522-0.16215-0.35305-0.1471-0.55204-0.011-0.33851,0.0421-0.67439,0.0876-1.0081-0.0112-0.23906,0.0143-0.47675,0.0759-0.7058,0.0203-0.21874,0.0246-0.44139,0.0865-0.65378,0.11352,0.10658,0.14216,0.35129,0.22748,0.5093,0.3115,0.79286,0.60958,1.5909,0.91804,2.3849,0.0741,0.15495,0.11012,0.38773,0.29604,0.43956,0.22923,0.094,0.17243-0.17714,0.18212-0.31394,0.0157-0.20033,0.12215-0.38118,0.0753-0.59075,0.0311-0.21876,0.076-0.43638,0.0746-0.66035,0.0514-0.21502,0.0816-0.43531,0.073-0.65683,0.0394-0.21333,0.0884-0.42525,0.0736-0.64437,0.003-0.23512,0.0748-0.45929,0.12497-0.68615,0.004-0.1517,0.40296-0.31035,0.15689-0.40244-0.21691,0.006-0.50749-0.14707-0.67677-0.0689,0.0438,0.17551,0.19664,0.3173,0.1661,0.51512,0.027,0.45016-0.0945,0.89275-0.0894,1.3424-0.0492,0.22216-0.0645,0.46554-0.0955,0.67786-0.12251-0.16729-0.16656-0.42721-0.26239-0.62736-0.0953-0.2427-0.17588-0.49223-0.29312-0.72573-0.0495-0.20776-0.16041-0.39474-0.21959-0.59956-0.11195-0.27522-0.22244-0.55103-0.33398-0.82642-0.25371-0.0354-0.51052-0.072-0.75237-0.15529-0.19061,0.11168,0.1127,0.29038,0.0821,0.45422,0.0596,0.32764,0.003,0.65727-0.0436,0.98229-0.0135,0.21585-0.0289,0.43086-0.0709,0.6436-0.001,0.23128-0.003,0.46367-0.0817,0.68556-0.0161,0.241-0.0595,0.48138-0.10141,0.7207-0.008,0.2047-0.20264,0.30745-0.29767,0.44813-0.004,0.0294-0.00047,0.0595-0.00074,0.0886z'/%3E %3Cpath d='m514.84,346.34c0.02,0.14278,0.19971,0.23572,0.12033,0.40287,0.003,0.19355-0.0297,0.38346-0.0625,0.57288-0.0145,0.18071-0.0313,0.36206-0.0729,0.53838-0.0293,0.29285-0.0904,0.58244-0.0883,0.8779-0.004,0.17738-0.0753,0.34483-0.0682,0.52349-0.0132,0.13752-0.0676,0.26626-0.0767,0.40529-0.0179,0.12135-0.0351,0.24301-0.063,0.36259-0.0514,0.0652-0.0859,0.13943-0.17608,0.14673-0.0841,0.17319,0.24593,0.1545,0.35487,0.18423,0.19285,0.0406,0.38382,0.0589,0.56573,0.12663,0.1453,0.0519,0.20402-0.10965,0.0749-0.17626-0.13909-0.18146-0.0369-0.41402-0.0253-0.61799,0.0149-0.15747,0.0271-0.31454,0.0657-0.46814,0.031-0.20832,0.0178-0.42254,0.0776-0.62579,0.0209-0.16129,0.01-0.32913,0.0705-0.48288,0.0341-0.20876,0.002-0.42764,0.076-0.62959-0.008-0.17876,0.042-0.35018,0.0797-0.52106-0.003-0.16278,0.0439-0.33261,0.19025-0.41766-0.1345-0.0702-0.29351-0.10727-0.44732-0.1303-0.15969-0.014-0.30716-0.0806-0.46355-0.1062-0.0459-0.003-0.096,0.004-0.13166,0.0349z'/%3E %3Cpath d='m516.07,349.1c-0.0161,0.2163,0.008,0.43135,0.043,0.6436,0.0441,0.29168,0.18099,0.55947,0.35289,0.79592,0.10242,0.19217,0.31155,0.27445,0.48228,0.39356,0.21486,0.12952,0.49674,0.11407,0.7223,0.018,0.13462-0.0625,0.30057-0.0949,0.37686-0.23872,0.15175-0.18203,0.336-0.35215,0.40598-0.58599-0.0992-0.21165-0.24264,0.10407-0.34382,0.16379-0.22697,0.17702-0.57283,0.24053-0.8237,0.0794-0.17613-0.12231-0.26718-0.31844-0.33363-0.51425-0.0398-0.19249-0.12265-0.3744-0.10386-0.5741-0.004-0.26104,0.002-0.52238,0.023-0.78266,0.10327-0.20247,0.0437-0.44419,0.13055-0.65338,0.0808-0.17569,0.11526-0.37965,0.2471-0.52695,0.0947-0.14152,0.26243-0.2095,0.4289-0.21625,0.17528,0.0275,0.28822,0.19369,0.39799,0.31941,0.13003,0.165,0.18141,0.37585,0.17559,0.58311-0.042,0.14578,0.13535,0.33854,0.22481,0.15233,0.0563-0.21266,0.2028-0.40463,0.21743-0.6241-0.0367-0.18216-0.21654-0.27629-0.33856-0.3981-0.13104-0.0956-0.27993-0.16472-0.42466-0.23721-0.27217-0.0765-0.59966-0.11332-0.84156,0.0658-0.16179,0.0828-0.31455,0.1818-0.43226,0.32236-0.19343,0.18586-0.27943,0.44825-0.37981,0.69012-0.10447,0.25214-0.15954,0.52257-0.19795,0.79144-0.008,0.11076-0.008,0.2221-0.009,0.33293z'/%3E %3Cpath d='m520.11,347.59c-0.24662,0.5093-0.44632,1.0399-0.6867,1.5522-0.0908,0.18419-0.13558,0.38701-0.24014,0.56491-0.11861,0.27234-0.21626,0.55506-0.37517,0.80797-0.12072,0.17126-0.16001,0.42971-0.36044,0.52759-0.16464,0.0344-0.12607,0.21006,0.0364,0.20446,0.20476,0.0226,0.39125,0.15009,0.58129,0.16114,0.16256-0.0956-0.0873-0.22611-0.0626-0.3621-0.0291-0.19238,0.0518-0.3782,0.13293-0.54616,0.14379-0.14759,0.35732-0.0156,0.52306,0.0184,0.12621,0.0825,0.33793,0.0343,0.42702,0.13207-0.001,0.27519-0.003,0.55037-0.004,0.82556-0.15068,0.0743-0.11939,0.26664,0.0574,0.26356,0.1834,0.0448,0.36446,0.0942,0.54393,0.14849,0.10504,0.0484,0.31609,0.0901,0.19293-0.0841-0.1232-0.26596-0.0851-0.56457-0.0992-0.84861-0.008-0.2362,0.009-0.47877-0.0336-0.71045-0.0587-0.19374-0.0165-0.40004-0.0321-0.59909,0.004-0.43042,0.0301-0.86234-0.0187-1.2911-0.008-0.20315,0.007-0.40738-0.018-0.6097-0.16888-0.0738-0.358-0.0907-0.53395-0.14707l-0.0305-0.008,0.00021,0.00002zm-0.0807,0.85083c0.01,0.60506,0.0195,1.2101,0.0293,1.8152-0.23388-0.004-0.44813-0.10987-0.67419-0.15571-0.12675-0.18303,0.16094-0.34363,0.14701-0.53845,0.11247-0.28123,0.2552-0.55042,0.36641-0.83288,0.0579-0.0906,0.0526-0.21463,0.13147-0.28816z'/%3E %3Cpath d='m521.84,352.25c-0.01-0.23063-0.18765-0.43104-0.1141-0.67254-0.0167-0.2968,0.0841-0.57671,0.14657-0.86179,0.0114-0.20574,0.0992-0.40106,0.11033-0.61012,0.0451-0.24915,0.13866-0.48972,0.14954-0.74452,0.0908-0.22433,0.16488,0.0655,0.17583,0.17109,0.13284,0.41039,0.22529,0.83334,0.33913,1.2484,0.0519,0.18223,0.0856,0.36808,0.15836,0.5433,0.11763,0.34053,0.16946,0.70057,0.2948,1.0383-0.013,0.20999,0.10094,0.47318,0.34696,0.42157,0.10552-0.23226,0.12955-0.50047,0.19139-0.7505,0.0591-0.21887,0.0391-0.45527,0.14303-0.66121,0.0822-0.3765,0.10052-0.76961,0.23271-1.1349,0.0759-0.29945,0.15184-0.59934,0.21292-0.90164,0.0661-0.11564,0.41858-0.28675,0.15711-0.386-0.19999-0.0314-0.42486-0.21669-0.61044-0.15704,0.0343,0.16168,0.13291,0.3106,0.12557,0.48446,0.01,0.23948-0.0777,0.46928-0.083,0.70675-0.0609,0.20012-0.11618,0.40084-0.15311,0.60711-0.0495,0.2346-0.0926,0.47047-0.1342,0.70657-0.16783-0.15331-0.1017-0.41534-0.20042-0.60739-0.0742-0.27109-0.16937-0.53547-0.21784-0.81235-0.0889-0.26147-0.15318-0.5293-0.2102-0.79909-0.0858-0.19603-0.13751-0.40478-0.16999-0.61672-0.14021-0.20162-0.41362-0.20615-0.62128-0.29946-0.18693-0.10477-0.33537,0.0126-0.18422,0.18756,0.0996,0.40803,0.001,0.83034-0.0875,1.2308-0.0794,0.35242-0.19028,0.70128-0.21965,1.0622-0.09,0.22273-0.0961,0.46242-0.15719,0.69218-0.0708,0.18867-0.13802,0.40714-0.32079,0.51628-0.23355,0.19767,0.21661,0.20951,0.33792,0.26837,0.10943,0.0666,0.23267,0.12136,0.36173,0.13033z'/%3E %3Cpath d='m525.79,349.59c-0.13211,0.30034-0.30887,0.5773-0.45306,0.87126-0.11875,0.28419-0.29001,0.54366-0.43557,0.81492-0.28052,0.4892-0.57189,0.97208-0.85656,1.4589-0.1428,0.0498-0.32969,0.26045-0.0681,0.28902,0.19901,0.0692,0.37385,0.20181,0.5799,0.24922,0.14744-0.0766-0.0931-0.26998-0.0616-0.40077,0.0196-0.20455,0.0887-0.39839,0.17973-0.5814,0.12569-0.0807,0.31614,0.0943,0.46395,0.12507,0.14767,0.10796,0.49046,0.0776,0.45318,0.31546,0.0116,0.25173,0.0116,0.5109-0.078,0.75017-0.11815-0.003-0.18579,0.0971-0.0651,0.17336,0.14867,0.069,0.30879,0.11125,0.45627,0.18573,0.14391,0.0272,0.28944,0.16674,0.43436,0.0988-0.0436-0.17909-0.11594-0.37809-0.0959-0.5773,0.0182-0.3111,0.0194-0.62233,0.0208-0.93383-0.004-0.21285,0.067-0.41754,0.0546-0.63033,0.0138-0.68402,0.0268-1.368,0.0404-2.0521-0.20598,0.0178-0.36238-0.16564-0.56925-0.15621zm-0.12657,0.82211c-0.008,0.61137-0.0167,1.2227-0.025,1.8341-0.156-0.0343-0.30026-0.11123-0.44972-0.16382-0.11114-0.0863-0.41358-0.11454-0.24396-0.28858,0.12428-0.2436,0.26209-0.4811,0.38488-0.72476,0.0934-0.22725,0.21927-0.44008,0.3338-0.65694z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1200' height='600'%3E %3Ctitle%3EFlag of Dominica%3C/title%3E %3Crect height='600' width='1200' fill='%23006b3f'/%3E %3Crect width='75' height='600' x='525' fill='%23fcd116'/%3E %3Crect width='1200' height='75' y='225' fill='%23fcd116'/%3E %3Crect width='75' height='600' x='600' fill='%23fff'/%3E %3Crect width='1200' height='75' y='300' fill='%23fff'/%3E %3Crect width='50' height='600' x='575' fill='%23000'/%3E %3Crect width='1200' height='50' y='275' fill='%23000'/%3E %3Cg fill='%23006b3f' transform='translate(600,300)'%3E %3Ccircle r='150' fill='%23d41c30'/%3E %3Cg id='star2'%3E %3Cpath id='star' stroke='%23000' d='m-4.81,-118.41 4.81,-13.72 4.37,13.5 14.65,0.22 -11.59,8.85 5.25,15.05 -12.68,-9.29 -12.46,8.85 4.81,-14.61 -11.37,-8.63 14.21,-0.22z'/%3E %3Cuse xlink:href='%23star' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23star2' transform='rotate(36)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(72)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(108)'/%3E %3Cuse xlink:href='%23star2' transform='rotate(144)'/%3E %3Cg stroke='%23000' stroke-width='2.5'%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.289553,-0.03018225,0.01658794,0.23225804,-186.11735,-75.926206)'/%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.30625538,-0.03184484,0.01668502,0.23224838,-188.73313,-74.886801)'/%3E %3Cellipse cx='680.21' cy='586.13' rx='30.805' ry='189.82' transform='matrix(0.24500433,-0.0258909,0.01789798,0.25675005,-151.94706,-90.935577)'/%3E %3Cpath fill='%239c4a00' stroke-width='0.6573' d='m-44.213085,62.564681c7.657331,-0.318514 4.332103,-4.415732 8.199242,-6.595651 3.864538,-2.177268 9.365358,-0.736785 11.015564,1.985834 1.650207,2.72262 0.327013,5.396731 2.450471,5.433299 2.12601,0.03661 59.928115,-2.387638 62.010231,-0.105265 2.084719,2.27972 2.428307,6.775972 0.269442,8.524141 -2.159263,1.769736 -75.234738,2.587907 -77.751167,0.737649 -2.516925,-1.823297 -6.202071,-9.529768 -6.193783,-9.980007z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M-3.3768912,68.194919C-3.5157446,73.97045 5.0266835,72.334565 5.1440072,77.158287 4.886691,82.271863 -9.1802916,77.470843 -9.3156063,68.11661 -8.7307374,58.771874 5.0382371,54.154377 5.208533,59.491796c0.1266662,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M1.6637058,68.261384C1.5248524,74.036915 10.067281,72.40103 10.184604,77.224752 9.927288,82.338328 -4.1396946,77.537308 -4.2750093,68.183075 -3.6901404,58.838339 10.078834,54.220842 10.24913,59.558261c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='M7.0709208,68.057753C6.9320674,73.833284 15.474496,72.197399 15.591819,77.021121 15.334503,82.134697 1.2675204,77.333677 1.1322057,67.979444 1.7170746,58.634708 15.486049,54.017211 15.656345,59.35463c0.126666,4.435124 -8.4465709,2.927591 -8.5854242,8.703123z'/%3E %3Cpath fill='%23fcd116' stroke-width='0.6326' d='m12.111394,68.124255c-0.138854,5.775532 8.403575,4.139646 8.520898,8.963369C20.374976,82.2012 6.3079934,77.40018 6.1726787,68.045947 6.7575476,58.701211 20.526522,54.083714 20.696818,59.421133c0.126666,4.435124 -8.446571,2.927591 -8.585424,8.703122z'/%3E %3Cellipse fill='%239c4a00' stroke-width='0.3991' cx='478.38' cy='-41.085999' rx='3.5339' ry='3.4030001' transform='matrix(1.3799165,0.02078085,-0.03061721,1.4544413,-625.22695,117.20523)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-119.97806,-293.41566)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.03129182,0.04226118,0.39513675,-127.33463,-293.99555)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20742248,-0.0312918,0.04226106,0.39513549,-132.603,-303.41129)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19942957,-0.0315355,0.04632234,0.43592867,-125.4075,-340.63478)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-112.65072,-316.23218)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-118.30405,-319.63879)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-125.43742,-324.55362)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.19950028,-0.03083913,0.04356143,0.40873864,-132.04249,-327.53171)'/%3E %3Cpath fill='%239461c9' stroke-width='0.5749' d='m-14.73408,-52.686013c0,0 -14.655341,12.719161 -13.010831,47.1436528 1.845436,34.6199222 32.3934914,50.8943372 32.3934914,50.8943372 0,0 7.7859806,-9.826932 6.8819576,-37.6434978C9.3473299,-32.960001 -5.0778778,-50.928723 -5.0778778,-50.928723l-9.6562022,-1.75729z'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-45.183498,-309.40147)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617733,-0.02883923,0.39634241,-52.318928,-311.28321)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20967854,0.00617736,-0.02883913,0.39634115,-55.824816,-321.48715)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.20185704,0.00451301,-0.03211329,0.43720504,-42.110313,-356.83224)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-33.906971,-330.54675)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-38.862639,-334.90639)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-45.005838,-341.01389)'/%3E %3Cellipse cx='427.11' cy='905' rx='20.814' ry='24.144' transform='matrix(0.2018025,0.00521083,-0.02998402,0.40995827,-50.974388,-345.12149)'/%3E %3Cellipse fill='%23d41c30' stroke-width='1pt' cx='624.42' cy='606.11' rx='58.28' ry='186.49' transform='matrix(0.19786701,-0.07643491,0.08023488,0.18709671,-155.83813,-59.21337)'/%3E %3Cellipse stroke-width='1.4635' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-99.510833,-162.76931)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-84.135444,-169.29958)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-90.652069,-169.41561)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-93.887858,-166.3691)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-94.461639,-172.01688)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-96.8782,-173.22007)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-95.468785,-176.63136)'/%3E %3Cellipse stroke-width='1.4635' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.49827764,0.00887179,-0.00656928,0.3689586,-114.72518,-179.36983)'/%3E %3Cellipse stroke-width='1.56' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.46713655,0.00831733,-0.00616707,0.34636886,-98.157196,-179.08115)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-100.2913,-183.52126)'/%3E %3Cellipse stroke-width='1.5462' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.00656928,0.3689586,-110.48856,-178.90566)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-108.8569,-179.77161)'/%3E %3Cellipse stroke-width='1.5623' cx='218.13' cy='356.75' rx='10.823' ry='12.905' transform='matrix(0.44637456,0.00794766,-0.0064352,0.36142827,-106.80676,-183.69602)'/%3E %3Cellipse stroke-width='2.5449' cx='528.68' cy='564.48' rx='67.438' ry='205.64' transform='matrix(0.21931516,-0.07742835,0.08682875,0.20202384,-145.01539,-72.55561)'/%3E %3Cellipse cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.20574399,-0.0978521,0.09471329,0.21196041,-137.12211,-77.403485)'/%3E %3Cpath stroke-width='0.5749' d='M31.462582,7.798675C44.273286,23.396889 42.655575,33.30197 41.319929,41.68219 37.295042,32.018935 35.09747,25.935914 22.284544,10.334996 9.4716187,-5.2659225 15.867064,-16.212552 16.746886,-21.981169c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z'/%3E %3Cpath stroke-width='0.5749' d='M32.616052,20.397765C45.426756,35.995979 43.809045,45.90106 42.473399,54.28128 38.448512,44.618025 36.25094,38.535004 23.438014,22.934086 10.625089,7.3331675 17.020534,-3.6134618 17.900356,-9.382079c1.926581,4.993077 1.90277,14.1789256 14.715696,29.779844z'/%3E %3Cpath stroke-width='0.5749' d='M33.001502,30.545466C46.121623,45.867895 44.702257,55.805012 43.534416,64.211635 39.317096,54.636146 36.998322,48.601234 23.875927,33.276148 10.753531,17.951062 16.928895,6.8711542 17.693213,1.0852029 19.719255,6.0361835 19.879107,15.22038 33.001502,30.545466z'/%3E %3Cellipse stroke-width='1.3887' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.40784061,-0.1037946,0.16693789,0.37767112,-299.57061,-196.0302)'/%3E %3Cellipse stroke-width='1.6398' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.36689221,-0.0631048,0.12978287,0.31264984,-259.00282,-166.87124)'/%3E %3Cellipse stroke-width='1.6398' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.36814797,-0.0553158,0.1232589,0.31530969,-261.52366,-166.81962)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29657862,-0.05431058,0.11151259,0.23307633,-211.06958,-135.53834)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.27027,-143.86531)'/%3E %3Cpath stroke-width='0.5749' d='M8.6195396,-15.767835C12.407426,-6.5127711 13.940854,1.8088668 12.039861,2.8095164 10.141163,3.8089573 5.5266551,-2.8908549 1.7387689,-12.145919'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.29951522,-0.03800069,0.09680807,0.23872917,-208.89375,-154.73721)'/%3E %3Cellipse stroke-width='2.0966' cx='528.68' cy='646.07' rx='13.321' ry='40.796' transform='matrix(0.30032211,-0.03210428,0.09144035,0.24056268,-212.194,-155.98718)'/%3E %3Cpath stroke-width='0.5749' d='m2.0257453,-28.338145c3.6779608,6.253928 5.6581289,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201'/%3E %3Cpath stroke-width='0.5749' d='m4.5726443,-32.485105c3.6779608,6.253928 5.6581287,12.09375 4.4184823,13.037247 -1.2381494,0.942356 -5.2275031,-3.368272 -8.9054639,-9.622201'/%3E %3Cpath stroke-width='0.5749' d='m16.013433,-31.606808c5.124964,8.542601 7.882604,16.520579 6.153303,17.810625 -1.727212,1.288488 -7.287655,-4.598619 -12.4126197,-13.14122'/%3E %3Cpath stroke-width='0.5749' d='m8.4524006,-36.082328c3.6926974,6.904591 5.6865404,13.348237 4.4490124,14.385262 -1.236034,1.035772 -5.2356299,-3.727092 -8.9283268,-10.631682'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m8.1245845,-46.086178c-2.4652011,2.482234 -0.05083,7.123595 2.2055225,8.801039 2.530629,2.294221 16.742134,17.286089 26.768781,4.672222C29.06535,-32.759025 14.072204,-51.617449 8.1245845,-46.086178z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m6.3689905,-53.485518c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306289,2.294221 16.7421339,17.286089 26.7687809,4.672222C27.309756,-40.158365 12.31661,-59.016789 6.3689905,-53.485518z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m4.1226915,-60.575768c-2.4652011,2.482234 -0.05083,7.123595 2.2055226,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.026684,-19.004532 -28.9743035,-13.473261z'/%3E %3Cpath fill='%239461c9' stroke-width='0.5905' d='m-0.75854747,-68.686568c-2.46520113,2.482234 -0.0508299,7.123595 2.20552257,8.801039 2.5306294,2.294221 16.7421339,17.286089 26.7687809,4.672222 -8.033538,-0.146108 -23.0266836,-19.004532 -28.97430347,-13.473261z'/%3E %3Cpath fill='%239461c9' stroke-width='0.6276' d='m-18.271949,-76.448224c5.080302,-3.778951 14.4116525,-4.884005 21.6814205,-1.183186 6.0553769,2.966807 16.1473035,15.072925 23.7340285,17.934947 -5.339994,0.952539 -8.588551,0.147731 -12.001308,-1.491593 -6.7388646,4.879721 -9.1401688,5.611298 -16.00788077,6.570161 -9.55160223,1.377954 -17.47968323,-1.108557 -20.26606523,-6.089426 -2.839252,-4.699505 -1.61543,-12.238734 2.859805,-15.740903z'/%3E %3Cellipse fill='%23d41c30' cx='287.23' cy='323.04' rx='14.154' ry='14.986' transform='matrix(0.30909157,0.00550335,-0.00301489,0.16932914,-95.304017,-125.19072)'/%3E %3Cellipse fill='%23fcd116' cx='204.58' cy='348.26' rx='23.254' ry='15.895' transform='matrix(0.24579207,-0.09143683,0.08132205,0.2192462,-99.445497,-116.289)'/%3E %3Cellipse fill='%23000' stroke='none' cx='283.9' cy='333.86' rx='5.828' ry='5.8279' transform='matrix(0.26990081,0.00480556,-0.00415607,0.23342269,-82.956029,-148.37388)'/%3E %3Cpath fill='%23fcd116' stroke-width='0.7318' d='m-17.127905,-65.514747c0.402078,1.948925 -1.043505,4.582316 -4.180015,5.515002 -3.195207,1.322722 -5.618416,4.322017 -7.016075,9.226342 -4.855803,-11.183796 -1.769609,-15.915544 3.387899,-17.06567 4.436579,-1.414945 7.11029,-1.235679 7.808191,2.324326z'/%3E %3Cellipse fill='%23000' stroke='none' cx='198.98' cy='362.39' rx='4.7097' ry='4.7097' transform='matrix(0.23597119,-0.0123552,0.01333585,0.24161486,-73.600709,-149.7658)'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='370' height='280'%3E %3Crect width='370' height='280' fill='%23c60c30'/%3E %3Crect width='40' height='280' x='120' fill='%23fff'/%3E %3Crect width='370' height='40' y='120' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 15 10'%3E %3Crect width='15' height='10' id='blue' style='fill:%236ab2e7'/%3E %3Crect width='15' height='5' y='5' id='green' style='fill:%2312ad2b'/%3E %3Cpath d='M 0,0 0,5 0,10 4.330127,7.5 8.660254,5 4.330127,2.5 0,0 z' id='path6904' style='fill:%23fff'/%3E %3Cpath d='m 3.3143278,3.75 0.3102707,0.954915 1.0040571,0 L 3.8163564,5.295085 4.126627,6.25 3.3143278,5.65983 2.5020286,6.25 2.8122992,5.295085 2,4.704915 l 1.004057,0 L 3.3143278,3.75 z' id='path6929' style='fill:%23d7141a'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600' viewBox='0 0 5 3'%3E %3Cdesc%3EFlag of Germany%3C/desc%3E %3Crect id='black_stripe' width='5' height='3' y='0' x='0' fill='%23000'/%3E %3Crect id='red_stripe' width='5' height='2' y='1' x='0' fill='%23D00'/%3E %3Crect id='gold_stripe' width='5' height='1' y='2' x='0' fill='%23FFCE00'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23d7141a'/%3E %3Crect width='900' height='300' fill='%23fff'/%3E %3Cpath d='M 450,300 0,0 V 600 z' fill='%2311457e'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23fff'/%3E %3Cpath id='branch' fill='%23435125' d='m434.8,498.25c-0.18-0.086-0.218-0.122-0.347-0.245l-0.125-0.117c-0.324-0.297-0.861-0.822-1.582-1.643-1.332-1.513-3.119-3.728-4.69-5.685-3.115-3.883-5.689-7.228-6.174-7.858l-0.793-1.032-7.767-2.395-5.671-2.644,3.03-3.406,10.408,4.456,7.767,1.594,14.363,10.564-0.011,0.009c-0.029,0.024-2.089,1.738-4.136,3.599-0.913,0.83-2.064,1.896-2.877,2.783-0.375,0.408-0.705,0.813-0.93,1.14-0.138,0.201-0.215,0.383-0.252,0.471l0.892-0.555,0.967,0.752-1.968,0.184-0.09,0.02zm-53.34-16.02c-6.777-0.001-13.471-1.874-19.895-5.567l-0.007-0.004,0.003-0.008s0.84-1.601,2.878-3.096c1.941-1.425,5.442-3.128,11.1-3.15h0.117c6.701,0,14.901,2.278,24.373,6.771-0.32,0.212-7.756,5.054-18.566,5.054l0.01,0.01zm-29.37-6.51c-1.253,0-2.379-0.474-3.17-1.333-0.649-0.706-1.114-1.646-1.422-2.878-0.504-2.018-0.365-4.025-0.351-4.217,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.511,0,4.49,2.178,5.338,4.337,0.481,1.227,0.574,2.259,0.274,3.067-0.3,0.81-1.24,1.37-2.34,1.37zm51.68-5.99c-17.359-2.479-24.717-8.755-27.833-13.583-3.323-5.149-2.641-9.912-2.634-9.96l0.003-0.014,0.013-0.004c0.005,0,1.061-0.285,2.658-0.293,4.618,0,16.43,2.323,27.798,23.842l0.007,0.014-0.02-0.01zm-35.58-3.44c-7.416-0.001-13.062-1.28-16.782-3.804-2.138-1.45-3.184-3.043-3.686-4.125-0.47-1.014-0.577-1.856-0.594-2.023,0.196-0.09,3.232-1.438,7.765-1.65,0.383-0.018,0.769-0.029,1.174-0.03,5.732,0,14.448,1.87,23.646,10.78l0.009,0.009-0.011,0.001c-4.2,0.55-8.08,0.84-11.53,0.84zm-35.91-1.38c-7.82,0-18.563-2.388-25.263-9.087l-0.007-0.008,0.02-0.005c0.07-0.018,7.342-1.863,15.523-2.062,0.488-0.012,0.979-0.019,1.475-0.019,7.332,0,12.944,1.422,16.682,4.225,1.305,0.979,2.018,1.89,2.178,2.783,0.134,0.746-0.26,1.55-1.056,2.15-1.683,1.271-4.692,1.949-8.945,2.017l-0.6,0.02zm-25.34-13c-0.963,0-1.867-0.426-2.479-1.167-0.506-0.614-0.858-1.416-1.108-2.522-0.418-1.848-0.292-3.656-0.291-3.674l0.001-0.018c0.364-0.172,0.771-0.264,1.217-0.275h0.003c1.157,0,2.039,0.63,2.589,1.158,0.733,0.705,1.333,1.645,1.688,2.645,0.365,1.03,0.424,1.892,0.18,2.635-0.2,0.59-0.88,1.21-1.8,1.21zm58.53-1.32c-1.253,0-2.379-0.474-3.17-1.333-0.649-0.706-1.114-1.646-1.422-2.878-0.504-2.018-0.365-4.025-0.351-4.217,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.511,0,4.49,2.178,5.338,4.337,0.481,1.227,0.574,2.259,0.274,3.067-0.3,0.82-1.25,1.37-2.34,1.37zm-28.51-1.18c-15.737-0.554-23.904-5.027-27.984-8.683-2.297-2.058-3.574-4.098-4.24-5.447-0.628-1.274-0.866-2.249-0.908-2.438l0.021-0.009c0.003,0,1.489-0.532,3.885-0.579l0.368-0.004c5.307,0,16.111,2.229,28.852,17.153v0.01zm17.09-1.59c-12.661-1.928-19.834-7.363-23.622-11.585-3.971-4.425-5.16-8.546-5.213-8.738,0.023-0.007,1.57-0.41,3.9-0.469,0.169-0.005,0.345-0.007,0.524-0.007,0.181,0,0.365,0.002,0.553,0.007,6.368,0.139,17.934,3.023,23.855,20.785h0.01zm-65-6.08c-4.149,0-8.174-0.48-11.962-1.427-6.629-1.658-9.473-4.189-10.691-6.021-0.692-1.04-0.943-1.952-1.031-2.534-0.085-0.556-0.04-0.999-0.031-1.073l0.031-0.011c0.017-0.004,4.4-1.235,10.464-1.328,0.239-0.004,0.48-0.006,0.725-0.006,2.927,0,5.808,0.279,8.564,0.83,10.536,2.107,16,10.06,16.053,10.14l0.005,0.009-0.013,0.003c-0.06,0.01-5.08,1.42-12.12,1.42zm29.39-10.68c-1.269,0-2.395-0.463-3.172-1.304-0.639-0.691-1.104-1.643-1.42-2.908-0.506-2.015-0.365-4.002-0.351-4.185,0.526-0.221,1.062-0.342,1.562-0.354l0.112-0.002c2.506,0,4.488,2.179,5.339,4.338,0.468,1.188,0.55,2.208,0.243,3.034-0.31,0.84-1.22,1.38-2.31,1.38zm-22.1-3.03c-0.095-0.023-5.977-1.536-11.967-5.225-5.544-3.413-12.326-9.45-13.153-18.83v-0.005l0.014-0.004c0.001,0,0.516-0.125,1.278-0.154,0.105-0.004,0.217-0.006,0.334-0.006,1.656,0,5.046,0.466,9.147,3.584,5.22,3.98,10.04,10.92,14.35,20.65zm14.43-0.53c-0.037-0.015-4.229-1.693-9.469-6.084-4.882-4.092-11.746-11.46-16.716-23.33,0.003-0.001,1.142-0.608,2.886-0.718,0.101-0.007,0.203-0.009,0.306-0.009,0.15,0,0.305,0.005,0.463,0.009,2.411,0.068,6.083,1.07,10.154,5.463,4.676,5.047,8.85,13.34,12.404,24.651l0.01,0.032-0.03-0.01zm-37.39-1.09c-4.821,0-6.471-2.615-6.957-3.74-0.798-1.849-0.556-3.689-0.554-3.707l0.003-0.02c0.78-0.195,1.605-0.303,2.398-0.314l0.165-0.001c3.799,0,6.798,1.929,8.084,3.841,0.255,0.379,1.037,1.694,0.39,2.721-0.52,0.81-1.7,1.22-3.53,1.22zm-10.68-13.47c-2.692,0-6.811-0.165-11.141-0.952-4.294-0.781-6.728-4.432-8.013-7.356-1.399-3.185-1.794-6.223-1.798-6.254h0.012c13.282,0.39,19.555,4.271,22.478,7.457,3.018,3.29,3.197,6.706,3.206,6.922l-0.009,0.001c-0.02,0-1.89,0.18-4.74,0.18zm13.83-13.82c-0.018-0.022-1.535-1.898-3.033-4.228-1.573-2.445-3.028-4.996-3.028-7.084,0-2.016-0.474-6.266-0.757-8.619-0.358-2.985-0.72-5.54-0.75-5.757l0.013,0.004c0.337,0.123,8.308,3.114,8.308,10.591,0,7.489-0.738,15.014-0.745,15.089l-0.001,0.011h-0.01zm-10.33-0.71c-0.084,0-0.167-0.008-0.25-0.021-2.356-0.393-6.496-2.194-11.073-4.818-5.082-2.914-9.209-6.036-11.62-8.791-2.198-2.512-3.503-6.457-3.88-11.726-0.267-3.739,0.053-6.854,0.087-7.163,0.412-0.137,0.85-0.204,1.315-0.204,1.764,0.029,3.647,0.823,6.189,2.574,1.981,1.365,4.165,3.221,6.49,5.514,4.012,3.957,7.168,7.932,7.199,7.971l0.032,0.04c0.265,0.475,2.537,4.571,4.307,8.558,1.124,2.532,1.767,4.357,2.024,5.746,0.147,0.791,0.19,1.31-0.004,1.781-0.081,0.195-0.235,0.376-0.385,0.448-0.14,0.06-0.28,0.09-0.44,0.09z'/%3E %3Cuse xlink:href='%23branch' transform='matrix(-1,0,0,1,842.178,0)'/%3E %3Cpath fill='%23d47600' d='m698.83,95.476l-2.355,0.938-0.923,0.368-2.854-0.157-2.673,1.283-4.74,3.239-0.209,0.15-1.767,0.461-1.641-0.708-0.932,0.424-0.321,1.92-0.887,1.379-1.092,0.767-3.783,0.387-3.19,1.645-4.15-1.111-1.928,0.755-4.099,3.692-2.095,0.992-0.732-0.042-2.778-0.143-1.173,0.384-1.752,1.693-3.315,0.258-1.033,0.715-1.618,3.26-1.753,1.808-1.003,0.212-1.087-0.398-0.817,0.144-0.37,2.086-0.793,0.874-2.219,0.764-1.773,1.477-1.556,0.799-2.084-0.052h-0.479l-2.076,1.146-3.905,0.342-1.624,1.549-0.358,0.331-0.758,0.458-1.24,0.74-0.304,0.184-1.495-0.267-1.75,0.693-0.708-1.089-1.211,0.727-1.604,0.069-1.998-0.889-1.522-0.678-1.113,0.161-0.387,1.94-0.039,0.206-1.17,1.557-2.184,1.323-0.297,0.387-2.485,3.208-4.722,4.966-3.993,2.028-4.139,1.259-2.897,2.38-7.599,3.767-11.994,5.967-2.453,0.786-3.52,0.562-6.278,2.312-5.539,1.671-0.308,0.094-1.096,0.332-7.81,2.363-3.635-0.384-2.153,0.782-5.605-0.622-3.897,0.077-2.467,0.513-4.637,2.224-7.827,3.762-2.586,2.366-4.027,2.101-4.715,1.493,0.011-1.981-0.028-0.084-1.636,0.517-1.181,0.373-3.825,0.59h-2.128l-1.321-0.384-0.204,0.069-7.818,2.576-8.719,0.842-4.363,1.399-3.26-0.052-2.038,0.607-3.995,0.488-1.428-0.381-0.322-0.088-11.75,0.51-5.372-0.607-2.564,0.583-4.296-1.445-6.269-0.727-1.465-0.439-3.295-0.978-1.491,0.859-1.116,0.119-2.667-0.967-0.96-0.025-2.202,0.796-1.267-0.325-1.177-0.938-2.761-0.411-1.682-1.414-9.402,1.246-2.551-0.75-8.554-2.492-1.361,0.069-1.696,1.271-2.548,0.929-2.212,0.575-3.012,0.105-3.497-0.918-3.606-1.748-1.333-0.317-2.974,0.3-0.91,0.083-5.466-2.932-7.042-4.404-4.778-2.296-1.794-0.291-0.241,0.853,0.89,2.805,0.303,2.774-0.091,2.563-0.049,1.587,0.446,1.425,1.725,1.912,0.719,1.92,0.526,5.284-0.006,5.362-0.839,8.551-0.283,1.302-1.001,4.43-0.914,4.069-3.546,10.833-0.974,1.343-2.391,1.631-5.419,3.688-3.99,2.301-1.263,0.523-3.239,0.245-2.018-0.105-2.513-1.361-2.467-0.635-3.232-2.324-3.595-0.744-3.941-2.278-1.026-1.233-2.146-0.202-2.976-0.893,0.002-0.005-1.093-0.327-0.755-0.22v-0.001l-3.796-0.104-3.54-1.634-1.864-0.45-2.547-0.129-2.666,1.239-0.001-0.004-1.351,0.629-1.707-0.678-1.235,0.077-1.399,2.115-0.209,0.328-0.964,0.51-1.2-0.017-0.939-0.025-1.016,0.444-1.368,0.593v0.003l-1.208,0.527-0.59,0.255-0.01-0.01-0.363,0.073-0.645,0.112-0.8,0.153-1.41-0.824-0.75-0.442-1.257-0.256-0.677,0.489-0.133,2.301-0.618,1.378-1.961,1.734-1.993,1.755-1.389,2.047-3.676,8.39-2.303,3.385-0.715,0.789-2.408,2.656-2.136,1.657-4.922,3.815-4.659,1.741-4.013,0.82-1.951,0.008-3.696-0.492-3.323-1.02-3.65-2.282-4.003-3.217-5.794-5.724-0.82-0.493-0.171-0.114-1.825-1.167-1.354,0.035-0.53,0.874-0.29,1.263-0.245,1.12-0.664,6.367,0.049,0.369,0.349,2.622,4.401,6.15,1.358,3.267,0.223,0.373,0.908,1.525,0.691,1.163,0.069,0.118,1.504,4.488-1.057,2.534,0.534,1.697-1.336,1.037-0.245,1.465,3.951,4.953,0.862,2.185-0.963,3.029-1.536,1.671-0.429,0.457,0.216,1.28,1.818,1.635,3.089,2.75,1.647,4.086,1.253,1.096,1.456-0.31,0.81,0.618,1.228-0.021,1.208,1.208,0.782,0.379,1.236,0.616,0.977,1.272,0.216,3.911,1.822,4.86,0.028,2.635,0.01,0.374,1.134,1.948,0.356,1.538-0.604,4.069,1.445,1.306,1.567-0.32,1.012,0.16,1.626,1.354,1.969,3.001,1.926-0.282,1.222,0.589,5.902,5.334,1.339,0.676,0.074,0.042,0.963,0.483,1.197,1.208,1.856-1.232,0.206-0.021,2.018-0.178,0.886,0.597,1.704,1.149,2.234-0.029,4.844,1.485,2.119,0.543,4.261,2.648,1.811,1.12,1.072,0.871,1.424,1.161,2.845,1.224,2.44,0.584,1.322,0.314,0.995,0.384,0.025-0.062,0.014,0.004-0.024,0.063,5.284,2.023,2.862,0.668,2.648,0.975,1.927,0.703,1.414,0.023,2-1.682,1.937-0.112,1.609,0.401,1.57-0.263,2.485-1.531,0.485-0.719,1.762-0.839,5.944-0.738,1.737,0.564,4.46-1.94,2.988,0.831,2.645-0.938,5.779,1.284,1.536,1.081,1.717,1.965,0.21,0.009,1.912,0.037-0.799,1.331,2.523,2.647,2.279,3.445,0.154,0.455,1.657,4.864,1.232,1.723,0.862,2.405,0.042,1.568-1.34,1.022-0.22,0.583-0.076,0.216,0.272,0.655,0.506-0.276,0.963-0.533,1.166-0.181,2.066,0.22,1.364,0.143,2.154-1.069,1.427-0.71,2.293,0.987,2.52-0.028,1.058,0.471,2.995,1.358,1.529,0.144,0.565-0.371,0.36-0.856-0.185-0.996-1.145-1.323-2.531-2.938-1.036-1.51-0.789-2.186-0.245-2.794-0.174-1.885,0.314-2.477,0.68-0.884,0.5-1.968h0.009l0.129-0.515,1.406-1.866,3.724-2.393,4-3.582,3.162-2.085,3.26-1.412,0.087-0.396,0.363,0.146,8.292-2.819,0.137-0.016,3.692-0.643,24.92,1.755,0.924-0.279,0.004-0.006,0.83-2.33,0.447-0.432,0.297-0.282,2.74-1.206,1.281-0.183,3.556,0.878,1.456,0.359,2.332-1.307,1.654,0.028,3.417-1.866,2.111,0.053,0.803-0.321,4.112-2.955,3.961-1.135,1.03-0.548,0.363-0.199,4.06-2.144,2.579-1.981,2.226-1.183,2.438-0.629,6.38-0.449,1.283-2.138,2.744-0.366,1.657-1.87,1.896-0.771,1.359-1.958,1.139-1.641,1.591-0.921,5.1-0.32,6.045,0.749,0.799-0.485,1.366-4.875,1.43-0.915,3.851-5.612,0.013-2.045,0.004-1.708,0.633-2.432-0.43-4.391,0.51-4.446,2.394-5.65,2.109-2.279,3.401-2.301,1.729-0.753,2.449-0.412v-0.006l0.36-0.061,0.624-0.107,8.433-0.116c0.117-0.087,3.067-0.042,3.067-0.042l2.812-0.038,7.114,1.266,0.506,0.088,2.405,0.779,2.774,2.157,2.936,2.868,0.551,0.535,1.902,0.801,0.575,0.251,1.571-0.251,2.237-1.165,1.688-1.427,2.301-1.257,0.056-0.08,1.295-1.948,0.039-0.04,0.028,0.007,0.003-0.011-0.022-0.005,0.511-0.775,4.447-1.733,5.23-0.304,0.588-0.318,0.327-0.175,1.382-1.623,1.295-0.011,3.135,1.134,2.204-0.437,1.75,0.699,1.36-0.161,2.565-0.304,2.754,1.938,1.605,0.205,5.658,3.31,0.294,0.048,0.152,0.028,0.324,0.053,0.671-0.199,0.998-0.289,0.132-0.039,0.126,0.174,0.643,0.907,0.882,0.126,1.044-1.393-0.415-0.632-0.157-0.23-2.021-0.411-1.815-3.103,1.728-1.861-2.711-3.326-0.45-0.551-0.153-0.234-0.937-1.423-4.746-7.235-6.182-4.935-0.002,0.004-2.165-1.732-0.014-0.01-0.758-0.596-3.302-3.358-2.358-3.13-0.309-0.674-0.487-1.062-1.413-3.078-2.462-1.896-2.006-2.191-0.098-0.129-4.14-5.626-0.68-0.943-0.978-0.565-2.066-0.014-0.195-0.196-0.116-0.121,0.07-0.074,0.991-0.985,1.105-0.278,0.476-1.089-2.108-6.104-0.014-0.213-0.157-1.95,1.718-8.855,0.22-1.079,2.928-5.958,1.814-1.486,1.98-3.892,1.696-2.488,1.625-1.582,0.284-0.168,2.934-1.776,2.465-0.347,2.348-0.331,4.099,1.264,3.901-0.076,0.761-0.081,1.77-0.203,2.911-0.917,1.374-0.848,0.713-1.093,1.487-4.987,0.478-1.587,0.917-1.724,5.306-6.108,4.011-3.71,9.019-6.613,4.415-2.639,2.254-1.347,20.126-8.946,5.23-5.302,2.725-2.757,4.821-3.235,5.641-2.311,4.854-3.842,1.06-1.334,1.336-4.303,1.113-0.269,1.005-2.174,0.286-0.618,3.961-2.792,0.448-0.223,15.388-7.71,2.236,0.307,1.197-1.793,4.477-0.751,0.824-0.14,1.104-0.551,0.939-1.599v-0.316l0.129-4.273,0.956-1.155,0.521-2.816,0.491-0.65,0.513-0.676,1.268-0.891-0.22-0.531z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='500'%3E %3Crect width='1000' height='500' fill='%230021ad'/%3E %3Cpath d='M0,0H1000V500z' fill='%231c8a42'/%3E %3Ccircle cx='500' cy='250' r='90.32' fill='%23ffc639'/%3E %3Cpath fill='%231c8a42' d='m444.84,209.43c6.1786,8.4767,15.542,22.689,23.072,18.979,5.8763,0.0202,8.9102,0.43341,9.7064,4.3442,13.859,2.3586,37.153-3.4875,51.647-22.366,0,0,1.2196,0.16127,0.79627-7.0152,0.0806-3.1246,4.2736-2.4997,4.3744-1.4817,0.5846,1.5522,0.4838,2.7114,1.27,2.7517,1.784-0.59468,4.2233-4.5962,6.2694-7.1362,0.55436-1.1188,0.25198-2.2981,0.38301-3.7092,1.0785-2.6509,3.7697-2.0763,4.3341-0.68539,0.51404,0.89706,0.52412,1.5825,1.0281,2.4795,2.7315,1.8244,7.6603,0.12095,8.0433,0.12095,0.48381-2.2275,1.9151-2.0159,1.9151-2.0159,1.8244-0.40317,1.1087-0.24191,2.3082,0.38302-1.0583,12.005,2.3586,12.539,2.0764,18.697,0.12095,6.8741-2.0764,8.8295-2.0764,11.45,0.69548,3.2052,10.835,3.3161,7.2672,6.0275-3.1347,1.6732,0.0101,4.8078-4.7071,6.0275-13.728,6.9648-16.359,12.942-16.359,12.942s-3.4471,6.5113-3.8302,6.5113c-2.2981,4.3442-5.211,1.9756-6.8338,4.0922-0.80635,2.661-1.7135,8.5574-0.1008,11.622,0.80635,4.2132-0.10079,6.5113-1.1087,10.724-0.90714,8.7892-4.3946,10.12-4.7978,13.204-1.6127,3.296,0.3427,18.778-1.1894,18.778-10.22,0.20159-18.052-1.9554-22.094-2.7617,3.941-16.984,2.409-31.901,2.409-33.433-1.0079-12.146-18.193-9.1924-20.824-10.805-2.1772-0.46366-3.5479-2.2376-4.314-3.0036-2.4291-0.26207-3.3363-0.81643-5.7654-1.0684-1.2095,0.60477-0.48381,1.2297-3.1851,2.0663-6.854,0.82651-9.8778-5.9771-9.8778-5.9771,0.33262-2.288-15.411,0.46365-23.969-1.522-3.5076,1.9554-5.0397,7.741-7.9123,8.4263-0.0806,1.7941-4.7272-1.4716-5.6646-3.2355-0.19151-5.1304,4.4752-7.3982,4.4752-7.3982,3.7092-2.6106,5.9065-3.0339,7.6906-4.8381,0.89706-4.4652,0.44349-7.7712,2.3485-11.128,1.6127-2.5602,3.9914-1.3607,5.6041-2.5098,1.7336-1.149,2.4694-8.6682,0.86683-10.724,0,0-6.9346-6.2593-7.3176-6.6423-2.2578-6.4709,2.6408-10.644,4.0418-10.17z'/%3E %3Cpath fill='%23ffc639' d='m877.93,97.555c-4.0922-16.194-40.721-51.071-68.247-73.265-6.5717-4.4773-10.855-1.8103-9.9987,4.573,3.427,5.716,5.9972,12,9.4242,17.716,0.95754,3.81,2.7618,6.477,3.7193,10.286,0,0,0.28222,6.5728,0.85674,7.1442,8.5675,9.4333,9.7165,17.432,9.7165,17.432,4.949,9.526,9.3335,16.478,18.002,24.29,9.7165,6.098,2.5702,25.047,2.8525,35.147,0,6.3802-4.566,5.6243-8.5674,4.8582-31.528-28.958-62.774-29.049-90.301-37.435-10.765-1.139-10.956,4.0015-7.4285,6.854,19.242,20.582,37.334,34.582,61.151,46.294,4.0015,2.4795,8.003,4.959,12.005,7.4386,4.566,3.81,9.142,7.62,13.708,11.43,10.573,6.854,11.44,13.143,11.44,13.708,0.28222,12.861-6.5818,22.86-8.5775,26.861-3.6084,13.637-10.855,16.006-10.855,16.006-58.874,39.723-89.737,50.004-185.18,37.717-1.4313-0.75595-10.573,0.76603,0,4.576,24.291,8.0937,83.961,21.076,141.69-6.2593,13.859-9.7165,23.132-6.5314,33.171-12.347,16.49-10.17,40.035-22.83,44.319-24.251,12.861-6.864,48.865-14.575,57.16-21.439,9.5149-0.76603,19.393-2.0159,20.058-10.2,3.1246-2.026,7.7006-0.54428,11.097-7.2168,7.5494-1.3103,6.2794-4.0116,6.2794-4.0116-1.905-5.332-8.9606-7.5293-14-11.43-7.4386-2.4795-12.579-3.2456-18.012-0.57452-1.7135,0.76603-3.427,1.522-5.1405,2.288,0,0-8.003-1.149-8.003-1.7135-17.78-0.9777-16.046-59.902-22.336-84.478z'/%3E %3Cpath fill='%231c8a42' d='m919.63,194.01a4.4025,2.7511,15.947,0,1,-8.3961,-2.6368,4.4025,2.7511,15.947,0,1,8.3961,2.6368z'/%3E %3Cg fill='%23fff'%3E %3Cpath id='s' d='m188.16,190.94-12.751-11.936-12.904,11.77,1.383-17.405-17.249-2.753,14.475-9.7743-8.6056-15.197,16.668,5.2197,6.5177-16.204,6.3099,16.287,16.734-5.0072-8.8005,15.086,14.348,9.959-17.283,2.5313,1.1585,17.424z'/%3E %3Cpath d='m233.39,335.53-13.752-9.1669-13.391,9.6641,4.7117-15.568-13.582-9.4155,16.667-0.44539,4.9883-15.496,5.5945,15.299,16.667-0.15537-13.21,9.9023,5.3073,15.382z'/%3E %3Cuse xlink:href='%23s' x='2.5215' y='269.0608'/%3E %3Cuse xlink:href='%23s' x='-112.0655' y='123.2228'/%3E %3Cuse xlink:href='%23s' x='108.4275' y='85.0268'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 54 36'%3E %3Crect width='54' height='36' fill='%23002b7f'/%3E %3Cpath d='M0,22.5H54V27H0z' fill='%23f9e814'/%3E %3Cg fill='%23fff' id='s'%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='m12,8v4h2z' transform='rotate(18,12,8)' id='o'/%3E %3Cuse xlink:href='%23o' x='-24' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72,12,12)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72,12,12)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144,12,12)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' x='-4' y='-4' transform='scale(0.75)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='510' height='300'%3E %3Crect width='510' height='300' fill='%23003893'/%3E %3Crect width='510' height='75' y='150' fill='%23fff'/%3E %3Crect width='510' height='25' y='175' fill='%23cf2027'/%3E %3Cg fill='%23f7d116' transform='translate(191.25,187.5)'%3E %3Cg id='s2'%3E %3Cg id='s' transform='translate(0,-75)'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-15V0H7.5' transform='rotate(18,0,-15)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' y='150'/%3E %3C/g%3E %3Cuse xlink:href='%23s2' transform='rotate(72)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(144)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(216)'/%3E %3Cuse xlink:href='%23s2' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' width='800' height='400'%3E %3Cpath d='M0,0h800v400H0z' fill='%23002a8f'/%3E %3Cpath d='M0,80h800v80H0v80h800v80H0z' fill='%23fff'/%3E %3Cpath d='M346.4,200L0,0v400z' fill='%23cf142b'/%3E %3Cpath d='M115.5,140l35.35,108.5 l-92.5-67h114.2l-92.5,67z' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='1000' height='600' viewBox='0 0 10 6'%3E %3Cpath d='M0,0h10v6H0z' fill='%23002b7f'/%3E %3Cpath d='M0,1h10v4H0z' fill='%23fff'/%3E %3Cpath d='M0,2h10v2H0z' fill='%23ce1126'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 6 4'%3E %3Crect fill='%23CE1126' width='6' height='4'/%3E %3Crect fill='%23003893' width='6' height='3'/%3E %3Crect fill='%23FCD116' width='6' height='2'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600' viewBox='0 0 30 20'%3E %3Cdefs%3E %3Cpath id='s' d='M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z' fill='%23ffde00'/%3E %3C/defs%3E %3Crect width='30' height='20' fill='%23de2910'/%3E %3Cuse xlink:href='%23s' transform='translate(5,5) scale(3)'/%3E %3Cuse xlink:href='%23s' transform='translate(10,2) rotate(23.036243)'/%3E %3Cuse xlink:href='%23s' transform='translate(12,4) rotate(45.869898)'/%3E %3Cuse xlink:href='%23s' transform='translate(12,7) rotate(69.945396)'/%3E %3Cuse xlink:href='%23s' transform='translate(10,9) rotate(20.659808)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='400' viewBox='0 0 90 60'%3E %3Crect width='30' height='60' fill='%23007a5e'/%3E %3Crect x='30' width='30' height='60' fill='%23ce1126'/%3E %3Crect x='60' width='30' height='60' fill='%23fcd116'/%3E %3Cg transform='translate(45,30)' fill='%23fcd116'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-8 v 8 h 4 z' transform='rotate(18 0,-8)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1500' height='1000' viewBox='-4 -4 24 16'%3E %3Cpath d='M20,12H-4V-4H20z' fill='%23d52b1e'/%3E %3Cpath d='M4,4H20V-4H-4z' fill='%23fff'/%3E %3Cpath d='M4,4H-4V-4H4z' fill='%230039a6'/%3E %3Cg id='f'%3E %3Cg id='t'%3E %3Cpath d='M0,-2V0H1z' fill='%23fff' transform='rotate(18,0,-2)' id='o'/%3E %3Cuse xlink:href='%23o' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(72)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23f' transform='rotate(144)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300'%3E %3CclipPath id='cp'%3E %3Cpath d='M0,0V75H350V150H300zM300,0H150V200H0V150z'/%3E %3C/clipPath%3E %3Crect width='600' height='300' fill='%2300247d'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23fff' stroke-width='30'/%3E %3Cpath d='M0,0L300,150M300,0L0,150' stroke='%23cf142b' stroke-width='20' clip-path='url(%23cp)'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23fff' stroke-width='50'/%3E %3Cpath d='M150,0V200M0,75H350' stroke='%23cf142b' stroke-width='30'/%3E %3Cpath d='M300,0V150H0V300H600V0z' fill='%2300247d'/%3E %3Cg transform='translate(450,150)'%3E %3Cg id='s1' transform='translate(0,-102)' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' d='M0,-22.5V0H12' transform='rotate(18,0,-22.5)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3Cg id='s7'%3E %3Cuse xlink:href='%23s1' transform='rotate(24)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(48)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(72)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(96)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(120)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(144)'/%3E %3Cuse xlink:href='%23s1' transform='rotate(168)'/%3E %3C/g%3E %3Cuse xlink:href='%23s7' transform='rotate(168)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300'%3E %3Crect fill='%23009E60' width='450' height='300'/%3E %3Crect fill='%23FFF' width='300' height='300'/%3E %3Crect fill='%23F77F00' width='150' height='300'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='320' height='320'%3E %3Crect fill='%23D52B1E' height='320' width='320'/%3E %3Crect fill='%23fff' height='60' width='200' x='60' y='130'/%3E %3Crect fill='%23fff' height='200' width='60' x='130' y='60'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 3 2'%3E %3Crect id='green_area' width='3' height='2' fill='%23009543'/%3E %3Cpath id='yellow_area' d='M 0 2 L 2 0 h 1 v 2 z' fill='%23FBDE4A'/%3E %3Cpath id='red_area' d='M 3 0 v 2 h -2 z' fill='%23DC241F'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 450 300'%3E %3Crect fill='%23FFCE00' width='450' height='300'/%3E %3Crect fill='%23289728' width='450' height='225'/%3E %3Crect fill='%23FFFFFF' width='450' height='150'/%3E %3Crect fill='%23003082' width='450' height='75'/%3E %3Crect x='187.5' fill='%23D21034' width='75' height='300'/%3E %3Cpath fill='%23FFCE00' d='M75.028,7.004L94.9,67.996L42.902,30.333h64.197L55.1,67.996L75.028,7.004z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='800' height='600'%3E %3Crect width='800' height='600' x='0' y ='0' style='fill:%23007fff' /%3E %3Cpath d='m 36,120 84,0 26,-84 26,84 84,0 -68,52 26,84 -68,-52 -68,52 26,-84 -68,-52 z M 750,0 0,450 0,600 0,600 50,600 800,150 800,0 750,0' style='fill:%23f7d618' /%3E %3Cpath d='M 800,0 0,480 0,600 0,600 0,600 800,120 800,0' style='fill:%23ce1021' /%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='600' height='300' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3C/defs%3E %3Crect width='10080' height='5040' fill='%23008000'/%3E %3Ccircle cx='5040' cy='2520' r='1050' fill='%23ffe000'/%3E %3Ccircle cx='5367.4' cy='2520' r='864' fill='%23008000'/%3E %3Ccircle cx='1730' cy='1470' r='1100' fill='%23ffe000'/%3E %3Cpath fill='%23802000' stroke='%237b3100' stroke-width='23.333' d='m1654.1,2299.4,274.67,0s12.398-25.178-2.7658-37.767-74.229-15.36-58.271-59.892c32.807-91.555,37.385-63.326,57.985-280.77s30.518-558.49,30.518-558.49h-39.674s7.6296,106.05-15.259,244.15-29.755,150.3-54.933,256.35-28.992,115.21-51.881,177.01-25.178,64.852-61.037,122.07c-35.859,57.222-22.889,35.859-42.726,70.192-9.9186,17.166-22.126,12.589-28.802,25.082-6.6759,12.494-7.8204,42.058-7.8204,42.058z'/%3E %3Cpath fill='%23008000' d='m1863.7,668.6c2.2817,42.661-2.0069,99.138-19.688,145.1-17.928,51.216-37.423,102.27-36.458,155.31-28.502,9.6945-57.877-61.678-85.312-19.688,20.624,58.016,68.239,103.95,100.86,156.22,5.5021,16.205,52.438,58.518,25.281,68.358-68.547-23.46-85.162-110.31-127.68-163.05-49.38-88.757-141.44-151.49-244-155.82-38.524,1.0094-163.78-9.548-131.19,56.419,47.997,32.632,107.14,53.91,154.53,90.537,35.31,3.3032,99.31,62.248,95.579,84.52-62.102-25.153-91.169-55.299-158.08-81.758-90.658-35.014-216.06-13.954-266.25,76.021-9.3572,23.433-23.172,91.731,6.2547,98.238,34.384-53.685,83.569-113.7,156.45-97.6,57.244,4.4692-63.877,106.64-17.544,86.084,14.681-6.5147,48.583-28.769,72.102-31.093,23.518-2.324,36.653,15.282,54.497,17.718,35.688,4.8718,45.515,19.833,42.207,28.537-3.9027,10.269-15.241,1.5013-51.52,13.004-18.14,5.7513-27.615,21.692-48.774,28.989-21.158,7.2976-65.173,7.8148-81.621,1.3436-57.547-24.996-151.89-20.645-169.83,51.468-0.016,31.711-28.236-3.5038-41.278,10.196-9.7795,34.603-12.309,70.132-63.633,66.99-31.155,32.684-63.06,66.527-102.62,89.781,23.215,53.284,115.2-53.516,110.9-8.4838-40.21,54.832,20.689,66.37,47.348,24.166,45.088-47.64,100.93-105.63,168.21-57.618,32.044,30.169,50.664-15.951,73.857-13.481,14.612,37.475,32.998,1.8444,49.583-8.75,27.15-3.3824,19.511,33.91,51.771,10.938,64.293-42.551,143.39-6.796,206.2-48.197,66.852-30.458,9.3858,24.532-9.0659,46.028-29.373,56.97-3.8997,131.76-67.613,167.14-25.593,67.895,30.237,157.4-26.707,207.63-8.2836,31.496,73.234,27.889,96.113,40.832,40.09,1.5876-1.7229-91.758,38.054-104.27,53.344,33.019,50.846-59.049,39.831-87.447,5.1712-64.552,8.8142-135.13,40.892-193.6,34.102-71.662,65.666,29.186,27.491,57.558-21.685,65.896-53.25,148.36-3.9423,209.64,14.211,3.1803,25.879,37.625,44.279,48.212s43.531-2.6843,48.118-34.022c23.601-94.369,11.712-195.85,45.415-287.63,23.788-28.43,56.603-4.584,71.355,21.559,47.23,54.833,80.43,123.38,137.61,168.56,52.063,24.362,98.106,61.211,122.1,114.81-0.3209,41.353,117.45,47.692,82.258,1.7272-33.768-44.747-11.488-89.504,22.715-119.26,18.318,4.5181,12.904-28.289-1.4583-15.312-22.995-5.4244-24.466-47.512,7.4967-27.507,53.836,17.379-4.197-38.962-23.655-40.69-45.52-28.215-97.819-60.676-120.2-109.72,59.256,0.6043,120.77,32.564,181.32,12.74,48.538-24.937,97.769,2.0801,114.72,44.864,37.52-5.9873,21.524-43.614,0-56.146,27.443-11.325,46.422-34.805,13.147-55.515-17.574-22.934,23.566-62.052-27.001-60.422,1.6515-38.627-13.556-73.973-55.66-87.318-42.178-35.717-165.95,52.62-162.36-27.89-12.471-43.818,50.278-5.8539,67.812-27.708,18.118-46.194-86.337-41.686-51.87-77.5,22.511-14.494,128.15-35.314,45.306-50.82-41.347,11.364-76.832,2.9489-109.37-17.513-29.657,49.603-114.34-26.938-99.252,61.251-11.585,33.23-87.278,119.57-107.76,53.423,17.422-51.845,107.1-68.797,79.291-138.7-4.2682-43.636-40.446,7.5887-57.49,4.335-8.6308-27.162,26.103-59.178,50.312-65.625,48.038,36.948,49.493-46.614,95.178-39.816,33.355-7.4109-10.771-21.718-20.074-27.996,9.1407-24.416,60.346-36.892,10.136-58.094-44.302-32.872-77.138,32.72-113.68,36.218-35.072-39.595,31.842-58.628,50.312-79.479,0.9929-15.543-39.017-4.6894-26.979-18.229,10.456-18.69,81.301-20.081,48.125-48.125-49.965-17.153-114.44-12.876-162.38,9.3461-30.203,9.7774-39.089,78.069-65.122,75.237-12.24-30.398,3.9853-90.372-37.917-99.167zm236.25,667.19c38.072-6.447,0.8081,57.818-17.5,56.875,1.6178-23.092-55.065-20.869-19.897-40.988,11.405-7.3645,24.112-12.982,37.397-15.887z'/%3E %3Cg fill='%23ffe000'%3E %3Cuse xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E%3Crect width='1000' height='500' fill='%23f00'/%3E%3Crect width='500' height='500' fill='%23fff' x='250'/%3E%3Cpath fill='%23ff0000' d='m 499.99228,46.875 -34.11312,63.62529 c -3.87086,6.91501 -10.80627,6.27363 -17.74169,2.41138 l -24.69699,-12.78858 18.40705,97.72711 c 3.87086,17.85419 -8.54859,17.85419 -14.67765,10.13435 l -43.10105,-48.25099 -6.99738,24.503 c -0.80692,3.21777 -4.35481,6.59744 -9.67748,5.79261 l -54.50177,-11.45912 14.31524,52.04475 c 3.06451,11.58054 5.4549,16.37528 -3.09375,19.42959 l -19.42619,9.13025 93.82127,76.20838 c 3.7135,2.88151 5.58971,8.067 4.26768,12.7621 l -8.21136,26.94707 c 32.30405,-3.72371 61.24898,-9.32594 93.56939,-12.77619 2.85323,-0.30459 7.62988,4.40408 7.61029,7.71058 l -4.28024,98.72342 15.70639,0 -2.47237,-98.5117 c -0.0197,-3.3065 4.31372,-8.22689 7.16695,-7.9223 32.32041,3.45026 61.26538,9.05248 93.56942,12.77619 l -8.21134,-26.94707 c -1.32203,-4.6951 0.55417,-9.88059 4.26767,-12.7621 l 93.82125,-76.20838 -19.42617,-9.13025 c -8.54867,-3.05431 -6.15828,-7.84905 -3.09377,-19.42959 l 14.31527,-52.04475 -54.5018,11.45912 c -5.32267,0.80483 -8.87056,-2.57484 -9.6775,-5.79261 l -6.99737,-24.503 -43.10103,48.25099 c -6.12908,7.71984 -18.54854,7.71984 -14.67768,-10.13435 l 18.40702,-97.72711 -24.69694,12.78858 c -6.93559,3.86225 -13.87083,4.50363 -17.7417,-2.41138'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='750' height='500'%3E %3Cdefs%3E %3CradialGradient id='white_skin'%3E %3Cstop stop-color='%23ffef5d' offset='0'/%3E %3Cstop stop-color='%23ea5700' offset='1'/%3E %3C/radialGradient%3E %3CradialGradient id='black_skin'%3E %3Cstop stop-color='%23952d1a' offset='0'/%3E %3Cstop stop-color='%23570a00' offset='1'/%3E %3C/radialGradient%3E %3C/defs%3E %3Crect width='750' height='500' fill='%23ce1126'/%3E %3Crect width='750' height='428.57' y='35.714' fill='%23003f87'/%3E %3Ccircle cx='375' cy='250' r='196.429' fill='%23fff'/%3E %3Cg id='leaves'%3E %3Ccircle cx='375' cy='249' r='162.812' fill='none' stroke='%23552300' stroke-width='4.103'/%3E %3Cg fill='%23007f00'%3E %3Cpath d='m356.19,76.241c14.725-15.798,28.039,2.4507,27.684,11.002-0.3554,8.551-15.207,27.416-28.646,12.234,13.922,3.5647,18.083-12.003,25.125-12.157-7.0412,0.1553-9.9194-15.259-24.163-11.078z'/%3E %3Cpath d='m202.92,200.12c-7.7422-20.102,14.644-23.856,22.208-19.751,7.5668,4.1055,18.021,25.681-1.648,30.908,9.3905-10.806-2.8239-21.409,0.15681-27.741-2.9807,6.3319-18.179,2.0599-20.717,16.585z'/%3E %3Cpath d='m533.28,180.24c20.168,7.9048,7.8468,26.827-0.31445,29.594-8.1602,2.7672-31.256-4.1438-21.861-22.074,1.6914,14.171,17.821,12.387,20.515,18.846-2.696-6.4591,10.741-14.701,1.6598-26.366z'/%3E %3Cpath d='m269.58,393.14c-21.576-2.1447-14.921-23.685-7.8322-28.556,7.091-4.8715,31.211-4.4746,27.099,15.318-5.5216-13.174-20.548-7.0918-24.915-12.576,4.3657,5.484-6.2951,17.05,5.6483,25.814z'/%3E %3Cpath d='m487.64,377.55c0.30792,21.517-22.013,17.408-27.698,10.973-5.6837-6.4355-8.0314-30.262,12.251-28.463-12.559,6.9449-4.7606,21.069-9.7539,25.998,4.9946-4.9288,17.788,4.2661,25.201-8.5071z'/%3E %3Cpath d='m218.64,159.24c-1.9676-21.431,20.606-19.029,26.768-13.044,6.1629,5.985,10.342,29.564-10.021,29.31,11.99-7.8783,3.1238-21.369,7.7226-26.663-4.5986,5.2951-18.063-2.9011-24.47,10.398z'/%3E %3Cpath d='m241.76,360.29c-21.382-3.5869-13.276-24.631-5.8711-29.018,7.4053-4.3845,31.444-2.3722,25.994,17.1-4.6126-13.517-20.019-8.4531-24.003-14.218,3.9841,5.7662-7.4394,16.593,3.8795,26.135z'/%3E %3Cpath d='m410.72,77.127c19.418-9.5784,25.333,12.174,21.94,20.043-3.3906,7.8684-24.026,20.269-31.157,1.3374,11.738,8.2404,21.201-4.8453,27.839-2.5074-6.6376-2.3379-3.812-17.762-18.622-18.873z'/%3E %3Cpath d='m452.04,404.49c-9.6263,19.283-27.594,5.5118-29.689-2.7897-2.0948-8.3027,6.78-30.564,23.996-19.769-14.369,0.4845-13.93,16.586-20.64,18.708,6.7098-2.1223,13.861,11.854,26.333,3.8502z'/%3E %3Cpath d='m546.33,218.38c16.316,14.177-1.7046,27.883-10.325,27.764-8.6232-0.11792-28.03-14.337-13.104-28.086-3.2108,13.909,12.583,17.614,12.931,24.595-0.34923-6.9808,15.097-10.257,10.498-24.273z'/%3E %3Cpath d='m272.4,105.04c4.8689-20.971,25.559-11.699,29.535-4.1028,3.9742,7.5954,0.52937,31.289-18.735,24.743,13.866-3.7717,9.6858-19.334,15.718-22.939-6.033,3.6047-16.249-8.3527-26.517,2.2992z'/%3E %3Cpath d='m208.27,284.73c-19-10.373-4.3648-27.596,4.0818-29.318,8.4457-1.7219,30.477,8.033,18.871,24.64,0.12873-14.266-16.099-14.523-17.948-21.267,1.8494,6.7447-12.528,13.235-5.0055,25.945z'/%3E %3Cpath d='m482.8,118.48c21.462-3.0857,20.24,19.412,14.544,25.837-5.6962,6.4248-29.2,11.816-30.023-8.3775,8.5614,11.464,21.665,1.9624,27.238,6.2392-5.5702-4.2766,1.9632-18.055-11.759-23.698z'/%3E %3Cpath d='m360.73,425.12c-19.798,8.7796-24.808-13.195-21.094-20.92,3.7135-7.7222,24.846-19.272,31.186-0.066-11.388-8.7111-21.384,3.9768-27.919,1.3715,6.5354,2.6044,3.0754,17.899,17.827,19.614z'/%3E %3Cpath d='m538.37,305.08c8.9398,19.606-13.18,24.682-20.979,21.034-7.7997-3.6483-19.538-24.565-0.21646-30.949-8.7227,11.342,4.1096,21.201,1.5145,27.699,2.5954-6.4987,18.024-3.1351,19.681-17.783z'/%3E %3Cpath d='m199.66,241.93c-12.438-17.629,8.355-26.675,16.7-24.519,8.3453,2.155,23.778,20.558,5.978,30.377,6.4598-12.748-7.988-20.083-6.6474-26.945-1.3413,6.8604-17.129,6.3866-16.031,21.087z'/%3E %3Cpath d='m316.63,412.08c-20.35,7.4333-23.854-14.831-19.622-22.286,4.2319-7.4571,26.1-17.562,31.12,2.0239-10.77-9.455-21.604,2.5349-27.949-0.50364,6.3434,3.0365,1.8485,18.064,16.451,20.765z'/%3E %3Cpath d='m310.76,84.939c12.058-17.887,28.08-1.9258,29.076,6.5749,0.99594,8.5009-10.703,29.437-26.369,16.525,14.312,1.3628,15.973-14.659,22.903-15.902-6.9308,1.2424-12.2-13.535-25.61-7.1978z'/%3E %3Cpath d='m519.27,347.62c1.3017,21.482-21.187,18.39-27.16,12.218-5.9754-6.171-9.4198-29.868,10.927-28.989-12.229,7.5055-3.7863,21.262-8.5468,26.412,4.7613-5.1492,17.965,3.4549,24.78-9.641z'/%3E %3Cpath d='m513.74,145.08c21.257,4.2586,12.48,25.038,4.9383,29.187-7.5416,4.1491-31.503,1.3792-25.433-17.913,4.1754,13.655,19.738,9.0811,23.535,14.969-3.7956-5.8864,7.969-16.347-3.0401-26.243z'/%3E %3Cpath d='m244.54,129.94c0.20546-21.52,22.423-16.885,27.95-10.317,5.5281,6.5692,7.3058,30.445-12.929,28.166,12.723-6.6462,5.2638-20.95,10.374-25.761-5.1098,4.811-17.679-4.6825-25.395,7.9121z'/%3E %3Cpath d='m217.66,323.91c-19.346-9.7227-5.311-27.431,3.0719-29.438,8.3832-2.0056,30.735,6.9965,19.708,23.987-0.36375-14.264-16.59-13.969-18.669-20.648,2.0802,6.6789-12.066,13.651-4.1108,26.099z'/%3E %3Cpath d='m450,94.806c20.287-7.5997,23.976,14.632,19.809,22.124-4.1688,7.4921-25.952,17.778-31.136-1.7668,10.848,9.3657,21.584-2.7129,27.952,0.27353-6.3698-2.9872-2.0005-18.051-16.625-20.631z'/%3E %3Cpath d='m406.94,422.71c-15.777,14.795-27.803-4.2965-26.862-12.805,0.94167-8.5102,17.054-26.357,29.418-10.32-13.645-4.4746-18.865,10.787-25.902,10.475,7.037,0.30977,8.8493,15.882,23.345,12.65z'/%3E %3Cpath d='m545.18,258.13c14.802,15.728-4.5106,27.572-13.077,26.598-8.567-0.97341-26.442-17.053-10.202-29.248-4.5982,13.52,10.741,18.778,10.382,25.758,0.3591-6.981,16.059-8.7056,12.897-23.108z'/%3E %3C/g%3E %3Cg fill='%23005800'%3E %3Cpath d='M355.23,99.477c13.92,3.563,17.41-11.815,24.45-11.969-4.11,4.909-14.83,17.422-24.45,11.969z'/%3E %3Cpath d='m356.19,76.241c14.725-15.798,28.039,2.4507,27.684,11.002-11.95-20.833-15.69-17.62-27.68-11.002z'/%3E %3Cpath d='m223.48,211.27c9.3905-10.806-2.9519-20.727,0.0279-27.06,2.6138,5.8324,9.1602,20.92-0.0279,27.06z'/%3E %3Cpath d='m202.92,200.12c-7.7422-20.102,14.644-23.856,22.208-19.751-24.115,1.3999-22.87,6.1503-22.208,19.751z'/%3E %3Cpath d='m511.11,187.76c1.6914,14.171,17.4,11.833,20.094,18.291-6.0994-2.0263-21.734-7.4196-20.094-18.291z'/%3E %3Cpath d='m533.28,180.24c20.168,7.9048,7.8468,26.827-0.31445,29.594,15.24-18.601,10.869-20.896,0.31445-29.594z'/%3E %3Cpath d='m288.85,379.91c-5.5212-13.175-19.992-6.6743-24.358-12.158,6.424,0.29832,22.948,1.2555,24.358,12.158z'/%3E %3Cpath d='m269.58,393.14c-21.576-2.1447-14.921-23.685-7.8322-28.556-9.5509,22.019-4.7128,23.044,7.8322,28.556z'/%3E %3Cpath d='m472.19,360.06c-12.559,6.9449-4.4041,20.473-9.3974,25.402-0.43343-6.3686-1.3565-22.769,9.3974-25.402z'/%3E %3Cpath d='m487.64,377.55c0.30792,21.517-22.013,17.408-27.698,10.973,23.133,6.9103,23.61,2.0234,27.698-10.973z'/%3E %3Cpath d='m235.39,175.5c11.99-7.8777,2.8118-20.747,7.412-26.041,0.92366,6.3177,3.1083,22.6-7.412,26.041z'/%3E %3Cpath d='m218.64,159.24c-1.9676-21.431,20.606-19.029,26.768-13.044-23.597-5.1329-23.694-0.2253-26.768,13.044z'/%3E %3Cpath d='m261.88,348.37c-4.6118-13.515-19.492-7.9979-23.476-13.762,6.3881,0.72693,22.81,2.7896,23.476,13.762z'/%3E %3Cpath d='m241.76,360.29c-21.382-3.5869-13.276-24.631-5.8711-29.018-11.026,21.332-6.2714,22.678,5.8711,29.018z'/%3E %3Cpath d='m401.51,98.508c11.738,8.2404,20.506-4.906,27.143-2.5684-5.5987,3.14-20.103,11.055-27.143,2.5684z'/%3E %3Cpath d='m410.72,77.127c19.418-9.5784,25.333,12.174,21.94,20.043-3.7188-23.688-8.364-22.003-21.94-20.043z'/%3E %3Cpath d='m446.35,381.93c-14.369,0.4845-13.339,16.217-20.048,18.338,2.544-5.8613,9.2688-20.871,20.048-18.338z'/%3E %3Cpath d='m452.04,404.49c-9.6263,19.283-27.594,5.5118-29.689-2.7897,17.401,16.631,20.072,12.501,29.689,2.7897z'/%3E %3Cpath d='m522.9,218.06c-3.2108,13.909,12.375,16.952,12.723,23.933-5.0562-3.9438-17.952-14.243-12.723-23.933z'/%3E %3Cpath d='m546.33,218.38c16.316,14.177-1.7046,27.883-10.325,27.764,20.656-12.427,17.317-16.049,10.325-27.764z'/%3E %3Cpath d='m283.2,125.68c13.866-3.7717,9.1965-18.839,15.23-22.445-1.1105,6.2874-4.1537,22.434-15.23,22.445z'/%3E %3Cpath d='m272.4,105.04c4.8689-20.971,25.559-11.699,29.535-4.1028-20.806-12.184-22.441-7.5529-29.535,4.1028z'/%3E %3Cpath d='m231.22,280.05c0.12854-14.267-15.753-13.92-17.6-20.664,5.7918,2.7734,20.614,10.085,17.6,20.664z'/%3E %3Cpath d='m208.27,284.73c-19-10.373-4.3648-27.596,4.0818-29.318-17.488,16.54-13.445,19.366-4.0818,29.318z'/%3E %3Cpath d='m467.32,135.94c8.5614,11.464,21.025,1.689,26.596,5.9648-6.3073,1.2503-22.577,4.2785-26.596-5.9648z'/%3E %3Cpath d='m482.8,118.48c21.462-3.0857,20.24,19.412,14.544,25.837,3.9152-23.657-1.0279-23.493-14.544-25.837z'/%3E %3Cpath d='m370.82,404.14c-11.388-8.7111-20.692,4.0668-27.226,1.4586,5.7249-2.9075,20.544-10.226,27.226-1.4586z'/%3E %3Cpath d='m360.73,425.12c-19.798,8.7796-24.808-13.195-21.094-20.92,2.7366,23.82,7.4485,22.324,21.094,20.92z'/%3E %3Cpath d='m517.17,295.17c-8.7224,11.344,4.1973,20.516,1.6022,27.014-2.959-5.6678-10.404-20.339-1.6022-27.014z'/%3E %3Cpath d='m538.37,305.08c8.9398,19.606-13.18,24.682-20.979,21.034,23.99-2.8304,22.459-7.4984,20.979-21.034z'/%3E %3Cpath d='m222.34,247.79c6.4598-12.748-7.9446-19.392-6.6042-26.253,3.9612,5.0267,14.011,18.08,6.6042,26.253z'/%3E %3Cpath d='m199.66,241.93c-12.438-17.629,8.355-26.675,16.7-24.519-23.048,7.1806-20.675,11.487-16.7,24.519z'/%3E %3Cpath d='m328.12,391.82c-10.77-9.455-20.921,2.6694-27.263-0.36673,5.9091-2.5197,21.192-8.8282,27.263,0.36673z'/%3E %3Cpath d='m316.63,412.08c-20.35,7.4333-23.854-14.831-19.622-22.286,1.1087,23.948,5.9109,22.773,19.622,22.286z'/%3E %3Cpath d='m313.47,108.04c14.312,1.3629,15.338-14.369,22.268-15.613-3.2857,5.4866-11.91,19.508-22.268,15.613z'/%3E %3Cpath d='m310.76,84.939c12.058-17.887,28.08-1.9258,29.076,6.5749-15.089-18.723-18.276-14.97-29.076-6.5749z'/%3E %3Cpath d='m503.03,330.85c-12.229,7.5055-3.4571,20.65-8.2188,25.801-0.72619-6.3423-2.4047-22.684,8.2188-25.801z'/%3E %3Cpath d='m519.27,347.62c1.3017,21.482-21.187,18.39-27.16,12.218,23.427,5.8525,23.677,0.95221,27.16-12.218z'/%3E %3Cpath d='m493.24,156.35c4.1763,13.654,19.227,8.6096,23.023,14.497-6.3616-0.92834-22.709-3.5075-23.023-14.497z'/%3E %3Cpath d='m513.74,145.08c21.257,4.2586,12.48,25.038,4.9383,29.187,11.708-20.971,6.9971-22.467-4.9383-29.187z'/%3E %3Cpath d='m259.57,147.78c12.723-6.6462,4.8939-20.363,10.002-25.173,0.28139,6.3765,0.81212,22.795-10.002,25.173z'/%3E %3Cpath d='m244.54,129.94c0.20546-21.52,22.423-16.885,27.95-10.317-22.959-7.4535-23.552-2.5797-27.95,10.317z'/%3E %3Cpath d='m240.44,318.46c-0.36376-14.264-16.222-13.379-18.303-20.056,5.8837,2.5758,20.949,9.3825,18.303,20.056z'/%3E %3Cpath d='m217.66,323.91c-19.346-9.7227-5.311-27.431,3.0719-29.438-16.91,17.121-12.771,19.808-3.0719,29.438z'/%3E %3Cpath d='m438.67,115.16c10.848,9.3657,20.896-2.8423,27.266,0.14355-5.8878,2.5682-21.119,9.002-27.266-0.14355z'/%3E %3Cpath d='m450,94.806c20.287-7.5997,23.976,14.632,19.809,22.124-1.3118-23.94-6.1016-22.724-19.809-22.124z'/%3E %3Cpath d='m409.5,399.59c-13.645-4.4746-18.182,10.643-25.216,10.331,4.4355-4.6275,15.994-16.407,25.216-10.331z'/%3E %3Cpath d='m406.94,422.71c-15.777,14.795-27.803-4.2965-26.862-12.805,10.497,21.576,14.446,18.617,26.862,12.805z'/%3E %3Cpath d='m521.9,255.48c-4.5972,13.52,10.602,18.098,10.242,25.078-4.6329-4.4262-16.424-15.956-10.242-25.078z'/%3E %3Cpath d='m545.18,258.13c14.802,15.728-4.5106,27.572-13.077,26.598,21.809-10.312,18.852-14.247,13.077-26.598z'/%3E %3C/g%3E %3C/g%3E %3Cg id='coa'%3E %3Cg id='tree' stroke-width='0.5087'%3E %3Cg fill='%23730000' stroke='%23000'%3E %3Cpath d='m405.26,125.34s0.61-1.426,1.73-0.61c1.018,0.812,1.321,4.375,1.321,4.375l-1.628,0.812c0.001,0.001,0.917-1.319-1.423-4.577z'/%3E %3Cpath d='m396.01,157.29s0.813-1.118-0.305-3.563l1.628-0.508s0.609,1.932-0.204,4.072l-1.119-0.001'/%3E %3Cpath d='m424.19,151.69-3.865,2.342,1.934,0.916,4.679-2.748-2.748-0.51'/%3E %3Cpath d='m372.4,166.85c-1.019,0.815-1.12,2.24-1.73,3.052-0.506,0.814-2.034,1.932-2.135,3.154-0.203,1.22-0.304,2.034,0.204,3.664,0.607,1.626,3.152,8.851,2.135,14.347-1.12,5.493-0.71,7.833-0.303,8.649,0.404,0.814,1.627,3.051,2.339,3.051,1.628-0.203,0.916-0.711,1.525-1.729,1.526-2.646,0-23.098-0.712-28.796-0.507-4.375-2.545-8.345-2.745-8.75-0.203-0.511-0.609-1.832-0.916-2.647-1.525-3.664-3.357-6.815-3.357-14.451,0,0-4.986,1.122-9.257-8.547-2.238-4.883-5.495-4.375-9.359-6.001l1.729-1.122s3.256,1.629,4.884,1.629,1.12-3.256,1.12-3.256l1.628-1.63v7.126c0,3.256,4.476,7.732,7.121,9.055,1.628,0.812,3.765-2.545,3.257-5.799-0.509-3.256,0-7.631,0-7.631l2.238,1.321s-0.814,1.424-0.61,2.238c0.303,0.816,1.422-0.813,2.236-1.629,0,0,0.203,0.205,1.018,0.205,0,0-1.628,2.745-2.44,4.172-0.812,1.324-0.812,6.514-0.812,8.447,0,1.934,0.712,6.409,0.712,7.833,0,1.021,1.931,5.19,3.46,7.736,0.507,1.016,1.728,3.661,1.728,3.661,1.221,1.933,1.321,3.256,2.035,4.886,0.406,0.812,1.12,3.153,1.628,7.225,0.204,1.016,0.406,4.883,0.714,7.425,0.304,2.442,2.34,0.511,4.779-1.219,2.442-1.832,2.442-6.207,2.442-6.207s1.934-1.628,1.628-0.712c-0.204,1.018,1.019,2.035,1.019,2.035-1.525,3.458-0.609,3.052,0.916,2.95,1.525-0.206,6.814-4.172,6.814-4.172,0.713-0.205,3.867-0.205,3.358,0-0.61,0.306-1.425,1.832-1.425,1.832l3.46-0.408c-1.221,0.916-5.801,3.561-6.815,4.172-1.12,0.714-6.611,3.361-8.952,4.274-2.34,1.016-6.919,3.256-7.122,5.596-0.103,2.342,0.304,8.649,0,10.683-0.204,2.035-1.019,11.093-1.019,11.093h-10.886s2.137-7.937-0.103-10.073c-2.136-2.238-7.122-8.752-10.377-10.992-3.257-2.135,2.135-0.505,2.135-0.505v-2.24l4.984,6.006s8.647-7.632,0-18.011c-2.746-3.256-5.494-8.241-7.629-8.752-2.238-0.61-3.358-1.119-7.123,0-3.866,1.118-13.124,1.118-16.99-4.988l3.257-0.508,2.744-1.119s-1.118,3.867,6.613,3.867c7.631,0,8.749,0,8.139-7.123l2.238-1.119,1.629,1.63s-1.12,3.866-0.509,5.493c0.509,1.627,3.257,2.748,5.393,4.375,0.916,0.713,1.628,0.815,2.238,0.815,0.915-0.102,1.118-0.102,2.339-1.324,1.832-2.035,1.424-1.933,3.256-3.559,0,0,0.916-1.426,1.12-1.63l1.12,2.952h-0.006z'/%3E %3Cpath d='m374.03,161.46c0.405-0.404,1.221-1.934,1.933-3.256,1.221-2.035,2.646-3.256,4.272-5.801,1.525-2.34,2.137-5.798,1.525-8.239l1.424,0.814,0.104,3.866s1.934-1.63,2.748-2.035l0.812,0.405s-6.104,6.31-11.802,16.485l-1.018-2.237,0.002-0.002z'/%3E %3Cpath d='m320.52,140.3c0.814,1.421,1.629,4.172,4.07,6.307l1.628-0.508s-3.764-4.375-3.764-6.307l-1.934,0.508'/%3E %3Cpath d='m330.08,137.85s0.508,5.19-0.812,7.123l1.627-0.811s1.119-3.561,0.813-5.496l-1.628-0.812v-0.004z'/%3E %3Cpath d='m383.7,121.47s-0.307,7.325,1.119,11.803l1.932-0.608s-0.304-1.327,1.322-1.937c1.629-0.508,5.494-2.135,7.426-3.765l-0.608-1.626s-2.95,2.34-4.375,2.949c-1.322,0.51-2.136,1.119-3.256,0.816-1.12-0.306-2.44-2.138-1.628-6.311l-1.932-1.321'/%3E %3Cpath d='m405.26,155.66s-0.507,5.189-0.202,7.429l1.729,0.408s-0.404-6.207,0.712-6.716l-2.239-1.121'/%3E %3Cpath d='m413,159.53s-1.933,3.358-4.17,3.664l3.561-0.714s1.019-0.508,2.544-2.135l-1.935-0.815'/%3E %3C/g%3E %3Cg fill='%23289400' stroke='%23030'%3E %3Cpath d='m381.87,144.16,1.321,0.811,1.424,0.206s1.525,1.424,3.256,2.745c1.321,1.122,1.321-0.202,1.321-0.202l0.812,3.256h1.12s-0.306,2.136-0.306,3.256l1.934-1.629,2.238,1.934s1.628-1.424,2.441-1.424c0.812,0,1.118-0.812,1.118-0.812h0.104c-5.393-2.546-7.731-5.19-6.104-7.938,2.646-4.578,7.02-1.629,8.443-1.016l19.737,10.581s1.322-0.814,0.406-1.63c-1.019-0.811-1.425-2.848-1.12-3.661,0.306-0.814,2.544,2.542,3.662,2.847,1.12,0.306,3.661,0.714,3.661,0.714l-0.102-1.018s3.256,2.237,3.256,3.358c0,0,2.341-1.221,1.525-1.934-0.813-0.71,3.562,1.731,3.866,3.055l0.915-1.021c-0.103,0,0.306-3.256,1.424-4.782,1.019-1.524,2.137-1.933,2.137-1.933s1.019-1.731,2.034-1.731c0,0-1.019-0.71-1.425-1.524-0.508-0.816-1.729-1.222-1.729-1.222s1.525-1.118,1.934-1.628c0.406-0.608,0.814-0.714,0.814-0.714s-2.342-1.932-3.97-2.235c0,0-0.102-2.648-2.136-2.85h0.916s-1.526-2.849-2.951-2.95c0,0,0.916-1.017,1.73-1.119,0,0-1.73-2.238-4.068-1.424l1.525-0.608s-1.119-1.22-4.576-0.61c0,0,0.303-1.424-1.221-2.545,0,0-1.322,0.1-1.322,1.118,0,0-1.221-1.118-2.746-1.118-1.526,0,0.508,1.629,0.508,1.629s-2.034-1.324-3.256-0.916c0,0,0.508-2.34-0.814-3.563,0,0-1.523,0.815-1.933,1.832l-0.406-1.017s-2.036,2.442-2.441,1.73c-0.305-0.406-0.609-2.135-0.609-2.135l-1.219,1.832,0.202-2.546s-1.424,0.815-2.543,3.458c0,0-1.425,1.324-1.425,2.542,0,0-1.119-1.32-2.137,0-0.916,1.424,0,1.122,0,1.122s-0.407,0.505-1.424,0.71l0.204,0.812s-1.321-0.71-2.339-0.404l0.507,1.219s-2.645,0.205-2.745-1.93c0,0-2.238-1.121-2.544,0.101l-1.628,1.018s-0.509-1.018-1.425-1.22c-1.019-0.306-0.204,1.32-0.204,1.32s-0.304-1.219-1.525-1.832c-1.219-0.505-0.203,1.122-0.203,1.122s-1.628-1.324-0.812-2.34c0,0-1.526,1.424-0.814,2.748l-1.018,0.711s-0.509-0.508-0.408-0.916c0.104-0.408-1.729,1.219-1.729,1.219s-1.119-2.643,0-2.643c0.102,0-1.933-0.102-2.237,2.24,0,0-1.322,0.101-2.544,0.505-1.322,0.408,0.916,1.324,0.916,1.324s-1.934-0.408-3.053,0.204l0.713,0.916s-0.713-0.713-2.442-0.104c-1.832,0.508,0.406,0.814,0.406,0.814s-1.832-0.406-2.747,0c-0.916,0.408,0.305,1.119,0.305,1.119s-3.357-1.017-3.866-0.71c-0.507,0.304,1.12,1.934,1.12,1.934s-2.035,0.508-2.44,2.035l1.831,0.71s-0.812,0.406-1.222,1.222c-0.403,0.814,1.222,0.405,1.222,0.405s-2.237,1.63-2.237,2.849c0,0,1.627,0.508,2.848-0.711s0.406-0.814,0.406-0.814l0.102,0.814s2.341-1.016,2.341-1.626c0-0.508-0.406,0.812-0.406,0.812l2.341-1.22,1.524,1.018v-0.002h0.001z'/%3E %3Cpath d='m379.93,112.42-0.509-2.238l5.188,0.608,0.915-2.135s2.441,1.118,3.256,1.929c0,0,4.781-1.219,6.207-0.71l-0.61,2.24s4.373,0.303,5.799,0.812c1.322,0.508-0.609,1.63-0.609,1.63s4.984,0.608,7.122,1.932c2.238,1.321,2.238,2.442,1.12,2.745l2.744,4.375s-4.373,0.508-5.187,1.626c-0.814,1.119-1.628-1.118-1.628-1.118l-0.814,3.052s-2.746-1.426-3.865-2.442c0,0-1.321,1.629-0.508,2.442l-4.986-3.256s-2.137-0.304-2.137,1.63c0,0-2.439-2.748-3.051-3.563l-2.748,0.815s-0.812-1.118-1.83-1.426c-1.12-0.201-0.306,1.426-0.306,1.426l-1.628-1.934-1.627-1.929s-1.425,1.929-2.544,1.929c-1.02,0-1.02-1.321-0.814-2.237,0.305-0.814-3.256-1.016-3.561,0,0,0-1.019-4.07,2.746-5.188,3.866-1.018,3.866-1.018,3.866-1.018l-0.001,0.003z'/%3E %3Cpath d='m360.2,126.36-1.729,1.629-1.019-0.508-2.034,2.237-0.407-1.223-1.119,1.832-1.729-0.609-0.814,1.322-1.525-0.306s-1.322,1.222-2.137,1.526c-0.813,0.206,0-1.829,0-1.829s-1.221,2.034-2.137,2.034c-0.812,0-0.507-0.916-0.507-0.916s-0.508,1.319-1.525,1.525c-0.916,0.102-0.51-1.017-0.51-1.017l-1.629,1.219v-1.017l-0.712-0.304s0.406-1.832,1.12-2.238c0.712-0.408-0.712-1.626-0.712-1.626l0.712-0.815s-2.036-0.508-2.036-0.101c0,0,1.019-2.745,2.441-3.258l0.103-3.051s1.425-1.219,2.747-1.324c1.423-0.203-0.406-2.34-0.406-2.34l3.255-1.929,0.406-2.34,4.984,0.403,1.018-2.135,3.969,1.016,3.356-1.73,2.441,2.849,3.662,0.307s-0.102,2.542-0.102,3.256c0,0,4.373,1.321,4.883,1.73,0,0-0.814,2.645-0.814,3.153,0,0,3.054-0.814,3.97-0.61,0,0,0.306,2.85,0.405,3.561,0,0,5.188,1.63,5.494,2.546,0,0-1.12,0.71-1.729,1.626,0,0,0.608,3.156,0.608,4.172l-0.406,0.61s-1.526-1.424-2.747-1.627l-1.019,2.237-1.83-1.22-1.119,0.102s-0.916-1.119-1.629-1.119l-0.103-1.018-1.424,0.916s-2.237-1.12-2.237-1.832c0-0.609,0.102-1.63,0.102-1.63l-2.34,1.63s-0.508-1.219-0.405-1.73c0.103-0.508-0.915,1.222-0.915,1.222s-1.222-2.138-1.12-2.546l-0.306,1.732s-2.441-0.812-2.745-2.442v-0.002z'/%3E %3Cpath d='m327.64,136.33s4.274,2.14,4.274,3.156c0,0,1.12-2.24,0.508-3.054l1.629,1.122s0.506-2.034-0.103-2.647c-0.509-0.508,3.66-2.235,4.576,0.51,0,0,2.545-2.645-2.339-4.885,0,0-0.405-1.626,2.544-1.219,0,0-0.203-1.018-0.916-1.424h2.849s-1.729-1.426-4.273-1.832c-2.44-0.408-0.916-0.711-1.018-1.224-0.204-0.508,0-2.34,0-2.34s-1.424-0.508-2.544,0.102l0.406-0.51s-2.646-0.71-3.661-0.101c0,0-1.526-0.61-1.322-2.24,0,0-1.526-0.1-2.236,1.526,0,0-1.425,1.629-3.357,1.629-0.406,0-1.832-0.815-1.832-0.815l-1.222,2.85-1.932-0.102,0.609,1.118s-2.95-0.811-3.866,0c0,0,1.12,1.732,0.813,2.951,0,0-2.341,0.408-2.849,0.815-0.61,0.403,0.813,0.71,0.813,0.71s-2.645,0.814-3.257,1.63l1.02,0.811-1.222,1.631,1.019,0.201s-1.729,0.51-2.644,0.815c-0.916,0.303,1.627,0.508,1.627,0.508l-1.219,1.118,1.933,0.303s-1.525,4.072-1.628,6.006c0,0,2.341-2.85,2.949-3.052l-1.83,3.052s3.46-1.118,3.766-1.631c0.304-0.608,0.609-1.117,0.609-1.117l0.103,1.73s1.322-1.832,1.525-2.545c0.103-0.71,2.136,0.713,2.136,0.713v-1.02s1.832,0.609,2.441,0.714c0.712,0.101,0.813-0.306,0.813-0.306l1.729-0.203-0.306,1.421s1.22-0.812,1.525-1.627c0.204-0.815,0.813,0,0.813,0l0.812-3.256h1.729l0.006,0.008z'/%3E %3Cpath d='m313.7,150.78,1.628,3.358c-1.322,0.1-3.256,1.626-3.256,1.626,0.304,5.597-1.118,5.291-1.118,5.291,0.403,1.018-0.259,2.905-0.259,2.905l8.092-4.837,0.102-0.508,9.564-4.48,0.303,0.508,2.748-1.524,1.933,5.085-1.933,1.119c0.103,1.73,2.137,4.784,2.137,4.784l2.544-0.608,2.747-1.021s0.103,1.526,0.103,1.021c0-0.411,2.949-1.424,2.949-1.424l1.322,1.322c1.02-0.101,2.848-2.546,2.848-2.546l2.137,0.816s0.712-1.22,0.712-2.136c0-0.814,2.645-0.814,2.645-0.814l1.832,1.321,2.34-1.931s0.712,1.424,1.628,1.626c1.019,0.102,3.561,2.034,3.561,1.63,0-0.406,1.12-2.646,1.12-2.646l4.271,1.73c-0.608-1.933-2.032-4.273-2.032-4.273s2.032-1.626,1.627-2.034-1.627,0-1.627,0l1.219-2.442h-1.627l0.507-0.608-2.645-1.118,1.423-2.85c-0.61-0.714-7.629-2.138-7.629-2.138l1.628-1.526s-0.814-1.219-1.628-1.219-5.087,0.102-5.291-0.303c-0.103-0.408-1.832-1.937-1.832-1.937l-2.646,1.937-1.322-0.408-2.34,0.916s0,1.321-0.307,0.405c-0.303-0.816-2.44-2.951-2.44-2.951-0.406,0.71-3.153,3.967-3.153,3.967s-0.406,1.732-1.322,0.508c-1.019-1.219-3.154-2.542-3.46-1.524-0.305,1.121-2.236,2.135-2.646,1.832-0.405-0.308-2.645-0.102-2.849,0.508-0.102,0.71-2.544,2.542-2.544,2.542-1.526-0.71-3.969-0.302-3.969-0.302s-0.712,1.118-0.812,2.034l-4.984,1.319h0.004v-0.002z'/%3E %3Cpath d='m359.69,191.99v-2.138l2.44,1.629,1.425-1.629,1.832,1.83,1.119-1.83v2.952l2.747-2.44,1.626,0.71v-2.34s1.935-3.258,1.12-3.866l1.628-0.508s-2.748-2.748-3.562-3.258c-0.812-0.608-1.932-0.608-1.932-0.608s-2.137-2.14-3.561-2.748c-1.322-0.508-2.138,0.608-2.138,0.608s-0.813-1.626-2.237-1.933c-1.32-0.303-1.32,1.119-1.32,1.119s-1.02-1.018-2.341-1.526c-1.322-0.608-0.407,1.22-0.407,1.22l-4.681-1.422,0.609,1.422-4.373-1.115,0.506,1.627-3.051-0.512-0.203,1.326-4.375,0.812,0.814,1.424-2.747-1.119v1.934l-3.052,1.118,1.119,1.02s-4.068,1.933-4.884,2.543c-0.812,0.508,1.629,1.626,1.629,1.626l-4.375-0.61,1.629,1.426-3.866,3.562,2.746,1.934-1.628,2.44,4.069,0.812,1.628,2.748,3.357-0.61v3.051l4.884-3.865s3.562,3.154,3.866,2.238c0.203-0.814,0.203-3.562,0.203-3.562h1.729v-2.745l1.322,1.118,2.238-3.258,2.949,4.072,2.237-5.188,3.256,0.508,0.006,0.001z'/%3E %3Cpath d='m379.63,179.68-0.508-4.68-1.423,1.424,0.607-4.375-2.235-0.408,0.812-4.272-1.627-0.816,0.404-2.034,1.629-1.219,2.95-2.85,6.814,0.105,0.813-2.24l4.885,0.815c0.812,0.916,3.355-1.832,3.355-1.832h1.019l1.12,2.134s3.561-0.508,5.188,0.61l-1.934,2.646,3.561,0.304,2.44,0.512,2.544-0.816,3.257-0.206,0.813,1.324h3.053l-1.019,1.219,3.968,1.832-0.812,0.815s2.237,0.814,3.865,0.814h0.813s0.813,1.931-0.307,2.745c0,0,1.12,2.748,3.562,3.258,2.441,0.508,2.441,0.508,2.746,1.117,0.307,0.51,0,3.258-2.746,3.258v2.748s-2.137,1.933-2.441,2.745l-1.629-1.119s-1.422,1.63-1.422,2.748c0,0-3.562-4.682-4.885-4.887-1.424-0.303-1.12,2.647-1.12,2.647l-3.864-3.256-0.509,2.237-3.256-2.745-1.934,1.319-3.46-3.559-3.357,0.408,1.321-1.731h-4.069l-0.812-3.559-0.61,2.949-2.44-1.626-3.154,3.458s-0.406-0.409-0.916-2.036c-0.507-1.628-1.933,1.932-1.933,1.932l-1.12-2.542-1.322,2.542s-1.12-1.932-2.238-2.542c-1.018-0.508-2.135,3.051-2.439,4.681l0.002,0.004z'/%3E %3Cpath d='m380.24,190.36,0.203-1.626,5.798-2.24,4.885-1.832,2.439-1.118,1.12,1.932,1.424-2.745,2.238,2.847,1.221-1.526,1.932,1.424h1.628l0.305,2.14s4.07,0.303,4.374-0.508c0.305-0.815,0.812,2.745,0.812,2.745l3.865,0.508,0.814,4.375s1.931,4.072,1.322,5.699c-0.51,1.73-2.138-2.136-2.138-2.136s-0.304,3.052-0.609,3.866c-0.203,0.812-5.188-0.814-5.188-0.814l-2.136,4.07s-2.237-3.256-3.255-3.256c-1.12,0-1.12,3.256-1.12,3.256s-3.256-3.867-4.681-5.496c-1.322-1.626-1.628,1.629-1.628,1.629s-2.136-3.562-2.136-4.578c0-1.119-1.934-2.24-1.934-2.24s-3.358,3.867-5.801,4.886c0,0,0.306-2.442-0.507-3.256-0.813-0.815-3.257,1.626-3.257,1.626s-1.729-3.764,0-7.631l0.01-0.001z'/%3E %3C/g%3E %3Cg fill='none' stroke='%23004b00'%3E %3Cpath d='m407.1,129.71,0.509,2.035s1.83-0.408,3.053-0.305c0,0-0.305,1.627-0.712,2.34,0,0,2.441-0.406,3.561,0.304l-0.509,1.219,2.849,1.222-2.645,2.136s4.271,1.524,5.087,2.748c0,0-2.746,1.932-3.154,1.832-0.406-0.206-0.102,0.811,0.61,1.727l-2.341-0.101s0.916,2.138,0.813,2.95c-0.102,0.814-3.866,0.609-3.866,0.609'/%3E %3Cpath d='m425,142.94s0.712-4.07-0.404-5.088c0,0,2.644,2.24,4.373,2.34,1.832,0.105-0.103-3.357-0.103-3.357s2.544,1.322,3.765,1.627c1.221,0.205-0.916-2.543-0.916-2.543s0.712-1.324,2.746-0.102'/%3E %3Cpath d='m387.16,119.64s0.1-0.916-0.308-1.424c-2.44-3.358,2.545,2.545,3.561,2.748'/%3E %3Cpath d='m395.09,120.96s1.628,1.219,2.442,1.219c0.813,0-0.508-3.256-0.916-3.661-0.406-0.408,2.95,1.321,4.172,1.526,1.221,0.303,1.423-2.035,1.423-2.035s3.765,0.609,4.579,1.119'/%3E %3Cpath d='m380.64,118.42s-0.305-2.136-0.405-3.052'/%3E %3Cpath d='m355.01,128.6c-0.204-0.408,1.02-2.24,0.509-3.054,0,0,0.712,0.612,1.424,0.714,0.61,0.101,0.404-2.342,0.404-2.342l0.814,0.304s2.137-1.018,1.729-1.832c-0.408-0.812,1.424,1.219,1.424,1.219s1.222-1.219,1.222-1.727c0-0.513,1.422,1.219,1.422,1.219s1.525-0.306,1.525-1.219c0-0.916,1.934,0.303,1.934,0.303s0.812-1.118,0.712-1.832' stroke-width='0.5087'/%3E %3Cpath d='m347.58,130.53s0.914-2.135-0.103-3.559'/%3E %3Cpath d='m322.86,137.24c0.103-1.016,0.609-3.764,0.103-4.172-0.508-0.403,1.019,0.408,2.238,0.713'/%3E %3Cpath d='m334.86,133.38c-1.221-1.223-1.934-1.832-3.864-1.832'/%3E %3Cpath d='m314.21,140.19c0.306-0.71,0.813-2.441,0.508-3.458'/%3E %3Cpath d='m340.76,190.66,1.322-2.748,1.628,3.866,1.118-2.442,0.406,0.815,2.441-2.645,2.646,3.968'/%3E %3Cpath d='m392.75,174.28,1.729-3.458,2.342,1.222,1.12-3.358,2.439,1.526,1.424-3.153,2.747,0.711,0.202-2.238s1.933,1.118,2.442,1.932c0.608,0.816,0-2.745,0-2.745l2.237,1.016s1.628-1.629-0.609-2.545'/%3E %3Cpath d='m399.57,169.91,2.441,3.562,2.033-2.34,1.832,3.967,2.34-1.424,3.356,1.933,1.525-1.219,3.662,2.645,1.526-3.153,3.256,1.017,2.135-3.661'/%3E %3Cpath d='m335.78,161.67s1.425-2.4453,0.91601-3.5637c-0.61133-1.1188,2.9492,1.934,2.9492,1.934s0.81249-2.443,0.30469-3.5605c-0.61055-1.1188,4.0703,3.2558,4.0703,3.2558s0.81446-3.764,0-4.5801c-0.81445-0.81406,4.4766,1.1215,4.4766,1.1215s2.1367-0.60897,1.3222-1.7305c-0.81445-1.1184,3.5586,1.6269,3.5586,1.6269s1.0184-2.7445,0-3.7656c-1.1184-1.1172,3.2566,1.3238,3.2566,1.3238l-1.6277-2.9508,3.5605,0.20273-0.30469-3.2562'/%3E %3Cpath d='m389.8,194.73,2.3398-1.1187,2.0351,2.0348,2.2383-3.5605,2.7461,2.6445,0.40625-2.6445,2.9492,1.223,0.61133-1.6312,3.2551,1.7324,0.3039-2.443,1.6277,0.50977,0.30664-1.6293'/%3E %3C/g%3E %3C/g%3E %3Cg id='shield'%3E %3Cpath fill='%239dd7ff' d='m336.59,310.53c-2.646-4.477-4.681-9.055-6.207-13.531l44.052-38.77,44.055,38.666c-1.526,4.475-3.562,9.26-6.409,13.84l-0.352,0.563c-0.812-0.303-3.312-1.276-3.312-1.276s-1.425,1.324-2.541,1.424c-1.526,0.205-2.849-1.32-2.849-1.32s-1.934,1.627-3.866,1.32c-1.934-0.201-2.748-1.424-2.748-1.424s-2.034,1.629-3.459,1.324c-1.322-0.309-2.238-1.225-2.238-1.225s-1.22,1.529-2.95,1.225c-1.627-0.309-3.153-1.225-3.153-1.225s-2.541,1.117-4.171,1.322c-1.626,0.308-3.052-1.424-3.052-1.424s-2.136,1.424-2.949,1.424c-0.814,0-3.866-1.424-3.866-1.424s-3.154,1.018-4.272,1.018c-1.019,0-4.171-1.321-4.171-1.321s-2.95,0.812-4.271,0.812c-1.426,0-3.459-0.812-3.459-0.812s-2.438,1.119-3.764,0.812c-1.424-0.303-2.544-0.812-2.544-0.812s-2.645,1.119-4.375,0.812c-1.628-0.303-3.561-1.42-3.561-1.42s-0.305,0.812-3.458,1.42h-0.104'/%3E %3Cpath fill='%23fff' stroke='%23000' stroke-width='0.7123' d='m374.44,213.66v44.566l-44.053,38.974c-4.272-12.414-4.577-23.504-4.577-28.285v-55.254h48.63'/%3E %3Cpath fill='%23ffd83c' stroke='%23000' stroke-width='0.7123' d='m374.44,213.66v44.566l43.951,38.974c4.271-12.414,4.577-23.504,4.577-28.285v-55.254h-48.528'/%3E %3Cg id='boat' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='%23730000' d='m346.02,301.27c3.312,1.795,2.19,1.229,9.055,3.66,5.597,1.937,12.106,2.849,21.567,2.849,8.278,0,12.938-0.656,15.56-1.38,2.719-0.78,3.363-1.877,3.363-1.877l-6.814,6.92s-27.394,1.479-32.354-1.729c-1.931-1.019-6.104-4.375-10.376-8.444v0.001z'/%3E %3Cg fill='none'%3E %3Cpath d='m386.21,288.35s8.75,4.984,0,14.549'/%3E %3Cpath d='m346.84,301.78,12.615-12.01-1.424,16.078'/%3E %3Cpath d='m364.64,307.27v-26.86'/%3E %3Cpath d='m386.21,307.27v-28.489'/%3E %3Cpath d='m375.32,307.78v-30.625'/%3E %3C/g%3E %3Cg fill='%23ff0018'%3E %3Cpath d='m364.64,281.84-5.698,1.832,5.698,0.61v-2.442'/%3E %3Cpath d='m375.32,277.66-6.001,2.24,6.001,0.203v-2.443'/%3E %3Cpath d='m386.21,279.29-6.002,2.24,6.002,0.303v-2.546,0.003z'/%3E %3Cpath d='m389.77,292.22c-0.305-1.222,3.562-1.118,3.562-1.118s1.12,4.068,0,6.611l-3.255-0.609s0.305-2.746-0.307-4.884z'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m348.77,300.15,0,0,10.683-10.379-0.509,6.207s-5.493,3.559-5.493,6.104l-4.681-1.932'/%3E %3Cpath d='m354.46,302.29s1.12-3.256,4.171-4.883l-0.305,6.512-3.864-1.629h-0.002z'/%3E %3Cpath d='m369.83,284.28s4.373-0.61,7.63,0c0,0-0.509,4.375,0,5.188,0,0-6.003-1.425-8.443,0.812-0.001,0-0.815-4.069,0.813-6z'/%3E %3Cpath d='m360.57,285.4s4.375-0.61,7.629,0c0,0-0.812,4.886-0.305,5.699,0,0-4.885-2.748-7.324-0.512,0,0-1.629-3.355,0-5.187z'/%3E %3Cpath d='m360.26,291.09s4.374-0.508,7.631,0c0,0-0.509,4.375,0,5.191,0,0-5.698-1.324-8.141,0.812,0.001,0.001-1.119-4.069,0.51-6.003z'/%3E %3Cpath d='m369.01,290.28s6.308-0.811,9.562-0.303c0,0-1.322,3.561,0.307,6.002,0,0-6.817-1.832-9.361,0.303-0.001,0-2.135-4.069-0.508-6.002z'/%3E %3Cpath d='m359.76,297.1l8.442,0.609s-0.812,6.207-0.305,7.021c0,0-6.815-1.629-8.141,0.608,0,0-2.238-5.696,0-8.241h0.003v0.003z'/%3E %3Cpath d='m369.32,297.1s7.322-0.51,10.682,0c0,0-1.936,4.683,0.204,8.75,0,0-9.565-2.744-10.889-0.51,0,0-2.235-5.697,0-8.24h0.003z'/%3E %3Cpath d='m380.51,284.28s4.373-0.61,7.63,0c0,0-0.507,4.375,0,5.188,0,0-6.002-1.425-8.442,0.812-0.002,0-0.816-4.069,0.812-6z'/%3E %3Cpath d='m380.51,290.28s4.373-0.508,7.63,0c0,0-0.507,4.375,0,5.189,0,0-6.002-1.322-8.442,0.815-0.002,0.001-0.816-4.071,0.812-6.004z'/%3E %3Cpath d='m381.02,296.59s4.373-0.607,7.73,0c0,0-1.119,6.817-0.609,7.631,0,0-4.982-2.34-7.324-0.303,0,0-1.423-5.392,0.203-7.328z'/%3E %3Cpath d='m390.07,297.1s1.422,5.187,3.254,5.799l-2.44,2.951s-2.95-2.137-3.256-4.576c0,0,1.932-2.241,2.442-4.174z'/%3E %3C/g%3E %3C/g%3E %3Cg id='waves' stroke='%23000' stroke-width='0.6104'%3E %3Cpath fill='%23006ac8' stroke='none' d='m411.88,311.14c-7.019,11.703-18.516,22.689-37.438,29.506-19.229-6.916-30.928-18.414-37.847-30.016l0.103-0.102c3.153-0.613,3.459-1.424,3.459-1.424s1.933,1.119,3.561,1.424c1.729,0.303,4.374-0.814,4.374-0.814s1.119,0.51,2.543,0.814c1.322,0.303,3.765-0.814,3.765-0.814s2.034,0.814,3.458,0.814c1.322,0,4.273-0.814,4.273-0.814s3.153,1.32,4.17,1.32c1.12,0,4.272-1.018,4.272-1.018s3.053,1.426,3.866,1.426c0.812,0,2.95-1.426,2.95-1.426s1.423,1.729,3.051,1.426c1.628-0.203,4.171-1.321,4.171-1.321s1.525,0.916,3.154,1.22c1.729,0.307,2.95-1.22,2.95-1.22s0.916,0.916,2.238,1.22c1.424,0.307,3.458-1.322,3.458-1.322s0.813,1.222,2.748,1.424c1.933,0.306,3.866-1.32,3.866-1.32s1.32,1.525,2.848,1.32c1.12-0.102,2.542-1.424,2.542-1.424s2.544,0.812,3.459,1.121'/%3E %3Cpath fill='none' stroke-width='0.5087' d='m410.15,313.79c-1.525,0.104-1.729-0.916-1.729-0.916s-2.032,1.731-3.967,1.425c-2.034-0.303-2.95-1.627-2.95-1.627s-2.137,1.73-3.562,1.424c-1.423-0.203-2.439-1.222-2.439-1.222s-1.322,1.528-3.053,1.222c-1.729-0.203-3.257-1.222-3.257-1.222s-2.746,1.122-4.477,1.425c-1.729,0.307-3.153-1.627-3.153-1.627s-3.968,1.324-4.781,1.324c-0.916,0-3.766-1.324-3.766-1.324s-1.932,1.223-3.051,1.223c-1.22,0-4.476-1.426-4.476-1.426s-3.054,0.816-4.478,0.816c-1.425,0-3.561-0.816-3.561-0.816s-2.645,1.119-4.069,0.816c-1.424-0.307-2.544-0.816-2.544-0.816s-2.849,1.119-4.578,0.816c-1.729-0.307-3.765-1.424-3.765-1.424s-0.304,0.709-3.661,1.424h-0.103'/%3E %3Cpath fill='%235ac800' d='m346.97,317.94s-0.28444,0.66512-2.9375,1.25c-0.0568-0.004-0.71875,0.15625-0.71875,0.15625,0.24453-0.0444,0.44305-0.0788,0.65625-0.125-0.0936,0.0356-0.303,0.11225-0.75,0.25,3,4.334,7.4939,8.268,12.177,11.423,4.6833,3.1547,10.065,6.9209,19.229,9.6085,9.6351-3.7615,12.206-5.1929,18.503-9.4102,6.297-4.5987,9.5783-7.4642,13.09-12.184-2.75,1.562-2.3552,1.58-3.7812,1.375-1.424-0.303-2.4688-1.3438-2.4688-1.3438s-1.3002,1.5488-3.0312,1.3438c-1.729-0.303-3.25-1.3438-3.25-1.3438s-2.26,1.5375-4.5,1.4375c-1.73-0.104-3.1562-1.625-3.1562-1.625s-3.9692,1.3125-4.7812,1.3125c-0.916,0-3.75-1.3125-3.75-1.3125s-1.9445,1.2188-3.0625,1.2188c-1.22,0-4.4688-1.4375-4.4688-1.4375s-3.0448,0.8125-4.4688,0.8125c-1.425,0-3.5625-0.8125-3.5625-0.8125s-2.5375,1.1175-4.0625,0.8125c-1.425-0.303-2.5625-0.8125-2.5625-0.8125s-2.8345,1.1175-4.5625,0.8125c-1.73-0.303-3.7812-1.4062-3.7812-1.4062z'/%3E %3Cpath fill='%23ffd800' d='m374.63,340.51c9.953-4.143,11.751-5.27,17.771-8.951-1.05,0.029-4.104-0.957-2.999-1.272,0,0-1.224,1.103-2.444,1.103-1.12,0-4.375-1.42-4.375-1.42s-3.051,0.811-4.476,0.811-3.561-0.811-3.561-0.811-2.646,1.116-4.07,0.811c-1.425-0.303-2.544-0.811-2.544-0.811s-2.949,1.116-4.577,0.811c-1.729-0.303-3.765-1.424-3.765-1.424s-2.504,1.328-4.076,1.481c4.809,3.522,9.872,6.961,19.116,9.672z'/%3E %3C/g%3E %3Cg id='weapons' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='%23b34b00' stroke-width='0.509' d='m367.88,259.34c1.977-1.61,3.112-3.159,2.452-4.362-0.743-1.033-1.905,0.646-3.214,0.252,0,0-1.976-1.222-2.515-2.098-1.153-1.281-2.636-2.434-3.49-3.535-0.905-1.021-4.31-5.522-9.492-10.704-1.49-0.972-1.149-4.65-2.217-5.792-0.091-0.796-10.358-10.96-14.022-14.637-1.481-1.09-2.262-1.797-4.865,0.563-2.055,1.854-2.794,3.767-0.098,6.077l13.356,12.144c1.951,1.896,4.676,2.241,5.819,3.223l13.576,13.883c1.709,1.477,2.529,2.524,1.563,3.787-1.073,2.077,0.075,2.357,0.319,2.42,0.156,0.086,1.115,0.084,1.755-0.41l1.073-0.811z'/%3E %3Cpath fill='none' stroke-width='0.5' d='m334.02,222.92,13.958,13.792'/%3E %3Cpath fill='%23fff' stroke-width='0.5713' d='m352.92,229.22c0.216-0.415,0.688-1.473,1.187-2.627,0.196-0.456,3.951-6.444,5.823-6.62,0,0,11.677,8.495,11.686,8.607,0.039,0.458-5.065,8.093-5.509,7.513-0.002-0.001-13.68-5.743-13.187-6.873z'/%3E %3Cpath fill='%23ccb8c8' stroke='none' d='m360.36,231.22c-1.599-1.242-4.242-2.453-6.375-3.875l-0.958,2c0.771,0.863,10.487,5.381,12.083,6.25,0,0-1.851-2.122-4.75-4.375z'/%3E %3Cpath fill='none' stroke-width='0.4' d='m353.98,227.09c1.25,0.875,3.625,2.375,5.125,3.25,2.875,2,4.695,4.203,6.75,5.375'/%3E %3Cpath fill='%23782121' d='m330.32,263.48,26.587-32.904c0.498-0.456,2.963-0.481,3.297,2.068l-25.179,34.315c0.001,0-2.868-0.284-4.705-3.479z'/%3E %3Cpath fill='%23730000' d='m419.44,263.84c-0.916,0.715-2.473,0.9-2.473,0.9-1.729-2.035-3.156-4.172-5.597-6.816l-26.555-32.663,2.747-2.645,23.907,27.981c0.712,0.711,4.886,5.088,8.854,10.274,0.002,0.002,0.348,2.032-0.883,2.969z'/%3E %3Cpath fill='%23fff' d='m393.87,229.43-4.274-5.088s-3.255,0.406-3.864,2.138c0,0-2.341,3.867-8.547,4.274,0,0,1.729,7.223,8.953,11.089,0,0,2.646-7.429,5.188-8.752-0.001,0.001,2.644-1.934,2.544-3.661z'/%3E %3Cpath fill='%23730000' d='m383.19,252.02c-0.609-0.205-1.221,0-2.137,0.509-0.812,0.51-1.83,0.304-1.729-0.714,0.102-0.916,0-0.812,1.119-1.524,1.629-0.916,3.765-1.019,5.087-0.51l-2.34,2.239'/%3E %3Cpath fill='%23730000' d='m412.18,223.12c-0.204-0.71-0.405-1.421,0.305-2.337,0.713-0.814,0.713-2.24-1.019-1.528-1.729,0.714-2.339,2.646-0.914,5.597l1.626-1.732h0.002z'/%3E %3Cpath fill='%23fff' d='m382.58,252.63,30.114-29.915,7.425,7.937s-1.524-0.612-2.136-0.206c-0.508,0.408,0.61,1.934,0.61,1.934s-1.424-0.508-2.034-0.102c-0.712,0.405,0,2.136,0,2.136s-1.221-0.916-1.832-0.51c-0.508,0.408,0,2.339,0,2.339s-1.628-0.507-2.033-0.102c-0.408,0.408,0,2.138,0,2.138s-1.629-0.814-2.442,0c-0.812,0.812,0.406,1.934,0.406,1.934s-2.034-0.815-2.848,0.405c-0.813,1.222,0.102,2.34,0.102,2.34s-1.627-0.812-2.033-0.408c-0.407,0.408,0,2.34,0,2.34s-1.424-0.814-2.34,0.206c-0.916,1.119,0.102,2.035,0.102,2.035s-1.321-0.816-2.036-0.411c-0.712,0.411,0.204,2.34,0.204,2.34s-1.321-0.916-2.237,0c-0.916,1.021,0,2.035,0,2.035s-1.12-1.018-2.238,0c-1.019,1.121,0,2.239,0,2.239s-1.626-0.813-2.236,0c-0.712,0.812,0.202,1.935,0.202,1.935s-1.219-0.713-2.033-0.309c-0.812,0.408,0,2.24,0,2.24s-1.22-1.324-1.729-0.609c-0.61,0.711,0.102,2.441,0.102,2.441s-1.12-1.324-1.729-0.609c-0.713,0.609,0.405,2.137,0.405,2.137s-2.034-0.916-1.525-0.916z'/%3E%3C!--c0.102,0-6.207-7.022-6.207-7.022--%3E %3Cg fill='%237e4b7e' stroke='none'%3E %3Cpath d='m410.96,225.16-2.34,2.34,0.508,8.039s0.509-2.34,1.221-0.714c0,0,0.204-1.932,0.712-1.626-0.409-0.206-0.102-8.039-0.101-8.039'/%3E %3Cpath d='m406.59,229.53-1.729,1.626,0.609,8.039s0.51-3.051,1.22-0.609c0,0-0.102-2.034-0.102-2.748,0.002,0.509,0.002-6.308,0.002-6.308'/%3E %3Cpath d='m388.38,247.55-1.628,1.727,0.408,4.886s0.508-3.153,1.22-0.714c0,0-0.204-2.031-0.204-2.746,0,0.509,0.204-3.155,0.204-3.155'/%3E %3C/g%3E %3Cg fill='none' stroke='%237e4b7e' stroke-width='0.9156'%3E %3Cpath d='m386.34,227.4c1.12,1.119,4.274,5.187,4.274,5.187'/%3E %3Cpath d='m387.77,229.64c-0.202,0.612-0.607,2.34-1.523,3.256'/%3E %3Cpath d='m388.27,230.04c-0.102,0.406-0.102,1.73-1.523,3.054'/%3E %3Cpath d='m388.78,230.66c-0.204,0.71-0.305,1.22-0.812,1.731'/%3E %3Cpath d='m389.09,231.27c0,0.508-0.303,0.61-0.405,0.916'/%3E %3Cpath d='m385.33,229.33c-0.406,0.405-3.358,2.338-4.985,2.95'/%3E %3Cpath d='m384.51,230.45c-0.406,0.408-2.238,1.832-3.256,2.24'/%3E %3Cpath d='m384.21,231.67c-0.609,0.41-1.628,1.424-2.441,1.73'/%3E %3Cpath d='m383.6,232.89c-0.406,0.508-1.018,0.916-1.525,1.222'/%3E %3Cpath d='m365.94,234.01c0.332-0.613,0.911-1.816,1.667-2.917,0.959-1.397,1.372-1.633,1.875-2.125' stroke-linecap='square'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='supporters'%3E %3Cpath fill='%23289400' stroke='%23060' stroke-width='0.5087' d='m267.72,316.03c1.526,0.711,0-4.987,0.507-7.123,0.61-2.238,4.984,5.494,7.123,6.514,2.238,1.118,15.87-5.395,15.87-5.395l3.256-6.104,1.73,4.985s3.763-4.375,4.883-6.002c1.119-1.627,0,3.257-1.12,4.884-1.12,1.629,3.256,2.239,2.746,5.495-0.508,3.257,4.375-2.239,4.375-2.239l12.615,1.119s2.135-7.632,5.493-12.007l1.018,4.887,5.188-5.29c5.799,15.263,18.009,31.849,43.035,40.903,23.501-8.547,35.608-23.709,41.913-38.159l7.021,7.228s5.494-1.631,6.511-2.238c1.118-0.51,12.92,4.172,12.92,4.172s2.136,0.814,3.256,1.63c1.118,0.812,0.304-3.563,0.304-3.563s6.003,1.118,5.493,4.375c0,0,1.322-3.051,2.442-3.56s3.763,2.748,4.375,3.866c0.508,1.02,13.43,2.646,15.26,3.765,0,0,1.425,1.63,1.425,2.748,0,0,2.748-0.306,4.885-0.306,0,0-1.628,0.811-1.628,2.543,0,1.629-0.814,2.953-2.442,3.764-1.628,0.816,0,1.424,2.137,1.63,2.238,0.304,0,3.052-4.375,4.683,0,0-1.018,2.439,0.814,3.252,0,0-3.766,0.308-4.375-0.812,0,0-1.32,2.543-1.32,3.867,0,0-4.069-1.324-5.188-1.933,0,0-1.629,1.625-0.51,2.439,0,0-7.425-0.811-8.851-3.559,0,0-2.646,0.813-2.137,1.729,0,0-5.188-3.56-6.815-3.56l-1.119,1.828s-3.561-2.135-4.681-2.135c-1.02,0-0.204,1.627-0.204,1.627l-4.983-3.053-1.933,3.053s-4.07-1.935-5.188-2.746c-1.019-0.813-1.32,1.627-2.136,1.931,0,0-1.628-2.235-3.866-1.931,0,0-0.813,2.746-0.508,3.561,0,0-6.308-1.322-7.426-1.63-1.12-0.304-0.508,1.323,0,2.444,0,0-4.681-1.323-5.698-2.139l-0.305,2.139s-3.864-0.307-4.679-1.121l-2.442,3.356h-3.561l-0.812,2.95s-6.815-1.93-7.427-0.811c-0.508,1.117,0.306,2.744,0.306,2.744l-6.002-0.812-0.507,2.441s-6.919-2.138-8.547-1.121c0,0-2.137,2.24-3.562,2.748-1.319,0.61,0-0.814,0-0.814l-2.135-2.949s-2.441,1.322-3.866,0.814c-1.321-0.613-5.697,2.135-7.123,1.32,0,0,0-1.935-1.117-2.442-1.019-0.509-2.95-0.509-3.766,0.815,0,0-0.812-1.121-2.237-3.257-1.322-2.239-3.257,0.203-3.257,0.203l-0.305-2.646-3.765-0.307c-2.238-0.305-2.746-2.24-2.746-2.24s-5.799,0.611-6.613,0.308l1.423-1.324s-7.935,1.632-9.562,1.021c-1.73-0.508,1.832-2.748,1.832-2.748s-7.327-1.828-8.751-2.135c-1.321-0.305-9.258,1.318-10.378,1.318-1.119,0-1.628-1.832-1.628-1.832s-1.935,1.631-3.562,2.141c0,0-1.322-3.256-0.507-3.563,0,0-5.188,1.424-5.494,2.748,0,0-1.322-2.136-1.12-3.052,0,0-2.441,3.867-3.561,4.679-1.12,0.815-0.204-1.933-0.204-1.933s-3.05,3.865-4.17,4.172v-2.748s-8.751,4.681-11.191,4.072c0,0,0-1.936,0.813-2.442l-5.494-0.306c-1.32-0.203-2.949-0.812-4.373-1.119-1.322-0.205,1.933-1.627,4.171-1.018,0,0-6.104-2.238-7.937-1.121,0,0-0.814-2.236,2.44-3.052,0,0-4.172-4.069-6.614-3.765,0,0,2.748-1.627,4.986-0.815,0,0-2.544-6.917-4.172-7.731,0,0,5.8-1.018,7.427-0.201l0.002-0.002z'/%3E %3Cg id='axe'%3E %3Cpath fill='%23730000' stroke='%23000' stroke-width='0.5087' d='m259.27,196.67,74.064-38.361c0.355-1.982-0.771-3.54-1.932-5.088-21.18,10.387-40.456,22.992-63.992,30.628-1.322,0.51-13.022,5.393-19.025,12.619-1.903,1.908-2.043,4.724-2.043,4.724s0.146,3.231,0.825,4.104c0,0,0.176,0.887,1.282,1.596-0.012,0,0.684,0.341,1.166,0.169,0.538,0.101,1.413,0.094,2.635-2.045,1.222-2.037,5.189-6.716,7.02-8.346z'/%3E %3Cpath d='m318.89,158.72,9.562-4.58s3.257,2.442,2.951,5.19c0,0,0.712,6.307,8.547,10.682,0,0-6.615,8.241-18.211,8.955,0,0,1.33-10.876-1.11-14.032,0,0-0.406,0.389-0.23-0.15,0.347-1.058-0.235-4.688-1.72-5.487-0.181-0.099,0.118-0.396,0.211-0.578z' stroke='%23000' stroke-width='0.50870001' fill='%23FFF'/%3E %3Cg fill='none' stroke='%237e4b7e' stroke-width='0.8139'%3E %3Cpath d='m330.08,160.04c-2.034,0.814-8.647,4.272-8.647,4.272'/%3E %3Cpath d='m326.93,162.07c-0.103,1.017-0.713,3.459,0,5.189'/%3E %3Cpath d='m326.01,162.38c0,0.508-0.813,2.34,0.103,4.783'/%3E %3Cpath d='m325,162.89c-0.204,1.021-0.406,1.63,0,2.751'/%3E %3Cpath d='m324.18,163.5c-0.203,0.609,0,0.916,0,1.321'/%3E %3Cpath d='m330.18,163.19c0.304,0.812,3.052,5.086,4.68,6.816'/%3E %3Cpath d='m330.59,165.12c0.307,0.814,1.832,3.765,2.951,4.886'/%3E %3Cpath d='m330.39,166.85c0.406,1.018,1.221,2.85,2.034,3.866'/%3E %3Cpath d='m330.39,168.89c0.204,0.815,0.61,1.832,1.221,2.546'/%3E %3C/g%3E %3C/g%3E %3Cg id='paddle' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='%23b34b00' d='m398.22,154.46,27.207,13.322c5.451,2.65,7.411,0.202,10.487,1.539l53.694,27.351c4.606,2.012,7.185,2.656,6.523,5.039-0.112,3.786,1.79,3.843,2.31,3.883,0.376,0.101,2.191-0.165,2.949-1.172,0.568-0.656,0.589-0.724,0.589-0.724,0.608-0.608,0.498-0.663,0.687-0.934,2.258-3.249,3.509-6.065,1.146-7.905-2.702-1.266-3.013,1.607-5.858,1.304,0,0-5.087-1.933-6.919-3.256-3.374-1.837-8.084-4.015-9.155-5.211-3.428-0.642-29.233-15.157-43.852-22.442-1.568-1.313-2.422-6.166-5.503-7.79-0.904-1.312-20.694-10.347-31.043-15.52-3.814-1.425-5.949-2.401-8.697,2.28-2.398,4.59-1.815,7.094,5.435,10.236z'/%3E %3Cpath fill='none' d='m400.52,148.76,30.458,15.208'/%3E %3C/g%3E %3Cg id='white_man' fill='%23ffa54b' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='url(%23white_skin)' d='m309.73,165.12c-0.203,0.61-0.712,0.203-0.712,0.408-0.405,2.135-0.305,3.253-0.813,4.475-0.712,1.424-3.256,2.748-3.154,2.645-2.034,0.609-4.475,3.054-8.442,0.814-0.204-0.101-0.406-0.306-0.61-0.508,0,0,1.117,4.169-2.95,6.204-1.424,0.713-15.77,8.244-15.77,8.244s-1.526,2.748-0.509,6.512c0.103,0.61,0.305,1.118-0.305,1.526-0.916,0.71-2.646,2.748-3.662,6.004,0,0-3.053-1.324-3.053-3.256,0-1.934,1.221-2.951,1.526-4.378,0.304-1.321,1.117-4.679,0.712-5.698-0.406-1.119-2.238-1.526-2.95-1.933-0.61-0.408-1.425,0.406-1.322,1.322,0.103,1.018,0.813,0.812,1.628,1.018,0,0-0.916,1.932-0.813,3.356l-9.258,4.783s1.22,1.626,1.627,2.34c0.405,0.712,1.321,10.175,4.069,14.653,2.747,4.477,3.663,3.256,4.273,3.866,0.508,0.508,1.321,1.321,2.034,1.934,0.712,0.508,3.865,0.811,4.477-0.916,0.712-1.631,1.22-2.647,3.154-4.174,1.933-1.524,5.899-5.391,5.899-7.123,0,0,2.34,6.716,2.034,12.313,0,0,8.546,1.731,16.177,1.932,7.632,0.105,11.497-1.524,11.497-1.524s1.018-6.409,0.608-7.631c0,0,1.221,4.172,2.137,5.596,1.019,1.727,2.136,5.288,4.374,5.493,2.137,0.101,3.969-2.135,4.171-3.051v-6.716h8.647c0-0.101,3.866,1.424,5.086,1.22,1.221-0.102,1.933-1.22,0.813-1.628l-0.405-0.303c1.117,0,2.543,0.71,2.543,0.71h4.271c0.103-0.101,0-0.408-0.103-0.508-0.305-1.222-2.544-2.24-4.17-2.95-1.629-0.609-3.459-1.324-4.681-1.424-1.932-0.206-3.256-0.101-6.206,0.408-0.813,0.101-3.865,0.405-5.799,1.321-0.509,0.306-1.019,0.406-0.813-0.916,0.306-1.426,0.204-7.835-1.32-10.583-1.12-1.932-1.018-3.562-0.814-5.188,0.104-1.63,0.204-7.225,0-8.854-0.306-1.627-2.544-3.867-6.611-4.375-3.866-0.511-7.123-3.664-7.325-6.207-0.305-2.542,0.408-7.223,0.814-9.257'/%3E %3Cg fill='none'%3E %3Cpath fill='url(%23white_skin)' d='m292.44,153.63c-0.712,3.253-0.712,6.104-0.609,9.257,0.102,2.135,1.118,4.577,2.034,6.715,0.609,1.426,1.425,3.052,2.746,3.867,3.562,2.34,6.919-0.203,8.852-1.017,0.916-0.308,2.341-1.626,2.747-2.442,0.508-1.219,0.303-2.135,0.812-4.475-0.103,0.1,0.813-0.408,0.712-0.408,0.916-1.526,0.712-2.034,1.221-3.054,0.509-1.018-0.609-2.136-1.832-1.931,0.609-1.933,1.019-4.072,0.405-5.904-0.202-0.608,0.51-2.235-0.608-1.832-4.579,1.832-9.97,1.426-14.854,1.426-0.406,0-0.712-0.815-1.321-0.71-0.103,0-0.204,0.303-0.307,0.505'/%3E %3Cpath fill='%23000' d='m292.03,155.35c-0.508-0.406-0.61-1.319,0-3.256,0.712-1.929,0-2.034,1.119-3.153,1.12-1.12,0.814-1.629,1.526-1.932,0.712-0.206,2.849-0.206,3.562-0.508,0.609-0.308,1.525-0.714,2.947-0.916,1.526-0.308,4.579-0.206,6.003,0.608,1.526,0.812,2.544,2.85,3.46,3.561,1.02,0.71,1.63,3.661,1.426,7.938-0.307,4.272-1.12,3.458-1.12,3.458s-1.222-2.034-2.238-0.308c0,0,0-1.626,0.204-2.848,0.102-1.219-0.61-3.458,0.102-4.985,0,0-5.8,1.832-8.751,1.729-3.051-0.202-7.322-0.916-7.526-1.626l-0.714,2.238'/%3E %3Cpath fill='%23fff' stroke='%23fff' d='m294.98,151.8c-0.305-0.61-1.832-2.85-0.609-3.561,1.12-0.612,0.406,2.745,1.935,3.458,0,0-0.509,1.526-1.321,0.102l-0.005,0.001z'/%3E %3Cpath d='m298.34,160.14c-0.508,1.732-0.712,2.138-0.916,3.156'/%3E %3Cpath d='m308.01,164.92c0.204,0.61,0.404,0.303,0.914,0.405'/%3E %3Cpath d='m309.33,161.36c0.509-0.609,1.221-0.303,0.813,1.223'/%3E %3Cpath d='m292.44,157.7c0.916,0.303,1.832,0.608,2.748,1.02,1.526,0.61,0.61,2.845,0.204,4.271-0.204,0.714-1.019,1.933-0.609,2.546,0.508,0.811,1.119,0.303,2.035,0.403,0-0.303,0.609-0.508,0.813-0.508,0.712-0.1,1.12,0.508,1.627,0.308,0.61-0.308,0.51-1.224,0.306-1.731'/%3E %3Cpath d='m299.46,159.53c0.102-0.403,1.018-0.811,1.526-0.915,2.136-0.405,3.661-0.712,5.393,0.511'/%3E %3Cpath d='m300.68,170.21c-1.729,0.408-3.561,0.71-5.188-0.206'/%3E %3Cpath d='m295.49,169.2c0.813-0.408,1.12-0.816,2.137-0.308,0-0.101,1.12-0.405,1.12-0.405,0.812,0,1.322,0.304,2.136,0.812'/%3E %3Cpath d='m295.39,169.6c0.916-0.306,3.358-0.306,5.394,0.102'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m292.34,160.14c0.713-0.1,1.526-0.916,3.154,0.306,1.12,0.712-1.832,1.426-1.322,1.324-1.32,0.202-1.729-0.508-1.828-1.122,0-0.202-0.204-0.508,0-0.508h-0.004z'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m300.68,160.95c0.712-1.426,1.832-1.119,2.849-0.816,1.019,0.306,0.713,0.105,1.629,0.613-1.12,0.203-0.814,0.303-1.629,0.71-0.916,0.408-1.729,0.61-2.341,0.206-0.204-0.206-0.712-0.508-0.712-0.916-0.001,0.101,0.102,0.203,0.204,0.203z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m293.76,161.36c0.406,0,0.712-0.406,0.712-0.814,0-0.508-0.306-0.916-0.712-0.916-0.507,0-0.812,0.408-0.812,0.916,0,0.408,0.303,0.814,0.812,0.814z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m302.41,161.56c0.405,0,0.712-0.403,0.712-0.916,0-0.508-0.407-0.811-0.813-0.811-0.405,0-0.712,0.303-0.712,0.811-0.001,0.514,0.407,0.916,0.813,0.916z'/%3E %3C/g%3E %3Cg id='body' stroke='%23000' stroke-width='0.5087'%3E %3Cg fill='none'%3E %3Cpath d='m345.85,213.66c-0.608-0.714-1.018-1.02-1.83-1.324-0.609-0.303-1.424-0.71-2.036-1.016-0.712-0.408-1.729-0.508-2.34-0.916'/%3E %3Cpath d='m340.05,213.05c-0.306-0.203-0.508-0.304-0.812-0.51-0.306-0.101-0.712-0.101-1.02-0.203-0.102,0-0.102-0.204-0.203-0.204-0.915-0.102-1.831-0.51-2.44-1.321'/%3E %3Cpath d='m272.8,201.45c0.914,0.71,3.152,2.24,3.356,5.19,0.204,1.525,1.019,3.051,1.019,3.051'/%3E %3Cpath d='m264.05,201.86c0.51,1.727,0.61,7.425,6.003,13.43'/%3E %3Cpath d='m265.07,193.92c-0.408,1.119-0.916,2.137,0.202,2.951'/%3E %3Cpath d='m279.72,207.56c1.12-2.545,4.578-2.342,4.578-4.782'/%3E %3Cpath d='m284.81,207.25c-0.306-2.849-0.916-4.475-0.405-8.647,0.203-1.223,0.405-5.9,0-8.141,0,0,1.629,7.833-3.662,9.363'/%3E %3Cpath d='m315.13,212.34c0-3.97,0.916-6.209,0.916-6.209,1.221-5.593-1.119-7.731-0.203-9.155,0.812-1.221,2.035-3.766,0.407-8.854,0,0,2.847,10.484-4.478,10.484-7.425,0-7.121-2.748-7.121-2.748'/%3E %3Cpath d='m284.4,190.46c0,2.135,0,8.447,9.055,8.447,2.746,0,5.698-1.933,7.324-3.256'/%3E %3Cpath d='m303.02,192.9c-0.306-1.934-0.306-4.375-0.306-6.92'/%3E %3Cpath d='m289.08,182.53c2.441-0.308,4.376-0.61,8.955-0.61'/%3E %3Cpath d='m298.34,175.6c0.509,2.24-0.304,5.8,3.866,6.309'/%3E %3Cpath d='m306.58,174.79c-0.61,1.629-0.61,3.256-0.814,4.375'/%3E %3Cpath d='m305.97,181.92c1.73,0,4.985-1.121,9.054-0.306'/%3E %3Cpath d='m316.45,204.4c0.813,1.63,1.018,3.765,3.561,6.207'/%3E %3Cpath d='m288.27,199.21c0.204,1.324-1.729,5.698-0.306,9.262,1.322,3.559,1.12,7.631-1.12,11.089'/%3E %3Cpath d='m293.46,200.54c-0.813,1.626-2.238,3.256-2.544,4.68'/%3E %3Cpath d='m297.52,203.59c0,1.018-2.744,8.749-4.68,10.886,0,0,3.561,1.424,3.051,6.614'/%3E %3Cpath d='m303.22,200.03c0,1.324-0.204,1.63,0.916,2.44'/%3E %3Cpath d='m306.58,202.47c1.32,1.628,5.492,6.514,4.576,9.259'/%3E %3Cpath d='m303.83,205.22c0.306,1.018,0.306,6.309-0.61,8.955'/%3E %3Cpath d='m301.09,213.97c-1.12,0-2.746,0.814-3.052,2.747'/%3E %3Cpath d='m306.78,213.66c1.118-0.306,3.355,1.626,3.355,7.123'/%3E %3Cpath d='m325.81,210.51c-2.136,0.61-3.052,1.732-2.44,1.119-1.12,0.916-2.138,1.526-2.138,1.526'/%3E %3C/g%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m289.79,197.99c0.608,0,1.118-0.408,1.118-0.916,0-0.411-0.507-0.816-1.118-0.816-0.509,0-1.02,0.405-1.02,0.816,0,0.505,0.508,0.916,1.02,0.916z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m312.89,198.3c0.51,0,1.02-0.405,1.02-0.916,0-0.505-0.508-0.811-1.02-0.811-0.607,0-1.118,0.306-1.118,0.811-0.001,0.511,0.51,0.916,1.118,0.916z'/%3E %3Cpath fill='%23fff' d='m280.54,239.81c1.22-7.937,4.985-14.551,5.086-15.162,0,0,3.865,0.816,10.58,1.424,6.612,0.71,8.444,0.408,11.496,0.202,2.949-0.303,6.815-0.811,6.815-0.811s1.221,2.44,1.322,4.883c0.305,5.188,2.236,27.677,2.439,33.679,0,0,0.814,3.562,0.814,12.312,0,9.567,2.645,28.999,2.645,39.381l-2.645,0.51s-14.446,1.119-14.446-0.814c0-2.135-0.813-27.066,1.322-42.126,0,0-0.508-2.95-1.322-5.496-0.813-2.442-4.375-10.073-4.375-11.698,0,0-5.695,16.072-6.001,18.824-0.304,2.543-1.12,38.357-1.628,41.312,0,0-8.241,6.308-9.36,6.92-1.118,0.509-9.054-3.36-9.258-4.375-0.306-1.118,0.814-13.229,4.578-33.176,1.425-7.123,0.61-8.44,0.61-10.375,0-1.934,0.103-27.474,1.322-35.412l0.006-0.002z'/%3E %3Cg fill='none'%3E %3Cpath d='m294.27,274.92c-0.609,2.24-1.628,4.375-3.559,5.803'/%3E %3Cpath d='m287.96,227.09c-0.304,1.322-2.238,7.325-7.122,10.887'/%3E %3Cpath d='m295.08,228.21c-1.12,3.562-5.493,22.693-6.309,45.383'/%3E %3Cpath d='m288.47,280.72c-0.204,2.135-1.322,18.012-1.628,20.756'/%3E %3Cpath d='m286.03,304.53c-0.509,1.117-2.746,10.375-2.746,18.619'/%3E %3Cpath d='m315.53,287.23c-0.204,1.933-1.019,15.668,3.561,27.98'/%3E %3Cpath d='m300.58,229.23c-0.305,2.237-0.813,16.688-0.813,17.806,0,1.117,1.628,2.747,2.441,3.054,0,0-1.628,0.509-1.933,6.003'/%3E %3Cpath d='m296.2,243.17c-0.308,1.727-1.934,8.547-3.054,11.295'/%3E %3Cpath d='m306.27,229.03s4.884,1.018,5.188,0c0,0,1.628,29.512,3.866,45.891'/%3E %3Cpath d='m304.14,232.79c0,1.934-0.609,16.485-0.609,16.485'/%3E %3Cpath d='m305.97,251.41s1.931,2.745,1.425,4.066'/%3E %3Cpath d='m289.59,227.4c1.629,0.508,3.053,0.812,3.053,0.812'/%3E %3Cpath d='m297.83,229.84c-0.307,0.814-0.61,4.58-0.61,4.58'/%3E %3Cpath d='m305.97,273.29c0.61,0.814,1.425,1.936,0.814,4.377'/%3E %3C/g%3E %3Cpath fill='%239b5f00' d='m284.91,224.45s0-3.256,1.22-4.886c0,0,3.457,0.714,8.342,1.222,4.984,0.508,8.951,0.916,12.615,0.508,3.663-0.406,7.428-1.322,7.428-1.322s1.017,4.784,0.506,5.496c0,0-3.968,0.814-8.341,1.016-4.477,0.303-11.902-0.408-14.445-0.812-3.359-0.408-6.31-1.02-7.325-1.222z'/%3E %3Cpath fill='%23fff' d='m288.06,224.85,0.608-4.883,1.019,0.1-0.203,5.088-1.424-0.305'/%3E %3Cpath fill='%23fff' d='m310.14,220.78,0.103,5.496,1.221-0.206-0.102-5.597-1.222,0.307'/%3E %3Cpath fill='%23fff' d='m294.47,220.78-0.406,5.291h0.713l0.712-5.291h-1.019'/%3E %3Cg%3E %3Cpath d='m276.77,320.81c-0.305,1.322-0.812,3.154-1.018,5.496,0,0.508-0.507,3.256,1.018,3.356,1.12,0.103,1.425-2.849,1.425-2.849s-1.019,3.256,0.305,3.664c1.832,0.403,2.034-3.562,2.034-3.562-0.204,1.119-1.425,3.969,0.306,4.271,1.831,0.307,2.339-3.867,2.339-3.867s-1.525,4.174,0.305,4.275c1.729,0.1,1.729-4.072,1.729-4.072s-0.916,4.988,1.526,4.58c1.321-0.203,1.628-1.934,1.933-2.951,0.406-1.524,1.322-3.457,0.204-6.612-0.812-2.341-0.507-2.951-0.507-2.951s-2.85,2.138-5.087,3.562c-1.019,0.609-6.514-2.34-6.514-2.34z'/%3E %3Cpath d='m306.48,316.43c-0.508-0.307-0.406,1.832-0.609,2.846-0.103,1.021,0.204,3.257,3.663,3.055,3.355-0.307,6.715-1.018,8.851-0.509,2.137,0.61,5.289,0.711,7.021,0.711,1.729,0,2.849-0.202,3.661-0.509,0.713-0.303,2.238,0.408,2.95,0.408,0.713,0,1.831-1.119,1.73-1.832-0.103-1.324-1.322-1.324-3.054-1.424-1.628-0.203-3.865-0.511-4.983-0.916-1.12-0.408-3.154-1.527-5.698-2.035,0,0-4.883,0.205-5.898,0.205-1.019,0-7.022,0.303-7.634,0z'/%3E %3C/g%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23ffb366' d='m255.71,189.85c-0.507,0.306-1.12-2.035,0.406-2.951,0,0,0.406-1.931,2.035-2.136,0,0,1.321-1.832,3.257-1.626,0,0,2.235-1.525,3.051-1.324,0.812,0.102,2.849,2.136,2.95,2.85,0.204,0.711,0,1.933-0.511,2.442-0.609,0.608-1.018-0.102-1.119-0.916,0,0,0.407,1.524-0.813,2.135-1.219,0.714-1.119,0.206-1.219-0.61,0,0-0.308,1.63-1.12,1.832-0.814,0.305-1.322-0.408-1.935-0.408,0,0,1.019,0.816,0.307,1.426-0.713,0.508-1.526,0.303-2.036-0.102-0.509-0.508-1.12-1.832-3.257-0.61l0.004-0.002z'/%3E %3Cpath d='m265.68,186.09c-0.51-1.629-2.137-3.054-4.069-2.848'/%3E %3Cpath d='m263.85,187.61c-0.306-0.408-0.408-0.816-0.712-1.22-0.916-1.528-2.849-1.424-4.477-1.832'/%3E %3Cpath d='m261.1,189.14c-0.609-0.406-0.813-1.222-1.425-1.524-1.018-0.408-2.034-0.916-3.255-0.714'/%3E %3C/g%3E %3C/g%3E %3Cg id='black_man' stroke='%23000' stroke-width='0.5087'%3E %3Cpath fill='url(%23black_skin)' d='m439.14,165.12c0.712-0.306,0.51,0.61,0.61,0.916,0.306,1.321,0.306,2.748,0.813,3.967,0.608,1.119,0.812,1.526,1.83,2.035,1.627,0.916,6.407,3.562,9.767,1.424,0.204-0.101,0.508-0.306,0.712-0.508,0,0-1.221,4.172,2.95,6.207,1.321,0.71,15.668,8.241,15.668,8.241s1.525,2.748,0.609,6.512c-0.204,0.61-0.405,1.118,0.204,1.526,1.019,0.71,2.644,2.748,3.766,6.004,0,0,2.947-1.324,2.947-3.256,0-1.934-1.219-2.951-1.525-4.375-0.202-1.324-1.017-4.682-0.608-5.698,0.405-1.118,2.135-1.526,2.847-1.936,0.714-0.408,1.526,0.406,1.322,1.322-0.102,1.018-0.812,0.816-1.628,1.018,0,0,1.02,1.932,0.814,3.356l9.358,4.783s-1.221,1.629-1.628,2.34c-0.509,0.715-1.425,10.175-4.171,14.653-2.748,4.477-3.663,3.256-4.171,3.866-0.61,0.508-1.424,1.324-2.137,1.934-0.608,0.508-3.764,0.814-4.476-0.916-0.712-1.628-1.221-2.647-3.153-4.174-1.934-1.524-5.9-5.391-5.9-7.123,0,0-2.341,6.719-2.035,12.313,0,0-8.443,1.731-16.176,1.936-7.631,0.102-11.497-1.528-11.497-1.528s-1.018-6.409-0.61-7.631c0,0-1.22,4.172-2.033,5.596-1.118,1.727-2.236,5.291-4.375,5.493-2.236,0.104-3.968-2.135-4.271-3.051v-6.716h-8.646c0-0.101-3.766,1.424-5.087,1.223-1.221-0.105-1.832-1.223-0.813-1.631l0.407-0.303c-1.119,0-2.544,0.71-2.544,0.71h-4.272c0-0.101,0.103-0.408,0.103-0.508,0.307-1.219,2.545-2.24,4.272-2.95,1.628-0.609,3.356-1.324,4.578-1.424,1.933-0.203,3.256-0.101,6.206,0.408,0.812,0.101,3.967,0.408,5.798,1.322,0.508,0.304,1.118,0.405,0.813-0.915-0.305-1.426-1.221-5.598,0.307-8.346,1.018-1.933,0.916-3.559,0.813-5.189-0.204-1.729-1.118-5.598-1.118-7.325,0-5.699,4.375-8.039,8.24-9.262,4.272-1.319,7.121-2.748,6.92-5.288-0.104-2.646,0.608-7.021,0.202-9.058'/%3E %3Cg fill='none'%3E %3Cpath fill='url(%23black_skin)' d='m456.34,153.63c0.916,3.356,1.12,4.169,1.12,5.291,0,1.219-0.509,1.424-0.104,2.748,0.713,2.441-0.712,5.088-2.441,7.937-0.813,1.32-1.424,3.052-2.746,3.866-3.356,2.135-7.427-0.408-9.563-1.327-1.117-0.505-1.729-1.319-2.033-2.135-0.407-1.219-0.509-2.34-0.813-3.967,0-0.306,0.103-1.219-0.609-0.916-1.22-1.424-1.018-2.034-1.524-3.051-0.509-1.021,0.916-2.139,2.034-1.934-0.61-1.933-0.916-4.072-0.306-5.904,0.204-0.608-0.508-2.235,0.51-1.832,4.577,1.832,9.969,1.426,14.854,1.426,0.404,0,0.71-0.812,1.32-0.71,0.098-0.001,0.2,0.305,0.301,0.508'/%3E %3Cpath fill='%23000' d='m456.75,155.35c0.508-0.406,0.204-2.34-0.306-4.375-0.203-1.017-1.018-1.424-2.136-2.542-1.12-1.122-1.525-1.122-2.236-1.424-0.609-0.206-2.034-0.206-2.746-0.508-0.61-0.308-2.238-0.105-3.766,0.101-2.036,0.304-3.153,0.202-4.679,1.018-1.526,0.814-2.746,1.73-3.256,3.256-0.406,1.118-1.12,2.542-0.814,6.817,0.204,4.272,1.019,3.458,1.019,3.458s1.12-1.628,1.832-0.61c0,0-0.103-2.24-0.305-3.561-0.103-1.222,0-2.748,0.509-4.58,0,0,4.679,1.732,9.054,1.732,3.053,0,7.021-0.306,7.123-1.017l0.71,2.235h-0.003z'/%3E %3Cpath d='m450.44,160.14c0.61,1.732,0.104,1.222,0.408,2.34'/%3E %3Cpath d='m440.57,164.51c0,0.812-0.61,0.61-1.019,0.61'/%3E %3Cpath d='m456.85,158.82c-0.916-0.713-2.645-0.204-3.46,0.102-1.525,0.71-0.712,2.24-0.204,3.664,0.204,0.71,1.02,1.727,0.511,2.441-0.407,0.812-0.713,0.408-1.629,0.51,0.104-0.308-0.812,0-1.117,0-0.61-0.102-0.916,0.403-1.426,0.202-0.608-0.304-0.508-1.22-0.306-1.729'/%3E %3Cpath d='m449.32,159.53c0-0.403-1.321-0.811-2.745-0.915-2.238-0.102-2.442,0.104-4.172,1.322'/%3E %3Cpath d='m453.9,168.89c-0.405-0.608-1.018-0.916-2.137-0.405,0-0.204-1.524-0.406-1.524-0.406-0.812,0-1.321,0.303-2.136,0.71'/%3E %3Cpath d='m453.69,169.4c-0.916-0.609-3.256-0.201-5.596-0.201'/%3E %3Cpath d='m448.3,170.01c1.73,0.512,3.46,0.816,5.188,0'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m456.44,160.14c-0.712-0.1-1.018-0.916-3.153,0.306-1.119,0.61,1.832,1.426,1.425,1.324,1.22,0.202,1.628-0.508,1.729-1.122-0.001-0.203,0.203-0.508-0.001-0.508z'/%3E %3Cpath fill='%23fff' stroke-width='0.3052' d='m448.1,160.95c0-0.816-1.829-1.119-2.847-0.816-1.019,0.306-0.61,0.105-1.526,0.613,1.02,0.203,0.712,0.303,1.526,0.71,0.914,0.408,1.12,0.814,2.339,0.206,0.306-0.105,0.712-0.508,0.813-0.916-0.101,0.101-0.202,0.203-0.305,0.203z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m455.12,161.36c-0.508,0-0.813-0.406-0.813-0.814,0-0.508,0.307-0.916,0.813-0.916,0.405,0,0.712,0.408,0.712,0.916,0,0.408-0.307,0.814-0.712,0.814z'/%3E %3Cpath fill='%23000' stroke-width='0.3052' d='m446.37,161.56c-0.406,0-0.712-0.403-0.712-0.916,0-0.508,0.403-0.811,0.812-0.811s0.712,0.303,0.712,0.811c0,0.514-0.303,0.916-0.812,0.916z'/%3E %3C/g%3E %3Cuse xlink:href='%23body' fill='%23730000' transform='matrix(-1,0,0,1,748.81578,0)'/%3E %3Cg fill='none'%3E %3Cpath fill='%23730000' d='m491.64,193.51c0.508,0.206,1.934-2.033,0.508-3.051,0,0-0.508-1.932-2.136-2.034,0,0-1.322-1.933-3.257-1.63,0,0-2.136-1.524-2.948-1.421-0.916,0.202-2.951,2.237-3.053,2.95-0.102,0.609,0,1.832,0.508,2.441,0.61,0.51,1.02-0.104,1.119-1.02,0,0-0.405,1.529,0.813,2.24,1.221,0.71,1.119,0.1,1.221-0.71,0,0,0.306,1.626,1.12,1.932,0.812,0.303,1.321-0.408,1.934-0.408,0,0-1.018,0.815-0.305,1.324,0.713,0.61,1.525,0.303,2.035-0.104,0.61-0.404,0.306-1.727,2.441-0.509z'/%3E %3Cpath d='m482.49,189.75c0.506-1.73,2.235-3.153,4.067-2.849'/%3E %3Cpath d='m484.42,191.28c0.203-0.411,0.305-0.816,0.61-1.224,0.915-1.524,2.948-1.524,4.576-1.832'/%3E %3Cpath d='m487.06,192.7c0.61-0.408,0.814-1.118,1.426-1.421,1.018-0.512,2.136-0.916,3.256-0.714'/%3E %3Cpath fill='%23730000' stroke='none' d='m482.31,186.77c-0.896,0.716-1.837,1.798-1.906,2.281-0.103,0.61-0.008,1.827,0.5,2.438,0.551,0.461,0.949-0.017,1.095-0.781-0.059,0.463-0.071,1.465,0.844,2,1.22,0.71,1.118,0.095,1.219-0.719,0,0,0.312,1.635,1.125,1.938,0.813,0.306,1.325-0.406,1.938-0.406,0,0-1.026,0.804-0.312,1.312,0.712,0.61,1.522,0.309,2.031-0.094,0.61-0.408,0.3-1.722,2.438-0.5,0.267,0.106,0.804-0.452,1.031-1.156l-7.688-5.531-2.315-0.782z'/%3E %3Cpath d='m480.68,188.19c-1.502,2.582,0.5,4.132,1.164,2.619-0.193,2.386,1.606,2.292,2.285,1.538,0.658,2.512,1.83,1.395,2.909,1.164-1.223,2.29,1.479,1.609,2.12,1.081,0.924-1.362,1.356-0.277,2.036-0.416l1.164-1.247'/%3E %3Cpath d='m484.38,187.23c-1.686,0.896-2.512,2.137-2.535,3.699'/%3E %3Cpath d='m486.71,188.73c-1.687,0.896-2.512,2.137-2.535,3.699'/%3E %3Cpath d='m489.58,190.68c-1.687,0.897-1.765,1.722-2.493,2.826'/%3E %3C/g%3E %3C/g%3E %3Cg fill='%235ac800'%3E %3Cpath d='m290.1,323.66-0.204-4.68,1.934,1.629,0.508-3.562c0.813-0.206,2.137,1.426,2.137,1.426l-0.204-3.564,2.95,3.257s-0.203-2.748,0.812-4.377c0,0,2.237,1.935,2.237,4.172,0,1.938,1.934-2.748,1.934-2.748,0.509,1.63,1.628,5.19,1.628,5.19l1.321-1.934,1.12,4.07,2.442-3.562,1.931,4.174,4.375-0.307,0.509,2.439,1.933-2.135,2.544,1.627s2.137-0.609,3.256-0.609,2.442,1.426,2.442,1.426,0.813-1.426,1.628-1.938c0.812-0.506,1.935,0.816,2.236,1.63l1.629-2.95s2.137,2.137,2.441,2.95c0,0,0.304-2.44,0.813-3.257,0.51-0.813,1.321,0.307,1.933,1.324l1.322-4.375s1.425,0.303,2.441,1.934c1.117,1.626,1.117-2.441,1.117-2.441s2.441,3.256,3.052,5.493c0,0-16.846,5.784-28.726,4.203-13.983-1.862-25.501-4.507-25.501-4.507'/%3E %3Cpath d='m405.57,323.15s0.813-2.239,1.935-3.36c0,0,2.136,2.546,2.136,3.36,0,0,0.608-0.305,1.729-1.121l1.628,1.627,1.935-1.32,1.832,1.626,3.356-1.424,1.322,1.424,5.188-0.606,1.933,0.812,1.832-2.341,1.73,1.832,2.746-2.748s1.322,1.118,1.628,1.935c0,0,2.238-1.117,2.747-1.935,0,0,2.136-0.813,2.44,0.509,0,0,1.322-1.018,1.222-2.135-0.102-1.118,1.525-0.307,2.034,1.117,0,0,0.609-2.235,2.236-2.44,0,0,1.118,1.319,0.813,3.767,0,0,2.441-1.938,3.561-2.141,0,0,0.508,2.748-0.305,5.193,0,0,2.543-4.174,3.053-2.748,0.204,0.812,0.814,3.561,0.204,5.492l2.238-1.424,0.812,2.748,2.44-0.509s-14.442,2.212-28.05,0.914c-13.607-1.298-26.376-6.104-26.375-6.104'/%3E %3Cpath d='m395.51,333.25c0.661-0.408-4.546,10.708-17.17,11.299-17.563,0.823-32.577-7.94-32.577-7.94s1.832-3.051,2.949-3.867c0,0,2.441,1.936,3.256,4.375,0,0,0.306-1.627,1.12-3.051,0,0,3.052,1.422,3.561,3.358,0,0,1.12-1.935,1.934-2.442,0.812-0.612,1.628,2.135,1.628,3.766,0,0,1.932-2.038,3.052-2.139,0,0,2.137,1.017,2.747,4.58,0,0,2.035-1.933,2.746-1.631,0,0,2.442,1.631,1.83,3.867-0.304,1.223,2.442-1.421,5.801-2.236l2.949,2.236s2.746-3.66,3.561-4.885c0,0,2.238,0.816,2.238,2.141,0,0,1.019-3.869,1.832-4.275,0.812-0.508,1.931,1.22,1.931,2.342,0,0,0.307-2.952,1.935-3.562,0,0,1.628,1.118,1.628,2.24-0.003-0.002,1.726-3.36,3.049-4.176z'/%3E %3C/g%3E %3Cg stroke-width='0.5087' stroke='%23060' fill='none'%3E %3Cpath d='m290.1,323.66-0.204-4.68,1.934,1.629,0.508-3.562c0.813-0.203,2.137,1.426,2.137,1.426l-0.204-3.561,2.95,3.256s-0.203-2.748,0.812-4.375c0,0,2.237,1.934,2.237,4.172,0,1.936,1.934-2.748,1.934-2.748,0.509,1.631,1.628,5.191,1.628,5.191l1.321-1.936,1.119,4.069,2.441-3.56,1.933,4.172,4.375-0.307,0.509,2.443,1.933-2.137,2.544,1.629s2.135-0.609,3.255-0.609,2.442,1.422,2.442,1.422,0.812-1.422,1.628-1.931c0.812-0.509,1.933,0.812,2.235,1.626l1.629-2.949s2.137,2.137,2.441,2.949c0,0,0.305-2.439,0.814-3.256,0.51-0.812,1.321,0.307,1.933,1.324l1.322-4.375s1.424,0.303,2.44,1.933c1.12,1.626,1.12-2.444,1.12-2.444s2.44,3.258,3.054,5.495'/%3E %3Cpath d='m405.57,323.15s0.812-2.235,1.933-3.356c0,0,2.136,2.545,2.136,3.356,0,0,0.61-0.305,1.73-1.117l1.628,1.626,1.933-1.32,1.832,1.627,3.358-1.424,1.319,1.424,5.188-0.608,1.935,0.812,1.83-2.337,1.73,1.828,2.746-2.744s1.322,1.115,1.628,1.932c0,0,2.238-1.119,2.747-1.932,0,0,2.135-0.814,2.439,0.505,0,0,1.322-1.017,1.221-2.135-0.103-1.118,1.525-0.304,2.034,1.122,0,0,0.609-2.24,2.238-2.445,0,0,1.118,1.323,0.812,3.766,0,0,2.441-1.932,3.561-2.137,0,0,0.509,2.745-0.304,5.189,0,0,2.544-4.172,3.052-2.747,0.204,0.812,0.814,3.562,0.204,5.493l2.238-1.424,0.813,2.748,2.44-0.51'/%3E %3Cpath d='m345.68,336.63s1.832-3.051,2.949-3.866c0,0,2.442,1.934,3.256,4.375,0,0,0.308-1.627,1.12-3.051,0,0,3.053,1.42,3.561,3.357,0,0,1.12-1.934,1.934-2.441,0.813-0.613,1.628,2.135,1.628,3.764,0,0,1.933-2.037,3.053-2.138,0,0,2.136,1.017,2.746,4.58,0,0,2.036-1.933,2.746-1.63,0,0,2.442,1.63,1.831,3.867-0.305,1.221,2.442-1.422,5.8-2.237l2.949,2.237s2.746-3.662,3.561-4.885c0,0,2.238,0.814,2.238,2.139,0,0,1.019-3.869,1.832-4.273,0.812-0.508,1.931,1.219,1.931,2.34,0,0,0.307-2.951,1.936-3.562,0,0,1.628,1.118,1.628,2.239,0,0,1.729-3.356,3.052-4.174'/%3E %3C/g%3E %3C/g%3E %3Cg id='motto'%3E %3Cg fill='%23fff'%3E %3Cpath d='m374.44,376.98c22.892,0.205,36.424-8.141,43.851-13.127,17.396-11.699,21.059-12.107,23.908-11.906,3.257,0.309,8.035,1.427,8.24,4.277,0.306,4.375-6.815,6.307-10.886,6.307-4.17,0-15.058-2.748-15.058-2.748l-2.85,1.936c1.934,0.916,24.215,8.342,28.488,1.323,4.372-7.122,8.749-18.622,8.749-18.622s-4.883-8.751-15.771-8.751c-10.987,0-21.671,6.922-28.791,12.106-7.123,5.19-16.074,12.312-39.883,12.312-23.807,0-32.86-7.122-39.981-12.312-7.121-5.188-17.805-12.106-28.689-12.106-10.987,0-15.872,8.751-15.872,8.751s4.374,11.5,8.749,18.622c4.272,7.019,26.555-0.407,28.485-1.323l-2.746-1.936s-10.987,2.748-15.058,2.748c-4.171,0-11.293-1.932-10.987-6.307,0.204-2.85,4.984-3.97,8.241-4.277,2.848-0.201,6.511,0.207,23.907,11.906,7.431,4.986,20.962,13.025,43.954,13.127'/%3E %3Cpath d='m337.61,350.01s0-1.938-0.308-4.783c-0.406-3.664-2.542-4.58-4.271-4.071-1.118,0.403-3.356,3.155-3.356,3.155v0.103c-1.018-0.715-2.034-1.323-3.154-1.935,0.814-0.916,5.494-3.764,6.613-3.764,1.019,0,15.058,5.697,19.532,9.562,1.12,1.021,1.935,7.328,1.322,9.361-7.528-1.933-12.411-4.781-16.381-7.529v-0.102'/%3E %3Cpath d='m330.89,364.26s-3.053,3.051-3.153,8.648c-0.104,6.613,4.68,6.92,7.833,6.816,3.765-0.104,6.815-2.238,6.715-9.259,0,0-6.207-2.647-11.396-6.207'/%3E %3Cpath d='m411.17,350.01s0.103-1.938,0.408-4.783c0.403-3.664,2.44-4.58,4.17-4.071,1.119,0.403,3.356,3.155,3.356,3.155v0.103c1.017-0.715,2.032-1.323,3.152-1.935-0.812-0.916-5.491-3.764-6.51-3.764-1.118,0-15.157,5.697-19.634,9.562-1.02,1.021-1.832,7.328-1.322,9.361,7.631-1.933,12.411-4.781,16.38-7.529v-0.102'/%3E %3Cpath d='m417.88,364.26s3.053,3.051,3.154,8.648c0.204,6.613-4.682,6.92-7.833,6.816-3.766-0.104-6.715-2.238-6.715-9.259,0,0,6.207-2.647,11.396-6.207'/%3E %3C/g%3E %3Cg fill='%2369f'%3E %3Cpath d='m324.28,359.78s-10.887,2.748-14.956,2.748c-4.17,0-11.293-1.93-10.987-6.308,0.204-2.85,4.985-3.967,8.241-4.272,2.441-0.207,5.595,0.101,17.702,7.832'/%3E %3Cpath d='m424.5,359.78s10.885,2.748,15.058,2.748c4.07,0,11.191-1.93,10.885-6.308-0.202-2.85-4.983-3.967-8.239-4.272-2.444-0.207-5.598,0.101-17.704,7.832'/%3E %3Cpath d='m337.61,350.11c-1.119-0.814-2.238-1.631-3.258-2.441-1.525-1.121-3.052-2.139-4.681-3.256,0,0,2.238-2.85,3.357-3.156,1.729-0.609,3.865,0.303,4.271,3.967,0.306,2.85,0.306,4.887,0.306,4.887'/%3E %3Cpath d='m330.18,378.81c1.936,1.121,4.07,1.02,5.394,0.916,3.765-0.102,6.816-2.238,6.715-9.258,0,0,4.678,2.34,12.309,4.172,0,0,1.222,1.525,1.424,4.576,0.308,2.547-1.424,5.291-3.457,5.09,0,0-10.683-1.934-17.192-3.051-3.766-0.711-5.189-2.443-5.189-2.443'/%3E %3Cpath d='m411.17,350.11c1.118-0.814,2.238-1.631,3.355-2.441,1.426-1.121,2.95-2.139,4.579-3.256,0,0-2.237-2.85-3.356-3.156-1.729-0.609-3.765,0.303-4.17,3.967-0.307,2.847-0.408,4.886-0.408,4.886'/%3E %3Cpath d='m418.59,378.81c-1.933,1.121-4.07,1.02-5.393,0.916-3.765-0.102-6.715-2.238-6.715-9.258,0,0-4.681,2.34-12.209,4.172,0,0-1.322,1.525-1.526,4.576-0.204,2.547,1.526,5.291,3.459,5.09,0,0,10.783-1.934,17.193-3.051,3.765-0.711,5.188-2.443,5.188-2.443'/%3E %3C/g%3E %3Cg fill='none' stroke='%23000' stroke-width='0.7122'%3E %3Cpath d='m374.44,376.98c22.893,0.203,36.424-8.143,43.851-13.127,17.396-11.701,21.059-12.106,23.907-11.904,3.257,0.305,8.039,1.425,8.24,4.273,0.307,4.375-6.815,6.307-10.887,6.307-4.17,0-15.057-2.743-15.057-2.743l-2.848,1.934c1.934,0.916,24.212,8.343,28.485,1.32,4.375-7.122,8.748-18.619,8.748-18.619s-4.883-8.754-15.77-8.754c-10.986,0-21.669,6.922-28.792,12.11-7.121,5.189-16.072,12.312-39.881,12.312-23.807,0-32.859-7.123-39.981-12.312-7.121-5.188-17.806-12.11-28.69-12.11-10.986,0-15.87,8.754-15.87,8.754s4.373,11.497,8.749,18.619c4.273,7.021,26.555-0.404,28.486-1.32l-2.745-1.934s-10.989,2.743-15.056,2.743c-4.173,0-11.294-1.928-10.989-6.307,0.204-2.85,4.984-3.967,8.241-4.273,2.847-0.202,6.509,0.205,23.907,11.904,7.429,4.988,20.96,13.027,43.952,13.127z'/%3E %3Cpath d='m324.28,359.78s-10.888,2.748-14.954,2.748c-4.172,0-11.293-1.933-10.989-6.308,0.204-2.85,4.985-3.97,8.241-4.272,2.439-0.207,5.595,0.101,17.702,7.832z'/%3E %3Cpath d='m424.49,359.78s10.887,2.748,15.058,2.748c4.069,0,11.191-1.933,10.886-6.308-0.204-2.85-4.983-3.97-8.238-4.272-2.442-0.207-5.598,0.102-17.702,7.832h-0.004z'/%3E %3Cpath d='m337.61,350.11c-1.12-0.814-2.238-1.631-3.258-2.441-1.523-1.121-3.051-2.139-4.679-3.256,0,0,2.238-2.85,3.356-3.156,1.729-0.609,3.865,0.303,4.271,3.971,0.31,2.843,0.31,4.882,0.31,4.882z'/%3E %3Cpath d='m337.61,350.01s0-1.936-0.308-4.783c-0.404-3.664-2.542-4.58-4.271-4.071-1.12,0.407-3.358,3.155-3.358,3.155v0.103c-1.018-0.712-2.036-1.323-3.154-1.935,0.814-0.916,5.494-3.764,6.614-3.764,1.02,0,15.057,5.697,19.533,9.565,1.12,1.019,1.933,7.325,1.322,9.362-7.529-1.937-12.413-4.785-16.383-7.53'/%3E %3Cpath d='m330.89,364.26s-3.051,3.051-3.152,8.648c-0.103,6.609,4.679,6.918,7.833,6.816,3.765-0.104,6.814-2.238,6.717-9.263,0,0-6.207-2.646-11.396-6.207l-0.002,0.006z'/%3E %3Cpath d='m333.44,365.78s-2.439,2.543-2.847,6.715c-0.204,3.257,1.932,5.086,4.679,4.883,3.866-0.201,5.394-5.492,3.562-8.443l-5.394-3.155'/%3E %3Cpath d='m330.18,378.81c1.934,1.119,4.068,1.018,5.392,0.916,3.765-0.104,6.814-2.24,6.717-9.26,0,0,4.679,2.34,12.31,4.172,0,0,1.222,1.525,1.423,4.58,0.307,2.543-1.423,5.291-3.456,5.086,0,0-10.685-1.934-17.194-3.051-3.768-0.715-5.192-2.443-5.192-2.443z'/%3E %3Cpath d='m411.17,350.11c1.12-0.814,2.238-1.631,3.357-2.441,1.425-1.121,2.95-2.139,4.578-3.256,0,0-2.237-2.85-3.357-3.156-1.729-0.609-3.765,0.303-4.17,3.971-0.306,2.846-0.406,4.883-0.406,4.883h-0.002v-0.001z'/%3E %3Cpath d='m411.17,350.01s0.103-1.936,0.408-4.783c0.405-3.664,2.44-4.58,4.17-4.071,1.12,0.407,3.356,3.155,3.356,3.155v0.103c1.019-0.712,2.035-1.323,3.154-1.935-0.814-0.916-5.493-3.764-6.512-3.764-1.119,0-15.157,5.697-19.634,9.565-1.02,1.019-1.832,7.325-1.322,9.362,7.631-1.937,12.411-4.785,16.38-7.53'/%3E %3Cpath d='m417.88,364.26s3.053,3.051,3.154,8.648c0.204,6.609-4.682,6.918-7.835,6.816-3.764-0.104-6.713-2.238-6.713-9.263,0,0,6.205-2.646,11.394-6.207v0.006z'/%3E %3Cpath d='m415.34,365.78s2.442,2.543,2.849,6.715c0.307,3.257-1.935,5.086-4.681,4.883-3.865-0.201-5.289-5.492-3.561-8.443l5.393-3.155'/%3E %3Cpath d='m418.59,378.81c-1.933,1.119-4.07,1.018-5.393,0.916-3.764-0.104-6.713-2.24-6.713-9.26,0,0-4.682,2.34-12.208,4.172,0,0-1.322,1.525-1.526,4.58-0.203,2.543,1.526,5.291,3.459,5.086,0,0,10.785-1.934,17.192-3.051,3.766-0.715,5.189-2.443,5.189-2.443z'/%3E %3C/g%3E %3Cg fill='none' stroke='%23fff' stroke-width='0.7123'%3E %3Cpath d='m353.79,376.47s3.357,2.445-0.712,5.496'/%3E %3Cpath d='m343.72,374.84,10.275,4.478'/%3E %3Cpath d='m345.44,377.18,7.526,3.254'/%3E %3Cpath d='m348.09,375.25,5.697,2.547'/%3E %3Cpath d='m395.09,376.47s-3.46,2.445,0.61,5.496'/%3E %3Cpath d='m405.06,374.84-10.276,4.478'/%3E %3Cpath d='m403.43,377.18-7.527,3.254'/%3E %3Cpath d='m400.69,375.25-5.596,2.547'/%3E %3C/g%3E %3Cg fill='%23000' stroke='%23000' stroke-width='0.7'%3E %3Cpath d='m313.56,345.17c0.146,0.236,0.239,0.48301,0.285,0.736,0.039,0.25801,0.029,0.54701-0.03,0.865-0.145,0.756-0.55,1.322-1.206,1.712-0.66,0.38801-1.417,0.495-2.254,0.33501-0.389-0.072-0.771-0.20601-1.132-0.40201-0.362-0.18999-0.675-0.395-0.924-0.619-0.112,0.13201-0.23,0.259-0.348,0.392-0.163-0.03-0.326-0.062-0.488-0.093,0.157-0.985,0.312-1.971,0.475-2.954,0.161,0.03,0.327,0.062,0.495,0.096,0.031,0.382,0.093,0.728,0.174,1.048,0.076,0.32101,0.208,0.623,0.384,0.924,0.167,0.276,0.378,0.516,0.639,0.709,0.255,0.194,0.572,0.33,0.946,0.399,0.282,0.056,0.534,0.065,0.763,0.031,0.221-0.034,0.415-0.101,0.565-0.211,0.153-0.109,0.284-0.248,0.384-0.416,0.096-0.164,0.165-0.36,0.211-0.601,0.064-0.344,0.023-0.68-0.112-1.014-0.135-0.336-0.393-0.613-0.748-0.839-0.241-0.153-0.528-0.331-0.846-0.524-0.319-0.195-0.593-0.361-0.821-0.527-0.445-0.311-0.777-0.661-0.976-1.073-0.204-0.403-0.257-0.88799-0.148-1.457,0.062-0.325,0.188-0.612,0.377-0.871,0.188-0.26199,0.428-0.46899,0.719-0.646,0.277-0.172,0.588-0.27499,0.935-0.338,0.345-0.054,0.694-0.049,1.043,0.018,0.398,0.074,0.751,0.205,1.043,0.386,0.29,0.183,0.557,0.372,0.785,0.587,0.109-0.119,0.221-0.24,0.329-0.361,0.165,0.031,0.325,0.062,0.491,0.095-0.165,0.95-0.328,1.903-0.493,2.854-0.165-0.033-0.33-0.063-0.498-0.096-0.026-0.343-0.067-0.674-0.119-0.994-0.06-0.318-0.158-0.617-0.288-0.893-0.13-0.271-0.312-0.497-0.536-0.684-0.222-0.189-0.523-0.314-0.894-0.386-0.385-0.073-0.741-0.017-1.062,0.183-0.318,0.199-0.515,0.465-0.582,0.82-0.069,0.368-0.038,0.692,0.092,0.971,0.126,0.281,0.344,0.526,0.649,0.748,0.271,0.201,0.545,0.373,0.814,0.533,0.267,0.159,0.52,0.319,0.769,0.489,0.224,0.149,0.444,0.312,0.644,0.492,0.194,0.175,0.364,0.369,0.494,0.576'/%3E %3Cpath d='m326.04,346.92c-0.105-0.053-0.268-0.11199-0.484-0.182-0.217-0.07-0.406-0.10399-0.579-0.088-0.17,0.014-0.348,0.139-0.537,0.369-0.191,0.232-0.392,0.53699-0.596,0.91-0.611,1.107-1.224,2.215-1.834,3.324-0.234,0.422-0.526,0.74-0.878,0.955-0.351,0.21699-0.729,0.34-1.129,0.38099-0.396,0.041-0.772,0.008-1.14-0.078-0.368-0.098-0.695-0.22299-0.985-0.38299-0.463-0.256-0.849-0.541-1.146-0.863-0.297-0.328-0.52-0.656-0.647-0.998-0.131-0.342-0.186-0.678-0.161-1.012,0.021-0.332,0.113-0.639,0.271-0.924,0.831-1.508,1.663-3.015,2.494-4.521,0.067-0.125,0.103-0.246,0.113-0.354,0.002-0.102-0.045-0.229-0.129-0.371-0.066-0.102-0.156-0.207-0.28-0.317-0.129-0.104-0.229-0.188-0.32-0.246,0.069-0.127,0.141-0.256,0.21-0.382,1.078,0.595,2.151,1.188,3.228,1.779-0.069,0.127-0.142,0.257-0.211,0.382-0.105-0.054-0.24-0.103-0.409-0.161-0.171-0.062-0.302-0.098-0.388-0.109-0.147-0.023-0.271,0-0.365,0.082-0.1,0.079-0.181,0.172-0.245,0.291-0.777,1.408-1.556,2.816-2.332,4.225-0.112,0.205-0.208,0.433-0.281,0.68-0.083,0.249-0.107,0.51-0.081,0.777,0.029,0.279,0.139,0.539,0.313,0.799,0.176,0.26,0.478,0.508,0.902,0.742,0.396,0.22,0.771,0.345,1.111,0.371,0.337,0.021,0.642-0.021,0.912-0.14,0.252-0.112,0.475-0.256,0.649-0.435,0.178-0.178,0.327-0.375,0.445-0.588,0.578-1.049,1.153-2.092,1.73-3.137,0.221-0.4,0.374-0.742,0.453-1.029,0.083-0.286,0.086-0.491,0.019-0.637-0.072-0.162-0.213-0.328-0.401-0.496-0.195-0.172-0.349-0.299-0.462-0.367,0.07-0.127,0.142-0.256,0.211-0.381,1.056,0.582,2.111,1.164,3.169,1.748-0.069,0.13-0.139,0.257-0.21,0.384'/%3E %3Cpath d='m330.53,354.69c0.135,0.278,0.214,0.58299,0.219,0.90599,0.006,0.326-0.087,0.662-0.287,1.01-0.201,0.35-0.452,0.611-0.76,0.783-0.304,0.174-0.629,0.264-0.975,0.289-0.337,0.031-0.677-0.006-1.029-0.094-0.356-0.094-0.696-0.23-1.021-0.41601-1.211-0.697-2.423-1.396-3.631-2.092,0.073-0.12699,0.146-0.254,0.219-0.379,0.09,0.045,0.222,0.1,0.404,0.17001,0.181,0.073,0.314,0.11299,0.402,0.125,0.142,0.018,0.257-0.011,0.356-0.066,0.093-0.055,0.176-0.146,0.253-0.279,1.044-1.812,2.088-3.627,3.132-5.439,0.069-0.12301,0.11-0.239,0.125-0.354,0.009-0.11501-0.031-0.236-0.119-0.367-0.077-0.115-0.174-0.227-0.292-0.332-0.12-0.104-0.216-0.188-0.305-0.246,0.071-0.125,0.146-0.252,0.218-0.377,1.178,0.67799,2.358,1.357,3.54,2.039,0.274,0.15801,0.521,0.33401,0.743,0.53101,0.216,0.199,0.401,0.43,0.551,0.693,0.14,0.24799,0.223,0.52099,0.231,0.80999,0.009,0.29201-0.065,0.59501-0.241,0.899-0.152,0.264-0.339,0.471-0.556,0.621-0.215,0.15601-0.457,0.254-0.721,0.303-0.251,0.051-0.505,0.055-0.773,0.029-0.273-0.02-0.548-0.08-0.828-0.172-0.01,0.017-0.02,0.032-0.028,0.049,0.207,0.156,0.422,0.348,0.647,0.586,0.224,0.245,0.403,0.499,0.526,0.77zm-0.652-1.894c0.226-0.078,0.412-0.188,0.568-0.34001,0.152-0.15199,0.305-0.34899,0.45-0.601,0.237-0.41499,0.309-0.808,0.217-1.18-0.09-0.375-0.39-0.69901-0.886-0.985-0.114-0.064-0.261-0.14801-0.437-0.24401-0.181-0.099-0.329-0.178-0.442-0.236-0.562,0.973-1.119,1.941-1.679,2.912,0.227,0.131,0.451,0.26,0.681,0.392,0.298,0.172,0.571,0.28,0.824,0.327,0.256,0.044,0.489,0.035,0.704-0.045zm-0.637,2.847c0.257-0.445,0.312-0.898,0.179-1.363-0.136-0.467-0.491-0.857-1.061-1.186-0.23-0.13301-0.427-0.245-0.584-0.33001-0.16-0.086-0.281-0.148-0.363-0.19099-0.514,0.894-1.023,1.779-1.536,2.668-0.128,0.223-0.136,0.446-0.019,0.664,0.117,0.21899,0.34,0.422,0.671,0.611,0.533,0.309,1.035,0.39599,1.498,0.25,0.464-0.15201,0.866-0.51701,1.215-1.123z'/%3E %3Cpath d='m348.94,360.14c-0.111-0.041-0.275-0.086-0.499-0.13199-0.222-0.048-0.416-0.062-0.585-0.03-0.167,0.031-0.331,0.174-0.498,0.422-0.167,0.25-0.334,0.574-0.502,0.965-0.498,1.164-0.996,2.326-1.494,3.49-0.19,0.443-0.45,0.789-0.777,1.039-0.327,0.248-0.692,0.408-1.086,0.49-0.392,0.08-0.769,0.084-1.142,0.033-0.376-0.059-0.716-0.151-1.02-0.281-0.485-0.207-0.897-0.454-1.226-0.746-0.328-0.297-0.581-0.6-0.744-0.928-0.163-0.326-0.252-0.654-0.26-0.99-0.013-0.333,0.046-0.648,0.174-0.948,0.678-1.581,1.355-3.163,2.033-4.745,0.056-0.13,0.079-0.254,0.08-0.361-0.009-0.102-0.066-0.225-0.165-0.356-0.076-0.094-0.176-0.188-0.313-0.289-0.137-0.09-0.244-0.165-0.341-0.213,0.058-0.133,0.114-0.269,0.171-0.399,1.129,0.483,2.259,0.967,3.389,1.451-0.058,0.133-0.114,0.268-0.173,0.399-0.109-0.042-0.249-0.078-0.423-0.12-0.176-0.044-0.31-0.064-0.396-0.07-0.15-0.01-0.27,0.026-0.356,0.117-0.09,0.09-0.161,0.189-0.215,0.314-0.633,1.479-1.267,2.957-1.898,4.437-0.093,0.214-0.165,0.449-0.216,0.701-0.057,0.258-0.055,0.521-0.001,0.784,0.058,0.273,0.191,0.521,0.392,0.763,0.201,0.24,0.524,0.458,0.971,0.647,0.418,0.181,0.804,0.267,1.146,0.259,0.335-0.013,0.636-0.082,0.891-0.229,0.239-0.139,0.449-0.301,0.606-0.496,0.157-0.192,0.288-0.404,0.385-0.629,0.471-1.1,0.939-2.195,1.409-3.293,0.181-0.42,0.299-0.775,0.351-1.068,0.051-0.295,0.036-0.498-0.046-0.635-0.091-0.156-0.244-0.307-0.449-0.455-0.215-0.152-0.377-0.264-0.495-0.319,0.057-0.134,0.114-0.269,0.171-0.399,1.107,0.475,2.218,0.949,3.325,1.424-0.06,0.129-0.118,0.263-0.174,0.396'/%3E %3Cpath d='m358.51,371.38c-1.251-0.361-2.504-0.725-3.755-1.086,0.041-0.14101,0.082-0.28101,0.122-0.42001,0.139,0.033,0.315,0.07,0.537,0.109,0.217,0.034,0.376,0.045,0.469,0.028,0.146-0.045,0.262-0.099,0.349-0.18299,0.08-0.078,0.147-0.188,0.189-0.33601,0.588-2.033,1.176-4.065,1.765-6.102-0.033-0.01-0.062-0.018-0.092-0.025-1.642,2.113-3.323,4.195-4.968,6.31-0.098-0.028-0.195-0.058-0.298-0.086-0.2-2.699-0.453-5.396-0.653-8.093-0.024-0.008-0.053-0.017-0.077-0.022-0.482,1.668-0.966,3.336-1.447,5.008-0.141,0.482-0.215,0.854-0.225,1.132-0.015,0.27101,0.032,0.477,0.124,0.625,0.063,0.11,0.225,0.23701,0.479,0.395,0.253,0.156,0.422,0.244,0.504,0.273-0.04,0.139-0.081,0.278-0.122,0.42001-1.142-0.33001-2.286-0.66001-3.432-0.99,0.041-0.14301,0.082-0.283,0.122-0.42201,0.185,0.033,0.385,0.062,0.595,0.074,0.209,0.017,0.378-0.002,0.514-0.062,0.169-0.073,0.312-0.207,0.436-0.42599,0.116-0.21301,0.252-0.58601,0.406-1.121,0.413-1.43,0.827-2.863,1.24-4.293,0.072-0.24801,0.101-0.457,0.087-0.63301-0.014-0.18099-0.062-0.32399-0.146-0.461-0.096-0.145-0.226-0.26299-0.388-0.36699-0.165-0.10801-0.337-0.188-0.51-0.24401,0.04-0.139,0.081-0.279,0.121-0.418,0.966,0.279,1.929,0.557,2.894,0.836,0.19,2.336,0.432,4.669,0.62,7.007,1.188-1.563,2.41-3.103,3.6-4.667,0.133-0.173,0.261-0.35401,0.374-0.55501,0.112-0.19099,0.182-0.324,0.208-0.39699,0.923,0.26699,1.85,0.534,2.771,0.802-0.04,0.139-0.081,0.279-0.121,0.418-0.114-0.027-0.258-0.047-0.439-0.068s-0.322-0.029-0.409-0.023c-0.15,0.01-0.264,0.061-0.344,0.159-0.078,0.101-0.138,0.20799-0.175,0.33899-0.583,2.018-1.166,4.032-1.748,6.049-0.039,0.135-0.049,0.26-0.03,0.368,0.021,0.109,0.089,0.21601,0.203,0.328,0.062,0.062,0.179,0.133,0.354,0.218,0.176,0.09,0.312,0.147,0.42,0.186-0.042,0.134-0.083,0.275-0.124,0.416'/%3E %3Cpath d='m367.6,368.62c0.23,0.205,0.423,0.455,0.553,0.75201,0.129,0.29899,0.179,0.64499,0.128,1.041-0.05,0.4-0.187,0.73801-0.397,1.018-0.216,0.275-0.479,0.484-0.786,0.645-0.302,0.158-0.632,0.256-0.988,0.312-0.364,0.051-0.729,0.057-1.102,0.01-1.386-0.174-2.771-0.349-4.156-0.522,0.018-0.146,0.035-0.291,0.054-0.435,0.101,0.007,0.243,0.007,0.439,0,0.193-0.002,0.336-0.017,0.422-0.041,0.136-0.039,0.233-0.106,0.301-0.198,0.063-0.086,0.107-0.201,0.127-0.355,0.262-2.075,0.521-4.15,0.783-6.227,0.019-0.14199,0.005-0.26699-0.021-0.375-0.037-0.10899-0.12-0.20499-0.252-0.293-0.118-0.076-0.248-0.14199-0.396-0.19099-0.153-0.051-0.272-0.092-0.376-0.10901,0.018-0.14499,0.035-0.289,0.054-0.43399,1.35,0.16999,2.701,0.341,4.054,0.51099,0.312,0.04,0.606,0.106,0.893,0.20401,0.275,0.1,0.533,0.23799,0.772,0.42599,0.223,0.173,0.409,0.39301,0.529,0.65601,0.121,0.266,0.164,0.572,0.12,0.922-0.038,0.303-0.129,0.56599-0.267,0.788-0.141,0.228-0.324,0.411-0.548,0.56-0.211,0.143-0.448,0.244-0.701,0.326-0.263,0.088-0.538,0.137-0.83,0.162-0.003,0.018-0.006,0.037-0.009,0.055,0.25,0.064,0.521,0.157,0.823,0.289,0.296,0.136,0.56,0.302,0.777,0.503zm-1.334-1.494c0.177-0.158,0.31-0.334,0.396-0.533,0.081-0.198,0.144-0.438,0.18-0.729,0.061-0.475-0.025-0.861-0.256-1.172-0.229-0.311-0.627-0.492-1.198-0.564-0.128-0.016-0.298-0.037-0.493-0.058-0.207-0.021-0.372-0.036-0.507-0.048-0.14,1.113-0.278,2.225-0.419,3.336,0.262,0.032,0.521,0.064,0.78,0.098,0.339,0.043,0.637,0.037,0.891-0.018,0.248-0.056,0.457-0.158,0.626-0.312zm0.514,2.873c0.063-0.513-0.06-0.951-0.36-1.328-0.308-0.377-0.786-0.6-1.437-0.682-0.267-0.033-0.487-0.061-0.668-0.078-0.183-0.019-0.317-0.029-0.412-0.037-0.129,1.021-0.256,2.037-0.384,3.056-0.032,0.254,0.05,0.46399,0.241,0.62,0.192,0.15599,0.479,0.25699,0.855,0.30399,0.613,0.078,1.106-0.035,1.476-0.351,0.372-0.321,0.602-0.814,0.689-1.504z'/%3E %3Cpath d='m378.69,372.75h-2.387c-0.519-0.82499-1.005-1.518-1.423-2.119-0.427-0.598-0.896-1.199-1.392-1.838h-0.905v2.769c0,0.142,0.026,0.271,0.068,0.374,0.045,0.111,0.145,0.195,0.295,0.25401,0.073,0.029,0.205,0.053,0.392,0.08,0.188,0.023,0.346,0.037,0.475,0.043v0.438h-3.74v-0.438c0.098-0.006,0.242-0.023,0.437-0.043,0.188-0.021,0.318-0.051,0.393-0.08,0.124-0.057,0.219-0.12901,0.272-0.23401,0.06-0.10399,0.082-0.23199,0.082-0.394v-6.313c0-0.139-0.019-0.27-0.061-0.38299-0.045-0.10801-0.14-0.19401-0.295-0.25-0.104-0.037-0.236-0.076-0.405-0.104-0.168-0.028-0.305-0.052-0.423-0.056v-0.437h4.085c0.373,0,0.723,0.034,1.055,0.11,0.329,0.082,0.623,0.199,0.89,0.371,0.255,0.166,0.466,0.371,0.617,0.639,0.152,0.264,0.231,0.584,0.231,0.959,0,0.34-0.053,0.633-0.155,0.893-0.104,0.26-0.26,0.47899-0.463,0.67-0.184,0.183-0.413,0.324-0.673,0.457-0.261,0.129-0.55,0.238-0.865,0.332,0.43,0.574,0.803,1.047,1.091,1.438,0.282,0.39,0.647,0.85801,1.059,1.421,0.182,0.249,0.353,0.42599,0.5,0.54199,0.145,0.121,0.295,0.21401,0.437,0.29101,0.105,0.058,0.244,0.093,0.405,0.12099,0.163,0.03,0.3,0.045,0.405,0.051-0.002,0.143-0.002,0.289-0.002,0.436zm-3.28-6.506c0-0.528-0.16-0.942-0.46-1.26-0.303-0.311-0.742-0.463-1.303-0.463h-1.062v3.742h0.818c0.573,0,1.058-0.173,1.434-0.542,0.375-0.36799,0.573-0.85399,0.573-1.477z'/%3E %3Cpath d='m388.88,372.1c-1.223,0.094-2.443,0.18599-3.669,0.279-0.012-0.14601-0.022-0.293-0.033-0.438,0.323-0.043,0.588-0.104,0.802-0.18401,0.205-0.08,0.307-0.15999,0.3-0.251-0.003-0.037-0.015-0.079-0.023-0.13499-0.013-0.057-0.024-0.096-0.048-0.13901-0.288-0.63299-0.592-1.261-0.882-1.895-1.034,0.078-2.063,0.156-3.098,0.234-0.095,0.297-0.172,0.549-0.223,0.771-0.057,0.22199-0.111,0.421-0.153,0.604-0.041,0.182-0.07,0.323-0.08,0.438-0.01,0.11299-0.018,0.203-0.011,0.271,0.012,0.16399,0.151,0.276,0.42,0.35099,0.269,0.073,0.565,0.099,0.897,0.093,0.011,0.145,0.022,0.29,0.033,0.438-1.106,0.084-2.216,0.168-3.323,0.252-0.011-0.146-0.021-0.293-0.033-0.438,0.107-0.014,0.239-0.047,0.398-0.102,0.159-0.053,0.287-0.111,0.387-0.187,0.159-0.125,0.276-0.248,0.359-0.381,0.085-0.124,0.159-0.293,0.229-0.517,0.351-1.127,0.767-2.387,1.188-3.793,0.421-1.403,0.824-2.651,1.153-3.746,0.165-0.012,0.33-0.024,0.498-0.036,1.152,2.437,2.354,4.848,3.511,7.282,0.073,0.156,0.156,0.277,0.24,0.373,0.089,0.094,0.202,0.181,0.352,0.261,0.099,0.052,0.226,0.09,0.384,0.114,0.158,0.031,0.285,0.041,0.392,0.037,0.012,0.151,0.023,0.298,0.033,0.444zm-3.818-3.292c-0.523-1.091-1.07-2.175-1.596-3.271-0.344,1.162-0.715,2.314-1.062,3.473,0.887-0.068,1.77-0.134,2.658-0.202z'/%3E %3Cpath d='m401.43,361.92c-0.147,0.039-0.301,0.08-0.446,0.121-0.172-0.293-0.439-0.573-0.801-0.862-0.361-0.285-0.674-0.41-0.928-0.382-0.131,0.021-0.281,0.045-0.45,0.084-0.175,0.043-0.368,0.09-0.588,0.148-0.478,0.12901-0.953,0.26-1.432,0.389,0.307,1.129,0.612,2.259,0.918,3.384,0.324-0.089,0.654-0.179,0.979-0.26701,0.295-0.08,0.525-0.17,0.671-0.28099,0.141-0.10401,0.263-0.23701,0.341-0.39301,0.056-0.11299,0.096-0.27,0.111-0.47299,0.017-0.198,0.01-0.40601-0.027-0.62301,0.152-0.042,0.305-0.083,0.451-0.12299,0.301,1.109,0.601,2.213,0.898,3.316-0.146,0.039-0.299,0.08-0.45,0.12301-0.058-0.16801-0.157-0.35701-0.283-0.56201-0.136-0.2-0.256-0.34-0.363-0.416-0.157-0.118-0.338-0.18-0.529-0.185-0.202-0.006-0.428,0.033-0.687,0.104-0.325,0.089-0.655,0.179-0.979,0.267,0.264,0.969,0.524,1.934,0.787,2.902,0.035,0.129,0.094,0.241,0.178,0.329,0.077,0.089,0.189,0.142,0.341,0.173,0.068,0.016,0.21,0.01,0.418-0.009,0.209-0.012,0.37-0.039,0.474-0.062,0.037,0.14,0.077,0.283,0.114,0.423-1.233,0.334-2.467,0.67-3.701,1.004-0.037-0.14-0.077-0.283-0.114-0.423,0.12-0.038,0.278-0.098,0.472-0.172,0.191-0.075,0.319-0.127,0.373-0.174,0.106-0.084,0.178-0.188,0.201-0.299,0.023-0.117,0.021-0.244-0.018-0.389-0.55-2.025-1.1-4.053-1.649-6.08-0.034-0.129-0.098-0.238-0.16-0.333-0.072-0.085-0.189-0.138-0.346-0.167-0.121-0.021-0.278-0.023-0.468-0.018-0.201,0.006-0.354,0.024-0.462,0.049-0.037-0.141-0.076-0.283-0.114-0.42399,2.233-0.60501,4.469-1.211,6.696-1.815,0.189,0.706,0.382,1.413,0.572,2.116'/%3E %3Cpath d='m411.29,361.17c0.324,0.80601,0.641,1.615,0.964,2.42-2.08,1.005-4.154,2.006-6.229,3.008-0.063-0.13099-0.128-0.26599-0.191-0.39499,0.088-0.049,0.209-0.125,0.375-0.229,0.156-0.099,0.265-0.181,0.315-0.241,0.091-0.104,0.144-0.212,0.148-0.333,0.004-0.114-0.027-0.241-0.099-0.386-0.906-1.877-1.812-3.754-2.719-5.631-0.062-0.129-0.138-0.225-0.223-0.303-0.089-0.074-0.212-0.11-0.372-0.104-0.104-0.01-0.247,0.006-0.425,0.039-0.178,0.031-0.316,0.068-0.419,0.111-0.062-0.12901-0.128-0.265-0.189-0.395,1.123-0.542,2.24-1.082,3.362-1.624,0.063,0.12999,0.128,0.26499,0.19,0.396-0.106,0.057-0.231,0.137-0.377,0.248-0.154,0.115-0.264,0.20299-0.32,0.268-0.112,0.107-0.16,0.225-0.15,0.352-0.001,0.13099,0.034,0.25599,0.094,0.37699,0.851,1.76,1.7,3.521,2.551,5.283,0.116,0.24,0.217,0.424,0.31,0.54501,0.093,0.127,0.199,0.207,0.324,0.23399,0.113,0.029,0.263,0.01,0.444-0.061,0.182-0.059,0.424-0.162,0.73-0.312,0.139-0.065,0.277-0.14201,0.428-0.21901,0.148-0.077,0.281-0.16599,0.404-0.24799,0.121-0.089,0.224-0.181,0.318-0.272,0.09-0.092,0.149-0.174,0.172-0.262,0.067-0.246,0.132-0.585,0.166-1.035,0.031-0.44099,0.046-0.78699,0.019-1.041,0.134-0.061,0.267-0.126,0.399-0.19001'/%3E %3Cpath d='m415.95,352.52c0.537,0.154,1.054,0.40801,1.527,0.78501,0.479,0.38799,0.896,0.867,1.247,1.461,0.354,0.598,0.571,1.195,0.67,1.795,0.098,0.6,0.062,1.173-0.07,1.723-0.129,0.537-0.369,1.021-0.697,1.469-0.328,0.447-0.742,0.812-1.245,1.107-0.529,0.312-1.073,0.51-1.642,0.572s-1.112,0.029-1.639-0.137c-0.526-0.155-1.026-0.412-1.498-0.799-0.473-0.386-0.874-0.849-1.203-1.404-0.361-0.612-0.582-1.215-0.678-1.811-0.093-0.591-0.062-1.16,0.062-1.714,0.132-0.543,0.378-1.034,0.711-1.485,0.332-0.451,0.742-0.812,1.231-1.101,0.508-0.301,1.042-0.491,1.593-0.562,0.561-0.075,1.103-0.047,1.631,0.101zm2.347,5.807c0.003-0.44201-0.051-0.895-0.206-1.354-0.148-0.459-0.37-0.937-0.666-1.438-0.306-0.516-0.635-0.959-0.989-1.334-0.354-0.369-0.729-0.643-1.104-0.832-0.374-0.188-0.764-0.269-1.158-0.265-0.391,0.001-0.787,0.124-1.169,0.349-0.426,0.252-0.737,0.562-0.918,0.939-0.182,0.375-0.282,0.781-0.277,1.213,0.008,0.418,0.084,0.857,0.245,1.326,0.16,0.471,0.374,0.934,0.646,1.395,0.299,0.506,0.621,0.937,0.949,1.295,0.332,0.355,0.701,0.629,1.083,0.832,0.382,0.201,0.763,0.287,1.163,0.293,0.396,0,0.801-0.113,1.209-0.354,0.38-0.225,0.679-0.525,0.879-0.88,0.198-0.36,0.31-0.757,0.313-1.185z'/%3E %3Cpath d='m429.27,352.37c-0.647,0.45899-1.301,0.922-1.948,1.381-0.896-0.37301-1.697-0.65601-2.383-0.904-0.696-0.246-1.43-0.46001-2.195-0.69501-0.249,0.17601-0.494,0.35-0.743,0.525,0.532,0.749,1.066,1.504,1.602,2.259,0.081,0.11301,0.181,0.19901,0.271,0.265,0.104,0.064,0.231,0.071,0.386,0.035,0.079-0.017,0.198-0.074,0.368-0.16201,0.17-0.088,0.301-0.168,0.411-0.24,0.083,0.11901,0.17,0.24,0.253,0.35701-1.017,0.723-2.034,1.442-3.051,2.163-0.084-0.116-0.17-0.239-0.254-0.356,0.079-0.062,0.186-0.157,0.332-0.287,0.138-0.125,0.229-0.223,0.274-0.295,0.067-0.112,0.103-0.229,0.083-0.346-0.012-0.117-0.063-0.236-0.156-0.367-1.219-1.717-2.437-3.437-3.652-5.152-0.081-0.113-0.172-0.206-0.271-0.273-0.099-0.066-0.226-0.082-0.381-0.037-0.111,0.033-0.24,0.078-0.393,0.146-0.16,0.074-0.281,0.141-0.378,0.203-0.084-0.11701-0.17-0.24-0.254-0.35701,1.11-0.78699,2.219-1.572,3.33-2.361,0.305-0.21499,0.613-0.389,0.924-0.51699,0.315-0.126,0.629-0.20401,0.941-0.216,0.308-0.016,0.596,0.037,0.87,0.16199,0.283,0.12701,0.529,0.346,0.745,0.65,0.198,0.278,0.329,0.547,0.389,0.81901,0.068,0.27099,0.071,0.538,0.016,0.81299-0.045,0.25401-0.149,0.498-0.287,0.76-0.14,0.257-0.307,0.513-0.516,0.771,0.686,0.221,1.262,0.389,1.724,0.54101,0.453,0.15599,1.025,0.326,1.685,0.547,0.291,0.10299,0.535,0.14599,0.724,0.15599,0.185,0.014,0.364,0.004,0.522-0.018,0.12-0.014,0.25-0.066,0.401-0.135,0.151-0.067,0.271-0.139,0.358-0.19401,0.083,0.11901,0.17,0.24001,0.253,0.35901zm-6.435-3.41c-0.306-0.432-0.68-0.678-1.105-0.76199-0.43-0.076-0.874,0.049-1.333,0.375-0.288,0.20299-0.575,0.40699-0.867,0.61399,0.723,1.021,1.442,2.035,2.166,3.056,0.224-0.158,0.446-0.315,0.67-0.475,0.468-0.331,0.761-0.755,0.852-1.271,0.094-0.52-0.024-1.032-0.383-1.537z'/%3E %3Cpath d='m436.56,346.87c0.243,0.822,0.487,1.648,0.735,2.469-2.299,0.85299-4.593,1.703-6.891,2.556-0.051-0.135-0.103-0.274-0.152-0.41,0.116-0.049,0.27-0.122,0.449-0.224,0.185-0.098,0.305-0.164,0.354-0.217,0.101-0.105,0.162-0.21499,0.178-0.321,0.015-0.113-0.002-0.233-0.057-0.379-0.729-1.964-1.454-3.923-2.184-5.888-0.047-0.125-0.114-0.23-0.189-0.315-0.08-0.079-0.201-0.119-0.359-0.136-0.122-0.012-0.279,0-0.467,0.025-0.199,0.021-0.345,0.053-0.455,0.088-0.051-0.135-0.104-0.274-0.152-0.41,2.142-0.795,4.281-1.588,6.422-2.383,0.243,0.656,0.488,1.318,0.731,1.975-0.147,0.056-0.296,0.109-0.438,0.164-0.184-0.27-0.475-0.51-0.849-0.745-0.387-0.239-0.698-0.322-0.945-0.267-0.124,0.029-0.272,0.067-0.441,0.125-0.175,0.06-0.364,0.123-0.581,0.203-0.435,0.161-0.868,0.322-1.302,0.483,0.4,1.082,0.805,2.169,1.205,3.251,0.312-0.115,0.621-0.23,0.938-0.348,0.296-0.109,0.509-0.217,0.63-0.33,0.112-0.104,0.204-0.234,0.258-0.408,0.048-0.145,0.062-0.319,0.056-0.533-0.011-0.208-0.033-0.393-0.077-0.57,0.144-0.053,0.291-0.106,0.438-0.162,0.397,1.071,0.793,2.14,1.19,3.211-0.147,0.056-0.296,0.109-0.438,0.162-0.089-0.178-0.202-0.363-0.343-0.545-0.144-0.175-0.269-0.3-0.383-0.365-0.179-0.104-0.347-0.149-0.518-0.139-0.177,0.008-0.386,0.062-0.638,0.156-0.314,0.117-0.627,0.232-0.938,0.348,0.305,0.822,0.606,1.639,0.912,2.461,0.092,0.244,0.182,0.428,0.271,0.562,0.088,0.133,0.194,0.207,0.321,0.245,0.126,0.039,0.286,0.029,0.466-0.014,0.184-0.051,0.439-0.129,0.761-0.248,0.129-0.049,0.296-0.109,0.509-0.188,0.212-0.078,0.389-0.147,0.523-0.224,0.14-0.073,0.289-0.157,0.432-0.256,0.142-0.104,0.236-0.195,0.271-0.289,0.112-0.252,0.201-0.604,0.255-1.051s0.086-0.768,0.07-0.961c0.141-0.054,0.278-0.105,0.422-0.158'/%3E %3Cpath d='m443.96,340.81c0.438,0.35299,0.814,0.78699,1.099,1.321,0.289,0.543,0.484,1.147,0.574,1.832,0.092,0.688,0.06,1.324-0.087,1.914-0.145,0.58999-0.399,1.104-0.737,1.559-0.324,0.44101-0.739,0.793-1.217,1.076-0.479,0.28301-1.001,0.45501-1.575,0.53101-0.615,0.082-1.192,0.049-1.734-0.11701-0.547-0.164-1.04-0.40599-1.459-0.76599-0.418-0.351-0.782-0.78101-1.061-1.32-0.289-0.539-0.479-1.123-0.562-1.764-0.093-0.70499-0.061-1.347,0.085-1.932,0.146-0.57999,0.402-1.094,0.734-1.553,0.334-0.448,0.749-0.80499,1.23-1.09,0.482-0.28501,1.007-0.45501,1.569-0.53,0.579-0.076,1.146-0.043,1.686,0.106,0.54,0.15199,1.028,0.391,1.455,0.733zm-0.113,6.262c0.18-0.405,0.303-0.843,0.345-1.327,0.038-0.47899,0.021-1.006-0.056-1.584-0.078-0.59401-0.208-1.131-0.389-1.613-0.18-0.47899-0.413-0.879-0.683-1.198-0.276-0.31899-0.599-0.548-0.963-0.697-0.364-0.15099-0.773-0.19399-1.212-0.13699-0.495,0.065-0.903,0.22799-1.218,0.50599-0.313,0.272-0.566,0.606-0.731,1.008-0.15,0.386-0.258,0.82-0.288,1.313-0.041,0.496-0.026,1.007,0.043,1.537,0.077,0.582,0.204,1.104,0.371,1.562,0.161,0.458,0.398,0.853,0.672,1.188,0.267,0.338,0.583,0.563,0.95,0.727,0.365,0.156,0.786,0.209,1.255,0.146,0.438-0.058,0.826-0.217,1.148-0.463,0.324-0.254,0.584-0.574,0.756-0.968z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m422.97,213.66v55.25c0,10.988-1.525,54.744-48.53,71.738-47.104-16.994-48.63-60.746-48.63-71.738v-55.25h97.16' stroke='%23000' stroke-width='1.01740003' fill='none'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='450' viewBox='0 0 1098 549'%3E %3Ctitle%3EFlag of Belarus%3C/title%3E %3Crect fill='%23C8313E' width='1098' height='549'/%3E %3Crect y='366' fill='%234AA657' width='1098' height='183'/%3E %3Crect fill='%23FFF' width='122' height='549'/%3E %3Cg id='h'%3E %3Cg id='q' fill='%23C8313E' fill-rule='evenodd' transform='scale(5.304347826,9)'%3E %3Cpath d='M4,0h3v1h1v1h1v1h1v1h1v1h-1v1h-1v1h-1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h-1v-1h1v-1h1v-1h1v-1h1zM5,2h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM5,4h1v1h-1zM0,1h1v1h-1zM0,7h1v1h-1zM11,0h0.6v2h-.6zM11,7h.6v2h-.6zM2,9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM2,11h1v1h-1zM8,9h1v1h1v1h1v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h1v-1h1zM8,11h1v1h-1zM0,15h1v1h-1zM11,14h.6v2h-.6z'/%3E %3Cpath d='M0,18h1v-1h1v-1h1v-1h1v-1h1v-1h1v1h1v1h1v1h1v1h1v1h1v1h.6v4h-.6v1h-1v1h-1v1h-1v1h-1v1h-1v2.6h-2v-0.6h-1v-1h-1v-1h-1v-1h-1 v-3h1v1h1v1h1v1h1v-1h1v-1h1v-1h1v-1h1v-1h1v-1h-1v-1h-1v-1h-3v1h2v1h-1v1h-1v1h-1v-1h-1v-1h-1v-1h-1zM0,22h1v1h-1zM11,25h.6v1h-.6zM9,27h1v1h1v1h.6v1.6h-.6v-.6h-1v-1h-1zM7,30h1v.6h-1z'/%3E %3C/g%3E %3Cuse xlink:href='%23q' transform='translate(122,0) scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23h' transform='translate(0,549) scale(1,-1)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='800' viewBox='0 0 36 24'%3E %3Crect width='36' height='24' fill='%2375aadb'/%3E %3Crect y='9' width='36' height='6' fill='%23fff'/%3E %3Crect y='10' width='36' height='4'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8' standalone='yes'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' version='1.1' width='1100' height='800'%3E %3Crect width='1100' height='800' fill='%23ef2b2d'/%3E %3Crect width='200' height='800' x='300' fill='%23fff'/%3E %3Crect width='1100' height='200' y='300' fill='%23fff'/%3E %3Crect width='100' height='800' x='350' fill='%23002868'/%3E %3Crect width='1100' height='100' y='350' fill='%23002868'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23ffd520'/%3E %3Cpath d='M0,600H900V0z' fill='%23ff4e12'/%3E %3Cg stroke='%23000' stroke-width='0.5208'%3E %3Cg fill='%23fff'%3E %3Cpath d='m481.74,187.59c-4.9875-1.7708-8.2083,0.805-8.0458,7.2442,0.15833,6.4392,3.5417,10.142,8.5292,7.7271l-0.48334-14.971z'/%3E %3Cpath d='m486.12,175.53c-4.1542-3.28-8.0292-1.8738-9.9458,4.2758-1.9167,6.1492,0.0958,10.742,5.5958,10.058l4.35-14.333z'/%3E %3Cpath d='m493.04,163.86c-3.5792-3.9046-7.6292-3.1383-10.508,2.6246-2.875,5.7633-1.625,10.618,3.9167,10.825l6.5917-13.45z'/%3E %3Cpath d='m488.5,220.59c-6.1167,2.2538-6.7625,10.625-2.8958,15.776,3.8625,5.1512,10.946,6.1171,14.808,0l-11.91-15.78z'/%3E %3Cpath d='m481.42,202.88c-5.7958-1.9317-11.017,5.8525-11.913,12.878-1.125,8.8538-13.683,11.751-6.7583,25.113,1.4458-8.5317,7.0833-13.2,11.588-13.522,4.5083-0.32208,11.271-1.2879,14.167-6.7613l-7.0833-17.708z'/%3E %3Cpath d='m499.77,237.33c-6.7625,1.6096-7.7292,10.625-2.9,17.064,4.1333,5.5129,17.063,4.1854,16.742-1.2879l-13.842-15.776z'/%3E %3Cpath d='m518.93,291.58c0.32084-5.795-9.0125-8.0488-13.521-6.9221-4.5083,1.1271-13.121-0.16083-15.133-4.9904-1.6083,3.8638,0.72501,8.0492,7.2458,10.142,4.9333,1.5846,4.8292,5.1512,3.3792,6.7613,3.7042,0.64375,14.65,0.64375,18.029-4.9904z'/%3E %3Cpath d='m513.62,254.56c-6.6-2.8975-10.513,1.5158-13.038,5.795-3.7042,6.2783-15.133-1.7704-18.996,6.6004,5.2333-2.2538,10.558,2.5525,13.038,4.1854,7.0833,4.6683,20.767,3.2196,22.7-7.7271l-3.7042-8.8538z'/%3E %3Cpath d='m517.48,262.28c-6.6,4.99-9.175,10.946-9.0125,14.971,0.1625,4.0246,5.7958,12.878,11.913,13.361,3.5417-7.2442,5.3125-22.537-2.9-28.332z'/%3E %3Cpath d='m490.12,293.35c0-2.4146,3.5417-3.3804,5.9542-2.5758,2.4167,0.805,6.1167,3.2196,4.8292,5.7954l-10.783-3.2196z'/%3E %3Cpath d='m453.73,280.15c-0.64167-2.8975,4.025-7.8879,10.304-5.1513,6.275,2.7367,7.0833,8.0492,4.5042,10.142l-14.808-4.9904z'/%3E %3Cpath d='m469.02,285.46c-0.48333-1.61,4.0375-4.8254,11.754-2.8979,7.725,1.9321,9.6208,6.9067,9.3375,10.786l-21.092-7.8879z'/%3E %3Cpath d='m452.93,280.15c4.025-3.0583,2.5-8.855-1.1292-10.625-6.6-3.2196-4.1833-11.59-8.3708-13.2-4.1833-1.61-8.2083-4.5075-8.3708-7.405-2.0917,4.0242-0.80417,7.7271,2.0958,10.303,2.8958,2.5758-2.2542,13.039,1.4458,15.776l14.329,5.1513z'/%3E %3Cpath d='m366.64,277.9c-3.3804-5.3121-11.43-4.3463-14.81-0.64375-3.3804,3.7025-2.8975,9.1758,0.32208,11.59l14.488-10.947z'/%3E %3Cpath d='m385.96,270.01c-1.2879-7.0829-9.82-7.8879-14.488-6.1171-4.6683,1.7708-7.8879,8.8538-4.8292,14.005l19.318-7.8879z'/%3E %3Cpath d='m398.84,269.04c3.0583-5.9563-2.8975-14.81-9.6588-16.098-5.6446-1.0738-12.315-1.0462-14.488-6.6-1.3683,4.8296,2.2542,7.8879,6.4396,10.625,4.185,2.7367-0.80542,9.82,5.9558,13.844l11.752-1.7708z'/%3E %3Cpath d='m398.2,269.25c-1.4088-4.2667,1.4488-9.9434,7.2325-9.5454,5.7842,0.39792,9.08,4.6013,6.53,9.8558l-13.763-0.31041z'/%3E %3Cpath d='m411.07,269.57c-0.79583-4.4221,2.83-9.6404,8.5008-8.435s8.3417,5.83,5.0833,10.675l-13.584-2.2396z'/%3E %3Cpath d='m423.86,271.6c-0.575-4.4575,3.3083-9.4875,8.9125-8.0013,5.6042,1.4871,8.0417,6.2404,4.5417,10.915l-13.454-2.9142z'/%3E %3Cpath d='m326.72,345.35c-10.786,0-13.42,2.5679-14.971,13.683-1.9317,13.844,16.903,15.454,14.971-13.683z'/%3E %3Cpath d='m331.55,330.86c-16.581-6.2783-25.595,19.961-42.015,15.293,5.8754,9.3367,20.118,0.0167,25.434,0.96583,9.015,1.61,28.493-1.7708,16.581-16.259z'/%3E %3Cpath d='m320.76,366.76c-8.21-3.7021-17.064,8.8542-15.454,14.327,2.0438,6.9521,20.766,1.2879,15.454-14.327z'/%3E %3Cpath d='m282.45,420.85c4.5075,1.2833,9.9804,3.8625,9.0146,12.554-0.96583,8.6917-17.385,26.4-32.195,27.367-14.81,0.96667-20.123,18.833-32.84,13.842,11.912-2.25,11.912-15.775,21.249-19.958-6.7612-2.4167-10.303,12.879-18.995,12.879-8.6929,0-12.878,13.842-23.503,12.875-10.625-0.9625-11.743,16.854-33,17.067-16.259,0.15834-36.381,19.154-43.625,10.946,15.776-2.2542,22.142-10.996,31.552-20.608,15.132-15.45,32.196-8.5292,37.991-22.213-6.9225,4.6667-14.971,6.9208-22.859,6.7625-9.9017-0.20417-20.766,15.775-31.874,8.6917,6.4392-0.80416,10.625-3.5417,17.386-10.625,6.9238-7.2542,17.083-2.5667,25.113-9.9792,12.556-11.592,23.342-1.9333,35.415-16.421-3.3808-1.6083-10.625-0.48334-17.386,3.0583-6.7613,3.5417-15.454-2.4167-23.181,1.7708,0.96583-9.4958,18.995-4.0625,30.264-10.625,12.718-7.4042,23.262-5.2333,33.323-4.3458-14.005-0.0792-19.478-13.363-38.795-9.5-8.425,1.6875-15.132-11.588-23.503-4.8292,0.24125-4.9875,9.015-9.0134,18.03-4.1833,9.0146,4.8292,12.648-4.2258,30.586,7.0833,7.405,4.6667,20.122-2.9,28.171,2.0917-1.0462-3.0583-5.6346-4.9917-11.027-4.5875,3.3808-6.9208,25.193-6.0375,34.691,0.8875z'/%3E %3Cpath d='m296.78,410.38c-7.0829-5.4733-16.903,1.1283-23.664-1.4488,0,4.5062,2.2538,11.269,9.6588,13.844,2.2538-1.6083,12.395-10.463,14.005-12.395z'/%3E %3Cpath d='m307.89,394.77c-11.108-5.6342-13.039,8.3708-21.732,5.4733,0.32209,4.0246,3.5417,9.015,10.625,10.142l11.108-15.615z'/%3E %3Cpath d='m314.49,382.05c-16.42-6.4392-18.513,9.3367-28.171,6.2779,2.2538,5.4733,16.098,8.3708,23.181,6.4392l4.9904-12.717z'/%3E %3Cpath d='m337.02,312.99c-4.3467-6.1171-13.522-1.1267-14.971,6.1171-1.4488,7.2442,2.0925,17.386,8.21,15.132l6.7608-21.249z'/%3E %3Cpath d='m348.13,293.67c-7.5658-1.7704-16.259-0.96584-15.293,6.4392-2.8979,1.2879-3.7025,10.786,4.1854,12.878l11.108-19.318z'/%3E %3Cpath d='m353.12,288.68c-7.405-8.6929-15.663-8.4908-20.283-4.8296-8.5321,6.7613-16.823,2.8979-17.064,9.6588,5.1517-3.9438,9.6588,0.805,13.844-0.64375,4.1854-1.4488,7.2442,6.6,18.835,3.2196l4.6683-7.405z'/%3E %3Cpath d='m335.25,418.6c1.1271,2.0917,8.0488,3.0583,11.43-0.48334,4.4804-4.6958-0.48291-17.709-7.5663-18.675-7.0829-0.96583-7.7267,14.65-3.8633,19.158z'/%3E %3Cpath d='m327.2,418.92c10.141,3.7,14.488-4.6708,9.0146-9.9813-1.4488,1.7708-6.7613,8.2104-9.0146,9.9813z'/%3E %3Cpath d='m289.21,432.76c-1.9321,5.7958-11.913,6.7625-23.181,24.792-11.269,18.029-22.054,10.463-24.791,22.858,13.522-10.946,24.142-3.675,32.195-14.488,12.235-16.421,22.309-14.063,27.045-25.113,6.7608-15.775,36.381-15.454,37.991-40.244-9.9808-1.9321-41.533,24.79-49.259,32.194z'/%3E %3Cpath d='m543.24,189.36c12.879,4.1854,13.2,20.927,28.008,26.4,14.813,5.4733,16.263,18.673,28.333,15.454-11.267-3.0588-10.463-16.098-22.213-19.318-13.783-3.7758-18.996-24.791-29.946-28.01'/%3E %3Cpath d='m602.32,276.77c2.2542,5.1512,1.9333,14.327-6.1167,16.742,4.3458,2.7367,10.783,0.16084,14.325-5.795-5.3125,11.751-1.7708,22.376,6.6,24.469-4.025-8.21,4.9917-12.074,2.0958-17.386,5.3125,2.2538,9.9792,9.4979,9.8167,14.005,6.925-7.7271-5.15-18.03-2.8958-25.273l-23.825-6.7613z'/%3E %3Cpath d='m518.93,359.51c-7.8875-6.9221-11.254,1.8096-15.133-1.2075-3.6208-2.8171-8.45-3.2196-10.3-0.4025,6.7625,0.24167,3.4583,5.4733,16.579,6.7613-13.121,0.88541-10.704,15.535-19.479,14.81,9.3375,8.8538,14.167-7.8879,21.733-5.1512-2.2542,0.64375,3.5417,5.9562-0.48333,13.039,6.5208-0.16084,9.175-9.1758,9.9833-13.844l-2.9-14.005z'/%3E %3Cpath d='m345.23,434.69c-2.8979-2.4125-11.269-3.5417-14.488-1.6083-3.2192,1.9292-2.0925,2.4125,1.7708,2.7375,3.8638,0.32084,8.8525,6.5708,0.48291,6.9208-3.8633,0.15834-2.5754,9.4958-10.625,10.142,3.3,4.025,12.718,1.3667,16.098-3.0583-0.64375,3.6208,4.1854,6.9208,2.2538,11.267,5.9562,0.64584,2.495-12.071,11.913-11.429-3.8638,0.48334-2.2538,9.175,4.5071,6.9208-4.0242,1.9333-1.9317,6.6,2.5758,5.475-2.8975,0.96667-3.8638,4.6667,0.16084,6.7625,3.8638-5.3125-0.48292-24.308-14.649-34.129z'/%3E %3Cpath d='m695.85,257.07c12.321,0,22.308-9.9896,22.308-22.312,0-12.32-9.9875-22.31-22.308-22.31-12.325,0-22.313,9.99-22.313,22.31,0,12.322,9.9875,22.312,22.313,22.312z'/%3E %3Cpath d='m579.3,284.02c6.7625-6.4392,17.067-9.6588,24.146-4.8296,7.0833,4.8296,30.588,10.625,42.179,2.5758,11.588-8.0492,17.063-12.235,22.213-11.269,3.8667,5.7954,8.5334,8.5321,14.329,9.015,1.7708,1.9317,8.05,3.5417,11.592,3.0583,5.15,1.2879,11.429-0.32166,16.417-5.795,7.7292,1.1267,14.971-4.6683,17.708-13.361,8.2083-0.96583,8.6917-10.142,3.5417-16.259-4.8292-0.96584-1.125-17.225-18.675-14.005,7.4083,4.5071,1.7708,13.522,7.8917,17.708-4.1875,0-9.5792,1.7708-10.867,8.0488,1.6083-4.3462-0.24167-7.2438-1.3708-8.2096,0.1625-3.7025-8.0458-12.798-15.775-9.4979,5.5542,1.2075,2.4167,10.142,6.4417,13.522-2.9,0.16125-5.9583,1.61-7.7292,4.1854-2.0917-3.7025-9.4958-7.5658-14.004-7.8879,0-1.2879-0.24166-3.8633-0.80416-5.1512-2.0125-3.8633-3.7042-8.4508-2.9-14.327-3.8625,4.1854-7.0833,9.9808-9.0125,14.166-6.1167-4.1854-21.25,1.9317-28.333,3.5412-7.0833,1.61-30.908-2.2533-36.383-8.0488-5.4708-5.795-16.096-9.3367-26.075-12.234-13.725-3.9833-13.846-18.995-28.979-29.298-0.32083,18.674,28.013,77.914,34.45,84.353z'/%3E %3Cpath d='m421.54,426.32c11.913,0,21.571-9.6583,21.571-21.571s-9.6583-21.57-21.571-21.57-21.571,9.6575-21.571,21.57c0,11.913,9.6575,21.571,21.571,21.571z'/%3E %3Cpath d='m370.02,409.74c4.3462,5.6346,11.751,5.3138,14.81,4.8304,2.5758,6.7583,10.785,6.6,14.327,10.3,3.5417,3.7042,15.613,3.3833,19.155,1.2875-3.2167-0.32083-7.4033-2.25-11.428-5.6333-4.8579-4.0792-2.5758-12.234-6.4392-15.131,2.8975-3.2196,3.3804-8.5317,2.7367-10.625,3.0588-1.7708,5.3121-4.6683,5.6342-6.1171,5.3129-0.32208,9.9796-3.0588,11.913-5.1512,2.7375,2.5754,9.6583-0.805,13.363,3.5412,0.80417-10.625-9.3375-16.259-16.1-12.717-2.7375-1.4488-9.9804-0.48292-11.268,1.4488-2.2538-0.96584-8.5321,2.2538-11.43,4.3462,3.2196-1.7704,3.7025-7.0829,2.4146-9.0146,2.7367-1.1267,5.7954-4.8292,6.1171-7.5658,3.8638,0.64375,9.6575-1.9321,12.233-1.2879-4.1833-5.4733-11.105-7.405-18.189-6.9221-7.325,0.40292-10.463,5.5542-11.429,11.108-4.3467,2.5754-5.7954,11.268-4.1854,14.327-2.4958-0.08-4.8296,2.3346-5.7954,3.7025-3.3804-1.4488-8.21-2.4946-11.671-2.4946'/%3E %3Cpath d='m366.32,373.2c-1.4488-4.1854,0.47-7.9533,1.4488-11.268,2.495-8.4508,0.96584-10.625-6.6-9.4975-0.64375,4.0242,3.2196,17.225,5.1513,20.766z'/%3E %3Cpath d='m360.77,352.91c1.9317,1.9317,8.7738,2.8175,9.4979-3.2996,0.83167-7.0225-2.0121-9.74-8.1292-7.0033-0.48292,1.61-1.0471,8.21-1.3688,10.303z'/%3E %3Cpath d='m362.22,342.37c2.5758,1.0458,8.13,3.1388,11.188-2.8175,2.5658-4.9954-0.80458-8.8538-6.1167-8.5321-1.2883,1.4488-3.8638,6.6004-5.0717,11.35z'/%3E %3Cpath d='m366.97,330.54c0.64375,1.9317,7.2442,8.3708,12.073,3.7025,4.8296-4.6683,4.8296-11.59-2.4146-14.166-1.9321,0.32166-7.7271,7.0829-9.6588,10.463z'/%3E %3Cpath d='m376.62,320.08c1.4488,4.0242,5.9558,10.946,14.327,7.7267,8.3713-3.2196,4.8296-13.683,0.96625-15.776-2.2538,0.16125-11.43,4.3467-15.293,8.0492z'/%3E %3Cpath d='m391.92,312.03c-0.64417,3.5417,0,13.2,11.429,13.039,11.428-0.16083,8.2113-13.522,5.3125-15.454-4.6683,0-12.556,0.16083-16.742,2.4146z'/%3E %3Cpath d='m409.14,310.09c-1.2879,2.7367-4.1896,20.75,18.191,15.776,2.8958-0.64375,10.463-17.225-18.191-15.776z'/%3E %3Cpath d='m421.37,311.7c-2.25,2.2533,3.5417,20.444,18.675,17.385,15.133-3.0588,2.4167-20.283-18.675-17.385z'/%3E %3Cpath d='m434.25,314.44c-2.4125,4.9904,1.2125,19.8,19.883,19.8,16.921,0-0.8875-19.478-19.883-19.8z'/%3E %3Cpath d='m448.9,318.79c-1.2125,2.7662-2.6958,18.468,19.317,19.8,15.938,0.96583,12.075-21.571-19.317-19.8z'/%3E %3Cpath d='m472.57,325.39c-2.7333,4.8296-5.6333,16.903,18.513,17.869,15.471,0.61917,5.9583-17.547-18.513-17.869z'/%3E %3Cpath d='m492.69,329.09c-3.5417,4.8296-0.93333,14.303,8.0458,16.098,11.271,2.2538,12.879-8.3708,5.1542-13.522-7.7292-5.1513-13.2-2.5758-13.2-2.5758z'/%3E %3Cpath d='m503.64,331.34c-2.575,4.5075-0.97917,15.454,16.096,15.454,3.5417,0,17.067-13.844-16.096-15.454z'/%3E %3Cpath d='m371.48,541.27c13.83,0,25.042-11.213,25.042-25.042,0-13.833-11.212-25.046-25.042-25.046-13.831,0-25.043,11.213-25.043,25.046,0,13.829,11.212,25.042,25.043,25.042z'/%3E %3Cpath d='m555.15,177.13c-1.9333,1.9317-5.9542,7.7267-6.7625,9.9804-8.3708,25.113,13.975,43.871,27.046,70.83,10.304,21.249,9.0167,54.733-7.0833,75.982-5.5083,7.2683-3.8625,9.3367-10.946,16.742-2.7167,2.8408-5.7958,6.4392-4.8292,16.742,4.5083-1.61,10.946,2.5758,12.233,6.1171,3.2208-1.6096,7.7292-0.96584,9.3375,0.96583,5.4708-2.5754,9.9792-1.2879,14.808,3.8638,4.1875-0.64416,8.6958,0,12.879,4.5071,2.2542-4.5071,6.7625-6.1171,9.9792-5.1512-0.32083-5.795,5.475-9.9804,10.625-7.7267-1.6083-7.7271,5.475-13.523,12.238-11.269,5.7917-4.5075,17.383-4.8292,23.179,1.9317-10.304-2.8975-9.9792,8.0492-18.675,7.0833,2.2542,6.4392-3.5417,10.142-9.3334,12.234,3.7-1.7708,7.725-3.8633,9.0125-1.6096,3.2208-2.8167,9.6584-1.7708,11.271-0.32208,4.2625-1.3679,8.3708-0.32208,10.3,4.8292,5.7958,3.5417,9.6583,12.556,5.475,19.318-1.2875-7.0829-6.1167-6.7613-8.05-9.6588-4.5083,1.61-9.0167,1.61-10.304-1.2879-2.575,2.5758-11.267,4.8296-15.129,0.96584-1.45,5.7954-6.4417,10.625-12.238,10.625,1.6125,4.5071-2.8958,12.236-6.4375,16.098,5.475,2.8958,3.8625,9.3375,2.575,13.2,8.3708,1.2875,1.2875,8.6917,15.775,13.521-7.0792,2.2542-20.925,0-22.858-8.6917-7.0833-0.32083-11.913-7.4042-11.588-14.813-5.475-5.15-6.2792-12.554,1.2875-17.705-6.4417,1.9317-9.9834-8.3708-19.321-4.1854-4.6417,2.0825-16.9-1.4488-16.738-5.7954-1.9333,3.2196-13.683,1.9321-15.296-3.5412-3.8625,2.0925-12.879-1.4488-12.717-6.7613-4.9917,2.2538-11.75-1.7708-11.429-6.9221-4.6667-0.64375-5.15-4.8292-4.8292-8.3708-4.1875-1.9317-3.0583-5.9563-1.45-10.785-2.8958-3.2196-1.6083-7.7271,0.64583-11.913-3.2208-3.2196-2.575-7.0829-1.6125-11.59-15.454-1.2879-34.813-5.015-79.2-18.673-66.967-20.605-84.997,27.688-70.187,57.952,17.087,34.919-1.9317,42.5,3.8638,68.579,6.1171,1.2875,9.3367,6.4375,9.015,11.913,3.6208,0.15834,6.1967,3.5375,4.9088,9.9792,3.0588-0.5625,7.0034,0.32083,9.5788,2.8958,2.2538-4.1833,9.6588-5.15,13.523-0.32084,8.3688-0.64583,12.556,6.1167,12.235,14.488,4.5042,8.05,2.8958,17.871-1.9333,24.146,0.48334-3.3792,0-8.2084-0.15833-11.104-0.3-5.3292-7.7292-6.4417-6.9242-10.788-3.8633,0.32083-7.5663-1.7708-8.8538-4.6667-2.2538,1.9292-5.4733,2.575-8.21,1.6083,4.3462,1.9333,7.7271,9.6583,6.4392,14.808,2.2538,3.8667,1.7708,10.95-0.96583,14.008-1.2879,6.275-6.1171,8.5292-12.395,5.7917,3.5417-2.25,4.8292-6.275,4.6683-9.6583-2.2538-1.9292-3.3804-5.6333-3.5417-7.8875-6.2779,0.96667-14.971-4.3458-16.574-6.4458-13.831,0-25.043,11.213-25.043,25.046-0.64375-5.1542-7.1588-10.229-6.3542-14.575-3.8633-11.913,1.61-23.021,17.386-25.271-1.9317-4.5083,4.8292-9.1792,2.2538-14.329-3.2904-6.5792-9.3367-15.133-18.351-25.113,5.4733-9.3375,3.8633-21.892,0.64375-29.62-4.6233-11.096-9.015-8.3708-25.435,9.6579-26.76,29.383-62.46,21.25-94.012,40.567-8.3838,5.1333-16.741,7.0833-7.7267-1.9292,9.015-9.0167,32.84-18.029,48.293-25.758,28.94-14.471,53.445-38.635,63.104-85.64,22.697-110.46,106.24-74.05,159.04-53.445,49.571,19.346,40.567-24.469,15.454-50.869-30.183-31.732-24.146-56.664-9.9792-76.626,25.433-3.5412,74.213,5.3125,64.392,13.845z'/%3E %3Cpath d='m644.82,448.48c15.217,0,27.554-12.333,27.554-27.55,0-15.218-12.338-27.554-27.554-27.554-15.217,0-27.554,12.336-27.554,27.554,0,15.217,12.338,27.55,27.554,27.55z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m539.7,178.41c-6.1167,27.045-0.96667,39.279,8.05,51.191,18.629,24.621,33.483,80.811,12.233,117.51'/%3E %3Cg stroke-linecap='round'%3E %3Cpath d='m571.89,315.41c2.575-0.96583,7.4042-4.0242,8.5333-9.3367'/%3E %3Cpath d='m573.82,303.66c0.80417-4.6683,8.0458-6.68,8.2083-11.67'/%3E %3Cpath d='m573.98,285.46c-0.48334-4.8296,7.2458-9.1758,6.1167-14.005'/%3E %3Cpath d='m569.8,268.08c-0.64584-2.7367,6.4375-7.8879,4.5083-12.234'/%3E %3Cpath d='m564.49,251.18c-1.45-3.0588,3.3792-6.6004,1.2875-9.82'/%3E %3Cpath d='m556.76,237.65c-0.48334-2.0925,2.4958-6.68,0.8875-9.4163'/%3E %3Cpath d='m549.03,221.72c0.64167-0.805,3.2208-2.7367,2.1708-5.1513'/%3E %3Cpath d='m543.72,210.05c1.0458-0.56375,4.1833-1.53,3.7833-3.8633'/%3E %3Cpath stroke-linejoin='round' d='m382.58,513.57c-6.4392-2.2542-14.488,0.96667-16.098,6.4417'/%3E %3Cpath stroke-linejoin='round' d='m371.31,525c0.805-5.4708,9.1758-7.8875,11.751-5.3125-5.3121-2.8958-7.8879,7.4042-3.2196,7.7292'/%3E %3Cpath stroke-linejoin='round' d='m423.15,397.67c-3.8625,1.9321-4.9875,9.015,0,14.329'/%3E %3Cpath stroke-linejoin='round' d='m428.94,399.28c-2.7333,2.2538-2.575,9.0146,1.45,10.625-3.3792-2.4146,0-6.6,2.4167-6.7612,2.4125-0.16084,4.0208,2.7367,1.125,5.6342'/%3E %3Cpath stroke-linejoin='round' d='m655.12,415.21c-9.0125-2.4125-16.258,8.05-8.05,17.388-0.15833-9.0167,6.2792-14.971,14.167-13.363'/%3E %3Cpath stroke-linejoin='round' d='m657.61,425.47c-2.2167,0-3.4625,1.7333-3.4625,3.4208,0,1.7708,1.5292,3.4625,4.025,3.4625,1.6125,0,2.9-1.85,2.9-3.3'/%3E %3Cpath stroke-linejoin='round' d='m689.4,227.83c1.45,5.4733,9.0167,7.7271,14.971,6.4392'/%3E %3Cpath stroke-linejoin='round' d='m704.37,230.73c-4.6667,0.16125-8.5292-4.1854-8.2083-7.8879,0,2.7367,6.2792,4.0246,8.2083,2.2538'/%3E %3Cpath d='m384.83,414.57c-1.2875-3.2208,3.8638-6.4404,4.0246-9.4992,0.16125-3.0583,5.795-5.4729,11.59,0.32209'/%3E %3Cpath d='m397.71,371.11c-1.1267,0.48292-2.0929,1.1267-3.0588,1.4488'/%3E %3Cpath d='m408.82,388.65c-1.3688,0.0813-4.1854-0.08-5.715-1.1271'/%3E %3Cpath d='m403.19,394.77c-1.1267,0.56417-3.6229,1.53-5.0717,1.8521'/%3E %3Cpath d='m347.97,492c-0.16125,2.9,2.7367,7.0833,4.3462,8.3708'/%3E %3Cpath d='m360.53,485.08c-1.61,2.4125-2.5754,6.6-1.61,9.4958'/%3E %3Cpath d='m384.51,494.74c-2.8979-1.9333-0.96583-6.925-1.2879-10.142-0.32208-3.2208,3.3808-8.3708,10.625-4.025'/%3E %3Cpath d='m357.47,476.39c2.8979-0.48333,5.9563-0.325,7.8879,0.47917'/%3E %3Cpath d='m394.17,467.21c-1.2875,1.7708-1.6096,3.7042-1.7704,4.9917'/%3E %3Cpath d='m407.69,466.89c-2.2538,0-4.1854,1.6083-5.1513,3.2208'/%3E %3Cpath d='m376.46,384.47c2.5758,0.88584,9.2558,4.9904,9.4979,9.2567'/%3E %3Cpath d='m403.83,363.54c-7.8875-0.16125-10.946-8.21-4.99-8.21'/%3E %3Cpath d='m418,374.32c-3.0583,1.2879-1.6083,6.6,2.7375,9.1758'/%3E %3Cpath d='m399.16,424.87c-1.5296-1.9292,0.48291-7.5625,5.4733-5.875'/%3E %3Cpath d='m410.91,483.63c0.32-4.9083,6.52-7.8083,9.0158-2.2542'/%3E %3Cpath d='m388.05,497.63c-0.40292-5.3917,2.3338-7.1625,4.7483-7.4833,2.4146-0.32084,5.8767,1.6875,7.4863,5.2292'/%3E %3Cpath d='m340.08,501.66c0.32208-3.2208,3.0588-6.6,5.9562-6.1167'/%3E %3Cpath d='m634.67,358.71c-2.0958,1.53-3.4625,8.3708,4.5042,9.015'/%3E %3Cpath d='m622.44,369.98c0,0.80459,1.0458,1.9317,1.6917,2.4146'/%3E %3Cpath d='m660.43,382.86c-2.0917-1.6096-7.4875,4.9104-2.575,9.6588'/%3E %3Cpath d='m609.24,436.95c-1.2083-4.5875,3.0583-5.7958,7.0833-4.8292'/%3E %3Cpath d='m598.94,404.43c2.4125-1.6096,4.8292-3.3804,7.8875-4.1854'/%3E %3Cpath d='m597.65,422.13c0-3.8625,1.9292-7.0792,3.7-8.0458'/%3E %3Cpath d='m611.81,377.71c-0.32083,4.6683,1.6125,9.1758,3.0625,11.59'/%3E %3Cpath d='m650.13,378.03c-2.3375,0.725-4.4292,1.6096-5.3125,3.5417'/%3E %3Cpath d='m647.55,391.23c1.1292-0.96583,2.4167-2.0925,2.9792-2.8975'/%3E %3Cpath d='m708.4,250.69c0,4.5071-5.6333,6.9217-9.3333,4.0242'/%3E %3Cpath d='m720.64,250.85c2.4917,1.9317,11.104,0.0812,9.0917-4.9092'/%3E %3Cpath d='m710.17,276.77c-1.7708-0.32209-4.8292-2.2538-6.1167-3.8633'/%3E %3Cpath d='m727.88,263.41c-2.8958,0.64375-4.8292,0-6.2792-0.64375'/%3E %3Cpath d='m682.16,279.51c1.6083,0,5.4708-0.64417,8.1292-2.0117'/%3E %3Cpath d='m677.33,251.02c-2.0917-0.24083-3.625,0.16125-4.8292,0.96584'/%3E %3Cpath d='m709.77,258.9c-0.5625,2.0129-2.0125,5.1512-3.7833,6.5204'/%3E %3Cpath stroke-linejoin='round' d='m671.86,265.99c4.025-1.7708,9.0167,11.912,18.675,7.0829'/%3E %3Cpath stroke-linejoin='round' d='m691.34,258.9c-1.2875,1.7708-2.0917,4.5075-2.2542,6.9221'/%3E %3C/g%3E %3Cpath d='m498.81,237.98c1.2875-0.16083,3.5417-0.64375,4.025-2.2538'/%3E %3Cpath d='m333.16,387.85c4.8296,2.7367,8.2104,7.405,6.1175,14.327'/%3E %3Cpath d='m554.5,223.17c1.45,0.96583,6.925,0.96583,9.9833-0.16083'/%3E %3Cpath d='m568.35,226.39c-0.1625,2.2538,0.48333,10.785-3.8625,12.556'/%3E %3Cpath d='m566.1,237.82c4.025,1.2879,12.075,0.80459,14.65-6.6'/%3E %3Cpath d='m575.11,237.49c2.0917,3.2196,2.7333,9.4979-3.5417,12.878'/%3E %3Cpath d='m576.72,242.81c4.6667,1.6096,15.454,1.7704,14.325-7.405'/%3E %3Cpath d='m587.35,242.81c3.2208,4.5071,17.388,9.8196,15.133,0.48292'/%3E %3Cpath d='m574.31,255.84c5.4708,1.2879,13.2-2.415,9.9792-12.073'/%3E %3Cpath d='m599.74,248.6c0.80416,3.7025,18.833,7.5658,16.421-0.805'/%3E %3Cpath d='m612.78,252.63c3.3833,7.7267,21.25,7.0829,15.617-3.2196'/%3E %3Cpath d='m625.5,257.45c3.5417,4.3467,19.321,1.7708,13.042-8.6929'/%3E %3Cpath d='m638.37,257.29c9.8208,7.405,21.25-3.2196,8.8542-10.947'/%3E %3Cpath d='m652.86,254.88c8.6958,6.9221,19.321-5.6346,11.754-9.1758'/%3E %3Cpath d='m584.12,251.98c2.7375,0.805,8.5333,0.48292,9.8208-4.5071'/%3E %3Cpath d='m591.77,250.85c-0.32083,7.325,11.996,10.142,15.133,1.6908'/%3E %3Cpath d='m602.8,257.13c2.2542,4.8292,13.038,6.7608,14.808-0.16125'/%3E %3Cpath d='m615.84,260.19c1.7708,4.8296,11.108,4.3467,13.683-0.64375'/%3E %3Cpath d='m626.14,262.77c2.8958,6.2779,14.808,6.2779,17.546-2.8979'/%3E %3Cpath d='m641.6,263.89c4.6667,2.8979,14.65,1.7708,13.842-7.2438'/%3E %3Cpath d='m653.51,263.09c6.9208,5.6346,16.742,0.16125,11.913-9.3367'/%3E %3Cpath d='m664.94,270.49c3.7042-0.64375,5.6333-8.0488,1.7708-9.9804'/%3E %3Cpath d='m579.14,271.78c7.725-4.1854,9.175-11.268,3.8625-18.19'/%3E %3Cpath d='m585.74,264.7c4.8292,2.8975,14.004-0.16083,15.613-7.2442'/%3E %3Cpath d='m592.34,265.5c2.7333,3.5413,3.2167,7.8879-0.325,11.912'/%3E %3Cpath d='m594.59,270.01c8.5292-5.3121,19.154,4.5075,11.267,10.464'/%3E %3Cpath d='m604.41,269.53c1.9333-0.48291,5.3125-4.0242,5.6333-8.0488'/%3E %3Cpath d='m608.27,273.23c3.5417-3.7025,27.692,3.8638,12.396,11.59'/%3E %3Cpath d='m619.54,263.09c4.6667,1.7708,7.0833,8.3713,0,10.625'/%3E %3Cpath d='m625.66,279.19c5.15-5.3121,21.25-1.9317,15.454,4.8296'/%3E %3Cpath d='m637.25,277.09c2.8958-9.82,20.121-3.7025,14.488,0.32167'/%3E %3Cpath d='m633.71,267.27c0.48333,1.9321,0.64166,6.7613-2.575,9.3371'/%3E %3Cpath d='m648.2,265.34c0.64167,1.61,0.48334,4.6683-0.96667,6.6004'/%3E %3Cpath d='m659.14,265.5c0.96666,1.7704,2.575,5.1513-0.96667,7.8879'/%3E %3Cpath d='m521.35,191.45c0.15833,9.1754,3.3792,15.293,15.775,9.4975'/%3E %3Cpath d='m525.21,202.4c-6.1167,8.21,0.80417,17.064,12.879,8.21'/%3E %3Cpath d='m506.37,206.42c8.3708,9.0146,23.342,2.4146,13.683-11.269'/%3E %3Cpath d='m530.2,214.15c-1.6125,8.8538,5.6333,10.625,11.588,6.6'/%3E %3Cpath d='m498.97,207.87c1.525,8.9013,10.625,15.937,19.479,10.464'/%3E %3Cpath d='m509.92,220.11c0,12.718,17.546,14.166,21.571,0.96625'/%3E %3Cpath d='m525.21,229.12c5.6333,11.59,17.867,6.9221,21.892-0.16084'/%3E %3Cpath d='m512.81,210.61c2.2542,5.6342,6.7625,11.913,17.225,7.2442'/%3E %3Cpath d='m480.62,207.87c1.45,4.6683,9.8208,10.303,19.479,3.8633'/%3E %3Cpath d='m486.57,213.83c-5.1542,7.5658,5.15,14.649,17.546,3.3804'/%3E %3Cpath d='m492.69,223.17c2.0917,10.625,6.275,19.157,21.408,5.4733'/%3E %3Cpath d='m506.53,234.11c5.475,6.7608,13.846,10.946,21.733-0.48292'/%3E %3Cpath d='m534.06,236.04c-0.48333,8.0488,1.125,12.073,7.4042,11.751,4.95-0.25334,9.6584-4.1854,12.396-8.3708'/%3E %3Cpath d='m540.34,247.8c-0.1625,9.1758,7.0792,16.42,20.604,7.0833'/%3E %3Cpath d='m545.97,258.58c-2.575,6.9221,5.15,18.19,20.283,12.395'/%3E %3Cpath d='m513.94,240.23c-0.9625,8.8538,7.2458,14.81,20.446,3.3804'/%3E %3Cpath d='m520.38,250.05c0.48334,7.2442,8.6917,15.937,20.767,3.3804'/%3E %3Cpath d='m526.17,259.23c-0.96667,12.395,10.463,15.937,20.121,6.4392'/%3E %3Cpath d='m508.95,250.05c2.575,0.16125,4.6667-2.0925,5.9542-3.7025'/%3E %3Cpath d='m514.42,259.06c2.2542,0.48292,6.1208-1.61,7.4083-4.1854'/%3E %3Cpath d='m520.06,273.71c2.575,2.7367,11.267,0.805,12.392-2.8975'/%3E %3Cpath d='m529.72,273.55c4.8292,11.268,17.704,10.785,23.017-1.9317'/%3E %3Cpath d='m550.32,276.13c2.4125,6.6,8.5333,10.785,18.513,8.5317'/%3E %3Cpath d='m555.15,282.89c-5.6333,9.1758,1.7708,19.961,14.325,9.3367'/%3E %3Cpath d='m558.21,296.57c-0.64167,5.795,4.6708,12.395,11.913,13.2'/%3E %3Cpath d='m534.38,279.67c-1.9333,13.039,7.4042,19.318,19.158,12.395'/%3E %3Cpath d='m520.7,285.95c3.0583,2.4146,8.5333,2.7367,13.683,0.805'/%3E %3Cpath d='m540.66,294.32c-2.9,10.947,8.3708,18.835,18.029,6.6'/%3E %3Cpath d='m525.05,287.72c0.1625,5.6342,5.6375,11.751,15.133,9.9804'/%3E %3Cpath d='m566.74,308.97c-6.4417,4.3462-7.7292,12.073,1.2875,17.063'/%3E %3Cpath d='m550.96,306.71c0.325,6.6,3.3833,10.303,10.625,10.946'/%3E %3Cpath d='m541.47,303.33c-9.6583,8.8542-0.1625,19.157,11.267,10.464'/%3E %3Cpath d='m548.23,316.53c-3.2208,10.142,8.8542,16.259,15.292,5.9562'/%3E %3Cpath d='m528.27,294.96c-3.5417,9.9808,0.96667,16.581,9.175,15.937'/%3E %3Cpath d='m515.55,293.03c0.48334,5.9562,5.6333,8.0488,11.429,6.7612'/%3E %3Cpath d='m519.25,299.31c-4.3458,8.3708,2.2542,12.878,10.95,9.6588'/%3E %3Cpath d='m556.6,327.64c-1.45,5.3121-0.64583,9.1758,7.2417,10.947'/%3E %3Cpath d='m557.08,335.21c-9.5,4.3467-10.304,13.523-2.9,19.478'/%3E %3Cpath d='m549.43,324.99c-4.9875,4.5075-4.025,12.314,1.45,15.373'/%3E %3Cpath d='m507.18,295.61c-5.475,5.3933-0.24167,20.283,11.829,12.155'/%3E %3Cpath d='m538.57,314.44c-7.4083,6.1175-4.025,17.225,8.2083,14.166'/%3E %3Cpath d='m526.33,309.77c-3.8625,10.947-0.15834,14.81,8.5333,14.971'/%3E %3Cpath d='m499.13,295.12c-6.6,4.99-4.8292,12.073-1.9292,15.293,2.8958,3.2196,8.3667,1.7708,10.138-2.4146'/%3E %3Cpath d='m485.28,290.78c-7.4042,9.4979,0,20.766,10.467,17.386'/%3E %3Cpath d='m524.89,318.95c-7.5667,2.7367-13.338,9.6071-8.6958,15.615,2.7375,3.5417,14.65,4.0246,18.029-9.6588'/%3E %3Cpath d='m511.2,310.09c-4.3458,6.2783-2.9,12.235,5.15,15.293'/%3E %3Cpath d='m510.72,321.85c-4.6708,2.5758-7.7292,5.6346-6.6,11.269'/%3E %3Cpath d='m500.26,312.03c-1.7708,7.5663,0.32083,12.235,4.9875,14.488'/%3E %3Cpath d='m500.1,321.04c-7.2458-0.48292-10.946,2.5754-8.5333,9.6588'/%3E %3Cpath d='m492.21,322.81c-7.0833-2.5758-8.2125-8.6929-5.1542-15.132'/%3E %3Cpath d='m486.09,317.18c-7.7292,0.32208-11.108,4.1854-11.108,9.4979'/%3E %3Cpath d='m475.62,287.07c-5.6333,2.4146-7.4042,9.9808-5.3125,14.166,2.0958,4.1854,8.6958,4.5075,12.721,1.7708'/%3E %3Cpath d='m459.85,281.12c-5.15,5.7954,0.80417,17.064,9.9834,14.327'/%3E %3Cpath d='m446.65,276.61c-4.8292,6.7608,0.48333,18.03,12.879,14.81'/%3E %3Cpath d='m460.17,322.81c-1.2875-8.0492,7.0833-13.361,17.388-2.8979'/%3E %3Cpath d='m472.57,303.66c-3.0583,2.7367-4.5042,7.0829-4.025,10.625'/%3E %3Cpath d='m433.45,272.75c-5.3125,9.015,1.1292,17.225,12.558,14.005'/%3E %3Cpath d='m463.23,295.12c-7.5667,7.5658-4.9917,15.132,0.64167,19.478'/%3E %3Cpath d='m458.4,303.98c-11.429,0.16084-12.071,13.361-2.7333,17.547'/%3E %3Cpath d='m449.71,290.78c-4.6667,3.2196-6.1167,12.073,1.9333,15.615'/%3E %3Cpath d='m449.39,310.58c-4.8292-2.2538-10.625,0.48292-10.142,6.1171'/%3E %3Cpath d='m442.14,310.74c-4.3458-10.303-17.063-8.5317-15.933,2.0929'/%3E %3Cpath d='m445.68,298.02c-2.7333,0.48291-8.2083,2.0925-10.3,6.2783'/%3E %3Cpath d='m436.19,286.43c-5.15,5.795-1.1292,12.717,3.0583,14.166'/%3E %3Cpath d='m420.9,270.17c-0.96667,6.9221,1.7708,10.303,10.463,9.6588'/%3E %3Cpath d='m423.95,279.03c-3.3833,8.3708,1.125,12.073,9.8167,11.59'/%3E %3Cpath d='m425.88,289.33c-5.15,6.1171-1.6083,12.718,3.3792,15.454'/%3E %3Cpath d='m423.47,297.06c-9.175-1.1271-10.625,9.4975-7.5667,14.488'/%3E %3Cpath d='m416.06,269.37c-5.6321,2.4146-8.8517,9.4975-5.7933,13.844,3.06,4.3463,9.1767,2.8975,12.556,0.64375'/%3E %3Cpath d='m412.2,285.14c-4.6675,7.0829-0.48333,12.395,4.5083,14.488'/%3E %3Cpath d='m394.17,268.56c-3.7021,3.8633-1.4488,11.752,7.5663,11.913,7.2579,0.13,10.946-6.7612,8.6929-11.59'/%3E %3Cpath d='m400.45,280.47c-2.8975,6.4392-1.1267,13.361,9.8196,12.234'/%3E %3Cpath d='m414.94,302.85c-6.7608-3.0583-15.776,0-11.912,8.0492'/%3E %3Cpath d='m402.06,291.42c-2.7367,3.8633-1.7708,9.3367,1.2875,12.717'/%3E %3Cpath d='m401.58,301.72c-4.5075,0.805-8.8542,3.2196-6.1175,10.303'/%3E %3Cpath d='m394.81,306.23c-5.795-1.7708-13.2,2.4146-8.6929,8.3708'/%3E %3Cpath d='m385.16,308.97c-4.9904-0.80501-10.946,4.5071-6.1171,9.8196'/%3E %3Cpath d='m377.11,314.44c-4.5075,1.1271-9.8196,6.2783-5.1517,10.303'/%3E %3Cpath d='m399.81,289.17c-6.4392,2.8975-7.0833,10.142-4.0246,15.454'/%3E %3Cpath d='m393.04,275.81c-9.6588,3.7025-9.4975,16.581,1.1267,20.605'/%3E %3Cpath d='m389.66,293.51c-5.795,3.3804-6.9221,9.8196-3.0583,14.005'/%3E %3Cpath d='m379.52,270.98c-3.8638,1.2879-3.5417,13.2,6.7613,12.878'/%3E %3Cpath d='m368.9,275c-7.7271,5.1513,1.6096,18.19,14.166,8.8538'/%3E %3Cpath d='m376.14,287.07c-1.1267,5.3125,0.32209,11.108,8.8542,11.752'/%3E %3Cpath d='m376.62,294.16c-6.1175,2.2533-7.2442,14.81,3.8633,15.776'/%3E %3Cpath d='m357.15,282.73c-7.8879,7.2442,6.4392,13.522,11.752,3.0588'/%3E %3Cpath d='m346.2,294.8c-3.8638,4.6683,9.6583,16.903,15.615-3.5417'/%3E %3Cpath d='m363.26,290.94c0.32167,4.8292,3.2196,7.7267,9.1754,8.0488'/%3E %3Cpath d='m372.28,303.66c-9.4975,1.4488-12.556,13.361-1.9317,15.937'/%3E %3Cpath d='m354.73,302.05c-0.32208,4.5071,4.3463,8.2096,9.6588,7.405'/%3E %3Cpath d='m369.22,319.27c-8.6925,1.9317-9.8196,13.2-2.0925,12.556'/%3E %3Cpath d='m363.1,342.29c-7.2446-2.1729-7.4054-10.786-0.96625-14.005'/%3E %3Cpath d='m357.15,334.72c-6.1167,3.7025-3.7021,12.556-0.48292,13.844,3.2196,1.2879,5.7954-0.32166,6.1175-3.0583'/%3E %3Cpath d='m362.3,357.9c0.64417,4.1854-14.891,2.5758-6.9217-10.463'/%3E %3Cpath d='m355.29,358.63c-5.2313,8.21,3.3008,14.89,8.6929,7.8883'/%3E %3Cpath d='m356.02,368.53c-2.0929,6.6004,5.875,11.35,11.026,6.1983'/%3E %3Cpath d='m338.63,306.71c-2.8979,5.9563,11.59,8.2096,12.556-4.0246'/%3E %3Cpath d='m334.61,315.57c-2.8975,11.59,18.995,9.1758,13.361-5.7954'/%3E %3Cpath d='m348.45,317.5c3.0583,1.7708,12.235,1.9317,14.488-7.8879'/%3E %3Cpath d='m356.34,317.82c0.64375,3.0583,3.3804,6.7608,5.9558,7.8879'/%3E %3Cpath d='m345.88,320.88c-0.96583,6.2783,5.3121,11.43,12.556,10.947'/%3E %3Cpath d='m347,327c-3.5412,4.8296-4.6683,14.166,6.4396,14.81'/%3E %3Cpath d='m330.1,328.61c-1.7708,4.9904,8.6929,10.142,14.81,1.9317'/%3E %3Cpath d='m326.88,341.32c-0.88625,3.7838,8.5317,8.8542,13.844-7.2438'/%3E %3Cpath d='m336.54,342.29c2.2538,4.0242,9.8196,7.2438,14.488-0.64417'/%3E %3Cpath d='m343.46,346.48c-1.9317,5.6342,3.3808,10.946,9.8196,9.3367'/%3E %3Cpath d='m331.39,345.19c-1.2879,8.0488,8.0488,12.717,13.844,8.5317'/%3E %3Cpath d='m325.27,348.73c-2.7362,10.303,10.464,14.166,15.454,6.4388'/%3E %3Cpath d='m337.35,358.23c0.48333,5.7954,9.4983,10.785,16.581,5.9563'/%3E %3Cpath d='m321.25,363.06c-0.64375,2.5754,10.142,5.1513,11.751-3.8638'/%3E %3Cpath d='m327.53,365.31c2.5754,6.6004,11.268,8.21,16.259,0.16125'/%3E %3Cpath d='m340.89,368.69c1.1271,6.1171,9.015,9.4975,15.937,5.3121'/%3E %3Cpath d='m359.72,376.42c-1.7704,8.21,6.7613,14.81,12.073,10.303'/%3E %3Cpath d='m346.04,374.97c-2.5754,9.015,8.6929,14.166,14.971,9.1758'/%3E %3Cpath d='m332.52,370.46c-0.64375,8.3708,5.9562,13.361,13.522,9.6583'/%3E %3Cpath d='m318.19,371.27c-2.2542,5.4733,9.6588,9.9808,15.293,5.3125'/%3E %3Cpath d='m310.78,386.24c3.0588,3.5412,13.683,0,14.649-7.8879'/%3E %3Cpath d='m322.54,384.14c3.8633,4.5075,13.039,6.9221,16.742-2.7367'/%3E %3Cpath d='m336.06,386.4c-0.16125,6.9221,12.235,11.913,16.259-0.805'/%3E %3Cpath d='m366.88,388.09c-1.1271,3.3808,1.53,8.7729,7.0829,9.4167'/%3E %3Cpath d='m356.66,386c-0.805,3.8633,4.8296,9.2554,10.786,7.0829'/%3E %3Cpath d='m368.58,394.69c-1.6096,4.1854-0.24208,10.221,5.3921,10.141'/%3E %3Cpath d='m369.14,402.5c-4.1854,3.5412-2.415,9.8204,3.6229,10.062'/%3E %3Cpath d='m366.97,408.45c-5.9563,4.0225-3.8633,12.877,4.0242,12.398'/%3E %3Cpath d='m348.94,391.39c0,8.6929,10.785,9.9804,12.878,1.9317'/%3E %3Cpath d='m357.63,398.47c-1.61,5.1512,2.5754,10.142,9.1754,8.6929'/%3E %3Cpath d='m358.92,460.61c1.4492,2.0958,7.405-1.4458,5.7954-4.9875s-7.9192-1.6167-7.2442,2.0917'/%3E %3Cpath d='m363.26,454.17c0.80459-7.0833-7.5663-8.2083-9.6588-2.0917'/%3E %3Cpath d='m356.66,448.54c2.0929-3.5417-4.99-8.3708-7.8879-3.2208'/%3E %3Cpath d='m351.35,443.22c1.9317-5.1542-6.1171-7.4042-6.7613-2.7375'/%3E %3Cpath d='m342.82,433.72c0.96625-2.575,9.9808-0.96667,6.1175,4.3458'/%3E %3Cpath d='m355.86,444.51c3.5417-3.2208-2.4142-9.8208-6.1171-7.4042'/%3E %3Cpath d='m379.68,454.33c-2.8179,0.32084-5.7158,2.1708-3.6229,8.1292,1.4512,4.1333,7.6471,4.3458,8.5317,1.85'/%3E %3Cpath d='m375.58,457.31c-2.7367-1.7708-8.6929,1.2083-5.9562,7.0042,2.0604,4.3625,7.2442,2.575,8.0488,0.32083'/%3E %3Cpath d='m360.2,465.6c1.3675,2.4125,8.2088,1.3708,9.4167-1.2875'/%3E %3Cpath d='m364.87,457.63c1.4488-0.96667,4.1042,0.2375,4.6683,1.4458'/%3E %3Cpath d='m364.39,417.95c-4.6683,3.0583-1.7708,12.396,5.4733,9.9792'/%3E %3Cpath d='m362.94,425.52c-3.7025,2.8958-0.32208,11.913,6.6,8.5333'/%3E %3Cpath d='m364.07,434.05c-2.5754,2.575-0.0808,9.7375,6.6004,8.3708'/%3E %3Cpath d='m363.1,437.59c-1.4492-0.64584-5.2325-0.1625-6.8425,2.25'/%3E %3Cpath d='m358.92,404.99c-3.5412,3.3804-1.8517,10.304,4.7483,10.866'/%3E %3Cpath d='m357.63,412.07c-5.0717,2.4958-5.0717,12.554,5.07,12.958'/%3E %3Cpath d='m357.23,423.42c-2.8167,2.2542-1.4488,10.946,5.7954,9.8167'/%3E %3Cpath d='m359.56,432.92c-1.0471,1.0458-1.2083,3.7042-0.32208,4.8292'/%3E %3Cpath d='m356.34,429.62c-2.5754,0.0792-5.9562,1.9333-6.8425,4.5875'/%3E %3Cpath d='m344.83,424.87c0.96583-2.575,8.9354-2.4125,9.4979,5.1542'/%3E %3Cpath d='m355.13,421.01c-1.1271,0.24167-3.2996,1.2875-3.8633,3.4625'/%3E %3Cpath d='m351.67,397.43c-3.4617,3.1388-5.1512,13.04,5.3921,14.97'/%3E %3Cpath d='m344.67,417.87c0-2.6583,7.1642-4.9125,9.6588-0.96666'/%3E %3Cpath d='m340.08,403.46c1.0458,2.0129,6.0362,4.7496,9.095,2.4958'/%3E %3Cpath d='m314.16,387.69c-0.16042,4.6683,3.7029,8.8538,9.015,8.21,5.3121-0.64417,6.4392-5.3125,4.8292-8.3713'/%3E %3Cpath d='m323.98,396.06c-3.5417,4.3463,0.805,10.464,4.8292,8.6929'/%3E %3Cpath d='m328.01,393c2.0929-0.805,9.015-1.7708,11.108,1.4488'/%3E %3Cpath d='m305.63,394.29c-1.61,2.4146,8.3712,4.8296,11.751,0.16083'/%3E %3Cpath d='m314,396.86c-0.3225,3.2196,1.2875,8.6925,9.4975,6.4392'/%3E %3Cpath d='m324.79,408.29c1.2875-2.7367-4.8296-7.2438-9.4979-2.2538-4.6683,4.9904,0.64375,10.625,3.5417,8.6917'/%3E %3Cpath d='m303.38,397.51c-2.4146,4.1854,6.9221,11.833,12.235,4.7496'/%3E %3Cpath d='m297.18,404.75c-3.3804,3.4617,0.805,9.8208,5.8763,7.8875,5.0704-1.9313,4.5875-7.2438,3.3808-8.6113'/%3E %3Cpath d='m290.66,411.19c-2.7367,2.4942-0.0813,8.3692,3.7025,8.3692,3.7821,0,6.1171-2.975,5.3921-6.7583'/%3E %3Cpath d='m306.03,410.71c-0.48333,3.7021,4.99,6.2771,8.5317,2.8188'/%3E %3Cpath d='m314.73,406.76c0.48292-0.805,0.0813-2.1742-0.72334-2.8179'/%3E %3Cpath d='m284.79,416.18c-3.1383,2.4958,3.6229,9.4167,7.8879,3.0583'/%3E %3Cpath d='m309.01,414.81c-2.0129,1.9292,1.2067,7,4.4262,5.4708'/%3E %3Cpath d='m297.99,418.35c0.48292,3.4583,7.2442,6.0333,11.51,0.725'/%3E %3Cpath d='m301.69,421.81c-1.0458,2.175,1.0471,5.6375,3.6225,5.1542'/%3E %3Cpath d='m365.76,441.7c-2.4942,4.9083,5.4733,10.625,11.269,4.6667'/%3E %3Cpath d='m371.55,449.02c-1.2067,2.6542,0.24209,6.3583,2.4146,7.725'/%3E %3Cpath d='m363.99,454.57c0.56417-2.4167,4.0242-4.6708,7.1642-3.5417'/%3E %3Cpath d='m359.8,448.21c0.48292-2.1708,3.3804-4.3458,5.5542-3.7792'/%3E %3Cpath d='m549.35,347.76c-11.429,0.16125-6.6,18.513,3.2208,14.81'/%3E %3Cpath d='m545.65,361.29c-2.2542,3.7025,2.0917,9.5788,6.9208,6.1171'/%3E %3Cpath d='m551.29,368.13c-3.3833,5.6342,8.6917,14.246,13.521,5.3921'/%3E %3Cpath d='m560.95,376.9c0.15834,5.3125,15.613,8.6929,13.363-1.9317'/%3E %3Cpath d='m572.86,380.76c3.7,6.2779,17.546,6.9221,16.096-2.4146'/%3E %3Cpath d='m585.9,384.79c2.9,4.1854,16.421,6.7608,15.938-1.9321'/%3E %3Cpath d='m531,331.83c1.9292,4.9904,8.5292,6.7613,15.775,3.8633'/%3E %3Cpath d='m526.82,335.37c4.5083,2.8975-2.0917,16.098-9.0125,10.785'/%3E %3Cpath d='m526.82,343.58c4.9917,2.415,11.108,0.64417,12.879-6.4392'/%3E %3Cpath d='m536.64,342.61c0.48334,3.7025,5.7958,6.6004,12.717,5.1512'/%3E %3Cpath d='m524.24,346.48c6.4417,5.4733-2.8958,16.742-7.0833,11.59'/%3E %3Cpath d='m526.66,350.66c3.0583,2.2538,10.946,0.96584,11.75-4.9904'/%3E %3Cpath d='m534.87,350.66c0.64583,3.8633,3.7042,5.3121,8.05,5.4733'/%3E %3Cpath d='m524.89,355.97c3.2167,4.5075,11.267,5.7954,14.808-0.16083'/%3E %3Cpath d='m536.15,359.19c-0.32083,4.3467,4.5083,7.8879,9.5,6.9221'/%3E %3Cpath d='m518.61,368.85c4.1833,2.0925,8.6917-5.795,5.15-11.268'/%3E %3Cpath d='m523.44,377.22c4.9917,0.32208,5.6333-7.2438,0.96667-11.43'/%3E %3Cpath d='m534.87,384.14c4.1875-0.96583,2.8958-10.142-7.2458-10.947'/%3E %3Cpath d='m547.58,390.91c4.025-1.1271,0.80417-11.269-10.3-10.625'/%3E %3Cpath d='m562.88,394.45c2.7333-4.1854-6.2792-11.268-13.683-7.5658'/%3E %3Cpath d='m570.44,400.24c4.9917,1.4488,8.3708-11.751-7.4042-9.6588'/%3E %3Cpath d='m579.62,400.24c4.35-1.1267,7.4084-9.015-5.3083-6.4392'/%3E %3Cpath d='m589.28,400.89c3.8625,1.9321,5.6333-9.3367-6.1208-6.2779'/%3E %3Cpath d='m524.4,365.79c4.8292,2.7367,12.396-0.48291,11.75-6.6'/%3E %3Cpath d='m534.22,364.51c1.6125,2.8975,0.96667,8.5317-2.0917,9.9804'/%3E %3Cpath d='m534.7,371.27c3.2208,1.2879,7.5667,0.16125,10.142-4.99'/%3E %3Cpath d='m540.34,371.27c0.9625,2.2538,1.2875,6.7613-0.80833,9.015'/%3E %3Cpath d='m541.15,375.13c3.5417,1.9317,7.725-0.64417,9.4958-4.3467'/%3E %3Cpath d='m548.39,374c2.575,1.61,4.8292,9.1758,0.48333,12.235'/%3E %3Cpath d='m551.29,382.7c3.0583,0.16083,7.5667,0.16083,10.463-3.7025'/%3E %3Cpath d='m559.66,381.09c2.7375,0.805,5.9542,5.3125,4.8292,9.3371'/%3E %3Cpath d='m564.65,388.97c3.0625-0.32209,8.3708-2.415,9.8208-6.1175'/%3E %3Cpath d='m573.02,385.27c2.5792,1.4488,4.35,4.5071,4.025,8.0488'/%3E %3Cpath d='m577.04,390.74c3.0583-0.16084,5.7958-1.7704,6.6-5.1513'/%3E %3Cpath d='m582.84,387.85c2.2542,0.805,4.9917,3.3804,5.1542,6.4392'/%3E %3Cpath d='m587.67,392.35c2.2542-0.32209,3.8625-1.7708,5.3125-4.0246'/%3E %3Cpath d='m599.1,388.01c2.9,2.8979-0.9625,12.557-6.9208,10.786'/%3E %3Cpath d='m537.28,192.9c-5.9583,3.5412-22.863,2.4146-14.492-11.59'/%3E %3Cpath d='m538.89,183.4c-11.75,4.6683-26.242-4.3462-11.108-14.166'/%3E %3Cpath d='m523.76,166.02c-9.8208,0-16.421,15.776-3.2167,21.249'/%3E %3Cpath d='m485.61,172.62c-2.575,4.99,6.6,10.463,12.879,5.4733,4.8625-3.8662,4.5042-14.327,1.6083-18.352'/%3E %3Cpath d='m480.62,184.53c-3.2208,10.624,20.446,11.268,16.742-5.6346'/%3E %3Cpath d='m479.33,200.31c0.80417,8.0488,22.7,5.4733,15.613-10.786'/%3E %3Cpath d='m497.52,185.01c1.7708,2.4146,6.6,6.6,14.808,5.795'/%3E %3Cpath d='m501.38,173.58c0.725,2.8975,5.6333,5.1512,11.913,2.9788'/%3E %3Cpath d='m281.73,418.51c-5.5533,3.9458,2.9788,10.142,6.1171,3.3'/%3E %3Cpath d='m277.38,421.57c-5.5529,3.9417,2.9788,10.138,6.1175,3.2958'/%3E %3Cpath d='m272.79,424.55c-5.5546,3.9458,2.9775,10.142,6.1171,3.3'/%3E %3Cpath d='m267.96,427.29c-5.3125,2.8167,0.88458,9.7375,6.2779,3.6208'/%3E %3Cpath d='m262.73,429.95c-5.3125,2.8125,0.88584,9.7375,6.2783,3.6208'/%3E %3Cpath d='m289.7,421.65c-0.0813,4.1042,7.7271,5.7958,10.543-0.325'/%3E %3Cpath d='m294.61,425.44c-2.4146,3.0583,2.0129,6.8417,4.4275,5.4708'/%3E %3Cpath d='m284.22,424.87c-0.24208,3.4625,6.5188,5.475,9.8196,1.6917'/%3E %3Cpath d='m287.93,428.5c-2.1738,2.8167,2.0925,6.6,4.8292,5.4708'/%3E %3Cpath d='m279.72,428.01c0.24083,2.7375,4.1042,5.875,8.29,4.1042'/%3E %3Cpath d='m282.21,431.71c-1.61,1.45-0.80459,4.8333,1.4488,5.8792'/%3E %3Cpath d='m273.84,431.47c-0.64375,2.4958,3.6225,6.925,7.9688,4.025'/%3E %3Cpath d='m274.72,434.37c-2.5754,2.0125-2.2538,5.0708,1.0458,5.4708'/%3E %3Cpath d='m268.53,434.05c-0.32167,1.6875,1.8521,4.425,4.5888,4.1042'/%3E %3Cpath d='m254.76,433.89c-2.5754,1.3667,4.0246,8.3708,8.1288,1.85'/%3E %3Cpath d='m248.4,436.78c-3.2196,1.5333,4.7492,9.2584,8.2913,1.3708'/%3E %3Cpath d='m269.25,436.46c-2.4958,0.5625-4.1054,4.1875-2.0129,5.6333'/%3E %3Cpath d='m261.12,437.75c-0.32208,1.45,2.7367,3.8625,5.2329,2.9792'/%3E %3Cpath d='m259.03,438.4c-2.4146,1.5292-1.1271,5.7917,1.6908,5.15'/%3E %3Cpath d='m250.42,441.21c-2.2538,1.6875-0.725,5.0708,2.4146,4.2667'/%3E %3Cpath d='m254.52,440.97c0.0813,0.88333,2.0929,2.2542,3.7838,1.6917'/%3E %3Cpath d='m242.61,439.52c-2.8162,1.2083-2.6554,8.2917,6.8425,4.4292'/%3E %3Cpath d='m236.25,442.34c-3.9446,1.9333-2.6567,7.2458,5.9562,2.175'/%3E %3Cpath d='m242.93,444.92c-1.0458,0.80416-2.1725,4.3458,1.7708,2.975'/%3E %3Cpath d='m235.69,446.6c-1.6096,1.45-0.5625,4.4292,2.9792,3.3'/%3E %3Cpath d='m227.4,447.09c-2.8975,1.6917,3.4604,3.9458,7.7271-0.5625'/%3E %3Cpath d='m229.33,449.18c-1.2883,1.2875-1.2883,5.0708,2.0925,3.7042'/%3E %3Cpath d='m221.12,450.71c-1.9317,1.45,1.3679,3.3833,7.405,0.725'/%3E %3Cpath d='m223.53,452.8c-2.2538,1.85-2.0129,4.1833,1.2875,3.4583'/%3E %3Cpath d='m216.85,453.85c-2.4946,2.2542,1.1267,3.7833,5.4733,1.9292'/%3E %3Cpath d='m216.93,456.35c-4.2667,1.9292-2.415,5.4708,0.24084,4.1042'/%3E %3Cpath d='m359.4,468.66c-0.98917,2.1292,2.2538,3.8625,5.3125,3.3792,2.9379-0.4625,5.7483-2.8833,3.5413-6.275'/%3E %3Cpath d='m368.41,469.95c2.8975,2.2542,8.0488-0.32083,8.0488-3.7042'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cpath d='m545.97,128.83c-12.879-6.4392-39.6-18.352-47.167-8.6929,6.9208-2.8975,27.204,0.16125,43.946,15.615l3.2208-6.9221z'/%3E %3Cpath d='m553.78,128.15c-14.892-17.347-23.663-13.464-34.371-19.439-10.058-5.6142-26.079-6.7612-29.183,2.1671,14.696-7.1575,28.188,3.8488,36.475,5.1804,11.383,1.8279,17.808,10.628,21.138,14.675l5.9417-2.5833z'/%3E %3Cpath d='m609.88,125.93c-7.7292-17.708-24.254-13.083-31.554-20.605-10.621-10.946-37.504-21.088-48.613-13.522,24.467-1.2879,34.888,16.865,47.971,23.181,9.3375,4.5075,19.317,14.166,32.196,10.947z'/%3E %3Cpath d='m580.91,124c-13.2-16.42-33.488-30.908-42.821-25.435,12.233,0.64375,16.096,9.1758,24.792,14.649,8.6917,5.4733,4.8292,13.361,18.029,10.786z'/%3E %3Cpath d='m518.12,152.98c-13.846-5.1513-40.888-7.7267-53.446,8.0492,20.929,3.5413,52.479,1.6096,53.446-8.0492z'/%3E %3Cpath d='m515.55,159.1c-13.846-6.4392-24.658,2.555-37.671,1.2875-24.788-2.4146-42.496-0.96584-44.75,10.947,14.167-12.717,37.992-2.2538,47.65-4.8292,9.6584-2.5758,45.396-0.32208,56.663,4.5071-5.7958-7.0829-14.808-9.0146-21.892-11.912z'/%3E %3Cpath d='m559.01,122.23c-3.2167-10.625-3.0583-21.893,12.879-21.088-4.025-4.9904-18.833-7.5658-21.25,11.108-17.546-12.878-36.704-15.132-40.242-4.0242,9.0125-7.7271,23.017-2.0929,39.758,16.903,1.45-0.805,5.3125-2.4146,8.8542-2.8975z'/%3E %3Cpath d='m534.87,136.88c-9.9792-6.4388-23.504-16.903,0.1625-21.088-10.142-5.4733-24.954-3.0588-23.342,15.615-27.046-10.947-46.467-7.2521-50.55,3.5413-4.5083,11.913,12.238,18.513,15.133,10.947-3.0583,1.2879-13.521-2.2538-8.05-9.015,5.475-6.7608,33.525-1.6854,60.208,12.235,7.4042,3.8633,32.838,3.2196,6.4375-12.235z'/%3E %3Cpath d='m527.78,154.59c-7.7-15.722-32.679-1.4488-37.713-16.678-6.8792,22.312,35.521,9.9658,37.713,16.678z'/%3E %3Cpath d='m686.67,171.65c5.2375,2.6025,9.7667-1.4888,1.7542-4.6979,5.2417,2.6012,9.8125-1.3925,1.8-4.6029,5.2417,2.6012,9.8125-1.3921,1.8-4.6025-2.1375,2.1517-5.1958,10.04-5.3542,13.903z'/%3E %3Cpath d='m689.4,141.39c11.592-12.234-0.9625-16.42,13.2-28.976,11.592-10.273,2.2125-17.12,13.204-25.113,3.5417-2.5754,11.267-7.7267,11.913-12.878,4.6667,11.59-14.492,13.2-13.204,31.874,0.82084,11.89-7.2167,10.851-10.3,30.908-0.64583,4.1854-3.5417,13.522-14.813,4.1854z'/%3E %3Cpath d='m694.56,146.86c6.4375-13.844,13.829-13.578,17.383-18.995,6.7625-10.303,21.088,1.7708,33.163-7.405-2.0917,13.039-18.35,8.3708-25.433,16.742-7.0833,8.3708-12.879,12.235-25.113,9.6588z'/%3E %3Cpath d='m696.17,151.37c11.271-9.015,19.575-3.0008,27.367-7.7271,19.638-11.913,27.529,2.4146,45.075-3.2196-4.6708,11.268-30.588,1.61-41.854,9.9808-11.271,8.3708-50.871,16.42-30.588,0.96583z'/%3E %3Cpath d='m663.33,215.6c-0.1625-5.1513-4.9917-11.752-11.754-12.556-6.7583-0.805-9.6583-7.8883-14.808-8.21-5.15-0.32209-8.5333-10.625-15.617-10.464-7.0833,0.16125-9.9792,9.3367,6.6,17.708,16.583,8.3713,34.933,18.03,35.579,13.523z'/%3E %3Cpath d='m642.4,219.95c-7.0833,0.32209-8.05,10.625-14.808,10.947,9.3334,4.9904,16.096-2.2538,20.925-8.6929l-6.1167-2.2538z'/%3E %3Cpath d='m648.2,221.23c-6.1167,5.1513-7.8875,15.937,0.96667,18.995-5.3125-7.3246,9.3375-10.625,4.8292-17.386l-5.7958-1.6096z'/%3E %3Cpath d='m654.31,221.56c-4.8292,9.3367,7.5667,10.463,4.3458,17.547,7.0833-1.61,8.2125-14.971,1.7708-18.513l-6.1167,0.96625z'/%3E %3Cpath d='m606.98,201.59c11.592-0.64375,22.192,5.6267,29.3,15.776,4.5083,6.4388,19.638,9.0146,24.792,3.8633,5.15-5.1512,2.2542-16.098-10.625-12.556-3.2208-5.4733-12.558-3.5417-17.063-8.0492-4.5083-4.5071-21.896-17.385-26.404,0.96584z'/%3E %3Cpath stroke-linecap='round' d='m650.45,208.68c-3.0583,0.64375-4.025,5.9562-2.0958,8.6929'/%3E %3Cpath stroke-linecap='round' d='m657.05,211.9c0.96667,1.6096,0.32083,3.8633-0.1625,4.9904'/%3E %3Cpath stroke-linecap='round' d='m625.34,202.08c5.9542,0.32209,7.0833,4.6688,13.521,6.2783'/%3E %3Cpath d='m621.4,187.43c20.571,5.1512,36.892,9.6588,47.013,15.454,10.121,5.7954,25.792,7.405,39.504,3.5417,13.713-3.8633,40.154-7.405,38.85,9.6588,7.1875-8.5321-1.9583-17.708-20.242-19.318,0.32916-8.3708-8.6292-15.937-15.071-10.947,5.9583-0.80459,11.1,10.303-0.65,14.81,2.2833-8.3708-6.0417-15.937-14.692-12.234,5.55,1.6096,11.163,10.917-1.2542,14.488-7.8375,2.2538-19.263-0.64375-27.75-5.795-8.4875-5.1517-56.154-23.825-45.708-9.6588z'/%3E %3Cpath d='m673.31,179.06c-6.4375,2.8975-2.2542,9.6588-12.233,13.522-9.9833,3.8633-16.904,12.717-14.65,20.283,6.7625-14.81,18.675-14.166,22.858-19.961,4.1875-5.7954,10.304-14.327,4.025-13.844z'/%3E %3Cpath d='m675.08,180.02c-0.32083,11.751-9.5708,7.4704-5.9583,23.986,1.1292,5.1512,3.2208,13.522-0.32083,21.893,10.383-7.5658,3.7042-23.46,8.3708-29.459,2.2542-2.8975,5.15-7.405,6.2792-11.268-2.4167,6.7608-2.2542,19.318,4.3458,22.537-5.3125-12.557,14.329-22.859,0.80417-37.347-1.9292,3.5417-8.05,9.8196-13.521,9.6588z'/%3E %3Cpath d='m642.24,168.27c1.6125,2.4146,3.2208,8.5321,1.7708,11.913,3.2208-1.9317,7.8917-6.9221,9.3375-10.303,6.6,0.96584,9.175,9.1758,2.9,12.717,3.8625,0,10.463,0,14.163-4.3462-4.5042-4.9904-18.508-12.718-28.171-9.9808z'/%3E %3Cpath d='m542.11,145.18c-1.0417-0.94916-2.8-1.8517-5.9542-2.4996-9.7458-1.9988-4.7125-10.784,3.5833-10.706,17.704-19.317,27.646-4.4262,49.217-10.543,7.55-2.1404,12.733-1.5079,16.846,0.27167,9.6583-6.4392,20.988-4.64,29.2,2.9262,0.9125-1.4517,2.1375-2.5592,3.8583-3.0371,7.5625-2.1004,13.679,4.3479,15.771,12.719,5.8958-1.0921,12.629,1.8262,17.058,5.8504,6.1333-3.15,10.358-3.29,11.913-0.0512,5.475-2.5758,12.567-4.1908,16.108,4.5021,3.5417,8.6929-8.3708,6.1171-10.304,24.469-1.1917,11.321-13.842,15.776-23.825,9.015-15.967-10.817-31.55-12.557-39.279,3.8633-7.725,16.42-13.779,25.96-32.517,20.605-6.7583-1.9321-15.454,0.64375-20.925,8.0488-5.475,7.405-13.846,0.48291-23.825,1.2879,12.554-1.9317,7.7458-5.0896,18.675-5.7954,9.9792-0.64375,7.4042-9.9804,13.842-11.268-25.113,6.4392-24.146-2.8979-44.75,3.5412,9.0125-11.59,23.179-5.1513,30.263-11.912-18.675-0.32208-27.025-12.522-35.417-7.405-13.2,8.0488-7.4083,30.965-41.854,28.976-16.742-0.96583-27.367,1.2879-37.346,11.269,17.388-36.059,41.038-16.249,52.479-27.688,6.7625-6.7613,11.913-11.913,15.454-18.352,1.2458-2.2667,2.9333-3.5621,5.0417-4.0629-28.654-9.015-11.325-23.058,16.688-24.023z'/%3E %3Cpath stroke-linecap='round' d='m683.59,140.11c0.4375,0.90542,0.6625,2.08,0.6625,3.5325,0,7.0829-10.625,7.405-11.267,17.869-0.3375,5.4733-0.96666,8.5317-4.6708,7.8879-3.7-0.64417-6.9208-6.4392-3.3792-13.2'/%3E %3Cpath d='m547.42,134.63c-2.6667-1.8738-5.3333-2.635-7.725-2.6571'/%3E %3Cpath d='m605.74,121.65c8.525,3.6908,12.683,12.546,25.067,12.98,11.921,0.41833,19.321,17.708,39.279,6.4388,0.54167-0.305,1.0708-0.58959,1.5833-0.85375'/%3E %3Cpath d='m635,124.63c-1.7792,2.8292-2.1833,6.7783-1.6958,10.244'/%3E %3Cpath d='m596.04,161.03c-15.129,0-18.996,7.7267-18.996,15.132,0,7.405,7.0833,17.064,19.642,17.064,12.554,0,19.317-7.7267,19.317-16.098s-7.7292-16.098-19.963-16.098z'/%3E %3Cpath d='m598.77,192.9c-0.32084-4.1854-7.8875-3.5417-7.5667-6.7613,0.32084-3.2196,4.1875-4.5075,4.1875-9.0146,0-4.5075,6.7583-4.8296,9.0125-1.2879,2.2542,3.5412,9.0167,10.463,10.467,6.9221'/%3E %3Cpath d='m604.41,175.84c-3.5417,3.5412-5.15,10.785-0.48334,16.42'/%3E %3Cpath d='m609.24,181.31c-1.125,2.4146-1.4458,6.1171-0.15833,8.3708'/%3E %3Cpath fill='none' d='m669.36,169.48c11.833,0.96583,13.846-12.074,4.9917-12.878'/%3E %3Cpath fill='none' d='m654.8,134.31c-4.1042-5.2313-13.521-7.0021-13.683,4.1054'/%3E %3Cpath d='m639.99,151.05c-4.025-9.9808-14.329-11.43-19.804-6.4392-4.5542,4.1533-4.6667,14.971,5.1542,17.225,3.3792-4.0242,9.9792-9.3367,14.65-10.785z'/%3E %3Cpath d='m635.56,144.77c-5.7958-5.1517-14.329,4.5883-6.6,13.522'/%3E %3Cpath d='m525.31,169.16c3.8792-0.92083,9.55,0.9775,18.246,5.0675,5.475,2.5758,21.896,8.0492,32.196,2.5758-10.625,3.8633-18.671-12.235-26.721-10.303-8.05,1.9317-22.779,4.9096-28.975-0.96625,15.129,0.96625,23.267-11.021,40.563-0.64375,4.8333,2.8975,10.95,4.8296,16.421,4.5075-14.163-17.064-32.838-6.1175-34.771-19.961,8.5333,9.1758,29.379-2.0929,40.004,15.132'/%3E %3Cpath d='m545.33,152.01c-1.9917-2.4792-1.0917-4.9504-3.2292-6.9054'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='m654.8,134.31c-3.5417-3.7829-11.267-0.805-9.0958,6.8421,1.6917-3.5413,5.3125-6.52,9.0958-6.8421z'/%3E %3Cpath fill='%23000' stroke='none' d='m632.91,154.93c2.4375-1.7696,4.9542-3.2233,7.075-3.8817-1.1583-2.8642-2.8292-5.0262-4.7583-6.5346-1.8417-1.2721-7.1333,5.8442-2.3167,10.416z'/%3E %3Cg fill='none' stroke-linecap='round'%3E %3Cpath d='m623.4,141.87c-5.7958-3.8633-11.108-3.5413-12.879-0.32167-4.1833-0.16125-7.6458,2.8975-7.8083,9.0146'/%3E %3Cpath d='m611.65,153.14c-6.9208-4.7483-16.421-2.9775-15.775,7.6471'/%3E %3Cpath d='m591.69,166.82c3.3792-2.7367,8.2083-4.6683,11.913,0.16125'/%3E %3Cpath d='m643.37,156.36c-1.2875,1.7704-2.2542,4.5071-0.1625,8.6929-2.575-3.3808-9.0125-3.3808-15.938,5.6338'/%3E %3Cpath d='m658.66,155.88c-8.3708,0.96583-8.2083,6.4388-1.45,8.8538'/%3E %3Cpath d='m599.1,135.43c-7.0833-1.4488-12.233,2.7367-2.4125,6.2783'/%3E %3Cpath d='m612.62,130.6c-9.9834-2.4146-14.008,0.16084-9.5,2.4146'/%3E %3Cpath d='m583.8,170.69c-0.32083,3.5417,1.6083,8.21,7.4042,2.8979'/%3E %3Cpath d='m585.74,181.31c0,0.96583-0.1625,2.0925-0.80833,2.8975'/%3E %3Cpath d='m562.55,134.14c-6.1167-1.7708-7.2417-7.405-0.15834-6.9221'/%3E %3Cpath d='m560.46,147.18c-6.7625-2.2538-6.7625-8.8538-1.1292-8.21'/%3E %3Cpath d='m573.02,143.8c-7.8875-1.9321-8.2083-7.4054-2.25-6.6004'/%3E %3Cpath d='m573.98,127.06c-4.1833-0.32166-10.625,4.3467,0.1625,7.0833'/%3E %3Cpath d='m585.74,136.4c-9.8208-1.4488-9.6583,2.5758-3.8667,5.1517'/%3E %3Cpath d='m593.14,127.06c-7.5667-1.4488-10.142,3.0588-4.9917,4.9904'/%3E %3Cpath d='m569.32,154.91c-1.8542-1.5288-3.3792-8.8542,5.4708-6.68'/%3E %3Cpath d='m587.67,152.66c-5.9542-1.61-11.588,4.1854-6.1167,7.5658'/%3E %3Cpath d='m595.55,145.74c-6.275-1.1271-11.588,0.64375-8.2083,2.8975'/%3E %3C/g%3E %3Cpath fill='%23fff' d='m654.46,134.31c-3.5375,0.65541-6.7083,2.7342-8.7625,6.8396'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='300'%3E %3Crect width='600' height='300' fill='%2300abc9'/%3E %3Crect width='600' height='100' y='100' fill='%23fae042'/%3E %3Cpath d='M0,0V300L259.8076,150z' fill='%23000'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' height='504' width='720' version='1.0' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-2100 -1470 4200 2940'%3E %3Cdefs%3E %3Cpath id='D' fill-rule='evenodd' d='m-31.5 0h33a30 30 0 0 0 30 -30v-10a30 30 0 0 0 -30 -30h-33zm13-13h19a19 19 0 0 0 19 -19v-6a19 19 0 0 0 -19 -19h-19z'/%3E %3Cpath id='E' transform='translate(-31.5)' d='m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z'/%3E %3Cpath id='e' d='m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z'/%3E %3Cg id='G'%3E %3CclipPath id='gcut'%3E %3Cpath d='m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z'/%3E %3C/clipPath%3E %3Cuse xlink:href='%23O' clip-path='url(%23gcut)'/%3E %3Crect y='-35' x='5' height='10' width='26.5'/%3E %3Crect y='-35' x='21.5' height='35' width='10'/%3E %3C/g%3E %3Cpath id='M' d='m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z'/%3E %3Cpath id='O' fill-rule='evenodd' d='m0 0a31.5 35 0 0 0 0 -70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0 -44 18.5 22 0 0 0 0 44'/%3E %3Cpath id='P' fill-rule='evenodd' d='m-31.5 0h13v-26h28a22 22 0 0 0 0 -44h-40zm13-39h27a9 9 0 0 0 0 -18h-27z'/%3E %3Cg id='R'%3E %3Cuse xlink:href='%23P'/%3E %3Cpath d='m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32'/%3E %3C/g%3E %3Cpath id='S' d='m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z'/%3E %3Cg id='star' fill='%23fff'%3E %3Cg id='c'%3E %3Cpath id='t' transform='rotate(18 0,-1)' d='m0-1v1h0.5'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(-72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3C/g%3E %3Cuse id='star1' xlink:href='%23star' transform='scale(31.5)'/%3E %3Cuse id='star2' xlink:href='%23star' transform='scale(26.25)'/%3E %3Cuse id='star3' xlink:href='%23star' transform='scale(21)'/%3E %3Cuse id='star4' xlink:href='%23star' transform='scale(15)'/%3E %3Cuse id='star5' xlink:href='%23star' transform='scale(10.5)'/%3E %3C/defs%3E %3Crect y='-50%25' x='-50%25' height='100%25' fill='%23009b3a' width='100%25'/%3E %3Cpath d='m-1743 0 1743 1113 1743-1113-1743-1113z' fill='%23fedf00'/%3E %3Ccircle r='735' fill='%23002776'/%3E %3CclipPath id='band'%3E %3Ccircle r='735'/%3E %3C/clipPath%3E %3Cpath fill='%23fff' d='m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0 -3360 0z' clip-path='url(%23band)'/%3E %3Cg transform='translate(-420,1470)' fill='%23009b3a'%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(-7)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(-4)'/%3E %3Cuse y='-1697.5' xlink:href='%23D' transform='rotate(-1)'/%3E %3Cuse y='-1697.5' xlink:href='%23E' transform='rotate(2)'/%3E %3Cuse y='-1697.5' xlink:href='%23M' transform='rotate(5)'/%3E %3Cuse y='-1697.5' xlink:href='%23e' transform='rotate(9.75)'/%3E %3Cuse y='-1697.5' xlink:href='%23P' transform='rotate(14.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(17.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(20.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23G' transform='rotate(23.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23R' transform='rotate(26.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23E' transform='rotate(29.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23S' transform='rotate(32.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23S' transform='rotate(35.5)'/%3E %3Cuse y='-1697.5' xlink:href='%23O' transform='rotate(38.5)'/%3E %3C/g%3E %3Cuse id='αCMi' y='-132' x='-600' xlink:href='%23star1'/%3E %3Cuse id='αCMa' y='177' x='-535' xlink:href='%23star1'/%3E %3Cuse id='βCMa' y='243' x='-625' xlink:href='%23star2'/%3E %3Cuse id='γCMa' y='132' x='-463' xlink:href='%23star4'/%3E %3Cuse id='δCMa' y='250' x='-382' xlink:href='%23star2'/%3E %3Cuse id='εCMa' y='323' x='-404' xlink:href='%23star3'/%3E %3Cuse id='αVir' y='-228' x='228' xlink:href='%23star1'/%3E %3Cuse id='αSco' y='258' x='515' xlink:href='%23star1'/%3E %3Cuse id='βSco' y='265' x='617' xlink:href='%23star3'/%3E %3Cuse id='εSco' y='323' x='545' xlink:href='%23star2'/%3E %3Cuse id='θSco' y='477' x='368' xlink:href='%23star2'/%3E %3Cuse id='ιSco' y='551' x='367' xlink:href='%23star3'/%3E %3Cuse id='κSco' y='419' x='441' xlink:href='%23star3'/%3E %3Cuse id='λSco' y='382' x='500' xlink:href='%23star2'/%3E %3Cuse id='μSco' y='405' x='365' xlink:href='%23star3'/%3E %3Cuse id='αHya' y='30' x='-280' xlink:href='%23star2'/%3E %3Cuse id='γHya' y='-37' x='200' xlink:href='%23star3'/%3E %3Cuse id='αCru' y='330' xlink:href='%23star1'/%3E %3Cuse id='βCru' y='184' x='85' xlink:href='%23star2'/%3E %3Cuse id='γCru' y='118' xlink:href='%23star2'/%3E %3Cuse id='δCru' y='184' x='-74' xlink:href='%23star3'/%3E %3Cuse id='εCru' y='235' x='-37' xlink:href='%23star4'/%3E %3Cuse id='αTrA' y='495' x='220' xlink:href='%23star2'/%3E %3Cuse id='βTrA' y='430' x='283' xlink:href='%23star3'/%3E %3Cuse id='γTrA' y='412' x='162' xlink:href='%23star3'/%3E %3Cuse id='αCar' y='390' x='-295' xlink:href='%23star1'/%3E %3Cuse id='σOct' y='575' xlink:href='%23star5'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 9 6'%3E %3Crect fill='%2321468B' width='9' height='6'/%3E %3Crect fill='%23FFF' width='9' height='4'/%3E %3Crect fill='%23AE1C28' width='9' height='2'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Inkscape (http://www.inkscape.org/) --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' version='1.1' width='1100' height='750' id='svg2'%3E %3Cmetadata id='metadata14'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3E%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cdefs id='defs12' /%3E %3Crect width='1100' height='750' x='0' y='0' id='rect4' style='fill:%23007934' /%3E %3Crect width='1100' height='500' x='0' y='0' id='rect6' style='fill:%23ffe000;fill-opacity:1' /%3E %3Crect width='1100' height='250' x='0' y='0' id='rect8' style='fill:%23d52b1e' /%3E %3Cg transform='matrix(0.12820513,0,0,0.12820513,425,266.66667)' id='g8695'%3E %3Cg transform='translate(0,-33.645288)' id='g14699' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-1,0,0,1,1952.1115,3.7236016)' id='g46545' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(7.3943106,0.8910471,-1.0392097,6.3400848,-2382.5346,-1030.2797)' id='g46547' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path46549' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path46551' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.3943106,-0.8910471,1.0392097,6.3400848,-2997.8599,-169.04813)' id='g46553' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path46555' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path46557' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.4669838,0,0,6.4023999,-2701.2711,-602.41592)' id='g46559' style='stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path46561' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path46563' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(-2.1114528,3.7236016)' id='g38441' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(7.3943106,0.8910471,-1.0392097,6.3400848,-2382.5346,-1030.2797)' id='g3476' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path1717' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path3474' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.3943106,-0.8910471,1.0392097,6.3400848,-2997.8599,-169.04813)' id='g1737' style='stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path1739' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path1741' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694398;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.4669838,0,0,6.4023999,-2701.2711,-602.41592)' id='g1731' style='stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 400.69184,187.88473 c 1.07937,0.91624 183.54488,161.53565 184.34577,162.23498 0.4728,-0.55475 1.38813,-1.62556 1.83785,-2.12746 -0.75249,-0.67778 -183.28281,-161.1998 -184.35626,-162.17822 0.32588,-0.60196 -2.49708,2.70057 -1.82736,2.0707 z' id='path1733' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 389.18442,177.62366 c 0.76215,1.21298 2.95253,4.29715 2.62562,6.84311 1.14446,-1.14382 1.68363,-1.96415 2.76181,-3.19342 -0.58737,1.80722 -0.20304,2.75555 0.66941,3.25649 0.62562,0.72013 2.36081,0.28737 3.45,-0.11987 -1.01293,0.95979 -2.14383,1.96385 -3.67977,2.35995 -1.53592,0.39613 -2.09319,0.37248 -3.02815,0.61432 1.02993,0.45993 3.65628,1.08073 5.43863,1.15179 0.89119,0.0356 2.60015,-0.0214 3.26987,-0.6513 1.07937,0.91624 2.90081,-1.09228 1.82736,-2.0707 0.32588,-0.60196 0.24961,-1.48626 0.18886,-2.66034 -0.0687,-1.32579 -0.63177,-3.55402 -1.8703,-5.54373 0.005,1.08147 -0.12467,2.24219 -0.33341,3.3083 -0.20528,1.0485 -0.81841,1.96456 -1.41343,2.9478 0.29004,-0.97668 0.34785,-2.40164 -0.62244,-3.2874 -0.97028,-0.8857 -2.17519,-0.71799 -3.2338,-0.0373 0.87895,-1.05131 1.56894,-1.70293 2.64002,-2.90747 -1.26087,0.16373 -5.53807,-1.07627 -6.99674,-1.81681 -1.45857,-0.74053 -6.22284,-4.04126 -8.921,-6.06024 2.32119,2.35588 6.48157,6.67956 7.22746,7.86678 z' id='path1735' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.21694382;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-6.2056208,-2.3690086,-2.7629299,5.3208753,4182.7969,613.03001)' id='g2373' style='stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path2375' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path2377' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path2379' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path2381' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path2383' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path2390' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path2392' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path2394' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path2396' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path2398' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path2400' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path2402' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path2404' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path2406' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path2408' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path2410' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path2412' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path2414' style='fill:none;stroke:%23000000;stroke-width:0.23847184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-6.2529099,-2.2757944,-2.6542057,5.3614204,4097.7489,593.25426)' id='g3429' style='stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path3431' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3433' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3435' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path3437' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3439' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3442' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3446' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3448' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path3450' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path3452' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path3454' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3456' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3458' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path3460' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path3462' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path3464' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path3466' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3468' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3470' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(6.2683131,-2.3929649,2.7908411,5.3746176,-2258.4183,602.88362)' id='g3472' style='stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path3475' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3477' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3479' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path3481' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3483' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3489' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3491' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path3493' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path3495' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path3497' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3499' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3501' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path3503' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path3505' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path3507' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path3509' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3511' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3513' style='fill:none;stroke:%23000000;stroke-width:0.23608682;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(6.2529099,-2.2757944,2.6542057,5.3614204,-2145.7489,593.25426)' id='g3515' style='stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 408.42144,331.29731 c -4.14882,-7.95881 -21.27065,-18.78136 -24.22199,-19.08939 7.86928,17.3567 20.83844,23.63768 24.22199,19.08939 z' id='path3517' style='fill:%2300e519;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3519' style='fill:%23ffe533;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.34347,331.29827 c -3.38355,4.5483 -16.27474,-1.73365 -24.14402,-19.01142 11.72162,11.09786 22.20245,19.16833 24.14402,19.01142 z' id='path3521' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 408.42144,331.2203 c -4.42028,-8.46513 -22.35743,-18.93634 -24.26146,-19.12886 7.90971,17.31821 20.87791,23.67716 24.26146,19.12886 z' id='path3523' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3525' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 384.55849,175.70207 -2.78962,118.60046 c 1.23984,2.7954 4.07759,1.04539 4.5435,1.5883 1.04441,4.38851 4.18924,6.5996 4.57621,7.68735 0.84997,5.90364 -2.41614,8.9368 -2.72706,9.17072 -3.69351,2.44982 -0.43509,7.88565 -1.0964,8.85692 0.0761,2.33046 3.76571,3.45382 3.45189,6.0952 0.27242,-0.19348 0.0212,19.07495 -0.0192,21.133 0.61991,1.3977 0.76335,14.37264 0.76335,14.37264 3.49424,1.47278 21.21289,-2.50567 21.40638,-2.23518 -1.26679,-17.28451 -9.66936,-46.68338 -8.69617,-47.88759 -0.61028,-12.19812 -3.86003,-26.56786 -7.35429,-28.04065 -3.56933,-5.2019 -2.51239,-14.02128 -0.76238,-15.38241 -3.72816,-1.7837 -4.61857,-5.31741 -4.81302,-5.58887 l 1.16668,-85.5408 c -2.13409,-2.1341 -2.291,-0.73543 -3.88507,0.62569 0,0 -0.61799,-3.03027 -0.38504,-3.26322 -1.08678,-1.47567 -3.02931,-0.92891 -3.37971,-0.19156 z' id='path3527' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43509,-33.87402 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3531' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.65977,153.16367 c -0.0809,2.33142 -1.32262,1.78851 -1.86649,1.86649 l -2.02051,-0.23006 c -2.01858,-0.85383 -3.61265,-0.11455 -3.96303,0.62473 l -3.04087,138.8777 c 1.23984,2.7954 4.27204,1.31684 4.77548,1.89922 l 1.95312,-94.94255 c 0,0 -0.43413,-33.87306 -0.34846,-43.19588 l 5.43871,-0.23872 c 1.55268,0.23199 2.44694,-0.66227 2.56631,-2.5663 l -2.20726,-50.49722 -1.2485,47.50929 -0.0385,0.8933' id='path3533' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.59206,303.91605 c 4.93046,1.89826 5.78044,7.25899 0.41681,10.83796' id='path3535' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 403.74127,309.27679 c 1.24176,1.8636 3.10727,0.61799 3.10727,0.61799' id='path3537' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.97454,273.78078 c -2.22458,11.85061 -0.75661,21.01749 -0.798,23.61941 1.66531,5.78717 0.33403,16.66556 -0.94912,18.10272 l 1.95216,31.34815' id='path3539' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3541' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 381.80737,294.80693 c 2.56341,0.076 13.21174,-4.51749 19.65541,-0.0183 2.12831,9.67128 2.04265,18.5282 2.54609,19.96537 -9.36517,3.3874 -15.07631,4.59739 -17.09777,4.83226 -0.69789,-1.24272 -0.30707,-3.65115 -0.30707,-3.65115 -0.58045,-2.36897 1.78948,-3.18718 1.78948,-3.18718 1.90884,-4.77933 0.43703,-9.36228 -2.43635,-10.91304 -3.57222,-2.01665 -2.368,-1.9021 -2.83391,-2.13313 -1.20229,-1.90307 -1.31588,-4.89484 -1.31588,-4.89484 z' id='path3543' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172 l -5.54653,-8.50172' id='path3545' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 388.87481,298.14139 c 3.33831,1.39578 5.89884,4.73408 5.54653,8.50172' id='path3547' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 399.73972,310.56186 c -0.66131,0.66131 -1.70958,0.70078 -2.36993,0.0404 -0.65938,-0.65939 -0.65842,-1.74617 0.003,-2.40748 0.66034,-0.66034 1.70862,-0.6228 2.368,0.0366 0.66035,0.66035 0.65938,1.67012 -9.6e-4,2.33046 z' id='path3549' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 398.5432,302.21128 c -0.66131,0.66131 -1.74905,0.66131 -2.40844,0.002 -0.65937,-0.65938 -0.62087,-1.70862 0.0404,-2.36992 0.66034,-0.66035 1.67108,-0.66035 2.33046,-9.7e-4 0.65938,0.65938 0.69788,1.70862 0.0375,2.36897 z' id='path3551' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3553' style='fill:%23cce5e5;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.18679,188.71743 c -1.08678,-1.08678 -0.89137,-3.06878 0.46975,-4.4299 l 9.12933,0.18674 c 0,0 0.81532,0.58238 1.04732,2.13506 0.19252,1.59215 -1.28412,2.1389 -1.28412,2.1389 l -9.36228,-0.0308' id='path3555' style='fill:none;stroke:%23000000;stroke-width:0.23847134;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(7.4370353,-0.29145011,0.55781232,6.406304,670.55047,-1365.9813)' id='g2502' style='stroke:%23000000;stroke-width:0.21694411;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 5.3346094,370.91334 c 0.934977,-1.0632 62.7144166,-68.44801 63.4276096,-69.23663 -0.546422,-0.4824 -1.601054,-1.41623 -2.095078,-1.8747 -0.690782,0.74059 -62.6239996,68.19189 -63.6209946,69.24813 -0.596172,-0.33632 2.906607,2.54389 2.288463,1.8632 z' id='path2500' style='fill:%23a05a2c;fill-opacity:1;stroke:%23000000;stroke-width:0.21694411;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(-0.404828,0.449606,-0.449606,-0.404828,194.9452,306.1962)' id='g2595' style='stroke:%23000000;stroke-width:0.35858223;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(1.450749,1.37671,-1.37671,1.450749,164.9287,-295.1823)' id='g3437' style='fill:%23dedede;fill-opacity:1;stroke:%23000000;stroke-width:0.17929105;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 146.6203,176.74359 c 1.44,1.8 4.0855,4.04754 6.2455,3.68754 0.18,3.42 -4.41,6.39 -6.03,5.67 0.99,-3.6 -3.34794,-6.5027 -3.25794,-6.5027 l 3.04244,-2.85484 z' id='path2399' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.17929105;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 125.90205,161.75608 c 0.23156,-3.51836 -0.3402,-4.51172 -0.86505,-8.85652 -0.51501,-4.26342 -8.333,-4.63039 -11.23886,-5.35429 0,0 6.85308,-8.47833 15.9642,-8.47698 9.11112,0.001 14.56445,4.29025 16.30124,9.6682 0,0 -10.75755,-0.53203 -11.66566,3.82072 -0.87997,4.21793 -0.45366,5.16579 -0.36474,8.6243' id='path720' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.35858223;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Crect width='12.37437' height='6.3639612' x='123.74368' y='158.97264' id='rect2593' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:0.35858223;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='translate(-2.1114528,3.7236016)' id='g38827' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg id='g46228' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 832.93795,1488.201 -11.24,110.162 c 0,0 17.0485,-20.8667 21.1467,-27.8 4.0981,-6.9332 18.8753,-25.4762 22.0361,-89.6894 0,0 -11.53978,-35.5079 -16.97298,-35.431 -9.0396,-4.4557 -14.96982,42.7584 -14.96982,42.7584 z m 27.0937,-245.5984 c 0,0 -29.5764,176.8817 -32.574,192.9662 0,5.5012 15.0112,20.0886 25.8539,-14.1163 l 17.8677,-128.5896 c 0,0 -8.0328,-34.2624 -11.1476,-50.2603 z' id='path2603' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.89285,1418.1194 c -7.2129,-9.0648 -16.2292,-20.3957 -17.1191,-24.9668 l -4.66,39.0254 c 0,0 24.6127,17.9855 21.1005,52.4112 l 4.7774,-6.9427 2.7632,-13.7895 c 0,0 5.0582,-22.9889 5.105,-36.7399 0,0 -5.199,-2.2182 -11.967,-8.9977 l 0,0 z' id='path2605' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 821.69965,1598.345 c 0,0 40.8651,-34.9544 43.1829,-117.4894 l 5.0584,-22.989 c 0,0 0.843,18.322 9.0395,4.4556 7.9856,-18.4468 7.5875,-34.4834 7.5875,-34.4834 0,0 14.777,-18.5426 19.2266,4.3114 0,0 -13.7222,107.9056 -14.6592,117.0859 -1.1708,11.4751 -3.2551,25.2548 -3.2551,25.2548 0,0 -8.1029,-13.6355 -16.2992,0.2309 -8.8755,13.8759 -22.9735,32.4092 -49.8814,23.6232 l 0,0 z m 49.4814,-305.5003 -17.8674,128.5896 c 0,0 14.2384,6.6738 16.6273,36.4323 1.3115,13.732 6.7681,6.7795 9.0395,4.4556 2.9742,-9.2091 0.7727,-27.5115 0.7727,-27.5115 l 7.7745,-89.4877 c 0,0 -15.4801,-41.0319 -16.3466,-52.4783 z' id='path2607' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 857.03095,1590.9877 -2.599,32.1211 c 0,0 12.2244,-0.173 20.4208,-14.0394 9.5546,-13.8854 13.0204,-34.5601 13.0204,-34.5601 0,0 -9.461,-13.6166 -16.2994,0.2307 -6.6036,11.5519 -14.5428,16.2477 -14.5428,16.2477 z m 21.9423,-128.6473 c 6.604,-11.552 8.7116,-32.2075 7.5875,-34.4833 l -8.30828,6.9717 c 2.6698,13.7125 0.72078,27.5116 0.72078,27.5116 z' id='path2609' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 919.21895,1449.3875 c -5.6205,-11.3792 -15.1052,-18.1203 -15.1052,-18.1203 l -18.1483,144.6357 c 0,0 -5.1049,36.7401 -27.7741,46.2277 0,0 12.9278,125.8624 53.7931,90.908 5.9014,-4.6669 13.278,-43.7307 10.8656,-66.614 -2.8571,-25.1685 -9.5318,-59.4499 -10.1639,-73.1915 -0.3984,-16.0364 1.86839,-32.2787 5.80269,-57.5436 1.6157,-9.1897 6.37226,-29.3331 7.28556,-31.6376 2.2715,-2.3241 -0.48985,-21 -6.55545,-34.6644 z' id='path2611' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 938.86685,1427.1532 c 0,0 11.0535,11.3021 13.0909,11.2734 2.7165,-0.039 -28.68334,235.8639 -28.68334,235.8639 0,0 1.18164,-24.728 -7.98364,-72.7565 -7.44564,-39.0171 2.16252,-91.4007 10.55711,-116.5352 0,0 9.90457,-7.3836 13.01897,-57.8456 z' id='path2613' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 886.60875,1347.682 c 0,0 -6.112,66.5468 -7.5403,87.1924 0,0 20.7017,-30.0854 26.0414,-2.6602 l 4.6601,-39.0252 c 0,0 -18.009,-29.5375 -23.1612,-45.507 z' id='path2619' style='fill:%23f7e214;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 870.75092,1457.6637 c 0,0 -6.79596,-74.5342 -42.89881,-21.8408 -1.39974,0.019 -3.31572,29.6128 -1.24048,36.699 1.1346,9.4709 11.12548,21.1882 15.30079,28.2443 7.89114,11.7471 16.3378,-2.6038 16.3378,-2.6038 0,0 8.20512,-11.9759 12.5007,-40.4987 z' id='path2621' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(1,-0.04702074,0,1,-2.2402185,26.33245)' id='g46260' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 586.92745,838.90947 c -1.3302,-42.47871 -14.6773,-113.66915 -15.3412,-162.07779 L 425.25675,520.83687 c 0,0 -18.0611,119.96174 -71.1929,186.53571 l 232.8636,131.60989' id='path236' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 597.49388,844.43331 c 6.1621,-29.21459 13.5591,-62.06604 18.4676,-123.54139 l -94.2,-97.24502 c 0.3762,38.74522 -43.4931,96.60853 -46.4621,168.83923' id='path6858' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 678.72756,937.60442 c 10.8066,-51.25367 -15.68378,-58.91622 23.71972,-129.89659 l -87.04676,-87.55809 c -16.2197,48.31751 -27.1401,79.39667 -25.727,121.87536 l 74.1618,56.26539' id='path238' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46249' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 337.90285,1241.5978 c -17.6248,-52.3867 6.303,-155.1608 3.6429,-221.0135 -1.9939,-42.48061 29.2436,-202.21617 28.5773,-250.53379 l -172.034,-107.44557 c 0,0 -7.4912,174.58162 -27.291,364.74936 -17.8157,97.674 -17.6979,186.9273 -4.8973,261.4838 18.2887,105.9774 36.2532,149.485 79.064,194.3175 75.9792,78.6255 239.5863,33.1999 239.5863,33.1999 137.8261,-28.5197 217.2142,-115.3382 217.2142,-115.3382 0,0 -44.827,10.5911 -117.4598,17.9733 -159.1864,-11.1519 -221.8825,28.632 -226.8347,-134.7009' id='path1466' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 798.94255,1347.4263 2.6601,-1.1496 c -29.8384,11.1657 -71.4524,23.4993 -71.4524,23.4993 l -96.991,7.4644 c -210.3899,4.9187 -184.0526,-125.3492 -175.7093,-335.5212 1.9963,-79.75702 17.8065,-180.20483 13.7334,-215.76778 l -141.0351,-80.79199 c -46.0025,129.96648 -31.665,220.89093 -40.8713,287.38017 -4.8068,71.6185 -20.0806,211.4811 3.1445,272.5093 32.8707,141.978 144.0394,136.1933 294.5239,123.7084 74.6517,-6.1936 114.8199,-25.3861 114.8199,-25.3861 l 97.0942,-55.8717' id='path1468' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 801.68565,1344.58 c -29.1784,15.1082 -72.1124,26.2555 -72.1124,26.2555 l -98.3108,9.7098 c -152.5209,12.9399 -241.8084,-94.194 -222.2648,-336.4513 0.1293,-85.58426 2.8724,-123.59981 32.4009,-237.61027 l 83.8245,49.18311 0,7.89215 c -4.7369,25.58935 -16.7308,85.43176 -16.7308,112.80179 0,194.50942 122.9863,343.91002 290.5333,369.27752 l 2.6601,-1.1315' id='path1470' style='fill:%23007a3d;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 244.89215,759.75096 c 14.2136,23.88513 99.0882,153.17293 146.638,177.62185' id='path1474' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 259.18875,844.21546 c 14.2158,24.45064 118.126,170.06404 164.927,178.26054' id='path1476' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1066.7355 c 23.7751,28.5197 47.4673,85.0303 118.1261,121.6699' id='path1478' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1228.6032 c 47.4671,44.2666 164.927,141.5588 278.3158,145.5548' id='path1480' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1301.4444 c 23.7751,28.5198 75.3153,161.8858 292.6123,101.3612' id='path1482' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1325.8951 c 14.2155,32.005 122.8652,210.2765 316.3874,141.4861' id='path1484' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46238' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 462.20445,1177.5906 c -17.6248,-52.3867 6.3032,-155.1608 3.6429,-221.01339 -1.9939,-42.48042 18.0434,-189.41138 17.377,-237.72899 L 322.39065,598.59776 c 0,0 -7.4908,174.58176 -27.2907,364.74945 -17.816,97.67399 -31.39661,217.31349 -18.1964,291.80029 21.603,121.9025 80.21406,156.1875 90.7984,165.6172 82.16457,73.2014 267.63002,66.0029 286.0569,59.4174 132.53569,-47.3661 190.2705,-131.5745 190.2705,-131.5745 0,0 -62.7893,-1.0062 -135.422,6.3756 -159.1867,-11.1515 -239.5838,-4.5105 -244.5361,-167.8436' id='path2419' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 923.24415,1283.4194 2.6602,-1.1497 c -29.8384,11.1654 -71.4525,23.4993 -71.4525,23.4993 l -96.9909,7.4644 c -210.3899,4.9186 -184.0524,-125.3492 -175.7091,-335.52124 1.9961,-79.75689 4.7392,-151.39372 0.666,-186.95707 l -126.101,-91.99612 c -46.0026,129.96661 -33.5317,203.28436 -42.7381,269.77366 -4.8068,71.61847 -20.0805,211.48107 3.1446,272.50907 32.8706,141.9782 144.0391,136.1933 294.5239,123.7084 74.6518,-6.1933 114.8198,-25.386 114.8198,-25.386 l 97.0943,-55.8717' id='path2421' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.98335,1281.5197 c -29.1782,15.1085 -72.1119,26.2559 -72.1119,26.2559 l -98.3111,9.7097 c -152.5208,12.9399 -241.8086,-94.1942 -222.2649,-336.4512 0.1293,-85.58451 -2.7276,-91.5877 26.8005,-205.59846 46.7189,30.27386 136.015,106.50937 136.015,106.50937 0,0 -24.29385,34.1993 -18.598,82.01037 0,194.50922 78.2636,293.25532 245.8102,318.62282 l 18.3773,-158.8556' id='path2423' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 369.19375,695.74391 c 14.2136,23.885 99.0882,153.17294 146.6383,177.62199' id='path2427' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.49035,780.20842 c 14.2159,24.4509 118.1261,170.06414 164.9269,178.26064' id='path2429' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1002.7285 c 23.7748,28.5195 47.4669,85.0303 118.1258,121.6696' id='path2431' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1164.5962 c 47.4674,44.2669 164.9271,141.5586 278.3161,145.5546' id='path2433' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1237.4373 c 23.7753,28.5199 75.3154,161.8858 292.6126,101.3613' id='path2435' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1261.8881 c 14.2157,32.005 122.8651,210.2764 316.3872,141.4859' id='path2437' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.7729,94.37835 0.759,119.68548 -0.1671,2.73323 10.3499,67.00898 6.7286,70.44221 -12.3497,14.09212 -12.7856,15.65722 -25.7994,5.22755 -1.8677,-2.14492 5.6134,-67.96457 6.1668,-77.01703 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238' id='path1486' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.6899,94.38193 0.759,119.68548 -0.1671,2.73323 12.5488,92.19937 8.5925,70.52608 -12.3495,14.09186 -14.884,19.40952 -27.8978,8.97971 -1.8677,-2.14492 5.8479,-71.8006 6.4013,-80.85306 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238 l 0,0 0.0722,0.17861 z' id='path1488' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2972,116.81525 -1.8264,51.66406 -4.051,66.27651 -3.2284,96.39606 0.5409,2.06344 -5.0422,38.91192 -6.686,54.9318 -1.1718,8.25771 1.2024,2.11524 -0.1673,2.73335 -10.5508,6.45452 -17.7264,1.2646 -24.1576,-3.82635 -1.9086,-1.44519 17.0522,-46.09001 17.6056,-55.14273 10.0124,-131.10758 29.0249,-207.93792 29.0249,-207.93792 0,0 -7.587,46.51574 2.906,-3.96946' id='path1490' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2146,116.81909 -1.8259,51.66393 -4.0509,66.27638 -3.2281,96.39607 0.5409,2.06343 -5.0423,38.91191 -6.6861,54.93166 -1.1717,8.25745 1.2025,2.11524 -0.167,2.7335 -10.5511,6.45437 -17.7264,1.26458 -24.1578,-3.82637 -1.9085,-1.44518 17.052,-46.09027 17.6109,-55.23019 10.0124,-131.10744 28.942,-207.94175 28.942,-207.94175 0,0 -7.587,46.51547 2.9062,-3.96932 l 0,0 -0.005,0.0873 z m -6.0728,211.03022 c 0,0 -11.13,5.04722 -12.3699,2.18494 m -0.481,-15.28238 c 0,0 9.5053,-0.25255 11.0003,-2.92615 m -0.5504,-12.78579 c 0,0 -7.0222,4.57419 -8.9239,1.66023 m 8.7437,-20.50279 -6.7602,0.28819 m 7.2091,-18.51076 -7.4252,0.25852 m 6.2629,-26.18363 c 0,0 -4.1932,1.87264 -4.6914,-0.89053 m 6.0118,-20.7132 -6.061,-0.27255 m -5.7926,116.5627 c 0,0 -10.9158,1.54853 -12.1186,-1.9259 m 12.9911,-23.22806 c 0,0 -10.8756,0.89279 -11.3309,-2.57038 m 11.7723,-15.56487 c 0,0 -8.8395,0.28262 -9.4633,-0.42506 m 11.1993,-17.05976 -8.8005,-0.39525 m 8.7511,-20.59035 -6.0194,-0.95004 m 8.4543,-17.09539 c 0,0 -5.4801,1.13514 -6.6411,-1.65785 m 7.2602,-19.38553 c 0,0 -4.9403,3.22043 -4.7306,-0.21253 m -0.5982,109.18796 c 0,0 -10.8277,0.10507 -10.6244,-3.21844' id='path1492' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.7731,94.37861 0.7591,119.68547 -0.1672,2.73336 10.3498,67.00938 6.7283,70.44247 -12.3498,14.09186 -12.7854,15.6571 -25.7993,5.22757 -1.8679,-2.14493 5.6135,-67.96445 6.1667,-77.0173 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925' id='path2439' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.6902,94.38232 0.7591,119.68547 -0.1672,2.73336 12.5487,92.19951 8.5925,70.52621 -12.3498,14.092 -14.8843,19.40953 -27.8981,8.97999 -1.8673,-2.14506 5.8481,-71.80061 6.4013,-80.85346 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925 l 0,0 0.072,0.17874 z' id='path2441' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2976,116.81536 -1.8257,51.6638 -4.0507,66.27638 -3.2282,96.39608 0.5411,2.06357 -5.042,38.91178 -6.6861,54.93192 -1.1716,8.25745 1.2027,2.11498 -0.1669,2.73323 -10.551,6.45438 -17.7264,1.26446 -24.1579,-3.82622 -1.9083,-1.44519 17.0524,-46.09015 17.6058,-55.14288 10.0123,-131.10757 29.0246,-207.93791 29.0246,-207.93791 l 2.9063,-3.96958' id='path2443' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2147,116.81908 -1.8258,51.66392 -4.0508,66.27638 -3.2279,96.39606 0.5407,2.06357 -5.0425,38.91192 -6.6865,54.93194 -1.1715,8.25731 1.2029,2.1151 -0.1669,2.73322 -10.5509,6.45465 -17.7262,1.26459 -24.1578,-3.82636 -1.9081,-1.44505 17.0526,-46.09001 17.6109,-55.23031 10.0126,-131.10745 28.9421,-207.94149 28.9421,-207.94149 l 2.9063,-3.96947 0,0 -0.005,0.0873 z m -6.073,211.03034 c 0,0 -11.1296,5.04722 -12.3696,2.1848 m -0.4813,-15.28198 c 0,0 9.5052,-0.25281 11.0002,-2.92641 m -0.5502,-12.78567 c 0,0 -7.022,4.5738 -8.9238,1.65997 m 8.7434,-20.50264 -6.76,0.28805 m 7.209,-18.51076 -7.425,0.25838 m 6.2627,-26.18349 c 0,0 -4.1933,1.87251 -4.6911,-0.89053 m 6.0117,-20.7132 -6.0608,-0.27242 m -5.7928,116.5627 c 0,0 -10.916,1.5488 -12.1186,-1.92591 m 12.991,-23.22831 c 0,0 -10.8758,0.89292 -11.331,-2.57012 m 11.7727,-15.56487 c 0,0 -8.8396,0.28262 -9.4635,-0.4252 m 11.1991,-17.05948 -8.8002,-0.39551 m 8.7509,-20.59023 -6.0195,-0.95017 m 8.4546,-17.09539 c 0,0 -5.4801,1.13514 -6.6412,-1.65798 m 7.2604,-19.38526 c 0,0 -4.9407,3.22029 -4.731,-0.21254 m -0.598,109.18796 c 0,0 -10.8279,0.10521 -10.6247,-3.21871' id='path2445' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(7.4567489,0.3350755,-0.3907918,6.3936151,-2152.8789,-980.23756)' id='g2487' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.2597,9.7299 1.09155,15.27315 -0.17955,6.726 0,8.63835 -0.36765,12.54855 -0.0769,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.27035 -0.2679,-17.1 -2.1831,-27.19755 -2.1831,-27.19755 l -0.35625,-0.53295' id='path212' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.26825,9.7299 1.08015,15.27315 -0.1767,6.726 0,8.63835 -0.36765,12.54855 -0.077,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.28175 -0.2679,-17.1 -2.1717,-27.19755 -2.1717,-27.19755 l -0.35625,-0.53295 0,0 z' id='path214' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,244.61326 c 0,0 1.4478,0.26505 1.63875,-0.17955' id='path2469' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,241.33861 c 0,0 1.4478,0.17955 1.4478,-0.2679' id='path2467' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,238.97881 c 0,0 1.1685,0.0883 1.26825,0' id='path2465' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.46895,236.69596 1.1799,0' id='path2463' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.64565,233.96851 0.81225,-0.0884' id='path2461' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,231.60871 c 0,0 0.62415,0.17955 0.81225,-0.1767' id='path2459' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,228.86986 c 0,0 0.62415,0.44745 0.62415,0' id='path2457' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,243.06571 c 0,0 1.4478,0.077 1.4478,-0.35625' id='path2455' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 806.66725,651.2808 9.7153,0.72149 c 0,0 -15.0236,-1.09434 -9.7153,-0.72149 z' id='path3079' style='fill:%23005000;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 937.21825,1074.8468 c 0,0 -4.5288,-1.9413 -5.661,0 0,0.9709 1.1322,1.9416 2.2645,1.9416 1.1319,0 3.3965,-1.9416 3.3965,-1.9416 z' id='path4435' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 924.76395,1088.4376 c 0,0 19.2475,-1.9416 26.0405,-1.9416' id='path2941' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='translate(45.160387,-17.433837)' id='g37871' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-0.9773238,0.02796767,0.0271617,1.0063241,4636.2403,-91.417631)' id='g4081' style='stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-8.5612132,0,0,7.1058458,6939.2223,-1935.3371)' id='g4083' style='stroke:%23000000;stroke-width:0.19384736;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(2.698228,0.188676,-0.188676,2.698228,-83.95137,198.3774)' id='g4085' style='stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 156.89937,89.492537 c -0.0326,1.927576 -3.76381,4.277709 -6.81891,0.32337 -3.19349,-2.72162 -2.73384,-7.079109 -0.32947,-7.767359 L 177.5685,47.471874 c 1.14367,-0.795862 1.2235,-1.517334 1.77636,-2.271883 1.30518,1.486191 3.98739,4.142158 5.44264,5.419584 -0.80859,0.859605 -1.46049,1.669663 -1.61792,2.323361 l -26.27021,36.549601 z' id='path4087' style='fill:%23e8a30e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(4.31408,0.22609,-0.22609,4.31408,-96.979953,-495.72462)' id='g4089' style='stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 123.24464,190.48427 c 0.83741,-1.42667 4.36995,2.17219 3.48803,3.32673 -0.88193,1.15455 -4.25579,-1.888 -3.48803,-3.32673 z' id='path4091' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 126.41817,193.54356 c -0.62839,0.58457 -3.18339,-1.82708 -2.7996,-2.76435 0.65951,-0.88378 3.48273,2.18618 2.7996,2.76435 z' id='path4093' style='fill:%23cccccf;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cpath d='m 3513.1548,736.63692 c 56.5472,-19.2548 95.9439,-57.2317 120,-113.0372' id='path4097' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3934.4833,1159.2881 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path4101' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3964.4603,1190.9305 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path4103' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4138.4935,1357.4694 c 71.1276,-23.5221 127.3222,-76.133 147.3871,-150.7178' id='path4105' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4169.3032,1389.1118 c 71.1276,-23.5221 128.1549,-76.9657 148.2198,-151.5505' id='path4107' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4338.3403,1405.7658 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path4109' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path4111' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4375.2216,1406.928 c 0.3123,10.999 -9.0146,20.1579 -20.8509,20.4757 -11.8364,0.3178 -21.7168,-8.3254 -22.0886,-19.3228 -0.3718,-10.9974 8.9053,-20.1998 20.7398,-20.573 11.8345,-0.3731 21.7616,11.5546 22.1929,22.5501' id='path4113' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0' /%3E %3Cpath d='m 4336.2403,1403.8367 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path4127' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path4129' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-1,0,0,1,1952.1115,3.7236016)' id='g46565' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg id='g46567' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 832.93795,1488.201 -11.24,110.162 c 0,0 17.0485,-20.8667 21.1467,-27.8 4.0981,-6.9332 18.8753,-25.4762 22.0361,-89.6894 0,0 -11.53978,-35.5079 -16.97298,-35.431 -9.0396,-4.4557 -14.96982,42.7584 -14.96982,42.7584 z m 27.0937,-245.5984 c 0,0 -29.5764,176.8817 -32.574,192.9662 0,5.5012 15.0112,20.0886 25.8539,-14.1163 l 17.8677,-128.5896 c 0,0 -8.0328,-34.2624 -11.1476,-50.2603 z' id='path46569' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.89285,1418.1194 c -7.2129,-9.0648 -16.2292,-20.3957 -17.1191,-24.9668 l -4.66,39.0254 c 0,0 24.6127,17.9855 21.1005,52.4112 l 4.7774,-6.9427 2.7632,-13.7895 c 0,0 5.0582,-22.9889 5.105,-36.7399 0,0 -5.199,-2.2182 -11.967,-8.9977 l 0,0 z' id='path46571' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 821.69965,1598.345 c 0,0 40.8651,-34.9544 43.1829,-117.4894 l 5.0584,-22.989 c 0,0 0.843,18.322 9.0395,4.4556 7.9856,-18.4468 7.5875,-34.4834 7.5875,-34.4834 0,0 14.777,-18.5426 19.2266,4.3114 0,0 -13.7222,107.9056 -14.6592,117.0859 -1.1708,11.4751 -3.2551,25.2548 -3.2551,25.2548 0,0 -8.1029,-13.6355 -16.2992,0.2309 -8.8755,13.8759 -22.9735,32.4092 -49.8814,23.6232 l 0,0 z m 49.4814,-305.5003 -17.8674,128.5896 c 0,0 14.2384,6.6738 16.6273,36.4323 1.3115,13.732 6.7681,6.7795 9.0395,4.4556 2.9742,-9.2091 0.7727,-27.5115 0.7727,-27.5115 l 7.7745,-89.4877 c 0,0 -15.4801,-41.0319 -16.3466,-52.4783 z' id='path46573' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 857.03095,1590.9877 -2.599,32.1211 c 0,0 12.2244,-0.173 20.4208,-14.0394 9.5546,-13.8854 13.0204,-34.5601 13.0204,-34.5601 0,0 -9.461,-13.6166 -16.2994,0.2307 -6.6036,11.5519 -14.5428,16.2477 -14.5428,16.2477 z m 21.9423,-128.6473 c 6.604,-11.552 8.7116,-32.2075 7.5875,-34.4833 l -8.30828,6.9717 c 2.6698,13.7125 0.72078,27.5116 0.72078,27.5116 z' id='path46575' style='fill:%23ffe000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 919.21895,1449.3875 c -5.6205,-11.3792 -15.1052,-18.1203 -15.1052,-18.1203 l -18.1483,144.6357 c 0,0 -5.1049,36.7401 -27.7741,46.2277 0,0 12.9278,125.8624 53.7931,90.908 5.9014,-4.6669 13.278,-43.7307 10.8656,-66.614 -2.8571,-25.1685 -9.5318,-59.4499 -10.1639,-73.1915 -0.3984,-16.0364 1.86839,-32.2787 5.80269,-57.5436 1.6157,-9.1897 6.37226,-29.3331 7.28556,-31.6376 2.2715,-2.3241 -0.48985,-21 -6.55545,-34.6644 z' id='path46577' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 938.86685,1427.1532 c 0,0 11.0535,11.3021 13.0909,11.2734 2.7165,-0.039 -28.68334,235.8639 -28.68334,235.8639 0,0 1.18164,-24.728 -7.98364,-72.7565 -7.44564,-39.0171 2.16252,-91.4007 10.55711,-116.5352 0,0 9.90457,-7.3836 13.01897,-57.8456 z' id='path46579' style='fill:%23d52b1e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 886.60875,1347.682 c 0,0 -6.112,66.5468 -7.5403,87.1924 0,0 20.7017,-30.0854 26.0414,-2.6602 l 4.6601,-39.0252 c 0,0 -18.009,-29.5375 -23.1612,-45.507 z' id='path46581' style='fill:%23f7e214;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 870.75092,1457.6637 c 0,0 -6.79596,-74.5342 -42.89881,-21.8408 -1.39974,0.019 -3.31572,29.6128 -1.24048,36.699 1.1346,9.4709 11.12548,21.1882 15.30079,28.2443 7.89114,11.7471 16.3378,-2.6038 16.3378,-2.6038 0,0 8.20512,-11.9759 12.5007,-40.4987 z' id='path46583' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(1,-0.04702074,0,1,-2.2402185,26.33245)' id='g46585' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 586.92745,838.90947 c -1.3302,-42.47871 -14.6773,-113.66915 -15.3412,-162.07779 L 425.25675,520.83687 c 0,0 -18.0611,119.96174 -71.1929,186.53571 l 232.8636,131.60989' id='path46587' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 597.49388,844.43331 c 6.1621,-29.21459 13.5591,-62.06604 18.4676,-123.54139 l -94.2,-97.24502 c 0.3762,38.74522 -43.4931,96.60853 -46.4621,168.83923' id='path46589' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 678.72756,937.60442 c 10.8066,-51.25367 -15.68378,-58.91622 23.71972,-129.89659 l -87.04676,-87.55809 c -16.2197,48.31751 -27.1401,79.39667 -25.727,121.87536 l 74.1618,56.26539' id='path46591' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46593' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 337.90285,1241.5978 c -17.6248,-52.3867 6.303,-155.1608 3.6429,-221.0135 -1.9939,-42.48061 29.2436,-202.21617 28.5773,-250.53379 l -172.034,-107.44557 c 0,0 -7.4912,174.58162 -27.291,364.74936 -17.8157,97.674 -17.6979,186.9273 -4.8973,261.4838 18.2887,105.9774 36.2532,149.485 79.064,194.3175 75.9792,78.6255 239.5863,33.1999 239.5863,33.1999 137.8261,-28.5197 217.2142,-115.3382 217.2142,-115.3382 0,0 -44.827,10.5911 -117.4598,17.9733 -159.1864,-11.1519 -221.8825,28.632 -226.8347,-134.7009' id='path46595' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 798.94255,1347.4263 2.6601,-1.1496 c -29.8384,11.1657 -71.4524,23.4993 -71.4524,23.4993 l -96.991,7.4644 c -210.3899,4.9187 -184.0526,-125.3492 -175.7093,-335.5212 1.9963,-79.75702 17.8065,-180.20483 13.7334,-215.76778 l -141.0351,-80.79199 c -46.0025,129.96648 -31.665,220.89093 -40.8713,287.38017 -4.8068,71.6185 -20.0806,211.4811 3.1445,272.5093 32.8707,141.978 144.0394,136.1933 294.5239,123.7084 74.6517,-6.1936 114.8199,-25.3861 114.8199,-25.3861 l 97.0942,-55.8717' id='path46597' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 801.68565,1344.58 c -29.1784,15.1082 -72.1124,26.2555 -72.1124,26.2555 l -98.3108,9.7098 c -152.5209,12.9399 -241.8084,-94.194 -222.2648,-336.4513 0.1293,-85.58426 2.8724,-123.59981 32.4009,-237.61027 l 83.8245,49.18311 0,7.89215 c -4.7369,25.58935 -16.7308,85.43176 -16.7308,112.80179 0,194.50942 122.9863,343.91002 290.5333,369.27752 l 2.6601,-1.1315' id='path46599' style='fill:%23007a3d;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 244.89215,759.75096 c 14.2136,23.88513 99.0882,153.17293 146.638,177.62185' id='path46601' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 259.18875,844.21546 c 14.2158,24.45064 118.126,170.06404 164.927,178.26054' id='path46603' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1066.7355 c 23.7751,28.5197 47.4673,85.0303 118.1261,121.6699' id='path46605' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1228.6032 c 47.4671,44.2666 164.927,141.5588 278.3158,145.5548' id='path46607' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 268.66505,1301.4444 c 23.7751,28.5198 75.3153,161.8858 292.6123,101.3612' id='path46609' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 235.41365,1325.8951 c 14.2155,32.005 122.8652,210.2765 316.3874,141.4861' id='path46611' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg id='g46613' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 462.20445,1177.5906 c -17.6248,-52.3867 6.3032,-155.1608 3.6429,-221.01339 -1.9939,-42.48042 18.0434,-189.41138 17.377,-237.72899 L 322.39065,598.59776 c 0,0 -7.4908,174.58176 -27.2907,364.74945 -17.816,97.67399 -31.39661,217.31349 -18.1964,291.80029 21.603,121.9025 80.21406,156.1875 90.7984,165.6172 82.16457,73.2014 267.63002,66.0029 286.0569,59.4174 132.53569,-47.3661 190.2705,-131.5745 190.2705,-131.5745 0,0 -62.7893,-1.0062 -135.422,6.3756 -159.1867,-11.1515 -239.5838,-4.5105 -244.5361,-167.8436' id='path46615' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 923.24415,1283.4194 2.6602,-1.1497 c -29.8384,11.1654 -71.4525,23.4993 -71.4525,23.4993 l -96.9909,7.4644 c -210.3899,4.9186 -184.0524,-125.3492 -175.7091,-335.52124 1.9961,-79.75689 4.7392,-151.39372 0.666,-186.95707 l -126.101,-91.99612 c -46.0026,129.96661 -33.5317,203.28436 -42.7381,269.77366 -4.8068,71.61847 -20.0805,211.48107 3.1446,272.50907 32.8706,141.9782 144.0391,136.1933 294.5239,123.7084 74.6518,-6.1933 114.8198,-25.386 114.8198,-25.386 l 97.0943,-55.8717' id='path46617' style='fill:%23ffe000;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 926.98335,1281.5197 c -29.1782,15.1085 -72.1119,26.2559 -72.1119,26.2559 l -98.3111,9.7097 c -152.5208,12.9399 -241.8086,-94.1942 -222.2649,-336.4512 0.1293,-85.58451 -2.7276,-91.5877 26.8005,-205.59846 46.7189,30.27386 136.015,106.50937 136.015,106.50937 0,0 -24.29385,34.1993 -18.598,82.01037 0,194.50922 78.2636,293.25532 245.8102,318.62282 l 18.3773,-158.8556' id='path46619' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 369.19375,695.74391 c 14.2136,23.885 99.0882,153.17294 146.6383,177.62199' id='path46621' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 383.49035,780.20842 c 14.2159,24.4509 118.1261,170.06414 164.9269,178.26064' id='path46623' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1002.7285 c 23.7748,28.5195 47.4669,85.0303 118.1258,121.6696' id='path46625' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1164.5962 c 47.4674,44.2669 164.9271,141.5586 278.3161,145.5546' id='path46627' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 392.96655,1237.4373 c 23.7753,28.5199 75.3154,161.8858 292.6126,101.3613' id='path46629' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.71555,1261.8881 c 14.2157,32.005 122.8651,210.2764 316.3872,141.4859' id='path46631' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.7729,94.37835 0.759,119.68548 -0.1671,2.73323 10.3499,67.00898 6.7286,70.44221 -12.3497,14.09212 -12.7856,15.65722 -25.7994,5.22755 -1.8677,-2.14492 5.6134,-67.96457 6.1668,-77.01703 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238' id='path46633' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 199.22285,679.50793 c 0,0 -7.115,61.95089 -7.7941,73.05909 -3.2837,53.72498 -1.6899,94.38193 0.759,119.68548 -0.1671,2.73323 12.5488,92.19937 8.5925,70.52608 -12.3495,14.09186 -14.884,19.40952 -27.8978,8.97971 -1.8677,-2.14492 5.8479,-71.8006 6.4013,-80.85306 1.2613,-9.72251 3.2972,-86.61407 4.6797,-120.14313 0.1454,-13.25869 11.542,-78.52516 11.542,-78.52516 0,0 1.5164,-13.89893 3.6452,7.09238 l 0,0 0.0722,0.17861 z' id='path46635' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2972,116.81525 -1.8264,51.66406 -4.051,66.27651 -3.2284,96.39606 0.5409,2.06344 -5.0422,38.91192 -6.686,54.9318 -1.1718,8.25771 1.2024,2.11524 -0.1673,2.73335 -10.5508,6.45452 -17.7264,1.2646 -24.1576,-3.82635 -1.9086,-1.44519 17.0522,-46.09001 17.6056,-55.14273 10.0124,-131.10758 29.0249,-207.93792 29.0249,-207.93792 0,0 -7.587,46.51574 2.906,-3.96946' id='path46637' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 197.88685,657.78481 c 0,0 -14.0261,74.2259 -15.2146,116.81909 -1.8259,51.66393 -4.0509,66.27638 -3.2281,96.39607 0.5409,2.06343 -5.0423,38.91191 -6.6861,54.93166 -1.1717,8.25745 1.2025,2.11524 -0.167,2.7335 -10.5511,6.45437 -17.7264,1.26458 -24.1578,-3.82637 -1.9085,-1.44518 17.052,-46.09027 17.6109,-55.23019 10.0124,-131.10744 28.942,-207.94175 28.942,-207.94175 0,0 -7.587,46.51547 2.9062,-3.96932 l 0,0 -0.005,0.0873 z m -6.0728,211.03022 c 0,0 -11.13,5.04722 -12.3699,2.18494 m -0.481,-15.28238 c 0,0 9.5053,-0.25255 11.0003,-2.92615 m -0.5504,-12.78579 c 0,0 -7.0222,4.57419 -8.9239,1.66023 m 8.7437,-20.50279 -6.7602,0.28819 m 7.2091,-18.51076 -7.4252,0.25852 m 6.2629,-26.18363 c 0,0 -4.1932,1.87264 -4.6914,-0.89053 m 6.0118,-20.7132 -6.061,-0.27255 m -5.7926,116.5627 c 0,0 -10.9158,1.54853 -12.1186,-1.9259 m 12.9911,-23.22806 c 0,0 -10.8756,0.89279 -11.3309,-2.57038 m 11.7723,-15.56487 c 0,0 -8.8395,0.28262 -9.4633,-0.42506 m 11.1993,-17.05976 -8.8005,-0.39525 m 8.7511,-20.59035 -6.0194,-0.95004 m 8.4543,-17.09539 c 0,0 -5.4801,1.13514 -6.6411,-1.65785 m 7.2602,-19.38553 c 0,0 -4.9403,3.22043 -4.7306,-0.21253 m -0.5982,109.18796 c 0,0 -10.8277,0.10507 -10.6244,-3.21844' id='path46639' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.7731,94.37861 0.7591,119.68547 -0.1672,2.73336 10.3498,67.00938 6.7283,70.44247 -12.3498,14.09186 -12.7854,15.6571 -25.7993,5.22757 -1.8679,-2.14493 5.6135,-67.96445 6.1667,-77.0173 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925' id='path46641' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 323.52465,615.50089 c 0,0 -7.115,61.95075 -7.7941,73.05883 -3.2838,53.72524 -1.6902,94.38232 0.7591,119.68547 -0.1672,2.73336 12.5487,92.19951 8.5925,70.52621 -12.3498,14.092 -14.8843,19.40953 -27.8981,8.97999 -1.8673,-2.14506 5.8481,-71.80061 6.4013,-80.85346 1.2614,-9.72225 3.2972,-86.61406 4.6797,-120.14287 0.1455,-13.25869 11.5421,-78.52541 11.5421,-78.52541 0,0 1.5166,-13.89868 3.6455,7.0925 l 0,0 0.072,0.17874 z' id='path46643' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2976,116.81536 -1.8257,51.6638 -4.0507,66.27638 -3.2282,96.39608 0.5411,2.06357 -5.042,38.91178 -6.6861,54.93192 -1.1716,8.25745 1.2027,2.11498 -0.1669,2.73323 -10.551,6.45438 -17.7264,1.26446 -24.1579,-3.82622 -1.9083,-1.44519 17.0524,-46.09015 17.6058,-55.14288 10.0123,-131.10757 29.0246,-207.93791 29.0246,-207.93791 l 2.9063,-3.96958' id='path46645' style='fill:%23f7e214;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 322.18865,593.77765 c 0,0 -14.0262,74.22616 -15.2147,116.81908 -1.8258,51.66392 -4.0508,66.27638 -3.2279,96.39606 0.5407,2.06357 -5.0425,38.91192 -6.6865,54.93194 -1.1715,8.25731 1.2029,2.1151 -0.1669,2.73322 -10.5509,6.45465 -17.7262,1.26459 -24.1578,-3.82636 -1.9081,-1.44505 17.0526,-46.09001 17.6109,-55.23031 10.0126,-131.10745 28.9421,-207.94149 28.9421,-207.94149 l 2.9063,-3.96947 0,0 -0.005,0.0873 z m -6.073,211.03034 c 0,0 -11.1296,5.04722 -12.3696,2.1848 m -0.4813,-15.28198 c 0,0 9.5052,-0.25281 11.0002,-2.92641 m -0.5502,-12.78567 c 0,0 -7.022,4.5738 -8.9238,1.65997 m 8.7434,-20.50264 -6.76,0.28805 m 7.209,-18.51076 -7.425,0.25838 m 6.2627,-26.18349 c 0,0 -4.1933,1.87251 -4.6911,-0.89053 m 6.0117,-20.7132 -6.0608,-0.27242 m -5.7928,116.5627 c 0,0 -10.916,1.5488 -12.1186,-1.92591 m 12.991,-23.22831 c 0,0 -10.8758,0.89292 -11.331,-2.57012 m 11.7727,-15.56487 c 0,0 -8.8396,0.28262 -9.4635,-0.4252 m 11.1991,-17.05948 -8.8002,-0.39551 m 8.7509,-20.59023 -6.0195,-0.95017 m 8.4546,-17.09539 c 0,0 -5.4801,1.13514 -6.6412,-1.65798 m 7.2604,-19.38526 c 0,0 -4.9407,3.22029 -4.731,-0.21254 m -0.598,109.18796 c 0,0 -10.8279,0.10521 -10.6247,-3.21871' id='path46647' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(7.4567489,0.3350755,-0.3907918,6.3936151,-2152.8789,-980.23756)' id='g46649' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.2597,9.7299 1.09155,15.27315 -0.17955,6.726 0,8.63835 -0.36765,12.54855 -0.0769,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.27035 -0.2679,-17.1 -2.1831,-27.19755 -2.1831,-27.19755 l -0.35625,-0.53295' id='path46651' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.46575,216.69181 c 0,0 1.26825,9.7299 1.08015,15.27315 -0.1767,6.726 0,8.63835 -0.36765,12.54855 -0.077,0.26505 0.36765,5.08725 0.4446,7.17915 0.0798,1.08015 -0.1767,0.2679 0,0.35625 1.35945,0.9006 2.3598,0.2679 3.26325,-0.35625 0.35625,-0.1767 -1.9038,-6.09045 -1.9038,-7.28175 -0.2679,-17.1 -2.1717,-27.19755 -2.1717,-27.19755 l -0.35625,-0.53295 0,0 z' id='path46653' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,244.61326 c 0,0 1.4478,0.26505 1.63875,-0.17955' id='path46655' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,241.33861 c 0,0 1.4478,0.17955 1.4478,-0.2679' id='path46657' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,238.97881 c 0,0 1.1685,0.0883 1.26825,0' id='path46659' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.46895,236.69596 1.1799,0' id='path46661' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.64565,233.96851 0.81225,-0.0884' id='path46663' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,231.60871 c 0,0 0.62415,0.17955 0.81225,-0.1767' id='path46665' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.5687,228.86986 c 0,0 0.62415,0.44745 0.62415,0' id='path46667' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 357.37775,243.06571 c 0,0 1.4478,0.077 1.4478,-0.35625' id='path46669' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:0.21694401;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 806.66725,651.2808 9.7153,0.72149 c 0,0 -15.0236,-1.09434 -9.7153,-0.72149 z' id='path46671' style='fill:%23005000;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 937.21825,1074.8468 c 0,0 -4.5288,-1.9413 -5.661,0 0,0.9709 1.1322,1.9416 2.2645,1.9416 1.1319,0 3.3965,-1.9416 3.3965,-1.9416 z' id='path46673' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 924.76395,1088.4376 c 0,0 19.2475,-1.9416 26.0405,-1.9416' id='path46675' style='fill:%23ffffff;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.99723987,-0.07424718,0.07424718,0.99723987,-33.971314,39.538796)' id='g46878' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 621.71166,588.00003 c 1.55124,-25.53783 26.6974,-38.51833 30.57352,-40.73782 12.386,-7.09211 20.9226,-13.39856 46.59511,-14.82978 0,0 1.34883,5.39291 0.91767,9.90624 -0.4249,4.52124 -7.12657,19.73971 -27.64814,31.49049 -20.90475,11.97003 -50.43816,14.17087 -50.43816,14.17087 z' id='path3865' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 622.15665,578.25035 325.46028,494.50865 18.37956,-15.5902 -332.1678,-502.41998 -11.67204,23.50153 z' id='path4013' style='fill:%23a05a2c;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.5;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(0.99901905,-0.0442824,0.0442824,0.99901905,-36.518183,37.578281)' id='g46862' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 639.39145,477.70486 c 0,0 39.2902,0.59415 36.8077,-22.20147 -2.8749,-22.59323 -29.0661,-25.29076 -39.8614,-27.61258 -11.1856,-2.09816 -47.7692,1.93173 -59.5934,11.26176 -12.2107,9.54028 -36.7132,25.40194 -33.1996,57.38094 3.5195,31.98736 10.1271,54.49984 19.2649,75.25145 8.9867,21.29819 3.8469,40.1481 -0.192,48.24779 -1.3531,3.47731 -6.3395,14.8341 2.8712,20.28391 13.5751,7.81261 17.1477,8.28336 31.1751,-4.03531 14.2785,-11.979 33.8714,-31.79907 36.5462,-57.25154 2.6806,-25.44409 28.3769,-37.29832 32.3475,-39.34399 12.6879,-6.53667 21.4954,-12.45891 47.2061,-12.75189 0,0 -7.2349,-15.71335 -20.8087,-16.59231 -13.8095,-1.21547 -39.6849,-16.58216 -52.5636,-32.63676 z' id='path3859' style='fill:%23d52b1e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 639.39145,477.70486 c 0,0 39.2902,0.59415 36.8077,-22.20147 -2.8749,-22.59323 -29.0661,-25.29076 -39.8614,-27.61258 -11.1856,-2.09816 -47.7692,1.93173 -59.5934,11.26176 -12.2107,9.54028 -36.7132,25.40194 -33.1996,57.38094 3.5195,31.98736 10.1271,54.49984 19.2649,75.25145 8.9867,21.29819 3.8469,40.1481 -0.192,48.24779 -1.3531,3.47731 -6.3395,14.8341 2.8712,20.28391 13.5751,7.81261 17.1477,8.28336 31.1751,-4.03531 14.2785,-11.979 33.8714,-31.79907 36.5462,-57.25154 2.6806,-25.44409 28.3769,-37.29832 32.3475,-39.34399 12.6879,-6.53667 21.4954,-12.45891 47.2061,-12.75189 0,0 -7.2349,-15.71335 -20.8087,-16.59231 -13.8095,-1.21547 -39.6849,-16.58216 -52.5636,-32.63676 z' id='path3861' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 639.39145,477.70486 c -5.2361,-0.54057 -19.9223,-9.17678 -31.1102,-6.6509 -10.9523,2.86209 -34.1151,12.94196 -32.8263,31.72934' id='path3867' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 701.95405,515.37377 c 0,0 -23.4775,6.54593 -40.5287,15.33036 -7.1474,3.68245 -31.4899,21.31532 -47.3509,34.12098 -13.9614,10.8889 -18.7124,27.22742 -47.6668,42.14454' id='path13300' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 688.23155,510.41745 c -5.088,3.5369 -10.1603,7.07704 -18.5699,10.48286 -8.0017,3.20658 -11.1807,9.4673 -16.5704,14.09765' id='path3875' style='fill:none;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-1,0,0,1,1904.8396,-17.433837)' id='g46509' style='stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-0.9773238,0.02796767,0.0271617,1.0063241,4636.2403,-91.417631)' id='g46511' style='stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(-8.5612132,0,0,7.1058458,6939.2223,-1935.3371)' id='g46513' style='stroke:%23000000;stroke-width:0.19384736;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg transform='matrix(2.698228,0.188676,-0.188676,2.698228,-83.95137,198.3774)' id='g46515' style='stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 156.89937,89.492537 c -0.0326,1.927576 -3.76381,4.277709 -6.81891,0.32337 -3.19349,-2.72162 -2.73384,-7.079109 -0.32947,-7.767359 L 177.5685,47.471874 c 1.14367,-0.795862 1.2235,-1.517334 1.77636,-2.271883 1.30518,1.486191 3.98739,4.142158 5.44264,5.419584 -0.80859,0.859605 -1.46049,1.669663 -1.61792,2.323361 l -26.27021,36.549601 z' id='path46517' style='fill:%23e8a30e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.07166747;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(4.31408,0.22609,-0.22609,4.31408,-96.979953,-495.72462)' id='g46519' style='stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 123.24464,190.48427 c 0.83741,-1.42667 4.36995,2.17219 3.48803,3.32673 -0.88193,1.15455 -4.25579,-1.888 -3.48803,-3.32673 z' id='path46521' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 126.41817,193.54356 c -0.62839,0.58457 -3.18339,-1.82708 -2.7996,-2.76435 0.65951,-0.88378 3.48273,2.18618 2.7996,2.76435 z' id='path46523' style='fill:%23cccccf;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.04487207;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cpath d='m 3513.1548,736.63692 c 56.5472,-19.2548 95.9439,-57.2317 120,-113.0372' id='path46525' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3934.4833,1159.2881 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path46527' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 3964.4603,1190.9305 c 71.1276,-23.5221 118.9952,-70.3041 139.0601,-144.8889' id='path46529' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4138.4935,1357.4694 c 71.1276,-23.5221 127.3222,-76.133 147.3871,-150.7178' id='path46531' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4169.3032,1389.1118 c 71.1276,-23.5221 128.1549,-76.9657 148.2198,-151.5505' id='path46533' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4338.3403,1405.7658 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path46535' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path46537' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4375.2216,1406.928 c 0.3123,10.999 -9.0146,20.1579 -20.8509,20.4757 -11.8364,0.3178 -21.7168,-8.3254 -22.0886,-19.3228 -0.3718,-10.9974 8.9053,-20.1998 20.7398,-20.573 11.8345,-0.3731 21.7616,11.5546 22.1929,22.5501' id='path46539' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.51194298;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;stroke-dashoffset:0' /%3E %3Cpath d='m 4336.2403,1403.8367 c 4.0114,16.3412 13.4191,21.2161 26.2299,15.8212' id='path46541' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 4192.5889,1403.1357 c 28.071,40.3961 57.6604,27.1803 82.7184,26.9003' id='path46543' style='fill:none;stroke:%23000000;stroke-width:1.51194298;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(-0.75814503,0,0,0.75814503,1187.3206,-301.79642)' id='g14289-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.97851324;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline'%3E %3Cg transform='matrix(0.9146189,0,0,0.9146189,7.9399242,38.377158)' id='g8637-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -47.847628,478.55214 c -31.189887,49.90467 -77.451952,139.94721 -90.080292,208.92023 -23.29528,127.234 13.1162,268.29966 123.956446,367.98143 90.307556,81.2159 232.039924,106.3136 291.220764,118.4577 59.0305,12.1134 101.74626,31.1032 111.50717,44.1483 0.49248,-9.1885 1.83275,-18.3768 -8.0111,-27.5652 -28.03886,-12.3568 -73.53237,-19.67 -136.95616,-32.7412 -127.44783,-26.266 -261.343435,-74.0477 -334.288819,-213.12114 -95.118921,-181.34822 -38.443081,-323.87293 43.94928,-465.34228 0,0 -1.297289,-0.73784 -1.297289,-0.73784 z' id='path30956-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9505055,0.9172151,0.88825,0.8453266,-371.8457,472.97883)' id='path30731-5' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052171;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -169.58338,995.64452 c 18.95531,11.26108 37.7394,14.19488 52.7909,19.22078 11.63262,3.8845 31.653462,10.1918 38.545829,12.7876 6.598221,2.485 16.876215,7.1209 25.674547,11.1017 13.945413,6.3095 29.037461,23.8214 29.037461,23.8214 0,0 -21.21744,22.2597 -46.558275,19.1076 -19.870286,-2.4716 -29.887953,-7.9171 -39.855932,-12.7636 -10.36255,-5.0383 -10.12109,-10.76 -25.04645,-21.5174 -16.50364,-11.895 -28.06417,-35.3848 -34.58808,-51.75808 z' id='path30759-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -70.253644,1016.6675 c 6.077317,9.528 20.609513,8.7802 28.91506,7.4854 l 3.755291,4.7526 c -11.406268,0.1637 -26.99614,0.2925 -34.798256,-9.9804 0.192213,-1.5378 1.11311,-2.2662 2.127905,-2.2576 z' id='path30761-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -169.32579,996.50585 c 17.15921,16.71365 49.18745,35.29995 81.321128,49.02895 32.183592,13.7504 69.76834,18.151 87.87877855,18.0381 l 4.78002775,5.0441 c -26.0567653,-2.4248 -60.4166663,-7.1451 -89.5318733,-19.0925 -37.961841,-15.5775 -69.139881,-35.5942 -84.695511,-52.02413 l 0.24745,-0.99452 z' id='path30763-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -127.5252,1076.9144 c 34.223423,-1.2047 53.059733,9.4421 84.857391,16.396 29.721875,6.4999 64.486113,-8.9539 83.72249,19.6434 -77.45679,50.1926 -133.369482,16.4204 -168.579881,-36.0394 z' id='path30906-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -57.861504,1147.2458 c 14.751122,-12.6497 141.48495,-55.5304 161.723764,-7.6042 -30.148575,33.341 -118.391595,40.7863 -161.723764,7.6042 z' id='path30908-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -27.819877,1180.9893 c 13.385645,-2.1172 29.1597964,-5.2224 44.578745,-7.0054 15.487338,-1.7912 21.554942,-4.4712 33.000376,-6.0493 18.727851,-2.5822 40.164795,-28.8655 106.175076,-8.8073 -25.55384,58.8679 -112.758262,71.224 -183.754197,21.862 z' id='path30910-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -56.359348,1148.1963 c 67.519725,13.4805 146.873829,-0.043 178.246488,-18.5353 l 5.00689,3.3269 c -72.335806,30.8267 -142.616313,26.7699 -183.253378,15.2084 z' id='path30914-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -126.45638,1076.907 c 39.764273,26.6671 91.011135,46.548 200.777837,31.8425 l 1.502056,3.8021 c -150.41421,12.9008 -165.298396,-14.6713 -202.279893,-35.6446 z' id='path30916-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -27.319158,1181.4646 c 52.478273,1.8637 82.015969,25.2451 180.318158,-23.1398 8.03209,-3.9534 18.75115,-6.7081 24.96585,-9.6533 l 9.01243,3.3269 c -6.84225,3.054 -17.88709,2.9712 -24.04113,5.6867 -122.751752,54.1642 -119.314808,28.8417 -190.255308,23.7795 z' id='path30920-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='translate(6.2098842,4.5162794)' id='g3317-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(0.6662805,-1.1204105,1.1011974,0.5769506,-468.20416,995.22832)' id='path30890-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.68478,1119.673 c 11.32472,2.9164 14.57638,16.3815 15.55623,24.3164 l 5.84855,2.1152 c -2.98071,-10.4519 -7.15086,-24.7113 -19.70599,-28.996 -1.50417,0.5996 -1.98751,1.6408 -1.69879,2.5644 z' id='path30924-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-1.3147397,0.3128712,0.2942269,1.1607992,-105.43462,68.60708)' id='path30729-2' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052171;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -82.512219,964.25771 c 2.461617,-36.66127 20.254378,14.14787 56.195102,-67.76533 10.444589,-23.80448 10.362149,-38.9882 17.4458255,-74.72452 -19.5664995,30.89054 -52.2792025,39.22533 -65.5616105,63.09123 -13.068502,23.4816 -9.733618,61.23931 -8.079317,79.39862 z' id='path30733-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -9.5792876,824.45634 c 0,0 -17.7022104,41.3355 -43.1933824,70.57281 -25.642512,29.41102 -30.447646,65.19583 -30.447646,65.19583' id='path30735-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -27.10234,859.56181 c -22.549021,30.36379 -52.8627,66.34569 -54.286325,104.122 l -3.521401,1.31141 c 5.250217,-49.68294 34.623115,-72.62694 52.740483,-97.6916 l 5.067243,-7.74181 z' id='path30737-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -217.75674,906.45522 c 16.50525,13.57745 33.86029,18.48998 47.44176,25.20458 10.49662,5.18943 19.30761,12.0785 25.49108,15.4588 5.91965,3.23606 15.55442,4.73781 23.36688,9.74577 12.3828,7.93759 36.608678,35.71591 36.608678,35.71591 0,0 -22.967018,18.81832 -37.199848,15.73022 -41.39216,-8.0217 -53.45866,-24.44861 -74.34903,-39.6551 -16.12052,-13.20408 -17.1964,-44.54864 -21.35952,-62.20018 z' id='path30739-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -66.226302,993.83107 3.894481,5.71305 c -23.754121,-2.34136 -61.595049,-25.14088 -86.817089,-37.83684 -33.93621,-17.08237 -52.95258,-30.07418 -67.255,-54.36654 16.19624,24.28331 37.36944,38.06719 69.23438,53.47191 26.75763,12.9357 64.803128,34.81946 80.943228,33.01842 z' id='path30741-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -231.83431,826.16772 c 13.83665,16.04059 30.06081,23.67907 42.24397,32.48522 9.41574,6.80592 16.86637,15.01511 22.3554,19.34298 5.25473,4.14319 14.48098,7.17605 21.28407,13.37052 10.78303,9.81818 26.78494,38.48215 26.78494,38.48215 0,0 -11.47048,12.25334 -24.94419,6.91614 -41.72746,-5.16951 -53.99025,-24.95099 -69.50399,-60.55717 -8.68361,-18.46261 -17.2753,-31.97363 -18.2202,-50.03984 z' id='path30743-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(1.2324921,0.535398,-0.5124945,1.0903238,-15.823411,291.78404)' id='path30745-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -98.135231,936.69841 2.815916,6.25779 C -145.33316,920.15434 -210.94381,874.17691 -232.4226,827.34331 c 30.54195,50.51615 80.99616,83.82351 134.287369,109.3551 z' id='path30747-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -243.24309,748.88918 c 11.8865,16.69919 26.6325,25.30604 37.48342,34.78547 8.38619,7.32623 14.81771,15.89758 19.68038,20.52246 4.6552,4.42752 13.13569,8.03408 19.10254,14.58208 9.45732,10.37852 22.47169,39.62658 22.47169,39.62658 0,0 -15.26444,14.36397 -27.58347,8.20491 -12.31903,-6.15908 -28.83697,-20.14295 -37.00805,-27.43618 -8.5079,-7.59392 -10.59796,-25.91472 -20.58773,-39.88601 -11.62298,-16.25552 -13.97554,-32.58611 -13.55878,-50.39931 z' id='path30749-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -207.23421,800.53745 c 24.25936,27.63235 54.1148,53.98137 82.06478,66.02697 l 2.20232,6.33926 c -45.51129,-25.80012 -64.69608,-49.12278 -84.834,-71.48215 l 0.5669,-0.88408 z' id='path30751-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -226.03236,701.30385 c 8.28336,16.21491 20.69819,25.83071 29.278,35.63435 6.63096,7.57682 11.19487,15.94785 14.97326,20.66795 3.61721,4.51867 10.99423,8.88404 15.47629,15.43281 7.10417,10.37977 14.23715,37.64017 14.23715,37.64017 0,0 -10.34873,11.01571 -20.90239,3.87669 -10.55366,-7.13902 -25.66359,-21.71514 -32.09712,-29.23194 -6.69884,-7.82669 -10.08073,-24.76777 -17.05343,-38.34046 -8.11273,-15.79177 -7.45164,-30.29506 -3.91176,-45.67957 z' id='path30753-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -149.23788,682.08309 c 4.40142,9.50931 6.16458,18.83031 9.01243,28.63454 l 1.12657,-7.01011 c -2.34773,-7.67809 -4.22086,-15.75965 -7.88587,-22.81258 -0.75108,-0.1623 -1.50205,-0.20644 -2.25313,1.18815 z' id='path30755-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -201.12606,751.3442 c 18.04476,27.50129 41.60436,54.7069 65.88953,69.23219 l 0.96157,5.81816 c -38.45122,-29.01552 -52.46161,-52.03908 -67.54293,-74.36655 l 0.69183,-0.6838 z' id='path30757-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -102.33872,925.27463 c 2.00679,-8.76547 3.61309,-15.66551 9.369651,-23.54116 0.861646,-0.0567 1.471426,0.2152 1.666451,1.02858 -5.238969,8.49156 -7.448821,15.92559 -8.911812,26.20925 l -2.12429,-3.69667 z' id='path30765-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.7407207,-0.6718913,-0.6626821,0.6478724,343.61021,366.4895)' id='path30727-3' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -109.35883,601.78044 c 6.2605,-5.45846 14.041624,-10.33958 21.941855,-15.17545 0.902218,0.3096 1.000434,0.94628 0.738425,1.72952 -9.079622,5.73908 -17.04172,11.31445 -23.80313,17.68223 l 1.12285,-4.2363 z' id='path30767-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -206.42739,608.03309 c 19.87791,41.93134 67.67965,71.22443 48.50395,132.74407 -49.39268,44.60867 -52.56122,-79.83812 -48.50395,-132.74407 z' id='path30868-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -161.10982,516.28843 c 8.13512,42.85151 46.17604,78.29386 21.24259,135.09651 -70.02989,17.60367 -36.6531,-76.77156 -21.24259,-135.09651 z' id='path30870-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -119.68683,452.10079 c -35.18289,65.43776 -43.64243,103.28516 -2.12419,146.18652 0,0 21.79969,-20.4906 27.005302,-58.19421 4.402862,-31.8894 -21.615792,-70.06957 -24.881112,-87.99231 z' id='path30872-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -61.269626,414.1259 c -9.335807,41.48014 26.569493,60.4945 -24.783075,113.92467 -36.635619,-43.58456 -19.147529,-54.47205 24.783075,-113.92467 z' id='path30874-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -47.461996,486.71506 c 59.186036,6.32012 36.134492,-44.99185 53.0106064,-92.36038 -34.8581094,25.98143 -82.0920564,36.43178 -53.0106064,92.36038 z' id='path30876-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -86.052701,565.01728 c 16.659013,-77.17027 69.752372,-46.98582 99.132099,-80.9907 -15.1971103,49.76495 -37.512543,83.74496 -99.132099,80.9907 z' id='path30878-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -109.93346,636.81438 c 46.250019,-3.04549 83.747196,-25.8231 108.6502792,-76.99245 C -48.718815,580.999 -101.31366,583.14328 -109.93346,636.81438 z' id='path30880-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -116.94322,703.82631 c 18.246011,-20.94913 18.700735,-34.46455 25.645423,-48.43021 11.499161,-23.1247 23.705214,-43.59042 53.464045,-65.1574 -0.215713,54.58238 -7.975664,114.88753 -79.109468,113.58761 z' id='path30882-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -127.45772,760.85776 c 28.391951,-39.55445 54.705,-73.16893 97.635068,-100.75555 -17.814385,38.83921 -9.57882,110.67904 -97.635068,100.75555 z' id='path30884-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -119.44661,839.27598 c 87.127245,-2.4431 78.88873,-84.63975 79.610082,-123.09285 -15.734383,23.53452 -34.978117,43.98941 -49.313681,60.91796 -15.653141,18.48431 -30.735161,39.35151 -30.296401,62.17489 z' id='path30886-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -108.93212,888.22797 c 7.0424,-17.82139 1.63607,-25.02437 17.18979,-40.68001 16.806721,-16.91693 49.046302,-47.19021 65.925229,-81.93757 2.439423,30.71988 2.82718,78.15145 -20.968617,94.01756 -18.00449,12.00479 -33.703239,15.3832 -62.146402,28.60002 z' id='path30894-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -32.826764,1015.5982 c 68.37386,-53.18645 27.2686931,-98.05455 21.529707,-137.82599 -17.372817,44.84619 -66.280621,83.52027 -21.529707,137.82599 z' id='path30896-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -60.865617,502.79051 c 21.97439,-41.23483 35.316675,-63.81894 64.636046,-106.81838 -33.841407,48.91145 -48.446436,79.96628 -67.890518,113.47206' id='path30912-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -33.828303,1028.9055 c -2.786391,-54.15815 11.968648,-100.82358 21.529809,-149.7075 -9.034532,51.61824 -21.861813,103.56377 -17.023439,153.9849 l -4.50637,-4.2774 z' id='path30930-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -115.0012,899.06408 c 7.13248,-33.11525 72.391537,-55.10577 88.68338,-132.02791 -13.361944,76.47976 -79.52041,95.75985 -86.17989,138.80039 l -2.50349,-6.77248 z' id='path30932-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -129.59998,854.02973 1.77019,8.40151 c 9.64963,-51.84823 70.552558,-77.36503 88.156754,-146.52257 -25.727873,74.94091 -75.374464,84.83426 -89.926944,138.12106 z' id='path30934-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -141.63752,776.39964 c 29.97314,-45.7067 71.870836,-62.95541 111.523736,-116.61315 -37.088448,52.71593 -83.851636,77.44676 -112.231836,123.67043 l 0.7081,-7.05728 z' id='path30936-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -140.57533,716.24473 c 32.98559,-14.10742 67.209616,-53.68583 103.026584,-126.02286 -23.492012,53.5239 -53.269622,101.9338 -103.026584,134.08831 l 0,-8.06545 z' id='path30938-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M -125.3515,645.67193 C -86.863733,615.24109 -36.96588,595.03364 -1.0823309,559.30426 -30.900915,593.32089 -88.192356,617.09507 -126.4136,650.71283 l 1.0621,-5.0409 z' id='path30940-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -95.611853,570.05821 c 38.888666,-26.4268 76.360837,-34.6586 108.691251,-84.68736 -25.967186,48.94742 -67.298288,61.34625 -110.107444,88.38403 l 1.416193,-3.69667 z' id='path30942-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -206.42739,609.04129 c 13.93376,54.00433 25.71431,110.76478 62.66568,147.19469 l -0.3541,-7.05728 c -16.89108,-9.45471 -43.58905,-65.72009 -62.31158,-140.13741 z' id='path30944-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -161.46392,518.30482 c 2.53955,55.81503 1.57085,114.84521 30.44775,146.52257 l 2.12429,-6.38514 c -29.4442,-23.84221 -26.99213,-86.93132 -32.57204,-140.13743 z' id='path30946-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -121.81102,454.7893 c -9.87971,49.12027 -10.60207,94.55253 2.47829,168.03049 l 2.83228,-5.37699 c -8.20582,-43.28591 -17.50989,-87.63029 -5.31057,-162.6535 z' id='path30948-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -62.331821,415.80622 c -19.740135,41.66813 -34.849574,83.83857 -21.950689,129.04742 l 3.540482,-5.04091 c -15.292212,-41.3355 2.584236,-82.67101 18.410207,-124.00651 z' id='path30950-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='matrix(0.9850754,0.1721232,-0.1721232,0.9850754,184.73266,0.2731797)' id='g3281-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -2.2845182,979.003 c -13.3256908,59.3443 24.0920552,94.2107 64.0886052,111.2114 13.933836,-85.284 -42.775615,-66.0933 -64.0886052,-111.2114 z' id='path30898-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -3.285956,979.003 c 2.0342082,34.912 45.946031,66.7231 67.593537,122.6176 l 6.008225,3.8021 C 40.891792,1037.8008 0.08892556,1016.9272 -3.285956,979.003 z' id='path30918-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9844485,0.1759721,0.1080895,0.9204363,-25.544871,106.89833)' id='path42835-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -115.98395,609.25633 c -0.49694,-8.29106 0.39217,-17.43331 1.38986,-26.64221 0.79628,-0.52516 1.36034,-0.21397 1.82037,0.47195 -1.0031,10.69441 -1.45312,20.40406 -0.54229,29.6472 l -2.66794,-3.47694 z' id='path42837-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.7656157,-0.3802691,-0.1729816,0.7822886,93.850308,250.49401)' id='path42841-5' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.65327358;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -109.46903,598.68249 c 1.90561,-6.79537 5.05421,-13.53086 8.30017,-20.26163 0.72399,0.006 1.04997,0.54848 1.197637,1.33149 -3.656237,7.8985 -6.640017,15.31256 -8.504377,23.07636 l -0.99343,-4.14622 z' id='path42843-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9998418,-0.02052883,-0.07453799,0.9237588,47.838005,233.93788)' id='path42850-5' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -139.37359,708.80059 c 1.13887,-8.22749 3.8038,-17.01779 6.58829,-25.85215 0.88381,-0.35878 1.37588,0.057 1.69245,0.81982 -3.08115,10.28995 -5.42682,19.72275 -6.34655,28.96501 l -1.93419,-3.93268 z' id='path42852-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.6960369,-0.7458915,-0.622706,0.7192273,287.33872,446.81179)' id='path42856-1' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.20199919;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -138.3051,708.01702 c 5.88284,-6.05964 13.19457,-11.47835 20.61822,-16.84683 0.84779,0.3437 0.94008,1.0505 0.69388,1.92 -8.5319,6.37117 -16.01368,12.56059 -22.36721,19.6297 l 1.05511,-4.70287 z' id='path42858-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.9335968,0.3584719,0.2797353,0.8835352,-109.82582,412.55656)' id='path42862-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -103.9022,922.9561 c -2.05163,-8.04857 -2.90262,-17.19444 -3.65954,-26.42626 0.68295,-0.6659 1.29558,-0.46667 1.87671,0.12018 1.03176,10.69168 2.42096,20.31197 5.05862,29.21747 l -3.27579,-2.91139 z' id='path42864-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(0.7407207,-0.6718913,0.6626821,0.6478724,-554.7183,692.67512)' id='path42868-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902558;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -101.74926,927.96606 c -6.2605,-5.45846 -14.04162,-10.33958 -21.94186,-15.17545 -0.90221,0.3096 -1.00043,0.94628 -0.73842,1.72952 9.07962,5.73908 17.04172,11.31445 23.80313,17.68223 l -1.12285,-4.2363 z' id='path42870-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.6610817,0.7503838,0.6574118,0.6532196,-286.71184,567.55437)' id='path42874-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:2.24902582;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -44.87854,1017.0645 c -5.54865,-6.1807 -10.542067,-13.8902 -15.491965,-21.71951 0.296487,-0.90662 0.931676,-1.01405 1.718633,-0.76343 5.870112,8.99544 11.560329,16.87594 18.025466,23.54424 l -4.252134,-1.0613 z' id='path42876-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(1.346098,-0.1506978,0.1592309,1.1843181,-310.55669,437.15465)' id='path30888-7' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -43.067457,997.98027 c 4.114009,10.59703 1.17688,14.71893 -1.267363,19.33933 l 2.577407,5.4137 c 3.645326,-6.081 5.018637,-12.8067 1.799414,-25.43483 -1.512299,-0.5812 -2.628422,-0.1663 -3.109458,0.6818 z' id='path30952-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg transform='translate(18.065117,6.2098841)' id='g3321-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 151.75914,1156.682 c 11.68715,0.9958 17.5359,-5.5201 21.35627,-12.639 l 6.25818,-0.057 c -6.6171,8.8202 -13.61752,15.7784 -26.95888,15.6605 -1.19134,-1.0578 -1.26405,-2.1934 -0.65557,-2.9646 z' id='path30954-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(0.2974956,1.2552123,1.2297151,-0.2509299,-488.57474,1103.999)' id='path30892-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.70052159;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 74.400955,1015.695 c -8.843312,54.1723 22.75983,98.1925 70.420865,111.8454 15.5605,-69.8336 -48.821592,-72.3333 -70.420865,-111.8454 z' id='path30900-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 74.313554,1016.13 c 17.496678,42.5043 41.164226,82.0662 83.570426,125.6764 l 9.12108,1.1798 C 119.80735,1105.647 93.896095,1057.1417 74.313554,1016.13 z' id='path30928-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 148.40157,484.16351 a 5.78188,8.1221653 0 1 1 -11.56376,0 5.78188,8.1221653 0 1 1 11.56376,0 z' transform='matrix(-0.6093744,1.1080292,1.0046067,0.2495521,-235.48892,857.4059)' id='path42880-2' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.92317355;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cpath d='m 183.60247,1147.4269 c -8.6734,-2.7373 -17.09374,-7.2733 -25.49424,-11.9504 0.10931,-1.0476 0.86884,-1.5209 1.91973,-1.7369 9.87934,5.2672 19.21558,9.5628 29.16892,12.2376 l -5.59441,1.4497 z' transform='matrix(0.9999988,0.00155371,-0.00155371,0.9999988,11.83673,3.536214)' id='path42882-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cg transform='matrix(0.8458764,-0.2850894,0.2850894,0.8458764,-298.28817,241.35557)' id='g3299-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.42342067;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 179.12885,1032.2936 c -5.35793,23.8994 5.80888,50.8055 17.11255,72.6781 11.28705,21.8404 11.10918,28.5467 32.37509,43.5148 40.13,-44.0365 -32.36121,-79.8792 -49.48764,-116.1929 z' id='path30904-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.42342067;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 179.53121,1031.8183 c 9.36265,55.9302 41.83749,92.8226 53.51099,130.8213 l 3.21863,0.7651 c -17.50159,-52.1184 -41.60829,-69.0185 -56.72962,-131.5864 z' id='path30922-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.42342067;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(0.9146189,0,0,0.9146189,47.539065,38.377158)' id='g13596-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 598.31412,478.55214 c 31.1899,49.90467 77.452,139.94721 90.0803,208.92023 23.2953,127.234 -13.1162,268.29966 -123.9564,367.98143 -90.30758,81.2159 -232.03995,106.3136 -291.22079,118.4577 -59.0305,12.1134 -101.74626,31.1032 -111.50717,44.1483 -0.49248,-9.1885 -1.83275,-18.3768 8.0111,-27.5652 28.03886,-12.3568 73.53237,-19.67 136.95616,-32.7412 127.44783,-26.266 261.3434,-74.0477 334.2888,-213.12114 95.1189,-181.34822 38.4431,-323.87293 -43.9493,-465.34228 0,0 1.2973,-0.73784 1.2973,-0.73784 z' id='path8725-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.16321063;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline' /%3E %3Cg transform='matrix(1.3022102,0,0,-1.240275,1150.9941,1861.2105)' id='g12828-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.70215559;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12270-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.70215559;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12272-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.70215559;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.4994531,0.771884,0.6180033,0.2437134,-250.74479,1390.7491)' id='g12848-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.7956059;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12850-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.7956059;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12852-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.7956059;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.6213959,-0.4266944,-0.5367293,0.7014285,531.44896,-179.10295)' id='g12854-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.65293002;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12856-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.65293002;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12858-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.65293002;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.2522786,-0.6942997,-0.5962581,0.2687864,806.00342,-65.264068)' id='g12860-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.11651707;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12862-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.11651707;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12864-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.11651707;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.4725685,-0.4952455,0.4182085,-0.2641216,88.279179,363.06063)' id='g12866-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.75469446;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path12868-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.75469446;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path12870-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.75469446;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.1226049,-0.8120892,-0.5577693,0.2026637,884.0155,-61.176303)' id='g13368-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948585;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13370-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.12948585;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13372-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948585;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.01621438,-0.8765958,-0.7728635,0.07245876,1087.9884,9.438215)' id='g13374-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.62585926;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13376-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.62585926;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13378-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.62585926;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.130198,-0.8109065,-0.5929845,0.02341862,1092.8091,122.74526)' id='g13380-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948608;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13382-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.12948608;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13384-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.12948608;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5496038,-0.5215127,0.4968935,-0.4506495,16.09552,492.27995)' id='g13410-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860378;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13412-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.03860378;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13414-5' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860378;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5857891,-0.4805111,0.4630936,-0.4853168,30.149938,571.82772)' id='g13416-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860402;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13418-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.03860402;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13420-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.03860402;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.6064455,-0.5390597,0.5161558,-0.4996707,3.3922791,589.89562)' id='g13422-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.83734989;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13424-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.83734989;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13426-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.83734989;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.1429591,-0.4898699,-0.4898699,-0.1429591,1056.9161,403.04795)' id='g13386-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13388-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13390-7' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.4261055;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13392-7' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.4261055;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(-0.419933,-0.2899416,0.2899416,-0.419933,225.65271,697.98936)' id='g13402-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13404-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:4.23906517;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13406-4' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.42610538;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13408-9' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.42610538;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.1887179,-0.8344005,-0.6179725,-0.01468413,1156.357,178.29599)' id='g13428-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00443673;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13430-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.00443673;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13432-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00443673;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5949448,-0.6002887,0.5694516,-0.4854556,-6.8818963,592.21485)' id='g13434-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.72397423;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13436-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.72397423;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13438-5' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.72397423;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.6122539,-0.6273173,0.5413064,-0.3350423,6.2234616,537.20671)' id='g13440-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93102407;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13442-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.93102407;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13444-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93102407;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.2394166,-0.8562176,-0.8766131,-0.1288541,1342.3992,279.20705)' id='g13446-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.44712496;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13448-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.44712496;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13450-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.44712496;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.5023219,-0.7527747,0.610357,-0.2390198,33.380253,466.14431)' id='g13468-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.84159565;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13470-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.84159565;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13472-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.84159565;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.3791608,-0.8401911,-0.813416,-0.3008227,1392.1158,450.40441)' id='g13474-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.42235351;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13476-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.42235351;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13478-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.42235351;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.2813949,-0.4804287,-0.4804287,-0.2813949,1166.3515,646.91462)' id='g13452-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.88527322;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13454-5' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.88527322;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13456-5' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708289;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13458-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708277;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(-0.3673801,-0.418362,0.418362,-0.3673801,206.19155,738.10693)' id='g13460-5' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.88527274;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13462-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.88527274;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13464-6' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708265;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13466-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.30708265;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.5626148,-0.8431291,-0.6836172,-0.267709,1422.1156,483.04164)' id='g13480-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.53707433;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13482-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.53707433;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13484-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.53707433;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.4152512,-0.9201646,0.8908409,-0.3294565,-83.402015,470.62188)' id='g13486-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21182156;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13488-7' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.21182156;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13490-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21182156;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.3892046,-0.9406352,0.8210276,-0.2192935,-43.79711,448.95252)' id='g13492-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.33586049;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13494-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.33586049;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13496-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.33586049;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.6388382,-0.9262605,-0.9112106,-0.5389084,1583.5435,641.57676)' id='g13498-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.98443508;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13500-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.98443508;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13502-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.98443508;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.1262906,-0.9454318,0.7314131,0.05409885,105.2893,401.96935)' id='g13520-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61431813;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13522-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.61431813;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13524-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61431813;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.9303579,-0.7541605,-0.8080281,-0.7771551,1638.0954,995.52974)' id='g13526-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.8740406;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13528-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.8740406;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13530-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.8740406;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.8418401,-0.7879327,-0.7073185,-0.4638558,1557.7814,750.03765)' id='g13532-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.2219677;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13534-3' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.2219677;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13536-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.2219677;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.211981,-1.042379,0.9672414,-0.1382921,-51.806391,405.45688)' id='g13538-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.12370801;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13540-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.12370801;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13542-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.12370801;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.5038958,-0.3672631,-0.3672631,-0.5038958,1188.0468,1029.5482)' id='g13504-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.46928096;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13506-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.46928096;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13508-1' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713476;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13510-8' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713476;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(-0.1899081,-0.5939093,0.5939093,-0.1899081,159.45611,693.43989)' id='g13512-6' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.46928024;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -606.77601,630.47461 c 0,0 21.04973,-4.10126 38.04761,0.71297 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -19.49347,0.17033 -24.33861,3.72185 -16.90297,12.39002 -44.25083,14.97468 -44.25083,14.97468' id='path13514-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.46928024;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13516-3' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713452;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13518-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.16713452;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.9819508,-0.4324055,-0.4067155,-0.7955344,1406.7477,1236.6902)' id='g13560-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21122718;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13562-8' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.21122718;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13564-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.21122718;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(-0.01944838,-0.8631675,0.6280074,-0.02880219,197.18609,531.98185)' id='g13566-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93659878;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13568-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.93659878;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13570-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.93659878;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(1.1269885,-0.392778,-0.5430228,-0.8863561,1507.2123,1361.3348)' id='g13572-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.96476924;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13574-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.96476924;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13576-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.96476924;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.3993444,-0.7288053,0.8130674,0.5251965,279.79257,343.94694)' id='g13578-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.41507053;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13580-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.41507053;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13582-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.41507053;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.696387,-0.1776568,-0.1776568,-0.696387,1076.5,1401.2073)' id='g13544-1' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path13546-4' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13548-0' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260042;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13550-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260042;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.1340534,-0.7060782,0.7060782,0.1340534,173.51639,559.83585)' id='g13552-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path13554-1' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:3.00993133;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path13556-7' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260054;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path13558-8' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.01260042;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(1.2100873,-0.1517841,-0.1629134,-1.1274212,1290.461,1673.4615)' id='g13584-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.83546782;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13586-0' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.83546782;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13588-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.83546782;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.8253189,0.06338252,0.06338252,-0.8253189,868.37091,1695.9253)' id='g12835-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path12276-2' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path12278-8' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.8791877;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path12280-2' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.87918764;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3Cg transform='matrix(0.5652312,-0.665172,0.8314156,0.6288832,305.03571,356.51042)' id='g13590-8' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.26953363;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -609.04308,575.41643 c 2.99311,-5.86006 54.13479,-52.96927 100.6414,-49.43818 34.05111,2.58537 39.68441,11.19919 39.68441,11.19919 0,0 3.17444,8.86416 -27.05833,15.35842 -30.544,6.56111 -83.49439,28.4647 -113.26748,22.88057 z' id='path13592-9' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.26953363;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -470.39884,536.95567 c -36.55056,-4.34048 -73.7972,11.16414 -102.96184,22.85478' id='path13594-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.26953363;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.5034646,-0.6570327,0.6570327,0.5034646,285.79297,423.83359)' id='g12840-2' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -596.77336,640.69848 c 0,0 11.04708,-14.32513 28.04496,-9.5109 16.99788,4.81424 24.49823,11.71067 24.49823,11.71067 l 6.00717,-5.41925 c 0,0 -17.22327,-8.59807 -25.982,-11.11633 -8.75878,-2.51829 -11.05959,-2.88811 -11.05959,-2.88811 0,0 13.64839,-8.91018 20.17833,-9.80376 6.52992,-0.89359 16.1026,-1.7145 16.1026,-1.7145 l -0.89528,-6.5287 c 0,0 -18.62568,1.86414 -24.33861,3.72185 -5.71289,1.8577 -33.15682,21.45883 -33.15682,21.45883' id='path12842-6' style='fill:%23007934;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:2.61336493;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.9290795,0.5060742,-0.5060742,2.9290795,-1270.8633,-1207.7956)' id='path12844-6' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.8791877;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3Cpath d='m 358.19737,560.58832 a 6.296,4.2722856 0 1 1 -12.592,0 6.296,4.2722856 0 1 1 12.592,0 z' transform='matrix(2.4181614,1.7286162,-1.7286162,2.4181614,-414.22017,-1318.1522)' id='path12846-4' style='fill:%23000000;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.8791877;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(1.1428572,0,0,1.1428572,-139.28578,-99.630767)' id='g44719'%3E %3Cpath d='m 593.678,214.479 c 0,0 -8.426,19.153 -5.515,21.053 0,0 8.549,-14.868 16.052,-20.495 3.902,-3.602 6.274,0.031 6.777,-3.136 0.502,-3.167 -10.267,-7.711 -10.267,-7.711 l -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4673-8-4' style='fill:%23452c25' /%3E %3Cpath d='m 593.678,214.479 c 0,0 -8.426,19.153 -5.515,21.053 0,0 8.549,-14.868 16.052,-20.496 3.902,-3.601 6.274,0.032 6.777,-3.135 0.502,-3.168 -10.267,-7.711 -10.267,-7.711 l -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4675-9-6' style='fill:none;stroke:%23000000;stroke-width:0.58499998' /%3E %3Cpath d='m 562.943,229.062 c 0,0 -12.246,20.868 -9.035,21.113 3.211,0.246 16.305,-26.609 16.305,-26.609 l -4.464,0.748 -2.806,4.748 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4677-7-2' style='fill:%23452c25' /%3E %3Cpath d='m 562.943,229.062 c 0,0 -12.246,20.868 -9.035,21.113 3.211,0.246 16.305,-26.609 16.305,-26.609 l -4.464,0.748 -2.806,4.748 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4679-2-6' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 566.642,223.246 c 0,0 -12.8,20.532 -9.598,20.863 3.203,0.332 17.012,-26.163 17.012,-26.163 l -4.482,0.629 -2.932,4.671 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4681-2-1' style='fill:%23452c25' /%3E %3Cpath d='m 566.642,223.246 c 0,0 -12.8,20.532 -9.598,20.863 3.203,0.332 17.012,-26.163 17.012,-26.163 l -4.482,0.629 -2.932,4.671 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4683-0-6' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 569.231,219.674 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4685-8-2' style='fill:%23452c25' /%3E %3Cpath d='m 569.231,219.674 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4687-8-2' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 573.128,216.281 c 0,0 -17.065,17.151 -14.019,18.19 3.047,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4689-0-1' style='fill:%23452c25' /%3E %3Cpath d='m 573.128,216.281 c 0,0 -17.065,17.151 -14.019,18.19 3.047,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4691-05-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 573.737,210.044 c 0,0 -14.893,19.069 -11.743,19.736 3.15,0.667 19.674,-24.225 19.674,-24.225 l -4.523,0.153 -3.408,4.336 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4693-9-5' style='fill:%23452c25' /%3E %3Cpath d='m 573.737,210.044 c 0,0 -14.893,19.069 -11.743,19.736 3.15,0.667 19.674,-24.225 19.674,-24.225 l -4.523,0.153 -3.408,4.336 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4695-8-0' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 569.939,226.431 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4697-1-4' style='fill:%23452c25' /%3E %3Cpath d='m 569.939,226.431 c 0,0 -14.575,19.312 -11.414,19.928 3.16,0.615 19.27,-24.548 19.27,-24.548 l -4.521,0.228 -3.335,4.392 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4699-4-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.14,222.614 c 0,0 -8.532,15.721 -7.558,16.371 0.976,0.65 11.337,-8.965 16.457,-18.32 5.12,-9.355 -9.265,1.559 -9.265,1.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4701-4-7' style='fill:%23452c25' /%3E %3Cpath d='m 578.14,222.614 c 0,0 -8.532,15.721 -7.558,16.371 0.976,0.65 11.337,-8.965 16.457,-18.32 5.12,-9.355 -9.265,1.559 -9.265,1.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4703-6-0' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 579.054,221.054 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.57,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4709-0-4' style='fill:%23452c25' /%3E %3Cpath d='m 579.054,221.054 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.569,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4711-6-4' style='fill:none;stroke:%23000000;stroke-width:0.58499998' /%3E %3Cpath d='m 574.678,219.38 c 0,0 -17.066,17.151 -14.02,18.19 3.046,1.039 22.431,-21.698 22.431,-21.698 l -4.511,-0.39 -3.9,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4713-9-7' style='fill:%23452c25' /%3E %3Cpath d='m 574.678,219.38 c 0,0 -17.066,17.151 -14.02,18.19 3.046,1.039 22.431,-21.698 22.431,-21.698 l -4.511,-0.39 -3.9,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4715-5-1' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 576.034,221.704 c 0,0 -17.066,17.151 -14.02,18.19 3.048,1.039 22.431,-21.698 22.431,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4717-7-9' style='fill:%23452c25' /%3E %3Cpath d='m 576.034,221.704 c 0,0 -17.066,17.151 -14.02,18.19 3.048,1.039 22.431,-21.698 22.431,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4719-3-7' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 577.389,224.415 c 0,0 -17.065,17.151 -14.019,18.19 3.046,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4721-3-9' style='fill:%23452c25' /%3E %3Cpath d='m 577.389,224.415 c 0,0 -17.065,17.151 -14.019,18.19 3.046,1.039 22.43,-21.698 22.43,-21.698 l -4.51,-0.39 -3.901,3.898 z' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4723-4-6' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.665,200.869 c 0,0 -12.678,15.852 -10.851,18.58 1.829,2.729 13.41,-7.277 17.067,-14.292 3.657,-7.016 -6.095,-4.807 -6.095,-4.807' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4725-6-8' style='fill:%23452c25' /%3E %3Cpath d='m 578.665,200.869 c 0,0 -12.678,15.851 -10.851,18.58 1.829,2.729 13.41,-7.277 17.067,-14.292 3.657,-7.016 -6.095,-4.807 -6.095,-4.807' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4727-2-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.257,217.706 c 0,0 -10.867,20.358 -8.063,19.189 2.804,-1.17 13.82,-16.48 15.039,-19.858 1.22,-3.378 0.809,-6.908 0.809,-6.908 l -8.412,5.067 0.722,3.944' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4729-6-7' style='fill:%23452c25' /%3E %3Cpath d='m 578.257,217.706 c 0,0 -10.867,20.358 -8.063,19.189 2.804,-1.17 13.82,-16.48 15.039,-19.858 1.22,-3.378 0.809,-6.908 0.809,-6.908 l -8.412,5.067 0.722,3.944' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4731-0-2' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 578.333,211.01 c 0,0 9.018,-16.228 -0.063,3.056 -9.08,19.284 -12.477,16.1 -12.477,16.1 -0.7,-1.097 7.896,-14.163 7.896,-14.163 0,0 6.383,-10.054 7.913,-11.009' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4733-2-1' style='fill:%23452c25' /%3E %3Cpath d='m 578.333,211.01 c 0,0 9.018,-16.228 -0.063,3.056 -9.08,19.284 -12.477,16.1 -12.477,16.1 -0.7,-1.097 7.896,-14.163 7.896,-14.163 0,0 6.383,-10.054 7.913,-11.009' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4735-8-1' style='fill:none;stroke:%23000000;stroke-width:0.40400001' /%3E %3Cpath d='m 588.003,208.855 c 0,0 10.029,-16.116 -0.024,3.06 -10.054,19.176 -13.976,15.935 -13.976,15.935 -0.815,-1.111 8.783,-14.066 8.783,-14.066 0,0 7.122,-9.971 8.851,-10.905' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4737-7-0' style='fill:%23452c25' /%3E %3Cpath d='m 588.003,208.855 c 0,0 10.029,-16.116 -0.024,3.06 -10.054,19.176 -13.976,15.935 -13.976,15.935 -0.815,-1.111 8.783,-14.066 8.783,-14.066 0,0 7.122,-9.971 8.851,-10.905' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4739-6-4' style='fill:none;stroke:%23000000;stroke-width:0.43099999' /%3E %3Cpath d='m 584.324,202.053 c 0,0 -12.678,15.851 -10.851,18.58 1.829,2.729 13.41,-7.277 17.067,-14.292 3.657,-7.016 -6.095,-4.807 -6.095,-4.807' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4751-1-5' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:0.47299999' /%3E %3C/g%3E %3Cg transform='translate(125,-33.395283)' id='g6782'%3E %3Cpath d='m -237.59735,1162.174 a 577.60738,643.15145 0 1 1 -1155.21475,0 577.60738,643.15145 0 1 1 1155.21475,0 z' transform='matrix(0.69251195,0,0,0.69967968,1414.539,200.25672)' id='path4790-9' style='fill:%23e8a30e;fill-opacity:1;stroke:none' /%3E %3Cpath d='m 529.4688,1013.4062 c 0,-209.05218 147.0862,-369.49997 320.5312,-369.49997 173.4451,0 320.5312,160.44799 320.5312,369.49997' id='path15610' style='font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;text-indent:0;text-align:start;text-decoration:none;line-height:normal;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;text-anchor:start;baseline-shift:baseline;color:%23000000;fill:none;stroke:%23339900;stroke-width:10;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate;font-family:Sans;-inkscape-font-specification:Sans' /%3E %3Cpath d='m 450.5409,1036.9979 c 10.908,237.5606 185.5899,426.4063 399.4688,426.4063 213.8789,0 388.5294,-188.8457 399.4375,-426.4063 l -798.9063,0 z' id='path12214-3' style='fill:%23007934;fill-opacity:1;stroke:%23eeeeee;stroke-opacity:1' /%3E %3Cpath d='m -237.59735,1162.174 a 577.60738,643.15145 0 1 1 -1155.21475,0 577.60738,643.15145 0 1 1 1155.21475,0 z' transform='matrix(0.69251195,0,0,0.69967968,1414.539,200.2458)' id='path17689' style='fill:none;stroke:%23000000;stroke-width:6.4647131;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg id='g8764'%3E %3Cg transform='matrix(0.89888361,0,0,0.89888358,602.80714,256.31033)' id='g5967-9' style='stroke:%23000000;stroke-width:1.11249113;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline'%3E %3Cpath d='m 200.51045,493.62183 c -4.87234,19.05527 0.49825,34.74179 9.81055,49.52259 7.20095,11.4296 11.93227,23.60997 11.70717,36.69681 -3.27561,1.84709 -6.39917,3.83804 -9.41431,5.98055 l -75.25773,-49.98699 50.52421,74.42746 c -0.90775,1.25334 -1.79218,2.55604 -2.6437,3.84498 -14.3304,-6.45556 -27.78276,-7.73562 -40.60162,-5.25593 -18.12127,3.50537 -33.5061,-0.28984 -49.57122,-9.86467 10.02885,16.91938 24.99118,24.20993 42.02754,28.07677 13.20014,2.9961 25.13177,8.25359 34.23728,17.70263 -0.99077,3.56052 -1.80901,7.16179 -2.43119,10.81755 l -88.58352,17.96332 88.38381,16.90213 c 0.24293,1.5206 0.53565,3.03673 0.84614,4.55477 -14.70201,5.56253 -25.15478,14.14816 -32.46731,24.96838 -10.33501,15.29233 -23.82469,23.4913 -41.95485,28.08063 19.05525,4.87238 34.7155,-0.56169 49.4963,-9.87399 11.42962,-7.20093 23.60999,-11.93227 36.69679,-11.70717 1.84709,3.27561 3.83804,6.39917 5.98055,9.41431 l -49.9607,75.32119 74.46462,-50.61396 c 1.24367,0.90012 2.50286,1.82523 3.78154,2.66997 -6.45554,14.33042 -7.70935,27.84621 -5.22966,40.66507 3.50536,18.12131 -0.31606,33.4428 -9.89094,49.50781 16.91943,-10.02872 24.20999,-24.9911 28.07677,-42.02755 2.99611,-13.20017 8.2536,-25.13179 17.70263,-34.2373 3.56771,0.99361 7.15419,1.80769 10.81755,2.43118 l 17.96333,88.58357 16.90212,-88.38386 c 1.52061,-0.24289 3.03675,-0.5356 4.55481,-0.84612 5.55935,14.70641 14.15064,25.15647 24.96834,32.46735 15.29235,10.33498 23.49134,23.82472 28.08065,41.95481 4.8724,-19.05519 -0.56168,-34.71548 -9.87398,-49.49625 -7.21495,-11.45195 -11.8934,-23.59536 -11.64374,-36.72314 3.25417,-1.83772 6.35405,-3.82477 9.35087,-5.95426 l 75.32115,49.96073 -50.5505,-74.49092 c 0.88821,-1.22858 1.77239,-2.49258 2.60658,-3.75527 14.33447,6.4742 27.83963,7.7106 40.66504,5.22967 18.12124,-3.50552 33.44273,0.3162 49.50777,9.89095 -10.02881,-16.9194 -24.96486,-24.14651 -42.00126,-28.01333 -13.1853,-2.99271 -25.10336,-8.35144 -34.20009,-17.79237 0.98835,-3.55441 1.74665,-7.14197 2.36772,-10.79126 l 88.60983,-17.89987 -88.41012,-16.96558 c -0.24291,-1.5206 -0.53564,-3.03673 -0.84614,-4.55481 14.71551,-5.55738 25.15375,-14.14668 32.46733,-24.96832 10.33498,-15.29234 23.851,-23.4279 41.9811,-28.01719 -19.05525,-4.87238 -34.74178,0.49821 -49.52254,9.8105 -11.45183,7.21495 -23.59528,11.89343 -36.72307,11.64375 -1.83777,-3.25416 -3.82482,-6.35404 -5.95429,-9.35085 l 49.98699,-75.25775 -74.51718,50.48707 c -1.2286,-0.8882 -2.49256,-1.77236 -3.75525,-2.60655 6.4655,-14.32627 7.73561,-27.78279 5.2559,-40.60162 -3.50542,-18.1213 0.28989,-33.50614 9.8647,-49.57122 -16.91939,10.02883 -24.14653,24.96487 -28.01334,42.00124 -2.99946,13.21496 -8.34866,25.18536 -17.8295,34.28984 -3.54355,-0.98412 -7.11638,-1.83833 -10.75411,-2.45745 l -17.89992,-88.60981 -16.96558,88.41009 c -1.52058,0.24292 -3.03671,0.53563 -4.55477,0.84615 -5.56153,-14.70591 -14.14651,-25.15362 -24.96836,-32.46732 -15.29233,-10.33502 -23.42787,-23.85096 -28.01719,-41.98114 z' id='path5969-6' style='fill:%23d52b1e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.6687367;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible' /%3E %3Cg transform='matrix(1.9336856,0,0,1.9336856,395.15964,685.49999)' id='g5971-3' style='stroke:none'%3E %3Cuse transform='matrix(0.9238795,0.3826834,-0.3826834,0.9238795,35.714286,-47.857143)' id='use5973-7' style='fill:%23fcbf49;stroke:none' x='0' y='0' width='330' height='330' /%3E %3Cuse transform='matrix(-1,0,0,1,35.714286,-47.857143)' id='use5975-0' style='fill:%23fcbf49;stroke:none' x='0' y='0' width='330' height='330' /%3E %3Cg id='g5977-4' style='fill:%23000000;stroke:none'%3E %3Cg transform='translate(-30.709165,2.1386886)' id='g5979-0' style='fill:%23000000;stroke:none'%3E %3Cpath d='m 9.571429,-21.857143 c -11.5,-10 -26,-11.5 -34,-4 -5.806373,7.76306 -5.288976,16.9037284 1.5,26.5 -0.5,0 -1.5,0.5 -2,1 -5.042555,-9.6028165 -5.909949,-19.491103 -2.5,-28.5 11,-9 26,-10 37,5' id='path5981-7' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -8.428571,-24.857143 c -6.5,0 -8,1.5 -11,4 -3,2.5 -4.5,2 -5,2.5 -0.5,0.5 0,2 1,1.5 1,-0.5 3,-1.5 6,-4 3,-2.5 6,-2.5 9,-2.5 9,0 14,7.5 15,7 1,-0.5 -5,-8.5 -15,-8.5' id='path5983-6' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.071429,-16.357143 c -6.5,-7 -18.5,-7.5 -23.5,0.5 l 2,0 c 5,-8 17,-4.5 18,-1 l 0,1' id='path5985-3' style='fill:%23000000;stroke:none' /%3E %3Ccircle cx='22' cy='-9' r='4.5' transform='translate(-31.428571,-7.857143)' id='circle5987-9' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.428571,-15.857143 c 5,4.5 16,5 23.5,-0.5 l -3.5,-0.5 c -5,5.5 -13,5 -18,1 l 0,-1' id='path5989-6' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.571429,-13.857143 c -8.5,6.5 -17,6 -22,3 -5,-3 -5,-4 -4,-4 1,0 2,1 6,3 4,2 10,2 20,-2' id='path5991-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.928571,1.142857 c 1.41609,0.5034893 2.241084,1.977139 1.930035,3.447534 -0.311049,1.470394 -1.66214,2.483712 -3.160813,2.370609 -1.498672,-0.113103 -2.682377,-1.31772 -2.769222,-2.818143 -0.5,1 -2.5,4 -6.5,4 l -1,0 1,1.5 c 1,0 4,0 6,-1.5 1.163388,1.669092 3.301964,2.349966 5.216194,1.660715 1.91423,-0.68925 3.127878,-2.577147 2.960205,-4.604763 -0.167673,-2.027616 -1.674951,-3.6905072 -3.676399,-4.055952' id='path5993-8' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -4.5,-3 -6.5,-7.5 -11.5,-7.5 -1,0 -3,0.5 -5,1.5 l -1,0 1,1.5 c 2,0 5,-2.5 8.5,-0.5 3.5,2 5.5,4 8,5' id='path5995-5' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -16.428571,22.142857 c -10,-3 -12,-1 -15,-1 l -1,0 1,2 c 4,0 6,-3 15,-1' id='path5997-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -11,-1 -7.5,5.5 -16.5,5.5 l -1,0 1,1.5 c 11,0 6,-6 16.5,-7' id='path5999-5' style='fill:%23000000;stroke:none' /%3E %3C/g%3E %3Cg transform='matrix(-1,0,0,1,-93.571428,2.1386886)' id='g6001-5' style='fill:%23000000;stroke:none'%3E %3Cpath d='m 9.571429,-21.857143 c -11.5,-10 -26,-11.5 -34,-4 -5.806373,7.76306 -5.288976,16.9037284 1.5,26.5 -0.5,0 -1.5,0.5 -2,1 -5.042555,-9.6028165 -5.909949,-19.491103 -2.5,-28.5 11,-9 26,-10 37,5' id='path6003-0' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -8.428571,-24.857143 c -6.5,0 -8,1.5 -11,4 -3,2.5 -4.5,2 -5,2.5 -0.5,0.5 0,2 1,1.5 1,-0.5 3,-1.5 6,-4 3,-2.5 6,-2.5 9,-2.5 9,0 14,7.5 15,7 1,-0.5 -5,-8.5 -15,-8.5' id='path6005-0' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.071429,-16.357143 c -6.5,-7 -18.5,-7.5 -23.5,0.5 l 2,0 c 5,-8 17,-4.5 18,-1 l 0,1' id='path6007-8' style='fill:%23000000;stroke:none' /%3E %3Ccircle cx='22' cy='-9' r='4.5' transform='translate(-31.428571,-7.857143)' id='circle6009-7' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.428571,-15.857143 c 5,4.5 16,5 23.5,-0.5 l -3.5,-0.5 c -5,5.5 -13,5 -18,1 l 0,-1' id='path6011-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m 3.571429,-13.857143 c -8.5,6.5 -17,6 -22,3 -5,-3 -5,-4 -4,-4 1,0 2,1 6,3 4,2 10,2 20,-2' id='path6013-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -20.928571,1.142857 c 1.41609,0.5034893 2.241084,1.977139 1.930035,3.447534 -0.311049,1.470394 -1.66214,2.483712 -3.160813,2.370609 -1.498672,-0.113103 -2.682377,-1.31772 -2.769222,-2.818143 -0.5,1 -2.5,4 -6.5,4 l -1,0 1,1.5 c 1,0 4,0 6,-1.5 1.163388,1.669092 3.301964,2.349966 5.216194,1.660715 1.91423,-0.68925 3.127878,-2.577147 2.960205,-4.604763 -0.167673,-2.027616 -1.674951,-3.6905072 -3.676399,-4.055952' id='path6015-4' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -4.5,-3 -6.5,-7.5 -11.5,-7.5 -1,0 -3,0.5 -5,1.5 l -1,0 1,1.5 c 2,0 5,-2.5 8.5,-0.5 3.5,2 5.5,4 8,5' id='path6017-8' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -16.428571,22.142857 c -10,-3 -12,-1 -15,-1 l -1,0 1,2 c 4,0 6,-3 15,-1' id='path6019-3' style='fill:%23000000;stroke:none' /%3E %3Cpath d='m -14.928571,22.142857 c -11,-1 -7.5,5.5 -16.5,5.5 l -1,0 1,1.5 c 11,0 6,-6 16.5,-7' id='path6021-3' style='fill:%23000000;stroke:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(1.4408391,0.04809649,-0.05005259,1.4994388,-465.07439,-459.79661)' id='g3889-3-4' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 975.07733,1010.8917 c 13.5931,1.2193 27.74127,0.3631 39.85067,-3.6975 11.0594,-4.0995 23.1706,-6.9927 35.2798,-6.1883 0,-1.62187 3.5211,-2.88048 1.4822,-4.09979 -4.5094,-2.47791 -10.0706,-2.02361 -15.6305,-4.51462 -9.0837,-3.69752 -14.5816,-10.3266 -23.6637,-14.89305 -0.9887,-0.35047 -5.0045,-2.43924 -5.0045,-4.51493 19.6627,25.3455 63.5281,10.66947 101.3888,6.59047 3.522,0.81693 12.6042,-2.02374 20.141,-4.51478 9.0839,-3.28227 31.2598,-1.63943 36.8209,-5.38858 0.9267,-0.35026 -9.5728,-6.15742 -11.6115,-7.83116 -5.4998,-6.18309 -19.1529,-4.91565 -26.1962,-11.55553 -11.0606,-11.14801 -27.6799,-14.03708 -41.3963,-23.15838 -3.027,-1.62188 -9.0837,-0.88727 -13.593,-1.74887 -5.6619,-4.29036 -0.2829,-4.31778 -43.5042,-36.27097 -38.61337,-13.84343 -36.76217,-25.3551 -60.71157,-33.35815 -8.5257,-3.69741 -16.439,-10.54914 -23.4824,-8.46023 -12.6027,3.69741 -39.7038,18.11997 -51.8136,25.57588 -10.0709,6.18312 -22.5883,17.11553 -31.1755,24.16012 -2.2553,1.84923 -28.3101,24.55521 -58.1313,41.56176 -29.8212,17.00619 -73.024,40.38254 -76.7934,40.78811 68.4386,-5.49026 -60.6493,20.6457 247.7443,31.5185 z' id='path430-1-0' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-linecap:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 804.22467,940.41498 c 17.044,-9.61464 82.2656,-46.69393 102.0215,-71.93545 -2.8046,0.2723 5.8496,7.46703 5.2708,10.52825 6.4281,-0.42918 2.8896,-7.03656 8.2324,-7.46594 4.1175,0 7.0769,-1.71862 10.6156,-3.06231 4.1173,-0.85956 1.7343,1.71891 1.7343,3.06231 -5.273,10.09917 -17.0438,16.2228 -26.5039,24.11902 1.1553,0.85925 2.3109,1.71891 1.7341,3.06102 3.4644,0.3769 7.5815,0.3769 9.9647,-1.71901 0.5785,-0.42908 0.5785,-1.77258 0.5785,-2.63194 3.5387,1.28993 2.3114,3.92196 1.156,5.69435 -2.3113,5.26428 -12.3501,4.78024 -15.3116,9.61513 -3.4666,5.2106 -7.0052,9.61513 -12.3481,13.59086 4.1155,-3.49169 8.8094,-7.89632 14.1542,-8.32658 8.2325,-0.85976 11.1942,-6.12374 18.2716,-7.84265 7.6534,-1.71881 12.348,-7.89612 18.2713,-12.73111 -2.311,3.4916 -7.0788,6.55391 -5.2731,10.52974 0.5788,0.42889 2.48005,1.67953 4.86325,0.7662 -5.2731,7.03686 -16.05725,12.34042 -19.59585,20.66671 -3.5383,-1.28973 -5.8493,1.28864 -8.2324,1.71911 -3.4663,1.28844 -2.311,6.55252 -4.694,8.3251 -9.9668,5.69445 -14.733,14.93426 -18.8483,22.77688 -0.5788,0.85945 -8.2327,5.25974 -11.1945,6.12619 -5.2726,2.20019 -37.9068,28.14724 -38.4835,24.65427 -3.4664,-16.64765 -36.2688,14.65617 -112.7448,-8.99578' id='path436-3-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 985.94905,971.96173 c -0.5768,-0.64732 -1.7322,-0.96611 -1.7322,-1.2845 1.1554,-2.60989 -4.1172,-2.93862 -4.1172,-5.58317 8.8112,0 15.8882,9.46711 21.23125,3.5691 1.1574,-1.32508 -2.31115,-3.24873 2.8896,-4.89349 1.1554,-0.28185 -1.1554,-1.2846 -0.5787,-1.96669 -2.8876,0 -5.27095,0.32056 -7.07685,-0.28156 -2.3111,-0.6422 -3.5386,-1.28411 -6.4265,-1.9665 -2.8895,-0.6424 -4.1171,-3.57166 0,-4.57519 7.6539,-1.32479 15.88815,3.57235 21.80995,0.64191 4.6941,-2.28716 9.3881,-2.92916 14.0821,-4.5749 2.3111,-0.6427 10.0387,-0.28097 7.654,1.92621 -1.7325,1.3243 -5.8498,0.96375 -8.2328,1.60596 -4.1152,1.2843 -7.6538,3.2509 -11.7713,4.89585 2.8899,-0.32056 2.3113,2.93005 5.8498,1.96659 5.2726,-1.60496 10.6157,-3.57166 16.4651,-4.25394 -0.5768,-1.28402 1.1574,-2.28794 1.1574,-3.61263 0.5766,0 1.1535,0 1.7321,0 -2.8895,-3.89261 5.2727,-2.24688 8.2329,-5.53904 0,0.6422 0.5064,0.6422 1.1555,0.96384 -4.1157,1.60487 -2.3112,4.21367 -3.4664,6.22133 -0.5773,0.6423 -2.3112,0.96286 -1.7326,1.9665 2.3109,1.60516 2.3109,-1.28402 4.1154,-0.64221 1.7339,0.32076 4.1172,0.96287 5.2726,0.64221 2.8878,0 5.8494,-1.28402 4.0434,-3.61263 -2.3111,-1.92622 -4.6941,-3.57235 -4.6941,-6.18115 0,-0.32075 -0.5768,-0.6421 -1.7322,-0.96286 4.694,0 8.2323,1.32429 9.9649,3.2514 2.3109,1.96639 2.8895,4.89674 6.5002,5.57873 7.0047,0.96286 6.426,-2.28795 6.426,-5.57873 5.2731,0.32026 12.9287,2.28676 11.7731,4.89674 -0.5064,1.92631 -4.6938,3.57126 -8.8112,3.93289 -2.8877,0.28077 -1.1555,2.28725 -2.8877,2.60909 -3.4665,0 -7.6558,0.64211 -8.8111,1.9664 -1.1554,1.96659 0.5767,5.86384 2.8876,7.17917 3.4666,1.61294 10.5453,-0.63719 15.8883,0 0.507,-2.92838 4.1176,-3.88415 7.0771,-5.89467 3.4666,-1.92661 -1.732,-3.57274 -4.6939,-4.89703 -2.3109,-0.6423 -0.5768,-1.2847 0.5785,-2.92956 1.7327,-1.92641 7.077,-0.32144 7.6541,-1.92641 1.1557,-1.9662 -1.1555,-4.89694 1.1557,-6.22142 1.7338,-1.28412 4.117,0.96296 3.466,2.60879 2.3109,-0.28038 2.8898,-1.60575 5.2726,-1.92631 2.8877,-0.32076 4.6941,1.92631 3.4668,2.6087 -3.4668,2.28814 -6.4285,3.8933 -5.2727,7.18409 0,1.64584 -4.1151,2.28824 -2.311,3.61243 3.4663,2.28725 3.4663,4.57559 4.694,7.18557 1.1554,2.92827 7.6558,3.5755 13.5052,2.29109 -2.3108,-5.5483 11.1944,-3.25701 17.1161,-4.90107 0.5048,0 0.5048,-0.96611 0,-1.28411 -2.8899,-1.60497 -3.4665,-2.24855 -2.8899,-4.57569 0,-0.28136 -1.0834,-0.96355 -1.7324,-1.28431 8.8115,2.6088 24.4051,6.07162 30.9053,10.97082 -8.2324,1.60299 -23.828,-1.49445 -32.0606,0.4683 -9.9668,2.60959 -20.0036,5.85665 -30.6934,5.85665 -4.6938,0 -9.3879,-1.92169 -14.0817,-1.92169 m -94.96605,-2.60968 c 1.1557,0.27772 -2.8875,-0.31859 -3.466,-0.64733' id='path3090-0-9' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 957.98778,1017.3317 c 16.3473,-1.4162 19.3362,10.7217 29.6969,-0.3029 9.8693,1.416 18.84692,-2.0308 18.93532,-3.3913 23.0216,3.865 93.8065,-4.7323 88.9484,-9.4034 -7.598,-7.8077 -19.6047,-10.45549 -29.2273,-17.05588 -2.1406,-1.20011 -6.5436,-1.74127 -9.7984,-2.51041 -5.4327,-1.40475 -12.5427,0.0207 -17.2025,-2.13681 -7.4997,-3.73439 -15.442,-6.92921 -22.1491,-11.71445 -4.2164,-2.69672 -5.782,-7.16219 -10.413,-10.45084 -4.9488,-3.27578 -11.93872,-3.71051 -16.97382,-5.65767 -7.5713,-2.63821 -11.9273,-9.44476 -19.0401,-14.25409 -2.4668,-1.75807 -6.5607,-1.47493 -9.4036,-3.0176 -6.0646,-2.81004 -10.8625,-9.11816 -16.0922,-8.06906 -9.3563,1.8508 -14.648,9.41747 -23.8039,13.75412 -7.6138,3.59479 -10.9693,9.92129 -17.5372,14.14815 -1.725,1.1096 -21.7093,14.80664 -44.1992,24.59757 -22.4904,9.79095 -52.0176,21.71717 -54.7859,21.81167 0,0 20.6388,13.5979 67.4596,10.1829 l 28.9783,7.9584 15.9335,-3.2244 c 0,0 39.9076,-1.3118 40.6742,-1.264 z' id='path1871-3-7' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 860.34546,985.45434 c 10.3637,-5.19291 50.0212,-25.21684 61.9951,-38.7709 -1.7087,0.15427 3.5866,3.97284 3.2418,5.61127 3.9175,-0.24964 1.7422,-3.7704 4.9982,-4.01671 2.5097,-0.0129 4.3091,-0.9407 6.4631,-1.66998 2.5076,-0.47253 1.0617,0.9133 1.0654,1.63134 -3.187,5.41486 -10.3455,8.72505 -16.0907,12.9753 0.7064,0.45586 1.4135,0.91182 1.0651,1.63087 2.1132,0.19055 4.6229,0.17767 6.0699,-0.95011 0.3516,-0.2312 0.348,-0.94916 0.3456,-1.40857 2.1609,0.67835 1.4196,2.08902 0.7201,3.04032 -1.3945,2.82106 -7.5154,2.59385 -9.3077,5.18742 -2.0989,2.79587 -4.244,5.16129 -7.4902,7.30328 2.4994,-1.87918 5.3487,-4.24822 8.6058,-4.49517 5.016,-0.48515 6.8071,-3.30832 11.1167,-4.24893 4.6611,-0.94281 7.5057,-4.25952 11.1033,-6.86258 -1.3993,1.87348 -4.2973,3.52546 -3.1855,5.64486 0.354,0.22757 1.7689,1.39779 3.2189,0.90232 -3.1949,3.77782 -10.0069,6.13871 -12.1414,10.60045 -2.1605,-0.67851 -3.5622,0.70708 -5.0138,0.94438 -2.1095,0.69985 -1.3909,3.50993 -2.8384,4.465 -6.0603,3.07477 -8.9404,8.02892 -11.4274,12.23353 -0.3508,0.46139 -5.0045,2.83767 -6.8076,3.30989 -3.2083,1.19258 -23.0308,15.16388 -23.3923,13.29888 -2.1585,-8.8878 -21.3998,4.9511 -68.0841,-7.4528' id='path3088-3-3' style='fill:%23007934;fill-opacity:1;stroke:%23000000;stroke-width:1.01994634;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 850,563.40623 c -220.9139,0 -400,201.47189 -400,449.99997 0,248.5282 179.0861,450 400,450 220.9139,0 400,-201.4718 400,-450 0,-248.52808 -179.0861,-449.99997 -400,-449.99997 z m 0,100.5 c 161.0463,0 300.5312,149.75879 300.5312,349.49997 0,199.7413 -139.4849,349.4688 -300.5312,349.4688 -161.0463,0 -300.5312,-149.7274 -300.5312,-349.4688 0,-199.74108 139.4849,-349.49997 300.5312,-349.49997 z' id='path4014-9' style='font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;text-indent:0;text-align:start;text-decoration:none;line-height:normal;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;text-anchor:start;baseline-shift:baseline;color:%23000000;fill:%2300a6de;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate;font-family:Sans;-inkscape-font-specification:Sans' /%3E %3Cg transform='matrix(0.43572985,0,0,0.35330032,849.27131,1196.2863)' id='1-5-2-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;display:inline'%3E %3Cpath d='m 133.86614,24.413387 c 0.1063,6.944882 -1.98425,7.192913 -12.54331,8.964567 -10.34645,1.73622 -12.3307,1.771653 -12.47244,-4.818898 -0.1063,-6.944882 2.19685,-7.228347 12.54331,-8.964567 9.77953,-1.629922 12.33071,-2.480315 12.47244,4.818898 z' id='2-8-89-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 136.09842,24.023623 c 0.14174,4.358268 -6.62598,5.42126 -14.74015,6.767717 -8.14961,1.346456 -14.563,2.267716 -14.70473,-1.84252 -0.17716,-4.358268 6.59055,-5.42126 14.74016,-6.767717 8.11417,-1.346457 14.52756,-2.692913 14.70472,1.84252 z' id='3-1-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 56.905511,333.88584 C 79.15748,260.46851 85.003936,205.01575 53.149606,126.3189 106.01575,64.098427 144.81496,85.677168 179.85827,129.86221 c -33.34252,77.70473 -24.62599,133.08662 -5.563,204.55512 -41.45669,27.03544 -77.562987,26.25591 -117.389759,-0.53149 z' id='4-2-9-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 115.33464,87.625987 c -1.09842,0.03543 -2.19685,0.07087 -3.29527,0.177165 3.68504,89.255908 0.56693,177.803158 -0.0709,266.421268 1.45276,0.0709 2.94095,0.1063 4.3937,0.1063 -0.24803,-89.18504 3.93307,-175.53544 -0.81496,-266.704733 -0.0709,0 -0.14173,0 -0.2126,0 z' id='5-5-9-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 125.3622,88.547247 c -9.35433,81.248033 -12.82677,163.346463 -10.55905,265.783473 1.27559,0 2.58661,0 3.8622,-0.0354 -0.53149,-101.09056 2.33859,-183.25985 10.34646,-264.862216 -1.20472,-0.318898 -2.44488,-0.637796 -3.64961,-0.885827 z' id='6-7-9-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 143.29134,3.5787403 c -9.38977,12.7559057 -14.56299,12.6496067 -9.8504,32.4212607 10.38189,-8.716536 10.09843,-15.944882 9.8504,-32.4212607 z' id='7-4-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 122.45669,12.118111 c 6.12992,7.972441 15.09449,12.11811 9.38977,33.625985 -11.19685,-11.940945 -9.7441,-13.14567 -9.38977,-33.625985 z' id='8-4-2-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 120.54331,34.086615 c 8.11417,7.26378 15.55511,8.787402 9.99212,27.531497 -7.12205,-10.488189 -10.20472,-9.602362 -9.99212,-27.531497 z' id='9-4-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 118.31102,45.779529 c 6.16536,7.830709 15.12992,11.905512 9.46063,32.952757 -11.19685,-11.692914 -9.74409,-12.862205 -9.46063,-32.952757 z' id='10-4-8-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 114.73228,62.822837 C 121.9252,70.511813 132.34252,74.622049 125.96457,94.9252 113.52756,81.992128 119.65748,78.980317 114.73228,62.822837 z' id='11-4-7-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 113.35039,80.043309 c 6.73229,7.440946 17.36221,11.799213 11.33859,31.429131 -9.60237,-10.84252 -10.84252,-12.543303 -11.33859,-31.429131 z' id='12-2-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.49212,21.543308 c -4.88976,5.031496 -16.15748,4.535433 -16.61811,26.007875 13.88977,-9.850394 13.74804,-7.972442 16.61811,-26.007875 z' id='13-9-7-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.74803,36.814962 c -5.20866,4.641732 -17.2559,4.074803 -17.64567,24.200788 14.81102,-9.070867 14.66929,-7.299213 17.64567,-24.200788 z' id='14-3-3-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 146.97638,50.63386 c -5.38583,5.031496 -17.85827,4.429134 -18.28347,26.149607 15.34252,-9.814961 15.16536,-7.937008 18.28347,-26.149607 z' id='15-0-0-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 146.05512,69.625986 c -5.66929,2.586615 -18.92126,-2.551181 -19.02756,24.377954 11.33858,-3.720473 10.55905,-11.905512 19.02756,-24.377954 z' id='16-7-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 139.74803,86.031499 c -7.90157,4.074803 -12.36614,3.259842 -13.8189,24.909451 11.44488,-9.5315 11.30315,-7.75984 13.8189,-24.909451 z' id='17-7-6-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 148.42913,98.787405 C 128.44488,169.40552 124.22835,236.26772 126.2126,353.65749 c 1.62992,-0.2126 3.22441,-0.46063 4.85433,-0.74409 -0.99213,-116.39764 2.62205,-180.81497 20.97638,-251.53938 -1.20473,-0.92126 -2.40945,-1.771655 -3.61418,-2.586615 z' id='18-8-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 181.02756,20.976379 c -11.40945,9.956693 -16.44095,8.503937 -15.23622,28.984252 11.69291,-5.740157 12.6496,-12.862205 15.23622,-28.984252 z' id='19-7-2-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 159.09449,23.846457 c 4.67716,9.389764 12.7559,15.732284 3.47244,35.185041 -8.92914,-14.52756 -7.29921,-15.34252 -3.47244,-35.185041 z' id='20-3-1-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 153.46063,44.716537 c 6.73228,9.177165 13.74803,12.614173 5.06693,29.444883 -5.17323,-12.118111 -8.36221,-12.047245 -5.06693,-29.444883 z' id='21-0-9-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.27953,55.523624 c 4.67716,9.248031 12.79133,15.555118 3.57874,34.547245 -8.96457,-14.314961 -7.33465,-15.094489 -3.57874,-34.547245 z' id='22-3-1-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 142.79527,71.149608 c 5.74016,9.389764 15.27166,16.122048 5.52756,34.192912 -9.99212,-15.83858 -3.437,-17.149604 -5.52756,-34.192912 z' id='23-8-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 138.47244,87.555121 c 5.38583,9 15.02362,16.051179 5.74016,33.590549 -7.54725,-13.11023 -8.46851,-15.09449 -5.74016,-33.590549 z' id='24-2-0-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 184.03937,40.110237 c -5.66929,3.614174 -16.65354,0.177166 -20.79921,20.940946 15.30708,-5.917323 14.84645,-4.145669 20.79921,-20.940946 z' id='25-5-3-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 180.67323,54.779529 c -5.91733,3.153544 -17.64567,-0.602362 -21.47244,18.921261 16.08661,-4.925197 15.62598,-3.295276 21.47244,-18.921261 z' id='26-2-3-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 176.56299,67.748034 c -6.16535,3.472441 -18.28346,-0.354331 -22.46457,20.65748 16.75985,-5.527559 16.26378,-3.755905 22.46457,-20.65748 z' id='27-0-6-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 172.38189,85.996066 c -6.02362,1.027559 -18.1063,-7.440946 -22.85433,18.744094 11.76378,-0.67323 12.40157,-8.822834 22.85433,-18.744094 z' id='28-3-2-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 163.34646,100.31103 c -8.43308,1.87795 -12.68504,-0.0709 -17.82284,20.58661 12.89764,-6.23622 12.43701,-4.57086 17.82284,-20.58661 z' id='29-7-2-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 167.17323,115.15748 c -25.97244,64.20473 -31.5,122.9882 -18.56693,232.68899 1.87795,-0.70866 3.79134,-1.52363 5.70472,-2.37402 -12.8622,-104.74016 -7.79527,-163.38189 16.05118,-226.87796 -1.06299,-1.20472 -2.12598,-2.33858 -3.18897,-3.43701 z' id='30-2-1-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 210.50787,38.338584 c -12.40157,8.007874 -17.2559,5.775591 -18.2126,26.220473 12.22441,-3.826772 13.96063,-10.700788 18.2126,-26.220473 z' id='31-9-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 188.39764,37.629922 c 3.6496,10.02756 11.01968,17.64567 -0.24804,35.362206 -7.37007,-15.80315 -5.66929,-16.334646 0.24804,-35.362206 z' id='32-7-3-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 180.60236,57.401577 c 5.70473,10.169291 12.33071,14.669291 1.94882,29.905512 C 178.68898,74.51575 175.5,74.090553 180.60236,57.401577 z' id='33-5-2-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 175.2874,67.429136 c 3.72047,9.885827 11.09055,17.433071 -0.0354,34.724414 -7.40551,-15.590555 -5.70473,-16.086618 0.0354,-34.724414 z' id='34-3-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 167.24409,81.850396 c 4.7126,10.204725 13.46457,18.354334 1.87796,34.688974 -8.25591,-17.255902 -1.59449,-17.539367 -1.87796,-34.688974 z' id='35-4-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 161.22047,97.370082 c 4.3937,9.779528 13.25197,18.283468 2.16142,34.122048 -6.09449,-14.1378 -6.80315,-16.26378 -2.16142,-34.122048 z' id='36-3-5-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 211.46457,57.755907 c -5.98819,2.622048 -16.54725,-2.515748 -22.85434,17.362205 15.83859,-3.401574 15.20079,-1.73622 22.85434,-17.362205 z' id='37-2-4-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 206.61023,71.716538 c -6.20078,2.161417 -17.50393,-3.401575 -23.35039,15.23622 16.51181,-2.267716 15.90945,-0.708661 23.35039,-15.23622 z' id='38-1-96-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 201.15354,83.870081 c -6.48425,2.444882 -18.14173,-3.295275 -24.48425,16.830709 17.22047,-2.799212 16.54724,-1.098425 24.48425,-16.830709 z' id='39-1-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 195.09449,101.23229 c -6.09449,0.0709 -17.22048,-10.240161 -24.69685,14.88189 11.76378,1.24015 13.25196,-6.73229 24.69685,-14.88189 z' id='40-3-8-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 184.6063,113.95276 c -8.61024,0.5315 -12.61418,-2.05512 -19.87795,17.53937 13.46456,-4.14567 12.82677,-2.51575 19.87795,-17.53937 z' id='41-2-2-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 101.37402,89.85827 c -1.1693,0.354331 -2.374021,0.779528 -3.578745,1.204725 8.574805,81.283465 14.066925,163.346465 13.003935,263.090555 1.09843,0.0709 2.19685,0.14174 3.29528,0.14174 2.83464,-101.76379 -2.94095,-183.33072 -12.72047,-264.43702 z' id='42-5-7-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 83.338582,1.9133859 C 92.65748,15.165355 97.830708,15.34252 93.01181,34.901576 82.665354,25.582678 82.984251,18.354331 83.338582,1.9133859 z' id='43-3-4-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 104.13779,11.586615 C 97.937007,19.240158 88.937007,22.889764 94.535432,44.716537 105.76772,33.413387 104.35039,32.102363 104.13779,11.586615 z' id='44-5-0-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 105.90945,33.661418 C 97.724409,40.464568 90.283464,41.598426 95.740157,60.661419 102.93307,50.527561 105.98031,51.625986 105.90945,33.661418 z' id='45-1-7-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 108.07087,45.496064 C 101.87008,53.007876 92.870078,56.551183 98.397637,77.917325 109.70079,66.862207 108.24803,65.586616 108.07087,45.496064 z' id='46-2-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 111.54331,62.716537 c -7.22835,7.334646 -17.681106,10.84252 -11.40945,31.500001 12.50787,-12.22441 6.37795,-15.590551 11.40945,-31.500001 z' id='47-2-01-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 112.8189,80.043309 c -6.80315,7.051182 -17.433074,10.807087 -11.51575,30.791341 9.63779,-10.34646 10.87795,-11.976379 11.51575,-30.791341 z' id='48-2-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.031496,19.523623 c 4.85433,5.279527 16.122047,5.456693 16.476377,26.929134 C 79.653543,35.822836 79.795275,37.700789 77.031496,19.523623 z' id='49-6-9-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.669291,34.83071 c 5.173228,4.925197 17.255905,5.031496 17.503937,25.157481 C 80.397637,50.137797 80.574803,51.874017 77.669291,34.83071 z' id='50-4-3-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 79.370078,48.720474 C 84.720472,54.070868 97.192913,54.177167 97.51181,75.933073 82.240157,65.232285 82.381889,67.110238 79.370078,48.720474 z' id='51-0-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 80.185039,67.783467 C 85.85433,70.688978 99.106298,66.295278 99.070865,93.224412 87.732283,88.866144 88.582677,80.716538 80.185039,67.783467 z' id='52-7-5-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 86.385826,84.54331 c 7.901575,4.5 12.330709,3.968504 13.677164,25.65354 C 88.653543,100.063 88.795275,101.83465 86.385826,84.54331 z' id='53-0-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 79.370078,101.19685 c -1.169291,0.8504 -2.338582,1.77166 -3.543307,2.72835 18.496063,70.12205 25.299209,134.96457 23.669291,248.7756 1.417328,0.28346 2.870078,0.53149 4.287398,0.74409 C 106.40551,238.32284 99.318897,171.4252 79.370078,101.19685 z' id='54-3-5-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 45.496063,17.220473 C 56.870078,27.779528 61.901574,26.610237 60.590551,47.05512 48.933071,40.6063 47.976378,33.44882 45.496063,17.220473 z' id='55-4-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 67.429133,21.259843 C 62.716535,30.401576 54.566929,36.318899 63.744094,56.267718 72.779527,42.236222 71.149606,41.350395 67.429133,21.259843 z' id='56-0-6-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 72.921259,42.44882 C 66.153543,51.271655 59.102362,54.318899 67.677165,71.610238 72.921259,59.811025 76.110236,60.059057 72.921259,42.44882 z' id='57-0-8-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.066929,53.503939 c -4.748032,9 -12.897638,14.846457 -3.826772,34.334646 9.070866,-13.818898 7.440945,-14.669291 3.826772,-34.334646 z' id='58-5-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 83.409448,69.484254 C 77.633858,78.55512 68.066929,84.755908 77.704724,103.35827 87.767716,88.086617 81.248031,86.421262 83.409448,69.484254 z' id='59-3-9-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 87.625984,86.137798 c -5.385827,8.716536 -15.094488,15.200792 -5.917323,33.236222 7.61811,-12.64961 8.53937,-14.56299 5.917323,-33.236222 z' id='60-1-8-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 42.413386,36.177166 c 5.633858,3.897638 16.61811,1.098426 20.65748,22.074804 C 47.763779,51.484254 48.224409,53.255907 42.413386,36.177166 z' id='61-0-7-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 45.673228,51.023624 c 5.88189,3.472441 17.645669,0.389763 21.330709,20.090551 C 50.952756,65.303152 51.377952,66.968506 45.673228,51.023624 z' id='62-6-0-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 49.677165,64.204726 c 6.129921,3.826772 18.318897,0.673229 22.322834,21.933072 C 55.311023,79.653546 55.771653,81.460632 49.677165,64.204726 z' id='63-7-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 53.751968,82.665357 C 59.77559,84.047247 71.929133,76.251971 76.499999,102.68504 64.73622,101.37402 64.169291,93.188979 53.751968,82.665357 z' id='64-5-9-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 62.681102,97.476381 c 8.433071,2.374016 12.685039,0.673228 17.716535,21.614169 -12.862204,-6.98031 -12.401575,-5.24409 -17.716535,-21.614169 z' id='65-0-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 60.909448,117.67323 c -0.956693,0.99213 -1.913385,2.01969 -2.870078,3.08268 23.492125,65.09055 27.318897,120.86221 19.665354,224.57481 l 1.062992,0.74409 c 1.240157,0.5315 2.444882,1.063 3.685039,1.55906 8.716536,-105.20079 4.429134,-162.10631 -21.543307,-229.96064 z' id='66-0-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 15.944882,32.917324 C 28.27559,41.598426 33.165354,39.614174 33.980315,60.165356 21.791338,55.629923 20.090551,48.649608 15.944882,32.917324 z' id='67-4-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 38.055118,33.44882 c -3.720473,9.814961 -11.125984,17.007874 0.03543,35.362206 7.440945,-15.377954 5.740157,-16.015749 -0.03543,-35.362206 z' id='68-5-6-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 45.708661,53.610238 c -5.77559,9.850394 -12.437008,14.031496 -2.125984,29.834646 3.968504,-12.57874 7.122047,-12.826772 2.125984,-29.834646 z' id='69-4-3-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 50.952756,63.956695 C 47.19685,73.629923 39.755905,80.751971 50.77559,98.681105 58.322834,83.515751 56.622047,82.913388 50.952756,63.956695 z' id='70-9-94-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 58.925196,78.838585 C 54.141732,88.759845 45.35433,96.448822 56.834645,113.42126 65.19685,96.625987 58.535433,95.988192 58.925196,78.838585 z' id='71-5-5-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 64.842519,94.677168 c -4.429134,9.531492 -13.358267,17.539372 -2.374016,34.015752 6.200788,-13.8189 6.909449,-15.87402 2.374016,-34.015752 z' id='72-6-3-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 14.846457,52.263781 C 20.834646,55.240159 31.429134,50.704726 37.594488,70.901577 21.755905,66.614175 22.429134,68.314963 14.846457,52.263781 z' id='73-4-8-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 19.629921,66.472443 C 25.830708,68.988191 37.133858,64.062994 42.874015,83.055121 26.362205,79.830711 27,81.425199 19.629921,66.472443 z' id='74-8-2-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 25.015748,78.944884 C 31.464567,81.77953 43.15748,76.677168 49.3937,97.157483 32.173228,93.401578 32.846456,95.137798 25.015748,78.944884 z' id='75-2-39-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 30.968504,96.66142 c 6.094488,0.389764 17.291338,-9.283465 24.590551,16.26378 -11.76378,0.56693 -13.216536,-7.47638 -24.590551,-16.26378 z' id='76-1-4-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 41.350393,109.94882 c 8.610237,1.02756 12.614174,-1.34645 19.807087,18.6378 -13.464567,-4.85433 -12.862205,-3.22441 -19.807087,-18.6378 z' id='77-6-85-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 102.29527,0.53149608 C 111.01181,14.42126 116.14961,14.952756 110.44488,34.086615 100.55905,24.094489 101.19685,16.901575 102.29527,0.53149608 z' id='78-8-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 122.63386,11.657481 c -6.51969,7.192913 -15.69685,10.169291 -11.09055,32.314961 11.76378,-10.488189 10.38189,-11.870079 11.09055,-32.314961 z' id='79-3-3-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 123.41338,33.767718 c -8.4685,6.23622 -15.98031,6.838582 -11.37401,26.220473 7.61811,-9.602363 10.62992,-8.291339 11.37401,-26.220473 z' id='80-1-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 125.00787,45.708663 c -6.51968,7.051181 -15.66141,9.992126 -11.09055,31.677166 11.76378,-10.240158 10.38189,-11.622048 11.09055,-31.677166 z' id='81-4-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 127.73622,63.141734 c -7.58268,6.80315 -18.17717,9.56693 -12.86221,30.614174 13.07481,-11.338583 7.08662,-15.129921 12.86221,-30.614174 z' id='82-8-1-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 128.23228,80.503939 c -7.12204,6.555119 -17.92913,9.602363 -12.93307,29.905511 10.09843,-9.63779 11.44488,-11.161416 12.93307,-29.905511 z' id='83-4-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 95.173228,17.681103 C 99.81496,23.279528 111.04724,24.200788 110.44488,45.67323 97.086613,34.122048 97.15748,36.000001 95.173228,17.681103 z' id='84-9-4-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 95.137795,32.98819 c 4.960625,5.279528 17.007875,6.200788 16.370075,26.291339 C 97.192913,48.401576 97.263779,50.17323 95.137795,32.98819 z' id='85-2-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 96.200787,46.94882 c 5.102363,5.704725 17.574803,6.661418 16.901573,28.381891 C 98.326771,63.602364 98.362204,65.51575 96.200787,46.94882 z' id='86-0-77-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 96.129921,66.011813 C 101.69291,69.307089 115.12205,65.834648 113.88189,92.692916 102.7559,87.555121 103.96063,79.511813 96.129921,66.011813 z' id='87-7-9-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 101.58661,83.16142 c 7.68898,5.066929 12.15355,4.818898 12.50788,26.53937 -10.94882,-10.913385 -10.87796,-9.14173 -12.50788,-26.53937 z' id='88-0-6-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 91.098425,94.00394 c -1.311024,0.637795 -2.586615,1.346457 -3.897638,2.090551 16.370083,82.523629 20.196853,158.704729 18.779523,257.669299 0.46063,0.0354 0.92126,0.0709 1.38189,0.14173 l 1.87796,-0.42519 c 2.37401,-88.29922 0,-174.57875 -18.141735,-259.47639 z' id='89-6-4-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 63.141732,11.586615 C 73.948818,23.031497 79.051181,22.251969 76.677165,42.519686 65.338582,35.18504 64.807086,27.992127 63.141732,11.586615 z' id='90-0-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 84.826771,17.362205 C 79.653543,26.114174 71.220472,31.358269 79.334645,51.980317 89.07874,38.692915 87.519684,37.665355 84.826771,17.362205 z' id='91-7-9-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 89.255905,38.940946 c -7.228347,8.255906 -14.456693,10.736221 -6.767717,28.629922 5.846457,-11.374016 9,-10.84252 6.767717,-28.629922 z' id='92-0-2-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 92.799212,50.279529 c -5.208661,8.574803 -13.641732,13.748032 -5.598425,33.90945 9.779527,-13.039371 8.185039,-14.031497 5.598425,-33.90945 z' id='93-5-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 98.326771,66.720474 C 92.055117,75.295278 82.204724,80.716538 90.850393,100.02756 101.72835,85.606302 95.279527,83.374018 98.326771,66.720474 z' id='94-6-3-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 101.69291,83.62205 c -5.881887,8.255905 -15.909446,13.96063 -7.653541,32.66929 8.255901,-12.01181 9.283461,-13.85433 7.653541,-32.66929 z' id='95-7-1-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 59.066929,30.259843 c 5.42126,4.322835 16.547244,2.409449 19.488189,23.633859 C 63.637795,45.921261 63.992126,47.763781 59.066929,30.259843 z' id='96-3-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 61.547244,45.283466 C 67.251968,49.216537 79.15748,47.090553 81.850393,67.039372 66.082677,59.952758 66.437007,61.653545 61.547244,45.283466 z' id='97-8-9-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 64.913385,58.748033 c 5.917323,4.322835 18.212599,2.125985 21.153544,23.633859 C 69.69685,74.586616 70.086614,76.429136 64.913385,58.748033 z' id='98-4-7-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 67.996062,77.492128 c 5.952756,1.84252 18.496063,-4.96063 21.720473,21.755906 C 78.023621,97.015751 77.846456,88.795278 67.996062,77.492128 z' id='99-9-0-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 76.145669,92.976381 c 8.326771,3.011811 12.649606,1.665354 16.582677,22.925199 -12.472441,-7.97244 -12.11811,-6.23622 -16.582677,-22.925199 z' id='100-2-2-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 54.637795,124.58268 c -0.496063,0.56693 -0.992126,1.13386 -1.488189,1.73622 19.38189,47.94095 24.838582,87.23622 21.082677,127.24016 0,0 0,0.0354 0,0.0709 -0.708661,26.18504 -3.933071,54.35433 -9.354331,85.2874 1.38189,0.81496 2.76378,1.55906 4.110236,2.30315 l 0.779528,0.28347 C 85.039369,252.9567 83.586614,187.54725 54.637795,124.58268 z' id='101-6-6-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 71.114173,107.85827 c -1.204725,1.06299 -2.444882,2.16142 -3.649607,3.29528 22.181103,73.13386 25.228347,140.56299 22.03937,238.88977 l 2.940945,0.99212 c 0.425197,0.1063 0.850394,0.2126 1.275591,0.3189 4.216535,-100.06299 1.488189,-170.00788 -22.606299,-243.49607 z' id='102-5-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 31.003937,24.980316 c 12.047244,9.354331 16.972441,7.653543 17.07874,28.169292 C 36.035433,47.976379 34.61811,40.925198 31.003937,24.980316 z' id='103-7-7-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 53.07874,26.716536 C 49.03937,36.318899 41.350393,43.122049 51.874015,62.043309 59.881889,47.090553 58.181102,46.381891 53.07874,26.716536 z' id='104-7-6-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 60.059055,47.303151 c -6.129922,9.496063 -12.933071,13.287402 -3.22441,29.622048 4.429134,-12.330709 7.582677,-12.401575 3.22441,-29.622048 z' id='105-4-2-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 64.913385,57.862206 C 60.803149,67.322837 53.114173,74.05512 63.496063,92.551184 71.574803,77.811026 69.909448,77.102365 64.913385,57.862206 z' id='106-5-53-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 72.35433,73.169294 C 67.216535,82.807089 58.145669,90.000003 69.023622,107.57481 77.988188,91.275593 71.362204,90.248034 72.35433,73.169294 z' id='107-7-4-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 77.704724,89.326774 c -4.783465,9.248032 -13.96063,16.759846 -3.57874,33.803146 6.69685,-13.46456 7.476378,-15.48425 3.57874,-33.803146 z' id='108-9-0-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 29.232283,44.255907 c 5.88189,3.295276 16.61811,-0.673229 22.074803,19.84252 C 35.645669,58.925199 36.212598,60.696852 29.232283,44.255907 z' id='109-8-7-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 33.519685,58.7126 C 39.614173,61.547246 51.094488,57.224411 56.161417,76.500002 39.755905,72.389766 40.322834,74.019687 33.519685,58.7126 z' id='110-3-5-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 38.444882,71.433073 C 44.787401,74.622049 56.692913,70.157482 62.185039,90.956696 45.106299,86.244097 45.708661,88.015751 38.444882,71.433073 z' id='111-0-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 43.759842,89.468507 C 49.85433,90.177168 61.370078,81.106302 67.783464,107.00788 55.984252,106.93701 54.850393,98.822838 43.759842,89.468507 z' id='112-2-3-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 53.681102,103.2874 c 8.574803,1.48819 12.649606,-0.67322 19.133858,19.66536 -13.287401,-5.59843 -12.720472,-3.93307 -19.133858,-19.66536 z' id='113-2-18-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 0.49606299,46.700789 C 13.641732,53.362206 18.212598,50.63386 21.188976,70.901577 8.6456692,68.350396 6.2716535,61.688978 0.49606299,46.700789 z' id='114-3-8-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 22.429134,43.688978 c -2.657481,10.38189 -9.248032,18.708662 3.720472,35.18504 5.775591,-16.511811 4.003937,-16.866142 -3.720472,-35.18504 z' id='115-6-8-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 32.137795,62.539372 C 27.425197,73.24016 21.295275,78.448821 33.129921,92.515751 35.716535,79.370081 38.834645,78.625987 32.137795,62.539372 z' id='116-7-0-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 38.374015,71.964569 C 35.681102,82.204727 29.090551,90.460633 41.846456,106.51181 47.692913,90.212601 45.956693,89.893703 38.374015,71.964569 z' id='117-1-17-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 47.834645,85.464569 C 44.149606,96.129924 36.248031,105.16536 49.358267,120.18898 55.877952,102.15355 49.251968,102.57874 47.834645,85.464569 z' id='118-5-5-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 55.346456,100.31103 c -3.401574,10.16929 -11.374015,19.55905 1.204725,34.15748 4.677165,-14.70473 5.173228,-16.86614 -1.204725,-34.15748 z' id='119-5-0-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 1.4527559,66.082679 C 7.6889763,68.102364 17.681102,61.901577 25.901575,81.000002 9.7795275,79.263782 10.629921,80.85827 1.4527559,66.082679 z' id='120-4-5-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 7.6889763,79.47638 C 14.066929,81.000002 24.732283,74.267719 32.385827,92.232286 15.732283,91.665357 16.511811,93.188979 7.6889763,79.47638 z' id='121-0-90-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 14.279527,91.027562 c 6.696851,1.771653 17.751969,-5.173229 26.043307,14.208658 -17.43307,-0.99212 -16.582677,0.60237 -26.043307,-14.208658 z' id='122-2-9-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 22.03937,107.68111 C 28.098425,107.07874 38.161417,95.704727 48.082677,119.90552 36.496063,122.3504 34.228346,114.59055 22.03937,107.68111 z' id='123-6-3-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 33.69685,119.23229 c 8.610236,-0.35433 12.330709,-3.36614 21.543307,15.37795 -13.818897,-2.69291 -13.03937,-1.16929 -21.543307,-15.37795 z' id='124-0-5-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 139.6063,93.54331 c -18.8504,84.50788 -21.50788,171.88583 -19.66536,260.68111 1.45276,-0.0709 2.90552,-0.17717 4.35827,-0.35433 -0.77953,-99.92126 2.40945,-175.9252 19.24016,-258.200796 -1.31102,-0.744094 -2.62205,-1.488189 -3.93307,-2.125984 z' id='125-6-42-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 167.56299,14.492126 c -10.87795,10.84252 -15.94488,9.779528 -13.7126,30.188978 11.37402,-6.696851 11.97638,-13.889764 13.7126,-30.188978 z' id='126-1-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 145.84252,19.062993 c 5.13779,9.035433 13.53543,14.740158 5.27953,34.901576 -9.67323,-13.818899 -8.07874,-14.740158 -5.27953,-34.901576 z' id='127-1-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 141.30709,40.393702 c 7.19291,8.64567 14.38582,11.515748 6.59055,28.984253 -5.81103,-11.657481 -8.96457,-11.338583 -6.59055,-28.984253 z' id='128-1-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 137.69291,51.519687 c 5.1378,8.858268 13.57087,14.527559 5.38583,34.228347 -9.70866,-13.6063 -8.11417,-14.492126 -5.38583,-34.228347 z' id='129-7-7-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 132.05905,67.641734 c 6.20079,8.929134 16.05119,14.881891 7.26378,33.732286 C 128.55118,86.350396 135,84.507877 132.05905,67.641734 z' id='130-3-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 128.62205,84.366144 c 5.77559,8.610237 15.80315,14.846457 7.44094,33.094486 -8.18504,-12.47244 -9.2126,-14.38582 -7.44094,-33.094486 z' id='131-0-2-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 171.53149,33.377954 c -5.45669,4.03937 -16.54724,1.488189 -19.62992,22.570867 C 166.88976,48.79134 166.5,50.598427 171.53149,33.377954 z' id='132-0-0-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 168.94488,48.295277 c -5.70472,3.614173 -17.61024,0.814961 -20.40945,20.586615 15.80315,-6.200788 15.41339,-4.5 20.40945,-20.586615 z' id='133-4-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.54331,61.582679 c -5.95276,3.933071 -18.24804,1.062992 -21.33071,22.429135 16.40551,-6.874016 16.01575,-5.06693 21.33071,-22.429135 z' id='134-8-1-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 162.3189,80.114176 c -5.95276,1.523622 -18.46063,-5.98819 -21.82678,20.551184 11.69292,-1.594491 11.90552,-9.779531 21.82678,-20.551184 z' id='135-3-75-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 154.06299,95.137798 c -8.32677,2.586614 -12.64961,0.956693 -16.72441,22.003942 12.54331,-7.26378 12.18898,-5.563 16.72441,-22.003942 z' id='136-0-9-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 159.34252,107.46851 c -25.97244,72.46063 -29.44488,142.51181 -23.38583,244.38189 1.94882,-0.49606 3.89764,-1.02755 5.84646,-1.62992 -6.69685,-103.03937 -3.36614,-168.98032 20.72834,-239.77559 -1.06299,-1.02756 -2.12598,-2.01969 -3.18897,-2.97638 z' id='137-1-18-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 199.62992,29.692914 c -12.11811,8.681103 -17.00787,6.696851 -17.25591,27.2126 12.08268,-4.500001 13.53544,-11.480316 17.25591,-27.2126 z' id='138-2-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 177.51968,30.188977 c 4.00394,9.850394 11.65748,17.043308 1.02756,35.397639 -7.90157,-15.413386 -6.23622,-16.051181 -1.02756,-35.397639 z' id='139-9-7-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 170.4685,50.385828 c 6.05906,9.850394 12.82677,13.996064 3.01181,29.799214 C 169.15748,67.606301 165.9685,67.35827 170.4685,50.385828 z' id='140-0-8-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.50787,60.696852 c 4.03937,9.673229 11.69292,16.795276 1.20473,34.724411 -7.97244,-15.200788 -6.27166,-15.767717 -1.20473,-34.724411 z' id='141-3-6-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 157.99606,75.543309 c 5.06693,9.956694 14.10236,17.64567 3.11811,34.582681 -8.85827,-16.795279 -2.23228,-17.433074 -3.11811,-34.582681 z' id='142-8-6-6' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 152.53937,91.417326 c 4.7126,9.531494 13.85433,17.539374 3.36614,33.980314 -6.59055,-13.8189 -7.37008,-15.87401 -3.36614,-33.980314 z' id='143-8-9-4' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 201.25984,49.039372 c -5.88189,2.976378 -16.58268,-1.594489 -22.1811,18.602362 15.69685,-4.251968 15.09449,-2.551181 22.1811,-18.602362 z' id='144-5-9-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 196.90157,63.283466 c -6.09448,2.480315 -17.53937,-2.480315 -22.74803,16.511812 16.44095,-3.188977 15.83858,-1.594488 22.74803,-16.511812 z' id='145-7-2-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 191.90551,75.720475 c -6.37795,2.799212 -18.2126,-2.267717 -23.84646,18.177166 17.11418,-3.720473 16.47638,-2.019686 23.84646,-18.177166 z' id='146-7-6-8' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 186.48425,93.437011 c -6.09449,0.389763 -17.5748,-9.318898 -24.12992,16.228349 11.79921,0.56693 13.00394,-7.47638 24.12992,-16.228349 z' id='147-0-65-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 176.49212,106.72441 c -8.5748,0.99213 -12.68503,-1.38189 -19.24015,18.60237 13.2874,-4.85434 12.72047,-3.22441 19.24015,-18.60237 z' id='148-8-8-1' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 176.91732,126.17717 c -30.33071,65.62205 -27.74409,135.4252 -15.23622,215.68111 1.55906,-0.81496 3.08268,-1.66536 4.67717,-2.55118 -5.3504,-34.68898 -8.78741,-66.50788 -8.68111,-96.66142 0,-0.0709 0,-0.1063 0,-0.17717 -1.55905,-35.04331 4.14567,-70.54725 22.21654,-112.6063 -0.99213,-1.24016 -1.98425,-2.48032 -2.97638,-3.68504 z' id='149-9-40-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 229.99606,53.114175 c -13.1811,5.917323 -17.75197,2.940945 -20.83464,23.031497 12.5433,-1.84252 14.98818,-8.397638 20.83464,-23.031497 z' id='150-3-3-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 208.09842,48.897639 c 2.58662,10.48819 9.1063,19.169292 -3.9685,34.937009 -5.63386,-16.830709 -3.89764,-17.07874 3.9685,-34.937009 z' id='151-0-7-2' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 198.28346,67.181104 c 4.6063,10.94882 10.73622,16.511812 -1.20472,29.905513 -2.51575,-13.287402 -5.59843,-14.208662 1.20472,-29.905513 z' id='152-7-83-7' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 191.94094,76.251971 c 2.65748,10.38189 9.2126,18.992126 -3.6496,34.370079 -5.77559,-16.61811 -4.00394,-16.866142 3.6496,-34.370079 z' id='153-4-11-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 182.44488,89.220475 c 3.61417,10.842525 11.44488,20.338585 -1.77165,34.618115 -6.37796,-18.35433 0.24803,-17.57481 1.77165,-34.618115 z' id='154-7-25-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 174.82677,103.64174 c 3.33071,10.34645 11.26772,20.19685 -1.41732,34.08661 -4.6063,-14.95276 -5.06693,-17.14961 1.41732,-34.08661 z' id='155-8-7-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='M 228.93307,72.460632 C 222.69685,74.090553 212.74016,67.35827 204.37795,85.996066 220.5,85.145672 219.68504,86.704727 228.93307,72.460632 z' id='156-3-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 222.62598,85.464569 c -6.37795,1.169292 -17.00787,-6.129921 -24.80315,11.40945 16.68898,0.35433 15.87402,1.807086 24.80315,-11.40945 z' id='157-7-2-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 215.92913,96.66142 c -6.69685,1.38189 -17.6811,-6.165354 -26.11417,12.75591 17.43307,-0.0354 16.58268,1.52362 26.11417,-12.75591 z' id='158-1-1-5' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 208.09842,112.85433 c -6.05905,-0.92126 -16.05118,-12.862201 -26.11417,10.80709 11.55118,3.08268 13.88976,-4.57087 26.11417,-10.80709 z' id='159-0-6-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 196.33464,123.76772 c -8.61023,-0.85039 -12.29527,-4.0748 -21.61417,14.17323 13.85433,-1.94882 13.0748,-0.46063 21.61417,-14.17323 z' id='160-0-1-3' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 98.787401,218.16142 31.854329,0.88583 c 19.27559,0.5315 34.75984,5.95276 34.72441,12.18898 0,6.20078 -15.51968,10.77165 -34.79527,10.24016 l -31.854335,-0.88583 c -19.275591,-0.5315 -34.759843,-5.95276 -34.724409,-12.18898 0.03543,-6.20079 15.519684,-10.80709 34.795275,-10.24016 z' id='161-8-1-9' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 76.712598,217.52363 -9.531496,19.77165 c 1.488189,1.55906 3.366142,2.51575 5.456693,2.58662 l 5.740157,0.14173 10.700788,-22.14567 -12.366142,-0.35433 z m 24.803152,0.70866 -10.665357,22.14567 12.330707,0.35433 10.70079,-22.1811 -12.36614,-0.3189 z m 24.83858,0.67323 -10.70079,22.14567 12.33071,0.35433 10.70079,-22.14567 -12.33071,-0.35433 z m 24.80315,0.70866 -10.70079,22.14567 12.36614,0.35433 9.38977,-19.48819 c -1.55906,-1.73622 -3.54331,-2.79921 -5.74016,-2.87008 l -5.31496,-0.14173 z' id='162-3-5-0' style='fill:%23e8a30e;fill-opacity:1;fill-rule:nonzero;stroke:%23000000;stroke-width:1.27435184;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(0.46969353,-0.01273905,0.04093079,0.50219049,803.71591,468.85609)' id='g4771' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m -123.17601,1511.6014 c 0.23144,-0.046 2.99626,43.3713 6.38193,64.5284 0.41442,2.5897 3.55058,4.092 4.25463,6.6183 0.76173,2.7334 -0.19697,5.6721 -0.23637,8.5093 -0.004,0.3151 0.0446,0.6335 0,0.9455 -0.55712,3.8998 -4.00031,7.4673 -3.30915,11.3456 0.39535,2.2185 3.14014,3.3612 4.01825,5.4365 5.10393,12.0625 4.03652,26.4702 6.38194,38.7643 0.98853,5.1816 -0.94899,-0.9973 8.272882,13.7093 0.92654,1.4776 4.96373,1.6546 4.96373,1.6546 l 4.01825,0.2364 3.75595,3.8794 -5.68267,5.1813 -17.549432,1.6713 -7.85545,-5.0141 c 0,0 2.47745,-4.2434 1.00282,-6.3512 -1.05729,-1.5113 -4.83543,-0.5041 -5.01412,-2.3399 -0.32732,-3.3627 -0.70146,-12.5292 -0.83569,-12.5353 -0.29976,-0.014 -0.15568,-0.5947 -0.33427,-0.8357 0,0 -12.7817,-14.6738 -17.21515,-23.2321 -2.29339,-4.4271 -2.14515,-9.9132 -4.67985,-14.2067 -1.62332,-2.7497 -5.22599,-4.0998 -6.51836,-7.0197 -10.74969,-24.2876 -21.52301,-71.1302 -21.56072,-70.8663' id='path4714-2' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -333.806,1500.4203 45.3034,11.3258 -18.0109,62.8923 c -9.68654,19.8578 -8.97583,20.5846 -6.87508,26.2701 4.41167,10.9269 7.0933,27.2799 23.61059,53.2557 5.97926,6.6123 12.86499,7.4045 15.18591,10.0906 0.97279,2.8355 6.14165,7.1141 10.6565,8.8815 l 14.519,0 c 2.68403,-3.2191 2.62922,-2.1473 3.45577,-4.5926 -0.80895,-2.9676 -7.805,-1.9463 -12.33036,-6.0217 -1.92962,-7.7089 -11.72338,-19.5628 -12.55764,-27.6732 -4.4535,-17.7184 -2.74541,-18.2363 0.12037,-36.2061 1.42758,-9.257 11.11157,-29.6689 14.98049,-40.7823 7.80135,-11.86 16.28497,-32.5258 16.47338,-47.4595 l -16.38305,-41.693 -10.19328,-16.9888' id='path4697-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -307.15125,1424.2896 c -75.62204,20.367 -49.74606,84.639 -28.88573,85.8659' id='path4668-3' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -80.845868,1319.762 12.8951,-22.825 1.44811,-8.4129 -0.89238,-1.7883 -21.49062,21.787 -0.37304,1.4472' id='path4634-7-4' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -41.126278,1358.0397 c 4.57429,1.7713 10.39704,3.5373 11.66777,0.9429 1.57373,-3.213 2.36186,-5.4865 -1.03125,-8.0937 -1.63062,-1.4672 1.22707,-3.6566 -0.46875,-7.8125 -12.19293,-8.8033 -21.05912,-9.2347 -23.65625,-16.0625 l -0.0937,-4.6875 c -0.1411,-5.9257 -18.51455,-8.837 -22.78125,-11.8438 0,0 -7.51511,-3.8381 -11.59375,-4.7812 -1.74301,-0.403 -5.375,-0.3438 -5.375,-0.3438 -18.854722,-0.6475 -29.122172,17.6895 -33.249992,28.9063 0,0 -8.19473,51.3768 -19.40625,74.4375 -1.02144,2.101 -2.51903,3.9937 -4.25,5.5625 -1.6829,1.5252 -3.55044,3.7976 -5.8125,3.5937 -51.97659,-4.6841 -87.39015,-7.783 -108.68751,-7.5937 -21.29735,0.1893 -46.88987,14.9836 -48.53125,16.625 0,0 -24.88611,13.8873 -32.125,37.4062 -2.41742,7.8542 -1.15612,17.2253 1.34375,26.5938 18.0636,63.0418 46.70491,0.9513 55.05988,1.9045 l 10.283,1.1731 c 12.0733,1.3773 31.41952,36.9186 64.99379,44.7758 101.33273,23.7143 134.013482,-26.0413 141.587042,-138.2646 l 1.39395,-1.5847 0,-3.8268 6.02721,-8.8016 0.0957,-12.4371 -1.33938,-5.9316 0.38268,-2.296 29.3707,-2.7745 5.1901,-2.033' id='path4656-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -88.423678,1324.949 14.75609,-26.1191 1.6571,-9.6269 -1.02117,-2.0465 -24.5921,24.9313 -0.42687,1.656' id='path4634-8' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -345.17726,1490.8889 c 4.98592,18.6852 15.28188,37.3886 13.84375,44.1875 -2.15919,10.2078 -8.70851,14.768 -9.25,15.7188 -0.4971,0.8728 -2.89814,2.1287 -3.6875,2.75 -3.41648,2.6888 -5.99683,8.2229 -7.78125,12.1875 -2.20066,4.8893 -3.57266,9.2813 -3.40625,14.125 0.6182,17.9942 8.41138,55.1426 8.9375,55.6875 0,0 5.94472,3.6118 7.4375,7.0625 1.52009,3.5137 0.62601,6.8382 0.0625,10.625 -0.77298,5.1939 -4.90625,16.7187 -4.90625,16.7187 0,0 0.0425,2.2538 0.6875,2.9375 1.80575,1.914 8.1875,5.3125 8.1875,5.3125 l 14,0 c 0,0 -7.1498,-7.5491 -7.59375,-9.2187 -0.49247,-1.8522 -0.68771,-3.2729 0.0313,-5.3438 1.32801,-3.8251 5.66749,-8.2962 7.15625,-10.5625 1.60322,-2.4406 0.65625,-8.9375 0.65625,-8.9375 0.0639,-2.3642 -1.87564,-3.4997 -1.9375,-4.5 -0.48155,-7.7856 -0.50724,-13.3977 -0.1875,-21.125 0.28211,-6.8181 3.28125,-27.1871 3.28125,-27.1875 0,0 3.54279,-2.5474 5,-4.1562 1.32233,-1.46 3.3125,-4.9063 3.3125,-4.9063 0,0 17.68542,-8.6651 25.46875,-14.5937 9.23057,-7.031 24.71875,-24.5 24.71875,-24.5 0,0 4.63502,-7.1263 5.59376,-11.1875 0.32527,-1.3779 0.20692,-2.8495 0,-4.25 -1.12313,-7.6017 -3.52143,-15.0922 -6.68751,-22.0938 -3.07498,-6.8002 -6.77122,-13.497 -11.8125,-19 -0.51966,-0.5672 -1.84375,-1.375 -1.84375,-1.375' id='path4683-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -126.06058,1534.2453 c -14.58858,8.2365 -47.98384,14.4606 -49.04788,20.6494 0,0 -4.35035,38.834 -10.43697,54.2213 -2.39884,6.0645 -5.65204,7.7702 -8.58348,13.5959 -3.05235,6.0659 -3.30483,10.7534 -6.01758,16.7989 -2.90132,6.4656 -7.60144,12.2128 -9.19609,23.5025 l -0.47317,9.4004 9.567,5.8359 -10.71504,3.0614 -15.78556,-6.5055 -0.0957,-14.3505 4.8792,-14.7332 0.38268,-2.3918 -3.25278,-9.0886 0.19134,-32.3365 4.87917,-24.0132 4.11381,-88.6861' id='path4691-0' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -83.288438,1362.8333 c 6.11313,5.096 14.4676,8.511 34.70603,3.013 3.56879,2.3579 7.33667,5.2783 16.68354,-5.3645' id='path4654-8' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -39.673538,1347.5299 c 0.13031,-0.1303 3.59581,2.4702 4.95531,2.5026 1.05939,0.025 2.55912,-1.9663 1.75188,-2.6528 -0.8853,-0.7529 -2.56781,-1.6184 -3.45371,-1.1012 -1.28631,0.751 -3.2258,1.4728 -3.25348,1.2514 z' id='path4704-5' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:3.08510709;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m -75.359368,1333.3786 c 0,0 1.86715,0.1 2.42635,1.5688 1.89311,4.9735 7.51586,5.9584 12.47014,0.8886 0.6267,-0.6413 2.10846,-1.4988 2.26948,-1.5203 -0.90746,-0.094 -1.51684,-0.029 -2.18914,-0.7303 -4.60698,-4.8065 -10.13522,-0.9803 -11.89158,-0.6893 -1.15213,0.1909 -1.9682,0.3611 -3.08525,0.4825 z' id='path4706-2' style='fill:%23000000;fill-opacity:1;stroke:none' /%3E %3C/g%3E %3Cg transform='matrix(3.543307,0,0,3.543307,435.43162,920.19831)' id='g5254' style='fill-rule:evenodd;stroke:%23e3e4e5;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cg id='Capa_x0020_1' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cmetadata id='CorelCorpID_0Corel-Layer' /%3E %3Cg id='_109262760' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 148.412,101.384 c 0.001,0.006 0.002,0.012 0.003,0.0182 -0.1998,1.0256 -0.1876,1.8516 -0.0488,2.5598 -0.1853,0.9301 -0.1988,1.8278 -0.0469,2.5809 -0.1564,0.8216 -0.1891,1.6404 -0.0418,2.4575 -0.1445,0.8103 -0.1567,1.5859 -0.0368,2.3266 0.8486,0.6497 3.2535,0.7263 4.329,0.1377 0.1293,-0.7389 0.1271,-1.6285 -0.007,-2.4407 0.1579,-0.8149 0.1356,-1.6339 -0.0103,-2.4578 0.1616,-0.751 0.1596,-1.6488 -0.0137,-2.5815 0.1479,-0.7062 0.1705,-1.5318 -0.016,-2.5601 0.1409,-0.7876 0.1497,-1.6597 -0.0189,-2.6656 0.142,-0.7983 0.1471,-1.6501 -0.0198,-2.5685 0.15,-0.7838 0.1417,-1.6692 -0.0221,-2.6657 10e-4,-0.0079 0.002,-0.0157 0.003,-0.0238 0.1228,-0.7907 0.1271,-1.6798 -0.0191,-2.6897 0.15,-0.9586 0.1321,-1.8479 -0.021,-2.7216 0.1313,-0.8287 0.1401,-1.709 -0.019,-2.6901 0.1541,-0.7879 0.1506,-1.658 -0.019,-2.6899 0.2222,-0.8376 0.1332,-1.8897 -0.027,-2.7197 -7e-4,-0.0033 -0.001,-0.0067 -0.002,-0.01 0.1408,-0.9741 0.131,-1.8534 -0.011,-2.6818 0.142,-0.8945 0.1418,-1.7902 -0.0191,-2.69 0.1065,-0.891 0.095,-1.7934 -0.0209,-2.7217 0.115,-0.8854 0.0978,-1.7527 -0.0298,-2.6859 0.1036,-0.8137 0.1088,-1.6953 -0.0298,-2.6872 0.1224,-0.8544 0.1602,-1.7617 5e-4,-2.7282 0.122,-0.8749 0.1114,-1.773 -0.031,-2.6936 0.1214,-0.8344 0.1278,-1.722 -0.0331,-2.6865 0.1453,-0.9655 0.117,-1.8343 -0.0293,-2.6359 0.1144,-0.8924 0.1077,-1.5449 0.004,-2.4365 0.0227,-0.2727 0.004,-0.7862 -0.0282,-1.0589 l -2.7146,-0.0391 c -0.1153,0.1874 -0.1488,0.5635 -0.0742,1.0697 -0.1343,0.3875 -0.1279,2.0617 0.0288,2.4521 -0.1565,0.7995 -0.196,1.6677 -0.0631,2.6353 -0.1733,0.9621 -0.1782,1.8498 -0.0675,2.6857 -0.1544,0.9184 -0.1765,1.8163 -0.0657,2.6929 -0.172,0.9641 -0.1459,1.8721 -0.0344,2.728 -0.1515,0.9898 -0.1575,1.8713 -0.0643,2.6865 -0.1395,0.9313 -0.1679,1.7983 -0.0644,2.6853 -0.1277,0.9263 -0.151,1.8286 -0.0558,2.721 -0.1725,0.8975 -0.184,1.793 -0.0536,2.6895 -0.1527,0.8264 -0.1736,1.7053 -0.0455,2.6815 -0.1721,0.829 -0.2762,1.8846 -0.0639,2.7289 -0.1829,1.0294 -0.1974,1.8994 -0.0536,2.6894 -0.1717,0.9787 -0.1741,1.859 -0.0536,2.6894 -0.1641,0.8715 -0.1935,1.7605 -0.056,2.7212 -0.1606,1.0177 -0.1662,1.9144 -0.0509,2.7131 -0.1766,0.9939 -0.1964,1.8792 -0.0564,2.6649 -0.1788,0.9161 -0.1847,1.7678 -0.0529,2.5681 -0.18,0.9956 -0.1838,1.862 -0.0559,2.6468 z' id='_112166136' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.382,103.934 c 1.0008,0.4629 3.5561,0.3827 4.1563,0.0749' id='_112703888' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.361,101.364 c 0.9553,0.4061 3.2354,0.3849 4.161,0.0771' id='_105428400' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.488,98.6745 c 0.9251,0.4628 3.1199,0.3438 4.0152,0.0764' id='_122805528' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.541,96.1225 c 1.0234,0.4629 3.2513,0.3361 3.9423,0.0687' id='_113328848' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.591,93.4895 c 1.0993,0.3135 3.0265,0.3013 3.873,0.0118' id='_140461728' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.643,90.7981 c 1.1325,0.2708 2.899,0.2807 3.8024,0.0133' id='_111252504' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.695,88.0713 c 1.0336,0.2638 3.0258,0.2797 3.7289,0.0185' id='_127192920' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.747,85.3975 c 0.8973,0.2881 2.7881,0.2636 3.6576,0.0024' id='_99199072' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.823,82.6992 c 1.1464,0.278 2.7328,0.3013 3.5628,0.0108' id='_57974072' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.876,79.9675 c 1.1659,0.2763 2.8197,0.2436 3.4889,0.0209' id='_139695576' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.917,77.2849 c 1.1524,0.2594 2.9598,0.1655 3.4287,0.0136' id='_108876192' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.983,74.6633 c 1.074,0.1956 2.8846,0.094 3.3441,-0.0548' id='_104468904' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.038,71.8798 c 1.0566,0.2852 2.8129,0.1544 3.2678,0.0071' id='_108959488' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.108,69.2544 c 1.0069,0.2579 2.5911,0.1525 3.1786,-0.0574' id='_109312288' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.19,66.5129 c 0.9896,0.2148 2.6421,0.1353 3.0781,-0.0058' id='_109287888' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.23,63.8084 c 0.9872,0.2041 2.5899,0.1153 3.0165,-0.0229' id='_85988992' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.324,61.1244 c 1.0745,0.1317 2.4438,0.1188 2.8517,-0.0133' id='_144371400' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.388,58.3767 c 0.8915,0.1886 2.3753,0.172 2.7692,0.0445' id='_142302024' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.446,55.7443 c 0.972,0.1544 2.3143,0.1447 2.6988,0.0201' id='_90888000' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.34,53.3045 c 0.7285,0.0748 2.5167,0.1256 2.8168,0.0284' id='_108984096' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.336,106.486 c 1.0151,0.4629 3.6068,0.3827 4.2156,0.0749' id='_59547952' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.286,108.933 c 1.0295,0.4629 3.6581,0.3827 4.2756,0.0748' id='_109262800' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.42333335;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3Cg id='Capa_x0020_2' style='stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cmetadata id='CorelCorpID_1Corel-Layer' /%3E %3Cg id='_110261640' style='stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 156.59,46.9239 c 1.641,-0.3606 4.002,-0.4093 7.2607,-0.4954 -0.7856,-0.262 -1.6572,-0.5327 -2.9631,-0.8798 1.9041,-0.2637 6.4373,-0.2046 7.5997,-0.2155 -0.7872,-0.4813 -2.74,-1.2517 -3.2598,-1.3573 2.4932,-0.4114 5.4714,-0.0178 7.5678,0.3184 -0.9789,-0.549 -2.085,-1.2572 -3.4878,-1.6389 2.9929,-0.2051 4.1802,0.0358 6.9571,0.4088 -0.379,-0.3405 -1.6692,-1.275 -3.0335,-1.6643 3.3264,-0.609 5.1915,-0.7379 8.4519,-0.4753 -9.4178,-4.3096 -20.8446,-2.0676 -27.7226,2.6729 0.6897,-1.0807 2.1764,-2.7222 3.6274,-3.9598 -0.7347,-0.0585 -1.4326,-0.0406 -2.3817,0.1315 1.0076,-1.1044 2.903,-2.5798 4.1867,-3.0898 -0.9372,-0.0498 -1.7292,-0.0693 -2.5711,0.0969 1.262,-1.1721 3.1661,-2.4108 4.7833,-3.2349 -0.9599,-0.0882 -1.9404,-0.1071 -2.8922,0.0666 1.2755,-1.5013 3.5045,-3.0372 5.4747,-3.9739 -1.2831,-0.0211 -2.0731,0.0228 -3.2192,0.2485 1.6388,-1.4948 3.8304,-3.0616 6.7123,-4.5169 -11.4225,1.2793 -17.7283,9.5146 -18.2653,16.489 -3.0443,-6.5629 -11.3354,-12.8399 -22.7498,-12.3613 3.4076,1.0389 6.1151,2.3042 8.2234,3.5851 -1.268,-0.0487 -2.1115,0.0331 -3.4618,0.261 2.3172,0.6508 5.0556,1.8787 6.7816,3.2235 -1.0487,-0.0249 -2.0779,0.1516 -3.0686,0.398 1.9144,0.5912 4.2354,1.563 5.8628,2.5716 -0.9306,-0.0368 -1.7612,0.111 -2.7379,0.3135 1.4835,0.32 3.8559,1.5387 5.1986,2.5181 -1.046,-0.0249 -1.7861,0.0682 -2.5468,0.2479 3.4347,1.3395 3.6545,1.9437 4.4125,2.3979 -7.1243,-1.523 -17.4219,0.8294 -25.3393,10.0274 1.1488,-0.9686 6.0518,-2.7942 7.6088,-3.2133 -0.8115,0.9713 -1.0925,1.4813 -1.7346,2.7 1.7801,-1.4385 4.4682,-2.6258 7.0323,-3.6474 -0.5398,0.8175 -1.1256,1.8808 -1.3958,2.5614 1.8668,-1.1559 2.4358,-1.3227 6.2581,-3.1402 -0.2761,0.4672 -1.0373,1.4813 -1.4011,2.4439 1.1678,-0.6654 3.943,-1.6789 5.8244,-2.3551 0.1289,-0.0476 -1.1321,1.0325 -1.7022,2.3259 0.4294,-0.1619 3.0389,-1.1056 3.138,-1.1326 -6.0242,4.2067 -10.5157,11.2644 -9.6061,19.8489 0.3476,-1.3421 1.9393,-5.1958 2.8413,-6.7367 -0.0991,1.0222 0.1326,2.7173 0.3205,3.4753 0.8868,-2.5636 1.8619,-4.6079 3.3155,-6.8287 -0.1202,1.3703 -0.0871,2.8824 0.1013,3.5039 0.8121,-1.896 1.4526,-3.524 3.4433,-7.0339 -0.1288,0.523 -0.1565,2.0032 -0.0352,3.3112 0.6594,-1.4444 2.1905,-4.2922 3.6859,-6.3988 -0.0736,0.7753 -0.2139,2.0871 -0.1554,2.6323 0.1586,-0.2772 0.6308,-1.0536 1.1797,-1.9215 0.856,-1.3518 1.8993,-2.9246 2.2393,-3.1775 0.262,0.2642 0.5105,0.588 0.7433,0.96 0.9372,1.504 1.6085,3.8028 1.8175,6.1833 0.5003,-1.1683 0.7158,-2.3594 0.7791,-2.9891 1.0687,2.3909 2.2739,6.1309 2.36,8.1915 0.3595,-1.0937 0.5452,-1.7747 0.6746,-3.4872 1.1136,1.7877 2.0833,6.191 2.1732,8.1021 0.4331,-0.7482 0.7915,-1.6832 1.0525,-3.079 1.0903,2.4618 1.5208,5.5251 1.785,7.6387 2.7979,-10.1811 -1.2176,-16.7624 -6.1125,-21.7845 1.2312,0.6676 2.7882,2.0384 4.3101,3.6897 -0.1391,-0.7688 -0.5619,-2.2349 -0.9068,-3.0064 1.8094,1.2864 4.4763,3.9365 5.2191,4.701 -0.1278,-1.0065 -0.2718,-1.5392 -0.804,-2.8234 2.1353,1.4796 4.0416,4.0134 5.1223,5.4097 -0.0872,-0.6437 -0.2594,-1.8522 -0.7033,-3.2414 1.9479,1.4564 3.8878,4.3816 4.7714,6.0302 -0.0233,-1.1272 -0.3389,-2.3194 -0.6042,-3.5479 2.6523,2.242 3.6322,4.6139 4.4703,6.047 0.0212,-9.1931 -10.618,-17.463 -20.5056,-18.3249 z' id='_109373744' style='fill:%23007934;fill-opacity:1;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cg id='g5212' style='stroke:%23e7e7e7;stroke-width:0.42333335;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none'%3E %3Cpath d='m 152.494,47.0175 c 10.7792,-1.5406 24.6254,7.7441 24.6017,18.2311 -0.8387,-1.4332 -1.8186,-3.8049 -4.4718,-6.0474 0.2667,1.2291 0.5817,2.4215 0.6047,3.5484 -0.8831,-1.6491 -2.8229,-4.5741 -4.7717,-6.0305 0.4442,1.3894 0.6171,2.5982 0.7045,3.2425 -1.081,-1.3973 -2.9874,-3.9313 -5.1233,-5.4106 0.5328,1.2845 0.6766,1.8168 0.8042,2.8246 -0.7428,-0.7657 -3.4095,-3.4161 -5.219,-4.7026 0.3453,0.7721 0.7678,2.2384 0.9073,3.0067 -1.5224,-1.6517 -3.0793,-3.0219 -4.3106,-3.6896' id='_57651880' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 150.079,46.8892 c -6.4528,-4.1578 -20.1473,-3.4016 -30.0886,8.1482 1.1479,-0.9684 6.051,-2.7939 7.6087,-3.2137 -0.8119,0.9714 -1.0931,1.4818 -1.7348,2.7001 1.7803,-1.4389 4.4681,-2.6253 7.0318,-3.6473 -0.5399,0.8177 -1.1256,1.8809 -1.3948,2.5612 1.8658,-1.1564 2.435,-1.3222 6.2572,-3.1401 -0.2765,0.4675 -1.0379,1.4814 -1.4005,2.4443 1.1664,-0.6654 3.9423,-1.6794 5.8234,-2.3561 0.1298,-0.0468 -1.1319,1.0335 -1.7016,2.3271 0.4289,-0.1625 3.0397,-1.1052 3.1378,-1.1332' id='_109373784' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 150.512,45.2491 c -1.3704,-7.5872 -10.4595,-16.3174 -23.8474,-15.7566 3.4078,1.0396 6.1159,2.305 8.2232,3.5854 -1.2671,-0.0487 -2.1108,0.0336 -3.4605,0.2617 2.3154,0.6502 5.0548,1.8781 6.7804,3.223 -1.0482,-0.0248 -2.0775,0.1522 -3.0682,0.3986 1.9138,0.5901 4.2352,1.5628 5.8626,2.571 -0.9302,-0.0367 -1.7612,0.1113 -2.7376,0.3137 1.4838,0.3203 3.8554,1.5387 5.1984,2.518 -1.046,-0.0248 -1.7867,0.0689 -2.5469,0.248 3.4341,1.339 3.655,1.9436 4.4116,2.3988' id='_59500704' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 150.417,48.2445 c -8.969,2.7373 -17.6366,11.5624 -16.405,23.1839 0.3472,-1.3414 1.939,-5.1962 2.8405,-6.7364 -0.0984,1.0224 0.1327,2.7171 0.3206,3.474 0.8869,-2.5625 1.862,-4.6073 3.3151,-6.8279 -0.1195,1.3709 -0.086,2.8828 0.102,3.5054 0.8123,-1.8966 1.4515,-3.5244 3.4431,-7.0351 -0.1292,0.5229 -0.1565,2.0028 -0.0352,3.3114 0.6594,-1.4442 2.1904,-4.2923 3.6858,-6.3991 -0.0737,0.7753 -0.2132,2.0876 -0.1559,2.6319 0.4074,-0.7082 2.861,-4.6842 3.4196,-5.0985' id='_114147888' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 145.367,52.8151 c -0.6246,1.7686 -1.1355,3.6773 -1.3336,4.9933' id='_109396888' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 142.088,55.0574 c -0.6088,1.577 -1.3598,4.4486 -1.6004,6.2807' id='_57647160' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 138.793,58.196 c -0.8961,2.0169 -1.7003,4.9316 -1.9405,6.496' id='_61202400' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cline y2='50.181301' x2='150.98199' y1='52.254101' x1='150.94701' class='fil1 str2' id='_108003056' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 160.236,61.2899 c 0.2745,1.6367 0.4089,2.4981 0.3102,4.8457' id='_109350400' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 156.826,55.6296 c 0.3532,1.8278 0.5013,3.0374 0.4962,5.483' id='_109347792' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 153.65,51.9621 c 0.3935,1.1276 0.6335,2.5775 0.6362,4.4475' id='_137236192' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 170.618,55.049 c 1.195,1.5373 1.7758,3.2643 2.0067,4.1521' id='_137234560' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.768,51.6804 c 1.1715,1.3802 2.3138,3.8331 2.689,5.0386' id='_137232928' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 161.695,50.3172 c 1.0078,1.3133 1.6963,2.7045 2.3433,4.2339' id='_276224976' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 127.599,51.8237 c 1.1065,-1.18 2.8274,-2.8354 5.9497,-4.1123' id='_276223488' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 132.896,50.8765 c 1.3346,-1.6887 2.0169,-2.7511 5.5171,-4.2747' id='_61025264' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 137.758,50.2977 c 1.1013,-1.4081 2.8701,-3.004 5.551,-3.9575' id='_61023680' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 142.181,50.3857 c 1.7488,-1.5959 3.361,-2.4443 5.5075,-3.3549' id='_61022688' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 134.888,33.0775 c 2.3091,0.2535 5.4957,1.056 7.4435,2.3405' id='_60098480' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 138.208,36.5622 c 2.1007,0.0371 4.9699,0.6643 6.4442,1.4664' id='_59194896' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 141.003,39.5324 c 2.0773,0.0392 4.6798,0.8954 6.8102,2.1159' id='_60493792' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 143.463,42.364 c 2.7835,0.2454 4.6914,1.2563 5.9323,2.015' id='_59289568' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 152.289,44.8741 c 6.5684,-5.5837 19.1653,-8.6301 29.3925,-3.9493 -3.2607,-0.264 -5.1252,-0.1338 -8.4512,0.4747 1.3638,0.3894 2.6545,1.3245 3.0337,1.6648 -2.7769,-0.373 -3.9638,-0.6141 -6.9572,-0.4088 1.4027,0.3813 2.5088,1.0898 3.487,1.6388 -2.0952,-0.3367 -5.0741,-0.7293 -7.5672,-0.3178 0.5198,0.1049 2.4721,0.8748 3.2596,1.3563 -1.1627,0.0117 -5.6949,-0.0473 -7.5991,0.2156 1.306,0.3473 2.1771,0.6178 2.9627,0.8803 -3.2594,0.0855 -5.6199,0.1341 -7.2607,0.4948' id='_59437040' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 173.231,41.3995 c -2.0254,-0.8195 -5.5608,-1.1901 -7.3778,-1.0743' id='_57583984' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 169.307,42.6555 c -3.58,-1.1863 -6.9823,-1.1225 -8.6907,-0.8639' id='_59158512' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 165.227,43.9765 c -3.1489,-0.8873 -6.8417,-0.9095 -8.5501,-0.6509' id='_56459728' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 160.888,45.5483 c -3.0306,-0.7298 -5.2028,-0.6286 -6.9111,-0.3699' id='_55106048' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 156.852,48.8592 c 1.2396,1.0509 2.1242,2.2843 2.7711,3.8137' id='_55036328' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 149.415,41.8546 c 0.5367,-6.9747 6.8421,-15.2098 18.265,-16.4891 -2.8811,1.4555 -5.0727,3.0221 -6.7122,4.517 1.1466,-0.2259 1.9356,-0.2693 3.2194,-0.2487 -1.9701,0.9366 -4.1987,2.4725 -5.4751,3.9734 0.952,-0.1725 1.9318,-0.154 2.8917,-0.0652 -1.6167,0.8233 -3.5203,2.0616 -4.7822,3.2342 0.8416,-0.1667 1.6337,-0.147 2.5708,-0.0972 -1.284,0.5102 -3.1788,1.9849 -4.1872,3.0901 0.9499,-0.1721 1.6475,-0.1903 2.3818,-0.1314 -1.4507,1.2373 -2.937,2.8796 -3.6268,3.9596' id='_57285408' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 160.967,29.8822 c -1.6678,0.4595 -3.7841,1.3396 -5.3197,2.4452' id='_60502904' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 158.712,33.6068 c -1.5673,0.2737 -3.5186,0.9919 -4.8137,1.7701' id='_110052216' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 156.821,36.7764 c -1.6379,0.2884 -3.4997,1.2062 -5.0569,2.3855' id='_60876664' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 155.205,39.7693 c -2.4879,0.6254 -4.0054,1.8405 -4.9697,2.7252' id='_56253864' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 148.679,50.7319 c -0.4875,1.2544 -0.8346,2.9194 -0.9955,3.9885' id='_141276520' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 151.706,47.8077 c 6.3601,5.5562 14.2699,12.7107 10.6267,25.9665 -0.2643,-2.1136 -0.6948,-5.1764 -1.7849,-7.6386 -0.2613,1.3966 -0.6198,2.3313 -1.0531,3.0795 -0.0892,-1.9111 -1.059,-6.3143 -2.1732,-8.1026 -0.1291,1.7125 -0.3147,2.3936 -0.6742,3.4881 -0.0864,-2.0614 -1.2914,-5.8011 -2.3599,-8.1917 -0.0635,0.6286 -0.279,1.8206 -0.7789,2.9888 -0.2605,-2.9704 -1.2412,-5.8129 -2.5613,-7.1431' id='_56765888' style='fill:none;stroke:%23e7e7e7;stroke-width:0.42333335;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg id='text5512' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;text-align:center;line-height:125%25;letter-spacing:60px;word-spacing:0px;text-anchor:middle;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold'%3E %3Cpath d='m 524.56397,799.32401 15.36274,8.33983 3.7273,-6.86604 c 1.91026,-3.51879 2.48407,-6.28155 1.72144,-8.28829 -0.74707,-2.03523 -2.79421,-3.96141 -6.14141,-5.77852 -3.69047,-2.00336 -6.63673,-2.75087 -8.8388,-2.24253 -2.23062,0.49294 -4.06034,2.05537 -5.48917,4.68729 -1.84808,3.40446 -2.75007,5.74831 -2.70598,7.03156 0.0597,1.25473 0.84767,2.29363 2.36388,3.1167 m 20.04023,10.87905 19.73984,10.71598 c 1.51625,0.82314 2.86861,0.89058 4.0571,0.20232 1.204,-0.71682 2.62135,-2.57719 4.25205,-5.5811 1.55303,-2.86082 2.5809,-5.26597 3.08361,-7.21547 0.48961,-1.99356 0.42136,-3.64182 -0.20474,-4.94478 -0.6106,-1.33148 -1.34788,-2.36138 -2.21184,-3.08972 -0.87706,-0.77239 -2.23106,-1.65558 -4.06199,-2.64957 -9.21193,-5.00074 -15.95454,-3.5311 -20.22786,4.40892 l -4.42617,8.15342 m -31.6696,-9.41392 c 1.11824,-2.05976 2.53518,-4.77225 4.25084,-8.13748 1.71575,-3.36511 2.79102,-5.44822 3.22583,-6.24931 2.09665,-3.86208 4.34283,-6.97631 6.73856,-9.34271 2.38272,-2.41039 4.68529,-3.95688 6.90774,-4.63946 2.19389,-0.69797 4.2067,-0.99426 6.03844,-0.88889 1.83178,0.10552 3.563,0.60086 5.19367,1.48602 2.28869,1.24251 4.03094,3.35504 5.22675,6.33762 1.21137,2.9541 1.73572,5.97965 1.57304,9.07666 3.51314,-3.53757 7.27148,-5.92351 11.27504,-7.15782 4.00355,-1.23417 7.96501,-0.78746 11.88438,1.34014 4.34847,2.36069 7.10264,6.43004 8.26251,12.20809 1.13123,5.76262 -0.48517,12.66339 -4.84919,20.70233 -1.49094,2.74644 -3.10242,5.6126 -4.83446,8.59848 -1.71653,2.95732 -3.11835,5.43726 -4.20547,7.43984 l -3.79596,7.60658 -0.30407,-0.0539 c -4.36074,-3.29325 -10.03134,-6.83458 -17.01181,-10.62402 l -21.49927,-11.6711 c -6.75155,-3.66514 -12.81041,-6.49127 -18.1766,-8.47839 l -0.16429,-0.31142 c 1.7558,-2.82484 3.17724,-5.23857 4.26432,-7.24121' id='path7858' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 621.17915,668.83074 c -8.74694,7.3005 -7.22792,18.01076 4.55707,32.13078 5.94464,7.12256 11.87456,11.33174 17.78976,12.62758 5.89432,1.27089 11.24064,-0.0961 16.039,-4.10092 4.34845,-3.62933 6.18731,-8.00491 5.51658,-13.12674 -0.67081,-5.12175 -3.87422,-11.11895 -9.61025,-17.99161 -6.61213,-7.92217 -12.62577,-12.61268 -18.04093,-14.07155 -5.41105,-1.50456 -10.82812,0.006 -16.25123,4.53246 m 45.44263,-2.24781 c 6.44521,7.72237 9.24402,16.02887 8.39643,24.91953 -0.84354,8.8449 -5.33886,16.66724 -13.48598,23.46705 -7.62237,6.36183 -15.87663,9.35024 -24.76281,8.96522 -8.88618,-0.38498 -16.32245,-4.16373 -22.30883,-11.33625 -6.36179,-7.62231 -9.18362,-16.058 -8.46549,-25.30709 0.71818,-9.24898 4.9384,-17.09613 12.66069,-23.54144 8.14717,-6.79976 16.5868,-9.92168 25.31891,-9.36577 8.73622,0.51024 16.28524,4.57648 22.64708,12.19875' id='path7860' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 764.17011,634.81851 c 1.82535,6.55395 3.22909,10.6234 4.21121,12.20837 3.85707,-1.07425 8.02676,-2.42143 12.50906,-4.04153 4.51359,-1.62881 8.05074,-3.00256 10.61145,-4.12126 l 3.85411,-1.63098 0.29295,0.3239 c 0.16274,1.06979 0.61095,2.92173 1.34465,5.55582 0.25323,0.90942 0.6915,2.24037 1.31482,3.99285 l -0.10955,0.33463 c -1.58902,0.23982 -3.54377,0.68288 -5.86425,1.32917 l -29.30456,8.1618 -7.87078,2.49626 -0.21972,-0.24292 c -0.58684,-4.53351 -2.04802,-11.05371 -4.38353,-19.56062 l -6.5635,-23.56594 c -2.18346,-7.83958 -4.33453,-14.16763 -6.4532,-18.98418 l 0.15659,-0.34773 c 2.93739,-0.6153 5.48795,-1.2243 7.65169,-1.827 l 7.91782,-2.50937 0.17268,0.25603 c 0.55189,4.40814 2.02875,10.92398 4.43057,19.54752 l 6.30149,22.62518' id='path7862' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 876.85306,599.92361 c 0.83195,-7.63706 1.1663,-14.31329 1.00306,-20.0287 l 0.22589,-0.27009 c 3.15017,0.5397 5.85789,0.9329 8.12315,1.17961 -2e-5,6e-5 2.76121,0.20263 8.28369,0.6077 l 0.0654,0.30182 c -1.38014,5.15435 -2.50733,11.74421 -3.38157,19.76959 l -2.64925,24.31902 c -0.82141,7.54004 -1.13958,14.21803 -0.95452,20.03399 l -0.22589,0.27009 c -3.15021,-0.53964 -5.85793,-0.93285 -8.12315,-1.17962 -2e-5,0 -2.76124,-0.20256 -8.28369,-0.6077 l -0.0653,-0.30182 c 1.3942,-5.28373 2.50521,-11.87535 3.33302,-19.77488 l 2.64925,-24.31901' id='path7864' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 996.90213,663.72858 c 20.12567,-15.94374 32.91677,-26.82901 38.37327,-32.65585 0.6245,0.55709 2.2847,1.55939 4.9806,3.0069 2.1222,1.13958 3.5737,1.80811 4.3545,2.00559 -27.953,21.16265 -46.9394,35.74144 -56.95921,43.73642 l -6.06566,-3.25696 c 0.54025,-5.54769 1.39579,-13.91885 2.56664,-25.11352 1.17079,-11.19464 2.14071,-20.74215 2.90975,-28.64254 0.78438,-7.929 1.23967,-13.55925 1.36588,-16.89076 0.91134,0.71111 3.83344,2.39098 8.7663,5.03962 3.4701,1.86337 5.739,2.97078 6.8065,3.32224 -2.9296,13.57564 -5.29581,30.05857 -7.09857,49.44886' id='path7866' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 1100.0879,710.59152 c 5.6797,-5.17285 10.3503,-9.95503 14.0118,-14.34656 l 0.3481,-0.0529 c 2.0036,2.49007 3.7726,4.57741 5.307,6.26203 0,3e-5 1.9353,1.97993 5.806,5.93969 l -0.1509,0.26948 c -4.4468,2.94923 -9.6544,7.14178 -15.6229,12.57766 l -18.0859,16.4721 c -5.6076,5.10711 -10.2672,9.90132 -13.979,14.38265 l -0.3481,0.0529 c -2.0037,-2.49005 -3.7727,-4.57739 -5.307,-6.26203 0,-10e-6 -1.9353,-1.97991 -5.8059,-5.93969 l 0.1508,-0.26947 c 4.543,-3.03689 9.7397,-7.24147 15.59,-12.61377 l 18.086,-16.47209' id='path7868' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3Cpath d='m 1160.8469,832.54062 c 6.3149,-6.49146 11.6987,-12.24465 16.1515,-17.25959 l -0.2677,-0.57555 -23.7234,0.74873 c 1.0763,2.62275 2.4862,5.80837 4.2297,9.55686 0.8786,1.88897 2.0819,4.39882 3.6099,7.52955 m -13.9638,-16.82278 c -10.384,0.52174 -18.2108,1.25421 -23.4804,2.19739 -0.1661,-0.82027 -0.709,-2.21917 -1.6288,-4.1967 -1.2356,-2.65641 -2.1135,-4.31236 -2.6338,-4.96788 33.7933,-0.20895 57.759,-0.51391 71.897,-0.91489 l 3.7891,8.1463 c -24.5102,25.72478 -40.4722,43.23729 -47.886,52.53758 -0.3034,-1.11548 -1.4985,-3.91636 -3.5852,-8.40267 -1.7985,-3.86659 -3.0265,-6.27519 -3.684,-7.22581 4.5515,-3.87625 10.2377,-9.24951 17.0585,-16.11981 -1.6138,-3.70114 -2.9698,-6.73232 -4.0681,-9.09354 -1.5925,-3.42382 -3.5186,-7.41047 -5.7783,-11.95997' id='path7870' style='font-size:100px;font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;letter-spacing:60px;fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.5;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none;font-family:Linux Biolinum;-inkscape-font-specification:Linux Biolinum Bold' /%3E %3C/g%3E %3Cg id='g8752' style='fill:%23e8a30e;fill-opacity:1;stroke-width:1.5;stroke-miterlimit:4;stroke-dasharray:none'%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1443.2499,469.16955)' id='path6841' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1554.5953,421.73669)' id='path6843' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1726.5714,117.53384)' id='path6845' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,578.4198,334.55701)' id='path6847' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,636.1068,235.33423)' id='path6849' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,256.7501,469.16955)' id='path6853' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,145.4047,421.73669)' id='path6855' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(0.83717005,0,0,0.83717005,-26.5714,117.53384)' id='path6857' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1121.5802,334.55701)' id='path6859' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 636.96729,1079.9993 11.17497,32.149 34.02876,0.6934 -27.12224,20.5626 9.85595,32.5776 -27.93745,-19.4406 -27.93744,19.4406 9.85595,-32.5776 -27.12224,-20.5626 34.02876,-0.6934 z' transform='matrix(-0.83717005,0,0,0.83717005,1063.8932,235.33423)' id='path6861' style='fill:%23e8a30e;fill-opacity:1;stroke:%23000000;stroke-width:1.79175067;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cg transform='matrix(3,0,0,3,-2015.2607,-1836.6377)' id='g4397'%3E %3Cg id='g45422'%3E %3Cg transform='matrix(0.4945295,0,0,0.4407188,780.5066,844.55531)' id='g4979' style='fill:%23e7e7e7;fill-opacity:1'%3E %3Cpath d='m 361.87949,211.77963 -0.0229,-4.44419 0.54752,0 -6.79287,-4.38776 -5.46601,-0.003 -6.75627,4.38181 0.5399,0.003 0.0229,4.44129 17.92622,0.0122' id='path190' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 361.87949,211.77963 -0.0229,-4.44419 0.54752,0 -6.79287,-4.38776 -0.51493,-6.68341 -4.43052,0 -0.52056,6.68036 -6.75627,4.38181 0.5399,0.003 0.0229,4.44129 17.92622,0.0122 0.002,-0.003 z' id='path192' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 363.96737,217.61792 0.002,1.39076 -21.88389,-0.0244 -0.009,-1.3848 21.89304,0.0185' id='path198' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 363.96737,217.61792 0.002,1.39076 -21.88389,-0.0244 -0.009,-1.3848 21.89304,0.0185 -0.002,0 z' id='path200' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 343.53845,217.53404 -0.0183,-4.70651 0.88604,-0.002 -0.0487,4.76142 0.0534,-4.72314 -1.2765,-0.0366 0,-1.00978 19.55809,0.0215 0.009,1.00047 -1.20637,0 0.0229,4.76599 -0.0427,-4.76599 0.89829,0 0.0198,4.71246' id='path202' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 343.53845,217.53404 -0.0183,-4.70651 0.88604,-0.002 -0.0487,4.76142 0.0534,-4.72314 -1.2765,-0.0366 0,-1.00978 19.55809,0.0215 0.009,1.00047 -1.20637,0 0.0229,4.76599 -0.0427,-4.76599 0.89829,0 0.0198,4.71246' id='path204' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 347.74319,216.37495 -0.0137,-3.28205 -2.62625,0 0.0153,3.27885 2.62472,0.003' id='path206' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 345.81849,213.77753 0.008,1.90639 1.20179,0 -0.006,-1.90639 -1.20332,0' id='path208' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 360.58162,216.38395 -0.0152,-3.27885 -2.6171,-0.003 0.0122,3.2819 2.62015,0' id='path210' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.65692,213.78973 0.0137,1.90029 1.20026,0 -0.0107,-1.90029 -1.20332,0' id='path2319' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 360.56179,211.0401 -0.0152,-3.2822 -2.62015,0 0.009,3.2822 2.62778,0 -0.002,0 z' id='path2321' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 358.63709,208.44877 0.008,1.90335 1.20027,0 -0.002,-1.90335 -1.20637,0' id='path216' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 347.72184,211.0279 -0.0183,-3.27595 -2.62168,-0.003 0.0122,3.27748 2.62778,0 0,0.002 z' id='path218' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 345.79714,208.43657 0.006,1.90045 1.20332,0.003 -0.009,-1.90335 -1.20027,0' id='path220' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 352.4741,211.03384 -0.0122,-3.27594 -2.6232,-0.003 0.0107,3.27884 2.62472,0' id='path222' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.55093,208.43962 0.006,1.9003 1.20179,0.006 -0.008,-1.9064 -1.20027,0' id='path224' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.13743,211.0401 -0.0183,-3.2822 -2.62168,-0.003 0.0122,3.27884 2.62778,0.006' id='path226' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 354.21121,208.44283 0.009,1.90639 1.20179,0 -0.006,-1.90639 -1.20484,0' id='path228' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.78713,210.03337 0.029,7.5661 -7.59966,-0.0122 -0.0274,-7.55985 7.5966,0.006' id='path230' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 356.78713,210.03337 0.029,7.5661 -7.59966,-0.0122 -0.0274,-7.55985 7.5966,0.006 0.002,0 z' id='path232' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 349.14325,212.19293 7.6515,0.006' id='path234' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.09797,217.59642 -0.0259,-5.34706' id='path2333' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 355.89189,217.59947 -0.0259,-5.34385' id='path2335' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 359.56131,206.81095 -4.27947,-3.12511 -4.80869,-0.006 -4.24592,3.11901 13.33408,0.0122' id='path240' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.85138,202.99816 4.0446,0.003' id='path2338' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 351.94031,201.56455 0.006,0.95 1.85759,0 -0.006,-0.95 -1.85759,0' id='path244' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 349.54435,210.24551 0.55362,0 -0.16166,0.29725 c 0,0 0.26689,0.3433 0.005,0.73663 l 0.14489,0.27315 -0.53379,0 0.14488,-0.25943 c 0,0 -0.27299,-0.45585 0.0122,-0.75035 l -0.16472,-0.29725' id='path252' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 350.67294,210.24551 0.55362,0 -0.16014,0.29725 c 0,0 0.26689,0.33415 0.002,0.73663 l 0.14336,0.27315 -0.53226,0 0.14336,-0.25943 c 0,0 -0.2669,-0.45585 0.0137,-0.75035 l -0.16319,-0.29725' id='path254' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 351.90371,210.24551 0.55209,0 -0.16471,0.29725 c 0,0 0.26994,0.3433 0.005,0.73663 l 0.14489,0.27909 -0.52922,-0.006 0.14184,-0.25943 c 0,0 -0.26995,-0.45295 0.0107,-0.75035 l -0.16166,-0.29725 0.002,0 z' id='path256' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 353.29309,210.24841 0.55667,0 -0.16319,0.30045 c 0,0 0.26689,0.3372 0.002,0.73205 l 0.14946,0.27757 -0.53684,0 0.14336,-0.25927 c 0,0 -0.26689,-0.45905 0.0183,-0.75035 l -0.16777,-0.30045 -0.002,0 z' id='path258' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 354.52843,210.24841 0.55209,0 -0.16318,0.30045 c 0,0 0.26842,0.3372 0.003,0.73053 l 0.14641,0.27909 -0.53227,0 0.13879,-0.25927 c 0,0 -0.26842,-0.456 0.0213,-0.75035 l -0.16624,-0.30045' id='path260' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 355.75615,210.25146 0.55209,-0.003 -0.16319,0.30045 c 0,0 0.273,0.3372 0.008,0.73205 l 0.13879,0.27757 -0.53379,0 0.14336,-0.25927 c 0,0 -0.2669,-0.456 0.0183,-0.75035 l -0.16319,-0.2974' id='path262' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.37349528;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3Cpath d='m 954.4347,929.4981 1.30438,0 0,1.52247 -1.30438,0 0,-1.52247 z' id='path13722' style='fill:%23e7e7e7;fill-opacity:1;fill-rule:evenodd;stroke:%23000000;stroke-width:0.13021348;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 955.09984,927.63497 -0.0259,1.94455' id='path14693' style='fill:none;stroke:%23000000;stroke-width:0.30000001;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3Cpath d='m 954.37609,928.36033 1.42159,0.0197' id='path14695' style='fill:none;stroke:%23000000;stroke-width:0.37895805;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' /%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3Cg transform='matrix(1.1428572,0,0,1.1428572,-139.28578,-99.630767)' id='g44354'%3E %3Cpath d='m 586.607,219.117 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.57,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4705-8-5' style='fill:%23452c25' /%3E %3Cpath d='m 586.607,219.117 c 0,0 -8.426,19.153 -5.515,21.053 0,0 10.569,-11.555 13.329,-20.736 2.757,-9.181 0,-0.633 0,-0.633 l -0.767,-9.973 -6.894,9.497' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4707-6-4' style='fill:none;stroke:%23000000;stroke-width:0.58499998' /%3E %3Cpath d='m 588.388,209.963 c 0,0 -10.125,21.095 -7.809,22.654 0,0 8.411,-9.485 10.605,-17.02 2.193,-7.536 0,-0.52 0,-0.52 l 2.812,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4741-0-0' style='fill:%23452c25' /%3E %3Cpath d='m 588.388,209.963 c 0,0 -10.125,21.095 -7.809,22.654 0,0 8.411,-9.485 10.605,-17.02 2.193,-7.536 0,-0.52 0,-0.52 l 2.812,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4743-9-3' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 598.819,205.264 c 0,0 -10.125,21.095 -7.81,22.654 0,0 8.411,-9.485 10.606,-17.021 2.194,-7.536 0,-0.52 0,-0.52 l 2.811,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4745-4-0' style='fill:%23452c25' /%3E %3Cpath d='m 598.819,205.264 c 0,0 -10.125,21.095 -7.81,22.654 0,0 8.411,-9.485 10.606,-17.021 2.194,-7.536 0,-0.52 0,-0.52 l 2.811,-13.559' transform='matrix(2.9630465,0,0,3.0271457,-793.65832,-153.42246)' id='path4747-0-4' style='fill:none;stroke:%23000000;stroke-width:0.47299999' /%3E %3Cpath d='m 1367.8396,353.13405 35.6189,20.2092 c 0,0 8.6875,7.20462 -10.3854,2.96357 -19.0733,-4.24102 -59.7471,-18.27786 -136.5847,-67.72631 -34.7387,-22.3585 -45.7021,-21.72886 -45.7021,-21.72886 l 48.4223,1.31376 108.631,64.96861 z' id='path6051-6-0' style='fill:%23452c25' /%3E %3Cpath d='m 1367.8396,353.13405 35.6189,20.2092 c 0,0 8.6875,7.20462 -10.3854,2.96357 -19.0733,-4.24102 -59.7471,-18.27786 -136.5847,-67.72631 -34.7387,-22.3585 -45.7021,-21.72886 -45.7021,-21.72886 l 48.4223,1.31376 108.631,64.96861 z' id='path6053-6-2' style='fill:none;stroke:%23000000;stroke-width:1.27883279' /%3E %3Cpath d='m 1379.6118,344.34622 35.6189,20.20923 c 0,0 8.6878,7.2046 -10.3886,2.96358 -19.0701,-4.241 -59.7437,-18.2779 -136.5815,-67.72634 -34.7388,-22.35848 -6.7914,18.44443 -6.7914,18.44443 l 5.8875,-26.82963 112.2551,52.93873 z' id='path6055-6-5' style='fill:%23452c25' /%3E %3Cpath d='m 1379.6118,344.34622 35.6189,20.20923 c 0,0 8.6878,7.2046 -10.3886,2.96358 -19.0701,-4.241 -59.7437,-18.2779 -136.5815,-67.72634 -34.7388,-22.35848 -6.7914,18.44443 -6.7914,18.44443 l 5.8875,-26.82963 112.2551,52.93873 z' id='path6057-6-3' style='fill:none;stroke:%23000000;stroke-width:1.27883279' /%3E %3Cpath d='m 1438.861,363.80169 c 0,0 -42.5317,-7.90384 -58.0166,-19.23747 0,0 2.7202,4.89183 -18.0804,-4.58012 0,0 8.0181,18.23556 -50.5348,-21.65918 -58.5558,-39.88874 -38.084,-19.83995 -38.084,-19.83995 l 16.3797,-4.2259 c 0,0 89.8959,35.91712 99.7541,39.67379 9.861,3.7567 48.582,29.86883 48.582,29.86883' id='path6059-6-8' style='fill:%23452c25' /%3E %3Cpath d='m 1438.861,363.80169 c 0,0 -42.5317,-7.90384 -58.0166,-19.23747 0,0 2.7202,4.89183 -18.0804,-4.58012 0,0 8.0181,18.23556 -50.5348,-21.65918 -58.5558,-39.88874 -38.084,-19.83995 -38.084,-19.83995 l 16.3797,-4.2259 c 0,0 89.8959,35.91712 99.7541,39.67379 9.861,3.7567 48.582,29.86883 48.582,29.86883 z' id='path6061-0-0' style='fill:none;stroke:%23000000;stroke-width:1.24588883' /%3E %3Cpath d='m 1216.4843,379.7366 14.2494,20.32123 c 0,0 -4.7381,19.04982 -54.2031,-18.01759 -49.465,-37.06435 -46.8547,-33.99785 -46.8547,-33.99785 l 27.3193,-3.81116 59.9929,34.04627' id='path6063-0-3' style='fill:%23452c25' /%3E %3Cpath d='m 1216.4843,379.7366 14.2494,20.32123 c 0,0 -4.7381,19.04982 -54.2031,-18.01759 -49.465,-37.06435 -46.8547,-33.99785 -46.8547,-33.99785 l 27.3193,-3.81116 59.9929,34.04627' id='path6065-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1152.2365,389.92297 c 0,0 22.9756,30.05648 17.8584,33.79504 -5.1142,3.73547 -32.244,2.12806 -51.6163,-27.28671 -19.3723,-29.41475 -0.4061,-1.49842 -0.4061,-1.49842 l 1.7987,-47.55645 32.8662,41.08741' id='path6067-4-8' style='fill:%23452c25' /%3E %3Cpath d='m 1152.2365,389.92297 c 0,0 22.9756,30.05648 17.8584,33.79504 -5.1142,3.73547 -32.244,2.12806 -51.6163,-27.28671 -19.3723,-29.41475 -0.4061,-1.49842 -0.4061,-1.49842 l 1.7987,-47.55645 32.8662,41.08741' id='path6069-1-9' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1175.8283,376.08888 c 0,0 22.1191,28.53994 19.7013,32.88089 -2.4118,4.34392 -33.589,1.5832 -58.4402,-26.57834 -24.8509,-28.15851 -3.6948,-37.15826 -3.6948,-37.15826 l 42.0339,29.36031' id='path6071-0-0' style='fill:%23452c25' /%3E %3Cpath d='m 1175.6285,375.34119 c 0,0 22.3189,29.28763 19.9011,33.62858 -2.4118,4.34392 -33.589,1.5832 -58.4402,-26.57834 -24.8509,-28.15851 -3.6948,-37.15826 -3.6948,-37.15826 l 42.2339,30.10802 z' id='path6073-1-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1301.8644,359.2398 c 0,0 63.0359,27.11415 16.2851,25.34025 0,0 -91.5791,-24.6652 -138.961,-65.24714 l 13.399,-17.71783 108.5452,56.04457' id='path6075-1-0' style='fill:%23452c25' /%3E %3Cpath d='m 1301.8644,359.2398 c 0,0 63.0359,27.11415 16.2851,25.34025 0,0 -91.5791,-24.6652 -138.961,-65.24714 l 13.399,-17.71783 108.5452,56.04457' id='path6077-7-9' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1334.9469,351.41763 c 0,0 34.1194,20.69963 36.6558,28.56721 2.5424,7.86756 -106.0238,-20.27886 -163.2993,-67.96852 l 25.58,-12.52328 101.0635,51.92459 z' id='path6079-0-3' style='fill:%23452c25' /%3E %3Cpath d='m 1334.9469,351.41763 c 0,0 34.1194,20.69963 36.6558,28.56721 2.5424,7.86756 -106.0238,-20.27886 -163.2993,-67.96852 l 25.58,-12.52328 101.0635,51.92459 z' id='path6081-6-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1235.8478,370.1678 c 0,0 24.6733,20.25764 21.8733,22.60975 -2.7972,2.35208 -52.8402,-5.13402 -92.1211,-35.36614 l 4.7053,-18.06297 66.0284,29.85066' id='path6083-7-5' style='fill:%23452c25' /%3E %3Cpath d='m 1235.8478,370.1678 c 0,0 24.6733,20.25764 21.8733,22.60975 -2.7972,2.35208 -52.8402,-5.13402 -92.1211,-35.36614 l 4.7022,-18.06297 66.0315,29.85066' id='path6085-7-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1278.0505,368.45139 c 0,0 24.3383,16.78857 19.2953,18.5564 -5.049,1.76482 -24.1429,16.77039 -114.7468,-36.2985 l -10.6759,-5.86662 14.3827,-22.59759 91.792,44.72906' id='path6087-6-1' style='fill:%23452c25' /%3E %3Cpath d='m 1278.0743,367.71278 c 0,0 24.3145,17.52718 19.2715,19.29501 -5.049,1.76482 -24.1429,16.77039 -114.7468,-36.2985 l -10.6759,-5.86662 14.3827,-22.59759 91.7685,45.4677 z' id='path6089-0-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1185.0641,318.73961 c 0,0 29.4468,26.37552 25.6927,30.16853 -3.7603,3.79302 -38.8159,-4.55582 -54.2741,-16.04691 -15.4583,-11.49103 -26.7179,-26.2181 -26.7179,-26.2181 l 32.8574,-7.0835 22.4419,19.17998 z' id='path6091-6-3' style='fill:%23452c25' /%3E %3Cpath d='m 1185.0641,318.73961 c 0,0 29.4468,26.37552 25.6927,30.16853 -3.7603,3.79302 -38.8159,-4.55582 -54.2741,-16.04691 -15.4583,-11.49103 -26.7179,-26.2181 -26.7179,-26.2181 l 32.8574,-7.0835 22.4419,19.17998 z' id='path6093-2-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1149.958,274.69765 53.6518,31.97877 c 0,0 43.785,30.91019 39.1628,33.68004 -4.6314,2.76985 -39.1419,-8.02194 -63.6048,-21.36561 -24.4601,-13.34062 -52.8342,-42.07126 -52.8342,-42.07126' id='path6095-1-9' style='fill:%23452c25' /%3E %3Cpath d='m 1149.958,274.69765 53.6518,31.97877 c 0,0 43.785,30.91019 39.1628,33.68004 -4.6314,2.76985 -39.1419,-8.02194 -63.6048,-21.36561 -24.4601,-13.34062 -52.8342,-42.07126 -52.8342,-42.07126' id='path6097-2-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1116.0962,425.93689 c 0,0 9.9916,25.57332 4.0209,27.79526 -5.9705,2.22494 -20.765,-2.33089 -32.6498,-25.51883 -11.8846,-23.1849 10.3515,-13.38402 10.3515,-13.38402 l 18.2774,11.10762 z' id='path6099-5-7' style='fill:%23452c25' /%3E %3Cpath d='m 1116.0962,425.93689 c 0,0 9.9916,25.57332 4.0209,27.79526 -5.9705,2.22494 -20.765,-2.33089 -32.6498,-25.51883 -11.8846,-23.1849 8.0589,-12.87454 8.0589,-12.87454 l 20.57,10.59814 z' id='path6101-9-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1133.8924,409.39958 c 0,0 14.9989,24.79237 11.7308,27.61968 -3.2713,2.82736 -23.0527,11.38814 -44.6058,-20.58458 -21.5473,-31.96967 22.1755,-25.24033 22.1755,-25.24033 l 10.6995,18.20523 z' id='path6103-1-8' style='fill:%23452c25' /%3E %3Cpath d='m 1133.8924,409.39958 c 0,0 14.9989,24.79237 11.7308,27.61968 -3.2713,2.82736 -23.0527,11.38814 -44.6058,-20.58458 -21.5473,-31.96967 22.1755,-25.24033 22.1755,-25.24033 l 10.6995,18.20523 z' id='path6105-1-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1089.0584,297.52839 c 0,0 51.1748,98.80911 46.917,104.0612 -4.2638,5.25512 -24.4717,-0.0181 -35.7967,-26.13942 -11.3307,-26.12728 -20.5902,-60.04646 -20.5902,-60.04646 l 9.4699,-17.87529 z' id='path6107-7-4' style='fill:%23452c25' /%3E %3Cpath d='m 1089.0584,297.52839 c 0,0 51.1748,98.80911 46.917,104.0612 -4.2638,5.25512 -24.4717,-0.0181 -35.7967,-26.13942 -11.3307,-26.12728 -20.5902,-60.04346 -20.5902,-60.04346 l 9.4699,-17.87829 z' id='path6109-7-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1148.6781,322.67187 c 0,0 42.6974,36.29547 33.9297,40.86646 -8.7705,4.57704 -25.7548,-2.0433 -50.7302,-26.75391 -24.9727,-24.71059 16.3975,-15.60795 16.3975,-15.60795' id='path6111-7-5' style='fill:%23452c25' /%3E %3Cpath d='m 1148.4767,321.92416 c 0,0 42.8988,37.04318 34.1311,41.61417 -8.7705,4.57704 -25.7548,-2.0433 -50.7302,-26.75391 -24.9727,-24.71059 16.5991,-14.86026 16.5991,-14.86026 z' id='path6113-4-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1127.978,323.28334 c 0,0 30.5194,56.04159 26.7119,61.31486 -3.8073,5.27026 -26.706,-13.9279 -37.9922,-28.20995 -11.2862,-14.27906 -19.8285,-35.0362 -19.8285,-35.0362' id='path6115-3-8' style='fill:%23452c25' /%3E %3Cpath d='m 1127.978,323.28334 c 0,0 30.5194,56.04159 26.7119,61.31486 -3.8073,5.27026 -26.706,-13.9279 -37.9922,-28.20995 -11.2862,-14.27906 -19.8285,-35.0362 -19.8285,-35.0362' id='path6117-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 899.2785,438.36939 c 0,0 -1.80751,33.03523 0,35.50238 1.81034,2.46408 18.56921,2.46408 19.46999,-22.189 0.90672,-24.6561 -3.62069,-25.6399 -3.62069,-25.6399 l -16.30267,11.33965' id='path6119-2-2' style='fill:%23452c25' /%3E %3Cpath d='m 899.2785,438.36939 c 0,0 -1.80751,33.03523 0,35.50238 1.81034,2.46408 18.56921,2.46408 19.46999,-22.189 0.90672,-24.6561 -3.62069,-25.6399 -3.62069,-25.6399 l -16.30267,11.33965' id='path6121-2-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 909.30544,398.55938 c 0,0 -11.77215,36.97963 -0.45052,44.37798 11.31879,7.3953 20.37698,-36.48923 20.82724,-46.34865 0.45336,-9.86243 -20.37672,1.97067 -20.37672,1.97067' id='path6123-8-3' style='fill:%23452c25' /%3E %3Cpath d='m 909.30544,398.55938 c 0,0 -11.77215,36.97963 -0.45052,44.37798 11.31879,7.3953 20.37698,-36.48923 20.82724,-46.34865 0.45336,-9.86243 -20.37672,1.97067 -20.37672,1.97067 z' id='path6125-3-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 917.39151,445.76469 c 0,0 2.2637,34.51553 8.60456,35.99278 6.33802,1.48028 16.75034,-9.8594 16.75034,-18.735 0,-8.87558 -10.86568,-29.5843 -10.86568,-29.5843 l -14.94543,10.84927' id='path6127-7-1' style='fill:%23452c25' /%3E %3Cpath d='m 917.39151,445.76469 c 0,0 2.2637,34.51553 8.60172,35.99278 6.34086,1.48028 16.75318,-9.8594 16.75318,-18.735 0,-8.87558 -10.86853,-29.5843 -10.86853,-29.5843 l -14.94258,10.84927' id='path6129-2-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 917.69366,404.43207 c 0,0 -11.77215,36.97963 -0.45336,44.3749 11.32189,7.39836 20.37982,-36.48618 20.83034,-46.34558 0.45336,-9.86242 -20.37698,1.97068 -20.37698,1.97068 z' id='path6133-6-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 918.60943,345.08791 c 0,0 -17.20939,17.75115 -16.75318,27.6136 0.45026,9.8594 25.35775,-13.3134 27.62145,-17.7542 2.26087,-4.43477 -10.86827,-9.8594 -10.86827,-9.8594' id='path6135-9-1' style='fill:%23452c25' /%3E %3Cpath d='m 918.60943,345.08791 c 0,0 -17.20939,17.75115 -16.75318,27.6136 0.45026,9.8594 25.35465,-13.3134 27.62145,-17.7542 2.26087,-4.43477 -10.86827,-9.8594 -10.86827,-9.8594 z' id='path6137-6-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 906.77783,335.14068 c 0,0 -13.5856,25.1465 -9.96181,33.03523 3.62379,7.88877 16.75319,-5.915 23.09405,-14.79063 6.34086,-8.87557 -13.13224,-18.2446 -13.13224,-18.2446' id='path6139-8-7' style='fill:%23452c25' /%3E %3Cpath d='m 906.77783,335.14068 c 0,0 -13.5856,25.1465 -9.96181,33.03523 3.62379,7.88877 16.75319,-5.915 23.09405,-14.79063 6.34086,-8.87557 -13.13224,-18.2446 -13.13224,-18.2446 z' id='path6141-8-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1097.7431,301.82695 c 0,0 21.6926,40.86039 15.7278,43.08236 -5.9645,2.22188 -15.1292,-8.02497 -24.2199,-20.23952 -9.0965,-12.21753 8.4921,-22.84284 8.4921,-22.84284' id='path6143-6-6' style='fill:%23452c25' /%3E %3Cpath d='m 1097.7431,301.82695 c 0,0 21.6926,40.86039 15.7278,43.08236 -5.9645,2.22188 -15.1292,-8.02497 -24.2199,-20.23952 -9.0965,-12.21753 8.4921,-22.84284 8.4921,-22.84284 z' id='path6145-6-9' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1098.244,385.39132 c 0,0 7.8698,34.37019 0.9628,37.53964 -13.5173,6.20262 -21.0495,-24.43209 -21.8642,-35.93222 -0.9155,-12.86539 20.9014,-1.60742 20.9014,-1.60742 z' id='path6149-6-7' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1071.2062,439.88296 c 0,0 1.8282,25.73376 -1.8786,28.04954 -3.7039,2.31274 -12.7885,2.92726 -22.9134,-18.70776 -10.1274,-21.63197 -5.4194,-13.54344 -5.4194,-13.54344 l 24.8928,-12.29928 5.4044,14.03989' id='path6153-5-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1096.1031,433.9997 c 0,0 2.9083,27.25792 -2.5586,28.0208 -5.4639,0.76281 -19.9999,-8.45147 -26.3296,-24.76815 -7.2975,-18.81166 25.3843,-13.26494 25.3843,-13.26494 l 3.5039,10.01229 z' id='path6157-2-2' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1070.4714,350.40656 c 0,0 27.9799,62.60139 23.476,71.51633 -8.8121,17.4515 -34.229,-38.13294 -41.9062,-59.82242 -8.5839,-24.26862 18.4302,-11.69391 18.4302,-11.69391 z' id='path6161-8-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1057.502,360.86234 c 0,0 38.1405,68.90086 22.0511,70.50525 -16.0804,1.6044 -45.3256,-49.97213 -50.2296,-61.95962 -4.9069,-11.99051 28.1785,-8.54563 28.1785,-8.54563 z' id='path6165-4-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1055.2204,375.16559 c 0,0 18.7652,66.03416 6.6759,60.19484 -12.0893,-5.8394 -26.6465,-55.57541 -28.6319,-66.30967 -1.9853,-10.73728 21.956,6.11483 21.956,6.11483 z' id='path6169-4-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1121.1512,281.27569 c 0,0 28.9283,44.19024 19.5473,45.50099 -9.3839,1.31077 -43.6871,-29.52374 -44.0043,-34.63052 -0.3112,-5.10376 24.457,-10.8705 24.457,-10.8705 z' id='path6173-9-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1103.0676,283.13736 c 0,0 36.8873,50.34749 25.7608,52.90544 -11.1263,2.55488 -11.9588,-5.3157 -11.9588,-5.3157 0,0 -29.4349,-26.5299 -31.4084,-33.24105 -1.9762,-6.71425 16.5222,-14.9965 16.5222,-14.9965' id='path6177-8-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1139.6111,283.91834 c 0,0 25.3665,26.16667 18.7085,35.02105 -6.652,8.85743 -41.8884,-33.12908 -46.6856,-38.46288 -4.7973,-5.33989 30.7298,2.41564 30.7298,2.41564' id='path6185-2-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1078.1131,320.27133 c 0,0 40.8426,79.56855 33.3224,87.6571 -7.5172,8.09155 -52.9141,-59.656 -54.4965,-69.47909 -1.5762,-9.82308 21.5918,-19.66736 21.5918,-19.66736' id='path6189-1-0' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1054.6221,327.4699 c 0,0 16.338,24.89524 15.4106,38.31157 -0.9245,13.40722 -24.6971,-19.19816 -26.7444,-25.33723 -2.0533,-6.14207 11.3338,-12.97434 11.3338,-12.97434 z' id='path6193-9-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.65319824' /%3E %3Cpath d='m 1088.2199,314.57424 c 0,0 12.7055,25.68837 8.8093,33.42276 -3.8905,7.73129 -21.2007,-15.60497 -27.2275,-24.73481 -6.03,-9.12988 18.4182,-8.68792 18.4182,-8.68792 z' id='path6197-3-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1029.2881,339.8237 c 0,0 19.9352,22.11634 18.9781,33.90703 -0.9571,11.79073 -29.9058,-17.20022 -32.4422,-22.63094 -2.5336,-5.42465 13.4641,-11.27609 13.4641,-11.27609 z' id='path6201-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.70111728' /%3E %3Cpath d='m 1158.1508,276.00842 c 0,0 30.1786,27.07479 25.4971,31.32186 -4.6817,4.2471 -45.5065,-24.98906 -51.6548,-30.67102 -6.1454,-5.67894 26.1577,-0.65084 26.1577,-0.65084 z' id='path6205-9-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1132.6359,274.05289 23.6038,19.87929 c 0,0 21.9265,14.65438 18.1724,18.4474 -3.7543,3.79301 -38.102,-11.92995 -44.1968,-19.08614 -6.0981,-7.15921 -5.3899,-14.53032 -5.3899,-14.53032 l 7.8105,-4.71023 z' id='path6209-2-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1210.4159,280.31001 c 0,0 89.3714,36.23796 85.896,44.97732 -3.4757,8.73936 -93.6975,-29.0152 -107.8551,-38.97147 -14.1545,-9.95933 20.6199,-6.55682 20.6199,-6.55682' id='path6213-4-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1213.6427,291.78892 c 0,0 67.113,37.7909 59.2846,41.4174 -7.8284,3.62653 -55.8681,-9.20554 -80.6598,-26.01225 -24.7948,-16.80972 -35.3522,-26.12426 -35.3522,-26.12426 l 30.6081,-7.13196 26.1193,17.85107 z' id='path6217-4-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1048.4234,337.71983 c 0,0 12.7055,25.68836 8.8121,33.42273 -3.8937,7.73434 -16.5369,-6.60226 -22.5637,-15.72907 -6.0327,-9.13291 13.7516,-17.69366 13.7516,-17.69366 z' id='path6221-9-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1051.4426,395.64727 c 0,0 10.4834,37.43674 -1.0846,44.36283 -11.5674,6.9261 -19.0967,-37.29744 -19.2063,-47.16899 -0.1138,-9.87455 20.2909,2.80616 20.2909,2.80616 z' id='path6225-7-7' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 999.48563,333.97523 c 0,0 37.31657,-16.3829 43.93317,-15.07216 0,0 7.8281,-1.96762 12.0386,-5.24302 4.2137,-3.27537 13.8436,-11.13987 13.8436,-11.13987 0,0 -6.6195,-45.21952 40.9256,-40.63038 47.5479,4.58614 110.1364,10.48604 122.7767,12.45067 12.6373,1.9646 58.9794,15.07215 69.8123,20.31517 10.8328,5.24303 81.4216,37.19455 95.8663,42.43755 8.5544,3.10284 27.4261,14.90265 41.394,24.01433 9.6208,6.27229 -0.2965,1.783 -0.2965,1.783 0,0 -114.3203,-60.68821 -154.7302,-68.80401 -10.113,-2.03121 0.6932,11.57884 0.6932,11.57884 0,0 -26.2614,-10.35585 -37.0942,-14.94196 -10.836,-4.58614 -19.8613,-6.55379 -30.0927,-5.89993 -10.2314,0.65691 -18.0539,-1.30772 -24.0719,-3.27537 -6.0209,-1.9646 -40.3241,-3.27537 -46.3419,-3.93225 -6.018,-0.65389 -10.8331,-1.96463 -10.8331,-1.96463 l 2.4061,3.93228 -16.8509,-2.62154 -4.8148,7.20765 c 0,0 -16.2494,3.27537 -17.4555,-1.96762 -1.2,-5.24003 -9.6299,23.59357 -13.8433,32.11196 -4.2133,8.52141 -19.8613,8.51839 -24.6761,13.76441 -4.812,5.24302 -7.8227,8.51839 -10.2257,9.82916 -2.4087,1.31074 -14.4448,8.51839 -18.661,8.51839 -4.2136,0 -30.0868,1.96762 -30.0868,1.96762 l -6.62256,-10.48601 3.00759,-3.93228 z' id='path6229-6-7' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1048.5477,439.93747 c 0,0 0.6666,33.08667 -1.2296,35.47509 -1.8992,2.39147 -18.6374,1.70432 -18.6909,-22.96996 -0.049,-24.6743 4.5067,-25.47342 4.5067,-25.47342 l 15.8938,11.99956' id='path6233-7-5' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1052.5685,414.55788 c 0,0 -3.1673,-14.3245 -5.4341,-16.30122 -2.2638,-1.97673 0.9067,-3.95042 0.9067,-3.95042 0,0 -5.8847,-14.32745 -9.5085,-16.79457 -3.6238,-2.47015 0.4505,-4.4469 0.4505,-4.4469 0,0 -6.338,-9.88062 -10.8656,-12.84117 -4.5275,-2.9666 0,-3.46002 0,-3.46002 0,0 -4.7319,-13.26494 -15.7664,-19.34345 0,0 -7.3155,-7.695 -14.77662,-9.81401 -7.46987,-2.12204 -25.97395,-4.08967 -48.34505,-3.68102 -23.56808,0.42987 -33.55961,16.76435 -33.55961,16.76435 l -1.50509,18.95295 3.39556,-2.31274 -4.98388,23.59357 c -0.78808,5.3974 4.22552,14.7755 4.5039,26.05464 0.0853,3.569 0.3081,7.3045 0.71131,11.13083 1.07241,10.11974 3.44002,20.86611 8.03567,30.76488 0.36445,0.781 0.69917,3.0756 1.1378,2.33088 1.15253,-1.97974 3.73648,6.68094 6.06248,9.78678 0,0 1.3955,11.77559 2.50952,7.41044 0.43268,-1.69519 4.21362,6.66881 6.54841,11.91486 0.84753,1.91012 5.30671,14.87235 5.13793,8.96943 -0.1861,-6.45689 3.91715,13.75536 3.91715,16.65535 l 5.43414,-7.90387 2.71707,8.89374 4.52483,-0.49645 -1.35725,8.3973 c 0,0 12.67888,-10.371 13.13534,-14.32444 0.44742,-3.95043 0.90362,-6.914 0.90362,-6.914 l 4.07431,-3.95345 6.34086,-9.88059 c 0,0 15.8522,12.35074 17.6597,16.79761 1.8103,4.44385 3.6268,8.3973 3.6268,8.3973 l 4.0741,-3.95345 3.6209,8.89072 2.2669,-4.44385 2.1985,6.17237 0.1913,-0.37841 1.4487,4.07152 c 1.0934,1.02619 3.6298,1.54383 8.3826,-6.40845 6.7914,-11.3609 6.3439,-20.25162 6.7914,-22.22834 0.4533,-1.9767 3.1704,3.457 3.1704,3.457 0,0 5.8875,-10.86747 4.9808,-17.78147 -0.9068,-6.91702 3.6266,-4.44687 3.6266,-4.44687 0,0 0.9039,-18.27788 0,-22.72175 -0.9096,-4.44687 3.1647,-3.457 3.1647,-3.457 0,0 -1.3572,-21.73491 -2.7173,-24.20506 -1.3598,-2.47015 3.1676,-2.96358 3.1676,-2.96358 z' id='path6257-2-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41959441' /%3E %3Cpath d='m 1020.8373,364.27092 c 3.1942,0.95659 4.7559,4.56192 6.1248,7.35899 -0.085,-0.17266 0.2016,-0.98383 0.036,-1.32891 -1.3689,-2.79707 -2.9601,-6.44785 -6.1602,-7.40745 0.026,0.005 -0.2145,1.31382 0,1.37737' id='path6259-5-8' /%3E %3Cpath d='m 1023.7263,377.92939 c 5.9053,4.99481 6.4122,11.8089 6.0831,19.26779 0,0.22409 0.08,1.54383 0.1163,0.69625 0.3497,-7.89178 0.2559,-15.88345 -6.1987,-21.34137 0.1474,0.12717 -0.2696,1.14729 0,1.37733' id='path6261-2-6' /%3E %3Cpath d='m 1035.9962,384.91607 c 3.2506,5.34897 3.5558,11.24585 3.5618,17.42423 0,0.78403 0.137,0.78403 0.137,0 0,-6.56286 -0.168,-12.99856 -3.6654,-18.75315 0.088,0.14216 -0.2275,1.01407 -0.034,1.32892' id='path6263-0-2' /%3E %3Cpath d='m 1040.3016,410.71338 c -0.3673,3.82028 -1.0577,7.5739 -1.7925,11.33665 -0.054,0.26943 0.046,1.31079 0.067,1.18667 0.7496,-3.82933 1.4459,-7.65868 1.8191,-11.55162 0.026,-0.17266 -0.047,-1.51054 -0.096,-0.9717' id='path6265-5-1' /%3E %3Cpath d='m 1036.3253,430.51393 c 0.3081,2.50344 0.6281,4.98574 0.3613,7.51945 -0.026,0.1755 0.039,1.51054 0.096,0.9717 0.3379,-3.18454 0.028,-6.30253 -0.3613,-9.46285 -0.065,-0.54186 -0.1163,0.7931 -0.096,0.9717' id='path6267-8-0' /%3E %3Cpath d='m 1028.7192,405.66408 c 0,4.22893 0.034,8.45181 0.3792,12.66864 0.046,0.53881 0.1137,-0.79312 0.098,-0.97475 -0.32,-3.89292 -0.3407,-7.78885 -0.3407,-11.69389 0,-0.781 -0.137,-0.781 -0.137,0' id='path6269-8-9' /%3E %3Cpath d='m 1025.4865,433.09913 c 0.3287,4.01398 0.3406,8.03706 0.3406,12.06317 0,0.78402 0.137,0.78402 0.137,0 0,-4.35 -0.026,-8.70002 -0.3823,-13.03488 -0.046,-0.53886 -0.1085,0.7931 -0.096,0.97171' id='path6271-3-4' /%3E %3Cpath d='m 1043.5995,429.60884 c 1.748,1.84655 2.8207,4.01398 3.2177,6.55074 0.041,0.26635 0.088,-0.20575 0.093,-0.24814 0.026,-0.30877 0.026,-0.63266 -0.026,-0.94143 -0.4117,-2.59732 -1.4991,-4.84647 -3.286,-6.73842 0.1629,0.1755 -0.2636,1.09882 0,1.37733' id='path6273-6-6' /%3E %3Cpath d='m 1042.5152,401.92253 c 1.7953,1.5015 3.2562,3.32383 4.699,5.16734 -0.168,-0.21505 0.2482,-1.05946 0,-1.3743 -1.4428,-1.84351 -2.9006,-3.66892 -4.699,-5.17039 0.1499,0.12407 -0.2699,1.15036 0,1.37735' id='path6275-4-1' /%3E %3Cpath d='m 1027.6315,422.64335 c -0.026,3.77485 -0.3554,7.51037 -1.0489,11.21864 -0.057,0.26938 0.044,1.31071 0.065,1.18964 0.7705,-4.09873 1.0905,-8.23686 1.1171,-12.40828 0,-0.781 -0.1267,-0.781 -0.1344,0' id='path6277-9-3' /%3E %3Cpath d='m 1019.7055,430.88324 c 0.3081,3.37224 0.3081,6.73237 0,10.10159 0,0.1786 0.052,1.51054 0.096,0.97173 0.3644,-4.02006 0.3644,-8.02799 0,-12.045 -0.047,-0.53886 -0.1086,0.79307 -0.096,0.97168' id='path6279-2-0' /%3E %3Cpath d='m 876.24364,339.48768 c 0,0 -9.05793,34.02208 -2.2637,37.47303 13.29223,6.75359 21.87922,-23.55121 23.09404,-35.00893 1.35698,-12.81995 -20.83034,-2.4641 -20.83034,-2.4641' id='path6281-8-3' style='fill:%23452c25' /%3E %3Cpath d='m 876.24364,339.48768 c 0,0 -9.05793,34.02208 -2.2637,37.47303 13.29223,6.75359 21.87922,-23.55121 23.09404,-35.00893 1.35698,-12.81995 -20.83034,-2.4641 -20.83034,-2.4641 z' id='path6283-8-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 895.83822,339.21522 c 0,0 -17.20629,17.75118 -16.75008,27.61363 0.44741,9.8594 25.35775,-13.3134 27.61861,-17.75422 2.26681,-4.43476 -10.86853,-9.85941 -10.86853,-9.85941' id='path6285-8-0' style='fill:%23452c25' /%3E %3Cpath d='m 895.83822,339.21522 c 0,0 -17.20629,17.75118 -16.75008,27.61363 0.44741,9.8594 25.3549,-13.3134 27.61861,-17.75422 2.26681,-4.43476 -10.86853,-9.85941 -10.86853,-9.85941 z' id='path6287-5-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 602.35455,341.71564 c 0,0 -35.55373,17.84503 -38.66497,25.47952 -3.11692,7.63444 107.23863,-11.56675 167.87148,-54.42203 l -24.59319,-14.56361 -104.61332,43.50612 z' id='path6289-9-1' style='fill:%23452c25' /%3E %3Cpath d='m 602.35455,341.71564 c 0,0 -35.55373,17.84503 -38.66497,25.47952 -3.11692,7.63444 107.23863,-11.56675 167.87148,-54.42203 l -24.59319,-14.56361 -104.61332,43.50612 z' id='path6291-6-3' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 643.91416,348.88695 c 0,0 -64.35149,23.40592 -17.5591,24.35035 0,0 92.72873,-19.30408 142.12861,-57.06169 l -12.47753,-18.46559 -111.28012,49.64219' id='path6293-7-5' style='fill:%23452c25' /%3E %3Cpath d='m 644.32022,348.11957 c 0,0 -64.75755,24.1733 -17.96516,25.11773 0,0 92.72873,-19.30408 142.12861,-57.06169 l -12.47753,-18.46559 -111.68592,50.40955 z' id='path6295-2-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 739.43389,283.54299 c 0,0 -68.37231,35.00895 -60.67731,38.95332 7.695,3.94435 56.14964,-6.90492 81.50765,-22.68242 25.36059,-15.77748 36.22912,-24.65308 36.22912,-24.65308 l -30.33878,-8.38215 -26.72068,16.76433 z' id='path6297-7-6' style='fill:%23452c25' /%3E %3Cpath d='m 739.43389,283.54299 c 0,0 -68.37231,35.00895 -60.67731,38.95332 7.695,3.94435 56.14964,-6.90492 81.50765,-22.68242 25.36059,-15.77748 36.22912,-24.65308 36.22912,-24.65308 l -30.33878,-8.38215 -26.72068,16.76433 z' id='path6299-2-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 713.61399,360.3326 c 0,0 -24.42751,20.44839 -21.59775,22.77625 2.82976,2.33088 52.77786,-5.54575 91.69149,-36.07751 l -4.92469,-18.02665 -65.66997,30.36528' id='path6301-3-8' style='fill:%23452c25' /%3E %3Cpath d='m 713.61399,360.3326 c 0,0 -24.42751,20.44839 -21.59775,22.77625 2.82976,2.33088 52.77786,-5.54575 91.69149,-36.07751 l -4.92469,-18.02665 -65.66997,30.36528' id='path6303-6-5' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 671.10009,357.1571 c 0,0 -23.47038,17.92376 -18.34409,19.4464 5.12888,1.52571 24.96953,15.59887 112.81183,-41.69891 l 10.36477,-6.36608 -15.49675,-21.88328 -89.46008,49.02467' id='path6305-4-4' style='fill:%23452c25' /%3E %3Cpath d='m 671.0378,356.41849 c 0,0 -23.40809,18.66237 -18.2818,20.18501 5.12888,1.52571 24.96953,15.59887 112.81183,-41.69891 l 10.36477,-6.36608 -15.49675,-21.88328 -89.39805,49.76326 z' id='path6307-7-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 652.96614,289.00395 c -73.87441,25.84275 -147.9507,77.31935 -147.9507,77.31935 7.24164,-2.46712 190.09136,-76.07519 190.09136,-76.07519' id='path6309-1-4' style='fill:%23452c25' /%3E %3Cpath d='m 815.05378,404.34429 c 0,0 -15.84646,24.15963 -12.67888,27.12018 3.17043,2.95752 22.64353,12.32652 45.28137,-18.73805 22.64353,-31.06153 -21.2837,-26.13333 -21.2837,-26.13333 l -11.31879,17.75118 z' id='path6313-6-4' style='fill:%23452c25' /%3E %3Cpath d='m 815.05378,404.34429 c 0,0 -15.84646,24.15963 -12.67888,27.12018 3.17043,2.95752 22.64353,12.32652 45.28137,-18.73805 22.64353,-31.06153 -21.2837,-26.13333 -21.2837,-26.13333 l -11.31879,17.75118 z' id='path6315-9-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 832.26317,421.60507 c 0,0 -10.86853,25.14647 -4.98078,27.6136 5.8844,2.4641 20.82724,-1.48028 33.50896,-24.16265 12.67888,-22.68243 -5.8875,-11.33973 -5.8875,-11.33973 l -22.64068,7.88875 z' id='path6337-3-3' style='fill:%23452c25' /%3E %3Cpath d='m 797.39413,384.13201 c 0,0 -24.00077,29.09086 -19.01999,33.03526 4.98387,3.94437 32.15507,3.45395 52.53205,-25.14653 20.37672,-28.5974 0.45026,-1.47725 0.45026,-1.47725 l -5.88466,-26.1333 -28.53102,18.24457' id='path6317-8-9' style='fill:%23452c25' /%3E %3Cpath d='m 832.26317,421.60507 c 0,0 -10.86853,25.14647 -4.98078,27.6136 5.8844,2.4641 20.82724,-1.48028 33.50896,-24.16265 12.67888,-22.68243 -5.8875,-11.33973 -5.8875,-11.33973 l -22.64068,7.88875 z' id='path6339-5-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 797.39413,384.13201 c 0,0 -24.00077,29.09086 -19.01999,33.03526 4.98387,3.94437 32.15507,3.45395 52.53205,-25.14653 20.37672,-28.5974 0.45026,-1.47725 0.45026,-1.47725 l -5.88466,-26.1333 -28.53102,18.24457' id='path6319-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 774.30008,369.33836 c 0,0 -23.09404,27.6136 -20.83033,32.04838 2.2668,4.44083 33.51205,2.96058 59.32317,-24.15965 25.81111,-27.1202 4.98103,-36.97963 4.98103,-36.97963 l -43.01766,27.61063' id='path6321-1-7' style='fill:%23452c25' /%3E %3Cpath d='m 774.30008,369.33836 c 0,0 -23.09404,27.6136 -20.83033,32.04838 2.2668,4.44083 33.51205,2.96058 59.32317,-24.15965 25.81111,-27.1202 4.98103,-36.97963 4.98103,-36.97963 l -43.01766,27.61063' id='path6323-0-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 733.54639,371.31206 -14.94258,19.72183 c 0,0 4.07405,19.22848 54.78955,-15.77745 50.7155,-35.00898 48.00128,-32.04843 48.00128,-32.04843 l -27.17404,-4.9312 -61.13067,31.55495' id='path6325-3-5' style='fill:%23452c25' /%3E %3Cpath d='m 733.31816,370.5719 -14.71435,20.46199 c 0,0 4.07405,19.22848 54.78955,-15.77745 50.7155,-35.00898 48.00128,-32.04843 48.00128,-32.04843 l -27.17404,-4.9312 -60.90244,32.29509 z' id='path6327-9-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 571.7878,341.10717 -32.14629,14.44861 c 0,0 -7.26541,6.36909 11.61526,6.84434 18.88042,0.47526 57.88605,-4.74349 125.74581,-43.22159 30.68229,-17.39999 50.11404,-33.98274 50.11404,-33.98274 l -24.72088,-9.18437 -130.60794,65.09575 z' id='path6329-5-8' style='fill:%23452c25' /%3E %3Cpath d='m 571.7878,341.10717 -32.14629,14.44861 c 0,0 -7.26541,6.36909 11.61526,6.84434 18.88042,0.47526 57.88605,-4.74349 125.74581,-43.22159 30.68229,-17.39999 50.11404,-33.98274 50.11404,-33.98274 l -24.72088,-9.18437 -130.60794,65.09575 z' id='path6331-1-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 516.73434,361.37998 c 0,0 46.25013,-5.0281 64.62988,-17.07914 0,0 -3.75716,5.6214 19.88794,-3.61139 0,0 -11.77214,21.17791 57.18973,-20.79953 68.96215,-41.98348 0.56296,-0.84758 0.56296,-0.84758 l 76.5889,-43.87848 -4.47701,-8.75148 c 0,0 -146.33602,62.67401 -157.4059,66.1643 -11.07298,3.49337 -56.9765,28.8033 -56.9765,28.8033' id='path6333-6-4' style='fill:%23452c25' /%3E %3Cpath d='m 658.72337,319.46613 76.87038,-44.30227 -4.47701,-8.75148 c 0,0 -146.33602,62.67401 -157.4059,66.1643 -11.07298,3.49337 -56.9765,28.8033 -56.9765,28.8033 0,0 46.25013,-5.0281 64.62988,-17.07914 0,0 -3.75716,5.6214 19.88794,-3.61139 0,0 -11.49067,20.75412 57.47121,-21.22332 z' id='path6335-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 852.64015,420.53949 c 0,0 -4.52767,36.65876 0.90646,38.01489 5.4344,1.35921 20.8275,-10.18027 27.16836,-32.5842 6.34085,-22.40387 -24.90155,-19.68553 -24.90155,-19.68553 l -4.52741,12.89566' id='path6341-5-4' style='fill:%23452c25' /%3E %3Cpath d='m 852.64015,420.53949 c 0,0 -4.52767,36.65876 0.90646,38.01489 5.4344,1.35921 20.8275,-10.18027 27.16836,-32.5842 6.34085,-22.40387 -24.90155,-19.68553 -24.90155,-19.68553 l -4.52741,12.89566' id='path6343-6-6' style='fill:none;stroke:%23000000;stroke-width:1.66218317' /%3E %3Cpath d='m 876.63781,437.38254 c 0,0 -2.71706,25.63991 0.90673,28.10401 3.62379,2.46715 12.67887,3.454 23.5443,-17.74816 10.86853,-21.2021 5.8875,-13.31337 5.8875,-13.31337 l -24.45103,-13.31338 -5.8875,13.8068' id='path6345-5-5' style='fill:%23452c25' /%3E %3Cpath d='m 876.63781,436.15051 c 0,0 -2.71706,26.87194 0.90673,29.33604 3.62379,2.46715 12.67887,3.454 23.5443,-17.74816 10.86853,-21.2021 5.8875,-13.31337 5.8875,-13.31337 l -24.45103,-13.31338 -5.8875,15.03887 z' id='path6347-3-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 883.42893,389.55664 c 0,0 -19.92335,43.39113 -8.60172,42.8977 11.32189,-0.49342 26.71783,-33.03827 28.9787,-40.4336 2.26681,-7.39832 -20.37698,-2.4641 -20.37698,-2.4641' id='path6349-1-8' style='fill:%23452c25' /%3E %3Cpath d='m 883.42893,389.55664 c 0,0 -19.92335,43.39113 -8.59862,42.8977 11.31595,-0.49342 26.71473,-33.03827 28.9756,-40.4336 2.26681,-7.39832 -20.37698,-2.4641 -20.37698,-2.4641 z' id='path6351-6-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 881.70156,389.17221 c 0,0 -7.49649,47.81981 3.2061,43.76951 10.69948,-4.05033 16.75602,-40.06127 16.95143,-47.85312 0.19644,-7.79795 -20.15753,4.08361 -20.15753,4.08361' id='path6353-9-0' style='fill:%23452c25' /%3E %3Cpath d='m 881.70156,389.17221 c 0,0 -7.49649,47.81981 3.2061,43.76951 10.69948,-4.05033 16.75602,-40.06127 16.95143,-47.85312 0.19644,-7.79795 -20.15753,4.08361 -20.15753,4.08361 z' id='path6355-0-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 897.92125,393.99142 c 0,0 -11.77215,36.97962 -0.45336,44.37495 11.32189,7.39832 20.37698,-36.4862 20.83034,-46.34865 0.45336,-9.85941 -20.37698,1.9737 -20.37698,1.9737' id='path6357-9-6' style='fill:%23452c25' /%3E %3Cpath d='m 897.92125,393.99142 c 0,0 -11.77215,36.97962 -0.45336,44.37495 11.32189,7.39832 20.37698,-36.4862 20.83034,-46.34563 0.45336,-9.86243 -20.37698,1.97068 -20.37698,1.97068 z' id='path6359-7-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 851.51114,381.81928 c 0,0 -11.32706,34.02207 -4.53284,37.47302 13.29223,6.75359 24.14809,-23.55118 25.36007,-35.00892 1.35699,-12.81995 -20.82723,-2.4641 -20.82723,-2.4641 z' id='path6363-2-0' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 767.05845,311.65006 c 0,0 -30.33879,25.14648 -26.72094,29.09083 3.62689,3.94437 38.94645,-2.9575 54.79265,-13.80378 15.84957,-10.84927 22.18733,-16.76732 22.18733,-16.76732 l -27.1681,-16.76433 -23.09094,18.2446 z' id='path6367-4-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 793.77318,286.01011 c 0,0 -19.46715,15.7775 -15.8493,19.72188 3.62379,3.9474 38.48998,-10.35283 44.828,-17.25778 6.34086,-6.9019 5.8875,-14.29723 5.8875,-14.29723 l -34.8662,11.83313 z' id='path6371-5-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 813.6968,283.54299 c 0,0 -26.26448,21.69557 -19.92646,29.5843 6.34086,7.88875 43.02024,-27.1202 47.99817,-31.55498 4.98104,-4.44082 -30.79188,0.98383 -30.79188,0.98383' id='path6375-8-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 801.92464,273.68356 -52.97946,25.1465 c 0,0 -44.83085,29.09088 -40.30318,32.0484 4.52741,2.96055 39.39645,-6.40845 64.3011,-18.73497 24.90439,-12.32658 52.52869,-33.03528 52.52869,-33.03528' id='path6379-1-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 816.68655,302.30223 c 0,0 -57.32905,49.28496 -48.72138,54.21618 8.59862,4.92815 46.93663,-15.71073 72.74464,-39.37998' id='path6383-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 823.94887,318.53379 c 0,0 -32.4394,54.74895 -28.81871,60.17055 3.62405,5.42465 27.16836,-12.81998 38.94336,-26.62375 11.77525,-13.8068 21.03168,-34.19763 21.03168,-34.19763' id='path6387-4-2' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 842.59821,323.36509 c 0,0 -35.15052,65.3228 -31.07646,70.74742 4.07715,5.42163 24.45413,0.98685 36.68248,-24.65308 12.22267,-25.64295 11.17379,-42.18026 11.17379,-42.18026 l -16.77981,-3.91408 z' id='path6391-0-3' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 863.01965,326.49817 c 0,0 -39.06199,80.62199 -31.36389,88.51072 7.70094,7.88875 50.95252,-61.1453 52.93475,-70.89573 3.48163,-17.14881 -22.02422,-19.09526 -22.02422,-19.09526' id='path6395-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 780.64094,273.19013 c 0,0 -35.31955,16.76433 -28.07482,20.21533 7.24164,3.45095 40.30034,-11.33972 44.82801,-12.82 4.53336,-1.48027 -16.75319,-7.39533 -16.75319,-7.39533 z' id='path6399-7-6' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 786.07534,278.61478 c 0,0 -21.73422,17.25776 -17.20655,21.69561 4.52457,4.43777 37.58327,-13.31343 43.92128,-18.73808 6.33802,-5.42465 -26.71473,-2.95753 -26.71473,-2.95753 z' id='path6403-8-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 831.67644,279.99214 c 0,0 -29.70165,39.94015 -20.60211,41.51732 9.10549,1.57413 43.60129,-25.75192 44.07843,-30.48032 0.47999,-4.73145 -23.47632,-11.037 -23.47632,-11.037 z' id='path6407-3-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.50345206' /%3E %3Cpath d='m 844.94205,288.96761 c 0,0 -31.69577,39.93715 -22.64353,42.40428 9.05793,2.4641 9.96181,-3.94438 9.96181,-3.94438 0,0 24.90439,-20.70867 26.71473,-26.13335 1.81345,-5.42465 -13.12939,-12.81995 -13.12939,-12.81995' id='path6411-2-9' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 854.9067,298.33664 c 0,0 -23.09689,39.94017 -17.20939,42.40425 5.88775,2.46712 15.3962,-7.3953 24.90439,-19.23143 9.50844,-11.83007 -7.695,-23.17282 -7.695,-23.17282 z' id='path6415-9-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 860.79135,316.58126 c 0,0 -13.5856,25.14648 -9.96181,33.03523 3.62095,7.88877 16.75319,-5.91505 23.09405,-14.79063 6.34086,-8.87557 -13.13224,-18.2446 -13.13224,-18.2446 z' id='path6419-5-0' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 866.48939,386.38724 c 0,0 -9.05819,34.0221 -2.26397,37.47303 13.28939,6.75359 21.87922,-23.55121 23.09405,-35.00893 1.35724,-12.81995 -20.83008,-2.4641 -20.83008,-2.4641 z' id='path6423-7-4' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 928.7134,340.37463 c 0,0 -9.05819,-2.95752 -15.84956,-2.95752 0,0 -19.92336,-15.77751 -30.79189,-17.25778 -10.86543,-1.48028 -1.58522,-1.72546 -1.58522,-1.72546 0,0 -1.13185,-25.88817 -4.30228,-27.85882 0,0 -1.81034,-26.62677 -18.56353,-28.59747 -16.75603,-1.97368 -54.34239,1.47725 -61.13351,-0.98685 -6.79138,-2.46713 -27.60389,-11.14895 -67.01533,-0.4934 -40.3329,10.90376 -119.68333,46.53328 -123.75764,47.52013 -4.07716,0.98685 91.15541,-20.89336 117.87014,-32.72951 0,0 26.71474,-1.97067 34.8662,-4.43477 0,0 -30.33568,14.79065 -2.26397,8.38217 28.07508,-6.4115 21.73422,0 21.73422,0 0,0 -2.71732,6.40848 13.13198,2.95753 15.85241,-3.45398 15.85241,0 15.85241,0 0,0 18.11301,6.40847 32.14913,-1.9737 0,0 7.24448,25.14952 16.30267,28.59745 0,0 10.76178,23.04263 33.40246,27.48041 0,0 10.75583,7.62237 13.01954,9.10267 l 12.79157,4.19861 13.68925,-10.70396' id='path6429-1-1' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 743.05484,272.20328 c 0,0 -90.55964,32.54186 -87.39515,41.41743 3.17043,8.8756 94.63963,-25.1465 109.12911,-34.51552 14.49516,-9.36601 -20.37698,-7.3953 -20.37698,-7.3953' id='path6433-0-8' style='fill:%23452c25;fill-opacity:1;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 993.76407,342.37857 c 2.07115,0.34512 3.82514,1.2805 5.6802,2.23709 0.0569,0.0274 0.85043,0.52066 0.99253,0.31787 0.1448,-0.20291 -0.557,-0.82642 -0.60146,-0.86884 -1.11712,-1.10184 -2.46531,-2.14623 -3.85486,-2.86367 -2.36761,-1.21994 -4.67888,-2.49132 -7.33055,-2.93331 -0.5247,-0.0848 1.4309,1.78603 1.56427,1.89502 0.95118,0.76286 2.30532,2.01002 3.54987,2.21584' id='path6735-8-5' /%3E %3Cpath d='m 923.25833,410.75882 c 1.34225,2.57304 1.54954,5.54871 2.89489,8.12179 -0.0853,-0.16646 0.20678,-0.9929 0.0362,-1.32892 -1.34225,-2.57307 -1.54954,-5.54877 -2.8918,-8.12184 0.0827,0.16336 -0.21453,0.99295 -0.0388,1.32897' id='path6737-9-7' /%3E %3Cpath d='m 935.56087,341.01334 c 3.03111,-1.07462 6.24031,-1.10187 9.39575,-1.47722 0.14733,-0.0181 0.0543,-1.38343 0,-1.37738 -3.1526,0.37538 -6.36154,0.40263 -9.39575,1.47725 -0.22229,0.0788 0.0413,1.36223 0,1.37735' id='path6739-7-0' /%3E %3Cpath d='m 953.62968,339.53612 c 2.87112,-1.35918 5.92006,-1.47423 9.03415,-1.47423 0.1008,0 0.1008,-1.3804 0,-1.3804 -3.11409,0.003 -6.16303,0.11812 -9.03415,1.47728 -0.24555,0.11812 0.0775,1.34103 0,1.37735' id='path6741-4-2' /%3E %3Cpath d='m 922.19161,355.51034 c -0.37634,0.0667 -0.39986,0.37236 -0.4208,0.7114 -0.0258,0.30877 -0.031,0.63571 0.0284,0.94146 0.0413,0.26333 0.0853,-0.20574 0.0905,-0.24813 -0.0258,0.25744 0.13699,0.003 0.30216,-0.0274 0.17317,-0.0305 0.0284,-1.38043 0,-1.37735' id='path6743-7-5' /%3E %3Cpath d='m 920.31897,404.18688 c 0,2.54581 0.0258,5.08859 0.39417,7.6072 0.0439,0.26641 0.0931,-0.20575 0.0956,-0.24529 0.0258,-0.3118 0.0258,-0.63267 -0.0284,-0.94449 -0.32309,-2.12808 -0.32594,-4.26827 -0.32594,-6.41752 -0.002,-0.78103 -0.13699,-0.78103 -0.13699,0' id='path6745-4-7' /%3E %3Cpath d='m 938.60103,548.15487 c 0,0 -10.24019,7.92507 -11.39582,11.66057 -1.15279,3.7355 -1.47562,7.33174 -1.47562,7.33174 0,0 9.16752,-1.10792 8.04755,3.9474 0,0 2.97477,1.71334 7.70379,-9.26308 4.72334,-10.97944 9.1944,-15.71694 12.54576,-15.39604 3.35111,0.31482 7.62082,3.57504 9.77209,5.86661 2.15696,2.29457 5.12294,4.00491 8.85658,2.93026 0,0 -3.92026,-5.97257 -1.44616,-7.27726 2.47436,-1.30469 6.24316,-1.05343 6.24316,-1.05343 0,0 -3.12597,-7.44074 -9.84317,-8.51537 -6.7172,-1.07768 -11.36919,-2.94845 -9.77519,-5.87266 1.5971,-2.92424 10.19004,-25.61871 10.19004,-25.61871 l -11.38703,-16.72198 -4.56308,14.54848 c 0,0 1.48441,8.6001 1.54386,10.80387 0.0594,2.20074 -9.05509,21.00232 -10.2818,22.0921 -1.22387,1.09279 -25.63923,10.53145 -28.54601,11.46077 -2.898,0.93236 -8.97522,8.15815 -8.97522,8.15815 l -0.69322,5.42465 c 0,0 4.09188,-3.34497 5.40156,-1.35615 0,0 2.82977,-3.57507 5.37211,-2.23404 2.54234,1.34104 2.14222,1.84958 2.14222,1.84958 0,0 4.51578,-2.97567 5.31576,-4.43475 0.79713,-1.46515 1.01347,-1.2805 1.01347,-1.2805 0,0 2.28128,-0.60542 5.61196,-1.16848' id='path6811-7-8' style='fill:%23bd8759' /%3E %3Cpath d='m 938.60103,548.15487 c 0,0 -10.24019,7.92507 -11.39582,11.66057 -1.15279,3.7355 -1.47562,7.33174 -1.47562,7.33174 0,0 9.16752,-1.10792 8.04755,3.9474 0,0 2.97477,1.71334 7.70379,-9.26308 4.72334,-10.97944 9.1944,-15.71694 12.54576,-15.39907 3.35111,0.31785 7.62082,3.57807 9.77209,5.86964 2.15696,2.29457 5.12294,4.00491 8.85658,2.93026 0,0 -3.92026,-5.97559 -1.44616,-7.27726 2.47436,-1.30469 6.24316,-1.05343 6.24316,-1.05343 0,0 -3.12597,-7.44074 -9.84317,-8.51537 -6.7172,-1.07768 -11.36919,-2.94845 -9.77519,-5.87266 1.5971,-2.92424 10.19004,-25.61873 10.19004,-25.61873 l -11.38703,-16.72196 -4.56308,14.54848 c 0,0 1.48441,8.6001 1.54386,10.80387 0.0594,2.20074 -9.05509,21.00232 -10.2818,22.0921 -1.22387,1.09279 -25.63923,10.53145 -28.54601,11.46077 -2.898,0.93236 -8.97522,8.15815 -8.97522,8.15815 l -0.69322,5.42465 c 0,0 4.09188,-3.34497 5.40156,-1.35615 0,0 2.82977,-3.57507 5.37211,-2.23404 2.54234,1.34104 2.14222,1.84958 2.14222,1.84958 0,0 4.51578,-2.97567 5.31576,-4.43475 0.79713,-1.46515 1.01347,-1.2805 1.01347,-1.2805 0,0 2.28128,-0.60542 5.61196,-1.16848' id='path6813-9-3' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1008.2445,497.78621 c 0,0 0.4149,19.25867 0.4149,22.83979 0,3.58414 -0.4149,8.95733 -2.4713,12.09043 -2.0533,3.13611 -4.1128,4.92818 -7.40164,4.92818 -3.29191,0 -11.92646,-0.44801 -13.57087,2.68509 -1.65035,3.13611 -2.883,4.92818 -2.883,4.92818 0,0 5.34832,-3.13611 6.16897,0 0.82091,3.1331 -2.05331,5.8212 -2.05331,5.8212 0,0 4.93658,0.89605 9.4552,-1.79207 4.52455,-2.68507 6.99275,-3.13308 9.05195,-3.13308 2.0593,0 3.704,2.23705 3.704,2.23705 0,0 1.2324,6.71725 0.8178,10.74941 -0.412,4.02912 -1.2327,12.09343 3.2919,12.09343 0,0 1.6415,-4.03215 3.2888,-4.48019 1.6446,-0.44801 6.1692,4.02915 5.3483,5.37319 0,0 0.8209,-8.50929 -0.8237,-13.43447 -1.6445,-4.92515 -2.4682,-10.30137 -2.4682,-10.30137 0,0 13.9857,4.92821 15.2184,6.71725 1.2355,1.79207 4.5243,4.92818 5.7569,4.48017 1.2327,-0.44801 0,-4.48017 2.4654,-5.37319 2.4712,-0.89602 3.7036,1.34103 3.7036,1.34103 0,0 -4.1126,-9.40231 -10.2815,-12.53844 -6.1693,-3.13308 -10.2818,-3.13613 -12.75,-5.8212 -2.4684,-2.6881 -2.883,-5.8212 -3.2891,-8.95733 -0.4117,-3.13611 0.1086,-30.20787 0.1086,-30.20787 l -10.3914,-2.03726' id='path6815-1-8' style='fill:%23bd8759' /%3E %3Cpath d='m 1008.4502,496.37242 c 0,0 0.2094,20.67246 0.2094,24.25358 0,3.58414 -0.4146,8.95733 -2.471,12.09043 -2.0536,3.13611 -4.1128,4.92818 -7.40188,4.92818 -3.29191,0 -11.9262,-0.44801 -13.57061,2.68509 -1.6444,3.13611 -2.88301,4.92818 -2.88301,4.92818 0,0 5.34833,-3.13611 6.16898,0 0.82375,3.1331 -2.05331,5.8212 -2.05331,5.8212 0,0 4.93632,0.89605 9.45494,-1.79207 4.52459,-2.68507 6.99299,-3.13308 9.05229,-3.13308 2.0592,0 3.7036,2.23705 3.7036,2.23705 0,0 1.2327,6.71725 0.8178,10.74941 -0.4117,4.02912 -1.2324,12.09343 3.2922,12.09343 0,0 1.6413,-4.03215 3.2888,-4.48019 1.6447,-0.44801 6.1692,4.02915 5.3483,5.37319 0,0 0.8209,-8.50929 -0.8237,-13.43447 -1.6444,-4.92515 -2.4682,-10.30137 -2.4682,-10.30137 0,0 13.9855,4.92821 15.2181,6.71725 1.2358,1.79207 4.5246,4.92818 5.7573,4.48017 1.2326,-0.44801 0,-4.48017 2.4653,-5.37319 2.4712,-0.89602 3.7036,1.34103 3.7036,1.34103 0,0 -4.1125,-9.40231 -10.2815,-12.53844 -6.1692,-3.13308 -10.2818,-3.13613 -12.75,-5.8212 -2.4684,-2.6881 -2.8832,-5.8212 -3.289,-8.95733 -0.412,-3.13611 0.1085,-30.20787 0.1085,-30.20787 l -10.5974,-1.65898 z' id='path6817-9-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 922.41079,371.40891 c 0,0 -1.35698,-13.71899 2.4891,-15.19927 0,0 1.36008,-12.57479 18.11611,-10.84932 0,0 5.65927,-9.369 14.71435,-4.4378 0,0 8.60483,-4.18954 13.5856,-1.72544 4.98388,2.46712 11.09366,6.65666 11.54702,7.64351 0,0 7.24164,-1.48027 10.6403,1.23206 3.39866,2.71232 1.81345,11.58794 1.81345,11.58794 0,0 8.14838,6.23895 8.82688,11.74832 0.6785,5.50941 0.6785,7.7283 -1.135,9.20555 0,0 3.6238,2.96055 2.9453,7.15011 -0.6813,4.19264 -4.0771,10.27112 -4.7556,10.27112 -0.6785,0 0.4533,10.93106 -3.16761,14.63019 -3.6238,3.69916 -7.01936,4.4378 -8.60147,4.93123 -1.58547,0.49342 -5.66262,6.4085 -9.51155,7.15014 -3.84892,0.73858 -9.05508,-5.91808 -9.50844,-7.89178 -0.45336,-1.9707 -5.65927,-4.18959 -5.65927,-4.18959 0,0 -11.77525,12.57479 -19.69538,10.60109 -7.92633,-1.97067 -11.77526,-8.63041 -12.4509,-9.86245 -0.68134,-1.23206 -2.94504,-10.35283 -2.94504,-10.35283 0,0 -8.82996,-5.17946 -8.15147,-10.10763 0.67849,-4.93123 4.30229,-10.8493 4.30229,-10.8493 l -3.39867,-10.68585 z' id='path6819-9-5' style='fill:%23dcddde' /%3E %3Cpath d='m 951.84285,527.33112 c -1.07266,0.19386 -1.82223,0.0333 -2.52166,-0.45708' id='path6821-2-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 955.76001,517.37787 c -1.27427,-0.18171 -2.42085,-0.5903 -3.38082,-1.19875' id='path6823-8-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 951.71258,522.4877 c 0.75836,0.42984 1.63536,0.59937 2.52141,0.46013' id='path6825-2-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 943.34788,538.06235 c 0.48593,0.33904 1.06077,0.55096 1.68886,0.59938' id='path6827-6-3' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1013.5928,528.6873 c 1.677,0.29363 3.209,1.18663 4.9363,1.34404' id='path6829-3-5' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1016.4727,523.7591 c -1.3303,0.32997 -2.4681,0.0667 -3.2888,-0.89605' id='path6831-2-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1017.2936,517.9379 c -1.5319,0.19076 -3.1823,0.10288 -4.5245,-0.44801' id='path6833-9-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1011.5364,537.64158 c 1.5646,0.21195 3.0133,0.98081 4.5246,1.34406' id='path6835-2-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1011.9482,543.91082 c 0.7526,-0.1755 1.4668,-0.0364 2.0564,0.44801' id='path6837-6-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1013.1839,560.92943 c 1.0251,-0.1817 2.0236,-0.0333 2.8771,0.44801' id='path6839-9-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 961.76899,538.93116 c -1.29469,0.1998 -2.32884,0.98685 -2.86517,2.25523' id='path6841-03-7' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 970.15153,539.72426 c -1.8044,1.04133 -3.40745,2.50346 -3.64163,4.59823' id='path6843-85-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 918.13513,548.95707 c 1.40455,1.26837 3.4669,2.01908 4.68173,3.19061' id='path6845-5-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1028.3961,542.12177 c -1.0636,0.4904 -1.7749,1.45606 -2.0533,2.6881' id='path6847-90-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1034.1562,543.91082 c -0.7289,0.29363 -1.1732,0.93234 -1.2324,1.79207' id='path6849-2-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 905.16005,560.7387 5.86682,-1.51659 0.56605,0.23005 c 0,0 -3.84918,7.43469 -2.80314,9.23583 1.04889,1.80117 -5.24751,-3.26325 -3.62973,-7.94929' id='path6851-2-5' style='fill:%23d9c0b9' /%3E %3Cpath d='m 905.16005,560.7387 5.86966,-1.51659 0.56321,0.23005 c 0,0 -3.84918,7.43469 -2.80314,9.23583 1.04889,1.80117 -5.24751,-3.26325 -3.62973,-7.94929 z' id='path6853-2-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 927.49263,565.13414 c 0,0 -6.49206,10.84323 1.92873,16.2709 0,0 -0.52134,-10.11673 6.08032,-12.29023 l -8.00905,-3.98067 z' id='path6855-3-8' style='fill:%23d9c0b9' /%3E %3Cpath d='m 927.49263,565.13414 c 0,0 -6.49206,10.84323 1.92873,16.2709 0,0 -0.52134,-10.11673 6.08032,-12.29023 l -8.00905,-3.98067 z' id='path6857-3-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 970.593,555.0174 -1.96155,-5.86056 2.28154,-3.08464 4.60754,-0.0514 1.95561,0.92024 c 0,0 3.70986,8.46088 0.46525,12.89566 0,0 -1.37198,-4.77382 -2.9453,-5.4307 0,0 -3.43407,-0.53884 -4.40309,0.61147' id='path6859-0-9' style='fill:%23d9c0b9' /%3E %3Cpath d='m 970.593,555.0174 -1.96155,-5.86056 2.28154,-3.08464 4.60754,-0.0514 1.95561,0.92024 c 0,0 3.70986,8.46088 0.46525,12.89566 0,0 -1.37198,-4.77382 -2.9453,-5.4307 0,0 -3.43407,-0.53884 -4.40309,0.61147 z' id='path6861-7-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 985.00235,542.6152 3.85771,0 1.46684,3.59926 -0.54822,3.33291 -3.33043,1.53171 c 0,0 -5.49048,-1.39852 -4.13944,5.13405 0,0 -2.57491,-11.99961 2.69354,-13.59793' id='path6863-1-5' style='fill:%23d9c0b9' /%3E %3Cpath d='m 985.00235,542.6152 3.85771,0 1.46684,3.59926 -0.54822,3.33291 -3.33043,1.53171 c 0,0 -5.48764,-1.39852 -4.13944,5.13405 0,0 -2.57491,-11.99961 2.69354,-13.59793 z' id='path6865-4-1' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1012.2415,569.47809 3.9823,-4.39846 4.2816,2.26433 c 0,0 -1.7746,11.60001 -2.4475,12.46579 -0.6725,0.86575 -0.7968,0.99892 -0.7968,1.33193 0,0.33297 -0.6757,-2.19771 -1.9587,-3.66589 -1.2831,-1.46513 -2.6313,-7.86451 -3.0609,-7.9977' id='path6867-6-8' style='fill:%23d9c0b9' /%3E %3Cpath d='m 1012.2415,569.47809 3.9823,-4.39846 4.2816,2.26433 c 0,0 -1.7746,11.60001 -2.4475,12.46579 -0.6725,0.86575 -0.7968,0.99892 -0.7968,1.33193 0,0.33297 -0.6757,-2.19771 -1.9587,-3.66589 -1.2831,-1.46513 -2.6313,-7.86451 -3.0609,-7.9977 z' id='path6869-0-0' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1038.1979,557.8145 c 0,0 6.4267,7.99769 5.6298,10.59804 0,0 6.6105,-6.66579 -1.8993,-16.12864 l -3.7305,5.5306 z' id='path6871-7-0' style='fill:%23d9c0b9' /%3E %3Cpath d='m 1038.1979,557.8145 c 0,0 6.4267,7.99769 5.6298,10.59804 0,0 6.6105,-6.66579 -1.8993,-16.12864 l -3.7305,5.5306 z' id='path6873-7-8' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 1009.9957,356.14911 c 1.2799,0.36628 2.077,1.30164 2.5126,2.55792 0.026,0.0576 0.08,-0.42079 0.08,-0.4783 0,-0.26033 0.039,-0.59635 -0.046,-0.84758 -0.4356,-1.27446 -1.2446,-2.23406 -2.5452,-2.60942 0.026,0.005 -0.2042,1.31984 0,1.37738' id='path6875-1-3' /%3E %3Cpath d='m 1011.4416,378.29567 c 2.006,2.10387 3.4904,4.54677 4.3201,7.35898 -0.065,-0.22409 0.1525,-0.94443 0.036,-1.32891 -0.8357,-2.83036 -2.3408,-5.29446 -4.3558,-7.40742 0.1628,0.17266 -0.2637,1.10492 0,1.37735' id='path6877-9-0' /%3E %3Cpath d='m 1006.7451,362.05504 c 1.9587,1.69522 3.6178,3.67799 5.4194,5.53664 -0.1654,-0.16956 0.2665,-1.10492 0,-1.37732 -1.8016,-1.85563 -3.4607,-3.84148 -5.4194,-5.53668 0.1473,0.13312 -0.2696,1.14426 0,1.37736' id='path6879-5-9' /%3E %3Cpath d='m 1012.1291,398.8742 c 0.5689,3.31474 -0.1913,6.14515 -1.4252,9.07845 -0.1551,0.36018 0.1163,1.13514 0.039,1.32892 1.5734,-3.7537 2.1482,-7.56791 1.4578,-11.59402 -0.026,-0.12096 -0.1189,0.91725 -0.072,1.18665' id='path6881-5-1' /%3E %3Cpath d='m 1017.1869,410.31985 c 0.2608,1.70427 0.3081,3.38434 0,5.08864 -0.054,0.30272 -0.041,0.63269 -0.026,0.94146 0,0.0424 0.044,0.50854 0.093,0.24529 0.4386,-2.4641 0.3732,-4.99786 0,-7.46193 -0.039,-0.26636 -0.088,0.2029 -0.093,0.24529 -0.026,0.30877 -0.026,0.62961 0.026,0.94141' id='path6883-7-7' /%3E %3Cpath d='m 1036.7163,450.62631 c 1.289,4.61638 1.3927,9.33266 1.3955,14.10043 0,0.78405 0.137,0.78405 0.137,0 0,-5.20668 -0.085,-10.38615 -1.4963,-15.42934 0.065,0.23004 -0.1421,0.94143 -0.036,1.32891' id='path6885-9-3' /%3E %3Cpath d='m 1033.4658,460.00439 c -1.0636,3.25722 -2.1391,6.50837 -3.6148,9.59912 -0.1654,0.34508 0.1215,1.1503 0.036,1.32589 1.4785,-3.08772 2.5483,-6.3419 3.6119,-9.5961 0.1267,-0.37838 -0.1034,-1.11399 -0.034,-1.32891' id='path6887-8-9' /%3E %3Cpath d='m 924.36046,428.8702 c 3.02542,3.94133 4.66104,8.65766 7.21217,12.89566 -0.0853,-0.14527 0.22228,-1.01107 0.0362,-1.32892 -2.56017,-4.25012 -4.20742,-8.98759 -7.24474,-12.94407 0.16801,0.221 -0.24813,1.05644 -0.002,1.37733' id='path6889-7-1' /%3E %3Cpath d='m 943.51382,429.33941 c -2.75868,0.36325 -3.43433,-3.60229 -5.78101,-4.42871 0.0388,0.0129 -0.22228,1.29865 0,1.3743 2.33479,0.82642 3.02517,4.79504 5.78101,4.43176 0.15509,-0.0207 0.0414,-1.3834 0,-1.37735' id='path6891-1-8' /%3E %3Cpath d='m 932.65408,447.67181 c 1.98223,3.47819 3.28622,7.31357 5.4194,10.70397 -0.0853,-0.13622 0.23004,-1.01712 0.0388,-1.32889 -2.13628,-3.39042 -3.44001,-7.22278 -5.42224,-10.70399 0.0853,0.15146 -0.21971,1.00502 -0.0362,1.32891' id='path6893-4-3' /%3E %3Cpath d='m 945.31822,452.12775 c 2.2283,2.67903 4.24309,5.49734 5.39873,8.83627 -0.0672,-0.21195 0.168,-0.95358 0.0388,-1.32891 -1.16753,-3.35713 -3.20016,-6.19356 -5.43724,-8.88471 0.16801,0.2029 -0.25589,1.07161 0,1.37735' id='path6895-6-5' /%3E %3Cpath d='m 944.21583,465.3897 c 1.12307,2.31879 2.1275,4.69508 3.25366,7.01387 -0.0827,-0.17266 0.20161,-0.9838 0.0362,-1.32891 -1.12617,-2.31879 -2.13059,-4.69509 -3.25366,-7.01387 0.0827,0.1786 -0.20161,0.98685 -0.0362,1.32891' id='path6897-3-9' /%3E %3Cpath d='m 956.14229,467.97489 c 0.65187,2.43384 1.01322,4.93123 1.03416,7.45584 0,0.781 0.14216,0.78402 0.13699,0 -0.0284,-2.97265 -0.36471,-5.91203 -1.13496,-8.78475 0.0594,0.23625 -0.14216,0.94144 -0.0362,1.32891' id='path6899-8-1' /%3E %3Cpath d='m 951.0664,478.98158 c 0.7824,3.50543 1.8075,6.93821 3.62974,10.038 -0.0827,-0.14836 0.22228,-1.01107 0.0388,-1.32891 -1.79561,-3.05742 -2.82692,-6.43872 -3.59717,-9.89572 -0.0362,-0.12716 -0.13182,0.92022 -0.0724,1.18663' id='path6901-6-3' /%3E %3Cpath d='m 953.99102,432.19403 c 2.85639,1.09278 5.71588,2.17043 8.67281,2.95445 0,-0.003 0.19902,-1.32589 0,-1.37732 -2.95693,-0.78405 -5.81642,-1.86168 -8.67281,-2.9545 0.0517,0.0207 -0.22745,1.28954 0,1.37737' id='path6903-8-7' /%3E %3Cpath d='m 956.15703,444.37527 c 3.40745,1.89799 6.99867,3.41156 10.4772,5.16729 -0.0853,-0.0424 0.2533,-1.25018 0,-1.3743 -3.47853,-1.75576 -7.06975,-3.27235 -10.4772,-5.17039 0.10339,0.0574 -0.25848,1.23209 0,1.3774' id='path6905-5-6' /%3E %3Cpath d='m 959.41043,458.03371 c 1.76304,2.14021 3.68298,4.10481 5.781,5.90598 -0.1525,-0.13027 0.26959,-1.14426 0,-1.37732 -2.09802,-1.80117 -4.01796,-3.76275 -5.781,-5.90601 0.168,0.20575 -0.25072,1.07163 0,1.37735' id='path6907-8-6' /%3E %3Cpath d='m 963.00475,474.98877 c 1.46658,2.34303 2.15696,4.94332 2.51546,7.68292 0.0362,0.26641 0.0879,-0.20884 0.093,-0.24813 0.0258,-0.3118 0.0258,-0.62969 -0.0284,-0.94146 -0.36445,-2.77895 -1.04888,-5.43677 -2.54234,-7.82214 0.0827,0.13931 -0.23004,1.01709 -0.0388,1.32891' id='path6909-0-7' /%3E %3Cpath d='m 973.10562,432.83574 c 0.32309,1.63466 0.70511,3.25118 1.09928,4.86767 -0.0594,-0.23909 0.13441,-0.93539 0.0388,-1.32589 -0.38513,-1.5711 -0.75552,-3.14215 -1.06957,-4.7284 -0.0517,-0.26338 -0.0853,0.1998 -0.0879,0.24529 -0.0258,0.30877 -0.0388,0.64176 0.0258,0.94146' id='path6911-0-0' /%3E %3Cpath d='m 998.41607,422.71906 c -0.71106,1.79507 -1.56169,3.50541 -2.53045,5.16731 -0.1861,0.32087 0.12148,1.18058 0.0362,1.32892 0.96876,-1.66493 1.8194,-3.37225 2.52735,-5.16732 0.1525,-0.36631 -0.11372,-1.13219 -0.0336,-1.32891' id='path6913-2-3' /%3E %3Cpath d='m 1008.846,422.27407 c 0,2.90302 -0.047,5.79091 -0.6876,8.63944 -0.062,0.2664 0.039,1.31079 0.065,1.18667 0.7288,-3.22393 0.7555,-6.52957 0.7586,-9.82308 0,-0.78406 -0.137,-0.78406 -0.137,-0.003' id='path6915-2-8' /%3E %3Cpath d='m 1011.0327,438.26644 c 0.2639,2.49137 0,4.94338 -0.3467,7.4105 -0.039,0.27246 0.057,1.30167 0.067,1.18662 0.4356,-3.18454 0.7111,-6.36003 0.3733,-9.56882 -0.057,-0.53884 -0.1137,0.79315 -0.096,0.9717' id='path6917-3-0' /%3E %3Cpath d='m 1018.9944,453.42942 c -0.4712,3.42677 -2.5392,6.1663 -5.0224,8.39731 -0.2696,0.23908 0.1525,1.23813 0,1.37737 2.5423,-2.28549 4.6075,-5.08256 5.0904,-8.58803 0.041,-0.27245 -0.054,-1.30167 -0.067,-1.18665' id='path6919-6-1' /%3E %3Cpath d='m 993.35801,438.59036 c -0.71985,1.43486 -1.65319,2.72746 -2.53045,4.0594 -0.12148,0.18455 -0.0543,0.64781 -0.0465,0.85063 0,0.0455 0.0388,0.54794 0.0775,0.47828 0.8801,-1.33194 1.8106,-2.62756 2.53045,-4.0594 0.10856,-0.21479 0.0543,-0.61751 0.0465,-0.84761 0.002,-0.0486 -0.0439,-0.54486 -0.0775,-0.4813' id='path6921-4-9' /%3E %3Cpath d='m 996.2679,458.87225 c -1.08171,1.47118 -2.17789,2.92723 -3.615,4.0594 -0.27269,0.21479 0.14474,1.26538 0,1.37737 1.434,-1.13219 2.53045,-2.58822 3.615,-4.05939 0.11373,-0.15431 0.0646,-0.5116 0.0646,-0.69023 0,-0.0757 -0.0931,-0.65386 -0.0646,-0.68715' id='path6923-2-6' /%3E %3Cpath d='m 987.23349,469.57626 c -3.52893,-3.49336 -5.18522,-7.97353 -3.59432,-13.04399 0.1189,-0.3814 -0.10598,-1.10795 -0.0388,-1.3259 -1.77184,5.6426 -0.60147,11.56065 3.63284,15.74722 -0.16284,-0.16051 0.26648,-1.11397 0,-1.37733' id='path6925-9-6' /%3E %3Cpath d='m 975.27472,458.30922 c 0.27243,2.08869 0.25848,4.11388 -0.34377,6.1239 -0.11631,0.38442 0.10081,1.10492 0.0362,1.32891 0.83849,-2.80012 0.75267,-5.76671 0.37918,-8.63949 -0.0388,-0.26635 -0.0879,0.20575 -0.0905,0.24529 -0.0258,0.3118 -0.0258,0.62964 0.0258,0.94144' id='path6927-1-0' /%3E %3Cpath d='m 1002.7509,471.81632 c -0.7496,2.50344 -2.0977,4.69813 -3.25338,7.0139 -0.16801,0.34206 0.12148,1.15638 0.0388,1.32891 1.15558,-2.31576 2.50668,-4.51348 3.25048,-7.0139 0.1164,-0.38442 -0.1008,-1.10492 -0.036,-1.32891' id='path6929-8-6' /%3E %3Cpath d='m 1020.4581,479.19952 c -1.5288,2.69117 -3.2919,5.22485 -5.0609,7.75254 -0.2016,0.29057 0.1215,1.20782 0.039,1.32591 1.7718,-2.52771 3.5289,-5.05837 5.055,-7.74953 0.1861,-0.32689 -0.1215,-1.17753 -0.034,-1.32892' id='path6931-1-6' /%3E %3Cpath d='m 1029.1103,488.49589 c -0.738,4.73145 -1.1084,9.50222 -1.4697,14.27298 -0.026,0.22694 0.057,1.54389 0.1189,0.69625 0.3466,-4.61033 0.7082,-9.21159 1.4192,-13.78258 0.047,-0.26943 -0.052,-1.30167 -0.067,-1.18665' id='path6933-0-2' /%3E %3Cpath d='m 1040.2838,471.92532 c 0.028,1.60742 0.335,3.19361 0.3616,4.79801 0.026,0.96565 0.137,0.0726 0.1266,-0.36629 -0.026,-1.60741 -0.3349,-3.19361 -0.3585,-4.798 -0.026,-0.96566 -0.137,-0.0695 -0.1292,0.36628' id='path6935-8-7' /%3E %3Cpath d='m 921.43894,419.83719 c -0.67255,4.7496 -0.0879,9.2843 1.46088,13.80985 -0.0698,-0.21195 0.16543,-0.95356 0.0362,-1.32891 -1.27427,-3.70824 -2.00316,-7.22882 -1.42832,-11.29429 0.0388,-0.26943 -0.0569,-1.30472 -0.0672,-1.18665' id='path6937-2-2' /%3E %3Cpath d='m 962.38829,361.02277 c 7.62987,-7.00177 17.70721,-14.3759 28.52819,-11.79678 0,0 0.18868,-1.33194 0,-1.37735 -10.82098,-2.57913 -20.89832,4.79501 -28.52819,11.79678 -0.26958,0.24813 0.15767,1.23206 0,1.37735' id='path6955-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 999.06794,369.36258 c -7.65649,-5.2067 -21.02885,-7.1108 -28.52818,-0.6932 -0.27269,0.23005 0.14991,1.24714 0,1.37733 7.49933,-6.41755 20.87169,-4.51346 28.52818,0.6932 -0.12665,-0.0879 0.26648,-1.19875 0,-1.37733' id='path6957-3-8' style='fill:%23ffffff' /%3E %3Cpath d='m 969.84343,381.12305 c 3.13476,10.15608 7.18839,20.49681 5.4163,31.35515 -0.0439,0.27246 0.0491,1.30772 0.0672,1.18968 1.91709,-11.76649 -2.02953,-22.7914 -5.45198,-33.87374 0.0698,0.2241 -0.15249,0.94746 -0.0336,1.32891' id='path6959-0-5' style='fill:%23ffffff' /%3E %3Cpath d='m 957.60008,387.29844 c 1.87548,10.27409 0.67565,20.65114 -0.0259,30.97675 -0.0258,0.22693 0.062,1.54385 0.11632,0.69627 0.74078,-10.95222 1.96439,-21.97106 -0.0258,-32.8597 -0.0258,-0.12096 -0.1189,0.91725 -0.0672,1.18668' id='path6961-9-2' style='fill:%23ffffff' /%3E %3Cpath d='m 973.93532,379.75777 c 9.97964,2.36725 19.73984,9.02092 25.11194,18.01759 -0.0853,-0.14527 0.22487,-1.01107 0.0388,-1.32892 -5.38683,-9.02393 -15.1354,-15.68967 -25.14761,-18.06599 0,0.003 -0.19644,1.33496 -0.002,1.37732' id='path6963-2-1' style='fill:%23ffffff' /%3E %3Cpath d='m 965.03738,393.6433 c 0.0362,6.31465 0.52729,12.6353 -1.30968,18.76527 -0.11114,0.38445 0.10339,1.10495 0.0362,1.32892 1.96749,-6.56282 1.4459,-13.3255 1.41333,-20.09419 0,-0.781 -0.14216,-0.78402 -0.13958,0' id='path6965-0-4' style='fill:%23ffffff' /%3E %3Cpath d='m 980.72669,392.25083 c 6.26978,5.18246 11.23583,13.0167 12.17796,21.30808 0.062,0.54186 0.11631,-0.7931 0.0905,-0.97171 -0.95997,-8.46695 -5.84899,-16.40409 -12.27282,-21.71374 0.14733,0.12406 -0.2639,1.15335 0.002,1.37737' id='path6967-6-5' style='fill:%23ffffff' /%3E %3Cpath d='m 934.55644,409.57214 c 2.07709,-2.96357 4.652,-6.34486 8.13363,-7.60719 0.22487,-0.0848 -0.0439,-1.36221 0,-1.38041 -3.50541,1.27443 -6.07438,4.67392 -8.1693,7.65869 -0.20419,0.29665 0.12148,1.20782 0.0362,1.32891' id='path6969-5-0' style='fill:%23ffffff' /%3E %3Cpath d='m 949.49902,355.57998 c -1.32441,-5.64262 -5.55872,-8.97248 -10.09802,-12.00871 0.10856,0.0726 -0.24038,1.06558 0,1.22601 4.50673,3.01504 8.74698,6.34795 10.06261,11.9663 -0.0465,-0.21479 0.1189,-0.83244 0.0362,-1.1836' id='path6971-4-9' style='fill:%23ffffff' /%3E %3Cpath d='m 940.65433,355.4831 c -5.22684,-2.48224 -10.63125,-2.77287 -16.30551,-2.7759 -0.0982,0 -0.0982,1.37738 0,1.37738 5.67426,0.005 11.07867,0.29365 16.30551,2.7759 -0.0801,-0.0393 0.24297,-1.25931 0,-1.37738' id='path6973-5-0' style='fill:%23ffffff' /%3E %3Cpath d='m 956.98673,354.6113 c 0.69038,-5.42163 -0.11115,-10.54353 -4.78537,-13.88856 0.11631,0.0848 -0.23521,1.03834 0,1.2048 3.9231,2.80921 5.35711,6.71727 4.72618,11.6424 -0.0336,0.23908 0.0439,1.13821 0.0594,1.04136' id='path6975-8-1' style='fill:%23ffffff' /%3E %3Cpath d='m 976.64954,361.02277 c 4.91254,-2.60939 10.26396,-2.12201 15.62108,-2.08267 0.0982,0 0.10597,-1.3743 0,-1.3743 -5.36022,-0.0424 -10.70854,-0.52974 -15.62108,2.07962 -0.2533,0.13622 0.0982,1.32592 0,1.37735' id='path6977-4-0' style='fill:%23ffffff' /%3E %3Cpath d='m 985.48234,374.20296 c 7.57946,0.80219 13.35737,4.69511 18.33816,10.41038 -0.3347,-0.38448 0.5156,-2.16742 0,-2.75472 -4.98364,-5.71223 -10.76154,-9.60817 -18.33816,-10.41037 -0.11373,-0.0129 -0.28742,2.72444 0,2.75471' id='path6979-3-5' style='fill:%23ffffff' /%3E %3Cpath d='m 952.16569,395.09029 c -1.79251,7.24696 -0.42054,16.41014 -8.79713,19.37976 -0.44457,0.15741 0.0827,2.72446 0,2.75473 8.48308,-3.00594 7.06096,-12.16609 8.86536,-19.47969 0.19644,-0.78405 -0.1861,-2.17955 -0.0672,-2.65483' id='path6981-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 969.8256,389.42042 c 2.90678,7.61935 6.963,15.39608 5.39872,23.85393 -0.0982,0.53882 0.0905,2.61849 0.13699,2.3763 1.91994,-10.41941 -1.81344,-19.31925 -5.46696,-28.88503 0.1525,0.40265 -0.35256,1.91924 -0.0672,2.6548' id='path6983-2-6' style='fill:%23ffffff' /%3E %3Cpath d='m 980.72669,388.07941 c 7.38975,0.94144 13.8937,7.51942 14.87435,15.07821 0.0698,0.53281 0.18352,-0.4147 0.1861,-0.49343 0.0336,-0.62661 0.031,-1.26233 -0.0543,-1.88592 -0.99848,-7.69198 -7.4342,-14.4879 -15.00772,-15.45353 -0.0956,-0.0129 -0.30525,2.71836 0,2.75467' id='path6985-3-2' style='fill:%23ffffff' /%3E %3Cpath d='m 980.6613,398.99532 c 1.15874,6.32972 2.95125,12.66557 0.70822,18.99534 -0.26365,0.74468 0.22228,2.23703 0.0724,2.6548 2.79435,-7.89482 0.80902,-16.0681 -0.64592,-24.02951 -0.0439,-0.23909 -0.23005,1.83751 -0.13441,2.37937' id='path6987-8-8' style='fill:%23ffffff' /%3E %3Cpath d='m 976.64954,371.42711 c 8.13053,-1.37435 16.73509,-2.60032 23.77256,2.77585 -0.2787,-0.21505 0.5392,-2.34301 0,-2.75471 -7.03747,-5.37316 -15.64203,-4.15017 -23.77256,-2.77584 -0.33188,0.0574 -0.0569,2.76377 0,2.7547' id='path6989-2-8' style='fill:%23ffffff' /%3E %3Cpath d='m 961.77804,355.27725 c 0.9747,-6.72327 6.89477,-11.52738 12.83887,-13.69178 0.45026,-0.16335 -0.093,-2.71836 0,-2.75165 -6.13356,2.23099 -11.97376,7.17431 -12.97534,14.06409 -0.0905,0.62056 -0.0827,1.26233 -0.0517,1.88592 0,0.0848 0.10856,1.02621 0.1861,0.49342' id='path6991-6-5' style='fill:%23ffffff' /%3E %3Cpath d='m 954.35263,359.31545 c -0.19903,-7.45281 -3.4638,-13.45258 -6.67584,-19.97003 0.14733,0.30272 -0.36445,1.7436 -0.0646,2.35205 2.88016,5.83335 6.33491,11.53645 6.5099,18.2658 0.0465,1.71339 0.2533,0.13311 0.23004,-0.64782' id='path6993-3-8' style='fill:%23ffffff' /%3E %3Cpath d='m 947.51085,363.30829 c -1.449,-6.63552 -5.82831,-11.03398 -11.61526,-14.06716 0.1861,0.0998 -0.50661,2.4883 0,2.75471 5.59154,2.92725 10.06545,7.23486 11.47904,13.6918 0.0594,0.24813 0.25331,-1.84356 0.13699,-2.37935' id='path6995-5-9' style='fill:%23ffffff' /%3E %3Cpath d='m 936.57718,360.65047 c -3.79567,-2.64273 -7.78391,-5.13105 -12.40024,-5.8394 -0.062,-0.0103 -0.25072,2.10994 0,2.14626 4.61633,0.70834 8.60172,3.19366 12.40024,5.83937 -0.20161,-0.14216 0.4208,-1.85566 0,-2.14623' id='path6997-2-7' style='fill:%23ffffff' /%3E %3Cpath d='m 960.25486,391.84216 c 0.65187,7.05021 1.52912,14.17008 -1.97913,20.59973 -0.35876,0.65688 0.24555,2.33998 0.0724,2.6548 4.20148,-7.70712 2.87396,-16.81581 2.09777,-25.20096 -0.0982,-1.0807 -0.22229,1.58922 -0.18869,1.94643' id='path6999-9-7' style='fill:%23ffffff' /%3E %3Cpath d='m 968.46551,388.03098 c 2.35572,6.62944 5.13793,13.68268 4.67268,20.87518 -0.0284,0.45408 0.12406,3.08769 0.23521,1.39252 0.56605,-8.7636 -1.93493,-16.77042 -4.83552,-24.92253 0.14733,0.41474 -0.33498,1.90712 -0.0698,2.65483' id='path7001-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 973.93532,378.3653 c 6.74097,2.07055 13.43155,4.27737 18.3353,9.71411 -0.33188,-0.3693 0.52159,-2.17954 0,-2.75165 -4.90375,-5.43982 -11.59433,-7.64661 -18.3353,-9.71716 0.0491,0.0155 -0.42364,2.62453 0,2.7547' id='path7003-1-5' style='fill:%23ffffff' /%3E %3Cpath d='m 955.69178,363.39 c 0.71416,-5.86662 1.34225,-11.71201 1.39859,-17.62706 0.0258,-1.56808 -0.25588,-1.56503 -0.26958,0 -0.0517,5.25817 -0.68444,10.47092 -1.32158,15.6806 -0.0413,0.35724 0.062,3.02413 0.19386,1.94646' id='path7005-0-9' style='fill:%23ffffff' /%3E %3Cpath d='m 943.3714,359.65147 c -4.97793,-2.26428 -9.40169,-5.49426 -13.5856,-9.01784 0.29957,0.25124 -0.54201,2.29762 0,2.75468 4.18391,3.52663 8.60767,6.75661 13.5856,9.02094 -0.14991,-0.0695 0.48309,-2.53679 0,-2.75778' id='path7007-7-6' style='fill:%23ffffff' /%3E %3Cpath d='m 941.32998,395.04188 c -3.19705,2.02211 -5.39872,4.84339 -6.82679,8.3761 -0.19385,0.47825 -0.10855,1.19569 -0.0956,1.69517 0.002,0.10597 0.1189,1.08072 0.16801,0.95963 1.41023,-3.49332 3.60001,-6.28133 6.7526,-8.2762 0.53349,-0.33602 -0.23779,-2.60642 0,-2.7547' id='path7009-2-4' style='fill:%23ffffff' /%3E %3Cpath d='m 950.03251,400.21524 c -0.12407,4.83135 -2.7853,8.83321 -5.98546,12.17214 -0.52728,0.55096 0.32594,2.41264 0,2.7547 3.85797,-4.02611 6.0979,-8.51534 6.24316,-14.19428 0.0258,-0.87788 -0.20678,-2.6639 -0.25848,-0.73256' id='path7011-1-1' style='fill:%23ffffff' /%3E %3Cpath d='m 972.83319,362.21849 c 4.00891,-6.33277 13.69803,-6.85951 20.16942,-8.62733 0.4058,-0.10908 -0.0258,-2.74563 0,-2.75168 -6.55436,1.78905 -16.18713,2.31879 -20.24076,8.72421 -0.39107,0.61755 0.24296,2.38542 0.0698,2.6548' id='path7013-5-3' style='fill:%23ffffff' /%3E %3Cpath d='m 928.28356,362.1156 c -1.55265,-0.46619 -2.97477,-1.26233 -4.3881,-2.05546 0.12407,0.0695 -0.31999,1.51964 0,1.7013 1.41618,0.79307 2.83545,1.59224 4.3881,2.05842 -0.0284,-0.0103 0.25847,-1.62559 0,-1.70426' id='path7015-6-6' style='fill:%23ffffff' /%3E %3Cpath d='m 929.16366,394.51813 c -1.3986,0.57216 -2.84165,1.15638 -3.80757,2.3945 -0.22745,0.29062 -0.1344,1.03526 -0.1344,1.37737 0,0.32387 0,0.65084 0.0388,0.97168 0,-0.0455 0.0646,0.43894 0.0956,0.40262 0.96592,-1.23508 2.40897,-1.82234 3.80757,-2.39147 0.21453,-0.0879 0.13441,-1.20779 0.13441,-1.37732 0,-0.0695 -0.062,-1.40765 -0.13441,-1.37738' id='path7017-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 935.02169,396.01053 c -2.87422,1.28652 -4.96604,3.77484 -6.76475,6.32067 -0.31689,0.45711 0.18868,1.89802 0.0594,2.08572 1.78088,-2.51856 3.86676,-4.97361 6.70841,-6.24196 0.37634,-0.17266 -0.11631,-2.11294 -0.002,-2.16443' id='path7019-9-3' style='fill:%23ffffff' /%3E %3Cpath d='m 946.11225,398.75618 c -2.50977,6.11483 -9.34845,12.87142 -4.3881,19.70973 -0.17317,-0.23004 0.48593,-2.08569 0.0672,-2.65483 -3.43123,-4.73744 2.61342,-10.06222 4.39119,-14.40009 0.29621,-0.72352 -0.23004,-2.26736 -0.0698,-2.65481' id='path7021-8-1' style='fill:%23ffffff' /%3E %3Cpath d='m 953.92589,398.65326 c 0.19127,6.2329 -0.90957,12.38401 -1.99128,18.48976 -0.0931,0.54189 0.0905,2.61546 0.13958,2.37935 1.26833,-7.16224 2.33194,-14.30328 2.11276,-21.60173 -0.062,-1.92828 -0.28768,-0.14526 -0.2608,0.73262' id='path7023-4-7' style='fill:%23ffffff' /%3E %3Cpath d='m 973.97099,391.2882 c 4.54214,5.94832 8.56321,12.34772 10.50382,19.69763 -0.12148,-0.46618 0.27838,-1.87685 0.0698,-2.6548 -1.95251,-7.39227 -6.00898,-13.81592 -10.57491,-19.79753 0.33473,0.44196 -0.49187,2.10991 0,2.7547' id='path7025-3-4' style='fill:%23ffffff' /%3E %3Cpath d='m 976.31172,386.49924 c 7.46987,5.69103 15.78701,11.04303 21.04952,19.09826 -0.17576,-0.26034 0.46499,-2.04938 0.0672,-2.6548 -5.28913,-8.09763 -13.61222,-13.47686 -21.1206,-19.19814 0.28122,0.21505 -0.53349,2.34601 0.002,2.75468' id='path7027-8-7' style='fill:%23ffffff' /%3E %3Cpath d='m 980.70576,376.67008 c 2.7853,-0.26938 5.3721,-0.16335 8.01809,0.81132 2.36761,0.8748 4.3289,2.83038 6.48328,4.12903 2.17169,1.30772 4.36457,2.49434 6.13637,4.36209 2.3201,2.43988 2.3408,6.59915 3.0252,9.73831 0.044,0.21195 0.2094,-1.57108 0.1163,-2.02819 -0.557,-2.57609 -0.8504,-5.18243 -1.7302,-7.6738 -0.8535,-2.43383 -2.95719,-3.9292 -5.01076,-5.24 -2.45627,-1.57107 -4.86808,-3.16337 -7.30393,-4.76472 -2.8918,-1.90104 -6.42667,-2.00396 -9.73358,-1.68309 -0.24038,0.0233 -0.10597,2.35815 0,2.34905' id='path7029-3-2' style='fill:%23ffffff' /%3E %3Cpath d='m 998.99376,391.9693 c 0.82091,2.41262 1.78964,4.77077 2.61654,7.18041 -0.096,-0.27551 0.2093,-1.23814 0.046,-1.72552 -0.8238,-2.41263 -1.78966,-4.77076 -2.61652,-7.18035 0.0956,0.27848 -0.21453,1.24111 -0.0465,1.72546' id='path7031-1-6' style='fill:%23ffffff' /%3E %3Cpath d='m 978.06882,353.89086 c 5.26225,-1.44699 10.64314,-2.40357 15.81363,-4.18959 0.44147,-0.15147 -0.0749,-2.72749 0,-2.75171 -5.17049,1.783 -10.55138,2.73961 -15.81363,4.18659 -0.40296,0.11192 0.0284,2.74861 0,2.75471' id='path7033-3-6' style='fill:%23ffffff' /%3E %3Cpath d='m 956.14229,356.53351 c 0.73769,-2.79102 1.92899,-5.06442 3.51989,-7.44374 1.95871,-2.92423 2.23424,-6.59008 4.64037,-9.26308 0.51849,-0.57515 -0.32904,-2.38234 0,-2.75165 -1.98223,2.19769 -2.66977,5.02508 -3.81067,7.71015 -1.36293,3.22086 -3.50231,5.6002 -4.42067,9.09352 -0.20677,0.77798 0.19644,2.18862 0.0698,2.6548' id='path7035-8-5' style='fill:%23ffffff' /%3E %3Cpath d='m 938.17429,405.7761 c -0.93619,4.53166 -0.76147,9.26006 0.90956,13.58583 -0.15508,-0.39959 0.35566,-1.91918 0.0698,-2.6548 -1.09334,-2.83945 -1.46968,-5.52152 -0.84443,-8.55168 0.12407,-0.59937 0.0801,-1.27745 0.0465,-1.88592 0,-0.0938 -0.0775,-1.01409 -0.18351,-0.49343' id='path7037-9-0' style='fill:%23ffffff' /%3E %3Cpath d='m 949.07823,414.34596 c -1.88453,2.56702 -1.91115,6.47808 -0.91551,9.42653 0.0388,0.0998 0.15766,-0.79615 0.16025,-0.90512 0.0258,-0.4934 0.0672,-1.11699 -0.0879,-1.5923 -0.55701,-1.64673 -0.14475,-2.99384 0.84443,-4.3379 0.20936,-0.28757 0.12665,-0.96565 0.12665,-1.29562 0,-0.14526 -0.18093,-1.22899 -0.12665,-1.29559' id='path7039-9-6' style='fill:%23ffffff' /%3E %3Cpath d='m 957.18213,409.99294 c -0.0853,2.60938 -1.47846,5.0886 -2.5687,7.3832 -0.23521,0.5025 0.17576,1.66188 0.0569,1.91616 1.35104,-2.84855 2.59559,-5.56689 2.70208,-8.77265 0.0258,-0.63269 -0.13958,-1.91616 -0.18869,-0.52671' id='path7041-3-0' style='fill:%23ffffff' /%3E %3Cpath d='m 957.43414,394.69674 0,3.29054 c 0,0.0969 -0.0258,1.37732 0.13441,1.37732 0.16025,0 0.13699,-1.28047 0.13699,-1.37732 l 0,-3.29054 c 0,-0.0938 0.0258,-1.37735 -0.13699,-1.37735 -0.15509,0 -0.13441,1.28654 -0.13441,1.37735' id='path7043-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 953.72738,396.62505 c 0.20936,0.3875 0.38513,0.77495 0.52729,1.19877 0.093,0.58118 0.13699,0.61144 0.1344,0.0907 -0.0284,0.23004 -0.062,0.45706 -0.10597,0.68111 -0.11115,0.60842 -0.0801,1.27137 -0.0465,1.88589 0.002,0.0879 0.0827,1.02017 0.18352,0.49345 0.41485,-2.25825 0.50971,-4.94639 -0.6193,-7.00482 -0.0672,-0.13311 -0.16284,0.86575 -0.16542,0.9626 0,0.44197 -0.12924,1.2835 0.0956,1.6922' id='path7045-1-5' style='fill:%23ffffff' /%3E %3Cpath d='m 948.45608,394.86932 c -0.54512,1.71031 -0.90956,3.45095 -1.20293,5.22482 -0.1008,0.6115 -0.0853,1.26536 -0.0465,1.8829 0.002,0.0848 0.0956,1.02317 0.18352,0.49343 0.27838,-1.67703 0.62215,-3.32379 1.14064,-4.94635 0.16284,-0.51464 0.10339,-1.16246 0.093,-1.6922 0,-0.12406 -0.1344,-1.0716 -0.16542,-0.9626' id='path7047-7-2' style='fill:%23ffffff' /%3E %3Cpath d='m 944.39366,395.11753 c -2.46221,3.01506 -5.74533,5.016 -9.0786,6.88071 -0.51566,0.2906 0.20419,2.63965 0,2.7547 3.33327,-1.8647 6.61639,-3.86567 9.0786,-6.88071 0.22487,-0.28153 0.13441,-1.04438 0.13441,-1.37732 0,-0.13932 -0.17835,-1.32594 -0.13441,-1.37738' id='path7049-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 937.36552,396.31325 c -1.5025,1.19575 -3.18232,2.06148 -4.98103,2.69115 -0.44147,0.15741 0.0801,2.72743 0,2.75467 1.79561,-0.62961 3.47853,-1.49842 4.98103,-2.69112 0.23521,-0.18765 0.13441,-1.12611 0.13441,-1.37735 0,-0.0907 -0.12407,-1.38342 -0.13441,-1.37735' id='path7051-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 927.40656,393.86427 c -1.45184,0.64479 -2.93935,1.20482 -4.3912,1.85263 -0.38822,0.16956 0.11373,2.15836 0,2.20982 1.45185,-0.64479 2.93936,-1.2048 4.3912,-1.85261 0.38823,-0.17266 -0.11631,-2.15835 0,-2.20984' id='path7053-3-0' style='fill:%23ffffff' /%3E %3Cpath d='m 957.73345,392.66855 c 0.0284,1.80117 0.3081,3.55088 0.64877,5.31268 0.10081,0.52067 0.18093,-0.40265 0.1861,-0.49645 0.0336,-0.60847 0.0646,-1.2805 -0.0465,-1.88292 -0.2378,-1.2078 -0.50971,-2.43079 -0.52729,-3.66585 -0.002,-0.11502 -0.12665,-1.07163 -0.16542,-0.9596 -0.17835,0.49947 -0.10081,1.17452 -0.0956,1.69214' id='path7055-3-8' style='fill:%23ffffff' /%3E %3Cpath d='m 962.41492,390.51022 c 0.0258,2.10689 0.22745,4.13505 0.9778,6.11483 0.0414,0.11502 0.16284,-0.85366 0.16542,-0.96266 0.0258,-0.50854 0.0879,-1.20479 -0.0956,-1.69217 -0.41485,-1.09582 -0.76741,-2.27337 -0.7793,-3.46 0,-0.0938 0.0258,-1.37735 -0.13699,-1.37735 -0.15508,0 -0.1344,1.28353 -0.1344,1.37735' id='path7057-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 966.02398,390.04099 c 0.62808,0.88695 1.34225,2.09782 1.37197,3.22696 0.002,0.11502 0.12407,1.07463 0.16284,0.96263 0.18351,-0.4995 0.10597,-1.17758 0.0956,-1.69522 -0.0439,-1.89497 -0.45336,-3.59319 -1.55575,-5.14917 -0.0956,-0.13622 -0.16542,0.86575 -0.168,0.96266 0,0.38745 -0.14733,1.35008 0.0956,1.69214' id='path7059-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 970.45679,388.29736 c 1.5467,0.33604 2.94814,0.96565 4.10067,2.09479 -0.0258,-0.0181 0.13441,-1.26838 0.13441,-1.37735 0,-0.2906 0.1008,-1.14728 -0.13441,-1.37732 -1.15253,-1.12917 -2.55113,-1.75878 -4.10067,-2.0948 -0.0258,-0.005 -0.36755,2.67597 0,2.75468' id='path7061-3-5' style='fill:%23ffffff' /%3E %3Cpath d='m 972.80036,384.70719 c 1.81061,1.51055 3.81067,2.63966 6.14546,2.99082 0.0749,0.0129 0.32309,-2.70326 0,-2.75473 -2.33479,-0.35113 -4.33485,-1.48027 -6.14546,-2.99079 -0.002,-0.003 -0.13699,1.28348 -0.13699,1.37733 0,0.26036 -0.1008,1.18057 0.13699,1.37737' id='path7063-7-2' style='fill:%23ffffff' /%3E %3Cpath d='m 977.77545,372.73783 c 1.58806,0.0181 3.13192,0.28153 4.68456,0.59937 0.0336,0.005 0.36161,-2.68202 0,-2.7547 -1.55264,-0.31782 -3.0965,-0.5812 -4.68456,-0.59935 -0.19644,-0.003 -0.21453,2.75468 0,2.75468' id='path7065-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 975.47013,367.00441 c 0.95118,-1.55896 2.38519,-2.70624 3.76905,-3.84143 0.23521,-0.19075 0.13699,-1.11702 0.13699,-1.3743 0,-0.0938 -0.1344,-1.38043 -0.13699,-1.37735 -1.41927,1.16238 -2.86517,2.33998 -3.84297,3.93827 -0.23521,0.38146 -0.10598,1.27141 -0.0956,1.6922 0.002,0.0938 0.0853,1.0958 0.16801,0.96261' id='path7067-5-4' style='fill:%23ffffff' /%3E %3Cpath d='m 971.10866,361.48293 c 0.27553,-1.82234 0.86821,-3.43583 1.98223,-4.89793 0.22487,-0.29668 0.13699,-1.03224 0.13699,-1.37738 0,-0.14836 -0.1861,-1.31374 -0.13699,-1.37735 -1.20009,1.57718 -1.82224,3.30871 -2.11871,5.27329 -0.093,0.61754 -0.0827,1.26233 -0.0491,1.88595 0,0.0788 0.10598,1.02314 0.1861,0.49342' id='path7069-7-8' style='fill:%23ffffff' /%3E %3Cpath d='m 967.56189,358.928 c 1.8044,-2.53975 3.01328,-5.44887 4.68456,-8.07642 0.2378,-0.37236 0.10598,-1.28353 0.0956,-1.69523 -0.002,-0.0938 -0.0801,-1.09579 -0.16801,-0.9596 -1.66818,2.62758 -2.88016,5.5367 -4.68456,8.07645 -0.24297,0.34206 -0.10339,1.3047 -0.093,1.69215 0.002,0.0938 0.0698,1.09584 0.16542,0.96265' id='path7071-4-6' style='fill:%23ffffff' /%3E %3Cpath d='m 959.48745,349.88894 c 0.0672,3.09072 0.28458,6.17841 0.93929,9.1995 0.11632,0.51767 0.18093,-0.39353 0.1861,-0.49343 0.0388,-0.60237 0.0801,-1.28957 -0.0465,-1.88287 -0.54512,-2.49137 -0.76431,-5.00691 -0.81781,-7.55579 -0.0414,-1.93128 -0.27553,-0.14526 -0.2608,0.73259' id='path7073-8-7' style='fill:%23ffffff' /%3E %3Cpath d='m 946.40562,352.0473 c 0.47404,1.12004 1.09334,2.17045 1.65035,3.24812 0.34971,0.67808 0.66376,1.36826 0.93929,2.07968 0.1008,0.26938 0.1861,0.54183 0.2639,0.82034 -0.16801,-0.56003 0.12148,-0.41167 -0.2197,0.17266 -0.37324,0.64176 0.24555,2.35813 0.075,2.6548 0.79403,-1.36825 0.66971,-3.58716 0.31121,-5.08259 -0.56296,-2.37632 -2.01196,-4.33485 -2.95125,-6.54771 0.16284,0.37838 -0.37323,1.93738 -0.0672,2.6548' id='path7075-2-1' style='fill:%23ffffff' /%3E %3Cpath d='m 943.80409,357.42049 c -1.78967,-1.79815 -3.81946,-3.29959 -5.85493,-4.78592 -0.0258,-0.0129 -0.13699,1.2926 -0.13699,1.37733 0,0.23624 -0.0982,1.20484 0.13699,1.37433 2.03547,1.48937 4.06242,2.99084 5.85493,4.78896 -0.0258,-0.0207 0.1344,-1.26838 0.1344,-1.37733 0,-0.29367 0.10339,-1.14126 -0.1344,-1.37737' id='path7077-2-4' style='fill:%23ffffff' /%3E %3Cpath d='m 952.3673,360.28419 c 1.21198,-6.0422 0.98064,-12.09047 -1.4963,-17.77543 0.16283,0.37234 -0.38229,1.94344 -0.075,2.65481 1.8044,4.14115 2.34668,8.20052 1.43401,12.74124 -0.12148,0.60243 -0.0827,1.27748 -0.0517,1.88595 0,0.0907 0.0827,1.01712 0.1861,0.49343' id='path7079-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 965.18239,352.39541 c 0.20161,0 0.20161,-2.75468 0,-2.75468 -0.20161,0 -0.20161,2.75468 0,2.75468' id='path7081-3-6' style='fill:%23ffffff' /%3E %3Cpath d='m 950.68438,360.55659 c 0.31689,-3.41461 1.12281,-6.75959 1.46373,-10.17422 0.0982,-0.95961 0.0905,-1.95858 0,-2.91819 -0.0646,-0.69924 -0.21453,-0.69622 -0.28768,0 -0.34351,3.41161 -1.14374,6.75357 -1.46373,10.17123 -0.0879,0.96565 -0.0931,1.95855 0,2.92118 0.0672,0.69322 0.22229,0.69927 0.28768,0' id='path7083-1-7' style='fill:%23ffffff' /%3E %3Cpath d='m 987.73416,381.80416 c 2.96313,0.9717 5.88775,2.98171 7.26541,5.90897 0.0905,0.19076 0.24555,-1.2926 0.24814,-1.44396 0.0258,-0.70832 0.17576,-1.87075 -0.13958,-2.53978 -1.41333,-2.99082 -4.3439,-5.06139 -7.37501,-6.05731 0.0982,0.0333 -0.64902,3.92015 0,4.13208' id='path7085-8-0' style='fill:%23ffffff' /%3E %3Cpath d='m 977.7222,402.37359 c 0.53039,1.7618 0.57485,3.38434 0.24555,5.20063 -0.16542,0.91117 -0.12406,1.90407 -0.075,2.82434 0,0.13311 0.13699,1.53176 0.28122,0.74166 0.74672,-4.11691 0.87131,-8.71514 -0.34067,-12.75034 -0.0465,-0.15147 -0.24555,1.2593 -0.25072,1.44396 -0.0258,0.80219 -0.0956,1.75877 0.13957,2.53975' id='path7087-9-0' style='fill:%23ffffff' /%3E %3Cpath d='m 969.37223,396.79153 c 0,3.41763 0.20161,6.81412 -0.48592,10.18332 -0.18352,0.89907 -0.12407,1.91619 -0.0672,2.82738 0,0.13932 0.11632,1.52264 0.27553,0.74161 0.92741,-4.5316 0.70538,-9.15407 0.68444,-13.75231 0,-0.14216 0.0336,-2.06453 -0.20161,-2.06453 -0.23004,0.003 -0.20419,1.92224 -0.20419,2.06453' id='path7089-9-4' style='fill:%23ffffff' /%3E %3Cpath d='m 965.12914,400.48467 c -1.17941,4.53468 -2.34667,9.07232 -3.27123,13.67056 -0.17835,0.90212 -0.12407,1.91619 -0.0698,2.82736 0,0.13931 0.12148,1.52266 0.28148,0.74166 0.89199,-4.45897 2.02384,-8.85743 3.16758,-13.25589 0.305,-1.16845 -0.29052,-3.28142 -0.10597,-3.98369' id='path7091-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 970.83881,403.37556 c 0.0388,3.89291 0.48903,7.82519 0.0595,11.70296 -0.10597,0.95661 -0.0931,1.96463 0,2.92118 0.0672,0.70233 0.20678,0.69021 0.28458,0 0.54822,-4.88881 0.10856,-9.7262 0.062,-14.62414 0,-0.14216 0.0336,-2.06447 -0.20161,-2.06447 -0.23521,0 -0.20419,1.92223 -0.20419,2.06447' id='path7093-0-9' style='fill:%23ffffff' /%3E %3Cpath d='m 943.41302,405.45826 c 0.0801,-1.22901 0.0672,-1.47423 -0.0362,-0.73861 -0.0543,0.26938 -0.12924,0.53579 -0.21712,0.79312 -0.14474,0.44194 -0.35566,0.85363 -0.57794,1.25623 -0.34067,0.6115 -0.16026,1.87685 -0.14216,2.53981 0,0.14216 0.13957,1.64373 0.24813,1.44391 1.43711,-2.59427 1.33062,-5.99978 0.9274,-8.86046 -0.11114,-0.79912 -0.26958,0.61755 -0.27553,0.74166 -0.0569,0.93542 -0.0594,1.89503 0.0698,2.82434' id='path7095-4-2' style='fill:%23ffffff' /%3E %3Cpath d='m 955.46665,397.28798 c 0.79997,1.54688 0.74078,2.89397 0.73173,4.59219 -0.002,0.13931 -0.031,2.06452 0.19903,2.06452 0.23004,0 0.19902,-1.92528 0.20161,-2.06452 0.0258,-2.85158 0.31999,-5.96649 -1.02795,-8.57591 -0.10081,-0.19385 -0.24297,1.29865 -0.24813,1.44396 -0.0258,0.68413 -0.18352,1.90407 0.14474,2.53976' id='path7097-1-0' style='fill:%23ffffff' /%3E %3Cpath d='m 958.74072,395.86827 c 0.44458,0.3572 0.82376,0.7507 1.12901,1.24413 0.13441,0.21789 0.22746,0.45408 0.31715,0.69325 0.0956,0.25124 0.12924,1.002 0.11114,0.13621 0,0.4087 0.0284,0.82944 0.0931,1.23509 -0.002,-0.0207 0.0672,0.45709 0.15767,0.20885 0.26959,-0.75076 0.16026,-1.76183 0.14475,-2.54283 -0.0414,-2.01002 -0.32904,-3.81116 -1.95277,-5.10678 -0.0646,-0.0514 -0.14733,0.66898 -0.14216,0.60539 -0.0491,0.48738 -0.062,0.97478 -0.062,1.46216 0,0.4843 0,0.9747 0.062,1.45908 0.0258,0.12122 0.0258,0.49945 0.14216,0.60539' id='path7099-9-9' style='fill:%23ffffff' /%3E %3Cpath d='m 962.78841,392.20237 c 0.65187,1.31379 1.3986,2.57612 2.05047,3.88989 0.10339,0.21195 0.14991,-0.17551 0.15767,-0.20885 0.062,-0.40562 0.0775,-0.82339 0.0905,-1.23509 0,-0.52974 0,-1.05948 -0.0258,-1.59224 -0.0258,-0.26036 0.002,-0.6993 -0.12148,-0.94751 -0.65187,-1.31379 -1.3986,-2.57612 -2.04762,-3.88989 -0.10598,-0.21195 -0.14733,0.1755 -0.15767,0.20885 -0.0646,0.40567 -0.0801,0.82339 -0.093,1.23508 0,0.52974 0,1.06251 0.0258,1.58928 0.0258,0.26333 -0.002,0.70229 0.12148,0.95048' id='path7101-4-1' style='fill:%23ffffff' /%3E %3Cpath d='m 971.86417,388.91188 c 1.59995,2.27942 3.25625,4.51953 5.03118,6.65671 -0.0594,-0.0726 0.20161,-1.86173 0.20161,-2.06455 0,-0.49645 0.14474,-1.65281 -0.20161,-2.0675 -1.73927,-2.09177 -3.36015,-4.27739 -4.92469,-6.50838 -0.13957,-0.2029 -0.24555,1.30167 -0.24813,1.44396 -0.0258,0.5842 -0.22229,2.02211 0.14216,2.53976' id='path7103-6-0' style='fill:%23ffffff' /%3E %3Cpath d='m 976.55158,381.13213 c 1.21508,2.13713 2.61342,4.15019 4.15134,6.05728 -0.062,-0.0786 0.2016,-1.85865 0.2016,-2.0645 0,-0.50249 0.14216,-1.64071 -0.2016,-2.06755 -1.50225,-1.85865 -2.86233,-3.82328 -4.04743,-5.90895 -0.10856,-0.1998 -0.24297,1.30164 -0.24814,1.44391 -0.0258,0.65388 -0.19902,1.93738 0.14475,2.53981' id='path7105-9-1' style='fill:%23ffffff' /%3E %3Cpath d='m 930.92076,360.3205 c -1.35414,-1.0898 -2.79409,-2.02216 -4.3912,-2.69114 -0.10597,-0.0483 -0.20161,1.96157 -0.20161,2.06452 0,0.25744 -0.12148,1.93129 0.20161,2.06453 1.59711,0.67201 3.03706,1.60132 4.3912,2.69414 0,0.005 0.20161,-1.93133 0.20161,-2.06752 0,-0.38146 0.14991,-1.78 -0.20161,-2.06453' id='path7107-7-6' style='fill:%23ffffff' /%3E %3Cpath d='m 945.21742,355.4014 c 0.1008,0.23314 0.18868,0.46618 0.27579,0.70529 0.0569,0.17266 0.10339,0.34811 0.14216,0.52672 0.0465,0.32694 0.0569,0.33299 0.0284,0.0181 0,0.4087 0.031,0.83247 0.0956,1.23512 0,-0.0233 0.0646,0.45705 0.15509,0.20574 0.26959,-0.75071 0.15767,-1.75878 0.14216,-2.53976 -0.0258,-1.41974 -0.16025,-2.82738 -0.72605,-4.13507 -0.0982,-0.22694 -0.15767,0.1967 -0.15767,0.20884 -0.0646,0.40565 -0.0801,0.82337 -0.0905,1.23509 -0.0284,0.73257 -0.16542,1.84656 0.13958,2.53976' id='path7109-3-3' style='fill:%23ffffff' /%3E %3Cpath d='m 956.49769,344.68526 c 0.0672,2.71536 -0.22228,5.56389 -1.61468,7.93117 -0.34687,0.58722 -0.16283,1.89799 -0.14216,2.53973 0.002,0.14216 0.12924,1.64376 0.24814,1.44093 2.18952,-3.72035 2.01169,-8.82111 1.89926,-13.01067 0,-0.16956 -0.18869,-1.61042 -0.24814,-1.44091 -0.26648,0.74768 -0.16283,1.76485 -0.14216,2.53975' id='path7111-0-2' style='fill:%23ffffff' /%3E %3Cpath d='m 959.03409,359.96327 c 2.40018,-1.61045 4.04174,-4.08057 5.32454,-6.65667 0.3231,-0.64781 0.16026,-1.84655 0.14216,-2.5398 -0.002,-0.14527 -0.14991,-1.63769 -0.24813,-1.44391 -1.25928,2.53066 -2.86233,4.92817 -5.21779,6.50832 -0.34662,0.23599 -0.20161,1.72549 -0.20161,2.06755 0,0.12097 0.16025,2.0948 0.20161,2.06451' id='path7113-3-1' style='fill:%23ffffff' /%3E %3Cpath d='m 966.05964,359.66664 c 0.8235,-0.85971 1.52293,-1.83141 2.34358,-2.69117 0.12407,-0.13311 0.12407,-0.44798 0.14474,-0.60539 0.0465,-0.48436 0.0594,-0.97473 0.0594,-1.46211 0,-0.48737 0,-0.97475 -0.0594,-1.4591 0,0.0667 -0.0879,-0.66293 -0.14474,-0.60545 -0.82065,0.85971 -1.52008,1.83144 -2.34358,2.69117 -0.12665,0.13311 -0.12665,0.44798 -0.14216,0.60539 -0.0491,0.48738 -0.0594,0.97476 -0.0594,1.46211 0,0.48435 0,0.97475 0.0594,1.4591 0,-0.0695 0.0905,0.65991 0.14216,0.60545' id='path7115-8-3' style='fill:%23ffffff' /%3E %3Cpath d='m 976.60508,361.5162 c -2.64004,-0.0103 -5.27724,-0.0362 -7.90539,-0.29968 -0.18093,-0.0181 -0.42984,4.08967 0,4.13208 2.62815,0.26031 5.26535,0.29058 7.90539,0.29965 0.29621,0.003 0.30526,-4.13205 0,-4.13205' id='path7117-3-2' style='fill:%23ffffff' /%3E %3Cpath d='m 974.26125,371.03356 c 3.5111,2.10689 6.9157,4.39239 10.54544,6.28131 -0.27837,-0.14526 0.75862,-3.73243 0,-4.12903 -3.62974,-1.89197 -7.03434,-4.17442 -10.54544,-6.28433 0.33472,0.2029 -0.78808,3.65979 0,4.13205' id='path7119-3-6' style='fill:%23ffffff' /%3E %3Cpath d='m 974.55462,378.21696 c 3.12881,1.99187 6.54841,3.52364 9.37197,5.98466 0,-0.003 0.19902,-1.92224 0.19902,-2.06752 0,-0.40263 0.1525,-1.75576 -0.19902,-2.06453 -2.82356,-2.46105 -6.24316,-3.99279 -9.37197,-5.98463 -0.0543,-0.0305 -0.20161,1.95248 -0.20161,2.06752 0,0.32389 -0.14475,1.84049 0.20161,2.0645' id='path7121-5-2' style='fill:%23ffffff' /%3E %3Cpath d='m 954.40303,363.18112 c 0.45026,-1.50749 0.44147,-3.124 0.44147,-4.68296 0,-0.14216 0.031,-2.06452 -0.20161,-2.06452 -0.23521,0 -0.20419,1.92223 -0.20419,2.06452 0,0.56606 0,0.0879 0.0258,0.005 -0.0258,0.23625 -0.0853,0.46618 -0.15509,0.69325 -0.23521,0.78403 -0.16284,1.73451 -0.14216,2.53973 0.0258,0.4117 0.0258,0.82944 0.0931,1.23512 0,-0.0486 0.075,0.47825 0.15767,0.20884' id='path7123-8-8' style='fill:%23ffffff' /%3E %3Cpath d='m 929.74729,352.18654 c 2.7499,3.36622 6.23437,5.80303 9.62114,8.43971 2.50977,1.95248 4.36458,5.27631 7.0757,6.81709 -0.31405,-0.1755 0.77645,-3.68704 0,-4.129 -2.44154,-1.38947 -4.07121,-4.33182 -6.24006,-6.14811 -3.57649,-2.99995 -7.45798,-5.44285 -10.45368,-9.11172 0.50377,0.62057 -0.75862,3.20571 -0.002,4.13203' id='path7125-1-8' style='fill:%23ffffff' /%3E %3Cpath d='m 935.60817,363.31434 c -1.65914,-1.70729 -3.17922,-3.53875 -4.68431,-5.38531 -0.0465,-0.0545 -0.15508,0.67203 -0.14733,0.60545 -0.0439,0.48435 -0.0594,0.97173 -0.0594,1.45908 0,0.4995 -0.14216,1.64376 0.2042,2.06752 1.50508,1.84656 3.02516,3.67497 4.68456,5.38529 -0.0362,-0.0362 0.19902,-1.89494 0.19902,-2.0675 0.002,-0.44804 0.15509,-1.7013 -0.19644,-2.06453' id='path7127-7-4' style='fill:%23ffffff' /%3E %3Cpath d='m 932.33125,390.61315 c -1.10523,2.00396 -2.03858,4.11083 -3.46096,5.909 -0.34066,0.43284 -0.20161,1.55895 -0.20161,2.0675 0,0.21195 0.26959,1.97975 0.20161,2.06453 1.45779,-1.85263 2.42965,-3.99886 3.5646,-6.05732 0.33783,-0.61149 0.16284,-1.87685 0.14475,-2.53978 -0.002,-0.14216 -0.13958,-1.64371 -0.24814,-1.44393' id='path7129-6-4' style='fill:%23ffffff' /%3E %3Cpath d='m 935.40966,394.74822 c -0.0517,2.2976 -0.83539,4.58917 -1.11996,6.86556 -0.1189,0.95354 -0.0905,1.97065 0,2.92421 0.0724,0.70837 0.2016,0.6811 0.28768,0 0.36134,-2.9333 1.15847,-5.71522 1.22361,-8.69089 0.0258,-0.77801 0.12406,-1.79207 -0.14216,-2.54284 -0.0569,-0.16645 -0.24555,1.27446 -0.24814,1.44396' id='path7131-8-6' style='fill:%23ffffff' /%3E %3Cpath d='m 946.20116,413.74356 c 1.95277,-6.53257 1.73927,-13.43749 1.6059,-20.19108 -0.0569,-2.89999 -0.41485,-0.2179 -0.39107,1.09582 0.1008,5.11285 0.15508,10.17122 -1.32157,15.11152 -0.34067,1.15031 0.30835,3.31174 0.10597,3.98374' id='path7133-1-3' style='fill:%23ffffff' /%3E %3Cpath d='m 952.53918,397.88735 c 0.74363,2.26735 0.89483,4.33185 0.53918,6.69608 -0.14216,0.92632 -0.12666,1.89195 -0.0698,2.82733 0,0.12123 0.15508,1.53479 0.27579,0.73864 0.70821,-4.67696 0.85916,-9.70809 -0.63429,-14.24574 -0.0543,-0.16051 -0.24297,1.26838 -0.24814,1.44391 -0.0284,0.78403 -0.11114,1.77395 0.13958,2.53978' id='path7135-4-4' style='fill:%23ffffff' /%3E %3Cpath d='m 958.74072,395.56554 c 2.28154,2.79104 2.97193,6.49628 2.75274,10.05618 -0.0388,0.67505 0.19127,4.6285 0.34971,2.08572 0.32594,-5.38229 0.47094,-11.90276 -3.10245,-16.27393 0.062,0.0757 -0.20161,1.85866 -0.20161,2.0675 0,0.49645 -0.14216,1.64379 0.20161,2.06453' id='path7137-2-9' style='fill:%23ffffff' /%3E %3Cpath d='m 960.44458,392.80177 c 1.42522,5.93924 2.52735,11.92997 3.13502,18.01755 0.16025,1.61652 0.33472,-2.38539 0.28742,-2.92118 -0.64593,-6.44479 -1.80156,-12.78971 -3.31285,-19.08011 0.17059,0.72046 -0.39107,2.80619 -0.10856,3.98374' id='path7139-4-9' style='fill:%23ffffff' /%3E %3Cpath d='m 966.30261,391.30332 c 2.60153,3.58719 4.87402,7.36808 6.1483,11.66964 0.0465,0.14837 0.24296,-1.2593 0.24555,-1.44396 0.0284,-0.80522 0.093,-1.7557 -0.14216,-2.53973 -1.27428,-4.29858 -3.54393,-8.08252 -6.1483,-11.66969 0.2533,0.34816 -0.7289,3.13011 -0.10339,3.98374' id='path7141-8-7' style='fill:%23ffffff' /%3E %3Cpath d='m 978.41543,381.33795 c -1.20293,-2.08872 -3.76001,-2.34601 -5.91128,-2.1674 -0.40606,0.0333 -0.19644,4.14715 0,4.13202 2.03574,-0.16955 4.652,0.0207 5.80169,2.01909 0.11631,0.1998 0.24555,-1.30167 0.25072,-1.44391 0.0258,-0.65083 0.2016,-1.94343 -0.14216,-2.5398' id='path7143-6-5' style='fill:%23ffffff' /%3E %3Cpath d='m 972.21078,379.70936 c 3.79284,-0.55093 7.5973,-0.59632 11.4196,-0.5994 0.3081,0 0.3081,-4.129 0,-4.129 -3.81946,0 -7.62392,0.0455 -11.4196,0.59635 -0.47714,0.0695 -0.11889,4.15322 0,4.13205' id='path7145-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 979.23918,348.35418 c -3.03421,3.62956 -4.64321,8.55773 -5.66547,13.1469 -0.19902,0.88695 -0.12406,1.92528 -0.0698,2.8243 0,0.15147 0.10338,1.51662 0.27579,0.74169 0.97185,-4.35912 2.58679,-9.13896 5.46386,-12.58083 0.34661,-0.4147 0.20161,-1.57413 0.20161,-2.06756 0,-0.19979 -0.26391,-1.99489 -0.2042,-2.0645' id='path7147-8-9' style='fill:%23ffffff' /%3E %3Cpath d='m 962.73801,351.90501 c 0.5658,3.49034 2.00006,6.70815 2.97787,10.08042 0.0439,0.14836 0.24296,-1.25628 0.24555,-1.44396 0.0258,-0.80827 0.0879,-1.75273 -0.13958,-2.53976 -0.93645,-3.233 -2.33789,-6.32069 -2.88016,-9.66265 -0.12666,-0.79615 -0.26959,0.61452 -0.27554,0.74161 -0.0543,0.92634 -0.0775,1.9011 0.0698,2.82434' id='path7149-7-7' style='fill:%23ffffff' /%3E %3Cpath d='m 959.61798,357.92601 c -1.36913,-1.69822 -2.53045,-3.49332 -3.16474,-5.60928 -0.0801,-0.26943 -0.16543,0.25434 -0.15767,0.20574 -0.0646,0.40565 -0.0801,0.82642 -0.0905,1.23509 -0.0258,0.80522 -0.0931,1.75878 0.14216,2.54278 0.64903,2.17655 1.8698,4.01401 3.27124,5.75767 0.0465,0.0545 0.14733,-0.67508 0.14216,-0.60545 0.0517,-0.48735 0.062,-0.97473 0.062,-1.4621 0,-0.49948 0.14216,-1.63466 -0.20419,-2.06453' id='path7151-6-3' style='fill:%23ffffff' /%3E %3Cpath d='m 954.05616,360.6202 c -4.59565,-1.4894 -8.99564,-3.32383 -12.88927,-6.28136 0.42389,0.31785 -0.80592,3.51151 0,4.12906 3.89053,2.96055 8.29362,4.79193 12.88927,6.28435 -0.0956,-0.0305 0.64592,-3.9232 0,-4.13205' id='path7153-1-4' style='fill:%23ffffff' /%3E %3Cpath d='m 959.11422,359.46079 c 0,0 -18.21976,3.11794 -23.02581,4.21981 -4.80605,1.10189 -15.68647,2.20376 -19.47904,2.20376 -3.79568,0 -9.6152,-3.03015 -13.66263,-3.85657 -4.04768,-0.82641 -17.20344,-2.20374 -22.00949,2.7547 -4.8063,4.95847 -7.84336,6.61128 -9.36034,8.26411 -1.51723,1.65283 -7.61203,7.05934 -7.85215,9.45378 -0.24038,2.39147 1.52887,5.97256 4.56308,5.97256 3.03706,0 9.41669,6.45994 9.40764,7.81002 -0.0258,2.25223 8.33214,4.67694 16.20212,4.63155 14.18991,-0.0786 21.17385,-7.23791 42.44541,-4.72837 11.58269,1.36522 32.88706,-7.7132 36.68558,-13.2226 3.79284,-5.50941 6.07128,-11.29429 2.2756,-17.63011 -3.79568,-6.33582 -15.17081,-5.68499 -16.18997,-5.87266' id='path7155-7-8' style='fill:%23dba05f' /%3E %3Cpath d='m 959.11422,359.46079 c 0,0 -18.21976,3.11794 -23.02581,4.21981 -4.80605,1.10189 -15.68647,2.20376 -19.47904,2.20376 -3.79568,0 -9.6152,-3.03015 -13.66263,-3.85657 -4.04768,-0.82641 -17.20344,-2.20374 -22.00949,2.7547 -4.8063,4.95847 -7.84336,6.61128 -9.36034,8.26411 -1.51723,1.65283 -7.61203,7.05934 -7.85215,9.45378 -0.24038,2.39147 1.52887,5.97256 4.56308,5.97256 3.03706,0 9.41669,6.45994 9.40764,7.81002 -0.0258,2.25223 8.33214,4.67694 16.20212,4.63155 14.18991,-0.0786 21.17385,-7.23791 42.44541,-4.72837 11.58269,1.36522 32.88706,-7.7132 36.68558,-13.2226 3.79284,-5.50941 6.07128,-11.29429 2.2756,-17.63011 -3.79568,-6.33582 -15.17081,-5.68499 -16.18997,-5.87266 z' id='path7157-1-6' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 882.83935,379.89401 c 0.002,0 -0.0465,0.40263 -0.12923,-0.22099 l -0.10598,-0.48738 -0.12665,-0.33601 -0.0258,-0.37236 c -0.0827,-0.13027 0.38228,0.0907 1.85195,-1.35615 0,0.0274 0.44458,-0.69323 1.24145,-1.88892 -0.0853,0.0545 1.8106,-2.35516 4.59565,-2.9939 2.77652,-0.64781 5.34548,-0.1817 5.70088,-0.16051 0.1189,-0.15431 -6.2964,-0.2241 -6.7172,0.52672 0.0258,-0.50253 6.18707,-0.7144 6.51585,-0.28456 0.0801,-0.14526 -5.81047,-0.19385 -6.2491,0.6145 0,-0.36626 5.34522,-0.62359 5.92601,-0.13027 0,0 -0.99538,-0.11192 -1.26497,-0.0848 l 0.46499,0.0817 -0.74957,-0.0103 -0.43268,-0.0424 c 0,-0.0129 1.17347,0.14216 1.25049,0.24813 0,0.0181 0.52729,-0.14836 -1.56738,-0.0362 0,0.005 -1.28306,-0.23625 -3.36919,0.42986 -2.74059,0.39957 -2.65478,4.11996 -6.80896,6.5023' id='path7159-4-4' /%3E %3Cpath d='m 882.3772,378.34413 c 0.24297,0.0207 2.02953,-0.70232 3.74218,-3.87477 -0.48567,-0.86575 6.43597,-3.56292 7.15298,-2.69716 0.031,-0.0274 1.88737,0 2.97192,0.1755' id='path7161-8-9' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 889.23372,372.35337 c -0.70537,-0.0969 -4.21932,2.86368 -3.89933,3.03021 -0.75861,1.81932 -2.73206,3.00896 -2.96029,2.96055' id='path7163-7-7' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 889.52993,372.77112 c 0,-0.23004 4.7528,-0.68413 5.69209,-0.32992' id='path7165-2-5' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 888.64698,374.04252 c -0.12923,-0.49645 4.94821,-1.18662 5.41941,-0.84153' id='path7167-0-1' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 893.95085,377.2725 c 0,0 0.21453,0.13027 -0.0775,-0.15741 l -0.21712,-0.24813 -0.12665,-0.21195 -0.18093,-0.15741 c 0,0 -0.16026,0.0667 -1.43401,1.19572 0,-0.0103 -0.55727,0.4147 -1.21482,1.03224 -0.0258,-0.0545 -1.23576,1.02619 -2.60179,1.77393 -1.45469,0.21479 -3.5615,1.15938 -3.5615,1.53473 -0.12665,-0.56303 4.17796,-1.69214 4.11566,-1.76178 0.3081,0.20291 -3.81635,0.95959 -3.89337,1.7981 -0.14733,-0.5055 3.78378,-1.49235 3.94662,-1.5045 0.20161,0.23004 -3.46664,0.83549 -3.57623,1.62862 0,0.0207 0.50376,-0.49948 0.70511,-0.50855 l -0.25847,0.19386 c 0.12665,-0.12717 0.29931,-0.15147 0.4593,-0.21195 l 0.26959,-0.12407 c 0,0.005 -0.73174,0.32389 -0.70821,0.47525 0.0362,0.0817 -0.4177,-0.0455 0.94833,-0.41469 0.0258,0.13027 3.46974,-0.69927 7.40448,-4.33188' id='path7169-4-5' /%3E %3Cpath d='m 893.30777,376.3916 c -0.0258,-0.0574 -1.52292,1.49542 -3.0903,2.60034 0.0258,0.26031 -3.21205,2.15228 -4.05648,1.92524 -0.0543,-0.0998 -1.37792,0.55701 -1.92898,1.23206' id='path7171-6-8' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 888.51361,380.23305 c 0.24555,-0.24219 2.2787,-1.62861 2.2787,-1.64376 0.72295,-0.76885 2.51546,-2.19769 2.51856,-2.20071' id='path7173-0-5' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 888.58779,380.58721 c 0.16801,0.16646 -3.02542,0.60545 -3.53487,1.37436' id='path7175-9-6' style='fill:none;stroke:%23000000;stroke-width:0.00299493' /%3E %3Cpath d='m 889.50925,380.49641 c 0.20419,0.41172 -3.4165,1.37735 -3.5646,1.48632' id='path7177-6-3' style='fill:none;stroke:%23939598;stroke-width:0.00299493' /%3E %3Cpath d='m 898.98513,362.53331 c 0,0 -0.25589,-5.78485 -5.81952,-7.9886 -5.56467,-2.20379 -11.89363,-2.47927 -14.16639,-2.20379 -2.27844,0.27548 -2.65477,1.2926 -5.49927,1.74971 -2.8476,0.45408 -5.88181,1.83141 -5.88181,1.83141 0,0 0,-0.27543 -1.51982,2.47925 -1.52008,2.7547 -4.04459,4.13202 -2.77936,6.6113 1.26212,2.47922 0.42364,2.91208 1.98223,3.38431 1.55859,0.47226 -0.77335,-0.84456 -0.77335,-0.84456 0,0 -9.75141,3.14218 -7.37811,9.11472 2.37355,5.97561 4.7497,3.74155 5.45791,3.6205 0.71132,-0.12406 5.51737,-2.60336 5.51737,-2.60336 l 7.89945,-7.38018 c 0,0 9.30089,-3.63863 10.31126,-3.91408 1.01631,-0.27551 5.4194,0.10287 5.4194,0.10287 l 7.23001,-3.9595 z' id='path7179-5-9' style='fill:%23c6262c' /%3E %3Cpath d='m 898.98513,362.53331 c 0,0 -0.25589,-5.78485 -5.81952,-7.9886 -5.56467,-2.20379 -11.89363,-2.47927 -14.16639,-2.20379 -2.27844,0.27548 -2.65477,1.2926 -5.49927,1.74971 -2.8476,0.45408 -5.88181,1.83141 -5.88181,1.83141 0,0 0,-0.27543 -1.51982,2.47925 -1.52008,2.7547 -4.04459,4.13202 -2.77936,6.6113 1.26212,2.47922 0.42364,2.91208 1.98223,3.38431 1.55859,0.47226 -0.77335,-0.84456 -0.77335,-0.84456 0,0 -9.75141,3.14218 -7.37811,9.11472 2.37355,5.97561 4.7497,3.74155 5.45791,3.6205 0.71132,-0.12406 5.51737,-2.60336 5.51737,-2.60336 l 7.89945,-7.3832 c 0,0 9.30089,-3.63563 10.31126,-3.91106 1.01631,-0.27551 5.4194,0.10287 5.4194,0.10287 l 7.23001,-3.9595 z' id='path7181-3-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 891.91512,376.10705 c 0,1.44093 -1.46374,3.30261 -3.27098,4.15627 -1.8106,0.85061 -3.27718,0.37538 -3.27718,-1.06555 0,-1.44396 1.46373,-3.30564 3.27124,-4.15927 1.80724,-0.85067 3.27692,-0.37541 3.27692,1.06855' id='path7183-4-5' /%3E %3Cpath d='m 853.27108,402.52495 c 0,0 -7.63271,-13.13479 13.54114,-19.57049 0,0 6.40031,3.48422 7.87877,5.89688 0,0 -3.69202,6.16629 -15.75754,7.77673 0,0 -5.4163,1.60742 -5.66237,5.89688' id='path7185-6-7' style='fill:%23d9c0b9' /%3E %3Cpath d='m 853.27108,402.52495 c 0,0 -7.63271,-13.13479 13.54114,-19.57049 0,0 6.40031,3.48422 7.87877,5.89688 0,0 -3.69202,6.16629 -15.75754,7.77673 0,0 -5.4163,1.60742 -5.66237,5.89688 z' id='path7187-6-2' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 855.48749,400.3787 c 0,0 8.52185,1.79812 14.27598,-2.41264 4.71713,-3.45095 6.40315,-1.87683 7.63296,-1.60742 0,0 0.24814,-4.28946 -2.70828,-7.5073 0,0 -5.98236,4.9403 -10.41517,6.28131 -4.42686,1.34104 -7.42541,0.89608 -8.78549,5.24605' id='path7189-1-1' style='fill:%23d9c0b9' /%3E %3Cpath d='m 855.48749,400.3787 c 0,0 8.52185,1.79812 14.27598,-2.41264 4.71713,-3.45095 6.40315,-1.87683 7.63296,-1.60742 0,0 0.24814,-4.28946 -2.70828,-7.5073 0,0 -5.98236,4.9403 -10.41517,6.28131 -4.42686,1.34104 -7.42541,0.89608 -8.78549,5.24605 z' id='path7191-2-4' style='fill:none;stroke:%23000000;stroke-width:1.41659927' /%3E %3Cpath d='m 879.183,396.06806 c 1.58831,0 3.19705,0.0181 4.75564,-0.34811 0.1861,-0.0424 0,-1.37737 0,-1.37435 -1.55859,0.36328 -3.16733,0.34509 -4.75564,0.34509 -0.10081,-0.003 -0.10081,1.37737 0,1.37737' id='path7193-6-0' style='fill:%237a2e26' /%3E %3Cpath d='m 876.19634,374.00621 c -1.30968,0.005 -0.91577,1.57715 -1.70101,2.23708 -0.1189,0.0969 -0.0672,0.55696 -0.0672,0.68715 0,0.0483 0.0646,0.69017 0.0672,0.69017 0.78524,-0.65688 0.4239,-2.23098 1.70101,-2.23703 0.10339,0 0.0982,-1.37737 0,-1.37737' id='path7195-5-6' style='fill:%237a2e26' /%3E %3Cpath d='m 880.59038,376.97583 c 0.66092,-1.23811 1.9675,-1.74361 3.14381,-2.33696 0.25072,-0.12407 -0.0853,-1.33194 0,-1.3743 -1.19699,0.60242 -2.50383,1.12001 -3.17638,2.38235 -0.10855,0.20884 -0.0569,0.62359 -0.0491,0.84763 0.002,0.0483 0.0491,0.54791 0.0827,0.48128' id='path7197-6-0' style='fill:%237a2e26' /%3E %3Cpath d='m 886.28842,384.57703 c 1.0755,0.0848 1.91399,-0.37541 2.55423,-1.24419 0.10597,-0.15146 0.0646,-0.51159 0.0646,-0.68715 0,-0.0757 -0.0956,-0.65386 -0.0646,-0.69017 -0.64308,0.86878 -1.47873,1.32891 -2.55423,1.24413 -0.0672,-0.005 -0.13441,1.36523 0,1.37738' id='path7199-8-9' style='fill:%237a2e26' /%3E %3Cpath d='m 890.78921,382.96354 c 1.73926,-0.73254 3.07273,-1.84049 4.02675,-3.50239 0.11631,-0.1998 0.0569,-0.62964 0.0517,-0.84764 0,-0.0455 -0.0465,-0.54791 -0.0827,-0.4813 -0.94808,1.64978 -2.27249,2.73048 -3.99418,3.45397 -0.2378,0.10003 0.062,1.35014 0,1.37736' id='path7201-1-6' style='fill:%237a2e26' /%3E %3Cpath d='m 883.71635,375.5228 c -0.99538,1.67707 -2.8799,2.53071 -4.01175,4.09876 -0.20678,0.28763 0.11889,1.21389 0.0362,1.32891 1.13185,-1.57108 3.01328,-2.41866 4.01176,-4.09876 0.11631,-0.1967 0.0569,-0.63566 0.0517,-0.84759 0,-0.0483 -0.0465,-0.54791 -0.0853,-0.48132' id='path7203-6-7' style='fill:%237a2e26' /%3E %3Cpath d='m 886.77435,397.49688 c 3.60906,0.19385 7.09353,-0.29363 10.578,-1.24114 0.19903,-0.0574 -0.0258,-1.37432 0,-1.37735 -3.48757,0.94751 -6.97205,1.43489 -10.578,1.24111 -0.0801,-0.003 -0.12407,1.37133 0,1.37738' id='path7205-6-6' style='fill:%237a2e26' /%3E %3Cpath d='m 903.43267,396.87631 c 4.71403,-3.42068 8.69064,-6.34794 10.2314,-12.3235 0.1008,-0.39053 -0.0956,-1.09283 -0.0362,-1.32589 -1.53481,5.93017 -5.53494,8.8877 -10.19598,12.27201 -0.26649,0.1936 0.1344,1.28053 0,1.37738' id='path7207-8-5' style='fill:%237a2e26' /%3E %3Cpath d='m 906.23271,388.67879 c 3.3511,-1.99487 5.74818,-5.14312 7.06975,-8.84531 0.13441,-0.37233 -0.10855,-1.12007 -0.0362,-1.32891 -1.31253,3.68704 -3.70366,6.81407 -7.03434,8.79689 -0.26649,0.15431 0.10855,1.31072 0,1.37733' id='path7209-6-6' style='fill:%237a2e26' /%3E %3Cpath d='m 904.65034,367.8066 c 2.56896,-0.30877 5.3721,1.82542 7.17366,3.47822 -0.15767,-0.14216 0.26959,-1.12911 0,-1.37738 -1.79871,-1.65283 -4.6047,-3.78696 -7.17366,-3.47816 -0.14733,0.0181 -0.0517,1.38337 0,1.37732' id='path7211-3-6' style='fill:%237a2e26' /%3E %3Cpath d='m 971.42554,378.21696 c 2.92463,-4.72537 1.32752,-10.63737 -1.70075,-14.86933 0.0827,0.11813 -0.24296,1.04136 -0.0362,1.32892 2.56017,3.57806 4.25782,8.08852 1.70385,12.21153 -0.19644,0.31179 0.1189,1.18964 0.0336,1.32888' id='path7213-6-8' style='fill:%237a2e26' /%3E %3Cpath d='m 920.45829,371.53606 c 2.95124,2.14018 11.07867,7.58907 8.85942,12.06319 -0.17318,0.34206 0.1189,1.15938 0.0362,1.32891 3.04015,-6.12389 -4.80889,-11.80585 -8.89509,-14.76943 0.12923,0.0938 -0.26959,1.17755 0,1.37733' id='path7215-9-3' style='fill:%237a2e26' /%3E %3Cpath d='m 943.3714,393.52523 c 0.46525,-1.25925 0.62835,-2.57304 0.75862,-3.90498 0.0336,-0.32087 0.0336,-0.65084 0,-0.97176 -0.0284,-0.23314 -0.0698,-0.23314 -0.0956,0 -0.1189,1.21392 -0.27269,2.40055 -0.69917,3.54783 -0.0905,0.24529 -0.0543,0.59335 -0.0465,0.84761 0.002,0.0545 0.0594,0.53884 0.0827,0.4813' id='path7217-2-4' style='fill:%237a2e26' /%3E %3Cpath d='m 952.16569,391.36083 c 1.76614,-0.2997 3.52609,-1.20177 5.28913,-2.40054' id='path7219-7-6' style='fill:%235e3f17' /%3E %3Cpath d='m 867.25679,386.38724 c -3.46379,2.11902 -8.91576,2.14626 -9.99747,6.92912 -0.0258,0.0667 0,0.32694 0.0258,0.29668 1.0786,-4.76472 6.54557,-4.77989 9.97964,-6.88071 0.0646,-0.0455 -0.031,-0.32692 0,-0.34509' id='path7221-5-7' style='fill:%235e3f17' /%3E %3Cpath d='m 864.91891,371.085 c 1.49035,0.0274 3.23866,0.81129 3.01043,2.63968 -0.0414,0.31784 -0.0336,0.65688 0,0.97475 0.0258,0.23624 0.0646,0.22694 0.0956,0 0.13957,-1.11699 0.19127,-2.40052 -0.2378,-3.46005 -0.47714,-1.1715 -1.73926,-1.51054 -2.86827,-1.53171 -0.0956,0 -0.10856,1.37733 0,1.37733' id='path7223-1-6' style='fill:%23842116' /%3E %3Cpath d='m 872.06879,373.83667 c 0.71416,-2.02211 0.54512,-4.4166 -0.6785,-6.18445 0.0827,0.12096 -0.24038,1.03229 -0.0362,1.32589 0.75836,1.09584 1.15253,2.20074 0.67849,3.52965 -0.13441,0.37541 0.10856,1.12007 0.0362,1.32891' id='path7225-6-3' style='fill:%23842116' /%3E %3Cpath d='m 877.85858,367.72187 c -0.36755,-2.40964 -1.21198,-5.08863 -3.43123,-6.33886 0.10339,0.0574 -0.25847,1.22903 0,1.37737 2.16006,1.21689 3.01044,3.80209 3.3661,6.14812 0.0413,0.26635 0.0853,-0.2029 0.0879,-0.24529 0.0258,-0.30877 0.0258,-0.63269 -0.0259,-0.94146' id='path7227-8-2' style='fill:%23842116' /%3E %3Cpath d='m 882.95205,366.48071 c 0.3112,-2.24308 0.1189,-4.63757 -1.73332,-6.13901 0.14733,0.11812 -0.27269,1.15635 0,1.37732 1.02795,0.83246 1.86075,2.1735 1.66508,3.57507 -0.0439,0.30877 -0.0414,0.62662 -0.0258,0.93841 0.002,0.0424 0.0569,0.51462 0.0905,0.24814' id='path7229-1-7' style='fill:%23842116' /%3E %3Cpath d='m 874.42735,358.9401 c 4.97793,-2.52464 15.11731,-3.64468 19.01974,1.38642 -0.1706,-0.21479 0.24555,-1.05645 0,-1.37432 -3.90243,-5.0341 -14.04181,-3.91409 -19.01974,-1.38943 -0.2533,0.12717 0.0905,1.33497 0,1.37733' id='path7231-1-8' style='fill:%23842116' /%3E %3Cpath d='m 862.56034,379.73355 c 1.12901,-1.674 0.76741,-3.91708 -0.33782,-5.4912 0.0827,0.11812 -0.24038,1.03526 -0.0388,1.32891 0.29621,0.41167 0.54227,0.82944 0.73794,1.29865 0.24038,0.57512 -0.0853,1.07462 -0.39728,1.53473 -0.12148,0.17861 -0.0543,0.64781 -0.0465,0.84761 0.002,0.0486 0.0388,0.54794 0.0827,0.4813' id='path7233-6-2' style='fill:%237a2e26' /%3E %3Cpath d='m 913.40017,394.33348 c 1.60305,-1.02317 2.72611,-2.54581 3.08461,-4.45897 0.0594,-0.30272 0.0439,-0.63572 0.0258,-0.94141 0,-0.0455 -0.0413,-0.5086 -0.0879,-0.24529 -0.34377,1.82841 -1.49036,3.29351 -3.01922,4.26827 -0.2639,0.16955 0.11889,1.30167 0,1.37737' id='path7235-3-4' style='fill:%237a2e26' /%3E %3Cpath d='m 921.02719,393.70989 c 0.68728,-0.75978 0.94213,-1.674 0.98064,-2.6881 0,-0.25433 0.0414,-0.59937 -0.0465,-0.84456 -0.0258,-0.0574 -0.0827,0.42382 -0.0827,0.47828 -0.0258,0.58725 -0.48283,1.27143 -0.85038,1.67703 -0.11631,0.13027 -0.0646,0.53279 -0.0646,0.6902 -0.002,0.0605 0.0801,0.669 0.0646,0.68715' id='path7237-2-7' style='fill:%237a2e26' /%3E %3Cpath d='m 967.0788,368.43929 c 1.25334,2.22194 1.45779,4.66784 0.89794,7.15619 -0.0594,0.26938 0.0414,1.31377 0.0672,1.18965 0.71106,-3.15125 0.68134,-6.81408 -0.9336,-9.67478 0.0879,0.15431 -0.21712,1.00502 -0.0336,1.32894' id='path7239-2-5' style='fill:%237a2e26' /%3E %3Cpath d='m 962.50099,373.11321 c 0.90672,2.2431 0.83848,4.57706 0.58079,6.95333 -0.0258,0.17861 0.0362,1.51362 0.0956,0.97173 0.34351,-3.14822 0.5658,-6.25711 -0.64024,-9.254 0.0801,0.1967 -0.18093,0.96571 -0.0362,1.32894' id='path7241-0-3' style='fill:%237a2e26' /%3E %3Cpath d='m 958.18087,377.12417 c 0,1.67707 0.0258,3.3541 -0.55701,4.94634 -0.13957,0.37238 0.10856,1.12309 0.0362,1.32891 0.72295,-1.99184 0.65755,-4.18348 0.66065,-6.27525 -0.002,-0.78101 -0.13957,-0.78101 -0.13957,0' id='path7243-5-1' style='fill:%237a2e26' /%3E %3Cpath d='m 1020.3545,511.6263 0.9687,2.71534 c 0,0 0.2068,0.52977 0.6757,0.9687 l -1.4459,-4.06242 -0.199,0.37838 z' id='path7245-6-2' style='fill:%23452c25' /%3E %3Cpath d='m 915.83886,346.12922 c -18.28205,1.05041 -36.30925,-11.09449 -36.30925,-11.09449 -22.64663,-4.4378 -23.9651,-24.91341 -23.9651,-24.91341 -9.06103,-3.45095 -16.85373,-26.7176 -16.85373,-26.7176 -14.03586,8.37915 -31.60091,0.091 -31.60091,0.091 0,0 0,-3.45095 -15.84931,0 -15.8524,3.45098 -13.13533,-2.95752 -13.13533,-2.95752 0,0 6.34111,-6.4115 -21.73371,0 -28.07507,6.4085 2.26655,-8.38218 2.26655,-8.38218 -8.1512,2.4641 -34.86904,4.4378 -34.86904,4.4378 -9.80465,0.44197 -19.75457,5.27934 -30.59053,8.36703 -6.74382,1.92226 -18.28206,4.16235 -24.11631,6.65369 -15.56472,6.65364 -46.75983,20.95086 -72.52337,31.06155 -33.87056,13.29221 -60.71298,23.40587 -58.94684,22.97905 2.11561,-0.51157 36.78019,-22.46745 80.1977,-42.15301 40.31532,-18.28397 86.59207,-35.20268 109.92314,-41.8291 30.27649,-10.03198 55.07413,-5.24 69.13971,-0.13622 6.79138,2.4641 44.25911,-1.15335 61.00919,0.81732 16.75603,1.97068 18.50124,29.52379 18.50124,29.52379 3.17043,1.97365 4.30228,27.85882 4.30228,27.85882 0,0 -9.28331,0.24813 1.58522,1.72543 10.86853,1.48028 30.79214,17.25781 30.79214,17.25781 6.79112,0 7.56163,-0.23909 7.56163,-0.23909 0,0 3.94662,-4.97661 9.38386,-7.05629 5.43129,-2.08267 10.41517,-4.16532 16.52495,-4.62545 6.11289,-0.46621 14.74408,-0.52069 20.85386,0.17266 6.11289,0.69622 13.33075,0.75071 21.93557,2.37022 8.60457,1.61954 9.50845,2.0827 12.22553,3.00599 2.7171,0.92627 5.1498,0.32689 5.1498,0.32689 11.1883,-4.67691 31.9387,-12.94104 36.7151,-11.99353 0,0 7.8283,-1.96765 12.0386,-5.24302 4.2105,-3.27537 13.8404,-11.14293 13.8404,-11.14293 0,0 -6.6461,-46.79969 40.899,-42.21355 47.5451,4.58914 110.5838,10.69189 123.2242,12.65952 12.6344,1.96463 57.9039,14.8966 68.7367,20.13962 10.8329,5.24302 41.9629,19.18909 55.8149,25.31601 5.6239,2.48532 27.0438,11.97539 42.8962,18.23555 23.7873,9.39322 41.5627,25.04055 41.5627,25.04055 -14.9071,-6.30557 -26.9579,-13.51622 -38.7657,-18.6442 -9.5498,-4.1472 -19.5383,-6.07551 -27.3103,-9.52646 -16.4805,-7.32264 -29.1772,-13.99145 -39.1656,-18.64415 -36.8218,-17.1488 -36.484,-17.83595 -51.4,-19.00443 -10.2818,-0.80824 7.3869,12.54145 7.3869,12.54145 0,0 -33.7018,-13.10756 -44.5346,-17.69367 -10.83,-4.58916 -19.8582,-6.55379 -30.0896,-5.89993 -10.2314,0.65691 -18.057,-1.30772 -24.0719,-3.27534 -6.018,-1.96765 -40.3241,-3.2754 -46.345,-3.93228 -6.0149,-0.65386 -10.83,-1.96463 -10.83,-1.96463 l 2.4061,3.92926 -16.8508,-2.61849 -4.8151,7.20762 c 0,0 -16.2492,3.2754 -17.4552,-1.96762 -1.203,-5.24 -9.63,23.59054 -13.8433,32.11196 -4.2137,8.51839 -23.4379,5.69405 -28.2527,10.93707 -4.8151,5.24303 -15.0847,8.75146 -17.4878,10.06223 -2.4092,1.31077 -9.71,0.69325 -13.9234,0.69325 -6.2698,0 -0.9274,0.0938 -11.2123,2.04935 0,0 -8.8832,-0.0848 -12.2787,-1.4712 -3.3956,-1.3864 -10.86857,-3.53873 -14.63168,-4.61335 -5.13792,-1.46818 -33.72245,-2.11902 -37.7965,-1.88895 -4.07715,0.23004 -10.96934,2.34001 -15.49675,4.18956 -4.52457,1.84958 -12.45375,6.70818 -12.45375,7.86453' id='path7253-6-3' style='fill:%23dcddde' /%3E %3Cpath d='m 915.83886,346.12922 c -18.28205,1.05041 -36.30925,-11.09449 -36.30925,-11.09449 -22.64663,-4.4378 -23.9651,-24.91341 -23.9651,-24.91341 -9.06103,-3.45095 -16.85373,-26.7176 -16.85373,-26.7176 -14.03586,8.37915 -31.60091,0.091 -31.60091,0.091 0,0 0,-3.45095 -15.84931,0 -15.8524,3.45098 -13.13533,-2.95752 -13.13533,-2.95752 0,0 6.34111,-6.4115 -21.73371,0 -28.07507,6.4085 2.26655,-8.38218 2.26655,-8.38218 -8.1512,2.4641 -34.86904,4.4378 -34.86904,4.4378 -9.80465,0.44197 -19.75457,5.27934 -30.59053,8.36703 -6.74382,1.92226 -18.28206,4.16235 -24.11631,6.65369 -15.56472,6.65364 -46.75983,20.95086 -72.52337,31.06155 -33.87056,13.29221 -60.71298,23.40587 -58.94684,22.97905 2.11561,-0.51157 36.78019,-22.46745 80.1977,-42.15301 40.31532,-18.28397 86.59207,-35.20268 109.92314,-41.8291 30.27649,-10.03198 55.07413,-5.24 69.13971,-0.13622 6.79138,2.4641 44.25911,-1.15335 61.00919,0.81732 16.75603,1.97068 18.50124,29.52379 18.50124,29.52379 3.17043,1.97365 4.30228,27.85882 4.30228,27.85882 0,0 -9.28331,0.24529 1.58522,1.72543 10.86853,1.48028 30.79214,17.25781 30.79214,17.25781 6.79112,0 7.56163,-0.24219 7.56163,-0.24219 0,0 3.94662,-4.97362 9.38386,-7.05324 5.43129,-2.0827 10.41517,-4.16537 16.52495,-4.6255 6.11289,-0.46616 14.74408,-0.52067 20.85386,0.17266 6.11289,0.69627 13.33075,0.75073 21.93557,2.37027 8.60457,1.61952 9.50845,2.08265 12.22553,3.00594 2.7171,0.92631 5.1498,0.32692 5.1498,0.32692 11.1883,-4.67692 31.9387,-12.94105 36.7151,-11.99354 0,0 7.8283,-1.96765 12.0386,-5.24302 4.2105,-3.27537 13.8404,-11.14293 13.8404,-11.14293 0,0 -6.6461,-46.79966 40.899,-42.21355 47.5451,4.58917 110.5838,10.69187 123.2242,12.65955 12.6344,1.9646 57.9039,14.8966 68.7367,20.13962 10.8329,5.24297 41.9629,19.18906 55.8149,25.31598 5.6239,2.48529 27.0438,11.97539 42.8962,18.23553 23.7873,9.39327 41.5627,25.04055 41.5627,25.04055 -14.9071,-6.30553 -26.9579,-13.51617 -38.7657,-18.6442 -9.5498,-4.14717 -19.5383,-6.07548 -27.3075,-9.52641 -16.4833,-7.32264 -29.18,-13.99145 -39.1684,-18.6442 -36.8218,-17.1488 -36.484,-17.83595 -51.4,-19.00443 -10.2818,-0.80825 7.3869,12.54147 7.3869,12.54147 0,0 -33.7018,-13.10753 -44.5346,-17.69669 -10.83,-4.58611 -19.8582,-6.55074 -30.0896,-5.89688 -10.2314,0.65691 -18.057,-1.30772 -24.0719,-3.27537 -6.018,-1.96765 -40.3241,-3.27537 -46.345,-3.93228 -6.0149,-0.65386 -10.83,-1.96463 -10.83,-1.96463 l 2.4061,3.92926 -16.8508,-2.61849 -4.8151,7.20765 c 0,0 -16.2492,3.27537 -17.4552,-1.96765 -1.203,-5.24 -9.63,23.59054 -13.8433,32.11196 -4.2137,8.51839 -23.4379,5.69408 -28.2527,10.9371 -4.8151,5.24302 -15.0847,8.75146 -17.4878,10.0622 -2.4092,1.31077 -9.71,0.69323 -13.9234,0.69323 -6.2698,0 -0.9274,0.0938 -11.2123,2.0494 0,0 -8.8832,-0.0848 -12.2787,-1.4712 -3.3956,-1.38947 -10.86857,-3.53875 -14.63168,-4.61335 -5.13792,-1.47121 -33.72245,-2.12204 -37.7965,-1.88898 -4.07715,0.23004 -10.96934,2.33998 -15.49675,4.18959 -4.52457,1.84958 -12.45375,6.70815 -12.45375,7.86453' id='path7255-1-6' style='fill:%23e7e7e7;fill-opacity:1;stroke:%23000000;stroke-width:0.68883264' /%3E %3Cpath d='m 917.7115,340.65918 c 0,0 -1.9171,1.47121 -2.40018,5.14917 -0.47999,3.681 -0.24038,2.20984 -0.24038,2.20984' id='path7257-0-6' style='fill:%23452c25' /%3E %3Cpath d='m 1010.0962,335.26783 c 2.424,1.80721 4.9218,3.64467 7.0729,5.79698 0.07,0.0757 0.7645,0.70837 0.5275,0.1998 -0.2639,-0.55701 -0.7142,-1.07466 -1.1409,-1.50452 -2.3852,-2.3884 -5.117,-4.45598 -7.8134,-6.46294 -0.4446,-0.33299 0.044,0.47828 0.1008,0.56606 0.3466,0.50249 0.7584,1.03833 1.2534,1.40459' id='path7259-8-9' style='fill:%23574f4c' /%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1440' height='720'%3E %3Crect width='1440' height='720' fill='%23f7e017'/%3E %3Cpath d='M0,50V370L1440,520V350z' fill='%23fff'/%3E %3Cpath d='M0,220V370L1440,670V520z' fill='%23000'/%3E %3Cg fill='%23cf1126'%3E %3Cpath d='M695.74,569.72c-19.36-2.57-37.11-8.73-49.44-17.17-2.39-1.64-4.64-2.98-4.99-2.98-0.36,0-0.65,1.82-0.65,4.07,0,6.37-2.56,9.58-9,11.25-6.16,1.6-15.56-1.63-23.18-7.95-7.89-6.55-17-11.55-24.71-13.55-6.35-1.66-14.78-1.39-20.87,0.65-2.83,0.95-6.05,2.29-7.17,2.98-1.11,0.69-2.36,1.25-2.76,1.25-1.08,0-0.93-6.85,0.2-9.04,1.49-2.87,5.16-5.7,9.44-7.26,2.16-0.79,3.93-1.8,3.93-2.25s-0.73-2.1-1.62-3.65c-2.9-5.08-1.71-10,3.35-13.87,5.18-3.96,13.95-4.64,21.7-1.69,1.95,0.74,3.77,1.35,4.04,1.35,1.02,0,0.4-1.43-2.41-5.52-3.24-4.74-3.88-7.08-3.48-12.72,0.52-7.14,6.34-12.98,13.47-13.5,5.82-0.42,9.44,1.54,18.03,9.72,25.65,24.46,53.54,37.94,86.07,41.59,8.21,0.92,24.73,0.43,34.42-1.03,29.27-4.41,58.76-19.13,81.79-40.82,6.38-6.01,9.45-7.6,14.68-7.62,4.55-0.02,7.74,1.45,11,5.05,2.97,3.3,3.98,6.43,3.66,11.44-0.21,3.21-0.73,4.79-2.64,7.9-2.82,4.59-2.34,5.01,3.24,2.85,7.54-2.94,16.83-1.58,21.84,3.18,4.41,4.19,4.83,8.38,1.4,14.06-1.25,2.08-2.27,4.03-2.27,4.34,0,0.57,0.95,0.84,5.53,1.58,5.99,0.96,9.42,5.41,9.42,12.21,0,2.04-0.25,3.7-0.56,3.7-0.3,0-2.57-0.83-5.04-1.85-6.98-2.88-10.95-3.62-19.11-3.57-6.21,0.04-8.35,0.33-12.68,1.74-6.63,2.17-13.72,6.35-19.5,11.5-6.37,5.68-10.38,7.47-16.58,7.42-5.76-0.06-9.7-1.73-11.78-5.02-1.11-1.76-1.27-2.83-1-6.81,0.18-2.59,0.14-4.71-0.07-4.71-0.22,0-2.46,1.42-4.99,3.17-6.64,4.56-10.87,6.82-18.47,9.83-23.18,9.17-56.63,13.14-82.24,9.75z'/%3E %3Cpath d='m706.34,525.17c-38.58-3.7033-75.494-23.798-97.939-55.657-24.37-33.235-32.05-77.117-24.611-117.24,3.9535-18.267,11.929-36.546,25.544-49.554-10.85,23.003-14.516,49.369-8.7299,74.29,8.989,49.753,51.036,91.87,101.34,99.156,19.9,5.761,40.487-0.32356,59.496-6.4934,41.935-14.779,73.879-54.583,77.777-99.079,3.3363-24.078-0.36023-49.114-11.207-70.916,6.1825,3.2692,13.987,16.087,18.589,24.707,16.003,31.003,16.734,68.155,7.3126,101.24-12.78,42.097-44.965,78.978-87.511,92.382-19.308,6.3081-39.842,8.2315-60.058,7.1679z'/%3E %3Cg id='hand'%3E %3Cpath d='m512.02,469.9c-2.5284-0.39577-5.3161,2.092-4.3628,4.6971,1.823,2.633,4.9641,3.9201,7.798,5.1795,6.7915,2.7224,14.179,3.7823,21.471,3.6055-2.5133-0.006,0.86258,0.026,1.8015-0.00068,5.774,0.0171,11.516-1.0234,16.944-2.98,3.018-1.0614,6.8641-2.0244,8.1009-5.3629,1.2069-2.1744-0.98008-4.3462-3.1859-3.9108-3.0714,0.67078-5.9433,2.064-8.9896,2.8576-6.5725,1.8534-13.494,2.5704-20.303,2.0116-4.9792-0.60782-9.8039-2.2005-14.41-4.1433-1.5972-0.70457-3.0962-1.7322-4.8648-1.9536z'/%3E %3Cpath d='m514.83,459.52c-2.5558-0.38057-4.7577,2.5607-3.6917,4.9076,1.965,2.8484,5.2671,4.3651,8.356,5.6992,5.3706,2.1486,11.204,3.0471,16.975,2.8752-2.1917-0.006,0.75258,0.026,1.5651-0.00068,4.9069,0.006,9.7882-0.96448,14.325-2.8311,2.7732-1.0787,6.1693-2.1246,7.3241-5.177,0.89621-1.6768,0.21293-4.1165-1.8997-4.2476-1.9288-0.0953-3.5928,1.1322-5.3782,1.6831-6.4849,2.6815-13.622,3.8183-20.614,3.2146-4.3567-0.56071-8.519-2.1681-12.47-4.0312-1.4847-0.71699-2.8205-1.8356-4.4909-2.092z'/%3E %3Cpath d='m518.28,449.57c-2.1908-0.26295-3.6978,2.2088-3.3288,4.1816,0.32687,1.7334,1.8824,2.8984,3.1689,3.9607,5.3292,3.8973,12.083,5.5573,18.626,5.3398-2.5415-0.009,3.4093,0.0418,1.5947-0.007,4.1442-0.0169,8.2378-1.0309,11.966-2.825,2.4889-1.0824,5.4115-2.3356,6.2502-5.1771,0.40122-1.3236,0.65233-3.227-0.84101-3.97-1.5638-0.87412-3.1169,0.47031-4.5388,1.0156-4.7891,2.4374-10.125,3.7932-15.507,3.7682-4.6507,0.15705-9.0334-1.799-13.068-3.9072-1.464-0.74578-2.6708-2.0422-4.3214-2.3798z'/%3E %3Cpath d='m481.53,302.7c-3.2575,3.2606-0.7701,9.2712-0.94626,13.543,1.6879,13.158,3.785,26.484,8.697,38.87,6.015,12.102,18.791,18.573,26.533,29.268,2.7675,5.155,1.7849,11.355,2.3681,16.994,0.45808,15.366,0.31593,30.743,0.047,46.111,6.9387,3.4817,14.474,6.9863,22.456,5.6471,4.7306-1.13,13.512-1.8326,14.496-6.5436-0.38235-26.5-0.6304-53.01-0.98289-79.506-2.6903-8.1185-10.951-12.32-17.129-17.514-5.0992-5.0259-9.844-10.435-14.188-16.099-2.6218-4.4175-12.868-6.0092-9.1612,1.6764,2.1735,6.6538,7.7204,11.61,9.1091,18.602,0.30342,3.8316,4.8776,10.879,0.97314,13.114-2.4837-4.2216-6.0823-7.815-10.682-9.9574-4.4324-3.3044-11.759-4.68-13.359-10.517-1.1745-8.2799-5.4152-15.782-10.887-21.986,1.4102-7.4368,0.005-16.737-6.4234-21.49l-0.92101-0.21254-0.00013-0.00002z'/%3E %3Cpath d='m491.44,304.19c-2.9629,0.47847-2.8621,4.2538-1.491,6.239,1.4583,4.2881,1.8554,8.9449,1.0659,13.409,5.2675,6.1665,9.3467,13.543,10.576,21.64,0.0299,3.0437,3.2327,4.0512,5.309,5.5551,4.8712,3.1016,10.348,5.3512,14.686,9.2326,0.91286,0.97602,1.6017,2.0271,0.9566,0.035-0.67695-2.5463-1.0251-5.3576-3.0207-7.2849-2.7345-2.939-6.15-5.5628-10.133-6.4593-0.33199-4.114-2.2913-7.8931-4.1017-11.532-2.0066-3.4792-4.1026-7.2065-7.5407-9.4626,0.13834-6.098,0.0385-12.495-2.5857-18.122-0.7696-1.4455-1.9032-3.163-3.7197-3.2499z'/%3E %3Cpath d='m499.73,306.62c-2.0642,0.61274-1.6695,3.1587-1.0158,4.7165,0.98881,4.3156,1.1436,8.7732,1.063,13.184,3.7911,3.0003,6.1624,7.3501,8.3216,11.586,1.3534,2.8304,2.6366,5.7518,3.1556,8.8651,3.0757,1.0188,5.7672,2.946,8.171,5.0773-0.95256-2.8824-3.0766-5.1129-4.5042-7.7441-1.5516-2.7372-3.0336-5.5913-3.6904-8.6923-2.9581-3.1576-4.5872-7.6305-3.9408-11.952,0.13267-4.7762-1.4093-9.7114-4.6059-13.311-0.8049-0.79276-1.7658-1.6692-2.954-1.7296z'/%3E %3Cpath d='m509.16,307.97c-1.1224,0.1984-1.8054,1.2662-2.4064,2.1373-0.23225,0.87316,0.83776,1.8114,1.0081,2.7596,1.3127,3.2919,1.8084,6.903,1.4162,10.426-0.0864,2.5018,0.80881,4.9458,2.0839,7.0649,0.36793-1.5628,1.8164-2.6864,3.3865-2.8406,0.57114-0.10043,1.4107,0.18835,1.0779-0.68251-0.39881-4.7853-1.128-9.5978-2.8007-14.119-0.64833-1.615-1.3844-3.3147-2.7835-4.4203-0.28367-0.20186-0.62304-0.3745-0.98205-0.32512z'/%3E %3C/g%3E %3Cuse xlink:href='%23hand' transform='matrix(-1,0,0,1,1440,0)'/%3E %3Cpath d='m715.67,475.98c-13.493-1.2846-25.667-11.12-29.829-24,0.22423-2.2187,2.9867,1.2413,4.2917,1.4741,2.4503,1.3606,5.0998,2.4802,7.9211,2.6539,3.5571,1.529,5.7565,5.0346,9.1516,6.8629,1.5764,1.2278,7.1544,3.641,6.1182-0.26421-1.307-2.04-2.2057-4.6242-1.0806-6.9613,1.8918-4.1503,4.8018-7.7638,7.7306-11.226,2.1527-0.71996,3.5939,3.5262,5.1338,4.9568,2.1308,3.2786,4.7004,7.2793,3.447,11.352-1.2198,1.5087-2.0216,6.0472,1.2409,4.5219,4.0213-1.7692,7.3158-4.7418,10.651-7.5175,2.9183-2.0384,6.6539-2.1824,9.7125-3.9699,1.4177-0.35921,4.3706-3.1946,4.9861-1.6225-1.6759,4.4876-4.4822,8.5068-7.4822,12.211-4.8588,5.5503-11.432,9.7247-18.786,10.902-4.3459,0.79562-8.806,0.96352-13.207,0.62747z'/%3E %3Cpath d='m731.53,460.22c0.29719-2.7079-0.31965-5.4735-1.703-7.9349-2.123-4.3258-5.1213-8.1663-8.0456-11.961-2.7573-1.615-4.2871,3.6582-6.1205,5.1714-2.8566,4.2769-6.4434,8.6562-6.617,14.036-1.6071,2.5012-4.6044-2.0411-5.8962-3.5357-2.4673-3.4911-4.3356-7.6206-4.0297-11.987-0.29227-7.0356,1.0571-14.041,3.6204-20.581,1.9348-5.5826,5.0755-11.006,4.7564-17.105,0.22416-4.5905-0.70745-9.6582-4.4262-12.745-3.538-2.7758,2.2916-3.3674,4.1432-1.928,3.1686,0.21257,4.8825,5.4481,7.7771,4.152,1.1532-2.7346,1.3824-5.9968,3.7595-8.1295,2.3338-3.1959,4.773,1.3562,5.5715,3.488,1.6467,1.8723-0.0931,6.5066,2.5817,6.6282,3.2062-2.2473,5.4923-6.0227,9.5918-6.8447,1.6623-0.94835,4.5034-0.12664,2.3114,1.7848-3.0339,2.8443-5.6262,6.4002-6.1786,10.631-0.92788,5.3074,0.39912,10.69,2.7124,15.47,4.4468,9.3901,7.8854,19.996,5.6361,30.444-1.0432,4.644-4.1982,8.6454-8.0313,11.341-0.4847,0.29274-1.2499,0.27192-1.4134-0.39473z'/%3E %3Cpath d='m726.73,389.63c-1.4562-2.6239-3.2238-5.2103-5.673-6.9945-2.3812-0.005-3.8508,2.9985-5.468,4.5721-1.134,2.11-2.5118,5.6386-5.3053,2.8796-4.4442-2.5928-5.2306-8.2748-5.202-12.958-0.27951-7.5908,2.777-14.674,5.4923-21.587,1.7275-4.3277,1.3019-9.1991,0.24806-13.634-1.3266-5.0918-5.4137-8.6231-8.5601-12.595,0.214-1.5365,4.235-0.69686,5.7483-0.40478,3.3588,0.85136,5.3664,3.8249,7.8703,5.9259,1.7818-0.53937,1.0545-4.1395,1.8839-5.833,0.0613-2.3821,3.233-5.5228,4.5407-2.1121,1.9588,2.1674-0.0626,6.4643,2.4686,7.8144,2.4113-0.89283,3.6009-3.5283,5.8666-4.72,2.2295-1.5204,5.3776-1.69,7.7781-0.49647,0.84484,2.2126-2.6402,4.0548-3.6496,5.9771-4.052,5.0056-5.4756,11.91-3.7401,18.112,1.3759,4.8649,3.8133,9.4058,4.6546,14.434,1.0126,5.6525,0.97903,11.589-0.48403,17.159-0.87455,3.3816-3.8021,5.6402-6.8258,7.0448-0.74602-0.69428-1.1395-1.7142-1.6436-2.583z'/%3E %3Cpath d='M711.61,326.89c-3.36-2.46-4.47-4.81-4.47-9.46,0-2.38,0.44-3.67,2.01-5.83,2.31-3.2,1.89-4.21-1.38-3.27-5.26,1.51-7.77,0.13-7.95-4.35-0.08-2.19,0.38-3.12,3.33-6.66,2.36-2.84,3.22-4.33,2.75-4.8-0.46-0.46-3.25,1.96-8.98,7.79-4.57,4.65-9.71,9.4-11.42,10.56-9.84,6.64-19.24,7.67-23.53,2.56-2.2-2.61-2.08-4.08,0.46-5.66,1.17-0.72,3.14-2.38,4.39-3.69,2.95-3.07,11.74-9.41,16.1-11.61,3.54-1.79,4.38-3,2.08-3-2.98,0-12.54,6.22-19.79,12.88-2.13,1.97-5.2,4.16-6.81,4.87-3.62,1.6-10.73,2.19-13.89,1.15-2.23-0.74-6.3-4.58-6.3-5.95,0-0.36,0.93-1.16,2.06-1.77,1.13-0.6,3.16-2.07,4.5-3.24,5.8-5.09,16.79-10.33,25.51-12.16,2.77-0.58,1.75-1.98-1.34-1.84-5.99,0.26-17.88,5.83-24.98,11.69-8.32,6.86-20.87,6.21-24.91-1.29-0.7-1.29-1.11-2.5-0.91-2.69,0.19-0.19,2.66-0.93,5.49-1.65,3.06-0.77,9.12-3.28,14.91-6.17,9.11-4.54,11.81-5.51,18.08-6.52,2.82-0.45,2.97-1.83,0.23-2.15-3.53-0.42-8.94,1.35-18.5,6.05-12.28,6.04-15.72,7.08-22.19,6.7-5.9-0.36-9.23-1.87-14.02-6.4-3.13-2.97-7.57-10.51-6.7-11.38,0.21-0.21,1.65,0,3.2,0.45,1.72,0.51,6.65,0.85,12.59,0.86,8.31,0.02,10.52-0.2,14.95-1.48,7.41-2.14,17.26-7.15,24-12.18,12.89-9.64,23.4-13.51,36.8-13.57,12.37-0.05,20.24,2.81,27.21,9.88,2.36,2.39,4.37,3.94,4.7,3.61,0.31-0.31,0.65-4.49,0.75-9.29,0,0,3.64-0.35,4.41,0.67,0,7.79,0.09,8.4,1.22,8.4,0.74,0,1.53-0.76,2.02-1.94,1.06-2.55,4.98-6.04,9.17-8.16,9.05-4.59,24.71-4.73,37.29-0.34,5.3,1.86,11.18,5.18,16.78,9.5,5.62,4.32,17.11,10.1,23.9,12.03,6.87,1.95,18.98,2.44,25.19,1.03,2.56-0.58,4.96-1.06,5.34-1.06,2.29,0-1.61,7.63-6.19,12.1-8.37,8.18-19.26,8.14-34.58-0.12-9.55-5.14-20.97-7.95-20.97-5.15,0,0.58,0.6,0.97,1.49,0.97,3.32,0,9.73,2.23,18.67,6.47,9.67,4.6,15.1,6.54,18.32,6.54,2.34,0,2.41,1.45,0.23,4.65-2.31,3.41-6.23,5.1-11.77,5.09-5.29-0.02-8.23-1.18-12.96-5.11-7.91-6.58-27.62-13.92-26.86-10,0.15,0.78,1.1,1.26,3.13,1.57,6.86,1.05,14.91,4.89,23.15,11.06,2.54,1.91,5.18,3.79,5.85,4.19,1.13,0.66,1.15,0.86,0.26,2.53-1.48,2.76-5.21,4.9-9.25,5.32-5.23,0.54-9.78-1.02-14.49-4.96-9.94-8.32-19.31-14.34-22.31-14.34-2.45,0-1.35,1.35,2.97,3.64,5.68,3.01,11.52,7.08,15.82,11.03,2.03,1.88,4.32,3.74,5.08,4.15,1.8,0.96,1.73,2.37-0.25,4.96-2.02,2.64-5.36,3.8-9.69,3.34-8.64-0.91-15.38-5.08-25.97-16.07-4.14-4.29-7.83-7.8-8.21-7.8-1.41,0-0.58,1.91,2.15,4.97,3.38,3.78,4.03,5.91,2.75,8.98-1.13,2.72-3.01,3.35-6.87,2.31-3.95-1.07-4.57-0.1-1.98,3.12,3.86,4.81,3.29,10.7-1.44,14.75-1.47,1.25-3.01,2.28-3.43,2.28-0.41,0-1.45-1.07-2.32-2.38-3.04-4.62-5.71-4.59-8.67,0.08-1.03,1.63-1.9,2.95-1.93,2.94-0.04-0.01-1.43-1.01-3.08-2.23z'/%3E %3Cpath d='M726.67,233.03,721.54,237.09,716.94,233.62,716.94,261.36,726.67,261.48z'/%3E %3Cpath d='M694.89,204.25c-1.02,13.11-4.35,22.26-8.98,32.35l11.1-10.29,7.72,9.17,8.36-9.33,8.53,7.88,8.2-8.2,8.52,9.97,7.4-8.2,12.54,9c-4.55-10.09-10.71-18.64-9.94-32.84-12.15,9.03-41.02,10.66-53.45,0.49z'/%3E %3Cpath d='M716.95,197.56c-4.46,0.08-9.16,0.14-13.39,0.97-2.93,0.58-5.59,1.53-7.81,3.1,0.36,8.53,41,12.09,51.9,0.16-2.29-1.67-5.09-2.66-8.17-3.26-4.07-0.79-8.57-0.87-12.84-0.94,0,2.34,0.02,4.69,0.02,7.04l-9.71-0.03v-7.04z'/%3E %3Cpath d='M724.9,153.97,718.59,154.02,718.59,203.4,725.03,203.43z'/%3E %3Cpath d='M724.89,155.24,722.48,178.88,746.8,190.76,734.49,174.3,751.3,168.85z'/%3E %3Cpath d='M722.18,149.08c-3.69,0-6.42,1.38-6.42,3.02s2.73,3.03,6.42,3.03,6.4-1.39,6.4-3.03-2.71-3.02-6.4-3.02z'/%3E %3C/g%3E %3Cg fill='%23f7e017'%3E %3Cpath d='M711.05,563.82c3.99-1.32,6.26-3.74,7.89-8.4,0.81-2.32,1.36-4.73,1.22-5.36-0.34-1.49-2.06-1.41-3.96,0.17-1.3,1.09-1.46,1.64-1.09,3.86,0.95,5.6-1.04,6.99-11.64,8.13-1.05,0.11-4.09-0.07-6.77-0.4-5.04-0.63-6.84-0.13-5.01,1.39,0.55,0.46,1.95,1.08,3.11,1.37,2.83,0.73,13.22,0.24,16.25-0.76z'/%3E %3Cpath d='M733.02,562.89c0.6-0.55,2.66-1.5,4.58-2.12,2.56-0.82,3.88-1.7,4.96-3.31,3.11-4.63,2.53-8.62-2.04-14-2.48-2.92-3.58-2.84-5.56,0.4-1.71,2.8-1.67,2.98,0.79,3.62,1.29,0.33,2.53,1.28,3.21,2.45,2.68,4.64,1.89,7.51-2.08,7.54-3.6,0.03-4.59,0.54-5.56,2.87-0.51,1.21-0.92,2.5-0.92,2.87,0,0.98,1.36,0.81,2.62-0.32z'/%3E %3Cpath d='M725.81,557.65c0.68-1.84,0.92-5.15,0.84-11.9-0.05-5.14-0.25-9.5-0.45-9.7-0.6-0.6-3.56,1.31-3.95,2.54-0.2,0.64,0.13,2.12,0.73,3.28,0.92,1.79,1.04,3.46,0.76,10.47-0.36,8.86,0.22,10.35,2.07,5.31z'/%3E %3Cpath d='M708.89,553.43c0.36-1.65,0.82-5.03,1.03-7.5s0.72-5.59,1.12-6.94c1.02-3.46-0.01-4.37-2.74-2.43l-2.03,1.45,0.42,4.97c0.39,4.48-0.32,12.83-1.35,16.07-0.28,0.86,0.12,0.64,1.25-0.68,0.91-1.06,1.95-3.29,2.3-4.94z'/%3E %3Cpath d='m693.88,555.84c3.6514-3.0546,3.2318-8.2704,4.04-12.52-0.0835-2.8248,1.8038-6.2116,0.58588-8.6828-3.4119,0.62408-5.5147,3.8554-3.7684,7.0746,0.14546,3.7382,0.0129,7.8076-1.9089,11.113-1.5698,2.1618-6.5419,1.6234-6.3131-1.4406,1.2477-4.6065-4.2718-2.3648-6.4264-1.1571-1.6657,1.1597-5.1825,1.2451-3.9601-1.6569-0.80663-3.8664-5.7798-1.4479-8.4816-1.4651-2.552-0.0466-0.21096-5.1708-3.8736-4.271-6.8058-0.53675-14.319,0.0602-20.21-4.0515-3.4486-1.6577-2.937-5.8052-1.1415-8.4888,2.1442-3.6651,2.7555-8.249,6.1588-11.093,3.369-3.231-3.1775-1.8666-4.6517-0.77788-3.2819,1.7962-0.23302,6.4226-2.9192,8.9886-1.5695,2.6611-3.6362,6.3361-7.2698,5.8296-5.2398-0.9908-8.2605-5.8651-12.017-9.1317-3.218-0.64222-1.4087,5.2218,0.25284,6.4543,3.2878,2.4618,7.1291,4.2558,11.092,5.3187,3.9439-0.63072,4.0717,4.5336,7.4444,5.3437,6.1873,2.883,13.083,3.7467,19.833,4.0986,2.6511,0.22107,1.16,4.9425,4.6458,4.0096,1.948,0.50493,6.3478-0.72487,6.5682,1.5381-2.9527,3.5059,2.8341,3.4276,4.9757,2.7999,2.742-0.41905,6.2461-1.4668,6.9708,2.2924,2.289,2.413,6.4921,2.057,9.2796,0.67619,0.39162-0.22691,0.75972-0.49483,1.0937-0.80043z'/%3E %3Cpath d='M634.12,525.57c1.11-1.41,2.77-4.26,3.69-6.34,0.91-2.09,2.28-4.46,3.03-5.27,1.76-1.9,0.78-3.07-2.06-2.44-1.5,0.33-2.11,0.88-2.36,2.18-0.85,4.24-2.39,8.58-3.76,10.6-2.48,3.66-2.54,3.81-1.52,3.81,0.53,0,1.87-1.14,2.98-2.54z'/%3E %3Cpath d='M596.66,502.09c-2.8,0-2.92,1.77-0.19,2.72,1.32,0.46,2.44,1.57,3.34,3.38,2.66,5.29,4.22,6.23,11.28,6.84l4.53,0.41,0.22,2.75c0.11,1.52,0.47,2.78,0.82,2.78s2.1-0.76,3.87-1.66c3.32-1.68,6.47-5.6,6.47-8.03,0-1.59-2.65-3.31-5.06-3.31-1.07,0-3.11,0.86-4.72,2.03-5.04,3.65-10.43,2.91-13.38-1.84-2.42-3.92-4.95-6.07-7.18-6.07zm24.46,9.75c1.34,0,1.67,0.99,0.94,2.88-0.5,1.3-2.13,1.34-2.62,0.06-0.58-1.51,0.23-2.94,1.68-2.94z'/%3E %3Cpath d='M810.84,505.69c-1.83,0.07-2.37,0.47-3.53,2.19-1.9,2.82-2.09,8.93-0.34,11.09,1.09,1.34,1.25,1.37,3.56,0.41,3.22-1.35,3.76-1.3,3.75,0.43-0.02,4.42-6.36,12.94-13,17.47-1.79,1.22-3.39,2.58-3.56,3.03-0.48,1.26,1.98,0.98,5-0.56,4.12-2.1,9.53-7.62,11.75-11.97,1.76-3.47,2.01-4.65,2.22-10.72,0.19-5.59,0.04-7.23-0.91-9.09-1.06-2.09-1.4-2.28-4.06-2.28-0.32,0-0.61-0.01-0.88,0zm0.22,3.9c1.38,0,1.62,0.31,1.78,2.29,0.14,1.64-0.15,2.64-1.06,3.46-1.24,1.12-1.34,1.11-2.44-0.56-1.54-2.36-0.59-5.19,1.72-5.19z'/%3E %3Cpath d='M780.7,552.27c5.85-2.88,9.3-6.12,11.52-10.81,1.05-2.23,1.91-4.33,1.91-4.69,0-0.81-2.88-2.15-4.61-2.15-1.72,0-2.07-1.19-1.33-4.48,0.72-3.21-0.15-7.23-1.56-7.23-0.51,0-1.41,0.75-2.01,1.66-0.92,1.41-0.97,2.01-0.29,4.06,1,3.04,0.21,5.31-2.51,7.25-1.29,0.92-2,1.98-2,3.01,0,0.87,0.11,1.58,0.24,1.58,0.14,0,1.56-0.74,3.16-1.63l2.92-1.63,1.72,1.35c0.94,0.74,1.72,1.95,1.72,2.69,0,3.56-10.15,9.54-17.12,10.1-3.71,0.3-4.34,0.17-5.63-1.11-1.05-1.05-1.35-1.93-1.09-3.17,0.2-0.95,0.56-2.68,0.8-3.84,0.64-3.1-0.69-2.68-2.99,0.94-1.89,2.99-2.45,6.18-1.39,7.86,0.87,1.37,6.65,2.68,10.74,2.43,2.57-0.15,5.11-0.87,7.8-2.19z'/%3E %3Cpath d='M819.74,530.49c3.68-3.67,5.24-8.14,5.26-15.05l0.01-5.19,3.04-1.44c3.95-1.88,7.69-5.62,7.69-7.7,0-2.14-0.95-2.03-2.67,0.3-1.25,1.69-2.92,2.71-9.03,5.52-1.54,0.71-1.64,1.09-1.99,7.55-0.41,7.45-1.42,10.24-5.58,15.33-2.55,3.1-2.64,3.51-0.87,3.51,0.73,0,2.59-1.27,4.14-2.83z'/%3E %3Cpath d='M779.66,526.33c0.35-1.07-1.68-1.83-2.56-0.96-0.37,0.37-0.47,1.01-0.22,1.42,0.58,0.93,2.42,0.62,2.78-0.46z'/%3E %3Cpath d='M834.93,512.02c0.36-1.07-1.68-1.83-2.55-0.96-0.38,0.38-0.48,1.02-0.23,1.43,0.58,0.93,2.42,0.62,2.78-0.47z'/%3E %3Cpath d='m768.41,473.28c-1.4296,0.68071-2.1713,2.2244-3.165,3.4028-0.71516,0.48622-0.14203,0.9405,0.26976,1.3988,2.5225,2.7171,3.5898,6.3866,4.7883,9.8088,1.177,4.0402,2.659,8.3784,1.4283,12.588-0.48423,1.6123-1.7525,3.2813-3.6466,2.746-3.0304-0.18916-6.0122-0.99351-9.0512-0.96152-2.705,0.14095-4.7956,2.6024-7.5614,2.3341-1.767,0.11638-1.6925-3.618-3.3341-2.6194-0.8128,1.9472-0.41254,4.1196-0.50932,6.1787,0.30628,0.29508,1.165,0.0377,1.6799,0.1242h5.4451c0.38492,1.8802,0.33677,4.0358,1.6875,5.5312,1.8899,0.67214,4.0159,0.0917,5.8116-0.64309,1.9256-0.89569,2.1834-3.2112,2.7274-5.0153,0.57858-1.9384,3.117-1.4302,4.6149-2.1913,3.6648-1.0697,6.0666-4.8789,5.852-8.6268-0.23686-5.722-2.4198-11.105-4.0759-16.521-0.83346-2.386-1.4104-4.875-2.377-7.2045-0.11331-0.20034-0.34573-0.36894-0.58432-0.32903zm-9.07,32.72c2.0364-0.13276,2.9212,2.3697,2.4899,4.0293-0.76215,2.2555-3.5349,0.80928-4.0958-0.81602-1.0301-1.4517-0.39353-3.4044,1.6058-3.2133z'/%3E %3Cpath d='M683.94,487.22c-0.91-0.02-1.93,0.32-2.94,1.03-5.31,3.72-6.67,8.12-3.06,9.84,2.65,1.27,1.98,2.76-2.19,4.85-5.97,2.98-11.24,2.61-21.25-1.53-2.46-1.02-3.1-0.63-2.53,1.62,0.55,2.21,2.57,3.42,7.59,4.56,5.4,1.24,11.93,0.84,16.13-0.97,2.05-0.88,4.48-2.73,6.53-4.96l3.25-3.57,3.78,0.47c4.66,0.57,4.75,0.62,4.75,2.85,0,1.77,0.1,1.81,4.38,2.21,2.41,0.23,5.58,0.44,7.06,0.44,1.89,0.01,2.96,0.34,3.59,1.22,0.84,1.17,1.34,1.23,8.38,0.6,6.58-0.6,7.87-0.55,10.84,0.46,2.11,0.72,4.43,1.01,6.19,0.82,5.04-0.57,11.99-4.69,13-7.72,0.12-0.37,1.95-1.02,4.06-1.44,5.09-1.02,5.31-2.13,0.56-2.72-2.06-0.26-5.15-1.01-6.87-1.69-1.73-0.68-4.09-1.25-5.25-1.25-2.56,0-4.97,1.6-4.97,3.25,0,1.08,0.38,1.19,3.41,0.88,2.85-0.29,3.68-0.13,5.18,1.06,0.99,0.78,1.65,1.7,1.44,2.03-0.67,1.09-6.62,3.8-9.25,4.22-1.76,0.28-3.18,0.09-4.56-0.62-2.31-1.2-5.71-1.38-6.35-0.35-0.27,0.45-1,0.16-2-0.78l-1.56-1.47-3.53,1.47c-3.59,1.49-4.91,1.43-4.91-0.28,0-0.78-1.05-0.87-6.34-0.53-5.83,0.38-6.44,0.28-7.53-0.94-1.01-1.12-1.03-1.51-0.31-2.66,0.66-1.06,0.66-1.52,0.03-2.15s-1.45-0.62-3.75,0c-5.8,1.55-7.44,0.68-7.44-3.85,0-2.72-1.56-4.37-3.56-4.4zm-1.44,4.16c0.31,0,0.57,0.19,0.97,0.59,0.51,0.51,0.78,1.4,0.56,1.97-0.52,1.35-2.98,1.3-3.5-0.06-0.25-0.66,0.07-1.4,0.81-1.94,0.52-0.38,0.85-0.57,1.16-0.56z'/%3E %3Cpath d='M672.1,495.6c3.53-2.24,3.45-2.07,3.96-8.29,0.35-4.39,0.29-4.72-0.9-4.72-1.73,0-2.63,1.9-2.63,5.52,0,2.32-0.36,3.36-1.6,4.59-2.94,2.94-10.24,1.6-11.16-2.05-0.31-1.25,0.09-2.38,1.62-4.55,3.19-4.53,2.47-5.64-1.44-2.2-2.69,2.35-3.17,2.42-2.66,0.39,0.47-1.87-0.51-2.61-2.7-2.06-1.12,0.28-1.73,0.98-2,2.34-0.26,1.33-0.87,2.07-1.93,2.33-1.77,0.45-4.79-1.23-4.79-2.66,0-1.06,4.52-6.58,10.32-12.6,2.19-2.28,3.98-4.4,3.98-4.72s-1.17-0.58-2.6-0.58c-2.09,0-2.6,0.23-2.6,1.2,0,0.66-2.92,4.49-6.5,8.52-7.46,8.4-8.08,10.15-4.39,12.39,2.97,1.82,6.78,1.68,9.77-0.35l2.42-1.65v2.99c0,3.82,0.76,5.19,3.76,6.78,3.77,1.99,8.33,1.75,12.07-0.62z'/%3E %3Cpath d='m828.66,443.69c-2.7668,1.6519-0.60168,5.1236-0.18254,7.4288-1.1299,3.146-5.1718,3.9934-8.1183,4.5774-4.1736,0.69135-7.1308,4.1827-8.7186,7.8921-0.86037,2.4089-2.9366,6.1445-5.1993,2.4767-1.9667-1.9933-5.5819-3.5732-7.9078-1.2462-1.7668,1.6824-2.2148,4.1568-2.8735,6.4025-1.0427-1.7262-1.5104-4.2966-3.7201-4.8424-3.5276,0.49628-2.2527,4.9439-0.594,6.7779,1.5076,2.1378,2.9558,4.9578,1.4779,7.4969-1.303,3.0516-5.8095,5.11-8.4565,2.4995-2.4722-1.305-0.81896-5.9649-3.254-6.221-1.204,0.86977-1.3032,5.7458-3.2303,3.1024-1.3906-2.2586-0.65318-5.3523-2.3547-7.3843-2.0106,0.24966-3.6272,3.7115-2.9583,5.5709,2.6825,3.6176,3.7849,8.1558,4.8314,12.467,0.65196,1.7264-0.0951,5.2267,1.5199,5.9106,1.1196-2.7787,0.0791-5.9306,0.96044-8.7358,2.6182-0.32901,5.5303,0.86591,8.2761,0.23077,3.9286-0.50981,6.9646-3.825,8.3424-7.3555,0.41644-2.6542-0.079-5.3476-0.15274-8.0168,3.1034,0.48084,6.3281,0.47101,9.3135,1.4788,1.4804,2.2709-0.46974,5.4485-0.87913,7.9295-1.5586,5.0524-5.5163,8.7194-9.366,12.097-1.6101,0.95299-1.8264,3.4782,0.55162,2.118,5.1735-2.2122,9.0295-6.8975,11.248-11.969,1.619-3.9019,0.31744-8.2474,1.3744-12.238,1.5617-2.9959,5.3215-2.3646,8.1035-2.3553,2.879-0.10959,5.3363-3.464,4.3747-6.2619-0.91607-3.2468,2.519-4.8109,4.8661-5.9714,3.1119-1.5702,5.4981-4.7591,5.2571-8.3583-0.12787-1.8402-0.0371-5.3318-2.5312-5.5zm-11.031,18.75c3.3336,0.88568-0.60342,7.2524-2.375,3.2188-0.54528-1.539,0.75001-3.2741,2.375-3.2188zm-15.47,4.56c4.3385-0.25338,2.7806,6.0812-0.88479,3.2048-1.9006-0.95441-1.2718-3.3229,0.88479-3.2048z'/%3E %3Cpath d='M645.1,491.48c0.12-0.63-0.2-1.08-0.77-1.08-1.21,0-1.94,1.06-1.37,1.98,0.59,0.95,1.89,0.41,2.14-0.9z'/%3E %3Cpath d='M695.94,485.8c0-0.93-0.35-1.28-1.13-1.13-1.7,0.32-1.89,2.48-0.22,2.48,0.93,0,1.35-0.42,1.35-1.35z'/%3E %3Cpath d='m633.03,455.28c-2.029-0.41667-3.3053,1.3004-4,2.9375-1.5174,2.5503-3.3705,5.1587-6.0931,6.5091-1.9578,0.54422-4.0937-0.20046-5.7819-1.2102-2.0147-1.0029-1.5567-3.4259-2.4202-5.1005-1.457-1.1443-4.0407,0.4921-3.9834,2.2714-0.16115,2.3862,2.0713,3.7641,3.9242,4.6869,1.5747,0.96445,3.8577,1.5009,4.4871,3.4529-0.0437,1.6587,0.6235,3.5571,2.6435,2.9166,2.2597-0.0372,2.8449,2.7155,1.9326,4.3671-0.92932,1.8613-1.5564,4.0416-1.1119,6.1154,1.08,0.90934,2.1827-1.5301,2.9652-2.2268,0.53138-0.70851,1.0628-1.417,1.5941-2.1255,3.9984,0.21679,7.9929,0.72673,12.001,0.5846,2.8505-0.0516,5.2778-1.8114,7.0906-3.875,2.5633-2.6802,4.6693-5.8294,7.597-8.142,2.0839-0.50859,0.96439-4.4336-1.2124-3.3001-1.9608,0.7355-2.578,2.9513-3.9368,4.3632-2.3146,2.8028-4.6762,5.6471-7.5941,7.8434-2.1245,0.8812-4.5705,0.49663-6.7532-0.00022-0.91062-0.79618,1.8087-1.445,2.188-2.33,1.252-1.2507,2.7385-2.438,3.4639-4.0814-0.69398-1.5148-2.8167-1.6373-4.3126-1.6678-3.6856,0.44249-6.5007,3.5363-10.223,3.8277-2.8253,0.099-1.355-2.9607-0.0813-4.0046,2.4916-2.9589,5.1844-5.7458,7.7858-8.6074,0.73816-0.88845,3.4086-1.732,1.7006-2.98-0.59723-0.21503-1.2431-0.21478-1.8694-0.22424zm1.8125,14.969c1.8586,1.0454-1.1858,2.7567-2.4681,2.5229-1.6823,0.50416-1.7125-1.2116-0.2183-1.5533,0.8401-0.43711,1.7274-0.89316,2.6864-0.96961zm-5.7188,3.9062c1.0579-0.0202,3.2748,0.99623,1.1931,1.6469-1.4494,1.1234-3.0867-1.1434-1.1931-1.6469z'/%3E %3Cpath d='M674.15,476.74c0-1.41-2.53-1.21-2.81,0.22-0.18,0.92,0.11,1.14,1.29,0.97,0.84-0.12,1.52-0.65,1.52-1.19z'/%3E %3Cpath d='M786.2,466.82c0.26-1.35-1.62-2.25-2.61-1.26s-0.08,2.87,1.26,2.61c0.62-0.12,1.23-0.73,1.35-1.35z'/%3E %3Cpath d='M611.82,453.09c1.76-1.51,1.78-1.61,1.02-4.93-1.08-4.65-1.01-5.15,0.76-5.59,2.24-0.57,7.93,2.48,9.19,4.92,0.98,1.89,0.95,2.02-0.71,3.56-1.79,1.65-1.78,3.58,0.01,3.58,1.48,0,5.57-3.87,5.57-5.26,0-1.93-4.54-6.49-8.13-8.16-2.22-1.04-4.44-1.52-7.01-1.53-4.6,0-5.22,0.99-3.98,6.34,1.46,6.27-0.52,7.12-5.57,2.39-3.75-3.51-5.23-7.16-5.21-12.91,0.01-6.17,2.37-9.22,7.69-9.94,3.53-0.47,3.44-1.3-0.19-1.84-5.3-0.8-9.78,2.74-11.48,9.06-1.89,7.01,2.44,15.55,10.1,19.95,4.01,2.3,5.61,2.37,7.94,0.36z'/%3E %3Cpath d='M820.66,445.4c0.43-0.43,0.78-1.4,0.78-2.15s0.73-2.36,1.62-3.57c0.9-1.21,1.63-2.45,1.63-2.75,0-1.23-2.03-1.19-3.63,0.08-1.64,1.28-2.87,1.31-2.87,0.06,0-0.31,0.78-0.95,1.74-1.42,2.38-1.16,2.58-2.31,0.57-3.23-2.58-1.17-5.17,0.97-5.44,4.5-0.17,2.36,0.02,2.77,1.84,3.84,1.66,0.98,1.97,1.5,1.69,2.9-0.48,2.43,0.53,3.28,2.07,1.74z'/%3E %3Cpath d='M840.29,443.18c1.44-1.29,2.61-2.76,2.61-3.25s1.24-1.79,2.76-2.88c4.31-3.1,5.26-6.23,3.33-11.04-0.75-1.89-3.11-4.5-8.24-9.12-3.94-3.56-7.57-6.47-8.04-6.47-1.4,0-1.15,5.15,0.27,5.6,2.56,0.82,4.11,1.87,8.14,5.5,4.68,4.23,6.84,8.18,5.66,10.38-1.13,2.13-2.63,1.47-6.76-2.96-2.17-2.33-4.32-4.23-4.76-4.23-0.48,0.01-0.82,0.85-0.82,2.03,0,1.48,0.79,2.89,2.93,5.27,3.49,3.88,3.83,6.21,1.21,8.27-0.94,0.74-1.91,1.35-2.15,1.35-0.23,0-1-1.16-1.7-2.57-1.46-2.96-10.39-12.39-11.73-12.39-0.61,0-0.91,0.76-0.91,2.26,0,1.81,0.36,2.45,1.8,3.19,1.77,0.92,6.15,5.33,10.55,10.65,1.26,1.52,2.5,2.75,2.77,2.76,0.26,0,1.65-1.06,3.08-2.35z'/%3E %3Cpath d='M849.05,418.11c-0.58-1.87-12.56-14.2-13.79-14.2-0.64,0-0.84,0.76-0.69,2.72,0.17,2.38,0.43,2.79,2.07,3.22,1.02,0.27,4.18,2.75,7.01,5.5,2.82,2.75,5.3,4.84,5.5,4.63,0.2-0.2,0.16-1.04-0.1-1.87z'/%3E %3Cpath d='m777.5,556.89a1.7806,1.6322,0,1,1,-3.5612,0,1.7806,1.6322,0,1,1,3.5612,0z'/%3E %3Cpath d='m783.79,554.79a1.7806,1.6322,0,1,1,-3.5612,0,1.7806,1.6322,0,1,1,3.5612,0z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H1200V600H0z' fill='%23cf142b'/%3E %3Cg%3E %3Cpath fill='%23fff' d='m767.32,145.154v253.639c3.0024,36.3156,78.6864,59.178,131.454,97.7484,69.2124-46.422,136.34-55.812,139.039-107.858l0.8424-243.529h-271.33z'/%3E %3Cg fill='none'%3E %3Cpath fill='%232f8f22' stroke='%23000' stroke-width='0.45648' d='m767.292,395.158,2.8344,14.4852,9.4464,11.3376,68.34,44.0856,50.0724,31.1796,97.626-53.2224,33.6972-25.8252,6.6144-33.696-4.0956-7.872,0.9456,8.1876-2.5212,6.6132-2.832-1.8912-1.8888-12.2808-0.3168,9.1308-4.7232,5.3568-0.9444-6.6168,1.26-4.722-1.89-5.3532-0.63,10.7064-2.5188,4.7256-2.2056-3.1512,0.9456-4.7256-0.3144-4.4064-1.5756-2.2068-0.3168,4.7256-0.9432,1.5732,0.3156,2.8332-1.89,1.8912-1.26-3.7776,0.6312-3.4668-0.6312-3.1464-1.26-3.4668,0.3168,5.67-3.15,6.9276-2.52,1.5744-1.5744-1.89,0.3168-6.6132-2.2056-3.7776,0.6288,8.1876-3.1476,7.2444-1.8888-2.2068-0.948-2.2032v-3.4668l3.4668-8.8164-3.4668,3.15-2.832,7.5564-1.26,2.2032-1.5744-3.7776,2.2056-8.5032-1.2612-1.572-2.8332,10.3908-2.5212,1.5744-1.8888-0.6312-1.2588,0.6312-152.425,8.5032-4.0944-5.9844-0.9432,5.9844-2.5212,2.2032-2.5176-11.0232-1.89,11.6544-2.5212-5.6688,1.2612-12.9144-1.2612-0.9432-1.8876,6.9276v9.7632l-0.9456,6.6132-1.89-1.26-2.5188-5.9832-0.3144-9.7644,0.9432-6.9276-2.5188,8.1876v10.0788l-0.3144,5.0364-3.1512-6.9276-1.5744-5.67-3.1488-6.612,1.89,8.5032v4.41l-5.3544-4.7256-2.8332-13.2252-0.63,9.7632,1.26,4.722-1.5744,1.8912-3.1488-5.67-1.8888-7.5564-2.2044-7.2444v11.6508l1.5744,6.3-1.26,1.5756-2.5188-1.26-0.9456-6.9312-0.6312-10.0752-2.5176,6.9276-0.6312,7.2408-0.9444,5.67-1.5744,3.7812-4.4088,0.3228z'/%3E %3Cpath stroke='%234dcf4a' stroke-width='0.91284' d='m876.022,472.104c-0.8184-14.8848,12.6432-29.772-23.5932-44.6604'/%3E %3Cpath stroke='%2338bb26' stroke-width='1.14108' d='m910.572,463.678c0-19.662-11.2356-28.0872-33.7068-25.2792'/%3E %3Cpath stroke='%2351c757' stroke-width='0.91284' d='m922.368,472.104c-11.8752-14.298-27.7368-12.642-46.3464,0'/%3E %3Cpath stroke='%2351c757' stroke-width='0.91284' d='m951.86,453.566c-4.5108-8.406-20.9736-2.8692-38.7612,4.2168'/%3E %3Cpath stroke='%237acb73' stroke-width='0.82164' d='m1011.69,426.602c-4.494-12.9204-12.3576-20.2248-23.5944-21.9096'/%3E %3Cpath stroke='%234cb135' stroke-width='1.14108' d='m1026.86,406.376c-2.9808-6.6744-6.1008-13.0752-13.482-10.9548'/%3E %3Cpath stroke='%2360c85a' stroke-width='1.278' d='m845.686,459.466c3.9252-13.476-0.3324-18.7692-7.5828-21.0672'/%3E %3Cpath stroke='%2371ce5b' stroke-width='1.1868' d='m781.645,409.747c7.5-3.2556,13.4892-9.5316,24.4356-5.8956'/%3E %3Cpath stroke='%2371ce5b' stroke-width='1.1868' d='m772.375,401.323c6.1248,0.1284,10.4016,2.5188,11.796,8.4252'/%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.45648'%3E %3Cpath fill='%23000' d='m905.36,150.642c-3.54226,3.25938-7.17643,6.25083-12.2809,4.95671-3.49269,1.43202-0.1051,9.6721-5.79256,7.97449-5.51847-4.36808-4.05772,5.21006-7.59441,7.21367-3.23212,1.03309-9.23263,2.62193-4.48171,6.4602,2.90371,2.83623,5.69451,7.76316,0.94071,10.2349-2.75484,5.18425-3.34176-4.77529-7.4259,1.07401-1.32405,5.91639,8.79055,4.62676,4.08827,9.21187-0.78856,2.74357-3.59803-6.76192-6.44736,0.79472-2.21447,3.12776-2.29966,7.74438,1.95225,9.14175,3.62127,2.07886,11.2149-1.08347,6.69187,5.02064,0.00071,3.60178-5.94797,9.58271-3.68958,2.80003,4.0639-4.71862-1.8354-6.02381-4.50767-2.80487-5.48606,3.74093-3.207,12.0658,2.15222,14.4675,1.58725,3.3247,3.19831,4.20255-0.81863,8.20386,0.54947,4.0071-0.28217,7.45192-5.56777,7.20054-2.95045,2.79703-4.93387,7.46347-10.5468,6.75851-5.38845,2.17173-6.74333-1.37286-7.75895-5.64889-1.74428-4.24891-8.86625-6.67841-11.4651-1.98322-3.11881-1.26246-7.17118-7.18853-10.3691-1.35643-2.84405,3.89495-7.34196-2.27757-10.3462,2.78933-3.49352,3.83808,2.17437,7.42167,2.99352,10.3485,4.67277,3.76705,2.15916,5.99326,1.16127,10.8641-1.69545,4.41349,6.18471,7.14548,3.74513,10.6827-3.50124,2.73566-9.13569,5.89127-7.78267,11.1306-4.96442,1.74934-4.29305,7.44363-2.75561,11.3861,2.50006,5.62804,13.0832,4.98976,12.577-1.90098,2.80156-0.3991,6.09545,5.68243,8.1378,8.63606-1.9793,2.07989-8.40314-0.42696-11.9477,1.37249-4.64835-0.47891-8.63578,4.57286-13.2739,5.25391-3.36265,1.9929-7.8415,4.58416-6.7234,9.42037,0.8343,4.06606,2.37229,8.11037,1.7734,12.29-2.22903,3.69492-4.13929,7.61192-3.95762,12.0699-1.96561,6.51342,2.42679,14.3677-3.14518,19.6989-1.57378,4.81798,2.70258,4.79602,4.60869,1.72367,2.58216,1.13252,4.21461-3.2789,3.97188-5.18394,2.26039,4.12424,3.04019-1.12915,5.08565,2.74261,4.13911-1.37458-0.94111-13.3054,1.65159-8.31367,1.97682,2.89796,3.02284,9.05703,5.87021,9.48817,3.1671-1.25364,1.55632-12.9016,3.84451-3.84111,2.47079,8.07865,3.75238,16.6026,7.83058,24.029,2.3965,6.98672,8.71819,13.5099,16.7166,12.1469,2.26668,2.14863-3.51443,6.58908-4.62453,9.62413-3.57381,2.7051-7.98711-0.78552-11.767-0.93801-3.78981,1.47298-8.14276,2.27747-10.8382,5.53593-1.72713,3.79253-3.04612,7.09939-3.4332,10.8552-0.88863,5.31036,0.13036,11.4231,5.4288,14.0472,1.32615-4.06475,0.32208-7.52903,5.988-7.1808,3.96282,2.27349-0.43644,8.10318,3.08723,11.6783,1.78178,3.71091,6.91704,8.34229,5.22056,1.031-2.01613-5.74223,3.3569-5.79493,6.61661-8.16246,4.29542-4.53022,4.97256-0.12594,4.39461,4.3024,2.40725,3.14858,7.21565-2.9313,8.38176-5.643,1.66418-3.14588,0.0985-9.92787,3.0556-8.5594,3.80813-0.98073,6.27449-4.46801,9.26253-6.94112,2.69313-5.24053,7.73558-0.0687,11.7046,0.68887,4.94459,2.13323,11.5753,1.37682,13.8037,7.37185-3.80873-1.882-8.25871,1.64004-6.864,6.3864,1.9254,4.86856,7.80907,3.45041,11.3493,2.75596,3.56187,1.46818,7.57486-3.00643,11.4073,0.29753,3.75006-0.8166,7.88442-0.30457,11.4062-2.17749,3.4679-2.8491,2.0463-9.28119-3.0312-8.2992,2.32392-3.43251,7.59164-4.39502,11.094-6.786,4.02682-0.36578,7.52934-4.83217,11.0583-4.16909,5.02567,3.47708,7.52356,9.09418,11.8431,13.1088,4.23568,0.49022,0.3119,6.3769,0.76513,9.97366-1.13344,4.34512,1.29721,10.359,4.92686,4.42063,2.18556-3.95092,8.19703-2.82151,8.52258-8.00637,1.67796-4.37996,2.81142,6.40087,7.104,5.8248,0.28878,3.34521-0.97692,11.5345,4.0692,6.1476,4.42932-4.06469,5.16729-10.2904,3.5904-15.8052,0.71023-4.51311,7.2393,2.71525,6.05479,5.95468,1.00747,4.16725,6.17809-3.60099,6.90937-5.97298,0.56765-6.08552,0.74611-13.2759-3.86336-17.9397-3.49944-1.73665-4.94891-7.1766-9.95409-6.97476-3.44514,1.89486-7.37505,5.50514-8.84411-0.82243-4.5437-4.03599,3.08055-4.31882,5.6258-6.17201,5.12321-3.23731,7.92808-8.79362,8.96725-14.5657,1.86359-5.29724,3.46296-10.6852,4.68515-16.1675,4.00765-1.44117,7.76437-4.3775,9.99505-6.80623,4.55375-8.55582,0.19862,6.4166-1.41842,9.93834,3.47934,1.53958,8.02677-1.24501,9.51677-4.9319,2.2413-2.48392,2.7348-12.2521,3.9023-4.42962,0.5192,2.70794-4.3038,10.7481-0.3951,9.32604,4.04-1.29321,7.2811-5.17916,9.1374-8.91988,1.6184-5.0203,3.2276-11.1261,1.1868-15.964,3.2478-2.22444-0.2354-11.5228-3.7512-6.4668-4.5133-0.851-3.2152-7.41982-4.0384-10.661,3.6967-5.2321,0.613-15.3666-6.5792-15.1198-3.63519-2.08391-6.535-3.01516-10.2622-4.42079-4.84246,1.51061-8.30162-3.06667-13.1193-2.27392-7.27824,0.36128,0.6124-7.96674,3.43543-5.09674,3.30081,4.25235,10.2938,6.27454,13.6909,1.07153-0.16107-3.9225-0.15243-9.32357-3.65476-12.394-0.69406-4.38556-1.86451-8.53282-4.88218-11.951-3.70561-5.44536,3.10924-6.71299,5.35331-10.1034,0.99678-4.38737-1.66522-9.19954-4.29157-12.7821,2.82357-2.82577,5.6705-8.06344,2.6352-11.652,1.12886-3.42185-6.57321-4.017-9.06677-3.68003-4.99081-0.33128-9.18147,4.22055-14.1507,4.56182-4.25118,3.46864-9.40421,5.39471-14.8732,4.01385-3.86818-0.96115-6.90044-5.20991-8.97502-7.73471-5.04291,2.76035-0.91474-5.44702-5.01013-7.84979-2.83276-3.88498-8.69936-3.05119-6.57192,2.6488-3.70572,4.52734-0.47388-6.08652-2.79033-8.26063-3.01597-7.27229-1.7811-2.05451,2.29253-0.0649,4.52782,3.1003,11.1217,1.2253,12.2539-4.33848-2.22247-3.30433,0.26012-9.82401-4.75208-9.3564-3.6689,0.56032-3.85351,9.49795-5.90822,2.19016-0.55728-4.03175-2.83103-7.38551-4.8648-10.8465,2.73143,4.79514,8.02254,9.97456,13.8913,7.01852,3.14999-2.05918,4.26721-7.17898,2.3745-10.2464,0.17684-10.6094-5.94865,5.63578-8.76097-2.75775-6.501-1.92597,12.4594-8.92611,4.68272-11.2458-2.64508,3.68241-8.39049,1.94873-8.9959-1.91707,3.27961-1.83593,6.40279-8.91899,4.23398-11.2631-4.73233-2.68508-6.56446-6.73855-5.5068-12.1777-2.7735-2.96986-9.86367,2.25059-10.2761-4.42963-0.23117-6.20499-5.88188,0.81895-8.98114-1.4233-2.33726-1.38202-4.71261-2.75526-6.92316-4.47896z'/%3E %3Cg fill='%23d40000'%3E %3Cpath d='m904.106,194.538c-0.3108,6.8796-6.2196,5.4348-7.908,3.5532-1.6236-6.2904,7.8012-8.0148,7.908-3.5532z'/%3E %3Cpath d='m907.309,194.143c0.6156,5.4336,6.8472,6.1884,8.0268,3.912,2.0592-5.1888-5.6772-8.4852-8.0268-3.912z'/%3E %3Cpath stroke-linejoin='round' d='m903.481,188.9v1.1904l-0.6552,0.12-0.2376-0.2976-0.1776-1.8468-0.3576-0.1776v-0.834l0.8328-0.0588v-0.7752h-1.0116l-0.3588,0.7752-0.18,1.0716,0.42,0.894-0.42,0.7152-0.7728,0.4164-1.0728,1.014-0.7164,0.3564-1.668,0.1788-1.3692-0.6564-1.3728-1.3104s-0.5952-0.9528-0.6552-1.1916c-0.0588-0.2376-0.4176-1.0716-0.4176-1.0716l-0.3588-0.894-0.6552-0.7152-1.0128-0.12-0.2976,1.2516-0.3564,0.4764-0.8352,0.1188-0.8916-0.774-0.5964-1.0128-0.6564-1.3116-0.5364-0.894-0.774-1.1304-0.3588-0.6552-0.3564-1.5504-0.8952-1.1316-0.5952-0.9528-0.9516-0.774-1.014-0.7752h-1.1916l-0.7752-0.5952-1.1292-1.0728-0.8352-1.1316-0.534-0.6552,0.1188-0.5964,0.4164-0.5376,0.894-0.5352,0.8928-0.06,1.014-0.2376,1.0128-0.5364,0.1788-0.7152,0.1788-1.1916,1.0716-1.9068,0.4764-1.3704,0.06-1.0716,1.5492-0.2388,1.4904,0.1788,1.0716,0.2988,1.1316,0.3564,1.3104-0.6552,1.0728-1.3716,0.3564-2.382,0.4764-2.2044,0.5376-1.2504h2.742l0.9504,0.6552,0.7752-0.3564,0.714-0.3576,1.7292,0.1776h0.8928s0.7152-1.1316,1.014-1.3104c0.2964-0.1788,1.7268-2.0856,1.7268-2.0856l1.8468-0.4764,0.9528,0.12,1.3116,1.4904,1.0716,0.6552,0.954,0.06,2.2644,1.4892s0.7152,0.5952,0.954,0.4752c0.2376-0.1188,2.2656-1.0128,2.2656-1.0128l1.7844-0.1188,1.908-0.6552,0.6552,1.488s0.954,2.2644,1.2516,2.5032c0.2988,0.2376,1.4892,2.5008,1.4892,2.5008s0.5964-0.2976,0.8952-0.3576c0.2964-0.0588,1.6668,0.2988,1.6668,0.2988l3.9324,0.1788,0.5364-0.5964,0.4152,0.7152-0.534,2.7408,0.2376,2.0856,0.7152,2.8008,0.8928,1.3104,1.1928,0.0588,1.5492,1.3116,0.06,1.3104-1.1916,0.4176-1.0728-0.3576-1.3728,0.774-2.1432,1.2504-1.7892,1.788-1.5468,2.2032-1.014,2.2044-1.0116,0.7152-0.8952-0.3576-0.894,0.0588-0.4164,1.0728-0.894,1.0716-0.7752,2.7408-1.668,1.8468-1.728,0.834-1.2504,0.954h-0.8328l-1.4304-1.3716-0.6552-0.5952-0.1776-2.1444-1.3728-1.074h-1.014l1.4904,1.1928,0.06,1.608-0.8328,0.714-0.4188-0.1188-0.4152-0.834h-0.4788l-0.06,1.608-1.7868,2.0856-1.7868-1.4892-0.06-1.9068-0.8916-0.1752z'/%3E %3Cpath d='m874.307,173.86,2.6616,0.0852,1.3752,2.0628,1.2024,1.2876,1.2012,0.9456,1.032,0.1704,1.9752,2.9208v0.3444l1.5444,1.374,0.4308,1.8024,0.1716,0.6012-0.0864,0.7728-0.8592,0.516-1.0308-0.1728-0.6012-0.4296-1.8876,1.632-1.2036,1.632-0.7728,0.1728-2.0628,2.232-1.0296,0.3444-1.632,1.2024-2.5764-0.0864-1.6308-1.9752-0.342-0.774-0.0864-1.5456,1.4604-1.0308,0.6864,0.7728-0.342,0.7728,0.084,0.9456,0.8604,0.3432,0.858-0.0864,3.0924-2.6628,0.7728-0.4296,1.8036-1.8024,1.1172-0.6012-0.0852-1.116-1.2888-1.9752-0.4284-1.374-0.3432-1.2888-0.342-0.9456-1.2036-1.3728-0.6876-0.774-0.258-0.7728-1.2012-0.9456-0.3432-0.1728v-0.5988h-0.005z'/%3E %3Cpath fill='%23a00' d='m926.009,183.908h1.3752l1.4604-0.6876,1.1172-0.9444h1.0296l0.6876,0.6864,1.1172-0.0852,0.6864-0.8592,0.258-1.0308,0.9444-1.2876,0.258-1.2888,0.8592-1.8036,0.258-1.2888-2.1468-0.0852-2.4912,2.148-1.89,0.0852-1.5456,1.632-1.2012,0.1704-1.2888,1.89-0.4284,1.1172,0.1716,1.1172,0.7692,0.5148z'/%3E %3Cpath stroke-linejoin='round' d='m899.472,201.173-1.6332,1.632-0.4284,1.4592,0.6864,1.4592,1.5468,0.258,1.1172-0.6,1.0296,1.2012,0.1716,2.0616,2.0616,2.232,0.9444,0.258,0.774-0.8592,0.858-0.8592,0.0864-0.858,1.3752-0.6012,0.3432-2.5764,0.774,0.9432,1.2864-0.7728,1.6332-0.1704v-2.148l-0.6012-1.4592-1.29-0.9456-1.974-0.8592-2.1468-0.7728-1.0308,0.0864-1.8924,1.1184-2.0604,0.6852-1.6308,0.0876z'/%3E %3Cpath stroke-linejoin='round' d='m912.4,200.641,3.1008-0.1416c2.1276-1.38,3.048-6.9996,4.512-10.7136,2.2716-2.9448,5.0604-3.8256,8.46-2.256l1.974,0.564,2.5368,1.9728h1.8312l1.2708,0.282,1.974,0.1416,3.5256-2.82-0.1404,2.9604-2.3976,2.1144-4.9344,1.8336-3.8076-2.2548-0.1404,0.564,8.178,9.0216h0.7044l1.41,1.41,0.7044-0.564,0.1416-2.3964,2.8212-2.5368,0.2808,3.6648,0.9864,1.8324v3.5244l-2.6784,3.384-4.2288,0.564-4.9344-3.1008-0.1404-1.41-4.5132-5.2164v2.256l2.6796,5.4984,0.4224,2.1144,0.9876,0.9876,0.7056,1.6932v2.1144l1.2672,2.9604,2.256,0.2808,0.5664-1.4088v-1.974l2.3964-2.3976,1.5516-0.1404,0.564,0.846-0.7056,0.7044-0.282,1.5516v0.9864l1.974,2.6784,0.5652,1.692-2.9616,4.5108-1.9752,0.5652-3.5232-0.5652-2.1156-1.4088h-1.128l-3.2436-4.9356-0.4212-2.3964-4.3716-6.9084-0.1428,1.41,1.6944,2.1156,0.8448,3.2424,0.8448,5.7804,2.538,4.9344,0.1404,9.1644,0.8472,0.9864h1.1256l1.4112-1.1268,1.1268-1.5504-0.282-5.358h1.5516l2.6784,1.5516,1.974,3.2424,0.7044,1.41v2.9604l-0.9852,0.1404-1.9752,2.1156-3.2436,1.4088h-5.6376l-1.2684-1.1268h-1.128l-0.8448-0.846h-1.5516l-4.3728-6.2028-0.1392-10.2924,0.564-2.2548v-3.102h-0.7044v3.102l-0.7068,1.9752-0.1404,2.8188,0.1404,7.7544,4.6524,7.4724,3.384,1.692,0.9876,1.128h-1.551l0.1416,1.128-1.2708-0.282-0.2808,0.564-0.7044-0.282-1.2708-0.8472-1.692,0.2832-1.1256,0.564h-2.9604l-1.2708-2.538-0.9852-1.974-3.384-3.102h-2.538l-0.564-1.8324,0.4236-3.2424,0.7068-2.9604v-7.896l-0.5664,9.024-1.5492,5.0748-0.5652,0.4236-0.1416,5.7792,0.9876,2.6796,3.9468,4.3704-2.6784,0.282-1.974-0.8448-2.1156,0.4212-3.2412-0.7044-3.6672-1.2684-2.3964-2.3964-1.128-2.6796-0.4236-2.6772-0.564-2.82,0.564-2.2548,0.282-2.256-1.1268,2.5368v6.0624l-1.5516-0.4224v-1.692l-1.2684-1.692-0.2808-2.256-0.4236-3.3828-0.1428-5.4984,0.1428-3.384,0.7044-3.8064-0.564-0.1416-0.4248,4.7952-0.2808,9.4452-0.9864,0.2832-2.2548,3.1008h-5.078l-1.974-1.6908,3.8076-4.0896-0.4224-3.2424-0.4248-3.8052-0.4224-6.486-4.3716,4.6524-4.9332,3.5256h-4.23l-2.3964-2.9616-0.4248-3.3828,0.2832-2.3976,2.5368-3.384,1.8312-0.2808,0.7068-0.7056,0.4224,0.564-0.9852,2.82-0.9876,2.1144,0.8448,1.974,2.3988,0.282,3.1008-4.7928,2.3964-5.64,1.8324-2.82v-1.5504l-1.6896,1.2684-1.9752,0.4236-5.7792,0.1416-3.3828-2.1156-0.5652-1.692,0.1404-1.5504,0.1428-2.1144,3.6648-2.3976,0.1404,5.0748,2.3988-1.974v-0.982l3.1008-4.0896,7.4724-6.6252h4.512l2.6772,1.974,1.1268,0.282,3.2436,3.102,0.1404,3.9468,3.8076,3.102-2.256,2.6784,0.138,1.4112,2.118,1.5504,1.9728-0.564,0.846,5.2164,2.3964,1.41,1.2684,0.1404,4.7952-5.64,2.1156-0.2808,1.2684-2.82-0.5664-2.256-0.5616-1.2768z'/%3E %3Cpath d='m858.209,249.643v0.8268l1.6572,2.2476-0.1188,2.3664-8.4,4.2588-3.6648,0.2376-1.8948,1.7736-4.8504,1.5384-2.1276-0.474,0.354-1.182,0.2364-2.0112-0.2364-1.1832-1.5372-0.828v-1.8948l1.8924-0.5904-0.5928-0.8268-1.0644-0.12,0.2376-2.4828,0.4728-0.9456,0.1188-0.5928-0.1188-1.1832-0.4728-1.0644-1.302-0.3564-3.7848,1.5396-0.5916-0.5928-1.7748,1.8924-0.9468,0.1188-0.1176-1.5384-1.8924-2.4852v-0.474l-3.5484-0.5904-2.4852,3.1944h-1.7748l-1.2996-0.9456h-1.0668l-1.1808,0.708-0.7116-0.2352-1.0644,1.8936h-0.5904l-0.7116-1.5396-0.9456-1.5372-0.354-0.948,0.474-1.8912,1.5372-0.9468,1.89-0.948,1.4232-0.2352,1.6548,0.9468,0.7104,1.536,2.13-2.01,2.1276-2.3664,1.7736-0.7092,2.2488,0.354,2.4852,3.3132,2.364,0.2352,2.8404-2.0112,1.0644-0.5916,2.604,0.3552,2.6028,1.4196,2.7204,4.0212,0.474,3.9036,0.5904,1.0656,4.7316-0.3564,4.968-0.9456,2.838-0.1128z'/%3E %3Cpath stroke='none' d='m861.049,244.319-1.302,5.7972,1.5372,1.656-0.1188,1.8924,0.8268,0.828,1.5384-0.828,1.5372-1.0644,1.5372-0.5928,1.7748-0.9456,0.2352-1.0656,1.8924-0.9456,2.0124-0.5928,2.6016-0.7092,2.604-0.3552-1.8924-1.302-5.442-3.5472-2.2488-0.2376-0.828,0.7092-3.192,0.1188-1.7736,0.4728-1.2996,0.7116z'/%3E %3Cpath d='m887.192,238.523-3.7848-0.1188h-2.4864l-2.01-0.8268-1.656-1.656-0.2364-1.5384-1.182-1.8924-1.1832-1.1832h-1.7748l-2.4828,1.656-1.0656,2.1288-0.2352,3.4308,1.4184,2.9568,4.7316,3.5496,2.7216,0.5904,1.8948-0.8256,4.2564-1.8936,2.7216-1.7736,0.9492-1.5384-0.5964-1.0656z'/%3E %3Cpath d='m878.083,233.08,2.1276-2.2464,0.1188-5.088-0.5916-0.4728,0.5916-2.0112,0.2364-1.656h-0.828l-4.614,4.3764-3.1944,0.4728-1.6536,0.948-0.12,1.182,1.302,0.828,2.3664-0.2364,1.2996,0.1188,2.9592,3.7848z'/%3E %3Cpath d='m879.976,246.448,4.1388-0.3552,3.3132,0.2376,1.656,0.474,3.3132,1.7736,1.8936,0.948,3.6672-0.2376-1.4196-1.7736-1.4208-1.7748-0.948-1.7748-0.2352-1.7736-0.8256,0.2364-0.948-0.2364-1.182-1.5372-0.7092-2.2488-0.4752-2.9568-0.9444-0.12-0.7116,1.4196,0.7116,0.7092,0.708,1.4196-1.1832,1.5372-0.1176,1.1844-1.5372,1.1832-2.13,0.9468-2.0112,0.8268-2.2476,0.828-0.3552,1.0644,0,0z'/%3E %3Cpath d='m910.26,241.006,0.1188,5.0868,1.7748,1.5384h1.6548l1.302-0.7092,0.3552-1.0644-1.1832-0.7092-0.474-1.4196-2.484-2.7216h-1.065v-0.001z'/%3E %3Cpath d='m929.543,245.028,5.0856,3.4308,1.5384,0.474,1.4196-0.474,2.3652-1.8924,1.182-2.6028,0.12-1.8912-1.182-0.1188-1.8924,1.302-2.7216,0.2364-2.1288,0.354h-1.6572l-1.6572,0.3552-0.4716,0.8268z'/%3E %3Cpath d='m944.21,241.126-0.9444,1.5384-0.9468,2.3652-2.13,2.2488,0.1188,1.6548h-0.948l0.1212,1.302,1.6536,1.2996,4.6152,0.7092,3.6684-4.7304v-1.302l-2.0124-2.3664-1.4208-0.354-1.7748-2.3652z'/%3E %3Cpath d='m965.74,254.375,2.3676,1.1832v0.828l-0.9468,1.302-0.5904,2.4828-0.2376,1.5384-2.8392,0.1188-2.9568-1.0644-1.6572-1.0644h-1.5372l-0.828-0.7092-1.4184-0.9468-1.776-1.1844-1.8912-2.4828-1.3008-1.656v-1.1832l1.7748-2.2476,1.7748-0.5904h7.926l3.666-1.302,2.9568-2.484,3.5496-0.7092,0.828-0.9468,2.3664-0.474,5.9148-3.0756,3.312,0.5904,3.3132-0.1176,2.838,0.8268,1.0656,0.9468-0.5916,0.3552-1.5372-0.1188-1.7748,0.9468-0.2376,3.1944,1.4196,2.6016-0.354,0.7104-1.7748-0.1188-1.182-0.5928-0.5928-1.0644v-1.0644l-1.1808-1.656-0.9468-0.354h-2.1276l-0.7104,4.494h-1.0668l-2.0088-1.7736-2.9592-0.3564-2.0112,1.7748,0.7092,2.3664,2.9592,2.8392h1.5372l1.4196,1.6548-0.12,1.3008-2.1276-0.474-2.13-0.4716-1.7736-0.8304-1.4208,0.2376-1.656-0.948-1.656-0.708-1.0644-0.474-0.714,0.9504z'/%3E %3Cpath d='m973.724,307.228-1.8816,1.7052-1.2552,2.4192-0.4476,2.508-0.8064,3.1368-0.3588,2.4192,0.3588,5.2872,0.18,2.8668,1.7016,2.6904,0.8952,0.2676,1.0752,2.1492,1.5228-4.2108,0.7188,0.5376,0.4476,3.1356,2.5092,2.1504s-2.3304-1.164-2.868-1.164-0.6264,0.6252-0.6264,0.6252l0.6264,1.344,1.4328,1.434,2.5104,0.984,4.6596,0.09-1.0752,1.0752h-3.2256l-0.8088,0.6264,1.1664,1.7028,1.4328,2.2392,2.6004,1.2552,2.6856-0.7164h0.8964l-0.4476,1.0752,1.344,0.984,1.164,1.0752,1.0764,1.1652,0.8952,0.1788v1.344l-1.6128,4.0332-0.36,1.8804-0.894,1.524-0.5376,2.328-1.6128,2.778-0.1788,0.9864h0.8064l1.164-1.5252,1.704-0.7164,2.0616-2.688s1.164,0.36,1.434-0.18c0.2676-0.5376,1.5228-4.3008,1.5228-4.3008l1.254-0.2688,0.6276-3.942,1.0752,3.6744,0.8976,4.6596-0.36,3.9432-2.3304,4.2996-0.6252,0.72,0.3576,1.4316h1.7028l1.9716-2.0628,3.4044-4.5696,1.3464-4.5696,0.7164-8.8716,1.5228,4.1232,1.434,4.0308,0.7188,3.1356-1.0764,4.122-1.344,4.8408,1.7928-1.2564,3.7644-4.212,2.9556-4.3884,0.8076-3.2256,0.7176-6.1836-0.4488-4.8384,0.1776-1.7928,0.6276-0.9852-0.09-3.2256-0.6264-1.344-2.1492,2.8668-0.8964,0.18-2.5104-1.7028-0.6252-0.18-1.434-2.0616-0.984-3.3156,0.088-3.7632h-0.5364s0.2688-3.1368,0.5364-3.9432c0.27-0.8064,0.6276-2.328,0.6276-2.328l-0.4488-3.3168-1.7016-3.1368-2.0616-1.7904-3.3144-0.9852-3.8556-1.0764-2.2392-1.7904-4.212-0.4476-2.1504,0.2688-4.032-1.8816-2.5992-0.9864-3.3144-0.0876-3.1368-0.36-1.6164,0.0936z'/%3E %3Cpath d='m829.548,307.424-8.2644-0.1644-1.3224-0.6612-1.9824,1.6512h-3.8016l-4.1328,2.3148-2.8092,2.148-1.4868-0.1644-5.7864,5.2896,0.8268,4.296,0.66,1.158,0.3312,4.1328,0.1644,5.9484-1.3212,0.9936-1.9836,4.9596-1.158,4.296-0.9912,8.43,0.8268,6.2796-1.158,3.306-2.3136,3.6372-0.4956,1.818,1.9824-1.3236-0.3288-0.6612,0.9912,1.4868,2.4768-4.4628,0.9936,1.6536,0.99,0.1644v-5.6196l-1.1556-8.76,2.8092,9.0924,0.6624,3.3048,0.4956-0.1668,0.33-7.4376,1.8168,4.1328,0.1668,3.6348,0.8256,0.6624,0.498-0.9924v-5.454l-2.9772-8.76-1.4868-8.1012,3.9672,10.5792,2.3148,2.148,2.148,5.7864,1.8204,3.3048,0.3288,2.148,1.3224-0.8256,0.498-0.8256-1.158-0.8268,0.8256-0.66-0.1668-2.9748-0.99-6.9396h-0.9912l-3.4716-7.2732,3.1404,4.464h1.3224l0.1656-1.1592-1.4868-2.9748-0.33-3.4716,2.9748,4.2984,0.99-0.4956-1.6524-4.7952-0.3288-5.454,0.9912,2.3136-0.1656,2.6448,2.1492,2.646,2.148,1.1556,1.6524-1.9812-1.158-0.828-0.4944-2.3124-1.6548-1.9836v-2.646l2.3172,4.1328,2.1468,1.488,2.1492,0.4956,2.1492-1.4868,3.6348-4.1328-0.4932-0.4968-3.804,0.1668-2.9748-1.9836-2.6436-2.478v-2.1492l0.4956,0.3288,1.1556,2.316,2.1492,2.1492,2.4792,0.3288,3.1416,0.1668,3.4692-3.1404,1.8204-5.9508,0.4956-3.306-0.6612-4.1316-2.1504-4.794-1.3224-2.1492-1.1568-0.4968z'/%3E %3Cpath d='m951.204,398.996-8.7624,9.0876-1.1568-0.3288-3.1404,2.6448-0.1644,2.8104,2.9748,2.316,1.158,2.148,0.8268-0.1668,2.9736,3.636,2.8116,3.9684,1.158,0.6624,0.8244,1.8168-1.4856,2.148,0.4956,1.3248,2.3136-0.3324,2.646,0.1668,1.6512,0.9912,0.6624,2.976v1.1544l1.818-0.99,1.488-2.1492,0.1656-5.2884-0.3288-1.4868,0.4932-3.9684,0.4956,5.2884,1.158,1.6536,0.8256-0.6624,0.9912,3.4728,2.1492,2.1492,1.158,1.9812,0.1668-1.32-0.1668-2.6448,1.158-2.976,1.3224-3.4704,1.3224-0.828,1.1556,0.4992,1.656,1.65-0.1668,0.6624,1.488-0.1668-0.3324-3.966-2.1468-2.976-3.3072-2.1456-1.6524-1.6524-1.4868-2.6448,2.3136,1.3212,2.4792,2.3148,2.3136,1.158,1.6536,0.3288,2.8116,5.4552,1.818,2.6448,0.33-3.636,1.3224-4.134,1.3236-1.8168,1.6524-0.1668,2.1492,0.6624-0.4968-2.4804-1.6524-3.1404-3.306-2.9736-3.4716-2.6448-2.9736-1.3248-2.6472,2.316-0.8256,0.3288-1.488,1.3248-1.1556-0.4956-3.8028-3.6396-0.9912-0.6588-1.6524-3.9684-2.4804-1.158-3.8016,0.3324-4.632-0.9936z'/%3E %3Cpath d='m851.863,396.848,0,0,1.158,1.9812,0.9924,3.1404,1.6512,1.8204-0.1644,0.99,2.3136,1.9824,2.3136,3.636,3.8028,3.1392-2.8104,2.4816-6.612,4.9596-2.1492,0.6624-2.8092-1.6572,0.33,3.9684,1.1568,1.8204-2.9748-0.6624-3.4728,0.3288-2.148,1.8204-0.4968,1.8168-0.8256-1.3212-1.158-1.8204-0.33-0.3288-0.66,0.4956,0.4956,0.3288,0.1644,3.306-0.8256,0.6624-0.1668,0.9912-3.8004,2.478-0.9912-2.478-1.3248-2.8104-2.3136-1.158-2.478,0.3324-2.8104,1.6524,0.8256-2.3148,1.6536-2.6448,3.1392-2.6436,3.1404-1.9824,2.4792-0.9912,0.6624-0.3324-0.828-0.8256-4.626,1.3212-3.3072,2.1492-3.4716,2.4804-2.6436,3.7992-1.3224,0.9912v-2.808l-1.4892-3.8016-0.4956-2.4816-1.488-1.8168h-1.8168l-2.4792,0.4956,1.8192-3.1392,3.6348-1.9824,1.6536-2.8104,2.9748-2.4816,2.4792-0.4956,3.6372,0.4956,1.8156,0.9948,3.474,0.1632,2.1468-0.1632,2.646-1.3248,2.1492-3.9684,2.9736-4.2948,3.474-1.8192,4.1328-0.3264z'/%3E %3C/g%3E %3Cpath fill='%23000' d='m892.877,173.292v2.0844l-0.7752,1.2504h-1.3704l-0.8328,0.894-0.2388,0.7152,1.5492,1.4292,1.4292,1.0128,0.5952,0.7164,0.3588,0.1776,5.958-0.06,0.714,0.7152,1.3116-0.9528,1.6104-2.4432,5.064,0.06,2.6796,1.9656,0.1788,1.6092,0.5964,0.2388,1.428-1.2504,1.1916-0.0588,0.5952,0.774h1.074l3.5148-3.1584,0.5964-0.834,1.3104-0.06-0.1776-1.0128-1.4292-0.3576-1.2504-1.2504-0.3588-2.0856-1.1316-0.1776-1.9656,1.0128-3.396,1.668-1.1328,0.834-1.0128,0.0588s-0.4164-0.3564-0.6552-0.3564h-1.3104l-1.074,0.894h-0.834l-0.2976-0.2988-4.5876-0.3576-3.8124-0.9528-1.968-1.3104-1.2504-1.0128-0.3588-0.3564-0.5352,0.2364z'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m895.739,178.772h2.6208l0.6552,0.5364v0.714l-1.2504,0.5364-2.2056,0.1188-1.5492-0.2376-1.074-0.954-0.2364-1.9056,1.428-1.6092h1.3716l0.12,0.5364,0.12,2.2644z'/%3E %3Cpath d='m913.254,178.654-0.4164,0.3564v0.7152l0.534,0.3576,2.6232,0.12,2.8596-2.2632,0.06-0.8952-1.7256-1.4892h-1.4904l-0.2388,0.4164,0.3588,0.7752,0.4752,0.7152-0.4752,0.9528-2.5644,0.2388z'/%3E %3C/g%3E %3Cg fill='%2348489c'%3E %3Cpath fill='%235656a6' d='m819.408,249.526,1.5384,2.7192-0.1176,4.8504-0.5928,0.5928-2.2464-1.8936-1.1844-1.6548-1.1832-2.0112v-1.7736l1.1832-0.9468,1.5372-0.354,1.0656,0.4716z'/%3E %3Cpath fill='%235656a6' d='m824.141,257.33,3.4296-7.0968v-1.8924l-1.302-1.8948h-1.7748l-1.8912,1.7748v6.27l1.5384,2.8392z'/%3E %3Cpath fill='%235656a6' d='m830.054,257.33,1.8936-0.8268,4.614-4.3776,0.7092-1.3008-0.3564-1.0644-1.2996-0.9468-0.8268-0.2364-1.8936,0.828-1.0644,1.0644-2.13,3.7848,0.354,3.0756,0,0z'/%3E %3Cpath fill='%235656a6' d='m838.219,260.406-1.6572,1.1844-1.8936-0.1188-3.4284-2.3664,0.1176-0.474,2.1288-0.3552,1.8924-0.828,1.8924,0.1176,1.0668,0.9468,0.3528,1.0656-0.4716,0.828,0,0z'/%3E %3Cpath d='m970,256.975h2.7216l1.5372,0.828h3.0756v1.1844l-1.7748,1.2996-3.4308,0.9468-1.5384,0.7092-1.182-0.1188-0.828-1.0644v-1.656l0.7092-1.4196,0.7104-0.7092z'/%3E %3Cpath d='m988.808,253.31,0,0s1.8936-1.0668,2.2464-1.8924c0.3564-0.828,1.1832-2.604,1.1832-2.604l0.7116-3.0756-0.9456-2.6016-1.7748-0.4728-1.5372,0.1176-0.828,0.8268-0.2352,2.2488,0.8268,1.8924,0.7104,1.0644-0.1188,2.0112-0.2388,2.4852z'/%3E %3Cpath d='m981.71,254.255,0,0,1.8936-0.9456,1.1808-2.2476,0.1212-2.4852-0.9468-1.8936-1.302-1.4172h-1.7748l-0.474,3.3108,1.3008,1.302v4.3764h0.001z'/%3E %3Cpath d='m979.463,256.385,0.7092-0.828,0.3576-1.7748-0.7104-2.6016-1.0668-1.1832-1.2996-1.1832-1.4208-0.9456h-2.0124l-1.2996,1.0644,0.3528,2.13,2.3688,1.7736,1.8924,0.3552,2.1288,3.1932z'/%3E %3Cpath d='m988.106,250.757v2.1336l-2.1324,0.306-0.1524-2.8956,2.2848,0.456z'/%3E %3Cpath fill='%234f4d9f' d='m971.699,428.416-1.818,2.4804v4.1316l0.8256,1.9848-0.8256,7.7676,4.1328-5.784,1.4856-2.9772-0.1644-3.9648-1.158-1.8204-1.3224-1.1568-1.1556-0.6612z'/%3E %3Cpath fill='%234f4d9f' d='m985.418,419.824-1.3224,0.3288-1.488,3.1392-0.3288,4.1316,0.8256,2.148v2.9772l0.3312,1.8168,1.4856-2.1456,2.1492-3.6384,0.3288-2.6448v-3.6348l-0.9912-1.6536-0.99-0.8244z'/%3E %3Cpath fill='%234f4d9f' d='m949.384,441.308,2.1492-1.4868,1.6536-1.158,2.1504-2.808-0.3324-2.148-1.3236-0.9912-1.6524-0.6624-1.4868,0.1668-1.6536,2.3124,0.1668,4.6296,0.3288,2.1456,0,0z'/%3E %3Cpath fill='%234748a5' d='m848.724,426.766,1.6524,0.6588v4.464l-2.8092,3.1404-3.1392,2.3148,0.1632-2.976-0.8256-0.9876v-3.144l0.6624-0.8256v-1.4856l2.8092-1.4904,1.4868,0.3312z'/%3E %3Cpath fill='%234748a5' d='m827.234,429.409,2.3136-0.1656,2.4792,1.4856,0.9912,2.8116-1.4868,1.3236-0.8256,1.3212-0.4956,2.1492,0.33,3.4728,0.1656,3.1404-2.8092-3.474-2.3136-3.6348-0.1668-3.6348,0.8256-3.1404,0.9924-1.6548z'/%3E %3Cpath fill='%234748a5' d='m819.3,425.278-0.6612,2.3124-0.8256,0.4956-0.9912,1.3236v4.9572l-1.6536-0.9876-1.818-2.316-0.9912-2.4804,0.3312-6.2796,0.8256-2.6448,1.9836-0.6624,1.9836,0.6624,1.6512,3.8016,0.1656,1.818z'/%3E %3Cpath fill='%234748a5' d='m819.468,409.246-0.9924,2.4768-2.6448,1.9824c-0.4044-2.64,0.9552-4.026,3.6372-4.4592z'/%3E %3C/g%3E %3C/g%3E %3Cg stroke='%23000' stroke-width='0.45648'%3E %3Cg%3E %3Cpath fill='%23dfda4d' d='m825.559,261.236,3.1932,2.9568,2.3676,1.5372,1.8924,0.7092,2.3664,1.302h4.9692l4.494-0.474,2.2476-0.828,4.3764-0.1188,3.5496-1.656,2.6016-1.7736,2.6016-0.1176,1.4232-1.4208h1.8912l3.7836-2.8392,5.3256-2.364,5.5596-2.0112,6.0348-1.1832,2.4828,0.1176,0.9456,0.7092,1.1844,2.0112,0.4716,0.9468-0.5904,2.0112-2.2464,1.302-0.474-1.4208,1.4184-1.1832-0.354-0.7092-2.2488-0.3552h-1.5384l-1.4172,1.4196-0.2376,3.1944,1.8924,1.6548,2.0112,1.302,1.7748,0.1188,2.13-1.2996,2.8392-2.4852,1.6548-2.8392-0.474-4.14-0.9456-2.604-2.8392-2.1288-3.5484-1.4208-6.1512,0.12-3.6672,0.9456-1.4208,0.474-3.9024,2.6016-1.7748,0.1188-3.9036,2.6016-1.5396,0.5904-1.7748,0.7092-2.7204,1.1844-5.2068,2.364-3.5472,2.13-1.7748,0.2376-4.1388,2.6016-5.916,0.474-1.0644-0.5928-2.7216-0.354-1.7748-0.7116-1.7736-0.9456-2.4828-2.9568-0.7116-0.474h-2.2476l-0.7092,0.948,0.3552,2.0136z'/%3E %3Cpath fill='%23d9d24d' d='m894.408,251.299,0.7104,5.9148-1.3008,3.666,2.7216,0.1188h3.192l2.8392-0.5928,2.7216-0.2364,2.4852,0.1188,2.0112,0.2364,2.4828-0.9456,0.1188-1.8924-0.5916-1.656,1.182-3.6684-0.474-0.828-18.0984-0.2352z'/%3E %3Cpath fill='%23d9d34a' d='m922.444,257.804-0.7092,0.474-1.0644-0.474-0.5928-1.6548,1.1832-1.0656,2.6016,0.1188,2.3664,2.1288v3.0756l-3.1944,1.5396-3.3108,0.828-3.6684-1.0656-2.2476-3.0756-0.5916-2.1288,0.474-3.6684,0.5916-2.3664,3.1944-2.3664,3.4296-1.0644,4.0212-0.5928,4.6164,1.1832,9.3432,3.5496,6.27,2.8392,6.9792,3.6684,4.1412,1.8924,5.442,2.6016,3.3132,1.1832,3.7848-0.474,1.656,0.1188,3.312-1.0644,2.2476-0.2376,4.968-5.7972,2.0112-1.1832-0.2352,2.6016-3.3132,3.6684-2.838,3.1944-1.182,0.1188-1.5384,1.2996-2.9568-0.1188-6.8616,0.3564-3.312-1.0644-5.2056-1.0656-6.1512-2.7204-4.8516-2.4852-2.3664-0.3528-3.6684-1.8936-2.2464-0.2364-1.3008-0.9468-4.0236-1.182-3.3132-1.1844-3.192-0.3552-2.4852-0.354-1.182,0.7092-1.1832,1.656-0.5904,2.2476,0.828,2.7216,1.4196,0.2376,1.302-0.5904,0.4716-0.9468-0.5916-0.2364z'/%3E %3Cpath fill='%23ddd457' d='m852.564,388.192-1.5108,1.5072-2.3736-1.5072,1.0776-2.8044,3.8832-0.648,2.1576,3.2352-0.864,3.234-3.0204,3.018-3.6672,1.08-3.666,0.4296-4.3128-0.2136-5.8248-1.2972-4.5276-5.3904-3.4512-6.9012-2.586-5.8224-3.0204-11.862-1.5108-4.9608-0.6468-4.5288-3.234-6.2544,1.2924-1.0776,11.2152-9.9204h0.648l2.3736-2.1576,4.0956-7.764,0.432-0.4308,1.2936-4.7436-0.216-8.1948-1.0776-3.882-2.5872-4.314s-0.8628-1.5096,0-1.2936c0.8616,0.216-2.3724-3.6672-2.3724-3.6672l-3.884-4.1v-0.86l-2.802-2.8044-1.9416-1.0776h-1.5096l-0.648-0.864-2.8044-0.8616-1.2924,1.2936-0.8628,2.8044v1.0788l1.9392,0.8616,0.6468-0.4308-0.6468-1.08,0.216-1.2936,1.512-1.0776,1.7244,1.2912-0.216,3.2352-1.2936,1.5108-3.234,0.2172-2.5884-1.2948-1.0776-2.1576-0.8616-3.2328,0.8616-1.9416,1.2948-1.0776,2.1564,0.4308,3.45-0.864,1.0776-0.4308,2.8044,0.4308,1.9416,1.9416,2.1552,1.2936,5.3928,6.0396,1.5084,1.5084,2.8044,4.0992,3.4512,7.764,0.8616,5.3904-0.4296,5.3928-2.8044,7.764-3.2352,4.9596-4.5276,5.6076-7.764,6.4716-1.0776,0.2148-1.7256,2.1576,3.0204,6.4692,4.7436,19.842,3.882,8.1948,5.6076,5.8224,4.3128,2.3736,5.6088,0.648,4.9596-1.296,2.1576-1.938-0.864-1.2948z'/%3E %3Cpath fill='%23dbd45d' d='m861.622,392.72-0.6468,1.0764,0.8628,1.7268,2.1576,0.4308,1.5084-1.9416v-2.1588l-1.2948-2.37-1.7244-0.4344-1.9404,0.2172-2.8044,1.9416-1.5108,1.7256-0.8628,4.0968,2.1576,6.6876,3.4512,4.5276,8.6256,5.6076,9.2748,3.45,5.8212,0.8616,4.3152,4.3152,2.1564,5.1744-1.9404,3.2376-2.5884,0.2148v-1.2936l1.0776-0.2172,1.2948-1.2936-0.6468-1.2936-2.5872-1.5108-2.1564,1.7256-0.2172,3.8832,1.9392,1.9416,2.8044,0.6444,2.1576-0.8628,2.1552-2.3736,0.2184-2.8032-0.8628-4.098-3.6684-5.1732-3.8796-1.9416-9.7056-3.4524-6.2544-2.37-4.53-3.2388-4.0968-4.3116-2.3724-6.252,1.0776-4.098,2.3736-1.7268,1.2936,0.4308-0.432,1.2984z'/%3E %3Cpath fill='%23e5dc5e' d='m939.906,392.934,1.7256,1.0788,0.2172,1.7244-1.9416,0.8628-2.5872-0.4308v-2.586l1.5084-3.2352,4.3152-0.2172,1.9404,2.3736,1.2948,4.5276-1.2948,4.746-4.9608,4.0968-6.9012,4.746-7.548,3.234-11.214,5.3904-3.2352,2.37-2.8044,5.1768,1.7268,3.0216,2.1564,0.4308v-1.0788l-0.648-0.8628,0.4308-2.3736,1.2948-1.2924,2.586,1.5108,0.6492,3.234-2.3736,2.3736-2.5884,0.4308-4.0968-1.9416-1.2948-2.1552-0.2148-3.0228,1.7256-2.8032,3.45-3.4488,5.3928-3.0228,7.764-3.234,11.4288-5.6052,7.9788-8.628v-3.4488l-1.7256-2.1564-2.1564,0.2148z'/%3E %3Cpath fill='%23d7d643' d='m949.826,386.681v1.938h1.5096l1.5108-0.2148,0.6468-2.586-1.2936-1.7244-1.7256-0.2184-2.1576,0.4308-2.3712,1.7256-0.216,3.4524,1.0764,2.37,2.1576,3.234,3.882,1.9416,3.8808,1.0788,5.8248-0.4308,6.6852-3.234,6.2544-4.5288,2.5872-6.2556,3.234-11.43,4.0968-14.448,2.5884-5.3904,2.1564-1.9428-0.6468-0.8616h-1.9404l-4.9608-3.666-5.1744-3.2352-6.6864-7.9788-3.45-6.6864-1.0788-9.4884,1.9416-9.2748,4.0968-6.9012,6.6852-5.6076,6.0396-4.3128,6.0384-0.2136,0.8604,2.3712-0.8604,1.9416-1.2948-1.0788-1.9404-0.216-0.8616,3.2352,2.154,1.0776,3.882-0.4308,1.08-2.5872-0.4308-3.666-2.8044-2.5884-4.962,0.4308-3.666,0.4308-4.53,2.5884-4.7424,4.9596-3.234,4.7448-4.0992,6.6852-1.2936,6.0384,0.216,10.5684,5.3928,11.4288,4.7436,6.0396,9.2724,6.2532,1.5108,1.0788-2.8032,6.2544-4.098,13.1556-2.5872,10.5672-2.1564,4.5288-6.9012,6.0384-7.7652,3.018-6.684-0.2136-3.2352-2.3736-0.864-2.1564-0.216-3.234,1.7268-0.4308z'/%3E %3C/g%3E %3Cg fill='%235db7d2'%3E %3Cpath fill='%2344b3cc' d='m890.873,284.615-0.33,3.3048,0.9912,7.2732,3.636,19.9992h1.8192l0.1644-3.1392-6.2808-27.438z'/%3E %3Cpath fill='%2350aece' d='m900.127,313.706-6.6108-28.926,4.9572,29.4216,1.6536-0.4956z'/%3E %3Cpath fill='%2350afce' d='m901.285,313.375,2.3136-0.8256-8.5956-27.7692,6.282,28.5948,0,0z'/%3E %3Cpath fill='%2350abce' d='m897.484,283.127,10.0824,28.926-1.9836,0.66-8.0988-29.586z'/%3E %3Cpath fill='%2350b0ce' d='m909.054,311.39-9.7524-29.2548,12.3972,28.926-2.6448,0.3288,0,0z'/%3E %3Cpath fill='%2350b3ce' d='m912.69,309.904-11.5704-27.9348,14.3796,28.266-2.8092-0.3312,0,0z'/%3E %3Cpath fill='%2364b4d1' d='m822.091,258.767-1.56,0.2388-1.9176,1.56-0.84,2.0388,0.1212,3.7176,1.3188,2.2776,2.2788,2.4,1.0788,1.7988-0.6,3.2364-3.2364,2.0388-3.4776,2.5188-1.32,2.0388-0.48,2.2776,0.1212,2.3988,0.4788,0.5988,2.6388-0.1212,1.5588-0.4776,2.3976-0.24,2.2776,0.36,3.4776,2.3988,4.9176,4.4376,2.1564,2.5188-1.5576-3.7188-0.8388-4.4376-0.6-4.4364,0.7212-2.6376,1.1988-1.68,1.3188,0.7212,1.0788-0.6,1.44,0.72,1.2-0.72,1.9176,0.6,2.3964-1.2,3.5988-2.7576h2.5176l0.7212,0.5988,1.4376-0.5988,0.84,1.2,2.9988-2.28,2.3976-1.1988,2.3976,0.9588,3.1188,0.72,1.2-1.0788,2.5176-0.1212,3.4764-0.4788,1.68,1.1988,1.6764,4.0764,1.2,1.3212,1.8,0.3576,0.9588,0.48,1.6776,4.1976,1.2,3.3576,0.6,4.0764-0.2412,1.0788,1.0788-0.1188,1.68,1.6764,1.4388,0.7212,1.1988,1.3188,0.3576,2.1576,0.9612-0.1188,0.84-1.0788,1.6788,0.36,1.4388,1.5576,1.4376,0.1212-2.52-16.6692-2.3976-1.3188-0.12-3.8364,5.6364-2.04,0.12-1.4376-0.8388-2.4-1.0788-2.1576-2.1588,0.2388,1.6776-5.3952,4.1976,4.3164-1.9188,0.2412,1.6764,6.594,7.1976-1.1988,1.3188,1.8-0.48,1.5576,0.6012,1.0788,0.3576,1.92,2.16,2.7564,5.6364,12.2304,5.3952,11.0328,2.3988-2.5176,2.5188-0.5988,2.7588-1.92,1.6776-0.6,1.1988-1.5576,3.1188-0.1212,4.6752,4.1976,0.7212-1.0788,4.4352-0.2412,1.4388,2.8776,0.2412,1.2,1.7988-0.72,4.9164,1.0776,2.9976,2.4,2.2764,0.9576,0.6012,1.2012,1.3188-1.56,0.96,0.1212,1.56,0.36,4.9152-0.36,2.52-5.0376s2.2764-4.6752,3.3588-5.8752c1.0776-1.1988,5.5152-5.9952,5.5152-5.9952l5.3952-3.5988,4.0764-2.2776,3.8376-0.48,3.5988-0.12-0.12-3.2376-1.4388-3.1176-3.5988-4.6752-0.72-3.7176v-2.28l3.1188-2.0388,3.7176-2.9976,0.1212-3.1188-1.0788-3.8376-2.16-3.2364-0.72-0.6-1.2-0.2388-1.6776,1.0776-3.3576,4.6764-3.7176,3.7188-4.5564,2.7588-5.2764,0.5988-8.3928-1.3188-5.8752-1.8-7.3164-2.7576-7.6752-3.5976-4.1964-0.8412-6.3564-3.1164-2.3976-0.1212-0.1212,1.08,1.9176,1.9176-0.4776,3.3588-1.6788,1.7976-3.1176,0.1212s0.36,0.2412-1.4388,0.72c-1.8,0.48-3.3576,0-3.3576,0l-2.9976-1.7988-2.8788-0.48h-5.7552l-6.3552,0.6012-7.1964,0.5988-3.5964,3.1188-3.1188,0.48-3.3576-0.84-3.4764-4.0764,0.12-2.2776,2.5176-3.1188-1.3188-0.12-7.9152,2.8788-4.9176,2.7564-2.6364,1.68-1.9188-0.1212-2.52,2.2788-3.1176,0.24-1.8,1.9176-0.5988-0.2388-5.0352,1.3188-4.5576,0.8388s-5.7564,0.84-6.3552,0.84c-0.6012,0-6.1152-0.72-6.1152-0.72l-4.0788-2.0388-1.9176-2.1576-1.8-1.2-2.3976-2.5164,0.1212-1.92-0.7188-0.4776z'/%3E %3Cpath d='m893.774,318.595-0.1704,3.7428,2.7228-0.678-0.3408-3.5736-2.2116,0.5088,0,0z'/%3E %3Cpath d='m897.348,317.575v3.0624h1.1916v-3.2328l-1.1916,0.1704z'/%3E %3Cpath d='m900.071,316.895v3.4032l1.7004-0.5112-0.1704-3.0624-1.53,0.1704z'/%3E %3Cpath d='m903.643,316.213,0.1716,2.5524h1.5288l0.1716-3.0624-1.872,0.51z'/%3E %3Cpath d='m907.046,315.533v2.724h2.3808l-0.3396-3.0648-2.0412,0.3408z'/%3E %3Cpath d='m910.788,314.683v2.5524l2.0424-0.5112-0.51-2.7228-1.5324,0.6816z'/%3E %3C/g%3E %3Cg fill='%23ccc'%3E %3Cpath fill='%23fffcfc' d='m973.633,345.67v2.6904l0.6276,0.3588,0.18,0.8952,2.7756,0.4488-0.27-0.8964-1.7928-1.7028-0.4476-1.2552-1.0728-0.5388z'/%3E %3Cpath d='m916.933,309.892-0.4596-0.9156,1.5264-1.6764,2.8932-0.6072,2.286-1.83,2.8956-1.8288,3.048-0.762,3.9636,3.3516-1.3716,1.0704-1.374-0.1536-2.5896,1.6752-1.98,1.2204-1.6764-0.3048-1.5252-0.4572-0.9132,0.762h-1.374l-1.068,0.6096-2.2812-0.1536z'/%3E %3Cpath d='m935.527,305.623,1.5228-0.6072h2.286l1.2204,3.3516v1.068l1.98-0.6096h3.6588l2.5896,1.2192,2.286,2.286,2.4384,1.3728h1.98v-1.068h1.9812l0.4584,0.6108,2.1324,0.3036,1.5252-0.456,0.4572,1.3716-0.3048,1.8276-0.4584,1.374,0.6096,5.7888,2.7444,9.9072,5.1816,8.3832-1.98-0.9156-4.4208-0.6096-1.3728,0.6096-1.8276-0.1524-2.1336,1.9812-1.068,0.1512-0.9132,0.7632-1.6764-2.286-6.4008-8.5344-1.6764-1.8288-3.6576-7.9236-5.0292-10.8228-0.306-4.4208-1.218-1.2192-0.6096-0.1524v-0.7632h0.001z'/%3E %3Cpath d='m933.697,364.607,2.592,1.2192-0.1524-1.2192,1.8288,1.2192s1.6752,0.306,2.5896,0.1524c0.9132-0.1524,2.8956-2.1324,2.8956-2.1324l0.6096-4.1148,3.9636-6.8592,2.8932-1.6764,0.918-0.1524,2.7408-3.0492,5.1816-2.742,2.4384-0.9156,3.9636,0.762,2.8956,1.3728,0.6096,2.4384,0.4584,6.5532,1.8276,1.374,1.5252-0.7644,1.3716-1.6752,3.3516-1.2216,2.4396,0.3036-0.1536,3.0504-1.0656,5.6388-1.6764,5.9436-2.7432,9.4476-2.5896,6.708-6.402,4.878-5.0292,3.198h-8.0784l-2.4372-2.2848,3.048-0.7644,1.0668-1.8252,0.3048-3.2016-2.742-1.9812-2.7432,0.1524-3.6576,2.1348-1.374,1.8252-0.762,2.136h-1.3704l-3.0504-0.1536-2.286,1.5252-1.6752,2.1312-0.4584,3.2016,0.7644,2.2872,1.6752,1.0668,3.048-0.1536,0.7632-0.6072h0.6096l-2.7444,3.0444-3.504,3.66-4.5732,3.048-3.048,0.9132-5.0292,1.83-3.6576,1.6764-4.116,0.1524-4.2672,3.8088-2.8956,2.2884-1.9812,2.742-0.9144,4.7256v3.5028l2.2836,3.048-0.3036,0.9168-1.3716-0.156-0.7632-0.6072h-3.3516l-0.9156-1.3728-1.6764,0.306-2.4372,0.7608-1.068,1.0692-1.8288-0.9168,1.068-2.742,0.1524-2.5896-0.762-3.5076-2.286-4.5732-1.98-2.1312-3.5076-2.1348-6.7056-1.9824-7.314-2.7384-5.334-2.5944-1.9812-3.048-0.7632-3.8088,1.2204,1.2192-1.068-4.2672,1.524,1.9788,1.0692,0.1524,3.048,3.8124,2.4384,0.4584,0.6096,0.3024h0.7608l0.1524-0.3024,2.286,1.2192,2.592,0.7608h3.6564l-3.1992-0.7608-3.9636-1.8288-4.1148-2.2884-2.286-3.0444-0.306-1.3728-1.2192-0.1524,0.1536-0.9168,0.9144-1.0668,1.2192,0.1536,0.306,0.9132,1.2192-0.4584,1.98,1.5264,3.354,0.3024,2.4372,0.306-2.1312-1.2192-3.354-1.8288-3.3528-3.0492-1.068-0.1524-3.354-5.1792-1.8276-5.0304-1.524-5.3328v-6.2508l1.98-5.0268,2.8956-4.5732,1.6764-1.5252,1.3716,0.4572,3.5052-2.5896,2.4384-0.762,3.2016,0.15,2.4384,0.7632,3.5052,1.068,1.6752,2.1324,1.6764,0.1536,0.456,1.2192-0.9132,0.3048,1.2192,1.6764-0.4572,1.0668,1.068,1.3716-0.1524,1.98-1.98,2.2872,1.3704,2.2848-0.1536,0.7644,1.6764,1.8288,1.5252,2.2836,2.5908,0.4584,6.096,0.1536,4.4184-0.4584,2.592-0.1536-1.068-1.2192,1.8288-0.4584,2.286-0.4584,4.1148-3.1968s3.2016-5.4888,3.8112-6.2508c0.6096-0.7608,1.8276-3.3528,1.8276-3.3528l5.1816-5.334,1.98-0.762,4.5732-2.2848h4.7256l1.2216,1.3728,1.98,0.3048,1.8288,2.2848,0.9132,6.2496-2.8956,1.98h-2.436l-1.6764-1.0668-0.4584,0.9144-1.9812-0.456z'/%3E %3Cpath d='m859.741,387.068s0.3588-0.7164,0.7188-0.7164c0.3588,0,1.1652-0.0876,1.1652-0.0876l0.0888-4.662s-0.6264-0.3564-0.7176-0.7164c-0.0888-0.3564-0.0888-2.0604-0.0888-2.0604l-0.6264-0.6276-0.09-18.8184-1.7928-4.8384-1.5228-2.598-1.254-0.9864-1.9728-0.1776-2.2404,1.434-1.344,0.7164-2.868-0.6252-1.074-0.7188-1.7052-0.0876-1.5228-2.778-3.1356-0.9864-1.4328-0.4476-4.3008-0.3588-1.254-0.09-1.6152,1.0764-1.8816,2.2404-1.3428,2.5968-0.1788,4.2132,0.9852,1.344v1.9704l0.4488,0.8064v1.7028l-1.434-1.7028-1.434-3.4944-0.7164-2.1504-0.6276,0.8964,0.1788,2.868,0.0888,2.328,0.8076,2.1528,0.8064,3.0444,1.344,3.8532,1.0752,4.1244,0.9864,3.9408,1.8816,3.5844,1.6128,2.2404,3.6744,3.6732,2.3292,1.6128,3.5844,1.2564,4.032-0.0876,1.2528-0.9-1.6128-1.5216s-0.2676-0.984-0.2676-1.344,0.5364-2.1516,0.5364-2.1516l1.7028-1.7928,4.9284-0.8952,1.7028,1.2552,2.2404,2.5092,1.8816,0.9816z'/%3E %3Cpath d='m913.682,313.831v2.5524l1.53-0.3408-0.3384-2.2116h-1.1916z'/%3E %3Cpath d='m916.234,313.151v2.0412h1.0224v-2.2116l-1.0224,0.1704z'/%3E %3Cpath d='m918.448,312.98,0.1692,1.8708,1.7016-0.3384-0.1704-2.2128-1.7004,0.6804,0,0z'/%3E %3Cpath d='m921.848,311.62v2.5536h1.0224l0.3396-2.5536h-1.362z'/%3E %3Cpath d='m924.743,311.11v2.2128l1.3608,0.1704-0.3408-2.382h-1.02v-0.001z'/%3E %3Cpath d='m927.466,310.429v2.5512l1.3608,0.1704v-2.2116l-1.3608-0.51z'/%3E %3Cpath d='m930.187,309.577-0.5112,2.892h1.5324l-0.1716-2.2116-0.8496-0.6804z'/%3E %3Cpath d='m932.228,309.577v2.3832l2.2128-1.0224-0.342-2.5536-1.8708,1.1928z'/%3E %3C/g%3E %3Cpath fill='%2376401b' stroke='none' d='m890.046,266.598-1.488,4.4628,5.1252-0.8268-3.6372-3.636,0,0z'/%3E %3Cg fill='%23784421'%3E %3Cpath d='m932.194,351.556-4.7916,1.3248-3.306,2.6448-4.2984,4.4616-3.4716,6.282-3.966,4.794-7.2744,2.9736-6.612,0.1668-5.124-1.4856-1.818-2.8128-0.4956-3.6348-0.6612-4.464-1.488-2.8092-2.3136-2.8116-2.6448-1.818,2.8116-11.9016,0.8256-2.6448v-3.4716l0.4956-4.626,2.4792-4.1328,2.4792-2.3136,4.2972-1.9836,7.602-1.9824,7.6044-2.4792,7.9344-1.818,8.9256-2.1492,3.8016-0.33-0.33,4.9584,0.9924,1.8192-0.1668,12.8916-0.8256,11.406-0.6612,5.946z'/%3E %3Cpath d='m934.014,351.391,4.6272,0.9924,3.636,2.1492,1.4868,2.148,1.9836-1.6524,0.8256-2.8116,3.4716-1.9812,5.2908-4.6284-4.4652-6.7776-2.3148-3.306-3.1404-3.6348-3.8016-6.942-4.2972-9.4224h-2.3148l-0.33,18.6768,0.1668,6.7764-0.8244,10.4136z'/%3E %3Cpath fill='%23a05a2c' d='m886.904,279.325,0.1668,3.4716,14.2152-4.4628v-1.3224l-14.382,2.3136z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m846.526,359.353,0.6396,3.21,2.1408,3.852,4.0632,3.528-3.4224-2.46,2.5668,3.4236-4.3836-2.7804,4.2768,2.7804-4.4928-6.4188-1.3884-5.1348,0,0z'/%3E %3Cpath d='m841.285,373.577-1.6044,1.7112-2.7816-0.4272,0.1068,3.5304,3.8496,5.67-3.8496-5.3472,0.108-3.6348,2.6748,0.21,1.4964-1.7124,0,0z'/%3E %3Cpath d='M836.686,383.419,835.83,380.958v-2.7792l0.8556,5.2404z'/%3E %3C/g%3E %3Cg fill='%23666'%3E %3Cpath d='m887.275,369.728-1.2828,1.2816-2.1384,0.5364s-2.1384-0.2136-2.5668-0.5364c-0.4272-0.3192-2.7816-1.71-2.7816-1.71l2.7816,1.4964h4.9188l1.0692-1.068z'/%3E %3Cpath d='m890.698,374.756,0.534,3.102,2.1384,3.7404,1.3896,1.8204-4.062-8.6628,0,0z'/%3E %3Cpath fill='%23808080' d='m898.078,383.525-2.034-0.6384-1.818-1.7148-2.5668-4.596,2.6736,3.4224,3.7452,3.5268,0,0z'/%3E %3Cpath stroke-width='0.13692' d='m880.217,371.011,0.3216,9.0912,0.8556,3.5304,1.2804,2.5668,1.7136,2.6748,0.4272-1.0692,1.818,1.2828,0.5364-0.5364-1.8204-1.8168-1.818-2.4612-1.0716-2.5668-1.1748-4.3848-0.4272-4.7052h1.4952l-0.4272-0.8556-1.7088-0.75z'/%3E %3Cpath fill='%23808080' stroke-width='0.13692' d='m920.644,385.344,3.4224-0.3204,3.21-2.6748,0.534-1.8204,1.4964-1.0704-0.2136,3.1032,0.7476,1.6056,2.0316,0.642,1.2828,1.1748,2.2476,0.2148,3.2076-2.0304,2.3532-2.4612,2.0328-1.8192,1.4964-0.642,0.5352-2.994h0.9624l0.2136-1.392-0.4272-2.6712-0.9624-2.568-1.2828-1.7112-2.1396-1.9248-0.9612,0.4284,2.352,2.2452,1.9248,2.46,0.1068,3.8496-0.534,1.4976-2.8884,3.3168-3.7428,4.0632-1.818,0.8556-3.8496-0.5328-1.392-1.8192-0.3204-1.2828-0.4284-1.2828v-1.4976l0.5352-1.0692-3.9564,4.4904-1.6044,0.1056-4.1712,3.5316z'/%3E %3Cpath fill='%23808080' stroke-width='0.22824' d='m972.088,357.323,0.8556-0.7488,0.9624,1.392,0.216,3.8484,0.1056,0.108v2.5668l-1.4952,2.7816-3.21,3.4224-3.7428,1.602-3.4236,0.4272-2.3532-0.5316-0.8556-1.392-0.534-1.3896v-3.2076l0.642-1.284,0.2136,0.6408-0.1068,3.5304,1.1748,1.3908,2.46,0.7464,2.2452-0.7464,2.6748-0.75,2.2452-1.2828,0.108-0.7488-0.8556-0.1068,0.2136-0.3204h1.2828l1.6044-3.21,0.534-2.6748v-2.1384l-0.6396-0.6408-0.3228-0.534v-0.75h0.001z'/%3E %3Cpath d='m887.381,406.842-5.3484,2.5668-4.9188,1.4964-2.6748-0.4272,5.2392,1.9248,2.034-1.6032,3.2076-1.6056,2.4612-2.352,0,0z'/%3E %3Cpath fill='%23999' stroke-width='0.18252' d='m891.553,417.643,2.8872,0.8556,1.3896,0.5364,2.9952,0.4272-2.2464,1.3884,2.886,0.6408s-2.778,0.3228-3.2064,0.3228-1.926,0.9612-1.926,0.9612-0.3204,1.7148,0.642,1.6056c0.9648-0.108,2.352-0.3228,2.8872-0.3228s2.2464,0.3228,2.2464,0.3228l1.0704,0.8556-0.642,0.9648-4.4928,0.1056,0.6432,0.5364h3.636l-3.528,2.352,4.2756-0.1092,3.4224,1.392v0.8556l-3.3144,0.75-0.7488-1.2864-4.278,1.1772-0.8556,1.0704-1.6044-1.0704,1.2828-2.7792-0.1068-2.8884-0.642-2.2476-1.4964-3.3132-1.176-3.1032z'/%3E %3C/g%3E %3Cg fill='%23e2d67e'%3E %3Cpath fill='%23e4cb5e' stroke-width='0.22824' d='m868.889,274.852-3.4452,0.4164-2.436,0.2976-1.6044,0.9516-1.3068-0.774-0.7728,0.4752-2.9112-1.5444-3.3876,1.8432-1.6044,1.4244h-1.008l-0.774-1.0092-1.5444,1.0716-0.8916-0.8928-0.9504-0.534-6.4164,4.6344-2.3172-0.7728-1.0104,0.8916-0.4176,0.3564-0.2352,1.0092-0.9528-2.4972-0.8304,0.594-1.4256-0.4752-1.0104,1.4268-0.2376,3.7428,0.594,4.6932,1.5468,5.1696,1.4244,2.1384,1.188,0.2376,0.3576-1.4856,0.654,2.7924,0.9504,0.9492,0.2976,5.0508,3.8616,8.6748,0.3564,4.4556,0.1776,7.7232-1.4256,1.7256-1.8408,2.7924,0.0588,0.8292-1.9008,3.6252,0.1176,5.526,0.4176,0.4752,0.12,5.2872,1.4844,0.1188,1.188,1.3068,2.6148-0.2364v-1.6044l0.3564,1.8408,2.0784,2.7348,1.7832,1.4244,1.2456,0.06,0.654-0.9504-0.06-5.9412,0.4164,6.5352,1.3068-0.06,1.6656-1.4844,2.1984-0.2976,0.7128,0.06s0.594,0.3564,0.8916,0.8904c0.2964,0.534,1.3668,1.0116,1.3668,1.0116l0.7728,1.6044,0.9504,0.3564,0.4752-1.0116-0.6528-12.6552-0.654-10.3368-0.7128-13.1292-0.714-16.7568-0.1188-5.346-0.8316-0.7128,0.06-1.7232,2.0208-0.594,1.1868-0.3564-0.5352-1.6032-0.5928-5.3472v-2.0196l0.714-0.594,1.4256-0.0588,1.0104,1.188,1.9608,8.1384,1.0104,0.3564,3.564-0.06,8.0808,12.7752,2.8512,4.278,3.9216,7.3068,5.1108,7.308,1.6044,2.1384,1.0692,0.1212,0.3564-7.7844,2.2596-1.9608-1.902-13.4268-1.5444-0.2964-2.1384-1.9608-1.188,0.1776-1.188,1.9608-1.4844-1.6632-0.18-1.902-1.3668-0.8892h-1.008l-1.3092-1.782-0.7116-0.18-0.8316,0.7728-0.1788-6.0588-1.3068-2.8512-0.2376-1.7232-2.436-3.4464-2.5536-0.594s-1.128-2.556-1.128-2.9124-0.4776-1.6044-0.4776-1.6044l-1.7904-1.8456z'/%3E %3Cpath fill='%23dcc56a' d='m871.027,356.128-1.722-2.1972-0.594-2.3172-0.2376-4.9908-0.534-4.7544-0.9516-7.3668-1.5444-9.09-1.2468-7.3668-0.4764-4.3368-1.0092-5.1108-0.4164-3.5052-0.4164-2.9112-0.3564-4.158,1.188,3.7428,1.962,8.7336,2.196,6.06,0.8916,4.0992v2.3172l1.5456,3.3252,1.0104,4.2204,2.0784,8.9112,2.1984,7.3092,1.128,5.286,0.1776,2.0208-2.3172,0.774-1.128,0.5328-1.4256,0.7728z'/%3E %3Cpath fill='%23e2cc75' d='m882.613,354.348,1.2492-6.0012,1.4856-4.5744,0.6528-3.09,0.4752-2.4948-0.12-3.7428-1.0092-2.1984-4.6332-9.3276-2.7936-5.6436-1.1292-2.9124-2.0784-3.6252-2.7924-5.8224-2.496-4.3356-2.0784-3.5652-1.9608-2.616-0.5928,0.5364,1.7808,6.654,1.4844,5.7024,1.4268,6.2976,2.376,8.2584,1.3668,5.7048,1.3668,3.5052,1.3068,4.9308,3.624,11.7648,0.714,3.0888,1.7832,3.5664,0.5916-0.06,0,0z'/%3E %3Cpath fill='%23ddd690' d='m863.999,357.562-1.8732,1.8708,0.1704,0.6816h2.2116l0.6828-1.5324-1.1916-1.02z'/%3E %3Cpath fill='%23ddd690' d='m861.785,355.008,0.3408,2.0424,1.5312-0.1704,0.8496-1.53-0.1692-1.1916-1.5312,0.3408-1.0212,0.5088z'/%3E %3Cpath fill='%23ddd690' d='m865.528,354.158,0.5112,1.3608h2.8932v-1.02l-1.1904-0.5112-2.214,0.1704z'/%3E %3Cpath fill='%23ddd690' d='m865.19,351.607,0.168,1.53h2.0436l1.02-1.3632-1.1904-1.02-2.0412,0.8532z'/%3E %3Cpath fill='%23ddd690' d='m861.104,352.116-0.3408,1.0224,1.0224,0.51,2.214-0.51v-0.852l-2.8956-0.1704z'/%3E %3Cpath fill='%23ddd690' d='m861.104,349.564v1.1916l2.2128,0.1704,0.6816-1.0212-0.852-0.6804-2.0424,0.3396z'/%3E %3Cpath fill='%23ddd690' d='m865.528,348.544-0.3372,1.02,2.04,0.5112,1.02-0.8508-1.5288-1.0224-1.194,0.342,0,0z'/%3E %3Cpath fill='%23ddd690' d='m861.276,345.821-0.3408,1.5312,1.3608,0.1704,1.1916-0.8508,0.1704-1.1892-1.362-0.1728-1.02,0.5112,0,0z'/%3E %3Cpath fill='%23ddd690' d='m865.019,345.14v1.53l2.2128,0.5088v-2.2116l-1.0212-0.3384-1.1916,0.5112z'/%3E %3Cpath fill='%23ddd690' d='m862.976,342.587h-2.0412l-0.1728,2.3808,2.3832-1.02-0.1692-1.3608z'/%3E %3Cpath fill='%23ddd690' d='m864.677,341.906-0.8496,1.7016h2.382l1.0212-2.2104-1.362-0.3408-1.1916,0.8496z'/%3E %3Cpath fill='%23ddd690' d='m864.167,339.014,0.1728,1.362,2.2128-0.3408-0.8532-1.7004-1.5324,0.6792,0,0z'/%3E %3Cpath fill='%23ddd690' d='m861.955,339.526-1.53-0.3408,0.1716,1.8732,2.2116-0.3396-0.8532-1.1928,0,0z'/%3E %3Cpath fill='%23ddd690' d='m860.425,336.462-0.1704,1.7028h2.7228l-0.5112-1.7028h-2.0412z'/%3E %3Cpath fill='%23ddd690' d='m863.658,335.611v2.0424h2.5524l-0.5124-2.0424h-2.04z'/%3E %3Cpath fill='%23ddd690' d='m862.296,334.08-1.7004,2.04-0.6816-1.7004,1.1904-2.0424,1.1916,1.7028,0,0z'/%3E %3Cpath fill='%23ddd690' d='m863.827,332.548-0.3396,1.7028h2.2104v-1.7028l-0.8484-0.51-1.0224,0.51z'/%3E %3Cpath fill='%23ddd690' d='m861.104,330.508h-1.1904l-0.1704,1.362h2.0412l-0.6804-1.362z'/%3E %3Cpath d='m863.488,329.996-0.3408,1.5312h1.7028v-1.5312h-1.362z'/%3E %3Cpath d='m862.976,326.933-0.3396,1.53h2.3808l0.1728-1.3596-2.214-0.1704z'/%3E %3Cpath d='m860.255,327.614-0.3408,2.2116,2.0412-0.8484v-1.1916l-1.7004-0.1716z'/%3E %3Cpath d='m860.084,324.552-0.6804,1.3608,1.0212,0.5112,0.852-1.1916-0.3408-1.02-0.852,0.3396,0,0z'/%3E %3Cpath d='m862.894,323.405-0.5376,1.128,0.882,1.5204,1.2264-0.2952,0.0516-1.7172-1.3764-0.6876-0.246,0.0516,0,0z'/%3E %3Cpath d='m860,321.684-0.444,1.2276,0.8844,0.7848s0.7344-0.2928,0.7344-0.5412c0-0.2436,0.246-1.0296,0.246-1.0296l-0.9804-0.5892-0.4404,0.1476z'/%3E %3Cpath d='m862.356,321.047-0.2952,1.3752,0.6876,0.4416,1.2264,0.0984s0.0492-0.9336,0.0492-1.2768c0-0.342-0.8844-0.7356-0.8844-0.7356l-0.7836,0.0972z'/%3E %3Cpath d='m859.754,319.181-0.0996,1.374,1.032,0.246s0.54-0.5376,0.54-0.7344c0-0.1956-0.492-1.08-0.492-1.08l-0.9804,0.1944z'/%3E %3Cpath d='m862.061,318.788-0.1968,1.1292s0.3936,0.5388,0.8844,0.5388c0.4896,0,0.6864-0.4896,0.6864-0.6852,0-0.198-0.1968-1.032-0.1968-1.032l-1.1772,0.0492z'/%3E %3Cpath d='m859.655,317.267-0.342,1.1304,0.9804,0.4404,0.7368-0.9816-0.786-0.5376-0.5892-0.0516z'/%3E %3Cpath d='m861.962,316.58-0.1464,1.0296s0.6852,0.4908,0.9324,0.3432c0.246-0.1464,0.5388-0.7836,0.5388-0.7836l-0.8844-0.5892h-0.4404z'/%3E %3Cpath d='m858.968,314.371-0.2448,1.2756s0.7344,0.6876,0.9312,0.5904c0.198-0.0996,1.2276-0.3936,1.2276-0.3936l-0.54-1.2756s-0.6372-0.1476-0.8328-0.1476c-0.1968,0-0.5904,0-0.5412-0.0492z'/%3E %3Cpath d='m861.521,313.733-0.2928,1.2264,1.6668,0.2952s0.246-1.3752-0.096-1.3752c-0.3468,0.001-1.1808-0.0972-1.278-0.1464z'/%3E %3Cpath d='m859.116,312.065-0.294,0.7368,0.8328,0.6372,0.6876-0.3912-0.4428-0.9336-0.7836-0.0492z'/%3E %3Cpath d='m861.618,311.574-0.636,0.9828,1.0296,0.4392,0.882-0.6852-1.2756-0.7368z'/%3E %3Cpath d='m859.165,309.415-0.4416,0.7368,0.4908,0.7836,0.786-0.6384-0.8352-0.882z'/%3E %3Cpath d='m860.932,308.924-0.3924,0.54,0.5892,0.7836,0.9804-0.5388,0.0984-0.4416-0.4416-0.54-0.834,0.1968z'/%3E %3Cpath d='m858.919,307.402-0.4416,1.0296,0.9804,0.54,0.5424-0.6852-0.3456-0.786-0.7356-0.0984z'/%3E %3Cpath d='m860.784,306.42-0.54,0.6888,0.7368,0.7356,0.9312-0.5412-0.636-0.7848-0.492-0.0984z'/%3E %3Cpath d='m858.919,305.683h-0.3924v0.834l1.128-0.0984-0.1968-0.834-0.5388,0.0984z'/%3E %3Cpath d='m860.441,304.702-0.0492,0.9324,1.0296-0.1476-0.0492-0.8328-0.9312,0.048z'/%3E %3Cpath d='m858.674,303.967-0.342,0.4896,0.5868,0.786,0.5904-0.5412s0.1956-0.7344,0-0.7344h-0.8352z'/%3E %3Cpath d='m858.772,302.347-0.4392,0.3924,0.5376,0.5388,0.6864-0.342-0.7848-0.5892,0,0z'/%3E %3Cpath d='m858.919,301.121-0.54,0.7836h0.9336l-0.3936-0.7836z'/%3E %3Cpath d='m860.146,301.561,0.0984,0.786h0.786l-0.8844-0.786z'/%3E %3Cpath d='m860.195,302.838s-0.1944,1.0296,0,1.0296c0.1968,0,0.7368-0.1476,0.7368-0.1476l-0.7368-0.882z'/%3E %3Cpath fill='%23d3c55f' d='m886.307,326.544-1.0776,1.4724,0.0972,1.5228,1.4244,1.3248,1.3248-1.866-1.7688-2.454z'/%3E %3Cpath fill='%23d3c75f' d='m888.222,324.432-1.3248,1.9164,1.2756,2.0124,1.3248-0.8328s0.1968-1.6716-0.0492-1.9668c-0.246-0.2928-1.2756-1.1784-1.2264-1.1292z'/%3E %3Cpath d='m885.767,321.733s-0.588,0.8832-0.588,1.0812c0,0.1956,0.3444,1.6176,0.3444,1.6176l0.834,1.0812s0.93-0.2952,1.0284-0.5904c0.0984-0.2916,0.4428-1.4232,0.4428-1.4232l-1.128-1.4736-0.9336-0.2928z'/%3E %3Cpath fill='%23d3c95f' d='m883.706,323.844-0.246,0.4896s-0.1452,1.1796,0.1476,1.3752c0.294,0.1968,1.1772,1.1304,1.1772,1.1304s0.7836-0.4908,0.7836-0.7368-0.588-1.7688-0.588-1.7688l-0.6852-0.6852-0.5892,0.1956z'/%3E %3Cpath d='m881.693,320.458-0.3912,0.9312,0.4896,1.2768,0.9336,0.9324s1.0296-0.1944,1.0296-0.3936v-1.374l-0.6396-1.0788-1.0788-0.4896-0.3432,0.1956z'/%3E %3Cpath d='m883.902,319.574-0.2448,0.7356s0.0984,1.032,0.294,1.128c0.1968,0.0984,0.9816,0.492,0.9816,0.492l0.6852-1.1292-0.6852-1.4232-1.0308,0.1968z'/%3E %3Cpath d='m882.824,317.22-0.492,1.0788,0.2952,0.7836,0.6876,0.3444s0.7836-0.3924,0.7836-0.5892v-1.0296l-0.882-0.5412-0.3924-0.0468z'/%3E %3Cpath d='m880.565,318.004-0.6372,0.834,0.246,1.032,1.0788,0.3432,0.7356-0.8844-0.5904-1.1772-0.8328-0.1476z'/%3E %3Cpath d='m879.728,315.794-0.5376,0.4908v0.6384l0.834,0.6396,0.7836-0.3936-0.1956-0.8844-0.3912-0.5892-0.4932,0.0984z'/%3E %3Cpath d='m881.89,315.157-0.3444,0.7848,0.4908,1.0308,0.7872-0.4416-0.15-0.8844-0.7836-0.4896,0,0z'/%3E %3Cpath d='m880.417,313.048-0.1944,1.7664,1.2252-0.1968,0.2952-0.9312-0.4404-0.6888-0.8856,0.0504,0,0z'/%3E %3Cpath d='m879.14,313.439c-0.1956,0.048-0.882,0.0984-0.882,0.0984l0.1968,1.7652,0.7836-0.096,0.2952-0.6384-0.0984-0.7848-0.2952-0.3444z'/%3E %3Cpath d='m877.669,311.672-0.588,0.7368,0.588,0.9804,0.54-0.0984,0.342-0.7344-0.882-0.8844,0,0z'/%3E %3Cpath d='m879.581,311.179-0.4896,0.5412,0.3936,0.5892,0.4908,0.0492,0.4896-0.5904-0.4404-0.5376-0.444-0.0516,0,0z'/%3E %3Cpath d='m876.442,309.906-0.3444,0.9312,0.9336,0.246,0.2436-0.5892-0.2928-0.5412-0.54-0.0468,0,0z'/%3E %3Cpath d='m878.062,309.415-0.0972,1.0788,1.0296-0.0984-0.0984-0.882-0.834-0.0984,0,0z'/%3E %3Cpath d='m875.264,308.188,0.0492,0.9312h1.0296s0.3444-1.0788-0.0984-1.0296c-0.4416,0.0492-0.882,0.1452-0.9804,0.0984z'/%3E %3Cpath d='m877.228,307.745v0.9324l1.0788-0.1476-0.2448-0.8328-0.834,0.048z'/%3E %3Cpath d='m875.803,306.764h-1.0788l0.1476,0.9324,0.9804-0.0984-0.0492-0.834z'/%3E %3Cpath d='m876.491,306.125-0.1476,0.8844,1.1304-0.0492v-0.8352h-0.9828z'/%3E %3Cpath d='m875.412,304.702-0.0492,1.0308s1.2264,0.1956,1.2264,0c0-0.1968-0.246-0.8832-0.246-0.8832l-0.9312-0.1476z'/%3E %3Cpath d='m874.724,304.8h-0.9816l0.0996,1.128h1.1772l0.1464-0.7836-0.4416-0.3444z'/%3E %3Cpath d='m872.418,301.463-0.492,0.4908,1.5228,2.4048h0.9312l-0.882-1.2264s0.1464-0.588-0.0984-0.6852c-0.2436-0.0984-0.4404-0.0984-0.4404-0.0984l-0.5412-0.8856z'/%3E %3Cpath d='m872.612,300.53-0.342,0.4416,1.8168,1.2264v1.0296l0.834,0.786,0.6852,0.1944-0.2436-0.8328-0.3432-0.9312-0.6888-0.5412-0.4884-0.882s-0.246-0.0492-0.4428-0.0984c-0.1944-0.0492-0.3912-0.3444-0.3912-0.3444l-0.396-0.048z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath fill='%23000' d='m851.578,283.375-0.1728,7.9956,0.5112,2.5524v4.4256l0.1704,6.8064v4.5936l-3.9144-4.7664,4.0836,5.106,0.6804,4.9332,1.0224,1.8732-0.6804,2.5524,0.1704,4.2528v12.0804l-3.9144-9.528,0.3408,19.7376,0.3408-11.3988,1.362-2.0436,2.2116,5.6172,0.3396,2.5524-0.5112-9.5304'/%3E %3Cpath d='m835.582,282.694-0.6804,5.106,1.362,3.5712,0.1716,4.9356-0.1716-5.4444-1.362-2.7228,0.6804-5.4456z'/%3E %3Cpath d='m840.517,285.757v6.4656l1.1904,1.5312-0.3384,6.8064,1.02,2.0412v11.2296'/%3E %3Cpath d='m847.492,278.101-1.3608,2.5512,0.5112,4.5948,0.3396,3.2328-0.51,5.1024'/%3E %3Cpath d='m878.462,290.52-0.1728,7.8276,0.8508,4.2528,0.6816,4.5936'/%3E %3Cpath d='m885.776,301.921,1.5312,17.016'/%3E %3Cpath d='m842.047,327.275,0.3408,9.8688,0.6804,4.2552,0.1704,4.5924'/%3E %3C/g%3E %3Cg fill='%23d38d5f'%3E %3Cpath d='m893.264,345.481v-1.7028l7.4868-1.7028-1.1916,0.852,0.1704,5.1048'/%3E %3Cpath d='m913.682,341.226v-2.2128l7.4868-1.3608-1.7028,0.3408,0.3408,5.274'/%3E %3Cpath d='m897.518,357.731v-1.7028l6.2964-1.1892-0.1716,6.2952'/%3E %3Cpath d='m912.491,355.35v-2.724l6.8052-1.1904,0.3408,5.9532'/%3E %3Cpath d='m890.372,333.059v4.254l-1.5312,0.3408v-2.0424l1.5312-2.5524z'/%3E %3Cpath d='m893.946,332.377,0.1692,4.2552h-1.1916l-0.3396-3.744,1.362-0.5112z'/%3E %3Cpath d='m896.665,331.528-1.1892,0.6792v3.4032l1.7028-0.3408-0.5136-3.7416z'/%3E %3Cpath d='m899.9,330.337-1.1916,1.0212v3.0624l1.8708-0.1704-0.6792-3.9132z'/%3E %3Cpath d='m903.643,329.485-1.7028,0.6804v3.4032l1.8744-0.3396-0.1716-3.744z'/%3E %3Cpath d='m907.217,328.464-1.5312,0.1716v4.254l1.8732-0.3408-0.342-4.0848z'/%3E %3Cpath d='m911.81,327.614-1.7004,0.6792,0.1704,2.892,1.7004-0.5088-0.1704-3.0624z'/%3E %3Cpath d='m916.064,326.424-1.7004,0.8508v2.892h1.53l0.1704-3.7428z'/%3E %3Cpath d='m919.468,325.402-1.362,0.6804v3.2328h1.7028l-0.3408-3.9132z'/%3E %3Cpath d='m923.21,325.063-1.362,0.8496v2.5512h1.8744l-0.5124-3.4008z'/%3E %3Cpath d='m927.295,323.7-1.5324,0.6816,0.1716,2.5512,1.5312-0.3396-0.1704-2.8932,0,0z'/%3E %3Cpath d='m931.718,322.679-1.7016,0.8508v2.7228l2.0436-0.1704-0.342-3.4032z'/%3E %3C/g%3E %3Cg stroke-width='0.91284'%3E %3Cpath fill='%23fffcfc' d='m891.564,368.79,26.3712-5.9544'/%3E %3Cpath fill='%23c87137' d='m885.096,352.285,2.7252,0.3408,44.9184-10.2096'/%3E %3Cpath fill='%23c87137' stroke-width='0.86724' d='m887.65,340.717,6.9756-1.0236,38.7948-10.2084'/%3E %3Cpath fill='none' stroke-width='1.1868' d='m935.122,327.955,6.6348-1.1916'/%3E %3Cpath fill='%23fffcfc' stroke-width='1.32372' d='m935.122,341.906,14.6328-3.912'/%3E %3C/g%3E %3C/g%3E %3Cpath fill='none' stroke='%23000' stroke-width='8.2159' d='m767.32,145.154v253.639c3.0024,36.3156,78.6864,59.178,131.454,97.7484,69.2124-46.422,136.34-55.812,139.039-107.858l0.8424-243.529h-271.33z'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300' viewBox='0 0 937.5 625'%3E %3Cpath fill='%23FFF' d='M0 625h937.5V0H0V625z'/%3E %3Cg fill='none'%3E %3Cpath fill='%23CE0F25' d='M659.049 394.35c10.735 25.244 6.121 45.149 0 64.53 15.479-5.609 48.359-21.014 44.419-40.226C696.574 401.836 675.119 397.716 659.049 394.35'/%3E %3Cpath stroke='%23221B0F' d='M659.049 394.35c10.735 25.244 6.121 45.149 0 64.53 15.479-5.609 48.359-21.014 44.419-40.226C696.574 401.836 675.119 397.716 659.049 394.35z'/%3E %3Cpath fill='%23FAF8F0' d='M604.198 503.635c9.756-3.152 16.456-6.744 32.61-8.985 6.658-0.923 24.596 0.161 34.996-3.075 10.015-3.12 15.813-6.081 16.099-11.106 0.509-9.006 3.43-19.321 6.961-28.685 5.036-13.362 11.151-24.134 12.095-27.744 0.891-3.404-0.64-6.816-2.896-9.945 -8.792-12.194-28.496-21.087-46.054-21.066l0.746 2.989c13.518 0.245 40.244 10.371 41.851 23.915 2.423 20.399-66.544 23.491-104.855 31.064 0 0-9.878 2.456-13.244 5.93 -2.384 2.456-3.599 8.816-1.119 11.172C598.908 484.747 604.198 503.635 604.198 503.635'/%3E %3Cpath stroke='%23221B0F' d='M604.198 503.635c9.756-3.152 16.456-6.744 32.61-8.985 6.658-0.923 24.596 0.161 34.996-3.075 10.015-3.12 15.813-6.081 16.099-11.106 0.509-9.006 3.43-19.321 6.961-28.685 5.036-13.362 11.151-24.134 12.095-27.744 0.891-3.404-0.64-6.816-2.896-9.945 -8.792-12.194-28.496-21.087-46.054-21.066l0.746 2.989c13.518 0.245 40.244 10.371 41.851 23.915 2.423 20.399-66.544 23.491-104.855 31.064 0 0-9.878 2.456-13.244 5.93 -2.384 2.456-3.599 8.816-1.119 11.172C598.908 484.747 604.198 503.635 604.198 503.635z'/%3E %3Cpath fill='%23F6E4BE' d='M700.591 432.568c-25.791 16.68-60.626 17.901-91.055 20.664l-19.374 19.696 17.76 26.156c0 0 19.784-6.49 30.028-8.074 7.24-1.117 15.374-0.115 22.601-1.29 6.188-1.007 11.685-0.457 15.823-5.167 4.81-5.48 4.564-15.445 7.103-22.28 1.62-4.356 4.209-7.956 7.579-13.121C696.457 440.869 700.591 432.568 700.591 432.568'/%3E %3Cpath fill='%23CE0F25' d='M594.856 514.846c4.751-22.985-10-32.042-17.935-45.961 0 0 8.549 3.504 13.076 4.109 8.494 1.134 13.394 0.96 25.681-1.019 10.059-1.621 18.512-6.689 25.515-3.465 0.973 0.448 1.72 1.554 1.867 2.617 0.454 3.278-1.45 6.64-3.362 9.341C629.205 495.276 594.856 514.846 594.856 514.846'/%3E %3Cpath stroke='%23221B0F' d='M594.856 514.846c4.751-22.985-10-32.042-17.935-45.961 0 0 8.549 3.504 13.076 4.109 8.494 1.134 13.394 0.96 25.681-1.019 10.059-1.621 18.512-6.689 25.515-3.465 0.973 0.448 1.72 1.554 1.867 2.617 0.454 3.278-1.45 6.64-3.362 9.341C629.205 495.276 594.856 514.846 594.856 514.846z'/%3E %3Cpath fill='%23CE0F25' d='M278.37 394.35c-10.736 25.244-6.121 45.149 0 64.53 -15.479-5.609-48.36-21.014-44.417-40.226C240.847 401.836 262.3 397.716 278.37 394.35'/%3E %3Cpath stroke='%23221B0F' d='M278.37 394.35c-10.736 25.244-6.121 45.149 0 64.53 -15.479-5.609-48.36-21.014-44.417-40.226C240.847 401.836 262.3 397.716 278.37 394.35z'/%3E %3Cpath fill='%23FAF8F0' d='M333.22 503.635c-9.757-3.152-16.455-6.744-32.608-8.985 -6.66-0.923-24.596 0.161-34.996-3.075 -10.016-3.12-15.816-6.081-16.1-11.106 -0.51-9.006-3.431-19.321-6.961-28.685 -5.039-13.362-11.154-24.134-12.096-27.744 -0.89-3.404 0.64-6.816 2.898-9.945 8.792-12.194 28.499-21.087 46.054-21.066l-0.747 2.989c-13.516 0.245-40.242 10.371-41.851 23.915 -2.423 20.399 66.544 23.491 104.856 31.064 0 0 9.876 2.456 13.244 5.93 2.384 2.456 3.599 8.816 1.117 11.172C338.513 484.747 333.22 503.635 333.22 503.635'/%3E %3Cpath stroke='%23221B0F' d='M333.22 503.635c-9.757-3.152-16.455-6.744-32.608-8.985 -6.66-0.923-24.596 0.161-34.996-3.075 -10.016-3.12-15.816-6.081-16.1-11.106 -0.51-9.006-3.431-19.321-6.961-28.685 -5.039-13.362-11.154-24.134-12.096-27.744 -0.89-3.404 0.64-6.816 2.898-9.945 8.792-12.194 28.499-21.087 46.054-21.066l-0.747 2.989c-13.516 0.245-40.242 10.371-41.851 23.915 -2.423 20.399 66.544 23.491 104.856 31.064 0 0 9.876 2.456 13.244 5.93 2.384 2.456 3.599 8.816 1.117 11.172C338.513 484.747 333.22 503.635 333.22 503.635z'/%3E %3Cpath fill='%23F6E4BE' d='M236.83 432.568c25.79 16.68 60.625 17.901 91.054 20.664l19.372 19.696 -17.759 26.156c0 0-19.785-6.49-30.029-8.074 -7.239-1.117-15.37-0.115-22.601-1.29 -6.188-1.007-11.686-0.457-15.821-5.167 -4.81-5.48-4.564-15.445-7.104-22.28 -1.617-4.356-4.207-7.956-7.579-13.121C240.964 440.869 236.83 432.568 236.83 432.568'/%3E %3Cpath fill='%23CE0F25' d='M342.561 514.846c-4.749-22.985 10-32.042 17.938-45.961 0 0-8.55 3.504-13.08 4.109 -8.49 1.134-13.391 0.96-25.679-1.019 -10.057-1.621-18.513-6.689-25.514-3.465 -0.974 0.448-1.722 1.554-1.869 2.617 -0.454 3.278 1.45 6.64 3.362 9.341C308.215 495.276 342.561 514.846 342.561 514.846'/%3E %3Cpath stroke='%23221B0F' d='M342.561 514.846c-4.749-22.985 10-32.042 17.938-45.961 0 0-8.55 3.504-13.08 4.109 -8.49 1.134-13.391 0.96-25.679-1.019 -10.057-1.621-18.513-6.689-25.514-3.465 -0.974 0.448-1.722 1.554-1.869 2.617 -0.454 3.278 1.45 6.64 3.362 9.341C308.215 495.276 342.561 514.846 342.561 514.846z'/%3E %3Cpath fill='%23FAF8F0' d='M305.291 543.188c-4.464-2.861-9.549-5.693-12.377-9.996 -1.949-2.965-2.796-7.039-1.904-10.474 5.216-20.094 4.106-30.854 0.49-46.069 -1.167-4.917-2.358-12.341 3.794-12.01 15.78 0.851 33.471 5.886 46.178 5.431 5.191-0.189 12.95-1.221 13.616-6.881 0.791-6.723-16.472-12.695-16.472-12.695 10.261 1.178 18.752 5.424 21.666 11.428 1.184 2.441 0.635 5.897-0.894 8.141 -3.009 4.423-8.734 5.621-14.034 6.331 -10.558 1.425-28.455-1.47-38.575-3.412 -4.577-0.878-6.177-1.598-6.976-0.971 -2.002 1.577 0.731 4.762 7.103 10.72 12.891 12.055 27.917 21.872 43.424 30.307 42.229 22.967 74.524 30.305 118.381 30.305 43.855 0 76.149-7.337 118.38-30.305 15.506-8.435 30.531-18.253 43.423-30.307 6.372-5.957 9.108-9.143 7.1-10.72 -0.794-0.626-2.395 0.094-6.974 0.971 -10.12 1.943-28.017 4.837-38.576 3.413 -5.296-0.71-11.024-1.909-14.033-6.331 -1.529-2.244-2.077-5.7-0.891-8.141 2.914-6.004 11.402-10.25 21.664-11.427 0 0-17.262 5.973-16.471 12.695 0.665 5.66 8.424 6.693 13.615 6.881 12.709 0.455 30.396-4.58 46.179-5.431 6.152-0.331 4.962 7.092 3.792 12.01 -3.616 15.215-4.728 25.975 0.491 46.069 0.89 3.435 0.042 7.509-1.905 10.474 -2.827 4.304-7.911 7.135-12.378 9.996 -51.901 33.279-110.235 50.366-163.416 50.366C415.528 593.555 357.193 576.467 305.291 543.188'/%3E %3Cpath stroke='%23221B0F' d='M305.291 543.188c-4.464-2.861-9.549-5.693-12.377-9.996 -1.949-2.965-2.796-7.039-1.904-10.474 5.216-20.094 4.106-30.854 0.49-46.069 -1.167-4.917-2.358-12.341 3.794-12.01 15.78 0.851 33.471 5.886 46.178 5.431 5.191-0.189 12.95-1.221 13.616-6.881 0.791-6.723-16.472-12.695-16.472-12.695 10.261 1.178 18.752 5.424 21.666 11.428 1.184 2.441 0.635 5.897-0.894 8.141 -3.009 4.423-8.734 5.621-14.034 6.331 -10.558 1.425-28.455-1.47-38.575-3.412 -4.577-0.878-6.177-1.598-6.976-0.971 -2.002 1.577 0.731 4.762 7.103 10.72 12.891 12.055 27.917 21.872 43.424 30.307 42.229 22.967 74.524 30.305 118.381 30.305 43.855 0 76.149-7.337 118.38-30.305 15.506-8.435 30.531-18.253 43.423-30.307 6.372-5.957 9.108-9.143 7.1-10.72 -0.794-0.626-2.395 0.094-6.974 0.971 -10.12 1.943-28.017 4.837-38.576 3.413 -5.296-0.71-11.024-1.909-14.033-6.331 -1.529-2.244-2.077-5.7-0.891-8.141 2.914-6.004 11.402-10.25 21.664-11.427 0 0-17.262 5.973-16.471 12.695 0.665 5.66 8.424 6.693 13.615 6.881 12.709 0.455 30.396-4.58 46.179-5.431 6.152-0.331 4.962 7.092 3.792 12.01 -3.616 15.215-4.728 25.975 0.491 46.069 0.89 3.435 0.042 7.509-1.905 10.474 -2.827 4.304-7.911 7.135-12.378 9.996 -51.901 33.279-110.235 50.366-163.416 50.366C415.528 593.555 357.193 576.467 305.291 543.188z'/%3E %3Cpath fill='%23F6E4BE' d='M637.419 535.408c0 0 3.499-3.49 4.145-6.447 1.611-7.385-2.131-15.006-2.303-22.563 -0.185-8.148 1.383-24.404 1.383-24.404 -20.186 19.274-75.825 68.013-171.934 68.013 -93.4 0-151.749-48.739-171.935-68.013 0 0 1.565 16.256 1.381 24.404 -0.17 7.556-3.915 15.178-2.301 22.563 0.645 2.958 4.143 6.448 4.143 6.448 52.923 33.996 109.461 54.795 168.712 54.795C527.959 590.203 584.498 569.404 637.419 535.408'/%3E %3C/g%3E %3Cpath d='M365.845 550.515c1.832-5.256 7.756-10.813 17.201-7.524 7.839 2.731 11.168 8.888 8.714 15.929 -2.452 7.039-9.43 10.85-17.426 8.066C365.298 563.839 363.949 555.956 365.845 550.515M386.956 558.521c2.399-6.886-0.174-12.572-5.338-14.371 -3.62-1.261-8.43-0.731-11.098 6.925 -2.227 6.395-0.374 12.729 5.671 14.831C378.396 566.676 383.86 567.408 386.956 558.521'/%3E %3Cpath d='M398.135 558.267c1.155-4.813 1.368-5.697 1.545-6.727 0.195-1.091 0.056-1.659-0.961-2.138 -0.245-0.126-0.787-0.29-1.241-0.399 -0.356-0.085-0.536-0.193-0.484-0.418 0.054-0.22 0.296-0.23 0.783-0.11 1.719 0.41 3.737 0.996 4.71 1.229 0.779 0.188 2.844 0.583 4.011 0.859 0.487 0.117 0.699 0.236 0.646 0.456 -0.054 0.224-0.264 0.24-0.589 0.16 -0.355-0.082-0.557-0.1-0.961-0.128 -0.915-0.052-1.304 0.423-1.634 1.515 -0.307 0.997-0.521 1.884-1.675 6.696l-1.064 4.431c-1.101 4.59-0.624 6.745 0.661 8.395 1.178 1.519 2.639 2.004 3.741 2.269 1.428 0.341 3.284 0.319 4.885-0.639 2.201-1.311 2.982-4.137 3.764-7.397l0.95-3.958c1.154-4.811 1.366-5.697 1.545-6.726 0.194-1.092 0.056-1.661-0.961-2.138 -0.245-0.125-0.789-0.29-1.144-0.375 -0.357-0.086-0.537-0.198-0.484-0.418 0.053-0.223 0.295-0.23 0.75-0.12 1.653 0.396 3.673 0.981 3.705 0.989 0.389 0.095 2.455 0.489 3.72 0.79 0.454 0.109 0.665 0.226 0.612 0.448 -0.054 0.223-0.264 0.24-0.652 0.145 -0.356-0.085-0.559-0.1-0.964-0.13 -0.912-0.051-1.301 0.424-1.632 1.516 -0.307 0.999-0.52 1.884-1.675 6.695l-0.813 3.388c-0.842 3.516-2.096 7.164-5.366 8.79 -2.765 1.38-5.184 1.167-7.291 0.664 -1.719-0.413-4.809-1.255-6.673-3.913 -1.305-1.852-1.975-4.491-0.874-9.081L398.135 558.267z'/%3E %3Cpath d='M427.129 571.524c-0.165-0.025-0.24 0.031-0.334 0.215l-2.416 4.159c-0.445 0.759-0.72 1.509-0.776 1.897 -0.084 0.579 0.153 1.04 1.176 1.188l0.495 0.07c0.396 0.056 0.485 0.135 0.459 0.329 -0.037 0.258-0.245 0.294-0.607 0.241 -1.056-0.153-2.463-0.45-3.485-0.598 -0.363-0.052-2.191-0.216-3.908-0.462 -0.429-0.061-0.618-0.153-0.581-0.412 0.029-0.194 0.169-0.239 0.434-0.201 0.296 0.044 0.764 0.079 1.031 0.083 1.548 0.025 2.331-0.981 3.222-2.497l11.15-18.791c0.53-0.879 0.779-1.204 1.107-1.156 0.298 0.042 0.454 0.361 0.679 1.15 0.537 1.886 3.967 15.532 5.378 20.734 0.838 3.081 1.73 3.668 2.399 3.929 0.481 0.167 0.972 0.27 1.369 0.326 0.264 0.038 0.424 0.095 0.391 0.321 -0.036 0.258-0.343 0.28-1.564 0.102 -1.189-0.17-3.598-0.515-6.229-0.959 -0.589-0.115-0.985-0.172-0.952-0.399 0.027-0.193 0.169-0.239 0.504-0.224 0.24-0.031 0.513-0.288 0.403-0.698l-1.688-7.019c-0.043-0.169-0.132-0.25-0.298-0.271L427.129 571.524zM434.091 570.877c0.166 0.025 0.214-0.066 0.192-0.169l-1.832-8.354c-0.014-0.134-0.022-0.3-0.123-0.315 -0.097-0.014-0.187 0.138-0.239 0.265l-4.17 7.46c-0.051 0.122-0.033 0.225 0.1 0.244L434.091 570.877z'/%3E %3Cpath d='M451.349 578.297c-0.025 2.54 0.378 3.401 1.036 3.654 0.559 0.214 1.191 0.27 1.724 0.288 0.366 0.016 0.565 0.089 0.557 0.282 -0.01 0.259-0.311 0.315-0.777 0.299 -2.166-0.079-3.495-0.225-4.129-0.246 -0.3-0.011-1.869 0.028-3.601-0.034 -0.434-0.015-0.732-0.057-0.721-0.351 0.006-0.195 0.21-0.254 0.542-0.241 0.433 0.016 1.034 0.005 1.505-0.109 0.876-0.23 1.043-1.167 1.179-3.996l0.991-19.151c0.024-0.65 0.14-1.101 0.472-1.089 0.366 0.014 0.653 0.446 1.196 1.05 0.385 0.441 5.261 5.826 9.955 10.719 2.186 2.295 6.515 7.141 7.063 7.683l0.167 0.005 0.193-14.619c0.039-1.985-0.239-2.614-1.026-2.969 -0.493-0.211-1.292-0.242-1.757-0.259 -0.401-0.013-0.531-0.115-0.524-0.311 0.01-0.26 0.378-0.28 0.878-0.26 1.731 0.063 3.329 0.219 4.025 0.244 0.368 0.014 1.639-0.039 3.27 0.017 0.435 0.015 0.768 0.06 0.757 0.321 -0.007 0.194-0.211 0.286-0.61 0.27 -0.334-0.012-0.601-0.022-1.005 0.063 -0.943 0.226-1.232 0.901-1.333 2.721l-1.107 20.513c-0.026 0.716-0.167 1.005-0.469 0.994 -0.366-0.013-0.754-0.386-1.107-0.758 -2.029-2.028-6.139-6.443-9.482-9.917 -3.506-3.644-7.06-7.746-7.638-8.386l-0.1-0.003L451.349 578.297z'/%3E %3Cpath d='M483.181 574.563c-0.169 0.014-0.229 0.081-0.281 0.283l-1.472 4.578c-0.273 0.836-0.383 1.627-0.353 2.019 0.041 0.584 0.371 0.984 1.404 0.907l0.499-0.035c0.396-0.028 0.503 0.027 0.516 0.224 0.019 0.259-0.175 0.339-0.541 0.365 -1.064 0.078-2.502 0.084-3.533 0.161 -0.365 0.024-2.189 0.255-3.916 0.381 -0.431 0.033-0.636-0.018-0.656-0.279 -0.013-0.194 0.114-0.269 0.381-0.29 0.3-0.02 0.762-0.085 1.025-0.138 1.516-0.307 2.066-1.456 2.614-3.128l6.88-20.739c0.331-0.971 0.505-1.342 0.837-1.367 0.3-0.022 0.52 0.256 0.908 0.98 0.926 1.727 7.195 14.326 9.681 19.106 1.479 2.83 2.475 3.215 3.185 3.328 0.505 0.06 1.007 0.057 1.406 0.028 0.268-0.02 0.435 0 0.452 0.227 0.018 0.261-0.276 0.346-1.509 0.438 -1.195 0.086-3.623 0.264-6.288 0.39 -0.6 0.014-1.002 0.041-1.016-0.185 -0.015-0.195 0.114-0.269 0.444-0.328 0.228-0.081 0.44-0.39 0.244-0.768l-3.147-6.495c-0.079-0.159-0.184-0.214-0.349-0.204L483.181 574.563zM489.846 572.447c0.166-0.014 0.191-0.113 0.152-0.208l-3.575-7.769c-0.043-0.128-0.09-0.289-0.189-0.281s-0.155 0.174-0.176 0.306l-2.481 8.178c-0.024 0.134 0.018 0.229 0.15 0.219L489.846 572.447z'/%3E %3Cpath d='M509.529 570.608c0.65 4.115 0.999 6.334 1.781 6.804 0.635 0.396 1.527 0.486 4.095 0.081 1.746-0.274 3.027-0.509 3.714-1.506 0.329-0.481 0.583-1.445 0.551-2.066 -0.011-0.291 0.024-0.497 0.289-0.537 0.229-0.039 0.286 0.119 0.347 0.503 0.056 0.355 0.206 2.804 0.088 3.78 -0.085 0.737-0.225 0.925-1.939 1.194 -2.37 0.371-4.094 0.576-5.58 0.781 -1.493 0.166-2.684 0.319-4.034 0.534 -0.363 0.056-1.088 0.173-1.872 0.328 -0.757 0.119-1.604 0.319-2.263 0.422 -0.429 0.068-0.675 0.006-0.711-0.217 -0.024-0.162 0.091-0.279 0.488-0.341 0.494-0.079 0.879-0.204 1.166-0.315 0.639-0.232 0.691-0.968 0.676-1.919 -0.049-1.378-0.448-3.917-0.912-6.876l-0.891-5.661c-0.768-4.889-0.909-5.79-1.137-6.807 -0.236-1.083-0.581-1.556-1.704-1.609 -0.275-0.025-0.674 0.005-1.103 0.074 -0.363 0.054-0.569 0.023-0.605-0.201 -0.035-0.225 0.185-0.325 0.679-0.405 1.549-0.244 3.638-0.474 4.528-0.612 0.791-0.126 3.179-0.601 4.466-0.802 0.46-0.073 0.701-0.045 0.735 0.181 0.037 0.225-0.151 0.321-0.545 0.384 -0.364 0.056-0.886 0.171-1.271 0.299 -0.864 0.299-1.041 0.888-0.93 2.024 0.096 1.04 0.237 1.941 1.006 6.83L509.529 570.608z'/%3E %3Cpath d='M527.885 568.32c-0.16 0.04-0.209 0.119-0.23 0.324l-0.699 4.759c-0.132 0.87-0.11 1.667-0.018 2.046 0.137 0.57 0.529 0.91 1.534 0.667l0.486-0.117c0.389-0.096 0.502-0.054 0.547 0.134 0.061 0.254-0.119 0.364-0.474 0.451 -1.037 0.251-2.452 0.493-3.459 0.738 -0.356 0.086-2.116 0.611-3.802 1.02 -0.42 0.103-0.631 0.086-0.691-0.167 -0.045-0.189 0.069-0.284 0.327-0.347 0.291-0.069 0.739-0.21 0.99-0.306 1.445-0.55 1.8-1.775 2.064-3.515l3.381-21.584c0.166-1.01 0.276-1.409 0.6-1.486 0.291-0.069 0.555 0.166 1.055 0.816 1.2 1.552 9.452 12.95 12.69 17.258 1.923 2.55 2.969 2.766 3.69 2.759 0.506-0.024 1-0.109 1.39-0.204 0.26-0.061 0.43-0.071 0.484 0.151 0.059 0.254-0.215 0.388-1.415 0.677 -1.166 0.282-3.531 0.855-6.14 1.421 -0.591 0.109-0.98 0.203-1.034-0.019 -0.048-0.189 0.069-0.285 0.384-0.395 0.212-0.119 0.37-0.459 0.116-0.799l-4.173-5.889c-0.103-0.141-0.216-0.182-0.376-0.143L527.885 568.32zM534.114 565.137c0.162-0.039 0.171-0.141 0.116-0.228l-4.804-7.075c-0.06-0.119-0.134-0.27-0.23-0.246 -0.096 0.025-0.125 0.198-0.128 0.33l-1.1 8.472c-0.004 0.134 0.054 0.222 0.183 0.19L534.114 565.137z'/%3E %3Cpath d='M545.004 560.026c-1.8-5.266-0.558-13.291 8.909-16.526 7.857-2.681 14.272 0.115 16.683 7.17 2.409 7.055-0.735 14.355-8.75 17.09C552.79 570.856 546.866 565.481 545.004 560.026M566.566 553.32c-2.358-6.901-7.889-9.794-13.064-8.025 -3.629 1.237-7.089 4.621-4.47 12.291 2.188 6.409 7.553 10.253 13.611 8.184C564.852 565.016 569.609 562.224 566.566 553.32'/%3E %3Cpath fill='%23666' d='M600.99 134.593H336.514v18.726H600.99V134.593z'/%3E %3Cpath fill='none' stroke='%23552200' d='M600.99 134.593H336.514v18.726H600.99V134.593z'/%3E %3Cg fill='%235E520E' stroke='%23552200'%3E %3Cpath fill='%23EACE24' stroke='%23806600' stroke-width='2' d='M336.514 153.318l-29.936-70.443 -5.031 1.529 -10.99-25.175 20.187-5.964 4.571 11.818 9.746-2.889 -4.171-11.585 20.56-4.742 3.655 12.07 10.121-1.949L351.723 43.8l20.62-3.595 2.823 12.279 13.641-1.932 1.185 6.206 5.063-0.641 -1.04-6.175 10.45-1.36 1.066 6.281 5.11-0.515 -0.769-6.331 10.382-0.948 0.872 6.326 10.099-0.775 -1.841-18.731 20.92-1.069 0.684 12.324 9.976-0.152 -0.18-12.441 21.006 0.001 -0.323 12.592 10.155 0.208 0.739-12.533 20.871 0.917 -1.906 18.997 10.095 0.699 0.876-6.261 10.35 0.95 -0.821 6.271 5.219 0.511 0.944-6.116 10.415 1.115 -1 6.25 5.158 0.716 1.247-6.245 13.487 1.995 2.859-12.379 20.592 3.594 -3.194 12.415 9.72 1.908 3.766-12.221 20.524 4.649 -4.271 12.059 9.779 2.671 4.725-12.066 20.263 5.779L641.07 84.203l-8.674-2.857 -30.483 71.973C517.724 129.097 417.809 128.996 336.514 153.318'/%3E %3Cpath d='M462.536 95.047V72.721c0-8.93 16.066-8.93 16.066 0v22.326'/%3E %3Cpath d='M345.25 110.217l-6.93-21.565c-2.771-8.625 12.746-12.092 15.519-3.466l6.929 21.565'/%3E %3Cpath d='M579.064 105.929l6.929-21.564c2.775-8.626 18.29-5.16 15.519 3.465l-6.931 21.565'/%3E %3Cpath fill='none' stroke='%23806600' d='M514.974 119.629l-0.915 7.759M333.067 144.973c88.135-25.836 184.129-26.221 272.559-1.09M329.87 137.896c90.111-26.456 188.276-26.865 278.703-1.165M327.021 130.716c92.091-27.003 192.401-27.375 284.776-1.056M324.11 124.146c93.783-27.525 195.94-27.951 290.05-1.212M549.956 123.741l-1.609 7.573M596.106 133.588l-2.605 7.077M576.629 128.849l-2.204 7.189M548.824 115.996l-1.526 7.467M564.871 118.697l-1.971 7.166M583.166 122.409l-2.198 7.155M603.71 127.503l-2.72 7.089M578.848 114.276l-1.96 6.535M602.296 119.591l-2.536 6.84M593.418 117.503l-2.266 6.595M558.132 110.558l-1.626 6.79M546.068 108.28l-1.464 7.136M503.769 118.94l-0.689 7.505M530.669 121.308l-1.236 7.325M497.786 110.866l-0.525 7.583M511.589 111.635l-0.804 7.483M535.02 114.313l-1.284 7.229M529.905 106.382l-1.091 6.825M516.019 105.132l-0.854 7.013M494.619 103.346l-0.442 7M365.031 129.124l2.147 6.95M488.345 118.026l-0.356 7.741M351.105 132.363l2.505 7.096M433.071 119.18l0.79 7.59M452.047 118.344l0.397 7.355M410.636 121.244l1.295 7.516M464.826 118.026l0.135 7.47M383.307 125.404l1.8 7.411M357.934 122.717l2.351 7.265M375.902 119.012l1.938 7.189M387.103 117.042l1.699 7.427M403.415 114.579l1.386 7.331M425.885 112.362l0.944 7.518M443.539 111.024l0.589 7.699M459.268 110.489l0.246 7.474M481.416 110.03l-0.21 7.471M340.824 126.968l2.734 7.245M477.316 103.044l-0.118 7.185M461.38 103.235l0.184 6.9M446.812 103.804l0.457 6.908M419.722 105.892l0.981 7M398.551 108.28l1.342 6.74M383.754 110.458l1.655 6.865M366.379 113.665l1.927 6.596M340.5 119.212l2.599 7.026M556.506 101.82l8.036-37.306M321.068 116.431c95.924-28.114 200.404-28.491 296.615-1.075M506.806 67.845c18.643 1.164 37.333 3.221 55.693 6.163M513.746 52.902l-0.69 5.793 0 0c-27.5-1.91-55.476-1.919-82.977-0.013l0 0 -0.737-5.916M379.247 74.024c18.179-2.916 37.099-4.966 55.557-6.138M376.891 64.68l8.567 37.223M437.545 96.112l-3.638-37.683M507.314 58.353l-2.018 37.784M377.7 52.127l2.61 12.115 0 0c-26.975 4.16-52.976 12.363-78.764 20.163M562.536 51.915c0 0-2.528 11.995-2.527 11.996 27.659 4.176 54.641 12.294 81.062 20.292'/%3E %3C/g%3E %3Cpath fill='%231353B4' stroke='%23554400' stroke-width='2' d='M336.514 153.317c-0.704 45.093-0.662 90.191 0 135.284 0.636 43.444 2.766 77.346 21.895 103.856 23.042 31.931 61.427 54.975 110.806 77.616 49.376-22.641 87.764-45.685 110.806-77.616 19.126-26.51 21.258-60.413 21.894-103.856 0.664-45.092 0.704-90.191 0-135.284L336.514 153.317 336.514 153.317z'/%3E %3Cpath fill='%23CE0F25' d='M598.216 344.999c0.088-11.274 2.433-16.629 2.434-27.901 1.169-22.626 1.618-45.096 1.265-67.644H336.514c-0.354 22.548 0.094 44.817 1.262 67.644 0.004 11.272 2.416 16.628 2.501 27.901H598.216z'/%3E %3Cpath fill='none' stroke='%23554400' stroke-width='2' d='M336.135 248.863h266.159M340.106 344.999h258.111'/%3E %3Cpath fill='%23FFF' stroke='%23000' stroke-width='0.805' d='M436.14 311.056l32.228-13.13 -13.13 32.229 14.324-9.548 14.325 9.548 -13.131-32.229 32.229 13.13 -9.55-14.323 9.55-14.324 -32.229 13.13 13.131-32.228 -14.325 9.549 -14.324-9.549 13.13 32.228 -32.228-13.13 9.549 14.324L436.14 311.056z'/%3E %3Cg id='t1' fill='%23FFF' stroke='%23000'%3E %3Cpath fill='%23EACE24' stroke='none' d='M256.42 398.03c-0.345 39.061-0.69 40.443-0.69 40.443 17.109 16.765 19.139 22.906 24.195 28.346 6.567-9.507 16.764-5.705 16.764-5.705 2.075-8.986 12.964-16.764 12.964-16.764 -15.209-1.209-41.48-8.989-43.554-12.099 -6.888-10.332 2.592-41.651 2.592-41.651L256.42 398.03z'/%3E %3Cpath fill='none' stroke='%23806600' d='M256.42 398.03c-0.345 39.061-0.69 40.443-0.69 40.443 17.109 16.765 19.139 22.906 24.195 28.346 6.567-9.507 16.764-5.705 16.764-5.705 2.075-8.986 12.964-16.764 12.964-16.764 -15.209-1.209-41.48-8.989-43.554-12.099 -6.888-10.332 2.592-41.651 2.592-41.651L256.42 398.03z'/%3E %3Cpath fill='%23EACE24' stroke='none' d='M293.936 459.211l-16.865-12.953 20.042 11.975'/%3E %3Cpath fill='none' stroke='%23806600' d='M293.936 459.211l-16.865-12.953 20.042 11.975'/%3E %3Cpath fill='%23EACE24' d='M268.904 379.505c0 0 21.131-8.626 42.788 6.57 2.069 0.604 3.581 0.427 5.227 0.141 4.186-4.489 13.681-17.685 21.014-15.974 0.54-11.15-0.734-55.728-0.734-55.728 -3.176-0.124-4.277 6.11-4.277 6.11 1.834 12.709-5.5 89.948-35.563 38.862l-21.265 2.2L268.904 379.505z'/%3E %3Cpath fill='none' stroke='%23806600' d='M268.904 379.505c0 0 21.131-8.626 42.788 6.57 2.069 0.604 3.581 0.427 5.227 0.141 4.186-4.489 13.681-17.685 21.014-15.974 0.54-11.15-0.734-55.728-0.734-55.728 -3.176-0.124-4.277 6.11-4.277 6.11 1.834 12.709-5.5 89.948-35.563 38.862l-21.265 2.2L268.904 379.505z'/%3E %3Cpath fill='%23EACE24' stroke='none' d='M257.333 200.842c18.148 6.567 18.375 10.037 36.347 25.937 14.345 5.705 35.71 19.692 36.92 22.804l-1.164 4.543c2.766 1.727 5.378-4.644 5.378-4.644 -2.765-15.729-53.276-63.103-53.276-63.103l-22.249 4.685L257.333 200.842z'/%3E %3Cpath fill='none' stroke='%23806600' d='M257.333 200.842c18.148 6.567 18.375 10.037 36.347 25.937 14.345 5.705 35.71 19.692 36.92 22.804l-1.164 4.543c2.766 1.727 5.378-4.644 5.378-4.644 -2.765-15.729-53.276-63.103-53.276-63.103l-22.249 4.685L257.333 200.842z'/%3E %3Cpath fill='none' d='M274.395 193.804l56.861 52.195 1.211 3.802'/%3E %3Cpath fill='none' d='M286.838 213.161c5.704 10.025 16.248 13.654 16.248 13.654'/%3E %3Cpath d='M263.87 180.412c-0.244-18.82 21.999-31.285 21.999-32.996 -2.201-13.415-33.976 18.575-35.688 22.731 -1.964 6.064 2.445 13.443 2.445 13.443'/%3E %3Cpath d='M269.981 155.725c-6.6 5.377-11.976 22.976-11.976 22.976'/%3E %3Cpath d='M253.604 180.168c-2.688-18.088 11-33.73 10.022-34.219 -8.411-4.205-19.311 18.086-22.487 25.42l4.155 24.93'/%3E %3Cpath d='M249.205 165.258c-3.423 8.799 0.244 20.775 0.244 20.775'/%3E %3Cpath d='M246.516 189.7c-4.4-4.399-0.245-35.929-1.467-35.929 -9.288 0-14.175 30.307-12.22 36.663 6.342 20.614 11.487 24.197 11.487 24.197'/%3E %3Cpath d='M238.206 178.946c-0.734 9.289 6.599 20.776 6.599 20.776'/%3E %3Cpath d='M244.316 212.92c-11.731-10.999-13.766-40.511-15.397-43.506 -12.553 2.445-6.11 33.73-6.11 33.73 0.244 2.444 16.62 21.998 16.62 21.998'/%3E %3Cpath d='M227.451 188.967c-4.155 8.31 14.665 32.998 14.665 32.998'/%3E %3Cpath d='M258.982 282.823c0 0-3.178-42.528 2.199-48.882l-15.886-23.465 -20.531 40.817 18.575 33.975L258.982 282.823z'/%3E %3Cpath fill='none' d='M258.982 282.823c0 0-3.178-42.528 2.199-48.882l-15.886-23.465 -20.531 40.817 18.575 33.975L258.982 282.823z'/%3E %3Cpath d='M244.026 375.503c6.966 8.92 10.37 29.036 10.37 29.036l2.074-6.569c0.978 0.611 1.571 5.705 2.938 5.705 0.611 0 0.504-5.251 1.901-5.533 0.611-0.12 0.206 7.26 1.556 7.26 1.1 0 1.188-5.256 1.555-5.013 0.864 0.575 1.035 6.978 1.729 3.63 -0.977-34.341 66.34-62.443 64.985-100.936 1.711-39.839-41.135-54.959-67.405-88.488 0 0-7.381-21.987 6.221-12.271 11-1.711 10.025-12.616 10.025-12.616h6.049c2.69-23.464-20.912-17.974-20.912-17.974 -21.875 0-23.85 22.64-23.85 22.64 -5.622 29.454 32.542 64.53 32.542 64.53 5.621 12.221-0.05 33.295-0.05 33.295l-53.114 50.04'/%3E %3Cpath d='M221.253 341.843c-2.934 3.545-18.003 21.403-21.669 27.635 -5.191 5.723 4.9 4.113 4.9 4.113s-14.922 15.775-22.17 20.389c2.225 6.675 16.536-2.994 16.536-2.994s-13.933 8.555-13.198 10.266c4.251 3.244 16.619-5.865 16.619-5.865s-2.954 4.154-0.489 5.621c4.156 0 13.687-7.576 13.687-7.576s-1.955 4.399 0.245 5.131c3.974-2.505 28.843-23.221 28.843-23.221'/%3E %3Cpath fill='none' d='M230.855 331.268c0 0-7.432 9.851-2.42 8.296'/%3E %3Cpath d='M229.809 305.698c-6.049 11.753-13.77 31.131-5.359 39.75 2.766 0.865 10.145-27.608 15.901-30.245 0.864-2.936 4.666-15.899 4.666-15.899'/%3E %3Cpath d='M239.184 304.332c3.173 0-6.347 6.356-9.778 15.154'/%3E %3Cpath d='M241.734 306.564c-4.666 21.949-0.345 26.615 1.556 26.789 2.765-1.385 7.605-21.434 13.135-22.643'/%3E %3Cpath d='M218.056 204.938c-19.356-18.148-21.95-38.886-24.024-39.061 -9.135-0.76 3.111 36.815 3.111 36.815l23.159 18.492'/%3E %3Cpath d='M214.986 209.499c0 0-9.286-7.089-14.176-16.621'/%3E %3Cpath d='M218.056 218.074c-28.69-15.901-32.147-41.825-34.566-40.962 -8.834 3.489 2.419 27.309 2.419 27.309 1.556 6.567 24.37 27.134 24.37 27.134'/%3E %3Cpath d='M212.542 225.63c0 0-12.22-9.044-21.997-23.954'/%3E %3Cpath d='M209.242 229.653c-34.393-19.01-35.085-40.789-38.887-39.405 -8.168 22.139 21.776 43.034 42.862 58.762'/%3E %3Cpath d='M211.076 239.073c0 0-15.644-5.621-25.421-20.531'/%3E %3Cpath d='M212.526 248.491c-29.9-9.505-44.336-37.371-48.048-35.949 -8.641 3.284 9.506 26.616 9.506 26.616 14.69 13.654 38.887 23.678 38.887 23.678'/%3E %3Cpath d='M213.276 252.761c0 0-20.776-3.911-32.02-15.4'/%3E %3Cpath d='M212.699 261.108c-47.874-15.383-49.775-30.418-54.269-29.209 -8.525 6.483 18.839 27.999 18.839 27.999 3.455 5.184 38.369 14.691 38.369 14.691'/%3E %3Cpath d='M216.453 263.516c0 0-24.198 0.489-34.463-7.822'/%3E %3Cpath d='M214.945 274.417c-45.8-9.68-52.54-23.16-56.171-22.295 -5.724 7.781 21.951 24.713 21.951 24.713 17.11 9.852 40.269 11.234 40.269 11.234'/%3E %3Cpath d='M220.119 279.89c0 0-16.131 0.489-26.398-5.132'/%3E %3Cpath d='M213.562 304.487c-12.788 11.753-20.047 33.695-13.48 35.086 3.629 0.171 13.48-25.581 27.826-29.208l9.159-7.952'/%3E %3Cpath d='M231.851 301.155c3.171 0-16.614 6.112-20.043 14.911'/%3E %3Cpath d='M206.822 293.773c-18.665 13.999-24.637 30.557-21.948 31.455 4.147 1.383 20.745-15.871 26.789-16.939 2.938-0.518 20.394-9.85 20.394-9.85'/%3E %3Cpath d='M218.164 295.533c3.171 0-12.948 5.621-16.376 14.423'/%3E %3Cpath d='M220.131 287.724c-20.394 2.419-56.17-19.357-56.861-17.456 -8.879 10.401 29.554 27.826 38.022 26.961l30.072 1.901'/%3E %3Cpath d='M228.184 293.577c0 0-24.686 0.246-35.93-4.886'/%3E %3Cpath d='M284.156 290.157c0 0 0-11.488-5.621-11.977 0 0-12.71-0.976-26.886 1.467 -32.424-19.357-7.024-44.221-11.489-52.795 -1.466-13.198-23.219-32.997-23.219-32.997 -2.2 1.957 0.443 14.277-1.223 13.444 -4.399-2.199-1.686 7.485-2.933 10.021 -4.155-1.466-3.942 4.823-2.933 9.532 -3.422 0.49-2.201 6.355-1.467 10.511 -6.71-3.691 2.031 10.464-0.245 10.02 -10.265-1.467 1.467 9.778 1.467 9.778 -5.866 2.2-3.126 6.563 0.979 8.31 -5.134 3.666 0.121 9.519 1.954 9.778 -4.644 2.443 0.524 5.976 3.177 8.554 -4.155 3.911 3.422 5.581 7.09 7.087 -2.934 4.644 0.515 5.648 3.665 7.088 -1.955 3.666 2.856 3.394 5.865 2.935 -3.665 3.91 2.445 5.621 4.889 5.13 0 0 1.304 5.074 5.623 3.179 -1.221 3.913 7.578 3.423 7.578 3.423 0 3.914 12.954 2.445 12.954 2.445'/%3E %3Cg fill='none'%3E %3Cpath d='M221.087 223.77c0 0 2.689 7.088 5.866 7.088'/%3E %3Cpath d='M216.209 207.054c0 0 3.421 11.978 6.599 11.978'/%3E %3Cpath d='M213.276 216.342c0 0 0.978 7.821 4.154 7.821'/%3E %3Cpath d='M209.854 226.363c0 0 2.689 7.088 5.865 7.088'/%3E %3Cpath d='M208.142 236.628c0 0 2.934 6.355 6.111 6.355'/%3E %3Cpath d='M208.387 246.894c0 0 4.889 7.821 8.065 7.821'/%3E %3Cpath d='M209.365 257.405c0 0 5.132 4.4 8.31 4.4'/%3E %3Cpath d='M210.586 265.714c0 0 5.132 4.4 8.31 4.4'/%3E %3Cpath d='M211.809 274.758c0 0 7.576 3.666 10.754 3.666'/%3E %3Cpath d='M215.23 283.313c0 0 8.555 0.734 11.732 0.734'/%3E %3Cpath d='M222.205 290.33c0 0 7.173-0.304 10.349-0.304'/%3E %3Cpath d='M226.354 297.244c0 0 6.136-1.688 10.004-0.304'/%3E %3Cpath d='M232.057 301.218c0 0 6.134-1.689 10.004-0.304'/%3E %3Cpath d='M236.55 305.884c0 0 5.963-0.82 10.176-2.551'/%3E %3Cpath d='M242.6 308.996c0 0 2.504 0.732 6.719-0.994'/%3E %3Cpath d='M249.859 312.105c0 0 2.16-0.13 6.375-1.856'/%3E %3Cpath d='M280.26 189.816c-5.011-9.505-10.198-8.468-10.198-8.468 -2.591 0-3.456 1.728-6.394 1.728 -3.63 0-2.765-3.803-2.765-3.803'/%3E %3C/g%3E %3Cpath fill='%23000' stroke='none' d='M272.137 181.521c-1.037 4.494-4.338 5.366-4.338 5.366s0.716 4.289 3.474 4.485c5.065 0.907 6.719-3.649 4.32-7.605C274.731 182.73 272.137 181.521 272.137 181.521'/%3E %3Cpath stroke='none' d='M275.279 186.708c0.164 0.554-0.675 1.33-1.875 1.731 -1.2 0.404-2.306 0.279-2.47-0.276 0 0-0.001-0.001-0.001-0.003 -0.164-0.555 0.676-1.33 1.875-1.732 1.201-0.401 2.306-0.277 2.471 0.277V186.708'/%3E %3Cpath fill='none' d='M206.061 373.022c-1.589 2.566 5.745 3.248 7.7 0.244 0 4.156 5.665 4.314 7.699 2.322 0.855 2.689 4.813 2.003 7.333-0.489 0.428 1.16 4.014 3.647 5.339 3.17 2.59-0.934 12.71-15.254 14.909-16.475M195.77 392.969c0 0 11.623-11.319 19.226-17.367M199.745 397.117c0 0 15.289-14.13 22.894-20.179M214.436 394.352c0 0 10.156-10.464 17.76-16.512M204.325 373.292c0 0 11.356-13.535 18.961-19.584M213.187 373.652c0 0 9.546-10.953 20.45-18.711M221.89 375.286c0 0 4.499-8.628 18.214-19.196M228.856 375.165c0 0 5.22-9.049 14.658-15.831M228.261 376.377c-7.778 7.95-14 13.309-14 13.309M217.029 377.069c-7.779 7.95-15.727 14.345-15.727 14.345M209.423 374.822c-7.778 7.95-9.851 8.643-9.851 8.643M217.06 347.612c-1.59 2.566 2.004 8.781 9.663 5.086 -2.42 6.402 1.171 4.66 6.145 2.324 -1.392 5.452 4.813 2 7.331-0.49 0.427 1.161 0.557 3.995 2.919 4.21 2.743 0.249 5.623-7.651 7.824-8.871M226.471 352.814l13.889-12.731M219.081 353.483l6.761-10.289M232.714 354.938l8.338-9.151M239.943 354.744l4.392-4.809M226.534 356.155c-1.729 1.902-5.704 4.84-5.704 4.84M233.965 358.058c-3.803 2.938-7.085 6.05-7.085 6.05M246.064 360.995c-7.778 7.95-6.049 5.876-6.049 5.876M241.915 357.711c-3.803 2.939-6.049 5.185-6.049 5.185M249.692 338.354c-11.061 13.827 4.84 2.765 4.84 2.765M235.44 344.943c0 0-6.486 1.188 0.945-7.799M247.965 330.577l-2.074 3.284M245.539 239.562c-1.955 5.621 3.423 11.244 3.423 11.244M241.384 242.74c-1.956 5.621 7.086 14.909 7.086 14.909M239.671 252.271c-1.954 5.623 8.066 10.266 8.066 10.266M244.072 266.448c0.489 4.155 7.821 3.177 7.821 3.177M233.611 220.838c0 0 0.624 4.735 2.939 11.235 -3.63 3.629-4.32 9.159-4.32 9.159M221.087 223.77c0 0 2.689 7.088 5.866 7.088M219.532 232.586c0 0 2.689 7.088 5.866 7.088M216.594 240.017c0 0 3.38 4.669 6.557 4.669M217.803 249.35c0 0 3.381 4.669 6.559 4.669M220.223 259.201c0 0 3.726 0.866 6.903 0.866M222.47 266.114c0 0 0.787 0.175 3.965 0.175M226.272 217.377c0 0-0.423 3.978 2.756 3.978M229.976 280.763c0 0 3.972-0.463 3.272-3.561M224.1 275.234c0 0 6.91-2.019 6.213-5.117M238.618 288.713c0 0 1.208-8.066 0.509-11.166M248.124 295.109c0 0-1.213-10.66-3.639-12.031M258.666 297.7c-2.591-8.986-6.051-13.079-8.478-13.932M268.864 297.183c-2.592-8.987-9.509-12.387-11.936-13.241M280.961 297.526c-2.592-8.986-9.506-12.387-11.934-13.238M272.498 309.5c-9.333 3.456-13.653 11.925-13.653 11.925M259.947 195.563c-2.445 0-3.178 1.466-3.178 1.466M251.881 209.983c-1.037 2.938 2.23 6.975 1.711 6.111M252.042 186.292c-2.421 0-2.594 4.666-2.594 4.666M265.178 226.734l3.456 4.494M266.905 239.869l3.629 4.147M282.114 253.868l4.321 4.667'/%3E %3Cpath fill='%23000' stroke='none' d='M304.346 270.347c0 0 2.054 5.674 3.519 6.162 0 0 1.666 0.56 2.766-0.172 1.001-0.668 0-2.075 0-2.075C309.289 272.307 304.346 270.347 304.346 270.347M295.601 273.193c0 0-0.339 6.024 0.819 7.049 0 0 1.313 1.17 2.611 0.926 1.184-0.221 0.815-1.908 0.815-1.908C299.376 276.934 295.601 273.193 295.601 273.193M301.589 294.457c0 0-0.338 6.024 0.82 7.05 0 0 1.313 1.167 2.611 0.926 1.181-0.222 0.814-1.909 0.814-1.909C305.364 298.198 301.589 294.457 301.589 294.457M316.377 300.495l-0.13 0.301h-0.329c-0.2 0-0.387-0.087-0.527-0.246 -0.636-0.721-0.359-3.964-0.116-5.977 -0.627-0.818-2.075-2.852-1.885-3.942 0.05-0.286 0.199-0.513 0.43-0.658l0.317-0.198 0.28 0.248c0.368 0.326 3.603 3.232 3.83 4.825C318.38 295.77 316.849 299.403 316.377 300.495zM283.702 318.162c-1.099 0-2.07 3.32-1.346 4.689 0 0 0.816 1.555 2.118 1.785 1.185 0.209 1.434-1.5 1.434-1.5C286.285 320.793 285.906 318.162 283.702 318.162M277.098 366.725c-0.472 0.821-2.362 1.968-2.735 2.189l-0.294 0.174 -0.27-0.211c-0.673-0.529-0.293-1.921 1.128-4.138 0.006-0.99 0.106-3.571 0.945-4.327 0.216-0.193 0.47-0.281 0.745-0.253l0.372 0.039 0.067 0.367C277.145 361.05 277.901 365.332 277.098 366.725zM261.578 371.246c-0.273 0.477-0.762 0.633-1.26 0.633 -0.436 0-0.878-0.119-1.191-0.249l-0.116-0.068c-0.819-0.641-0.438-2.657-0.216-3.561 0.001-0.916 0.081-3.635 0.945-4.413 0.215-0.193 0.473-0.281 0.744-0.253l0.349 0.037 0.083 0.341C261.166 364.729 262.37 369.867 261.578 371.246zM274.41 347.66c-0.285 0.494-0.774 0.637-1.241 0.637 -0.569 0-1.107-0.211-1.208-0.253l-0.118-0.068c-0.839-0.658-0.42-2.752-0.201-3.622 0.176-0.507 1.055-2.805 2.531-2.649l0.384 0.041 0.058 0.382C274.677 342.547 275.207 346.272 274.41 347.66zM294.456 330.261c0 0-2.435 5.519-1.714 6.886 0 0 0.817 1.558 2.119 1.786 1.185 0.209 1.433-1.5 1.433-1.5C296.674 335.091 294.456 330.261 294.456 330.261M287.36 344.519c-3.62 1.194-4.38 5.486-4.112 7.005 0 0 0.3 1.732 1.467 2.351 1.064 0.565 1.825-0.986 1.825-0.986C287.62 350.775 289.926 346.475 287.36 344.519M267.809 323.201c-2.441 1.646-2.449 3.084-2.465 4.629 0 0-0.022 1.756 1.013 2.58 0.943 0.747 4.174-0.638 4.174-0.638C271.979 327.893 267.931 327.844 267.809 323.201M293.961 299.615c-2.441 1.646-2.448 1.371-2.464 4.626 0 0 0.832 2.614 1.869 3.436 0.94 0.748 1.974-1.614 1.974-1.614C296.789 304.186 296.039 300.225 293.961 299.615M311.933 312.664c-1.1 0-2.07 3.32-1.347 4.686 0 0 0.818 1.556 2.119 1.786 1.185 0.21 1.434-1.499 1.434-1.499C314.515 315.294 314.136 312.664 311.933 312.664M304.355 322.073c-1.571 5.08-3.413 6.621-2.691 7.988 0 0 1.794 0.455 3.096 0.684 1.185 0.211 1.432-1.497 1.432-1.497C306.573 326.904 304.721 327.572 304.355 322.073M261.58 381.247c-1.1 0-2.07 3.319-1.347 4.686 0 0 0.816 1.555 2.119 1.785 1.185 0.209 1.432-1.499 1.432-1.499C264.164 383.878 263.783 381.247 261.58 381.247'/%3E %3C/g%3E %3Cuse xlink:href='%23t1' transform='matrix(-1,0,0,1,937.5,0) translate(-1,0)'/%3E %3Cg id='t2' fill='%23EACE24' stroke='%23806600'%3E %3Cpath d='M462.575 214.875c0.309-2.981 0.144-8.604-1.376-11.159 -0.514-0.862-1.772-1.869-2.755-1.826 -0.966 0.043-2.298 0.336-2.753 1.216 -0.417 0.808-0.689 2.541-0.59 3.45 0.137 1.264 1.572 3.854 1.572 3.854s-5.142-1.064-6.884-2.434c-1.721-1.356-3.581-3.925-4.13-6.088 -0.189-0.74-0.924-3.139 0.005-6.017 0.539-1.67 2.159-3.905 3.415-5.018 3.276-2.909 9.636-2.064 10.939-1.341 1.719 0.957 3.816 2.991 4.522 4.87 0.549 1.459 1.689 5.766 1.967 7.305 0.568 3.137 0.734 4.323 0.983 7.506 0.171 2.185 0.645 4.146 0.196 6.29 -0.241 1.155-0.541 3.804-1.196 5.549 -0.658 1.754-1.67 2.604-2.541 3.379 -1.78 1.585-7.473 2.435-7.473 2.435s3.128-4.073 3.933-5.884C461.368 218.809 462.333 217.23 462.575 214.875'/%3E %3Cpath d='M476.522 214.875c-0.308-2.981-0.144-8.604 1.376-11.159 0.514-0.862 1.774-1.869 2.755-1.826 0.966 0.043 2.296 0.336 2.753 1.216 0.419 0.808 0.69 2.541 0.59 3.45 -0.139 1.264-1.574 3.854-1.574 3.854s5.144-1.064 6.886-2.434c1.721-1.356 3.579-3.925 4.129-6.088 0.189-0.74 0.924-3.139-0.005-6.017 -0.539-1.67-2.161-3.905-3.414-5.018 -3.277-2.909-9.639-2.064-10.94-1.341 -1.721 0.957-3.818 2.991-4.524 4.87 -0.549 1.459-1.688 5.766-1.967 7.305 -0.568 3.137-0.733 4.323-0.983 7.506 -0.173 2.185-0.646 4.146-0.197 6.29 0.243 1.155 0.544 3.804 1.197 5.549 0.656 1.754 1.67 2.604 2.541 3.379 1.779 1.585 7.474 2.435 7.474 2.435s-3.129-4.073-3.934-5.884C477.73 218.809 476.766 217.23 476.522 214.875'/%3E %3Cpath d='M469.513 237.02c0 0 4.594-3.887 5.356-8.286 0.683-3.958-2.362-8.591-2.594-10.455 -0.921-7.454 1.034-17.384 1.21-18.195 0.701-3.224 1.581-4.604 2.051-5.66 0.339-0.76 1.304-2.271 2.269-3.735 0.554-0.841 1.787-2.406 2.416-3.999 0.666-1.687 0.71-3.405 0.721-4.321 0.016-1.561-0.271-2.89-0.673-4.161 -0.381-1.209-1.626-3.186-3.429-4.323 -1.944-1.226-3.515-2.211-4.114-2.601 -1.975-1.289-3.191-5.528-3.215-5.528s-1.24 4.238-3.215 5.528c-0.598 0.39-2.098 1.375-4.043 2.601 -1.802 1.136-3.048 3.114-3.427 4.323 -0.403 1.271-0.689 2.6-0.671 4.161 0.009 0.916 0.054 2.634 0.721 4.321 0.628 1.592 1.861 3.156 2.416 3.999 0.966 1.464 1.93 2.975 2.268 3.735 0.47 1.056 1.351 2.436 2.051 5.66 0.176 0.811 2.132 10.741 1.209 18.195 -0.231 1.864-3.348 6.497-2.664 10.455C464.918 233.132 469.513 237.02 469.513 237.02'/%3E %3Cpath d='M479.837 213.11l-2.213-3.16h-16.145l-2.218 3.16 2.218 3.144h16.146L479.837 213.11z'/%3E %3C/g%3E %3Cuse xlink:href='%23t2' x='-86.94'/%3E %3Cuse xlink:href='%23t2' x='86.94'/%3E %3Cg id='t3'%3E %3Cpath fill='%23EACE24' stroke='%23806600' stroke-miterlimit='10' d='M445.151 439.394h48.684v11.395h-48.684V439.394zM445.149 436.915c-0.081-10.701-1.586-21.734-6.15-31.13 0.566-0.17 1.165-0.26 1.785-0.26 3.441 0 6.231 2.788 6.231 6.229 0 0.854-0.169 1.663-0.479 2.401 0.8-0.374 1.693-0.582 2.634-0.582 3.44 0 6.231 2.79 6.231 6.234 0 3.439-2.791 6.23-6.231 6.23 -0.446 0-0.882-0.05-1.302-0.138 0.467 4.205 2.625 7.391 5.216 7.391 2 0 3.74-1.897 4.647-4.696 0.905 2.799 2.648 4.696 4.647 4.696 2.785 0 5.069-3.681 5.291-8.356 -1.004 0.695-2.221 1.103-3.533 1.103 -3.443 0-6.232-2.791-6.232-6.23 0-3.426 2.765-6.207 6.184-6.234 -0.525-0.911-0.826-1.971-0.826-3.101 0-3.441 2.79-6.23 6.231-6.23 3.441 0 6.232 2.789 6.232 6.23 0 1.128-0.303 2.19-0.827 3.101 3.419 0.026 6.184 2.807 6.184 6.234 0 3.439-2.79 6.23-6.231 6.23 -1.313 0-2.529-0.408-3.534-1.103 0.221 4.675 2.506 8.356 5.293 8.356 2 0 3.741-1.897 4.647-4.696 0.906 2.799 2.646 4.696 4.646 4.696 2.593 0 4.749-3.186 5.218-7.391 -0.42 0.088-0.858 0.138-1.304 0.138 -3.44 0-6.23-2.791-6.23-6.23 0-3.444 2.79-6.234 6.23-6.234 0.941 0 1.835 0.209 2.634 0.582 -0.307-0.739-0.479-1.548-0.479-2.401 0-3.441 2.79-6.229 6.23-6.229 0.622 0 1.223 0.09 1.787 0.26 -4.565 9.396-6.069 20.429-6.151 31.13H445.149L445.149 436.915z'/%3E %3Cpath fill='%23806600' d='M470.924 419.776l6.634-1.04 -6.97-1.095 -1.095-6.969 -1.091 6.969 -6.971 1.095 6.635 1.04H470.924z'/%3E %3Cpath fill='%23806600' d='M444.93 441.269c0.255-0.001 0.509 0.095 0.702 0.289 0.101 0.103 0.176 0.22 0.225 0.35l1.149 2.526c0.121 0.269 0.111 0.563-0.001 0.814h0.001l-1.173 2.579c-0.165 0.366-0.525 0.582-0.904 0.582L444.93 441.269 444.93 441.269z'/%3E %3Cpath fill='%23806600' d='M445.503 421.533l6.361-2.151 -7.054 0.103 -2.26-6.681 1.696 8.401L445.503 421.533z'/%3E %3Cpath fill='%23806600' d='M443.709 418.248h0.05 0.017c0.063 0.004 0.115 0.01 0.158 0.014 0.132 0.016 0.253 0.064 0.351 0.141l0.003 0.004 0.005 0.004c0.119 0.087 0.231 0.18 0.334 0.276l0.034 0.038c0.109 0.102 0.206 0.202 0.286 0.301l0.034 0.042c0.489 0.613 0.783 1.391 0.783 2.235h0.004v0.009h-0.004c0 0.325-0.042 0.632-0.121 0.92l-0.009 0.03 -0.03 0.1c-0.006 0.02-0.013 0.038-0.019 0.056l-0.004 0.008 -0.004 0.009c-0.074 0.219-0.166 0.434-0.278 0.628 -0.061 0.11-0.15 0.194-0.252 0.256h0.001l-0.006 0.004 -0.004 0.001 -0.005 0.005c-0.046 0.026-0.1 0.057-0.165 0.092l-0.13 0.063c-0.321-1.766-0.707-3.514-1.16-5.232l0.042-0.003v-0.001h0.005c0.029 0 0.055 0.001 0.084 0.004C443.709 418.252 443.709 418.248 443.709 418.248z'/%3E %3Cpath fill='%23FF8080' d='M464.851 444.943l4.365-2.579 4.365 2.579 -4.365 2.579L464.851 444.943z'/%3E %3Cpath fill='none' stroke='%239E7800' stroke-linejoin='round' d='M464.851 444.943l4.365-2.579 4.365 2.579 -4.365 2.579L464.851 444.943z'/%3E %3Cpath fill='%23FF8080' d='M464.851 444.943l4.365-2.579 4.365 2.579 -4.365 2.579L464.851 444.943z'/%3E %3Cpath fill='%23BA0028' d='M473.581 444.943l-4.289 2.534 -0.076 0.045v-2.579H473.581z'/%3E %3Cpath fill='%23CF1E45' d='M469.216 444.943v2.579l-4.366-2.579H469.216z'/%3E %3Cpath fill='%23FF083C' d='M469.216 442.361v2.381 0.2h4.365l-0.103-0.061 -3.95-2.334L469.216 442.361z'/%3E %3Cpath fill='%23FF99CC' d='M442.574 444.852l2.577-2.578 1.174 2.578 -1.174 2.579L442.574 444.852z'/%3E %3Cpath fill='%23F00' d='M442.574 444.852h3.751l-1.174 2.579L442.574 444.852z'/%3E %3Cpath fill='%23CCC' d='M443.626 418.944c0.077 0 0.153 0.004 0.229 0.014 0.732 0.52 1.211 1.379 1.211 2.346 0 0.514-0.138 0.996-0.374 1.414 -0.311 0.191-0.675 0.304-1.066 0.304 -1.126 0-2.04-0.913-2.04-2.039C441.586 419.858 442.5 418.944 443.626 418.944'/%3E %3Cpath fill='none' stroke='%239E7800' d='M443.626 418.944c0.077 0 0.153 0.004 0.229 0.014 0.732 0.52 1.211 1.379 1.211 2.346 0 0.514-0.138 0.996-0.374 1.414 -0.311 0.191-0.675 0.304-1.066 0.304 -1.126 0-2.04-0.913-2.04-2.039C441.586 419.858 442.5 418.944 443.626 418.944z'/%3E %3Cpath fill='%23FFF' d='M442.649 419.753c0.537 0 0.973 0.438 0.973 0.974 0 0.537-0.435 0.974-0.973 0.974s-0.974-0.436-0.974-0.974C441.675 420.191 442.111 419.753 442.649 419.753'/%3E %3Cpath fill='%23806600' d='M493.485 421.533l-6.36-2.151 7.051 0.103 2.26-6.681 -1.695 8.401L493.485 421.533z'/%3E %3Cpath fill='%23806600' d='M495.281 418.248h-0.05 -0.02c-0.06 0.004-0.114 0.01-0.156 0.014 -0.131 0.016-0.254 0.064-0.35 0.141l-0.004 0.004 -0.004 0.004c-0.119 0.087-0.231 0.18-0.334 0.276l-0.037 0.038c-0.109 0.102-0.204 0.202-0.284 0.301l-0.034 0.042c-0.49 0.613-0.785 1.391-0.785 2.235h-0.001v0.009h0.001c0.001 0.325 0.045 0.632 0.124 0.92l0.011 0.03 0.028 0.1c0.005 0.02 0.012 0.038 0.019 0.056l0.004 0.008 0.004 0.009c0.074 0.219 0.166 0.434 0.279 0.628 0.06 0.11 0.149 0.194 0.251 0.256l0.004 0.004 0.006 0.001 0.004 0.005c0.046 0.026 0.1 0.057 0.165 0.092l0.129 0.063c0.323-1.766 0.706-3.514 1.161-5.232l-0.042-0.003v-0.001h-0.006c-0.028 0-0.054 0.001-0.084 0.004L495.281 418.248z'/%3E %3Cpath fill='%23CCC' d='M495.365 418.944c-0.079 0-0.158 0.004-0.232 0.014 -0.731 0.52-1.209 1.379-1.209 2.346 0 0.514 0.135 0.996 0.372 1.414 0.314 0.191 0.675 0.304 1.069 0.304 1.124 0 2.036-0.913 2.036-2.039C497.401 419.858 496.489 418.944 495.365 418.944'/%3E %3Cpath fill='none' stroke='%239E7800' d='M495.365 418.944c-0.079 0-0.158 0.004-0.232 0.014 -0.731 0.52-1.209 1.379-1.209 2.346 0 0.514 0.135 0.996 0.372 1.414 0.314 0.191 0.675 0.304 1.069 0.304 1.124 0 2.036-0.913 2.036-2.039C497.401 419.858 496.489 418.944 495.365 418.944z'/%3E %3Cpath fill='%23FFF' d='M495.723 419.368c-0.537 0-0.974 0.435-0.974 0.973 0 0.537 0.436 0.972 0.974 0.972 0.535 0 0.974-0.435 0.974-0.972C496.696 419.803 496.258 419.368 495.723 419.368'/%3E %3Cpath fill='%23806600' d='M494.059 441.269c-0.255-0.001-0.509 0.095-0.704 0.289 -0.1 0.103-0.176 0.22-0.225 0.35l-1.149 2.526c-0.12 0.269-0.111 0.563 0.003 0.814h-0.003l1.173 2.579c0.165 0.366 0.526 0.582 0.905 0.582C494.059 448.409 494.059 441.269 494.059 441.269z'/%3E %3Cpath fill='%23FF083C' d='M496.415 444.852l-2.579-2.578 -1.174 2.578 1.174 2.579L496.415 444.852z'/%3E %3Cpath fill='%23BA0028' d='M496.415 444.852h-3.753l1.174 2.579L496.415 444.852z'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='469.496' cy='418.747' r='2.287'/%3E %3Ccircle fill='%23FFF' cx='469.085' cy='418.041' r='0.975'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='458.079' cy='442.665' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='457.793' cy='442.174' r='0.677'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='458.079' cy='447.518' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='457.793' cy='447.026' r='0.677'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='481.16' cy='442.665' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='480.874' cy='442.174' r='0.677'/%3E %3Ccircle fill='%23CCC' stroke='%239E7800' stroke-width='0.5' cx='481.16' cy='447.518' r='1.668'/%3E %3Ccircle fill='%23FFF' cx='480.874' cy='447.026' r='0.677'/%3E %3C/g%3E %3Cuse xlink:href='%23t3' x='-49.151' y='-55.104'/%3E %3Cuse xlink:href='%23t3' x='49.151' y='-55.104'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='300' viewBox='0 0 15 10'%3E %3Crect fill='%23E8112D' width='15' height='10'/%3E %3Crect fill='%23FCD116' width='15' height='5'/%3E %3Crect fill='%23008751' width='6' height='10'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='500' height='300'%3E %3Cdefs%3E %3Cg id='b' fill='%231eb53a'%3E %3Cg id='s'%3E %3Cg id='t'%3E %3Cg id='c'%3E %3Cpath id='h' d='M0,-20V0H20' transform='rotate(30,0,-20)'/%3E %3Cuse xlink:href='%23h' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(120)'/%3E %3Cuse xlink:href='%23c' transform='rotate(240)'/%3E %3C/g%3E %3Cuse xlink:href='%23t' transform='rotate(180)'/%3E %3C/g%3E %3Cuse xlink:href='%23s' fill='%23ce1126' transform='scale(0.82)'/%3E %3C/g%3E %3Cuse id='star' xlink:href='%23b' x='250' y='106'/%3E %3C/defs%3E %3Cpath d='M0,0H500L0,300H500z' fill='%23ce1126'/%3E %3Cpath d='M0,0V300L500,0V300z' fill='%231eb53a'/%3E %3Cpath d='M0,0 500,300M500,0 0,300' stroke='%23fff' stroke-width='40'/%3E %3Ccircle cx='250' cy='150' r='85' fill='%23fff'/%3E %3Cuse xlink:href='%23star'/%3E %3Cuse xlink:href='%23star' transform='rotate(120,250,150)'/%3E %3Cuse xlink:href='%23star' transform='rotate(240,250,150)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1500' height='900' viewBox='0 0 150 90'%3E %3Cpath d='M0,0H150V90H0' fill='%23fff'/%3E %3Cpath fill='%23ce1126' d='M150,0 37,0l23,9 -23,9 23,9 -23,9 23,9 -23,9 23,9 -23,9 23,9 -23,9H150'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='600' viewBox='0 0 5 3'%3E %3Crect width='5' height='3' fill='%23fff'/%3E %3Crect width='5' height='2' y='1' fill='%2300966E'/%3E %3Crect width='5' height='1' y='2' fill='%23D62612'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg version='1.0' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='900' height='600'%3E %3Crect width='900' height='600' fill='%23009e49'/%3E %3Crect width='900' height='300' fill='%23ef2b2d'/%3E %3Cg transform='translate(450,300)' fill='%23fcd116'%3E %3Cg id='c'%3E %3Cpath id='t' d='M 0,-100 V 0 H 50' transform='rotate(18 0,-100)'/%3E %3Cuse xlink:href='%23t' transform='scale(-1,1)'/%3E %3C/g%3E %3Cuse xlink:href='%23c' transform='rotate(72)'/%3E %3Cuse xlink:href='%23c' transform='rotate(144)'/%3E %3Cuse xlink:href='%23c' transform='rotate(216)'/%3E %3Cuse xlink:href='%23c' transform='rotate(288)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='450' height='390'%3E %3Crect fill='%23ED2939' width='450' height='390'/%3E %3Crect fill='%23FAE042' width='300' height='390'/%3E %3Crect width='150' height='390'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='500' height='300' viewBox='0 0 20 12'%3E%3Crect width='20' height='12' fill='%23006a4e'/%3E%3Ccircle cx='9' cy='6' r='4' fill='%23f42a41'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1' width='1500' height='1000' viewBox='0 0 24000 16000'%3E %3Ctitle%3EFlag of Barbados%3C/title%3E %3Crect width='24000' height='16000' fill='%2300267f' /%3E %3Crect width='8000' height='16000' fill='%23ffc726' x='8000' /%3E %3Cpath id='h' fill='%23000' d='M 12000,4124 C 11740,4833 11475,5571 10908,6136 C 11084,6078 11392,6026 11590,6031 L 11590,9013 L 10748,9138 C 10718,9135 10708,9088 10708,9024 C 10627,8098 10408,7320 10156,6515 C 10138,6405 9819,5985 10065,6059 C 10095,6063 10424,6197 10372,6133 C 9924,5669 9269,5335 8633,5236 C 8577,5222 8544,5250 8594,5315 C 9438,6614 10144,8147 10138,9966 C 10466,9966 11261,9772 11590,9772 C 11590,9772 11590,11876 11590,11876 L 12005,11876 12100, 6000 z'/%3E %3Cuse xlink:href='%23h' transform='translate(24000,0) scale(-1,1)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='800' height='400' viewBox='0 0 16 8'%3E%3Crect width='16' height='8' fill='%23002395'/%3E%3Cpath d='m4.24,0h8v8z' fill='%23fecb00'/%3E%3Cg id='g'%3E%3Cpath d='M2.353283,0.5248529 2.8,-0.85 3.246717,0.524853 2.077197,-0.324853H3.522803z' fill='%23fff' id='s'/%3E%3Cuse xlink:href='%23s' x='1' y='1'/%3E%3Cuse xlink:href='%23s' x='2' y='2'/%3E%3C/g%3E%3Cuse xlink:href='%23g' x='3' y='3'/%3E%3Cuse xlink:href='%23g' x='6' y='6'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3Crect width='1200' height='600' fill='%233f9c35'/%3E %3Crect width='1200' height='400' fill='%23ed2939'/%3E %3Crect width='1200' height='200' fill='%2300b9e4'/%3E %3Ccircle cx='580' cy='300' r='90' fill='%23fff'/%3E %3Ccircle cx='600' cy='300' r='75' fill='%23ed2939'/%3E %3Cpath d='M680,250 689.567,276.903 715.355,264.645 703.097,290.433 730,300 703.097,309.567 715.355,335.355 689.567,323.097 680,350 670.433,323.097 644.645,335.355 656.903,309.567 630,300 656.903,290.433 644.645,264.645 670.433,276.903 680,250z' fill='%23fff'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='520' height='340' viewBox='0 0 260 170'%3E %3Crect fill='%230053A5' width='260' height='170'/%3E %3Cg fill='%23FFCE00'%3E %3Crect x='80' width='50' height='170'/%3E %3Crect y='60' width='260' height='50'/%3E %3C/g%3E %3Cg fill='%23D21034'%3E %3Crect x='95' width='20' height='170'/%3E %3Crect y='75' width='260' height='20'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600' viewBox='0 0 27 18'%3E %3Cpath fill='%234189DD' d='M0,0h27v18H0V0z'/%3E %3Cpath fill='%23F9D616' d='M0,12h27v1H0v1h27v1H0V12z'/%3E %3Cpolygon fill='%23D21034' stroke='%23FFF' stroke-width='0.2' stroke-miterlimit='10' points='4.625,3.375 4,1.349609 3.375,3.375 1.349609,4 3.375,4.625 4,6.650391 4.625,4.625 6.650391,4'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1280' height='640' viewBox='0 0 10080 5040'%3E %3Cdefs%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V1.5H7V3H6zM6,0H3V3.5H0V3z'/%3E %3C/clipPath%3E %3Cpath id='Star7' d='M0,-360 69.421398,-144.155019 281.459334,-224.456329 155.988466,-35.603349 350.974048,80.107536 125.093037,99.758368 156.198146,324.348792 0,160 -156.198146,324.348792 -125.093037,99.758368 -350.974048,80.107536 -155.988466,-35.603349 -281.459334,-224.456329 -69.421398,-144.155019z'/%3E %3Cpath id='Star5' d='M0,-210 54.859957,-75.508253 199.721868,-64.893569 88.765275,28.841586 123.434903,169.893569 0,93.333333 -123.434903,169.893569 -88.765275,28.841586 -199.721868,-64.893569 -54.859957,-75.508253z'/%3E %3Cuse id='Cstar' xlink:href='%23Star7' transform='scale(2.1)'/%3E %3C/defs%3E %3Cg transform='scale(840)'%3E %3Crect width='12' height='6' fill='%2300008b'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23fff' stroke-width='0.6'/%3E %3Cpath d='M0,0 6,3M6,0 0,3' stroke='%23f00' stroke-width='0.4' clip-path='url(%23c)'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23fff'/%3E %3Cpath d='M3,0V3.5M0,1.5H7' stroke='%23f00' stroke-width='0.6'/%3E %3Cpath d='M0,3H6V0H8V4H0z' fill='%2300008b'/%3E %3C/g%3E %3Cg fill='%23fff'%3E %3Cuse id='Comwlth' xlink:href='%23Cstar' x='2520' y='3780'/%3E %3Cuse id='αCrucis' xlink:href='%23Star7' x='7560' y='4200'/%3E %3Cuse id='βCrucis' xlink:href='%23Star7' x='6300' y='2205'/%3E %3Cuse id='γCrucis' xlink:href='%23Star7' x='7560' y='840'/%3E %3Cuse id='δCrucis' xlink:href='%23Star7' x='8680' y='1869'/%3E %3Cuse id='εCrucis' xlink:href='%23Star5' x='8064' y='2730'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='900' height='600'%3E %3Crect fill='%23ed2939' width='900' height='600'/%3E %3Crect fill='%23fff' y='200' width='900' height='200'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1000' height='500'%3E %3Crect height='500' width='1000' fill='%23006'/%3E %3Cpath d='M0,250 1000,0V500z' fill='%23bd1021'/%3E %3Cpath d='M107.14,250 1000,26.79V473.21' fill='%23fff'/%3E %3Cg stroke='%23000' stroke-width='1.72'%3E %3Cpath d='m832.04,306.06s-6.2429-5.108,1.135-13.337c-3.973-3.4049-0.2834-9.9312-0.2834-9.9312s-6.8111-2.5547,0.2834-13.054c-5.108-3.4049-2.8381-11.068-2.8381-11.068s-16.742-6.2429-0.85018-12.201c-13.054,5.6748-25.257-7.6626-25.257-7.6626l-19.012,0.56816c-3.2161-15.797-28.283-2.0814-9.6482-47.39-4.8242-0.85142-10.216-2.27-15.607,1.7027-5.3916,3.9728-20.715,12.486-29.796,3.9728-9.0806-8.5131,5.9593-20.715,6.2431-20.999,0.28367-0.2838,20.148-10.5,22.986-17.31-0.28381-5.108-6.5269-9.0806-0.85142-20.148,6.5267-10.5,46.538-20.432,64.701-23.837,8.7962-3.9728,12.769-11.635,12.769-11.635l1.9865,7.378s40.296-11.918,42.282-17.594c1.9865-5.6755,0.85156,5.1078,0.85156,5.1078,15.891-1.4189,36.038-15.04,38.876-8.7969,13.337-2.5539,38.877-13.905,38.877-13.905s8.7962-0.28364,2.5533,9.3646c3.973,6.2429-1.135,11.635-1.4184,11.635-0.28477,0,1.7017,6.2429-3.4062,9.6482,1.7045,5.3916-3.1215,9.6482-3.1215,9.6482s2.2713,6.5267-6.8097,9.932c0.85157,5.6755-5.108,6.8106-5.108,6.8106s0.85156,5.9593-3.1215,8.5131c0,4.5404-4.5398,6.8106-4.5398,6.8106s2.8367,1.7026-1.1363,4.5404c-3.9716,2.8377-45.119,28.093-45.119,27.81,0-0.28366,30.08,5.3917,32.066,6.5268,1.9865,1.1351,24.688,16.175,24.688,16.175l-22.987,28.377s-25.539-2.8367-26.673-1.4184c-1.135,1.4184,5.3914,1.9865,6.8097,4.2564,1.4197,2.2699,3.6896,7.6627,8.2294,7.0945,4.5412-0.56816-8.5129,8.2295-17.026,9.081,0,3.1215,10.783,3.4049,13.621,0.85155,2.8381-2.5547-6.8111,7.3779-7.9461,8.7962s12.771-1.9865,12.771-1.9865-2.2713,9.3644-14.472,12.202c4.8232,7.946,2.8367,13.054,2.5533,13.054-0.28339,0-7.946-7.946-15.324-6.5277,1.9865,7.6627,7.9461,14.756,9.6492,15.892,1.7017,1.135-13.337,0.85018-15.324-3.4062-1.9865-4.2564-3.6896,10.216,1.7018,14.757-6.2416,0.2834-11.634-3.4062-11.634-3.4062s-3.6882,8.5128-1.135,12.771c2.5547,4.2564-8.7962-8.5142-8.7962-8.5142l-21.567,9.081-4.8246-8.2294z' fill='%239c3900' stroke-linejoin='round'/%3E %3Cg fill='%23ffc221'%3E %3Cpath d='m665.36,289.17c0.50543,0,31.331-0.50627,45.48-8.5913,7.0747,11.117,16.676,18.697,16.676,18.697l4.5481-16.17s11.117,0.50489,12.128,3.032c-1.516,3.0307-2.0213,7.0739-2.0213,7.0739s7.58,0.50627,8.0853,1.516c0.5053,1.0111-2.0213,9.601-2.0213,9.601l32.342,7.5801s2.5266-12.633,5.0532-11.117c2.5268,1.516,13.644,17.181,29.31,18.192,15.665,1.0111,16.676-13.139,16.676-13.139l3.5369,2.0223s6.569-14.149,7.5801-14.149,2.5272,2.0209,11.117,2.0209c2.5272,3.032,3.5383,10.106,3.5383,10.106s-9.6024,9.6024-6.5704,17.183c3.032,7.5801,3.5383,5.5578,3.5383,5.5578l69.736,16.676s3.5383,5.5592-2.5258,8.5913c0,0.50489-70.242-16.171-70.242-16.171s-6.5704,7.5801-11.623,6.0641c-5.053-1.516-1.516,3.032-1.516,3.032l75.8,6.0641s5.5592,7.0752,1.516,9.0962c-5.053,0.50488-81.864-5.053-81.864-5.053s-4.5481,9.601-9.601,1.516c-3.5369,5.5578-7.5801-1.516-7.5801-1.516s-6.569,5.053-7.5801-0.50626c-5.5592,4.0432-9.0961-2.5258-9.0961-2.5258l-32.341-2.0223-2.0213,3.032s5.5587,1.516-3.032,5.0543c-8.5907,3.5369,51.544,2.0209,53.06,2.5258,1.516,0.50625-4.0418,5.0543-4.0418,5.0543s30.825,2.0209,36.383-4.5481c5.5592-6.5703-2.0209,8.5899-2.0209,8.5899s24.256-1.0098,24.256-2.0209-0.50626,7.5801-17.181,6.569c10.106,6.5704,22.739,10.612,22.739,10.612s-12.633,3.032-27.287-0.50488c2.5258,6.569,13.644,12.633,13.644,12.633s-8.0864,7.0752-26.279-10.107c5.0543,9.0962,1.0111,12.634,0.50625,11.623-0.50625-1.0111-9.0961-13.644-29.309-18.192,12.633,8.085,7.0739,11.623,7.0739,11.623s-6.569-11.623-17.181,0c-4.0432-10.612-19.708-16.676-38.911-17.687-6.064-7.0739-9.6014-5.0529-23.751-9.0961-8.0853-9.0948-19.708-19.202-19.708-19.202s0.5053-13.644,14.149-12.128c1.516,4.5481,1.516,3.032,1.516,3.032s15.16-5.5592,19.708,2.0209c6.5692-11.623,15.665-1.7375,17.181,2.3043,4.3537,0.63832,26.278,1.2326,26.278,1.2326s-2.5272-4.5481-1.0112-4.0418c1.516,0.50488,13.644-4.5481,13.139-6.0641-0.50625-1.516-1.0111-6.569,1.0098-6.0641,2.0223,0.50489-17.181-2.5272-27.793,5.5592-3.5373-3.5383-1.0106-13.139-1.0106-13.139l-31.331-6.569-1.516,8.085s-9.096,1.516-8.5907-0.50487c0.50529-2.0223-2.0213,7.0739-2.0213,7.0739s-12.128-3.0321-12.128-3.5369c0-0.50489,3.5374-18.192,3.5374-17.687,0,0.50626-10.107,1.0112-24.256,11.623-4.0426-12.633-35.879-29.309-35.879-29.814z'/%3E %3Cpath d='m704.78,247.73s-21.224,18.191,0,28.803c1.0106-7.0752,2.5268-8.085,2.5268-8.085s17.687,6.569,28.299-9.0961c-4.5481-6.569-12.633-4.0418-12.633-4.0418s-16.676-0.001-18.192-7.5801z'/%3E %3C/g%3E %3Cpath d='m722.47,255.82-14.655,12.633' fill='none'/%3E %3Cg fill='%23fff'%3E %3Cpath d='m705.48,247.88,0,0s2.8377-2.8381,3.6891-6.2429c0.85129-3.4049-1.1351-7.0945,2.2702-10.216,3.4051-3.1215,48.241-22.134,51.93-25.823,3.6891-3.6888,10.499-11.634,11.351-13.337,0.85129-1.7027,3.4053,8.5131-4.2566,13.054,8.2293-2.2707,13.621-4.8243,17.026-3.6892-3.4058,4.8242-12.486,12.77-16.743,12.77,9.932-3.6896,19.012-6.8111,21.567-4.8246,2.5533,1.9865-12.202,11.919-18.162,12.486,9.932-2.5533,23.27-6.5263,24.971-2.2699-5.3914,1.7031-3.6896,3.1201-14.756,9.3644-1.4188,1.1363-8.5131,1.4184-8.5131,1.4184,8.5131-0.85156,20.147-4.2564,21.282,1.9865-6.8097,2.5533-9.3639,5.9595-15.039,7.3779-5.6755,1.4197-18.729,3.973-26.675,7.0945-7.9455,3.1215-19.58,12.202-19.58,12.202s-25.256,0.85155-25.256,0.56678c0-0.28339-4.824-11.634-5.1078-11.918z' stroke-linejoin='round'/%3E %3Cpath d='m921.99,230.57,49.092,9.3644s5.3928-6.2429,2.5547-9.6478c7.3779-1.7017,5.3914-11.351,5.3914-11.351s8.5128-3.6883,1.4183-12.202c4.826-4.8239-1.135-8.5128-1.135-8.5128s1.9865-8.5131-4.2564-9.3644c1.7031-6.8104-10.783-9.0807-10.783-9.0807s-25.823,7.0944-43.985,7.6618c5.9595,5.9593-2.2699,9.6482-2.2699,9.6482s4.8246,3.4053,3.4049,6.2429c-1.4183,2.8382,0.85157,5.9597-5.3914,7.9462,8.2294,3.6896-0.85156,9.9312-0.85156,9.9312s9.081,6.2429,6.8111,9.3644z'/%3E %3C/g%3E %3Cg fill='none'%3E %3Cpath d='m742.17,293.72-6.5694,29.309'/%3E %3Cpath d='m748.24,304.83-2.0213,9.601'/%3E %3Cpath d='m780.58,312.41-3.032,9.0962'/%3E %3Cpath d='m836.67,374.06c-0.50489,0-16.17,2.0209-18.192,1.516-2.0209-0.50489,24.761,8.085,24.761,11.622'/%3E %3Cpath d='m808.37,377.6s-15.666-10.106-18.192-9.0961c-2.5269,1.0111,15.665-0.50489,17.181-2.0209'/%3E %3Cpath d='m776.03,365.98s-16.171,0.50488-17.687-1.0111,15.665,11.117,18.697,10.107'/%3E %3Cpath d='m744.7,358.9c-0.5053,0-11.117-4.0418-15.665-5.0543,4.0426,4.0432,7.0747,9.6024,17.181,11.623'/%3E %3Cpath d='m748.74,352.34c-0.50529-1.0111-20.213-7.0752-20.213-10.107,4.5481,1.516,11.117,3.5369,17.181,2.0209'/%3E %3Cpath d='m853.35,329.09-2.0209,9.0948'/%3E %3Cpath d='m767.6,343.56s3.3779,3.724,0.34585,8.2721'/%3E %3Cpath d='m838.69,347.28-5.5578,0.50625'/%3E %3Cpath d='m793.21,344.25,10.106,1.516'/%3E %3Cpath d='m820.4,318.26s0.2834,10.216-8.2294,9.9326c-8.5128-0.28477-5.6762,0.2834-5.6762,0.2834'/%3E %3Cpath d='m826.93,316.55s3.4049,1.135,2.5547,3.6896c-0.85155,2.5533,0.85018,9.9312-9.081,17.026-10.501,2.2699-9.3644-8.7962-9.3644-8.7962'/%3E %3Cpath d='m830.62,319.68s6.2429-3.6883,7.0945,2.2713c0.85018,5.9582-5.108,17.026-9.3644,18.729-4.2578,1.7018-9.081-0.28476-8.5142-3.1215'/%3E %3Cpath d='m838.28,322.23s5.6762-4.5412,7.3779,1.4184c1.7031,5.9596-4.5398,19.297-7.0945,19.58'/%3E %3Cpath d='m846.23,323.65s2.8381-1.4184,4.8232,0.28339'/%3E %3Cpath d='m837.15,344.08c-1.135,0.28339-5.9595,0.56678-7.6613-3.1215'/%3E %3Cpath d='m811.61,334.15c-0.28339,0-5.9582,0.28476-5.9582,0.28476'/%3E %3Cpath d='m833.46,356.57-0.56679-9.3644-2.2699-3.1215-3.973,3.973s-0.56816,9.3644-2.2699,10.216'/%3E %3Cpath d='m826.65,347.77c-0.28339-0.56678-3.1215-5.9582-3.1215-5.9582l-4.8246,5.9582s-0.5668,8.5142-2.2699,9.3658'/%3E %3Cpath d='m818.7,347.49c0-0.28339-1.9865-5.6748-1.9865-5.6748s-5.6748,3.1215-6.2429,5.3914c-0.56679,2.2699-0.85156,8.5128-2.2699,9.081'/%3E %3Cpath d='m810.47,346.07s0.56816-5.108-1.135-5.108c-1.7018,0-9.3644,7.0945-9.6478,13.337'/%3E %3Cpath d='m717.39,245.9s0.28382-5.6748,2.8377-7.6613c2.554-1.9865,15.324-6.8111,18.161-11.068,2.8377-4.2564-4.2566,7.3779-3.1215,10.499'/%3E %3Cpath d='m722.5,237.38s6.2431,2.2713,4.8242,7.0945'/%3E %3Cpath d='m57.344,126.01a3.9192,3.9192,0,1,1,-7.8384,0,3.9192,3.9192,0,1,1,7.8384,0z' transform='matrix(1.1946929,0,0,1.1946929,661.37184,90.106184)' stroke-width='1pt'/%3E %3Cpath d='m917.17,220.07,0,0s43.417,5.108,45.404,5.108c1.9865,0,9.6478,2.5547,11.068,5.108'/%3E %3Cpath d='m919.44,217.52,60.443,1.4184'/%3E %3Cpath d='m919.72,216.1s57.321-3.4049,61.294-9.3644'/%3E %3Cpath d='m921.43,203.61s57.606-6.2429,58.174-5.3916'/%3E %3Cpath d='m919.44,196.52s55.903-8.7969,56.47-7.378'/%3E %3Cpath d='m759.96,160.48s17.594,19.296,15.891,32.35'/%3E %3Cpath d='m774.72,182.61s5.6753,8.2293,7.9455,9.0806c2.2702,0.85128,22.134,1.9864,23.269,10.5,1.135,5.3916-4.2564,3.6885-3.4049,7.6616,1.4184,5.108,14.756,11.634,29.228,3.973'/%3E %3Cpath d='m818.42,217.8s11.918,17.594,29.512-1.4183'/%3E %3Cpath d='m838.85,224.05s14.472,7.6613,26.39-12.202'/%3E %3Cpath d='m849.92,225.75s7.0945,5.9596,21.852-1.9851'/%3E %3Cpath d='m892.2,215.82s21.85,4.5398,23.27,5.9596'/%3E %3Cpath d='m900.43,210.99c0.28339,0,15.324,0.56817,15.324,0.56817'/%3E %3Cpath d='m891.06,202.48s26.107-1.7026,29.513,3.6895'/%3E %3Cpath d='m879.71,194.25s36.607,1.4188,38.309,3.4053'/%3E %3Cpath d='m887.94,231.71s6.2429-1.7017,7.0945-0.85019'/%3E %3Cpath d='m873.75,247.03s8.2294,7.0945,18.73,3.973'/%3E %3Cpath d='m878.29,258.95s9.3644,4.2564,20.432,1.7018'/%3E %3Cpath d='m881.41,266.04s9.3644,6.2429,15.607,5.1066'/%3E %3Cpath d='m877.16,269.73s6.5263,4.8246,6.8097,7.3779'/%3E %3Cpath d='m868.08,275.41s1.9865,10.215,9.081,13.904'/%3E %3Cpath d='m863.25,279.95s-3.1215,13.337,4.8246,21.567'/%3E %3Cpath d='m855.02,290.45c0,0.28339-0.56679,6.2429-0.2834,6.8111'/%3E %3Cpath d='m803.94,238.8,15.324-0.85157s5.6748-2.2699,1.7017-5.9582'/%3E %3Cpath d='m822.96,235.4c0.28477,0,14.472,1.135,18.162,5.3914,3.6882,4.2564,8.2294,12.769,10.783,14.189,2.5547,1.4184,3.1215-0.56816,3.1215-0.56816'/%3E %3Cpath d='m848.78,252.14s-7.6613,13.054-1.7018,17.027'/%3E %3Cpath d='m844.52,266.61s-6.8097,9.081-1.4184,13.621'/%3E %3Cpath d='m841.69,279.1s-5.3914,8.7976,1.1363,14.756'/%3E %3Cpath d='m839.3,255.76c-0.36594,0.36594-6.591,4.7599-8.788,3.6621'/%3E %3Cpath d='m832.71,269.68s2.5629,2.5629,4.7599,2.197'/%3E %3Cpath d='m833.01,282.98,4.09,2.805'/%3E %3Cpath d='m833.56,293.17,3.5383,2.1351'/%3E %3Cpath d='m769.47,154.01s7.4602,3.8794,13.428,0c5.9688-3.8792,34.615-18.501,42.075-20.888,7.4591-2.3873,11.637-16.114,13.13-22.082'/%3E %3Cpath d='m832.44,127.15,41.777-12.235s6.8634-5.6697,7.1619-16.114'/%3E %3Cpath d='m878.39,110.14s41.776-4.1776,41.776-19.695'/%3E %3Cpath d='m913.6,101.19s43.866-11.936,48.044-16.412'/%3E %3Cpath d='m791.26,163.55s26.558-13.727,30.736-15.219c4.1766-1.4921,13.725-13.428-0.59705-13.428'/%3E %3Cpath d='m804.09,168.93c0.29852,0,21.783-14.025,28.945-15.815,3.8795-5.3712,1.7912-11.041-4.7737-9.8473'/%3E %3Cpath d='m834.82,149.53c0.59705-0.29839,11.638-0.59678,7.759,8.0569-5.6679,4.1776-30.139,16.412-30.139,16.412'/%3E %3Cpath d='m829.15,140.28,46.551-15.517s3.8795-8.0569-1.7898-9.2505'/%3E %3Cpath d='m912.71,101.49c0,0.29839,5.9692,3.5808,2.3882,8.9521-6.5648,3.8793-37.599,11.339-37.599,11.339'/%3E %3Cpath d='M959.85,96.712,915.99,108.95'/%3E %3Cpath d='m956.57,106.56-38.195,11.638'/%3E %3Cpath d='M953.29,116.11,919.57,126.25'/%3E %3Cpath d='m947.02,125.66c-0.89558,0-25.065,7.4602-25.065,7.4602'/%3E %3Cpath d='m941.65,133.12-15.518,6.2665'/%3E %3Cpath d='m937.77,141.47c-0.59705,0-13.428,5.6697-13.428,5.6697'/%3E %3Cpath d='m933.89,148.34-11.936,5.6695'/%3E %3Cpath d='m913.3,161.17s1.4926,0.59678,1.1941,2.3873'/%3E %3Cpath d='m883.16,177.58s5.0736,1.7903,0.29853,6.5649c-2.3868,3.2824-9.2502,2.3874-13.428,8.3553'/%3E %3Cpath d='m915.69,110.74s6.2677,1.4919,1.4926,9.5489c-12.534,4.7745-37.898,12.533-37.898,12.533s-1.1927,2.0889-4.4752,3.8793c-3.2824,1.7904-39.389,11.936-39.389,11.936'/%3E %3Cpath d='m917.78,119.99s6.8634,2.984,0,8.0569c-7.759,4.476-34.914,12.831-34.914,12.831s-0.29854,2.3871-1.4913,3.2824c-1.1941,0.89517-37.002,12.831-37.002,12.831'/%3E %3Cpath d='m919.57,128.04s7.1619,2.0889,0.89558,8.0568c-7.4604,4.4761-31.333,12.533-31.333,12.533s-2.3868,2.9839-6.2663,4.1776c-3.8795,1.1936-28.646,11.339-28.646,11.339'/%3E %3Cpath d='m921.36,136.1c2.0897,0.89517,7.759,1.7905,0.89559,7.1618-8.0561,3.5808-27.751,11.339-27.751,11.339l-1.7912,3.2824-31.332,13.428'/%3E %3Cpath d='m923.15,144.16s2.9839,3.581-3.581,7.7586c-7.1619,3.8792-22.678,9.8473-22.678,9.8473'/%3E %3Cpath d='m919.57,152.51s3.2824,2.0889-0.8942,5.0729c-4.7751,2.3873-23.574,12.235-23.574,12.235l-12.236,8.0569'/%3E %3Cpath d='m876.6,125.06c0,0.29839,5.0736,4.4761,3.2824,9.2505,4.4765,3.2824,3.581,6.8634,3.581,6.8634s6.2663,3.5808,5.3721,8.6537c6.2663,1.4921,5.9678,5.0729,5.9678,5.0729l-2.0897,3.2824s6.2663-0.29839,0.89558,7.7586c3.2824,1.7905,1.7912,3.8792,1.7912,3.8792'/%3E %3Cpath d='m893.61,166.24c-0.89558,0-21.783,7.7586-27.155,12.533'/%3E %3Cpath d='m843.18,156.99s6.2663-0.29839,5.3721,6.5648c7.1619-2.3873,5.6693,4.476,5.6693,4.476s8.3546-3.2824,6.8634,7.1618c5.3707-1.1936,4.4752,4.1776,4.4752,4.1776s4.7751-0.29839,4.7751,2.3873c3.2824-2.984,6.8634-1.492,6.8634-1.492s2.3868-3.2826,5.6693-2.3872'/%3E %3Cpath d='m848.85,163.26c0,0.59706-28.051,16.114-28.051,16.114'/%3E %3Cpath d='m854.22,168.33-21.187,13.13'/%3E %3Cpath d='m861.38,174.89c0,0.29839-18.502,11.041-18.502,11.041'/%3E %3Cpath d='m865.56,179.07s-13.13,10.743-16.114,10.146'/%3E %3Cpath d='m870.04,182.35s-7.4604,5.6698-13.727,8.3553'/%3E %3Cpath d='m877.79,179.97s2.3868,2.984-12.533,10.742'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg width='800' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.0' height='500'%3E %3Crect width='800' fill='%2374acdf' height='500'/%3E %3Crect y='166.67' width='800' fill='%23fff' height='166.67'/%3E %3Cg id='rays'%3E %3Cpath id='ray1' stroke-width='1.1116' stroke='%2385340a' fill='%23f6b40e' d='m396.84 251.31l28.454 61.992s0.4896 1.185 1.28 0.8586c0.7902-0.3267 0.2988-1.5116 0.2988-1.5116l-23.715-63.956m-0.68 24.12c-0.3465 9.4278 5.4526 14.613 4.6943 23.032-0.7569 8.42 3.8673 13.18 4.9396 16.454 1.0733 3.2744-1.16 5.2323-0.198 5.6982 0.96336 0.4662 3.07-2.1207 2.3833-6.7756-0.68675-4.6549-4.2204-6.0368-3.3898-16.32 0.83-10.283-4.206-12.678-2.98-22.058'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(22.5 400,250)'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(45 400,250)'/%3E %3Cuse xlink:href='%23ray1' transform='rotate(67.5 400,250)'/%3E %3Cpath id='ray2' fill='%2385340a' d='m404.31 274.41c0.45334 9.0538 5.5867 13.063 4.5787 21.314 2.2133-6.5249-3.1233-11.583-2.82-21.22m-7.6487-23.757l19.487 42.577-16.329-43.887'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(22.5 400,250)'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(45 400,250)'/%3E %3Cuse xlink:href='%23ray2' transform='rotate(67.5 400,250)'/%3E %3C/g%3E %3Cuse xlink:href='%23rays' transform='rotate(90 400,250)'/%3E %3Cuse xlink:href='%23rays' transform='rotate(180 400,250)'/%3E %3Cuse xlink:href='%23rays' transform='rotate(270 400,250)'/%3E %3Ccircle r='27.778' stroke='%2385340a' cy='250' cx='400' stroke-width='1.5' fill='%23f6b40e'/%3E %3Cpath id='loweyecontour' fill='%23843511' d='m409.47 244.06c-1.8967 0.00003-3.7131 0.82183-4.7812 2.5312 2.1367 1.9227 6.8565 2.1318 10.062-0.21875-1.3883-1.4954-3.3845-2.3125-5.2812-2.3125zm-0.0312 0.4375c1.8462-0.0335 3.5717 0.81446 3.8125 1.6562-2.1367 2.3504-5.5508 2.1463-7.6875 0.4375 0.9348-1.4957 2.4391-2.0677 3.875-2.0938z'/%3E %3Cuse xlink:href='%23uppalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cuse xlink:href='%23eyebrow_nose' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cuse xlink:href='%23pupil' transform='translate(18.862)'/%3E %3Cuse xlink:href='%23lowpalpebra' transform='matrix(-1 0 0 1 800.25 0)'/%3E %3Cpath d='m395.75 253.84c-0.91341 0.16668-1.5625 0.97727-1.5625 1.9062 0 1.0614 0.87748 1.9062 1.9375 1.9062 0.62667 0 1.2025-0.2968 1.5625-0.8125 0.73952 0.55614 1.7646 0.61511 2.3125 0.625 0.0843 0.002 0.19312 0 0.25 0 0.54791-0.01 1.573-0.0689 2.3125-0.625 0.36 0.5157 0.93583 0.8125 1.5625 0.8125 1.06 0 1.9375-0.84488 1.9375-1.9062 0-0.92898-0.64918-1.7396-1.5625-1.9062 0.513 0.1809 0.84375 0.6765 0.84375 1.2188 0 0.7074-0.57124 1.2812-1.2812 1.2812-0.6804 0-1.2413-0.54015-1.2812-1.2188-0.20862 0.41637-1.0341 1.6551-2.6562 1.7188-1.6222-0.0636-2.4476-1.3024-2.6562-1.7188-0.04 0.6786-0.60085 1.2188-1.2812 1.2188-0.71001 0-1.2812-0.57385-1.2812-1.2812 0-0.54225 0.33075-1.0378 0.84375-1.2188z' fill='%2385340a'/%3E %3Cpath d='m397.84 259.53c-2.138 0-2.9829 1.9368-4.9062 3.2188 1.0687-0.42633 1.9096-1.2693 3.4062-2.125 1.496-0.85442 2.7717 0.1875 3.625 0.1875h0.0312c0.8532 0 2.129-1.0416 3.625-0.1875 1.4967 0.8559 2.3688 1.6987 3.4375 2.125-1.9233-1.282-2.7996-3.2188-4.9375-3.2188-0.4266 0-1.2716 0.23055-2.125 0.65625h-0.0312c-0.85334-0.42642-1.6983-0.65625-2.125-0.65625z' fill='%2385340a'/%3E %3Cpath d='m397.12 262.06c-0.8439 0.0374-1.9596 0.20675-3.5625 0.6875 3.8473-0.85434 4.6962 0.4375 6.4062 0.4375h0.0312c1.71 0 2.5588-1.292 6.4062-0.4375-4.2744-1.282-5.1242-0.4375-6.4062-0.4375h-0.0312c-0.80125 0-1.4372-0.3124-2.8438-0.25z' fill='%2385340a'/%3E %3Cpath d='m393.75 262.72c-0.24819 0.003-0.51871 0.005-0.8125 0.0312 4.488 0.42766 2.3306 3 7.0312 3h0.0312c4.7007 0 2.5745-2.5724 7.0625-3-4.7007-0.4266-3.2146 2.3438-7.0625 2.3438h-0.0312c-3.6075 0-2.4959-2.4215-6.2188-2.375z' fill='%2385340a'/%3E %3Cpath d='m403.85 269.66c0-2.1234-1.7233-3.8465-3.8463-3.8465-2.1233 0-3.8463 1.723-3.8463 3.8465 0.423-1.781 2.0166-3.0393 3.8463-3.0393 1.8333 0 3.424 1.2586 3.8463 3.0393v0 0z' fill='%2385340a'/%3E %3Cpath id='eyebrow_nose' fill='%2385340a' d='m382.73 244.02c4.9146-4.2729 11.11-4.9147 14.53-1.7086 0.837 1.1207 1.3733 2.319 1.5934 3.5696 0.4302 2.433-0.3303 5.0617-2.2367 7.7559 0.2151-0.001 0.6435 0.2124 0.8568 0.4266 1.6967-3.244 2.2967-6.5761 1.74-9.7454-0.1458-0.828-0.3735-1.643-0.6696-2.4357-4.7007-3.8452-11.11-4.2729-15.811 2.1377z'/%3E %3Cpath id='uppalpebra' fill='%2385340a' d='m390.42 242.74c2.7767 0 3.4186 0.6417 4.7007 1.71 1.2833 1.0683 1.9233 0.8541 2.1367 1.0683 0.2124 0.2142 0 0.8541-0.4266 0.6399s-1.2833-0.6399-2.5633-1.7086c-1.2833-1.0696-2.5633-1.0683-3.8463-1.0683-3.8463 0-5.983 3.2046-6.4094 2.9907-0.4266-0.2142 2.1367-3.6325 6.4094-3.6325z'/%3E %3Cuse xlink:href='%23loweyecontour' transform='translate(-19.181)'/%3E %3Ccircle id='pupil' cy='246.15' cx='390.54' r='1.923' fill='%2385340a'/%3E %3Cpath id='lowpalpebra' fill='%2385340a' d='m385.29 247.44c3.6327 2.7783 7.265 2.5644 9.4017 1.282 2.1367-1.282 2.1367-1.7086 1.71-1.7086-0.4266 0-0.8532 0.4266-2.5633 1.281-1.71 0.8559-4.273 0.8559-8.546-0.8541z'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3C!-- Created with Inkscape (http://www.inkscape.org/) --%3E %3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.0' width='267' height='267' id='svg2'%3E %3Ctitle id='title4'%3EAntarctic Treaty System flag%3C/title%3E %3Cmetadata id='metadata33'%3E %3Crdf:RDF%3E %3Ccc:Work rdf:about=''%3E %3Cdc:format%3Eimage/svg+xml%3C/dc:format%3E %3Cdc:type rdf:resource='http://purl.org/dc/dcmitype/StillImage' /%3E %3Cdc:title%3EAntarctic Treaty System flag%3C/dc:title%3E %3C/cc:Work%3E %3C/rdf:RDF%3E %3C/metadata%3E %3Cdefs id='defs6'%3E %3Cg id='lines' style='fill:none'%3E %3Ccircle cx='133.5' cy='133.5' r='49.5' id='circle9' /%3E %3Ccircle cx='133.5' cy='133.5' r='92.5' id='circle11' /%3E %3Ccircle cx='133.5' cy='133.5' r='133' id='circle13' /%3E %3Cpath d='M -100,133.5 H 367 M 133.5,-100 v 467' id='axes' /%3E %3Cuse transform='matrix(0.8660254,0.5,-0.5,0.8660254,84.635609,-48.864391)' id='use16' x='0' y='0' width='267' height='267' xlink:href='%23axes' /%3E %3Cuse transform='matrix(0.5,0.8660254,-0.8660254,0.5,182.36439,-48.864391)' id='use18' x='0' y='0' width='267' height='267' xlink:href='%23axes' /%3E %3C/g%3E %3Cpath d='m 146.39642,44.921091 -0.62414,-0.267304 0.62414,0.267304 z m 17.83255,176.420599 -2.40739,-1.42562 -7.13302,1.78204 -6.24138,-3.92046 0,1.51472 -1.51576,-2.04931 1.78325,-1.78204 -0.26749,-5.34606 2.05074,0 1.24828,-3.56408 1.4266,-0.62369 -1.15911,-1.78204 1.78325,-0.62369 -0.26748,-2.67305 -1.78326,-0.891 2.31823,-0.26731 -1.4266,-6.50441 -3.56652,-3.56405 -2.13991,0.89101 0.89163,2.94035 -7.40052,0 -6.24138,-2.67304 -2.40739,-1.15832 -11.85865,-2.67304 -0.89162,1.42563 -4.19065,0.35638 -1.15912,0 -1.78325,2.94035 -5.08228,-3.56408 -2.67488,0.89104 0.35665,2.40573 -6.598031,-3.56408 -0.26749,2.31663 -6.50889,-2.94032 -0.356652,0.26728 -3.20987,1.24742 -0.624139,-2.4057 -7.757141,-3.83136 -8.292116,-2.67305 -1.515767,-6.86082 0,-1.51472 -3.20987,-5.88068 1.426603,-7.1281 -2.674879,-0.89101 -0.891627,-3.02945 4.458122,-0.53459 -2.05074,0 0.267488,-4.45506 -6.508889,2.04932 -0.267488,-1.78201 -0.891627,3.29674 -3.566522,1.4256 -2.407394,-2.3166 -0.891627,-2.40577 -0.891628,-4.72236 2.050743,-1.51473 0.891627,1.15831 0.624137,-1.42559 -1.515764,-10.69218 2.407391,0.53461 1.159115,-11.22677 0.356652,-0.35641 2.318231,-1.42562 -2.94237,0.26731 -1.159113,-2.67304 5.349753,-5.96979 -4.814774,-0.89102 -3.566521,3.56407 -1.426604,-4.09865 -2.139906,2.94034 -0.534973,-2.04933 -2.674882,0.89102 -1.783255,0.89101 1.426603,-5.34607 -1.159112,-0.6237 0.624137,-1.51472 -1.515764,0.3564 -0.267488,-3.02946 5.617258,0 -0.267488,-1.42562 -1.783258,0 -3.299015,-5.702466 -1.783255,0.623709 -1.159115,-2.049329 -0.624137,1.782028 -1.783255,-1.247416 1.783255,-1.158315 -2.674882,-0.891014 0.624139,-1.514723 -2.1399,-1.158315 -0.53498,-4.72237 -2.1399,-0.623709 1.24827,-0.891014 -2.40739,-6.237081 0.26749,-2.049328 0.89163,-6.237084 1.78325,0 -0.53497,3.831353 4.458119,6.237084 3.20987,4.187761 6.598037,1.782027 0,0.267302 0.891628,-1.51472 3.566521,4.187761 1.783255,2.049326 0.891627,0.891013 10.07538,4.811459 1.783255,0.891013 0.624137,0.534606 4.725627,5.702472 2.67488,-1.24742 19.615777,-4.455046 0.62414,-3.564064 1.4266,0.623707 -0.26748,-1.158312 0.89162,-0.62371 4.190651,-1.514723 0,-4.098642 1.4266,-1.514723 1.78326,-6.860809 -0.89163,-2.673038 4.19065,-10.068437 0,-1.514723 0,-4.72237 2.05074,0 2.4074,-3.564064 2.94236,-0.891013 0.35665,-3.296745 4.10147,-4.989662 1.78326,0.891014 8.3813,-3.029456 0.89163,-0.891013 1.78325,-1.782025 -0.62414,-2.940342 1.78326,0 0.89163,4.72237 9.18374,2.138432 1.51577,-1.514723 0.62414,0.267304 8.02464,1.782028 0.26749,-0.267305 4.19065,-2.405736 0.26749,2.673038 3.56652,0.356405 2.94237,2.316633 0.62412,0.623709 4.45812,3.831354 5.34976,0.356408 3.29902,0.534605 4.10147,-1.425619 0.35665,2.673038 1.78328,1.158315 1.42658,-2.673038 1.78328,0 1.24829,6.860811 1.42656,0.267305 -0.26746,2.405733 -0.26753,0.267302 0.53499,0 3.56654,-1.782025 3.299,-1.158315 9.18376,3.207656 1.78324,-0.534606 0.62418,3.207659 2.40739,0.356405 -0.62418,-1.51472 2.05074,0 0.62417,3.296745 2.40739,-2.673038 5.61725,3.564066 1.51575,6.504404 -2.40738,0.623706 0.62417,4.989662 0.89158,1.51472 6.24139,15.770913 -3.29902,2.940335 -0.26746,3.56407 -2.67491,3.29674 2.9424,2.04933 -1.15913,0.89101 2.67488,2.67304 4.10147,0.62371 1.24829,1.78203 1.15909,2.31663 2.94237,1.24741 3.56655,-2.40573 2.40736,0.26731 -2.94234,4.18776 2.94234,7.75179 -3.56652,2.94034 1.51578,4.72237 -0.8916,4.18776 1.78321,2.40574 4.72564,0.891 -4.72564,6.50441 0.89164,1.15834 1.15912,1.24739 -2.05076,3.20767 2.05076,1.24741 -10.43202,8.55373 2.40739,5.96978 -0.62415,3.56408 -3.56654,1.15828 -0.89158,3.02946 -4.10147,1.78204 -1.24829,3.83136 -0.89163,2.04932 4.19066,2.13845 -6.2414,0.53459 1.51575,3.29674 -3.03153,2.94036 -4.72565,0.891 -1.51575,2.67305 3.56652,1.78201 -6.77635,6.23709 2.05073,3.29674 -5.34975,-1.15832 -5.97391,3.56408 -8.02463,3.83135 -1.78328,2.67305 -1.15909,-0.89101 1.15909,-2.67307 -5.34976,2.04932 -1.15909,-2.04932 -8.02464,4.72239 -3.56652,-1.15831 -6.50888,1.15831 -1.78327,-0.89103 m 0.26749,-172.232701 -0.62415,-0.623706 -0.26746,0 0,0.356404 0.62412,0 0.26749,0.267305 0,0 z m -2.05076,171.341841 1.78327,0.89101 -1.78327,-0.89101 z m 0,0 1.78327,0.89101 M 39.044473,98.738565 l 0.356652,-2.138429 -3.299019,-2.049329 2.94237,4.187761 -3e-6,0 z m -7.133017,-16.394636 -1.78325,0 0.89163,2.673035 0.89162,-2.316633 0,-0.356405 0,0 z m -0.89162,-2.673038 -0.89163,0.891014 1.78325,1.247418 -0.89162,-2.138432 z m 8.02464,19.067656 0.356652,-2.138429 -3.299022,-2.049329 2.942373,4.187761 0,0 z m -7.13301,-16.394636 -1.78326,0 0.89163,2.673035 0.89163,-2.31663 0,-0.356408 0,0 z m -0.89163,-2.673038 -0.89163,0.891013 1.78326,1.247419 -0.89163,-2.138432 z m 8.024643,19.067659 0.356652,-2.138432 -3.299015,-2.049326 2.942366,4.187761 -3e-6,0 z m -7.133013,-16.394639 -1.78325,0 0.89162,2.673038 0.89163,-2.316633 0,-0.356408 0,0 z m -0.89163,-2.673035 -0.89162,0.89101 1.78325,1.247419 -0.89163,-2.138429 z m 5.34976,-6.237084 0,-2.316633 -2.05075,0.534605 0.26749,1.514723 1.78326,0.267305 0,0 z m -2.31824,-6.504404 0.53498,1.158316 1.24828,-2.673039 -1.78326,1.247419 0,0.267304 0,0 z m 2.31824,6.504404 0,-2.316633 -2.05075,0.534605 0.26749,1.514723 1.78326,0.267305 0,0 z m -2.31824,-6.504404 0.53498,1.158316 1.24828,-2.673039 -1.78326,1.247419 0,0.267304 0,0 z m 2.31824,6.504404 0,-2.316633 -2.05075,0.534605 0.26749,1.514723 1.78326,0.267305 0,0 z m -2.31824,-6.504404 0.53498,1.158316 1.24828,-2.673039 -1.78326,1.247419 0,0.267304 0,0 z m 31.74199,90.88333 -2.050742,0.26734 -1.783255,2.4057 2.94237,-0.62369 0.891627,-2.04932 0,0 z m 0,0 -2.050742,0.26734 -1.783255,2.4057 2.94237,-0.62369 0.891627,-2.04932 0,0 z m 0,0 -2.050742,0.26734 -1.783255,2.4057 2.94237,-0.62369 0.891627,-2.04932 0,0 z m 2.139904,-60.321433 -0.62414,-0.534606 -1.783254,-0.891013 1.783254,0.891013 0.62414,0.534606 z' transform='translate(0,-1.5)' id='antarctica' style='fill:%23ffffff' /%3E %3CclipPath id='clip'%3E %3Cuse id='use22' x='0' y='0' width='267' height='267' xlink:href='%23antarctica' /%3E %3C/clipPath%3E %3C/defs%3E %3Crect width='267' height='267' x='0' y='0' id='fondo' style='fill:%23072b5f;fill-opacity:1' /%3E %3Cuse id='use25' style='stroke:%23ffffff;stroke-width:3;stroke-miterlimit:4;stroke-dasharray:none' x='0' y='0' width='267' height='267' xlink:href='%23lines' /%3E %3Cuse id='use27' x='0' y='0' width='267' height='267' xlink:href='%23antarctica' /%3E %3Cuse clip-path='url(%23clip)' id='use29' style='stroke:%23072b5f;stroke-width:3;stroke-miterlimit:4;stroke-opacity:1;stroke-dasharray:none' x='0' y='0' width='267' height='267' xlink:href='%23lines' /%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='450' height='300'%3E %3Crect width='450' height='300' fill='%23000'/%3E %3Crect width='450' height='150' fill='%23ce1126'/%3E %3Cg fill='%23f9d616'%3E %3Cpath d='M231.115,91.82A58.5,58.5 0 1,1 187.916,195.244L179.358,205.685A72,72 0 1,0 232.526,78.394z'/%3E %3Cg id='s3'%3E %3Cpath id='s' d='M302.62435,142.35494C303.12516,147.43953 303.12516,152.56101 302.62435,157.6456L287.69659,156.17534C288.10106,152.06855 288.10106,147.93196 287.69659,143.82518z'/%3E %3Cuse xlink:href='%23s' transform='rotate(22.5,225,150)'/%3E %3Cuse xlink:href='%23s' transform='rotate(45,225,150)'/%3E %3C/g%3E %3Cuse xlink:href='%23s3' transform='rotate(-67.5,225,150)'/%3E %3Cuse xlink:href='%23s3' transform='rotate(67.5,225,150)'/%3E %3Cpath d='M199.32444,114.65618H250.67551L209.1325,144.84033 224.99998,96.000328 240.86746,144.84033z'/%3E %3Cpath d='M287.87869,216.3146C291.71694,220.02891 296.88529,223.69038 300.6338,227.01716C304.38231,230.34392 307.25434,233.10958 309.57908,236.88884C312.98624,242.42773 309.16023,248.7008 303.85486,245.01872C300.98581,243.02751 299.18307,237.65214 294.78788,233.20395C291.53252,230.43267 288.96764,227.52745 280.78551,226.1257C280.39268,226.05841 280.27777,225.22842 280.58665,224.86618z'/%3E %3Cpath fill='%23000' d='M231.36058,197.84505 251.60791,209.8174 256.00949,226.89558 279.24991,225.13494 289.46162,213.16262 251.60791,186.9291 231.36058,197.84505z'/%3E %3Cpath d='M279.66324,223.6894C253.62799,206.37539 237.07238,197.02622 212.12131,182.83938C202.31974,177.26634 187.0985,163.25747 199.1052,139.81914C199.86106,155.20638 260.67394,197.4423 286.3703,215.80679z'/%3E %3Cpath fill='none' stroke='%23000' stroke-width='1.5' stroke-linecap='round' d='M216.08561,167.51949C236.13137,186.41034 261.37565,201.82127 283.89761,218.85496'/%3E %3Ccircle id='c' cx='290.4' cy='222.297' r='1.008' fill='%23000'/%3E %3Cuse xlink:href='%23c' x='7.41957' y='6.4655991'/%3E %3Cuse xlink:href='%23c' x='13.93812' y='13.090317'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3Crect fill='%23F2A800' width='1200' height='600'/%3E %3Crect fill='%230033A0' width='1200' height='400'/%3E %3Crect fill='%23D90012' width='1200' height='200'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='700' height='500'%3E %3Crect width='700' height='500' fill='%23e41e20'/%3E %3Cpath id='half' d='m300.094,97.2043c-4.8618-0.082-12.9308,1.54998-12.75,5.2812-13.5419-2.32092-14.952,3.27267-14.1562,8.25003,1.28844-1.97532,2.85723-3.04776,4.06251-3.24999,1.80576-0.2997,3.6954,0.2835,5.625,1.46871,1.92969,1.1853,4.05558,3.09798,5.00004,4.28121-4.77945,1.14264-8.4717,0.405-12.2188-0.2502-1.84716-0.3231-4.43205-1.36224-5.96871-2.43747-1.53666-1.07541-2.0205-2.08755-4.43754-4.56246-2.84967-2.91798-5.88258-2.09637-4.93749,2.43747,2.18556,4.21092,5.83659,6.08859,10.4375,6.84378,2.214,0.3636,5.51196,1.15263,9.25,1.15623,3.73806,0.004,7.93521-0.54,10.2188-0.0625-1.37187,0.8613-2.92428,2.34621-6.00003,2.93751-3.12777,0.6012-7.88301-1.85994-10.7812-2.53125,0.3681,2.43855,3.44403,4.71816,9.49999,5.90625,9.95152,2.16693,18.2208,3.81375,23.6875,6.78123,5.46669,2.96748,8.91342,6.68268,11.375,9.59375,4.89861,5.79312,5.15628,10.2402,5.46876,11.2187,1.00782,9.2557-2.21958,14.4622-8.21871,16.0625-2.99961,0.8001-8.32788-0.7065-10.2812-2.99997-1.95345-2.29293-3.85407-6.23421-3.31254-12.4062,0.5265-2.42127,3.29526-8.72811,0.93753-10.0312-10.8616-6.00326-24.0512-12.0744-33.5938-15.6873-2.60815-0.98745-4.75675,2.55735-5.59375,3.9375-16.2111-1.97418-30.827-12.9443-37.4062-24.625-4.48101-7.95555-11.8665,0.0164-10.625,7.5312,2.0043,8.38764,8.39502,14.4519,16.0625,18.75,7.86951,4.33314,17.7059,8.59698,27.6562,8.37504,5.36067,1.01412,5.30775,7.94943-1.125,9.24999-12.5809,0.0796-22.6175-0.234-32.0938-9.375-7.18776-6.5628-11.2342,1.25694-9.15624,5.68746,3.52134,13.6583,23.0063,17.483,42.7187,13.0625,7.63344-1.26414,3.06252,6.91542,0.90621,7.00002-8.23662,5.90562-22.9827,11.6841-35.9688-0.0625-5.94243-4.55022-9.96016-0.7254-7.74999,5.84379,5.76216,17.1274,27.8037,13.5302,42.9375,5.09373,3.89529-2.17143,7.43049,2.88045,2.68749,6.71877-18.8201,13.1503-28.2298,13.2999-36.7187,8.24998-10.6275-4.1913-11.5623,7.59637-5.25,11.4688,7.01595,4.30398,24.8701,1.07703,37.9688-7.15626,5.61537-4.17483,5.86944,2.35305,2.31246,4.93749-15.5442,13.4334-21.671,16.971-37.875,14.7812-8.03511-0.6264-7.91442,9.2799-1.59372,13.1562,8.62983,5.29245,25.4827-3.49245,38.5625-14.3438,5.50521-2.94165,6.40935,1.88271,3.68748,7.59375-7.99209,10.0832-15.4932,16.0281-22.7187,18.7812-7.22556,2.75319-14.1755,2.31453-19.0938,0.6246-6.00021-2.06145-6.75261,4.17429-3.43746,9.84375,1.99836,3.41748,10.2797,4.51332,19.2187,1.34379,8.93907-3.16908,18.5358-10.6026,25.125-19.3125,5.73291-5.01894,5.01993,1.72368,2.40624,6.46875-13.1944,20.8587-25.262,28.5963-41.1562,27.2812-7.04754-1.19673-8.6481,4.28364-4.1562,9.34375,7.88742,6.54111,17.7493,6.336,26.375-0.1251,7.66818-7.39323,22.3379-23.3134,30.0312-31.8438,5.42133-4.32189,7.1532-0.0612,5.56254,8.71875-1.44666,5.02803-5.06826,10.3234-14.9375,14.1875-6.74226,3.84804-1.67904,9.15142,3.375,9.25,2.78136,0.0542,8.42922-3.19716,12.75-8.06247,5.68422-6.40053,6.02226-10.6976,9.15625-20.6562,2.96091-4.85442,8.24949-2.58858,8.25003,2.50002-2.53647,9.97519-4.71582,11.7638-9.84375,15.8438-4.90482,4.60494,3.41523,6.13962,6.21873,4.24998,8.11044-5.46678,11.0713-12.5383,13.7812-18.9688,1.95606-4.64166,7.63038-2.39148,5.00004,5.18751-6.28605,18.1128-16.6152,25.2447-34.6875,28.9062-1.83159,0.3258-2.94876,1.40661-2.31246,3.53124,2.42559,2.51811,4.85559,4.80303,7.28127,7.3125-11.1751,3.25377-20.2541,5.08171-31.4377,8.34421-5.48685-3.59721-9.9194-6.64909-15.4062-10.25-1.44684-3.38229-2.12149-8.54505-10.2188-4.90626-5.48685-2.53413-8.01783-1.60488-11.0625,0.93753,4.39542,0.1638,6.30783,1.34091,8.03124,3.34377,2.25009,5.92614,7.43877,6.49863,12.75,4.81248,3.45528,2.91078,5.29542,5.1435,8.74998,8.06247-6.44922-0.2205-10.9422-0.3348-17.375-0.531-6.1407-6.5934-11.042-6.23223-15.4375-1.06245-3.35007,0.5148-4.77018,0.5868-7.06248,4.65624,3.60513-1.4796,5.87322-1.92312,7.43751-0.3123,6.52869,3.78495,10.7938,2.94012,14.0313,0,6.29874,0.3852,11.9746,0.711,18.2812,1.125-2.3166,1.96911-5.49585,3.01365-7.81254,5.00004-9.4603-2.70648-14.3979,0.93663-16.0625,8.65629-1.26783,3.11571-1.86147,6.32349-1.31247,9.65626,0.91566-3.04839,2.38788-5.66937,5.09373-7.3125,8.43201,2.14182,11.6026-1.3005,12.0625-6.34374,4.06449-3.31632,10.1935-4.04766,14.25-7.40628,4.743,1.51839,7.03575,2.45889,11.8125,3.96873,1.6983,5.16078,5.5413,7.20423,11.7812,5.87502,7.42797,0.2331,6.11667,3.28095,6.71877,5.71878,1.97406-3.50109,1.91907-6.90588-2.65626-10-1.66464-4.52241-5.35275-6.57918-10.1875-3.96873-4.55094-1.29204-5.7474-3.1491-10.2812-4.43754,11.4681-3.65526,19.603-4.47777,31.0625-8.12502,2.86848,2.70585,5.14188,4.64841,8.03124,7.06248,1.5228,0.90891,2.98053,1.13787,3.87504,0,7.18083-10.3932,10.3879-19.5528,17.0625-26.4062,2.54997-2.83554,5.77161-6.66135,9.34375-7.59375,1.78605-0.4662,3.97638-0.1818,5.37498,1.34379,1.3986,1.52541,2.49723,4.33683,2.0313,8.53128-0.6687,6.02082-2.12337,7.9218-3.81249,11.5312-1.68912,3.60954-3.75336,5.82975-5.87502,8.59374-4.24341,5.52789-9.8424,8.74539-13.1562,10.9062-6.62769,4.3218-9.43073,2.43027-14.5625,2.15622-6.63273,0.7443-8.39754,3.97467-2.96874,8.4375,5.07492,2.64051,9.63652,2.96649,13.3438,2.28123,3.18312-0.5886,6.90831-4.6971,9.5625-6.90624,2.98764-3.4515,7.94097,0.6417,4.56246,4.65624-6.13935,7.29477-12.2738,12.1044-19.8438,12-7.95465,1.07055-6.46668,5.54004-1.18746,7.71876,9.50117,3.92121,18.0796-3.42351,22.4375-8.25003,3.36222-3.67839,5.75028-3.82185,5.15628,1.87497-3.33783,10.3136-7.89912,14.2977-15.3438,14.8125-6.03855-0.5607-6.1038,4.10058-1.6875,7.25004,10.0603,6.96321,17.3459-4.89474,20.75-12.0625,2.42568-6.46569,6.14619-3.39093,6.5313,1.93752,0.0502,7.11936-3.16674,12.9321-11.7812,20.2187,6.59115,10.5015,14.2752,21.1829,20.8749,31.7188l20.005-222.806-20-35.202c-2.08305-1.92312-9.12777-10.223-10.9686-11.375-0.6714-0.7173-1.07973-1.22409-0.0936-1.59372,0.95364-0.3573,3.18591-0.7578,4.68747-1.03122-4.2417-4.2489-7.87662-5.61159-15.9065-7.93728,1.95687-0.8334,3.86037-0.3483,9.625-0.6246-2.2886-3.24868-7.40028-8.22482-14-10.6254,4.35852-3.09852,5.20785-3.30617,9.53126-6.93749-7.48656-0.531-13.8798-1.95712-20.3125-3.90625-4.06692-1.90161-9.71539-3.51615-12.4687-3.56251zm0.7191,8.71875c3.95622,0,6.40629,1.35612,6.40629,2.99997,0,1.67238-2.45007,3.03129-6.40629,3.03129-3.93975,0-6.43752-1.48293-6.43752-3.15621,0.00071-1.64385,2.49777-2.87505,6.43752-2.87505z' fill='%23000'/%3E %3Cuse xlink:href='%23half' transform='matrix(-1,0,0,1,700,0)'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600'%3E %3CclipPath id='c'%3E %3Cpath d='M0,0V150H700V300H600zM600,0H300V350H0V300z'/%3E %3C/clipPath%3E %3Crect width='1200' height='600' fill='%2300247d'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23fff' stroke-width='60'/%3E %3Cpath d='M0,0 600,300M600,0 0,300' stroke='%23cf142b' stroke-width='40' clip-path='url(%23c)'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23fff' stroke-width='100'/%3E %3Cpath d='M300,0V350M0,150H700' stroke='%23cf142b' stroke-width='60'/%3E %3Cpath d='M0,300H600V0H800V400H0z' fill='%2300247d'/%3E %3Cg%3E %3Cpath fill='%23cc3' d='m780.583,154.039c0,148.827,11.8732,201.675,52.6064,242.479,40.7332,40.8042,56.1659,47.2313,67.5231,53.4827,13.1015-7.21148,28.1971-15.1341,65.1152-52.0521,36.513-36.515,54.173-89.15,54.173-246.452-26.559,11.3712-39.7859,15.1175-63.0119,15.0513-17.202,1.68548-43.7399-9.33789-59.6086-16.5484-10.371,6.60246-25.4152,14.4763-52.4514,15.3604-31.2252,1.30952-41.1191-3.73522-64.3451-11.3217z'/%3E %3Cpath fill='%23fff' d='m787.775,163.438c0,46.0434-2.72184,108.794,7.00639,145.1,9.77001,36.4622,12.0129,41.8034,19.3596,54.5282l171.206-1.27105c10.576-18.3181,11.1098-29.6647,18.9526-58.9348,7.8148-29.1649,9.7886-94.177,10.0167-142.6-17.216,8.72445-39.7613,14.9075-61.6436,12.1948-17.5423-1.2754-33.7513-5.09258-52.6268-15.2637-16.374,9.35261-22.0822,13.6217-49.1184,14.7138-21.0507,0.98975-38.1018,2.61503-63.1522-8.46789z'/%3E %3Cpath fill='%239cf' d='m814.51,362.056c12.1849,24.4477,69.6325,71.3032,86.433,81.0029,19.168-11.0667,69.8476-57.368,83.9727-81.0029h-170.406z'/%3E %3Cpath fill='%23f90' d='m904.221,231.606c5.41355,12.1396,22.7699,25.5448,27.5414,32.1145-6.07314,6.56934-7.28706,5.85387-6.49064,18.0587,10.5604-10.534,10.7499-11.6322,17.5423-10.0346,14.8794,14.1555,2.66292,44.5571-9.63422,51.1666-12.2936,7.05101-10.0622-0.24417-28.4886,8.59299,8.44836,6.88711,18.237-1.01015,26.2362,1.10047,4.34697,4.91697-2.06648,13.8779,1.31216,22.317,7.06953-0.6489,6.22049-14.2559,7.86595-19.1896,5.16445-18.0757,36.2143-30.6826,37.7931-47.2631,6.54677-2.93012,13.09-0.9165,21.0507,3.34487-3.96455-15.5336-17.0792-15.3664-20.5946-20.2178-8.36767-12.1907-15.7845-26.0981-33.6566-29.7059-13.5672-2.73878-12.5532,0.82385-21.2472-4.83-5.41355-4.01853-21.8612-11.6181-19.2298-5.45416z'/%3E %3Cpath fill='%23f90' d='m860.839,283.106c8.72935-10.2344,13.0534-31.1272,16.9171-38.2184,8.92956,2.05041,8.83312,3.40792,19.7799-2.96497-14.7027-3.98084-15.8096-3.62755-17.5012-10.0994,6.17695-19.1553,40.0786-23.0599,51.953-15.7817,12.2822,7.06894,4.4742,8.596,21.2779,20.0001,2.44044-10.3389-9.45634-14.9009-11.2359-22.6298,2.52932-5.96126,13.8358-4.74122,20.084-11.5316-3.90439-5.6561-16.127,1.41619-21.4712,2.33396-19.1762,4.09085-45.373-16.1931-61.4875-9.77821-5.77578-4.14976-6.96507-10.606-6.73193-19.3072-12.5539,10.5985-6.27225,21.5753-9.12921,26.805-7.39678,12.7485-16.8297,25.4974-11.8265,42.248,3.79803,12.7158,6.62838,10.1968,5.44639,20.1666-1.19785,6.44061-0.56211,23.8553,3.92513,18.7577z'/%3E %3Cpath fill='%23f90' d='m931.763,290.302c-13.7027-1.82835-34.6943,5.45107-43.0585,5.96673-2.77851-8.34642-1.51002-8.96995-12.8934-14.605,4.03197,14.0554,4.9217,14.7758-0.0129,19.5038-20.3904,4.86884-41.4321-20.7724-41.0411-34.2257-0.008-13.6779,5.40195-8.09713,6.94685-27.7067-10.5433,3.35691-8.48447,15.4235-14.502,20.8735-6.65962,1.01994-11.4131-8.83635-20.7407-10.4218-3.05765,6.11145,9.61345,12.4257,13.2018,16.3114,13.5917,13.53,8.93457,45.397,23.0288,55.2268-0.7374,6.85915-5.91783,11.1692-13.8492,15.48,16.0079,4.76053,22.612-6.04289,28.7845-6.41709,15.2702-0.5594,31.594,0.5423,44.0424-12.2046,9.45-9.67656,5.72467-10.6828,15.2857-14.8756,6.40117-2.35427,21.7049-11.8813,14.8078-12.9056z'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(3.5084546,0,0,3.3448778,6.3307176,-163.01097)'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(-1.6389991,-2.9574373,3.1020668,-1.5625831,914.32327,1224.3275)'/%3E %3Ccircle fill='%23fff' cx='266.239' cy='122.104' r='0.806' transform='matrix(-1.8069804,2.8671155,-3.007328,-1.7227325,1749.0027,-240.21318)'/%3E %3C/g%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='690' height='460' viewBox='0 0 138 92'%3E %3Crect width='138' height='92' fill='%23fff'/%3E %3Crect width='138' height='36' fill='%23000'/%3E %3Cg transform='translate(69,36)'%3E %3Cg id='c3'%3E %3C!-- y3 = -y2 = 30*sin(11.25deg)/sqrt(5-4*cos(11.25deg)-sin%5E2(11.25deg)) --%3E %3Cpath id='c' d='M-30,0 0,-5.7423716V5.7423716z' fill='%23fcd116'/%3E %3Cuse xlink:href='%23c' transform='rotate(22.5)'/%3E %3Cuse xlink:href='%23c' transform='rotate(45)'/%3E %3C/g%3E %3Cuse xlink:href='%23c3' transform='rotate(67.5)'/%3E %3Cuse xlink:href='%23c3' transform='rotate(135)'/%3E %3C/g%3E %3Crect y='36' width='138' height='20' fill='%230072c6'/%3E %3Cpath d='M0,0V92H138V0L69,92z' fill='%23ce1126'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8' standalone='no'?%3E %3Csvg width='600' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' height='400'%3E %3Crect width='600' fill='%23090' height='400'/%3E %3Crect width='400' fill='%23bf0000' height='400'/%3E %3Crect width='200' height='400'/%3E %3Cg stroke-width='.5' stroke='%23bd6b00' fill-rule='evenodd' fill='%23fff'%3E %3Cpath d='m319.5 225.84 8.354 0.001c0.0311 3.1574 1.8815 6.5489 4.4798 8.4926h-16.008c2.5051-2.271 3.1897-4.9625 3.1741-8.4938z'/%3E %3Cpath stroke='none' d='m266.71 178.53 4.5742 5.0402 56.934 0.0932 4.6674-5.0402-14.56-0.18636-7.0937-4.947-22.868-0.0932-6.6266 5.1333h-15.027z'/%3E %3Cpath d='m290.02 172.74 19.66-0.0203c2.6616-1.4073 3.4919-5.9014 3.4788-8.4161-0.037-7.4282-5.2325-10.991-10.447-11.18-0.78128-0.0394-1.688-0.64749-1.8947-1.3595-0.51368-1.6128-0.38108-2.6411-0.94375-2.5838-0.50055-0.007-0.35361 0.93999-0.79921 2.4524-0.24489 0.75261-1.0907 1.4945-1.9341 1.5375-6.4904 0.32374-10.676 5.0616-10.513 11.134 0.1099 4.0151 0.577 6.4127 3.3927 8.4364z'/%3E %3Cpath stroke='none' d='m257.66 242.83h84.469l-7.5608-6.1607h-69.348l-7.5596 6.1607z'/%3E %3Cpath d='m296.39 219.69 1.5399 4.6196h3.4991l-2.799-4.6208-2.2399 0.001zm-1.9592 4.6196 0.88641 4.573 4.1059 0.0466-1.4933-4.6208-3.4991 0.001zm6.9527 0.0466 2.8468 4.5264h5.8334l-4.573-4.5742-4.1071 0.0478zm-34.441 10.36c3.0953-2.8778 5.0712-5.3352 5.0867-8.8665h7.5596c0.0155 1.9759 0.73111 3.1574 1.8206 3.0797l7.654-0.0466-0.0466-4.5264h-5.5538l-0.001-24.688c-0.2019-8.7267 10.609-13.813 15.028-13.767l-26.275-0.0466v-0.79324h55.255l0.0466 0.79324-26.647 0.0466c7.9025 0.0155 15.524 7.4987 15.587 13.815v6.9993h-1.0274l-0.0466-6.9061c0-6.9073-8.6993-13.363-15.681-13.161-6.0364 0.17322-15.4 5.9277-15.307 13.115v2.1467l14.327 0.0932-0.13978 2.4729 2.2495 1.4359 4.487 1.43-0.0657 3.7093 3.2136 0.94734 0.0275 3.7057 3.8551 1.6546v3.8359l2.4454 1.5064-0.1123 3.8957 3.3139 2.3331h-7.8403l4.9004 5.4606h-7.2335l-3.5946-5.4606h-4.7594l2.1467 5.4128-5.0855-0.0466-1.2149-5.3662h-6.2061l0.0466 5.7856-22.214 0.001zm22.168-14.981v4.573h5.3209l-1.0752-4.573h-4.2457z'/%3E %3Crect y='211.66' x='289.39' height='7.6068' fill='none' width='3.3134'/%3E %3Cpath d='m284.71 219.8h3.2339l-0.0203-5.5968c-0.0418-2.4329 2.142-4.8854 3.1873-4.967 1.1588-0.0439 2.8671 2.2965 2.9244 4.7757l0.0466 5.8064 3.431-0.007v-14.411l-12.803 0.0682v14.332z' fill='none'/%3E %3Crect y='223.14' x='310.3' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='217.77' x='307.92' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='212.4' x='304.05' height='3.1268' fill='none' width='4.0135'/%3E %3Crect y='207.88' x='300.74' height='3.1268' fill='none' width='4.0135'/%3E %3Cpath d='m298.08 219.82 4.1059 0.13977 7.3266 6.4868v-3.8264l-2.4729-1.7728v-3.0344l-3.5934-2.0524v-3.2673l-3.5002-1.166v-4.4344l-1.774-1.4467-0.092 14.374z' fill='none'/%3E %3Crect y='210.35' x='315.43' height='7.0468' width='.98004'/%3E %3Cg id='c'%3E %3Cpath d='m257.32 186.53c-1.234-1.9819-2.7118 2.7488-7.7878 6.2706-2.363 1.608-4.0092 5.8931-4.0247 8.7124-0.0777 1.9365 0.21503 3.8682-0.001 5.7414-0.13619 1.1851-1.3714 3.8156-0.52683 4.4882 2.234 1.6605 5.1261 5.4308 6.4677 6.7317 1.16 1.0166 2.1647-5.248 3.0355-8.0518 0.93301-3.0045 0.51489-6.5955 3.1024-9.3718 1.8338-1.8744 6.4594-3.7189 5.9397-4.5539l-6.2049-9.9668z'/%3E %3Cpath d='m257.06 201.88c-0.38526-0.88581-0.95754-1.8017-1.6562-2.5938-0.69871-0.79204-1.5248-1.4569-2.4375-1.7812-0.88164-0.32494-1.7792-0.75131-2.4062-1.5312-0.31351-0.38997-0.58408-0.88198-0.71875-1.4688-0.12477-0.54363-0.12348-1.2104-0.0312-1.9688-0.10986 0.0798-0.16783 0.17131-0.28125 0.25-2.363 1.608-4.0157 5.8994-4.0312 8.7188-0.0312 0.77881-0.0314 1.5387 0 2.3125 0.17489 0.48532 0.34357 0.95597 0.59375 1.25 0.32596 0.3831 0.71323 0.63629 1.125 0.8125 0.82354 0.35241 1.7746 0.42507 2.6562 0.75 0.9127 0.32434 1.8518 1.058 2.6562 1.9375 0.76683 0.83843 1.3575 1.8005 1.75 2.6562 0.0663-0.2425 0.15395-0.60389 0.21875-0.8125 0.84505-2.7212 0.69713-5.8888 2.5625-8.5312z' fill='%23bf0000'/%3E %3Cpath d='m249.82 192.39c-0.48382 3.3557 1.3846 4.4727 3.1478 5.1226 1.8254 0.64868 3.3223 2.6067 4.0928 4.3783' fill='none'/%3E %3Cpath d='m245.3 203.44c0.77054 2.8934 2.7978 2.5314 4.5611 3.1813 1.8254 0.64868 3.7452 2.9567 4.5157 4.7283' fill='none'/%3E %3Cpath d='m255.61 184.48 0.92464-0.59373 17.752 29.898-0.92345 0.59373-17.753-29.898z'/%3E %3Cpath d='m257.52 183.29a2.0459 2.0459 0 1 1 -4.0919 0 2.0459 2.0459 0 1 1 4.0919 0z'/%3E %3Crect y='159.27' x='272.7' height='1.6499' width='7.1937'/%3E %3Crect y='162.4' x='272.7' height='13.784' width='7.1937'/%3E %3Cpath d='m272.26 157.39 7.9801 0.0466c0.3118-2.7058-2.3893-5.6291-3.9662-5.5992-1.559 0.0753-4.0761 2.9555-4.014 5.5526z'/%3E %3Cpath stroke='none' d='m292.62 155.76c-1.5214 0.63988-2.6876 2.3773-3.4062 4.375-0.71863 1.9977-0.99146 4.2674-0.65625 6.0938v0.0312c0.12767 0.63033 0.30087 1.0828 0.5 1.4062s0.42233 0.51338 0.6875 0.5625c0.26517 0.0491 0.51389-0.0929 0.65625-0.3125 0.14236-0.21963 0.21213-0.50902 0.1875-0.84375-0.14424-1.8787-0.13498-3.7323 0.3125-5.4062 0.44748-1.674 1.3381-3.1644 2.9688-4.375 0.29479-0.21603 0.46415-0.46321 0.5-0.71875 0.0358-0.25554-0.0995-0.47402-0.28125-0.625-0.36346-0.30196-0.93739-0.40779-1.4688-0.1875zm0.15625 0.4375c0.37058-0.15363 0.84219-0.0633 1.0312 0.0937 0.0945 0.0785 0.10575 0.13319 0.0937 0.21875-0.012 0.0856-0.0775 0.23402-0.3125 0.40625-1.7131 1.2718-2.6562 2.8713-3.125 4.625s-0.45856 3.6602-0.3125 5.5625c0.019 0.2578-0.0553 0.45499-0.125 0.5625s-0.10683 0.13994-0.1875 0.125c-0.0807-0.0149-0.24759-0.11733-0.40625-0.375s-0.31728-0.65644-0.4375-1.25c-0.31467-1.7145-0.0372-3.9474 0.65625-5.875 0.69341-1.9276 1.8032-3.5378 3.125-4.0938z' fill='%23bd6b00'/%3E %3Cpath stroke='none' d='m295.19 157.73c-1.5192 0.63893-2.5013 2.292-3.0312 4.1875-0.52999 1.8955-0.61336 4.0655-0.28125 5.875 0.26002 1.2838 0.9344 1.9611 1.5938 2.0625 0.32968 0.0507 0.64783-0.0795 0.84375-0.34375 0.19592-0.26429 0.26001-0.61887 0.15625-1.0625-0.37233-1.4981-0.51562-3.366-0.25-5.0625s0.94019-3.2115 2.2188-4.125c0.29553-0.21508 0.46393-0.46314 0.5-0.71875 0.0361-0.25561-0.0995-0.50509-0.28125-0.65625-0.36357-0.30232-0.93709-0.37666-1.4688-0.15625zm0.1875 0.4375c0.37028-0.15351 0.81045-0.0639 1 0.0937 0.0948 0.0788 0.13702 0.13359 0.125 0.21875-0.012 0.0852-0.10826 0.23486-0.34375 0.40625-1.4117 1.0086-2.1286 2.6642-2.4062 4.4375-0.27764 1.7733-0.105 3.6646 0.28125 5.2188 0.0826 0.35318 0.00066 0.59139-0.0937 0.71875-0.0944 0.12736-0.21432 0.18576-0.40625 0.15625-0.38385-0.059-0.98301-0.5548-1.2188-1.7188-0.31777-1.7314-0.22749-3.868 0.28125-5.6875s1.4572-3.2869 2.7812-3.8438z' fill='%23bd6b00'/%3E %3Crect y='187.39' x='272.31' height='11.107' width='8.0268'/%3E %3Crect y='204.85' x='272.78' height='2.3334' width='7.7468'/%3E %3Crect y='208.95' x='272.59' height='8.6802' width='7.9335'/%3E %3Crect y='219.41' x='272.03' height='4.8534' width='8.6802'/%3E %3Cpath d='m273.1 202.76h6.9946l1.387-2.3092h-9.6359l1.2544 2.3092z'/%3E %3Cpath d='m282.53 194.25 0.0657-6.0711h4.8179c-1.8923 1.5614-3.652 3.4537-4.8836 6.0711z'/%3E %3Cpath d='m273.56 196.74c0.0478 1.2986 1.5184 0.71916 1.5184 0.0657 0-2.0034 0.0263-4.1693-0.0538-5.5873-0.01-1.0453 2.4908-0.78368 2.4765-0.13978 0.01 1.6916 0.0287 4.0116 0.0382 5.9911-0.0179 0.96407 1.6151 0.88045 1.5924 0-0.01-2.2113-0.0108-5.4248 0-7.0519 0.0143-2.0954-5.5013-2.05-5.5443-0.0466 0.002 1.645-0.0299 4.5898-0.0275 6.7688z' fill='none'/%3E %3Crect y='209.98' x='273.57' height='7.0935' fill='none' width='5.6935'/%3E %3Crect y='212.92' x='277.21' height='1.1667' width='2.0067'/%3E %3Crect y='212.92' x='273.71' height='1.1667' width='1.96'/%3E %3Crect y='210.07' x='275.67' height='2.8934' width='1.54'/%3E %3Crect y='214.04' x='275.67' height='3.0801' width='1.54'/%3E %3Cpath d='m243.99 138.97c0.356 5.567-1.3714 8.6228-4.3198 8.1581-0.81235-3.0881 1.0357-5.1596 4.3198-8.1581z'/%3E %3Cpath d='m237.52 151.31c-2.621-1.3332-0.72992-11.513 0.27596-15.78 0.74425 5.4965 1.9891 13.309-0.27596 15.78z'/%3E %3Cpath d='m238.45 151.79c4.4058 1.5327 7.8941-3.2124 9.0732-8.7077-3.6364 5.0186-9.5546 5.0246-9.0732 8.7077z'/%3E %3Cpath d='m235.11 156.93c-3.4453-0.9103-1.3702-11.71-0.74425-16.03 0.75739 4.4619 3.1323 14.552 0.74425 16.03z'/%3E %3Cpath d='m236.29 156.59c0.19233-3.7248 3.9052-2.6485 6.4677-4.6364-0.41812 1.8612-1.9938 5.1596-6.4677 4.6364z'/%3E %3Cpath d='m232.07 161.58c-3.4142-0.92106-1.3619-12.544-1.5554-17.329 1.0011 4.1346 4.1705 16.209 1.5554 17.329z'/%3E %3Cpath d='m233.66 161.08c2.7966 0.90911 6.5012-0.90792 6.7927-4.2386-2.4084 1.6343-6.2539 0.38467-6.7927 4.2386z'/%3E %3Cpath d='m229.52 166.71c-3.2649 0.26043-1.8039-9.6383-1.8015-18.857 1.1994 8.6169 4.4667 16.505 1.8015 18.857z'/%3E %3Cpath d='m230.65 166.26c2.2053 1.1062 6.1559-0.66182 7.2837-4.3867-3.9841 1.7322-6.6481 0.0394-7.2837 4.3867z'/%3E %3Cpath d='m256.28 144.13c-0.58059 4.8287-2.5541 7.6385-5.5025 7.1738-0.81235-3.0881 1.5781-5.0616 5.5025-7.1738z'/%3E %3Cpath d='m248.48 156.52c4.898 0.69527 6.6624-3.0642 9.9596-7.8702-4.6208 3.3438-10.146 4.039-9.9596 7.8702z'/%3E %3Cpath d='m247.09 155.97c-2.67-3.204-0.0896-7.2275 1.9508-10.657-0.43842 5.1023 1.2998 7.9407-1.9508 10.657z'/%3E %3Cpath d='m245.91 161.26c-0.30105-3.1335 5.0378-3.83 7.4521-5.5718-0.81235 1.811-2.0428 6.6863-7.4521 5.5718z'/%3E %3Cpath d='m244.79 161.33c-3.6914-0.41812-2.1587-6.6863 0.4874-10.17-1.1146 4.8072 1.9496 8.1498-0.4874 10.17z'/%3E %3Cpath d='m242.01 166.55c-4.2015-1.8576-1.5088-7.1272 0.0705-10.238-0.67377 4.0856 2.6927 7.1964-0.0705 10.238z'/%3E %3Cpath d='m242.84 166.06c2.2053 2.879 6.5012-0.85894 7.3828-5.2241-3.738 3.112-6.5 2.6007-7.3828 5.2241z'/%3E %3Cpath d='m233.24 186.32c-0.43166-4.2875 2.7929-12.084 0.50438-16.24-0.31201-0.57103 0.68503-2.087 1.329-1.1672 1.0064 1.4682 2.041 5.6518 2.4738 4.1071 0.45863-1.6796 0.52901-4.6507 2.0164-5.2277 0.94895-0.33808 2.2908-0.55909 1.9249 0.9342-0.36362 1.4359-1.1777 3.419-0.27565 3.5469 0.52315 0.0776 2.0304-1.9544 3.2996-2.8934 1.0228-0.83743 2.5489 0.47308 1.0533 1.7262-4.8608 4.0367-9.5704 5.8537-12.326 15.214z'/%3E %3Cpath d='m224.51 250.85c-0.57042-0.10939-1.3518-0.30325-0.64081 0.58385 5.6789 6.9961 7.3221 8.924 15.603 7.9397 8.3647-1.1012 10.357-3.3637 16.214-6.6504 3.1284-1.8351 7.7026-2.2426 11.17-1.1055 1.6142 0.52834 2.5906 0.56022 1.4336-0.59826-1.1575-1.1569-2.5249-2.7312-3.9485-3.8153-3.1181-2.3942-8.4069-3.4322-12.723-2.6616-6.1044 0.95734-11.148 4.8442-17.176 6.3123-3.1669 0.72294-6.6407 0.61388-9.9317-0.005z'/%3E %3Cpath d='m272.3 263.35c1.056 0.13141 1.725 2.1766 2.2447 0.79204 0.88164-2.2423 0.26401-4.0259-0.72633-3.8288-1.1696 0.3118-3.1478 2.934-1.5184 3.0368z'/%3E %3Cpath stroke='none' d='m220.6 182.92c-1.2149-1.2687-0.86372-1.7537 0.933-1.774 1.4252-0.0896 4.2493 0.87328 5.3209 0.0932 0.98198-0.71319 0.59134-3.738 1.0274-5.1333 0.18994-0.77771 0.7347-1.9986 1.9592-0.0932 3.6221 5.8047 8.1462 12.773 10.08 19.6 1.0572 3.8264 0.0621 9.7996-3.4537 13.814 0.12425-3.4226-1.1516-5.7247-2.707-8.587-1.921-3.7619-9.0565-13.951-13.16-17.919z'/%3E %3Cpath d='m235.53 213.44c3.9829 0.0191 4.6674-5.3197 4.6674-6.813-1.9604 0.37272-5.4141 3.64-4.6674 6.813z'/%3E %3Cpath d='m269.95 265.26c2.8326 0.64461 2.7937-6.1781-0.0995-9.0701 1.274 4.3824-2.1286 8.3884 0.0995 9.0701z'/%3E %3Cpath d='m268.85 265.2c0.18688 3.2427-7.9586-0.42377-10.052-2.9462 4.8125 2.0445 9.8145 0.35216 10.052 2.9462z'/%3E %3Cpath d='m265.28 260.57c0.29129 3.1414-7.0638 0.37929-9.2378-2.074 4.83 1.5602 8.9164-0.51099 9.2378 2.074z'/%3E %3Cpath d='m266.63 261.01c2.8326 0.64461 2.3737-6.412-0.37932-8.8369 1.3211 4.7091-1.8488 8.1552 0.37932 8.8369z'/%3E %3Cpath d='m263.65 256.72c2.8326 0.64461 1.207-5.4312-0.89265-7.8575 0.34096 4.4298-1.055 7.5021 0.89265 7.8575z'/%3E %3Cpath d='m262.15 256.7c0.29185 3.2349-5.4301 0.75147-7.6509-2.3088 4.783 1.561 7.3296-0.27617 7.6509 2.3088z'/%3E %3Cpath d='m260.59 254.24c1.8558-1.3343-0.11294-4.8633-3.645-4.6447 0.34557 2.1312 1.5659 5.88 3.645 4.6447z'/%3E %3Cpath d='m274.54 268.87c0.18688 3.2427-7.9595 1.6298-10.519-1.8255 5.1387 0.97109 10.281-0.76847 10.519 1.8255z'/%3E %3Cpath d='m242.18 263.07c0.29185 3.2349-8.6024-0.32249-10.823-3.3827 4.783 1.561 10.502 0.79778 10.823 3.3827z'/%3E %3Cpath d='m247.63 264.45c1.8558-1.3343-1.9327-4.7703-4.951-5.578 0.34558 2.1312 2.8719 6.8132 4.951 5.578z'/%3E %3Cpath d='m248.2 266.69c0.1986 2.9084-9.5373 1.3132-12.084-1.3741 8.3771 1.5142 11.81-1.1172 12.084 1.3741z'/%3E %3Cpath d='m252.76 268.63c1.0806 2.7015-8.2641 2.0422-11.545 0.4715 5.3012-0.0461 10.802-2.3534 11.545-0.4715z'/%3E %3Cpath d='m257.13 270.6c1.0345 2.421-7.6104 2.3687-11.824 1.0303 5.5812-0.0458 10.801-3.4259 11.824-1.0303z'/%3E %3Cpath d='m263.42 271.9c1.531 2.8646-7.5878 3.1435-10.547 1.7331 5.2725-0.72515 9.2422-3.9877 10.547-1.7331z'/%3E %3Cpath d='m252.74 267c-2.9011 1.8295-2.7458-3.5643-5.0532-7.2996 3.6255 3.3017 7.0194 5.5553 5.0532 7.2996z'/%3E %3Cpath d='m257.88 268.94c-2.4335 2.156-4.379-5.2459-6.594-9.399 3.5805 3.9539 8.8395 7.6085 6.594 9.399z'/%3E %3Cpath d='m264.68 271c-2.0609 2.3888-8.0196-7.0181-10.187-11.919 3.2992 3.8152 11.826 9.895 10.187 11.919z'/%3E %3Cpath d='m258.88 278.18c-1.028 3.6318-16.192-3.4234-17.885-7.0785 8.6768 4.5975 18.092 3.6359 17.885 7.0785z'/%3E %3Cpath d='m210.15 204.38c-0.35481-0.45993-1.3738 0.012-1.1194 1.1206 0.23653 1.5004 2.449 9.2034 6.2515 11.853 2.7118 1.9544 16.965 5.1023 23.427 6.439 3.5564 0.71558 6.5346 2.4896 8.8677 5.3209-0.96526-3.7022-1.7406-6.445-2.9866-9.7996-1.2114-2.9483-4.4213-6.1738-7.746-6.3471-6.175-0.2222-14.167-0.74783-19.974-3.2673-2.9973-1.252-4.7917-2.9436-6.7198-5.3197z'/%3E %3Cpath d='m245.54 234.87c1.9469 1.4336 4.0958-3.704 1.6225-8.588-0.0776 4.7012-3.8141 6.2791-1.6225 8.588z'/%3E %3Cpath d='m247.41 239.58c2.6927 0.82665 3.536-3.937 1.7626-7.7474 0.2957 4.0938-4.2336 6.5596-1.7626 7.7474z'/%3E %3Cpath d='m249.46 243.36c2.6006 1.2948 3.5848-3.5179 1.7159-7.0917 0.2039 4.5593-3.7203 5.9035-1.7159 7.0917z'/%3E %3Cpath d='m248.39 243.65c-1.0304 3.0802-7.0069-2.6554-8.0141-5.7748 3.7094 3.6852 8.7568 3.278 8.0141 5.7748z'/%3E %3Cpath d='m245.68 238.94c-1.171 3.0797-8.6865-4.8497-10.348-8.6679 3.7094 3.6852 11.184 6.4975 10.348 8.6679z'/%3E %3Cpath d='m244.19 234.32c-1.1706 3.5001-9.3403-5.829-11.654-9.1352 3.8968 3.6388 12.537 6.5919 11.654 9.1352z'/%3E %3Cpath d='m243.93 230.86c2.8765-0.55945-0.1633-2.9553-3.6892-6.849-0.16487 4.0999 0.50799 6.9664 3.6892 6.849z'/%3E %3Cpath d='m239.08 228.53c1.2422-1.3529-1.1906-1.9289-4.203-5.3096-0.44441 2.2798 2.7942 6.4535 4.203 5.3096z'/%3E %3Cpath d='m253 243.73c1.5742 0.92123 2.6516-2.3045 0.68982-5.225-0.44888 3.1594-2.1332 4.0368-0.68982 5.225z'/%3E %3Cpath d='m218.81 223.38c-3.3424 2.004-8.6516-5.992-10.068-9.2817 2.9329 3.7754 10.699 7.2242 10.068 9.2817z'/%3E %3Cpath d='m221.65 228.04c-1.8496 2.0506-7.6713-3.5187-9.6942-6.3413 3.1204 2.7022 10.512 3.0236 9.6942 6.3413z'/%3E %3Cpath d='m224.82 232.22c-0.61034 2.801-9.1062-3.4952-11.092-6.4756 3.6626 3.4518 11.649 3.1398 11.092 6.4756z'/%3E %3Cpath d='m223.52 235.25c-1.3106 2.5218-8.2206-3.7268-9.8794-6.9868 4.222 3.6843 10.949 4.4926 9.8794 6.9868z'/%3E %3Cpath d='m219.97 222.97c2.1805-2.2988 1.2516-3.3763-0.338-6.9994-0.8689 3.7206-2.1793 5.2055 0.338 6.9994z'/%3E %3Cpath d='m222.86 227.31c3.9544 0.17418 0.0381-4.6378-0.89693-8.6793 0.3439 4.6062-1.0136 8.2375 0.89693 8.6793z'/%3E %3Cpath d='m225.38 231.13c2.7405-0.61933 1.95-4.4971-0.15066-9.1933 0.43644 5.0738-2.3203 8.0055 0.15066 9.1933z'/%3E %3Cpath d='m224.45 238.8c-1.0304 3.0802-8.8265-4.0555-10.067-6.7554 3.9426 3.3119 10.763 4.4456 10.067 6.7554z'/%3E %3Cpath d='m229.12 243.61c-1.1698 3.0817-9.3391-3.1669-11.839-6.5678 4.9223 3.8722 12.443 3.5126 11.839 6.5678z'/%3E %3Cpath d='m233.88 248.46c-1.3096 4.2937-9.8528-2.5609-12.399-5.9148 5.4358 4.1511 13.096 2.859 12.399 5.9148z'/%3E %3Cpath d='m225.85 237.43c2.3206 1.201 3.2577-5.3837 1.9487-10.033 0.0175 5.0736-4.6535 8.8452-1.9487 10.033z'/%3E %3Cpath d='m229.81 242.66c2.7876 0.82809 1.904-6.2694-0.47802-10.873-0.30875 4.561-2.3662 8.8924 0.47802 10.873z'/%3E %3Cpath d='m234.76 247.56c3.1142 0.17446 0.97142-6.084-1.5973-9.6132 0.4372 4.6069-1.0129 9.0788 1.5973 9.6132z'/%3E %3Cpath d='m229.3 250.23c-0.93619 1.5864-3.226-1.3475-6.9861-3.4886 3.3817 0.88442 7.4021 2.0185 6.9861 3.4886z'/%3E %3Cpath d='m227.52 197.49c2.9065-2.1503 0.6893-6.1726 0-9.9979-0.93539 3.6281-3.3975 8.3887 0 9.9979z'/%3E %3Cpath d='m227.42 202.85c-4.3664-0.52444-3.7093-6.1715-3.8407-9.7506 1.3129 4.8586 4.892 5.6793 3.8407 9.7506z'/%3E %3Cpath d='m228.11 202.12c3.6938-0.21384 3.4979-4.4166 3.695-8.6682-1.872 3.9076-4.0892 4.5145-3.695 8.6682z'/%3E %3Cpath d='m227.96 207.34c-2.8731 0.22937-4.3664-2.5935-5.0234-6.9934 2.725 4.0546 5.2038 2.7907 5.0234 6.9934z'/%3E %3Cpath d='m228.99 206.99c3.6938 0.47546 3.1036-3.8252 2.9555-6.9946-1.1325 3.0212-4.137 3.9733-2.9555 6.9946z'/%3E %3Cpath d='m223.23 205.17c0.29507 2.8074 2.0691 7.6337 4.9255 6.5502 1.1815-3.4477-2.5123-4.137-4.9255-6.5502z'/%3E %3Cpath d='m229.04 212.02c-1.2806-2.4621 2.9053-3.695 3.7918-6.8954 0.50891 4.5802 0.0824 7.5847-3.7918 6.8954z'/%3E %3Cpath d='m217.13 182.84c2.2997-2.4765 0.26879-6.4056-0.42051-10.231-0.9354 3.6281-2.5565 8.4353 0.42051 10.231z'/%3E %3Cpath d='m217.06 187.45c-4.039 0.40976-5.0162-7.8045-5.4272-11.337 1.3129 4.8586 5.9648 7.0794 5.4272 11.337z'/%3E %3Cpath d='m217.89 187.37c2.854-1.4742 2.191-4.6495 3.0881-7.0352-1.9186 2.928-3.6687 3.3474-3.0881 7.0352z'/%3E %3Cpath d='m217.09 192.75c-4.2254 0.36197-6.7425-8.7387-6.8739-12.318 1.3129 4.8586 7.3661 7.4999 6.8739 12.318z'/%3E %3Cpath d='m217.9 192.61c3.9733-0.91389 3.4979-3.4835 2.9018-7.642-1.2651 4.1884-3.4824 3.3008-2.9018 7.642z'/%3E %3Cpath d='m217.04 198c-4.6459 0.78845-4.3198-6.5609-8.0088-11.893 3.1909 3.9602 8.9358 8.9502 8.0088 11.893z'/%3E %3Cpath d='m218.09 197.75c3.5074 0.10154 3.8503-5.1787 3.6556-7.3207-0.80638 2.1336-4.9302 4.1597-3.6556 7.3207z'/%3E %3Cpath d='m209.78 192.34c1.7418 5.6542 4.2158 11.32 7.2586 10.89 1.461-3.2148-2.8862-3.6245-7.2586-10.89z'/%3E %3Cpath d='m218.14 202.4c-1.2806-2.4621 2.9053-3.695 3.7918-6.8954 0.50891 4.5802 0.0824 7.5847-3.7918 6.8954z'/%3E %3Cpath d='m210.98 198.8c2.4872 5.0939 3.609 10.948 7.0244 10.097 1.2747-3.9614-3.7714-4.7905-7.0244-10.097z'/%3E %3Cpath d='m218.71 207.93c-1.467-2.6951 2.719-3.6484 3.7452-7.3625 0.5555 4.861 0.0358 8.3314-3.7452 7.3625z'/%3E %3Cpath d='m225.87 173.45c2.4514 0.66302 5.0222-2.0894 4.131-6.2085-2.8014 0.69766-4.0868 3.241-4.131 6.2085z'/%3E %3Cpath d='m218.03 171.39c0.21384 1.1588 1.6235 1.2639 1.2137-0.37272-0.34166-1.3284-0.4002-2.3271 0-3.4071 0.54834-1.3535 0.36556-3.658-0.0466-4.6196-0.41573-1.0154-1.7931-0.42051-1.2137 0.37392 0.63793 0.92106 0.67138 2.8372 0.23295 3.732-0.577 1.3212-0.4205 3.075-0.18636 4.2935z'/%3E %3Cpath d='m240.9 187.31c-0.94705 1.3932-2.8812 0.54113-1.4078-1.3724 1.2073-1.5486 2.9282-2.8138 3.0552-4.4136 0.10028-2.0286 1.2909-5.1066 2.3726-6.1447 1.1177-1.106 2.4089 0.44989 1.2142 1.1874-1.3426 0.87203-2.2147 4.4568-2.1853 5.836-0.0453 2.0013-2.0413 3.447-3.0489 4.9072z'/%3E %3Cpath d='m237.92 185.07c-0.94705 1.3932-2.4566 0.58456-1.6013-1.6522 0.72225-1.5486 0.79972-3.4676 1.6042-4.6 1.125-1.7165 3.0307-3.1471 4.1125-4.1853 1.1177-1.106 2.0456-0.0402 1.0207 0.90749-1.2445 1.2453-2.5947 2.7953-3.345 3.9693-1.3993 2.2808-0.78335 4.1004-1.7909 5.5607z'/%3E %3Cpath d='m222.18 177.86c-0.11229 1.9667 1.4706 2.4433 1.4001-0.40889-0.0717-2.9777-2.179-5.702-0.88642-10.235 0.67975-2.2176 0.69169-6.2814 0.27955-8.4413-0.36198-2.1423-1.8863-0.74253-1.3069 0.92566 0.63793 1.9341-0.11946 5.6442-0.60687 7.5106-1.4634 5.4335 1.2066 8.0801 1.1206 10.649z'/%3E %3Cpath d='m226.5 166.98c-0.23238 1.8098-1.7642 1.974-1.319-0.58213 0.37128-2.0748 0.43489-3.6346 0-5.3213-0.59586-2.114-0.39724-5.7131 0.0506-7.2151 0.45176-1.5859 1.9486-0.65676 1.319 0.584-0.69323 1.4385-0.72958 4.4313-0.25315 5.8288 0.62702 2.0636 0.45696 4.8026 0.20252 6.7057z'/%3E %3Cpath d='m210.94 204c0.75806 0.90214 2.0358 0.29761 0.87149-0.92336-0.95298-0.98655-0.63931-1.2979-1.22-2.4999-0.57427-1.343-0.54434-2.084-1.2375-3.0436-0.61297-0.91033-1.535 0.0184-0.91733 0.78454 0.77539 0.90604 0.56133 1.5743 1.0356 2.4508 0.87626 1.4999 0.66261 2.2875 1.4678 3.2315z'/%3E %3Cpath d='m231.34 228.61c2.4394 1.1994 4.2911 4.1955 4.413 6.6361 0.20667 2.8086 0.61165 5.1799 1.8732 7.1761-2.0082-0.55909-2.9698-3.7595-3.2554-6.8249-0.2891-3.1729-1.9986-4.5491-3.0308-6.9874z'/%3E %3Cpath d='m236.42 234.49c1.688 3.1159 4.0486 4.3044 4.1692 6.6167 0.2045 2.661 0.40664 2.7968 1.1277 5.4136-1.9871-0.5297-2.4871-0.70287-3.0238-4.6847-0.33098-2.7979-2.571-4.7718-2.2732-7.3456z'/%3E %3Cpath stroke='none' d='m288.97 263.32c0.94853 1.7884 2.038 4.5109 4.0128 4.0128 0.0311-1.369-2.1312-2.3176-4.0128-4.0128z'/%3E %3Cpath stroke='none' d='m291.91 263.93c3.8353 1.5721 7.1472 1.1839 7.5598 3.5946-3.598 0.38826-4.9137-1.0895-7.5598-3.5946z'/%3E %3Cpath stroke='none' d='m275.85 251.24c2.5828 2.1157 4.2588 4.5312 5.0401 7.6528 0.81474 2.9077 1.9604 5.2265 3.6412 7.8403-2.7381-1.8672-4.4596-4.407-5.3209-7.4676-0.7562-3.0081-1.6486-5.2564-3.3605-8.0255z'/%3E %3Cpath stroke='none' d='m279.03 251.23c2.7692 2.2101 5.3794 4.7188 6.1607 7.8403 0.81474 2.9077 1.3069 5.1333 3.1741 8.0267-2.9244-1.8672-4.0856-4.6877-4.947-7.7483-0.7562-3.0069-2.4896-5.2552-4.3879-8.1187z'/%3E %3Cpath stroke='none' d='m288.17 258.47c-0.0765-0.54594 0.29746-1.0226 0.74664-1.166 0.87446-0.32733 1.7454-0.59373 2.6126-0.83982 0.98556-0.23296 1.5375 0.47068 1.5411 0.933 0.005 0.76934 0.0406 1.4228 0 2.0058-0.0538 0.72634-0.19234 0.78009-0.65347 0.88761-0.73827 0.12424-1.6844 0.25087-2.4263 0.74664-0.58776 0.36078-1.1528 0.0753-1.4467-0.55908-0.18994-0.48502-0.29387-1.4336-0.37391-2.0082z'/%3E %3Cpath stroke='none' d='m298.8 258.47c0.0683-0.54594-0.21986-1.0692-0.62115-1.2126-0.78124-0.32732-1.5593-0.40736-2.38-0.37391-0.91144-0.0143-1.1409 0.19114-1.1441 0.65346-0.004 0.76934-0.0363 1.516 0 2.099 0.048 0.72634 0.032 0.78009 0.44398 0.88761 0.65957 0.12424 1.7845 0.15769 2.4472 0.65346 0.5251 0.36078 1.1238 0.0753 1.1526-0.60568-0.0128-0.51368 0.0299-1.5267 0.10139-2.1013z'/%3E %3C/g%3E %3Cuse x='-600' xlink:href='%23c' transform='scale(-1,1)'/%3E %3Cg stroke='none'%3E %3Cpath d='m328.54 286.65c0.0466 1.1815 0.18756 2.1312 0.88761 3.0797-4.0761-1.633-9.8306-0.75859-13.767 1.074-1.7561 0.83863-3.8802-0.95809-1.8206-2.6604 2.9292-2.3737 9.7063-1.0274 14.7-1.4933zm-57.505-0.0621c0.0573 1.1134-0.0717 2.1336-0.48144 3.106 4.4309-1.8349 9.1879-0.3106 13.664 1.4945 3.0774 1.2723 3.3258-0.93061 2.7823-1.6928-0.9342-1.3523-2.7417-2.8372-5.0282-2.8695-1.522-0.0215-7.3816-0.0741-10.937-0.0382zm3.7404-21.642c-1.2364-0.5328-2.6724-0.0203-3.9602 1.3356-4.3269 4.2397-9.4041 8.3707-13.502 11.584-1.5291 1.3284-3.0917 3.7117 3.431 6.0938 0.23654 0.0896 4.9912 1.8517 8.004 1.964 1.2305-0.0346 1.2269 1.8027 0.99871 2.2925-0.51966 0.9784-0.14336 1.3523-1.1934 2.2937-1.0943 0.92345 0.11707 2.1193 0.9772 1.3069 3.6723-3.1884 9.6275-1.148 15.366 0.71797 1.3559 0.37511 3.8371 0.26999 3.8156-1.6008 0.0239-2.038 1.5004-3.4787 2.4036-3.5313 2.3427 0.40617 13.919 0.53519 17.485 0.10154 2.0786-0.26998 2.2041 2.848 3.3163 4.0773 0.76695 0.81473 3.7189 1.031 5.7426 0.13738 4.0008-1.8588 10.097-1.8588 12.582-0.0824 1.0214 0.7777 1.8278 0.14694 1.2472-0.64271-0.74784-1.0799-0.73112-1.5805-1.1026-2.4334-0.933-1.8983-0.18875-2.363 0.78965-2.5004 11.054-1.4252 14.582-5.1966 11.202-8.2716-4.364-3.8276-9.2225-7.6755-13.408-12.198-1.1349-1.1994-1.8851-1.6808-4.2469-0.69885-7.2215 3.2888-16.388 5.6864-25.358 5.862-8.3469 0.0717-19.824-3.7894-24.589-5.8071z'/%3E %3Cpath d='m326.62 265.54c-0.58023 0.0578-1.1972 0.23826-1.6562 0.40625-8.921 3.1336-17.117 5.328-25.656 5.3125-8.3351-0.0155-17.066-2.3091-24.906-5.5312-0.44624-0.19053-0.95981-0.16084-1.4688-0.0312-0.50894 0.12959-1.0125 0.36576-1.3438 0.6875-3.6409 3.6266-7.5824 7.1483-11.812 10.344-0.63909 0.48801-0.53496 1.7307 0.5 2.1562h0.0312c8.3042 2.9793 16.412 8.5315 39.625 8.3125 23.433-0.22135 31.746-5.64 39.188-8.125 0.52464-0.19981 1.0644-0.4994 1.3125-0.96875 0.12404-0.23467 0.15766-0.52598 0.0625-0.8125-0.0952-0.28652-0.28357-0.55445-0.625-0.84375h-0.0312c-4.2235-3.4524-8.7488-6.2064-11.719-10.406-0.33382-0.47902-0.91977-0.55785-1.5-0.5zm0.0312 0.4375c0.50718-0.0506 0.89476 0.027 1.0938 0.3125 3.0414 4.3011 7.621 7.0738 11.812 10.5 0.30008 0.25426 0.44154 0.48023 0.5 0.65625 0.0585 0.17602 0.0438 0.29557-0.0312 0.4375-0.15003 0.28386-0.58962 0.56991-1.0625 0.75-7.534 2.5157-15.668 7.9043-39.031 8.125-23.115 0.21804-31.094-5.3023-39.469-8.3125-0.75458-0.31029-0.68706-1.1606-0.40625-1.375 4.2421-3.2062 8.227-6.7414 11.875-10.375 0.25052-0.24332 0.65266-0.45018 1.0938-0.5625 0.44109-0.11232 0.91238-0.13081 1.2188 0 7.8791 3.2384 16.613 5.5781 25.031 5.5938 8.6179 0.0156 16.903-2.2032 25.844-5.3438 0.44524-0.16293 1.0241-0.35569 1.5312-0.40625z' fill='%23bd6b00'/%3E %3Cpath d='m269.71 114.56c-0.0681-1.3788 2.0691-1.4841 1.8242 0.41202-0.313 2.3623 4.4583 8.342 4.8538 12.029 0.2652 2.4726-1.4527 4.6371-3.1538 5.9841-2.0858 1.6157-5.2934 1.3935-6.7938 0.46662-0.90792-0.73075-1.7358-3.2334-1.056-4.224 0.24012-0.33342 1.3272 3.673 3.7213 3.6574 3.2578-0.021 5.8967-2.4682 5.9934-4.6508 0.16725-3.8014-5.3292-9.8095-5.389-13.675z'/%3E %3Cpath d='m279.24 123.95c0.53878-0.38503 1.3989 1.2959 0.79204 1.716-0.50533 0.33652-1.4921-1.2493-0.79204-1.716z'/%3E %3Cpath d='m280.69 120.54c-0.27237 0.13212-0.81354-0.0555-0.65226-0.28671 0.76217-1.0889 2.3869-2.7279 3.5648-3.3 0.36198-0.17585 0.99513 0.46303 0.77651 0.77602-0.70483 1.0071-2.4203 2.1949-3.689 2.8107z'/%3E %3Cpath d='m293.28 110.55c0.30224-0.63089 2.1169-1.3441 2.5792-1.7707 0.42767-0.43783 0.63195 0.37046 0.44917 0.75202-0.30224 0.63052-1.8684 1.6954-2.5553 1.724-0.36914 0.0154-0.65585-0.32422-0.47307-0.7053z'/%3E %3Cpath d='m297.59 110.75c0.39304-1.1074 1.6605-2.7861 2.5326-3.3387 0.44799-0.28336 1.252-0.0605 1.1014 0.364-0.3333 0.93958-1.8839 2.5812-2.9268 3.3546-0.31657 0.28169-0.79801-0.12328-0.70722-0.37989z'/%3E %3Cpath d='m293.9 113.52c-0.26282 0.13153-0.12066 0.69133 0.1326 0.77591 0.53878 0.17943 1.5196 0.21443 1.964-0.0307 0.6451-0.39757 0.35122-2.8442-0.5125-1.5372-0.57939 0.80625-1.0023 0.54726-1.5841 0.79204z'/%3E %3Cpath d='m286.61 119.14c-1.3177-1.0262 0.3548-2.4639 1.7322-1.4601 2.6831 2.024-4.0032 9.7781-7.6408 13.403-0.66541 0.70984-1.2496-1.078-0.39662-1.848 2.6079-2.2121 5.0497-4.8551 6.7472-7.5854 0.32733-0.52563 0.64032-1.6587-0.44201-2.5092z'/%3E %3Cpath d='m301.88 112.47c0.16366-0.9821-1.5889 0.0206-1.6211-1.2814-0.0167-0.68906 1.915-1.1725 2.7226-0.37989 1.3643 1.384 0.34406 3.7184-1.9245 3.8653-1.8911 0.0835-5.0461 2.685-4.5659 3.2319 0.54595 0.67532 5.4499 1.1213 8.3015 0.67472 1.7657-0.24776 1.3953 1.3314-0.41334 1.5452-1.7477 0.20142-3.1717 0.0147-4.8048 0.52803-1.9222 0.54917-2.7608 3.1292-3.8288 4.0921-0.23773 0.16737-0.87925-0.84591-0.63554-1.2268 0.76934-1.2032 1.9962-3.0449 3.3462-3.572 0.85176-0.34501-2.3486-0.45384-3.37-0.74533-0.80995-0.24418-0.57461-1.2735-0.26401-1.848 0.41215-0.89513 3.4286-3.916 4.6447-3.8666 1.1421 0.0483 2.2997-0.2842 2.4132-1.0173z'/%3E %3Cpath d='m306.96 112.73c0.56745-0.50055 0.85775-1.3381 1.4527-1.848 0.32613-0.32661 0.84699 0.0647 0.75978 0.85332-0.0729 0.62084-0.90672 1.1559-1.467 1.6227-0.45635 0.34178-0.98676-0.39638-0.74545-0.62802z'/%3E %3Cpath d='m313.43 110.43c0.8446-0.0933 1.0548 1.5372 0.13141 1.8012-0.56028 0.18672-1.0501-1.7051-0.13141-1.8012z'/%3E %3Cpath d='m311.3 115.47c-0.0131 1.4037 0.67974 1.2746 2.0022 1.2266 1.283-0.0483 2.412 0.0331 2.4072-1.2346-0.006-1.3141-0.72753-2.4637-0.93898-1.5694-0.18636 0.84006-0.33449 2.2154-0.8231 1.6161-0.46112-0.515-0.27834-0.6279-1.0716 0.2173-0.43962 0.46579-0.48979-0.22578-0.75381-0.66003-0.18397-0.2572-0.8207 0.20775-0.8219 0.40402z'/%3E %3Cpath d='m302.08 122.63c-0.31538 1.8576-0.0263 4.4587 0.92464 4.4881 1.1755 0.0382 3.6078-4.0615 4.7594-6.188 0.6905-1.1867 1.8768-1.3942 1.3822-0.15602-0.74903 1.9104-0.68213 5.9976-0.0239 7.1987 0.35361 0.64689 2.9639-0.59325 3.3856-1.5147 0.76695-1.6746 0.14335-4.7616 0.41214-6.6468 0.13022-1.2376 1.2627-1.4963 1.203-0.34919-0.11229 2.0524-0.30702 5.8151-0.16247 7.524 0.086 0.98234 2.8946 2.432 3.3462-0.54272 0.23774-1.8724 1.2018-3.7189-0.0466-5.7933-0.77411-1.297 1.1361-1.1345 2.1659 0.63733 0.72036 1.2058-0.60687 3.2015-0.56028 4.744 0.11947 2.3731-1.7262 3.7214-3.0654 3.7494-1.197 0.0241-1.9771-1.4462-2.9579-1.4668-1.0883-0.0694-2.2065 1.693-3.106 1.6307-3.4859-0.23821-1.6402-5.3335-2.7022-5.396-1.1815-0.0695-2.5744 4.994-4.0295 4.8134-1.4348-0.17227-2.9197-4.1268-2.3224-5.8 0.53998-1.5567 1.5578-1.9216 1.3977-0.93204z'/%3E %3Cpath d='m318.96 114.6c-1.7012-1.0376 0.10752-3.7361 0.93898-2.788 1.6056 1.9229 3.2243 6.487 4.3556 6.8641 0.71678 0.23905 0.68333-3.3736 1.1886-5.016 0.32614-1.2133 1.7931-0.81724 1.5124 0.73733-0.0956 0.51906-1.9162 6.4213-1.7764 6.6546 1.2615 2.522 2.5099 5.0812 3.2996 7.788 0.32613 1.1667-1.0752 0.38097-1.2424 0.1387-0.89478-1.3375-2.4609-6.452-2.4609-6.2187-0.72036 3.598-0.89 4.6599-1.6546 7.7174-0.23295 0.97995-1.6749 0.80147-1.3499-0.92393 0.31299-1.4182 2.3749-8.3926 2.259-8.5947-1.6211-2.8616-3.1036-5.1252-5.07-6.3588z'/%3E %3Cpath d='m322.03 131.2c-0.47427-0.0538-1.2102 1.055 1.1516 1.4906 3.1562 0.57127 6.6111-0.49171 7.6695-3.5866 1.2125-3.6865 2.0141-7.1765 2.6473-8.4934 0.79084-1.5347 1.8027-1.4107 1.056-3.6506-0.52683-1.6123-1.51-1.1258-1.7167-0.26402-0.55192 2.3498-2.6461 9.9521-3.2996 11.352-1.2328 2.5547-3.7177 3.5654-7.5082 3.152z'/%3E %3Cpath d='m328.35 119.07c-0.33808-0.72537-1.1265-0.1639-0.98557 0.62933 0.0836 0.71702 0.66541 1.1068 1.2496 1.0866 0.69169-0.0239 2.1551 0.0232 2.1587-1.1253 0.002-0.80685-0.63196-1.481-1.1026-0.59063-0.45037 0.80614-1.0298 0.72168-1.3201 0z'/%3E %3Cpath d='m329.14 116.03c-0.24251 0.16833-0.0251 1.0656 0.26401 1.0559 1.031-0.0344 2.492-0.36328 3.2745-0.90791 0.22937-0.15937 0.1338-0.70161-0.19233-0.69073-0.99393 0.0331-2.5756 0.007-3.3462 0.54271z'/%3E %3Cpath d='m337.9 118.29c0.74664-1.1667 2.8062-1.2855 2.0655 0.38001-0.52444 1.1476-5.6518 11.055-6.3518 12.315-0.76337 1.4167-1.3882 0.71522-0.8458-0.38802 0.72992-1.4197 4.898-11.962 5.1321-12.307z'/%3E %3Cpath d='m330.18 133.04c-0.21862-0.78845-1.4419-1.9543-1.3045 0.1547 0.2437 3.8285 5.5036 2.6184 7.0961 1.2577 1.4455-1.2811 0.19114 4.3222 2.1121 4.9218 1.0584 0.33927 3.0511-1.105 4.0307-2.3761 2.7166-3.5249 4.4452-8.5779 7.0579-12.058 0.98676-1.3608-0.53997-2.3322-1.1576-1.2493-2.2722 3.8098-5.0939 11.585-8.176 13.604-2.5123 1.608-1.768-2.0703-1.8553-3.1753-0.1099-0.81068-1.0979-2.0034-2.4155-0.9084-0.92106 0.71964-2.3522 1.305-3.6484 1.1879-0.75142-0.0418-1.3858-0.0287-1.7394-1.3586z'/%3E %3Cpath d='m339.57 125.93c0.0275-0.21611-1.1122-0.31419-1.056 0.79204 0.0394 0.81891 1.019 1.0412 1.1875 0.92404 1.5411-1.1208-0.32733-0.56183-0.13141-1.7161z'/%3E %3Cpath d='m337.33 130.42c-0.30343 0.071-0.58178 1.0397 0.13261 1.0946 0.65346 0.0466 3.2135-0.22817 3.9208-0.18672 0.45755-0.0172 0.63196-0.89191-0.34883-0.84531-1.1898 0.0596-2.7536-0.23857-3.7045-0.0626z'/%3E %3Cpath d='m275.37 113.76c0.40617 0.0194 1.5196 1.4621 1.4467 1.9133-0.0502 0.21276-1.191-0.0317-1.5399-0.32661-0.25804-0.21838-0.15411-1.5984 0.0932-1.5867zm-5.3687 10.452c-1.0178 0.55514 0.16128 1.651 0.92345 1.1879 2.8611-1.8525 7.1546-3.7984 8.0518-7.4681 0.2879-1.2429 1.4431-3.1481 2.5398-3.5732 1.0596-0.41083 2.5983 1.9171 3.603 0.0853 0.58895-1.0471 2.6533 0.68715 3.1514-0.43329 0.60687-1.3533 0.31778-2.0984 0.34286-3.3946-0.0442-0.84914-0.69288-1.1028-1.1636 0.27202-0.2449 0.62252 0.043 1.251-0.1565 1.576-0.15172 0.24705-0.62479 0.48609-0.89955 0.28002-0.25327-0.18995-0.0777-0.72036-0.68453-0.95475-0.23534-0.1179-0.61284-0.21598-0.7765 0.0853-0.72036 1.2847-1.1194 2.4826-2.1276 1.1174-0.89836-1.176-1.3535-3.2088-2.0118-0.42672-0.23653 0.98187-1.7286 2.4067-2.6091 2.4067-1.0991 0-0.8231-2.8938-3.2374-2.4534-1.2412 0.26473-1.1552 2.6396-0.97004 3.5175 0.30463 1.22 3.9315 0.34369 3.7511 1.1412-0.62001 2.7712-4.4667 5.4053-7.7268 7.0348z'/%3E %3Cpath d='m247.3 137.42c-0.15411 0.46352 0.46232 1.7227 1.1014 1.8158 0.62718 0.0466 0.94734-1.3595 0.74545-1.8158-0.14933-0.33569-1.737-0.32852-1.8469 0z'/%3E %3Cpath d='m250.63 142.3c-0.40259-0.43365-1.5889 0.72992-0.62957 1.553 0.53877 0.43604 2.5123 1.0692 3.0523 0.14814 0.73111-1.1851-0.72037-5.4881-0.0777-6.0568 0.50175-0.4444 2.8277 2.8743 3.9757 3.1132 2.6975 0.37392 2.05-4.6184 4.9565-4.2792 1.9807 0.26402 2.1981-2.2113 1.9222-3.7568-0.221-1.483-2.6222-3.6238-3.726-4.5814-1.4527-1.2093-2.1002 0.89156-1.1886 1.5841 1.1731 0.93946 3.2362 2.8371 3.5648 4.0924 0.1553 0.59253-1.4336 1.7704-2.0189 1.4515-1.3511-0.73708-2.6079-3.898-3.7894-4.62-0.40259-0.24586-1.3929 0.30977-0.91628 1.296 0.53639 1.0566 2.9053 2.6932 3.0439 3.8209 0.12543 1.0286-1.0561 3.253-1.8314 3.253-0.85297 0-3.0272-2.6879-3.7057-3.953-0.33928-0.60567-1.5148-0.54714-1.6378 0.28911-0.19473 1.2556 0.18158 3.9124 0.48143 5.5586 0.23774 1.559-0.87805 1.6378-1.4754 1.0871z'/%3E %3Cpath d='m246.56 133.73c-0.33927 0.38359 0.79204 1.1338 1.0166 0.9391 0.43604-0.37751 2.1288-2.3073 1.8027-2.9818-0.29029-0.6015-2.6186-1.9187-2.9973-1.2666-0.70244 1.1287 2.1945 1.6344 1.7406 1.9653-0.2234 0.12818-1.0202 0.67855-1.5626 1.344z'/%3E %3Cpath d='m250.73 125.27s0.72752 2.4891 1.3201 1.4521c0.47905-0.71869-1.3201-1.4521-1.3201-1.4521z'/%3E %3Cpath d='m251.92 129.23c-0.2664 0.14563-1.0166 0.73996-0.52802 1.0561 0.77292 0.45718 2.8755 0.81915 2.4215-0.67605-0.27596-0.88068 3.1706 0.0245 2.3307-2.36-0.21981-0.65991-1.2591-1.6123-1.7704-1.7468-0.32494-0.0855-1.4288 0.5199-0.73828 0.85344 0.50413 0.26103 2.0249 1.1546 1.4598 1.7399-0.64152 0.61225-1.0883-0.27477-1.8863-0.13189-0.4014 0.0763-0.13977 1.2186-0.36556 1.5294-0.12663 0.17334-0.70603-0.3824-0.92345-0.26402z'/%3E %3Cpath d='m257.4 119.77c-0.43485 0.2173-1.2138 1.3963-1.2424 1.9414-0.0155 0.2909 0.30344 0.69074 0.55192 0.56662 0.45635-0.22794 1.1612-1.3438 1.1875-1.856 0.0167-0.32386-0.22698-0.78678-0.49696-0.65203z'/%3E %3Cpath d='m260.24 119.46c-0.83982-1.0267 0.8912-2.5509 1.6701-0.49601 0.47069 1.2891 5.4881 7.8921 6.5143 10.132 0.72634 1.516-0.0263 2.1423-0.92464 1.056-2.541-3.242-4.6256-7.2831-7.2598-10.692z'/%3E %3Cpath d='m265.39 119.6c0.89478-0.96932 2.7214-2.9492 2.2292-4.0533-0.3775-0.94961-1.4873-0.85524-1.6773-0.63614-1.0859 1.2962 0.77173 0.97087 0.50413 1.4135-0.55311 1.0384-1.1038 1.61-1.3894 2.608-0.0669 0.23403 0.17203 0.84257 0.3333 0.66792z'/%3E %3Cpath d='m343.17 122.84c-0.6427-0.52062 0.63196-3.044 1.4945-2.0534 2.3678 2.74 3.468 11.636 4.1525 18.294 0 0-1.0644 0.8876-1.0728 0.74664 0-3.5468-1.4252-14.397-4.5742-16.987z'/%3E %3Cpath d='m290.07 114.18c-0.76575-1.7604 1.1492-2.412 1.436-1.1572 1.3308 5.7827 4.5169 10.161 6.942 14.093 0.72992 1.2293 0.14455 1.9618-1.6307 0.83063-1.2293-0.84281-2.4777-3.9162-3.0821-4.0374-1.0943-0.20368-3.7129 4.9927-9.0696 3.5094-1.3858-0.38718-1.2938-4.5079-1.3201-6.328-0.0585-0.85332 0.88402-1.0787 0.91628 0.0853 0.049 1.6781-0.002 5.164 2.1444 5.2813 1.7501 0.0978 5.6267-2.3765 6.4438-4.3107 0.72753-1.9887-1.952-5.9413-2.7799-7.9667z'/%3E %3Cpath d='m344.61 138.38c0.42767-1.191 6.1141-10.735 6.8607-12.835 0.38228-1.0126 2.0141 1.7366 0.42051 3.2201-1.4001 1.26-5.5311 8.0342-6.3017 10.408-0.3548 1.0716-1.4312 0.56148-0.97959-0.79323z'/%3E %3Cpath d='m354.28 129.28c1.0501-3.9348 3.5934 0.60699 1.3535 2.8469-3.4584 3.3874-4.5002 9.8539-9.9871 10.827-1.479 0.31777-4.082-0.66541-4.8538-1.2137-0.30105-0.21384 0.19472-1.6187 1.1194-0.93301 1.3368 1.0441 4.0976 1.2794 5.555 0.0932 3.118-3.0606 5.6566-7.1136 6.813-11.621z'/%3E %3Cpath d='m297.27 142.02c-0.24729 0.28432-1.0035 0.23773-1.0716 0.63674-0.29747 1.4801 0 2.2304-0.32614 3.6556-0.31179 1.3643-1.2591 1.4156-1.1946 0.30343 0.086-1.4419 1.2747-3.4776 0.43484-3.6173-0.55909-0.13141-0.99035-0.87925-0.41215-1.2484 1.0919-0.75739 1.6784-0.64151 2.4287-0.41334 0.26162 0.08 0.32852 0.46471 0.14097 0.68333z'/%3E %3Cpath d='m296.5 140.09c-1.4479 1.2663-2.7906 1.7836-4.1227 3.3844-0.54475 0.65585-0.52922 1.5697-0.85416 2.406-0.32613 0.88761-1.375 1.062-1.7 0.87685-0.54356-0.35719-0.46471-2.0034-1.0716-1.117-0.51489 0.81593-0.84699 1.9401-1.608 1.9257-0.68811-0.0143-1.9867-1.4216-1.3284-1.4897 2.2519-0.23057 2.2244-2.0332 3.0678-2.1515 0.94615-0.12663 1.0083 1.4885 1.5924 1.1648 0.45874-0.23534 0.67497-2.1169 1.1731-2.6246 1.5267-1.5602 2.7345-2.3845 4.2923-3.5313 0.78845-0.62837 1.3511 0.50533 0.55909 1.1564z'/%3E %3Cpath d='m301.78 144.94c-1.1588 0.23415-0.96168 1.7238-0.62121 1.909 0.56148 0.26163 1.43 0.37153 1.7549-1.3416 0.15172-0.70363 0.2891 3.4979 1.8314 1.8792 0.88761-0.98079 3.0869 0.17799 4.008-1.056 0.65943-0.82191 0.86252-1.3953 0.34883-2.6091-0.14933-0.36914-1.0525-0.18756-1.0011 0.70841 0.0454 0.755-0.53519 1.6868-1.2902 1.5279-0.36675-0.0669 0.20667-1.8469-0.16127-2.3295-0.20309-0.26521-0.5113-0.23654-0.71319 0.0382-0.28313 0.38467 0.28432 2.0906-0.6463 2.3152-1.1743 0.27118-0.55908-1.1409-1.056-1.3989-1.5984-0.80637-1.7525 0.20906-2.4538 0.35719z'/%3E %3Cpath d='m310.83 142.08c0.84938-0.23892 0.58418-0.24012 1.921-1.3344 0.52086-0.39423 0.6236 0.75978 0.56865 1.2161-0.0968 0.77532-1.0178 0.22818-1.3033 0.91031-0.41812 0.88641-0.24848 2.9483-0.38826 3.7882-0.0956 0.43126-0.78726 0.39423-0.85296 0.0538-0.19831-1.0238 0.13977-2.0261 0.10752-3.3067-0.0108-0.43484-0.63316-1.117-0.0526-1.3272z'/%3E %3Cpath d='m305.83 139.46c-0.20548 0.92655-0.18995 1.6899-0.18995 2.3255 0.0466 0.51369 0.98557 0.18278 0.98199 0.11707-0.0466-0.81354 0.13857-1.9389-0.10155-2.2526-0.13021-0.16928-0.64271-0.36484-0.69049-0.18995z'/%3E %3Cpath d='m299.54 130.19-1.4584 5.5938-2.029-3.75v3.8438l-4.375-5.1875 1.5218 5.5625-3.9312-3.3438 2.0924 3.7812-6.9747-4.5 4.4385 5.1875-5.5798-2.75 3.9946 3.375-9.1305-3.4375 8.8135 4.3438c3.2225-1.5882 7.6406-2.5625 12.554-2.5625 4.8962 0 9.3348 0.98435 12.554 2.5625 0.0116 0.006 0.0518-0.006 0.0634 0l8.7501-4.3438-9.0037 3.4688 3.9312-3.4062-5.5164 2.7188 4.375-5.1562-6.9747 4.5 2.0924-3.7812-3.9312 3.3438 1.5218-5.5625-4.375 5.2188 0.0634-3.875-2.029 3.75-1.4584-5.5938z'/%3E %3C/g%3E %3C/g%3E %3Cpath d='m291.82 251.63c-0.00001 0.59294-0.0892 1.4489-0.26749 2.5679h-0.41461c-0.00001-0.76234-0.0357-1.3486-0.107-1.7588-0.0669-0.41014-0.20062-0.89831-0.40124-1.4645-0.16495-0.47701-0.34551-0.88271-0.54166-1.2171-0.19617-0.33881-0.51047-0.78909-0.94291-1.3508l0.82922-2.0463c0.3834 0.4904 0.65535 0.86712 0.81585 1.1301 0.18278 0.30317 0.35442 0.68434 0.51492 1.1435 0.16495 0.4592 0.292 0.94068 0.38117 1.4444 0.0892 0.50378 0.13374 1.0209 0.13375 1.5514' fill='%23fff'/%3E %3Cpath d='m298.32 247.67c-0.00001 0.62415-0.11815 1.0923-0.35443 1.4043-0.23628 0.31208-0.63975 0.53499-1.2104 0.66873 0.16495 0.57957 0.27417 1.0321 0.32768 1.3575 0.0579 0.32546 0.0869 0.6888 0.0869 1.09 0 0.25858-0.0156 0.53498-0.0468 0.82922-0.0268 0.29424-0.078 0.69102-0.15381 1.1903h-0.37448c-0.00001-0.44582-0.0245-0.82922-0.0736-1.1502-0.0446-0.32544-0.11369-0.63083-0.20731-0.91615-0.0223-0.0713-0.14044-0.38563-0.35442-0.94291-0.20954-0.56172-0.41908-1.0276-0.62861-1.3976-0.20507-0.37448-0.54167-0.8894-1.0098-1.5448l0.64197-1.9259c0.33882 0.48595 0.63529 0.82254 0.88941 1.0098 0.25411 0.1828 0.55504 0.27419 0.90278 0.27418 0.75788 0.00001 1.1368-0.41014 1.1368-1.2304h0.38786c0 0.2675 0.007 0.49041 0.0201 0.66872 0.0134 0.17388 0.0201 0.37896 0.0201 0.61523' fill='%23fff'/%3E %3Cpath d='m304.29 252.19-0.48148 2.0062c-0.30316-0.0847-0.55059-0.32321-0.74229-0.71553-0.1605-0.32545-0.27641-0.73783-0.34774-1.2372-0.0669-0.49931-0.10031-1.0165-0.1003-1.5514-0.4057 0.107-0.72669 0.1605-0.96297 0.16049-0.46811 0.00001-0.85597-0.12259-1.1636-0.3678-0.30316-0.24965-0.45474-0.56395-0.45474-0.9429 0-0.81584 0.20954-1.5492 0.62861-2.2001 0.42352-0.65534 0.90054-0.98301 1.4311-0.98302 0.41015 0.00001 0.69547 0.11592 0.85597 0.34773 0.17832 0.25413 0.28755 0.54391 0.32767 0.86935 0.0401 0.32545 0.0602 0.95405 0.0602 1.8858-0.00001 0.83369 0.0669 1.4222 0.20062 1.7654 0.10699 0.26749 0.35665 0.58848 0.74897 0.96297m-1.8056-3.3303c-0.0803-0.50822-0.34774-0.76234-0.80247-0.76235-0.19616 0.00001-0.37672 0.0535-0.54167 0.1605s-0.24743 0.20062-0.24743 0.28086c0 0.2675 0.32099 0.40124 0.96297 0.40124 0.20507 0 0.4146-0.0267 0.6286-0.0802' fill='%23fff'/%3E %3Cpath d='m310.61 251.69-0.24074 2.4342c-0.47703-0.33436-0.91839-0.93844-1.3241-1.8122-0.42353-0.91392-0.85151-2.209-1.284-3.8853-0.37003 1.6139-0.67542 2.7975-0.91615 3.5509-0.23629 0.74898-0.47034 1.2795-0.70217 1.5916-0.15603 0.20953-0.40569 0.4213-0.74897 0.63529l0.0535-2.3272c0.44136-0.60185 0.7512-1.061 0.92953-1.3776 0.26303-0.46811 0.47925-1.0142 0.64866-1.6384 0.17387-0.6286 0.3299-1.469 0.46811-2.5211h0.44136c0.27194 1.0566 0.53498 1.897 0.7891 2.5211 0.23627 0.58848 0.51268 1.1079 0.82922 1.5581 0.2229 0.31653 0.57509 0.74006 1.0566 1.2706' fill='%23fff'/%3E %3Cpath d='m328.98 274.65c0.32497 0.38098 0.55329 0.75473 0.68495 1.1212 0.12801 0.36224 0.22048 0.87984 0.27742 1.5528l-0.72521 0.0591c-0.30903-0.60477-0.60962-1.0784-0.90172-1.4208-0.22275-0.26111-0.58253-0.63238-1.0794-1.1138-0.49683-0.48142-1.0047-0.95049-1.5236-1.4072-0.52252-0.46101-1.188-0.99369-1.9966-1.598-0.28364-0.21128-0.4638-0.36187-0.54049-0.45177-0.11319-0.13269-0.20263-0.39415-0.26833-0.78437-0.0693-0.39448-0.1128-0.88494-0.13041-1.4714l2.5326 2.0598c0.95529 0.78652 1.746 1.4811 2.3722 2.0839 0.48224 0.46431 0.91504 0.92119 1.2984 1.3706m-8.9817-5.4124-0.15174 1.8623-2.9822-0.0806 0.22403-1.9006 2.9099 0.11878m7.8445 8.3364-7.1052 2.1647-1.3076-1.8069 6.1428-1.8715c-0.27881-0.38529-0.49459-0.65466-0.64729-0.80813-0.23728-0.23579-0.50854-0.4207-0.81378-0.55472-0.0197 0.34113-0.16097 0.6409-0.42377 0.89933-0.26282 0.25845-0.60239 0.45109-1.0187 0.57793-0.54602 0.16636-1.0917 0.18937-1.6369 0.069-0.54524-0.12034-0.94606-0.35767-1.2024-0.71196-0.37818-0.52257-0.58114-1.2174-0.60891-2.0846-0.0312-0.95257 0.22954-1.5131 0.78239-1.6815 0.71666-0.21834 1.6856-0.019 2.9069 0.59805 1.2212 0.61706 2.1588 1.3773 2.8126 2.2808l2.12 2.9295m-5.457-3.7938c-0.33492-0.15199-0.60288-0.24601-0.8039-0.28207-0.1974-0.0425-0.378-0.0389-0.54181 0.011-0.20476 0.0624-0.34578 0.17832-0.42306 0.34779-0.0773 0.16949-0.0582 0.33394 0.0571 0.49337 0.0737 0.10186 0.19763 0.16951 0.37177 0.20293 0.17775 0.0269 0.3656 0.0102 0.56352-0.0501 0.15699-0.0478 0.29314-0.12444 0.40847-0.22984 0.11893-0.1119 0.24156-0.27628 0.36786-0.49314m-7.612-1.4544-0.4351 1.8434-2.9552-0.2717 0.44889-1.8622 2.9415 0.29042m7.0047 7.1968-1.5782 0.36205c-0.56162 0.12885-1.0959 0.16839-1.6029 0.11863-0.50697-0.0497-0.98121-0.20821-1.4227-0.47537-0.26101 0.47503-0.71972 0.87346-1.3761 1.1953-0.43524 0.21401-0.94077 0.38707-1.5166 0.51917l-1.1197 0.25686-1.0255-1.882 1.1197-0.25687c0.59006-0.13536 0.99233-0.2484 1.2068-0.33912 0.21909-0.097 0.49354-0.26112 0.82335-0.49247-0.36157-0.22321-0.65323-0.37685-0.87497-0.46091-0.26987-0.099-0.50788-0.12479-0.71405-0.0775-0.0782 0.0179-0.14279 0.0535-0.19377 0.10673-0.0464 0.047-0.0858 0.12867-0.11836 0.24511l-0.49183 0.0661c-0.45495-0.8349-0.5588-1.4805-0.31158-1.9368 0.25182-0.46253 0.85759-0.80388 1.8173-1.0241 0.98816-0.22668 1.8322-0.2776 2.532-0.15275 0.70446 0.11863 1.1761 0.39704 1.4148 0.83524 0.1282 0.23525 0.17671 0.4784 0.14556 0.72944-0.0337 0.24645-0.15614 0.60147-0.36737 1.0651 0.14727 0.0648 0.32005 0.10302 0.51832 0.11461 0.19826 0.0116 0.37559-0.00054 0.53199-0.0364l1.5782-0.36206 1.0255 1.882m-7.5437 1.7549-1.5392 0.2414c-0.85751 0.13449-1.5619 0.003-2.1131-0.3934-0.61288-0.43741-1.1417-1.253-1.5864-2.4466l-0.75738-2.033c-0.17186-0.46128-0.40456-0.80481-0.69812-1.0306-0.14134-0.10869-0.42766-0.25254-0.85894-0.43154l0.52296-1.9696c0.56683 0.31379 1.0036 0.64292 1.3104 0.98741 0.3591 0.40173 0.66356 0.93786 0.91337 1.6084l0.52353 1.4053c0.37027 0.99393 0.72978 1.6674 1.0785 2.0204 0.2764 0.28383 0.5905 0.39815 0.94231 0.34297l1.5391-0.2414 0.72284 1.9403m-6.5774-7.0651-0.99392 1.7499-2.812-0.64929 1.002-1.7654 2.804 0.66485m1.6358 7.9213-7.0124 0.63521-0.42537-1.977 5.8922-0.53374c-0.15305-0.32205-0.36236-0.58714-0.62792-0.79527-0.13913-0.11583-0.44742-0.31021-0.92488-0.58312l0.52396-1.811c0.6487 0.36114 1.1224 0.7579 1.421 1.1903 0.30605 0.43171 0.55448 1.0909 0.74528 1.9776l0.40816 1.897m-5.6298 0.89755c-0.84343-0.028-1.5407-0.0904-2.0917-0.18713-0.55109-0.0967-1.091-0.23959-1.6196-0.42863-0.45261 0.18581-0.85462 0.30471-1.206 0.35671-0.34389 0.0523-0.85848 0.067-1.5437 0.0442l-1.8412-0.0612c-0.50454-0.0168-0.89691-0.11555-1.1771-0.29634-0.28019-0.18078-0.52137-0.47293-0.72355-0.87648-0.4466 0.39667-0.93288 0.67443-1.4588 0.83331-0.44873 0.13694-0.97807 0.19528-1.588 0.17499l-1.6153-0.0537 0.15746-1.9935 1.6153 0.0537c0.7907 0.0263 1.461-0.0959 2.0109-0.36668 0.71498-0.35345 1.1028-0.91373 1.1634-1.6809l0.73973 0.0981c-0.0274 0.15586-0.0566 0.33371-0.0874 0.53354-0.0309 0.19983-0.056 0.4219-0.0753 0.6662-0.0197 0.2492 0.0957 0.46124 0.34614 0.63613 0.25043 0.1749 0.5451 0.26798 0.88397 0.27924l1.3894 0.0462c0.91871 0.0306 1.5804-0.0307 1.9851-0.18384 0.49023-0.18455 0.75696-0.55046 0.80019-1.0977 0.009-0.11727 0.074-0.22044 0.19433-0.30953 0.072-0.0515 0.2177-0.12747 0.43705-0.22796l0.4466-0.2056c0.008 0.0933 0.009 0.22075 0.004 0.38224-0.005 0.15661-0.009 0.25935-0.013 0.3082-0.0212 0.26874-0.10966 0.62343-0.26524 1.0641 0.27166 0.0972 0.57819 0.18334 0.91959 0.25838 0.34136 0.075 0.70273 0.13605 1.0841 0.18302 0.0131-0.16613-0.064-0.38425-0.23145-0.65436-0.16743-0.27011-0.24748-0.45158-0.24013-0.54443 0.01-0.12703 0.0441-0.22387 0.10223-0.29053 0.017-0.0239 0.10579-0.0969 0.26644-0.21895l1.0267-0.81093c0.17899 0.3146 0.29988 0.60031 0.36266 0.85714 0.0707 0.2522 0.0911 0.56641 0.0614 0.94264l-0.21882 2.7704m-10.645-8.1911-1.7712 1.2539-1.3356-0.8244-1.3149 0.9805-1.7572-1.06 1.6777-1.1935 1.4181 0.79248 1.3698-1.0018 1.7134 1.0528m-2.785 7.6352-6.8649-1.1248 0.75327-1.9354 5.7682 0.94517c0.0451-0.33575 0.005-0.63246-0.12018-0.89015-0.0617-0.1413-0.23446-0.39669-0.51839-0.76618l1.5364-1.5497c0.39138 0.49306 0.59992 0.97634 0.62562 1.4498 0.033 0.4747-0.11944 1.1461-0.45729 2.0142l-0.7228 1.8571m-5.7788-0.89598-1.4847-0.3572c-0.82718-0.19901-1.2988-0.56293-1.4148-1.0918-0.13218-0.58491 0.13072-1.4531 0.78871-2.6045l1.1207-1.9611c0.25427-0.44496 0.35675-0.81428 0.30743-1.1079-0.0238-0.14137-0.13755-0.36442-0.34138-0.66916l2.1284-1.4447c0.20032 0.46565 0.27957 0.89694 0.23771 1.2939-0.0477 0.46337-0.25632 1.0185-0.62594 1.6653l-0.77464 1.3556c-0.54789 0.95877-0.82902 1.6478-0.8434 2.067-0.0149 0.3356 0.1474 0.54422 0.48676 0.62586l1.4847 0.3572-1.0696 1.8716m-3.5159-7.43-2.4095 1.0168-1.6552-1.6116 2.4303-1.0261 1.6344 1.6209m-1.0246 6.2246c-0.50104 0.59175-0.99326 1.0359-1.4767 1.3325-0.47979 0.2923-1.0171 0.47477-1.612 0.54741-0.58829 0.075-1.3338 0.0409-2.2364-0.10218-0.89965-0.13648-1.7658-0.35312-2.5985-0.64994-1.6059-0.57245-2.6835-1.205-3.2327-1.8976-0.54624-0.68595-0.52347-1.3784 0.0683-2.0774 0.50465-0.59604 1.1045-1.0912 1.7996-1.4853 0.76509-0.43622 1.9589-0.93173 3.5815-1.4866l0.36605 0.48217c-1.2678 0.49146-2.1422 0.86363-2.623 1.1165-0.4742 0.25522-0.85833 0.55649-1.1524 0.90383-0.38122 0.45025-0.32337 0.95094 0.17355 1.5021 0.50717 0.54921 1.3654 1.0394 2.5748 1.4705 1.1896 0.42403 2.316 0.63299 3.3794 0.62687 1.0634-0.006 1.7766-0.22359 2.1397-0.65239 0.22509-0.26586 0.37567-0.55549 0.45177-0.86889 0.0827-0.31104 0.13265-0.83749 0.14995-1.5794l2.3428-1.4257c0.001 0.70949-0.032 1.186-0.10052 1.4295-0.11762 0.44373-0.41968 0.9529-0.90616 1.5275l-1.0892 1.2864' fill='%23bf0000'/%3E %3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='1200' height='600' viewBox='0 0 12 6'%3E %3Crect width='12' height='2' fill='%2300732f' id='green'/%3E %3Crect width='12' height='2' y='2' fill='%23fff'/%3E %3Crect width='12' height='2' y='4'/%3E %3Crect width='3' height='6' fill='%23f00' id='red'/%3E%3C/svg%3E"},function(a,t){a.exports="data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='1000' height='700'%3E %3Crect width='1000' height='700' fill='%23d0103a'/%3E %3Crect width='680' height='700' fill='%23fedf00'/%3E %3Crect width='320' height='700' fill='%230018a8'/%3E %3Cg%3E %3Cpath fill='%23c7b37f' d='m469.37,188.48c12.051,0,16.979,10.338,29.029,10.338,7.4391,0,11.777-2.4293,18.261-6.087,4.5235-2.5618,7.4098-3.9272,12.605-3.9272,5.3188,0,8.5799,1.608,11.301,6.1669,1.5373,2.5796,2.814,7.6282,2.1378,10.525-1.2815,5.4935-2.0711,7.8814-4.2621,12.953-1.0426,2.4383-2.0278,3.8979-2.0278,6.5661,0,6.3963,8.704,8.5937,14.622,8.6852,1.2899,0.02,12.139,0.1981,18.815-6.5609-3.6222-0.1594-7.6754-2.9642-7.6754-6.5867,0-4.0992,2.8804-6.8735,6.7854-8.0573,0.74205-0.2119,2.0058,0.4432,2.6775,0.09,0.95395-0.4947,0.50765-1.5685,1.3558-2.24,1.9436-1.5547,3.2071-2.5253,5.6986-2.5253,1.6254,0,2.5779,0.2291,3.8853,1.1656,0.68913,0.4947,0.94268,1.107,1.7908,1.107,1.7846,0,2.6682-1.1309,4.4529-1.1309,1.4489,0,2.3325,0.1945,3.6044,0.8481,1.0603,0.5479,1.0367,2.3489,2.2382,2.3489,0.6008,0,3.7786-1.2953,5.4395-1.2953,3.4458,0,5.2852,1.2474,7.5117,3.8625,0.60107,0.7068,0.9852,2.1369,1.5961,2.1369,1.2303,0,4.0651,0.7924,5.832,2.5594,0.75978,0.7597,1.0966,1.1194,1.6797,2.0381,0.40663,0.654,1.0299,2.2493,1.7484,2.5256,0.84194,0.3239,1.548,0.2617,2.655,0.9714,2.5256,1.6189,4.4684,4.6622,4.3774,7.611-0.0304,0.9888-0.48176,2.3677-0.75105,3.3096-2.9409,10.284-9.9399,13.548-17.008,22.382-3.004,3.7637-5.3747,6.7673-5.3747,11.591,0,1.1664,1.436,3.3019,2.0722,4.2739-0.38862-2.2664,0.64749-5.0508,3.0433-5.1803,3.282-0.1776,5.8168,2.3176,6.2586,5.5689,0.0882,0.7598-0.19451,2.0723-0.51807,2.8492,1.7669-1.1661,4.0961-1.9543,6.2164-2.2017,1.1487-0.1238,1.813-0.1585,2.9789-0.1294,5.2453,0.1294,11.034,3.0802,14.547,6.0639,10.749,9.1305,12.049,22.492,11.462,26.203-1.3043,8.2462-0.4837,23.168-21.56,29.117,3.8977,1.6412,6.5493,4.5731,6.5493,8.1778,0,3.9227-3.0037,7.2798-6.9264,7.2798-2.2442,0-3.7992-0.5479-5.3717-2.1203-4.3822,4.3819-5.2304,8.8525-5.2304,15.054,0,3.7108,0.70688,5.9018,2.2619,9.2589,1.6431,3.5518,2.8269,5.6367,5.7957,8.1988,1.5725-2.3677,3.2336-4.0994,6.0782-4.0994,2.7566,0,5.0891,0.8836,6.2198,3.3926,0.33573,0.7598,0.0353,1.3783,0.42408,2.1203,0.49471,0.9542,1.3254,1.1664,1.8378,2.1206,0.79496,1.4664,0.018,2.7209,0.7066,4.2405,0.4418,0.9896,1.4138,1.1309,1.8378,2.1203,0.67142,1.5198,0.84815,2.5621,0.84815,4.2407,0,4.7002-4.2762,8.0576-8.9764,8.0576-1.4135,0-2.191-0.5656-3.6047-0.4241,2.686,2.6857,4.7357,3.8518,6.7854,7.0677,2.9685,4.6473,3.7105,7.9515,4.382,13.429,0.12381,1.0249,0.1416,1.6434,0.1416,2.686,0,7.0324-1.0955,11.238-4.2407,17.528-3.004,6.0253-5.5661,9.365-11.026,13.287-8.5168,6.1314-14.719,7.8986-25.02,9.8951-6.6087,1.2722-10.39,1.8378-17.105,2.2616-8.5875,0.5479-13.482,0.5657-22.052,1.131-11.238,0.7598-19.03,2.3499-26.999,10.319,3.7637,2.7563,6.361,5.4597,6.361,10.107,0,4.7706-2.9508,8.1809-7.492,9.683-1.06,0.3531-1.8375,0.035-2.8272,0.5653-1.1838,0.6185-1.1309,1.9788-2.2616,2.6857-1.9968,1.2722-3.5516,1.555-5.937,1.555-4.2055,0-7.0682-0.9894-10.037-3.9582-3.4455,2.8627-4.6118,5.4426-8.4814,7.6336-1.2725,0.7066-1.9262,1.6962-3.3926,1.6962-2.3148,0-3.3751-1.4666-5.2304-2.8272-2.9508-2.1558-4.5235-3.587-6.9267-6.361-3.5161,2.1026-5.6719,3.8166-9.7536,3.8166-2.5093,0-4.0994-0.3534-6.2198-1.6963-1.1132-0.6891-1.2899-1.714-2.4032-2.4031-1.1661-0.7243-2.1381-0.4593-3.3926-0.9894-4.718-2.032-7.7748-5.5307-7.7748-10.672,0-4.5058,2.845-7.3684,6.9266-9.2592-7.828-7.8274-15.532-9.188-26.576-9.8948-8.5343-0.5476-13.394-0.5653-21.911-1.131-6.7674-0.4592-10.531-1.1484-17.246-2.2616-5.0714-0.8304-8.075-1.0955-12.722-3.2513-15.991-7.4565-26.187-17.687-28.272-35.198-0.17671-1.5019-0.14114-2.3677-0.14114-3.8873,0-9.1176,3.5867-14.683,10.036-21.133-1.6611-0.3889-2.774,0.1589-4.3822-0.4241-4.0288-1.4666-6.9264-4.2584-6.9264-8.5523,0-1.5902,0.0707-2.6505,0.84814-4.0285,0.5476-0.9719,1.5902-1.1664,1.8375-2.2619,0.31798-1.4487-0.10603-2.4735,0.56562-3.8166,0.4415-0.9011,1.2722-1.0778,1.6963-1.9791,1.3957-2.8976,3.1452-5.2301,6.361-5.2301,2.7563,0,4.5235,1.4489,5.937,3.8166,2.686-1.2367,3.428-3.2513,4.9476-5.7954,2.5267-4.2232,3.6754-7.174,3.6754-12.086,0-3.428-0.33572-5.4423-1.4135-8.6936-0.7775-2.3322-1.0958-3.9224-2.8272-5.6541-1.5728,1.5724-3.1278,2.1203-5.3717,2.1203-4.4883,0-7.916-3.8521-7.916-8.3401,0-3.3397,1.6431-5.8132,4.6648-7.2092-2.4209-2.0849-4.5235-2.2619-7.2092-3.9579-4.082-2.5799-5.5129-5.301-8.1989-9.3298-1.7495-2.6328-2.2087-4.4703-3.11-7.4917-1.0778-3.6399-1.6963-5.8134-1.6963-9.6123,0-0.9894,0.018-1.5725,0.14115-2.5444,1.0074-7.6687,2.3857-12.475,7.2095-18.518,2.8624-3.587,4.8063-5.7957,9.047-7.6333,3.6044-1.555,5.7602-2.686,9.683-2.686,1.1838,0,1.873,0,3.0394,0.1416,1.8021,0.2297,2.9508,0.3887,4.5232,1.2723,0.6008,0.3357,1.6963,1.3428,1.6963,0.6359,0-0.8126-0.42405-1.2367-0.42405-2.0497,0-3.251,2.3325-6.2195,5.5838-6.2195,2.35,0,3.3042,2.0672,4.4529,4.0995,0.74206-1.2371,1.1307-2.0852,1.1307-3.5342,0-5.3716-2.8801-8.1102-6.2195-12.298-7.2801-9.0999-16.398-13.358-16.398-25.02,0-3.4809,1.6786-5.8488,4.6648-7.6332,0.86585-0.5127,2.0297,0,2.8779-0.5425,0.72432-0.4596,0.64133-1.395,1.1008-2.137,0.72433-1.1484,1.3656-1.6419,2.3731-2.5256,1.6608-1.4486,3.1193-1.0147,4.9568-2.2869,0.91878-0.6362,1.1357-1.4624,1.8426-2.3106,2.0497-2.4737,3.8895-3.668,7.1231-3.668,1.6256,0,2.5377,0.01,4.0395,0.607,0.51244,0.1945,1.4698,0.9669,1.5942,0.8174,0.32387-0.3883,1.2013-1.3183,2.2436-1.813,1.3606-0.6537,1.9124-0.9067,3.4322-0.9067,1.7314,0,2.866,0.9714,4.5975,0.9714,0.63624,0,0.78286-0.6354,1.2953-0.9714,1.5373-1.0423,2.422-1.6315,4.295-1.6315,1.8024,0,2.7979,0.5951,4.3175,1.5668,1.4312,0.9013,1.6372,2.1082,3.1038,2.9564,0.81268,0.4772,1.5018,0.2651,2.4032,0.5656,4.0285,1.3428,7.0679,4.0285,7.0679,8.2692,0,2.2971-0.5479,3.9404-2.2619,5.4423-1.3606,1.2015-2.6505,0.9896-4.382,1.555,5.619,4.488,10.508,5.6012,17.682,5.6012,6.5732,0,14.612-2.6868,14.612-9.2597,0-3.0571-1.6898-4.6994-2.8914-7.5089-2.1558-5.0004-3.3253-7.9422-3.3253-13.384,0-4.3116,0.46964-6.9272,2.9789-10.426,2.5796-3.6045,5.7316-4.445,10.167-4.445z'/%3E %3Cg fill='none' stroke='%23703d29'%3E %3Cpath stroke-width='1.041' stroke-linejoin='round' d='m425.59,223.46c0.43223,1.6315,1.7517,3.1604,3.8197,3.8068,1.2441,0.3886,4.1208,0.233,5.9868-2.177,1.5125-1.9537,1.3969-4.3735,0.83211-6.2968-0.36581-1.2447-1.3707-2.4457-2.6981-3.4683l-7.9374,8.0568-0.002,0.079z'/%3E %3Cpath stroke-width='1.037' stroke-linecap='round' d='m626.61,343.94c-1.866-4.5092-6.6863-2.4879-6.9827,0-0.68323,5.7321,4.3395,7.4638,7.9158,6.5307,1.7714-0.4621,3.0673-1.5778,3.8957-3.0313,0.93454-1.64,1.2171-3.7797,0.61008-5.8235-0.27492-0.9269-0.66242-1.7073-1.3254-2.581-0.66579-0.878-1.3544-1.4791-1.9993-1.8905-1.3755-0.8779-2.8739-0.9646-5.2239-0.9646-8.7079,0-16.327,10.289-18.886,20.977-0.84278,3.52-2.0013,11.371-0.39592,18.815,1.7104,7.9301,5.1381,13.42,9.1598,17.585,2.1769,2.2546,5.1457,4.2618,8.9896,6.4351,1.1856,0.6705,4.3198,2.0609,6.4967,2.6831,2.2357,0.6388,4.3,0.5454,6.1582,0.1418,5.1598-1.1205,7.559-5.9189,4.9597-10.829-2.1279-4.0201-8.3967-6.2198-11.351-1.0885-0.25071,0.4353-0.64103,1.3836-0.62835,2.4107,0.0158,1.3682,0.58418,3.0172,1.5612,3.6391,2.2458,1.4292,5.8382,1.0251,5.6713-2.9401'/%3E %3Cpath stroke-width='1.276' d='m599.69,403.07c1.7478-2.0561,5.7569-5.1403,10.343-5.7034,4.6541-0.5718,8.6986,0.7837,12.828,3.0048,8.0596,4.3347,12.554,8.9947,15.549,17.641,0.76063,2.1952,1.3915,5.5055,1.3037,9.0211-0.14025,5.604-1.5629,11.73-3.0917,14.692-1.3336,2.5835-4.8204,13.994-23.946,21.868-11.161,4.5949-28.3,5.6538-40.118,6.1204-16.256,0.6416-31.254,1.2438-39.962,11.973'/%3E %3Cg stroke-width='1.121'%3E %3Cpath d='m603.75,421.45c-0.46629-1.7104-0.0349-3.3501,1.3217-5.209,1.8139-2.4856,5.6756-3.3431,9.1745-1.3994,1.1703,0.6503,2.6378,1.5066,3.9649,3.2653,0.50202,0.6653,1.3504,1.7391,1.7883,2.4879,1.0586,1.8108,1.494,3.2927,1.703,3.8875,3.8453,10.928-2.2655,22.771-10.255,27.522-6.2062,3.6906-13.608,5.3357-22.469,6.3751-3.9826,0.4674-6.2569,0.4368-10.263,0.6222-3.2237,0.1493-6.0082,0.096-8.63,0.064-2.1575-0.027-4.2049-0.016-6.2969-0.064-3.4156-0.079-6.9497-0.1589-11.274,0.1556-4.5497,0.3309-7.9729,0.4477-11.818,1.0884-2.5118,0.4187-5.4558,0.8226-8.5422,1.5151-0.92609,0.2075-1.8651,0.3773-2.8092,0.6618-0.63398,0.1912-1.2604,0.3853-1.8811,0.5746-5.5717,1.6994-10.985,3.7697-15.257,6.5209-1.3198,0.8501-2.8106,1.7011-3.8771,2.7079-0.66466,0.627-1.472,1.2565-2.1237,1.8978-2.9899,2.9415-6.0473,6.1261-6.7623,10.438-0.13192,0.7955-0.13169,1.6293-0.13169,2.507,0,2.7988,2.2774,6.6084,8.4195,7.8524'/%3E %3Cpath d='m516.37,229.11c1.2852,2.3241,1.992,3.7378,1.2441,6.1421-0.84731,2.7231-2.7783,4.3538-5.5202,4.3538-6.2198,0-9.8782-7.3642-7.075-12.051,4.976-8.3187,14.539-3.6466,23.402,0.4739-0.42746-2.1338-1.1734-2.8278-1.0958-5.4712,0.19315-6.5642,5.061-9.5412,7.0046-15.605,1.1577-3.6124,1.6183-6.7497-1.0251-9.3155-2.3078-2.2396-4.9819-2.2056-7.9937-1.0248-6.0174,2.3587-13.246,9.1373-25.97,9.3256-12.724-0.1883-20.012-6.9669-26.03-9.3256-3.0115-1.1808-5.686-1.2148-7.9934,1.0248-2.6435,2.5658-2.1831,5.7031-1.0252,9.3155,1.9436,6.0641,6.8116,9.0411,7.0043,15.605,0.0779,2.6434-0.66833,3.3374-1.0955,5.4712,8.8633-4.1205,18.798-9.2119,23.402-0.4739,2.5652,4.8688-0.85519,12.051-7.0752,12.051-2.7417,0-4.6673-1.7481-5.5199-4.3538-0.76005-2.3227,0-4.3538,1.2441-6.1421'/%3E %3Cpath stroke-linecap='round' d='m491.5,224.79c2.4029,1.8378,4.0994,4.0994,3.8166,7.7748-0.30645,3.9863-1.2722,4.9476-4.382,7.0679'/%3E %3Cpath stroke-linecap='round' d='m494.68,233.7c-0.14115,2.4029-1.1307,3.9579-3.5338,4.9473'/%3E %3C/g%3E %3Cpath fill='%23c7b37f' stroke='none' d='m432.4,214.49,1.0884,0.7775,1.1661,1.2441,0.7775,1.555,0.38862,1.3217,0.0779,1.7104-0.0779,1.1661-0.38862,1.3217-0.7775,0.9328-0.93312,1.0109-1.3214,0.6998-1.7106,0.3886-1.477,0.2333-1.555-0.6999-1.3994-1.0105-0.85517-1.244-0.62218-1.555,0-0.6219,7.6195-7.2306z'/%3E %3Cpath stroke-width='1.041' stroke-linecap='round' d='m430.01,220.57c-0.47838-2.5813-3.4958-3.1109-4.6648-1.586-1.8001,2.3478-0.48513,6.2572,3.1759,7.4014,1.2438,0.3889,4.1205,0.2333,5.9865-2.1769,1.5125-1.9537,1.3969-4.3735,0.83208-6.2969-0.36552-1.2446-1.3642-2.3294-2.6981-3.3435-4.2511-3.2333-11.118-2.4879-13.373,2.9541-2.9086,7.0203,3.421,12.284,9.2522,16.249,7.3409,4.9918,15.705,5.8996,22.003,5.8312,14.306-0.1556,25.19-6.9973,32.265-10.884,1.6482-0.9056,3.3453-0.7207,4.1982,0.3109,0.96295,1.1644,0.94748,3.0428-0.38861,4.2759'/%3E %3Cpath stroke-width='1.057' d='m387.6,414.35-3.1877,1.1663-3.2654,2.4879-1.3994,1.9436-1.7883,3.1098-0.7775,2.3325-0.6219,2.8768-0.31096,2.1766'/%3E %3Cpath stroke-width='1.057' d='m405.95,414.66-0.23327,2.7991-0.46629,1.9436-1.3997,3.343-2.1769,2.8768-2.3325,1.8659-1.7104,0.8552-2.4102,0.5443'/%3E %3Cpath stroke-width='1.197' d='m499.6,489.23c-0.57969,2.5878-3.0039,5.5484-8.279,6.6169,0,0-0.62556,0.1292-1.0254,0.2118'/%3E %3Cpath stroke-width='1.356' d='m631.59,406.57c3.3394,3.114,5.6851,6.905,7.488,12.109,0.76064,2.1952,1.3912,5.5056,1.3034,9.0211-0.1398,5.6041-1.5626,11.73-3.0917,14.692-1.3333,2.5838-4.8201,13.994-23.946,21.868-11.161,4.5953-28.3,5.6539-40.118,6.1205-16.022,0.6326-30.822,1.2266-39.582,11.516'/%3E %3Cpath stroke-width='0.929' d='m605.45,416.95c1.1881-1.6211,5.5174-3.6734,9.0163-1.7295,1.1515,0.6397,2.5163,1.4487,3.7136,3.2426'/%3E %3Cpath stroke-width='1.356' d='m627.51,402.79c0.78229,0.3008,1.5604,0.5718,2.2436,0.7671,2.236,0.6387,4.3372,0.6883,6.1584,0.1418,4.4225-1.3265,7.2612-5.4589,4.9597-10.829-0.53383-1.2452-1.5556-2.4392-2.7164-3.3335'/%3E %3Cpath stroke-width='1.041' stroke-linecap='round' d='m375.44,287.13c-2.9685,1.8378-5.1823,2.2728-7.492,4.9475-2.2994,4.5531-3.2034,6.9991-4.1002,10.65'/%3E %3Cpath stroke-width='1.041' stroke-linecap='round' d='m435.88,221.96c0,2.6856-1.9791,4.3819-4.6648,4.9475'/%3E %3Cpath stroke-width='0.997' d='m620.49,275.03c7.3898-0.1509,28.859,5.6392,29.012,30.876,0.15083,24.925-15.383,28.997-21.607,30.656'/%3E %3Cpath stroke-width='1.037' d='m622.43,275.03c12.743-0.5541,25.892,8.8261,26.472,32.236,0.45249,18.289-12.517,26.584-18.742,28.243'/%3E %3Cg stroke-width='0.881'%3E %3Cpath d='m615.33,363.16,0.19608-2.5022,0.83407-3.9739,1.1774-3.0909,1.3245-2.5512,1.7171-2.0606'/%3E %3Cpath d='m632.74,343.67-0.19451,2.449-0.69985,1.6718-1.0884,1.5939-1.2438,0.9328-1.9048,0.6996-1.6715,0.1168-1.2441-0.1945'/%3E %3Cpath d='m602.33,268.42,0.54422-2.6435,1.1661-2.449,1.5162-2.4491,2.6046-3.343,2.0601-2.2937,3.343-3.3818,2.8767-2.9156,1.8271-2.0993,2.4102-2.9153,2.1381-3.2265,1.2829-2.6435,0.69955-3.4207,0.21252-4.2418-0.3886-1.2302'/%3E %3Cpath d='m605.44,429.44,2.527-0.5054,1.9048-1.0108,1.0496-1.0496,0.73867-1.205,0.5054-1.9436,0.0388-1.3606'/%3E %3Cpath d='m364.94,403.38,1.8662,0.1555,2.4099-0.1945,2.4102-0.8552'/%3E %3Cpath d='m379.44,345.38-0.31093,2.1769-0.50539,0.9717-0.73869,0.9331-1.0108,0.7773-1.1273,0.5054-1.4773,0.2332-1.0108,0.078'/%3E %3Cpath d='m388.73,326.65-0.54424,3.3819-0.66072,1.4774-1.3606,1.8659-1.8271,1.3994-1.866,0.9328-3.6154,0.8941'/%3E %3Cpath d='m402.76,274.48-0.69956,2.0213-0.85516,1.4774-1.1664,1.6326-1.6327,1.4771-1.9436,0.9331-1.6327,0.3886-1.0108-0.078'/%3E %3Cpath d='m394.41,272.65,0.0391,1.555'/%3E %3C/g%3E %3Cg stroke-width='0.987'%3E %3Cpath stroke-linecap='round' d='m397.32,325.09c-1.1273,1.0105-2.2503,1.6304-3.2654,2.0289'/%3E %3Cpath stroke-linecap='round' d='m629.24,397.16c0.1335,0.1447,0.58137,0.2172,0.73866,0.3109,2.2157,1.3217,6.5774-0.3264,5.2945-3.7474'/%3E %3Cpath d='m621.54,349.38c1.5725,2.0547,4.5384,2.588,6.8827,1.9765,1.7717-0.4621,3.0676-1.5781,3.8957-3.0312,0.93454-1.64,1.2173-3.7798,0.61038-5.8239-0.27522-0.9266-0.66242-1.7069-1.3254-2.581-0.66608-0.8777-1.492-1.8111-2.1322-2.2298-0.16974-0.111-0.33908-0.2614-0.51834-0.383'/%3E %3Cpath d='m638.99,390.46c0.0678-0.365,0.10333-0.7409,0.10333-1.125,0-1.8105-0.75725-3.468-2.0092-4.5857-0.42746-0.3816-0.84138-0.9736-1.3594-1.2328'/%3E %3Cpath d='m636.47,384.25c-0.0727-2.9123-2.456-4.9954-5.4099-5.5135'/%3E %3Cpath d='m624.54,383.17c-0.67874-0.5544-1.4064-1.0246-2.0418-1.6895-3.8259-4.0044-6.7038-9.9242-6.7423-16.677-0.0369-6.4737,2.5658-13.062,5.5979-15.627'/%3E %3Cpath d='m533.07,481.44,2.7988-2.5658,1.9439-1.4771,3.654-2.2546,3.421-1.6326,2.4102-0.6222,4.8204-1.0882,5.5979-0.8554'/%3E %3Cpath d='m511.61,501.2c-2.0216,3.11-6.842,7.7747-11.896,9.6407-5.0536-1.866-9.8738-6.5307-11.895-9.6407'/%3E %3Cpath stroke-linecap='round' d='m491.28,494.73c-0.63372,2.3489-1.7852,4.626-3.4677,6.4511'/%3E %3Cpath d='m491.78,491.47-0.69983,3.4206'/%3E %3Cpath d='m487.43,501.42-1.4771,1.4773-2.6435,1.4771-3.0321,0.9331'/%3E %3Cpath d='m471.46,227.45c0.37933-1.1821,0.7671-2.0719,0.70996-4.0144-0.19315-6.5642-5.0607-9.5412-7.0046-15.606-1.1577-3.612-1.618-6.7494,1.0254-9.3152,2.3075-2.2396,4.9816-2.2058,7.9934-1.0251,6.0174,2.359,13.308,9.1376,26.032,9.3259-12.724-0.1882-20.015-6.9669-26.032-9.3259-3.0118-1.1807-5.9347-1.5255-8.2425,0.7142-2.6432,2.5658-1.9341,6.0141-0.77639,9.6261,1.9439,6.0644,6.5628,9.0414,6.7558,15.606,0.0572,1.9425-0.45501,2.8323-0.83406,4.0144'/%3E %3Cpath d='m500.18,206.37c12.517-0.661,23.245-9.0712,26.706-9.7573,3.0856-0.612,4.8086-0.3354,7.0721,1.7213-2.2636-2.0567-4.8418-1.9931-7.7706-0.845-6.0175,2.359-13.246,9.1376-25.97,9.3259'/%3E %3Cpath d='m624.59,383.2c-5.209-3.7319-9.672-10.856-9.7184-19.274-0.036-6.4739,2.5655-13.061,5.5976-15.627'/%3E %3Cpath d='m511.17,500.76c-2.0213,3.1097-6.8416,7.7748-11.895,9.6404-5.0536-1.8656-9.874-6.5307-11.895-9.6404'/%3E %3Cpath stroke-linecap='round' d='m479.17,230.74c1.3018-0.7209,2.5101-1.4064,3.6244-2.0184,1.6482-0.9056,3.6292-0.7157,4.4821,0.316,0.96266,1.1644,1.1104,3.1826-0.22542,4.416'/%3E %3Cpath d='m460.48,239.49c8.5875-1.7922,15.585-5.6381,20.875-8.5967'/%3E %3Cpath d='m531.78,487.43c0.70997,0.4843,1.1661,1.4926,1.1661,1.4926,0.19675,0.4685,0.45052,0.9114,0.52088,1.3268,0.40352,2.3784-1.156,3.8605-3.0828,4.0848-2.6477,0.3078-4.6352-1.2652-5.4825-3.17'/%3E %3Cpath d='m460.04,239.05c8.5875-1.7925,15.585-5.6384,20.875-8.5968'/%3E %3Cpath d='m633.38,397.49c-1.6327,0.6292-2.5258,0.544-4.557-0.3579-0.8338-0.3703-1.7883-0.9435-2.9066-1.5784-3.9807-2.2607-8.7079-5.8238-13.139-14.143-1.3105-2.4602-2.1246-4.7432-2.6728-6.9922-0.42266-1.7354-0.71587-3.4505-0.7792-5.2112-0.10783-3,0.21499-6.1323,0.96381-9.721,1.2365-5.9254,2.7251-9.1432,6.3754-14.15,1.7953-2.4622,3.3433-3.9649,6.6863-4.0425'/%3E %3Cpath d='m398.83,279.88c2.7794,2.3623,4.1208,5.2866,4.1208,8.9409,0,4.8409-4.0502,12.75-14.002,15.549-3.8138,1.0724-7.5882,0.2073-9.8706-1.1807'/%3E %3Cpath d='m400.46,296.28c1.7883,1.2438,2.4881,2.6406,2.4881,5.0697,0,1.6647-1.0763,3.8228-2.9074,5.8666-2.9977,3.3461-8.0821,6.1897-13.716,6.2603-3.0563,0.038-6.2294-0.6008-9.4218-2.7358-3.4131-2.2821-5.2093-5.3643-5.9868-8.3967'/%3E %3Cpath d='m400.3,306.71c2.0258,1.8623,2.648,4.1932,2.648,7.129,0,4.2891-1.7424,7.5998-5.7493,11.107-0.89598,0.784-1.9048,1.5187-3.0329,2.1783'/%3E %3Cpath d='m596.4,292.63,0,5.5188'/%3E %3Cpath d='m595.96,291.27,0,7.774'/%3E %3Cpath d='m596.4,274.44,0,10.185'/%3E %3Cpath d='m595.96,272.19,0,13.918'/%3E %3Cpath d='m592.99,414.17c-1.9304,3.8352-3.4727,5.8492-6.5307,8.8632-3.0855,3.0408-5.2239,4.4343-9.0965,6.3751-3.7719,1.8905-6.1477,2.4916-10.263,3.421-4.1124,0.9286-6.5175,1.131-10.729,1.3215-3.8619,0.1751-6.0529,0.014-9.9095-0.2544-4.1276-0.2856-6.4168-0.8608-10.538-1.2227-3.4038-0.2988-5.3263-0.5741-8.7434-0.5656-3.5122,0.01-5.5247,0.031-8.9831,0.6433-3.2234,0.5709-5.052,1.0257-8.0857,2.2548-4.1976,1.7005-8.9412,4.6648-9.9517,5.9865-1.0108-1.3217-5.7541-4.286-9.952-5.9865-3.0338-1.2291-4.8623-1.6839-8.0855-2.2548-3.459-0.6124-5.471-0.6346-8.9834-0.6433-3.417-0.01-5.3395,0.2668-8.7434,0.5656-4.1211,0.3619-6.4106,0.9371-10.538,1.2227-3.8566,0.2668-6.0473,0.4294-9.9092,0.2544-4.212-0.1905-6.6174-0.3903-10.729-1.3215-4.1149-0.9317-6.4888-1.5347-10.263-3.421-3.8752-1.9368-6.011-3.3343-9.0965-6.3751-0.33318-0.3286-0.64864-0.6452-0.94832-0.9536'/%3E %3Cpath d='m478.8,505.47,2.7988-0.3497'/%3E %3Cpath d='m528.9,501.44,2.825-0.269,2.6907-1.0763,1.8834-1.1437,2.5562-3.027,0.53774-1.1436,0.40382-2.6235,0.13462-1.2108'/%3E %3Cpath d='m613.23,277.36c1.2131-4.1276-0.2676-8.4831-4.2663-8.3657'/%3E %3Cpath d='m402.79,341.75c-1.0136,3.4281-3.1939,5.7702-5.6198,7.2934'/%3E %3Cpath d='m402.86,276.05c-0.99953,2.8889-2.8289,4.953-5.7237,6.2604-2.8866,1.3037-6.2274,0.086-8.014-1.2922'/%3E %3Cpath stroke-linecap='round' d='m380.95,291.2c2.3922,1.2526,4.8195-0.5836,4.3217-3.6959-0.23329-1.4576-1.8052-3.2988-3.9328-3.4333'/%3E %3Cpath d='m390.87,422.86c0.51553,0.4852,0.62583,1.1149,1.3218,1.2438,1.0496,0.1945,1.866,0.5831,2.9156-0.8163,1.2939-1.725,0.59855-4.4082-0.7474-6.0974-1.4405-1.808-5.6134-3.4055-9.112-1.4616-1.1706,0.6503-2.6381,1.5063-3.9652,3.2654-0.50172,0.6649-1.3504,1.739-1.788,2.4878-1.0589,1.8108-1.494,3.2924-1.7033,3.8873-3.2012,9.0979,0.59995,18.664,6.4885,24.493'/%3E %3Cpath stroke-linecap='round' d='m531.59,487.23c0.63794,0.6647,1.0105,1.2441,1.0105,1.2441,0.19675,0.4682,0.35708,0.9112,0.42773,1.3268,0.40323,2.3784-1.156,3.8605-3.083,4.0845-2.6477,0.3082-4.4197-1.2519-5.2672-3.1567'/%3E %3Cpath d='m608.5,216.81c5.2278,0.6376,9.7837,5.6277,9.7837,10.992,0,6.9194-2.3311,9.4961-5.9741,14.446-3.8985,5.2973-16.638,15.005-16.638,26.045,0,6.6864,1.866,10.962,6.6863,13.139,3.1081,1.4036,6.7423-0.1157,8.3967-1.6107,4.0429-3.6543,2.4265-10.062-1.788-10.828-5.1316-0.9332-6.096,7.145-1.0885,6.6083'/%3E %3Cpath d='m635.73,383.51c-0.45954-2.7701-2.8132-4.8795-5.648-4.8795-3.1638,0-5.7287,2.628-5.7287,5.87,0,1.5877,0.61514,3.0281,1.6147,4.0848'/%3E %3Cpath d='m599.79,279.88c-2.7794,2.3623-4.1208,5.2866-4.1208,8.9409,0,4.8409,4.0502,12.75,14.002,15.549,3.8135,1.0724,7.4574,0.9714,9.7398-0.4168'/%3E %3Cpath d='m375.61,287.8c-2.3784,0.7938-5.3486,2.2774-7.5497,5.3953-1.8561,2.6297-2.9384,6.2856-3.6087,9.4846-0.29321,1.3999-0.64301,5.832,0.2524,10.41,0.6613,3.3805,2.0573,6.5271,3.6016,8.8064,0.5535,0.8169,1.0558,1.3671,1.6206,1.9318,0.51778,0.5178,1.2528,0.9751,1.7737,1.3727'/%3E %3Cpath d='m471.72,469.02c7.5764,3.3588,13.13,5.8745,17.839,13.31,1.4771,2.3325,1.866,5.6756,1.866,7.6192,0,4.1982-1.7106,8.9409-5.2093,11.895-3.2462,2.7414-6.4531,3.5763-10.418,3.1877-3.007-0.2949-5.8309-2.4878-6.2974-4.0428'/%3E %3Cpath d='m396.88,325.2c4.2762,3.3431,6.0644,6.5862,6.0644,11.74,0,5.9085-2.8767,9.5627-6.2201,11.662'/%3E %3Cpath stroke-linecap='round' d='m392.99,344.41c6.3751,7.9301,9.7578,12.637,9.9517,22.08,0.18146,8.8627-2.6435,14.927-7.9304,21.303'/%3E %3Cpath d='m515.23,239.57c1.1591-0.7609,2.0098-1.9791,2.4974-3.4848,0.75302-2.3252,0.76908-4.3077-0.47471-6.0957,1.5345,2.0081,1.6757,3.7043,1.2438,6.1418-0.27465,1.5522-1.2644,2.3685-2.4974,3.4849'/%3E %3Cpath d='m596.4,374.24,0,25.241,0.0668,0c0,0.018-0.009,2.3888-0.21183,3.8872-0.13305,0.9824-0.27155,1.8705-0.42857,2.7023'/%3E %3Cpath d='m595.96,371.81,0,27.223,0.0673,0.0003c0,0.018-0.009,2.3885-0.21183,3.8872-0.21184,1.5624-0.43701,2.8869-0.72939,4.1245'/%3E %3Cpath d='m595.96,339.94,0,22.702'/%3E %3Cpath d='m596.4,341.73,0,18.463'/%3E %3Cpath d='m596.4,318.25,0,13.841'/%3E %3Cpath d='m595.96,316.62,0,17.064'/%3E %3Cpath d='m596.4,304.1,0,5.3693'/%3E %3Cpath d='m595.96,303.01,0,7.7762'/%3E %3Cpath d='m593.08,412.65c-0.16546,0.3503-0.34189,0.7108-0.5296,1.0842-1.9304,3.8352-3.473,5.8492-6.531,8.863-3.0853,3.0411-5.2236,4.4343-9.0965,6.3754-3.7716,1.8901-6.1475,2.4915-10.263,3.421-4.1121,0.9286-6.5175,1.1309-10.729,1.3214-3.8617,0.1747-6.0529,0.011-9.9092-0.2547-4.1276-0.2853-6.4168-0.8605-10.538-1.2224-3.4038-0.2991-5.3263-0.5743-8.7431-0.5656-3.5124,0.01-5.5244,0.031-8.9831,0.6433-3.2234,0.5707-5.052,1.0254-8.086,2.2546-4.1976,1.7007-8.9409,4.6647-9.9517,5.9865-1.0108-1.3218-5.7538-4.2858-9.9517-5.9865-3.0338-1.2292-4.8623-1.6839-8.0857-2.2546-3.4587-0.6123-5.471-0.6345-8.9834-0.6433-3.4168-0.01-5.3393,0.2665-8.7431,0.5656-4.1214,0.3619-6.4108,0.9371-10.538,1.2224-3.8566,0.2668-6.0473,0.4294-9.9095,0.2547-4.212-0.1904-6.6171-0.39-10.729-1.3214-4.1146-0.9323-6.4891-1.534-10.263-3.421-3.8749-1.9378-6.0113-3.3343-9.0965-6.3754-1.6155-1.5922-2.8081-2.9055-3.8583-4.3555'/%3E %3Cpath d='m406.42,413.26c0.66553,4.9422-1.4129,9.7995-3.5228,12.034-1.3217,1.3994-4.2005,4.0736-7.7748,4.1205-5.9088,0.078-7.6726-3.9863-8.0306-4.9757'/%3E %3Cpath d='m399.4,410.7c1.0966,1.0829,2.07,2.4049,2.8934,3.965,1.4771,2.7988,1.022,7.4801-0.14834,9.6407-0.12856,0.2375-0.28789,0.4894-0.47474,0.7482'/%3E %3Cpath d='m370.04,453.2c3.5136,3.6874,8.8275,7.692,16.99,11.052,11.161,4.5953,28.3,5.6539,40.118,6.1205,15.715,0.6204,30.193,1.266,39.01,10.998'/%3E %3Cpath d='m493.29,475.01c2.5982,2.556,5.247,5.2954,6.3658,8.798'/%3E %3Cpath d='m488.18,501.7c-0.33966,0.3625-0.70069,0.7066-1.0831,1.0297-3.2462,2.7411-6.4531,3.5763-10.418,3.1874-3.007-0.2947-5.9077-2.5478-6.6852-4.0252'/%3E %3Cpath d='m461.63,497.35c0.14498,0.1981,0.29742,0.3906,0.45726,0.5766,1.8876,2.1983,4.8674,3.576,7.9777,3.8332'/%3E %3Cpath d='m512.05,501.64c-2.0216,3.1098-6.842,7.7745-11.895,9.6405-5.0537-1.866-9.874-6.5307-11.896-9.6405-0.16344-0.2518-0.3208-0.4938-0.4719-0.7266'/%3E %3Cpath d='m512.13,501.62c0.36074,0.3917,0.74626,0.7624,1.1562,1.1088,3.2462,2.7411,6.4531,3.5763,10.418,3.1874,3.007-0.2947,5.395-2.3036,6.3596-4.0429,0,0,0.54113-0.5816,0.69252-1.1366'/%3E %3Cpath d='m529.75,500.99-1.1605,1.8666-1.7655,1.4633-2.6739,1.1098-2.4214,0.1011'/%3E %3Cpath d='m536.03,483.22c1.4306,1.0969,2.8354,2.7594,3.5985,4.5342,0.49076,1.1411,0.71813,2.3956,0.78792,3.6976,0.13215,2.4682-0.73502,4.7413-2.2228,6.4739-1.9974,2.326-5.113,3.7336-8.4288,3.8664-0.24679,0.01-0.49188,0.011-0.73445,0'/%3E %3Cpath d='m529.32,501.35,0,0c-3.1706,0.1271-6.0037-1.2312-8.0925-3.3754'/%3E %3Cpath d='m620.72,391.93c-2.4738-2.2799-5.0362-5.4397-7.5069-10.077-1.3105-2.4603-2.1246-4.7433-2.6725-6.9925-0.42292-1.7354-0.71587-3.4505-0.77917-5.211-0.10784-3.0002,0.21498-6.1322,0.96378-9.7212,1.2362-5.9251,3.4426-10.509,6.3754-14.15,0.99982-1.2418,2.1544-2.7915,3.2507-3.4879'/%3E %3Cpath d='m618.2,223.83c3.9652,0.3109,7.6386,4.5792,7.5902,8.7639-0.0703,6.0782-2.1082,8.5894-6.8906,14.545-4.1205,5.1313-16.482,14.15-16.171,22.78,0.0551,1.5316,0.88023,3.1154,1.8021,4.3895'/%3E %3Cpath d='m599.59,279.72c0.87826,0.8672,1.9405,1.5839,3.2068,2.1558,2.2613,1.0212,4.8012,0.4952,6.6543-0.4432'/%3E %3Cpath d='m576.37,213.9c1.3276,0.9044,2.6814,2.2909,3.4151,4.0614,2.9082,7.0204-3.421,12.284-9.2522,16.249-4.181,2.8429-8.6941,4.3614-12.968,5.1288'/%3E %3Cpath d='m569.69,227.43c-1.4138-0.014-3.0945-0.417-4.9203-2.3393-0.42041-0.4426-0.91259-1.0276-1.1053-1.553'/%3E %3Cpath d='m540.45,231.2c-0.73839-0.3703-1.5314-0.9092-2.0626-1.5038-1.3864-1.5505-2.3103-3.6498-1.2424-6.8532,0.98742-2.9626,5.7462-11.274,5.9794-17.027,0.35626-8.7895-3.0242-13.977-8.312-16'/%3E %3Cpath stroke-linecap='round' d='m542.68,203.85-0.20644,3.3051-0.89485,3.374-1.7213,4.6129-1.3082,2.9606-1.3769,2.9609-0.68858,2.0658-0.2755,1.5148,0.20688,1.4458'/%3E %3Cpath stroke-linecap='round' d='m595.81,423.4c0.27211,0.6607,0.93284,1.3059,0.93284,1.3059,1.0108,1.6873,4.9402,4.6547,8.5146,4.7016,5.9088,0.078,7.3119-4.0572,7.4638-4.9757,0.746-4.5088-0.79607-5.7425-3.11-7.0127,0,0-1.3617-0.7055-2.9944-0.4334'/%3E %3Cpath d='m370.23,403.67c-2.086,0.5341-4.0454,0.547-5.7574,0.033-4.4228-1.3265-8.0067-5.5636-6.1795-10.829'/%3E %3Cpath d='m379.21,343.15c0.44292,0.4446,0.58559,1.1076,0.65284,1.6701,0.68324,5.7318-4.3395,7.4016-7.9158,6.4685-1.7714-0.462-3.8824-2.1068-4.7106-3.56-0.59713-1.0473-0.95902-2.2987-0.9621-3.5988'/%3E %3Cpath d='m400.74,307.15c0.89571,0.8234,1.517,1.7382,1.9315,2.7566'/%3E %3Cpath d='m400.9,296.6c0.82957,0.5771,1.425,1.3116,1.8249,2.0424'/%3E %3Cpath stroke-linecap='round' d='m402.91,303.94c-0.48316,1.1906-1.3172,2.4752-2.4304,3.7178-2.9978,3.3459-8.0821,6.1894-13.716,6.26-3.0563,0.038-6.2294-0.6007-9.4218-2.7354-3.4131-2.2825-5.6381-5.5281-6.3768-8.7158'/%3E %3Cpath d='m399.11,280.13c1.7306,1.4711,3.0594,3.3467,3.6982,5.2945'/%3E %3Cpath stroke-linecap='round' d='m402.86,292.56c-1.3842,4.5739-5.5104,10.231-13.473,12.248-3.8037,0.9638-8.702-0.2412-10.374-1.6639'/%3E %3Cpath d='m375.06,291.49c0.41674,4.1205,3.1742,7.2089,8.4012,7.3077,7.3502,0.1386,11.818-10.574,5.2869-18.094'/%3E %3Cpath stroke-linecap='round' d='m358.52,327.39c1.0738,1.3471,2.3373,2.561,3.6298,3.6365,2.6212,2.1814,5.7118,4.1014,9.2721,5.1528'/%3E %3Cpath stroke-linecap='round' d='m379.67,336.95c6.569-0.789,10.272-5.6837,9.538-11.41-0.55941-4.3633-4.5629-7.7182-7.2849-7.9123'/%3E %3Cpath d='m390.39,268.92c2.8494-0.1053,4.4703,2.4831,4.4444,4.6645'/%3E %3Cpath stroke-linecap='round' d='m389.72,229.81c1.5609,4.0831,4.6034,7.2753,7.8606,9.099'/%3E %3Cpath stroke-linecap='round' d='m622.86,287.29c2.6862,3.6785,0.92722,10.932-6.379,11.07-2.854,0.054-5.4291-1.5283-6.9385-3.9244'/%3E %3Cpath d='m596.4,239.25,0,24.686'/%3E %3Cpath stroke-linecap='round' d='m380.87,291.14c2.2548,1.6324,5.1502-1.1239,4.0296-4.0493-0.75614-1.9752-3.5631-4.1071-7.4504-1.4636-4.2933,2.9192-3.11,12.129,5.1313,12.284,7.3499,0.1387,11.818-10.574,5.2869-18.093-6.2828-7.2342-17.727-5.5419-25.19,0.3959-3.1762,2.5264-9.1745,9.1452-11.04,18.164-0.5811,2.8081-0.9562,5.1122-0.91203,7.9301,0.0292,1.8567,0.20058,3.9365,0.7564,6.5307,1.1231,5.2403,2.9679,9.0797,4.8055,11.745,0.70406,1.0218,1.347,1.871,2.0365,2.5605,1.279,1.2789,1.662,1.9565,2.9541,3.032,4.2235,3.5147,9.665,6.2699,16.327,5.9865,7.3082-0.3112,11.507-5.4422,10.729-11.507-0.75359-5.879-6.6903-8.8052-10.574-6.0641-2.6435,1.8659-3.5839,7.6445,1.0884,9.0185,2.6435,0.7776,4.9757-2.5655,3.1098-4.5091'/%3E %3Cpath stroke-linecap='round' d='m584.4,210.68c4.2179-2.2909,7.4692-1.8668,9.874,1.47,2.6134,3.6262,2.9862,8.4525,2.4102,11.28-0.85519,4.1985-2.0686,5.942-5.4074,8.9876'/%3E %3Cpath stroke-linecap='round' d='m594.58,212.55c4.8204-3.1874,10.041-1.8336,12.906,2.4102,2.0992,3.1097,2.6358,5.7121,2.4878,9.5627-0.25353,6.6003-4.3839,11.832-8.9409,14.383'/%3E %3Cpath d='m617.28,223.67c3.9649,0.3109,7.1526,3.9007,7.1526,8.0857,0,5.9865-1.6707,8.5836-6.4531,14.539-4.1205,5.1313-16.482,14.15-16.171,22.78,0.11774,3.2634,2.8686,6.3383,5.2419,6.5094'/%3E %3Cpath stroke-linecap='round' d='m617.75,291.14c-2.2546,1.6324-5.1313-1.0035-3.8873-3.8026,0.85884-1.9326,3.421-4.3538,7.3082-1.7103,4.2933,2.9192,3.11,12.129-5.1313,12.284-7.3502,0.1387-12.317-10.297-5.2869-18.093,6.4165-7.1158,18.315-5.7234,25.778,0.2141,3.1761,2.5267,9.5659,9.466,10.936,18.573,1.658,11.02,1.4455,24.575-9.9365,32.922-4.5767,3.356-10.918,4.8817-16.516,4.6364-7.308-0.3205-11.506-5.4423-10.729-11.507,0.75386-5.8791,6.4153-8.3675,10.574-6.0642,4.3192,2.3924,3.565,8.4659-1.0884,9.0186-2.7361,0.325-4.976-2.5655-3.11-4.5092'/%3E %3Cpath d='m613.86,287.34c1.212-5.4543,5.8846-5.9623,9.6576-5.9068,10.296,0.1508,17.416,12.364,17.535,24.178,0.15083,14.923-6.334,23.711-17.241,24.178-2.8221,0.1211-7.6839-1.2213-7.7675-4.6648'/%3E %3Cpath stroke-linecap='square' d='m620.2,284.9c10.858,2.413,14.67,12.196,14.67,21.532,0,7.6158-0.75416,18.022-15.575,21.682'/%3E %3Cpath d='m638.11,389.58c0.0677-0.3647,0.10356-0.7406,0.10356-1.125,0-3.3706-2.7327-6.103-6.1033-6.103-3.3709,0-6.1033,2.7324-6.1033,6.103,0,1.9394,0.90469,3.6675,2.3151,4.7854'/%3E %3Cpath stroke-linecap='round' d='m616.33,380.33c2.0432,3.0321,4.5165,6.4035,9.7401,9.2375'/%3E %3Cpath stroke-linecap='round' d='m624.11,406.05c-5.1195-3.3587-14.838-7.7615-23.624-3.4277-3.2589,1.6077-5.4423,3.5963-6.6751,6.8397-2.2197,5.8393,0.26143,12.275,2.7878,14.949,1.3217,1.3994,4.2004,4.0735,7.7748,4.1208,5.9086,0.078,7.3133-4.0572,7.4636-4.976,0.69983-4.2759-1.788-5.9865-3.1098-6.453-1.0139-0.3577-4.3122-0.2662-5.012,2.0654-0.233,0.7773-0.27494,2.133,0.34725,3.1438'/%3E %3Cpath stroke-linecap='round' d='m531.99,488.16c1.6327,3.343-0.22422,5.0235-2.4878,5.2866-3.343,0.3887-5.1313-2.2545-5.3646-4.6647-0.37819-3.9081,2.9159-7.4492,6.842-7.3859,3.5352,0.057,6.4145,2.3376,7.7644,5.4766,0.49047,1.1411,0.71783,2.3952,0.78763,3.6976,0.13259,2.4678-0.73473,4.7413-2.2228,6.4736-1.9974,2.326-5.1128,3.7336-8.4285,3.8664-6.6002,0.2648-11.74-5.9085-11.74-12.206,0-12.051,17.872-18.623,24.957-20.314,8.7076-2.0775,14.006-2.8553,27.989-3.6323,5.5979-0.3109,9.6973-0.1531,15.861-0.7921,5.5152-0.5715,8.3967-0.8405,14.072-2.1623,7.0828-1.6493,13.684-4.5871,19.592-9.9517,4.5502-4.1309,7.1529-7.0749,9.2592-12.75,1.8178-4.8975,2.653-14.596-1.9509-21.769-4.0688-6.3399-9.7184-9.6331-16.171-10.566-5.8292-0.8428-10.942,1.6726-13.995,7.4565-1.4771,2.7988-1.022,7.4799,0.14836,9.6404,1.0108,1.866,3.8968,4.6178,7.4712,4.6651,5.9086,0.078,7.3133-4.0572,7.4636-4.976,0.69983-4.2759-1.788-5.9865-3.1098-6.453-1.0139-0.3577-4.3122-0.2662-5.012,2.0654-0.233,0.7773-0.27494,2.133,0.34725,3.1438'/%3E %3Cpath stroke-linecap='round' d='m526.9,469.02c-7.5764,3.3588-13.13,5.8745-17.839,13.31-1.4774,2.3325-1.866,5.6756-1.866,7.6192,0,4.1982,1.7103,8.9409,5.2093,11.895,3.2462,2.7414,6.4528,3.5763,10.418,3.1877,3.007-0.2949,5.8312-2.4878,6.2977-4.0428'/%3E %3Cpath d='m601.73,325.2c-3.5448,1.1825-6.0644,6.5862-6.0644,11.74,0,5.9085,2.8767,9.5627,6.2198,11.662'/%3E %3Cpath stroke-linecap='round' d='m605.62,344.41c-6.3754,7.9301-9.7578,12.637-9.9517,22.08-0.1819,8.8627,2.6435,14.927,7.9304,21.303'/%3E %3Cpath d='m571.64,212.58c0.16411-0.2443,0.34557-0.513,0.54731-0.8096,2.6435-3.8873,7.3116-4.9116,10.729-2.3323,4.1206,3.1098,5.1612,8.4023,4.0429,13.994-0.69985,3.4987-3.0732,6.4128-6.325,8.5211'/%3E %3Cpath stroke-linecap='round' d='m414.22,210.68c-4.0432-1.8657-7.371-1.5066-9.874,1.47-2.8768,3.421-2.9865,8.4525-2.4102,11.28,0.8552,4.1985,2.0683,5.942,5.4074,8.9876'/%3E %3Cpath d='m404.03,212.55c-4.8201-3.1874-10.041-1.8336-12.906,2.4102-2.0992,3.1097-2.6358,5.7121-2.4881,9.5627,0.25382,6.6003,4.3842,11.832,8.9412,14.383'/%3E %3Cpath d='m390.12,216.81c-5.2278,0.6376-9.4004,5.0688-9.4004,10.433,0,6.9196,1.7033,9.7184,5.5906,15.005,3.8965,5.299,16.638,15.005,16.638,26.045,0,6.6864-1.866,10.962-6.6863,13.139-3.1083,1.4036-6.7423-0.1157-8.3967-1.6107-4.0432-3.6543-2.4265-10.062,1.788-10.828,5.1313-0.9332,6.0957,7.145,1.0884,6.6083'/%3E %3Cpath d='m381.33,223.67c-3.9652,0.3109-7.8665,3.7229-7.8665,7.9079,0,5.9865,2.3846,8.7614,7.1667,14.716,4.1208,5.1313,15.762,13.972,15.451,22.602-0.11729,3.2634-2.3111,7.2531-4.488,6.7865'/%3E %3Cpath stroke-linecap='round' d='m372,343.94c1.866-4.5092,6.6864-2.4879,6.9829,0,0.68324,5.7321-4.3395,7.4638-7.9158,6.5307-1.7714-0.4621-3.0676-1.5778-3.8957-3.0313-0.93454-1.64-1.2171-3.7797-0.61037-5.8235,0.27521-0.9269,0.66271-1.7073,1.3257-2.581,0.6658-0.878,1.3541-1.4791,1.9991-1.8905,1.3755-0.8779,2.8742-0.9646,5.2242-0.9646,8.7076,0,16.327,10.289,18.886,20.977,0.84278,3.52,2.0013,11.371,0.39592,18.815-1.7106,7.9301-5.1384,13.42-9.1598,17.585-2.1769,2.2546-5.146,4.2618-8.9896,6.4351-1.1856,0.6705-4.3198,2.0609-6.4967,2.6831-2.236,0.6388-4.3369,0.688-6.1582,0.1418-4.4225-1.3268-7.2612-5.4591-4.9596-10.829,1.7916-4.1808,8.3967-6.2198,11.351-1.0885,0.25071,0.4353,0.64073,1.3836,0.62836,2.4107-0.0158,1.3682-0.58419,3.0172-1.5615,3.6391-2.2459,1.4292-5.8382,1.0251-5.6711-2.9401'/%3E %3Cpath d='m365.24,397.49c1.6327,0.6292,2.5258,0.544,4.5573-0.3579,0.8335-0.3703,1.7883-0.9435,2.9066-1.5784,3.9804-2.2607,8.7076-5.8238,13.139-14.143,1.3105-2.4602,2.1246-4.7432,2.6725-6.9922,0.42293-1.7354,0.71588-3.4505,0.77919-5.2112,0.10805-3-0.215-6.1323-0.96378-9.721-1.2362-5.9254-2.7251-9.1432-6.3754-14.15-1.7951-2.4622-3.343-3.9649-6.6864-4.0425'/%3E %3Cpath d='m360.51,389.58c-0.0678-0.3647-0.10332-0.7406-0.10332-1.125,0-3.3706,2.7324-6.103,6.1033-6.103,3.3706,0,6.103,2.7324,6.103,6.103,0,1.9394-0.90442,3.6675-2.3148,4.7854'/%3E %3Cpath d='m362.88,383.51c0.45954-2.7701,2.8132-4.8795,5.6477-4.8795,3.1641,0,5.729,2.628,5.729,5.87,0,1.5877-0.61514,3.0281-1.6147,4.0848'/%3E %3Cpath d='m374.02,383.2c5.209-3.7319,9.672-10.856,9.7184-19.274,0.0358-6.4739-2.5658-13.061-5.5976-15.627'/%3E %3Cpath stroke-linecap='round' d='m382.29,380.33c-2.0432,3.0321-4.5165,6.4035-9.7404,9.2375'/%3E %3Cpath d='m397.81,402.63c-1.4489-3.4089-4.3288-4.9853-9.0189-5.4856-4.6625-0.4978-8.6986,0.7837-12.828,3.0048-8.0598,4.3346-12.554,8.9946-15.55,17.641-0.76034,2.1952-1.3912,5.5056-1.3034,9.0211,0.14025,5.6041,1.5629,11.73,3.0917,14.692,1.3336,2.5835,4.8204,13.994,23.946,21.868,11.161,4.5949,28.3,5.6539,40.118,6.1201,16.256,0.6419,31.255,1.2441,39.962,11.973'/%3E %3Cpath stroke-linecap='round' d='m374.5,406.05c5.1198-3.3587,14.838-7.7615,23.624-3.4277,3.2589,1.6077,5.4423,3.5963,6.6751,6.8397,2.2197,5.8393-0.2617,12.275-2.7878,14.949-1.3217,1.3994-4.2004,4.0735-7.7748,4.1208-5.9088,0.078-7.3133-4.0572-7.4636-4.976-0.69983-4.2759,1.788-5.9865,3.1098-6.453,1.0139-0.3577,4.3122-0.2662,5.0117,2.0654,0.23327,0.7773,0.27491,2.133-0.34698,3.1438'/%3E %3Cpath d='m394.86,421.45c0.46656-1.7104,0.22651-3.5063-1.3215-5.209-1.555-1.7104-5.6756-3.3431-9.1745-1.3994-1.1703,0.6503-2.6381,1.5066-3.9649,3.2653-0.50202,0.6653-1.3504,1.7391-1.7883,2.4879-1.0589,1.8108-1.494,3.2927-1.7033,3.8875-3.845,10.928,2.413,22.532,10.256,27.522,6.8416,4.3538,13.839,5.5979,22.469,6.3751,3.9936,0.3599,6.2566,0.4368,10.263,0.6222,3.2237,0.1493,6.0082,0.096,8.63,0.064,2.1575-0.027,4.2049-0.016,6.2969-0.064,3.4156-0.079,6.9494-0.1589,11.274,0.1556,4.5497,0.3309,7.9729,0.4477,11.818,1.0884,2.5115,0.4187,5.4558,0.8226,8.5422,1.5151,0.92609,0.2075,1.8651,0.3773,2.8089,0.6618,0.63427,0.1912,1.2604,0.3853,1.8814,0.5746,5.5714,1.6994,10.985,3.7697,15.257,6.5209,1.3198,0.8501,2.8402,1.6707,3.8771,2.7079,0.7958,0.7956,1.472,1.2565,2.1234,1.8978,2.9902,2.9415,6.0476,6.1261,6.7626,10.438,0.13191,0.7955,0.1317,1.6293,0.1317,2.507,0,2.7988-2.2774,6.6084-8.4195,7.8524'/%3E %3Cpath d='m466.62,488.16c-1.6327,3.343,0.22422,5.0235,2.4878,5.2866,3.343,0.3887,5.1313-2.2545,5.3646-4.6647,0.37821-3.9081-2.9159-7.4492-6.842-7.3859-3.5352,0.057-6.4145,2.3376-7.7644,5.4766-0.49075,1.1411-0.71784,2.3952-0.78791,3.6976-0.13237,2.4678,0.73501,4.7413,2.2228,6.4736,1.9974,2.326,5.113,3.7336,8.4288,3.8664,6.6002,0.2648,11.74-5.9085,11.74-12.206,0-12.051-17.873-18.623-24.957-20.314-8.7079-2.0775-14.006-2.8553-27.989-3.6323-5.5979-0.3109-9.6973-0.1531-15.861-0.7921-5.5152-0.5715-8.3967-0.8405-14.073-2.1623-7.0826-1.6493-13.684-4.5871-19.592-9.9517-4.55-4.1309-7.1526-7.0749-9.2592-12.75-1.8176-4.8975-2.6527-14.596,1.951-21.769,4.069-6.3399,9.7184-9.6331,16.172-10.566,5.8292-0.8428,10.942,1.6726,13.995,7.4565,1.4771,2.7988,1.0218,7.4799-0.14835,9.6404-1.0108,1.866-3.8968,4.6178-7.4712,4.6651-5.9088,0.078-7.3133-4.0572-7.4636-4.976-0.69983-4.2759,1.788-5.9865,3.1098-6.453,1.0139-0.3577,4.3122-0.2662,5.0117,2.0654,0.23327,0.7773,0.27491,2.133-0.34698,3.1438'/%3E %3Cpath stroke-linecap='round' d='m426.97,212.58c-0.16411-0.2443-0.34583-0.513-0.54732-0.8096-2.6435-3.8873-7.3116-4.9116-10.729-2.3323-4.1206,3.1098-5.1612,8.4023-4.0429,13.994,0.69955,3.4987,3.0732,6.4128,6.3247,8.5211'/%3E %3Cpath d='m573.04,224.37c-6.2975,6.8417-12.595,9.0262-22.003,9.3296-2.9376,0.095-8.5523-0.9329-11.818-3.2581-2.0976-1.4936-4.4315-4.0502-2.9544-8.4817,0.98746-2.9622,5.7462-11.273,5.9795-17.027,0.35626-8.7892-3.025-13.606-8.312-15.472-9.7739-3.4497-20.267,6.2113-26.589,8.319-3.3053,1.1017-4.9903,1.2319-8.0081,1.2429-3.0177-0.011-4.7627-0.1411-8.068-1.2429-6.3228-2.1077-16.816-11.769-26.59-8.319-5.2867,1.8659-8.668,6.6824-8.3117,15.472,0.2333,5.7532,4.9918,14.064,5.9792,17.027,1.4774,4.4315-0.85658,6.9881-2.9541,8.4817-3.2656,2.3252-8.8801,3.3529-11.818,3.2581-9.4072-0.3034-15.705-2.4879-22.003-9.3296'/%3E %3Cpath stroke-linecap='round' d='m464.58,466.27c1.246,0.4868,0.30336-0.2952,8.1947,3.2032,7.5764,3.3585,12.954,6.2999,17.663,13.736,1.4774,2.3323,1.866,5.6756,1.866,7.6192,0,1.2528-0.15217,2.554-0.45867,3.8417'/%3E %3Cpath d='m465.09,500.06c1.5362,0.7682,3.2792,1.2167,5.081,1.2891,6.6002,0.2648,11.74-5.9089,11.74-12.206,0-4.3662-2.377-8.0441-5.7062-11'/%3E %3Cpath stroke-linecap='round' d='m466.52,488.15c-1.5938,3.5532,0.67678,5.4749,2.9401,5.738,3.3433,0.3889,5.2248-2.2546,5.458-4.6647,0.25355-2.6213-1.145-5.171-3.278-6.4852'/%3E %3Cpath d='m609.53,216.87c5.0182,0,9.394,5.5855,9.394,11.317,0,6.605-3.5127,10.648-6.0869,13.705-2.0722,2.4608-4.3158,4.6625-6.9824,7.3482'/%3E %3Cpath stroke-linecap='round' d='m603.58,211.58c1.7064,0.7901,3.2037,2.1276,4.3456,3.8188,2.099,3.1101,2.6331,5.7121,2.4879,9.5631-0.24905,6.6-4.998,11.17-9.2462,13.959'/%3E %3Cpath stroke-linecap='round' d='m593.71,211.58c0.34695,0.2961,0.68042,0.6338,1.0004,1.0142,2.8768,3.421,3.0993,8.4775,2.4102,11.281-1.0353,4.2128-2.4276,6.0287-5.8464,8.5483'/%3E %3Cpath stroke-linecap='round' d='m583.36,209.85c4.1206,3.1098,5.3458,8.4887,3.9807,14.026-0.9756,3.9567-3.4635,6.3281-6.5656,8.2174'/%3E %3Cpath stroke-linecap='round' d='m598.16,296.28c0.49301,1.4472,1.3065,1.9486,2.3317,3.0225,2.229,2.335,5.4963,4.3434,9.623,5.5039,3.8138,1.0727,7.2494,0.2662,9.8706-1.3671'/%3E %3Cpath stroke-linecap='round' d='m365.29,387.87c1.9372-0.035,3.869,1.273,5.1325,3.4677,0.25072,0.4356,0.64103,1.3836,0.62835,2.4107-0.0158,1.3682-0.6154,2.8309-1.5924,3.4525-2.2456,1.4292-6.2327,0.8149-6.0659-3.15'/%3E %3Cpath d='m377.33,336.4c7.7033,1.4379,15.119,10.729,17.546,20.865,0.84279,3.5201,2.0016,11.371,0.39592,18.815-1.7103,7.9301-5.1381,13.42-9.1598,17.585-0.95338,0.9875-2.0587,1.9276-3.3231,2.8548l-1.6428,1.1135'/%3E %3Cpath d='m368.76,378.67c3.1641,0,5.9336,3.0316,5.9336,6.2733,0,1.5876-0.61515,3.0281-1.6147,4.0848'/%3E %3Cpath d='m366.62,382.35c3.2966,0,6.4325,3.1758,6.4325,6.5464,0,1.9397-0.90469,3.6678-2.3151,4.7855'/%3E %3Cpath stroke-linecap='round' d='m396.84,349.2c3.0273,4.0629,5.0252,7.5612,5.9544,12.07'/%3E %3Cpath stroke-linecap='round' d='m402.69,374.53c-0.4995,2.2459-1.2593,4.3246-2.2639,6.3222-1.2731,2.5304-3.4919,5.3478-5.5523,7.2525'/%3E %3Cpath d='m397.32,325.52c2.9187,2.2816,4.678,4.6412,5.5011,7.4687'/%3E %3Cpath stroke-linecap='round' d='m402.9,317.92c-0.76653,2.6592-2.5059,4.6738-5.2661,7.1926'/%3E %3Cpath stroke-linecap='round' d='m383.33,298.27,3.3686-0.8865,1.9943-1.5071,1.2854-1.8176,1.1081-2.8368,0.4432-2.3049'/%3E %3Cpath d='m376.51,286.41c-1.0634,0.26582-2.4109,0.65948-3.8239,1.3328-1.8928,0.90191-3.9033,2.3056-5.506,4.5758-1.8561,2.6296-2.9384,6.2859-3.6084,9.4848-0.29322,1.3997-0.64328,5.832,0.25214,10.41,0.66128,3.3801,2.0573,6.527,3.6016,8.8061,0.55379,0.8172,1.0561,1.5226,1.6206,2.0874,2.0216,2.0213,3.8875,3.2654,6.9973,2.6432'/%3E %3Cpath stroke-linecap='round' d='m395.38,271.58c-0.54618,2.0066-1.6248,4.4933-4.7737,4.2213'/%3E %3Cpath d='m383.87,285.2c-3.0236-2.9558-9.4292-3.7263-15.798,0.3022-0.81858,0.5181-1.6372,1.183-2.4479,1.8587-0.87628,0.7299-1.5753,1.5693-2.2506,2.4819-0.73419,0.9925-1.6361,2.6801-2.1811,3.8009-0.75022,1.5438-1.0609,2.5579-1.4742,4.1408-1.163,4.4554-1.158,8.5959-1.0209,9.7761,0.17626,1.5131,0.32023,2.9035,0.56757,4.1822,0.84505,4.3715,2.1381,7.439,3.4753,9.6565,1.4067,2.3325,4.9054,7.6898,12.058,8.3967,2.8112,0.278,7.6121-1.0106,7.7675-4.6648'/%3E %3Cpath stroke-linecap='round' d='m568.38,220.42c0.47838-2.5813,3.5892-3.0796,4.7582-1.555,1.8001,2.348,0.60952,6.3818-3.0515,7.526-1.2441,0.3889-4.1205,0.2333-5.9865-2.1769-1.5125-1.9537-1.3969-4.3735-0.83208-6.2969,0.36553-1.2446,1.3642-2.3294,2.6981-3.3435,4.2511-3.2333,11.118-2.4879,13.372,2.9541,2.9086,7.0203-3.4207,12.284-9.2519,16.249-7.3409,4.9918-15.705,5.8996-22.003,5.8312-14.306-0.1556-25.19-6.9973-32.265-10.884-1.6482-0.9056-3.3456-0.7207-4.1982,0.3109-0.96295,1.1644-0.94749,3.0428,0.38861,4.2759'/%3E %3Cpath stroke-linecap='round' d='m571.26,218c1.5162,0.07,1.922,0.6616,2.3868,1.2674,1.7998,2.348,0.48487,6.3821-3.1761,7.526'/%3E %3Cpath stroke-linecap='round' d='m598.34,307.33c-5.4504,5.9325-0.43701,16.116,3.6365,18.418,1.4101,1.0966,2.0126,0.5153,3.1404,1.1749'/%3E %3Cpath d='m598.63,295.99c-1.7883,1.2441-2.4184,2.6415-2.4879,5.0697-0.0583,2.032,0.29603,4.2883,2.2034,6.2727,2.9713,3.0917,8.7859,5.7836,14.42,5.8542,3.0563,0.038,6.2294-0.6007,9.4218-2.7354,3.4131-2.2825,5.2093-5.3646,5.9868-8.3967'/%3E %3Cpath d='m595.58,398.6c0,0.018-0.009,2.3885-0.21183,3.8873-0.59151,4.3631-1.2857,6.8737-3.2654,10.807-1.9304,3.8354-3.4728,5.8491-6.5307,8.8632-3.0853,3.0411-5.2236,4.4343-9.0965,6.3754-3.7716,1.8902-6.1477,2.4912-10.263,3.4207-4.1121,0.9286-6.5175,1.1312-10.729,1.3217-3.8619,0.1747-6.0529,0.011-9.9095-0.2546-4.1273-0.2857-6.4167-0.8606-10.538-1.2224-3.4038-0.2992-5.3263-0.5744-8.7431-0.5659-3.5124,0.01-5.525,0.031-8.9834,0.6435-3.2232,0.5707-5.0517,1.0254-8.0857,2.2546-4.1979,1.7008-8.9409,4.6648-9.9517,5.9865-1.0108-1.3217-5.7541-4.286-9.9517-5.9865-3.034-1.2292-4.8626-1.6839-8.0857-2.2546-3.4584-0.6123-5.471-0.6345-8.9834-0.6435-3.417-0.01-5.3396,0.2667-8.7431,0.5659-4.1217,0.3618-6.4108,0.9367-10.538,1.2224-3.8568,0.2667-6.0475,0.4294-9.9095,0.2546-4.2117-0.1904-6.6171-0.3931-10.729-1.3217-4.1149-0.9295-6.4911-1.5305-10.263-3.4207-3.8729-1.9411-6.0112-3.3343-9.0965-6.3754-3.058-3.0141-4.6006-5.0278-6.5307-8.8632-1.9796-3.9329-2.6739-6.4435-3.2656-10.807-0.20329-1.4988-0.21162-3.8687-0.21162-3.8873v-0.0003-159.02h192.55v159.02l0.0668,0.0003z'/%3E %3C/g%3E %3Cg fill='%23c7b37f' stroke='%23c7b37f'%3E %3Cpath stroke-width='0.51271021' d='m387.41,421.32c0-2.1575,1.7492-3.9067,3.907-3.9067,2.1575,0,3.9067,1.7492,3.9067,3.9067,0,2.1578-1.7492,3.9067-3.9067,3.9067-2.1578,0-3.907-1.7489-3.907-3.9067z'/%3E %3Cpath stroke-width='0.51271021' d='m363.42,393.71c0-1.9321,1.2356-3.4986,2.76-3.4986s2.7602,1.5665,2.7602,3.4986c0,1.9324-1.2359,3.4987-2.7602,3.4987s-2.76-1.5663-2.76-3.4987z'/%3E %3Cpath stroke='none' d='m377.05,324.36c0-1.5871,1.1931-2.8734,2.6649-2.8734,1.4717,0,2.6648,1.2863,2.6648,2.8734,0,1.5868-1.1931,2.8733-2.6648,2.8733s-2.6649-1.2865-2.6649-2.8733z'/%3E %3Cpath stroke='none' d='m424.91,221.81c-0.16816-1.5919,0.78762-2.9969,2.135-3.1379,1.3473-0.1409,2.5762,1.035,2.7445,2.6271,0.16839,1.5919-0.78765,2.9967-2.1353,3.1379-1.3473,0.141-2.5759-1.0349-2.7442-2.6271z'/%3E %3C/g%3E %3Cg stroke='%23c7b37f' stroke-width='0.987' stroke-linecap='round'%3E %3Cpath d='m373.92,340.54c-0.57379,0.2499-0.89064,0.4561-1.3218,0.9098-0.41197,0.4333-0.49752,0.5906-0.81633,1.2983-0.23329,0.5178-0.29463,1.118-0.38102,1.8581'/%3E %3Cpath d='m378.77,386.4c0.54255-0.6579,0.87039-1.0119,1.3915-1.687,0.43363-0.5616,0.69168-0.8709,1.073-1.4694,0.34361-0.5392,0.49752-0.8676,0.80087-1.4307,0.42746-0.7938,0.64019-1.2567,1.0496-2.0601'/%3E %3Cpath d='m381.11,401.53c-0.92495,0.4246-1.4723,0.6123-2.3713,1.0884-0.68354,0.3622-1.0547,0.5935-1.7106,1.0029-0.77441,0.484-1.2069,0.7666-1.9436,1.3063-0.76739,0.5622-1.1619,0.9297-1.9048,1.5237'/%3E %3Cpath d='m396.56,347.25c-0.50033-0.5152-0.77189-0.8169-1.2829-1.3214-0.53437-0.5274-0.82507-0.8386-1.3994-1.3218-0.55717-0.4685-0.9109-0.6829-1.4928-1.1197'/%3E %3Cpath stroke-linecap='butt' d='m397.17,326.47c-0.7429,0.3306-1.1326,0.5932-1.9048,0.8476-0.885,0.2915-1.4849,0.4431-2.3401,0.482'/%3E %3Cpath d='m371,300.68c0.25468,0.9067,0.3104,1.4478,0.65314,2.3246,0.43082,1.102,0.79101,1.6817,1.4461,2.6668,0.68296,1.0266,1.1096,1.5939,1.9904,2.4569,0.77356,0.7576,1.2638,1.14,2.1693,1.7337,0.8597,0.5637,1.418,0.7587,2.3247,1.2438'/%3E %3Cpath d='m378.04,301.95c0.75809,0.4061,1.1495,0.7119,1.9439,1.0417,0.71899,0.2986,1.1456,0.4247,1.9045,0.5986,1.0268,0.2355,1.6293,0.2946,2.6826,0.3188,1.1402,0.027,1.477,0,2.9156-0.2333'/%3E %3Cpath d='m398.69,240.15c-1.2463-0.7277-2.0081-1.046-3.1956-1.866-1.2078-0.8341-1.8733-1.3453-2.9232-2.3713-0.75725-0.7395-1.1816-1.1707-1.8116-2.0213-0.56224-0.7595-0.77779-1.257-1.275-2.0604'/%3E %3Cpath d='m401.2,224.72c0.39114,1.0459,0.50285,1.6839,1.0029,2.6823,0.67873,1.3552,1.2027,2.0671,2.2236,3.1877,1.4149,1.5525,2.6131,1.9917,4.2837,3.2653'/%3E %3Cpath d='m410.98,224.61c0.38806,0.9398,0.50651,1.5181,0.99532,2.4099,0.43193,0.7885,0.72965,1.2083,1.2984,1.9048,0.72516,0.8886,1.1968,1.3521,2.0992,2.0604,1.049,0.8236,1.7925,1.0671,2.9386,1.7492'/%3E %3C/g%3E %3Cpath fill='%23703d29' stroke-width='0.27661592' d='m520.78,211.91c-0.0802-2.6489-2.6896-2.9243-3.6894-2.9243-2.8855,0-3.6661,1.7998-7.2657,3.7327-4.512,2.4231-6.4553,2.9615-10.466,2.9975-4.0102-0.036-6.0048-0.5744-10.517-2.9975-3.5994-1.9329-4.2052-3.6748-7.091-3.6748-1.5663,0-3.5895,1.353-3.5127,3.8327,0,0-0.0301,0.8031,0.0932,1.3465,0.0463,0.2046,0.29518,0.1407,0.3734,0.3199-0.0371-1.2024,0.20757-1.8251,0.80003-2.6327,0.76061-1.0378,2.0244-1.3133,2.5396-1.3133,2.8855,0,3.9537,1.8516,7.5533,3.7845,4.512,2.4231,6.4534,2.9615,10.464,2.9975,4.0102-0.036,6.0068-0.5744,10.519-2.9975,3.5997-1.9329,4.6341-3.9379,7.5198-3.9379,0.99981,0,1.7053,0.6472,2.0328,1.6665,0.20171,0.6269,0.088,1.0451,0.14026,1.2932,0.0254,0.1212,0.17379,0.1088,0.20643,0.2398,0.10018-0.4665,0.33345-0.6331,0.29998-1.7328z'/%3E %3C/g%3E %3Cg fill='%23703d29'%3E %3Cpath d='m413.12,434.42c0.81016-0.8724,1.4225-0.5439,1.5728-0.9458,0.11098-0.2971-0.129-0.327-0.45898-0.4505-0.44038-0.1646-0.90694-0.2592-1.3473-0.4241-0.45614-0.1704-0.87036-0.4049-1.3265-0.5754-0.18887-0.071-0.62527-0.2935-0.74964,0.039-0.2285,0.6114,1.6017,0.5588,0.9877,2.2016-0.10467,0.2794-0.36469,0.8794-1.2744,1.8738l-4.1411,4.5072c-0.0929,0.1047-0.24737,0.3259-0.34162,0.2904-0.0945-0.035-0.0817-0.3092-0.083-0.4494l0.0592-6.3917c0.005-1.2128,0.10807-2.1107,0.30421-2.635,0.27435-0.7339,1.12-0.1191,1.2964-0.5909,0.11121-0.2969,0.0259-0.309-0.47725-0.4973-0.25185-0.094-0.73389-0.1947-1.7404-0.5709-0.53495-0.2002-1.0434-0.47-1.5626-0.6638-0.23581-0.088-0.67113-0.4103-0.82787,0.01-0.0459,0.1224,0.11931,0.3036,0.16006,0.3388,0.57939,0.4159,0.7277,0.6902,0.74035,1.4719l0.11346,11.635c0.009,0.8397,0.10063,1.0732,0.25803,1.132,0.17312,0.065,0.29097-0.011,0.63371-0.4004l8.205-8.9035z'/%3E %3Cpath d='m417.95,436.22c0.53324-1.6904,1.5322-0.6712,1.723-1.2762,0.0673-0.2136-0.00098-0.2744-0.48203-0.4258-0.91259-0.2878-1.5117-0.3984-2.0883-0.5802-0.56056-0.1767-1.1625-0.4449-1.7872-0.6416-0.14408-0.046-0.52764-0.2254-0.62303,0.077-0.19652,0.6228,1.7703,0.6951,1.2598,2.3142l-2.693,8.5411c-0.53298,1.6904-1.5401,0.8642-1.7365,1.4869-0.0282,0.089-0.0355,0.2238,0.10897,0.2693,0.4162,0.1313,1.1273,0.2772,1.8159,0.4941,1.2491,0.394,1.8192,0.652,2.4119,0.8389,0.36807,0.1161,0.53495,0.09,0.59657-0.1054,0.17942-0.5695-1.8721-0.3165-1.1821-2.5053l2.6761-8.4875z'/%3E %3Cpath d='m423.73,437.93c0.31798-1.0733,0.81689-0.9256,1.4126-0.7491,1.6262,0.4817,2.1355,2.0725,1.6164,3.8256-0.31264,1.0555-0.70604,2.0289-3.1534,1.3037-0.48288-0.1429-1.0786-0.3194-0.94607-0.7665l1.0704-3.6137zm-4.4337,7.696c-0.66777,2.254-1.797,1.2775-1.9664,1.8499-0.10604,0.3577,0.2479,0.4044,0.42491,0.4567,0.80507,0.2383,1.6313,0.4055,2.5005,0.663,0.67619,0.2001,1.0898,0.4007,1.3637,0.4817,0.37003,0.1095,0.53072,0.04,0.57856-0.1206,0.19067-0.6439-1.6206-0.3827-1.0536-2.2968l0.91681-3.0948c0.1855-0.6261,0.12584-0.7801,0.97927-0.5271,0.80507,0.2383,1.0471,0.4851,1.1841,1.382l0.51524,3.227c0.19157,1.1856,0.37313,2.4651,1.6451,2.8419,0.64384,0.1907,1.8232,0.1119,1.9875-0.4426,0.0423-0.143-0.0225-0.2789-0.16749-0.322-0.16096-0.048-0.35371,0.011-0.51467-0.036-0.12899-0.038-0.43478-0.129-0.49499-0.4578-0.49133-2.5973-1.0915-5.5968-1.0598-5.7043,0.0529-0.1787,0.56759-0.2014,1.1563-0.4747,0.59402-0.291,1.257-0.8144,1.5961-1.9594,0.24396-0.8228,0.66917-3.4406-2.8568-4.4849-1.0789-0.3197-2.1949-0.5724-3.2735-0.892-1.0142-0.3003-1.1219-0.4101-1.8626-0.6296-0.19292-0.057-0.38075-0.016-0.43365,0.1635-0.19068,0.6438,1.7604,0.502,1.1667,2.5053l-2.3314,7.8713z'/%3E %3Cpath d='m432.46,449.48c-0.51835,2.1589-2.1541,0.8453-2.3241,1.5524-0.0959,0.3994,0.18595,0.4478,0.48007,0.5184,0.65312,0.1567,1.2092,0.2136,2.3032,0.4764,1.0938,0.2625,1.6152,0.4646,2.2684,0.6213,0.47357,0.1137,0.78705,0.2465,0.89147-0.1888,0.12224-0.508-2.0942-0.4838-1.5584-2.7153l1.9687-8.2002c0.20914-0.8707,0.39422-0.9222,1.0637-0.7615l1.3876,0.3332c1.8952,0.3782,0.88922,2.2667,1.5424,2.4234,0.42463,0.102,0.41478-0.6486,0.43448-0.8743l0.22129-1.7123c0.027-0.1851,0.088-0.4393-0.15668-0.4978-1.5184-0.3647-2.63-0.5549-5.0137-1.1273-2.384-0.5724-3.4604-0.9075-4.9788-1.2719-0.24482-0.059-0.30587,0.1949-0.36582,0.3725l-0.83602,2.332c-0.0896,0.2279-0.28309,0.6036,0.0597,0.686,0.73473,0.1763,0.8155-2.3178,2.6606-1.8749l1.3715,0.3292c0.66917,0.161,0.81073,0.2907,0.60164,1.1616l-2.021,8.4178z'/%3E %3Cpath d='m452.3,444.42c0.64638-0.9996,1.3062-0.7823,1.3848-1.2044,0.0576-0.3118-0.1837-0.2997-0.53045-0.3639-0.46233-0.086-0.93819-0.098-1.4005-0.1837-0.47868-0.089-0.9275-0.2479-1.4062-0.3366-0.19811-0.037-0.66692-0.1803-0.73135,0.168-0.11908,0.6421,1.6743,0.2724,1.3547,1.9968-0.0543,0.2938-0.20643,0.9297-0.92948,2.0669l-3.2958,5.1578c-0.0732,0.119-0.18685,0.3638-0.2859,0.3452-0.099-0.018-0.13395-0.2904-0.15984-0.428l-1.0516-6.3047c-0.20553-1.1957-0.26-2.0979-0.15803-2.648,0.14295-0.7705,1.0825-0.3118,1.1743-0.8073,0.0576-0.3118-0.0282-0.3087-0.55632-0.4067-0.26424-0.049-0.75669-0.064-1.8133-0.26-0.56139-0.104-1.1093-0.2814-1.6541-0.3824-0.24764-0.046-0.73221-0.2876-0.81381,0.1524-0.0239,0.1285,0.17041,0.2783,0.21656,0.3059,0.64272,0.309,0.8366,0.5535,0.98461,1.3209l2.1322,11.439c0.15443,0.8256,0.28561,1.0397,0.4508,1.0704,0.18145,0.034,0.28448-0.061,0.55463-0.5045l6.5341-10.193z'/%3E %3Cpath d='m453.23,454.93c0.009,0.4556-0.0324,0.6,0.36301,0.7795,0.92073,0.4001,1.6915,0.9832,2.7017,1.152,2.1693,0.363,3.9672-1.0198,4.3704-3.4302,0.39114-2.3371-0.56957-3.3113-2.1969-4.4726-2.0373-1.4571-2.9083-1.8488-2.702-3.0816,0.20622-1.2328,1.0685-1.8074,2.1617-1.6245,2.8486,0.4767,2.5242,3.941,2.9049,4.0046,0.36443,0.061,0.4511-0.1515,0.4857-0.5617l0.23048-2.4966c0.0378-0.4285,0.13372-0.6964-0.11481-0.7378-0.21521-0.036-0.67874,0.1891-0.89373,0.1531-0.49694-0.083-1.0724-0.9174-2.4305-1.1445-1.9377-0.3244-3.5214,0.9996-3.8754,3.1159-0.32332,1.9321,0.53382,2.8132,1.8409,3.7508,2.4479,1.7529,3.4511,2.1665,3.1894,3.7308-0.24651,1.472-1.3879,2.189-2.6798,1.9729-1.8381-0.3078-2.5847-2.1541-2.8191-4.0094-0.0261-0.2501-0.0315-0.4212-0.29659-0.4657-0.41422-0.069-0.33768,0.4922-0.33122,0.7581l0.0919,2.6069z'/%3E %3Cpath d='m477.95,447.96c0.53833-1.062,1.2173-0.9148,1.2511-1.3426,0.0247-0.3163-0.21386-0.2791-0.56561-0.3067-0.46852-0.037-0.94325,0.0009-1.4121-0.036-0.48539-0.038-0.94802-0.1497-1.4337-0.188-0.20081-0.016-0.68184-0.1096-0.70969,0.2437-0.0511,0.6509,1.6937,0.096,1.5561,1.8443-0.0235,0.2977-0.10806,0.9461-0.70857,2.1527l-2.7383,5.4738c-0.0605,0.1263-0.1479,0.3813-0.24847,0.3734-0.10039-0.01-0.16343-0.2749-0.2035-0.4088l-1.7047-6.1604c-0.32924-1.1678-0.47808-2.059-0.43419-2.6171,0.0612-0.7811,1.044-0.4232,1.0834-0.9255,0.0247-0.316-0.0602-0.3039-0.59599-0.3461-0.2679-0.02-0.75895,0.016-1.8305-0.069-0.56899-0.045-1.1324-0.1641-1.6847-0.2073-0.25101-0.02-0.75838-0.2096-0.79354,0.2367-0.0113,0.1303,0.19877,0.2591,0.24733,0.2816,0.67171,0.2401,0.88979,0.4632,1.1174,1.2109l3.3163,11.153c0.23975,0.8051,0.39256,1.004,0.55998,1.0172,0.18393,0.014,0.27663-0.091,0.49894-0.5597l5.433-10.82z'/%3E %3Cpath d='m480.6,457c-0.0158,1.9028-1.6256,1.5531-1.6321,2.2993-0.002,0.3172,0.33373,0.2268,0.51863,0.2285,0.45332,0,0.90723-0.067,1.4444-0.062,0.58785,0.01,1.158,0.085,1.9808,0.092,0.21837,0,0.63793,0.024,0.64018-0.2369,0.007-0.8769-2.1527,0.3728-2.1215-3.2091l0.0553-6.3433c0.00098-0.1679,0.036-0.2983,0.13687-0.2975,0.0842,0.0009,0.18392,0.095,0.30026,0.2454l7.992,9.7719c0.11617,0.1504,0.19924,0.2628,0.43422,0.2651,0.20148,0,0.20283-0.1475,0.20643-0.558l0.0912-10.466c0.0158-1.9588,1.4402-1.4987,1.4453-2.0584,0.00056-0.056,0.002-0.2426-0.31685-0.2454-0.15105,0-0.73952,0.068-1.7973,0.059-1.1588-0.011-1.645-0.089-1.9138-0.091-0.21813,0-0.27014,0.1843-0.27126,0.3148-0.005,0.6157,2.046,0.2978,2.0311,1.9955l-0.0541,6.2127c-0.005,0.4663-0.0396,0.69-0.14047,0.6891-0.10063-0.0008-0.30024-0.2265-0.51635-0.4896l-6.6782-8.2866c-0.29914-0.3571-0.0966-0.486-0.63371-0.4905-0.89007-0.01-1.3274,0.063-1.7638,0.059-0.31911,0-0.62077-0.08-0.9396-0.083-0.20149,0-0.28674,0.1465-0.28816,0.3146-0.009,0.8954,1.8831-0.3008,1.8519,3.2814l-0.0617,7.0896z'/%3E %3Cpath d='m496.86,448.6c0.0158-1.7725,1.2691-1.0898,1.2745-1.7241,0.002-0.224-0.0814-0.262-0.58531-0.2665-0.95706-0.01-1.5623,0.061-2.1665,0.056-0.58783,0-1.2421-0.086-1.8969-0.091-0.15105-0.001-0.57041-0.061-0.57322,0.2564-0.005,0.6528,1.8029,0.1472,1.788,1.8448l0.0158,8.9553c-0.0158,1.7722-1.2202,1.2767-1.2258,1.9298-0.00084,0.093,0.0315,0.224,0.18257,0.2254,0.43673,0.01,1.1594-0.064,1.8814-0.058,1.3096,0.011,1.9304,0.091,2.5514,0.097,0.38637,0,0.53804-0.07,0.53973-0.2752,0.005-0.5971-1.8828,0.2448-1.8629-2.05l0.0776-8.8992z'/%3E %3Cpath d='m503.9,457.27c0.0202,2.2203-1.8859,1.3412-1.8794,2.0689,0.005,0.4106,0.28871,0.3894,0.59121,0.3866,0.67141-0.01,1.2249-0.085,2.35-0.095,1.125-0.01,1.6797,0.06,2.3514,0.054,0.48682,0,0.82338,0.049,0.81943-0.399-0.005-0.5226-2.149,0.037-2.1693-2.2574l-0.0734-8.433c-0.007-0.8954,0.1594-0.9902,0.84758-0.9961l1.4273-0.011c1.9304-0.091,1.4112,1.9841,2.0829,1.9782,0.43644,0,0.24539-0.7299,0.20981-0.9534l-0.19967-1.7148c-0.0181-0.1866-0.0202-0.4477-0.2724-0.4455-1.5618,0.014-2.686,0.098-5.1375,0.1195-2.4516,0.02-3.5772-0.044-5.1389-0.03-0.25184,0-0.24959,0.2634-0.26479,0.4503l-0.24706,2.465c-0.0315,0.2429-0.12854,0.654,0.22399,0.6512,0.75584-0.01,0.23075-2.4462,2.1279-2.4628l1.4104-0.014c0.68857-0.01,0.85714,0.086,0.86502,0.9812l0.0757,8.6567z'/%3E %3Cpath d='m513.68,453.74c-0.30139,0.024-0.53439,0.061-0.54902-0.1252-0.0202-0.2603,0.0639-0.4728,0.12989-0.7027l1.0299-3.3933c0.0675-0.2114,0.13304-0.2353,0.16658-0.2378,0.0835-0.01,0.0336,0,0.14543,0.1382l1.6378,3.2586c0.1013,0.2165,0.21769,0.4133,0.23833,0.6737,0.0135,0.1859-0.22128,0.1857-0.52255,0.2095l-2.2765,0.179zm2.8745,0.7845c0.43534-0.034,0.53353,0.1452,1.2002,1.5525,0.22377,0.4877,0.36722,0.8132,0.3993,1.2224,0.0896,1.1346-1.1152,1.0234-1.0727,1.5629,0.0202,0.2606,0.23525,0.2062,0.53635,0.1823,0.48569-0.038,1.0992-0.1611,1.8356-0.2192,1.105-0.087,1.5626-0.048,2.1654-0.096,0.45193-0.035,0.60557-0.011,0.5808-0.3265-0.0484-0.6137-0.89512,0.1828-1.535-1.0954l-5.4156-11.028c-0.2617-0.5409-0.29798-0.5755-0.44882-0.5637-0.21746,0.018-0.27352,0.3771-0.36724,0.6841l-3.6509,11.61c-0.33625,1.0744-1.1988,1.0299-1.1652,1.4577,0.0202,0.242,0.28391,0.1834,0.51833,0.1652,0.4854-0.038,0.9652-0.1508,1.4672-0.1905,0.53578-0.042,1.0437-0.01,1.5795-0.049,0.35148-0.028,0.88079,0.062,0.85012-0.3289-0.0396-0.502-1.8243-0.062-1.9296-1.4014-0.0351-0.4466,0.14791-1.116,0.23581-1.497,0.28845-1.2582,0.63428-1.36,0.91879-1.3825l3.2977-0.2595z'/%3E %3Cpath d='m529.53,446.79c-0.16838-1.2764-0.10422-1.3037,1.9104-1.5688,3.213-0.4232,2.1994,1.9121,2.982,1.8092,0.3827-0.05,0.21926-0.6498,0.17086-0.8882l-0.30756-1.8226c-0.0225-0.1666-0.16299-0.336-0.37933-0.3075-1.465,0.1927-2.6041,0.4181-3.786,0.5737-2.5472,0.3352-3.7556,0.419-4.438,0.5088-0.23326,0.031-0.34695,0.1963-0.32501,0.363,0.0974,0.7398,1.9008-0.1,2.1201,1.5649l1.1397,8.6572c0.29686,2.2566-1.0997,1.4245-0.98772,2.2751,0.0158,0.1113,0.12675,0.1905,0.34302,0.1621,0.91567-0.1206,1.6051-0.2867,2.1212-0.3545,0.73277-0.097,1.3583-0.1036,1.9909-0.1869,0.41618-0.055,0.77554-0.027,0.72684-0.397-0.0657-0.4992-1.8859,0.2107-2.1564-1.8424l-0.36048-2.7377c-0.14115-1.073-0.23694-1.286,0.52876-1.387l1.232-0.1621c1.7314-0.2279,1.5235,1.7942,2.0562,1.7241,0.39959-0.053,0.21184-0.7054,0.16389-0.9438l-0.55013-3.2771c-0.0824-0.4973-0.26057-0.4362-0.37707-0.421-0.33318,0.044-0.15894,1.7522-1.5908,1.9408l-1.0488,0.1382c-0.71588,0.094-0.73276-0.035-0.83774-0.8307l-0.34076-2.5897z'/%3E %3Cpath d='m535.67,451.03c0.69026,3.724,3.3782,5.7875,6.6968,5.1724,5.2669-0.9759,5.4408-5.6573,4.965-8.2253-0.72095-3.8893-3.6197-5.8-6.8324-5.1665-3.939,0.7679-5.574,4.2018-4.8294,8.2194zm1.837-1.422c-0.49301-2.66-0.13688-5.3449,2.6435-5.917,2.1229-0.4313,4.5316,1.3235,5.283,5.3776,0.56449,3.0453,0.0957,5.675-2.7341,6.2564-2.9451,0.6027-4.696-3.0386-5.1924-5.717z'/%3E %3Cpath d='m550.53,443.11c-0.26114-1.0887,0.24509-1.21,0.84897-1.3552,1.6493-0.3959,2.886,0.7272,3.3126,2.505,0.2572,1.0705,0.40297,2.11-2.0787,2.7057-0.48992,0.1177-1.0941,0.2625-1.203-0.1907l-0.87993-3.6646zm0.009,8.8818c0.54873,2.2859-0.91737,2.0045-0.77808,2.585,0.0869,0.363,0.41676,0.2262,0.59657,0.1832,0.81635-0.196,1.6152-0.4646,2.4971-0.6762,0.6855-0.1645,1.1439-0.1981,1.4214-0.2645,0.37566-0.09,0.48007-0.2305,0.44094-0.3937-0.15668-0.6531-1.5947,0.4787-2.0607-1.4624l-0.75358-3.1385c-0.15219-0.6351-0.28085-0.7386,0.58444-0.9463,0.81635-0.1959,1.1495-0.1033,1.7168,0.6047l2.0596,2.5374c0.75895,0.9306,1.5559,1.9481,2.8455,1.6386,0.65314-0.1567,1.6349-0.8147,1.5001-1.3772-0.0348-0.1449-0.15893-0.2304-0.30616-0.1949-0.16321,0.039-0.30026,0.1871-0.46374,0.2265-0.13058,0.031-0.44068,0.1056-0.65735-0.1495-1.7244-2.0035-3.7438-4.3009-3.7699-4.4098-0.0437-0.1814,0.39058-0.4584,0.76402-0.9894,0.36919-0.549,0.68155-1.3338,0.40267-2.4949-0.20036-0.8346-1.1411-3.3143-4.7168-2.4557-1.0941,0.2625-2.1867,0.6016-3.2808,0.8641-1.0285,0.2471-1.1766,0.2058-1.9279,0.3861-0.19586,0.047-0.33739,0.177-0.29378,0.3585,0.15668,0.6532,1.7754-0.4454,2.2633,1.5866l1.9163,7.9824z'/%3E %3Cpath d='m564.01,448.98c0.55604,2.1496-1.5052,1.7576-1.3232,2.462,0.10265,0.3976,0.37456,0.3081,0.66721,0.2324,0.6503-0.1682,1.1681-0.3793,2.2574-0.661,1.089-0.2817,1.6442-0.3481,2.2945-0.5164,0.47133-0.1218,0.81043-0.1517,0.69844-0.5853-0.13079-0.5057-2.0762,0.5563-2.6508-1.6656l-2.1116-8.1645c-0.22422-0.867-0.0851-0.9993,0.58137-1.1718l1.3819-0.3573c1.8508-0.5558,1.8491,1.5837,2.4994,1.4157,0.42266-0.1094,0.0617-0.7677-0.027-0.9759l-0.60866-1.6155c-0.0628-0.1765-0.12831-0.4295-0.372-0.3664-1.512,0.3911-2.5824,0.7451-4.956,1.3589-2.3733,0.6137-3.4812,0.8231-4.9932,1.2142-0.2437,0.063-0.17852,0.316-0.14813,0.5006l0.35652,2.4518c0.0284,0.2432,0.0336,0.6658,0.37482,0.5775,0.73165-0.1891-0.36807-2.4293,1.4689-2.9043l1.3656-0.3532c0.66663-0.1724,0.85236-0.124,1.0766,0.7429l2.1676,8.3812z'/%3E %3Cpath d='m572.6,437.52c-0.47387-1.7079,0.91935-1.3972,0.74995-2.0087-0.0599-0.2156-0.15083-0.229-0.63626-0.095-0.92242,0.2558-1.4849,0.4894-2.0674,0.6509-0.56618,0.1569-1.2173,0.26-1.8482,0.435-0.14588,0.04-0.56534,0.098-0.48063,0.4044,0.17469,0.6292,1.8634-0.3813,2.317,1.2548l2.3936,8.6299c0.47358,1.7079-0.82113,1.5635-0.64666,2.193,0.025,0.09,0.0923,0.2069,0.23806,0.1664,0.42042-0.1169,1.0963-0.3816,1.7922-0.5746,1.2621-0.3501,1.8806-0.4441,2.4794-0.6101,0.37228-0.1034,0.49779-0.2155,0.44293-0.4134-0.15961-0.5752-1.7424,0.7544-2.3556-1.4571l-2.3784-8.5759z'/%3E %3Cpath d='m576.18,441.69c1.2018,3.5918,4.1509,5.2611,7.3516,4.1901,5.0796-1.6994,4.6006-6.3594,3.7716-8.8365-1.255-3.7508-4.3912-5.2394-7.4847-4.1651-3.7938,1.3088-4.9349,4.9366-3.6385,8.8115zm1.6214-1.6639c-0.85856-2.5652-0.87938-5.2734,1.7939-6.2271,2.0424-0.7226,4.6718,0.6799,5.9803,4.5899,0.98265,2.9373,0.88416,5.6064-1.837,6.5761-2.8326,1.0065-5.0731-2.3557-5.9372-4.9389z'/%3E %3Cpath d='m589.72,431.56c-0.41027-1.0414,0.0741-1.2322,0.65229-1.4599,1.5781-0.6216,2.9589,0.3183,3.6289,2.0193,0.40353,1.0243,0.69254,2.0334-1.6819,2.9688-0.46881,0.1846-1.0468,0.4123-1.2179-0.023l-1.3814-3.5065zm1.2446,8.7943c0.86165,2.1871-0.62977,2.1128-0.41085,2.6683,0.13666,0.3472,0.44433,0.1661,0.61627,0.098,0.78117-0.3076,1.535-0.6847,2.3784-1.017,0.65622-0.2586,1.1056-0.3551,1.371-0.4601,0.35963-0.1412,0.44348-0.2946,0.38185-0.4511-0.24621-0.625-1.5125,0.6962-2.2442-1.1613l-1.183-3.0031c-0.23919-0.6076-0.38101-0.6923,0.44714-1.0184,0.78116-0.3076,1.1239-0.2623,1.7841,0.3599l2.3928,2.2259c0.88105,0.816,1.8117,1.7128,3.0459,1.2266,0.62497-0.2462,1.5058-1.0341,1.2936-1.5725-0.0545-0.1387-0.18933-0.206-0.3298-0.1506-0.15646,0.062-0.27154,0.2271-0.42773,0.2887-0.12494,0.049-0.42181,0.1662-0.67198-0.056-1.9864-1.7441-4.306-3.7381-4.3468-3.8422-0.0687-0.1736,0.32305-0.5082,0.61878-1.0859,0.28901-0.5952,0.48908-1.416,0.0515-2.527-0.31461-0.7986-1.5913-3.123-5.0129-1.7753-1.0468,0.4125-2.0818,0.9002-3.1286,1.3127-0.98406,0.3877-1.1363,0.3675-1.8553,0.6506-0.18752,0.074-0.30954,0.2219-0.24115,0.3956,0.24621,0.625,1.6963-0.688,2.4622,1.2562l3.0087,7.638z'/%3E %3C/g%3E %3Cg%3E %3Cg fill='%23fedf00'%3E %3Cpath fill='%23d52b1e' d='m412.66,249.25h82.179v82.023h-82.179z'/%3E %3Cpath id='mits' fill='%23fff' d='m451.2,313.83s-0.048,2.9314-0.85518,5.2867c-0.93313,2.7214-0.94016,2.7214-1.7956,4.0429-1.1524,1.7809-2.5571,3.0827-3.8096,3.8875-1.9583,1.2584-3.9483,1.8876-5.9482,1.7103-5.491-0.4865-8.0382-6.4401-9.2831-11.273-1.3217-5.131-5.0733-7.9231-7.4638-6.0642-1.3994,1.0885-1.4782,2.9142-0.31093,4.6651,1.2441,1.8657,4.0991,2.7988,4.0991,2.7988l-2.9328,3.7319s-6.3019-0.8205-7.5345-7.3932c-0.46629-2.4881,0.74177-7.1335,4.891-8.5222,5.2968-1.7731,8.686,2.0041,10.318,5.1916,2.2456,4.3836,3.2096,12.434,9.4294,11.19,3.3838-0.6768,4.976-5.5979,4.976-7.8525l2.467-2.6434,3.6542,1.1664,0.0986,0.078z'/%3E %3Cuse xlink:href='%23mits' transform='matrix(-1,0,0,1,907.5206,0)'/%3E %3Cpath d='m461.12,278.95,10.76-11.643s1.624-1.3096,1.6096-3.4015l-2.2186,0.3452-0.49694-1.1416-0.11054-1.1473,2.9817-0.6292c0.0473-0.4843,0.007-0.8507,0.092-1.385,0.0795-0.4939,0.19-0.7587,0.31123-1.2441l-3.2656,0.2188c0.16592-0.5715,0.1281-0.8754,0.31094-1.4067,0.15399-0.4469,0.19675-0.6177,0.50287-1.1028,0.60641-0.091,1.158-0.2279,1.9073-0.3039,0.7277-0.073,1.1433-0.039,1.8733-0.085,1.781-3.3214,9.1894-6.3732,14.454-0.9042,3.8096,3.9582,2.9876,11.219-1.9509,13.139-2.7988,1.0885-5.0534,0.4449-6.8617-1.1101l1.9709-3.8656c2.7211,1.6254,4.9757-0.3959,4.8204-2.4952-0.19676-2.6535-1.9186-4.2966-4.3538-4.5094-2.2543-0.197-3.8726,1.093-4.8983,3.1101-0.62583,1.2305-0.33627,2.1332-0.54423,3.4986-0.22568,1.4833-0.0988,2.3109-0.53691,3.8096-0.31825,1.0882-1.1549,2.4341-2.3697,3.5926l-11.03,11.935-42.941,46.445-3.2268-2.9831,43.211-46.737z'/%3E %3Cpath fill='%23fff' d='m429.51,283.04s2.6994,13.372,11.874,33.431c4.665-1.7103,7.4191-2.7991,12.362-2.7991,4.9431,0,7.6971,0.9331,12.362,2.7991,9.1742-20.059,11.874-33.431,11.874-33.431l-24.236-31.177-24.236,31.177z'/%3E %3Cpath d='m456.12,262.41,16.82,21.637s-2.2433,10.52-9.0782,26.354c-2.646-0.6025-4.9158-1.1276-7.7323-1.3195l-0.009-46.671z'/%3E %3Cpath d='m451.38,262.41-16.82,21.637s2.2433,10.52,9.0782,26.354c2.646-0.6025,4.9158-1.1276,7.7323-1.3195l0.009-46.671z'/%3E %3C/g%3E %3Cg fill='%23d52b1e'%3E %3Cpath fill='%23fedf00' d='m503.6,249.25h82.179v82.023h-82.179z'/%3E %3Cpath d='m515.11,249.25h12.253v82.023h-12.253z'/%3E %3Cpath d='m538.59,249.25h12.253v82.023h-12.253z'/%3E %3Cpath d='m562.07,249.25h12.253v82.023h-12.253z'/%3E %3C/g%3E %3Cg fill='%23d52b1e' stroke='%23d52b1e' stroke-width='0.513'%3E %3Cpath fill='%23fedf00' stroke='none' d='m412.97,402.41c0.23327,1.4774,0.75922,4.0119,2.1625,6.6087,1.4771,2.3322,0.93285,2.2689,4.2762,6.0008,1.6456,1.837,4.2137,3.4109,6.2271,4.4948,2.0213,1.0885,3.5169,1.6229,6.8417,2.4952,6.5175,1.7104,11.091,1.817,16.574,1.5984,4.2781-0.1709,7.5443-0.6973,10.249-1.0615,3.8574-0.5189,6.7305-0.8278,11.118-1.0105,2.1333-0.089,4.149-0.1101,6.1421,0,2.4057,0.1326,4.7818,0.5054,7.3085,1.0105,5.442,1.0885,10.962,3.1877,10.962,3.1877l0.0135-85.655-82.193-0.023v58.543s0.16862,2.8599,0.31828,3.8096z'/%3E %3Cpath d='m422.51,417.43,3.8518,2.2412,5.2782,1.8989-0.005-81.527h-9.1264z'/%3E %3Cpath d='m468.17,421.14,0.0113-81.099h-9.1435v82.396s6.2572-0.80203,9.1312-0.98833z'/%3E %3Cpath d='m486.41,340.05h-9.1134v81.381c2.9699,0.3213,6.0236,0.85177,9.1311,1.6825l-0.018-83.064z'/%3E %3Cpath d='m449.92,340.05v83.331c-0.0903,0.01-6.1007,0.31515-9.1733-0.003l0.002-83.314z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23fedf00' d='m585.48,402.39c-0.23327,1.4771-0.75921,4.0116-2.1626,6.6084-1.4771,2.3325-0.93285,2.2692-4.2759,6.0009-1.6456,1.8369-4.214,3.4108-6.2271,4.495-2.0216,1.0885-3.5169,1.6226-6.8417,2.4952-6.5178,1.7103-11.091,1.817-16.574,1.5981-4.2778-0.1707-7.544-0.6973-10.249-1.0612-3.8574-0.5189-6.7305-0.8279-11.118-1.0108-2.133-0.089-4.149-0.1096-6.1421,0-2.4057,0.1326-4.7815,0.5054-7.3082,1.0108-5.4423,1.0885-11.033,3.1877-11.033,3.1877l0.0565-85.655,82.193-0.023v58.543s-0.16815,2.8596-0.31826,3.8096z'/%3E %3Cg id='cow'%3E %3Cpath fill='%23d52b1e' d='m524.62,346.91s-0.36638,0.1753-0.59375,0.2813c-0.29828,0.3273-0.44752,0.519-0.78125,0.8125-0.44293,0.3892-0.76881,0.503-1.25,0.8437-0.23045,0.163-0.41928,0.2156-0.59375,0.4375-0.25219,0.3208-0.0791,0.6292-0.25,1-0.18658,0.405-0.36896,0.5965-0.65625,0.9375-0.36612,0.4348-0.64912,0.6098-1.0625,1-0.41817,0.3951-0.58752,0.7265-1.0938,1-0.1339,0.072-0.19832,0.1425-0.34375,0.1875-0.21554,0.067-0.34931-0.011-0.5625,0.062-0.38806,0.1343-0.51024,0.5626-0.78125,0.7188,0.11196,0.2178,0.10686,0.3725,0.21875,0.5937,0.15785,0.3234,0.70512,1.2154,0.8125,1.4375,0.20907,0.3051,0.27011,0.6996,0.53125,0.7813,0.53775,0.1681,0.8586,0.1532,1.3125,0.125,0.79213,0.1818,1.2805,0.1578,2.0312,0.4687,0.61288,0.2539,0.86262,0.575,1.4688,0.8438,0.47418,0.2102,0.77191,0.3394,1.2812,0.4375,0.38665,0.074,0.60802,0.132,1,0.094,0.24961-0.024,0.37681-0.1197,0.625-0.1562,0.0488-0.01,0.0809,0,0.125,0l-0.0312,0.375c-0.005,0,0.005,0.028,0,0.031v0.062h0.0625l2.0625,0.9063c-0.0738,0.1176-0.1515,0.2566-0.1875,0.375-0.0981,0.3205-0.114,0.6886-0.0625,0.8437,0.62922,1.8877,1.1592,3.0684,1.4688,3.1875,0.6154,0.2364,0.80591,0.8649,1.1562,1.5-0.12367,0.1321-0.22734,0.2008-0.34375,0.3125-0.61493,0.5902-1.152,1.0093-1.6562,1.8125-0.74541,1.1879-1.2487,1.2038-0.3125,2.7813,0.54902,0.9247,0.81425,1.0994,1.5312,2.4062,0.36161,0.6591,0.56221,1.1733,0.78125,1.9688,0.20712,0.7519,0.2779,1.1895,0.3125,1.9687l0.96875,0.375,0.65625-0.6562,0.625-1.1875,0.0312-0.9063c-0.23861-0.2026-0.3076-0.4733-0.25-0.7812,0.0695-0.3686,0.51434-0.2913,0.71875-0.625,0.28309-0.4615-0.33152-0.7344-0.65625-1.0938-0.60558-0.6697-1.4305-0.8329-1.625-1.8437-0.0523-0.2732,0.0776-0.4267,0.375-0.7188,0.85519-0.8399,1.1299-0.9736,1.9688-1.8125,0.242,0.142,0.61054,0.1932,0.96875,0.125,0.27914-0.053,0.52914,0.1252,1.4062,0.375,0.60951,0.1736,0.8732,0.086,1.2188,0.031l0.375-0.094c0.0504,0.2114,0.1115,0.4157,0.125,0.6875,0.0531,1.0604-0.15471,2.9947,0.15625,3.5,0.13118,0.2131,0.18605,0.3315,0.28125,0.5625,0.0986,0.2406,0.21375,0.3963,0.21875,0.6563,0.0112,0.6956,0.0471,1.1405,0,1.875-0.0441,0.6911-0.10304,1.042-0.21875,1.75-0.074,0.4511-0.16594,0.7136-0.4375,1.0625-0.28336,0.3639-0.59506,0.4174-0.96875,0.6875l-0.0937,1,1.125,0.4687,1.2812,0.3125,0.6875-0.2812c0-0.2544,0.0399-0.399,0.15625-0.625,0.12748-0.2465,0.23181-0.4386,0.46875-0.5313,0.36244-0.1423,0.75947,0.1292,0.90625-0.094,0.15946-0.242,0.0594-0.3375,0.0312-0.75-0.0453-0.6621-0.18355-0.9888-0.28125-1.6563-0.16416-1.1107-0.20985-1.6865-0.15625-2.75,0.0311-0.6165,0.0383-0.9563,0.15625-1.5625,0.17195-0.8824,0.48556-1.3112,0.6875-2.1875,0.22541-0.9775,0.2647-1.6062,0.375-2.4687,3.1694,0.4528,5.8074,0.3972,9.3438-0.375,0.16911-0.037,0.75-0.25,0.75-0.25,0.79947,0.6889,1.706,1.2642,2.7188,1.625-0.006,0.1016-0.0158,0.8456,0,0.9687,0.0365,0.2876-0.0414,0.4813,0.125,0.7188,0.10551,0.1506,0.19603,0.2396,0.375,0.2812,0.26255,0.061,0.45476,0.023,0.65625-0.1562,0.22633-0.2015,0.1843-0.4545,0.25-0.75,0.032-0.1407,0.007-0.5644,0-0.6875,0.36667,0.055,0.49117,0.062,0.875,0.062,0.35765,0,0.52944,0.014,0.875-0.031,0.005,0.081,0.0199,0.3689,0.0312,0.4688,0.0268,0.2443-0.0757,0.4347,0.0312,0.6562,0.11087,0.2296,0.24955,0.3592,0.5,0.4063,0.20599,0.039,0.35363,0.018,0.53125-0.094,0.29551-0.1851,0.2632-0.4984,0.3125-0.8437,0.0146-0.11,0.0113-0.6919,0-0.7813,0.21161-0.067,0.82729-0.2917,1.0312-0.375-0.005,0.2426-0.0388,0.5168-0.0937,0.8125-0.0699,0.376-0.11965,0.5785-0.25,0.9375-0.20598,0.5676-0.44159,0.8561-0.75,1.375-0.37681,0.6338-0.57286,0.9854-1.0312,1.5625-0.21105,0.266-0.35764,0.3856-0.5625,0.6563-0.25522,0.3374-0.34218,0.5663-0.59375,0.9062-0.32418,0.4382-0.51034,0.724-0.9375,1.0625-0.69364,0.5499-1.1499,0.1099-2.0938,0.8438l-0.21875,1.0312,1.4375,0.5313,1.2812,0.25,0.4375-0.25c-0.0118-0.3011,0.0319-0.5139,0.21875-0.75,0.21357-0.2698,0.44159-0.3511,0.78125-0.4063,0.36132-0.059,0.74677,0.034,1.0312-0.2187,0.35006-0.3109,0.34867-0.9141,0.625-1.4688,0.85827-1.7235,1.6208-2.5628,3-3.9062,0.6126-0.5966,1.1374-0.7579,1.6562-1.4375,0.24651-0.3225,0.51995-0.4692,0.53125-0.875,0.008-0.2828-0.14395-0.4151-0.21875-0.6875-0.10357-0.3771-0.1875-1-0.1875-1,1.5218,0.7446,0.97085,0.6462,1.25,1.4062,0.22555,0.6149-0.0325,1.0395,0.0625,1.6875,0.11114,0.7559,0.46615,1.1139,0.53125,1.875,0.0777,0.9048-0.14299,1.4205-0.3125,2.3125-0.14886,0.7846-0.12995,1.2768-0.46875,2-0.32248,0.6889-0.57094,1.0769-1.1562,1.5625-0.21105,0.175-0.36836,0.2503-0.59375,0.4063l-0.125,1.0312,1.125,0.375,1.625,0.4375,0.375-0.3437c0.16348-0.6545-0.0547-1.6165,0.40625-1.6875,0.40606-0.062,0.69275,0.0001,0.78125-0.3125,0.0367-0.1314,0.0589-0.3259,0.0937-0.625,0.22118-1.8859,0.42149-3.6454,0.625-4.5,0.23012-0.9677,0.21445-1.178,0.40625-1.9063,0.17532-0.6641-0.0853-0.2824,0.40625-1.6875,0.73418-2.0972-0.20816-2.375-1.0625-3.6562-0.46205-0.6931-0.6218-0.9442-0.6875-1.5-0.097-0.8169,0.1647-1.4947,0.125-2.75-0.041-1.3198-0.0225-2.1591,0-2.875,0.11538-0.053,0.22175-0.1207,0.34375-0.1875,1.1706-0.6427,1.6363-0.8361,2.375-2.4688,0.22389-0.4955,0.3195-0.9937,0.3125-1.4687-0.005-0.3321-0.0648-0.6522-0.0937-1.0313-0.0304-0.399-0.19094-0.6375-0.3125-0.9375-0.12945-0.3182-0.32443-0.5586-0.5625-0.8437-0.77243-0.9247-1.7789-1.1319-2.7188-1.4688-1.4835-0.5317-2.505-0.4346-4.125-0.5625-1.6721-0.1321-2.6064-0.1577-4.2812-0.062-2.0067,0.1143-3.1279,0.519-5.125,0.75-1.9158,0.2217-2.9778,0.3701-4.9062,0.4063-2.2602,0.042-4.4207-0.4606-5.7812-0.3438-2.451,0.21-2.493,0.7612-6.1875,1.0625-1.927,0.1574-3.8438,0.1875-3.8438,0.1875l-2.1562-0.6875c0.85659-0.3061,1.0661-0.4881,1.4688-1.0312,0.27183-0.3661,0.23326-0.6784,0.5625-1.0625,0.26677-0.3118,0.443-0.6224,0.78125-0.9688-0.3101-0.2491-0.64289-0.3763-0.9375-0.4375-0.36386-0.076-0.57336-0.042-0.9375,0-0.49414,0.056-0.77245,0.1243-1.2188,0.3438-0.35934,0.177-0.62403,0.3574-0.84375,0.5937,0,0-1.2856-0.8287-2.1875-1.2187-1.1186-0.4843-1.6006-0.7117-3-0.9063zm1.9688,11.906h0.0625c-0.0123,0.01-0.019,0.022-0.0312,0.031l-0.0312-0.031z'/%3E %3Cg fill='none' stroke='%23fedf00' stroke-width='0.987' stroke-linecap='round'%3E %3Cpath d='m568.77,359.52-0.76315,0.244c-0.86699,0.4021-1.5778,0.4178-2.6001,0.4961-2.6437,0.2021-4.2714-1.0572-6.9976-0.8476-1.4039,0.108-2.0252,1.1909-3.4598,1.5483-0.65256,0.1625-1.0313,0.2254-1.7016,0.2819l0.51272-1.0333s-1.284,0.2617-2.1153,0.2634c-0.59629,0.001-0.93595-0.028-1.5235-0.1301l1.0181-0.9506s-0.81351-0.1319-1.2936-0.3351c-0.44265-0.1871-0.68353-0.3301-1.06-0.6292,0.66327-0.1139,1.0358-0.1921,1.6893-0.3535,1.5561-0.3849,2.0398-1.147,3.8909-1.3254,1.149-0.1112,3.0321-0.046,7.6428,0.7168,3.0357,0.502,4.3822,0.267,5.5354-0.2572,0.7609-0.3459,1.0108-1.0108,1.1031-1.7883,0.0925-0.7764-0.40408-1.4045-0.87376-1.81-0.12268-0.106-0.44404-0.3351-1.1129-0.363'/%3E %3Cpath fill='%23fcd900' stroke-width='0.513' stroke-linecap='butt' d='m524.8,350.61c-0.53042-0.066-0.88442,0.011-1.3397,0.2915-0.48036,0.2958-0.5417,0.6965-0.88809,1.142,0.44517,0.099,0.69843,0.3607,1.1419,0.2538,0.34668-0.084,0.52677-0.2386,0.76117-0.5076,0.31546-0.3625,0.4314-0.6754,0.42746-1.156l-0.10266-0.024z'/%3E %3Cpath d='m536.04,363.79s0.26396,0.4801,0.40661,0.7992c0.24793,0.5552,0.37624,0.8785,0.52426,1.468,0.20036,0.7987,0.11369,1.2838,0.24088,2.0973,0.0225,0.1432,0.0498,0.2634,0.0767,0.3768l-0.0511,1.1287'/%3E %3Cpath d='m544.04,362.71s-0.21881,0.8122-0.354,1.3325c-0.35201,1.3538-0.67648,2.0871-0.94381,3.4601-0.0448,0.2302-0.0777,0.4429-0.10356,0.6444'/%3E %3Cpath d='m531.78,364.17c0.79018,0.1756,0.54424,3.3602,1.7888,4.0904'/%3E %3Cpath stroke-linecap='butt' d='m560.12,369.78,0.3844-0.249c1.0139-0.4146,1.9251-1.0271,2.6857-1.7897'/%3E %3Cpath d='m552.38,368.02c0.002-0.0005,0.005-0.0009,0.007,0,3.533-0.883,5.8849-2.6476,7.5786-2.8688'/%3E %3Cpath d='m555.97,363.61c0.29885-0.011,0.58475-0.033,0.82928-0.068,1.4681-0.2096,1.7042,0.6869,2.7262,1.2584,1.8564,1.0381,2.0973,2.307,4.299,3.3555,0.11638,0.055,0.22331,0.1069,0.32135,0.1551l0.84729,0.4288'/%3E %3Cpath fill='%23fcd900' stroke-width='0.513' stroke-linecap='butt' d='m517.7,354.53c0.26819,0.067,0.43196,0.08,0.70745,0.054,0.33148-0.031,0.48373-0.2378,0.81635-0.2488,0.27097-0.01,0.46261-0.032,0.68407,0.1245,0.14092,0.099,0.1999,0.1894,0.27999,0.3419,0.0871,0.1668,0.163,0.2823,0.1245,0.4666-0.0595,0.2842-0.32417,0.4173-0.61431,0.4198-0.23721,0-0.43391-0.062-0.54422-0.2721-0.0707-0.1348-0.0815-0.2425-0.0388-0.3886-0.28393,0.1067-0.48964,0.1108-0.7775,0.016-0.30308-0.1002-0.47473-0.2386-0.63738-0.513z'/%3E %3C/g%3E %3Cg fill='%230065bd'%3E %3Cpath d='m525.13,364.17c-0.79692-0.2375-1.9658-0.8259-1.9658-0.8259,0.32277-0.251,0.58672-0.2651,0.86276-0.5547,0.38919-0.4083,0.37287-0.7885,0.59264-1.3192,0.21566-0.52,0.18459-0.9545,0.67142-1.3428,0.28956-0.231,0.76232-0.269,1.1177-0.1652,0.35287,0.1127,0.75921,0.4012,0.84843,0.7662,0.13732,0.5611-0.15984,0.8853-0.24595,1.454-0.0858,0.5679-0.29295,0.894-0.19473,1.4599,0.0651,0.3743,0.22625,0.5186,0.35344,0.9072,0,0-1.2643-0.1488-2.0399-0.3796z'/%3E %3Cpath d='m524.14,365.12c-0.007-0.3473,0.2707-0.634,0.61795-0.6399,0.34754-0.01,0.634,0.2707,0.64019,0.6179,0.007,0.3475-0.2707,0.634-0.61795,0.6399-0.34754,0.01-0.634-0.2704-0.64019-0.6179z'/%3E %3Cpath d='m522.38,348.61s-0.0898-0.06-0.14362-0.1036c-0.38326-0.3098-0.41985-0.6531-0.60164-1.111-0.17221-0.4333-0.25692-0.6908-0.3146-1.1534-0.0506-0.4058,0-0.6396,0-1.0485,0-0.3681,0.0396-0.5777,0-0.9435-0.0405-0.3751-0.0306-0.6121-0.21003-0.9438-0.097-0.1801-0.39453-0.3374-0.31435-0.4196,0.0946-0.097,0.25694-0.02,0.4193,0,0.39987,0.048,0.63089,0.1657,0.94381,0.4196,0.37707,0.3058,0.52651,0.5709,0.67171,1.0485,0.16681,0.5481,0.24847,0.8982,0.40774,1.468,0.0826,0.2955,0.12877,0.4688,0.28365,0.7339,0.16096,0.2758,0.31967,0.3838,0.52425,0.6292l-0.0113,0.023c-0.29828,0.327-0.44378,0.5394-0.77666,0.8338-0.30504,0.2699-0.55998,0.4033-0.84674,0.5729l-0.0324-0.01z'/%3E %3Cpath d='m525.98,359.25,2.2309,1.0311c1.1481-0.6348,2.4732-1.9239,3.4964-3.9191,0.88079-1.7176,1.0206-2.6505,1.3639-4.3127l-1.7891-0.5817-0.35709,0.073c-0.55239,1.7233-0.69253,2.704-1.6178,4.1926-0.80226,1.2911-1.7185,2.3049-2.6491,3.0338l-0.67817,0.4834z'/%3E %3Cpath d='m530.92,377.37c0.35963-0.4928,0.51327-0.8107,0.92214-1.2635,0.45616-0.5051,0.80003-0.7021,1.3116-1.151,0.15556,0.016,0.33544-0.011,0.4812,0.072-0.0284,0.5448-0.0563,0.9487-0.1801,1.5407-0.10041,0.4804-0.1864,0.746-0.34698,1.2097-0.13462,0.3881-0.15848,0.6391-0.38973,0.979-0.1542,0.2266-0.29013,0.3158-0.47585,0.5178-0.51046-0.7418-1.3302-1.2967-1.3223-1.9053z'/%3E %3Cpath d='m563.93,379.22c0.57264,0.2103,0.92075,0.2702,1.4686,0.5384,0.6112,0.2994,0.89541,0.5757,1.4678,0.9438,0.0268,0.154,0.10379,0.3188,0.063,0.4823-0.53155,0.1229-0.92749,0.2076-1.5308,0.2516-0.48935,0.036-0.76849,0.027-1.2584,0-0.41028-0.023-0.65818,0.024-1.0485-0.1047-0.26058-0.086-0.38383-0.192-0.62891-0.3146,0.57236-0.6954,0.87992-1.6364,1.4672-1.7968z'/%3E %3Cpath d='m554.17,377.18c0.57265,0.21,0.92047,0.2699,1.4683,0.538,0.6112,0.2994,0.89571,0.5758,1.4681,0.9438,0.0263,0.154,0.10378,0.3189,0.063,0.4826-0.53157,0.1227-0.92749,0.2074-1.5311,0.2513-0.48934,0.036-0.76821,0.027-1.2581,0-0.41029-0.023-0.65821,0.024-1.0485-0.1046-0.26058-0.086-0.38383-0.1918-0.62921-0.3146,0.57263-0.6954,0.87992-1.6364,1.4675-1.7965z'/%3E %3Cpath d='m536.83,379.31c0.57292,0.21,0.92073,0.2701,1.4686,0.5383,0.6112,0.2991,0.89571,0.5758,1.4681,0.9438,0.0266,0.154,0.10378,0.3189,0.063,0.4824-0.53157,0.1227-0.92749,0.2075-1.5311,0.2515-0.48934,0.036-0.76821,0.027-1.2581,0-0.41028-0.022-0.65821,0.024-1.0485-0.1049-0.26058-0.086-0.38383-0.1915-0.62922-0.3143,0.57237-0.6953,0.87993-1.6363,1.4672-1.7967z'/%3E %3Cpath d='m527.85,349.51c-0.61259-0.2781-1.0493-1.0446-0.66072-1.5939,0.15555-0.2197,0.41309-0.1736,0.56617-0.3951,0.18866-0.2726,0.14161-0.5076,0.13597-0.8388-0.007-0.3771-0.14385-0.5727-0.20957-0.9438-0.072-0.4058-0.13913-0.6363-0.13598-1.0485,0.005-0.6281-0.0378-1.0756,0.34555-1.5728,0.24454-0.3171,0.66044-0.5923,0.82421-0.6123,0.14746,0.1364-0.0565,0.502-0.0322,0.822,0.0353,0.462,0.13056,0.7173,0.28758,1.1534,0.20239,0.5625,0.47867,0.8085,0.70267,1.3631,0.20847,0.5156,0.39986,0.8074,0.41956,1.3631,0.0158,0.4567-0.0241,0.7356-0.20959,1.1535-0.16434,0.3695-0.2997,0.5791-0.60951,0.8388-0.26931,0.2252-0.45841,0.3251-0.79637,0.4193-0.24735,0.02-0.40157-0.01-0.62781-0.108z'/%3E %3C/g%3E %3C/g%3E %3Cuse xlink:href='%23cow' y='36.590756'/%3E %3C/g%3E %3Cg fill='none' stroke='%23703d29' stroke-width='0.797'%3E %3Cpath d='m412.66,249.25h82.179v82.023h-82.179z'/%3E %3Cpath d='m503.6,249.25h82.179v82.023h-82.179z'/%3E %3Cpath d='m412.97,402.41c0.23327,1.4774,0.75922,4.0119,2.1625,6.6087,1.4771,2.3322,0.93285,2.2689,4.2762,6.0008,1.6456,1.837,4.2137,3.4109,6.2271,4.4948,2.0213,1.0885,3.5169,1.6229,6.8417,2.4952,6.5175,1.7104,11.091,1.817,16.574,1.5984,4.2781-0.1709,7.5443-0.6973,10.249-1.0615,3.8574-0.5189,6.7305-0.8278,11.118-1.0105,2.1333-0.089,4.149-0.1101,6.1421,0,2.4057,0.1326,4.7818,0.5054,7.3085,1.0105,5.442,1.0885,10.962,3.1877,10.962,3.1877l0.0135-85.655-82.193-0.023v58.543s0.16862,2.8599,0.31828,3.8096z'/%3E %3Cpath d='m585.48,402.39c-0.23327,1.4771-0.75921,4.0116-2.1626,6.6084-1.4771,2.3325-0.93285,2.2692-4.2759,6.0009-1.6456,1.8369-4.214,3.4108-6.2271,4.495-2.0216,1.0885-3.5169,1.6226-6.8417,2.4952-6.5178,1.7103-11.091,1.817-16.574,1.5981-4.2778-0.1707-7.544-0.6973-10.249-1.0612-3.8574-0.5189-6.7305-0.8279-11.118-1.0108-2.133-0.089-4.149-0.1096-6.1421,0-2.4057,0.1326-4.7815,0.5054-7.3082,1.0108-5.4423,1.0885-11.033,3.1877-11.033,3.1877l0.0565-85.655,82.193-0.023v58.543s-0.16815,2.8596-0.31826,3.8096z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"},function(a,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var l=Ul(i(256)),e=Ul(i(255)),o=Ul(i(254)),c=Ul(i(253)),r=Ul(i(252)),s=Ul(i(251)),n=Ul(i(250)),d=Ul(i(249)),m=Ul(i(248)),f=Ul(i(247)),h=Ul(i(246)),p=Ul(i(245)),C=Ul(i(244)),E=Ul(i(243)),k=Ul(i(242)),g=Ul(i(241)),u=Ul(i(240)),z=Ul(i(239)),y=Ul(i(238)),w=Ul(i(237)),v=Ul(i(236)),b=Ul(i(235)),x=Ul(i(234)),M=Ul(i(233)),L=Ul(i(232)),R=Ul(i(231)),S=Ul(i(230)),A=Ul(i(229)),F=Ul(i(228)),B=Ul(i(227)),T=Ul(i(226)),G=Ul(i(225)),j=Ul(i(224)),D=Ul(i(223)),N=Ul(i(222)),P=Ul(i(221)),V=Ul(i(220)),I=Ul(i(219)),U=Ul(i(218)),H=Ul(i(217)),K=Ul(i(216)),q=Ul(i(215)),O=Ul(i(214)),_=Ul(i(213)),Z=Ul(i(212)),J=Ul(i(211)),W=Ul(i(210)),Y=Ul(i(209)),Q=Ul(i(208)),X=Ul(i(207)),$=Ul(i(206)),aa=Ul(i(205)),ta=Ul(i(204)),ia=Ul(i(203)),la=Ul(i(202)),ea=Ul(i(201)),oa=Ul(i(200)),ca=Ul(i(199)),ra=Ul(i(198)),sa=Ul(i(197)),na=Ul(i(196)),da=Ul(i(195)),ma=Ul(i(194)),fa=Ul(i(193)),ha=Ul(i(192)),pa=Ul(i(191)),Ca=Ul(i(190)),Ea=Ul(i(189)),ka=Ul(i(188)),ga=Ul(i(187)),ua=Ul(i(186)),za=Ul(i(185)),ya=Ul(i(184)),wa=Ul(i(183)),va=Ul(i(182)),ba=Ul(i(181)),xa=Ul(i(180)),Ma=Ul(i(179)),La=Ul(i(178)),Ra=Ul(i(177)),Sa=Ul(i(176)),Aa=Ul(i(175)),Fa=Ul(i(174)),Ba=Ul(i(173)),Ta=Ul(i(172)),Ga=Ul(i(171)),ja=Ul(i(170)),Da=Ul(i(169)),Na=Ul(i(168)),Pa=Ul(i(167)),Va=Ul(i(166)),Ia=Ul(i(165)),Ua=Ul(i(164)),Ha=Ul(i(163)),Ka=Ul(i(162)),qa=Ul(i(161)),Oa=Ul(i(160)),_a=Ul(i(159)),Za=Ul(i(158)),Ja=Ul(i(157)),Wa=Ul(i(156)),Ya=Ul(i(155)),Qa=Ul(i(154)),Xa=Ul(i(153)),$a=Ul(i(152)),at=Ul(i(151)),tt=Ul(i(150)),it=Ul(i(149)),lt=Ul(i(148)),et=Ul(i(147)),ot=Ul(i(146)),ct=Ul(i(145)),rt=Ul(i(144)),st=Ul(i(143)),nt=Ul(i(142)),dt=Ul(i(141)),mt=Ul(i(140)),ft=Ul(i(139)),ht=Ul(i(138)),pt=Ul(i(137)),Ct=Ul(i(136)),Et=Ul(i(135)),kt=Ul(i(134)),gt=Ul(i(133)),ut=Ul(i(132)),zt=Ul(i(131)),yt=Ul(i(130)),wt=Ul(i(129)),vt=Ul(i(128)),bt=Ul(i(127)),xt=Ul(i(126)),Mt=Ul(i(125)),Lt=Ul(i(124)),Rt=Ul(i(123)),St=Ul(i(122)),At=Ul(i(121)),Ft=Ul(i(120)),Bt=Ul(i(119)),Tt=Ul(i(118)),Gt=Ul(i(117)),jt=Ul(i(116)),Dt=Ul(i(115)),Nt=Ul(i(114)),Pt=Ul(i(113)),Vt=Ul(i(112)),It=Ul(i(111)),Ut=Ul(i(110)),Ht=Ul(i(109)),Kt=Ul(i(108)),qt=Ul(i(107)),Ot=Ul(i(106)),_t=Ul(i(105)),Zt=Ul(i(104)),Jt=Ul(i(103)),Wt=Ul(i(102)),Yt=Ul(i(101)),Qt=Ul(i(100)),Xt=Ul(i(99)),$t=Ul(i(98)),ai=Ul(i(97)),ti=Ul(i(96)),ii=Ul(i(95)),li=Ul(i(94)),ei=Ul(i(93)),oi=Ul(i(92)),ci=Ul(i(91)),ri=Ul(i(90)),si=Ul(i(89)),ni=Ul(i(88)),di=Ul(i(87)),mi=Ul(i(86)),fi=Ul(i(85)),hi=Ul(i(84)),pi=Ul(i(83)),Ci=Ul(i(82)),Ei=Ul(i(81)),ki=Ul(i(80)),gi=Ul(i(79)),ui=Ul(i(78)),zi=Ul(i(77)),yi=Ul(i(76)),wi=Ul(i(75)),vi=Ul(i(74)),bi=Ul(i(73)),xi=Ul(i(72)),Mi=Ul(i(71)),Li=Ul(i(70)),Ri=Ul(i(69)),Si=Ul(i(68)),Ai=Ul(i(67)),Fi=Ul(i(66)),Bi=Ul(i(65)),Ti=Ul(i(64)),Gi=Ul(i(63)),ji=Ul(i(62)),Di=Ul(i(61)),Ni=Ul(i(60)),Pi=Ul(i(59)),Vi=Ul(i(58)),Ii=Ul(i(57)),Ui=Ul(i(56)),Hi=Ul(i(55)),Ki=Ul(i(54)),qi=Ul(i(53)),Oi=Ul(i(52)),_i=Ul(i(51)),Zi=Ul(i(50)),Ji=Ul(i(49)),Wi=Ul(i(48)),Yi=Ul(i(47)),Qi=Ul(i(46)),Xi=Ul(i(45)),$i=Ul(i(44)),al=Ul(i(43)),tl=Ul(i(42)),il=Ul(i(41)),ll=Ul(i(40)),el=Ul(i(39)),ol=Ul(i(38)),cl=Ul(i(37)),rl=Ul(i(36)),sl=Ul(i(35)),nl=Ul(i(34)),dl=Ul(i(33)),ml=Ul(i(32)),fl=Ul(i(31)),hl=Ul(i(30)),pl=Ul(i(29)),Cl=Ul(i(28)),El=Ul(i(27)),kl=Ul(i(26)),gl=Ul(i(25)),ul=Ul(i(24)),zl=Ul(i(23)),yl=Ul(i(22)),wl=Ul(i(21)),vl=Ul(i(20)),bl=Ul(i(19)),xl=Ul(i(18)),Ml=Ul(i(17)),Ll=Ul(i(16)),Rl=Ul(i(15)),Sl=Ul(i(14)),Al=Ul(i(13)),Fl=Ul(i(12)),Bl=Ul(i(11)),Tl=Ul(i(10)),Gl=Ul(i(9)),jl=Ul(i(8)),Dl=Ul(i(7)),Nl=Ul(i(6)),Pl=Ul(i(5)),Vl=Ul(i(4)),Il=Ul(i(3));function Ul(a){return a&&a.__esModule?a:{default:a}}t.default={flag_AD:l.default,flag_AE:e.default,flag_AF:o.default,flag_AG:c.default,flag_AI:r.default,flag_AL:s.default,flag_AM:n.default,flag_AO:d.default,flag_AQ:m.default,flag_AR:f.default,flag_AS:h.default,flag_AT:p.default,flag_AU:C.default,flag_AW:E.default,flag_AX:k.default,flag_AZ:g.default,flag_BA:u.default,flag_BB:z.default,flag_BD:y.default,flag_BE:w.default,flag_BF:v.default,flag_BG:b.default,flag_BH:x.default,flag_BI:M.default,flag_BJ:L.default,flag_BL:R.default,flag_BM:S.default,flag_BN:A.default,flag_BO:F.default,flag_BQ:B.default,flag_BR:T.default,flag_BS:G.default,flag_BT:j.default,flag_BV:D.default,flag_BW:N.default,flag_BY:P.default,flag_BZ:V.default,flag_CA:I.default,flag_CC:U.default,flag_CD:H.default,flag_CF:K.default,flag_CG:q.default,flag_CH:O.default,flag_CI:_.default,flag_CK:Z.default,flag_CL:J.default,flag_CM:W.default,flag_CN:Y.default,flag_CO:Q.default,flag_CR:X.default,flag_CU:$.default,flag_CV:aa.default,flag_CW:ta.default,flag_CX:ia.default,flag_CY:la.default,flag_CZ:ea.default,flag_DE:oa.default,flag_DJ:ca.default,flag_DK:ra.default,flag_DM:sa.default,flag_DO:na.default,flag_DZ:da.default,flag_EC:ma.default,flag_EE:fa.default,flag_EG:ha.default,flag_EH:pa.default,flag_ER:Ca.default,flag_ES:Ea.default,flag_ET:ka.default,flag_FI:ga.default,flag_FJ:ua.default,flag_FK:za.default,flag_FM:ya.default,flag_FO:wa.default,flag_FR:va.default,flag_GA:ba.default,flag_GB_ENG:xa.default,flag_GB_NIR:Ma.default,flag_GB_SCT:La.default,flag_GB_WLS:Ra.default,flag_GB:Sa.default,flag_GD:Aa.default,flag_GE:Fa.default,flag_GF:Ba.default,flag_GG:Ta.default,flag_GH:Ga.default,flag_GI:ja.default,flag_GL:Da.default,flag_GM:Na.default,flag_GN:Pa.default,flag_GP:Va.default,flag_GQ:Ia.default,flag_GR:Ua.default,flag_GS:Ha.default,flag_GT:Ka.default,flag_GU:qa.default,flag_GW:Oa.default,flag_GY:_a.default,flag_HK:Za.default,flag_HM:Ja.default,flag_HN:Wa.default,flag_HR:Ya.default,flag_HT:Qa.default,flag_HU:Xa.default,flag_ID:$a.default,flag_IE:at.default,flag_IL:tt.default,flag_IM:it.default,flag_IN:lt.default,flag_IO:et.default,flag_IQ:ot.default,flag_IR:ct.default,flag_IS:rt.default,flag_IT:st.default,flag_JE:nt.default,flag_JM:dt.default,flag_JO:mt.default,flag_JP:ft.default,flag_KE:ht.default,flag_KG:pt.default,flag_KH:Ct.default,flag_KI:Et.default,flag_KM:kt.default,flag_KN:gt.default,flag_KP:ut.default,flag_KR:zt.default,flag_KW:yt.default,flag_KY:wt.default,flag_KZ:vt.default,flag_LA:bt.default,flag_LB:xt.default,flag_LC:Mt.default,flag_LI:Lt.default,flag_LK:Rt.default,flag_LR:St.default,flag_LS:At.default,flag_LT:Ft.default,flag_LU:Bt.default,flag_LV:Tt.default,flag_LY:Gt.default,flag_MA:jt.default,flag_MC:Dt.default,flag_MD:Nt.default,flag_ME:Pt.default,flag_MF:Vt.default,flag_MG:It.default,flag_MH:Ut.default,flag_MK:Ht.default,flag_ML:Kt.default,flag_MM:qt.default,flag_MN:Ot.default,flag_MO:_t.default,flag_MP:Zt.default,flag_MQ:Jt.default,flag_MR:Wt.default,flag_MS:Yt.default,flag_MT:Qt.default,flag_MU:Xt.default,flag_MV:$t.default,flag_MW:ai.default,flag_MX:ti.default,flag_MY:ii.default,flag_MZ:li.default,flag_NA:ei.default,flag_NC:oi.default,flag_NE:ci.default,flag_NF:ri.default,flag_NG:si.default,flag_NI:ni.default,flag_NL:di.default,flag_NO:mi.default,flag_NP:fi.default,flag_NR:hi.default,flag_NU:pi.default,flag_NZ:Ci.default,flag_OM:Ei.default,flag_PA:ki.default,flag_PE:gi.default,flag_PF:ui.default,flag_PG:zi.default,flag_PH:yi.default,flag_PK:wi.default,flag_PL:vi.default,flag_PM:bi.default,flag_PN:xi.default,flag_PR:Mi.default,flag_PS:Li.default,flag_PT:Ri.default,flag_PW:Si.default,flag_PY:Ai.default,flag_QA:Fi.default,flag_RE:Bi.default,flag_RO:Ti.default,flag_RS:Gi.default,flag_RU:ji.default,flag_RW:Di.default,flag_SA:Ni.default,flag_SB:Pi.default,flag_SC:Vi.default,flag_SD:Ii.default,flag_SE:Ui.default,flag_SG:Hi.default,flag_SH:Ki.default,flag_SI:qi.default,flag_SJ:Oi.default,flag_SK:_i.default,flag_SL:Zi.default,flag_SM:Ji.default,flag_SN:Wi.default,flag_SO:Yi.default,flag_SR:Qi.default,flag_SS:Xi.default,flag_ST:$i.default,flag_SV:al.default,flag_SX:tl.default,flag_SY:il.default,flag_SZ:ll.default,flag_TC:el.default,flag_TD:ol.default,flag_TF:cl.default,flag_TG:rl.default,flag_TH:sl.default,flag_TJ:nl.default,flag_TK:dl.default,flag_TL:ml.default,flag_TM:fl.default,flag_TN:hl.default,flag_TO:pl.default,flag_TR:Cl.default,flag_TT:El.default,flag_TV:kl.default,flag_TW:gl.default,flag_TZ:ul.default,flag_UA:zl.default,flag_UG:yl.default,flag_UM:wl.default,flag_US:vl.default,flag_UY:bl.default,flag_UZ:xl.default,flag_VA:Ml.default,flag_VC:Ll.default,flag_VE:Rl.default,flag_VG:Sl.default,flag_VI:Al.default,flag_VN:Fl.default,flag_VU:Bl.default,flag_WF:Tl.default,flag_XK:Gl.default,flag_WS:jl.default,flag_YE:Dl.default,flag_YT:Nl.default,flag_ZA:Pl.default,flag_ZM:Vl.default,flag_ZW:Il.default}},function(t,i){t.exports=a},function(a,t,i){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var l=Object.assign||function(a){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var l in i)Object.prototype.hasOwnProperty.call(i,l)&&(a[l]=i[l])}return a},e=r(i(258)),o=r(i(257)),c=i(2);function r(a){return a&&a.__esModule?a:{default:a}}t.default=function(a){var t=a.code,i=a.fallback,r=void 0===i?null:i,s=function(a,t){var i={};for(var l in a)t.indexOf(l)>=0||Object.prototype.hasOwnProperty.call(a,l)&&(i[l]=a[l]);return i}(a,["code","fallback"]),n=(0,c.getAlphaTwoCode)(t);return n?e.default.createElement("img",l({},s,{src:o.default["flag_"+n]})):r}}])});

/***/ },
/* 2965 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.2.0
	 * react.production.min.js
	 *
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var m=__webpack_require__(25),n=__webpack_require__(300),p=__webpack_require__(67),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
	function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
	function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
	function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
	f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
	function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
	var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
	d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
	isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ },
/* 2966 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(163);


/***/ },
/* 2967 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(1323);
	
	/*<replacement>*/
	var util = __webpack_require__(222);
	util.inherits = __webpack_require__(98);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 2968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(375).Buffer;
	/*</replacement>*/
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();

/***/ },
/* 2969 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(528).PassThrough


/***/ },
/* 2970 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(528).Transform


/***/ },
/* 2971 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(527);


/***/ },
/* 2972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTickValuesFixedDomain = exports.getTickValues = exports.getNiceTickValues = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @fileOverview calculate tick values of scale
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @author xile611, arcthur
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * @date 2015-09-17
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */
	
	var _utils = __webpack_require__(1326);
	
	var _arithmetic = __webpack_require__(2974);
	
	var _arithmetic2 = _interopRequireDefault(_arithmetic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Calculate a interval of a minimum value and a maximum value
	 *
	 * @param  {Number} min       The minimum value
	 * @param  {Number} max       The maximum value
	 * @return {Array} An interval
	 */
	function getValidInterval(_ref) {
	  var _ref2 = _slicedToArray(_ref, 2),
	      min = _ref2[0],
	      max = _ref2[1];
	
	  var validMin = min,
	      validMax = max;
	
	  // exchange
	
	  if (min > max) {
	    validMin = max;
	    validMax = min;
	  }
	
	  return [validMin, validMax];
	}
	
	/**
	 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
	 *
	 * @param  {Number}  roughStep        The rough step calculated by deviding the
	 * difference by the tickCount
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Integer} correctionFactor A correction factor
	 * @return {Number}  The step which is easy to understand between two ticks
	 */
	function getFormatStep(roughStep, allowDecimals, correctionFactor) {
	  if (roughStep <= 0) {
	    return 0;
	  }
	
	  var digitCount = _arithmetic2.default.getDigitCount(roughStep);
	  // The ratio between the rough step and the smallest number which has a bigger
	  // order of magnitudes than the rough step
	  var stepRatio = roughStep / Math.pow(10, digitCount);
	  // When an integer and a float multiplied, the accuracy of result may be wrong
	  var amendStepRatio = digitCount !== 1 ? _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.05) + correctionFactor, 0.05) : _arithmetic2.default.multiply(Math.ceil(stepRatio / 0.1) + correctionFactor, 0.1);
	
	  var formatStep = _arithmetic2.default.multiply(amendStepRatio, Math.pow(10, digitCount));
	
	  return allowDecimals ? formatStep : Math.ceil(formatStep);
	}
	
	/**
	 * calculate the ticks when the minimum value equals to the maximum value
	 *
	 * @param  {Number}  value         The minimum valuue which is also the maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}                 ticks
	 */
	function getTickOfSingleValue(value, tickCount, allowDecimals) {
	  var isFlt = _arithmetic2.default.isFloat(value);
	  var step = 1;
	  // calculate the middle value of ticks
	  var middle = value;
	
	  if (isFlt && allowDecimals) {
	    var absVal = Math.abs(value);
	
	    if (absVal < 1) {
	      // The step should be a float number when the difference is smaller than 1
	      step = Math.pow(10, _arithmetic2.default.getDigitCount(value) - 1);
	
	      middle = _arithmetic2.default.multiply(Math.floor(value / step), step);
	    } else if (absVal > 1) {
	      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
	      middle = Math.floor(value);
	    }
	  } else if (value === 0) {
	    middle = Math.floor((tickCount - 1) / 2);
	  } else if (!allowDecimals) {
	    middle = Math.floor(value);
	  }
	
	  var middleIndex = Math.floor((tickCount - 1) / 2);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(n - middleIndex, step));
	  }), _utils.range);
	
	  return fn(0, tickCount);
	}
	
	/**
	 * Calculate the step
	 *
	 * @param  {Number}  min              The minimum value of an interval
	 * @param  {Number}  max              The maximum value of an interval
	 * @param  {Integer} tickCount        The count of ticks
	 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
	 * @param  {Number}  correctionFactor A correction factor
	 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
	 */
	function calculateStep(min, max, tickCount, allowDecimals) {
	  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	
	  // The step which is easy to understand between two ticks
	  var step = getFormatStep((max - min) / (tickCount - 1), allowDecimals, correctionFactor);
	
	  // A medial value of ticks
	  var middle = void 0;
	
	  // When 0 is inside the interval, 0 should be a tick
	  if (min <= 0 && max >= 0) {
	    middle = 0;
	  } else {
	    // calculate the middle value
	    middle = _arithmetic2.default.divide(_arithmetic2.default.sum(min, max), 2);
	    // minus modulo value
	    middle = _arithmetic2.default.minus(middle, _arithmetic2.default.modulo(middle, step));
	    // strip
	    middle = _arithmetic2.default.strip(middle, 16);
	  }
	
	  var belowCount = Math.ceil((middle - min) / step);
	  var upCount = Math.ceil((max - middle) / step);
	  var scaleCount = belowCount + upCount + 1;
	
	  if (scaleCount > tickCount) {
	    // When more ticks need to cover the interval, step should be bigger.
	    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
	  } else if (scaleCount < tickCount) {
	    // When less ticks can cover the interval, we should add some additional ticks
	    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
	    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
	  }
	
	  return {
	    step: step,
	    tickMin: _arithmetic2.default.minus(middle, _arithmetic2.default.multiply(belowCount, step)),
	    tickMax: _arithmetic2.default.sum(middle, _arithmetic2.default.multiply(upCount, step))
	  };
	}
	/**
	 * Calculate the ticks of an interval
	 *
	 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
	 * @param  {Integer} tickCount     The count of ticks
	 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
	 * @return {Array}   ticks
	 */
	function getNiceTickValuesFn(_ref3) {
	  var _ref4 = _slicedToArray(_ref3, 2),
	      min = _ref4[0],
	      max = _ref4[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval = getValidInterval([min, max]),
	      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
	      cormin = _getValidInterval2[0],
	      cormax = _getValidInterval2[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  // Get the step between two ticks
	
	  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
	      step = _calculateStep.step,
	      tickMin = _calculateStep.tickMin,
	      tickMax = _calculateStep.tickMax;
	
	  var values = _arithmetic2.default.rangeStep(tickMin, tickMax + 0.1 * step, step);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFn(_ref5) {
	  var _ref6 = _slicedToArray(_ref5, 2),
	      min = _ref6[0],
	      max = _ref6[1];
	
	  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var count = Math.max(tickCount, 2);
	
	  var _getValidInterval3 = getValidInterval([min, max]),
	      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
	      cormin = _getValidInterval4[0],
	      cormax = _getValidInterval4[1];
	
	  if (cormin === cormax) {
	    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
	  }
	
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	
	  var fn = (0, _utils.compose)((0, _utils.map)(function (n) {
	    return cormin + n * step;
	  }), _utils.range);
	
	  var values = fn(0, count).filter(function (entry) {
	    return entry >= cormin && entry <= cormax;
	  });
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	function getTickValuesFixedDomainFn(_ref7, tickCount) {
	  var _ref8 = _slicedToArray(_ref7, 2),
	      min = _ref8[0],
	      max = _ref8[1];
	
	  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  // More than two ticks should be return
	  var _getValidInterval5 = getValidInterval([min, max]),
	      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
	      cormin = _getValidInterval6[0],
	      cormax = _getValidInterval6[1];
	
	  if (cormin === cormax) {
	    return [cormin];
	  }
	
	  var count = Math.max(tickCount, 2);
	  var step = getFormatStep((cormax - cormin) / (count - 1), allowDecimals, 0);
	  var values = [].concat(_toConsumableArray(_arithmetic2.default.rangeStep(cormin, cormax - 0.99 * step, step)), [cormax]);
	
	  return min > max ? (0, _utils.reverse)(values) : values;
	}
	
	var getNiceTickValues = exports.getNiceTickValues = (0, _utils.memoize)(getNiceTickValuesFn);
	var getTickValues = exports.getTickValues = (0, _utils.memoize)(getTickValuesFn);
	var getTickValuesFixedDomain = exports.getTickValuesFixedDomain = (0, _utils.memoize)(getTickValuesFixedDomainFn);

/***/ },
/* 2973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getNiceTickValues = __webpack_require__(2972);
	
	Object.defineProperty(exports, 'getTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValues;
	  }
	});
	Object.defineProperty(exports, 'getNiceTickValues', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getNiceTickValues;
	  }
	});
	Object.defineProperty(exports, 'getTickValuesFixedDomain', {
	  enumerable: true,
	  get: function get() {
	    return _getNiceTickValues.getTickValuesFixedDomain;
	  }
	});

/***/ },
/* 2974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _utils = __webpack_require__(1326);
	
	/**
	 * 把错误的数据转正
	 * strip(0.09999999999999998)=0.1
	 * @param {Number} num       输入值
	 * @param {Number} precision 精度
	 * @return {Number} 数值
	 */
	function strip(num) {
	  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
	
	  return +parseFloat(num.toPrecision(precision));
	}
	
	/**
	 * 判断数据是否为浮点类型
	 *
	 * @param {Number} num 输入值
	 * @return {Boolean} 是否是浮点类型
	 */
	/**
	 * @fileOverview 一些公用的运算方法
	 * @author xile611
	 * @date 2015-09-17
	 */
	function isFloat(num) {
	  return (/^([+-]?)\d*\.\d+$/.test(num)
	  );
	}
	
	/**
	 * 获取数值的位数
	 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
	 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
	 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
	 *
	 * @param  {Number} value 数值
	 * @return {Integer} 位数
	 */
	function getDigitCount(value) {
	  var abs = Math.abs(value);
	  var result = void 0;
	
	  if (value === 0) {
	    result = 1;
	  } else {
	    result = Math.floor(Math.log(abs) / Math.log(10)) + 1;
	  }
	
	  return result;
	}
	/**
	 * 计算数值的小数点后的位数
	 * @param  {Number} a 数值，可能为整数，也可能为浮点数
	 * @return {Integer}   位数
	 */
	function getDecimalDigitCount(a) {
	  var str = a ? '' + a : '';
	
	  // scientific notation
	  if (str.indexOf('e') >= 0) {
	    return Math.abs(parseInt(str.slice(str.indexOf('e') + 1), 10));
	  }
	  var ary = str.split('.');
	
	  return ary.length > 1 ? ary[1].length : 0;
	}
	/**
	 * 乘法运算，解决了js运算的精度问题
	 * @param  {Number} a 被乘数
	 * @param  {Number} b 乘数
	 * @return {Number}   积
	 */
	function multiply(a, b) {
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	  var count = getDecimalDigitCount(a) + getDecimalDigitCount(b);
	
	  return intA * intB / Math.pow(10, count);
	}
	/**
	 * 加法运算，解决了js运算的精度问题
	 * @param  {Number} a 被加数
	 * @param  {Number} b 加数
	 * @return {Number}   和
	 */
	function sum(a, b) {
	  var count = Math.max(getDecimalDigitCount(a), getDecimalDigitCount(b));
	
	  count = Math.pow(10, count);
	  return (multiply(a, count) + multiply(b, count)) / count;
	}
	/**
	 * 减法运算，解决了js运算的精度问题
	 * @param  {Number} a 被减数
	 * @param  {Number} b 减数
	 * @return {Number}   差
	 */
	function minus(a, b) {
	  return sum(a, -b);
	}
	/**
	 * 除法运算，解决了js运算的精度问题
	 * @param  {Number} a 被除数
	 * @param  {Number} b 除数
	 * @return {Number}   结果
	 */
	function divide(a, b) {
	  var ca = getDecimalDigitCount(a);
	  var cb = getDecimalDigitCount(b);
	  var intA = parseInt(('' + a).replace('.', ''), 10);
	  var intB = parseInt(('' + b).replace('.', ''), 10);
	
	  return intA / intB * Math.pow(10, cb - ca);
	}
	
	function modulo(a, b) {
	  var mod = Math.abs(b);
	
	  if (b <= 0) {
	    return a;
	  }
	
	  var cnt = Math.floor(a / mod);
	
	  return minus(a, multiply(mod, cnt));
	}
	
	/**
	 * 按照固定的步长获取[start, end)这个区间的数据
	 * 并且需要处理js计算精度的问题
	 *
	 * @param  {Number} start 起点
	 * @param  {Number} end   终点，不包含该值
	 * @param  {Number} step  步长
	 * @return {Array}        若干数值
	 */
	function rangeStep(start, end, step) {
	  var num = start;
	  var result = [];
	
	  while (num < end) {
	    result.push(num);
	
	    num = sum(num, step);
	  }
	
	  return result;
	}
	/**
	 * 对数值进行线性插值
	 *
	 * @param  {Number} a  定义域的极点
	 * @param  {Number} b  定义域的极点
	 * @param  {Number} t  [0, 1]内的某个值
	 * @return {Number}    定义域内的某个值
	 */
	var interpolateNumber = (0, _utils.curry)(function (a, b, t) {
	  var newA = +a;
	  var newB = +b;
	
	  return newA + t * (newB - newA);
	});
	/**
	 * 线性插值的逆运算
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
	 */
	var uninterpolateNumber = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return (x - a) / diff;
	});
	/**
	 * 线性插值的逆运算，并且有截断的操作
	 *
	 * @param  {Number} a 定义域的极点
	 * @param  {Number} b 定义域的极点
	 * @param  {Number} x 可以认为是插值后的一个输出值
	 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
	 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
	 */
	var uninterpolateTruncation = (0, _utils.curry)(function (a, b, x) {
	  var diff = b - +a;
	
	  diff = diff || Infinity;
	
	  return Math.max(0, Math.min(1, (x - a) / diff));
	});
	
	exports.default = {
	  rangeStep: rangeStep,
	  isFloat: isFloat,
	  getDigitCount: getDigitCount,
	  getDecimalDigitCount: getDecimalDigitCount,
	
	  sum: sum,
	  minus: minus,
	  multiply: multiply,
	  divide: divide,
	  modulo: modulo,
	  strip: strip,
	
	  interpolateNumber: interpolateNumber,
	  uninterpolateNumber: uninterpolateNumber,
	  uninterpolateTruncation: uninterpolateTruncation
	};

/***/ },
/* 2975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Cartesian Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CartesianGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(CartesianGrid, _Component);
	
	  function CartesianGrid() {
	    _classCallCheck(this, CartesianGrid);
	
	    return _possibleConstructorReturn(this, (CartesianGrid.__proto__ || Object.getPrototypeOf(CartesianGrid)).apply(this, arguments));
	  }
	
	  _createClass(CartesianGrid, [{
	    key: 'renderLineItem',
	    value: function renderLineItem(option, props) {
	      var lineItem = void 0;
	
	      if (_react2.default.isValidElement(option)) {
	        lineItem = _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        lineItem = option(props);
	      } else {
	        var x1 = props.x1,
	            y1 = props.y1,
	            x2 = props.x2,
	            y2 = props.y2,
	            key = props.key,
	            others = _objectWithoutProperties(props, ['x1', 'y1', 'x2', 'y2', 'key']);
	
	        lineItem = _react2.default.createElement('line', _extends({}, (0, _ReactUtils.getPresentationAttributes)(others), {
	          x1: x1,
	          y1: y1,
	          x2: x2,
	          y2: y2,
	          fill: 'none',
	          key: key
	        }));
	      }
	
	      return lineItem;
	    }
	
	    /**
	     * Draw the horizontal grid lines
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal lines
	     */
	
	  }, {
	    key: 'renderHorizontal',
	    value: function renderHorizontal(horizontalPoints) {
	      var _this2 = this;
	
	      var _props = this.props,
	          x = _props.x,
	          width = _props.width,
	          horizontal = _props.horizontal;
	
	
	      if (!horizontalPoints || !horizontalPoints.length) {
	        return null;
	      }
	
	      var items = horizontalPoints.map(function (entry, i) {
	        var props = _extends({}, _this2.props, {
	          x1: x,
	          y1: entry,
	          x2: x + width,
	          y2: entry,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this2.renderLineItem(horizontal, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-horizontal' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid lines
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical lines
	     */
	
	  }, {
	    key: 'renderVertical',
	    value: function renderVertical(verticalPoints) {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          y = _props2.y,
	          height = _props2.height,
	          vertical = _props2.vertical;
	
	
	      if (!verticalPoints || !verticalPoints.length) {
	        return null;
	      }
	
	      var items = verticalPoints.map(function (entry, i) {
	        var props = _extends({}, _this3.props, {
	          x1: entry,
	          y1: y,
	          x2: entry,
	          y2: y + height,
	          key: 'line-' + i,
	          index: i
	        });
	
	        return _this3.renderLineItem(vertical, props);
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid-vertical' },
	        items
	      );
	    }
	
	    /**
	     * Draw vertical grid stripes filled by colors
	     * @param {Array} verticalPoints either passed in as props or generated from function
	     * @return {Group} Vertical stripes
	     */
	
	  }, {
	    key: 'renderVerticalStripes',
	    value: function renderVerticalStripes(verticalPoints) {
	      var verticalFill = this.props.verticalFill;
	
	      if (!verticalFill || !verticalFill.length) {
	        return null;
	      }
	
	      var _props3 = this.props,
	          fillOpacity = _props3.fillOpacity,
	          x = _props3.x,
	          y = _props3.y,
	          width = _props3.width,
	          height = _props3.height;
	
	      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
	        return a - b > 0;
	      });
	
	      if (x !== verticalPointsUpdated[0]) {
	        verticalPointsUpdated.unshift(0);
	      }
	
	      var items = verticalPointsUpdated.map(function (entry, i) {
	        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
	        if (lineWidth <= 0) {
	          return null;
	        }
	        var colorIndex = i % verticalFill.length;
	        return _react2.default.createElement('rect', {
	          key: 'react-' + i,
	          x: Math.round(entry + x - x),
	          y: y,
	          width: lineWidth,
	          height: height,
	          stroke: 'none',
	          fill: verticalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: 'recharts-cartesian-grid-bg'
	        });
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-gridstripes-vertical' },
	        items
	      );
	    }
	
	    /**
	     * Draw horizontal grid stripes filled by colors
	     * @param {Array} horizontalPoints either passed in as props or generated from function
	     * @return {Group} Horizontal stripes
	     */
	
	  }, {
	    key: 'renderHorizontalStripes',
	    value: function renderHorizontalStripes(horizontalPoints) {
	      var horizontalFill = this.props.horizontalFill;
	
	      if (!horizontalFill || !horizontalFill.length) {
	        return null;
	      }
	
	      var _props4 = this.props,
	          fillOpacity = _props4.fillOpacity,
	          x = _props4.x,
	          y = _props4.y,
	          width = _props4.width,
	          height = _props4.height;
	
	      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
	        return a - b > 0;
	      });
	      if (y !== horizontalPointsUpdated[0]) {
	        horizontalPointsUpdated.unshift(0);
	      }
	
	      var items = horizontalPointsUpdated.map(function (entry, i) {
	        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
	        if (lineHeight <= 0) {
	          return null;
	        }
	        var colorIndex = i % horizontalFill.length;
	        return _react2.default.createElement('rect', {
	          key: 'react-' + i,
	          y: Math.round(entry + y - y),
	          x: x,
	          height: lineHeight,
	          width: width,
	          stroke: 'none',
	          fill: horizontalFill[colorIndex],
	          fillOpacity: fillOpacity,
	          className: 'recharts-cartesian-grid-bg'
	        });
	      });
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-gridstripes-horizontal' },
	        items
	      );
	    }
	  }, {
	    key: 'renderBackground',
	    value: function renderBackground() {
	      var fill = this.props.fill;
	
	
	      if (!fill || fill === 'none') {
	        return null;
	      }
	
	      var _props5 = this.props,
	          fillOpacity = _props5.fillOpacity,
	          x = _props5.x,
	          y = _props5.y,
	          width = _props5.width,
	          height = _props5.height;
	
	
	      return _react2.default.createElement('rect', {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        stroke: 'none',
	        fill: fill,
	        fillOpacity: fillOpacity,
	        className: 'recharts-cartesian-grid-bg'
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props6 = this.props,
	          x = _props6.x,
	          y = _props6.y,
	          width = _props6.width,
	          height = _props6.height,
	          horizontal = _props6.horizontal,
	          vertical = _props6.vertical,
	          horizontalCoordinatesGenerator = _props6.horizontalCoordinatesGenerator,
	          verticalCoordinatesGenerator = _props6.verticalCoordinatesGenerator,
	          xAxis = _props6.xAxis,
	          yAxis = _props6.yAxis,
	          offset = _props6.offset,
	          chartWidth = _props6.chartWidth,
	          chartHeight = _props6.chartHeight;
	
	
	      if (!(0, _DataUtils.isNumber)(width) || width <= 0 || !(0, _DataUtils.isNumber)(height) || height <= 0 || !(0, _DataUtils.isNumber)(x) || x !== +x || !(0, _DataUtils.isNumber)(y) || y !== +y) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          horizontalPoints = _props7.horizontalPoints,
	          verticalPoints = _props7.verticalPoints;
	
	      // No horizontal points are specified
	
	      if ((!horizontalPoints || !horizontalPoints.length) && (0, _isFunction3.default)(horizontalCoordinatesGenerator)) {
	        horizontalPoints = horizontalCoordinatesGenerator({ yAxis: yAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      // No vertical points are specified
	      if ((!verticalPoints || !verticalPoints.length) && (0, _isFunction3.default)(verticalCoordinatesGenerator)) {
	        verticalPoints = verticalCoordinatesGenerator({ xAxis: xAxis, width: chartWidth,
	          height: chartHeight, offset: offset });
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-cartesian-grid' },
	        this.renderBackground(),
	        horizontal && this.renderHorizontal(horizontalPoints),
	        vertical && this.renderVertical(verticalPoints),
	        horizontal && this.renderHorizontalStripes(horizontalPoints),
	        vertical && this.renderVerticalStripes(verticalPoints)
	      );
	    }
	  }]);
	
	  return CartesianGrid;
	}(_react.Component), _class2.displayName = 'CartesianGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  x: _propTypes2.default.number,
	  y: _propTypes2.default.number,
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  horizontal: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  vertical: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.bool]),
	  horizontalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  verticalPoints: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  horizontalCoordinatesGenerator: _propTypes2.default.func,
	  verticalCoordinatesGenerator: _propTypes2.default.func,
	  xAxis: _propTypes2.default.object,
	  yAxis: _propTypes2.default.object,
	  offset: _propTypes2.default.object,
	  chartWidth: _propTypes2.default.number,
	  chartHeight: _propTypes2.default.number,
	  verticalFill: _propTypes2.default.arrayOf(_propTypes2.default.string),
	  horizontalFill: _propTypes2.default.arrayOf(_propTypes2.default.string)
	}), _class2.defaultProps = {
	  horizontal: true,
	  vertical: true,
	  // The ordinates of horizontal grid lines
	  horizontalPoints: [],
	  // The abscissas of vertical grid lines
	  verticalPoints: [],
	
	  stroke: '#ccc',
	  fill: 'none',
	  // The fill of colors of grid lines
	  verticalFill: [],
	  horizontalFill: []
	}, _temp)) || _class;
	
	exports.default = CartesianGrid;

/***/ },
/* 2976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(529);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _XAxis = __webpack_require__(204);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(205);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'AreaChart',
	  GraphicalChild: _Area2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Area Chart
	     */

/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Bar = __webpack_require__(530);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _XAxis = __webpack_require__(204);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(205);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'BarChart',
	  GraphicalChild: _Bar2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Bar Chart
	     */

/***/ },
/* 2978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Area = __webpack_require__(529);
	
	var _Area2 = _interopRequireDefault(_Area);
	
	var _Bar = __webpack_require__(530);
	
	var _Bar2 = _interopRequireDefault(_Bar);
	
	var _Line = __webpack_require__(531);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _Scatter = __webpack_require__(532);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(204);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(205);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(356);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'ComposedChart',
	  GraphicalChild: [_Line2.default, _Area2.default, _Bar2.default, _Scatter2.default],
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }, { axisType: 'zAxis', AxisComp: _ZAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Composed Chart
	     */

/***/ },
/* 2979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Line = __webpack_require__(531);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _XAxis = __webpack_require__(204);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(205);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'LineChart',
	  GraphicalChild: _Line2.default,
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	}); /**
	     * @fileOverview Line Chart
	     */

/***/ },
/* 2980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _PolarAngleAxis = __webpack_require__(358);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(359);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _Pie = __webpack_require__(1332);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Pie Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'PieChart',
	  GraphicalChild: _Pie2.default,
	  eventType: 'item',
	  legendContent: 'children',
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['centric']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ },
/* 2981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Radar = __webpack_require__(1333);
	
	var _Radar2 = _interopRequireDefault(_Radar);
	
	var _PolarAngleAxis = __webpack_require__(358);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(359);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'RadarChart',
	  GraphicalChild: _Radar2.default,
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'centric',
	    startAngle: 90,
	    endAngle: -270,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['centric']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ },
/* 2982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _PolarAngleAxis = __webpack_require__(358);
	
	var _PolarAngleAxis2 = _interopRequireDefault(_PolarAngleAxis);
	
	var _PolarRadiusAxis = __webpack_require__(359);
	
	var _PolarRadiusAxis2 = _interopRequireDefault(_PolarRadiusAxis);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _RadialBar = __webpack_require__(1334);
	
	var _RadialBar2 = _interopRequireDefault(_RadialBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Radar Bar Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'RadialBarChart',
	  GraphicalChild: _RadialBar2.default,
	  legendContent: 'children',
	  axisComponents: [{ axisType: 'angleAxis', AxisComp: _PolarAngleAxis2.default }, { axisType: 'radiusAxis', AxisComp: _PolarRadiusAxis2.default }],
	  formatAxisMap: _PolarUtils.formatAxisMap,
	  defaultProps: {
	    layout: 'radial',
	    startAngle: 0,
	    endAngle: 360,
	    cx: '50%',
	    cy: '50%',
	    innerRadius: 0,
	    outerRadius: '80%'
	  },
	  propTypes: {
	    layout: _propTypes2.default.oneOf(['radial']),
	    startAngle: _propTypes2.default.number,
	    endAngle: _propTypes2.default.number,
	    cx: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    cy: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    innerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
	    outerRadius: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	  }
	});

/***/ },
/* 2983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _sumBy2 = __webpack_require__(2449);
	
	var _sumBy3 = _interopRequireDefault(_sumBy2);
	
	var _min2 = __webpack_require__(1007);
	
	var _min3 = _interopRequireDefault(_min2);
	
	var _maxBy2 = __webpack_require__(1006);
	
	var _maxBy3 = _interopRequireDefault(_maxBy2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @file TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(259);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Tooltip = __webpack_require__(357);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _Rectangle = __webpack_require__(207);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultCoordinateOfTooltip = { x: 0, y: 0 };
	
	var interpolationGenerator = function interpolationGenerator(a, b) {
	  var ka = +a;
	  var kb = b - ka;
	  return function (t) {
	    return ka + kb * t;
	  };
	};
	var centerY = function centerY(node) {
	  return node.y + node.dy / 2;
	};
	var getValue = function getValue(entry) {
	  return entry && entry.value || 0;
	};
	var getSumOfIds = function getSumOfIds(links, ids) {
	  return ids.reduce(function (result, id) {
	    return result + getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var sourceNode = tree[link.source];
	
	    return result + centerY(sourceNode) * getValue(links[id]);
	  }, 0);
	};
	var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
	  return ids.reduce(function (result, id) {
	    var link = links[id];
	    var targetNode = tree[link.target];
	
	    return result + centerY(targetNode) * getValue(links[id]);
	  }, 0);
	};
	var ascendingY = function ascendingY(a, b) {
	  return a.y - b.y;
	};
	
	var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
	  var sourceNodes = [];
	  var sourceLinks = [];
	  var targetNodes = [];
	  var targetLinks = [];
	
	  for (var i = 0, len = links.length; i < len; i++) {
	    var link = links[i];
	
	    if (link.source === id) {
	      targetNodes.push(link.target);
	      targetLinks.push(i);
	    }
	
	    if (link.target === id) {
	      sourceNodes.push(link.source);
	      sourceLinks.push(i);
	    }
	  }
	
	  return { sourceNodes: sourceNodes, sourceLinks: sourceLinks, targetLinks: targetLinks, targetNodes: targetNodes };
	};
	
	var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
	  var targetNodes = curNode.targetNodes;
	
	  for (var i = 0, len = targetNodes.length; i < len; i++) {
	    var target = tree[targetNodes[i]];
	
	    if (target) {
	      target.depth = Math.max(curNode.depth + 1, target.depth);
	
	      updateDepthOfTargets(tree, target);
	    }
	  }
	};
	
	var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
	  var nodes = _ref.nodes,
	      links = _ref.links;
	
	  var tree = nodes.map(function (entry, index) {
	    var result = searchTargetsAndSources(links, index);
	
	    return _extends({}, entry, result, {
	      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
	      depth: 0
	    });
	  });
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!node.sourceNodes.length) {
	      updateDepthOfTargets(tree, node);
	    }
	  }
	  var maxDepth = (0, _maxBy3.default)(tree, function (entry) {
	    return entry.depth;
	  }).depth;
	
	  if (maxDepth >= 1) {
	    var childWidth = (width - nodeWidth) / maxDepth;
	    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
	      var _node = tree[_i];
	
	      if (!_node.targetNodes.length) {
	        _node.depth = maxDepth;
	      }
	      _node.x = _node.depth * childWidth;
	      _node.dx = nodeWidth;
	    }
	  }
	
	  return { tree: tree, maxDepth: maxDepth };
	};
	
	var getDepthTree = function getDepthTree(tree) {
	  var result = [];
	
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	
	    if (!result[node.depth]) {
	      result[node.depth] = [];
	    }
	
	    result[node.depth].push(node);
	  }
	
	  return result;
	};
	
	var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
	  var yRatio = (0, _min3.default)(depthTree.map(function (nodes) {
	    return (height - (nodes.length - 1) * nodePadding) / (0, _sumBy3.default)(nodes, getValue);
	  }));
	
	  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
	    for (var i = 0, len = depthTree[d].length; i < len; i++) {
	      var node = depthTree[d][i];
	
	      node.y = i;
	      node.dy = node.value * yRatio;
	    }
	  }
	
	  return links.map(function (link) {
	    return _extends({}, link, { dy: getValue(link) * yRatio });
	  });
	};
	
	var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
	  for (var i = 0, len = depthTree.length; i < len; i++) {
	    var nodes = depthTree[i];
	    var n = nodes.length;
	
	    // Sort by the value of y
	    nodes.sort(ascendingY);
	
	    var y0 = 0;
	    for (var j = 0; j < n; j++) {
	      var node = nodes[j];
	      var dy = y0 - node.y;
	
	      if (dy > 0) {
	        node.y += dy;
	      }
	
	      y0 = node.y + node.dy + nodePadding;
	    }
	
	    y0 = height + nodePadding;
	    for (var _j = n - 1; _j >= 0; _j--) {
	      var _node2 = nodes[_j];
	      var _dy = _node2.y + _node2.dy + nodePadding - y0;
	
	      if (_dy > 0) {
	        _node2.y -= _dy;
	        y0 = _node2.y;
	      } else {
	        break;
	      }
	    }
	  }
	};
	
	var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
	  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.sourceLinks.length) {
	        var sourceSum = getSumOfIds(links, node.sourceLinks);
	        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
	        var y = weightedSum / sourceSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
	  for (var i = depthTree.length - 1; i >= 0; i--) {
	    var nodes = depthTree[i];
	
	    for (var j = 0, len = nodes.length; j < len; j++) {
	      var node = nodes[j];
	
	      if (node.targetLinks.length) {
	        var targetSum = getSumOfIds(links, node.targetLinks);
	        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
	        var y = weightedSum / targetSum;
	
	        node.y += (y - centerY(node)) * alpha;
	      }
	    }
	  }
	};
	var updateYOfLinks = function updateYOfLinks(tree, links) {
	  for (var i = 0, len = tree.length; i < len; i++) {
	    var node = tree[i];
	    var sy = 0;
	    var ty = 0;
	
	    node.targetLinks.sort(function (a, b) {
	      return tree[links[a].target].y - tree[links[b].target].y;
	    });
	    node.sourceLinks.sort(function (a, b) {
	      return tree[links[a].source].y - tree[links[b].source].y;
	    });
	
	    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
	      var link = links[node.targetLinks[j]];
	
	      if (link) {
	        link.sy = sy;
	        sy += link.dy;
	      }
	    }
	
	    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
	      var _link = links[node.sourceLinks[_j2]];
	
	      if (_link) {
	        _link.ty = ty;
	        ty += _link.dy;
	      }
	    }
	  }
	};
	
	var computeData = function computeData(_ref2) {
	  var data = _ref2.data,
	      width = _ref2.width,
	      height = _ref2.height,
	      iterations = _ref2.iterations,
	      nodeWidth = _ref2.nodeWidth,
	      nodePadding = _ref2.nodePadding;
	  var links = data.links;
	
	  var _getNodesTree = getNodesTree(data, width, nodeWidth),
	      tree = _getNodesTree.tree;
	
	  var depthTree = getDepthTree(tree);
	  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
	
	  resolveCollisions(depthTree, height, nodePadding);
	
	  var alpha = 1;
	  for (var i = 1; i <= iterations; i++) {
	    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
	
	    resolveCollisions(depthTree, height, nodePadding);
	
	    relaxLeftToRight(tree, depthTree, newLinks, alpha);
	
	    resolveCollisions(depthTree, height, nodePadding);
	  }
	
	  updateYOfLinks(tree, newLinks);
	
	  return { nodes: tree, links: newLinks };
	};
	
	var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
	  if (type === 'node') {
	    return { x: el.x + el.width / 2, y: el.y + el.height / 2 };
	  }
	
	  return {
	    x: (el.sourceX + el.targetX) / 2,
	    y: (el.sourceY + el.targetY) / 2
	  };
	};
	
	var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
	  var payload = el.payload;
	
	  if (type === 'node') {
	    return [{
	      payload: el,
	      name: (0, _ChartUtils.getValueByDataKey)(payload, nameKey, ''),
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	  if (payload.source && payload.target) {
	    var sourceName = (0, _ChartUtils.getValueByDataKey)(payload.source, nameKey, '');
	    var targetName = (0, _ChartUtils.getValueByDataKey)(payload.target, nameKey, '');
	
	    return [{
	      payload: el,
	      name: sourceName + ' - ' + targetName,
	      value: (0, _ChartUtils.getValueByDataKey)(payload, 'value')
	    }];
	  }
	
	  return [];
	};
	
	var Sankey = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(Sankey, _Component);
	
	  function Sankey(props) {
	    _classCallCheck(this, Sankey);
	
	    var _this = _possibleConstructorReturn(this, (Sankey.__proto__ || Object.getPrototypeOf(Sankey)).call(this, props));
	
	    _this.state = _this.createDefaultState(props);
	    return _this;
	  }
	
	  _createClass(Sankey, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _props = this.props,
	          data = _props.data,
	          width = _props.width,
	          height = _props.height,
	          margin = _props.margin,
	          iterations = _props.iterations,
	          nodeWidth = _props.nodeWidth,
	          nodePadding = _props.nodePadding,
	          nameKey = _props.nameKey;
	
	      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !(0, _PureRender.shallowEqual)(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
	        this.setState(this.createDefaultState(nextProps));
	      }
	    }
	    /**
	     * Returns default, reset state for the sankey chart.
	     * @param  {Object} props The latest props
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState(props) {
	      var data = props.data,
	          width = props.width,
	          height = props.height,
	          margin = props.margin,
	          iterations = props.iterations,
	          nodeWidth = props.nodeWidth,
	          nodePadding = props.nodePadding;
	
	      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
	      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);
	
	      var _computeData = computeData({
	        data: data,
	        width: contentWidth,
	        height: contentHeight,
	        iterations: iterations, nodeWidth: nodeWidth, nodePadding: nodePadding
	      }),
	          links = _computeData.links,
	          nodes = _computeData.nodes;
	
	      return {
	        activeElement: null,
	        activeElementType: null,
	        isTooltipActive: false,
	        nodes: nodes, links: links
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(el, type, e) {
	      var _props2 = this.props,
	          onMouseEnter = _props2.onMouseEnter,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          activeElement: el,
	          activeElementType: type,
	          isTooltipActive: true
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(el, type, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(el, type, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(el, type, e) {
	      var _props3 = this.props,
	          onMouseLeave = _props3.onMouseLeave,
	          children = _props3.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(el, type, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(el, type, e);
	      }
	    }
	  }, {
	    key: 'renderLinkItem',
	    value: function renderLinkItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      var sourceX = props.sourceX,
	          sourceY = props.sourceY,
	          sourceControlX = props.sourceControlX,
	          targetX = props.targetX,
	          targetY = props.targetY,
	          targetControlX = props.targetControlX,
	          linkWidth = props.linkWidth,
	          others = _objectWithoutProperties(props, ['sourceX', 'sourceY', 'sourceControlX', 'targetX', 'targetY', 'targetControlX', 'linkWidth']);
	
	      return _react2.default.createElement('path', _extends({
	        className: 'recharts-sankey-link',
	        d: '\n          M' + sourceX + ',' + sourceY + '\n          C' + sourceControlX + ',' + sourceY + ' ' + targetControlX + ',' + targetY + ' ' + targetX + ',' + targetY + '\n        ',
	        fill: 'none',
	        stroke: '#333',
	        strokeWidth: linkWidth,
	        strokeOpacity: '0.2'
	      }, (0, _ReactUtils.getPresentationAttributes)(others)));
	    }
	  }, {
	    key: 'renderLinks',
	    value: function renderLinks(links, nodes) {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          linkCurvature = _props4.linkCurvature,
	          linkContent = _props4.link,
	          margin = _props4.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-links', key: 'recharts-sankey-links' },
	        links.map(function (link, i) {
	          var sourceRelativeY = link.sy,
	              targetRelativeY = link.ty,
	              linkWidth = link.dy;
	
	          var source = nodes[link.source];
	          var target = nodes[link.target];
	          var sourceX = source.x + source.dx + left;
	          var targetX = target.x + left;
	          var interpolationFunc = interpolationGenerator(sourceX, targetX);
	          var sourceControlX = interpolationFunc(linkCurvature);
	          var targetControlX = interpolationFunc(1 - linkCurvature);
	          var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
	          var targetY = target.y + targetRelativeY + linkWidth / 2 + top;
	
	          var linkProps = _extends({
	            sourceX: sourceX, targetX: targetX,
	            sourceY: sourceY, targetY: targetY,
	            sourceControlX: sourceControlX, targetControlX: targetControlX,
	            sourceRelativeY: sourceRelativeY, targetRelativeY: targetRelativeY,
	            linkWidth: linkWidth,
	            index: i,
	            payload: _extends({}, link, { source: source, target: target })
	          }, (0, _ReactUtils.getPresentationAttributes)(linkContent));
	          var events = {
	            onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
	            onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'link' + i }, events),
	            _this2.renderLinkItem(linkContent, linkProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderNodeItem',
	    value: function renderNodeItem(option, props) {
	      if (_react2.default.isValidElement(option)) {
	        return _react2.default.cloneElement(option, props);
	      } else if ((0, _isFunction3.default)(option)) {
	        return option(props);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        className: 'recharts-sankey-node',
	        fill: '#0088fe',
	        fillOpacity: '0.8'
	      }, props));
	    }
	  }, {
	    key: 'renderNodes',
	    value: function renderNodes(nodes) {
	      var _this3 = this;
	
	      var _props5 = this.props,
	          nodeContent = _props5.node,
	          margin = _props5.margin;
	
	      var top = margin.top || 0;
	      var left = margin.left || 0;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { className: 'recharts-sankey-nodes', key: 'recharts-sankey-nodes' },
	        nodes.map(function (node, i) {
	          var x = node.x,
	              y = node.y,
	              dx = node.dx,
	              dy = node.dy;
	
	          var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(nodeContent), {
	            x: x + left,
	            y: y + top,
	            width: dx,
	            height: dy,
	            index: i,
	            payload: node
	          });
	          var events = {
	            onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
	            onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node')
	          };
	
	          return _react2.default.createElement(
	            _Layer2.default,
	            _extends({ key: 'node' + i }, events),
	            _this3.renderNodeItem(nodeContent, nodeProps)
	          );
	        })
	      );
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props6 = this.props,
	          children = _props6.children,
	          width = _props6.width,
	          height = _props6.height,
	          nameKey = _props6.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeElement = _state.activeElement,
	          activeElementType = _state.activeElementType;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
	      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var _state2 = this.state,
	          links = _state2.links,
	          nodes = _state2.nodes;
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          (0, _ReactUtils.filterSvgElements)(children),
	          this.renderLinks(links, nodes),
	          this.renderNodes(nodes)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Sankey;
	}(_react.Component), _class2.displayName = 'Sankey', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, _ReactUtils.EVENT_ATTRIBUTES, {
	
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.shape({
	    nodes: _propTypes2.default.array,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      target: _propTypes2.default.number,
	      source: _propTypes2.default.number,
	      value: _propTypes2.default.number
	    }))
	  }),
	
	  nodePadding: _propTypes2.default.number,
	  nodeWidth: _propTypes2.default.number,
	  linkCurvature: _propTypes2.default.number,
	  iterations: _propTypes2.default.number,
	
	  node: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	  link: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.element, _propTypes2.default.func]),
	
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	  margin: _propTypes2.default.shape({
	    top: _propTypes2.default.number,
	    right: _propTypes2.default.number,
	    bottom: _propTypes2.default.number,
	    left: _propTypes2.default.number
	  })
	}), _class2.defaultProps = {
	  nodePadding: 10,
	  nodeWidth: 10,
	  nameKey: 'name',
	  dataKey: 'value',
	  linkCurvature: 0.5,
	  iterations: 32,
	  margin: { top: 5, right: 5, bottom: 5, left: 5 }
	}, _temp)) || _class;
	
	exports.default = Sankey;

/***/ },
/* 2984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _generateCategoricalChart = __webpack_require__(136);
	
	var _generateCategoricalChart2 = _interopRequireDefault(_generateCategoricalChart);
	
	var _Scatter = __webpack_require__(532);
	
	var _Scatter2 = _interopRequireDefault(_Scatter);
	
	var _XAxis = __webpack_require__(204);
	
	var _XAxis2 = _interopRequireDefault(_XAxis);
	
	var _YAxis = __webpack_require__(205);
	
	var _YAxis2 = _interopRequireDefault(_YAxis);
	
	var _ZAxis = __webpack_require__(356);
	
	var _ZAxis2 = _interopRequireDefault(_ZAxis);
	
	var _CartesianUtils = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @fileOverview Scatter Chart
	 */
	exports.default = (0, _generateCategoricalChart2.default)({
	  chartName: 'ScatterChart',
	  GraphicalChild: _Scatter2.default,
	  eventType: 'single',
	  axisComponents: [{ axisType: 'xAxis', AxisComp: _XAxis2.default }, { axisType: 'yAxis', AxisComp: _YAxis2.default }, { axisType: 'zAxis', AxisComp: _ZAxis2.default }],
	  formatAxisMap: _CartesianUtils.formatAxisMap
	});

/***/ },
/* 2985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isFunction2 = __webpack_require__(24);
	
	var _isFunction3 = _interopRequireDefault(_isFunction2);
	
	var _isNaN2 = __webpack_require__(319);
	
	var _isNaN3 = _interopRequireDefault(_isNaN2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * @fileOverview TreemapChart
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSmooth = __webpack_require__(103);
	
	var _reactSmooth2 = _interopRequireDefault(_reactSmooth);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Surface = __webpack_require__(259);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Layer = __webpack_require__(46);
	
	var _Layer2 = _interopRequireDefault(_Layer);
	
	var _Rectangle = __webpack_require__(207);
	
	var _Rectangle2 = _interopRequireDefault(_Rectangle);
	
	var _ReactUtils = __webpack_require__(20);
	
	var _Tooltip = __webpack_require__(357);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _ChartUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var computeNode = function computeNode(_ref) {
	  var depth = _ref.depth,
	      node = _ref.node,
	      index = _ref.index,
	      valueKey = _ref.valueKey;
	  var children = node.children;
	
	  var childDepth = depth + 1;
	  var computedChildren = children && children.length ? children.map(function (child, i) {
	    return computeNode({ depth: childDepth, node: child, index: i, valueKey: valueKey });
	  }) : null;
	  var value = void 0;
	
	  if (children && children.length) {
	    value = computedChildren.reduce(function (result, child) {
	      return result + child.value;
	    }, 0);
	  } else {
	    value = (0, _isNaN3.default)(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
	  }
	
	  return _extends({}, node, {
	    children: computedChildren,
	    value: value, depth: depth, index: index
	  });
	};
	
	var filterRect = function filterRect(node) {
	  return { x: node.x, y: node.y, width: node.width, height: node.height };
	};
	
	// Compute the area for each child based on value & scale.
	var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
	  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
	
	  return children.map(function (child) {
	    var area = child.value * ratio;
	
	    return _extends({}, child, {
	      area: (0, _isNaN3.default)(area) || area <= 0 ? 0 : area
	    });
	  });
	};
	
	// Computes the score for the specified row, as the worst aspect ratio.
	var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
	  var parentArea = parentSize * parentSize;
	  var rowArea = row.area * row.area;
	
	  var _row$reduce = row.reduce(function (result, child) {
	    return {
	      min: Math.min(result.min, child.area),
	      max: Math.max(result.max, child.area)
	    };
	  }, { min: Infinity, max: 0 }),
	      min = _row$reduce.min,
	      max = _row$reduce.max;
	
	  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
	};
	
	var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
	  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowHeight > parentRect.height) {
	    rowHeight = parentRect.height;
	  }
	
	  var curX = parentRect.x;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = curX;
	    child.y = parentRect.y;
	    child.height = rowHeight;
	    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
	    curX += child.width;
	  }
	  // what's z
	  child.z = true;
	  // add the remain x to the last one of row
	  child.width += parentRect.x + parentRect.width - curX;
	
	  return _extends({}, parentRect, {
	    y: parentRect.y + rowHeight,
	    height: parentRect.height - rowHeight
	  });
	};
	
	var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
	  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;
	
	  if (isFlush || rowWidth > parentRect.width) {
	    rowWidth = parentRect.width;
	  }
	
	  var curY = parentRect.y;
	  var child = void 0;
	  for (var i = 0, len = row.length; i < len; i++) {
	    child = row[i];
	    child.x = parentRect.x;
	    child.y = curY;
	    child.width = rowWidth;
	    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
	    curY += child.height;
	  }
	  child.z = false;
	  child.height += parentRect.y + parentRect.height - curY;
	
	  return _extends({}, parentRect, {
	    x: parentRect.x + rowWidth,
	    width: parentRect.width - rowWidth
	  });
	};
	
	var position = function position(row, parentSize, parentRect, isFlush) {
	  if (parentSize === parentRect.width) {
	    return horizontalPosition(row, parentSize, parentRect, isFlush);
	  }
	
	  return verticalPosition(row, parentSize, parentRect, isFlush);
	};
	
	// Recursively arranges the specified node's children into squarified rows.
	var squarify = function squarify(node, aspectRatio) {
	  var children = node.children;
	
	  if (children && children.length) {
	    var rect = filterRect(node);
	    var row = [];
	    var best = Infinity; // the best row score so far
	    var child = void 0,
	        score = void 0; // the current row score
	    var size = Math.min(rect.width, rect.height); // initial orientation
	    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
	    var tempChildren = scaleChildren.slice();
	
	    row.area = 0;
	
	    while (tempChildren.length > 0) {
	      // row first
	      row.push(child = tempChildren[0]);
	      row.area += child.area;
	
	      score = getWorstScore(row, size, aspectRatio);
	      if (score <= best) {
	        // continue with this orientation
	        tempChildren.shift();
	        best = score;
	      } else {
	        // abort, and try a different orientation
	        row.area -= row.pop().area;
	        rect = position(row, size, rect, false);
	        size = Math.min(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	    }
	
	    if (row.length) {
	      rect = position(row, size, rect, true);
	      row.length = row.area = 0;
	    }
	
	    return _extends({}, node, { children: scaleChildren.map(function (c) {
	        return squarify(c, aspectRatio);
	      }) });
	  }
	
	  return node;
	};
	
	var Treemap = (0, _PureRender2.default)(_class = (_temp2 = _class2 = function (_Component) {
	  _inherits(Treemap, _Component);
	
	  function Treemap() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Treemap);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Treemap.__proto__ || Object.getPrototypeOf(Treemap)).call.apply(_ref2, [this].concat(args))), _this), _this.state = _this.createDefaultState(), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Treemap, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data !== this.props.data) {
	        this.setState(this.createDefaultState());
	      }
	    }
	    /**
	     * Returns default, reset state for the treemap chart.
	     * @return {Object} Whole new state
	     */
	
	  }, {
	    key: 'createDefaultState',
	    value: function createDefaultState() {
	      return {
	        isTooltipActive: false,
	        activeNode: null
	      };
	    }
	  }, {
	    key: 'handleMouseEnter',
	    value: function handleMouseEnter(node, e) {
	      var _props = this.props,
	          onMouseEnter = _props.onMouseEnter,
	          children = _props.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: true,
	          activeNode: node
	        }, function () {
	          if (onMouseEnter) {
	            onMouseEnter(node, e);
	          }
	        });
	      } else if (onMouseEnter) {
	        onMouseEnter(node, e);
	      }
	    }
	  }, {
	    key: 'handleMouseLeave',
	    value: function handleMouseLeave(node, e) {
	      var _props2 = this.props,
	          onMouseLeave = _props2.onMouseLeave,
	          children = _props2.children;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (tooltipItem) {
	        this.setState({
	          isTooltipActive: false,
	          activeNode: null
	        }, function () {
	          if (onMouseLeave) {
	            onMouseLeave(node, e);
	          }
	        });
	      } else if (onMouseLeave) {
	        onMouseLeave(node, e);
	      }
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(node) {
	      var onClick = this.props.onClick;
	
	
	      if (onClick) {
	        onClick(node);
	      }
	    }
	  }, {
	    key: 'renderAnimatedItem',
	    value: function renderAnimatedItem(content, nodeProps, isLeaf) {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          isAnimationActive = _props3.isAnimationActive,
	          animationBegin = _props3.animationBegin,
	          animationDuration = _props3.animationDuration,
	          animationEasing = _props3.animationEasing,
	          isUpdateAnimationActive = _props3.isUpdateAnimationActive;
	      var width = nodeProps.width,
	          height = nodeProps.height,
	          x = nodeProps.x,
	          y = nodeProps.y;
	
	      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
	      var event = {};
	
	      if (isLeaf) {
	        event = {
	          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
	          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
	          onClick: this.handleClick.bind(this, nodeProps)
	        };
	      }
	
	      return _react2.default.createElement(
	        _reactSmooth2.default,
	        {
	          from: { x: x, y: y, width: width, height: height },
	          to: { x: x, y: y, width: width, height: height },
	          duration: animationDuration,
	          easing: animationEasing,
	          isActive: isUpdateAnimationActive
	        },
	        function (_ref3) {
	          var currX = _ref3.x,
	              currY = _ref3.y,
	              currWidth = _ref3.width,
	              currHeight = _ref3.height;
	          return _react2.default.createElement(
	            _reactSmooth2.default,
	            {
	              from: 'translate(' + translateX + 'px, ' + translateX + 'px)',
	              to: 'translate(0, 0)',
	              attributeName: 'transform',
	              begin: animationBegin,
	              easing: animationEasing,
	              isActive: isAnimationActive,
	              duration: animationDuration
	            },
	            _react2.default.createElement(
	              _Layer2.default,
	              event,
	              _this2.renderContentItem(content, _extends({}, nodeProps, {
	                isAnimationActive: isAnimationActive,
	                isUpdateAnimationActive: !isUpdateAnimationActive,
	                width: currWidth,
	                height: currHeight,
	                x: currX,
	                y: currY
	              }))
	            )
	          );
	        }
	      );
	    }
	  }, {
	    key: 'renderContentItem',
	    value: function renderContentItem(content, nodeProps) {
	      if (_react2.default.isValidElement(content)) {
	        return _react2.default.cloneElement(content, nodeProps);
	      } else if ((0, _isFunction3.default)(content)) {
	        return content(nodeProps);
	      }
	
	      return _react2.default.createElement(_Rectangle2.default, _extends({
	        fill: '#fff',
	        stroke: '#000'
	      }, nodeProps));
	    }
	  }, {
	    key: 'renderNode',
	    value: function renderNode(root, node, i) {
	      var _this3 = this;
	
	      var content = this.props.content;
	
	      var nodeProps = _extends({}, (0, _ReactUtils.getPresentationAttributes)(this.props), node, { root: root });
	      var isLeaf = !node.children || !node.children.length;
	
	      return _react2.default.createElement(
	        _Layer2.default,
	        { key: 'recharts-treemap-node-' + i, className: 'recharts-treemap-depth-' + node.depth },
	        this.renderAnimatedItem(content, nodeProps, isLeaf),
	        node.children && node.children.length ? node.children.map(function (child, index) {
	          return _this3.renderNode(node, child, index);
	        }) : null
	      );
	    }
	  }, {
	    key: 'renderAllNodes',
	    value: function renderAllNodes() {
	      var _props4 = this.props,
	          width = _props4.width,
	          height = _props4.height,
	          data = _props4.data,
	          dataKey = _props4.dataKey,
	          aspectRatio = _props4.aspectRatio;
	
	
	      var root = computeNode({
	        depth: 0,
	        node: { children: data, x: 0, y: 0, width: width, height: height },
	        index: 0,
	        valueKey: dataKey
	      });
	
	      var formatRoot = squarify(root, aspectRatio);
	
	      return this.renderNode(formatRoot, formatRoot, 0);
	    }
	  }, {
	    key: 'renderTooltip',
	    value: function renderTooltip() {
	      var _props5 = this.props,
	          children = _props5.children,
	          nameKey = _props5.nameKey;
	
	      var tooltipItem = (0, _ReactUtils.findChildByType)(children, _Tooltip2.default);
	
	      if (!tooltipItem) {
	        return null;
	      }
	
	      var _props6 = this.props,
	          width = _props6.width,
	          height = _props6.height,
	          dataKey = _props6.dataKey;
	      var _state = this.state,
	          isTooltipActive = _state.isTooltipActive,
	          activeNode = _state.activeNode;
	
	      var viewBox = { x: 0, y: 0, width: width, height: height };
	      var coordinate = activeNode ? {
	        x: activeNode.x + activeNode.width / 2,
	        y: activeNode.y + activeNode.height / 2
	      } : null;
	      var payload = isTooltipActive && activeNode ? [{
	        payload: activeNode,
	        name: (0, _ChartUtils.getValueByDataKey)(activeNode, nameKey, ''),
	        value: (0, _ChartUtils.getValueByDataKey)(activeNode, dataKey)
	      }] : [];
	
	      return _react2.default.cloneElement(tooltipItem, {
	        viewBox: viewBox,
	        active: isTooltipActive,
	        coordinate: coordinate,
	        label: '',
	        payload: payload
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!(0, _ReactUtils.validateWidthHeight)(this)) {
	        return null;
	      }
	
	      var _props7 = this.props,
	          width = _props7.width,
	          height = _props7.height,
	          className = _props7.className,
	          style = _props7.style,
	          children = _props7.children,
	          others = _objectWithoutProperties(_props7, ['width', 'height', 'className', 'style', 'children']);
	
	      var attrs = (0, _ReactUtils.getPresentationAttributes)(others);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('recharts-wrapper', className),
	          style: _extends({}, style, { position: 'relative', cursor: 'default', width: width, height: height })
	        },
	        _react2.default.createElement(
	          _Surface2.default,
	          _extends({}, attrs, { width: width, height: height }),
	          this.renderAllNodes(),
	          (0, _ReactUtils.filterSvgElements)(children)
	        ),
	        this.renderTooltip()
	      );
	    }
	  }]);
	
	  return Treemap;
	}(_react.Component), _class2.displayName = 'Treemap', _class2.propTypes = {
	  width: _propTypes2.default.number,
	  height: _propTypes2.default.number,
	  data: _propTypes2.default.array,
	  style: _propTypes2.default.object,
	  aspectRatio: _propTypes2.default.number,
	  content: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func]),
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  nameKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  dataKey: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.func]),
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	
	  isAnimationActive: _propTypes2.default.bool,
	  isUpdateAnimationActive: _propTypes2.default.bool,
	  animationBegin: _propTypes2.default.number,
	  animationDuration: _propTypes2.default.number,
	  animationEasing: _propTypes2.default.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
	}, _class2.defaultProps = {
	  dataKey: 'value',
	  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
	  isAnimationActive: !(0, _ReactUtils.isSsr)(),
	  isUpdateAnimationActive: !(0, _ReactUtils.isSsr)(),
	  animationBegin: 0,
	  animationDuration: 1500,
	  animationEasing: 'linear'
	}, _temp2)) || _class;
	
	exports.default = Treemap;

/***/ },
/* 2986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Legend Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _Surface = __webpack_require__(259);
	
	var _Surface2 = _interopRequireDefault(_Surface);
	
	var _Symbols = __webpack_require__(535);
	
	var _Symbols2 = _interopRequireDefault(_Symbols);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SIZE = 32;
	var ICON_TYPES = _ReactUtils.LEGEND_TYPES.filter(function (type) {
	  return type !== 'none';
	});
	
	var DefaultLegendContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultLegendContent, _Component);
	
	  function DefaultLegendContent() {
	    _classCallCheck(this, DefaultLegendContent);
	
	    return _possibleConstructorReturn(this, (DefaultLegendContent.__proto__ || Object.getPrototypeOf(DefaultLegendContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultLegendContent, [{
	    key: 'renderIcon',
	
	
	    /**
	     * Render the path of icon
	     * @param {Object} data Data of each legend item
	     * @return {String} Path element
	     */
	    value: function renderIcon(data) {
	      var inactiveColor = this.props.inactiveColor;
	
	      var halfSize = SIZE / 2;
	      var sixthSize = SIZE / 6;
	      var thirdSize = SIZE / 3;
	      var color = data.inactive ? inactiveColor : data.color;
	
	      if (data.type === 'plainline') {
	        return _react2.default.createElement('line', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          strokeDasharray: data.payload.strokeDasharray,
	          x1: 0,
	          y1: halfSize,
	          x2: SIZE,
	          y2: halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'line') {
	        return _react2.default.createElement('path', {
	          strokeWidth: 4,
	          fill: 'none',
	          stroke: color,
	          d: 'M0,' + halfSize + 'h' + thirdSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + 2 * thirdSize + ',' + halfSize + '\n            H' + SIZE + 'M' + 2 * thirdSize + ',' + halfSize + '\n            A' + sixthSize + ',' + sixthSize + ',0,1,1,' + thirdSize + ',' + halfSize,
	          className: 'recharts-legend-icon'
	        });
	      } else if (data.type === 'rect') {
	        return _react2.default.createElement('path', {
	          stroke: 'none',
	          fill: color,
	          d: 'M0,' + SIZE / 8 + 'h' + SIZE + 'v' + SIZE * 3 / 4 + 'h' + -SIZE + 'z',
	          className: 'recharts-legend-icon'
	        });
	      }
	
	      return _react2.default.createElement(_Symbols2.default, {
	        fill: color,
	        cx: halfSize,
	        cy: halfSize,
	        size: SIZE,
	        sizeType: 'diameter',
	        type: data.type
	      });
	    }
	
	    /**
	     * Draw items of legend
	     * @return {ReactElement} Items
	     */
	
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var _this2 = this;
	
	      var _props = this.props,
	          payload = _props.payload,
	          iconSize = _props.iconSize,
	          layout = _props.layout,
	          formatter = _props.formatter;
	
	      var viewBox = { x: 0, y: 0, width: SIZE, height: SIZE };
	      var itemStyle = {
	        display: layout === 'horizontal' ? 'inline-block' : 'block',
	        marginRight: 10
	      };
	      var svgStyle = { display: 'inline-block', verticalAlign: 'middle', marginRight: 4 };
	
	      return payload.map(function (entry, i) {
	        var _classNames;
	
	        var finalFormatter = entry.formatter || formatter;
	        var className = (0, _classnames2.default)((_classNames = {
	          'recharts-legend-item': true
	        }, _defineProperty(_classNames, 'legend-item-' + i, true), _defineProperty(_classNames, 'inactive', entry.inactive), _classNames));
	
	        if (entry.type === 'none') {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          'li',
	          _extends({
	            className: className,
	            style: itemStyle,
	            key: 'legend-item-' + i
	          }, (0, _ReactUtils.filterEventsOfChild)(_this2.props, entry, i)),
	          _react2.default.createElement(
	            _Surface2.default,
	            { width: iconSize, height: iconSize, viewBox: viewBox, style: svgStyle },
	            _this2.renderIcon(entry)
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'recharts-legend-item-text' },
	            finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value
	          )
	        );
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          payload = _props2.payload,
	          layout = _props2.layout,
	          align = _props2.align;
	
	
	      if (!payload || !payload.length) {
	        return null;
	      }
	
	      var finalStyle = {
	        padding: 0,
	        margin: 0,
	        textAlign: layout === 'horizontal' ? align : 'left'
	      };
	
	      return _react2.default.createElement(
	        'ul',
	        { className: 'recharts-default-legend', style: finalStyle },
	        this.renderItems()
	      );
	    }
	  }]);
	
	  return DefaultLegendContent;
	}(_react.Component), _class2.displayName = 'Legend', _class2.propTypes = {
	  content: _propTypes2.default.element,
	  iconSize: _propTypes2.default.number,
	  iconType: _propTypes2.default.oneOf(ICON_TYPES),
	  layout: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  align: _propTypes2.default.oneOf(['center', 'left', 'right']),
	  verticalAlign: _propTypes2.default.oneOf(['top', 'bottom', 'middle']),
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.any,
	    id: _propTypes2.default.any,
	    type: _propTypes2.default.oneOf(_ReactUtils.LEGEND_TYPES)
	  })),
	  inactiveColor: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  onMouseEnter: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onClick: _propTypes2.default.func
	}, _class2.defaultProps = {
	  iconSize: 14,
	  layout: 'horizontal',
	  align: 'center',
	  verticalAlign: 'middle',
	  inactiveColor: '#ccc'
	}, _temp)) || _class;
	
	exports.default = DefaultLegendContent;

/***/ },
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isArray2 = __webpack_require__(36);
	
	var _isArray3 = _interopRequireDefault(_isArray2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Default Tooltip Content
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _DataUtils = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultFormatter = function defaultFormatter(value) {
	  return (0, _isArray3.default)(value) && (0, _DataUtils.isNumOrStr)(value[0]) && (0, _DataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
	};
	
	var DefaultTooltipContent = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(DefaultTooltipContent, _Component);
	
	  function DefaultTooltipContent() {
	    _classCallCheck(this, DefaultTooltipContent);
	
	    return _possibleConstructorReturn(this, (DefaultTooltipContent.__proto__ || Object.getPrototypeOf(DefaultTooltipContent)).apply(this, arguments));
	  }
	
	  _createClass(DefaultTooltipContent, [{
	    key: 'renderContent',
	    value: function renderContent() {
	      var _props = this.props,
	          payload = _props.payload,
	          separator = _props.separator,
	          formatter = _props.formatter,
	          itemStyle = _props.itemStyle,
	          itemSorter = _props.itemSorter;
	
	
	      if (payload && payload.length) {
	        var listStyle = { padding: 0, margin: 0 };
	
	        var items = payload.sort(itemSorter).map(function (entry, i) {
	          var finalItemStyle = _extends({
	            display: 'block',
	            paddingTop: 4,
	            paddingBottom: 4,
	            color: entry.color || '#000'
	          }, itemStyle);
	          var hasName = (0, _DataUtils.isNumOrStr)(entry.name);
	          var finalFormatter = entry.formatter || formatter || defaultFormatter;
	
	          return _react2.default.createElement(
	            'li',
	            { className: 'recharts-tooltip-item', key: 'tooltip-item-' + i, style: finalItemStyle },
	            hasName ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-name' },
	              entry.name
	            ) : null,
	            hasName ? _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-separator' },
	              separator
	            ) : null,
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-value' },
	              finalFormatter ? finalFormatter(entry.value, entry.name, entry, i) : entry.value
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'recharts-tooltip-item-unit' },
	              entry.unit || ''
	            )
	          );
	        });
	
	        return _react2.default.createElement(
	          'ul',
	          { className: 'recharts-tooltip-item-list', style: listStyle },
	          items
	        );
	      }
	
	      return null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          labelStyle = _props2.labelStyle,
	          label = _props2.label,
	          labelFormatter = _props2.labelFormatter;
	
	      var finalStyle = {
	        margin: 0,
	        padding: 10,
	        backgroundColor: '#fff',
	        border: '1px solid #ccc',
	        whiteSpace: 'nowrap'
	      };
	      var finalLabelStyle = _extends({
	        margin: 0
	      }, labelStyle);
	      var hasLabel = (0, _DataUtils.isNumOrStr)(label);
	      var finalLabel = hasLabel ? label : '';
	
	      if (hasLabel && labelFormatter) {
	        finalLabel = labelFormatter(label);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'recharts-default-tooltip', style: finalStyle },
	        _react2.default.createElement(
	          'p',
	          { className: 'recharts-tooltip-label', style: finalLabelStyle },
	          finalLabel
	        ),
	        this.renderContent()
	      );
	    }
	  }]);
	
	  return DefaultTooltipContent;
	}(_react.Component), _class2.displayName = 'DefaultTooltipContent', _class2.propTypes = {
	  separator: _propTypes2.default.string,
	  formatter: _propTypes2.default.func,
	  itemStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  labelFormatter: _propTypes2.default.func,
	  label: _propTypes2.default.any,
	  payload: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.any,
	    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.array]),
	    unit: _propTypes2.default.any
	  })),
	  itemSorter: _propTypes2.default.func
	}, _class2.defaultProps = {
	  separator: ' : ',
	  itemStyle: {},
	  labelStyle: {}
	}, _temp)) || _class;
	
	exports.default = DefaultTooltipContent;

/***/ },
/* 2988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _debounce2 = __webpack_require__(1002);
	
	var _debounce3 = _interopRequireDefault(_debounce2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
	                    */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactResizeDetector = __webpack_require__(2833);
	
	var _reactResizeDetector2 = _interopRequireDefault(_reactResizeDetector);
	
	var _DataUtils = __webpack_require__(39);
	
	var _LogUtils = __webpack_require__(1336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ResponsiveContainer = (_temp = _class = function (_Component) {
	  _inherits(ResponsiveContainer, _Component);
	
	  function ResponsiveContainer(props) {
	    _classCallCheck(this, ResponsiveContainer);
	
	    var _this = _possibleConstructorReturn(this, (ResponsiveContainer.__proto__ || Object.getPrototypeOf(ResponsiveContainer)).call(this, props));
	
	    _this.updateDimensionsImmediate = function () {
	      if (!_this.mounted) {
	        return;
	      }
	
	      var newSize = _this.getContainerSize();
	
	      if (newSize) {
	        var _this$state = _this.state,
	            oldWidth = _this$state.containerWidth,
	            oldHeight = _this$state.containerHeight;
	        var containerWidth = newSize.containerWidth,
	            containerHeight = newSize.containerHeight;
	
	
	        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
	          _this.setState({ containerWidth: containerWidth, containerHeight: containerHeight });
	        }
	      }
	    };
	
	    _this.state = {
	      containerWidth: -1,
	      containerHeight: -1
	    };
	
	    _this.handleResize = props.debounce > 0 ? (0, _debounce3.default)(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
	    return _this;
	  }
	
	  /* eslint-disable  react/no-did-mount-set-state */
	
	
	  _createClass(ResponsiveContainer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.mounted = true;
	
	      var size = this.getContainerSize();
	
	      if (size) {
	        this.setState(size);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mounted = false;
	    }
	  }, {
	    key: 'getContainerSize',
	    value: function getContainerSize() {
	      if (!this.container) {
	        return null;
	      }
	
	      return {
	        containerWidth: this.container.clientWidth,
	        containerHeight: this.container.clientHeight
	      };
	    }
	  }, {
	    key: 'renderChart',
	    value: function renderChart() {
	      var _state = this.state,
	          containerWidth = _state.containerWidth,
	          containerHeight = _state.containerHeight;
	
	
	      if (containerWidth < 0 || containerHeight < 0) {
	        return null;
	      }
	
	      var _props = this.props,
	          aspect = _props.aspect,
	          width = _props.width,
	          height = _props.height,
	          minWidth = _props.minWidth,
	          minHeight = _props.minHeight,
	          maxHeight = _props.maxHeight,
	          children = _props.children;
	
	
	      (0, _LogUtils.warn)((0, _DataUtils.isPercent)(width) || (0, _DataUtils.isPercent)(height), 'The width(%s) and height(%s) are both fixed numbers,\n       maybe you don\'t need to use a ResponsiveContainer.', width, height);
	
	      (0, _LogUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
	
	      var calculatedWidth = (0, _DataUtils.isPercent)(width) ? containerWidth : width;
	      var calculatedHeight = (0, _DataUtils.isPercent)(height) ? containerHeight : height;
	
	      if (aspect && aspect > 0) {
	        // Preserve the desired aspect ratio
	        calculatedHeight = calculatedWidth / aspect;
	        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
	        if (maxHeight && calculatedHeight > maxHeight) {
	          calculatedHeight = maxHeight;
	        }
	      }
	
	      (0, _LogUtils.warn)(calculatedWidth > 0 || calculatedHeight > 0, 'The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.', calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
	
	      return _react2.default.cloneElement(children, {
	        width: calculatedWidth,
	        height: calculatedHeight
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          minWidth = _props2.minWidth,
	          minHeight = _props2.minHeight,
	          width = _props2.width,
	          height = _props2.height,
	          maxHeight = _props2.maxHeight,
	          id = _props2.id,
	          className = _props2.className;
	
	      var style = { width: width, height: height, minWidth: minWidth, minHeight: minHeight, maxHeight: maxHeight };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          id: id,
	          className: (0, _classnames2.default)('recharts-responsive-container', className),
	          style: style,
	          ref: function ref(node) {
	            _this2.container = node;
	          }
	        },
	        this.renderChart(),
	        _react2.default.createElement(_reactResizeDetector2.default, { handleWidth: true, handleHeight: true, onResize: this.handleResize })
	      );
	    }
	  }]);
	
	  return ResponsiveContainer;
	}(_react.Component), _class.displayName = 'ResponsiveContainer', _class.propTypes = {
	  aspect: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  minWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  maxHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  children: _propTypes2.default.node.isRequired,
	  debounce: _propTypes2.default.number,
	  id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	}, _class.defaultProps = {
	  width: '100%',
	  height: '100%',
	  debounce: 0
	}, _temp);
	exports.default = ResponsiveContainer;

/***/ },
/* 2989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ComposedChart = exports.RadialBarChart = exports.AreaChart = exports.ScatterChart = exports.RadarChart = exports.Sankey = exports.Treemap = exports.PieChart = exports.BarChart = exports.LineChart = exports.ErrorBar = exports.ZAxis = exports.YAxis = exports.XAxis = exports.Scatter = exports.Bar = exports.Area = exports.Line = exports.CartesianGrid = exports.CartesianAxis = exports.ReferenceArea = exports.ReferenceDot = exports.ReferenceLine = exports.Brush = exports.RadialBar = exports.Radar = exports.Pie = exports.PolarAngleAxis = exports.PolarRadiusAxis = exports.PolarGrid = exports.Symbols = exports.Cross = exports.Dot = exports.Polygon = exports.Rectangle = exports.Curve = exports.Sector = exports.LabelList = exports.Label = exports.Text = exports.Cell = exports.ResponsiveContainer = exports.Tooltip = exports.Legend = exports.Layer = exports.Surface = undefined;
	
	__webpack_require__(2991);
	
	var _Surface2 = __webpack_require__(259);
	
	var _Surface3 = _interopRequireDefault(_Surface2);
	
	var _Layer2 = __webpack_require__(46);
	
	var _Layer3 = _interopRequireDefault(_Layer2);
	
	var _Legend2 = __webpack_require__(533);
	
	var _Legend3 = _interopRequireDefault(_Legend2);
	
	var _Tooltip2 = __webpack_require__(357);
	
	var _Tooltip3 = _interopRequireDefault(_Tooltip2);
	
	var _ResponsiveContainer2 = __webpack_require__(2988);
	
	var _ResponsiveContainer3 = _interopRequireDefault(_ResponsiveContainer2);
	
	var _Cell2 = __webpack_require__(258);
	
	var _Cell3 = _interopRequireDefault(_Cell2);
	
	var _Text2 = __webpack_require__(164);
	
	var _Text3 = _interopRequireDefault(_Text2);
	
	var _Label2 = __webpack_require__(137);
	
	var _Label3 = _interopRequireDefault(_Label2);
	
	var _LabelList2 = __webpack_require__(138);
	
	var _LabelList3 = _interopRequireDefault(_LabelList2);
	
	var _Sector2 = __webpack_require__(360);
	
	var _Sector3 = _interopRequireDefault(_Sector2);
	
	var _Curve2 = __webpack_require__(206);
	
	var _Curve3 = _interopRequireDefault(_Curve2);
	
	var _Rectangle2 = __webpack_require__(207);
	
	var _Rectangle3 = _interopRequireDefault(_Rectangle2);
	
	var _Polygon2 = __webpack_require__(534);
	
	var _Polygon3 = _interopRequireDefault(_Polygon2);
	
	var _Dot2 = __webpack_require__(165);
	
	var _Dot3 = _interopRequireDefault(_Dot2);
	
	var _Cross2 = __webpack_require__(1335);
	
	var _Cross3 = _interopRequireDefault(_Cross2);
	
	var _Symbols2 = __webpack_require__(535);
	
	var _Symbols3 = _interopRequireDefault(_Symbols2);
	
	var _PolarGrid2 = __webpack_require__(2990);
	
	var _PolarGrid3 = _interopRequireDefault(_PolarGrid2);
	
	var _PolarRadiusAxis2 = __webpack_require__(359);
	
	var _PolarRadiusAxis3 = _interopRequireDefault(_PolarRadiusAxis2);
	
	var _PolarAngleAxis2 = __webpack_require__(358);
	
	var _PolarAngleAxis3 = _interopRequireDefault(_PolarAngleAxis2);
	
	var _Pie2 = __webpack_require__(1332);
	
	var _Pie3 = _interopRequireDefault(_Pie2);
	
	var _Radar2 = __webpack_require__(1333);
	
	var _Radar3 = _interopRequireDefault(_Radar2);
	
	var _RadialBar2 = __webpack_require__(1334);
	
	var _RadialBar3 = _interopRequireDefault(_RadialBar2);
	
	var _Brush2 = __webpack_require__(1327);
	
	var _Brush3 = _interopRequireDefault(_Brush2);
	
	var _ReferenceLine2 = __webpack_require__(1331);
	
	var _ReferenceLine3 = _interopRequireDefault(_ReferenceLine2);
	
	var _ReferenceDot2 = __webpack_require__(1330);
	
	var _ReferenceDot3 = _interopRequireDefault(_ReferenceDot2);
	
	var _ReferenceArea2 = __webpack_require__(1329);
	
	var _ReferenceArea3 = _interopRequireDefault(_ReferenceArea2);
	
	var _CartesianAxis2 = __webpack_require__(1328);
	
	var _CartesianAxis3 = _interopRequireDefault(_CartesianAxis2);
	
	var _CartesianGrid2 = __webpack_require__(2975);
	
	var _CartesianGrid3 = _interopRequireDefault(_CartesianGrid2);
	
	var _Line2 = __webpack_require__(531);
	
	var _Line3 = _interopRequireDefault(_Line2);
	
	var _Area2 = __webpack_require__(529);
	
	var _Area3 = _interopRequireDefault(_Area2);
	
	var _Bar2 = __webpack_require__(530);
	
	var _Bar3 = _interopRequireDefault(_Bar2);
	
	var _Scatter2 = __webpack_require__(532);
	
	var _Scatter3 = _interopRequireDefault(_Scatter2);
	
	var _XAxis2 = __webpack_require__(204);
	
	var _XAxis3 = _interopRequireDefault(_XAxis2);
	
	var _YAxis2 = __webpack_require__(205);
	
	var _YAxis3 = _interopRequireDefault(_YAxis2);
	
	var _ZAxis2 = __webpack_require__(356);
	
	var _ZAxis3 = _interopRequireDefault(_ZAxis2);
	
	var _ErrorBar2 = __webpack_require__(257);
	
	var _ErrorBar3 = _interopRequireDefault(_ErrorBar2);
	
	var _LineChart2 = __webpack_require__(2979);
	
	var _LineChart3 = _interopRequireDefault(_LineChart2);
	
	var _BarChart2 = __webpack_require__(2977);
	
	var _BarChart3 = _interopRequireDefault(_BarChart2);
	
	var _PieChart2 = __webpack_require__(2980);
	
	var _PieChart3 = _interopRequireDefault(_PieChart2);
	
	var _Treemap2 = __webpack_require__(2985);
	
	var _Treemap3 = _interopRequireDefault(_Treemap2);
	
	var _Sankey2 = __webpack_require__(2983);
	
	var _Sankey3 = _interopRequireDefault(_Sankey2);
	
	var _RadarChart2 = __webpack_require__(2981);
	
	var _RadarChart3 = _interopRequireDefault(_RadarChart2);
	
	var _ScatterChart2 = __webpack_require__(2984);
	
	var _ScatterChart3 = _interopRequireDefault(_ScatterChart2);
	
	var _AreaChart2 = __webpack_require__(2976);
	
	var _AreaChart3 = _interopRequireDefault(_AreaChart2);
	
	var _RadialBarChart2 = __webpack_require__(2982);
	
	var _RadialBarChart3 = _interopRequireDefault(_RadialBarChart2);
	
	var _ComposedChart2 = __webpack_require__(2978);
	
	var _ComposedChart3 = _interopRequireDefault(_ComposedChart2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Surface = _Surface3.default;
	exports.Layer = _Layer3.default;
	exports.Legend = _Legend3.default;
	exports.Tooltip = _Tooltip3.default;
	exports.ResponsiveContainer = _ResponsiveContainer3.default;
	exports.Cell = _Cell3.default;
	exports.Text = _Text3.default;
	exports.Label = _Label3.default;
	exports.LabelList = _LabelList3.default;
	exports.Sector = _Sector3.default;
	exports.Curve = _Curve3.default;
	exports.Rectangle = _Rectangle3.default;
	exports.Polygon = _Polygon3.default;
	exports.Dot = _Dot3.default;
	exports.Cross = _Cross3.default;
	exports.Symbols = _Symbols3.default;
	exports.PolarGrid = _PolarGrid3.default;
	exports.PolarRadiusAxis = _PolarRadiusAxis3.default;
	exports.PolarAngleAxis = _PolarAngleAxis3.default;
	exports.Pie = _Pie3.default;
	exports.Radar = _Radar3.default;
	exports.RadialBar = _RadialBar3.default;
	exports.Brush = _Brush3.default;
	exports.ReferenceLine = _ReferenceLine3.default;
	exports.ReferenceDot = _ReferenceDot3.default;
	exports.ReferenceArea = _ReferenceArea3.default;
	exports.CartesianAxis = _CartesianAxis3.default;
	exports.CartesianGrid = _CartesianGrid3.default;
	exports.Line = _Line3.default;
	exports.Area = _Area3.default;
	exports.Bar = _Bar3.default;
	exports.Scatter = _Scatter3.default;
	exports.XAxis = _XAxis3.default;
	exports.YAxis = _YAxis3.default;
	exports.ZAxis = _ZAxis3.default;
	exports.ErrorBar = _ErrorBar3.default;
	exports.LineChart = _LineChart3.default;
	exports.BarChart = _BarChart3.default;
	exports.PieChart = _PieChart3.default;
	exports.Treemap = _Treemap3.default;
	exports.Sankey = _Sankey3.default;
	exports.RadarChart = _RadarChart3.default;
	exports.ScatterChart = _ScatterChart3.default;
	exports.AreaChart = _AreaChart3.default;
	exports.RadialBarChart = _RadialBarChart3.default;
	exports.ComposedChart = _ComposedChart3.default;

/***/ },
/* 2990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp; /**
	                             * @fileOverview Polar Grid
	                             */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PureRender = __webpack_require__(22);
	
	var _PureRender2 = _interopRequireDefault(_PureRender);
	
	var _PolarUtils = __webpack_require__(91);
	
	var _ReactUtils = __webpack_require__(20);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PolarGrid = (0, _PureRender2.default)(_class = (_temp = _class2 = function (_Component) {
	  _inherits(PolarGrid, _Component);
	
	  function PolarGrid() {
	    _classCallCheck(this, PolarGrid);
	
	    return _possibleConstructorReturn(this, (PolarGrid.__proto__ || Object.getPrototypeOf(PolarGrid)).apply(this, arguments));
	  }
	
	  _createClass(PolarGrid, [{
	    key: 'getPolygonPath',
	    value: function getPolygonPath(radius) {
	      var _props = this.props,
	          cx = _props.cx,
	          cy = _props.cy,
	          polarAngles = _props.polarAngles;
	
	
	      var path = '';
	
	      polarAngles.forEach(function (angle, i) {
	        var point = (0, _PolarUtils.polarToCartesian)(cx, cy, radius, angle);
	
	        if (i) {
	          path += 'L ' + point.x + ',' + point.y;
	        } else {
	          path += 'M ' + point.x + ',' + point.y;
	        }
	      });
	      path += 'Z';
	
	      return path;
	    }
	    /**
	     * Draw axis of radial line
	     * @return {[type]} The lines
	     */
	
	  }, {
	    key: 'renderPolarAngles',
	    value: function renderPolarAngles() {
	      var _props2 = this.props,
	          cx = _props2.cx,
	          cy = _props2.cy,
	          innerRadius = _props2.innerRadius,
	          outerRadius = _props2.outerRadius,
	          polarAngles = _props2.polarAngles;
	
	
	      if (!polarAngles || !polarAngles.length) {
	        return null;
	      }
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props));
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-angle' },
	        polarAngles.map(function (entry, i) {
	          var start = (0, _PolarUtils.polarToCartesian)(cx, cy, innerRadius, entry);
	          var end = (0, _PolarUtils.polarToCartesian)(cx, cy, outerRadius, entry);
	
	          return _react2.default.createElement('line', _extends({}, props, {
	            key: 'line-' + i,
	            x1: start.x,
	            y1: start.y,
	            x2: end.x,
	            y2: end.y
	          }));
	        })
	      );
	    }
	    /**
	     * Draw concentric circles
	     * @param {Number} radius The radius of circle
	     * @param {Number} index  The index of circle
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} circle
	     */
	
	  }, {
	    key: 'renderConcentricCircle',
	    value: function renderConcentricCircle(radius, index, extraProps) {
	      var _props3 = this.props,
	          cx = _props3.cx,
	          cy = _props3.cy;
	
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('circle', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-circle',
	        key: 'circle-' + index,
	        cx: cx,
	        cy: cy,
	        r: radius
	      }));
	    }
	    /**
	     * Draw concentric polygons
	     * @param {Number} radius     The radius of polygon
	     * @param {Number} index      The index of polygon
	     * @param {Object} extraProps Extra props
	     * @return {ReactElement} polygon
	     */
	
	  }, {
	    key: 'renderConcentricPolygon',
	    value: function renderConcentricPolygon(radius, index, extraProps) {
	      var props = _extends({
	        stroke: '#ccc'
	      }, (0, _ReactUtils.getPresentationAttributes)(this.props), {
	        fill: 'none'
	      }, extraProps);
	
	      return _react2.default.createElement('path', _extends({}, props, {
	        className: 'recharts-polar-grid-concentric-polygon',
	        key: 'path-' + index,
	        d: this.getPolygonPath(radius)
	      }));
	    }
	
	    /**
	     * Draw concentric axis
	     * @return {ReactElement} Concentric axis
	     * @todo Optimize the name
	     */
	
	  }, {
	    key: 'renderConcentricPath',
	    value: function renderConcentricPath() {
	      var _this2 = this;
	
	      var _props4 = this.props,
	          polarRadius = _props4.polarRadius,
	          gridType = _props4.gridType;
	
	
	      if (!polarRadius || !polarRadius.length) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid-concentric' },
	        polarRadius.map(function (entry, i) {
	          return gridType === 'circle' ? _this2.renderConcentricCircle(entry, i) : _this2.renderConcentricPolygon(entry, i);
	        })
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var outerRadius = this.props.outerRadius;
	
	
	      if (outerRadius <= 0) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { className: 'recharts-polar-grid' },
	        this.renderPolarAngles(),
	        this.renderConcentricPath()
	      );
	    }
	  }]);
	
	  return PolarGrid;
	}(_react.Component), _class2.displayName = 'PolarGrid', _class2.propTypes = _extends({}, _ReactUtils.PRESENTATION_ATTRIBUTES, {
	  cx: _propTypes2.default.number,
	  cy: _propTypes2.default.number,
	  innerRadius: _propTypes2.default.number,
	  outerRadius: _propTypes2.default.number,
	
	  polarAngles: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  polarRadius: _propTypes2.default.arrayOf(_propTypes2.default.number),
	  gridType: _propTypes2.default.oneOf(['polygon', 'circle'])
	}), _class2.defaultProps = {
	  cx: 0,
	  cy: 0,
	  innerRadius: 0,
	  outerRadius: 0,
	  gridType: 'polygon'
	}, _temp)) || _class;
	
	exports.default = PolarGrid;

/***/ },
/* 2991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2994);
	
	/* eslint no-proto: 0 */
	var testObject = {};
	
	if (!(Object.setPrototypeOf || testObject.__proto__)) {
	  var nativeGetPrototypeOf = Object.getPrototypeOf;
	
	  Object.getPrototypeOf = function (object) {
	    if (object.__proto__) {
	      return object.__proto__;
	    }
	
	    return nativeGetPrototypeOf.call(Object, object);
	  };
	}

/***/ },
/* 2992 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
	
	var generatePrefixStyle = exports.generatePrefixStyle = function generatePrefixStyle(name, value) {
	  if (!name) {
	    return null;
	  }
	
	  var camelName = name.replace(/(\w)/, function (v) {
	    return v.toUpperCase();
	  });
	  var result = PREFIX_LIST.reduce(function (res, entry) {
	    return _extends({}, res, _defineProperty({}, entry + camelName, value));
	  }, {});
	
	  result[name] = value;
	
	  return result;
	};

/***/ },
/* 2993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SYNC_EVENT = exports.eventCenter = undefined;
	
	var _events = __webpack_require__(298);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var eventCenter = new _events2.default();
	
	if (eventCenter.setMaxListeners) {
	  eventCenter.setMaxListeners(10);
	}
	
	exports.eventCenter = eventCenter;
	var SYNC_EVENT = exports.SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ },
/* 2994 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3007);
	__webpack_require__(3008);
	__webpack_require__(3009);
	__webpack_require__(3010);
	__webpack_require__(3011);
	__webpack_require__(3012);
	__webpack_require__(3013);
	__webpack_require__(3014);
	__webpack_require__(3015);
	__webpack_require__(3016);
	__webpack_require__(3017);
	__webpack_require__(3018);
	__webpack_require__(3019);
	__webpack_require__(3020);
	__webpack_require__(3021);
	__webpack_require__(3022);
	__webpack_require__(3023);
	module.exports = __webpack_require__(537).Math;


/***/ },
/* 2995 */
1772,
/* 2996 */
[3343, 540],
/* 2997 */
[3344, 2995],
/* 2998 */
[3346, 540, 539],
/* 2999 */
145,
/* 3000 */
[3348, 538, 361, 2998],
/* 3001 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(542);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 3002 */
[3349, 2996, 3000, 3005, 538],
/* 3003 */
220,
/* 3004 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(539);
	var hide = __webpack_require__(1337);
	var has = __webpack_require__(2999);
	var SRC = __webpack_require__(3006)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(537).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 3005 */
[3350, 540],
/* 3006 */
284,
/* 3007 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(55);
	var log1p = __webpack_require__(1338);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 3008 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(55);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 3009 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(55);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 3010 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(55);
	var sign = __webpack_require__(542);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 3011 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 3012 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(55);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 3013 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(55);
	var $expm1 = __webpack_require__(541);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 3014 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', { fround: __webpack_require__(3001) });


/***/ },
/* 3015 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(55);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 3016 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(55);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(361)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 3017 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 3018 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(1338) });


/***/ },
/* 3019 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 3020 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', { sign: __webpack_require__(542) });


/***/ },
/* 3021 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(55);
	var expm1 = __webpack_require__(541);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(361)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 3022 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(55);
	var expm1 = __webpack_require__(541);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 3023 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(55);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 3024 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	var balanced = __webpack_require__(3025)
	var reduceFunctionCall = __webpack_require__(3026)
	var mexp = __webpack_require__(2451)
	
	/**
	 * Constantes
	 */
	var MAX_STACK = 100 // should be enough for a single calc()...
	var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g
	
	/**
	 * Global variables
	 */
	var stack
	
	/**
	 * Expose reduceCSSCalc plugin
	 *
	 * @type {Function}
	 */
	module.exports = reduceCSSCalc
	
	/**
	 * Reduce CSS calc() in a string, whenever it's possible
	 *
	 * @param {String} value css input
	 */
	function reduceCSSCalc(value, decimalPrecision) {
	  stack = 0
	  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)
	
	  // Allow calc() on multiple lines
	  value = value.replace(/\n+/g, " ")
	
	  /**
	   * Evaluates an expression
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateExpression (expression, functionIdentifier, call) {
	    if (stack++ > MAX_STACK) {
	      stack = 0
	      throw new Error("Call stack overflow for " + call)
	    }
	
	    if (expression === "") {
	      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
	    }
	
	    expression = evaluateNestedExpression(expression, call)
	
	    var units = getUnitsInExpression(expression)
	
	    // If the expression contains multiple units or CSS variables,
	    // then let the expression be (i.e. browser calc())
	    if (units.length > 1 || expression.indexOf("var(") > -1) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    var unit = units[0] || ""
	
	    if (unit === "%") {
	      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
	      // console.log(expression)
	      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
	        return parseFloat(percent.slice(0, -1)) * 0.01
	      })
	    }
	
	    // Remove units in expression:
	    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
	    var result
	
	    try {
	      result = mexp.eval(toEvaluate)
	    }
	    catch (e) {
	      return functionIdentifier + "(" + expression + ")"
	    }
	
	    // Transform back to a percentage result:
	    if (unit === "%") {
	      result *= 100
	    }
	
	    // adjust rounding shit
	    // (0.1 * 0.2 === 0.020000000000000004)
	    if (functionIdentifier.length || unit === "%") {
	      result = Math.round(result * decimalPrecision) / decimalPrecision
	    }
	
	    // Add unit
	    result += unit
	
	    return result
	  }
	
	  /**
	   * Evaluates nested expressions
	   *
	   * @param {String} expression
	   * @returns {String}
	   */
	  function evaluateNestedExpression(expression, call) {
	    // Remove the calc part from nested expressions to ensure
	    // better browser compatibility
	    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
	    var evaluatedPart = ""
	    var nonEvaluatedPart = expression
	    var matches
	    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
	      if (matches[0].index > 0) {
	        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
	      }
	
	      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
	      if (balancedExpr.body === "") {
	        throw new Error("'" + expression + "' must contain a non-whitespace string")
	      }
	
	      var evaluated = evaluateExpression(balancedExpr.body, "", call)
	
	      evaluatedPart += balancedExpr.pre + evaluated
	      nonEvaluatedPart = balancedExpr.post
	    }
	
	    return evaluatedPart + nonEvaluatedPart
	  }
	
	  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
	}
	
	/**
	 * Checks what units are used in an expression
	 *
	 * @param {String} expression
	 * @returns {Array}
	 */
	
	function getUnitsInExpression(expression) {
	  var uniqueUnits = []
	  var uniqueLowerCaseUnits = []
	  var unitRegEx = /[\.0-9]([%a-z]+)/gi
	  var matches = unitRegEx.exec(expression)
	
	  while (matches) {
	    if (!matches || !matches[1]) {
	      continue
	    }
	
	    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
	      uniqueUnits.push(matches[1])
	      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
	    }
	
	    matches = unitRegEx.exec(expression)
	  }
	
	  return uniqueUnits
	}


/***/ },
/* 3025 */
/***/ function(module, exports) {

	module.exports = balanced;
	function balanced(a, b, str) {
	  if (a instanceof RegExp) a = maybeMatch(a, str);
	  if (b instanceof RegExp) b = maybeMatch(b, str);
	
	  var r = range(a, b, str);
	
	  return r && {
	    start: r[0],
	    end: r[1],
	    pre: str.slice(0, r[0]),
	    body: str.slice(r[0] + a.length, r[1]),
	    post: str.slice(r[1] + b.length)
	  };
	}
	
	function maybeMatch(reg, str) {
	  var m = str.match(reg);
	  return m ? m[0] : null;
	}
	
	balanced.range = range;
	function range(a, b, str) {
	  var begs, beg, left, right, result;
	  var ai = str.indexOf(a);
	  var bi = str.indexOf(b, ai + 1);
	  var i = ai;
	
	  if (ai >= 0 && bi > 0) {
	    begs = [];
	    left = str.length;
	
	    while (i >= 0 && !result) {
	      if (i == ai) {
	        begs.push(i);
	        ai = str.indexOf(a, i + 1);
	      } else if (begs.length == 1) {
	        result = [ begs.pop(), bi ];
	      } else {
	        beg = begs.pop();
	        if (beg < left) {
	          left = beg;
	          right = bi;
	        }
	
	        bi = str.indexOf(b, i + 1);
	      }
	
	      i = ai < bi && ai >= 0 ? ai : bi;
	    }
	
	    if (begs.length) {
	      result = [ left, right ];
	    }
	  }
	
	  return result;
	}


/***/ },
/* 3026 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Module dependencies
	 */
	var balanced = __webpack_require__(3027)
	
	/**
	 * Expose `reduceFunctionCall`
	 *
	 * @type {Function}
	 */
	module.exports = reduceFunctionCall
	
	/**
	 * Walkthrough all expressions, evaluate them and insert them into the declaration
	 *
	 * @param {Array} expressions
	 * @param {Object} declaration
	 */
	
	function reduceFunctionCall(string, functionRE, callback) {
	  var call = string
	  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
	    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
	  }, string)
	}
	
	/**
	 * Parses expressions in a value
	 *
	 * @param {String} value
	 * @returns {Array}
	 * @api private
	 */
	
	function getFunctionCalls(call, functionRE) {
	  var expressions = []
	
	  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
	  do {
	    var searchMatch = fnRE.exec(call)
	    if (!searchMatch) {
	      return expressions
	    }
	    if (searchMatch[1] === undefined) {
	      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
	    }
	    var fn = searchMatch[1]
	    var startIndex = searchMatch.index
	    var matches = balanced("(", ")", call.substring(startIndex))
	
	    if (!matches || matches.start !== searchMatch[0].length - 1) {
	      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
	    }
	
	    expressions.push({matches: matches, functionIdentifier: fn})
	    call = matches.post
	  }
	  while (fnRE.test(call))
	
	  return expressions
	}
	
	/**
	 * Evaluates an expression
	 *
	 * @param {String} expression
	 * @returns {String}
	 * @api private
	 */
	
	function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
	  // allow recursivity
	  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
	}


/***/ },
/* 3027 */
3025,
/* 3028 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = reduceReducers;
	
	function reduceReducers() {
	  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
	    reducers[_key] = arguments[_key];
	  }
	
	  return function (previous, current) {
	    return reducers.reduce(function (p, r) {
	      return r(p, current);
	    }, previous);
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 3029 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};

/***/ },
/* 3030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createActions;
	
	var _camelCase = __webpack_require__(1340);
	
	var _camelCase2 = _interopRequireDefault(_camelCase);
	
	var _identity = __webpack_require__(110);
	
	var _identity2 = _interopRequireDefault(_identity);
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _isArray = __webpack_require__(36);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _last = __webpack_require__(1005);
	
	var _last2 = _interopRequireDefault(_last);
	
	var _isString = __webpack_require__(154);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isFunction = __webpack_require__(24);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _isNil = __webpack_require__(63);
	
	var _isNil2 = _interopRequireDefault(_isNil);
	
	var _createAction = __webpack_require__(1342);
	
	var _createAction2 = _interopRequireDefault(_createAction);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _arrayToObject = __webpack_require__(3029);
	
	var _arrayToObject2 = _interopRequireDefault(_arrayToObject);
	
	var _flattenUtils = __webpack_require__(1343);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  var _ref = (0, _isPlainObject2.default)((0, _last2.default)(identityActions)) ? identityActions.pop() : {};
	
	  var namespace = _ref.namespace;
	
	  (0, _invariant2.default)(identityActions.every(_isString2.default) && ((0, _isString2.default)(actionMap) || (0, _isPlainObject2.default)(actionMap)), 'Expected optional object followed by string action types');
	  if ((0, _isString2.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions));
	  }
	  return _extends({}, actionCreatorsFromActionMap(actionMap, namespace), actionCreatorsFromIdentityActions(identityActions));
	}
	
	function actionCreatorsFromActionMap(actionMap, namespace) {
	  var flatActionMap = (0, _flattenUtils.flattenActionMap)(actionMap, namespace);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _flattenUtils.unflattenActionCreators)(flatActionCreators, namespace);
	}
	
	function actionMapToActionCreators(actionMap) {
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction2.default)(actionMapValue) || (0, _isNil2.default)(actionMapValue)) {
	      return true;
	    } else if ((0, _isArray2.default)(actionMapValue)) {
	      var _actionMapValue = _slicedToArray(actionMapValue, 2);
	
	      var _actionMapValue$ = _actionMapValue[0];
	      var payload = _actionMapValue$ === undefined ? _identity2.default : _actionMapValue$;
	      var meta = _actionMapValue[1];
	
	      return (0, _isFunction2.default)(payload) && (0, _isFunction2.default)(meta);
	    }
	    return false;
	  }
	
	  return (0, _arrayToObject2.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var actionMapValue = actionMap[type];
	    (0, _invariant2.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
	    var actionCreator = (0, _isArray2.default)(actionMapValue) ? _createAction2.default.apply(undefined, [type].concat(_toConsumableArray(actionMapValue))) : (0, _createAction2.default)(type, actionMapValue);
	    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions) {
	  var actionMap = (0, _arrayToObject2.default)(identityActions, function (partialActionMap, type) {
	    return _extends({}, partialActionMap, _defineProperty({}, type, _identity2.default));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap);
	  return (0, _arrayToObject2.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    return _extends({}, partialActionCreators, _defineProperty({}, (0, _camelCase2.default)(type), actionCreators[type]));
	  });
	}

/***/ },
/* 3031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = handleActions;
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _reduceReducers = __webpack_require__(3028);
	
	var _reduceReducers2 = _interopRequireDefault(_reduceReducers);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _handleAction = __webpack_require__(1344);
	
	var _handleAction2 = _interopRequireDefault(_handleAction);
	
	var _ownKeys = __webpack_require__(543);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	var _flattenUtils = __webpack_require__(1343);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function handleActions(handlers, defaultState) {
	  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	  var namespace = _ref.namespace;
	
	  (0, _invariant2.default)((0, _isPlainObject2.default)(handlers), 'Expected handlers to be an plain object.');
	  var flattenedReducerMap = (0, _flattenUtils.flattenReducerMap)(handlers, namespace);
	  var reducers = (0, _ownKeys2.default)(flattenedReducerMap).map(function (type) {
	    return (0, _handleAction2.default)(type, flattenedReducerMap[type], defaultState);
	  });
	  var reducer = _reduceReducers2.default.apply(undefined, _toConsumableArray(reducers));
	  return function () {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? defaultState : arguments[0];
	    var action = arguments[1];
	    return reducer(state, action);
	  };
	}

/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hasGeneratorInterface;
	
	var _ownKeys = __webpack_require__(543);
	
	var _ownKeys2 = _interopRequireDefault(_ownKeys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasGeneratorInterface(handler) {
	  var keys = (0, _ownKeys2.default)(handler);
	  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
	    return ownKey === 'next' || ownKey === 'throw';
	  });
	  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
	}

/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3055)


/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _createFieldProps2 = __webpack_require__(1348);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _onChangeValue = __webpack_require__(1354);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	var _eventConsts = __webpack_require__(3103);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _isReactNative = __webpack_require__(1356);
	
	var _isReactNative2 = _interopRequireDefault(_isReactNative);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	var createConnectedField = function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain2.default.getIn(syncErrors, name);
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = function (_Component) {
	    _inherits(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ConnectedField);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      }, _this.isPristine = function () {
	        return _this.props.pristine;
	      }, _this.getValue = function () {
	        return _this.props.value;
	      }, _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        var defaultPrevented = false;
	        if (onChange) {
	          // Can't seem to find a way to extend Event in React Native,
	          // thus I simply avoid adding preventDefault() in a RN environment
	          // to prevent the following error:
	          // `One of the sources for assign has an enumerable key on the prototype chain`
	          // Reference: https://github.com/facebook/react-native/issues/5507
	          if (!_isReactNative2.default) {
	            onChange(_extends({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            onChange(event, newValue, previousValue, name);
	          }
	        }
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	
	          // call post-change callback
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'change');
	          }
	        }
	      }, _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	
	
	        var defaultPrevented = false;
	        if (onFocus) {
	          if (!_isReactNative2.default) {
	            onFocus(_extends({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), name);
	          } else {
	            onFocus(event, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      }, _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	
	        var newValue = (0, _onChangeValue2.default)(event, { name: name, parse: parse, normalize: normalize });
	
	        // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	        if (onBlur) {
	          if (!_isReactNative2.default) {
	            onBlur(_extends({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            onBlur(event, newValue, previousValue, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue));
	
	          // call post-blur callback
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'blur');
	          }
	        }
	      }, _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            name = _this$props4.name,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event, name);
	        }
	      }, _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	
	        var defaultPrevented = false;
	        if (onDrop) {
	          onDrop(_extends({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue, name);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ConnectedField, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        // if we have children, we MUST update in React 16
	        // https://twitter.com/erikras/status/915866544558788608
	        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        }));
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.ref;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            normalize = _props.normalize,
	            onBlur = _props.onBlur,
	            onChange = _props.onChange,
	            onFocus = _props.onFocus,
	            onDragStart = _props.onDragStart,
	            onDrop = _props.onDrop,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);
	
	        var _createFieldProps = (0, _createFieldProps3.default)(structure, name, _extends({}, rest, {
	          form: _reduxForm.form,
	          onBlur: this.handleBlur,
	          onChange: this.handleChange,
	          onDrop: this.handleDrop,
	          onDragStart: this.handleDragStart,
	          onFocus: this.handleFocus
	        })),
	            custom = _createFieldProps.custom,
	            props = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	        if (withRef) {
	          custom.ref = this.saveRef;
	        }
	        if (typeof component === 'string') {
	          var input = props.input,
	              meta = props.meta; // eslint-disable-line no-unused-vars
	          // flatten input into other props
	
	          return (0, _react.createElement)(component, _extends({}, input, custom));
	        } else {
	          return (0, _react.createElement)(component, _extends({}, props, custom));
	        }
	      }
	    }]);
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initialState = getIn(formState, 'initial.' + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for checkboxes)
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedField);
	};
	
	exports.default = createConnectedField;

/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(556);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _redux = __webpack_require__(56);
	
	var _createFieldArrayProps = __webpack_require__(3042);
	
	var _createFieldArrayProps2 = _interopRequireDefault(_createFieldArrayProps);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	var createConnectedFieldArray = function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain2.default.getIn(syncErrors, name + '._error');
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + '._warning');
	  };
	
	  var ConnectedFieldArray = function (_Component) {
	    _inherits(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, ConnectedFieldArray);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
	        _this.ref = ref;
	      }, _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(ConnectedFieldArray, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this2 = this;
	
	        // Update if the elements of the value array was updated.
	        var thisValue = this.props.value;
	        var nextValue = nextProps.value;
	
	        if (thisValue && nextValue) {
	          var nextValueItemsSame = nextValue.every(function (val) {
	            return ~thisValue.indexOf(val);
	          });
	          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
	            return val !== thisValue[index];
	          });
	          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	            return !deepEqual(val, nextValue[index]);
	          })) {
	            return true;
	          }
	        }
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        // if we have children, we MUST update in React 16
	        // https://twitter.com/erikras/status/915866544558788608
	        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          // useful to debug rerenders
	          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	          // }
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	        }));
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.ref;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            name = _props.name,
	            _reduxForm = _props._reduxForm,
	            validate = _props.validate,
	            warn = _props.warn,
	            rerenderOnEveryChange = _props.rerenderOnEveryChange,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);
	
	        var props = (0, _createFieldArrayProps2.default)(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	        if (withRef) {
	          props.ref = this.saveRef;
	        }
	        return (0, _react.createElement)(component, props);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    props: _propTypes2.default.object,
	    rerenderOnEveryChange: _propTypes2.default.bool
	  };
	
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	
	  ConnectedFieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, 'values.' + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, 'fields.' + name),
	      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	
	    return (0, _mapValues3.default)({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, { withRef: true });
	  return connector(ConnectedFieldArray);
	};
	
	exports.default = createConnectedFieldArray;

/***/ },
/* 3036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _createFieldProps2 = __webpack_require__(1348);
	
	var _createFieldProps3 = _interopRequireDefault(_createFieldProps2);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _onChangeValue = __webpack_require__(1354);
	
	var _onChangeValue2 = _interopRequireDefault(_onChangeValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var createConnectedFields = function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain2.default.getIn(syncErrors, name + '._error') || _plain2.default.getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name);
	    // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = function (_Component) {
	    _inherits(ConnectedFields, _Component);
	
	    function ConnectedFields(props) {
	      _classCallCheck(this, ConnectedFields);
	
	      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));
	
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse });
	
	        dispatch(_reduxForm.change(name, value));
	
	        // call post-change callback
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'change');
	        }
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	
	        var value = (0, _onChangeValue2.default)(event, { name: name, parse: parse });
	
	        // dispatch blur action
	        dispatch(_reduxForm.blur(name, value));
	
	        // call post-blur callback
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'blur');
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	      return _this;
	    }
	
	    _createClass(ConnectedFields, [{
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	          return !_this2.props._fields[nextName];
	        }))) {
	          // names has changed. The cached event handlers need to be updated
	          this.prepareEventHandlers(nextProps);
	        }
	      }
	    }, {
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        var _this3 = this;
	
	        var nextPropsKeys = Object.keys(nextProps);
	        var thisPropsKeys = Object.keys(this.props);
	        // if we have children, we MUST update in React 16
	        // https://twitter.com/erikras/status/915866544558788608
	        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	        }));
	      }
	    }, {
	      key: 'isDirty',
	      value: function isDirty() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).some(function (name) {
	          return _fields[name].dirty;
	        });
	      }
	    }, {
	      key: 'getValues',
	      value: function getValues() {
	        var _fields = this.props._fields;
	
	        return Object.keys(_fields).reduce(function (accumulator, name) {
	          return _plain2.default.setIn(accumulator, name, _fields[name].value);
	        }, {});
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        return this.refs.renderedComponent;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this4 = this;
	
	        var _props = this.props,
	            component = _props.component,
	            withRef = _props.withRef,
	            _fields = _props._fields,
	            _reduxForm = _props._reduxForm,
	            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);
	
	        var sectionPrefix = _reduxForm.sectionPrefix,
	            form = _reduxForm.form;
	
	        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	          var connectedProps = _fields[name];
	
	          var _createFieldProps = (0, _createFieldProps3.default)(structure, name, _extends({}, connectedProps, rest, {
	            form: form,
	            onBlur: _this4.onBlurFns[name],
	            onChange: _this4.onChangeFns[name],
	            onFocus: _this4.onFocusFns[name]
	          })),
	              custom = _createFieldProps.custom,
	              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);
	
	          accumulator.custom = custom;
	          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	          return _plain2.default.setIn(accumulator, fieldName, fieldProps);
	        }, {}),
	            custom = _Object$keys$reduce.custom,
	            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);
	
	        if (withRef) {
	          props.ref = 'renderedComponent';
	        }
	
	        return (0, _react.createElement)(component, _extends({}, props, custom));
	      }
	    }]);
	
	    return ConnectedFields;
	  }(_react.Component);
	
	  ConnectedFields.propTypes = {
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    _fields: _propTypes2.default.object.isRequired,
	    props: _propTypes2.default.object
	  };
	
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, 'initial.' + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, 'values.' + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, 'asyncErrors.' + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, 'fields.' + name),
	          submitError: getIn(formState, 'submitErrors.' + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for checkboxes)
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, { withRef: true });
	  return connector(ConnectedFields);
	};
	
	exports.default = createConnectedFields;

/***/ },
/* 3037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form(props, context) {
	    _classCallCheck(this, Form);
	
	    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement('form', this.props);
	    }
	  }]);
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes2.default.func.isRequired
	};
	Form.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = Form;

/***/ },
/* 3038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _prefixName = __webpack_require__(260);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormSection = function (_Component) {
	  _inherits(FormSection, _Component);
	
	  function FormSection(props, context) {
	    _classCallCheck(this, FormSection);
	
	    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));
	
	    if (!context._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	    return _this;
	  }
	
	  _createClass(FormSection, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var context = this.context,
	          name = this.props.name;
	
	      return {
	        _reduxForm: _extends({}, context._reduxForm, {
	          sectionPrefix: (0, _prefixName2.default)(context, name)
	        })
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          component = _props.component,
	          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);
	
	      if (_react2.default.isValidElement(children)) {
	        return children;
	      }
	
	      return (0, _react.createElement)(component, _extends({}, rest, {
	        children: children
	      }));
	    }
	  }]);
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string])
	};
	
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	FormSection.childContextTypes = {
	  _reduxForm: _propTypes2.default.object.isRequired
	};
	
	FormSection.contextTypes = {
	  _reduxForm: _propTypes2.default.object
	};
	
	exports.default = FormSection;

/***/ },
/* 3039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPromise = __webpack_require__(441);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	  if (!(0, _isPromise2.default)(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (errors && Object.keys(errors).length) {
	        stop(errors);
	        return errors;
	      } else if (rejected) {
	        stop();
	        throw new Error('Asynchronous validation promise was rejected without errors.');
	      }
	      stop();
	      return Promise.resolve();
	    };
	  };
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	exports.default = asyncValidation;

/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(261);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedField = __webpack_require__(3034);
	
	var _ConnectedField2 = _interopRequireDefault(_ConnectedField);
	
	var _shallowCompare = __webpack_require__(1360);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _prefixName = __webpack_require__(260);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createField = function createField(structure) {
	  var ConnectedField = (0, _ConnectedField2.default)(structure);
	
	  var setIn = structure.setIn;
	
	  var Field = function (_Component) {
	    _inherits(Field, _Component);
	
	    function Field(props, context) {
	      _classCallCheck(this, Field);
	
	      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));
	
	      _this.saveRef = function (ref) {
	        return _this.ref = ref;
	      };
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	        var previousValues = _this.context._reduxForm.getValues();
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues);
	      };
	
	      if (!context._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Field, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _shallowCompare2.default)(this, nextProps, nextState);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'Field', function () {
	          return _this2.props.validate;
	        }, function () {
	          return _this2.props.warn;
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextContext) {
	        var oldName = (0, _prefixName2.default)(this.context, this.props.name);
	        var newName = (0, _prefixName2.default)(nextContext, nextProps.name);
	
	        if (oldName !== newName ||
	        // use deepEqual here because they could be a function or an array of functions
	        !_plain2.default.deepEqual(this.props.validate, nextProps.validate) || !_plain2.default.deepEqual(this.props.warn, nextProps.warn)) {
	          // unregister old name
	          this.context._reduxForm.unregister(oldName);
	          // register new name
	          this.context._reduxForm.register(newName, 'Field', function () {
	            return nextProps.validate;
	          }, function () {
	            return nextProps.warn;
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
	        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedField, _extends({}, this.props, {
	          name: this.name,
	          normalize: this.normalize,
	          _reduxForm: this.context._reduxForm,
	          ref: this.saveRef
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.ref && this.ref.getWrappedInstance().getValue();
	      }
	    }]);
	
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    normalize: _propTypes2.default.func,
	    onBlur: _propTypes2.default.func,
	    onChange: _propTypes2.default.func,
	    onFocus: _propTypes2.default.func,
	    onDragStart: _propTypes2.default.func,
	    onDrop: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  Field.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Field;
	};
	
	exports.default = createField;

/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(261);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFieldArray = __webpack_require__(3035);
	
	var _ConnectedFieldArray2 = _interopRequireDefault(_ConnectedFieldArray);
	
	var _prefixName = __webpack_require__(260);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	      if (result) {
	        return _defineProperty({}, key, result);
	      }
	    }
	  };
	};
	
	var createFieldArray = function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray2.default)(structure);
	
	  var FieldArray = function (_Component) {
	    _inherits(FieldArray, _Component);
	
	    function FieldArray(props, context) {
	      _classCallCheck(this, FieldArray);
	
	      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));
	
	      _this.saveRef = function (ref) {
	        _this.ref = ref;
	      };
	
	      if (!context._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(FieldArray, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var _this2 = this;
	
	        this.context._reduxForm.register(this.name, 'FieldArray', function () {
	          return wrapError(_this2.props.validate, '_error');
	        }, function () {
	          return wrapError(_this2.props.warn, '_warning');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps, nextContext) {
	        var oldName = (0, _prefixName2.default)(this.context, this.props.name);
	        var newName = (0, _prefixName2.default)(nextContext, nextProps.name);
	
	        if (oldName !== newName) {
	          // unregister old name
	          this.context._reduxForm.unregister(oldName);
	          // register new name
	          this.context._reduxForm.register(newName, 'FieldArray');
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this.context._reduxForm.unregister(this.name);
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
	        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return (0, _react.createElement)(ConnectedFieldArray, _extends({}, this.props, {
	          name: this.name,
	          _reduxForm: this.context._reduxForm,
	          ref: this.saveRef
	        }));
	      }
	    }, {
	      key: 'name',
	      get: function get() {
	        return (0, _prefixName2.default)(this.context, this.props.name);
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return !this.ref || this.ref.getWrappedInstance().dirty;
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !!(this.ref && this.ref.getWrappedInstance().pristine);
	      }
	    }, {
	      key: 'value',
	      get: function get() {
	        return this.ref ? this.ref.getWrappedInstance().value : undefined;
	      }
	    }]);
	
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes2.default.string.isRequired,
	    component: _propTypes2.default.func.isRequired,
	    props: _propTypes2.default.object,
	    validate: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    warn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.arrayOf(_propTypes2.default.func)]),
	    withRef: _propTypes2.default.bool
	  };
	  FieldArray.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return FieldArray;
	};
	
	exports.default = createFieldArray;

/***/ },
/* 3042 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
	  var getIn = _ref2.getIn;
	
	  var arrayInsert = _ref.arrayInsert,
	      arrayMove = _ref.arrayMove,
	      arrayPop = _ref.arrayPop,
	      arrayPush = _ref.arrayPush,
	      arrayRemove = _ref.arrayRemove,
	      arrayRemoveAll = _ref.arrayRemoveAll,
	      arrayShift = _ref.arrayShift,
	      arraySplice = _ref.arraySplice,
	      arraySwap = _ref.arraySwap,
	      arrayUnshift = _ref.arrayUnshift,
	      asyncError = _ref.asyncError,
	      dirty = _ref.dirty,
	      length = _ref.length,
	      pristine = _ref.pristine,
	      submitError = _ref.submitError,
	      state = _ref.state,
	      submitFailed = _ref.submitFailed,
	      submitting = _ref.submitting,
	      syncError = _ref.syncError,
	      syncWarning = _ref.syncWarning,
	      value = _ref.value,
	      props = _ref.props,
	      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);
	
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
	  var finalProps = _extends({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, rest);
	  return finalProps;
	};
	exports.default = createFieldArrayProps;

/***/ },
/* 3043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(261);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ConnectedFields = __webpack_require__(3036);
	
	var _ConnectedFields2 = _interopRequireDefault(_ConnectedFields);
	
	var _shallowCompare = __webpack_require__(1360);
	
	var _shallowCompare2 = _interopRequireDefault(_shallowCompare);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _prefixName = __webpack_require__(260);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var createFields = function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields2.default)(structure);
	
	  var Fields = function (_Component) {
	    _inherits(Fields, _Component);
	
	    function Fields(props, context) {
	      _classCallCheck(this, Fields);
	
	      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));
	
	      if (!context._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	      return _this;
	    }
	
	    _createClass(Fields, [{
	      key: 'shouldComponentUpdate',
	      value: function shouldComponentUpdate(nextProps) {
	        return (0, _shallowCompare2.default)(this, nextProps);
	      }
	    }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        var error = validateNameProp(this.props.names);
	        if (error) {
	          throw error;
	        }
	        var context = this.context;
	        var register = context._reduxForm.register;
	
	        this.names.forEach(function (name) {
	          return register(name, 'Field');
	        });
	      }
	    }, {
	      key: 'componentWillReceiveProps',
	      value: function componentWillReceiveProps(nextProps) {
	        if (!_plain2.default.deepEqual(this.props.names, nextProps.names)) {
	          var context = this.context;
	          var _context$_reduxForm = context._reduxForm,
	              register = _context$_reduxForm.register,
	              unregister = _context$_reduxForm.unregister;
	          // unregister old name
	
	          this.props.names.forEach(function (name) {
	            return unregister((0, _prefixName2.default)(context, name));
	          });
	          // register new name
	          nextProps.names.forEach(function (name) {
	            return register((0, _prefixName2.default)(context, name), 'Field');
	          });
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        var context = this.context;
	        var unregister = context._reduxForm.unregister;
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName2.default)(context, name));
	        });
	      }
	    }, {
	      key: 'getRenderedComponent',
	      value: function getRenderedComponent() {
	        (0, _invariant2.default)(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
	        return this.refs.connected.getWrappedInstance().getRenderedComponent();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var context = this.context;
	
	        return (0, _react.createElement)(ConnectedFields, _extends({}, this.props, {
	          names: this.props.names.map(function (name) {
	            return (0, _prefixName2.default)(context, name);
	          }),
	          _reduxForm: this.context._reduxForm,
	          ref: 'connected'
	        }));
	      }
	    }, {
	      key: 'names',
	      get: function get() {
	        var context = this.context;
	
	        return this.props.names.map(function (name) {
	          return (0, _prefixName2.default)(context, name);
	        });
	      }
	    }, {
	      key: 'dirty',
	      get: function get() {
	        return this.refs.connected.getWrappedInstance().isDirty();
	      }
	    }, {
	      key: 'pristine',
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: 'values',
	      get: function get() {
	        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
	      }
	    }]);
	
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = {
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    },
	    component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
	    format: _propTypes2.default.func,
	    parse: _propTypes2.default.func,
	    props: _propTypes2.default.object,
	    withRef: _propTypes2.default.bool
	  };
	  Fields.contextTypes = {
	    _reduxForm: _propTypes2.default.object
	  };
	
	  return Fields;
	};
	
	exports.default = createFields;

/***/ },
/* 3044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invariant = __webpack_require__(261);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFormValueSelector = function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant2.default)(form, 'Form value must be specified');
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	    return function (state) {
	      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant2.default)(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
	        return value === undefined ? accumulator : _plain2.default.setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	};
	
	exports.default = createFormValueSelector;

/***/ },
/* 3045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _mapValues2 = __webpack_require__(556);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _isEqual2 = __webpack_require__(3197);
	
	var _isEqual3 = _interopRequireDefault(_isEqual2);
	
	var _isEmpty2 = __webpack_require__(3196);
	
	var _isEmpty3 = _interopRequireDefault(_isEmpty2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(40);
	
	var _prefixName = __webpack_require__(260);
	
	var _prefixName2 = _interopRequireDefault(_prefixName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = function (_React$Component) {
	        _inherits(FormValues, _React$Component);
	
	        function FormValues(props, context) {
	          _classCallCheck(this, FormValues);
	
	          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));
	
	          if (!context._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	          _this.updateComponent(props);
	          return _this;
	        }
	
	        _createClass(FormValues, [{
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(props) {
	            if (typeof firstArg === 'function') {
	              this.updateComponent(props);
	            }
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var Component = this.Component;
	
	            return _react2.default.createElement(Component
	            // so that the connected component updates props when sectionPrefix has changed
	            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
	            }, this.props));
	          }
	        }, {
	          key: 'updateComponent',
	          value: function updateComponent(props) {
	            var valuesMap = void 0;
	            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
	            if (typeof resolvedFirstArg === 'string') {
	              valuesMap = rest.reduce(function (result, k) {
	                result[k] = k;
	                return result;
	              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
	            } else {
	              valuesMap = resolvedFirstArg;
	            }
	            if ((0, _isEmpty3.default)(valuesMap)) {
	              // maybe that empty valuesMap is ok if firstArg is a function?
	              // if this is the case, we probably should set this.Component = Component
	              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
	            }
	            if ((0, _isEqual3.default)(valuesMap, this._valuesMap)) {
	              // no change in valuesMap
	              return;
	            }
	            this._valuesMap = valuesMap;
	            this.setComponent();
	          }
	        }, {
	          key: 'setComponent',
	          value: function setComponent() {
	            var _this2 = this;
	
	            var formValuesSelector = function formValuesSelector(_, _ref2) {
	              var sectionPrefix = _ref2.sectionPrefix;
	
	              // Yes, we're only using connect() for listening to updates.
	              // The second argument needs to be there so that connect calls
	              // the selector when props change
	              var getValues = _this2.context._reduxForm.getValues;
	
	              var values = getValues();
	              return (0, _mapValues3.default)(_this2._valuesMap, function (path) {
	                return getIn(values, (0, _prefixName2.default)(_this2.context, path));
	              });
	            };
	            this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	              return {};
	            } // ignore dispatch
	            )(function (_ref3) {
	              var sectionPrefix = _ref3.sectionPrefix,
	                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);
	
	              return _react2.default.createElement(Component, otherProps);
	            });
	          }
	        }]);
	
	        return FormValues;
	      }(_react2.default.Component);
	
	      FormValues.contextTypes = {
	        _reduxForm: _propTypes2.default.object
	      };
	      return FormValues;
	    };
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 3046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actionTypes = __webpack_require__(544);
	
	var _deleteInWithCleanUp = __webpack_require__(3049);
	
	var _deleteInWithCleanUp2 = _interopRequireDefault(_deleteInWithCleanUp);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(structure);
	  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp2.default)(_plain2.default);
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + '.' + field);
	    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
	  };
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	    var existing = _plain2.default.getIn(slice, field);
	    return existing || force ? setIn(state, key, _plain2.default.setIn(slice, field, _plain2.default.splice(existing, index, removeNum, value))) : state;
	  };
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, _actionTypes.ARRAY_INSERT, function (state, _ref) {
	    var _ref$meta = _ref.meta,
	        field = _ref$meta.field,
	        index = _ref$meta.index,
	        payload = _ref.payload;
	
	    return arraySplice(state, field, index, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_MOVE, function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        from = _ref2$meta.from,
	        to = _ref2$meta.to;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + '.' + field;
	        if (getIn(result, path)) {
	          var value = getIn(result, path + '[' + from + ']');
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_POP, function (state, _ref3) {
	    var field = _ref3.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_PUSH, function (state, _ref4) {
	    var field = _ref4.meta.field,
	        payload = _ref4.payload;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE, function (state, _ref5) {
	    var _ref5$meta = _ref5.meta,
	        field = _ref5$meta.field,
	        index = _ref5$meta.index;
	
	    return arraySplice(state, field, index, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_REMOVE_ALL, function (state, _ref6) {
	    var field = _ref6.meta.field;
	
	    var array = getIn(state, 'values.' + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SHIFT, function (state, _ref7) {
	    var field = _ref7.meta.field;
	
	    return arraySplice(state, field, 0, 1);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SPLICE, function (state, _ref8) {
	    var _ref8$meta = _ref8.meta,
	        field = _ref8$meta.field,
	        index = _ref8$meta.index,
	        removeNum = _ref8$meta.removeNum,
	        payload = _ref8.payload;
	
	    return arraySplice(state, field, index, removeNum, payload);
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_SWAP, function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        indexA = _ref9$meta.indexA,
	        indexB = _ref9$meta.indexB;
	
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
	      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
	        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
	      }
	    });
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.ARRAY_UNSHIFT, function (state, _ref10) {
	    var field = _ref10.meta.field,
	        payload = _ref10.payload;
	
	    return arraySplice(state, field, 0, 0, payload);
	  }), _defineProperty(_behaviors, _actionTypes.AUTOFILL, function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	
	    var result = state;
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    result = setIn(result, 'fields.' + field + '.autofilled', true);
	    result = setIn(result, 'values.' + field, payload);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.BLUR, function (state, _ref12) {
	    var _ref12$meta = _ref12.meta,
	        field = _ref12$meta.field,
	        touch = _ref12$meta.touch,
	        payload = _ref12.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	    result = deleteIn(result, 'fields.' + field + '.active');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CHANGE, function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
	        payload = _ref13.payload;
	
	    var result = state;
	    var initial = getIn(result, 'initial.' + field);
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, 'values.' + field, payload);
	    }
	    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	    }
	    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	    if (touch) {
	      result = setIn(result, 'fields.' + field + '.touched', true);
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT, function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_SUBMIT_ERRORS, function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_ASYNC_ERROR, function (state, _ref14) {
	    var field = _ref14.meta.field;
	
	    return deleteIn(state, 'asyncErrors.' + field);
	  }), _defineProperty(_behaviors, _actionTypes.CLEAR_FIELDS, function (state, _ref15) {
	    var _ref15$meta = _ref15.meta,
	        keepTouched = _ref15$meta.keepTouched,
	        persistentSubmitErrors = _ref15$meta.persistentSubmitErrors,
	        fields = _ref15$meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      result = deleteInWithCleanUp(result, 'values.' + field);
	      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
	      if (!persistentSubmitErrors) {
	        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
	      }
	      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
	      if (!keepTouched) {
	        result = deleteIn(result, 'fields.' + field + '.touched');
	      }
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.FOCUS, function (state, _ref16) {
	    var field = _ref16.meta.field;
	
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
	    result = setIn(result, 'fields.' + field + '.visited', true);
	    result = setIn(result, 'fields.' + field + '.active', true);
	    result = setIn(result, 'active', field);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.INITIALIZE, function (state, _ref17) {
	    var payload = _ref17.payload,
	        _ref17$meta = _ref17.meta,
	        keepDirty = _ref17$meta.keepDirty,
	        keepSubmitSucceeded = _ref17$meta.keepSubmitSucceeded,
	        updateUnregisteredFields = _ref17$meta.updateUnregisteredFields,
	        keepValues = _ref17$meta.keepValues;
	
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	    var warning = getIn(state, 'warning');
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	    var syncWarnings = getIn(state, 'syncWarnings');
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    }
	
	    // persist old errors, they will get recalculated if the new form values are different from the old values
	    var error = getIn(state, 'error');
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	    var syncErrors = getIn(state, 'syncErrors');
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	
	    var newInitialValues = mapData;
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var overwritePristineValue = function overwritePristineValue(name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name);
	
	            // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        };
	
	        if (!updateUnregisteredFields) {
	          forEach(keys(registeredFields), function (name) {
	            return overwritePristineValue(name);
	          });
	        }
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	
	          if (updateUnregisteredFields) {
	            overwritePristineValue(name);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepValues) {
	      forEach(keys(previousValues), function (name) {
	        var previousValue = getIn(previousValues, name);
	
	        newValues = setIn(newValues, name, previousValue);
	      });
	
	      forEach(keys(previousInitialValues), function (name) {
	        var previousInitialValue = getIn(previousInitialValues, name);
	
	        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
	      });
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.REGISTER_FIELD, function (state, _ref18) {
	    var _ref18$payload = _ref18.payload,
	        name = _ref18$payload.name,
	        type = _ref18$payload.type;
	
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(state, key);
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({ name: name, type: type, count: 1 });
	    }
	    return setIn(state, key, field);
	  }), _defineProperty(_behaviors, _actionTypes.RESET, function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	    var values = getIn(state, 'initial');
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.RESET_SECTION, function (state, _ref19) {
	    var sections = _ref19.meta.sections;
	
	    var result = state;
	
	    sections.forEach(function (section) {
	      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
	      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
	      result = deleteInWithCleanUp(result, 'fields.' + section);
	
	      var values = getIn(state, 'initial.' + section);
	      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
	    });
	
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SUBMIT, function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }), _defineProperty(_behaviors, _actionTypes.START_ASYNC_VALIDATION, function (state, _ref20) {
	    var field = _ref20.meta.field;
	
	    return setIn(state, 'asyncValidating', field || true);
	  }), _defineProperty(_behaviors, _actionTypes.START_SUBMIT, function (state) {
	    return setIn(state, 'submitting', true);
	  }), _defineProperty(_behaviors, _actionTypes.STOP_ASYNC_VALIDATION, function (state, _ref21) {
	    var payload = _ref21.payload;
	
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.STOP_SUBMIT, function (state, _ref22) {
	    var payload = _ref22.payload;
	
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = _objectWithoutProperties(payload, ['_error']);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_FAILED, function (state, _ref23) {
	    var fields = _ref23.meta.fields;
	
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.SET_SUBMIT_SUCCEEDED, function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.TOUCH, function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, 'fields.' + field + '.touched', true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNREGISTER_FIELD, function (state, _ref25) {
	    var _ref25$payload = _ref25.payload,
	        name = _ref25$payload.name,
	        destroyOnUnmount = _ref25$payload.destroyOnUnmount;
	
	    var result = state;
	    var key = 'registeredFields[\'' + name + '\']';
	    var field = getIn(result, key);
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	      var syncErrors = getIn(result, 'syncErrors');
	      if (syncErrors) {
	        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
	        if (_plain2.default.deepEqual(syncErrors, _plain2.default.empty)) {
	          result = deleteIn(result, 'syncErrors');
	        } else {
	          result = setIn(result, 'syncErrors', syncErrors);
	        }
	      }
	      var syncWarnings = getIn(result, 'syncWarnings');
	      if (syncWarnings) {
	        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
	        if (_plain2.default.deepEqual(syncWarnings, _plain2.default.empty)) {
	          result = deleteIn(result, 'syncWarnings');
	        } else {
	          result = setIn(result, 'syncWarnings', syncWarnings);
	        }
	      }
	      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
	      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UNTOUCH, function (state, _ref26) {
	    var fields = _ref26.meta.fields;
	
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, 'fields.' + field + '.touched');
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, 'fields.' + key + '.touched');
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_ERRORS, function (state, _ref27) {
	    var _ref27$payload = _ref27.payload,
	        syncErrors = _ref27$payload.syncErrors,
	        error = _ref27$payload.error;
	
	    var result = state;
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	    return result;
	  }), _defineProperty(_behaviors, _actionTypes.UPDATE_SYNC_WARNINGS, function (state, _ref28) {
	    var _ref28$payload = _ref28.payload,
	        syncWarnings = _ref28$payload.syncWarnings,
	        warning = _ref28$payload.warning;
	
	    var result = state;
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	    return result;
	  }), _behaviors);
	
	  var reducer = function reducer() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	    var action = arguments[1];
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function () {
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
	
	      var form = action && action.meta && action.meta.form;
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	
	  /**
	   * Adds additional functionality to the reducer
	   */
	  function decorate(target) {
	    target.plugin = function (reducers) {
	      var _this = this;
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function () {
	        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
	        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
	
	        var callPlugin = function callPlugin(processed, key) {
	          var previousState = getIn(processed, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
	        };
	
	        var processed = _this(state, action); // run through redux-form reducer
	        var form = action && action.meta && action.meta.form;
	
	        if (form) {
	          // this is an action aimed at forms, so only give it to the specified form's plugin
	          return reducers[form] ? callPlugin(processed, form) : processed;
	        } else {
	          // this is not a form-specific action, so send it to all the plugins
	          return Object.keys(reducers).reduce(callPlugin, processed);
	        }
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	exports.default = createReducer;

/***/ },
/* 3047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _merge4 = __webpack_require__(3200);
	
	var _merge5 = _interopRequireDefault(_merge4);
	
	var _mapValues2 = __webpack_require__(556);
	
	var _mapValues3 = _interopRequireDefault(_mapValues2);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _hoistNonReactStatics = __webpack_require__(3106);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(261);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _isPromise = __webpack_require__(441);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _reactRedux = __webpack_require__(40);
	
	var _redux = __webpack_require__(56);
	
	var _actions = __webpack_require__(1347);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _asyncValidation = __webpack_require__(3039);
	
	var _asyncValidation2 = _interopRequireDefault(_asyncValidation);
	
	var _defaultShouldAsyncValidate = __webpack_require__(1349);
	
	var _defaultShouldAsyncValidate2 = _interopRequireDefault(_defaultShouldAsyncValidate);
	
	var _defaultShouldValidate = __webpack_require__(1351);
	
	var _defaultShouldValidate2 = _interopRequireDefault(_defaultShouldValidate);
	
	var _defaultShouldError = __webpack_require__(1350);
	
	var _defaultShouldError2 = _interopRequireDefault(_defaultShouldError);
	
	var _defaultShouldWarn = __webpack_require__(1352);
	
	var _defaultShouldWarn2 = _interopRequireDefault(_defaultShouldWarn);
	
	var _silenceEvent = __webpack_require__(1355);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	var _silenceEvents = __webpack_require__(3051);
	
	var _silenceEvents2 = _interopRequireDefault(_silenceEvents);
	
	var _generateValidator = __webpack_require__(3052);
	
	var _generateValidator2 = _interopRequireDefault(_generateValidator);
	
	var _handleSubmit = __webpack_require__(3053);
	
	var _handleSubmit2 = _interopRequireDefault(_handleSubmit);
	
	var _isValid = __webpack_require__(545);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	var _getDisplayName = __webpack_require__(3104);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	var _isHotReloading = __webpack_require__(3105);
	
	var _isHotReloading2 = _interopRequireDefault(_isHotReloading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	// extract field-specific actions
	
	var arrayInsert = _actions2.default.arrayInsert,
	    arrayMove = _actions2.default.arrayMove,
	    arrayPop = _actions2.default.arrayPop,
	    arrayPush = _actions2.default.arrayPush,
	    arrayRemove = _actions2.default.arrayRemove,
	    arrayRemoveAll = _actions2.default.arrayRemoveAll,
	    arrayShift = _actions2.default.arrayShift,
	    arraySplice = _actions2.default.arraySplice,
	    arraySwap = _actions2.default.arraySwap,
	    arrayUnshift = _actions2.default.arrayUnshift,
	    blur = _actions2.default.blur,
	    change = _actions2.default.change,
	    focus = _actions2.default.focus,
	    formActions = _objectWithoutProperties(_actions2.default, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);
	
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	
	var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(_actions2.default)), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	var createReduxForm = function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS;
	
	  var isValid = (0, _isValid2.default)(structure);
	  return function (initialConfig) {
	    var config = _extends({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate2.default,
	      shouldValidate: _defaultShouldValidate2.default,
	      shouldError: _defaultShouldError2.default,
	      shouldWarn: _defaultShouldWarn2.default,
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      updateUnregisteredFields: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false
	    }, initialConfig);
	
	    return function (WrappedComponent) {
	      var Form = function (_Component) {
	        _inherits(Form, _Component);
	
	        function Form() {
	          var _ref;
	
	          var _temp, _this, _ret;
	
	          _classCallCheck(this, Form);
	
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
	            return _this.props.values;
	          }, _this.isValid = function () {
	            return _this.props.valid;
	          }, _this.isPristine = function () {
	            return _this.props.pristine;
	          }, _this.register = function (name, type, getValidator, getWarner) {
	            var lastCount = _this.fieldCounts[name];
	            var nextCount = (lastCount || 0) + 1;
	            _this.fieldCounts[name] = nextCount;
	            _this.props.registerField(name, type);
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          }, _this.unregister = function (name) {
	            var lastCount = _this.fieldCounts[name];
	            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
	
	            if (!_this.destroyed) {
	              var _this$props = _this.props,
	                  _destroyOnUnmount = _this$props.destroyOnUnmount,
	                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
	                  _unregisterField = _this$props.unregisterField;
	
	              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
	                _unregisterField(name, _destroyOnUnmount);
	                if (!_this.fieldCounts[name]) {
	                  delete _this.fieldValidators[name];
	                  delete _this.fieldWarners[name];
	                }
	              } else {
	                _unregisterField(name, false);
	              }
	            }
	          }, _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	            var list = [];
	            if (!registeredFields) {
	              return list;
	            }
	            var keySeq = keys(registeredFields);
	            if (options && options.excludeFieldArray) {
	              keySeq = keySeq.filter(function (name) {
	                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
	              });
	            }
	            return fromJS(keySeq.reduce(function (acc, key) {
	              acc.push(key);
	              return acc;
	            }, list));
	          }, _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          }, _this.generateValidator = function () {
	            var validators = _this.getValidators();
	            return Object.keys(validators).length ? (0, _generateValidator2.default)(validators, structure) : undefined;
	          }, _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          }, _this.generateWarner = function () {
	            var warners = _this.getWarners();
	            return Object.keys(warners).length ? (0, _generateValidator2.default)(warners, structure) : undefined;
	          }, _this.asyncValidate = function (name, value, trigger) {
	            var _this$props2 = _this.props,
	                asyncBlurFields = _this$props2.asyncBlurFields,
	                asyncChangeFields = _this$props2.asyncChangeFields,
	                asyncErrors = _this$props2.asyncErrors,
	                asyncValidate = _this$props2.asyncValidate,
	                dispatch = _this$props2.dispatch,
	                initialized = _this$props2.initialized,
	                pristine = _this$props2.pristine,
	                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
	                startAsyncValidation = _this$props2.startAsyncValidation,
	                stopAsyncValidation = _this$props2.stopAsyncValidation,
	                syncErrors = _this$props2.syncErrors,
	                values = _this$props2.values;
	
	            var submitting = !name;
	
	            var fieldNeedsValidation = function fieldNeedsValidation() {
	              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
	              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
	              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
	
	              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
	            };
	
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	              if (fieldNeedsValidation() && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : trigger,
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation2.default)(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          }, _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          }, _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            throw error;
	          }, _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise2.default)(promise)) {
	              return promise;
	            }
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          }, _this.submit = function (submitOrEvent) {
	            var _this$props3 = _this.props,
	                onSubmit = _this$props3.onSubmit,
	                blur = _this$props3.blur,
	                change = _this$props3.change,
	                dispatch = _this$props3.dispatch;
	
	
	            if (!submitOrEvent || (0, _silenceEvent2.default)(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(onSubmit), _extends({}, _this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents2.default)(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit2.default)(checkSubmit(submitOrEvent), _extends({}, _this.props, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
	              });
	            }
	          }, _this.reset = function () {
	            return _this.props.reset();
	          }, _temp), _possibleConstructorReturn(_this, _ret);
	        }
	
	        _createClass(Form, [{
	          key: 'getChildContext',
	          value: function getChildContext() {
	            var _this2 = this;
	
	            return {
	              _reduxForm: _extends({}, this.props, {
	                getFormState: function getFormState(state) {
	                  return getIn(_this2.props.getFormState(state), _this2.props.form);
	                },
	                asyncValidate: this.asyncValidate,
	                getValues: this.getValues,
	                sectionPrefix: undefined,
	                register: this.register,
	                unregister: this.unregister,
	                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	                  return _this2.innerOnSubmit = innerOnSubmit;
	                }
	              })
	            };
	          }
	        }, {
	          key: 'initIfNeeded',
	          value: function initIfNeeded(nextProps) {
	            var enableReinitialize = this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
	                this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  lastInitialValues: this.props.initialValues,
	                  updateUnregisteredFields: nextProps.updateUnregisteredFields
	                });
	              }
	            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
	              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
	                updateUnregisteredFields: this.props.updateUnregisteredFields
	              });
	            }
	          }
	        }, {
	          key: 'updateSyncErrorsIfNeeded',
	          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
	            var _props = this.props,
	                error = _props.error,
	                updateSyncErrors = _props.updateSyncErrors;
	
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	            if (!(noErrors && nextNoErrors) && (!_plain2.default.deepEqual(lastSyncErrors, nextSyncErrors) || !_plain2.default.deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          }
	        }, {
	          key: 'clearSubmitPromiseIfNeeded',
	          value: function clearSubmitPromiseIfNeeded(nextProps) {
	            var submitting = this.props.submitting;
	
	            if (this.submitPromise && submitting && !nextProps.submitting) {
	              delete this.submitPromise;
	            }
	          }
	        }, {
	          key: 'submitIfNeeded',
	          value: function submitIfNeeded(nextProps) {
	            var _props2 = this.props,
	                clearSubmit = _props2.clearSubmit,
	                triggerSubmit = _props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	              this.submit();
	            }
	          }
	        }, {
	          key: 'shouldErrorFunction',
	          value: function shouldErrorFunction() {
	            var _props3 = this.props,
	                shouldValidate = _props3.shouldValidate,
	                shouldError = _props3.shouldError;
	
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate2.default;
	            var shouldErrorOverridden = shouldError !== _defaultShouldError2.default;
	
	            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
	          }
	        }, {
	          key: 'validateIfNeeded',
	          value: function validateIfNeeded(nextProps) {
	            var _props4 = this.props,
	                validate = _props4.validate,
	                values = _props4.values;
	
	            var shouldError = this.shouldErrorFunction();
	            var fieldLevelValidate = this.generateValidator();
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(this.getValidators());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              };
	
	              if (shouldError(validateParams)) {
	                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;
	
	                var _merge2 = (0, _merge5.default)(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);
	
	                this.lastFieldValidatorKeys = fieldValidatorKeys;
	                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            } else {
	              this.lastFieldValidatorKeys = [];
	            }
	          }
	        }, {
	          key: 'updateSyncWarningsIfNeeded',
	          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _props5 = this.props,
	                warning = _props5.warning,
	                syncWarnings = _props5.syncWarnings,
	                updateSyncWarnings = _props5.updateSyncWarnings;
	
	            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	            if (!(noWarnings && nextNoWarnings) && (!_plain2.default.deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain2.default.deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          }
	        }, {
	          key: 'shouldWarnFunction',
	          value: function shouldWarnFunction() {
	            var _props6 = this.props,
	                shouldValidate = _props6.shouldValidate,
	                shouldWarn = _props6.shouldWarn;
	
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate2.default;
	            var shouldWarnOverridden = shouldWarn !== _defaultShouldWarn2.default;
	
	            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
	          }
	        }, {
	          key: 'warnIfNeeded',
	          value: function warnIfNeeded(nextProps) {
	            var _props7 = this.props,
	                warn = _props7.warn,
	                values = _props7.values;
	
	            var shouldWarn = this.shouldWarnFunction();
	            var fieldLevelWarn = this.generateWarner();
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(this.getWarners());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              };
	
	              if (shouldWarn(validateParams)) {
	                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;
	
	                var _merge3 = (0, _merge5.default)(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);
	
	                this.lastFieldWarnerKeys = fieldWarnerKeys;
	                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          }
	        }, {
	          key: 'componentWillMount',
	          value: function componentWillMount() {
	            if (!(0, _isHotReloading2.default)()) {
	              this.initIfNeeded();
	              this.validateIfNeeded();
	              this.warnIfNeeded();
	            }
	            (0, _invariant2.default)(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
	          }
	        }, {
	          key: 'componentWillReceiveProps',
	          value: function componentWillReceiveProps(nextProps) {
	            this.initIfNeeded(nextProps);
	            this.validateIfNeeded(nextProps);
	            this.warnIfNeeded(nextProps);
	            this.clearSubmitPromiseIfNeeded(nextProps);
	            this.submitIfNeeded(nextProps);
	            var onChange = nextProps.onChange,
	                values = nextProps.values,
	                dispatch = nextProps.dispatch;
	
	            if (onChange && !deepEqual(values, this.props.values)) {
	              onChange(values, dispatch, nextProps, this.props.values);
	            }
	          }
	        }, {
	          key: 'shouldComponentUpdate',
	          value: function shouldComponentUpdate(nextProps) {
	            var _this3 = this;
	
	            if (!this.props.pure) return true;
	            var _config$immutableProp = config.immutableProps,
	                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
	            // if we have children, we MUST update in React 16
	            // https://twitter.com/erikras/status/915866544558788608
	
	            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
	              // useful to debug rerenders
	              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	              // }
	              if (~immutableProps.indexOf(prop)) {
	                return _this3.props[prop] !== nextProps[prop];
	              }
	              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	            }));
	          }
	        }, {
	          key: 'componentDidMount',
	          value: function componentDidMount() {
	            if (!(0, _isHotReloading2.default)()) {
	              this.initIfNeeded(this.props);
	              this.validateIfNeeded();
	              this.warnIfNeeded();
	            }
	            (0, _invariant2.default)(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
	          }
	        }, {
	          key: 'componentWillUnmount',
	          value: function componentWillUnmount() {
	            var _props8 = this.props,
	                destroyOnUnmount = _props8.destroyOnUnmount,
	                destroy = _props8.destroy;
	
	            if (destroyOnUnmount && !(0, _isHotReloading2.default)()) {
	              this.destroyed = true;
	              destroy();
	            }
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            // remove some redux-form config-only props
	            /* eslint-disable no-unused-vars */
	            var _props9 = this.props,
	                anyTouched = _props9.anyTouched,
	                array = _props9.array,
	                arrayInsert = _props9.arrayInsert,
	                arrayMove = _props9.arrayMove,
	                arrayPop = _props9.arrayPop,
	                arrayPush = _props9.arrayPush,
	                arrayRemove = _props9.arrayRemove,
	                arrayRemoveAll = _props9.arrayRemoveAll,
	                arrayShift = _props9.arrayShift,
	                arraySplice = _props9.arraySplice,
	                arraySwap = _props9.arraySwap,
	                arrayUnshift = _props9.arrayUnshift,
	                asyncErrors = _props9.asyncErrors,
	                asyncValidate = _props9.asyncValidate,
	                asyncValidating = _props9.asyncValidating,
	                blur = _props9.blur,
	                change = _props9.change,
	                clearSubmit = _props9.clearSubmit,
	                destroy = _props9.destroy,
	                destroyOnUnmount = _props9.destroyOnUnmount,
	                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
	                dirty = _props9.dirty,
	                dispatch = _props9.dispatch,
	                enableReinitialize = _props9.enableReinitialize,
	                error = _props9.error,
	                focus = _props9.focus,
	                form = _props9.form,
	                getFormState = _props9.getFormState,
	                initialize = _props9.initialize,
	                initialized = _props9.initialized,
	                initialValues = _props9.initialValues,
	                invalid = _props9.invalid,
	                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
	                updateUnregisteredFields = _props9.updateUnregisteredFields,
	                pristine = _props9.pristine,
	                propNamespace = _props9.propNamespace,
	                registeredFields = _props9.registeredFields,
	                registerField = _props9.registerField,
	                reset = _props9.reset,
	                resetSection = _props9.resetSection,
	                setSubmitFailed = _props9.setSubmitFailed,
	                setSubmitSucceeded = _props9.setSubmitSucceeded,
	                shouldAsyncValidate = _props9.shouldAsyncValidate,
	                shouldValidate = _props9.shouldValidate,
	                shouldError = _props9.shouldError,
	                shouldWarn = _props9.shouldWarn,
	                startAsyncValidation = _props9.startAsyncValidation,
	                startSubmit = _props9.startSubmit,
	                stopAsyncValidation = _props9.stopAsyncValidation,
	                stopSubmit = _props9.stopSubmit,
	                submitting = _props9.submitting,
	                submitFailed = _props9.submitFailed,
	                submitSucceeded = _props9.submitSucceeded,
	                touch = _props9.touch,
	                touchOnBlur = _props9.touchOnBlur,
	                touchOnChange = _props9.touchOnChange,
	                persistentSubmitErrors = _props9.persistentSubmitErrors,
	                syncErrors = _props9.syncErrors,
	                syncWarnings = _props9.syncWarnings,
	                unregisterField = _props9.unregisterField,
	                untouch = _props9.untouch,
	                updateSyncErrors = _props9.updateSyncErrors,
	                updateSyncWarnings = _props9.updateSyncWarnings,
	                valid = _props9.valid,
	                validExceptSubmit = _props9.validExceptSubmit,
	                values = _props9.values,
	                warning = _props9.warning,
	                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
	            /* eslint-enable no-unused-vars */
	
	
	            var reduxFormProps = _extends({
	              array: array,
	              anyTouched: anyTouched,
	              asyncValidate: this.asyncValidate,
	              asyncValidating: asyncValidating
	            }, (0, _redux.bindActionCreators)({ blur: blur, change: change }, dispatch), {
	              clearSubmit: clearSubmit,
	              destroy: destroy,
	              dirty: dirty,
	              dispatch: dispatch,
	              error: error,
	              form: form,
	              handleSubmit: this.submit,
	              initialize: initialize,
	              initialized: initialized,
	              initialValues: initialValues,
	              invalid: invalid,
	              pristine: pristine,
	              reset: reset,
	              resetSection: resetSection,
	              submitting: submitting,
	              submitFailed: submitFailed,
	              submitSucceeded: submitSucceeded,
	              touch: touch,
	              untouch: untouch,
	              valid: valid,
	              warning: warning
	            });
	            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
	            if (isClassComponent(WrappedComponent)) {
	              propsToPass.ref = 'wrapped';
	            }
	            return (0, _react.createElement)(WrappedComponent, propsToPass);
	          }
	        }]);
	
	        return Form;
	      }(_react.Component);
	
	      Form.displayName = 'Form(' + (0, _getDisplayName2.default)(WrappedComponent) + ')';
	      Form.WrappedComponent = WrappedComponent;
	      Form.childContextTypes = {
	        _reduxForm: _propTypes2.default.object.isRequired
	      };
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes2.default.bool,
	        forceUnregisterOnUnmount: _propTypes2.default.bool,
	        form: _propTypes2.default.string.isRequired,
	        initialValues: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
	        getFormState: _propTypes2.default.func,
	        onSubmitFail: _propTypes2.default.func,
	        onSubmitSuccess: _propTypes2.default.func,
	        propNamespace: _propTypes2.default.string,
	        validate: _propTypes2.default.func,
	        warn: _propTypes2.default.func,
	        touchOnBlur: _propTypes2.default.bool,
	        touchOnChange: _propTypes2.default.bool,
	        triggerSubmit: _propTypes2.default.bool,
	        persistentSubmitErrors: _propTypes2.default.bool,
	        registeredFields: _propTypes2.default.any
	      };
	
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	
	        var initial = initialValues || stateInitial || empty;
	
	        if (shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	        var syncErrors = getIn(formState, 'syncErrors') || {};
	        var syncWarnings = getIn(formState, 'syncWarnings') || {};
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        };
	
	        // Bind the first parameter on `props.form`
	        var boundFormACs = (0, _mapValues3.default)(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues3.default)(arrayActions, bindForm);
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	        var boundFocus = bindForm(focus);
	
	        // Wrap action creators with `dispatch`
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	
	        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	
	        return function () {
	          return computedActions;
	        };
	      }, undefined, { withRef: true });
	      var ConnectedForm = (0, _hoistNonReactStatics2.default)(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config;
	
	      // build outer component to expose instance api
	
	      var ReduxForm = function (_Component2) {
	        _inherits(ReduxForm, _Component2);
	
	        function ReduxForm() {
	          _classCallCheck(this, ReduxForm);
	
	          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
	        }
	
	        _createClass(ReduxForm, [{
	          key: 'submit',
	          value: function submit() {
	            return this.ref && this.ref.getWrappedInstance().submit();
	          }
	        }, {
	          key: 'reset',
	          value: function reset() {
	            if (this.ref) {
	              this.ref.getWrappedInstance().reset();
	            }
	          }
	        }, {
	          key: 'render',
	          value: function render() {
	            var _this5 = this;
	
	            var _props10 = this.props,
	                initialValues = _props10.initialValues,
	                rest = _objectWithoutProperties(_props10, ['initialValues']);
	
	            return (0, _react.createElement)(ConnectedForm, _extends({}, rest, {
	              ref: function ref(_ref3) {
	                return _this5.ref = _ref3;
	              },
	              // convert initialValues if need to
	              initialValues: fromJS(initialValues)
	            }));
	          }
	        }, {
	          key: 'valid',
	          get: function get() {
	            return !!(this.ref && this.ref.getWrappedInstance().isValid());
	          }
	        }, {
	          key: 'invalid',
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: 'pristine',
	          get: function get() {
	            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
	          }
	        }, {
	          key: 'dirty',
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: 'values',
	          get: function get() {
	            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
	          }
	        }, {
	          key: 'fieldList',
	          get: function get() {
	            // mainly provided for testing
	            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
	          }
	        }, {
	          key: 'wrappedInstance',
	          get: function get() {
	            // for testing
	            return this.ref && this.ref.getWrappedInstance().refs.wrapped;
	          }
	        }]);
	
	        return ReduxForm;
	      }(_react.Component);
	
	      return (0, _hoistNonReactStatics2.default)(ReduxForm, WrappedComponent);
	    };
	  };
	};
	
	exports.default = createReduxForm;

/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reactRedux = __webpack_require__(40);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var createValues = function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = _extends({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
	    }
	    // ignore dispatch
	    );
	  };
	};
	
	exports.default = createValues;

/***/ },
/* 3049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(209);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDeleteInWithCleanUp(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn,
	      deleteIn = _ref.deleteIn,
	      setIn = _ref.setIn;
	
	  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	    if (path[path.length - 1] === ']') {
	      // array path
	      var pathTokens = (0, _toPath3.default)(path);
	      pathTokens.pop();
	      var parent = getIn(state, pathTokens.join('.'));
	      return parent ? setIn(state, path) : state;
	    }
	
	    var result = state;
	    if (getIn(state, path) !== undefined) {
	      result = deleteIn(state, path);
	    }
	
	    var dotIndex = path.lastIndexOf('.');
	    if (dotIndex > 0) {
	      var parentPath = path.substring(0, dotIndex);
	      if (parentPath[parentPath.length - 1] !== ']') {
	        var _parent = getIn(result, parentPath);
	        if (deepEqual(_parent, empty)) {
	          return deleteInWithCleanUp(result, parentPath);
	        }
	      }
	    }
	    return result;
	  };
	
	  return deleteInWithCleanUp;
	}
	
	exports.default = createDeleteInWithCleanUp;

/***/ },
/* 3050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEvent = __webpack_require__(1353);
	
	var _isEvent2 = _interopRequireDefault(_isEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	  return result;
	};
	
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent2.default)(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	    var detypedEvent = event;
	    var _detypedEvent$target = detypedEvent.target,
	        type = _detypedEvent$target.type,
	        value = _detypedEvent$target.value,
	        checked = _detypedEvent$target.checked,
	        files = _detypedEvent$target.files,
	        dataTransfer = detypedEvent.dataTransfer;
	
	    if (type === 'checkbox') {
	      return !!checked;
	    }
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	    return value;
	  }
	  return event;
	};
	
	exports.default = getValue;

/***/ },
/* 3051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _silenceEvent = __webpack_require__(1355);
	
	var _silenceEvent2 = _interopRequireDefault(_silenceEvent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent2.default)(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
	  };
	};
	exports.default = silenceEvents;

/***/ },
/* 3052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _plain = __webpack_require__(114);
	
	var _plain2 = _interopRequireDefault(_plain);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	
	var getError = function getError(value, values, props, validators, name) {
	  var array = toArray(validators);
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props, name);
	    if (error) {
	      return error;
	    }
	  }
	};
	
	var generateValidator = function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name], name);
	      if (error) {
	        errors = _plain2.default.setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	};
	
	exports.default = generateValidator;

/***/ },
/* 3053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isPromise = __webpack_require__(441);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	var _SubmissionError = __webpack_require__(1346);
	
	var _SubmissionError2 = _interopRequireDefault(_SubmissionError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      syncErrors = props.syncErrors,
	      asyncErrors = props.asyncErrors,
	      touch = props.touch,
	      values = props.values,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	
	
	  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched
	
	  if (valid || persistentSubmitErrors) {
	    var doSubmit = function doSubmit() {
	      var result = void 0;
	      try {
	        result = submit(values, dispatch, props);
	      } catch (submitError) {
	        var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      }
	      if ((0, _isPromise2.default)(result)) {
	        startSubmit();
	        return result.then(function (submitResult) {
	          stopSubmit();
	          setSubmitSucceeded();
	          if (onSubmitSuccess) {
	            onSubmitSuccess(submitResult, dispatch, props);
	          }
	          return submitResult;
	        }, function (submitError) {
	          var error = submitError instanceof _SubmissionError2.default ? submitError.errors : undefined;
	          stopSubmit(error);
	          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	          if (onSubmitFail) {
	            onSubmitFail(error, dispatch, submitError, props);
	          }
	          if (error || onSubmitFail) {
	            // if you've provided an onSubmitFail callback, don't re-throw the error
	            return error;
	          } else {
	            throw submitError;
	          }
	        });
	      } else {
	        setSubmitSucceeded();
	        if (onSubmitSuccess) {
	          onSubmitSuccess(result, dispatch, props);
	        }
	      }
	      return result;
	    };
	
	    var asyncValidateResult = asyncValidate && asyncValidate();
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	        return doSubmit();
	      }).catch(function (asyncErrors) {
	        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return doSubmit();
	    }
	  } else {
	    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
	    var errors = _extends({}, asyncErrors, syncErrors);
	    if (onSubmitFail) {
	      onSubmitFail(errors, dispatch, null, props);
	    }
	    return errors;
	  }
	};
	
	exports.default = handleSubmit;

/***/ },
/* 3054 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + '._error'];
	    case 'FieldArray':
	      return [name + '._error'];
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	
	var createHasError = function createHasError(_ref) {
	  var getIn = _ref.getIn;
	
	  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	  return hasError;
	};
	
	exports.default = createHasError;

/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.updateSyncWarnings = exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.resetSection = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearFields = exports.clearSubmitErrors = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.actionTypes = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.getFormError = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.formPropTypes = exports.fieldArrayPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.propTypes = exports.SubmissionError = exports.FormSection = exports.Form = exports.defaultShouldWarn = exports.defaultShouldError = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = undefined;
	
	var _defaultShouldAsyncValidate = __webpack_require__(1349);
	
	Object.defineProperty(exports, 'defaultShouldAsyncValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldAsyncValidate).default;
	  }
	});
	
	var _defaultShouldValidate = __webpack_require__(1351);
	
	Object.defineProperty(exports, 'defaultShouldValidate', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldValidate).default;
	  }
	});
	
	var _defaultShouldError = __webpack_require__(1350);
	
	Object.defineProperty(exports, 'defaultShouldError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldError).default;
	  }
	});
	
	var _defaultShouldWarn = __webpack_require__(1352);
	
	Object.defineProperty(exports, 'defaultShouldWarn', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_defaultShouldWarn).default;
	  }
	});
	
	var _Form = __webpack_require__(3037);
	
	Object.defineProperty(exports, 'Form', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Form).default;
	  }
	});
	
	var _FormSection = __webpack_require__(3038);
	
	Object.defineProperty(exports, 'FormSection', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FormSection).default;
	  }
	});
	
	var _SubmissionError = __webpack_require__(1346);
	
	Object.defineProperty(exports, 'SubmissionError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_SubmissionError).default;
	  }
	});
	
	var _propTypes = __webpack_require__(3080);
	
	Object.defineProperty(exports, 'propTypes', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_propTypes).default;
	  }
	});
	Object.defineProperty(exports, 'fieldInputPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldInputPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldMetaPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldMetaPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldArrayFieldsPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldArrayFieldsPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldArrayMetaPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldArrayMetaPropTypes;
	  }
	});
	Object.defineProperty(exports, 'fieldArrayPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.fieldArrayPropTypes;
	  }
	});
	Object.defineProperty(exports, 'formPropTypes', {
	  enumerable: true,
	  get: function get() {
	    return _propTypes.formPropTypes;
	  }
	});
	
	var _Field = __webpack_require__(3056);
	
	Object.defineProperty(exports, 'Field', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Field).default;
	  }
	});
	
	var _Fields = __webpack_require__(3058);
	
	Object.defineProperty(exports, 'Fields', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Fields).default;
	  }
	});
	
	var _FieldArray = __webpack_require__(3057);
	
	Object.defineProperty(exports, 'FieldArray', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_FieldArray).default;
	  }
	});
	
	var _formValueSelector = __webpack_require__(3059);
	
	Object.defineProperty(exports, 'formValueSelector', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValueSelector).default;
	  }
	});
	
	var _formValues = __webpack_require__(3060);
	
	Object.defineProperty(exports, 'formValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_formValues).default;
	  }
	});
	
	var _getFormError = __webpack_require__(3062);
	
	Object.defineProperty(exports, 'getFormError', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormError).default;
	  }
	});
	
	var _getFormNames = __webpack_require__(3065);
	
	Object.defineProperty(exports, 'getFormNames', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormNames).default;
	  }
	});
	
	var _getFormValues = __webpack_require__(3069);
	
	Object.defineProperty(exports, 'getFormValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormValues).default;
	  }
	});
	
	var _getFormInitialValues = __webpack_require__(3063);
	
	Object.defineProperty(exports, 'getFormInitialValues', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormInitialValues).default;
	  }
	});
	
	var _getFormSyncErrors = __webpack_require__(3067);
	
	Object.defineProperty(exports, 'getFormSyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncErrors).default;
	  }
	});
	
	var _getFormMeta = __webpack_require__(3064);
	
	Object.defineProperty(exports, 'getFormMeta', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormMeta).default;
	  }
	});
	
	var _getFormAsyncErrors = __webpack_require__(3061);
	
	Object.defineProperty(exports, 'getFormAsyncErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormAsyncErrors).default;
	  }
	});
	
	var _getFormSyncWarnings = __webpack_require__(3068);
	
	Object.defineProperty(exports, 'getFormSyncWarnings', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSyncWarnings).default;
	  }
	});
	
	var _getFormSubmitErrors = __webpack_require__(3066);
	
	Object.defineProperty(exports, 'getFormSubmitErrors', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_getFormSubmitErrors).default;
	  }
	});
	
	var _isDirty = __webpack_require__(3072);
	
	Object.defineProperty(exports, 'isDirty', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isDirty).default;
	  }
	});
	
	var _isInvalid = __webpack_require__(3073);
	
	Object.defineProperty(exports, 'isInvalid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isInvalid).default;
	  }
	});
	
	var _isPristine = __webpack_require__(3074);
	
	Object.defineProperty(exports, 'isPristine', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isPristine).default;
	  }
	});
	
	var _isValid = __webpack_require__(3076);
	
	Object.defineProperty(exports, 'isValid', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isValid).default;
	  }
	});
	
	var _isSubmitting = __webpack_require__(3075);
	
	Object.defineProperty(exports, 'isSubmitting', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_isSubmitting).default;
	  }
	});
	
	var _hasSubmitSucceeded = __webpack_require__(3071);
	
	Object.defineProperty(exports, 'hasSubmitSucceeded', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitSucceeded).default;
	  }
	});
	
	var _hasSubmitFailed = __webpack_require__(3070);
	
	Object.defineProperty(exports, 'hasSubmitFailed', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_hasSubmitFailed).default;
	  }
	});
	
	var _reduxForm = __webpack_require__(3078);
	
	Object.defineProperty(exports, 'reduxForm', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reduxForm).default;
	  }
	});
	
	var _reducer = __webpack_require__(3077);
	
	Object.defineProperty(exports, 'reducer', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	
	var _values = __webpack_require__(3079);
	
	Object.defineProperty(exports, 'values', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_values).default;
	  }
	});
	
	var _actions = __webpack_require__(1347);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	var _actionTypes2 = __webpack_require__(544);
	
	var _actionTypes = _interopRequireWildcard(_actionTypes2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var actionTypes = exports.actionTypes = _actionTypes;
	var arrayInsert = exports.arrayInsert = _actions2.default.arrayInsert;
	var arrayMove = exports.arrayMove = _actions2.default.arrayMove;
	var arrayPop = exports.arrayPop = _actions2.default.arrayPop;
	var arrayPush = exports.arrayPush = _actions2.default.arrayPush;
	var arrayRemove = exports.arrayRemove = _actions2.default.arrayRemove;
	var arrayRemoveAll = exports.arrayRemoveAll = _actions2.default.arrayRemoveAll;
	var arrayShift = exports.arrayShift = _actions2.default.arrayShift;
	var arraySplice = exports.arraySplice = _actions2.default.arraySplice;
	var arraySwap = exports.arraySwap = _actions2.default.arraySwap;
	var arrayUnshift = exports.arrayUnshift = _actions2.default.arrayUnshift;
	var autofill = exports.autofill = _actions2.default.autofill;
	var blur = exports.blur = _actions2.default.blur;
	var change = exports.change = _actions2.default.change;
	var clearSubmitErrors = exports.clearSubmitErrors = _actions2.default.clearSubmitErrors;
	var clearFields = exports.clearFields = _actions2.default.clearFields;
	var destroy = exports.destroy = _actions2.default.destroy;
	var focus = exports.focus = _actions2.default.focus;
	var initialize = exports.initialize = _actions2.default.initialize;
	var registerField = exports.registerField = _actions2.default.registerField;
	var reset = exports.reset = _actions2.default.reset;
	var resetSection = exports.resetSection = _actions2.default.resetSection;
	var setSubmitFailed = exports.setSubmitFailed = _actions2.default.setSubmitFailed;
	var setSubmitSucceeded = exports.setSubmitSucceeded = _actions2.default.setSubmitSucceeded;
	var startAsyncValidation = exports.startAsyncValidation = _actions2.default.startAsyncValidation;
	var startSubmit = exports.startSubmit = _actions2.default.startSubmit;
	var stopAsyncValidation = exports.stopAsyncValidation = _actions2.default.stopAsyncValidation;
	var stopSubmit = exports.stopSubmit = _actions2.default.stopSubmit;
	var submit = exports.submit = _actions2.default.submit;
	var touch = exports.touch = _actions2.default.touch;
	var unregisterField = exports.unregisterField = _actions2.default.unregisterField;
	var untouch = exports.untouch = _actions2.default.untouch;
	var updateSyncWarnings = exports.updateSyncWarnings = _actions2.default.updateSyncWarnings;

/***/ },
/* 3056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createField = __webpack_require__(3040);
	
	var _createField2 = _interopRequireDefault(_createField);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createField2.default)(_immutable2.default);

/***/ },
/* 3057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFieldArray = __webpack_require__(3041);
	
	var _createFieldArray2 = _interopRequireDefault(_createFieldArray);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFieldArray2.default)(_immutable2.default);

/***/ },
/* 3058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFields = __webpack_require__(3043);
	
	var _createFields2 = _interopRequireDefault(_createFields);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFields2.default)(_immutable2.default);

/***/ },
/* 3059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValueSelector = __webpack_require__(3044);
	
	var _createFormValueSelector2 = _interopRequireDefault(_createFormValueSelector);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValueSelector2.default)(_immutable2.default);

/***/ },
/* 3060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createFormValues = __webpack_require__(3045);
	
	var _createFormValues2 = _interopRequireDefault(_createFormValues);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createFormValues2.default)(_immutable2.default);

/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormAsyncErrors = __webpack_require__(3081);
	
	var _getFormAsyncErrors2 = _interopRequireDefault(_getFormAsyncErrors);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormAsyncErrors2.default)(_immutable2.default);

/***/ },
/* 3062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormError = __webpack_require__(3082);
	
	var _getFormError2 = _interopRequireDefault(_getFormError);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormError2.default)(_immutable2.default);

/***/ },
/* 3063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormInitialValues = __webpack_require__(3083);
	
	var _getFormInitialValues2 = _interopRequireDefault(_getFormInitialValues);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormInitialValues2.default)(_immutable2.default);

/***/ },
/* 3064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormMeta = __webpack_require__(3084);
	
	var _getFormMeta2 = _interopRequireDefault(_getFormMeta);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormMeta2.default)(_immutable2.default);

/***/ },
/* 3065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormNames = __webpack_require__(3085);
	
	var _getFormNames2 = _interopRequireDefault(_getFormNames);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormNames2.default)(_immutable2.default);

/***/ },
/* 3066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSubmitErrors = __webpack_require__(3086);
	
	var _getFormSubmitErrors2 = _interopRequireDefault(_getFormSubmitErrors);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSubmitErrors2.default)(_immutable2.default);

/***/ },
/* 3067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncErrors = __webpack_require__(3087);
	
	var _getFormSyncErrors2 = _interopRequireDefault(_getFormSyncErrors);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncErrors2.default)(_immutable2.default);

/***/ },
/* 3068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormSyncWarnings = __webpack_require__(3088);
	
	var _getFormSyncWarnings2 = _interopRequireDefault(_getFormSyncWarnings);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormSyncWarnings2.default)(_immutable2.default);

/***/ },
/* 3069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getFormValues = __webpack_require__(3089);
	
	var _getFormValues2 = _interopRequireDefault(_getFormValues);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _getFormValues2.default)(_immutable2.default);

/***/ },
/* 3070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitFailed = __webpack_require__(3090);
	
	var _hasSubmitFailed2 = _interopRequireDefault(_hasSubmitFailed);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitFailed2.default)(_immutable2.default);

/***/ },
/* 3071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hasSubmitSucceeded = __webpack_require__(3091);
	
	var _hasSubmitSucceeded2 = _interopRequireDefault(_hasSubmitSucceeded);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _hasSubmitSucceeded2.default)(_immutable2.default);

/***/ },
/* 3072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isDirty = __webpack_require__(3092);
	
	var _isDirty2 = _interopRequireDefault(_isDirty);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isDirty2.default)(_immutable2.default);

/***/ },
/* 3073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isInvalid = __webpack_require__(3093);
	
	var _isInvalid2 = _interopRequireDefault(_isInvalid);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isInvalid2.default)(_immutable2.default);

/***/ },
/* 3074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(1357);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isPristine2.default)(_immutable2.default);

/***/ },
/* 3075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isSubmitting = __webpack_require__(3094);
	
	var _isSubmitting2 = _interopRequireDefault(_isSubmitting);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isSubmitting2.default)(_immutable2.default);

/***/ },
/* 3076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(545);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _isValid2.default)(_immutable2.default);

/***/ },
/* 3077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReducer = __webpack_require__(3046);
	
	var _createReducer2 = _interopRequireDefault(_createReducer);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReducer2.default)(_immutable2.default);

/***/ },
/* 3078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReduxForm = __webpack_require__(3047);
	
	var _createReduxForm2 = _interopRequireDefault(_createReduxForm);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createReduxForm2.default)(_immutable2.default);

/***/ },
/* 3079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createValues = __webpack_require__(3048);
	
	var _createValues2 = _interopRequireDefault(_createValues);
	
	var _immutable = __webpack_require__(41);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createValues2.default)(_immutable2.default);

/***/ },
/* 3080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fieldArrayPropTypes = exports.fieldPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = undefined;
	
	var _propTypes = __webpack_require__(93);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var any = _propTypes2.default.any,
	    bool = _propTypes2.default.bool,
	    func = _propTypes2.default.func,
	    shape = _propTypes2.default.shape,
	    string = _propTypes2.default.string,
	    oneOfType = _propTypes2.default.oneOfType,
	    object = _propTypes2.default.object,
	    number = _propTypes2.default.number;
	var formPropTypes = exports.formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired, // true if any values are different from initialValues
	  error: any, // form-wide error from '_error' key in validation result
	  form: string.isRequired, // the name of the form
	  invalid: bool.isRequired, // true if there are any validation errors
	  initialized: bool.isRequired, // true if the form has been initialized
	  initialValues: object, // the initialValues object passed to reduxForm
	  pristine: bool.isRequired, // true if the values are the same as initialValues
	  pure: bool.isRequired, // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired, // true if the form is in the process of being submitted
	  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
	  valid: bool.isRequired, // true if there are no validation errors
	  warning: any, // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired, // function to insert a value into an array field
	    move: func.isRequired, // function to move a value within an array field
	    pop: func.isRequired, // function to pop a value off of an array field
	    push: func.isRequired, // function to push a value onto an array field
	    remove: func.isRequired, // function to remove a value from an array field
	    removeAll: func.isRequired, // function to remove all the values from an array field
	    shift: func.isRequired, // function to shift a value out of an array field
	    splice: func.isRequired, // function to splice a value into an array field
	    swap: func.isRequired, // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	  }),
	  asyncValidate: func.isRequired, // function to trigger async validation
	  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired, // action to mark a field as blurred
	  change: func.isRequired, // action to change the value of a field
	  clearAsyncError: func.isRequired, // action to clear the async error of a field
	  clearFields: func.isRequired, // action to clean fields values for all fields
	  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
	  destroy: func.isRequired, // action to destroy the form's data in Redux
	  dispatch: func.isRequired, // the Redux dispatch action
	  handleSubmit: func.isRequired, // function to submit the form
	  initialize: func.isRequired, // action to initialize form data
	  reset: func.isRequired, // action to reset the form data to previously initialized values
	  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
	  touch: func.isRequired, // action to mark fields as touched
	  submit: func.isRequired, // action to trigger a submission of the specified form
	  untouch: func.isRequired, // action to mark fields as untouched
	
	  // triggerSubmit
	  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	};
	
	var fieldInputPropTypes = exports.fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	
	var fieldMetaPropTypes = exports.fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	
	var fieldArrayMetaPropTypes = exports.fieldArrayMetaPropTypes = {
	  dirty: bool.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitFailed: bool,
	  submitting: bool,
	  valid: bool.isRequired,
	  warning: string
	};
	
	var fieldArrayFieldsPropTypes = exports.fieldArrayFieldsPropTypes = {
	  name: string.isRequired,
	  forEach: func.isRequired,
	  get: func.isRequired,
	  getAll: func.isRequired,
	  insert: func.isRequired,
	  length: number.isRequired,
	  map: func.isRequired,
	  move: func.isRequired,
	  pop: func.isRequired,
	  push: func.isRequired,
	  reduce: func.isRequired,
	  remove: func.isRequired,
	  removeAll: func.isRequired,
	  shift: func.isRequired,
	  swap: func.isRequired,
	  unshift: func.isRequired
	};
	
	var fieldPropTypes = exports.fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired
	};
	
	var fieldArrayPropTypes = exports.fieldArrayPropTypes = {
	  fields: shape(fieldArrayFieldsPropTypes).isRequired,
	  meta: shape(fieldArrayMetaPropTypes).isRequired
	};
	
	exports.default = formPropTypes;

/***/ },
/* 3081 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
	    };
	  };
	};
	
	exports.default = createGetFormAsyncErrors;

/***/ },
/* 3082 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormError = function createGetFormError(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.error');
	    };
	  };
	};
	
	exports.default = createGetFormError;

/***/ },
/* 3083 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.initial');
	    };
	  };
	};
	
	exports.default = createGetFormInitialValues;

/***/ },
/* 3084 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormMeta = function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
	    };
	  };
	};
	
	exports.default = createGetFormMeta;

/***/ },
/* 3085 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return keys(nonNullGetFormState(state));
	    };
	  };
	}
	
	exports.default = createGetFormNames;

/***/ },
/* 3086 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
	    };
	  };
	};
	
	exports.default = createGetFormSubmitErrors;

/***/ },
/* 3087 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
	    };
	  };
	};
	
	exports.default = createGetFormSyncErrors;

/***/ },
/* 3088 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
	    };
	  };
	};
	
	exports.default = createGetFormSyncWarnings;

/***/ },
/* 3089 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createGetFormValues = function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return getIn(nonNullGetFormState(state), form + '.values');
	    };
	  };
	};
	
	exports.default = createGetFormValues;

/***/ },
/* 3090 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
	    };
	  };
	};
	
	exports.default = createHasSubmitFailed;

/***/ },
/* 3091 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
	    };
	  };
	};
	
	exports.default = createHasSubmitSucceeded;

/***/ },
/* 3092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isPristine = __webpack_require__(1357);
	
	var _isPristine2 = _interopRequireDefault(_isPristine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsDirty = function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isPristine(state);
	    };
	  };
	};
	exports.default = createIsDirty;

/***/ },
/* 3093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isValid = __webpack_require__(545);
	
	var _isValid2 = _interopRequireDefault(_isValid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createIsInvalid = function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid2.default)(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	};
	exports.default = createIsInvalid;

/***/ },
/* 3094 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var createIsSubmitting = function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	      return !!getIn(nonNullGetFormState(state), form + '.submitting');
	    };
	  };
	};
	
	exports.default = createIsSubmitting;

/***/ },
/* 3095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(552);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	var _immutable = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	  if (!obj && !other) {
	    var objIsEmpty = obj === null || obj === undefined || obj === '';
	    var otherIsEmpty = other === null || other === undefined || other === '';
	    return objIsEmpty === otherIsEmpty;
	  }
	
	  if (_immutable.Iterable.isIterable(obj) && _immutable.Iterable.isIterable(other)) {
	    return obj.count() === other.count() && obj.every(function (value, key) {
	      return other.has(key) && (0, _isEqualWith3.default)(value, other.get(key), customizer);
	    });
	  }
	
	  return void 0;
	};
	
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 3096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(35);
	
	var _keys = __webpack_require__(1359);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var empty = (0, _immutable.List)();
	
	var keys = function keys(value) {
	  if (_immutable.List.isList(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  if (_immutable.Iterable.isIterable(value)) {
	    return value.keySeq();
	  }
	
	  return value ? (0, _immutable.List)((0, _keys2.default)(value)) : empty;
	};
	
	exports.default = keys;

/***/ },
/* 3097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(209);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	exports.default = setIn;
	
	var _immutable = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrayPattern = /\[(\d+)\]/;
	
	
	var undefinedArrayMerge = function undefinedArrayMerge(previous, next) {
	  return next !== undefined ? next : previous;
	};
	
	var mergeLists = function mergeLists(originalList, value) {
	  if (originalList && _immutable.List.isList(originalList)) {
	    return originalList.map(function (originalListValue, index) {
	      return undefinedArrayMerge(value.get(index), originalListValue);
	    }).concat(value.slice(originalList.size));
	  }
	
	  return value;
	};
	
	/*
	 * ImmutableJS' setIn function doesn't support array (List) creation
	 * so we must pre-insert all arrays in the path ahead of time.
	 * 
	 * Additionally we must also pre-set a dummy Map at the location
	 * of an array index if there's parts that come afterwards because 
	 * the setIn function uses `{}` to mark an unset value instead of 
	 * undefined (which is the case for list / arrays).
	 */
	function setIn(state, field, value) {
	  var path = (0, _toPath3.default)(field);
	  if (!field || typeof field !== 'string' || !arrayPattern.test(field)) {
	    return state.setIn(path, value);
	  }
	
	  return state.withMutations(function (mutable) {
	    var _loop = function _loop(pathIndex) {
	      var nextPart = path[pathIndex + 1];
	      if (isNaN(nextPart)) {
	        return 'continue';
	      }
	
	      mutable = mutable.updateIn(path.slice(0, pathIndex + 1), function (value) {
	        return mergeLists(value, new _immutable.List().set(parseInt(nextPart, 10), new _immutable.Map()));
	      });
	    };
	
	    for (var pathIndex = 0; pathIndex < path.length - 1; ++pathIndex) {
	      var _ret = _loop(pathIndex);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return mutable.setIn(path, value);
	  });
	}

/***/ },
/* 3098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(35);
	
	exports.default = function (list, index, removeNum, value) {
	  list = _immutable.List.isList(list) ? list : (0, _immutable.List)();
	
	  if (index < list.count()) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      // first insert true and then re-set it to undefined
	      return list.splice(index, 0, true) // placeholder
	      .set(index, undefined);
	    }
	    if (value != null) {
	      return list.splice(index, removeNum, value); // removing and adding
	    } else {
	      return list.splice(index, removeNum); // removing
	    }
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return list;
	  }
	  // trying to add outside of range: just set value
	  return list.set(index, value);
	};

/***/ },
/* 3099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isEqualWith2 = __webpack_require__(552);
	
	var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	
	  if (!obj && !other) {
	    var objIsEmpty = obj === null || obj === undefined || obj === '';
	    var otherIsEmpty = other === null || other === undefined || other === '';
	    return objIsEmpty === otherIsEmpty;
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	  if (_react2.default.isValidElement(obj) || _react2.default.isValidElement(other)) return false;
	};
	
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith3.default)(a, b, customizer);
	};
	
	exports.default = deepEqual;

/***/ },
/* 3100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(209);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
	      }
	      var firstIndex = Number(first);
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(_toConsumableArray(state));
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	      return state;
	    }
	    if (first in state) {
	      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
	      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
	    }
	    return state;
	  }
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
	    }
	    var _firstIndex = Number(first);
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(_toConsumableArray(state));
	      _copy.splice(_firstIndex, 1);
	      return _copy;
	    }
	    return state;
	  }
	  if (first in state) {
	    var _copy2 = _extends({}, state);
	    delete _copy2[first];
	    return _copy2;
	  }
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray((0, _toPath3.default)(field))));
	};
	
	exports.default = deleteIn;

/***/ },
/* 3101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toPath2 = __webpack_require__(209);
	
	var _toPath3 = _interopRequireDefault(_toPath2);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      return _defineProperty({}, first, next);
	    }
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return _extends({}, state, _defineProperty({}, first, next));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath3.default)(field), 0);
	};
	
	exports.default = setIn;

/***/ },
/* 3102 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(_toConsumableArray(array));
	      _copy2.splice(index, 0, true); // temporary placeholder
	      _copy2[index] = undefined; // set to undefined
	      return _copy2;
	    }
	    if (value != null) {
	      var _copy3 = [].concat(_toConsumableArray(array));
	      _copy3.splice(index, removeNum, value); // removing and adding
	      return _copy3;
	    }
	    var _copy = [].concat(_toConsumableArray(array));
	    _copy.splice(index, removeNum); // removing
	    return _copy;
	  }
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  }
	  // trying to add outside of range: just set value
	  var copy = [].concat(_toConsumableArray(array));
	  copy[index] = value;
	  return copy;
	};
	
	exports.default = splice;

/***/ },
/* 3103 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var dataKey = exports.dataKey = 'text';

/***/ },
/* 3104 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	exports.default = getDisplayName;

/***/ },
/* 3105 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var isHotReloading = function isHotReloading() {
	  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
	};
	
	exports.default = isHotReloading;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 3106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ },
/* 3107 */
[3450, 166, 104],
/* 3108 */
[3451, 3156, 3157, 3158, 3159, 3160],
/* 3109 */
[3455, 166, 104],
/* 3110 */
[3456, 166, 104],
/* 3111 */
[3457, 547, 3182, 3183],
/* 3112 */
[3461, 166, 104],
/* 3113 */
2333,
/* 3114 */
977,
/* 3115 */
980,
/* 3116 */
2337,
/* 3117 */
[3463, 365, 263],
/* 3118 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(140);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 3119 */
[3467, 1365, 555],
/* 3120 */
[3469, 3115, 92],
/* 3121 */
2348,
/* 3122 */
[3471, 208, 167],
/* 3123 */
[3473, 548, 1371, 3148, 3149, 1374, 92, 371, 373],
/* 3124 */
[3474, 548, 366],
/* 3125 */
[3475, 553, 3164, 140, 1380],
/* 3126 */
[3476, 208, 554, 167],
/* 3127 */
[3477, 3129, 3130, 551, 92, 3201],
/* 3128 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(140),
	    isPrototype = __webpack_require__(368),
	    nativeKeysIn = __webpack_require__(3178);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 3129 */
[3479, 3124, 3151, 1376],
/* 3130 */
[3480, 366, 3193, 3194, 550, 1375, 1376, 262],
/* 3131 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(548),
	    assignMergeValue = __webpack_require__(1364),
	    baseFor = __webpack_require__(1365),
	    baseMergeDeep = __webpack_require__(3132),
	    isObject = __webpack_require__(140),
	    keysIn = __webpack_require__(1381),
	    safeGet = __webpack_require__(1378);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 3132 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(1364),
	    cloneBuffer = __webpack_require__(3142),
	    cloneTypedArray = __webpack_require__(3143),
	    copyArray = __webpack_require__(1369),
	    initCloneObject = __webpack_require__(3161),
	    isArguments = __webpack_require__(370),
	    isArray = __webpack_require__(92),
	    isArrayLikeObject = __webpack_require__(3195),
	    isBuffer = __webpack_require__(371),
	    isFunction = __webpack_require__(553),
	    isObject = __webpack_require__(140),
	    isPlainObject = __webpack_require__(3198),
	    isTypedArray = __webpack_require__(373),
	    safeGet = __webpack_require__(1378),
	    toPlainObject = __webpack_require__(3204);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 3133 */
2359,
/* 3134 */
[3481, 1366],
/* 3135 */
[3482, 551, 3181, 3185],
/* 3136 */
[3483, 3192, 1370, 551],
/* 3137 */
2366,
/* 3138 */
[3484, 363, 1363, 92, 372],
/* 3139 */
313,
/* 3140 */
455,
/* 3141 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(1361);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 3142 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(104);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 3143 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(3141);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 3144 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(3117),
	    baseAssignValue = __webpack_require__(365);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 3145 */
[3486, 104],
/* 3146 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(3135),
	    isIterateeCall = __webpack_require__(3162);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 3147 */
2376,
/* 3148 */
[3489, 363, 1361, 263, 1371, 3175, 3184],
/* 3149 */
[3490, 3150],
/* 3150 */
[3491, 3120, 3153, 555],
/* 3151 */
[3493, 1375, 555],
/* 3152 */
[3496, 363],
/* 3153 */
[3497, 3114, 3202],
/* 3154 */
2387,
/* 3155 */
[3499, 1368, 370, 92, 549, 554, 262],
/* 3156 */
[3500, 369],
/* 3157 */
2390,
/* 3158 */
[3501, 369],
/* 3159 */
[3502, 369],
/* 3160 */
[3503, 369],
/* 3161 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(3118),
	    getPrototype = __webpack_require__(1373),
	    isPrototype = __webpack_require__(368);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 3162 */
[3504, 263, 264, 549, 140],
/* 3163 */
2395,
/* 3164 */
[3506, 3145],
/* 3165 */
2398,
/* 3166 */
[3508, 364],
/* 3167 */
[3509, 364],
/* 3168 */
[3510, 364],
/* 3169 */
[3511, 364],
/* 3170 */
[3512, 3108, 362, 546],
/* 3171 */
[3513, 367],
/* 3172 */
[3514, 367],
/* 3173 */
[3515, 367],
/* 3174 */
[3516, 367],
/* 3175 */
995,
/* 3176 */
[3517, 3199],
/* 3177 */
[3519, 1377],
/* 3178 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 3179 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1372);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 3180 */
2411,
/* 3181 */
[3520, 3113],
/* 3182 */
2412,
/* 3183 */
2413,
/* 3184 */
999,
/* 3185 */
[3522, 3136, 3186],
/* 3186 */
2414,
/* 3187 */
[3523, 362],
/* 3188 */
2416,
/* 3189 */
2417,
/* 3190 */
2418,
/* 3191 */
[3524, 362, 546, 547],
/* 3192 */
2425,
/* 3193 */
[3526, 1366],
/* 3194 */
[3527, 3121, 3155],
/* 3195 */
[3530, 264, 167],
/* 3196 */
[3532, 1367, 1374, 370, 92, 264, 371, 368, 373],
/* 3197 */
[3533, 366],
/* 3198 */
[3535, 208, 1373, 167],
/* 3199 */
[3540, 547],
/* 3200 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(3131),
	    createAssigner = __webpack_require__(3146);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 3201 */
[3542, 3133, 3134, 550, 262],
/* 3202 */
2447,
/* 3203 */
2448,
/* 3204 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(3144),
	    keysIn = __webpack_require__(1381);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 3205 */
[3545, 3206],
/* 3206 */
1144,
/* 3207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(35);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _utilities = __webpack_require__(3210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (reducers) {
	  var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _immutable2.default.Map;
	
	  var reducerKeys = Object.keys(reducers);
	
	  // eslint-disable-next-line space-infix-ops
	  return function () {
	    var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
	    var action = arguments[1];
	
	    // eslint-disable-next-line no-process-env
	    if (false) {
	      var warningMessage = (0, _utilities.getUnexpectedInvocationParameterMessage)(inputState, reducers, action);
	
	      if (warningMessage) {
	        // eslint-disable-next-line no-console
	        console.error(warningMessage);
	      }
	    }
	
	    return inputState.withMutations(function (temporaryState) {
	      reducerKeys.forEach(function (reducerName) {
	        var reducer = reducers[reducerName];
	        var currentDomainState = temporaryState.get(reducerName);
	        var nextDomainState = reducer(currentDomainState, action);
	
	        (0, _utilities.validateNextState)(nextDomainState, reducerName, action);
	
	        temporaryState.set(reducerName, nextDomainState);
	      });
	    });
	  };
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=combineReducers.js.map

/***/ },
/* 3208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.combineReducers = undefined;
	
	var _combineReducers2 = __webpack_require__(3207);
	
	var _combineReducers3 = _interopRequireDefault(_combineReducers2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.combineReducers = _combineReducers3.default;
	//# sourceMappingURL=index.js.map

/***/ },
/* 3209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _immutable = __webpack_require__(35);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _getStateName = __webpack_require__(1383);
	
	var _getStateName2 = _interopRequireDefault(_getStateName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (state, reducers, action) {
	  var reducerNames = Object.keys(reducers);
	
	  if (!reducerNames.length) {
	    return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
	  }
	
	  var stateName = (0, _getStateName2.default)(action);
	
	  if (_immutable2.default.isImmutable ? !_immutable2.default.isImmutable(state) : !_immutable2.default.Iterable.isIterable(state)) {
	    return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "' + reducerNames.join('", "') + '".';
	  }
	
	  var unexpectedStatePropertyNames = state.toSeq().keySeq().toArray().filter(function (name) {
	    return !reducers.hasOwnProperty(name);
	  });
	
	  if (unexpectedStatePropertyNames.length > 0) {
	    return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
	  }
	
	  return null;
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=getUnexpectedInvocationParameterMessage.js.map

/***/ },
/* 3210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validateNextState = exports.getUnexpectedInvocationParameterMessage = exports.getStateName = undefined;
	
	var _getStateName2 = __webpack_require__(1383);
	
	var _getStateName3 = _interopRequireDefault(_getStateName2);
	
	var _getUnexpectedInvocationParameterMessage2 = __webpack_require__(3209);
	
	var _getUnexpectedInvocationParameterMessage3 = _interopRequireDefault(_getUnexpectedInvocationParameterMessage2);
	
	var _validateNextState2 = __webpack_require__(3211);
	
	var _validateNextState3 = _interopRequireDefault(_validateNextState2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.getStateName = _getStateName3.default;
	exports.getUnexpectedInvocationParameterMessage = _getUnexpectedInvocationParameterMessage3.default;
	exports.validateNextState = _validateNextState3.default;
	//# sourceMappingURL=index.js.map

/***/ },
/* 3211 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nextState, reducerName, action) {
	  // eslint-disable-next-line no-undefined
	  if (nextState === undefined) {
	    throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
	  }
	};
	
	module.exports = exports['default'];
	//# sourceMappingURL=validateNextState.js.map

/***/ },
/* 3212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports._stateInit = undefined;
	exports._stateIterator = _stateIterator;
	exports._stateGetter = _stateGetter;
	exports._stateSetter = _stateSetter;
	
	var _immutable = __webpack_require__(35);
	
	var _stateInit = exports._stateInit = new _immutable.Map();
	
	function _stateIterator(state, callback) {
	  return state.forEach(callback);
	}
	
	function _stateGetter(state, key) {
	  return state.get(key);
	}
	
	function _stateSetter(state, key, value) {
	  return state.set(key, value);
	}

/***/ },
/* 3213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.stateReconciler = stateReconciler;
	
	var _immutable = __webpack_require__(35);
	
	function stateReconciler(state, inboundState, reducedState, logger) {
	  var newState = reducedState ? reducedState : (0, _immutable.Map)();
	
	  Object.keys(inboundState).forEach(function (key) {
	    // if initialState does not have key, skip auto rehydration
	    if (!state.has(key)) return;
	
	    // if reducer modifies substate, skip auto rehydration
	    if (state.get(key) !== reducedState.get(key)) {
	      if (logger) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
	      newState = newState.set(key, reducedState.get(key));
	      return;
	    }
	
	    // otherwise take the inboundState
	    if (state.has(key)) {
	      newState = newState.mergeIn([key], inboundState[key]); // shallow merge
	    } else {
	      newState = newState.set(key, inboundState[key]); // hard set
	    }
	
	    if (logger) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState.get(key));
	  });
	
	  return newState;
	}

/***/ },
/* 3214 */
[3547, 265, 3218],
/* 3215 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function createTransform(inbound, outbound) {
	  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var whitelist = config.whitelist || null;
	  var blacklist = config.blacklist || null;
	
	  function whitelistBlacklistCheck(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return true;
	    if (blacklist && blacklist.indexOf(key) !== -1) return true;
	    return false;
	  }
	
	  return {
	    in: function _in(state, key) {
	      return !whitelistBlacklistCheck(key) && inbound ? inbound(state, key) : state;
	    },
	    out: function out(state, key) {
	      return !whitelistBlacklistCheck(key) && outbound ? outbound(state, key) : state;
	    }
	  };
	}
	
	exports.default = createTransform;

/***/ },
/* 3216 */
[3551, 3214, 1385, 3215, 1387, 3217, 1388],
/* 3217 */
[3552, 265, 1387, 1385, 1389],
/* 3218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isStatePlainEnough;
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isStatePlainEnough(a) {
	  // isPlainObject + duck type not immutable
	  if (!a) return false;
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) !== 'object') return false;
	  if (typeof a.asMutable === 'function') return false;
	  if (!(0, _isPlainObject2.default)(a)) return false;
	  return true;
	}

/***/ },
/* 3219 */
/***/ function(module, exports, __webpack_require__) {

	var transit = __webpack_require__(3292)
	var reduxPersist = __webpack_require__(3222)
	
	module.exports = function (config) {
	  config = config || {}
	
	  var transitInstance = transit
	  if (config.records) {
	    transitInstance = transit.withRecords(config.records)
	  }
	
	  return reduxPersist.createTransform(
	    function(state){
	      return transitInstance.toJSON(state)
	    },
	    function(raw){
	      return transitInstance.fromJSON(raw)
	    },
	    config
	  )
	}


/***/ },
/* 3220 */
[3547, 266, 3224],
/* 3221 */
3215,
/* 3222 */
[3551, 3220, 1390, 3221, 1392, 3223, 1393],
/* 3223 */
[3552, 266, 1392, 1390, 1394],
/* 3224 */
3218,
/* 3225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.utils = exports.effects = exports.detach = exports.CANCEL = exports.delay = exports.throttle = exports.takeLatest = exports.takeEvery = exports.buffers = exports.channel = exports.eventChannel = exports.END = exports.runSaga = undefined;
	
	var _runSaga = /*#__PURE__*/__webpack_require__(1396);
	
	Object.defineProperty(exports, 'runSaga', {
	  enumerable: true,
	  get: function get() {
	    return _runSaga.runSaga;
	  }
	});
	
	var _channel = /*#__PURE__*/__webpack_require__(210);
	
	Object.defineProperty(exports, 'END', {
	  enumerable: true,
	  get: function get() {
	    return _channel.END;
	  }
	});
	Object.defineProperty(exports, 'eventChannel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.eventChannel;
	  }
	});
	Object.defineProperty(exports, 'channel', {
	  enumerable: true,
	  get: function get() {
	    return _channel.channel;
	  }
	});
	
	var _buffers = /*#__PURE__*/__webpack_require__(374);
	
	Object.defineProperty(exports, 'buffers', {
	  enumerable: true,
	  get: function get() {
	    return _buffers.buffers;
	  }
	});
	
	var _sagaHelpers = /*#__PURE__*/__webpack_require__(1397);
	
	Object.defineProperty(exports, 'takeEvery', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeEvery;
	  }
	});
	Object.defineProperty(exports, 'takeLatest', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.takeLatest;
	  }
	});
	Object.defineProperty(exports, 'throttle', {
	  enumerable: true,
	  get: function get() {
	    return _sagaHelpers.throttle;
	  }
	});
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	Object.defineProperty(exports, 'delay', {
	  enumerable: true,
	  get: function get() {
	    return _utils.delay;
	  }
	});
	Object.defineProperty(exports, 'CANCEL', {
	  enumerable: true,
	  get: function get() {
	    return _utils.CANCEL;
	  }
	});
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	Object.defineProperty(exports, 'detach', {
	  enumerable: true,
	  get: function get() {
	    return _io.detach;
	  }
	});
	
	var _middleware = /*#__PURE__*/__webpack_require__(3226);
	
	var _middleware2 = /*#__PURE__*/_interopRequireDefault(_middleware);
	
	var _effects = /*#__PURE__*/__webpack_require__(557);
	
	var effects = /*#__PURE__*/_interopRequireWildcard(_effects);
	
	var _utils2 = /*#__PURE__*/__webpack_require__(3230);
	
	var utils = /*#__PURE__*/_interopRequireWildcard(_utils2);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _middleware2.default;
	exports.effects = effects;
	exports.utils = utils;

/***/ },
/* 3226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = sagaMiddlewareFactory;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	var _channel = /*#__PURE__*/__webpack_require__(210);
	
	var _runSaga = /*#__PURE__*/__webpack_require__(1396);
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function sagaMiddlewareFactory() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var _ref$context = _ref.context,
	      context = _ref$context === undefined ? {} : _ref$context,
	      options = _objectWithoutProperties(_ref, ['context']);
	
	  var sagaMonitor = options.sagaMonitor,
	      logger = options.logger,
	      onError = options.onError;
	
	
	  if (_utils.is.func(options)) {
	    if (true) {
	      throw new Error('Saga middleware no longer accept Generator functions. Use sagaMiddleware.run instead');
	    } else {
	      throw new Error('You passed a function to the Saga middleware. You are likely trying to start a        Saga by directly passing it to the middleware. This is no longer possible starting from 0.10.0.        To run a Saga, you must do it dynamically AFTER mounting the middleware into the store.\n        Example:\n          import createSagaMiddleware from \'redux-saga\'\n          ... other imports\n\n          const sagaMiddleware = createSagaMiddleware()\n          const store = createStore(reducer, applyMiddleware(sagaMiddleware))\n          sagaMiddleware.run(saga, ...args)\n      ');
	    }
	  }
	
	  if (logger && !_utils.is.func(logger)) {
	    throw new Error('`options.logger` passed to the Saga middleware is not a function!');
	  }
	
	  if (false) {
	    throw new Error('`options.onerror` was removed. Use `options.onError` instead.');
	  }
	
	  if (onError && !_utils.is.func(onError)) {
	    throw new Error('`options.onError` passed to the Saga middleware is not a function!');
	  }
	
	  if (options.emitter && !_utils.is.func(options.emitter)) {
	    throw new Error('`options.emitter` passed to the Saga middleware is not a function!');
	  }
	
	  function sagaMiddleware(_ref2) {
	    var getState = _ref2.getState,
	        dispatch = _ref2.dispatch;
	
	    var sagaEmitter = (0, _channel.emitter)();
	    sagaEmitter.emit = (options.emitter || _utils.ident)(sagaEmitter.emit);
	
	    sagaMiddleware.run = _runSaga.runSaga.bind(null, {
	      context: context,
	      subscribe: sagaEmitter.subscribe,
	      dispatch: dispatch,
	      getState: getState,
	      sagaMonitor: sagaMonitor,
	      logger: logger,
	      onError: onError
	    });
	
	    return function (next) {
	      return function (action) {
	        if (sagaMonitor && sagaMonitor.actionDispatched) {
	          sagaMonitor.actionDispatched(action);
	        }
	        var result = next(action); // hit reducers
	        sagaEmitter.emit(action);
	        return result;
	      };
	    };
	  }
	
	  sagaMiddleware.run = function () {
	    throw new Error('Before running a Saga, you must mount the Saga middleware on the Store using applyMiddleware');
	  };
	
	  sagaMiddleware.setContext = function (props) {
	    (0, _utils.check)(props, _utils.is.object, (0, _utils.createSetContextWarning)('sagaMiddleware', props));
	    _utils.object.assign(context, props);
	  };
	
	  return sagaMiddleware;
	}

/***/ },
/* 3227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeEvery;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__(558);
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	var _channel = /*#__PURE__*/__webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeEvery(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	
	  var action = void 0,
	      setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q1', yFork(action)];
	    }
	  }, 'q1', 'takeEvery(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 3228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = takeLatest;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__(558);
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	var _channel = /*#__PURE__*/__webpack_require__(210);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function takeLatest(patternOrChannel, worker) {
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  var yTake = { done: false, value: (0, _io.take)(patternOrChannel) };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yCancel = function yCancel(task) {
	    return { done: false, value: (0, _io.cancel)(task) };
	  };
	
	  var task = void 0,
	      action = void 0;
	  var setTask = function setTask(t) {
	    return task = t;
	  };
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yTake, setAction];
	    },
	    q2: function q2() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : task ? ['q3', yCancel(task)] : ['q1', yFork(action), setTask];
	    },
	    q3: function q3() {
	      return ['q1', yFork(action), setTask];
	    }
	  }, 'q1', 'takeLatest(' + (0, _fsmIterator.safeName)(patternOrChannel) + ', ' + worker.name + ')');
	}

/***/ },
/* 3229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = throttle;
	
	var _fsmIterator = /*#__PURE__*/__webpack_require__(558);
	
	var _fsmIterator2 = /*#__PURE__*/_interopRequireDefault(_fsmIterator);
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	var _channel = /*#__PURE__*/__webpack_require__(210);
	
	var _buffers = /*#__PURE__*/__webpack_require__(374);
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function throttle(delayLength, pattern, worker) {
	  for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    args[_key - 3] = arguments[_key];
	  }
	
	  var action = void 0,
	      channel = void 0;
	
	  var yActionChannel = { done: false, value: (0, _io.actionChannel)(pattern, _buffers.buffers.sliding(1)) };
	  var yTake = function yTake() {
	    return { done: false, value: (0, _io.take)(channel) };
	  };
	  var yFork = function yFork(ac) {
	    return { done: false, value: _io.fork.apply(undefined, [worker].concat(args, [ac])) };
	  };
	  var yDelay = { done: false, value: (0, _io.call)(_utils.delay, delayLength) };
	
	  var setAction = function setAction(ac) {
	    return action = ac;
	  };
	  var setChannel = function setChannel(ch) {
	    return channel = ch;
	  };
	
	  return (0, _fsmIterator2.default)({
	    q1: function q1() {
	      return ['q2', yActionChannel, setChannel];
	    },
	    q2: function q2() {
	      return ['q3', yTake(), setAction];
	    },
	    q3: function q3() {
	      return action === _channel.END ? [_fsmIterator.qEnd] : ['q4', yFork(action)];
	    },
	    q4: function q4() {
	      return ['q2', yDelay];
	    }
	  }, 'q1', 'throttle(' + (0, _fsmIterator.safeName)(pattern) + ', ' + worker.name + ')');
	}

/***/ },
/* 3230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = /*#__PURE__*/__webpack_require__(94);
	
	Object.defineProperty(exports, 'TASK', {
	  enumerable: true,
	  get: function get() {
	    return _utils.TASK;
	  }
	});
	Object.defineProperty(exports, 'SAGA_ACTION', {
	  enumerable: true,
	  get: function get() {
	    return _utils.SAGA_ACTION;
	  }
	});
	Object.defineProperty(exports, 'noop', {
	  enumerable: true,
	  get: function get() {
	    return _utils.noop;
	  }
	});
	Object.defineProperty(exports, 'is', {
	  enumerable: true,
	  get: function get() {
	    return _utils.is;
	  }
	});
	Object.defineProperty(exports, 'deferred', {
	  enumerable: true,
	  get: function get() {
	    return _utils.deferred;
	  }
	});
	Object.defineProperty(exports, 'arrayOfDeffered', {
	  enumerable: true,
	  get: function get() {
	    return _utils.arrayOfDeffered;
	  }
	});
	Object.defineProperty(exports, 'createMockTask', {
	  enumerable: true,
	  get: function get() {
	    return _utils.createMockTask;
	  }
	});
	Object.defineProperty(exports, 'cloneableGenerator', {
	  enumerable: true,
	  get: function get() {
	    return _utils.cloneableGenerator;
	  }
	});
	
	var _io = /*#__PURE__*/__webpack_require__(168);
	
	Object.defineProperty(exports, 'asEffect', {
	  enumerable: true,
	  get: function get() {
	    return _io.asEffect;
	  }
	});
	
	var _proc = /*#__PURE__*/__webpack_require__(1395);
	
	Object.defineProperty(exports, 'CHANNEL_END', {
	  enumerable: true,
	  get: function get() {
	    return _proc.CHANNEL_END;
	  }
	});

/***/ },
/* 3231 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ },
/* 3232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1399);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 3233 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 3234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1400);
	
	var _isPlainObject = __webpack_require__(88);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1401);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 3235 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 3236 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {
	module.exports = ripemd160
	
	
	
	/*
	CryptoJS v3.1.2
	code.google.com/p/crypto-js
	(c) 2009-2013 by Jeff Mott. All rights reserved.
	code.google.com/p/crypto-js/wiki/License
	*/
	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.
	
	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
	
	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
	
	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/
	
	// Constants table
	var zl = [
	    0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	    7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	    3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	    1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	    4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13];
	var zr = [
	    5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	    6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	    15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	    8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	    12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11];
	var sl = [
	     11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	    7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	    11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	      11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	    9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ];
	var sr = [
	    8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	    9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	    9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	    15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	    8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ];
	
	var hl =  [ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E];
	var hr =  [ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000];
	
	var bytesToWords = function (bytes) {
	  var words = [];
	  for (var i = 0, b = 0; i < bytes.length; i++, b += 8) {
	    words[b >>> 5] |= bytes[i] << (24 - b % 32);
	  }
	  return words;
	};
	
	var wordsToBytes = function (words) {
	  var bytes = [];
	  for (var b = 0; b < words.length * 32; b += 8) {
	    bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
	  }
	  return bytes;
	};
	
	var processBlock = function (H, M, offset) {
	
	  // Swap endian
	  for (var i = 0; i < 16; i++) {
	    var offset_i = offset + i;
	    var M_offset_i = M[offset_i];
	
	    // Swap
	    M[offset_i] = (
	        (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	        (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	    );
	  }
	
	  // Working variables
	  var al, bl, cl, dl, el;
	  var ar, br, cr, dr, er;
	
	  ar = al = H[0];
	  br = bl = H[1];
	  cr = cl = H[2];
	  dr = dl = H[3];
	  er = el = H[4];
	  // Computation
	  var t;
	  for (var i = 0; i < 80; i += 1) {
	    t = (al +  M[offset+zl[i]])|0;
	    if (i<16){
	        t +=  f1(bl,cl,dl) + hl[0];
	    } else if (i<32) {
	        t +=  f2(bl,cl,dl) + hl[1];
	    } else if (i<48) {
	        t +=  f3(bl,cl,dl) + hl[2];
	    } else if (i<64) {
	        t +=  f4(bl,cl,dl) + hl[3];
	    } else {// if (i<80) {
	        t +=  f5(bl,cl,dl) + hl[4];
	    }
	    t = t|0;
	    t =  rotl(t,sl[i]);
	    t = (t+el)|0;
	    al = el;
	    el = dl;
	    dl = rotl(cl, 10);
	    cl = bl;
	    bl = t;
	
	    t = (ar + M[offset+zr[i]])|0;
	    if (i<16){
	        t +=  f5(br,cr,dr) + hr[0];
	    } else if (i<32) {
	        t +=  f4(br,cr,dr) + hr[1];
	    } else if (i<48) {
	        t +=  f3(br,cr,dr) + hr[2];
	    } else if (i<64) {
	        t +=  f2(br,cr,dr) + hr[3];
	    } else {// if (i<80) {
	        t +=  f1(br,cr,dr) + hr[4];
	    }
	    t = t|0;
	    t =  rotl(t,sr[i]) ;
	    t = (t+er)|0;
	    ar = er;
	    er = dr;
	    dr = rotl(cr, 10);
	    cr = br;
	    br = t;
	  }
	  // Intermediate hash value
	  t    = (H[1] + cl + dr)|0;
	  H[1] = (H[2] + dl + er)|0;
	  H[2] = (H[3] + el + ar)|0;
	  H[3] = (H[4] + al + br)|0;
	  H[4] = (H[0] + bl + cr)|0;
	  H[0] =  t;
	};
	
	function f1(x, y, z) {
	  return ((x) ^ (y) ^ (z));
	}
	
	function f2(x, y, z) {
	  return (((x)&(y)) | ((~x)&(z)));
	}
	
	function f3(x, y, z) {
	  return (((x) | (~(y))) ^ (z));
	}
	
	function f4(x, y, z) {
	  return (((x) & (z)) | ((y)&(~(z))));
	}
	
	function f5(x, y, z) {
	  return ((x) ^ ((y) |(~(z))));
	}
	
	function rotl(x,n) {
	  return (x<<n) | (x>>>(32-n));
	}
	
	function ripemd160(message) {
	  var H = [0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0];
	
	  if (typeof message == 'string')
	    message = new Buffer(message, 'utf8');
	
	  var m = bytesToWords(message);
	
	  var nBitsLeft = message.length * 8;
	  var nBitsTotal = message.length * 8;
	
	  // Add padding
	  m[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	  m[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	      (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	      (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	  );
	
	  for (var i=0 ; i<m.length; i += 16) {
	    processBlock(H, m, i);
	  }
	
	  // Swap endian
	  for (var i = 0; i < 5; i++) {
	      // Shortcut
	    var H_i = H[i];
	
	    // Swap
	    H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	          (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	  }
	
	  var digestbytes = wordsToBytes(H);
	  return new Buffer(digestbytes);
	}
	
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 3237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(7);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var touchSupported = typeof window !== 'undefined' && 'ontouchstart' in window;
	
	var TouchFeedback = function (_React$Component) {
	    (0, _inherits3['default'])(TouchFeedback, _React$Component);
	
	    function TouchFeedback() {
	        (0, _classCallCheck3['default'])(this, TouchFeedback);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));
	
	        _this.state = {
	            active: false
	        };
	        _this.onTouchStart = function (e) {
	            _this.triggerEvent('TouchStart', true, e);
	        };
	        _this.onTouchMove = function (e) {
	            _this.triggerEvent('TouchMove', false, e);
	        };
	        _this.onTouchEnd = function (e) {
	            _this.triggerEvent('TouchEnd', false, e);
	        };
	        _this.onTouchCancel = function (e) {
	            _this.triggerEvent('TouchCancel', false, e);
	        };
	        _this.onMouseDown = function (e) {
	            // pc simulate mobile
	            if (_this.props.onTouchStart) {
	                _this.triggerEvent('TouchStart', true, e);
	            }
	            _this.triggerEvent('MouseDown', true, e);
	        };
	        _this.onMouseUp = function (e) {
	            if (_this.props.onTouchEnd) {
	                _this.triggerEvent('TouchEnd', false, e);
	            }
	            _this.triggerEvent('MouseUp', false, e);
	        };
	        _this.onMouseLeave = function (e) {
	            _this.triggerEvent('MouseLeave', false, e);
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(TouchFeedback, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.disabled && this.state.active) {
	                this.setState({
	                    active: false
	                });
	            }
	        }
	    }, {
	        key: 'triggerEvent',
	        value: function triggerEvent(type, isActive, ev) {
	            var eventType = 'on' + type;
	            if (this.props[eventType]) {
	                this.props[eventType](ev);
	            }
	            if (isActive !== this.state.active) {
	                this.setState({
	                    active: isActive
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                disabled = _props.disabled,
	                activeClassName = _props.activeClassName,
	                activeStyle = _props.activeStyle;
	
	            var events = disabled ? undefined : {
	                onTouchStart: this.onTouchStart,
	                onTouchMove: this.onTouchMove,
	                onTouchEnd: this.onTouchEnd,
	                onTouchCancel: this.onTouchCancel,
	                onMouseDown: this.onMouseDown,
	                onMouseUp: this.onMouseUp,
	                onMouseLeave: this.onMouseLeave
	            };
	            var child = _react2['default'].Children.only(children);
	            if (!disabled && this.state.active) {
	                var _child$props = child.props,
	                    style = _child$props.style,
	                    className = _child$props.className;
	
	                if (activeStyle !== false) {
	                    if (activeStyle) {
	                        style = (0, _extends3['default'])({}, style, activeStyle);
	                    }
	                    className = (0, _classnames2['default'])(className, activeClassName);
	                }
	                return _react2['default'].cloneElement(child, (0, _extends3['default'])({ className: className,
	                    style: style }, events));
	            }
	            return _react2['default'].cloneElement(child, events);
	        }
	    }]);
	    return TouchFeedback;
	}(_react2['default'].Component);
	
	exports['default'] = TouchFeedback;
	
	TouchFeedback.defaultProps = {
	    disabled: false
	};
	module.exports = exports['default'];

/***/ },
/* 3238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TouchFeedback = __webpack_require__(3237);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TouchFeedback)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 3239 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.compute = void 0;
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var isElement = function isElement(el) {
	  return el != null && typeof el == 'object' && el.nodeType === 1;
	};
	
	function hasScrollableSpace(el, axis) {
	  if (axis === 'Y') {
	    return el.clientHeight < el.scrollHeight;
	  }
	
	  if (axis === 'X') {
	    return el.clientWidth < el.scrollWidth;
	  }
	
	  return false;
	}
	
	function isScrollable(el) {
	  var isScrollableY = hasScrollableSpace(el, 'Y');
	  var isScrollableX = hasScrollableSpace(el, 'X');
	  return isScrollableY || isScrollableX;
	}
	
	var alignNearestBlock = function alignNearestBlock(targetStart, targetSize, frame, frameRect) {
	  var targetEnd = targetStart + targetSize;
	  var elementEdgeA = frame.scrollTop + targetStart;
	  var elementEdgeB = frame.scrollTop + targetEnd;
	  var scrollingEdgeA = frame.scrollTop;
	  var height = frame === document.documentElement ? frame.clientHeight : frameRect.bottom;
	  var scrollingEdgeB = document.documentElement ? frame.scrollTop + height : frameRect.bottom;
	
	  if (elementEdgeA < scrollingEdgeA && elementEdgeB > scrollingEdgeB || elementEdgeA > scrollingEdgeA && elementEdgeB < scrollingEdgeB) {
	    return 0;
	  }
	
	  if (elementEdgeA < scrollingEdgeA && targetSize < height) {
	    return targetStart;
	  }
	
	  if (elementEdgeB > scrollingEdgeB && targetSize > height) {
	    return targetStart;
	  }
	
	  if (elementEdgeB > scrollingEdgeB && targetSize < height) {
	    return elementEdgeB - scrollingEdgeB;
	  }
	
	  if (elementEdgeA < scrollingEdgeA && targetSize > height) {
	    return elementEdgeB - scrollingEdgeB;
	  }
	
	  return 0;
	};
	
	var alignNearestInline = function alignNearestInline(targetStart, targetSize, frame, frameRect) {
	  var targetEnd = targetStart + targetSize;
	  var elementEdgeC = frame.scrollLeft + targetStart;
	  var elementEdgeD = frame.scrollLeft + targetEnd;
	  var scrollingEdgeC = frame.scrollLeft;
	  var scrollingEdgeD = frame.scrollLeft + frame.clientWidth;
	  console.log('test');
	
	  if (elementEdgeC < scrollingEdgeC && targetSize < frame.clientWidth || frameRect.left < 0 && targetEnd > frameRect.left && targetSize < frame.clientWidth) {
	    return targetStart;
	  }
	
	  if (elementEdgeD < scrollingEdgeD && targetSize < frame.clientWidth || frameRect.right > 0 && targetEnd > frameRect.right && targetSize < frame.clientWidth) {
	    return targetEnd - frameRect.left - frame.clientWidth;
	  }
	
	  return 0;
	};
	
	var compute = function compute(target, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var _scrollMode$block$inl = _extends({
	    scrollMode: 'always',
	    block: 'center',
	    inline: 'nearest'
	  }, options),
	      scrollMode = _scrollMode$block$inl.scrollMode,
	      block = _scrollMode$block$inl.block,
	      inline = _scrollMode$block$inl.inline,
	      boundary = _scrollMode$block$inl.boundary;
	
	  if (!isElement(target)) {
	    throw new Error('Element is required in scrollIntoViewIfNeeded');
	  }
	
	  var targetRect = target.getBoundingClientRect();
	  var frames = [];
	  var parent;
	
	  while (isElement(parent = target.parentNode) && target !== boundary) {
	    if (isScrollable(parent)) {
	      frames.push(parent);
	    }
	
	    target = parent;
	  }
	
	  if (scrollMode === 'if-needed') {
	    var isVisible = frames.every(function (frame) {
	      var frameRect = frame.getBoundingClientRect();
	
	      if (targetRect.top < frameRect.top) {
	        return false;
	      }
	
	      if (targetRect.bottom > frameRect.bottom) {
	        return false;
	      }
	
	      if (frame === document.documentElement && targetRect.bottom > frame.clientHeight) {
	        return false;
	      }
	
	      return true;
	    });
	
	    if (isVisible) {
	      return [];
	    }
	  }
	
	  var targetBlock;
	  var targetInline;
	  var computations = frames.map(function (frame) {
	    var frameRect = frame.getBoundingClientRect();
	    var blockScroll = 0;
	    var inlineScroll = 0;
	
	    if (block === 'start') {
	      if (!targetBlock) {
	        targetBlock = targetRect.top;
	      }
	
	      if (document.documentElement === frame) {
	        blockScroll = frame.scrollTop + targetBlock;
	      } else {
	        var offset = Math.min(targetBlock - frameRect.top, frame.scrollHeight - frame.clientHeight - frame.scrollTop);
	        blockScroll = frame.scrollTop + offset;
	        targetBlock -= blockScroll - frame.scrollTop;
	      }
	    }
	
	    if (block === 'center') {
	      if (!targetBlock) {
	        targetBlock = targetRect.top + targetRect.height / 2;
	      }
	
	      if (document.documentElement === frame) {
	        blockScroll = frame.scrollTop + targetBlock - frame.clientHeight / 2;
	      } else {
	        var _offset = 0 - Math.min(frameRect.top + frameRect.height / 2 - targetBlock, frame.scrollTop);
	
	        blockScroll = frame.scrollTop + _offset;
	        targetBlock += frame.scrollTop - blockScroll;
	      }
	    }
	
	    if (block === 'end') {
	      if (!targetBlock) {
	        targetBlock = targetRect.bottom;
	      }
	
	      if (document.documentElement === frame) {
	        blockScroll = frame.scrollTop + targetBlock - frame.clientHeight;
	      } else {
	        var _offset2 = 0 - Math.min(frameRect.bottom - targetBlock, frame.scrollTop);
	
	        blockScroll = frame.scrollTop + _offset2;
	        targetBlock += frame.scrollTop - blockScroll;
	      }
	    }
	
	    if (block === 'nearest') {
	      if (!targetBlock) {
	        targetBlock = targetRect.top;
	      }
	
	      var _offset3 = alignNearestBlock(targetBlock, targetRect.height, frame, frameRect);
	
	      blockScroll = frame.scrollTop + _offset3;
	
	      if (document.documentElement !== frame) {
	        targetBlock -= _offset3;
	      }
	    }
	
	    if (inline === 'start') {
	      if (!targetInline) {
	        targetInline = targetRect.left;
	      }
	
	      if (document.documentElement === frame) {
	        inlineScroll = frame.scrollLeft + targetInline;
	      } else {
	        var _offset4 = Math.min(targetInline - frameRect.left, frame.scrollLeft - frame.clientLeft - frame.scrollLeft);
	
	        inlineScroll = frame.scrollLeft + _offset4;
	        targetInline -= inlineScroll - frame.scrollLeft;
	      }
	    }
	
	    if (inline === 'center') {
	      if (!targetInline) {
	        targetInline = targetRect.left + targetRect.width / 2;
	      }
	
	      if (document.documentElement === frame) {
	        inlineScroll = frame.scrollLeft + targetInline - frame.clientWidth / 2;
	      } else {
	        var _offset5 = 0 - Math.min(frameRect.left + frameRect.width / 2 - targetInline, frame.scrollLeft);
	
	        inlineScroll = frame.scrollLeft + _offset5;
	        targetInline += frame.scrollLeft - inlineScroll;
	      }
	    }
	
	    if (inline === 'end') {
	      if (!targetInline) {
	        targetInline = targetRect.right;
	      }
	
	      if (document.documentElement === frame) {
	        inlineScroll = frame.scrollLeft + targetInline - frame.clientWidth;
	      } else {
	        var _offset6 = 0 - Math.min(frameRect.right - targetInline, frame.scrollLeft);
	
	        inlineScroll = frame.scrollLeft + _offset6;
	        targetInline += frame.scrollLeft - inlineScroll;
	      }
	    }
	
	    if (inline === 'nearest') {
	      if (!targetInline) {
	        targetInline = targetRect.left;
	      }
	
	      var _offset7 = alignNearestInline(targetInline, targetRect.width, frame, frameRect);
	
	      inlineScroll = frame.scrollLeft + _offset7;
	
	      if (document.documentElement !== frame) {
	        targetInline -= _offset7;
	      }
	    }
	
	    return {
	      el: frame,
	      top: blockScroll,
	      left: inlineScroll
	    };
	  });
	  return computations;
	};
	
	exports.compute = compute;

/***/ },
/* 3240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _compute = __webpack_require__(3239);
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var _default = function _default(target, maybeOptions) {
	  if (maybeOptions === void 0) {
	    maybeOptions = true;
	  }
	
	  var options = {};
	
	  if (maybeOptions === true || maybeOptions === null) {
	    options = {
	      block: 'start',
	      inline: 'nearest'
	    };
	  } else if (maybeOptions === false) {
	    options = {
	      block: 'end',
	      inline: 'nearest'
	    };
	  } else if (maybeOptions === Object(maybeOptions)) {
	    options = Object.keys(maybeOptions).length === 0 ? {
	      block: 'start',
	      inline: 'nearest'
	    } : _extends({
	      block: 'center',
	      inline: 'nearest'
	    }, maybeOptions);
	  }
	
	  var _options = options,
	      _options$behavior = _options.behavior,
	      behavior = _options$behavior === void 0 ? 'auto' : _options$behavior,
	      computeOptions = _objectWithoutProperties(_options, ["behavior"]);
	
	  var instructions = (0, _compute.compute)(target, computeOptions);
	
	  if (typeof behavior == 'function') {
	    return behavior(instructions);
	  }
	
	  instructions.forEach(function (_ref) {
	    var el = _ref.el,
	        top = _ref.top,
	        left = _ref.left;
	
	    if (el.scroll) {
	      el.scroll({
	        top: top,
	        left: left,
	        behavior: behavior
	      });
	    } else {
	      el.scrollTop = top;
	      el.scrollLeft = left;
	    }
	  });
	};
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 3241 */
/***/ function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;
	
	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }
	
	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }
	
	    return sectionIndex === data.length ? null : sectionIndex;
	  }
	
	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }
	
	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }
	
	    return sectionIndex === -1 ? null : sectionIndex;
	  }
	
	  function next(position) {
	    var _position = _slicedToArray(position, 2);
	
	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, 0];
	      }
	
	      return [sectionIndex, itemIndex + 1];
	    }
	
	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, 0];
	    }
	
	    return [null, itemIndex + 1];
	  }
	
	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);
	
	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, data[sectionIndex] - 1];
	      }
	
	      return [sectionIndex, itemIndex - 1];
	    }
	
	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, data - 1];
	    }
	
	    return [null, itemIndex - 1];
	  }
	
	  function isLast(position) {
	    return next(position)[1] === null;
	  }
	
	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ },
/* 3242 */
/***/ function(module, exports) {

	module.exports = function cmp (a, b) {
	    var pa = a.split('.');
	    var pb = b.split('.');
	    for (var i = 0; i < 3; i++) {
	        var na = Number(pa[i]);
	        var nb = Number(pb[i]);
	        if (na > nb) return 1;
	        if (nb > na) return -1;
	        if (!isNaN(na) && isNaN(nb)) return 1;
	        if (isNaN(na) && !isNaN(nb)) return -1;
	    }
	    return 0;
	};


/***/ },
/* 3243 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./en/index": 1402
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 3243;


/***/ },
/* 3244 */
/***/ function(module, exports, __webpack_require__) {

	var negators = __webpack_require__(2297);
	
	module.exports = {
	    apply: function(tokens, cursor, tokenScore) {
	        if (cursor > 0) {
	            var prevtoken = tokens[cursor - 1];
	            if (negators[prevtoken]) {
	                tokenScore = -tokenScore;
	            }
	        }
	        return tokenScore;
	    }
	};


/***/ },
/* 3245 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {var tokenize = __webpack_require__(3247);
	var languageProcessor = __webpack_require__(3246);
	
	/**
	 * Constructor
	 * @param {Object} options - Instance options
	 */
	var Sentiment = function (options) {
	    this.options = options;
	};
	
	/**
	 * Registers the specified language
	 *
	 * @param {String} languageCode
	 *     - Two-digit code for the language to register
	 * @param {Object} language
	 *     - The language module to register
	 */
	Sentiment.prototype.registerLanguage = function (languageCode, language) {
	    languageProcessor.addLanguage(languageCode, language);
	};
	
	/**
	 * Performs sentiment analysis on the provided input 'phrase'.
	 *
	 * @param {String} phrase
	 *     - Input phrase
	 * @param {Object} opts
	 *     - Options
	 * @param {Object} opts.language
	 *     - Input language code (2 digit code), defaults to 'en'
	 * @param {Object} opts.extras
	 *     - Optional sentiment additions to AFINN (hash k/v pairs)
	 * @param {function} callback
	 *     - Optional callback
	 * @return {Object}
	 */
	Sentiment.prototype.analyze = function (phrase, opts, callback) {
	    // Parse arguments
	    if (typeof phrase === 'undefined') phrase = '';
	    if (typeof opts === 'function') {
	        callback = opts;
	        opts = {};
	    }
	    opts = opts || {};
	
	    var languageCode = opts.language || 'en';
	    var labels = languageProcessor.getLabels(languageCode);
	
	    // Merge extra labels
	    if (typeof opts.extras === 'object') {
	        labels = Object.assign(labels, opts.extras);
	    }
	
	    // Storage objects
	    var tokens      = tokenize(phrase),
	        score       = 0,
	        words       = [],
	        positive    = [],
	        negative    = [];
	
	    // Iterate over tokens
	    var i = tokens.length;
	    while (i--) {
	        var obj = tokens[i];
	        if (!labels.hasOwnProperty(obj)) continue;
	        words.push(obj);
	
	        // Apply scoring strategy
	        var tokenScore = labels[obj];
	        // eslint-disable-next-line max-len
	        tokenScore = languageProcessor.applyScoringStrategy(languageCode, tokens, i, tokenScore);
	        if (tokenScore > 0) positive.push(obj);
	        if (tokenScore < 0) negative.push(obj);
	        score += tokenScore;
	    }
	
	    var result = {
	        score:          score,
	        comparative:    tokens.length > 0 ? score / tokens.length : 0,
	        tokens:         tokens,
	        words:          words,
	        positive:       positive,
	        negative:       negative
	    };
	
	    // Handle optional async interface
	    if (typeof callback === 'function') {
	        process.nextTick(function () {
	            callback(null, result);
	        });
	    } else {
	        return result;
	    }
	};
	
	module.exports = Sentiment;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)))

/***/ },
/* 3246 */
/***/ function(module, exports, __webpack_require__) {

	var emojis = __webpack_require__(2295);
	
	// English is loaded by default
	var enLanguage = __webpack_require__(1402);
	// Add emojis
	Object.assign(enLanguage.labels, emojis);
	
	// Cache loaded languages
	var languages = {
	    en: enLanguage
	};
	
	module.exports = {
	
	    /**
	     * Registers the specified language
	     *
	     * @param {String} languageCode
	     *     - Two-digit code for the language to register
	     * @param {Object} language
	     *     - The language module to register
	     */
	    addLanguage: function (languageCode, language) {
	        if (!language.labels) {
	            throw new Error('language.labels must be defined!');
	        }
	        // Add emojis
	        Object.assign(language.labels, emojis);
	        languages[languageCode] = language;
	    },
	
	    /**
	     * Retrieves a language object from the cache,
	     * or tries to load it from the set of supported languages
	     *
	     * @param {String} languageCode - Two-digit code for the language to fetch
	     */
	    getLanguage: function(languageCode) {
	        if (!languageCode) {
	            // Default to english if no language was specified
	            return languages.en;
	        }
	        if (!languages[languageCode]) {
	            // Try to load specified language
	            try {
	                // eslint-disable-next-line max-len
	                var language = __webpack_require__(3243)("./" + languageCode + '/index');
	                // Add language to in-memory cache
	                this.addLanguage(languageCode, language);
	            } catch (err) {
	                throw new Error('No language found: ' + languageCode);
	            }
	        }
	        return languages[languageCode];
	    },
	
	    /**
	     * Returns AFINN-165 weighted labels for the specified language
	     *
	     * @param {String} languageCode - Two-digit language code
	     * @return {Object}
	     */
	    getLabels: function(languageCode) {
	        var language = this.getLanguage(languageCode);
	        return language.labels;
	    },
	
	    /**
	     * Applies a scoring strategy for the current token
	     *
	     * @param {String} languageCode - Two-digit language code
	     * @param {Array} tokens - Tokens of the phrase to analyze
	     * @param {int} cursor - Cursor of the current token being analyzed
	     * @param {int} tokenScore - The score of the current token being analyzed
	     */
	    applyScoringStrategy: function(languageCode, tokens, cursor, tokenScore) {
	        var language = this.getLanguage(languageCode);
	        // Fallback to default strategy if none was specified
	        // eslint-disable-next-line max-len
	        var scoringStrategy = language.scoringStrategy || defaultScoringStrategy;
	        return scoringStrategy.apply(tokens, cursor, tokenScore);
	    }
	};
	
	var defaultScoringStrategy = {
	    apply: function(tokens, cursor, tokenScore) {
	        return tokenScore;
	    }
	};


/***/ },
/* 3247 */
/***/ function(module, exports) {

	/*eslint no-useless-escape: "off"*/
	
	/**
	 * Remove special characters and return an array of tokens (words).
	 * @param  {string} input Input string
	 * @return {array}        Array of tokens
	 */
	module.exports = function(input) {
	    return input
	        .toLowerCase()
	        .replace(/\n/g, ' ')
	        .replace(/[.,\/#!$%\^&\*;:{}=_`\"~()]/g, '')
	        .split(' ');
	};


/***/ },
/* 3248 */
/***/ function(module, exports) {

	module.exports = function (Buffer) {
	
	  //prototype class for hash functions
	  function Hash (blockSize, finalSize) {
	    this._block = new Buffer(blockSize) //new Uint32Array(blockSize/4)
	    this._finalSize = finalSize
	    this._blockSize = blockSize
	    this._len = 0
	    this._s = 0
	  }
	
	  Hash.prototype.init = function () {
	    this._s = 0
	    this._len = 0
	  }
	
	  Hash.prototype.update = function (data, enc) {
	    if ("string" === typeof data) {
	      enc = enc || "utf8"
	      data = new Buffer(data, enc)
	    }
	
	    var l = this._len += data.length
	    var s = this._s = (this._s || 0)
	    var f = 0
	    var buffer = this._block
	
	    while (s < l) {
	      var t = Math.min(data.length, f + this._blockSize - (s % this._blockSize))
	      var ch = (t - f)
	
	      for (var i = 0; i < ch; i++) {
	        buffer[(s % this._blockSize) + i] = data[i + f]
	      }
	
	      s += ch
	      f += ch
	
	      if ((s % this._blockSize) === 0) {
	        this._update(buffer)
	      }
	    }
	    this._s = s
	
	    return this
	  }
	
	  Hash.prototype.digest = function (enc) {
	    // Suppose the length of the message M, in bits, is l
	    var l = this._len * 8
	
	    // Append the bit 1 to the end of the message
	    this._block[this._len % this._blockSize] = 0x80
	
	    // and then k zero bits, where k is the smallest non-negative solution to the equation (l + 1 + k) === finalSize mod blockSize
	    this._block.fill(0, this._len % this._blockSize + 1)
	
	    if (l % (this._blockSize * 8) >= this._finalSize * 8) {
	      this._update(this._block)
	      this._block.fill(0)
	    }
	
	    // to this append the block which is equal to the number l written in binary
	    // TODO: handle case where l is > Math.pow(2, 29)
	    this._block.writeInt32BE(l, this._blockSize - 4)
	
	    var hash = this._update(this._block) || this._hash()
	
	    return enc ? hash.toString(enc) : hash
	  }
	
	  Hash.prototype._update = function () {
	    throw new Error('_update must be implemented by subclass')
	  }
	
	  return Hash
	}


/***/ },
/* 3249 */
/***/ function(module, exports, __webpack_require__) {

	var exports = module.exports = function (alg) {
	  var Alg = exports[alg]
	  if(!Alg) throw new Error(alg + ' is not supported (we accept pull requests)')
	  return new Alg()
	}
	
	var Buffer = __webpack_require__(28).Buffer
	var Hash   = __webpack_require__(3248)(Buffer)
	
	exports.sha1 = __webpack_require__(3250)(Buffer, Hash)
	exports.sha256 = __webpack_require__(3251)(Buffer, Hash)
	exports.sha512 = __webpack_require__(3252)(Buffer, Hash)


/***/ },
/* 3250 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
	 * in FIPS PUB 180-1
	 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for details.
	 */
	
	var inherits = __webpack_require__(579).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var A = 0|0
	  var B = 4|0
	  var C = 8|0
	  var D = 12|0
	  var E = 16|0
	
	  var W = new (typeof Int32Array === 'undefined' ? Array : Int32Array)(80)
	
	  var POOL = []
	
	  function Sha1 () {
	    if(POOL.length)
	      return POOL.pop().init()
	
	    if(!(this instanceof Sha1)) return new Sha1()
	    this._w = W
	    Hash.call(this, 16*4, 14*4)
	
	    this._h = null
	    this.init()
	  }
	
	  inherits(Sha1, Hash)
	
	  Sha1.prototype.init = function () {
	    this._a = 0x67452301
	    this._b = 0xefcdab89
	    this._c = 0x98badcfe
	    this._d = 0x10325476
	    this._e = 0xc3d2e1f0
	
	    Hash.prototype.init.call(this)
	    return this
	  }
	
	  Sha1.prototype._POOL = POOL
	  Sha1.prototype._update = function (X) {
	
	    var a, b, c, d, e, _a, _b, _c, _d, _e
	
	    a = _a = this._a
	    b = _b = this._b
	    c = _c = this._c
	    d = _d = this._d
	    e = _e = this._e
	
	    var w = this._w
	
	    for(var j = 0; j < 80; j++) {
	      var W = w[j] = j < 16 ? X.readInt32BE(j*4)
	        : rol(w[j - 3] ^ w[j -  8] ^ w[j - 14] ^ w[j - 16], 1)
	
	      var t = add(
	        add(rol(a, 5), sha1_ft(j, b, c, d)),
	        add(add(e, W), sha1_kt(j))
	      )
	
	      e = d
	      d = c
	      c = rol(b, 30)
	      b = a
	      a = t
	    }
	
	    this._a = add(a, _a)
	    this._b = add(b, _b)
	    this._c = add(c, _c)
	    this._d = add(d, _d)
	    this._e = add(e, _e)
	  }
	
	  Sha1.prototype._hash = function () {
	    if(POOL.length < 100) POOL.push(this)
	    var H = new Buffer(20)
	    //console.log(this._a|0, this._b|0, this._c|0, this._d|0, this._e|0)
	    H.writeInt32BE(this._a|0, A)
	    H.writeInt32BE(this._b|0, B)
	    H.writeInt32BE(this._c|0, C)
	    H.writeInt32BE(this._d|0, D)
	    H.writeInt32BE(this._e|0, E)
	    return H
	  }
	
	  /*
	   * Perform the appropriate triplet combination function for the current
	   * iteration
	   */
	  function sha1_ft(t, b, c, d) {
	    if(t < 20) return (b & c) | ((~b) & d);
	    if(t < 40) return b ^ c ^ d;
	    if(t < 60) return (b & c) | (b & d) | (c & d);
	    return b ^ c ^ d;
	  }
	
	  /*
	   * Determine the appropriate additive constant for the current iteration
	   */
	  function sha1_kt(t) {
	    return (t < 20) ?  1518500249 : (t < 40) ?  1859775393 :
	           (t < 60) ? -1894007588 : -899497514;
	  }
	
	  /*
	   * Add integers, wrapping at 2^32. This uses 16-bit operations internally
	   * to work around bugs in some JS interpreters.
	   * //dominictarr: this is 10 years old, so maybe this can be dropped?)
	   *
	   */
	  function add(x, y) {
	    return (x + y ) | 0
	  //lets see how this goes on testling.
	  //  var lsw = (x & 0xFFFF) + (y & 0xFFFF);
	  //  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	  //  return (msw << 16) | (lsw & 0xFFFF);
	  }
	
	  /*
	   * Bitwise rotate a 32-bit number to the left.
	   */
	  function rol(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt));
	  }
	
	  return Sha1
	}


/***/ },
/* 3251 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
	 * in FIPS 180-2
	 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 *
	 */
	
	var inherits = __webpack_require__(579).inherits
	
	module.exports = function (Buffer, Hash) {
	
	  var K = [
	      0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
	      0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
	      0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
	      0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
	      0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
	      0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
	      0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
	      0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
	      0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
	      0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
	      0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
	      0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
	      0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
	      0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
	      0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
	      0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
	    ]
	
	  var W = new Array(64)
	
	  function Sha256() {
	    this.init()
	
	    this._w = W //new Array(64)
	
	    Hash.call(this, 16*4, 14*4)
	  }
	
	  inherits(Sha256, Hash)
	
	  Sha256.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, n) {
	    return (X >>> n) | (X << (32 - n));
	  }
	
	  function R (X, n) {
	    return (X >>> n);
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  function Sigma0256 (x) {
	    return (S(x, 2) ^ S(x, 13) ^ S(x, 22));
	  }
	
	  function Sigma1256 (x) {
	    return (S(x, 6) ^ S(x, 11) ^ S(x, 25));
	  }
	
	  function Gamma0256 (x) {
	    return (S(x, 7) ^ S(x, 18) ^ R(x, 3));
	  }
	
	  function Gamma1256 (x) {
	    return (S(x, 17) ^ S(x, 19) ^ R(x, 10));
	  }
	
	  Sha256.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var T1, T2
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    for (var j = 0; j < 64; j++) {
	      var w = W[j] = j < 16
	        ? M.readInt32BE(j * 4)
	        : Gamma1256(W[j - 2]) + W[j - 7] + Gamma0256(W[j - 15]) + W[j - 16]
	
	      T1 = h + Sigma1256(e) + Ch(e, f, g) + K[j] + w
	
	      T2 = Sigma0256(a) + Maj(a, b, c);
	      h = g; g = f; f = e; e = d + T1; d = c; c = b; b = a; a = T1 + T2;
	    }
	
	    this._a = (a + this._a) | 0
	    this._b = (b + this._b) | 0
	    this._c = (c + this._c) | 0
	    this._d = (d + this._d) | 0
	    this._e = (e + this._e) | 0
	    this._f = (f + this._f) | 0
	    this._g = (g + this._g) | 0
	    this._h = (h + this._h) | 0
	
	  };
	
	  Sha256.prototype._hash = function () {
	    var H = new Buffer(32)
	
	    H.writeInt32BE(this._a,  0)
	    H.writeInt32BE(this._b,  4)
	    H.writeInt32BE(this._c,  8)
	    H.writeInt32BE(this._d, 12)
	    H.writeInt32BE(this._e, 16)
	    H.writeInt32BE(this._f, 20)
	    H.writeInt32BE(this._g, 24)
	    H.writeInt32BE(this._h, 28)
	
	    return H
	  }
	
	  return Sha256
	
	}


/***/ },
/* 3252 */
/***/ function(module, exports, __webpack_require__) {

	var inherits = __webpack_require__(579).inherits
	
	module.exports = function (Buffer, Hash) {
	  var K = [
	    0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
	    0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
	    0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
	    0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
	    0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
	    0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
	    0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
	    0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
	    0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
	    0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
	    0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
	    0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
	    0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
	    0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
	    0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
	    0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
	    0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
	    0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
	    0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
	    0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
	    0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
	    0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
	    0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
	    0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
	    0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
	    0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
	    0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
	    0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
	    0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
	    0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
	    0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
	    0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
	    0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
	    0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
	    0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
	    0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
	    0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
	    0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
	    0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
	    0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
	  ]
	
	  var W = new Array(160)
	
	  function Sha512() {
	    this.init()
	    this._w = W
	
	    Hash.call(this, 128, 112)
	  }
	
	  inherits(Sha512, Hash)
	
	  Sha512.prototype.init = function () {
	
	    this._a = 0x6a09e667|0
	    this._b = 0xbb67ae85|0
	    this._c = 0x3c6ef372|0
	    this._d = 0xa54ff53a|0
	    this._e = 0x510e527f|0
	    this._f = 0x9b05688c|0
	    this._g = 0x1f83d9ab|0
	    this._h = 0x5be0cd19|0
	
	    this._al = 0xf3bcc908|0
	    this._bl = 0x84caa73b|0
	    this._cl = 0xfe94f82b|0
	    this._dl = 0x5f1d36f1|0
	    this._el = 0xade682d1|0
	    this._fl = 0x2b3e6c1f|0
	    this._gl = 0xfb41bd6b|0
	    this._hl = 0x137e2179|0
	
	    this._len = this._s = 0
	
	    return this
	  }
	
	  function S (X, Xl, n) {
	    return (X >>> n) | (Xl << (32 - n))
	  }
	
	  function Ch (x, y, z) {
	    return ((x & y) ^ ((~x) & z));
	  }
	
	  function Maj (x, y, z) {
	    return ((x & y) ^ (x & z) ^ (y & z));
	  }
	
	  Sha512.prototype._update = function(M) {
	
	    var W = this._w
	    var a, b, c, d, e, f, g, h
	    var al, bl, cl, dl, el, fl, gl, hl
	
	    a = this._a | 0
	    b = this._b | 0
	    c = this._c | 0
	    d = this._d | 0
	    e = this._e | 0
	    f = this._f | 0
	    g = this._g | 0
	    h = this._h | 0
	
	    al = this._al | 0
	    bl = this._bl | 0
	    cl = this._cl | 0
	    dl = this._dl | 0
	    el = this._el | 0
	    fl = this._fl | 0
	    gl = this._gl | 0
	    hl = this._hl | 0
	
	    for (var i = 0; i < 80; i++) {
	      var j = i * 2
	
	      var Wi, Wil
	
	      if (i < 16) {
	        Wi = W[j] = M.readInt32BE(j * 4)
	        Wil = W[j + 1] = M.readInt32BE(j * 4 + 4)
	
	      } else {
	        var x  = W[j - 15*2]
	        var xl = W[j - 15*2 + 1]
	        var gamma0  = S(x, xl, 1) ^ S(x, xl, 8) ^ (x >>> 7)
	        var gamma0l = S(xl, x, 1) ^ S(xl, x, 8) ^ S(xl, x, 7)
	
	        x  = W[j - 2*2]
	        xl = W[j - 2*2 + 1]
	        var gamma1  = S(x, xl, 19) ^ S(xl, x, 29) ^ (x >>> 6)
	        var gamma1l = S(xl, x, 19) ^ S(x, xl, 29) ^ S(xl, x, 6)
	
	        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	        var Wi7  = W[j - 7*2]
	        var Wi7l = W[j - 7*2 + 1]
	
	        var Wi16  = W[j - 16*2]
	        var Wi16l = W[j - 16*2 + 1]
	
	        Wil = gamma0l + Wi7l
	        Wi  = gamma0  + Wi7 + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0)
	        Wil = Wil + gamma1l
	        Wi  = Wi  + gamma1  + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0)
	        Wil = Wil + Wi16l
	        Wi  = Wi  + Wi16 + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0)
	
	        W[j] = Wi
	        W[j + 1] = Wil
	      }
	
	      var maj = Maj(a, b, c)
	      var majl = Maj(al, bl, cl)
	
	      var sigma0h = S(a, al, 28) ^ S(al, a, 2) ^ S(al, a, 7)
	      var sigma0l = S(al, a, 28) ^ S(a, al, 2) ^ S(a, al, 7)
	      var sigma1h = S(e, el, 14) ^ S(e, el, 18) ^ S(el, e, 9)
	      var sigma1l = S(el, e, 14) ^ S(el, e, 18) ^ S(e, el, 9)
	
	      // t1 = h + sigma1 + ch + K[i] + W[i]
	      var Ki = K[j]
	      var Kil = K[j + 1]
	
	      var ch = Ch(e, f, g)
	      var chl = Ch(el, fl, gl)
	
	      var t1l = hl + sigma1l
	      var t1 = h + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0)
	      t1l = t1l + chl
	      t1 = t1 + ch + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0)
	      t1l = t1l + Kil
	      t1 = t1 + Ki + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0)
	      t1l = t1l + Wil
	      t1 = t1 + Wi + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0)
	
	      // t2 = sigma0 + maj
	      var t2l = sigma0l + majl
	      var t2 = sigma0h + maj + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0)
	
	      h  = g
	      hl = gl
	      g  = f
	      gl = fl
	      f  = e
	      fl = el
	      el = (dl + t1l) | 0
	      e  = (d + t1 + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	      d  = c
	      dl = cl
	      c  = b
	      cl = bl
	      b  = a
	      bl = al
	      al = (t1l + t2l) | 0
	      a  = (t1 + t2 + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0
	    }
	
	    this._al = (this._al + al) | 0
	    this._bl = (this._bl + bl) | 0
	    this._cl = (this._cl + cl) | 0
	    this._dl = (this._dl + dl) | 0
	    this._el = (this._el + el) | 0
	    this._fl = (this._fl + fl) | 0
	    this._gl = (this._gl + gl) | 0
	    this._hl = (this._hl + hl) | 0
	
	    this._a = (this._a + a + ((this._al >>> 0) < (al >>> 0) ? 1 : 0)) | 0
	    this._b = (this._b + b + ((this._bl >>> 0) < (bl >>> 0) ? 1 : 0)) | 0
	    this._c = (this._c + c + ((this._cl >>> 0) < (cl >>> 0) ? 1 : 0)) | 0
	    this._d = (this._d + d + ((this._dl >>> 0) < (dl >>> 0) ? 1 : 0)) | 0
	    this._e = (this._e + e + ((this._el >>> 0) < (el >>> 0) ? 1 : 0)) | 0
	    this._f = (this._f + f + ((this._fl >>> 0) < (fl >>> 0) ? 1 : 0)) | 0
	    this._g = (this._g + g + ((this._gl >>> 0) < (gl >>> 0) ? 1 : 0)) | 0
	    this._h = (this._h + h + ((this._hl >>> 0) < (hl >>> 0) ? 1 : 0)) | 0
	  }
	
	  Sha512.prototype._hash = function () {
	    var H = new Buffer(64)
	
	    function writeInt64BE(h, l, offset) {
	      H.writeInt32BE(h, offset)
	      H.writeInt32BE(l, offset + 4)
	    }
	
	    writeInt64BE(this._a, this._al, 0)
	    writeInt64BE(this._b, this._bl, 8)
	    writeInt64BE(this._c, this._cl, 16)
	    writeInt64BE(this._d, this._dl, 24)
	    writeInt64BE(this._e, this._el, 32)
	    writeInt64BE(this._f, this._fl, 40)
	    writeInt64BE(this._g, this._gl, 48)
	    writeInt64BE(this._h, this._hl, 56)
	
	    return H
	  }
	
	  return Sha512
	
	}


/***/ },
/* 3253 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Pulled from react-compat
	// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
	function shallowDiffers(a, b) {
	  for (var i in a) {
	    if (!(i in b)) return true;
	  }for (var _i in b) {
	    if (a[_i] !== b[_i]) return true;
	  }return false;
	}
	
	exports.default = function (instance, nextProps, nextState) {
	  return shallowDiffers(instance.props, nextProps) || shallowDiffers(instance.state, nextState);
	};
	
	module.exports = exports["default"];

/***/ },
/* 3254 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(298).EventEmitter;
	var inherits = __webpack_require__(98);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(528);
	Stream.Writable = __webpack_require__(2971);
	Stream.Duplex = __webpack_require__(2966);
	Stream.Transform = __webpack_require__(2970);
	Stream.PassThrough = __webpack_require__(2969);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 3255 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 3256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    if (false) {
	      // $FlowInvalidInputTest
	      throw new Error('Cannot create styled-component for component: ' + tag);
	    }
	
	    /* This is callable directly as a template function */
	    var templateFunction = function templateFunction(strings) {
	      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        interpolations[_key - 1] = arguments[_key];
	      }
	
	      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || {}, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	};
	
	module.exports = exports['default'];

/***/ },
/* 3257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _interleave = __webpack_require__(3271);
	
	var _interleave2 = _interopRequireDefault(_interleave);
	
	var _flatten = __webpack_require__(1408);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (strings) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  return (0, _flatten2.default)((0, _interleave2.default)(strings, interpolations));
	};
	
	module.exports = exports['default'];

/***/ },
/* 3258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(561);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal(strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = css.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(JSON.stringify(rules));
	
	    var componentId = 'sc-global-' + hash;
	    if (_StyleSheet2.default.instance.hasInjectedComponent(componentId)) return;
	
	    _StyleSheet2.default.instance.inject(componentId, false, stringifyRules(rules));
	  };
	
	  return injectGlobal;
	};
	
	module.exports = exports['default'];

/***/ },
/* 3259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(561);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	exports.default = function (nameGenerator, stringifyRules, css) {
	  return function (strings) {
	    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      interpolations[_key - 1] = arguments[_key];
	    }
	
	    var rules = css.apply(undefined, [strings].concat(interpolations));
	    var hash = (0, _hash2.default)(replaceWhitespace(JSON.stringify(rules)));
	
	    var existingName = _StyleSheet2.default.instance.getName(hash);
	    if (existingName) return existingName;
	
	    var name = nameGenerator(hash);
	    if (_StyleSheet2.default.instance.alreadyInjected(hash, name)) return name;
	
	    var generatedCSS = stringifyRules(rules, name, '@keyframes');
	    _StyleSheet2.default.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
	    return name;
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 3260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _domElements = __webpack_require__(3266);
	
	var _domElements2 = _interopRequireDefault(_domElements);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	exports.default = function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  _domElements2.default.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	};
	
	module.exports = exports['default'];

/***/ },
/* 3261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(3276);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ThemeProvider = __webpack_require__(377);
	
	var _isStyledComponent2 = __webpack_require__(560);
	
	var _isStyledComponent3 = _interopRequireDefault(_isStyledComponent2);
	
	var _determineTheme = __webpack_require__(1407);
	
	var _determineTheme2 = _interopRequireDefault(_determineTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/* globals ReactClass */
	
	var wrapWithTheme = function wrapWithTheme(Component) {
	  var _WithTheme$contextTyp;
	
	  var componentName = Component.displayName || Component.name || 'Component';
	
	  var shouldSetInnerRef = (0, _isStyledComponent3.default)(Component) ||
	  // NOTE: We can't pass a ref to a stateless functional component
	  typeof Component === 'function' && !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  var WithTheme = function (_React$Component) {
	    _inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[_ThemeProvider.CHANNEL_NEXT];
	      var themeProp = (0, _determineTheme2.default)(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = (0, _determineTheme2.default)(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = (0, _determineTheme2.default)(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[_ThemeProvider.CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var theme = this.state.theme;
	
	
	      return _react2.default.createElement(Component, _extends({
	        theme: theme
	      }, this.props, {
	        innerRef: shouldSetInnerRef ? innerRef : undefined,
	        ref: shouldSetInnerRef ? undefined : innerRef
	      }));
	    };
	
	    return WithTheme;
	  }(_react2.default.Component);
	
	  WithTheme.displayName = 'WithTheme(' + componentName + ')';
	  WithTheme.styledComponentId = 'withTheme';
	  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[_ThemeProvider.CHANNEL] = _propTypes2.default.func, _WithTheme$contextTyp[_ThemeProvider.CHANNEL_NEXT] = _ThemeProvider.CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);
	
	
	  return (0, _hoistNonReactStatics2.default)(WithTheme, Component);
	};
	
	exports.default = wrapWithTheme;
	module.exports = exports['default'];

/***/ },
/* 3262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.COMPONENTS_PER_TAG = undefined;
	
	var _extractCompsFromCSS = __webpack_require__(3268);
	
	var _extractCompsFromCSS2 = _interopRequireDefault(_extractCompsFromCSS);
	
	var _nonce = __webpack_require__(1409);
	
	var _nonce2 = _interopRequireDefault(_nonce);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	/* eslint-disable no-underscore-dangle */
	/*
	 * Browser Style Sheet with Rehydration
	 *
	 * <style data-styled-components="x y z"
	 *        data-styled-components-is-local="true">
	 *   /· sc-component-id: a ·/
	 *   .sc-a { ... }
	 *   .x { ... }
	 *   /· sc-component-id: b ·/
	 *   .sc-b { ... }
	 *   .y { ... }
	 *   .z { ... }
	 * </style>
	 *
	 * Note: replace · with * in the above snippet.
	 * */
	
	
	var babelPluginFlowReactPropTypes_proptype_Tag = __webpack_require__(115).babelPluginFlowReactPropTypes_proptype_Tag || __webpack_require__(2).any;
	
	var COMPONENTS_PER_TAG = exports.COMPONENTS_PER_TAG = 40;
	
	var BrowserTag = function () {
	  function BrowserTag(el, isLocal) {
	    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	    _classCallCheck(this, BrowserTag);
	
	    this.el = el;
	    this.isLocal = isLocal;
	    this.ready = false;
	
	    var extractedComps = (0, _extractCompsFromCSS2.default)(existingSource);
	
	    this.size = extractedComps.length;
	    this.components = extractedComps.reduce(function (acc, obj) {
	      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
	      return acc;
	    }, {});
	  }
	
	  BrowserTag.prototype.isFull = function isFull() {
	    return this.size >= COMPONENTS_PER_TAG;
	  };
	
	  BrowserTag.prototype.addComponent = function addComponent(componentId) {
	    if (!this.ready) this.replaceElement();
	    if (false) {
	      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
	    }
	
	    var comp = { componentId: componentId, textNode: document.createTextNode('') };
	    this.el.appendChild(comp.textNode);
	
	    this.size += 1;
	    this.components[componentId] = comp;
	  };
	
	  BrowserTag.prototype.inject = function inject(componentId, css, name) {
	    if (!this.ready) this.replaceElement();
	    var comp = this.components[componentId];
	
	    if (false) {
	      throw new Error('Must add a new component before you can inject css into it');
	    }
	    if (comp.textNode.data === '') {
	      comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
	    }
	
	    comp.textNode.appendData(css);
	    if (name) {
	      var existingNames = this.el.getAttribute(_StyleSheet.SC_ATTR);
	      this.el.setAttribute(_StyleSheet.SC_ATTR, existingNames ? existingNames + ' ' + name : name);
	    }
	
	    var nonce = (0, _nonce2.default)();
	
	    if (nonce) {
	      this.el.setAttribute('nonce', nonce);
	    }
	  };
	
	  BrowserTag.prototype.toHTML = function toHTML() {
	    return this.el.outerHTML;
	  };
	
	  BrowserTag.prototype.toReactElement = function toReactElement() {
	    throw new Error("BrowserTag doesn't implement toReactElement!");
	  };
	
	  BrowserTag.prototype.clone = function clone() {
	    throw new Error('BrowserTag cannot be cloned!');
	  };
	
	  /* Because we care about source order, before we can inject anything we need to
	   * create a text node for each component and replace the existing CSS. */
	
	
	  BrowserTag.prototype.replaceElement = function replaceElement() {
	    var _this = this;
	
	    this.ready = true;
	    // We have nothing to inject. Use the current el.
	    if (this.size === 0) return;
	
	    // Build up our replacement style tag
	    var newEl = this.el.cloneNode();
	    newEl.appendChild(document.createTextNode('\n'));
	
	    Object.keys(this.components).forEach(function (key) {
	      var comp = _this.components[key];
	
	      // eslint-disable-next-line no-param-reassign
	      comp.textNode = document.createTextNode(comp.cssFromDOM);
	      newEl.appendChild(comp.textNode);
	    });
	
	    if (!this.el.parentNode) {
	      throw new Error("Trying to replace an element that wasn't mounted!");
	    }
	
	    // The ol' switcheroo
	    this.el.parentNode.replaceChild(newEl, this.el);
	    this.el = newEl;
	  };
	
	  return BrowserTag;
	}();
	
	/* Factory function to separate DOM operations from logical ones*/
	
	
	exports.default = {
	  create: function create() {
	    var tags = [];
	    var names = {};
	
	    /* Construct existing state from DOM */
	    var nodes = document.querySelectorAll('[' + _StyleSheet.SC_ATTR + ']');
	    var nodesLength = nodes.length;
	
	    for (var i = 0; i < nodesLength; i += 1) {
	      var el = nodes[i];
	
	      tags.push(new BrowserTag(el, el.getAttribute(_StyleSheet.LOCAL_ATTR) === 'true', el.innerHTML));
	
	      var attr = el.getAttribute(_StyleSheet.SC_ATTR);
	      if (attr) {
	        attr.trim().split(/\s+/).forEach(function (name) {
	          names[name] = true;
	        });
	      }
	    }
	
	    /* Factory for making more tags */
	    var tagConstructor = function tagConstructor(isLocal) {
	      var el = document.createElement('style');
	      el.type = 'text/css';
	      el.setAttribute(_StyleSheet.SC_ATTR, '');
	      el.setAttribute(_StyleSheet.LOCAL_ATTR, isLocal ? 'true' : 'false');
	      if (!document.head) throw new Error('Missing document <head>');
	      document.head.appendChild(el);
	      return new BrowserTag(el, isLocal);
	    };
	
	    return new _StyleSheet2.default(tagConstructor, tags, names);
	  }
	};

/***/ },
/* 3263 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	exports.__esModule = true;
	
	var _hash = __webpack_require__(561);
	
	var _hash2 = _interopRequireDefault(_hash);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _isStyledComponent = __webpack_require__(560);
	
	var _isStyledComponent2 = _interopRequireDefault(_isStyledComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var babelPluginFlowReactPropTypes_proptype_Stringifier = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Stringifier || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Flattener = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Flattener || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_NameGenerator = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_NameGenerator || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(2).any;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0; i < rules.length; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !(0, _isStyledComponent2.default)(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled copmonent
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      var value = attrs[key];
	      if (typeof value === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHRMEnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	
	exports.default = function (nameGenerator, flatten, stringifyRules) {
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      _classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	      if (!_StyleSheet2.default.instance.hasInjectedComponent(this.componentId)) {
	        var placeholder =  false ? '.' + componentId + ' {}' : '';
	        _StyleSheet2.default.instance.deferredInject(componentId, true, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          lastClassName = this.lastClassName;
	
	      if (isStatic && lastClassName !== undefined) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var hash = (0, _hash2.default)(this.componentId + flatCSS.join(''));
	
	      var existingName = styleSheet.getName(hash);
	      if (existingName !== undefined) {
	        if (styleSheet.stylesCacheable) {
	          this.lastClassName = existingName;
	        }
	        return existingName;
	      }
	
	      var name = nameGenerator(hash);
	      if (styleSheet.stylesCacheable) {
	        this.lastClassName = existingName;
	      }
	      if (styleSheet.alreadyInjected(hash, name)) {
	        return name;
	      }
	
	      var css = '\n' + stringifyRules(flatCSS, '.' + name);
	      // NOTE: this can only be set when we inject the class-name.
	      // For some reason, presumably due to how css is stringifyRules behaves in
	      // differently between client and server, styles break.
	      styleSheet.inject(this.componentId, true, css, hash, name);
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return nameGenerator((0, _hash2.default)(str));
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	};
	
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 3264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createWarnTooManyClasses = __webpack_require__(3265);
	
	var _createWarnTooManyClasses2 = _interopRequireDefault(_createWarnTooManyClasses);
	
	var _validAttr = __webpack_require__(3275);
	
	var _validAttr2 = _interopRequireDefault(_validAttr);
	
	var _isTag = __webpack_require__(3272);
	
	var _isTag2 = _interopRequireDefault(_isTag);
	
	var _isStyledComponent = __webpack_require__(560);
	
	var _isStyledComponent2 = _interopRequireDefault(_isStyledComponent);
	
	var _getComponentName = __webpack_require__(3270);
	
	var _getComponentName2 = _interopRequireDefault(_getComponentName);
	
	var _determineTheme = __webpack_require__(1407);
	
	var _determineTheme2 = _interopRequireDefault(_determineTheme);
	
	var _escape = __webpack_require__(3267);
	
	var _escape2 = _interopRequireDefault(_escape);
	
	var _ThemeProvider = __webpack_require__(377);
	
	var _StyleSheet = __webpack_require__(115);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _ServerStyleSheet = __webpack_require__(376);
	
	var _ServerStyleSheet2 = _interopRequireDefault(_ServerStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var babelPluginFlowReactPropTypes_proptype_Theme = __webpack_require__(377).babelPluginFlowReactPropTypes_proptype_Theme || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	var babelPluginFlowReactPropTypes_proptype_RuleSet = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_RuleSet || __webpack_require__(2).any;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	exports.default = function (ComponentStyle, constructWithOptions) {
	  var identifiers = {};
	
	  /* We depend on components having unique IDs */
	  var generateId = function generateId(_displayName, parentComponentId) {
	    var displayName = typeof _displayName !== 'string' ? 'sc' : (0, _escape2.default)(_displayName);
	
	    var componentId = void 0;
	
	    /**
	     * only fall back to hashing the component injection order if
	     * a proper displayName isn't provided by the babel plugin
	     */
	    if (!_displayName) {
	      var nr = (identifiers[displayName] || 0) + 1;
	      identifiers[displayName] = nr;
	
	      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	    } else {
	      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
	    }
	
	    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	  };
	
	  var BaseStyledComponent = function (_Component) {
	    _inherits(BaseStyledComponent, _Component);
	
	    function BaseStyledComponent() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, BaseStyledComponent);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	        theme: null,
	        generatedClassName: ''
	      }, _this.unsubscribeId = -1, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	      if (this.unsubscribeId !== -1) {
	        this.context[_ThemeProvider.CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	      var attrs = this.constructor.attrs;
	
	      var context = _extends({}, props, { theme: theme });
	      if (attrs === undefined) {
	        return context;
	      }
	
	      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	        var attr = attrs[key];
	        // eslint-disable-next-line no-param-reassign
	        acc[key] = typeof attr === 'function' ? attr(context) : attr;
	        return acc;
	      }, {});
	
	      return _extends({}, context, this.attrs);
	    };
	
	    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	      var _constructor = this.constructor,
	          attrs = _constructor.attrs,
	          componentStyle = _constructor.componentStyle,
	          warnTooManyClasses = _constructor.warnTooManyClasses;
	
	      var styleSheet = this.context[_StyleSheet.CONTEXT_KEY] || _StyleSheet2.default.instance;
	
	      // staticaly styled-components don't need to build an execution context object,
	      // and shouldn't be increasing the number of class names
	      if (componentStyle.isStatic && attrs === undefined) {
	        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	      } else {
	        var executionContext = this.buildExecutionContext(theme, props);
	        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	        if (false) {
	          warnTooManyClasses(className);
	        }
	
	        return className;
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var componentStyle = this.constructor.componentStyle;
	
	      var styledContext = this.context[_ThemeProvider.CHANNEL_NEXT];
	
	      // If this is a staticaly-styled component, we don't need to the theme
	      // to generate or build styles.
	      if (componentStyle.isStatic) {
	        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	        this.setState({ generatedClassName: generatedClassName });
	        // If there is a theme in the context, subscribe to the event emitter. This
	        // is necessary due to pure components blocking context updates, this circumvents
	        // that by updating when an event is emitted
	      } else if (styledContext !== undefined) {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          // This will be called once immediately
	          var theme = (0, _determineTheme2.default)(_this2.props, nextTheme, _this2.constructor.defaultProps);
	          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	        });
	      } else {
	        // eslint-disable-next-line react/prop-types
	        var _theme = this.props.theme || {};
	        var _generatedClassName = this.generateAndInjectStyles(_theme, this.props);
	        this.setState({ theme: _theme, generatedClassName: _generatedClassName });
	      }
	    };
	
	    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      // If this is a staticaly-styled component, we don't need to listen to
	      // props changes to update styles
	      var componentStyle = this.constructor.componentStyle;
	
	      if (componentStyle.isStatic) {
	        return;
	      }
	
	      this.setState(function (oldState) {
	        var theme = (0, _determineTheme2.default)(nextProps, oldState.theme, _this3.constructor.defaultProps);
	        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	        return { theme: theme, generatedClassName: generatedClassName };
	      });
	    };
	
	    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.unsubscribeFromContext();
	    };
	
	    BaseStyledComponent.prototype.render = function render() {
	      var _this4 = this;
	
	      // eslint-disable-next-line react/prop-types
	      var innerRef = this.props.innerRef;
	      var generatedClassName = this.state.generatedClassName;
	      var _constructor2 = this.constructor,
	          styledComponentId = _constructor2.styledComponentId,
	          target = _constructor2.target;
	
	
	      var isTargetTag = (0, _isTag2.default)(target);
	
	      var className = [
	      // eslint-disable-next-line react/prop-types
	      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	      var baseProps = _extends({}, this.attrs, {
	        className: className
	      });
	
	      if ((0, _isStyledComponent2.default)(target)) {
	        baseProps.innerRef = innerRef;
	      } else {
	        baseProps.ref = innerRef;
	      }
	
	      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
	        // Don't pass through non HTML tags through to HTML elements
	        // always omit innerRef
	        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || (0, _validAttr2.default)(propName))) {
	          // eslint-disable-next-line no-param-reassign
	          acc[propName] = _this4.props[propName];
	        }
	
	        return acc;
	      }, baseProps);
	
	      return (0, _react.createElement)(target, propsForElement);
	    };
	
	    return BaseStyledComponent;
	  }(_react.Component);
	
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _StyledComponent$cont;
	
	    var _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? (0, _isTag2.default)(target) ? 'styled.' + target : 'Styled(' + (0, _getComponentName2.default)(target) + ')' : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? (0, _escape2.default)(options.displayName) + '-' + options.componentId : componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      _inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        _classCallCheck(this, StyledComponent);
	
	        return _possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = _objectWithoutProperties(options, ['componentId']);
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + ((0, _isTag2.default)(tag) ? tag : (0, _escape2.default)((0, _getComponentName2.default)(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      _createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = _objectWithoutProperties(options, ['rules', 'componentId']);
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[_ThemeProvider.CHANNEL] = _propTypes2.default.func, _StyledComponent$cont[_ThemeProvider.CHANNEL_NEXT] = _ThemeProvider.CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[_StyleSheet.CONTEXT_KEY] = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_StyleSheet2.default), _propTypes2.default.instanceOf(_ServerStyleSheet2.default)]), _StyledComponent$cont);
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.target = target;
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = (0, _createWarnTooManyClasses2.default)(displayName);
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	};
	
	module.exports = exports['default'];

/***/ },
/* 3265 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var LIMIT = 200;
	
	exports.default = function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 3266 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	// Thanks to ReactDOMFactories for this handy list!
	
	exports.default = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	module.exports = exports['default'];

/***/ },
/* 3267 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = escape;
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	module.exports = exports['default'];

/***/ },
/* 3268 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//gm;
	
	exports.default = function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	};
	
	module.exports = exports['default'];

/***/ },
/* 3269 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
	var charsLength = chars.length;
	
	/* Some high number, usually 9-digit base-10. Map it to base-😎 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = chars[x % charsLength] + name;
	  }
	
	  return chars[x % charsLength] + name;
	};
	
	exports.default = generateAlphabeticName;
	module.exports = exports['default'];

/***/ },
/* 3270 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getComponentName;
	
	
	/* eslint-disable no-undef */
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	module.exports = exports['default'];

/***/ },
/* 3271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	exports.default = function (strings, interpolations) {
	  return interpolations.reduce(function (array, interp, i) {
	    return array.concat(interp, strings[i + 1]);
	  }, [strings[0]]);
	};
	
	module.exports = exports['default'];

/***/ },
/* 3272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = isTag;
	
	var babelPluginFlowReactPropTypes_proptype_Target = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Target || __webpack_require__(2).any;
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	module.exports = exports['default'];

/***/ },
/* 3273 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	// Helper to call a given function, only once
	exports.default = function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	};
	
	module.exports = exports["default"];

/***/ },
/* 3274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _stylis = __webpack_require__(3282);
	
	var _stylis2 = _interopRequireDefault(_stylis);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Interpolation = __webpack_require__(42).babelPluginFlowReactPropTypes_proptype_Interpolation || __webpack_require__(2).any;
	
	var stylis = new _stylis2.default({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: true
	});
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	exports.default = stringifyRules;
	module.exports = exports['default'];

/***/ },
/* 3275 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 **/
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ntrol|ord)s|o(?:lor(?:Interpolation)?|ntent)|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|o(?:ntextMenu|ls)|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|(?:rossOrigi|olSpa)n|apHeight|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|in(?:tercep|lis)|restar|forma|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;
	
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	exports.default = function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	};
	
	module.exports = exports['default'];

/***/ },
/* 3276 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 3277 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Revert the palette
	 * @example
	 * reversePalette({ primary: ['red', 'yellow', 'green'] })
	 * // { primary: ['green', 'yellow', 'red'] }
	 */
	var reversePalette = exports.reversePalette = function reversePalette(palette) {
	  return Object.keys(palette).reduce(function (newPalette, key) {
	    return _extends({}, newPalette, _defineProperty({}, key, [].concat(_toConsumableArray(palette[key])).reverse()));
	  }, {});
	};

/***/ },
/* 3278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.palette = exports.size = exports.font = exports.key = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _styledTools = __webpack_require__(3281);
	
	var _theme = __webpack_require__(3279);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the value of `props.theme[path]` or `styledTheme[path]`
	 * @example
	 * const Button = styled.button`
	 *  font-family: ${key('fonts.primary')};
	 *  color: ${key(['colors', 'primary', 0])};
	 * `
	 */
	var key = exports.key = function key(path, defaultValue) {
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _styledTools.prop)(path, (0, _styledTools.prop)(path, defaultValue)(_theme2.default))(props.theme);
	  };
	};
	
	/**
	 * Shorthand to `key(['fonts', path])`
	 * @example
	 * const Button = styled.button`
	 *  font-family: ${font('primary')};
	 * `
	 */
	var font = exports.font = function font(path, defaultValue) {
	  return key(['fonts', path], defaultValue);
	};
	
	/**
	 * Shorthand to `key(['sizes', path])`
	 * @example
	 * const Button = styled.button`
	 *  padding: ${size('padding')};
	 * `
	 */
	var size = exports.size = function size(path, defaultValue) {
	  return key(['sizes', path], defaultValue);
	};
	
	/**
	 * Returns the value of `props.theme[palette || reversePalette][path][index]` or
	 * `styledTheme[palette || reversePalette][path][index]` (default theme)
	 *
	 * The arguments can be passed in any order, as long as types are kept.
	 * @param {number} index The index of tone in theme palette tones array
	 * @param {string} [path=props.palette] The key of the tones in theme palette object
	 * @param {Object} [exceptions] An object with path as key and index as value
	 * @param {boolean} [reverse] Flag to return tone from `reversePalette` or `palette`
	 * @param {string} [defaultValue] Default value
	 * @example
	 * // index = 1
	 * // exception = { grayscale: 0 }
	 * // reverse = true
	 * const Button = styled.button`
	 *  background-color: ${palette({ grayscale: 0 }, 1, true)};
	 * `
	 *
	 * // renders props.theme.reversePalette.grayscale[0]
	 * <Button palette="grayscale" />
	 *
	 * // renders props.theme.palette.danger[1] (nullify reverse)
	 * <Button palette="danger" reverse />
	 * @returns {Tones}
	 */
	// eslint-disable-next-line flowtype-errors/show-errors
	var palette = exports.palette = function palette() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var exceptions = args.find(function (arg) {
	      return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object';
	    }) || {};
	    var path = args.find(function (arg) {
	      return typeof arg === 'string';
	    }) || props.palette;
	    var defaultValue = [].concat(args).reverse().find(function (arg) {
	      return typeof arg === 'string';
	    });
	    var index = args.find(function (arg) {
	      return typeof arg === 'number';
	    });
	    var reverse = args.find(function (arg) {
	      return typeof arg === 'boolean';
	    });
	    reverse = reverse ? !props.reverse : props.reverse;
	
	    if (typeof index === 'undefined') {
	      throw new Error('[palette] You must pass index');
	    }
	    if (typeof path === 'undefined') {
	      throw new Error('[palette] You must pass palette path');
	    }
	
	    if (Object.keys(exceptions).indexOf(path) >= 0) {
	      index = exceptions[path];
	    }
	
	    var palettePath = reverse ? 'reversePalette' : 'palette';
	    return key([palettePath, path, index], defaultValue !== path && defaultValue)(props);
	  };
	};

/***/ },
/* 3279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _coolorsToHex = __webpack_require__(1866);
	
	var _coolorsToHex2 = _interopRequireDefault(_coolorsToHex);
	
	var _composer = __webpack_require__(3277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var theme = {};
	
	theme.palette = {
	  primary: (0, _coolorsToHex2.default)('https://coolors.co/1976d2-2196f3-71bcf7-97cef9-c2e2fb'),
	  secondary: (0, _coolorsToHex2.default)('https://coolors.co/c2185b-e91e63-f06292-f48caf-f8bbd0'),
	  danger: (0, _coolorsToHex2.default)('https://coolors.co/d32f2f-f44336-f8877f-f9a7a1-ffcdd2'),
	  alert: (0, _coolorsToHex2.default)('https://coolors.co/ffa000-ffc107-ffd761-ffecb3-fff2ce'),
	  success: (0, _coolorsToHex2.default)('https://coolors.co/388e3c-4caf50-7cc47f-9fd4a1-c8e6c9'),
	  grayscale: ['#212121', '#616161', '#9e9e9e', '#bdbdbd', '#e0e0e0', '#ffffff']
	};
	
	theme.reversePalette = (0, _composer.reversePalette)(theme.palette);
	
	theme.fonts = {
	  primary: 'Helvetica Neue, Helvetica, Roboto, sans-serif',
	  pre: 'Consolas, Liberation Mono, Menlo, Courier, monospace',
	  quote: 'Georgia, serif'
	};
	
	theme.sizes = {
	  maxWidth: '1100px'
	};
	
	exports.default = theme;

/***/ },
/* 3280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.switchProp = exports.ifProp = exports.get = exports.prop = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _get2 = __webpack_require__(153);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _at = __webpack_require__(2424);
	
	var _at2 = _interopRequireDefault(_at);
	
	var _values = __webpack_require__(465);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _difference = __webpack_require__(2426);
	
	var _difference2 = _interopRequireDefault(_difference);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns the value of `props[path]` or `defaultValue`
	 * @example
	 * const Button = styled.button`
	 *  color: ${prop('color', 'red')};
	 * `
	 */
	var prop = exports.prop = function prop(path, defaultValue) {
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return (0, _get3.default)(props, path, defaultValue);
	  };
	};
	
	var get = exports.get = prop;
	
	/**
	 * Returns `pass` if prop is truthy. Otherwise returns `fail`
	 * @example
	 * // usage with styled-theme
	 * import styled from 'styled-components'
	 * import { ifProp } from 'styled-tools'
	 * import { palette } from 'styled-theme'
	 *
	 * const Button = styled.button`
	 *  background-color: ${ifProp('transparent', 'transparent', palette(0))};
	 *  color: ${ifProp(['transparent', 'accent'], palette('secondary', 0))};
	 *  font-size: ${ifProp({ size: 'large' }, '20px', ifProp({ size: 'medium' }, '16px', '12px'))};
	 *`
	 */
	var ifProp = exports.ifProp = function ifProp(needle, pass, fail) {
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var result = void 0;
	    if (Array.isArray(needle)) {
	      result = !(0, _at2.default)(props, needle).filter(function (value) {
	        return !value;
	      }).length;
	    } else if ((typeof needle === 'undefined' ? 'undefined' : _typeof(needle)) === 'object') {
	      var needleKeys = Object.keys(needle);
	      var needleValues = (0, _values2.default)(needle);
	      result = !(0, _difference2.default)((0, _at2.default)(props, needleKeys), needleValues).length;
	    } else {
	      result = (0, _get3.default)(props, needle);
	    }
	    return result ? pass : fail;
	  };
	};
	
	/**
	 * Switches on a given prop. Returns the value or function for a given prop value.
	 * @example
	 * import styled, { css } from 'styled-components'
	 * import { switchProp } from 'styled-theme'
	 *
	 * const Button = styled.button`
	 *  font-size: ${switchProp('size', {
	 *    small: prop('theme.sizes.sm', '12px'),
	 *    large: prop('theme.sizes.lg', '20px'),
	 *    default: prop('theme.sizes.md', '16px'),
	 *  })};
	 *  ${switchProp('theme.kind', {
	 *    light: css`
	 *      color: LightBlue;
	 *    `,
	 *    dark: css`
	 *      color: DarkBlue;
	 *    `,
	 *  })}
	 * `
	 *
	 * <Button size="large" theme={{ kind: 'light' }} />
	 */
	var switchProp = exports.switchProp = function switchProp(needle, switches) {
	  return function () {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var propType = (0, _get3.default)(props, needle);
	    return (0, _get3.default)(switches, propType);
	  };
	};

/***/ },
/* 3281 */
[3448, 3280],
/* 3282 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([^]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 169 /* <at>i */
		var CHARSET = 163 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(++length)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											caret++
											code = first
										}
										case COLON:
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								code = body.charCodeAt(caret)
	
								switch (code) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first + second) {
									case NULL: {
										break
									}
									case IMPORT:
									case CHARSET: {
										flat += chars + body.charAt(caret)
										break
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON)
											break
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust: t, e, x
				case 1015: {
					// text-size-adjust, -
					return out.charCodeAt(9) === DASH ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					return out.charCodeAt(8) === DASH ? webkit + out + out : out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '') + out
							}
						}
					}
					break
				}
				// width: min-content / width: max-content
				case 953: {
					if ((index = out.indexOf('-content', 9)) > 0) {
						// width: min-content / width: max-content
						if (out.charCodeAt(index - 3) === 109 && out.charCodeAt(index - 4) !== 45) {
							cache = out.substring(index - 3)
							return 'width:' + webkit + cache + 'width:' + moz + cache + 'width:' + cache
						}
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		var i = 0
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
	
			switch (out) {
				case void 0:
				case false:
				case true:
				case null:
				case content: {
					break
				}
				default: {
					return out
				}
			}
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					switch (plugin.constructor) {
						case Array: {
							for (var i = 0, length = plugin.length; i < length; ++i) {
								use(plugin[i])
							}
							break
						}
						case Function: {
							plugins[plugged++] = plugin
							break
						}
						case Boolean: {
							unkwn = !!plugin|0
						}
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 3283 */
/***/ function(module, exports) {

	function Agent() {
	  this._defaults = [];
	}
	
	["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
	 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
	  /** Default setting for all requests from this agent */
	  Agent.prototype[fn] = function(/*varargs*/) {
	    this._defaults.push({fn:fn, arguments:arguments});
	    return this;
	  }
	});
	
	Agent.prototype._setDefaults = function(req) {
	    this._defaults.forEach(function(def) {
	      req[def.fn].apply(req, def.arguments);
	    });
	};
	
	module.exports = Agent;


/***/ },
/* 3284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module of mixed-in functions shared between node and client code
	 */
	var isObject = __webpack_require__(1411);
	
	/**
	 * Expose `RequestBase`.
	 */
	
	module.exports = RequestBase;
	
	/**
	 * Initialize a new `RequestBase`.
	 *
	 * @api public
	 */
	
	function RequestBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in RequestBase.prototype) {
	    obj[key] = RequestBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.clearTimeout = function _clearTimeout(){
	  clearTimeout(this._timer);
	  clearTimeout(this._responseTimeoutTimer);
	  delete this._timer;
	  delete this._responseTimeoutTimer;
	  return this;
	};
	
	/**
	 * Override default response body parser
	 *
	 * This function will be called to convert incoming data into request.body
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.parse = function parse(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set format of binary response body.
	 * In browser valid formats are 'blob' and 'arraybuffer',
	 * which return Blob and ArrayBuffer, respectively.
	 *
	 * In Node all values result in Buffer.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .responseType('blob')
	 *        .end(callback);
	 *
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.responseType = function(val){
	  this._responseType = val;
	  return this;
	};
	
	/**
	 * Override default request body serializer
	 *
	 * This function will be called to convert data set via .send or .attach into payload to send
	 *
	 * @param {Function}
	 * @api public
	 */
	
	RequestBase.prototype.serialize = function serialize(fn){
	  this._serializer = fn;
	  return this;
	};
	
	/**
	 * Set timeouts.
	 *
	 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
	 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
	 *
	 * Value of 0 or false means no timeout.
	 *
	 * @param {Number|Object} ms or {response, deadline}
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.timeout = function timeout(options){
	  if (!options || 'object' !== typeof options) {
	    this._timeout = options;
	    this._responseTimeout = 0;
	    return this;
	  }
	
	  for(var option in options) {
	    switch(option) {
	      case 'deadline':
	        this._timeout = options.deadline;
	        break;
	      case 'response':
	        this._responseTimeout = options.response;
	        break;
	      default:
	        console.warn("Unknown timeout option", option);
	    }
	  }
	  return this;
	};
	
	/**
	 * Set number of retry attempts on error.
	 *
	 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
	 *
	 * @param {Number} count
	 * @param {Function} [fn]
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.retry = function retry(count, fn){
	  // Default to 1 if no count passed or true
	  if (arguments.length === 0 || count === true) count = 1;
	  if (count <= 0) count = 0;
	  this._maxRetries = count;
	  this._retries = 0;
	  this._retryCallback = fn;
	  return this;
	};
	
	var ERROR_CODES = [
	  'ECONNRESET',
	  'ETIMEDOUT',
	  'EADDRINFO',
	  'ESOCKETTIMEDOUT'
	];
	
	/**
	 * Determine if a request should be retried.
	 * (Borrowed from segmentio/superagent-retry)
	 *
	 * @param {Error} err
	 * @param {Response} [res]
	 * @returns {Boolean}
	 */
	RequestBase.prototype._shouldRetry = function(err, res) {
	  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
	    return false;
	  }
	  if (this._retryCallback) {
	    try {
	      var override = this._retryCallback(err, res);
	      if (override === true) return true;
	      if (override === false) return false;
	      // undefined falls back to defaults
	    } catch(e) {
	      console.error(e);
	    }
	  }
	  if (res && res.status && res.status >= 500 && res.status != 501) return true;
	  if (err) {
	    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
	    // Superagent timeout
	    if (err.timeout && err.code == 'ECONNABORTED') return true;
	    if (err.crossDomain) return true;
	  }
	  return false;
	};
	
	/**
	 * Retry request
	 *
	 * @return {Request} for chaining
	 * @api private
	 */
	
	RequestBase.prototype._retry = function() {
	
	  this.clearTimeout();
	
	  // node
	  if (this.req) {
	    this.req = null;
	    this.req = this.request();
	  }
	
	  this._aborted = false;
	  this.timedout = false;
	
	  return this._end();
	};
	
	/**
	 * Promise support
	 *
	 * @param {Function} resolve
	 * @param {Function} [reject]
	 * @return {Request}
	 */
	
	RequestBase.prototype.then = function then(resolve, reject) {
	  if (!this._fullfilledPromise) {
	    var self = this;
	    if (this._endCalled) {
	      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
	    }
	    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
	      self.end(function(err, res) {
	        if (err) innerReject(err);
	        else innerResolve(res);
	      });
	    });
	  }
	  return this._fullfilledPromise.then(resolve, reject);
	};
	
	RequestBase.prototype.catch = function(cb) {
	  return this.then(undefined, cb);
	};
	
	/**
	 * Allow for extension
	 */
	
	RequestBase.prototype.use = function use(fn) {
	  fn(this);
	  return this;
	};
	
	RequestBase.prototype.ok = function(cb) {
	  if ('function' !== typeof cb) throw Error("Callback required");
	  this._okCallback = cb;
	  return this;
	};
	
	RequestBase.prototype._isResponseOK = function(res) {
	  if (!res) {
	    return false;
	  }
	
	  if (this._okCallback) {
	    return this._okCallback(res);
	  }
	
	  return res.status >= 200 && res.status < 300;
	};
	
	/**
	 * Get request header `field`.
	 * Case-insensitive.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	RequestBase.prototype.get = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 * This is a deprecated internal API. Use `.get(field)` instead.
	 *
	 * (getHeader is no longer used internally by the superagent code base)
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 * @deprecated
	 */
	
	RequestBase.prototype.getHeader = RequestBase.prototype.get;
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 * Case-insensitive.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 * Case-insensitive.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 */
	RequestBase.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Write the field `name` and `val`, or multiple fields with one object
	 * for "multipart/form-data" request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 *
	 * request.post('/upload')
	 *   .field({ foo: 'bar', baz: 'qux' })
	 *   .end(callback);
	 * ```
	 *
	 * @param {String|Object} name
	 * @param {String|Blob|File|Buffer|fs.ReadStream} val
	 * @return {Request} for chaining
	 * @api public
	 */
	RequestBase.prototype.field = function(name, val) {
	  // name should be either a string or an object.
	  if (null === name || undefined === name) {
	    throw new Error('.field(name, val) name can not be empty');
	  }
	
	  if (this._data) {
	    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObject(name)) {
	    for (var key in name) {
	      this.field(key, name[key]);
	    }
	    return this;
	  }
	
	  if (Array.isArray(val)) {
	    for (var i in val) {
	      this.field(name, val[i]);
	    }
	    return this;
	  }
	
	  // val should be defined now
	  if (null === val || undefined === val) {
	    throw new Error('.field(name, val) val can not be empty');
	  }
	  if ('boolean' === typeof val) {
	    val = '' + val;
	  }
	  this._getFormData().append(name, val);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	RequestBase.prototype.abort = function(){
	  if (this._aborted) {
	    return this;
	  }
	  this._aborted = true;
	  this.xhr && this.xhr.abort(); // browser
	  this.req && this.req.abort(); // node
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
	  switch (options.type) {
	    case 'basic':
	      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
	      break;
	
	    case 'auto':
	      this.username = user;
	      this.password = pass;
	      break;
	
	    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
	      this.set('Authorization', 'Bearer ' + user);
	      break;
	  }
	  return this;
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	RequestBase.prototype.withCredentials = function(on) {
	  // This is browser-only functionality. Node side is no-op.
	  if (on == undefined) on = true;
	  this._withCredentials = on;
	  return this;
	};
	
	/**
	 * Set the max redirects to `n`. Does noting in browser XHR implementation.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.redirects = function(n){
	  this._maxRedirects = n;
	  return this;
	};
	
	/**
	 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
	 * Default 200MB.
	 *
	 * @param {Number} n
	 * @return {Request} for chaining
	 */
	RequestBase.prototype.maxResponseSize = function(n){
	  if ('number' !== typeof n) {
	    throw TypeError("Invalid argument");
	  }
	  this._maxResponseSize = n;
	  return this;
	};
	
	/**
	 * Convert to a plain javascript object (not JSON string) of scalar properties.
	 * Note as this method is designed to return a useful non-this value,
	 * it cannot be chained.
	 *
	 * @return {Object} describing method, url, and data of this request
	 * @api public
	 */
	
	RequestBase.prototype.toJSON = function() {
	  return {
	    method: this.method,
	    url: this.url,
	    data: this._data,
	    headers: this._header,
	  };
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	 *      request.post('/user')
	 *        .send('name=tobi')
	 *        .send('species=ferret')
	 *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.send = function(data){
	  var isObj = isObject(data);
	  var type = this._header['content-type'];
	
	  if (this._formData) {
	    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
	  }
	
	  if (isObj && !this._data) {
	    if (Array.isArray(data)) {
	      this._data = [];
	    } else if (!this._isHost(data)) {
	      this._data = {};
	    }
	  } else if (data && this._data && this._isHost(this._data)) {
	    throw Error("Can't merge these send calls");
	  }
	
	  // merge
	  if (isObj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    // default to x-www-form-urlencoded
	    if (!type) this.type('form');
	    type = this._header['content-type'];
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!isObj || this._isHost(data)) {
	    return this;
	  }
	
	  // default to json
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Sort `querystring` by the sort function
	 *
	 *
	 * Examples:
	 *
	 *       // default order
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery()
	 *         .end(callback)
	 *
	 *       // customized sort function
	 *       request.get('/user')
	 *         .query('name=Nick')
	 *         .query('search=Manny')
	 *         .sortQuery(function(a, b){
	 *           return a.length - b.length;
	 *         })
	 *         .end(callback)
	 *
	 *
	 * @param {Function} sort
	 * @return {Request} for chaining
	 * @api public
	 */
	
	RequestBase.prototype.sortQuery = function(sort) {
	  // _sort default to true but otherwise can be a function or boolean
	  this._sort = typeof sort === 'undefined' ? true : sort;
	  return this;
	};
	
	/**
	 * Compose querystring to append to req.url
	 *
	 * @api private
	 */
	RequestBase.prototype._finalizeQueryString = function(){
	  var query = this._query.join('&');
	  if (query) {
	    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
	  }
	  this._query.length = 0; // Makes the call idempotent
	
	  if (this._sort) {
	    var index = this.url.indexOf('?');
	    if (index >= 0) {
	      var queryArr = this.url.substring(index + 1).split('&');
	      if ('function' === typeof this._sort) {
	        queryArr.sort(this._sort);
	      } else {
	        queryArr.sort();
	      }
	      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
	    }
	  }
	};
	
	// For backwards compat only
	RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	RequestBase.prototype._timeoutError = function(reason, timeout, errno){
	  if (this._aborted) {
	    return;
	  }
	  var err = new Error(reason + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  err.code = 'ECONNABORTED';
	  err.errno = errno;
	  this.timedout = true;
	  this.abort();
	  this.callback(err);
	};
	
	RequestBase.prototype._setTimeouts = function() {
	  var self = this;
	
	  // deadline
	  if (this._timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
	    }, this._timeout);
	  }
	  // response timeout
	  if (this._responseTimeout && !this._responseTimeoutTimer) {
	    this._responseTimeoutTimer = setTimeout(function(){
	      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
	    }, this._responseTimeout);
	  }
	};


/***/ },
/* 3285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(3286);
	
	/**
	 * Expose `ResponseBase`.
	 */
	
	module.exports = ResponseBase;
	
	/**
	 * Initialize a new `ResponseBase`.
	 *
	 * @api public
	 */
	
	function ResponseBase(obj) {
	  if (obj) return mixin(obj);
	}
	
	/**
	 * Mixin the prototype properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in ResponseBase.prototype) {
	    obj[key] = ResponseBase.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	ResponseBase.prototype.get = function(field) {
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	ResponseBase.prototype._setHeaderProperties = function(header){
	    // TODO: moar!
	    // TODO: make this a util
	
	    // content-type
	    var ct = header['content-type'] || '';
	    this.type = utils.type(ct);
	
	    // params
	    var params = utils.params(ct);
	    for (var key in params) this[key] = params[key];
	
	    this.links = {};
	
	    // links
	    try {
	        if (header.link) {
	            this.links = utils.parseLinks(header.link);
	        }
	    } catch (err) {
	        // ignore
	    }
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	ResponseBase.prototype._setStatusProperties = function(status){
	    var type = status / 100 | 0;
	
	    // status / class
	    this.status = this.statusCode = status;
	    this.statusType = type;
	
	    // basics
	    this.info = 1 == type;
	    this.ok = 2 == type;
	    this.redirect = 3 == type;
	    this.clientError = 4 == type;
	    this.serverError = 5 == type;
	    this.error = (4 == type || 5 == type)
	        ? this.toError()
	        : false;
	
	    // sugar
	    this.accepted = 202 == status;
	    this.noContent = 204 == status;
	    this.badRequest = 400 == status;
	    this.unauthorized = 401 == status;
	    this.notAcceptable = 406 == status;
	    this.forbidden = 403 == status;
	    this.notFound = 404 == status;
	};


/***/ },
/* 3286 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	exports.type = function(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.params = function(str){
	  return str.split(/ *; */).reduce(function(obj, str){
	    var parts = str.split(/ *= */);
	    var key = parts.shift();
	    var val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Parse Link header fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	exports.parseLinks = function(str){
	  return str.split(/ *, */).reduce(function(obj, str){
	    var parts = str.split(/ *; */);
	    var url = parts[0].slice(1, -1);
	    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
	    obj[rel] = url;
	    return obj;
	  }, {});
	};
	
	/**
	 * Strip content related fields from `header`.
	 *
	 * @param {Object} header
	 * @return {Object} header
	 * @api private
	 */
	
	exports.cleanHeader = function(header, changesOrigin){
	  delete header['content-type'];
	  delete header['content-length'];
	  delete header['transfer-encoding'];
	  delete header['host'];
	  // secuirty
	  if (changesOrigin) {
	    delete header['authorization'];
	    delete header['cookie'];
	  }
	  return header;
	};


/***/ },
/* 3287 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(3288);


/***/ },
/* 3288 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(3289);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(70)(module)))

/***/ },
/* 3289 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 3290 */
1424,
/* 3291 */
/***/ function(module, exports, __webpack_require__) {

	var matcher = __webpack_require__(3290);
	var wordyWords = [
	  'a number of',
	  'abundance',
	  'accede to',
	  'accelerate',
	  'accentuate',
	  'accompany',
	  'accomplish',
	  'accorded',
	  'accrue',
	  'acquiesce',
	  'acquire',
	  'additional',
	  'adjacent to',
	  'adjustment',
	  'admissible',
	  'advantageous',
	  'adversely impact',
	  'advise',
	  'aforementioned',
	  'aggregate',
	  'aircraft',
	  'all of',
	  'all things considered',
	  'alleviate',
	  'allocate',
	  'along the lines of',
	  'already existing',
	  'alternatively',
	  'amazing',
	  'ameliorate',
	  'anticipate',
	  'apparent',
	  'appreciable',
	  'as a matter of fact',
	  'as a means of',
	  'as far as I\'m concerned',
	  'as of yet',
	  'as to',
	  'as yet',
	  'ascertain',
	  'assistance',
	  'at the present time',
	  'at this time',
	  'attain',
	  'attributable to',
	  'authorize',
	  'because of the fact that',
	  'belated',
	  'benefit from',
	  'bestow',
	  'by means of',
	  'by virtue of the fact that',
	  'by virtue of',
	  'cease',
	  'close proximity',
	  'commence',
	  'comply with',
	  'concerning',
	  'consequently',
	  'consolidate',
	  'constitutes',
	  'demonstrate',
	  'depart',
	  'designate',
	  'discontinue',
	  'due to the fact that',
	  'each and every',
	  'economical',
	  'eliminate',
	  'elucidate',
	  'employ',
	  'endeavor',
	  'enumerate',
	  'equitable',
	  'equivalent',
	  'evaluate',
	  'evidenced',
	  'exclusively',
	  'expedite',
	  'expend',
	  'expiration',
	  'facilitate',
	  'factual evidence',
	  'feasible',
	  'finalize',
	  'first and foremost',
	  'for all intents and purposes',
	  'for the most part',
	  'for the purpose of',
	  'forfeit',
	  'formulate',
	  'have a tendency to',
	  'honest truth',
	  'however',
	  'if and when',
	  'impacted',
	  'implement',
	  'in a manner of speaking',
	  'in a timely manner',
	  'in a very real sense',
	  'in accordance with',
	  'in addition',
	  'in all likelihood',
	  'in an effort to',
	  'in between',
	  'in excess of',
	  'in lieu of',
	  'in light of the fact that',
	  'in many cases',
	  'in my opinion',
	  'in order to',
	  'in regard to',
	  'in some instances',
	  'in terms of',
	  'in the case of ',
	  'in the event that',
	  'in the final analysis',
	  'in the nature of',
	  'in the near future',
	  'in the process of',
	  'inception',
	  'incumbent upon',
	  'indicate',
	  'indication',
	  'initiate',
	  'irregardless',
	  'is applicable to',
	  'is authorized to',
	  'is responsible for',
	  'it is essential',
	  'it is',
	  'it seems that',
	  'it was',
	  'magnitude',
	  'maximum',
	  'methodology',
	  'minimize',
	  'minimum',
	  'modify',
	  'monitor',
	  'multiple',
	  'necessitate',
	  'nevertheless',
	  'not certain',
	  'not many',
	  'not often',
	  'not unless',
	  'not unlike',
	  'notwithstanding',
	  'null and void',
	  'numerous',
	  'objective',
	  'obligate',
	  'obtain',
	  'on the contrary',
	  'on the other hand',
	  'one particular',
	  'optimum',
	  'overall',
	  'owing to the fact that',
	  'participate',
	  'particulars',
	  'pass away',
	  'pertaining to',
	  'point in time',
	  'portion',
	  'possess',
	  'preclude',
	  'previously',
	  'prior to',
	  'prioritize',
	  'procure',
	  'proficiency',
	  'provided that',
	  'purchase',
	  'put simply',
	  'readily apparent',
	  'refer back',
	  'regarding',
	  'relocate',
	  'remainder',
	  'remuneration',
	  'requirement',
	  'reside',
	  'residence',
	  'retain',
	  'satisfy',
	  'shall',
	  'should you wish',
	  'similar to',
	  'solicit',
	  'span across',
	  'strategize',
	  'subsequent',
	  'substantial',
	  'successfully complete',
	  'sufficient',
	  'terminate',
	  'the month of',
	  'the point I am trying to make',
	  'therefore',
	  'time period',
	  'took advantage of',
	  'transmit',
	  'transpire',
	  'type of',
	  'until such time as',
	  'utilization',
	  'utilize',
	  'validate',
	  'various different',
	  'what I mean to say is',
	  'whether or not',
	  'with respect to',
	  'with the exception of',
	  'witnessed'
	];
	
	var wordyRegex = new RegExp('\\b(' + wordyWords.join('|') + ')\\b', 'gi');
	
	module.exports = function(text) {
	  return matcher(wordyRegex, text, "wordy");
	};


/***/ },
/* 3292 */
/***/ function(module, exports, __webpack_require__) {

	var transit = __webpack_require__(3293);
	var Immutable = __webpack_require__(35);
	
	function createReader(handlers) {
	  return transit.reader('json', {
	    mapBuilder: {
	      init: function() {
	        return {};
	      },
	      add: function(m, k, v) {
	        m[k] = v;
	        return m;
	      },
	      finalize: function(m) {
	        return m;
	      }
	    },
	    handlers: handlers
	  });
	}
	
	function createReaderHandlers(extras, recordMap, missingRecordHandler) {
	  var handlers = {
	    iM: function(v) {
	      var m = Immutable.Map().asMutable();
	      for (var i = 0; i < v.length; i += 2) {
	        m = m.set(v[i], v[i + 1]);
	      }
	      return m.asImmutable();
	    },
	    iOM: function(v) {
	      var m = Immutable.OrderedMap().asMutable();
	      for (var i = 0; i < v.length; i += 2) {
	        m = m.set(v[i], v[i + 1]);
	      }
	      return m.asImmutable();
	    },
	    iL: function(v) {
	      return Immutable.List(v);
	    },
	    iS: function(v) {
	      return Immutable.Set(v);
	    },
	    iOS: function(v) {
	      return Immutable.OrderedSet(v);
	    },
	    iR: function(v) {
	      var RecordType = recordMap[v.n];
	      if (!RecordType) {
	        return missingRecordHandler(v.n, v.v);
	      }
	
	      return new RecordType(v.v);
	    }
	  };
	  extras.forEach(function(extra) {
	    handlers[extra.tag] = extra.read;
	  });
	  return handlers;
	}
	
	function createWriter(handlers) {
	  return transit.writer('json', {
	    handlers: handlers
	  });
	}
	
	function createWriterHandlers(extras, recordMap, predicate) {
	  function mapSerializer(m) {
	    var i = 0;
	    if (predicate) {
	      m = m.filter(predicate);
	    }
	    var a = new Array(2 * m.size);
	    m.forEach(function(v, k) {
	      a[i++] = k;
	      a[i++] = v;
	    });
	    return a;
	  }
	
	  var handlers = transit.map([
	    Immutable.Map, transit.makeWriteHandler({
	      tag: function() {
	        return 'iM';
	      },
	      rep: mapSerializer
	    }),
	    Immutable.OrderedMap, transit.makeWriteHandler({
	      tag: function() {
	        return 'iOM';
	      },
	      rep: mapSerializer
	    }),
	    Immutable.List, transit.makeWriteHandler({
	      tag: function() {
	        return "iL";
	      },
	      rep: function(v) {
	        if (predicate) {
	          v = v.filter(predicate);
	        }
	        return v.toArray();
	      }
	    }),
	    Immutable.Set, transit.makeWriteHandler({
	      tag: function() {
	        return "iS";
	      },
	      rep: function(v) {
	        if (predicate) {
	          v = v.filter(predicate);
	        }
	        return v.toArray();
	      }
	    }),
	    Immutable.OrderedSet, transit.makeWriteHandler({
	      tag: function() {
	        return "iOS";
	      },
	      rep: function(v) {
	        if (predicate) {
	          v = v.filter(predicate);
	        }
	        return v.toArray();
	      }
	    }),
	    Function, transit.makeWriteHandler({
	      tag: function() {
	        return '_';
	      },
	      rep: function() {
	        return null;
	      }
	    }),
	    "default", transit.makeWriteHandler({
	      tag: function() {
	        return 'iM';
	      },
	      rep: function(m) {
	        if (!('toMap' in m)) {
	          var e = "Error serializing unrecognized object " + m.toString();
	          throw new Error(e);
	        }
	        return mapSerializer(m.toMap());
	      }
	    })
	  ]);
	
	  Object.keys(recordMap).forEach(function(name) {
	    handlers.set(recordMap[name], makeRecordHandler(name, predicate));
	  });
	
	  extras.forEach(function(extra) {
	    handlers.set(extra.class, transit.makeWriteHandler({
	      tag: function() { return extra.tag; },
	      rep: extra.write
	    }));
	  });
	
	  return handlers;
	}
	
	function validateExtras(extras) {
	  if (!Array.isArray(extras)) {
	    invalidExtras(extras, "Expected array of handlers, got %j");
	  }
	  extras.forEach(function(extra) {
	    if (typeof extra.tag !== "string") {
	      invalidExtras(extra,
	        "Expected %j to have property 'tag' which is a string");
	    }
	    if (typeof extra.class !== "function") {
	      invalidExtras(extra,
	        "Expected %j to have property 'class' which is a constructor function");
	    }
	    if (typeof extra.write !== "function") {
	      invalidExtras(extra,
	        "Expected %j to have property 'write' which is a function");
	    }
	    if (typeof extra.read !== "function") {
	      invalidExtras(extra,
	        "Expected %j to have property 'write' which is a function");
	    }
	  });
	}
	function invalidExtras(data, msg) {
	  var json = JSON.stringify(data);
	  throw new Error(msg.replace("%j", json));
	}
	
	function recordName(record) {
	  /* eslint no-underscore-dangle: 0 */
	  return record._name || record.constructor.name || 'Record';
	}
	
	function makeRecordHandler(name) {
	  return transit.makeWriteHandler({
	    tag: function() {
	      return 'iR';
	    },
	    rep: function(m) {
	      return {
	        n: name,
	        v: m.toObject()
	      };
	    }
	  });
	}
	
	function buildRecordMap(recordClasses) {
	  var recordMap = {};
	
	  recordClasses.forEach(function(RecordType) {
	    var rec = new RecordType({});
	    var recName = recordName(rec);
	
	    if (!recName || recName === 'Record') {
	      throw new Error('Cannot (de)serialize Record() without a name');
	    }
	
	    if (recordMap[recName]) {
	      throw new Error('There\'s already a constructor for a Record named ' +
	                      recName);
	    }
	    recordMap[recName] = RecordType;
	  });
	
	  return recordMap;
	}
	
	function defaultMissingRecordHandler(recName) {
	  var msg = 'Tried to deserialize Record type named `' + recName + '`, ' +
	            'but no type with that name was passed to withRecords()';
	  throw new Error(msg);
	}
	
	function createInstanceFromHandlers(handlers) {
	  var reader = createReader(handlers.read);
	  var writer = createWriter(handlers.write);
	
	  return {
	    toJSON: function toJSON(data) {
	      return writer.write(data);
	    },
	    fromJSON: function fromJSON(json) {
	      return reader.read(json);
	    },
	    withExtraHandlers: function(extra) {
	      return createInstanceFromHandlers(handlers.withExtraHandlers(extra));
	    },
	    withFilter: function(predicate) {
	      return createInstanceFromHandlers(handlers.withFilter(predicate));
	    },
	    withRecords: function(recordClasses, missingRecordHandler) {
	      return createInstanceFromHandlers(
	        handlers.withRecords(recordClasses, missingRecordHandler)
	      );
	    }
	  };
	}
	
	function createHandlers(options) {
	  var records = options.records || {};
	  var filter = options.filter || false;
	  var missingRecordFn = options.missingRecordHandler
	                          || defaultMissingRecordHandler;
	  var extras = options.extras || [];
	
	  return {
	    read: createReaderHandlers(extras, records, missingRecordFn),
	    write: createWriterHandlers(extras, records, filter),
	    withExtraHandlers: function(moreExtras) {
	      validateExtras(moreExtras);
	
	      return createHandlers({
	        extras: extras.concat(moreExtras),
	        records: records,
	        filter: filter,
	        missingRecordHandler: missingRecordFn
	      });
	    },
	    withFilter: function(newFilter) {
	      return createHandlers({
	        extras: extras,
	        records: records,
	        filter: newFilter,
	        missingRecordHandler: missingRecordFn
	      });
	    },
	    withRecords: function(recordClasses, missingRecordHandler) {
	      var recordMap = buildRecordMap(recordClasses);
	      return createHandlers({
	        extras: extras,
	        records: recordMap,
	        filter: filter,
	        missingRecordHandler: missingRecordHandler
	      });
	    }
	  };
	}
	
	module.exports = createInstanceFromHandlers(createHandlers({}));
	module.exports.handlers = createHandlers({});


/***/ },
/* 3293 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// transit-js 0.8.847
	// http://transit-format.org
	// 
	// Copyright 2014 Cognitect. All Rights Reserved.
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//      http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS-IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License..
	var COMPILED = !0, goog = goog || {};
	goog.global = this;
	goog.isDef = function(a) {
	  return void 0 !== a;
	};
	goog.exportPath_ = function(a, b, c) {
	  a = a.split(".");
	  c = c || goog.global;
	  a[0] in c || !c.execScript || c.execScript("var " + a[0]);
	  for (var d;a.length && (d = a.shift());) {
	    !a.length && goog.isDef(b) ? c[d] = b : c = c[d] ? c[d] : c[d] = {};
	  }
	};
	goog.define = function(a, b) {
	  var c = b;
	  COMPILED || (goog.global.CLOSURE_UNCOMPILED_DEFINES && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_UNCOMPILED_DEFINES, a) ? c = goog.global.CLOSURE_UNCOMPILED_DEFINES[a] : goog.global.CLOSURE_DEFINES && Object.prototype.hasOwnProperty.call(goog.global.CLOSURE_DEFINES, a) && (c = goog.global.CLOSURE_DEFINES[a]));
	  goog.exportPath_(a, c);
	};
	goog.DEBUG = !0;
	goog.LOCALE = "en";
	goog.TRUSTED_SITE = !0;
	goog.STRICT_MODE_COMPATIBLE = !1;
	goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
	goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
	goog.provide = function(a) {
	  if (!COMPILED && goog.isProvided_(a)) {
	    throw Error('Namespace "' + a + '" already declared.');
	  }
	  goog.constructNamespace_(a);
	};
	goog.constructNamespace_ = function(a, b) {
	  if (!COMPILED) {
	    delete goog.implicitNamespaces_[a];
	    for (var c = a;(c = c.substring(0, c.lastIndexOf("."))) && !goog.getObjectByName(c);) {
	      goog.implicitNamespaces_[c] = !0;
	    }
	  }
	  goog.exportPath_(a, b);
	};
	goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
	goog.module = function(a) {
	  if (!goog.isString(a) || !a || -1 == a.search(goog.VALID_MODULE_RE_)) {
	    throw Error("Invalid module identifier");
	  }
	  if (!goog.isInModuleLoader_()) {
	    throw Error("Module " + a + " has been loaded incorrectly.");
	  }
	  if (goog.moduleLoaderState_.moduleName) {
	    throw Error("goog.module may only be called once per module.");
	  }
	  goog.moduleLoaderState_.moduleName = a;
	  if (!COMPILED) {
	    if (goog.isProvided_(a)) {
	      throw Error('Namespace "' + a + '" already declared.');
	    }
	    delete goog.implicitNamespaces_[a];
	  }
	};
	goog.module.get = function(a) {
	  return goog.module.getInternal_(a);
	};
	goog.module.getInternal_ = function(a) {
	  if (!COMPILED) {
	    return goog.isProvided_(a) ? a in goog.loadedModules_ ? goog.loadedModules_[a] : goog.getObjectByName(a) : null;
	  }
	};
	goog.moduleLoaderState_ = null;
	goog.isInModuleLoader_ = function() {
	  return null != goog.moduleLoaderState_;
	};
	goog.module.declareTestMethods = function() {
	  if (!goog.isInModuleLoader_()) {
	    throw Error("goog.module.declareTestMethods must be called from within a goog.module");
	  }
	  goog.moduleLoaderState_.declareTestMethods = !0;
	};
	goog.module.declareLegacyNamespace = function() {
	  if (!COMPILED && !goog.isInModuleLoader_()) {
	    throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
	  }
	  if (!COMPILED && !goog.moduleLoaderState_.moduleName) {
	    throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
	  }
	  goog.moduleLoaderState_.declareLegacyNamespace = !0;
	};
	goog.setTestOnly = function(a) {
	  if (goog.DISALLOW_TEST_ONLY_CODE) {
	    throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
	  }
	};
	goog.forwardDeclare = function(a) {
	};
	COMPILED || (goog.isProvided_ = function(a) {
	  return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && goog.isDefAndNotNull(goog.getObjectByName(a));
	}, goog.implicitNamespaces_ = {"goog.module":!0});
	goog.getObjectByName = function(a, b) {
	  for (var c = a.split("."), d = b || goog.global, e;e = c.shift();) {
	    if (goog.isDefAndNotNull(d[e])) {
	      d = d[e];
	    } else {
	      return null;
	    }
	  }
	  return d;
	};
	goog.globalize = function(a, b) {
	  var c = b || goog.global, d;
	  for (d in a) {
	    c[d] = a[d];
	  }
	};
	goog.addDependency = function(a, b, c, d) {
	  if (goog.DEPENDENCIES_ENABLED) {
	    var e;
	    a = a.replace(/\\/g, "/");
	    for (var f = goog.dependencies_, g = 0;e = b[g];g++) {
	      f.nameToPath[e] = a, f.pathIsModule[a] = !!d;
	    }
	    for (d = 0;b = c[d];d++) {
	      a in f.requires || (f.requires[a] = {}), f.requires[a][b] = !0;
	    }
	  }
	};
	goog.ENABLE_DEBUG_LOADER = !0;
	goog.logToConsole_ = function(a) {
	  goog.global.console && goog.global.console.error(a);
	};
	goog.require = function(a) {
	  if (!COMPILED) {
	    goog.ENABLE_DEBUG_LOADER && goog.IS_OLD_IE_ && goog.maybeProcessDeferredDep_(a);
	    if (goog.isProvided_(a)) {
	      return goog.isInModuleLoader_() ? goog.module.getInternal_(a) : null;
	    }
	    if (goog.ENABLE_DEBUG_LOADER) {
	      var b = goog.getPathFromDeps_(a);
	      if (b) {
	        return goog.included_[b] = !0, goog.writeScripts_(), null;
	      }
	    }
	    a = "goog.require could not find: " + a;
	    goog.logToConsole_(a);
	    throw Error(a);
	  }
	};
	goog.basePath = "";
	goog.nullFunction = function() {
	};
	goog.abstractMethod = function() {
	  throw Error("unimplemented abstract method");
	};
	goog.addSingletonGetter = function(a) {
	  a.getInstance = function() {
	    if (a.instance_) {
	      return a.instance_;
	    }
	    goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
	    return a.instance_ = new a;
	  };
	};
	goog.instantiatedSingletons_ = [];
	goog.LOAD_MODULE_USING_EVAL = !0;
	goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
	goog.loadedModules_ = {};
	goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
	goog.DEPENDENCIES_ENABLED && (goog.included_ = {}, goog.dependencies_ = {pathIsModule:{}, nameToPath:{}, requires:{}, visited:{}, written:{}, deferred:{}}, goog.inHtmlDocument_ = function() {
	  var a = goog.global.document;
	  return "undefined" != typeof a && "write" in a;
	}, goog.findBasePath_ = function() {
	  if (goog.global.CLOSURE_BASE_PATH) {
	    goog.basePath = goog.global.CLOSURE_BASE_PATH;
	  } else {
	    if (goog.inHtmlDocument_()) {
	      for (var a = goog.global.document.getElementsByTagName("SCRIPT"), b = a.length - 1;0 <= b;--b) {
	        var c = a[b].src, d = c.lastIndexOf("?"), d = -1 == d ? c.length : d;
	        if ("base.js" == c.substr(d - 7, 7)) {
	          goog.basePath = c.substr(0, d - 7);
	          break;
	        }
	      }
	    }
	  }
	}, goog.importScript_ = function(a, b) {
	  (goog.global.CLOSURE_IMPORT_SCRIPT || goog.writeScriptTag_)(a, b) && (goog.dependencies_.written[a] = !0);
	}, goog.IS_OLD_IE_ = !goog.global.atob && goog.global.document && goog.global.document.all, goog.importModule_ = function(a) {
	  goog.importScript_("", 'goog.retrieveAndExecModule_("' + a + '");') && (goog.dependencies_.written[a] = !0);
	}, goog.queuedModules_ = [], goog.wrapModule_ = function(a, b) {
	  return goog.LOAD_MODULE_USING_EVAL && goog.isDef(goog.global.JSON) ? "goog.loadModule(" + goog.global.JSON.stringify(b + "\n//# sourceURL=" + a + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + b + "\n;return exports});\n//# sourceURL=" + a + "\n";
	}, goog.loadQueuedModules_ = function() {
	  var a = goog.queuedModules_.length;
	  if (0 < a) {
	    var b = goog.queuedModules_;
	    goog.queuedModules_ = [];
	    for (var c = 0;c < a;c++) {
	      goog.maybeProcessDeferredPath_(b[c]);
	    }
	  }
	}, goog.maybeProcessDeferredDep_ = function(a) {
	  goog.isDeferredModule_(a) && goog.allDepsAreAvailable_(a) && (a = goog.getPathFromDeps_(a), goog.maybeProcessDeferredPath_(goog.basePath + a));
	}, goog.isDeferredModule_ = function(a) {
	  return (a = goog.getPathFromDeps_(a)) && goog.dependencies_.pathIsModule[a] ? goog.basePath + a in goog.dependencies_.deferred : !1;
	}, goog.allDepsAreAvailable_ = function(a) {
	  if ((a = goog.getPathFromDeps_(a)) && a in goog.dependencies_.requires) {
	    for (var b in goog.dependencies_.requires[a]) {
	      if (!goog.isProvided_(b) && !goog.isDeferredModule_(b)) {
	        return !1;
	      }
	    }
	  }
	  return !0;
	}, goog.maybeProcessDeferredPath_ = function(a) {
	  if (a in goog.dependencies_.deferred) {
	    var b = goog.dependencies_.deferred[a];
	    delete goog.dependencies_.deferred[a];
	    goog.globalEval(b);
	  }
	}, goog.loadModule = function(a) {
	  var b = goog.moduleLoaderState_;
	  try {
	    goog.moduleLoaderState_ = {moduleName:void 0, declareTestMethods:!1};
	    var c;
	    if (goog.isFunction(a)) {
	      c = a.call(goog.global, {});
	    } else {
	      if (goog.isString(a)) {
	        c = goog.loadModuleFromSource_.call(goog.global, a);
	      } else {
	        throw Error("Invalid module definition");
	      }
	    }
	    var d = goog.moduleLoaderState_.moduleName;
	    if (!goog.isString(d) || !d) {
	      throw Error('Invalid module name "' + d + '"');
	    }
	    goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && Object.seal(c);
	    goog.loadedModules_[d] = c;
	    if (goog.moduleLoaderState_.declareTestMethods) {
	      for (var e in c) {
	        if (0 === e.indexOf("test", 0) || "tearDown" == e || "setUp" == e || "setUpPage" == e || "tearDownPage" == e) {
	          goog.global[e] = c[e];
	        }
	      }
	    }
	  } finally {
	    goog.moduleLoaderState_ = b;
	  }
	}, goog.loadModuleFromSource_ = function(a) {
	  eval(a);
	  return {};
	}, goog.writeScriptSrcNode_ = function(a) {
	  goog.global.document.write('<script type="text/javascript" src="' + a + '">\x3c/script>');
	}, goog.appendScriptSrcNode_ = function(a) {
	  var b = goog.global.document, c = b.createElement("script");
	  c.type = "text/javascript";
	  c.src = a;
	  c.defer = !1;
	  c.async = !1;
	  b.head.appendChild(c);
	}, goog.writeScriptTag_ = function(a, b) {
	  if (goog.inHtmlDocument_()) {
	    var c = goog.global.document;
	    if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && "complete" == c.readyState) {
	      if (/\bdeps.js$/.test(a)) {
	        return !1;
	      }
	      throw Error('Cannot write "' + a + '" after document load');
	    }
	    var d = goog.IS_OLD_IE_;
	    void 0 === b ? d ? (d = " onreadystatechange='goog.onScriptLoad_(this, " + ++goog.lastNonModuleScriptIndex_ + ")' ", c.write('<script type="text/javascript" src="' + a + '"' + d + ">\x3c/script>")) : goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING ? goog.appendScriptSrcNode_(a) : goog.writeScriptSrcNode_(a) : c.write('<script type="text/javascript">' + b + "\x3c/script>");
	    return !0;
	  }
	  return !1;
	}, goog.lastNonModuleScriptIndex_ = 0, goog.onScriptLoad_ = function(a, b) {
	  "complete" == a.readyState && goog.lastNonModuleScriptIndex_ == b && goog.loadQueuedModules_();
	  return !0;
	}, goog.writeScripts_ = function() {
	  function a(e) {
	    if (!(e in d.written)) {
	      if (!(e in d.visited) && (d.visited[e] = !0, e in d.requires)) {
	        for (var f in d.requires[e]) {
	          if (!goog.isProvided_(f)) {
	            if (f in d.nameToPath) {
	              a(d.nameToPath[f]);
	            } else {
	              throw Error("Undefined nameToPath for " + f);
	            }
	          }
	        }
	      }
	      e in c || (c[e] = !0, b.push(e));
	    }
	  }
	  var b = [], c = {}, d = goog.dependencies_, e;
	  for (e in goog.included_) {
	    d.written[e] || a(e);
	  }
	  for (var f = 0;f < b.length;f++) {
	    e = b[f], goog.dependencies_.written[e] = !0;
	  }
	  var g = goog.moduleLoaderState_;
	  goog.moduleLoaderState_ = null;
	  for (f = 0;f < b.length;f++) {
	    if (e = b[f]) {
	      d.pathIsModule[e] ? goog.importModule_(goog.basePath + e) : goog.importScript_(goog.basePath + e);
	    } else {
	      throw goog.moduleLoaderState_ = g, Error("Undefined script input");
	    }
	  }
	  goog.moduleLoaderState_ = g;
	}, goog.getPathFromDeps_ = function(a) {
	  return a in goog.dependencies_.nameToPath ? goog.dependencies_.nameToPath[a] : null;
	}, goog.findBasePath_(), goog.global.CLOSURE_NO_DEPS || goog.importScript_(goog.basePath + "deps.js"));
	goog.normalizePath_ = function(a) {
	  a = a.split("/");
	  for (var b = 0;b < a.length;) {
	    "." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
	  }
	  return a.join("/");
	};
	goog.loadFileSync_ = function(a) {
	  if (goog.global.CLOSURE_LOAD_FILE_SYNC) {
	    return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
	  }
	  var b = new goog.global.XMLHttpRequest;
	  b.open("get", a, !1);
	  b.send();
	  return b.responseText;
	};
	goog.retrieveAndExecModule_ = function(a) {
	  if (!COMPILED) {
	    var b = a;
	    a = goog.normalizePath_(a);
	    var c = goog.global.CLOSURE_IMPORT_SCRIPT || goog.writeScriptTag_, d = goog.loadFileSync_(a);
	    if (null != d) {
	      d = goog.wrapModule_(a, d), goog.IS_OLD_IE_ ? (goog.dependencies_.deferred[b] = d, goog.queuedModules_.push(b)) : c(a, d);
	    } else {
	      throw Error("load of " + a + "failed");
	    }
	  }
	};
	goog.typeOf = function(a) {
	  var b = typeof a;
	  if ("object" == b) {
	    if (a) {
	      if (a instanceof Array) {
	        return "array";
	      }
	      if (a instanceof Object) {
	        return b;
	      }
	      var c = Object.prototype.toString.call(a);
	      if ("[object Window]" == c) {
	        return "object";
	      }
	      if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) {
	        return "array";
	      }
	      if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) {
	        return "function";
	      }
	    } else {
	      return "null";
	    }
	  } else {
	    if ("function" == b && "undefined" == typeof a.call) {
	      return "object";
	    }
	  }
	  return b;
	};
	goog.isNull = function(a) {
	  return null === a;
	};
	goog.isDefAndNotNull = function(a) {
	  return null != a;
	};
	goog.isArray = function(a) {
	  return "array" == goog.typeOf(a);
	};
	goog.isArrayLike = function(a) {
	  var b = goog.typeOf(a);
	  return "array" == b || "object" == b && "number" == typeof a.length;
	};
	goog.isDateLike = function(a) {
	  return goog.isObject(a) && "function" == typeof a.getFullYear;
	};
	goog.isString = function(a) {
	  return "string" == typeof a;
	};
	goog.isBoolean = function(a) {
	  return "boolean" == typeof a;
	};
	goog.isNumber = function(a) {
	  return "number" == typeof a;
	};
	goog.isFunction = function(a) {
	  return "function" == goog.typeOf(a);
	};
	goog.isObject = function(a) {
	  var b = typeof a;
	  return "object" == b && null != a || "function" == b;
	};
	goog.getUid = function(a) {
	  return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
	};
	goog.hasUid = function(a) {
	  return !!a[goog.UID_PROPERTY_];
	};
	goog.removeUid = function(a) {
	  "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
	  try {
	    delete a[goog.UID_PROPERTY_];
	  } catch (b) {
	  }
	};
	goog.UID_PROPERTY_ = "closure_uid_" + (1E9 * Math.random() >>> 0);
	goog.uidCounter_ = 0;
	goog.getHashCode = goog.getUid;
	goog.removeHashCode = goog.removeUid;
	goog.cloneObject = function(a) {
	  var b = goog.typeOf(a);
	  if ("object" == b || "array" == b) {
	    if (a.clone) {
	      return a.clone();
	    }
	    var b = "array" == b ? [] : {}, c;
	    for (c in a) {
	      b[c] = goog.cloneObject(a[c]);
	    }
	    return b;
	  }
	  return a;
	};
	goog.bindNative_ = function(a, b, c) {
	  return a.call.apply(a.bind, arguments);
	};
	goog.bindJs_ = function(a, b, c) {
	  if (!a) {
	    throw Error();
	  }
	  if (2 < arguments.length) {
	    var d = Array.prototype.slice.call(arguments, 2);
	    return function() {
	      var c = Array.prototype.slice.call(arguments);
	      Array.prototype.unshift.apply(c, d);
	      return a.apply(b, c);
	    };
	  }
	  return function() {
	    return a.apply(b, arguments);
	  };
	};
	goog.bind = function(a, b, c) {
	  Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
	  return goog.bind.apply(null, arguments);
	};
	goog.partial = function(a, b) {
	  var c = Array.prototype.slice.call(arguments, 1);
	  return function() {
	    var b = c.slice();
	    b.push.apply(b, arguments);
	    return a.apply(this, b);
	  };
	};
	goog.mixin = function(a, b) {
	  for (var c in b) {
	    a[c] = b[c];
	  }
	};
	goog.now = goog.TRUSTED_SITE && Date.now || function() {
	  return +new Date;
	};
	goog.globalEval = function(a) {
	  if (goog.global.execScript) {
	    goog.global.execScript(a, "JavaScript");
	  } else {
	    if (goog.global.eval) {
	      if (null == goog.evalWorksForGlobals_ && (goog.global.eval("var _et_ = 1;"), "undefined" != typeof goog.global._et_ ? (delete goog.global._et_, goog.evalWorksForGlobals_ = !0) : goog.evalWorksForGlobals_ = !1), goog.evalWorksForGlobals_) {
	        goog.global.eval(a);
	      } else {
	        var b = goog.global.document, c = b.createElement("SCRIPT");
	        c.type = "text/javascript";
	        c.defer = !1;
	        c.appendChild(b.createTextNode(a));
	        b.body.appendChild(c);
	        b.body.removeChild(c);
	      }
	    } else {
	      throw Error("goog.globalEval not available");
	    }
	  }
	};
	goog.evalWorksForGlobals_ = null;
	goog.getCssName = function(a, b) {
	  var c = function(a) {
	    return goog.cssNameMapping_[a] || a;
	  }, d = function(a) {
	    a = a.split("-");
	    for (var b = [], d = 0;d < a.length;d++) {
	      b.push(c(a[d]));
	    }
	    return b.join("-");
	  }, d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(a) {
	    return a;
	  };
	  return b ? a + "-" + d(b) : d(a);
	};
	goog.setCssNameMapping = function(a, b) {
	  goog.cssNameMapping_ = a;
	  goog.cssNameMappingStyle_ = b;
	};
	!COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
	goog.getMsg = function(a, b) {
	  b && (a = a.replace(/\{\$([^}]+)}/g, function(a, d) {
	    return d in b ? b[d] : a;
	  }));
	  return a;
	};
	goog.getMsgWithFallback = function(a, b) {
	  return a;
	};
	goog.exportSymbol = function(a, b, c) {
	  goog.exportPath_(a, b, c);
	};
	goog.exportProperty = function(a, b, c) {
	  a[b] = c;
	};
	goog.inherits = function(a, b) {
	  function c() {
	  }
	  c.prototype = b.prototype;
	  a.superClass_ = b.prototype;
	  a.prototype = new c;
	  a.prototype.constructor = a;
	  a.base = function(a, c, f) {
	    for (var g = Array(arguments.length - 2), h = 2;h < arguments.length;h++) {
	      g[h - 2] = arguments[h];
	    }
	    return b.prototype[c].apply(a, g);
	  };
	};
	goog.base = function(a, b, c) {
	  var d = arguments.callee.caller;
	  if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) {
	    throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
	  }
	  if (d.superClass_) {
	    for (var e = Array(arguments.length - 1), f = 1;f < arguments.length;f++) {
	      e[f - 1] = arguments[f];
	    }
	    return d.superClass_.constructor.apply(a, e);
	  }
	  e = Array(arguments.length - 2);
	  for (f = 2;f < arguments.length;f++) {
	    e[f - 2] = arguments[f];
	  }
	  for (var f = !1, g = a.constructor;g;g = g.superClass_ && g.superClass_.constructor) {
	    if (g.prototype[b] === d) {
	      f = !0;
	    } else {
	      if (f) {
	        return g.prototype[b].apply(a, e);
	      }
	    }
	  }
	  if (a[b] === d) {
	    return a.constructor.prototype[b].apply(a, e);
	  }
	  throw Error("goog.base called from a method of one name to a method of a different name");
	};
	goog.scope = function(a) {
	  a.call(goog.global);
	};
	COMPILED || (goog.global.COMPILED = COMPILED);
	goog.defineClass = function(a, b) {
	  var c = b.constructor, d = b.statics;
	  c && c != Object.prototype.constructor || (c = function() {
	    throw Error("cannot instantiate an interface (no constructor defined).");
	  });
	  c = goog.defineClass.createSealingConstructor_(c, a);
	  a && goog.inherits(c, a);
	  delete b.constructor;
	  delete b.statics;
	  goog.defineClass.applyProperties_(c.prototype, b);
	  null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
	  return c;
	};
	goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
	goog.defineClass.createSealingConstructor_ = function(a, b) {
	  if (goog.defineClass.SEAL_CLASS_INSTANCES && Object.seal instanceof Function) {
	    if (b && b.prototype && b.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_]) {
	      return a;
	    }
	    var c = function() {
	      var b = a.apply(this, arguments) || this;
	      b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
	      this.constructor === c && Object.seal(b);
	      return b;
	    };
	    return c;
	  }
	  return a;
	};
	goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	goog.defineClass.applyProperties_ = function(a, b) {
	  for (var c in b) {
	    Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
	  }
	  for (var d = 0;d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length;d++) {
	    c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
	  }
	};
	goog.tagUnsealableClass = function(a) {
	  !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
	};
	goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
	goog.math = {};
	goog.math.Long = function(a, b) {
	  this.low_ = a | 0;
	  this.high_ = b | 0;
	};
	goog.math.Long.IntCache_ = {};
	goog.math.Long.fromInt = function(a) {
	  if (-128 <= a && 128 > a) {
	    var b = goog.math.Long.IntCache_[a];
	    if (b) {
	      return b;
	    }
	  }
	  b = new goog.math.Long(a | 0, 0 > a ? -1 : 0);
	  -128 <= a && 128 > a && (goog.math.Long.IntCache_[a] = b);
	  return b;
	};
	goog.math.Long.fromNumber = function(a) {
	  return isNaN(a) || !isFinite(a) ? goog.math.Long.getZero() : a <= -goog.math.Long.TWO_PWR_63_DBL_ ? goog.math.Long.getMinValue() : a + 1 >= goog.math.Long.TWO_PWR_63_DBL_ ? goog.math.Long.getMaxValue() : 0 > a ? goog.math.Long.fromNumber(-a).negate() : new goog.math.Long(a % goog.math.Long.TWO_PWR_32_DBL_ | 0, a / goog.math.Long.TWO_PWR_32_DBL_ | 0);
	};
	goog.math.Long.fromBits = function(a, b) {
	  return new goog.math.Long(a, b);
	};
	goog.math.Long.fromString = function(a, b) {
	  if (0 == a.length) {
	    throw Error("number format error: empty string");
	  }
	  var c = b || 10;
	  if (2 > c || 36 < c) {
	    throw Error("radix out of range: " + c);
	  }
	  if ("-" == a.charAt(0)) {
	    return goog.math.Long.fromString(a.substring(1), c).negate();
	  }
	  if (0 <= a.indexOf("-")) {
	    throw Error('number format error: interior "-" character: ' + a);
	  }
	  for (var d = goog.math.Long.fromNumber(Math.pow(c, 8)), e = goog.math.Long.getZero(), f = 0;f < a.length;f += 8) {
	    var g = Math.min(8, a.length - f), h = parseInt(a.substring(f, f + g), c);
	    8 > g ? (g = goog.math.Long.fromNumber(Math.pow(c, g)), e = e.multiply(g).add(goog.math.Long.fromNumber(h))) : (e = e.multiply(d), e = e.add(goog.math.Long.fromNumber(h)));
	  }
	  return e;
	};
	goog.math.Long.TWO_PWR_16_DBL_ = 65536;
	goog.math.Long.getTwoPwr24DBL_ = 16777216;
	goog.math.Long.TWO_PWR_32_DBL_ = goog.math.Long.TWO_PWR_16_DBL_ * goog.math.Long.TWO_PWR_16_DBL_;
	goog.math.Long.TWO_PWR_31_DBL_ = goog.math.Long.TWO_PWR_32_DBL_ / 2;
	goog.math.Long.TWO_PWR_48_DBL_ = goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_16_DBL_;
	goog.math.Long.TWO_PWR_64_DBL_ = goog.math.Long.TWO_PWR_32_DBL_ * goog.math.Long.TWO_PWR_32_DBL_;
	goog.math.Long.TWO_PWR_63_DBL_ = goog.math.Long.TWO_PWR_64_DBL_ / 2;
	goog.math.Long.getZero = function() {
	  goog.math.Long.ZERO_ || (goog.math.Long.ZERO_ = goog.math.Long.fromInt(0));
	  return goog.math.Long.ZERO_;
	};
	goog.math.Long.getOne = function() {
	  goog.math.Long.ONE_ || (goog.math.Long.ONE_ = goog.math.Long.fromInt(1));
	  return goog.math.Long.ONE_;
	};
	goog.math.Long.getNegOne = function() {
	  goog.math.Long.NEG_ONE_ || (goog.math.Long.NEG_ONE_ = goog.math.Long.fromInt(-1));
	  return goog.math.Long.NEG_ONE_;
	};
	goog.math.Long.getMaxValue = function() {
	  goog.math.Long.MAX_VALUE_ || (goog.math.Long.MAX_VALUE_ = goog.math.Long.fromBits(-1, 2147483647));
	  return goog.math.Long.MAX_VALUE_;
	};
	goog.math.Long.getMinValue = function() {
	  goog.math.Long.MIN_VALUE_ || (goog.math.Long.MIN_VALUE_ = goog.math.Long.fromBits(0, -2147483648));
	  return goog.math.Long.MIN_VALUE_;
	};
	goog.math.Long.getTwoPwr24 = function() {
	  goog.math.Long.TWO_PWR_24_ || (goog.math.Long.TWO_PWR_24_ = goog.math.Long.fromInt(16777216));
	  return goog.math.Long.TWO_PWR_24_;
	};
	goog.math.Long.prototype.toInt = function() {
	  return this.low_;
	};
	goog.math.Long.prototype.toNumber = function() {
	  return this.high_ * goog.math.Long.TWO_PWR_32_DBL_ + this.getLowBitsUnsigned();
	};
	goog.math.Long.prototype.toString = function(a) {
	  a = a || 10;
	  if (2 > a || 36 < a) {
	    throw Error("radix out of range: " + a);
	  }
	  if (this.isZero()) {
	    return "0";
	  }
	  if (this.isNegative()) {
	    if (this.equals(goog.math.Long.getMinValue())) {
	      var b = goog.math.Long.fromNumber(a), c = this.div(b), b = c.multiply(b).subtract(this);
	      return c.toString(a) + b.toInt().toString(a);
	    }
	    return "-" + this.negate().toString(a);
	  }
	  for (var c = goog.math.Long.fromNumber(Math.pow(a, 6)), b = this, d = "";;) {
	    var e = b.div(c), f = b.subtract(e.multiply(c)).toInt().toString(a), b = e;
	    if (b.isZero()) {
	      return f + d;
	    }
	    for (;6 > f.length;) {
	      f = "0" + f;
	    }
	    d = "" + f + d;
	  }
	};
	goog.math.Long.prototype.getHighBits = function() {
	  return this.high_;
	};
	goog.math.Long.prototype.getLowBits = function() {
	  return this.low_;
	};
	goog.math.Long.prototype.getLowBitsUnsigned = function() {
	  return 0 <= this.low_ ? this.low_ : goog.math.Long.TWO_PWR_32_DBL_ + this.low_;
	};
	goog.math.Long.prototype.getNumBitsAbs = function() {
	  if (this.isNegative()) {
	    return this.equals(goog.math.Long.getMinValue()) ? 64 : this.negate().getNumBitsAbs();
	  }
	  for (var a = 0 != this.high_ ? this.high_ : this.low_, b = 31;0 < b && 0 == (a & 1 << b);b--) {
	  }
	  return 0 != this.high_ ? b + 33 : b + 1;
	};
	goog.math.Long.prototype.isZero = function() {
	  return 0 == this.high_ && 0 == this.low_;
	};
	goog.math.Long.prototype.isNegative = function() {
	  return 0 > this.high_;
	};
	goog.math.Long.prototype.isOdd = function() {
	  return 1 == (this.low_ & 1);
	};
	goog.math.Long.prototype.equals = function(a) {
	  return this.high_ == a.high_ && this.low_ == a.low_;
	};
	goog.math.Long.prototype.notEquals = function(a) {
	  return this.high_ != a.high_ || this.low_ != a.low_;
	};
	goog.math.Long.prototype.lessThan = function(a) {
	  return 0 > this.compare(a);
	};
	goog.math.Long.prototype.lessThanOrEqual = function(a) {
	  return 0 >= this.compare(a);
	};
	goog.math.Long.prototype.greaterThan = function(a) {
	  return 0 < this.compare(a);
	};
	goog.math.Long.prototype.greaterThanOrEqual = function(a) {
	  return 0 <= this.compare(a);
	};
	goog.math.Long.prototype.compare = function(a) {
	  if (this.equals(a)) {
	    return 0;
	  }
	  var b = this.isNegative(), c = a.isNegative();
	  return b && !c ? -1 : !b && c ? 1 : this.subtract(a).isNegative() ? -1 : 1;
	};
	goog.math.Long.prototype.negate = function() {
	  return this.equals(goog.math.Long.getMinValue()) ? goog.math.Long.getMinValue() : this.not().add(goog.math.Long.getOne());
	};
	goog.math.Long.prototype.add = function(a) {
	  var b = this.high_ >>> 16, c = this.high_ & 65535, d = this.low_ >>> 16, e = a.high_ >>> 16, f = a.high_ & 65535, g = a.low_ >>> 16, h;
	  h = 0 + ((this.low_ & 65535) + (a.low_ & 65535));
	  a = 0 + (h >>> 16);
	  a += d + g;
	  d = 0 + (a >>> 16);
	  d += c + f;
	  c = 0 + (d >>> 16);
	  c = c + (b + e) & 65535;
	  return goog.math.Long.fromBits((a & 65535) << 16 | h & 65535, c << 16 | d & 65535);
	};
	goog.math.Long.prototype.subtract = function(a) {
	  return this.add(a.negate());
	};
	goog.math.Long.prototype.multiply = function(a) {
	  if (this.isZero() || a.isZero()) {
	    return goog.math.Long.getZero();
	  }
	  if (this.equals(goog.math.Long.getMinValue())) {
	    return a.isOdd() ? goog.math.Long.getMinValue() : goog.math.Long.getZero();
	  }
	  if (a.equals(goog.math.Long.getMinValue())) {
	    return this.isOdd() ? goog.math.Long.getMinValue() : goog.math.Long.getZero();
	  }
	  if (this.isNegative()) {
	    return a.isNegative() ? this.negate().multiply(a.negate()) : this.negate().multiply(a).negate();
	  }
	  if (a.isNegative()) {
	    return this.multiply(a.negate()).negate();
	  }
	  if (this.lessThan(goog.math.Long.getTwoPwr24()) && a.lessThan(goog.math.Long.getTwoPwr24())) {
	    return goog.math.Long.fromNumber(this.toNumber() * a.toNumber());
	  }
	  var b = this.high_ >>> 16, c = this.high_ & 65535, d = this.low_ >>> 16, e = this.low_ & 65535, f = a.high_ >>> 16, g = a.high_ & 65535, h = a.low_ >>> 16;
	  a = a.low_ & 65535;
	  var m, k, l, n;
	  n = 0 + e * a;
	  l = 0 + (n >>> 16);
	  l += d * a;
	  k = 0 + (l >>> 16);
	  l = (l & 65535) + e * h;
	  k += l >>> 16;
	  l &= 65535;
	  k += c * a;
	  m = 0 + (k >>> 16);
	  k = (k & 65535) + d * h;
	  m += k >>> 16;
	  k &= 65535;
	  k += e * g;
	  m += k >>> 16;
	  k &= 65535;
	  m = m + (b * a + c * h + d * g + e * f) & 65535;
	  return goog.math.Long.fromBits(l << 16 | n & 65535, m << 16 | k);
	};
	goog.math.Long.prototype.div = function(a) {
	  if (a.isZero()) {
	    throw Error("division by zero");
	  }
	  if (this.isZero()) {
	    return goog.math.Long.getZero();
	  }
	  if (this.equals(goog.math.Long.getMinValue())) {
	    if (a.equals(goog.math.Long.getOne()) || a.equals(goog.math.Long.getNegOne())) {
	      return goog.math.Long.getMinValue();
	    }
	    if (a.equals(goog.math.Long.getMinValue())) {
	      return goog.math.Long.getOne();
	    }
	    var b = this.shiftRight(1).div(a).shiftLeft(1);
	    if (b.equals(goog.math.Long.getZero())) {
	      return a.isNegative() ? goog.math.Long.getOne() : goog.math.Long.getNegOne();
	    }
	    var c = this.subtract(a.multiply(b));
	    return b.add(c.div(a));
	  }
	  if (a.equals(goog.math.Long.getMinValue())) {
	    return goog.math.Long.getZero();
	  }
	  if (this.isNegative()) {
	    return a.isNegative() ? this.negate().div(a.negate()) : this.negate().div(a).negate();
	  }
	  if (a.isNegative()) {
	    return this.div(a.negate()).negate();
	  }
	  for (var d = goog.math.Long.getZero(), c = this;c.greaterThanOrEqual(a);) {
	    for (var b = Math.max(1, Math.floor(c.toNumber() / a.toNumber())), e = Math.ceil(Math.log(b) / Math.LN2), e = 48 >= e ? 1 : Math.pow(2, e - 48), f = goog.math.Long.fromNumber(b), g = f.multiply(a);g.isNegative() || g.greaterThan(c);) {
	      b -= e, f = goog.math.Long.fromNumber(b), g = f.multiply(a);
	    }
	    f.isZero() && (f = goog.math.Long.getOne());
	    d = d.add(f);
	    c = c.subtract(g);
	  }
	  return d;
	};
	goog.math.Long.prototype.modulo = function(a) {
	  return this.subtract(this.div(a).multiply(a));
	};
	goog.math.Long.prototype.not = function() {
	  return goog.math.Long.fromBits(~this.low_, ~this.high_);
	};
	goog.math.Long.prototype.and = function(a) {
	  return goog.math.Long.fromBits(this.low_ & a.low_, this.high_ & a.high_);
	};
	goog.math.Long.prototype.or = function(a) {
	  return goog.math.Long.fromBits(this.low_ | a.low_, this.high_ | a.high_);
	};
	goog.math.Long.prototype.xor = function(a) {
	  return goog.math.Long.fromBits(this.low_ ^ a.low_, this.high_ ^ a.high_);
	};
	goog.math.Long.prototype.shiftLeft = function(a) {
	  a &= 63;
	  if (0 == a) {
	    return this;
	  }
	  var b = this.low_;
	  return 32 > a ? goog.math.Long.fromBits(b << a, this.high_ << a | b >>> 32 - a) : goog.math.Long.fromBits(0, b << a - 32);
	};
	goog.math.Long.prototype.shiftRight = function(a) {
	  a &= 63;
	  if (0 == a) {
	    return this;
	  }
	  var b = this.high_;
	  return 32 > a ? goog.math.Long.fromBits(this.low_ >>> a | b << 32 - a, b >> a) : goog.math.Long.fromBits(b >> a - 32, 0 <= b ? 0 : -1);
	};
	goog.math.Long.prototype.shiftRightUnsigned = function(a) {
	  a &= 63;
	  if (0 == a) {
	    return this;
	  }
	  var b = this.high_;
	  return 32 > a ? goog.math.Long.fromBits(this.low_ >>> a | b << 32 - a, b >>> a) : 32 == a ? goog.math.Long.fromBits(b, 0) : goog.math.Long.fromBits(b >>> a - 32, 0);
	};
	goog.object = {};
	goog.object.forEach = function(a, b, c) {
	  for (var d in a) {
	    b.call(c, a[d], d, a);
	  }
	};
	goog.object.filter = function(a, b, c) {
	  var d = {}, e;
	  for (e in a) {
	    b.call(c, a[e], e, a) && (d[e] = a[e]);
	  }
	  return d;
	};
	goog.object.map = function(a, b, c) {
	  var d = {}, e;
	  for (e in a) {
	    d[e] = b.call(c, a[e], e, a);
	  }
	  return d;
	};
	goog.object.some = function(a, b, c) {
	  for (var d in a) {
	    if (b.call(c, a[d], d, a)) {
	      return !0;
	    }
	  }
	  return !1;
	};
	goog.object.every = function(a, b, c) {
	  for (var d in a) {
	    if (!b.call(c, a[d], d, a)) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.object.getCount = function(a) {
	  var b = 0, c;
	  for (c in a) {
	    b++;
	  }
	  return b;
	};
	goog.object.getAnyKey = function(a) {
	  for (var b in a) {
	    return b;
	  }
	};
	goog.object.getAnyValue = function(a) {
	  for (var b in a) {
	    return a[b];
	  }
	};
	goog.object.contains = function(a, b) {
	  return goog.object.containsValue(a, b);
	};
	goog.object.getValues = function(a) {
	  var b = [], c = 0, d;
	  for (d in a) {
	    b[c++] = a[d];
	  }
	  return b;
	};
	goog.object.getKeys = function(a) {
	  var b = [], c = 0, d;
	  for (d in a) {
	    b[c++] = d;
	  }
	  return b;
	};
	goog.object.getValueByKeys = function(a, b) {
	  for (var c = goog.isArrayLike(b), d = c ? b : arguments, c = c ? 0 : 1;c < d.length && (a = a[d[c]], goog.isDef(a));c++) {
	  }
	  return a;
	};
	goog.object.containsKey = function(a, b) {
	  return b in a;
	};
	goog.object.containsValue = function(a, b) {
	  for (var c in a) {
	    if (a[c] == b) {
	      return !0;
	    }
	  }
	  return !1;
	};
	goog.object.findKey = function(a, b, c) {
	  for (var d in a) {
	    if (b.call(c, a[d], d, a)) {
	      return d;
	    }
	  }
	};
	goog.object.findValue = function(a, b, c) {
	  return (b = goog.object.findKey(a, b, c)) && a[b];
	};
	goog.object.isEmpty = function(a) {
	  for (var b in a) {
	    return !1;
	  }
	  return !0;
	};
	goog.object.clear = function(a) {
	  for (var b in a) {
	    delete a[b];
	  }
	};
	goog.object.remove = function(a, b) {
	  var c;
	  (c = b in a) && delete a[b];
	  return c;
	};
	goog.object.add = function(a, b, c) {
	  if (b in a) {
	    throw Error('The object already contains the key "' + b + '"');
	  }
	  goog.object.set(a, b, c);
	};
	goog.object.get = function(a, b, c) {
	  return b in a ? a[b] : c;
	};
	goog.object.set = function(a, b, c) {
	  a[b] = c;
	};
	goog.object.setIfUndefined = function(a, b, c) {
	  return b in a ? a[b] : a[b] = c;
	};
	goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
	  if (b in a) {
	    return a[b];
	  }
	  c = c();
	  return a[b] = c;
	};
	goog.object.equals = function(a, b) {
	  for (var c in a) {
	    if (!(c in b) || a[c] !== b[c]) {
	      return !1;
	    }
	  }
	  for (c in b) {
	    if (!(c in a)) {
	      return !1;
	    }
	  }
	  return !0;
	};
	goog.object.clone = function(a) {
	  var b = {}, c;
	  for (c in a) {
	    b[c] = a[c];
	  }
	  return b;
	};
	goog.object.unsafeClone = function(a) {
	  var b = goog.typeOf(a);
	  if ("object" == b || "array" == b) {
	    if (a.clone) {
	      return a.clone();
	    }
	    var b = "array" == b ? [] : {}, c;
	    for (c in a) {
	      b[c] = goog.object.unsafeClone(a[c]);
	    }
	    return b;
	  }
	  return a;
	};
	goog.object.transpose = function(a) {
	  var b = {}, c;
	  for (c in a) {
	    b[a[c]] = c;
	  }
	  return b;
	};
	goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
	goog.object.extend = function(a, b) {
	  for (var c, d, e = 1;e < arguments.length;e++) {
	    d = arguments[e];
	    for (c in d) {
	      a[c] = d[c];
	    }
	    for (var f = 0;f < goog.object.PROTOTYPE_FIELDS_.length;f++) {
	      c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
	    }
	  }
	};
	goog.object.create = function(a) {
	  var b = arguments.length;
	  if (1 == b && goog.isArray(arguments[0])) {
	    return goog.object.create.apply(null, arguments[0]);
	  }
	  if (b % 2) {
	    throw Error("Uneven number of arguments");
	  }
	  for (var c = {}, d = 0;d < b;d += 2) {
	    c[arguments[d]] = arguments[d + 1];
	  }
	  return c;
	};
	goog.object.createSet = function(a) {
	  var b = arguments.length;
	  if (1 == b && goog.isArray(arguments[0])) {
	    return goog.object.createSet.apply(null, arguments[0]);
	  }
	  for (var c = {}, d = 0;d < b;d++) {
	    c[arguments[d]] = !0;
	  }
	  return c;
	};
	goog.object.createImmutableView = function(a) {
	  var b = a;
	  Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
	  return b;
	};
	goog.object.isImmutableView = function(a) {
	  return !!Object.isFrozen && Object.isFrozen(a);
	};
	var com = {cognitect:{}};
	com.cognitect.transit = {};
	com.cognitect.transit.delimiters = {};
	com.cognitect.transit.delimiters.ESC = "~";
	com.cognitect.transit.delimiters.TAG = "#";
	com.cognitect.transit.delimiters.SUB = "^";
	com.cognitect.transit.delimiters.RES = "`";
	com.cognitect.transit.delimiters.ESC_TAG = "~#";
	com.cognitect.transit.caching = {};
	com.cognitect.transit.caching.MIN_SIZE_CACHEABLE = 3;
	com.cognitect.transit.caching.BASE_CHAR_IDX = 48;
	com.cognitect.transit.caching.CACHE_CODE_DIGITS = 44;
	com.cognitect.transit.caching.MAX_CACHE_ENTRIES = com.cognitect.transit.caching.CACHE_CODE_DIGITS * com.cognitect.transit.caching.CACHE_CODE_DIGITS;
	com.cognitect.transit.caching.MAX_CACHE_SIZE = 4096;
	com.cognitect.transit.caching.isCacheable = function(a, b) {
	  if (a.length > com.cognitect.transit.caching.MIN_SIZE_CACHEABLE) {
	    if (b) {
	      return !0;
	    }
	    var c = a.charAt(0), d = a.charAt(1);
	    return c === com.cognitect.transit.delimiters.ESC ? ":" === d || "$" === d || "#" === d : !1;
	  }
	  return !1;
	};
	com.cognitect.transit.caching.idxToCode = function(a) {
	  var b = Math.floor(a / com.cognitect.transit.caching.CACHE_CODE_DIGITS);
	  a = String.fromCharCode(a % com.cognitect.transit.caching.CACHE_CODE_DIGITS + com.cognitect.transit.caching.BASE_CHAR_IDX);
	  return 0 === b ? com.cognitect.transit.delimiters.SUB + a : com.cognitect.transit.delimiters.SUB + String.fromCharCode(b + com.cognitect.transit.caching.BASE_CHAR_IDX) + a;
	};
	com.cognitect.transit.caching.WriteCache = function() {
	  this.cacheSize = this.gen = this.idx = 0;
	  this.cache = {};
	};
	com.cognitect.transit.caching.WriteCache.prototype.write = function(a, b) {
	  if (com.cognitect.transit.caching.isCacheable(a, b)) {
	    this.cacheSize === com.cognitect.transit.caching.MAX_CACHE_SIZE ? (this.clear(), this.gen = 0, this.cache = {}) : this.idx === com.cognitect.transit.caching.MAX_CACHE_ENTRIES && this.clear();
	    var c = this.cache[a];
	    return null == c ? (this.cache[a] = [com.cognitect.transit.caching.idxToCode(this.idx), this.gen], this.idx++, a) : c[1] != this.gen ? (c[1] = this.gen, c[0] = com.cognitect.transit.caching.idxToCode(this.idx), this.idx++, a) : c[0];
	  }
	  return a;
	};
	com.cognitect.transit.caching.WriteCache.prototype.clear = function() {
	  this.idx = 0;
	  this.gen++;
	};
	com.cognitect.transit.caching.writeCache = function() {
	  return new com.cognitect.transit.caching.WriteCache;
	};
	com.cognitect.transit.caching.isCacheCode = function(a) {
	  return a.charAt(0) === com.cognitect.transit.delimiters.SUB && " " !== a.charAt(1);
	};
	com.cognitect.transit.caching.codeToIdx = function(a) {
	  if (2 === a.length) {
	    return a.charCodeAt(1) - com.cognitect.transit.caching.BASE_CHAR_IDX;
	  }
	  var b = (a.charCodeAt(1) - com.cognitect.transit.caching.BASE_CHAR_IDX) * com.cognitect.transit.caching.CACHE_CODE_DIGITS;
	  a = a.charCodeAt(2) - com.cognitect.transit.caching.BASE_CHAR_IDX;
	  return b + a;
	};
	com.cognitect.transit.caching.ReadCache = function() {
	  this.idx = 0;
	  this.cache = [];
	};
	com.cognitect.transit.caching.ReadCache.prototype.write = function(a, b) {
	  this.idx == com.cognitect.transit.caching.MAX_CACHE_ENTRIES && (this.idx = 0);
	  this.cache[this.idx] = a;
	  this.idx++;
	  return a;
	};
	com.cognitect.transit.caching.ReadCache.prototype.read = function(a, b) {
	  return this.cache[com.cognitect.transit.caching.codeToIdx(a)];
	};
	com.cognitect.transit.caching.ReadCache.prototype.clear = function() {
	  this.idx = 0;
	};
	com.cognitect.transit.caching.readCache = function() {
	  return new com.cognitect.transit.caching.ReadCache;
	};
	com.cognitect.transit.util = {};
	com.cognitect.transit.util.objectKeys = "undefined" != typeof Object.keys ? function(a) {
	  return Object.keys(a);
	} : function(a) {
	  return goog.object.getKeys(a);
	};
	com.cognitect.transit.util.isArray = "undefined" != typeof Array.isArray ? function(a) {
	  return Array.isArray(a);
	} : function(a) {
	  return "array" === goog.typeOf(a);
	};
	com.cognitect.transit.util.chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	com.cognitect.transit.util.randInt = function(a) {
	  return Math.round(Math.random() * a);
	};
	com.cognitect.transit.util.randHex = function() {
	  return com.cognitect.transit.util.randInt(15).toString(16);
	};
	com.cognitect.transit.util.randomUUID = function() {
	  var a = (8 | 3 & com.cognitect.transit.util.randInt(14)).toString(16);
	  return com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-" + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-4" + com.cognitect.transit.util.randHex() + 
	  com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-" + a + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + "-" + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + 
	  com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex() + com.cognitect.transit.util.randHex();
	};
	com.cognitect.transit.util.btoa = function(a) {
	  if ("undefined" != typeof btoa) {
	    return btoa(a);
	  }
	  a = String(a);
	  for (var b, c, d = 0, e = com.cognitect.transit.util.chars, f = "";a.charAt(d | 0) || (e = "=", d % 1);f += e.charAt(63 & b >> 8 - d % 1 * 8)) {
	    c = a.charCodeAt(d += .75);
	    if (255 < c) {
	      throw Error("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
	    }
	    b = b << 8 | c;
	  }
	  return f;
	};
	com.cognitect.transit.util.atob = function(a) {
	  if ("undefined" != typeof atob) {
	    return atob(a);
	  }
	  a = String(a).replace(/=+$/, "");
	  if (1 == a.length % 4) {
	    throw Error("'atob' failed: The string to be decoded is not correctly encoded.");
	  }
	  for (var b = 0, c, d, e = 0, f = "";d = a.charAt(e++);~d && (c = b % 4 ? 64 * c + d : d, b++ % 4) ? f += String.fromCharCode(255 & c >> (-2 * b & 6)) : 0) {
	    d = com.cognitect.transit.util.chars.indexOf(d);
	  }
	  return f;
	};
	com.cognitect.transit.util.Uint8ToBase64 = function(a) {
	  for (var b = 0, c = a.length, d = "", e = null;b < c;) {
	    e = a.subarray(b, Math.min(b + 32768, c)), d += String.fromCharCode.apply(null, e), b += 32768;
	  }
	  return com.cognitect.transit.util.btoa(d);
	};
	com.cognitect.transit.util.Base64ToUint8 = function(a) {
	  a = com.cognitect.transit.util.atob(a);
	  for (var b = a.length, c = new Uint8Array(b), d = 0;d < b;d++) {
	    var e = a.charCodeAt(d);
	    c[d] = e;
	  }
	  return c;
	};
	com.cognitect.transit.eq = {};
	com.cognitect.transit.eq.hashCodeProperty = "transit$hashCode$";
	com.cognitect.transit.eq.hashCodeCounter = 1;
	com.cognitect.transit.eq.equals = function(a, b) {
	  if (null == a) {
	    return null == b;
	  }
	  if (a === b) {
	    return !0;
	  }
	  if ("object" === typeof a) {
	    if (com.cognitect.transit.util.isArray(a)) {
	      if (com.cognitect.transit.util.isArray(b) && a.length === b.length) {
	        for (var c = 0;c < a.length;c++) {
	          if (!com.cognitect.transit.eq.equals(a[c], b[c])) {
	            return !1;
	          }
	        }
	        return !0;
	      }
	      return !1;
	    }
	    if (a.com$cognitect$transit$equals) {
	      return a.com$cognitect$transit$equals(b);
	    }
	    if (null != b && "object" === typeof b) {
	      if (b.com$cognitect$transit$equals) {
	        return b.com$cognitect$transit$equals(a);
	      }
	      var c = 0, d = com.cognitect.transit.util.objectKeys(b).length, e;
	      for (e in a) {
	        if (a.hasOwnProperty(e) && (c++, !b.hasOwnProperty(e) || !com.cognitect.transit.eq.equals(a[e], b[e]))) {
	          return !1;
	        }
	      }
	      return c === d;
	    }
	  }
	  return !1;
	};
	com.cognitect.transit.eq.hashCombine = function(a, b) {
	  return a ^ b + 2654435769 + (a << 6) + (a >> 2);
	};
	com.cognitect.transit.eq.stringCodeCache = {};
	com.cognitect.transit.eq.stringCodeCacheSize = 0;
	com.cognitect.transit.eq.STR_CACHE_MAX = 256;
	com.cognitect.transit.eq.hashString = function(a) {
	  var b = com.cognitect.transit.eq.stringCodeCache[a];
	  if (null != b) {
	    return b;
	  }
	  for (var c = b = 0;c < a.length;++c) {
	    b = 31 * b + a.charCodeAt(c), b %= 4294967296;
	  }
	  com.cognitect.transit.eq.stringCodeCacheSize++;
	  com.cognitect.transit.eq.stringCodeCacheSize >= com.cognitect.transit.eq.STR_CACHE_MAX && (com.cognitect.transit.eq.stringCodeCache = {}, com.cognitect.transit.eq.stringCodeCacheSize = 1);
	  return com.cognitect.transit.eq.stringCodeCache[a] = b;
	};
	com.cognitect.transit.eq.hashMapLike = function(a) {
	  var b = 0;
	  if (null != a.forEach) {
	    a.forEach(function(a, c, d) {
	      b = (b + (com.cognitect.transit.eq.hashCode(c) ^ com.cognitect.transit.eq.hashCode(a))) % 4503599627370496;
	    });
	  } else {
	    for (var c = com.cognitect.transit.util.objectKeys(a), d = 0;d < c.length;d++) {
	      var e = c[d], f = a[e], b = (b + (com.cognitect.transit.eq.hashCode(e) ^ com.cognitect.transit.eq.hashCode(f))) % 4503599627370496
	    }
	  }
	  return b;
	};
	com.cognitect.transit.eq.hashArrayLike = function(a) {
	  var b = 0;
	  if (com.cognitect.transit.util.isArray(a)) {
	    for (var c = 0;c < a.length;c++) {
	      b = com.cognitect.transit.eq.hashCombine(b, com.cognitect.transit.eq.hashCode(a[c]));
	    }
	  } else {
	    a.forEach && a.forEach(function(a, c) {
	      b = com.cognitect.transit.eq.hashCombine(b, com.cognitect.transit.eq.hashCode(a));
	    });
	  }
	  return b;
	};
	com.cognitect.transit.eq.hashCode = function(a) {
	  if (null == a) {
	    return 0;
	  }
	  switch(typeof a) {
	    case "number":
	      return a;
	    case "boolean":
	      return !0 === a ? 1 : 0;
	    case "string":
	      return com.cognitect.transit.eq.hashString(a);
	    case "function":
	      var b = a[com.cognitect.transit.eq.hashCodeProperty];
	      b || (b = com.cognitect.transit.eq.hashCodeCounter, "undefined" != typeof Object.defineProperty ? Object.defineProperty(a, com.cognitect.transit.eq.hashCodeProperty, {value:b, enumerable:!1}) : a[com.cognitect.transit.eq.hashCodeProperty] = b, com.cognitect.transit.eq.hashCodeCounter++);
	      return b;
	    default:
	      return a instanceof Date ? a.valueOf() : com.cognitect.transit.util.isArray(a) ? com.cognitect.transit.eq.hashArrayLike(a) : a.com$cognitect$transit$hashCode ? a.com$cognitect$transit$hashCode() : com.cognitect.transit.eq.hashMapLike(a);
	  }
	};
	com.cognitect.transit.eq.extendToEQ = function(a, b) {
	  a.com$cognitect$transit$hashCode = b.hashCode;
	  a.com$cognitect$transit$equals = b.equals;
	  return a;
	};
	com.cognitect.transit.types = {};
	com.cognitect.transit.types.ITERATOR = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";
	com.cognitect.transit.types.TaggedValue = function(a, b) {
	  this.tag = a;
	  this.rep = b;
	  this.hashCode = -1;
	};
	com.cognitect.transit.types.TaggedValue.prototype.toString = function() {
	  return "[TaggedValue: " + this.tag + ", " + this.rep + "]";
	};
	com.cognitect.transit.types.TaggedValue.prototype.equiv = function(a) {
	  return com.cognitect.transit.eq.equals(this, a);
	};
	com.cognitect.transit.types.TaggedValue.prototype.equiv = com.cognitect.transit.types.TaggedValue.prototype.equiv;
	com.cognitect.transit.types.TaggedValue.prototype.com$cognitect$transit$equals = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue ? this.tag === a.tag && com.cognitect.transit.eq.equals(this.rep, a.rep) : !1;
	};
	com.cognitect.transit.types.TaggedValue.prototype.com$cognitect$transit$hashCode = function() {
	  -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCombine(com.cognitect.transit.eq.hashCode(this.tag), com.cognitect.transit.eq.hashCode(this.rep)));
	  return this.hashCode;
	};
	com.cognitect.transit.types.taggedValue = function(a, b) {
	  return new com.cognitect.transit.types.TaggedValue(a, b);
	};
	com.cognitect.transit.types.isTaggedValue = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue;
	};
	com.cognitect.transit.types.nullValue = function() {
	  return null;
	};
	com.cognitect.transit.types.boolValue = function(a) {
	  return "t" === a;
	};
	com.cognitect.transit.types.MAX_INT = goog.math.Long.fromString("9007199254740991");
	com.cognitect.transit.types.MIN_INT = goog.math.Long.fromString("-9007199254740991");
	com.cognitect.transit.types.intValue = function(a) {
	  if ("number" === typeof a || a instanceof goog.math.Long) {
	    return a;
	  }
	  a = goog.math.Long.fromString(a, 10);
	  return a.greaterThan(com.cognitect.transit.types.MAX_INT) || a.lessThan(com.cognitect.transit.types.MIN_INT) ? a : a.toNumber();
	};
	goog.math.Long.prototype.equiv = function(a) {
	  return com.cognitect.transit.eq.equals(this, a);
	};
	goog.math.Long.prototype.equiv = goog.math.Long.prototype.equiv;
	goog.math.Long.prototype.com$cognitect$transit$equals = function(a) {
	  return a instanceof goog.math.Long && this.equals(a);
	};
	goog.math.Long.prototype.com$cognitect$transit$hashCode = function() {
	  return this.toInt();
	};
	com.cognitect.transit.types.isInteger = function(a) {
	  return a instanceof goog.math.Long ? !0 : "number" === typeof a && !isNaN(a) && Infinity !== a && parseFloat(a) === parseInt(a, 10);
	};
	com.cognitect.transit.types.floatValue = function(a) {
	  return parseFloat(a);
	};
	com.cognitect.transit.types.bigInteger = function(a) {
	  return com.cognitect.transit.types.taggedValue("n", a);
	};
	com.cognitect.transit.types.isBigInteger = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue && "n" === a.tag;
	};
	com.cognitect.transit.types.bigDecimalValue = function(a) {
	  return com.cognitect.transit.types.taggedValue("f", a);
	};
	com.cognitect.transit.types.isBigDecimal = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue && "f" === a.tag;
	};
	com.cognitect.transit.types.charValue = function(a) {
	  return a;
	};
	com.cognitect.transit.types.Keyword = function(a) {
	  this._name = a;
	  this.hashCode = -1;
	};
	com.cognitect.transit.types.Keyword.prototype.toString = function() {
	  return ":" + this._name;
	};
	com.cognitect.transit.types.Keyword.prototype.namespace = function() {
	  var a = this._name.indexOf("/");
	  return -1 != a ? this._name.substring(0, a) : null;
	};
	com.cognitect.transit.types.Keyword.prototype.name = function() {
	  var a = this._name.indexOf("/");
	  return -1 != a ? this._name.substring(a + 1, this._name.length) : this._name;
	};
	com.cognitect.transit.types.Keyword.prototype.equiv = function(a) {
	  return com.cognitect.transit.eq.equals(this, a);
	};
	com.cognitect.transit.types.Keyword.prototype.equiv = com.cognitect.transit.types.Keyword.prototype.equiv;
	com.cognitect.transit.types.Keyword.prototype.com$cognitect$transit$equals = function(a) {
	  return a instanceof com.cognitect.transit.types.Keyword && this._name == a._name;
	};
	com.cognitect.transit.types.Keyword.prototype.com$cognitect$transit$hashCode = function() {
	  -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCode(this._name));
	  return this.hashCode;
	};
	com.cognitect.transit.types.keyword = function(a) {
	  return new com.cognitect.transit.types.Keyword(a);
	};
	com.cognitect.transit.types.isKeyword = function(a) {
	  return a instanceof com.cognitect.transit.types.Keyword;
	};
	com.cognitect.transit.types.Symbol = function(a) {
	  this._name = a;
	  this.hashCode = -1;
	};
	com.cognitect.transit.types.Symbol.prototype.namespace = function() {
	  var a = this._name.indexOf("/");
	  return -1 != a ? this._name.substring(0, a) : null;
	};
	com.cognitect.transit.types.Symbol.prototype.name = function() {
	  var a = this._name.indexOf("/");
	  return -1 != a ? this._name.substring(a + 1, this._name.length) : this._name;
	};
	com.cognitect.transit.types.Symbol.prototype.toString = function() {
	  return this._name;
	};
	com.cognitect.transit.types.Symbol.prototype.equiv = function(a) {
	  return com.cognitect.transit.eq.equals(this, a);
	};
	com.cognitect.transit.types.Symbol.prototype.equiv = com.cognitect.transit.types.Symbol.prototype.equiv;
	com.cognitect.transit.types.Symbol.prototype.com$cognitect$transit$equals = function(a) {
	  return a instanceof com.cognitect.transit.types.Symbol && this._name == a._name;
	};
	com.cognitect.transit.types.Symbol.prototype.com$cognitect$transit$hashCode = function() {
	  -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCode(this._name));
	  return this.hashCode;
	};
	com.cognitect.transit.types.symbol = function(a) {
	  return new com.cognitect.transit.types.Symbol(a);
	};
	com.cognitect.transit.types.isSymbol = function(a) {
	  return a instanceof com.cognitect.transit.types.Symbol;
	};
	com.cognitect.transit.types.hexFor = function(a, b, c) {
	  var d = "";
	  c = c || b + 1;
	  for (var e = 8 * (7 - b), f = goog.math.Long.fromInt(255).shiftLeft(e);b < c;b++, e -= 8, f = f.shiftRightUnsigned(8)) {
	    var g = a.and(f).shiftRightUnsigned(e).toString(16);
	    1 == g.length && (g = "0" + g);
	    d += g;
	  }
	  return d;
	};
	com.cognitect.transit.types.UUID = function(a, b) {
	  this.high = a;
	  this.low = b;
	  this.hashCode = -1;
	};
	com.cognitect.transit.types.UUID.prototype.getLeastSignificantBits = function() {
	  return this.low;
	};
	com.cognitect.transit.types.UUID.prototype.getMostSignificantBits = function() {
	  return this.high;
	};
	com.cognitect.transit.types.UUID.prototype.toString = function() {
	  var a, b = this.high, c = this.low;
	  a = "" + (com.cognitect.transit.types.hexFor(b, 0, 4) + "-");
	  a += com.cognitect.transit.types.hexFor(b, 4, 6) + "-";
	  a += com.cognitect.transit.types.hexFor(b, 6, 8) + "-";
	  a += com.cognitect.transit.types.hexFor(c, 0, 2) + "-";
	  return a += com.cognitect.transit.types.hexFor(c, 2, 8);
	};
	com.cognitect.transit.types.UUID.prototype.equiv = function(a) {
	  return com.cognitect.transit.eq.equals(this, a);
	};
	com.cognitect.transit.types.UUID.prototype.equiv = com.cognitect.transit.types.UUID.prototype.equiv;
	com.cognitect.transit.types.UUID.prototype.com$cognitect$transit$equals = function(a) {
	  return a instanceof com.cognitect.transit.types.UUID && this.high.equals(a.high) && this.low.equals(a.low);
	};
	com.cognitect.transit.types.UUID.prototype.com$cognitect$transit$hashCode = function() {
	  -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashCode(this.toString()));
	  return this.hashCode;
	};
	com.cognitect.transit.types.UUIDfromString = function(a) {
	  a = a.replace(/-/g, "");
	  for (var b = null, c = null, d = c = 0, e = 24, f = 0, f = c = 0, e = 24;8 > f;f += 2, e -= 8) {
	    c |= parseInt(a.substring(f, f + 2), 16) << e;
	  }
	  d = 0;
	  f = 8;
	  for (e = 24;16 > f;f += 2, e -= 8) {
	    d |= parseInt(a.substring(f, f + 2), 16) << e;
	  }
	  b = goog.math.Long.fromBits(d, c);
	  c = 0;
	  f = 16;
	  for (e = 24;24 > f;f += 2, e -= 8) {
	    c |= parseInt(a.substring(f, f + 2), 16) << e;
	  }
	  d = 0;
	  for (e = f = 24;32 > f;f += 2, e -= 8) {
	    d |= parseInt(a.substring(f, f + 2), 16) << e;
	  }
	  c = goog.math.Long.fromBits(d, c);
	  return new com.cognitect.transit.types.UUID(b, c);
	};
	com.cognitect.transit.types.uuid = function(a) {
	  return com.cognitect.transit.types.UUIDfromString(a);
	};
	com.cognitect.transit.types.isUUID = function(a) {
	  return a instanceof com.cognitect.transit.types.UUID;
	};
	com.cognitect.transit.types.date = function(a) {
	  a = "number" === typeof a ? a : parseInt(a, 10);
	  return new Date(a);
	};
	com.cognitect.transit.types.verboseDate = function(a) {
	  return new Date(a);
	};
	Date.prototype.com$cognitect$transit$equals = function(a) {
	  return a instanceof Date ? this.valueOf() === a.valueOf() : !1;
	};
	Date.prototype.com$cognitect$transit$hashCode = function() {
	  return this.valueOf();
	};
	com.cognitect.transit.types.binary = function(a, b) {
	  return b && !1 === b.preferBuffers || "undefined" == typeof Buffer ? "undefined" != typeof Uint8Array ? com.cognitect.transit.util.Base64ToUint8(a) : com.cognitect.transit.types.taggedValue("b", a) : new Buffer(a, "base64");
	};
	com.cognitect.transit.types.isBinary = function(a) {
	  return "undefined" != typeof Buffer && a instanceof Buffer ? !0 : "undefined" != typeof Uint8Array && a instanceof Uint8Array ? !0 : a instanceof com.cognitect.transit.types.TaggedValue && "b" === a.tag;
	};
	com.cognitect.transit.types.uri = function(a) {
	  return com.cognitect.transit.types.taggedValue("r", a);
	};
	com.cognitect.transit.types.isURI = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue && "r" === a.tag;
	};
	com.cognitect.transit.types.KEYS = 0;
	com.cognitect.transit.types.VALUES = 1;
	com.cognitect.transit.types.ENTRIES = 2;
	com.cognitect.transit.types.TransitArrayMapIterator = function(a, b) {
	  this.entries = a;
	  this.type = b || com.cognitect.transit.types.KEYS;
	  this.idx = 0;
	};
	com.cognitect.transit.types.TransitArrayMapIterator.prototype.next = function() {
	  if (this.idx < this.entries.length) {
	    var a = null, a = this.type === com.cognitect.transit.types.KEYS ? this.entries[this.idx] : this.type === com.cognitect.transit.types.VALUES ? this.entries[this.idx + 1] : [this.entries[this.idx], this.entries[this.idx + 1]], a = {value:a, done:!1};
	    this.idx += 2;
	    return a;
	  }
	  return {value:null, done:!0};
	};
	com.cognitect.transit.types.TransitArrayMapIterator.prototype.next = com.cognitect.transit.types.TransitArrayMapIterator.prototype.next;
	com.cognitect.transit.types.TransitArrayMapIterator.prototype[com.cognitect.transit.types.ITERATOR] = function() {
	  return this;
	};
	com.cognitect.transit.types.TransitMapIterator = function(a, b) {
	  this.map = a;
	  this.type = b || com.cognitect.transit.types.KEYS;
	  this.keys = this.map.getKeys();
	  this.idx = 0;
	  this.bucket = null;
	  this.bucketIdx = 0;
	};
	com.cognitect.transit.types.TransitMapIterator.prototype.next = function() {
	  if (this.idx < this.map.size) {
	    null != this.bucket && this.bucketIdx < this.bucket.length || (this.bucket = this.map.map[this.keys[this.idx]], this.bucketIdx = 0);
	    var a = null, a = this.type === com.cognitect.transit.types.KEYS ? this.bucket[this.bucketIdx] : this.type === com.cognitect.transit.types.VALUES ? this.bucket[this.bucketIdx + 1] : [this.bucket[this.bucketIdx], this.bucket[this.bucketIdx + 1]], a = {value:a, done:!1};
	    this.idx++;
	    this.bucketIdx += 2;
	    return a;
	  }
	  return {value:null, done:!0};
	};
	com.cognitect.transit.types.TransitMapIterator.prototype.next = com.cognitect.transit.types.TransitMapIterator.prototype.next;
	com.cognitect.transit.types.TransitMapIterator.prototype[com.cognitect.transit.types.ITERATOR] = function() {
	  return this;
	};
	com.cognitect.transit.types.mapEquals = function(a, b) {
	  if (a instanceof com.cognitect.transit.types.TransitMap && com.cognitect.transit.types.isMap(b)) {
	    if (a.size !== b.size) {
	      return !1;
	    }
	    for (var c in a.map) {
	      for (var d = a.map[c], e = 0;e < d.length;e += 2) {
	        if (!com.cognitect.transit.eq.equals(d[e + 1], b.get(d[e]))) {
	          return !1;
	        }
	      }
	    }
	    return !0;
	  }
	  if (a instanceof com.cognitect.transit.types.TransitArrayMap && com.cognitect.transit.types.isMap(b)) {
	    if (a.size !== b.size) {
	      return !1;
	    }
	    c = a._entries;
	    for (e = 0;e < c.length;e += 2) {
	      if (!com.cognitect.transit.eq.equals(c[e + 1], b.get(c[e]))) {
	        return !1;
	      }
	    }
	    return !0;
	  }
	  if (null != b && "object" === typeof b && (e = com.cognitect.transit.util.objectKeys(b), c = e.length, a.size === c)) {
	    for (d = 0;d < c;d++) {
	      var f = e[d];
	      if (!a.has(f) || !com.cognitect.transit.eq.equals(b[f], a.get(f))) {
	        return !1;
	      }
	    }
	    return !0;
	  }
	  return !1;
	};
	com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD = 8;
	com.cognitect.transit.types.ARRAY_MAP_THRESHOLD = 32;
	com.cognitect.transit.types.ARRAY_MAP_ACCESS_THRESHOLD = 32;
	com.cognitect.transit.types.print = function(a) {
	  return null == a ? "null" : goog.isArray(a) ? "[" + a.toString() + "]" : goog.isString(a) ? '"' + a + '"' : a.toString();
	};
	com.cognitect.transit.types.printMap = function(a) {
	  var b = 0, c = "TransitMap {";
	  a.forEach(function(d, e) {
	    c += com.cognitect.transit.types.print(e) + " => " + com.cognitect.transit.types.print(d);
	    b < a.size - 1 && (c += ", ");
	    b++;
	  });
	  return c + "}";
	};
	com.cognitect.transit.types.printSet = function(a) {
	  var b = 0, c = "TransitSet {";
	  a.forEach(function(d) {
	    c += com.cognitect.transit.types.print(d);
	    b < a.size - 1 && (c += ", ");
	    b++;
	  });
	  return c + "}";
	};
	com.cognitect.transit.types.TransitArrayMap = function(a) {
	  this._entries = a;
	  this.backingMap = null;
	  this.hashCode = -1;
	  this.size = a.length / 2;
	  this.accesses = 0;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.toString = function() {
	  return com.cognitect.transit.types.printMap(this);
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.inspect = function() {
	  return this.toString();
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.convert = function() {
	  if (this.backingMap) {
	    throw Error("Invalid operation, already converted");
	  }
	  if (this.size < com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD) {
	    return !1;
	  }
	  this.accesses++;
	  return this.accesses > com.cognitect.transit.types.ARRAY_MAP_ACCESS_THRESHOLD ? (this.backingMap = com.cognitect.transit.types.map(this._entries, !1, !0), this._entries = [], !0) : !1;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.clear = function() {
	  this.hashCode = -1;
	  this.backingMap ? this.backingMap.clear() : this._entries = [];
	  this.size = 0;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.clear = com.cognitect.transit.types.TransitArrayMap.prototype.clear;
	com.cognitect.transit.types.TransitArrayMap.prototype.keys = function() {
	  return this.backingMap ? this.backingMap.keys() : new com.cognitect.transit.types.TransitArrayMapIterator(this._entries, com.cognitect.transit.types.KEYS);
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.keys = com.cognitect.transit.types.TransitArrayMap.prototype.keys;
	com.cognitect.transit.types.TransitArrayMap.prototype.keySet = function() {
	  if (this.backingMap) {
	    return this.backingMap.keySet();
	  }
	  for (var a = [], b = 0, c = 0;c < this._entries.length;b++, c += 2) {
	    a[b] = this._entries[c];
	  }
	  return a;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.keySet = com.cognitect.transit.types.TransitArrayMap.prototype.keySet;
	com.cognitect.transit.types.TransitArrayMap.prototype.entries = function() {
	  return this.backingMap ? this.backingMap.entries() : new com.cognitect.transit.types.TransitArrayMapIterator(this._entries, com.cognitect.transit.types.ENTRIES);
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.entries = com.cognitect.transit.types.TransitArrayMap.prototype.entries;
	com.cognitect.transit.types.TransitArrayMap.prototype.values = function() {
	  return this.backingMap ? this.backingMap.values() : new com.cognitect.transit.types.TransitArrayMapIterator(this._entries, com.cognitect.transit.types.VALUES);
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.values = com.cognitect.transit.types.TransitArrayMap.prototype.values;
	com.cognitect.transit.types.TransitArrayMap.prototype.forEach = function(a) {
	  if (this.backingMap) {
	    this.backingMap.forEach(a);
	  } else {
	    for (var b = 0;b < this._entries.length;b += 2) {
	      a(this._entries[b + 1], this._entries[b]);
	    }
	  }
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.forEach = com.cognitect.transit.types.TransitArrayMap.prototype.forEach;
	com.cognitect.transit.types.TransitArrayMap.prototype.get = function(a, b) {
	  if (this.backingMap) {
	    return this.backingMap.get(a);
	  }
	  if (this.convert()) {
	    return this.get(a);
	  }
	  for (var c = 0;c < this._entries.length;c += 2) {
	    if (com.cognitect.transit.eq.equals(this._entries[c], a)) {
	      return this._entries[c + 1];
	    }
	  }
	  return b;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.get = com.cognitect.transit.types.TransitArrayMap.prototype.get;
	com.cognitect.transit.types.TransitArrayMap.prototype.has = function(a) {
	  if (this.backingMap) {
	    return this.backingMap.has(a);
	  }
	  if (this.convert()) {
	    return this.has(a);
	  }
	  for (var b = 0;b < this._entries.length;b += 2) {
	    if (com.cognitect.transit.eq.equals(this._entries[b], a)) {
	      return !0;
	    }
	  }
	  return !1;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.has = com.cognitect.transit.types.TransitArrayMap.prototype.has;
	com.cognitect.transit.types.TransitArrayMap.prototype.set = function(a, b) {
	  this.hashCode = -1;
	  if (this.backingMap) {
	    this.backingMap.set(a, b), this.size = this.backingMap.size;
	  } else {
	    for (var c = 0;c < this._entries.length;c += 2) {
	      if (com.cognitect.transit.eq.equals(this._entries[c], a)) {
	        this._entries[c + 1] = b;
	        return;
	      }
	    }
	    this._entries.push(a);
	    this._entries.push(b);
	    this.size++;
	    this.size > com.cognitect.transit.types.ARRAY_MAP_THRESHOLD && (this.backingMap = com.cognitect.transit.types.map(this._entries, !1, !0), this._entries = null);
	  }
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.set = com.cognitect.transit.types.TransitArrayMap.prototype.set;
	com.cognitect.transit.types.TransitArrayMap.prototype["delete"] = function(a) {
	  this.hashCode = -1;
	  if (this.backingMap) {
	    return a = this.backingMap["delete"](a), this.size = this.backingMap.size, a;
	  }
	  for (var b = 0;b < this._entries.length;b += 2) {
	    if (com.cognitect.transit.eq.equals(this._entries[b], a)) {
	      return a = this._entries[b + 1], this._entries.splice(b, 2), this.size--, a;
	    }
	  }
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.clone = function() {
	  var a = com.cognitect.transit.types.map();
	  this.forEach(function(b, c) {
	    a.set(c, b);
	  });
	  return a;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.clone = com.cognitect.transit.types.TransitArrayMap.prototype.clone;
	com.cognitect.transit.types.TransitArrayMap.prototype[com.cognitect.transit.types.ITERATOR] = function() {
	  return this.entries();
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.com$cognitect$transit$hashCode = function() {
	  if (this.backingMap) {
	    return this.backingMap.com$cognitect$transit$hashCode();
	  }
	  -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashMapLike(this));
	  return this.hashCode;
	};
	com.cognitect.transit.types.TransitArrayMap.prototype.com$cognitect$transit$equals = function(a) {
	  return this.backingMap ? com.cognitect.transit.types.mapEquals(this.backingMap, a) : com.cognitect.transit.types.mapEquals(this, a);
	};
	com.cognitect.transit.types.TransitMap = function(a, b, c) {
	  this.map = b || {};
	  this._keys = a || [];
	  this.size = c || 0;
	  this.hashCode = -1;
	};
	com.cognitect.transit.types.TransitMap.prototype.toString = function() {
	  return com.cognitect.transit.types.printMap(this);
	};
	com.cognitect.transit.types.TransitMap.prototype.inspect = function() {
	  return this.toString();
	};
	com.cognitect.transit.types.TransitMap.prototype.clear = function() {
	  this.hashCode = -1;
	  this.map = {};
	  this._keys = [];
	  this.size = 0;
	};
	com.cognitect.transit.types.TransitMap.prototype.clear = com.cognitect.transit.types.TransitMap.prototype.clear;
	com.cognitect.transit.types.TransitMap.prototype.getKeys = function() {
	  return null != this._keys ? this._keys : com.cognitect.transit.util.objectKeys(this.map);
	};
	com.cognitect.transit.types.TransitMap.prototype["delete"] = function(a) {
	  this.hashCode = -1;
	  this._keys = null;
	  for (var b = com.cognitect.transit.eq.hashCode(a), c = this.map[b], d = 0;d < c.length;d += 2) {
	    if (com.cognitect.transit.eq.equals(a, c[d])) {
	      return a = c[d + 1], c.splice(d, 2), 0 === c.length && delete this.map[b], this.size--, a;
	    }
	  }
	};
	com.cognitect.transit.types.TransitMap.prototype.entries = function() {
	  return new com.cognitect.transit.types.TransitMapIterator(this, com.cognitect.transit.types.ENTRIES);
	};
	com.cognitect.transit.types.TransitMap.prototype.entries = com.cognitect.transit.types.TransitMap.prototype.entries;
	com.cognitect.transit.types.TransitMap.prototype.forEach = function(a) {
	  for (var b = this.getKeys(), c = 0;c < b.length;c++) {
	    for (var d = this.map[b[c]], e = 0;e < d.length;e += 2) {
	      a(d[e + 1], d[e], this);
	    }
	  }
	};
	com.cognitect.transit.types.TransitMap.prototype.forEach = com.cognitect.transit.types.TransitMap.prototype.forEach;
	com.cognitect.transit.types.TransitMap.prototype.get = function(a, b) {
	  var c = com.cognitect.transit.eq.hashCode(a), c = this.map[c];
	  if (null != c) {
	    for (var d = 0;d < c.length;d += 2) {
	      if (com.cognitect.transit.eq.equals(a, c[d])) {
	        return c[d + 1];
	      }
	    }
	  } else {
	    return b;
	  }
	};
	com.cognitect.transit.types.TransitMap.prototype.get = com.cognitect.transit.types.TransitMap.prototype.get;
	com.cognitect.transit.types.TransitMap.prototype.has = function(a) {
	  var b = com.cognitect.transit.eq.hashCode(a), b = this.map[b];
	  if (null != b) {
	    for (var c = 0;c < b.length;c += 2) {
	      if (com.cognitect.transit.eq.equals(a, b[c])) {
	        return !0;
	      }
	    }
	  }
	  return !1;
	};
	com.cognitect.transit.types.TransitMap.prototype.has = com.cognitect.transit.types.TransitMap.prototype.has;
	com.cognitect.transit.types.TransitMap.prototype.keys = function() {
	  return new com.cognitect.transit.types.TransitMapIterator(this, com.cognitect.transit.types.KEYS);
	};
	com.cognitect.transit.types.TransitMap.prototype.keys = com.cognitect.transit.types.TransitMap.prototype.keys;
	com.cognitect.transit.types.TransitMap.prototype.keySet = function() {
	  for (var a = this.getKeys(), b = [], c = 0;c < a.length;c++) {
	    for (var d = this.map[a[c]], e = 0;e < d.length;e += 2) {
	      b.push(d[e]);
	    }
	  }
	  return b;
	};
	com.cognitect.transit.types.TransitMap.prototype.keySet = com.cognitect.transit.types.TransitMap.prototype.keySet;
	com.cognitect.transit.types.TransitMap.prototype.set = function(a, b) {
	  this.hashCode = -1;
	  var c = com.cognitect.transit.eq.hashCode(a), d = this.map[c];
	  if (null == d) {
	    this._keys && this._keys.push(c), this.map[c] = [a, b], this.size++;
	  } else {
	    for (var c = !0, e = 0;e < d.length;e += 2) {
	      if (com.cognitect.transit.eq.equals(b, d[e])) {
	        c = !1;
	        d[e] = b;
	        break;
	      }
	    }
	    c && (d.push(a), d.push(b), this.size++);
	  }
	};
	com.cognitect.transit.types.TransitMap.prototype.set = com.cognitect.transit.types.TransitMap.prototype.set;
	com.cognitect.transit.types.TransitMap.prototype.values = function() {
	  return new com.cognitect.transit.types.TransitMapIterator(this, com.cognitect.transit.types.VALUES);
	};
	com.cognitect.transit.types.TransitMap.prototype.values = com.cognitect.transit.types.TransitMap.prototype.values;
	com.cognitect.transit.types.TransitMap.prototype.clone = function() {
	  var a = com.cognitect.transit.types.map();
	  this.forEach(function(b, c) {
	    a.set(c, b);
	  });
	  return a;
	};
	com.cognitect.transit.types.TransitMap.prototype.clone = com.cognitect.transit.types.TransitMap.prototype.clone;
	com.cognitect.transit.types.TransitMap.prototype[com.cognitect.transit.types.ITERATOR] = function() {
	  return this.entries();
	};
	com.cognitect.transit.types.TransitMap.prototype.com$cognitect$transit$hashCode = function() {
	  -1 === this.hashCode && (this.hashCode = com.cognitect.transit.eq.hashMapLike(this));
	  return this.hashCode;
	};
	com.cognitect.transit.types.TransitMap.prototype.com$cognitect$transit$equals = function(a) {
	  return com.cognitect.transit.types.mapEquals(this, a);
	};
	com.cognitect.transit.types.map = function(a, b, c) {
	  a = a || [];
	  b = !1 === b ? b : !0;
	  if ((!0 !== c || !c) && a.length <= 2 * com.cognitect.transit.types.ARRAY_MAP_THRESHOLD) {
	    if (b) {
	      var d = a;
	      a = [];
	      for (b = 0;b < d.length;b += 2) {
	        var e = !1;
	        for (c = 0;c < a.length;c += 2) {
	          if (com.cognitect.transit.eq.equals(a[c], d[b])) {
	            a[c + 1] = d[b + 1];
	            e = !0;
	            break;
	          }
	        }
	        e || (a.push(d[b]), a.push(d[b + 1]));
	      }
	    }
	    return new com.cognitect.transit.types.TransitArrayMap(a);
	  }
	  var d = {}, e = [], f = 0;
	  for (b = 0;b < a.length;b += 2) {
	    c = com.cognitect.transit.eq.hashCode(a[b]);
	    var g = d[c];
	    if (null == g) {
	      e.push(c), d[c] = [a[b], a[b + 1]], f++;
	    } else {
	      var h = !0;
	      for (c = 0;c < g.length;c += 2) {
	        if (com.cognitect.transit.eq.equals(g[c], a[b])) {
	          g[c + 1] = a[b + 1];
	          h = !1;
	          break;
	        }
	      }
	      h && (g.push(a[b]), g.push(a[b + 1]), f++);
	    }
	  }
	  return new com.cognitect.transit.types.TransitMap(e, d, f);
	};
	com.cognitect.transit.types.isArrayMap = function(a) {
	  return a instanceof com.cognitect.transit.types.TransitArrayMap;
	};
	com.cognitect.transit.types.isMap = function(a) {
	  return a instanceof com.cognitect.transit.types.TransitArrayMap || a instanceof com.cognitect.transit.types.TransitMap;
	};
	com.cognitect.transit.types.TransitSet = function(a) {
	  this.map = a;
	  this.size = a.size;
	};
	com.cognitect.transit.types.TransitSet.prototype.toString = function() {
	  return com.cognitect.transit.types.printSet(this);
	};
	com.cognitect.transit.types.TransitSet.prototype.inspect = function() {
	  return this.toString();
	};
	com.cognitect.transit.types.TransitSet.prototype.add = function(a) {
	  this.map.set(a, a);
	  this.size = this.map.size;
	};
	com.cognitect.transit.types.TransitSet.prototype.add = com.cognitect.transit.types.TransitSet.prototype.add;
	com.cognitect.transit.types.TransitSet.prototype.clear = function() {
	  this.map = new com.cognitect.transit.types.TransitMap;
	  this.size = 0;
	};
	com.cognitect.transit.types.TransitSet.prototype.clear = com.cognitect.transit.types.TransitSet.prototype.clear;
	com.cognitect.transit.types.TransitSet.prototype["delete"] = function(a) {
	  a = this.map["delete"](a);
	  this.size = this.map.size;
	  return a;
	};
	com.cognitect.transit.types.TransitSet.prototype.entries = function() {
	  return this.map.entries();
	};
	com.cognitect.transit.types.TransitSet.prototype.entries = com.cognitect.transit.types.TransitSet.prototype.entries;
	com.cognitect.transit.types.TransitSet.prototype.forEach = function(a, b) {
	  var c = this;
	  this.map.forEach(function(b, e, f) {
	    a(e, c);
	  });
	};
	com.cognitect.transit.types.TransitSet.prototype.forEach = com.cognitect.transit.types.TransitSet.prototype.forEach;
	com.cognitect.transit.types.TransitSet.prototype.has = function(a) {
	  return this.map.has(a);
	};
	com.cognitect.transit.types.TransitSet.prototype.has = com.cognitect.transit.types.TransitSet.prototype.has;
	com.cognitect.transit.types.TransitSet.prototype.keys = function() {
	  return this.map.keys();
	};
	com.cognitect.transit.types.TransitSet.prototype.keys = com.cognitect.transit.types.TransitSet.prototype.keys;
	com.cognitect.transit.types.TransitSet.prototype.keySet = function() {
	  return this.map.keySet();
	};
	com.cognitect.transit.types.TransitSet.prototype.keySet = com.cognitect.transit.types.TransitSet.prototype.keySet;
	com.cognitect.transit.types.TransitSet.prototype.values = function() {
	  return this.map.values();
	};
	com.cognitect.transit.types.TransitSet.prototype.values = com.cognitect.transit.types.TransitSet.prototype.values;
	com.cognitect.transit.types.TransitSet.prototype.clone = function() {
	  var a = com.cognitect.transit.types.set();
	  this.forEach(function(b) {
	    a.add(b);
	  });
	  return a;
	};
	com.cognitect.transit.types.TransitSet.prototype.clone = com.cognitect.transit.types.TransitSet.prototype.clone;
	com.cognitect.transit.types.TransitSet.prototype[com.cognitect.transit.types.ITERATOR] = function() {
	  return this.values();
	};
	com.cognitect.transit.types.TransitSet.prototype.com$cognitect$transit$equals = function(a) {
	  if (a instanceof com.cognitect.transit.types.TransitSet) {
	    if (this.size === a.size) {
	      return com.cognitect.transit.eq.equals(this.map, a.map);
	    }
	  } else {
	    return !1;
	  }
	};
	com.cognitect.transit.types.TransitSet.prototype.com$cognitect$transit$hashCode = function(a) {
	  return com.cognitect.transit.eq.hashCode(this.map);
	};
	com.cognitect.transit.types.set = function(a) {
	  a = a || [];
	  for (var b = {}, c = [], d = 0, e = 0;e < a.length;e++) {
	    var f = com.cognitect.transit.eq.hashCode(a[e]), g = b[f];
	    if (null == g) {
	      c.push(f), b[f] = [a[e], a[e]], d++;
	    } else {
	      for (var f = !0, h = 0;h < g.length;h += 2) {
	        if (com.cognitect.transit.eq.equals(g[h], a[e])) {
	          f = !1;
	          break;
	        }
	      }
	      f && (g.push(a[e]), g.push(a[e]), d++);
	    }
	  }
	  return new com.cognitect.transit.types.TransitSet(new com.cognitect.transit.types.TransitMap(c, b, d));
	};
	com.cognitect.transit.types.isSet = function(a) {
	  return a instanceof com.cognitect.transit.types.TransitSet;
	};
	com.cognitect.transit.types.quoted = function(a) {
	  return com.cognitect.transit.types.taggedValue("'", a);
	};
	com.cognitect.transit.types.isQuoted = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue && "'" === a.tag;
	};
	com.cognitect.transit.types.list = function(a) {
	  return com.cognitect.transit.types.taggedValue("list", a);
	};
	com.cognitect.transit.types.isList = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue && "list" === a.tag;
	};
	com.cognitect.transit.types.link = function(a) {
	  return com.cognitect.transit.types.taggedValue("link", a);
	};
	com.cognitect.transit.types.isLink = function(a) {
	  return a instanceof com.cognitect.transit.types.TaggedValue && "link" === a.tag;
	};
	com.cognitect.transit.types.specialDouble = function(a) {
	  switch(a) {
	    case "-INF":
	      return -Infinity;
	    case "INF":
	      return Infinity;
	    case "NaN":
	      return NaN;
	    default:
	      throw Error("Invalid special double value " + a);;
	  }
	};
	com.cognitect.transit.handlers = {};
	com.cognitect.transit.handlers.ctorGuid = 0;
	com.cognitect.transit.handlers.ctorGuidProperty = "transit$guid$" + com.cognitect.transit.util.randomUUID();
	com.cognitect.transit.handlers.typeTag = function(a) {
	  if (null == a) {
	    return "null";
	  }
	  if (a === String) {
	    return "string";
	  }
	  if (a === Boolean) {
	    return "boolean";
	  }
	  if (a === Number) {
	    return "number";
	  }
	  if (a === Array) {
	    return "array";
	  }
	  if (a === Object) {
	    return "map";
	  }
	  var b = a[com.cognitect.transit.handlers.ctorGuidProperty];
	  null == b && ("undefined" != typeof Object.defineProperty ? (b = ++com.cognitect.transit.handlers.ctorGuid, Object.defineProperty(a, com.cognitect.transit.handlers.ctorGuidProperty, {value:b, enumerable:!1})) : a[com.cognitect.transit.handlers.ctorGuidProperty] = b = ++com.cognitect.transit.handlers.ctorGuid);
	  return b;
	};
	com.cognitect.transit.handlers.constructor = function(a) {
	  return null == a ? null : a.constructor;
	};
	com.cognitect.transit.handlers.padZeros = function(a, b) {
	  for (var c = a.toString(), d = c.length;d < b;d++) {
	    c = "0" + c;
	  }
	  return c;
	};
	com.cognitect.transit.handlers.stringableKeys = function(a) {
	  a = com.cognitect.transit.util.objectKeys(a);
	  for (var b = 0;b < a.length;b++) {
	  }
	  return !0;
	};
	com.cognitect.transit.handlers.NilHandler = function() {
	};
	com.cognitect.transit.handlers.NilHandler.prototype.tag = function(a) {
	  return "_";
	};
	com.cognitect.transit.handlers.NilHandler.prototype.rep = function(a) {
	  return null;
	};
	com.cognitect.transit.handlers.NilHandler.prototype.stringRep = function(a) {
	  return "null";
	};
	com.cognitect.transit.handlers.StringHandler = function() {
	};
	com.cognitect.transit.handlers.StringHandler.prototype.tag = function(a) {
	  return "s";
	};
	com.cognitect.transit.handlers.StringHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.StringHandler.prototype.stringRep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.NumberHandler = function() {
	};
	com.cognitect.transit.handlers.NumberHandler.prototype.tag = function(a) {
	  return "i";
	};
	com.cognitect.transit.handlers.NumberHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.NumberHandler.prototype.stringRep = function(a) {
	  return a.toString();
	};
	com.cognitect.transit.handlers.IntegerHandler = function() {
	};
	com.cognitect.transit.handlers.IntegerHandler.prototype.tag = function(a) {
	  return "i";
	};
	com.cognitect.transit.handlers.IntegerHandler.prototype.rep = function(a) {
	  return a.toString();
	};
	com.cognitect.transit.handlers.IntegerHandler.prototype.stringRep = function(a) {
	  return a.toString();
	};
	com.cognitect.transit.handlers.BooleanHandler = function() {
	};
	com.cognitect.transit.handlers.BooleanHandler.prototype.tag = function(a) {
	  return "?";
	};
	com.cognitect.transit.handlers.BooleanHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.BooleanHandler.prototype.stringRep = function(a) {
	  return a.toString();
	};
	com.cognitect.transit.handlers.ArrayHandler = function() {
	};
	com.cognitect.transit.handlers.ArrayHandler.prototype.tag = function(a) {
	  return "array";
	};
	com.cognitect.transit.handlers.ArrayHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.ArrayHandler.prototype.stringRep = function(a) {
	  return null;
	};
	com.cognitect.transit.handlers.MapHandler = function() {
	};
	com.cognitect.transit.handlers.MapHandler.prototype.tag = function(a) {
	  return "map";
	};
	com.cognitect.transit.handlers.MapHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.MapHandler.prototype.stringRep = function(a) {
	  return null;
	};
	com.cognitect.transit.handlers.VerboseDateHandler = function() {
	};
	com.cognitect.transit.handlers.VerboseDateHandler.prototype.tag = function(a) {
	  return "t";
	};
	com.cognitect.transit.handlers.VerboseDateHandler.prototype.rep = function(a) {
	  return a.getUTCFullYear() + "-" + com.cognitect.transit.handlers.padZeros(a.getUTCMonth() + 1, 2) + "-" + com.cognitect.transit.handlers.padZeros(a.getUTCDate(), 2) + "T" + com.cognitect.transit.handlers.padZeros(a.getUTCHours(), 2) + ":" + com.cognitect.transit.handlers.padZeros(a.getUTCMinutes(), 2) + ":" + com.cognitect.transit.handlers.padZeros(a.getUTCSeconds(), 2) + "." + com.cognitect.transit.handlers.padZeros(a.getUTCMilliseconds(), 3) + "Z";
	};
	com.cognitect.transit.handlers.VerboseDateHandler.prototype.stringRep = function(a, b) {
	  return b.rep(a);
	};
	com.cognitect.transit.handlers.DateHandler = function() {
	};
	com.cognitect.transit.handlers.DateHandler.prototype.tag = function(a) {
	  return "m";
	};
	com.cognitect.transit.handlers.DateHandler.prototype.rep = function(a) {
	  return a.valueOf();
	};
	com.cognitect.transit.handlers.DateHandler.prototype.stringRep = function(a) {
	  return a.valueOf().toString();
	};
	com.cognitect.transit.handlers.DateHandler.prototype.getVerboseHandler = function(a) {
	  return new com.cognitect.transit.handlers.VerboseDateHandler;
	};
	com.cognitect.transit.handlers.UUIDHandler = function() {
	};
	com.cognitect.transit.handlers.UUIDHandler.prototype.tag = function(a) {
	  return "u";
	};
	com.cognitect.transit.handlers.UUIDHandler.prototype.rep = function(a) {
	  return a.toString();
	};
	com.cognitect.transit.handlers.UUIDHandler.prototype.stringRep = function(a) {
	  return a.toString();
	};
	com.cognitect.transit.handlers.KeywordHandler = function() {
	};
	com.cognitect.transit.handlers.KeywordHandler.prototype.tag = function(a) {
	  return ":";
	};
	com.cognitect.transit.handlers.KeywordHandler.prototype.rep = function(a) {
	  return a._name;
	};
	com.cognitect.transit.handlers.KeywordHandler.prototype.stringRep = function(a, b) {
	  return b.rep(a);
	};
	com.cognitect.transit.handlers.SymbolHandler = function() {
	};
	com.cognitect.transit.handlers.SymbolHandler.prototype.tag = function(a) {
	  return "$";
	};
	com.cognitect.transit.handlers.SymbolHandler.prototype.rep = function(a) {
	  return a._name;
	};
	com.cognitect.transit.handlers.SymbolHandler.prototype.stringRep = function(a, b) {
	  return b.rep(a);
	};
	com.cognitect.transit.handlers.TaggedHandler = function() {
	};
	com.cognitect.transit.handlers.TaggedHandler.prototype.tag = function(a) {
	  return a.tag;
	};
	com.cognitect.transit.handlers.TaggedHandler.prototype.rep = function(a) {
	  return a.rep;
	};
	com.cognitect.transit.handlers.TaggedHandler.prototype.stringRep = function(a, b) {
	  return null;
	};
	com.cognitect.transit.handlers.TransitSetHandler = function() {
	};
	com.cognitect.transit.handlers.TransitSetHandler.prototype.tag = function(a) {
	  return "set";
	};
	com.cognitect.transit.handlers.TransitSetHandler.prototype.rep = function(a) {
	  var b = [];
	  a.forEach(function(a, d) {
	    b.push(a);
	  });
	  return com.cognitect.transit.types.taggedValue("array", b);
	};
	com.cognitect.transit.handlers.TransitSetHandler.prototype.stringRep = function(a, b) {
	  return null;
	};
	com.cognitect.transit.handlers.TransitArrayMapHandler = function() {
	};
	com.cognitect.transit.handlers.TransitArrayMapHandler.prototype.tag = function(a) {
	  return "map";
	};
	com.cognitect.transit.handlers.TransitArrayMapHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.TransitArrayMapHandler.prototype.stringRep = function(a, b) {
	  return null;
	};
	com.cognitect.transit.handlers.TransitMapHandler = function() {
	};
	com.cognitect.transit.handlers.TransitMapHandler.prototype.tag = function(a) {
	  return "map";
	};
	com.cognitect.transit.handlers.TransitMapHandler.prototype.rep = function(a) {
	  return a;
	};
	com.cognitect.transit.handlers.TransitMapHandler.prototype.stringRep = function(a, b) {
	  return null;
	};
	com.cognitect.transit.handlers.BufferHandler = function() {
	};
	com.cognitect.transit.handlers.BufferHandler.prototype.tag = function(a) {
	  return "b";
	};
	com.cognitect.transit.handlers.BufferHandler.prototype.rep = function(a) {
	  return a.toString("base64");
	};
	com.cognitect.transit.handlers.BufferHandler.prototype.stringRep = function(a, b) {
	  return null;
	};
	com.cognitect.transit.handlers.Uint8ArrayHandler = function() {
	};
	com.cognitect.transit.handlers.Uint8ArrayHandler.prototype.tag = function(a) {
	  return "b";
	};
	com.cognitect.transit.handlers.Uint8ArrayHandler.prototype.rep = function(a) {
	  return com.cognitect.transit.util.Uint8ToBase64(a);
	};
	com.cognitect.transit.handlers.Uint8ArrayHandler.prototype.stringRep = function(a, b) {
	  return null;
	};
	com.cognitect.transit.handlers.defaultHandlers = function(a) {
	  a.set(null, new com.cognitect.transit.handlers.NilHandler);
	  a.set(String, new com.cognitect.transit.handlers.StringHandler);
	  a.set(Number, new com.cognitect.transit.handlers.NumberHandler);
	  a.set(goog.math.Long, new com.cognitect.transit.handlers.IntegerHandler);
	  a.set(Boolean, new com.cognitect.transit.handlers.BooleanHandler);
	  a.set(Array, new com.cognitect.transit.handlers.ArrayHandler);
	  a.set(Object, new com.cognitect.transit.handlers.MapHandler);
	  a.set(Date, new com.cognitect.transit.handlers.DateHandler);
	  a.set(com.cognitect.transit.types.UUID, new com.cognitect.transit.handlers.UUIDHandler);
	  a.set(com.cognitect.transit.types.Keyword, new com.cognitect.transit.handlers.KeywordHandler);
	  a.set(com.cognitect.transit.types.Symbol, new com.cognitect.transit.handlers.SymbolHandler);
	  a.set(com.cognitect.transit.types.TaggedValue, new com.cognitect.transit.handlers.TaggedHandler);
	  a.set(com.cognitect.transit.types.TransitSet, new com.cognitect.transit.handlers.TransitSetHandler);
	  a.set(com.cognitect.transit.types.TransitArrayMap, new com.cognitect.transit.handlers.TransitArrayMapHandler);
	  a.set(com.cognitect.transit.types.TransitMap, new com.cognitect.transit.handlers.TransitMapHandler);
	  "undefined" != typeof Buffer && a.set(Buffer, new com.cognitect.transit.handlers.BufferHandler);
	  "undefined" != typeof Uint8Array && a.set(Uint8Array, new com.cognitect.transit.handlers.Uint8ArrayHandler);
	  return a;
	};
	com.cognitect.transit.handlers.Handlers = function() {
	  this.handlers = {};
	  com.cognitect.transit.handlers.defaultHandlers(this);
	};
	com.cognitect.transit.handlers.Handlers.prototype.get = function(a) {
	  var b = null, b = "string" === typeof a ? this.handlers[a] : this.handlers[com.cognitect.transit.handlers.typeTag(a)];
	  return null != b ? b : this.handlers["default"];
	};
	com.cognitect.transit.handlers.Handlers.prototype.get = com.cognitect.transit.handlers.Handlers.prototype.get;
	com.cognitect.transit.handlers.validTag = function(a) {
	  switch(a) {
	    case "null":
	    ;
	    case "string":
	    ;
	    case "boolean":
	    ;
	    case "number":
	    ;
	    case "array":
	    ;
	    case "map":
	      return !1;
	  }
	  return !0;
	};
	com.cognitect.transit.handlers.Handlers.prototype.set = function(a, b) {
	  "string" === typeof a && com.cognitect.transit.handlers.validTag(a) ? this.handlers[a] = b : this.handlers[com.cognitect.transit.handlers.typeTag(a)] = b;
	};
	com.cognitect.transit.impl = {};
	com.cognitect.transit.impl.decoder = {};
	com.cognitect.transit.impl.decoder.Tag = function(a) {
	  this.str = a;
	};
	com.cognitect.transit.impl.decoder.tag = function(a) {
	  return new com.cognitect.transit.impl.decoder.Tag(a);
	};
	com.cognitect.transit.impl.decoder.isTag = function(a) {
	  return a && a instanceof com.cognitect.transit.impl.decoder.Tag;
	};
	com.cognitect.transit.impl.decoder.isGroundHandler = function(a) {
	  switch(a) {
	    case "_":
	    ;
	    case "s":
	    ;
	    case "?":
	    ;
	    case "i":
	    ;
	    case "d":
	    ;
	    case "b":
	    ;
	    case "'":
	    ;
	    case "array":
	    ;
	    case "map":
	      return !0;
	  }
	  return !1;
	};
	com.cognitect.transit.impl.decoder.Decoder = function(a) {
	  this.options = a || {};
	  this.handlers = {};
	  for (var b in this.defaults.handlers) {
	    this.handlers[b] = this.defaults.handlers[b];
	  }
	  for (b in this.options.handlers) {
	    if (com.cognitect.transit.impl.decoder.isGroundHandler(b)) {
	      throw Error('Cannot override handler for ground type "' + b + '"');
	    }
	    this.handlers[b] = this.options.handlers[b];
	  }
	  this.preferStrings = null != this.options.preferStrings ? this.options.preferStrings : this.defaults.preferStrings;
	  this.preferBuffers = null != this.options.preferBuffers ? this.options.preferBuffers : this.defaults.preferBuffers;
	  this.defaultHandler = this.options.defaultHandler || this.defaults.defaultHandler;
	  this.mapBuilder = this.options.mapBuilder;
	  this.arrayBuilder = this.options.arrayBuilder;
	};
	com.cognitect.transit.impl.decoder.Decoder.prototype.defaults = {handlers:{_:function(a, b) {
	  return com.cognitect.transit.types.nullValue();
	}, "?":function(a, b) {
	  return com.cognitect.transit.types.boolValue(a);
	}, b:function(a, b) {
	  return com.cognitect.transit.types.binary(a, b);
	}, i:function(a, b) {
	  return com.cognitect.transit.types.intValue(a);
	}, n:function(a, b) {
	  return com.cognitect.transit.types.bigInteger(a);
	}, d:function(a, b) {
	  return com.cognitect.transit.types.floatValue(a);
	}, f:function(a, b) {
	  return com.cognitect.transit.types.bigDecimalValue(a);
	}, c:function(a, b) {
	  return com.cognitect.transit.types.charValue(a);
	}, ":":function(a, b) {
	  return com.cognitect.transit.types.keyword(a);
	}, $:function(a, b) {
	  return com.cognitect.transit.types.symbol(a);
	}, r:function(a, b) {
	  return com.cognitect.transit.types.uri(a);
	}, z:function(a, b) {
	  return com.cognitect.transit.types.specialDouble(a);
	}, "'":function(a, b) {
	  return a;
	}, m:function(a, b) {
	  return com.cognitect.transit.types.date(a);
	}, t:function(a, b) {
	  return com.cognitect.transit.types.verboseDate(a);
	}, u:function(a, b) {
	  return com.cognitect.transit.types.uuid(a);
	}, set:function(a, b) {
	  return com.cognitect.transit.types.set(a);
	}, list:function(a, b) {
	  return com.cognitect.transit.types.list(a);
	}, link:function(a, b) {
	  return com.cognitect.transit.types.link(a);
	}, cmap:function(a, b) {
	  return com.cognitect.transit.types.map(a, !1);
	}}, defaultHandler:function(a, b) {
	  return com.cognitect.transit.types.taggedValue(a, b);
	}, preferStrings:!0, preferBuffers:!0};
	com.cognitect.transit.impl.decoder.Decoder.prototype.decode = function(a, b, c, d) {
	  if (null == a) {
	    return null;
	  }
	  switch(typeof a) {
	    case "string":
	      return this.decodeString(a, b, c, d);
	    case "object":
	      return com.cognitect.transit.util.isArray(a) ? "^ " === a[0] ? this.decodeArrayHash(a, b, c, d) : this.decodeArray(a, b, c, d) : this.decodeHash(a, b, c, d);
	  }
	  return a;
	};
	com.cognitect.transit.impl.decoder.Decoder.prototype.decode = com.cognitect.transit.impl.decoder.Decoder.prototype.decode;
	com.cognitect.transit.impl.decoder.Decoder.prototype.decodeString = function(a, b, c, d) {
	  return com.cognitect.transit.caching.isCacheable(a, c) ? (a = this.parseString(a, b, !1), b && b.write(a, c), a) : com.cognitect.transit.caching.isCacheCode(a) ? b.read(a, c) : this.parseString(a, b, c);
	};
	com.cognitect.transit.impl.decoder.Decoder.prototype.decodeHash = function(a, b, c, d) {
	  c = com.cognitect.transit.util.objectKeys(a);
	  var e = c[0];
	  d = 1 == c.length ? this.decode(e, b, !1, !1) : null;
	  if (com.cognitect.transit.impl.decoder.isTag(d)) {
	    return a = a[e], c = this.handlers[d.str], null != c ? c(this.decode(a, b, !1, !0), this) : com.cognitect.transit.types.taggedValue(d.str, this.decode(a, b, !1, !1));
	  }
	  if (this.mapBuilder) {
	    if (c.length < 2 * com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD && this.mapBuilder.fromArray) {
	      var f = [];
	      for (d = 0;d < c.length;d++) {
	        e = c[d], f.push(this.decode(e, b, !0, !1)), f.push(this.decode(a[e], b, !1, !1));
	      }
	      return this.mapBuilder.fromArray(f, a);
	    }
	    f = this.mapBuilder.init(a);
	    for (d = 0;d < c.length;d++) {
	      e = c[d], f = this.mapBuilder.add(f, this.decode(e, b, !0, !1), this.decode(a[e], b, !1, !1), a);
	    }
	    return this.mapBuilder.finalize(f, a);
	  }
	  f = [];
	  for (d = 0;d < c.length;d++) {
	    e = c[d], f.push(this.decode(e, b, !0, !1)), f.push(this.decode(a[e], b, !1, !1));
	  }
	  return com.cognitect.transit.types.map(f, !1);
	};
	com.cognitect.transit.impl.decoder.Decoder.prototype.decodeArrayHash = function(a, b, c, d) {
	  if (this.mapBuilder) {
	    if (a.length < 2 * com.cognitect.transit.types.SMALL_ARRAY_MAP_THRESHOLD + 1 && this.mapBuilder.fromArray) {
	      d = [];
	      for (c = 1;c < a.length;c += 2) {
	        d.push(this.decode(a[c], b, !0, !1)), d.push(this.decode(a[c + 1], b, !1, !1));
	      }
	      return this.mapBuilder.fromArray(d, a);
	    }
	    d = this.mapBuilder.init(a);
	    for (c = 1;c < a.length;c += 2) {
	      d = this.mapBuilder.add(d, this.decode(a[c], b, !0, !1), this.decode(a[c + 1], b, !1, !1), a);
	    }
	    return this.mapBuilder.finalize(d, a);
	  }
	  d = [];
	  for (c = 1;c < a.length;c += 2) {
	    d.push(this.decode(a[c], b, !0, !1)), d.push(this.decode(a[c + 1], b, !1, !1));
	  }
	  return com.cognitect.transit.types.map(d, !1);
	};
	com.cognitect.transit.impl.decoder.Decoder.prototype.decodeArray = function(a, b, c, d) {
	  if (d) {
	    var e = [];
	    for (d = 0;d < a.length;d++) {
	      e.push(this.decode(a[d], b, c, !1));
	    }
	    return e;
	  }
	  e = b && b.idx;
	  if (2 === a.length && "string" === typeof a[0] && (d = this.decode(a[0], b, !1, !1), com.cognitect.transit.impl.decoder.isTag(d))) {
	    return a = a[1], e = this.handlers[d.str], null != e ? e = e(this.decode(a, b, c, !0), this) : com.cognitect.transit.types.taggedValue(d.str, this.decode(a, b, c, !1));
	  }
	  b && e != b.idx && (b.idx = e);
	  if (this.arrayBuilder) {
	    if (32 >= a.length && this.arrayBuilder.fromArray) {
	      e = [];
	      for (d = 0;d < a.length;d++) {
	        e.push(this.decode(a[d], b, c, !1));
	      }
	      return this.arrayBuilder.fromArray(e, a);
	    }
	    e = this.arrayBuilder.init(a);
	    for (d = 0;d < a.length;d++) {
	      e = this.arrayBuilder.add(e, this.decode(a[d], b, c, !1), a);
	    }
	    return this.arrayBuilder.finalize(e, a);
	  }
	  e = [];
	  for (d = 0;d < a.length;d++) {
	    e.push(this.decode(a[d], b, c, !1));
	  }
	  return e;
	};
	com.cognitect.transit.impl.decoder.Decoder.prototype.parseString = function(a, b, c) {
	  if (a.charAt(0) === com.cognitect.transit.delimiters.ESC) {
	    b = a.charAt(1);
	    if (b === com.cognitect.transit.delimiters.ESC || b === com.cognitect.transit.delimiters.SUB || b === com.cognitect.transit.delimiters.RES) {
	      return a.substring(1);
	    }
	    if (b === com.cognitect.transit.delimiters.TAG) {
	      return com.cognitect.transit.impl.decoder.tag(a.substring(2));
	    }
	    c = this.handlers[b];
	    return null == c ? this.defaultHandler(b, a.substring(2)) : c(a.substring(2), this);
	  }
	  return a;
	};
	com.cognitect.transit.impl.decoder.decoder = function(a) {
	  return new com.cognitect.transit.impl.decoder.Decoder(a);
	};
	com.cognitect.transit.impl.reader = {};
	com.cognitect.transit.impl.reader.JSONUnmarshaller = function(a) {
	  this.decoder = new com.cognitect.transit.impl.decoder.Decoder(a);
	};
	com.cognitect.transit.impl.reader.JSONUnmarshaller.prototype.unmarshal = function(a, b) {
	  return this.decoder.decode(JSON.parse(a), b);
	};
	com.cognitect.transit.impl.reader.Reader = function(a, b) {
	  this.unmarshaller = a;
	  this.options = b || {};
	  this.cache = this.options.cache ? this.options.cache : new com.cognitect.transit.caching.ReadCache;
	};
	com.cognitect.transit.impl.reader.Reader.prototype.read = function(a) {
	  a = this.unmarshaller.unmarshal(a, this.cache);
	  this.cache.clear();
	  return a;
	};
	com.cognitect.transit.impl.reader.Reader.prototype.read = com.cognitect.transit.impl.reader.Reader.prototype.read;
	com.cognitect.transit.impl.writer = {};
	com.cognitect.transit.impl.writer.escape = function(a) {
	  if (0 < a.length) {
	    var b = a.charAt(0);
	    return b === com.cognitect.transit.delimiters.ESC || b === com.cognitect.transit.delimiters.SUB || b === com.cognitect.transit.delimiters.RES ? com.cognitect.transit.delimiters.ESC + a : a;
	  }
	  return a;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller = function(a) {
	  this.opts = a || {};
	  this.preferStrings = null != this.opts.preferStrings ? this.opts.preferStrings : !0;
	  this.objectBuilder = this.opts.objectBuilder || null;
	  this.handlers = new com.cognitect.transit.handlers.Handlers;
	  if (a = this.opts.handlers) {
	    if (com.cognitect.transit.util.isArray(a) || !a.forEach) {
	      throw Error('transit writer "handlers" option must be a map');
	    }
	    var b = this;
	    a.forEach(function(a, d) {
	      if (void 0 !== d) {
	        b.handlers.set(d, a);
	      } else {
	        throw Error("Cannot create handler for JavaScript undefined");
	      }
	    });
	  }
	  this.handlerForForeign = this.opts.handlerForForeign;
	  this.unpack = this.opts.unpack || function(a) {
	    return com.cognitect.transit.types.isArrayMap(a) && null === a.backingMap ? a._entries : !1;
	  };
	  this.verbose = this.opts && this.opts.verbose || !1;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.handler = function(a) {
	  var b = this.handlers.get(com.cognitect.transit.handlers.constructor(a));
	  return null != b ? b : (a = a && a.transitTag) ? this.handlers.get(a) : null;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.registerHandler = function(a, b) {
	  this.handlers.set(a, b);
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitNil = function(a, b) {
	  return a ? this.emitString(com.cognitect.transit.delimiters.ESC, "_", "", a, b) : null;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitString = function(a, b, c, d, e) {
	  a = a + b + c;
	  return e ? e.write(a, d) : a;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitBoolean = function(a, b, c) {
	  return b ? this.emitString(com.cognitect.transit.delimiters.ESC, "?", a.toString()[0], b, c) : a;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitInteger = function(a, b, c) {
	  return Infinity === a ? this.emitString(com.cognitect.transit.delimiters.ESC, "z", "INF", b, c) : -Infinity === a ? this.emitString(com.cognitect.transit.delimiters.ESC, "z", "-INF", b, c) : isNaN(a) ? this.emitString(com.cognitect.transit.delimiters.ESC, "z", "NaN", b, c) : b || "string" === typeof a || a instanceof goog.math.Long ? this.emitString(com.cognitect.transit.delimiters.ESC, "i", a.toString(), b, c) : a;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitDouble = function(a, b, c) {
	  return b ? this.emitString(a.ESC, "d", a, b, c) : a;
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitBinary = function(a, b, c) {
	  return this.emitString(com.cognitect.transit.delimiters.ESC, "b", a, b, c);
	};
	com.cognitect.transit.impl.writer.JSONMarshaller.prototype.emitQuoted = function(a, b, c) {
	  if (a.verbose) {
	    a = {};
	    var d = this.emitString(com.cognitect.transit.delimiters.ESC_TAG, "'", "", !0, c);
	    a[d] = com.cognitect.transit.impl.writer.marshal(this, b, !1, c);
	    return a;
	  }
	  return [this.emitString(com.cognitect.transit.delimiters.ESC_TAG, "'", "", !0, c), com.cognitect.transit.impl.writer.marshal(this, b, !1, c)];
	};
	com.cognitect.transit.impl.writer.emitObjects = function(a, b, c) {
	  var d = [];
	  if (com.cognitect.transit.util.isArray(b)) {
	    for (var e = 0;e < b.length;e++) {
	      d.push(com.cognitect.transit.impl.writer.marshal(a, b[e], !1, c));
	    }
	  } else {
	    b.forEach(function(b, e) {
	      d.push(com.cognitect.transit.impl.writer.marshal(a, b, !1, c));
	    });
	  }
	  return d;
	};
	com.cognitect.transit.impl.writer.emitArray = function(a, b, c, d) {
	  return com.cognitect.transit.impl.writer.emitObjects(a, b, d);
	};
	com.cognitect.transit.impl.writer.isStringableKey = function(a, b) {
	  if ("string" !== typeof b) {
	    var c = a.handler(b);
	    return c && 1 === c.tag(b).length;
	  }
	  return !0;
	};
	com.cognitect.transit.impl.writer.stringableKeys = function(a, b) {
	  var c = a.unpack(b), d = !0;
	  if (c) {
	    for (var e = 0;e < c.length && (d = com.cognitect.transit.impl.writer.isStringableKey(a, c[e]), d);e += 2) {
	    }
	    return d;
	  }
	  if (b.keys && (c = b.keys(), e = null, c.next)) {
	    for (e = c.next();!e.done;) {
	      d = com.cognitect.transit.impl.writer.isStringableKey(a, e.value);
	      if (!d) {
	        break;
	      }
	      e = c.next();
	    }
	    return d;
	  }
	  if (b.forEach) {
	    return b.forEach(function(b, c) {
	      d = d && com.cognitect.transit.impl.writer.isStringableKey(a, c);
	    }), d;
	  }
	  throw Error("Cannot walk keys of object type " + com.cognitect.transit.handlers.constructor(b).name);
	};
	com.cognitect.transit.impl.writer.isForeignObject = function(a) {
	  if (a.constructor.transit$isObject) {
	    return !0;
	  }
	  var b = a.constructor.toString(), b = b.substr(9), b = b.substr(0, b.indexOf("("));
	  isObject = "Object" == b;
	  "undefined" != typeof Object.defineProperty ? Object.defineProperty(a.constructor, "transit$isObject", {value:isObject, enumerable:!1}) : a.constructor.transit$isObject = isObject;
	  return isObject;
	};
	com.cognitect.transit.impl.writer.emitMap = function(a, b, c, d) {
	  var e = null, f = null, g = null, e = null;
	  c = 0;
	  if (b.constructor === Object || null != b.forEach || a.handlerForForeign && com.cognitect.transit.impl.writer.isForeignObject(b)) {
	    if (a.verbose) {
	      if (null != b.forEach) {
	        if (com.cognitect.transit.impl.writer.stringableKeys(a, b)) {
	          var h = {};
	          b.forEach(function(b, c) {
	            h[com.cognitect.transit.impl.writer.marshal(a, c, !0, !1)] = com.cognitect.transit.impl.writer.marshal(a, b, !1, d);
	          });
	        } else {
	          e = a.unpack(b);
	          f = [];
	          g = a.emitString(com.cognitect.transit.delimiters.ESC_TAG, "cmap", "", !0, d);
	          if (e) {
	            for (;c < e.length;c += 2) {
	              f.push(com.cognitect.transit.impl.writer.marshal(a, e[c], !1, !1)), f.push(com.cognitect.transit.impl.writer.marshal(a, e[c + 1], !1, d));
	            }
	          } else {
	            b.forEach(function(b, c) {
	              f.push(com.cognitect.transit.impl.writer.marshal(a, c, !1, !1));
	              f.push(com.cognitect.transit.impl.writer.marshal(a, b, !1, d));
	            });
	          }
	          h = {};
	          h[g] = f;
	        }
	      } else {
	        for (e = com.cognitect.transit.util.objectKeys(b), h = {};c < e.length;c++) {
	          h[com.cognitect.transit.impl.writer.marshal(a, e[c], !0, !1)] = com.cognitect.transit.impl.writer.marshal(a, b[e[c]], !1, d);
	        }
	      }
	      return h;
	    }
	    if (null != b.forEach) {
	      if (com.cognitect.transit.impl.writer.stringableKeys(a, b)) {
	        e = a.unpack(b);
	        h = ["^ "];
	        if (e) {
	          for (;c < e.length;c += 2) {
	            h.push(com.cognitect.transit.impl.writer.marshal(a, e[c], !0, d)), h.push(com.cognitect.transit.impl.writer.marshal(a, e[c + 1], !1, d));
	          }
	        } else {
	          b.forEach(function(b, c) {
	            h.push(com.cognitect.transit.impl.writer.marshal(a, c, !0, d));
	            h.push(com.cognitect.transit.impl.writer.marshal(a, b, !1, d));
	          });
	        }
	        return h;
	      }
	      e = a.unpack(b);
	      f = [];
	      g = a.emitString(com.cognitect.transit.delimiters.ESC_TAG, "cmap", "", !0, d);
	      if (e) {
	        for (;c < e.length;c += 2) {
	          f.push(com.cognitect.transit.impl.writer.marshal(a, e[c], !1, d)), f.push(com.cognitect.transit.impl.writer.marshal(a, e[c + 1], !1, d));
	        }
	      } else {
	        b.forEach(function(b, c) {
	          f.push(com.cognitect.transit.impl.writer.marshal(a, c, !1, d));
	          f.push(com.cognitect.transit.impl.writer.marshal(a, b, !1, d));
	        });
	      }
	      return [g, f];
	    }
	    h = ["^ "];
	    for (e = com.cognitect.transit.util.objectKeys(b);c < e.length;c++) {
	      h.push(com.cognitect.transit.impl.writer.marshal(a, e[c], !0, d)), h.push(com.cognitect.transit.impl.writer.marshal(a, b[e[c]], !1, d));
	    }
	    return h;
	  }
	  if (null != a.objectBuilder) {
	    return a.objectBuilder(b, function(b) {
	      return com.cognitect.transit.impl.writer.marshal(a, b, !0, d);
	    }, function(b) {
	      return com.cognitect.transit.impl.writer.marshal(a, b, !1, d);
	    });
	  }
	  c = com.cognitect.transit.handlers.constructor(b).name;
	  e = Error("Cannot write " + c);
	  e.data = {obj:b, type:c};
	  throw e;
	};
	com.cognitect.transit.impl.writer.emitTaggedMap = function(a, b, c, d, e) {
	  return a.verbose ? (d = {}, d[a.emitString(com.cognitect.transit.delimiters.ESC_TAG, b, "", !0, e)] = com.cognitect.transit.impl.writer.marshal(a, c, !1, e), d) : [a.emitString(com.cognitect.transit.delimiters.ESC_TAG, b, "", !0, e), com.cognitect.transit.impl.writer.marshal(a, c, !1, e)];
	};
	com.cognitect.transit.impl.writer.emitEncoded = function(a, b, c, d, e, f, g) {
	  if (1 === c.length) {
	    if ("string" === typeof d) {
	      return a.emitString(com.cognitect.transit.delimiters.ESC, c, d, f, g);
	    }
	    if (f || a.preferStrings) {
	      (d = a.verbose && b.getVerboseHandler()) ? (c = d.tag(e), d = d.stringRep(e, d)) : d = b.stringRep(e, b);
	      if (null !== d) {
	        return a.emitString(com.cognitect.transit.delimiters.ESC, c, d, f, g);
	      }
	      a = Error('Tag "' + c + '" cannot be encoded as string');
	      a.data = {tag:c, rep:d, obj:e};
	      throw a;
	    }
	  }
	  return com.cognitect.transit.impl.writer.emitTaggedMap(a, c, d, f, g);
	};
	com.cognitect.transit.impl.writer.marshal = function(a, b, c, d) {
	  var e = a.handler(b) || (a.handlerForForeign ? a.handlerForForeign(b, a.handlers) : null), f = e ? e.tag(b) : null, g = e ? e.rep(b) : null;
	  if (null != e && null != f) {
	    switch(f) {
	      case "_":
	        return a.emitNil(c, d);
	      case "s":
	        return a.emitString("", "", com.cognitect.transit.impl.writer.escape(g), c, d);
	      case "?":
	        return a.emitBoolean(g, c, d);
	      case "i":
	        return a.emitInteger(g, c, d);
	      case "d":
	        return a.emitDouble(g, c, d);
	      case "b":
	        return a.emitBinary(g, c, d);
	      case "'":
	        return a.emitQuoted(a, g, d);
	      case "array":
	        return com.cognitect.transit.impl.writer.emitArray(a, g, c, d);
	      case "map":
	        return com.cognitect.transit.impl.writer.emitMap(a, g, c, d);
	      default:
	        return com.cognitect.transit.impl.writer.emitEncoded(a, e, f, g, b, c, d);
	    }
	  } else {
	    throw a = com.cognitect.transit.handlers.constructor(b).name, c = Error("Cannot write " + a), c.data = {obj:b, type:a}, c;
	  }
	};
	com.cognitect.transit.impl.writer.maybeQuoted = function(a, b) {
	  var c = a.handler(b) || (a.handlerForForeign ? a.handlerForForeign(b, a.handlers) : null);
	  if (null != c) {
	    return 1 === c.tag(b).length ? com.cognitect.transit.types.quoted(b) : b;
	  }
	  var c = com.cognitect.transit.handlers.constructor(b).name, d = Error("Cannot write " + c);
	  d.data = {obj:b, type:c};
	  throw d;
	};
	com.cognitect.transit.impl.writer.marshalTop = function(a, b, c, d) {
	  return JSON.stringify(com.cognitect.transit.impl.writer.marshal(a, com.cognitect.transit.impl.writer.maybeQuoted(a, b), c, d));
	};
	com.cognitect.transit.impl.writer.Writer = function(a, b) {
	  this._marshaller = a;
	  this.options = b || {};
	  this.cache = !1 === this.options.cache ? null : this.options.cache ? this.options.cache : new com.cognitect.transit.caching.WriteCache;
	};
	com.cognitect.transit.impl.writer.Writer.prototype.marshaller = function() {
	  return this._marshaller;
	};
	com.cognitect.transit.impl.writer.Writer.prototype.marshaller = com.cognitect.transit.impl.writer.Writer.prototype.marshaller;
	com.cognitect.transit.impl.writer.Writer.prototype.write = function(a, b) {
	  var c = null, c = b || {}, d = c.asMapKey || !1, e = this._marshaller.verbose ? !1 : this.cache, c = !1 === c.marshalTop ? com.cognitect.transit.impl.writer.marshal(this._marshaller, a, d, e) : com.cognitect.transit.impl.writer.marshalTop(this._marshaller, a, d, e);
	  null != this.cache && this.cache.clear();
	  return c;
	};
	com.cognitect.transit.impl.writer.Writer.prototype.write = com.cognitect.transit.impl.writer.Writer.prototype.write;
	com.cognitect.transit.impl.writer.Writer.prototype.register = function(a, b) {
	  this._marshaller.registerHandler(a, b);
	};
	com.cognitect.transit.impl.writer.Writer.prototype.register = com.cognitect.transit.impl.writer.Writer.prototype.register;
	var TRANSIT_DEV = !0, TRANSIT_NODE_TARGET = !0, TRANSIT_BROWSER_TARGET = !1, TRANSIT_BROWSER_AMD_TARGET = !1;
	com.cognitect.transit.reader = function(a, b) {
	  if ("json" === a || "json-verbose" === a || null == a) {
	    var c = new com.cognitect.transit.impl.reader.JSONUnmarshaller(b);
	    return new com.cognitect.transit.impl.reader.Reader(c, b);
	  }
	  throw Error("Cannot create reader of type " + a);
	};
	com.cognitect.transit.writer = function(a, b) {
	  if ("json" === a || "json-verbose" === a || null == a) {
	    "json-verbose" === a && (null == b && (b = {}), b.verbose = !0);
	    var c = new com.cognitect.transit.impl.writer.JSONMarshaller(b);
	    return new com.cognitect.transit.impl.writer.Writer(c, b);
	  }
	  c = Error('Type must be "json"');
	  c.data = {type:a};
	  throw c;
	};
	com.cognitect.transit.makeWriteHandler = function(a) {
	  var b = function() {
	  };
	  b.prototype.tag = a.tag;
	  b.prototype.rep = a.rep;
	  b.prototype.stringRep = a.stringRep;
	  b.prototype.getVerboseHandler = a.getVerboseHandler;
	  return new b;
	};
	com.cognitect.transit.makeBuilder = function(a) {
	  var b = function() {
	  };
	  b.prototype.init = a.init;
	  b.prototype.add = a.add;
	  b.prototype.finalize = a.finalize;
	  b.prototype.fromArray = a.fromArray;
	  return new b;
	};
	com.cognitect.transit.date = com.cognitect.transit.types.date;
	com.cognitect.transit.integer = com.cognitect.transit.types.intValue;
	com.cognitect.transit.isInteger = com.cognitect.transit.types.isInteger;
	com.cognitect.transit.uuid = com.cognitect.transit.types.uuid;
	com.cognitect.transit.isUUID = com.cognitect.transit.types.isUUID;
	com.cognitect.transit.bigInt = com.cognitect.transit.types.bigInteger;
	com.cognitect.transit.isBigInt = com.cognitect.transit.types.isBigInteger;
	com.cognitect.transit.bigDec = com.cognitect.transit.types.bigDecimalValue;
	com.cognitect.transit.isBigDec = com.cognitect.transit.types.isBigDecimal;
	com.cognitect.transit.keyword = com.cognitect.transit.types.keyword;
	com.cognitect.transit.isKeyword = com.cognitect.transit.types.isKeyword;
	com.cognitect.transit.symbol = com.cognitect.transit.types.symbol;
	com.cognitect.transit.isSymbol = com.cognitect.transit.types.isSymbol;
	com.cognitect.transit.binary = com.cognitect.transit.types.binary;
	com.cognitect.transit.isBinary = com.cognitect.transit.types.isBinary;
	com.cognitect.transit.uri = com.cognitect.transit.types.uri;
	com.cognitect.transit.isURI = com.cognitect.transit.types.isURI;
	com.cognitect.transit.map = com.cognitect.transit.types.map;
	com.cognitect.transit.isMap = com.cognitect.transit.types.isMap;
	com.cognitect.transit.set = com.cognitect.transit.types.set;
	com.cognitect.transit.isSet = com.cognitect.transit.types.isSet;
	com.cognitect.transit.list = com.cognitect.transit.types.list;
	com.cognitect.transit.isList = com.cognitect.transit.types.isList;
	com.cognitect.transit.quoted = com.cognitect.transit.types.quoted;
	com.cognitect.transit.isQuoted = com.cognitect.transit.types.isQuoted;
	com.cognitect.transit.tagged = com.cognitect.transit.types.taggedValue;
	com.cognitect.transit.isTaggedValue = com.cognitect.transit.types.isTaggedValue;
	com.cognitect.transit.link = com.cognitect.transit.types.link;
	com.cognitect.transit.isLink = com.cognitect.transit.types.isLink;
	com.cognitect.transit.hash = com.cognitect.transit.eq.hashCode;
	com.cognitect.transit.hashMapLike = com.cognitect.transit.eq.hashMapLike;
	com.cognitect.transit.hashArrayLike = com.cognitect.transit.eq.hashArrayLike;
	com.cognitect.transit.equals = com.cognitect.transit.eq.equals;
	com.cognitect.transit.extendToEQ = com.cognitect.transit.eq.extendToEQ;
	com.cognitect.transit.mapToObject = function(a) {
	  var b = {};
	  a.forEach(function(a, d) {
	    if ("string" !== typeof d) {
	      throw Error("Cannot convert map with non-string keys");
	    }
	    b[d] = a;
	  });
	  return b;
	};
	com.cognitect.transit.objectToMap = function(a) {
	  var b = com.cognitect.transit.map(), c;
	  for (c in a) {
	    a.hasOwnProperty(c) && b.set(c, a[c]);
	  }
	  return b;
	};
	com.cognitect.transit.decoder = com.cognitect.transit.impl.decoder.decoder;
	com.cognitect.transit.readCache = com.cognitect.transit.caching.readCache;
	com.cognitect.transit.writeCache = com.cognitect.transit.caching.writeCache;
	com.cognitect.transit.UUIDfromString = com.cognitect.transit.types.UUIDfromString;
	com.cognitect.transit.randomUUID = com.cognitect.transit.util.randomUUID;
	com.cognitect.transit.stringableKeys = com.cognitect.transit.impl.writer.stringableKeys;
	TRANSIT_BROWSER_TARGET && (goog.exportSymbol("transit.reader", com.cognitect.transit.reader), goog.exportSymbol("transit.writer", com.cognitect.transit.writer), goog.exportSymbol("transit.makeBuilder", com.cognitect.transit.makeBuilder), goog.exportSymbol("transit.makeWriteHandler", com.cognitect.transit.makeWriteHandler), goog.exportSymbol("transit.date", com.cognitect.transit.types.date), goog.exportSymbol("transit.integer", com.cognitect.transit.types.intValue), goog.exportSymbol("transit.isInteger", 
	com.cognitect.transit.types.isInteger), goog.exportSymbol("transit.uuid", com.cognitect.transit.types.uuid), goog.exportSymbol("transit.isUUID", com.cognitect.transit.types.isUUID), goog.exportSymbol("transit.bigInt", com.cognitect.transit.types.bigInteger), goog.exportSymbol("transit.isBigInt", com.cognitect.transit.types.isBigInteger), goog.exportSymbol("transit.bigDec", com.cognitect.transit.types.bigDecimalValue), goog.exportSymbol("transit.isBigDec", com.cognitect.transit.types.isBigDecimal), 
	goog.exportSymbol("transit.keyword", com.cognitect.transit.types.keyword), goog.exportSymbol("transit.isKeyword", com.cognitect.transit.types.isKeyword), goog.exportSymbol("transit.symbol", com.cognitect.transit.types.symbol), goog.exportSymbol("transit.isSymbol", com.cognitect.transit.types.isSymbol), goog.exportSymbol("transit.binary", com.cognitect.transit.types.binary), goog.exportSymbol("transit.isBinary", com.cognitect.transit.types.isBinary), goog.exportSymbol("transit.uri", com.cognitect.transit.types.uri), 
	goog.exportSymbol("transit.isURI", com.cognitect.transit.types.isURI), goog.exportSymbol("transit.map", com.cognitect.transit.types.map), goog.exportSymbol("transit.isMap", com.cognitect.transit.types.isMap), goog.exportSymbol("transit.set", com.cognitect.transit.types.set), goog.exportSymbol("transit.isSet", com.cognitect.transit.types.isSet), goog.exportSymbol("transit.list", com.cognitect.transit.types.list), goog.exportSymbol("transit.isList", com.cognitect.transit.types.isList), goog.exportSymbol("transit.quoted", 
	com.cognitect.transit.types.quoted), goog.exportSymbol("transit.isQuoted", com.cognitect.transit.types.isQuoted), goog.exportSymbol("transit.tagged", com.cognitect.transit.types.taggedValue), goog.exportSymbol("transit.isTaggedValue", com.cognitect.transit.types.isTaggedValue), goog.exportSymbol("transit.link", com.cognitect.transit.types.link), goog.exportSymbol("transit.isLink", com.cognitect.transit.types.isLink), goog.exportSymbol("transit.hash", com.cognitect.transit.eq.hashCode), goog.exportSymbol("transit.hashMapLike", 
	com.cognitect.transit.eq.hashMapLike), goog.exportSymbol("transit.hashArrayLike", com.cognitect.transit.eq.hashArrayLike), goog.exportSymbol("transit.equals", com.cognitect.transit.eq.equals), goog.exportSymbol("transit.extendToEQ", com.cognitect.transit.eq.extendToEQ), goog.exportSymbol("transit.mapToObject", com.cognitect.transit.mapToObject), goog.exportSymbol("transit.objectToMap", com.cognitect.transit.objectToMap), goog.exportSymbol("transit.decoder", com.cognitect.transit.impl.decoder.decoder), 
	goog.exportSymbol("transit.UUIDfromString", com.cognitect.transit.types.UUIDfromString), goog.exportSymbol("transit.randomUUID", com.cognitect.transit.util.randomUUID), goog.exportSymbol("transit.stringableKeys", com.cognitect.transit.impl.writer.stringableKeys), goog.exportSymbol("transit.readCache", com.cognitect.transit.caching.readCache), goog.exportSymbol("transit.writeCache", com.cognitect.transit.caching.writeCache));
	TRANSIT_NODE_TARGET && (module.exports = {reader:com.cognitect.transit.reader, writer:com.cognitect.transit.writer, makeBuilder:com.cognitect.transit.makeBuilder, makeWriteHandler:com.cognitect.transit.makeWriteHandler, date:com.cognitect.transit.types.date, integer:com.cognitect.transit.types.intValue, isInteger:com.cognitect.transit.types.isInteger, uuid:com.cognitect.transit.types.uuid, isUUID:com.cognitect.transit.types.isUUID, bigInt:com.cognitect.transit.types.bigInteger, isBigInt:com.cognitect.transit.types.isBigInteger, 
	bigDec:com.cognitect.transit.types.bigDecimalValue, isBigDec:com.cognitect.transit.types.isBigDecimal, keyword:com.cognitect.transit.types.keyword, isKeyword:com.cognitect.transit.types.isKeyword, symbol:com.cognitect.transit.types.symbol, isSymbol:com.cognitect.transit.types.isSymbol, binary:com.cognitect.transit.types.binary, isBinary:com.cognitect.transit.types.isBinary, uri:com.cognitect.transit.types.uri, isURI:com.cognitect.transit.types.isURI, map:com.cognitect.transit.types.map, isMap:com.cognitect.transit.types.isMap, 
	set:com.cognitect.transit.types.set, isSet:com.cognitect.transit.types.isSet, list:com.cognitect.transit.types.list, isList:com.cognitect.transit.types.isList, quoted:com.cognitect.transit.types.quoted, isQuoted:com.cognitect.transit.types.isQuoted, tagged:com.cognitect.transit.types.taggedValue, isTaggedValue:com.cognitect.transit.types.isTaggedValue, link:com.cognitect.transit.types.link, isLink:com.cognitect.transit.types.isLink, hash:com.cognitect.transit.eq.hashCode, hashArrayLike:com.cognitect.transit.eq.hashArrayLike, 
	hashMapLike:com.cognitect.transit.eq.hashMapLike, equals:com.cognitect.transit.eq.equals, extendToEQ:com.cognitect.transit.eq.extendToEQ, mapToObject:com.cognitect.transit.mapToObject, objectToMap:com.cognitect.transit.objectToMap, decoder:com.cognitect.transit.impl.decoder.decoder, UUIDfromString:com.cognitect.transit.types.UUIDfromString, randomUUID:com.cognitect.transit.util.randomUUID, stringableKeys:com.cognitect.transit.impl.writer.stringableKeys, readCache:com.cognitect.transit.caching.readCache, 
	writeCache:com.cognitect.transit.caching.writeCache});
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 3294 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.17
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.17',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major', // deprecated
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded';
	
	
	    ///////////
	    // Helper
	    //////////
	
	
	    var util = {
	        extend : function (regexes, extensions) {
	            var margedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    margedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    margedRegexes[i] = regexes[i];
	                }
	            }
	            return margedRegexes;
	        },
	        has : function (str1, str2) {
	          if (typeof str1 === "string") {
	            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
	          } else {
	            return false;
	          }
	        },
	        lowerize : function (str) {
	            return str.toLowerCase();
	        },
	        major : function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
	        },
	        trim : function (str) {
	          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	        }
	    };
	
	
	    ///////////////
	    // Map helper
	    //////////////
	
	
	    var mapper = {
	
	        rgx : function (ua, arrays) {
	
	            //var result = {},
	            var i = 0, j, k, p, q, matches, match;//, args = arguments;
	
	            /*// construct object barebones
	            for (p = 0; p < args[1].length; p++) {
	                q = args[1][p];
	                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
	            }*/
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length == 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length == 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length == 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	            // console.log(this);
	            //return this;
	        },
	
	        str : function (str, map) {
	
	            for (var i in map) {
	                // check if array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (util.has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (util.has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	        }
	    };
	
	
	    ///////////////
	    // String map
	    //////////////
	
	
	    var maps = {
	
	        browser : {
	            oldsafari : {
	                version : {
	                    '1.0'   : '/8',
	                    '1.2'   : '/1',
	                    '1.3'   : '/3',
	                    '2.0'   : '/412',
	                    '2.0.2' : '/416',
	                    '2.0.3' : '/417',
	                    '2.0.4' : '/419',
	                    '?'     : '/'
	                }
	            }
	        },
	
	        device : {
	            amazon : {
	                model : {
	                    'Fire Phone' : ['SD', 'KF']
	                }
	            },
	            sprint : {
	                model : {
	                    'Evo Shift 4G' : '7373KT'
	                },
	                vendor : {
	                    'HTC'       : 'APA',
	                    'Sprint'    : 'Sprint'
	                }
	            }
	        },
	
	        os : {
	            windows : {
	                version : {
	                    'ME'        : '4.90',
	                    'NT 3.11'   : 'NT3.51',
	                    'NT 4.0'    : 'NT4.0',
	                    '2000'      : 'NT 5.0',
	                    'XP'        : ['NT 5.1', 'NT 5.2'],
	                    'Vista'     : 'NT 6.0',
	                    '7'         : 'NT 6.1',
	                    '8'         : 'NT 6.2',
	                    '8.1'       : 'NT 6.3',
	                    '10'        : ['NT 6.4', 'NT 10.0'],
	                    'RT'        : 'ARM'
	                }
	            }
	        }
	    };
	
	
	    //////////////
	    // Regex map
	    /////////////
	
	
	    var regexes = {
	
	        browser : [[
	
	            // Presto based
	            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
	            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
	            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
	            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
	            ], [NAME, VERSION], [
	
	            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
	            ], [[NAME, 'Opera Mini'], VERSION], [
	
	            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
	            ], [[NAME, 'Opera'], VERSION], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
	                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	
	            // Trident based
	            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
	                                                                                // Avant/IEMobile/SlimBrowser/Baidu
	            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer
	
	            // Webkit/KHTML based
	            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
	            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
	                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
	            ], [NAME, VERSION], [
	
	            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
	            ], [[NAME, 'IE'], VERSION], [
	
	            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
	            ], [NAME, VERSION], [
	
	            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
	            ], [[NAME, 'Yandex'], VERSION], [
	
	            /(puffin)\/([\w\.]+)/i                                              // Puffin
	            ], [[NAME, 'Puffin'], VERSION], [
	
	            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
	                                                                                // UCBrowser
	            ], [[NAME, 'UCBrowser'], VERSION], [
	
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
	            ], [[NAME, 'WeChat'], VERSION], [
	
	            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
	            ], [NAME, VERSION], [
	
	            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
	            ], [NAME, VERSION], [
	
	            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI Browser']], [
	
	            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
	            ], [VERSION, [NAME, 'Facebook']], [
	
	            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
	            ], [VERSION, [NAME, 'Chrome Headless']], [
	
	            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
	            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [
	
	            /((?:oculus|samsung)browser)\/([\w\.]+)/i
	            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser
	
	            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
	            ], [VERSION, [NAME, 'Android Browser']], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
	                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [
	
	            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
	            ], [[NAME, 'Dolphin'], VERSION], [
	
	            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
	            ], [[NAME, 'Chrome'], VERSION], [
	
	            /(coast)\/([\w\.]+)/i                                               // Opera Coast
	            ], [[NAME, 'Opera Coast'], VERSION], [
	
	            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, 'Firefox']], [
	
	            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	
	            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	
	            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
	            ], [[NAME, 'GSA'], VERSION], [
	
	            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
	            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [
	
	            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
	            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
	            /(links)\s\(([\w\.]+)/i,                                            // Links
	            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
	            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
	            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
	            ], [NAME, VERSION]
	
	            /* /////////////////////
	            // Media players BEGIN
	            ////////////////////////
	
	            , [
	
	            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
	            /(coremedia) v((\d+)[\w\._]+)/i
	            ], [NAME, VERSION], [
	
	            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
	            ], [NAME, VERSION], [
	
	            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
	            ], [NAME, VERSION], [
	
	            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
	                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
	                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
	            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
	            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
	            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
	            ], [NAME, VERSION], [
	            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
	            ], [NAME, VERSION], [
	
	            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
	            ], [[NAME, 'Flip Player'], VERSION], [
	
	            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
	                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
	            ], [NAME], [
	
	            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
	                                                                                // Gstreamer
	            ], [NAME, VERSION], [
	
	            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
	            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
	                                                                                // Java/urllib/requests/wget/cURL
	            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
	            ], [NAME, VERSION], [
	
	            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
	            ], [[NAME, /_/g, ' '], VERSION], [
	
	            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
	                                                                                // MPlayer SVN
	            ], [NAME, VERSION], [
	
	            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
	            ], [NAME, VERSION], [
	
	            /(mplayer)/i,                                                       // MPlayer (no other info)
	            /(yourmuze)/i,                                                      // YourMuze
	            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
	            ], [NAME], [
	
	            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
	            ], [NAME, VERSION], [
	
	            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
	            ], [NAME, VERSION], [
	
	            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
	            ], [NAME, VERSION], [
	
	            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
	            /(winamp)\s((\d+)[\w\.-]+)/i,
	            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
	            ], [NAME, VERSION], [
	
	            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
	                                                                                // inlight radio
	            ], [NAME], [
	
	            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
	                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
	                                                                                // SoundTap/Totem/Stagefright/Streamium
	            ], [NAME, VERSION], [
	
	            /(smp)((\d+)[\d\.]+)/i                                              // SMP
	            ], [NAME, VERSION], [
	
	            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
	            /(vlc)\/((\d+)[\w\.-]+)/i,
	            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
	            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
	            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
	            ], [NAME, VERSION], [
	
	            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
	            /(windows-media-player)\/((\d+)[\w\.-]+)/i
	            ], [[NAME, /-/g, ' '], VERSION], [
	
	            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
	                                                                                // Windows Media Server
	            ], [VERSION, [NAME, 'Windows']], [
	
	            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
	            ], [NAME, VERSION], [
	
	            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
	            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
	            ], [[NAME, 'rad.io'], VERSION]
	
	            //////////////////////
	            // Media players END
	            ////////////////////*/
	
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, util.lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows\s(ce|mobile);\sppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
	            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, util.lowerize]]
	        ],
	
	        device : [[
	
	            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	
	            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [
	
	            /(apple\s{0,1}tv)/i                                                 // Apple TV
	            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [
	
	            /(archos)\s(gamepad2?)/i,                                           // Archos
	            /(hp).+(touchpad)/i,                                                // HP TouchPad
	            /(hp).+(tablet)/i,                                                  // HP Tablet
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
	            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
	            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
	
	            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
	            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
	            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
	            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [
	
	            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
	                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
	            /(asus)-?(\w+)/i                                                    // Asus
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
	            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
	                                                                                // Asus Tablets
	            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
	            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [
	
	            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
	            /(sony)?(?:sgp.+)\sbuild\//i
	            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
	            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /\s(ouya)\s/i,                                                      // Ouya
	            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	
	            /android.+;\s(shield)\sbuild/i                                      // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	
	            /(playstation\s[34portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [
	
	            /(sprint\s(\w+))/i                                                  // Sprint Phones
	            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [
	
	            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
	            /(zte)-(\w+)*/i,                                                    // ZTE
	            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
	                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            /(nexus\s9)/i                                                       // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	
	            /d\/huawei([\w\s-]+)[;\)]/i,
	            /(nexus\s6p)/i                                                      // Huawei
	            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [
	
	            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
	            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [
	
	                                                                                // Motorola
	            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
	            /mot[\s-]?(\w+)*/i,
	            /(XT\d{3,4}) build\//i,
	            /(nexus\s6)/i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
	            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
	            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [
	
	            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
	            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [
	
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [
	
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	
	            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
	            /((SM-T\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
	            /smart-tv.+(samsung)/i
	            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
	            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
	            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
	            /sec-((sgh\w+))/i
	            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [
	
	            /sie-(\w+)*/i                                                       // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	
	            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
	            /(nokia)[\s_-]?([\w-]+)*/i
	            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [
	
	            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
	            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
	            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
	            /(lg) netcast\.tv/i                                                 // LG SmartTV
	            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
	            /(nexus\s[45])/i,                                                   // LG
	            /lg[e;\s\/-]+(\w+)*/i,
	            /android.+lg(\-?[\d\w]+)\s+build/i
	            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [
	
	            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            /linux;.+((jolla));/i                                               // Jolla
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	
	            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [
	
	            /android.+;\s(glass)\s\d/i                                          // Google Glass
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [
	
	            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [
	
	            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
	            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [
	
	            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
	            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
	            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
	            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
	            /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
	            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [
	
	            /android.+a000(1)\s+build/i                                         // OnePlus
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
	            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
	            ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	
	            /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
	            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones
	
	            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	
	            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	
	            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
	            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
	
	            /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
	            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
	            ], [[TYPE, util.lowerize], VENDOR, MODEL], [
	
	            /(android.+)[;\/].+build/i                                          // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']]
	
	
	        /*//////////////////////////
	            // TODO: move to string map
	            ////////////////////////////
	
	            /(C6603)/i                                                          // Sony Xperia Z C6603
	            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	            /(C6903)/i                                                          // Sony Xperia Z 1
	            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
	
	            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
	            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
	            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
	            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
	            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
	            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
	            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
	            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
	            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
	
	            /(T3C)/i                                                            // Advan Vandroid T3C
	            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
	            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
	            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
	            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [
	
	            /(V972M)/i                                                          // ZTE V972M
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	
	            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
	            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
	            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
	
	            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
	            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [
	
	            /////////////
	            // END TODO
	            ///////////*/
	
	        ],
	
	        engine : [[
	
	            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, 'EdgeHTML']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
	            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
	            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows based
	            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
	            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
	            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
	            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
	            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [
	
	            // Mobile/Embedded OS
	            /\((bb)(10);/i                                                      // BlackBerry 10
	            ], [[NAME, 'BlackBerry'], VERSION], [
	            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
	            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
	            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
	                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
	            /linux;.+(sailfish);/i                                              // Sailfish OS
	            ], [NAME, VERSION], [
	            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
	            ], [[NAME, 'Symbian'], VERSION], [
	            /\((series40);/i                                                    // Series 40
	            ], [NAME], [
	            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
	            ], [[NAME, 'Firefox OS'], VERSION], [
	
	            // Console
	            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation
	
	            // GNU/Linux based
	            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
	            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
	            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
	                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
	                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
	            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
	            /(gnu)\s?([\w\.]+)*/i                                               // GNU
	            ], [NAME, VERSION], [
	
	            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Solaris
	            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	
	            // BSD based
	            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
	            ], [NAME, VERSION],[
	
	            /(haiku)\s(\w+)/i                                                  // Haiku
	            ], [NAME, VERSION],[
	
	            /cfnetwork\/.+darwin/i,
	            /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	
	            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
	            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Other
	            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
	            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
	            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
	                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
	            /(unix)\s?([\w\.]+)*/i                                              // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	
	    /////////////////
	    // Constructor
	    ////////////////
	    /*
	    var Browser = function (name, version) {
	        this[NAME] = name;
	        this[VERSION] = version;
	    };
	    var CPU = function (arch) {
	        this[ARCHITECTURE] = arch;
	    };
	    var Device = function (vendor, model, type) {
	        this[VENDOR] = vendor;
	        this[MODEL] = model;
	        this[TYPE] = type;
	    };
	    var Engine = Browser;
	    var OS = Browser;
	    */
	    var UAParser = function (uastring, extensions) {
	
	        if (typeof uastring === 'object') {
	            extensions = uastring;
	            uastring = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(uastring, extensions).getResult();
	        }
	
	        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
	        //var browser = new Browser();
	        //var cpu = new CPU();
	        //var device = new Device();
	        //var engine = new Engine();
	        //var os = new OS();
	
	        this.getBrowser = function () {
	            var browser = { name: undefined, version: undefined };
	            mapper.rgx.call(browser, ua, rgxmap.browser);
	            browser.major = util.major(browser.version); // deprecated
	            return browser;
	        };
	        this.getCPU = function () {
	            var cpu = { architecture: undefined };
	            mapper.rgx.call(cpu, ua, rgxmap.cpu);
	            return cpu;
	        };
	        this.getDevice = function () {
	            var device = { vendor: undefined, model: undefined, type: undefined };
	            mapper.rgx.call(device, ua, rgxmap.device);
	            return device;
	        };
	        this.getEngine = function () {
	            var engine = { name: undefined, version: undefined };
	            mapper.rgx.call(engine, ua, rgxmap.engine);
	            return engine;
	        };
	        this.getOS = function () {
	            var os = { name: undefined, version: undefined };
	            mapper.rgx.call(os, ua, rgxmap.os);
	            return os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return ua;
	        };
	        this.setUA = function (uastring) {
	            ua = uastring;
	            //browser = new Browser();
	            //cpu = new CPU();
	            //device = new Device();
	            //engine = new Engine();
	            //os = new OS();
	            return this;
	        };
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER = {
	        NAME    : NAME,
	        MAJOR   : MAJOR, // deprecated
	        VERSION : VERSION
	    };
	    UAParser.CPU = {
	        ARCHITECTURE : ARCHITECTURE
	    };
	    UAParser.DEVICE = {
	        MODEL   : MODEL,
	        VENDOR  : VENDOR,
	        TYPE    : TYPE,
	        CONSOLE : CONSOLE,
	        MOBILE  : MOBILE,
	        SMARTTV : SMARTTV,
	        TABLET  : TABLET,
	        WEARABLE: WEARABLE,
	        EMBEDDED: EMBEDDED
	    };
	    UAParser.ENGINE = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    UAParser.OS = {
	        NAME    : NAME,
	        VERSION : VERSION
	    };
	    //UAParser.Utils = util;
	
	    ///////////
	    // Export
	    //////////
	
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        // TODO: test!!!!!!!!
	        /*
	        if (require && require.main === module && process) {
	            // cli
	            var jsonize = function (arr) {
	                var res = [];
	                for (var i in arr) {
	                    res.push(new UAParser(arr[i]).getResult());
	                }
	                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
	            };
	            if (process.stdin.isTTY) {
	                // via args
	                jsonize(process.argv.slice(2));
	            } else {
	                // via pipe
	                var str = '';
	                process.stdin.on('readable', function() {
	                    var read = process.stdin.read();
	                    if (read !== null) {
	                        str += read;
	                    }
	                });
	                process.stdin.on('end', function () {
	                    jsonize(str.replace(/\n$/, '').split('\n'));
	                });
	            }
	        }
	        */
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(1417)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (window) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = window && (window.jQuery || window.Zepto);
	    if (typeof $ !== UNDEF_TYPE) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (uastring) {
	            parser.setUA(uastring);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 3295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createUncontrollable;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utils = __webpack_require__(3296);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function createUncontrollable(mixin, set) {
	
	  return uncontrollable;
	
	  function uncontrollable(Component, controlledValues) {
	    var _class, _temp;
	
	    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var displayName = Component.displayName || Component.name || 'Component',
	        basePropTypes = utils.getType(Component).propTypes,
	        isCompositeComponent = utils.isReactComponent(Component),
	        controlledProps = Object.keys(controlledValues),
	        propTypes;
	
	    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));
	
	    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);
	
	    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));
	
	    methods = utils.transform(methods, function (obj, method) {
	      obj[method] = function () {
	        var _refs$inner;
	
	        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
	      };
	    }, {});
	
	    var component = (_temp = _class = function (_React$Component) {
	      _inherits(component, _React$Component);
	
	      function component() {
	        _classCallCheck(this, component);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	      }
	
	      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
	      };
	
	      component.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        var props = this.props;
	
	        this._values = {};
	
	        controlledProps.forEach(function (key) {
	          _this2._values[key] = props[utils.defaultKey(key)];
	        });
	      };
	
	      /**
	       * If a prop switches from controlled to Uncontrolled
	       * reset its value to the defaultValue
	       */
	
	
	      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var props = this.props;
	
	        if (mixin.componentWillReceiveProps) {
	          mixin.componentWillReceiveProps.call(this, nextProps);
	        }
	
	        controlledProps.forEach(function (key) {
	          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
	            _this3._values[key] = nextProps[utils.defaultKey(key)];
	          }
	        });
	      };
	
	      component.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unmounted = true;
	      };
	
	      component.prototype.getControlledInstance = function getControlledInstance() {
	        return this.refs.inner;
	      };
	
	      component.prototype.render = function render() {
	        var _this4 = this;
	
	        var newProps = {},
	            props = omitProps(this.props);
	
	        utils.each(controlledValues, function (handle, propName) {
	          var linkPropName = utils.getLinkName(propName),
	              prop = _this4.props[propName];
	
	          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
	            prop = _this4.props[linkPropName].value;
	          }
	
	          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];
	
	          newProps[handle] = setAndNotify.bind(_this4, propName);
	        });
	
	        newProps = _extends({}, props, newProps, {
	          ref: isCompositeComponent ? 'inner' : null
	        });
	
	        return _react2.default.createElement(Component, newProps);
	      };
	
	      return component;
	    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);
	
	    _extends(component.prototype, methods);
	
	    component.ControlledComponent = Component;
	
	    /**
	     * useful when wrapping a Component and you want to control
	     * everything
	     */
	    component.deferControlTo = function (newComponent) {
	      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var nextMethods = arguments[2];
	
	      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
	    };
	
	    return component;
	
	    function setAndNotify(propName, value) {
	      var linkName = utils.getLinkName(propName),
	          handler = this.props[controlledValues[propName]];
	
	      if (linkName && isProp(this.props, linkName) && !handler) {
	        handler = this.props[linkName].requestChange;
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      set(this, propName, handler, value, args);
	    }
	
	    function isProp(props, prop) {
	      return props[prop] !== undefined;
	    }
	
	    function omitProps(props) {
	      var result = {};
	
	      utils.each(props, function (value, key) {
	        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
	      });
	
	      return result;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 3296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.version = undefined;
	exports.uncontrolledPropTypes = uncontrolledPropTypes;
	exports.getType = getType;
	exports.getValue = getValue;
	exports.getLinkName = getLinkName;
	exports.defaultKey = defaultKey;
	exports.chain = chain;
	exports.transform = transform;
	exports.each = each;
	exports.has = has;
	exports.isReactComponent = isReactComponent;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(29);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function readOnlyPropType(handler, name) {
	  return function (props, propName) {
	    if (props[propName] !== undefined) {
	      if (!props[handler]) {
	        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
	      }
	    }
	  };
	}
	
	function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
	  var propTypes = {};
	
	  if (false) {
	    transform(controlledValues, function (obj, handler, prop) {
	      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);
	
	      obj[prop] = readOnlyPropType(handler, displayName);
	    }, propTypes);
	  }
	
	  return propTypes;
	}
	
	var version = exports.version = _react2.default.version.split('.').map(parseFloat);
	
	function getType(component) {
	  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;
	
	  return component.type;
	}
	
	function getValue(props, name) {
	  var linkPropName = getLinkName(name);
	
	  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;
	
	  return props[name];
	}
	
	function isProp(props, prop) {
	  return props[prop] !== undefined;
	}
	
	function getLinkName(name) {
	  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
	}
	
	function defaultKey(key) {
	  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
	}
	
	function chain(thisArg, a, b) {
	  return function chainedFunction() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    a && a.call.apply(a, [thisArg].concat(args));
	    b && b.call.apply(b, [thisArg].concat(args));
	  };
	}
	
	function transform(obj, cb, seed) {
	  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
	  return seed;
	}
	
	function each(obj, cb, thisArg) {
	  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);
	
	  for (var key in obj) {
	    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
	  }
	}
	
	function has(o, k) {
	  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
	}
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	function isReactComponent(component) {
	  return !!(component && component.prototype && component.prototype.isReactComponent);
	}

/***/ },
/* 3297 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3298 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3299 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAcCAYAAAATFf3WAAAAAXNSR0IArs4c6QAAAOxJREFUWAntmDEOwjAMRZsKsbKCOAeHYGArWyVOwgADgntwN8QB2CjhuWpQ1IkmhHqIJTdO28RPP06ltCgSm7V2g986rxKnGz59B0bTWsO1Hj5LwhEAiXq+6YKErMIFyjd1kDV0GTK6UlExKxmtokyQlfyJjF8qaVwyZF8Sz13/j+2aXAe89HK+iHfGmGsLCNyeG0fvBQ2hBeJigJsQPPCpBqoeQ1Mi45Ob994DNV23xCuITvhiJLIZeWUPfPYEsSzxGR/XVH8TM1xocWTlsnKhCoSO015zWwD1nkeAU3/s9AF1HTelZlEw6tfHG6OGTbJgCjTBAAAAAElFTkSuQmCC"

/***/ },
/* 3300 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3301 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAsCAYAAAFknRrQAAAAAXNSR0IArs4c6QAABkxJREFUWAntWF1sFUUUnjO7vS0IWlEDiobdu1dKU8BqApFoYoUoGH8QfdIHE42P/r6YKDEQfNME8EEjJiao4UUejBg1EsUHY0BNFQmaVvZyb2OI5aGoRYTS3R3Pmduznf257RZaAsab3Jwz3/nmzN+ZMzMrRLOf5zi/m7aK6z7gLXKUNEHSERgck0lTJMSCXAPTbEvKneSTARVpdbzdjo6O69gYNxycGTnGIJBSWeR+zIA/ULvfpoIS6j4GScbVTRDM1tnQ8OmUn2OApFLRNgD5vMaUWioADvv1o9tFep7MSqaembvF5fIKIpiy2+lujyuds+fYw2SKOb3MXbZs2ZWsg+d460CoJYnRj1ljDNSQqDjOm4TnzSdjHZ53W7wK1YG6nmduiqSJxURa3CXl8mKU7/FCs6RKerFJkRZsKc2ZcywcPr0VZNjCGEn6xcQwjL47PTx8ayTgIxGq+WgDwkgmiEZ/dCCT0cDGPeq1BdHwqNR8IhHG5LhpBtBRrsfceKRmC/14ok1yM4y2s8kjHbxyebsIo2fThnMt43QO6Q3C4cGOsFcB6yzzsMoi51hnZ+e1zKEQohHFE8oGkji5GTwP8wfqC816rGcqk4HnT+LyHqnXv/UcdxCTAQVNHAvMAQnr/VptD9n4l+vUlnATEeYtWHAEnQqp7DulDHTIxhXHOKFl1Rljmes0VOI1IpwYHHwGRb+CYBNivJnXko05IhCbsHiAMP7lOlVK3U0EzOU6MWF+7uHhc0Xm4KZ7gzGWuU6NXaB51Xot3g1cMc1hnGScG0zwfPVG1q9UrmlV6oppcDZyuFr9LeOnp6enbfPmzYkR4PzBqlWrZqXJXV1d89JYbhnT4cmK475rGnHHvYPYmRS2lmPVxEm3qVe7du58Sgk51jvVgqvdWUkchKoLe2ubGHKWUHyYmN1Wer+vr2/o/NJZuotYbr/6qlK8Jdl+PsOn6cBT0M3EqQJFd4pPuREtAT7DkV6ewGz7BxGExxMYF5pNNtunIrmnidCZioOJuJnhY+h8gFcoHZN0paLKfOpaUmzsr9UOYflthHVyZo7ZSMYpOrwHr2VzTFJ8TZPWtgauVmNIeSbH1LNOW6w7rCiyTJJlyZW6bNt9JPGiuQEzWJvJMfWsUyFGQKmEUyyPUKXW1lb0RTdCdRaThs4bVE7/sk5HwwPB+PB1xSBSP+mKp06tQbkvjNQnxvAzzrNOQXwJAhLJAwD2klMVRUNagvgaOVXSc38zEaeZntI25dXn7M4N27a1pr9a3Yfnvc/DZ47Z4wsT/BjMc81WSU/3Bi8RlTTHLM9IT2fE6bQn6Rtcp0UHbqVS8fA0zQSxOU9F9Lb29oHe3t7RIlw8h9yDFFY3uu7LE1XA8+pF4mHI/TwRr8N1O5AX4j/q9LylE3HZVmydVCPLKSUmjCQ8XBt2gKZZkRoOlXJQUNswGkVllJP+oLu7u/3vP//6HJNZI2NOWuXCETCNDUsJD/969OgX4Lluv4jUYgBxUCj7CdEizqa7okYDesTNxop7MOe/lLZzWQXBK3gWbUDeKPJuZjwtIQhuxy8Sb2lcwtNgWV+lOSqIHsNE+wLhVmvpehvPBb4g7PcH/B/TFaiMMYqrhclQqBNV328af5gyT2iWUOGEPNddiO3qpnC3Dfg5PvHptCcIhO4oDrxUKEb9eu1yaLHbqvX643kDYQwz5pNjvMRJxHaW+Drae8vKFTalCNTjrzZsz5OZgySPRBiOWh/QzeyMF+Xt3r075DpFZKEZLeJopjmFZtQ8rrlD/AjmsvkYZoyPci6bRzpjeQ9ltpnyvzWjedcKc7Sk5z2F05zJrh5pvln+f+nN2ZgOvdCMXjpL3/iMkHgpKUturFarPs8W7vodeMqMf6gmg21tMU8d5LyOnMRnHfTzKvrpZT/NZKEZxbPzIX5NsCMZhltRjzuK+no8ZvW3OubYSu1APT5y8VV3L784mANRtAv16emoZct1Uep9KkulX7gxkiCsB/HrWcnEZoVzD5llaclHcDCJ47U0e/Zhk9NMLzSj+P76ppkDxv26n/hmyLgp8br2vVmein7pJHx8T/+B8UcB3oNXq9W4NJn76FRGPl3cMAwfNXyNwPLlyy/7Z/jkh9jBuwzDxaECHAdlbcB78v6Lo0MFevEvMyV7iZbclHYAAAAASUVORK5CYII="

/***/ },
/* 3302 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAkCAYAAAGS8ngzAAAAAXNSR0IArs4c6QAAA79JREFUWAntWE1oE0EUzqRNI+ihIiQnEfypClEQL4KnQG9qUVsj9tCT2kNSxYOgVNFDK4IV1LQNQU8FLab+UBp7Enrx6EmDXhpQPCVg6UGxNTXxe+u+MNnMZHebpFpwYPNm3ryfb+a9ebMbj8d1i8fjpdHR0SlSFPSDwTBRakKIJc/Y2Nj1P0PFL6Q7mO3lDuh57hvMubm5VjCizBSweaZUKoWYEYvFBj2JROIAM4gSNHlc7sPpSHlgdmTntIbHLABXN7ivpKlUqg2u0lWTsDJTxbQwlBjBnLfIeSrwmZM7nAhZZSotEXiWGB8f3859I5Q8kEEODAxUzLGMQWVBnqhKCp5g6vV6R/SxMqUQhSuqLWAjBkVG9FUwdAPCqUoCq7ytR6tCrXFDjWljwCFoQ/uJhiN4F6h2YW+60L+Ek3LPilJrjASTyaSPDLESjEzDyHEeN5UayHhJ9XgC6iE61j/wfKrHEOkSIE7rd9jYffUYRJz22uoDdQe8VlUFlaKTPKPyWlU9VmtMpafkOUGmVFQx15kxKq6qq4QKMKJbvm6sS1Uus1gsduG5CcVpVqBzmsvllpGPvcyzUu1Bh6EpKPbgmCyBbmDFUCjkC4fDKzyWqRIZCaA6nKIqIRuicqQzRDpaZDRJDdlPN+yRYDDoj0Qi5XJkTDbzx0CG6G3GcmLykpw6xVZkotHoJMnTi8sQIjfoVFknR9ewoDqE2/MqrN/WCdrxjVomRNqIZj2GyBGW+hmk0zCGnPpg5103T69y2OttMHhLILP34AL6qBN2woeh98jL/bZ55sSYHETs/zC27ZoTvVoy2tNUS8k6J6en3LfKuRk3BJgbh05l/wNzulMs98/uGH3cOW6oKw+R3GdJAcc6HQgEunU3At2u+Xz+OeSPmvKPUAbOOXXmqlzAWQucPYGzCDsAwJfofwHvggngAehWjE9IMiksoheL+MU8O+oKGBujz+hMJvMU45PM09AXuPlP17qwNXr2F7lOkfj0DlMoFChcx2Q57OKMz+fr7u/vL8h8N/1V7ZjVgZlPxlcmQjahyzur3rocl3cM910fXlruYxXtf2kli7hnL+KenSD/Aq9jhwDoDfKkxWAI8Qw58hrP97UACL8b8XTi6TH908k93ApQaQIFIN+QH+1ujnQDgSfNUrQILJuA5ZUXnRw5IMbCwsLuBjpzZYp8EwYTS07Mzs76s9nsWzBCbAmIv0JoTUIJXxTKLewbNINvjIPl5Kcjj++qyxCkvxx3QsAvCTezuwyf8/A5CUB3uNT8BmK5j85PfypCAAAAAElFTkSuQmCC"

/***/ },
/* 3303 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAkCAYAAADl9UilAAAAAXNSR0IArs4c6QAAA1tJREFUWAntV11IFFEUvmd28wcfKjYJ1LXoRyJSiIicXMl0iUwL+rG/B+nJ116TCoQCgyConhJ68SVtVQgxMiwNhiToKQtKKqLVIFLs37+ZOZ0zeYfdXNcZd1tfdmC955577vk+v5l75gyIJFxVgUCRqZv3OZXiVQ480rThRNMqiSbg/aib9Yi40fqRnYycSSFGRLIiyETaEW53ZrKIuUN1EJ0m5kCkqJC0YlFyOJikFXMgUlRIWrEoORxMvA5i7JBgILDB0I1LKGA415/fHAqFZuzFGEZdXV3Gl/BoIwgs8ng9F/s07X2MsJguV7dS181GRHFaIDYRYCcDx8xKzjlSnRzLe3jvQrGx/K6IKQCv7CSItWPh0VBDQ8MK2zdnsI/XiFStXIvaK51xRlfEfAV5NwHEXZmPuolDwy+G2lEImxzblo/WZBzv4b1y7mQEJ0GRMU0VFd6ByZk71Owcs/0AU6TO364i0rYCoKMiO+NU08CAbsc7MFwT45xM7snUdDs9O0fiYZBSXXuyMk+4JcU5Xd1KSYKBNpcUnwQB96Tv35HXOGYppDjXkhSTJPghp+eJTp44KH3WCKK7qKT4aEtLy2yU38UkIWKMw2Vh7ONoFwqs4Tkp1bOmMP/IYjWOY+NdCRPj5ExuPPzJ6vV9/rzWREnFI5xeW0iBqFtZEwisnjSM/WiKTQIgKV87CwHbfsQpUMTbbI/nQY+mTUi/TWyvGqhH07xOhXOVXEztCF9BUc72D2qtjOvhP5Wluy8jmtfITI1KDDr/yqK3x+H1/kLvh5FwPwTLykoNAzV671kk6cB3CAX6PCb+mr83+R5DgRxhYlC+4gDAoLpf5tUNPE9MLVL0Gmh8/OzpleTDL5rxVuUu9ZwpRLMlEJgXFEBUrW0AP32FBVcXTfGfAixs4sDpmZOCQFLyRIhxKowk4/JcjM0cGJ05sWJWu0sSrqsqL9+6PLSEYGzmwPjMibuLNknGmNU7gqq6Xc5TNTImY0fgtUF1dXXm5MS353QAtskFS1KAlJxKws2hrtcnsamwv6QPnR1Wgd2nqltmkFpmFMV2wHIYIIYyQBx/ODj42ioT70ZGxnaq6u3f339MU9uylmrJSuLl6tNuqf8HYTHmG1LqRq6/4Ex3b+9nzvUHKrU4lrQnzPwAAAAASUVORK5CYII="

/***/ },
/* 3304 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3305 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3306 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAAGWB6gOAAAAAXNSR0IArs4c6QAABAJJREFUWAm9mEtIFWEUx9WizJIiswJJBFMKe5ibEDdSVFALoSgp6AHRIgprUZtoVdAisqCNuWtT0aKXm1KQSAqKFrUIpIUimj3oYQ9KLPX2O9+db+6Z15179daB/3zn/M//nG8cZ7757uTlOZZIJJZbPzCSLM/j0K8zxAkdG99DEjR7CI9cZ7SfEsFeSUXKI9EG1ruU1GOfQJkl8QdBk5z4DHDaJvwjuYSIXvkTOjYiIcTBinXS4X/CL/bzUlAdIJ2KRmmFHQazHE7idlOAMxeM+qvhnoPk1Xcdv4qY3Hawwpx0SN6lpEmBG0U7E0aEuDJMA38QvlSmqwLB24NsKA+5GmwAk6ECPR2CuyLyWYnWRPoUNanCwkghCaUTN6Ul+CVMumKdQ3oGFEqNmMkxnnMDrc7Ql1rsnpzmiHgZ1gVkUism/9vWQDZ7osOU0PC9acshmx5OzbhtUmKbOOOudM3QLFD6nem0doJaVaDdi7HFfgHV8ryuApndjLoBRXVgHGh7qTWxPpXvVPVNfHmuFupC4n1AnrNucAJ4zxZiAohd0IV+n/wio0oeOj15uAEnWe9JRASq0TdXAlnuJNpcMsZB3wWOOXVbjJzAXJeY2tC002jSNpL4UagyhqTushTrRrtjakLT9KiWRth8u2q/CVXGk8OOZKlttDK+JlRR47B9dtnsDZXFkPxJ1+TvMjLGXhsw7o+p9aSlDvtjGxUnY3N87FGmCVCbJZoxdVkI3Ic0Ta2bQt8AxIY0+TrJJY9uIsJBdd3RJ2/ECJ2HpkA2FpvAEfAEWOvzCNMFVHy2VWr8ir8sXV1GOZosAS3gDnBfGPjaHhKY7VFGTbMR0VheMOaeY4yzfgTexdKZDL4C1IDUNiHLE9lD8RjQ9pbgOJiTTS/RUlOvG/n8TuLwEyWxFvxQBbLXmdJC5T9p+sh94zfZNIYbyrNKLe+s5nDl1Fj63XD69zDKBt5ad6AjmUs2y/gFhN4LgcIsCHquAeZfw1gAngJr991WMPJcW5MX9vQfR7d7tMM88mNqyE7MeNKocToUeT66Re4zzCsPj7WP9oRGLMO4MffTRndkvlI1t7hl9gUbXfVvMxO+9rPlhLoUuU35/8PdqiYZyM/P75dFS/bA2lLvXaXOtcuE8tvsu5r4gDsH5CmV+I2/GcgTcNUV5dChbxEYBtZuB9qTOWSzavwQEE6ToPcOIAuvtfZASzKVYNAqfOO6QMEUCHoeBXL1rclqXedvNdMh5FNVA5CPWlVqFL8RvABZGZPJZ5wWIBvReap4FH8vN/AtxU3PZTL5WRq28YIONbkyraAobmZ7heJ0bp6mtQSyPDwDFUA+ss0GY2AEyF5fPp89AD1cieS2myAT+wusFGmxgpk3HgAAAABJRU5ErkJggg=="

/***/ },
/* 3307 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/Kochava.c9cdd3ec.png";

/***/ },
/* 3308 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/adjust.6baed00b.jpg";

/***/ },
/* 3309 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/apps_flyer.7a6e36bd.png";

/***/ },
/* 3310 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/iPhone-X-Mockup-inside.f2b38757.png";

/***/ },
/* 3311 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/iPhone-X-Mockup.5e37c37a.png";

/***/ },
/* 3312 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/tune.39e50189.png";

/***/ },
/* 3313 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAAEEfUpiAAAAAXNSR0IArs4c6QAABUBJREFUWAnNll9InlUcx/X1fVVC6apMwSTTLtQbt7V1tSXtopJsRHgrRtP811XMMSIR2mjrLjV1JlQUkVfDiAoKc9TYVsubKZHGssJNiaSLXIq+9vk+O79nz/O8z/uuoIseOJzz+/2+v7/nd85z8vKyfcPDw39KljDA7u5usa3vMA8NDe2i3yMY6x9C8JmZmWQC7o5xFxYWDtta8F2fYBEEBvmhNb5e8eMMSRxB7EeSJlBE+fn579XX15+6evXq5UQicaKnp2ePyXPP+OpnHDAU61lb542Pj6eMUCbQ5aIBtXn8mPT8dAENKsi0h7yl9Vhvb2++0WTRqTT9VBF+YULNyWTyCY8OBmgAeDe19s0pluLi4srNzc1KTF/o6+vzZD7ANLVj8/PzS4CqHE8xemFQPGrX86ZhQzMuVavVEDOGULjRyqhmP0lgeAAVBhobG6u1tck1G8/ba4VLTpcMwHqFtZfe9vZ2Oz3wi8lsVj1wOueX2ATBWV4KCgrOUv77g3ytt7a2xFvxi4O12ShIdDqd9k9AUA7/aww3B3leXhi61UMhyW0C+U3GhHEyttEEgAZZt1CfcmpwhVRe7urqmjP5fzZnRDAyMtJNfiPOg99ERLHMaaxpamraDnoPGaDqOwC/ojiHgiCtSekA6VxEfhz56ajcCug3UwbAMTC0yug3uRcBnnVhnMTyOxJMTU0VrK2tXcNjJeS7NFZoZ9QfDQ0NKaVjjVRryjKwurq6jfKAThzfs6qL+PbBe0QHTnTSbdeACTVL0WgMvY3CA0ZrxtkloqjSWmehpaio6CkRWb7uuro6/+KKYhJ4KK+pqbkRFYjGy19MT0e3TjKi2tWcYHGFW36/iODH9Xg3dBHpTAf5tsaxl2ZSLcqRnUQQuqY7Ozv/gOfXwhSjc8L1d2NUQAQParuifNEUflbXmy9jmx6H6d2iPjPLApyutMwjjmDiTkaQt0WjCuWoSDhIn+B8juL2cHi+WVpauo+r/DmKNgh/kaI+FAwuZMAEo6OjjTs7O6+itBdD1+FP0zyhZjNsrAETRmdn+Aj8feof5gqHWXGOvmVXz/2biydnAK4kb+Ck1jlSac4xPi8sLPzZGlhl0iVNUIcZCtC6YpHdfpGf2adOP2OKDUAbiqHncaST8ELwoGdYyMHQpiMew1Yxtt7CztEoPBSAy/hjwFsAH9WhjyoY7U7aXR0dHTfAx/a7YQlE9+SXBFJIRZqDFfEDwLl3lWPsPI4PmXJwBvM6XfqS410D+xtGH3b09yUlJY3t7e2qWuxHILPgDwbfGF4Aai6ug+/QmqPNQ1eCWQKzn84ewcDvZWVlT7a2tvqHEcMfwm8FO4F+h+nEzZxD+WnkbbVHzeo9LXRkBCaj29dDRBvwZViWrS/FcYLK7BODE/C+L8iykA90Ljifzd4fBcZe8Gkd/Cx6sWwcP8PQ36dMGXV3d8/GAgNM5yPtfHo/FGV+XUZ0nMD+GsBnXVL2H+mHanRPU/bjWYERgfOhxPWA89+/3j9DV14EH0tOTk6W4vgDmulkdXV17A0XqwjTfKD/kTDeFtD1AzCWqcKgOzLZ9D1+aWmpHjfnNXgA+CcppxJC2ZYP+ZJP4b0AtEilUrrtFgFcBNgmXrZvfX29gvJ/prGxsXFPNlyQL5uyDW+RPqgxWUb0APsBvkaUa4Bacl1GZiTXrKyRT2PzXmxmvOoyAjBjLpBT0Hp3qNzH/mkwzukZnB5EL43+CXQzn5MIswaAzPu4clNcUkcxdoxRZXw36/Grz99KEThcZpzhOXY27kUlzP/m+xsCqJzKxbPuWAAAAABJRU5ErkJggg=="

/***/ },
/* 3314 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/trophy.aed94704.png";

/***/ },
/* 3315 */
/***/ function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ },
/* 3316 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 3317 */
98,
/* 3318 */
/***/ function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ },
/* 3319 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 3320 */
/***/ function(module, exports) {

	var weasels = [
	  'are a number',
	  'clearly',
	  'completely',
	  'exceedingly',
	  'excellent',
	  'extremely',
	  'fairly',
	  'few',
	  'huge',
	  'interestingly',
	  'is a number',
	  'largely',
	  'many',
	  'mostly',
	  'obviously',
	  'quite',
	  'relatively',
	  'remarkably',
	  'several',
	  'significantly',
	  'substantially',
	  'surprisingly',
	  'tiny',
	  'various',
	  'vast',
	  'very'
	];
	
	// Allow "too many" and "too few"
	var exceptions = [
	  'many',
	  'few'
	]
	
	var re = new RegExp('\\b(' + weasels.join('|') + ')\\b', 'gi');
	
	module.exports = function (text, opts) {
	  var suggestions = [];
	  while (match = re.exec(text)) {
	    var weasel = match[0].toLowerCase();
	    if (exceptions.indexOf(weasel) === -1 ||
	        text.substr(match.index-4, 4) !== 'too ') {
	      suggestions.push({
	        index: match.index,
	        offset: weasel.length,
	      });
	    }
	  }
	  return suggestions;
	};


/***/ },
/* 3321 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 3322 */
/***/ function(module, exports) {

	
	// annotate file contents with suggestions
	module.exports = function (contents, suggestions, parse) {
	
	  var lines = contents.split('\n');
	
	  return suggestions.map(function (suggestion) {
	    var lineColumn = findLineColumn(suggestion.index);
	
	    var fix = 0;
	
	    if (lineColumn.col > 25) {
	      fix = lineColumn.col - 25;
	    }
	
	    if(parse){
	      return {
	        reason: suggestion.reason,
	        line: lineColumn.line,
	        col: lineColumn.col,
	      }
	    }
	    var lineSegment = lines[lineColumn.line - 1].substr(fix, 80);
	
	    return [
	      lineSegment,
	      repeatChar(' ', lineColumn.col - fix) + repeatChar('^', suggestion.offset),
	      suggestion.reason + ' on line ' + lineColumn.line + ' at column ' + lineColumn.col
	    ].join('\n');
	  })
	
	  function findLineColumn (index) {
	    var line = contents.substr(0, index).split('\n').length;
	
	
	    var startOfLineIndex = (function () {
	      var x = lines.slice(0);
	      x.splice(line - 1);
	      return x.join('\n').length + (x.length > 0);
	    }());
	
	    var col = index - startOfLineIndex;
	
	    return {
	      line: line,
	      col: col
	    };
	  }
	}
	
	function repeatChar (ch, times) {
	  var str = '';
	  for (var i = times; i > 0; i--) {
	    str += ch;
	  }
	  return str;
	}


/***/ },
/* 3323 */
/***/ function(module, exports) {

	
	// via http://matt.might.net/articles/shell-scripts-for-passive-voice-weasel-words-duplicates/
	
	// Example:
	// Many readers are not aware that the
	// the brain will automatically ignore
	// a second instance of the word "the"
	// when it starts a new line.
	var re = new RegExp('(\\s*)([^\\s]+)', 'gi');
	var word = /\w+/;
	
	module.exports = function (text) {
	  var suggestions = [];
	  var lastMatch = '';
	  while (match = re.exec(text)) {
	    if (word.test(match[2]) && match[2].toLowerCase() === lastMatch) {
	      suggestions.push({
	        index: match.index + match[1].length,
	        offset: match[2].length
	      });
	    }
	    lastMatch = match[2].toLowerCase();
	  }
	  return suggestions;
	}


/***/ },
/* 3324 */
/***/ function(module, exports) {

	
	// Opinion: I think it's gross to start written English independent clauses with "so"
	//          most of the time. Maybe it's okay in spoken English.
	//
	// More on "so:"
	// * http://www.nytimes.com/2010/05/22/us/22iht-currents.html?_r=0
	// * http://comminfo.rutgers.edu/images/comprofiler/plug_profilegallery/84/pg_2103855866.pdf
	
	// this implementation is really naive
	var re = new RegExp('([^\n\\.;!?]+)([\\.;!?]+)', 'gi');
	var startsWithSo = new RegExp('^(\\s)*so\\b[\\s\\S]', 'i');
	module.exports = function (text) {
	  var suggestions = [];
	  var match, innerMatch;
	
	  while (match = re.exec(text)) {
	    if (innerMatch = startsWithSo.exec(match[1])) {
	      suggestions.push({
	        index: match.index + (innerMatch[1] || '').length,
	        offset: 2
	      });
	    }
	  }
	  return suggestions;
	};


/***/ },
/* 3325 */
/***/ function(module, exports) {

	
	// Opinion: I think it's gross to start written English sentences with "there (is|are)"
	//          (most of the time)
	
	// this implementation is really naive
	var re = new RegExp('([^\n\\.;!?]+)([\\.;!?]+)', 'gi');
	var startsWithThereIs = new RegExp('^(\\s)*there\\b\\s(is|are)\\b', 'i');
	module.exports = function (text) {
	  var suggestions = [];
	  var match, innerMatch;
	
	  while (match = re.exec(text)) {
	    if (innerMatch = startsWithThereIs.exec(match[1])) {
	      suggestions.push({
	        index: match.index + (innerMatch[1] || '').length,
	        offset: innerMatch[0].length - (innerMatch[1] || '').length
	      });
	    }
	  }
	  return suggestions;
	};


/***/ },
/* 3326 */
/***/ function(module, exports, __webpack_require__) {

	var assign = Object.assign || __webpack_require__(57);
	
	var defaultChecks = {
	  weasel  : { fn: __webpack_require__(3320),            explanation: 'is a weasel word' },
	  illusion : { fn: __webpack_require__(3323), explanation: 'is repeated' },
	  so       : { fn: __webpack_require__(3324),    explanation: 'adds no meaning' },
	  thereIs  : { fn: __webpack_require__(3325),          explanation: 'is unnecessary verbiage' },
	  passive  : { fn: __webpack_require__(2476),           explanation: 'may be passive voice' },
	  adverb   : { fn: __webpack_require__(1423),            explanation: 'can weaken meaning'},
	  tooWordy : { fn: __webpack_require__(3291),               explanation: 'is wordy or unneeded'},
	  cliches  : { fn: __webpack_require__(2460),              explanation: 'is a cliche'},
	  eprime   : { fn: __webpack_require__(1977),                 explanation: 'is a form of \'to be\''}
	};
	
	// User must explicitly opt-in
	var disabledChecks = {
	  eprime: false
	};
	
	module.exports = function (text, opts) {
	  opts = opts ? opts : {};
	  var finalOpts = {};
	  opts = assign({}, disabledChecks, opts);
	  Object.keys(opts).map(function(optKey) {
	    if(optKey !== 'checks') {
	      finalOpts[optKey] = opts[optKey];
	    }
	  });
	
	  var finalChecks = opts.checks || defaultChecks;
	
	  var suggestions = [];
	  Object.keys(finalChecks).forEach(function (checkName) {
	    if (finalOpts[checkName] !== false) {
	      suggestions = suggestions.concat(finalChecks[checkName].fn(text).
	                          map(reasonable(finalChecks[checkName].explanation)));
	    }
	  });
	
	  return dedup(suggestions).sort(function (a, b) {
	    return a.index < b.index ? -1 : 1;
	  });
	
	  function reasonable (reason) {
	    return function (suggestion) {
	      suggestion.reason = '"' +
	          text.substr(suggestion.index, suggestion.offset) +
	          '" ' + reason;
	      return suggestion;
	    };
	  }
	};
	
	
	function dedup (suggestions) {
	  var dupsHash = {};
	
	  return suggestions.reduce(function(memo, suggestion) {
	    var key = suggestion.index + ":" + suggestion.offset;
	    if (!dupsHash[key]) {
	      dupsHash[key] = suggestion;
	      memo.push(suggestion);
	    } else {
	      dupsHash[key].reason += " and " + suggestion.reason.substring(suggestion.offset + 3);
	    }
	    return memo;
	  }, []);
	}
	
	module.exports.annotate = __webpack_require__(3322);


/***/ },
/* 3327 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* cpexcel.js (C) 2013-2014 SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.3.7"};
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d[i]] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	if (typeof module !== 'undefined' && module.exports) module.exports = cptable;
	/* cputils.js (C) 2013-2014 SheetJS -- http://sheetjs.com */
	/*jshint newcap: false */
	(function(root, factory){
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports) module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	}(this, function(cpt){
	  "use strict";
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpecache = {};
	  var cpdcache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x){ return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  if(has_buf) {
	    var mdl = 1024, mdb = new Buffer(mdl);
	    var make_EE = function make_EE(E){
	      var EE = new Buffer(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i, j, D, w;
	        if(typeof data === 'string') {
	          out = Buffer(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out.length = j;
	          out = out.slice(0,j);
	        } else {
	          out = Buffer(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(ofmt === undefined || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = new Buffer(131072), d=0, c;
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = new Buffer(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        mdb.length = 2 * len;
	        return mdb.toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = new Buffer(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = new Buffer(2*len), i, j, jj, k, D;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out.length = k;
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out.length = k;
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(ofmt === undefined || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = new Buffer(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = new Buffer(2*len), i, j, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        out.length = k;
	        return out.toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = new Buffer(mdl); }
	      mdb.length = 0;
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      mdb.length = k;
	      return mdb.toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = new Buffer(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      mdb.length = j;
	      if(ofmt === undefined || ofmt === 'buf') return mdb;
	      if(ofmt !== 'arr') return mdb.toString('binary');
	      return [].slice.call(mdb);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i, s;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var cp_decache = function cp_decache(cp) { cpdcache[cp] = cpecache[cp] = undefined; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = last_cp = undefined;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc, last_cp;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp) { return last_enc(data, ofmt); }
	    if(cpecache[cp] !== undefined) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? new Buffer(4*len) : [], w, i, j = 0, c, tt, ww;
	    var C = cpt[cp], E, M;
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[data[i]];
	      out[j] = w&255;
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && typeof data === "string") { out = new Buffer(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = data[++i].charCodeAt(0) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = new Buffer(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = new Buffer(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255; w >>= 8;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          c = data[i];
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out.length = j;
	    out = out.slice(0,j);
	    if(typeof Buffer === 'undefined') return (ofmt == 'str') ? out.map(sfcc).join("") : out;
	    if(ofmt === undefined || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    var len = data.length, out = new Array(len), w, i, j = 1, k = 0, ww;
	    var C = cpt[cp], D, M;
	    if(C && (D=C.dec)) {
	      if(typeof data === "string") data = data.split("").map(cca);
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        w = D[(data[i]<<8)+ data[i+1]];
	        if(!w) {
	          j = 1;
	          w = D[data[i]];
	        }
	        if(!w) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = w;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        i = 0;
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        i = 0;
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        i = 0;
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        i = 0;
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] == 0 && data[3] == 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        i = 0;
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] == 0 && data[0] == 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        i = 0;
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64;
	          var c1, c2, c3;
	          var e1, e2, e3, e4;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          if((tt.length & 1) === 1) tt.length--;
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64[l];
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out.length = k;
	    return out.join("");
	  };
	  var hascp = function hascp(cp) { return cpt[cp] || magic[cp]; };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 3328 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/* ods.js (C) 2014 SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint -W041 */
	var ODS = {};
	(function make_ods(ODS) {
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	var get_utils = function() {
		if(typeof XLSX !== 'undefined') return XLSX.utils;
		if(true) try {
			return __webpack_require__(268).utils;
		} catch(e) {
			try { return __webpack_require__(268).utils; }
			catch(ee) { return __webpack_require__(268).utils; }
		}
		throw new Error("Cannot find XLSX utils");
	};
	var has_buf = (typeof Buffer !== 'undefined');
	
	function cc2str(arr) {
		var o = "";
		for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
		return o;
	}
	function getdata(data) {
		if(!data) return null;
		if(data.data) return data.data;
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer().toString('binary');
		if(data.asBinary) return data.asBinary();
		if(data._data && data._data.getContent) return cc2str(Array.prototype.slice.call(data._data.getContent(),0));
		return null;
	}
	
	function safegetzipfile(zip, file) {
		var f = file; if(zip.files[f]) return zip.files[f];
		f = file.toLowerCase(); if(zip.files[f]) return zip.files[f];
		f = f.replace(/\//g,'\\'); if(zip.files[f]) return zip.files[f];
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	var _fs, jszip;
	if(typeof JSZip !== 'undefined') jszip = JSZip;
	if (true) {
		if (typeof module !== 'undefined' && module.exports) {
			if(has_buf && typeof jszip === 'undefined') jszip = __webpack_require__(965);
			if(typeof jszip === 'undefined') jszip = __webpack_require__(1419).JSZip;
			_fs = __webpack_require__(466);
		}
	}
	var attregexg=/\b[\w:-]+=["'][^"]*['"]/g;
	var tagregex=/<[^>]*>/g;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root) {
		var z = [];
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.substr(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, w="", v="", i=0, q="", cc="";
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.substr(0,c); v = cc.substring(c+2, cc.length-1);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) z[q] = v;
			else z[(j===5 && q.substr(0,5)==="xmlns"?"xmlns":"")+q.substr(j+1)] = v;
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = {
		'"': '&quot;',
		"'": '&apos;',
		'>': '&gt;',
		'<': '&lt;',
		'&': '&amp;'
	};
	var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var encregex = /&[a-z]*;/g, coderegex = /_x([\da-fA-F]+)_/g;
	function unescapexml(text){
		var s = text + '';
		return s.replace(encregex, function($$) { return encodings[$$]; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
	}
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).substr(-4) + "_";});
	}
	
	function parsexmlbool(value, tag) {
		switch(value) {
			case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	function datenum(v) {
		var epoch = Date.parse(v);
		return (epoch + 2209161600000) / (24 * 60 * 60 * 1000);
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].substr(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].substr(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	/* copied from js-xls (C) SheetJS Apache2 license */
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		throw "badf";
	}
	
	var xlmlregex = /<(\/?)([a-z0-9]*:|)([\w-]+)[^>]*>/mg;
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	var parse_manifest = function(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0]);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: throw Rn;
		}
	};
	var parse_text_p = function(text, tag) {
		return utf8read(text.replace(/<text:s\/>/g," ").replace(/<[^>]*>/g,""));
	};
	
	var utf8read = function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { out += String.fromCharCode(((c & 31) << 6) | (d & 63)); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	};
	var parse_content_xml = (function() {
	
		var number_formats = {
			/* ods name: [short ssf fmt, long ssf fmt] */
			day: ["d", "dd"],
			month: ["m", "mm"],
			year: ["y", "yy"],
			hours: ["h", "hh"],
			minutes: ["m", "mm"],
			seconds: ["s", "ss"],
			"am-pm": ["A/P", "AM/PM"],
			"day-of-week": ["ddd", "dddd"]
		};
	
		return function pcx(d, opts) {
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag, NF, pidx;
			var sheetag;
			var Sheets = {}, SheetNames = [], ws = {};
			var Rn, q;
			var ctag;
			var textp, textpidx, textptag;
			var R, C, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
	
			while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
	
				case 'table': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = get_utils().encode_range(range);
						if(merges.length) ws['!merges'] = merges;
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0]);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = {}; merges = [];
					}
					break;
	
				case 'table-row': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') break;
					++R; C = -1; break;
				case 'covered-table-cell': // 9.1.5 table:covered-table-cell
					++C; break; /* stub */
				case 'table-cell':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						ctag = parsexmltag(Rn[0]);
						if(ctag['number-columns-repeated']) C+= parseInt(ctag['number-columns-repeated'], 10);
						else ++C;
					}
					else if(Rn[1]!=='/') {
						++C;
						if(C > range.e.c) range.e.c = C;
						if(R > range.e.r) range.e.r = R;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						ctag = parsexmltag(Rn[0]);
						q = {t:ctag['value-type'], v:null};
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'n'; q.v = datenum(ctag['date-value']); q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400; break;
							case 'string': q.t = 's'; break;
							default: throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						if(q.t === 's') q.v = textp;
						if(textp) q.w = textp;
						if(!(opts.sheetRows && opts.sheetRows < R)) ws[get_utils().encode_cell({r:R,c:C})] = q;
						q = null;
					}
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document-content': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				/* ignore state */
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					break;
	
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0]);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
	
				case 'style': break; // 16.2 <style:style>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0]);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0]);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].substr(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
	
				case 'body': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
	
				case 'graphic-properties': break;
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'named-range': break; // 9.4.11 <table:named-range>
				case 'span': break; // <text:span>
				case 'p':
					if(Rn[1]==='/') textp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
					else { textptag = parsexmltag(Rn[0]); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
				case 'date': break; // <*:date>
				case 'annotation': break;
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': break; // <*:title>
				case 'desc': break; // <*:desc>
	
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'database-range': break; // 9.4.15 <table:database-range>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
				default: if(opts.WTF) throw Rn;
			}
			var out = {
				Sheets: Sheets,
				SheetNames: SheetNames
			};
			return out;
		};
	})();
	/* Part 3: Packages */
	var parse_ods = function(zip, opts) {
		//var manifest = parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'));
		return parse_content_xml(getzipdata(zip, 'content.xml'), opts);
	};
	ODS.parse_ods = parse_ods;
	})( true ? exports : ODS);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(28).Buffer))

/***/ },
/* 3329 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 3330 */
3329,
/* 3331 */
3329,
/* 3332 */
3329,
/* 3333 */
3329,
/* 3334 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h:mm',
	        LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	        l : 'YYYY.MM.DD',
	        ll : 'YYYY년 MMMM D일',
	        lll : 'YYYY년 MMMM D일 A h:mm',
	        llll : 'YYYY년 MMMM D일 dddd A h:mm'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '1분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '일';
	            case 'M':
	                return number + '월';
	            case 'w':
	            case 'W':
	                return number + '주';
	            default:
	                return number;
	        }
	    },
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 3335 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        ss : '%d segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 3336 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.getScroll = getScroll;
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isDev = ("production") !== 'production';
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function offset(elem) {
	  var box = void 0;
	  var x = void 0;
	  var y = void 0;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  box = elem.getBoundingClientRect();
	  x = box.left;
	  y = box.top;
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  var w = doc.defaultView || doc.parentWindow;
	  x += getScroll(w);
	  y += getScroll(w, true);
	  return {
	    left: x, top: y
	  };
	}
	
	function _componentDidUpdate(component, init) {
	  var styles = component.props.styles;
	
	  var wrapNode = component.nav || component.root;
	  var containerOffset = offset(wrapNode);
	  var inkBarNode = component.inkBar;
	  var activeTab = component.activeTab;
	  var inkBarNodeStyle = inkBarNode.style;
	  var tabBarPosition = component.props.tabBarPosition;
	  if (init) {
	    // prevent mount animation
	    inkBarNodeStyle.display = 'none';
	  }
	  if (activeTab) {
	    var tabNode = activeTab;
	    var tabOffset = offset(tabNode);
	    var transformSupported = (0, _utils.isTransformSupported)(inkBarNodeStyle);
	    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
	      var left = tabOffset.left - containerOffset.left;
	      var width = tabNode.offsetWidth;
	
	      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
	      // It means no css working, then ink bar should not have width until css is loaded
	      // Fix https://github.com/ant-design/ant-design/issues/7564
	      if (width === wrapNode.offsetWidth) {
	        width = 0;
	      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
	        width = parseFloat(styles.inkBar.width, 10);
	        if (width) {
	          left = left + (tabNode.offsetWidth - width) / 2;
	        }
	      }
	      // use 3d gpu to optimize render
	      if (transformSupported) {
	        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
	        inkBarNodeStyle.width = width + 'px';
	        inkBarNodeStyle.height = '';
	      } else {
	        inkBarNodeStyle.left = left + 'px';
	        inkBarNodeStyle.top = '';
	        inkBarNodeStyle.bottom = '';
	        inkBarNodeStyle.right = wrapNode.offsetWidth - left - width + 'px';
	      }
	    } else {
	      var top = tabOffset.top - containerOffset.top;
	      var height = tabNode.offsetHeight;
	      if (styles.inkBar && styles.inkBar.height !== undefined) {
	        height = parseFloat(styles.inkBar.height, 10);
	        if (height) {
	          top = top + (tabNode.offsetHeight - height) / 2;
	        }
	      }
	      if (transformSupported) {
	        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
	        inkBarNodeStyle.height = height + 'px';
	        inkBarNodeStyle.width = '';
	      } else {
	        inkBarNodeStyle.left = '';
	        inkBarNodeStyle.right = '';
	        inkBarNodeStyle.top = top + 'px';
	        inkBarNodeStyle.bottom = wrapNode.offsetHeight - top - height + 'px';
	      }
	    }
	  }
	  inkBarNodeStyle.display = activeTab ? 'block' : 'none';
	}
	
	exports['default'] = {
	  getDefaultProps: function getDefaultProps() {
	    return {
	      inkBarAnimated: true
	    };
	  },
	  componentDidUpdate: function componentDidUpdate() {
	    _componentDidUpdate(this);
	  },
	  componentDidMount: function componentDidMount() {
	    var _this = this;
	
	    if (isDev) {
	      // https://github.com/ant-design/ant-design/issues/8678
	      this.timeout = setTimeout(function () {
	        _componentDidUpdate(_this, true);
	      }, 0);
	    } else {
	      _componentDidUpdate(this, true);
	    }
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    clearTimeout(this.timeout);
	  },
	  getInkBarNode: function getInkBarNode() {
	    var _classnames;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        styles = _props.styles,
	        inkBarAnimated = _props.inkBarAnimated;
	
	    var className = prefixCls + '-ink-bar';
	    var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
	    return _react2['default'].createElement('div', {
	      style: styles.inkBar,
	      className: classes,
	      key: 'inkBar',
	      ref: this.saveRef('inkBar')
	    });
	  }
	};

/***/ },
/* 3337 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _InkTabBarMixin = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _InkTabBarMixin2 = _interopRequireDefault(_InkTabBarMixin);
	
	var _ScrollableTabBarMixin = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _ScrollableTabBarMixin2 = _interopRequireDefault(_ScrollableTabBarMixin);
	
	var _TabBarMixin = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _TabBarMixin2 = _interopRequireDefault(_TabBarMixin);
	
	var _RefMixin = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _RefMixin2 = _interopRequireDefault(_RefMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ScrollableInkTabBar = (0, _createReactClass2['default'])({
	  displayName: 'ScrollableInkTabBar',
	  mixins: [_RefMixin2['default'], _TabBarMixin2['default'], _InkTabBarMixin2['default'], _ScrollableTabBarMixin2['default']],
	  render: function render() {
	    var inkBarNode = this.getInkBarNode();
	    var tabs = this.getTabs();
	    var scrollbarNode = this.getScrollBarNode([inkBarNode, tabs]);
	    return this.getRootNode(scrollbarNode);
	  }
	});
	
	exports['default'] = ScrollableInkTabBar;
	module.exports = exports['default'];

/***/ },
/* 3338 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContent = (0, _createReactClass2['default'])({
	  displayName: 'TabContent',
	  propTypes: {
	    animated: _propTypes2['default'].bool,
	    animatedWithMargin: _propTypes2['default'].bool,
	    prefixCls: _propTypes2['default'].string,
	    children: _propTypes2['default'].any,
	    activeKey: _propTypes2['default'].string,
	    style: _propTypes2['default'].any,
	    tabBarPosition: _propTypes2['default'].string
	  },
	  getDefaultProps: function getDefaultProps() {
	    return {
	      animated: true
	    };
	  },
	  getTabPanes: function getTabPanes() {
	    var props = this.props;
	    var activeKey = props.activeKey;
	    var children = props.children;
	    var newChildren = [];
	
	    _react2['default'].Children.forEach(children, function (child) {
	      if (!child) {
	        return;
	      }
	      var key = child.key;
	      var active = activeKey === key;
	      newChildren.push(_react2['default'].cloneElement(child, {
	        active: active,
	        destroyInactiveTabPane: props.destroyInactiveTabPane,
	        rootPrefixCls: props.prefixCls
	      }));
	    });
	
	    return newChildren;
	  },
	  render: function render() {
	    var _classnames;
	
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        children = props.children,
	        activeKey = props.activeKey,
	        tabBarPosition = props.tabBarPosition,
	        animated = props.animated,
	        animatedWithMargin = props.animatedWithMargin;
	    var style = props.style;
	
	    var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames));
	    if (animated) {
	      var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
	      if (activeIndex !== -1) {
	        var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition));
	        style = (0, _extends3['default'])({}, style, animatedStyle);
	      } else {
	        style = (0, _extends3['default'])({}, style, {
	          display: 'none'
	        });
	      }
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: classes,
	        style: style
	      },
	      this.getTabPanes()
	    );
	  }
	});
	
	exports['default'] = TabContent;
	module.exports = exports['default'];

/***/ },
/* 3339 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createReactClass = __webpack_require__(19);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabPane = (0, _createReactClass2['default'])({
	  displayName: 'TabPane',
	  propTypes: {
	    className: _propTypes2['default'].string,
	    active: _propTypes2['default'].bool,
	    style: _propTypes2['default'].any,
	    destroyInactiveTabPane: _propTypes2['default'].bool,
	    forceRender: _propTypes2['default'].bool,
	    placeholder: _propTypes2['default'].node
	  },
	  getDefaultProps: function getDefaultProps() {
	    return { placeholder: null };
	  },
	  render: function render() {
	    var _classnames;
	
	    var _props = this.props,
	        className = _props.className,
	        destroyInactiveTabPane = _props.destroyInactiveTabPane,
	        active = _props.active,
	        forceRender = _props.forceRender,
	        rootPrefixCls = _props.rootPrefixCls,
	        style = _props.style,
	        children = _props.children,
	        placeholder = _props.placeholder,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);
	
	    this._isActived = this._isActived || active;
	    var prefixCls = rootPrefixCls + '-tabpane';
	    var cls = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls, 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-inactive', !active), (0, _defineProperty3['default'])(_classnames, prefixCls + '-active', active), (0, _defineProperty3['default'])(_classnames, className, className), _classnames));
	    var isRender = destroyInactiveTabPane ? active : this._isActived;
	    return _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({
	        style: style,
	        role: 'tabpanel',
	        'aria-hidden': active ? 'false' : 'true',
	        className: cls
	      }, (0, _utils.getDataAttr)(restProps)),
	      isRender || forceRender ? children : placeholder
	    );
	  }
	});
	
	exports['default'] = TabPane;
	module.exports = exports['default'];

/***/ },
/* 3340 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(13);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(11);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _TabPane = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _classnames2 = __webpack_require__(7);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(__webpack_module_template_argument_2__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getDefaultActiveKey(props) {
	  var activeKey = void 0;
	  _react2['default'].Children.forEach(props.children, function (child) {
	    if (child && !activeKey && !child.props.disabled) {
	      activeKey = child.key;
	    }
	  });
	  return activeKey;
	}
	
	function activeKeyIsValid(props, key) {
	  var keys = _react2['default'].Children.map(props.children, function (child) {
	    return child && child.key;
	  });
	  return keys.indexOf(key) >= 0;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs(props) {
	    (0, _classCallCheck3['default'])(this, Tabs);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeKey = void 0;
	    if ('activeKey' in props) {
	      activeKey = props.activeKey;
	    } else if ('defaultActiveKey' in props) {
	      activeKey = props.defaultActiveKey;
	    } else {
	      activeKey = getDefaultActiveKey(props);
	    }
	
	    _this.state = {
	      activeKey: activeKey
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Tabs, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ('activeKey' in nextProps) {
	        this.setState({
	          activeKey: nextProps.activeKey
	        });
	      } else if (!activeKeyIsValid(nextProps, this.state.activeKey)) {
	        // https://github.com/ant-design/ant-design/issues/7093
	        this.setState({
	          activeKey: getDefaultActiveKey(nextProps)
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var props = this.props;
	      var prefixCls = props.prefixCls,
	          tabBarPosition = props.tabBarPosition,
	          className = props.className,
	          renderTabContent = props.renderTabContent,
	          renderTabBar = props.renderTabBar,
	          destroyInactiveTabPane = props.destroyInactiveTabPane,
	          restProps = (0, _objectWithoutProperties3['default'])(props, ['prefixCls', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane']);
	
	      var cls = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls, 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-' + tabBarPosition, 1), (0, _defineProperty3['default'])(_classnames, className, !!className), _classnames));
	
	      this.tabBar = renderTabBar();
	      var contents = [_react2['default'].cloneElement(this.tabBar, {
	        prefixCls: prefixCls,
	        key: 'tabBar',
	        onKeyDown: this.onNavKeyDown,
	        tabBarPosition: tabBarPosition,
	        onTabClick: this.onTabClick,
	        panels: props.children,
	        activeKey: this.state.activeKey
	      }), _react2['default'].cloneElement(renderTabContent(), {
	        prefixCls: prefixCls,
	        tabBarPosition: tabBarPosition,
	        activeKey: this.state.activeKey,
	        destroyInactiveTabPane: destroyInactiveTabPane,
	        children: props.children,
	        onChange: this.setActiveKey,
	        key: 'tabContent'
	      })];
	      if (tabBarPosition === 'bottom') {
	        contents.reverse();
	      }
	      return _react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          className: cls,
	          style: props.style
	        }, (0, _utils.getDataAttr)(restProps)),
	        contents
	      );
	    }
	  }]);
	  return Tabs;
	}(_react2['default'].Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onTabClick = function (activeKey) {
	    if (_this2.tabBar.props.onTabClick) {
	      _this2.tabBar.props.onTabClick(activeKey);
	    }
	    _this2.setActiveKey(activeKey);
	  };
	
	  this.onNavKeyDown = function (e) {
	    var eventKeyCode = e.keyCode;
	    if (eventKeyCode === _KeyCode2['default'].RIGHT || eventKeyCode === _KeyCode2['default'].DOWN) {
	      e.preventDefault();
	      var nextKey = _this2.getNextActiveKey(true);
	      _this2.onTabClick(nextKey);
	    } else if (eventKeyCode === _KeyCode2['default'].LEFT || eventKeyCode === _KeyCode2['default'].UP) {
	      e.preventDefault();
	      var previousKey = _this2.getNextActiveKey(false);
	      _this2.onTabClick(previousKey);
	    }
	  };
	
	  this.setActiveKey = function (activeKey) {
	    if (_this2.state.activeKey !== activeKey) {
	      if (!('activeKey' in _this2.props)) {
	        _this2.setState({
	          activeKey: activeKey
	        });
	      }
	      _this2.props.onChange(activeKey);
	    }
	  };
	
	  this.getNextActiveKey = function (next) {
	    var activeKey = _this2.state.activeKey;
	    var children = [];
	    _react2['default'].Children.forEach(_this2.props.children, function (c) {
	      if (c && !c.props.disabled) {
	        if (next) {
	          children.push(c);
	        } else {
	          children.unshift(c);
	        }
	      }
	    });
	    var length = children.length;
	    var ret = length && children[0].key;
	    children.forEach(function (child, i) {
	      if (child.key === activeKey) {
	        if (i === length - 1) {
	          ret = children[0].key;
	        } else {
	          ret = children[i + 1].key;
	        }
	      }
	    });
	    return ret;
	  };
	};
	
	exports['default'] = Tabs;
	
	
	Tabs.propTypes = {
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  renderTabBar: _propTypes2['default'].func.isRequired,
	  renderTabContent: _propTypes2['default'].func.isRequired,
	  onChange: _propTypes2['default'].func,
	  children: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  tabBarPosition: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  activeKey: _propTypes2['default'].string,
	  defaultActiveKey: _propTypes2['default'].string
	};
	
	Tabs.defaultProps = {
	  prefixCls: 'rc-tabs',
	  destroyInactiveTabPane: false,
	  onChange: noop,
	  tabBarPosition: 'top',
	  style: {}
	};
	
	Tabs.TabPane = _TabPane2['default'];
	module.exports = exports['default'];

/***/ },
/* 3341 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabContent = exports.TabPane = undefined;
	
	var _Tabs = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabPane = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _TabContent = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tabs2['default'];
	exports.TabPane = _TabPane2['default'];
	exports.TabContent = _TabContent2['default'];

/***/ },
/* 3342 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__(__webpack_module_template_argument_0__);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IsoWidgetsWrapper = function (_Component) {
	  _inherits(IsoWidgetsWrapper, _Component);
	
	  function IsoWidgetsWrapper() {
	    _classCallCheck(this, IsoWidgetsWrapper);
	
	    return _possibleConstructorReturn(this, (IsoWidgetsWrapper.__proto__ || Object.getPrototypeOf(IsoWidgetsWrapper)).apply(this, arguments));
	  }
	
	  _createClass(IsoWidgetsWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          width = _props.width,
	          gutterTop = _props.gutterTop,
	          gutterRight = _props.gutterRight,
	          gutterBottom = _props.gutterBottom,
	          gutterLeft = _props.gutterLeft,
	          padding = _props.padding,
	          bgColor = _props.bgColor,
	          children = _props.children;
	
	      var wrapperStyle = {
	        width: width,
	        marginTop: gutterTop,
	        marginRight: gutterRight,
	        marginBottom: gutterBottom,
	        marginLeft: gutterLeft,
	        padding: padding,
	        backgroundColor: bgColor
	      };
	
	      return _react2.default.createElement(
	        _style.WidgetWrapper,
	        { className: 'isoWidgetsWrapper', style: wrapperStyle },
	        children
	      );
	    }
	  }]);
	
	  return IsoWidgetsWrapper;
	}(_react.Component);
	
	exports.default = IsoWidgetsWrapper;

/***/ },
/* 3343 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 3344 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 3345 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3346 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 3347 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 3348 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3349 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 3350 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 3351 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 3352 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 3353 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arKw = moment.defineLocale('ar-kw', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arKw;
	
	})));


/***/ },
/* 3354 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 3355 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 3356 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 3357 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 3358 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 3359 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 3360 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 3361 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 3362 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 3363 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 3364 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 3365 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 3366 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 3367 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 3368 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 3369 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 3370 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 3371 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 3372 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 3373 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	    weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	    weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-a de] MMMM, YYYY',
	        LLL : 'D[-a de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'post %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 3374 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 3375 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 3376 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چند ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 3377 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 3378 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 3379 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 3380 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'D':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 3381 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Aujourd’hui à] LT',
	        nextDay : '[Demain à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[Hier à] LT',
	        lastWeek : 'dddd [dernier à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // TODO: Return 'e' when day of month > 1. Move this case inside
	            // block for masculine words below.
	            // See https://github.com/moment/moment/issues/3375
	            case 'D':
	                return number + (number === 1 ? 'er' : '');
	
	            // Words with masculine grammatical gender: mois, trimestre, jour
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	                return number + (number === 1 ? 'er' : 'e');
	
	            // Words with feminine grammatical gender: semaine
	            case 'w':
	            case 'W':
	                return number + (number === 1 ? 're' : 'e');
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 3382 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (!m) {
	            return monthsShortWithDots;
	        } else if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 3383 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 3384 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 3385 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['thodde secondanim', 'thodde second'],
	        'm': ['eka mintan', 'ek minute'],
	        'mm': [number + ' mintanim', number + ' mintam'],
	        'h': ['eka horan', 'ek hor'],
	        'hh': [number + ' horanim', number + ' hor'],
	        'd': ['eka disan', 'ek dis'],
	        'dd': [number + ' disanim', number + ' dis'],
	        'M': ['eka mhoinean', 'ek mhoino'],
	        'MM': [number + ' mhoineanim', number + ' mhoine'],
	        'y': ['eka vorsan', 'ek voros'],
	        'yy': [number + ' vorsanim', number + ' vorsam']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var gomLatn = moment.defineLocale('gom-latn', {
	    months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	    monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	    weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	    weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'A h:mm [vazta]',
	        LTS : 'A h:mm:ss [vazta]',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY A h:mm [vazta]',
	        LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	        llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	    },
	    calendar : {
	        sameDay: '[Aiz] LT',
	        nextDay: '[Faleam] LT',
	        nextWeek: '[Ieta to] dddd[,] LT',
	        lastDay: '[Kal] LT',
	        lastWeek: '[Fatlo] dddd[,] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s',
	        past : '%s adim',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            // the ordinal 'er' only applies to day of the month
	            case 'D':
	                return number + 'er';
	            default:
	            case 'M':
	            case 'Q':
	            case 'DDD':
	            case 'd':
	            case 'w':
	            case 'W':
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    },
	    meridiemParse: /rati|sokalli|donparam|sanje/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'rati') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'sokalli') {
	            return hour;
	        } else if (meridiem === 'donparam') {
	            return hour > 12 ? hour : hour + 12;
	        } else if (meridiem === 'sanje') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'rati';
	        } else if (hour < 12) {
	            return 'sokalli';
	        } else if (hour < 16) {
	            return 'donparam';
	        } else if (hour < 20) {
	            return 'sanje';
	        } else {
	            return 'rati';
	        }
	    }
	});
	
	return gomLatn;
	
	})));


/***/ },
/* 3386 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 3387 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 3388 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 3389 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 3390 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 3391 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 3392 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 3393 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	    weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	    weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 3394 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日 HH:mm',
	        LLLL : 'YYYY年M月D日 HH:mm dddd',
	        l : 'YYYY/MM/DD',
	        ll : 'YYYY年M月D日',
	        lll : 'YYYY年M月D日 HH:mm',
	        llll : 'YYYY年M月D日 HH:mm dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 3395 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 3396 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის უკან');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის უკან');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 3397 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 3398 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 3399 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '೧',
	    '2': '೨',
	    '3': '೩',
	    '4': '೪',
	    '5': '೫',
	    '6': '೬',
	    '7': '೭',
	    '8': '೮',
	    '9': '೯',
	    '0': '೦'
	};
	var numberMap = {
	    '೧': '1',
	    '೨': '2',
	    '೩': '3',
	    '೪': '4',
	    '೫': '5',
	    '೬': '6',
	    '೭': '7',
	    '೮': '8',
	    '೯': '9',
	    '೦': '0'
	};
	
	var kn = moment.defineLocale('kn', {
	    months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	    monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬ_ಅಕ್ಟೋಬ_ನವೆಂಬ_ಡಿಸೆಂಬ'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	    weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	    weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[ಇಂದು] LT',
	        nextDay : '[ನಾಳೆ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ನಿನ್ನೆ] LT',
	        lastWeek : '[ಕೊನೆಯ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ನಂತರ',
	        past : '%s ಹಿಂದೆ',
	        s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	        m : 'ಒಂದು ನಿಮಿಷ',
	        mm : '%d ನಿಮಿಷ',
	        h : 'ಒಂದು ಗಂಟೆ',
	        hh : '%d ಗಂಟೆ',
	        d : 'ಒಂದು ದಿನ',
	        dd : '%d ದಿನ',
	        M : 'ಒಂದು ತಿಂಗಳು',
	        MM : '%d ತಿಂಗಳು',
	        y : 'ಒಂದು ವರ್ಷ',
	        yy : '%d ವರ್ಷ'
	    },
	    preparse: function (string) {
	        return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ರಾತ್ರಿ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	            return hour;
	        } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ಸಂಜೆ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ರಾತ್ರಿ';
	        } else if (hour < 10) {
	            return 'ಬೆಳಿಗ್ಗೆ';
	        } else if (hour < 17) {
	            return 'ಮಧ್ಯಾಹ್ನ';
	        } else if (hour < 20) {
	            return 'ಸಂಜೆ';
	        } else {
	            return 'ರಾತ್ರಿ';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	    ordinal : function (number) {
	        return number + 'ನೇ';
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kn;
	
	})));


/***/ },
/* 3400 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 3401 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 3402 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 3403 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 3404 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 3405 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 3406 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 3407 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 3408 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 3409 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 3410 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 3411 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 3412 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 3413 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 3414 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 3415 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 3416 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 3417 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 3418 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوري',
	    'فيبروري',
	    'مارچ',
	    'اپريل',
	    'مئي',
	    'جون',
	    'جولاءِ',
	    'آگسٽ',
	    'سيپٽمبر',
	    'آڪٽوبر',
	    'نومبر',
	    'ڊسمبر'
	];
	var days = [
	    'آچر',
	    'سومر',
	    'اڱارو',
	    'اربع',
	    'خميس',
	    'جمع',
	    'ڇنڇر'
	];
	
	var sd = moment.defineLocale('sd', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[اڄ] LT',
	        nextDay : '[سڀاڻي] LT',
	        nextWeek : 'dddd [اڳين هفتي تي] LT',
	        lastDay : '[ڪالهه] LT',
	        lastWeek : '[گزريل هفتي] dddd [تي] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s پوء',
	        past : '%s اڳ',
	        s : 'چند سيڪنڊ',
	        m : 'هڪ منٽ',
	        mm : '%d منٽ',
	        h : 'هڪ ڪلاڪ',
	        hh : '%d ڪلاڪ',
	        d : 'هڪ ڏينهن',
	        dd : '%d ڏينهن',
	        M : 'هڪ مهينو',
	        MM : '%d مهينا',
	        y : 'هڪ سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sd;
	
	})));


/***/ },
/* 3419 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 3420 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 3421 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 3422 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 3423 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 3424 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 3425 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 3426 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 3427 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 3428 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 3429 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 3430 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    dayOfMonthOrdinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 3431 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 3432 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 3433 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 3434 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 3435 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 3436 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 3437 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 3438 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    };
	
	    if (!m) {
	        return weekdays['nominative'];
	    }
	
	    var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 3439 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'جنوری',
	    'فروری',
	    'مارچ',
	    'اپریل',
	    'مئی',
	    'جون',
	    'جولائی',
	    'اگست',
	    'ستمبر',
	    'اکتوبر',
	    'نومبر',
	    'دسمبر'
	];
	var days = [
	    'اتوار',
	    'پیر',
	    'منگل',
	    'بدھ',
	    'جمعرات',
	    'جمعہ',
	    'ہفتہ'
	];
	
	var ur = moment.defineLocale('ur', {
	    months : months,
	    monthsShort : months,
	    weekdays : days,
	    weekdaysShort : days,
	    weekdaysMin : days,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd، D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /صبح|شام/,
	    isPM : function (input) {
	        return 'شام' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'صبح';
	        }
	        return 'شام';
	    },
	    calendar : {
	        sameDay : '[آج بوقت] LT',
	        nextDay : '[کل بوقت] LT',
	        nextWeek : 'dddd [بوقت] LT',
	        lastDay : '[گذشتہ روز بوقت] LT',
	        lastWeek : '[گذشتہ] dddd [بوقت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s بعد',
	        past : '%s قبل',
	        s : 'چند سیکنڈ',
	        m : 'ایک منٹ',
	        mm : '%d منٹ',
	        h : 'ایک گھنٹہ',
	        hh : '%d گھنٹے',
	        d : 'ایک دن',
	        dd : '%d دن',
	        M : 'ایک ماہ',
	        MM : '%d ماہ',
	        y : 'ایک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ur;
	
	})));


/***/ },
/* 3440 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uzLatn = moment.defineLocale('uz-latn', {
	    months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	    monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	    weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	    weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	    weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Bugun soat] LT [da]',
	        nextDay : '[Ertaga] LT [da]',
	        nextWeek : 'dddd [kuni soat] LT [da]',
	        lastDay : '[Kecha soat] LT [da]',
	        lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Yaqin %s ichida',
	        past : 'Bir necha %s oldin',
	        s : 'soniya',
	        m : 'bir daqiqa',
	        mm : '%d daqiqa',
	        h : 'bir soat',
	        hh : '%d soat',
	        d : 'bir kun',
	        dd : '%d kun',
	        M : 'bir oy',
	        MM : '%d oy',
	        y : 'bir yil',
	        yy : '%d yil'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uzLatn;
	
	})));


/***/ },
/* 3441 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 3442 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 3443 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 3444 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 3445 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 3446 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 3447 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(__webpack_module_template_argument_0__)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日 HH:mm',
	        LLLL : 'YYYY年MMMD日dddd HH:mm',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日 HH:mm',
	        llll : 'YYYY年MMMD日dddd HH:mm'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 3448 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	module.exports = __webpack_require__(__webpack_module_template_argument_0__)


/***/ },
/* 3449 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ },
/* 3450 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 3451 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var hashClear = __webpack_require__(__webpack_module_template_argument_0__),
	    hashDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    hashGet = __webpack_require__(__webpack_module_template_argument_2__),
	    hashHas = __webpack_require__(__webpack_module_template_argument_3__),
	    hashSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 3452 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var listCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
	    listCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    listCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
	    listCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    listCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 3453 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 3454 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var mapCacheClear = __webpack_require__(__webpack_module_template_argument_0__),
	    mapCacheDelete = __webpack_require__(__webpack_module_template_argument_1__),
	    mapCacheGet = __webpack_require__(__webpack_module_template_argument_2__),
	    mapCacheHas = __webpack_require__(__webpack_module_template_argument_3__),
	    mapCacheSet = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 3455 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 3456 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 3457 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var MapCache = __webpack_require__(__webpack_module_template_argument_0__),
	    setCacheAdd = __webpack_require__(__webpack_module_template_argument_1__),
	    setCacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 3458 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    stackClear = __webpack_require__(__webpack_module_template_argument_1__),
	    stackDelete = __webpack_require__(__webpack_module_template_argument_2__),
	    stackGet = __webpack_require__(__webpack_module_template_argument_3__),
	    stackHas = __webpack_require__(__webpack_module_template_argument_4__),
	    stackSet = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 3459 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 3460 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 3461 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__),
	    root = __webpack_require__(__webpack_module_template_argument_1__);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 3462 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var baseTimes = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_3__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_4__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 3463 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseAssignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    eq = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 3464 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 3465 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 3466 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var createBaseFor = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 3467 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseFor = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 3468 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var castPath = __webpack_require__(__webpack_module_template_argument_0__),
	    toKey = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 3469 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayPush = __webpack_require__(__webpack_module_template_argument_0__),
	    isArray = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 3470 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 3471 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 3472 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsEqualDeep = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 3473 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    equalArrays = __webpack_require__(__webpack_module_template_argument_1__),
	    equalByTag = __webpack_require__(__webpack_module_template_argument_2__),
	    equalObjects = __webpack_require__(__webpack_module_template_argument_3__),
	    getTag = __webpack_require__(__webpack_module_template_argument_4__),
	    isArray = __webpack_require__(__webpack_module_template_argument_5__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_6__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_7__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 3474 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var Stack = __webpack_require__(__webpack_module_template_argument_0__),
	    baseIsEqual = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 3475 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isMasked = __webpack_require__(__webpack_module_template_argument_1__),
	    isObject = __webpack_require__(__webpack_module_template_argument_2__),
	    toSource = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 3476 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 3477 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var baseMatches = __webpack_require__(__webpack_module_template_argument_0__),
	    baseMatchesProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    property = __webpack_require__(__webpack_module_template_argument_4__);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 3478 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isPrototype = __webpack_require__(__webpack_module_template_argument_0__),
	    nativeKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 3479 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsMatch = __webpack_require__(__webpack_module_template_argument_0__),
	    getMatchData = __webpack_require__(__webpack_module_template_argument_1__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 3480 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__),
	    get = __webpack_require__(__webpack_module_template_argument_1__),
	    hasIn = __webpack_require__(__webpack_module_template_argument_2__),
	    isKey = __webpack_require__(__webpack_module_template_argument_3__),
	    isStrictComparable = __webpack_require__(__webpack_module_template_argument_4__),
	    matchesStrictComparable = __webpack_require__(__webpack_module_template_argument_5__),
	    toKey = __webpack_require__(__webpack_module_template_argument_6__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 3481 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 3482 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var identity = __webpack_require__(__webpack_module_template_argument_0__),
	    overRest = __webpack_require__(__webpack_module_template_argument_1__),
	    setToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 3483 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var constant = __webpack_require__(__webpack_module_template_argument_0__),
	    defineProperty = __webpack_require__(__webpack_module_template_argument_1__),
	    identity = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 3484 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    arrayMap = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_3__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 3485 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isKey = __webpack_require__(__webpack_module_template_argument_1__),
	    stringToPath = __webpack_require__(__webpack_module_template_argument_2__),
	    toString = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 3486 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 3487 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 3488 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var SetCache = __webpack_require__(__webpack_module_template_argument_0__),
	    arraySome = __webpack_require__(__webpack_module_template_argument_1__),
	    cacheHas = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 3489 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    Uint8Array = __webpack_require__(__webpack_module_template_argument_1__),
	    eq = __webpack_require__(__webpack_module_template_argument_2__),
	    equalArrays = __webpack_require__(__webpack_module_template_argument_3__),
	    mapToArray = __webpack_require__(__webpack_module_template_argument_4__),
	    setToArray = __webpack_require__(__webpack_module_template_argument_5__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 3490 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getAllKeys = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 3491 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetAllKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getSymbols = __webpack_require__(__webpack_module_template_argument_1__),
	    keys = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 3492 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isKeyable = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 3493 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isStrictComparable = __webpack_require__(__webpack_module_template_argument_0__),
	    keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 3494 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsNative = __webpack_require__(__webpack_module_template_argument_0__),
	    getValue = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 3495 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 3496 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 3497 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var arrayFilter = __webpack_require__(__webpack_module_template_argument_0__),
	    stubArray = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 3498 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var DataView = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    Promise = __webpack_require__(__webpack_module_template_argument_2__),
	    Set = __webpack_require__(__webpack_module_template_argument_3__),
	    WeakMap = __webpack_require__(__webpack_module_template_argument_4__),
	    baseGetTag = __webpack_require__(__webpack_module_template_argument_5__),
	    toSource = __webpack_require__(__webpack_module_template_argument_6__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 3499 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	var castPath = __webpack_require__(__webpack_module_template_argument_0__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_1__),
	    isArray = __webpack_require__(__webpack_module_template_argument_2__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_3__),
	    isLength = __webpack_require__(__webpack_module_template_argument_4__),
	    toKey = __webpack_require__(__webpack_module_template_argument_5__);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 3500 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 3501 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 3502 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 3503 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var nativeCreate = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 3504 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var eq = __webpack_require__(__webpack_module_template_argument_0__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_1__),
	    isIndex = __webpack_require__(__webpack_module_template_argument_2__),
	    isObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 3505 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArray = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 3506 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var coreJsData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 3507 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 3508 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 3509 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 3510 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 3511 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var assocIndexOf = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 3512 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Hash = __webpack_require__(__webpack_module_template_argument_0__),
	    ListCache = __webpack_require__(__webpack_module_template_argument_1__),
	    Map = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 3513 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 3514 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 3515 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 3516 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getMapData = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 3517 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var memoize = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 3518 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var getNative = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 3519 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var overArg = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 3520 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var apply = __webpack_require__(__webpack_module_template_argument_0__);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 3521 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 3522 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseSetToString = __webpack_require__(__webpack_module_template_argument_0__),
	    shortOut = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 3523 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 3524 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var ListCache = __webpack_require__(__webpack_module_template_argument_0__),
	    Map = __webpack_require__(__webpack_module_template_argument_1__),
	    MapCache = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 3525 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isSymbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 3526 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseGet = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 3527 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseHasIn = __webpack_require__(__webpack_module_template_argument_0__),
	    hasPath = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 3528 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseIsArguments = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 3529 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isFunction = __webpack_require__(__webpack_module_template_argument_0__),
	    isLength = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 3530 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isArrayLike = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 3531 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(__webpack_module_template_argument_0__),
	    stubFalse = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(70)(module)))

/***/ },
/* 3532 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__) {

	var baseKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    getTag = __webpack_require__(__webpack_module_template_argument_1__),
	    isArguments = __webpack_require__(__webpack_module_template_argument_2__),
	    isArray = __webpack_require__(__webpack_module_template_argument_3__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_4__),
	    isBuffer = __webpack_require__(__webpack_module_template_argument_5__),
	    isPrototype = __webpack_require__(__webpack_module_template_argument_6__),
	    isTypedArray = __webpack_require__(__webpack_module_template_argument_7__);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ },
/* 3533 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseIsEqual = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 3534 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 3535 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    getPrototype = __webpack_require__(__webpack_module_template_argument_1__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 3536 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObjectLike = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 3537 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseIsTypedArray = __webpack_require__(__webpack_module_template_argument_0__),
	    baseUnary = __webpack_require__(__webpack_module_template_argument_1__),
	    nodeUtil = __webpack_require__(__webpack_module_template_argument_2__);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 3538 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var arrayLikeKeys = __webpack_require__(__webpack_module_template_argument_0__),
	    baseKeys = __webpack_require__(__webpack_module_template_argument_1__),
	    isArrayLike = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 3539 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var baseAssignValue = __webpack_require__(__webpack_module_template_argument_0__),
	    baseForOwn = __webpack_require__(__webpack_module_template_argument_1__),
	    baseIteratee = __webpack_require__(__webpack_module_template_argument_2__);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 3540 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var MapCache = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 3541 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 3542 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var baseProperty = __webpack_require__(__webpack_module_template_argument_0__),
	    basePropertyDeep = __webpack_require__(__webpack_module_template_argument_1__),
	    isKey = __webpack_require__(__webpack_module_template_argument_2__),
	    toKey = __webpack_require__(__webpack_module_template_argument_3__);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 3543 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__),
	    isSymbol = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 3544 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var baseToString = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 3545 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(67);
	var invariant = __webpack_require__(18);
	var ReactPropTypesSecret = __webpack_require__(__webpack_module_template_argument_0__);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 3546 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__)();
	}


/***/ },
/* 3547 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = autoRehydrate;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _isStatePlainEnough = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _isStatePlainEnough2 = _interopRequireDefault(_isStatePlainEnough);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function autoRehydrate() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var stateReconciler = config.stateReconciler || defaultStateReconciler;
	
	  return function (next) {
	    return function (reducer, initialState, enhancer) {
	      var store = next(liftReducer(reducer), initialState, enhancer);
	      return _extends({}, store, {
	        replaceReducer: function replaceReducer(reducer) {
	          return store.replaceReducer(liftReducer(reducer));
	        }
	      });
	    };
	  };
	
	  function liftReducer(reducer) {
	    var rehydrated = false;
	    var preRehydrateActions = [];
	    return function (state, action) {
	      if (action.type !== _constants.REHYDRATE) {
	        if (config.log && !rehydrated) preRehydrateActions.push(action); // store pre-rehydrate actions for debugging
	        return reducer(state, action);
	      } else {
	        if (config.log && !rehydrated) logPreRehydrate(preRehydrateActions);
	        rehydrated = true;
	
	        var inboundState = action.payload;
	        var reducedState = reducer(state, action);
	
	        return stateReconciler(state, inboundState, reducedState, config.log);
	      }
	    };
	  }
	}
	
	function logPreRehydrate(preRehydrateActions) {
	  var concernedActions = preRehydrateActions.slice(1);
	  if (concernedActions.length > 0) {
	    console.log('\n      redux-persist/autoRehydrate: %d actions were fired before rehydration completed. This can be a symptom of a race\n      condition where the rehydrate action may overwrite the previously affected state. Consider running these actions\n      after rehydration:\n    ', concernedActions.length, concernedActions);
	  }
	}
	
	function defaultStateReconciler(state, inboundState, reducedState, log) {
	  var newState = _extends({}, reducedState);
	
	  Object.keys(inboundState).forEach(function (key) {
	    // if initialState does not have key, skip auto rehydration
	    if (!state.hasOwnProperty(key)) return;
	
	    // if initial state is an object but inbound state is null/undefined, skip
	    if (_typeof(state[key]) === 'object' && !inboundState[key]) {
	      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` is falsy but initial state is an object, skipping autoRehydrate.', key);
	      return;
	    }
	
	    // if reducer modifies substate, skip auto rehydration
	    if (state[key] !== reducedState[key]) {
	      if (log) console.log('redux-persist/autoRehydrate: sub state for key `%s` modified, skipping autoRehydrate.', key);
	      newState[key] = reducedState[key];
	      return;
	    }
	
	    // otherwise take the inboundState
	    if ((0, _isStatePlainEnough2.default)(inboundState[key]) && (0, _isStatePlainEnough2.default)(state[key])) newState[key] = _extends({}, state[key], inboundState[key]); // shallow merge
	    else newState[key] = inboundState[key]; // hard set
	
	    if (log) console.log('redux-persist/autoRehydrate: key `%s`, rehydrated to ', key, newState[key]);
	  });
	  return newState;
	}

/***/ },
/* 3548 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createPersistor;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _asyncLocalStorage = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	var _purgeStoredState = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);
	
	var _jsonStringifySafe = __webpack_require__(961);
	
	var _jsonStringifySafe2 = _interopRequireDefault(_jsonStringifySafe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPersistor(store, config) {
	  // defaults
	  var serializer = config.serialize === false ? function (data) {
	    return data;
	  } : defaultSerializer;
	  var deserializer = config.serialize === false ? function (data) {
	    return data;
	  } : defaultDeserializer;
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var transforms = config.transforms || [];
	  var debounce = config.debounce || false;
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // pluggable state shape (e.g. immutablejs)
	  var stateInit = config._stateInit || {};
	  var stateIterator = config._stateIterator || defaultStateIterator;
	  var stateGetter = config._stateGetter || defaultStateGetter;
	  var stateSetter = config._stateSetter || defaultStateSetter;
	
	  // storage with keys -> getAllKeys for localForage support
	  var storage = config.storage || (0, _asyncLocalStorage2.default)('local');
	  if (storage.keys && !storage.getAllKeys) {
	    storage.getAllKeys = storage.keys;
	  }
	
	  // initialize stateful values
	  var lastState = stateInit;
	  var paused = false;
	  var storesToProcess = [];
	  var timeIterator = null;
	
	  store.subscribe(function () {
	    if (paused) return;
	
	    var state = store.getState();
	
	    stateIterator(state, function (subState, key) {
	      if (!passWhitelistBlacklist(key)) return;
	      if (stateGetter(lastState, key) === stateGetter(state, key)) return;
	      if (storesToProcess.indexOf(key) !== -1) return;
	      storesToProcess.push(key);
	    });
	
	    var len = storesToProcess.length;
	
	    // time iterator (read: debounce)
	    if (timeIterator === null) {
	      timeIterator = setInterval(function () {
	        if (paused && len === storesToProcess.length || storesToProcess.length === 0) {
	          clearInterval(timeIterator);
	          timeIterator = null;
	          return;
	        }
	
	        var key = storesToProcess.shift();
	        var storageKey = createStorageKey(key);
	        var endState = transforms.reduce(function (subState, transformer) {
	          return transformer.in(subState, key);
	        }, stateGetter(store.getState(), key));
	        if (typeof endState !== 'undefined') storage.setItem(storageKey, serializer(endState), warnIfSetError(key));
	      }, debounce);
	    }
	
	    lastState = state;
	  });
	
	  function passWhitelistBlacklist(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return false;
	    if (blacklist.indexOf(key) !== -1) return false;
	    return true;
	  }
	
	  function adhocRehydrate(incoming) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var state = {};
	    if (options.serial) {
	      stateIterator(incoming, function (subState, key) {
	        try {
	          var data = deserializer(subState);
	          var value = transforms.reduceRight(function (interState, transformer) {
	            return transformer.out(interState, key);
	          }, data);
	          state = stateSetter(state, key, value);
	        } catch (err) {
	          if (false) console.warn('Error rehydrating data for key "' + key + '"', subState, err);
	        }
	      });
	    } else state = incoming;
	
	    store.dispatch(rehydrateAction(state));
	    return state;
	  }
	
	  function createStorageKey(key) {
	    return '' + keyPrefix + key;
	  }
	
	  // return `persistor`
	  return {
	    rehydrate: adhocRehydrate,
	    pause: function pause() {
	      paused = true;
	    },
	    resume: function resume() {
	      paused = false;
	    },
	    purge: function purge(keys) {
	      return (0, _purgeStoredState2.default)({ storage: storage, keyPrefix: keyPrefix }, keys);
	    }
	  };
	}
	
	function warnIfSetError(key) {
	  return function setError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}
	
	function defaultSerializer(data) {
	  return (0, _jsonStringifySafe2.default)(data, null, null, function (k, v) {
	    if (false) return null;
	    throw new Error('\n      redux-persist: cannot process cyclical state.\n      Consider changing your state structure to have no cycles.\n      Alternatively blacklist the corresponding reducer key.\n      Cycle encounted at key "' + k + '" with value "' + v + '".\n    ');
	  });
	}
	
	function defaultDeserializer(serial) {
	  return JSON.parse(serial);
	}
	
	function rehydrateAction(data) {
	  return {
	    type: _constants.REHYDRATE,
	    payload: data
	  };
	}
	
	function defaultStateIterator(collection, callback) {
	  return Object.keys(collection).forEach(function (key) {
	    return callback(collection[key], key);
	  });
	}
	
	function defaultStateGetter(state, key) {
	  return state[key];
	}
	
	function defaultStateSetter(state, key, value) {
	  state[key] = value;
	  return state;
	}

/***/ },
/* 3549 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function (type, config) {
	  var storage = getStorage(type);
	  return {
	    getAllKeys: function getAllKeys(cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var keys = [];
	          for (var i = 0; i < storage.length; i++) {
	            keys.push(storage.key(i));
	          }
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null, keys);
	            resolve(keys);
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    getItem: function getItem(key, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          var s = storage.getItem(key);
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null, s);
	            resolve(s);
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    setItem: function setItem(key, string, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          storage.setItem(key, string);
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null);
	            resolve();
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    },
	    removeItem: function removeItem(key, cb) {
	      return new Promise(function (resolve, reject) {
	        try {
	          storage.removeItem(key);
	          (0, _setImmediate2.default)(function () {
	            cb && cb(null);
	            resolve();
	          });
	        } catch (e) {
	          cb && cb(e);
	          reject(e);
	        }
	      });
	    }
	  };
	};
	
	var _setImmediate = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _setImmediate2 = _interopRequireDefault(_setImmediate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noStorage = function noStorage() {
	  /* noop */return null;
	};
	if (false) {
	  noStorage = function noStorage() {
	    console.error('redux-persist asyncLocalStorage requires a global localStorage object. Either use a different storage backend or if this is a universal redux application you probably should conditionally persist like so: https://gist.github.com/rt2zz/ac9eb396793f95ff3c3b');
	    return null;
	  };
	}
	
	function _hasStorage(storageType) {
	  if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || !(storageType in window)) {
	    return false;
	  }
	
	  try {
	    var storage = window[storageType];
	    var testKey = 'redux-persist ' + storageType + ' test';
	    storage.setItem(testKey, 'test');
	    storage.getItem(testKey);
	    storage.removeItem(testKey);
	  } catch (e) {
	    if (false) console.warn('redux-persist ' + storageType + ' test failed, persistence will be disabled.');
	    return false;
	  }
	  return true;
	}
	
	function hasLocalStorage() {
	  return _hasStorage('localStorage');
	}
	
	function hasSessionStorage() {
	  return _hasStorage('sessionStorage');
	}
	
	function getStorage(type) {
	  if (type === 'local') {
	    return hasLocalStorage() ? window.localStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	  if (type === 'session') {
	    return hasSessionStorage() ? window.sessionStorage : { getItem: noStorage, setItem: noStorage, removeItem: noStorage, getAllKeys: noStorage };
	  }
	}

/***/ },
/* 3550 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = getStoredState;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _asyncLocalStorage = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _asyncLocalStorage2 = _interopRequireDefault(_asyncLocalStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStoredState(config, onComplete) {
	  var storage = config.storage || (0, _asyncLocalStorage2.default)('local');
	  var deserializer = config.serialize === false ? function (data) {
	    return data;
	  } : defaultDeserializer;
	  var blacklist = config.blacklist || [];
	  var whitelist = config.whitelist || false;
	  var transforms = config.transforms || [];
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // fallback getAllKeys to `keys` if present (LocalForage compatability)
	  if (storage.keys && !storage.getAllKeys) storage = _extends({}, storage, { getAllKeys: storage.keys });
	
	  var restoredState = {};
	  var completionCount = 0;
	
	  storage.getAllKeys(function (err, allKeys) {
	    if (err) {
	      if (false) console.warn('redux-persist/getStoredState: Error in storage.getAllKeys');
	      complete(err);
	    }
	
	    var persistKeys = allKeys.filter(function (key) {
	      return key.indexOf(keyPrefix) === 0;
	    }).map(function (key) {
	      return key.slice(keyPrefix.length);
	    });
	    var keysToRestore = persistKeys.filter(passWhitelistBlacklist);
	
	    var restoreCount = keysToRestore.length;
	    if (restoreCount === 0) complete(null, restoredState);
	    keysToRestore.forEach(function (key) {
	      storage.getItem(createStorageKey(key), function (err, serialized) {
	        if (err && ("production") !== 'production') console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);else restoredState[key] = rehydrate(key, serialized);
	        completionCount += 1;
	        if (completionCount === restoreCount) complete(null, restoredState);
	      });
	    });
	  });
	
	  function rehydrate(key, serialized) {
	    var state = null;
	
	    try {
	      var data = deserializer(serialized);
	      state = transforms.reduceRight(function (subState, transformer) {
	        return transformer.out(subState, key);
	      }, data);
	    } catch (err) {
	      if (false) console.warn('redux-persist/getStoredState: Error restoring data for key:', key, err);
	    }
	
	    return state;
	  }
	
	  function complete(err, restoredState) {
	    onComplete(err, restoredState);
	  }
	
	  function passWhitelistBlacklist(key) {
	    if (whitelist && whitelist.indexOf(key) === -1) return false;
	    if (blacklist.indexOf(key) !== -1) return false;
	    return true;
	  }
	
	  function createStorageKey(key) {
	    return '' + keyPrefix + key;
	  }
	
	  if (typeof onComplete !== 'function' && !!Promise) {
	    return new Promise(function (resolve, reject) {
	      onComplete = function onComplete(err, restoredState) {
	        if (err) reject(err);else resolve(restoredState);
	      };
	    });
	  }
	}
	
	function defaultDeserializer(serial) {
	  return JSON.parse(serial);
	}

/***/ },
/* 3551 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storages = exports.purgeStoredState = exports.persistStore = exports.getStoredState = exports.createTransform = exports.createPersistor = exports.autoRehydrate = undefined;
	
	var _autoRehydrate = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _autoRehydrate2 = _interopRequireDefault(_autoRehydrate);
	
	var _createPersistor = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _createPersistor2 = _interopRequireDefault(_createPersistor);
	
	var _createTransform = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _createTransform2 = _interopRequireDefault(_createTransform);
	
	var _getStoredState = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var _persistStore = __webpack_require__(__webpack_module_template_argument_4__);
	
	var _persistStore2 = _interopRequireDefault(_persistStore);
	
	var _purgeStoredState = __webpack_require__(__webpack_module_template_argument_5__);
	
	var _purgeStoredState2 = _interopRequireDefault(_purgeStoredState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// @TODO remove in v5
	var deprecated = function deprecated(cb, cb2, cb3) {
	  console.error('redux-persist: this method of importing storages has been removed. instead use `import { asyncLocalStorage } from "redux-persist/storages"`');
	  if (typeof cb === 'function') cb();
	  if (typeof cb2 === 'function') cb2();
	  if (typeof cb3 === 'function') cb3();
	};
	var deprecatedStorage = { getAllKeys: deprecated, getItem: deprecated, setItem: deprecated, removeItem: deprecated };
	var storages = {
	  asyncLocalStorage: deprecatedStorage,
	  asyncSessionStorage: deprecatedStorage
	};
	
	exports.autoRehydrate = _autoRehydrate2.default;
	exports.createPersistor = _createPersistor2.default;
	exports.createTransform = _createTransform2.default;
	exports.getStoredState = _getStoredState2.default;
	exports.persistStore = _persistStore2.default;
	exports.purgeStoredState = _purgeStoredState2.default;
	exports.storages = storages;

/***/ },
/* 3552 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = persistStore;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	var _getStoredState = __webpack_require__(__webpack_module_template_argument_1__);
	
	var _getStoredState2 = _interopRequireDefault(_getStoredState);
	
	var _createPersistor = __webpack_require__(__webpack_module_template_argument_2__);
	
	var _createPersistor2 = _interopRequireDefault(_createPersistor);
	
	var _setImmediate = __webpack_require__(__webpack_module_template_argument_3__);
	
	var _setImmediate2 = _interopRequireDefault(_setImmediate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function persistStore(store) {
	  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var onComplete = arguments[2];
	
	  // defaults
	  // @TODO remove shouldRestore
	  var shouldRestore = !config.skipRestore;
	  if (false) console.warn('redux-persist: config.skipRestore has been deprecated. If you want to skip restoration use `createPersistor` instead');
	
	  var purgeKeys = null;
	
	  // create and pause persistor
	  var persistor = (0, _createPersistor2.default)(store, config);
	  persistor.pause();
	
	  // restore
	  if (shouldRestore) {
	    (0, _setImmediate2.default)(function () {
	      (0, _getStoredState2.default)(config, function (err, restoredState) {
	        if (err) {
	          complete(err);
	          return;
	        }
	        // do not persist state for purgeKeys
	        if (purgeKeys) {
	          if (purgeKeys === '*') restoredState = {};else purgeKeys.forEach(function (key) {
	            return delete restoredState[key];
	          });
	        }
	        try {
	          store.dispatch(rehydrateAction(restoredState, err));
	        } finally {
	          complete(err, restoredState);
	        }
	      });
	    });
	  } else (0, _setImmediate2.default)(complete);
	
	  function complete(err, restoredState) {
	    persistor.resume();
	    onComplete && onComplete(err, restoredState);
	  }
	
	  return _extends({}, persistor, {
	    purge: function purge(keys) {
	      purgeKeys = keys || '*';
	      return persistor.purge(keys);
	    }
	  });
	}
	
	function rehydrateAction(payload) {
	  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  return {
	    type: _constants.REHYDRATE,
	    payload: payload,
	    error: error
	  };
	}

/***/ },
/* 3553 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = purgeStoredState;
	
	var _constants = __webpack_require__(__webpack_module_template_argument_0__);
	
	function purgeStoredState(config, keys) {
	  var storage = config.storage;
	  var keyPrefix = config.keyPrefix !== undefined ? config.keyPrefix : _constants.KEY_PREFIX;
	
	  // basic validation
	  if (Array.isArray(config)) throw new Error('redux-persist: purgeStoredState requires config as a first argument (found array). An array of keys is the optional second argument.');
	  if (!storage) throw new Error('redux-persist: config.storage required in purgeStoredState');
	
	  if (typeof keys === 'undefined') {
	    // if keys is not defined, purge all keys
	    return new Promise(function (resolve, reject) {
	      storage.getAllKeys(function (err, allKeys) {
	        if (err) {
	          if (false) console.warn('redux-persist: error during purgeStoredState in storage.getAllKeys');
	          reject(err);
	        } else {
	          resolve(purgeStoredState(config, allKeys.filter(function (key) {
	            return key.indexOf(keyPrefix) === 0;
	          }).map(function (key) {
	            return key.slice(keyPrefix.length);
	          })));
	        }
	      });
	    });
	  } else {
	    // otherwise purge specified keys
	    return Promise.all(keys.map(function (key) {
	      return storage.removeItem('' + keyPrefix + key, warnIfRemoveError(key));
	    }));
	  }
	}
	
	function warnIfRemoveError(key) {
	  return function removeError(err) {
	    if (err && ("production") !== 'production') {
	      console.warn('Error storing data for key:', key, err);
	    }
	  };
	}

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.ea9cf45a.js